(function () {
    // var script = document.createElement('script');
    // script.type = 'text/javascript';
    // script.src = "https://maps.googleapis.com/maps/api/js?key=" + googleApiKey +
    //     "&v=3.exp&libraries=drawing,places,geometry";
    // document.body.appendChild(script);
    // script.onload = function () {
    //     // document.body.appendChild(script);
    //     var scriptForGMap = document.createElement('script');
    //     scriptForGMap.type = 'text/javascript';
    //     scriptForGMap.src =
    //         "http://cdn.sobekdigital.com/includes/gmaps-markerwithlabel/1.9.1/gmaps-markerwithlabel-1.9.1.js";
    //     document.body.appendChild(scriptForGMap);

    //     var scriptJsMap = document.createElement('script');
    //     scriptJsMap.type = 'text/javascript';
    //     scriptJsMap.src =
    //         "https://cdn.rawgit.com/googlemaps/js-map-label/gh-pages/src/maplabel.js";
    //     document.body.appendChild(scriptJsMap);
    // };
    mainModule();

})();

function mainModule() {
    'use strict';

    var filtro = angular
        .module('transVipMain', ['chart.js', 'ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router',
 'ui.bootstrap', 'ui.select', 'toastr', 'ngMaterial', 'pascalprecht.translate', 'platanus.rut', 'daterangepicker', 'textAngular', 'tmh.dynamicLocale', 'ngIdle', 'dndLists', 'ui.sortable', 'ui.calendar'
        ])
        .run(["$rootScope", "$state", "$document", "$log", "checkDomain", function ($rootScope, $state, $document, $log, checkDomain) {
            $rootScope.app = {
                name: 'TRANSVIP',
                description: 'TRANSVIP',
                year: ((new Date()).getFullYear())
            };
            $log.log = function () { };
            var domain = checkDomain.getDomainName();
            if (domain != 'dev') {
                console.log = function () { };
            }




        }])

    filtro.filter("unique", function() {
        return function(collection, keyname) {
            var output = [],
            keys = [];
            angular.forEach(collection, function(item) {
                var key = item[keyname];
                if (keys.indexOf(key) === -1) {
                    keys.push(key);
                    output.push(item);
                }
            });
            return output;
        };
    });
};

/**
 * Created by cl-macmini-51 on 5/18/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('editControlledWayController', editControlledWayController);

    /** @ngInject */
    function editControlledWayController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document,
        moment, $scope, RutHelper, controlledWayService, filterFilter, getGeofence,adminAccessService , getCorporate, languageBasedErrorFactory, errorMessageFactory, pendingRequests, getFilters) {

            var vm = this;
            vm.init = init;
            vm.getAllControlledWay = getAllControlledWay;
            vm.updateControlledWay = updateControlledWay;
            vm.loading = false;
            vm.controlledWayData = [];
            vm.changeDateIntoSpanish = changeDateIntoSpanish;
            vm.changeDateFormat = changeDateFormat;
            vm.editDataArray = [];
            vm.value_exclusive_error = false;
            vm.updateValueExclusive = updateValueExclusive;  
            vm.value_pass_error = false;
            vm.value_pass = value_pass;
            vm.numberWithCommas = numberWithCommas;
            vm.convertValueToChileanCurrency = convertValueToChileanCurrency;
            vm.removeDot = removeDot;
            vm.clickContainer = clickContainer;

            function init() {
                vm.getAllControlledWay();
                document.getElementById("exclusiveValue").focus();
            };
            init();

            
            function getAllControlledWay() {
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.control_way_id = $stateParams.controlled_way_id;
                vm.loading = true;
                var promise = controlledWayService.getControlledWayData(dataSend);
                promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
    
                        if (payload.title.status == 400) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            return [];
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                            return [];
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            vm.controlledWayData = payload.title.data;
                            for(var i = 0; i < 7; i++) {
                                vm.editDataArray.push({
                                    'pasejro': i,
                                    'total_value': vm.controlledWayData[0]['ValuePass'+ [i+1]] * (i+1),
                                    'value_pass': (vm.controlledWayData[0]['ValuePass'+ [i+1]]),
                                })
                            }

                            console.log('debug value', vm.editDataArray);
                            vm.value_exclusive = numberWithCommas(vm.controlledWayData[0].ValueExclusive);
                            setTimeout(function(){
                                vm.convertValueToChileanCurrency();
                                vm.clickContainer();
                            });
                            if(!vm.controlledWayData.length) {
                                vm.tBodyFlag = false;
                                vm.tFootFlag = true;
                            }
                            else {
                                vm.tBodyFlag = true;
                                vm.tFootFlag = false;
                            }
                        }
                    },
                    function (errorPayload) {
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            };
            function convertValueToChileanCurrency() {
                for(var l = 0; l < vm.editDataArray.length; l++) {
                    if(vm.editDataArray[l].value_pass) {
                        vm.editDataArray[l].value_pass = numberWithCommas(vm.editDataArray[l].value_pass);
                    }
                }
            }

            function updateControlledWay() {
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.controlled_way_id = $stateParams.controlled_way_id;
                if(vm.value_exclusive) {
                    var value_exclusive = vm.value_exclusive.replace(/\./g,'');
                }
                dataSend.value_exclusive = value_exclusive;
                // dataSend.value_pass1 = vm.editDataArray[0].value_pass;
                // dataSend.value_pass2 = vm.editDataArray[1].value_pass;
                // dataSend.value_pass3 = vm.editDataArray[2].value_pass;
                // dataSend.value_pass4 = vm.editDataArray[3].value_pass;
                // dataSend.value_pass5 = vm.editDataArray[4].value_pass;
                // dataSend.value_pass6 = vm.editDataArray[5].value_pass;
                // dataSend.value_pass7 = vm.editDataArray[6].value_pass;
                if(vm.editDataArray[0].value_pass)
                    var value_pass1 = (vm.editDataArray[0].value_pass).replace(/\./g,'');

                dataSend.value_pass1 = value_pass1;

                if(vm.editDataArray[1].value_pass)
                    var value_pass2 = (vm.editDataArray[1].value_pass).replace(/\./g,'');
                
                dataSend.value_pass2 = value_pass2;

                if(vm.editDataArray[2].value_pass)
                    var value_pass3 = (vm.editDataArray[2].value_pass).replace(/\./g,'');
                
                dataSend.value_pass3 = value_pass3;

                if(vm.editDataArray[3].value_pass)
                    var value_pass4 = (vm.editDataArray[3].value_pass).replace(/\./g,'');
                
                dataSend.value_pass4 = value_pass4;

                if(vm.editDataArray[4].value_pass)
                    var value_pass5 = (vm.editDataArray[4].value_pass).replace(/\./g,'');
                
                dataSend.value_pass5 = value_pass5;

                if(vm.editDataArray[5].value_pass)
                    var value_pass6 = (vm.editDataArray[5].value_pass).replace(/\./g,'');
                
                dataSend.value_pass6 = value_pass6;

                if(vm.editDataArray[6].value_pass)
                    var value_pass7 = (vm.editDataArray[6].value_pass).replace(/\./g,'');
                
                dataSend.value_pass7 = value_pass7;

                console.log('debug dataSend', dataSend);

                if(!dataSend.value_exclusive || dataSend.value_exclusive < 1 || dataSend.value_exclusive > 5000) {
                    vm.value_exclusive_error = true;
                    return;
                }
                else {
                    vm.value_exclusive_error = false;                    
                }

                if(!dataSend.value_pass1 || dataSend.value_pass1 < 1 || dataSend.value_pass1 > 5000) {
                    vm.value_pass_error = true;
                    return;
                }
                else {
                    vm.value_pass_error = false;
                }
                if(!dataSend.value_pass2 || dataSend.value_pass2 < 1 || dataSend.value_pass2 > 5000) {
                    vm.value_pass_error = true;
                    return;
                }
                else {
                    vm.value_pass_error = false;
                }
                if(!dataSend.value_pass3 || dataSend.value_pass3 < 1 || dataSend.value_pass3 > 5000) {
                    vm.value_pass_error = true;
                    return;
                }
                else {
                    vm.value_pass_error = false;
                }
                if(!dataSend.value_pass4 || dataSend.value_pass4 < 1 || dataSend.value_pass4 > 5000) {
                    vm.value_pass_error = true;
                    return;
                }
                else {
                    vm.value_pass_error = false;
                }
                if(!dataSend.value_pass5 || dataSend.value_pass5 < 1 || dataSend.value_pass5 > 5000) {
                    vm.value_pass_error = true;
                    return;
                }
                else {
                    vm.value_pass_error = false;
                }
                if(!dataSend.value_pass6 || dataSend.value_pass6 < 1 || dataSend.value_pass6 > 5000) {
                    vm.value_pass_error = true;
                    return;
                }
                else {
                    vm.value_pass_error = false;
                }
                if(!dataSend.value_pass7 || dataSend.value_pass7 < 1 || dataSend.value_pass7 > 5000) {
                    vm.value_pass_error = true;
                    return;
                }
                else {
                    vm.value_pass_error = false;
                }
                vm.loading = true;
                var promise = controlledWayService.updateControlledWay(dataSend);
                promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
    
                        if (payload.title.status == 400) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            return [];
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                            return [];
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            languageBasedErrorFactory.getProperErrorMessage('controlledWaySucc', 0, 2, 'layout.controlledWayMain.controlledWay');
                        }
                    },
                    function (errorPayload) {
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }

            function updateValueExclusive() {
                if(!vm.value_exclusive || vm.value_exclusive < 1 || vm.value_exclusive > 5000) {
                    vm.value_exclusive_error = true;
                    return;
                }
                else {
                    vm.value_exclusive_error = false;                    
                }

                if(vm.value_exclusive) {
                    vm.value_exclusive = numberWithCommas(vm.value_exclusive);
                }
            }

            function value_pass() {
                for(var k = 0; k < vm.editDataArray.length; k++) {
                    if(!vm.editDataArray[k].value_pass || vm.editDataArray[k].value_pass < 1 || vm.editDataArray[k].value_pass > 5000) {
                        vm.value_pass_error = true;
                        return;
                    }
                    else {
                        vm.value_pass_error = false;
                    }

                    if(vm.editDataArray[k].value_pass) {
                        vm.editDataArray[k].value_pass = numberWithCommas(vm.editDataArray[k].value_pass);
                        vm.editDataArray[k].total_value = removeDot(vm.editDataArray[k].value_pass) * (k+1);
                    }

                    
                }
            }

            function changeDateFormat(date) {
                // console.log(date);
                var data = date.split('T')[0];
                var newDate = new Date(data);
                //console.log(newDate,date.split('T')[1].split(':')[0],Number(date.split('T')[1].split(':')[1]));
                newDate.setHours(Number(date.split('T')[1].split(':')[0]));
                newDate.setMinutes(Number(date.split('T')[1].split(':')[1]));
                newDate.setSeconds(0);
                // console.log(newDate);
                return newDate;
            };

            function changeDateIntoSpanish(date) {
                var options = {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric'
                };
                return new Date(date).toLocaleString($cookies.get('language') == 'spanish' ? 'es' : 'en', options)
            }

            function numberWithCommas(x) {
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            };

            function removeDot(x) {
                return x.replace(/\./g,'')
            }

            function clickContainer() {
                document.getElementById("exclusiveValue").blur();
            }

    }
})();
/**
 * Created by cl-macmini-51 on 08/02/18.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('autoAssignController', autoAssignController);

    /** @ngInject */
    function autoAssignController($cookies, $state, $log, $rootScope, checkDomain, $timeout, $q, $scope, filterFilter, $mdDialog, $document, getGeofence, languageBasedErrorFactory, errorMessageFactory,Initializer, adminAccessService) {
        var vm = this;
        $log.log('driver');
        var myCenter;
        var zoomLevel = 8;
        var all_overlays = [];
        var coordinates_array = [];
        vm.addressChange = addressChange;
        vm.pickAddressFlag = false;
        var markers = [];
        var mapProp = {};
        var drawingManager = '';
        var mc = null;
        var map = null;
        var icon = {};
        var bounds;
        var geocoder;
        var infoWindow;
        var location = "";
        var currentId = 0;
        var laArray = [];
        var poly = '';
        vm.AutoAssignGeo = true;
        var uniqueId = function () {
            return ++currentId;
        };

        vm.addressHave = '';
        vm.noDataFlag = false;
        vm.addFixedRouteGeofenceFlag = true;
        vm.editFixedRouteGeofenceFlag = false;
        vm.viewFixedRouteGeofenceFlag = false;
        vm.isAirportService = false;
        document.getElementById("googleMap").style.height = window.innerHeight - 200 + 'px';
        vm.filterData = {
            geofenceStatus: '1'
        }; 
        // Service To Get Map Instance
        Initializer.mapsInitialized
            .then(function () {
                console.log('>>>> GOOGLE INIT', google);
                if (google) {
                    myCenter = new google.maps.LatLng(-33.447487, -70.673676);
                    bounds = new google.maps.LatLngBounds();
                    geocoder = new google.maps.Geocoder();
                    infoWindow = new google.maps.InfoWindow();
                } else {
                    alert(languageBasedErrorFactory.getProperErrorMessage('onRoadMessage', 0, '3'));
                }

            });
        vm.setMapOnAll = setMapOnAll;
        vm.drawingFunctions = drawingFunctions;
        vm.mapInitialize = mapInitialize;
        vm.latLongArrayList = latLongArrayList;
        vm.addFixedRouteGeofenceHit = addFixedRouteGeofenceHit;
        vm.getAllBranches = getAllBranches;
        vm.branchChanged = branchChanged;
        vm.branchList = [];
        vm.editFixedRouteGeofenceHit = editFixedRouteGeofenceHit;
        vm.editFixedRouteGeofence = editFixedRouteGeofence;
        vm.cancelEdit = cancelEdit;
        vm.deleteFixedRouteGeofence = deleteFixedRouteGeofence;
        vm.viewFixedRouteGeofence = viewFixedRouteGeofence;
        vm.goBack = goBack;
        vm.setBooleans = setBooleans;
        vm.changeFixedRegionStatus = changeFixedRegionStatus;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();

        vm.addNewGeoFence = addNewGeoFence;
        vm.addNewGeoFenceToggle = false;
        vm.openMultipleGeofencePopup = openMultipleGeofencePopup;
        vm.checkboxToShowAllGeoFenceFunction = checkboxToShowAllGeoFenceFunction;
        vm.removeGeoFenceFromMap = removeGeoFenceFromMap;
        vm.mainPaginationChangedForMultipleGeofence = mainPaginationChangedForMultipleGeofence;
        vm.mainSearch = mainSearch;
        vm.checkboxToShowAllGeoFence = false;
        vm.openMultipleGeofencePopupButtonDisable = true;
        vm.removeGeoFenceFromMapDisableButtonStatus = false;
        vm.hideFilters = true;
        vm.regionIdArray = [];
        //==========================set boolean=======================
        function setBooleans(type) {
            switch (type) {
                case 'AIRPORT_ZONE':
                    if (vm.isAirportService) {
                        vm.isAirportService = false;
                    } else {
                        vm.isAirportService = true;
                    }
                    break;
            }
        };

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.autoAssignMain.autoAssign');
            }
        });
        //================set map nulll======================
        function setMapOnAll(map, id) {
            for (var i = 0; i < markers.length; i++) {
                var marker = markers[i];
                marker.setMap(map);
            }
        };
        // If the map position is out of range, move it back
        function checkBounds(map) {
            if (typeof (map.getBounds()) == 'undefined')
                return;

            var latNorth = map.getBounds().getNorthEast().lat();
            var latSouth = map.getBounds().getSouthWest().lat();
            var newLat;

            if (latNorth < 85 && latSouth > -85) /* in both side -> it's ok */
                return;
            else {
                if (latNorth > 85 && latSouth < -85) /* out both side -> it's ok */
                    return;
                else {
                    if (latNorth > 85)
                        newLat = map.getCenter().lat() - (latNorth - 85);
                    /* too north, centering */
                    if (latSouth < -85)
                        newLat = map.getCenter().lat() - (latSouth + 85);
                    /* too south, centering */
                }
            }
            if (newLat) {
                var newCenter = new google.maps.LatLng(newLat, map.getCenter().lng());
                map.setCenter(newCenter);
            }
        }

        //===========================auto complete===============================
        function addressChange(data) {
            initAutocomplete(data);

        }
        var autocomplete;
        var domain = checkDomain.getDomainName();

        function initAutocomplete(data) {
            if ((!vm.pickAddressFlag) && data && data.length >= 3) {
                vm.pickAddressFlag = true;
                autocomplete = new google.maps.places.Autocomplete(
                    (document.getElementById('addressGot')), {
                        placeIdOnly: true
                    });
                if (domain != 'dev' && domain != 'test')
                    autocomplete.setComponentRestrictions({
                        'country': ['CL']
                    });

                autocomplete.addListener('place_changed', fillInAddress);
            } else if (data && data.length < 3) {
                vm.pickAddressFlag = false;
                google.maps.event.clearInstanceListeners(addressGot);
                $(".pac-container").hide();
            }
        };

        function placeMarker(map, location) {
            if (markers.length > 1) {
                setMapOnAll(null);
            }
            var id = uniqueId();
            var marker = new google.maps.Marker({
                id: id,
                position: location,
                draggable: false,
                map: map
            });
            bounds = new google.maps.LatLngBounds();
            bounds.extend(location);
            map.fitBounds(bounds);
            markers.push(marker);
        };

        function fillInAddress() {
            // Get the place details from the autocomplete object.
            var place = autocomplete.getPlace();
            if (!place.place_id) {
                return;
            }
            geocoder.geocode({
                'placeId': place.place_id
            }, function (results, status) {
                if (status !== 'OK') {
                    window.alert('Geocoder failed due to: ' + status);
                    return;
                }
                var formattedAddress = results[0].formatted_address;
                vm.addressHave = formattedAddress;
                myCenter = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
                zoomLevel = 12;
                mapInitialize();
                placeMarker(map, myCenter);
            });
        };
        // initAutocomplete();
        //================map initialize===========================
        vm.bermudaTriangleArray = [];

        function drawingFunctions(map, data, type) {
            var triangleCoords = [];
            for (var i = 0; i < data.region_data[0].length; i++) {
                triangleCoords.push({
                    lat: data.region_data[0][i].x,
                    lng: data.region_data[0][i].y
                })
            }

            // bounds = new google.maps.LatLngBounds();

            // for (var i = 0; i < data.region_data.length; i++) {
            // bounds.extend(new google.maps.LatLng(data.region_data[0].x, data.region_data[0].y));
            // }

            // map.fitBounds(bounds);
            // map.setCenter(myCenter = new google.maps.LatLng(data.region_data[0].x, data.region_data[0].y));



            // Construct the polygon.
            var bermudaTriangle = new google.maps.Polygon({
                paths: triangleCoords,
                strokeColor: data.strokeColor,
                strokeOpacity: 1,
                strokeWeight: 2,
                fillColor: data.fillColor,
                fillOpacity: 0.5
            });
            if (type) {
                bermudaTriangle.content = '<div class="infoWindowContent">' +
                    '<center><b>'+data.branch_name+'</b></center>' +
                    '<span> ' + data.region_name + '</span><br>'
                '</div>';
            } else {
                bermudaTriangle.content = '<div class="infoWindowContent">' +
                    '<center><b>Geofence</b></center>' +
                    '<span> ' + data.region_name + '</span><br>'
                '</div>';
            }


            if (data.edit) {
                bermudaTriangle.setOptions({
                    editable: true
                });
                drawingManager.setOptions({
                    drawingControl: false,
                    drawingMode: null
                });
            } else {
                bermudaTriangle.setOptions({
                    editable: false
                });
            }

            google.maps.event.addListener(bermudaTriangle.getPath(), 'insert_at', function () {
                var length = bermudaTriangle.getPath().getArray().length;
                coordinates_array = [];
                for (var i = 0; i < length; i++) {
                    console.log( bermudaTriangle.getPath(),' bermudaTriangle.getPath().');
                    
                    var latlong = bermudaTriangle.getPath().getAt(i).lat() + " " + bermudaTriangle.getPath().getAt(i).lng();
                    coordinates_array.push(latlong)
                }
                latLongArrayList(coordinates_array, 'insert');
            });
            google.maps.event.addListener(bermudaTriangle.getPath(), 'set_at', function () {
                var length = bermudaTriangle.getPath().getArray().length;
                coordinates_array = [];
                for (var i = 0; i < length; i++) {
                    var latlong = bermudaTriangle.getPath().getAt(i).lat() + " " + bermudaTriangle.getPath().getAt(i).lng();
                    coordinates_array.push(latlong)
                }
                latLongArrayList(coordinates_array, 'insert');
            });

            if (!vm.hideFilters) {
                if (data.view) {
                    infoWindow.setContent(bermudaTriangle.content);
                    infoWindow.setPosition(new google.maps.LatLng(data.region_data[0][0].x, data.region_data[0][0].y));
                    infoWindow.open(map, bermudaTriangle);
                }
            }
            if (vm.hideFilters) {
                if (data.view) {
                    if (vm.viewFixedRouteGeofenceFlag)
                        bermudaTriangle.setOptions({
                            visible: true
                        });
                    infoWindow.setContent(bermudaTriangle.content);
                    infoWindow.setPosition(new google.maps.LatLng(data.region_data[0][0].x, data.region_data[0][0].y));
                    infoWindow.open(map, bermudaTriangle);
                } else {
                    if (vm.viewFixedRouteGeofenceFlag)
                        bermudaTriangle.setOptions({
                            visible: false
                        });
                }
            }

            if (data.add || data.edit) {
                $log.log('adding');
            } else {
                google.maps.event.addListener(bermudaTriangle, 'click', function (event) {
                    infoWindow.setContent(bermudaTriangle.content);
                    infoWindow.setPosition(event.latLng);
                    infoWindow.open(map, bermudaTriangle);
                });
                //google.maps.event.addListener(bermudaTriangle, 'mouseover', function (event) {
                //    infoWindow.setContent(bermudaTriangle.content);
                //    infoWindow.setPosition(event.latLng);
                //    infoWindow.open(map,bermudaTriangle);
                //});
            }
            bermudaTriangle.setMap(map);
            vm.bermudaTriangleArray.push(bermudaTriangle);
        };

        function mapInitialize(data) {
            console.log('debug', data)
            if (typeof google === 'undefined') {
                var deferred = $q.defer();
                $timeout(function() {
                    deferred.resolve();
                }, 1500);
                return deferred.promise;
            }
            mapProp = {
                center: myCenter,
                zoom: Number(zoomLevel),
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                minZoom: 5,
                //maxZoom: 15,
                scrollwheel: false
            };
            map = new google.maps.Map(document.getElementById("googleMap"), mapProp);
            google.maps.event.addListener(map, 'center_changed', function () {
                checkBounds(map);
            });
            drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: null, //google.maps.drawing.OverlayType.MARKER
                drawingControl: true,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: ['polygon'] //'marker', 'circle', 'polyline', 'rectangle'
                },
                //markerOptions: {icon: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png'},
                polygonOptions: {
                    fillColor: '#f18903',
                    fillOpacity: 0.5,
                    strokeWeight: 1,
                    clickable: false,
                    editable: true,
                    zIndex: 1
                }
            });
            drawingManager.setMap(map);
            google.maps.event.addListener(drawingManager, 'overlaycomplete', function (event) {
                var coordinates_array = [];
                if (event.type == 'polygon') {
                    all_overlays.push(event);
                    drawingManager.setOptions({
                        drawingControl: false,
                        drawingMode: null
                    });
                    //drawingManager.setDrawingMode(null);    //hiidng the drawing tool aftre completion of polygon
                    console.log(event.overlay.latLngs,'event.overlay.latLngs');
                    
                    var length = event.overlay.getPath().getArray().length;
                    for (var i = 0; i < length; i++) {
                        //var latlong = event.overlay.latLngs.getPath().getArray()[i].lat() + " " + event.overlay.latLngs.getPath().getArray()[i].lng();
                        var latlong = event.overlay.getPath().getArray()[i].lat() + " " + event.overlay.getPath().getArray()[i].lng();
                        coordinates_array.push(latlong)
                    }
                    latLongArrayList(coordinates_array);

                }

                google.maps.event.addListener(event.overlay.getPath(), 'insert_at', function () {
                    var length = event.overlay.getPath().i.length;
                    coordinates_array = [];
                    for (var i = 0; i < length; i++) {
                        var latlong = event.overlay.getPath().i[i].lat() + " " + event.overlay.getPath().i[i].lng();
                        coordinates_array.push(latlong)
                    }
                    latLongArrayList(coordinates_array, 'insert');
                });
                google.maps.event.addListener(event.overlay.getPath(), 'set_at', function () {
                    var length = event.overlay.getPath().i.length;
                    coordinates_array = [];
                    for (var i = 0; i < length; i++) {
                        var latlong = event.overlay.getPath().i[i].lat() + " " + event.overlay.getPath().i[i].lng();
                        coordinates_array.push(latlong)
                    }
                    latLongArrayList(coordinates_array, 'insert');
                });
            });
            if (data && data.length) {
                data.forEach(function (makeMap) {
                    if (makeMap.child && makeMap.child.length) {
                        drawingFunctions(map, makeMap, 1);
                        makeMap.child.forEach(function (data) {
                            drawingFunctions(map, data, 0);
                        })
                    } else {
                        drawingFunctions(map, makeMap, 1);
                    }
                });
            } else {
                $log.log('no branch');
            }
        };

        function latLongArrayList(coordinates_array, type) {
            vm.removeGeoFenceFromMapDisableButtonStatus = false;
            if (type == 'insert') {
                if (coordinates_array[0] === coordinates_array[coordinates_array.length - 1]) {
                    vm.finalArrayCordinates = coordinates_array;
                } else {
                    var newArray = coordinates_array;
                    newArray[newArray.length] = newArray[0];
                    vm.finalArrayCordinates = newArray;
                }
                $scope.$apply();
            } else {
                var str_coordinates = '';
                var arr_len = coordinates_array.length;

                var newArray = coordinates_array;
                newArray[newArray.length] = newArray[0];
                vm.finalArrayCordinates = newArray;
                //var new_arr = [];
                //for (var i = 0; i < arr_len; i++) {
                //    var val = coordinates_array[i].split(' ');
                //    var obj = {
                //        "lat": val[0],
                //        "lng": val[1]
                //    };
                //    str_coordinates += coordinates_array[i].toString() + ",";
                //    new_arr.push(obj);
                //}
                //str_coordinates += coordinates_array[0].toString() + ",";
                //str_coordinates = str_coordinates.slice(0, -1);
                //new_arr[new_arr.length] = {
                //    lat: new_arr[0].lat,
                //    lng: new_arr[0].lng
                //};
                $scope.$apply();
                console.log(  vm.finalArrayCordinates ,'  vm.finalArrayCordinates >>>>>>>>>');
                
            }
        };

        //====================branches for adding======================
        function branchesForAdding(filter) {
            vm.loading = true;
            var promise = getGeofence.getAllBranchList(filter);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    console.log('debug1', payload);
                    if (payload.title.data.length) {
                        var where = _.where(payload.title.data, {
                            parent_id: 0
                        });
                        var where1 = _.where(where, {
                            is_active: 1
                        });
                        vm.branchList = where1;
                        for (var i = 0; i < vm.branchList.length; i++) {
                            vm.branchList[i].index = i;
                            vm.branchList[i].add = false;
                            vm.branchList[i].edit = false;
                            vm.branchList[i].strokeColor = '#f18903';
                            vm.branchList[i].fillColor = 'transparent';
                            vm.branchList[i].child = [];
                        }
                        var whereFixed = [];
                        for (var i = 0; i < payload.title.data.length; i++) {
                            if (payload.title.data[i].parent_id != 0) {
                                whereFixed.push(payload.title.data[i]);
                            }
                        }
                        if (whereFixed.length) {
                            var newCombinationArray = vm.branchList;
                            for (var i = 0; i < whereFixed.length; i++) {
                                whereFixed[i].index = i;
                                whereFixed[i].edit = false;
                                whereFixed[i].strokeColor = '#063c4a';
                                whereFixed[i].fillColor = '#063c4a';
                                whereFixed[i].parent = {
                                    region_name: '',
                                    region_id: '',
                                    region_data: [],
                                    strokeColor: '#f18903',
                                    fillColor: 'transparent'
                                };
                                for (var j = 0; j < vm.branchList.length; j++) {
                                    if (whereFixed[i].parent_id == vm.branchList[j].region_id) {
                                        whereFixed[i].parent.region_name = vm.branchList[j].region_name;
                                        whereFixed[i].parent.region_id = vm.branchList[j].region_id;
                                        whereFixed[i].parent.region_data = vm.branchList[j].region_data;
                                    }
                                }
                                for (var j = 0; j < newCombinationArray.length; j++) {
                                    if (whereFixed[i].parent_id == newCombinationArray[j].region_id) {
                                        newCombinationArray[j].child.push(whereFixed[i]);
                                    }
                                }
                            }
                            //vm.tableFixedRouteList = whereFixed;
                            //vm.fixedRouteList = newCombinationArray;
                            $log.log('whereFixed', newCombinationArray);
                            //mapInitialize(vm.fixedRouteList);
                        } else {
                            //vm.fixedRouteList = [];
                            //vm.noDataFlag = true;
                            //mapInitialize(vm.fixedRouteList);
                        }
                    } else {
                        vm.branchList = [];
                        //vm.fixedRouteList = [];
                        //vm.noDataFlag = true;
                        //errorMessageFactory.showErrorMessage('Please add branch first.',0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        branchesForAdding(2);


        function mainPaginationChangedForMultipleGeofence() {
            vm.mainBranchesForAddingForPopupoffset += 25;
            if (vm.mainBranchesForAddingForPopupoffset < vm.mainBranchListForPopupCount) {
                vm.getAllBranches(vm.mainShowActiveOrInactiveGeofenceStatus, vm.mainBranchesForAddingForPopupoffset, vm.mainSearchStringVariable);
            }
        }

        vm.checkSearchLength = 0;
        function mainSearch(searchString) {
            if(searchString && vm.search.length > 2) {
                vm.checkSearchLength = vm.search.length;
                vm.allBranchList = [];
                vm.tableFixedRouteList = [];
                vm.fixedRouteList = [];
                vm.mainSearchStringVariable = searchString;
                vm.mainBranchesForAddingForPopupoffset = 0;
                vm.getAllBranches(vm.mainShowActiveOrInactiveGeofenceStatus, vm.mainBranchesForAddingForPopupoffset, vm.mainSearchStringVariable);
            }
            else if(vm.checkSearchLength > 2) {
                vm.checkSearchLength = 0;
                vm.checkSearchLength = vm.search.length;
                vm.allBranchList = [];
                vm.tableFixedRouteList = [];
                vm.fixedRouteList = [];
                vm.mainSearchStringVariable = searchString;
                vm.mainBranchesForAddingForPopupoffset = 0;
                vm.getAllBranches(vm.mainShowActiveOrInactiveGeofenceStatus, vm.mainBranchesForAddingForPopupoffset);
            }
        }

        //===========================get all branches==========================
        vm.allBranchList = [];
        vm.tableFixedRouteList = [];
        vm.fixedRouteList = [];
        vm.getaMainBranchesForAddingForPopupLimit = 25;
        vm.mainBranchesForAddingForPopupoffset = 0;
        vm.mainSearchStringVariable = '';
        vm.mainShowActiveOrInactiveGeofenceStatus = 1;
        vm.filterData.geofenceStatus = "1";

        function getAllBranches(filter, mainOffset, mainSearchString, changeState) {

            vm.mainShowActiveOrInactiveGeofenceStatus = filter;
            vm.loading = true;
            var promise = getGeofence.getAllBranchListForPopupAutoAssign(filter, vm.getaMainBranchesForAddingForPopupLimit, mainOffset, mainSearchString);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (changeState) {
                        vm.allBranchList = [];
                        vm.tableFixedRouteList = [];
                        vm.fixedRouteList = [];
                        vm.mainBranchesForAddingForPopupoffset = 0;
                    }
                    console.log('debug', payload);
                    vm.mainBranchListForPopupCount = payload.title.count;
                    if (payload.title.data.length) {
                        if (mainSearchString) {
                            vm.allBranchList = [];
                            vm.tableFixedRouteList = [];
                            vm.fixedRouteList = [];
                        }
                        vm.noDataFlag = false;
                        //if(filter == '0') {
                        //    var where1 = _.where(payload.title.data, {parent_id: 0});
                        //    var where = _.where(where1,{is_active: 0});
                        //}
                        //else if(filter == '1') {
                        //    var where1 = _.where(payload.title.data, {parent_id: 0});
                        //    var where = _.where(where1,{is_active: 1});
                        //}
                        //else{
                        var where = _.where(payload.title.data, {
                            parent_id: 0
                        });
                        //var where = _.where(where1,{is_active: 0});
                        //}
                        // where.forEach(function (geoFence) {
                        //     vm.allBranchList.push(geoFence);
                        // });
                        vm.allBranchList = where;
                        for (var i = 0; i < vm.allBranchList.length; i++) {
                            vm.allBranchList[i].index = i;
                            vm.allBranchList[i].add = false;
                            vm.allBranchList[i].edit = false;
                            vm.allBranchList[i].strokeColor = '#f18903';
                            vm.allBranchList[i].fillColor = 'transparent';
                            vm.allBranchList[i].child = [];
                        }
                        var whereFixed = [];
                        for (var i = 0; i < payload.title.data.length; i++) {
                            if (filter == '0') {
                                if (payload.title.data[i].parent_id != 0 && payload.title.data[i].is_active == 0) {
                                    whereFixed.push(payload.title.data[i]);
                                }
                            } else if (filter == '1') {
                                if (payload.title.data[i].parent_id != 0 && payload.title.data[i].is_active == 1) {
                                    whereFixed.push(payload.title.data[i]);
                                }
                            } else {
                                if (payload.title.data[i].parent_id != 0) {
                                    whereFixed.push(payload.title.data[i]);
                                }
                            }
                        }
                        if (whereFixed.length) {
                            var newCombinationArray = vm.allBranchList;

                            for (var i = 0; i < whereFixed.length; i++) {
                                whereFixed[i].index = i;
                                whereFixed[i].edit = false;
                                whereFixed[i].view = false;
                                // CHANGE COLOR #063c4a to transparent for child geofence on initialization
                                whereFixed[i].strokeColor = '#063c4a';
                                whereFixed[i].fillColor = '#063c4a';
                                whereFixed[i].parent = {
                                    region_name: '',
                                    auto_assignment_region_id: '',
                                    region_data: [],
                                    strokeColor: '#f18903',
                                    fillColor: 'transparent'
                                };
                                // for (var j = 0; j < vm.allBranchList.length; j++) {
                                //     if (whereFixed[i].parent_id == vm.allBranchList[j].region_id) {
                                // whereFixed[i].parent = {};
                                whereFixed[i].parent.region_name = whereFixed[i].region_name;
                                whereFixed[i].parent.auto_assignment_region_id = whereFixed[i].auto_assignment_region_id;
                                whereFixed[i].parent.region_data = whereFixed[i].region_data;
                                //     }
                                // }
                                // for (var j = 0; j < newCombinationArray.length; j++) {
                                //     if (whereFixed[i].parent_id == newCombinationArray[j].region_id) {
                                //         newCombinationArray[j].child.push(whereFixed[i]);
                                //     }
                                // }
                            }
                            whereFixed.forEach(function (geoFence) {
                                vm.tableFixedRouteList.push(geoFence);
                                vm.fixedRouteList.push(geoFence);
                            });
                            // newCombinationArray.forEach(function (geoFence) {
                            //     vm.fixedRouteList.push(geoFence);
                            // });
                            $log.log('whereFixed', newCombinationArray);
                            console.log('debug', vm.fixedRouteList, newCombinationArray);
                            mapInitialize();
                        } else {
                            // vm.fixedRouteList = [];
                            // vm.noDataFlag = true;
                            // mapInitialize(vm.fixedRouteList);
                        }
                    } else {
                        vm.allBranchList = [];
                        vm.fixedRouteList = [];
                        vm.noDataFlag = true;
                        // languageBasedErrorFactory.getProperErrorMessage('branchReq', 0, 0);
                        //errorMessageFactory.showErrorMessage('Please add branch first.',0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllBranches(vm.mainShowActiveOrInactiveGeofenceStatus, vm.mainBranchesForAddingForPopupoffset);
        //=================================branch changed============================
        function getBranch() {
            // vm.branchList = [];
            // vm.branchList = JSON.parse(JSON.stringify(getFilters.branchesFiltersData.data));

            // $scope.$apply();
            vm.loading = true;
            var promise = getGeofence.branch();
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        var where = _.where(payload.title.data, {
                            parent_id: 0
                        });
                        //vm.branchList = _.where(where, { is_active: 1 });
                        var salidaBranch = where.map(function(a) {return {region_id: a.region_id, region_name: a.region_name}; });
                        vm.branchList = salidaBranch;
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    // vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        getBranch();

        //=================================branch changed============================
        function branchChanged() {
            $log.log(vm.branchName);
            var where = _.where(vm.branchList, {
                region_id: vm.branchName
            });
            console.log('debug', vm.branchList, vm.branchName, where);
            $log.log(where);
            where[0].add = true;
            myCenter = new google.maps.LatLng(where[0].region_data[0].x, where[0].region_data[0].y);
            zoomLevel = 12;
            mapInitialize(vm.fixedRouteList);
        };

        //=============================add branch geofence function hit=================================
        function addFixedRouteGeofenceHit() {
            $log.log(vm.finalArrayCordinates);
            $log.log(vm.name);
            $log.log(vm.description);
            $log.log(vm.branchName);
            $log.log(vm.isAirportService);
            console.log(vm.finalArrayCordinates,'vm.finalArrayCordinates');
            
            if (!vm.finalArrayCordinates || !vm.finalArrayCordinates.length) {
                //errorMessageFactory.showErrorMessage('Please select some region from map.');
                languageBasedErrorFactory.getProperErrorMessage('branchEditPop', 0, 0);
                return;
            }

            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.region_name = vm.name.toUpperCase();
            dataSend.region_description = vm.description;
            dataSend.region_data = vm.finalArrayCordinates;
            // dataSend.isAirportService = vm.isAirportService;
            dataSend.parent_id = vm.branchName;
            dataSend.is_airport = false;
            $log.log(dataSend);
            vm.loading = true;
            var promise = getGeofence.branchGeofenceAddAutoAssign(dataSend);
            promise.then(
                function (payload) {
                    if(payload.title.status == 200) {
                        $log.log(payload);
                        vm.loading = false;
                        $state.reload('layout.autoAssignMain.autoAssign');
                    }
                    else{
                        // vm.loading = false;
                        errorMessageFactory.showErrorMessage(payload.title.message, 1);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //==========================cancel========================
        function cancelEdit() {
            $state.reload('layout.autoAssignMain.autoAssign');
        };

        //====================edit fixed route====================
        function editFixedRouteGeofence(data) {
            console.log('debug', data);
            vm.loading = true;
            var promise = adminAccessService.checkStateValid('Editar zona autoasignación');
            return promise.then(function (payload) {
                vm.loading = false;
                if (payload.title.status == 400) {
                    errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    return false;
                } else if (payload.title.status == 401) {
                    errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    return false;
                } else if (payload.title.status == 201 || payload.title.status == 200) {
                    if (!payload.title.data.granted) {
                        languageBasedErrorFactory.getProperErrorMessage('optionNotAvail', 0, 0);
                        return false;
                    } else {

                        vm.editFixedRouteGeofenceIndex;
                        $log.log(data);
                        vm.addFixedRouteGeofenceFlag = false;
                        vm.editFixedRouteGeofenceFlag = true;
                        vm.viewFixedRouteGeofenceFlag = false;
                        vm.editName = data.region_name;
                        vm.editDescription = data.region_description;
                        vm.editID = data.auto_assignment_region_id;
                        vm.editRegionData = data.region_data;
                        // vm.isAirportService = data.isAirportService;
                        vm.branchNameEdit = data.parent_id;
                        // for (var i = 0; i < vm.fixedRouteList.length; i++) {
                        //     for (var j = 0; j < vm.fixedRouteList[i].child.length; j++) {
                        //         if (vm.fixedRouteList[i].child[j].region_id == data.region_id) {
                        //             vm.fixedRouteList[i].child[j].view = true;
                        //             vm.fixedRouteList[i].child[j].edit = true;
                        //             vm.editFixedRouteGeofenceIndex = i;
                        //         } else {
                        //             vm.fixedRouteList[i].child[j].view = false;
                        //             vm.fixedRouteList[i].child[j].edit = false;
                        //         }
                        //     }
                        // }

                        // WIP
                        for (var i = 0; i < vm.fixedRouteList.length; i++) {
                            if (vm.fixedRouteList[i].auto_assignment_region_id == data.auto_assignment_region_id) {
                                vm.fixedRouteList[i].view = true;
                                vm.fixedRouteList[i].edit = true;
                                vm.editFixedRouteGeofenceIndex = i;
                            } else {
                                vm.fixedRouteList[i].view = false;
                                vm.fixedRouteList[i].edit = false;
                            }
                        }

                        myCenter = new google.maps.LatLng(data.region_data[0][0].x, data.region_data[0][0].y);
                        zoomLevel = 12;
                        if (!vm.hideFilters) {
                            mapInitialize(vm.fixedRouteList);
                        } else {
                            mapInitialize([vm.fixedRouteList[vm.editFixedRouteGeofenceIndex]]);
                        }
                    }
                }
            })
        };

        function editFixedRouteGeofenceHit() {
            console.log(vm.finalArrayCordinates);
            console.log(vm.editName);
            console.log(vm.editDescription);
            console.log(vm.editID);
            console.log(vm.editRegionData);
            console.log(vm.isAirportService);

            if (!vm.finalArrayCordinates || !vm.finalArrayCordinates.length) {
                vm.finalArrayCordinates = [];
                for (var i = 0; i < vm.editRegionData[0].length; i++) {
                    vm.finalArrayCordinates.push(vm.editRegionData[0][i].x + ' ' + vm.editRegionData[0][i].y);
                }
            }
            console.log(vm.finalArrayCordinates);
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.region_name = vm.editName.toUpperCase();
            dataSend.region_description = vm.editDescription;
            dataSend.region_data = vm.finalArrayCordinates;
            dataSend.auto_assignment_region_id = vm.editID;
            // dataSend.isAirportService = vm.isAirportService;
            dataSend.parent_id = vm.branchNameEdit;
            dataSend.child = true;
            dataSend.is_airport = false;
            $log.log(dataSend);
            vm.loading = true;
            var promise = getGeofence.editBranchListAutoAssignment(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if(payload.title.status == 200){
                        var dataForSysLogs = {
                            access_token: $cookies.get('obj'),
                            id: vm.editID,
                            identity: 29, // 0- driver, 1- customer , 2 -car
                            message: 'Auto assignment geofence details updated.'
                        };
                        $rootScope.systemLogsAdmin(dataForSysLogs);
                        languageBasedErrorFactory.getProperErrorMessage('fixedGeoEditSucc', 0, 1, 'layout.autoAssignMain.autoAssign');
                    }else{
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    //errorMessageFactory.showErrorMessage('Fixed route geofence details updated successfully.',1);
                    //$timeout(function() {
                    //    $mdDialog.hide();
                    //    $state.reload();
                    //}, 2000);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //=====================to delete fixed route====================
        function deleteFixedRouteGeofence(id, $event) {
            vm.loading = true;
            var promise = adminAccessService.checkStateValid('Eliminar zona autoasignación');
            return promise.then(function (payload) {
                vm.loading = false;
                if (payload.title.status == 400) {
                    errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    return false;
                } else if (payload.title.status == 401) {
                    errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    return false;
                } else if (payload.title.status == 201 || payload.title.status == 200) {
                    if (!payload.title.data.granted) {
                        languageBasedErrorFactory.getProperErrorMessage('optionNotAvail', 0, 0);
                        return false;
                    } else {
                        var confirm = $mdDialog.confirm()
                            .title(languageBasedErrorFactory.getProperErrorMessage('fixedGeoEditPop', 0, '3'))
                            .textContent('')
                            .ariaLabel('Lucky day')
                            .targetEvent($event)
                            .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                            .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

                        $mdDialog.show(confirm).then(function () {
                            $log.log('confirmed', id);
                            //errorMessageFactory.showErrorMessage('Functionality is pending',0);
                            var dataSend = {};
                            dataSend.access_token = $cookies.get('obj');
                            dataSend.auto_assignment_region_id = id.auto_assignment_region_id;
                            dataSend.is_deleted = 1;
                            dataSend.parent = id.parent_id == 0 ? 0 : 1;
                            vm.loading = true;
                            var promise = getGeofence.removeRegionAutoAssign(dataSend);
                            promise.then(
                                function (payload) {
                                    $log.log(payload);
                                    vm.loading = false;
                                    if(payload.title.status == 200){
                                        var dataForSysLogs = {
                                            access_token: $cookies.get('obj'),
                                            id: id.auto_assignment_region_id,
                                            identity: 29, // 0- driver, 1- customer , 2 -car
                                            message: 'Auto assignment geofence deleted.'
                                        };
                                        $rootScope.systemLogsAdmin(dataForSysLogs);
                                        languageBasedErrorFactory.getProperErrorMessage('fixedGeoDeleteSucc', 0, 1, 'layout.autoAssignMain.autoAssign');
                                    }else{
                                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                                    }
                                    //errorMessageFactory.showErrorMessage('Fixed route geofence deleted successfully.',1);
                                },
                                function (errorPayload) {
                                    $log.log(errorPayload);
                                    vm.loading = false;
                                    if (errorPayload.data.status == 401) {
                                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                                    } else {
                                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                                    }
                                }
                            );
                        }, function () {
                            $log.log('not confirmed');
                        });
                    }
                }
            })
        };
        //=====================to change status small geofence====================
        function changeFixedRegionStatus(id, $event) {
            vm.loading = true;
            var promise = adminAccessService.checkStateValid('Activar/Desactivar zona autoasignación');
            return promise.then(function (payload) {
                vm.loading = false;
                if (payload.title.status == 400) {
                    errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    return false;
                } else if (payload.title.status == 401) {
                    errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    return false;
                } else if (payload.title.status == 201 || payload.title.status == 200) {
                    if (!payload.title.data.granted) {
                        languageBasedErrorFactory.getProperErrorMessage('optionNotAvail', 0, 0);
                        return false;
                    } else {

                        var confirm = $mdDialog.confirm()
                            .title(languageBasedErrorFactory.getProperErrorMessage('fixedGeoStatusPop', 0, '3'))
                            .textContent('')
                            .ariaLabel('Lucky day')
                            .targetEvent($event)
                            .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                            .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

                        $mdDialog.show(confirm).then(function () {
                            $log.log('confirmed', id);
                            //errorMessageFactory.showErrorMessage('Functionality is pending',0);
                            var dataSend = {};
                            dataSend.access_token = $cookies.get('obj');
                            dataSend.auto_assignment_region_id = id.auto_assignment_region_id;
                            // dataSend.parent = id.parent_id == 0 ? 0 : 1;
                            dataSend.is_active = id.is_active == 0 ? 1 : 0;
                            vm.loading = true;
                            var promise = getGeofence.blockUnblockAutoAssignmentRegion(dataSend);
                            promise.then(
                                function (payload) {
                                    $log.log(payload);
                                    vm.loading = false;
                                    if(payload.title.status == 200){
                                        var dataForSysLogs = {
                                            access_token: $cookies.get('obj'),
                                            id: id.auto_assignment_region_id,
                                            identity: 29, // 0- driver, 1- customer , 2 -car
                                            message: 'Auto assignment Geofence status updated.'
                                        };
                                        $rootScope.systemLogsAdmin(dataForSysLogs);
                                        languageBasedErrorFactory.getProperErrorMessage('fixedGeoStatusSucc', 0, 1, 'layout.autoAssignMain.autoAssign');
                                    }else{
                                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                                    }
                                    //errorMessageFactory.showErrorMessage('Geofence status updated successfully.',1);
                                },
                                function (errorPayload) {
                                    $log.log(errorPayload);
                                    vm.loading = false;
                                    if (errorPayload.data.status == 401) {
                                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                                    } else {
                                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                                    }
                                }
                            );
                        }, function () {
                            $log.log('not confirmed');
                        });
                    }
                }
            })
        };

        //=====================view fixed route geofence=====================
        function viewFixedRouteGeofence(data) {
            vm.viewFixedRouteGeofenceIndex;
            vm.addFixedRouteGeofenceFlag = false;
            vm.editFixedRouteGeofenceFlag = false;
            vm.viewFixedRouteGeofenceFlag = true;
            vm.viewFixedRouteName = data.region_name;
            vm.viewFixedRouteDescription = data.region_description;
            vm.viewFixedRouteID = data.auto_assignment_region_id;
            vm.viewFixedRouteData = data.region_data;
            // vm.viewAirportZone = data.isAirportService;
            vm.viewFixedRouteStatus = data.is_active;
            vm.viewFixedRouteParentID = data.parent_id;
            vm.viewFixedRouteParentName = data.branch_name;

            // for (var i = 0; i < vm.fixedRouteList.length; i++) {
            //     for (var j = 0; j < vm.fixedRouteList[i].child.length; j++) {
            //         if (vm.fixedRouteList[i].child[j].region_id == data.region_id) {
            //             vm.fixedRouteList[i].child[j].view = true;
            //             vm.fixedRouteList[i].child[j].edit = false;
            //             vm.viewFixedRouteGeofenceIndex = i;
            //         } else {
            //             vm.fixedRouteList[i].child[j].view = false;
            //             vm.fixedRouteList[i].child[j].edit = false;
            //         }
            //     }
            // }

            for (var i = 0; i < vm.fixedRouteList.length; i++) {
                if (vm.fixedRouteList[i].auto_assignment_region_id == data.auto_assignment_region_id) {
                    vm.fixedRouteList[i].view = true;
                    vm.fixedRouteList[i].edit = false;
                    vm.viewFixedRouteGeofenceIndex = i;
                } else {
                    vm.fixedRouteList[i].view = false;
                    vm.fixedRouteList[i].edit = false;
                }
            }

            myCenter = new google.maps.LatLng(data.region_data[0][0].x, data.region_data[0][0].y);
            zoomLevel = 12;
            if (!vm.hideFilters) {
                mapInitialize(vm.fixedRouteList);
            } else {
                mapInitialize([vm.fixedRouteList[vm.viewFixedRouteGeofenceIndex]]);
            }
        };
        //=======================go back========================
        function goBack() {
            // vm.addFixedRouteGeofenceFlag = true;
            // vm.editFixedRouteGeofenceFlag = false;
            // vm.viewFixedRouteGeofenceFlag = false;
            // for (var i = 0; i < vm.fixedRouteList.length; i++) {
            //     for (var j = 0; j < vm.fixedRouteList[i].child.length; j++) {
            //         vm.fixedRouteList[i].child[j].view = false;
            //     }
            // }
            // myCenter = new google.maps.LatLng(-33.447487, -70.673676);
            // zoomLevel = 8;
            // mapInitialize(vm.fixedRouteList);
            $state.reload();

        };

        // ============= TOGGLE MAP WHEN CLICK ON ADD NEW GEOFENCE =============
        function addNewGeoFence(edit) {
            vm.loading = true;
            if(edit && edit == 1){
                var promise = adminAccessService.checkStateValid('Editar zona autoasignación');
            } else if(edit && edit == 2){
                var promise = adminAccessService.checkStateValid('Home Screen Main');
            } else {
                var promise = adminAccessService.checkStateValid('Creación zona autoasignación');
            }
            return promise.then(function (payload) {
                vm.loading = false;
                if (payload.title.status == 400) {
                    errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    return false;
                } else if (payload.title.status == 401) {
                    errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    return false;
                } else if (payload.title.status == 201 || payload.title.status == 200) {
                    if (!payload.title.data.granted) {
                        languageBasedErrorFactory.getProperErrorMessage('optionNotAvail', 0, 0);
                        return false;
                    } else {
                        //mapInitialize();
                        $("#showMap").slideDown("slow");
                        vm.addNewGeoFenceToggle = true;
                    }
                }
            })
        }

        // =========== OPEN MULTIPLE GEOFENCE POPUP ===============
        function openMultipleGeofencePopup($event) {

            vm.items = {};
            $scope.branchListForPopupCount = 0;
            $scope.regionIdArray = [];
            $scope.selectedBranch = [];
            var parentEl = angular.element($document.body);

            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/selectMultipleGeofenceAutoassign.html',
                locals: {
                    items: $scope.branchListForPopup,
                    regionIdArray: vm.regionIdArray
                },
                bindToController: true,
                controller: DialogController
            });


            function DialogController($scope, $mdDialog, items, regionIdArray) {
                $scope.items = $scope.branchListForPopup;
                $scope.loading = false;
                $scope.activeGeoFence = 0;
                $scope.inactiveGeoFence = 0;
                $scope.showActiveOrInactiveGeofenceStatus = 1;
                $scope.searchStringVariable = '';
                $scope.regionIdArrayLength = regionIdArray.length;
                $scope.blockID = vm.editID;
                //vm.addFixedRouteGeofenceFlag = true;
                //vm.editFixedRouteGeofenceFlag = false;
                //vm.viewFixedRouteGeofenceFlag = false;
                $scope.isDesc = false;
                vm.estado = [
                    { name: 'Activas', id: 1 },
                    { name: 'Todas', id: 2 },
                    { name: 'Desactivadas', id: 0 }
                ];
                $scope.estados = vm.estado;
                $scope.selectedEstado = $scope.estados.find(function(estado) {
                    return estado.id === 1;
                });
                //select checkboxes
                $scope.selectAllItems = function() {
                    angular.forEach($scope.branchListForPopup, function(item) {
                        if( item.selected != true ){
                            item.selected = true;
                            $scope.getGeofenceRegionId(item.auto_assignment_region_id);
                        }
                    });
                    $scope.regionIdArrayLength = regionIdArray.length;
                    if($scope.blockID){
                        $scope.regionIdArrayLength = $scope.regionIdArrayLength - 1;
                    }
                };
                $scope.unselectAllItems = function() {
                    angular.forEach($scope.branchListForPopup, function(item) {
                        item.selected = false;
                        var _index = regionIdArray.indexOf(item.auto_assignment_region_id);
                        if (_index > -1) { // only splice array when item is found
                            regionIdArray.splice(_index, 1); // 2nd parameter means remove one item only
                        }
                        $scope.regionIdArrayLength = regionIdArray.length;
                    });
                };

                //vm.branchList.push({ region_id: 0, region_name: 'All' });
                $scope.branchList = vm.branchList;
                var sucursalesSeleccionadas = [];
                //$scope.selectedBranch = $scope.branchList.find(function(b) {
                    //return b.region_id === 0;
                //});

                $scope.selectingZones = function (data, evento){
                    var salida = data.map(function(e){ return e.region_id });
                    sucursalesSeleccionadas = salida;
                    if(evento == 'select'){
                        $scope.filterBranchFunction(salida);
                    } else {
                        $scope.filterBranchFunction(salida);
                    }
                }

                $scope.paginationChangedForMultipleGeofence = function () {
                    $scope.branchesForAddingForPopupoffset += 25;
                    if ($scope.branchesForAddingForPopupoffset < $scope.branchListForPopupCount) {
                        $scope.branchesForAddingForPopup($scope.showActiveOrInactiveGeofenceStatus, $scope.branchesForAddingForPopupoffset, $scope.searchStringVariable, $scope.sortStringVariable, $scope.isDescStatus);
                    }
                }

                $scope.getGeofenceRegionId = function (region_id) {
                    if (regionIdArray.indexOf(region_id) == -1) {
                        regionIdArray.push(region_id);
                        $scope.regionIdArrayLength = $scope.regionIdArrayLength + 1;
                    } else {
                        regionIdArray.splice(regionIdArray.indexOf(region_id), 1);
                        $scope.regionIdArrayLength = $scope.regionIdArrayLength - 1;
                    }
                    //$scope.regionIdArrayLength = regionIdArray.length;
                }

                $scope.filterBranchFunction = function (sucursal_id) {
                    $scope.branchListForPopup = [];
                    $scope.branchesForAddingForPopupoffset = 0;
                    $scope.branchesForAddingForPopup($scope.showActiveOrInactiveGeofenceStatus, $scope.branchesForAddingForPopupoffset, null, null, null, sucursal_id);
                }

                $scope.showActiveOrInactiveGeofenceFunction = function (status) {
                    $scope.branchListForPopup = [];
                    $scope.branchesForAddingForPopupoffset = 0;
                    $scope.showActiveOrInactiveGeofenceStatus = status;
                    $scope.branchesForAddingForPopup($scope.showActiveOrInactiveGeofenceStatus, $scope.branchesForAddingForPopupoffset, null, null, null, sucursalesSeleccionadas);
                }

                $scope.searchGeofenceFunction = function (string) {
                    $scope.searchStringVariable = string;
                    $scope.branchesForAddingForPopupoffset = 0;
                    $timeout.cancel($scope.yourTimer);
                    $scope.yourTimer = $timeout(function () {
                        $scope.loading = true;
                        $scope.branchListForPopup = [];
                        $scope.branchesForAddingForPopup($scope.showActiveOrInactiveGeofenceStatus, $scope.branchesForAddingForPopupoffset, string);
                    }, 1000);
                }

                $scope.sortByHead = function (sortString) {
                    $scope.loading = true;
                    $scope.sortStringVariable = sortString;
                    $scope.isDesc = !$scope.isDesc;
                    $scope.isDescStatus = $scope.isDesc == true ? 'DESC' : 'ASC';
                    $scope.branchListForPopup = [];
                    $scope.branchesForAddingForPopupoffset = 0;
                    $scope.branchesForAddingForPopup($scope.showActiveOrInactiveGeofenceStatus, $scope.branchesForAddingForPopupoffset, '', sortString, $scope.isDescStatus);
                }

                // ========== CLICK TO CLOSE DIALOG BOX ========= 
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };

                // ========== CLICK TO CLOSE DIALOG BOX AND CONFIRM RESPONSE ========= 
                $scope.confirmUpload = function (dataSend) {
                    $scope.stingRegionIdArray = "";
                    var regionIdArrayLength = regionIdArray.length;
                    for (var i = 0; i < regionIdArrayLength; i++) {
                        $scope.stingRegionIdArray += (i == 0) ? (regionIdArray[i]) : "," + (regionIdArray[i]);
                    }
                    if(vm.editID){
                        $scope.stingRegionIdArray += "," +vm.editID;
                    }

                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.id = $scope.stingRegionIdArray;
                    $log.log(dataSend);
                    vm.loading = true;

                    var promise = getGeofence.findAutoassignRegions(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log(payload);
                            vm.loading = false;
                            if (payload.title.data.length) {

                                var whereFixed = payload.title.data;

                                var where = _.where(payload.title.data, {
                                    parent_id: 0
                                });
                                //var where = _.where(where1,{is_active: 0});
                                //}

                                vm.allBranchList = where; //payload.title.data; //where;
                                for (var i = 0; i < vm.allBranchList.length; i++) {
                                    vm.allBranchList[i].index = i;
                                    vm.allBranchList[i].add = false;
                                    vm.allBranchList[i].edit = false;
                                    vm.allBranchList[i].strokeColor = '#f18903';
                                    vm.allBranchList[i].fillColor = 'transparent';
                                    vm.allBranchList[i].child = [];
                                }
                                if (whereFixed.length) {
                                    var newCombinationArray = vm.allBranchList;

                                    // comment code to hide geofences

                                    for (var i = 0; i < whereFixed.length; i++) {
                                        whereFixed[i].index = i;
                                        whereFixed[i].edit = false;
                                        whereFixed[i].view = false;
                                        whereFixed[i].strokeColor = (whereFixed[i].auto_assignment_region_id != vm.editID) ? '#A7E5F5' : '#063c4a';
                                        whereFixed[i].fillColor = (whereFixed[i].auto_assignment_region_id != vm.editID) ? '#A7E5F5' : '#063c4a';
                                        whereFixed[i].parent = {
                                            region_name: '',
                                            region_id: '',
                                            region_data: [],
                                            strokeColor: '#f18903',
                                            fillColor: 'transparent'
                                        };
                                        // whereFixed[i].region_data = whereFixed[i].region_data[0];

                                        // whereFixed[i].parent = {};
                                        whereFixed[i].parent.region_name = whereFixed[i].region_name;
                                        whereFixed[i].parent.region_id = whereFixed[i].region_id;
                                        whereFixed[i].parent.region_data = whereFixed[i].region_data;

                                        // for (var j = 0; j < vm.allBranchList.length; j++) {
                                        //     if (whereFixed[i].parent_id == vm.allBranchList[j].region_id) {
                                        //         whereFixed[i].parent.region_name = vm.allBranchList[j].region_name;
                                        //         whereFixed[i].parent.region_id = vm.allBranchList[j].region_id;
                                        //         whereFixed[i].parent.region_data = vm.allBranchList[j].region_data[0];
                                        //     }
                                        // }
                                        // for (var j = 0; j < newCombinationArray.length; j++) {
                                        //     if (whereFixed[i].parent_id == newCombinationArray[j].region_id) {
                                        //         newCombinationArray[j].child.push(whereFixed[i]);
                                        //     }
                                        // }
                                    }
                                    vm.tableFixedRouteList = whereFixed;
                                    vm.fixedRouteList = whereFixed; //newCombinationArray; //whereFixed
                                    // $log.log('whereFixed', newCombinationArray);
                                    //myCenter = new google.maps.LatLng(vm.fixedRouteList[0].region_data[0][0].x, vm.fixedRouteList[0].region_data[0][0].y);
                                    var bounds = new google.maps.LatLngBounds();
                                    vm.fixedRouteList.forEach(function(geocerca) {
                                        geocerca.region_data.forEach(function(punto) {
                                            bounds.extend(new google.maps.LatLng(punto[0].x, punto[0].y));
                                        });
                                    });
                                    zoomLevel = getZoomLevel(map, bounds, map.getDiv().offsetWidth, map.getDiv().offsetHeight);
                                    myCenter = bounds.getCenter();

                                    mapInitialize(vm.fixedRouteList);
                                    vm.hideFilters = false;
                                } else {
                                    vm.fixedRouteList = [];
                                    vm.noDataFlag = true;
                                    mapInitialize(vm.fixedRouteList);
                                    vm.hideFilters = false;
                                }

                            } else {

                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );

                    $mdDialog.hide();
                };
                //====================branches for adding For Popup======================
                vm.branchesForAddingForPopupLimit = 25;
                $scope.branchesForAddingForPopupoffset = 0;
                $scope.branchListForPopup = [];
                $scope.branchListForPopupCount = 0;

                $scope.branchesForAddingForPopup = function (filter, offset, searchString, sortByString, sortByASCOrDESC, sucursal_id) {
                    $scope.loading = true;
                    var promise = getGeofence.getAllBranchListForPopupAutoAssign(filter, vm.branchesForAddingForPopupLimit, offset, searchString, sortByString, sortByASCOrDESC, sucursal_id);
                    promise.then(
                        function (payload) {
                            $log.log(payload);
                            $scope.loading = false;
                            if (payload.title.data.length) {
                                payload.title.data.forEach(function (region) {
                                    if (regionIdArray.includes(region.auto_assignment_region_id)) {
                                        region.selected = true;
                                    }
                                    $scope.branchListForPopup.push(region);
                                });
                                $scope.branchListForPopupCount = payload.title.count;
                            } else {
                                $scope.branchListForPopupCount = payload.title.count;
                                $scope.branchListForPopup = [];
                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            $scope.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                };
                $scope.branchesForAddingForPopup(1, $scope.branchesForAddingForPopupoffset);
            }
        }

        // ================ FUNCTION TO SHOW MULTIPLE GEOFENCE SELECTION BUTTON IS DISABLE OR ENABLE ==================
        function checkboxToShowAllGeoFenceFunction(status) {
            vm.openMultipleGeofencePopupButtonDisable = !status;
            if (vm.openMultipleGeofencePopupButtonDisable) {
                vm.addFixedRouteGeofenceFlag = true;
                vm.editFixedRouteGeofenceFlag = false;
                vm.viewFixedRouteGeofenceFlag = false;
                // getAllBranches(vm.mainShowActiveOrInactiveGeofenceStatus);
                vm.mainBranchesForAddingForPopupoffset = 0;
                vm.allBranchList = [];
                vm.tableFixedRouteList = [];
                vm.fixedRouteList = [];
                vm.getAllBranches(vm.mainShowActiveOrInactiveGeofenceStatus, vm.mainBranchesForAddingForPopupoffset);
                vm.hideFilters = true;
            }
        }

        // ================ REMOVE GEOFENCE FROM MAP WHEN ADDING A NEW ONE ==================
        function removeGeoFenceFromMap() {

            // Hide geofence when user view or edit existing geofence
            for (var i = 0; i < vm.bermudaTriangleArray.length; i++) {
                if (vm.bermudaTriangleArray[i].visible) {
                    vm.bermudaTriangleArray[i].visible = false;
                    infoWindow.close();
                    vm.bermudaTriangleArray[i].setMap(map);
                }
            }
            vm.finalArrayCordinates = [];

            // Hide geofence when user is creating New geofence
            if (all_overlays[0]) {
                all_overlays[0].overlay.setMap(null);
            }
            all_overlays = [];

            drawingManager.setOptions({
                drawingControl: true
            });
            drawingManager.setMap(map);
        }

        function getZoomLevel(map, bounds, mapWidth, mapHeight) {
            var WORLD_DIM = { height: 256, width: 256 };
            var ZOOM_MAX = 21;

            var ne = bounds.getNorthEast();
            var sw = bounds.getSouthWest();

            var latFraction = (latRad(ne.lat()) - latRad(sw.lat())) / Math.PI;

            var lngDiff = ne.lng() - sw.lng();
            var lngFraction = ((lngDiff < 0) ? (lngDiff + 360) : lngDiff) / 360;

            var latZoom = zoom(mapHeight, WORLD_DIM.height, latFraction);
            var lngZoom = zoom(mapWidth, WORLD_DIM.width, lngFraction);

            var zoomLevel = Math.min(latZoom, lngZoom, ZOOM_MAX);

            return zoomLevel;
        }

        function latRad(lat) {
            var sin = Math.sin(lat * Math.PI / 180);
            var radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
            return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
        }

        function zoom(mapPx, worldPx, fraction) {
            return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
        }
    }
})();

/**
 * Created by cl-macmini-51 on 7/11/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .controller('ViewVehicleController', ViewVehicleController);

    /** @ngInject */
    function ViewVehicleController($cookies, $state, $log, $rootScope, $mdDialog, $timeout, $document, getVehicles, $scope, filterFilter, $stateParams,languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.getAllVehicles = getAllVehicles;
        vm.goBack = goBack;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();

        //====================event for getting refreshed================
        $scope.$on('StateReload', function(evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.vehicleTypeMain.viewVehicleType');
            }
        });

        //==================get all Vehicles=======================
        function getAllVehicles(id) {
            vm.loading = true;
            var promise = getVehicles.vehicleDetails(id);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.vehicleDetail = payload.title.data[0];
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        getAllVehicles($stateParams.id);
        //=================go back================
        function goBack() {
            $state.go('layout.vehicleTypeMain.vehicleType');
        };
    }
})();
/**
 * Created by cl-macmini-51 on 4/19/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('VehicleController', VehicleController);

    /** @ngInject */
    function VehicleController($cookies, $state, $log, $rootScope, $mdDialog, $timeout, $document, getVehicles, $scope, filterFilter, languageBasedErrorFactory, errorMessageFactory) {
        var vm = this;
        vm.getAllVehicles = getAllVehicles;
        vm.loading = false;
        vm.currentPage = 0;
        vm.totalVehicles = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.getPagesCount = getPagesCount;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.init = init;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.deleteVehicleHit = deleteVehicleHit;
        vm.blockUnblockVehicle = blockUnblockVehicle;
        vm.paginationNew = paginationNew;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.predicate = 'index';
        vm.reverse = false;
        vm.filterData = {
            vehicleStatus: '1'
        };
        //====================function for dropdown pages and page count===============
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];

        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllVehicles(0, vm.itemsPerPageGot, vm.filterData.vehicleStatus);
        };

        function paginationNew(page) {
            getAllVehicles((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData.vehicleStatus);
        }

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.vehicleTypeMain.vehicleType');
            }
        });

        //==================get all Vehicles=======================
        function getAllVehicles(skip, limit, filter) {
            vm.loading = true;
            var promise = getVehicles.allVehicles(skip, limit, filter);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.totalVehicles = payload.title.data.totalCount;
                        vm.dataLength = payload.title.data.totalCount;

                        if (payload.title.data.totalCount == 0) {
                            vm.sp_pagination = false;
                            vm.tBodyFlag = false;
                            vm.tFootFlag = true;
                        } else {
                            vm.sp_pagination = true;
                            vm.tBodyFlag = true;
                            vm.tFootFlag = false;
                        }

                        var dataArray = [];

                        var VehicleList = payload.title.data.result;
                        VehicleList.forEach(function (column) {
                            var d = {};
                            d.id = column.id;
                            d.name = column.name;
                            d.tag = column.tag;
                            d.categoria = column.categoria;
                            d.created_on = column.created_on;
                            d.created_by = column.created_by;
                            d.updated_on = column.updated_on;
                            d.updated_by = column.updated_by;
                            d.status = column.status;
                            d.vehicle_image = column.vehicle_image;
                            d.vehicle_img_offline = column.vehicle_img_offline;
                            d.vehicle_img_online = column.vehicle_img_online;
                            d.vehicle_img_position = column.vehicle_img_position;
                            d.vehicle_img_busy = column.vehicle_img_busy;
                            d.vehicle_img_road = column.vehicle_img_road;
                            d.vehicle_img_accepted = column.vehicle_img_accepted;
                            dataArray.push(d);
                        });
                        vm.VehicleList = dataArray;

                        for (var i = 0; i < vm.VehicleList.length; i++) {
                            vm.VehicleList[i].index = (skip + i);
                        }
                        if (vm.dataLength <= vm.itemsPerPageGot) {
                            vm.sp_pagination = false;
                        } else {
                            vm.sp_pagination = true;
                            //vm.pageCount(payload.title.data.totalCount);
                        }
                        vm.skipValue = vm.VehicleList[0].index;
                        vm.limitValue = vm.VehicleList[vm.VehicleList.length - 1].index;

                        $scope.$watch('vm.search', function (newVal, oldVal) {
                            vm.filtered = filterFilter(vm.VehicleList, newVal);
                            vm.totalItems = vm.filtered.length;
                            if (vm.filtered.length == 0) {
                                vm.watchPagination = false;
                            } else {
                                vm.watchPagination = true;
                            }
                            if (vm.filterOn == true) {
                                vm.skipValueFilter = vm.filtered.length;
                                vm.sp_pagination = false;
                            }
                        }, true);
                    }

                    //range();
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    } else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        vm.getAllVehicles((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData.vehicleStatus);
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        vm.currentPage++;
        //        vm.getAllVehicles((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData.vehicleStatus);
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    vm.getAllVehicles((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData.vehicleStatus);
        //};

        function init() {
            vm.getAllVehicles(0, vm.searchModel.limit, vm.filterData.vehicleStatus);
        };
        init();

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            vm.filterOn = true;
            if (vm.search.length == 0) {
                vm.filterOn = false;
                vm.watchPagination = true;
                vm.sp_pagination = true;
            }
        };
        //==================block_unblock function======================
        function blockUnblockVehicle($event, id, value) {
            $log.log('block_unblock');
            var parentEl = angular.element($document.body);
            var msg = languageBasedErrorFactory.getProperErrorMessage('statusVehiclePop', 0, '3');
            //==============dialog for confirm====================
            var confirm = $mdDialog.confirm()
                .title(msg)
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                var a = '';
                var msgSys = '';
                if (value == 0) {
                    a = 1;
                    msgSys = 'Vehicle type unblocked.'
                } else if (value == 1) {
                    a = 0;
                    msgSys = 'Vehicle type blocked.'
                }
                //errorMessageFactory.showErrorMessage('Functionality is pending.',0);
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.status = a;
                dataSend.vehicle_type_id = id;
                dataSend.content_type = 'application/json';
                vm.loading = true;
                var promise = getVehicles.editVehicles(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        if (payload.title.status == 200) {
                            var dataForSysLogs = {
                                access_token: $cookies.get('obj'),
                                id: id,
                                identity: 13,
                                message: msgSys
                            };
                            $rootScope.systemLogsAdmin(dataForSysLogs);
                            // languageBasedErrorFactory.getProperErrorMessage('statusVehicleSucc',0,1,'layout.vehicleTypeMain.vehicleType');
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'layout.vehicleTypeMain.vehicleType');
                        } else {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                        //errorMessageFactory.showErrorMessage('Vehicle status updated successfully.',1);
                        //$timeout(function() {
                        //    $mdDialog.hide();
                        //    $state.reload();
                        //}, 2000);
                    },
                    function (errorPayload) {
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('unblock');
            });
        };
        //=====================to delete vehicle====================
        function deleteVehicleHit(data, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('deleteVehiclePop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                //errorMessageFactory.showErrorMessage('Functionality is pending',0);
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.deleteType = 1;
                dataSend.type_of_vehicle = data.id;
                vm.loading = true;
                var promise = getVehicles.deleteVehicle(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        //errorMessageFactory.showErrorMessage('Vehicle deleted successfully.',1);
                        languageBasedErrorFactory.getProperErrorMessage('deleteVehicleSucc', 0, 1, 'layout.vehicleTypeMain.vehicleType');
                        //$state.reload();
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        };


    }

})();
/**
 * Created by cl-macmini-51 on 4/28/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('EditVehicleController', EditVehicleController);

    /** @ngInject */
    function EditVehicleController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document, moment, getVehicles, $scope, RutHelper, languageBasedErrorFactory, errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.registerApi = registerApi;
        vm.goBack = goBack;
        vm.clickTrigger = clickTrigger;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings()
        vm.dataToFill = {
            name: '',
            tag: '',
            category: '',
            hideImageG: false,
            hideImageOf: false,
            hideImageOn: false,
            hideImageB: false,
            hideImageP: false,
            hideImageA: false,
            hideImageO: false,
            uploadName: '',
            vehicle_img: '',
            vehicle_img_offline: '',
            vehicle_img_online: '',
            vehicle_img_busy: '',
            vehicle_img_road: '',
            vehicle_img_accepted: '',
            vehicle_img_position: '',
            vehicle_imgU: '',
            vehicle_img_offlineU: '',
            vehicle_img_onlineU: '',
            vehicle_img_busyU: '',
            vehicle_img_roadU: '',
            vehicle_img_acceptedU: '',
            vehicle_img_positionU: '',
            vehicle_type_id: $stateParams.id
        };
        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.vehicleTypeMain.editVehicleType');
            }
        });
        //=================go back================
        function goBack() {
            $state.go('layout.vehicleTypeMain.vehicleType');
        };
        //==================get all Vehicles=======================
        function getAllVehicles(id) {
            vm.loading = true;
            var promise = getVehicles.vehicleDetails(id);
            promise.then(
                function (payload) {

                    $log.log('sxdsads', payload);
                    vm.loading = false;

                    vm.dataToFill.name = payload.title.data[0].name;
                    vm.dataToFill.tag = payload.title.data[0].tag;
                    vm.dataToFill.category = payload.title.data[0].categoria;
                    vm.dataToFill.vehicle_img = payload.title.data[0].vehicle_image;
                    vm.dataToFill.vehicle_img_offline = payload.title.data[0].vehicle_img_offline;
                    vm.dataToFill.vehicle_img_online = payload.title.data[0].vehicle_img_online;
                    vm.dataToFill.vehicle_img_position = payload.title.data[0].vehicle_img_position;
                    vm.dataToFill.vehicle_img_busy = payload.title.data[0].vehicle_img_busy;
                    vm.dataToFill.vehicle_img_road = payload.title.data[0].vehicle_img_road;
                    vm.dataToFill.vehicle_img_accepted = payload.title.data[0].vehicle_img_accepted;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllVehicles($stateParams.id);

        //======================vehicle image ======================
        function clickTrigger($event, type) {
            $log.log('ddf');
            $event.stopPropagation();
            vm.dataToFill.uploadName = type;
            var element = document.getElementById('documentUpload');
            element.click();
        };
        $scope.file_to_upload = function (File, type) {
            var file = File[0];
            var transcript = File[0];
            var reader = new FileReader;
            reader.onload = function (e) {
                var img = new Image();
                img.onload = function () {
                    if (img.width > 40 && img.height > 80) {
                        languageBasedErrorFactory.getProperErrorMessage('vehicleImageCheck', 0, 0);
                        return;
                    } else {
                        if (type == 'VEHICLE_IMAGE') {
                            vm.dataToFill.hideImageG = true;
                            document.getElementById('vehicleImageEdit').setAttribute('src', e.target.result);
                            vm.dataToFill.vehicle_imgU = File[0];
                        } else if (type == 'VEHICLE_IMAGE_OFF') {
                            vm.dataToFill.hideImageOf = true;
                            document.getElementById('vehicleImageOffEdit').setAttribute('src', e.target.result);
                            vm.dataToFill.vehicle_img_offlineU = File[0];
                        } else if (type == 'VEHICLE_IMAGE_ON') {
                            vm.dataToFill.hideImageOn = true;
                            document.getElementById('vehicleImageOnEdit').setAttribute('src', e.target.result);
                            vm.dataToFill.vehicle_img_onlineU = File[0];
                        } else if (type == 'VEHICLE_IMAGE_BUSY') {
                            vm.dataToFill.hideImageB = true;
                            document.getElementById('vehicleImageBusyEdit').setAttribute('src', e.target.result);
                            vm.dataToFill.vehicle_img_busyU = File[0];
                        } else if (type == 'VEHICLE_IMAGE_POSITION') {
                            vm.dataToFill.hideImageP = true;
                            document.getElementById('vehicleImagePositionEdit').setAttribute('src', e.target.result);
                            vm.dataToFill.vehicle_img_positionU = File[0];
                        } else if (type == 'VEHICLE_IMAGE_ACCEPTED') {
                            vm.dataToFill.hideImageA = true;
                            document.getElementById('vehicleImageAcceptedEdit').setAttribute('src', e.target.result);
                            vm.dataToFill.vehicle_img_acceptedU = File[0];
                        } else if (type == 'VEHICLE_IMAGE_ROAD') {
                            vm.dataToFill.hideImageO = true;
                            document.getElementById('vehicleImageRoadEdit').setAttribute('src', e.target.result);
                            vm.dataToFill.vehicle_img_roadU = File[0];
                        }
                        $scope.$apply();
                    }
                };
                img.src = reader.result;
            };
            reader.readAsDataURL(transcript);
            $log.log(vm.dataToFill);
        };
        //======================submit form====================
        function registerApi() {
            $log.log('12344', vm.dataToFill);
            if (!vm.dataToFill.vehicle_img && !vm.dataToFill.vehicle_imgU) {
                languageBasedErrorFactory.getProperErrorMessage('vehicleImageError', 0, 0);
                return;
            }
            if (!vm.dataToFill.vehicle_img_offline && !vm.dataToFill.vehicle_img_offlineU) {
                languageBasedErrorFactory.getProperErrorMessage('vehicleImageOffError', 0, 0);
                return;
            }
            if (!vm.dataToFill.vehicle_img_online && !vm.dataToFill.vehicle_img_onlineU) {
                languageBasedErrorFactory.getProperErrorMessage('vehicleImageOnError', 0, 0);
                return;
            }
            if (!vm.dataToFill.vehicle_img_busy && !vm.dataToFill.vehicle_img_busyU) {
                languageBasedErrorFactory.getProperErrorMessage('vehicleImageBusyError', 0, 0);
                return;
            }
            if (!vm.dataToFill.vehicle_img_road && !vm.dataToFill.vehicle_img_roadU) {
                languageBasedErrorFactory.getProperErrorMessage('vehicleImageOnroadError', 0, 0);
                return;
            }
            if (!vm.dataToFill.vehicle_img_accepted && !vm.dataToFill.vehicle_img_acceptedU) {
                languageBasedErrorFactory.getProperErrorMessage('vehicleImageAcceptedError', 0, 0);
                return;
            }
            if (!vm.dataToFill.vehicle_img_position && !vm.dataToFill.vehicle_img_positionU) {
                languageBasedErrorFactory.getProperErrorMessage('vehicleImagePositionError', 0, 0);
                return;
            }

            var dataSend = new FormData();
            dataSend.append('name', vm.dataToFill.name);
            dataSend.append('tag', vm.dataToFill.tag);
            dataSend.append('vehicle_category', vm.dataToFill.category);
            dataSend.append('vehicle_type_id', vm.dataToFill.vehicle_type_id);
            if (vm.dataToFill.vehicle_imgU)
                dataSend.append('vehicle_img', vm.dataToFill.vehicle_imgU);
            if (vm.dataToFill.vehicle_img_offlineU)
                dataSend.append('vehicle_img_offline', vm.dataToFill.vehicle_img_offlineU);
            if (vm.dataToFill.vehicle_img_onlineU)
                dataSend.append('vehicle_img_online', vm.dataToFill.vehicle_img_onlineU);
            if (vm.dataToFill.vehicle_img_busyU)
                dataSend.append('vehicle_img_busy', vm.dataToFill.vehicle_img_busyU);
            if (vm.dataToFill.vehicle_img_roadU)
                dataSend.append('vehicle_img_road', vm.dataToFill.vehicle_img_roadU);
            if (vm.dataToFill.vehicle_img_acceptedU)
                dataSend.append('vehicle_img_accepted', vm.dataToFill.vehicle_img_acceptedU);
            if (vm.dataToFill.vehicle_img_positionU)
                dataSend.append('vehicle_img_position', vm.dataToFill.vehicle_img_positionU);
            dataSend.append('access_token', $cookies.get('obj'));
            vm.loading = true;
            var promise = getVehicles.editVehicles(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        var dataForSysLogs = {
                            access_token: $cookies.get('obj'),
                            id: $stateParams.id,
                            identity: 13,
                            message: 'Vehicle type updated.'
                        };
                        $rootScope.systemLogsAdmin(dataForSysLogs);
                        // languageBasedErrorFactory.getProperErrorMessage('vehicleEditSucc',0,2,'layout.vehicleTypeMain.vehicleType');
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'layout.vehicleTypeMain.vehicleType');
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    //$timeout(function() {
                    //    $mdDialog.hide();
                    //    $state.reload();
                    //}, 2000);
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
    }
})();
/**
 * Created by cl-macmini-51 on 4/28/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .controller('AddVehicleController', AddVehicleController);

    /** @ngInject */
    function AddVehicleController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document, moment, getVehicles, $scope, RutHelper, languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.registerApi = registerApi;
        vm.goBack = goBack;
        vm.clickTrigger = clickTrigger;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.dataToFill = {
            name: '',
            tag: '',
            category: '',
            vehicle_img: '',
            vehicle_img_offline: '',
            vehicle_img_position: '',
            vehicle_img_online: '',
            vehicle_img_busy: '',
            vehicle_img_road: '',
            vehicle_img_accepted: '',
            uploadName: ''
        };
        //====================event for getting refreshed================
        $scope.$on('StateReload', function(evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.vehicleTypeMain.addVehicle');
            }
        });
        //=================go back================
        function goBack() {
            $state.go('layout.vehicleTypeMain.vehicleType');
        };

        //======================vehicle image ======================
        function clickTrigger($event,type) {
            $log.log('ddf');
            $event.stopPropagation();
            vm.dataToFill.uploadName = type;
            var element = document.getElementById('documentUpload');
            element.click();
        };
        $scope.file_to_upload = function(File, type) {
            var file = File[0];
            var transcript = File[0];
            var reader = new FileReader;
            reader.onload = function(e) {
                var img = new Image();
                img.onload = function () {
                    if(img.width > 40 && img.height > 80){
                        languageBasedErrorFactory.getProperErrorMessage('vehicleImageCheck',0,0);
                        return;
                    }
                    else{
                        if(type == 'VEHICLE_IMAGE'){
                            document.getElementById('vehicleImage').setAttribute('src', e.target.result);
                            vm.dataToFill.vehicle_img = File[0];
                        }
                        else if(type == 'OFF_IMAGE'){
                            document.getElementById('offImage').setAttribute('src', e.target.result);
                            vm.dataToFill.vehicle_img_offline = File[0];
                        }
                        else if(type == 'ON_IMAGE'){
                            document.getElementById('onImage').setAttribute('src', e.target.result);
                            vm.dataToFill.vehicle_img_online = File[0];
                        }
                        else if(type == 'BUSY_IMAGE'){
                            document.getElementById('busyImage').setAttribute('src', e.target.result);
                            vm.dataToFill.vehicle_img_busy = File[0];
                        }
                        else if(type == 'POSITION_IMAGE'){
                            document.getElementById('positionImage').setAttribute('src', e.target.result);
                            vm.dataToFill.vehicle_img_position = File[0];
                        }
                        else if(type == 'ACCEPTED_IMAGE'){
                            document.getElementById('acceptedImage').setAttribute('src', e.target.result);
                            vm.dataToFill.vehicle_img_accepted = File[0];
                        }
                        else if(type == 'ON_ROAD_IMAGE'){
                            document.getElementById('onroadImage').setAttribute('src', e.target.result);
                            vm.dataToFill.vehicle_img_road = File[0];
                        }
                    }
                };
                img.src = reader.result;
            };
            reader.readAsDataURL(transcript);
            $log.log(vm.dataToFill);
        };

        //======================submit form====================
        function registerApi() {
            $log.log('12344', vm.dataToFill);

            if(!vm.dataToFill.vehicle_img){
                languageBasedErrorFactory.getProperErrorMessage('vehicleImageError',0,0);
                return;
            }
            if(!vm.dataToFill.vehicle_img_offline){
                languageBasedErrorFactory.getProperErrorMessage('vehicleImageOffError',0,0);
                return;
            }
            if(!vm.dataToFill.vehicle_img_online){
                languageBasedErrorFactory.getProperErrorMessage('vehicleImageOnError',0,0);
                return;
            }
            if(!vm.dataToFill.vehicle_img_busy){
                languageBasedErrorFactory.getProperErrorMessage('vehicleImageBusyError',0,0);
                return;
            }
            if(!vm.dataToFill.vehicle_img_accepted){
                languageBasedErrorFactory.getProperErrorMessage('vehicleImageAcceptedError',0,0);
                return;
            }
            if(!vm.dataToFill.vehicle_img_road){
                languageBasedErrorFactory.getProperErrorMessage('vehicleImageOnroadError',0,0);
                return;
            }
            if(!vm.dataToFill.vehicle_img_position){
                languageBasedErrorFactory.getProperErrorMessage('vehicleImagePositionError',0,0);
                return;
            }




            var dataSend = new FormData();
            dataSend.append('name',vm.dataToFill.name);
            dataSend.append('tag',vm.dataToFill.tag);
            dataSend.append('vehicle_category', vm.dataToFill.category);
            dataSend.append('vehicle_img',vm.dataToFill.vehicle_img);
            dataSend.append('vehicle_img_road',vm.dataToFill.vehicle_img_road);
            dataSend.append('vehicle_img_position',vm.dataToFill.vehicle_img_position);
            dataSend.append('vehicle_img_busy',vm.dataToFill.vehicle_img_busy);
            dataSend.append('vehicle_img_online',vm.dataToFill.vehicle_img_online);
            dataSend.append('vehicle_img_offline',vm.dataToFill.vehicle_img_offline);
            dataSend.append('vehicle_img_accepted',vm.dataToFill.vehicle_img_accepted);
            dataSend.append('access_token',$cookies.get('obj'));
            vm.loading = true;
            var promise = getVehicles.addVehicles(dataSend);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    languageBasedErrorFactory.getProperErrorMessage('vehicleAddSucc',0,2,'layout.vehicleTypeMain.vehicleType');
                    //errorMessageFactory.showErrorMessage('Vehicle added successfully.',2,'layout.vehicleTypeMain.vehicleType');
                    //$timeout(function() {
                    //    $mdDialog.hide();
                    //    $state.reload();
                    //}, 2000);
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
    }
})();
/**
 * Created by cl-macmini-51 on 7/11/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('ViewTypeOfServiceController', ViewTypeOfServiceController);

    /** @ngInject */
    function ViewTypeOfServiceController($cookies, $state, $log, $rootScope, $timeout, getCars, $scope, filterFilter, $mdDialog,$document, getServices,$stateParams,languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.getAllServices = getAllServices;
        vm.goBack = goBack;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.typeOfServiceMain.viewTypeofService');
            }
        });
        //=====================get service hit=========================
        function getAllServices(id) {
            vm.loading = true;
            var promise = getServices.serviceDetails(id);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.serviceDetail = payload.title.data;
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        getAllServices($stateParams.id);
        //=================go back================
        function goBack() {
            $state.go('layout.typeOfServiceMain.typeofService');
        };
    }
})();

/**
 * Created by cl-macmini-51 on 4/19/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .controller('ServiceController', ServiceController);

    /** @ngInject */
    function ServiceController($cookies, $state, $log, $rootScope, $mdDialog, $timeout, $document, getServices, $scope, filterFilter, languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.getAllServices = getAllServices;
        vm.loading = false;
        vm.currentPage = 0;
        vm.totalServices = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.getPagesCount = getPagesCount;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.init = init;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.blockUnblockService = blockUnblockService;
        vm.deleteServiceHit = deleteServiceHit;
        vm.paginationNew = paginationNew;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.predicate = 'index';
        vm.reverse = false;
        vm.filterData = {
            serviceStatus: '1'
        };
        //====================function for dropdown pages and page count===============
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];

        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllServices(0, vm.itemsPerPageGot,vm.filterData.serviceStatus);
        };
        function paginationNew(page){
            getAllServices((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot,vm.filterData.serviceStatus);
        }

        //====================event for getting refreshed================
        $scope.$on('StateReload', function(evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.typeOfServiceMain.typeofService');
            }
        });

        //==================get all services=======================
        function getAllServices(skip, limit,filter) {
            vm.loading = true;
            var promise = getServices.allServices(skip, limit,filter,1);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if(payload.title.status == 400){
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    else if(payload.title.status == 401){
                        errorMessageFactory.showErrorMessage(payload.title.message,2,'home');
                    }
                    else if(payload.title.status == 201 || payload.title.status == 200) {
                        vm.totalServices = payload.title.data.totalCount;
                        vm.dataLength = payload.title.data.totalCount;

                        if (payload.title.data.totalCount == 0) {
                            vm.sp_pagination = false;
                            vm.tBodyFlag = false;
                            vm.tFootFlag = true;
                        } else {
                            vm.sp_pagination = true;
                            vm.tBodyFlag = true;
                            vm.tFootFlag = false;
                        }

                        var dataArray = [];

                        var serviceList = payload.title.data.result;
                        serviceList.forEach(function (column) {
                            var d = {};
                            d.id = column.id;
                            d.service_name = column.service_name;
                            d.status = column.status;
                            d.created_on = column.created_on;
                            d.created_by = column.created_by;
                            d.updated_on = column.updated_on;
                            d.updated_by = column.updated_by;
                            d.controlled_way = column.controlled_way;
                            d.region_name = column.region_name;
                            d.branch_id = column.branch_id;
                            d.max_limit = column.max_limit;
                            d.service_image = column.service_image;
                            d.service_thumb_image = column.service_thumb_image;
                            d.vehicle_mapping = column.vehicle_mapping;
                            d.fare_type = column.fare_type;
                            d.service_transport_type = column.service_transport_type;
                            d.is_current = column.is_current;
                            d.is_scheduled = column.is_scheduled;
                            d.tolerance = column.tolerance;
                            d.category = column.category;
                            d.shared_wait_time=column.shared_wait_time;
                            // d.status = column.status;
                            // d.RUT = column.RUT;
                            // d.created_on = column.created_on;
                            // d.contact_created_by = column.created_by;
                            // d.updated_on = column.updated_on;
                            // d.updated_by = column.updated_by;
                            dataArray.push(d);
                        });
                        vm.serviceList = dataArray;

                        for (var i = 0; i < vm.serviceList.length; i++) {
                            vm.serviceList[i].index = (skip + i);
                        }
                        if (vm.dataLength <= vm.itemsPerPageGot) {
                            vm.sp_pagination = false;
                        } else {
                            vm.sp_pagination = true;
                            //vm.pageCount(payload.title.data.totalCount);
                        }
                        vm.skipValue = vm.serviceList[0].index;
                        vm.limitValue = vm.serviceList[vm.serviceList.length - 1].index;

                        $scope.$watch('vm.search', function (newVal, oldVal) {
                            vm.filtered = filterFilter(vm.serviceList, newVal);
                            vm.totalItems = vm.filtered.length;
                            if (vm.filtered.length == 0) {
                                vm.watchPagination = false;
                            } else {
                                vm.watchPagination = true;
                            }
                            if (vm.filterOn == true) {
                                vm.skipValueFilter = vm.filtered.length;
                                vm.sp_pagination = false;
                            }
                        }, true);
                    }

                    //range();
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };

        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    } else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        vm.getAllServices((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData.serviceStatus);
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        vm.currentPage++;
        //        vm.getAllServices((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData.serviceStatus);
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    vm.getAllServices((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData.serviceStatus);
        //};

        function init() {
            vm.getAllServices(0, vm.searchModel.limit,vm.filterData.serviceStatus);
        };
        init();

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            vm.filterOn = true;
            if (vm.search.length == 0) {
                vm.filterOn = false;
                vm.watchPagination = true;
                vm.sp_pagination = true;
            }
        };

        //==================block_unblock function======================
        function blockUnblockService($event, id, value) {
            $log.log('block_unblock');
            var parentEl = angular.element($document.body);
            var msg = languageBasedErrorFactory.getProperErrorMessage('statusServicePop',0,'3');
            //==============dialog for confirm====================
            var confirm = $mdDialog.confirm()
                .title(msg)
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton',0,'3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton',0,'3'));

            $mdDialog.show(confirm).then(function() {
                var a = '';
                var msgSys = '';
                if (value == 0) {
                    a = 1;
                    msgSys = 'Service unblocked.';
                } else if (value == 1) {
                    a = 0;
                    msgSys = 'Service blocked.';
                }
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.type_of_service_id = id;
                dataSend.status = a;
                dataSend.content_type = 'application/json';
                //errorMessageFactory.showErrorMessage('Functionality is pending.',0);
                $log.log('blocked');
                var promise = getServices.editServices(dataSend);
                promise.then(
                    function(payload) {
                        $log.log('block_unblock', payload);
                        var dataForSysLogs = {
                            access_token: $cookies.get('obj'),
                            id: id,
                            identity : 12,
                            message : msgSys
                        };
                        $rootScope.systemLogsAdmin(dataForSysLogs);
                        languageBasedErrorFactory.getProperErrorMessage('statusServiceSucc',0,1,'layout.typeOfServiceMain.typeofService');
                        //errorMessageFactory.showErrorMessage('Service status update successfully.',1);
                    },
                    function(errorPayload) {
                        vm.loading = false;
                        if(errorPayload.data.status == 401){
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                        }
                        else{
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                        }
                    }
                );
            }, function() {
                $log.log('unblock');
            });
        };
        //=====================to delete service====================
        function deleteServiceHit(data, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('deleteServicePop',0,'3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton',0,'3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton',0,'3'));

            $mdDialog.show(confirm).then(function() {
                $log.log('confirmed');
                //errorMessageFactory.showErrorMessage('Functionality is pending',0);
                var dataSend = {
                    deleteType: 1,
                    type_of_service_id: data.id,
                    access_token: $cookies.get('obj')
                };
                vm.loading = true;
                var promise = getServices.deleteService(dataSend);
                promise.then(
                    function(payload) {
                        $log.log(payload);
                        vm.loading = false;
                        languageBasedErrorFactory.getProperErrorMessage('deleteServiceSucc',0,1,'layout.typeOfServiceMain.typeofService');
                        //errorMessageFactory.showErrorMessage('Service deleted successfully.',1);
                        //$state.reload();
                    },
                    function(errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if(errorPayload.data.status == 401){
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                        }
                        else{
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                        }
                    }
                );
            }, function() {
                $log.log('not confirmed');
            });
        };


    }

})();

/**
 * Created by cl-macmini-51 on 4/28/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('EditServiceController', EditServiceController);

    /** @ngInject */
    function EditServiceController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document, moment, getServices, $scope, RutHelper, getVehicles, languageBasedErrorFactory, errorMessageFactory, getGeofence) {
        var vm = this;
        vm.loading = false;
        vm.editApi = editApi;
        vm.goBack = goBack;
        vm.clickTrigger = clickTrigger;
        vm.setBooleans = setBooleans;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.dataToFill = {
            service_name: '',
            service_name_english: '',
            status: '',
            max_limit: '',
            service_img: '',
            hideImage: false,
            service_imgU: '',
            controlledWay: '',
            branch_value: '',
            vehicle_type: [],
            type_of_service_id: $stateParams.id,
            current: false,
            scheduled: false,
            uniquePassengerFare: "true",
            exclusiveShared: "1",
            tolerance: '',
            shared_wait_time: '',
            service_transport_type: 'false'
        };

        //==============set boolean=================
        function setBooleans(type) {
            switch (type) {
                case 'CURRENT':
                    vm.dataToFill.current = !vm.dataToFill.current;
                    break;
                case 'SCHEDULED':
                    vm.dataToFill.scheduled = !vm.dataToFill.scheduled;
                    break;
                default:
                    break;
            }
        }

        //==================get all vehicles=========================
        function getAllVehicles() {
            var promise = getVehicles.allVehicles(0, 0, 2);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.vehicleList = _.where(payload.title.data.result, {
                            status: 1
                        });
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //======================vehicle image ======================
        function clickTrigger($event) {
            $log.log('ddf');
            $event.stopPropagation();
            var element = document.getElementById('documentUpload');
            element.click();
        };
        $scope.file_to_upload = function (File, type) {
            var file = File[0];
            var transcript = File[0];
            var reader = new FileReader;
            reader.onload = function (e) {
                var img = new Image();
                img.onload = function () {
                    if (img.width > 300 && img.height > 300) {
                        languageBasedErrorFactory.getProperErrorMessage('serviceImageCheck', 0, 0);
                        return;
                    } else {
                        vm.dataToFill.hideImage = true;
                        document.getElementById('serviceImageEdit').setAttribute('src', e.target.result);
                        vm.dataToFill.service_imgU = File[0];
                        $scope.$apply();
                    }
                };
                img.src = reader.result;
            };
            reader.readAsDataURL(transcript);
            $log.log(vm.dataToFill);
        };
        //====================get branch list====================
        function getBranch() {
            //vm.loading = true;
            var promise = getGeofence.branch();
            promise.then(
                function (payload) {
                    $log.log(payload);
                    //vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        var where = _.where(payload.title.data, {
                            parent_id: 0
                        });
                        //vm.branchList = _.where(where, { is_active: 1 });
                        vm.branchList = where;
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        getBranch();
        //==================get all services=======================
        function getAllServices(id) {
            vm.loading = true;
            var promise = getServices.serviceDetails(id);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.dataToFill.service_name = payload.title.data.service_name;
                    vm.dataToFill.service_name_english = payload.title.data.service_name_english;
                    vm.dataToFill.status = payload.title.data.status.toString();
                    vm.dataToFill.max_limit = payload.title.data.max_limit;
                    vm.dataToFill.service_img = payload.title.data.service_image;
                    vm.dataToFill.controlledWay = payload.title.data.controlled_way;
                    vm.dataToFill.branch_value = payload.title.data.branch_id;
                    vm.dataToFill.tolerance = payload.title.data.tolerance;
                    vm.dataToFill.shared_wait_time = payload.title.data.shared_wait_time;
                    vm.dataToFill.exclusiveShared = payload.title.data.category.toString();
                    vm.dataToFill.uniquePassengerFare = payload.title.data.fare_type == 0 ? "true" : "false";
                    vm.dataToFill.service_transport_type = payload.title.data.service_transport_type == 0 ? "false" : "true";
                    vm.dataToFill.current = payload.title.data.is_current ? true : false;
                    vm.dataToFill.scheduled = payload.title.data.is_scheduled ? true : false;
                    for (var i = 0; i < payload.title.data.vehicle_mapping.length; i++) {
                        if (payload.title.data.vehicle_mapping[i].status == 1)
                            vm.dataToFill.vehicle_type.push(payload.title.data.vehicle_mapping[i].id);
                    }
                    getAllVehicles();
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        getAllServices($stateParams.id);
        //======================submit form====================
        function editApi() {
            $log.log('12344', vm.dataToFill);

            if (!vm.dataToFill.service_img && !vm.dataToFill.service_imgU) {
                languageBasedErrorFactory.getProperErrorMessage('serviceImageError', 0, 0);
                return;
            }
            if (vm.dataToFill.controlledWay > 10000) {
                errorMessageFactory.showErrorMessage('A través del aeropuerto controlado no puede ser mayor que 10000', 0);
                return;
            }

            if (vm.dataToFill.shared_wait_time > 100) {
                errorMessageFactory.showErrorMessage('Tiempo Espera Compartido cannot be greater than 100', 0);
                return;
            }

            var dataSend = new FormData();
            dataSend.append('access_token', $cookies.get('obj'));
            dataSend.append('service_name', vm.dataToFill.service_name);
            dataSend.append('service_name_english', vm.dataToFill.service_name_english);
            dataSend.append('max_limit', vm.dataToFill.max_limit);
            dataSend.append('vehicle_type', JSON.stringify(vm.dataToFill.vehicle_type));
            dataSend.append('type_of_service_id', vm.dataToFill.type_of_service_id);
            dataSend.append('controlled_way', vm.dataToFill.controlledWay);
            dataSend.append('branch_id', vm.dataToFill.branch_value);
            dataSend.append('fare_type', vm.dataToFill.uniquePassengerFare == "true" ? 0 : 1);
            dataSend.append('service_transport_type', vm.dataToFill.service_transport_type == "true" ? 1 : 0);
            dataSend.append('is_current', vm.dataToFill.current ? 1 : 0);
            dataSend.append('is_scheduled', vm.dataToFill.scheduled ? 1 : 0);
            dataSend.append('tolerance', vm.dataToFill.tolerance);
            dataSend.append('shared_wait_time', vm.dataToFill.shared_wait_time);
            dataSend.append('category', Number(vm.dataToFill.exclusiveShared));
            if (vm.dataToFill.service_imgU)
                dataSend.append('service_img', vm.dataToFill.service_imgU);
            vm.loading = true;
            var promise = getServices.editServices(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        var dataForSysLogs = {
                            access_token: $cookies.get('obj'),
                            id: vm.dataToFill.type_of_service_id,
                            identity: 12,
                            message: 'Service updated.'
                        };
                        $rootScope.systemLogsAdmin(dataForSysLogs);
                        languageBasedErrorFactory.getProperErrorMessage('serviceEditSucc', 0, 2, 'layout.typeOfServiceMain.typeofService');
                        //errorMessageFactory.showErrorMessage('Service updated successfully.',2,'layout.typeOfServiceMain.typeofService');
                        //$timeout(function() {
                        //    $mdDialog.hide();
                        //    $state.reload();
                        //}, 2000);
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.typeOfServiceMain.editTypeofService');
            }
        });
        //=================go back================
        function goBack() {
            $state.go('layout.typeOfServiceMain.typeofService');
        };
    }
})();
/**
 * Created by cl-macmini-51 on 4/28/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('AddServiceController', AddServiceController);

    /** @ngInject */
    function AddServiceController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document, moment, getServices, $scope,
        RutHelper, getVehicles, languageBasedErrorFactory, errorMessageFactory, getGeofence, getFilters) {
        var vm = this;
        vm.loading = false;
        vm.registerApi = registerApi;
        vm.goBack = goBack;
        vm.branchChanged = branchChanged;
        vm.vehicleChanged = vehicleChanged;
        vm.clickTrigger = clickTrigger;
        vm.vehicleChanged = vehicleChanged;
        vm.setBooleans = setBooleans;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.dataToFill = {
            service_name: '',
            service_name_english: '',
            service_img: '',
            vehicle_type: [],
            max_limit: '',
            controlledWay: '',
            branch_value: '',
            current: false,
            scheduled: false,
            uniquePassengerFare: "true",
            exclusiveShared: "1",
            tolerance: 0,
            shared_wait_time: '',
            service_transport_type:'false'
        };

        vm.paginationChangedForVehicle = paginationChangedForVehicle;
        vm.paginationChangedForBranch = paginationChangedForBranch;

        vm.vehicleSearch = vehicleSearch;
        vm.branchSearch = branchSearch;

        vm.globalLimit = 10;
        vm.globalOffset = vm.globalLimit;

        vm.vehicleList = [];

        vm.branchList = [];

        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'vehicleList', 'service', 'agreement', 'corporatesList', 'operation_point'];

        vm.branchOffset = 0;
        vm.vehicleOffset = 0;

        // =================== FILTER OBJECT ===================
        vm.filterObject = {
            access_token: $cookies.get('obj'),
            branch_filter: 1,
            vehicle_filter: 1,
            service_filter: 0,
            agreement_filter: 0,
            corporate_filter: 0,
            service_category: 0,
            corporate_status: 0,
            agreement_status: 0,
            vehicle__status: 1,
            operation_point_filter: 0,
            branch_limit: vm.globalLimit,
            branch_offset: vm.branchOffset,
            vehicle_limit: vm.globalLimit,
            vehicle_offset: vm.vehicleOffset,
            branch_search_filter: 0,
            vehicle_search_filter: 0,
            service_search_filter: 0,
            agreement_search_filter: 0,
            corporate_search_filter: 0,
            operation_point_search_filter: 0
        }

        setTimeout(function () {
            setTimeout(function () {
                document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                    // if (vm.branchList && (vm.branchList.length == 0)) {
                    vm.searchBranchData = '';
                    getFilterDataFromBackend(0, 0);
                    // }
                });

                document.getElementsByClassName('ui-select-search')[1].addEventListener('blur', function ($event) {
                    // if (vm.vehicleList && (vm.vehicleList.length == 0)) {
                    vm.searchVehicleData = '';
                    getFilterDataFromBackend(0, 0);
                    // }
                });



            })


        })
        // =================== GET FILTER DATA ===================
        function getFilterDataFromBackend(data, type) { //Acc to Index ['branch_search', 'vehicle_search', 'service_search', 'agreement_search', 'corporate_search', 'operation_point_search']
            if (data) {
                vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
            } else {
                vm.filterObject = {
                    access_token: $cookies.get('obj'),
                    branch_filter: 1,
                    vehicle_filter: 1,
                    service_filter: 0,
                    agreement_filter: 0,
                    corporate_filter: 0,
                    service_category: 0,
                    corporate_status: 0,
                    agreement_status: 2,
                    vehicle__status: 2,
                    operation_point_filter: 0,
                    branch_search_filter: 0,
                    vehicle_search_filter: 0,
                    service_search_filter: 0,
                    agreement_search_filter: 0,
                    corporate_search_filter: 0,
                    operation_point_search_filter: 0
                }
            }

            vm.filterObject.branch_limit = vm.globalLimit;
            vm.filterObject.branch_offset = vm.branchOffset;
            vm.filterObject.vehicle_limit = vm.globalLimit;
            vm.filterObject.vehicle_offset = vm.vehicleOffset;


            var promise = getFilters.getAllFilterData(vm.filterObject);
            promise.then(
                function (payload) {

                    // ********** BRANCH DATA ********
                    if (payload.title.data.branches) {
                        var index = _.findIndex(vm.branchList, {
                            region_id: 'all'
                        });
                        if (index == -1)
                            vm.branchList.push({
                                region_name: 'All',
                                region_id: 'all'
                            });
                        angular.forEach(payload.title.data.branches.data, function (column) {
                            var branchIndex = _.findIndex(vm.branchList, {
                                region_id: column.region_id
                            });
                            if (branchIndex == -1)
                                vm.branchList.push(column)

                        });
                        vm.branchTotalBackendCount = payload.title.data.branches.totalCount;
                    }

                    // ********** VEHICLE DATA ********
                    if (payload.title.data.vehicles) {

                        vm.vehicleTotalBackendCount = payload.title.data.vehicles.totalCount;
                        angular.forEach(payload.title.data.vehicles.data, function (column) {
                            // vm.vehicleList.push({
                            //     id: column.id,
                            //     name: column.name
                            // })
                            var vechicleIndex = _.findIndex(vm.vehicleList, {
                                id: column.id
                            });
                            if (vechicleIndex == -1)
                                vm.vehicleList.push({
                                    id: column.id,
                                    name: column.name
                                })

                        });
                    }

                    vm.loading = false;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        }
        getFilterDataFromBackend();

        function vehicleChanged() {
            vm.agreement = [];
            vm.branchList = [];
            vm.vehicle = [];
            vm.service = [];
            getFilterDataFromBackend();
        };

        // ************ PAGINATION ON VEHICLE **************
        function paginationChangedForVehicle() {
            var index = _.findIndex(vm[vm.searchFilterArray[1]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.vehicleTotalBackendCount > (vm.vehicleList.length - index)) {
                commonFunction(1);
                vm.vehicleOffset = vm.vehicleOffset + 10;
                getFilterDataFromBackend(vm.searchVehicleData, 1);
            }
        }

        // ************ PAGINATION ON BRANCH **************
        function paginationChangedForBranch() {
            var index = _.findIndex(vm[vm.searchFilterArray[0]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.branchTotalBackendCount > (vm.branchList.length - index)) {
                commonFunction(0);
                vm.branchOffset += 10;
                getFilterDataFromBackend(vm.searchBranchData, 0);
            }
        }

        // *********** COMMON FUNCTION FOR FILTER PAGINATION AND SEARCHING ***********
        function commonFunction(type, mode) {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                // vm['search' + vm.searchFilterArray[i] + 'Data'] = '';
                if (mode == 'search' || i != type) {
                    vm[vm.searchFilterArrayForClearArray[i]] = [];
                    vm[vm.searchFilterArray[i] + 'Offset'] = 0;
                    vm['search' + vm.searchFilterArray[i].substring(0, 1).toUpperCase() + vm.searchFilterArray[i].substring(1) + 'Data'] = '';
                }
            }
        }
        // ******** CLEAR OFFSET *******
        function clearOffset() {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                vm[vm.searchFilterArray[i] + 'Offset'] = 0;
            }
        }

        function branchChanged() {
            if (vm.branchList.length == 0) {
                clearOffset();
                getFilterDataFromBackend();
            }
        }

        function vehicleChanged() {
            if (vm.vehicleList.length == 0) {
                clearOffset();
                getFilterDataFromBackend();
            }
        }
        // ************ SEARCH VEHICLE ***************
        function vehicleSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchVehicleData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(1, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 1);
                }, 2000);
            }
        }

        // ************ SEARCH BRANCH ***************
        function branchSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchBranchData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(0, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 0);
                }, 2000);
            }
        }

        //==============set boolean=================
        function setBooleans(type) {
            switch (type) {
                case 'CURRENT':
                    vm.dataToFill.current = !vm.dataToFill.current;
                    break;
                case 'SCHEDULED':
                    vm.dataToFill.scheduled = !vm.dataToFill.scheduled;
                    break;
                default:
                    break;
            }
        }

        //==================get all vehicles=========================
        // function getAllVehicles() {
        //     vm.vehicleList = [];
        //     vm.vehicleList = getFilters.vehiclesFiltersData.data;
        // var promise = getVehicles.allVehicles(0, 0, 2);
        // promise.then(
        //     function (payload) {
        //         $log.log(payload);
        //         vm.loading = false;
        //         if (payload.title.status == 400) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //         } else if (payload.title.status == 401) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //         } else if (payload.title.status == 201 || payload.title.status == 200) {
        //             vm.vehicleList = _.where(payload.title.data.result, {
        //                 status: 1
        //             });
        //         }
        //     },
        //     function (errorPayload) {
        //         vm.loading = false;
        //         if (errorPayload.data.status == 401) {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //         } else {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //         }
        //     }
        // );
        // };
        // WHen Page refresh service take time to get data from backend
        // setTimeout(function () {
        //     getAllVehicles();
        // }, 1000);
        //====================get branch list====================
        // function getBranch() {
        //     vm.branchList = [];
        //     vm.branchList = JSON.parse(JSON.stringify(getFilters.branchesFiltersData.data));

        //vm.loading = true;
        // var promise = getGeofence.branch();
        // promise.then(
        //     function (payload) {
        //         $log.log(payload);
        //         if (payload.title.status == 400) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //         } else if (payload.title.status == 401) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //         } else if (payload.title.status == 201 || payload.title.status == 200) {
        //             //vm.loading = false;
        //             var where = _.where(payload.title.data, {
        //                 parent_id: 0
        //             });
        //             //vm.branchList = _.where(where, { is_active: 1 });
        //             vm.branchList = where;
        //         }
        //     },
        //     function (errorPayload) {
        //         $log.log(errorPayload);
        // vm.loading = false;
        //         if (errorPayload.data.status == 401) {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //         } else {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //         }
        //     }
        // );
        // }
        // WHen Page refresh service take time to get data from backend
        // setTimeout(function () {
        //     getBranch();
        // }, 1000);

        //======================vehicle image ======================
        function clickTrigger($event) {
            $log.log('ddf');
            $event.stopPropagation();
            var element = document.getElementById('documentUpload');
            element.click();
        };
        $scope.file_to_upload = function (File, type) {
            var file = File[0];
            var transcript = File[0];
            var reader = new FileReader;
            reader.onload = function (e) {
                var img = new Image();
                img.onload = function () {
                    if (img.width > 300 && img.height > 300) {
                        languageBasedErrorFactory.getProperErrorMessage('serviceImageCheck', 0, 0);
                        return;
                    } else {
                        document.getElementById('serviceImage').setAttribute('src', e.target.result);
                        vm.dataToFill.service_img = File[0];
                    }
                };
                img.src = reader.result;
            };
            reader.readAsDataURL(transcript);
            $log.log(vm.dataToFill);
        };
        //======================submit form====================
        function registerApi() {
            $log.log('12344', vm.dataToFill);
            if (!vm.dataToFill.service_img) {
                languageBasedErrorFactory.getProperErrorMessage('serviceImageError', 0, 0);
                return;
            }
            if (vm.dataToFill.controlledWay > 10000) {
                errorMessageFactory.showErrorMessage('A través del aeropuerto controlado no puede ser mayor que 10000', 0);
                return;
            }

            if (vm.dataToFill.shared_wait_time > 100) {
                errorMessageFactory.showErrorMessage('Tiempo Espera Compartido cannot be greater than 100', 0);
                return;
            }

            var dataSend = new FormData();
            dataSend.append('service_name', vm.dataToFill.service_name);
            dataSend.append('service_name_english', vm.dataToFill.service_name_english);
            dataSend.append('service_img', vm.dataToFill.service_img);
            dataSend.append('vehicle_type', JSON.stringify(vm.dataToFill.vehicle_type));
            dataSend.append('max_limit', vm.dataToFill.max_limit);
            dataSend.append('controlled_way', vm.dataToFill.controlledWay);
            dataSend.append('branch_id', vm.dataToFill.branch_value);
            dataSend.append('fare_type', vm.dataToFill.uniquePassengerFare == "true" ? 0 : 1);
            dataSend.append('service_transport_type', vm.dataToFill.service_transport_type == "true" ? 1 : 0);
            dataSend.append('is_current', vm.dataToFill.current ? 1 : 0);
            dataSend.append('is_scheduled', vm.dataToFill.scheduled ? 1 : 0);
            dataSend.append('tolerance', vm.dataToFill.tolerance);
            dataSend.append('shared_wait_time', vm.dataToFill.shared_wait_time);
            dataSend.append('category', Number(vm.dataToFill.exclusiveShared));
            dataSend.append('access_token', $cookies.get('obj'));
            vm.loading = true;
            var promise = getServices.addServices(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        languageBasedErrorFactory.getProperErrorMessage('addServiceSucc', 0, 2, 'layout.typeOfServiceMain.typeofService');
                        //errorMessageFactory.showErrorMessage('Service added successfully.',2,'layout.typeOfServiceMain.typeofService');
                        //$timeout(function() {
                        //    $mdDialog.hide();
                        //    //$state.reload();
                        //}, 2000);
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.typeOfServiceMain.addService');
            }
        });
        //=================go back================
        function goBack() {
            $state.go('layout.typeOfServiceMain.typeofService');
        };
    }
})();
/**
 * Created by cl-macmini-51 on 23/02/18.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('SpecialDirectionsController', SpecialDirectionsController);

    /** @ngInject */
    function SpecialDirectionsController($cookies, $scope, $log, errorMessageFactory, getGeofence, pendingRequests, checkDomain, $document, $mdDialog, languageBasedErrorFactory, Initializer) {
        var vm = this;
        vm.loading = false;

        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();


        vm.filterData = {
            searchBookingId: '',
            filter_pickup_to_time_value: '',
            filter_pickup_to_date_value: '',
            filter_pickup_from_time_value: '',
            filter_pickup_from_date_value: ''
        }
        vm.resetFilter = resetFilter;
        vm.ismeridian = true;
        vm.slideData = slideData;
        vm.applyFilter = applyFilter;
        vm.selectedEstadoOptionsChange = selectedEstadoOptionsChange;
        vm.addSpecialDirections = addSpecialDirections;
        vm.showJobIdInHtml = showJobIdInHtml;
        vm.addSpecialDirectionsAPI = addSpecialDirectionsAPI;
        vm.getSpecialAddressAPI = getSpecialAddressAPI;
        vm.closeSpecialDirections = closeSpecialDirections;
        vm.showEstadoInTable = showEstadoInTable;
        vm.showBookingIds = showBookingIds;
        vm.editSpecialDirection = editSpecialDirection;
        vm.editSpecialAddressAPI = editSpecialAddressAPI;
        vm.deleteSpecialAddressAPI = deleteSpecialAddressAPI;
        vm.paginationOnTable = paginationOnTable;
        vm.getPagesCount = getPagesCount;
        vm.getFilter = getFilter;
        vm.specialDirection = {};
        vm.selectedEstadoOptions = 0;
        vm.selectedEstadoOptionsInAdd = 0;
        vm.showAddSpecialDirectionContent = false;
        $("#showAddSpecialDirectionContentSlide").hide();
        vm.modifyBooking = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.selectedIndex = 0;
        vm.offset = 0;
        vm.limit = 10;
        vm.searchModel = {
            limit: 25,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.currentPage = 0;
        vm.maxSize = 5;
        vm.estadoOptions = [{
            id: 0,
            name: 'Dirección válida'
        }, {
            id: 1,
            name: 'Dirección pendiente de validar'
        }, {
            id: 2,
            name: 'Dirección errónea'
        }]
        vm.specialDirectionsArray = [];
        var autocomplete;
        var domain = checkDomain.getDomainName();
        var geocoder;
        // Service To Get Map Instance
        Initializer.mapsInitialized
            .then(function () {
                console.log('>>>> GOOGLE INIT', google);
                if (google) {
                    geocoder = new google.maps.Geocoder();
                } else {
                    alert(languageBasedErrorFactory.getProperErrorMessage('onRoadMessage', 0, '3'));
                }

            });
        vm.pickAddressFlag = false;
        vm.addressChange = addressChange;
        vm.initAutocomplete = initAutocomplete;
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.hstep = 1;
        vm.mstep = 15;

        function selectedEstadoOptionsChange() {
            vm.offset = 0;
            getSpecialAddressAPI();
        }

        // ***************** ADD SPECIAL DIRECTIONS *****************
        function addSpecialDirections() {
            vm.showAddSpecialDirectionContent = true;
            vm.modifyBooking = false;
            vm.specialDirection = {};
            vm.selectedEstadoOptions = 0;
            $("#showAddSpecialDirectionContentSlide").slideDown('slow');
        }


        function addressChange(data) {
            initAutocomplete(data);
        }
        // ***************** PLACES AUTOCOMPLETE *****************
        function initAutocomplete(data) {
            if ((!vm.pickAddressFlag) && data && data.length >= 3) {
                vm.pickAddressFlag = true;
                autocomplete = new google.maps.places.Autocomplete(
                    (document.getElementById('correctDirection')), {
                        placeIdOnly: true
                    });
                if (domain != 'dev' && domain != 'test')
                    autocomplete.setComponentRestrictions({
                        'country': ['CL']
                    });
                autocomplete.addListener('place_changed', fillInAddress);
            } else if (data && data.length < 3) {
                vm.pickAddressFlag = false;
                google.maps.event.clearInstanceListeners(correctDirection);
                $(".pac-container").hide();
            }
        };

        function fillInAddress() {
            // Get the place details from the autocomplete object.
            var place = autocomplete.getPlace();
            if (!place.place_id) {
                return;
            }
            geocoder.geocode({
                'placeId': place.place_id
            }, function (results, status) {
                if (status !== 'OK') {
                    window.alert('Geocoder failed due to: ' + status);
                    return;
                }
                vm.specialDirection.latitute = results[0].geometry.location.lat();
                vm.specialDirection.longitude = results[0].geometry.location.lng();
                $scope.$apply();
            });
        };


        function addressChange(data) {
            initAutocomplete(data);
        }
        // ***************** PLACES AUTOCOMPLETE *****************
        function initAutocomplete(data) {
            if ((!vm.pickAddressFlag) && data && data.length >= 3) {
                vm.pickAddressFlag = true;
                autocomplete = new google.maps.places.Autocomplete(
                    (document.getElementById('correctDirection')), {
                        placeIdOnly: true
                    });
                if (domain != 'dev' && domain != 'test')
                    autocomplete.setComponentRestrictions({
                        'country': ['CL']
                    });
                autocomplete.addListener('place_changed', fillInAddress);
            } else if (data && data.length < 3) {
                vm.pickAddressFlag = false;
                google.maps.event.clearInstanceListeners(correctDirection);
                $(".pac-container").hide();
            }
        };

        function fillInAddress() {
            // Get the place details from the autocomplete object.
            var place = autocomplete.getPlace();
            if (!place.place_id) {
                return;
            }
            geocoder.geocode({
                'placeId': place.place_id
            }, function (results, status) {
                if (status !== 'OK') {
                    window.alert('Geocoder failed due to: ' + status);
                    return;
                }
                vm.specialDirection.correctAddress = results[0].formatted_address;
                vm.specialDirection.latitute = (results[0].geometry.location.lat().toFixed(2));
                vm.specialDirection.longitude = (results[0].geometry.location.lng().toFixed(2));
                $scope.$apply();
            });
        };

        // ***************** ADD SPECIAL DIRECTIONS API *****************
        function addSpecialDirectionsAPI() {
            if (!vm.modifyBooking) {
                if (!vm.specialDirection.directions) {
                    languageBasedErrorFactory.getProperErrorMessage('pleaseEnterTheNameOfTheAddress', 0, 0);
                    // errorMessageFactory.showErrorMessage('por favor ingrese el nombre de la dirección', 0);
                    return false;
                }
                if (!vm.specialDirection.latitute || !vm.specialDirection.longitude) {
                    languageBasedErrorFactory.getProperErrorMessage('pleaseEnterLatitudeAndLongitude', 0, 0);
                    // errorMessageFactory.showErrorMessage('Por favor ingrese latitud y longitud', 0);
                    return false;
                }
                if (!(/^[0-9.+-]+$/.test(vm.specialDirection.latitute)) || !(/^[0-9.+-]+$/.test(vm.specialDirection.longitude))) {
                    languageBasedErrorFactory.getProperErrorMessage('pleaseEnterValidLatitudeAndLongitude', 0, 0);
                    // errorMessageFactory.showErrorMessage('Por favor ingrese latitud y longitud válidas', 0);
                    return false
                }
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.latitude = vm.specialDirection.latitute;
                dataSend.longitude = vm.specialDirection.longitude;
                dataSend.address = vm.specialDirection.directions;
                dataSend.state = vm.selectedEstadoOptionsInAdd;
                vm.loading = true;
                var promise = getGeofence.addSpecialDirections(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        if (payload.title.status == 200) {
                            errorMessageFactory.showErrorMessage('Dirección agregada con éxito', 0);
                            setTimeout(function () {
                                vm.showAddSpecialDirectionContent = false;
                                $scope.$apply();
                            }, 400);
                            $("#showAddSpecialDirectionContentSlide").slideUp();
                            vm.specialDirection = {};
                            vm.selectedEstadoOptions = 0;
                            getSpecialAddressAPI();
                        }
                        if (payload.title.status == 400) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }
            if (vm.modifyBooking) {
                if (!vm.specialDirection.directions) {
                    // errorMessageFactory.showErrorMessage('por favor ingrese el nombre de la dirección', 0);
                    languageBasedErrorFactory.getProperErrorMessage('pleaseEnterTheNameOfTheAddress', 0, 0);
                    return false;
                }
                if (!vm.specialDirection.latitute || !vm.specialDirection.longitude) {
                    // errorMessageFactory.showErrorMessage('Por favor ingrese latitud y longitud', 0);
                    languageBasedErrorFactory.getProperErrorMessage('pleaseEnterLatitudeAndLongitude', 0, 0);
                    return false;
                }
                if (!(/^[0-9.+-]+$/.test(vm.specialDirection.latitute)) || !(/^[0-9.+-]+$/.test(vm.specialDirection.longitude))) {
                    // errorMessageFactory.showErrorMessage('Por favor ingrese latitud y longitud válidas', 0);
                    languageBasedErrorFactory.getProperErrorMessage('pleaseEnterValidLatitudeAndLongitude', 0, 0);
                    return false
                }
                editSpecialAddressAPI()
            }
        };

        // ***************** ADD SPECIAL DIRECTIONS *****************
        function editSpecialAddressAPI() {
            if (!vm.specialDirection.correctAddress) {
                // errorMessageFactory.showErrorMessage('por favor ingrese el nombre de la dirección', 0);
                languageBasedErrorFactory.getProperErrorMessage('pleaseEnterTheNameOfTheAddress', 0, 0);
                return false
            }
            if (!vm.specialDirection.latitute || !vm.specialDirection.longitude) {
                // errorMessageFactory.showErrorMessage('Por favor ingrese latitud y longitud', 0);
                languageBasedErrorFactory.getProperErrorMessage('pleaseEnterLatitudeAndLongitude', 0, 0);
                return false;
            }
            if (!(/^[0-9.+-]+$/.test(vm.specialDirection.latitute)) || !(/^[0-9.+-]+$/.test(vm.specialDirection.longitude))) {
                // errorMessageFactory.showErrorMessage('Por favor ingrese latitud y longitud válidas', 0);
                languageBasedErrorFactory.getProperErrorMessage('pleaseEnterValidLatitudeAndLongitude', 0, 0);
                return false
            }
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.address_id = vm.specialDirection.addressId;
            dataSend.latitude = vm.specialDirection.latitute;
            dataSend.longitude = vm.specialDirection.longitude;
            dataSend.address = vm.specialDirection.directions;
            dataSend.state = vm.selectedEstadoOptionsInAdd;
            dataSend.corrected_address = vm.specialDirection.correctAddress;

            vm.loading = true;
            var promise = getGeofence.editSpecialAddress(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        errorMessageFactory.showErrorMessage('Dirección agregada con éxito', 0);
                        setTimeout(function () {
                            vm.showAddSpecialDirectionContent = false;
                            $scope.$apply();
                        }, 400);
                        $("#showAddSpecialDirectionContentSlide").slideUp();
                        vm.modifyBooking = false;
                        vm.specialDirection = {};
                        vm.selectedEstadoOptions = 0;
                        getSpecialAddressAPI();
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        // ***************** ADD SPECIAL DIRECTIONS API *****************
        function getSpecialAddressAPI() {

            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.state = vm.selectedEstadoOptions;
            dataSend.limit = vm.limit;
            dataSend.offset = vm.offset;
            dataSend.since_date = new Date($scope.pickFromDate).toJSON();
            dataSend.until_date = new Date($scope.pickToDate).toJSON();
            dataSend.task_id = vm.filterData.searchBookingId;
            console.log(dataSend);

            if (vm.search && vm.search.length > 0) {
                dataSend.search_filter = 1;
                dataSend.search_value = vm.search;
            }
            $log.log(dataSend);
            vm.loading = true;

            var promise = getGeofence.getSpecialAddress(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title && payload.title.data && payload.title.data.result && payload.title.data.result.length) {
                        vm.dataLength = payload.title.data.totalCount
                        vm.specialDirectionsArray = payload.title.data.result;
                        vm.filterOn = false;
                        vm.tFootFlag = false;
                        vm.sp_pagination = true;
                        vm.skipValue = vm.offset;
                        vm.limitValue = vm.offset + vm.specialDirectionsArray.length - 1;
                    } else {
                        vm.dataLength = 0;
                        vm.specialDirectionsArray = [];
                        vm.tFootFlag = true;
                        vm.filterOn = true;
                        vm.sp_pagination = false;
                        vm.skipValue = vm.offset;
                        vm.limitValue = vm.offset + vm.specialDirectionsArray.length - 1;
                    }
                    if (payload.title.status == 404) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        getSpecialAddressAPI();

        // ***************** EDIT SPECIAL DIRECTIONS *****************
        function editSpecialDirection(data) {
            vm.showAddSpecialDirectionContent = false;
            $("#showAddSpecialDirectionContentSlide").slideUp();
            vm.specialDirection.addressId = data.address_id;
            vm.specialDirection.latitute = data.latitude;
            vm.specialDirection.longitude = data.longitude;
            vm.specialDirection.directions = data.address;
            vm.specialDirection.correctAddress = data.corrected_address;

            vm.selectedIndex = data.state;
            vm.showAddSpecialDirectionContent = true;
            $("#showAddSpecialDirectionContentSlide").slideDown();
            vm.modifyBooking = true;
        }

        // ***************** CLOSE SPECIAL DIRECTIONS ADD OR MODIFY FIELDS *****************
        function closeSpecialDirections() {
            setTimeout(function () {
                vm.showAddSpecialDirectionContent = false;
                $scope.$apply();
            }, 400);
            $("#showAddSpecialDirectionContentSlide").slideUp();
        }

        // ***************** SHOW ESTADO IN TABLE *****************
        function showEstadoInTable(state) {
            vm.name;
            vm.estadoOptions.forEach(function (data) {
                if (data.id == state) {
                    vm.name = data.name;
                }
            });
            return vm.name;
        }

        // ***************** DELETE SPECIAL ADDRESS API *****************
        function deleteSpecialAddressAPI(data) {
            var dataSend = {};

            dataSend.access_token = $cookies.get('obj');
            dataSend.address_id = data.address_id;

            vm.loading = true;
            var promise = getGeofence.deleteSpecialAddress(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        errorMessageFactory.showErrorMessage('Dirección eliminada con éxito', 0);
                        getSpecialAddressAPI();
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        // ***************** PAGINATION ON TABLE *****************
        function paginationOnTable(page) {
            vm.offset = (page - 1) * vm.itemsPerPageGot;
            getSpecialAddressAPI();
        }

        //==================== TO GET OFFSET FROM DROPDOWN ===============
        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            vm.limit = vm.itemsPerPageSelected;
            vm.offset = 0;
            getSpecialAddressAPI();
        };

        // ***************** SEARCH FILTER *****************
        function getFilter() {
            vm.currentPage = 0;
            vm.offset = 0;
            pendingRequests.cancelAll();
            if (vm.search.length == 0) {
                getSpecialAddressAPI();
            } else {
                getSpecialAddressAPI();
            }
        };
        // vm.datePickerE_3 = datePickerE_3;
        vm.datePickerE_1 = datePickerE_1;

        function datePickerE_1(type) {
            if (type == 1) {
                vm.datePicker_1.pickupFromDate = true;
                vm.datePicker_1.pickupToDate = false;
            } else if (type == 2) {
                vm.datePicker_1.pickupFromDate = false;
                vm.datePicker_1.pickupToDate = true;
            }
        };
        // vm.datePicker_1 = {
        //     pickupDate: false
        // };

        vm.datePicker_1 = {
            pickupFromDate: false,
            pickupToDate: false
        };
        vm.dateOptions = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            // maxDate: new Date(),
            // minDate: new Date(vm.filterData.filter_pickup_from_date_value),
            startingDay: 1,
            showWeeks: false,

        };

        $('#derp').hide();

        function slideData() {
            $('#derp').slideToggle(1000);
        }

        function applyFilter() {
            if (vm.filterData.filter_pickup_from_date_value && vm.filterData.filter_pickup_from_time_value) {
                $scope.pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            }

            if (vm.filterData.filter_pickup_to_date_value && vm.filterData.filter_pickup_to_time_value) {
                $scope.pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            }

            if ($scope.pickFromDate > $scope.pickToDate) {
                languageBasedErrorFactory.getProperErrorMessage('appropriateFilter', 0, 0);
                return;
            }
            getSpecialAddressAPI();

            // $scope.object = {
            //     since_date: new Date(pickFromDate).toJSON(),
            //     until_date: new Date(pickupToDate).toJSON(),
            //     task_id: vm.filterData.searchBookingId
            // }

            console.log($scope.object);


        }

        function dateTimeFormat(dateGot, timeGot) {
            var dateToChange = dateGot;
            if (timeGot) {
                dateToChange.setHours(timeGot.getHours());
                dateToChange.setMinutes(timeGot.getMinutes());
                dateToChange.setSeconds(timeGot.getSeconds());
            } else {
                dateToChange.setHours(0);
                dateToChange.setMinutes(0);
                dateToChange.setSeconds(0);
            }
            return dateToChange;
        };

        function resetFilter() {
            if ((vm.filterData.searchBookingId != undefined) || (vm.filterData.filter_pickup_from_date_value != undefined) || (vm.filterData.filter_pickup_from_time_value != undefined) || (vm.filterData.filter_pickup_to_date_value != undefined) || (vm.filterData.filter_pickup_to_time_value != undefined)) {
                vm.filterData = {};
            }

            // vm.currentPage = 0;
            // vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            // vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            // vm.filterData = {
            //     limit: vm.itemsPerPageGot,
            //     searchBookingId: '',
            //     filter_pickup_from_date_value: getFirstDateOfPreviousMonth(),
            //     filter_pickup_to_date_value: setToPickupDate(),
            //     filter_pickup_from_time_value: showFilterTime(1),
            //     filter_pickup_to_time_value: showFilterTime(2),
            // };
            // function setToPickupDate() {
            //     var x = new Date();
            //     var yesterday = new Date(x.getTime() + (24 * 60 * 60 * 1000));
            //     return yesterday;
            // }

            // function showFilterTime(type) {
            //     if (type == 1) {
            //         var x = new Date();
            //         x.setHours('00');
            //         x.setMinutes('00');
            //         x.setSeconds('00');
            //         return x;
            //     } else {
            //         var x = new Date();
            //         x.setHours('23');
            //         x.setMinutes('59');
            //         x.setSeconds('00');
            //         return x;
            //     }

            // }
            // function getFirstDateOfPreviousMonth() {
            //     var date = new Date();
            //     var yesterday = new Date(date.getTime() - 24 * 60 * 60 * 1000);
            //     return yesterday;
            // }
            // console.log(vm.filterData, ' vm.filterData ===========');

            // vm.dateOptions = {
            //     formatYear: 'yy',
            //     startingDay: 1,
            //     showWeeks: false,

            // };

        }

        function showBookingIds(address_id, job_id, $event) {
            if (address_id && job_id != '--' && job_id != ' ') {
                vm.loading = true;
                console.log(address_id);
                var promise = getGeofence.bookingIdToShow(address_id);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        if (payload.title.status == 200) {
                            console.log(payload, "payload");

                            vm.items = {
                                bookingIds: payload.title.data || []
                            };
                            var parentEl = angular.element($document.body);
                            $mdDialog.show({
                                parent: parentEl,
                                targetEvent: $event,
                                templateUrl: 'app/components/dialogViews/showBookingIds.html',
                                locals: {
                                    items: vm.items
                                },
                                bindToController: true,
                                controller: DialogController
                            });

                            function DialogController($scope, $mdDialog, items) {
                                $scope.items = items;
                                console.log($scope.items.bookingIds);
                                $scope.closeDialog = function () {
                                    $mdDialog.hide();
                                };
                                $scope.confirmUpload = function () {



                                };
                            }
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }
        }

        function showJobIdInHtml(job_ids) {
            if(job_ids && job_ids != ' ') {
                var replaceJobs = job_ids.replace(/, /g,"|").replace(/ ,/g,"|").replace(/,/g,'|').replace(/ /g,'|');
                return replaceJobs.split('|')[0] || '--';
            } else {
                return '--';    
            }
        }
    }

})();
/**
 * Created by cl-macmini-51 on 23/02/18.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('SharedRouteAssignmentController', SharedRouteAssignmentController);

    /** @ngInject */
    function SharedRouteAssignmentController($cookies, $state, $log, $rootScope, $mdDialog, $q, $timeout, $document, $scope, filterFilter, languageBasedErrorFactory,
        errorMessageFactory, hidePublicPlaces, adminAccessService, checkDomain, RutHelper, getGeofence, getAgreement, getServices, sharedRouteAssignment, sharedRouteAssignmentHereMaps, $filter, getFilters, Initializer) {
        var vm = this;
        vm.loading = false;
        vm.dateOptions = {};
        vm.showButtonSave = false;
        vm.clickOk = clickOk;
        vm.branchChanged = branchChanged;
        vm.datePicker_1 = {
            pickupFromDate: false,
            pickupToDate: false,
            pickupFromDatePackage: false,
            pickupToDatePackage: false
        };
        vm.checkClickedPackage = true
        vm.getPackageSection = getPackageSection;
        vm.socketCount = 0;
        vm.VolverButton = VolverButton;
        vm.blockUnblockBooking = blockUnblockBooking;
        vm.altInputFormats = ['M!/d!/yyyy'];
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.AsssignedList = AsssignedList;
        vm.idBooking = '';
        vm.flightSearchModel = '';
        vm.nominaSearchModel = '';
        vm.comunaSearchModel = '';
        vm.searchFilter = searchFilter;
        vm.hstep = 1;
        vm.mstep = 15;
        vm.ismeridian = true;
        vm.parentDragStart = false;
        vm.setFlagInJob = setFlagInJob;
        vm.filterData = {
            branch_value: '',
            aggrement_value: 'all',
            service_value: '',
            filter_pickup_from_date_value: '',
            filter_pickup_from_time_value: '',
            filter_pickup_to_date_value: setToPickupDate(),
            filter_pickup_to_time_value: showFilterTime(2),
            unassignedBookingCount: 0,
            unassignedBookingCountShow: 0,
            unassignedSkip: 0,
            unassignedLimit: 10,
            unassignedLimitMade: 10,
            unassignedBookingList: [],
            unassignedPredicate: 'index',
            makePackagePredicate: 'index',
            unassignedReverse: false,
            makePackageReverse: false,
            serviceDetailsSelected: '',
            makePackageList: [],
            makePackageCount: 0,
            filterApplied: false,
            filterAppliedPackage: false,
            totalPassengerAssigned: 0,
            totalBookingAssigned: 0,
            totalAssignedETA: 0,
            dropLocationArray: [],
            createdPredicate: 'index',
            createdReverse: false,
            createdSkip: 0,
            createdLimit: 15,
            createdBookingCount: 0,
            createdBookingList: [],
            sharedServiceName: 'NEW',
            vehicleAssigned: 'PENDING',
            modifyFlag: false,
            typeOfTrip: 'R',
            typeOfTripModify: '',

            branch_value_package: '',
            aggrement_value_package: '',
            service_value_package: '',
            filter_pickup_from_date_value_package: '',
            filter_pickup_from_time_value_package: '',
            filter_pickup_to_date_value_package: setToPickupDate(),
            filter_pickup_to_time_value_package: showFilterTime(2),
            typeOfTripPackage: '',
        };
        vm.mapViewTab = false;
        vm.unassignedBookingsTab = true;
        vm.servicesCreatedTab = true;
        vm.bookingsAssignmentTab = false;
        vm.upperTabsBody = true;
        vm.lowerTabsBody = true;
        vm.serviceFilterData = serviceFilterData;

        vm.initializeMap = initializeMap;
        vm.booking = '';
        vm.idPackete = '';
        vm.vehicleSearch = ''
        if ($cookies.get('branch')) {
            vm.filterData.branch_value = JSON.parse($cookies.get('branch'));
        }
        if ($cookies.get('branchPackage')) {
            vm.filterData.branch_value_package = JSON.parse($cookies.get('branchPackage'));
        }
        if ($cookies.get('type_of_service')) {
            vm.filterData.service_value = JSON.parse($cookies.get('type_of_service'));

        }
        if ($cookies.get('type_of_service_package')) {
            vm.filterData.service_value_package = JSON.parse($cookies.get('type_of_service_package'));

        }
        if ($cookies.get("type_of_service_package.name")); {
            vm.nameForShow = $cookies.get('type_of_service.name');
        }
        if ($cookies.get("type_of_service_package.max")) {
            vm.maxForShow = $cookies.get('type_of_service.max');
        }

        if ($cookies.get('type_of_trip')) {
            vm.filterData.typeOfTrip = $cookies.get('type_of_trip');
        }
        if ($cookies.get('type_of_trip_package')) {
            vm.filterData.typeOfTripPackage = $cookies.get('type_of_trip_package');
        }
        if ($cookies.get('contract_id')) {
            vm.filterData.aggrement_value = $cookies.get('contract_id') == 'all' ? $cookies.get('contract_id') : JSON.parse($cookies.get('contract_id'));
        }
        if ($cookies.get('contract_id_package')) {
            vm.filterData.aggrement_value_package = $cookies.get('contract_id_package') == 'all' ? $cookies.get('contract_id_package') : JSON.parse($cookies.get('contract_id_package'));
        }
        if ($cookies.get('pickUpDate')) {
            vm.filterData.filter_pickup_from_date_value = new Date($cookies.get('pickUpDate')) || new Date();
        } else {
            vm.filterData.filter_pickup_from_date_value = new Date();
        }
        if ($cookies.get('pickUpDatePackage')) {
            vm.filterData.filter_pickup_from_date_value_package = new Date($cookies.get('pickUpDatePackage')) || new Date();
        } else {
            vm.filterData.filter_pickup_from_date_value_package = new Date();
        }
        if ($cookies.get('pickDateto')) {
            vm.filterData.filter_pickup_to_date_value = new Date($cookies.get('pickDateto')) || new Date();
        } else {
            vm.filterData.filter_pickup_to_date_value = new Date();
        }
        if ($cookies.get('pickDatetoPackage')) {
            vm.filterData.filter_pickup_to_date_value_package = new Date($cookies.get('pickDatetoPackage')) || new Date();
        } else {
            vm.filterData.filter_pickup_to_date_value_package = new Date();
        }
        if ($cookies.get('pickTime')) {
            vm.filterData.filter_pickup_from_time_value = new Date($cookies.get('pickTime')) || new Date(new Date().setHours(0, 0, 0, 0));
        } else {
            vm.filterData.filter_pickup_from_time_value = new Date(new Date().setHours(0, 0, 0, 0));
        }
        if ($cookies.get('pickTimePackage')) {
            vm.filterData.filter_pickup_from_time_value_package = new Date($cookies.get('pickTimePackage')) || new Date(new Date().setHours(0, 0, 0, 0));
        } else {
            vm.filterData.filter_pickup_from_time_value_package = new Date(new Date().setHours(0, 0, 0, 0));
        }
        if ($cookies.get('dropTime')) {
            vm.filterData.filter_pickup_to_time_value = new Date($cookies.get('dropTime')) || new Date(new Date().setHours(23, 59, 0, 0));
        } else {
            vm.filterData.filter_pickup_to_time_value = new Date(new Date().setHours(23, 59, 0, 0));
        }
        if ($cookies.get('dropTimePackage')) {
            vm.filterData.filter_pickup_to_time_value_package = new Date($cookies.get('dropTimePackage')) || new Date(new Date().setHours(23, 59, 0, 0));
        } else {
            vm.filterData.filter_pickup_to_time_value_package = new Date(new Date().setHours(23, 59, 0, 0));
        }





        vm.typeTripFilter = [{
                text: 'From Airport',
                id: 'Z'
            },
            {
                text: 'To Airport',
                id: 'R'
            },
            {
                text: 'Point To Point',
                id: 'P'
            }
        ];
        vm.countToSocket = 0;
        var unassignLength = 0;

        var myCenter;
        var infowindow;
        var trafficLayer;
        var bounds;
        var directionsService;
        var directionsDisplay;

        // Service To Get Map Instance
        Initializer.mapsInitialized
            .then(function () {
                if (google) {
                    myCenter = new google.maps.LatLng(-33.447487, -70.673676);
                    infowindow = new google.maps.InfoWindow({
                        size: new google.maps.Size(150, 50)
                    });
                    trafficLayer = new google.maps.TrafficLayer();
                    bounds = new google.maps.LatLngBounds();
                    directionsService = new google.maps.DirectionsService;
                    directionsDisplay = new google.maps.DirectionsRenderer;

                    google.maps.event.addListener(infowindow, 'domready', function () {
                        var iwOuter = $('.gm-style-iw');
                        var map = $('.gm-ui-hover-effect');

                        var iwBackground = iwOuter.prev();
                        iwOuter.css({
                            top: '36px',
                            left: '20px'
                        });
                        iwOuter.children().children(':nth-child(1)').css({
                            'overflow': 'hidden',
                            padding: '0px 18px 0px 18px'
                        });

                        // Remove the background shadow DIV
                        iwBackground.children(':nth-child(2)').css({
                            'display': 'none'
                        });
                        // Remove the white background DIV
                        iwBackground.children(':nth-child(4)').css({
                            'display': 'none'
                        });
                        //iwOuter.parent().parent().css({ left: '115px' });
                        //// Moves the shadow of the arrow 76px to the left margin
                        //iwBackground.children(':nth-child(1)').attr('style', function (i, s) { return s + 'left: 76px !important;' });
                        //// Moves the arrow 76px to the left margin
                        //iwBackground.children(':nth-child(3)').attr('style', function (i, s) { return s + 'left: 76px !important;' });
                        iwBackground.children(':nth-child(3)').find('div').children().css({
                            'background-color': 'cornsilk',
                            'box-shadow': 'none'
                        });
                        var iwCloseBtn = iwOuter.next();
                        // Apply the desired effect to the close button
                        iwCloseBtn.css({
                            top: '38px',
                            right: '44px', // button repositioning
                            // backgound: 'white',
                            width: '20px',
                            height: '22px'
                        });

                        console.log(map.children());
                        map.css({
                            background: 'white',
                            opacity: 1
                        })
                        map.children().css({
                            margin: '4px'
                        });

                        // iwCloseBtn.siblings().find('div').siblings().css({
                        //     margin: '6px'
                        // });


                        // The API automatically applies 0.7 opacity to the button after the mouseout event.
                        // This function reverses this event to the desired value.
                        iwCloseBtn.mouseout(function () {
                            $(this).css({
                                opacity: '1'
                            });
                        });
                        $('#assignToRoute').off('click').on('click', function (event) {
                            vm.bookingsAssignmentTab = true;
                            vm.servicesCreatedTab = false;
                            vm.lowerTabsBody = true;
                            assignToPackageFromMap(vm.jobIdOfMarker);
                        });
                    });

                    // ****** DEFAULT FOR BOOKING FILTER ***********
                    if (($cookies.get('branch')) && ($cookies.get('type_of_service')) && ($cookies.get('type_of_trip')) && ($cookies.get('contract_id'))) {
                        vm.sendCreatePackageTypeOfTrip = vm.filterData.typeOfTrip;
                        getSharedToAirportOnly(false, vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_to_date_value, 'scroll');
                        // getSharedPackageList('noScroll', false);
                        vm.filterData.filterApplied = true;
                        if (vm.mapViewTab) {
                            $timeout(function () {
                                initialize();
                                directionsDisplay.setMap(null);
                            })
                        }

                    }
                    // ****** DEFAULT FOR PACKAGE FILTER ***********
                    if (($cookies.get('branchPackage')) && ($cookies.get('type_of_service_package')) && ($cookies.get('type_of_trip_package'))) {
                        // getSharedToAirportOnly(false, vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_to_date_value, 'scroll');
                        if (vm.filterData.filter_pickup_from_date_value_package && vm.filterData.filter_pickup_from_time_value_package) {
                            var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value_package, vm.filterData.filter_pickup_from_time_value_package);
                        }
                        if (vm.filterData.filter_pickup_to_date_value_package && vm.filterData.filter_pickup_to_time_value_package) {
                            var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value_package, vm.filterData.filter_pickup_to_time_value_package);
                        }
                        getSharedPackageList('noScroll', false, pickFromDate, pickToDate);
                        vm.filterData.filterAppliedPackage = true;
                        // if (vm.mapViewTab) {
                        //     $timeout(function () {
                        //         initialize();
                        //         directionsDisplay.setMap(null);
                        //     })
                        // }

                    }

                } else {
                    alert(languageBasedErrorFactory.getProperErrorMessage('onRoadMessage', 0, '3'));
                }

            });


        var markers = [];
        var map = null;
        var icon = null;
        vm.service = [];


        vm.slideData = slideData;
        vm.slideDataPackage = slideDataPackage;
        vm.datePickerE_1 = datePickerE_1;
        vm.applyFilter = applyFilter;
        vm.applyFilterPackage = applyFilterPackage;
        vm.resetFilter = resetFilter;
        vm.serviceChanged = serviceChanged;
        //vm.dropedArea = dropedArea;
        //vm.dropedAreaBack = dropedAreaBack;
        //vm.onDragstart = onDragstart;
        vm.paginationChangedForUnassigned = paginationChangedForUnassigned;
        vm.calculateDataAndValidatePackage = calculateDataAndValidatePackage;
        vm.saveSharedPackage = saveSharedPackage;
        vm.newPackage = newPackage;
        vm.paginationChangedForCreated = paginationChangedForCreated;
        vm.assignBookings = assignBookings;
        vm.unassignBooking = unassignBooking;
        vm.deletePackage = deleteBooking;
        vm.modifyBooking = modifyBooking;
        vm.saveModifySharedPackage = saveModifySharedPackage;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();


        // ============== search Filter =============
        function searchFilter() {
            var pickFromDate = '';
            var pickToDate = '';
            if (vm.filterData.filter_pickup_from_date_value && vm.filterData.filter_pickup_from_time_value) {
                pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            }
            if (vm.filterData.filter_pickup_to_date_value && vm.filterData.filter_pickup_to_time_value) {
                pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            }
            $timeout.cancel(vm.yourTimer);
            vm.yourTimer = $timeout(function () {
                vm.loading = true;
                vm.filterData.unassignedBookingList = [];
                vm.filterData.offset = 0;
                vm.filterData.unassignedSkip = 0;
                vm.filterData.unassignedLimit = 10;
                vm.filterData.unassignedLimitMade = 10;
                getSharedToAirportOnly(true, pickFromDate, pickToDate, 'scroll');
            }, 1000);
        }

        //====================socket connection=================

        $scope.$on("$locationChangeStart", function (event, next, current) {
            if (vm.filterData.makePackageList.length > 0) {
                var jobData = [];
                vm.filterData.makePackageList.forEach(function (d) {
                    jobData.push(d.job_id);
                })
                setFlagInJob(jobData);
            }


        });
        //====================socket connection===================

        // =================Intiliaze map =================
        function initializeMap() {
            applyFilter('scroll');
            vm.idBooking = '';
            vm.comunaSearchModel = '';
            vm.nominaSearchModel = '';
            vm.flightSearchModel = '';
        }

        function AsssignedList() {
            vm.idBooking = '';
            vm.filterData.unassignedBookingList = [];
            vm.comunaSearchModel = '';
            vm.nominaSearchModel = '';
            vm.flightSearchModel = '';
            applyFilter('modify');
        }


        /////////////////////////////// check FIlter is Equal Or Not //////////////////////////
        function checkStatus(bookingArray) {
            var flagStatus = false;
            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            var DatetoSend = new Date(date_time_value2).getTime();
            var dateFrom = new Date(date_time_value1).getTime();
            var dateTo = DatetoSend;
            var booking_date = bookingArray.job_time_utc;
            booking_date = new Date(booking_date).getTime();
            if (vm.filterData.branch_value == bookingArray.branch_id) {
                if (vm.filterData.aggrement_value == 'all' || vm.filterData.aggrement_value == bookingArray.contract_id) { // aggreement id is always same as filter
                    if (vm.filterData.service_value == bookingArray.service_id) { // service id is always same as filter
                        if (vm.filterData.typeOfTrip == bookingArray.type_of_trip) { // type of trip is always same as filter
                            if (dateFrom <= booking_date && booking_date <= dateTo) { // the booking is come always betwwen the date filters
                                if (bookingArray.job_status == 6) { // for uniassign booking always come
                                    return true;
                                }
                            }
                        }
                    }
                }
            }
            return flagStatus;
        }

        // ******** CHECK FILTER OF PACKAGE ********
        function checkStatusPackage(bookingArray) {
            var flagStatus = false;
            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value_package, vm.filterData.filter_pickup_from_time_value_package);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value_package, vm.filterData.filter_pickup_to_time_value_package);
            var DatetoSend = new Date(date_time_value2).getTime();
            var dateFrom = new Date(date_time_value1).getTime();
            var dateTo = DatetoSend;
            var booking_date = bookingArray.job_time_utc;
            booking_date = new Date(booking_date).getTime();
            if (vm.filterData.branch_value_package == bookingArray.branch_id) {
                if (vm.filterData.aggrement_value_package == 'all' || vm.filterData.aggrement_value_package == bookingArray.contract_id) { // aggreement id is always same as filter
                    if (vm.filterData.service_value_package == bookingArray.service_id) { // service id is always same as filter
                        if (vm.filterData.typeOfTripPackage == bookingArray.type_of_trip) { // type of trip is always same as filter
                            if (dateFrom <= booking_date && booking_date <= dateTo) { // the booking is come always betwwen the date filters
                                return true;
                            }
                        }
                    }
                }
            }
            return flagStatus;
        }

        //====================socket connection===================
        var myListener = $rootScope.$on('SocketComesUpcoming', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data && data.res && data.res.message && data.res.message.jobArray.length > 0) {
                var loopArray = data.res.message.jobArray;
                loopArray.forEach(function (data) {
                    if (checkStatus(data) && vm.socketCount >= 100) {
                        vm.socketCount = '100+';
                    } else if (checkStatus(data)) {
                        vm.socketCount += 1;
                    }
                });
                $scope.$apply();
            }


        });

        //==================== GET PACKAGE CREATION SOCKET ===================
        var myListener = $rootScope.$on('socketEventPackageCreationForSharedScreen', function (evt, data) {
            if (data.res.message[0])
                data = data.res.message[0];
            var findIndexOfBookingIncreatedBookingList = _.findIndex(vm.filterData.createdBookingList, {
                shared_service_id: data.shared_service_id || 0
            })
            if (findIndexOfBookingIncreatedBookingList == -1) {
                if (checkStatusPackage(data))
                    if (data) {
                        // data = data.res.message[0];
                        vm.filterData.createdBookingList.push({
                            eta: data.eta,
                            first_pickup_address: data.first_pickup_address,
                            first_pickup_time: data.first_pickup_time,
                            pax: data.pax,
                            shared_service_id: data.shared_service_id,
                            status: data.status,
                            total_bookings: data.total_bookings,
                            planificador_package_id: 0,
                            unique_car_id: data.unique_car_id
                        });
                        vm.filterData.createdBookingCount += 1;
                        $scope.$apply();
                    }
            } else {
                if (data.status == 2) {
                    // This check is to DELETE BOOKING ON BOOKING ENDED
                    vm.filterData.createdBookingList.splice(findIndexOfBookingIncreatedBookingList, 1);
                    vm.filterData.createdBookingCount -= 1;
                } else {
                    vm.filterData.createdBookingList[findIndexOfBookingIncreatedBookingList] = {
                        eta: data.eta,
                        first_pickup_address: data.first_pickup_address,
                        first_pickup_time: data.first_pickup_time,
                        pax: data.pax,
                        shared_service_id: data.shared_service_id,
                        status: data.status,
                        planificador_package_id: 0,
                        total_bookings: data.total_bookings,
                        unique_car_id: data.unique_car_id
                    };
                }
                $scope.$apply();
            }
        });

        //==================== PACKAGE DELETION SOCKET ===================
        var myListener = $rootScope.$on('socketEventPackageDeletionShared', function (evt, data) {
            if (data.res.message)
                data = data.res.message;
            var findIndexOfBookingIncreatedBookingList = _.findIndex(vm.filterData.createdBookingList, {
                shared_service_id: data || 0
            });
            if (findIndexOfBookingIncreatedBookingList > -1) {
                vm.filterData.createdBookingList.splice(findIndexOfBookingIncreatedBookingList, 1);
                vm.filterData.createdBookingCount -= 1;
                $scope.$apply();
            }
        });

        //====================socket connection===================
        var myListenerOngoing = $rootScope.$on('SocketComesOngoing', function (evt, data) {
            console.log("socket ongoing ", data);

            $log.log(evt);
            $log.log(data);


        });
        var myListenerCreated = $rootScope.$on('SocketComesShared', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data && data.res && data.res.message.length > 0) {
                data.res.message.forEach(function (dataLoop) {
                    if (data && data.res.message.length > 0 && dataLoop.shared_service_id == null) {
                        data.res.message.forEach(function (data) {
                            var index = vm.filterData.unassignedBookingList.findIndex(function (x) {
                                return x.job_id == data.job_id;
                            });
                            if (index >= 0) {
                                vm.filterData.unassignedBookingList.splice(index, 1);
                                vm.filterData.unassignedBookingCount = vm.filterData.unassignedBookingList.length;
                                $scope.$apply();
                                // vm.filterData.unassignedBookingList.splice(index, 1);
                            }
                        })
                    } else {
                        var index = vm.filterData.unassignedBookingList.findIndex(function (x) {
                            return x.job_id == dataLoop.job_id;
                        });
                        if (index >= 0) {
                            vm.filterData.unassignedBookingList.splice(index, 1);
                            vm.filterData.unassignedBookingCount = vm.filterData.unassignedBookingList.length;
                            $scope.$apply();
                            // vm.filterData.unassignedBookingList.splice(index, 1);
                        }
                    }
                    // if (data.data && vm.countToSocket == 0 && vm.filterData.filterApplied && vm.fun == true && dataLoop.shared_service_id != null) {
                    //     getSharedPackageList('noScroll', false);
                    // }
                })
            }
        });

        var assignSocket = $rootScope.$on('quickScreeenBookingAssignedSocket', function (evt, data) {
            console.log(data, "socket delete");
            $log.log(evt);
            $log.log(data);
            vm.fun = true;
            // if (data.data && vm.countToSocket == 0 && vm.filterData.filterApplied && vm.fun == true) {
            //     getSharedPackageList('noScroll', false);
            // }


        });
        $scope.$on('$destroy', assignSocket);
        var quickAssingnmentShared = $rootScope.$on('quickScreeenBookingSharedSocket', function (evt, data) {
            console.log(data, "data>>>>>>>>>>>>>>>>>>>>>");
            if (data && data.res && data.res.message && data.res.message.jobArray.length > 0) {
                data.res.message.jobArray.forEach(function (data) {
                    if (vm.filterData.filter_pickup_from_date_value && vm.filterData.filter_pickup_from_time_value) {
                        var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
                    }
                    if (vm.filterData.filter_pickup_to_date_value && vm.filterData.filter_pickup_to_time_value) {
                        var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
                    }
                    console.log(data, vm.countToSocket == 0, vm.filterData.filterApplied);

                    if (data && vm.countToSocket == 0 && vm.filterData.filterApplied) {
                        vm.filterData.unassignedBookingList = [];
                        getSharedToAirportOnly(false, pickFromDate, pickToDate, 'scroll');
                        vm.countToSocket = 1;
                    }
                })

            }

        });
        $scope.$on('$destroy', quickAssingnmentShared);

        var DeletePackage = $rootScope.$on('socketEventDeletion', function (evt, data) {
            console.log(data, "socket delete");
            $log.log(evt);
            $log.log(data);
            if (data && data.res.message.length > 0) {
                console.log("i m here ");
                vm.filterData.unassignedBookingCount = vm.filterData.unassignedBookingList.length + data.res.message.length;
                data.res.message.forEach(function (data) {
                    console.log("i m here lopp", data);
                    //    var index = vm.filterData.unassignedBookingList.findIndex(function (x) {
                    //         return x.job_id == data.job_id;
                    //     });
                    //     if (index >= 0) {
                    vm.filterData.unassignedBookingList.push(data);
                    $scope.$apply();
                    // vm.filterData.unassignedBookingList.splice(index, 1);
                    // }
                })
            }
            // if (data.data && vm.countToSocket == 0 && vm.filterData.filterApplied && vm.fun == true) {
            //     getSharedPackageList('scroll', false);
            // }

        });
        $scope.$on('$destroy', myListener);
        $scope.$on('$destroy', myListenerCreated);
        $scope.$on('$destroy', DeletePackage);
        //$rootScope.socket.on('socketEventToUser',function(res){
        //    showDriversWithFilterSocket(vm.dataToFill);
        //});


        //==================== GET UNLOCK THE BOOKING ===================
        var UnlockSocket = $rootScope.$on('SocketComesValidation', function (evt, data) {
            console.log(data, "data");
            var index;
            if (data && data.res && data.res.message.length > 0) {
                data.res.message.forEach(function (data) {
                    index = vm.filterData.unassignedBookingList.findIndex(function (x) {
                        return x.job_id == data.job_id;
                    });
                    if (index >= 0) {
                        vm.filterData.unassignedBookingList[index].locking_id = data.locking_id;
                        vm.filterData.unassignedBookingList[index].locking_id_name = data.locking_id_name;
                        $scope.$apply();
                        // vm.filterData.unassignedBookingList.splice(index, 1);
                    }
                })

            }

        });
        $scope.$on('$destroy', UnlockSocket);

        //==================== GET UNLOCK BY BUTTON THE BOOKING ===================
        var UnlockSocketByButton = $rootScope.$on('socketComesToUnlockTheBooking', function (evt, data) {
            console.log(data, "data");

            var packageIndex;
            if (data && data.res && data.res.message.length > 0) {
                data.res.message.forEach(function (data) {
                    packageIndex = vm.filterData.makePackageList.findIndex(function (x) {
                        return x.job_id == data.job_id;
                    });
                    if (packageIndex >= 0) {
                        if (vm.filterData.makePackageList.length > 0) {
                            console.log("inner");

                            vm.filterData.makePackageList[packageIndex].locking_id = data.locking_id;
                            if (vm.filterData.makePackageList[packageIndex].locking_id == null) {
                                // vm.filterData.unassignedBookingList.push(data);
                                var index = vm.filterData.unassignedBookingList.findIndex(function (x) {
                                    return x.job_id == data.job_id;
                                });
                                if (index < 0) {
                                    vm.filterData.unassignedBookingList.push(data);
                                }
                                vm.filterData.makePackageList.splice(packageIndex, 1);
                                $scope.$apply();

                            }
                        }
                    }
                })

            }

        });
        $scope.$on('$destroy', UnlockSocketByButton);

        if ($rootScope.socket.connected == false || $rootScope.socket.connected == 'false') {
            $rootScope.socket.connect();
        }


        //=======================map=========================
        function setMapOnAll(map, type) {
            for (var i = 0; i < markers.length; i++) {
                if (markers[i].type == type) {
                    markers[i].setMap(map);
                }
                if (type == 'all') {
                    markers[i].setMap(map);
                }
            }
        }

        // If the map position is out of range, move it back
        function checkBounds(map) {
            if (typeof (map.getBounds()) == 'undefined')
                return;

            var latNorth = map.getBounds().getNorthEast().lat();
            var latSouth = map.getBounds().getSouthWest().lat();
            var newLat;

            if (latNorth < 85 && latSouth > -85) /* in both side -> it's ok */
                return;
            else {
                if (latNorth > 85 && latSouth < -85) /* out both side -> it's ok */
                    return;
                else {
                    if (latNorth > 85)
                        newLat = map.getCenter().lat() - (latNorth - 85);
                    /* too north, centering */
                    if (latSouth < -85)
                        newLat = map.getCenter().lat() - (latSouth + 85);
                    /* too south, centering */
                }
            }
            if (newLat) {
                var newCenter = new google.maps.LatLng(newLat, map.getCenter().lng());
                map.setCenter(newCenter);
            }
        }

        function initialize() {
            var mapProp = {
                center: myCenter,
                zoom: 3,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                minZoom: 3,
                //maxZoom: 18,
                mapTypeControl: false
            };
            map = new google.maps.Map(document.getElementById("googleMap"), mapProp);
            map.setOptions({
                styles: hidePublicPlaces.hidePublic()
            });
            google.maps.event.addListener(map, 'center_changed', function () {
                checkBounds(map);
            });
            //google.maps.event.addListener(map, 'click', function() {
            //    infowindow.close();
            //    restorePreviousData();
            //});
            //google.maps.event.addListener(infowindow,'closeclick',function(){
            //    restorePreviousData();
            //});
        };

        function createMarker(latlng, data) {
            //var marker = new google.maps.Marker({
            //    position: latlng,
            //    map: map
            //});
            if (data.type == 'pickNotAssigned') {
                var url;
                if (data.is_routing == 0) {
                    url = 'assets/images/blackCircle.png';
                } else {
                    url = 'assets/images/blueMarker.png';
                }
                var icon = {
                    url: url,
                    size: new google.maps.Size(70, 70),
                    scaledSize: new google.maps.Size(20, 20), // scaled size
                    origin: new google.maps.Point(0, 0), // origin
                    labelOrigin: new google.maps.Point(25, 15),
                    anchor: new google.maps.Point(8, 16) // anchor
                };
                var text = '<p>' + data.job_pickup_datetime_filter + '<br/>' + data.number_of_passangers + ' Pax</p>';
            } else if (data.type == 'drop') {
                var icon = {
                    url: 'assets/images/redCircle.png',
                    size: new google.maps.Size(70, 70),
                    scaledSize: new google.maps.Size(20, 20), // scaled size
                    origin: new google.maps.Point(0, 0), // origin
                    labelOrigin: new google.maps.Point(25, 15),
                    anchor: new google.maps.Point(8, 16) // anchor
                };
            } else if (data.type == 'pickAssigned') {
                var icon = {
                    url: 'assets/images/greenCircle.png',
                    size: new google.maps.Size(70, 70),
                    scaledSize: new google.maps.Size(20, 20), // scaled size
                    origin: new google.maps.Point(0, 0), // origin
                    labelOrigin: new google.maps.Point(25, 15),
                    anchor: new google.maps.Point(8, 16) // anchor
                };
                var text = '<p>' + data.job_pickup_datetime_filter_new + '<br/>' + data.number_of_passangers + ' Pax</p>';
            } else if (data.type == 'pickStarted') {
                var icon = {
                    url: 'assets/images/blackCircle.png',
                    size: new google.maps.Size(70, 70),
                    scaledSize: new google.maps.Size(20, 20), // scaled size
                    origin: new google.maps.Point(0, 0), // origin
                    labelOrigin: new google.maps.Point(25, 15),
                    anchor: new google.maps.Point(8, 16) // anchor
                };
                var text = '<p>' + data.job_pickup_datetime_filter_new + '<br/>' + data.number_of_passangers + ' Pax</p>';
            }



            var marker = new MarkerWithLabel({
                position: latlng,
                draggable: false,
                raiseOnDrag: false,
                icon: icon,
                map: map,
                labelContent: data.type != 'drop' ? text : '',
                labelAnchor: data.type != 'drop' ? new google.maps.Point(22, 0) : '',
                labelClass: data.type != 'drop' ? "labelsMap" : '', // the CSS class for the label
                labelStyle: data.type != 'drop' ? {
                    opacity: 0.75
                } : '',
                type: data.type,
                id: data.job_id
            });
            console.log(marker, ';marker');




            //var mapLabel = new MapLabel({
            //    text: 'TEST',
            //    position: latlng,
            //    map: map,
            //    fontSize: 35,
            //    align: 'center'
            //});
            //mapLabel.set('position', latlng);

            bounds.extend(latlng);
            if (map != null)
                map.fitBounds(bounds);
            google.maps.event.addListener(marker, 'click', function (event) {
                vm.jobIdOfMarker = marker.id;
                vm.jobTypeOfMarker = marker.type;
                if (marker.type != 'drop') {
                    marker.content = makeInfoWindow(data);
                    infowindow.setContent(marker.content);
                    infowindow.open(map, marker);
                }
            });
            markers.push(marker); //push local var marker into global array
        };

        function makeInfoWindow(data) {
            var divWithAssignment = '<div class="row" id="googleMapsDetailsWithCar">' +
                '<div class="col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center serviceDetails">' + data.service_name + '</div>' +
                '<div class="col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center idBooking">' + '<span class="label">Id Booking</span>' + '<span class="id"> #' + data.job_id + '</span>' + '</div>' +
                '  <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 paddingOnDuty1">' +
                '  <div class="pickUpText">Pickup</div>' +
                '   <div class="addressDiv"><i class="fa fa-map-marker"></i>&nbsp;&nbsp;' + data.job_pickup_address + '</div>' +
                ' </div>' +
                '<div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 paddingOnDuty1">' +
                '    <div class="pickUpText">Drop off</div>' +
                '<div class="addressDiv"><i class="fa fa-map-marker"></i>&nbsp;&nbsp;' + data.job_address + '</div>' +
                '</div>' +
                '<div class="col-lg-12 col-sm-12 col-xs-12 col-md-12 distanceDivPS paddingZero">' +
                '    <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 distanceDivs" style="padding:2px;">Distance: ' + data.distance + 'KM</div>' +
                '<div class="distanceDivs col-lg-6 col-sm-6 col-xs-6 col-md-6" style="padding:2px;">Time Trip: ' + data.eta + ' min</div>' +
                '</div>' +
                ' <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 customerDriverDivS">' +
                '   <div class="customerDivPS">' +
                '  <div class="customerText">Customer</div>' +
                '   <div class="customerName">' + data.job_pickup_name + '</div>' +
                ' <div class="customerName">+56 ' + data.job_pickup_phone + '</div>' +
                ' <div class="customerName">' + data.number_of_passangers + ' Pax</div>' +
                '   </div>' +
                '</div>' +
                ' <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 pickUpDetailsPS">' +
                '   <div class="pickUpText1">Pickup Time</div>' +
                '<div class="pickUpTime">' + data.job_pickup_datetime_filter + ' Hrs</div>' +
                '<div class="pickUpAgreement">' + data.name + '</div>' +
                '  </div>' +
                '<div class="col-lg-12 col-sm-12 col-xs-12 col-md-12 paddingOnDuty statusChangeD" id="assignToRoute" style="background: green;">' + data.text + '</div>' +
                '</div>';

            var divWithoutAssignment = '<div class="row" id="googleMapsDetailsWithCar">' +
                '<div class="col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center serviceDetails">' + data.service_name + '</div>' +
                '<div class="col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center idBooking">' + '<span class="label">Id Booking</span>' + '<span class="id"> #' + data.job_id + '</span>' + '</div>' +
                '  <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 paddingOnDuty1">' +
                '  <div class="pickUpText">Pickup</div>' +
                '   <div class="addressDiv"><i class="fa fa-map-marker"></i>&nbsp;&nbsp;' + data.job_pickup_address + '</div>' +
                ' </div>' +
                '<div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 paddingOnDuty1">' +
                '    <div class="pickUpText">Drop off</div>' +
                '<div class="addressDiv"><i class="fa fa-map-marker"></i>&nbsp;&nbsp;' + data.job_address + '</div>' +
                '</div>' +
                '<div class="col-lg-12 col-sm-12 col-xs-12 col-md-12 distanceDivPS paddingZero">' +
                '    <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 distanceDivs" style="padding:2px;">Distance: ' + data.distance + 'KM</div>' +
                '<div class="distanceDivs col-lg-6 col-sm-6 col-xs-6 col-md-6" style="padding:2px;">Time Trip: ' + data.newEta + ' min</div>' +
                '</div>' +
                ' <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 customerDriverDivS">' +
                '   <div class="customerDivPS">' +
                '  <div class="customerText">Customer</div>' +
                '   <div class="customerName">' + data.job_pickup_name + '</div>' +
                ' <div class="customerName">+56 ' + data.job_pickup_phone + '</div>' +
                ' <div class="customerName">' + data.number_of_passangers + ' Pax</div>' +
                '   </div>' +
                '</div>' +
                ' <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 pickUpDetailsPS">' +
                '   <div class="pickUpText1">Pickup Time</div>' +
                '<div class="pickUpTime">' + data.job_pickup_datetime_filter_new + ' Hrs</div>' +
                '<div class="pickUpAgreement">' + data.name + '</div>' +
                '  </div>' +
                '</div>';

            if (vm.jobTypeOfMarker == 'pickNotAssigned') {
                return divWithAssignment;
            } else if (vm.jobTypeOfMarker == 'pickAssigned') {
                return divWithoutAssignment;
            } else if (vm.jobTypeOfMarker == 'pickStarted') {
                return divWithoutAssignment;
            }
        };


        //================default values in date and time===========================
        function showFilterTime(type) {
            var x = new Date();
            if (type == 1) {
                x.setHours('00');
                x.setMinutes('00');
                x.setSeconds('00');
            } else if (type == 2) {
                var currentHrs = x.getHours();
                var nextTwelveHrs = currentHrs + 12;
                var currentMins = x.getMinutes();
                x.setHours(nextTwelveHrs);
                x.setMinutes(currentMins);
                x.setSeconds('00');
            }
            return x;
        }

        function setToPickupDate() {
            var x = new Date();
            var currentHrs = x.getHours();
            var nextTwelveHrs = currentHrs + 12;
            if (nextTwelveHrs > 24) {
                var tomorrow = new Date();
                tomorrow.setDate(x.getDate() + 1);
                return tomorrow;
            } else {
                return new Date();
            }
        }

        //==================date picker function==================
        vm.dateOptions = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(2090, 12, 31),
            //minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };
        vm.dateOptionsT = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(2090, 12, 31),
            //minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };

        function datePickerE_1(type) {
            switch (type) {
                case 1:
                    vm.datePicker_1.pickupFromDate = true;
                    vm.datePicker_1.pickupToDate = false;
                    vm.datePicker_1.pickupFromDatePackage = false;
                    vm.datePicker_1.pickupToDatePackage = false;
                    break;
                case 2:
                    vm.datePicker_1.pickupFromDate = false;
                    vm.datePicker_1.pickupToDate = true;
                    vm.datePicker_1.pickupFromDatePackage = false;
                    vm.datePicker_1.pickupToDatePackage = false;
                    break;
                case 3:
                    vm.datePicker_1.pickupFromDate = false;
                    vm.datePicker_1.pickupToDate = false;
                    vm.datePicker_1.pickupFromDatePackage = true;
                    vm.datePicker_1.pickupToDatePackage = false;
                    break;
                case 4:
                    vm.datePicker_1.pickupFromDate = false;
                    vm.datePicker_1.pickupToDate = false;
                    vm.datePicker_1.pickupFromDatePackage = false;
                    vm.datePicker_1.pickupToDatePackage = true;
                    break;
            }
        };


        //====================slide data======================
        $('#derp').show();

        function slideData() {
            $('#derp').slideToggle(1000);
        }

        // ********* FILTERS FOR PACKAGE *********
        $('#packageFilter').show();

        function slideDataPackage() {
            if (vm.filterData.makePackageList.length > 0 && vm.bookingsAssignmentTab) {
                vm.checkClickedPackage = false;
            } else {
                $('#packageFilter').slideToggle(1000);
            }
        }

        //===================reset filter=====================
        function resetFilter(type) {
            if (type) {
                if (vm.filterData.makePackageList && vm.filterData.makePackageList.length) {
                    var jobData = [];
                    vm.filterData.makePackageList.forEach(function (d) {
                        jobData.push(d.job_id);
                    })
                    setFlagInJob(jobData);
                }
                var branch;
                if ($cookies.get('branchPackage')) {
                    vm.filterData.branch_value_package = $cookies.remove('branchPackage');
                }
                if ($cookies.get('type_of_service_package')) {
                    vm.filterData.service_value_package = $cookies.remove('type_of_service_package');
                }
                if ($cookies.get('type_of_trip_package')) {
                    vm.filterData.typeOfTripPackage = $cookies.put('type_of_trip_package', 'R')
                }
                if ($cookies.get('contract_id_package')) {
                    vm.filterData.aggrement_value_package = $cookies.put('contract_id_package');
                }
                if ($cookies.get('pickUpDatePackage')) {
                    $cookies.put("pickUpDatePackage", new Date());
                    vm.filterData.filter_pickup_from_date_value_package = new Date();
                } else {
                    vm.filterData.filter_pickup_from_date_value_package = new Date();
                }
                if ($cookies.get('pickDatetoPackage')) {
                    $cookies.put("pickDatetoPackage", new Date());
                    vm.filterData.filter_pickup_to_date_value_package = new Date();
                } else {
                    vm.filterData.filter_pickup_to_date_value_package = new Date();
                }
                if ($cookies.get('pickTimePackage')) {
                    $cookies.put("pickTimePackage", new Date(new Date().setHours(0, 0, 0, 0)));
                    vm.filterData.filter_pickup_from_time_value_package = new Date(new Date().setHours(0, 0, 0, 0));
                } else {
                    vm.filterData.filter_pickup_from_time_value_package = new Date(new Date().setHours(0, 0, 0, 0));
                }
                if ($cookies.get('dropTimePackage')) {
                    $cookies.put("dropTimePackage", new Date(new Date().setHours(23, 59, 0, 0)));
                    vm.filterData.filter_pickup_to_time_value_package = new Date(new Date().setHours(23, 59, 0, 0));
                } else {
                    vm.filterData.filter_pickup_to_time_value_package = new Date(new Date().setHours(23, 59, 0, 0));
                }
                vm.filterData.makePackagePredicate = 'index';
                vm.filterData.filterAppliedPackage = false;
                // vm.filterData.unassignedReverse = false;
                vm.filterData.makePackageReverse = false;
                vm.filterData.makePackageList = [];
                vm.filterData.dropLocationArray = [];
                vm.filterData.makePackageCount = 0;
                vm.filterData.totalPassengerAssigned = 0;
                vm.filterData.totalBookingAssigned = 0;
                vm.filterData.totalAssignedETA = 0;
                vm.filterData.createdPredicate = 'index';
                vm.filterData.createdReverse = false;
                vm.filterData.createdSkip = 0;
                vm.filterData.createdLimit = 15;
                vm.filterData.createdBookingCount = 0;
                vm.filterData.createdBookingList = [];
                vm.filterData.sharedServiceName = 'NEW';
                vm.filterData.vehicleAssigned = 'PENDING';
                vm.filterData.modifyFlag = false;
                // setMapOnAll(null, 'all');
            } else {
                if (vm.filterData.makePackageList && vm.filterData.makePackageList.length) {
                    var jobData = [];
                    vm.filterData.makePackageList.forEach(function (d) {
                        jobData.push(d.job_id);
                    })
                    setFlagInJob(jobData);
                }
                var branch;
                if ($cookies.get('branch')) {
                    vm.filterData.branch_value = $cookies.remove('branch');
                }
                if ($cookies.get('type_of_service')) {
                    vm.filterData.service_value = $cookies.remove('type_of_service');
                }
                if ($cookies.get('type_of_trip')) {
                    vm.filterData.typeOfTrip = $cookies.put('type_of_trip', 'R')
                }
                if ($cookies.get('contract_id')) {
                    vm.filterData.aggrement_value = $cookies.put('contract_id');
                }
                if ($cookies.get('pickUpDate')) {
                    $cookies.put("pickUpDate", new Date());
                    vm.filterData.filter_pickup_from_date_value = new Date();
                } else {
                    vm.filterData.filter_pickup_from_date_value = new Date();
                }
                if ($cookies.get('pickDateto')) {
                    $cookies.put("pickDateto", new Date());
                    vm.filterData.filter_pickup_to_date_value = new Date();
                } else {
                    vm.filterData.filter_pickup_to_date_value = new Date();
                }
                if ($cookies.get('pickTime')) {
                    $cookies.put("pickTime", new Date(new Date().setHours(0, 0, 0, 0)));
                    vm.filterData.filter_pickup_from_time_value = new Date(new Date().setHours(0, 0, 0, 0));
                } else {
                    vm.filterData.filter_pickup_from_time_value = new Date(new Date().setHours(0, 0, 0, 0));
                }
                if ($cookies.get('dropTime')) {
                    $cookies.put("dropTime", new Date(new Date().setHours(23, 59, 0, 0)));
                    vm.filterData.filter_pickup_to_time_value = new Date(new Date().setHours(23, 59, 0, 0));
                } else {
                    vm.filterData.filter_pickup_to_time_value = new Date(new Date().setHours(23, 59, 0, 0));
                }
                vm.filterData.unassignedBookingList = [];
                vm.filterData.unassignedBookingCount = 0;
                vm.filterData.unassignedBookingCountShow = 0;
                vm.filterData.unassignedSkip = 0;
                vm.filterData.unassignedLimit = 10;
                vm.filterData.unassignedLimitMade = 10;
                vm.filterData.serviceDetailsSelected = '';
                vm.filterData.filterApplied = false;
                vm.filterData.unassignedPredicate = 'index';
                // vm.filterData.makePackagePredicate = 'index';
                vm.filterData.unassignedReverse = false;
                vm.filterData.modifyFlag = false;
                setMapOnAll(null, 'all');
            }
        }
        //====================get branch list====================
        function getBranch() {
            // vm.branchList = [];
            // vm.branchList = JSON.parse(JSON.stringify(getFilters.branchesFiltersData.data));

            // $scope.$apply();
            vm.loading = true;
            var promise = getGeofence.branch();
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        var where = _.where(payload.title.data, {
                            parent_id: 0
                        });
                        //vm.branchList = _.where(where, { is_active: 1 });
                        vm.branchList = where;
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    // vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        // WHen Page refresh service take time to get data from backend
        // setTimeout(function () {
        getBranch();
        // }, 1000);
        //======================get all services==============
        function getAllServices(skip, limit) {


            vm.loading = false;
            var promise = getServices.allServices(skip, limit, 2, 0);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    //vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.service = [];
                        angular.forEach(payload.title.data.result, function (column) {
                            if (column.status == 1 && column.category == 1)
                                vm.service.push({
                                    id: column.id,
                                    name: column.service_name,
                                    max: column.max_limit
                                });
                        });
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllServices(0, 0);

        //======================get all services==============
        function getAllAgreement(skip, limt) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.offset = skip;
            dataSend.limit = limt;
            dataSend.key = 3;
            //vm.loading = false;
            var promise = getAgreement.getAgreementListLessData(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    //vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.agreement = [];
                        angular.forEach(payload.title.data, function (column) {
                            if (column.status == 1)
                                vm.agreement.push({
                                    id: column.id,
                                    name: column.name
                                });
                        });
                        vm.agreement.push({
                            id: 'all',
                            name: 'All'
                        });
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllAgreement(0, 0);
        //====================date time format====================
        function dateTimeFormat(dateGot, timeGot) {
            var dateToChange = dateGot;
            if (timeGot) {
                dateToChange.setHours(timeGot.getHours());
                dateToChange.setMinutes(timeGot.getMinutes());
                dateToChange.setSeconds(timeGot.getSeconds());
            } else {
                dateToChange.setHours(0);
                dateToChange.setMinutes(0);
                dateToChange.setSeconds(0);
            }
            return dateToChange;
        };

        /////////////////// VolverButton ////////////////////
        function VolverButton() {
            if (vm.filterData.filter_pickup_from_date_value && vm.filterData.filter_pickup_from_time_value) {
                var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            }
            if (vm.filterData.filter_pickup_to_date_value && vm.filterData.filter_pickup_to_time_value) {
                var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            }
            vm.socketCount = 0;
            vm.filterData.unassignedLimit = 10;
            vm.filterData.unassignedSkip = 0;
            getSharedToAirportOnly(false, pickFromDate, pickToDate, 'Unscroll');
        }

        //===================apply filter=====================
        function applyFilter(type) {
            vm.sendCreatePackageTypeOfTrip = vm.filterData.typeOfTrip;
            vm.filterData.makePackageList = [];
            if (!vm.filterData.filter_pickup_from_date_value && vm.filterData.filter_pickup_from_time_value) {
                languageBasedErrorFactory.getProperErrorMessage('appropriateFilter', 0, 0);
                return;
            }
            if (vm.filterData.filter_pickup_from_date_value && !vm.filterData.filter_pickup_from_time_value) {
                languageBasedErrorFactory.getProperErrorMessage('appropriateFilter', 0, 0);
                return;
            }
            if (vm.filterData.filter_pickup_to_date_value && !vm.filterData.filter_pickup_to_time_value) {
                languageBasedErrorFactory.getProperErrorMessage('appropriateFilter', 0, 0);
                return;
            }

            if (vm.filterData.filter_pickup_from_date_value && vm.filterData.filter_pickup_from_time_value) {
                var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            }
            if (vm.filterData.filter_pickup_to_date_value && vm.filterData.filter_pickup_to_time_value) {
                var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            }

            if (pickFromDate > pickToDate) {
                languageBasedErrorFactory.getProperErrorMessage('appropriateFilter', 0, 0);
                return;
            }

            if (vm.mapViewTab) {
                setMapOnAll(null, 'all');
            }
            // if (type == 'blank') {
            //     vm.filterData.makePackageList = [];
            //     vm.filterData.makePackageCount = 0;
            // }
            vm.filterData.dropLocationArray = [];
            // vm.filterData.totalPassengerAssigned = 0;
            // vm.filterData.totalBookingAssigned = 0;
            // vm.filterData.totalAssignedETA = 0;
            // vm.filterData.createdPredicate = 'index';
            // vm.filterData.createdReverse = false;
            // vm.filterData.createdSkip = 0;
            // vm.filterData.createdLimit = 15;
            // vm.filterData.createdBookingCount = 0;
            // vm.filterData.createdBookingList = [];
            vm.filterData.modifyFlag = false;
            if (type == 'scroll') {
                vm.filterData.filterApplied = true;
                vm.filterData.filterAppliedPackage = true;
                if (vm.mapViewTab) {
                    $timeout(function () {
                        initialize();
                        directionsDisplay.setMap(null);
                    })
                }
                if (vm.filterData.serviceDetailsSelected != undefined)
                    getSharedToAirportOnly(false, pickFromDate, pickToDate, 'scroll');
                // getSharedPackageList('noScroll', false);
            } else {
                vm.filterData.unassignedSkip = 0;
                vm.filterData.unassignedLimit = 10;
                vm.filterData.unassignedLimitMade = 10;
                vm.filterData.filterApplied = true;
                vm.filterData.filterAppliedPackage = true;
                if (vm.mapViewTab) {
                    $timeout(function () {
                        initialize();
                        directionsDisplay.setMap(null);
                    })
                }
                if (vm.filterData.serviceDetailsSelected != undefined)
                    getSharedToAirportOnly(true, pickFromDate, pickToDate);
                // getSharedPackageList('noScroll', false);
            }
        }

        // ******** APPLY FILTER FOR PACKAE ********
        function applyFilterPackage(type) {
            if (!vm.filterData.filter_pickup_from_date_value_package && vm.filterData.filter_pickup_from_time_value_package) {
                languageBasedErrorFactory.getProperErrorMessage('appropriateFilter', 0, 0);
                return;
            }
            if (vm.filterData.filter_pickup_from_date_value_package && !vm.filterData.filter_pickup_from_time_value_package) {
                languageBasedErrorFactory.getProperErrorMessage('appropriateFilter', 0, 0);
                return;
            }
            if (vm.filterData.filter_pickup_to_date_value_package && !vm.filterData.filter_pickup_to_time_value_package) {
                languageBasedErrorFactory.getProperErrorMessage('appropriateFilter', 0, 0);
                return;
            }

            if (vm.filterData.filter_pickup_from_date_value_package && vm.filterData.filter_pickup_from_time_value_package) {
                var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value_package, vm.filterData.filter_pickup_from_time_value_package);
            }
            if (vm.filterData.filter_pickup_to_date_value_package && vm.filterData.filter_pickup_to_time_value_package) {
                var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value_package, vm.filterData.filter_pickup_to_time_value_package);
            }

            if (pickFromDate > pickToDate) {
                languageBasedErrorFactory.getProperErrorMessage('appropriateFilter', 0, 0);
                return;
            }

            // if (vm.mapViewTab) {
            //     setMapOnAll(null, 'all');
            // }
            if (type == 'blank') {
                vm.filterData.makePackageList = [];
                vm.filterData.makePackageCount = 0;
            }
            vm.filterData.dropLocationArray = [];
            vm.filterData.totalPassengerAssigned = 0;
            vm.filterData.totalBookingAssigned = 0;
            vm.filterData.totalAssignedETA = 0;
            vm.filterData.createdPredicate = 'index';
            vm.filterData.createdReverse = false;
            vm.filterData.createdSkip = 0;
            vm.filterData.createdLimit = 15;
            vm.filterData.createdBookingCount = 0;
            vm.filterData.createdBookingList = [];
            vm.filterData.modifyFlag = false;
            getSharedPackageList('noScroll', false, pickFromDate, pickToDate);
            vm.filterData.filterAppliedPackage = true;
        }

        // ******** CLEAR OFFSET *******
        // function clearOffset() {
        //     for (var i = 0; i < vm.searchFilterArray.length; i++) {
        //         vm[vm.searchFilterArray[i] + 'Offset'] = 0;
        //     }
        // }

        function branchChanged(type) {
            if (type) {
                if (vm.filterData.branch_value_package != 'all')
                    $cookies.put('branchPackage', vm.filterData.branch_value_package);
            } else {
                if (vm.filterData.branch_value != 'all')
                    $cookies.put('branch', vm.filterData.branch_value);
            }
            // vm.agreement = [];
            // vm.branchList = [];
            // vm.vehicle = [];
            // clearOffset();
            // vm.filterObject.branch_offset  = 0;
            // getFilterDataFromBackend();
        }
        vm.agreementChanged = function (type) {
            if (type) {
                // if (vm.filterData.aggrement_value_package != 'all')
                $cookies.put('contract_id_package', vm.filterData.aggrement_value_package);
            } else {
                // if (vm.filterData.aggrement_value != 'all')
                $cookies.put('contract_id', vm.filterData.aggrement_value);
            }
            // vm.agreement = [];
            // vm.branchList = [];
            // vm.vehicle = [];
            // clearOffset();
            // vm.filterObject.agreement_offset = 0; 
            // getFilterDataFromBackend();
        }

        //  //===================service selected================
        function serviceChanged(type) {
            if (type) {
                vm.filterData.serviceDetailsSelected = _.where(vm.service, {
                    id: vm.filterData.service_value_package
                })[0];
                $cookies.put("type_of_service_package.name", vm.filterData.serviceDetailsSelected.name);
                // vm.agreement = [];
                // vm.branchList = [];
                // vm.vehicle = [];
                // getFilterDataFromBackend();
                $cookies.put("type_of_service_package.max", vm.filterData.serviceDetailsSelected.max);
                vm.nameForShow = $cookies.get('type_of_service_package.name');
                vm.maxForShow = $cookies.get('type_of_service_package.max');
                $cookies.put('type_of_service_package', vm.filterData.service_value_package)
            } else {
                vm.filterData.serviceDetailsSelected = _.where(vm.service, {
                    id: vm.filterData.service_value
                })[0];
                if (vm.filterData.serviceDetailsSelected != undefined) {
                    $cookies.put("type_of_service.name", vm.filterData.serviceDetailsSelected.name);
                    // vm.agreement = [];
                    // vm.branchList = [];
                    // vm.vehicle = [];
                    // getFilterDataFromBackend();
                    $cookies.put("type_of_service.max", vm.filterData.serviceDetailsSelected.max);
                    vm.nameForShow = $cookies.get('type_of_service.name');
                    vm.maxForShow = $cookies.get('type_of_service.max');
                    $cookies.put('type_of_service', vm.filterData.service_value)
                }
            }

        }

        vm.typeOfTrip = function (type) {
            if (type) {
                $cookies.put('type_of_trip_package', vm.filterData.typeOfTripPackage)
            } else {
                $cookies.put('type_of_trip', vm.filterData.typeOfTrip)
            }
        }
        vm.pickupFromToDateChanged = function (data) {

            switch (data) {
                case 1:
                    $cookies.put('pickUpDate', vm.filterData.filter_pickup_from_date_value);
                    break;
                case 2:
                    $cookies.put('pickDateto', vm.filterData.filter_pickup_to_date_value);
                    break;
                case 3:
                    $cookies.put('pickUpDatePackage', vm.filterData.filter_pickup_from_date_value_package);
                    break;
                case 4:
                    $cookies.put('pickDatetoPackage', vm.filterData.filter_pickup_to_date_value_package);
                    break;
            }
        }
        vm.changeTime = function (type) {
            if (type) {
                $cookies.put('pickTimePackage', vm.filterData.filter_pickup_from_time_value_package);
            } else {
                $cookies.put('pickTime', vm.filterData.filter_pickup_from_time_value);
            }
        }
        vm.changeDropTime = function (type) {
            if (type) {
                $cookies.put('dropTimePackage', vm.filterData.filter_pickup_to_time_value_package);
            } else {
                $cookies.put('dropTime', vm.filterData.filter_pickup_to_time_value);
            }
        }
        //=====================get shared to airport only=========================
        function getSharedToAirportOnly(loading, pickFromDate, pickToDate, type) {
            console.log(vm.filterData.unassignedSkip, vm.filterData.unassignedLimit);

            vm.countToSocket = vm.countToSocket + 1;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.offset = vm.filterData.unassignedSkip;
            dataSend.limit = vm.filterData.unassignedLimit;
            dataSend.branch = vm.filterData.branch_value;
            dataSend.type_of_service = vm.filterData.service_value;
            dataSend.type_of_trip = vm.filterData.typeOfTrip;
            if (vm.filterData.aggrement_value != 'all')
                dataSend.contract_id = vm.filterData.aggrement_value;
            //else dataSend.contract_id = '';
            if (pickFromDate && pickToDate) {
                dataSend.from_pickup_datetime = pickFromDate.toISOString();
                dataSend.to_pickup_datetime = pickToDate.toISOString();
            }
            if (vm.flightSearchModel) {
                dataSend.flight_number_string_flag = 1;
                dataSend.flight_number_search_value = vm.flightSearchModel;
            } else {
                dataSend.flight_number_string_flag = 0;
            }
            if (vm.nominaSearchModel) {
                dataSend.nomina_string_flag = 1;
                dataSend.nomina_search_value = vm.nominaSearchModel;
            } else {
                dataSend.nomina_string_flag = 0;
            }
            if (vm.idBooking) {
                dataSend.booking_id = vm.idBooking;
            }
            if (vm.comunaSearchModel) {
                dataSend.communa_string_flag = 1;
                dataSend.communa_search_value = vm.comunaSearchModel;
            } else {
                dataSend.communa_string_flag = 0;
            }
            vm.loading = loading;
            // vm.filterData.unassignedBookingList = [];
            var promise = sharedRouteAssignment.getSharedBookings(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.countToSocket = 0;
                    vm.loading = false;
                    // vm.socketCount = 0;
                    vm.filterData.unassignedBookingCount = payload.title.data.totalCount;
                    vm.filterData.unassignedBookingCountShow = payload.title.data.totalCount;
                    if (payload.title.data.result.length == 0) {
                        $timeout(function () {
                            initialize();
                            directionsDisplay.setMap(null);
                        });
                    }
                    if (type == 'scroll') {
                        for (var i = 0; i < payload.title.data.result.length; i++) {
                            vm.filterData.unassignedBookingList.push(payload.title.data.result[i]);
                        }
                    } else {
                        vm.filterData.unassignedBookingList = payload.title.data.result;
                    }
                    if (type == 'socket') {
                        if (vm.filterData.makePackageList && vm.filterData.makePackageList.length) {
                            for (var i = 0; i < vm.filterData.makePackageList.length; i++) {
                                var index = _.findIndex(vm.filterData.unassignedBookingList, {
                                    job_id: vm.filterData.makePackageList[i].job_id
                                });
                                // Tv-2129
                                // if (index > -1) {
                                //     vm.filterData.unassignedBookingList.splice(index, 1);
                                // }
                            }
                        }
                        vm.filterData.unassignedBookingCount = vm.filterData.unassignedBookingList.length;
                    }

                    if (vm.filterData.unassignedBookingList.length) {
                        setMapOnAll(null, 'pickNotAssigned');
                        vm.filterData.dropLocationArray = _.uniq(vm.filterData.unassignedBookingList, function (x) {
                            return x.job_latitude && x.job_longitude;
                        });
                        vm.filterData.unassignedBookingList.forEach(function (data) {
                            data.job_pickup_datetime_filter = $filter('date')(data.original_pickup_datetime, "HH:mm");
                            data.distance = data.estimated_distance ? Math.round(data.estimated_distance / 1000) : 0;
                            data.type = 'pickNotAssigned';
                            data.text = 'Assign to Route';
                            vm.job_longitude = data.job_pickup_longitude;
                            vm.job_latitude = data.job_pickup_latitude;
                            vm.dataMarker = data;
                            createMarker(new google.maps.LatLng(data.job_pickup_latitude, data.job_pickup_longitude), data);
                        })
                    }

                    if (vm.filterData.dropLocationArray.length) {
                        vm.filterData.dropLocationArray.forEach(function (data) {
                            data.type = 'drop';
                            vm.job_longitude = data.job_latitude;
                            vm.job_latitude = data.job_longitude;
                            vm.dataMarker = data;
                            createMarker(new google.maps.LatLng(data.job_latitude, data.job_longitude), data);
                        })
                    }
                    unassignLength = vm.filterData.unassignedBookingList.length;
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        //=================pagination changed for unassigned bookings================
        function paginationChangedForUnassigned() {
            if (vm.filterData.filter_pickup_from_date_value && vm.filterData.filter_pickup_from_time_value) {
                var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            }
            if (vm.filterData.filter_pickup_to_date_value && vm.filterData.filter_pickup_to_time_value) {
                var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            }
            if (vm.filterData.unassignedBookingCountShow > vm.filterData.unassignedBookingList.length) {
                vm.filterData.unassignedSkip = vm.filterData.unassignedSkip + vm.filterData.unassignedLimitMade;
                getSharedToAirportOnly(false, pickFromDate, pickToDate, 'scroll');
            }
        }

        function paginationChangedForCreated() {
            if (vm.filterData.filter_pickup_from_date_value_package && vm.filterData.filter_pickup_from_time_value_package) {
                var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value_package, vm.filterData.filter_pickup_from_time_value_package);
            }
            if (vm.filterData.filter_pickup_to_date_value_package && vm.filterData.filter_pickup_to_time_value_package) {
                var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value_package, vm.filterData.filter_pickup_to_time_value_package);
            }
            if (vm.filterData.createdBookingCount > vm.filterData.createdBookingList.length) {
                vm.filterData.createdSkip = vm.filterData.createdSkip + 15;
                getSharedPackageList('scroll', true, pickFromDate, pickToDate);
            }
        }

        vm.sortableOptions = {
            placeholder: "app",
            connectWith: ".apps-container",
            helper: function (e, item) {
                vm.oldJobId = Number(item[0].id.split('-')[0]);
                return item;
            },
            update: function (e, ui) {
                $timeout(function () {
                    calculateDataAndValidatePackage();
                }, 100);
                unassignLength = vm.filterData.unassignedBookingList.length;
            },
            items: "tr:not(.not-sortable)"
        };
        vm.sortableOptionsUnassign = {
            placeholder: "app",
            connectWith: ".apps-container",
            helper: function (e, item) {
                vm.newJobId = Number(item[0].id.split('-')[0]);
                vm.newPassenger = Number(item[0].id.split('-')[1]);
                return item;
            },
            update: function (e, ui) {
                if (vm.filterData.unassignedBookingList.length > unassignLength)
                    setFlagInJob(vm.oldJobId);
                //calculateDataAndValidatePackage();
            },
            items: "tr:not(.not-sortable)"


        };

        vm.click1 = function (data, index) {
            vm.bookingsAssignmentTab = true;
            vm.servicesCreatedTab = false;
            vm.lowerTabsBody = true;
            //TV-2179 
            // vm.filterData.unassignedBookingList.splice(index, 1);
            vm.filterData.makePackageList.push(data);
            if (vm.filterData.makePackageList.length > 0) {
                vm.filterData.filterAppliedPackage = true;
                $('#packageFilter').hide();
            }
            vm.ErrorData = data;
            unassignLength = vm.filterData.unassignedBookingList.length;
            if (vm.filterData.unassignedBookingList.length > unassignLength)
                setFlagInJob(data.job_id);
            $timeout(function () {
                // hitDistanceMatrixForGoogleMapsToAirport();
                // calculateDataAndValidatePackage();
                calculateDataAndValidatePackage();
            }, 100);

        }
        vm.click2 = function (data, index) {
            console.log(data, 'data?>>>>>>>>>>>');

            if (vm.showButtonSave) {
                return true;
            }
            var messageState = '';
            if (data.job_status == 1) {
                messageState = ' Esta reserva no puede ser removida del paquete porque ya fue iniciada.';
            }
            if (data.job_status == 2) {
                messageState = 'Esta reserva no puede ser removida del paquete porque ya fue Finalizada.';
            }
            if (data.job_status == 2 || data.job_status == 1) {
                errorMessageFactory.showErrorMessage(messageState, 0);
                return;
            }
            vm.filterData.makePackageList.splice(index, 1);
            //TV-2179 
            var index = vm.filterData.unassignedBookingList.findIndex(function (x) {
                return x.job_id == data.job_id;
            });
            var object = {
                job_time_utc: data.job_time_utc,
                branch_id: data.branch,
                contract_id: data.contract_id,
                service_id: data.type_of_service,
                type_of_trip: data.type_of_trip,
                job_status: data.job_status
            };
            if ((index < 0) && checkStatus(object)) {
                vm.filterData.unassignedBookingList.push(data);
            }
            changeAssignedData();
            setFlagInJob(data.job_id);
        }


        function blockUnblockBooking(id, type) {
            // $log.log(data);
            vm.loading = true;
            var promise = adminAccessService.checkStateValid('Desbloquear'); //$stateParams.id
            return promise.then(
                function (payload) {
                    vm.loading = false;
                    console.log(payload);
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (!payload.title.data.granted) {
                            languageBasedErrorFactory.getProperErrorMessage('optionNotAvail', 0, 0);
                            //errorMessageFactory.showErrorMessage('Option not available because you not have the right',0);
                            return false;
                        } else {
                            vm.loading = false;
                            setFlagInJob(id, type)
                            return true;
                        }
                    }
                },
                function (errorPayload) {
                    console.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        //===================set flag in job=====================
        function setFlagInJob(id, type) {
            var dataSend = {};
            dataSend.job_id = [];
            if (typeof id != 'number') {
                id.forEach(function (d) {
                    dataSend.job_id.push(d);
                })
            } else dataSend.job_id.push(id);
            if (type == 'popUp') {
                dataSend.desbloquear_unlock = 1;
            }
            dataSend.access_token = $cookies.get('obj');
            var promise = sharedRouteAssignment.makeFlagSetInJob(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    if (payload && payload.title.status == 200) {
                        // if (type == 'popUp') {
                        //     errorMessageFactory.showErrorMessage('Booking Unlock Successfull', 0);
                        // }
                        if (type)
                            if (typeof id != 'number') {
                                id.forEach(function (d) {
                                    decreaseDataWhenBookingIsRemoved(d)
                                })
                            } else decreaseDataWhenBookingIsRemoved(id);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function decreaseDataWhenBookingIsRemoved(job_id) {
            var findIndex = _.findIndex(vm.filterData.unassignedBookingList, {
                job_id: job_id
            })
            console.log(findIndex, vm.filterData.unassignedBookingList[findIndex]);
            if (findIndex != -1) {
                vm.filterData.totalPassengerAssigned > 0 ? vm.filterData.totalPassengerAssigned -= vm.filterData.unassignedBookingList[findIndex].number_of_passangers || 0 : vm.filterData.totalPassengerAssigned = 0;
                if (vm.filterData.modifyFlag) {
                    vm.filterData.totalAssignedETA = _.max(vm.filterData.makePackageList, function (x) {
                        return x.newDataEta;
                    }).newDataEta;
                } else {
                    vm.filterData.totalAssignedETA = _.max(vm.filterData.makePackageList, function (x) {
                        return x.newEta;
                    }).newEta;
                }
                vm.filterData.totalBookingAssigned > 0 ? vm.filterData.totalBookingAssigned -= 1 : vm.filterData.totalBookingAssigned = 0;
            }
        }


        //============to check point lies in 50 m================
        function arePointsNear(checkPoint, centerPoint, km) {
            var ky = 40000 / 360;
            var kx = Math.cos(Math.PI * centerPoint.lat / 180.0) * ky;
            var dx = Math.abs(centerPoint.lng - checkPoint.lng) * kx;
            var dy = Math.abs(centerPoint.lat - checkPoint.lat) * ky;
            return Math.sqrt(dx * dx + dy * dy) <= km;
        }


        //======================distance matrix only for getting eta==================
        function checkPoinToPointBookings() {
            if (vm.filterData.makePackageList.length > 1) {
                var pickCheck = {
                    lat: vm.filterData.makePackageList[vm.filterData.makePackageList.length - 1].job_pickup_latitude,
                    lng: vm.filterData.makePackageList[vm.filterData.makePackageList.length - 1].job_pickup_longitude
                }
                var pickCenter = {
                    lat: vm.filterData.makePackageList[0].job_pickup_latitude,
                    lng: vm.filterData.makePackageList[0].job_pickup_longitude
                }
                var dropCheck = {
                    lat: vm.filterData.makePackageList[vm.filterData.makePackageList.length - 1].job_latitude,
                    lng: vm.filterData.makePackageList[vm.filterData.makePackageList.length - 1].job_longitude
                }
                var dropCenter = {
                    lat: vm.filterData.makePackageList[0].job_latitude,
                    lng: vm.filterData.makePackageList[0].job_longitude
                }
                var pickUpFlag = arePointsNear(pickCheck, pickCenter, Number(vm.filterData.globalDistance / 1000));
                var dropOffFlag = arePointsNear(dropCheck, dropCenter, Number(vm.filterData.globalDistance / 1000));
                if (pickUpFlag && !dropOffFlag) {
                    setMapOnAll(null, 'all');
                    vm.filterData.commonPickUp = true;
                    hitDistanceMatrixForGoogleMapsFromAirport();
                } else if (!pickUpFlag && dropOffFlag) {
                    setMapOnAll(null, 'all');
                    vm.filterData.commonPickUp = false;
                    hitDistanceMatrixForGoogleMapsToAirport();
                } else if (pickUpFlag && dropOffFlag) {
                    setMapOnAll(null, 'all');
                    vm.filterData.commonPickUp = false;
                    hitDistanceMatrixForGoogleMapsToAirport();
                } else if (!pickUpFlag && !dropOffFlag) {
                    setMapOnAll(null, 'all');
                    vm.filterData.commonPickUp = false;
                    hitDistanceMatrixForGoogleMapsToAirport();
                }
            } else {
                setMapOnAll(null, 'all');
                vm.filterData.commonPickUp = false;
                hitDistanceMatrixForGoogleMapsToAirport();
            }
        }


        function calculateDataAndValidatePackage() {
            vm.parentDragStart = false;
            if (vm.filterData.makePackageList.length) {
                if (!vm.filterData.modifyFlag) {
                    if (vm.filterData.typeOfTrip == 'R') {
                        setMapOnAll(null, 'all');
                        hitDistanceMatrixForGoogleMapsToAirport();
                    } else if (vm.filterData.typeOfTrip == 'Z') {
                        setMapOnAll(null, 'all');
                        hitDistanceMatrixForGoogleMapsFromAirport();
                    } else if (vm.filterData.typeOfTrip == 'P') {
                        checkPoinToPointBookings();
                    }
                } else {
                    if (vm.filterData.typeOfTripModify == 'R') {
                        setMapOnAll(null, 'all');
                        hitDistanceMatrixForGoogleMapsToAirport();
                    } else if (vm.filterData.typeOfTripModify == 'Z') {
                        setMapOnAll(null, 'all');
                        hitDistanceMatrixForGoogleMapsFromAirport();
                    } else if (vm.filterData.typeOfTrip == 'P') {
                        checkPoinToPointBookings();
                    }

                }
            } else {
                setMapOnAll(null, 'all');
                directionsDisplay.setMap(null);
                vm.filterData.totalPassengerAssigned = 0;
                vm.filterData.totalAssignedETA = 0;
                vm.filterData.totalBookingAssigned = 0;
                if (vm.filterData.unassignedBookingCountShow > 0) {
                    vm.filterData.unassignedBookingCount = vm.filterData.unassignedBookingCountShow;
                } else {
                    vm.filterData.unassignedBookingCount = vm.filterData.unassignedBookingList.length;
                }
                vm.filterData.unassignedBookingList.forEach(function (data) {
                    data.job_pickup_datetime_filter = $filter('date')(data.original_pickup_datetime, "HH:mm");
                    data.type = 'pickNotAssigned';
                    data.text = 'Assign to Route';
                    // data.is_valid_tolerance = true;
                    data.distance = data.estimated_distance ? Math.round(data.estimated_distance / 1000) : 0;
                    createMarker(new google.maps.LatLng(data.job_pickup_latitude, data.job_pickup_longitude), data);
                });
                vm.filterData.dropLocationArray.forEach(function (data) {
                    data.type = 'drop';
                    createMarker(new google.maps.LatLng(data.job_latitude, data.job_longitude), data);
                });
            }
        }

        function assignToPackageFromMap(id) {
            var index = vm.filterData.makePackageList.findIndex(function (x) {
                return x.job_id == id;
            });
            if (index >= 0) {
                errorMessageFactory.showErrorMessage('La Reserva ya está en la pestaña CREAR SERVICIOS', 0);
                return;
            }
            var index = _.findIndex(vm.filterData.unassignedBookingList, {
                job_id: id
            });
            var where = _.where(vm.filterData.unassignedBookingList, {
                job_id: id
            })[0];
            if (index >= 0) {
                vm.newJobId = Number(where.job_id);
                vm.newPassenger = Number(where.number_of_passangers);
                var totalPassengerAlreadyInPackage = vm.filterData.totalPassengerAssigned + Number(where.number_of_passangers);
                if (totalPassengerAlreadyInPackage > vm.filterData.serviceDetailsSelected.max) {
                    var msg = 'The total passenger of service exceed to passengers allowed to ' + vm.filterData.serviceDetailsSelected.name;
                    errorMessageFactory.showErrorMessage(msg, 0);
                    return;
                } else {
                    var a = vm.filterData.unassignedBookingList.splice(index, 1);
                    vm.filterData.makePackageList.push(a[0]);
                    //setMapOnAll(null,'all');
                    //changeAssignedData();
                    if (vm.filterData.makePackageList.length) {
                        if (!vm.filterData.modifyFlag) {
                            if (vm.filterData.typeOfTrip == 'R') {
                                setMapOnAll(null, 'all');
                                hitDistanceMatrixForGoogleMapsToAirport();
                            } else if (vm.filterData.typeOfTrip == 'Z') {
                                setMapOnAll(null, 'all');
                                hitDistanceMatrixForGoogleMapsFromAirport();
                            }
                        } else {
                            if (vm.filterData.typeOfTripModify == 'R') {
                                setMapOnAll(null, 'all');
                                hitDistanceMatrixForGoogleMapsToAirport();
                            } else if (vm.filterData.typeOfTripModify == 'Z') {
                                setMapOnAll(null, 'all');
                                hitDistanceMatrixForGoogleMapsFromAirport();
                            }
                        }
                    } else {
                        setMapOnAll(null, 'all');
                        directionsDisplay.setMap(null);
                        vm.filterData.totalPassengerAssigned = 0;
                        vm.filterData.totalAssignedETA = 0;
                        vm.filterData.totalBookingAssigned = 0;
                        if (vm.filterData.unassignedBookingCountShow > 0) {
                            vm.filterData.unassignedBookingCount = vm.filterData.unassignedBookingCountShow;
                        } else {
                            vm.filterData.unassignedBookingCount = vm.filterData.unassignedBookingList.length;
                        }
                        vm.filterData.unassignedBookingList.forEach(function (data) {
                            data.job_pickup_datetime_filter = $filter('date')(data.original_pickup_datetime, "HH:mm");
                            data.type = 'pickNotAssigned';
                            data.text = 'Assign to Route';
                            // data.is_valid_tolerance = true;
                            data.distance = data.estimated_distance ? Math.round(data.estimated_distance / 1000) : 0;
                            createMarker(new google.maps.LatLng(data.job_pickup_latitude, data.job_pickup_longitude), data);
                        });
                        vm.filterData.dropLocationArray.forEach(function (data) {
                            data.type = 'drop';
                            createMarker(new google.maps.LatLng(data.job_latitude, data.job_longitude), data);
                        });
                    }
                    $scope.$digest();
                }
            }
        }


        //======================distance matrix only for getting eta==================
        function hitDistanceMatrixForGoogleMapsToAirport(type) {
            console.log("hitDistanceMatrixForGoogleMapsToAirport>>>>>>>>>>>>>>>>>>>>", type);

            directionsDisplay.setMap(map);
            directionsDisplay.setOptions({
                suppressMarkers: true
            });

            var promises = [];

            for (var i = 0; i < vm.filterData.makePackageList.length; i++) {
                var dataSend = {};
                if (i === vm.filterData.makePackageList.length - 1) {
                    // Último viaje, se dirige al destino final
                    dataSend.origin = Number(vm.filterData.makePackageList[i].job_pickup_latitude) + ',' + Number(vm.filterData.makePackageList[i].job_pickup_longitude);
                    dataSend.destination = Number(vm.filterData.makePackageList[i].job_latitude) + ',' + Number(vm.filterData.makePackageList[i].job_longitude);
                } else {
                    // Recoge al siguiente y se dirige al destino del siguiente
                    dataSend.origin = Number(vm.filterData.makePackageList[i].job_pickup_latitude) + ',' + Number(vm.filterData.makePackageList[i].job_pickup_longitude);
                    dataSend.destination = Number(vm.filterData.makePackageList[i + 1].job_pickup_latitude) + ',' + Number(vm.filterData.makePackageList[i + 1].job_pickup_longitude);
                }
                dataSend.departureTime = new Date().toISOString();

                var promise = sharedRouteAssignmentHereMaps.distanceMatricHereMapApiGroup(dataSend);
                promises.push(promise);
            }
            $q.all(promises).then(
                function (responses) {
                    for (var i = 0; i < responses.length; i++) {
                        var response = responses[i];
                        $log.log('sxdsads', response);
                        vm.loading = false;
                        vm.payloadResponse = JSON.parse(response.response);
            
                        // Reinicia los valores acumulados para cada viaje
                        var newEta = 0;
                        var distance = 0;
            
                        for (var x = vm.payloadResponse.routes[0].sections.length - 1; x >= 0; x--) {
                            newEta += Math.round(vm.payloadResponse.routes[0].sections[x].summary.duration / 60);
                            distance += Math.round(vm.payloadResponse.routes[0].sections[x].summary.length / 1000);
                        }
            
                        // Asigna los valores acumulados al viaje actual
                        if (type != 'modify') {
                            vm.filterData.makePackageList[i].newEta = newEta;
                        }
                        vm.filterData.makePackageList[i].distance = distance;
                    }
            
                    // Agrega un bucle para sumar la newEta al viaje anterior (excepto para el primer viaje)
                    for (var j = vm.filterData.makePackageList.length - 1; j > 0; j--) {
                        vm.filterData.makePackageList[j - 1].newEta += vm.filterData.makePackageList[j].newEta;
                    }
            
                    if (type != 'modify') {
                        toValidateAllBookings(vm.filterData.makePackageList, type);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        vm.picklatArray = [];
        vm.picklngArray = [];
        vm.droplatArray = [];
        vm.droplngArray = [];

        function hitDistanceMatrixForGoogleMapsFromAirport(type) {
            console.log("hitDistanceMatrixForGoogleMapsFromAirport>>>>>>>>>>>>>>");
            directionsDisplay.setMap(map);
            directionsDisplay.setOptions({
                suppressMarkers: true
            });
            var promises = [];

            for (var i = 0; i < vm.filterData.makePackageList.length; i++) {
                var dataSend = {};

                if (i === 0) {
                    // Primer viaje, toma el origen de la primera reserva
                    dataSend.origin = Number(vm.filterData.makePackageList[0].job_pickup_latitude) + ',' + Number(vm.filterData.makePackageList[0].job_pickup_longitude);
                } else {
                    // Recoge al siguiente y se dirige al destino del siguiente
                    dataSend.origin = Number(vm.filterData.makePackageList[i - 1].job_latitude) + ',' + Number(vm.filterData.makePackageList[i - 1].job_longitude);
                }
            
                // El destino es siempre el punto de entrega del viaje actual
                dataSend.destination = Number(vm.filterData.makePackageList[i].job_latitude) + ',' + Number(vm.filterData.makePackageList[i].job_longitude);
            
                dataSend.departureTime = new Date().toISOString();

                var promise = sharedRouteAssignmentHereMaps.distanceMatricHereMapApiGroup(dataSend);
                promises.push(promise);

            }
            $q.all(promises).then(
                function (responses) {
                    var totalEta = 0;
                    var totalDistance = 0;
            
                    for (var i = 0; i < responses.length; i++) {
                        var response = responses[i];
                        $log.log('sxdsads', response);
                        vm.loading = false;
                        vm.payloadResponse = JSON.parse(response.response);

                        // Reinicia los valores acumulados para cada viaje
                        var newEta = 0;
                        var distance = 0;

                        for (var x = vm.payloadResponse.routes[0].sections.length - 1; x >= 0; x--) {
                            newEta += Math.round(vm.payloadResponse.routes[0].sections[x].summary.duration / 60);
                            distance += Math.round(vm.payloadResponse.routes[0].sections[x].summary.length / 1000);
                        }

                        // Acumula los valores totales para todos los viajes
                        totalEta += newEta;
                        totalDistance += distance;

                        // Asigna los valores acumulados al viaje actual
                        if (type != 'modify') {
                            vm.filterData.makePackageList[i].newEta = totalEta;
                        }
                        vm.filterData.makePackageList[i].distance = totalDistance;

                        // Log para verificar los resultados
                        $log.log('Acumulado para el viaje ' + (i + 1) + ': newEta = ' + totalEta + ', distance = ' + totalDistance);
                    }
                    if (type != 'modify') {
                        toValidateAllBookings(vm.filterData.makePackageList, type);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        //===================validate all bookings========================
        function toValidateAllBookings(data, type) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.jobs = [];
            data.forEach(function (column) {
                dataSend.jobs.push({
                    job_id: column.job_id,
                    new_eta: column.newEta
                })
            });
            if (!vm.filterData.modifyFlag) {
                // dataSend.type_of_trip = vm.filterData.typeOfTrip;
                if (vm.sendCreatePackageTypeOfTrip && vm.sendCreatePackageTypeOfTrip == vm.filterData.typeOfTrip) {
                    dataSend.type_of_trip = vm.filterData.typeOfTrip;
                } else {
                    dataSend.type_of_trip = vm.sendCreatePackageTypeOfTrip;
                }
            } else {
                dataSend.type_of_trip = vm.filterData.typeOfTripModify;
            }
            if (vm.filterData.serviceDetailsSelected.id) {
                dataSend.type_of_service = vm.filterData.serviceDetailsSelected.id;
            } else {
                dataSend.type_of_service = JSON.parse($cookies.get("type_of_service"));
            }
            if (vm.filterData.modifyFlag)
                dataSend.shared_service_id = vm.packageData.shared_service_id;
            vm.loading = true;
            var promise = sharedRouteAssignment.validateSharedServices(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 200 || payload.title.status == 201) {
                        var msg = '<ul>';
                        if (!payload.title.data.is_valid_contract && type != 'checkAgain') {
                            msg += '<li>Agreement does not allow mixed service.</li>';
                            //errorMessageFactory.showErrorMessage('Agreement does not allow mixed service.',0);
                        }
                        if (!payload.title.data.is_valid_route_type && type != 'checkAgain') {
                            msg += '<li>Tipo de ruta es variable. No se puede hacer un servicio compartido.</li>';
                            //errorMessageFactory.showErrorMessage('Tipo de ruta es variable. No se puede hacer un servicio compartido.',0);
                        }
                        if (payload.title.data.invalid_pickup_bookings && payload.title.data.invalid_pickup_bookings.length && type != 'checkAgain') { //!payload.title.data.is_valid_pickup_time
                            msg += '<li>La hora de retiro para la reserva ya se cumplió</li>';
                            //var msg = 'La hora de retiro para la reserva #' + payload.title.data.invalid_pickup_bookings.join(',#') +' ya se cumplio';
                            //var msg = 'La hora de retiro para la reserva ya se cumplió';
                            //errorMessageFactory.showErrorMessage(msg,0);
                        }
                        if (!payload.title.data.is_valid_pax && type != 'checkAgain') {
                            msg += '<li>The total passenger of service exceed to passengers allowed to ' + vm.filterData.serviceDetailsSelected.name + '</li>';
                            //var msg = 'The total passenger of service exceed to passengers allowed to ' + vm.filterData.serviceDetailsSelected.name;
                            //errorMessageFactory.showErrorMessage(msg, 0);
                        }
                        msg += '</ul>';

                        if (msg.indexOf('<li>') > -1 && type != 'checkAgain') {
                            vm.items = {};
                            vm.items.msg = msg;
                            var parentEl = angular.element($document.body);
                            $mdDialog.show({
                                parent: parentEl,
                                targetEvent: parentEl,
                                templateUrl: 'app/components/dialogViews/sharedGroupedError.html',
                                bindToController: true,
                                locals: {
                                    items: vm.items
                                },
                                controller: ErrorControllerS
                            });

                            function ErrorControllerS($scope, $mdDialog, items) {
                                $scope.items = items;
                                $scope.closeDialog = function () {
                                    $mdDialog.hide();
                                }
                            }
                        }
                        toFilterArrays(payload.title.data, type);
                    } else if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        setFlagInJob(payload.title.data.job_id[0].job_id);
                        vm.filterData.makePackageList.splice(vm.ErrorData, 1);
                        vm.filterData.unassignedBookingList.push(vm.ErrorData);

                        var indexOfProblem = _.findIndex(vm.filterData.makePackageList, {
                            job_id: vm.newJobId
                        });
                        if (indexOfProblem > -1) {
                            var splicedBooking = vm.filterData.makePackageList.splice(indexOfProblem, 1)[0];
                            vm.filterData.unassignedBookingList.push(splicedBooking);
                        }
                        if (vm.filterData.unassignedBookingCountShow > 0) {
                            vm.filterData.unassignedBookingCount = vm.filterData.unassignedBookingCountShow - vm.filterData.makePackageList.length;
                        } else {
                            vm.filterData.unassignedBookingCount = vm.filterData.unassignedBookingCountShow + vm.filterData.makePackageList.length;
                        }
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        //======================make assignment with route======================
        function toFilterArrays(data, type) {
            if (data.is_valid_contract && data.is_valid_route_type && data.is_valid_pax) { //&& data.is_valid_pickup_time
                for (var i = 0; i < data.jobs.length; i++) {
                    for (var j = 0; j < vm.filterData.makePackageList.length; j++) {
                        if (vm.filterData.makePackageList[j].job_id == data.jobs[i].job_id) {
                            vm.filterData.makePackageList[j].is_valid_tolerance = data.jobs[i].is_valid_tolerance;
                            vm.filterData.makePackageList[j].job_dropoff_utc_new = data.jobs[i].temp_delivery_time;
                            vm.filterData.makePackageList[j].job_time_new = data.jobs[i].temp_pickup_time;
                            vm.filterData.makePackageList[j].newEta = data.jobs[i].temp_eta;
                        }
                    }
                }
                if (vm.filterData.unassignedBookingCountShow > 0) {
                    vm.filterData.unassignedBookingCount = vm.filterData.unassignedBookingCountShow - vm.filterData.makePackageList.length;
                } else {
                    vm.filterData.unassignedBookingCount = vm.filterData.unassignedBookingCountShow + vm.filterData.makePackageList.length;
                }
                changeAssignedData(type);
            }
            else {
                var indexOfProblem = _.findIndex(vm.filterData.makePackageList, {
                    job_id: vm.newJobId
                });
                if (indexOfProblem > -1) {
                    var splicedBooking = vm.filterData.makePackageList.splice(indexOfProblem, 1)[0];
                    vm.filterData.unassignedBookingList.push(splicedBooking);
                }
                for (var i = 0; i < data.jobs.length; i++) {
                    for (var j = 0; j < vm.filterData.makePackageList.length; j++) {
                        if (vm.filterData.makePackageList[j].job_id == data.jobs[i].job_id) {
                            vm.filterData.makePackageList[j].is_valid_tolerance = data.jobs[i].is_valid_tolerance;
                            vm.filterData.makePackageList[j].job_dropoff_utc_new = data.jobs[i].temp_delivery_time;
                            vm.filterData.makePackageList[j].job_time_new = data.jobs[i].temp_pickup_time;
                            vm.filterData.makePackageList[j].newEta = data.jobs[i].temp_eta;
                        }
                    }
                }
                if (vm.filterData.unassignedBookingCountShow > 0) {
                    vm.filterData.unassignedBookingCount = vm.filterData.unassignedBookingCountShow - vm.filterData.makePackageList.length;
                } else {
                    vm.filterData.unassignedBookingCount = vm.filterData.unassignedBookingCountShow + vm.filterData.makePackageList.length;
                }
                changeAssignedData(type);
            }
        }


        function changeAssignedData(type) {
            vm.filterData.totalPassengerAssigned = 0;
            vm.filterData.totalAssignedETA = 0;
            vm.filterData.totalBookingAssigned = 0;
            setMapOnAll(null, 'all');
            vm.filterData.unassignedBookingList.forEach(function (data) {
                data.job_pickup_datetime_filter = $filter('date')(data.original_pickup_datetime, "HH:mm");
                data.type = 'pickNotAssigned';
                data.text = 'Assign to Route';
                // data.is_valid_tolerance = true;
                data.distance = data.estimated_distance ? Math.round(data.estimated_distance / 1000) : 0;
                createMarker(new google.maps.LatLng(data.job_pickup_latitude, data.job_pickup_longitude), data);
            })
            vm.filterData.dropLocationArray.forEach(function (data) {
                data.type = 'drop';
                createMarker(new google.maps.LatLng(data.job_latitude, data.job_longitude), data);
            });
            if (vm.filterData.makePackageList && vm.filterData.makePackageList.length) {
                vm.filterData.totalAssignedETA = _.max(vm.filterData.makePackageList, function (x) {
                    return x.newEta;
                }).newEta;
                vm.filterData.makePackageList.forEach(function (data) {
                    vm.filterData.totalPassengerAssigned = vm.filterData.totalPassengerAssigned + Number(data.number_of_passangers);
                    vm.filterData.totalBookingAssigned = vm.filterData.totalBookingAssigned + 1;
                    data.job_pickup_datetime_filter = $filter('date')(data.original_pickup_datetime, "HH:mm");
                    //data.job_time_new = new Date(moment(new Date(data.job_dropoff_utc)).subtract(data.newEta * 60, 'seconds'));
                    data.job_pickup_datetime_filter_new = $filter('date')(data.job_time_new, "HH:mm");
                    data.type = 'pickAssigned';
                    data.text = '';
                    createMarker(new google.maps.LatLng(data.job_pickup_latitude, data.job_pickup_longitude), data);
                })
            } else {
                vm.filterData.totalPassengerAssigned = 0;
                vm.filterData.totalAssignedETA = 0;
                vm.filterData.totalBookingAssigned = 0;
            }
            if (vm.filterData.makePackageList.length) {
                if (!vm.filterData.modifyFlag) {
                    if (vm.filterData.typeOfTrip == 'R') {
                        if (type != 'checkAgain')
                            makePathFromGoogleToAirport();
                    } else if (vm.filterData.typeOfTrip == 'Z') {
                        if (type != 'checkAgain')
                            makePathFromGoogleFromAirport();
                    }
                } else {
                    if (vm.filterData.typeOfTripModify == 'R') {
                        if (type != 'checkAgain')
                            makePathFromGoogleToAirport();
                    } else if (vm.filterData.typeOfTripModify == 'Z') {
                        if (type != 'checkAgain')
                            makePathFromGoogleFromAirport();
                    }
                }
            } else {
                directionsDisplay.setMap(null);
            }
        }

        function makePathFromGoogleToAirport(type) {
            var waypts = [];
            if (vm.filterData.makePackageList.length > 1) {
                vm.filterData.makePackageList.forEach(function (data, index) {
                    if (index > 0) {
                        waypts.push({
                            location: new google.maps.LatLng(data.job_pickup_latitude, data.job_pickup_longitude),
                            stopover: true
                        })
                    }
                });
            }
            directionsDisplay.setMap(map);
            directionsDisplay.setOptions({
                suppressMarkers: true
            });
            var myLatlng = new google.maps.LatLng(vm.filterData.makePackageList[0].job_pickup_latitude, vm.filterData.makePackageList[0].job_pickup_longitude);
            var myLatlng1 = new google.maps.LatLng(vm.filterData.dropLocationArray[0].job_latitude, vm.filterData.dropLocationArray[0].job_longitude);
                    if (type != 'modify') {
                        // toValidateAllBookings(vm.filterData.makePackageList);
                        hitDistanceMatrixForGoogleMapsToAirport('checkAgain');
                    }
        }

        function makePathFromGoogleFromAirport(type) {
            var waypts = [];
            if (vm.filterData.makePackageList.length > 1) {
                vm.filterData.makePackageList.forEach(function (data, index) {
                    if (index < vm.filterData.makePackageList.length - 1) {
                        waypts.push({
                            location: new google.maps.LatLng(data.job_latitude, data.job_longitude),
                            stopover: true
                        })
                    }
                });
            }
            directionsDisplay.setMap(map);
            directionsDisplay.setOptions({
                suppressMarkers: true
            });
            var myLatlng = new google.maps.LatLng(vm.filterData.makePackageList[0].job_pickup_latitude, vm.filterData.makePackageList[0].job_pickup_longitude);
            var myLatlng1 = new google.maps.LatLng(vm.filterData.makePackageList[vm.filterData.makePackageList.length - 1].job_latitude, vm.filterData.makePackageList[vm.filterData.makePackageList.length - 1].job_longitude);
                    if (type != 'modify') {
                        // toValidateAllBookings(vm.filterData.makePackageList);
                        hitDistanceMatrixForGoogleMapsFromAirport('checkAgain');
                    }
        }

        //==================save shared package==================
        function saveSharedPackage() {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.jobs = [];
            vm.filterData.makePackageList.forEach(function (column) {
                dataSend.jobs.push({
                    job_id: column.job_id,
                    new_eta: column.newEta
                })
            })
            if (vm.sendCreatePackageTypeOfTrip && vm.sendCreatePackageTypeOfTrip == vm.filterData.typeOfTrip) {
                dataSend.type_of_trip = vm.filterData.typeOfTrip;
            } else {
                dataSend.type_of_trip = vm.sendCreatePackageTypeOfTrip;
            }
            // dataSend.type_of_service = vm.filterData.serviceDetailsSelected.id;
            if (vm.filterData.serviceDetailsSelected.id) {
                dataSend.type_of_service = vm.filterData.serviceDetailsSelected.id;
            } else {
                dataSend.type_of_service = JSON.parse($cookies.get("type_of_service"));
            }
            var promise = sharedRouteAssignment.sharedServicePackage(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        errorMessageFactory.showErrorMessage(
                            languageBasedErrorFactory.getProperErrorMessage('success_created_package', 0, 3), 0);
                        newPackage();
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        //=================make new package button======================
        function newPackage(type, dataToModify, packageData) {
            console.log(dataToModify, 'dataToModify');

            if (vm.filterData.makePackageList && vm.filterData.makePackageList.length) {
                var jobData = [];
                vm.filterData.makePackageList.forEach(function (d) {
                    jobData.push(d.job_id);
                })
                setFlagInJob(jobData);
            }
            vm.filterData.makePackageList = [];
            vm.filterData.dropLocationArray = [];
            vm.filterData.makePackageCount = 0;
            vm.filterData.totalPassengerAssigned = 0;
            vm.filterData.totalBookingAssigned = 0;
            vm.filterData.totalAssignedETA = 0;
            vm.filterData.unassignedSkip = 0;
            vm.filterData.unassignedLimit = 10;
            vm.filterData.unassignedLimitMade = 10;
            vm.filterData.sharedServiceName = 'NEW';
            vm.filterData.vehicleAssigned = 'PENDING';
            serviceChanged(0);
            applyFilter('modify');
            if (type == 'modify') {
                $timeout(function () {
                    makeDataForModification(dataToModify.title.data.data, packageData);
                }, 1000);
            }
        }



        //====================get shared package list=======================
        function getSharedPackageList(type, load, pickFromDate, pickToDate) {

            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.offset = vm.filterData.createdSkip;
            dataSend.limit = vm.filterData.createdLimit;
            dataSend.branch = vm.filterData.branch_value_package;
            dataSend.booking_type = 1;
            dataSend.type_of_trip = vm.filterData.typeOfTripPackage;
            vm.loading = load;
            if (vm.booking) {
                dataSend.booking_id = vm.booking;
            }
            if (vm.idPackete) {
                dataSend.package_id = vm.idPackete;
            }
            if (vm.vehicleSearch) {
                dataSend.vehicle_number = vm.vehicleSearch;
            }

            dataSend.type_of_service = vm.filterData.service_value_package;
            if (vm.filterData.aggrement_value_package != 'all')
                dataSend.contract_id = vm.filterData.aggrement_value_package;
            //else dataSend.contract_id = '';
            if (pickFromDate && pickToDate) {
                dataSend.from_pickup_datetime = pickFromDate.toISOString();
                dataSend.to_pickup_datetime = pickToDate.toISOString();
            }

            var promise = sharedRouteAssignment.getSharedPackageBookingsList(dataSend);
            promise.then(
                function (payload) {
                    $log.log('getlist', payload);
                    vm.loading = false;
                    vm.filterData.createdBookingCount = payload.title.data.count;
                    if (payload.title && payload.title.data && payload.title.data.data)
                        if (type == 'scroll') {
                            for (var i = 0; i < payload.title.data.data.length; i++) {
                                vm.filterData.createdBookingList.push(payload.title.data.data[i]);
                            }
                        } else if (type == 'noScroll') {
                        for (var i = 0; i < payload.title.data.data.length; i++) {
                            var indexOfBookings = _.findIndex(vm.filterData.createdBookingList, {
                                shared_service_id: payload.title.data.data[i].shared_service_id
                            });
                            if (indexOfBookings == -1)
                                vm.filterData.createdBookingList.push(payload.title.data.data[i]);
                        }
                    } else {
                        vm.filterData.createdBookingList = payload.title.data.data;
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        //======================assign bookings=================
        function assignBookings(data, $event) {
            var dataSend = {
                access_token: $cookies.get('obj'),
                shared_service_id: Number(data.shared_service_id),
                limit: 10,
                offset: 0,
                all_vehicles_flag: 0,
                item: '',
                search_id: '',
                key: 0,
            };
            vm.loading = true;
            var promise = sharedRouteAssignment.getAvailableDriverForShared(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.arrayToshow = [];
                    // vm.exclude_car_id = _.uniq(payload.title.data.exclude_car_id);
                    for (var i = 0; i < payload.title.data.result.length; i++) {
                        var d = {};
                        d.unique_car_id = payload.title.data.result[i].unique_car_id;
                        d.last_name = payload.title.data.result[i].last_name;
                        d.first_name = payload.title.data.result[i].first_name;
                        d.phone = payload.title.data.result[i].phone;
                        d.country_code = payload.title.data.result[i].country_code;
                        d.is_available = payload.title.data.result[i].is_available;
                        d.name = payload.title.data.result[i].name;
                        d.status = payload.title.data.result[i].status;
                        d.job_status = payload.title.data.result[i].job_status;
                        d.limit = payload.title.data.limit;
                        d.fleet_id = payload.title.data.result[i].fleet_id;
                        d.off = payload.title.data.result[i].off ? payload.title.data.result[i].off : false;
                        // d.showFlag = vm.exclude_car_id.includes(payload.title.data.result[i].unique_car_id);
                        d.totalCount = payload.title.data.totalCount;
                        vm.arrayToshow.push(d);
                    }
                    openPopUpForAssignment(vm.arrayToshow, $event, data);
                    //driverGetFromManual(payload, $event, data);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function openPopUpForAssignment(data, $event, jobData) {
            vm.items = {
                allDrivers: data,
                selectedDriver: {},
                ShiftErrMsg: '',
                shared_service_id: jobData.shared_service_id,
                jobData: jobData,
                limit: data.length > 0 ? data[0].limit : 10,
                offset: 0,
                total: data.length > 0 ? data[0].totalCount : 10,
                searchDriver: '',
                searchDriverbyVehicleId: '',
                onOffDuty: '0',
                allVehicle: '0',
                // onOffDuty: '0',
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/assignDriverToSharedService.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: AssignDriverDialogController
            });

            function AssignDriverDialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    if ($scope.items.selectedDriver.fleet_id) {
                        //finalSelectedDriverApi($scope.items);
                        checkBeforeAssignDriver($scope.items, $event);
                        $mdDialog.hide();
                    } else {
                        $scope.items.ShiftErrMsg = languageBasedErrorFactory.getProperErrorMessage('assignPopError', 0, '3');
                        $timeout(function () {
                            $scope.items.ShiftErrMsg = '';
                        }, 2000);
                    }
                };
                $scope.selectDriver = function (data) {
                    $log.log(data);
                    $scope.items.selectedDriver = data;
                };
                var filterTextTimeout = '';
                $scope.getAssignDriverSearch = function (data) {
                    $scope.items.offset = 0;
                    if (data && data.length) {
                        if (filterTextTimeout) $timeout.cancel(filterTextTimeout);
                        filterTextTimeout = $timeout(function () {
                            $scope.getDataDriver('search');
                        }, 500);
                    } else {
                        $scope.items.allDrivers = [];
                        $scope.getDataDriver();
                    }
                };

                $scope.paginationFunction = function () {
                    if ($scope.items.allDrivers.length == $scope.items.total) {
                        return;
                    }
                    $scope.items.offset = $scope.items.offset + 10;
                    $scope.getDataDriver();
                };

                $scope.getDataDriverChange = function () {
                    $scope.items.allDrivers = [];
                    $scope.items.offset = 0;
                    $scope.getDataDriver();
                }

                $scope.getDataDriverChange1 = function () {
                    $scope.items.allDrivers = [];
                    $scope.items.offset = 0;
                    $scope.getDataDriver();
                }

                $scope.getDataDriver = function (type) {
                    var dataSend = {
                        access_token: $cookies.get('obj'),
                        shared_service_id: Number(jobData.shared_service_id),
                        limit: $scope.items.limit,
                        offset: $scope.items.offset,
                        item: $scope.items.searchDriver ? $scope.items.searchDriver : '',
                        search_id: $scope.items.searchDriverbyVehicleId ? $scope.items.searchDriverbyVehicleId : '',
                        key: $scope.items.onOffDuty,
                        all_vehicles_flag: $scope.items.allVehicle,
                        // key:  $scope.items.onOffDuty
                    };
                    vm.loading = true;
                    var promise = sharedRouteAssignment.getAvailableDriverForShared(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            vm.loading = false;
                            $scope.items.total = payload.title.data.totalCount;
                            if (type == 'search') {
                                // $scope.items.allDrivers = payload.title.data.result;
                                $scope.items.allDrivers = [];
                                // vm.exclude_car_id = payload.title.data.exclude_car_id;
                                for (var i = 0; i < payload.title.data.result.length; i++) {
                                    var d = {};
                                    d.unique_car_id = payload.title.data.result[i].unique_car_id;
                                    d.last_name = payload.title.data.result[i].last_name;
                                    d.first_name = payload.title.data.result[i].first_name;
                                    d.phone = payload.title.data.result[i].phone;
                                    d.country_code = payload.title.data.result[i].country_code;
                                    d.is_available = payload.title.data.result[i].is_available;
                                    d.name = payload.title.data.result[i].name;
                                    d.status = payload.title.data.result[i].status;
                                    d.job_status = payload.title.data.result[i].job_status;
                                    d.limit = payload.title.data.limit;
                                    d.fleet_id = payload.title.data.result[i].fleet_id;
                                    d.off = payload.title.data.result[i].off ? payload.title.data.result[i].off : false;
                                    // d.showFlag = vm.exclude_car_id.includes(payload.title.data.result[i].unique_car_id);
                                    d.totalCount = payload.title.data.totalCount;
                                    $scope.items.allDrivers.push(d);
                                }
                            } else {
                                // vm.exclude_car_id = payload.title.data.exclude_car_id;
                                for (var i = 0; i < payload.title.data.result.length; i++) {
                                    var d = {};
                                    d.unique_car_id = payload.title.data.result[i].unique_car_id;
                                    d.last_name = payload.title.data.result[i].last_name;
                                    d.first_name = payload.title.data.result[i].first_name;
                                    d.phone = payload.title.data.result[i].phone;
                                    d.country_code = payload.title.data.result[i].country_code;
                                    d.is_available = payload.title.data.result[i].is_available;
                                    d.name = payload.title.data.result[i].name;
                                    d.fleet_id = payload.title.data.result[i].fleet_id;
                                    d.status = payload.title.data.result[i].status;
                                    d.job_status = payload.title.data.result[i].job_status;
                                    d.limit = payload.title.data.limit;
                                    d.off = payload.title.data.result[i].off ? payload.title.data.result[i].off : false;
                                    // d.showFlag = vm.exclude_car_id.includes(payload.title.data.result[i].unique_car_id);
                                    d.totalCount = payload.title.data.totalCount;
                                    $scope.items.allDrivers.push(d);
                                }
                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }
            }
        }

        function checkBeforeAssignDriver(data, $event) {
            var dataSend = {
                access_token: $cookies.get('obj'),
                group_id: Number(data.shared_service_id),
                fleet_id: Number(data.selectedDriver.fleet_id)
            };
            vm.loading = true;
            var promise = sharedRouteAssignment.checkDriverStatusForShared(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        checkDriverPop(payload.title, data, $event);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        finalSelectedDriverApi(data);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        checkDriverPop(errorPayload.data.message, data, $event);
                    }
                }
            );
        }

        function checkDriverPop(msg, data, $event) {
            vm.items = {};
            vm.items.data = msg.data.final_response;
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/manualAssignErrors.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: ErrorDialogController
            });

            function ErrorDialogController($scope, items, $mdDialog) {
                $scope.items = items;

                $scope.confirmDialog = function () {
                    $mdDialog.hide();
                    finalSelectedDriverApi(data);
                }
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                }
            }

            //var confirm = $mdDialog.confirm()
            //    .title(msg)
            //    .textContent('')
            //    .ariaLabel('Lucky day')
            //    .targetEvent($event)
            //    .ok('CONTINUE')
            //    .cancel('CANCEL');
            //
            //$mdDialog.show(confirm).then(function () {
            //    finalSelectedDriverApi(data);
            //}, function () {
            //    $log.log('not confirmed');
            //});
        };

        function finalSelectedDriverApi(data) {
            $log.log(data);
            var dataSend = {
                access_token: $cookies.get('obj'),
                shared_service_id: Number(data.shared_service_id),
                fleet_id: Number(data.selectedDriver.fleet_id),
                booking_type: 1
            };
            vm.loading = true;
            vm.fun = false;
            var promise = sharedRouteAssignment.manualAssignBookingToFleet(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        // languageBasedErrorFactory.getProperErrorMessage('driverAssignedSucc', 0, 0);
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        languageBasedErrorFactory.getProperErrorMessage('driverAssignedSucc', 0, 0);
                        vm.filterData.createdSkip = 0;
                        vm.filterData.createdLimit = 15;
                        vm.filterData.createdBookingList = [];
                        if (vm.filterData.filter_pickup_from_date_value_package && vm.filterData.filter_pickup_from_time_value_package) {
                            var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value_package, vm.filterData.filter_pickup_from_time_value_package);
                        }
                        if (vm.filterData.filter_pickup_to_date_value_package && vm.filterData.filter_pickup_to_time_value_package) {
                            var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value_package, vm.filterData.filter_pickup_to_time_value_package);
                        }
                        getSharedPackageList('noScroll', false, pickFromDate, pickToDate);


                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };



        // =========================== delete Booking ===========================
        function deleteBooking(data, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('deletePackagePop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));
            $mdDialog.show(confirm).then(function () {
                var dataSend = {};
                vm.fun = true;
                dataSend.access_token = $cookies.get('obj');
                dataSend.package_id = data.shared_service_id;
                var promise = sharedRouteAssignment.deletePackageBooking(dataSend);
                promise.then(
                    function (payload) {
                        if (payload.title.status == 200) {
                            $log.log('sxdsads', payload);
                            vm.loading = false;
                            newPackage();
                            if (vm.filterData.filter_pickup_from_date_value_package && vm.filterData.filter_pickup_from_time_value_package) {
                                var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value_package, vm.filterData.filter_pickup_from_time_value_package);
                            }
                            if (vm.filterData.filter_pickup_to_date_value_package && vm.filterData.filter_pickup_to_time_value_package) {
                                var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value_package, vm.filterData.filter_pickup_to_time_value_package);
                            }
                            getSharedPackageList('noScroll', false, pickFromDate, pickToDate);
                        } else {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        }
        // =========================== delete Booking ===========================

        //=============================unassign booking==========================
        function unassignBooking(data, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('unassginPop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                var dataSend = {};
                vm.fun = true;
                dataSend.access_token = $cookies.get('obj');
                dataSend.shared_service_id = Number(data.shared_service_id);
                dataSend.booking_type = 1;
                vm.loading = true;
                var promise = sharedRouteAssignment.manualUnassignBookingToFleet(dataSend);
                promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        if (payload.title.status == 400) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2);
                        } else if (payload.title.status == 200) {
                            languageBasedErrorFactory.getProperErrorMessage('unassginSucc', 0, 0);
                            vm.filterData.createdSkip = 0;
                            vm.filterData.createdLimit = 15;
                            vm.filterData.createdBookingList = [];
                            if (vm.filterData.filter_pickup_from_date_value_package && vm.filterData.filter_pickup_from_time_value_package) {
                                var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value_package, vm.filterData.filter_pickup_from_time_value_package);
                            }
                            if (vm.filterData.filter_pickup_to_date_value_package && vm.filterData.filter_pickup_to_time_value_package) {
                                var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value_package, vm.filterData.filter_pickup_to_time_value_package);
                            }
                            getSharedPackageList('noScroll', false, pickFromDate, pickToDate);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        }

        //===============modify booking====================
        function modifyBooking(data, type) {
            if (type == 'edit') {
                vm.showButtonSave = false;
            } else {
                vm.showButtonSave = true;
            }
            vm.bookingsAssignmentTab = true;
            vm.servicesCreatedTab = false;
            var firstBookingDate = new Date(data.first_pickup_time).getDate();
            var firstBookingMonth = new Date(data.first_pickup_time).getMonth();
            var firstBookingYear = new Date(data.first_pickup_time).getFullYear();
            //if((firstBookingDate < new Date().getDate()) || (firstBookingMonth < new Date().getMonth()) || (firstBookingYear < new Date().getFullYear())){
            //    errorMessageFactory.showErrorMessage('You can not modify this package', 0);
            //    return;
            //}

            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.shared_service_id = Number(data.shared_service_id);
            dataSend.booking_type = 1;
            vm.loading = true;
            var promise = sharedRouteAssignment.getPackageDetails(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.packageData = data;
                    newPackage('modify', payload, data);
                    vm.checkClickedPackage = false;
                    $('#packageFilter').hide();
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        //=======================make data for modification=====================
        function makeDataForModification(data, packageData) {
            vm.filterData.modifyFlag = true;
            vm.filterData.sharedServiceName = packageData.shared_service_id;
            vm.filterData.vehicleAssigned = packageData.unique_car_id ? packageData.unique_car_id : 'PENDING';
            vm.filterData.serviceDetailsSelected = _.where(vm.service, {
                id: data[0].type_of_service
            })[0];
            vm.filterData.totalAssignedETA = _.max(data, function (x) {
                return x.eta;
            }).eta;
            data.forEach(function (column, index) {
                vm.filterData.totalPassengerAssigned = vm.filterData.totalPassengerAssigned + column.number_of_passangers;
                vm.filterData.totalBookingAssigned = vm.filterData.totalBookingAssigned + 1;

                //column.is_valid_tolerance = true;
                column.greater_delivery_time = false;
                column.job_dropoff_utc_new = new Date(column.job_delivery_datetime);
                column.newEta = column.temp_eta;
                column.newDataEta = column.temp_eta;
                column.job_time_new = column.temp_pickup_time;
                column.job_pickup_datetime_filter = $filter('date')(column.original_pickup_datetime, "HH:mm");
                //data.job_time_new = new Date(moment(new Date(data.job_dropoff_utc)).subtract(data.newEta * 60, 'seconds'));
                column.job_pickup_datetime_filter_new = $filter('date')(column.job_time_new, "HH:mm");
                if (column.job_status == 1 || column.job_status == 2) {
                    column.type = 'pickAssigned';
                } else {
                    column.type = 'pickStarted';
                }
                vm.filterData.typeOfTripModify = column.type_of_trip;
                column.text = '';
                vm.filterData.makePackageList.push(column);
                createMarker(new google.maps.LatLng(Number(column.job_pickup_latitude), Number(column.job_pickup_longitude)), column);
            });

            vm.filterData.dropLocationArray = _.uniq(vm.filterData.makePackageList, function (x) {
                return x.job_latitude && x.job_longitude;
            });
            if (vm.filterData.dropLocationArray.length) {
                vm.filterData.dropLocationArray.forEach(function (data) {
                    data.type = 'drop';
                    createMarker(new google.maps.LatLng(data.job_latitude, data.job_longitude), data);
                })
            }

            if (vm.filterData.typeOfTripModify == 'R') {
                //setMapOnAll(null,'all');
                hitDistanceMatrixForGoogleMapsToAirport('modify');
                makePathFromGoogleToAirport('modify');
            } else if (vm.filterData.typeOfTripModify == 'Z') {
                //setMapOnAll(null,'all');
                hitDistanceMatrixForGoogleMapsFromAirport('modify');
                makePathFromGoogleFromAirport('modify');
            }
        }

        //==================modification api========================
        function saveModifySharedPackage() {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.jobs = [];
            vm.filterData.makePackageList.forEach(function (column) {
                dataSend.jobs.push({
                    job_id: column.job_id,
                    new_eta: column.newEta
                })
            })
            dataSend.type_of_service = vm.filterData.serviceDetailsSelected.id;
            dataSend.shared_service_id = vm.packageData.shared_service_id;
            dataSend.type_of_trip = vm.filterData.typeOfTripModify;
            var promise = sharedRouteAssignment.modifySharedService(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    errorMessageFactory.showErrorMessage(
                        languageBasedErrorFactory.getProperErrorMessage('success_update_package', 0, 3), 0);
                    vm.filterData.createdSkip = 0;
                    vm.filterData.createdLimit = 15;
                    vm.packageData = '';
                    if (vm.filterData.filter_pickup_from_date_value_package && vm.filterData.filter_pickup_from_time_value_package) {
                        var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value_package, vm.filterData.filter_pickup_from_time_value_package);
                    }
                    if (vm.filterData.filter_pickup_to_date_value_package && vm.filterData.filter_pickup_to_time_value_package) {
                        var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value_package, vm.filterData.filter_pickup_to_time_value_package);
                    }
                    getSharedPackageList('noScroll', false, pickFromDate, pickToDate);
                    newPackage();
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function serviceFilterData() {
            $timeout.cancel(vm.yourTimer);
            vm.yourTimer = $timeout(function () {
                vm.loading = true;
                vm.filterData.createdBookingList = [];
                vm.filterData.createdSkip = 0;
                vm.filterData.createdLimit = 10;
                if (vm.filterData.filter_pickup_from_date_value_package && vm.filterData.filter_pickup_from_time_value_package) {
                    var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value_package, vm.filterData.filter_pickup_from_time_value_package);
                }
                if (vm.filterData.filter_pickup_to_date_value_package && vm.filterData.filter_pickup_to_time_value_package) {
                    var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value_package, vm.filterData.filter_pickup_to_time_value_package);
                }
                getSharedPackageList('scroll', true, pickFromDate, pickToDate);
            }, 1000);
        }

        function getPackageSection(value) {
            if (value) {
                vm.checkClickedPackage = false;
                $('#packageFilter').hide();
            }
        }

        function clickOk() {
            vm.filterData.makePackageList = [];
            vm.filterData.sharedServiceName = 'NEW';
            vm.maxForShow = $cookies.get('type_of_service.max');
            vm.filterData.totalAssignedETA = 0;
            vm.filterData.totalBookingAssigned = 0;
            vm.filterData.totalPassengerAssigned = 0;
            vm.filterData.sharedServiceName = 'NEW';
            vm.filterData.vehicleAssigned = 'PENDING';
            vm.filterData.modifyFlag = false;
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('RejectedBookingController', RejectedBookingController);

    /** @ngInject */
    function RejectedBookingController($cookies, $state, $log, $rootScope, $stateParams, $mdDialog, $timeout, $document, generatePaymentStatus, getGeofence, getServices, $scope, filterFilter, languageBasedErrorFactory, errorMessageFactory, getFilters) {
        var vm = this;
        vm.loading = false;
        vm.currentPage = 0;
        vm.totalBins = 0;
        vm.skipValueFilter = 0;
        vm.dataLength = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = false;
        vm.tFootFlag = true;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.servicesList = [];
        vm.servicesList.push({
            id: 'all',
            name: 'All'
        })
        vm.predicate = 'index';
        vm.reverse = false;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.getPagesCount = getPagesCount;
        vm.paginationNew = paginationNew;
        vm.getRejectedBooking = getRejectedBooking;
        vm.onFilterChange = onFilterChange;
        vm.exportToCSV = exportToCSV;
        vm.applyFilter = applyFilter;
        vm.dataToFill = {
            from: new Date(moment(new Date()).startOf('day')._d.toUTCString()),
            untill: new Date(moment(new Date()).endOf('day')._d.toUTCString()),
            branch: '',
            typeOfService: '',
            vehicle_number: ''
        };

        vm.dateOptionsFrom = {};
        vm.dateOptionsUntill = {};
        vm.datePicker_1 = {
            from: false,
            untill: false
        };
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.altInputFormats = ['M!/d!/yyyy'];
        vm.datePickerE_1 = datePickerE_1;

        vm.paginationChangedForService = paginationChangedForService;
        vm.paginationChangedForBranch = paginationChangedForBranch;

        vm.serviceSearch = serviceSearch;
        vm.branchSearch = branchSearch;

        vm.globalLimit = 10;
        vm.globalOffset = vm.globalLimit;

        vm.servicesList = [];

        vm.branchList = [];

        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'vehicle', 'servicesList', 'agreement', 'corporatesList', 'operation_point'];

        vm.serviceOffset = 0;
        vm.branchOffset = 0;

        // =================== FILTER OBJECT ===================
        vm.filterObject = {
            access_token: $cookies.get('obj'),
            branch_filter: 1,
            vehicle_filter: 0,
            service_filter: 1,
            agreement_filter: 0,
            corporate_filter: 0,
            service_category: 0,
            corporate_status: 0,
            agreement_status: 0,
            vehicle__status: 0,
            operation_point_filter: 0,
            service_limit: vm.globalLimit,
            service_offset: vm.serviceOffset,
            branch_limit: vm.globalLimit,
            branch_offset: vm.branchOffset,
            branch_search_filter: 0,
            vehicle_search_filter: 0,
            service_search_filter: 0,
            agreement_search_filter: 0,
            corporate_search_filter: 0,
            operation_point_search_filter: 0
        }

        setTimeout(function () {
            document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                // if (vm.branchList && (vm.branchList.length == 0)) {
                vm.searchBranchData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

            document.getElementsByClassName('ui-select-search')[1].addEventListener('blur', function ($event) {
                // if (vm.servicesList && (vm.servicesList.length == 0)) {
                vm.searchServiceData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

        })

        // =================== GET FILTER DATA ===================
        function getFilterDataFromBackend(data, type) { //Acc to Index ['branch_search', 'vehicle_search', 'service_search', 'agreement_search', 'corporate_search', 'operation_point_search']
            if (data) {
                vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
            } else {
                vm.filterObject = {
                    access_token: $cookies.get('obj'),
                    branch_filter: 1,
                    vehicle_filter: 0,
                    service_filter: 1,
                    agreement_filter: 0,
                    corporate_filter: 0,
                    service_category: 0,
                    corporate_status: 0,
                    agreement_status: 2,
                    vehicle__status: 2,
                    operation_point_filter: 0,
                    branch_search_filter: 0,
                    vehicle_search_filter: 0,
                    service_search_filter: 0,
                    agreement_search_filter: 0,
                    corporate_search_filter: 0,
                    operation_point_search_filter: 0
                }
            }

            vm.filterObject.service_limit = vm.globalLimit;
            vm.filterObject.service_offset = vm.serviceOffset;
            vm.filterObject.branch_limit = vm.globalLimit;
            vm.filterObject.branch_offset = vm.branchOffset;

            var promise = getFilters.getAllFilterData(vm.filterObject);
            promise.then(
                function (payload) {

                    // ********** BRANCH DATA ********
                    if (payload.title.data.branches) {

                        angular.forEach(payload.title.data.branches.data, function (column) {
                            var branchIndex = _.findIndex(vm.branchList, {
                                region_id: column.region_id
                            });
                            if (branchIndex == -1)
                                vm.branchList.push(column)

                        });
                        vm.branchTotalBackendCount = payload.title.data.branches.totalCount;
                    }
                    // *********** SERVICE DATA *********
                    if (payload.title.data.services) {

                        vm.serviceTotalBackendCount = payload.title.data.services.totalCount;
                        angular.forEach(payload.title.data.services.data, function (column) {
                            // vm.servicesList.push({
                            //     id: column.id,
                            //     name: column.service_name
                            // });
                            var serviceIndex = _.findIndex(vm.servicesList, {
                                id: column.id
                            });
                            if (serviceIndex == -1)
                                vm.servicesList.push({
                                    id: column.id,
                                    name: column.service_name
                                })

                        });
                    }

                    vm.loading = false;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        }
        getFilterDataFromBackend();


        // ************ PAGINATION ON SERIVCE **************
        function paginationChangedForService() {
            var index = _.findIndex(vm[vm.searchFilterArray[2]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.serviceTotalBackendCount > (vm.servicesList.length - index)) {
                commonFunction(2);
                vm.serviceOffset += 10;
                getFilterDataFromBackend(vm.searchServiceData, 2);
            }
        }

        // ************ PAGINATION ON BRANCH **************
        function paginationChangedForBranch() {
            var index = _.findIndex(vm[vm.searchFilterArray[0]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.branchTotalBackendCount > (vm.branchList.length - index)) {
                commonFunction(0);
                vm.branchOffset += 10;
                getFilterDataFromBackend(vm.searchBranchData, 0);
            }
        }

        // *********** COMMON FUNCTION FOR FILTER PAGINATION AND SEARCHING ***********
        function commonFunction(type, mode) {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                // vm['search' + vm.searchFilterArray[i] + 'Data'] = '';
                if (mode == 'search' || i != type) {
                    vm[vm.searchFilterArrayForClearArray[i]] = [];
                    vm[vm.searchFilterArray[i] + 'Offset'] = 0;
                    vm['search' + vm.searchFilterArray[i].substring(0, 1).toUpperCase() + vm.searchFilterArray[i].substring(1) + 'Data'] = '';
                }
            }
        }

        // ************ SEARCH SERVICE ***************
        function serviceSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchServiceData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(2, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 2);
                }, 2000);
            }
        }

        // ************ SEARCH BRANCH ***************
        function branchSearch(data, branch) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchBranchData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(0, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 0);
                }, 2000);
            }
        }

        //==================date picker function==================
        vm.dateOptionsFrom = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(),
            //minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };
        vm.dateOptionsUntill = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(),
            //minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };

        function datePickerE_1(type) {
            if (type == '1') {
                vm.datePicker_1.from = true;
                vm.datePicker_1.untill = false;
            } else if (type == '2') {
                vm.datePicker_1.untill = true;
                vm.datePicker_1.from = false;
            }
        };

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            if (data.data) {
                $state.reload('layout.rejectedBookingMain.rejectedBooking');
            }
        });

        //====================function for dropdown pages and page count===============
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];

        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getRejectedBooking(0, vm.itemsPerPageGot);
        };

        function paginationNew(page) {
            getRejectedBooking((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot);
        }

        //==============get all services=================
        // function getAllServices() {
        //     vm.servicesList = [];
        //     vm.servicesList = getFilters.servicesFiltersData.data;

        // vm.loading = true;
        // var promise = getServices.allServices(0, 0, 2);
        // promise.then(
        //     function (payload) {
        //         vm.loading = false;
        //         if (payload.title.status == 400) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //         } else if (payload.title.status == 401) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //         } else if (payload.title.status == 201 || payload.title.status == 200) {
        //             vm.servicesList = _.where(payload.title.data.result, {
        //                 status: 1
        //             });
        //         }
        //     },
        //     function (errorPayload) {
        // vm.loading = false;
        //         if (errorPayload.data.status == 401) {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //         } else {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //         }
        //     }
        // );
        // };
        // WHen Page refresh service take time to get data from backend
        // setTimeout(function () {
        //     getAllServices();
        // }, 1000);

        //====================get branch list====================
        // function getBranch() {
        //     vm.branchList = [];
        //     vm.branchList = getFilters.branchesFiltersData.data;

        // vm.loading = true;
        // var promise = getGeofence.branch();
        // promise.then(
        //     function (payload) {
        //         $log.log('branch', payload);
        //         vm.loading = false;
        //         if(payload.title.status == 400){
        //             errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //         }
        //         else if(payload.title.status == 401){
        //             errorMessageFactory.showErrorMessage(payload.title.message,2,'home');
        //         }
        //         else if(payload.title.status == 201 || payload.title.status == 200) {
        //             var where = _.where(payload.title.data, {is_active: 1});
        //             vm.branchList = _.where(where, {parent_id: 0});
        //         }
        //     },
        //     function (errorPayload) {
        //         $log.log(errorPayload);
        //         vm.loading = false;
        //         if (errorPayload.data.status == 401) {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //         }
        //         else {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //         }
        //     }
        // );
        // }
        // WHen Page refresh service take time to get data from backend
        // setTimeout(function () {
        //     getBranch();
        // }, 1000);

        //========================get rejected bookings hit=======================
        function getRejectedBooking(skip, limit, data) {


            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.offset = skip;
            dataSend.limit = limit;
            dataSend.start_date = vm.dataToFill.from;
            dataSend.end_date = vm.dataToFill.untill;

            if (vm.dataToFill.branch) {
                dataSend.branch = data.branch;
            }
            if (vm.dataToFill.typeOfService) {
                dataSend.service = data.typeOfService;
            }
            if (vm.dataToFill.vehicle_number) {
                dataSend.unique_car_id = data.vehicle_number;
            }

            vm.loading = true;
            var promise = generatePaymentStatus.getRejectLogs(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.totalBookings = payload.title.data.totalCount;
                    vm.dataLength = payload.title.data.totalCount;

                    if (payload.title.data.totalCount == 0) {
                        vm.sp_pagination = false;
                        vm.tBodyFlag = false;
                        vm.tFootFlag = true;
                        vm.filterOn = true;
                        vm.skipValueFilter = 0;
                    } else {
                        vm.sp_pagination = true;
                        vm.tBodyFlag = true;
                        vm.tFootFlag = false;
                        vm.filterOn = false;
                        vm.skipValueFilter = 0;


                        var dataArray = [];
                        var rejectedList = payload.title.data.result;
                        rejectedList.forEach(function (column) {
                            var d = {};
                            d.region_name = column.region_name;
                            d.unique_car_id = column.unique_car_id;
                            d.driver_name = column.driver_name;
                            d.car_status = column.car_status;
                            d.job_id = column.job_id;
                            d.service_name = column.service_name;
                            d.name = column.name;
                            d.retiro_datetime = column.retiro_datetime;
                            d.type_of_trip = column.type_of_trip;
                            d.estimated_cost = column.estimated_cost;
                            d.is_rejected = column.is_rejected;
                            d.is_missed = column.is_missed;
                            dataArray.push(d);
                        });
                        vm.rejectedBookings = dataArray;
                        for (var i = 0; i < vm.rejectedBookings.length; i++) {
                            vm.rejectedBookings[i].index = (skip + i);
                        }
                        if (vm.dataLength <= vm.itemsPerPageGot) {
                            vm.sp_pagination = false;
                        } else {
                            vm.sp_pagination = true;
                            //vm.pageCount(payload.title.totalCount);
                        }
                        vm.skipValue = vm.rejectedBookings[0].index;
                        vm.limitValue = vm.rejectedBookings[vm.rejectedBookings.length - 1].index;

                        $scope.$watch('vm.search', function (newVal, oldVal) {
                            vm.filtered = filterFilter(vm.rejectedBookings, newVal);
                            vm.totalItems = vm.filtered.length;
                            if (vm.filtered.length == 0) {
                                vm.watchPagination = false;
                            } else {
                                vm.watchPagination = true;
                            }
                            if (vm.filterOn == true) {
                                vm.skipValueFilter = vm.filtered.length;
                                vm.sp_pagination = false;
                            }
                        }, true);

                        //range();
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };

        function init() {
            vm.getRejectedBooking(0, vm.searchModel.limit);
        };
        init();

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            vm.filterOn = true;
            if (vm.search.length == 0) {
                vm.filterOn = false;
                vm.watchPagination = true;
                vm.sp_pagination = true;
            }
        };

        //==============Function for on change of filters==============

        function onFilterChange() {
            if (vm.dataToFill.from > vm.dataToFill.untill) {
                errorMessageFactory.showErrorMessage('Desde la fecha no puede ser mayor que la fecha de finalización', 0);
                vm.dataToFill.from = new Date(moment(new Date()).startOf('day')._d.toUTCString());
                vm.dataToFill.untill = new Date(moment(new Date()).endOf('day')._d.toUTCString());
                return;
            }
            // getRejectedBooking(0, vm.itemsPerPageGot, vm.dataToFill)
        }

        function applyFilter(){
            getRejectedBooking(0, vm.itemsPerPageGot, vm.dataToFill)
        }
        // ******** CLEAR OFFSET *******
        function clearOffset() {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                vm[vm.searchFilterArray[i] + 'Offset'] = 0;
            }
        }

        //=========CSV Download ================
        function exportToCSV(s, l) {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.offset = s;
            dataSend.limit = l;
            dataSend.start_date = vm.dataToFill.from;
            dataSend.end_date = vm.dataToFill.untill;

            var promise = generatePaymentStatus.getRejectLogs(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.agreement = [];
                    vm.branchList = [];
                    vm.vehicle = [];
                    vm.service = [];
                    clearOffset();
                    getFilterDataFromBackend();
                    var dataArrayE = [];
                    var rejectedListExport = payload.title.data.result;
                    rejectedListExport.forEach(function (column) {
                        var d = {};
                        d['Sucursal'] = column.region_name;
                        d['Vehículo'] = column.unique_car_id;
                        d['Conductor'] = column.driver_name;
                        d['Estado del vehículo al rechazar'] = column.car_status;
                        d['Reserva'] = column.job_id;
                        d['Tipo Servicio'] = column.service_name;
                        d['Convenio'] = column.name;
                        d['Retiro'] = moment(column.retiro_datetime).format('DD/MM/YY HH:mm');
                        d['Tipo Viaje'] = column.type_of_trip;
                        d['Tarifa Estimada'] = column.estimated_cost;
                        if(column.is_rejected  == 0 && column.is_missed == 1){
                            d['Acción']  = 'Omitido';
                        }else if(column.is_rejected  == 1 && column.is_missed == 0){
                            d['Acción']  = 'Rechazado';
                        }else{
                            d['Acción']  = 'Aceptado';
                        }
                       
                        dataArrayE.push(d);
                    });
                    vm.rejectedBookingsExport = dataArrayE;
                    alasql('SELECT * INTO CSV("Rejected_reservations.csv",{headers:true}) FROM ?', [vm.rejectedBookingsExport]);

                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };

    }
})();
/**
 * Created by cl-macmini-51 on 08/02/18.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('QuickSaleController', QuickSaleController);

    /** @ngInject */
    function QuickSaleController($cookies, $state, $log, $rootScope, $mdDialog, $timeout, $document, getServices, $scope, filterFilter, languageBasedErrorFactory,
        errorMessageFactory, getCustomers, hidePublicPlaces, checkDomain, getBookings, RutHelper, getAgreement, getCorporate, quickSaleService, getFilters, Initializer, sharedRouteAssignment) {
        var vm = this;
        var myCenter;
        vm.showAgreementInUI = true;
        vm.retunrDateChanged = retunrDateChanged
        vm.defaultCustomerFlag = false;
        var zoomLevel = 12;
        vm.createBookingflag = false;
        vm.createBookingflag = false;
        vm.matchArray = [];
        vm.showPickUpTime = false;
        vm.flagforError = false;
        vm.MarkfavouriteAddressDrop = MarkfavouriteAddressDrop;
        vm.showPickUpTimeForRtype = false;
        vm.couponFlag = false;
        vm.count = 0;
        var markers = [];
        vm.returnDateShared = returnDateShared;
        vm.viaControlledFLag = false;
        vm.flagForOtherAgreement = false;
        vm.bookingSuccesPopUp = false;
        vm.pickAddressFlag = false;
        vm.pickFavAddress = pickFavAddress;
        vm.retunrTimeSharedChanged = retunrTimeSharedChanged;
        vm.dropooffaddress = dropooffaddress;
        vm.fillInAddress = fillInAddress;
        vm.pickUpaddressBlack = pickUpaddressBlack;
        // vm.paginationChangedForCorporation = paginationChangedForCorporation;
        vm.PassengerValue = PassengerValue;
        vm.showBookingIdPopUp = false;
        vm.PassengerValueForDynamnicAgreementCount = PassengerValueForDynamnicAgreementCount;

        // VARIABLES AND FUNCTIONS FOR MODIFY SPECIAL FARE - TV-1703
        vm.showEstimatePriceInHtml = showEstimatePriceInHtml;
        vm.showEstimatePriceForRoundTripInHtml = showEstimatePriceForRoundTripInHtml;
        vm.showEstimatePriceForFixedPriceInHtml = showEstimatePriceForFixedPriceInHtml;
        vm.clickFunction = clickFunction;
        vm.finalAdjustedPriceFromAdmin = 0;

        vm.FlagToShowEstimatedPrice = false;
        vm.math = window.Math;
        vm.viaControlledFLag1 = false;
        vm.viaControlledFLag = false;
        vm.retunrTimeChanged = retunrTimeChanged;
        vm.numberFLag = -1;
        // vm.classFLag = 6;
        // vm.classFLag[6] = true;
        var mapProp = {};
        vm.addressFlag = -1;
        vm.NumberArray = [{
            key: 1
        },
        {
            key: 2
        },
        {
            key: 3
        },
        {
            key: 4
        },
        {
            key: 5
        },
        {
            key: 6
        },
        {
            key: 7
        },
        {
            key: 8
        }
        ];
        vm.flagToshow = false;
        console.log(vm.NumberArray, ' vm.NumberArray');
        vm.isActiveDrop = false;
        var map = null;
        var bounds;
        var geocoder;
        var location = "";
        var autocomplete;
        var directionsService;
        var directionsDisplay;
        // Service To Get Map Instance
        Initializer.mapsInitialized
            .then(function () {
                console.log('>>>> GOOGLE INIT', google);
                if (google) {
                    myCenter = new google.maps.LatLng(-33.447487, -70.673676);
                    bounds = new google.maps.LatLngBounds();
                    geocoder = new google.maps.Geocoder();
                    // directionsService = new google.maps.DirectionsService;
                    directionsDisplay = new google.maps.DirectionsRenderer;
                } else {
                    alert(languageBasedErrorFactory.getProperErrorMessage('onRoadMessage', 0, '3'));
                }

            });
        var domain = checkDomain.getDomainName();
        vm.loading = false;
        vm.submit = false;
        vm.disableSubmitButton = false;
        vm.fullCuota = false;
        vm.SelectAddress = SelectAddress;
        vm.disabledSubmitButton = true;

        // ********** INSERT INTO ARRAY AT PARTICULAR POSITION **********
        Array.prototype.insert = function (index, item) {
            this.splice(index, 0, item);
        };

        function toClearValues() {
            console.log(" i  m in  toClearValues");

            vm.dataToFill.serviceTypeList = [];
            vm.dataToFill.paymentMethodList = [];
            vm.dataToFill.passengerRutCheck = 0;
            vm.dataToFill.applicantRutCheck = 0;
            vm.dataToFill.costCenterCheck = 0;
            vm.dataToFill.costSubCenterCheck = 0;
            vm.dataToFill.RolCheck = 0;
            vm.dataToFill.graphCheck = 0;
            vm.dataToFill.workOrderCheck = 0;
            vm.dataToFill.pepCheck = 0;
            vm.dataToFill.purposeOfTripCheck = 0;
            vm.dataToFill.noOfVoucherCheck = 0;
            vm.dataToFill.nominaCheck = 0;
            vm.dataToFill.solictudCheck = 0;
            if (!vm.defaultCustomerFlag) {
                vm.dataToFill.newCustomerFlag = false;
                vm.dataToFill.first_name = '';
                vm.dataToFill.last_name = '';
                vm.dataToFill.customer = '';
                vm.dataToFill.customerMobile = '';
                vm.dataToFill.customerId = '';
                vm.dataToFill.customerEmail = '';
            }
            vm.dataToFill.previousCustomerId = '';
            vm.dataToFill.employeeId = '';
            vm.dataToFill.contractIdSelected = '';
            vm.dataToFill.customerContarctId = '';
            vm.dataToFill.dropOffAddress = '';
            vm.dataToFill.dropLat = '';
            vm.dataToFill.dropLng = '';
            vm.dataToFill.payment_method = '';
            vm.dataToFill.route_id = '';
            vm.dataToFill.route_type = '';
            vm.dataToFill.itemOfChargeList = [];
            vm.dataToFill.itemOfChargeSelected = [];
            vm.dataToFill.contractListShowing = [];
            vm.matchArray = [];
            vm.dataToFill.contractList = [];
            vm.dataToFill.estimatedFareVariable = '';
            vm.dataToFill.estimatedFareRoute = '';
            vm.dataToFill.ReturnestimatedFareRoute = '';
            vm.dataToFill.estimatedFare = '';
            vm.dataToFill.minimumFare = '';
            vm.dataToFill.passengerCount = '';
            vm.dataToFill.serviceTypeSelected = '';
            vm.dataToFill.passengerRut = '';
            vm.dataToFill.applicantRut = '';
            vm.dataToFill.costCenter = '';
            vm.dataToFill.costSubCenter = '';
            vm.dataToFill.Rol = '';

            vm.dataToFill.graph = '';
            vm.dataToFill.workOrder = '';
            vm.dataToFill.pep = '';
            vm.dataToFill.noOfVoucher = '';
            vm.dataToFill.purposeOfTrip = '';
            vm.dataToFill.solictud = '';
            vm.dataToFill.nomina = '';
            vm.dataToFill.passengerRUTError = false;
            vm.dataToFill.applicantRUTError = false;
            vm.dataToFill.etaSchedule = '';
            vm.dataToFill.etaScheduleValue = 0;
            vm.dataToFill.estimatedDistance = '';
            vm.dataToFill.roundTrip = false;
            vm.dataToFill.is_wait_time_included = false;
            vm.dataToFill.returnDate = '';
            vm.dataToFill.returnTime = '';
            vm.dataToFill.couponCode = '';
            vm.dataToFill.corporate_account_id = '';
            vm.dataToFill.authRequired = '';
            vm.dataToFill.auther_id = '';
            vm.dataToFill.authRUT = '';
            vm.dataToFill.authName = '';
            vm.dataToFill.observations = '';
            vm.dataToFill.paymentMethodSelected = '';
            vm.dataToFill.selectedServiceDetails = '';
            vm.submit = false;
        }


        vm.dataToFill = {
            spotShow: false,
            shiftOpenClose: null,
            noService: null,
            newCustomerFlag: false,
            couponApplied: false,
            operationData: {

                operation: '',
                service: [],
                time: {
                    unique_code: '',
                    login_time: ''
                }
            },
            first_name: '',
            last_name: '',
            customer: '',
            customerMobile: '',
            customerId: '',
            previousCustomerId: '',
            ReturnEstimatedDistance: 0,
            etaScheduleValueReturn: 0,
            customerEmail: '',
            employeeId: '',
            customerProfile: 1,
            contractIdSelected: '',
            customerContarctId: '',
            pickUpAddress: '',
            dropOffAddress: '',
            pickLat: '',
            pickLng: '',
            dropLat: '',
            dropLng: '',
            payment_method: '',
            serviceTypeList: [],
            paymentMethodList: [],
            route_id: '',
            route_type: '',
            itemOfChargeList: [],
            itemOfChargeSelected: [],
            contractListShowing: [],
            contractList: [],
            estimatedFareVariable: '',
            estimatedFareRoute: '',
            estimatedFare: '',
            minimumFare: '',
            passengerCount: '',
            serviceTypeSelected: '',
            passengerRutCheck: 0,
            applicantRutCheck: 0,
            costCenterCheck: 0,
            costSubCenterCheck: 0,
            RolCheck: 0,
            graphCheck: 0,
            workOrderCheck: 0,
            pepCheck: 0,
            purposeOfTripCheck: 0,
            noOfVoucherCheck: 0,
            nominaCheck: 0,
            solictudCheck: 0,
            passengerRut: '',
            applicantRut: '',
            costCenter: '',
            costSubCenter: '',
            Rol: '',
            graph: '',
            workOrder: '',
            pep: '',
            noOfVoucher: '',
            purposeOfTrip: '',
            solictud: '',
            nomina: '',
            passengerRUTError: false,
            applicantRUTError: false,
            etaSchedule: '',
            etaScheduleValue: 0,
            estimatedDistance: '',
            airportCheck: '',
            roundTrip: false,
            is_wait_time_included: false,
            returnDate: '',
            returnTime: '',
            couponCode: '',
            corporate_account_id: '',
            authRequired: '',
            auther_id: '',
            authRUT: '',
            authName: '',
            observations: '',
            paymentMethodSelected: '',
            bookingFor: 0,
            carType: '',
            selectedServiceDetails: '',
            country_code: '+56',
            rt_discount: '',
            webDiscount: '',
            couponValidation: false,
            appliedCouponData: [],
            sortData: '',
            timeZone: new Date().getTimezoneOffset(),
            viaControlled: 0,
            returnTimeShared: '',
            viaControlledReal: 0,
            controllerWayTarifa: 0,
            viaControlledApply: false,
            controlledWayCheck: 0,
            time_trip_shared_service: 0,
            is_vip: ''
        };
        vm.dataToFill.customerProfile = 1;
        vm.dataToFill.Return_policy = {
            first_name: '',
            last_name: '',
            password: '',
            confirmPassword: '',
            country_code: '+56',
            timeZone: new Date().getTimezoneOffset(),
            customerMobile: '',
            customerMobileG: '',
            customerEmail: '',
            customerId: '',
            previousCustomerId: '',
            customerProfile: 1,
            passengerCount: '',
            bookingFor: 0,
            personName: '',
            personEmail: '',
            personMobile: '',
            otherBooking: false,
            carType: '',
            reference_point: '',
            pickUpAddress: '',
            dropOffAddress: '',
            pickUpLat: '',
            pickUpLng: '',
            dropOffLat: '',
            dropOffLng: '',
            numberOfPassengerError: false,
            numberOfPassengerCount: 0,
            bookingType: '',
            scheduledBooking: '',
            currentBooking: '',
            reaccurringBooking: false,
            roundTrip: false,
            scheduledDate: new Date(),
            scheduledTime: new Date(),
            dropDate: new Date(),
            dropTime: new Date(),
            tillDate: '',
            tillTime: new Date(),
            contractIdSelected: '',
            serviceTypeSelected: '',
            corporate_account_id: '',
            route_id: '',
            route_type: '',
            type_of_agreement: '',
            is_wait_time_included: false,
            favPickLocId: '',
            favDropLocId: '',
            returnDate: new Date(),
            returnTime: new Date(),
            itemOfChargeList: [],
            itemOfChargeSelected: [],
            authRequired: '',
            authRUT: '',
            rutFlag: false,
            auther_id: '',
            employeeId: '',
            customerContarctId: '',
            contractList: [],
            contractListShowing: [],
            is_item_of_charges: 0,
            item_of_charges: [],
            // bookingId: $stateParams.id,
            previousPickFlag: false,
            previousDropFlag: false,
            nearDriver: '',
            payment_method: '',
            passengerRutCheck: 0,
            applicantRutCheck: 0,
            costCenterCheck: 0,
            costSubCenterCheck: 0,
            RolCheck: 0,
            graphCheck: 0,
            workOrderCheck: 0,
            pepCheck: 0,
            purposeOfTripCheck: 0,
            noOfVoucherCheck: 0,
            nominaCheck: 0,
            solictudCheck: 0,
            passengerRut: '',
            applicantRut: '',
            costCenter: '',
            costSubCenter: '',
            Rol: '',
            graph: '',
            workOrder: '',
            pep: '',
            purposeOfTrip: '',
            noOfVoucher: '',
            nomina: '',
            solictud: '',
            passengerRUTError: false,
            applicantRUTError: false,
            observations: '',
            etaSchedule: '',
            estimatedDistance: '',
            estimatedFare: '',
            estimatedFareRoute: '',
            estimatedFareVariable: '',
            minimumFare: 0,
            airportCheck: '',
            discounts: [],
            couponValidation: false,
            roundTripDiscount: 0,
            webDiscount: 0,
            couponApplied: false,
            couponCode: '',
            paymentMethodList: [],
            selectedServiceDetails: '',
            viaControlled: 0,
            viaControlledReal: 0,
            viaControlledApply: false,
            controlledWayCheck: 0,
            etaScheduleValue: 0,
            is_vip: '',
            is_POS_booking: 0,
            payment_status: 0,
            created_by_admin: 0,
            time_trip_shared_service: 0
        }
        vm.returnDateOptions = {};
        vm.datePicker_1 = {
            returnDate: false
        };
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.altInputFormats = ['M!/d!/yyyy'];
        vm.hstep = 1;
        vm.mstep = 15;
        vm.ismeridian = false;
        vm.returnDateOptions = {
            formatYear: 'yy',
            maxDate: new Date(2090, 12, 31),
            minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };

        vm.hideMapVariable = true;
        vm.toggleMap = toggleMap;

        vm.spotCorporateShow = spotCorporateShow;
        vm.salesReport = salesReport;
        vm.closeShift = closeShift;
        vm.searchCustomer = searchCustomer;
        vm.onSelectingCustomer = onSelectingCustomer;
        vm.getPreviousAddressHit = getPreviousAddressHit;
        vm.selectService = selectService;
        vm.numberOfPassenger = numberOfPassenger;
        vm.addNewCustomer = addNewCustomer;
        vm.datePickerE_1 = datePickerE_1;
        vm.setBooleans = setBooleans;
        vm.passengerRutChange = passengerRutChange;
        vm.applicantRutChange = applicantRutChange;
        vm.selectingItemOfCharges = selectingItemOfCharges;
        vm.agreementTypeChanged = agreementTypeChanged;
        vm.addEndowment = addEndowment;
        vm.selectPaymentMethod = selectPaymentMethod;
        vm.createBookingByPass = createBookingByPass;
        vm.applyCoupon = applyCoupon;
        vm.changeQuantityOfItem = changeQuantityOfItem;



        // vm.corporate = corporate;
        vm.corporateOffset = 0;
        vm.agreementOffset = 0;
        vm.globalLimit = 50;
        vm.globalOffset = vm.globalLimit;
        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'vehicle', 'service', 'agreement', 'corporatesList', 'operation_point'];
        vm.corporatesList = [];
        vm.corporatesList.push({
            company_name: 'All',
            id: 'all'
        });

        vm.agreement = [];
        vm.agreement.push({
            name: 'All',
            id: 'all'
        });

        // =================== FILTER OBJECT ===================
        vm.filterObject = {
            access_token: $cookies.get('obj'),
            branch_filter: 0,
            vehicle_filter: 0,
            service_filter: 0,
            agreement_filter: 1,
            corporate_filter: 1,
            service_category: 0,
            corporate_status: 2,
            agreement_status: 1,
            vehicle__status: 0,
            operation_point_filter: 0,
            branch_limit: 0,
            branch_offset: 0,
            agreement_limit: vm.globalLimit,
            agreement_offset: vm.agreementOffset,
            corporate_limit: vm.globalLimit,
            corporate_offset: vm.corporateOffset,
            branch_search_filter: 0,
            vehicle_search_filter: 0,
            service_search_filter: 0,
            agreement_search_filter: 0,
            corporate_search_filter: 0,
            operation_point_search_filter: 0
        }
        var restriccion_flota;
        var sucursal_id;
        var cupos_global = 0;
        var cupos_fecha_global;


        // setTimeout(function () {
        //     document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
        //         // if (vm.branchList && (vm.branchList.length == 0)) {
        //         vm.searchBranchData = '';
        //         getFilterDataFromBackend(0,0);
        //         // }
        //     });

        //     document.getElementsByClassName('ui-select-search')[1].addEventListener('blur', function ($event) {
        //         // if (vm.corporatesList && (vm.corporatesList.length == 0)) {
        //         vm.searchCorporateData = '';
        //         getFilterDataFromBackend(0, 0);
        //         // }
        //     });




        // })











        // *********** COMMON FUNCTION FOR FILTER PAGINATION AND SEARCHING ***********
        function commonFunction(type, mode) {

            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                console.log("searching ..........");

                if (mode == 'search' || i != type) {
                    vm[vm.searchFilterArrayForClearArray[i]] = [];
                    // vm[vm.searchFilterArrayForClearArray[i]].push({
                    //     id: 'all',
                    //     name: 'All'
                    // });
                    vm[vm.searchFilterArray[i] + 'Offset'] = 0;
                    vm['search' + vm.searchFilterArray[i].substring(0, 1).toUpperCase() + vm.searchFilterArray[i].substring(1) + 'Data'] = '';
                }
            }
        }


        function clearOffset() {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                vm[vm.searchFilterArray[i] + 'Offset'] = 0;
            }
        }

        function retunrTimeChanged() {
            // vm.dataToFill.returnTime =  dateTimeFormat(vm.dataToFill.returnDate,vm.dataToFill.returnTime)
            if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking == 'P') {
                calculateDateRangeOfPointToPoint();
            }
        }

        function calculateDateRangeOfPointToPoint() {
            var datePointToPoint = dateTimeFormat(vm.dataToFill.returnDate, vm.dataToFill.returnTime);
            // var pickRangeForRtypeReturn = moment(datePointToPoint).subtract((((vm.pickup_travel_time_pap != 0 ? vm.dataToFill.etaScheduleValue : 0) + vm.pickup_travel_time_pap) * 60), 'seconds');
            var newpickRangeForRtypeReturn = '';
            if (vm.is_group_allowed == 1) {
                newpickRangeForRtypeReturn = moment(datePointToPoint).subtract((vm.time_trip_shared_service_point_to_point * 60), 'seconds');
            } else {
                newpickRangeForRtypeReturn = datePointToPoint
            }
            vm.ptoptravelTime = moment(newpickRangeForRtypeReturn).format('HH:mm');
            var rangePointToPoint = moment(datePointToPoint).add((vm.time_trip_shared_service_point_to_point * 60), 'seconds')
            vm.rangeOfPointToPoint = moment(rangePointToPoint).format('HH:mm');

        }

        function retunrDateChanged() {
            if (vm.dataToFill.returnDate) {
                vm.dataToFill.returnTime = new Date();
                vm.dataToFill.returnTime.setMinutes(vm.dataToFill.returnTime.getMinutes() + 35);
            }
            if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking == 'P') {
                calculateDateRangeOfPointToPoint();
            }
            vm.dataToFill.returnTime = dateTimeFormat(vm.dataToFill.returnDate, vm.dataToFill.returnTime);
        }

        function datePickerE_1(type) {
            if (type == '2') {
                vm.datePicker_1.returnDate = true;
            } else {
                vm.datePicker_1.returnDateShared = true;
            }
        };

        function passengerRutChange() {
            $log.log('data', vm.dataToFill.passengerRut);
            if (vm.dataToFill.passengerRut) {
                if (RutHelper.validate(vm.dataToFill.passengerRut)) {
                    vm.dataToFill.passengerRUTError = false;
                } else {
                    vm.dataToFill.passengerRUTError = true;
                }
            } else if (vm.dataToFill.passengerRut === null) {
                vm.dataToFill.passengerRUTError = true;
            } else if (vm.dataToFill.passengerRut === undefined) {
                vm.dataToFill.passengerRUTError = false;
            }
        }


        function applicantRutChange() {
            $log.log('data', vm.dataToFill.applicantRut);
            if (vm.dataToFill.applicantRut) {
                if (RutHelper.validate(vm.dataToFill.applicantRut)) {
                    vm.dataToFill.applicantRUTError = false;
                } else {
                    vm.dataToFill.applicantRUTError = true;
                }
            } else if (vm.dataToFill.applicantRut === null) {
                vm.dataToFill.applicantRUTError = true;
            } else if (vm.dataToFill.applicantRut === undefined) {
                vm.dataToFill.applicantRUTError = false;
            }
        }


        function PassengerValue(index, data) {
            console.log(data, index, 'PassengerValue');

            if (!vm.dataToFill.customerId && !vm.dataToFill.newCustomerFlag) {
                languageBasedErrorFactory.getProperErrorMessage('selectCustomerf', 0, 0);
                //errorMessageFactory.showErrorMessage('Please fill customer details first',0);
                return;
            }
            vm.dataToFill.appliedCouponData = [];
            vm.numberFLag = index;
            vm.dataToFill.passengerCount = data.key;
            if (data.key) {
                numberOfPassenger(vm.dataToFill.passengerCount);
                calculateRtDiscount();


            }
            if (vm.roundTripPayload)
                calulatePriceReturn(vm.roundTripPayload);
        }

        function PassengerValueForDynamnicAgreementCount(data) {
            console.log(data, 'PassengerValue');

            if (!vm.dataToFill.customerId && !vm.dataToFill.newCustomerFlag) {
                languageBasedErrorFactory.getProperErrorMessage('selectCustomerf', 0, 0);
                //errorMessageFactory.showErrorMessage('Please fill customer details first',0);
                return;
            }
            // vm.dataToFill.appliedCouponData = [];
            // vm.numberFLag = index;
            vm.dataToFill.passengerCount = data;
            if (data) {
                numberOfPassenger(vm.dataToFill.passengerCount);
                calculateRtDiscount();


            }

        }

        //=========================show spot corporate======================
        function spotCorporateShow(type, data) {
            if (data.is_corporate_profile)
                if (data.panel_booking_access != 1) {
                    errorMessageFactory.showErrorMessage('Este cliente no está autorizado para crear reservas desde el panel', 0);
                    vm.dataToFill.contractIdSelected = '';
                    return;
                }

            getAddressApi();
            getCustomerData(data);
            vm.contract_id_used = data.contract_id;
            vm.agreementTypeUsed = data.agreement_type;
            vm.contractNameUsed = data.contract_name;
            vm.flagforError = false;
            // vm.dataToFill.contractList = [];
            if (data.agreement_type == 'SPOT') {
                vm.flagAgreement = true;
                vm.dataToFill.customerProfile = 0;
                vm.flagForOtherAgreement = false;
                vm.dataToFill.spotShow = true;
                vm.showAgreementInUI = false;
                vm.dataToFill.contractIdSelected = data.contract_id;
            } else {
                vm.flagAgreement = false;
                if (data.contract_name == "OTROS CONVENIOS") {
                    vm.dataToFill.spotShow = false;
                    vm.flagForOtherAgreement = false;
                    vm.dataToFill.newCustomerFlag = false;
                    vm.dataToFill.last_name = '';
                    vm.dataToFill.first_name = '';
                    vm.contractNameUsed = undefined;
                    vm.dataToFill.customerProfile = 1;
                    vm.showAgreementInUI = true;
                } else {
                    vm.dataToFill.spotShow = true;
                    vm.flagForOtherAgreement = true;
                    vm.showAgreementInUI = false;
                    if (vm.dataToFill.newCustomerFlag) {
                        vm.dataToFill.customerProfile = 0;
                    } else {
                        vm.dataToFill.customerProfile = 0;
                    }
                    vm.dataToFill.contractIdSelected = data.contract_id;
                }

            }
            // if (type == '1') {
            //     vm.dataToFill.spotShow = true;
            //     vm.dataToFill.customerProfile = 0;
            //     getSpotAgreement();
            //     //toGetAirportService(vm.dataToFill.pickLat,vm.dataToFill.pickLng);
            // } else {
            //     vm.dataToFill.spotShow = false;
            //     vm.dataToFill.customerProfile = 1;
            // }
            if (type == vm.agreementArray.length - 1) {
                // vm.dataToFill.spotShow[type] = false;
                vm.classFLag = type;
                // vm.dataToFill.customerProfile = 1;
                vm.dataToFill.serviceTypeSelected = '';
                vm.dataToFill.customer = '';
                vm.dataToFill.customerId = '';
                vm.FlagToShowEstimatedPrice = false;
                $(".pac-container").hide();
                vm.dataToFill.customerEmail = '';
                vm.dataToFill.Return_policy.estimatedFare = 0;
                vm.dataToFill.estimatedFare = 0;
                vm.via_controlled_price_to_send = 0;
                vm.viaControlled2 = 0;
                vm.dataToFill.customerMobile = '';
                vm.matchArray = [];
                vm.dataToFill.dropOffAddress = '';
                vm.dataToFill.appliedCouponData = [];
                vm.flagToshow = false;
                vm.dataToFill.passengerCount = 1;
                vm.dataToFill.sortData = [];
                // vm.dataToFill.pickLat = '';
                // vm.dataToFill.pickLng = '';
                vm.dataToFill.dropLat = '';
                vm.dataToFill.dropLng = '';
                vm.dataToFill.roundTrip = false;
                vm.dataToFill.estimatedFare = '';
                vm.dataToFill.is_wait_time_included = false;
                vm.dataToFill.contractIdSelected = data.contract_id;

                // getSpotAgreement();

            } else {
                // vm.dataToFill.spotShow[type] = true;
                // vm.dataToFill.customerProfile = 0;
                vm.classFLag = type;
                vm.flagToshow = true;
                vm.dataToFill.Return_policy.estimatedFare = 0;
                vm.dataToFill.estimatedFare = 0;
                vm.via_controlled_price_to_send = 0;
                vm.viaControlled2 = 0;
                vm.dataToFill.appliedCouponData = [];
                vm.dataToFill.roundTrip = false;
                vm.dataToFill.sortData = [];
                vm.dataToFill.contractIdSelected = data.contract_id;
                vm.dataToFill.dropOffAddress = '';
                $(".pac-container").hide();
                vm.matchArray = [];
                vm.dataToFill.dropOffAddress = '';
                vm.dataToFill.passengerCount = 1;
                vm.addressFlag = -1;
                vm.FlagToShowEstimatedPrice = false;
                // vm.dataToFill.pickLat = '';
                // vm.dataToFill.pickLng = '';
                vm.dataToFill.dropLat = '';
                vm.dataToFill.dropLng = '';
                vm.dataToFill.serviceTypeSelected = '';
                vm.dataToFill.is_wait_time_included = false;

                vm.numberFLag = -1;
                // vm.dataToFill.serviceTypeList[type] = false;
                // getCustomerData(data);
                if (data.agreement_type == "CORPORATE") {
                    agreementTypeChanged();
                } else {
                    getSpotAgreement();
                }

            }

            bounds = new google.maps.LatLngBounds();
            // toClearValues();
            //setMapOnAll(null,'drop');
            markers = [];
            mapInitialize();
            $timeout(function () {
                forPickUp();
            })
            // console.log(vm.dataToFill.contractIdSelected, 'vm.dataToFill.contractIdSelected');

        }

        function getCustomerData(data) {
            vm.loading = true;
            var dataSend = {};
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.point_id = vm.point_id_to_send;
            dataSend.contract_id = data.contract_id;
            // dataSend.contract_id = vm.contract_id_to_send;
            var promise = quickSaleService.getCustomerData(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        if (payload.title.data.final_data[0].customer_id != null) {
                            vm.defaultCustomerFlag = false;
                            vm.dataToFill.newCustomerFlag = false;
                            vm.dataToFill.customer = payload.title.data.final_data[0].customer_name;
                            vm.dataToFill.customerId = payload.title.data.final_data[0].customer_id;
                            vm.dataToFill.customerEmail = payload.title.data.final_data[0].email;
                            vm.dataToFill.customerMobile = payload.title.data.final_data[0].phone_number;
                            if (!vm.dataToFill.first_name) {
                                checkCustomerIsAllowedInContract(vm.dataToFill.customerId);
                            }
                            vm.dataToFill.last_name = '';
                            vm.dataToFill.first_name = '';
                            // toClearValues();
                        } else {
                            vm.defaultCustomerFlag = true;
                            if (!vm.dataToFill.first_name) {
                                checkCustomerIsAllowedInContract(vm.dataToFill.customerId);
                            }

                        }
                    } else {
                        //   errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    // toClearValues();
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );

        };


        //======================sales report======================
        function salesReport() {
            getPrintSalesHeight();
        };
        //==========================close shift=======================
        function closeShift(type) {
            if (type == 1) {
                openShiftStartPopUp('No ha comenzado su turno, ¿desea comenzar su turno?', 1);
            } else {
                openShiftStartPopUp('¿Quieres cerrar tu turno?', 0);
            }
        };

        //==========================drop map functions======================
        function setMapOnAll(map, id) {
            for (var i = 0; i < markers.length; i++) {
                var marker = markers[i];
                if (markers[i].id == id) {
                    marker.setMap(map);
                }
                if (!id) {
                    marker.setMap(map);
                }
            }
        };
        // If the map position is out of range, move it back
        function checkBounds(map) {
            if (typeof (map.getBounds()) == 'undefined')
                return;

            var latNorth = map.getBounds().getNorthEast().lat();
            var latSouth = map.getBounds().getSouthWest().lat();
            var newLat;

            if (latNorth < 85 && latSouth > -85) /* in both side -> it's ok */
                return;
            else {
                if (latNorth > 85 && latSouth < -85) /* out both side -> it's ok */
                    return;
                else {
                    if (latNorth > 85)
                        newLat = map.getCenter().lat() - (latNorth - 85);
                    /* too north, centering */
                    if (latSouth < -85)
                        newLat = map.getCenter().lat() - (latSouth + 85);
                    /* too south, centering */
                }
            }
            if (newLat) {
                var newCenter = new google.maps.LatLng(newLat, map.getCenter().lng());
                map.setCenter(newCenter);
            }
        }



        function mapInitialize(data) {
            mapProp = {
                center: myCenter,
                zoom: Number(zoomLevel),
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                minZoom: 3,
                maxZoom: 18,
                scrollwheel: false
            };
            map = new google.maps.Map(document.getElementById("googleMap"), mapProp);
            map.setOptions({
                styles: hidePublicPlaces.hidePublic()
            });
            google.maps.event.addListener(map, 'center_changed', function () {
                checkBounds(map);
            });
            var input = document.getElementById('dropOffAddress');
            google.maps.event.addDomListener(input, 'keydown', function (event) {
                if (event.keyCode === 13) {
                    event.preventDefault();
                }
            });
        };

        function dropooffaddress(data) {
            //initAutocomplete(data);
            initAutocompleteOld(data);
        }

        function pickUpaddressBlack(data) {
            if (data == undefined) {
                $(".pac-container").hide();
            }
        }

        function initAutocompleteOld(data) {
            var dropoffAddress = document.getElementById('dropOffAddress');
            var country = 'CL';
            vm.addressDropOffArray = [];
            if (data && data.length >= 4) {
                vm.pickAddressFlag = true;
                var service = new google.maps.places.AutocompleteService();
                service.getPlacePredictions({ input: dropoffAddress.value, componentRestrictions: { country: country } }, function(predictions, status) {
                    if (status === google.maps.places.PlacesServiceStatus.OK) {
                        for(i=0;i<predictions.length; i++){
                            var data = predictions[i];
                            data.type = 1; //0 local, 1 heremaps
                            vm.addressDropOffArray.push({
                                label: data.description,
                                id_origin: data.place_id,
                            })
                        }
                        $scope.$apply();
                    } else {
                        vm.addressDropOffArray = [];
                        errorMessageFactory.showErrorMessage("Error al obtener los datos", 0);
                    }
                });
            } else if (data && data.length < 4) {
                vm.pickAddressFlag = false;
                google.maps.event.clearInstanceListeners(dropoffAddress);
                $(".pac-container").hide();
            }

        };

        function initAutocomplete(data) {
            var dropoffAddress = document.getElementById('dropOffAddress');
            if (data && data.length >= 4) {
                vm.pickAddressFlag = true;
                var dataSend = {}
                dataSend.at = '-33.4724228,-70.7699137';
                dataSend.channel = 2;
                vm.dataToFill.previousDropFlag = false;
                vm.dataToFill.previousPickFlag = false;
                dataSend.query_string = dropoffAddress.value;
                dataSend.user_id = vm.dataToFill.customerEmail;
                var promise = quickSaleService.autoSuggestAconcagua(dataSend);
                promise.then(
                    function (response) {
                        vm.loading = false;
                        console.log(response)
                        var obj = JSON.parse(response.response);
                        if(response.status == 200){
                            vm.addressDropOffArray = [];
                            if(obj.items && obj.items.length > 0 ){
                                //obj.data.forEach(function (data) {
                                for(i=0;i<obj.items.length; i++){
                                    var data = obj.items[i];
                                    data.type = 1; //0 local, 1 heremaps
                                    vm.addressDropOffArray.push({
                                        label: data.title,
                                        id_origin: data.id,
                                    })
                                //})
                                }
                                $scope.$apply();
                            }
                        } else {
                            vm.addressDropOffArray = [];
                            $log.log(obj.details);
                            errorMessageFactory.showErrorMessage("Error al obtener los datos", 0);
                        }
                    }, 
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                    }
                );
                //vm.pickAddressFlag = true;
                //autocomplete = new google.maps.places.Autocomplete(
                    //dropoffAddress, {
                    //placeIdOnly: true
                //});
                //if (domain != 'dev' && domain != 'test')
                    //autocomplete.setComponentRestrictions({
                        //'country': ['CL']
                    //});
                //autocomplete.addListener('place_changed', fillInAddress);
                // $(".pac-container").css('display', 'block');
            } 
            //else if (data && data.length < 4) {
                //vm.pickAddressFlag = false;
                //google.maps.event.clearInstanceListeners(dropoffAddress);
                //$(".pac-container").hide();

            //}


        };



        function fillInAddress(data) {
            $(".pac-container").hide();
            vm.addressDropOffArray = [];

            if (!data.id_origin) {
                return;
            }
            geocoder.geocode({
                'placeId': data.id_origin
            }, function (results, status) {
                    // console.log(results,status,"geocode ----------------")
                    if (status !== 'OK') {
                        window.alert('Geocoder failed due to: ' + status);
                        return;
                    }
                    $scope.address = hidePublicPlaces.formattedAddress(results[0]);
                    $scope.addressLat = results[0].geometry.location.lat();
                    $scope.addressLng = results[0].geometry.location.lng();
                    var string1 = results[0].formatted_address;
                    var address1 = string1.replace(", Chile", " ");
                    vm.dataToFill.dropOffAddress = address1;
                    vm.dataToFill.dropLat = $scope.addressLat;
                    vm.dataToFill.dropLng = $scope.addressLng;

                    for (var i = 0; i < vm.dataToFill.serviceTypeList.length; i++) {
                        vm.dataToFill.serviceTypeList[i].active = false;
                    }
                    vm.dataToFill.serviceTypeSelected = '';
                    vm.dataToFill.selectedServiceDetails = '';
                    vm.FlagToShowEstimatedPrice = false;
                    vm.numberFLag = -1;
                    for (var i = 0; i < vm.dataToFill.paymentMethodList.length; i++) {
                        vm.dataToFill.paymentMethodList[i].active = false;
                    }

                    // ********* VARIABLES ARE INITIALIZE TO AGAIN SET INPUT FIELD VARIABLE ********
                    vm.calculatedEstimatePriceFormFunctionEstimated = -1;
                    vm.finalAdjustedPriceFromAdmin = 0;
                    vm.calculatedEstimatePriceForFixedPriceFormFunction = 0;
                    vm.calculatedEstimatePriceForRoundTripFormFunction = 0;
                    vm.click = false;

                    getFavoriteAddress();
                    // ********** TO GET CITY OF ADDRESS **********
                    results[0].address_components.forEach(function (data) {
                        if (data.types[0] == 'locality') {
                            vm.jobDropoffComuna = data.long_name || null;
                        }
                    });

                    $scope.$apply();
                    var location = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
                    console.log(location)
                    placeMarker(map, location, 'drop');
                });
        }

        function fillInAddressOld(data) {
            $(".pac-container").hide();
            vm.loading = true;
            vm.dataToFill.dropOffAddress = data.label;
            vm.addressDropOffArray = [];
            var dataSend = {};
            dataSend.channel = 2;
            dataSend.label = data.label;
            dataSend.origin = data.origin;
            dataSend.id_origin = data.id_origin;
            dataSend.user_id = vm.dataToFill.customerEmail;
            var promise = quickSaleService.autoSuggestDetailsAconcagua(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        //vm.loading = false;
                        var response = JSON.parse(payload.response);
                        if (response) {
                            var salida = response;
                            var city;
                            city = salida.county;
                            if (vm.pickUpCity && (vm.pickUpCity != city)) {
                                errorMessageFactory.showErrorMessage('Error, esta dirección cambia el tramo original. El cambio no debe afectar la tarifa.', 0);
                                // results= '';
                                vm.dataToFill.pickUpAddress = vm.pickUpAddress;
                                vm.addressChange = false;
                                return;
                            }
                            $scope.addressPick = vm.dataToFill.pickUpAddress;
                            // $scope.addressLat = data.latitude;
                            // $scope.addressLng = data.longitude;
                            $scope.addressLat = salida.position.lat;
                            $scope.addressLng = salida.position.lng;
                            // var string = response.Response.View[0].Result[0].Location.Address.Label;
                            // var address = string.replace(", Chile", " ");
                            // vm.dataToFill.pickUpAddress = vm.addressHave;
                            //
                            //-----------------
                            //vm.dataToFill.pickUpLat = $scope.addressLat;
                            //vm.dataToFill.pickUpLng = $scope.addressLng;
                            //vm.dataToFill.pickLat = $scope.addressLat;
                            //vm.dataToFill.pickLng = $scope.addressLng;
                            //vm.dataToFill.previousPickFlag = false;
                            //vm.pickaddressChange = true;
                            //vm.dataToFill.previousDropFlag = false;
                            //getFavoriteAddress('pick');
                            //// ********** TO GET CITY OF ADDRESS **********
                            //vm.jobPickupComuna = response.data[0].city_name;
                            //$scope.$apply();
                            //vm.getFixedRoutesForPersonalFlag = true;
                            //var location = new google.maps.LatLng(salida.latitude, salida.longitude);
                            //if (vm.toAirportFlag) {
                                //getAirportAddressApi();
                            //}
                            //if (vm.ptopAirportFlag && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                                //getFixedRoutesForPersonal(vm.dataToFill);
                            //}
                            //if (vm.dataToFill.serviceTypeSelected) { //&& (vm.dataToFill.bookingType == '0' || vm.dataToFill.bookingType == 0)
                                //vm.dataToFill.nearDriver = '';
                                //toGetAirportService(salida.latitude, salida.longitude, vm.dataToFill.serviceTypeSelected, map);
                            //}
                    //var string1 = results[0].formatted_address;
                    //var address1 = string1.replace(", Chile", " ");
                    //vm.dataToFill.dropOffAddress = address1;
                    vm.dataToFill.dropLat = $scope.addressLat;
                    vm.dataToFill.dropLng = $scope.addressLng;

                    for (var i = 0; i < vm.dataToFill.serviceTypeList.length; i++) {
                        vm.dataToFill.serviceTypeList[i].active = false;
                    }
                    vm.dataToFill.serviceTypeSelected = '';
                    vm.dataToFill.selectedServiceDetails = '';
                    vm.FlagToShowEstimatedPrice = false;
                    vm.numberFLag = -1;
                    for (var i = 0; i < vm.dataToFill.paymentMethodList.length; i++) {
                        vm.dataToFill.paymentMethodList[i].active = false;
                    }

                    // ********* VARIABLES ARE INITIALIZE TO AGAIN SET INPUT FIELD VARIABLE ********
                    vm.calculatedEstimatePriceFormFunctionEstimated = -1;
                    vm.finalAdjustedPriceFromAdmin = 0;
                    vm.calculatedEstimatePriceForFixedPriceFormFunction = 0;
                    vm.calculatedEstimatePriceForRoundTripFormFunction = 0;
                    vm.click = false;

                    getFavoriteAddress();
                    // ********** TO GET CITY OF ADDRESS **********
                    //results[0].address_components.forEach(function (data) {
                        //if (data.types[0] == 'locality') {
                            vm.jobDropoffComuna = city;
                        //}
                    //});

                            $scope.$apply();
                            var location = new google.maps.LatLng(Number($scope.addressLat), Number($scope.addressLng));
                            $timeout(function () {
                                placeMarker(map, location, 'pick');
                            }, 2000);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                    }
                );
            //if (true) {
                //var data = autocomplete.getPlace();
                //console.log(data);

                //if (!data.place_id) {
                    //return;
                //}
                //geocoder.geocode({
                    //'placeId': data.place_id
                //}, function (results, status) {
                    //// console.log(results,status,"geocode ----------------")
                    //if (status !== 'OK') {
                        //window.alert('Geocoder failed due to: ' + status);
                        //return;
                    //}
                    //$scope.address = hidePublicPlaces.formattedAddress(results[0]);
                    //$scope.addressLat = results[0].geometry.location.lat();
                    //$scope.addressLng = results[0].geometry.location.lng();
                    //var string1 = results[0].formatted_address;
                    //var address1 = string1.replace(", Chile", " ");
                    //vm.dataToFill.dropOffAddress = address1;
                    //vm.dataToFill.dropLat = $scope.addressLat;
                    //vm.dataToFill.dropLng = $scope.addressLng;

                    //for (var i = 0; i < vm.dataToFill.serviceTypeList.length; i++) {
                        //vm.dataToFill.serviceTypeList[i].active = false;
                    //}
                    //vm.dataToFill.serviceTypeSelected = '';
                    //vm.dataToFill.selectedServiceDetails = '';
                    //vm.FlagToShowEstimatedPrice = false;
                    //vm.numberFLag = -1;
                    //for (var i = 0; i < vm.dataToFill.paymentMethodList.length; i++) {
                        //vm.dataToFill.paymentMethodList[i].active = false;
                    //}

                    //// ********* VARIABLES ARE INITIALIZE TO AGAIN SET INPUT FIELD VARIABLE ********
                    //vm.calculatedEstimatePriceFormFunctionEstimated = -1;
                    //vm.finalAdjustedPriceFromAdmin = 0;
                    //vm.calculatedEstimatePriceForFixedPriceFormFunction = 0;
                    //vm.calculatedEstimatePriceForRoundTripFormFunction = 0;
                    //vm.click = false;

                    //getFavoriteAddress();
                    //// ********** TO GET CITY OF ADDRESS **********
                    //results[0].address_components.forEach(function (data) {
                        //if (data.types[0] == 'locality') {
                            //vm.jobDropoffComuna = data.long_name || null;
                        //}
                    //});

                    //$scope.$apply();
                    //var location = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
                    //console.log(location)
                    //placeMarker(map, location, 'drop');
                //});
            //} else {
                //console.log('in elseeee')
                //var location = new google.maps.LatLng(vm.dataToFill.dropLat, vm.dataToFill.dropLng);
                //placeMarker(map, location, 'drop');
            //}


        }

        function fillInAddress1() {
            console.log('in elseeee')
            var location = new google.maps.LatLng(vm.dataToFill.dropLat, vm.dataToFill.dropLng);
            getFavoriteAddress();
            placeMarker(map, location, 'drop');
        }


        function forPickUp() {
            console.log(vm.dataToFill.pickLat, vm.dataToFill.pickLng, 'asdjk')
            var location = new google.maps.LatLng(vm.dataToFill.pickLat, vm.dataToFill.pickLng);
            placeMarker(map, location, 'pick');
        }

        function placeMarker(map, location, data) {
            console.log(data, '>>>>>>>>>>>>>>>>>>>>placeMarker>>>>>>>>>>>>>>');

            var id;
            if (data == 'pick') {
                id = 'pick';
                if (markers.length) {
                    for (var i = 0; i < markers.length; i++) {
                        if (markers[i].id == 'pick') {
                            setMapOnAll(null, 'pick');
                        }
                    }
                } else {
                    id = 'pick';
                }
            } else if (data == 'drop') {
                id = 'drop';
                if (markers.length) {
                    for (var i = 0; i < markers.length; i++) {
                        if (markers[i].id == 'drop') {
                            setMapOnAll(null, 'drop');
                        }
                    }
                } else {
                    id = 'drop';
                }
            }
            var marker = new google.maps.Marker({
                id: id,
                position: location,
                draggable: false,
                map: map
            });
            bounds.extend(location);
            //map.fitBounds(bounds);
            markers.push(marker);
            console.log(markers);
            if (vm.dataToFill.pickLat && vm.dataToFill.dropLat) {
                calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.pickLat, vm.dataToFill.pickLng, vm.dataToFill.dropLat, vm.dataToFill.dropLng, map);
            }
            if (vm.dataToFill.pickLat && vm.dataToFill.dropLat && vm.dataToFill.serviceTypeSelected) {
                getFixedRoutesForPersonal(vm.dataToFill, 1);
            }
        };


        //////////////////// CALCULATE RETURN TRIP PRICE ////////////////////
        function calulatePriceReturn(payload) {





            //TDM213 BOTH FOR FIXED AND VARIABLE
            vm.toll_price_return = 0;
            vm.toll_id_return = false;
            for (var i = 0; i < payload.title.data.finalResult_return.price_list.itemOfCharge.length; i++) {
                if (payload.title.data.finalResult_return.price_list.itemOfCharge[i].item_of_charge_id === 2) {
                    vm.toll_id_return = true;
                    vm.tollChargeWay = payload.title.data.finalResult_return.price_list.itemOfCharge[i].toll_charge_way;
                    vm.toll_price_return = payload.title.data.finalResult_return.price_list.itemOfCharge[i].price;
                }
            }
            if (payload.title.data.apply_charge_by_toll && vm.toll_id_return) {
                if (vm.tollChargeWay == 1) {
                    vm.tollPriceReturnToAdd = Math.round(vm.toll_price_return);
                    vm.estimated_toll_price_return = vm.tollPriceReturnToAdd * vm.tollCountReturn;
                }
                else if (vm.tollChargeWay == 2) {
                    vm.tollPriceToAdd = Math.round(vm.tollPrice);
                    vm.estimated_toll_price_return = vm.tollPriceReturnToAdd || 0;
                }
            } else {
                vm.estimated_toll_price_return = 0;
            }
            //TDM213 BOTH FOR FIXED AND VARIABLE






            console.log('debug payload', payload);
            if (payload.title.data.finalResult_return.type_of_route == 1) {

                vm.dataToFill.ReturnestimatedFareVariable = vm.dataToFill.selectedServiceDetails.fare_type ?
                    (Number(payload.title.data.finalResult_return.price) * Number(vm.dataToFill.passengerCount)) + vm.estimated_toll_price_return
                    : payload.title.data.finalResult_return.price + vm.estimated_toll_price_return;
                vm.dataToFill.ReturnestimatedFareRoute = vm.dataToFill.selectedServiceDetails.fare_type ?
                    (Number(payload.title.data.finalResult_return.price) * Number(vm.dataToFill.passengerCount)) + vm.estimated_toll_price_return
                    : payload.title.data.finalResult_return.price;
                vm.dataToFill.ReturnestimatedFare = vm.dataToFill.ReturnestimatedFareRoute;
                vm.dataToFill.ReturnestimatedFareRoute = Number(payload.title.data.finalResult_return.price) + vm.estimated_toll_price_return;
            } else {
                if (vm.dataToFill.ReturnEstimatedDistance != undefined && vm.dataToFill.etaScheduleValueReturn != undefined) {
                    console.log('debug payload', payload);
                    console.log('debug payload.title.data.finalResult_return.price_list', payload.title.data.finalResult_return.price_list);

                    // if (payload.title.data.apply_charge_by_toll) {
                    //     vm.toll_price_return = 0;
                    //     for (var i = 0; i < payload.title.data.finalResult_return.price_list[0].itemOfCharge.length; i++) {
                    //         if (payload.title.data.finalResult_return.price_list[0].itemOfCharge[i].item_of_charge_id === 2 && payload.title.data.finalResult_return.price_list[0].itemOfCharge[i].price) {
                    //             vm.toll_price_return = payload.title.data.finalResult_return.price_list[0].itemOfCharge[i].price;
                    //         }
                    //     }
                    //     if (vm.toll_price_return) {
                    //         vm.tollPriceReturnToAdd = Math.round(vm.toll_price_return);
                    //         vm.estimated_toll_price_return = vm.tollPriceReturnToAdd * vm.tollCountReturn;
                    //     }
                    //     else {
                    //         vm.tollPriceReturnToAdd = Math.round(vm.tollPriceReturn);
                    //         vm.estimated_toll_price_return = vm.tollPriceReturnToAdd;
                    //     }
                    // }
                    // else {
                    //     vm.estimated_toll_price_return = 0;
                    // }

                    vm.estimated_eta_return = (vm.dataToFill.etaScheduleValueReturn * payload.title.data.finalResult_return.time_of_trip_price);
                    vm.estimated_distance_return = (vm.dataToFill.ReturnEstimatedDistance * payload.title.data.finalResult_return.perKMChanges);
                    console.log('debug vm.estimated_toll_price_return vm.estimated_eta_return vm.estimated_distance_return', vm.estimated_toll_price_return, vm.estimated_eta_return, vm.estimated_distance_return, vm.tollPriceReturnToAdd, vm.tollCountReturn);
                    var Return_calEstFare = Number(vm.estimated_distance_return + vm.estimated_eta_return + vm.estimated_toll_price_return + payload.title.data.finalResult_return.baseFare);
                    console.log('debug Return_calEstFare', Return_calEstFare);
                }
                vm.dataToFill.ReturnestimatedFareRoute = vm.dataToFill.selectedServiceDetails.fare_type ? ((Number(Return_calEstFare) * Number(vm.dataToFill.passengerCount)) < payload.title.data.minimumFare ? payload.title.data.finalResult_return.minimumFare : (Number(Return_calEstFare) * Number(vm.dataToFill.passengerCount))) : (Return_calEstFare < payload.title.data.finalResult_return.minimumFare ? payload.title.data.finalResult_return.minimumFare : Return_calEstFare);
                vm.dataToFill.ReturnestimatedFare = vm.dataToFill.ReturnestimatedFareRoute;
                vm.dataToFill.ReturnestimatedFareVariable = Return_calEstFare;
                vm.dataToFill.ReturnestimatedFareRoute = Return_calEstFare;
                vm.dataToFill.ReturnminimumFare = payload.title.data.finalResult_return.minimumFare;
            }

            //========================Repeated Block Need to check the requirement of this========================
            if (vm.dataToFill.Return_policy.route_type == 1) {
                vm.dataToFill.Return_policy.estimatedFareVariable = vm.dataToFill.selectedServiceDetails.fare_type ?
                    (Number(payload.title.data.finalResult_return.price) * Number(vm.dataToFill.passengerCount)) + vm.estimated_toll_price_return
                    : payload.title.data.finalResult_return.price + vm.estimated_toll_price_return;
                vm.dataToFill.Return_policy.$estimatedFareRoute = vm.dataToFill.selectedServiceDetails.fare_type ?
                    (Number(payload.title.data.finalResult_return.price) * Number(vm.dataToFill.passengerCount)) + vm.estimated_toll_price_return
                    : payload.title.data.finalResult_return.price + vm.estimated_toll_price_return;
                vm.dataToFill.Return_policy.estimatedFare = vm.dataToFill.Return_policy.$estimatedFareRoute;
                vm.dataToFill.Return_policy.estimatedFareRoute = Number(payload.title.data.price) + vm.estimated_toll_price_return;
                vm.estimatedFareRouteForRoundTrip = Number(vm.dataToFill.selectedServiceDetails.fare_type ?
                    (Number(payload.title.data.finalResult_return.price) * Number(vm.dataToFill.passengerCount)) + vm.estimated_toll_price_return
                    : payload.title.data.finalResult_return.price) + vm.estimated_toll_price_return;
            } else {
                if (vm.dataToFill.ReturnEstimatedDistance != undefined && vm.dataToFill.etaScheduleValueReturn != undefined) {
                    console.log('debug payload', payload);
                    console.log('debug payload.title.data.finalResult_return.price_list', payload.title.data.finalResult_return.price_list);

                    // if (payload.title.data.apply_charge_by_toll) {
                    //     vm.toll_price_return = 0;
                    //     for (var i = 0; i < payload.title.data.finalResult_return.price_list[0].itemOfCharge.length; i++) {
                    //         if (payload.title.data.finalResult_return.price_list[0].itemOfCharge[i].item_of_charge_id === 2 && payload.title.data.finalResult_return.price_list[0].itemOfCharge[i].price) {
                    //             vm.toll_price_return = payload.title.data.finalResult_return.price_list[0].itemOfCharge[i].price;
                    //         }
                    //     }
                    //     if (vm.toll_price_return) {
                    //         vm.tollPriceReturnToAdd = Math.round(vm.toll_price_return);
                    //         vm.estimated_toll_price_return = vm.tollPriceReturnToAdd * vm.tollCountReturn;
                    //     }
                    //     else {
                    //         vm.tollPriceReturnToAdd = Math.round(vm.tollPriceReturn);
                    //         vm.estimated_toll_price_return = vm.tollPriceReturnToAdd;
                    //     }
                    // }
                    // else {
                    //     vm.estimated_toll_price_return = 0;
                    // }

                    vm.estimated_eta_return = (vm.dataToFill.etaScheduleValueReturn * payload.title.data.finalResult_return.time_of_trip_price);

                    vm.estimated_distance_return = (vm.dataToFill.ReturnEstimatedDistance * payload.title.data.finalResult_return.perKMChanges);

                    console.log('debug vm.estimated_toll_price_return vm.estimated_eta_return vm.estimated_distance_return', vm.estimated_toll_price_return, vm.estimated_eta_return, vm.estimated_distance_return, vm.tollPriceReturnToAdd, vm.tollCountReturn);

                    var calEstFare = Number(vm.estimated_distance_return + vm.estimated_eta_return + vm.estimated_toll_price_return + payload.title.data.finalResult_return.baseFare);
                    console.log('debug calEstFare', calEstFare);
                }
                vm.dataToFill.Return_policy.estimatedFareRoute = vm.dataToFill.selectedServiceDetails.fare_type ? ((Number(calEstFare) * Number(vm.dataToFill.passengerCount)) < payload.title.data.finalResult_return.minimumFare ? payload.title.data.finalResult_return.minimumFare : (Number(calEstFare) * Number(vm.dataToFill.passengerCount))) : (calEstFare < payload.title.data.finalResult_return.minimumFare ? payload.title.data.finalResult_return.minimumFare : calEstFare);
                vm.dataToFill.Return_policy.estimatedFare = vm.dataToFill.Return_policy.estimatedFareRoute;
                vm.dataToFill.Return_policy.estimatedFareVariable = calEstFare;
                vm.dataToFill.Return_policy.estimatedFareRoute = calEstFare;
                vm.dataToFill.Return_policy.minimumFare = payload.title.data.finalResult_return.minimumFare;
            }
        }
        //////////////////// CALCULATE RETURN TRIP PRICE ////////////////////

        //////////////////// CALCULATE RETURN PICKUP TIME IF SERVICE IS SHARED  ////////////////////
        function calculateEstimatePickUpTimeReturn(eta) {
            var etaSeconds, dropDateTimeNewFormat;
            if (vm.dataToFill.selectedServiceDetails.category == 1) {
                etaSeconds = Math.round(eta) * 60 + vm.dataToFill.time_trip_shared_service * 60;
            } else {
                etaSeconds = Math.round(eta) * 60;
            }
            var addEtaSeconds = vm.tolerance_for_shared_R * 60;
            vm.etaSeconds = etaSeconds;
            if (new Date(vm.dataToFill.returnDateShared) != 'Invalid Date' && new Date(vm.dataToFill.returnTimeShared) != 'Invalid Date') {
                vm.showPickUpTime = true;
                vm.showPickUpTimeForRtype = false;
                dropDateTimeNewFormat = dateTimeFormat(vm.dataToFill.returnDateShared, vm.dataToFill.returnTimeShared);
                var pickRange3 = moment(dropDateTimeNewFormat).subtract(etaSeconds, 'seconds');
                var newpickRange3 = moment(pickRange3).subtract(addEtaSeconds, 'seconds');
                vm.pickRange5 = moment(newpickRange3).format('HH:mm');
                var pickRange3ToShowAdd = moment(pickRange3).add(addEtaSeconds, 'seconds');
                vm.pickRange3ToShowAdd = moment(pickRange3ToShowAdd).format('HH:mm');
            } else {
                vm.showPickUpTime = false;
            }
            //get_cuota_rt();
        }

        function retunrTimeSharedChanged() {
            // vm.dataToFill.returnTimeShared = dateTimeFormat(vm.dataToFill.returnDateShared,vm.dataToFill.returnTimeShared);
            //vm.dataToFill.returnDateShared = undefined;
            if(vm.dataToFill.returnTimeShared == null){
                return;
            }
            if (vm.dataToFill.selectedServiceDetails.category == 1){
                setTimeout(function () {
                calculateEstimatePickUpTimeReturn(vm.dataToFill.etaScheduleValueReturn);
                }, 600);
            }
            if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip == 'R'){
                setTimeout(function () {
                calculateEstimatePickUpTimeForRType(vm.dataToFill.etaScheduleValueReturn);
                }, 600);
            }
            if (vm.type_of_trip == 'R' && vm.method_range_pickup == 1 && vm.dataToFill.selectedServiceDetails.category == 1) {
                if (vm.dataToFill.roundTrip) {
                    if (vm.dataToFill.returnTimeShared != '' && vm.dataToFill.returnDateShared != '') {
                        // RoutingApiFuncationRoundTrip(vm.dataToFill);
                        $timeout(function () {
                            RoutingApiFuncationRoundTrip_quick(vm.dataToFill)
                        }, 1000);
                    }
                }
            }
            setTimeout(function () {
            getFixedRoutesForPersonal(vm.dataToFill);
            }, 600);
        }

        function returnDateShared() {
            if (vm.dataToFill.returnDateShared) {
                console.log(vm.dataToFill.returnDateShared, 'vm.dataToFill.returnDateShared');
                vm.dataToFill.returnTimeShared = new Date();
                vm.dataToFill.returnTimeShared.setMinutes(vm.dataToFill.returnTimeShared.getMinutes() + 35);
            }
            vm.dataToFill.returnTimeShared = dateTimeFormat(vm.dataToFill.returnDateShared, vm.dataToFill.returnTimeShared);
            if (vm.dataToFill.selectedServiceDetails.category == 1){
                calculateEstimatePickUpTimeReturn(vm.dataToFill.etaScheduleValueReturn);
            }
            if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip == 'R'){
                calculateEstimatePickUpTimeForRType(vm.dataToFill.etaScheduleValueReturn);
            }
            //get_cuota_rt();
            if (vm.type_of_trip == 'R' && vm.method_range_pickup == 1 && vm.dataToFill.selectedServiceDetails.category == 1) {
                if (vm.dataToFill.roundTrip) {
                    if (vm.dataToFill.returnTimeShared != '' && vm.dataToFill.returnDateShared != '') {
                        RoutingApiFuncationRoundTrip_quick(vm.dataToFill);
                    }
                }
            }
            getFixedRoutesForPersonal(vm.dataToFill);
        }
        //////////////////// CALCULATE RETURN PICKUP TIME IF SERVICE IS SHARED  ////////////////////


        /////////// FUNCATION TO CALCULATE EXCLUSIVE WITH R PICKUP TIME //////////////////////////
        function calculateEstimatePickUpTimeForRType(eta) {
            var etaSeconds;
            etaSeconds = Math.round(eta) * 60;
            var tolerance = vm.travel_time_service_pick_up * 60;
            var addTolerance = vm.tolerance_time_withdrawal_pickup * 60;
            console.log(tolerance, 'tolerance');
            console.log(etaSeconds, 'etaSeconds');
            console.log(addTolerance, 'addTolerance');
            var dropDateTimeNewFormat;
            if (new Date(vm.dataToFill.returnDateShared) != 'Invalid Date' && new Date(vm.dataToFill.returnTimeShared) != 'Invalid Date') {
                dropDateTimeNewFormat = dateTimeFormat(vm.dataToFill.returnDateShared, vm.dataToFill.returnTimeShared);
            } else {
                dropDateTimeNewFormat = new Date();
            }
            var pickRange1 = moment(dropDateTimeNewFormat).add(tolerance, 'seconds');
            var pickRange10 = moment(pickRange1).format('HH:mm');
            var pickRange2 = moment(dropDateTimeNewFormat).format('HH:mm');
            vm.pickRange10 = pickRange10;
            vm.pickRange2 = pickRange2;

            if (new Date(vm.dataToFill.returnDateShared) != 'Invalid Date' && new Date(vm.dataToFill.returnTimeShared) != 'Invalid Date') {
                vm.showPickUpTimeForRtype = true;
                vm.showPickUpTime = false;
                console.log("dropDateTimeNewFormat======>",dropDateTimeNewFormat)
                //var pickRangeForRtype = moment(dropDateTimeNewFormat).subtract(etaSeconds, 'seconds').subtract(tolerance, 'seconds');
                var pickRangeForRtype = moment(dropDateTimeNewFormat).add(0, 'seconds')
                vm.errorShowDateForRType = pickRangeForRtype;
                if (vm.is_group_allowed == 1) {
                    var newpickRangeForRtype = moment(pickRangeForRtype).subtract(addTolerance, 'seconds');
                    vm.pickRangeForRType = moment(newpickRangeForRtype).format('HH:mm');
                } else {
                     vm.pickRangeForRType = moment(pickRangeForRtype).format('HH:mm');
                    //vm.pickRangeForRType = moment(dropDateTimeNewFormat).format('HH:mm');
                }
                vm.pickRangeForRType = moment(pickRangeForRtype).format('HH:mm');
                // vm.pickRangeForRType = moment(dropDateTimeNewFormat).format('HH:mm');
                var pickRangeForEstimated = moment(pickRangeForRtype).add(addTolerance, 'seconds');
            
                vm.pickRangeForEstimated = moment(pickRangeForEstimated).format('HH:mm');
              
                console.log(vm.pickRangeForRType, 'pickRangeForRType', 'pickRangeForEstimated', vm.pickRangeForEstimated);
                get_cuota_rt();
                
            } else {
                vm.showPickUpTimeForRtype = false;
            }
        }

        // ============================= Rounding Function ============================= //
        function roundToTwo(num) {
            console.log('debug num', num, +(Math.round(num + "e+2") + "e-2"));
            return +(Math.round(num + "e+2") + "e-2");
        }

        function calculateAndDisplayRoute(directionsService, directionsDisplay, lat1, lng1, lat2, lng2, map, type, payload) {
            console.log("calculateAndDisplayRoute>>>>>>", lat1, lng1, lat2, lng2);

            directionsDisplay.setMap(map);
            directionsDisplay.setOptions({
                suppressMarkers: true
            });
            var myLatlng = new google.maps.LatLng(lat1, lng1);
            var myLatlng1 = new google.maps.LatLng(lat2, lng2);
            var sendDate;
            if (vm.dataToFill.returnDate != '') {
                sendDate = new Date(vm.dataToFill.returnDate);
            } else {
                sendDate = new Date();
            }
            var dataSend = {};
            dataSend.picklat = lat1;
            dataSend.picklng = lng1;
            dataSend.droplat = lat2;
            dataSend.droplng = lng2;
            dataSend.departure = new Date(sendDate).toISOString();
            tollCostEstimatedRouteHereMaps(lat1, lng1, lat2, lng2, sendDate, type, payload);
        }

        function tollCostEstimatedRouteHereMaps(lat1, lng1, lat2, lng2, sendDate, type, payloadSearchFixedVariable) {
            var dataSend = {};
            dataSend.waypoint0 = lat1 + ',' + lng1;
            dataSend.waypoint1 = lat2 + ',' + lng2;
            dataSend.departure_date = moment.utc(sendDate).format('YYYY-MM-DDTHH:mm:ss-00');
            dataSend.origen = "panel-quick";
            var promise = getBookings.tollCostEstimatedRouteHereMaps(dataSend);
            vm.loading = true;
            promise.then(
                function (payload) {
                    vm.loading = false;
                    console.log('debug tollCostEstimatedRouteHereMaps payload', payload);
                    if (payload.title.status == 400) {
                        if (payload.title.data && payload.title.data.custom_error) {
                            openPopForErrorAddress(payload);
                        } else {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (type == 'ROUND TRIP') {
                            vm.tollPriceReturn = payload.title.data.tollPrice;
                            vm.tollCountReturn = payload.title.data.tollCount;
                            vm.dataToFill.etaScheduleValueReturn = Math.round(payload.title.data.etaInSeconds / 60);
                            vm.dataToFill.ReturnEstimatedDistance = roundToTwo((payload.title.data.distanceInMeters / 1000));
                            vm.ReturnEstimatedDistanceToSend = payload.title.data.distanceInMeters;
                            if (payloadSearchFixedVariable){
                                calulatePriceReturn(payloadSearchFixedVariable);
                             }
                                
                         
                            if (vm.dataToFill.selectedServiceDetails.category == 1){
                               calculateEstimatePickUpTimeReturn(vm.dataToFill.etaScheduleValueReturn);
                            }   
                            if (vm.dataToFill.selectedServiceDetails.category == 0){
                              calculateEstimatePickUpTimeForRType(vm.dataToFill.etaScheduleValueReturn);
                            }
                            vm.heremaps_toll_details_return = payload.title.data;
                        } else {
                            vm.tollPrice = payload.title.data.tollPrice;
                            vm.tollCount = payload.title.data.tollCount;
                            vm.dataToFill.etaSchedule = Math.round(payload.title.data.etaInSeconds / 60);
                            vm.dataToFill.etaScheduleValue = Math.round(payload.title.data.etaInSeconds / 60);
                            vm.dataToFill.estimatedDistance = roundToTwo((payload.title.data.distanceInMeters / 1000));
                            vm.estimatedDistanceToSend = payload.title.data.distanceInMeters;
                            vm.heremaps_toll_details = payload.title.data;
                        }
                        setTimeout(function () {
                            vm.disabledSubmitButton1 = false;
                        }, 1500);
                    }
                    //get_cuota_rt();
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        //errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //================egt focus of drop off location================
        function getPreviousAddressHit() {
            if (!vm.dataToFill.customerId && !vm.dataToFill.newCustomerFlag) {
                languageBasedErrorFactory.getProperErrorMessage('selectCustomerf', 0, 0);
                //errorMessageFactory.showErrorMessage('Please fill customer details first',0);
                return;
            }
        }

        //========================search customer=========================
        function searchCustomer(data) {
            if (data && vm.dataToFill.customer.length > 3) {
                //return vm.allCustomersList;
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.search_id = data.toString();
                var promise = getCustomers.getCustomerAccordingToSearch(dataSend);
                return promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        if (payload.title.status == 400) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            return [];
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                            return [];
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            if (payload.title.data.length > 0) {
                                return payload.title.data;
                            } else {
                                vm.flagforError = true;
                                return [];
                            }
                        }

                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            //errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                        }
                    }
                );
            } else {
                return [];
            }
        };

        //========================add new customer========================
        function addNewCustomer() {
            console.log(" i m here in addNewCustomer");
            vm.dataToFill.newCustomerFlag = true;
            vm.dataToFill.customerMobile = '';
            vm.dataToFill.customerId = '';
            vm.dataToFill.previousCustomerId = '';
            vm.dataToFill.customerEmail = '';
            vm.dataToFill.employeeId = '';
            vm.dataToFill.customerProfile = vm.dataToFill.spotShow ? 0 : 1;
            // if (vm.flagToshow == false) {
            //     vm.dataToFill.customerProfile = vm.dataToFill.spotShow ? 1 : 0;
            // } else {
            //     vm.dataToFill.customerProfile = vm.dataToFill.spotShow ? 1 : 0;
            // }
            // vm.dataToFill.contractIdSelected = '';
        };


        //=====================pickupfav address =========================
        function pickFavAddress($event) {
            getCustomerFavouriteAddress('popUp');
        };



        function openPopForFavouriteAddress($event) {
            vm.pickLocationList = [];
            vm.pickLocationListAgreement = [];
            if (vm.dataToFill.favDropLocId) {
                for (var i = 0; i < vm.favAddressList.length; i++) {
                    if (Number(vm.dataToFill.favDropLocId) != vm.favAddressList[i].location_id) {
                        vm.pickLocationList.push(vm.favAddressList[i]);
                    }
                }
            } else {
                for (var i = 0; i < vm.favAddressList.length; i++) {
                    vm.pickLocationList.push(vm.favAddressList[i]);
                }
            }
            vm.items = {
                list: vm.pickLocationList,
                errMsg: '',
                selected: '',
                agreementList: vm.pickLocationListAgreement,
                searchaddress: ''
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/favAddressesView.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });

            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.colorFlag = [];
                $scope.maxLimit = 0;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                    if ((vm.dataToFill.dropLat && vm.dataToFill.dropLng))
                        getFavoriteAddress('pick');
                };
                $scope.divSelected = function (data, index) {
                    if ($scope.colorFlag[index] == true) {
                        $scope.colorFlag[index] = false;
                        $scope.items.selected = null;
                    } else {
                        $scope.colorFlag = [];
                        $scope.colorFlag[index] = true;
                        $scope.items.selected = data.location_id;
                    }
                }
                $scope.getFilter = function () {
                    $scope.items.list = [];
                    $scope.items.agreementList = [];
                    if (vm.dataToFill.customerId == null || vm.dataToFill.customerId == undefined || vm.dataToFill.customerId == '') {
                        return false;
                    }
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.customer_id = vm.dataToFill.customerId;
                    if (vm.personalFlag == true) {
                        dataSend.contract_id = vm.dataToFill.contractIdSelected;
                    } else {
                        dataSend.contract_id = vm.dataToFill.customerContarctId;
                    }
                    if ($scope.items.searchaddress != '')
                        dataSend.search_value = $scope.items.searchaddress;
                    vm.loading = true;
                    var promise = getCustomers.getFavoriteLocation(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            vm.loading = false;
                            if (payload.title.data.length) {
                                $scope.items.listarray = payload.title.data;
                                for (var i = 0; i < $scope.items.listarray.length; i++) {
                                    if ($scope.items.listarray[i].aggreement_address == 0) {
                                        $scope.items.list.push($scope.items.listarray[i]);
                                    } else {
                                        $scope.items.list.push($scope.items.listarray[i]);
                                    }
                                }
                                vm.favAddFlag = true;
                                vm.favAddFlagI = {
                                    'width': '65%'
                                };
                                vm.favAddFlagB = {
                                    'width': '35%'
                                };
                                // if (type == 'popUp') {
                                //     openPopForFavouriteAddress($event);
                                // }
                            } else {
                                vm.favAddressList = [];
                                vm.favAddFlag = false;
                                vm.favAddFlagI = {
                                    'width': '100%'
                                };
                                vm.favAddFlagB = {
                                    'width': '0%'
                                };
                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }
                $scope.deleteFavouriteAddress = function (data, index) {
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.location_id = data.location_id;
                    dataSend.is_admin = 1;
                    dataSend.customer_id = vm.dataToFill.customerId;
                    vm.loading = true;
                    var promise = getBookings.setUnFavouriteAddress(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            vm.loading = false;
                            if (payload.title.status == 200) {
                                $scope.items.list.splice(index, 1);
                            } else {
                                vm.isActivePick = !vm.isActivePick;
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            $scope.items.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }
                $scope.confirmUpload = function () {
                    $log.log('confirmed', $scope.items);
                    if ($scope.items.selected == null) {
                        $scope.items.errMsg = languageBasedErrorFactory.getProperErrorMessage('selectLocationError', 0, '3');
                        $timeout(function () {
                            $scope.items.errMsg = '';
                        }, 2000);
                    } else {
                        $mdDialog.hide();
                        vm.dataToFill.favPickLocId = $scope.items.selected;
                        vm.addressChange = true;
                        makeByPassFunctionForFav();
                    }
                };
            }
        }


        function makeByPassFunctionForFav() {
            // reverseGeocodeForFavPickUp(vm.dataToFill.pickUpAddress);
            var where = _.where(vm.favAddressList, {
                location_id: Number(vm.dataToFill.favPickLocId)
            });
            console.log('where', where, vm.dataToFill);
            vm.dataToFill.dropOffAddress = where[0].address;
            if (vm.getInfoFlag == true) {
                var geocoder = new google.maps.Geocoder;
                vm.pickaddressChange = true;
                geocoder.geocode({
                    'address': vm.dataToFill.dropOffAddress
                }, function (results, status) {
                    if (status === 'OK') {
                        var city;
                        for (var i = 0; i < results[0].address_components.length; i++) {
                            for (var j = 0; j < results[0].address_components[i].types.length; j++) {
                                if (results[0].address_components[i].types[j] == 'locality') {
                                    city = results[0].address_components[i].short_name;
                                    vm.jobPickupComuna = city;
                                }
                            }
                        }
                        if (vm.pickUpCity && (vm.pickUpCity != city)) {
                            errorMessageFactory.showErrorMessage('Error, esta dirección cambia el tramo original. El cambio no debe afectar la tarifa.', 0);
                            vm.dataToFill.dropOffAddress = vm.pickUpAddress;
                            return;

                        } else {
                            // reverseGeocodeForFavPickUp(vm.dataToFill.pickUpAddress);
                            vm.dataToFill.dropLat = where[0].latitude;
                            vm.dataToFill.dropLng = where[0].longtitude;
                            var location = new google.maps.LatLng(Number(where[0].latitude), Number(where[0].longtitude));
                            placeMarker(map, location, 'drop');
                            if (vm.dataToFill.serviceTypeSelected) { //&& (vm.dataToFill.bookingType == '0' || vm.dataToFill.bookingType == 0)
                                vm.dataToFill.nearDriver = '';
                                toGetAirportService(vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.serviceTypeSelected, map);
                                //toGetNearByDrivers(vm.dataToFill.pickUpLat,vm.dataToFill.pickUpLng,vm.dataToFill.serviceTypeSelected,map);
                            }
                        }
                    } else {
                        window.alert('Geocode was not successful for the following reason: ' +
                            status);
                    }
                });
            } else {
                // reverseGeocodeForFavPickUp(vm.dataToFill.pickUpAddress);
                vm.dataToFill.dropLat = where[0].latitude;
                vm.dataToFill.dropLng = where[0].longtitude;
                vm.jobPickupComuna = where[0].communa;
                var location = new google.maps.LatLng(Number(where[0].latitude), Number(where[0].longtitude));
                placeMarker(map, location, 'drop');

                for (var i = 0; i < vm.dataToFill.serviceTypeList.length; i++) {
                    vm.dataToFill.serviceTypeList[i].active = false;
                }
                vm.dataToFill.serviceTypeSelected = '';
                vm.dataToFill.selectedServiceDetails = '';
                vm.FlagToShowEstimatedPrice = false;
                vm.numberFLag = -1;
                for (var i = 0; i < vm.dataToFill.paymentMethodList.length; i++) {
                    vm.dataToFill.paymentMethodList[i].active = false;
                }

                if (vm.dataToFill.serviceTypeSelected) { //&& (vm.dataToFill.bookingType == '0' || vm.dataToFill.bookingType == 0)
                    vm.dataToFill.nearDriver = '';
                    toGetAirportService(vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.serviceTypeSelected, map);
                    //toGetNearByDrivers(vm.dataToFill.pickUpLat,vm.dataToFill.pickUpLng,vm.dataToFill.serviceTypeSelected,map);
                }
            }
            if ((vm.dataToFill.dropLat && vm.dataToFill.dropLng))
                getFavoriteAddress('pick');
        }

        //==========================get customer faourite address=============================
        function getCustomerFavouriteAddress(type, $event) {
            if (vm.dataToFill.customerId == null || vm.dataToFill.customerId == undefined || vm.dataToFill.customerId == '') {
                return false;
            }
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.customer_id = vm.dataToFill.customer.customer_id ? vm.dataToFill.customer.customer_id : vm.dataToFill.customerId;
            dataSend.contract_id = vm.dataToFill.contractIdSelected;
            vm.loading = true;
            var promise = getCustomers.getFavoriteLocation(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.data.length) {
                        vm.favAddressList = payload.title.data;
                        vm.favAddFlag = true;
                        vm.favAddFlagI = {
                            'width': '65%'
                        };
                        vm.favAddFlagB = {
                            'width': '25%'
                        };
                        if (type == 'popUp') {
                            openPopForFavouriteAddress($event);
                        }
                    } else {
                        vm.favAddressList = [];
                        vm.favAddFlag = false;
                        vm.favAddFlagI = {
                            'width': '100%'
                        };
                        vm.favAddFlagB = {
                            'width': '0%'
                        };
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }







        //======================selecting particular customer=========================
        function onSelectingCustomer() {
            vm.flagforError = false;
            vm.dataToFill.customerMobile = vm.dataToFill.customer.phone_number;
            vm.dataToFill.customerId = vm.dataToFill.customer.customer_id;
            vm.dataToFill.previousCustomerId = vm.dataToFill.customer.customer_id;
            vm.dataToFill.customerEmail = vm.dataToFill.customer.email;
            vm.dataToFill.employeeId = vm.dataToFill.customer.customer_id;
            vm.dataToFill.category_name = vm.dataToFill.customer.category_name;
            vm.dataToFill.category_background = vm.dataToFill.customer.category_background;
            vm.dataToFill.category_foreground = vm.dataToFill.customer.category_foreground;
            vm.dataToFill.authRequired = '';
            vm.dataToFill.customerProfile = vm.dataToFill.spotShow ? 0 : 1;
            checkCustomerIsAllowedInContract(vm.dataToFill.customer.customer_id);

        };

        //=======================get spot agreement for personal======================
        function getSpotAgreement() {
            vm.loading = true;
            var promise = getBookings.getSpotAgreementForBooking();
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.data) {
                        vm.dataToFill.serviceTypeList = [];
                        vm.dataToFill.paymentMethodList = [];
                        // vm.dataToFill.contractIdSelected = payload.title.data.contract_id.id;
                        vm.dataToFill.payment_method = payload.title.data.contract_id.payment_method_default;
                        vm.FlagToCheckViaControl = payload.title.data.contract_id.controlled_way;
                        restriccion_flota = payload.title.data.contract_id.restriccion_flota;
                        for (var i = 0; i < payload.title.data.payment.length; i++) {
                            for (var j = 0; j < payload.title.data.payment[i].mapping.length; j++) {
                                if (payload.title.data.payment[i].mapping[j].channel_name == 'POS') {
                                    vm.dataToFill.paymentMethodList.push(payload.title.data.payment[i]);
                                }
                            }
                        }

                        for (var i = 0; i < payload.title.data.service_types.length; i++) {
                            for (var j = 0; j < vm.dataToFill.operationData.service.length; j++) {
                                if (Number(payload.title.data.service_types[i].id) == Number(vm.dataToFill.operationData.service[j].service_type_id)) {
                                    vm.dataToFill.serviceTypeList.push(payload.title.data.service_types[i]);
                                }
                            }
                        }

                        if (vm.dataToFill.serviceTypeList.length == 0) {
                            vm.dataToFill.noService = true;
                        }

                        console.log('vm.dataToFill.serviceTypeList', vm.dataToFill.serviceTypeList);

                        vm.dataToFill.passengerRutCheck = payload.title.data.contract_id.RUT_mendatory;
                        vm.dataToFill.applicantRutCheck = payload.title.data.contract_id.applicant_RUT_mendatory;
                        vm.dataToFill.costCenterCheck = payload.title.data.contract_id.cost_center_mandatory;
                        vm.dataToFill.costSubCenterCheck = payload.title.data.contract_id.cost_sub_center_mandatory;
                        vm.dataToFill.RolCheck = payload.title.data.contract_id.ROL_mandatory;
                        vm.dataToFill.graphCheck = payload.title.data.contract_id.graph_mandatory;
                        vm.dataToFill.workOrderCheck = payload.title.data.contract_id.work_order_mandatory;
                        vm.dataToFill.pepCheck = payload.title.data.contract_id.PEP_mandatory;
                        vm.dataToFill.purposeOfTripCheck = payload.title.data.contract_id.purpose_of_trip_mandatory;
                        vm.dataToFill.noOfVoucherCheck = payload.title.data.contract_id.number_of_voucher_mandatory;
                        vm.dataToFill.nominaCheck = payload.title.data.contract_id.nomina_mandatory;
                        vm.dataToFill.solictudCheck = payload.title.data.contract_id.solicitud_mandatory;
                        vm.dataToFill.controllerWayTarifa = payload.title.data.contract_id.via_control_include_in_tarifa;
                        vm.dataToFill.rt_discount = payload.title.data.contract_id.rt_discount;
                        vm.dataToFill.webDiscount = payload.title.data.contract_id.web_discount;
                        vm.dataToFill.allowChangeFarePanel = payload.title.data.contract_id.allow_change_fare_POS || 0;
                        vm.click = false; //Because after click on modify input field will change when personal or corporate changes

                        vm.dataToFill.controlledWayCheck = payload.title.data.contract_id.controlled_way;

                        for (var i = 0; i < vm.dataToFill.serviceTypeList.length; i++) {
                            vm.dataToFill.serviceTypeList[i].disabled = false;
                            vm.dataToFill.serviceTypeList[i].active = false;
                        }
                        if (vm.dataToFill.paymentMethodList.length == 0) {
                            var where = _.where(payload.title.data.payment, {
                                id: Number(vm.dataToFill.payment_method)
                            })[0];
                            vm.dataToFill.paymentMethodList.push(where);
                        } else {
                            var where = _.where(vm.dataToFill.paymentMethodList, {
                                id: Number(vm.dataToFill.payment_method)
                            });
                            if (!where && where.length == 0) {
                                vm.dataToFill.payment_method = 0;
                                vm.dataToFill.paymentMethodSelected = '';
                            }
                        }
                        for (var i = 0; i < vm.dataToFill.paymentMethodList.length; i++) {
                            vm.dataToFill.paymentMethodList[i].active = false;
                            if (vm.dataToFill.paymentMethodList[i].id == Number(vm.dataToFill.payment_method)) {
                                vm.dataToFill.paymentMethodList[i].active = true;
                                vm.dataToFill.paymentMethodSelected = vm.dataToFill.paymentMethodList[i];
                            }
                        }
                    } else {
                        // vm.dataToFill.contractIdSelected = '';
                        vm.dataToFill.serviceTypeList = [];
                        vm.dataToFill.paymentMethodList = [];
                    }
                    getCustomerFavouriteAddress();
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }


        //======================get corporate agreement=============================
        function getCorporateAgreement(data) {
            vm.dataToFill.contractList = [];
            vm.dataToFill.contractListShowing = [];
            vm.matchArray = [];
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.employee_id = vm.dataToFill.employeeId ? vm.dataToFill.employeeId : data;
            // vm.dataToFill.customerProfile = 1;
            //dataSend.contract_id = vm.dataToFill.customerContarctId;
            vm.loading = true;
            var promise = getBookings.getCorporateAgreementForBooking(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    console.log(payload, "heelo");
                    if (payload.title.data) {
                        for (var i = 0; i < payload.title.data.length; i++) {
                            vm.dataToFill.contractList.push(payload.title.data[i]);
                            vm.dataToFill.contractListShowing.push({
                                id: payload.title.data[i].id,
                                name: payload.title.data[i].name,
                                is_block: payload.title.data[i].employee_details.panel_booking_access || 0
                            });
                            vm.matchArray.push(payload.title.data[i].id);
                        }
                    } else {
                        vm.dataToFill.contractList = [];
                        vm.dataToFill.contractListShowing = [];
                        vm.matchArray = [];
                        //vm.serviceTypeList = [];
                    }
                    console.log(vm.dataToFill.contractListShowing, vm.matchArray, ' vm.dataToFill.contractListShowing');

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        //=======================get fixed routes for personal========================
        function getFixedRoutesForPersonal(data, addressChangeData) {

            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.pickup_lat = data.pickLat;
            dataSend.pickup_long = data.pickLng;
            dataSend.drop_lat = data.dropLat;
            dataSend.drop_long = data.dropLng;
            dataSend.contract_id = data.contractIdSelected;
            dataSend.service_type = data.serviceTypeSelected;
            var fecha;
            if(data.selectedServiceDetails.category == 1 && vm.pickRange1 && vm.pickRange2 && data.airportCheck != 'Z'  &&  vm.method_range_pickup){
                if(vm.pickRangeForRouting){
                    fecha = moment(data.dropDate).format('YYYY-MM-DD') +' '+ vm.pickRangeForRouting;
                }
            } else if(data.selectedServiceDetails.category == 1 && vm.pickRange1 && vm.pickRange2 && data.airportCheck != 'Z'  &&  !vm.method_range_pickup){
                fecha = moment(data.dropDate).format('YYYY-MM-DD') +' '+ vm.newPickRange3;
            } else if(data.scheduledBooking && data.selectedServiceDetails.category == 1){
                fecha = data.dropTime;
            } else {
                if(data.bookingType == '0'){
                    fecha = data.dropDate;
                } else {
                    if(data.scheduledBooking == 1){
                        fecha = data.scheduledTime;
                    } else {
                        fecha = data.dropDate;
                    } 
                }
            }
            if(fecha == null && vm.dataToFill.roundTrip){
                return;
            }
            dataSend.pickup_datetime = moment(fecha).format('YYYY-MM-DDTHH:mm:ss');
            var fecha_return = moment().format('YYYY-MM-DDTHH:mm:ss');
            if(vm.dataToFill.returnDateShared && vm.dataToFill.selectedServiceDetails.category == 0)
                fecha_return = moment(vm.dataToFill.returnDateShared).format('YYYY-MM-DD H:mm:ss');
            if(vm.method_range_pickup && vm.showPickUpTime && vm.dataToFill.selectedServiceDetails.category == 1){
                fecha_return = moment(vm.dataToFill.returnDateShared).format('YYYY-MM-DD') + ' ' + vm.pickRange5 ;
            }
            if(vm.showPickUpTime && !vm.method_range_pickup){
                fecha_return = moment(vm.dataToFill.returnDateShared).format('YYYY-MM-DD') + ' ' +vm.dataToFill.returnTimeShared;
            }
            dataSend.pickup_datetime_return = moment(fecha_return).format('YYYY-MM-DDTHH:mm:ss');

            vm.loading = true;
            var promise = getBookings.getFixedRoutesForPersonal(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.searchFixedVariablePayload = payload;
                    if (payload.title.status == 400) {
                        vm.dataToFill.favPickLocId = '';
                        vm.dataToFill.favDropLocId = '';
                        vm.dataToFill.route_id = '';
                        vm.dataToFill.itemOfChargeList = [];
                        vm.dataToFill.itemOfChargeSelected = [];
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        vm.dataToFill.favPickLocId = '';
                        vm.dataToFill.favDropLocId = '';
                        vm.dataToFill.route_id = '';
                        vm.dataToFill.itemOfChargeList = [];
                        vm.dataToFill.itemOfChargeSelected = [];
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.loading = true;
                        vm.couponType = undefined;
                        vm.couponFlag = true;
                        vm.dataToFill.route_id = payload.title.data.id;
                        if(payload.title.data.factor){
                            if(payload.title.data.factor.bloques){
                                vm.dataToFill.factor_value = payload.title.data.factor.bloques[0].factor;
                                vm.dataToFill.factor_tipo = 0;
                                vm.dataToFill.factor_id = payload.title.data.factor.bloques[0].id;
                            } else if(payload.title.data.factor.exepciones){
                                vm.dataToFill.factor_value = payload.title.data.factor.exepciones[0].factor;
                                vm.dataToFill.factor_tipo = 1;
                                vm.dataToFill.factor_id = payload.title.data.factor.exepciones[0].id;
                            }
                        } else {
                            delete vm.dataToFill.factor_return_value;
                            delete vm.dataToFill.factor_return_tipo;
                            delete vm.dataToFill.factor_return_id;
                        }
                        if(payload.title.data.finalResult_return.factor){
                            if(payload.title.data.finalResult_return.factor.bloques){
                                vm.dataToFill.factor_return_value = payload.title.data.finalResult_return.factor.bloques[0].factor;
                                vm.dataToFill.factor_return_tipo = 0;
                                vm.dataToFill.factor_return_id = payload.title.data.finalResult_return.factor.bloques[0].id;
                            } else if(payload.title.data.finalResult_return.factor.exepciones){
                                vm.dataToFill.factor_return_value = payload.title.data.finalResult_return.factor.exepciones[0].factor;
                                vm.dataToFill.factor_return_tipo = 1;
                                vm.dataToFill.factor_return_id = payload.title.data.finalResult_return.factor.exepciones[0].id;
                            }
                        } else {
                            delete vm.dataToFill.factor_return_value;
                            delete vm.dataToFill.factor_return_tipo;
                            delete vm.dataToFill.factor_return_id;
                        }
                        sucursal_id = payload.title.data.branch;
                        //restriccion_flota = payload.title.data.restriccion_flota;
                        if (addressChangeData) {
                            vm.FlagToShowEstimatedPrice = false;
                        } else {
                            vm.FlagToShowEstimatedPrice = true;
                        }

                        vm.dataToFill.route_type = payload.title.data.type_of_route;
                        console.log(vm.dataToFill.customerProfile, 'vm.dataToFill.customerProfile');
                        if (vm.flagForOtherAgreement == true) {
                            vm.dataToFill.type_of_agreement = 1;
                        } else {
                            vm.dataToFill.type_of_agreement = vm.dataToFill.customerProfile == 0 || vm.dataToFill.customerProfile == '0' ? 0 : 1;
                        }

                        vm.dataToFill.itemOfChargeList = [];
                        console.log(payload.title.data.type_of_trip, payload.title.data.controlled_way_flag, vm.selectedEmployeeData);
                        vm.is_group_allowed = payload.title.data.is_group_allowed;
                        vm.is_group_external = payload.title.data.is_grouped_external;
                        vm.tolerance_for_shared_R = payload.title.data.tolerance;
                        if (payload.title.data.type_of_trip == "Z" && payload.title.data.controlled_way_flag == 1 && vm.FlagToCheckViaControl == 1) {
                            // vm.viaControlled1 = payload.title.data.via_controlled_price;
                            // vm.via_controlled_price_to_send = payload.title.data.via_controlled_price;
                            if (vm.dataToFill.selectedServiceDetails.fare_type == 1 &&
                                vm.dataToFill.selectedServiceDetails.category == 1) {
                                vm.viaControlled2 = payload.title.data.via_controlled_price + (payload.title.data.via_controlled_price * (vm.dataToFill.passengerCount - 1));
                                vm.via_controlled_price_to_send = payload.title.data.via_controlled_price + (payload.title.data.via_controlled_price * (vm.dataToFill.passengerCount - 1));
                                // vm.addViaControlled = 0;
                                console.log(vm.via_controlled_price_to_send, ' vm.via_controlled_price_to_send');

                            } else {
                                vm.viaControlled2 = payload.title.data.via_controlled_price;
                                vm.via_controlled_price_to_send = payload.title.data.via_controlled_price;
                                // vm.addViaControlled = 0;
                            }

                        } else {
                            vm.viaControlled1 = 0;
                            vm.via_controlled_price_to_send = 0;
                        }
                        vm.method_range_pickup = payload.title.data.method_range_pickup;
                        if (payload.title.data.type_of_trip == "Z") {
                            vm.type_of_trip1 = payload.title.data.type_of_trip;
                            vm.viaControlledFLag1 = true;
                            // vm.dataToFill.viaControlledApply = true;
                        } else {
                            vm.type_of_trip1 = payload.title.data.type_of_trip;
                            vm.viaControlledFLag1 = false;
                            // vm.dataToFill.viaControlledApply = false;
                            // && vm.dataToFill.controlledWayCheck == 1
                        }
                        if (payload.title.data.pickup_tolerance_time_pap) {
                            vm.time_trip_shared_service_point_to_point = payload.title.data.pickup_tolerance_time_pap;
                            vm.pickup_travel_time_pap = payload.title.data.pickup_travel_time_pap;
                        } else {
                            vm.time_trip_shared_service_point_to_point = 0;
                            vm.pickup_travel_time_pap = 0;
                        }
                        vm.type_of_trip_Validate_Booking = payload.title.data.type_of_trip;
                        vm.dataToFill.itemOfChargeSelected = [];
                        vm.Search_type_of_trip = payload.title.data.type_of_trip;
                        vm.tolerance_time_withdrawal_pickup = payload.title.data.tolerance_time_withdrawal_pickup;
                        vm.travel_time_service_pick_up = payload.title.data.travel_time_service_pick_up;
                        if (payload.title.data.price_list.itemOfCharge && payload.title.data.price_list.itemOfCharge.length) {
                            for (var i = 0; i < payload.title.data.price_list.itemOfCharge.length; i++) {
                                payload.title.data.price_list.itemOfCharge[i].quantity = 1;
                                payload.title.data.price_list.itemOfCharge[i].oldPrice = payload.title.data.price_list.itemOfCharge[i].price;
                                if (payload.title.data.price_list.itemOfCharge[i].tic_manually == 1) {
                                    var itemRet = payload.title.data.price_list.itemOfCharge[i];
                                    itemRet.tic_long_name = itemRet.tic_long_name + ' (Ida)';
                                    itemRet.retorno = false;
                                    vm.dataToFill.itemOfChargeList.push(itemRet);
                                }
                            }
                        } else {
                            vm.dataToFill.itemOfChargeList = [];
                        }

                        //TDM213 BOTH FOR FIXED AND VARIABLE
                        vm.toll_price = 0;
                        vm.toll_id = false;
                        for (var i = 0; i < payload.title.data.price_list.itemOfCharge.length; i++) {
                            if (payload.title.data.price_list.itemOfCharge[i].item_of_charge_id === 2) {
                                vm.toll_id = true;
                                vm.tollChargeWay = payload.title.data.price_list.itemOfCharge[i].toll_charge_way;
                                vm.toll_price = payload.title.data.price_list.itemOfCharge[i].price;
                            }
                        }
                        if (payload.title.data.apply_charge_by_toll && vm.toll_id) {
                            if (vm.tollChargeWay == 1) {
                                vm.tollPriceToAdd = Math.round(vm.toll_price);
                                vm.estimated_toll_price = vm.tollPriceToAdd * vm.tollCount;
                            }
                            else if (vm.tollChargeWay == 2) {
                                vm.tollPriceToAdd = Math.round(vm.tollPrice);
                                vm.estimated_toll_price = vm.tollPriceToAdd;
                            }
                            else {

                            }
                        } else {
                            vm.estimated_toll_price = 0;
                        }
                        //TDM213 BOTH FOR FIXED AND VARIABLE



                        if (vm.dataToFill.route_type == 1) {
                            vm.dataToFill.estimatedFareVariable = vm.dataToFill.selectedServiceDetails.fare_type ?
                                (Number(payload.title.data.price) * Number(vm.dataToFill.passengerCount)) + vm.estimated_toll_price
                                : payload.title.data.price + vm.estimated_toll_price;
                            vm.dataToFill.estimatedFareRoute = vm.dataToFill.selectedServiceDetails.fare_type ?
                                (Number(payload.title.data.price) * Number(vm.dataToFill.passengerCount)) + vm.estimated_toll_price
                                : payload.title.data.price + vm.estimated_toll_price;
                            vm.dataToFill.estimatedFare = vm.dataToFill.estimatedFareRoute;
                            vm.dataToFill.estimatedFareRoute = Number(payload.title.data.price) + vm.estimated_toll_price;
                            vm.fixedPriceFromSearchFixesVariable = (vm.dataToFill.selectedServiceDetails.fare_type ?
                                (Number(payload.title.data.price) * Number(vm.dataToFill.passengerCount)) + vm.estimated_toll_price
                                : (payload.title.data.price + vm.estimated_toll_price)) || 0;

                        } else {
                            console.log('debug vm.dataToFill.estimatedDistance', vm.dataToFill.estimatedDistance);

                            // if (payload.title.data.apply_charge_by_toll) {
                            //     vm.toll_price = 0;
                            //     for (var i = 0; i < payload.title.data.price_list[0].itemOfCharge.length; i++) {
                            //         if (payload.title.data.price_list[0].itemOfCharge[i].item_of_charge_id === 2 && payload.title.data.price_list[0].itemOfCharge[i].price) {
                            //             vm.toll_price = payload.title.data.price_list[0].itemOfCharge[i].price;
                            //         }
                            //     }
                            //     if (vm.toll_price) {
                            //         vm.tollPriceToAdd = Math.round(vm.toll_price);
                            //         vm.estimated_toll_price = vm.tollPriceToAdd * vm.tollCount;
                            //     }
                            //     else {
                            //         vm.tollPriceToAdd = Math.round(vm.tollPrice);
                            //         vm.estimated_toll_price = vm.tollPriceToAdd;
                            //     }
                            // }
                            // else {
                            //     vm.estimated_toll_price = 0;
                            // }

                            vm.estimated_eta = (vm.dataToFill.etaScheduleValue * payload.title.data.time_of_trip_price);
                            vm.estimated_distance = (vm.dataToFill.estimatedDistance * payload.title.data.perKMChanges);
                            var calEstFare = Number(vm.estimated_distance + vm.estimated_eta + vm.estimated_toll_price + payload.title.data.baseFare);
                            // var calEstFare = Number((vm.dataToFill.estimatedDistance * (payload.title.data.perKMChanges).toFixed(2)) + payload.title.data.baseFare);
                            vm.dataToFill.estimatedFareRoute = vm.dataToFill.selectedServiceDetails.fare_type ? ((Number(calEstFare) * Number(vm.dataToFill.passengerCount)) < payload.title.data.minimumFare ? vm.dataToFill.factor_value ? Number(payload.title.data.minimumFare) * vm.dataToFill.factor_value : payload.title.data.minimumFare : (Number(calEstFare) * Number(vm.dataToFill.passengerCount))) : (calEstFare < payload.title.data.minimumFare ? vm.dataToFill.factor_value ? Number(payload.title.data.minimumFare) * vm.dataToFill.factor_value : payload.title.data.minimumFare : calEstFare);
                            vm.dataToFill.estimatedFare = vm.dataToFill.estimatedFareRoute;
                            vm.dataToFill.estimatedFareVariable = calEstFare;
                            vm.dataToFill.estimatedFareRoute = calEstFare;
                            vm.dataToFill.minimumFare = payload.title.data.minimumFare;
                        }
                        if (payload.title.data.return_flag == true) {
                            vm.roundTripPayload = payload;
                            setTimeout(function () {
                                if (vm.dataToFill.dropOffAddress) {
                                    calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.dropLat, vm.dataToFill.dropLng, vm.dataToFill.pickLat, vm.dataToFill.pickLng, map, 'ROUND TRIP', vm.roundTripPayload);
                                }
                                calculateRtDiscount();
                                vm.loading = false;
                            }, 500)
                            // if (vm.dataToFill.dropOffAddress) {
                            //     calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.dropLat, vm.dataToFill.dropLng, vm.dataToFill.pickLat, vm.dataToFill.pickLng, map, 'ROUND TRIP', payload);
                            //     // getFixedRoutesForPersonal(vm.dataToFill);

                            // }
                            console.log(payload.title.data.finalResult_return.id, '++++++++++++++++++++++++++++');
                            vm.return_flag = payload.title.data.return_flag;
                            vm.dataToFill.Return_policy.route_id = payload.title.data.finalResult_return.id;
                            vm.dataToFill.Return_policy.route_type = payload.title.data.finalResult_return.type_of_route;
                            vm.dataToFill.Return_policy.type_of_agreement = vm.dataToFill.customerProfile == 0 || vm.dataToFill.customerProfile == '0' ? 0 : 1;
                            vm.dataToFill.Return_policy.itemOfChargeList = [];
                            vm.dataToFill.Return_policy.itemOfChargeSelected = [];
                            if (payload.title.data.finalResult_return.price_list.itemOfCharge && payload.title.data.finalResult_return.price_list.itemOfCharge.length) {
                                for (var i = 0; i < payload.title.data.finalResult_return.price_list.itemOfCharge.length; i++) {
                                    payload.title.data.finalResult_return.price_list.itemOfCharge[i].quantity = 1;
                                    payload.title.data.finalResult_return.price_list.itemOfCharge[i].oldPrice = payload.title.data.finalResult_return.price_list.itemOfCharge[i].price;
                                    if (payload.title.data.finalResult_return.price_list.itemOfCharge[i].tic_manually == 1) {
                                        var itemRet = payload.title.data.finalResult_return.price_list.itemOfCharge[i];
                                        itemRet.tic_long_name = itemRet.tic_long_name + ' (Vuelta)';
                                        itemRet.retorno = true;
                                        vm.dataToFill.itemOfChargeList.push(itemRet);
                                    }
                                }
                            } else {
                                vm.dataToFill.Return_policy.itemOfChargeList = [];
                            }
                            // if (payload.title.data.finalResult_return.type_of_route == 1) {
                            //     vm.dataToFill.ReturnestimatedFareVariable = vm.dataToFill.selectedServiceDetails.fare_type ? Number(payload.title.data.finalResult_return.price) * Number(vm.dataToFill.passengerCount) : payload.title.data.finalResult_return.price;
                            //     vm.dataToFill.ReturnestimatedFareRoute = vm.dataToFill.selectedServiceDetails.fare_type ? Number(payload.title.data.finalResult_return.price) * Number(vm.dataToFill.passengerCount) : payload.title.data.finalResult_return.price;
                            //     vm.dataToFill.ReturnestimatedFare = vm.dataToFill.ReturnestimatedFareRoute;
                            //     vm.dataToFill.ReturnestimatedFareRoute = Number(payload.title.data.finalResult_return.price);
                            //     // vm.estimatedFareRouteForRoundTrip = Number(payload.title.data.finalResult_return.price);
                            //     console.log(vm.dataToFill.ReturnestimatedFare, 'vm.dataToFill.ReturnestimatedFare');

                            // } else {
                            //     if (vm.dataToFill.ReturnEstimatedDistance != undefined)
                            //         var calEstFare = Number((vm.dataToFill.ReturnEstimatedDistance * payload.title.data.perKMChanges.toFixed(2)) + payload.title.data.baseFare);
                            //     vm.dataToFill.ReturnestimatedFareRoute = vm.dataToFill.selectedServiceDetails.fare_type ? ((Number(calEstFare) * Number(vm.dataToFill.passengerCount)) < payload.title.data.minimumFare ? payload.title.data.finalResult_return.minimumFare : (Number(calEstFare) * Number(vm.dataToFill.passengerCount))) : (calEstFare < payload.title.data.finalResult_return.minimumFare ? payload.title.data.finalResult_return.minimumFare : calEstFare);
                            //     vm.dataToFill.ReturnestimatedFare = vm.dataToFill.ReturnestimatedFareRoute;
                            //     vm.dataToFill.ReturnestimatedFareVariable = calEstFare;
                            //     vm.dataToFill.ReturnestimatedFareRoute = calEstFare;
                            //     vm.dataToFill.ReturnminimumFare = payload.title.data.finalResult_return.minimumFare;
                            // }
                            if (payload.title.data.finalResult_return.type_of_trip == "Z" && payload.title.data.finalResult_return.controlled_way_flag == 1 && vm.FlagToCheckViaControl == 1) {
                                // vm.viaControlled2 = payload.title.data.finalResult_return.via_controlled_price;
                                if (vm.dataToFill.selectedServiceDetails.fare_type == 1 &&
                                    vm.dataToFill.selectedServiceDetails.category == 1) {
                                    vm.viaControlled2 = payload.title.data.finalResult_return.via_controlled_price + (payload.title.data.finalResult_return.via_controlled_price * (vm.dataToFill.passengerCount - 1));
                                    // vm.addViaControlled = 0;
                                } else {
                                    vm.viaControlled2 = payload.title.data.finalResult_return.via_controlled_price;
                                    // vm.addViaControlled = 0;
                                }
                                vm.SendTrip = payload.title.data.finalResult_return.type_of_trip;

                            } else {
                                vm.viaControlled2 = 0;
                            }
                            vm.type_of_trip = payload.title.data.finalResult_return.type_of_trip;
                            if (payload.title.data.finalResult_return.type_of_trip == "Z") {
                                vm.viaControlledFLag = true;
                                vm.dataToFill.viaControlledApply = true;
                            } else {
                                vm.viaControlledFLag = false;
                                vm.dataToFill.viaControlledApply = false;
                            }
                            vm.dataToFill.appliedCouponData = [];
                            // numberOfPassenger(vm.dataToFill.passengerCount);
                            calculateRtDiscount();
                            vm.estimatedCost_to_show = Math.round(vm.dataToFill.estimatedFare + vm.via_controlled_price_to_send);
                            if (vm.type_of_trip == 'R' && vm.method_range_pickup == 1 && vm.dataToFill.selectedServiceDetails.category == 1) {
                                if (vm.dataToFill.roundTrip) {
                                    if (vm.dataToFill.returnTimeShared != '' && vm.dataToFill.returnDateShared != '') {
                                        RoutingApiFuncationRoundTrip_quick(vm.dataToFill);
                                    }
                                }
                            }
                        } else {
                            vm.loading = false;
                        }
                        // ********* VARIABLES ARE INITIALIZE TO AGAIN SET INPUT FIELD VARIABLE ********
                        vm.calculatedEstimatePriceFormFunctionEstimated = -1;
                        vm.finalAdjustedPriceFromAdmin = 0;
                        vm.calculatedEstimatePriceForFixedPriceFormFunction = 0;
                        vm.calculatedEstimatePriceForRoundTripFormFunction = 0;
                        vm.click = false;
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    vm.dataToFill.favPickLocId = '';
                    vm.dataToFill.favDropLocId = '';
                    vm.dataToFill.route_id = '';
                    vm.dataToFill.itemOfChargeList = [];
                    vm.dataToFill.itemOfChargeSelected = [];
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        //errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        function SelectAddress(index, data) {
            console.log(data, "puneet here ");

            vm.dataToFill.dropOffAddress = '';
            if (!vm.dataToFill.customerId && !vm.dataToFill.newCustomerFlag) {
                languageBasedErrorFactory.getProperErrorMessage('selectCustomerf', 0, 0);
                //errorMessageFactory.showErrorMessage('Please fill customer details first',0);
                return;
            }
            console.log(data, "data", vm.addressArray);
            vm.addressFlag = index;
            vm.dataToFill.dropOffAddress = data.direction_name;
            vm.dataToFill.dropLat = Number(data.latitude);
            vm.dataToFill.dropLng = Number(data.longtitude);
            vm.jobDropoffComuna = data.communa || null;
            $timeout(function () {

                fillInAddress1();
            });
            // $timeout(function () {
            //     console.log('2')
            //     initAutocomplete();
            //     placeMarker(map,location,'drop');
            // });




        }

        //=================check passeneger count with service=======================
        function numberOfPassenger(data) {
            console.log(data);
            if (vm.dataToFill.pickLat && vm.dataToFill.dropLat && vm.dataToFill.serviceTypeSelected) {
                getFixedRoutesForPersonal(vm.dataToFill, 0);
            }
            if (data) {
                for (var i = 0; i < vm.dataToFill.serviceTypeList.length; i++) {
                    if (vm.dataToFill.serviceTypeList[i].max_limit < data) {
                        vm.dataToFill.serviceTypeList[i].disabled = true;
                    } else {
                        vm.dataToFill.serviceTypeList[i].disabled = false;
                    }
                }
            } else {
                for (var i = 0; i < vm.dataToFill.serviceTypeList.length; i++) {
                    vm.dataToFill.serviceTypeList[i].disabled = false;

                }
            }
            if (vm.dataToFill.selectedServiceDetails.fare_type == 1) {
                vm.dataToFill.viaControlled = Number(vm.dataToFill.viaControlledReal) * Number(vm.dataToFill.passengerCount);

            } else {
                vm.dataToFill.viaControlled = Number(vm.dataToFill.viaControlledReal);
            }
            $timeout(function () {
                if (vm.dataToFill.route_type == 1) {
                    vm.dataToFill.estimatedFare = 0;
                    // vm.dataToFill.ReturnestimatedFare = 0;
                    vm.dataToFill.Return_policy.estimatedFare = 0;
                    for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                        vm.dataToFill.estimatedFare = vm.dataToFill.estimatedFare + Number(vm.dataToFill.itemOfChargeSelected[i].price);
                        // calculateRtDiscount();
                    }
                    vm.dataToFill.estimatedFare = vm.dataToFill.selectedServiceDetails.fare_type ? Number(vm.dataToFill.estimatedFareRoute) * Number(vm.dataToFill.passengerCount) + Number(vm.dataToFill.estimatedFare) : Number(vm.dataToFill.estimatedFare) + Number(vm.dataToFill.estimatedFareRoute);
                    vm.dataToFill.Return_policy.estimatedFare = vm.dataToFill.selectedServiceDetails.fare_type ? Number(vm.dataToFill.ReturnestimatedFareRoute) * Number(vm.dataToFill.passengerCount) + Number(vm.dataToFill.Return_policy.estimatedFare) : Number(vm.dataToFill.Return_policy.estimatedFare) + Number(vm.dataToFill.ReturnestimatedFareRoute);

                    //    getFixedRoutesForPersonal(vm.dataToFill);
                    // calculateRtDiscount();
                } else {
                    //var calEstFare = vm.dataToFill.selectedServiceDetails.fare_type?Number((vm.dataToFill.estimatedDistance * payload.title.data[0].perKMChanges.toFixed(2))+payload.title.data[0].baseFare) * Number(vm.dataToFill.passengerCount):Number((vm.dataToFill.estimatedDistance * payload.title.data[0].perKMChanges.toFixed(2))+payload.title.data[0].baseFare);
                    //vm.dataToFill.estimatedFareRoute = calEstFare < payload.title.data[0].minimumFare ? payload.title.data[0].minimumFare : calEstFare;
                    //vm.dataToFill.estimatedFare = vm.dataToFill.estimatedFareRoute;
                    //vm.dataToFill.estimatedFareVariable = calEstFare;
                    //vm.dataToFill.estimatedFareRoute = calEstFare;
                    //vm.dataToFill.minimumFare = payload.title.data[0].minimumFare;
                    vm.dataToFill.estimatedFare = 0;
                    // vm.dataToFill.ReturnestimatedFare = 0;
                    // vm.dataToFill.Return_policy.estimatedFare = 0;
                    vm.dataToFill.Return_policy.estimatedFare = 0;
                    for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                        vm.dataToFill.estimatedFare = vm.dataToFill.estimatedFare + Number(vm.dataToFill.itemOfChargeSelected[i].price);

                    }
                    var calFare = vm.dataToFill.selectedServiceDetails.fare_type ? Number(vm.dataToFill.estimatedFareRoute) * Number(vm.dataToFill.passengerCount) + Number(vm.dataToFill.estimatedFare) : Number(vm.dataToFill.estimatedFare) + Number(vm.dataToFill.estimatedFareRoute);
                    var calFareReturn = vm.dataToFill.selectedServiceDetails.fare_type ? (Number(vm.dataToFill.ReturnestimatedFareRoute) * Number(vm.dataToFill.passengerCount) + Number(vm.dataToFill.Return_policy.estimatedFare)) : (Number(vm.dataToFill.Return_policy.estimatedFare) + Number(vm.dataToFill.ReturnestimatedFareRoute));
                    vm.dataToFill.estimatedFare = calFare < vm.dataToFill.minimumFare ? vm.dataToFill.minimumFare : calFare;
                    vm.dataToFill.Return_policy.estimatedFare = calFareReturn < vm.dataToFill.minimumFare ? vm.dataToFill.minimumFare : calFareReturn;
                }
            }, 3000)

            // calculateRtDiscount();
        }

        //========================select service=========================
        function selectService(data, index) {
            // console.log( vm.dataToFill.serviceTypeList[index].active, vm.dataToFill.serviceTypeList,' vm.dataToFill.serviceTypeList[index].active');
            if (!vm.dataToFill.customerId && !vm.dataToFill.newCustomerFlag) {
                languageBasedErrorFactory.getProperErrorMessage('selectCustomerf', 0, 0);
                //errorMessageFactory.showErrorMessage('Please fill customer details first',0);
                return;
            }
            // console.log(data);
            for (var i = 0; i < vm.dataToFill.serviceTypeList.length; i++) {
                if (vm.dataToFill.serviceTypeList[i].id != data.id) {
                    vm.dataToFill.serviceTypeList[i].active = false;
                }
            }
            vm.dataToFill.serviceTypeList[index].active = true;
            vm.dataToFill.serviceTypeSelected = vm.dataToFill.serviceTypeList[index].id;
            vm.dataToFill.selectedServiceDetails = vm.dataToFill.serviceTypeList[index];
            if (vm.dataToFill.pickLat && vm.dataToFill.dropLat && vm.dataToFill.serviceTypeSelected) {
                toGetAirportService(vm.dataToFill.pickLat, vm.dataToFill.pickLng, vm.dataToFill.serviceTypeSelected);
            }
        }

        //===================to get airport service==================
        $scope.$watchCollection('vm.dataToFill.selectedServiceDetails', function (newValue, oldValue) {
            console.log('being watched oldValue:', oldValue, 'newValue:', newValue);
            if (oldValue) {
                vm.dataToFill.viaControlledReal = vm.dataToFill.controlledWayCheck && vm.dataToFill.viaControlledApply ? newValue.controlled_way : 0;
                if (newValue.fare_type == 1) {
                    vm.dataToFill.viaControlled = Number(vm.dataToFill.viaControlledReal) * Number(vm.dataToFill.passengerCount);
                } else {
                    vm.dataToFill.viaControlled = Number(vm.dataToFill.viaControlledReal);
                }
            }
        }, true);
        $scope.$watchCollection('vm.dataToFill.controlledWayCheck', function (newValue, oldValue) {
            console.log('being watched oldValue:', oldValue, 'newValue:', newValue);
            vm.dataToFill.viaControlledReal = newValue && vm.dataToFill.viaControlledApply ? vm.dataToFill.selectedServiceDetails.controlled_way : 0;
            if (vm.dataToFill.selectedServiceDetails.fare_type == 1) {
                vm.dataToFill.viaControlled = Number(vm.dataToFill.viaControlledReal) * Number(vm.dataToFill.passengerCount);
            } else {
                vm.dataToFill.viaControlled = Number(vm.dataToFill.viaControlledReal);
            }
        }, true);
        $scope.$watchCollection('vm.dataToFill.viaControlledApply', function (newValue, oldValue) {
            console.log('being watched oldValue:', oldValue, 'newValue:', newValue);
            vm.dataToFill.viaControlledReal = vm.dataToFill.controlledWayCheck && newValue ? vm.dataToFill.selectedServiceDetails.controlled_way : 0;
            if (vm.dataToFill.selectedServiceDetails.fare_type == 1) {
                vm.dataToFill.viaControlled = Number(vm.dataToFill.viaControlledReal) * Number(vm.dataToFill.passengerCount);
            } else {
                vm.dataToFill.viaControlled = Number(vm.dataToFill.viaControlledReal);
            }
        }, true);

        function toGetAirportService(lat, lng, service) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.latitude = lat;
            dataSend.longitude = lng;
            dataSend.service_id = service;
            //vm.loading = true;
            var promise = getBookings.getAirportZone(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    //vm.loading = false;
                    vm.dataToFill.airportCheck = payload.title.data.type_of_trip;

                    if (payload.title.data.time_trip_shared_service) {
                        vm.dataToFill.time_trip_shared_service = payload.title.data.time_trip_shared_service;
                    } else vm.dataToFill.time_trip_shared_service = 0;

                    if (payload.title.data.type_of_trip == 'Z') {
                        vm.dataToFill.viaControlledApply = true;
                    } else vm.dataToFill.viaControlledApply = false;

                    if (vm.dataToFill.airportCheck == 'Z') {
                        vm.dataToFill.viaControlledReal = vm.dataToFill.controlledWayCheck && vm.dataToFill.viaControlledApply ? vm.dataToFill.selectedServiceDetails.controlled_way : 0;
                        if (vm.dataToFill.selectedServiceDetails.fare_type == 1) {
                            vm.dataToFill.viaControlled = Number(vm.dataToFill.viaControlledReal) * Number(vm.dataToFill.passengerCount);
                        } else {
                            vm.dataToFill.viaControlled = Number(vm.dataToFill.viaControlledReal);
                        }
                    }
                    getFixedRoutesForPersonal(vm.dataToFill, 0);
                },
                function (errorPayload) {
                    vm.loading = false;
                    $log.log(errorPayload);
                }
            );
        }
        //========================set boolean=======================
        function setBooleans(type) {
            switch (type) {
                case 'ROUND_TRIP':
                    if (vm.dataToFill.dropOffAddress) {
                        calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.dropLat, vm.dataToFill.dropLng, vm.dataToFill.pickLat, vm.dataToFill.pickLng, map, 'ROUND TRIP', vm.roundTripPayload);
                        // getFixedRoutesForPersonal(vm.dataToFill);

                    }
                    if (vm.dataToFill.roundTrip) {
                        vm.disableModifySpecialFareStatus = false;
                        vm.dataToFill.roundTrip = false;
                        calculateRtDiscount();
                    } else {
                        vm.dataToFill.roundTrip = true;
                        calculateRtDiscount();
                    }
                    if(vm.dataToFill.passengerCount == "" || vm.dataToFill.passengerCount == undefined){
                        vm.dataToFill.passengerCount = 1;
                    }
                    break;
                case 'WAIT_TIME_INCLUDED':
                    if (vm.dataToFill.is_wait_time_included) {
                        vm.dataToFill.is_wait_time_included = false;
                    } else {
                        vm.dataToFill.is_wait_time_included = true;
                    }
                    break;
            }
            if(vm.dataToFill.roundTrip && restriccion_flota == 1){
                get_cuota_rt() 
            } 
        };

        //======================selecting item of charges=====================
        function changeQuantityOfItem(data, index, type) {
            console.log(data);
            if (data) {
                vm.dataToFill.itemOfChargeSelected[index].price = Number(vm.dataToFill.itemOfChargeSelected[index].oldPrice) * vm.dataToFill.itemOfChargeSelected[index].quantity;
                selectingItemOfCharges(index, type);
            }
        }


        function selectingItemOfCharges(index, type) {
            //vm.dataToFill.estimatedFareVariable = vm.dataToFill.estimatedFare;
            // vm.click =  false;
            vm.dataToFill.estimatedFare = 0;
            vm.dataToFill.estimatedFareVariableReturn = 0;

            vm.dataToFill.estimatedFareVariable = vm.dataToFill.selectedServiceDetails.fare_type ? Number(vm.dataToFill.estimatedFareRoute) * Number(vm.dataToFill.passengerCount) : Number(vm.dataToFill.estimatedFareRoute);
            vm.dataToFill.estimatedFareVariableReturn = Number(vm.dataToFill.Return_policy.$estimatedFareRoute);
            //vm.dataToFill.estimatedFareVariableReturn = vm.dataToFill.selectedServiceDetails.fare_type ? Number(vm.dataToFill.Return_policy.$estimatedFareRoute) * Number(vm.dataToFill.passengerCount) : Number(vm.dataToFill.Return_policy.$estimatedFareRoute);

            // vm.dataToFill.estimatedFareVariable = Number(vm.dataToFill.estimatedFareRoute) * Number(vm.dataToFill.passengerCount);
            if (type == 'select') {
                for (var i = 0; i < index.length; i++) {
                    if( index[i].retorno == false ){
                        vm.dataToFill.estimatedFareVariable = vm.dataToFill.estimatedFareVariable + Number(index[i].price);
                    } else if( index[i].retorno == true ){
                        vm.dataToFill.estimatedFareVariableReturn = vm.dataToFill.estimatedFareVariableReturn + Number(index[i].price);
                    }
                }
            } else if (type == 'remove') {
                for (var i = 0; i < index.length; i++) {
                    if( index[i].retorno == false ){
                        vm.dataToFill.estimatedFareVariable = vm.dataToFill.estimatedFareVariable + Number(index[i].price);
                    } else if( index[i].retorno == true ){
                        vm.dataToFill.estimatedFareVariableReturn = vm.dataToFill.estimatedFareVariableReturn + Number(index[i].price);
                    }
                }
            } else {
                for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                    if( vm.dataToFill.itemOfChargeSelected[i].retorno == false ){
                        vm.dataToFill.estimatedFareVariable = vm.dataToFill.estimatedFareVariable + Number(vm.dataToFill.itemOfChargeSelected[i].price);
                    } else if( vm.dataToFill.itemOfChargeSelected[i].retorno == true ){
                        vm.dataToFill.estimatedFareVariableReturn = vm.dataToFill.estimatedFareVariableReturn + Number(vm.dataToFill.itemOfChargeSelected[i].price);
                    }
                }
            }
            console.log('ccc12',vm.dataToFill.estimatedFareVariableReturn,'return amount', vm.dataToFill.estimatedFareVariable, vm.dataToFill.minimumFare);
            // if (vm.dataToFill.minimumFare) {
                vm.dataToFill.estimatedFare = vm.dataToFill.estimatedFareVariable < vm.dataToFill.minimumFare ? vm.dataToFill.minimumFare : vm.dataToFill.estimatedFareVariable;
            // } else {
                vm.dataToFill.estimatedFare = vm.dataToFill.estimatedFareVariable;



                if (vm.dataToFill.estimatedFareVariableReturn) {
                    vm.dataToFill.Return_policy.estimatedFare = vm.dataToFill.estimatedFareVariableReturn;
                }

                // ********* VARIABLES ARE INITIALIZE TO AGAIN SET INPUT FIELD VARIABLE ********
                vm.calculatedEstimatePriceFormFunctionEstimated = -1;
                vm.finalAdjustedPriceFromAdmin = 0;
                vm.calculatedEstimatePriceForFixedPriceFormFunction = 0;
                vm.calculatedEstimatePriceForRoundTripFormFunction = 0;
                vm.click = false;
                vm.dataToFill.appliedCouponData = [];
                vm.dataToFill.appliedCouponData.push({
                    // 'estimatedCost': Math.round(Number(vm.dataToFill.estimatedFare) + Number(vm.via_controlled_price_to_send)),
                    'estimatedCost': viaControlledPrice(vm.dataToFill.estimatedFare, vm.via_controlled_price_to_send, vm.type_of_trip1),
                    'type': 1,
                    'coupon_name': 'Round Trip',
                    'value': (vm.dataToFill.roundTrip ? vm.dataToFill.rt_discount : 0),
                    'discountCost': calculateDiscountPercentageAmount(vm.dataToFill.estimatedFare, vm.via_controlled_price_to_send, vm.type_of_trip1, (vm.dataToFill.roundTrip ? vm.dataToFill.rt_discount : 0), 'parent'),
                    // 'discountCost': Math.round((vm.dataToFill.rt_discount * (vm.estimatedFareDiscount)) / 100),
                    // 'ReturndiscountCost': Math.round((vm.dataToFill.rt_discount * (vm.estimatedFareDiscountRound)) / 100),
                    'ReturndiscountCost': calculateDiscountPercentageAmount(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.SendTrip, (vm.dataToFill.roundTrip ? vm.dataToFill.rt_discount : 0)),
                    // 'finalAmount': Math.round(vm.estimatedFareDiscount) - Math.round((vm.dataToFill.rt_discount * (vm.estimatedFareDiscount)) / 100),
                    'finalAmount': calculateDiscountPercentage(vm.dataToFill.estimatedFare, vm.via_controlled_price_to_send, vm.type_of_trip1, (vm.dataToFill.roundTrip ? vm.dataToFill.rt_discount : 0), 'parent'),
                    // 'returnFinalAmount': (vm.estimatedFareDiscountRound - Math.round((vm.dataToFill.rt_discount * (vm.estimatedFareDiscountRound))) / 100),
                    'returnFinalAmount': calculateDiscountPercentage(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.SendTrip, (vm.dataToFill.roundTrip ? vm.dataToFill.rt_discount : 0)),
                    // 'roundTripFare': Math.round(Number(vm.dataToFill.ReturnestimatedFare) + Number(vm.viaControlled2)),
                    'roundTripFare': viaControlledPrice(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.SendTrip)
                })
                // vm.dataToFill.appliedCouponData.forEach(function (data) {
                //     data.finalAmount = data.finalAmount < 0 ? 0 : data.finalAmount;
                // })
                vm.dataToFill.sortData = vm.dataToFill.appliedCouponData.sort(function (a, b) {
                    return b.discountCost - a.discountCost;
                })

            // }
        }

        //====================agreement type changed==================
        function agreementTypeChanged() {
            var isAgreementBlock = 0;
            var isAgreementBlockIndex = _.findIndex(vm.dataToFill.contractListShowing, {
                id: vm.dataToFill.contractIdSelected
            })
            if (isAgreementBlockIndex > -1) {
                isAgreementBlock = vm.dataToFill.contractListShowing[isAgreementBlockIndex].is_block;
                if (isAgreementBlock == 0) {
                    errorMessageFactory.showErrorMessage('Este cliente no está autorizado para crear reservas desde el panel', 0);
                    vm.dataToFill.contractIdSelected = '';
                    return;
                }
            }
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.offset = 0;
            dataSend.limit = 0;
            dataSend.key = 3;
            dataSend.id = vm.dataToFill.contractIdSelected;
            vm.loading = true;
            var promise = getAgreement.allAgreementBooking(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);

                    vm.loading = false;
                    vm.finalAgreement = payload.title.data.result;
                    vm.dataToFill.serviceTypeList = [];
                    vm.dataToFill.paymentMethodList = [];
                    restriccion_flota = payload.title.data.result[0].restriccion_flota;
                    for (var i = 0; i < payload.title.data.result[0].type_of_service.length; i++) {
                        for (var j = 0; j < vm.dataToFill.operationData.service.length; j++) {
                            if (Number(vm.dataToFill.operationData.service[j].service_type_id) == Number(payload.title.data.result[0].type_of_service[i].id)) {
                                vm.dataToFill.serviceTypeList.push(payload.title.data.result[0].type_of_service[i]);
                            }
                        }
                    }
                    vm.matchArray.push(payload.title.data.result[0].id);
                    if (vm.dataToFill.serviceTypeList.length == 0) {
                        vm.dataToFill.noService = true;
                    }
                    for (var i = 0; i < payload.title.data.result[0].payment.length; i++) {
                        if (payload.title.data.result[0].payment[i].channel_name == 'POS') {
                            vm.dataToFill.paymentMethodList.push(payload.title.data.result[0].payment[i]);
                        }
                    }
                    console.log(vm.defaultCustomerFlag, 'vm.defaultCustomerFlag');

                    // if(!vm.defaultCustomerFlag){
                    //     vm.dataToFill.contractList.push(payload.title.data.result[0]);
                    // }
                    vm.dataToFill.customerContarctId = payload.title.data.result[0].id;
                    vm.FlagToCheckViaControl = payload.title.data.result[0].controlled_way;
                    vm.dataToFill.payment_method = payload.title.data.result[0].payment_method_default;
                    vm.dataToFill.passengerRutCheck = payload.title.data.result[0].RUT_mendatory;
                    vm.dataToFill.applicantRutCheck = payload.title.data.result[0].applicant_RUT_mendatory;
                    vm.dataToFill.costCenterCheck = payload.title.data.result[0].cost_center_mandatory;
                    vm.dataToFill.costSubCenterCheck = payload.title.data.result[0].cost_sub_center_mandatory;
                    vm.dataToFill.RolCheck = payload.title.data.result[0].ROL_mandatory;
                    vm.dataToFill.graphCheck = payload.title.data.result[0].graph_mandatory;
                    vm.dataToFill.workOrderCheck = payload.title.data.result[0].work_order_mandatory;
                    vm.dataToFill.pepCheck = payload.title.data.result[0].PEP_mandatory;
                    vm.dataToFill.purposeOfTripCheck = payload.title.data.result[0].purpose_of_trip_mandatory;
                    vm.dataToFill.noOfVoucherCheck = payload.title.data.result[0].number_of_voucher_mandatory;
                    vm.dataToFill.nominaCheck = payload.title.data.result[0].nomina_mandatory;
                    vm.dataToFill.solictudCheck = payload.title.data.result[0].solicitud_mandatory;
                    vm.dataToFill.rt_discount = payload.title.data.result[0].rt_discount;
                    vm.dataToFill.controllerWayTarifa = payload.title.data.result[0].via_control_include_in_tarifa;
                    vm.dataToFill.webDiscount = payload.title.data.result[0].web_discount;
                    vm.dataToFill.allowChangeFarePanel = payload.title.data.result[0].allow_change_fare_POS || 0;
                    vm.click = false; //Because after click on modify input field will change when personal or corporate changes

                    if (vm.dataToFill.paymentMethodList.length == 0) {
                        for (var i = 0; i < payload.title.data.result[0].payment.length; i++) {
                            if (payload.title.data.result[0].payment[i].id == Number(vm.dataToFill.payment_method)) {
                                vm.dataToFill.paymentMethodList.push(payload.title.data.result[0].payment[i]);
                            }
                        }
                    } else {
                        var where = _.where(vm.dataToFill.paymentMethodList, {
                            id: Number(vm.dataToFill.payment_method)
                        });
                        if (!where && where.length == 0) {
                            vm.dataToFill.payment_method = 0;
                            vm.dataToFill.paymentMethodSelected = '';
                        }
                    }
                    vm.dataToFill.controlledWayCheck = payload.title.data.result[0].controlled_way;
                    for (var i = 0; i < vm.dataToFill.paymentMethodList.length; i++) {
                        vm.dataToFill.paymentMethodList[i].active = false;
                        if (vm.dataToFill.paymentMethodList[i].id == Number(vm.dataToFill.payment_method)) {
                            vm.dataToFill.paymentMethodList[i].active = true;
                            vm.dataToFill.paymentMethodSelected = vm.dataToFill.paymentMethodList[i];
                        }
                    }
                    for (var i = 0; i < vm.dataToFill.serviceTypeList.length; i++) {
                        vm.dataToFill.serviceTypeList[i].disabled = false;
                        if (vm.dataToFill.serviceTypeSelected == vm.dataToFill.serviceTypeList[i].id)
                            vm.dataToFill.serviceTypeList[i].active = true;
                        else vm.dataToFill.serviceTypeList[i].active = false;
                    }
                    console.log(vm.dataToFill.contractList, 'vm.dataToFill.contractList');

                    var where = _.where(vm.dataToFill.contractList, {
                        id: Number(vm.dataToFill.contractIdSelected),
                    });
                    vm.selectedEmployeeData = where[0];
                    console.log(where[0], "where");

                    if (!payload.title.data.result[0].employee_details) {
                        if (where.length) {
                            console.log("here i m >>>>>>>>>>>>", where)
                            vm.dataToFill.corporate_account_id = where[0].employee_details.corporate_id;
                            vm.dataToFill.authRequired = where[0].employee_details.approval_required;
                            vm.dataToFill.auther_id = where[0].employee_details.auther_id; //auth_RUT
                            vm.dataToFill.authRUT = RutHelper.format(where[0].employee_details.auth_RUT);
                            vm.dataToFill.authName = where[0].employee_details.auth_name;
                            vm.dataToFill.passengerRut = RutHelper.format(where[0].employee_details.RUT);
                            vm.dataToFill.applicantRut = RutHelper.format(where[0].employee_details.RUT);
                            vm.dataToFill.costCenter = where[0].employee_details.cost_center;
                            vm.dataToFill.costSubCenter = where[0].employee_details.cost_subcenter;
                            vm.dataToFill.Rol = where[0].employee_details.ROI;
                            vm.dataToFill.graph = where[0].employee_details.graph;
                            vm.dataToFill.workOrder = where[0].employee_details.order_of_work;
                            vm.dataToFill.pep = where[0].employee_details.PEP;
                            vm.dataToFill.is_vip = where[0].employee_details.is_vip;
                        } else {
                            console.log("here i m else>>>>>>>>>>>>")
                            vm.dataToFill.corporate_account_id = payload.title.data.result[0].corporate_id.id;
                            vm.dataToFill.authRequired = 0;
                            vm.dataToFill.auther_id = '';
                            vm.dataToFill.authRUT = '';
                            vm.dataToFill.authName = '';
                            vm.dataToFill.passengerRut = '';
                            vm.dataToFill.applicantRut = '';
                            vm.dataToFill.costCenter = '';
                            vm.dataToFill.costSubCenter = '';
                            vm.dataToFill.Rol = '';
                            vm.dataToFill.graph = '';
                            vm.dataToFill.workOrder = '';
                            vm.dataToFill.pep = '';
                            vm.dataToFill.is_vip = 0;
                        }
                    }

                    if (vm.dataToFill.pickLat && vm.dataToFill.dropLat && vm.dataToFill.serviceTypeSelected) {
                        vm.dataToFill.sortData = [];
                        vm.dataToFill.couponValidation = false;
                        getFixedRoutesForPersonal(vm.dataToFill, 0);
                    }
                    getCustomerFavouriteAddress();

                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        //==============get all corporate=================
        function getAllCorporate() {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = 0;
            dataSend.offset = 0;
            dataSend.key = 2;
            dataSend.search_filter = 0;
            var promise = getCorporate.allCorporates(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.corporatesList = [];
                    vm.corporatesList = payload.title.data.result;
                    vm.corporatesList.push({
                        id: 'all',
                        company_name: 'All'
                    });
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        // //======================get all agreements==============
        // function getAllAgreement() {
        //     var dataSend = {};
        //     dataSend.access_token = $cookies.get('obj');
        //     vm.loading = true;
        //     var promise = getAgreement.getAgreementListLessData(dataSend);
        //     promise.then(
        //         function (payload) {
        //             $log.log('sxdsads', payload);
        //             vm.loading = false;
        //             if (payload.title.status == 400) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //             } else if (payload.title.status == 401) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //             } else if (payload.title.status == 201 || payload.title.status == 200) {
        //                 vm.agreement = [];
        //                 //vm.tableAgreement = [];
        //                 for (var i = 0; i < payload.title.data.length; i++) {
        //                     if (payload.title.data[i].agreement_type == 'CORPORATE' && payload.title.data[i].status == 1) {
        //                         vm.agreement.push({
        //                             name: payload.title.data[i].name,
        //                             id: payload.title.data[i].id
        //                         })
        //                     }
        //                 }
        //                 vm.agreement.push({
        //                     id: 'all',
        //                     name: 'All'
        //                 });
        //             }
        //         },
        //         function (errorPayload) {
        //             $log.log(errorPayload);
        //             vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // };

        //========================open endowment pop p======================
        function addEndowment($event) {


            vm.items = {
                agreement: vm.agreement,
                tableAgreement: [],
                corporatesList: vm.corporatesList,
                rutFilter: '',
                agreementSelected: 'all',
                corporateSelected: 'all',
                finalAgreement: '',
                errorMsg: false,
                rutInvalid: false,
                loading: false,
                agreementToSend: [],
                limit: 10,
                offset: 0,
                totalCount: 0,
                backgroundColor: 'grey',
                internetFlag: true
            }

            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/addEndowmentOfNewCustomer.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: AddEndowmentController
            });

            function AddEndowmentController($scope, $mdDialog, items) {
                $scope.items = items;
                var dataGet = [];
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                // INTERNET ISSUE TIKCET 4187
                window.addEventListener('online', function (event) {
                    $scope.items.internetFlag = true;
                });
                window.addEventListener('offline', function (event) {
                    $scope.items.internetFlag = false;
                });
                // vm = this;
                // =================== GET FILTER DATA ===================
                function getFilterDataFromBackend(data, type) {
                    console.log(data, "is here >>>>>>>>>>>>>");

                    if (data) {
                        vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                        vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
                    } else {
                        vm.filterObject = {
                            access_token: $cookies.get('obj'),
                            branch_filter: 0,
                            vehicle_filter: 0,
                            service_filter: 0,
                            agreement_filter: 1,
                            corporate_filter: 1,
                            service_category: 0,
                            corporate_status: 2,
                            agreement_status: 1,
                            vehicle__status: 0,
                            operation_point_filter: 0,
                            branch_search_filter: 0,
                            vehicle_search_filter: 0,
                            service_search_filter: 0,
                            agreement_search_filter: 0,
                            corporate_search_filter: 0,
                            operation_point_search_filter: 0,
                            agreement_type: 'CORPORATE'
                        }
                    }
                    vm.filterObject.agreement_limit = vm.globalLimit;
                    vm.filterObject.agreement_offset = vm.agreementOffset;
                    vm.filterObject.corporate_limit = vm.globalLimit;
                    vm.filterObject.corporate_offset = vm.corporateOffset;
                    $scope.agreementShowArray;
                    $scope.coprateListShow;
                    var promise = getFilters.getAllFilterData(vm.filterObject);
                    promise.then(
                        function (payload) {

                            // ********** Agrrement DATA ********
                            if (payload.title.data.agreements) {
                                var index = _.findIndex(vm.agreement, {
                                    id: 'all'
                                });
                                if (index == -1)
                                    vm.agreement.push({
                                        name: 'All',
                                        id: 'all'
                                    });
                                angular.forEach(payload.title.data.agreements.data, function (column) {
                                    // vm.corporatesList.push(column)
                                    var agreement = _.findIndex(vm.agreement, {
                                        id: column.id
                                    });
                                    if (agreement == -1)
                                        vm.agreement.push(column)

                                });
                                vm.agreementTotalBackendCount = payload.title.data.agreements.totalCount;
                                $scope.agreementShowArray = vm.agreement;
                            }
                            // ********** CORPORATE DATA ********
                            if (payload.title.data.corporates) {
                                var index = _.findIndex(vm.corporatesList, {
                                    id: 'all'
                                });
                                if (index == -1)
                                    vm.corporatesList.push({
                                        company_name: 'All',
                                        id: 'all'
                                    });
                                angular.forEach(payload.title.data.corporates.data, function (column) {
                                    // vm.corporatesList.push(column)
                                    var corprateIndex = _.findIndex(vm.corporatesList, {
                                        id: column.id
                                    });
                                    if (corprateIndex == -1)
                                        vm.corporatesList.push(column)

                                });
                                console.log(vm.corporatesList.length, 'vm.corporatesList');
                                $scope.coprateListShow = vm.corporatesList;
                                vm.corporateTotalBackendCount = payload.title.data.corporates.totalCount;
                            }
                            $timeout(function () {
                                $scope.$apply();
                            })
                            vm.loading = false;
                        },
                        function (errorPayload) {
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        });
                }

                $scope.corporate = function (data) {
                    setTimeout(function () {
                        // document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                        //     // if (vm.branchList && (vm.branchList.length == 0)) {
                        //     vm.searchCorporateData = '';
                        //     vm.agreementOffset = 0;
                        //     vm.agreement = [];
                        //     getFilterDataFromBackend(0, 0);
                        // });

                        document.getElementsByClassName('ui-select-search')[1].addEventListener('blur', function ($event) {
                            // if (vm.corporatesList && (vm.corporatesList.length == 0)) {
                            vm.searchCorporateData = '';
                            vm.corporatesList = [];
                            vm.corporateOffset = 0;
                            getFilterDataFromBackend(0, 0);
                            // }
                        });
                    })
                }
                $scope.aggrementchange = function () {
                    setTimeout(function () {
                        document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                            // if (vm.branchList && (vm.branchList.length == 0)) {
                            vm.searchCorporateData = '';
                            vm.agreementOffset = 0;
                            vm.agreement = [];
                            getFilterDataFromBackend(0, 0);
                        });

                        // document.getElementsByClassName('ui-select-search')[1].addEventListener('blur', function ($event) {
                        //     // if (vm.corporatesList && (vm.corporatesList.length == 0)) {
                        //     vm.searchCorporateData = '';
                        //     vm.corporatesList = [];
                        //     vm.corporateOffset = 0;
                        //     getFilterDataFromBackend(0, 0);
                        //     // }
                        // });
                    })
                }
                // *********** COMMON FUNCTION FOR FILTER PAGINATION AND SEARCHING ***********
                function commonFunction(type, mode) {

                    for (var i = 0; i < vm.searchFilterArray.length; i++) {
                        console.log("searching ..........");

                        if (mode == 'search' || i != type) {
                            vm[vm.searchFilterArrayForClearArray[i]] = [];
                            // vm[vm.searchFilterArrayForClearArray[i]].push({
                            //     id: 'all',
                            //     name: 'All'
                            // });
                            vm[vm.searchFilterArray[i] + 'Offset'] = 0;
                            vm['search' + vm.searchFilterArray[i].substring(0, 1).toUpperCase() + vm.searchFilterArray[i].substring(1) + 'Data'] = '';
                        }
                    }
                }
                getFilterDataFromBackend(0, 0);
                setTimeout(function () {
                    document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                        // if (vm.branchList && (vm.branchList.length == 0)) {
                        vm.searchCorporateData = '';
                        vm.agreementOffset = 0;
                        vm.agreement = [];
                        getFilterDataFromBackend(0, 0);
                    });

                    document.getElementsByClassName('ui-select-search')[1].addEventListener('blur', function ($event) {
                        // if (vm.corporatesList && (vm.corporatesList.length == 0)) {
                        vm.searchCorporateData = '';
                        vm.corporatesList = [];
                        vm.corporateOffset = 0;
                        getFilterDataFromBackend(0, 0);
                        // }
                    });
                })
                // ************ PAGINATION ON CORPORATE **************
                $scope.paginationChangedForCorporation = function () {
                    var index = _.findIndex(vm[vm.searchFilterArray[5]], {
                        id: 'all'
                    });
                    index = (index == -1 ? 0 : 1);
                    if (vm.corporateTotalBackendCount > (vm.corporatesList.length - index)) {
                        commonFunction(4);
                        vm.corporateOffset += vm.globalOffset;
                        getFilterDataFromBackend(vm.searchCorporateData, 4);
                    }
                }

                // ************ PAGINATION ON AGREEMENT **************
                $scope.paginationChangedForAgreement = function () {
                    var index = _.findIndex(vm[vm.searchFilterArray[3]], {
                        id: 'all'
                    });
                    index = (index == -1 ? 0 : 1);
                    if (vm.agreementTotalBackendCount > (vm.agreement.length - index)) {
                        commonFunction(3);
                        vm.agreementOffset += vm.globalOffset;
                        getFilterDataFromBackend(vm.searchAgreementData, 3);
                    }
                }

                // ************ SEARCH SERVICE ***************
                $scope.corporateSearch = function (data, event) {
                    if (event.keyCode != 40 && event.keyCode != 38) {
                        vm.searchCorporateData = data;
                        $timeout.cancel($scope.timeoutSearch);
                        commonFunction(4, 'search');
                        $scope.timeoutSearch = $timeout(function () {
                            getFilterDataFromBackend(data, 4);
                        }, 2000);
                    }
                }

                // ************ SEARCH AGREEMENT ***************
                $scope.agreementSearch = function (data, event) {
                    if (event.keyCode != 40 && event.keyCode != 38) {
                        vm.searchAgreementData = data;
                        $timeout.cancel($scope.timeoutSearch);
                        commonFunction(3, 'search');
                        $scope.timeoutSearch = $timeout(function () {
                            getFilterDataFromBackend(data, 3);
                        }, 2000);
                    }
                }

                $scope.confirmUpload = function () {
                    if (!$scope.items.internetFlag) {
                        return;
                    }
                    if ($scope.items.agreementToSend.length == 0) {
                        $scope.items.errorMsg = true;
                        $timeout(function () {
                            $scope.items.errorMsg = false;
                        }, 2000);
                    } else {
                        $mdDialog.hide();
                        makeNewAgreementInList($scope.items.agreementToSend);
                    }

                };
                $scope.selectParticularEndowment = function (index) {
                    $scope.items.agreementToSend = $scope.items.tableAgreement[index];
                }
                $scope.rutChange = function () {
                    if ($scope.items.rutFilter) {
                        if (RutHelper.validate($scope.items.rutFilter)) {
                            $log.log();
                            $scope.items.rutInvalid = false;
                        } else {
                            $scope.items.rutInvalid = true;
                        }
                    } else if ($scope.items.rutFilter === null) {
                        $scope.items.rutInvalid = true;
                    } else if ($scope.items.rutFilter === undefined) {
                        $scope.items.rutInvalid = false;
                    }
                }

                $scope.paginationChanged = function () {
                    if ($scope.items.totalCount != $scope.items.tableAgreement.length) {
                        $scope.items.offset = $scope.items.offset + $scope.items.limit;
                        $scope.getFilterDataForEndowment();
                    }
                }

                $scope.getFilterChange = function () {
                    $scope.items.tableAgreement = [];
                    dataGet = [];
                    $scope.items.offset = 0;
                    $scope.items.limit = 10;
                    vm.searchBranchData = '';
                    // vm.agreement = [];
                    // getFilterDataFromBackend(0,0);
                }

                $scope.getFilterDataForEndowment = function () {
                    if ($scope.items.rutInvalid) {
                        return;
                    }
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.limit = $scope.items.limit;
                    dataSend.offset = $scope.items.offset;
                    if ($scope.items.agreementSelected && $scope.items.agreementSelected != 'all') {
                        dataSend.agreement_id = Number($scope.items.agreementSelected);
                        $scope.items.tableAgreement = [];
                        dataGet = [];
                    }
                    if ($scope.items.corporateSelected && $scope.items.corporateSelected != 'all') {
                        dataSend.corporate_id = Number($scope.items.corporateSelected);
                        $scope.items.tableAgreement = [];
                        dataGet = [];
                    }

                    if ($scope.items.rutFilter) {
                        dataSend.corporate_rut = RutHelper.clean($scope.items.rutFilter);
                        $scope.items.tableAgreement = [];
                        dataGet = [];
                    }
                    console.log(dataSend);
                    $scope.items.loading = true;
                    var promise = getAgreement.getAgreementListLessDataWithFilters(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            $scope.items.loading = false;

                            for (var i = 0; i < payload.title.data.contracts.result.length; i++) {
                                payload.title.data.contracts.result[i].selected = false;
                                if (payload.title.data.contracts.result[i].employee_endowment == 1) {
                                    payload.title.data.contracts.result[i].color = 'lightgrey';
                                } else {
                                    payload.title.data.contracts.result[i].color = 'white';
                                }
                                dataGet.push(payload.title.data.contracts.result[i]);
                            }
                            $scope.items.totalCount = payload.title.data.contracts.totalCount;
                            $scope.items.tableAgreement = _.where(dataGet, {
                                agreement_type: 'CORPORATE'
                            });
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            $scope.items.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }
                $scope.getFilterDataForEndowment();
            }
        }

        //==========================make new agreement in new list======================
        function makeNewAgreementInList(data) {
            console.log(data);
            vm.dataToFill.contractIdSelected = data.contract_id;
            var where = _.where(vm.dataToFill.contractListShowing, {
                id: data.contract_id
            });
            var a = '';
            for (var i = 0; i < vm.dataToFill.contractListShowing.length; i++) {
                if (vm.dataToFill.contractListShowing[i].name.indexOf("*") > -1) {
                    a = i;
                    vm.dataToFill.contractListShowing.splice(a, 1);
                }
            }
            agreementTypeChanged();
            if (where.length) {
                return;
            } else {
                vm.dataToFill.contractListShowing.push({
                    name: data.name + '*',
                    id: data.contract_id
                });
            }
        }

        //====================get shift data for sale=====================
        function getShiftResponse() {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            var promise = quickSaleService.getShift(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    console.log(payload, 'shift id');

                    vm.loading = false;
                    if (payload.title.data.flag == 'FALSE') {
                        //openShiftStartPopUp(payload.title.data.message,1);
                        vm.dataToFill.shiftOpenClose = false;
                        vm.ShiftId = payload.title.data.shift_id;
                        $cookies.put('saleShiftId', payload.title.data.shift_id);
                    } else {
                        vm.dataToFill.shiftOpenClose = true;
                        var dataStore = {};
                        dataStore.number = vm.dataToFill.operationData.time.unique_code;
                        vm.ShiftId = payload.title.data.shift_id;
                        dataStore.time = vm.dataToFill.operationData.time.login_time;
                        dataStore.openClose = vm.dataToFill.shiftOpenClose ? 'open' : 'close';
                        $cookies.put('saleShift', dataStore);
                        $cookies.put('saleShiftId', payload.title.data.shift_id);
                        $timeout(function () {
                            document.getElementById("googleMap").style.height = '500px';
                            mapInitialize();
                            // getSpotAgreement();
                            //toGetAirportService(vm.dataToFill.pickLat,vm.dataToFill.pickLng);
                            // getAllCorporate();
                            // getAllAgreement();
                            $timeout(function () {
                                initAutocomplete();
                                forPickUp();
                            });
                        })
                        //getOperationPointData();
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        //=======================open shift start pop up=====================
        function openShiftStartPopUp(dataR, shiftOpenClose) {
            var parentEl = angular.element($document.body);
            //==============dialog for confirm====================
            //var confirm = $mdDialog.confirm()
                ////.title('Do you want to logout?')
                //.title(dataR)
                //.textContent('')
                //.ariaLabel('Lucky day')
                //.ok('Confirmar')
                //.cancel('Cancelar');
            var dialog = $mdDialog.show({
                parent: parentEl,
                clickOutsideToClose: false,
                template:
                    '<md-dialog md-theme="default" aria-label="Confirm Dialog" ng-class="dialog.css">' +
                    '  <md-dialog-content class="md-dialog-content">' +
                    '    <h2 class="md-title">{{ dataR }}</h2>' +
                    '  </md-dialog-content>' +
                    '  <md-dialog-actions>' +
                    '    <md-button class="md-primary md-confirm-button md-autofocus" ng-click="cerrarDialogo(false)" data-testid="boton-cancelar">' +
                    '      Cancelar' +
                    '    </md-button>' +
                    '    <md-button class="md-primary md-confirm-button md-autofocus" ng-click="cerrarDialogo(true)" data-testid="boton-aceptar">' +
                    '      Confirmar' +
                    '    </md-button>' +
                    '  </md-dialog-actions>' +
                    '</md-dialog>',
                controller: function($scope, $mdDialog) {
                    $scope.dataR = dataR;
                    $scope.cerrarDialogo = function(resultado) {
                        $mdDialog.hide(resultado);
                    };
                }
            });
            //$mdDialog.show(confirm).then(function () {
            dialog.then(function(result) {
                if(result){
                $log.log('confirmed');
                vm.loading = true;
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.shift_flag = shiftOpenClose;
                if (shiftOpenClose == 0) {
                    $cookies.remove('saleShiftId');
                }
                var promise = quickSaleService.startEndShift(dataSend); //$stateParams.id
                promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        if (shiftOpenClose) {
                            vm.dataToFill.shiftOpenClose = true;
                            $timeout(function () {
                                document.getElementById("googleMap").style.height = window.innerHeight - 200 + 'px';
                                mapInitialize();
                                getSpotAgreement();
                                //toGetAirportService(vm.dataToFill.pickLat,vm.dataToFill.pickLng);
                                // getAllCorporate();
                                // getAllAgreement();
                                getShiftResponse();
                                $timeout(function () {
                                    initAutocomplete();
                                    forPickUp();
                                });
                            })
                            vm.dataToFill.operationData.time.unique_code = payload.title.data.number_of_shift;
                            vm.dataToFill.operationData.time.login_time = payload.title.data.shift_open_time;
                            var dataStore = {};
                            dataStore.number = payload.title.data.number_of_shift;
                            dataStore.time = payload.title.data.shift_open_time;
                            dataStore.openClose = shiftOpenClose ? 'open' : 'close';
                            $cookies.put('saleShift', dataStore);
                            $cookies.put('saleShiftId', payload.title.data.number_of_shift);
                            //getOperationPointData();
                        } else {
                            vm.dataToFill.shiftOpenClose = false;
                            $cookies.remove('saleShift');
                            getPrintSalesHeight();
                            //toClearValues();
                        }
                    },
                    function (errorPayload) {
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
                }
            }, function () {
                $log.log('not confirmed');
            });
        }

        //=======================get admin point data==================
        function getOperationPointData() {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            var promise = quickSaleService.getOperationData(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    console.log(payload, "puneet");

                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.dataToFill.operationData.operation = payload.title.data.data[0];
                        vm.dataToFill.operationData.service = payload.title.data.services;
                        vm.point_id_to_send = payload.title.data.data[0].point_id;
                        vm.dataToFill.operationData.time.unique_code = payload.title.data.time[0].uniquecode;
                        vm.dataToFill.operationData.time.login_time = payload.title.data.time[0].login_time;
                        vm.dataToFill.pickUpAddress = vm.dataToFill.operationData.operation.address;
                        vm.jobPickupComuna = vm.dataToFill.operationData.operation.communa || null;
                        vm.dataToFill.pickLat = Number(vm.dataToFill.operationData.operation.latitude);
                        vm.dataToFill.pickLng = Number(vm.dataToFill.operationData.operation.longtitude);
                        getShiftResponse();
                        // getAddressApi();
                        // vm.dataToFill.customerProfile =1;
                        getAgreementApi();
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        getOperationPointData();

        //==================select payment method==================
        function selectPaymentMethod(data, index) {
            console.log(data);
            for (var i = 0; i < vm.dataToFill.paymentMethodList.length; i++) {
                if (vm.dataToFill.paymentMethodList[i].id == data.id) {
                    vm.dataToFill.paymentMethodList[i].active = true;
                } else {
                    vm.dataToFill.paymentMethodList[i].active = false;
                }
            }
            vm.dataToFill.paymentMethodSelected = data;
        }

        //============================date time format==============================
        function dateTimeFormat(dateGot, timeGot) {
            console.log(dateGot, timeGot);

            var dateToChange = dateGot;
            dateToChange.setHours(0);
            dateToChange.setMinutes(0);
            dateToChange.setSeconds(0);
            console.log(dateToChange);
            dateToChange.setHours(timeGot.getHours());
            dateToChange.setMinutes(timeGot.getMinutes());
            dateToChange.setSeconds(timeGot.getSeconds());
            console.log(dateToChange);
            //getFixedRoutesForPersonal(vm.dataToFill);
            return new Date(dateToChange);
        };


        //=================create booking bypass===========================
        function createBookingByPass($event) {
            get_cuota_rt();
            console.log(vm.dataToFill, 'createBookingByPass');
            $timeout(function () {
                checkAndMakeBookingData($event);
            }, 3000);
        }

        //====================================check and make booking data================================
        function checkAndMakeBookingData($event) {
            var returnDateTimeFormat = '';
            if (vm.dataToFill.returnDate == '' && vm.dataToFill.returnTime != '') {
                languageBasedErrorFactory.getProperErrorMessage('returnDateTimeError', 0, 0)
                return;
            }
            if (vm.dataToFill.returnTime == '' && vm.dataToFill.returnDate != '') {
                languageBasedErrorFactory.getProperErrorMessage('returnDateTimeError', 0, 0)
                return;
            }
            if (vm.dataToFill.returnDate != '' && vm.dataToFill.returnTime != '') {
                returnDateTimeFormat = dateTimeFormat(vm.dataToFill.returnDate, vm.dataToFill.returnTime);
            }

            if (!vm.dataToFill.serviceTypeSelected) {
                languageBasedErrorFactory.getProperErrorMessage('serviceReq', 0, 0);
                //errorMessageFactory.showErrorMessage("Selected customer don't have any corporate account");
                return;
            }

            if (!vm.dataToFill.paymentMethodSelected.id) {
                errorMessageFactory.showErrorMessage('Please select payment method.', 0, 0);
                //errorMessageFactory.showErrorMessage("Selected customer don't have any corporate account");
                return;
            }

            if (vm.dataToFill.route_id == '' || vm.dataToFill.route_id == undefined || vm.dataToFill.route_id == null) {
                languageBasedErrorFactory.getProperErrorMessage('validPickDrop', 0, 0)
                //errorMessageFactory.showErrorMessage('Please choose valid pickup and drop off locations');
                return;
            }
            if ((vm.dataToFill.corporate_account_id == '' || vm.dataToFill.corporate_account_id == undefined || vm.dataToFill.corporate_account_id == null) && (vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == '1')) {
                languageBasedErrorFactory.getProperErrorMessage('custCorpoNot', 0, 0)
                //errorMessageFactory.showErrorMessage("Selected customer don't have any corporate account");
                return;
            }

            if (vm.dataToFill.roundTrip && !vm.dataToFill.is_wait_time_included && vm.dataToFill.returnDate != '' && vm.dataToFill.returnTime != '') {
                // console.log('returnDateTimeFormat', returnDateTimeFormat, vm.dataToFill.returnDate, vm.dataToFill.returnTime);
                if (returnDateTimeFormat < new Date()) {
                    languageBasedErrorFactory.getProperErrorMessage('returnDateTimeError', 0, 0)
                    //errorMessageFactory.showErrorMessage("Please select appropriate return date & time.");
                    return;
                }
            }
            if(vm.fullCuota){
                return;
            }
            var where = _.where(vm.dataToFill.serviceTypeList, {
                id: Number(vm.dataToFill.serviceTypeSelected)
            });
            if (vm.dataToFill.passengerCount > where[0].max_limit) {
                languageBasedErrorFactory.getProperErrorMessage('noOfPassErr', 0, 0)
                //errorMessageFactory.showErrorMessage("Please enter correct no. of passengers.");
                return;
            }
            if (vm.dataToFill.pickLat == vm.dataToFill.dropLat && vm.dataToFill.pickLng == vm.dataToFill.dropLng) {
                languageBasedErrorFactory.getProperErrorMessage('dropPick', 0, 0)
                //errorMessageFactory.showErrorMessage("Drop-off location must be different from Pickup location");
                return;
            }
            vm.disableSubmitButton = true;
            var where = _.where(vm.dataToFill.contractList, {
                id: Number(vm.dataToFill.contractIdSelected)
            });
            // if (vm.dataToFill.customerProfile == '1' || vm.dataToFill.customerProfile == 1) {
            if (vm.dataToFill.first_name && (vm.agreementTypeUsed == 'SPOT')) {
                createCustomerNew($event);
            } else if (vm.agreementTypeUsed != 'SPOT' && vm.contractNameUsed != 'OTROS CONVENIOS') {
                if (vm.dataToFill.first_name) {
                    if (vm.createBookingflagNew) {
                        createBookingApi($event);
                    } else {
                        createEmployeeNew($event);
                    }
                } else if (where.length == 0) {
                    if (vm.createBookingflagNew) {
                        createBookingApi($event);
                    } else {
                        createEmployeeNew($event);
                    }
                } else {
                    if ((vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == '1') && vm.dataToFill.bookingFor == 0)
                        updateEmployeeProfile();
                    createBookingApi($event);
                }
            } else {
                if ((vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == '1') && vm.dataToFill.bookingFor == 0)
                    updateEmployeeProfile();
                createBookingApi($event);
            }
        }



        //=====================create new customer======================
        function createEmployeeNew($event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('newUserPop1', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('cancelButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.contract_id = vm.dataToFill.contractIdSelected;
                dataSend.corporate_id = vm.dataToFill.corporate_account_id;
                dataSend.domainUrl = checkDomain.getDomainName();
                var first_name_emp, last_name_emp;
                if (!vm.dataToFill.customer.first_name) {
                    first_name_emp = vm.dataToFill.customer.split(' ')[0];
                } else {
                    first_name_emp = vm.dataToFill.customer.first_name;
                }
                if (!vm.dataToFill.customer.last_name) {
                    last_name_emp = vm.dataToFill.customer.split(' ')[1];
                } else {
                    last_name_emp = vm.dataToFill.customer.last_name;
                }
                dataSend.employee_list = {
                    name: vm.dataToFill.first_name ? vm.dataToFill.first_name : first_name_emp,
                    last_name: vm.dataToFill.last_name ? vm.dataToFill.last_name : last_name_emp,
                    cost_center: vm.dataToFill.costCenter ? vm.dataToFill.costCenter : '',
                    cost_subcenter: vm.dataToFill.costSubCenter ? vm.dataToFill.costSubCenter : '',
                    ROI: vm.dataToFill.Rol ? vm.dataToFill.Rol : '',
                    graph: vm.dataToFill.graph ? vm.dataToFill.graph : '',
                    order_of_work: vm.dataToFill.workOrder ? vm.dataToFill.workOrder : '',
                    PEP: vm.dataToFill.pep ? vm.dataToFill.pep : '',
                    email: vm.dataToFill.customerEmail,
                    phone_number: vm.dataToFill.customerMobile,
                    //password:  vm.dataToFill.password?vm.dataToFill.password:'',
                    country_code: vm.dataToFill.country_code
                };
                vm.loading = true;
                var promise = getAgreement.manageEmployeesFromCreateBooking(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        if (payload.title.status == 200) {
                            languageBasedErrorFactory.getProperErrorMessage('userRegSucc1', 0, 0)
                            //errorMessageFactory.showErrorMessage('User registered successfully',0);
                            $timeout(function () {
                                $mdDialog.hide();
                                vm.createBookingflag = true;
                                vm.createBookingflagNew = true;
                                createBookingApi($event);
                            }, 1500);
                            //$state.reload();
                        } else {
                            vm.createBookingflag = false;
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }

                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        vm.disableSubmitButton = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        }

        function createCustomerNew($event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('newUserPop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('cancelButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                var dataSend = new FormData();
                var domain = checkDomain.getDomainName();
                dataSend.append('access_token', $cookies.get('obj'));
                dataSend.append('first_name', vm.dataToFill.first_name);
                dataSend.append('last_name', vm.dataToFill.last_name);
                dataSend.append('email', vm.dataToFill.customerEmail);
                dataSend.append('country_code', vm.dataToFill.country_code);
                dataSend.append('phone_number', vm.dataToFill.customerMobile);
                //dataSend.append('password',vm.dataToFill.password);
                dataSend.append('timezone', vm.dataToFill.timeZone);
                dataSend.append('domainUrl', domain);
                console.log(dataSend);
                vm.loading = true;
                var promise = getCustomers.addCustomer(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        if (payload.title.status == 400) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            languageBasedErrorFactory.getProperErrorMessage('userRegSucc', 0, 0)
                            //errorMessageFactory.showErrorMessage('User registered successfully',0);
                            $timeout(function () {
                                $mdDialog.hide();
                                createBookingApi($event);
                            }, 1500);
                            //$state.reload();
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        vm.disableSubmitButton = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        }

        //====================update employee details api=======================
        function updateEmployeeProfile() {
            console.log(vm.selectedEmployeeData);
            vm.checkDataChanged = {
                rut: false,
                costCenter: false,
                costSbCenter: false,
                rol: false,
                graph: false,
                pep: false
            };
            vm.selectedEmployeeData.employee_details.RUT = vm.selectedEmployeeData.employee_details.RUT ? vm.selectedEmployeeData.employee_details.RUT : '';
            if (RutHelper.clean(vm.dataToFill.applicantRut) != vm.selectedEmployeeData.employee_details.RUT)
                vm.checkDataChanged.rut = true;
            else vm.checkDataChanged.rut = false;
            if (vm.dataToFill.costCenter != vm.selectedEmployeeData.employee_details.cost_center)
                vm.checkDataChanged.costCenter = true;
            else vm.checkDataChanged.costCenter = false;
            if (vm.dataToFill.costSubCenter != vm.selectedEmployeeData.employee_details.cost_subcenter)
                vm.checkDataChanged.costSbCenter = true;
            else vm.checkDataChanged.costSbCenter = false;
            if (vm.dataToFill.Rol != vm.selectedEmployeeData.employee_details.ROI)
                vm.checkDataChanged.rol = true;
            else vm.checkDataChanged.rol = false;
            if (vm.dataToFill.graph != vm.selectedEmployeeData.employee_details.graph)
                vm.checkDataChanged.graph = true;
            else vm.checkDataChanged.graph = false;
            if (vm.dataToFill.pep != vm.selectedEmployeeData.employee_details.PEP)
                vm.checkDataChanged.pep = true;
            else vm.checkDataChanged.pep = false;

            console.log(vm.checkDataChanged);
            if (vm.checkDataChanged.rut || vm.checkDataChanged.costCenter || vm.checkDataChanged.costSbCenter || vm.checkDataChanged.rol || vm.checkDataChanged.graph || vm.checkDataChanged.pep) {
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.employee_id = vm.selectedEmployeeData.employee_details.id;
                dataSend.RUT = RutHelper.clean(vm.dataToFill.applicantRut);
                dataSend.cost_center = vm.dataToFill.costCenter;
                dataSend.cost_subcenter = vm.dataToFill.costSubCenter;
                dataSend.ROI = vm.dataToFill.Rol;
                dataSend.graph = vm.dataToFill.graph;
                dataSend.PEP = vm.dataToFill.pep;

                var promise = getAgreement.updateEmployeeAdditionalFields(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        if (payload.title.status == 400) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        } else if (payload.title.status == 201 || payload.title.status == 200) {

                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        vm.disableSubmitButton = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }
        }

        //=======================create booking api==========================
        function createBookingApi($event) {
            // TV-1345  CCOMMENT BY NAKUL
            var condition = _.contains(vm.matchArray, vm.dataToFill.contractIdSelected);
            if (condition == false && vm.matchArray != undefined && !vm.flagAgreement && !vm.createBookingflag) {
                errorMessageFactory.showErrorMessage('El cliente seleccionado no es parte de este convenio', 0);
                return false;
            }
            if (vm.dataToFill.roundTrip) {
                if (vm.return_flag == false || vm.return_flag == undefined) {
                    errorMessageFactory.showErrorMessage('Ida y vuelta de este servicio no está disponible', 0);
                    return false;
                }
            }
            var tz = moment.tz.guess();
            // if (!vm.dataToFill.is_wait_time_included && vm.dataToFill.roundTrip) {
            //     errorMessageFactory.showErrorMessage('¡Lo siento! No está permitido crear un viaje de ida y vuelta sin esperar a reservar.', 0);
            //     return false;
            // }
            // console.log(vm.via_controlled_price_to_send, ' vm.via_controlled_price_to_send');

            // console.log(vm.dataToFill.estimatedFare, vm.via_controlled_price_to_send, vm.dataToFill.estimatedFare, vm.viaControlled2, 'gffhffhgfhf', vm.viaControlled1);

            if (Number(vm.dataToFill.estimatedFare < vm.via_controlled_price_to_send) || Number(vm.dataToFill.estimatedFare < vm.viaControlled2)) {
                errorMessageFactory.showErrorMessage('Reserva no puede ser creada debido a que Via controlada es mayor que valor del tramo', 0);
                return false;
            }
            $log.log(vm.dataToFill);
            var dataSend = {};
            dataSend.time = [];
            dataSend.access_token = $cookies.get('obj');
            dataSend.customer_email = vm.dataToFill.customerEmail;
            dataSend.customer_phone_number = vm.dataToFill.customerMobile;
            var check;
            if (vm.flagForOtherAgreement == true) {
                check = 1;
            } else {
                check = vm.dataToFill.customerProfile == 0 || vm.dataToFill.customerProfile == '0' ? 0 : 1;
            }
            dataSend.profile = Number(check);
            dataSend.number_of_passangers = Number(vm.dataToFill.passengerCount);
            dataSend.timezone = new Date().getTimezoneOffset();
            dataSend.booking_for = Number(vm.dataToFill.bookingFor);
            dataSend.pickup_location = vm.dataToFill.pickUpAddress;
            dataSend.job_pickup_comuna = vm.jobPickupComuna || null; // Send CITY of PICKUP ADDRESS
            dataSend.drop_location = vm.dataToFill.dropOffAddress;
            dataSend.job_dropoff_comuna = vm.jobDropoffComuna || null; // Send CITY of DROPOFF ADDRESS
            dataSend.pickup_lat = vm.dataToFill.pickLat;
            dataSend.pickup_long = vm.dataToFill.pickLng;
            dataSend.drop_lat = vm.dataToFill.dropLat;
            dataSend.drop_long = vm.dataToFill.dropLng;
            dataSend.transport_type_id = Number(vm.dataToFill.carType);
            dataSend.schedule_ride = 0;
            dataSend.round_trip = Number(vm.dataToFill.roundTrip);
            dataSend.shift_id = vm.ShiftId;
            console.log(vm.type_of_trip, vm.dataToFill.selectedServiceDetails.category);

            if ((vm.dataToFill.roundTrip && !vm.dataToFill.is_wait_time_included && vm.dataToFill.selectedServiceDetails.category != 1) ||
                (vm.dataToFill.roundTrip && vm.type_of_trip != 'R' && vm.dataToFill.selectedServiceDetails.category == 1)) {
                if (vm.dataToFill.returnDate != '' && vm.dataToFill.returnTime != '') {
                    dataSend.returnTimeZone = moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.returnDate, vm.dataToFill.returnTime).toISOString()));
                    dataSend.return_date_time = dateTimeFormat(vm.dataToFill.returnDate, vm.dataToFill.returnTime).toISOString();
                } else {
                    if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip == 'R' && vm.dataToFill.returnDateShared != '' && vm.dataToFill.returnTimeShared != '') {
                        dataSend.returnTimeZone = moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.returnDateShared, vm.dataToFill.returnTimeShared).toISOString()));
                        dataSend.return_date_time = dateTimeFormat(vm.dataToFill.returnDateShared, vm.dataToFill.returnTimeShared).toISOString();
                        dataSend.return_booking_eta = vm.dataToFill.etaScheduleValueReturn;
                    } else {
                        dataSend.return_date_time = '0000-00-00 00:00:00';
                        dataSend.returnTimeZone = new Date().getTimezoneOffset();
                    }
                }

            } else {
                if (vm.dataToFill.roundTrip && vm.dataToFill.returnDateShared != '' && vm.dataToFill.returnTimeShared != '') {
                    dataSend.returnTimeZone = moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.returnDateShared, vm.dataToFill.returnTimeShared).toISOString()));
                    dataSend.return_date_time = dateTimeFormat(vm.dataToFill.returnDateShared, vm.dataToFill.returnTimeShared).toISOString();
                    if (vm.dataToFill.selectedServiceDetails.category == 1 && !vm.method_range_pickup) {
                        dataSend.return_booking_eta = vm.dataToFill.etaScheduleValueReturn + vm.dataToFill.time_trip_shared_service;
                        console.log(vm.dataToFill.etaScheduleValueReturn, 'ist if');

                    } else {
                        dataSend.return_booking_eta = vm.dataToFill.etaScheduleValueReturn;
                        console.log(vm.dataToFill.etaScheduleValueReturn, '2nd if');

                    }
                } else {
                    if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip == 'R' && vm.dataToFill.returnDateShared != '' && vm.dataToFill.returnTimeShared != '') {
                        dataSend.returnTimeZone = moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.returnDateShared, vm.dataToFill.returnTimeShared).toISOString()));
                        dataSend.return_date_time = dateTimeFormat(vm.dataToFill.returnDateShared, vm.dataToFill.returnTimeShared).toISOString();
                        dataSend.return_booking_eta = vm.dataToFill.etaScheduleValueReturn;
                    } else {
                        dataSend.return_date_time = '0000-00-00 00:00:00';
                        dataSend.returnTimeZone = new Date().getTimezoneOffset();
                    }
                }
            }
            if ((vm.dataToFill.selectedServiceDetails.category == 0) && (vm.type_of_trip == 'R')) {
                dataSend.travel_time = vm.travel_time_service_pick_up;
                dataSend.tolerance_time = vm.tolerance_time_withdrawal_pickup;
            }
            //if(vm.dataToFill.reference_point){
            //    dataSend.reference_point = vm.dataToFill.reference_point;
            //}
            if (vm.dataToFill.corporate_account_id && (vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == '1')) {
                dataSend.corporate_account_id = vm.dataToFill.corporate_account_id;
            }
            if (vm.dataToFill.selectedServiceDetails.category == 1) {
                dataSend.booking_eta = vm.dataToFill.etaScheduleValue + vm.dataToFill.time_trip_shared_service;
            } else {
                dataSend.booking_eta = vm.dataToFill.etaSchedule;
            }
            if (vm.dataToFill.route_type === 0 && vm.estimatedDistanceToSend)
                dataSend.est_distance = vm.estimatedDistanceToSend;
            dataSend.route_id = vm.dataToFill.route_id;
            dataSend.route_type = vm.dataToFill.route_type;
            dataSend.type_of_agreement = vm.dataToFill.type_of_agreement;
            dataSend.is_wait_time_included = vm.dataToFill.is_wait_time_included ? 1 : 0;
            dataSend.contract_id = vm.dataToFill.contractIdSelected;
            dataSend.service_type = Number(vm.dataToFill.serviceTypeSelected);

            if (vm.dataToFill.authRequired == '1' && check == 1) {
                dataSend.auth_required = Number(vm.dataToFill.authRequired);
                dataSend.auth_of = RutHelper.clean(vm.dataToFill.authRUT);
            } else {
                dataSend.auth_required = 0;
            }

            if (vm.dataToFill.itemOfChargeSelected.length) {
                vm.dataToFill.item_of_charges = [];
                vm.dataToFill.is_item_of_charges = 1;
                for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                    vm.dataToFill.item_of_charges.push({
                        "fixed_pricing_id": vm.dataToFill.itemOfChargeSelected[i].fixed_pricing_id ? vm.dataToFill.itemOfChargeSelected[i].fixed_pricing_id : vm.dataToFill.itemOfChargeSelected[i].variable_pricing_id,
                        "id": vm.dataToFill.itemOfChargeSelected[i].tic_id,
                        "item_of_charge_id": vm.dataToFill.itemOfChargeSelected[i].id,
                        "description": vm.dataToFill.itemOfChargeSelected[i].tic_description,
                        "long_name": vm.dataToFill.itemOfChargeSelected[i].tic_long_name,
                        "manually": vm.dataToFill.itemOfChargeSelected[i].tic_manually,
                        "price": vm.dataToFill.itemOfChargeSelected[i].price,
                        "short_name": vm.dataToFill.itemOfChargeSelected[i].tic_short_name,
                        "quantity": vm.dataToFill.itemOfChargeSelected[i].quantity,
                        "retorno": vm.dataToFill.itemOfChargeSelected[i].retorno
                    })
                }
                dataSend.is_item_of_charges = Number(vm.dataToFill.is_item_of_charges);
                var items_ida = vm.dataToFill.item_of_charges.filter(function(itm){ return itm.retorno == false });
                var items_vuelta = vm.dataToFill.item_of_charges.filter(function(itm){ return itm.retorno == true })
                dataSend.item_of_charges = items_ida;
                dataSend.item_of_charges_return = items_vuelta;
            } else {
                dataSend.is_item_of_charges = 0;
            }
            // console.log(vm.return_flag == true , vm.dataToFill.roundTrip == true,'vm.return_flag == true && vm.dataToFill.roundTrip == true');


            if (vm.dataToFill.passengerRutCheck == 1)
                dataSend.passenger_rut = RutHelper.clean(vm.dataToFill.passengerRut);
            if (vm.dataToFill.applicantRutCheck == 1)
                dataSend.applicant_rut = RutHelper.clean(vm.dataToFill.applicantRut);
            if (vm.dataToFill.costCenterCheck == 1)
                dataSend.cost_center = vm.dataToFill.costCenter;
            if (vm.dataToFill.costSubCenterCheck == 1)
                dataSend.sub_cost_center = vm.dataToFill.costSubCenter;
            if (vm.dataToFill.RolCheck == 1)
                dataSend.rol = vm.dataToFill.Rol;
            if (vm.dataToFill.graphCheck == 1)
                dataSend.graph = vm.dataToFill.graph;
            if (vm.dataToFill.workOrderCheck == 1)
                dataSend.work_order = vm.dataToFill.workOrder;
            if (vm.dataToFill.pepCheck == 1)
                dataSend.PEP = vm.dataToFill.pep;
            if (vm.dataToFill.purposeOfTripCheck == 1)
                dataSend.purpose_of_trip = vm.dataToFill.purposeOfTrip;
            if (vm.dataToFill.noOfVoucherCheck == 1)
                dataSend.number_of_voucher = vm.dataToFill.noOfVoucher;
            if (vm.dataToFill.nominaCheck == 1)
                dataSend.nomina = vm.dataToFill.nomina;
            if (vm.dataToFill.solictudCheck == 1)
                dataSend.solicitud = vm.dataToFill.solictud;
            dataSend.observations = vm.dataToFill.observations;
            if (vm.viaControlledFLag1 == true && vm.type_of_trip1 == 'Z') {
                // if (vm.dataToFill.selectedServiceDetails.fare_type == 1) {
                //     dataSend.via_controlled_price = Number(vm.via_controlled_price_to_send) + (vm.via_controlled_price_to_send * (vm.dataToFill.passengerCount - 1));
                //     vm.addViaControlled =  Number(vm.via_controlled_price_to_send);
                // } else {
                dataSend.via_controlled_price = Number(vm.via_controlled_price_to_send);
                vm.addViaControlled = Number(vm.via_controlled_price_to_send);
                // }
                // dataSend.via_controlled_price = Number(vm.via_controlled_price_to_send);
                // vm.addViaControlled = Number(vm.via_controlled_price_to_send);
            } else {
                vm.addViaControlled = 0;
            }

            if (vm.viaControlledFLag == true && vm.dataToFill.roundTrip == true) {
                // if (vm.dataToFill.selectedServiceDetails.fare_type == 1) {
                //     dataSend.via_controlled_price = Number(vm.viaControlled2) + (vm.viaControlled2 * (vm.dataToFill.passengerCount - 1));
                //     vm.addViaControlledRound =  Number(vm.viaControlled2);;
                // } else {
                dataSend.via_controlled_price_return = Number(vm.viaControlled2);
                vm.addViaControlledRound = Number(vm.viaControlled2);;
                // }
                // dataSend.via_controlled_price_return = Number(vm.viaControlled2);
                // vm.addViaControlledRound = Number(vm.viaControlled2);
            } else {
                vm.addViaControlledRound = 0;
            }
            // Tv-1795
            if (vm.dataToFill.controllerWayTarifa == 1) {
                vm.via_controlled_price_to_send = 0;
                vm.viaControlled2 = 0;
            }
            if (vm.dataToFill.appliedCouponData.length) {
                if (vm.dataToFill.controllerWayTarifa == 1) {
                    dataSend.estimated_payment_cost = Math.round(vm.dataToFill.sortData[0].finalAmount + vm.via_controlled_price_to_send);
                } else {
                    dataSend.estimated_payment_cost = Math.round(vm.dataToFill.sortData[0].finalAmount);
                }
                //dataSend.estimated_payment_cost = vm.dataToFill.sortData[0].finalAmount  + Number(vm.dataToFill.viaControlled); // Cost After discount
            } else {
                dataSend.estimated_payment_cost = Math.round(vm.dataToFill.estimatedFare + Number(vm.via_controlled_price_to_send));
            }

            if (vm.return_flag == true && vm.dataToFill.roundTrip == true) {
                //   
                if (vm.dataToFill.appliedCouponData.length) {
                    dataSend.route_id_return = vm.dataToFill.Return_policy.route_id;
                    dataSend.route_type_return = vm.dataToFill.Return_policy.route_type;
                    if (vm.dataToFill.controllerWayTarifa == 1) {

                        dataSend.estimated_payment_cost_return = Math.round(vm.dataToFill.sortData[0].returnFinalAmount + vm.viaControlled2);
                    } else {
                        dataSend.estimated_payment_cost_return = Math.round(vm.dataToFill.sortData[0].returnFinalAmount);
                    };
                    dataSend.final_discount_amount_return = vm.dataToFill.sortData[0].ReturndiscountCost;
                } else {
                    dataSend.route_id_return = vm.dataToFill.Return_policy.route_id;
                    dataSend.route_type_return = vm.dataToFill.Return_policy.route_type;
                    dataSend.estimated_payment_cost_return = Math.round((Number(vm.dataToFill.Return_policy.estimatedFare + vm.viaControlled2)));
                    dataSend.final_discount_amount_return = vm.dataToFill.sortData[0].ReturndiscountCost
                }
                if (vm.estimated_toll_price_return !== undefined) {
                    dataSend.estimated_toll_price_return = vm.estimated_toll_price_return;
                }
                // if (vm.heremaps_toll_details_return ) {
                if (vm.heremaps_toll_details_return && vm.searchFixedVariablePayload.title.data.apply_charge_by_toll) {
                    // dataSend.heremaps_toll_details_return = vm.heremaps_toll_details_return;
                    dataSend.heremaps_toll_details_return = JSON.stringify(vm.heremaps_toll_details_return.heremaps_response['detail-cost']);
                    dataSend.heremaps_estimated_tolls_return = vm.tollCountReturn;
                    dataSend.item_of_charge_tolls_price_return = vm.toll_price_return || 0;

                }
                if (vm.ReturnEstimatedDistanceToSend && vm.dataToFill.route_type === 0) {
                    dataSend.est_distance_return = vm.ReturnEstimatedDistanceToSend;
                }
            }
            // if (vm.heremaps_toll_details ) {
            if (vm.heremaps_toll_details && vm.searchFixedVariablePayload.title.data.apply_charge_by_toll) {
                // dataSend.heremaps_toll_details = vm.heremaps_toll_details;
                dataSend.heremaps_toll_details = JSON.stringify(vm.heremaps_toll_details.heremaps_response['detail-cost']);
                dataSend.heremaps_estimated_tolls = vm.tollCount;
                dataSend.item_of_charge_tolls_price = vm.toll_price || 0;

            }

            if (vm.estimated_toll_price !== undefined) {
                dataSend.estimated_toll_price = vm.estimated_toll_price;
            }
            dataSend.reaccurring = 0;

            dataSend.payment_method = vm.dataToFill.paymentMethodSelected.id;
            dataSend.is_POS_booking = 1;
            dataSend.POS_point_id = vm.dataToFill.operationData.operation.point_id;
            dataSend.discount_code = vm.dataToFill.couponCode;
            dataSend.payment_status = 1;
            dataSend.created_by_admin = 2;
            dataSend.payment_operation_point = vm.dataToFill.operationData.operation.point_id;
            dataSend.is_adjusted_discounted_amount = 0;


            //0-coupon
            //1-round trip
            //2-web
            //3-bin
            if (vm.dataToFill.appliedCouponData.length) {
                if (vm.dataToFill.sortData[0].coupon_name == 'Round Trip') {
                    dataSend.promo_type = 1;
                } else {
                    dataSend.promo_type = 0;
                    dataSend.promo_id = vm.dataToFill.sortData[0].coupon_name;

                }
                if (vm.dataToFill.appliedCouponData[0].promoType === 'adjustedPrice') {
                    dataSend.promo_type = 0;
                    dataSend.is_adjusted_discounted_amount = 1;
                }
                dataSend.discount_type = Number(vm.dataToFill.sortData[0].type);
                dataSend.discount_amount = ((dataSend.is_adjusted_discounted_amount == 1) && (dataSend.is_wait_time_included == 0) && (dataSend.round_trip == 1)) ? Number(vm.dataToFill.sortData[0].value / 2) : Number(vm.dataToFill.sortData[0].value);
                dataSend.final_discount_amount = vm.dataToFill.sortData[0].discountCost;
            }
            //dataSend.POS_payment_method = vm.dataToFill.paymentMethodSelected.id;
            if (vm.dataToFill.selectedServiceDetails.category == 0) { //exclusive
                dataSend.booking_type = 0; //Normal
            } else if (vm.dataToFill.selectedServiceDetails.category == 1) { //shared
                dataSend.booking_type = 1; //shared
            }
            //else if(vm.dataToFill.selectedServiceDetails.category == 2){ //Normal
            //    dataSend.booking_type = 0; //Normal
            //}

            if (vm.dataToFill.returnDateShared != '' && vm.dataToFill.returnTimeShared != '') {
                if (vm.type_of_trip == 'R' && vm.dataToFill.selectedServiceDetails.category == 1 && vm.method_range_pickup && vm.dataToFill.roundTrip == 1) {
                    dataSend.is_routing = 1;
                    dataSend.time_pickup_return_route = (vm.pickRangeSendForRoutingReturn);
                    dataSend.returnTimeZone = vm.timeZoneRRoundReturn;
                    dataSend.tolerance_before_route_return = vm.pickup_lower_range_return;
                    dataSend.tolerance_after_route_return = vm.pickup_top_range_return;
                    dataSend.travel_distance_route_return = vm.distanceRoutingApiReturn;
                }
            }
            dataSend.apply_charge_by_toll = vm.searchFixedVariablePayload.title.data.apply_charge_by_toll;
            if (vm.dataToFill.route_type === 0) {
                dataSend.apply_estimated_distance_variable_fare = vm.searchFixedVariablePayload.title.data.apply_estimated_distance_variable_fare;
                dataSend.collect_estimated_tag = vm.searchFixedVariablePayload.title.data.collect_estimated_tag;
            }
            dataSend.factor_value = vm.dataToFill.factor_value;
            dataSend.factor_type = vm.dataToFill.factor_tipo;
            dataSend.factor_id = vm.dataToFill.factor_id;
            if(vm.dataToFill.roundTrip){
                dataSend.factor_return_value = vm.dataToFill.factor_return_value;
                dataSend.factor_return_type = vm.dataToFill.factor_return_tipo;
                dataSend.factor_return_id = vm.dataToFill.factor_return_id;
            }
            $log.log(dataSend);
            vm.loading = true;
            // console.log(dataSend, 'dataSemd');

            var promise = getBookings.createBooking(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        if (payload.title.data.flag == 'pending_payment') {
                            vm.disableSubmitButton = false;
                            openPopPendingPayment(payload.title, $event);
                        } else {
                            vm.secondPrint = payload;

                            // console.log(vm.dataToFill.authRequired, 'vm.dataToFill.authRequired');

                            if (vm.dataToFill.authRequired == '1' || vm.dataToFill.authRequired == 1) {
                                if (payload.title.status == 400) {
                                    errorMessageFactory.showErrorMessage(payload.title.message, 0);
                                } else {
                                    vm.bookingSuccesPopUp = true;
                                    // bookingCreationSuccess(payload, 'Auth', $event);
                                }
                                //languageBasedErrorFactory.getProperErrorMessage('bookingSuccA',0,1)
                                //errorMessageFactory.showErrorMessage('Booking created successfully.But the Reserve will remain pending until Authorized.',1);
                            } else {
                                if (payload.title.status == 400) {
                                    errorMessageFactory.showErrorMessage(payload.title.message, 0);
                                } else {
                                    vm.bookingSuccesPopUp = true;
                                    // bookingCreationSuccess(payload, 'NoAuth', $event);
                                }
                                //languageBasedErrorFactory.getProperErrorMessage('bookingSucc',0,1)
                                //errorMessageFactory.showErrorMessage('Booking created successfully.',1);
                            }
                            if ((vm.dataToFill.airportCheck == 'Z' && vm.Search_type_of_trip == 'Z' && payload.title.data != {}) || (vm.dataToFill.airportCheck == 'P' && payload.title.data != {})) {
                                getPrintReceiptHeight(payload);
                            } else {
                                bookingCreationSuccess(payload, 'NoAuth', $event);

                            }
                        }
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }


                    //$timeout(function() {
                    //    $mdDialog.hide();
                    //     $state.reload();
                    //}, 2000);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    vm.disableSubmitButton = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        //=================open pop for pending payment=====================
        function openPopPendingPayment(data, $event) {
            vm.items = {};
            vm.items.data = data;

            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/openPopForPendingPayment.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                escapeToClose: false,
                controller: PendingPaymentController
            });

            function PendingPaymentController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };

                $scope.gotToPreviousBooking = function (items) {
                    $mdDialog.hide();
                    $state.go('layout.completedBookingsMain.completedBookingDetailsNew', {
                        id: items.data.data.job_id,
                        type: '2'
                    });
                }
            }
        }

        function get_cuota(){
            if(restriccion_flota == 1){
                //el convenio tiene restriccion de flota, se debe consultar la cuota
                var tipo_servicio = vm.dataToFill.serviceTypeSelected;
                var pasajeros = vm.dataToFill.passengerCount || 1;
                var fecha = new Date();
                console.log(sucursal_id, tipo_servicio, fecha);
                if( sucursal_id && tipo_servicio && fecha ){
                    //vm.loading = true;
                    cupos_fecha_global = moment(fecha).format('YYYY-MM-DD');
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.fecha = moment(fecha).format('YYYY-MM-DDTH:mm:ss');
                    dataSend.tipo_servicio = tipo_servicio;
                    dataSend.sucursal_id = sucursal_id;
                    dataSend.pasajeros = pasajeros;
                    var promise = getBookings.getFlotaCuota(dataSend);
                    promise.then(
                        function (payload) {
                            //vm.loading = false;
                            var response = JSON.parse(payload.response);
                            if (response.data) {
                                cupos_global = response.data.cupos_tomados;
                                if(response.data.cupos < 0 && Object.keys(response.data.bloque) != 0){
                                    errorMessageFactory.showErrorMessage("No hay disponibilidad del servicio seleccionado para el horario requerido. Revisa otras alternativas de horario.", 0);
                                    vm.disabledSubmitButton = false;
                                    vm.fullCuota = true;
                                    return false;
                                }
                                vm.disabledSubmitButton = true;
                                vm.fullCuota = false;
                                //vm.loading = false;
                                return true;
                            }
                            //vm.loading = false;
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        //vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );

                }
                return true;
            }
            return true;
        }

        function get_cuota_rt(){
            if(restriccion_flota == 1 && vm.dataToFill.roundTrip){
                //el convenio tiene restriccion de flota, se debe consultar la cuota
                var tipo_servicio = vm.dataToFill.serviceTypeSelected;
                var pasajeros = vm.dataToFill.passengerCount || 1;
                var fecha;
                if(vm.dataToFill.returnDateShared && vm.dataToFill.selectedServiceDetails.category == 0)
                    fecha = moment(vm.dataToFill.returnDateShared).format('YYYY-MM-DD H:mm:ss');
                if(vm.method_range_pickup && vm.dataToFill.selectedServiceDetails.category == 1 && vm.dataToFill.returnDateShared){
                    fecha = moment(vm.dataToFill.returnDateShared).format('YYYY-MM-DD') + ' ' + vm.pickRangeForRoutingReturn; 
                }
                if(vm.showPickUpTime && !vm.method_range_pickup && vm.dataToFill.returnDateShared){
                    fecha = moment(vm.dataToFill.returnDateShared).format('YYYY-MM-DD') + ' ' +vm.pickRange5;
                }

                console.log(sucursal_id, tipo_servicio, fecha);
                if( sucursal_id && tipo_servicio && fecha ){
                    //vm.loading = true;
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.fecha = moment(fecha).format('YYYY-MM-DDTHH:mm:ss');
                    dataSend.tipo_servicio = tipo_servicio;
                    dataSend.sucursal_id = sucursal_id;
                    dataSend.pasajeros = pasajeros;
                    var promise = getBookings.getFlotaCuota(dataSend);
                    promise.then(
                        function (payload) {
                            //vm.loading = false;
                            var response = JSON.parse(payload.response);
                            if (response.data && vm.dataToFill.roundTrip) {
                                var consulta = moment().format('YYYY-MM-DD');
                                if(vm.dataToFill.returnDateShared)
                                    consulta = moment(vm.dataToFill.returnDateShared).format('YYYY-MM-DD');
                                if(cupos_fecha_global == consulta) {
                                    response.data.cupos = response.data.cupos - cupos_global;
                                }
                                if(response.data.bloqueado == 1){
                                    errorMessageFactory.showErrorMessage("No hay disponibilidad del servicio seleccionado para el horario RT requerido. Revisa otras alternativas de horario.", 0);
                                    vm.disabledSubmitButton = false;
                                    vm.fullCuotaRT = true;
                                    return false;
                                }
                                vm.disabledSubmitButton = true;
                                vm.fullCuotaRT = false;
                                $scope.$apply();
                                return true;
                            }
                            vm.disabledSubmitButton = true;
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        //vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );

                }
                return true;
            }
            vm.disabledSubmitButton = true;
            return true;
        }


        //=======================open pop up after booking creation============================
        function bookingCreationSuccess(data, text, $event) {
            vm.items = {};
            vm.items.authPending = text == 'Auth' ? true : false;
            vm.items.tableData = data.title.jobs.data;
            vm.items.Template = data.title.pdf_data_resp;
            vm.items.copied = false;
            vm.items.loading = false;
            if (data.title.jobs.key == 0) {
                vm.items.singleBooking = true;
            } else {
                vm.items.singleBooking = false;
            }
            if (data.title.jobs.key == 0 || data.title.jobs.key == 2) {
                vm.items.roundTrip = false;
            } else {
                vm.items.roundTrip = true;
            }

            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/createBookingSuccess.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                escapeToClose: false,
                controller: CreateBookingSuccessController
            });

            function CreateBookingSuccessController($scope, $mdDialog, items, tmhDynamicLocale) {
                $scope.items = items;
                tmhDynamicLocale.set('es');
                var win = '';
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                    if (win) {
                        win.close();
                    }
                    $timeout(function () {
                        $state.reload('layout.quickSaleMain.quickSale');
                    }, 0);

                };
                $scope.getIndex = function (index) {
                    console.log(vm.items.Template, 'vm.items');
                    console.log(vm.items.Template[index], 'vm.items[index]');
                    $scope.copyTemplate(vm.items.Template[index]);

                }
                $scope.copyTemplate = function (data) {
                    vm.templateString = '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 ' +
                        '                Transitional//EN" ' +
                        '                "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">' +
                        '<html>' +
                        '' +
                        '<head>' +
                        '    <meta charset="UTF-8">' +
                        '    <meta name="viewport" content="width=device-width, ' +
                        '                initial-scale=1.0">' +
                        '    <title>Ride Over</title>' +
                        '' +
                        '    <style type="text/css">' +
                        '        .mainheader {' +
                        '            margin: 0 auto;' +
                        '            padding: 0 20px;' +
                        '            background-color: rgb(6, 60, 74);' +
                        '            width: 750px;' +
                        '        }' +
                        '' +
                        '        .mainLogoTd {' +
                        '            height: 80px;' +
                        '            border: none;' +
                        '        }' +
                        '' +
                        '        .tableStyle {' +
                        '            padding: 0 25px;' +
                        '            width: 100%;' +
                        '        }' +
                        '' +
                        '        .LeftTextWidth {' +
                        '            width: 70%;' +
                        '            padding-top: 15px;' +
                        '        }' +
                        '' +
                        '        .RightTextWidth {' +
                        '            width: 30%;' +
                        '            padding-top: 15px;' +
                        '        }' +
                        '' +
                        '        .LogotableStyle {' +
                        '            border: 0;' +
                        '            width: 100%;' +
                        '            text-align: center;' +
                        '            padding-top: 0;' +
                        '            padding-bottom: 0;' +
                        '        }' +
                        '' +
                        '        .padding30 {' +
                        '            padding-top: 30px;' +
                        '        }' +
                        '' +
                        '        .Hey-cutomer {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 22px;' +
                        '            font-weight: 500;' +
                        '            letter-spacing: 1px;' +
                        '            text-align: left;' +
                        '            color: #1f1f1f;' +
                        '        }' +
                        '' +
                        '        .Trip-Details {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 24px;' +
                        '            line-height: 1.4;' +
                        '            letter-spacing: 1px;' +
                        '            text-align: left;' +
                        '            font-weight: bold;' +
                        '            color: #242424;' +
                        '        }' +
                        '' +
                        '        .pickAddress {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 18px;' +
                        '            letter-spacing: 1.1px;' +
                        '            text-align: left;' +
                        '            color: #262626;' +
                        '        }' +
                        '' +
                        '        .You-Rode-with-James {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 18px;' +
                        '            font-weight: 600;' +
                        '            line-height: 1.4;' +
                        '            text-align: left;' +
                        '            color: #070707;' +
                        '        }' +
                        '' +
                        '        .LeftText {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 20px;' +
                        '            letter-spacing: 1.1px;' +
                        '            text-align: left;' +
                        '            color: #000000;' +
                        '        }' +
                        '' +
                        '        .RightText {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 20px;' +
                        '            font-weight: bold;' +
                        '            letter-spacing: 1.1px;' +
                        '            text-align: right;' +
                        '            color: #000000;' +
                        '        }' +
                        '' +
                        '        .Fare-Breakdown {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 18px;' +
                        '            font-weight: 600;' +
                        '            line-height: 1.4;' +
                        '            text-align: left;' +
                        '            color: #000000;' +
                        '        }' +
                        '' +
                        '        .TOTAL-FARE-Tk-880 {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 23px;' +
                        '            font-weight: bold;' +
                        '            line-height: .87;' +
                        '            text-align: right;' +
                        '            color: #a5a1ff;' +
                        '        }' +
                        '' +
                        '        .Fare-Details {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 18px;' +
                        '            line-height: .87;' +
                        '            color: #1f1f1f;' +
                        '        }' +
                        '' +
                        '        .straightLine {' +
                        '            padding-top: 20px;' +
                        '            border-bottom: 1px solid #b3b3b3;' +
                        '        }' +
                        '' +
                        '        .footerTable {' +
                        '            border: 0;' +
                        '            background-color: rgb(6, 60, 74);' +
                        '            width: 100%;' +
                        '        }' +
                        '' +
                        '        .Float-text {' +
                        '            float: right;' +
                        '        }' +
                        '' +
                        '        .Clear-all {' +
                        '            clear: both;' +
                        '        }' +
                        '' +
                        '        .Fair-full-details {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 17px;' +
                        '            line-height: .87;' +
                        '            text-align: right;' +
                        '            color: #1f1f1f;' +
                        '        }' +
                        '' +
                        '        .Visibilty {' +
                        '            visibility: hidden;' +
                        '        }' +
                        '' +
                        '        .Background-adjust {' +
                        '            background-color: lightgray;' +
                        '            padding: 5px;' +
                        '        }' +
                        '' +
                        '        .Total-Fair {' +
                        '            font-size: 35px;' +
                        '            font-weight: 600;' +
                        '            text-align: left;' +
                        '            padding-top: 5px;' +
                        '        }' +
                        '' +
                        '        .Total-Fair-1 {' +
                        '            font-size: 35px;' +
                        '            font-weight: 600;' +
                        '            text-align: right;' +
                        '            padding-top: 5px;' +
                        '        }' +
                        '' +
                        '        .Text-Align {' +
                        '            text-align: left;' +
                        '        }' +
                        '' +
                        '        .Text-Right {' +
                        '            text-align: right;' +
                        '        }' +
                        '' +
                        '        .Font-Size-Adjust {' +
                        '            font-size: 12px;' +
                        '        }' +
                        '' +
                        '        .Font-Size-Customer {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 22px;' +
                        '            line-height: .87;' +
                        '            text-align: left;' +
                        '            color: #1f1f1f;' +
                        '        }' +
                        '' +
                        '        .AddressDetails {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 22px;' +
                        '            line-height: .87;' +
                        '            text-align: left;' +
                        '            font-weight: bold;' +
                        '            color: #1f1f1f;' +
                        '        }' +
                        '' +
                        '        .padding10 {' +
                        '            padding-top: 10px;' +
                        '        }' +
                        '' +
                        '        .disance-Details {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 20px;' +
                        '            line-height: .87;' +
                        '            text-align: left;' +
                        '            color: #1f1f1f;' +
                        '        }' +
                        '' +
                        '        .Marker-image {' +
                        '            width: 30px;' +
                        '        }' +
                        '' +
                        '        .Tarifa-text {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 22px;' +
                        '            line-height: .87;' +
                        '            text-align: left;' +
                        '            font-weight: bold;' +
                        '            color: #1f1f1f;' +
                        '        }' +
                        '' +
                        '        .ObservationText {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 14px;' +
                        '            line-height: .87;' +
                        '            text-align: left;' +
                        '            color: #1f1f1f;' +
                        '            border: 2px solid #1f1f1f;' +
                        '        }' +
                        '' +
                        '        .bottomtext {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 15px;' +
                        '            line-height: .87;' +
                        '            text-align: left;' +
                        '            color: #1f1f1f;' +
                        '        }' +
                        '' +
                        '        .footerImage {' +
                        '            display: block;' +
                        '            margin: 0 auto;' +
                        '        }' +
                        '' +
                        '        .footerImageText {' +
                        '            color: #FFFFFF;' +
                        '            margin-top: 7px;' +
                        '            text-align: center;' +
                        '        }' +
                        '' +
                        '        .tableStyleWithoutPadding {' +
                        '            width: 100%;' +
                        '        }' +
                        '' +
                        '        pre {' +
                        '            font-family: sans-serif;' +
                        '            padding: 4px;' +
                        '            margin: 4px;' +
                        '        }' +
                        '' +
                        '        .createdText {' +
                        '            color: orange;' +
                        '            font-size: 18px;' +
                        '        }' +
                        '' +
                        '        .heading {' +
                        '            color: black;' +
                        '            font-weight: bold;' +
                        '            padding-left: 20px;' +
                        '            font-size: 18px;' +
                        '        }' +
                        '' +
                        '        .vip {' +
                        '            float: right;' +
                        '            color: red;' +
                        '            font-weight: bold;' +
                        '            font-size: 16px;' +
                        '            padding-right: 30px;' +
                        '            padding-bottom: 20px;' +
                        '        }' +
                        '' +
                        '        .headingRight {' +
                        '            float: right;' +
                        '            color: black;' +
                        '            /* font-weight: bold; */' +
                        '            font-size: 18px;' +
                        '            padding-right: 50px;' +
                        '            padding: 8px 20px 8px 0px;' +
                        '            min-height: 16px;' +
                        '        }' +
                        '    </style>' +
                        '</head>' +
                        '' +
                        '<body>' +
                        '    <table style=" margin: 0 auto;padding: 20px 20px; background-color: rgb(6, 60, 74);width: 600px;">' +
                        '        <tbody>' +
                        '            <tr style="background-color:#fff;color:#FFFFFF;">' +
                        '                <td style="padding:10px">' +
                        '                    <table style="border:0;width:100%;">' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold;font-size: 16px;">' +
                        '                                Reserva:' +
                        '                            </td>' +
                        '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.job_id}}' +
                        '' + '                       <td style="color: red;font-weight: bold;font-size: 14px;padding-right: 30px;">' +
                        '                                {{vip}}' +
                        '                            </td>' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr  style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold;font-size: 16px;">' +
                        '                                Nombre:' +
                        '                            </td>' +
                        '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.customer_username}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold; font-size: 16px;">' +
                        '                                Telefono:' +
                        '                            </td>' +
                        '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.customer_phone}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold; font-size: 16px;">' +
                        '                                Correo:' +
                        '                            </td>' +
                        '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.customer_email}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold; font-size: 16px;">' +
                        '                                Origen:' +
                        '                            </td>' +
                        '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.job_pickup_address}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold; font-size: 16px;width:200px">' +
                        '                                Fecha Retiro:' +
                        '                            </td>' +
                        '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.date}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold;font-size: 16px;width:200px">' +
                        '                                Hora retiro:' +
                        '                            </td>' +
                        '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.time}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold; font-size: 16px;">' +
                        '                                Destino:' +
                        '                            </td>' +
                        '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.job_address}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold; font-size: 16px;width:200px">' +
                        '                                Tipo Servicio:' +
                        '                            </td>' +
                        '                            <td style="color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.service_name}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold;font-size: 16px;width:200px">' +
                        '                                Num. Pasajeros:' +
                        '                            </td>' +
                        '                            <td style="color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.number_of_passangers}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold; font-size: 16px;">' +
                        '                                Estado:' +
                        '                            </td>' +
                        '                            <td style="color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.Estado}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold; font-size: 16px;">' +
                        '                                Convenio:' +
                        '                            </td>' +
                        '                            <td style="color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.contract_name}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold;font-size: 16px;width:200px">' +
                        '                                Tarifa estimada:' +
                        '                            </td>' +
                        '                            <td style="color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.estimated_payment_cost}} / {{vm.bookingDetails.fare}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                    </table>' +
                        '' +
                        '                </td>' +
                        '            </tr>' +
                        '        </tbody>' +
                        '    </table>' +
                        '</body>' +
                        '' +
                        '</html>';
                    vm.string = vm.templateString;
                    if (data.payment_status == 1 || data.payment_status == 1) {
                        vm.string = vm.string.replace('{{vm.bookingDetails.Estado}}', 'PAGADA');
                    } else {
                        vm.string = vm.string.replace('{{vm.bookingDetails.Estado}}', 'NO PAGADA');
                    }
                    if (data.job_time_utc && data.job_time_utc != '0000-00-00 00:00:00') {
                        var time = moment(data.job_time_utc).format('HH:mm')
                        vm.string = vm.string.replace('{{vm.bookingDetails.time}}', time);
                    } else {
                        vm.string = vm.string.replace('{{vm.bookingDetails.time}}', '--');
                    }
                    if (data.job_time_utc && data.job_time_utc != '0000-00-00 00:00:00') {
                        var date = moment(data.job_time_utc).format('MMMM DD YYYY')
                        vm.string = vm.string.replace('{{vm.bookingDetails.date}}', date);
                    } else {
                        vm.string = vm.string.replace('{{vm.bookingDetails.date}}', '--');
                    }
                    if (data.route_type == 1) {
                        vm.string = vm.string.replace('{{vm.bookingDetails.fare}}', 'FIJA');
                    } else {
                        vm.string = vm.string.replace('{{vm.bookingDetails.fare}}', 'Variable');
                    }
                    if (data.is_vip == 1) {
                        vm.string = vm.string.replace('{{vip}}', VIP);
                    } else {
                        vm.string = vm.string.replace('{{vip}}', '')
                    }

                    function numberWithCommas(x) {
                        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                    };
                    vm.string = vm.string.replace('{{vm.bookingDetails.job_id}}', JSON.stringify(data.job_id));
                    vm.string = vm.string.replace('{{vm.bookingDetails.customer_phone}}', data.customer_phone);
                    vm.string = vm.string.replace('{{vm.bookingDetails.customer_username}}', data.customer_username);
                    vm.string = vm.string.replace('{{vm.bookingDetails.job_pickup_address}}', data.job_pickup_address);
                    vm.string = vm.string.replace('{{vm.bookingDetails.customer_email}}', data.customer_email);
                    vm.string = vm.string.replace('{{vm.bookingDetails.job_address}}', data.job_address);
                    vm.string = vm.string.replace('{{vm.bookingDetails.service_name}}', data.service_name);
                    vm.string = vm.string.replace('{{vm.bookingDetails.contract_name}}', data.contract_name);
                    vm.string = vm.string.replace('{{vm.bookingDetails.number_of_passangers}}', data.number_of_passangers);
                    vm.string = vm.string.replace('{{vm.bookingDetails.estimated_payment_cost}}', '$' + numberWithCommas(data.estimated_payment_cost));
                    document.getElementById('copy').value = vm.string;
                    var copyText = document.getElementById('copy');
                    console.log(document.getElementById("copy"));
                    copyText.select();
                    document.execCommand("copy");
                    if (document.execCommand('copy') == true) {
                        $scope.items.copied = true;
                        $timeout(function () {
                            $scope.items.copied = false;
                        }, 2000);
                    }
                }
                $scope.copyText = function () {
                    var el = document.getElementById('copyData')
                    var body = document.body,
                        range, sel;
                    if (document.createRange && window.getSelection) {
                        range = document.createRange();
                        sel = window.getSelection();
                        sel.removeAllRanges();
                        try {
                            range.selectNodeContents(el);
                            sel.addRange(range);
                            document.execCommand("Copy");
                        } catch (e) {
                            range.selectNode(el);
                            sel.addRange(range);
                            document.execCommand("Copy");
                        }
                    } else if (body.createTextRange) {
                        range = body.createTextRange();
                        range.moveToElementText(el);
                        range.select();
                        document.execCommand("Copy");
                    }

                    $scope.items.copied = true;
                    $timeout(function () {
                        $scope.items.copied = false;
                    }, 2000);
                };

                $scope.openPdf = function (data) {
                    console.log(data);
                    $log.log(data);
                    $scope.items.loading = true;
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.job_id = Number(data.job_id);
                    var promise = getBookings.makeCreateBookingPdfHeight(dataSend);
                    promise.then(function (payload) {
                        $log.log('sxdsads', payload);
                        document.getElementById('showPrint').innerHTML = payload.title.data.pdf_html;
                        win = window.open('', "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=" + (screen.width) + ",height=" + (screen.height) + ",top=0,left=0");
                        $scope.items.loading = false;
                        $timeout(function () {
                            win.document.body.innerHTML = payload.title.data.pdf_html;
                            // $scope.getVoucherLink(data, payload.title.data);
                        }, 1000);
                    },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            $scope.items.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }

                $scope.getVoucherLink = function (data, pdfData) {
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.job_id = Number(data.job_id);
                    //dataSend.pdf_html = pdfData.pdf_html;
                    dataSend.height = $('#showPrint').height() + 200;
                    $scope.items.loading = true;
                    var promise = getBookings.makeCreateBookingPdf(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            $scope.items.loading = false;
                            if (win) {
                                win.close();
                            }
                            win = window.open(payload.title.data.pdfLink, "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=" + (screen.width) + ",height=" + (screen.height) + ",top=0,left=0");
                            win.document.body.innerHTML = '<iframe src="' + payload.title.data.pdfLink + '" height=' + screen.height + ' width=' + screen.width + '></ifrmae>';
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            $scope.items.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }

            }
        }

        vm.printCount = 0;

        //======================print receipt api=====================
        function getPrintReceiptHeight(data, type) {
            $log.log(data);
            console.log(data, "thermal data");
            vm.showBookingIdPopUp = false;
            var jobId = '';
            var dataSend = {};
            if (data.title.jobs.key == 0 && type != 'SecondPrint') {
                jobId = data.title.jobs.data[0].job_id;
                dataSend.job_id = Number(jobId);
                vm.printCount = 1;
                vm.showBookingIdPopUp = true;
            }
            if (data.title.jobs.key == 1 && type != 'SecondPrint') {
                for (var i = 0; i < data.title.jobs.data.length; i++) {
                    if (data.title.jobs.data[i].round == 0) {
                        jobId = data.title.jobs.data[i].job_id;
                        dataSend.job_id = Number(jobId);
                    }
                    if (data.title.jobs.data[i].round == 1) {
                        vm.returnIdToPrint = data.title.jobs.data[i].job_id;
                        dataSend.job_id = Number(jobId);
                    }
                }
            } else if (type == 'SecondPrint') {
                for (var i = 0; i < data.title.jobs.data.length; i++) {
                    if (data.title.jobs.data[i].round == 1) {
                        vm.returnIdToPrint = data.title.jobs.data[i].job_id;
                        dataSend.job_id = Number(vm.returnIdToPrint);
                        vm.showBookingIdPopUp = true;
                    }
                }

            }


            dataSend.access_token = $cookies.get('obj');

            dataSend.timezone = new Date().getTimezoneOffset();
            vm.loading = true;
            var promise = getBookings.getHeightForPrint(dataSend);
            promise.then(function (payload) {
                $log.log('sxdsads', payload);

                if (payload.title.status == 200) {
                    document.getElementById('showPrintR').innerHTML = payload.title.data;
                    setTimeout(function () {
                        document.querySelector('table.mainHeader-1').style.width = '100%';
                    }, 500);

                    console.log(payload.title.data, payload.title.data, 'payload.title.data');

                    $timeout(function () {
                        if (type != 'SecondPrint') {
                            getPrintReceiptLink(jobId, payload.title.data);
                        } else {
                            getPrintReceiptLink(vm.returnIdToPrint, payload.title.data);
                        }

                    }, 100);
                } else {
                    vm.loading = false;
                    errorMessageFactory.showErrorMessage(payload.title.message, 0);
                }
            },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        var winP = '';

        function getPrintReceiptLink(data, payload, $event) {
            $log.log(data);
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.job_id = Number(data);
            dataSend.timezone = new Date().getTimezoneOffset();
            dataSend.height = $('#showPrintR').height() + 200;
            dataSend.variableDetailsThermal = payload;
            vm.loading = true;
            var promise = getBookings.printReceipt(dataSend);
            promise.then(
                function (payload) {
                    console.log(payload.title, "puneet changes ");
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    console.log(document.getElementById("showPrintR").innerHTML, ' document.getElementById("showPrintR").innerHTML');

                    // document.getElementById('showPrintR').innerHTML = '';
                    // if (winP) {
                    //     winP.close();
                    // }
                    // winP = window.open("", "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=" + (screen.width) + ",height=" + (screen.height) + ",top=0,left=0");
                    // winP.document.body.innerHTML = '<iframe src="' + payload.title.data + '" height=' + screen.height + ' width=' + screen.width + '></ifrmae>';
                    function PrintDiv() {
                        var contents = document.getElementById("showPrintR").innerHTML;
                        var frame1 = document.createElement('iframe');
                        frame1.name = "frame1";
                        // frame1.value = "frame12"
                        frame1.style.position = "absolute";
                        frame1.style.top = "-1000000px";
                        document.body.appendChild(frame1);
                        var frameDoc = frame1.contentWindow ? frame1.contentWindow : frame1.contentDocument.document ? frame1.contentDocument.document : frame1.contentDocument;
                        frameDoc.document.open();
                        // frameDoc.document
                        frameDoc.document.write();
                        frameDoc.document.write();
                        frameDoc.document.write(contents);
                        frameDoc.document.write();
                        frameDoc.document.close();
                        // setTimeout(function () {
                        //     window.frames["frame1"].focus();
                        //     window.frames["frame1"].print();
                        //     document.body.removeChild(frame1);
                        //     if (vm.printCount == 0) {
                        //         getPrintReceiptHeight(vm.secondPrint, 'SecondPrint');
                        //         vm.printCount++;
                        //     }
                        // }, 500);
                        // return false;

                        frame1.onload = function () {
                            // setTimeout(function () {
                            window.frames["frame1"].focus();
                            window.frames["frame1"].print();
                            document.body.removeChild(frame1);
                            if (vm.printCount == 0) {
                                getPrintReceiptHeight(vm.secondPrint, 'SecondPrint');
                                vm.printCount++;
                            }
                            // }, 500);
                            return false;
                        };
                        frame1.onerror = function () {
                            errorMessageFactory.showErrorMessage('Please try again', 0);
                            return false;
                        };
                    }
                    PrintDiv();
                    if (vm.bookingSuccesPopUp == true && vm.showBookingIdPopUp == true && vm.printCount == 1) {

                        if (vm.dataToFill.authRequired == '1' || vm.dataToFill.authRequired == 1) {
                            bookingCreationSuccess(vm.secondPrint, 'Auth', $event);
                        } else {
                            bookingCreationSuccess(vm.secondPrint, 'NoAuth', $event);
                        }
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            )
        }



        //===========================get print of sales report==========================
        function getPrintSalesHeight() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.timezone = new Date().getTimezoneOffset();
            vm.loading = true;
            var promise = quickSaleService.getSaleHeight(dataSend);
            promise.then(function (payload) {
                $log.log('sxdsads', payload);
                document.getElementById('salesReport').innerHTML = payload.title.data.html;
                $timeout(function () {
                    getPrintSalesLink(payload.title.data.html);
                }, 100);
            },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        var winR = '';

        function getPrintSalesLink(data) {
            $log.log(data);
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.height = $('#salesReport').height() + 200;
            vm.loading = true;
            var promise = quickSaleService.getSaleReport(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    document.getElementById('salesReport').innerHTML = '';
                    if (winR) {
                        winR.close();
                    }
                    winR = window.open("", "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=" + (screen.width) + ",height=" + (screen.height) + ",top=0,left=0");
                    winR.document.body.innerHTML = '<iframe src="' + payload.title.data + '" height=' + screen.height + ' width=' + screen.width + '></ifrmae>';
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            )
        }

        //================function for applying coupon===============

        function applyCoupon(data) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.coupon_number = vm.dataToFill.couponCode;
            dataSend.flag = 2;
            dataSend.contract_id = Number(vm.dataToFill.contractIdSelected);
            vm.loading = true;
            var promise = quickSaleService.applyCoupon(dataSend);
            promise.then(
                function (payload) {
                    vm.loading = false;
                    console.log(payload);

                    if (payload.title.message == 'El cupón que aplicó no es válido.') {
                        vm.dataToFill.couponValidation = true;
                        return;
                    }
                    if (payload.title && payload.title.data && payload.title.data.status === 400) {
                        errorMessageFactory.showErrorMessage(payload.title.data.message, 0);
                        return;
                    }
                    if (payload.title && payload.title && payload.title.status === 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return;
                    }
                    vm.dataToFill.couponApplied = true;
                    if (payload && payload.title.data)
                        vm.couponType = payload.title.data.type;
                    if (payload && payload.title.data)
                        vm.disableModifySpecialFareStatus = true;
                    // languageBasedErrorFactory.getProperErrorMessage('couponApplySucc', 0, 0);
                    if (!(payload.title.data.type == 0 && vm.dataToFill.roundTrip == true))
                        languageBasedErrorFactory.getProperErrorMessage('couponApplySucc', 0, 0);
                    if (payload.title.data.type == 0 && vm.dataToFill.roundTrip == true) {
                        errorMessageFactory.showErrorMessage('Flat type discount cannot be applied on round trip.', 0);
                        return false;
                    }
                    ///////////////////////////TV-1795 //////////////////////////
                    // if ((Number(vm.dataToFill.Return_policy.estimatedFare)) < (Number(vm.viaControlled2))) {
                    //     errorMessageFactory.showErrorMessage('Cannot create booking as via controlled fare is greater than the stretch price', 0);
                    // } else {}
                    // if (vm.dataToFill.controllerWayTarifa == 1) {
                    //     vm.estimatedFareDiscount = (Number(vm.dataToFill.estimatedFare)) - (Number(vm.via_controlled_price_to_send));
                    //     vm.estimatedFareDiscountRound = (Number(vm.dataToFill.ReturnestimatedFare)) - (Number(vm.viaControlled2));
                    // } else {
                    //     vm.estimatedFareDiscount = (Number(vm.dataToFill.estimatedFare)) + (Number(vm.via_controlled_price_to_send));
                    //     vm.estimatedFareDiscountRound = (Number(vm.dataToFill.ReturnestimatedFare)) + (Number(vm.viaControlled2));
                    // }
                    // var returnValueSend = 0;
                    // var roundFinalAmountSend = 0;
                    // var roundTripFareSend = 0;
                    // if (vm.dataToFill.roundTrip == true) {
                    //     returnValueSend = payload.title.data.type ? Math.round(vm.estimatedFareDiscountRound * (payload.title.data.discount) / 100) : payload.title.data.discount;
                    //     roundFinalAmountSend = payload.title.data.type ? Math.round(vm.estimatedFareDiscountRound) - (vm.estimatedFareDiscountRound * Number(payload.title.data.discount) / 100) : Math.round(vm.estimatedFareDiscountRound - payload.title.data.discount);
                    //     roundTripFareSend = Number(vm.dataToFill.Return_policy.estimatedFare) + Number(vm.viaControlled2)
                    // }

                    vm.dataToFill.appliedCouponData.insert(0, {
                        // 'estimatedCost': Math.round(Number(vm.dataToFill.estimatedFare) + Number(vm.via_controlled_price_to_send)),
                        'estimatedCost': viaControlledPrice(vm.dataToFill.estimatedFare, vm.via_controlled_price_to_send, vm.type_of_trip1),
                        'type': payload.title.data.type,
                        'coupon_name': payload.title.data.coupon_number,
                        'value': payload.title.data.discount,
                        // 'discountCost': Math.round((payload.title.data.discount * (vm.estimatedFareDiscount)) / 100),
                        'discountCost': payload.title.data.type ? calculateDiscountPercentageAmount(vm.dataToFill.estimatedFare, vm.via_controlled_price_to_send, vm.type_of_trip1, payload.title.data.discount, 'parent') : calculateDiscountFlatAmount(vm.dataToFill.estimatedFare, vm.via_controlled_price_to_send, vm.type_of_trip1, payload.title.data.discount),
                        // 'ReturndiscountCost': returnValueSend,
                        'ReturndiscountCost': vm.dataToFill.roundTrip == true ? (payload.title.data.type ? calculateDiscountPercentageAmount(vm.dataToFill.ReturnestimatedFare, vm.viaControlled2, vm.SendTrip, payload.title.data.discount) : calculateDiscountFlatAmount(vm.dataToFill.ReturnestimatedFare, vm.viaControlled2, vm.SendTrip, payload.title.data.discount)) : 0,
                        // 'finalAmount': Math.round(vm.estimatedFareDiscount) - Math.round((payload.title.data.discount * (vm.estimatedFareDiscount)) / 100),
                        'finalAmount': payload.title.data.type ? calculateDiscountPercentage(vm.dataToFill.estimatedFare, vm.via_controlled_price_to_send, vm.type_of_trip1, payload.title.data.discount, 'parent') : calculateDiscountFlat(vm.dataToFill.estimatedFare, vm.via_controlled_price_to_send, vm.type_of_trip1, payload.title.data.discount),
                        // 'returnFinalAmount': roundFinalAmountSend,
                        'returnFinalAmount': vm.dataToFill.roundTrip == true ? (payload.title.data.type ? calculateDiscountPercentage(vm.dataToFill.ReturnestimatedFare, vm.viaControlled2, vm.SendTrip, payload.title.data.discount) : calculateDiscountFlat(vm.dataToFill.ReturnestimatedFare, vm.viaControlled2, vm.SendTrip, payload.title.data.discount)) : 0,
                        // 'roundTripFare': roundTripFareSend,
                        'roundTripFare': vm.dataToFill.roundTrip == true ? viaControlledPrice(vm.dataToFill.ReturnestimatedFare, vm.viaControlled2, vm.SendTrip) : 0,
                    })
                    vm.dataToFill.appliedCouponData.forEach(function (data) {
                        data.finalAmount = data.finalAmount < 0 ? 0 : data.finalAmount;
                    })
                    vm.dataToFill.sortData = vm.dataToFill.appliedCouponData.sort(function (a, b) {
                        return b.discountCost - a.discountCost;
                    })
                    console.log('sort data', vm.dataToFill.sortData);
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }


        // =====================get Address ============================
        function getAddressApi() {
            vm.loading = true;
            var dataSend = {};
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.point_id = vm.point_id_to_send;
            var promise = quickSaleService.getAddress(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    console.log(payload, "payload");
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        vm.addressArray = payload.title.data.final_data;
                    }
                    // $mdDialog.hide();
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );

        };


        // =====================get Agrreement ============================
        function getAgreementApi() {
            vm.loading = true;
            var dataSend = {};
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.point_id = vm.point_id_to_send;
            // dataSend.contract_id = vm.contract_id_to_send;
            var promise = quickSaleService.getAgreement(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    console.log(payload, "payload");
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        vm.agreementArray = payload.title.data.finalData;
                        vm.agreementArray.push({
                            contract_name: 'OTROS CONVENIOS',
                            agreement_type: "CORPORATE"

                        });

                        vm.classFLag = vm.agreementArray.length - 1;
                        // console.log(  vm.classFLag,'  vm.classFLag');

                    }
                    // $mdDialog.hide();
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );

        };




        function calculateRtDiscount() {
            console.log('debug calculateRtDiscount');
            ///////////////////////////TV-1795 //////////////////////////
            // vm.dataToFill.appliedCouponData = [];

            // ********* VARIABLES ARE INITIALIZE TO AGAIN SET INPUT FIELD VARIABLE ********
            vm.calculatedEstimatePriceFormFunctionEstimated = -1;
            vm.finalAdjustedPriceFromAdmin = 0;
            vm.calculatedEstimatePriceForFixedPriceFormFunction = 0;
            vm.calculatedEstimatePriceForRoundTripFormFunction = 0;
            vm.click = false;

            if (vm.dataToFill.roundTrip) {

                // if ((Number(vm.dataToFill.Return_policy.estimatedFare)) < (Number(vm.viaControlled2))) {
                //     vm.dataToFill.roundTrip = false;
                //     errorMessageFactory.showErrorMessage('hello', 0);
                // } else {
                if (vm.return_flag == true) {
                    vm.dataToFill.roundTrip = true;
                    vm.couponType = 1;
                    // }
                    // if (vm.dataToFill.controllerWayTarifa == 1) {
                    //     vm.estimatedFareDiscount = (Number(vm.dataToFill.estimatedFare)) - (Number(vm.via_controlled_price_to_send));
                    //     vm.estimatedFareDiscountRound = (Number(vm.dataToFill.ReturnestimatedFare)) - (Number(vm.viaControlled2));
                    //     console.log(vm.estimatedFareDiscount, ' vm.estimatedFareDiscount');
                    //     console.log(vm.estimatedFareDiscountRound, 'vm.estimatedFareDiscountRound');
                    // } else {
                    //     vm.estimatedFareDiscount = (Number(vm.dataToFill.estimatedFare)) + (Number(vm.via_controlled_price_to_send));
                    //     vm.estimatedFareDiscountRound = (Number(vm.dataToFill.ReturnestimatedFare)) + (Number(vm.viaControlled2));
                    // }
                    if (vm.dataToFill.rt_discount > 0) {
                        vm.disableModifySpecialFareStatus = true;
                    } else {
                        vm.disableModifySpecialFareStatus = false;
                    }
                    // TYPE_OF_TRIP KEYS
                    // SendTrip for child
                    // type_of_trip1 for parent
                    vm.dataToFill.appliedCouponData = [];
                    ///////////////////////////TV-1795 //////////////////////////
                    vm.dataToFill.appliedCouponData.push({
                        // 'estimatedCost': Math.round(Number(vm.dataToFill.estimatedFare) + Number(vm.via_controlled_price_to_send)),
                        'estimatedCost': viaControlledPrice(vm.dataToFill.estimatedFare, vm.via_controlled_price_to_send, vm.type_of_trip1),
                        'type': 1,
                        'coupon_name': 'Round Trip',
                        'value': vm.dataToFill.rt_discount,
                        'discountCost': calculateDiscountPercentageAmount(vm.dataToFill.estimatedFare, vm.via_controlled_price_to_send, vm.type_of_trip1, vm.dataToFill.rt_discount, 'parent'),
                        // 'discountCost': Math.round((vm.dataToFill.rt_discount * (vm.estimatedFareDiscount)) / 100),
                        // 'ReturndiscountCost': Math.round((vm.dataToFill.rt_discount * (vm.estimatedFareDiscountRound)) / 100),
                        'ReturndiscountCost': calculateDiscountPercentageAmount(vm.dataToFill.ReturnestimatedFare, vm.viaControlled2, vm.SendTrip, vm.dataToFill.rt_discount),
                        // 'finalAmount': Math.round(vm.estimatedFareDiscount) - Math.round((vm.dataToFill.rt_discount * (vm.estimatedFareDiscount)) / 100),
                        'finalAmount': calculateDiscountPercentage(vm.dataToFill.estimatedFare, vm.via_controlled_price_to_send, vm.type_of_trip1, vm.dataToFill.rt_discount, 'parent'),
                        // 'returnFinalAmount': (vm.estimatedFareDiscountRound - Math.round((vm.dataToFill.rt_discount * (vm.estimatedFareDiscountRound))) / 100),
                        'returnFinalAmount': calculateDiscountPercentage(vm.dataToFill.ReturnestimatedFare, vm.viaControlled2, vm.SendTrip, vm.dataToFill.rt_discount),
                        // 'roundTripFare': Math.round(Number(vm.dataToFill.ReturnestimatedFare) + Number(vm.viaControlled2)),
                        'roundTripFare': viaControlledPrice(vm.dataToFill.ReturnestimatedFare, vm.viaControlled2, vm.SendTrip)
                    })
                    console.log('debug value', vm.dataToFill.appliedCouponData);
                } else {
                    vm.dataToFill.roundTrip = false;
                    errorMessageFactory.showErrorMessage('Ida y vuelta de este servicio no está disponible', 0);
                }

            } else {
                var index = _.findIndex(vm.dataToFill.appliedCouponData, {
                    coupon_name: 'Round Trip'
                });
                if (index > -1) {
                    vm.dataToFill.appliedCouponData.splice(index, 1);
                }
            }
            vm.dataToFill.appliedCouponData.forEach(function (data) {
                data.finalAmount = data.finalAmount < 0 ? 0 : data.finalAmount;
            })
            vm.dataToFill.sortData = vm.dataToFill.appliedCouponData.sort(function (a, b) {
                return b.discountCost - a.discountCost;
            })
            // $scope.$apply();
        }

        // vm.dataToFill.appliedCouponData.insert(0,{
        //     // 'estimatedCost': Math.round(Number(vm.dataToFill.estimatedFare) + Number(vm.via_controlled_price_to_send)),
        //     'estimatedCost': viaControlledPrice(vm.dataToFill.estimatedFare, vm.via_controlled_price_to_send, vm.type_of_trip1),
        //     'type': payload.title.data.type,
        //     'coupon_name': payload.title.data.coupon_number,
        //     'value': payload.title.data.discount,
        //     // 'discountCost': Math.round((payload.title.data.discount * (vm.estimatedFareDiscount)) / 100),
        //     'discountCost': payload.title.data.type ? calculateDiscountPercentageAmount(vm.dataToFill.estimatedFare, vm.via_controlled_price_to_send, vm.type_of_trip1, payload.title.data.discount) : calculateDiscountFlatAmount(vm.dataToFill.estimatedFare, vm.via_controlled_price_to_send, vm.type_of_trip1, payload.title.data.discount),
        //     // 'ReturndiscountCost': returnValueSend,
        //     'ReturndiscountCost': vm.dataToFill.roundTrip == true ? (payload.title.data.type ? calculateDiscountPercentageAmount(vm.dataToFill.ReturnestimatedFare, vm.viaControlled2, vm.SendTrip, payload.title.data.discount) : calculateDiscountFlatAmount(vm.dataToFill.ReturnestimatedFare, vm.viaControlled2, vm.SendTrip, payload.title.data.discount)) : 0,
        //     // 'finalAmount': Math.round(vm.estimatedFareDiscount) - Math.round((payload.title.data.discount * (vm.estimatedFareDiscount)) / 100),
        //     'finalAmount': payload.title.data.type ? calculateDiscountPercentage(vm.dataToFill.estimatedFare, vm.via_controlled_price_to_send, vm.type_of_trip1, payload.title.data.discount) : calculateDiscountFlat(vm.dataToFill.estimatedFare, vm.via_controlled_price_to_send, vm.type_of_trip1, payload.title.data.discount),
        //     // 'returnFinalAmount': roundFinalAmountSend,
        //     'returnFinalAmount': vm.dataToFill.roundTrip == true ? (payload.title.data.type ? calculateDiscountPercentage(vm.dataToFill.ReturnestimatedFare, vm.viaControlled2, vm.SendTrip, payload.title.data.discount) : calculateDiscountFlat(vm.dataToFill.ReturnestimatedFare, vm.viaControlled2, vm.SendTrip, payload.title.data.discount)) : 0,
        //     // 'roundTripFare': roundTripFareSend,
        //     'roundTripFare': vm.dataToFill.roundTrip == true ? viaControlledPrice(vm.dataToFill.ReturnestimatedFare, vm.viaControlled2, vm.SendTrip) : 0,
        // })

        $scope.$watch('vm.dataToFill.estimatedFare', function (newValue, oldValue) {
            if (vm.dataToFill.appliedCouponData && vm.dataToFill.appliedCouponData.length) {
                vm.dataToFill.appliedCouponData.forEach(function (data) {
                    data.estimatedCost = viaControlledPrice(newValue, vm.via_controlled_price_to_send, vm.type_of_trip1);
                    if (data.coupon_name == 'Round Trip')
                        data.discountCost = calculateDiscountPercentageAmount(newValue, vm.via_controlled_price_to_send, vm.type_of_trip1, vm.dataToFill.rt_discount, 'parent');
                    // data.discountCost = Math.round(((Number(newValue) + Number(vm.dataToFill.viaControlled)) * (vm.dataToFill.rt_discount) / 100));
                    else {
                        if (data.type == 0 || data.type == '0')
                            // data.discountCost = Number(data.value);
                            data.discountCost = calculateDiscountFlatAmount(data.value);
                        // else data.discountCost = Math.round((Number(newValue) + Number(vm.dataToFill.viaControlled)) * (data.value / 100));
                        else data.discountCost = calculateDiscountPercentageAmount(newValue, vm.via_controlled_price_to_send, vm.type_of_trip1, data.value, 'parent');
                    }
                    // data.finalAmount = Number((Number(newValue) + Number(vm.dataToFill.viaControlled))) - Number(data.discountCost);
                    data.finalAmount = vm.couponType ? calculateDiscountPercentage(newValue, vm.via_controlled_price_to_send, vm.type_of_trip1, data.value, 'parent') : calculateDiscountFlat(newValue, vm.via_controlled_price_to_send, vm.type_of_trip1, data.value);
                });
                // vm.viaControlled1
                vm.dataToFill.appliedCouponData.forEach(function (data) {
                    data.finalAmount = data.finalAmount < 0 ? 0 : data.finalAmount;
                })
                vm.dataToFill.sortData = vm.dataToFill.appliedCouponData.sort(function (a, b) {
                    return b.discountCost - a.discountCost
                })
            }
            console.log(vm.dataToFill.appliedCouponData);
        });



        $scope.$watch('vm.dataToFill.Return_policy.estimatedFare', function (newValue, oldValue) {
            console.log(vm.dataToFill.Return_policy.estimatedFare, "newValue");

            if (vm.dataToFill.appliedCouponData && vm.dataToFill.appliedCouponData.length && vm.dataToFill.roundTrip == true) {
                // if(vm.dataToFill.controllerWayTarifa == 1){
                //     newValue = newValue - vm.viaControlled2;
                // }else{
                //     newValue = newValue;
                // }
                vm.dataToFill.appliedCouponData.forEach(function (data) {
                    // data.roundTripFare = Number(newValue) + (vm.dataToFill.controllerWayTarifa ? 0 :  Number(vm.viaControlled2)) + (vm.type_of_trip == 'Z'  ? (Number(vm.viaControlled2)) : 0);
                    data.roundTripFare = viaControlledPrice(newValue, vm.viaControlled2, vm.SendTrip);
                    if (data.coupon_name == 'ROUND TRIP')
                        // data.value = Math.round((Number(newValue) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled2))) * Number(vm.dataToFill.roundTripDiscount) / 100);
                        data.ReturndiscountCost = calculateDiscountPercentageAmount(newValue, vm.viaControlled2, vm.SendTrip, vm.dataToFill.rt_discount);
                    else {
                        if (data.type == 0 || data.type == '0')
                            // data.value = Number(data.discountTypeValue);
                            data.ReturndiscountCost = calculateDiscountFlatAmount(data.value);
                        else data.ReturndiscountCost = calculateDiscountPercentageAmount(newValue, vm.viaControlled2, vm.SendTrip, data.value);
                        // else data.value = Math.round((Number(newValue) + (vm.dataToFill.controllerWayTarifa ? 0 :Number(vm.viaControlled2))) * Number(data.discountTypeValue) / 100);
                    }
                    // data.roundFinalAmount = (Number(newValue) + (vm.dataToFill.controllerWayTarifa ? 0 :   Number(vm.viaControlled2))) - Number(data.value);
                    data.returnFinalAmount = vm.couponType ? calculateDiscountPercentage(newValue, vm.viaControlled2, vm.SendTrip, data.value) : calculateDiscountFlat(newValue, vm.dataToFill.viaControlled, vm.type_of_trip1, data.value);
              
                })

                vm.dataToFill.appliedCouponData.forEach(function (data) {
                    data.roundFinalAmount = data.roundFinalAmount < 0 ? 0 : data.roundFinalAmount;
                })
                vm.dataToFill.sortData = vm.dataToFill.appliedCouponData.sort(function (a, b) {
                    return b.ReturndiscountCost - a.ReturndiscountCost
                })
            }
            console.log(vm.dataToFill.sortData, "estimatedCHange");
        });

        function toggleMap() {
            $('#mapModal').modal('toggle');
            map.setZoom(12);

        }


        // ************ TO ADD CONTROLLEDVIA FLAG IN ESTIMATE PRICE  **********
        function viaControlledPrice(estimatePrice, controlledVia, typeOfTrip) {
            // console.log('>>>>>>> IN VIACONTROLLED PRICE >>>>>>', estimatePrice, controlledVia, typeOfTrip);
            var estimatePriceRound = Math.round(estimatePrice);
            if (vm.dataToFill.controllerWayTarifa == 1) {
                if (typeOfTrip == 'Z') {
                    return estimatePriceRound;
                } else {
                    return estimatePriceRound;
                }
            } else {
                if (typeOfTrip == 'Z') {
                    return Math.round(estimatePriceRound + controlledVia);
                } else {
                    return estimatePriceRound;
                }
            }
        }

        function calculateDiscountPercentage(estimatedPrice, controlledVia, typeOfTrip, discountValue, type) {
            var estimatePriceRound = Math.round(estimatedPrice);
            if (vm.dataToFill.controllerWayTarifa == 1) {
                if (typeOfTrip == 'Z') {
                    var newEstimate = 0;
                    var itemOfChargePrice = 0;
                    if (vm.dataToFill.itemOfChargeSelected.length > 0) {
                        for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                            if( vm.dataToFill.itemOfChargeSelected[i].retorno == false && type == 'parent'){
                                itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                            } else if(vm.dataToFill.itemOfChargeSelected[i].retorno == true && type==undefined){
                                itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                            }
                        }
                        newEstimate = estimatePriceRound - itemOfChargePrice;
                    } else {
                        newEstimate = estimatePriceRound;
                    }
                    return Math.round(((newEstimate - Math.round((newEstimate * discountValue) / 100))) < 0 ? 0 : ((newEstimate - Math.round((newEstimate * discountValue) / 100)) + itemOfChargePrice));
                } else {
                    var itemOfChargePrice = 0;
                    if (vm.dataToFill.itemOfChargeSelected.length > 0) {
                        for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                            if( vm.dataToFill.itemOfChargeSelected[i].retorno == false && type == 'parent'){
                                itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                            } else if(vm.dataToFill.itemOfChargeSelected[i].retorno == true && type==undefined){
                                itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                            }
                        }
                        estimatePriceRound = estimatePriceRound - itemOfChargePrice;
                    }else{
                        for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                            itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                        }
                        estimatePriceRound = estimatePriceRound - itemOfChargePrice;
                    }
                    return Math.round((estimatePriceRound - Math.round((estimatePriceRound * discountValue) / 100)) < 0 ? 0 : ((estimatePriceRound - Math.round((estimatePriceRound * discountValue) / 100)) + itemOfChargePrice));
                }
            } else {
                if (typeOfTrip == 'Z') {
                    // var newEstimate = estimatePrice;
                    var newEstimate = 0;
                    var itemOfChargePrice = 0;
                    if (vm.dataToFill.itemOfChargeSelected.length > 0) {
                        for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                            if( vm.dataToFill.itemOfChargeSelected[i].retorno == false && type == 'parent'){
                                itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                            } else if(vm.dataToFill.itemOfChargeSelected[i].retorno == true && type==undefined){
                                itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                            }
                        }
                        newEstimate = estimatePriceRound - itemOfChargePrice;
                    } else {
                        newEstimate = estimatePriceRound;
                    }
                    return Math.round(((newEstimate - Math.round((newEstimate * discountValue) / 100))) < 0 ? 0 : ((newEstimate - Math.round((newEstimate * discountValue) / 100)) + controlledVia + itemOfChargePrice));
                } else {
                    var itemOfChargePrice = 0;
                    if (vm.dataToFill.itemOfChargeSelected.length > 0) {
                        for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                            if( vm.dataToFill.itemOfChargeSelected[i].retorno == false && type == 'parent'){
                                itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                            } else if(vm.dataToFill.itemOfChargeSelected[i].retorno == true && type==undefined){
                                itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                            }
                        }
                        estimatePriceRound = estimatePriceRound - itemOfChargePrice;
                    }
                    return Math.round((estimatePriceRound - Math.round((estimatePriceRound * discountValue) / 100)) < 0 ? 0 : ((estimatePriceRound - Math.round((estimatePriceRound * discountValue) / 100)) + itemOfChargePrice));
                }
            }
        }

        function calculateDiscountPercentageAmount(estimatedPrice, controlledVia, typeOfTrip, discountValue, type) {
            var estimatePriceRound = Math.round(estimatedPrice);
            if (vm.dataToFill.controllerWayTarifa == 1) {
                if (typeOfTrip == 'Z') {
                    var newEstimate = 0;
                    var itemOfChargePrice = 0;
                    if (type == 'parent' && vm.dataToFill.itemOfChargeSelected.length > 0) {
                        for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                            itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                        }
                        newEstimate = estimatePriceRound - itemOfChargePrice;
                    } else {
                        newEstimate = estimatePriceRound;
                    }
                    return Math.round((newEstimate * discountValue) / 100);
                } else {
                    var itemOfChargePrice = 0;
                    if (type == 'parent' && vm.dataToFill.itemOfChargeSelected.length > 0) {
                        for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                            itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                        }
                        estimatePriceRound = estimatePriceRound - itemOfChargePrice;
                    }else{
                        for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                            itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                        }
                        estimatePriceRound = estimatePriceRound - itemOfChargePrice;
                    }
                    return Math.round((estimatePriceRound * discountValue) / 100);
                }
            } else {
                if (typeOfTrip == 'Z') {
                    // var newEstimate = estimatePrice;
                    var newEstimate = 0;
                    var itemOfChargePrice = 0;
                    if (type == 'parent' && vm.dataToFill.itemOfChargeSelected.length > 0) {
                        for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                            itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                        }
                        newEstimate = estimatePriceRound - itemOfChargePrice;
                    } else {
                        newEstimate = estimatePriceRound;
                    }
                    return Math.round((newEstimate * discountValue) / 100);
                } else {
                    var itemOfChargePrice = 0;
                    if (type == 'parent' && vm.dataToFill.itemOfChargeSelected.length > 0) {
                        for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                            itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                        }
                        estimatePriceRound = estimatePriceRound - itemOfChargePrice;
                    }
                    return Math.round((estimatePriceRound * discountValue) / 100);
                }
            }
        }

        function calculateDiscountFlat(estimatedPrice, controlledVia, typeOfTrip, discountValue) {
            var estimatePriceRound = Math.round(estimatedPrice);
            if (vm.dataToFill.controllerWayTarifa == 1) {
                if (typeOfTrip == 'Z') {
                    var newEstimate = estimatePriceRound;
                    return Math.round(((newEstimate - discountValue) + controlledVia) < 0 ? 0 : ((newEstimate - discountValue)));
                } else {
                    return Math.round((estimatePriceRound - discountValue) < 0 ? 0 : (estimatePriceRound - discountValue));
                }
            } else {
                if (typeOfTrip == 'Z') {
                    var newEstimate = estimatePriceRound;
                    return Math.round(((newEstimate - discountValue) + controlledVia) < 0 ? 0 : ((newEstimate - discountValue) + controlledVia));
                } else {
                    return Math.round((estimatePriceRound - discountValue) < 0 ? 0 : (estimatePriceRound - discountValue));
                }
            }
        }

        function calculateDiscountFlatAmount(discountValue) {
            return Math.round(discountValue);
        }

        // *************** SHOW ESTIMATE PRICE IN HTML **************
        vm.calculatedEstimatePriceFormFunction = 0;
        vm.calculatedEstimatePriceFormFunctionEstimated = -1;

        function showEstimatePriceInHtml(flagToShowEstimatedPrice, roundTrip, viaControlledFLag1, viaControlledFLag) {

            if (!vm.click) {
                if (flagToShowEstimatedPrice && roundTrip == false && viaControlledFLag1 == false && viaControlledFLag == false) {
                    vm.calculatedEstimatePriceFormFunction = vm.math.round(vm.dataToFill.estimatedFare) || 0;
                    // CONDITION TO CHANGE INPUT FIELD VALUE BECAUSE THIS FUNCTION CALLS ON EVERY ACTION ON PAGE
                    if (vm.calculatedEstimatePriceFormFunctionEstimated == -1) {
                        vm.calculatedEstimatePriceFormFunctionEstimated = vm.calculatedEstimatePriceFormFunction;
                    }
                    return true;
                }

                if (flagToShowEstimatedPrice && roundTrip == false && viaControlledFLag1 == true && viaControlledFLag == false) {
                    vm.calculatedEstimatePriceFormFunction = vm.math.round((vm.dataToFill.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : vm.via_controlled_price_to_send)) || 0;
                    // CONDITION TO CHANGE INPUT FIELD VALUE BECAUSE THIS FUNCTION CALLS ON EVERY ACTION ON PAGE
                    if (vm.calculatedEstimatePriceFormFunctionEstimated == -1) {
                        vm.calculatedEstimatePriceFormFunctionEstimated = vm.calculatedEstimatePriceFormFunction;
                    }
                    return true;
                }

                if (flagToShowEstimatedPrice && roundTrip == false && viaControlledFLag1 == false && viaControlledFLag == true) {
                    vm.calculatedEstimatePriceFormFunction = vm.math.round(vm.dataToFill.estimatedFare) || 0;
                    // CONDITION TO CHANGE INPUT FIELD VALUE BECAUSE THIS FUNCTION CALLS ON EVERY ACTION ON PAGE
                    if (vm.calculatedEstimatePriceFormFunctionEstimated == -1) {
                        vm.calculatedEstimatePriceFormFunctionEstimated = vm.calculatedEstimatePriceFormFunction;
                    }
                    return true;
                }

                if (flagToShowEstimatedPrice && roundTrip == true && viaControlledFLag1 == false && viaControlledFLag == false) {
                    vm.calculatedEstimatePriceFormFunction = vm.math.round((vm.dataToFill.estimatedFare) + (vm.dataToFill.Return_policy.estimatedFare)) || 0;
                    // CONDITION TO CHANGE INPUT FIELD VALUE BECAUSE THIS FUNCTION CALLS ON EVERY ACTION ON PAGE
                    if (vm.calculatedEstimatePriceFormFunctionEstimated == -1) {
                        vm.calculatedEstimatePriceFormFunctionEstimated = vm.calculatedEstimatePriceFormFunction;
                    }
                    return true;
                }

                if (flagToShowEstimatedPrice && roundTrip == true && viaControlledFLag1 == true && viaControlledFLag == false) {
                    vm.calculatedEstimatePriceFormFunction = vm.math.round((vm.dataToFill.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : vm.via_controlled_price_to_send) + (vm.dataToFill.Return_policy.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : vm.viaControlled2)) || 0;

                    // CONDITION TO CHANGE INPUT FIELD VALUE BECAUSE THIS FUNCTION CALLS ON EVERY ACTION ON PAGE
                    if (vm.calculatedEstimatePriceFormFunctionEstimated == -1) {
                        vm.calculatedEstimatePriceFormFunctionEstimated = vm.calculatedEstimatePriceFormFunction;
                    }
                    return true;
                }

                if (flagToShowEstimatedPrice && roundTrip == true && viaControlledFLag1 == false && viaControlledFLag == true) {
                    vm.calculatedEstimatePriceFormFunction = vm.math.round((vm.dataToFill.estimatedFare) + (vm.dataToFill.Return_policy.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : vm.viaControlled2)) || 0;
                    // CONDITION TO CHANGE INPUT FIELD VALUE BECAUSE THIS FUNCTION CALLS ON EVERY ACTION ON PAGE
                    if (vm.calculatedEstimatePriceFormFunctionEstimated == -1) {
                        vm.calculatedEstimatePriceFormFunctionEstimated = vm.calculatedEstimatePriceFormFunction;
                    }
                    return true;
                }
            } else {
                return true;
            }

        }


        // *************** SHOW ESTIMATE PRICE IN HTML FOR ROUND TRIP **************
        vm.calculatedEstimatePriceForRoundTripFormFunction = 0;
        vm.roundTripPercentageAdd = true;

        function showEstimatePriceForRoundTripInHtml(flagToShowEstimatedPrice, estimateFare, isRoundTrip, viaControlledFLag) {
            //console.log('debug', flagToShowEstimatedPrice, estimateFare, isRoundTrip, viaControlledFLag);

            if (flagToShowEstimatedPrice && estimateFare && isRoundTrip == true && viaControlledFLag == false) {
                if (vm.dataToFill.roundTrip == true && vm.calculatedEstimatePriceForRoundTripFormFunction >= 0)
                    vm.calculatedEstimatePriceForRoundTripFormFunction = vm.math.round(vm.dataToFill.Return_policy.estimatedFare) || 0;

                // CONDITION TO CHANGE INPUT FIELD VALUE BECAUSE THIS FUNCTION CALLS ON EVERY ACTION ON PAGE
                if (vm.roundTripPercentageAdd) {
                    // vm.calculatedEstimatePriceFormFunctionEstimated += vm.calculatedEstimatePriceForRoundTripFormFunction;
                    vm.calculatedEstimatePriceFormFunctionEstimated = vm.calculatedEstimatePriceFormFunction;
                    vm.roundTripPercentageAdd = false;
                }
                return true;
            }
            if (flagToShowEstimatedPrice && true && isRoundTrip == true && viaControlledFLag == true) {
                if (vm.dataToFill.roundTrip == true && vm.calculatedEstimatePriceForRoundTripFormFunction >= 0)
                    vm.calculatedEstimatePriceForRoundTripFormFunction = vm.math.round(vm.dataToFill.Return_policy.estimatedFare + (vm.dataToFill.controllerWayTarifa ? 0 : vm.viaControlled2)) || 0;

                // CONDITION TO CHANGE INPUT FIELD VALUE BECAUSE THIS FUNCTION CALLS ON EVERY ACTION ON PAGE
                if (vm.roundTripPercentageAdd) {
                    // vm.calculatedEstimatePriceFormFunctionEstimated += vm.calculatedEstimatePriceForRoundTripFormFunction;
                    vm.calculatedEstimatePriceFormFunctionEstimated = vm.calculatedEstimatePriceFormFunction;
                    vm.roundTripPercentageAdd = false;
                }
                return true;
            }
            get_cuota_rt();
        }

        // *************** SHOW ESTIMATE PRICE IN HTML FOR FIXED PRICE **************
        vm.calculatedEstimatePriceForFixedPriceFormFunction = 0;

        function showEstimatePriceForFixedPriceInHtml(flagToShowEstimatedPrice, estimateFare, isRoundTrip, viaControlledFLag) {
            //console.log('debug1', flagToShowEstimatedPrice, estimateFare, isRoundTrip, viaControlledFLag);

            if (flagToShowEstimatedPrice && estimateFare && isRoundTrip == true && viaControlledFLag == false) {

                // CONDITION TO CHANGE INPUT FIELD VALUE BECAUSE THIS FUNCTION CALLS ON EVERY ACTION ON PAGE
                if (vm.dataToFill.roundTrip == true && vm.calculatedEstimatePriceForFixedPriceFormFunction == 0)
                    vm.calculatedEstimatePriceForFixedPriceFormFunction = vm.math.round(vm.dataToFill.estimatedFare) || 0;
                return true;
            }
            if (flagToShowEstimatedPrice && estimateFare && isRoundTrip == true && viaControlledFLag == true) {

                // CONDITION TO CHANGE INPUT FIELD VALUE BECAUSE THIS FUNCTION CALLS ON EVERY ACTION ON PAGE
                if (vm.dataToFill.roundTrip == true && vm.calculatedEstimatePriceForFixedPriceFormFunction == 0)
                    vm.calculatedEstimatePriceForFixedPriceFormFunction = vm.math.round(vm.dataToFill.estimatedFare + (vm.dataToFill.controllerWayTarifa ? 0 : vm.via_controlled_price_to_send)) || 0;

                return true;
            }
        }

        // ***** FUNCTION RUN WHEN USER ADJUST PRICE ********
        vm.click = false;
        vm.finalAdjustedPriceFromAdmin = 0;

        function clickFunction(status) {
            // IF ROUND TRIP IS ON
            // 1703 change 
            if (vm.dataToFill.controllerWayTarifa == 1 && vm.type_of_trip1 == 'Z') {
                console.log("i m in ", vm.fixedPriceFromSearchFixesVariable, vm.via_controlled_price_to_send);

                vm.fixedPriceFromSearchFixesVariable1 = vm.fixedPriceFromSearchFixesVariable - vm.via_controlled_price_to_send;
            } else {
                vm.fixedPriceFromSearchFixesVariable1 = vm.fixedPriceFromSearchFixesVariable;
            }
            if (vm.dataToFill.controllerWayTarifa == 1 && vm.SendTrip == 'Z') {
                vm.estimatedFareRouteForRoundTrip1 = vm.estimatedFareRouteForRoundTrip - vm.viaControlled2;
            } else {
                vm.estimatedFareRouteForRoundTrip1 = vm.estimatedFareRouteForRoundTrip;
            }
            // 1703 change 
            if (vm.dataToFill.roundTrip) {
                vm.fixedAmountForAdjustedPrice = vm.fixedPriceFromSearchFixesVariable1 + vm.estimatedFareRouteForRoundTrip1;
            } else {
                vm.fixedAmountForAdjustedPrice = vm.fixedPriceFromSearchFixesVariable1;
            }
            // vm.calculateEstimateFareWithOutControlledVia = vm.calculatedEstimatePriceFormFunction - vm.fixedAmountForAdjustedPrice;
            // 1703 CHeck change 
            // ***** IF ADJUSTED PRICE IS GREATER THAN ESTIMATED PRICE ******
            // if ((status === 'Done') && (vm.fixedAmountForAdjustedPrice > vm.calculatedEstimatePriceFormFunctionEstimated)) {
            // // if ((status === 'Done') && (vm.calculateEstimateFareWithOutControlledVia > vm.calculatedEstimatePriceFormFunctionEstimated)) {
            //     errorMessageFactory.showErrorMessage('Valor ingresado no válido. Valor a pagar no puede ser menor que cero', 0);
            //     return true;
            // }
            function numberWithCommas(x) {
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            };
            if ((status === 'Done') && ((vm.fixedAmountForAdjustedPrice) < (vm.calculatedEstimatePriceFormFunction - vm.calculatedEstimatePriceFormFunctionEstimated))) {
                // errorMessageFactory.showErrorMessage('Error, el descuento no puede ser mayor a $' + (vm.fixedAmountForAdjustedPrice) + ' queel el valor del Tramo', 0);
                errorMessageFactory.showErrorMessage('Error, el descuento no puede ser mayor a $' + numberWithCommas(vm.fixedAmountForAdjustedPrice), 0);
                return true;
            }
            // if((status === 'Done') && ((vm.fixedAmountForAdjustedPrice)  < (vm.calculatedEstimatePriceFormFunction - vm.calculatedEstimatePriceFormFunctionEstimated))){
            //     errorMessageFactory.showErrorMessage('Error, el descuento no puede ser mayor a $' + (vm.fixedAmountForAdjustedPrice) + ' queel el valor del Tramo', 0);
            //     // errorMessageFactory.showErrorMessage('Valor ingresado no válido. Valor a pagar no puede ser menor que cero', 0);
            //     return true;
            // }
            // ***** IF ADJUSTED PRICE IS LESS THAN FIXED PRICE ******
            if ((status === 'Done') && (vm.calculatedEstimatePriceFormFunction < vm.calculatedEstimatePriceFormFunctionEstimated)) {
                // errorMessageFactory.showErrorMessage('Error, el descuento no puede ser mayor a $' + vm.calculatedEstimatePriceFormFunction + ' queel el valor del Tramo', 0);
                errorMessageFactory.showErrorMessage('Error, el monto final no puede ser mayor al original $' + numberWithCommas(vm.calculatedEstimatePriceFormFunction), 0);
                return true;
            }
            vm.click = !vm.click;
            // ****** CHECK WHEN CONFIRM ADJUSTED PRICE *******
            if (status === 'Done') {
                vm.finalAdjustedPriceFromAdmin = (vm.calculatedEstimatePriceFormFunction - vm.calculatedEstimatePriceFormFunctionEstimated) || 0;
                vm.dataToFill.appliedCouponData = [];
                vm.dummyDiscountObject = {};

                if (vm.dataToFill.roundTrip == true) {
                    vm.calculatedEstimatePriceForFixedPriceFormFunction -= vm.finalAdjustedPriceFromAdmin / 2;
                    vm.calculatedEstimatePriceForRoundTripFormFunction -= vm.finalAdjustedPriceFromAdmin / 2;
                    vm.dummyDiscountObject.type = 0;
                    vm.dummyDiscountObject.value = vm.math.round(vm.finalAdjustedPriceFromAdmin);
                    vm.dummyDiscountObject.promoType = 'adjustedPrice';
                    vm.dummyDiscountObject.finalAmount = vm.math.round(vm.calculatedEstimatePriceForFixedPriceFormFunction);
                    vm.dummyDiscountObject.discountCost = vm.math.round(vm.finalAdjustedPriceFromAdmin / 2) || 0;
                    vm.dummyDiscountObject.roundTripFare = vm.math.round(vm.calculatedEstimatePriceForRoundTripFormFunction);
                    vm.dummyDiscountObject.returnFinalAmount = vm.math.round(vm.calculatedEstimatePriceForRoundTripFormFunction);
                    //vm.dummyDiscountObject.estimatedFare = vm.math.round(vm.calculatedEstimatePriceForFixedPriceFormFunction + vm.finalAdjustedPriceFromAdmin);
                    vm.dummyDiscountObject.ReturndiscountCost = vm.math.round(vm.finalAdjustedPriceFromAdmin / 2);
                    vm.dummyDiscountObject.coupon_name = 'Special Discount';

                } else {

                    vm.dummyDiscountObject.type = 0;
                    vm.dummyDiscountObject.value = vm.finalAdjustedPriceFromAdmin;
                    vm.dummyDiscountObject.promoType = 'adjustedPrice';
                    vm.dummyDiscountObject.finalAmount = vm.calculatedEstimatePriceFormFunctionEstimated;
                    vm.dummyDiscountObject.discountCost = vm.finalAdjustedPriceFromAdmin || 0;

                }
                vm.dataToFill.appliedCouponData.push(vm.dummyDiscountObject);
                vm.dataToFill.sortData = vm.dataToFill.appliedCouponData.sort(function (a, b) {
                    return b.discountCost - a.discountCost;
                })
            }
        }


        //=======================create booking api==========================
        function checkCustomerIsAllowedInContract(cust_id) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.contract_id = vm.contract_id_used;
            dataSend.employee_id = cust_id;
            vm.loading = true;

            var promise = getBookings.checkCustomerIsAllowedInContract(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;

                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return [];
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return [];
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (payload.title.data.panel_booking_access != undefined)
                            if (!payload.title.data.panel_booking_access && (vm.dataToFill.customer.is_corporate_profile == 1)) {

                                vm.dataToFill.customer = '';
                                vm.dataToFill.customerMobile = '';
                                vm.dataToFill.customerId = '';
                                vm.dataToFill.previousCustomerId = '';
                                vm.dataToFill.customerEmail = '';
                                vm.dataToFill.employeeId = '';

                                errorMessageFactory.showErrorMessage('Este cliente no está autorizado para crear reservas desde el panel', 0);
                                return;
                            }
                        console.log(vm.dataToFill.customer);

                        if (!vm.defaultCustomerFlag) {
                            // vm.dataToFill.customerMobile = vm.dataToFill.customer.phone_number;
                            // vm.dataToFill.customerId = vm.dataToFill.customer.customer_id;
                            // vm.dataToFill.previousCustomerId = vm.dataToFill.customer.customer_id;
                            // vm.dataToFill.customerEmail = vm.dataToFill.customer.email;
                            // vm.dataToFill.employeeId = vm.dataToFill.customer.customer_id;
                            // vm.dataToFill.authRequired = '';
                            // vm.dataToFill.customerProfile = vm.dataToFill.spotShow ? 0 : 1;
                            getCorporateAgreement(cust_id);
                            getCustomerFavouriteAddress();
                            vm.dataToFill.contractIdSelected = vm.contract_id_used;
                        } else {
                            getCorporateAgreement(cust_id);
                            getCustomerFavouriteAddress();
                        }

                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    vm.disableSubmitButton = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        //////// FUNCATION TO MARK HEART FARVORITE NOT ////////////////
        function MarkfavouriteAddressDrop(data) {
            if (data == false)
                vm.isActiveDrop = !vm.isActiveDrop;
            else vm.isActiveDrop = !vm.isActiveDrop;
            if (vm.isActiveDrop) {
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.address = vm.dataToFill.dropOffAddress;
                dataSend.latitude = vm.dataToFill.dropLat;
                dataSend.longitude = vm.dataToFill.dropLng;
                dataSend.communa = vm.jobDropoffComuna;
                dataSend.is_admin = 1;
                dataSend.customer_id = vm.dataToFill.customerId;
                vm.loading = true;
                var promise = getBookings.setFavouriteAddress(dataSend);
                promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        if (payload.title.status == 200) { } else {
                            vm.isActiveDrop = !vm.isActiveDrop;
                            vm.dataToFill.location_id_address = payload.title.data.location_id;
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        $scope.items.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            } else {
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.location_id = vm.location_id_address;
                dataSend.is_admin = 1;
                dataSend.customer_id = vm.dataToFill.customerId;
                vm.loading = true;
                var promise = getBookings.setUnFavouriteAddress(dataSend);
                promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        if (payload.title.status == 200) { } else {
                            vm.isActivePick = !vm.isActivePick;
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        $scope.items.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }
        }

        //////// FUNCATION TO MARK HEART FARVORITE NOT ////////////////

        //////// FUNCATION TO GET THE ADDRESS IS FAVORITE OR NOT ////////////////
        function getFavoriteAddress(type) {
            var dataSend = {}
            if (type == 'pick') {
                dataSend.address = vm.dataToFill.dropOffAddress;
            } else {
                dataSend.address = vm.dataToFill.dropOffAddress;
            }
            dataSend.customer_id = vm.dataToFill.customerId;
            vm.loading = true;
            var promise = getBookings.getFavouriteAddress(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        // if (type == 'pick') {
                        //     vm.isActivePick = payload.title.data.is_favourite;
                        // vm.dataToFill.location_id_address = payload.title.data.location_id;
                        // } else {
                        vm.isActiveDrop = payload.title.data.is_favourite;
                        vm.location_id_address = payload.title.data.location_id;
                        // }
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    $scope.items.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        //////// FUNCATION TO GET THE ADDRESS IS FAVORITE OR NOT ////////////////



        /////// FUNCATION TO Routing Api ////////////////
        function RoutingApiFuncationRoundTrip_quick(data) {
            var dataSend = {};
            var tz = moment.tz.guess();
            dataSend.access_token = $cookies.get('obj');;
            dataSend.origin_longitude = data.dropLng;
            dataSend.origin_latitude = data.dropLat;
            dataSend.destination_latitude = data.pickLat;
            dataSend.destination_longitude = data.pickLng;
            dataSend.is_admin = 1;
            var convert_date = dateTimeFormat(vm.dataToFill.returnDateShared, vm.dataToFill.returnTimeShared).toISOString();
            convert_date = moment(convert_date).valueOf();
            dataSend.destination_at = moment(convert_date).format('YYYY-MM-DDTHH:mm:ssZ');
            vm.loading = true;
            var promise = getBookings.RoutingApi(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload && payload.title.status == 200) {
                        vm.bookingEta = true;
                        vm.timeZoneRRoundReturn = (moment.tz.zone(tz).utcOffset(moment(new Date(payload.title.data.estimated_pickup_datetime).toISOString())));
                        vm.dataToFill.etaScheduleValueReturn = (payload.title.data.estimated_travel_time);
                        vm.pickRangeSendForRoutingReturn = (new Date(payload.title.data.estimated_pickup_datetime).toISOString());
                        vm.pickup_lower_range_return = (new Date(payload.title.data.pickup_lower_range).toISOString());
                        vm.dataToFill.ReturnEstimatedDistance = 0;
                        vm.dataToFill.ReturnEstimatedDistance = roundToTwo(((payload.title.data.travel_distance) / 1000));
                        vm.ReturnEstimatedDistanceToSend = payload.title.data.travel_distance;
                        vm.distanceRoutingApiReturn = (payload.title.data.travel_distance);
                        vm.pickup_top_range_return = (new Date(payload.title.data.pickup_top_range).toISOString());
                        vm.pickRangeForRoutingReturn = moment(vm.pickRangeSendForRoutingReturn).format('HH:mm');

                    } else {
                        if (index == 1) {
                            vm.dataToFill.etaSchedule = 0;
                            vm.bookingEta = false;
                            RoutingApiFuncationRoundTrip_quick(vm.dataToFill, 0);
                            index++;
                        } else {
                            vm.bookingEta = false;
                            vm.bookingError = true;
                            errorMessageFactory.showErrorMessage('Error al calcular el Retiro. Error en la llamada a la API', 0);
                        }
                    }
                    get_cuota_rt();
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        /////// FUNCATION TO Routing Api ////////////////
    }


})();

/**
 * Created by cl-macmini-51 on 6/23/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .controller('ViewPromoCodeController', ViewPromoCodeController);

    /** @ngInject */
    function ViewPromoCodeController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document, moment, $scope, RutHelper, getPromoCodes,languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.goBack = goBack;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();


        //==================get PromoCode Details=======================
        function getPromoCodeDetails() {
            vm.loading = true;
            var promise = getPromoCodes.getPromoCode(0,0,$stateParams.id);
            promise.then(
                function(payload) {
                    vm.channelArray = [];
                    vm.loading = false;
                    vm.promoCodeDetails = _.where(payload.title.result,{promo_id:Number($stateParams.id)});
                    vm.promoCodeDetails[0].channel_name.forEach(function(col){
                        vm.channelArray.push(col);
                    })
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                });
        };
        getPromoCodeDetails();


        //====================event for getting refreshed================
        $scope.$on('StateReload', function(evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.promoCodeMain.viewPromoCode');
            }
        });
        //=================go back================
        function goBack() {
            $state.go('layout.promoCodeMain.promoList');
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('transVipMain')
        .controller('ViewBinController', ViewBinController);

    /** @ngInject */
    function ViewBinController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document, moment, $scope, RutHelper, getPromoCodes,languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.goBack = goBack;
        // languageBasedErrorFactory.checkLanguageOnLoad();
        // languageBasedErrorFactory.getTranslationStrings();

        //==================get Bin Details=======================
        function getBinDetails() {
            vm.loading = true;
            var promise = getPromoCodes.getAllBins(0,0);
            promise.then(
                function(payload) {
                    vm.loading = false;
                    vm.binDetails = _.where(payload.title.result,{bin_id:Number($stateParams.id)});
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                });
        };
        getBinDetails();

      
        //====================event for getting refreshed================
        $scope.$on('StateReload', function(evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.binMain.viewBin');
            }
        });
        //=================go back================
        function goBack() {
            $state.go('layout.binMain.binList');
        };
       
    }
})();
/**
 * Created by cl-macmini-51 on 6/23/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('PromoCodeListController', PromoCodeListController);

    /** @ngInject */
    function PromoCodeListController($cookies, $state, $log, $rootScope, $timeout, $scope, filterFilter, $mdDialog,$document,getPromoCodes,languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.totalEarnings = 0;
        vm.currentPage = 0;
        vm.totalCars = 0;
        vm.dataLength = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.skipValueFilter = 0;
        vm.predicate = 'index';
        vm.reverse = false;
        vm.getPagesCount = getPagesCount;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.init = init;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.changeDate = changeDate;
        vm.deletePromoCode = deletePromoCode
        vm.getPromoCodeHit = getPromoCodeHit;
        vm.block_unblock = block_unblock;
        vm.paginationNew = paginationNew;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        //====================event for getting refreshed================
        $scope.$on('StateReload', function(evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.promoCodeMain.promoList');
            }
        });
        //====================function for dropdown pages and page count===============
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];

        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getPromoCodeHit( 0, vm.itemsPerPageGot);
        };

        function paginationNew(page){
            getPromoCodeHit((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot);
        }

        //==================get all PromoCodes=======================
        function getPromoCodeHit(skip, limit) {
            vm.loading = true;
            var promise = getPromoCodes.getPromoCode(skip, limit);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.totalEarnings = payload.title.totalCount;
                    vm.dataLength = payload.title.totalCount;

                    if (payload.title.totalCount == 0) {
                        vm.sp_pagination = false;
                        vm.tBodyFlag = false;
                        vm.tFootFlag = true;
                        vm.filterOn = true;
                        vm.skipValueFilter = 0;
                    } else {
                        vm.sp_pagination = true;
                        vm.tBodyFlag = true;
                        vm.tFootFlag = false;
                        vm.filterOn = false;
                        vm.skipValueFilter = 0;

                        var dataArray = [];
                        var promoLIst = payload.title.result;
                        promoLIst.forEach(function(column) {
                            var d = {};
                            var channelArray = [];
                            d.added_at = column.added_at;
                            d.promo_id = column.promo_id;
                            d.promo_name = column.promo_name;
                            d.promo_type = column.promo_type;
                            d.status = column.status;
                            d.updated_at = column.updated_at;
                            d.valid_from = column.valid_from;
                            d.valid_to = column.valid_to;
                            d.value = column.value;
                            d.bin_or_coupon = column.bin_or_coupon;
                            d.transvip_assumeddiscountpercentage = column.transvip_assumeddiscountpercentage
                            column.channel_name.forEach(function(col){
                                channelArray.push(col)
                            })
                            d.channels = channelArray;
                            // d.channel_name = column.channel_name;
                            d.contract_name = column.contract_name;
                            dataArray.push(d);
                        });
                        vm.promoLIst = dataArray;
                        for (var i = 0; i < vm.promoLIst.length; i++) {
                            vm.promoLIst[i].index = (skip + i);
                        }
                        if (vm.dataLength <= vm.itemsPerPageGot) {
                            vm.sp_pagination = false;
                        } else {
                            vm.sp_pagination = true;
                            //vm.pageCount(payload.title.totalCount);
                        }
                        vm.skipValue = vm.promoLIst[0].index;
                        vm.limitValue = vm.promoLIst[vm.promoLIst.length - 1].index;

                        $scope.$watch('vm.search', function(newVal, oldVal) {
                            vm.filtered = filterFilter(vm.promoLIst, newVal);
                            vm.totalItems = vm.filtered.length;
                            if (vm.filtered.length == 0) {
                                vm.watchPagination = false;
                            } else {
                                vm.watchPagination = true;
                            }
                            if (vm.filterOn == true) {
                                vm.skipValueFilter = vm.filtered.length;
                                vm.sp_pagination = false;
                            }
                        }, true);

                        //range();
                    }
                },
                function(errorPayload) {
                    vm.loading = false;
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                });
        };
       
        function init() {
            vm.getPromoCodeHit(0, vm.searchModel.limit);
        };
        init();

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            vm.filterOn = true;
            if (vm.search.length == 0) {
                vm.filterOn = false;
                vm.watchPagination = true;
                vm.sp_pagination = true;
            }
        };
        function changeDate(validTo){
           return new Date(moment(validTo).add((new Date()).getTimezoneOffset(),'minutes'))
        }

        //==================block_unblock function======================
        function block_unblock($event, id, value, name) {
            $log.log('block_unblock');
            var parentEl = angular.element($document.body);
            var msg = languageBasedErrorFactory.getProperErrorMessage('statusPromoPop',0,'3');
            //==============dialog for confirm====================
            var confirm = $mdDialog.confirm()
                .title(msg)
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton',0,'3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton',0,'3'));

            $mdDialog.show(confirm).then(function() {
                var a = '';
                var msgSys = '';
                if (value == 0) {
                    a = 1;
                    msgSys = 'Promo unblocked.';
                } else if (value == 1) {
                    a = 0;
                    msgSys = 'Promo blocked.';
                }
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.promo_id = id;
                dataSend.status = a;
                dataSend.promo_name = name;
                var promise = getPromoCodes.editPromoCode(dataSend);
                promise.then(
                    function(payload) {
                        var dataForSysLogs = {
                            access_token: $cookies.get('obj'),
                            id: id,
                            identity : 5,
                            message : msgSys
                        };
                        $rootScope.systemLogsAdmin(dataForSysLogs);
                        $state.reload('layout.promoCodeMain.promoList');
                    },
                    function(errorPayload) {
                        vm.loading = false;
                        if(errorPayload.data.status == 401){
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                        }
                        else{
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                        }
                    }
                );
            }, function() {
                $log.log('unblock');
            });
        };

         //=====================to delete Promocode====================
         function deletePromoCode(data, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('promoDeletePop',0,'3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton',0,'3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton',0,'3'));

            $mdDialog.show(confirm).then(function() {
                var dataSend = {
                    is_deleted: 1,
                    promo_id: data.promo_id,
                    access_token: $cookies.get('obj')
                };
                vm.loading = true;
                var promise = getPromoCodes.deletePromoCode(dataSend);
                promise.then(
                    function(payload) {
                        $log.log(payload);
                        vm.loading = false;
                        languageBasedErrorFactory.getProperErrorMessage('promoDeleteSucc',0,1,'layout.promoCodeMain.promoList');
                    },
                    function(errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if(errorPayload.data.status == 401){
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                        }
                        else{
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                        }
                    }
                );
            }, function() {
                $log.log('not confirmed');
            });
        };
    }
})();

/**
 * Created by cl-macmini-51 on 6/23/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .controller('EditPromoCodeController', EditPromoCodeController);

    /** @ngInject */
    function EditPromoCodeController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document, moment, $scope, RutHelper, getPromoCodes,getAgreement, languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.dateOptions = {};
        vm.datePicker_1 = {
            end: false,
            start: false,
            startPrice: false,
            endPrice: false
        };
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.altInputFormats = ['M!/d!/yyyy'];
        vm.dataToFill = {
            promo_id: $stateParams.id,
            promo_name: '',
            valid_from: new Date(), //UTC
            valid_to: new Date(), //UTC
            promo_type: '', // 0 - flat , 1 - percentage
            value: '',
            tope:null,
            flagNoTope:false,
            channel_name: [],
            contract_name: '',
            description: '',
            channelArray:[],
            type: '',
            discountToggle: false,
            discount: 100
        };
        vm.changeInputTextColor = changeInputTextColor;
        vm.editApi = editApi;
        vm.channelChanged = channelChanged;
        vm.datePickerE_1 = datePickerE_1;
        vm.goBack = goBack;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();

        //==================date picker function==================
        vm.dateOptions = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(2090, 12, 31),
            minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };

        function datePickerE_1(type) {
            if(type == '1'){
                vm.datePicker_1.start = true;
                vm.datePicker_1.end = false;
            }
            else if(type == '2'){
                vm.datePicker_1.end = true;
                vm.datePicker_1.start = false;
            }
        };

        //==================get all drivers=======================
        function getPromoCodeHit() {
            vm.loading = true;
            var promise = getPromoCodes.getPromoCode(0,0,$stateParams.id);
            promise.then(
                function(payload) {
                    vm.loading = false;
                    var where = payload.title.result;
                    vm.dataToFill = {
                        promo_id: $stateParams.id,
                        promo_name: where[0].promo_name,
                        valid_from: new Date(where[0].valid_from), //UTC
                        valid_to: new Date(moment(where[0].valid_to).add((new Date()).getTimezoneOffset(),'minutes')), //UTC
                        promo_type: where[0].promo_type.toString(), // 0 - flat , 1 - percentage
                        value: where[0].value,
                        tope: where[0].tope,
                        flagNoTope: where[0].flag_tope == 0 ? false : true,
                        contract_name: where[0].contract_id,
                        channel_name: where[0].channel_name,
                        description: where[0].description,
                        type: where[0].bin_or_coupon,
                        channelArray: where[0].channel_id,
                        discountToggle: where[0].discount_shared_with_driver,
                        discount: where[0].transvip_assumeddiscountpercentage,
                    };
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                });
        };
        getPromoCodeHit();

        //======================submit form====================
        function editApi() {
            $log.log('12344', vm.dataToFill);

            if(vm.dataToFill.valid_from > vm.dataToFill.valid_to){
                languageBasedErrorFactory.getProperErrorMessage('promoErr1',0,0);
                //errorMessageFactory.showErrorMessage('Please select appropriate dates.',0);
                return;
            }
            if(vm.dataToFill.promo_type == '1' && vm.dataToFill.value > 100){
                languageBasedErrorFactory.getProperErrorMessage('promoErr2',0,0);
                //errorMessageFactory.showErrorMessage('Please enter promo value less than 100.',0);
                return;
            }
            // console.log(vm.dataToFill.valid_from,vm.dataToFill.valid_to);
            var convertEndDate = moment(vm.dataToFill.valid_to).format('YYYY-MM-DD HH:mm:ss');
            var addOneDayToEndDate = moment(convertEndDate,'YYYY-MM-DD HH:mm:ss').subtract((new Date()).getTimezoneOffset(),'minutes');
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.promo_name = vm.dataToFill.promo_name;
            dataSend.promo_id = vm.dataToFill.promo_id;
            dataSend.valid_from = vm.dataToFill.valid_from.toISOString();
            // dataSend.valid_to = vm.dataToFill.valid_to.toISOString();
            dataSend.valid_to = new Date(addOneDayToEndDate).toISOString();
            dataSend.promo_type = Number(vm.dataToFill.promo_type);
            dataSend.value = vm.dataToFill.value;
            dataSend.description = vm.dataToFill.description;
            dataSend.contract_id = vm.dataToFill.contract_name;
            dataSend.channel_id = vm.dataToFill.channelArray;
            dataSend.bin_or_coupon = vm.dataToFill.type;
            if( vm.dataToFill.tope != "" && vm.dataToFill.tope != null ){
                dataSend.valorTope = vm.dataToFill.tope;
            }
            if( vm.dataToFill.flagNoTope )
                dataSend.flagNoTope = 1;
            else
                dataSend.flagNoTope = 0;

            if(vm.dataToFill.discountToggle) {
                dataSend.discount_shared_with_driver = 1;
            }
            else {
                dataSend.discount_shared_with_driver = 0;
            }
            dataSend.transvip_assumeddiscountpercentage = parseInt(vm.dataToFill.discount);
            
            vm.loading = true;
            var promise = getPromoCodes.editPromoCode(dataSend);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    var dataForSysLogs = {
                        access_token: $cookies.get('obj'),
                        id: vm.dataToFill.promo_id,
                        identity : 5,
                        message : 'Promo updated.'
                    };
                    $rootScope.systemLogsAdmin(dataForSysLogs);
                    languageBasedErrorFactory.getProperErrorMessage('promoEditSucc',0,2,'layout.promoCodeMain.promoList');
                    //errorMessageFactory.showErrorMessage('Promo code updated successfully.',2,'layout.promoCodeMain.promoList');
                },
                function(errorPayload) {
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };

        function changeInputTextColor() {
            if(vm.dataToFill.discountToggle) {
                document.getElementsByClassName('inputText')[0].style.color = '#2795a0';
            }
            else {
                document.getElementsByClassName('inputText')[0].style.color = '#555555';
            }
        }
           //==================on channel change=================

           function channelChanged(channel){
            channel.forEach(function (column) {
                vm.dataToFill.channelArray.push(column.channel_id);
            });
        }

          //======================get all agreements==============
          function getAllAgreement() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
           

            var promise = getAgreement.getAgreementListLessData(dataSend);
            promise.then(
                function(payload) {
                    if(payload.title.status == 400){
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    else if(payload.title.status == 401){
                        errorMessageFactory.showErrorMessage(payload.title.message,2,'home');
                    }
                    else if(payload.title.status == 201 || payload.title.status == 200) {
                        vm.agreement = [];
                        angular.forEach(payload.title.data, function (column) {
                            if (column.status == 1) {
                                vm.agreement.push({id: column.id, name: column.name});
                            }
                        });
                    }
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllAgreement();

         //======================get promo Channels  ==============
         function getPromoChannels() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
           

            var promise = getPromoCodes.getpromoChannelsList(dataSend);
            promise.then(
                function(payload) {
                   vm.channel_name = payload.title;
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getPromoChannels();

     

        //====================event for getting refreshed================
        $scope.$on('StateReload', function(evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.promoCodeMain.editPromoCode');
            }
        });
        //=================go back================
        function goBack() {
            $state.go('layout.promoCodeMain.promoList');
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('transVipMain')
        .controller('EditCouponController', EditCouponController);

    /** @ngInject */
    function EditCouponController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document, moment, $scope, RutHelper, getPromoCodes,languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.loading = false;
    }
})();
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .controller('EditBinController', EditBinController);

    /** @ngInject */
    function EditBinController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document, moment, $scope, RutHelper, getPromoCodes,languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.dataToFill = {
            bin_id : $stateParams.id,
            promotion: '',
            binNumber: '', 
            binType: '', 
        };
        vm.goBack = goBack;
        vm.binEditApi = binEditApi;

        //================get Promo List for Bin==========

        function getPromoForBin() {
            vm.loading = true;
            var promise = getPromoCodes.getPromoListForBin(0);
            promise.then(
                function(payload) {
                    vm.loading = false;
                   vm.promoForBin = payload.title.result;
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                });
        };
        getPromoForBin();


         //==================get all bin detail=======================
         function getBinDetailHit() {
            vm.loading = true;
            var promise = getPromoCodes.getAllBins(0,0);
            promise.then(
                function(payload) {
                    vm.loading = false;
                    var where = _.where(payload.title.result,{bin_id:Number($stateParams.id)});
                    vm.dataToFill = {
                        bin_id : $stateParams.id,
                        promotion: where[0].promo_name,
                        binNumber: where[0].bin_number, 
                        binType: where[0].bin_type,
                    };
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                });
        };
        getBinDetailHit();


         //======================submit form====================
         function binEditApi() {
           
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.bin_type = vm.dataToFill.binType;
            dataSend.bin_number = vm.dataToFill.binNumber;
            dataSend.promo_id = vm.dataToFill.promotion;
            dataSend.bin_id = $stateParams.id;
            
            vm.loading = true;
            var promise = getPromoCodes.editBin(dataSend);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    var dataForSysLogs = {
                        access_token: $cookies.get('obj'),
                        id: vm.dataToFill.bin_id,
                        identity : 5,
                        message : 'Promo updated.'
                    };
                    $rootScope.systemLogsAdmin(dataForSysLogs);
                    languageBasedErrorFactory.getProperErrorMessage('promoEditSucc',0,2,'layout.binMain.binList');
                    //errorMessageFactory.showErrorMessage('Promo code updated successfully.',2,'layout.promoCodeMain.promoList');
                },
                function(errorPayload) {
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
          //========function to go back========
          function goBack() {
            $state.go('layout.binMain.binList');
        };

    }
})();
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('CouponListController', CouponListController);

    /** @ngInject */
    function CouponListController($cookies, $state, $log, $rootScope, $mdDialog, $timeout, $document, getPromoCodes, $scope, filterFilter, languageBasedErrorFactory, errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.currentPage = 0;
        vm.totalCoupons = 0;
        vm.skipValueFilter = 0;
        vm.dataLength = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = false;
        vm.tFootFlag = true;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.predicate = 'index';
        vm.reverse = false;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.getPagesCount = getPagesCount;
        vm.paginationNew = paginationNew;
        vm.getCouponsHit = getCouponsHit;
        vm.exportCSV = exportCSV;


        //====================function for dropdown pages and page count===============
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];

        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getCouponsHit(0, vm.itemsPerPageGot);
        };

        function paginationNew(page) {
            getCouponsHit((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot);
        }




        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            if (data.data) {
                $state.reload('layout.couponMain.couponList');
            }
        });

        //==================get all coupons=======================
        function getCouponsHit(skip, limit) {
            vm.loading = true;
            var promise = getPromoCodes.getCouponsList(skip, limit);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.totalCoupons = payload.title.count;
                    vm.dataLength = payload.title.count;

                    if (payload.title.count == 0) {
                        vm.sp_pagination = false;
                        vm.tBodyFlag = false;
                        vm.tFootFlag = true;
                        vm.filterOn = true;
                        vm.skipValueFilter = 0;
                    } else {
                        vm.sp_pagination = true;
                        vm.tBodyFlag = true;
                        vm.tFootFlag = false;
                        vm.filterOn = false;
                        vm.skipValueFilter = 0;

                        var dataArray = [];
                        var couponList = payload.title.result;
                        couponList.forEach(function (column) {
                            var d = {};
                            d.promo_id = column.promo_id;
                            d.promo_name = column.promo_name;
                            d.coupon_count = column.is_custom_name == 1 ? (column.total_count || 0) : (column.coupon_count || 0);
                            d.uniqueID = column.uniqueID;
                            d.is_custom_name = column.is_custom_name;

                            dataArray.push(d);
                        });
                        vm.allCouponsList = dataArray;
                        for (var i = 0; i < vm.allCouponsList.length; i++) {
                            vm.allCouponsList[i].index = (skip + i);
                        }
                        if (vm.dataLength <= vm.itemsPerPageGot) {
                            vm.sp_pagination = false;
                        } else {
                            vm.sp_pagination = true;
                            //vm.pageCount(payload.title.totalCount);
                        }
                        vm.skipValue = vm.allCouponsList[0].index;
                        vm.limitValue = vm.allCouponsList[vm.allCouponsList.length - 1].index;

                        $scope.$watch('vm.search', function (newVal, oldVal) {
                            vm.filtered = filterFilter(vm.allCouponsList, newVal);
                            vm.totalItems = vm.filtered.length;
                            if (vm.filtered.length == 0) {
                                vm.watchPagination = false;
                            } else {
                                vm.watchPagination = true;
                            }
                            if (vm.filterOn == true) {
                                vm.skipValueFilter = vm.filtered.length;
                                vm.sp_pagination = false;
                            }
                        }, true);
                    }
                    //range();
                },
                function (errorPayload) {
                    vm.loading = false;
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };

        //=================================export to CSV==============================
        function exportCSV(data) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.promo_id = data.promo_id;

            vm.loading = true;
            var promise = getPromoCodes.allCoupons(dataSend);
            promise.then(
                function (payload) {
                    vm.loading = false;

                    var couponArray = [];
                    var couponExport = payload.title.result;
                    couponExport.forEach(function (column) {
                        var d = {};
                        d['Id promocion'] = column.promo_id;
                        d['Promocion'] = column.promo_name;
                        d['Código'] = column.coupon_number;
                        d['Estado'] = column.is_used == '0' ? 'VALIDO' : 'QUEMADO';
                        d['Fecha Creacion'] = moment(column.added_at).format('MM/DD/YY  HH:mm');
                        d['Fecha Fin'] = moment(column.valid_to).format('MM/DD/YY  HH:mm');
                        if (column.is_used == 1) {
                            d['Fecha Uso'] = moment(column.updated_at).format('MM/DD/YY  HH:mm');
                        } else {
                            d['Fecha Uso'] = '--';
                        }

                        couponArray.push(d);
                    });
                    vm.couponListExport = couponArray;
                    alasql('SELECT * INTO CSV("couponsGenerated.csv",{headers:true}) FROM ?', [vm.couponListExport]);

                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };


        function init() {
            vm.getCouponsHit(0, vm.searchModel.limit);
        };
        init();

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            vm.filterOn = true;
            if (vm.search.length == 0) {
                vm.filterOn = false;
                vm.watchPagination = true;
                vm.sp_pagination = true;
            }
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .controller('BinListController', BinListController);

    /** @ngInject */
    function BinListController($cookies, $state, $log, $rootScope, $timeout, $scope, filterFilter, $mdDialog,$document,getPromoCodes,languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.currentPage = 0;
        vm.totalBins = 0;
        vm.skipValueFilter = 0;
        vm.dataLength = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = false;
        vm.tFootFlag = true;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.predicate = 'index';
        vm.reverse = false;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.getPagesCount = getPagesCount;
        vm.paginationNew = paginationNew;
        vm.getAllBinHit = getAllBinHit;
        vm.deleteBin = deleteBin;
        vm.block_unblock = block_unblock

          //====================event for getting refreshed================
          $scope.$on('StateReload', function(evt, data) {
            if (data.data) {
                $state.reload('layout.binMain.binList');
            }
        });

          //====================function for dropdown pages and page count===============
          vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];

        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllBinHit( 0, vm.itemsPerPageGot);
        };

        function paginationNew(page){
            getAllBinHit((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot);
        }


        //==================get all bins=======================
        function getAllBinHit(skip, limit) {
            vm.loading = true;
            var promise = getPromoCodes.getAllBins(skip, limit);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.totalBins = payload.title.count;
                    vm.dataLength = payload.title.count;

                    if (payload.title.count == 0) {
                        vm.sp_pagination = false;
                        vm.tBodyFlag = false;
                        vm.tFootFlag = true;
                        vm.filterOn = true;
                        vm.skipValueFilter = 0;
                    } else {
                        vm.sp_pagination = true;
                        vm.tBodyFlag = true;
                        vm.tFootFlag = false;
                        vm.filterOn = false;
                        vm.skipValueFilter = 0;

                        var binArray = [];
                        var binList = payload.title.result;
                        binList.forEach(function(column) {
                            var d = {};
                            d.bin_id = column.bin_id;
                            d.bin_number = column.bin_number;
                            d.bin_type = column.bin_type;
                            d.promo_name = column.promo_name;
                            d.status = column.status;
                            d.is_deleted = column.is_deleted;

                            binArray.push(d);
                        });
                        vm.allBinList = binArray;
                        for (var i = 0; i < vm.allBinList.length; i++) {
                            vm.allBinList[i].index = (skip + i);
                        }
                        if (vm.dataLength <= vm.itemsPerPageGot) {
                            vm.sp_pagination = false;
                        } else {
                            vm.sp_pagination = true;
                            //vm.pageCount(payload.title.totalCount);
                        }
                        vm.skipValue = vm.allBinList[0].index;
                        vm.limitValue = vm.allBinList[vm.allBinList.length - 1].index;

                        $scope.$watch('vm.search', function(newVal, oldVal) {
                            vm.filtered = filterFilter(vm.allBinList, newVal);
                            vm.totalItems = vm.filtered.length;
                            if (vm.filtered.length == 0) {
                                vm.watchPagination = false;
                            } else {
                                vm.watchPagination = true;
                            }
                            if (vm.filterOn == true) {
                                vm.skipValueFilter = vm.filtered.length;
                                vm.sp_pagination = false;
                            }
                        }, true);
                    }

                },
                function(errorPayload) {
                    vm.loading = false;
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                });
        };


        function init() {
            vm.getAllBinHit(0, vm.searchModel.limit);
        };
        init();

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            vm.filterOn = true;
            if (vm.search.length == 0) {
                vm.filterOn = false;
                vm.watchPagination = true;
                vm.sp_pagination = true;
            }
        };

         //=====================to delete Bin====================
         function deleteBin(data, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('binDeletePop',0,'3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton',0,'3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton',0,'3'));

            $mdDialog.show(confirm).then(function() {
                var dataSend = {
                    is_deleted: 1,
                    bin_id: data.bin_id,
                    access_token: $cookies.get('obj')
                };
                vm.loading = true;
                var promise = getPromoCodes.binDelete(dataSend);
                promise.then(
                    function(payload) {
                        $log.log(payload);
                        vm.loading = false;
                        languageBasedErrorFactory.getProperErrorMessage('binDeleteSucc',0,1,'layout.binMain.binList');
                    },
                    function(errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if(errorPayload.data.status == 401){
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                        }
                        else{
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                        }
                    }
                );
            }, function() {
                $log.log('not confirmed');
            });
        };

         //==================block_unblock function======================
         function block_unblock($event, id, value , number) {
            var parentEl = angular.element($document.body);
            var msg = languageBasedErrorFactory.getProperErrorMessage('statusBinPop',0,'3');
            //==============dialog for confirm====================
            var confirm = $mdDialog.confirm()
                .title(msg)
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton',0,'3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton',0,'3'));

            $mdDialog.show(confirm).then(function() {
                var a = '';
                var msgSys = '';
                if (value == 0) {
                    a = 1;
                    msgSys = 'Bin unblocked.';
                } else if (value == 1) {
                    a = 0;
                    msgSys = 'Bin blocked.';
                }
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.bin_id = id;
                dataSend.status = a;
                dataSend.bin_number = number;
                var promise = getPromoCodes.editBin(dataSend);
                promise.then(
                    function(payload) {
                        $log.log('block_unblock', payload);
                        var dataForSysLogs = {
                            access_token: $cookies.get('obj'),
                            id: id,
                            identity : 25,
                            message : msgSys
                        };
                        $rootScope.systemLogsAdmin(dataForSysLogs);
                        $state.reload('layout.binMain.binList');
                    },
                    function(errorPayload) {
                        vm.loading = false;
                        if(errorPayload.data.status == 401){
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                        }
                        else{
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                        }
                    }
                );
            }, function() {
                $log.log('unblock');
            });
        };


    }
})();

/**
 * Created by cl-macmini-51 on 6/23/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .controller('AddPromoCodeController', AddPromoCodeController);

    /** @ngInject */
    function AddPromoCodeController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document, moment, $scope, RutHelper,getAgreement, getPromoCodes,languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.dateOptions = {};
        vm.datePicker_1 = {
            end: false,
            start: false,
            startPrice: false,
            endPrice: false
        };
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.altInputFormats = ['M!/d!/yyyy'];
        vm.dataToFill = {
            promo_name: '',
            valid_from: new Date(), //UTC
            valid_to: new Date(), //UTC
            promo_type: '', // 0 - flat , 1 - percentage
            value: '',
            channel: [],
            agreement: '',
            description: '',
            type: '',
            discountToggle: false,
            discount: 100
        };
        vm.changeInputTextColor = changeInputTextColor;
        vm.registerApi = registerApi;
        vm.channelChanged = channelChanged;
        vm.datePickerE_1 = datePickerE_1;
        vm.goBack = goBack;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        //==================date picker function==================
        vm.dateOptions = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(2090, 12, 31),
            minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };

        function datePickerE_1(type) {
            if(type == '1'){
                vm.datePicker_1.start = true;
                vm.datePicker_1.end = false;
            }
            else if(type == '2'){
                vm.datePicker_1.end = true;
                vm.datePicker_1.start = false;
            }
        };

        //======================submit form====================
        function registerApi() {
            $log.log('12344', vm.dataToFill);

            if(vm.dataToFill.valid_from > vm.dataToFill.valid_to){
                languageBasedErrorFactory.getProperErrorMessage('promoErr1',0,0);
                //errorMessageFactory.showErrorMessage('Please select appropriate dates.',0);
                return;
            }
            if(vm.dataToFill.promo_type == '1' && vm.dataToFill.value > 100){
                languageBasedErrorFactory.getProperErrorMessage('promoErr2',0,0);
                //errorMessageFactory.showErrorMessage('Please enter promo value less than 100.',0);
                return;
            }
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.promo_name = vm.dataToFill.promo_name;
            dataSend.valid_from = vm.dataToFill.valid_from.toISOString();
            dataSend.valid_to = vm.dataToFill.valid_to.toISOString();
            dataSend.promo_type = Number(vm.dataToFill.promo_type);
            dataSend.value = vm.dataToFill.value;
            dataSend.contract_id = vm.dataToFill.agreement;
            dataSend.channel_id = vm.channelArray;
            dataSend.description = vm.dataToFill.description;
            dataSend.bin_or_coupon = vm.dataToFill.type;
            if( vm.dataToFill.tope != "" ){
                dataSend.valorTope = vm.dataToFill.tope;
            }
            if( vm.dataToFill.flagNoTope )
                dataSend.flagNoTope = 1;
            else
                dataSend.flagNoTope = 0;
            if(vm.dataToFill.discountToggle) {
                dataSend.discount_shared_with_driver = 1;
            }
            else {
                dataSend.discount_shared_with_driver = 0;
            }
            if(vm.dataToFill.discount) {
                dataSend.transvip_assumeddiscountpercentage = parseInt(vm.dataToFill.discount);
            }
            else {
                dataSend.transvip_assumeddiscountpercentage = 100;
            }
            vm.loading = true;
            var promise = getPromoCodes.addPromoCodes(dataSend);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if(payload.title.status == 200){
                        languageBasedErrorFactory.getProperErrorMessage('promoAddSucc',0,2,'layout.promoCodeMain.promoList');
                    }else{
                        errorMessageFactory.showErrorMessage(payload.title.message,0);
                    }
                    
                    //errorMessageFactory.showErrorMessage('Promo code created successfully.',2,'layout.promoCodeMain.promoList');
                },
                function(errorPayload) {
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };

         //======================get all agreements==============
         function getAllAgreement() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
           

            var promise = getAgreement.getAgreementListLessData(dataSend);
            promise.then(
                function(payload) {
                    if(payload.title.status == 400){
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    else if(payload.title.status == 401){
                        errorMessageFactory.showErrorMessage(payload.title.message,2,'home');
                    }
                    else if(payload.title.status == 201 || payload.title.status == 200) {
                        vm.agreement = [];
                        angular.forEach(payload.title.data, function (column) {
                            if (column.status == 1) {
                                vm.agreement.push({id: column.id, name: column.name});
                            }
                        });
                    }
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllAgreement();

         //======================get promo Channels  ==============
         function getPromoChannels() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
           

            var promise = getPromoCodes.getpromoChannelsList(dataSend);
            promise.then(
                function(payload) {
                   vm.channelsList = payload.title;
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getPromoChannels();

        function changeInputTextColor() {
            if(vm.dataToFill.discountToggle) {
                document.getElementsByClassName('inputText')[0].style.color = '#2795a0';
            }
            else {
                document.getElementsByClassName('inputText')[0].style.color = '#555555';
            }
        }
        //==================on channel change=================

        function channelChanged(channel){
            vm.channelArray = [];
            channel.forEach(function (column) {
                vm.channelArray.push(column.channel_id);
            });
        }
        //====================event for getting refreshed================
        $scope.$on('StateReload', function(evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.promoCodeMain.addPromoCode');
            }
        });
        //=================go back================
        function goBack() {
            $state.go('layout.promoCodeMain.promoList');
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('AddCouponController', AddCouponController);

    /** @ngInject */
    function AddCouponController($cookies, $state, $log, $rootScope, $stateParams, $mdDialog, $timeout, $document, getPromoCodes, $scope, filterFilter, languageBasedErrorFactory, errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.dataToFill = {
            promotion: $stateParams.id ? Number($stateParams.id) : '',
            noOfCouponToGenerate: '',
            generateCouponProcess: false,
            disablePromotion: false,
            isNameOfCoupon: $stateParams.isUnique ? Number($stateParams.isUnique) : 0,
            nameOfCoupon: $stateParams.uniqueName ? $stateParams.uniqueName : '',
            isEdit: $stateParams.isEdit ? Number($stateParams.isEdit) : 0
        };
        vm.goBack = goBack;
        vm.addNewCoupon = addNewCoupon;
        vm.exportToCSVcoupon = exportToCSVcoupon;
        // vm.changePromotion = changePromotion;
        vm.onSelected = onSelected;
        vm.is_edited = false;
        if ($stateParams.id) {
            vm.dataToFill.disablePromotion = true;
        }

        //================get Promo List for Bin==========

        function getPromoForBin() {
            vm.loading = true;
            var promise = getPromoCodes.getPromoListForBin(1);
            promise.then(
                function (payload) {
                    vm.loading = false;
                    vm.promoForCoupon = payload.title.result;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };
        getPromoForBin();

        //======================submit form====================
        function addNewCoupon() {


            if (vm.dataToFill.noOfCouponToGenerate <= 0) {
                errorMessageFactory.showErrorMessage('Por favor ingrese la cantidad mayor que 0', 0);
                return;
            }
            if (vm.dataToFill.noOfCouponToGenerate > 5000) {
                errorMessageFactory.showErrorMessage('Por favor ingrese la cantidad de menos de 5000', 0);
                return;
            }

            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.promo_id = vm.dataToFill.promotion;
            dataSend.number_of_coupons = vm.dataToFill.noOfCouponToGenerate;
            dataSend.is_custom_name = JSON.parse(vm.dataToFill.isNameOfCoupon) || 0;
            if (vm.dataToFill.isNameOfCoupon == 1)
                dataSend.custom_name = (vm.dataToFill.nameOfCoupon).toUpperCase() || '';

            vm.loading = true;
            vm.dataToFill.genrateCouponProcess = true;
            if (vm.dataToFill.isEdit && vm.dataToFill.isNameOfCoupon == 1)
                var promise = getPromoCodes.editCouponPromo(dataSend);
            else
                var promise = getPromoCodes.addCouponPromo(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    vm.dataToFill.genrateCouponProcess = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return [];
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return [];
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        getPromoForBin();
                        $mdDialog.show({
                            templateUrl: 'app/components/dialogViews/generateCouponSuccess.html',
                            bindToController: true,
                            controller: DialogController,
                            locals: {
                                items: vm.dataToFill.isNameOfCoupon
                            }
                        });

                        function DialogController($scope, $mdDialog, items) {
                            $scope.items = items;
                            $scope.closeDialog = function () {
                                $mdDialog.hide();
                                $state.go('layout.couponMain.couponList');
                            };
                            $scope.decline = function () {
                                $mdDialog.hide();
                                if (vm.dataToFill.isNameOfCoupon == 0)
                                    exportToCSVcoupon(0, 10);
                            };
                        }
                    }

                    //  languageBasedErrorFactory.getProperErrorMessage('couponAddSucc',0,2,'layout.couponMain.couponList');
                    //errorMessageFactory.showErrorMessage('Promo code created successfully.',2,'layout.promoCodeMain.promoList');
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        //=================================export to CSV==============================
        function exportToCSVcoupon() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.promo_id = vm.dataToFill.promotion;

            vm.loading = true;
            var promise = getPromoCodes.allCoupons(dataSend);
            promise.then(
                function (payload) {
                    vm.dataToFill.genrateCouponProcess = false;
                    vm.loading = false;

                    var couponArray = [];
                    var couponExport = payload.title.result;
                    couponExport.forEach(function (column) {
                        var d = {};
                        d['Id promocion'] = column.promo_id;
                        d['Promocion'] = column.promo_name;
                        d['Código'] = column.coupon_number;
                        d['Estado'] = column.is_used == '0' ? 'VALIDO' : 'QUEMADO';
                        d['Fecha Creacion'] = moment(column.added_at).format('MM/DD/YY  HH:mm');
                        d['Fecha Fin'] = moment(column.valid_to).format('MM/DD/YY  HH:mm');
                        if (column.is_used == 1) {
                            d['Fecha Uso'] = moment(column.updated_at).format('MM/DD/YY  HH:mm');
                        } else {
                            d['Fecha Uso'] = '--';
                        }

                        couponArray.push(d);
                    });
                    vm.couponListExport = couponArray;
                    alasql('SELECT * INTO CSV("couponsGenerated.csv",{headers:true}) FROM ?', [vm.couponListExport]);

                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };



        //========function to go back========
        function goBack() {
            $state.go('layout.couponMain.couponList');
        };

        // ********** CHANGE PROMOTION ***********
        // function changePromotion() {
        //     // var object = _.find(vm.promoForCoupon, {
        //     //     promo_id: vm.dataToFill.promotion
        //     // });

        //     // if (object && object.is_custom_name != null) {
        //     //     vm.dataToFill.isNameOfCoupon = object.is_custom_name;
        //     //     vm.is_edited = true;
        //     // } else {
        //     //     vm.is_edited = false;
        //     // }
        // }

        function onSelected(object) {
            if (object && object.is_custom_name != null) {
                vm.dataToFill.isNameOfCoupon = object.is_custom_name;
                vm.is_edited = true;
            } else {
                vm.is_edited = false;
            }
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .controller('AddBinController', AddBinController);

    /** @ngInject */
    function AddBinController($cookies, $state, $log, $rootScope, $mdDialog, $timeout, $document, getPromoCodes, $scope, filterFilter, languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.loading = false; 
        vm.dataToFill = {
            promotion: '',
            binNumber: '', 
            binType: '', 
        };
        vm.goBack = goBack;
        vm.addNewBin = addNewBin;

        //================get Promo List for Bin==========

        function getPromoForBin() {
            vm.loading = true;
            var promise = getPromoCodes.getPromoListForBin(0);
            promise.then(
                function(payload) {
                    vm.loading = false;
                   vm.promoForBin = payload.title.result;
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                });
        };
        getPromoForBin();


          //======================submit form====================
          function addNewBin() {
           
            // if(vm.dataToFill.binNumber > 6){
            //     languageBasedErrorFactory.getProperErrorMessage('binError',0,0);
            //     return;
            // }
           
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.bin_type = vm.dataToFill.binType;
            dataSend.bin_number = vm.dataToFill.binNumber;
            dataSend.promo_id = vm.dataToFill.promotion;

            vm.loading = true;
            var promise = getPromoCodes.addBinPromo(dataSend);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                  if(payload.title.status == 200){
                    languageBasedErrorFactory.getProperErrorMessage('binAddSucc',0,2,'layout.binMain.binList');
                  }
                  else if(payload.title.status == 404)
                    languageBasedErrorFactory.getProperErrorMessage('binAddErr',0,2);
                    //errorMessageFactory.showErrorMessage('Promo code created successfully.',2,'layout.promoCodeMain.promoList');
                },
                function(errorPayload) {
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };


    //========function to go back========
        function goBack() {
            $state.go('layout.binMain.binList');
        };

    }
})();
/**
 * Created by cl-macmini-51 on 9/8/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('VehicleBalanceReportController', VehicleBalanceReportController);

    /** @ngInject */
    function VehicleBalanceReportController($cookies, $state, $q, $log, $filter, $rootScope, $mdDialog, $timeout, $document, $scope, filterFilter,
        getProduction, getGeofence, getAgreement, getServices, getVehicles, errorMessageFactory, languageBasedErrorFactory, pendingRequests, moment, getFilters) {
        var vm = this;
        if ($rootScope.socket.connected == false || $rootScope.socket.connected == 'false') {
            $rootScope.socket.connect();
        }
        $log.log('summary production');
        vm.loading = false;
        vm.currentPage = 0;
        vm.totalSummaryList = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.skipForVechicleReport = 0;
        vm.filterTextTimeout = '';
        vm.getAllSummaryProduction = getAllSummaryProduction;
        vm.getPagesCount = getPagesCount;
        vm.init = init;
        vm.getFilter = getFilter;
        vm.branchChanged = branchChanged;
        vm.applyFilter = applyFilter;
        vm.serviceChanged = serviceChanged;
        vm.resetFilter = resetFilter;
        vm.exportToCSV = exportToCSV;
        vm.refreshData = refreshData;
        vm.paginationNew = paginationNew;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.altInputFormats = ['M!/d!/yyyy'];
        vm.searchModel = {
            limit: 25,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
        vm.filterData = {
            limit: vm.itemsPerPageGot,
            offset: 0,
            since_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
            until_date: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
            branch: '',
            type_of_service: '',
            type_of_vehicle: '',
            filter_branch: 0,
            filter_service: 0,
            filter_vehicle: 0,
            search_filter: 0,
            search_value: '',
            contrato_name: '',
            UniqueCarId: ''
        };

        vm.paginationChangedForService = paginationChangedForService;
        vm.paginationChangedForBranch = paginationChangedForBranch;

        vm.serviceSearch = serviceSearch;
        vm.branchSearch = branchSearch;

        vm.globalLimit = 1000;
        vm.globalOffset = vm.globalLimit;

        vm.service = [];
        vm.branchList = [];
        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'vehicle', 'service', 'agreement', 'corporatesList', 'operation_point'];
        moment.locale('es');
        vm.serviceOffset = 0;
        vm.branchOffset = 0;
        vm.vehicleOffset = 0;
        vm.paginationForVechicleReport = paginationForVechicleReport;
        vm.changeDateIntoSpanish = changeDateIntoSpanish;


        // convert date in spanish
        function changeDateIntoSpanish(date) {
            var Date = moment(date).format('MMMM DD, YYYY');
            return Date;
        }

        // =================== FILTER OBJECT ===================
        vm.filterObject = {
            access_token: $cookies.get('obj'),
            branch_filter: 1,
            vehicle_filter: 1,
            service_filter: 1,
            agreement_filter: 0,
            corporate_filter: 0,
            service_category: 0,
            corporate_status: 0,
            agreement_status: 0,
            vehicle__status: 2,
            operation_point_filter: 0,
            service_limit: vm.globalLimit,
            service_offset: vm.serviceOffset,
            branch_limit: vm.globalLimit,
            branch_offset: vm.branchOffset,
            vehicle_limit: vm.globalLimit,
            vehicle_offset: vm.vehicleOffset,
            branch_search_filter: 0,
            vehicle_search_filter: 0,
            service_search_filter: 0,
            agreement_search_filter: 0,
            corporate_search_filter: 0,
            operation_point_search_filter: 0
        }

        setTimeout(function () {
            document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                // if (vm.branchList && (vm.branchList.length == 0)) {
                vm.searchBranchData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

            document.getElementsByClassName('ui-select-search')[1].addEventListener('blur', function ($event) {
                // if (vm.service && (vm.service.length == 0)) {
                vm.searchServiceData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

        })

        // =================== APPLY FILTER  ===================
        function applyFilter() {
            vm.skipForVechicleReport = 0;
            getAllSummaryProduction(0, vm.itemsPerPageGot, vm.filterData);
        }
        // =================== GET FILTER DATA ===================
        function getFilterDataFromBackend(data, type) { //Acc to Index ['branch_search', 'vehicle_search', 'service_search', 'agreement_search', 'corporate_search', 'operation_point_search']
            if (data) {
                vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
            } else {
                vm.filterObject = {
                    access_token: $cookies.get('obj'),
                    branch_filter: 1,
                    vehicle_filter: 1,
                    service_filter: 1,
                    agreement_filter: 0,
                    corporate_filter: 0,
                    service_category: 0,
                    corporate_status: 0,
                    agreement_status: 2,
                    vehicle__status: 1,
                    operation_point_filter: 0,
                    branch_search_filter: 0,
                    vehicle_search_filter: 0,
                    service_search_filter: 0,
                    agreement_search_filter: 0,
                    corporate_search_filter: 0,
                    operation_point_search_filter: 0
                }
            }

            vm.filterObject.service_limit = vm.globalLimit;
            vm.filterObject.service_offset = vm.serviceOffset;
            vm.filterObject.branch_limit = vm.globalLimit;
            vm.filterObject.branch_offset = vm.branchOffset;
            vm.filterObject.vehicle_limit = vm.globalLimit;
            vm.filterObject.vehicle_offset = vm.vehicleOffset;

            var promise = getFilters.getAllFilterData(vm.filterObject);
            promise.then(
                function (payload) {

                    // ********** BRANCH DATA ********
                    if (payload.title.data.branches) {
                        angular.forEach(payload.title.data.branches.data, function (column) {
                            //CHECK FOR DUPLICATE ENTRY
                            var branchIndex = _.findIndex(vm.branchList, {
                                region_id: column.region_id
                            });
                            if (branchIndex == -1)
                                vm.branchList.push(column)
                        });
                        vm.branchTotalBackendCount = payload.title.data.branches.totalCount;
                    }


                    // *********** SERVICE DATA *********
                    if (payload.title.data.services) {
                        vm.serviceTotalBackendCount = payload.title.data.services.totalCount;
                        angular.forEach(payload.title.data.services.data, function (column) {
                            //CHECK FOR DUPLICATE ENTRY
                            var serviceIndex = _.findIndex(vm.service, {
                                id: column.id
                            });
                            if (serviceIndex == -1)
                                vm.service.push({
                                    id: column.id,
                                    name: column.service_name
                                });
                        });
                    }

                    vm.loading = false;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        }
        getFilterDataFromBackend();


        // ************ PAGINATION ON SERIVCE **************
        function paginationChangedForService() {
            var index = _.findIndex(vm[vm.searchFilterArray[2]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.serviceTotalBackendCount > (vm.service.length - index)) {
                commonFunction(2);
                vm.serviceOffset += 10;
                getFilterDataFromBackend(vm.searchServiceData, 2);
            }
        }


        // ************ PAGINATION ON BRANCH **************
        function paginationChangedForBranch() {
            var index = _.findIndex(vm[vm.searchFilterArray[0]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.branchTotalBackendCount > (vm.branchList.length - index)) {
                commonFunction(0);
                vm.branchOffset += 10;
                getFilterDataFromBackend(vm.searchBranchData, 0);
            }
        }

        // *********** COMMON FUNCTION FOR FILTER PAGINATION AND SEARCHING ***********
        function commonFunction(type, mode) {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                // vm['search' + vm.searchFilterArray[i] + 'Data'] = '';
                if (mode == 'search' || i != type) {
                    vm[vm.searchFilterArrayForClearArray[i]] = [];
                    // vm[vm.searchFilterArrayForClearArray[i]].push({
                    //     id: 'all',
                    //     name: 'All'
                    // });
                    vm[vm.searchFilterArray[i] + 'Offset'] = 0;
                    vm['search' + vm.searchFilterArray[i].substring(0, 1).toUpperCase() + vm.searchFilterArray[i].substring(1) + 'Data'] = '';
                }
            }
        }




        function paginationForVechicleReport() {
            console.log(vm.skipForVechicleReport,'vm.skipForVechicleReport');
            
            if (vm.summarProListCount.length == vm.itemsPerPageGot) {
                vm.skipForVechicleReport = vm.skipForVechicleReport + vm.itemsPerPageGot;
                getAllSummaryProduction(vm.skipForVechicleReport, vm.itemsPerPageGot, vm.filterData, 'scroll');
            }
        }
        // ************ SEARCH SERVICE ***************
        function serviceSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchServiceData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(2, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 2);
                }, 2000);
            }
        }

        // ************ SEARCH BRANCH ***************
        function branchSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchBranchData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(0, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 0);
                }, 2000);
            }
        }


        //=============================== CALENDER FUNCATIONS  ====================================//
        //================== DATE PICKER WEEK FUNCATION ==================
        vm.today = function () {
            vm.dt = new Date();
            vm.dt3 = new Date();
            var weekstart = vm.dt3.getDate() - vm.dt3.getDay() + 1;
            var weekend = weekstart + 6; // end day is the first day + 6
            var monday = new Date(vm.dt3.setDate(weekstart));
            var sunday = new Date(vm.dt3.setDate(weekend));
            document.getElementById('initialInput').style.display = 'none';
            document.getElementById('finalInput').style.display = 'block';
            vm.dt2 = moment(monday).format('MMMM DD YYYY') + ' - ' + moment(sunday).format('MMMM DD YYYY');
            var day = new Date(vm.dt2.split('-')[1]).getDate();
            var month = new Date(vm.dt2.split('-')[1]).getMonth();
            var year = new Date(vm.dt2.split('-')[1]).getFullYear();
            var max = new Date(year, month, day);
            var max1 = new Date(year, month, day);
            // var getDayMax = max.getDate() - max.getDay() + 1;
            // getDayMax = getDayMax + 27;
            console.log(max);
            vm.maxDateFrom = new Date(max1);
            vm.maxDate = new Date(max.setDate(max.getDate() + 28));
            console.log(vm.maxDateFrom,'vm.maxDateFrom');
            
        };
        vm.today();
        //==================DATE PICKER WEEK FUNCATION ==================


        //================== DATE OPTIONS ==================
        vm.dateOptions = {
            customClass: getWeekClass,
            dateDisabled: disabled,
            maxDate: vm.maxDateFrom,
            showWeeks: false,
            startingDay: 1,
        };
        //================== DATE OPTIONS ==================

        var dateChangeDeferred = $q.defer();
        vm.changePromise = dateChangeDeferred.promise;

        // Disable weekend selection
        function disabled(data) {
            var date = data.date,
                mode = data.mode;
            // return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
        }

        // open calender popup
        vm.open1 = function () {
            vm.popup1.opened = true;
        };


        // SET DATE FUNCATION
        vm.setDate = function (year, month, day) {
            vm.dt = new Date(year, month, day);
        };

        vm.format = 'dd-MMMM-yyyy'; //FORMAT OF CALENDER

        vm.popup1 = {
            opened: false
        };


        //================== SET WEEEK FOR SELECTED DATE ==================
        function getWeekClass(data) {
            var date = data.date,
                mode = data.mode;
            if (mode === 'day') {
                $log.info(vm.dt2 === date);
                var inicio = moment(vm.dt).startOf('isoWeek').toDate();
                var fin = moment(inicio).add(1, 'week');
                var fin1 = moment(fin).subtract(1, 'day');
                vm.fin1 = fin1;
                vm.dt2 = moment(inicio).format('MMMM DD YYYY') + ' - ' + moment(vm.fin1).format('MMMM DD YYYY');
                if (inicio <= date && fin > date) {
                    document.getElementById('initialInput').style.display = 'none';
                    document.getElementById('finalInput').style.display = 'block';
                    var day = new Date(vm.dt2.split('-')[1]).getDate();
                    var month = new Date(vm.dt2.split('-')[1]).getMonth();
                    var year = new Date(vm.dt2.split('-')[1]).getFullYear();
                    var max = new Date(year, month, day);
                    vm.maxDate = new Date(max.setDate(max.getDate() + 28));
                    //================== DATE OPTIONS ==================
                    vm.DateOptions = {
                        customClass: getWeek,
                        dateDisabled: Disabled,
                        maxDate: vm.maxDate,
                        showWeeks: false,
                        startingDay: 1,
                    };
                    //================== DATE OPTIONS ==================
                    return 'full';
                }
            }
            return '';
        }


        //================== DATE OPTIONS ==================
        vm.DateOptions = {
            customClass: getWeek,
            dateDisabled: Disabled,
            maxDate: vm.maxDate,
            showWeeks: false,
            startingDay: 1,
        };
        //================== DATE OPTIONS ==================


        //================== SET WEEEK FOR SELECTED DATE ==================


        //==================date picker function for week until ==================

        // get current date week
        vm.currentDay = function () {
            vm.Dt1 = new Date();
            vm.Dt2 = new Date();
            var firstDay = vm.Dt2.getDate() - vm.Dt2.getDay() + 1;
            var lastDay = firstDay + 6; // end day is the first day + 6
            var Monday = new Date(vm.Dt2.setDate(firstDay));
            var Sunday = new Date(vm.Dt2.setDate(lastDay));
            document.getElementById('mainId').style.display = 'none';
            document.getElementById('mainText').style.display = 'block';
            vm.Dt3 = moment(Monday).format('MMMM DD YYYY') + ' - ' + moment(Sunday).format('MMMM DD YYYY');; // FOR NON MANDATO
        };
        vm.currentDay();
        //==================date picker function for week until ==================


        var DateChangeDeferred = $q.defer();
        vm.ChangePromise = DateChangeDeferred.promise;

        // Disable weekend selection
        function Disabled(Data) {
            var dates = Data.dates,
                Mode = Data.Mode;
            // return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
        }

        // open calender 2 as popup
        vm.open2 = function () {
            vm.popup2.opened = true;
        };

        // SET DATE FUNCATION
        vm.setDate = function (year, month, day) {
            vm.Dt1 = new Date(year, month, day);
        };

        vm.Format = 'dd-MMMM-yyyy'; //FORMAT OF CALENDER

        vm.popup2 = {
            opened: false
        };


        //================== SET WEEEK FOR SELECTED DATE ==================
        function getWeek(data) {
            var date = data.date,
                mode = data.mode;
            if (mode === 'day') {
                $log.info(vm.Dt3 === date);
                var init = moment(vm.Dt1).startOf('isoWeek').toDate();
                var first = moment(init).add(1, 'week');
                var last = moment(first).subtract(1, 'day');
                vm.last = last;
                vm.Dt3 = moment(init).format('MMMM DD YYYY') + ' - ' + moment(vm.last).format('MMMM DD YYYY');
                if (init <= date && first > date) {
                    document.getElementById('mainId').style.display = 'none';
                    document.getElementById('mainText').style.display = 'block';
                    return 'Full';
                }
            }
            return '';
        }
        //================== SET WEEEK FOR SELECTED DATE ==================
        //=============================== CALENDER FUNCATIONS  ====================================//

        //====================function for dropdown pages and page count===============
        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllSummaryProduction(0, vm.itemsPerPageGot, vm.filterData);
        };

        function paginationNew(page) {
            getAllSummaryProduction((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData);
        }

        //==================refreshData=====================
        function refreshData() {
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllSummaryProduction(vm.currentPage * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData);
        }
        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.summaryProductionMain.summaryProduction');
            }
        });

        //====================date time format====================
        function dateTimeFormat(dateGot, timeGot) {
            var dateToChange = dateGot;
            dateToChange.setHours(timeGot.getHours());
            dateToChange.setMinutes(timeGot.getMinutes());
            dateToChange.setSeconds(timeGot.getSeconds());
            return dateToChange;
        };

        //==================hours format=====================
        function changeHoursFormat(data) {
            if (data) {
                var sec_num = parseInt(data, 10); // don't forget the second param
                var hours = Math.floor(sec_num / 3600);
                var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
                var seconds = sec_num - (hours * 3600) - (minutes * 60);

                if (hours < 10) {
                    hours = "0" + hours;
                }
                if (minutes < 10) {
                    minutes = "0" + minutes;
                }
                if (seconds < 10) {
                    seconds = "0" + seconds;
                }
                return hours + ':' + minutes + ':' + seconds;
            } else {
                return '00:00:00';
            }
        }
        //==================get all Vehicle Report=======================
        function getAllSummaryProduction(skip, limit, filter, type) {
            var since_date = vm.dt2.split('-')[0];
            since_date = new Date(since_date);
            var until_date = vm.Dt3.split('-')[0];
            until_date = new Date(until_date);
            if (until_date < since_date) {
                languageBasedErrorFactory.getProperErrorMessage('appropriateFilter', 0, 0);
                return;
            }
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit;
            dataSend.skip = skip;
            if (filter.branch != "") {
                var branchArray = [];
                branchArray.push(filter.branch);
                dataSend.branch_id = branchArray;
            }
            if (filter.type_of_service != "") {
                dataSend.service_id = filter.type_of_service;
            }
            if (filter.contrato_name != '') {
                dataSend.tipo_contrato = [];
                if(filter.contrato_name == 'all'){
                    dataSend.tipo_contrato.push('Freelance');
                    dataSend.tipo_contrato.push('Leasing');
                }else {
                    dataSend.tipo_contrato.push(filter.contrato_name);
                }
                // dataSend.tipo_contrato = filter.contrato_name;
            }
            if (filter.UniqueCarId != "") {
                dataSend.registration_number = filter.UniqueCarId;
            }
            dataSend.start_week = moment(vm.dt2.split('-')[0]).format('YYYY-MM-DD');
            dataSend.end_week = moment(vm.Dt3.split('-')[1]).format('YYYY-MM-DD');
            vm.loading = true;
            var promise = getProduction.vechicleReport(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        if (type == 'scroll') {
                            for (var i = 0; i < payload.title.data.length; i++) {
                                vm.summarProList.push(payload.title.data[i]);
                            }
                        } else {
                            vm.summarProList = payload.title.data;
                        }
                        vm.summarProListCount = payload.title.data;
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        // ==========================pagination==============================


        function init() {
            vm.getAllSummaryProduction(0, vm.searchModel.limit, vm.filterData);
        };
        init();

        function getFilter() {
            vm.currentPage = 0;
            vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
            vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
            pendingRequests.cancelAll();
            if (vm.search.length == 0) {
                vm.filterData.search_filter = 0;
                vm.filterData.search_value = '';
                vm.getAllSummaryProduction(0, vm.searchModel.limit, vm.filterData);
            } else {
                vm.filterData.search_filter = 1;
                vm.filterData.search_value = vm.search;
                vm.getAllSummaryProduction(0, vm.searchModel.limit, vm.filterData);
            }
        };


        // ******** CLEAR OFFSET *******
        function clearOffset() {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                vm[vm.searchFilterArray[i] + 'Offset'] = 0;
            }
        }

        //=================filter change functions=================
        function branchChanged() {
            vm.currentPage = 0;
            clearOffset();
            if (vm.filterData.branch && vm.filterData.branch != 'all') {
                vm.filterData.filter_branch = 1;
                // getAllSummaryProduction(0, vm.itemsPerPageGot, vm.filterData);
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                getFilterDataFromBackend();
            } else {
                vm.filterData.filter_branch = 0;
                vm.filterData.branch = 'all';
                // getAllSummaryProduction(0, vm.itemsPerPageGot, vm.filterData);
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                getFilterDataFromBackend()
            }
        };

        function serviceChanged() {
            vm.currentPage = 0;
            clearOffset();
            if (vm.filterData.type_of_service && vm.filterData.type_of_service != 'all') {
                vm.filterData.filter_service = 1;
                // getAllSummaryProduction(0, vm.itemsPerPageGot, vm.filterData);
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                getFilterDataFromBackend();
            } else {
                vm.filterData.filter_service = 0;
                vm.filterData.type_of_service = 'all';
                // getAllSummaryProduction(0, vm.itemsPerPageGot, vm.filterData);
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                getFilterDataFromBackend();
            }
        };


        function resetFilter() {
            vm.currentPage = 0;
            vm.filterData = {
                limit: vm.itemsPerPageGot,
                offset: 0,
                branch: '',
                type_of_service: '',
                type_of_vehicle: '',
                filter_branch: 0,
                filter_service: 0,
                filter_vehicle: 0,
                contrato_name: '',
                UniqueCarId: ''
            };
            vm.skipForVechicleReport = 0;
            vm.today();
            vm.currentDay();
            getAllSummaryProduction(0, vm.itemsPerPageGot, vm.filterData);
        };
        //=================================export to csv==============================
        function exportToCSV() {
            var since_date = vm.dt2.split('-')[0];
            since_date = new Date(since_date);
            var until_date = vm.Dt3.split('-')[0];
            var startDay = new Date().getDate() == new Date(vm.dt2.split('-')[0]).getDate();
            var endDay = new Date().getDate() == new Date(vm.Dt3.split('-')[0]).getDate();
            until_date = new Date(until_date);
            if (until_date < since_date) {
                languageBasedErrorFactory.getProperErrorMessage('appropriateFilter', 0, 0);
                return;
            }
            var dataSend = {};
           var tipo_contrato_array = [];
            dataSend.access_token = $cookies.get('obj');
            // dataSend.limit = limit;
            // dataSend.skip = skip;
            var filter = vm.filterData;
            if (filter.branch != "") {
                var branchArray = [];
                branchArray.push(filter.branch);
                dataSend.branch_id = branchArray;
            }
            if (startDay == true || endDay == true) {
                dataSend.is_today = moment().format('YYYY-MM-DD');
            }
            if (filter.type_of_service != "") {
                // var serviceId = [];
                // serviceId.push(filter.type_of_service);
                dataSend.service_id = (filter.type_of_service);
            }
            if (filter.contrato_name != "") {
                // dataSend.tipo_contrato = filter.contrato_name;
                if(filter.contrato_name == 'all'){
                    tipo_contrato_array.push('Freelance');
                    tipo_contrato_array.push('Leasing');
                }else {
                    tipo_contrato_array.push(filter.contrato_name);
                }
            }
            dataSend.tipo_contrato = (tipo_contrato_array)
            console.log(dataSend,'DATASEND');
            // return
            if (filter.UniqueCarId != "") {
                dataSend.registration_number = filter.UniqueCarId;
            }
            dataSend.fromTime = moment(vm.dt2.split('-')[0]).format('YYYY-MM-DD');
            dataSend.untilTime = moment(vm.Dt3.split('-')[1]).format('YYYY-MM-DD');
            vm.loading = true;
            var promise = getProduction.getVehicleReport(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        errorMessageFactory.showErrorMessage('Generación del reporte en progreso. Se descargará automáticamente cuando esté listo.', 0);
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
    }
})();
/**
 * Created by cl-macmini-51 on 9/8/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('SummaryProductionVehicleController', SummaryProductionVehicleController);

    /** @ngInject */
    function SummaryProductionVehicleController($cookies, $state, $log, $filter, $rootScope, $mdDialog, $timeout, $document, $scope, filterFilter,
        getProduction, getGeofence, getAgreement, getServices, getVehicles, errorMessageFactory, languageBasedErrorFactory, pendingRequests, moment, getFilters) {
        var vm = this;
        $log.log('summary production');
        vm.loading = false;
        vm.currentPage = 0;
        vm.totalSummaryList = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.filterTextTimeout = '';
        vm.getAllSummaryProduction = getAllSummaryProduction;
        vm.getPagesCount = getPagesCount;
        vm.applyFilter = applyFilter;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.init = init;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.datePickerE_1 = datePickerE_1;
        vm.branchChanged = branchChanged;
        vm.serviceChanged = serviceChanged;
        vm.vehicleChanged = vehicleChanged;
        vm.untillDateChanged = untillDateChanged;
        vm.sinceDateChanged = sinceDateChanged;
        vm.resetFilter = resetFilter;
        vm.exportToCSV = exportToCSV;
        vm.refreshData = refreshData;
        vm.paginationNew = paginationNew;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.dateOptions = {};
        vm.datePicker_1 = {
            sinceDate: false,
            untillDate: false
        };
        vm.altInputFormats = ['M!/d!/yyyy'];
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.predicate = 'index';
        vm.reverse = false;
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
        vm.filterData = {
            limit: vm.itemsPerPageGot,
            offset: 0,
            since_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
            until_date: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
            branch: '',
            type_of_service: '',
            type_of_vehicle: '',
            filter_branch: 0,
            filter_service: 0,
            filter_vehicle: 0,
            search_filter: 0,
            search_value: ''
        };

        vm.paginationChangedForService = paginationChangedForService;
        vm.paginationChangedForVehicle = paginationChangedForVehicle;
        vm.paginationChangedForBranch = paginationChangedForBranch;

        vm.vehicleSearch = vehicleSearch;
        vm.serviceSearch = serviceSearch;
        vm.branchSearch = branchSearch;

        vm.globalLimit = 10;
        vm.globalOffset = vm.globalLimit;

        vm.service = [];
        vm.service.push({
            id: 'all',
            name: 'All'
        })

        vm.vehicle = [];
        vm.vehicle.push({
            id: 'all',
            name: 'All'
        });

        vm.branchList = [];
        vm.branchList.push({
            region_name: 'All',
            region_id: 'all'
        });

        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'vehicle', 'service', 'agreement', 'corporatesList', 'operation_point'];

        vm.serviceOffset = 0;
        vm.branchOffset = 0;
        vm.vehicleOffset = 0;

        // =================== FILTER OBJECT ===================
        vm.filterObject = {
            access_token: $cookies.get('obj'),
            branch_filter: 1,
            vehicle_filter: 1,
            service_filter: 1,
            agreement_filter: 0,
            corporate_filter: 0,
            service_category: 0,
            corporate_status: 0,
            agreement_status: 0,
            vehicle__status: 2,
            operation_point_filter: 0,
            service_limit: vm.globalLimit,
            service_offset: vm.serviceOffset,
            branch_limit: vm.globalLimit,
            branch_offset: vm.branchOffset,
            vehicle_limit: vm.globalLimit,
            vehicle_offset: vm.vehicleOffset,
            branch_search_filter: 0,
            vehicle_search_filter: 0,
            service_search_filter: 0,
            agreement_search_filter: 0,
            corporate_search_filter: 0,
            operation_point_search_filter: 0
        }

        setTimeout(function () {
            document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                // if (vm.branchList && (vm.branchList.length == 0)) {
                vm.searchBranchData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

            document.getElementsByClassName('ui-select-search')[1].addEventListener('blur', function ($event) {
                // if (vm.service && (vm.service.length == 0)) {
                vm.searchServiceData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

            document.getElementsByClassName('ui-select-search')[2].addEventListener('blur', function ($event) {
                // if (vm.vehicle && (vm.vehicle.length == 0)) {
                vm.searchVehicleData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });
        })

        // =================== GET FILTER DATA ===================
        function getFilterDataFromBackend(data, type) { //Acc to Index ['branch_search', 'vehicle_search', 'service_search', 'agreement_search', 'corporate_search', 'operation_point_search']
            if (data) {
                vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
            } else {
                vm.filterObject = {
                    access_token: $cookies.get('obj'),
                    branch_filter: 1,
                    vehicle_filter: 1,
                    service_filter: 1,
                    agreement_filter: 0,
                    corporate_filter: 0,
                    service_category: 0,
                    corporate_status: 0,
                    agreement_status: 2,
                    vehicle__status: 1,
                    operation_point_filter: 0,
                    branch_search_filter: 0,
                    vehicle_search_filter: 0,
                    service_search_filter: 0,
                    agreement_search_filter: 0,
                    corporate_search_filter: 0,
                    operation_point_search_filter: 0
                }
            }

            vm.filterObject.service_limit = vm.globalLimit;
            vm.filterObject.service_offset = vm.serviceOffset;
            vm.filterObject.branch_limit = vm.globalLimit;
            vm.filterObject.branch_offset = vm.branchOffset;
            vm.filterObject.vehicle_limit = vm.globalLimit;
            vm.filterObject.vehicle_offset = vm.vehicleOffset;

            var promise = getFilters.getAllFilterData(vm.filterObject);
            promise.then(
                function (payload) {

                    // ********** BRANCH DATA ********
                    if (payload.title.data.branches) {
                        var index = _.findIndex(vm.branchList, {
                            region_id: 'all'
                        });
                        if (index == -1)
                            vm.branchList.push({
                                region_name: 'All',
                                region_id: 'all'
                            });
                        angular.forEach(payload.title.data.branches.data, function (column) {
                            //CHECK FOR DUPLICATE ENTRY
                            var branchIndex = _.findIndex(vm.branchList, {
                                region_id: column.region_id
                            });
                            if (branchIndex == -1)
                                vm.branchList.push(column)
                        });
                        vm.branchTotalBackendCount = payload.title.data.branches.totalCount;
                    }

                    // ********** VEHICLE DATA ********
                    if (payload.title.data.vehicles) {
                        var index = _.findIndex(vm.vehicle, {
                            id: 'all'
                        });
                        if (index == -1)
                            vm.vehicle.push({
                                name: 'All',
                                id: 'all'
                            });
                        vm.vehicleTotalBackendCount = payload.title.data.vehicles.totalCount;
                        angular.forEach(payload.title.data.vehicles.data, function (column) {
                            //CHECK FOR DUPLICATE ENTRY
                            var vehicleIndex = _.findIndex(vm.vehicle, {
                                id: column.id
                            });
                            if (vehicleIndex == -1)
                                vm.vehicle.push({
                                    id: column.id,
                                    name: column.name
                                })
                        });
                    }

                    // *********** SERVICE DATA *********
                    if (payload.title.data.services) {
                        var index = _.findIndex(vm.service, {
                            id: 'all'
                        });
                        if (index == -1)
                            vm.service.push({
                                name: 'All',
                                id: 'all'
                            });
                        vm.serviceTotalBackendCount = payload.title.data.services.totalCount;
                        angular.forEach(payload.title.data.services.data, function (column) {
                            //CHECK FOR DUPLICATE ENTRY
                            var serviceIndex = _.findIndex(vm.service, {
                                id: column.id
                            });
                            if (serviceIndex == -1)
                                vm.service.push({
                                    id: column.id,
                                    name: column.service_name
                                });
                        });
                    }

                    vm.loading = false;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        }
        getFilterDataFromBackend();


        // ************ PAGINATION ON SERIVCE **************
        function paginationChangedForService() {
            var index = _.findIndex(vm[vm.searchFilterArray[2]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.serviceTotalBackendCount > (vm.service.length - index)) {
                commonFunction(2);
                vm.serviceOffset += 10;
                getFilterDataFromBackend(vm.searchServiceData, 2);
            }
        }

        // ************ PAGINATION ON VEHICLE **************
        function paginationChangedForVehicle() {
            var index = _.findIndex(vm[vm.searchFilterArray[1]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.vehicleTotalBackendCount > (vm.vehicle.length - index)) {
                commonFunction(1);
                vm.vehicleOffset = vm.vehicleOffset + 10;
                getFilterDataFromBackend(vm.searchVehicleData, 1);
            }
        }

        // ************ PAGINATION ON BRANCH **************
        function paginationChangedForBranch() {
            var index = _.findIndex(vm[vm.searchFilterArray[0]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.branchTotalBackendCount > (vm.branchList.length - index)) {
                commonFunction(0);
                vm.branchOffset += 10;
                getFilterDataFromBackend(vm.searchBranchData, 0);
            }
        }

        // *********** COMMON FUNCTION FOR FILTER PAGINATION AND SEARCHING ***********
        function commonFunction(type, mode) {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                // vm['search' + vm.searchFilterArray[i] + 'Data'] = '';
                if (mode == 'search' || i != type) {
                    vm[vm.searchFilterArrayForClearArray[i]] = [];
                    // vm[vm.searchFilterArrayForClearArray[i]].push({
                    //     id: 'all',
                    //     name: 'All'
                    // });
                    vm[vm.searchFilterArray[i] + 'Offset'] = 0;
                    vm['search' + vm.searchFilterArray[i].substring(0, 1).toUpperCase() + vm.searchFilterArray[i].substring(1) + 'Data'] = '';
                }
            }
        }

        // ************ SEARCH VEHICLE ***************
        function vehicleSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchVehicleData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(1, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 1);
                }, 2000);
            }
        }

        // ************ SEARCH SERVICE ***************
        function serviceSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchServiceData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(2, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 2);
                }, 2000);
            }
        }

        // ************ SEARCH BRANCH ***************
        function branchSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchBranchData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(0, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 0);
                }, 2000);
            }
        }

        //==================date picker function==================
        vm.dateOptions = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(2090, 12, 31),
            //minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };

        function datePickerE_1(type) {
            if (type == 1) {
                vm.datePicker_1.sinceDate = true;
                vm.datePicker_1.untillDate = false;
            } else if (type == 2) {
                vm.datePicker_1.sinceDate = false;
                vm.datePicker_1.untillDate = true;
            }
        };

        //====================function for dropdown pages and page count===============
        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllSummaryProduction(0, vm.itemsPerPageGot, vm.filterData);
        };

        function paginationNew(page) {
            getAllSummaryProduction((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData);
        }

        //==================refreshData=====================
        function refreshData() {
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllSummaryProduction(vm.currentPage * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData);
        }
        //====================event for getting refreshed================
        function applyFilter(){
            vm.getAllSummaryProduction(0, vm.searchModel.limit, vm.filterData);
        }
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.summaryProductionMain.summaryProduction');
            }
        });

        //====================date time format====================
        function dateTimeFormat(dateGot, timeGot) {
            var dateToChange = dateGot;
            dateToChange.setHours(timeGot.getHours());
            dateToChange.setMinutes(timeGot.getMinutes());
            dateToChange.setSeconds(timeGot.getSeconds());
            return dateToChange;
        };

        //==================hours format=====================
        function changeHoursFormat(data) {
            if (data) {
                var sec_num = parseInt(data, 10); // don't forget the second param
                var hours = Math.floor(sec_num / 3600);
                var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
                var seconds = sec_num - (hours * 3600) - (minutes * 60);

                if (hours < 10) {
                    hours = "0" + hours;
                }
                if (minutes < 10) {
                    minutes = "0" + minutes;
                }
                if (seconds < 10) {
                    seconds = "0" + seconds;
                }
                return hours + ':' + minutes + ':' + seconds;
            } else {
                return '00:00:00';
            }
        }
        //==================get all drivers=======================
        function getAllSummaryProduction(skip, limit, filter) {
            if (filter.until_date < filter.since_date) {
                languageBasedErrorFactory.getProperErrorMessage('appropriateFilter', 0, 0);
                return;
            }
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit;
            dataSend.offset = skip;
            dataSend.filter_branch = filter.filter_branch;
            if (filter.filter_branch == 1 && filter.branch != 'all') {
                dataSend.branch = filter.branch;
            }
            dataSend.filter_service = filter.filter_service;
            if (filter.filter_service == 1 && filter.type_of_service != 'all') {
                dataSend.type_of_service = filter.type_of_service;
            }
            dataSend.filter_vehicle = filter.filter_vehicle;
            if (filter.filter_vehicle == 1 && filter.type_of_vehicle != 'all') {
                dataSend.type_of_vehicle = filter.type_of_vehicle;
            }
            dataSend.search_filter = filter.search_filter;
            if (filter.search_filter == 1) {
                dataSend.search_value = filter.search_value;
            }
            dataSend.since_date = moment(filter.since_date).format('YYYY-MM-DD') + 'T00:00:000Z'; //filter.since_date.toISOString();
            dataSend.until_date = moment(filter.until_date).format('YYYY-MM-DD') + 'T23:59:59Z'; //filter.until_date.toISOString();

            vm.loading = true;
            var promise = getProduction.summaryProduction(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.totalSummaryList = payload.title.data.totalCount;
                    vm.dataLength = payload.title.data.totalCount;

                    if (payload.title.data.totalCount == 0) {
                        vm.sp_pagination = false;
                        vm.tBodyFlag = false;
                        vm.tFootFlag = true;
                        vm.filterOn = true;
                        vm.skipValueFilter = 0;
                    } else {
                        vm.sp_pagination = true;
                        vm.tBodyFlag = true;
                        vm.tFootFlag = false;
                        vm.filterOn = false;
                        vm.skipValueFilter = 0;

                        var dataArray = [];
                        var summarProList = payload.title.data.result;
                        summarProList.forEach(function (column) {
                            var d = {};
                            d.average_trip_price = column.average_trip_price;
                            d.hours_worked = changeHoursFormat(column.hours_worked);
                            d.quantity_of_trips = column.quantity_of_trips;
                            d.region_name = column.region_name;
                            d.registration_number = column.registration_number;
                            d.total_earnings = column.total_earnings;
                            d.total_earnings_airport_service = column.total_earnings_airport_service;
                            d.total_earnings_non_airport_service = column.total_earnings_non_airport_service;
                            d.total_trips = column.total_trips;
                            d.total_trips_airport_service = column.total_trips_airport_service;
                            d.total_trips_non_airport_service = column.total_trips_non_airport_service;
                            d.type_of_service = column.type_of_service;
                            d.type_of_vehicle = column.type_of_vehicle;
                            d.unique_car_id = column.unique_car_id;
                            d.working_hours = column.working_hours;
                            dataArray.push(d);
                        });
                        vm.summarProList = dataArray;

                        for (var i = 0; i < vm.summarProList.length; i++) {
                            vm.summarProList[i].index = (skip + i);
                        }
                        if (vm.dataLength <= vm.itemsPerPageGot) {
                            vm.sp_pagination = false;
                        } else {
                            vm.sp_pagination = true;
                            //vm.pageCount(payload.title.data.totalCount);
                        }
                        vm.skipValue = vm.summarProList[0].index;
                        vm.limitValue = vm.summarProList[vm.summarProList.length - 1].index;

                        //$scope.$watch('vm.search', function (newVal, oldVal) {
                        //    vm.filtered = filterFilter(vm.summarProList, newVal);
                        //    vm.totalItems = vm.filtered.length;
                        //    if (vm.filtered.length == 0) {
                        //        vm.watchPagination = false;
                        //    } else {
                        //        vm.watchPagination = true;
                        //    }
                        //    if (vm.filterOn == true) {
                        //        vm.skipValueFilter = vm.filtered.length;
                        //        vm.sp_pagination = false;
                        //    }
                        //}, true);

                        //range();
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    } else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        vm.getAllSummaryProduction((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        vm.currentPage++;
        //        vm.getAllSummaryProduction((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    vm.getAllSummaryProduction((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //};

        function init() {
            vm.getAllSummaryProduction(0, vm.searchModel.limit, vm.filterData);
        };
        init();

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            //vm.filterOn = true;
            vm.currentPage = 0;
            vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
            vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
            pendingRequests.cancelAll();
            if (vm.search.length == 0) {
                vm.filterData.search_filter = 0;
                vm.filterData.search_value = '';
                vm.getAllSummaryProduction(0, vm.searchModel.limit, vm.filterData);
                //vm.filterOn = false;
                //vm.watchPagination = true;
                //vm.sp_pagination = true;
            } else {
                vm.filterData.search_filter = 1;
                vm.filterData.search_value = vm.search;
                //if (vm.filterTextTimeout) $timeout.cancel(vm.filterTextTimeout);
                //vm.filterTextTimeout = $timeout(function(){
                vm.getAllSummaryProduction(0, vm.searchModel.limit, vm.filterData);
                //},500);
            }
        };

        //====================get branch list====================
        // function getBranch() {
        //     vm.branchList = [];
        //     vm.branchList = JSON.parse(JSON.stringify(getFilters.branchesFiltersData.data));
        //     vm.branchList.push({
        //         region_name: 'All',
        //         region_id: 'all'
        //     });
        //     $scope.$apply();

        //vm.loading = true;
        // var promise = getGeofence.branch();
        // promise.then(
        //     function (payload) {
        //         $log.log(payload);
        //         //vm.loading = false;
        //         if (payload.title.status == 400) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //         } else if (payload.title.status == 401) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //         } else if (payload.title.status == 201 || payload.title.status == 200) {
        //             var where = _.where(payload.title.data, {
        //                 parent_id: 0
        //             });
        //             //vm.branchList = _.where(where, { is_active: 1 });
        //             vm.branchList = where;

        //             vm.branchList.push({
        //                 region_name: 'All',
        //                 region_id: 'all'
        //             });
        //         }
        //     },
        //     function (errorPayload) {
        //         $log.log(errorPayload);
        // vm.loading = false;
        //         if (errorPayload.data.status == 401) {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //         } else {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //         }
        //     }
        // );
        // }
        // WHen Page refresh service take time to get data from backend
        // setTimeout(function () {
        //     getBranch();
        // }, 1000);
        //======================get all vehicles==============
        // function getAllVehicles(skip, limt, filter) {
        //     vm.vehicle = [];
        //     angular.forEach(getFilters.vehiclesFiltersData.data, function (column) {
        //         vm.vehicle.push({
        //             id: column.id,
        //             name: column.name
        //         })
        //     });
        //     vm.vehicle.push({
        //         id: 'all',
        //         name: 'All'
        //     });
        //vm.loading = false;
        // var promise = getVehicles.allVehicles(skip, limt, filter);
        // promise.then(
        //     function (payload) {
        //         $log.log('sxdsads', payload);
        //         //vm.loading = false;
        //         if (payload.title.status == 400) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //         } else if (payload.title.status == 401) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //         } else if (payload.title.status == 201 || payload.title.status == 200) {
        //             vm.vehicle = [];
        //             angular.forEach(payload.title.data.result, function (column) {
        //                 vm.vehicle.push({
        //                     id: column.id,
        //                     name: column.name
        //                 })
        //             });
        //             vm.vehicle.push({
        //                 id: 'all',
        //                 name: 'All'
        //             });
        //         }
        //     },
        //     function (errorPayload) {
        //         $log.log(errorPayload);
        //         //vm.loading = false;
        //         if (errorPayload.data.status == 401) {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //         } else {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //         }
        //     }
        // );
        // };
        // WHen Page refresh service take time to get data from backend
        // setTimeout(function () {
        //     getAllVehicles(0, 0, 2);
        // }, 1000);
        //======================get all services==============
        // function getAllServices(skip, limit) {
        //     vm.service = [];
        //     angular.forEach(getFilters.servicesFiltersData.data, function (column) {
        //         vm.service.push({
        //             id: column.id,
        //             name: column.service_name
        //         });
        //     });
        //     vm.service.push({
        //         id: 'all',
        //         name: 'All'
        //     });

        //vm.loading = false;
        // var promise = getServices.allServices(skip, limit, 2);
        // promise.then(
        //     function (payload) {
        //         $log.log('sxdsads', payload);
        //         //vm.loading = false;
        //         if (payload.title.status == 400) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //         } else if (payload.title.status == 401) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //         } else if (payload.title.status == 201 || payload.title.status == 200) {
        //             vm.service = [];
        //             angular.forEach(payload.title.data.result, function (column) {
        //                 vm.service.push({
        //                     id: column.id,
        //                     name: column.service_name
        //                 });
        //             });
        //             vm.service.push({
        //                 id: 'all',
        //                 name: 'All'
        //             })
        //         }
        //     },
        //     function (errorPayload) {
        //         $log.log(errorPayload);
        // vm.loading = false;
        //         if (errorPayload.data.status == 401) {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //         } else {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //         }
        //     }
        // );
        // };
        // WHen Page refresh service take time to get data from backend
        // setTimeout(function () {
        //     getAllServices(0, 0);
        // }, 1000);

        // ******** CLEAR OFFSET *******
        function clearOffset() {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                vm[vm.searchFilterArray[i] + 'Offset'] = 0;
            }
        }

        //=================filter change functions=================
        function branchChanged() {
            vm.currentPage = 0;
            clearOffset();
            if (vm.filterData.branch && vm.filterData.branch != 'all') {
                vm.filterData.filter_branch = 1;
                // getAllSummaryProduction(0, vm.itemsPerPageGot, vm.filterData);
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                getFilterDataFromBackend();
            } else {
                vm.filterData.filter_branch = 0;
                vm.filterData.branch = 'all';
                // getAllSummaryProduction(0, vm.itemsPerPageGot, vm.filterData);
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                getFilterDataFromBackend()
            }
        };

        function serviceChanged() {
            vm.currentPage = 0;
            clearOffset();
            if (vm.filterData.type_of_service && vm.filterData.type_of_service != 'all') {
                vm.filterData.filter_service = 1;
                // getAllSummaryProduction(0, vm.itemsPerPageGot, vm.filterData);
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                getFilterDataFromBackend();
            } else {
                vm.filterData.filter_service = 0;
                vm.filterData.type_of_service = 'all';
                // getAllSummaryProduction(0, vm.itemsPerPageGot, vm.filterData);
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                getFilterDataFromBackend();
            }
        };

        function vehicleChanged() {
            vm.currentPage = 0;
            clearOffset();
            if (vm.filterData.type_of_vehicle && vm.filterData.type_of_vehicle != 'all') {
                vm.filterData.filter_vehicle = 1;
                // getAllSummaryProduction(0, vm.itemsPerPageGot, vm.filterData);
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                getFilterDataFromBackend();
            } else {
                vm.filterData.filter_vehicle = 0;
                vm.filterData.type_of_vehicle = 'all';
                // getAllSummaryProduction(0, vm.itemsPerPageGot, vm.filterData);
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                getFilterDataFromBackend();
            }
        };

        function sinceDateChanged() {
            vm.currentPage = 0;
            // if (vm.filterData.since_date) {
            //     getAllSummaryProduction(0, vm.itemsPerPageGot, vm.filterData);
            // } else {
            //     getAllSummaryProduction(0, vm.itemsPerPageGot, vm.filterData);
            // }
        };

        function untillDateChanged() {
            vm.currentPage = 0;
            // if (vm.filterData.until_date) {
            //     getAllSummaryProduction(0, vm.itemsPerPageGot, vm.filterData);
            // } else {
            //     getAllSummaryProduction(0, vm.itemsPerPageGot, vm.filterData);
            // }
        };

        function resetFilter() {
            vm.currentPage = 0;
            vm.filterData = {
                limit: vm.itemsPerPageGot,
                offset: 0,
                since_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
                until_date: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
                branch: '',
                type_of_service: '',
                type_of_vehicle: '',
                filter_branch: 0,
                filter_service: 0,
                filter_vehicle: 0
            };
            getAllSummaryProduction(0, vm.itemsPerPageGot, vm.filterData);
        };
        //=================================export to csv==============================
        function exportToCSV() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = 0;
            dataSend.offset = 0;
            dataSend.filter_branch = 0;
            dataSend.filter_service = 0;
            dataSend.filter_vehicle = 0;
            dataSend.since_date = moment(vm.filterData.since_date).format('YYYY-MM-DD') + 'T00:00:000Z'; //vm.filterData.since_date.toISOString();
            dataSend.until_date = moment(vm.filterData.until_date).format('YYYY-MM-DD') + 'T23:59:59Z'; //vm.filterData.until_date.toISOString();
            vm.loading = true;
            var promise = getProduction.summaryProduction(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;

                    var dataArrayE = [];
                    var summaryListExport = payload.title.data.result;
                    summaryListExport.forEach(function (column) {
                        var d = {};
                        d['Branch'] = column.region_name;
                        d['Vehicle Unique No.'] = column.unique_car_id;
                        d['Type of Service'] = column.type_of_service;
                        d['Type of Vehicle'] = column.type_of_vehicle;
                        d['Hours Worked'] = changeHoursFormat(column.hours_worked);
                        d['Quantity of Trips'] = column.quantity_of_trips;
                        d['$ Total Trips Airport Service'] = column.total_trips_airport_service;
                        d['$ Total Trips Non-Airport Service'] = column.total_trips_non_airport_service;
                        d['$ Total Trips'] = column.total_trips;
                        d['$ Average Trip Price'] = column.average_trip_price;
                        d['$ Total Earning Airport Service'] = column.total_earnings_airport_service;
                        d['$ Total Earning Non-Airport Service'] = column.total_earnings_non_airport_service;
                        d['$ Total Earning'] = column.total_earnings;
                        d['Working 24 Hrs'] = column.working_hours ? '24 hrs' : 'Not 24 hrs';
                        dataArrayE.push(d);
                    });
                    vm.summaryListExport = dataArrayE;
                    alasql('SELECT * INTO CSV("summaryProduction.csv",{headers:true}) FROM ?', [vm.summaryListExport]);

                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };
    }

})();
/**
 * Created by cl-macmini-51 on 9/8/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('ItemOfChargeCsvMainController', ItemOfChargeCsvMainController);

    /** @ngInject */
    function ItemOfChargeCsvMainController($cookies, $state, $log, $filter, $rootScope, $timeout, moment, getCars, $scope, filterFilter, $mdDialog, $document, getItemOfCharge, languageBasedErrorFactory, errorMessageFactory, pendingRequests) {
        var vm = this;
        vm.getAllItemOfCharges = getAllItemOfCharges;
        vm.loading = false;
        vm.maxSize = 5;
        vm.formatDate = formatDate;
        vm.currentPage = 0;
        vm.totalDetailedList;
        // vm.itemOfChargeListGotNew = [];
        vm.datePickerE_1 = datePickerE_1;
        vm.showValue = showValue;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.dateOptions = {};
        vm.showLongName = showLongName;
        vm.dateFlag  = false;
        vm.exportCsv = exportCsv;
        vm.sp_pagination = false;
        vm.getPagesCount = getPagesCount;
        vm.resetFilter = resetFilter;
        vm.paginationNew = paginationNew;
        // vm.downloadCsv = exportCsv;
        vm.sinceDateChanged = sinceDateChanged;
        vm.untillDateChanged = untillDateChanged;
        vm.datePicker_1 = {
            sinceDate: false,
            untillDate: false
        };
        vm.flag = false;
        vm.filterData = {
            limit: vm.itemsPerPageGot,
            offset: 0,
            since_date: new Date(),
            until_date: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
            branch: '',
            type_of_service: '',
            type_of_vehicle: '',
            filter_branch: 0,
            filter_service: 0,
            filter_vehicle: 0,
            search_filter: 0,
            search_value: ''
        };
        vm.applyFilter = applyFilter;
        vm.applyFilterNew = applyFilterNew;
        vm.altInputFormats = ['M!/d!/yyyy'];
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];

        function paginationNew(page) {
            getAllItemOfCharges();
        }
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
        //====================event for getting refreshed================
        // $scope.$on('StateReload', function (evt, data) {
        //     $log.log(evt);
        //     $log.log(data);
        //     if (data.data) {
        //         $state.reload('layout.itemOfChargeMain.itemOfChargeList');
        //     }
        // });

        function init() {
            vm.getAllItemOfCharges();
        };
        init();
        if ($rootScope.socket.connected == false || $rootScope.socket.connected == 'false') {
            $rootScope.socket.connect();
        }
         //==================Export Csv ======================= 
        function exportCsv(){
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.time_from = vm.formatDate(new Date(vm.filterData.since_date));
            dataSend.time_upto = vm.formatDate(new Date(vm.filterData.until_date));
            dataSend.socket = $rootScope.socket.id;
            var promise = getItemOfCharge.exportCsv(dataSend);
            promise.then(
                function (payload) {
                   
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        }


        var myListener2 = $rootScope.$on('csvPriceAdminFile', function (evt, res) {
            var link = res.res.message.link;
            var link1 = document.createElement("a");
            link1.download = link;
            link1.href = link;
            link1.click();


        });
        //==================Export Csv ======================= 
        //==================get all Headings Of Item Of charge=======================
        function getAllItemOfCharges(skip, limit, filter) {
            vm.loading = true;
            var promise = getItemOfCharge.getHeadingOfCharge();
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    // vm.totalItemOfCharge = payload.title.data.totalCount;
                    // vm.dataLength = payload.title.data.totalCount;

                    // if (payload.title.data.totalCount == 0) {
                    //     vm.sp_pagination = false;
                    //     vm.tBodyFlag = false;
                    //     vm.tFootFlag = true;
                    // }
                    // else {
                    //     vm.sp_pagination = true;
                    //     vm.tBodyFlag = true;
                    //     vm.tFootFlag = false;
                    // }

                    var dataArray = [];
                    var itemOfChargeListGot = payload.title.data.result;
                    itemOfChargeListGot.forEach(function (column) {
                        var d = {};
                        d.id = column.id;
                        d.long_name = column.long_name;
                        // d.short_name = column.short_name;
                        // d.description = column.description;
                        // d.manually = column.manually;
                        // d.mode = column.mode;
                        // d.driver_earnings = column.driver_earnings;
                        // d.state = column.state;
                        dataArray.push(d);
                    });
                    vm.itemOfChargeListGot = dataArray;
                    // for (var i = 0; i < vm.itemOfChargeListGot.length; i++) {
                    //     vm.itemOfChargeListGot[i].index = (skip + i);
                    // }
                    // if (vm.dataLength <= vm.itemOfChargeListGot) {
                    //     vm.sp_pagination = false;
                    // }
                    // else {
                    //     vm.sp_pagination = true;
                    //     //vm.pageCount(payload.title.data.totalCount);
                    // }
                    // vm.skipValue = vm.itemOfChargeListGot[0].index;
                    // vm.limitValue = vm.itemOfChargeListGot[vm.itemOfChargeListGot.length - 1].index;

                    // $scope.$watch('vm.search', function (newVal, oldVal) {
                    //     vm.filtered = filterFilter(vm.itemOfChargeListGot, newVal);
                    //     vm.totalItems = vm.filtered.length;
                    //     if (vm.filtered.length == 0) {
                    //         vm.watchPagination = false;
                    //     }
                    //     else {
                    //         vm.watchPagination = true;
                    //     }
                    //     if (vm.filterOn == true) {
                    //         vm.skipValueFilter = vm.filtered.length;
                    //         vm.sp_pagination = false;
                    //     }
                    // }, true);

                    //range();
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };
        // ==========================get all Headings Of Item Of charge==============================



        applyFilter(0, vm.itemsPerPageGot,vm.filterData);

        function sinceDateChanged() {
            vm.currentPage = 0;
            if(vm.filterData.since_date){
                vm.dateFlag = true;
            }else{
                vm.dateFlag = false;
            }
            var hey = new Date(vm.filterData.since_date);
            vm.maxDate = new Date(hey.setDate(hey.getDate() + 30));
            vm.filterData.until_date = vm.maxDate;
            vm.dateOptions = {
                //dateDisabled: disabled,
                formatYear: 'yy',
                maxDate: vm.maxDate,
                //minDate: new Date(),
                startingDay: 1,
                showWeeks: false
            };
            
            // applyFilter(0, vm.itemsPerPageGot,vm.filterData);
        };

        function untillDateChanged() {
            vm.currentPage = 0;
            // applyFilter(0, vm.itemsPerPageGot,vm.filterData);
        };

        // function exportCsv(){
        //     alasql('SELECT * INTO CSV("ItemsOfCharge.csv",{headers:true}) FROM ?', [vm.itemOfChargeListGotNew]);
        // }
        function resetFilter() {
            vm.currentPage = 0;
            vm.filterData = {
                limit: vm.itemsPerPageGot,
                offset: 0,
                since_date: new Date(),
                until_date: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
                branch: '',
                type_of_service: '',
                type_of_vehicle: '',
                filter_branch: 0,
                filter_service: 0,
                filter_vehicle: 0
            };
            applyFilter(0, vm.itemsPerPageGot,vm.filterData);
            // getAllDetailedProduction(0, vm.itemsPerPageGot, vm.filterData);
        };

        function applyFilterNew(){
            applyFilter(0, vm.itemsPerPageGot,vm.filterData);
        }

        function applyFilter(skip , limit , filter) {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.time_from = vm.formatDate(new Date(vm.filterData.since_date));
            dataSend.time_upto = vm.formatDate(new Date(vm.filterData.until_date));
            
            dataSend.limit = limit;
            dataSend.offset = skip;
            var promise = getItemOfCharge.getItemOfChargeNew(dataSend);
            promise.then(
                function (payload) {
                    vm.flag = true;
                    vm.loading = false;
                    var dataArray = [];
                    if (payload.title.data.totalCount == 0) {
                        vm.sp_pagination = false;
                        vm.tBodyFlag = false;
                        vm.tFootFlag = true;
                        vm.filterOn = true;
                        vm.skipValueFilter = 0;
                    } else {
                        vm.sp_pagination = true;
                        vm.tBodyFlag = true;
                        vm.tFootFlag = false;
                        vm.filterOn = false;
                        vm.skipValueFilter = 0;
                        
                    if (payload.title.data.data) {
                        var dataPayload = payload.title.data.data;
                        vm.totalDetailedList = payload.title.data.total_count;
                        vm.dataLength = payload.title.data.total_count;
                        
                        vm.itemOfChargeListGotNew = [];
                        for (var i = 0; i < dataPayload.length; i++) {
                            var obj = {};
                            obj.job_id = dataPayload[i].job_id;
                            for (var j = 0; j < vm.itemOfChargeListGot.length; j++) {
                                if (dataPayload[i].item_of_charges && (dataPayload[i].item_of_charges.length > 0)) {
                                    var  index = dataPayload[i].item_of_charges.findIndex(function(value,index){
                                        return value.id == vm.itemOfChargeListGot[j].id;
                                    })
                                    if(index != -1){
                                        obj[vm.itemOfChargeListGot[j].id]={}
                                        obj[vm.itemOfChargeListGot[j].id][vm.itemOfChargeListGot[j].long_name] = dataPayload[i].item_of_charges[index].price;
                                    }
                                    else{
                                        obj[vm.itemOfChargeListGot[j].id] = {};
                                        obj[vm.itemOfChargeListGot[j].id][vm.itemOfChargeListGot[j].long_name] = '--';
                                    }
                                } else {
                                    for (var j = 0; j < vm.itemOfChargeListGot.length; j++) {
                                        obj[vm.itemOfChargeListGot[j].id] = {};
                                        obj[vm.itemOfChargeListGot[j].id][vm.itemOfChargeListGot[j].long_name] = '--';
                                    }
                                }
                            }

                            vm.itemOfChargeListGotNew.push(obj);

                        }

                        if(vm.itemOfChargeListGotNew.length>0 ){
                            vm.keys1 = Object.keys(vm.itemOfChargeListGotNew[0]);

                        }
                        // else{
                        //     for (var j = 0; j < vm.itemOfChargeListGot.length; j++) {
                        //         vm.keys1.push(vm.itemOfChargeListGot[j].long_name)
                        //     }
                        // }
                       
                        //    dataArray.push(d);
                    }
                    // vm.itemOfChargeListGotNew = dataArray;

                    
                }
                },
                function (errorPayload) {
                    vm.loading = false;
                    // if (errorPayload.data.status == 401) {
                    //     errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    // } else {
                    //     errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    // }
                });
        };


        function showLongName(data){
            var keys = Object.keys(data);
            return keys[0];
        }
        function showValue(data , key){
           return data[key][Object.keys(data[key])[0]];
        }
        //==================date picker function==================
        function formatDate(date) {

            var d = new Date(date);
            var mon = d.getMonth() >= 9 ? (d.getMonth() + 1) : ('0' + (d.getMonth() + 1));
            var day = d.getDate() >= 10 ? d.getDate() : '0' + d.getDate();
            var year = d.getFullYear();
    
    
            return [year, mon, day].join('-');
        }

        function datePickerE_1(type) {
            if (type == 1) {
                vm.datePicker_1.sinceDate = true;
                vm.datePicker_1.untillDate = false;
            } else if (type == 2) {
                vm.datePicker_1.sinceDate = false;
                vm.datePicker_1.untillDate = true;
            }
        };
        //==================date picker function==================

        function paginationNew(page){
            applyFilter((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot,vm.filterData);
        }
        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            applyFilter(0, vm.itemsPerPageGot,vm.filterData);
        };
    }



})();
/**
 * Created by cl-macmini-51 on 9/8/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('DetailedProductionVehicleController', DetailedProductionVehicleController);

    /** @ngInject */
    function DetailedProductionVehicleController($cookies, $state, $log, $filter, $rootScope, $mdDialog, $timeout, $document, $scope, filterFilter, getProduction,
        getGeofence, getAgreement, getServices, getVehicles, moment, errorMessageFactory, languageBasedErrorFactory, pendingRequests, getFilters) {
        var vm = this;
        $log.log('detailed production');
        vm.loading = false;
        vm.currentPage = 0;
        vm.applyFilter =applyFilter;
        vm.totalDetailedList = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.filterTextTimeout = '';
        vm.getAllDetailedProduction = getAllDetailedProduction;
        vm.getPagesCount = getPagesCount;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.init = init;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.datePickerE_1 = datePickerE_1;
        vm.branchChanged = branchChanged;
        vm.serviceChanged = serviceChanged;
        vm.vehicleChanged = vehicleChanged;
        vm.untillDateChanged = untillDateChanged;
        vm.sinceDateChanged = sinceDateChanged;
        vm.resetFilter = resetFilter;
        vm.exportToCSV = exportToCSV;
        vm.refreshData = refreshData;
        vm.paginationNew = paginationNew;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.dateOptions = {};
        vm.datePicker_1 = {
            sinceDate: false,
            untillDate: false
        };
        vm.altInputFormats = ['M!/d!/yyyy'];
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.predicate = 'index';
        vm.reverse = false;
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
        vm.filterData = {
            limit: vm.itemsPerPageGot,
            offset: 0,
            since_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
            until_date: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
            branch: '',
            type_of_service: '',
            type_of_vehicle: '',
            filter_branch: 0,
            filter_service: 0,
            filter_vehicle: 0,
            search_filter: 0,
            search_value: ''
        };

        vm.paginationChangedForService = paginationChangedForService;
        vm.paginationChangedForVehicle = paginationChangedForVehicle;
        vm.paginationChangedForBranch = paginationChangedForBranch;

        vm.vehicleSearch = vehicleSearch;
        vm.serviceSearch = serviceSearch;
        vm.branchSearch = branchSearch;

        vm.globalLimit = 10;
        vm.globalOffset = vm.globalLimit;

        vm.service = [];
        vm.service.push({
            id: 'all',
            name: 'All'
        })

        vm.vehicle = [];
        vm.vehicle.push({
            id: 'all',
            name: 'All'
        });

        vm.branchList = [];
        vm.branchList.push({
            region_name: 'All',
            region_id: 'all'
        });

        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'vehicle', 'service', 'agreement', 'corporatesList', 'operation_point'];

        vm.serviceOffset = 0;
        vm.branchOffset = 0;
        vm.vehicleOffset = 0;

        // =================== FILTER OBJECT ===================
        vm.filterObject = {
            access_token: $cookies.get('obj'),
            branch_filter: 1,
            vehicle_filter: 1,
            service_filter: 1,
            agreement_filter: 0,
            corporate_filter: 0,
            service_category: 0,
            corporate_status: 0,
            agreement_status: 0,
            vehicle__status: 1,
            operation_point_filter: 0,
            service_limit: vm.globalLimit,
            service_offset: vm.serviceOffset,
            branch_limit: vm.globalLimit,
            branch_offset: vm.branchOffset,
            vehicle_limit: vm.globalLimit,
            vehicle_offset: vm.vehicleOffset,
            branch_search_filter: 0,
            vehicle_search_filter: 0,
            service_search_filter: 0,
            agreement_search_filter: 0,
            corporate_search_filter: 0,
            operation_point_search_filter: 0
        }

        setTimeout(function () {
            document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                // if (vm.branchList && (vm.branchList.length == 0)) {
                vm.searchBranchData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

            document.getElementsByClassName('ui-select-search')[1].addEventListener('blur', function ($event) {
                // if (vm.service && (vm.service.length == 0)) {
                vm.searchServiceData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

            document.getElementsByClassName('ui-select-search')[2].addEventListener('blur', function ($event) {
                // if (vm.vehicle && (vm.vehicle.length == 0)) {
                vm.searchVehicleData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });
        })
        // =================== GET FILTER DATA ===================
        function getFilterDataFromBackend(data, type) { //Acc to Index ['branch_search', 'vehicle_search', 'service_search', 'agreement_search', 'corporate_search', 'operation_point_search']
            if (data) {
                vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
            } else {
                vm.filterObject = {
                    access_token: $cookies.get('obj'),
                    branch_filter: 1,
                    vehicle_filter: 1,
                    service_filter: 1,
                    agreement_filter: 0,
                    corporate_filter: 0,
                    service_category: 0,
                    corporate_status: 0,
                    agreement_status: 2,
                    vehicle__status: 1,
                    operation_point_filter: 0,
                    branch_search_filter: 0,
                    vehicle_search_filter: 0,
                    service_search_filter: 0,
                    agreement_search_filter: 0,
                    corporate_search_filter: 0,
                    operation_point_search_filter: 0
                }
            }

            vm.filterObject.service_limit = vm.globalLimit;
            vm.filterObject.service_offset = vm.serviceOffset;
            vm.filterObject.branch_limit = vm.globalLimit;
            vm.filterObject.branch_offset = vm.branchOffset;
            vm.filterObject.vehicle_limit = vm.globalLimit;
            vm.filterObject.vehicle_offset = vm.vehicleOffset;

            var promise = getFilters.getAllFilterData(vm.filterObject);
            promise.then(
                function (payload) {

                    // ********** BRANCH DATA ********
                    if (payload.title.data.branches) {
                        var index = _.findIndex(vm.branchList, {
                            region_id: 'all'
                        });
                        if (index == -1)
                            vm.branchList.push({
                                region_name: 'All',
                                region_id: 'all'
                            });
                        angular.forEach(payload.title.data.branches.data, function (column) {
                            //CHECK FOR DUPLICATE ENTRY
                            var branchIndex = _.findIndex(vm.branchList, {
                                region_id: column.region_id
                            });
                            if (branchIndex == -1)
                                vm.branchList.push(column)
                        });
                        vm.branchTotalBackendCount = payload.title.data.branches.totalCount;
                    }

                    // ********** VEHICLE DATA ********
                    if (payload.title.data.vehicles) {
                        var index = _.findIndex(vm.vehicle, {
                            id: 'all'
                        });
                        if (index == -1)
                            vm.vehicle.push({
                                name: 'All',
                                id: 'all'
                            });
                        vm.vehicleTotalBackendCount = payload.title.data.vehicles.totalCount;
                        angular.forEach(payload.title.data.vehicles.data, function (column) {
                            //CHECK FOR DUPLICATE ENTRY
                            var vehicleIndex = _.findIndex(vm.vehicle, {
                                id: column.id
                            });
                            if (vehicleIndex == -1)
                                vm.vehicle.push({
                                    id: column.id,
                                    name: column.name
                                })
                        });
                    }

                    // *********** SERVICE DATA *********
                    if (payload.title.data.services) {
                        var index = _.findIndex(vm.service, {
                            id: 'all'
                        });
                        if (index == -1)
                            vm.service.push({
                                name: 'All',
                                id: 'all'
                            });
                        vm.serviceTotalBackendCount = payload.title.data.services.totalCount;
                        angular.forEach(payload.title.data.services.data, function (column) {
                            //CHECK FOR DUPLICATE ENTRY
                            var serviceIndex = _.findIndex(vm.service, {
                                id: column.id
                            });
                            if (serviceIndex == -1)
                                vm.service.push({
                                    id: column.id,
                                    name: column.service_name
                                });
                        });
                    }


                    vm.loading = false;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        }
        getFilterDataFromBackend();


        // ************ PAGINATION ON SERIVCE **************
        function paginationChangedForService() {
            var index = _.findIndex(vm[vm.searchFilterArray[2]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.serviceTotalBackendCount > (vm.service.length - index)) {
                commonFunction(2);
                vm.serviceOffset += 10;
                getFilterDataFromBackend(vm.searchServiceData, 2);
            }
        }

        // ************ PAGINATION ON VEHICLE **************
        function paginationChangedForVehicle() {
            var index = _.findIndex(vm[vm.searchFilterArray[1]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.vehicleTotalBackendCount > (vm.vehicle.length - index)) {
                commonFunction(1);
                vm.vehicleOffset = vm.vehicleOffset + 10;
                getFilterDataFromBackend(vm.searchVehicleData, 1);
            }
        }

        // ************ PAGINATION ON BRANCH **************
        function paginationChangedForBranch() {
            var index = _.findIndex(vm[vm.searchFilterArray[0]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.branchTotalBackendCount > (vm.branchList.length - index)) {
                commonFunction(0);
                vm.branchOffset += 10;
                getFilterDataFromBackend(vm.searchBranchData, 0);
            }
        }

        // *********** COMMON FUNCTION FOR FILTER PAGINATION AND SEARCHING ***********
        function commonFunction(type, mode) {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                // vm['search' + vm.searchFilterArray[i] + 'Data'] = '';
                if (mode == 'search' || i != type) {
                    vm[vm.searchFilterArrayForClearArray[i]] = [];
                    // vm[vm.searchFilterArrayForClearArray[i]].push({
                    //     id: 'all',
                    //     name: 'All'
                    // });
                    vm[vm.searchFilterArray[i] + 'Offset'] = 0;
                    vm['search' + vm.searchFilterArray[i].substring(0, 1).toUpperCase() + vm.searchFilterArray[i].substring(1) + 'Data'] = '';
                }
            }
        }

        // ************ SEARCH VEHICLE ***************
        function vehicleSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchVehicleData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(1, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 1);
                }, 2000);
            }
        }

        // ************ SEARCH SERVICE ***************
        function serviceSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchServiceData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(2, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 2);
                }, 2000);
            }
        }

        // ************ SEARCH BRANCH ***************
        function branchSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchBranchData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(0, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 0);
                }, 2000);
            }
        }

        //==================date picker function==================
        vm.dateOptions = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(2090, 12, 31),
            //minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };

        function datePickerE_1(type) {
            if (type == 1) {
                vm.datePicker_1.sinceDate = true;
                vm.datePicker_1.untillDate = false;
            } else if (type == 2) {
                vm.datePicker_1.sinceDate = false;
                vm.datePicker_1.untillDate = true;
            }
        };

        //====================function for dropdown pages and page count===============
        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllDetailedProduction(0, vm.itemsPerPageGot, vm.filterData);
        };

        function paginationNew(page) {
            getAllDetailedProduction((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData);
        }
        //==================refreshData=====================
        function refreshData() {
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllDetailedProduction(vm.currentPage * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData);
        }
        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.detailedProductionMain.detailedProduction');
            }
        });

        //====================date time format====================
        function dateTimeFormat(dateGot, timeGot) {

            var dateToChange = dateGot;
            dateToChange.setHours(timeGot.getHours());
            dateToChange.setMinutes(timeGot.getMinutes());
            dateToChange.setSeconds(timeGot.getSeconds());
            return dateToChange;
        };

        //==================hours format=====================
        function changeHoursFormat(data) {
            if (data && data > 60) {
                var h = Math.floor(data / 60);
                var remainder = data % 60;
                var finalH = h < 10 ? '0' + h : h;

                return finalH + ':' + remainder + ':00';
            } else if (data && data < 60) {
                var a = data < 10 ? '0' + data : data;
                return '00:' + a + ':00';
            } else {
                return '00:00:00';
            }
        }
        //==================get all drivers=======================
        function getAllDetailedProduction(skip, limit, filter) {
            if (filter.until_date < filter.since_date) {
                languageBasedErrorFactory.getProperErrorMessage('appropriateFilter', 0, 0);
                return;
            }
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit;
            dataSend.offset = skip;
            dataSend.filter_branch = filter.filter_branch;
            if (filter.filter_branch == 1 && filter.branch != 'all') {
                dataSend.branch = filter.branch;
            }
            dataSend.filter_service = filter.filter_service;
            if (filter.filter_service == 1 && filter.type_of_service != 'all') {
                dataSend.type_of_service = filter.type_of_service;
            }
            dataSend.filter_vehicle = filter.filter_vehicle;
            if (filter.filter_vehicle == 1 && filter.type_of_vehicle != 'all') {
                dataSend.type_of_vehicle = filter.type_of_vehicle;
            }
            dataSend.search_filter = filter.search_filter;
            if (filter.search_filter == 1) {
                dataSend.search_value = filter.search_value;
            }
            // dataSend.since_date = moment(filter.since_date).format('YYYY-MM-DD') + 'T00:00:000Z'; //filter.since_date.toISOString();
            // dataSend.until_date = moment(filter.until_date).format('YYYY-MM-DD') + 'T23:59:59Z'; //filter.until_date.toISOString();

            dataSend.since_date = moment.utc(moment(filter.since_date).set({
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0
            })).format('YYYY-MM-DD HH:mm:ss'); //BY DEFAULT DATEPICKER GIVE TIME 00:00:00 

            dataSend.until_date = moment.utc(moment(filter.until_date).set({
                hour: 23,
                minute: 59,
                second: 59,
                millisecond: 0
            })).format('YYYY-MM-DD HH:mm:ss'); //filter.until_date.toISOString();

            vm.loading = true;
            var promise = getProduction.detailedProduction(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.totalDetailedList = payload.title.data.totalCount;
                    vm.dataLength = payload.title.data.totalCount;

                    if (payload.title.data.totalCount == 0) {
                        vm.sp_pagination = false;
                        vm.tBodyFlag = false;
                        vm.tFootFlag = true;
                        vm.filterOn = true;
                        vm.skipValueFilter = 0;
                    } else {
                        vm.sp_pagination = true;
                        vm.tBodyFlag = true;
                        vm.tFootFlag = false;
                        vm.filterOn = false;
                        vm.skipValueFilter = 0;

                        var dataArray = [];
                        var DetailedProList = payload.title.data.result;
                        DetailedProList.forEach(function (column) {
                            var d = {};
                            d.booking_id = column.booking_id;
                            d.earning_percentage = column.earning_percentage;
                            d.driverName = column.first_name + ' ' + column.last_name;
                            d.unique_car_id = column.unique_car_id;
                            d.transport_details = column.transport_details;
                            d.started_datetime = column.started_datetime;
                            d.started_datetime_filtered = $filter('date')(column.started_datetime, "MMM d, yyyy hh:mm a'");
                            d.service_name = column.service_name;
                            d.service_cost = column.service_cost;
                            d.region_name = column.region_name;
                            d.payment_amount = column.payment_amount;
                            d.name = column.name;
                            d.modelity = column.modelity;
                            d.isAirportService = column.isAirportService;
                            dataArray.push(d);
                        });
                        vm.DetailedProList = dataArray;

                        for (var i = 0; i < vm.DetailedProList.length; i++) {
                            vm.DetailedProList[i].index = (skip + i);
                        }
                        if (vm.dataLength <= vm.itemsPerPageGot) {
                            vm.sp_pagination = false;
                        } else {
                            vm.sp_pagination = true;
                            //vm.pageCount(payload.title.data.totalCount);
                        }
                        vm.skipValue = vm.DetailedProList[0].index;
                        vm.limitValue = vm.DetailedProList[vm.DetailedProList.length - 1].index;

                        //$scope.$watch('vm.search', function (newVal, oldVal) {
                        //    vm.filtered = filterFilter(vm.DetailedProList, newVal);
                        //    vm.totalItems = vm.filtered.length;
                        //    if (vm.filtered.length == 0) {
                        //        vm.watchPagination = false;
                        //    } else {
                        //        vm.watchPagination = true;
                        //    }
                        //    if (vm.filterOn == true) {
                        //        vm.skipValueFilter = vm.filtered.length;
                        //        vm.sp_pagination = false;
                        //    }
                        //}, true);

                        //range();
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    } else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        vm.getAllDetailedProduction((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        vm.currentPage++;
        //        vm.getAllDetailedProduction((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    vm.getAllDetailedProduction((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //};

        function init() {
            vm.getAllDetailedProduction(0, vm.searchModel.limit, vm.filterData);
        };
        init();

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            //vm.filterOn = true;
            vm.currentPage = 0;
            vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
            vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
            pendingRequests.cancelAll();
            if (vm.search.length == 0) {
                vm.filterData.search_filter = 0;
                vm.filterData.search_value = '';
                vm.getAllDetailedProduction(0, vm.searchModel.limit, vm.filterData);
                //vm.filterOn = false;
                //vm.watchPagination = true;
                //vm.sp_pagination = true;

            } else {
                vm.filterData.search_filter = 1;
                vm.filterData.search_value = vm.search;
                //if (vm.filterTextTimeout) $timeout.cancel(vm.filterTextTimeout);
                //vm.filterTextTimeout = $timeout(function(){
                vm.getAllDetailedProduction(0, vm.searchModel.limit, vm.filterData);
                //},500);
            }
        };
        //====================get branch list====================
        // function getBranch() {
        // vm.branchList = [];
        // vm.branchList = JSON.parse(JSON.stringify(getFilters.branchesFiltersData.data));
        // vm.branchList.push({
        //     region_name: 'All',
        //     region_id: 'all'
        // });
        // $scope.$apply();

        //vm.loading = true;
        // var promise = getGeofence.branch();
        // promise.then(
        //     function (payload) {
        //         $log.log(payload);
        //         //vm.loading = false;
        //         if (payload.title.status == 400) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //         } else if (payload.title.status == 401) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //         } else if (payload.title.status == 201 || payload.title.status == 200) {
        //             var where = _.where(payload.title.data, {
        //                 parent_id: 0
        //             });
        //             //vm.branchList = _.where(where, { is_active: 1 });
        //             vm.branchList = where;

        //             vm.branchList.push({
        //                 region_name: 'All',
        //                 region_id: 'all'
        //             });
        //         }
        //     },
        //     function (errorPayload) {
        //         $log.log(errorPayload);
        // vm.loading = false;
        //         if (errorPayload.data.status == 401) {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //         } else {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //         }
        //     }
        // );
        // }
        // WHen Page refresh service take time to get data from backend
        // setTimeout(function () {
        //     getBranch();
        // }, 1000);
        //======================get all vehicles==============
        // function getAllVehicles(skip, limt, filter) {
        // vm.vehicle = [];
        // angular.forEach(getFilters.vehiclesFiltersData.data, function (column) {
        //     vm.vehicle.push({
        //         id: column.id,
        //         name: column.name
        //     })
        // });
        // vm.vehicle.push({
        //     id: 'all',
        //     name: 'All'
        // });

        //vm.loading = false;
        // var promise = getVehicles.allVehicles(skip, limt, filter);
        // promise.then(
        //     function (payload) {
        //         $log.log('sxdsads', payload);
        //         //vm.loading = false;
        //         if (payload.title.status == 400) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //         } else if (payload.title.status == 401) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //         } else if (payload.title.status == 201 || payload.title.status == 200) {
        //             vm.vehicle = [];
        //             angular.forEach(payload.title.data.result, function (column) {
        //                 vm.vehicle.push({
        //                     id: column.id,
        //                     name: column.name
        //                 })
        //             });
        //             vm.vehicle.push({
        //                 id: 'all',
        //                 name: 'All'
        //             });
        //         }
        //     },
        //     function (errorPayload) {
        //         $log.log(errorPayload);
        //         //vm.loading = false;
        //         if (errorPayload.data.status == 401) {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //         } else {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //         }
        //     }
        // );
        // };
        // WHen Page refresh service take time to get data from backend
        // setTimeout(function () {
        //     getAllVehicles(0, 0, 2);
        // }, 1000);
        //======================get all services==============
        // function getAllServices(skip, limit) {
        // vm.service = [];
        // angular.forEach(getFilters.servicesFiltersData.data, function (column) {
        //     vm.service.push({
        //         id: column.id,
        //         name: column.service_name
        //     });
        // });
        // vm.service.push({
        //     id: 'all',
        //     name: 'All'
        // });

        //vm.loading = false;
        // var promise = getServices.allServices(skip, limit, 2);
        // promise.then(
        //     function (payload) {
        //         $log.log('sxdsads', payload);
        //         //vm.loading = false;
        //         if (payload.title.status == 400) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //         } else if (payload.title.status == 401) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //         } else if (payload.title.status == 201 || payload.title.status == 200) {
        //             vm.service = [];
        //             angular.forEach(payload.title.data.result, function (column) {
        //                 vm.service.push({
        //                     id: column.id,
        //                     name: column.service_name
        //                 });
        //             });
        //             vm.service.push({
        //                 id: 'all',
        //                 name: 'All'
        //             })
        //         }
        //     },
        //     function (errorPayload) {
        //         $log.log(errorPayload);
        // vm.loading = false;
        //         if (errorPayload.data.status == 401) {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //         } else {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //         }
        //     }
        // );
        // };
        // WHen Page refresh service take time to get data from backend
        // setTimeout(function () {
        //     getAllServices(0, 0);
        // }, 1000);

        // ******** CLEAR OFFSET *******
        function clearOffset() {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                vm[vm.searchFilterArray[i] + 'Offset'] = 0;
            }
        }

        //=================filter change functions=================
        function branchChanged() {
            vm.currentPage = 0;
            clearOffset();
            if (vm.filterData.branch && vm.filterData.branch != 'all') {
                vm.filterData.filter_branch = 1;
                // getAllDetailedProduction(0, vm.itemsPerPageGot, vm.filterData);
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                getFilterDataFromBackend();
            } else {
                vm.filterData.filter_branch = 0;
                vm.filterData.branch = 'all';
                // getAllDetailedProduction(0, vm.itemsPerPageGot, vm.filterData);
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                getFilterDataFromBackend();
            }
        };

        function serviceChanged() {
            vm.currentPage = 0;
            clearOffset();
            if (vm.filterData.type_of_service && vm.filterData.type_of_service != 'all') {
                vm.filterData.filter_service = 1;
                // getAllDetailedProduction(0, vm.itemsPerPageGot, vm.filterData);
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                getFilterDataFromBackend();
            } else {
                vm.filterData.filter_service = 0;
                vm.filterData.type_of_service = 'all';
                // getAllDetailedProduction(0, vm.itemsPerPageGot, vm.filterData);
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                getFilterDataFromBackend();
            }
        };

        function vehicleChanged() {
            vm.currentPage = 0;
            clearOffset();
            if (vm.filterData.type_of_vehicle && vm.filterData.type_of_vehicle != 'all') {
                vm.filterData.filter_vehicle = 1;
                // getAllDetailedProduction(0, vm.itemsPerPageGot, vm.filterData);
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                getFilterDataFromBackend();
            } else {
                vm.filterData.filter_vehicle = 0;
                vm.filterData.type_of_vehicle = 'all';
                // getAllDetailedProduction(0, vm.itemsPerPageGot, vm.filterData);
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                getFilterDataFromBackend();
            }
        };

        function sinceDateChanged() {
            vm.currentPage = 0;
            // if (vm.filterData.since_date) {
            //     getAllDetailedProduction(0, vm.itemsPerPageGot, vm.filterData);
            // } else {
            //     getAllDetailedProduction(0, vm.itemsPerPageGot, vm.filterData);
            // }
        };

        function untillDateChanged() {
            vm.currentPage = 0;
            // if (vm.filterData.until_date) {
            //     getAllDetailedProduction(0, vm.itemsPerPageGot, vm.filterData);
            // } else {
            //     getAllDetailedProduction(0, vm.itemsPerPageGot, vm.filterData);
            // }
        };

        function resetFilter() {
            vm.currentPage = 0;
            vm.filterData = {
                limit: vm.itemsPerPageGot,
                offset: 0,
                since_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
                until_date: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
                branch: '',
                type_of_service: '',
                type_of_vehicle: '',
                filter_branch: 0,
                filter_service: 0,
                filter_vehicle: 0
            };
            getAllDetailedProduction(0, vm.itemsPerPageGot, vm.filterData);
        };

        function applyFilter(){
            vm.getAllDetailedProduction(0, vm.searchModel.limit, vm.filterData);
        }

        //=================================export to csv==============================
        function exportToCSV() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = 0;
            dataSend.offset = 0;
            dataSend.filter_branch = 0;
            dataSend.filter_service = 0;
            dataSend.filter_vehicle = 0;
            // dataSend.since_date = moment(vm.filterData.since_date).format('YYYY-MM-DD') + 'T00:00:000Z';
            // dataSend.until_date = moment(vm.filterData.until_date).format('YYYY-MM-DD') + 'T23:59:59Z';

            dataSend.since_date = moment.utc(moment(vm.filterData.since_date).set({
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0
            })).format('YYYY-MM-DD HH:mm:ss'); //BY DEFAULT DATEPICKER GIVE TIME 00:00:00 

            dataSend.until_date = moment.utc(moment(vm.filterData.until_date).set({
                hour: 23,
                minute: 59,
                second: 59,
                millisecond: 0
            })).format('YYYY-MM-DD HH:mm:ss'); //filter.until_date.toISOString();

            vm.loading = true;
            var promise = getProduction.detailedProduction(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;

                    var dataArrayE = [];
                    var detailListExport = payload.title.data.result;
                    detailListExport.forEach(function (column) {
                        var d = {};
                        d['Branch'] = column.region_name;
                        d['Vehicle Unique No.'] = column.unique_car_id;
                        d['Driver'] = column.first_name + " " + column.last_name;
                        d['ID Booking'] = column.booking_id;
                        d['Type of Service'] = column.service_name;
                        d['Type of Vehicle'] = column.name;
                        d['Start Time'] = moment(column.started_datetime).format('lll');
                        d['$ Trip'] = column.payment_amount;
                        d['Airport Service'] = column.isAirportService ? 'Yes' : 'No';
                        d['% Earning'] = column.earning_percentage;
                        d['$ Earning'] = column.service_cost;
                        d['Working 24 Hrs'] = column.modelity ? '24 hrs' : 'Not 24 hrs';
                        dataArrayE.push(d);
                    });
                    vm.detailListExport = dataArrayE;
                    alasql('SELECT * INTO CSV("detailedSummaryProduction.csv",{headers:true}) FROM ?', [vm.detailListExport]);

                },
                function (errorPayload) {
                    vm.loading = false;
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };
    }

})();
/**
 * Created by cl-macmini-51 on 7/11/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .controller('ViewPaymentTypeListController', ViewPaymentTypeListController);

    /** @ngInject */
    function ViewPaymentTypeListController($cookies, $state, $log, $rootScope, $mdDialog, $timeout, $document,getPromoCodes, getPaymentMethods, $scope, filterFilter, $stateParams,languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.getAllPaymentMethods = getAllPaymentMethods;
        vm.setBooleans = setBooleans;
        vm.goBack = goBack;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.loading = false;
        vm.dataToFill = {
            channels: [],
            channelArray: [],
            channelGot: []
        }
        //====================event for getting refreshed================
        $scope.$on('StateReload', function(evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.paymentTypeMain.viewPaymentType');
            }
        });

         //======================get promo Channels  ==============
        function getPromoChannels() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');

            var promise = getPromoCodes.getpromoChannelsListNew(dataSend);
            promise.then(
                function (payload) {
                    vm.dataToFill.channels = payload.title;
                    for (var i = 0; i < vm.dataToFill.channels.length; i++) {
                        vm.dataToFill.channels[i].checked = false;
                    }
                    vm.dataToFill.channels.map(function(x){
                        for(var i=0;i<vm.dataToFill.channelGot.length;i++){
                            if(x.channel_id == Number(vm.dataToFill.channelGot[i])){
                                x.checked = true;
                            }
                        }
                    })

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
      

        //=============For Channel switches================
        function setBooleans(index){
            vm.dataToFill.channels[index].checked = !vm.dataToFill.channels[index].checked;
        }

        //==================get all corporates=======================
        function getAllPaymentMethods(filter,skip, limit) {
            vm.loading = true;
            var promise = getPaymentMethods.allMethods(filter,skip, limit);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.paymentDetail = _.where(payload.title.data.result,{id:Number($stateParams.id)})[0];
                    vm.dataToFill.channelGot = vm.paymentDetail.channel_id;
                    getPromoChannels();
                },
                function(errorPayload) {
                    vm.loading = false;
                    $log.log(errorPayload);
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        getAllPaymentMethods(2,0,0);
        //=================go back================
        function goBack() {
            $state.go('layout.paymentTypeMain.paymentTypeList');
        };
    }
})();
/**
 * Created by cl-macmini-51 on 5/15/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .controller('PaymentTypeListController', PaymentTypeListController);

    /** @ngInject */
    function PaymentTypeListController($cookies, $state, $log, $rootScope, $mdDialog, $timeout, $document, getPaymentMethods, $scope, filterFilter, languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.getAllPaymentMethods = getAllPaymentMethods;
        vm.loading = false;
        vm.currentPage = 0;
        vm.totalMethods = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.getPagesCount = getPagesCount;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.init = init;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.paginationNew = paginationNew;
        vm.blockUnblockPayments = blockUnblockPayments;
        vm.deletePaymentType = deletePaymentType;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.predicate = 'index';
        vm.reverse = false;
        vm.filterData = {
            paymentStatus: '1'
        };
        //====================function for dropdown pages and page count===============
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];

        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllPaymentMethods(vm.filterData.paymentStatus,0, vm.itemsPerPageGot);
        };
        function paginationNew(page){
            getAllPaymentMethods(vm.filterData.paymentStatus,(page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot);
        }

        //====================event for getting refreshed================
        $scope.$on('StateReload', function(evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.paymentTypeMain.paymentTypeList');
            }
        });

        //==================get all corporates=======================
        function getAllPaymentMethods(filter,skip, limit) {
            vm.loading = true;
            var promise = getPaymentMethods.allMethods(filter,skip, limit);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.totalMethods = payload.title.data.totalCount;//payload.title.totalCount;
                    vm.dataLength = payload.title.data.totalCount;

                    if (payload.title.data.totalCount == 0) {
                        vm.sp_pagination = false;
                        vm.tBodyFlag = false;
                        vm.tFootFlag = true;
                    } else {
                        vm.sp_pagination = true;
                        vm.tBodyFlag = true;
                        vm.tFootFlag = false;
                    }

                    var dataArray = [];

                    var paymentMethodList = payload.title.data.result;
                    paymentMethodList.forEach(function(column) {
                        var d = {};

                        d.type = column.type;
                        d.id = column.id;
                        d.status = column.status;
                        d.payment_status = column.payment_status;
                        d.is_ionix = column.is_ionix;
                        if(column.channel_name)
                            d.channels = column.channel_name;
                        else d.channels = [];
                        dataArray.push(d);
                    });
                    vm.paymentMethodList = dataArray;

                    for (var i = 0; i < vm.paymentMethodList.length; i++) {
                        vm.paymentMethodList[i].index = (skip + i);
                    }
                    if (vm.dataLength <= vm.itemsPerPageGot) {
                        vm.sp_pagination = false;
                    } else {
                        vm.sp_pagination = true;
                        //vm.pageCount(payload.title.data.totalCount);
                    }
                    vm.skipValue = vm.paymentMethodList[0].index;
                    vm.limitValue = vm.paymentMethodList[vm.paymentMethodList.length - 1].index;

                    $scope.$watch('vm.search', function(newVal, oldVal) {
                        vm.filtered = filterFilter(vm.paymentMethodList, newVal);
                        vm.totalItems = vm.filtered.length;
                        if (vm.filtered.length == 0) {
                            vm.watchPagination = false;
                        } else {
                            vm.watchPagination = true;
                        }
                        if (vm.filterOn == true) {
                            vm.skipValueFilter = vm.filtered.length;
                            vm.sp_pagination = false;
                        }
                    }, true);

                    //range();
                },
                function(errorPayload) {
                    vm.loading = false;
                    $log.log(errorPayload);
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };

        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    } else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        vm.getAllPaymentMethods(vm.filterData.paymentStatus,(b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected);
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        vm.currentPage++;
        //        vm.getAllPaymentMethods(vm.filterData.paymentStatus,(a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected);
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    vm.getAllPaymentMethods(vm.filterData.paymentStatus,(m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected);
        //};

        function init() {
            vm.getAllPaymentMethods(vm.filterData.paymentStatus,0, vm.searchModel.limit);
        };
        init();

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            vm.filterOn = true;
            if (vm.search.length == 0) {
                vm.filterOn = false;
                vm.watchPagination = true;
                vm.sp_pagination = true;
            }
        };
        //==================block_unblock function======================
        function blockUnblockPayments($event, id, value) {
            $log.log('block_unblock');
            var parentEl = angular.element($document.body);
            var msg = languageBasedErrorFactory.getProperErrorMessage('statusPPop',0,'3');
            //==============dialog for confirm====================
            var confirm = $mdDialog.confirm()
                .title(msg)
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton',0,'3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton',0,'3'));

            $mdDialog.show(confirm).then(function() {
                var a = '';
                var msgSys = '';
                if (value == 0 || value == null) {
                    a = 1;
                    msgSys = 'Payment type unblocked.'
                } else if (value == 1) {
                    a = 0;
                    msgSys = 'Payment type blocked.'
                }
                //errorMessageFactory.showErrorMessage('Functionality is pending.',0);
                var dataSend = {
                    access_token: $cookies.get('obj'),
                    status: a,
                    payment_method_id: id
                };

                vm.loading = true;
                var promise = getPaymentMethods.updateMethod(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        var dataForSysLogs = {
                            access_token: $cookies.get('obj'),
                            id: id,
                            identity : 14,
                            message : msgSys
                        };
                        $rootScope.systemLogsAdmin(dataForSysLogs);
                        languageBasedErrorFactory.getProperErrorMessage('statusSucc',0,1,'layout.paymentTypeMain.paymentTypeList');
                        //errorMessageFactory.showErrorMessage('Payment method status updated successfully.',1);
                        //$timeout(function () {
                        //    $mdDialog.hide();
                        //    $state.reload();
                        //}, 2000);
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if(errorPayload.data.status == 401){
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                        }
                        else{
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                        }
                    }
                );
            }, function() {
                $log.log('unblock');
            });
        };
        //=====================to delete service====================
        function deletePaymentType(data, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('deletePop',0,'3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton',0,'3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton',0,'3'));

            $mdDialog.show(confirm).then(function() {
                $log.log('confirmed');
                //errorMessageFactory.showErrorMessage('Functionality is pending',0);
                var dataSend = {
                    deleteType: 1,
                    payment_method_id: data.id,
                    access_token: $cookies.get('obj')
                };
                vm.loading = true;
                var promise = getPaymentMethods.deletePaymentMethod(dataSend);
                promise.then(
                    function(payload) {
                        $log.log(payload);
                        vm.loading = false;
                        languageBasedErrorFactory.getProperErrorMessage('deleteSucc',0,1,'layout.paymentTypeMain.paymentTypeList');
                        //errorMessageFactory.showErrorMessage('Payment type deleted successfully.',1);
                        //$state.reload();
                    },
                    function(errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if(errorPayload.data.status == 401){
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                        }
                        else{
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                        }
                    }
                );
            }, function() {
                $log.log('not confirmed');
            });
        };


    }

})();

/**
 * Created by cl-macmini-51 on 5/15/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('PaymentTypeEditController', PaymentTypeEditController);

    /** @ngInject */
    function PaymentTypeEditController($cookies, $state, $log, $rootScope, $mdDialog, $timeout, $document, getPaymentMethods, getPromoCodes, $scope, filterFilter, $stateParams, languageBasedErrorFactory, errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.goBack = goBack;
        vm.editPaymentMethodApi = editPaymentMethodApi;
        vm.getAllPayment = getAllPayment;
        vm.setBooleans = setBooleans;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.dataToFill = {
            paymentType: '',
            paymentStatus: '',
            isIonix: '',
            channels: [],
            channelArray: [],
            channelGot: []
        };
        vm.setBooleansPayment = setBooleansPayment;
        vm.paymentStatus = false;
        vm.setMethod = setMethod;

        //======================get promo Channels  ==============
        function getPromoChannels() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');

            var promise = getPromoCodes.getpromoChannelsListNew(dataSend);
            promise.then(
                function (payload) {
                    vm.dataToFill.channels = payload.title;
                    for (var i = 0; i < vm.dataToFill.channels.length; i++) {
                        vm.dataToFill.channels[i].checked = false;
                    }
                    vm.dataToFill.channels.map(function (x) {
                        if (vm.dataToFill.channelGot.length) {
                            for (var i = 0; i < vm.dataToFill.channelGot.length; i++) {
                                if (x.channel_id == Number(vm.dataToFill.channelGot[i])) {
                                    x.checked = true;
                                }
                            }
                        } else x.checked = false;
                    })

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };


        //=============For Channel switches================
        function setBooleans(index) {
            vm.dataToFill.channels[index].checked = !vm.dataToFill.channels[index].checked;
        }


        function setBooleansPayment() {
            if (vm.paymentStatus) {
                vm.paymentStatus = false;
            } else {
                vm.paymentStatus = true;
            }
        }


        //======================get all payment method and then filter================================
        function getAllPayment(id) {

            vm.loading = true;
            var promise = getPaymentMethods.methodDetails(id);
            promise.then(
                function (payload) {
                    vm.loading = false;
                    vm.dataToFill.paymentType = payload.title.data[0].type;
                    vm.dataToFill.paymentTypeEnglish = payload.title.data[0].type_english;
                    vm.dataToFill.paymentStatus = payload.title.data[0].payment_status.toString();
                    vm.dataToFill.isIonix = payload.title.data[0].is_ionix.toString();
                    if (payload.title.data[0].channel_id && payload.title.data[0].channel_id.length)
                        vm.dataToFill.channelGot = payload.title.data[0].channel_id;
                    else vm.dataToFill.channelGot = [];
                    vm.paymentStatus = payload.title.data[0].is_refund;
                    vm.paymentMethodId = payload.title.data[0].refund_payment_id;
                    getPromoChannels();
                },
                function (errorPayload) {
                    vm.loading = false;
                    $log.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        getAllPayment($stateParams.id);
        //===========================function to add payment methhod========================
        function editPaymentMethodApi() {
            vm.errorFalg = false;
            if (vm.paymentStatus) {
                if (vm.paymentMethodId == undefined) {
                    vm.flagForTrue = true;
                    return true;
                }
            } else {
                vm.flagForTrue = false;
            }
            for (var i = 0; i < vm.dataToFill.channels.length; i++) {
                if (vm.dataToFill.channels[i].checked) {
                    vm.dataToFill.channelArray.push(vm.dataToFill.channels[i].channel_id);
                }
            }
            var errorFlag = _.compact(_.pluck(vm.dataToFill.channels, "checked")).length;
            console.log(errorFlag, 'errorFlag');
            if (errorFlag == 0) {
                errorMessageFactory.showErrorMessage('Selecciona al menos un canal de visiblidad para el método de pago', 0);
                return;
            }
            var dataSend = {
                access_token: $cookies.get('obj'),
                type: vm.dataToFill.paymentType,
                payment_status: vm.dataToFill.paymentStatus,
                is_ionix: vm.dataToFill.isIonix,
                payment_method_id: $stateParams.id,
                channel_id: vm.dataToFill.channelArray,
                is_refund: vm.paymentStatus ? 1 : 0,
                type_english: vm.dataToFill.paymentTypeEnglish,
            };
            if (vm.paymentStatus) {
                dataSend.refund_payment_id = Number(vm.paymentMethodId);
            }
            vm.loading = true;
            var promise = getPaymentMethods.updateMethod(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        var dataForSysLogs = {
                            access_token: $cookies.get('obj'),
                            id: $stateParams.id,
                            identity: 14,
                            message: 'Payment method updated.'
                        };
                        $rootScope.systemLogsAdmin(dataForSysLogs);
                        languageBasedErrorFactory.getProperErrorMessage('editPaymentSucc', 0, 2, 'layout.paymentTypeMain.paymentTypeList');
                        //errorMessageFactory.showErrorMessage('Payment method updated successfully.',2,'layout.paymentTypeMain.paymentTypeList');
                        //$timeout(function () {
                        //    $mdDialog.hide();
                        //    $state.reload();
                        //}, 2000);
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        vm.dataToFill.channelArray = [];
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //================function to go back======================
        function goBack() {
            $state.go('layout.paymentTypeMain.paymentTypeList');
        };


        getAllPaymentMethods(1, 0, 100);
        //==================get all corporates=======================
        function getAllPaymentMethods(filter, skip, limit) {
            vm.loading = true;
            var promise = getPaymentMethods.allMethods(filter, 0, 100);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.totalMethods = payload.title.data.totalCount; //payload.title.totalCount;
                    vm.dataLength = payload.title.data.totalCount;

                    if (payload.title.data.totalCount == 0) {
                        vm.sp_pagination = false;
                        vm.tBodyFlag = false;
                        vm.tFootFlag = true;
                    } else {
                        vm.sp_pagination = true;
                        vm.tBodyFlag = true;
                        vm.tFootFlag = false;
                    }

                    var dataArray = [];

                    var paymentMethodList = payload.title.data.result;
                    paymentMethodList.forEach(function (column) {
                        var d = {};

                        d.type = column.type;
                        d.id = column.id;
                        d.status = column.status;
                        d.payment_status = column.payment_status;
                        d.is_ionix = column.is_ionix;
                        if (column.channel_name)
                            d.channels = column.channel_name;
                        else d.channels = [];
                        dataArray.push(d);
                    });
                    vm.paymentMethodList = dataArray;

                    for (var i = 0; i < vm.paymentMethodList.length; i++) {
                        vm.paymentMethodList[i].index = (skip + i);
                    }
                    if (vm.dataLength <= vm.itemsPerPageGot) {
                        vm.sp_pagination = false;
                    } else {
                        vm.sp_pagination = true;
                        //vm.pageCount(payload.title.data.totalCount);
                    }
                    vm.skipValue = vm.paymentMethodList[0].index;
                    vm.limitValue = vm.paymentMethodList[vm.paymentMethodList.length - 1].index;

                    $scope.$watch('vm.search', function (newVal, oldVal) {
                        vm.filtered = filterFilter(vm.paymentMethodList, newVal);
                        vm.totalItems = vm.filtered.length;
                        if (vm.filtered.length == 0) {
                            vm.watchPagination = false;
                        } else {
                            vm.watchPagination = true;
                        }
                        if (vm.filterOn == true) {
                            vm.skipValueFilter = vm.filtered.length;
                            vm.sp_pagination = false;
                        }
                    }, true);

                    //range();
                },
                function (errorPayload) {
                    vm.loading = false;
                    $log.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        function setMethod() {
            vm.flagForTrue = false;
        }
    }
})();
/**
 * Created by cl-macmini-51 on 5/15/17.
 */

(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('PaymentTypeAddController', PaymentTypeAddController);

    /** @ngInject */
    function PaymentTypeAddController($cookies, $state, $log, $rootScope, $mdDialog, $timeout, $document, getPaymentMethods, getPromoCodes, $scope, filterFilter, languageBasedErrorFactory, errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.goBack = goBack;
        vm.addPaymentMethodApi = addPaymentMethodApi;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.dataToFill = {
            paymentType: '',
            paymentTypeEnglish: '',
            isIonix: '0',
            paymentStatus: '',
            channels: [],
            channelArray: []
        };
        vm.setBooleansPayment = setBooleansPayment;
        vm.setMethod = setMethod;
        vm.paymentStatus = false;
        vm.setBooleans = setBooleans;

        //======================get promo Channels  ==============
        function getPromoChannels() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');

            var promise = getPromoCodes.getpromoChannelsListNew(dataSend);
            promise.then(
                function (payload) {
                    vm.dataToFill.channels = payload.title;
                    for (var i = 0; i < vm.dataToFill.channels.length; i++) {
                        vm.dataToFill.channels[i].checked = false;
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getPromoChannels();

        //=============For Channel switches================

        function setBooleans(index) {
            vm.dataToFill.channels[index].checked = !vm.dataToFill.channels[index].checked;
        }

        function setBooleansPayment() {
            if (vm.paymentStatus) {
                vm.paymentStatus = false;
            } else {
                vm.paymentStatus = true;
            }
        }


        //===========================function to add payment methhod========================
        function addPaymentMethodApi() {
            console.log(vm.paymentMethodId, 'vm.paymentMethodId ');
            if (vm.paymentStatus) {
                console.log(vm.paymentMethodId, 'vm.paymentMethodId ');
                if (vm.paymentMethodId == undefined) {
                    vm.flagForTrue = true;
                    return true;
                }
            } else {
                vm.flagForTrue = false;
            }
            for (var i = 0; i < vm.dataToFill.channels.length; i++) {
                if (vm.dataToFill.channels[i].checked)
                    vm.dataToFill.channelArray.push(vm.dataToFill.channels[i].channel_id);
            }
            var errorFlag = _.compact(_.pluck(vm.dataToFill.channels,"checked")).length;
            if(errorFlag == 0){
                errorMessageFactory.showErrorMessage('Selecciona al menos un canal de visiblidad para el método de pago', 0);
                return;
            }


            var dataSend = {
                access_token: $cookies.get('obj'),
                type: vm.dataToFill.paymentType,
                type_english: vm.dataToFill.paymentTypeEnglish,
                is_ionix: vm.dataToFill.isIonix,
                payment_status: vm.dataToFill.paymentStatus,
                channel_id: vm.dataToFill.channelArray,
                is_refund: vm.paymentStatus ? 1 : 0,

            };
            if (vm.paymentStatus) {
                dataSend.refund_payment_id = Number(vm.paymentMethodId);
            }

            vm.loading = true;
            var promise = getPaymentMethods.addMethod(dataSend);
            promise.then(
                function (payload) {
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        // vm.loading = false;
                        languageBasedErrorFactory.getProperErrorMessage('paymentAucc', 0, 2, 'layout.paymentTypeMain.paymentTypeList');
                        //errorMessageFactory.showErrorMessage('Payment method added successfully.',2,'layout.paymentTypeMain.paymentTypeList');
                        //$timeout(function () {
                        //    $mdDialog.hide();
                        //    $state.reload();
                        //}, 2000);
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        vm.dataToFill.channelArray = [];
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };


        //================function to go back======================
        function goBack() {
            $state.go('layout.paymentTypeMain.paymentTypeList');
        };

        getAllPaymentMethods(1, 0, 100);
        //==================get all corporates=======================
        function getAllPaymentMethods(filter, skip, limit) {
            vm.loading = true;
            var promise = getPaymentMethods.allMethods(filter, 0, 100);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.totalMethods = payload.title.data.totalCount; //payload.title.totalCount;
                    vm.dataLength = payload.title.data.totalCount;

                    if (payload.title.data.totalCount == 0) {
                        vm.sp_pagination = false;
                        vm.tBodyFlag = false;
                        vm.tFootFlag = true;
                    } else {
                        vm.sp_pagination = true;
                        vm.tBodyFlag = true;
                        vm.tFootFlag = false;
                    }

                    var dataArray = [];

                    var paymentMethodList = payload.title.data.result;
                    paymentMethodList.forEach(function (column) {
                        var d = {};

                        d.type = column.type;
                        d.id = column.id;
                        d.status = column.status;
                        d.payment_status = column.payment_status;
                        d.is_ionix = column.is_ionix;
                        if (column.channel_name)
                            d.channels = column.channel_name;
                        else d.channels = [];
                        dataArray.push(d);
                    });
                    vm.paymentMethodList = dataArray;

                    for (var i = 0; i < vm.paymentMethodList.length; i++) {
                        vm.paymentMethodList[i].index = (skip + i);
                    }
                    if (vm.dataLength <= vm.itemsPerPageGot) {
                        vm.sp_pagination = false;
                    } else {
                        vm.sp_pagination = true;
                        //vm.pageCount(payload.title.data.totalCount);
                    }
                    vm.skipValue = vm.paymentMethodList[0].index;
                    vm.limitValue = vm.paymentMethodList[vm.paymentMethodList.length - 1].index;

                    $scope.$watch('vm.search', function (newVal, oldVal) {
                        vm.filtered = filterFilter(vm.paymentMethodList, newVal);
                        vm.totalItems = vm.filtered.length;
                        if (vm.filtered.length == 0) {
                            vm.watchPagination = false;
                        } else {
                            vm.watchPagination = true;
                        }
                        if (vm.filterOn == true) {
                            vm.skipValueFilter = vm.filtered.length;
                            vm.sp_pagination = false;
                        }
                    }, true);

                    //range();
                },
                function (errorPayload) {
                    vm.loading = false;
                    $log.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        function setMethod() {
            vm.flagForTrue = false;
        }
    }
})();
/**
 * Created by cl-macmini-51 on 07/02/18.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('OperationPointUserController', OperationPointUserController);

    /** @ngInject */
    function OperationPointUserController($cookies, $state, $log, $rootScope, $timeout, $scope, filterFilter, $mdDialog, $document,getOperationPoint,languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.totalOperationUsers = 0;
        vm.loading = false;
        vm.currentPage = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.noDataFlag = false;
        vm.predicate = 'index';
        vm.reverse = false;
        vm.allOperationPoint = [];
        vm.filterData = {
            operation_value: ''
        };
        vm.getPagesCount = getPagesCount;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.sort = sort;
        vm.getOperationPointUsers = getOperationPointUsers;
        vm.paginationNew = paginationNew;
        vm.changeToOperationPoint = changeToOperationPoint;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        //====================event for getting refreshed================
        $scope.$on('StateReload', function(evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.operationPointUserMain.operationPointUser');
            }
        });
        //====================function for dropdown pages and page count===============
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];

        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getOperationPointUsers(0, vm.itemsPerPageGot,vm.filterData);
        };
        function paginationNew(page){
            getOperationPointUsers((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot,vm.filterData);
        }

        //==================get all operation point==================
        function addToOperationPoint(){
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            var promise = getOperationPoint.getOperationList(dataSend);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if(payload.title.data && payload.title.data.length == 0){
                        vm.sp_pagination = false;
                        vm.tBodyFlag = false;
                        vm.tFootFlag = true;
                        vm.filterOn = true;
                        vm.skipValueFilter = 0;
                        vm.totalOperationUsers = 0;
                        vm.dataLength = 0;
                        languageBasedErrorFactory.getProperErrorMessage('noOperation',0,0);
                        return;
                    }
                    vm.allOperationPoint = payload.title.data;
                    vm.filterData.operation_value = vm.allOperationPoint[0].point_id;
                    vm.getOperationPointUsers(0, vm.searchModel.limit,vm.filterData);
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        }
        addToOperationPoint();

        //=====================get operation user hit=========================
        function getOperationPointUsers(skip, limit,filter){
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit;
            dataSend.offset = skip;
            dataSend.point_id = Number(filter.operation_value);
            // dataSend.status = Number(filter);
            var promise = getOperationPoint.getOperatioUserList(dataSend);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    vm.totalOperationUsers = payload.title.data.totalCount;
                    vm.dataLength = payload.title.data.totalCount;

                    if (payload.title.data.totalCount == 0) {
                        vm.sp_pagination = false;
                        vm.tBodyFlag = false;
                        vm.tFootFlag = true;
                        vm.filterOn = true;
                        vm.skipValueFilter = 0;
                    } else {
                        vm.sp_pagination = true;
                        vm.tBodyFlag = true;
                        vm.tFootFlag = false;
                        vm.filterOn = false;
                        vm.skipValueFilter = 0;

                        var dataArray = [];

                        var operationUserList = payload.title.data.result;


                        operationUserList.forEach(function(column) {
                            var d = {};
                            d.admin_id = column.admin_id;
                            d.email = column.email;
                            d.fullName = column.fullName;
                            d.branch = column.region_name;
                            d.point_id= column.point_id;
                            d.point_name= column.point_name;
                            dataArray.push(d);
                        });


                        vm.operationUserList = dataArray;

                        for (var i = 0; i < vm.operationUserList.length; i++) {
                            vm.operationUserList[i].index = (skip + i);
                        }
                        if (vm.dataLength <= vm.itemsPerPageGot) {
                            vm.sp_pagination = false;
                        } else {
                            vm.sp_pagination = true;
                            //vm.pageCount(payload.title.data.totalCount);
                        }
                        vm.skipValue = vm.operationUserList[0].index;
                        vm.limitValue = vm.operationUserList[vm.operationUserList.length - 1].index;

                        $scope.$watch('vm.search', function(newVal, oldVal) {
                            vm.filtered = filterFilter(vm.operationUserList, newVal);
                            vm.totalItems = vm.filtered.length;
                            if (vm.filtered.length == 0) {
                                vm.watchPagination = false;
                            } else {
                                vm.watchPagination = true;
                            }
                            if (vm.filterOn == true) {
                                vm.skipValueFilter = vm.filtered.length;
                                vm.sp_pagination = false;
                            }
                        }, true);

                        //range();
                    }
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };

        //================sorting====================
        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            vm.filterOn = true;
            if (vm.search.length == 0) {
                vm.filterOn = false;
                vm.watchPagination = true;
                vm.sp_pagination = true;
            }
        };

        //=======================function to add to operation  point==================
        function changeToOperationPoint(data,$event){
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = 10;
            dataSend.offset = 0;
            var promise = getOperationPoint.getOperation(dataSend);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    var opData = [];
                    for(var i=0;i<payload.title.data.result.length;i++){
                        if(payload.title.data.result[i].status){
                            if(data.point_id == payload.title.data.result[i].point_id){
                                payload.title.data.result[i].selected = true;
                                payload.title.data.result[i].color = 'grey';
                            }
                            else{
                                payload.title.data.result[i].selected = false;
                                payload.title.data.result[i].color = 'white';
                            }
                            opData.push(payload.title.data.result[i]);
                        }
                    }
                    openPopUpForAdding(data,opData,$event,payload.title.data.totalCount);

                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        }

        function openPopUpForAdding(data,opData,$event,total){
            vm.items = {
                adminData: data,
                opData: opData,
                skip: 0,
                limit: 10,
                errorNotSelected: false,
                search: '',
                selectedOp: '',
                totalCount: total,
                editData: true
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/addEditToOperationPoint.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: AddToOperationPoint
            });
            function AddToOperationPoint($scope, $mdDialog, items) {
                $scope.items = items;
                var filterTextTimeout = '';
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    if(!$scope.items.selectedOp){
                        $scope.items.errorNotSelected = true;
                        $timeout(function(){
                            $scope.items.errorNotSelected = false;
                        },2000);
                        return;
                    }
                    $mdDialog.hide();
                    changeAdminToOperationHit($scope.items);
                };

                $scope.paginationChanged = function(){
                    if($scope.items.totalCount != $scope.items.opData.length){
                        $scope.items.skip = $scope.items.skip + $scope.items.limit;
                        $scope.getNewOperation();
                    }
                };

                $scope.getSearchedResult = function(){
                    $scope.items.limit = 10;
                    $scope.items.skip = 0;
                    if($scope.items.search){
                        if (filterTextTimeout) $timeout.cancel(filterTextTimeout);
                        filterTextTimeout = $timeout(function(){
                            $scope.getNewOperation(1);
                        },500);
                    }
                    else{
                        $scope.items.opData = [];
                        $scope.getNewOperation();
                    }
                };

                $scope.selectParticularOperation = function(index,data){
                    $scope.items.selectedOp = data;
                };

                $scope.getNewOperation = function(search){
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.limit = $scope.items.limit;
                    dataSend.offset = $scope.items.skip;
                    if(search){
                        dataSend.search_filter = 1;
                        dataSend.search_value = $scope.items.search;
                    }
                    var promise = getOperationPoint.getOperation(dataSend);
                    promise.then(
                        function(payload) {
                            $log.log(payload);
                            //vm.loading = false;
                            if(search){
                                $scope.items.opData = [];
                                for(var i=0;i<payload.title.data.result.length;i++){
                                    if(payload.title.data.result[i].status){
                                        if($scope.items.adminData.point_id == payload.title.data.result[i].point_id){
                                            payload.title.data.result[i].selected = true;
                                            payload.title.data.result[i].color = 'grey';
                                        }
                                        else{
                                            payload.title.data.result[i].selected = false;
                                            payload.title.data.result[i].color = 'white';
                                        }
                                        $scope.items.opData.push(payload.title.data.result[i]);
                                    }
                                }
                            }
                            else{
                                for(var i=0;i<payload.title.data.result.length;i++){
                                    if(payload.title.data.result[i].status){
                                        if($scope.items.adminData.point_id == payload.title.data.result[i].point_id){
                                            payload.title.data.result[i].selected = true;
                                            payload.title.data.result[i].color = 'grey';
                                        }
                                        else{
                                            payload.title.data.result[i].selected = false;
                                            payload.title.data.result[i].color = 'white';
                                        }
                                        $scope.items.opData.push(payload.title.data.result[i]);
                                    }
                                }
                            }
                        },
                        function(errorPayload) {
                            $log.log(errorPayload);
                            //vm.loading = false;
                            if(errorPayload.data.status == 401){
                                errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                            }
                            else{
                                errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                            }
                        }
                    );
                }
            }
        }

        function changeAdminToOperationHit(data){
            vm.loading = true;
            var dataToSend = {};
            dataToSend.access_token = $cookies.get('obj');
            dataToSend.admin_id = data.adminData.admin_id;
            dataToSend.point_id = data.selectedOp.point_id;
            var promise = getOperationPoint.changeUserToOperation(dataToSend);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if(payload.title.status == 200){
                        languageBasedErrorFactory.getProperErrorMessage('operationPointChangeSucc',0,1,'layout.operationPointUserMain.operationPointUser');
                    }else{
                        errorMessageFactory.showErrorMessage(payload.title.message,0);
                    }
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        }
    }
})();

/**
 * Created by cl-macmini-51 on 07/02/18.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('OperationPointViewController', OperationPointViewController);

    /** @ngInject */
    function OperationPointViewController($cookies, $state, $log, $rootScope, $timeout, $scope, filterFilter, $mdDialog, $document,getGeofence,getServices,hidePublicPlaces,languageBasedErrorFactory,errorMessageFactory,getOperationPoint,$stateParams) {
        var vm = this;
        vm.loading = false;
        vm.dataToFill = {};
        vm.goBack = goBack;


        // ================get single operation=================
        function getSingleOperation(){
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.point_id = $stateParams.id;
            var promise = getOperationPoint.getOperation(dataSend);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;

                    vm.dataToFill = payload.title.data.result[0];
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        }
        getSingleOperation();

         // =====================get Address ============================
         function getAddressApi(){
            vm.loading = true;
            var dataSend = {};
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.point_id = $stateParams.id;
            var promise = getOperationPoint.getAddress(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if(payload.title.status == 200){
                        vm.addressArray = payload.title.data.final_data;
                        if(vm.addressArray.length == 8){
                            vm.addressButton = false;
                        }
                    }
                    // $mdDialog.hide();
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );

        };
        getAddressApi();

           // =====================get Agrreement ============================
           function getAgreementApi() {
            vm.loading = true;
            var dataSend = {};
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.point_id = $stateParams.id;
            // dataSend.contract_id = vm.contract_id_to_send;
            var promise = getOperationPoint.getAgreement(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        vm.agreementArray = payload.title.data.finalData;
                        if(vm.agreementArray.length == 6){
                            vm.agrrementButton = false;
                        }
                    }
                    // $mdDialog.hide();
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );

        };
        getAgreementApi();

        //==============================go back========================
        function goBack(){
            $state.go('layout.operationPointMain.operationPoint');
        }
        

    }
})();

/**
 * Created by cl-macmini-51 on 07/02/18.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('OperationPointRegisterController', OperationPointRegisterController);

    /** @ngInject */
    function OperationPointRegisterController($cookies, $state, getAgreement, getCorporate, checkDomain, $log, $rootScope, $timeout, $scope, filterFilter, $mdDialog, $document, getGeofence, getServices, hidePublicPlaces, languageBasedErrorFactory, errorMessageFactory, getOperationPoint, $stateParams, Initializer) {
        var vm = this;
        vm.loading = false;
        vm.agrrementButton = true;
        vm.addressButton = true;
        vm.dataToFill = {
            pointName: '',
            comission: '',
            pointName1: '',
            branch: '',
            pickUpDefault: '',
            lattitude: '',
            longitude: '',
            services: []
        };
        vm.domain = '';
        vm.openPopUpForAdding = openPopUpForAdding;
        vm.openPopUpForAgrrement = openPopUpForAgrrement;
        vm.employeePopUp = employeePopUp;
        vm.goBack = goBack;

        vm.deleteAddress = deleteAddress;
        vm.deleteAgrrement = deleteAgrrement;
        vm.defaultService = defaultService;
        vm.registerApi = registerApi;
        vm.openPopUpForAgrrementMain = openPopUpForAgrrementMain;
        vm.basicDetails = false;
        vm.mapFn = mapFn;

        // Service To Get Map Instance
        Initializer.mapsInitialized
            .then(function () {
                console.log('>>>> GOOGLE INIT', google);
                if (google) {
                    var input = document.getElementById('pickAddress');
                    google.maps.event.addDomListener(input, 'keydown', function (event) {
                        if (event.keyCode === 13) {
                            event.preventDefault();
                        }
                    });

                } else {
                    alert(languageBasedErrorFactory.getProperErrorMessage('onRoadMessage', 0, '3'));
                }

            });

        function mapFn(data) {
            $scope.address = hidePublicPlaces.formattedAddress(data);
            $scope.lat = data.geometry.location.lat();
            $scope.lng = data.geometry.location.lng();
            var string = data.formatted_address;
            var address = string.replace(", Chile", " ");
            // vm.dataToFill.pickUpAddress = address;
            vm.dataToFill.pickUpDefault = address;
            vm.dataToFill.pickUpDefault1 = address;
            vm.dataToFill.lattitude = $scope.lat;
            vm.dataToFill.longitude = $scope.lng;
            // ********** TO GET CITY OF ADDRESS **********
            data.address_components.forEach(function (component) {
                if (component.types[0] == 'locality') {
                    vm.addressComuna = component.long_name || null;
                }
            });

            $scope.$apply();
        }

        //====================get branch list====================
        function getBranch() {
            //vm.loading = true;
            var promise = getGeofence.branch();
            promise.then(
                function (payload) {
                    $log.log(payload);
                    //vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        // initAutocomplete();
                        var where = _.where(payload.title.data, {
                            parent_id: 0
                        });
                        vm.branchList = _.where(where, {
                            is_active: 1
                        });
                        vm.branchList = where;
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        getBranch();

        //======================get all services==============
        function getAllServices(skip, limit) {
            //vm.loading = false;
            var promise = getServices.allServices(skip, limit, 2, 0);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    //vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.service = [];
                        angular.forEach(payload.title.data.result, function (column) {
                            if (column.status == 1) {
                                vm.service.push({
                                    id: column.id,
                                    name: column.service_name,
                                    default: 0
                                });
                            }
                        });
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllServices(0, 0);




        function openPopUpForAgrrementMain($event) {
            if (vm.basicDetails == false) {
                errorMessageFactory.showErrorMessage('Please fill basic details first', 0);
                return false;
            }
            vm.items = {
                agreementName: vm.agreementName,
                // cName: vm.items.cName
            };

            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/addAgrrement.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: AddToOperationPointRegester,
                multiple: true,
            });

            function AddToOperationPointRegester($scope, $mdDialog, items) {
                $scope.items = items;
                var filterTextTimeout = '';
                $scope.closeDialog = function () {

                    vm.items = {
                        agreementName: '',
                    };
                    // $scope.$apply();
                    $mdDialog.hide();
                    $state.reload();
                };

                function stopRKey(evt) {
                    var evt = (evt) ? evt : ((event) ? event : null);
                    var node = (evt.target) ? evt.target : ((evt.srcElement) ? evt.srcElement : null);
                    if ((evt.keyCode == 13) && (node.type == "text")) {
                        return false;
                    }
                }

                document.onkeypress = stopRKey;
                $scope.confirmUpload = function () {
                    // if (vm.customer_id == undefined || vm.customer_id == null) {
                    //     errorMessageFactory.showErrorMessage('Seleccione cliente válido', 0);
                    //     return false;
                    // }
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    // dataSend.point_name = vm.dataToFill.pointName;
                    dataSend.point_id = vm.point_id_to_send;
                    dataSend.customer_id = vm.customer_id;
                    dataSend.contract_id = vm.contract_id_to_send;

                    var promise = getOperationPoint.addAgrrement(dataSend);
                    promise.then(
                        function (payload) {
                            vm.loading = false;
                            $log.log(payload);
                            $mdDialog.hide();
                            if (payload.title.status == 200) {
                                // getAgreementApi();
                                $state.reload();

                            } else {
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            }

                            //  vm.operation = payload.title.data.result;
                            // getAddressApi();
                            // languageBasedErrorFactory.getProperErrorMessage('operationEditSuccess', 0, 2, 'layout.operationPointMain.operationPoint');
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                };

                $scope.openPopUpForAgrrement = function () {
                    openPopUpForAgrrement($event);
                }

                $scope.searchCustomer = function (data) {
                    if (vm.contract_id_to_send == undefined) {
                        openPopUpForAgrrement($event);
                        return false;

                    }
                    if (data) {
                        //return vm.allCustomersList;
                        var dataSend = {};
                        dataSend.access_token = $cookies.get('obj');
                        dataSend.search_value = data.toString();
                        dataSend.contract_id = vm.contract_id_to_send;
                        if (vm.agreement_type == 'SPOT') {
                            dataSend.spot_flag = 1;
                        } else {
                            dataSend.spot_flag = 0;
                        }
                        var promise = getOperationPoint.searchCustomer(dataSend);
                        return promise.then(
                            function (payload) {
                                $log.log('sxdsads', payload);
                                vm.loading = false;
                                if (payload.title.status == 400) {
                                    // errorMessageFactory.showErrorMessage(payload.title.message, 0);
                                    return [];
                                } else if (payload.title.status == 401) {
                                    // errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                                    return [];
                                } else if (payload.title.status == 201 || payload.title.status == 200) {

                                    if (payload) {
                                        $scope.onSelectingCustomer = function ($event) {
                                            vm.customer_id = items.cName.customer_id;
                                        }
                                        return payload.title.data.final_data;
                                    } else {
                                        return [];
                                    }
                                }
                            },
                            function (errorPayload) {
                                $log.log(errorPayload);
                                vm.loading = false;
                                if (errorPayload.data.status == 401) {
                                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                                } else {
                                    //errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                                }
                            }
                        );
                    } else {
                        return [];
                    }
                    // searchCustomer(data);
                }


            }
        }


        //=================default service=========================
        function defaultService(data) {
            if (data) {
                for (var i = 0; i < vm.dataToFill.services.length; i++) {
                    if (vm.dataToFill.services[i].id == data) {
                        vm.dataToFill.services[i].default = 1;
                    }
                }
            }
        }

        // =====================delete Address ============================
        function deleteAddress(data, $event) {
            var confirm = $mdDialog.confirm()
                .title('¿Desea eliminar esta dirección?')
                // .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok('Confirmar')
                .cancel('Cerca');

            $mdDialog.show(confirm).then(function () {
                vm.loading = true;
                var dataSend = {};
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.point_id = data.point_id;
                dataSend.address_id = data.address_id;
                var promise = getOperationPoint.deleteAddress(dataSend);
                promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        if (payload.title.status == 200) {
                            vm.loading = true;
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                        // $mdDialog.hide();
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        //vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        }



        // =====================delete Agrrement ============================
        function deleteAgrrement(data, $event) {
            var confirm = $mdDialog.confirm()
                .title('¿Desea eliminar este Acuerdo?')
                // .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok('Confirmar')
                .cancel('Cerca');

            $mdDialog.show(confirm).then(function () {
                vm.loading = true;
                var dataSend = {};
                // var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.point_id = data.point_id;
                dataSend.default_customer_id = data.default_customer_id;
                var promise = getOperationPoint.deleteAgreement(dataSend);
                promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        if (payload.title.status == 200) {
                            vm.loading = false;
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            $state.reload();

                        }
                        // $mdDialog.hide();
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        //vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        }


        // =====================get Address ============================
        function getAddressApi() {
            vm.loading = true;
            var dataSend = {};
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.point_id = vm.point_id_to_send;
            var promise = getOperationPoint.getAddress(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        vm.addressArray = payload.title.data.final_data;
                        if (vm.addressArray.length == 8) {
                            vm.addressButton = false;
                        }
                    }
                    // $mdDialog.hide();
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );

        };




        function openPopUpForAdding($event) {
            if (vm.basicDetails == false) {
                errorMessageFactory.showErrorMessage('Please fill basic details first', 0);
                return false;
            }
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/addOperationPointRegesiter.html',
                locals: {
                    items: ''
                },
                bindToController: true,
                controller: AddToOperationPointRegester
            });

            function AddToOperationPointRegester($scope, $mdDialog, items) {
                $scope.items = items;
                var filterTextTimeout = '';
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };

                function stopRKey(evt) {
                    var evt = (evt) ? evt : ((event) ? event : null);
                    var node = (evt.target) ? evt.target : ((evt.srcElement) ? evt.srcElement : null);
                    if ((evt.keyCode == 13) && (node.type == "text")) {
                        return false;
                    }
                }

                document.onkeypress = stopRKey;
                $scope.confirmUpload = function () {
                    if (vm.dataToFill.pickUpDefault1 == undefined || vm.dataToFill.pickUpDefault1 == null) {
                        errorMessageFactory.showErrorMessage('Seleccione una dirección válida', 0);
                        return false;
                    }

                    vm.loading = true;
                    var dataSend = {};
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.point_id = vm.point_id_to_send;
                    dataSend.address_name = $scope.items.pointName1;
                    dataSend.direction_name = vm.dataToFill.pickUpDefault1;
                    dataSend.communa = vm.addressComuna;
                    dataSend.latitude = vm.dataToFill.lattitude;
                    dataSend.longitude = vm.dataToFill.longitude;
                    var promise = getOperationPoint.addAddress(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            vm.loading = false;
                            if (payload.title.status == 200) {
                                getAddressApi();
                            } else {
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            }
                            $mdDialog.hide();

                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            //vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );

                };




            }
        }



        //======================get all agreements==============
        function getAllAgreement() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            vm.loading = true;
            var promise = getAgreement.getAgreementListLessData(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.agreement = [];
                        //vm.tableAgreement = [];
                        for (var i = 0; i < payload.title.data.length; i++) {
                            if (payload.title.data[i].status == 1) {
                                vm.agreement.push({
                                    name: payload.title.data[i].name,
                                    id: payload.title.data[i].id
                                });

                            }

                            //if(payload.title.data.contracts[i].employee_endowment == 1){
                            //    payload.title.data.contracts[i].color = 'lightgrey';
                            //}
                            //else{
                            //    payload.title.data.contracts[i].color = 'white';
                            //}
                        }
                        vm.agreement.push({
                            id: 'all',
                            name: 'All'
                        });
                    }
                    //vm.tableAgreement = _.where(payload.title.data,{agreement_type:'CORPORATE'});
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllAgreement();


        //==============get all corporate=================
        function getAllCorporate() {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = 0;
            dataSend.offset = 0;
            dataSend.key = 2;
            dataSend.search_filter = 0;
            var promise = getCorporate.allCorporates(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.corporatesList = [];
                    vm.corporatesList = payload.title.data.result;
                    vm.corporatesList.push({
                        id: 'all',
                        company_name: 'All'
                    });
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllCorporate();


        function employeePopUp(data, $event) {
            vm.items = {
                agreement: data,
                tableAgreement: [],
                corporatesList: vm.corporatesList,
                rutFilter: '',
                agreementSelected: 'all',
                corporateSelected: 'all',
                finalAgreement: '',
                errorMsg: false,
                rutInvalid: false,
                loading: false,
                agreementToSend: [],
                limit: 10,
                offset: 0,
                totalCount: 0,
                backgroundColor: 'grey'
            }

            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/addOperationPointAgreement.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: AddEndowmentController
            });

            function AddEndowmentController($scope, $mdDialog, items) {
                $scope.items = items;
                var dataGet = [];
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    if ($scope.items.agreementToSend.length == 0) {
                        $scope.items.errorMsg = true;
                        $timeout(function () {
                            $scope.items.errorMsg = false;
                        }, 2000);
                    } else {
                        $mdDialog.hide();
                        vm.loading = true;
                        var dataSend = {};
                        dataSend.access_token = $cookies.get('obj');
                        dataSend.contract_id = $scope.items.agreementToSend.contract_id;
                        var promise = getCorporate.allCorporates(dataSend);
                        promise.then(
                            function (payload) {
                                $log.log('sxdsads', payload);
                                vm.loading = false;
                                if (payload.title.status == 200) {

                                } else {
                                    errorMessageFactory.showErrorMessage(payload.title.message, 0);
                                }
                            },
                            function (errorPayload) {
                                vm.loading = false;
                                if (errorPayload.data.status == 401) {
                                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                                } else {
                                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                                }
                            }
                        );

                    }

                };





            }
        }
        // function openPopUpForAgrrement($event){
        function openPopUpForAgrrement($event) {
            vm.items = {
                agreement: vm.agreement,
                tableAgreement: [],
                corporatesList: vm.corporatesList,
                rutFilter: '',
                agreementSelected: 'all',
                corporateSelected: 'all',
                finalAgreement: '',
                errorMsg: false,
                rutInvalid: false,
                loading: false,
                agreementToSend: [],
                limit: 10,
                offset: 0,
                totalCount: 0,
                backgroundColor: 'grey'
            }

            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/addOperationPointAgreement.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: AddEndowmentController
            });

            function AddEndowmentController($scope, $mdDialog, items) {
                $scope.items = items;

                var dataGet = [];
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    vm.agreement_type = $scope.items.agreementToSend.agreement_type;
                    vm.contract_id_to_send = $scope.items.agreementToSend.contract_id;
                    vm.agreementName = $scope.items.agreementToSend.name;
                    $mdDialog.hide();
                    openPopUpForAgrrementMain($event);
                };
                $scope.selectParticularEndowment = function (index) {
                    $scope.items.agreementToSend = $scope.items.tableAgreement[index];

                }
                $scope.rutChange = function () {
                    if ($scope.items.rutFilter) {
                        if (RutHelper.validate($scope.items.rutFilter)) {
                            $log.log();
                            $scope.items.rutInvalid = false;
                        } else {
                            $scope.items.rutInvalid = true;
                        }
                    } else if ($scope.items.rutFilter === null) {
                        $scope.items.rutInvalid = true;
                    } else if ($scope.items.rutFilter === undefined) {
                        $scope.items.rutInvalid = false;
                    }
                }

                $scope.paginationChanged = function () {
                    if ($scope.items.totalCount != $scope.items.tableAgreement.length) {
                        $scope.items.offset = $scope.items.offset + $scope.items.limit;
                        $scope.getFilterDataForEndowment();
                    }
                }

                $scope.getFilterChange = function () {
                    $scope.items.tableAgreement = [];
                    dataGet = [];
                    $scope.items.offset = 0;
                    $scope.items.limit = 10;
                }

                $scope.getFilterDataForEndowment = function () {
                    if ($scope.items.rutInvalid) {
                        return;
                    }
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.limit = $scope.items.limit;
                    dataSend.offset = $scope.items.offset;
                    dataSend.all_agreement_flag = 1;
                    if ($scope.items.agreementSelected && $scope.items.agreementSelected != 'all') {
                        dataSend.agreement_id = Number($scope.items.agreementSelected);
                        $scope.items.tableAgreement = [];
                        dataGet = [];
                    }
                    if ($scope.items.corporateSelected && $scope.items.corporateSelected != 'all') {
                        dataSend.corporate_id = Number($scope.items.corporateSelected);
                        $scope.items.tableAgreement = [];
                        dataGet = [];
                    }

                    if ($scope.items.rutFilter) {
                        dataSend.corporate_rut = RutHelper.clean($scope.items.rutFilter);
                        $scope.items.tableAgreement = [];
                        dataGet = [];
                    }
                    $scope.items.loading = true;
                    var promise = getAgreement.getAgreementListLessDataWithFilters(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            $scope.items.loading = false;
                            for (var i = 0; i < payload.title.data.contracts.result.length; i++) {
                                payload.title.data.contracts.result[i].selected = false;
                                if (payload.title.data.contracts.result[i].employee_endowment == 1) {
                                    payload.title.data.contracts.result[i].color = 'lightgrey';
                                } else {
                                    payload.title.data.contracts.result[i].color = 'white';
                                }
                                dataGet.push(payload.title.data.contracts.result[i]);
                            }
                            $scope.items.totalCount = payload.title.data.contracts.totalCount;
                            $scope.items.tableAgreement = _.where(dataGet, {
                                // agreement_type: 'CORPORATE'
                            });
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            $scope.items.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }
                $scope.getFilterDataForEndowment();
            }
        }


        // =====================get Agrreement ============================
        function getAgreementApi() {
            vm.loading = true;
            var dataSend = {};
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.point_id = vm.point_id_to_send;
            // dataSend.contract_id = vm.contract_id_to_send;
            var promise = getOperationPoint.getAgreement(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        vm.agreementArray = payload.title.data.finalData;
                        if (vm.agreementArray.length == 6) {
                            vm.agrrementButton = false;
                        }
                    }
                    // $mdDialog.hide();
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );

        };

        function getSingleOperation() {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.point_id = $stateParams.id;
            var promise = getOperationPoint.getOperation(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;

                    vm.dataToFill.pointName = payload.title.data.result[0].point_name;
                    vm.dataToFill.comission = payload.title.data.result[0].percentage;
                    vm.dataToFill.branch = payload.title.data.result[0].branch_id;
                    vm.dataToFill.pickUpDefault = payload.title.data.result[0].address;
                    vm.dataToFill.lattitude = payload.title.data.result[0].latitude;
                    vm.dataToFill.longitude = payload.title.data.result[0].longtitude;
                    vm.dataToFill.id = payload.title.data.result[0].point_id;
                    for (var i = 0; i < payload.title.data.result[0].services.length; i++) {
                        vm.dataToFill.services.push(Number(payload.title.data.result[0].services[i].service_type_id));
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }







        //=====================register api===================
        function registerApi() {
            if (vm.dataToFill.comission > 100) {
                languageBasedErrorFactory.getProperErrorMessage('percentageComissionErr', 0, 0);
                return;
            }
            if (!vm.dataToFill.lattitude && !vm.dataToFill.longitude) {
                languageBasedErrorFactory.getProperErrorMessage('addressError', 0, 0);
                return;

            }
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.point_name = vm.dataToFill.pointName;
            dataSend.percentage = vm.dataToFill.comission;
            dataSend.point_address = vm.dataToFill.pickUpDefault;
            dataSend.communa = vm.addressComuna || null;
            dataSend.lat = vm.dataToFill.lattitude;
            dataSend.long = vm.dataToFill.longitude;
            dataSend.branch = vm.dataToFill.branch;
            dataSend.service_type_id = vm.dataToFill.services;

            var promise = getOperationPoint.registerOperation(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    if (payload.title && payload.title.data && payload.title.data.finaldata)
                        vm.point_id_to_send = payload.title.data.finaldata.point_id;
                    vm.loading = false;
                    //  vm.operation = payload.title.data.result;
                    vm.basicDetails = true;
                    getAddressApi();
                    getAgreementApi();
                    // getSingleOperation();
                    // getBranch();
                    // getAllServices(0,0);
                    // getAllAgreement();
                    // getAllCorporate();
                    errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    // languageBasedErrorFactory.getProperErrorMessage('operationSuccess',0,2,'layout.operationPointMain.operationPoint');

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        //==============================go back========================
        function goBack() {
            $state.go('layout.operationPointMain.operationPoint');
        }


    }
})();
/**
 * Created by cl-macmini-51 on 07/02/18.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('OperationPointEditController', OperationPointEditController);

    /** @ngInject */
    function OperationPointEditController($cookies, $state, getAgreement, getCorporate, checkDomain, $log, $rootScope, $timeout, $scope, filterFilter, $mdDialog, $document, getGeofence, getServices, hidePublicPlaces, languageBasedErrorFactory, errorMessageFactory, getOperationPoint, $stateParams, Initializer) {
        var vm = this;
        vm.loading = false;
        vm.agrrementButton = true;
        vm.addressButton = true;
        // vm.mapFn1 = mapFn1;
        vm.dataToFill = {
            pointName: '',
            comission: '',
            branch: '',
            pickUpDefault: '',
            lattitude: '',
            longitude: '',
            id: '',
            services: []
        };
        vm.domain = checkDomain.getDomainName();
        vm.flagId = false;
        vm.openPopUpForAdding = openPopUpForAdding;
        vm.deleteAddress = deleteAddress;
        vm.openPopUpForAgrrement = openPopUpForAgrrement;
        vm.goBack = goBack;
        vm.mapFn = mapFn;
        vm.defaultService = defaultService;
        vm.editApi = editApi;
        $scope.states = searchCustomer;
        vm.deleteAgrrement = deleteAgrrement;
        vm.openPopUpForAgrrementMain = openPopUpForAgrrementMain;

        // Service To Get Map Instance
        Initializer.mapsInitialized
            .then(function () {
                if (google) {
                    //==================map function=======================
                    var input = document.getElementById('pickAddress');
                    google.maps.event.addDomListener(input, 'keydown', function (event) {
                        if (event.keyCode === 13) {
                            event.preventDefault();
                        }
                    });

                } else {
                    alert(languageBasedErrorFactory.getProperErrorMessage('googleNotDefined', 0, '3'));
                }

            });

        // ================get single operation=================
        function getSingleOperation() {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.point_id = $stateParams.id;
            var promise = getOperationPoint.getOperation(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;

                    vm.dataToFill.pointName = payload.title.data.result[0].point_name;
                    vm.dataToFill.comission = payload.title.data.result[0].percentage;
                    vm.dataToFill.branch = payload.title.data.result[0].branch_id;
                    vm.dataToFill.pickUpDefault = payload.title.data.result[0].address;
                    vm.addressComuna = payload.title.data.result[0].communa || null;
                    vm.dataToFill.lattitude = payload.title.data.result[0].latitude;
                    vm.dataToFill.longitude = payload.title.data.result[0].longtitude;
                    vm.dataToFill.id = payload.title.data.result[0].point_id;
                    getAddressApi();
                    getAgreementApi();
                    for (var i = 0; i < payload.title.data.result[0].services.length; i++) {
                        vm.dataToFill.services.push(Number(payload.title.data.result[0].services[i].service_type_id));
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        getSingleOperation();


        // var input = document.getElementById('dropOffAddress');
        // google.maps.event.addDomListener(input, 'keydown', function (event) {
        //     if (event.keyCode === 13) {
        //         event.preventDefault();
        //     }
        // });

        // =====================delete Address ============================
        function deleteAddress(data, $event) {
            var confirm = $mdDialog.confirm()
                .title('¿Desea eliminar esta dirección?')
                // .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok('Confirmar')
                .cancel('Cerca');

            $mdDialog.show(confirm).then(function () {
                vm.loading = true;
                var dataSend = {};
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.point_id = data.point_id;
                dataSend.address_id = data.address_id;
                var promise = getOperationPoint.deleteAddress(dataSend);
                promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        if (payload.title.status == 200) {
                            vm.loading = false;
                            // errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            $state.reload();
                        }
                        // $mdDialog.hide();
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        //vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        }

        // ====================== Search customer ==============

        function searchCustomer(data) {
            if (data) {
                //return vm.allCustomersList;
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.search_value = data.toString();
                dataSend.contract_id = vm.contract_id_to_send;

                var promise = getOperationPoint.searchCustomer(dataSend);
                return promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        if (payload.title.status == 400) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            return [];
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                            return [];
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            if (payload)
                                return payload.title.data.final_data;
                            else return [];
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            //errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                        }
                    }
                );
            } else {
                return [];
            }
        };



        //====================get branch list====================
        function getBranch() {
            //vm.loading = true;
            var promise = getGeofence.branch();
            promise.then(
                function (payload) {
                    $log.log(payload);
                    //vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        var where = _.where(payload.title.data, {
                            parent_id: 0
                        });
                        vm.branchList = _.where(where, {
                            is_active: 1
                        });
                        vm.branchList = where;
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        getBranch();

        //======================get all services==============
        function getAllServices(skip, limit) {
            //vm.loading = false;
            var promise = getServices.allServices(skip, limit, 2, 0);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    //vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.service = [];
                        angular.forEach(payload.title.data.result, function (column) {
                            if (column.status == 1) {
                                vm.service.push({
                                    id: column.id,
                                    name: column.service_name,
                                    default: 0
                                });
                            }
                        });
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllServices(0, 0);




        // =====================delete Agrrement ============================
        function deleteAgrrement(data, $event) {
            var confirm = $mdDialog.confirm()
                .title('¿Desea eliminar este Acuerdo?')
                // .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok('Confirmar')
                .cancel('Cerca');

            $mdDialog.show(confirm).then(function () {
                vm.loading = true;
                var dataSend = {};
                // var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.point_id = data.point_id;
                dataSend.default_customer_id = data.default_customer_id;
                var promise = getOperationPoint.deleteAgreement(dataSend);
                promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        if (payload.title.status == 200) {
                            vm.loading = false;
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            $state.reload();

                        }
                        // $mdDialog.hide();
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        //vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        }

        // =====================get Address ============================
        function getAddressApi() {
            vm.loading = true;
            var dataSend = {};
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.point_id = vm.dataToFill.id;
            var promise = getOperationPoint.getAddress(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        vm.addressArray = payload.title.data.final_data;
                        if (vm.addressArray.length == 8) {
                            vm.addressButton = false;
                        }
                    }
                    // $mdDialog.hide();
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );

        };


        // =====================get Agrreement ============================
        function getAgreementApi() {
            vm.loading = true;
            var dataSend = {};
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.point_id = vm.dataToFill.id;
            // dataSend.contract_id = vm.contract_id_to_send;
            var promise = getOperationPoint.getAgreement(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        vm.agreementArray = payload.title.data.finalData;
                        if (vm.agreementArray.length == 6) {
                            vm.agrrementButton = false;
                        }
                    }
                    // $mdDialog.hide();
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );

        };




        function openPopUpForAdding($event) {
            if (vm.basicDetails == false) {
                errorMessageFactory.showErrorMessage('Please fill basic details first', 0);
                return false;
            }
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/addOperationPointRegesiter.html',
                locals: {
                    items: ''
                },
                bindToController: true,
                controller: AddToOperationPointRegester
            });

            function AddToOperationPointRegester($scope, $mdDialog, items) {
                $scope.items = items;
                var filterTextTimeout = '';
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.mapFn1 = function (data) {
                    mapFn1(data);
                }

                function stopRKey(evt) {
                    var evt = (evt) ? evt : ((event) ? event : null);
                    var node = (evt.target) ? evt.target : ((evt.srcElement) ? evt.srcElement : null);
                    if ((evt.keyCode == 13) && (node.type == "text")) {
                        return false;
                    }
                }

                document.onkeypress = stopRKey;
                $scope.confirmUpload = function () {
                    if (vm.dataToFill.pickUpDefault1 == undefined || vm.dataToFill.pickUpDefault1 == null) {
                        errorMessageFactory.showErrorMessage('Seleccione una dirección válida', 0);
                        return false;
                    }

                    vm.loading = true;
                    var dataSend = {};
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.point_id = vm.dataToFill.id;
                    dataSend.address_name = $scope.items.pointName1;
                    dataSend.direction_name = vm.dataToFill.pickUpDefault1;
                    dataSend.communa = vm.addressComuna || null;
                    dataSend.latitude = vm.dataToFill.lattitude;
                    dataSend.longitude = vm.dataToFill.longitude;
                    var promise = getOperationPoint.addAddress(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);

                            vm.loading = false;
                            if (payload.title.status == 200) {
                                getAddressApi();
                            } else {
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            }

                            $mdDialog.hide();

                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            //vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );

                };




            }
        }






        //======================get all agreements==============
        function getAllAgreement() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            vm.loading = true;
            var promise = getAgreement.getAgreementListLessData(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.agreement = [];
                        //vm.tableAgreement = [];
                        for (var i = 0; i < payload.title.data.length; i++) {
                            if (payload.title.data[i].status == 1) {
                                vm.agreement.push({
                                    name: payload.title.data[i].name,
                                    id: payload.title.data[i].id
                                });

                            }

                            //if(payload.title.data.contracts[i].employee_endowment == 1){
                            //    payload.title.data.contracts[i].color = 'lightgrey';
                            //}
                            //else{
                            //    payload.title.data.contracts[i].color = 'white';
                            //}
                        }
                        vm.agreement.push({
                            id: 'all',
                            name: 'All'
                        });
                    }
                    //vm.tableAgreement = _.where(payload.title.data,{agreement_type:'CORPORATE'});
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllAgreement();


        //==============get all corporate=================
        function getAllCorporate() {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = 0;
            dataSend.offset = 0;
            dataSend.key = 2;
            dataSend.search_filter = 0;
            var promise = getCorporate.allCorporates(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.corporatesList = [];
                    vm.corporatesList = payload.title.data.result;
                    vm.corporatesList.push({
                        id: 'all',
                        company_name: 'All'
                    });
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllCorporate();



        function openPopUpForAgrrementMain($event) {

            // if (vm.basicDetails == false) {
            //     errorMessageFactory.showErrorMessage('Please fill basic details first', 0);
            //     return false;
            // }
            vm.items = {
                agreementName: vm.agreementName,
                // cName: vm.items.cName
            };

            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/addAgrrement.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: AddToOperationPointRegester,
                multiple: true,
            });

            function AddToOperationPointRegester($scope, $mdDialog, items) {
                $scope.items = items;
                var filterTextTimeout = '';
                $scope.closeDialog = function () {

                    vm.items = {
                        agreementName: '',
                    };
                    // $scope.$apply();
                    $state.reload();
                    $mdDialog.hide();

                };

                function stopRKey(evt) {
                    var evt = (evt) ? evt : ((event) ? event : null);
                    var node = (evt.target) ? evt.target : ((evt.srcElement) ? evt.srcElement : null);
                    if ((evt.keyCode == 13) && (node.type == "text")) {
                        return false;
                    }
                }

                document.onkeypress = stopRKey;
                $scope.confirmUpload = function () {
                    // if (vm.customer_id == undefined || vm.customer_id == null) {
                    //     errorMessageFactory.showErrorMessage('Seleccione cliente válido', 0);
                    //     return false;
                    // }
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    // dataSend.point_name = vm.dataToFill.pointName;
                    dataSend.point_id = vm.dataToFill.id;
                    dataSend.customer_id = vm.customer_id;
                    dataSend.contract_id = vm.contract_id_to_send;

                    var promise = getOperationPoint.addAgrrement(dataSend);
                    promise.then(
                        function (payload) {
                            vm.loading = false;
                            $log.log(payload);
                            $mdDialog.hide();
                            if (payload.title.status == 200) {
                                // getAgreementApi();
                                $state.reload();
                            } else {
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            }

                            //  vm.operation = payload.title.data.result;
                            // getAddressApi();
                            // languageBasedErrorFactory.getProperErrorMessage('operationEditSuccess', 0, 2, 'layout.operationPointMain.operationPoint');
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                };

                $scope.openPopUpForAgrrement = function () {
                    openPopUpForAgrrement($event);
                }

                $scope.searchCustomer = function (data) {

                    if (vm.contract_id_to_send == undefined) {
                        openPopUpForAgrrement($event);
                        return false;


                    }
                    if (data) {
                        //return vm.allCustomersList;
                        var dataSend = {};
                        dataSend.access_token = $cookies.get('obj');
                        dataSend.search_value = data.toString();
                        dataSend.contract_id = vm.contract_id_to_send;

                        if (vm.agreement_type == 'SPOT') {
                            dataSend.spot_flag = 1;
                        } else {
                            dataSend.spot_flag = 0;
                        }
                        var promise = getOperationPoint.searchCustomer(dataSend);
                        return promise.then(
                            function (payload) {
                                $log.log('sxdsads', payload);
                                vm.loading = false;
                                if (payload.title.status == 400) {
                                    // errorMessageFactory.showErrorMessage(payload.title.message, 0);
                                    return [];
                                } else if (payload.title.status == 401) {
                                    // errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                                    return [];
                                } else if (payload.title.status == 201 || payload.title.status == 200) {

                                    if (payload) {
                                        $scope.onSelectingCustomer = function ($event) {
                                            vm.customer_id = items.cName.customer_id;
                                        }
                                        return payload.title.data.final_data;
                                    } else {
                                        return [];
                                    }
                                }
                            },
                            function (errorPayload) {
                                $log.log(errorPayload);
                                vm.loading = false;
                                if (errorPayload.data.status == 401) {
                                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                                } else {
                                    //errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                                }
                            }
                        );
                    } else {
                        return [];
                    }
                    // searchCustomer(data);
                }


            }
        }

        // function openPopUpForAgrrement($event){

        function openPopUpForAgrrement($event) {
            vm.items = {
                agreement: vm.agreement,
                tableAgreement: [],
                corporatesList: vm.corporatesList,
                rutFilter: '',
                agreementSelected: 'all',
                corporateSelected: 'all',
                finalAgreement: '',
                errorMsg: false,
                rutInvalid: false,
                loading: false,
                agreementToSend: [],
                limit: 10,
                offset: 0,
                totalCount: 0,
                backgroundColor: 'grey'
            }

            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/addOperationPointAgreement.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: AddEndowmentController
            });

            function AddEndowmentController($scope, $mdDialog, items) {
                $scope.items = items;

                var dataGet = [];
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    vm.agreement_type = $scope.items.agreementToSend.agreement_type;
                    vm.contract_id_to_send = $scope.items.agreementToSend.contract_id;
                    vm.agreementName = $scope.items.agreementToSend.name;
                    $mdDialog.hide();
                    openPopUpForAgrrementMain($event);
                };
                $scope.selectParticularEndowment = function (index) {
                    $scope.items.agreementToSend = $scope.items.tableAgreement[index];

                }
                $scope.rutChange = function () {
                    if ($scope.items.rutFilter) {
                        if (RutHelper.validate($scope.items.rutFilter)) {
                            $log.log();
                            $scope.items.rutInvalid = false;
                        } else {
                            $scope.items.rutInvalid = true;
                        }
                    } else if ($scope.items.rutFilter === null) {
                        $scope.items.rutInvalid = true;
                    } else if ($scope.items.rutFilter === undefined) {
                        $scope.items.rutInvalid = false;
                    }
                }

                $scope.paginationChanged = function () {
                    if ($scope.items.totalCount != $scope.items.tableAgreement.length) {
                        $scope.items.offset = $scope.items.offset + $scope.items.limit;
                        $scope.getFilterDataForEndowment();
                    }
                }

                $scope.getFilterChange = function () {
                    $scope.items.tableAgreement = [];
                    dataGet = [];
                    $scope.items.offset = 0;
                    $scope.items.limit = 10;
                }

                $scope.getFilterDataForEndowment = function () {
                    if ($scope.items.rutInvalid) {
                        return;
                    }
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.limit = $scope.items.limit;
                    dataSend.offset = $scope.items.offset;
                    dataSend.all_agreement_flag = 1;
                    if ($scope.items.agreementSelected && $scope.items.agreementSelected != 'all') {
                        dataSend.agreement_id = Number($scope.items.agreementSelected);
                        $scope.items.tableAgreement = [];
                        dataGet = [];
                    }
                    if ($scope.items.corporateSelected && $scope.items.corporateSelected != 'all') {
                        dataSend.corporate_id = Number($scope.items.corporateSelected);
                        $scope.items.tableAgreement = [];
                        dataGet = [];
                    }

                    if ($scope.items.rutFilter) {
                        dataSend.corporate_rut = RutHelper.clean($scope.items.rutFilter);
                        $scope.items.tableAgreement = [];
                        dataGet = [];
                    }
                    $scope.items.loading = true;
                    var promise = getAgreement.getAgreementListLessDataWithFilters(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            $scope.items.loading = false;
                            for (var i = 0; i < payload.title.data.contracts.result.length; i++) {
                                payload.title.data.contracts.result[i].selected = false;
                                if (payload.title.data.contracts.result[i].employee_endowment == 1) {
                                    payload.title.data.contracts.result[i].color = 'lightgrey';
                                } else {
                                    payload.title.data.contracts.result[i].color = 'white';
                                }
                                dataGet.push(payload.title.data.contracts.result[i]);
                            }
                            $scope.items.totalCount = payload.title.data.contracts.totalCount;
                            $scope.items.tableAgreement = _.where(dataGet, {
                                // agreement_type: 'CORPORATE && SPOT'
                            });
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            $scope.items.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }
                $scope.getFilterDataForEndowment();
            }
        }




        function mapFn(data) {
            $scope.address = hidePublicPlaces.formattedAddress(data);
            $scope.lat = data.geometry.location.lat();
            $scope.lng = data.geometry.location.lng();
            var string = data.formatted_address;
            var address = string.replace(", Chile", " ");
            // vm.dataToFill.pickUpAddress = address;
            vm.dataToFill.pickUpDefault = address;
            vm.dataToFill.pickUpDefault1 = address;
            vm.dataToFill.lattitude = $scope.lat;
            vm.dataToFill.longitude = $scope.lng;

            // ********** TO GET CITY OF ADDRESS **********
            data.address_components.forEach(function (component) {
                if (component.types[0] == 'locality') {
                    vm.addressComuna = component.long_name || null;
                }
            });

            $scope.$apply();
        }

        function mapFn1(data) {
            $scope.address = hidePublicPlaces.formattedAddress(data);
            $scope.lat = data.geometry.location.lat();
            $scope.lng = data.geometry.location.lng();
            var string = data.formatted_address;
            var address = string.replace(", Chile", " ");
            // vm.dataToFill.pickUpAddress = address;
            vm.dataToFill.pickUpDefault = address;
            vm.dataToFill.pickUpDefault1 = address;
            vm.dataToFill.lattitude = $scope.lat;
            vm.dataToFill.longitude = $scope.lng;

            // ********** TO GET CITY OF ADDRESS **********
            data.address_components.forEach(function (component) {
                if (component.types[0] == 'locality') {
                    vm.addressComuna = component.long_name || null;
                }
            });

            $scope.$apply();
        }

        //   //==================map function=======================
        //   var input1 = document.getElementById('pickAddress1');
        //   google.maps.event.addDomListener(input1, 'keydown', function (event) {
        //       if (event.keyCode === 13) {
        //           event.preventDefault();
        //       }
        //   });

        //   function mapFn1(data) {
        //       $scope.address = hidePublicPlaces.formattedAddress(data);
        //       $scope.lat = data.geometry.location.lat();
        //       $scope.lng = data.geometry.location.lng();
        //       vm.dataToFill.pickUpDefault = $scope.address;
        //       vm.dataToFill.pickUpDefault1 = $scope.address;
        //       vm.dataToFill.lattitude = $scope.lat;
        //       vm.dataToFill.longitude = $scope.lng;
        //       $scope.$apply();
        //   }

        //=================default service=========================
        function defaultService(data) {
            if (data) {
                for (var i = 0; i < vm.dataToFill.services.length; i++) {
                    if (vm.dataToFill.services[i].id == data) {
                        vm.dataToFill.services[i].default = 1;
                    }
                }
            }
        }

        //=====================edit api===================
        function editApi() {
            if (vm.dataToFill.comission > 100) {
                languageBasedErrorFactory.getProperErrorMessage('percentageComissionErr', 0, 0);
                return;
            }
            if (!vm.dataToFill.lattitude && !vm.dataToFill.longitude) {
                languageBasedErrorFactory.getProperErrorMessage('addressError', 0, 0);
                return;

            }
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.point_name = vm.dataToFill.pointName;
            dataSend.point_id = vm.dataToFill.id;
            dataSend.percentage = vm.dataToFill.comission;
            dataSend.point_address = vm.dataToFill.pickUpDefault;
            dataSend.communa = vm.addressComuna || null;
            dataSend.latitude = vm.dataToFill.lattitude;
            dataSend.longitude = vm.dataToFill.longitude;
            dataSend.branch = vm.dataToFill.branch;
            dataSend.service_type_id = vm.dataToFill.services;

            var promise = getOperationPoint.editOperation(dataSend);
            promise.then(
                function (payload) {
                    vm.loading = false;
                    $log.log(payload);
                    if (payload.title.status == 200) {
                        //  vm.operation = payload.title.data.result;
                        getAddressApi();
                        getAgreementApi();
                        languageBasedErrorFactory.getProperErrorMessage('operationEditSuccess', 0, 2, 'layout.operationPointMain.operationPoint');
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        //==============================go back========================
        function goBack() {
            $state.go('layout.operationPointMain.operationPoint');
        }


    }
})();
/**
 * Created by cl-macmini-51 on 07/02/18.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('OperationPointController', OperationPointController);

    /** @ngInject */
    function OperationPointController($cookies, $state, $log, $rootScope, $timeout, $scope, filterFilter, $mdDialog, $document,languageBasedErrorFactory,errorMessageFactory,getOperationPoint) {
        var vm = this;
        vm.loading = false;
        vm.totalOperationPoints = 0;
        vm.loading = false;
        vm.currentPage = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.getPagesCount = getPagesCount;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.init = init;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.noDataFlag = false;
        vm.predicate = 'index';
        vm.reverse = false;
        vm.sort = sort;
        vm.getOperationPoints = getOperationPoints;
        vm.changeOperationStatus = changeOperationStatus;
        vm.deleteOperationPoints= deleteOperationPoints;
       // vm.changeReasonStatus = changeReasonStatus;
       // vm.editReasonPop = editReasonPop;
       // vm.deleteReason = deleteReason;
        vm.paginationNew = paginationNew;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.filterData = {
            operationStatus: '0'
        };

        //====================function for dropdown pages and page count===============
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];

        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getOperationPoints(0, vm.itemsPerPageGot,vm.filterData);
        };
        function paginationNew(page){
            getOperationPoints((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot,vm.filterData);
        }
        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.noShowReasonMain.noShowReason');
            }
        });
        //=====================add new reason hit=========================
        function getOperationPoints(skip, limit,filter){
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit;
            dataSend.offset = skip;
           // dataSend.status = Number(filter);
            var promise = getOperationPoint.getOperation(dataSend);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    vm.totalOperationPoints = payload.title.data.totalCount;
                    vm.dataLength = payload.title.data.totalCount;

                    if (payload.title.data.totalCount == 0) {
                        vm.sp_pagination = false;
                        vm.tBodyFlag = false;
                        vm.tFootFlag = true;
                        vm.filterOn = true;
                        vm.skipValueFilter = 0;
                    } else {
                        vm.sp_pagination = true;
                        vm.tBodyFlag = true;
                        vm.tFootFlag = false;
                        vm.filterOn = false;
                        vm.skipValueFilter = 0;

                        var dataArray = [];

                        var operationList = payload.title.data.result;


                        operationList.forEach(function(column) {
                            var d = {};
                            d.id = column.point_id;

                            d.pointName = column.point_name;
                            d.commissionPercentage = column.percentage;
                            d.branch = column.region_name;
                            d.address= column.address;
                            d.typeofservice= column.services;
                            d.status = column.status;
                            dataArray.push(d);
                        });


                        vm.operationList = dataArray;

                        for (var i = 0; i < vm.operationList.length; i++) {
                            vm.operationList[i].index = (skip + i);
                        }
                        if (vm.dataLength <= vm.itemsPerPageGot) {
                            vm.sp_pagination = false;
                        } else {
                            vm.sp_pagination = true;
                            //vm.pageCount(payload.title.data.totalCount);
                        }
                        vm.skipValue = vm.operationList[0].index;
                        vm.limitValue = vm.operationList[vm.operationList.length - 1].index;

                        $scope.$watch('vm.search', function(newVal, oldVal) {
                            vm.filtered = filterFilter(vm.operationList, newVal);
                            vm.totalItems = vm.filtered.length;
                            if (vm.filtered.length == 0) {
                                vm.watchPagination = false;
                            } else {
                                vm.watchPagination = true;
                            }
                            if (vm.filterOn == true) {
                                vm.skipValueFilter = vm.filtered.length;
                                vm.sp_pagination = false;
                            }
                        }, true);

                        //range();
                    }
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    } else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        vm.getOperationPoints((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData.noShowStatus);
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        vm.currentPage++;
        //        vm.getOperationPoints((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData.noShowStatus);
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    vm.getOperationPoints((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData.noShowStatus);
        //};

        function init() {
            vm.getOperationPoints(0, vm.searchModel.limit,vm.filterData);
        };
        init();

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            vm.filterOn = true;
            if (vm.search.length == 0) {
                vm.filterOn = false;
                vm.watchPagination = true;
                vm.sp_pagination = true;
            }
        };

        //===========================change operation status=========================
        function changeOperationStatus(id,value,$event){
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('statusOperationPop',0,'3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton',0,'3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton',0,'3'));

            $mdDialog.show(confirm).then(function() {
                var a = '';
                var msgSys = '';
                if (value == 0) {
                    a = 1;
                } else if (value == 1) {
                    a = 0;
                }
                //errorMessageFactory.showErrorMessage('Functionality is pending.',0);
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.status = a;
                dataSend.point_id = id;
                vm.loading = true;
                var promise = getOperationPoint.blockUnblockOperation(dataSend);
                promise.then(
                    function(payload) {
                        $log.log(payload);
                        vm.loading = false;
                        languageBasedErrorFactory.getProperErrorMessage('statusOperationSucc',0,1,'layout.operationPointMain.operationPoint')
                    },
                    function(errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if(errorPayload.data.status == 401){
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                        }
                        else{
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                        }
                    }
                );

            }, function() {
                $log.log('not confirmed');
            });
        };

        //======================delete operation hit===========================
        function deleteOperationPoints(data, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('deleteOperationPop',0,'3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton',0,'3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton',0,'3'));

            $mdDialog.show(confirm).then(function() {
                $log.log('confirmed');
                var dataSend = {
                    access_token: $cookies.get('obj'),
                    point_id: data.id
                };
                //errorMessageFactory.showErrorMessage('Functionality is pending.',0);
                vm.loading = true;
                var promise = getOperationPoint.deleteOperation(dataSend);
                promise.then(
                    function(payload) {
                        $log.log(payload);
                        vm.loading = false;
                        languageBasedErrorFactory.getProperErrorMessage('deleteOperationSucc',0,1,'layout.operationPointMain.operationPoint')
                        //errorMessageFactory.showErrorMessage('Reason deleted successfully.',1);
                    },
                    function(errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if(errorPayload.data.status == 401){
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                        }
                        else{
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                        }
                    }
                );
            }, function() {
                $log.log('not confirmed');
            });
        }


    }
})();

/**
 * Created by cl-macmini-51 on 9/15/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('OnOffDutyController', OnOffDutyController);

    /** @ngInject */
    function OnOffDutyController($cookies, $state, $log, $filter, $rootScope, $mdDialog, $timeout, $document, $scope, filterFilter, getGeofence, moment, getDrivers, errorMessageFactory, languageBasedErrorFactory, pendingRequests, getFilters) {
        var vm = this;
        $log.log('onOffDuty');
        vm.loading = false;
        vm.currentPage = 0;
        vm.totalOnOffList = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.filterTextTimeout = '';
        vm.getAllOnOffDuty = getAllOnOffDuty;
        vm.getPagesCount = getPagesCount;
        vm.applyFilter = applyFilter; 
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.init = init;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.datePickerE_1 = datePickerE_1;
        vm.branchChanged = branchChanged;
        vm.uniqueChanged = uniqueChanged;
        vm.untillDateChanged = untillDateChanged;
        vm.sinceDateChanged = sinceDateChanged;
        vm.resetFilter = resetFilter;
        vm.exportToCSV = exportToCSV;
        vm.refreshData = refreshData;
        vm.paginationNew = paginationNew;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.dateOptions = {};
        vm.datePicker_1 = {
            sinceDate: false,
            untillDate: false
        };
        vm.altInputFormats = ['M!/d!/yyyy'];
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.predicate = 'index';
        vm.reverse = false;
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
        vm.filterData = {
            limit: vm.itemsPerPageGot,
            offset: 0,
            since_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
            until_date: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
            branch: 'all',
            unique_id: '',
            branch_filter: 0,
            unique_id_filter: 0,
            search_filter: 0,
            search_value: ''
        };
        if ($rootScope.socket.connected == false || $rootScope.socket.connected == 'false') {
            $rootScope.socket.connect();
        }

        vm.paginationChangedForBranch = paginationChangedForBranch;
        vm.branchSearch = branchSearch;

        vm.globalLimit = 10;
        vm.globalOffset = vm.globalLimit;

        vm.branchList = [];
        vm.branchList.push({
            region_name: 'All',
            region_id: 'all'
        });

        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'vehicle', 'service', 'agreement', 'corporatesList', 'operation_point'];

        vm.branchOffset = 0;

        // =================== FILTER OBJECT ===================
        vm.filterObject = {
            access_token: $cookies.get('obj'),
            branch_filter: 1,
            vehicle_filter: 0,
            service_filter: 0,
            agreement_filter: 0,
            corporate_filter: 0,
            service_category: 0,
            corporate_status: 0,
            agreement_status: 0,
            vehicle__status: 0,
            operation_point_filter: 0,
            branch_limit: vm.globalLimit,
            branch_offset: vm.branchOffset,
            branch_search_filter: 0,
            vehicle_search_filter: 0,
            service_search_filter: 0,
            agreement_search_filter: 0,
            corporate_search_filter: 0,
            operation_point_search_filter: 0
        }

        setTimeout(function () {
            document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                // if (vm.branchList && (vm.branchList.length == 0)) {
                vm.searchBranchData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

        })

        function applyFilter(){
            vm.getAllOnOffDuty(0, vm.searchModel.limit, vm.filterData);
        }
        // =================== GET FILTER DATA ===================
        function getFilterDataFromBackend(data, type) { //Acc to Index ['branch_search', 'vehicle_search', 'service_search', 'agreement_search', 'corporate_search', 'operation_point_search']
            if (data) {
                vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
            } else {
                vm.filterObject = {
                    access_token: $cookies.get('obj'),
                    branch_filter: 1,
                    vehicle_filter: 0,
                    service_filter: 0,
                    agreement_filter: 0,
                    corporate_filter: 0,
                    service_category: 0,
                    corporate_status: 0,
                    agreement_status: 0,
                    vehicle__status: 0,
                    operation_point_filter: 0,
                    branch_search_filter: 0,
                    vehicle_search_filter: 0,
                    service_search_filter: 0,
                    agreement_search_filter: 0,
                    corporate_search_filter: 0,
                    operation_point_search_filter: 0
                }
            }

            vm.filterObject.branch_limit = vm.globalLimit;
            vm.filterObject.branch_offset = vm.branchOffset;

            var promise = getFilters.getAllFilterData(vm.filterObject);
            promise.then(
                function (payload) {

                    // ********** BRANCH DATA ********
                    if (payload.title.data.branches) {
                        var index = _.findIndex(vm.branchList, {
                            region_id: 'all'
                        });
                        if (index == -1)
                            vm.branchList.push({
                                region_name: 'All',
                                region_id: 'all'
                            });
                        angular.forEach(payload.title.data.branches.data, function (column) {
                            //CHECK FOR DUPLICATE ENTRY
                            var branchIndex = _.findIndex(vm.branchList, {
                                region_id: column.region_id
                            });
                            if (branchIndex == -1)
                                vm.branchList.push(column)
                        });
                        vm.branchTotalBackendCount = payload.title.data.branches.totalCount;
                    }
                    vm.loading = false;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        }
        getFilterDataFromBackend();

        // ************ PAGINATION ON BRANCH **************
        function paginationChangedForBranch() {
            var index = _.findIndex(vm[vm.searchFilterArray[0]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.branchTotalBackendCount > (vm.branchList.length - index)) {
                commonFunction(0);
                vm.branchOffset += 10;
                getFilterDataFromBackend(vm.searchBranchData, 0);
            }
        }

        // *********** COMMON FUNCTION FOR FILTER PAGINATION AND SEARCHING ***********
        function commonFunction(type, mode) {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                // vm['search' + vm.searchFilterArray[i] + 'Data'] = '';
                if (mode == 'search' || i != type) {
                    vm[vm.searchFilterArrayForClearArray[i]] = [];
                    // vm[vm.searchFilterArrayForClearArray[i]].push({
                    //     id: 'all',
                    //     name: 'All'
                    // });
                    vm[vm.searchFilterArray[i] + 'Offset'] = 0;
                    vm['search' + vm.searchFilterArray[i].substring(0, 1).toUpperCase() + vm.searchFilterArray[i].substring(1) + 'Data'] = '';
                }
            }
        }

        // ************ SEARCH BRANCH ***************
        function branchSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchBranchData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(0, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 0);
                }, 2000);
            }
        }

        //==================date picker function==================
        vm.dateOptions = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(2090, 12, 31),
            //minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };

        function datePickerE_1(type) {
            if (type == 1) {
                vm.datePicker_1.sinceDate = true;
                vm.datePicker_1.untillDate = false;
            } else if (type == 2) {
                vm.datePicker_1.sinceDate = false;
                vm.datePicker_1.untillDate = true;
            }
        };

        //====================function for dropdown pages and page count===============
        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllOnOffDuty(0, vm.itemsPerPageGot, vm.filterData);
        };

        function paginationNew(page) {
            getAllOnOffDuty((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData);
        }
        //==================refreshData=====================
        function refreshData() {
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllOnOffDuty(vm.currentPage * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData);
        }
        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.onOffDutyMain.onOffDuty');
            }
        });

        //====================date time format====================
        function dateTimeFormat(dateGot, timeGot) {
            var dateToChange = dateGot;
            if (timeGot) {
                dateToChange.setHours(23);
                dateToChange.setMinutes(59);
                dateToChange.setSeconds(59);
            } else {
                dateToChange.setHours(0);
                dateToChange.setMinutes(0);
                dateToChange.setSeconds(0);
            }
            return dateToChange;
        };

        //==================hours format=====================
        function changeHoursFormat(data) {
            if (data && data > 60) {
                var h = Math.floor(data / 60);
                var remainder = data % 60;
                var finalH = h < 10 ? '0' + h : h;

                return finalH + ':' + remainder + ':00';
            } else if (data && data < 60) {
                var a = data < 10 ? '0' + data : data;
                return '00:' + a + ':00';
            } else {
                return '00:00:00';
            }
        }
        //==================get all drivers=======================
        function getAllOnOffDuty(skip, limit, filter) {
            if (filter.until_date < filter.since_date) {
                languageBasedErrorFactory.getProperErrorMessage('appropriateFilter', 0, 0);
                return;
            }
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit;
            dataSend.offset = skip;
            dataSend.branch_filter = filter.branch_filter;
            if (filter.branch_filter == 1 && filter.branch != 'all') {
                dataSend.branch = filter.branch;
            }
            dataSend.unique_id_filter = filter.unique_id_filter;
            if (filter.unique_id_filter == 1 && filter.unique_id) {
                dataSend.unique_id = filter.unique_id;
            }
            dataSend.search_filter = filter.search_filter;
            if (filter.search_filter == 1) {
                dataSend.search_value = filter.search_value;
            }
            dataSend.since_date = moment(filter.since_date).format('YYYY-MM-DD') + 'T00:00:000Z'; //filter.since_date.toISOString();
            dataSend.until_date = moment(filter.until_date).format('YYYY-MM-DD') + 'T23:59:59Z'; //filter.until_date.toISOString();

            vm.loading = true;
            var promise = getDrivers.onOffDutyApi(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.totalOnOffList = payload.title.data.totalCount;
                    vm.dataLength = payload.title.data.totalCount;

                    if (payload.title.data.totalCount == 0) {
                        vm.sp_pagination = false;
                        vm.tBodyFlag = false;
                        vm.tFootFlag = true;
                        vm.filterOn = true;
                        vm.skipValueFilter = 0;
                    } else {
                        vm.sp_pagination = true;
                        vm.tBodyFlag = true;
                        vm.tFootFlag = false;
                        vm.filterOn = false;
                        vm.skipValueFilter = 0;

                        var dataArray = [];
                        var onOffList = payload.title.data.result;
                        onOffList.forEach(function (column) {
                            var d = {};
                            d.branch = column.branch;
                            d.car_photo = column.car_photo;
                            d.driverName = column.driver_first_name + ' ' + column.driver_last_name;
                            d.on_off_status = column.on_off_status;
                            d.ownerName = column.owner_first_name + ' ' + column.owner_last_name;
                            d.registration_number = column.registration_number;
                            d.updated_at_filtered = $filter('date')(column.updated_at, "MMM d, yyyy hh:mm a'");
                            d.type_of_car = column.type_of_car;
                            d.unique_car_id = column.unique_car_id;
                            d.updated_at = column.updated_at;
                            dataArray.push(d);
                        });
                        vm.onOffList = dataArray;

                        for (var i = 0; i < vm.onOffList.length; i++) {
                            vm.onOffList[i].index = (skip + i);
                        }
                        if (vm.dataLength <= vm.itemsPerPageGot) {
                            vm.sp_pagination = false;
                        } else {
                            vm.sp_pagination = true;
                            //vm.pageCount(payload.title.data.totalCount);
                        }
                        vm.skipValue = vm.onOffList[0].index;
                        vm.limitValue = vm.onOffList[vm.onOffList.length - 1].index;

                        //$scope.$watch('vm.search', function (newVal, oldVal) {
                        //    vm.filtered = filterFilter(vm.onOffList, newVal);
                        //    vm.totalItems = vm.filtered.length;
                        //    if (vm.filtered.length == 0) {
                        //        vm.watchPagination = false;
                        //    } else {
                        //        vm.watchPagination = true;
                        //    }
                        //    if (vm.filterOn == true) {
                        //        vm.skipValueFilter = vm.filtered.length;
                        //        vm.sp_pagination = false;
                        //    }
                        //}, true);

                        //range();
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    } else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        vm.getAllOnOffDuty((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        vm.currentPage++;
        //        vm.getAllOnOffDuty((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    vm.getAllOnOffDuty((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //};

        function init() {
            vm.getAllOnOffDuty(0, vm.searchModel.limit, vm.filterData);
        };
        init();

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            //vm.filterOn = true;
            vm.currentPage = 0;
            vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
            vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
            pendingRequests.cancelAll();
            if (vm.search.length == 0) {
                vm.filterData.search_filter = 0;
                vm.filterData.search_value = '';
                vm.getAllOnOffDuty(0, vm.searchModel.limit, vm.filterData);
                //vm.filterOn = false;
                //vm.watchPagination = true;
                //vm.sp_pagination = true;

            } else {
                vm.filterData.search_filter = 1;
                vm.filterData.search_value = vm.search;
                //if (vm.filterTextTimeout) $timeout.cancel(vm.filterTextTimeout);
                //vm.filterTextTimeout = $timeout(function(){
                vm.getAllOnOffDuty(0, vm.searchModel.limit, vm.filterData);
                //},500);
            }
        };
        //====================get branch list====================
        // function getBranch() {
        // vm.branchList = [];
        // vm.branchList = JSON.parse(JSON.stringify(getFilters.branchesFiltersData.data));
        // vm.branchList.push({
        //     region_name: 'All',
        //     region_id: 'all'
        // });
        // $scope.$apply();

        // vm.loading = true;
        // var promise = getGeofence.branch();
        // promise.then(
        //     function (payload) {
        //         $log.log(payload);
        //         vm.loading = false;
        //         if (payload.title.status == 400) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //         } else if (payload.title.status == 401) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //         } else if (payload.title.status == 201 || payload.title.status == 200) {
        //             var where = _.where(payload.title.data, {
        //                 parent_id: 0
        //             });
        //             //vm.branchList = _.where(where, { is_active: 1 });
        //             vm.branchList = where;

        //             vm.branchList.push({
        //                 region_name: 'All',
        //                 region_id: 'all'
        //             });
        //         }
        //     },
        //     function (errorPayload) {
        //         $log.log(errorPayload);
        // vm.loading = false;
        //         if (errorPayload.data.status == 401) {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //         } else {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //         }
        //     }
        // );
        // }
        // WHen Page refresh service take time to get data from backend
        // setTimeout(function () {
        //     getBranch();
        // }, 1000);

        // ******** CLEAR OFFSET *******
        function clearOffset() {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                vm[vm.searchFilterArray[i] + 'Offset'] = 0;
            }
        }

        //=================filter change functions=================
        function branchChanged() {
            vm.currentPage = 0;
            vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
            vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
            clearOffset();
            if (vm.filterData.branch && vm.filterData.branch != 'all') {
                vm.filterData.branch_filter = 1;
                // getAllOnOffDuty(0, vm.itemsPerPageGot, vm.filterData);
                vm.branchList = [];
                getFilterDataFromBackend();
            } else {
                vm.filterData.branch_filter = 0;
                vm.filterData.branch = 'all';
                // getAllOnOffDuty(0, vm.itemsPerPageGot, vm.filterData);
                vm.branchList = [];
                getFilterDataFromBackend();
            }
        };

        function uniqueChanged() {
            vm.currentPage = 0;
            vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
            vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
            if (vm.filterData.unique_id) {
                vm.filterData.unique_id_filter = 1;
                // getAllOnOffDuty(0, vm.itemsPerPageGot, vm.filterData);
            } else {
                vm.filterData.unique_id_filter = 0;
                vm.filterData.unique_id = '';
                // getAllOnOffDuty(0, vm.itemsPerPageGot, vm.filterData);
            }
        }

        function sinceDateChanged() {
            vm.currentPage = 0;
            vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
            vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
            // if (vm.filterData.since_date) {
            //     getAllOnOffDuty(0, vm.itemsPerPageGot, vm.filterData);
            // } else {
            //     getAllOnOffDuty(0, vm.itemsPerPageGot, vm.filterData);
            // }
        };

        function untillDateChanged() {
            vm.currentPage = 0;
            vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
            vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
            // if (vm.filterData.until_date) {
            //     getAllOnOffDuty(0, vm.itemsPerPageGot, vm.filterData);
            // } else {
            //     getAllOnOffDuty(0, vm.itemsPerPageGot, vm.filterData);
            // }
        };

        function resetFilter() {
            vm.currentPage = 0;
            vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
            vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
            vm.filterData = {
                limit: vm.itemsPerPageGot,
                offset: 0,
                since_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
                until_date: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
                branch: '',
                unique_id: '',
                branch_filter: 0,
                unique_id_filter: 0
            };
            getAllOnOffDuty(0, vm.itemsPerPageGot, vm.filterData);
        };

        //=================================export to csv==============================
        function exportToCSV() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            // dataSend.limit = 0;
            // dataSend.offset = 0;
            dataSend.branch_filter = 0;
            dataSend.unique_id_filter = 0;
            dataSend.since_date = moment(vm.filterData.since_date).format('YYYY-MM-DD') + 'T00:00:000Z';
            dataSend.until_date = moment(vm.filterData.until_date).format('YYYY-MM-DD') + 'T23:59:59Z';
            vm.loading = true;
            var promise = getDrivers.onOffDutyApiCsv(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if(payload.title.status == 200){

                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    // var dataArrayE = [];
                    // var onOffListExport = payload.title.data.result;
                    // onOffListExport.forEach(function (column) {
                    //     var d = {};
                    //     d['Unique Number'] = column.unique_car_id;
                    //     d['Type Of Vehicle'] = column.type_of_car;
                    //     d['Vehicle Unique No.'] = column.unique_car_id;
                    //     d['Driver'] = column.driver_first_name + " " + column.driver_last_name;
                    //     d['Branch'] = column.branch;
                    //     d['Date & Time'] = moment(column.updated_at).format('lll');
                    //     dataArrayE.push(d);
                    // });
                    // vm.onOffListExport = dataArrayE;
                    // alasql('SELECT * INTO CSV("onOffDutyReport.csv",{headers:true}) FROM ?', [vm.onOffListExport]);

                },
                function (errorPayload) {
                    vm.loading = false;
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };
    }

})();
/**
 * Created by cl-macmini-51 on 11/10/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('ViewNoShowReasonController', ViewNoShowReasonController);

    /** @ngInject */
    function ViewNoShowReasonController($cookies, $state, $log, $rootScope, $timeout, getCars, $scope, filterFilter, $mdDialog,$document, getNoShowReason,$stateParams,languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.getNoShowReasonHit = getNoShowReasonHit;
        vm.goBack = goBack;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.noShowReasonMain.noShowReason');
            }
        });
        //=====================add new reason hit=========================
        function getNoShowReasonHit(){
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = 0;
            dataSend.offset = 0;
            dataSend.reason_id = Number($stateParams.id);
            var promise = getNoShowReason.getNoShowReasonList(dataSend);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if(payload.title.status == 400){
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    else if(payload.title.status == 401){
                        errorMessageFactory.showErrorMessage(payload.title.message,2,'home');
                    }
                    else if(payload.title.status == 201 || payload.title.status == 200) {
                        vm.correctFareReasonDetail = payload.title.data.result[0];
                    }
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        getNoShowReasonHit();

        //=================go back================
        function goBack() {
            $state.go('layout.noShowReasonMain.noShowReason');
        };
    }
})();

/**
 * Created by cl-macmini-51 on 11/10/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('NoShowReasonController', NoShowReasonController);

    /** @ngInject */
    function NoShowReasonController($cookies, $state, $log, $rootScope, $timeout, getCars, $scope, filterFilter, $mdDialog,$document, getNoShowReason, languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.totalReasons = 0;
        vm.currentPage = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.getPagesCount = getPagesCount;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.init = init;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.noDataFlag = false;
        vm.predicate = 'index';
        vm.reverse = false;
        vm.addNewReason = addNewReason;
        vm.sort = sort;
        vm.getNoShowReasonHit = getNoShowReasonHit;
        vm.changeReasonStatus = changeReasonStatus;
        vm.editReasonPop = editReasonPop;
        vm.deleteReason = deleteReason;
        vm.paginationNew = paginationNew;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.filterData = {
            noShowStatus: '0'
        };

        //====================function for dropdown pages and page count===============
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];

        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getNoShowReasonHit(0, vm.itemsPerPageGot,vm.filterData.noShowStatus);
        };
        function paginationNew(page){
            getNoShowReasonHit((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot,vm.filterData.noShowStatus);
        }
        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.noShowReasonMain.noShowReason');
            }
        });
        //=====================add new reason hit=========================
        function getNoShowReasonHit(skip, limit,filter){
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit;
            dataSend.offset = skip;
            dataSend.status = Number(filter);
            var promise = getNoShowReason.getNoShowReasonList(dataSend);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if(payload.title.status == 400){
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    else if(payload.title.status == 401){
                        errorMessageFactory.showErrorMessage(payload.title.message,2,'home');
                    }
                    else if(payload.title.status == 201 || payload.title.status == 200) {
                        vm.totalReasons = payload.title.data.totalCount;
                        vm.dataLength = payload.title.data.totalCount;

                        if (payload.title.data.totalCount == 0) {
                            vm.sp_pagination = false;
                            vm.tBodyFlag = false;
                            vm.tFootFlag = true;
                            vm.filterOn = true;
                            vm.skipValueFilter = 0;
                        } else {
                            vm.sp_pagination = true;
                            vm.tBodyFlag = true;
                            vm.tFootFlag = false;
                            vm.filterOn = false;
                            vm.skipValueFilter = 0;

                            var dataArray = [];

                            var noShowReasonList = payload.title.data.result;
                            noShowReasonList.forEach(function (column) {
                                var d = {};
                                d.id = column.reason_id;
                                d.reason = column.reason;
                                d.status = column.block_status;
                                d.description = column.description;
                                dataArray.push(d);
                            });
                            vm.noShowReasonList = dataArray;

                            for (var i = 0; i < vm.noShowReasonList.length; i++) {
                                vm.noShowReasonList[i].index = (skip + i);
                            }
                            if (vm.dataLength <= vm.itemsPerPageGot) {
                                vm.sp_pagination = false;
                            } else {
                                vm.sp_pagination = true;
                                //vm.pageCount(payload.title.data.totalCount);
                            }
                            vm.skipValue = vm.noShowReasonList[0].index;
                            vm.limitValue = vm.noShowReasonList[vm.noShowReasonList.length - 1].index;

                            $scope.$watch('vm.search', function (newVal, oldVal) {
                                vm.filtered = filterFilter(vm.noShowReasonList, newVal);
                                vm.totalItems = vm.filtered.length;
                                if (vm.filtered.length == 0) {
                                    vm.watchPagination = false;
                                } else {
                                    vm.watchPagination = true;
                                }
                                if (vm.filterOn == true) {
                                    vm.skipValueFilter = vm.filtered.length;
                                    vm.sp_pagination = false;
                                }
                            }, true);

                            //range();
                        }
                    }
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    } else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        vm.getNoShowReasonHit((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData.noShowStatus);
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        vm.currentPage++;
        //        vm.getNoShowReasonHit((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData.noShowStatus);
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    vm.getNoShowReasonHit((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData.noShowStatus);
        //};

        function init() {
            vm.getNoShowReasonHit(0, vm.searchModel.limit,vm.filterData.noShowStatus);
        };
        init();

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            vm.filterOn = true;
            if (vm.search.length == 0) {
                vm.filterOn = false;
                vm.watchPagination = true;
                vm.sp_pagination = true;
            }
        };

        //===========================change price list status=========================
        function changeReasonStatus(id,value,$event){
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('statusReasonPop',0,'3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton',0,'3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton',0,'3'));

            $mdDialog.show(confirm).then(function() {
                var a = '';
                var msgSys = '';
                if (value == 0) {
                    a = 1;
                    msgSys = 'Reason blocked';
                } else if (value == 1) {
                    a = 0;
                    msgSys = 'Reason unblocked';
                }
                //errorMessageFactory.showErrorMessage('Functionality is pending.',0);
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.blocking_status = a;
                dataSend.reason_id = id;
                vm.loading = true;
                var promise = getNoShowReason.statusNoShowReason(dataSend);
                promise.then(
                    function(payload) {
                        $log.log(payload);
                        vm.loading = false;
                        var dataForSysLogs = {
                            access_token: $cookies.get('obj'),
                            id: id,
                            identity : 24,  // 0- driver, 1- customer , 2 -car,3-cancel reason
                            message : msgSys
                        };
                        $rootScope.systemLogsAdmin(dataForSysLogs);
                        languageBasedErrorFactory.getProperErrorMessage('statusReasonSucc',0,1,'layout.noShowReasonMain.noShowReason')
                        //errorMessageFactory.showErrorMessage('Reason status updated successfully.',1);
                        //$timeout(function() {
                        //    $mdDialog.hide();
                        //    $state.reload();
                        //}, 2000);
                    },
                    function(errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if(errorPayload.data.status == 401){
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                        }
                        else{
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                        }
                    }
                );

            }, function() {
                $log.log('not confirmed');
            });
        };

        //=====================add new reason hit=========================
        function addNewReasonHit(data){
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.reason = data.reason;
            dataSend.description = data.description;

            vm.loading = true;
            var promise = getNoShowReason.addNoShowReason(dataSend);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    languageBasedErrorFactory.getProperErrorMessage('addReasonSucc',0,1,'layout.noShowReasonMain.noShowReason')
                    //errorMessageFactory.showErrorMessage('Reason added successfully.',1);
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };

        //========================add new reason pop==========================
        function addNewReason($event){
            vm.items = {
                reason: '',
                description: ''
            }
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/addNoShowReason.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });
            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    $mdDialog.hide();
                    addNewReasonHit($scope.items);
                };
            }
        };

        //===================edit reason hit======================
        function editReasonHit(data){
            var dataSend = {};
            dataSend = data;
            dataSend.access_token = $cookies.get('obj');


            vm.loading = true;
            var promise = getNoShowReason.editNoShowReason(dataSend);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    var dataForSysLogs = {
                        access_token: $cookies.get('obj'),
                        id: data.reason_id,
                        identity : 24,  // 0- driver, 1- customer , 2 -car,3-cancel reason
                        message : 'Reason updated.'
                    };
                    $rootScope.systemLogsAdmin(dataForSysLogs);
                    languageBasedErrorFactory.getProperErrorMessage('editReasonSucc',0,1,'layout.noShowReasonMain.noShowReason')
                    //errorMessageFactory.showErrorMessage('Reason updated successfully.',1);
                    //$timeout(function() {
                    //    $mdDialog.hide();
                    //    $state.reload();
                    //}, 2000);
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        //===============edit reason pop=====================
        function editReasonPop(data,$event){
            vm.items = {
                reason: data.reason,
                description: data.description,
                reason_id: data.id
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/editNoShowReason.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });
            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    $mdDialog.hide();
                    editReasonHit($scope.items);
                };
            }
        };
        //======================delete reason hit===========================
        function deleteReason(data, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('deleteReasonPop',0,'3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton',0,'3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton',0,'3'));

            $mdDialog.show(confirm).then(function() {
                $log.log('confirmed');
                var dataSend = {
                    access_token: $cookies.get('obj'),
                    reason_id: data.id
                };
                //errorMessageFactory.showErrorMessage('Functionality is pending.',0);
                vm.loading = true;
                var promise = getNoShowReason.deleteCorrectFareReason(dataSend);
                promise.then(
                    function(payload) {
                        $log.log(payload);
                        vm.loading = false;
                        languageBasedErrorFactory.getProperErrorMessage('deleteReasonSucc',0,1,'layout.noShowReasonMain.noShowReason')
                        //errorMessageFactory.showErrorMessage('Reason deleted successfully.',1);
                    },
                    function(errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if(errorPayload.data.status == 401){
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                        }
                        else{
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                        }
                    }
                );
            }, function() {
                $log.log('not confirmed');
            });
        }
    }
})();

/**
 * Created by Rahul on 16/12/22.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('NewMassiveCreateBookingController', NewMassiveCreateBookingController);

    /** @ngInject */
    function NewMassiveCreateBookingController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document, moment, getCustomers, $scope, getBookings,
        RutHelper, errorMessageFactory, languageBasedErrorFactory, adminAccessService, hidePublicPlaces, pendingRequests, getCorporate, getAgreement, checkDomain, tmhDynamicLocale, quickSaleService, getFilters, Initializer, calenderTranslate, getServices) {
        var vm = this;
        vm.dataToFill = {
            selectCreateType: '',
            contractIdSelected: '',
            aggrement_value: '',
            serviceTypeSelected: '',
            TripType: '',
            payment_method: '',
            bookingType: ''
        };
        vm.submitButtonActivate = false;
        if ($rootScope.socket.connected == false || $rootScope.socket.connected == 'false') {
            $rootScope.socket.connect();
        }
        vm.errorFlag = false;
        vm.submitFlag = false;
        vm.showUploadedFiles = false;
        vm.disableCount = 0;
        vm.bookingsWithinFile = [];
        vm.agreementChanged = agreementChanged;
        vm.typeOfTripChanged = typeOfTripChanged;
        vm.makeTableViewOfXlsx = makeTableViewOfXlsx;
        vm.submitFieldsCreateBooking = submitFieldsCreateBooking;

        //======================get all Agreements==============
        function getAllAgreement(skip, limt) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.offset = skip;
            dataSend.limit = limt;
            dataSend.service_grouping_type = 2;
            //vm.loading = false;
            var promise = getAgreement.getAgreementListLessData(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    //vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.agreementBooking = [];
                        angular.forEach(payload.title.data, function (column) {
                            if (column.status == 1)
                                vm.agreementBooking.push({
                                    id: column.id,
                                    name: column.name
                                });
                        });
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllAgreement(0, 0);
        //======================get all Agreements==============


        //======================Select One Agrrement ==============
        function agreementChanged() {
            if (vm.dataToFill.contractIdSelected.id != '' && vm.dataToFill.TripType != '') {
                vm.submitFlag = true;
            }
            if (vm.dataToFill.contractIdSelected.id && vm.dataToFill.TripType)
                agreementTypeChanged(vm.dataToFill.contractIdSelected.id, vm.dataToFill.TripType);
        }
        //======================Select One Agrrement ==============

        //======================Select Type of Trip ==============
        function typeOfTripChanged() {
            if (vm.dataToFill.contractIdSelected.id && vm.dataToFill.TripType != '') {
                vm.submitFlag = true;
            }
            if (vm.dataToFill.contractIdSelected.id && vm.dataToFill.TripType)
                agreementTypeChanged(vm.dataToFill.contractIdSelected.id, vm.dataToFill.TripType);
        }
        //======================Select Type of Trip ==============


        //======================Get Create Booking Fields ==============
        function agreementTypeChanged(id,tot) {
            $scope.clearSelection();
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.contract_id = vm.contractId = id;
            dataSend.type_of_trip = vm.tot = tot;
            vm.loading = true;
            var promise = getBookings.getCreateBookingFields(dataSend);
            promise.then(
                function (payload) {
                    vm.loading = false;
                    vm.fields = payload.title.data;
                    vm.fieldsWithMetaData = vm.fields.filter(function(f){
                        return (f.meta_data==1);
                    })
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        //======================Get Create Booking Fields ==============

        function makeTableViewOfXlsx($event) {
            $log.log('ddf');
            $event.stopPropagation();
            vm.uploadName = 'xlxs';
            var element = document.getElementById('fileUpload');
            element.click();
        }

        //======================UPLOAD XLSX FILE TO GET HEADERS==============
        $scope.uploadXlsxGetHeaders = function (File, type) {
            vm.fileId = 0;
            vm.fieldsRequired = vm.fields.filter(function(f){
                return (f.required==1);
            })
            var dataSend = new FormData();
            dataSend.append('access_token', $cookies.get('obj'));
            dataSend.append('contract_id',vm.contractId);
            dataSend.append('fields_count',vm.fieldsRequired.length);
            dataSend.append('booking_xlsx', File[0]);
            vm.loading = true;
            var dataArray = [];
            var promise = getAgreement.uploadXlsxGetHeaders(dataSend);
            promise.then(
                function (payload) {
                    $log.log('payload', payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        vm.fields = vm.fieldsRequired;
                        getUploadedFiles();
                        $scope.clearSelection();
                        if(payload.title.data && payload.title.data.headers && payload.title.data.headers.length) {
                            vm.headers = [];
                            vm.headers = payload.title.data.headers.map(function(element){
                                return {value: element, disabled:false};
                            });
                            vm.fileId = payload.title.data.file_id;
                        }
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        //======================UPLOAD XLSX FILE TO GET HEADERS==============

        //======================DISABLE HEADER FROM DROPDOWN=================
        $scope.disableSelection = function(field) {
            vm.headers[vm.headers.indexOf(field)].disabled = true;
            vm.disableCount++;
        }
        //======================DISABLE HEADER FROM DROPDOWN=================

        //======================CLEAR SELECTION OF HEADERS===================
        $scope.clearSelection = function() {
            _.forEach(vm.fields, function(key, index){
               vm.fields[index].value = "";
            });
            _.forEach(vm.headers, function(key, index){
                vm.headers[index].disabled= false;
             });
             vm.disableCount = 0;
        }
        //======================CLEAR SELECTION OF HEADERS===================

        //======================Send Create Booking Fields ==============
        function submitFieldsCreateBooking() {
            var dataSend = {},header;
            dataSend.booking_fields = vm.fields.map(function(element){
                                header = element.value.value;
                                delete element.value;
                                return (Object.assign(element,{header : header}));
                            });
            if(dataSend.booking_fields)
            dataSend.access_token = $cookies.get('obj');
            dataSend.file_id = vm.fileId;
            dataSend.contract_id = vm.contractId;
            dataSend.type_of_trip = vm.tot;
            vm.loading = true;
            var promise = getBookings.submitFieldsCreateBooking(dataSend);
            promise.then(
                function (payload) {
                    vm.loading = false;
                    if (payload.title.status == 200) {

                    }
                    else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        //======================Send Create Booking Fields ==============

        //======================get uploaded files==============
        function getUploadedFiles() {
        var dataSend = {};
        dataSend.access_token = $cookies.get('obj');
        //vm.loading = false;
        var promise = getBookings.getUploadedFiles(dataSend);
        promise.then(
            function (payload) {
                $log.log('sxdsads', payload);
                //vm.loading = false;
                if (payload.title.status == 400) {
                    errorMessageFactory.showErrorMessage(payload.title.message, 0);
                } else if (payload.title.status == 401) {
                    errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                } else if (payload.title.status == 201 || payload.title.status == 200) {
                    vm.uploadedFiles = payload.title.data;
                }
            },
            function (errorPayload) {
                $log.log(errorPayload);
                //vm.loading = false;
                if (errorPayload.data.status == 401) {
                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                } else {
                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                }
            }
        );
        };
        getUploadedFiles();
        //======================get uploaded files==============

        //======================get bookings within file==============
        $scope.getBookingWithinFile = function(fileId) {
        var dataSend = {};
        dataSend.access_token = $cookies.get('obj');
        dataSend.file_id = fileId;
        dataSend.limit = 500;
        dataSend.skip = 0;
        //vm.loading = false;
        var promise = getBookings.getBookingWithinFile(dataSend);
        promise.then(
            function (payload) {
                $log.log('sxdsads', payload);
                //vm.loading = false;
                if (payload.title.status == 400) {
                    errorMessageFactory.showErrorMessage(payload.title.messsage, 0);
                } else if (payload.title.status == 401) {
                    errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                } else if (payload.title.status == 201 || payload.title.status == 200) {
                    vm.bookingsWithinFile = payload.title.data.bookings;
                }
            },
            function (errorPayload) {
                $log.log(errorPayload);
                //vm.loading = false;
                if (errorPayload.data.status == 401) {
                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                } else {
                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                }
            }
        );
        };
        //======================get bookings within file==============

        $scope.toggle = function() {
            vm.showUploadedFiles = !vm.showUploadedFiles;
        };

        $scope.exportExcel = function(url) {
            window.open(url, '_blank');
        }

        $scope.goBack = function() {
            // vm.bookingsWithinFile = [];
            $state.reload();
        }
    }
})();
/**
 * Created by cl-macmini-51 on 4/14/17.
 */
 (function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('FleetCapacityMatrixExceptionsController', FleetCapacityMatrixExceptionsController);

    /** @ngInject */
    function FleetCapacityMatrixExceptionsController($cookies, $state, $log, $http,$stateParams,MY_CONSTANT, $timeout, $rootScope, $interval, $scope, adminAccessService,mapDashboard, getDrivers, getVehicles, getServices, getAgreement, getGeofence, $mdDialog, $document, $filter, getBookings, languageBasedErrorFactory, errorMessageFactory, getFilters, Initializer,fleetCapacityMatrixService) {
        var vm = this;
        vm.count = 0;
        vm.params = $stateParams;
        vm.blocks = [];
        if(vm.params.id){
            vm.matrix_id = vm.params.id;
        }
        if(vm.params.sucursal){
            vm.sucursal = vm.params.sucursal;
        }
        if($stateParams.id){
            vm.id = $stateParams.id;
        }
        if(vm.params.exception){
            vm.blocks = vm.params.exception;
        }
        vm.approvalValueChanged = approvalValueChanged;
        vm.paginationChangedForBranch = paginationChangedForBranch;
        vm.branchChanged = branchChanged;
        // vm.branchList = [];
        vm.filterData = {
            branch_value: '',
        };
        vm.obj = [];
        vm.date;
        vm.cancel = cancel;
        vm.filterDay = filterDay;
        vm.addBlock = addBlock;
        vm.isAdd = false;
        vm.saveBlock = saveBlock;
        vm.removeBlock = removeBlock;
        vm.isDataException = false;
        vm.dataForBlock = {
            sucursal_id: '',
            dia_inicio:'',
            dia_fin:'',
            cupos: '',
            start_date: '',
            end_date: '',
            fecha_inicio: {
                hora: '00:00',
                minute: '00'
            },
            fecha_fin: {
                hora: '01:00', 
                minute: '15'
            },
        };
        moment.defineLocale('es', {
            months: 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split('_'),
            monthsShort: 'Ene_Feb_Mar_Abr_May_Jun_Jul_Ago_Sept_Oct_Nov_Dic'.split('_'),
            weekdays: 'Domingo_Lunes_Martes_Miercoles_Jueves_Viernes_Sabado'.split('_'),
            weekdaysShort: 'Dom._Lun._Mar._Mier._Jue._Vier._Sab.'.split('_'),
            weekdaysMin: 'Do_Lu_Ma_Mi_Ju_Vi_Sa'.split('_')
            }
        );
        moment.locale('es');


       

        vm.hoursArray = [{
            value: 0,
            id: '00:00'
        },
        {
            value: 1,
            id: '01:00'
        },
        {
            value: 2,
            id: '02:00'
        },
        {
            value: 3,
            id: '03:00'
        },
        {
            value: 4,
            id: '04:00'
        },
        {
            value: 5,
            id: '05:00'
        },
        {
            value: 6,
            id: '06:00'
        },
        {
            value: 7,
            id: '07:00'
        },
        {
            value: 8,
            id: '08:00'
        },
        {
            value: 9,
            id: '09:00'
        },
        {
            value: 10,
            id: '10:00'
        },
        {
            value: 11,
            id: '11:00'
        },
        {
            value: 12,
            id: '12:00'
        },
        {
            value: 13,
            id: '13:00'
        },
        {
            value: 14,
            id: '14:00'
        },
        {
            value: 15,
            id: '15:00'
        },
        {
            value: 16,
            id: '16:00'
        },
        {
            value: 17,
            id: '17:00'
        },
        {
            value: 18,
            id: '18:00'
        },
        {
            value: 19,
            id: '19:00'
        },
        {
            value: 20,
            id: '20:00'
        },
        {
            value: 21,
            id: '21:00'
        },
        {
            value: 22,
            id: '22:00'
        },
        {
            value: 23,
            id: '23:00'
        }
    ]


    vm.minutesArray = [{
        value: 0,
        id: '00'
        },
        {
            value: 1,
            id: '15'
        },
        {
            value: 2,
            id: '30'
        },
        {
            value: 3,
            id: '45'
        },
    ]

    var date = new Date();
    var d = date.getDate();
    var m = date.getMonth() + 1;
    var y = date.getFullYear();
    vm.date = y + "-" + m + "-" + d;

if(vm.id){
    getMatrix();
}

function getMatrix() {
    vm.loading = true;
    var dataSend = {};
    dataSend.access_token = $cookies.get('obj');
    dataSend.id = Number(vm.id);
    console.log(dataSend);
    var promise = fleetCapacityMatrixService.getMatriz(dataSend);
    promise.then(function (payload) {
        vm.loading = false;
        vm.blocks = [];
        angular.forEach(payload.title.data.matrizFlotaExcepciones, function(value) {
            vm.blocks.push({
                id: value.id,
                hora_inicio: moment(value.fechaInicio).utc().format('H:mm'),
                hora_fin: moment(value.fechaFin).utc().format('H:mm'),
                start_date: moment(value.fechaInicio).format('DD MMM YYYY'),
                start_date_format: moment(value.fechaInicio).format('YYYY-MM-DD'),
                end_date: moment(value.fechaFin).format('DD MMM YYYY'),
                end_date_format: moment(value.fechaFin).format('YYYY-MM-DD'),
                matriz_flota_id: value.matrizFlotaId,
                cupos: value.cupos,
                isData: true,
                status: value.status
            })

        });
    }, function (errorPayload) {
            $log.log(errorPayload);
            vm.loading = false;
            if (errorPayload.data.status == 401) {
                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
            } else {
                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
            }
        }
    );
}
        
      
        if ($cookies.get('branch')) {
            vm.filterData.branch_value = JSON.parse($cookies.get('branch'));
        }
        
        function addBlock() {
            vm.isAdd = !vm.isAdd;
        }

        function cancel() {
            $state.go('layout.fleetCapacityMatrixMain.fleetCapacityMatrix', {
                typeSelected:'lala'
            });
        }


        function saveBlock(data) {

            if(!data.fecha_inicio.hora || !data.fecha_fin.hora || !data.start_date || !data.end_date || isNaN(parseInt(data.cupos)) ) {
               errorMessageFactory.showErrorMessage('Todos los campos son obligatorios.', 0);
               return;
             }

            if(data.start_date.getTime() > data.end_date.getTime()){
                errorMessageFactory.showErrorMessage('La fecha de inicio no puede ser superior a la fecha de termino', 0);
                return;
            }


              for (var i = 0; i < vm.blocks.length; i++) {
                if (
                    Math.min(new Date(moment(vm.blocks[i].start_date).format('YYYY-MM-DD') + 'T' + vm.blocks[i].hora_inicio).getTime(), new Date(moment(vm.blocks[i].end_date).format('YYYY-MM-DD') + 'T' + vm.blocks[i].hora_fin).getTime()) 
                    < Math.max(new Date(moment(data.start_date).format('YYYY-MM-DD') + 'T' + data.fecha_inicio.hora).getTime(), new Date(moment(data.end_date).format('YYYY-MM-DD') + 'T' + data.fecha_fin.hora).getTime()) 
                    && Math.max(new Date(moment(vm.blocks[i].start_date).format('YYYY-MM-DD') + 'T' + vm.blocks[i].hora_inicio).getTime(), new Date(moment(vm.blocks[i].end_date).format('YYYY-MM-DD') + 'T' + vm.blocks[i].hora_fin).getTime()) 
                    > Math.min(new Date(moment(data.start_date).format('YYYY-MM-DD') + 'T' + data.fecha_inicio.hora).getTime(), new Date(moment(data.end_date).format('YYYY-MM-DD') + 'T' + data.fecha_fin.hora).getTime())) {
                        errorMessageFactory.showErrorMessage('Ya existe una excepción creada entre ese rango horas.', 0);
                        return;
                }
  
              }


              if(data.start_date.getTime() == data.end_date.getTime()) {
                if(data.fecha_inicio.hora >= data.fecha_fin.hora ){
                    errorMessageFactory.showErrorMessage('La hora de inicio no puede ser igual o mayor a la hora de termino.', 0);
                    return;
                }
            }

            

            vm.addBlock();
            var dataSend = {
                start_date: moment(data.start_date).format('DD MMM YYYY'),
                start_date_format: moment(data.start_date).format('YYYY-MM-DD'),
                end_date: moment(data.end_date).format('YYYY MMM DD'),
                end_date_format: moment(data.end_date).format('YYYY-MM-DD'),
                hora_inicio:data.fecha_inicio.hora ? data.fecha_inicio.hora : '',
                hora_fin: data.fecha_fin.hora ? data.fecha_fin.hora : '',
                cupos: data.cupos,
                status: true
            };
    
            vm.blocks.push(dataSend);


            
            vm.dataForBlock = {
                sucursal_id: '',
                dia_inicio:'',
                dia_fin:'',
                cupos: '',
                start_date: '',
                end_date: '',
                fecha_inicio: {
                    hora: '00:00',
                    minute: '00'
                },
                fecha_fin: {
                    hora: '01:00', 
                    minute: '15'
                },
            };
        }


        $scope.guardar_datos = function(formInstance,e) {


            if(vm.blocks.length < 1) {
                errorMessageFactory.showErrorMessage('Debe agregar un bloque horario', 0);
                return;
            }

            
            if(vm.id) {
                for (var i = 0; i < vm.blocks.length; i++) {
                    if(vm.blocks[i].id) {
                        vm.obj.push({id: Number(vm.blocks[i].id), fechaInicio:vm.blocks[i].start_date_format + ' ' + vm.blocks[i].hora_inicio, fechaFin:vm.blocks[i].end_date_format + ' ' + vm.blocks[i].hora_fin, cupos:vm.blocks[i].cupos, status:vm.blocks[i].status, matrizFlotaId: Number(vm.id) })
                    }else {
                        console.log('lala')
                        vm.obj.push({fechaInicio: vm.blocks[i].start_date_format + ' ' + vm.blocks[i].hora_inicio, fechaFin: vm.blocks[i].end_date_format + ' ' + vm.blocks[i].hora_fin, cupos:vm.blocks[i].cupos, status: vm.blocks[i].status, matrizFlotaId: Number(vm.id) })
                    }
                }
            } else {
                for (var i = 0; i < vm.blocks.length; i++) {
                    vm.obj.push({fechaInicio:vm.blocks[i].start_date_format + ' ' + vm.blocks[i].hora_inicio, fechaFin:vm.blocks[i].end_date_format + ' ' + vm.blocks[i].hora_fin, cupos:vm.blocks[i].cupos, status: vm.blocks[i].status })
                }

            }

            vm.loading = true;
            var toSend = {};
            var promise;
            toSend.access_token = $cookies.get('obj');
            toSend.matrizFlotaExcepciones = vm.obj;
            console.log(toSend);
            if(vm.id) {
                toSend.id = vm.id;
                promise = fleetCapacityMatrixService.updateMatrix(toSend);
            }else {
                promise = fleetCapacityMatrixService.addMatrix(toSend);
            }
            promise.then(function (payload) {
                $log.log('sxdsads', payload);
                console.log('sxdsads', payload)
                vm.loading = false;
                
                if (payload.title.status == 400) {
                    errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    return [];
                }
                else if (payload.title.status == 100) {
                    errorMessageFactory.showErrorMessage(payload.title.message, 2);
                    return [];
                }
                else if (payload.title.status == 401) {
                    errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    return [];
                }else if(payload.title.status == 201){
                    errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    return [];
                }
                else if (payload.title.status == 200) {
                    if(vm.id)  {
                        languageBasedErrorFactory.getProperErrorMessage('fleetCapacityMatrixUpdateSucc', 0, 2, 'layout.fleetCapacityMatrixMain.fleetCapacityMatrix');
                    }else {
                        languageBasedErrorFactory.getProperErrorMessage('fleetCapacityMatrixCreateSucc', 0, 2, 'layout.fleetCapacityMatrixMain.fleetCapacityMatrix');
                    }
                    $state.go('layout.fleetCapacityMatrixMain.fleetCapacityMatrix', {
                        estadoSelected: vm.params.estado
                    });
                    guardarExcepcion(payload.title.data.matriz_id)
                    // if(vm.params.exception){
                    //     if(vm.id){
                    //         guardarExcepcion(vm.id)
                    //     }else {
                    //         guardarExcepcion(payload.title.data.matriz_id)
                    //     }
                    // }
                    
                }
               
            }, function (errorPayload) {
                    console.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }

            
            );
            vm.obj = [];


           //if(vm.id){
                //vm.loading = true;
                //var toSend = {};
                //toSend.access_token = $cookies.get('obj');
                //toSend.bloques = vm.obj;
                //toSend.id = vm.id;
                //console.log(toSend);
    
                //var promise = fleetCapacityMatrixService.addException(toSend);
               
                //promise.then(function (payload) {
                    //$log.log('sxdsads', payload);
                    //console.log('sxdsads', payload)
                    //vm.loading = false;
                    
                    //if (payload.title.status == 400) {
                        //errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        //return [];
                    //} else if (payload.title.status == 401) {
                        //errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        //return [];
                    //}else if(payload.title.status == 201){
                        //errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        //return [];
                    //}
                    //else if (payload.title.status == 200) {
                        //errorMessageFactory.showErrorMessage('La excepción ha sido creada exitosamente.', 2);
                        //vm.obj = [];
                        //getMatrix();
                      
                    //}
                   
                //}, function (errorPayload) {
                        //console.log(errorPayload);
                        //vm.loading = false;
                        //if (errorPayload.data.status == 401) {
                            //errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        //} else {
                            //errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        //}
                    //}
    
                
                //);
    
        
           //}else {
               //$state.go('layout.fleetCapacityMatrixMain.fleetCapacityMatrixCreate', {
                   //exception: vm.obj,
                   //matriz: vm.params.matriz,
                   //create:true
               //});
           //}


        }

        function removeBlock(indice) {
            vm.blocks[indice].status = false;
        }

        //function removeBlock(value) {
            //if(value.isData){
                //deleteException(value)
            //}else {
                //var index = vm.blocks.indexOf(value);
                //vm.blocks.splice(index, 1); 
            //}
        //}

        //function deleteException(value) {

            //vm.loading = true;
            //var toSend = {};
            //toSend.access_token = $cookies.get('obj');
            //toSend.id = value.id;

        
            //var promise = fleetCapacityMatrixService.deleteExcep(toSend);
            //promise.then(function (payload) {
                //console.log('sxdsads', payload)
                //vm.loading = false;
                
                //if (payload.title.status == 400) {
                    //errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    //return [];
                //} else if (payload.title.status == 401) {
                    //errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    //return [];
                //}else if(payload.title.status == 201){
                    //errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    //return [];
                //}
                //else if (payload.title.status == 200) {
                    //var index = vm.blocks.indexOf(value);
                    //vm.blocks.splice(index, 1); 
                //}

               
            //}, function (errorPayload) {
                    //console.log(errorPayload);
                    //vm.loading = false;
                    //if (errorPayload.data.status == 401) {
                        //errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    //} else {
                        //errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    //}
                //}

            
            //);

        //}



        function getBranch() {
          
            vm.loading = true;
            var promise = getGeofence.branch();
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        var where = _.where(payload.title.data, {
                            parent_id: 0
                        });
                        //vm.branchList = _.where(where, { is_active: 1 });
                        vm.branchList = where;
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    // vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        // WHen Page refresh service take time to get data from backend
        // setTimeout(function () {
        getBranch();

        function branchChanged(type,value) {
            // console.log(value);
            // vm.dataForBlock.sucursal_id = value
            // if (type) {
            //     if (vm.filterData.branch_value_package != 'all')
            //         $cookies.put('branchPackage', vm.filterData.branch_value_package);
            // } else {
            //     if (vm.filterData.branch_value != 'all')
            //         $cookies.put('branch', vm.filterData.branch_ value);
            // }
    
        }

        function paginationChangedForBranch() {

        }
        


    
        function approvalValueChanged() {
            // vm.currentPage = 0;
            // if (vm.filterData.verification_stage && vm.filterData.verification_stage != 'all') {
            //     vm.filterData.filter_verification_stage = 1;
            //     getFilterDriverHit(0, vm.itemsPerPageGot, vm.filterData);
            // } else {
            //     vm.filterData.filter_verification_stage = 0;
            //     vm.filterData.verification_stage = 'all';
            //     getFilterDriverHit(0, vm.itemsPerPageGot, vm.filterData);
            // }
        };


        function filterDay(day) {
            var dia = '';
            if(day == '1') dia = 'Lunes'
            else if(day == '2') dia = 'Martes'
            else if(day == '3') dia = 'Miércoles'
            else if(day == '4') dia = 'Jueves'
            else if(day == '5') dia = 'Viernes'
            else if(day == '6') dia = 'Sábado'
            else if(day == '7') dia = 'Domingo'

            return dia;
        }


       


    }

})();

/**
 * Created by cl-macmini-51 on 4/14/17.
 */
 (function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('FleetCapacityMatrixDetailController', FleetCapacityMatrixDetailController);

    /** @ngInject */
    function FleetCapacityMatrixDetailController($cookies, $state, $log, $http,$stateParams,MY_CONSTANT, $timeout, $rootScope, $interval, $scope, adminAccessService,mapDashboard, getDrivers, getVehicles, getServices, getAgreement, getGeofence, $mdDialog, $document, $filter, getBookings, languageBasedErrorFactory, errorMessageFactory, getFilters, Initializer,fleetCapacityMatrixService) {
        var vm = this;
        var markers = [];
        var mc = null;
        vm.count = 0;
        vm.params = $stateParams.matriz;
        vm.id = $stateParams.id;
        vm.dates = [];
        vm.exceptions = [];
        vm.sucursal;
        vm.nombre;
        vm.matriz;
        vm.sucursal_id;
        vm.filterDay = filterDay;
        vm.cancel = cancel;
        console.log(vm.params);
        vm.handleExceptions = handleExceptions;
        vm.handleCalendar = handleCalendar;
        vm.branchChanged = branchChanged;
        vm.showExceptions = false;
        // vm.branchSearch = branchSearch;
        vm.branchList = [];
        vm.branchList.push({
            region_name: 'All',
            region_id: 'all'
        });
        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'vehicle', 'service', 'agreement', 'corporatesList', 'operation_point'];

        vm.filterData = {
            branch_value: '',
        };

        if ($cookies.get('branch')) {
            vm.filterData.branch_value = JSON.parse($cookies.get('branch'));
        }
        console.log(vm.filterData.branch_value)

        getMatrix();

        function getMatrix() {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.id = Number(vm.id);
            console.log(dataSend);
            var promise = fleetCapacityMatrixService.getMatriz(dataSend);
            promise.then(function (payload) {
                vm.loading = false;
                console.log(payload)
                vm.dates = payload.title.data.matrizFlotaBloques;
                vm.typeOfService = payload.title.data.matrizFlotaTypeOfService;
                vm.sucursal = payload.title.data.sucursal.regionName;
                vm.nombre = payload.title.data.nombre;
                vm.sucursal_id = payload.title.data.sucursalId;
                vm.matriz = payload.title.data;
                // vm.blocks = payload.title.data.bloques;
                // vm.dataForBlock.sucursal_id = payload.title.data.sucursal_id;
                vm.type_of_service_names = vm.typeOfService.map(function(item) { return item['typeOfService']['serviceName'] });
                vm.type_of_service_names = vm.type_of_service_names.join();

                angular.forEach(payload.title.data.matrizFlotaExcepciones, function(value) {
                    vm.exceptions.push({
                        id: value.id,
                        hora_inicio: moment(value.fechaInicio).format('H:mm'),
                        hora_fin: moment(value.fechaFin).format('H:mm'),
                        start_date: moment(value.fechaInicio).format('DD MMM YYYY'),
                        start_date_format: moment(value.fechaInicio).format('YYYY-MM-DD'),
                        end_date: moment(value.fechaFin).format('DD MMM YYYY'),
                        end_date_format: moment(value.fechaFin).format('YYYY-MM-DD'),
                        matriz_flota_id: value.matrizFlotaId,
                        cupos: value.cupos,
                        isData: true,
                        status: value.status
                    })
                });
        
            }, function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function handleExceptions() {
            vm.showExceptions = !vm.showExceptions;
        }

        //function handleExceptions() {
            //if(vm.matriz){
                //$state.go('layout.fleetCapacityMatrixMain.fleetCapacityMatrixExceptions', {
                    //matriz:vm.matriz,
                    //sucursal: vm.sucursal
                //});
            //}else {
                //$state.go('layout.fleetCapacityMatrixMain.fleetCapacityMatrixExceptions', {
                    //exception:vm.params.exception,
                    //matriz: {
                        //sucursal_id: vm.sucursal_id,
                        //bloques: vm.dates,
                        //sucursal: vm.sucursal
                    //}
                //});
            //}
        //}


        function handleCalendar() {
            $state.go('layout.fleetCapacityMatrixMain.fleetCapacityMatrixCalendar', {
                matriz:vm.matriz,
                id: vm.id
            });
        }





        function getBranch() {
          
            vm.loading = true;
            var promise = getGeofence.branch();
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        var where = _.where(payload.title.data, {
                            parent_id: 0
                        });
                        //vm.branchList = _.where(where, { is_active: 1 });
                        vm.branchList = where;
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    // vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        // WHen Page refresh service take time to get data from backend
        // setTimeout(function () {
        getBranch();

        function branchChanged(type) {
            if (type) {
                if (vm.filterData.branch_value_package != 'all')
                    $cookies.put('branchPackage', vm.filterData.branch_value_package);
            } else {
                if (vm.filterData.branch_value != 'all')
                    $cookies.put('branch', vm.filterData.branch_value);
            }
            // vm.agreement = [];
            // vm.branchList = [];
            // vm.vehicle = [];
            // clearOffset();
            // vm.filterObject.branch_offset  = 0;
            // getFilterDataFromBackend();
        }




        function cancel() {
            $state.go('layout.fleetCapacityMatrixMain.fleetCapacityMatrix', {
                typeSelected:'lala',
                sucursalSelected: $stateParams.sucursal,
                estadoSelected: $stateParams.estado
            });
        }

       
      
        
        function filterDay(day) {
            var dia = '';
            if(day == '1') dia = 'Lunes'
            else if(day == '2') dia = 'Martes'
            else if(day == '3') dia = 'Miércoles'
            else if(day == '4') dia = 'Jueves'
            else if(day == '5') dia = 'Viernes'
            else if(day == '6') dia = 'Sábado'
            else if(day == '7') dia = 'Domingo'

            return dia;
        }



    


       


    }

})();

/**
 * Created by cl-macmini-51 on 4/14/17.
 */
 (function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('FleetCapacityMatrixCreateController', FleetCapacityMatrixCreateController);

    /** @ngInject */
    function FleetCapacityMatrixCreateController($cookies, $state, $log, $http,$stateParams,MY_CONSTANT, $timeout, $rootScope, $interval, $scope, adminAccessService,mapDashboard, getDrivers, getVehicles, getServices, getAgreement, getGeofence, $mdDialog, $document, $filter, getBookings, languageBasedErrorFactory, errorMessageFactory, getFilters, Initializer,fleetCapacityMatrixService) {
        var vm = this;
        var markers = [];
        var mc = null;
        vm.count = 0;
        vm.params = $stateParams;
        var isEdit = false;
        if($stateParams.id){
            vm.id = $stateParams.id;
        }
        vm.approvalValueChanged = approvalValueChanged;
        vm.bloqueChanged = bloqueChanged;
        vm.paginationChangedForBranch = paginationChangedForBranch;
        vm.branchChanged = branchChanged;
        vm.onChangeName = onChangeName;
        vm.typeOfserviceChanged = typeOfserviceChanged;
        // vm.branchList = [];
        vm.filterData = {
            branch_value: '',
        };
        vm.obj = [];
        vm.objE = [];
        vm.serviceList = [];
        vm.cancel = cancel;
        vm.filterDay = filterDay;
        vm.addBlock = addBlock;
        vm.addException = addException;
        vm.editBlock = editBlock;
        vm.isAdd = false;
        vm.isAddException = false;
        vm.editBlockId = 0;
        vm.saveBlock = saveBlock;
        vm.saveException = saveException;
        vm.removeBlock = removeBlock;
        vm.removeException = removeException;
        vm.blocks = [];
        vm.exceptions = [];
        vm.handleExceptions = handleExceptions;
        vm.showExceptions = false;
        vm.typeOfserviceUsed = [];
        vm.dataForBlock = {
            sucursal_id: '',
            nombre: '',
            dia_inicio:'',
            dia_fin:'',
            cupos: '',
            fecha_inicio: {
                hora: '00:00',
                minute: '00'
            },
            fecha_fin: {
                hora: '01:00', 
                minute: '15'
            },
        };


        if(vm.params.create) {
            if(vm.params.matriz){
                vm.dataForBlock.sucursal_id = vm.params.matriz.sucursal_id
                vm.dataForBlock.nombre = vm.params.matriz.nombre
                vm.blocks = vm.params.matriz.bloques
            }
        }
        if($stateParams.exception && $stateParams.exception == 1){
            vm.handleExceptions();
        }


        vm.hoursArray = [{
                value: 0,
                id: '00:00'
            },
            {
                value: 1,
                id: '01:00'
            },
            {
                value: 2,
                id: '02:00'
            },
            {
                value: 3,
                id: '03:00'
            },
            {
                value: 4,
                id: '04:00'
            },
            {
                value: 5,
                id: '05:00'
            },
            {
                value: 6,
                id: '06:00'
            },
            {
                value: 7,
                id: '07:00'
            },
            {
                value: 8,
                id: '08:00'
            },
            {
                value: 9,
                id: '09:00'
            },
            {
                value: 10,
                id: '10:00'
            },
            {
                value: 11,
                id: '11:00'
            },
            {
                value: 12,
                id: '12:00'
            },
            {
                value: 13,
                id: '13:00'
            },
            {
                value: 14,
                id: '14:00'
            },
            {
                value: 15,
                id: '15:00'
            },
            {
                value: 16,
                id: '16:00'
            },
            {
                value: 17,
                id: '17:00'
            },
            {
                value: 18,
                id: '18:00'
            },
            {
                value: 19,
                id: '19:00'
            },
            {
                value: 20,
                id: '20:00'
            },
            {
                value: 21,
                id: '21:00'
            },
            {
                value: 22,
                id: '22:00'
            },
            {
                value: 23,
                id: '23:00'
            }
        ]


        vm.minutesArray = [{
            value: 0,
            id: '00'
            },
            {
                value: 1,
                id: '15'
            },
            {
                value: 2,
                id: '30'
            },
            {
                value: 3,
                id: '45'
            },
        ]

        if(vm.id){
            isEdit = true;
            getMatrix();
        }
        
        function getMatrix() {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.id = Number(vm.id);
            console.log(dataSend);
            var promise = fleetCapacityMatrixService.getMatriz(dataSend);
            promise.then(function (payload) {
                vm.loading = false;
                vm.exceptions = [];
                vm.blocks = payload.title.data.matrizFlotaBloques;
                vm.dataForBlock.typeOfService = payload.title.data.matrizFlotaTypeOfService;
                vm.dataForBlock.sucursal_id = payload.title.data.sucursalId;
                vm.dataForBlock.sucursal = payload.title.data.sucursal.regionName.toUpperCase();
                vm.dataForBlock.nombre = payload.title.data.nombre;
                vm.dataForBlock.type_of_service_id = [];

                angular.forEach(vm.dataForBlock.typeOfService, function(value) {
                    vm.dataForBlock.type_of_service_id.push({
                        id: value.typeOfService.id,
                        service_name: value.typeOfService.serviceName,
                        dataId: value.id
                    })

                });
                $timeout(function () {
                    typeOfserviceChanged(null,vm.dataForBlock.type_of_service_id);
                }, 1000);
                angular.forEach(payload.title.data.matrizFlotaExcepciones, function(value) {
                    vm.exceptions.push({
                        id: value.id,
                        hora_inicio: moment(value.fechaInicio).format('H:mm'),
                        hora_fin: moment(value.fechaFin).format('H:mm'),
                        start_date: moment(value.fechaInicio).format('DD MMM YYYY'),
                        start_date_format: moment(value.fechaInicio).format('YYYY-MM-DD'),
                        end_date: moment(value.fechaFin).format('DD MMM YYYY'),
                        end_date_format: moment(value.fechaFin).format('YYYY-MM-DD'),
                        matriz_flota_id: value.matrizFlotaId,
                        cupos: value.cupos,
                        isData: true,
                        status: value.status
                    })

                });
            }, function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

    function getTypeOfServiceUsed(branch_id) {
        vm.loading = true;
        vm.serviceList.forEach(function(service) {
            service.deshabilitado = false;
        });
        var dataSend = {};
        dataSend.access_token = $cookies.get('obj');
        dataSend.branch_id = Number(branch_id);
        if(isEdit){
            dataSend.id = Number(vm.id);
        }
        var promise = fleetCapacityMatrixService.getTypeOfServiceUsed(dataSend);
        promise.then(function (payload) {
            vm.loading = false;
            vm.typeOfserviceUsed = payload.title.data;
            angular.forEach(vm.typeOfserviceUsed, function(value) {
                var elementoADeshabilitar = vm.serviceList.find(function(service) {
                    return service.id === value.id;
                });

                if (elementoADeshabilitar) {
                    elementoADeshabilitar.deshabilitado = true;
                }
            });
            if(vm.dataForBlock.type_of_service_id && angular.isArray(vm.dataForBlock.type_of_service_id)){
                vm.dataForBlock.type_of_service_id = vm.dataForBlock.type_of_service_id.filter(function(servicioSeleccionado) {
                    return !vm.typeOfserviceUsed.some(function(servicioDesactivado) {
                        return servicioSeleccionado.id === servicioDesactivado.id;
                    });
                });
            }
            $timeout(function () {
                typeOfserviceChanged(null,vm.dataForBlock.type_of_service_id);
            }, 500);
        }, function(errorPayload) {
            $log.log(errorPayload);
            vm.loading = false;
            if (errorPayload.data.status == 401) {
                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
            } else {
                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
            }
        });
    }

      
        if ($cookies.get('branch')) {
            vm.filterData.branch_value = JSON.parse($cookies.get('branch'));
        }
        
        function addBlock() {
            vm.isAdd = !vm.isAdd;
            vm.editBlockId = 0;
            vm.dataForBlock = {
                sucursal: vm.dataForBlock.sucursal,
                sucursal_id: vm.dataForBlock.sucursal_id,
                nombre: vm.dataForBlock.nombre,
                typeOfService: vm.dataForBlock.typeOfService,
                type_of_service_id: vm.dataForBlock.type_of_service_id,
                dia_inicio:'',
                dia_fin:'',
                cupos: '',
                fecha_inicio: {
                    hora: '00:00',
                    minute: '00'
                },
                fecha_fin: {
                    hora: '01:00', 
                    minute: '15'
                },
            };
        }

        function addException() {
            vm.isAddException = !vm.isAddException;
        }

        function editBlock(data) {
            vm.editBlockId = data.id;
            vm.dataForBlock = {
                sucursal: vm.dataForBlock.sucursal,
                sucursal_id: vm.dataForBlock.sucursal_id,
                nombre: vm.dataForBlock.nombre,
                typeOfService: vm.dataForBlock.typeOfService,
                type_of_service_id: vm.dataForBlock.type_of_service_id,
                dia_inicio: data.diaInicio,
                dia_fin: data.diaFin,
                cupos: data.cupos,
                    fecha_inicio: {
                    hora: data.horaInicio,
                    minute: '00'
                },
                fecha_fin: {
                    hora: data.horaFin, 
                    minute: '00'
                },
            };
        }

        function cancel() {
            $state.go('layout.fleetCapacityMatrixMain.fleetCapacityMatrix', {
                typeSelected:'lala'
            });
        }

        function handleExceptions() {
            vm.showExceptions = !vm.showExceptions;
        }


        //function handleExceptions() {
            //if(vm.params.matriz){
                //$state.go('layout.fleetCapacityMatrixMain.fleetCapacityMatrixExceptions', {
                    //matriz:vm.params.matriz,
                    //sucursal: vm.dataForBlock.sucursal,
                    //id: vm.id
                //});
            //}else {
                //$state.go('layout.fleetCapacityMatrixMain.fleetCapacityMatrixExceptions', {
                    //exception:vm.params.exception,
                    //matriz: {
                        //sucursal_id: vm.dataForBlock.sucursal_id,
                        //bloques: vm.blocks
                    //},
                    //sucursal: vm.dataForBlock.sucursal,
                    //id: vm.id
                //});
            //}
        //}


        function saveBlock(data,$event) {

            if(!data.fecha_inicio.hora || !data.fecha_fin.hora || !data.dia_inicio || !data.dia_fin || isNaN(parseInt(data.cupos)) ) {
                errorMessageFactory.showErrorMessage('Todos los campos son obligatorios.', 0);
                return;
              }
            
            if(data.dia_inicio > data.dia_fin){
                    errorMessageFactory.showErrorMessage('El día de inicio no puede ser superior al día de termino', 0);
                    return;
                }


                if(data.dia_inicio == data.dia_fin) {
                    if(data.fecha_inicio.hora == data.fecha_fin.hora ){
                        errorMessageFactory.showErrorMessage('La hora de termino debe ser distinta a la hora de inicio.', 0);
                        return;
                    }
                }

    
            // for (var i = 0; i < vm.blocks.length; i++) {
            //     if(vm.blocks[i].dia == data.dia){
            //         if(vm.blocks[i].hora_fin > [data.fecha_inicio.hora, ':', data.fecha_inicio.minute].join('') && vm.blocks[i].hora_inicio < [data.fecha_fin.hora, ':', data.fecha_fin.minute].join('')) {
            //             errorMessageFactory.showErrorMessage('Ya existe un bloque horario creado entre ese rango horas.', 0);
            //             return;
            //         }
            //     }

            // }

            for (var i = 0; i < vm.blocks.length; i++) {
                if(vm.blocks[i].diaInicio == data.dia_inicio && vm.blocks[i].diaFin >= data.dia_inicio || vm.blocks[i].diaInicio <= data.dia_inicio && vm.blocks[i].diaFin >= data.dia_inicio){
                    if(vm.blocks[i].horaFin > data.fecha_inicio.hora && vm.blocks[i].horaInicio < data.fecha_fin.hora) {
                        errorMessageFactory.showErrorMessage('Ya existe un bloque horario creado entre ese rango horas.', 0);
                        return; 
                    }
                }

            }


            if(!data.fecha_inicio.hora || !data.fecha_inicio.minute || !data.fecha_fin.hora || !data.fecha_fin.minute || !data.dia_inicio || !data.dia_fin || isNaN(parseInt(data.cupos))) {
              errorMessageFactory.showErrorMessage('Todos los campos son obligatorios.', 0);
              return;
            }
            if(data.dia_inicio == data.dia_fin) {
                if(data.fecha_inicio.hora >= data.fecha_fin.hora) {
                        errorMessageFactory.showErrorMessage('La hora de inicio debe ser superior a la hora de termino.', 0);
                        return;
                }
            }
            vm.addBlock();
            var dataSend = {
                diaInicio: Number(data.dia_inicio),
                diaFin: Number(data.dia_fin),
                horaInicio:data.fecha_inicio.hora ? data.fecha_inicio.hora : '',
                horaFin: data.fecha_fin.hora ? data.fecha_fin.hora : '',
                cupos: data.cupos,
                status: true
            };
            if(vm.id){
                dataSend.matrizFlotaId = vm.id;
            }
    
            vm.blocks.push(dataSend);
            vm.dataForBlock = {
                sucursal: vm.dataForBlock.sucursal,
                sucursal_id: vm.dataForBlock.sucursal_id,
                nombre: vm.dataForBlock.nombre,
                typeOfService: vm.dataForBlock.typeOfService,
                type_of_service_id: vm.dataForBlock.type_of_service_id,
                dia_inicio:'',
                dia_fin:'',
                cupos: '',
                fecha_inicio: {
                    hora: '00:00',
                    minute: '00'
                },
                fecha_fin: {
                    hora: '01:00', 
                    minute: '15'
                },
            };
        }

        function saveException(data) {

            if(!data.fecha_inicio.hora || !data.fecha_fin.hora || !data.start_date || !data.end_date || isNaN(parseInt(data.cupos)) ) {
               errorMessageFactory.showErrorMessage('Todos los campos son obligatorios.', 0);
               return;
             }

            if(data.start_date.getTime() > data.end_date.getTime()){
                errorMessageFactory.showErrorMessage('La fecha de inicio no puede ser superior a la fecha de termino', 0);
                return;
            }


              for (var i = 0; i < vm.exceptions.length; i++) {
                if (vm.exceptions[i].status != false && 
                    Math.min(new Date(moment(vm.exceptions[i].start_date).format('YYYY-MM-DD') + 'T' + vm.exceptions[i].hora_inicio).getTime(), new Date(moment(vm.exceptions[i].end_date).format('YYYY-MM-DD') + 'T' + vm.exceptions[i].hora_fin).getTime()) 
                    < Math.max(new Date(moment(data.start_date).format('YYYY-MM-DD') + 'T' + data.fecha_inicio.hora).getTime(), new Date(moment(data.end_date).format('YYYY-MM-DD') + 'T' + data.fecha_fin.hora).getTime()) 
                    && Math.max(new Date(moment(vm.exceptions[i].start_date).format('YYYY-MM-DD') + 'T' + vm.exceptions[i].hora_inicio).getTime(), new Date(moment(vm.exceptions[i].end_date).format('YYYY-MM-DD') + 'T' + vm.exceptions[i].hora_fin).getTime()) 
                    > Math.min(new Date(moment(data.start_date).format('YYYY-MM-DD') + 'T' + data.fecha_inicio.hora).getTime(), new Date(moment(data.end_date).format('YYYY-MM-DD') + 'T' + data.fecha_fin.hora).getTime())) {
                        errorMessageFactory.showErrorMessage('Ya existe una excepción creada entre ese rango horas.', 0);
                        return;
                }
  
              }


              if(data.start_date.getTime() == data.end_date.getTime()) {
                if(data.fecha_inicio.hora >= data.fecha_fin.hora ){
                    errorMessageFactory.showErrorMessage('La hora de inicio no puede ser igual o mayor a la hora de termino.', 0);
                    return;
                }
            }

            

            vm.addException();
            var dataSend = {
                start_date: moment(data.start_date).format('DD MMM YYYY'),
                start_date_format: moment(data.start_date).format('YYYY-MM-DD'),
                end_date: moment(data.end_date).format('YYYY MMM DD'),
                end_date_format: moment(data.end_date).format('YYYY-MM-DD'),
                hora_inicio:data.fecha_inicio.hora ? data.fecha_inicio.hora : '',
                hora_fin: data.fecha_fin.hora ? data.fecha_fin.hora : '',
                cupos: data.cupos,
                status: true
            };
    
            vm.exceptions.push(dataSend);


            
            //vm.dataForBlock = {
                //sucursal_id: '',
                //dia_inicio:'',
                //dia_fin:'',
                //cupos: '',
                //start_date: '',
                //end_date: '',
                //fecha_inicio: {
                    //hora: '00:00',
                    //minute: '00'
                //},
                //fecha_fin: {
                    //hora: '01:00', 
                    //minute: '15'
                //},
            //};
        }


        $scope.guardar_datos = function(formInstance,e) {
            // if(!formInstance.nombre.$valid) {
            //     vm.isError = true;
            // }
            // if(!formInstance.$valid) {
            //     return;
            // }
            
            if(!vm.dataForBlock.sucursal_id){
                errorMessageFactory.showErrorMessage('Debe seleccionar una sucursal', 0);
                return;
            }

            if(vm.dataForBlock.type_of_service_id.length == 0){
                errorMessageFactory.showErrorMessage('Debe seleccionar a lo menos un tipo de servicio', 0);
                return;
            }

            
            if(vm.blocks.length < 1) {
                errorMessageFactory.showErrorMessage('Debe agregar un bloque horario', 0);
                return;
            }

            // for (var i = 1; i < $scope.dataForInstance.params.length; i++) {
            //     vm.obj.push({ id:i, value:$scope.dataForInstance.params[i]})
            // }

            for (var i = 0; i < vm.blocks.length; i++) {
                if(vm.id){
                    vm.obj.push({id: Number(vm.blocks[i].id),diaInicio:vm.blocks[i].diaInicio, diaFin:vm.blocks[i].diaFin,horaInicio:vm.blocks[i].horaInicio, horaFin:vm.blocks[i].horaFin, cupos:vm.blocks[i].cupos, matrizFlotaId:  Number(vm.id), status: true });
                }else {
                    vm.obj.push({ diaInicio:vm.blocks[i].diaInicio, diaFin:vm.blocks[i].diaFin,horaInicio:vm.blocks[i].horaInicio, horaFin:vm.blocks[i].horaFin, cupos:vm.blocks[i].cupos, status: true });
                }
            }
            if(vm.id) {
                for (var i = 0; i < vm.exceptions.length; i++) {
                    if(vm.exceptions[i].id) {
                        vm.objE.push({id: Number(vm.exceptions[i].id), fechaInicio:vm.exceptions[i].start_date_format + ' ' + vm.exceptions[i].hora_inicio, fechaFin:vm.exceptions[i].end_date_format + ' ' + vm.exceptions[i].hora_fin, cupos:vm.exceptions[i].cupos, status:vm.exceptions[i].status, matrizFlotaId: Number(vm.id) })
                    }else {
                        console.log('lala')
                        vm.objE.push({fechaInicio: vm.exceptions[i].start_date_format + ' ' + vm.exceptions[i].hora_inicio, fechaFin: vm.exceptions[i].end_date_format + ' ' + vm.exceptions[i].hora_fin, cupos:vm.exceptions[i].cupos, status: vm.exceptions[i].status, matrizFlotaId: Number(vm.id) })
                    }
                }
            } else {
                for (var i = 0; i < vm.exceptions.length; i++) {
                    vm.objE.push({fechaInicio:vm.exceptions[i].start_date_format + ' ' + vm.exceptions[i].hora_inicio, fechaFin:vm.exceptions[i].end_date_format + ' ' + vm.exceptions[i].hora_fin, cupos:vm.exceptions[i].cupos, status: vm.exceptions[i].status })
                }

            }

            var sendTypeOfService = []

            for (var i = 0; i < vm.dataForBlock.type_of_service_id.length; i++) {
                if(vm.id) {
                    if(vm.dataForBlock.type_of_service_id[i].dataId){
                        sendTypeOfService.push({ id: Number(vm.dataForBlock.type_of_service_id[i].dataId), matrizFlotaId: Number(vm.id), typeOfServiceId: vm.dataForBlock.type_of_service_id[i].id, status: true, typeOfService: {id: vm.dataForBlock.type_of_service_id[i].id, serviceName: vm.dataForBlock.type_of_service_id[i].service_name } })
                    } else {
                        sendTypeOfService.push({ matrizFlotaId: Number(vm.id), typeOfServiceId: vm.dataForBlock.type_of_service_id[i].id,  status: true, typeOfService: {id: vm.dataForBlock.type_of_service_id[i].id, serviceName: vm.dataForBlock.type_of_service_id[i].service_name } })
                    }
                } else {
                    sendTypeOfService.push({ typeOfServiceId: vm.dataForBlock.type_of_service_id[i].id, status: true, typeOfService: {id: vm.dataForBlock.type_of_service_id[i].id, serviceName: vm.dataForBlock.type_of_service_id[i].service_name } })
                }
            }

            vm.loading = true;
            var toSend = {};
            var promise;
            toSend.access_token = $cookies.get('obj');
            toSend.sucursalId = vm.dataForBlock.sucursal_id;
            toSend.nombre = vm.dataForBlock.nombre;
            toSend.typeOfService =  vm.dataForBlock.type_of_service_id;
            toSend.nombre = vm.dataForBlock.nombre;
            toSend.matrizFlotaTypeOfService = sendTypeOfService;
            toSend.matrizFlotaBloques = vm.obj;
            toSend.matrizFlotaExcepciones = vm.objE;
            console.log('SE ENVIA',toSend);
            if(vm.id) {
                toSend.id = Number(vm.id);
                promise = fleetCapacityMatrixService.updateMatrix(toSend);
            }else {
                promise = fleetCapacityMatrixService.addMatrix(toSend);
            }
            promise.then(function (payload) {
                $log.log('sxdsads', payload);
                console.log('sxdsads', payload)
                vm.loading = false;
                
                if (payload.title.status == 400) {
                    errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    return [];
                }
                else if (payload.title.status == 100) {
                    errorMessageFactory.showErrorMessage(payload.title.message, 2);
                    return [];
                }
                else if (payload.title.status == 401) {
                    errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    return [];
                }else if(payload.title.status == 201){
                    errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    return [];
                }
                else if (payload.title.status == 200 || payload.title.status == 'ok') {
                    if(vm.id)  {
                        languageBasedErrorFactory.getProperErrorMessage('fleetCapacityMatrixUpdateSucc', 0, 2, 'layout.fleetCapacityMatrixMain.fleetCapacityMatrix');
                    }else {
                        languageBasedErrorFactory.getProperErrorMessage('fleetCapacityMatrixCreateSucc', 0, 2, 'layout.fleetCapacityMatrixMain.fleetCapacityMatrix');
                    }
                    $state.go('layout.fleetCapacityMatrixMain.fleetCapacityMatrix', {
                        estadoSelected: vm.params.estado
                    });
                    guardarExcepcion(payload.title.data.matriz_id)
                    // if(vm.params.exception){
                    //     if(vm.id){
                    //         guardarExcepcion(vm.id)
                    //     }else {
                    //         guardarExcepcion(payload.title.data.matriz_id)
                    //     }
                    // }
                    
                }
               
            }, function (errorPayload) {
                    console.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }

            
            );
            vm.obj = [];

        }


        function guardarExcepcion(id) {
            console.log(vm.params.exception)
            vm.loading = true;
            var toSend = {};
            toSend.access_token = $cookies.get('obj');
            toSend.bloques = vm.params.exception;
            toSend.id = id;
            console.log(toSend);

            var promise = fleetCapacityMatrixService.addException(toSend);
           
            promise.then(function (payload) {
                $log.log('sxdsads', payload);
                console.log('sxdsads', payload)
                vm.loading = false;
                
                if (payload.title.status == 400) {
                    errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    return [];
                } else if (payload.title.status == 401) {
                    errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    return [];
                }else if(payload.title.status == 201){
                    errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    return [];
                }
                else if (payload.title.status == 200) {
                    languageBasedErrorFactory.getProperErrorMessage('createExceptionSucc', 0, 2, 'layout.fleetCapacityMatrixMain.fleetCapacityMatrix');
                    $state.go('layout.fleetCapacityMatrixMain.fleetCapacityMatrix', {
                        typeSelected: 'lala'
                    });
                }
               
            }, function (errorPayload) {
                    console.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }

            
            );

        }




        function removeBlock(value) {
            var confirm = $mdDialog.confirm()
                .title('¿Desea eliminar el bloque?')
                .textContent('')
                .ariaLabel('Lucky day')
                //.targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                var index = vm.blocks.indexOf(value);
                vm.blocks.splice(index, 1); 
            });
        }

        function removeException(indice) {
            var confirm = $mdDialog.confirm()
                .title('¿Desea eliminar la excepción?')
                .textContent('')
                .ariaLabel('Lucky day')
                //.targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                vm.exceptions[indice].status = false;
            });
        }

        function getAllAggrements() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.offset = 0;
            dataSend.limit = 0;
            dataSend.key = 3;
            vm.loading = true;
            var promise = getAgreement.allAgreements(dataSend);
            promise.then(
                function(payload) {
                    $log.log('allagree', payload);
                    vm.loading = false;
                    var where = payload.title.data.result;
                    vm.branchList = where[0].branch;
                    vm.serviceList = where[0].type_of_service;
                    vm.serviceList.forEach(function(service) {
                        service.deshabilitado = false;
                    });
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        //getAllAggrements();
        function getBranch() {
          
            vm.loading = true;
            var promise = getGeofence.branch();
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        var where = _.where(payload.title.data, {
                            parent_id: 0
                        });
                        //vm.branchList = _.where(where, { is_active: 1 });
                        vm.branchList = where;
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    // vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        getBranch();

        function getAllServices(skip, limit) {
            vm.loading = false;
            var promise = getServices.allServices(skip, limit, 1, 0);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.serviceList = payload.title.data.result;
                        vm.serviceList.forEach(function(service) {
                            service.deshabilitado = false;
                        });

                        //vm.serviceList = [];
                        //angular.forEach(payload.title.data.result, function (column) {
                            //vm.serviceList.push({
                                //id: column.id,
                                //name: column.service_name
                            //});
                        //});
                        //vm.serviceListFilterGot.push({
                            //id: 'all',
                            //name: 'All'
                        //})
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllServices(0, 100);
        if(isEdit){
            $timeout(function () {
                getTypeOfServiceUsed(vm.dataForBlock.sucursal_id);
            }, 800)
        }

        function branchChanged(type,value, name) {
            vm.dataForBlock.sucursal = name;
            getTypeOfServiceUsed(value);
            // console.log(value);
            // vm.dataForBlock.sucursal_id = value
            // if (type) {
            //     if (vm.filterData.branch_value_package != 'all')
            //         $cookies.put('branchPackage', vm.filterData.branch_value_package);
            // } else {
            //     if (vm.filterData.branch_value != 'all')
            //         $cookies.put('branch', vm.filterData.branch_ value);
            // }
    
        }

        function onChangeName(type, value) {
            console.log("CAMBIA NOMBRE", value, type);
        }

        function typeOfserviceChanged(type,data) {
            vm.dataForBlock.type_of_service_id = [];
            if(angular.isArray(data)) {
                angular.forEach(data, function(value, index) {
                    if(value.type_of_service_id){
                        vm.dataForBlock.type_of_service_id.push({
                            id: value.id,
                            service_name: value.service_name
                        })
                    } else {
                        vm.dataForBlock.type_of_service_id.push({
                            id: value.id,
                            service_name: value.service_name
                        });
                        if(value.dataId){
                            vm.dataForBlock.type_of_service_id[index].dataId = value.dataId;
                        }
                    }
                });
            }
            console.log(vm.dataForBlock.type_of_service_id);

            vm.serviceList.forEach(function(service) {
                service.deshabilitado = false;
            });
            angular.forEach(vm.typeOfserviceUsed, function(value) {
                var elementoADeshabilitar = vm.serviceList.find(function(service) {
                    return service.id === value.id;
                });

                if (elementoADeshabilitar) {
                    elementoADeshabilitar.deshabilitado = true;
                }
            });

            angular.forEach(vm.dataForBlock.type_of_service_id, function(value) {
                var elementoADeshabilitar = vm.serviceList.find(function(service) {
                    return service.id === value.id;
                });

                if (elementoADeshabilitar) {
                    elementoADeshabilitar.deshabilitado = true;
                }
            });





            //angular.forEach(data, function(value) {
                //vm.dataForBlock.type_of_service_id = [value.type_of_service_id.id]
            //});
            //vm.dataForBlock.type_of_service_id.filter(function(el, i, a){ return i == a.indexOf(el) });
            //
            //vm.dataForBlock.type_of_service_id = id
        }

        function paginationChangedForBranch() {

        }
    
        function approvalValueChanged() {
            // vm.currentPage = 0;
            // if (vm.filterData.verification_stage && vm.filterData.verification_stage != 'all') {
            //     vm.filterData.filter_verification_stage = 1;
            //     getFilterDriverHit(0, vm.itemsPerPageGot, vm.filterData);
            // } else {
            //     vm.filterData.filter_verification_stage = 0;
            //     vm.filterData.verification_stage = 'all';
            //     getFilterDriverHit(0, vm.itemsPerPageGot, vm.filterData);
            // }
        };

        function bloqueChanged(data){
            if(isNaN(parseInt(vm.dataForBlock.cupos)) || !vm.dataForBlock.fecha_inicio.hora || !vm.dataForBlock.fecha_fin.hora) {
                errorMessageFactory.showErrorMessage('Todos los campos son obligatorios.', 0);
                return;
            }
            if(vm.dataForBlock.dia_inicio > vm.dataForBlock.dia_fin){
                errorMessageFactory.showErrorMessage('El día de inicio no puede ser superior al día de termino', 0);
                return;
            }


            if(vm.dataForBlock.dia_inicio == vm.dataForBlock.dia_fin) {
                if(vm.dataForBlock.fecha_inicio.hora == vm.dataForBlock.fecha_fin.hora ){
                    errorMessageFactory.showErrorMessage('La hora de termino debe ser distinta a la hora de inicio.', 0);
                    return;
                }
            }
            for(i=0; i < vm.blocks.length; i++){
                var v = vm.blocks[i];
                if(data.id == v.id){
                    vm.blocks[i].diaInicio = vm.dataForBlock.dia_inicio;
                    vm.blocks[i].diaFin = vm.dataForBlock.dia_fin;
                    vm.blocks[i].cupos = vm.dataForBlock.cupos;
                    vm.blocks[i].horaInicio = vm.dataForBlock.fecha_inicio.hora;
                    vm.blocks[i].horaFin = vm.dataForBlock.fecha_fin.hora;
                }
            }
            vm.editBlockId = 0;
        }

        function filterDay(day) {
            var dia = '';
            if(day == '1') dia = 'Lunes'
            else if(day == '2') dia = 'Martes'
            else if(day == '3') dia = 'Miércoles'
            else if(day == '4') dia = 'Jueves'
            else if(day == '5') dia = 'Viernes'
            else if(day == '6') dia = 'Sábado'
            else if(day == '7') dia = 'Domingo'

            return dia;
        }

    }

})();

/**
 * Created by cl-macmini-51 on 4/14/17.
 */
 (function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('FleetCapacityMatrixController', FleetCapacityMatrixController);

    /** @ngInject */
    function FleetCapacityMatrixController($cookies, $state, $log, $http,$stateParams,MY_CONSTANT, $timeout, $rootScope, $interval, $scope, adminAccessService,mapDashboard, getDrivers, getVehicles, getServices, getAgreement, getGeofence, $mdDialog, $document, $filter, getBookings, languageBasedErrorFactory, errorMessageFactory, getFilters, Initializer,fleetCapacityMatrixService) {
        var vm = this;
        var markers = [];
        var mc = null;
        vm.count = 0;
        vm.activeFleet = [];
        vm.dataFleet = {id:'', nombre: '', estado: 0,eliminable:0}
        vm.estado = $stateParams.estadoSelected || '1';
        vm.changeState = changeState;
        vm.viewDetail = viewDetail;
        vm.createAndEdit = createAndEdit;
        vm.deleteMatrix = deleteMatrix;
        vm.paginationChangedForBranch = paginationChangedForBranch;
        vm.branchSelected = $stateParams.sucursalSelected;
        vm.filterData = {
            branch_value: '',
        };
        vm.sucursal_id = $stateParams.sucursalSelected;
        vm.branchChanged = branchChanged;
        if ($cookies.get('branch')) {
            vm.filterData.branch_value = JSON.parse($cookies.get('branch'));
        }

        getMatrices();


        function getMatrices(){
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            var promise = fleetCapacityMatrixService.getMatrices(dataSend);
            promise.then(function (payload) {
                vm.loading = false;
                vm.activeFleet = payload.title.data;
            }, function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        
       
        function changeState($event,data) {
            var promise;
            vm.loading = true;
            var toSend = {};
            toSend.access_token = $cookies.get('obj');
            toSend.id = data.id
            toSend.status = data.status == true ? 0 : 1;
            
            console.log(toSend);
            var promise = fleetCapacityMatrixService.activeMatrix(toSend);
            promise.then(function (payload) {
                $log.log('sxdsads', payload);
                console.log('sxdsads', payload)
                vm.loading = false;
                
                if (payload.title.status == 400) {
                    errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    return [];
                } else if (payload.title.status == 401) {
                    errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    return [];
                }else if(payload.title.status == 201){
                    errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    return [];
                }
                else if (payload.title.status == 200) {
                    if(data.status == 0) {
                        languageBasedErrorFactory.getProperErrorMessage('fleetCapacityMatrixActiveSucc', 0, 2, 'layout.fleetCapacityMatrixMain.fleetCapacityMatrix');
                    }else {
                        languageBasedErrorFactory.getProperErrorMessage('fleetCapacityMatrixDeactivateSucc', 0, 2, 'layout.fleetCapacityMatrixMain.fleetCapacityMatrix');
                    }
                    $state.go('layout.fleetCapacityMatrixMain.fleetCapacityMatrix', {
                        typeSelected: 'lala'
                    });
                }

                getMatrices();
               
            }, function (errorPayload) {
                    console.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }

            
            );
            // vm.loading = true;
        
            // for (var i = 0; i < vm.activeFleet.length; i++) {
            //     if(vm.activeFleet[i].id == data.id){
            //         vm.activeFleet[i].estado = !vm.activeFleet[i].estado
            //     }

            // }
        }





        function viewDetail(data) {
            $state.go('layout.fleetCapacityMatrixMain.fleetCapacityMatrixDetail', {
                matriz: data,
                estado: vm.estado, 
                sucursal:  vm.branchSelected,
                id: data.id
            });

        }

        function createAndEdit(data,estado) {
            if(data){
                $state.go('layout.fleetCapacityMatrixMain.fleetCapacityMatrixCreate', {
                    matriz: data,
                    estado:estado,
                    id: data.id
                });
            }else {
                $state.go('layout.fleetCapacityMatrixMain.fleetCapacityMatrixCreate');
            }
        }

        function deleteMatrix($event,value) {
            console.log(value.id)
            // var index = vm.activeFleet.filter(function(v){
            //     if(v.id == value.id){
            //         console.log(v)
            //         vm.activeFleet.splice(v.id, 1);
            //     }
            // });
            // var index = vm.activeFleet.indexOf(value);
            // vm.activeFleet.splice(index, 1); 
            var confirm = $mdDialog.confirm()
                .title('¿Desea eliminar esta matriz?')
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {


            vm.loading = true;
            var toSend = {};
            toSend.access_token = $cookies.get('obj');
            toSend.id = value.id;
            toSend.deleted = true;

            console.log(toSend)
        
            var promise = fleetCapacityMatrixService.deleteMatrix(toSend);
            promise.then(function (payload) {
                console.log('sxdsads', payload)
                vm.loading = false;
                
                if (payload.title.status == 400) {
                    errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    return [];
                } else if (payload.title.status == 401) {
                    errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    return [];
                }else if(payload.title.status == 201){
                    errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    return [];
                }
                else if (payload.title.status == 200) {
                    languageBasedErrorFactory.getProperErrorMessage('fleetCapacityMatrixDeleteSucc', 0, 2, 'layout.fleetCapacityMatrixMain.fleetCapacityMatrix');
                    $state.go('layout.fleetCapacityMatrixMain.fleetCapacityMatrix', {
                        typeSelected: 'lala'
                    });
                }

                getMatrices();
               
            }, function (errorPayload) {
                    console.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }

            
            );

            });
            
        }


        function getAllAggrements() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.offset = 0;
            dataSend.limit = 0;
            dataSend.key = 3;
            vm.loading = true;
            var promise = getAgreement.allAgreements(dataSend);
            promise.then(
                function(payload) {
                    $log.log('allagree', payload);
                    vm.loading = false;
                    var where = payload.title.data.result;
                    vm.branchList = where[0].branch;
                    vm.serviceList = where[0].type_of_service;
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        //getAllAggrements();

        function getBranch() {
          
            vm.loading = true;
            var promise = getGeofence.branch();
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        var where = _.where(payload.title.data, {
                            parent_id: 0
                        });
                        //vm.branchList = _.where(where, { is_active: 1 });
                        vm.branchList = where;
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    // vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        getBranch();

        function getAllServices(skip, limit) {
            vm.loading = false;
            var promise = getServices.allServices(skip, limit, 1, 0);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.serviceList = payload.title.data.result;
                        vm.serviceList.forEach(function(service) {
                            service.deshabilitado = false;
                        });
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllServices(0, 100);



        function paginationChangedForBranch() {
            console.log(vm.sucursal_id)
        }

        function branchChanged(type,value) {
            //console.log(value);
            vm.branchSelected = value;
            // console.log(vm.sucursal_id)
            // console.log(vm.branchList)
            
            
            // console.log(value);
            // vm.dataForBlock.sucursal_id = value
            // if (type) {
            //     if (vm.filterData.branch_value_package != 'all')
            //         $cookies.put('branchPackage', vm.filterData.branch_value_package);
            // } else {
            //     if (vm.filterData.branch_value != 'all')
            //         $cookies.put('branch', vm.filterData.branch_ value);
            // }
    
        }



       


    }

})();

/**
 * Created by cl-macmini-51 on 4/14/17.
 */
 (function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('FleetCapacityMatrixCalendarController', FleetCapacityMatrixCalendarController);

    /** @ngInject */
    function FleetCapacityMatrixCalendarController($cookies, $state, $log, $http,$stateParams,MY_CONSTANT, $timeout, $rootScope, $interval,$scope,$compile,uiCalendarConfig,adminAccessService,mapDashboard, getDrivers, getVehicles, getServices, getAgreement, getGeofence, $mdDialog, $document, $filter, getBookings, languageBasedErrorFactory, errorMessageFactory, getFilters, Initializer,fleetCapacityMatrixService) {
        var vm = this;
        var markers = [];
        var mc = null;
        vm.count = 0;
        vm.activeFleet = [];
        vm.dataFleet = {id:'', nombre: '', estado: 0,eliminable:0}
        vm.estado = '1';
        
        vm.filterData = {
          branch_value: '',
        };
        if($stateParams.id){
            vm.id = Number($stateParams.id);
            getMatrix();
        }
        vm.events = [];
        vm.eventsE = [];
        vm.show_exce = 0
        vm.tipoServicios = [
            {id:1,nombre:'Ver lista'},{id:2, nombre:'Ver excepciones'}
        ];
        vm.params = $stateParams;
        //vm.sucursal = $stateParams.matriz.nombre
        console.log(vm.params)
        vm.cancel = cancel;
        vm.servicioSeleccionado = servicioSeleccionado;
        vm.handleExceptions = handleExceptions;
        vm.handleList = handleList;
        if ($cookies.get('branch')) {
          vm.filterData.branch_value = JSON.parse($cookies.get('branch'));
        }


        function servicioSeleccionado(id){
          vm.serviceSelected = id;
          if(id == 2) {
            $scope.events = [];
            vm.show_exce = 1
            getMatrixCalendar();
          }else {
            $scope.events = [];
            vm.show_exce = 0
            getMatrixCalendar();
          }
        }



        function handleList() {
          $state.go('layout.fleetCapacityMatrixMain.fleetCapacityMatrixCreate', {
            id: vm.id,
            exception: 0
          });
        }

        //function handleExceptions() {
            //$scope.events = [];
            //vm.show_exce = !vm.show_exce;
            //getMatrixCalendar();
        //}

        //function handleExceptions() {
          //$state.go('layout.fleetCapacityMatrixMain.fleetCapacityMatrixExceptions', {
              //matriz:vm.params.matriz,
              //sucursal: vm.sucursal,
              //id: vm.id
          //});
        //}

        function handleExceptions() {
            $state.go('layout.fleetCapacityMatrixMain.fleetCapacityMatrixCreate', {
                id: vm.id,
                exception: 1
            });
        }




    var date = new Date();
    var d = date.getDate();
    var m = date.getMonth();
    var y = date.getFullYear();
    var w = date.getHours();

    function startAndEndOfWeek(date) {
      var now = date ? new Date(date) : new Date();

      var monday = new Date(now);
      monday.setDate(monday.getDate() - monday.getDay() + 1);
      monday.setHours(0 - 3,0,0)

      var sunday = new Date(now);
      sunday.setDate(sunday.getDate() - sunday.getDay() + 7);
      sunday.setHours(23 - 3,59,0)

      return [monday, sunday];
    }
    

  var week = startAndEndOfWeek(date)



      function stringToDate(stringDate) {
        var date = new Date();
        var splitDate = stringDate.split(':');
        date.setHours(splitDate[0], splitDate[1], splitDate[2]);
        
        return date.toLocaleTimeString();
      }


      function cancel() {
        $state.go('layout.fleetCapacityMatrixMain.fleetCapacityMatrixDetail', {
          matriz:vm.params.matriz
        });
      }




    function getMatrix() {
        vm.loading = true;
        var dataSend = {};
        dataSend.access_token = $cookies.get('obj');
        dataSend.id = Number(vm.id);
        console.log(dataSend);
        var promise = fleetCapacityMatrixService.getMatriz(dataSend);
        promise.then(function (payload) {
            vm.loading = false;
            vm.sucursal = payload.title.data.sucursal.regionName.toUpperCase();
        }, function (errorPayload) {
                $log.log(errorPayload);
                vm.loading = false;
                if (errorPayload.data.status == 401) {
                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                } else {
                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                }
            }
        );
    }


    function branchChanged(type,value) {
      console.log(value);

    }



    $scope.events = [];
    $scope.eventsE = [];
    

    getMatrixCalendar();

    function getMatrixCalendar() {
        vm.events = [];
        vm.loading = true;
        var dataSend = {};
        dataSend.access_token = $cookies.get('obj');
        dataSend.id = Number(vm.id);
        dataSend.show_exce = 1;
        dataSend.start = week[0]
        dataSend.end = week[1]
        console.log(dataSend);
        var promise = fleetCapacityMatrixService.getCalendar(dataSend);
        promise.then(function (payload) {
            vm.loading = false;
            console.log(payload)
            vm.events = payload.title.data

            $scope.events.slice(0, $scope.events.length);
            angular.forEach(payload.title.data, function(value) {
              
                $scope.events.push({
                    // id: value.id,
                    title: value.cupos > 1 ? value.cupos + ' ' + 'cupos' :value.cupos + ' ' + 'cupo',
                    start: value.start,
                    end: value.end,
                    backgroundColor: value.is_excep ? '#3B8C17' : '#9C9C9C',
                    allDay: false
                });
            });
        }, function (errorPayload) {
                $log.log(errorPayload);
                vm.loading = false;
                if (errorPayload.data.status == 401) {
                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                } else {
                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                }
            }
        );
    }
    getMatrixCalendarExce();

    function getMatrixCalendarExce() {
        vm.eventsE = [];
        $scope.eventsE = [];
        $scope.eventSE = undefined;
        vm.loading = true;
        var dataSend = {};
        dataSend.access_token = $cookies.get('obj');
        dataSend.id = Number(vm.id);
        dataSend.show_exce = 1;
        dataSend.start = week[0]
        dataSend.end = week[1]
        console.log(dataSend);
        var promise = fleetCapacityMatrixService.getCalendar(dataSend);
        promise.then(function (payload) {
            vm.loading = false;
            console.log(payload)
            vm.eventsE = payload.title.data

            $scope.eventsE.slice(0, $scope.eventsE.length);
            angular.forEach(payload.title.data, function(value) {
              
                $scope.eventsE.push({
                    // id: value.id,
                    title: value.cupos > 1 ? value.cupos + ' ' + 'cupos' :value.cupos + ' ' + 'cupo',
                    start: value.start,
                    end: value.end,
                    backgroundColor: value.is_excep ? '#3B8C17' : '#9C9C9C',
                    allDay: false
                });
            });
            //$scope.eventsE = [$scope.eventsE];
        }, function (errorPayload) {
                $log.log(errorPayload);
                vm.loading = false;
                if (errorPayload.data.status == 401) {
                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                } else {
                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                }
            }
        );
    }


    /* config object */
    $scope.uiConfig = {
      calendar:{
        lang: 'es',
        locale: 'es',
        height: 450,
        editable: false,
        droppable: false,
        timeFormat: 'H:mm',
        allDaySlot:false,
        nowIndicator:true,
        slotDuration:'01:00:00',
        agendaEventMinHeight:1000,
        header:{
          left: '',
          center: '',
          right: '',
        },
        allDayText: '',
        displayEventTime:false,
        displayEventEnd: true,
        slotLabelFormat:"HH:mm",
        firstDay: 1,
        scrollTime :  "00:00:00",
        defaultView: 'agendaWeek',
        eventBorderColor: '#EAEAEA',
        slotEventOverlap: false,
        dayNamesShort: ['dom.', 'lun.', 'mar.', 'mié.',
        'jue.', 'vie.', 'sáb'],
        // eventOverlap: false,
        // columnHeaderFormat: 'ddd',
        // slotLabelFormat: 'ddd',
        views: {
          week: {
            columnFormat: 'ddd D/M' // set format for week here
          },
        },
      }
    };
    
    $scope.eventSources = [$scope.events];
    //$scope.eventSourcesE = [$scope.eventsE];



    }

})();

/**
 * Created by cl-macmini-51 on 23/02/18.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('MassiveQuickassignmentController', MassiveQuickassignmentController);

    /** @ngInject */
    function MassiveQuickassignmentController($cookies, $state, $log, $http, MY_CONSTANT, $timeout, $rootScope, $interval, $scope, $mdDialog, $document, languageBasedErrorFactory, getFilters, getBookings, errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.applyFilter = applyFilter;
        vm.datePickerE_3 = datePickerE_3;
        vm.offsetSend = 0;
        vm.pickupFromToTimeChanged = pickupFromToTimeChanged;
        vm.paginationChangedForAssignedAssign = paginationChangedForAssignedAssign;
        vm.massivePushToDrivers = massivePushToDrivers;
        vm.vehicleChanged = vehicleChanged;
        vm.selectedAutoAssignBookingCount = 0;
        vm.assignBookingList = [];
        vm.resetSelectedData = resetSelectedData;
        vm.colorFlag = [];
        vm.selectedArray = [];
        vm.defaultcolorUnassign = true;
        vm.defaultcolorReload = true;
        vm.UnAssignBookingList = [];
        vm.historyData = [];
        vm.itemsPerPageGot = 25;
        vm.bookingSelected = bookingSelected;
        vm.paginationChangedForUnassignedAssign = paginationChangedForUnassignedAssign;
        vm.getAllAssignBookings = getAllAssignBookings;
        vm.getAllUnAssignBookings = getAllUnAssignBookings;
        languageBasedErrorFactory.getTranslationStrings(runThis);
        vm.ismeridian = true;
        vm.globalLimit = 1000;
        vm.slideData = slideData;
        vm.globalLimitService = 1000; //by 
        vm.branchChangedFilter = branchChangedFilter;
        vm.vehicleChangedFilter = vehicleChangedFilter;
        vm.serviceChangedFilter = serviceChangedFilter;
        vm.agreementChangedFilter = agreementChangedFilter;
        vm.typeTripChangedFilter = typeTripChangedFilter;
        vm.globalOffset = 1000;
        vm.typeTripChanged = typeTripChanged;
        vm.agreementChanged = agreementChanged;
        vm.serviceChanged = serviceChanged;
        vm.branchChanged = branchChanged;
        vm.resetFilter = resetFilter;
        vm.paginationChangedForAgreement = paginationChangedForAgreement;
        vm.altInputFormats = ['M!/d!/yyyy'];
        vm.datePicker_1 = {
            scheduledDate: false,
            returnDate: false
        };
        vm.agreementSearch = agreementSearch;
        vm.serviceSearch = serviceSearch;
        vm.branchSearch = branchSearch;
        vm.vehicleSearch = vehicleSearch;
        vm.filterData = {
            branch_filter: 0, //0, 1
            service_filter: 0, //0, 1
            vehicle_filter: 0, //0, 1
            aggrement_filter: 0, //0, 1
            //date_time_filter : 1,  //0, 1
            branch: 'all',
            service: [],
            vehicle: 'all',
            //date_time_value: '',
            agreement: 'all',
            unAssignBookingArray: [],
            unassignedBookingCountShow: 0,
            assignedBookingCountShow: 0,
            // type_of_trip: 'all',
            type_of_trip_filter: 1,
            //filter_pickup_date_value: getNextDate(),
            //filter_pickup_time_value: showFilterTime(),
            limit: 25,
            offset: 0,
            booking_status: 0,
            search_filter: 0,
            search_value: '',
            searchBookingId: '',
            searchPackageId: '',
            search: '',
            itemsPerPageSelected: 20,
            unassignedLimitMade: 20,
            assignedLimitMade: 20,
            filter_pickup_from_date_value: getFirstDateOfPreviousMonth(),
            filter_pickup_to_date_value: setToPickupDate(),
            filter_pickup_from_time_value: showFilterTime(1),
            filter_pickup_to_time_value: showFilterTime(2),
        };
        setTimeout(function () {
            vm.pickupFromToDateChanged(2);
        }, 1000);
        vm.filterData.type_of_trip = ['R','P'];
        vm.service = [];
        vm.dateOptions = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            // maxDate: new Date(),
            // minDate: new Date(vm.filterData.filter_pickup_from_date_value),
            startingDay: 1,
            showWeeks: false,

        };
        vm.dateOptionsForEndDate = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            // maxDate: new Date(),
            minDate: new Date(vm.filterData.filter_pickup_from_date_value),
            startingDay: 1,
            showWeeks: false,
        }
        // vm.service.push({
        //     id: 'all',
        //     name: 'All'
        // })

        vm.vehicle = [];
        vm.vehicle.push({
            id: 'all',
            name: 'All'
        });

        vm.branchList = [];
        vm.branchList.push({
            region_name: 'All',
            region_id: 'all'
        });

        vm.agreement = [];
        vm.agreement.push({
            id: 'all',
            name: 'All'
        });

        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'vehicle', 'service', 'agreement', 'corporatesList', 'operation_point'];

        vm.serviceOffset = 0;
        vm.branchOffset = 0;
        vm.vehicleOffset = 0;
        vm.agreementOffset = 0;
        vm.assignedOffset = 0;
        vm.unAssignedOffset = 0;


        if ($rootScope.socket.connected == false || $rootScope.socket.connected == 'false') {
            $rootScope.socket.connect();
        }

        function clearOffset() {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                vm[vm.searchFilterArray[i] + 'Offset'] = 0;
            }

        }
        setTimeout(function () {
            document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                // if (vm.branchList && (vm.branchList.length == 0)) {
                vm.searchBranchData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });


            document.getElementsByClassName('ui-select-search')[1].addEventListener('blur', function ($event) {
                // if (vm.agreement && (vm.agreement.length == 0)) {
                vm.searchAgreementData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

            document.getElementsByClassName('ui-select-search')[2].addEventListener('blur', function ($event) {
                // if (vm.service && (vm.service.length == 0)) {
                vm.searchServiceData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

            document.getElementsByClassName('ui-select-search')[3].addEventListener('blur', function ($event) {
                // if (vm.vehicle && (vm.vehicle.length == 0)) {
                vm.searchVehicleData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

        })
        ///////////// DATe FUNCTIONS/////////////////////
        function getFirstDateOfPreviousMonth() {
            var date = new Date();
            var yesterday = new Date(date.getTime() - 24 * 60 * 60 * 1000);
            return date;
        }

        function setToPickupDate() {
            var x = new Date();
            var yesterday = new Date(x.getTime() + (24 * 60 * 60 * 1000));
            return yesterday;
        }

        function showFilterTime(type) {
            if (type == 1) {
                var x = new Date();
                x.setHours('00');
                x.setMinutes('00');
                x.setSeconds('00');
                return x;
            } else {
                var x = new Date();
                x.setHours('23');
                x.setMinutes('59');
                x.setSeconds('00');
                return x;
            }

        }

        function datePickerE_3(type) {
            if (type == 1) {
                vm.datePicker_1.pickupFromDate = true;
                vm.datePicker_1.pickupToDate = false;

            } else if (type == 2) {
                vm.datePicker_1.pickupFromDate = false;
                vm.datePicker_1.pickupToDate = true;
            }
        };
        ///////////// DATe FUNCTIONS/////////////////////

        /////////////FILTER INTO LOCALSTORGAGE/////////////////////
        if (localStorage.getItem('massiveQuickAssignmentFilter')) {
            vm.filterData = JSON.parse(localStorage.getItem('massiveQuickAssignmentFilter'));
            init();
        } else {
            init();
        }
        $scope.$watchCollection('vm.filterData', function (newValue, oldValue) {
            localStorage.setItem('massiveQuickAssignmentFilter', JSON.stringify(newValue));
        })
        /////////////FILTER INTO LOCALSTORGAGE/////////////////////

        /////////////INIT FUNCTIONS/////////////////////
        function init() {
            vm.filterData.type_of_trip = ['R','P'];
            getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
            getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");

        };
        /////////////INIT FUNCTIONS/////////////////////

        /////////////DATE CHANGE FUNTION/////////////////////
        vm.pickupFromToDateChanged = function (data) {
            // vm.UnAssignBookingList = [];
            // vm.assignBookingList = [];
            vm.dateOptions = {
                //dateDisabled: disabled,
                formatYear: 'yy',
                // maxDate: new Date(),
                // minDate: new Date(vm.filterData.filter_pickup_from_date_value),
                startingDay: 1,
                showWeeks: false,

            };
            vm.dateOptionsForEndDate = {
                //dateDisabled: disabled,
                formatYear: 'yy',
                // maxDate: new Date(),
                minDate: new Date(vm.filterData.filter_pickup_from_date_value),
                startingDay: 1,
                showWeeks: false,
            }
            // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
            // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "scroll");

        }


        function addDays(theDate, days) {
            return new Date(theDate).getTime() + days * 48 * 60 * 60 * 1000;
        }

        /////////////DATE CHANGE FUNTION/////////////////////

        //====================Type Of Trip list====================
        function runThis() {
            vm.typeTripFilter = [
                // {
                //     name: languageBasedErrorFactory.getProperErrorMessage('allLabel', 0, '3'),
                //     id: 'all'
                // },
                // {
                //     name: 'From Airport',
                //     id: 'Z'
                // },
                {
                    name: 'To Airport',
                    id: 'R'
                },
                {
                    name: 'Point to Point',
                    id: 'P'
                }
            ]
        }

        //====================Type Of Trip list====================
        // =================== FILTER OBJECT ===================
        vm.filterObject = {
            access_token: $cookies.get('obj'),
            branch_filter: 1,
            vehicle_filter: 1,
            service_filter: 1,
            agreement_filter: 1,
            corporate_filter: 0,
            service_category: 0,
            corporate_status: 0,
            agreement_status: 1,
            vehicle__status: 1,
            operation_point_filter: 0,
            service_limit: vm.globalLimitService,
            service_offset: vm.serviceOffset,
            branch_limit: vm.globalLimit,
            branch_offset: vm.branchOffset,
            vehicle_limit: vm.globalLimit,
            vehicle_offset: vm.vehicleOffset,
            agreement_limit: vm.globalLimit,
            agreement_offset: vm.agreementOffset,
            branch_search_filter: 0,
            vehicle_search_filter: 0,
            service_search_filter: 0,
            agreement_search_filter: 0,
            corporate_search_filter: 0,
            operation_point_search_filter: 0
        }
        // document.getElementById('boxId').style.border = "1px solid #EF7D07";
        // document.getElementById('boxId').style.backgroundColor = "transparent";
        // document.getElementById('boxId').style.color = "#EF7D07";
        // document.getElementById('boxId1').style.border = "1px solid #EF7D07";
        // document.getElementById('boxId1').style.backgroundColor = "#EF7D07";
        // document.getElementById('boxId1').style.color = "#fff";
        // //=======================Assign Booking=========================
        // function assignBooking(boxId) {
        //     document.getElementById(boxId).style.border = "1px solid #EF7D07";
        //     document.getElementById(boxId).style.backgroundColor = "#EF7D07";
        //     document.getElementById(boxId).style.color = "#fff";
        //     document.getElementById('boxId1').style.border = "1px solid #EF7D07";
        //     document.getElementById('boxId1').style.backgroundColor = "transparent";
        //     document.getElementById('boxId1').style.color = "#EF7D07";
        // }
        // //=======================Assign Booking================
        // //=======================Un Assign Booking====
        // function unAssignBooking(boxId1) { 
        //     document.getElementById(boxId1).style.border = "1px solid #EF7D07";
        //     document.getElementById(boxId1).style.backgroundColor = "#EF7D07";
        //     document.getElementById(boxId1).style.color = "#fff";
        //     document.getElementById('boxId').style.border = "1px solid #EF7D07";
        //     document.getElementById('boxId').style.backgroundColor = 'transparent';
        //     document.getElementById('boxId').style.color = "#EF7D07";
        // }
        //=======================Un Assign Booking====Î
        // =================== GET FILTER DATA ===================
        function getFilterDataFromBackend(data, type) { //Acc to Index ['branch_search', 'vehicle_search', 'service_search', 'agreement_search', 'corporate_search', 'operation_point_search']
            if (data) {
                vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
            } else {
                vm.filterObject = {
                    access_token: $cookies.get('obj'),
                    branch_filter: 1,
                    vehicle_filter: 1,
                    service_filter: 1,
                    agreement_filter: 1,
                    corporate_filter: 0,
                    service_category: 0,
                    corporate_status: 0,
                    agreement_status: 1,
                    vehicle__status: 2,
                    operation_point_filter: 0,
                    branch_search_filter: 0,
                    vehicle_search_filter: 0,
                    service_search_filter: 0,
                    agreement_search_filter: 0,
                    corporate_search_filter: 0,
                    operation_point_search_filter: 0
                }
            }

            vm.filterObject.service_limit = vm.globalLimitService;
            vm.filterObject.service_offset = vm.serviceOffset;
            vm.filterObject.branch_limit = vm.globalLimit;
            vm.filterObject.branch_offset = vm.branchOffset;
            vm.filterObject.vehicle_limit = vm.globalLimit;
            vm.filterObject.vehicle_offset = vm.vehicleOffset;
            vm.filterObject.agreement_limit = vm.globalLimit;
            vm.filterObject.agreement_offset = vm.agreementOffset;


            var promise = getFilters.getAllFilterData(vm.filterObject);
            promise.then(
                function (payload) {

                    // ********** BRANCH DATA ********
                    if (payload.title.data.branches) {
                        var index = _.findIndex(vm.branchList, {
                            region_id: 'all'
                        });
                        if (index == -1)
                            vm.branchList.push({
                                region_name: 'All',
                                region_id: 'all'
                            });
                        angular.forEach(payload.title.data.branches.data, function (column) {
                            var branchIndex = _.findIndex(vm.branchList, {
                                region_id: column.region_id
                            });
                            if (branchIndex == -1)
                                vm.branchList.push(column)
                        });
                        vm.branchTotalBackendCount = payload.title.data.branches.totalCount;
                    }

                    // ********** VEHICLE DATA ********
                    if (payload.title.data.vehicles) {
                        var index = _.findIndex(vm.vehicle, {
                            id: 'all'
                        });
                        if (index == -1)
                            vm.vehicle.push({
                                name: 'All',
                                id: 'all'
                            });
                        vm.vehicleTotalBackendCount = payload.title.data.vehicles.totalCount;
                        angular.forEach(payload.title.data.vehicles.data, function (column) {
                            // vm.vehicle.push({
                            //     id: column.id,
                            //     name: column.name
                            // })
                            var vechicleIndex = _.findIndex(vm.vehicle, {
                                id: column.id
                            });
                            if (vechicleIndex == -1)
                                vm.vehicle.push({
                                    id: column.id,
                                    name: column.name
                                })
                        });
                    }

                    // *********** SERVICE DATA *********
                    if (payload.title.data.services) {
                        // var index = _.findIndex(vm.service, {
                        //     id: 'all'
                        // });
                        // if (index == -1)
                        //     vm.service.push({
                        //         name: 'All',
                        //         id: 'all'
                        //     });
                        vm.serviceTotalBackendCount = payload.title.data.services.totalCount;
                        angular.forEach(payload.title.data.services.data, function (column) {
                            // vm.service.push({
                            //     id: column.id,
                            //     name: column.service_name
                            // });
                            var serviceIndex = _.findIndex(vm.service, {
                                id: column.id
                            });
                            if (serviceIndex == -1)
                                vm.service.push({
                                    id: column.id,
                                    name: column.service_name
                                })
                        });
                    }

                    // *********** AGREEMENT DATA *********
                    if (payload.title.data.agreements) {
                        var index = _.findIndex(vm.agreement, {
                            id: 'all'
                        });
                        if (index == -1)
                            vm.agreement.push({
                                name: 'All',
                                id: 'all'
                            });
                        vm.agreementTotalBackendCount = payload.title.data.agreements.totalCount;
                        angular.forEach(payload.title.data.agreements.data, function (column) {
                            // vm.agreement.push({
                            //     id: column.id,
                            //     name: column.name
                            // });
                            var agreementIndex = _.findIndex(vm.agreement, {
                                id: column.id
                            });
                            if (agreementIndex == -1)
                                vm.agreement.push({
                                    id: column.id,
                                    name: column.name
                                })
                        });
                    }

                    vm.loading = false;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        }
        getFilterDataFromBackend();

        // ************ PAGINATION ON SERIVCE **************
        function paginationChangedForService() {
            var index = _.findIndex(vm[vm.searchFilterArray[2]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.serviceTotalBackendCount > (vm.service.length - index)) {
                commonFunction(2);
                vm.serviceOffset += vm.globalLimitService;
                getFilterDataFromBackend(vm.searchServiceData, 2);
            }
        }

        // ************ PAGINATION ON VEHICLE **************
        function paginationChangedForVehicle() {
            var index = _.findIndex(vm[vm.searchFilterArray[1]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.vehicleTotalBackendCount > (vm.vehicle.length - index)) {
                commonFunction(1);
                vm.vehicleOffset = vm.vehicleOffset + 10;
                getFilterDataFromBackend(vm.searchVehicleData, 1);
            }
        }

        // ************ PAGINATION ON BRANCH **************
        function paginationChangedForBranch() {
            var index = _.findIndex(vm[vm.searchFilterArray[0]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.branchTotalBackendCount > (vm.branchList.length - index)) {
                commonFunction(0);
                vm.branchOffset += 10;
                getFilterDataFromBackend(vm.searchBranchData, 0);
            }
        }

        // ************ PAGINATION ON AGREEMENT **************
        function paginationChangedForAgreement() {
            var index = _.findIndex(vm[vm.searchFilterArray[3]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.agreementTotalBackendCount > (vm.agreement.length - index)) {
                commonFunction(3);
                vm.agreementOffset += vm.globalOffset;
                getFilterDataFromBackend(vm.searchAgreementData, 3);
            }
        }

        // *********** COMMON FUNCTION FOR FILTER PAGINATION AND SEARCHING ***********
        function commonFunction(type, mode) {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                // vm['search' + vm.searchFilterArray[i] + 'Data'] = '';
                if (mode == 'search' || i != type) {
                    vm[vm.searchFilterArrayForClearArray[i]] = [];
                    // if (vm.searchFilterArrayForClearArray[i] != vm.searchFilterArrayForClearArray[0] && vm.searchFilterArrayForClearArray[i] == vm.searchFilterArrayForClearArray[3])
                    // vm[vm.searchFilterArrayForClearArray[i]].push({
                    //     id: 'all',
                    //     name: 'All'
                    // });
                    vm[vm.searchFilterArray[i] + 'Offset'] = 0;
                    vm['search' + vm.searchFilterArray[i].substring(0, 1).toUpperCase() + vm.searchFilterArray[i].substring(1) + 'Data'] = '';
                }
            }
        }

        // ************ SEARCH VEHICLE ***************
        function vehicleSearch(data, event) {
            // if (event.keyCode != 40 && event.keyCode != 38) {
            //     vm.searchVehicleData = data;
            //     $timeout.cancel($scope.timeoutSearch);
            //     commonFunction(1, 'search');
            //     $scope.timeoutSearch = $timeout(function () {
            //         getFilterDataFromBackend(data, 1);
            //     }, 2000);
            // }
            if (event.keyCode == 13) {
                vehicleChanged();
            }
        }

        // ************ SEARCH SERVICE ***************
        function serviceSearch(data, event) {
            // if (event.keyCode != 40 && event.keyCode != 38) {
            //     vm.searchServiceData = data;
            //     $timeout.cancel($scope.timeoutSearch);
            //     commonFunction(2, 'search');
            //     $scope.timeoutSearch = $timeout(function () {
            //         getFilterDataFromBackend(data, 2);
            //     }, 2000);
            // }
            if (event.keyCode == 13) {
                serviceChanged();
            }
        }

        // ************ SEARCH VEHICLE ***************
        function branchSearch(data, event) {
            // if (event.keyCode != 40 && event.keyCode != 38) {
            //     vm.searchBranchData = data;
            //     $timeout.cancel($scope.timeoutSearch);
            //     commonFunction(0, 'search');
            //     $scope.timeoutSearch = $timeout(function () {
            //         getFilterDataFromBackend(data, 0);
            //     }, 2000);
            // }
            if (event.keyCode == 13) {
                branchChanged();
            }
        }

        // ************ SEARCH AGREEMENT ***************
        function agreementSearch(data, event) {
            // if (event.keyCode != 40 && event.keyCode != 38) {
            //     vm.searchAgreementData = data;
            //     $timeout.cancel($scope.timeoutSearch);
            //     commonFunction(3, 'search');
            //     $scope.timeoutSearch = $timeout(function () {
            //         getFilterDataFromBackend(data, 3);
            //     }, 2000);
            // }
            if (event.keyCode == 13) {
                agreementChanged();
            }
        }
        //===================Reset filter====================
        function resetFilter() {
            vm.UnAssignBookingList = [];
            vm.assignBookingList = [];
            vm.filterData = {
                branch_filter: 0, //0, 1
                service_filter: 0, //0, 1
                vehicle_filter: 0, //0, 1
                aggrement_filter: 0, //0, 1
                //date_time_filter : 0,  //0, 1
                type_of_trip_filter: 1, //0, 1
                branch: 'all',
                service: [],
                vehicle: 'all',
                // type_of_trip: 'R',
                //date_time_value: '',
                agreement: 'all',
                //filter_pickup_date_value: getNextDate(),
                //filter_pickup_time_value: showFilterTime(),
                limit: vm.itemsPerPageGot,
                offset: 0,
                booking_status: 0,
                searchBookingId: '',
                searchPackageId: '',
                search: '',
                itemsPerPageSelected: 25,
                unassignedBookingCountShow: 0,
                assignedBookingCountShow: 0,
                unAssignBookingArray: [],
                filter_pickup_from_date_value: getFirstDateOfPreviousMonth(),
                filter_pickup_to_date_value: setToPickupDate(),
                filter_pickup_from_time_value: showFilterTime(1),
                filter_pickup_to_time_value: showFilterTime(2),
            };
            vm.filterData.type_of_trip = ['R','P']; 
            getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
            getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
            // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
        }

        function applyFilter() {
            vm.assignedOffset = 0;
            vm.unAssignedOffset = 0;
            vm.UnAssignBookingList = [];
            vm.assignBookingList = [];
            if(vm.filterData.type_of_trip.length == 0){
                vm.filterData.type_of_trip = ['R','P'];
            }         
            getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
            getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
        }

        //====================slide data======================
        $('#derp').hide();

        function slideData() {
            $('#derp').slideToggle(1000);
            document.getElementById('toDate').value = moment(vm.filterData.filter_pickup_to_date_value).format('DD-MMMM-YYYY');
            document.getElementById('fromDate').value = moment(vm.filterData.filter_pickup_from_date_value).format('DD-MMMM-YYYY');

        }

        //====================slide data======================

        //====================FILTERS FUNCTIONS======================
        function branchChangedFilter(data) {
            vm.branchChanged();
        }

        function vehicleChangedFilter(data) {
            vm.vehicleChanged();
        }

        function serviceChangedFilter(data) {
            vm.serviceChanged();
        }

        function agreementChangedFilter(data) {
            vm.agreementChanged();
        }

        function typeTripChangedFilter(data) {
            vm.typeTripChanged();
        }
        //====================FILTERS FUNCTIONS======================

        //=================filter change functions===============================================
        //===================Type of Trip====================
        function typeTripChanged() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            // vm.UnAssignBookingList = [];
            // vm.assignBookingList = [];
            vm.filterData.offset = 0;
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (vm.filterData.type_of_trip && vm.filterData.type_of_trip != 'all') {
                vm.filterData.type_of_trip_filter = 1;
                // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");

            } else {
                vm.filterData.type_of_trip_filter = 0;
                vm.filterData.type_of_trip = 'all';
                // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");

            }
        };
        //===================Type of Trip====================

        //===================Vechicle Changed====================
        function vehicleChanged() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            // vm.UnAssignBookingList = [];
            // vm.assignBookingList = [];
            vm.filterData.offset = 0;
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (vm.filterData.vehicle && vm.filterData.vehicle != 'all') {
                vm.filterData.vehicle_filter = 1;
                // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
                vm.agreement = [];
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                clearOffset();
                getFilterDataFromBackend();
            } else {
                vm.filterData.vehicle_filter = 0;
                vm.filterData.vehicle = 'all';
                // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
                vm.agreement = [];
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                clearOffset();
                getFilterDataFromBackend();
            }
        };


        //===================Vechicle Changed====================

        //===================Service Changed====================
        function serviceChanged() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            // vm.UnAssignBookingList = [];
            // vm.assignBookingList = [];
            vm.filterData.offset = 0;
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (vm.filterData.service.length > 0) {
                vm.filterData.service_filter = 1;
                // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
                vm.agreement = [];
                vm.branchList = [];
                vm.vehicle = [];
                clearOffset();
                vm.service = [];
                getFilterDataFromBackend();
            } else {
                vm.filterData.service_filter = 0;
                // vm.filterData.service = 'all';
                // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
                vm.agreement = [];
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                clearOffset();
                getFilterDataFromBackend();
            }
        };
        //===================Service Changed====================

        //===================TIME CHANGE FUNCATION====================
        function pickupFromToTimeChanged(type) {
            // vm.UnAssignBookingList = [];
            // vm.assignBookingList = [];
            // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
            // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
        }
        //===================Service Changed====================

        //===================Aggreement Changed====================
        function agreementChanged() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            // vm.UnAssignBookingList = [];
            // vm.assignBookingList = [];
            vm.filterData.offset = 0;
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (vm.filterData.agreement && vm.filterData.agreement != 'all') {
                vm.filterData.aggrement_filter = 1;
                // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
                vm.agreement = [];
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                clearOffset();
                getFilterDataFromBackend();
            } else {
                vm.filterData.aggrement_filter = 0;
                vm.filterData.agreement = 'all';
                // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
                vm.agreement = [];
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                clearOffset();
                getFilterDataFromBackend();
            }
        };
        //===================Aggreement Changed====================    

        //===================Branch Changed====================    

        function branchChanged() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            // vm.UnAssignBookingList = [];
            // vm.assignBookingList = [];
            vm.filterData.offset = 0;
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (vm.filterData.branch && vm.filterData.branch != 'all') {
                vm.filterData.branch_filter = 1;
                // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                vm.agreement = [];
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
                clearOffset();
                getFilterDataFromBackend();
            } else {
                vm.filterData.branch_filter = 0;
                vm.filterData.branch = 'all';
                // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
                vm.agreement = [];
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                clearOffset();
                getFilterDataFromBackend();
            }
        };

        //===================Branch Changed====================    
        //=================filter change functions===============================================

        ///////////// DATe FUNCTIONS/////////////////////
        //====================date time format====================
        function dateTimeFormat(dateGot, timeGot) {
            // var dateToChange = dateGot;
            var dateToChange = new Date(dateGot);
            var timeGotChange = new Date(timeGot);
            if (timeGotChange) {
                dateToChange.setHours(timeGotChange.getHours());
                dateToChange.setMinutes(timeGotChange.getMinutes());
                dateToChange.setSeconds(timeGotChange.getSeconds());
            } else {
                dateToChange.setHours(0);
                dateToChange.setMinutes(0);
                dateToChange.setSeconds(0);
            }
            return dateToChange;
        };
        //==================get all AssignBookings=======================
        function getAllUnAssignBookings(skip, limit, filter, loader, type) {
            var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            if (pickFromDate > pickToDate) {
                errorMessageFactory.showErrorMessage('Por favor, elija las fechas apropiadas de filtro.', 0);
                return;
            }

            vm.countToSocket = vm.countToSocket + 1;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit;
            dataSend.offset = skip;
            dataSend.booking_status = filter.booking_status;
            dataSend.branch_filter = filter.branch_filter;
            if (filter.branch_filter == 1 && filter.branch != 'all') {
                dataSend.branch_value = filter.branch;
            }
            dataSend.service_filter = filter.service_filter;
            if (filter.service_filter == 1 && filter.service != 'all') {
                dataSend.service_value = JSON.stringify(filter.service) || [];
            }
            dataSend.vehicle_filter = filter.vehicle_filter;
            if (filter.vehicle_filter == 1 && filter.vehicle != 'all') {
                dataSend.vehicle_value = filter.vehicle;
            }
            dataSend.search_filter = filter.search_filter;
            if (filter.search_filter == 1) {
                dataSend.search_value = filter.search_value;
            }
            //dataSend.date_time_filter = filter.date_time_filter;
            //if(filter.filter_pickup_date_value && filter.filter_pickup_time_value) {
            //    dataSend.date_time_value = dateTimeFormat(filter.filter_pickup_date_value, filter.filter_pickup_time_value);
            //}
            //else if(filter.filter_pickup_date_value && !filter.filter_pickup_time_value){
            //    dataSend.date_time_value = moment(filter.filter_pickup_date_value).format('YYYY-MM-DD');
            //}

            dataSend.aggrement_filter = filter.aggrement_filter;
            if (filter.aggrement_filter == 1 && filter.agreement != 'all') {
                dataSend.aggrement_value = filter.agreement;
            }

            // dataSend.type_of_trip_filter = filter.type_of_trip_filter;
            // if (filter.type_of_trip_filter == 1 && filter.type_of_trip != 'all') {
            var trip = [];
            trip.push(vm.filterData.type_of_trip);
            if (vm.filterData.type_of_trip && vm.filterData.type_of_trip.length > 0 && filter.type_of_trip != 'all') {
                dataSend.type_of_trip_filter = 1;
                dataSend.type_of_trip_value = trip;
            } else {
                dataSend.type_of_trip_filter = 0;
            }
            dataSend.date_value_from = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            dataSend.date_value_upto = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);

            // }
            vm.loading = true;
            var promise = getBookings.allUnAssignBookingsV2(dataSend);
            promise.then(
                function (payload) {
                    if (payload.title.status == 200) {
                        $log.log('sxdsads', payload);
                        vm.countToSocket = 0;
                        vm.loading = false;
                        if (payload.title.status == 400) {

                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        } else if (payload.title.status == 201 || payload.title.status == 200) {

                            vm.filterData.unassignedBookingCountShow = payload.title.data.totalCount;
                            vm.dataLength = payload.title.data.totalCount;
                            vm.urgentBookingCount = payload.title.data.urgent_booking_count || 0;

                            if (payload.title.data.totalCount == 0) {
                                // vm.sp_pagination = false;
                                // vm.tBodyFlag = false;
                                // vm.tFootFlag = true;
                                // vm.filterOn = true;
                                // vm.skipValueFilter = 0;
                            } else {
                                // vm.sp_pagination = true;
                                // vm.tBodyFlag = true;
                                // vm.tFootFlag = false;
                                // vm.filterOn = false;
                                // vm.skipValueFilter = 0;


                                if (type == "scroll") {
                                    for (var i = 0; i < payload.title.data.result.length; i++) {

                                        vm.filterData.unAssignBookingArray.push(payload.title.data.result[i]);
                                    }
                                } else {
                                    vm.filterData.unAssignBookingArray = payload.title.data.result;
                                }

                                // showNewDrivers(vm.dataToFill , 0);
                                var dataArray = [];
                                if (type == 'socket') {
                                    vm.UnAssignBookingList = [];
                                }
                                // vm.UnAssignBookingList = [];
                                vm.filterData.unAssignBookingArray = payload.title.data.result;
                                if (vm.filterData.unassignedBookingCountShow > vm.UnAssignBookingList.length) {
                                    var UnAssignBookingList = payload.title.data.result;
                                    UnAssignBookingList.forEach(function (column) {
                                        // this is to detect duplicate booking in array
                                        var index = _.findIndex(vm.UnAssignBookingList, {
                                            job_id: column.job_id
                                        });
                                        if (index == -1) {
                                            var d = {};
                                            d.contract_name = column.contract_name;
                                            d.estimated_payment_cost = column.estimated_payment_cost;
                                            d.is_VIP = column.is_VIP;
                                            d.is_round_trip = column.is_round_trip;
                                            d.booking_type = column.booking_type;
                                            d.branch = column.branch;
                                            d.type_of_service = column.type_of_service;
                                            d.job_address = column.job_address;
                                            d.job_id = column.job_id;
                                            d.job_pickup_address = column.job_pickup_address;
                                            d.job_pickup_name = column.job_pickup_name;
                                            d.job_pickup_phone = column.job_pickup_phone;
                                            d.job_time_utc = column.job_time_utc;
                                            d.locking_id = column.locking_id;
                                            d.service_name = column.service_name;
                                            d.locking_id_name = column.locking_id_name;
                                            d.observations = column.observations;
                                            d.reference_point = column.reference_point;
                                            d.round_trip_pickup_time_utc = column.round_trip_pickup_time_utc;
                                            d.urgent_booking_assignment = column.urgent_booking_assignment;
                                            d.latitude = column.job_pickup_latitude;
                                            d.longitude = column.job_pickup_longitude;
                                            d.is_person = true;
                                            d.booking_eta = column.booking_eta;
                                            d.reference_point = column.reference_point;
                                            d.color = column.urgent_booking_assignment ? '#ff4d4d' : '#333';
                                            d.booking_visibility_flag = column.booking_visibility_flag;
                                            d.auto_assignment = column.auto_assignment;
                                            // dataArray.push(d);
                                            vm.UnAssignBookingList.push(d);

                                        }
                                    });
                                    vm.historyData.push(UnAssignBookingList.length);
                                }
                                // vm.UnAssignBookingList.push(dataArray);
                                // vm.assignBookingList = [];
                                for (var i = 0; i < vm.UnAssignBookingList.length; i++) {
                                    vm.UnAssignBookingList[i].index = (skip + i);
                                }
                                if (vm.dataLength <= vm.itemsPerPageGot) {
                                    vm.sp_pagination = false;
                                } else {
                                    vm.sp_pagination = true;
                                    //vm.pageCount(payload.title.totalCount);
                                }
                                // vm.skipValue = vm.UnAssignBookingList[0].index;
                                // vm.limitValue = vm.UnAssignBookingList[vm.UnAssignBookingList.length - 1].index;



                                //$scope.$watch('vm.search', function (newVal, oldVal) {
                                //    vm.filtered = filterFilter(vm.upcomingBookingList, newVal);
                                //    vm.totalItems = vm.filtered.length;
                                //    if (vm.filtered.length == 0) {
                                //        vm.watchPagination = false;
                                //    } else {
                                //        vm.watchPagination = true;
                                //    }
                                //    if (vm.filterOn == true) {
                                //        vm.skipValueFilter = vm.filtered.length;
                                //        vm.sp_pagination = false;
                                //    }
                                //}, true);

                                //range();
                            }
                        }
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        //==================== GET SOCKET CONNECTION FOR DISCARD BOOKING===================
        var discardBookingSocket = $rootScope.$on('SocketForGetDataDiscardBooking', function (evt, data) {
            console.log(data, "first");
            console.log(">>>>>>>>>>>SocketForGetDataDiscardBooking>>>>>>>>>>");
            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            var dateTo = new Date(date_time_value2).getTime();
            var dateFrom = new Date(date_time_value1).getTime();
            for (var i = 0; i < data.data.message.jobArray.length; i++) {
                var index = _.findIndex(vm.UnAssignBookingList, {
                    job_id: data.data.message.jobArray[i].job_id
                });
                console.log(index, 'index');

                if (checkFilterStatus(data.data.message.jobArray[i])) {
                    console.log("app >>> testing", index);

                    if (index == -1) {
                        if (vm.UnAssignBookingList.length == 0) {
                            vm.UnAssignBookingList.push({
                                "contract_name": data.data.message.jobArray[i].contract_name,
                                "estimated_payment_cost": data.data.message.jobArray[i].estimated_payment_cost,
                                "is_VIP": data.data.message.jobArray[i].is_VIP,
                                "is_round_trip": data.data.message.jobArray[i].is_round_trip,
                                "booking_type": data.data.message.jobArray[i].booking_type,
                                "branch": data.data.message.jobArray[i].branch,
                                "type_of_service": data.data.message.jobArray[i].type_of_service,
                                "job_address": data.data.message.jobArray[i].job_address,
                                "job_id": data.data.message.jobArray[i].job_id,
                                "job_pickup_address": data.data.message.jobArray[i].job_pickup_address,
                                "job_pickup_name": data.data.message.jobArray[i].job_pickup_name,
                                "job_pickup_phone": data.data.message.jobArray[i].job_pickup_phone,
                                "job_time_utc": data.data.message.jobArray[i].job_time_utc,
                                "locking_id": data.data.message.jobArray[i].locking_id,
                                "service_name": data.data.message.jobArray[i].service_name,
                                "locking_id_name": data.data.message.jobArray[i].locking_id_name,
                                "observations": data.data.message.jobArray[i].observations,
                                "reference_point": data.data.message.jobArray[i].reference_point,
                                "round_trip_pickup_time_utc": data.data.message.jobArray[i].round_trip_pickup_time_utc,
                                "urgent_booking_assignment": data.data.message.jobArray[i].urgent_booking_assignment,
                                "latitude": data.data.message.jobArray[i].latitude,
                                "longitude": data.data.message.jobArray[i].longitude,
                                "is_person": true,
                                "booking_eta": data.data.message.jobArray[i].booking_eta,
                                "color": '#333',
                                "auto_assignment": data.data.message.jobArray[i].auto_assignment,
                                "booking_visibility_flag": data.data.message.jobArray[i].booking_visibility_flag
                            });
                            $scope.$apply();
                        } else {
                            for (var j = 0; j < vm.UnAssignBookingList.length; j++) {
                                console.log(new Date(vm.UnAssignBookingList[j].job_time_utc).getTime() > new Date(data.data.message.jobArray[i].job_time_utc).getTime());
                                if (!vm.UnAssignBookingList[j].urgent_booking_assignment)
                                    if (new Date(vm.UnAssignBookingList[j].job_time_utc).getTime() > new Date(data.data.message.jobArray[i].job_time_utc).getTime()) {
                                        vm.UnAssignBookingList.insert(j, {
                                            "contract_name": data.data.message.jobArray[i].contract_name,
                                            "estimated_payment_cost": data.data.message.jobArray[i].estimated_payment_cost,
                                            "is_VIP": data.data.message.jobArray[i].is_VIP,
                                            "is_round_trip": data.data.message.jobArray[i].is_round_trip,
                                            "booking_type": data.data.message.jobArray[i].booking_type,
                                            "branch": data.data.message.jobArray[i].branch,
                                            "type_of_service": data.data.message.jobArray[i].type_of_service,
                                            "job_address": data.data.message.jobArray[i].job_address,
                                            "job_id": data.data.message.jobArray[i].job_id,
                                            "job_pickup_address": data.data.message.jobArray[i].job_pickup_address,
                                            "job_pickup_name": data.data.message.jobArray[i].job_pickup_name,
                                            "job_pickup_phone": data.data.message.jobArray[i].job_pickup_phone,
                                            "job_time_utc": data.data.message.jobArray[i].job_time_utc,
                                            "locking_id": data.data.message.jobArray[i].locking_id,
                                            "service_name": data.data.message.jobArray[i].service_name,
                                            "locking_id_name": data.data.message.jobArray[i].locking_id_name,
                                            "observations": data.data.message.jobArray[i].observations,
                                            "reference_point": data.data.message.jobArray[i].reference_point,
                                            "round_trip_pickup_time_utc": data.data.message.jobArray[i].round_trip_pickup_time_utc,
                                            "urgent_booking_assignment": data.data.message.jobArray[i].urgent_booking_assignment,
                                            "latitude": data.data.message.jobArray[i].latitude,
                                            "longitude": data.data.message.jobArray[i].longitude,
                                            "is_person": true,
                                            "booking_eta": data.data.message.jobArray[i].booking_eta,
                                            "color": '#333',
                                            "auto_assignment": data.data.message.jobArray[i].auto_assignment,
                                            "booking_visibility_flag": data.data.message.jobArray[i].booking_visibility_flag
                                        });
                                        $scope.$apply();
                                        break;
                                    }
                            }

                            var findIndex = _.findIndex(vm.UnAssignBookingList, {
                                job_id: data.data.message.jobArray[i].job_id
                            });
                            if (findIndex == -1) {
                                vm.UnAssignBookingList.push({
                                    "contract_name": data.data.message.jobArray[i].contract_name,
                                    "estimated_payment_cost": data.data.message.jobArray[i].estimated_payment_cost,
                                    "is_VIP": data.data.message.jobArray[i].is_VIP,
                                    "is_round_trip": data.data.message.jobArray[i].is_round_trip,
                                    "booking_type": data.data.message.jobArray[i].booking_type,
                                    "branch": data.data.message.jobArray[i].branch,
                                    "type_of_service": data.data.message.jobArray[i].type_of_service,
                                    "job_address": data.data.message.jobArray[i].job_address,
                                    "job_id": data.data.message.jobArray[i].job_id,
                                    "job_pickup_address": data.data.message.jobArray[i].job_pickup_address,
                                    "job_pickup_name": data.data.message.jobArray[i].job_pickup_name,
                                    "job_pickup_phone": data.data.message.jobArray[i].job_pickup_phone,
                                    "job_time_utc": data.data.message.jobArray[i].job_time_utc,
                                    "locking_id": data.data.message.jobArray[i].locking_id,
                                    "service_name": data.data.message.jobArray[i].service_name,
                                    "locking_id_name": data.data.message.jobArray[i].locking_id_name,
                                    "observations": data.data.message.jobArray[i].observations,
                                    "reference_point": data.data.message.jobArray[i].reference_point,
                                    "round_trip_pickup_time_utc": data.data.message.jobArray[i].round_trip_pickup_time_utc,
                                    "urgent_booking_assignment": data.data.message.jobArray[i].urgent_booking_assignment,
                                    "latitude": data.data.message.jobArray[i].latitude,
                                    "longitude": data.data.message.jobArray[i].longitude,
                                    "is_person": true,
                                    "booking_eta": data.data.message.jobArray[i].booking_eta,
                                    "color": '#333',
                                    "auto_assignment": data.data.message.jobArray[i].auto_assignment,
                                    "booking_visibility_flag": data.data.message.jobArray[i].booking_visibility_flag
                                });
                            }
                        }
                    }
                }
            }
        });
        $scope.$on('$destroy', discardBookingSocket);
        //==================get all AssignBookings=======================
        //==================get all AssignBookings=======================
        function getAllAssignBookings(skip, limit, filter, loader, type) {
            var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            if (pickFromDate > pickToDate) {
                errorMessageFactory.showErrorMessage('Por favor, elija las fechas apropiadas de filtro.', 0);
                return;
            }
            vm.countToSocket = vm.countToSocket + 1;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit;
            dataSend.offset = skip;
            dataSend.booking_status = filter.booking_status;
            dataSend.branch_filter = filter.branch_filter;
            if (filter.branch_filter == 1 && filter.branch != 'all') {
                dataSend.branch_value = filter.branch;
            }
            dataSend.service_filter = filter.service_filter;
            if (filter.service_filter == 1 && filter.service != 'all') {
                dataSend.service_value = JSON.stringify(filter.service) || [];
            }
            dataSend.vehicle_filter = filter.vehicle_filter;
            if (filter.vehicle_filter == 1 && filter.vehicle != 'all') {
                dataSend.vehicle_value = filter.vehicle;
            }
            dataSend.search_filter = filter.search_filter;
            if (filter.search_filter == 1) {
                dataSend.search_value = filter.search_value;
            }
            //dataSend.date_time_filter = filter.date_time_filter;
            //if(filter.filter_pickup_date_value && filter.filter_pickup_time_value) {
            //    dataSend.date_time_value = dateTimeFormat(filter.filter_pickup_date_value, filter.filter_pickup_time_value);
            //}
            //else if(filter.filter_pickup_date_value && !filter.filter_pickup_time_value){
            //    dataSend.date_time_value = moment(filter.filter_pickup_date_value).format('YYYY-MM-DD');
            //}

            dataSend.aggrement_filter = filter.aggrement_filter;
            if (filter.aggrement_filter == 1 && filter.agreement != 'all') {
                dataSend.aggrement_value = filter.agreement;
            }

            dataSend.date_value_from = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            dataSend.date_value_upto = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);

            // dataSend.type_of_trip_filter = filter.type_of_trip_filter;
            // if (filter.type_of_trip_filter == 1 && filter.type_of_trip != 'all') {
            var trip = [];
            trip.push(vm.filterData.type_of_trip);
            if (vm.filterData.type_of_trip && vm.filterData.type_of_trip.length > 0 && filter.type_of_trip != 'all') {
                dataSend.type_of_trip_filter = 1;
                dataSend.type_of_trip_value = trip;
            } else {
                dataSend.type_of_trip_filter = 0;
            }
            vm.loading = true;
            dataSend.date_value = vm.selectedDateForFilter;
            var promise = getBookings.allAssignBookingsV2(dataSend);
            promise.then(
                function (payload) {
                    if (payload.title.status == 200) {
                        $log.log('sxdsads', payload);
                        vm.countToSocket = 0;
                        vm.loading = false;
                        if (payload.title.status == 400) {

                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            vm.filterData.assignedBookingCountShow = payload.title.data.totalCount;
                            vm.totalUpcomingBookings = payload.title.data.totalCount;
                            vm.dataLength = payload.title.data.totalCount;

                            if (payload.title.data.totalCount == 0) {
                                vm.sp_pagination = false;
                                vm.tBodyFlag = false;
                                vm.tFootFlag = true;
                                vm.filterOn = true;
                                vm.skipValueFilter = 0;
                            } else {
                                vm.sp_pagination = true;
                                vm.tBodyFlag = true;
                                vm.tFootFlag = false;
                                vm.filterOn = false;
                                vm.skipValueFilter = 0;

                                var dataArray = [];
                                if (type == 'socket') {
                                    vm.assignBookingList = [];
                                }
                                // vm.UnAssignBookingList = [];
                                var assignBookingList = payload.title.data.result;
                                // showNewDrivers(vm.dataToFill , 0);
                                if (vm.filterData.assignedBookingCountShow > vm.assignBookingList.length) {
                                    assignBookingList.forEach(function (column) {
                                        // this is to detect duplicate booking in array
                                        var index = _.findIndex(vm.assignBookingList, {
                                            job_id: column.job_id
                                        });
                                        if (index == -1) {
                                            var d = {};
                                            d.contract_name = column.contract_name;
                                            d.estimated_payment_cost = column.estimated_payment_cost;
                                            d.is_VIP = column.is_VIP;
                                            d.is_round_trip = column.is_round_trip;
                                            d.booking_type = column.booking_type;
                                            d.job_address = column.job_address;
                                            d.job_status = column.job_status;
                                            d.job_id = column.job_id;
                                            d.job_pickup_address = column.job_pickup_address;
                                            d.job_pickup_name = column.job_pickup_name;
                                            d.job_pickup_phone = column.job_pickup_phone;
                                            d.unique_car_id = column.unique_car_id;
                                            d.fleet_first_name = column.fleet_first_name + '' + column.fleet_last_name;
                                            d.fleet_phone_number = column.fleet_country_code + column.fleet_phone_number;
                                            d.service_name = column.service_name;
                                            d.assignment_identity = column.assignment_identity;
                                            d.auto_assignment = column.auto_assignment;
                                            d.job_time_utc = column.job_time_utc;
                                            d.locking_id = column.locking_id;
                                            d.locking_id_name = column.locking_id_name;
                                            d.observations = column.observations;
                                            d.reference_point = column.reference_point;
                                            d.round_trip_pickup_time_utc = column.round_trip_pickup_time_utc;
                                            d.urgent_booking_assignment = column.urgent_booking_assignment;
                                            d.type_of_trip = column.type_of_trip;
                                            d.job_pickup_latitude = column.job_pickup_latitude;
                                            d.job_pickup_longitude = column.job_pickup_longitude;
                                            d.schedule_ride = column.schedule_ride;
                                            vm.assignBookingList.push(d);
                                        }
                                    });
                                }
                                // vm.UnAssignBookingList = [];
                                // vm.assignBookingList = dataArray;

                                for (var i = 0; i < vm.assignBookingList.length; i++) {
                                    vm.assignBookingList[i].index = (skip + i);
                                }
                                if (vm.dataLength <= vm.itemsPerPageGot) {
                                    vm.sp_pagination = false;
                                } else {
                                    vm.sp_pagination = true;
                                    //vm.pageCount(payload.title.totalCount);
                                }
                                vm.skipValue = vm.assignBookingList[0].index;
                                vm.limitValue = vm.assignBookingList[vm.assignBookingList.length - 1].index;

                                //$scope.$watch('vm.search', function (newVal, oldVal) {
                                //    vm.filtered = filterFilter(vm.upcomingBookingList, newVal);
                                //    vm.totalItems = vm.filtered.length;
                                //    if (vm.filtered.length == 0) {
                                //        vm.watchPagination = false;
                                //    } else {
                                //        vm.watchPagination = true;
                                //    }
                                //    if (vm.filterOn == true) {
                                //        vm.skipValueFilter = vm.filtered.length;
                                //        vm.sp_pagination = false;
                                //    }
                                //}, true);

                                //range();
                            }
                        }
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //==================get all AssignBookings=======================

        // ========================= paginationChangedForAssignedAssign =================
        function paginationChangedForAssignedAssign() {
            if (vm.filterData.assignedBookingCountShow > vm.assignBookingList.length) {
                vm.assignedOffset = vm.assignedOffset + 25;
                getAllAssignBookings(vm.assignedOffset, vm.itemsPerPageGot, vm.filterData, true, "scroll");
            }
        }
        // ========================= paginationChangedForAssignedAssign =================

        // ========================= paginationChangedForUnassignedAssign =================
        function paginationChangedForUnassignedAssign() {
            if (vm.filterData.unassignedBookingCountShow > vm.UnAssignBookingList.length) {
                vm.unAssignedOffset = vm.unAssignedOffset + 25;
                getAllUnAssignBookings(vm.unAssignedOffset, vm.itemsPerPageGot, vm.filterData, true, "scroll");
            }
        }
        // ========================= paginationChangedForUnassignedAssign =================


        function bookingSelected(data, customer_data, index) {
            if (customer_data.auto_assignment == 1 && customer_data.booking_visibility_flag == 0) {
                return;
            }
            if (!vm.colorFlag[index] && vm.selectedAutoAssignBookingCount == 25) {
                return;
            } // MAX LIMIT{}
            else {
                vm.colorFlag[index] = !vm.colorFlag[index];
                if (!vm.colorFlag[index]) {
                    vm.selectedAutoAssignBookingCount -= 1;
                    vm.selectedArray[index] = null;
                } else {
                    vm.selectedAutoAssignBookingCount += 1;
                    vm.selectedArray[index] = (customer_data)
                }
            }
        }

        function resetSelectedData() {
            vm.colorFlag = [];
            vm.selectedArray = [];
            vm.selectedAutoAssignBookingCount = 0;
        }

        function checkFilterStatus(data) {
            var flagStatus = false;
            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            var dateTo = new Date(date_time_value2).getTime();
            var dateFrom = new Date(date_time_value1).getTime();
            var booking_date = data.job_time_utc;
            booking_date = new Date(booking_date).getTime();
            console.log(data, 'data');

            if (dateFrom <= booking_date && booking_date <= dateTo && (data.booking_type == 0 || data.booking_type == undefined) && (data.job_status != 9 && data.job_status != 3)) {
                console.log("date match >>>>>>>>>>>>>>>>>>>>", dateFrom, booking_date, dateTo);
                if (vm.filterData.type_of_trip_filter == [] || (vm.filterData.type_of_trip.includes(data.type_of_trip))) {
                    console.log("type of of trip match >>>>>>>>>>>>>>>>>>>>");
                    if (vm.filterData.service_filter == [] || vm.filterData.service.includes(data.type_of_service)) {
                        console.log("type of of service match >>>>>>>>>>>>>>>>>>>>");
                        if (vm.filterData.aggrement_filter == 0 || (vm.filterData.agreement == data.contract_id)) {
                            console.log("type of of  agreement match>>>>>>>>>>>>>>>>>>>>");
                            if (vm.filterData.branch_filter == 0 || (vm.filterData.branch == data.branch) || (vm.filterData.branch == data.branch_id)) {
                                console.log("type of of branch match >>>>>>>>>>>>>>>>>>>>");
                                flagStatus = true;
                            }
                        }
                    }
                }
            }
            return flagStatus;
        }

        // ********** INSERT INTO ARRAY **********
        Array.prototype.insert = function (index, item) {
            this.splice(index, 0, item);
        };


        //====================SOCKET CONNECATION FOR CREATE BOOKING===================
        var myListener = $rootScope.$on('quickScreeenBookingCreationSocket', function (evt, data) {
            console.log(">>>>>>>>>>>>>>>>>>>quickScreeenBookingCreationSocket<<<<<<<<<<<<<<<<<<<<<<<");
            console.log('debug', data);
            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            var dateTo = new Date(date_time_value2).getTime();
            var dateFrom = new Date(date_time_value1).getTime();
            for (var i = 0; i < data.res.message.jobArray.length; i++) {
                var index = _.findIndex(vm.UnAssignBookingList, {
                    job_id: data.res.message.jobArray[i].job_id
                });
                console.log(index, 'index');

                if (checkFilterStatus(data.res.message.jobArray[i])) {
                    console.log("app >>> testing", index);

                    if (index == -1) {
                        if (vm.UnAssignBookingList.length == 0 && data.res.message.jobArray[i].discard_from_group) {
                            vm.UnAssignBookingList.push({
                                "contract_name": data.res.message.jobArray[i].contract_name,
                                "estimated_payment_cost": data.res.message.jobArray[i].estimated_payment_cost,
                                "is_VIP": data.res.message.jobArray[i].is_VIP,
                                "is_round_trip": data.res.message.jobArray[i].is_round_trip,
                                "booking_type": data.res.message.jobArray[i].booking_type,
                                "branch": data.res.message.jobArray[i].branch,
                                "type_of_service": data.res.message.jobArray[i].type_of_service,
                                "job_address": data.res.message.jobArray[i].job_address,
                                "job_id": data.res.message.jobArray[i].job_id,
                                "job_pickup_address": data.res.message.jobArray[i].job_pickup_address,
                                "job_pickup_name": data.res.message.jobArray[i].job_pickup_name,
                                "job_pickup_phone": data.res.message.jobArray[i].job_pickup_phone,
                                "job_time_utc": data.res.message.jobArray[i].job_time_utc,
                                "locking_id": data.res.message.jobArray[i].locking_id,
                                "service_name": data.res.message.jobArray[i].service_name,
                                "locking_id_name": data.res.message.jobArray[i].locking_id_name,
                                "observations": data.res.message.jobArray[i].observations,
                                "reference_point": data.res.message.jobArray[i].reference_point,
                                "round_trip_pickup_time_utc": data.res.message.jobArray[i].round_trip_pickup_time_utc,
                                "urgent_booking_assignment": data.res.message.jobArray[i].urgent_booking_assignment,
                                "latitude": data.res.message.jobArray[i].latitude,
                                "longitude": data.res.message.jobArray[i].longitude,
                                "is_person": true,
                                "booking_eta": data.res.message.jobArray[i].booking_eta,
                                "color": '#333',
                                "auto_assignment": data.res.message.jobArray[i].auto_assignment,
                                "booking_visibility_flag": data.res.message.jobArray[i].booking_visibility_flag
                            });
                            $scope.$apply();
                        } else {
                            for (var j = 0; j < vm.UnAssignBookingList.length; j++) {
                                console.log(new Date(vm.UnAssignBookingList[j].job_time_utc).getTime() > new Date(data.res.message.jobArray[i].job_time_utc).getTime());
                                if (!vm.UnAssignBookingList[j].urgent_booking_assignment && data.res.message.jobArray[i].discard_from_group)
                                    if (new Date(vm.UnAssignBookingList[j].job_time_utc).getTime() > new Date(data.res.message.jobArray[i].job_time_utc).getTime()) {
                                        vm.UnAssignBookingList.insert(j, {
                                            "contract_name": data.res.message.jobArray[i].contract_name,
                                            "estimated_payment_cost": data.res.message.jobArray[i].estimated_payment_cost,
                                            "is_VIP": data.res.message.jobArray[i].is_VIP,
                                            "is_round_trip": data.res.message.jobArray[i].is_round_trip,
                                            "booking_type": data.res.message.jobArray[i].booking_type,
                                            "branch": data.res.message.jobArray[i].branch,
                                            "type_of_service": data.res.message.jobArray[i].type_of_service,
                                            "job_address": data.res.message.jobArray[i].job_address,
                                            "job_id": data.res.message.jobArray[i].job_id,
                                            "job_pickup_address": data.res.message.jobArray[i].job_pickup_address,
                                            "job_pickup_name": data.res.message.jobArray[i].job_pickup_name,
                                            "job_pickup_phone": data.res.message.jobArray[i].job_pickup_phone,
                                            "job_time_utc": data.res.message.jobArray[i].job_time_utc,
                                            "locking_id": data.res.message.jobArray[i].locking_id,
                                            "service_name": data.res.message.jobArray[i].service_name,
                                            "locking_id_name": data.res.message.jobArray[i].locking_id_name,
                                            "observations": data.res.message.jobArray[i].observations,
                                            "reference_point": data.res.message.jobArray[i].reference_point,
                                            "round_trip_pickup_time_utc": data.res.message.jobArray[i].round_trip_pickup_time_utc,
                                            "urgent_booking_assignment": data.res.message.jobArray[i].urgent_booking_assignment,
                                            "latitude": data.res.message.jobArray[i].latitude,
                                            "longitude": data.res.message.jobArray[i].longitude,
                                            "is_person": true,
                                            "booking_eta": data.res.message.jobArray[i].booking_eta,
                                            "color": '#333',
                                            "auto_assignment": data.res.message.jobArray[i].auto_assignment,
                                            "booking_visibility_flag": data.res.message.jobArray[i].booking_visibility_flag
                                        });
                                        $scope.$apply();
                                        break;
                                    }
                            }

                            var findIndex = _.findIndex(vm.UnAssignBookingList, {
                                job_id: data.res.message.jobArray[i].job_id
                            });
                            if (findIndex == -1 && data.res.message.jobArray[i].discard_from_group) {
                                vm.UnAssignBookingList.push({
                                    "contract_name": data.res.message.jobArray[i].contract_name,
                                    "estimated_payment_cost": data.res.message.jobArray[i].estimated_payment_cost,
                                    "is_VIP": data.res.message.jobArray[i].is_VIP,
                                    "is_round_trip": data.res.message.jobArray[i].is_round_trip,
                                    "booking_type": data.res.message.jobArray[i].booking_type,
                                    "branch": data.res.message.jobArray[i].branch,
                                    "type_of_service": data.res.message.jobArray[i].type_of_service,
                                    "job_address": data.res.message.jobArray[i].job_address,
                                    "job_id": data.res.message.jobArray[i].job_id,
                                    "job_pickup_address": data.res.message.jobArray[i].job_pickup_address,
                                    "job_pickup_name": data.res.message.jobArray[i].job_pickup_name,
                                    "job_pickup_phone": data.res.message.jobArray[i].job_pickup_phone,
                                    "job_time_utc": data.res.message.jobArray[i].job_time_utc,
                                    "locking_id": data.res.message.jobArray[i].locking_id,
                                    "service_name": data.res.message.jobArray[i].service_name,
                                    "locking_id_name": data.res.message.jobArray[i].locking_id_name,
                                    "observations": data.res.message.jobArray[i].observations,
                                    "reference_point": data.res.message.jobArray[i].reference_point,
                                    "round_trip_pickup_time_utc": data.res.message.jobArray[i].round_trip_pickup_time_utc,
                                    "urgent_booking_assignment": data.res.message.jobArray[i].urgent_booking_assignment,
                                    "latitude": data.res.message.jobArray[i].latitude,
                                    "longitude": data.res.message.jobArray[i].longitude,
                                    "is_person": true,
                                    "booking_eta": data.res.message.jobArray[i].booking_eta,
                                    "color": '#333',
                                    "auto_assignment": data.res.message.jobArray[i].auto_assignment,
                                    "booking_visibility_flag": data.res.message.jobArray[i].booking_visibility_flag
                                });
                                $scope.$apply();
                            }
                        }
                    }
                }
            }
        });
        //====================SOCKET CONNECATION FOR CREATE BOOKING===================

        //====================SOCKET CONNECATION FOR CHANGE JOB STATUS===================
        var assignSocket = $rootScope.$on('quickScreeenBookingAssignedSocket', function (evt, data) {
            console.log(">>>>>>>>>>>quickScreeenBookingAssignedSocket>>>>>>>>>>");
            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            var dateTo = new Date(date_time_value2).getTime();
            var dateFrom = new Date(date_time_value1).getTime();

            for (var i = 0; i < data.res.message.jobArray.length; i++) {

                if (checkFilterStatus(data.res.message.jobArray[i])) {
                    var index = _.findIndex(vm.UnAssignBookingList, {
                        job_id: data.res.message.jobArray[i].job_id
                    });
                    if (index != -1) {
                        vm.UnAssignBookingList.splice(index, 1);
                        $scope.$apply();
                    } else {
                        if (data.res.message.jobArray[i].job_status == 6) {
                            vm.UnAssignBookingList.push({
                                "contract_name": data.res.message.jobArray[i].contract_name,
                                "estimated_payment_cost": data.res.message.jobArray[i].estimated_payment_cost,
                                "is_VIP": data.res.message.jobArray[i].is_VIP,
                                "is_round_trip": data.res.message.jobArray[i].is_round_trip,
                                "booking_type": data.res.message.jobArray[i].booking_type,
                                "branch": data.res.message.jobArray[i].branch,
                                "type_of_service": data.res.message.jobArray[i].type_of_service,
                                "job_address": data.res.message.jobArray[i].job_address,
                                "job_id": data.res.message.jobArray[i].job_id,
                                "job_pickup_address": data.res.message.jobArray[i].job_pickup_address,
                                "job_pickup_name": data.res.message.jobArray[i].job_pickup_name,
                                "job_pickup_phone": data.res.message.jobArray[i].job_pickup_phone,
                                "job_time_utc": data.res.message.jobArray[i].job_time_utc,
                                "locking_id": data.res.message.jobArray[i].locking_id,
                                "service_name": data.res.message.jobArray[i].service_name,
                                "locking_id_name": data.res.message.jobArray[i].locking_id_name,
                                "observations": data.res.message.jobArray[i].observations,
                                "reference_point": data.res.message.jobArray[i].reference_point,
                                "round_trip_pickup_time_utc": data.res.message.jobArray[i].round_trip_pickup_time_utc,
                                "urgent_booking_assignment": data.res.message.jobArray[i].urgent_booking_assignment,
                                "latitude": data.res.message.jobArray[i].latitude,
                                "longitude": data.res.message.jobArray[i].longitude,
                                "is_person": true,
                                "booking_eta": data.res.message.jobArray[i].booking_eta,
                                "color": "#333",
                                "auto_assignment": data.res.message.jobArray[i].auto_assignment,
                                "booking_visibility_flag": data.res.message.jobArray[i].booking_visibility_flag,
                                "schedule_ride": data.res.message.jobArray[i].schedule_ride
                            });
                            // vm.assignBookingList.splice(index, 1);
                            $scope.$apply();
                        }
                    }

                    var index1 = _.findIndex(vm.assignBookingList, {
                        job_id: data.res.message.jobArray[i].job_id
                    });
                    if (index1 == -1) {
                        // vm.loadMore = 1;
                        if (data.res.message.jobArray[i].job_status == 0 || data.res.message.jobArray[i].job_status == 7) {
                            if (vm.assignBookingList.length == 0) {
                                vm.assignBookingList.push({
                                    "contract_name": data.res.message.jobArray[i].contract_name,
                                    "estimated_payment_cost": data.res.message.jobArray[i].estimated_payment_cost,
                                    "is_VIP": data.res.message.jobArray[i].is_VIP,
                                    "is_round_trip": data.res.message.jobArray[i].is_round_trip,
                                    "booking_type": data.res.message.jobArray[i].booking_type,
                                    "branch": data.res.message.jobArray[i].branch,
                                    "type_of_service": data.res.message.jobArray[i].type_of_service,
                                    "job_address": data.res.message.jobArray[i].job_address,
                                    "job_id": data.res.message.jobArray[i].job_id,
                                    "job_pickup_address": data.res.message.jobArray[i].job_pickup_address,
                                    "job_pickup_name": data.res.message.jobArray[i].job_pickup_name,
                                    "job_pickup_phone": data.res.message.jobArray[i].job_pickup_phone,
                                    "job_time_utc": data.res.message.jobArray[i].job_time_utc,
                                    "locking_id": data.res.message.jobArray[i].locking_id,
                                    "service_name": data.res.message.jobArray[i].service_name,
                                    "locking_id_name": data.res.message.jobArray[i].locking_id_name,
                                    "observations": data.res.message.jobArray[i].observations,
                                    "reference_point": data.res.message.jobArray[i].reference_point,
                                    "round_trip_pickup_time_utc": data.res.message.jobArray[i].round_trip_pickup_time_utc,
                                    "urgent_booking_assignment": data.res.message.jobArray[i].urgent_booking_assignment,
                                    "latitude": data.res.message.jobArray[i].latitude,
                                    "longitude": data.res.message.jobArray[i].longitude,
                                    "is_person": true,
                                    "booking_eta": data.res.message.jobArray[i].booking_eta,
                                    "color": "#333",
                                    "fleet_first_name": data.res.message.jobArray[i].fleet_first_name + '' + data.res.message.jobArray[i].fleet_last_name,
                                    "fleet_phone_number": data.res.message.jobArray[i].fleet_country_code + data.res.message.jobArray[i].fleet_phone_number,
                                    "assignment_identity": data.res.message.jobArray[i].assignment_identity,
                                    "auto_assignment": data.res.message.jobArray[i].auto_assignment,
                                    "job_status": data.res.message.jobArray[i].job_status,
                                    "unique_car_id": data.res.message.jobArray[i].unique_car_id,
                                    "schedule_ride": data.res.message.jobArray[i].schedule_ride
                                });
                                $scope.$apply();
                            } else {
                                for (var j = 0; j < vm.assignBookingList.length; j++) {
                                    if (new Date(vm.assignBookingList[j].job_time_utc).getTime() > new Date(data.res.message.jobArray[i].job_time_utc).getTime()) {
                                        vm.assignBookingList.insert(j, {
                                            "contract_name": data.res.message.jobArray[i].contract_name,
                                            "estimated_payment_cost": data.res.message.jobArray[i].estimated_payment_cost,
                                            "is_VIP": data.res.message.jobArray[i].is_VIP,
                                            "is_round_trip": data.res.message.jobArray[i].is_round_trip,
                                            "booking_type": data.res.message.jobArray[i].booking_type,
                                            "branch": data.res.message.jobArray[i].branch,
                                            "type_of_service": data.res.message.jobArray[i].type_of_service,
                                            "job_address": data.res.message.jobArray[i].job_address,
                                            "job_id": data.res.message.jobArray[i].job_id,
                                            "job_pickup_address": data.res.message.jobArray[i].job_pickup_address,
                                            "job_pickup_name": data.res.message.jobArray[i].job_pickup_name,
                                            "job_pickup_phone": data.res.message.jobArray[i].job_pickup_phone,
                                            "job_time_utc": data.res.message.jobArray[i].job_time_utc,
                                            "locking_id": data.res.message.jobArray[i].locking_id,
                                            "service_name": data.res.message.jobArray[i].service_name,
                                            "locking_id_name": data.res.message.jobArray[i].locking_id_name,
                                            "observations": data.res.message.jobArray[i].observations,
                                            "reference_point": data.res.message.jobArray[i].reference_point,
                                            "round_trip_pickup_time_utc": data.res.message.jobArray[i].round_trip_pickup_time_utc,
                                            "urgent_booking_assignment": data.res.message.jobArray[i].urgent_booking_assignment,
                                            "latitude": data.res.message.jobArray[i].latitude,
                                            "longitude": data.res.message.jobArray[i].longitude,
                                            "is_person": true,
                                            "booking_eta": data.res.message.jobArray[i].booking_eta,
                                            "color": "#333",
                                            "fleet_first_name": data.res.message.jobArray[i].fleet_first_name + '' + data.res.message.jobArray[i].fleet_last_name,
                                            "fleet_phone_number": data.res.message.jobArray[i].fleet_country_code + data.res.message.jobArray[i].fleet_phone_number,
                                            "assignment_identity": data.res.message.jobArray[i].assignment_identity,
                                            "auto_assignment": data.res.message.jobArray[i].auto_assignment,
                                            "job_status": data.res.message.jobArray[i].job_status,
                                            "unique_car_id": data.res.message.jobArray[i].unique_car_id,
                                            "schedule_ride": data.res.message.jobArray[i].schedule_ride
                                        });
                                        $scope.$apply();
                                        break;
                                    }
                                }


                                var findIndex = _.findIndex(vm.assignBookingList, {
                                    job_id: data.res.message.jobArray[i].job_id
                                });
                                if (findIndex == -1) {
                                    vm.assignBookingList.push({
                                        "contract_name": data.res.message.jobArray[i].contract_name,
                                        "estimated_payment_cost": data.res.message.jobArray[i].estimated_payment_cost,
                                        "is_VIP": data.res.message.jobArray[i].is_VIP,
                                        "is_round_trip": data.res.message.jobArray[i].is_round_trip,
                                        "booking_type": data.res.message.jobArray[i].booking_type,
                                        "branch": data.res.message.jobArray[i].branch,
                                        "type_of_service": data.res.message.jobArray[i].type_of_service,
                                        "job_address": data.res.message.jobArray[i].job_address,
                                        "job_id": data.res.message.jobArray[i].job_id,
                                        "job_pickup_address": data.res.message.jobArray[i].job_pickup_address,
                                        "job_pickup_name": data.res.message.jobArray[i].job_pickup_name,
                                        "job_pickup_phone": data.res.message.jobArray[i].job_pickup_phone,
                                        "job_time_utc": data.res.message.jobArray[i].job_time_utc,
                                        "locking_id": data.res.message.jobArray[i].locking_id,
                                        "service_name": data.res.message.jobArray[i].service_name,
                                        "locking_id_name": data.res.message.jobArray[i].locking_id_name,
                                        "observations": data.res.message.jobArray[i].observations,
                                        "reference_point": data.res.message.jobArray[i].reference_point,
                                        "round_trip_pickup_time_utc": data.res.message.jobArray[i].round_trip_pickup_time_utc,
                                        "urgent_booking_assignment": data.res.message.jobArray[i].urgent_booking_assignment,
                                        "latitude": data.res.message.jobArray[i].latitude,
                                        "longitude": data.res.message.jobArray[i].longitude,
                                        "is_person": true,
                                        "booking_eta": data.res.message.jobArray[i].booking_eta,
                                        "color": "#333",
                                        "fleet_first_name": data.res.message.jobArray[i].fleet_first_name + '' + data.res.message.jobArray[i].fleet_last_name,
                                        "fleet_phone_number": data.res.message.jobArray[i].fleet_country_code + data.res.message.jobArray[i].fleet_phone_number,
                                        "assignment_identity": data.res.message.jobArray[i].assignment_identity,
                                        "auto_assignment": data.res.message.jobArray[i].auto_assignment,
                                        "job_status": data.res.message.jobArray[i].job_status,
                                        "unique_car_id": data.res.message.jobArray[i].unique_car_id,
                                        "schedule_ride": data.res.message.jobArray[i].schedule_ride
                                    });
                                    $scope.$apply();
                                }
                            }
                        }
                    }
                }

            }
        });
        //====================SOCKET CONNECATION FOR CREATE BOOKING===================

        //====================SOCKET CONNECATION FOR CHANGE JOB STATUS===================
        var assignScannedSocket = $rootScope.$on('quickScreeenBookingScanneddSocket', function (evt, data) {
            console.log(">>>>>>>>>>>quickScreeenBookingScanneddSocket>>>>>>>>>>");

            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            var dateTo = new Date(date_time_value2).getTime();
            var dateFrom = new Date(date_time_value1).getTime();

            for (var i = 0; i < data.res.message.jobArray.length; i++) {

                if (checkFilterStatus(data.res.message.jobArray[i])) {
                    var index = _.findIndex(vm.UnAssignBookingList, {
                        job_id: data.res.message.jobArray[i].job_id
                    });
                    if (index != -1) {
                        vm.UnAssignBookingList.splice(index, 1);
                        $scope.$apply();
                    }

                    var index = _.findIndex(vm.assignBookingList, {
                        job_id: data.res.message.jobArray[i].job_id
                    });
                    if (index == -1) {
                        // vm.loadMore = 1;
                        if (vm.assignBookingList.length == 0) {
                            vm.assignBookingList.push({
                                "contract_name": data.res.message.jobArray[i].contract_name,
                                "estimated_payment_cost": data.res.message.jobArray[i].estimated_payment_cost,
                                "is_VIP": data.res.message.jobArray[i].is_VIP,
                                "is_round_trip": data.res.message.jobArray[i].is_round_trip,
                                "booking_type": data.res.message.jobArray[i].booking_type,
                                "branch": data.res.message.jobArray[i].branch,
                                "type_of_service": data.res.message.jobArray[i].type_of_service,
                                "job_address": data.res.message.jobArray[i].job_address,
                                "job_id": data.res.message.jobArray[i].job_id,
                                "job_pickup_address": data.res.message.jobArray[i].job_pickup_address,
                                "job_pickup_name": data.res.message.jobArray[i].job_pickup_name,
                                "job_pickup_phone": data.res.message.jobArray[i].job_pickup_phone,
                                "job_time_utc": data.res.message.jobArray[i].job_time_utc,
                                "locking_id": data.res.message.jobArray[i].locking_id,
                                "service_name": data.res.message.jobArray[i].service_name,
                                "locking_id_name": data.res.message.jobArray[i].locking_id_name,
                                "observations": data.res.message.jobArray[i].observations,
                                "reference_point": data.res.message.jobArray[i].reference_point,
                                "round_trip_pickup_time_utc": data.res.message.jobArray[i].round_trip_pickup_time_utc,
                                "urgent_booking_assignment": data.res.message.jobArray[i].urgent_booking_assignment,
                                "latitude": data.res.message.jobArray[i].latitude,
                                "longitude": data.res.message.jobArray[i].longitude,
                                "is_person": true,
                                "booking_eta": data.res.message.jobArray[i].booking_eta,
                                "color": "#333",
                                "fleet_first_name": data.res.message.jobArray[i].fleet_first_name + '' + data.res.message.jobArray[i].fleet_last_name,
                                "fleet_phone_number": data.res.message.jobArray[i].fleet_country_code + data.res.message.jobArray[i].fleet_phone_number,
                                "assignment_identity": data.res.message.jobArray[i].assignment_identity,
                                "auto_assignment": data.res.message.jobArray[i].auto_assignment,
                                "job_status": data.res.message.jobArray[i].job_status,
                                "unique_car_id": data.res.message.jobArray[i].unique_car_id,
                                "schedule_ride": data.res.message.jobArray[i].schedule_ride
                            });
                            $scope.$apply();
                        } else {
                            for (var j = 0; j < vm.assignBookingList.length; j++) {
                                if (new Date(vm.assignBookingList[j].job_time_utc).getTime() > new Date(data.res.message.jobArray[i].job_time_utc).getTime()) {
                                    vm.assignBookingList.insert(j, {
                                        "contract_name": data.res.message.jobArray[i].contract_name,
                                        "estimated_payment_cost": data.res.message.jobArray[i].estimated_payment_cost,
                                        "is_VIP": data.res.message.jobArray[i].is_VIP,
                                        "is_round_trip": data.res.message.jobArray[i].is_round_trip,
                                        "booking_type": data.res.message.jobArray[i].booking_type,
                                        "branch": data.res.message.jobArray[i].branch,
                                        "type_of_service": data.res.message.jobArray[i].type_of_service,
                                        "job_address": data.res.message.jobArray[i].job_address,
                                        "job_id": data.res.message.jobArray[i].job_id,
                                        "job_pickup_address": data.res.message.jobArray[i].job_pickup_address,
                                        "job_pickup_name": data.res.message.jobArray[i].job_pickup_name,
                                        "job_pickup_phone": data.res.message.jobArray[i].job_pickup_phone,
                                        "job_time_utc": data.res.message.jobArray[i].job_time_utc,
                                        "locking_id": data.res.message.jobArray[i].locking_id,
                                        "service_name": data.res.message.jobArray[i].service_name,
                                        "locking_id_name": data.res.message.jobArray[i].locking_id_name,
                                        "observations": data.res.message.jobArray[i].observations,
                                        "reference_point": data.res.message.jobArray[i].reference_point,
                                        "round_trip_pickup_time_utc": data.res.message.jobArray[i].round_trip_pickup_time_utc,
                                        "urgent_booking_assignment": data.res.message.jobArray[i].urgent_booking_assignment,
                                        "latitude": data.res.message.jobArray[i].latitude,
                                        "longitude": data.res.message.jobArray[i].longitude,
                                        "is_person": true,
                                        "booking_eta": data.res.message.jobArray[i].booking_eta,
                                        "color": "#333",
                                        "fleet_first_name": data.res.message.jobArray[i].fleet_first_name + '' + data.res.message.jobArray[i].fleet_last_name,
                                        "fleet_phone_number": data.res.message.jobArray[i].fleet_country_code + data.res.message.jobArray[i].fleet_phone_number,
                                        "assignment_identity": data.res.message.jobArray[i].assignment_identity,
                                        "auto_assignment": data.res.message.jobArray[i].auto_assignment,
                                        "job_status": data.res.message.jobArray[i].job_status,
                                        "unique_car_id": data.res.message.jobArray[i].unique_car_id,
                                        "schedule_ride": data.res.message.jobArray[i].schedule_ride
                                    });
                                    $scope.$apply();
                                    break;
                                }
                            }


                            var findIndex = _.findIndex(vm.assignBookingList, {
                                job_id: data.res.message.jobArray[i].job_id
                            });
                            if (findIndex == -1) {
                                vm.assignBookingList.push({
                                    "contract_name": data.res.message.jobArray[i].contract_name,
                                    "estimated_payment_cost": data.res.message.jobArray[i].estimated_payment_cost,
                                    "is_VIP": data.res.message.jobArray[i].is_VIP,
                                    "is_round_trip": data.res.message.jobArray[i].is_round_trip,
                                    "booking_type": data.res.message.jobArray[i].booking_type,
                                    "branch": data.res.message.jobArray[i].branch,
                                    "type_of_service": data.res.message.jobArray[i].type_of_service,
                                    "job_address": data.res.message.jobArray[i].job_address,
                                    "job_id": data.res.message.jobArray[i].job_id,
                                    "job_pickup_address": data.res.message.jobArray[i].job_pickup_address,
                                    "job_pickup_name": data.res.message.jobArray[i].job_pickup_name,
                                    "job_pickup_phone": data.res.message.jobArray[i].job_pickup_phone,
                                    "job_time_utc": data.res.message.jobArray[i].job_time_utc,
                                    "locking_id": data.res.message.jobArray[i].locking_id,
                                    "service_name": data.res.message.jobArray[i].service_name,
                                    "locking_id_name": data.res.message.jobArray[i].locking_id_name,
                                    "observations": data.res.message.jobArray[i].observations,
                                    "reference_point": data.res.message.jobArray[i].reference_point,
                                    "round_trip_pickup_time_utc": data.res.message.jobArray[i].round_trip_pickup_time_utc,
                                    "urgent_booking_assignment": data.res.message.jobArray[i].urgent_booking_assignment,
                                    "latitude": data.res.message.jobArray[i].latitude,
                                    "longitude": data.res.message.jobArray[i].longitude,
                                    "is_person": true,
                                    "booking_eta": data.res.message.jobArray[i].booking_eta,
                                    "color": "#333",
                                    "fleet_first_name": data.res.message.jobArray[i].fleet_first_name + '' + data.res.message.jobArray[i].fleet_last_name,
                                    "fleet_phone_number": data.res.message.jobArray[i].fleet_country_code + data.res.message.jobArray[i].fleet_phone_number,
                                    "assignment_identity": data.res.message.jobArray[i].assignment_identity,
                                    "auto_assignment": data.res.message.jobArray[i].auto_assignment,
                                    "job_status": data.res.message.jobArray[i].job_status,
                                    "unique_car_id": data.res.message.jobArray[i].unique_car_id,
                                    "schedule_ride": data.res.message.jobArray[i].schedule_ride
                                });
                            }
                        }
                    }
                }

            }
        });
        //====================SOCKET CONNECATION FOR CREATE BOOKING===================

        //====================SOCKET CONNECTION FOR MODIFY BOOKING===================
        var myListener = $rootScope.$on('quickScreeenBookingModifySocket', function (evt, data) {
            console.log(">>>>>>>>>>>quickScreeenBookingModifySocket>>>>>>>>>>");
            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            var dateTo = new Date(date_time_value2).getTime();
            var dateFrom = new Date(date_time_value1).getTime();

            for (var i = 0; i < data.res.message.jobArray.length; i++) {

                var index = _.findIndex(vm.UnAssignBookingList, {
                    job_id: data.res.message.jobArray[i].job_id
                });
                if (checkFilterStatus(data.res.message.jobArray[i])) {
                    if (index != -1) {
                        vm.UnAssignBookingList.splice(index, 1);
                        if (vm.UnAssignBookingList.length == 0) {
                            vm.UnAssignBookingList.push({
                                "contract_name": data.res.message.jobArray[i].contract_name,
                                "estimated_payment_cost": data.res.message.jobArray[i].estimated_payment_cost,
                                "is_VIP": data.res.message.jobArray[i].is_VIP,
                                "is_round_trip": data.res.message.jobArray[i].is_round_trip,
                                "booking_type": data.res.message.jobArray[i].booking_type,
                                "branch": data.res.message.jobArray[i].branch,
                                "type_of_service": data.res.message.jobArray[i].type_of_service,
                                "job_address": data.res.message.jobArray[i].job_address,
                                "job_id": data.res.message.jobArray[i].job_id,
                                "job_pickup_address": data.res.message.jobArray[i].job_pickup_address,
                                "job_pickup_name": data.res.message.jobArray[i].job_pickup_name,
                                "job_pickup_phone": data.res.message.jobArray[i].job_pickup_phone,
                                "job_time_utc": data.res.message.jobArray[i].job_time_utc,
                                "locking_id": data.res.message.jobArray[i].locking_id,
                                "service_name": data.res.message.jobArray[i].service_name,
                                "locking_id_name": data.res.message.jobArray[i].locking_id_name,
                                "observations": data.res.message.jobArray[i].observations,
                                "reference_point": data.res.message.jobArray[i].reference_point,
                                "round_trip_pickup_time_utc": data.res.message.jobArray[i].round_trip_pickup_time_utc,
                                "urgent_booking_assignment": data.res.message.jobArray[i].urgent_booking_assignment,
                                "latitude": data.res.message.jobArray[i].latitude,
                                "longitude": data.res.message.jobArray[i].longitude,
                                "is_person": true,
                                "booking_eta": data.res.message.jobArray[i].booking_eta,
                                "color": "#333",
                                "auto_assignment": data.res.message.jobArray[i].auto_assignment,
                                "booking_visibility_flag": data.res.message.jobArray[i].booking_visibility_flag,
                                "schedule_ride": data.res.message.jobArray[i].schedule_ride
                            });
                            $scope.$apply();
                        } else {
                            for (var j = 0; j < vm.UnAssignBookingList.length; j++) {
                                if (!vm.UnAssignBookingList[j].urgent_booking_assignment)
                                    if (new Date(vm.UnAssignBookingList[j].job_time_utc).getTime() > new Date(data.res.message.jobArray[i].job_time_utc).getTime()) {
                                        vm.UnAssignBookingList.insert(j, {
                                            "contract_name": data.res.message.jobArray[i].contract_name,
                                            "estimated_payment_cost": data.res.message.jobArray[i].estimated_payment_cost,
                                            "is_VIP": data.res.message.jobArray[i].is_VIP,
                                            "is_round_trip": data.res.message.jobArray[i].is_round_trip,
                                            "booking_type": data.res.message.jobArray[i].booking_type,
                                            "branch": data.res.message.jobArray[i].branch,
                                            "type_of_service": data.res.message.jobArray[i].type_of_service,
                                            "job_address": data.res.message.jobArray[i].job_address,
                                            "job_id": data.res.message.jobArray[i].job_id,
                                            "job_pickup_address": data.res.message.jobArray[i].job_pickup_address,
                                            "job_pickup_name": data.res.message.jobArray[i].job_pickup_name,
                                            "job_pickup_phone": data.res.message.jobArray[i].job_pickup_phone,
                                            "job_time_utc": data.res.message.jobArray[i].job_time_utc,
                                            "locking_id": data.res.message.jobArray[i].locking_id,
                                            "service_name": data.res.message.jobArray[i].service_name,
                                            "locking_id_name": data.res.message.jobArray[i].locking_id_name,
                                            "observations": data.res.message.jobArray[i].observations,
                                            "reference_point": data.res.message.jobArray[i].reference_point,
                                            "round_trip_pickup_time_utc": data.res.message.jobArray[i].round_trip_pickup_time_utc,
                                            "urgent_booking_assignment": data.res.message.jobArray[i].urgent_booking_assignment,
                                            "latitude": data.res.message.jobArray[i].latitude,
                                            "longitude": data.res.message.jobArray[i].longitude,
                                            "is_person": true,
                                            "booking_eta": data.res.message.jobArray[i].booking_eta,
                                            "color": "#333",
                                            "auto_assignment": data.res.message.jobArray[i].auto_assignment,
                                            "booking_visibility_flag": data.res.message.jobArray[i].booking_visibility_flag,
                                            "schedule_ride": data.res.message.jobArray[i].schedule_ride
                                        });
                                        $scope.$apply();
                                        break;
                                    }
                            }
                            var findIndex = _.findIndex(vm.UnAssignBookingList, {
                                job_id: data.res.message.jobArray[i].job_id
                            });
                            if (findIndex == -1) {
                                vm.UnAssignBookingList.push({
                                    "contract_name": data.res.message.jobArray[i].contract_name,
                                    "estimated_payment_cost": data.res.message.jobArray[i].estimated_payment_cost,
                                    "is_VIP": data.res.message.jobArray[i].is_VIP,
                                    "is_round_trip": data.res.message.jobArray[i].is_round_trip,
                                    "booking_type": data.res.message.jobArray[i].booking_type,
                                    "branch": data.res.message.jobArray[i].branch,
                                    "type_of_service": data.res.message.jobArray[i].type_of_service,
                                    "job_address": data.res.message.jobArray[i].job_address,
                                    "job_id": data.res.message.jobArray[i].job_id,
                                    "job_pickup_address": data.res.message.jobArray[i].job_pickup_address,
                                    "job_pickup_name": data.res.message.jobArray[i].job_pickup_name,
                                    "job_pickup_phone": data.res.message.jobArray[i].job_pickup_phone,
                                    "job_time_utc": data.res.message.jobArray[i].job_time_utc,
                                    "locking_id": data.res.message.jobArray[i].locking_id,
                                    "service_name": data.res.message.jobArray[i].service_name,
                                    "locking_id_name": data.res.message.jobArray[i].locking_id_name,
                                    "observations": data.res.message.jobArray[i].observations,
                                    "reference_point": data.res.message.jobArray[i].reference_point,
                                    "round_trip_pickup_time_utc": data.res.message.jobArray[i].round_trip_pickup_time_utc,
                                    "urgent_booking_assignment": data.res.message.jobArray[i].urgent_booking_assignment,
                                    "latitude": data.res.message.jobArray[i].latitude,
                                    "longitude": data.res.message.jobArray[i].longitude,
                                    "is_person": true,
                                    "booking_eta": data.res.message.jobArray[i].booking_eta,
                                    "color": data.res.message.jobArray[i].urgent_booking_assignment ? '#ff4d4d' : '#333',
                                    "auto_assignment": data.res.message.jobArray[i].auto_assignment,
                                    "booking_visibility_flag": data.res.message.jobArray[i].booking_visibility_flag,
                                    "schedule_ride": data.res.message.jobArray[i].schedule_ride
                                });
                            }
                        }
                    }
                }
                else {
                    if (index != -1) {
                        if (data.res.message.jobArray[i].job_status == 6 && data.res.message.jobArray[i].booking_date_modified) {
                            vm.UnAssignBookingList.splice(index, 1);
                            $scope.$apply();
                        } else if (data.res.message.jobArray[i].job_status == 9 || data.res.message.jobArray[i].job_status == 3) {
                            vm.UnAssignBookingList.splice(index, 1);
                            $scope.$apply();
                        }
                    } else {
                        if (data.res.message.jobArray[i].job_status == 9 || data.res.message.jobArray[i].job_status == 3) {
                            vm.assignBookingList.splice(index, 1);
                            $scope.$apply();
                        }
                    }
                }
            }
        });
        //====================SOCKET CONNECTION FOR MODIFY BOOKING===================

        //====================SOCKET CONNECTION FOR UNASSIGNBOOKING===================
        $rootScope.$on('quickScreeenBookingunassignedSocket', function (evt, data) {
            console.log(">>>>>>>>>>>quickScreeenBookingunassignedSocket>>>>>>>>>>");
            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            var dateTo = new Date(date_time_value2).getTime();
            var dateFrom = new Date(date_time_value1).getTime();
            for (var i = 0; i < data.res.message.jobArray.length; i++) {
                var index1 = _.findIndex(vm.UnAssignBookingList, {
                    job_id: data.res.message.jobArray[i].job_id
                });
                if (checkFilterStatus(data.res.message.jobArray[i])) {
                    var index = _.findIndex(vm.assignBookingList, {
                        job_id: data.res.message.jobArray[i].job_id
                    });
                    if (index != -1) {
                        vm.assignBookingList.splice(index, 1);
                        $scope.$apply();
                    }
                    if (index1 == -1) {
                        // vm.loadMore = 1;
                        if (vm.UnAssignBookingList.length == 0 && data.res.message.jobArray[i].booking_type == 0) {
                            vm.UnAssignBookingList.push({
                                "contract_name": data.res.message.jobArray[i].contract_name,
                                "estimated_payment_cost": data.res.message.jobArray[i].estimated_payment_cost,
                                "is_VIP": data.res.message.jobArray[i].is_VIP,
                                "is_round_trip": data.res.message.jobArray[i].is_round_trip,
                                "booking_type": data.res.message.jobArray[i].booking_type,
                                "branch": data.res.message.jobArray[i].branch,
                                "type_of_service": data.res.message.jobArray[i].type_of_service,
                                "job_address": data.res.message.jobArray[i].job_address,
                                "job_id": data.res.message.jobArray[i].job_id,
                                "job_pickup_address": data.res.message.jobArray[i].job_pickup_address,
                                "job_pickup_name": data.res.message.jobArray[i].job_pickup_name,
                                "job_pickup_phone": data.res.message.jobArray[i].job_pickup_phone,
                                "job_time_utc": data.res.message.jobArray[i].job_time_utc,
                                "locking_id": data.res.message.jobArray[i].locking_id,
                                "service_name": data.res.message.jobArray[i].service_name,
                                "locking_id_name": data.res.message.jobArray[i].locking_id_name,
                                "observations": data.res.message.jobArray[i].observations,
                                "reference_point": data.res.message.jobArray[i].reference_point,
                                "round_trip_pickup_time_utc": data.res.message.jobArray[i].round_trip_pickup_time_utc,
                                "urgent_booking_assignment": data.res.message.jobArray[i].urgent_booking_assignment,
                                "latitude": data.res.message.jobArray[i].latitude,
                                "longitude": data.res.message.jobArray[i].longitude,
                                "is_person": true,
                                "booking_eta": data.res.message.jobArray[i].booking_eta,
                                "color": "#333",
                                "auto_assignment": data.res.message.jobArray[i].auto_assignment,
                                "booking_visibility_flag": data.res.message.jobArray[i].booking_visibility_flag,
                                "schedule_ride": data.res.message.jobArray[i].schedule_ride
                            });
                            $scope.$apply();
                        } else {
                            console.log(vm.UnAssignBookingList.length);

                            for (var j = 0; j < vm.UnAssignBookingList.length; j++) {
                                console.log('>>>>>>>>>>', new Date(vm.UnAssignBookingList[j].job_time_utc).getTime() > new Date(data.res.message.jobArray[i].job_time_utc).getTime());
                                if (!vm.UnAssignBookingList[j].urgent_booking_assignment && data.res.message.jobArray[i].booking_type == 0)
                                    if (new Date(vm.UnAssignBookingList[j].job_time_utc).getTime() > new Date(data.res.message.jobArray[i].job_time_utc).getTime()) {
                                        vm.UnAssignBookingList.insert(j, {
                                            "contract_name": data.res.message.jobArray[i].contract_name,
                                            "estimated_payment_cost": data.res.message.jobArray[i].estimated_payment_cost,
                                            "is_VIP": data.res.message.jobArray[i].is_VIP,
                                            "is_round_trip": data.res.message.jobArray[i].is_round_trip,
                                            "booking_type": data.res.message.jobArray[i].booking_type,
                                            "branch": data.res.message.jobArray[i].branch,
                                            "type_of_service": data.res.message.jobArray[i].type_of_service,
                                            "job_address": data.res.message.jobArray[i].job_address,
                                            "job_id": data.res.message.jobArray[i].job_id,
                                            "job_pickup_address": data.res.message.jobArray[i].job_pickup_address,
                                            "job_pickup_name": data.res.message.jobArray[i].job_pickup_name,
                                            "job_pickup_phone": data.res.message.jobArray[i].job_pickup_phone,
                                            "job_time_utc": data.res.message.jobArray[i].job_time_utc,
                                            "locking_id": data.res.message.jobArray[i].locking_id,
                                            "service_name": data.res.message.jobArray[i].service_name,
                                            "locking_id_name": data.res.message.jobArray[i].locking_id_name,
                                            "observations": data.res.message.jobArray[i].observations,
                                            "reference_point": data.res.message.jobArray[i].reference_point,
                                            "round_trip_pickup_time_utc": data.res.message.jobArray[i].round_trip_pickup_time_utc,
                                            "urgent_booking_assignment": data.res.message.jobArray[i].urgent_booking_assignment,
                                            "latitude": data.res.message.jobArray[i].latitude,
                                            "longitude": data.res.message.jobArray[i].longitude,
                                            "is_person": true,
                                            "booking_eta": data.res.message.jobArray[i].booking_eta,
                                            "color": data.res.message.jobArray[i].urgent_booking_assignment ? '#ff4d4d' : '#333',
                                            "auto_assignment": data.res.message.jobArray[i].auto_assignment,
                                            "booking_visibility_flag": data.res.message.jobArray[i].booking_visibility_flag,
                                            "schedule_ride": data.res.message.jobArray[i].schedule_ride
                                        });
                                        $scope.$apply();
                                        break;
                                    }
                            }

                            var findIndex = _.findIndex(vm.UnAssignBookingList, {
                                job_id: data.res.message.jobArray[i].job_id
                            });
                            if (findIndex == -1 && data.res.message.jobArray[i].booking_type == 0) {
                                vm.UnAssignBookingList.push({
                                    "contract_name": data.res.message.jobArray[i].contract_name,
                                    "estimated_payment_cost": data.res.message.jobArray[i].estimated_payment_cost,
                                    "is_VIP": data.res.message.jobArray[i].is_VIP,
                                    "is_round_trip": data.res.message.jobArray[i].is_round_trip,
                                    "booking_type": data.res.message.jobArray[i].booking_type,
                                    "branch": data.res.message.jobArray[i].branch,
                                    "type_of_service": data.res.message.jobArray[i].type_of_service,
                                    "job_address": data.res.message.jobArray[i].job_address,
                                    "job_id": data.res.message.jobArray[i].job_id,
                                    "job_pickup_address": data.res.message.jobArray[i].job_pickup_address,
                                    "job_pickup_name": data.res.message.jobArray[i].job_pickup_name,
                                    "job_pickup_phone": data.res.message.jobArray[i].job_pickup_phone,
                                    "job_time_utc": data.res.message.jobArray[i].job_time_utc,
                                    "locking_id": data.res.message.jobArray[i].locking_id,
                                    "service_name": data.res.message.jobArray[i].service_name,
                                    "locking_id_name": data.res.message.jobArray[i].locking_id_name,
                                    "observations": data.res.message.jobArray[i].observations,
                                    "reference_point": data.res.message.jobArray[i].reference_point,
                                    "round_trip_pickup_time_utc": data.res.message.jobArray[i].round_trip_pickup_time_utc,
                                    "urgent_booking_assignment": data.res.message.jobArray[i].urgent_booking_assignment,
                                    "latitude": data.res.message.jobArray[i].latitude,
                                    "longitude": data.res.message.jobArray[i].longitude,
                                    "is_person": true,
                                    "booking_eta": data.res.message.jobArray[i].booking_eta,
                                    "color": data.res.message.jobArray[i].urgent_booking_assignment ? '#ff4d4d' : '#333',
                                    "auto_assignment": data.res.message.jobArray[i].auto_assignment,
                                    "booking_visibility_flag": data.res.message.jobArray[i].booking_visibility_flag,
                                    "schedule_ride": data.res.message.jobArray[i].schedule_ride
                                });
                                $scope.$apply();
                            }
                        }
                    }
                }

            }

        });
        //====================SOCKET CONNECTION FOR UNASSIGNBOOKING===================

        // ==================== SOCKET CONNECTION FOR JOB MULTIPLE TO CHANGE THE STATUS /////////////
        $rootScope.$on('NotifyToAdminForJobMultiple', function (evt, data) {
            console.log(">>>>>>>>>>>>>>>>>>>NotifyToAdminForJobMultiple?<<<<<<<<<<<<<<<<<<<<<<<");

            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            var dateTo = new Date(date_time_value2).getTime();
            var dateFrom = new Date(date_time_value1).getTime();
            var index1 = _.findIndex(vm.UnAssignBookingList, {
                job_id: data.res.message.job_id
            });
            if (checkFilterStatus(data.res.message)) {
                if (index1 != -1) {
                    if (data.res.message.urgent_booking_assignment == 1) {
                        var dummyObject = vm.UnAssignBookingList.splice(index1, 1);
                        vm.UnAssignBookingList.insert(0, dummyObject[0]);
                        vm.UnAssignBookingList[0].auto_assignment = data.res.message.auto_assignment;
                        vm.UnAssignBookingList[0].booking_visibility_flag = data.res.message.booking_visibility_flag;
                        vm.UnAssignBookingList[0].color = data.res.message.urgent_booking_assignment ? '#ff4d4d' : '#333';
                        if (vm.colorFlag[index1]) {
                            vm.colorFlag[0] = !vm.colorFlag[0];
                            if (vm.selectedAutoAssignBookingCount > 0)
                                vm.selectedAutoAssignBookingCount -= 1;
                        }
                        $scope.$apply();
                    } else {
                        vm.UnAssignBookingList[index1].auto_assignment = data.res.message.auto_assignment;
                        vm.UnAssignBookingList[index1].booking_visibility_flag = data.res.message.booking_visibility_flag;
                        vm.UnAssignBookingList[index1].color = data.res.message.urgent_booking_assignment ? '#ff4d4d' : '#333';
                        if (vm.colorFlag[index1]) {
                            vm.colorFlag[index1] = !vm.colorFlag[index1];
                            if (vm.selectedAutoAssignBookingCount > 0)
                                vm.selectedAutoAssignBookingCount -= 1;
                        }
                        $scope.$apply();
                    }
                }
            }
        });
        // ==================== SOCKET CONNECTION FOR JOB MULTIPLE TO CHANGE THE STATUS /////////////

        // ==================== SOCKET CONNECTION FOR JOB MULTIPLE TO JOB ACCEPTED /////////////
        $rootScope.$on('NotifyToAdminForJobAcceptedMultiple', function (evt, data) {
            console.log(">>>>>>>>>>>>>>>>>>>NotifyToAdminForJobAcceptedMultiple?<<<<<<<<<<<<<<<<<<<<<<<");
            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            var dateTo = new Date(date_time_value2).getTime();
            var dateFrom = new Date(date_time_value1).getTime();
            var index1 = _.findIndex(vm.UnAssignBookingList, {
                job_id: data.res.message.job_id
            });
            if (checkFilterStatus(data.res.message)) {
                if (index != -1) {
                    vm.UnAssignBookingList.splice(index, 1);
                    $scope.$apply();
                }

                var indexAccepted = _.findIndex(vm.assignBookingList, {
                    job_id: data.res.message.jobArray[i].job_id
                });
                if (indexAccepted == -1) {
                    // vm.loadMore = 1;
                    if (vm.assignBookingList.length == 0) {
                        vm.assignBookingList.push({
                            "contract_name": data.res.message.jobArray[i].contract_name,
                            "estimated_payment_cost": data.res.message.jobArray[i].estimated_payment_cost,
                            "is_VIP": data.res.message.jobArray[i].is_VIP,
                            "is_round_trip": data.res.message.jobArray[i].is_round_trip,
                            "booking_type": data.res.message.jobArray[i].booking_type,
                            "branch": data.res.message.jobArray[i].branch,
                            "type_of_service": data.res.message.jobArray[i].type_of_service,
                            "job_address": data.res.message.jobArray[i].job_address,
                            "job_id": data.res.message.jobArray[i].job_id,
                            "job_pickup_address": data.res.message.jobArray[i].job_pickup_address,
                            "job_pickup_name": data.res.message.jobArray[i].job_pickup_name,
                            "job_pickup_phone": data.res.message.jobArray[i].job_pickup_phone,
                            "job_time_utc": data.res.message.jobArray[i].job_time_utc,
                            "locking_id": data.res.message.jobArray[i].locking_id,
                            "service_name": data.res.message.jobArray[i].service_name,
                            "locking_id_name": data.res.message.jobArray[i].locking_id_name,
                            "observations": data.res.message.jobArray[i].observations,
                            "reference_point": data.res.message.jobArray[i].reference_point,
                            "round_trip_pickup_time_utc": data.res.message.jobArray[i].round_trip_pickup_time_utc,
                            "urgent_booking_assignment": data.res.message.jobArray[i].urgent_booking_assignment,
                            "latitude": data.res.message.jobArray[i].latitude,
                            "longitude": data.res.message.jobArray[i].longitude,
                            "is_person": true,
                            "booking_eta": data.res.message.jobArray[i].booking_eta,
                            "color": "#333",
                            "fleet_first_name": data.res.message.jobArray[i].fleet_first_name + '' + data.res.message.jobArray[i].fleet_last_name,
                            "fleet_phone_number": data.res.message.jobArray[i].fleet_country_code + data.res.message.jobArray[i].fleet_phone_number,
                            "assignment_identity": data.res.message.jobArray[i].assignment_identity,
                            "auto_assignment": data.res.message.jobArray[i].auto_assignment,
                            "job_status": data.res.message.jobArray[i].job_status,
                            "unique_car_id": data.res.message.jobArray[i].unique_car_id,
                            "schedule_ride": data.res.message.jobArray[i].schedule_ride
                        });
                        $scope.$apply();
                    } else {
                        for (var j = 0; j < vm.assignBookingList.length; j++) {
                            if (new Date(vm.assignBookingList[j].job_time_utc).getTime() > new Date(data.res.message.jobArray[i].job_time_utc).getTime()) {
                                vm.assignBookingList.insert(j, {
                                    "contract_name": data.res.message.jobArray[i].contract_name,
                                    "estimated_payment_cost": data.res.message.jobArray[i].estimated_payment_cost,
                                    "is_VIP": data.res.message.jobArray[i].is_VIP,
                                    "is_round_trip": data.res.message.jobArray[i].is_round_trip,
                                    "booking_type": data.res.message.jobArray[i].booking_type,
                                    "branch": data.res.message.jobArray[i].branch,
                                    "type_of_service": data.res.message.jobArray[i].type_of_service,
                                    "job_address": data.res.message.jobArray[i].job_address,
                                    "job_id": data.res.message.jobArray[i].job_id,
                                    "job_pickup_address": data.res.message.jobArray[i].job_pickup_address,
                                    "job_pickup_name": data.res.message.jobArray[i].job_pickup_name,
                                    "job_pickup_phone": data.res.message.jobArray[i].job_pickup_phone,
                                    "job_time_utc": data.res.message.jobArray[i].job_time_utc,
                                    "locking_id": data.res.message.jobArray[i].locking_id,
                                    "service_name": data.res.message.jobArray[i].service_name,
                                    "locking_id_name": data.res.message.jobArray[i].locking_id_name,
                                    "observations": data.res.message.jobArray[i].observations,
                                    "reference_point": data.res.message.jobArray[i].reference_point,
                                    "round_trip_pickup_time_utc": data.res.message.jobArray[i].round_trip_pickup_time_utc,
                                    "urgent_booking_assignment": data.res.message.jobArray[i].urgent_booking_assignment,
                                    "latitude": data.res.message.jobArray[i].latitude,
                                    "longitude": data.res.message.jobArray[i].longitude,
                                    "is_person": true,
                                    "booking_eta": data.res.message.jobArray[i].booking_eta,
                                    "color": "#333",
                                    "fleet_first_name": data.res.message.jobArray[i].fleet_first_name + '' + data.res.message.jobArray[i].fleet_last_name,
                                    "fleet_phone_number": data.res.message.jobArray[i].fleet_country_code + data.res.message.jobArray[i].fleet_phone_number,
                                    "assignment_identity": data.res.message.jobArray[i].assignment_identity,
                                    "auto_assignment": data.res.message.jobArray[i].auto_assignment,
                                    "job_status": data.res.message.jobArray[i].job_status,
                                    "unique_car_id": data.res.message.jobArray[i].unique_car_id,
                                    "schedule_ride": data.res.message.jobArray[i].schedule_ride
                                });
                                $scope.$apply();
                                break;
                            }
                        }
                    }
                }
            }
        });
        // ==================== SOCKET CONNECTION FOR JOB MULTIPLE TO CHANGE THE STATUS /////////////


        //====================SOCKET CONNECTION FOR CANCEL NOSHOW===================
        $rootScope.$on('SocketComesUpcoming', function (evt, data) {
            console.log(">>>>>>>>>>>>>>>>>>>SocketComesUpcoming?<<<<<<<<<<<<<<<<<<<<<<<");
            console.log('debug1', data);
            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            var dateTo = new Date(date_time_value2).getTime();
            var dateFrom = new Date(date_time_value1).getTime();
            for (var i = 0; i < data.res.message.jobArray.length; i++) {
                var index1 = _.findIndex(vm.UnAssignBookingList, {
                    job_id: data.res.message.jobArray[i].job_id
                });
                if (checkFilterStatus(data.res.message.jobArray[i])) {

                    if (data.res.message.jobArray[i].booking_type == 0 && (data.res.message.jobArray[i].job_status == 9 || data.res.message.jobArray[i].job_status == 12)) {
                        var index = _.findIndex(vm.assignBookingList, {
                            job_id: data.res.message.jobArray[i].job_id
                        });
                        if (index != -1) {
                            vm.assignBookingList.splice(index, 1);
                            $scope.$apply();
                        }
                        var index1 = _.findIndex(vm.UnAssignBookingList, {
                            job_id: data.res.message.jobArray[i].job_id
                        });
                        console.log("i m in tis please check ", data.res.message.jobArray[i].job_id, index1);

                        if (index1 != -1) {
                            vm.UnAssignBookingList.splice(index1, 1);
                            $scope.$apply();
                        }
                    }
                }
            }
        });
        //====================SOCKET CONNECTION FOR CANCEL NOSHOW===================

        //====================SOCKET CONNECTION FOR CANCEL NOSHOW===================
        $rootScope.$on('SocketComesOngoing', function (evt, data) {
            //console.log("SocketComesOngoing", data);
            console.log(">>>>>>>>>>>>>>>>>>>SocketComesOngoing?<<<<<<<<<<<<<<<<<<<<<<<");
            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            var dateTo = new Date(date_time_value2).getTime();
            var dateFrom = new Date(date_time_value1).getTime();
            for (var i = 0; i < data.res.message.jobArray.length; i++) {
                // var index1 = _.findIndex(vm.UnAssignBookingList, {
                //     job_id: data.res.message.jobArray[i].job_id
                // });
                if (checkFilterStatus(data.res.message.jobArray[i])) {
                    var index = _.findIndex(vm.assignBookingList, {
                        job_id: data.res.message.jobArray[i].job_id
                    });
                    if (data.res.message.jobArray[i].job_status == 1 || data.res.message.jobArray[i].job_status == 2) {
                        if (index != -1) {
                            vm.assignBookingList.splice(index, 1);
                            $scope.$apply();
                        }
                    } else {
                        if (index != -1) {
                            vm.assignBookingList[index].job_status = data.res.message.jobArray[i].job_status;
                            $scope.$apply();
                        }
                    }
                }
            }
        });
        //====================SOCKET CONNECTION FOR CANCEL NOSHOW===================

        //====================MASSIVE PUSH TO DRIVERS ===================
        function massivePushToDrivers() {
            var dataSend = {};
            dataSend.job_id = [];
            dataSend.access_token = $cookies.get('obj');
            console.log(vm.selectedArray);
            vm.selectedArray.forEach(function (data) {
                if (data != null)
                    dataSend.job_id.push(data.job_id);
            })
            dataSend.job_id = _.uniq(dataSend.job_id);
            if (dataSend.job_id.length == 0) {
                return;
            }
            // dataSend.socket_id = $rootScope.socket.id;
            vm.loading = true;
            vm.flagForLoading = false;
            var promise = getBookings.autoAssignMassivePush(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    //vm.loading = false;

                    // socketDataForAssign();
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        vm.loading = false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        vm.loading = false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.loading = false;
                        vm.colorFlag = [];
                        vm.selectedArray = [];
                        vm.selectedAutoAssignBookingCount = 0;
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        //====================MASSIVE PUSH TO DRIVERS ===================
    }



})();

/**
 * Created by cl-macmini-51 on 5/20/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('MassiveModifyBookingController', MassiveModifyBookingController);

    /** @ngInject */
    function MassiveModifyBookingController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document, moment, getCustomers, $scope, getBookings,
        RutHelper, errorMessageFactory, languageBasedErrorFactory, adminAccessService, hidePublicPlaces, pendingRequests, getCorporate, getAgreement, checkDomain, tmhDynamicLocale, quickSaleService, getFilters, Initializer, calenderTranslate, getServices) {
        var vm = this;
        if ($rootScope.socket.connected == false || $rootScope.socket.connected == 'false') {
            $rootScope.socket.connect();
        }
        vm.refId = $stateParams.id;
        vm.changeDateIntoSpanish = changeDateIntoSpanish;
        vm.refreshPage = refreshPage;
        vm.downloadData = downloadData;
        vm.paginationForData = paginationForData;
        vm.offset = 0;
        function changeDateIntoSpanish(date) {
            var options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            };
            return new Date(date).toLocaleString($cookies.get('language') == 'spanish' ? 'es' : 'en', options)
        }
        if (vm.refId != null) {
            getBulkCsvData(0, 0, 'unscroll');
        }

        function getBulkCsvData(linkSend, offsetNew , type) {
            var d = [];
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.carga_masiva_id = Number(vm.refId);
            dataSend.download_link = linkSend;
            dataSend.limit = 200;
            dataSend.offset = offsetNew;
            var dataArray = [];
            vm.loading = true;
            var promise = getAgreement.getMassiveModificationData(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    console.log(payload,'carga_masiva_result');
                    
                    if (linkSend == 0) {
                        if (payload && payload.title.status == 200) {
                            vm.achiveLines = payload.title.data.totalCount;
                            vm.errorLines = payload.title.data.carga_masiva_result.CantidadLineasErroresCargaBD != null ?  payload.title.data.carga_masiva_result.CantidadLineasErroresCargaBD : 0;
                            if (payload.title.status == 200) {
                                if (payload.title.data.result.length > 0) {
                                    vm.totalCount = payload.title.data.totalCount;
                                    if (type != 'scroll') {
                                        vm.bookingData = payload.title.data.result;
                                    } else {
                                        console.log(type, 'type');
                                        for (var i = 0; i < payload.title.data.result.length; i++) {
                                            vm.bookingData.push(payload.title.data.result[i])
                                        }
                                    }
                                } else {
                                    vm.bookingData = '';
                                    vm.totalCount = payload.title.data.totalCount;
                                }
                            } else {
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            }

                        }
                    } else {
                        var link = document.createElement("a");
                        link.download = payload.title.data.carga_masiva_result.enlazar_xlsx;
                        link.href = payload.title.data.carga_masiva_result.enlazar_xlsx;
                        link.click();
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function downloadData() {
            getBulkCsvData(1);
        }

        function refreshPage() {
            $state.go('layout.massiveCreateBookingMain.massiveCreateBooking');
        }

        function paginationForData() {
            if (vm.totalCount > vm.bookingData.length + 1) {
                vm.offset = vm.offset + 200;
                getBulkCsvData(0 , vm.offset , 'scroll');
            }
        }
    }
})();
/**
 * Created by cl-macmini-51 on 5/20/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('MassiveCreatePackageNewPageController', MassiveCreatePackageNewPageController);

    /** @ngInject */
    function MassiveCreatePackageNewPageController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document, moment, getCustomers, $scope, getBookings,
        RutHelper, errorMessageFactory, languageBasedErrorFactory, adminAccessService, hidePublicPlaces, pendingRequests, getCorporate, getAgreement, checkDomain, tmhDynamicLocale, quickSaleService, getFilters, Initializer, calenderTranslate, getServices) {
        var vm = this;
        if ($rootScope.socket.connected == false || $rootScope.socket.connected == 'false') {
            $rootScope.socket.connect();
        }
        vm.refId = $stateParams.id;
        vm.changeDateIntoSpanish = changeDateIntoSpanish;
        vm.refreshPage = refreshPage;
        vm.downloadData = downloadData;

        function changeDateIntoSpanish(date) {
            var options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            };
            return new Date(date).toLocaleString($cookies.get('language') == 'spanish' ? 'es' : 'en', options)
        }
        if (vm.refId != null) {
            getBulkCsvData(0);
        }

        function getBulkCsvData(linkSend) {
            var d = [];
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.tableRefId = Number(vm.refId);
            dataSend.link = linkSend;
            var dataArray = [];
            vm.loading = true;
            var promise = getAgreement.getPackageDataAfterCreationNew(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    console.log(payload.title.data,'payload.title.data');
                    
                    if (linkSend == 0) {
                        if (payload && payload.title.status == 200) {
                            vm.achiveLines = payload.title.data.totalLines;
                            vm.errorLines = payload.title.data.errorLinesCount;
                            vm.previewPackageData = payload.title.data.data;
                            // vm.CsvData = dataArray;
                            // vm.previewPackageData = dataArray;
                        }
                    } else {
                        var link = document.createElement("a");
                        link.download = payload.title.data.data[0].enlazar_xlsx;
                        link.href = payload.title.data.data[0].enlazar_xlsx;
                        link.click();
                    }
                   
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function downloadData() {
            getBulkCsvData(1);
        }

        function refreshPage(){
            $state.go('layout.massiveCreateBookingMain.massiveCreateBooking');
        }
    }
})();
/**
 * Created by cl-macmini-51 on 5/20/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('MassiveCreateBookingNewPageController', MassiveCreateBookingNewPageController);

    /** @ngInject */
    function MassiveCreateBookingNewPageController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document, moment, getCustomers, $scope, getBookings,
        RutHelper, errorMessageFactory, languageBasedErrorFactory, adminAccessService, hidePublicPlaces, pendingRequests, getCorporate, getAgreement, checkDomain, tmhDynamicLocale, quickSaleService, getFilters, Initializer, calenderTranslate, getServices) {
        var vm = this;
        if ($rootScope.socket.connected == false || $rootScope.socket.connected == 'false') {
            $rootScope.socket.connect();
        }
        vm.refId = $stateParams.id;
        vm.changeDateIntoSpanish = changeDateIntoSpanish;
        vm.refreshPage = refreshPage;
        vm.downloadData = downloadData;

        function changeDateIntoSpanish(date) {
            var options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            };
            return new Date(date).toLocaleString($cookies.get('language') == 'spanish' ? 'es' : 'en', options)
        }
        if (vm.refId != null) {
            getBulkCsvData(0);
        }

        function getBulkCsvData(linkSend) {
            var d = [];
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.tableRefId = Number(vm.refId);
            dataSend.link = linkSend;
            var dataArray = [];
            vm.loading = true;
            var promise = getAgreement.afterCreateMassiveBooking(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (linkSend == 0) {
                        if (payload && payload.title.status == 200) {
                            vm.achiveLines = payload.title.data.totalLines;
                            vm.errorLines = payload.title.data.errorLinesCount;
                            payload.title.data.data.forEach(function (column) {
                                var d = {};
                                d.contract_name = column.Convenio;
                                d.service_name = column.Tipo_de_Servicio;
                                d.payment_method_name = column.Método_de_Pago;
                                d.type_of_trip = column.Tipo_de_Viaje;
                                d.Detalle = column.Detalle;
                                d.booking_type = 'Programada';
                                d.Nombre_completo_del_cliente = column.Nombre_completo_del_cliente;
                                d.Email_Cliente = column.Email_Cliente;
                                d.telephone_number = column.Telefono_Cliente;
                                d.No_of_passenger = column.Numero_de_Pasajeros;
                                d.pickup_address = column.Direccion_de_Retiro;
                                d.dropoff_address = column.Direccion_de_Destino;
                                d.Reference = column.Referencia_Direccion_de_Recogida;
                                d.Observaciones = column.Observaciones;
                                d.Fecha_Recogida_Programada = column.Fecha;
                                d.Hora_Recogida = column.Hora;
                                d.Pasajero_RUT = RutHelper.format(column.Pasajero_RUT);
                                d.Rut_Solicitante = RutHelper.format(column.Rut_Solicitante);;
                                d.Centro_de_Costo = column.Centro_de_Costo;
                                d.Centro_SubCost = column.Centro_SubCost;
                                d.ROL = column.ROL;
                                d.Grafo = column.Grafo;
                                d.Orden_de_trabajo = column.Orden_de_trabajo;
                                d.PEP = column.PEP;
                                d.no_of_vocher = column.Numero_Vale;
                                d.Nomina = column.Nomina;
                                d.Solicitud = column.Solicitud;
                                d.purpose_de_viaje = column.Proposito_de_viaje;
                                d.name_of_airline = column.Nombre_de_la_aerolinea;
                                d.flight_number = column.Numero_de_vuelo;
                                d.Fecha_de_vuelo = column.Fecha_de_vuelo;
                                d.Tipo_de_vuelo = column.Tipo_de_vuelo;
                                d.error = column.Estado == "ERROR" ? true : false;
                                d.afterCreationError = column.afterCreationError;
                                d.beforeCreationError = column.beforeCreationError;
                                dataArray.push(d);
                            })
                            vm.CsvData = dataArray;
                        }
                    } else {
                        var link = document.createElement("a");
                        link.download = payload.title.data.data.enlazar_xlsx;
                        link.href = payload.title.data.data.enlazar_xlsx;
                        link.click();
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function downloadData() {
            getBulkCsvData(1);
        }

        function refreshPage(){
            $state.go('layout.massiveCreateBookingMain.massiveCreateBooking');
        }
    }
})();
/**
 * Created by cl-macmini-51 on 5/20/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('MassiveCreateBookingController', MassiveCreateBookingController);

    /** @ngInject */
    function MassiveCreateBookingController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document, moment, getCustomers, $scope, getBookings,
        RutHelper, errorMessageFactory, languageBasedErrorFactory, adminAccessService, hidePublicPlaces, pendingRequests, getCorporate, getAgreement, checkDomain, tmhDynamicLocale, quickSaleService, getFilters, Initializer, calenderTranslate, getServices) {
        var vm = this;
        vm.successTableFlag = false;
        // vm.ismeridian = true;
        vm.hstep = 1;
        vm.mstep = 15;
        vm.dataToFill = {
            selectCreateType: '',
            contractIdSelected: '',
            aggrement_value: '',
            serviceTypeSelected: '',
            TripType: '',
            payment_method: '',
            bookingType: ''

        };
        vm.submitButtonActivate = false;
        if ($rootScope.socket.connected == false || $rootScope.socket.connected == 'false') {
            $rootScope.socket.connect();
        }
        vm.errorFlag = false;
        vm.submitFlag = false;
        vm.agreementChanged = agreementChanged;
        vm.serviceTypeChanged = serviceTypeChanged;
        vm.selectHolding = selectHolding;
        vm.selectTypeOfService = selectTypeOfService;
        vm.selectPaymentMethod = selectPaymentMethod;
        vm.selectBookingType = selectBookingType;
        vm.submitCsvButton = submitCsvButton;
        vm.makeTableViewOfCsv = makeTableViewOfCsv;
        vm.cancelTheCreateBookingProcess = cancelTheCreateBookingProcess;
        vm.DownloadValidateCSVData = DownloadValidateCSVData;
        vm.startUploadMassiveBooking = startUploadMassiveBooking;
        //======================get all Agreements==============
        function getAllAgreement(skip, limt) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.offset = skip;
            dataSend.limit = limt;
            dataSend.key = 3;
            //vm.loading = false;
            var promise = getAgreement.getAgreementListLessData(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    //vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.agreementBooking = [];
                        angular.forEach(payload.title.data, function (column) {
                            if (column.status == 1)
                                vm.agreementBooking.push({
                                    id: column.id,
                                    name: column.name
                                });
                        });
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllAgreement(0, 0);
        //======================get all Agreements==============


        //======================Select One Agrrement ==============
        function agreementChanged(contract_id) {
            if (vm.dataToFill.contractIdSelected.id != '' && vm.dataToFill.serviceTypeSelected != '' && vm.dataToFill.TripType != '' &&
                vm.dataToFill.bookingType != '' && vm.dataToFill.payment_method != '') {
                vm.submitFlag = true;
            }
            if (contract_id)
                agreementTypeChanged(contract_id.id);
        }

        function selectHolding() {
            if (vm.dataToFill.contractIdSelected.id != '' && vm.dataToFill.serviceTypeSelected != '' && vm.dataToFill.TripType != '' &&
                vm.dataToFill.bookingType != '' && vm.dataToFill.payment_method != '') {
                vm.submitFlag = true;
            }
        }

        function selectTypeOfService() {
            if (vm.dataToFill.contractIdSelected.id != '' && vm.dataToFill.serviceTypeSelected != '' && vm.dataToFill.TripType != '' &&
                vm.dataToFill.bookingType != '' && vm.dataToFill.payment_method != '') {
                vm.submitFlag = true;
            }
        }

        function selectPaymentMethod() {
            if (vm.dataToFill.contractIdSelected.id != '' && vm.dataToFill.serviceTypeSelected != '' && vm.dataToFill.TripType != '' &&
                vm.dataToFill.bookingType != '' && vm.dataToFill.payment_method != '') {
                vm.submitFlag = true;
            }
        }

        function serviceTypeChanged() {
            if (vm.dataToFill.contractIdSelected.id != '' && vm.dataToFill.serviceTypeSelected != '' && vm.dataToFill.TripType != '' &&
                vm.dataToFill.bookingType != '' && vm.dataToFill.payment_method != '') {
                vm.submitFlag = true;
            }
        }
        //======================Select One Agrrement ==============


        //======================Get All Type Of Services==============
        function agreementTypeChanged(data) {
            vm.flagForAirline = false;
            vm.flagForFlightNumber = false;
            vm.flagForFlightDate = false;
            vm.flagForFlightType = false;
            var isAgreementBlock = 0;
            var isAgreementBlockIndex = _.findIndex(vm.dataToFill.contractListShowing, {
                id: vm.dataToFill.contractIdSelected
            })
            if (isAgreementBlockIndex > -1) {
                isAgreementBlock = vm.dataToFill.contractListShowing[isAgreementBlockIndex].is_block;
                if (isAgreementBlock == 0) {
                    errorMessageFactory.showErrorMessage('Este cliente no está autorizado para crear reservas desde el panel', 0);
                    vm.dataToFill.contractIdSelected = '';
                    return;
                }
            }
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.offset = 0;
            dataSend.limit = 0;
            dataSend.key = 3;
            dataSend.id = data;
            vm.loading = true;
            var promise = getAgreement.allAgreementBooking(dataSend);
            promise.then(
                function (payload) {
                    vm.loading = false;
                    vm.finalAgreement = payload.title.data.result;
                    //console.log('final Agreement', vm.finalAgreement);
                    vm.serviceTypeList = [];
                    for (var i = 0; i < payload.title.data.result[0].type_of_service.length; i++) {
                        vm.serviceTypeList.push(payload.title.data.result[0].type_of_service[i]);
                    }
                    vm.dataToFill.customerContarctId = payload.title.data.result[0].id;
                    // if (!$stateParams.id)
                    // vm.dataToFill.payment_method = payload.title.data.result[0].payment_method_default;
                    if (payload.title.data.result[0].airline_mandatory == 1) {
                        vm.flagForAirline = true;
                    }
                    if (payload.title.data.result[0].flight_number_mandatory == 1) {
                        vm.flagForFlightNumber = true;
                    }
                    if (payload.title.data.result[0].flight_date_mandatory == 1) {
                        vm.flagForFlightDate = true;
                    }
                    if (payload.title.data.result[0].flight_type_mandatory == 1) {
                        vm.flagForFlightType = true;
                    }
                    vm.airlineMandatory = payload.title.data.result[0].airline_mandatory;
                    vm.flightNumberMandatory = payload.title.data.result[0].flight_number_mandatory;
                    vm.flightDateMandatory = payload.title.data.result[0].flight_date_mandatory;
                    vm.flightTypeMandatory = payload.title.data.result[0].flight_type_mandatory;
                    vm.dataToFill.passengerRutCheck = payload.title.data.result[0].RUT_mendatory;
                    vm.dataToFill.applicantRutCheck = payload.title.data.result[0].applicant_RUT_mendatory;
                    vm.dataToFill.costCenterCheck = payload.title.data.result[0].cost_center_mandatory;
                    vm.dataToFill.costSubCenterCheck = payload.title.data.result[0].cost_sub_center_mandatory;
                    vm.dataToFill.RolCheck = payload.title.data.result[0].ROL_mandatory;
                    vm.dataToFill.graphCheck = payload.title.data.result[0].graph_mandatory;
                    vm.dataToFill.workOrderCheck = payload.title.data.result[0].work_order_mandatory;
                    vm.dataToFill.pepCheck = payload.title.data.result[0].PEP_mandatory;
                    vm.dataToFill.purposeOfTripCheck = payload.title.data.result[0].purpose_of_trip_mandatory;
                    vm.dataToFill.noOfVoucherCheck = payload.title.data.result[0].number_of_voucher_mandatory;
                    vm.dataToFill.nominaCheck = payload.title.data.result[0].nomina_mandatory;
                    vm.dataToFill.controlledWayCheck = payload.title.data.result[0].controlled_way;
                    vm.dataToFill.controllerWayTarifa = payload.title.data.result[0].via_control_include_in_tarifa;
                    vm.dataToFill.solictudCheck = payload.title.data.result[0].solicitud_mandatory;
                    vm.dataToFill.roundTripDiscount = payload.title.data.result[0].rt_discount;
                    vm.dataToFill.webDiscount = payload.title.data.result[0].web_discount;
                    vm.dataToFill.allowChangeFarePanel = payload.title.data.result[0].allow_change_fare_panel || 0;
                    vm.dataToFill.allowBookingWithoutRequest = payload.title.data.result[0].is_bwr;
                    // ON CHANGE AGREEMENT MODIFY INPUT FILED CHANGE INTO STATIC VALUE
                    vm.click = false;

                    vm.addressChange = true;

                    vm.dataToFill.roundTrip == false;

                    vm.dataToFill.paymentMethodList = [];

                    for (var i = 0; i < payload.title.data.result[0].payment.length; i++) {
                        if (payload.title.data.result[0].payment[i].channel_name == 'pannel') {
                            vm.dataToFill.paymentMethodList.push(payload.title.data.result[0].payment[i]);
                        }
                    }

                    if (vm.dataToFill.paymentMethodList.length == 0) {
                        for (var i = 0; i < payload.title.data.result[0].payment.length; i++) {
                            if (payload.title.data.result[0].payment[i].id == Number(vm.dataToFill.payment_method)) {
                                vm.dataToFill.paymentMethodList.push(payload.title.data.result[0].payment[i]);
                            }
                        }
                    } else {
                        var where = _.where(vm.dataToFill.paymentMethodList, {
                            id: Number(vm.dataToFill.payment_method)
                        });
                        if (where.length == 0) {
                            vm.dataToFill.payment_method = '';
                        }
                    }


                    var where = _.where(vm.dataToFill.contractList, {
                        id: Number(vm.dataToFill.contractIdSelected)
                    });
                    vm.selectedEmployeeData = where[0];
                    console.log(vm.selectedEmployeeData);

                    if (!payload.title.data.result[0].employee_details) {
                        if (where.length) {
                            vm.dataToFill.corporate_account_id = where[0].employee_details.corporate_id;
                            vm.dataToFill.authRequired = where[0].employee_details.approval_required;
                            vm.dataToFill.auther_id = where[0].employee_details.auther_id; //auth_RUT
                            vm.dataToFill.authRUT = RutHelper.format(where[0].employee_details.auth_RUT);
                            vm.dataToFill.authName = where[0].employee_details.auth_name;
                            if (vm.modifyFalg == false) {
                                vm.dataToFill.passengerRut = RutHelper.format(where[0].employee_details.RUT);
                                vm.dataToFill.applicantRut = RutHelper.format(where[0].employee_details.RUT);
                                vm.dataToFill.costCenter = where[0].employee_details.cost_center;
                                vm.dataToFill.costSubCenter = where[0].employee_details.cost_subcenter;
                                vm.dataToFill.Rol = where[0].employee_details.ROI;
                                vm.dataToFill.graph = where[0].employee_details.graph;
                                vm.dataToFill.workOrder = where[0].employee_details.order_of_work;
                                vm.dataToFill.pep = where[0].employee_details.PEP;
                                vm.dataToFill.is_vip = where[0].employee_details.is_vip;
                            }


                            if (where[0].employee_details.thirdBooking == 1) {
                                vm.bookingForOptions = [{
                                        //name: 'Self',
                                        name: 'Para mi',
                                        value: 0
                                    },
                                    {
                                        // name: 'Someone else',
                                        name:'Alguien más',
                                        value: 1
                                    }
                                ];
                            } else {
                                vm.bookingForOptions = [{
                                    name: 'Para mi',
                                    value: 0
                                }];
                            }
                        } else {
                            vm.dataToFill.corporate_account_id = payload.title.data.result[0].corporate_id.id;
                            vm.dataToFill.authRequired = 0;
                            vm.dataToFill.auther_id = '';
                            vm.dataToFill.authRUT = '';
                            vm.dataToFill.authName = '';
                            // vm.dataToFill.passengerRut = '';
                            vm.dataToFill.applicantRut = '';
                            vm.dataToFill.costCenter = '';
                            vm.dataToFill.costSubCenter = '';
                            vm.dataToFill.Rol = '';
                            vm.dataToFill.graph = '';
                            vm.dataToFill.workOrder = '';
                            vm.dataToFill.pep = '';
                            vm.dataToFill.is_vip = 0;
                            vm.bookingForOptions = [{
                                name: 'Para mi',
                                value: 0
                            }];
                        }
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
            // // THIS CHECK IS FOR PET USER
            if ((JSON.parse($cookies.get('adminType') || 0) == 1) && (vm.dataToFill.customerId > 0)) {
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.customer_id = vm.dataToFill.customerId;
                dataSend.contract_id = vm.dataToFill.contractIdSelected;
                dataSend.is_customer = 0; // 0-frontend ,1- customerApp
                var promise = getAgreement.getDetailsForPET(dataSend);
                promise.then(
                    function (payload) {

                        vm.loading = false;
                        if (payload.title.status == 400) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            if (payload.title && payload.title.data && payload.title.data.phone_number && payload.title.data.email) {
                                vm.isEmpDataChange = true; // TV-2378
                                vm.dataToFill.customerMobileG = payload.title.data.phone_number;
                                vm.dataToFill.customerEmail = payload.title.data.email;
                                vm.dataToFill.customerMobile = payload.title.data.name + ' ' + payload.title.data.last_name;
                            }
                        }
                    },
                    function (errorPayload) {
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }
        }
        //======================Get All Type Of Services==============

        //======================Select One Booking Type ==============
        function selectBookingType(data) {
            if (data == 'Modificar Masivamente') {
                vm.PackageFlag = true;
                resetFilter('Búsqueda por filtro');
                vm.dataToFill.createBooking = '';
            } else {
                vm.PackageFlag = false;
                vm.dataToFill.createBooking = '';
            }
            vm.errorFlag = true;
            if(vm.dataToFill.selectCreateType) {
                vm.loading = true;
                var promise = adminAccessService.checkStateValid(data); //$stateParams.id
                return promise.then(
                    function (payload) {
                        vm.loading = false;
                        console.log(payload);
                        if (payload.title.status == 400) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            return false;
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                            return false;
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            if (!payload.title.data.granted) {
                                errorMessageFactory.showErrorMessage(' No está autorizado para usar esta opción', 0);
                                vm.errorFlag = true;
                                return false;
                            } else {
                                vm.loading = false;
                                vm.errorFlag = false;
                                vm.grantedCheckbox = true;
                                if (data == 'Modificar Masivamente') {
                                    vm.dataToFill.createBooking = '';
                                    getFilterDataFromBackend();
                                } else {
                                    if (vm.dataToFill.contractIdSelected.id != '' && vm.dataToFill.serviceTypeSelected != '' && vm.dataToFill.TripType != '' &&
                                        vm.dataToFill.bookingType != '' && vm.dataToFill.payment_method != '') {
                                        vm.submitFlag = true;
                                    }
                                    vm.dataToFill.createBooking = '';
                                    getFilterDataFromBackend();
                                }
                            }
                        }
                    },
                    function (errorPayload) {
                        console.log(errorPayload);
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }
        }
        //======================Select One Booking Type ==============

        //======================Download CSV with Heading ==============
        function submitCsvButton() {
            console.log('debug');
            var passengerRutCheck = vm.dataToFill.passengerRutCheck == 1 ? 'Pasajero_RUT,' : '';
            var applicantRutCheck = vm.dataToFill.applicantRutCheck == 1 ? 'Rut_Solicitante,' : '';
            var costCenterCheck = vm.dataToFill.costCenterCheck == 1 ? 'Centro_de_Costo,' : '';
            var costSubCenterCheck = vm.dataToFill.costSubCenterCheck == 1 ? 'Centro_SubCost,' : '';
            var RolCheck = vm.dataToFill.RolCheck == 1 ? 'ROL,' : '';
            var graphCheck = vm.dataToFill.graphCheck == 1 ? 'Grafo,' : '';
            var workOrderCheck = vm.dataToFill.workOrderCheck == 1 ? 'Orden_de_trabajo,' : '';
            var pepCheck = vm.dataToFill.pepCheck == 1 ? 'PEP,' : '';
            var noOfVoucherCheck = vm.dataToFill.noOfVoucherCheck == 1 ? 'Numero_Vale,' : '';
            var nominaCheck = vm.dataToFill.nominaCheck == 1 ? 'Nomina,' : '';
            var solictudCheck = vm.dataToFill.solictudCheck == 1 ? 'Solicitud,' : '';
            var purposeOfTripCheck = vm.dataToFill.purposeOfTripCheck == 1 ? 'Proposito_de_viaje,' : '';
            var nameOfAirline = vm.flagForAirline && vm.dataToFill.TripType != 'P' ? 'Nombre_de_la_aerolinea,' : '';
            var numberOfAirline = vm.flagForFlightNumber && vm.dataToFill.TripType != 'P' ? 'Numero_de_vuelo,' : '';
            var typeOfAirline = vm.flagForFlightType && vm.dataToFill.TripType != 'P' ? 'Tipo_de_vuelo,' : '';
            var dateOfAirline = vm.flagForFlightDate && vm.dataToFill.TripType != 'P' ? 'Fecha_de_vuelo' : '';
            var csv = 'Nombre_completo_del_cliente,Email_Cliente,Telefono_Cliente,Numero_de_Pasajeros,Direccion_de_Retiro,Direccion_de_Destino,Referencia_Direccion_de_Recogida,Observaciones,Fecha,Hora,' +
                passengerRutCheck + applicantRutCheck + costCenterCheck + costSubCenterCheck + RolCheck + graphCheck + workOrderCheck + pepCheck + noOfVoucherCheck + nominaCheck + solictudCheck +
                purposeOfTripCheck + nameOfAirline + numberOfAirline + typeOfAirline + dateOfAirline;
            if (csv.endsWith(',')) {
                csv = csv.substring(0, csv.length - 1);
            }
            vm.dataToFill.TripType + ',' + vm.dataToFill.payment_method;
            var blobCsv = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
            var hiddenElement = document.createElement('a');
            var urlCsv = URL.createObjectURL(blobCsv);
            //hiddenElement.href = 'data:text/csv;charset=UTF-8,' + encodeURI(csv);
            hiddenElement.href = urlCsv;
            hiddenElement.target = '_blank';
            hiddenElement.download = 'pb-' + moment().format('YYYY-MM-DD') + '-' + moment().format('hhmmss') + '-' + vm.dataToFill.contractIdSelected.name.replace(" ", "_") + '.csv';
            hiddenElement.click();
            vm.submitButtonActivate = true;
        }
        //======================Download CSV with Heading ==============




        //======================Upload CSV with Data ==============
        vm.uploadName = '';

        function makeTableViewOfCsv($event) {
            if (vm.dataToFill.contractIdSelected.id == '' || vm.dataToFill.serviceTypeSelected == '' || vm.dataToFill.TripType == '' ||
                vm.dataToFill.bookingType == '' || vm.dataToFill.payment_method == '') {
                return;
            }
            $log.log('ddf');
            $event.stopPropagation();
            vm.uploadName = 'hello';
            var element = document.getElementById('documentUpload');
            element.click();
        }
        $scope.file_to_upload = function (File, type) {
            var dataSend = new FormData();
            var isAirportFlag = 0;
            if (vm.dataToFill.TripType == "Z") {
                isAirportFlag = 1;
            } else if (vm.dataToFill.TripType == "R") {
                isAirportFlag = 2;
            }
            dataSend.append('access_token', $cookies.get('obj'));
            dataSend.append('contract_id', Number(vm.dataToFill.contractIdSelected.id));
            dataSend.append('service_type', Number(vm.dataToFill.serviceTypeSelected.id));
            dataSend.append('type_of_trip', vm.dataToFill.TripType);
            dataSend.append('booking_type', Number(vm.dataToFill.serviceTypeSelected.category));
            dataSend.append('payment_method', Number(vm.dataToFill.payment_method.id));
            // dataSend.append('contract_name', (vm.dataToFill.contractIdSelected.name));
            dataSend.append('service_name', (vm.dataToFill.serviceTypeSelected.service_name));
            dataSend.append('payment_method_name', (vm.dataToFill.payment_method.type));
            dataSend.append('payment_status', 0);
            dataSend.append('profile', 1);
            dataSend.append('type_of_agreement', 0);
            dataSend.append('airport', isAirportFlag);
            dataSend.append('file', File[0]);
            vm.loading = true;
            var promise = getBookings.validMassiveCreateCSV(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload && payload.title.status == 200) {
                        vm.successTableFlag = true;
                        getBulkCsvData(0);
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        //======================Upload CSV with Data ==============


        //======================Get CSV with Data ==============
        function getBulkCsvData(linkSend) {
            var d = [];
            vm.passengerRutFlag = 0;
            vm.applicantRutFlag = 0;
            vm.costCenterCheckFlag = 0;
            vm.costSubCenterCheckFlag = 0;
            vm.pepCheckFlag = 0;
            vm.workOrderCheckFlag = 0;
            vm.graphCheckFlag = 0;
            vm.RolCheckFlag = 0;
            vm.purposeOfTripCheckFlag = 0;
            vm.solictudCheckFlag = 0;
            vm.nominaCheckFlag = 0;
            vm.noOfVoucherCheckFlag = 0;
            vm.flagForFlightDateNew = 0;
            vm.flagForFlightTypeNew = 0;
            vm.flagForFlightNumberNew = 0;
            vm.flagForAirlineNew = 0;
            vm.finalCSVAraay = [];
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.link = linkSend;
            var dataArray = [];
            vm.loading = true;
            var promise = getBookings.getBulkCSVData(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload && payload.title.status == 200) {
                        vm.tableRefId = payload.title.data.tableRefId;
                        vm.fileName = payload.title.data.fileName;
                        vm.achiveLines = payload.title.data.totalLines;
                        vm.errorLines = payload.title.data.errorLinesCount;
                        if (linkSend == 0) {
                            payload.title.data.data.forEach(function (column) {
                                var d = {};
                                d.contract_name = column.contract_name;
                                d.service_name = column.service_name;
                                d.payment_method_name = column.payment_method_name;
                                d.type_of_trip = vm.dataToFill.TripType;
                                d.booking_type = 'Programada';
                                d.Nombre_completo_del_cliente = column.Nombre_completo_del_cliente;
                                d.Email_Cliente = column.Email_Cliente;
                                d.telephone_number = column.Telefono_Cliente;
                                d.No_of_passenger = column.Numero_de_Pasajeros;
                                d.pickup_address = column.Direccion_de_Retiro;
                                d.dropoff_address = column.Direccion_de_Destino;
                                d.Reference = column.Referencia_Direccion_de_Recogida;
                                d.Observaciones = column.Observaciones;
                                d.Fecha_Recogida_Programada = changeDateIntoSpanish(column.Fecha);
                                d.Hora_Recogida = column.Hora.split(' ')[1];
                                d.Pasajero_RUT = RutHelper.format(column.Pasajero_RUT);
                                d.Rut_Solicitante = RutHelper.format(column.Rut_Solicitante);;
                                d.Centro_de_Costo = column.Centro_de_Costo;
                                d.Centro_SubCost = column.Centro_SubCost;
                                d.ROL = column.ROL;
                                d.Grafo = column.Grafo;
                                d.Orden_de_trabajo = column.Orden_de_trabajo;
                                d.PEP = column.PEP;
                                d.no_of_vocher = column.Numero_Vale;
                                d.Nomina = column.Nomina;
                                d.Solicitud = column.Solicitud;
                                d.purpose_de_viaje = column.Proposito_de_viaje;
                                d.name_of_airline = column.Nombre_de_la_aerolinea;
                                d.flight_number = column.Numero_de_vuelo;
                                d.Fecha_de_vuelo = column.Fecha_de_vuelo;
                                d.Tipo_de_vuelo = column.Tipo_de_vuelo;
                                var errormsg = column.error_keys.split(', ');
                                errormsg = errormsg.filter(Boolean);
                                var a = [];
                                errormsg.forEach(function (data) {
                                    if (data == 'Email_Cliente') {
                                        d.errorEmailCliente = 1;
                                    }
                                    if (data == 'Fecha') {
                                        d.errorFechaRecogidaProgramada = 1;
                                    }
                                    if (data == 'Hora') {
                                        d.errorHoraRecogida = 1;
                                    }
                                    if (data == 'Direccion_de_Destino') {
                                        d.errorDireccionDeDestino = 1;
                                    }
                                    if (data == 'Direccion_de_Retiro') {
                                        d.errorDireccionDeRetiro = 1;
                                    }
                                    if (data == 'Nombre_completo_del_cliente') {
                                        d.errorNombreCompletoDelCliente = 1;
                                    }
                                    if (data == 'Numero_de_Pasajeros') {
                                        d.errorNumeroDePasajeros = 1;
                                    }
                                    if (data == 'Observaciones') {
                                        d.errorObservaciones = 1;
                                    }
                                    if (data == 'Referencia_Direccion_de_Recogida') {
                                        d.errorReferenciaDireccionDeRecogida = 1;
                                    }
                                    if (data == 'Telefono_Cliente') {
                                        d.errorTelefonoCliente = 1;
                                    }
                                    if (data == 'Telefono_Cliente') {
                                        d.errorTelefonoCliente = 1;
                                    }
                                    if (data == 'Pasajero_RUT') {
                                        d.errorPassengerRutFlag = 1;
                                    }
                                    if (data == 'Rut_Solicitante') {
                                        d.errorApplicantRutFlag = 1;
                                    }
                                    if (data == 'Centro_de_Costo') {
                                        d.errorCostCenterCheckFlag = 1;
                                    }
                                    if (data == 'Centro_SubCost') {
                                        d.errorSubCenterCheckFlag = 1;
                                    }
                                    if (data == 'ROL') {
                                        d.errorRolCheckFlag = 1;
                                    }
                                    if (data == 'Grafo') {
                                        d.errorGraphCheckFlag = 1;
                                    }
                                    if (data == 'Orden_de_trabajo') {
                                        d.errorWorkOrderCheckFlag = 1;
                                    }
                                    if (data == 'PEP') {
                                        d.errorPepCheckFlag = 1;
                                    }
                                    if (data == 'Numero_Vale') {
                                        d.errorNoOfVoucherCheckFlag = 1;
                                    }
                                    if (data == 'Nomina') {
                                        d.errorNominaCheckFlag = 1;
                                    }
                                    if (data == 'Solicitud') {
                                        d.errorSolictudCheckFlag = 1;
                                    }
                                    if (data == 'Proposito_de_viaje') {
                                        d.errorPurposeOfTripCheckFlag = 1;
                                    }
                                    if (data == 'Nombre_de_la_aerolinea') {
                                        d.errorFlagForAirlineNew = 1;
                                    }
                                    if (data == 'Numero_de_vuelo') {
                                        d.errorFlagForFlightNumberNew = 1;
                                    }
                                    if (data == 'Tipo_de_vuelo') {
                                        d.errorFlagForFlightTypeNew = 1;
                                    }
                                    if (data == 'Fecha_de_vuelo') {
                                        d.errorFlagForFlightDateNew = 1;
                                    }
                                })
                                d.error = column.error;
                                d.Descripcio_del_error = column.Descripcio_del_error;
                                dataArray.push(d);
                            })
                            vm.CsvData = dataArray;
                            vm.headingCsv = Object.keys(payload.title.data.data[0]);
                            vm.headingCsv.forEach(function (data) {
                                if (data == 'Pasajero_RUT') {
                                    vm.passengerRutFlag = 1;
                                }
                                if (data == 'Rut_Solicitante') {
                                    vm.applicantRutFlag = 1;
                                }
                                if (data == 'Centro_de_Costo') {
                                    vm.costCenterCheckFlag = 1;
                                }
                                if (data == 'Centro_SubCost') {
                                    vm.costSubCenterCheckFlag = 1;
                                }
                                if (data == 'ROL') {
                                    vm.RolCheckFlag = 1;
                                }
                                if (data == 'Grafo') {
                                    vm.graphCheckFlag = 1;
                                }
                                if (data == 'Orden_de_trabajo') {
                                    vm.workOrderCheckFlag = 1;
                                }
                                if (data == 'PEP') {
                                    vm.pepCheckFlag = 1;
                                }
                                if (data == 'Numero_Vale') {
                                    vm.noOfVoucherCheckFlag = 1;
                                }
                                if (data == 'Nomina') {
                                    vm.nominaCheckFlag = 1;
                                }
                                if (data == 'Solicitud') {
                                    vm.solictudCheckFlag = 1;
                                }
                                if (data == 'Proposito_de_viaje') {
                                    vm.purposeOfTripCheckFlag = 1;
                                }
                                if (data == 'Nombre_de_la_aerolinea') {
                                    vm.flagForAirlineNew = 1;
                                }
                                if (data == 'Numero_de_vuelo') {
                                    vm.flagForFlightNumberNew = 1;
                                }
                                if (data == 'Tipo_de_vuelo') {
                                    vm.flagForFlightTypeNew = 1;
                                }
                                if (data == 'Fecha_de_vuelo') {
                                    vm.flagForFlightDateNew = 1;
                                }
                            })
                        } else if (linkSend == 1) {
                            var link = document.createElement("a");
                            link.download = payload.title.data.data;
                            link.href = payload.title.data.data;
                            link.click();
                        }
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        //======================Get CSV with Data ==============


        //======================CANCEL THE CREATE BOOKING PROCESS ==============
        function cancelTheCreateBookingProcess() {
            var parentEl = angular.element($document.body);
            var confirm = $mdDialog.confirm()
                //.title('Do you want to logout?')
                .title('Está seguro que desea Cancelar la Carga Masiva')
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent(parentEl)
                .ok(languageBasedErrorFactory.getProperErrorMessage('SI', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('NO', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                vm.loading = true;
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.tableRefId = vm.tableRefId;
                var promise = getAgreement.cancelValidatedData(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        if (payload.title.status == 200) {
                            $state.reload('layout.massiveCreateBookingMain.massiveCreateBooking');
                        } else {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        vm.disableSubmitButton = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
                vm.countToSocket = 0;
            });
            // $state.reload();
        }
        //======================CANCEL THE CREATE BOOKING PROCESS ==============

        //======================DOWNLOAD THE VALIDATE CSV DATA ==============
        function DownloadValidateCSVData() {
            getBulkCsvData(1);
        }
        //======================DOWNLOAD THE VALIDATE CSV DATA ==============


        //======================DOWNLOAD ERROR REMOVE AND MASSIVE CREATE BOOKING API==============
        function startUploadMassiveBooking() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.fileName = vm.fileName;
            dataSend.tableRefId = vm.tableRefId;
            if (vm.errorLines == vm.achiveLines) {
                errorMessageFactory.showErrorMessage('Esta acción no se puede realizar porque todas las líneas tienen error', 0);
                return;
            }
            vm.loading = true;
            var promise = getAgreement.createMassiveBooking(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        $state.reload('layout.massiveCreateBookingMain.massiveCreateBooking');
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    vm.disableSubmitButton = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        //======================DOWNLOAD ERROR REMOVE AND MASSIVE CREATE BOOKING API==============









        //======================MODIFY BOOKING SCREEN CONTROLLER CODE HERE ==============
        vm.ctrlFn = ctrlFn;
        vm.latitude = '';
        vm.longitude = '';
        $('#derp').hide();
        vm.globalLimit = 2000;
        vm.serviceOffset = 0;
        vm.offset = 0;
        vm.branchOffset = 0;
        vm.vehicleOffset = 0;
        vm.agreementOffset = 0;
        vm.applyModifications = applyModifications;
        vm.changeDateIntoSpanish = changeDateIntoSpanish;
        vm.changeDateIntoSpanishNew = changeDateIntoSpanishNew;
        vm.confirmBookingsFlag = false;
        vm.confirmBookings = confirmBookings;
        vm.changeInJobIdArrayFunction = changeInJobIdArrayFunction;
        vm.branchList = [];
        vm.vehicle = [];
        vm.service = [];
        vm.agreement = [];
        vm.altInputFormats = ['M!/d!/yyyy'];
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.datePickerE_3 = datePickerE_3;
        vm.slideData = slideData;
        vm.datePicker_1 = {
            pickupDate: false
        };
        vm.resetFilter = resetFilter;
        vm.filterData = {
            branch_filter: 0, //0, 1
            service_filter: 0, //0, 1
            vehicle_filter: 0, //0, 1
            aggrement_filter: 0, //0, 1
            //date_time_filter : 0,  //0, 1
            type_of_trip_filter: 0, //0, 1
            branch: '',
            service: '',
            vehicle: '',
            // new_pickup_from_date_value: new Date(),
            // type_of_trip: 'From Airport',
            //date_time_value: '',
            agreement: '',
            //filter_pickup_date_value: getNextDate(),
            //filter_pickup_time_value: showFilterTime(),
            limit: vm.itemsPerPageGot,
            offset: 0,
            booking_status: 0,
            searchBookingId: '',
            searchPackageId: '',
            agreementSearch: '',
            agreementValue: 0,
            searchByName: 0,
            search: '',
            itemsPerPageSelected: 25,
            filter_pickup_from_date_value: getFirstDateOfPreviousMonth(),
            filter_pickup_to_date_value: setToPickupDate(),
            new_pickup_from_date_value: getFirstDateOfPreviousMonth(),
            filter_pickup_from_time_value: showFilterTime(1),
            filter_pickup_to_time_value: showFilterTime(2),
            new_pickup_to_time_value: showFilterTime(1),
        };
        vm.bookingDataPagination = bookingDataPagination;
        vm.applyFilter = applyFilter;
        vm.dateOptions = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            // maxDate: new Date(),
            minDate: new Date(),
            startingDay: 1,
            showWeeks: false,

        };
        vm.dateOptionsPickup = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            //    maxDate: new Date(),
            minDate: new Date(),
            startingDay: 1,
            showWeeks: false,
        }
        vm.changeFiltersValue = changeFiltersValue;
        vm.dataToFillModify = {
            TripTypeModify: '',
            Solicitante: '',
            Vuelo: '',
            optionToModify: '',
            filtersToApply: '',
            job_ids: ''
        }
        //======================SLIDE FILTER TO DOWN  ==============
        function slideData() {
            // vm.agreement = [];
            // vm.branchList = [];
            // vm.vehicle = [];
            // vm.service = [];
            // getFilterDataFromBackend();
            $('#derp').slideToggle(1000);
            document.getElementById('toDate').value = moment(vm.filterData.filter_pickup_to_date_value).format('DD-MMMM-YYYY');
            document.getElementById('fromDate').value = moment(vm.filterData.filter_pickup_from_date_value).format('DD-MMMM-YYYY');
            vm.filterData.searchByName = 0;
        }
        //======================SLIDE FILTER TO DOWN  ================ 



        //======================FIUNCTION TO OPEN CALENDER ================ 
        function datePickerE_3(type) {
            if (type == 1) {
                vm.datePicker_1.pickupFromDate = true;
                vm.datePicker_1.pickupToDate = false;
                vm.datePicker_1.newDate = false;
            } else if (type == 2) {
                vm.datePicker_1.pickupFromDate = false;
                vm.datePicker_1.pickupToDate = true;
                vm.datePicker_1.newDate = false;
            } else if (type == 3) {
                vm.datePicker_1.pickupFromDate = false;
                vm.datePicker_1.pickupToDate = false;
                vm.datePicker_1.newDate = true;
            }
        };

        vm.pickupFromToDateChanged = function (data) {
            vm.dateOptions = {
                //dateDisabled: disabled,
                formatYear: 'yy',
                // maxDate: new Date(),
                minDate: new Date(),
                startingDay: 1,
                showWeeks: false,
    
            };
        }

        function showFilterTime(type) {
            if (type == 1) {
                var x = new Date();
                // x.setHours('00');
                // x.setMinutes('00');
                // x.setSeconds('00');
                return x;
            } else {
                var x = new Date();
                x.setHours('23');
                x.setMinutes('59');
                x.setSeconds('00');
                return x;
            }
        }

        function getFirstDateOfPreviousMonth() {
            var date = new Date();
            // var yesterday = new Date(date.getTime() - 24 * 60 * 60 * 1000);
            return date;
        }

        function setToPickupDate() {
            var x = new Date();
            var yesterday = new Date(x.getTime() + (24 * 60 * 60 * 1000));
            return yesterday;
        }

        function resetFilter(type) {
            if (type == 'Búsqueda por filtro') {
                vm.dataToFillModify.TripTypeModify = '';
                vm.dataToFillModify.Vuelo = '';
                vm.dataToFillModify.Solicitante = '';
                vm.filterData = {
                    branch_filter: 0, //0, 1
                    service_filter: 0, //0, 1
                    vehicle_filter: 0, //0, 1
                    aggrement_filter: 0, //0, 1
                    //date_time_filter : 0,  //0, 1
                    type_of_trip_filter: 0, //0, 1
                    branch: '',
                    service: '',
                    vehicle: '',
                    // type_of_trip: 'From Airport',
                    //date_time_value: '',
                    agreement: '',
                    //filter_pickup_date_value: getNextDate(),
                    //filter_pickup_time_value: showFilterTime(),
                    limit: vm.itemsPerPageGot,
                    offset: 0,
                    booking_status: 0,
                    searchBookingId: '',
                    searchPackageId: '',
                    agreementSearch: '',
                    agreementValue: 0,
                    searchByName: 0,
                    search: '',
                    itemsPerPageSelected: 25,
                    filter_pickup_from_date_value: getFirstDateOfPreviousMonth(),
                    filter_pickup_to_date_value: setToPickupDate(),
                    filter_pickup_from_time_value: showFilterTime(1),
                    filter_pickup_to_time_value: showFilterTime(2),
                };

                vm.dateOptions = {
                    //dateDisabled: disabled,
                    formatYear: 'yy',
                    // maxDate: new Date(),
                    minDate: new Date(),
                    startingDay: 1,
                    showWeeks: false,
        
                };
            } else {
                vm.dataToFillModify.job_ids = '';
            }
        }
        //======================FIUNCTION TO OPEN CALENDER ================ 


        // =================== GET FILTER DATA ===================
        function getFilterDataFromBackend(data, type) { //Acc to Index ['branch_search', 'vehicle_search', 'service_search', 'agreement_search', 'corporate_search', 'operation_point_search']
            console.log('>>>>>> IN BACKEND', data, type);
            if (data) {
                vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
            } else {
                vm.filterObject = {
                    access_token: $cookies.get('obj'),
                    branch_filter: 1,
                    vehicle_filter: 1,
                    service_filter: 1,
                    agreement_filter: 1,
                    corporate_filter: 0,
                    service_category: 0,
                    corporate_status: 0,
                    agreement_status: 1,
                    vehicle__status: 2,
                    operation_point_filter: 0,
                    branch_search_filter: 0,
                    vehicle_search_filter: 0,
                    service_search_filter: 0,
                    agreement_search_filter: 0,
                    corporate_search_filter: 0,
                    operation_point_search_filter: 0
                }
            }
            vm.filterObject.service_limit = vm.globalLimit;
            vm.filterObject.service_offset = vm.serviceOffset;
            vm.filterObject.branch_limit = vm.globalLimit;
            vm.filterObject.branch_offset = vm.branchOffset;
            vm.filterObject.vehicle_limit = vm.globalLimit;
            vm.filterObject.vehicle_offset = vm.vehicleOffset;
            vm.filterObject.agreement_limit = vm.globalLimit;
            vm.filterObject.agreement_offset = vm.agreementOffset;
            var promise = getFilters.getAllFilterData(vm.filterObject);
            promise.then(
                function (payload) {

                    // ********** BRANCH DATA ********
                    if (payload.title.data.branches) {
                        var index = _.findIndex(vm.branchList, {
                            region_id: 'all'
                        });
                        if (index == -1)
                            angular.forEach(payload.title.data.branches.data, function (column) {
                                var branchIndex = _.findIndex(vm.branchList, {
                                    region_id: column.region_id
                                });
                                if (branchIndex == -1)
                                    vm.branchList.push(column)
                            });
                        vm.branchTotalBackendCount = payload.title.data.branches.totalCount;
                    }

                    // ********** VEHICLE DATA ********
                    if (payload.title.data.vehicles) {
                        var index = _.findIndex(vm.vehicle, {
                            id: 'all'
                        });
                        if (index == -1)
                            vm.vehicleTotalBackendCount = payload.title.data.vehicles.totalCount;
                        angular.forEach(payload.title.data.vehicles.data, function (column) {
                            // vm.vehicle.push({
                            //     id: column.id,
                            //     name: column.name
                            // })
                            var vechicleIndex = _.findIndex(vm.vehicle, {
                                id: column.id
                            });
                            if (vechicleIndex == -1)
                                vm.vehicle.push({
                                    id: column.id,
                                    name: column.name
                                })
                        });
                    }

                    // *********** SERVICE DATA *********
                    if (payload.title.data.services) {
                        var index = _.findIndex(vm.service, {
                            id: 'all'
                        });
                        if (index == -1)
                            vm.serviceTotalBackendCount = payload.title.data.services.totalCount;
                        angular.forEach(payload.title.data.services.data, function (column) {
                            // vm.service.push({
                            //     id: column.id,
                            //     name: column.service_name
                            // });
                            var serviceIndex = _.findIndex(vm.service, {
                                id: column.id
                            });
                            if (serviceIndex == -1)
                                vm.service.push({
                                    id: column.id,
                                    name: column.service_name
                                })
                        });
                    }

                    // *********** AGREEMENT DATA *********
                    if (payload.title.data.agreements) {
                        var index = _.findIndex(vm.agreement, {
                            id: 'all'
                        });
                        if (index == -1)
                            vm.agreementTotalBackendCount = payload.title.data.agreements.totalCount;
                        angular.forEach(payload.title.data.agreements.data, function (column) {
                            // vm.agreement.push({
                            //     id: column.id,
                            //     name: column.name
                            // });
                            var agreementIndex = _.findIndex(vm.agreement, {
                                id: column.id
                            });
                            if (agreementIndex == -1)
                                vm.agreement.push({
                                    id: column.id,
                                    name: column.name
                                })
                        });
                        console.log(vm.agreement, 'vm.agreement');

                    }


                    vm.loading = false;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        }
        // =================== GET FILTER DATA ===================


        // ===================FUNCTION TO CLICK ON APPLY FILTER =================== 
        function applyFilter(type, offsetNew, offsetOld) {
            if (type == 'Búsqueda por números de Reservas') {
                var format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|.<>\/?]/;
                if (format.test(vm.dataToFillModify.job_ids)) {
                    errorMessageFactory.showErrorMessage('Debe agregar una coma para separar los números de Reserva');
                    return;
                }
                var a = vm.dataToFillModify.job_ids.split(',');
                a = a.filter(Boolean);
                if (a.length == 0) {
                    return;
                }
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.job_ids_value = [];
                dataSend.job_ids_filter = 1;
                dataSend.limit = 1000;
                dataSend.offset = 0;
                dataSend.job_ids_value.push(a);
                vm.loading = true;
                var promise = getAgreement.getBookingForMassiveModification(dataSend);
                promise.then(
                    function (payload) {
                        vm.loading = false;
                        if (payload.title.status == 200) {
                            if (payload.title.data.result.length > 0) {
                                vm.totalCount = payload.title.data.totalCount;
                                vm.bookingData = payload.title.data.result;
                            } else {
                                vm.bookingData = '';
                                vm.totalCount = payload.title.data.totalCount;
                            }
                        } else {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            } else {
                if (vm.filterData.branch == '' || vm.filterData.agreement == '' || vm.filterData.service == '' ||
                    vm.dataToFillModify.TripTypeModify == '') {
                    errorMessageFactory.showErrorMessage('Por favor seleccione los filtros primero');
                    return
                }
                var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
                var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);

                if (pickFromDate > pickToDate) {
                    errorMessageFactory.showErrorMessage('Por favor, elija las fechas apropiadas de filtro.', 0);
                    return;
                }
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.branch_filter = 1;
                dataSend.branch_value = vm.filterData.branch;
                dataSend.aggrement_filter = 1;
                dataSend.aggrement_value = vm.filterData.agreement;
                dataSend.date_time_filter = 1;
                dataSend.date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
                dataSend.date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
                dataSend.service_filter = 1;
                dataSend.service_value = vm.filterData.service;
                dataSend.job_status_filter = 1;
                var job_status = [];
                job_status.push(6);
                dataSend.job_status_value = job_status;
                dataSend.type_of_trip_filter = 1;
                dataSend.type_of_trip_value = vm.dataToFillModify.TripTypeModify;
                if (vm.dataToFillModify.Solicitante != '') {
                    dataSend.applicant_filter = 1;
                    dataSend.applicant_value = vm.dataToFillModify.Solicitante;
                } else {
                    dataSend.applicant_filter = 0;
                }
                if (vm.dataToFillModify.Vuelo != '') {
                    dataSend.flight_filter = 1;
                    dataSend.flight_value = vm.dataToFillModify.Vuelo;
                } else {
                    dataSend.flight_filter = 0;
                }
                dataSend.limit = 200;
                dataSend.offset = offsetOld ? offsetOld : 0;
                vm.loading = true;
                var promise = getAgreement.getBookingForMassiveModification(dataSend);
                promise.then(
                    function (payload) {
                        vm.loading = false;
                        if (payload.title.status == 200) {
                            if (payload.title.data.result.length > 0) {
                                vm.totalCount = payload.title.data.totalCount;
                                if (offsetNew != 'scroll') {
                                    vm.bookingData = payload.title.data.result;
                                } else {
                                    console.log(offsetNew, 'offsetNew');
                                    for (var i = 0; i < payload.title.data.result.length; i++) {
                                        vm.bookingData.push(payload.title.data.result[i])
                                    }
                                }
                            } else {
                                vm.bookingData = '';
                                vm.totalCount = payload.title.data.totalCount;
                            }
                        } else {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }
        }
        // ===================FUNCTION TO CLICK ON APPLY FILTER ===================    

        // ===================TO ENTER THE VALUE IN TEXTBOX=================== 
        function changeInJobIdArrayFunction(data, $event) {
            if ($event.keyCode === 32) {
                $event.preventDefault();
            }
        }
        // ===================TO ENTER THE VALUE IN TEXTBOX=================== 


        // ===================CONVERT DATE TO SPANISH=================== 
        function changeDateIntoSpanish(date) {
            var options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            };
            // return moment(new Date(date)).format('DD MMM YYYY').toLocaleString($cookies.get('language') == 'spanish' ? 'es' : 'en', options)
            moment.locale('es');
            return moment((date)).format('DD MMM YYYY');
        }
    
        function changeDateIntoSpanishNew(date){
            var options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            };
            return new Date(date).toLocaleString($cookies.get('language') == 'spanish' ? 'es' : 'en', options)
        }
        // ===================CONVERT DATE TO SPANISH=================== 

        // ===================CONFIRMATION FOR BOOKING CHECK=================== 
        function confirmBookings() {
            if (vm.dataToFill.selectCreateType == 'Modificar Masivamente') {
                if (vm.dataToFillModify.optionToModify == 'Modificar Fecha de Retiro y Dirección de Retiro') {
                    if ((vm.latitude == '' && vm.longitude == '')) {
                        errorMessageFactory.showErrorMessage('Por favor complete la dirección primero', 0);
                        return;
                    } else if (vm.filterData.new_pickup_from_date_value == undefined) {
                        errorMessageFactory.showErrorMessage('Ingrese primero la fecha de retiro', 0);
                        return;
                    } else if (vm.filterData.new_pickup_to_time_value == undefined){
                        errorMessageFactory.showErrorMessage('ingrese primero la hora de retiro', 0);
                        return;
                    }
                    if (vm.bookingData && (vm.totalCount != vm.bookingData.length)) {
                        errorMessageFactory.showErrorMessage('Por favor, consulte todas las reservas antes de la confirmación', 0);
                        return;
                    } else {
                        vm.confirmBookingsFlag = true;
                        vm.showAppllyModifcationButton = true;
                    }
                } else {
                     if (vm.filterData.new_pickup_from_date_value == undefined) {
                        errorMessageFactory.showErrorMessage('Ingrese primero la fecha de retiro', 0);
                        return;
                    } else if (vm.filterData.new_pickup_to_time_value == undefined){
                        errorMessageFactory.showErrorMessage('ingrese primero la hora de retiro', 0);
                        return;
                    }
                    if (vm.bookingData && (vm.totalCount != vm.bookingData.length)) {
                        errorMessageFactory.showErrorMessage('Por favor, consulte todas las reservas antes de la confirmación', 0);
                        return;
                    } else {
                        vm.confirmBookingsFlag = true;
                        vm.showAppllyModifcationButton = true;
                    }
                }
            } else {
                vm.confirmBookingsFlag = true;
                vm.showAppllyModifcationButton = true;
            }
        }
        // ===================CONFIRMATION FOR BOOKING CHECK===================

        // ===================CHANGE VALUE FILTER===================
        function changeFiltersValue(data) {
            if (data == 'Búsqueda por filtros') {
                vm.bookingData = '';
                vm.dataToFillModify.job_ids = '';
            } else {
                vm.bookingData = '';
                vm.dataToFillModify.job_ids = '';
            }
        }
        // ===================CHANGE VALUE FILTER===================



        //====================date time format====================
        function dateTimeFormat(dateGot, timeGot) {
            var dateToChange = new Date(dateGot);
            var timeGotChange = new Date(timeGot);
            if (timeGotChange) {
                dateToChange.setHours(timeGotChange.getHours());
                dateToChange.setMinutes(timeGotChange.getMinutes());
                dateToChange.setSeconds(timeGotChange.getSeconds());
            } else {
                dateToChange.setHours(0);
                dateToChange.setMinutes(0);
                dateToChange.setSeconds(0);
            }
            return dateToChange;
        };
        //====================date time format====================

        //====================PAGINATION FOR BOOKING DATA ====================
        function bookingDataPagination() {
            if (vm.dataToFillModify.filtersToApply == 'Búsqueda por filtros') {
                if (vm.totalCount > vm.bookingData.length + 1) {
                    vm.offset = vm.offset + 200;
                    applyFilter('Búsqueda por filtros', 'scroll', vm.offset);
                }
            }
        }
        //====================PAGINATION FOR BOOKING DATA ====================

        //====================APPLY MODIFCATION  ====================
        function applyModifications($event) {
            vm.items = {
                data: 'data'
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/massiveModificationOfBookingConfirmationPopUp.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: ChangePasswordController
            });

            function ChangePasswordController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    vm.loading = true;
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.update_action = 0;
                    dataSend.new_pickup_time = dateTimeFormat(vm.filterData.new_pickup_from_date_value, vm.filterData.new_pickup_to_time_value);
                    if (vm.dataToFillModify.optionToModify == 'Modificar Fecha de Retiro y Dirección de Retiro') {
                        dataSend.new_pickup_address = vm.searchedAddress;
                        dataSend.new_pickup_longitude = Number(vm.longitude);
                        dataSend.new_pickup_latitude = Number(vm.latitude);
                    }
                    // dataSend.job_ids = ;
                    if (vm.dataToFillModify.filtersToApply == 'Búsqueda por filtros') {
                        var job_id = [];
                        vm.bookingData.forEach(function (column) {
                            job_id.push(column.job_id);
                        })
                    } else {
                        var a = vm.dataToFillModify.job_ids.split(',');
                        a = a.filter(Boolean);
                        var job_id = a;
                    }
                    dataSend.job_ids = JSON.stringify(job_id);
                    var promise = getAgreement.massiveUpdateBookings(dataSend);
                    promise.then(
                        function (payload) {
                            vm.loading = false;
                            if (payload.title.status == 200) {
                                // $state.reload('layout.massiveCreateBookingMain.massiveCreateBooking');
                                $mdDialog.hide();
                            } else {
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            }
                        },
                        function (errorPayload) {
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                    // $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    vm.loading = true;
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.update_action = 1;
                    dataSend.new_pickup_time = dateTimeFormat(vm.filterData.new_pickup_from_date_value, vm.filterData.new_pickup_to_time_value);
                    if (vm.dataToFillModify.optionToModify == 'Modificar Fecha de Retiro y Dirección de Retiro') {
                        dataSend.new_pickup_address = vm.searchedAddress;
                        dataSend.new_pickup_longitude = Number(vm.longitude);
                        dataSend.new_pickup_latitude = Number(vm.latitude);
                    }
                    // dataSend.job_ids = ;
                    if (vm.dataToFillModify.filtersToApply == 'Búsqueda por filtros') {
                        var job_id = [];
                        vm.bookingData.forEach(function (column) {
                            job_id.push(column.job_id);
                        })
                    } else {
                        var a = vm.dataToFillModify.job_ids.split(',');
                        a = a.filter(Boolean);
                        var job_id = a;
                    }
                    dataSend.job_ids = JSON.stringify(job_id);
                    var promise = getAgreement.massiveUpdateBookings(dataSend);
                    promise.then(
                        function (payload) {
                            vm.loading = false;
                            if (payload.title.status == 200) {
                                $state.reload('layout.massiveCreateBookingMain.massiveCreateBooking');
                                $mdDialog.hide();
                            } else {
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            }
                        },
                        function (errorPayload) {
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                };
            }
        }
        //====================APPLY MODIFCATION  ====================

        function ctrlFn(data) {
            vm.latitude = data.geometry.location.lat()
            vm.longitude = data.geometry.location.lng()
        }



        //======================MODIFY BOOKING SCREEN CONTROLLER CODE HERE ==============






        //======================PACKAGE CREATION SCREEN CONTROLLER CODE HERE ==============
        vm.PackageFlag = false;
        vm.previewOfPackageScreenFlag = false;
        vm.selectBookingOrPackage = selectBookingOrPackage;
        vm.applyFilterPackageCreation = applyFilterPackageCreation;
        vm.generatePackageReport = generatePackageReport;
        vm.packageDataPagination = packageDataPagination;
        vm.packageoffset = 0;
        vm.showSubmitButtonAfterDownloadReport = false;
        vm.makeTableViewOfXlsxPackage = makeTableViewOfXlsxPackage;
        vm.cancelTheCreatePackageProcess = cancelTheCreatePackageProcess;
        vm.startCreatePackageProcess = startCreatePackageProcess;
        vm.spanishToDate = spanishToDate;
        vm.hstep = 1;
        vm.mstep = 15;
        //======================FUNCTION TO SELECT THE BOOKING OR PACKAGE ==============
        function selectBookingOrPackage(data) {
            if (data == 'Paquetes') {
                getFilterDataFromBackend();
                resetFilter('Búsqueda por filtro');
            }
        }
        //======================FUNCTION TO SELECT THE BOOKING OR PACKAGE ==============

        //======================GET ALL THE BOOKING THAT MAKE A PACKAGE ==============
        function applyFilterPackageCreation(type, offsetOld) {
            if (vm.filterData.branch == '' || vm.filterData.agreement == '' || vm.filterData.service == '' ||
                vm.dataToFillModify.TripTypeModify == '') {
                errorMessageFactory.showErrorMessage('Por favor seleccione los filtros primero');
                return
            }
            var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            if (pickFromDate > pickToDate) {
                errorMessageFactory.showErrorMessage('Por favor, elija las fechas apropiadas de filtro.', 0);
                return;
            }
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.branch_filter = 1;
            dataSend.link = 0;
            dataSend.branch_value = vm.filterData.branch;
            dataSend.aggrement_filter = 1;
            dataSend.aggrement_value = vm.filterData.agreement;
            dataSend.date_time_filter = 1;
            dataSend.date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            dataSend.date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            dataSend.service_filter = 1;
            dataSend.service_value = vm.filterData.service;
            dataSend.type_of_trip_filter = 1;
            dataSend.type_of_trip_value = vm.dataToFillModify.TripTypeModify;
            if (vm.dataToFillModify.Solicitante != '') {
                dataSend.applicant_filter = 1;
                dataSend.applicant_value = vm.dataToFillModify.Solicitante;
            } else {
                dataSend.applicant_filter = 0;
            }
            if (vm.dataToFillModify.Vuelo != '') {
                dataSend.flight_filter = 1;
                dataSend.flight_value = vm.dataToFillModify.Vuelo;
            } else {
                dataSend.flight_filter = 0;
            }
            var dataArray = [];
            dataSend.limit = 200;
            dataSend.offset = offsetOld ? offsetOld : 0;
            vm.loading = true;
            var promise = getAgreement.getBookingForPackageCreation(dataSend);
            promise.then(
                function (payload) {
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        if (payload.title.data.data.length > 0) {
                            vm.totalCount = payload.title.data.count;
                            if (type != 'scroll') {
                                payload.title.data.data.forEach(function (column) {
                                    var d = {};
                                    d.contract_name = column.Convenio;
                                    d.service_name = column.Tipo_Servicio;
                                    d.job_id = column.Reserva;
                                    d.type_of_trip = column.Tipo_Viaje;
                                    d.branch_name = column.Sucursal;
                                    d.flight_number = column.Vuelo;
                                    d.customer_username = column.Nombre_Solicitante;
                                    d.job_pickup_datetime = column.Retiro;
                                    d.number_of_passangers = column.Pasajero;
                                    d.job_pickup_address = column.Dirección_de_Retiro;
                                    d.nomina = column.Nómina;
                                    dataArray.push(d);
                                });
                                vm.packageData = dataArray;
                                console.log(vm.packageData, 'vm.packageData');

                            } else {
                                for (var i = 0; i < payload.title.data.data.length; i++) {
                                    vm.packageData.push({
                                        'contract_name': payload.title.data.data[i].Convenio,
                                        'service_name': payload.title.data.data[i].Tipo_Servicio,
                                        'job_id': payload.title.data.data[i].Reserva,
                                        'type_of_trip': payload.title.data.data[i].Tipo_Viaje,
                                        'branch_name': payload.title.data.data[i].Sucursal,
                                        'flight_number': payload.title.data.data[i].Vuelo,
                                        'customer_username': payload.title.data.data[i].Nombre_Solicitante,
                                        'job_pickup_datetime': payload.title.data.data[i].Retiro,
                                        'number_of_passangers': payload.title.data.data[i].Pasajero,
                                        'job_pickup_address': payload.title.data.data[i].Dirección_de_Retiro,
                                        'nomina': payload.title.data.data[i].Nomina,
                                    })
                                }
                            }
                        } else {
                            vm.packageData = '';
                            vm.totalCount = payload.title.data.count;
                        }
                    } else {
                        vm.packageData = '';
                        vm.totalCount = payload.title.data.count;
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        //======================GET ALL THE BOOKING THAT MAKE A PACKAGE ==============


        //======================TO GENERATE THE PAKCAGE REPORT  ==============
        function generatePackageReport() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.branch_filter = 1;
            dataSend.link = 1;
            dataSend.branch_value = vm.filterData.branch;
            dataSend.aggrement_filter = 1;
            dataSend.aggrement_value = vm.filterData.agreement;
            dataSend.date_time_filter = 1;
            dataSend.date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            dataSend.date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            dataSend.service_filter = 1;
            dataSend.service_value = vm.filterData.service;
            dataSend.type_of_trip_filter = 1;
            dataSend.type_of_trip_value = vm.dataToFillModify.TripTypeModify;
            if (vm.dataToFillModify.Solicitante != '') {
                dataSend.applicant_filter = 1;
                dataSend.applicant_value = vm.dataToFillModify.Solicitante;
            } else {
                dataSend.applicant_filter = 0;
            }
            if (vm.dataToFillModify.Vuelo != '') {
                dataSend.flight_filter = 1;
                dataSend.flight_value = vm.dataToFillModify.Vuelo;
            } else {
                dataSend.flight_filter = 0;
            }
            dataSend.limit = 0;
            dataSend.offset = 0;
            vm.loading = true;
            var promise = getAgreement.getBookingForPackageCreation(dataSend);
            promise.then(
                function (payload) {
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        vm.showSubmitButtonAfterDownloadReport = true;
                        var link = document.createElement("a");
                        link.download = payload.title.data.data;
                        link.href = payload.title.data.data;
                        link.click();
                    } else {
                        vm.showSubmitButtonAfterDownloadReport = false;
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        //======================TO GENERATE THE PAKCAGE REPORT  ==============


        //======================PAGINATION FOR PACKAGE DATA  ==============
        function packageDataPagination() {
            if (vm.totalCount > vm.packageData.length + 1) {
                vm.packageoffset = vm.packageoffset + 200;
                applyFilterPackageCreation('scroll', vm.packageoffset);
            }
        }
        //======================PAGINATION FOR PACKAGE DATA  ==============


        function makeTableViewOfXlsxPackage($event) {
            $log.log('ddf');
            $event.stopPropagation();
            vm.uploadName = 'hello';
            var element = document.getElementById('documentUploadPackage');
            element.click();
        }

        $scope.file_to_upload_package = function (File, type) {
            var dataSend = new FormData();
            dataSend.append('access_token', $cookies.get('obj'));
            dataSend.append('file', File[0]);
            vm.loading = true;
            var dataArray = [];
            var promise = getAgreement.UploadMassivePackageFile(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    console.log(payload, '>>>>>>>>>>>>>>>UploadMassivePackageFile>>>>>>>>>>>>>>>');
                    if (payload.title.status == 200) {
                        vm.previewOfPackageScreenFlag = true;
                        // vm.previewTotalCount = payload.title.data.totalCount;
                        vm.totalLines = payload.title.data.totalLines;
                        vm.errorLines = payload.title.data.errorLines;
                        payload.title.data.data.forEach(function (column) {
                            var d = {};
                            d.Convenio = column.Convenio;
                            d.Direccion_de_Retiro = column.Dirección_de_Retiro;
                            d.Nombre_Solicitante = column.Nombre_Solicitante;
                            d.Nomina = column.Nómina;
                            d.Pasajero = column.Pasajero;
                            d.Reserva = column.Reserva;
                            d.Retiro = column.Retiro;
                            d.Sucursal = column.Sucursal;
                            d.Tipo_Servicio = column.Tipo_Servicio;
                            d.Tipo_Viaje = column.Tipo_Viaje;
                            d.Vuelo = column.Vuelo;
                            d.beforeCreationError = column.beforeCreationError;
                            d.error = column.error;
                            d.package = column.package;
                            dataArray.push(d);
                        })
                        vm.previewPackageData = dataArray;
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        //======================PACKAGE CREATION SCREEN CONTROLLER CODE HERE ==============


        //======================CANCEL BUTTON SHOW IN PREVEIW DATA SCREEN ==============
        function cancelTheCreatePackageProcess() {

        }
        //======================CANCEL BUTTON SHOW IN PREVEIW DATA SCREEN ==============

        //======================CREATE PACKAGE BUTTON SHOW IN PREVEIW DATA SCREEN ==============
        function startCreatePackageProcess($event) {
            if (vm.errorLines == vm.totalLines) {
                errorMessageFactory.showErrorMessage('Esta acción no se puede realizar porque todas las líneas tienen error', 0);
                return;
            }
            vm.items = {
                data: ''
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/massivCreationOfPackage.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: PackageCreationController
            });

            function PackageCreationController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    var promise = getAgreement.createMassivePackage(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            vm.loading = false;
                            if (payload.title.status == 200) {
                                $state.reload('layout.massiveCreateBookingMain.massiveCreateBooking');
                                $mdDialog.hide();
                            } else {
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            }
                        },
                        function (errorPayload) {
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                };
            }
        }
        //====================APPLY MODIFCATION  ====================



        //======================MODIFY BOOKING SCREEN CONTROLLER CODE HERE ==============
        //======================CANCEL BUTTON SHOW IN PREVEIW DATA SCREEN ==============


        //======================CHANGE DATE TO SPANISH ==============
        function spanishToDate(date) {
            moment.locale('es');
            return moment(date).format('LLLL');
        }
        //======================CHANGE DATE TO SPANISH ==============
    }
})();
/**
 * Created by cl-macmini-51 on 5/29/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('ItemOfChargeController', ItemOfChargeController);

    /** @ngInject */
    function ItemOfChargeController($cookies, $state, $log, $rootScope, $timeout, getCars, $scope, filterFilter, $mdDialog,$document, getItemOfCharge, adminAccessService, languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.getPagesCount = getPagesCount;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.init = init;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.cancelEdit = cancelEdit;
        vm.getAllItemOfCharges = getAllItemOfCharges;
        vm.addItemsHit = addItemsHit;
        vm.blockUnblockItemOfCharge = blockUnblockItemOfCharge;
        vm.deleteItemOfChargeHit = deleteItemOfChargeHit;
        vm.editItemOfCharge = editItemOfCharge;
        vm.checkEditDeleteAccess = checkEditDeleteAccess;
        vm.editApi = editApi;
        vm.viewItemOfCharge = viewItemOfCharge;
        vm.goBack = goBack;
        vm.paginationNew = paginationNew;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings(runThis);
        vm.loading = false;
        vm.currentPage = 0;
        vm.totalItemOfCharge = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.predicate = 'index';
        vm.reverse = false;
        vm.addItemFlag = true;
        vm.editItemFlag = false;
        vm.editItemOfChargeFlag = false;
        vm.viewItemOfChargeFlag = false;
        function runThis(){
            vm.dataToFill = {
                short_name: '',
                long_name: '',
                description: '',
                mode: '',
                manually: '',
                id: '',
                driverEarning: [
                    {
                        value: languageBasedErrorFactory.getProperErrorMessage('accToList',0,'3'),
                        id: 2
                    },
                    {
                        value: languageBasedErrorFactory.getProperErrorMessage('100Percent',0,'3'),
                        id: 1
                    },
                    {
                        value: languageBasedErrorFactory.getProperErrorMessage('0Percent',0,'3'),
                        id: 0
                    }
                ],
                driverEarningSelected: ''
            };
        }
        vm.filterData = {
            itemStatus: '1'
        };
        //==========================cancel========================
        function cancelEdit(){
            $state.reload('layout.itemOfChargeMain.itemOfChargeList');
        };

        //====================function for dropdown pages and page count===============
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];

        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllItemOfCharges(0, vm.itemsPerPageGot,vm.filterData.itemStatus);
        };

        function paginationNew(page){
            getAllItemOfCharges((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot,vm.filterData.itemStatus);
        }
        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.itemOfChargeMain.itemOfChargeList');
            }
        });
        //==================get all drivers=======================
        function getAllItemOfCharges(skip, limit,filter) {
            vm.loading = true;
            var promise = getItemOfCharge.getItemOfChargePagination(skip, limit,filter);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.totalItemOfCharge = payload.title.data.totalCount;
                    vm.dataLength = payload.title.data.totalCount;
                    
                    if (payload.title.data.totalCount == 0) {
                        vm.sp_pagination = false;
                        vm.tBodyFlag = false;
                        vm.tFootFlag = true;
                    }
                    else {
                        vm.sp_pagination = true;
                        vm.tBodyFlag = true;
                        vm.tFootFlag = false;
                    }
                    
                    var dataArray = [];
                    var itemOfChargeListGot = payload.title.data.result;
                    itemOfChargeListGot.forEach(function (column) {
                        var d = {};
                        d.id = column.id;
                        d.long_name = column.long_name;
                        d.short_name = column.short_name;
                        d.description = column.description;
                        d.manually = column.manually;
                        d.mode = column.mode;
                        d.driver_earnings = column.driver_earnings;
                        d.state = column.state;
                        dataArray.push(d);
                    });
                    vm.itemOfChargeListGot = dataArray;
                    for (var i = 0; i < vm.itemOfChargeListGot.length; i++) {
                        vm.itemOfChargeListGot[i].index = (skip + i);
                    }
                    if (vm.dataLength <= vm.itemOfChargeListGot) {
                        vm.sp_pagination = false;
                    }
                    else {
                        vm.sp_pagination = true;
                        //vm.pageCount(payload.title.data.totalCount);
                    }
                    vm.skipValue = vm.itemOfChargeListGot[0].index;
                    vm.limitValue = vm.itemOfChargeListGot[vm.itemOfChargeListGot.length - 1].index;
                    
                    $scope.$watch('vm.search', function (newVal, oldVal) {
                        vm.filtered = filterFilter(vm.itemOfChargeListGot, newVal);
                        vm.totalItems = vm.filtered.length;
                        if (vm.filtered.length == 0) {
                            vm.watchPagination = false;
                        }
                        else {
                            vm.watchPagination = true;
                        }
                        if (vm.filterOn == true) {
                            vm.skipValueFilter = vm.filtered.length;
                            vm.sp_pagination = false;
                        }
                    }, true);
                    
                    //range();
                },
                function (errorPayload) {
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                });
        };
        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    }
        //    else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        vm.getAllItemOfCharges((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData.itemStatus);
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        vm.currentPage++;
        //        vm.getAllItemOfCharges((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData.itemStatus);
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    vm.getAllItemOfCharges((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData.itemStatus);
        //};

        function init() {
            vm.getAllItemOfCharges(0, vm.searchModel.limit,vm.filterData.itemStatus);
        };
        init();

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            vm.filterOn = true;
            if (vm.search.length == 0) {
                vm.filterOn = false;
                vm.watchPagination = true;
                vm.sp_pagination = true;
            }
        };

        //===============================add items hit==================================
        function addItemsHit(){
            $log.log(vm.dataToFill);

            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.long_name = vm.dataToFill.long_name;
            dataSend.short_name = vm.dataToFill.short_name;
            dataSend.mode = vm.dataToFill.mode;
            dataSend.manually = vm.dataToFill.manually;
            dataSend.description = vm.dataToFill.description;
            dataSend.driver_earnings = vm.dataToFill.driverEarningSelected;

            vm.loading = true;
            var promise = getItemOfCharge.addItemOfCharge(dataSend);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    languageBasedErrorFactory.getProperErrorMessage('addItemSucc',0,1,'layout.itemOfChargeMain.itemOfChargeList');
                    //errorMessageFactory.showErrorMessage('Item of charge created successfully.',1);
                    //$timeout(function() {
                    //    $mdDialog.hide();
                    //    $state.reload();
                    //}, 2000);
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };

        //==================block_unblock function======================
        function blockUnblockItemOfCharge($event, id, value) {
            $log.log('block_unblock');
            var parentEl = angular.element($document.body);
            var msg = languageBasedErrorFactory.getProperErrorMessage('statusItemPop',0,'3');
            //==============dialog for confirm====================
            var confirm = $mdDialog.confirm()
                .title(msg)
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton',0,'3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton',0,'3'));

            $mdDialog.show(confirm).then(function() {
                var a = '';
                var msgSys = '';
                if (value == 0) {
                    a = 1;
                    msgSys = 'Item of charge unblocked.'
                } else if (value == 1) {
                    a = 0;
                    msgSys = 'Item of charge blocked.'
                }
                //errorMessageFactory.showErrorMessage('Functionality is pending.',0);
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.state = a;
                dataSend.item_of_charge_id = id;

                vm.loading = true;
                var promise = getItemOfCharge.editItemOfCharge(dataSend);
                promise.then(
                    function(payload) {
                        $log.log(payload);
                        vm.loading = false;
                        var dataForSysLogs = {
                            access_token: $cookies.get('obj'),
                            id: id,
                            identity : 15,
                            message : msgSys
                        };
                        $rootScope.systemLogsAdmin(dataForSysLogs);
                        languageBasedErrorFactory.getProperErrorMessage('statusItemSucc',0,1,'layout.itemOfChargeMain.itemOfChargeList');
                        //errorMessageFactory.showErrorMessage('Item of charge status updated successfully.',1);
                        //$timeout(function() {
                        //    $mdDialog.hide();
                        //    $state.reload();
                        //}, 2000);
                    },
                    function(errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if(errorPayload.data.status == 401){
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                        }
                        else{
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                        }
                    }
                );
            }, function() {
                $log.log('unblock');
            });
        };
        //=====================to delete service====================
        function deleteItemOfChargeHit(data, $event, value) {
            var confirm;
            if(value) {
                openPopUp(data,$event,'delete')
                // confirm = $mdDialog.confirm()
                // .title(languageBasedErrorFactory.getProperErrorMessage('deleteItemPopToll',0,'3'))
                // .textContent('')
                // .ariaLabel('Lucky day')
                // .targetEvent($event)
                // .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton',0,'3'))
                // .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton',0,'3'));
            }
            else {
                confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('deletedItemPop',0,'3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton',0,'3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton',0,'3'));
            }

            // $mdDialog.show(confirm).then(function() {
            //     $log.log('confirmed');
            //     //errorMessageFactory.showErrorMessage('Functionality is pending',0);
            //     var dataSend = {
            //         deleteType: 1,
            //         item_of_charge_id: data.id,
            //         access_token: $cookies.get('obj')
            //     };
            //     vm.loading = true;
            //     var promise = getItemOfCharge.deleteItemOfCharge(dataSend);
            //     promise.then(
            //         function(payload) {
            //             $log.log(payload);
            //             vm.loading = false;
            //             languageBasedErrorFactory.getProperErrorMessage('deletedItemSucc',0,1,'layout.itemOfChargeMain.itemOfChargeList');
            //             //errorMessageFactory.showErrorMessage('Item of charge deleted successfully.',1);
            //             //$state.reload();
            //         },
            //         function(errorPayload) {
            //             $log.log(errorPayload);
            //             vm.loading = false;
            //             if(errorPayload.data.status == 401){
            //                 errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
            //             }
            //             else{
            //                 errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
            //             }
            //         }
            //     );
            // }, function() {
            //     $log.log('not confirmed');
            // });
        };

        function checkEditDeleteAccess(value, data, $event) {
            var promise = adminAccessService.checkStateValid(value); //$stateParams.id
            promise.then(
                function (payload) {
                    adminAccessService.getPreviousState();
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (!payload.title.data.granted) {
                            console.log('debug data', data);
                            errorMessageFactory.showErrorMessage('No tiene permiso para ejecutar esta opción', 0);
                            return true;
                        }
                        else if(value === 'Modificar item de cargo TAG') {
                            vm.editItemOfCharge(data, $event, value);
                        }
                        else if(value === 'Eliminar item de cargo TAG') {
                            vm.deleteItemOfChargeHit(data, $event, value);
                        }
                    }
                },
                function (errorPayload) {
                    console.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function openPopUp(data,$event,value){
            vm.items = {
                editDelete : value == 'edit'?1:0,
                data:data
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/editDeleteRedHeading.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });

            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function (value) {
                    if(value){
                        $mdDialog.hide();
                        vm.editItemOfCharge($scope.items.data)
                    }else{
                        var dataSend = {
                            deleteType: 1,
                            item_of_charge_id: $scope.items.data.id,
                            access_token: $cookies.get('obj')
                        };
                        vm.loading = true;
                        var promise = getItemOfCharge.deleteItemOfCharge(dataSend);
                        promise.then(
                            function(payload) {
                                $log.log(payload);
                                vm.loading = false;
                                $mdDialog.hide();
                                languageBasedErrorFactory.getProperErrorMessage('deletedItemSucc',0,1,'layout.itemOfChargeMain.itemOfChargeList');
                            },
                            function(errorPayload) {
                                $log.log(errorPayload);
                                vm.loading = false;
                                if(errorPayload.data.status == 401){
                                    errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                                }
                                else{
                                    errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                                }
                            }
                        );
                    }
                }
            }
        }





        //==========================edit item of charge=========================
        function editItemOfCharge(data, $event, value){
            if(value) {
                openPopUp(data,$event,'edit')
                // confirm = $mdDialog.confirm()
                // .title(languageBasedErrorFactory.getProperErrorMessage('modifyItemPopToll',0,'3'))
                // .textContent('')
                // .ariaLabel('Lucky day')
                // .targetEvent($event)
                // .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton',0,'3'))
                // .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton',0,'3'));

                // $mdDialog.show(confirm).then(function() {
                //     vm.editItemOfChargeFlag = true;
                //     vm.viewItemOfChargeFlag = false;
                //     vm.addItemFlag = false;
                //     vm.dataToFill.short_name = data.short_name;
                //     vm.dataToFill.id = data.id;
                //     vm.dataToFill.long_name = data.long_name;
                //     vm.dataToFill.description = data.description;
                //     vm.dataToFill.driverEarningSelected = data.driver_earnings;
                //     vm.dataToFill.mode = data.mode.toString();
                //     vm.dataToFill.manually = data.manually.toString();
                // }, function() {
                //     $log.log('not confirmed');
                // });
            }
            else {
                vm.editItemOfChargeFlag = true;
                vm.viewItemOfChargeFlag = false;
                vm.addItemFlag = false;
                vm.dataToFill.short_name = data.short_name;
                vm.dataToFill.id = data.id;
                vm.dataToFill.long_name = data.long_name;
                vm.dataToFill.description = data.description;
                vm.dataToFill.driverEarningSelected = data.driver_earnings;
                vm.dataToFill.mode = data.mode.toString();
                vm.dataToFill.manually = data.manually.toString();
            }
        };

        function editApi(){
            //errorMessageFactory.showErrorMessage('Functionality is pending.',0);

            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.long_name = vm.dataToFill.long_name;
            dataSend.short_name = vm.dataToFill.short_name;
            dataSend.mode = vm.dataToFill.mode;
            dataSend.manually = vm.dataToFill.manually;
            dataSend.description = vm.dataToFill.description;
            dataSend.item_of_charge_id = vm.dataToFill.id;
            dataSend.driver_earnings = vm.dataToFill.driverEarningSelected;

            vm.loading = true;
            var promise = getItemOfCharge.editItemOfCharge(dataSend);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    var dataForSysLogs = {
                        access_token: $cookies.get('obj'),
                        id: vm.dataToFill.id,
                        identity : 15,
                        message : 'Item of charge updated.'
                    };
                    $rootScope.systemLogsAdmin(dataForSysLogs);
                    languageBasedErrorFactory.getProperErrorMessage('editItemSucc',0,1,'layout.itemOfChargeMain.itemOfChargeList');
                    //errorMessageFactory.showErrorMessage('Item of charge updated successfully.',1);
                    //$timeout(function() {
                    //    $mdDialog.hide();
                    //    $state.reload();
                    //}, 2000);
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };

        //===================view item of charge=============================
        function viewItemOfCharge(data){
            vm.editItemOfChargeFlag = false;
            vm.viewItemOfChargeFlag = true;
            vm.addItemFlag = false;
            vm.itemLongName = data.long_name;
            vm.itemShortName = data.short_name;
            vm.itemID = data.id;
            vm.itemState = data.state;
            vm.itemMode = data.mode;
            vm.itemManually = data.manually;
            vm.itemDescription = data.description;
            vm.driverEarning = data.driver_earnings;
        };
        //======================go back=======================
        function goBack(){
            vm.editItemOfChargeFlag = false;
            vm.viewItemOfChargeFlag = false;
            vm.addItemFlag = true;
        }
    }
})();
/**
 * Created by cl-macmini-51 on 5/24/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('IlluminatedZoneServicesNewPageController', IlluminatedZoneServicesNewPageController);

    /** @ngInject */
    function IlluminatedZoneServicesNewPageController($cookies, $state, $log, adminAccessService, $rootScope, $timeout, $interval, getCars, $scope, filterFilter, $mdDialog, $document, getGeofence, languageBasedErrorFactory, errorMessageFactory, getFilters) {
        var vm = this;
        vm.currentPage = 0;
        vm.skipValueFilter = 0;
        vm.restrictionsChangeFlag = false;
        vm.showErrorMessageFlag = false;
        vm.changeValue = changeValue;
        vm.dataLength = 0;
        vm.sp_pagination = false;
        vm.restrictionsChange = restrictionsChange;
        vm.selectedTab = selectedTab;
        vm.sumbitGrabar = sumbitGrabar;
        vm.tBodyFlag = false;
        vm.tFootFlag = true;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = true;
        vm.predicate = 'index';
        vm.reverse = false;
        vm.getFilter = getFilter;
        vm.getPagesCount = getPagesCount;
        vm.paginationNew = paginationNew;
        vm.branchChanged = branchChanged;
        vm.regionChanged = regionChanged;
        vm.flagForCssNew = {
            'height': '476px'
        }
        vm.countToSocket = 0;
        vm.dataToFill = {
            branchId: '',
            iluuminatedId: '',
            showRegions: false,
            showServiceType: false,
            vehicleId: '',
            isDivSelected: 0
        }

        vm.paginationChangedForBranch = paginationChangedForBranch;
        vm.branchSearch = branchSearch;
        vm.globalLimit = 10;
        vm.globalOffset = vm.globalLimit;
        vm.branchList = [];

        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'vehicle', 'service', 'agreement', 'corporatesList', 'operation_point'];
        vm.branchOffset = 0;

        // =================== FILTER OBJECT ===================
        vm.filterObject = {
            access_token: $cookies.get('obj'),
            branch_filter: 1,
            vehicle_filter: 0,
            service_filter: 0,
            agreement_filter: 0,
            corporate_filter: 0,
            service_category: 0,
            corporate_status: 0,
            agreement_status: 0,
            vehicle__status: 0,
            operation_point_filter: 0,
            branch_limit: vm.globalLimit,
            branch_offset: vm.branchOffset,
            branch_search_filter: 0,
            vehicle_search_filter: 0,
            service_search_filter: 0,
            agreement_search_filter: 0,
            corporate_search_filter: 0,
            operation_point_search_filter: 0
        }
        vm.hoursArray = [{
                value: 0,
                id: '00:00'
            },
            {
                value: 1,
                id: '01:00'
            },
            {
                value: 2,
                id: '02:00'
            },
            {
                value: 3,
                id: '03:00'
            },
            {
                value: 4,
                id: '04:00'
            },
            {
                value: 5,
                id: '05:00'
            },
            {
                value: 6,
                id: '06:00'
            },
            {
                value: 7,
                id: '07:00'
            },
            {
                value: 8,
                id: '08:00'
            },
            {
                value: 9,
                id: '09:00'
            },
            {
                value: 10,
                id: '10:00'
            },
            {
                value: 11,
                id: '11:00'
            },
            {
                value: 12,
                id: '12:00'
            },
            {
                value: 13,
                id: '13:00'
            },
            {
                value: 14,
                id: '14:00'
            },
            {
                value: 15,
                id: '15:00'
            },
            {
                value: 16,
                id: '16:00'
            },
            {
                value: 17,
                id: '17:00'
            },
            {
                value: 18,
                id: '18:00'
            },
            {
                value: 19,
                id: '19:00'
            },
            {
                value: 20,
                id: '20:00'
            },
            {
                value: 21,
                id: '21:00'
            },
            {
                value: 22,
                id: '22:00'
            },
            {
                value: 23,
                id: '23:00'
            }
        ]
        setTimeout(function () {
            document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                // if (vm.branchList && (vm.branchList.length == 0)) {
                vm.searchBranchData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

        })
        // =================== GET FILTER DATA ===================
        function getFilterDataFromBackend(data, type) { //Acc to Index ['branch_search', 'vehicle_search', 'service_search', 'agreement_search', 'corporate_search', 'operation_point_search']
            if (data) {
                vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
            } else {
                vm.filterObject = {
                    access_token: $cookies.get('obj'),
                    branch_filter: 1,
                    vehicle_filter: 0,
                    service_filter: 0,
                    agreement_filter: 0,
                    corporate_filter: 0,
                    service_category: 0,
                    corporate_status: 0,
                    agreement_status: 0,
                    vehicle__status: 0,
                    operation_point_filter: 0,
                    branch_search_filter: 0,
                    vehicle_search_filter: 0,
                    service_search_filter: 0,
                    agreement_search_filter: 0,
                    corporate_search_filter: 0,
                    operation_point_search_filter: 0
                }
            }

            vm.filterObject.branch_limit = vm.globalLimit;
            vm.filterObject.branch_offset = vm.branchOffset;
            var promise = getFilters.getAllFilterData(vm.filterObject);
            promise.then(
                function (payload) {

                    // ********** BRANCH DATA ********
                    if (payload.title.data.branches) {

                        angular.forEach(payload.title.data.branches.data, function (column) {
                            //CHECK FOR DUPLICATE ENTRY
                            var branchIndex = _.findIndex(vm.branchList, {
                                region_id: column.region_id
                            });
                            if (branchIndex == -1)
                                vm.branchList.push(column)
                        });
                        vm.branchTotalBackendCount = payload.title.data.branches.totalCount;
                    }

                    vm.loading = false;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        }
        getFilterDataFromBackend();

        // ************ PAGINATION ON BRANCH **************
        function paginationChangedForBranch() {
            var index = _.findIndex(vm[vm.searchFilterArray[0]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.branchTotalBackendCount > (vm.branchList.length - index)) {
                commonFunction(0);
                vm.branchOffset += 10;
                getFilterDataFromBackend(vm.searchBranchData, 0);
            }
        }

        // *********** COMMON FUNCTION FOR FILTER PAGINATION AND SEARCHING ***********
        function commonFunction(type, mode) {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                // vm['search' + vm.searchFilterArray[i] + 'Data'] = '';
                if (mode == 'search' || i != type) {
                    vm[vm.searchFilterArrayForClearArray[i]] = [];
                    // vm[vm.searchFilterArrayForClearArray[i]].push({
                    //     id: 'all',
                    //     name: 'All'
                    // });
                    vm[vm.searchFilterArray[i] + 'Offset'] = 0;
                    vm['search' + vm.searchFilterArray[i].substring(0, 1).toUpperCase() + vm.searchFilterArray[i].substring(1) + 'Data'] = '';
                }
            }
        }

        // ************ SEARCH BRANCH ***************
        function branchSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchBranchData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(0, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 0);
                }, 2000);
            }
        }

        //====================function for dropdown pages and page count===============
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];

        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            if (vm.illuminatedVehicles && vm.illuminatedVehicles.length)
                getDriverOfSelectedType(0, vm.itemsPerPageGot, vm.dataToFill, true);
        };

        function paginationNew(page) {
            getDriverOfSelectedType((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.dataToFill, true);
        }


        if ($rootScope.socket.connected == false || $rootScope.socket.connected == 'false') {
            $rootScope.socket.connect();
        }

        // ******** CLEAR OFFSET *******
        function clearOffset() {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                vm[vm.searchFilterArray[i] + 'Offset'] = 0;
            }
        }

        function branchChanged() {
            getIlluminatedRegions(vm.dataToFill.branchId);
            vm.branchList = [];
            clearOffset();
            getFilterDataFromBackend();
            vm.dataToFill.iluuminatedId = '';
            vm.dataToFill.showRegions = true;
            vm.illuminatedVehicles = [];
            vm.sp_pagination = false;
            vm.tBodyFlag = false;
            vm.tFootFlag = true;
            vm.filterOn = true;
            vm.skipValueFilter = 0;
            vm.dataLength = 0;
            vm.driverList = [];
        }

        // ================get illuminated regions================
        function getIlluminatedRegions(branchId) {
            var dataToSend = {};
            vm.illuminatedRegionList = [];
            dataToSend.branch_id = branchId;
            dataToSend.access_token = $cookies.get('obj');
            var promise = getGeofence.getilluminatedRegionsList(dataToSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.data.data.length) {
                        var dataNew  = payload.title.data.data;
                        dataNew.forEach(function (data){
                            if(data.control_cantity_driver_app == 1){
                                vm.illuminatedRegionList.push({
                                    region_id: data.region_id,
                                    region_name : data.region_name
                                })
                            }
                        });
                        if(vm.illuminatedRegionList.length == 0){
                            vm.illuminatedRegionList = [];
                            errorMessageFactory.showErrorMessage('No hay zona iluminada con restricción permitida para esta sucursal', 0);
                        }
                        // vm.illuminatedRegionList = payload.title.data.data; //TV-4100
                    } else {
                        vm.illuminatedRegionList = [];
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            )
        }

        function regionChanged() {
            vm.dataToFill.showServiceType = true;
            vm.dataToFill.isDivSelected = 0;
            getIlluminatedZoneServices(vm.dataToFill.iluuminatedId);
        }

        // ===============get services===============
        function getIlluminatedZoneServices(zoneId, type) {
            vm.countToSocket = vm.countToSocket + 1;
            var dataToSend = {};
            // dataToSend.zone_id = zoneId;
            dataToSend.access_token = $cookies.get('obj');
            var promise = getGeofence.getilluminatedZoneServicesNew(dataToSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    vm.countToSocket = 0;
                    if (payload.title.data.data.length) {
                        vm.illuminatedVehicles = payload.title.data.data;
                        vm.dataToFill.vehicleId = vm.illuminatedVehicles[vm.dataToFill.isDivSelected] ? vm.illuminatedVehicles[vm.dataToFill.isDivSelected].id : payload.title.data.data[0].id;
                        // if (type == 'socket') {
                        //     getDriverOfSelectedType(vm.currentPage * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.dataToFill, false);
                        // } else {
                        //     getDriverOfSelectedType(0, vm.itemsPerPageGot, vm.dataToFill, true);
                        // }
                        getIlluminatedRegionsRestriction(vm.dataToFill);
                    } else {
                        vm.illuminatedVehicles = [];
                        vm.sp_pagination = false;
                        vm.tBodyFlag = false;
                        vm.tFootFlag = true;
                        vm.filterOn = true;
                        vm.skipValueFilter = 0;
                        vm.dataLength = 0;
                        vm.driverList = [];
                        errorMessageFactory.showErrorMessage('No hay vehículo disponible', 0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            )

        }

        function getFilter() {
            vm.filterOn = true;
            if (vm.search.length == 0) {
                vm.filterOn = false;
                vm.watchPagination = true;
                vm.sp_pagination = true;
            }
        };

        function getIlluminatedRegionsRestriction(data) {
            var dataToSend = {};
            dataToSend.access_token = $cookies.get('obj');
            dataToSend.illuminated_zone_id = data.iluuminatedId;
            dataToSend.vehicle_type_id = JSON.stringify(data.vehicleId);
            dataToSend.branch_id = data.branchId;
            var promise = getGeofence.viewTransvipIlluminatedRegionsRestriction(dataToSend); //$stateParams.id
            return promise.then(
                function (payload) {
                    if (payload.title.status == 200) {
                        if (payload.title.data && payload.title.data.restrictions.length > 0) {
                            vm.restrictionsArray = payload.title.data.restrictions;
                        }
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }

                },
                function (errorPayload) {
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function restrictionsChange(restrictionsData, hoursData, weekDay) {
            vm.flagForCssNew = {
                'height': '600px'
            }
            vm.restrictionsChangeFlag = true;
            vm.hourDay = hoursData.id.split(':')[0];
            vm.weekDay = weekDay;
            vm.changeRestrictionsData = restrictionsData;
            vm.ChangeHoursData = hoursData;
            vm.restrictionValue = restrictionsData[hoursData.id];
        }

        function sumbitGrabar() {
            if (vm.restrictionValue > 999) {
                vm.showErrorMessageFlag = true;
                vm.flagToShowCss = {
                    'border': '1px solid red'
                }
                return;
            }
            if (vm.restrictionValue == undefined) {
                return;
            }
            var dataToSend = {};
            dataToSend.access_token = $cookies.get('obj');
            dataToSend.illuminated_zone_id = vm.dataToFill.iluuminatedId;
            dataToSend.vehicle_type_id = JSON.stringify(vm.dataToFill.vehicleId);
            dataToSend.branch_id = vm.dataToFill.branchId;
            dataToSend.day_id = vm.changeRestrictionsData.day_id;
            dataToSend.day_slot = vm.ChangeHoursData.id;
            dataToSend.slot_restriction = Number(vm.restrictionValue);
            var promise = getGeofence.editTransvipIlluminatedRegionsRestriction(dataToSend); //$stateParams.id
            return promise.then(
                function (payload) {
                    if (payload.title.status == 200) {
                        getIlluminatedRegionsRestriction(vm.dataToFill);
                        vm.restrictionsChangeFlag = false;
                        vm.flagForCssNew = {
                            'height': '476px'
                        }
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }

                },
                function (errorPayload) {
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function selectedTab(data, index) {
            vm.restrictionsChangeFlag = false;
            vm.dataToFill.isDivSelected = index;
            vm.dataToFill.vehicleId = data.id
            getIlluminatedRegionsRestriction(vm.dataToFill);
        }

        function changeValue() {
            if (vm.restrictionValue > 999) {
                vm.showErrorMessageFlag = true;
                vm.flagToShowCss = {
                    'border': '1px solid red'
                }
            } else {
                vm.showErrorMessageFlag = false;
                vm.flagToShowCss = {
                    'border': '1px solid lightgray'
                }
            }
        }
    }
})();
/**
 * Created by cl-macmini-51 on 5/24/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('IlluminatedZoneServicesController', IlluminatedZoneServicesController);

    /** @ngInject */
    function IlluminatedZoneServicesController($cookies, $state, $log, adminAccessService, $rootScope, $timeout, $interval, getCars, $scope, filterFilter, $mdDialog, $document, getGeofence, languageBasedErrorFactory, errorMessageFactory, getFilters) {
        var vm = this;
        vm.currentPage = 0;
        vm.skipValueFilter = 0;
        vm.dataLength = 0;
        vm.deleteDriver = deleteDriver;
        vm.sp_pagination = false;
        vm.tBodyFlag = false;
        vm.tFootFlag = true;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = true;
        vm.VerifyMaunalButton = VerifyMaunalButton;
        vm.predicate = 'index';
        vm.reverse = false;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.getPagesCount = getPagesCount;
        vm.paginationNew = paginationNew;
        vm.branchChanged = branchChanged;
        vm.regionChanged = regionChanged;
        vm.activeButton = activeButton;

        vm.countToSocket = 0;
        vm.dataToFill = {
            branchId: '',
            iluuminatedId: '',
            showRegions: false,
            showServiceType: false,
            vehicleId: '',
            isDivSelected: 0
        }

        vm.paginationChangedForBranch = paginationChangedForBranch;
        vm.branchSearch = branchSearch;
        vm.globalLimit = 10;
        vm.globalOffset = vm.globalLimit;
        vm.branchList = [];

        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'vehicle', 'service', 'agreement', 'corporatesList', 'operation_point'];
        vm.branchOffset = 0;

        // =================== FILTER OBJECT ===================
        vm.filterObject = {
            access_token: $cookies.get('obj'),
            branch_filter: 1,
            vehicle_filter: 0,
            service_filter: 0,
            agreement_filter: 0,
            corporate_filter: 0,
            service_category: 0,
            corporate_status: 0,
            agreement_status: 0,
            vehicle__status: 0,
            operation_point_filter: 0,
            branch_limit: vm.globalLimit,
            branch_offset: vm.branchOffset,
            branch_search_filter: 0,
            vehicle_search_filter: 0,
            service_search_filter: 0,
            agreement_search_filter: 0,
            corporate_search_filter: 0,
            operation_point_search_filter: 0
        }

        setTimeout(function () {
            document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                // if (vm.branchList && (vm.branchList.length == 0)) {
                vm.searchBranchData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

        })
        // =================== GET FILTER DATA ===================
        function getFilterDataFromBackend(data, type) { //Acc to Index ['branch_search', 'vehicle_search', 'service_search', 'agreement_search', 'corporate_search', 'operation_point_search']
            if (data) {
                vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
            } else {
                vm.filterObject = {
                    access_token: $cookies.get('obj'),
                    branch_filter: 1,
                    vehicle_filter: 0,
                    service_filter: 0,
                    agreement_filter: 0,
                    corporate_filter: 0,
                    service_category: 0,
                    corporate_status: 0,
                    agreement_status: 0,
                    vehicle__status: 0,
                    operation_point_filter: 0,
                    branch_search_filter: 0,
                    vehicle_search_filter: 0,
                    service_search_filter: 0,
                    agreement_search_filter: 0,
                    corporate_search_filter: 0,
                    operation_point_search_filter: 0
                }
            }

            vm.filterObject.branch_limit = vm.globalLimit;
            vm.filterObject.branch_offset = vm.branchOffset;
            var promise = getFilters.getAllFilterData(vm.filterObject);
            promise.then(
                function (payload) {

                    // ********** BRANCH DATA ********
                    if (payload.title.data.branches) {

                        angular.forEach(payload.title.data.branches.data, function (column) {
                            //CHECK FOR DUPLICATE ENTRY
                            var branchIndex = _.findIndex(vm.branchList, {
                                region_id: column.region_id
                            });
                            if (branchIndex == -1)
                                vm.branchList.push(column)
                        });
                        vm.branchTotalBackendCount = payload.title.data.branches.totalCount;
                    }

                    vm.loading = false;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        }
        getFilterDataFromBackend();

        // ************ PAGINATION ON BRANCH **************
        function paginationChangedForBranch() {
            var index = _.findIndex(vm[vm.searchFilterArray[0]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.branchTotalBackendCount > (vm.branchList.length - index)) {
                commonFunction(0);
                vm.branchOffset += 10;
                getFilterDataFromBackend(vm.searchBranchData, 0);
            }
        }

        // *********** COMMON FUNCTION FOR FILTER PAGINATION AND SEARCHING ***********
        function commonFunction(type, mode) {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                // vm['search' + vm.searchFilterArray[i] + 'Data'] = '';
                if (mode == 'search' || i != type) {
                    vm[vm.searchFilterArrayForClearArray[i]] = [];
                    // vm[vm.searchFilterArrayForClearArray[i]].push({
                    //     id: 'all',
                    //     name: 'All'
                    // });
                    vm[vm.searchFilterArray[i] + 'Offset'] = 0;
                    vm['search' + vm.searchFilterArray[i].substring(0, 1).toUpperCase() + vm.searchFilterArray[i].substring(1) + 'Data'] = '';
                }
            }
        }

        // ************ SEARCH BRANCH ***************
        function branchSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchBranchData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(0, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 0);
                }, 2000);
            }
        }

        //====================function for dropdown pages and page count===============
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];

        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            if (vm.illuminatedVehicles && vm.illuminatedVehicles.length)
                getDriverOfSelectedType(0, vm.itemsPerPageGot, vm.dataToFill, true);
        };

        function paginationNew(page) {
            getDriverOfSelectedType((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.dataToFill, true);
        }

        //====================socket connection===================
        var myListener = $rootScope.$on('SocketComesIlluminated', function (evt, data) {
            $log.log(evt);
            $log.log('socketgsgsgsgg', data);
            console.log(data, 'data>>>>>>>>>>>>>>>>>>>>>>>>SocketComesIlluminated');

            if (data && data.data == true && data.res && data.res.message) {
                var payload = data.res.message;
                vm.dataToFill.vehicleId = vm.illuminatedVehicles[vm.dataToFill.isDivSelected] ? vm.illuminatedVehicles[vm.dataToFill.isDivSelected].id : payload.id;
                var index = -1
                index = vm.driverList.findIndex(function (x) {
                    return x.fleet_id == payload.fleet_id;
                });
                var indexService = -1;
                var indexServiceId = -1;

                indexService = vm.illuminatedVehicles.findIndex(function (x) {
                    return x.id.includes(payload.id[0]);
                });
                if (indexService > 0) {
                    if (vm.illuminatedVehicles[indexService].count == undefined) {
                        vm.illuminatedVehicles[indexService].count = 0;
                    }
                }
                if (index == -1) {
                    if (payload.region_id == vm.dataToFill.iluuminatedId) {
                        console.log(payload.region_id, 'payload.region_id', vm.dataToFill.vehicleId);
                        if (vm.dataToFill.vehicleId.includes(payload.id[0])) {
                            console.log(payload.id, 'payload.id', vm.dataToFill.vehicleId);
                            if (payload.isEnterZone == true) {
                                console.log(payload.isEnterZone, 'isEnterZone');

                                var d = {};
                                var dataArray = [];
                                d.unique_car_id = payload.unique_car_id;
                                d.fleet_name = payload.fleet_name;
                                d.entry_time = payload.entry_time;
                                d.total_passengers = payload.total_passengers;
                                // d.passenger_entry_time_formatted = '00:00';
                                if (vm.promise1) {
                                    $interval.cancel(vm.promise1);
                                }
                                if (payload.passenger_entry_time) {
                                    d.passenger_entry_time = payload.passenger_entry_time;
                                    // d.passenger_entry_time_formatted1 = (column.passenger_entry_time);
                                    /////////// TV-2631////////////////////////////
                                    vm.promise1 = $interval(function () {
                                        var countDownDate = new Date(payload.passenger_entry_time).getTime();
                                        var now = new Date().getTime();
                                        var difference = now - countDownDate;
                                        var hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                                        var minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
                                        var seconds = Math.floor((difference % (1000 * 60) / 1000));
                                        if (minutes <= 9) {
                                            minutes = '0' + minutes;
                                        }
                                        if (hours <= 9) {
                                            hours = '0' + hours;
                                        }
                                        if (seconds <= 9) {
                                            seconds = '0' + seconds;
                                        }
                                        d.passenger_entry_time_formatted =
                                            hours + ":" + minutes + ":" + seconds;

                                    }, 0);
                                    /////////// TV-2631////////////////////////////
                                } else {
                                    d.passenger_entry_time_formatted = '00:00';
                                }
                                d.action = payload.action;
                                d.fleet_id = payload.fleet_id;
                                // dataArray.push(d);
                                vm.driverList.push(d);
                                vm.tBodyFlag = true;
                                console.log(vm.driverList, 'vm.driverList');

                            }
                        }
                    }
                } else {
                    if (payload.region_id == vm.dataToFill.iluuminatedId) {
                        console.log(payload.region_id , vm.dataToFill.iluuminatedId, 'region_id>>>>>>>>>>>>>>');
                        if (vm.dataToFill.vehicleId.includes(payload.id[0])) {
                            vm.dataToFill.isDivSelected = 0;
                            // if (indexService <= 0)
                            // vm.illuminatedVehicles[indexService].count = vm.illuminatedVehicles[indexService] ? vm.illuminatedVehicles[indexService].count - 1 : 0;
                            vm.dataToFill.vehicleId = vm.illuminatedVehicles[0].id;
                            if (vm.illuminatedVehicles[indexService].count <= 0)
                                getDriverOfSelectedType(0, vm.itemsPerPageGot, vm.dataToFill, true);
                            vm.driverList.splice(index, 1);
                        }
                    }
                }
                if (indexService == -1) {
                    if (payload.region_id == vm.dataToFill.iluuminatedId) {
                        console.log(payload.region_id , vm.dataToFill.iluuminatedId, 'region_id>>>>>>>>>>>>>> 2');
                        if (payload.isEnterZone == true) {
                            vm.illuminatedVehicles.push({
                                name: payload.name,
                                vehicle_image: payload.vehicle_image,
                                count: vm.illuminatedVehicles[indexService] ? vm.illuminatedVehicles[indexService].count + 1 : 1,
                                id: payload.id
                            });
                        }
                    }
                } else {
                    if (payload.region_id == vm.dataToFill.iluuminatedId) {
                        if (payload.isEnterZone == false) {
                            if (vm.illuminatedVehicles[indexService].count == 0) {
                                vm.illuminatedVehicles.splice(indexService, 1);
                            } else {
                                vm.illuminatedVehicles[indexService].count = vm.illuminatedVehicles[indexService] ? vm.illuminatedVehicles[indexService].count - 1 : 0;
                                if (vm.illuminatedVehicles[indexService].count == 0) {
                                    vm.illuminatedVehicles.splice(indexService, 1);
                                }
                                getDriverOfSelectedType(0, vm.itemsPerPageGot, vm.dataToFill, false);
                            }
                        }
                        if (payload.isEnterZone == true) {
                            if (vm.illuminatedVehicles[indexService].count == 0) {
                                vm.illuminatedVehicles.splice(indexService, 1);
                            }
                            getDriverOfSelectedType(0, vm.itemsPerPageGot, vm.dataToFill, false);
                            vm.illuminatedVehicles[indexService].count = vm.illuminatedVehicles[indexService].count + 1;
    
                        }
                    }
                }
                $scope.$apply();
            }
            // if (data.data && vm.countToSocket == 0 && vm.dataToFill.iluuminatedId) {
            //     vm.itemsPerPageGot = vm.itemsPerPageSelected;
            //     getIlluminatedZoneServices(vm.dataToFill.iluuminatedId, 'socket');
            // }

        });
        $scope.$on('$destroy', myListener);


        if ($rootScope.socket.connected == false || $rootScope.socket.connected == 'false') {
            $rootScope.socket.connect();
        }


        // ===============get branches list all===============
        // function getBranches() {
        // vm.branchList = [];
        // vm.branchList = getFilters.branchesFiltersData.data;

        // var promise = getGeofence.branch();
        // promise.then(
        //     function (payload) {
        //         $log.log(payload);
        //         vm.loading = false;
        //         if (payload.title.status == 400) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //         } else if (payload.title.status == 401) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //         } else if (payload.title.status == 201 || payload.title.status == 200) {
        //             if (payload.title.data.length) {
        //                 vm.branchList = _.where(payload.title.data, {
        //                     parent_id: 0
        //                 });
        //             } else {
        //                 vm.branchList = [];
        //             }
        //         }
        //     },
        //     function (errorPayload) {
        //         $log.log(errorPayload);
        // vm.loading = false;
        //         if (errorPayload.data.status == 401) {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //         } else {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //         }
        //     }
        // )

        // }
        // WHen Page refresh service take time to get data from backend
        // setTimeout(function () {
        //     getBranches();
        // }, 1000);

        // ******** CLEAR OFFSET *******
        function clearOffset() {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                vm[vm.searchFilterArray[i] + 'Offset'] = 0;
            }
        }

        function branchChanged() {
            getIlluminatedRegions(vm.dataToFill.branchId);
            vm.branchList = [];
            clearOffset();
            getFilterDataFromBackend();
            vm.dataToFill.iluuminatedId = '';
            vm.dataToFill.showRegions = true;
            vm.illuminatedVehicles = [];
            vm.sp_pagination = false;
            vm.tBodyFlag = false;
            vm.tFootFlag = true;
            vm.filterOn = true;
            vm.skipValueFilter = 0;
            vm.dataLength = 0;
            vm.driverList = [];
        }

        // ================get illuminated regions================
        function getIlluminatedRegions(branchId) {
            var dataToSend = {};
            dataToSend.branch_id = branchId;
            dataToSend.access_token = $cookies.get('obj');

            var promise = getGeofence.getilluminatedRegionsList(dataToSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.data.data.length) {
                        vm.illuminatedRegionList = payload.title.data.data;
                    } else {
                        vm.illuminatedRegionList = [];
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            )
        }
        
        $rootScope.socket.on("connect", function () {
            if(vm.dataToFill.iluuminatedId != ""){
                regionChanged();
            }
        }); 

        function regionChanged() {
            vm.dataToFill.showServiceType = true;
            vm.dataToFill.isDivSelected = 0;
            getIlluminatedZoneServices(vm.dataToFill.iluuminatedId);
        }

        // ===============get services===============
        function getIlluminatedZoneServices(zoneId, type) {
            vm.countToSocket = vm.countToSocket + 1;
            var dataToSend = {};
            dataToSend.zone_id = zoneId;
            dataToSend.access_token = $cookies.get('obj');
            var promise = getGeofence.getilluminatedZoneServices(dataToSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    vm.countToSocket = 0;
                    if (payload.title.data.data.length) {
                        vm.illuminatedVehicles = payload.title.data.data;
                        vm.dataToFill.vehicleId = vm.illuminatedVehicles[vm.dataToFill.isDivSelected] ? vm.illuminatedVehicles[vm.dataToFill.isDivSelected].id : payload.title.data.data[0].id;
                        console.log(vm.dataToFill.vehicleId, 'vm.dataToFill.vehicleId >>>>>>>>>>> change');

                        if (type == 'socket') {
                            getDriverOfSelectedType(vm.currentPage * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.dataToFill, false);
                        } else {
                            getDriverOfSelectedType(0, vm.itemsPerPageGot, vm.dataToFill, true);
                        }
                    } else {
                        vm.illuminatedVehicles = [];
                        vm.sp_pagination = false;
                        vm.tBodyFlag = false;
                        vm.tFootFlag = true;
                        vm.filterOn = true;
                        vm.skipValueFilter = 0;
                        vm.dataLength = 0;
                        vm.driverList = [];
                        errorMessageFactory.showErrorMessage('No hay vehículo disponible', 0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            )

        }

        /////////////////////// TV-2631 /////////////////
        // function calculateTimeDifference(data) {
        //     var currentTime = new Date().getTime();
        //     var localFormat = new Date(data).getTime();
        //     var difference = parseInt((currentTime - localFormat) / (1000 * 60));
        //     var format = difference + ':' + '00';
        //     return format;
        // }
        /////////////////////// TV-2631 /////////////////


        /////////////////////////////// ADD VECHICLE MANUALLY /////////////
        function VerifyMaunalButton($event) {
            var promise = adminAccessService.checkStateValid('Add/Remove Cars of Illuminated Zone'); //$stateParams.id
            return promise.then(
                function (payload) {
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (!payload.title.data.granted) {
                            languageBasedErrorFactory.getProperErrorMessage('optionNotAvail', 0, 0);
                            //errorMessageFactory.showErrorMessage('Option not available because you not have the right',0);
                            return false;
                        } else {
                            openPopUpForAdd($event);
                            return true;
                        }
                    }
                },
                function (errorPayload) {
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function openPopUpForAdd($event) {
            var parentEl = angular.element($document.body);
            $scope.errorFlag = false;
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/addDriverManually.html',
                locals: {
                    items: {}
                },
                bindToController: true,
                controller: AddDriverManually
            });

            function AddDriverManually($scope, $mdDialog, items) {
                $scope.items = items;
                var filterTextTimeout = '';
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };

                function stopRKey(evt) {
                    var evt = (evt) ? evt : ((event) ? event : null);
                    var node = (evt.target) ? evt.target : ((evt.srcElement) ? evt.srcElement : null);
                    if ((evt.keyCode == 13) && (node.type == "text")) {
                        return false;
                    }
                }

                $scope.searchVechile = function (data) {
                    if (data != null) {
                        var dataToSend = {};
                        dataToSend.search_id = data;
                        dataToSend.access_token = $cookies.get('obj');
                        var promise = getGeofence.SearchVechileByID(dataToSend);
                        promise.then(
                            function (payload) {
                                $log.log(payload);
                                vm.loading = false;
                                if (payload.title.status == 200) {
                                    if (payload && payload.title.data.length > 0) {
                                        $scope.errorFlag = false;
                                        $scope.dataPayload = payload.title.data[0];
                                        $scope.items.pointName2 = payload.title.data[0].name;
                                        $scope.items.pointName3 = payload.title.data[0].car_types;
                                    }
                                } else {
                                    $scope.items.pointName2 = '';
                                    $scope.items.pointName3 = '';
                                    $scope.errorFlag = true;
                                    $scope.errorMessage = payload.title.message;
                                }


                            },
                            function (errorPayload) {
                                $log.log(errorPayload);
                                vm.loading = false;
                                if (errorPayload.data.status == 401) {
                                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                                } else {
                                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                                }
                            }
                        )
                    }
                }
                document.onkeypress = stopRKey;
                $scope.confirmUpload = function () {
                    var dataToSend = {};
                    dataToSend.fleet_id = Number($scope.dataPayload.fleet_id);
                    dataToSend.unique_car_id = Number($scope.dataPayload.unique_car_id);
                    dataToSend.region_id = vm.dataToFill.iluuminatedId;
                    dataToSend.is_delete = 0;
                    dataToSend.access_token = $cookies.get('obj');
                    var promise = getGeofence.addDriverMaunally(dataToSend);
                    promise.then(
                        function (payload) {
                            $log.log(payload);
                            vm.loading = false;
                            if (payload && payload.title.status == 200) {
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                                $mdDialog.hide();
                                getIlluminatedZoneServices(vm.dataToFill.iluuminatedId);
                            } else {
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            }

                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    )
                };
            }
        }
        /////////////////////////////// DELETE DRIVER \////////////////////
        function deleteDriver(data, $event) {
            var promise = adminAccessService.checkStateValid('Add/Remove Cars of Illuminated Zone'); //$stateParams.id
            return promise.then(
                function (payload) {
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (!payload.title.data.granted) {
                            languageBasedErrorFactory.getProperErrorMessage('optionNotAvail', 0, 0);
                            //errorMessageFactory.showErrorMessage('Option not available because you not have the right',0);
                            return false;
                        } else {
                            openPopUpFordelete(data, $event);
                            return true;
                        }
                    }
                },
                function (errorPayload) {
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        //==================== SOCKET EVENT TO GET UPDATED PAX ON THIS ===================
        var myListener1 = $rootScope.$on('socketEventUpdatePax', function (evt, data) {
            console.log('>>>>>. IN SOCKET >>>>>', "socketEventUpdatePax" );
            if (data.res.message)
                data = data.res.message;
            var index = vm.driverList.findIndex(function (x) {
                return x.unique_car_id == data.unique_car_id;
            });
            if (vm.promise1) {
                $interval.cancel(vm.promise1);
            }
            if (index >= 0) {
                // vm.driverList[index].passenger_entry_time_formatted = '00:00'
                if (data.passenger_entry_time) {
                    /////////// TV-2631////////////////////////////
                    vm.promise1 = $interval(function () {
                        var countDownDate = new Date(data.passenger_entry_time).getTime();
                        var now = new Date().getTime();
                        var difference = now - countDownDate;
                        var hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                        var minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
                        var seconds = Math.floor((difference % (1000 * 60) / 1000));
                        if (hours <= 9) {
                            hours = '0' + hours;
                        }
                        if (minutes <= 9) {
                            minutes = '0' + minutes;
                        }
                        if (seconds <= 9) {
                            seconds = '0' + seconds;
                        }
                        vm.driverList[index].passenger_entry_time_formatted =
                            hours + ":" + minutes + ":" + seconds;

                    }, 1000);
                    /////////// TV-2631////////////////////////////
                } else {
                    vm.driverList[index].passenger_entry_time_formatted = '00:00';
                }
                vm.driverList[index].total_passengers = data.total_passengers;
                $scope.$apply();
            }
        });
        $scope.$on('$destroy', myListener1);
        //==================== SOCKET EVENT TO GET UPDATED PAX ON THIS ===================


        function openPopUpFordelete(data, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('deleteDriverPop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                vm.loading = true;
                var dataToSend = {};
                dataToSend.fleet_id = data;
                dataToSend.region_id = vm.dataToFill.iluuminatedId;
                dataToSend.is_delete = 1;
                dataToSend.access_token = $cookies.get('obj');
                var promise = getGeofence.addDriverMaunally(dataToSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        if (payload.title.status == 200) {
                            getIlluminatedZoneServices(vm.dataToFill.iluuminatedId);
                        } else {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                )
            }, function () {
                $log.log('not confirmed');
            });
        }
        /////////////////////////////// DELETE DRIVER \////////////////////


        /////////////////////////////// ADD VECHICLE MANUALLY /////////////
        // ============driver list===============
        function getDriverOfSelectedType(skip, limit, data, loading) {
            console.log(data, 'data');

            vm.countToSocket = vm.countToSocket + 1;
            var dataToSend = {};
            dataToSend.zone_id = data.iluuminatedId;
            dataToSend.vehicle_id = JSON.stringify(data.vehicleId);
            dataToSend.branch_id = data.branchId;
            dataToSend.limit = limit;
            dataToSend.offset = skip;
            dataToSend.access_token = $cookies.get('obj');
            vm.loading = loading;
            var promise = getGeofence.getDriverOfSelectedService(dataToSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.countToSocket = 0;
                    vm.loading = false;
                    vm.dataLength = payload.title.data.totalCount;
                    if (payload.title.data.totalCount == 0) {
                        vm.sp_pagination = false;
                        vm.tBodyFlag = false;
                        vm.tFootFlag = true;
                        vm.filterOn = true;
                        vm.skipValueFilter = 0;
                    } else {
                        vm.sp_pagination = true;
                        vm.tBodyFlag = true;
                        vm.tFootFlag = false;
                        vm.filterOn = false;
                        vm.skipValueFilter = 0;

                        var dataArray = [];

                        var driverList = payload.title.data.result;
                        driverList.forEach(function (column) {
                            var d = {};
                            d.unique_car_id = column.unique_car_id;
                            d.fleet_name = column.fleet_name;
                            d.entry_time = column.entry_time;
                            d.total_passengers = column.total_passengers;
                            d.passenger_entry_time_formatted = '00:00';
                            if (vm.promise1) {
                                $interval.cancel(vm.promise1);
                            }
                            if (column.passenger_entry_time) {
                                d.passenger_entry_time = column.passenger_entry_time;
                                // d.passenger_entry_time_formatted1 = (column.passenger_entry_time);
                                /////////// TV-2631////////////////////////////
                                vm.promise1 = $interval(function () {
                                    var countDownDate = new Date(column.passenger_entry_time).getTime();
                                    var now = new Date().getTime();
                                    var difference = now - countDownDate;
                                    var hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                                    var minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
                                    var seconds = Math.floor((difference % (1000 * 60) / 1000));
                                    if (minutes <= 9) {
                                        minutes = '0' + minutes;
                                    }
                                    if (hours <= 9) {
                                        hours = '0' + hours;
                                    }
                                    if (seconds <= 9) {
                                        seconds = '0' + seconds;
                                    }
                                    d.passenger_entry_time_formatted =
                                        hours + ":" + minutes + ":" + seconds;

                                }, 0);
                                /////////// TV-2631////////////////////////////
                            } else {
                                d.passenger_entry_time_formatted = '00:00';
                            }
                            d.action = column.action;
                            d.fleet_id = column.fleet_id;
                            dataArray.push(d);
                        });
                        vm.driverList = dataArray;

                        // if(vm.driverList && vm.driverList.length){
                        //    var interval = setInterval(function(){
                        //        for(var i=0;i<vm.driverList.length;i++){
                        //            if(vm.driverList[i].total_passengers == 0 || vm.driverList[i].total_passengers == '0' || !vm.driverList[i].total_passengers){
                        //                vm.driverList[i].passenger_entry_time_formatted = calculateTimeDifference(vm.driverList[i].passenger_entry_time)
                        //            }
                        //        }
                        //        $scope.$digest();
                        //    },60000);
                        // }

                        for (var i = 0; i < vm.driverList.length; i++) {
                            vm.driverList[i].index = (skip + i);
                        }
                        if (vm.dataLength <= vm.itemsPerPageGot) {
                            vm.sp_pagination = false;
                        } else {
                            vm.sp_pagination = true;
                            //vm.pageCount(payload.title.data.totalCount);
                        }
                        vm.skipValue = vm.driverList[0].index;
                        vm.limitValue = vm.driverList[vm.driverList.length - 1].index;

                        $scope.$watch('vm.search', function (newVal, oldVal) {
                            vm.filtered = filterFilter(vm.driverList, newVal);
                            vm.totalItems = vm.filtered.length;
                            if (vm.filtered.length == 0) {
                                vm.watchPagination = false;
                            } else {
                                vm.watchPagination = true;
                            }
                            if (vm.filterOn == true) {
                                vm.skipValueFilter = vm.filtered.length;
                                vm.sp_pagination = false;
                            }
                        }, true);

                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            )
        }

        // vm.isDivSelected = false;

        function activeButton(index, data) {
            vm.dataToFill.isDivSelected = index;
            vm.dataToFill.vehicleId = vm.illuminatedVehicles[vm.dataToFill.isDivSelected].id;
            getDriverOfSelectedType(0, vm.itemsPerPageGot, vm.dataToFill, true);

        }

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            vm.filterOn = true;
            if (vm.search.length == 0) {
                vm.filterOn = false;
                vm.watchPagination = true;
                vm.sp_pagination = true;
            }
        };

    }
})();
/**
 * Created by cl-macmini-51 on 21/02/18.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('IlluminatedZoneServicesLogController', IlluminatedZoneServicesLogController);

    /** @ngInject */
    function IlluminatedZoneServicesLogController($cookies, $state, $log, $rootScope, $timeout, getCars, $scope, filterFilter, $mdDialog, $document, getGeofence, languageBasedErrorFactory, errorMessageFactory, getFilters) {
        var vm = this;
        vm.currentPage = 0;
        vm.skipValueFilter = 0;
        vm.dataLength = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = false;
        vm.tFootFlag = true;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = true;
        vm.predicate = 'index';
        vm.reverse = false;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.getPagesCount = getPagesCount;
        vm.paginationNew = paginationNew;
        vm.branchChanged = branchChanged;
        vm.regionChanged = regionChanged;

        vm.countToSocket = 0;
        vm.dataToFill = {
            branchId: '',
            iluuminatedId: '',
            showRegions: false
        };

        vm.paginationChangedForBranch = paginationChangedForBranch;
        vm.branchSearch = branchSearch;
        vm.globalLimit = 10;
        vm.globalOffset = vm.globalLimit;
        vm.branchList = [];

        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'vehicle', 'service', 'agreement', 'corporatesList', 'operation_point'];
        vm.branchOffset = 0;

        // =================== FILTER OBJECT ===================
        vm.filterObject = {
            access_token: $cookies.get('obj'),
            branch_filter: 1,
            vehicle_filter: 0,
            service_filter: 0,
            agreement_filter: 0,
            corporate_filter: 0,
            service_category: 0,
            corporate_status: 0,
            agreement_status: 0,
            vehicle__status: 0,
            operation_point_filter: 0,
            branch_limit: vm.globalLimit,
            branch_offset: vm.branchOffset,
            branch_search_filter: 0,
            vehicle_search_filter: 0,
            service_search_filter: 0,
            agreement_search_filter: 0,
            corporate_search_filter: 0,
            operation_point_search_filter: 0
        }

        setTimeout(function () {
            document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                // if (vm.branchList && (vm.branchList.length == 0)) {
                vm.searchBranchData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

        })

        // =================== GET FILTER DATA ===================
        function getFilterDataFromBackend(data, type) { //Acc to Index ['branch_search', 'vehicle_search', 'service_search', 'agreement_search', 'corporate_search', 'operation_point_search']
            if (data) {
                vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
            } else {
                vm.filterObject = {
                    access_token: $cookies.get('obj'),
                    branch_filter: 1,
                    vehicle_filter: 0,
                    service_filter: 0,
                    agreement_filter: 0,
                    corporate_filter: 0,
                    service_category: 0,
                    corporate_status: 0,
                    agreement_status: 0,
                    vehicle__status: 0,
                    operation_point_filter: 0,
                    branch_search_filter: 0,
                    vehicle_search_filter: 0,
                    service_search_filter: 0,
                    agreement_search_filter: 0,
                    corporate_search_filter: 0,
                    operation_point_search_filter: 0
                }
            }

            vm.filterObject.branch_limit = vm.globalLimit;
            vm.filterObject.branch_offset = vm.branchOffset;

            var promise = getFilters.getAllFilterData(vm.filterObject);
            promise.then(
                function (payload) {

                    // ********** BRANCH DATA ********
                    if (payload.title.data.branches) {

                        angular.forEach(payload.title.data.branches.data, function (column) {
                            //CHECK FOR DUPLICATE ENTRY
                            var branchIndex = _.findIndex(vm.branchList, {
                                region_id: column.region_id
                            });
                            if (branchIndex == -1)
                                vm.branchList.push(column)
                        });
                        vm.branchTotalBackendCount = payload.title.data.branches.totalCount;
                    }

                    vm.loading = false;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        }
        getFilterDataFromBackend();

        // ************ PAGINATION ON BRANCH **************
        function paginationChangedForBranch() {
            var index = _.findIndex(vm[vm.searchFilterArray[0]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.branchTotalBackendCount > (vm.branchList.length - index)) {
                commonFunction(0);
                vm.branchOffset += 10;
                getFilterDataFromBackend(vm.searchBranchData, 0);
            }
        }
        // *********** COMMON FUNCTION FOR FILTER PAGINATION AND SEARCHING ***********
        function commonFunction(type, mode) {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                // vm['search' + vm.searchFilterArray[i] + 'Data'] = '';
                if (mode == 'search' || i != type) {
                    vm[vm.searchFilterArrayForClearArray[i]] = [];
                    vm[vm.searchFilterArray[i] + 'Offset'] = 0;
                    vm['search' + vm.searchFilterArray[i].substring(0, 1).toUpperCase() + vm.searchFilterArray[i].substring(1) + 'Data'] = '';
                }
            }
        }
        // ************ SEARCH BRANCH ***************
        function branchSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchBranchData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(0, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 0);
                }, 2000);
            }
        }

        //====================function for dropdown pages and page count===============
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];

        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            if (vm.dataToFill.iluuminatedId)
                getDriverOfSelectedType(0, vm.itemsPerPageGot, vm.dataToFill, true);
        };

        function paginationNew(page) {
            getDriverOfSelectedType((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.dataToFill, true);
        }

        // ===============get branches list all===============
        // function getBranches() {

        // vm.branchList = [];
        // vm.branchList = JSON.parse(JSON.stringify(getFilters.branchesFiltersData.data));

        // var promise = getGeofence.branch();
        // promise.then(
        //     function (payload) {
        //         $log.log(payload);
        //         vm.loading = false;
        //         if (payload.title.status == 400) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //         } else if (payload.title.status == 401) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //         } else if (payload.title.status == 201 || payload.title.status == 200) {
        //             if (payload.title.data.length) {
        //                 vm.branchList = _.where(payload.title.data, {
        //                     parent_id: 0
        //                 });
        //             } else {
        //                 vm.branchList = [];
        //             }
        //         }
        //     },
        //     function (errorPayload) {
        //         $log.log(errorPayload);
        // vm.loading = false;
        //         if (errorPayload.data.status == 401) {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //         } else {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //         }
        //     }
        // )

        // }
        // WHen Page refresh service take time to get data from backend
        // setTimeout(function () {
        //     getBranches();
        // }, 1000);

        // ******** CLEAR OFFSET *******
        function clearOffset() {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                vm[vm.searchFilterArray[i] + 'Offset'] = 0;
            }
        }

        function branchChanged() {
            getIlluminatedRegions(vm.dataToFill.branchId);
            vm.branchList = [];
            clearOffset();
            getFilterDataFromBackend();
            vm.dataToFill.iluuminatedId = '';
            vm.dataToFill.showRegions = true;
            vm.illuminatedRegionList = [];
            vm.sp_pagination = false;
            vm.tBodyFlag = false;
            vm.tFootFlag = true;
            vm.filterOn = true;
            vm.skipValueFilter = 0;
            vm.dataLength = 0;
            vm.driverList = [];
        }

        // ================get illuminated regions================
        function getIlluminatedRegions(branchId) {
            var dataToSend = {};
            dataToSend.branch_id = branchId;
            dataToSend.access_token = $cookies.get('obj');

            var promise = getGeofence.getilluminatedRegionsList(dataToSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.data.data.length) {
                        vm.illuminatedRegionList = payload.title.data.data;
                    } else {
                        vm.illuminatedRegionList = [];
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            )
        }

        function regionChanged() {
            getDriverOfSelectedType(0, vm.itemsPerPageGot, vm.dataToFill, true);
        }

        // ============driver list===============
        function getDriverOfSelectedType(skip, limit, data, loading) {
            var dataToSend = {};
            dataToSend.zone_id = data.iluuminatedId;
            dataToSend.limit = limit;
            dataToSend.offset = skip;
            dataToSend.access_token = $cookies.get('obj');
            vm.loading = loading;
            var promise = getGeofence.getDriverOfSelectedServiceLogs(dataToSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.countToSocket = 0;
                    vm.loading = false;
                    vm.dataLength = payload.title.data.totalCount;
                    if (payload.title.data.totalCount == 0) {
                        vm.sp_pagination = false;
                        vm.tBodyFlag = false;
                        vm.tFootFlag = true;
                        vm.filterOn = true;
                        vm.skipValueFilter = 0;
                    } else {
                        vm.sp_pagination = true;
                        vm.tBodyFlag = true;
                        vm.tFootFlag = false;
                        vm.filterOn = false;
                        vm.skipValueFilter = 0;

                        var dataArray = [];

                        var driverList = payload.title.data.result;
                        driverList.forEach(function (column) {
                            var d = {};
                            d.branch_name = column.branch_name;
                            d.car_id = column.car_id;
                            d.entry_time = column.entry_time;
                            d.flag = column.flag;
                            d.job_id = column.job_id;
                            d.position = column.position;
                            d.region_id = column.region_id;
                            d.region_name = column.region_name;
                            d.total_passengers = column.total_passengers;
                            d.action = column.action;
                            d.email =  column.email;
                            dataArray.push(d);
                        });
                        vm.driverList = dataArray;

                        for (var i = 0; i < vm.driverList.length; i++) {
                            vm.driverList[i].index = (skip + i);
                        }
                        if (vm.dataLength <= vm.itemsPerPageGot) {
                            vm.sp_pagination = false;
                        } else {
                            vm.sp_pagination = true;
                            //vm.pageCount(payload.title.data.totalCount);
                        }
                        vm.skipValue = vm.driverList[0].index;
                        vm.limitValue = vm.driverList[vm.driverList.length - 1].index;

                        $scope.$watch('vm.search', function (newVal, oldVal) {
                            vm.filtered = filterFilter(vm.driverList, newVal);
                            vm.totalItems = vm.filtered.length;
                            if (vm.filtered.length == 0) {
                                vm.watchPagination = false;
                            } else {
                                vm.watchPagination = true;
                            }
                            if (vm.filterOn == true) {
                                vm.skipValueFilter = vm.filtered.length;
                                vm.sp_pagination = false;
                            }
                        }, true);

                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            )
        }

        // vm.isDivSelected = false;

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            vm.filterOn = true;
            if (vm.search.length == 0) {
                vm.filterOn = false;
                vm.watchPagination = true;
                vm.sp_pagination = true;
            }
        };

    }
})();
/**
 * Created by cl-macmini-51 on 23/02/18.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('HomeScreenController', HomeScreenController);

    /** @ngInject */
    function HomeScreenController($rootScope, mapDashboard, $cookies, errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        if ($rootScope.socket.connected == false || $rootScope.socket.connected == 'false') {
            $rootScope.socket.connect();
        }
        vm.userType = JSON.parse($cookies.get('adminType') || 0) == 1;
        ////////// GET DATA FROM HOME SCREEN //////////////////
        function getHomeScreenDataApi() {
            var dataToSend = {
                access_token: $cookies.get('obj')
            };
            vm.loading = true;
            vm.urlInIframe = '';
            var promise = mapDashboard.getHomeScreenData(dataToSend);
            promise.then(
                function (payload) {
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        if (JSON.parse($cookies.get('adminType') || 0) == 0) {
                            if (payload && payload.title.data.data.length > 0) {
                                vm.isActive = payload.title.data.data[1].is_active;
                                setTimeout(function () {
                                    document.getElementById("iframeNormal").src = payload.title.data.data[1].link;
                                }, 0)
                            }
                        } else {
                            if (payload && payload.title.data.data.length > 0) {
                                // vm.urlInIframe = payload.title.data.data[0].link;
                                vm.isActive = payload.title.data.data[0].is_active;
                                setTimeout(function () {
                                    document.getElementById("iframePet").src = payload.title.data.data[0].link;
                                }, 0)
                            }
                        }
                        console.log(document.getElementById("iframePet"), ' document.getElementById("iframePet")');

                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    console.log(vm.urlInIframe, 'vm.urlInIframe ');

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        getHomeScreenDataApi();
    }

})();
/**
 * Created by cl-macmini-51 on 12/12/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('EditHelpDocumentsController', EditHelpDocumentsController);

    /** @ngInject */
    function EditHelpDocumentsController($cookies, $state, $log, $filter, $rootScope, $mdDialog, $timeout, $document,
                                        $scope, filterFilter,moment,errorMessageFactory,languageBasedErrorFactory,textAngularManager,helpDocumentService,$stateParams) {
        var vm = this;
        $log.log('add help docs');
        vm.loading = false;
        vm.dataToFill = {
            notes: '',
            documentName: '',
            documentType: $stateParams.type,
            userType: $stateParams.userType,
            documentTypes: [],
            documentId: '',
            selectedLanguage: $stateParams.lang
        }

        vm.updateDocumentApi = updateDocumentApi;
        vm.goBack = goBack;

        //=====================get document=======================
        function getDocuments(){
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.document_type =  vm.dataToFill.documentType;
            dataSend.user_type =  vm.dataToFill.userType == 'CUSTOMER'?1:0;
            dataSend.language_key = vm.dataToFill.selectedLanguage=='en'?0:1;
            vm.loading = true;
            var promise = helpDocumentService.getDocument(dataSend);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    vm.dataToFill.documentName = payload.title.data.data[0].document_name;
                    vm.dataToFill.documentId = payload.title.data.data[0].document_id;
                    vm.dataToFill.notes = payload.title.data.data[0].html_data;
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        }
        getDocuments();

        //==================get document names======================
        function documentName() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.user_type = 0;
            vm.loading = true;
            var promise = helpDocumentService.getDocumentName(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if(payload.title.data && payload.title.data.documents.length){
                        vm.dataToFill.documentTypes =  payload.title.data.documents;
                    }
                    else{
                        vm.dataToFill.documentTypes = [];
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        documentName();

        //=====================submit details=======================
        function updateDocumentApi(){
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.document_id = vm.dataToFill.documentId;
            dataSend.language_key = vm.dataToFill.selectedLanguage=='en'?0:1;
            dataSend.html_data = vm.dataToFill.notes;
            dataSend.user_type =  vm.dataToFill.userType == 'CUSTOMER'?1:0;
            vm.loading = true;
            var promise = helpDocumentService.updateDocument(dataSend);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    languageBasedErrorFactory.getProperErrorMessage('documentUpdatedSucc',0,2,'layout.helpDocMain.helpDocs');
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        }
        //===============go back===============
        function goBack(){
            $state.go('layout.helpDocMain.helpDocs')
        }
    }

})();
/**
 * Created by cl-macmini-51 on 12/12/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('HelpDocumentsController', HelpDocumentsController);

    /** @ngInject */
    function HelpDocumentsController($cookies, $state, $log, $filter, $rootScope, $mdDialog, $timeout, $document, $scope, filterFilter,moment,errorMessageFactory,languageBasedErrorFactory,helpDocumentService) {
        var vm = this;
        $log.log('help docs');
        vm.loading = false;
        vm.dataToFill = {
            selectedLanguage: 'es',
            documentName: '',
            userType: 'CUSTOMER',
            documentList: []
        };

        vm.getAllDocuments = getAllDocuments;


        //=====================get document=======================
        function getAllDocuments(){
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            if(vm.dataToFill.documentName)
                dataSend.name = vm.dataToFill.documentName;
            dataSend.user_type = vm.dataToFill.userType == 'CUSTOMER'?1:0;
            dataSend.language_key = vm.dataToFill.selectedLanguage=='en'?0:1;
            vm.loading = true;
            var promise = helpDocumentService.getDocument(dataSend);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if(payload.title.data && payload.title.data.data.length){
                        vm.dataToFill.documentList = payload.title.data.data;
                    }
                    else{
                        vm.dataToFill.documentList = [];
                    }
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        }
        getAllDocuments();
    }

})();
/**
 * Created by cl-macmini-51 on 12/12/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('AddHelpDocumentsController', AddHelpDocumentsController);

    /** @ngInject */
    function AddHelpDocumentsController($cookies, $state, $log, $filter, $rootScope, $mdDialog, $timeout, $document,
                                        $scope, filterFilter,moment,errorMessageFactory,languageBasedErrorFactory,textAngularManager,helpDocumentService) {
        var vm = this;
        $log.log('add help docs');
        vm.loading = false;
        vm.dataToFill = {
            notes: '',
            documentName: '',
            documentType: '',
            userType: '',
            documentTypes: [],
            selectedLanguage: ''
        }

        vm.registerNewDocument = registerNewDocument;
        vm.goBack = goBack;

        //==================get document names======================
        function documentName() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.user_type = 0;
            vm.loading = true;
            var promise = helpDocumentService.getDocumentName(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if(payload.title.data && payload.title.data.documents.length){
                        vm.dataToFill.documentTypes =  payload.title.data.documents;
                    }
                    else{
                        vm.dataToFill.documentTypes = [];
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        documentName();
        //=====================submit details=======================
        function registerNewDocument() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.name = vm.dataToFill.documentName;
            dataSend.document_type = vm.dataToFill.documentType;
            dataSend.user_type = vm.dataToFill.userType == 'CUSTOMER'?1:0;
            dataSend.language_key = vm.dataToFill.selectedLanguage == 'en' ? 0 : 1;
            dataSend.html_data = vm.dataToFill.notes;
            vm.loading = true;
            var promise = helpDocumentService.addDocument(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    languageBasedErrorFactory.getProperErrorMessage('documentAddedSucc', 0, 2, 'layout.helpDocMain.helpDocs');
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        //===============go back===============
        function goBack(){
            $state.go('layout.helpDocMain.helpDocs')
        }
    }

})();
/**
 * Created by cl-macmini-51 on 08/03/18.
 */


(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('GroupedRouteAssignmentController', GroupedRouteAssignmentController);

    /** @ngInject */
    function GroupedRouteAssignmentController($cookies, $state, $http, MY_CONSTANT, $log, $rootScope, $mdDialog, $timeout, $document, $scope, $q, filterFilter, languageBasedErrorFactory,
        errorMessageFactory, hidePublicPlaces, adminAccessService, globalParams, checkDomain, RutHelper, getGeofence, getAgreement, getServices, $filter, groupedRouteAssignment, sharedRouteAssignment, sharedRouteAssignmentHereMaps, getFilters, Initializer) {
        var vm = this;
        vm.loading = false;
        vm.parentDragStart = false;
        vm.setFlagInJob = setFlagInJob;
        vm.blockUnblockBooking = blockUnblockBooking;
        vm.VolverButton = VolverButton;
        vm.SelectAll = SelectAll;
        vm.SelectAllBookings = SelectAllBookings;
        vm.UpdateSelection = UpdateSelection;
        vm.DiscardGroup = DiscardGroup;
        vm.ResetSelection = ResetSelection;
        vm.ClearAllSelections = ClearAllSelections;
        vm.ExportDetailToExcel = ExportDetailToExcel;
        vm.SelectAllCreatedBookings = SelectAllCreatedBookings;
        vm.ClearCreatedSelections = ClearCreatedSelections;
        vm.socketCount = 0;
        vm.branchChanged = branchChanged;
        vm.dateOptions = {};
        vm.UnassignedList = UnassignedList;
        vm.datePicker_1 = {
            pickupFromDate: false,
            pickupToDate: false,
            pickupFromDatePackage: false,
            pickupToDatePackage: false,
        };
        vm.checkClickedPackage = true
        vm.selectDisabled = true;
        vm.seleccionar_reserva = seleccionarReserva;
        vm.getPackageSection = getPackageSection;
        var myCenter;
        var infowindow;
        var trafficLayer;
        var bounds;
        var directionsService;
        var directionsDisplay;

        // Service To Get Map Instance
        Initializer.mapsInitialized
            .then(function () {
                if (google) {
                    myCenter = new google.maps.LatLng(-33.447487, -70.673676);
                    infowindow = new google.maps.InfoWindow({
                        size: new google.maps.Size(150, 50)
                    });
                    trafficLayer = new google.maps.TrafficLayer();
                    bounds = new google.maps.LatLngBounds();
                    directionsService = new google.maps.DirectionsService;
                    directionsDisplay = new google.maps.DirectionsRenderer;

                    google.maps.event.addListener(infowindow, 'domready', function () {
                        var iwOuter = $('.gm-style-iw');
                        var map = $('.gm-ui-hover-effect');

                        var iwBackground = iwOuter.prev();
                        //$('.gm-style-iw').parent().css({'left': '-145px !important'});
                        iwOuter.css({
                            top: '36px',
                            left: '20px'
                        });
                        iwOuter.children().children(':nth-child(1)').css({
                            'overflow': 'hidden',
                            padding: '0px 18px 0px 18px'
                        });

                        // Remove the background shadow DIV
                        iwBackground.children(':nth-child(2)').css({
                            'display': 'none'
                        });
                        // Remove the white background DIV
                        iwBackground.children(':nth-child(4)').css({
                            'display': 'none'
                        });
                        //iwOuter.parent().parent().css({ left: '115px' });
                        //// Moves the shadow of the arrow 76px to the left margin
                        //iwBackground.children(':nth-child(1)').attr('style', function (i, s) { return s + 'left: 76px !important;' });
                        //// Moves the arrow 76px to the left margin
                        //iwBackground.children(':nth-child(3)').attr('style', function (i, s) { return s + 'left: 76px !important;' });
                        iwBackground.children(':nth-child(3)').find('div').children().css({
                            'background-color': 'cornsilk',
                            'box-shadow': 'none'
                        });
                        var iwCloseBtn = iwOuter.next();
                        // Apply the desired effect to the close button
                        iwCloseBtn.css({
                            top: '38px',
                            right: '44px', // button repositioning
                            // backgound: 'white',
                            width: '20px',
                            height: '22px'
                        });
                        map.css({
                            background: 'white',
                            opacity: 1
                        })
                        map.children().css({
                            margin: '4px'
                        });
                        // The API automatically applies 0.7 opacity to the button after the mouseout event.
                        // This function reverses this event to the desired value.
                        iwCloseBtn.mouseout(function () {
                            $(this).css({
                                opacity: '1'
                            });
                        });
                        $('#assignToRoute').off('click').on('click', function (event) {
                            vm.bookingsAssignmentTab = true;
                            vm.servicesCreatedTab = false;
                            vm.lowerTabsBody = true;
                            if (vm.discardBookingStatus) {
                                errorMessageFactory.showErrorMessage('This booking is discarded. Please undo the booking and then try', 0);
                            } else {
                                assignToPackageFromMap(vm.jobIdOfMarker);
                                // toValidateAllBookings(vm.jobIdOfMarker)
                            }
                        });
                    });
                    // FOR BOOKING FILTER
                    if (($cookies.get('groupBranch')) && ($cookies.get('group_type_of_service')) && ($cookies.get('group_type_of_trip')) && ($cookies.get('groupContract_id'))) {
                        getGroupedOnly(false, vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_to_date_value, 'scroll');
                        // getGroupedPackageList('noScroll', false);
                        vm.filterData.filterApplied = true;
                        // vm.filterData.filterAppliedService = true;
                        if (vm.mapViewTab) {
                            $timeout(function () {
                                initialize();
                                directionsDisplay.setMap(null);
                            })
                        }
                    }
                    // FOR PACKAGE FILTER
                    if (($cookies.get('groupBranchPackage')) && ($cookies.get('group_type_of_service_package')) && ($cookies.get('group_type_of_trip_package')) && ($cookies.get('groupContract_id_package'))) {
                        // getGroupedOnly(false, vm.filt÷erData.filter_pickup_from_date_value, vm.filterData.filter_pickup_to_date_value, 'scroll');
                        if (vm.filterData.filter_pickup_from_date_value_package && vm.filterData.filter_pickup_from_time_value_package) {
                            var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value_package, vm.filterData.filter_pickup_from_time_value_package);
                        }
                        if (vm.filterData.filter_pickup_to_date_value_package && vm.filterData.filter_pickup_to_time_value_package) {
                            var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value_package, vm.filterData.filter_pickup_to_time_value_package);
                        }
                        getGroupedPackageList('noScroll', false, pickFromDate, pickToDate);
                        // vm.filterData.filterApplied = true;
                        vm.filterData.filterAppliedService = true;
                        // if (vm.mapViewTab) {
                        //     $timeout(function () {
                        //         initialize();
                        //         directionsDisplay.setMap(null);
                        //     })
                        // }
                    }
                } else {
                    alert(languageBasedErrorFactory.getProperErrorMessage('onRoadMessage', 0, '3'));
                }

            });

        vm.altInputFormats = ['M!/d!/yyyy'];
        vm.changeTime = changeTime;
        vm.changeDropTime = changeDropTime;
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.hstep = 1;
        vm.mstep = 15;
        vm.ismeridian = true;
        vm.filterData = {
            branch_value: '',
            aggrement_value: '',
            service_value: '',
            filter_pickup_from_date_value: '',
            filter_pickup_from_time_value: '',
            filter_pickup_to_date_value: setToPickupDate(),
            filter_pickup_to_time_value: showFilterTime(2),
            serviceDetailsSelected: '',
            typeOfTrip: '',
            filterApplied: false,
            unassignedBookingCount: 0,
            unassignedBookingCountShow: 0,
            unassignedSkip: 0,
            unassignedLimit: 10,
            unassignedLimitMade: 10,
            unassignedBookingList: [],
            unassignedPredicate: 'index',
            unassignedReverse: false,
            dropLocationArray: [],
            makePackagePredicate: 'index',
            makePackageReverse: false,
            makePackageList: [],
            selectedDiscard: [],
            makePackageCount: 0,
            totalPassengerAssigned: 0,
            selectedExport: [],
            totalBookingAssigned: 0,
            totalAssignedETA: 0,
            createdPredicate: 'index',
            createdReverse: false,
            createdSkip: 0,
            createdLimit: 15,
            createdBookingCount: 0,
            createdBookingList: [],
            sharedServiceName: 'NEW',
            vehicleAssigned: 'PENDING',
            modifyFlag: false,
            typeOfTripModify: '',
            globalDistance: 0,
            commonPickUp: false,

            branch_value_package: '',
            aggrement_value_package: '',
            service_value_package: '',
            filter_pickup_from_date_value_package: '',
            filter_pickup_from_time_value_package: '',
            filter_pickup_to_date_value_package: setToPickupDate(),
            filter_pickup_to_time_value_package: showFilterTime(2),
            typeOfTripPackage: '',
        };
        vm.service = [];
        vm.discardBookingStatus = false;
        vm.flightSearchModel = '';
        vm.nominaSearchModel = '';
        vm.comunaSearchModel = '';
        if ($cookies.get('groupBranch')) {
            vm.filterData.branch_value = JSON.parse($cookies.get('groupBranch'));
        }
        if ($cookies.get('groupBranchPackage')) {
            vm.filterData.branch_value_package = JSON.parse($cookies.get('groupBranchPackage'));
        }
        if ($cookies.get('group_type_of_service')) {
            vm.filterData.service_value = JSON.parse($cookies.get('group_type_of_service'));
        }
        if ($cookies.get('group_type_of_service_package')) {
            vm.filterData.service_value_package = JSON.parse($cookies.get('group_type_of_service_package'));
        }
        if ($cookies.get('group_type_of_trip')) {
            vm.filterData.typeOfTrip = $cookies.get('group_type_of_trip');
        }

        if ($cookies.get('group_type_of_trip_package')) {
            vm.filterData.typeOfTripPackage = $cookies.get('group_type_of_trip_package');
        }
        if ($cookies.get('groupContract_id')) {
            vm.filterData.aggrement_value = JSON.parse($cookies.get('groupContract_id'));
        }
        if ($cookies.get('groupContract_id_package')) {
            vm.filterData.aggrement_value_package = JSON.parse($cookies.get('groupContract_id_package'));
        }
        if ($cookies.get('groupPickUpDate')) {
            vm.filterData.filter_pickup_from_date_value = new Date($cookies.get('groupPickUpDate')) || new Date();
        } else {
            vm.filterData.filter_pickup_from_date_value = new Date();
        }
        if ($cookies.get('groupPickUpDatePackage')) {
            vm.filterData.filter_pickup_from_date_value_package = new Date($cookies.get('groupPickUpDatePackage')) || new Date();
        } else {
            vm.filterData.filter_pickup_from_date_value_package = new Date();
        }
        if ($cookies.get('groupPickDateto')) {
            vm.filterData.filter_pickup_to_date_value = new Date($cookies.get('groupPickDateto')) || new Date();
        } else {
            vm.filterData.filter_pickup_to_date_value = new Date();
        }
        if ($cookies.get('groupPickDatetoPackage')) {
            vm.filterData.filter_pickup_to_date_value_package = new Date($cookies.get('groupPickDatetoPackage')) || new Date();
        } else {
            vm.filterData.filter_pickup_to_date_value_package = new Date();
        }
        if ($cookies.get("group_type_of_service_package.name")); {
            vm.nameForShow = $cookies.get('group_type_of_service_package.name');
        }
        if ($cookies.get("group_type_of_service_package.max")) {
            vm.maxForShow = $cookies.get('group_type_of_service_package.max');
        }
        if ($cookies.get('groupPickTime')) {
            vm.filterData.filter_pickup_from_time_value = new Date($cookies.get('groupPickTime')) || new Date(new Date().setHours(0, 0, 0, 0));
        } else {
            vm.filterData.filter_pickup_from_time_value = new Date(new Date().setHours(0, 0, 0, 0));
        }
        if ($cookies.get('groupPickTimePackage')) {
            vm.filterData.filter_pickup_from_time_value_package = new Date($cookies.get('groupPickTimePackage')) || new Date(new Date().setHours(0, 0, 0, 0));
        } else {
            vm.filterData.filter_pickup_from_time_value_package = new Date(new Date().setHours(0, 0, 0, 0));
        }
        if ($cookies.get('groupDropTime')) {
            vm.filterData.filter_pickup_to_time_value = new Date($cookies.get('groupDropTime')) || new Date(new Date().setHours(23, 59, 0, 0));
        } else {
            vm.filterData.filter_pickup_to_time_value = new Date(new Date().setHours(23, 59, 0, 0));
        }
        if ($cookies.get('groupDropTimePackage')) {
            vm.filterData.filter_pickup_to_time_value_package = new Date($cookies.get('groupDropTimePackage')) || new Date(new Date().setHours(23, 59, 0, 0));
        } else {
            vm.filterData.filter_pickup_to_time_value_package = new Date(new Date().setHours(23, 59, 0, 0));
        }
        vm.initializeMap = initializeMap;
        var unassignLength = 0;
        vm.countToSocket = 0;
        vm.typeTripFilter = [{
                text: 'From Airport',
                id: 'Z'
            },
            {
                text: 'To Airport',
                id: 'R'
            },
            {
                text: 'Point to Point',
                id: 'P'
            }
        ];
        vm.mapViewTab = false;
        vm.unassignedBookingsTab = true;
        vm.servicesCreatedTab = true;
        vm.bookingsAssignmentTab = false;
        vm.upperTabsBody = true;
        vm.lowerTabsBody = true;
        // filter booking_id, package_id, vehicle_number
        vm.serviceFilterData = serviceFilterData;
        var markers = [];
        var map = null;
        var icon = null;

        vm.slideData = slideData;
        vm.slideDataPackage = slideDataPackage;
        vm.datePickerE_1 = datePickerE_1;
        vm.applyFilter = applyFilter;
        vm.applyFilterServices = applyFilterServices;
        vm.resetFilter = resetFilter;
        vm.serviceChanged = serviceChanged;
        //vm.dropedArea = dropedArea;
        //vm.dropedAreaBack = dropedAreaBack;
        //vm.onDragstart = onDragstart;
        vm.paginationChangedForUnassigned = paginationChangedForUnassigned;
        vm.calculateDataAndValidatePackage = calculateDataAndValidatePackage;
        vm.saveGroupPackage = saveGroupPackage;
        vm.newPackage = newPackage;
        vm.paginationChangedForCreated = paginationChangedForCreated;
        vm.assignBookings = assignBookings;
        // vm.paginationChangedForService = paginationChangedForService;
        vm.unassignBooking = unassignBooking;
        vm.modifyBooking = modifyBooking;
        vm.deletePackage = deleteBooking;
        vm.saveModifyGroupPackage = saveModifyGroupPackage;

        vm.discardBookingStatusChange = discardBookingStatusChange;
        vm.discardBooking = discardBooking;
        vm.searchFilter = searchFilter;
        vm.enviarVoucher = enviarVoucher;

        vm.unassignedBookingListLoading = true;

        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();


        /////////////////////////////// check FIlter is Equal Or Not //////////////////////////
        function checkStatus(bookingArray) {
            console.log('>>>>>> IN checkStatus >>>', bookingArray, vm.filterData);
            var flagStatus = false;
            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            var DatetoSend = new Date(date_time_value2).getTime();
            var dateFrom = new Date(date_time_value1).getTime();
            var dateTo = DatetoSend;
            var booking_date = bookingArray.job_time_utc;
            booking_date = new Date(booking_date).getTime();
            if (vm.filterData.branch_value == bookingArray.branch_id) {
                if (vm.filterData.aggrement_value == bookingArray.contract_id) { // aggreement id is always same as filter
                    if (vm.filterData.service_value == bookingArray.service_id) { // service id is always same as filter
                        if (vm.filterData.typeOfTrip == bookingArray.type_of_trip) { // type of trip is always same as filter
                            if (dateFrom <= booking_date && booking_date <= dateTo) { // the booking is come always betwwen the date filters
                                if (bookingArray.job_status == 6) { // for uniassign booking always come
                                    return true;
                                }
                            }
                        }
                    }
                }
            }
            return flagStatus;
        }

        // ************* CHECK PACKAGE DETAILS WITH FILTER ************
        function checkStatusPackage(bookingArray) {
            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value_package, vm.filterData.filter_pickup_from_time_value_package);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value_package, vm.filterData.filter_pickup_to_time_value_package);
            var DatetoSend = new Date(date_time_value2).getTime();
            var dateFrom = new Date(date_time_value1).getTime();
            var booking_date = bookingArray.job_time_utc;
            booking_date = new Date(booking_date).getTime();
            if (vm.filterData.branch_value_package == bookingArray.branch_id) { // BRANCH ID IS SAME AS FILTER
                if (vm.filterData.aggrement_value_package == bookingArray.contract_id) { // aggreement id is always same as filter
                    if (vm.filterData.service_value_package == bookingArray.service_id) { // service id is always same as filter
                        if (vm.filterData.typeOfTripPackage == bookingArray.type_of_trip) { // type of trip is always same as filter
                            if (dateFrom <= booking_date && booking_date <= DatetoSend) { // the booking is come always betwwen the date filters
                                return true;
                            }
                        }
                    }
                }
            }
            return false;
        }

        //====================socket connection===================
        var myListener = $rootScope.$on('SocketComesUpcoming', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data && data.res && data.res.message && data.res.message.jobArray.length > 0) {
                var loopArray = data.res.message.jobArray;
                loopArray.forEach(function (data) {
                    if (checkStatus(data) && vm.socketCount >= 100) {
                        vm.socketCount = '100+';
                    } else if (checkStatus(data)) {
                        vm.socketCount += 1;
                    }
                });
                $scope.$apply();
            }

        });

        /////////////////// VolverButton ////////////////////
        function VolverButton() {
            // vm.filterData.unassignedBookingList = [];
            if (vm.filterData.filter_pickup_from_date_value && vm.filterData.filter_pickup_from_time_value) {
                var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            }
            if (vm.filterData.filter_pickup_to_date_value && vm.filterData.filter_pickup_to_time_value) {
                var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            }
            vm.socketCount = 0;
            vm.filterData.unassignedLimit = 10;
            vm.filterData.unassignedSkip = 0;
            getGroupedOnly(false, pickFromDate, pickToDate, 'Unscroll');
        }


        /////////////////// Discard Masive Contracts ////////////////////
        function UpdateSelection(booking) {
            console.log('SELECCION', booking);
        }

        function SelectAll() {
            if (vm.filterData.unassignedBookingList && vm.filterData.unassignedBookingList.length > 0) {
                var validList = vm.filterData.unassignedBookingList.filter(function(booking) {
                    return booking.discard_from_group === 0;
                });
                if(validList && validList.length > 0){
                    var reservasNoSeleccionadas = validList.filter(function(booking) {
                        return !vm.filterData.selectedDiscard.some(function(selectedBooking) {
                            return selectedBooking.job_id === booking.job_id;
                        });
                    });

                    // var reservasNoSeleccionadas = vm.filterData.unassignedBookingList.filter(function(objeto) {
                    //     return objeto.selected != true;
                    //   });

                    if (reservasNoSeleccionadas.length === 0) {
                        errorMessageFactory.showErrorMessage('Todas las reservas ya están seleccionadas.', 0);
                        return;
                    }

                    reservasNoSeleccionadas.forEach(function(booking) {
                        booking.selected = true;
                    });
                    vm.selectDisabled = false;
                    vm.bookingsAssignmentTab = true;
                    vm.servicesCreatedTab = false;
                    vm.lowerTabsBody = true;

                    vm.filterData.selectedDiscard = vm.filterData.selectedDiscard.concat(reservasNoSeleccionadas);

                    // if (vm.filterData.makePackageList.length > 0) {
                    //     vm.filterData.filterAppliedService = true;
                    //     $('#packageFilter').hide();
                    // }

                    $timeout(function () {
                        //toValidateAllBookings(reservasNoSeleccionadas);
                    }, 100);

                    if(!$scope.$$phase) $scope.$apply();
                } else {
                    errorMessageFactory.showErrorMessage('No hay reservas disponibles para seleccionar.', 0);
                }
            } else {
                errorMessageFactory.showErrorMessage('No hay reservas disponibles para seleccionar.', 0);
            }
        }

        function SelectAllBookings() {
            if (vm.filterData.unassignedBookingList && vm.filterData.unassignedBookingList.length > 0) {
                vm.filterData.unassignedBookingList.forEach(function(booking) {
                    booking.selected = true;
                });
            }  
        }

        function ClearAllSelections() {
            if (vm.filterData.unassignedBookingList && vm.filterData.unassignedBookingList.length > 0) {
                vm.filterData.unassignedBookingList.forEach(function(booking) {
                    booking.selected = false;
                });
                vm.selectDisabled = false;
                vm.bookingsAssignmentTab = true;
                vm.servicesCreatedTab = false;
                vm.lowerTabsBody = true;

                vm.filterData.selectedDiscard = vm.filterData.selectedDiscard.concat(reservasNoSeleccionadas);

                // if (vm.filterData.makePackageList.length > 0) {
                //     vm.filterData.filterAppliedService = true;
                //     $('#packageFilter').hide();
                // }

                $timeout(function () {
                    //toValidateAllBookings(reservasNoSeleccionadas);
                }, 100);

                if(!$scope.$$phase) $scope.$apply();
            } else {
                errorMessageFactory.showErrorMessage('No hay reservas disponibles para seleccionar.', 0);
            }
        }
        
        function DiscardGroup(){
            var hasSelection = vm.filterData.selectedDiscard.some(function (booking) {
                return booking.selected;
            });
  
            if (!hasSelection) {
                alert("Por favor, seleccione al menos una reserva para descartar.");
                return;
            }
  
            var mensajeDescarte = "¿Desea descartar las "+ vm.filterData.selectedDiscard.length +" reservas seleccionadas para que no sean agrupadas?";
            if(vm.filterData.selectedDiscard.length == 1){
                mensajeDescarte = "¿Desea descartar la reserva seleccionada para que no sea agrupada?";
            }
  
            var confirm = $mdDialog
              .confirm()
              .title(mensajeDescarte)
              .textContent("")
              .ariaLabel("Lucky day")
              .targetEvent()
              .ok("Confirmar")
              .cancel("Cerrar");
  
            $mdDialog.show(confirm).then(function () {
                var discardPromises = [];
                vm.filterData.selectedDiscard.forEach(function (data) {
                    if (data.selected) {
                        var dataSend = {
                            access_token: $cookies.get('obj'),
                            job_id: data.job_id,
                            discard_flag: 1 // 1 para descartar la reserva de la agrupación
                        };
                        vm.loading = true;
                        // Guarda todas las promesas en un arreglo
                        discardPromises.push(groupedRouteAssignment.discardBooking(dataSend));
                    }
                });

                $q.all(discardPromises).then(function () {
                    vm.loading = false;
                    $mdDialog.show(
                        $mdDialog
                        .alert()
                        .clickOutsideToClose(true)
                        .title("Éxito")
                        .textContent("Todas las reservas seleccionadas han sido descartadas con éxito.")
                        .ariaLabel("Mensaje de éxito")
                        .ok("Entendido")
                    );
                    eliminarElementosDescartados();
                }).catch(function (error) {
                    console.error("error al descartar",error);
                    $mdDialog.show(
                    $mdDialog
                        .alert()
                        .clickOutsideToClose(true)
                        .title("Error")
                        .textContent("Ocurrió un error al descartar las reservas. Intente de nuevo.")
                        .ariaLabel("Mensaje de error")
                        .ok("Entendido")
                    );
                    vm.loading = false;
                });

            }, function() {
                vm.loading = false;
            });
        }

        function eliminarElementosDescartados() {
            // var newArraySecundario = vm.filterData.unassignedBookingList.filter(function(es) {
            //     return !vm.filterData.selectedDiscard.some(function(ep) {
            //         return ep.job_id === es.job_id;
            //     });
            // });
          
            vm.filterData.selectedDiscard.length = 0;
            //Array.prototype.push.apply(vm.filterData.unassignedBookingList, newArraySecundario);
            if(vm.filterData.selectedDiscard.length > 0){
                vm.selectDisabled = false;
            } else {
                vm.selectDisabled = true;
            }
        }

        function ResetSelection() {
            if (vm.filterData.selectedDiscard && vm.filterData.selectedDiscard.length > 0) {  

                if (vm.filterData.selectedDiscard.length === 0) {
                    errorMessageFactory.showErrorMessage('Todas las reservas ya no están seleccionadas.', 0);
                    return;
                }

                for (var i = 0; i < vm.filterData.unassignedBookingList.length; i++) {
                    var objetoPrincipal = vm.filterData.unassignedBookingList[i];
                    var objetoEncontradoIndex = vm.filterData.selectedDiscard.findIndex(function(objeto) {
                      return objeto.job_id === objetoPrincipal.job_id;
                    });
                  
                    if (objetoEncontradoIndex !== -1) {
                        vm.filterData.unassignedBookingList[i].selected = false;
                        vm.filterData.selectedDiscard.splice(objetoEncontradoIndex, 1);
                    }
                }

                if (vm.filterData.selectedDiscard.length === 0) {
                    vm.selectDisabled = true;
                }

            } else {
                errorMessageFactory.showErrorMessage('No hay reservas seleccionadas para desbloquear.', 0);
            }
        }

        function ExportDetailToExcel($event){
            var hasSelection = vm.filterData.selectedExport.some(function (booking) {
                return booking.selected;
            });
            if (!hasSelection) {
                alert("Por favor, seleccione al menos una reserva para exportar.");
                return;
            }
            var seleccionados = vm.filterData.selectedExport;
            var confirmTxt ='¿Desea exportar el detalle de los '+ seleccionados.length +' paquetes de reservas seleccionados?';
            if(seleccionados.length == 1){
                confirmTxt ='¿Desea exportar el detalle del paquete de reserva seleccionado?';
            }
            var confirm = $mdDialog.confirm()
                .title(confirmTxt)
                // .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok('Confirmar')
                .cancel('Cancelar');

            $mdDialog.show(confirm).then(function () {
                vm.loading = true;
                var promises = vm.filterData.selectedExport
                    .filter(function (booking) {
                    return booking.selected;
                    }).map(function (booking) {
                        return getBookingDetails(booking);
                    });
                Promise.all(promises).then(function (allBookingDetails) {
                    var dataExport = [];
                    allBookingDetails.forEach(function (details) {
                    var bookingDetailsArray = details.title.data.data;
                    for (var i = 0; i < bookingDetailsArray.length; i++) {
                        var bookingDetail = bookingDetailsArray[i];
                        dataExport.push({
                        "Fecha Retiro": formatDate(bookingDetail.original_pickup_datetime),
                        "Hora Retiro": formatHour(bookingDetail.original_pickup_datetime),
                        "Rut Pasajero": bookingDetail.passenger_rut,
                        "Nombre Pasajero": bookingDetail.job_pickup_name,
                        "Dirección de Recogida": bookingDetail.job_pickup_address,
                        "Comuna Recogida": getCommuna(bookingDetail.job_pickup_address),
                        "Región Recogida": bookingDetail.region_name,
                        "Teléfono Pasajero": bookingDetail.job_pickup_phone,
                        "Dirección Destino": bookingDetail.job_address,
                        "Número Reserva": bookingDetail.job_id,
                        "Número Paquete": bookingDetail.shared_service_id,
                        });
                    }
                    });
                    var wb = XLSX.utils.book_new();
                    var ws = XLSX.utils.json_to_sheet(dataExport);
                    XLSX.utils.book_append_sheet(wb, ws, "DetalleReservas");
                    var date = new Date();
                    var fileName = 'DetalleReservas_' + date.toLocaleDateString('en-CA') + '_' + date.getHours() + '-' + date.getMinutes() + '-' + date.getSeconds() + '.xlsx';
                    fileName = fileName.replace(/[/\\?%*:|"<>]/g, "-");
                    XLSX.writeFile(wb, fileName);
                    vm.loading = false;
                }).catch(function (error) {
                    vm.loading = false;
                });
                vm.loading = false;
            }, function () {
                $log.log('not confirmed');
            });
        }

        function formatDate(date) {
          var dateObj = new Date(date);
          var day = ("0" + dateObj.getDate()).slice(-2);
          var month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
          var year = dateObj.getFullYear();
          return day + "-" + month + "-" + year;
        }

        function formatHour(date) {
          var dateObj = new Date(date);
          var hours = ("0" + dateObj.getHours()).slice(-2);
          var minutes = ("0" + dateObj.getMinutes()).slice(-2);
          var seconds = ("0" + dateObj.getSeconds()).slice(-2);
          return hours + ":" + minutes + ":" + seconds;
        }

        function getCommuna(direccion) {
            var partes = direccion.split(',');
            if (partes.length > 1) {
                return partes[1].trim();
            }
            return ''; 
        }

        function getBookingDetails(booking) {
          return new Promise(function (resolve, reject) {
            var dataSend = {
              access_token: $cookies.get("obj"),
              shared_service_id: Number(booking.shared_service_id),
              booking_type: 2,
            };
            sharedRouteAssignment.getPackageDetails(dataSend).then(
              function (payload) {
                resolve(payload);
              },
              function (errorPayload) {
                reject(errorPayload);
              }
            );
          });
        }

        vm.isSomethingSelected = function() {
            return vm.filterData.selectedExport.some(function (item) {
              return item.selected;
            });
        };

        vm.updateSelected = function (data) {
            console.log('UPDATE SELECT',data);

            if(data.selected) {
                data.selected = false;
                var objetoEncontradoIndex = vm.filterData.selectedExport.findIndex(function(objeto) {
                    return objeto.shared_service_id === data.shared_service_id;
                });
                
                if (objetoEncontradoIndex !== -1) {
                    vm.filterData.selectedExport.splice(objetoEncontradoIndex, 1);
                }
            } else {
                data.selected = true;
                var objetoEncontrado = vm.filterData.selectedExport.find(function(objeto) {
                    return objeto.shared_service_id === data.shared_service_id;
                });
                if(!objetoEncontrado){
                    vm.filterData.selectedExport.push(data);
                }
            }
        };

        function SelectAllCreatedBookings() {
            if (vm.filterData.createdBookingList && vm.filterData.createdBookingList.length > 0) {               
                var reservasNoSeleccionadas = vm.filterData.createdBookingList.filter(function(booking) {
                    return !vm.filterData.selectedExport.some(function(selectedBooking) {
                        return selectedBooking.shared_service_id === booking.shared_service_id;
                    });
                });
                
                if (reservasNoSeleccionadas.length === 0) {
                    errorMessageFactory.showErrorMessage('Todos los paquetes ya estan seleccionados.', 0);
                    return;
                }

                reservasNoSeleccionadas.forEach(function(booking) {
                    booking.selected = true;
                });

                vm.filterData.selectedExport = vm.filterData.selectedExport.concat(reservasNoSeleccionadas);

                if(!$scope.$$phase) $scope.$apply();
            } else {
                errorMessageFactory.showErrorMessage('No hay paquetes disponibles para seleccionar.', 0);
            }
        }

        function ClearCreatedSelections(){
            if (vm.filterData.createdBookingList && vm.filterData.createdBookingList.length > 0) {
                vm.filterData.createdBookingList.forEach(function(booking) {
                    booking.selected = false;
                    var objetoEncontradoIndex = vm.filterData.selectedExport.findIndex(function(objeto) {
                        return objeto.shared_service_id === booking.shared_service_id;
                    });
                    
                    if (objetoEncontradoIndex !== -1) {
                        vm.filterData.selectedExport.splice(objetoEncontradoIndex, 1);
                    }
                });

                if(!$scope.$$phase) $scope.$apply();
            } else {
                errorMessageFactory.showErrorMessage('No hay reservas disponibles para seleccionar.', 0);
            }
        }
       
        //====================socket connection=================

        $scope.$on("$locationChangeStart", function (event, next, current) {
            if (vm.filterData.makePackageList.length > 0) {
                var jobData = [];
                vm.filterData.makePackageList.forEach(function (d) {
                    jobData.push(d.job_id);
                })
                setFlagInJob(jobData);
            }
        });
        //====================socket connection===================

        var myListenerCreated = $rootScope.$on('SocketComesShared', function (evt, data) {
            console.log(data, "socket delete");
            console.log("in SHARED ?>>>>>>>>>");
            $log.log(evt);
            $log.log(data);
            if (data && data.res && data.res.message.length > 0) {
                data.res.message.forEach(function (dataLoop) {

                    if (data && data.res.message.length > 0 && dataLoop.shared_service_id == null) {
                        // data.res.message.forEach(function (data) {
                        var index = vm.filterData.unassignedBookingList.findIndex(function (x) {
                            return x.job_id == dataLoop.job_id;
                        });
                        if (index >= 0) {
                            vm.filterData.unassignedBookingList.splice(index, 1);
                            $scope.$apply();
                            // vm.filterData.unassignedBookingList.splice(index, 1);
                        }
                        // })
                    } else {
                        var index = vm.filterData.unassignedBookingList.findIndex(function (x) {
                            return x.job_id == dataLoop.job_id;
                        });
                        if (index >= 0) {
                            vm.filterData.unassignedBookingList.splice(index, 1);
                            vm.filterData.unassignedBookingCount = vm.filterData.unassignedBookingList.length;
                            $scope.$apply();
                            // vm.filterData.unassignedBookingList.splice(index, 1);
                        }
                    }
                })
            }

        });

        var DeletePackage = $rootScope.$on('socketEventDeletion', function (evt, data) {
            console.log(data, "socket delete");
            $log.log(evt);
            $log.log(data);
            if (data && data.res.message.length > 0) {
                console.log(vm.filterData.unassignedBookingList.length, data.res.message.length, 'data.res.message.length');

                vm.filterData.unassignedBookingCount = vm.filterData.unassignedBookingList.length + data.res.message.length;
                data.res.message.forEach(function (data) {
                    //    var index = vm.filterData.unassignedBookingList.findIndex(function (x) {
                    //         return x.job_id == data.job_id;
                    //     });
                    //     if (index >= 0) {
                    vm.filterData.unassignedBookingList.push(data);
                    $scope.$apply();
                    // vm.filterData.unassignedBookingList.splice(index, 1);
                    // }
                })
            }
            if (data.data && vm.countToSocket == 0 && vm.filterData.filterApplied && vm.fun == true) {
                // getSharedPackageList('noScroll', false);

            }

        });
        //==================== ON DELETE PACKAGE===================

        var deletePackageSocket = $rootScope.$on('socketEventPackageEnded', function (evt, data) {
            if (data && data.data && data.data.message && data.data.message.shared_service_id > 0) {
                var index = vm.filterData.createdBookingList.findIndex(function (x) {
                    return x.shared_service_id == data.data.message.shared_service_id;
                });
                if (index >= 0) {
                    vm.filterData.createdBookingList.splice(index, 1);
                    $scope.$apply();
                }
            }
        });

        $scope.$on('$destroy', myListener);
        $scope.$on('$destroy', myListenerCreated);
        $scope.$on('$destroy', deletePackageSocket);
        $scope.$on('$destroy', DeletePackage);
        //$rootScope.socket.on('socketEventToUser',function(res){
        //    showDriversWithFilterSocket(vm.dataToFill);
        //});


        if ($rootScope.socket.connected == false || $rootScope.socket.connected == 'false') {
            $rootScope.socket.connect();
        }

        // =================Intiliaze map =================
        function initializeMap() {
            if(vm.mapViewTab == true){
                applyFilter('scroll');
            }
            vm.idBooking = '';
            vm.comunaSearchModel = '';
            vm.nominaSearchModel = '';
            vm.flightSearchModel = '';
            vm.discardBookingStatus = false;
        }

        function UnassignedList() {
            vm.idBooking = '';
            vm.comunaSearchModel = '';
            vm.nominaSearchModel = '';
            vm.filterData.unassignedBookingList = [];
            vm.flightSearchModel = '';
            vm.discardBookingStatus = false;
            var pickFromDate = '';
            var pickToDate = '';
            if (vm.filterData.filter_pickup_from_date_value && vm.filterData.filter_pickup_from_time_value) {
                pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            }
            if (vm.filterData.filter_pickup_to_date_value && vm.filterData.filter_pickup_to_time_value) {
                pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            }
            getGroupedOnly(true, pickFromDate, pickToDate, 'scroll');
        }

        // =================global parameters=================
        function getGlobalParameters() {
            // vm.loading = true;
            var toSend = {};
            toSend.access_token = $cookies.get('obj');
            //toSend.booking_status = 4;
            var promise = globalParams.getGlobalParams(toSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    // vm.loading = false;
                    for (var i = 0; i < payload.title.data.length; i++) {
                        if (payload.title.data[i].reason == 'group booking common point distance in meters') {
                            vm.filterData.globalDistance = payload.title.data[i].ratio;
                        }
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getGlobalParameters();

        //=======================map=========================
        function setMapOnAll(map, type) {
            for (var i = 0; i < markers.length; i++) {
                if (markers[i].type == type) {
                    markers[i].setMap(map);
                }
                if (type == 'all') {
                    markers[i].setMap(map);
                }
            }
        }

        // If the map position is out of range, move it back
        function checkBounds(map) {
            if (typeof (map.getBounds()) == 'undefined')
                return;

            var latNorth = map.getBounds().getNorthEast().lat();
            var latSouth = map.getBounds().getSouthWest().lat();
            var newLat;

            if (latNorth < 85 && latSouth > -85) /* in both side -> it's ok */
                return;
            else {
                if (latNorth > 85 && latSouth < -85) /* out both side -> it's ok */
                    return;
                else {
                    if (latNorth > 85)
                        newLat = map.getCenter().lat() - (latNorth - 85);
                    /* too north, centering */
                    if (latSouth < -85)
                        newLat = map.getCenter().lat() - (latSouth + 85);
                    /* too south, centering */
                }
            }
            if (newLat) {
                var newCenter = new google.maps.LatLng(newLat, map.getCenter().lng());
                map.setCenter(newCenter);
            }
        }

        function initialize() {
            var mapProp = {
                center: myCenter,
                zoom: 3,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                minZoom: 3,
                //maxZoom: 18,
                mapTypeControl: false
            };
            map = new google.maps.Map(document.getElementById("groupedMap"), mapProp);
            map.setOptions({
                styles: hidePublicPlaces.hidePublic()
            });
            google.maps.event.addListener(map, 'center_changed', function () {
                checkBounds(map);
            });
            console.log("intiliase map");

            //google.maps.event.addListener(map, 'click', function() {
            //    infowindow.close();
            //    restorePreviousData();
            //});
            //google.maps.event.addListener(infowindow,'closeclick',function(){
            //    restorePreviousData();
            //});
        };

        function createMarker(latlng, data) {
            //var marker = new google.maps.Marker({
            //    position: latlng,
            //    map: map
            //});
            if (data.type == 'pickNotAssigned') {
                var icon = {
                    url: 'assets/images/blackCircle.png',
                    size: new google.maps.Size(70, 70),
                    scaledSize: new google.maps.Size(20, 20), // scaled size
                    origin: new google.maps.Point(0, 0), // origin
                    labelOrigin: new google.maps.Point(25, 15),
                    anchor: new google.maps.Point(8, 16) // anchor
                };
                var text = '<p>' + data.job_pickup_datetime_filter + '<br/>' + data.number_of_passangers + ' Pax</p>';
            } else if (data.type == 'drop') {
                var icon = {
                    url: 'assets/images/redCircle.png',
                    size: new google.maps.Size(70, 70),
                    scaledSize: new google.maps.Size(20, 20), // scaled size
                    origin: new google.maps.Point(0, 0), // origin
                    labelOrigin: new google.maps.Point(25, 15),
                    anchor: new google.maps.Point(8, 16) // anchor
                };
            } else if (data.type == 'pickAssigned') {
                var icon = {
                    url: 'assets/images/greenCircle.png',
                    size: new google.maps.Size(70, 70),
                    scaledSize: new google.maps.Size(20, 20), // scaled size
                    origin: new google.maps.Point(0, 0), // origin
                    labelOrigin: new google.maps.Point(25, 15),
                    anchor: new google.maps.Point(8, 16) // anchor
                };
                var text = '<p>' + data.job_pickup_datetime_filter_new + '<br/>' + data.number_of_passangers + ' Pax</p>';
            } else if (data.type == 'pickStarted') {
                var icon = {
                    url: 'assets/images/blackCircle.png',
                    size: new google.maps.Size(70, 70),
                    scaledSize: new google.maps.Size(20, 20), // scaled size
                    origin: new google.maps.Point(0, 0), // origin
                    labelOrigin: new google.maps.Point(25, 15),
                    anchor: new google.maps.Point(8, 16) // anchor
                };
                var text = '<p>' + data.job_pickup_datetime_filter_new + '<br/>' + data.number_of_passangers + ' Pax</p>';
            }


            var marker = new MarkerWithLabel({
                position: latlng,
                draggable: false,
                raiseOnDrag: false,
                icon: icon,
                map: map,
                labelContent: data.type != 'drop' ? text : '',
                labelAnchor: data.type != 'drop' ? new google.maps.Point(22, 0) : '',
                labelClass: data.type != 'drop' ? "labelsMap" : '', // the CSS class for the label
                labelStyle: data.type != 'drop' ? {
                    opacity: 0.75
                } : '',
                type: data.type,
                id: data.job_id
            });


            //var mapLabel = new MapLabel({
            //    text: 'TEST',
            //    position: latlng,
            //    map: map,
            //    fontSize: 35,
            //    align: 'center'
            //});
            //mapLabel.set('position', latlng);

            bounds.extend(latlng);
            if (map != null)
                map.fitBounds(bounds);
            google.maps.event.addListener(marker, 'click', function (event) {
                vm.jobIdOfMarker = marker.id;
                vm.jobTypeOfMarker = marker.type;
                if (marker.type != 'drop') {
                    marker.content = makeInfoWindow(data);
                    infowindow.setContent(marker.content);
                    infowindow.open(map, marker);
                }
            });
            markers.push(marker); //push local var marker into global array
        };

        function makeInfoWindow(data) {
            var divWithAssignment = '<div class="row" id="googleMapsDetailsWithCar">' +
                '<div class="col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center serviceDetails">' + data.service_name + '</div>' +
                '<div class="col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center idBooking">' + '<span class="label">Id Booking</span>' + '<span class="id"> #' + data.job_id + '</span>' + '</div>' +
                '  <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 paddingOnDuty1">' +
                '  <div class="pickUpText">Pickup</div>' +
                '   <div class="addressDiv"><i class="fa fa-map-marker"></i>&nbsp;&nbsp;' + data.job_pickup_address + '</div>' +
                ' </div>' +
                '<div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 paddingOnDuty1">' +
                '    <div class="pickUpText">Drop off</div>' +
                '<div class="addressDiv"><i class="fa fa-map-marker"></i>&nbsp;&nbsp;' + data.job_address + '</div>' +
                '</div>' +
                '<div class="col-lg-12 col-sm-12 col-xs-12 col-md-12 distanceDivPS paddingZero">' +
                '    <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 distanceDivs" style="padding:2px;">Distance ' + data.distance + 'KM</div>' +
                '<div class="distanceDivs col-lg-6 col-sm-6 col-xs-6 col-md-6" style="padding:2px;">Time Trip: ' + data.eta + ' min</div>' +
                '</div>' +
                ' <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 customerDriverDivS">' +
                '   <div class="customerDivPS">' +
                '  <div class="customerText">Customer</div>' +
                '   <div class="customerName">' + data.job_pickup_name + '</div>' +
                ' <div class="customerName">+56 ' + data.job_pickup_phone + '</div>' +
                ' <div class="customerName">' + data.number_of_passangers + ' Pax</div>' +
                '   </div>' +
                '</div>' +
                ' <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 pickUpDetailsPS">' +
                '   <div class="pickUpText1">Pickup Time</div>' +
                '<div class="pickUpTime">' + data.job_pickup_datetime_filter + ' Hrs</div>' +
                '<div class="pickUpAgreement">' + data.name + '</div>' +
                '  </div>' +
                '<div class="col-lg-12 col-sm-12 col-xs-12 col-md-12 paddingOnDuty statusChangeD" id="assignToRoute" style="background: green;">' + data.text + '</div>' +
                '</div>';

            var divWithoutAssignment = '<div class="row" id="googleMapsDetailsWithCar">' +
                '<div class="col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center serviceDetails">' + data.service_name + '</div>' +
                '<div class="col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center idBooking">' + '<span class="label">Id Booking</span>' + '<span class="id"> #' + data.job_id + '</span>' + '</div>' +
                '  <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 paddingOnDuty1">' +
                '  <div class="pickUpText">Pickup</div>' +
                '   <div class="addressDiv"><i class="fa fa-map-marker"></i>&nbsp;&nbsp;' + data.job_pickup_address + '</div>' +
                ' </div>' +
                '<div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 paddingOnDuty1">' +
                '    <div class="pickUpText">Drop off</div>' +
                '<div class="addressDiv"><i class="fa fa-map-marker"></i>&nbsp;&nbsp;' + data.job_address + '</div>' +
                '</div>' +
                '<div class="col-lg-12 col-sm-12 col-xs-12 col-md-12 distanceDivPS paddingZero">' +
                '    <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 distanceDivs" style="padding:2px;">Distance ' + data.distance + 'KM</div>' +
                '<div class="distanceDivs col-lg-6 col-sm-6 col-xs-6 col-md-6" style="padding:2px;">Time Trip: ' + data.newEta + ' min</div>' +
                '</div>' +
                ' <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 customerDriverDivS">' +
                '   <div class="customerDivPS">' +
                '  <div class="customerText">Customer</div>' +
                '   <div class="customerName">' + data.job_pickup_name + '</div>' +
                ' <div class="customerName">+56 ' + data.job_pickup_phone + '</div>' +
                ' <div class="customerName">' + data.number_of_passangers + ' Pax</div>' +
                '   </div>' +
                '</div>' +
                ' <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 pickUpDetailsPS">' +
                '   <div class="pickUpText1">Pickup Time</div>' +
                '<div class="pickUpTime">' + data.job_pickup_datetime_filter_new + ' Hrs</div>' +
                '<div class="pickUpAgreement">' + data.name + '</div>' +
                '  </div>' +
                '</div>';

            if (vm.jobTypeOfMarker == 'pickNotAssigned') {
                return divWithAssignment;
            } else if (vm.jobTypeOfMarker == 'pickAssigned') {
                return divWithoutAssignment;
            } else if (vm.jobTypeOfMarker == 'pickStarted') {
                return divWithoutAssignment;
            }
        };

        //================default values in date and time===========================
        function showFilterTime(type) {
            var x = new Date();
            if (type == 1) {
                x.setHours('00');
                x.setMinutes('00');
                x.setSeconds('00');
            } else if (type == 2) {
                var currentHrs = x.getHours();
                var nextTwelveHrs = currentHrs + 12;
                var currentMins = x.getMinutes();
                x.setHours(nextTwelveHrs);
                x.setMinutes(currentMins);
                x.setSeconds('00');
            }
            return x;
        }

        function setToPickupDate() {
            var x = new Date();
            var currentHrs = x.getHours();
            var nextTwelveHrs = currentHrs + 12;
            if (nextTwelveHrs > 24) {
                var tomorrow = new Date();
                tomorrow.setDate(x.getDate() + 1);
                return tomorrow;
            } else {
                return new Date();
            }
        }

        //==================date picker function==================
        vm.dateOptions = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(2090, 12, 31),
            //minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };
        vm.dateOptionsT = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(2090, 12, 31),
            //minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };

        function datePickerE_1(type) {
            switch (type) {
                case 1:
                    vm.datePicker_1.pickupFromDate = true;
                    vm.datePicker_1.pickupToDate = false;
                    vm.datePicker_1.pickupFromDatePackage = false;
                    vm.datePicker_1.pickupToDatePackage = false;
                    break;
                case 2:
                    vm.datePicker_1.pickupFromDate = false;
                    vm.datePicker_1.pickupToDate = true;
                    vm.datePicker_1.pickupFromDatePackage = false;
                    vm.datePicker_1.pickupToDatePackage = false;
                    break;
                case 3:
                    vm.datePicker_1.pickupFromDate = false;
                    vm.datePicker_1.pickupToDate = false;
                    vm.datePicker_1.pickupFromDatePackage = true;
                    vm.datePicker_1.pickupToDatePackage = false;
                    break;
                case 4:
                    vm.datePicker_1.pickupFromDate = false;
                    vm.datePicker_1.pickupToDate = false;
                    vm.datePicker_1.pickupFromDatePackage = false;
                    vm.datePicker_1.pickupToDatePackage = true;
                    break;
            }
        };


        //====================slide data======================
        $('#derp').show();

        function slideData() {
            $('#derp').slideToggle(1000);
        }

        // SLIDE DOWN PACKAGE
        function slideDataPackage() {
            if (vm.filterData.makePackageList.length > 0 && vm.bookingsAssignmentTab) {
                vm.checkClickedPackage = false;
            } else {
                $('#packageFilter').slideToggle(1000);
            }

        }

        $('#packageFilter').show();

        //===================reset filter=====================
        function resetFilter(type) {
            console.log('>>>>> TYPE >>>>', type);
            if (type == 0) {
                if (vm.filterData.makePackageList && vm.filterData.makePackageList.length) {
                    var jobData = [];
                    vm.filterData.makePackageList.forEach(function (d) {
                        jobData.push(d.job_id);
                    })
                    setFlagInJob(jobData);
                }
                if ($cookies.get('groupBranch')) {
                    vm.filterData.branch_value = $cookies.remove('groupBranch');
                }
                if ($cookies.get('group_type_of_service')) {
                    vm.filterData.service_value = $cookies.remove('group_type_of_service');
                }
                if ($cookies.get('group_type_of_trip')) {
                    vm.filterData.typeOfTrip = $cookies.put('group_type_of_trip', 'R');

                }
                if ($cookies.get('groupContract_id')) {
                    vm.filterData.aggrement_value = $cookies.remove('groupContract_id');
                }
                if ($cookies.get('groupPickUpDate')) {
                    $cookies.put("groupPickUpDate", new Date());
                    vm.filterData.filter_pickup_from_date_value = new Date();
                } else {
                    vm.filterData.filter_pickup_from_date_value = new Date();
                }
                if ($cookies.get('groupPickDateto')) {
                    $cookies.put("groupPickDateto", new Date());
                    vm.filterData.filter_pickup_to_date_value = new Date();
                } else {
                    vm.filterData.filter_pickup_to_date_value = new Date();
                }
                if ($cookies.get('groupPickTime')) {
                    $cookies.put("groupPickTime", new Date(new Date().setHours(0, 0, 0, 0)));
                    vm.filterData.filter_pickup_from_time_value = new Date(new Date().setHours(0, 0, 0, 0));
                } else {
                    vm.filterData.filter_pickup_from_time_value = new Date(new Date().setHours(0, 0, 0, 0));
                }
                if ($cookies.get('groupDropTime')) {
                    $cookies.put("groupDropTime", new Date(new Date().setHours(23, 59, 0, 0)));
                    vm.filterData.filter_pickup_to_time_value = new Date(new Date().setHours(23, 59, 0, 0))
                } else {
                    vm.filterData.filter_pickup_to_time_value = new Date(new Date().setHours(23, 59, 0, 0))
                }
                // vm.filterData.branch_value = '';
                // vm.filterData.aggrement_value = '';
                // vm.filterData.typeOfTrip = '';
                // vm.filterData.service_value = '';
                // vm.filterData.filter_pickup_from_date_value = '';
                // vm.filterData.filter_pickup_from_time_value = '';
                // vm.filterData.filter_pickup_to_date_value = setToPickupDate();
                // vm.filterData.filter_pickup_to_time_value = showFilterTime(2);
                vm.filterData.unassignedBookingList = [];
                vm.filterData.unassignedBookingCount = 0;
                vm.filterData.unassignedSkip = 0;
                vm.filterData.unassignedLimit = 10;
                vm.filterData.unassignedLimitMade = 10;
                vm.filterData.serviceDetailsSelected = '';
                vm.filterData.filterApplied = false;
                vm.filterData.unassignedPredicate = 'index';
                vm.filterData.makePackagePredicate = 'index';
                vm.filterData.unassignedReverse = false;
                vm.filterData.makePackageReverse = false;
                vm.filterData.makePackageList = [];
                vm.filterData.dropLocationArray = [];
                vm.filterData.makePackageCount = 0;
                vm.filterData.totalPassengerAssigned = 0;
                vm.filterData.totalBookingAssigned = 0;
                vm.filterData.totalAssignedETA = 0;
                vm.filterData.createdPredicate = 'index';
                vm.filterData.createdReverse = false;
                vm.filterData.createdSkip = 0;
                vm.filterData.createdLimit = 15;
                vm.filterData.createdBookingCount = 0;
                vm.filterData.createdBookingList = [];
                vm.filterData.sharedServiceName = 'NEW';
                vm.filterData.vehicleAssigned = 'PENDING';
                vm.filterData.modifyFlag = false;
                vm.idBooking = '';
                vm.flightSearchModel = '';
                vm.nominaSearchModel = '';
                vm.comunaSearchModel = '';
                // vm.booking = '';
                // vm.idPackete = '';
                // vm.vehicleSearch = ''
                setMapOnAll(null, 'all');
                // getFilterDataFromBackend();
            }
            // FOR PACKAGE FILTER
            if (type == 1) {
                if (vm.filterData.makePackageList && vm.filterData.makePackageList.length) {
                    var jobData = [];
                    vm.filterData.makePackageList.forEach(function (d) {
                        jobData.push(d.job_id);
                    })
                    setFlagInJob(jobData);
                }
                if ($cookies.get('groupBranchPackage')) {
                    vm.filterData.branch_value_package = $cookies.remove('groupBranchPackage');
                }
                if ($cookies.get('group_type_of_service_package')) {
                    vm.filterData.service_value_package = $cookies.remove('group_type_of_service_package');
                }
                if ($cookies.get('group_type_of_trip_package')) {
                    vm.filterData.typeOfTripPackage = $cookies.put('group_type_of_trip_package', 'R');
                }
                if ($cookies.get('groupContract_id_package')) {
                    vm.filterData.aggrement_value_package = $cookies.remove('groupContract_id_package');
                }
                if ($cookies.get('groupPickUpDatePackage')) {
                    $cookies.put("groupPickUpDatePackage", new Date());
                    vm.filterData.filter_pickup_from_date_value_package = new Date();
                } else {
                    vm.filterData.filter_pickup_from_date_value_package = new Date();
                }
                if ($cookies.get('groupPickDatetoPackage')) {
                    $cookies.put("groupPickDatetoPackage", new Date());
                    vm.filterData.filter_pickup_to_date_value_package = new Date();
                } else {
                    vm.filterData.filter_pickup_to_date_value_package = new Date();
                }
                if ($cookies.get('groupPickTimePackage')) {
                    $cookies.put("groupPickTimePackage", new Date(new Date().setHours(0, 0, 0, 0)));
                    vm.filterData.filter_pickup_from_time_value_package = new Date(new Date().setHours(0, 0, 0, 0));
                } else {
                    vm.filterData.filter_pickup_from_time_value_package = new Date(new Date().setHours(0, 0, 0, 0));
                }
                if ($cookies.get('groupDropTimePackage')) {
                    $cookies.put("groupDropTimePackage", new Date(new Date().setHours(23, 59, 0, 0)));
                    vm.filterData.filter_pickup_to_time_value_package = new Date(new Date().setHours(23, 59, 0, 0))
                } else {
                    vm.filterData.filter_pickup_to_time_value_package = new Date(new Date().setHours(23, 59, 0, 0))
                }
                // vm.filterData.branch_value = '';
                // vm.filterData.aggrement_value = '';
                // vm.filterData.typeOfTrip = '';
                // vm.filterData.service_value = '';
                // vm.filterData.filter_pickup_from_date_value = '';
                // vm.filterData.filter_pickup_from_time_value = '';
                // vm.filterData.filter_pickup_to_date_value = setToPickupDate();
                // vm.filterData.filter_pickup_to_time_value = showFilterTime(2);
                // vm.filterData.unassignedBookingList = [];
                // vm.filterData.unassignedBookingCount = 0;
                // vm.filterData.unassignedSkip = 0;
                // vm.filterData.unassignedLimit = 10;
                // vm.filterData.unassignedLimitMade = 10;
                // vm.filterData.serviceDetailsSelected = '';
                // vm.filterData.filterApplied = false;
                vm.filterData.filterAppliedService = false;
                // vm.filterData.unassignedPredicate = 'index';
                vm.filterData.makePackagePredicate = 'index';
                // vm.filterData.unassignedReverse = false;
                vm.filterData.makePackageReverse = false;
                vm.filterData.makePackageList = [];
                // vm.filterData.dropLocationArray = [];
                vm.filterData.makePackageCount = 0;
                vm.filterData.totalPassengerAssigned = 0;
                vm.filterData.totalBookingAssigned = 0;
                vm.filterData.totalAssignedETA = 0;
                vm.filterData.createdPredicate = 'index';
                vm.filterData.createdReverse = false;
                vm.filterData.createdSkip = 0;
                vm.filterData.createdLimit = 15;
                vm.filterData.createdBookingCount = 0;
                vm.filterData.createdBookingList = [];
                vm.filterData.sharedServiceName = 'NEW';
                vm.filterData.vehicleAssigned = 'PENDING';
                vm.filterData.modifyFlag = false;
                // vm.idBooking = '';
                // vm.flightSearchModel = '';
                // vm.nominaSearchModel = '';
                // vm.comunaSearchModel = '';
                vm.booking = '';
                vm.idPackete = '';
                vm.vehicleSearch = ''
                // setMapOnAll(null, 'all');
                // getFilterDataFromBackend();
            }
        }

        //====================get branch list====================
        function getBranch() {

            // vm.branchList = [];
            // vm.branchList = getFilters.branchesFiltersData.data;

            // $scope.$apply();


            vm.loading = true;
            var promise = getGeofence.branch();
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        var where = _.where(payload.title.data, {
                            parent_id: 0
                        });
                        //vm.branchList = _.where(where, { is_active: 1 });
                        vm.branchList = where;
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        // WHen Page refresh service take time to get data from backend
        // setTimeout(function () {
        getBranch();
        // }, 1000);
        //======================get all services==============
        function getAllServices(skip, limit) {
            //vm.loading = false;
            var promise = getServices.allServices(skip, limit, 2, 0);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    //vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.service = [];
                        angular.forEach(payload.title.data.result, function (column) {
                            if (column.status == 1 && column.category == 0)
                                vm.service.push({
                                    id: column.id,
                                    name: column.service_name,
                                    max: column.max_limit
                                });
                        });
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllServices(0, 0);

        //======================get all services==============
        function getAllAgreement(skip, limt) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.offset = skip;
            dataSend.limit = limt;
            dataSend.key = 3;
            dataSend.group_booking = 1;
            //vm.loading = false;
            var promise = getAgreement.getAgreementListLessData(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    //vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.agreement = [];
                        angular.forEach(payload.title.data, function (column) {
                            if (column.status == 1)
                                vm.agreement.push({
                                    id: column.id,
                                    name: column.name
                                });
                        });
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllAgreement(0, 0);
        //====================date time format====================
        function dateTimeFormat(dateGot, timeGot) {
            var dateToChange = dateGot;
            if (timeGot) {
                dateToChange.setHours(timeGot.getHours());
                dateToChange.setMinutes(timeGot.getMinutes());
                dateToChange.setSeconds(timeGot.getSeconds());
            } else {
                dateToChange.setHours(0);
                dateToChange.setMinutes(0);
                dateToChange.setSeconds(0);
            }
            return dateToChange;
        };

        // //===================service selected================
        // function serviceChanged() {
        //     vm.filterData.serviceDetailsSelected = _.where(vm.service, {
        //         id: vm.filterData.service_value
        //     })[0];
        // }

        //===================apply filter=====================
        function applyFilter(type) {
            if (!vm.filterData.filter_pickup_from_date_value && vm.filterData.filter_pickup_from_time_value) {
                languageBasedErrorFactory.getProperErrorMessage('appropriateFilter', 0, 0);
                return;
            }
            if (vm.filterData.filter_pickup_from_date_value && !vm.filterData.filter_pickup_from_time_value) {
                languageBasedErrorFactory.getProperErrorMessage('appropriateFilter', 0, 0);
                return;
            }
            if (vm.filterData.filter_pickup_to_date_value && !vm.filterData.filter_pickup_to_time_value) {
                languageBasedErrorFactory.getProperErrorMessage('appropriateFilter', 0, 0);
                return;
            }

            if (vm.filterData.filter_pickup_from_date_value && vm.filterData.filter_pickup_from_time_value) {
                var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            }
            if (vm.filterData.filter_pickup_to_date_value && vm.filterData.filter_pickup_to_time_value) {
                var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            }

            if (pickFromDate > pickToDate) {
                languageBasedErrorFactory.getProperErrorMessage('appropriateFilter', 0, 0);
                return;
            }

            if (vm.mapViewTab) {
                setMapOnAll(null, 'all');
            }
            if (type == 'blank') {
                vm.filterData.makePackageList = [];
                vm.filterData.makePackageCount = 0;
            }
            vm.filterData.dropLocationArray = [];
            vm.filterData.totalPassengerAssigned = 0;
            vm.filterData.totalBookingAssigned = 0;
            vm.filterData.totalAssignedETA = 0;
            // vm.filterData.createdPredicate = 'index';
            // vm.filterData.createdReverse = false;
            // vm.filterData.createdSkip = 0;
            // vm.filterData.createdLimit = 15;
            // vm.filterData.createdBookingCount = 0;
            // vm.filterData.createdBookingList = [];
            vm.filterData.modifyFlag = false;
            if (type == 'scroll') {
                vm.filterData.filterApplied = true;
                vm.filterData.filterAppliedService = true;
                if (vm.mapViewTab) {
                    $timeout(function () {
                        initialize();
                        directionsDisplay.setMap(null);
                    })
                }
                getGroupedOnly(false, pickFromDate, pickToDate, 'scroll');
                // getGroupedPackageList('noScroll', false, pickFromDate, pickToDate);
            } else {
                vm.filterData.unassignedSkip = 0;
                vm.filterData.unassignedLimit = 10;
                vm.filterData.unassignedLimitMade = 10;
                vm.filterData.filterApplied = true;
                vm.filterData.filterAppliedService = true;
                if (vm.mapViewTab) {
                    $timeout(function () {
                        initialize();
                        directionsDisplay.setMap(null);
                    })
                }
                getGroupedOnly(true, pickFromDate, pickToDate);
                // getGroupedPackageList('noScroll', false, pickFromDate, pickToDate);
            }
        }


        //=================== APPLY FILTER SERVICES =====================
        function applyFilterServices(type) {
            if (!vm.filterData.filter_pickup_from_date_value_package && vm.filterData.filter_pickup_from_time_value_package) {
                languageBasedErrorFactory.getProperErrorMessage('appropriateFilter', 0, 0);
                return;
            }
            if (vm.filterData.filter_pickup_from_date_value_package && !vm.filterData.filter_pickup_from_time_value_package) {
                languageBasedErrorFactory.getProperErrorMessage('appropriateFilter', 0, 0);
                return;
            }
            if (vm.filterData.filter_pickup_to_date_value_package && !vm.filterData.filter_pickup_to_time_value_package) {
                languageBasedErrorFactory.getProperErrorMessage('appropriateFilter', 0, 0);
                return;
            }

            if (vm.filterData.filter_pickup_from_date_value_package && vm.filterData.filter_pickup_from_time_value_package) {
                var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value_package, vm.filterData.filter_pickup_from_time_value_package);
            }
            if (vm.filterData.filter_pickup_to_date_value_package && vm.filterData.filter_pickup_to_time_value_package) {
                var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value_package, vm.filterData.filter_pickup_to_time_value_package);
            }

            if (pickFromDate > pickToDate) {
                languageBasedErrorFactory.getProperErrorMessage('appropriateFilter', 0, 0);
                return;
            }

            // if (vm.mapViewTab) {
            //     setMapOnAll(null, 'all');
            // }
            if (type == 'blank') {
                vm.filterData.makePackageList = [];
                vm.filterData.makePackageCount = 0;
            }
            vm.filterData.dropLocationArray = [];

            vm.filterData.totalPassengerAssigned = 0;
            vm.filterData.totalBookingAssigned = 0;
            vm.filterData.totalAssignedETA = 0;
            vm.filterData.createdPredicate = 'index';
            vm.filterData.createdReverse = false;
            vm.filterData.createdSkip = 0;
            vm.filterData.createdLimit = 15;
            vm.filterData.createdBookingCount = 0;
            vm.filterData.createdBookingList = [];
            vm.filterData.modifyFlag = false;
            vm.filterData.filterAppliedService = true;
            // if (type == 'scroll') {
            //     vm.filterData.filterApplied = true;
            //     if (vm.mapViewTab) {
            //         $timeout(function () {
            //             initialize();
            //             directionsDisplay.setMap(null);
            //         })
            //     }
            //     getGroupedOnly(false, pickFromDate, pickToDate, 'scroll');
            //     // getGroupedPackageList('noScroll', false);
            // } else {
            //     vm.filterData.unassignedSkip = 0;
            //     vm.filterData.unassignedLimit = 10;
            //     vm.filterData.unassignedLimitMade = 10;
            //     vm.filterData.filterApplied = true;
            //     vm.filterData.filterAppliedService = true;
            //     if (vm.mapViewTab) {
            //         $timeout(function () {
            //             initialize();
            //             directionsDisplay.setMap(null);
            //         })
            //     }
            getGroupedPackageList('noScroll', false, pickFromDate, pickToDate);
            // }
            // getGroupedOnly(true, pickFromDate, pickToDate);
        }

        // ******** CLEAR OFFSET *******
        // function clearOffset() {
        //     for (var i = 0; i < vm.searchFilterArray.length; i++) {
        //         vm[vm.searchFilterArray[i] + 'Offset'] = 0;
        //     }
        // }

        function branchChanged(type) {
            if (type) {
                $cookies.put('groupBranchPackage', vm.filterData.branch_value_package);
            } else {
                $cookies.put('groupBranch', vm.filterData.branch_value);
            }
            // vm.agreement = [];
            // vm.branchList = [];
            // vm.vehicle = [];
            // clearOffset();
            // vm.branchOffset = 0;
            // getFilterDataFromBackend();
        }
        vm.agreementChanged = function (type) {
            if (type) {
                if (vm.filterData.aggrement_value_package != 'all')
                    $cookies.put('groupContract_id_package', vm.filterData.aggrement_value_package)
            } else {
                if (vm.filterData.aggrement_value != 'all')
                    $cookies.put('groupContract_id', vm.filterData.aggrement_value)
            };
            // vm.agreement = [];
            // vm.branchList = [];
            // vm.vehicle = [];
            // clearOffset();
            // vm.agreementOffset = 0;
            // getFilterDataFromBackend();
        }

        //  //===================service selected================
        function serviceChanged(type) {
            // vm.agreement = [];
            // vm.branchList = [];
            // vm.vehicle = [];
            // getFilterDataFromBackend();
            console.log('>>>>>>> SERVICE CHANGES', vm.filterData.service_value_package);
            if (type) {
                vm.filterData.serviceDetailsSelected = _.where(vm.service, {
                    id: vm.filterData.service_value_package
                })[0];
                $cookies.put("group_type_of_service_package.name", vm.filterData.serviceDetailsSelected.name);
                $cookies.put("group_type_of_service_package.max", vm.filterData.serviceDetailsSelected.max);
                vm.nameForShow = $cookies.get('group_type_of_service_package.name');
                vm.maxForShow = $cookies.get('group_type_of_service_package.max');
                $cookies.put('group_type_of_service_package', vm.filterData.service_value_package)
            } else {
                vm.filterData.serviceDetailsSelected = _.where(vm.service, {
                    id: vm.filterData.service_value
                })[0];
                if (vm.filterData.serviceDetailsSelected != undefined) {
                    $cookies.put("group_type_of_service.name", vm.filterData.serviceDetailsSelected.name);
                    $cookies.put("group_type_of_service.max", vm.filterData.serviceDetailsSelected.max);
                    vm.nameForShow = $cookies.get('group_type_of_service.name');
                    vm.maxForShow = $cookies.get('group_type_of_service.max');
                    $cookies.put('group_type_of_service', vm.filterData.service_value)
                }
            }
        }

        vm.typeOfTrip = function (type) {
            if (type) {
                $cookies.put('group_type_of_trip_package', vm.filterData.typeOfTripPackage)
            } else {
                $cookies.put('group_type_of_trip', vm.filterData.typeOfTrip)
            }
        }
        vm.pickupFromToDateChanged = function (data) {
            switch (data) {
                case 1:
                    $cookies.put('groupPickUpDate', vm.filterData.filter_pickup_from_date_value);
                    break;
                case 2:
                    $cookies.put('groupPickDateto', vm.filterData.filter_pickup_to_date_value);
                    break;
                case 3:
                    $cookies.put('groupPickUpDatePackage', vm.filterData.filter_pickup_from_date_value_package);
                    break;
                case 4:
                    $cookies.put('groupPickDatetoPackage', vm.filterData.filter_pickup_to_date_value_package);
                    break;
            }
        }


        function changeTime(type) {
            if (type) {
                $cookies.put('groupPickTimePackage', vm.filterData.filter_pickup_from_time_value_package);
            } else {
                $cookies.put('groupPickTime', vm.filterData.filter_pickup_from_time_value);
            }
        }

        function changeDropTime(type) {
            if (type) {
                $cookies.put('groupDropTimePackage', vm.filterData.filter_pickup_to_time_value_package);
            } else {
                $cookies.put('groupDropTime', vm.filterData.filter_pickup_to_time_value);
            }
        }

        //=====================get grouped only=========================
        function getGroupedOnly(loading, pickFromDate, pickToDate, type) {
            if (type == 'scroll')
                vm.unassignedBookingListLoading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.offset = vm.filterData.unassignedSkip;
            dataSend.limit = vm.filterData.unassignedLimit;
            dataSend.branch = vm.filterData.branch_value;
            dataSend.type_of_service = vm.filterData.service_value;
            dataSend.type_of_trip = vm.filterData.typeOfTrip;
            if (vm.filterData.aggrement_value != 'all')
                dataSend.contract_id = vm.filterData.aggrement_value;
            //else dataSend.contract_id = '';
            if (pickFromDate && pickToDate) {
                dataSend.from_pickup_datetime = pickFromDate.toISOString();
                dataSend.to_pickup_datetime = pickToDate.toISOString();
            }
            if (vm.flightSearchModel) {
                dataSend.flight_number_string_flag = 1;
                dataSend.flight_number_search_value = vm.flightSearchModel;
            } else {
                dataSend.flight_number_string_flag = 0;
            }
            if (vm.nominaSearchModel) {
                dataSend.nomina_string_flag = 1;
                dataSend.nomina_search_value = vm.nominaSearchModel;
            } else {
                dataSend.nomina_string_flag = 0;
            }
            if (vm.idBooking) {
                dataSend.booking_id = vm.idBooking;
            }
            if (vm.comunaSearchModel) {
                dataSend.communa_string_flag = 1;
                dataSend.communa_search_value = vm.comunaSearchModel;
            } else {
                dataSend.communa_string_flag = 0;
            }
            if (vm.discardBookingStatus) {
                dataSend.discard_from_group = 1;
            } else {
                dataSend.discard_from_group = 0;
            }
            vm.loading = loading;
            // vm.filterData.unassignedBookingList = [];
            var promise = groupedRouteAssignment.getGroupedBookings(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    // vm.socketCount = 0;
                    vm.filterData.unassignedBookingCount = payload.title.data.totalCount;
                    vm.filterData.unassignedBookingCountShow = payload.title.data.totalCount;
                    if (payload.title.data.result.length == 0) {
                        $timeout(function () {
                            //initialize();
                            directionsDisplay.setMap(null);
                        });
                    }
                    if (type == 'scroll') {
                        console.log("first", payload.title.data.result.length);
                        // vm.filterData.unassignedBookingList = [];
                        var payloadIndex = payload.title.data.result.length;
                        for (var i = 0; i < payloadIndex; i++) {
                            var index = _.findIndex(vm.filterData.makePackageList, {
                                job_id: payload.title.data.result[i].job_id
                            });
                            if (index > -1) {
                                // payload.title.data.result.splice(i, 1);
                            } else {
                                vm.filterData.unassignedBookingList.push(payload.title.data.result[i]);
                                if (new Date(payload.title.data.result[i].time_with_tolerance_before).toISOString() == new Date(payload.title.data.result[i].time_with_tolerance_after).toISOString()) {
                                    payload.title.data.result[i].is_group_external_new = true;
                                } else {
                                    payload.title.data.result[i].is_group_external_new = false;
                                }
                            }
                        }

                        // for (var i = 0; i < payload.title.data.result.length; i++) {
                        //     vm.filterData.unassignedBookingList.push(payload.title.data.result[i]);
                        // }
                        vm.unassignedBookingListLoading = false;
                    } else {
                        console.log("i m in this");
                        // vm.filterData.unassignedBookingList = [];
                        var payloadIndexNew = payload.title.data.result.length;
                        for (var i = 0; i < payloadIndexNew; i++) {
                            if (new Date(payload.title.data.result[i].time_with_tolerance_before).toISOString() == new Date(payload.title.data.result[i].time_with_tolerance_after).toISOString()) {
                                payload.title.data.result[i].is_group_external_new = true;
                            } else {
                                payload.title.data.result[i].is_group_external_new = false;
                            }
                        }
                        vm.filterData.unassignedBookingList = payload.title.data.result;
                        console.log(vm.filterData.unassignedBookingList, ' vm.filterData.unassignedBookingList');
                    }
                    if (type == 'socket') {
                        if (vm.filterData.makePackageList && vm.filterData.makePackageList.length) {
                            for (var i = 0; i < vm.filterData.makePackageList.length; i++) {
                                var index = _.findIndex(vm.filterData.unassignedBookingList, {
                                    job_id: vm.filterData.makePackageList[i].job_id
                                });
                                // Tv-2129
                                // if (index > -1) {
                                //     vm.filterData.unassignedBookingList.splice(index, 1);
                                // }
                            }
                        }
                        vm.filterData.unassignedBookingCount = vm.filterData.unassignedBookingList.length;
                    }
                    if (vm.filterData.unassignedBookingList.length) {
                        setMapOnAll(null, 'pickNotAssigned');
                        vm.filterData.dropLocationArray = _.uniq(vm.filterData.unassignedBookingList, function (x) {
                            return x.job_latitude && x.job_longitude;
                        });
                        vm.filterData.unassignedBookingList.forEach(function (data) {
                            data.job_pickup_datetime_filter = $filter('date')(data.original_pickup_datetime, "HH:mm");
                            data.distance = data.estimated_distance ? Math.round(data.estimated_distance / 1000) : 0;
                            data.type = 'pickNotAssigned';
                            data.text = 'Assign to Route';
                            createMarker(new google.maps.LatLng(data.job_pickup_latitude, data.job_pickup_longitude), data);
                        })

                        for (var i = 0; i < vm.filterData.unassignedBookingList.length; i++) {
                            var objetoPrincipal = vm.filterData.unassignedBookingList[i];
                            var objetoEncontrado = vm.filterData.selectedDiscard.find(function(objeto) {
                              return objeto.job_id === objetoPrincipal.job_id;
                            });

                            if (objetoEncontrado) {
                                vm.filterData.unassignedBookingList[i].selected = true;
                            }
                        }
                    }

                    if (vm.filterData.dropLocationArray.length) {
                        vm.filterData.dropLocationArray.forEach(function (data) {
                            data.type = 'drop';
                            createMarker(new google.maps.LatLng(data.job_latitude, data.job_longitude), data);
                        })
                    }
                    unassignLength = vm.filterData.unassignedBookingList.length;
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    vm.unassignedBookingListLoading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }


        //=================pagination changed for unassigned bookings================
        function paginationChangedForUnassigned() {
            if (vm.filterData.filter_pickup_from_date_value && vm.filterData.filter_pickup_from_time_value) {
                var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            }
            if (vm.filterData.filter_pickup_to_date_value && vm.filterData.filter_pickup_to_time_value) {
                var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            }
            if (vm.filterData.unassignedBookingCountShow > vm.filterData.unassignedBookingList.length) {
                vm.filterData.unassignedSkip = vm.filterData.unassignedSkip + vm.filterData.unassignedLimitMade;
                getGroupedOnly(false, pickFromDate, pickToDate, 'scroll');
                //applyFilter('scroll');
            }
        }

        function paginationChangedForCreated() {
            if (vm.filterData.filter_pickup_from_date_value_package && vm.filterData.filter_pickup_from_time_value_package) {
                var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value_package, vm.filterData.filter_pickup_from_time_value_package);
            }
            if (vm.filterData.filter_pickup_to_date_value_package && vm.filterData.filter_pickup_to_time_value_package) {
                var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value_package, vm.filterData.filter_pickup_to_time_value_package);
            }
            if (vm.filterData.createdBookingCount > vm.filterData.createdBookingList.length) {
                vm.filterData.createdSkip = vm.filterData.createdSkip + 15;
                getGroupedPackageList('scroll', true, pickFromDate, pickToDate);
            }
        }

        //===================drag and drop functions======================
        //$scope.$watch('vm.filterData', function(model) {
        //}, true);

        vm.sortableOptions = {
            placeholder: "app",
            connectWith: ".apps-container",
            helper: function (e, item) {
                vm.oldJobId = Number(item[0].id.split('-')[0]);
                return item;
            },
            update: function (e, ui) {
                $timeout(function () {
                    calculateDataAndValidatePackage();
                }, 100);
                unassignLength = vm.filterData.unassignedBookingList.length;
            }
        };
        vm.sortableOptionsUnassign = {
            placeholder: "app",
            connectWith: ".apps-container",
            helper: function (e, item) {
                vm.newJobId = Number(item[0].id.split('-')[0]);
                vm.newPassenger = Number(item[0].id.split('-')[1]);
                return item;
            },
            update: function (e, ui) {
                if (vm.filterData.unassignedBookingList.length > unassignLength)
                    setFlagInJob(vm.oldJobId);
                //calculateDataAndValidatePackage();
            }
        };

        vm.click1 = function (data, index) {
            var data_validate = [];
            vm.bookingsAssignmentTab = true;
            vm.servicesCreatedTab = false;
            vm.lowerTabsBody = true;
            data_validate.push(data);
            //TV-2179 
            // vm.filterData.unassignedBookingList.splice(index, 1);
            vm.filterData.makePackageList.push(data);
            if (vm.filterData.makePackageList.length > 0) {
                vm.filterData.filterAppliedService = true;
                $('#packageFilter').hide();
            }
            vm.ErrorData = data;
            unassignLength = vm.filterData.unassignedBookingList.length;
            if (vm.filterData.unassignedBookingList.length > unassignLength)
                setFlagInJob(data.job_id);
            $timeout(function () {
                // hitDistanceMatrixForGoogleMapsToAirport();
                // calculateDataAndValidatePackage();
                console.log('>>>>>>>>', data_validate);
                toValidateAllBookings(data_validate);
            }, 100);
        }
        vm.click2 = function (data, index) {
            var messageState = '';
            if (data.job_status == 1) {
                messageState = ' Esta reserva no puede ser removida del paquete porque ya fue iniciada.';
            }
            if (data.job_status == 2) {
                messageState = 'Esta reserva no puede ser removida del paquete porque ya fue Finalizada.';
            }
            if (data.job_status == 2 || data.job_status == 1) {
                errorMessageFactory.showErrorMessage(messageState, 0);
                return;
            }
            vm.filterData.makePackageList.splice(index, 1);
            //TV-2179 
            var index = vm.filterData.unassignedBookingList.findIndex(function (x) {
                return x.job_id == data.job_id;
            });
            var object = {
                job_time_utc: data.job_time_utc,
                branch_id: data.branch,
                contract_id: data.contract_id,
                service_id: data.type_of_service,
                type_of_trip: data.type_of_trip,
                job_status: data.job_status
            };
            data.text = 'Assign to Route';
            if ((index < 0) && checkStatus(object)) {
                vm.filterData.unassignedBookingList.push(data);
            }
            // vm.filterData.unassignedBookingList.push(data);
            changeAssignedData();
            setFlagInJob(data.job_id);
        }


        function blockUnblockBooking(id, type) {
            // $log.log(data);
            vm.loading = true;
            var promise = adminAccessService.checkStateValid('Desbloquear'); //$stateParams.id
            return promise.then(
                function (payload) {
                    vm.loading = false;
                    console.log(payload);
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (!payload.title.data.granted) {
                            languageBasedErrorFactory.getProperErrorMessage('optionNotAvail', 0, 0);
                            //errorMessageFactory.showErrorMessage('Option not available because you not have the right',0);
                            return false;
                        } else {
                            vm.loading = false;
                            setFlagInJob(id, type)
                            return true;
                        }
                    }
                },
                function (errorPayload) {
                    console.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        //===================set flag in job=====================
        function setFlagInJob(id, type) {
            console.log(type, id);

            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.job_id = [];
            if (typeof id != 'number') {
                id.forEach(function (d) {
                    dataSend.job_id.push(d);
                })
            } else dataSend.job_id.push(id);
            if (type == 'popUp') {
                dataSend.desbloquear_unlock = 1;
            }
            var promise = sharedRouteAssignment.makeFlagSetInJob(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    if (payload && payload.title.status == 200) {
                        // if (type == 'popUp') {
                        //     errorMessageFactory.showErrorMessage('Booking Unlock Successfull', 0);
                        // }
                        if (type)
                            if (typeof id != 'number') {
                                id.forEach(function (d) {
                                    decreaseDataWhenBookingIsRemoved(d)
                                })
                            } else decreaseDataWhenBookingIsRemoved(id);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function decreaseDataWhenBookingIsRemoved(job_id) {
            var findIndex = _.findIndex(vm.filterData.unassignedBookingList, {
                job_id: job_id
            })
            console.log(findIndex, vm.filterData.unassignedBookingList[findIndex]);
            if (findIndex != -1) {
                vm.filterData.totalPassengerAssigned > 0 ? vm.filterData.totalPassengerAssigned -= vm.filterData.unassignedBookingList[findIndex].number_of_passangers || 0 : vm.filterData.totalPassengerAssigned = 0;
                if (vm.filterData.modifyFlag) {
                    vm.filterData.totalAssignedETA = _.max(vm.filterData.makePackageList, function (x) {
                        return x.newDataEta;
                    }).newDataEta;
                } else {
                    vm.filterData.totalAssignedETA = _.max(vm.filterData.makePackageList, function (x) {
                        return x.newEta;
                    }).newEta;
                }
                vm.filterData.totalBookingAssigned > 0 ? vm.filterData.totalBookingAssigned -= 1 : vm.filterData.totalBookingAssigned = 0;
                vm.filterData.unassignedBookingList[findIndex].text = 'Assign to Route';
            }
        }

        //function dropedArea(item,index,event){
        //    if(vm.filterData.makePackageList && vm.filterData.makePackageList.length){
        //        if(vm.parentDragStart){
        //            var totalPassengerAlreadyInPackage = vm.filterData.totalPassengerAssigned + Number(item.number_of_passangers);
        //            if(totalPassengerAlreadyInPackage > vm.filterData.serviceDetailsSelected.max){
        //                var msg = 'The total passenger of service exceed to passengers allowed to ' + vm.filterData.serviceDetailsSelected.name;
        //                errorMessageFactory.showErrorMessage(msg, 0);
        //                vm.parentDragStart = false;
        //                return false;
        //            }
        //            else{
        //                arrangeDataInDroppedArea(item);
        //            }
        //        }
        //        else{
        //            arrangeDataInDroppedArea(item);
        //        }
        //    }
        //    else{
        //        arrangeDataInDroppedArea(item);
        //    }
        //}

        //function arrangeDataInDroppedArea(item){
        //    var index = _.findIndex(vm.filterData.unassignedBookingList, {job_id: item.job_id});
        //    if(index >= 0){
        //        vm.filterData.unassignedBookingList.splice(index,1);
        //    }
        //
        //    if(vm.filterData.makePackageList.length){
        //        var where = _.findIndex(vm.filterData.makePackageList, {job_id: item.job_id});
        //        if(where < 0)
        //            vm.filterData.makePackageList.push(item);
        //    }
        //    else{
        //        vm.filterData.makePackageList.push(item);
        //    }
        //    vm.parentDragStart = false;
        //    return true;
        //}

        //function onDragstart(item, event){
        //    vm.parentDragStart = true;
        //}
        //
        //function dropedAreaBack(item){
        //    if(!vm.parentDragStart){
        //        var index = _.findIndex(vm.filterData.makePackageList, {job_id: item.job_id});
        //        if(index >= 0)
        //            vm.filterData.makePackageList.splice(index,1);
        //        vm.filterData.unassignedBookingList.push(item);
        //        return true;
        //    }
        //}

        function calculateDataAndValidatePackage() {
            vm.parentDragStart = false;
            //vm.filterData.unassignedBookingCount = vm.filterData.unassignedBookingList.length;
            //changeAssignedData();
            if (vm.filterData.makePackageList.length) {
                if (!vm.filterData.modifyFlag) {
                    if (vm.filterData.typeOfTrip == 'R') {
                        setMapOnAll(null, 'all');
                        vm.filterData.commonPickUp = false;
                        hitDistanceMatrixForGoogleMapsToAirport();
                        // hitGoogleDirecationsApi();
                    } else if (vm.filterData.typeOfTrip == 'Z') {
                        setMapOnAll(null, 'all');
                        vm.filterData.commonPickUp = true;
                        // hitGoogleDirecationsApi();
                        // hitGoogleDirecationsApiFrom();
                        hitDistanceMatrixForGoogleMapsFromAirport();
                    } else if (vm.filterData.typeOfTrip == 'P') {
                        checkPoinToPointBookings();
                    }
                } else {
                    if (vm.filterData.typeOfTripModify == 'R') {
                        setMapOnAll(null, 'all');
                        vm.filterData.commonPickUp = false;
                        // hitGoogleDirecationsApi();
                        hitDistanceMatrixForGoogleMapsToAirport();
                    } else if (vm.filterData.typeOfTripModify == 'Z') {
                        setMapOnAll(null, 'all');
                        vm.filterData.commonPickUp = true;
                        // hitGoogleDirecationsApiFrom();
                        hitDistanceMatrixForGoogleMapsFromAirport();
                    } else if (vm.filterData.typeOfTripModify == 'P') {
                        checkPoinToPointBookings();
                    }
                }

                //makePathFromGoogle();
            } else {
                setMapOnAll(null, 'all');
                directionsDisplay.setMap(null);
                vm.filterData.totalPassengerAssigned = 0;
                vm.filterData.totalAssignedETA = 0;
                vm.filterData.totalBookingAssigned = 0;
                if (vm.filterData.unassignedBookingCountShow > 0) {
                    vm.filterData.unassignedBookingCount = vm.filterData.unassignedBookingCountShow;
                } else {
                    vm.filterData.unassignedBookingCount = vm.filterData.unassignedBookingList.length;
                }
                vm.filterData.unassignedBookingList.forEach(function (data) {
                    data.job_pickup_datetime_filter = $filter('date')(data.original_pickup_datetime, "HH:mm");
                    data.type = 'pickNotAssigned';
                    data.text = 'Assign to Route';
                    // data.is_valid_tolerance = true;
                    data.distance = data.estimated_distance ? Math.round(data.estimated_distance / 1000) : 0;
                    createMarker(new google.maps.LatLng(data.job_pickup_latitude, data.job_pickup_longitude), data);
                });
                vm.filterData.dropLocationArray.forEach(function (data) {
                    data.type = 'drop';
                    createMarker(new google.maps.LatLng(data.job_latitude, data.job_longitude), data);
                });
            }
        }

        function assignToPackageFromMap(id) {
            var index = vm.filterData.makePackageList.findIndex(function (x) {
                return x.job_id == id;
            });
            if (index >= 0) {
                errorMessageFactory.showErrorMessage('La Reserva ya está en la pestaña CREAR SERVICIOS', 0);
                return;
            }
            var index = _.findIndex(vm.filterData.unassignedBookingList, {
                job_id: id
            });
            var where = _.where(vm.filterData.unassignedBookingList, {
                job_id: id
            })[0];
            if (index >= 0) {
                vm.newJobId = Number(where.job_id);
                vm.newPassenger = Number(where.number_of_passangers);
                var totalPassengerAlreadyInPackage = vm.filterData.totalPassengerAssigned + Number(where.number_of_passangers);
                if (totalPassengerAlreadyInPackage > vm.filterData.serviceDetailsSelected.max) {
                    var msg = 'The total passenger of service exceed to passengers allowed to ' + vm.filterData.serviceDetailsSelected.name;
                    errorMessageFactory.showErrorMessage(msg, 0);
                    return;
                } else {
                    var a = vm.filterData.unassignedBookingList.splice(index, 1);
                    vm.filterData.makePackageList.push(a[0]);
                    if (vm.filterData.makePackageList.length) {
                        if (!vm.filterData.modifyFlag) {
                            if (vm.filterData.typeOfTrip == 'R') {
                                setMapOnAll(null, 'all');
                                vm.filterData.commonPickUp = false;
                                hitDistanceMatrixForGoogleMapsToAirport();
                            } else if (vm.filterData.typeOfTrip == 'Z') {
                                setMapOnAll(null, 'all');
                                vm.filterData.commonPickUp = true;
                                hitDistanceMatrixForGoogleMapsFromAirport();
                            } else if (vm.filterData.typeOfTrip == 'P') {
                                checkPoinToPointBookings();
                            }
                        } else {
                            console.log(" i m in first else ");
                            if (vm.filterData.typeOfTripModify == 'R') {
                                console.log("drop >>>>>>>>>");
                                setMapOnAll(null, 'all');
                                vm.filterData.commonPickUp = false;
                                hitDistanceMatrixForGoogleMapsToAirport();
                            } else if (vm.filterData.typeOfTripModify == 'Z') {
                                setMapOnAll(null, 'all');
                                vm.filterData.commonPickUp = true;
                                hitDistanceMatrixForGoogleMapsFromAirport();
                            } else if (vm.filterData.typeOfTripModify == 'P') {
                                checkPoinToPointBookings();
                            }
                        }
                        //makePathFromGoogle();
                    } else {
                        console.log(" i m in second else ");
                        setMapOnAll(null, 'all');
                        directionsDisplay.setMap(null);
                        vm.filterData.totalPassengerAssigned = 0;
                        vm.filterData.totalAssignedETA = 0;
                        vm.filterData.totalBookingAssigned = 0;
                        if (vm.filterData.unassignedBookingCountShow > 0) {
                            vm.filterData.unassignedBookingCount = vm.filterData.unassignedBookingCountShow;
                        } else {
                            vm.filterData.unassignedBookingCount = vm.filterData.unassignedBookingList.length;
                        }
                        vm.filterData.unassignedBookingList.forEach(function (data) {
                            data.job_pickup_datetime_filter = $filter('date')(data.original_pickup_datetime, "HH:mm");
                            data.type = 'pickNotAssigned';
                            data.text = 'Assign to Route';
                            // data.is_valid_tolerance = true;
                            data.distance = data.estimated_distance ? Math.round(data.estimated_distance / 1000) : 0;
                            createMarker(new google.maps.LatLng(data.job_pickup_latitude, data.job_pickup_longitude), data);
                        });
                        vm.filterData.dropLocationArray.forEach(function (data) {
                            data.type = 'drop';
                            createMarker(new google.maps.LatLng(data.job_latitude, data.job_longitude), data);
                        });
                    }
                    $scope.$digest();
                }
            }
        }

        //======================distance matrix only for getting eta==================
        function checkPoinToPointBookings() {
            if (vm.filterData.makePackageList.length > 1) {
                var pickCheck = {
                    lat: vm.filterData.makePackageList[vm.filterData.makePackageList.length - 1].job_pickup_latitude,
                    lng: vm.filterData.makePackageList[vm.filterData.makePackageList.length - 1].job_pickup_longitude
                }
                var pickCenter = {
                    lat: vm.filterData.makePackageList[0].job_pickup_latitude,
                    lng: vm.filterData.makePackageList[0].job_pickup_longitude
                }
                var dropCheck = {
                    lat: vm.filterData.makePackageList[vm.filterData.makePackageList.length - 1].job_latitude,
                    lng: vm.filterData.makePackageList[vm.filterData.makePackageList.length - 1].job_longitude
                }
                var dropCenter = {
                    lat: vm.filterData.makePackageList[0].job_latitude,
                    lng: vm.filterData.makePackageList[0].job_longitude
                }
                var pickUpFlag = arePointsNear(pickCheck, pickCenter, Number(vm.filterData.globalDistance / 1000));
                var dropOffFlag = arePointsNear(dropCheck, dropCenter, Number(vm.filterData.globalDistance / 1000));
                if (pickUpFlag && !dropOffFlag) {
                    setMapOnAll(null, 'all');
                    vm.filterData.commonPickUp = true;
                    hitDistanceMatrixForGoogleMapsFromAirport();
                } else if (!pickUpFlag && dropOffFlag) {
                    setMapOnAll(null, 'all');
                    vm.filterData.commonPickUp = false;
                    hitDistanceMatrixForGoogleMapsToAirport();
                } else if (pickUpFlag && dropOffFlag) {
                    setMapOnAll(null, 'all');
                    vm.filterData.commonPickUp = false;
                    hitDistanceMatrixForGoogleMapsToAirport();
                } else if (!pickUpFlag && !dropOffFlag) {
                    var splicedBooking = vm.filterData.makePackageList.splice(vm.filterData.makePackageList.length - 1, 1)[0];
                    vm.filterData.unassignedBookingList.push(splicedBooking);
                    vm.filterData.unassignedBookingCount = vm.filterData.unassignedBookingCountShow;
                    errorMessageFactory.showErrorMessage('Booking does not have unique pickup and dropoff.', 0);
                    return;
                }
            } else {
                setMapOnAll(null, 'all');
                vm.filterData.commonPickUp = false;
                hitDistanceMatrixForGoogleMapsToAirport();
            }
        }


        //============to check point lies in 50 m================
        function arePointsNear(checkPoint, centerPoint, km) {
            var ky = 40000 / 360;
            var kx = Math.cos(Math.PI * centerPoint.lat / 180.0) * ky;
            var dx = Math.abs(centerPoint.lng - checkPoint.lng) * kx;
            var dy = Math.abs(centerPoint.lat - checkPoint.lat) * ky;
            return Math.sqrt(dx * dx + dy * dy) <= km;
        }

        function hitDistanceMatrixForGoogleMapsToAirport(type) {
            var dataSend = {};
            var puntos = {};
            if (vm.filterData.makePackageList.length > 0) {
                var x, y;
                for (var i = 0; i < vm.filterData.makePackageList.length; i++) {
                        x = i;
                        y = i + 1;
                    var key = 'waypoint' + x;
                    var key1 = 'waypoint' + y;
                    puntos[key] = Number(vm.filterData.makePackageList[i].job_pickup_latitude) + ',' + Number(vm.filterData.makePackageList[i].job_pickup_longitude);
                    puntos[key1] = Number(vm.filterData.makePackageList[i].job_latitude) + ',' + Number(vm.filterData.makePackageList[i].job_longitude);
                }
                dataSend.origin = Number(vm.filterData.makePackageList[0].job_pickup_latitude) + ',' + Number(vm.filterData.makePackageList[0].job_pickup_longitude);
                for (var i = 0; i < vm.filterData.makePackageList.length; i++) {
                    if(i > 0){
                        dataSend.via = Number(vm.filterData.makePackageList[i].job_pickup_latitude) + ',' + Number(vm.filterData.makePackageList[i].job_pickup_longitude);

                    }
                }
                dataSend.destination = Number(vm.filterData.makePackageList[vm.filterData.makePackageList.length - 1].job_latitude) + ',' + Number(vm.filterData.makePackageList[vm.filterData.makePackageList.length - 1].job_longitude);

            }
            directionsDisplay.setMap(map);
            directionsDisplay.setOptions({
                suppressMarkers: true
            });
            dataSend.departureTime = new Date().toISOString();
            var promise = sharedRouteAssignment.distanceMatricHereMapApiGroup(dataSend);
            promise.then(
                function (response) {
                    $log.log('sxdsads', response);
                    vm.loading = false;
                    vm.payloadResponse = JSON.parse(response.response);
                    var newEta = 0;
                    var distance = 0;
                    //console.log(vm.filterData.makePackageList, '>>>>>>>>>>>>> first array >>>>>>>>>>>');
                    for (var i = 0; i < vm.filterData.makePackageList.length; i++) {
                        var newEta = 0;
                        var distance = 0;
                        //for (var j = i; j < vm.payloadResponse.response.route[0].leg.length; j++) {
                        for(var j = 0; j < vm.payloadResponse.routes[0].sections.length; j++){
                            //newEta = newEta + Math.round(vm.payloadResponse.response.route[0].leg[j].travelTime / 60);
                            newEta = newEta + Math.round(vm.payloadResponse.routes[0].sections[j].summary.duration / 60);
                            //distance = distance + Math.round(vm.payloadResponse.response.route[0].leg[j].length / 1000);
                            distance = distance + Math.round(vm.payloadResponse.routes[0].sections[j].summary.length / 1000);

                        }
                        vm.filterData.makePackageList[i].newEta = newEta;
                        vm.filterData.makePackageList[i].distance = distance;
                        console.log(vm.filterData.makePackageList);

                    }
                    if (type != 'modify') {
                        toValidateAllBookings(vm.filterData.makePackageList, type);
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function hitDistanceMatrixForGoogleMapsFromAirport(type) {
            console.log(type, 'type');

            var dataSend = {};
            var puntos = {};
            if (vm.filterData.makePackageList.length > 0) {
                var x, y;
                for (var i = 0; i < vm.filterData.makePackageList.length; i++) {
                    if (i == 0) {
                        x = i;
                        y = i + 1;
                    } else {
                        x = i;
                        y = x + 1;
                    }

                    var key = 'waypoint' + x;
                    var key1 = 'waypoint' + y;
                    if(i == 0)
                        puntos[key] = Number(vm.filterData.makePackageList[i].job_pickup_latitude) + ',' + Number(vm.filterData.makePackageList[i].job_pickup_longitude);
                        puntos[key1] = Number(vm.filterData.makePackageList[i].job_latitude) + ',' + Number(vm.filterData.makePackageList[i].job_longitude);
                    
                }
                dataSend.origin = Number(vm.filterData.makePackageList[0].job_pickup_latitude) + ',' + Number(vm.filterData.makePackageList[0].job_pickup_longitude);
                for (var i = 0; i < vm.filterData.makePackageList.length; i++) {
                    if(i > 0){
                        dataSend.via = Number(vm.filterData.makePackageList[i].job_latitude) + ',' + Number(vm.filterData.makePackageList[i].job_longitude);

                    }
                }
                dataSend.destination = Number(vm.filterData.makePackageList[vm.filterData.makePackageList.length - 1].job_latitude) + ',' + Number(vm.filterData.makePackageList[vm.filterData.makePackageList.length - 1].job_longitude);

            }
            dataSend.departureTime = new Date().toISOString();
            var promise = sharedRouteAssignment.distanceMatricHereMapApiGroup(dataSend);
            promise.then(
                function (response) {
                    $log.log('sxdsads', response);
                    vm.loading = false;
                    vm.payloadResponse = JSON.parse(response.response);
                    var newEta = 0;
                    var distance = 0;
                    for (var i = 0; i < vm.filterData.makePackageList.length; i++) {
                        var newEta = 0;
                        var distance = 0;
                        //for (var j = i; j < vm.payloadResponse.response.route[0].leg.length; j++) {
                        for(var j = 0; j < vm.payloadResponse.routes[0].sections.length; j++){
                            //newEta = newEta + Math.round(vm.payloadResponse.response.route[0].leg[j].travelTime / 60);
                            newEta = newEta + Math.round(vm.payloadResponse.routes[0].sections[j].summary.duration / 60);
                            //distance = distance + Math.round(vm.payloadResponse.response.route[0].leg[j].length / 1000);
                            distance = distance + Math.round(vm.payloadResponse.routes[0].sections[j].summary.length / 1000);

                        }
                        vm.filterData.makePackageList[i].newEta = newEta;
                        vm.filterData.makePackageList[i].distance = distance; 
                    }
                    var createNewArray = [];
                    createNewArray.push(vm.filterData.makePackageList[vm.filterData.makePackageList.length - 1]);
                    if (type != 'modify') {
                        toValidateAllBookings(vm.filterData.makePackageList, type);
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        //===================validate all bookings========================
        function toValidateAllBookings(data, type, fulldata, google) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.jobs = [];
            if (google != 'google') {
                data.forEach(function (column) {
                    dataSend.jobs.push({
                        job_id: column.job_id,
                        new_eta: column.newEta
                    })
                })
            } else {
                data.forEach(function (column) {
                    dataSend.jobs.push({
                        job_id: column.job_id,
                        new_eta: column.newEta
                    })
                })
            }

            if (vm.filterData.serviceDetailsSelected.id) {
                dataSend.type_of_service = vm.filterData.serviceDetailsSelected.id;
            } else {
                dataSend.type_of_service = JSON.parse($cookies.get("group_type_of_service"));
            }

            dataSend.is_common_pickup = vm.filterData.commonPickUp;
            vm.loading = true;
            var promise = groupedRouteAssignment.validateGroupedServices(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    var msg = '<ul>';
                    //if(!payload.title.data.is_valid_contract && type != 'checkAgain'){
                    //    msg += '<li>Agreement does not allow mixed service.</li>';
                    //}
                    if (!payload.title.data.is_born_paid && type != 'checkAgain') {
                        msg += '<li>No se puede crear un paquete de reserva que no nace pagado</li>';
                        //errorMessageFactory.showErrorMessage('No se puede crear un paquete de reserva que no nace pagado', 0);
                    }
                    // if (!payload.title.data.is_valid_pax && type != 'checkAgain') {
                    //     msg += '<li>The total passenger of service exceed to passengers allowed to ' + vm.filterData.serviceDetailsSelected.name + '</li>';
                    //     //var msg = 'The total passenger of service exceed to passengers allowed to ' + vm.filterData.serviceDetailsSelected.name;
                    //     //errorMessageFactory.showErrorMessage(msg, 0);
                    // }
                    msg += '</ul>';
                    if (msg.indexOf('<li>') > -1 && type != 'checkAgain') {
                        vm.items = {};
                        vm.items.msg = msg;
                        var parentEl = angular.element($document.body);
                        $mdDialog.show({
                            parent: parentEl,
                            targetEvent: parentEl,
                            templateUrl: 'app/components/dialogViews/sharedGroupedError.html',
                            bindToController: true,
                            locals: {
                                items: vm.items
                            },
                            controller: ErrorControllerG
                        });

                        function ErrorControllerG($scope, $mdDialog, items) {
                            $scope.items = items;
                            $scope.closeDialog = function () {
                                setFlagInJob(dataSend.jobs[0].job_id);
                                var index = vm.filterData.makePackageList.findIndex(function (x) {
                                    return x.job_id == dataSend.jobs[0].job_id;
                                });
                                if (index >= 0) {
                                    vm.filterData.makePackageList.splice(index, 1);
                                    // vm.filterData.unassignedBookingList.push(fulldata);
                                    // applyFilter('modify');
                                    // errorMessageFactory.showErrorMessage('Boooking is  already in Crear Servicios', 0);
                                    return;
                                }
                                $mdDialog.hide();

                            }
                        }
                    }
                    if (!(!payload.title.data.is_born_paid && type != 'checkAgain')) {
                        toFilterArrays(payload.title.data, type);
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        setFlagInJob(errorPayload.data.data.job_id[0].job_id);
                        vm.filterData.makePackageList.splice(vm.ErrorData, 1);
                        vm.filterData.unassignedBookingList.push(vm.ErrorData);
                    }
                }
            );
        }

        //======================make assignment with route======================
        function toFilterArrays(data, type) {
            console.log(vm.filterData.makePackageList, 'vm.filterData.makePackageList>>>>>>>>>>>>>>');

            if (data.is_born_paid && data.is_valid_pax) {
                for (var i = 0; i < data.jobs.length; i++) {
                    for (var j = 0; j < vm.filterData.makePackageList.length; j++) {
                        if (vm.filterData.makePackageList[j].job_id == data.jobs[i].job_id) {
                            vm.filterData.makePackageList[j].is_valid_tolerance = data.jobs[i].is_valid_tolerance;
                            vm.filterData.makePackageList[j].job_dropoff_utc_new = data.jobs[i].temp_delivery_time;
                            vm.filterData.makePackageList[j].job_time_new = data.jobs[i].temp_pickup_time;
                            vm.filterData.makePackageList[j].newEta = data.jobs[i].temp_eta;
                            // vm.filterData.makePackageList[j].is_group_external = data.jobs[i].is_group_external;
                        }
                    }
                }
                if (vm.filterData.unassignedBookingCountShow > 0) {
                    vm.filterData.unassignedBookingCount = vm.filterData.unassignedBookingCountShow - vm.filterData.makePackageList.length;
                } else {
                    vm.filterData.unassignedBookingCount = vm.filterData.unassignedBookingCountShow + vm.filterData.makePackageList.length;
                }
                changeAssignedData(type);
            }
            //else if(!data.is_valid_pax){
            //    var indexOfProblem = _.findIndex(vm.filterData.makePackageList,{job_id:vm.newJobId});
            //    if(indexOfProblem > -1){
            //        var splicedBooking = vm.filterData.makePackageList.splice(indexOfProblem,1)[0];
            //        vm.filterData.unassignedBookingList.push(splicedBooking);
            //    }
            //    for(var i=0;i<data.jobs.length;i++){
            //        for(var j=0;j<vm.filterData.makePackageList.length;j++){
            //            if(vm.filterData.makePackageList[j].job_id == data.jobs[i].job_id){
            //                vm.filterData.makePackageList[j].is_valid_tolerance = data.jobs[i].is_valid_tolerance;
            //                vm.filterData.makePackageList[j].job_dropoff_utc_new = data.jobs[i].temp_delivery_time;
            //                vm.filterData.makePackageList[j].job_time_new = data.jobs[i].temp_pickup_time;
            //            }
            //        }
            //    }
            //    vm.filterData.unassignedBookingCount = vm.filterData.unassignedBookingCountShow - vm.filterData.makePackageList.length;
            //    changeAssignedData(type);
            //}
            else {
                var indexOfProblem = _.findIndex(vm.filterData.makePackageList, {
                    job_id: vm.newJobId
                });
                // if (indexOfProblem > -1) {
                //     // var splicedBooking = vm.filterData.makePackageList.splice(indexOfProblem, 1)[0];
                //     vm.filterData.unassignedBookingList.push(splicedBooking);
                // }
                for (var i = 0; i < data.jobs.length; i++) {
                    for (var j = 0; j < vm.filterData.makePackageList.length; j++) {
                        if (vm.filterData.makePackageList[j].job_id == data.jobs[i].job_id) {
                            vm.filterData.makePackageList[j].is_valid_tolerance = data.jobs[i].is_valid_tolerance;
                            vm.filterData.makePackageList[j].job_dropoff_utc_new = data.jobs[i].temp_delivery_time;
                            vm.filterData.makePackageList[j].job_time_new = data.jobs[i].temp_pickup_time;
                            vm.filterData.makePackageList[j].newEta = data.jobs[i].temp_eta;
                            // vm.filterData.makePackageList[j].is_group_external = data.jobs[i].is_group_external;
                        }
                    }
                }
                if (vm.filterData.unassignedBookingCountShow > 0) {
                    vm.filterData.unassignedBookingCount = vm.filterData.unassignedBookingCountShow - vm.filterData.makePackageList.length;
                } else {
                    vm.filterData.unassignedBookingCount = vm.filterData.unassignedBookingCountShow + vm.filterData.makePackageList.length;
                }
                changeAssignedData(type);
                //var problemWithBooking = data.jobs[data.jobs.length - 1];
                //var indexOfProblem = _.findIndex(vm.filterData.makePackageList,{job_id:problemWithBooking.job_id});
                //if(indexOfProblem > -1){
                //    var splicedBooking = vm.filterData.makePackageList.splice(indexOfProblem,1)[0];
                //    vm.filterData.unassignedBookingList.push(splicedBooking);
                //}
                //for(var i=0;i<data.jobs.length;i++){
                //    for(var j=0;j<vm.filterData.makePackageList.length;j++){
                //        if(vm.filterData.makePackageList[j].job_id == data.jobs[i].job_id){
                //            vm.filterData.makePackageList[j].is_valid_tolerance = data.jobs[i].is_valid_tolerance;
                //            vm.filterData.makePackageList[j].job_dropoff_utc_new = data.jobs[i].temp_delivery_time;
                //            vm.filterData.makePackageList[j].job_time_new = data.jobs[i].temp_pickup_time;
                //        }
                //    }
                //}
                //vm.filterData.unassignedBookingCount = vm.filterData.unassignedBookingCountShow - vm.filterData.makePackageList.length;
                //changeAssignedData(type);
            }
        }

        function changeAssignedData(type) {
            vm.filterData.totalPassengerAssigned = 0;
            vm.filterData.totalAssignedETA = 0;
            vm.filterData.totalBookingAssigned = 0;
            setMapOnAll(null, 'all');
            vm.filterData.unassignedBookingList.forEach(function (data) {
                data.job_pickup_datetime_filter = $filter('date')(data.original_pickup_datetime, "HH:mm");
                data.type = 'pickNotAssigned';
                data.text = 'Assign to Route';
                // data.is_valid_tolerance = true;
                data.distance = data.estimated_distance ? Math.round(data.estimated_distance / 1000) : 0;
                createMarker(new google.maps.LatLng(data.job_pickup_latitude, data.job_pickup_longitude), data);
            })
            vm.filterData.dropLocationArray.forEach(function (data) {
                data.type = 'drop';
                createMarker(new google.maps.LatLng(data.job_latitude, data.job_longitude), data);
            });
            if (vm.filterData.makePackageList && vm.filterData.makePackageList.length) {
                vm.filterData.totalAssignedETA = _.max(vm.filterData.makePackageList, function (x) {
                    return x.newEta;
                }).newEta;
                vm.filterData.makePackageList.forEach(function (data) {
                    vm.filterData.totalPassengerAssigned = vm.filterData.totalPassengerAssigned + Number(data.number_of_passangers);
                    vm.filterData.totalBookingAssigned = vm.filterData.totalBookingAssigned + 1;
                    data.job_pickup_datetime_filter = $filter('date')(data.original_pickup_datetime, "HH:mm");
                    //data.job_time_new = new Date(moment(new Date(data.job_dropoff_utc)).subtract(data.newEta * 60, 'seconds'));
                    data.job_pickup_datetime_filter_new = $filter('date')(data.job_time_new, "HH:mm");
                    data.type = 'pickAssigned';
                    data.text = '';
                    createMarker(new google.maps.LatLng(data.job_pickup_latitude, data.job_pickup_longitude), data);
                })
            } else {
                vm.filterData.totalPassengerAssigned = 0;
                vm.filterData.totalAssignedETA = 0;
                vm.filterData.totalBookingAssigned = 0;
            }
            if (vm.filterData.makePackageList.length) {
                //hitDistanceMatrixForGoogleMaps();
                if (!vm.filterData.modifyFlag) {
                    if (vm.filterData.typeOfTrip == 'R') {
                        if (type != 'checkAgain')
                            makePathFromGoogleToAirport();
                    } else if (vm.filterData.typeOfTrip == 'Z') {
                        if (type != 'checkAgain')
                            makePathFromGoogleFromAirport();
                    } else if (vm.filterData.typeOfTrip == 'P') {
                        checkPoinToPointBookingsPath(type);
                    }
                } else {
                    if (vm.filterData.typeOfTripModify == 'R') {
                        if (type != 'checkAgain')
                            makePathFromGoogleToAirport();
                    } else if (vm.filterData.typeOfTripModify == 'Z') {
                        if (type != 'checkAgain')
                            makePathFromGoogleFromAirport();
                    } else if (vm.filterData.typeOfTripModify == 'P') {
                        checkPoinToPointBookingsPath(type);
                    }
                }
            } else {
                directionsDisplay.setMap(null);
            }
        }


        function checkPoinToPointBookingsPath(type) {
            if (vm.filterData.makePackageList.length > 1) {
                var pickCheck = {
                    lat: vm.filterData.makePackageList[vm.filterData.makePackageList.length - 1].job_pickup_latitude,
                    lng: vm.filterData.makePackageList[vm.filterData.makePackageList.length - 1].job_pickup_longitude
                }
                var pickCenter = {
                    lat: vm.filterData.makePackageList[0].job_pickup_latitude,
                    lng: vm.filterData.makePackageList[0].job_pickup_longitude
                }
                var dropCheck = {
                    lat: vm.filterData.makePackageList[vm.filterData.makePackageList.length - 1].job_latitude,
                    lng: vm.filterData.makePackageList[vm.filterData.makePackageList.length - 1].job_longitude
                }
                var dropCenter = {
                    lat: vm.filterData.makePackageList[0].job_latitude,
                    lng: vm.filterData.makePackageList[0].job_longitude
                }
                var pickUpFlag = arePointsNear(pickCheck, pickCenter, Number(vm.filterData.globalDistance / 1000));
                var dropOffFlag = arePointsNear(dropCheck, dropCenter, Number(vm.filterData.globalDistance / 1000));
                if (pickUpFlag && !dropOffFlag) {
                    if (type != 'checkAgain')
                        makePathFromGoogleFromAirport();
                } else if (!pickUpFlag && dropOffFlag) {
                    if (type != 'checkAgain')
                        makePathFromGoogleToAirport();
                } else if (pickUpFlag && dropOffFlag) {
                    if (type != 'checkAgain')
                        makePathFromGoogleToAirport();
                } else if (!pickUpFlag && !dropOffFlag) {
                    if (type != 'checkAgain')
                        makePathFromGoogleToAirport();
                }
            } else {
                if (type != 'checkAgain')
                    makePathFromGoogleToAirport();
            }
        }

        function makePathFromGoogleToAirport(type) {
            var waypts = [];
            if (vm.filterData.makePackageList.length > 1) {
                vm.filterData.makePackageList.forEach(function (data, index) {
                    if (index > 0) {
                        waypts.push({
                            location: new google.maps.LatLng(data.job_pickup_latitude, data.job_pickup_longitude),
                            stopover: true
                        })
                    }
                });
            }
            if (type != 'modify')
                hitDistanceMatrixForGoogleMapsToAirport('checkAgain');
        }

        function hitGoogleDirecationsApiFrom(type) {
            var myLatlng = new google.maps.LatLng(vm.filterData.makePackageList[0].job_pickup_latitude, vm.filterData.makePackageList[0].job_pickup_longitude);
            var myLatlng1 = new google.maps.LatLng(vm.filterData.makePackageList[vm.filterData.makePackageList.length - 1].job_latitude, vm.filterData.makePackageList[vm.filterData.makePackageList.length - 1].job_longitude);
            var waypts = [];
            if (vm.filterData.makePackageList.length > 1) {
                vm.filterData.makePackageList.forEach(function (data, index) {
                    if (index < vm.filterData.makePackageList.length - 1) {
                        waypts.push({
                            location: new google.maps.LatLng(data.job_latitude, data.job_longitude),
                            stopover: true
                        })
                    }
                });
            }
            // var myLatlng1 = new google.maps.LatLng(vm.filterData.makePackageList[0].job_latitude, vm.filterData.makePackageList[0].job_longitude);
            directionsService.route({
                origin: myLatlng,
                optimizeWaypoints: true,
                waypoints: waypts.length ? waypts : [],
                destination: myLatlng1,
                travelMode: 'DRIVING'
            }, function (response, status) {
                if (status === 'OK') {
                    directionsDisplay.setDirections(response);
                    var createNewArray = [];

                    for (var i = 0; i < response.routes[0].waypoint_order.length; i++) {
                        createNewArray.push(vm.filterData.makePackageList[response.routes[0].waypoint_order[i]]);
                    }
                    createNewArray.push(vm.filterData.makePackageList[vm.filterData.makePackageList.length - 1]);
                    vm.filterData.makePackageList = createNewArray;
                    if (type != 'modify') {
                        // toValidateAllBookings(vm.filterData.makePackageList);
                        hitDistanceMatrixForGoogleMapsFromAirportNew('checkAgain');
                    }
                    $scope.$digest();
                } else {
                    window.alert('Directions request failed due to ' + status);
                }
            });
        }

        function hitGoogleDirecationsApi(type) {
            var waypts = [];
            if (vm.filterData.makePackageList.length > 1) {
                vm.filterData.makePackageList.forEach(function (data, index) {
                    console.log('debug', data);
                    if (index > 0) {
                        waypts.push({
                            location: new google.maps.LatLng(data.job_pickup_latitude, data.job_pickup_longitude),
                            stopover: true
                        })
                    }
                });
            }
            directionsDisplay.setMap(map);
            directionsDisplay.setOptions({
                suppressMarkers: true
            });
            var myLatlng = new google.maps.LatLng(vm.filterData.makePackageList[0].job_pickup_latitude, vm.filterData.makePackageList[0].job_pickup_longitude);
            var myLatlng1 = new google.maps.LatLng(vm.filterData.makePackageList[0].job_latitude, vm.filterData.makePackageList[0].job_longitude);
            directionsService.route({
                origin: myLatlng,
                optimizeWaypoints: true,
                waypoints: waypts.length ? waypts : [],
                destination: myLatlng1,
                travelMode: 'DRIVING'
            }, function (response, status) {
                if (status === 'OK') {
                    directionsDisplay.setDirections(response);
                    var createNewArray = [];
                    createNewArray.push(vm.filterData.makePackageList[0]);
                    for (var i = 0; i < response.routes[0].waypoint_order.length; i++) {
                        createNewArray.push(vm.filterData.makePackageList[response.routes[0].waypoint_order[i] + 1]);
                    }
                    vm.filterData.makePackageList = createNewArray;
                    if (type != 'modify')
                        hitDistanceMatrixForGoogleMapsToAirportNew('checkAgain');
                    $scope.$digest();
                } else {
                    window.alert('Directions request failed due to ' + status);
                }
            });
        }

        function hitDistanceMatrixForGoogleMapsFromAirportNew(type) {
            var waypts = [];
            if (vm.filterData.makePackageList.length > 1) {
                vm.filterData.makePackageList.forEach(function (data, index) {
                    if (index < vm.filterData.makePackageList.length - 1) {
                        waypts.push({
                            location: new google.maps.LatLng(data.job_latitude, data.job_longitude),
                            stopover: true
                        })
                    }
                });
            }
            directionsDisplay.setMap(map);
            directionsDisplay.setOptions({
                suppressMarkers: true
            });
            var myLatlng = new google.maps.LatLng(vm.filterData.makePackageList[0].job_pickup_latitude, vm.filterData.makePackageList[0].job_pickup_longitude);
            var myLatlng1 = new google.maps.LatLng(vm.filterData.makePackageList[vm.filterData.makePackageList.length - 1].job_latitude, vm.filterData.makePackageList[vm.filterData.makePackageList.length - 1].job_longitude);
            //var myLatlng1 = new google.maps.LatLng(vm.filterData.makePackageList[0].job_latitude, vm.filterData.makePackageList[0].job_longitude);
            directionsService.route({
                origin: myLatlng,
                optimizeWaypoints: true,
                waypoints: waypts.length ? waypts : [],
                destination: myLatlng1,
                travelMode: 'DRIVING'
            }, function (response, status) {
                if (status === 'OK') {
                    for (var i = 0; i < response.routes[0].legs.length; i++) {
                        var newEta = 0;
                        var distance = 0;
                        for (var j = 0; j <= i; j++) {
                            newEta = newEta + Math.round(response.routes[0].legs[j].duration.value / 60);
                            distance = distance + Math.round(response.routes[0].legs[j].distance.value / 1000);
                            vm.filterData.makePackageList[i].newEta = newEta;
                            vm.filterData.makePackageList[i].distance = distance;
                        }
                    }
                    var createNewArray = [];
                    for (var i = 0; i < response.routes[0].waypoint_order.length; i++) {
                        createNewArray.push(vm.filterData.makePackageList[response.routes[0].waypoint_order[i]]);
                    }
                    createNewArray.push(vm.filterData.makePackageList[vm.filterData.makePackageList.length - 1]);
                    vm.filterData.makePackageList = createNewArray;
                    console.log(vm.filterData.makePackageList, 'vm.filterData.makePackageList');

                    if (type != 'modify') {
                        toValidateAllBookings(vm.filterData.makePackageList, type, null, 'google');
                    }
                    $scope.$digest();
                } else {
                    window.alert('Directions request failed due to ' + status);
                }
            });
        }

        function hitDistanceMatrixForGoogleMapsToAirportNew(type) {
            console.log(type, '>>>>>>>>>>>>type>>>>>>>>>>>>>>>');

            var waypts = [];
            if (vm.filterData.makePackageList.length > 1) {
                vm.filterData.makePackageList.forEach(function (data, index) {
                    if (index > 0) {
                        waypts.push({
                            location: new google.maps.LatLng(data.job_pickup_latitude, data.job_pickup_longitude),
                            stopover: true
                        })
                    }
                });
            }
            directionsDisplay.setMap(map);
            directionsDisplay.setOptions({
                suppressMarkers: true
            });
            var myLatlng = new google.maps.LatLng(vm.filterData.makePackageList[0].job_pickup_latitude, vm.filterData.makePackageList[0].job_pickup_longitude);
            var myLatlng1 = new google.maps.LatLng(vm.filterData.dropLocationArray[0].job_latitude, vm.filterData.dropLocationArray[0].job_longitude);
            directionsService.route({
                origin: myLatlng,
                optimizeWaypoints: true,
                waypoints: waypts.length ? waypts : [],
                destination: myLatlng1,
                travelMode: 'DRIVING'
            }, function (response, status) {
                if (status === 'OK') {
                    for (var i = 0; i < response.routes[0].legs.length; i++) {
                        var newEta = 0;
                        var distance = 0;
                        for (var j = i; j < response.routes[0].legs.length; j++) {
                            newEta = newEta + Math.round(response.routes[0].legs[j].duration.value / 60);
                            distance = distance + Math.round(response.routes[0].legs[j].distance.value / 1000);

                        }
                        vm.filterData.makePackageList[i].newEta = newEta;
                        vm.filterData.makePackageList[i].distance = distance;
                        console.log(vm.filterData.makePackageList);

                    }
                    if (type != 'modify') {
                        toValidateAllBookings(vm.filterData.makePackageList, type, null, 'google');
                    }
                    $scope.$digest();
                } else {
                    window.alert('Directions request failed due to ' + status);
                }
            });
        }

        function makePathFromGoogleFromAirport(type) {
            var waypts = [];
            if (vm.filterData.makePackageList.length > 1) {
                vm.filterData.makePackageList.forEach(function (data, index) {
                    if (index < vm.filterData.makePackageList.length - 1) {
                        waypts.push({
                            location: new google.maps.LatLng(data.job_latitude, data.job_longitude),
                            stopover: true
                        })
                    }
                });
            }
            // directionsDisplay.setMap(map);
            // directionsDisplay.setOptions({
            //     suppressMarkers: true
            // });
            var myLatlng = new google.maps.LatLng(vm.filterData.makePackageList[0].job_pickup_latitude, vm.filterData.makePackageList[0].job_pickup_longitude);
            var myLatlng1 = new google.maps.LatLng(vm.filterData.makePackageList[vm.filterData.makePackageList.length - 1].job_latitude, vm.filterData.makePackageList[vm.filterData.makePackageList.length - 1].job_longitude);

            if (type != 'modify')
                hitDistanceMatrixForGoogleMapsFromAirport('checkAgain');
        }

        //==================save shared package==================
        function saveGroupPackage() {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.jobs = [];
            vm.filterData.makePackageList.forEach(function (column) {
                dataSend.jobs.push({
                    job_id: column.job_id,
                    new_eta: column.newEta
                })
            })
            // dataSend.type_of_service = vm.filterData.serviceDetailsSelected.id;
            if (vm.filterData.serviceDetailsSelected.id) {
                dataSend.type_of_service = vm.filterData.serviceDetailsSelected.id;
            } else {
                dataSend.type_of_service = JSON.parse($cookies.get("group_type_of_service"));
            }
            dataSend.is_common_pickup = vm.filterData.commonPickUp;
            var promise = groupedRouteAssignment.checkPassengerLimit(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    
                    if (payload.title.data.is_valid_pax) {
                        var confirm = $mdDialog.confirm()
                            .title('El número de pasajeros es mayor a la capacidad del vehiculo. Desea continuar?')
                            .textContent('')
                            .ariaLabel('Lucky day')
                            .targetEvent()
                            .ok('Confirm')
                            .cancel('Close');

                        $mdDialog.show(confirm).then(function () {
                            var promise = groupedRouteAssignment.groupedServicePackage(dataSend);
                            promise.then(
                                function (payload) {
                                    $log.log('sxdsads', payload);
                                    vm.loading = false;
                                    if (payload.title.status == 200) {
                                        errorMessageFactory.showErrorMessage(
                                            languageBasedErrorFactory.getProperErrorMessage('success_created_package', 0, 3), 0);
                                        newPackage();
                                    } else {
                                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                                    }
                                },
                                function (errorPayload) {
                                    $log.log(errorPayload);
                                    vm.loading = false;
                                    if (errorPayload.data.status == 401) {
                                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                                    } else {
                                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                                    }
                                }
                            );
                            newPackage();
                        }, function () {});
                    } else {
                        var promise = groupedRouteAssignment.groupedServicePackage(dataSend);
                        promise.then(
                            function (payload) {
                                $log.log('sxdsads', payload);
                                vm.loading = false;
                                if (payload.title.status == 200) {
                                    errorMessageFactory.showErrorMessage(
                                        languageBasedErrorFactory.getProperErrorMessage('success_created_package', 0, 3), 0);
                                    newPackage();
                                } else {
                                    errorMessageFactory.showErrorMessage(payload.title.message, 0);
                                }
                            },
                            function (errorPayload) {
                                $log.log(errorPayload);
                                vm.loading = false;
                                if (errorPayload.data.status == 401) {
                                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                                } else {
                                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                                }
                            }
                        );
                        newPackage();
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        //=================make new package button======================
        function newPackage(type, dataToModify, packageData) {
            if (vm.filterData.makePackageList && vm.filterData.makePackageList.length) {
                var jobData = [];
                vm.filterData.makePackageList.forEach(function (d) {
                    jobData.push(d.job_id);
                })
                setFlagInJob(jobData);
            }
            vm.filterData.makePackageList = [];
            vm.filterData.dropLocationArray = [];
            vm.filterData.makePackageCount = 0;
            vm.filterData.totalPassengerAssigned = 0;
            vm.filterData.totalBookingAssigned = 0;
            vm.filterData.totalAssignedETA = 0;
            vm.filterData.unassignedSkip = 0;
            vm.filterData.unassignedLimit = 10;
            vm.filterData.unassignedLimitMade = 10;
            vm.filterData.sharedServiceName = 'NEW';
            vm.filterData.vehicleAssigned = 'PENDING';
            serviceChanged(0);
            applyFilter('modify');
            if (type == 'modify') {
                $timeout(function () {
                    makeDataForModification(dataToModify.title.data.data, packageData);
                }, 1000);
            }
        }

        //====================get shared package list=======================
        function getGroupedPackageList(type, load, pickFromDate, pickToDate) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.offset = vm.filterData.createdSkip;
            dataSend.limit = vm.filterData.createdLimit;
            dataSend.branch = vm.filterData.branch_value_package;
            dataSend.booking_type = 2;
            if (vm.booking) {
                dataSend.booking_id = vm.booking;
            }
            if (vm.idPackete) {
                dataSend.package_id = vm.idPackete;
            }
            if (vm.vehicleSearch) {
                dataSend.vehicle_number = vm.vehicleSearch;
            }
            dataSend.type_of_trip = vm.filterData.typeOfTripPackage;


            dataSend.type_of_service = vm.filterData.service_value_package;
            if (vm.filterData.aggrement_value_package != 'all')
                dataSend.contract_id = vm.filterData.aggrement_value_package;
            //else dataSend.contract_id = '';
            if (pickFromDate && pickToDate) {
                dataSend.from_pickup_datetime = pickFromDate.toISOString();
                dataSend.to_pickup_datetime = pickToDate.toISOString();
            }


            vm.loading = load;
            var promise = sharedRouteAssignment.getSharedPackageBookingsList(dataSend);
            promise.then(
                function (payload) {
                    $log.log('getlist', payload);
                    vm.loading = false;
                    vm.filterData.createdBookingCount = payload.title.data.count;
                    if (type == 'scroll') {
                        for (var i = 0; i < payload.title.data.data.length; i++) {
                            vm.filterData.createdBookingList.push(payload.title.data.data[i]);
                        }
                    } else {
                        var sharedServiceIds = vm.filterData.createdBookingList.map(function(item) {
                            return item.shared_service_id;
                        });
                        for (var i = 0; i < payload.title.data.data.length; i++) {
                            var currentItem = payload.title.data.data[i];
                            var sharedServiceId = currentItem.shared_service_id;
                            // Verificar si el shared_service_id ya está presente en createdBookingList
                            if (sharedServiceIds.indexOf(sharedServiceId) === -1) {
                                vm.filterData.createdBookingList.push(currentItem);
                            }
                        }
                    }

                    for (var i = 0; i < vm.filterData.createdBookingList.length; i++) {
                        var objetoPrincipal = vm.filterData.createdBookingList[i];
                        var objetoEncontrado = vm.filterData.selectedExport.find(function(objeto) {
                          return objeto.shared_service_id === objetoPrincipal.shared_service_id;
                        });

                        if (objetoEncontrado) {
                            vm.filterData.createdBookingList[i].selected = true;
                        }
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data && errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        //======================assign bookings=================
        function assignBookings(data, $event) {
            var dataSend = {
                access_token: $cookies.get('obj'),
                shared_service_id: Number(data.shared_service_id),
                limit: 10,
                offset: 0,
                all_vehicles_flag: 0,
                item: '',
                search_id: '',
                key: 0,
            };
            vm.loading = true;
            var promise = sharedRouteAssignment.getAvailableDriverForShared(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.assignBookingData = {
                        payload: payload,
                        event: $event,
                        data: data
                    }
                    vm.arrayToshow = [];
                    // vm.exclude_car_id = _.uniq(payload.title.data.exclude_car_id);
                    for (var i = 0; i < payload.title.data.result.length; i++) {
                        var d = {};
                        d.unique_car_id = payload.title.data.result[i].unique_car_id;
                        d.last_name = payload.title.data.result[i].last_name;
                        d.first_name = payload.title.data.result[i].first_name;
                        d.phone = payload.title.data.result[i].phone;
                        d.country_code = payload.title.data.result[i].country_code;
                        d.is_available = payload.title.data.result[i].is_available;
                        d.name = payload.title.data.result[i].name;
                        d.status = payload.title.data.result[i].status;
                        d.fleet_id = payload.title.data.result[i].fleet_id;
                        d.off = payload.title.data.result[i].off ? payload.title.data.result[i].off : false;
                        d.job_status = payload.title.data.result[i].job_status;
                        d.limit = payload.title.data.limit;
                        // d.showFlag = vm.exclude_car_id.includes(payload.title.data.result[i].unique_car_id);
                        d.totalCount = payload.title.data.totalCount;
                        vm.arrayToshow.push(d);
                    }
                    openPopUpForAssignment(vm.arrayToshow, $event, data);
                    //driverGetFromManual(payload, $event, data);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function openPopUpForAssignment(data, $event, jobData) {
            vm.items = {
                allDrivers: data,
                selectedDriver: {},
                ShiftErrMsg: '',
                shared_service_id: jobData.shared_service_id,
                jobData: jobData,
                limit: data.length > 0 ? data[0].limit : 10,
                offset: 0,
                total: data.length > 0 ? data[0].totalCount : 10,
                searchDriver: '',
                searchDriverbyVehicleId: '',
                onOffDuty: '0',
                allVehicle: '0'
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/assignDriverToSharedService.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: AssignDriverDialogController
            });

            function AssignDriverDialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    if ($scope.items.selectedDriver.fleet_id) {
                        //finalSelectedDriverApi($scope.items);
                        checkBeforeAssignDriver($scope.items, $event);
                        $mdDialog.hide();
                    } else {
                        $scope.items.ShiftErrMsg = languageBasedErrorFactory.getProperErrorMessage('assignPopError', 0, '3');
                        $timeout(function () {
                            $scope.items.ShiftErrMsg = '';
                        }, 2000);
                    }
                };
                $scope.selectDriver = function (data) {
                    $log.log(data);
                    $scope.items.selectedDriver = data;
                };
                var filterTextTimeout = '';
                $scope.getAssignDriverSearch = function (data) {
                    $scope.items.offset = 0;
                    if (data && data.length) {
                        if (filterTextTimeout) $timeout.cancel(filterTextTimeout);
                        filterTextTimeout = $timeout(function () {
                            $scope.getDataDriver('search');
                        }, 500);
                    } else {
                        $scope.items.allDrivers = [];
                        $scope.getDataDriver();
                    }
                };

                $scope.paginationFunction = function () {
                    if ($scope.items.allDrivers.length == $scope.items.total) {
                        return;
                    }
                    $scope.items.offset = $scope.items.offset + 10;
                    $scope.getDataDriver();
                };

                $scope.getDataDriverChange = function () {
                    $scope.items.allDrivers = [];
                    $scope.items.offset = 0;
                    $scope.getDataDriver();
                }

                $scope.getDataDriver = function (type) {
                    var dataSend = {
                        access_token: $cookies.get('obj'),
                        shared_service_id: Number(jobData.shared_service_id),
                        limit: $scope.items.limit,
                        offset: $scope.items.offset,
                        item: $scope.items.searchDriver ? $scope.items.searchDriver : '',
                        search_id: $scope.items.searchDriverbyVehicleId ? $scope.items.searchDriverbyVehicleId : '',
                        key: $scope.items.onOffDuty,
                        all_vehicles_flag: $scope.items.allVehicle
                    };
                    vm.loading = true;
                    var promise = sharedRouteAssignment.getAvailableDriverForShared(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            vm.loading = false;
                            $scope.items.total = payload.title.data.totalCount;
                            if (type == 'search') {
                                // $scope.items.allDrivers = payload.title.data.result;
                                $scope.items.allDrivers = [];
                                // vm.exclude_car_id = payload.title.data.exclude_car_id;
                                for (var i = 0; i < payload.title.data.result.length; i++) {
                                    var d = {};
                                    d.unique_car_id = payload.title.data.result[i].unique_car_id;
                                    d.last_name = payload.title.data.result[i].last_name;
                                    d.first_name = payload.title.data.result[i].first_name;
                                    d.phone = payload.title.data.result[i].phone;
                                    d.country_code = payload.title.data.result[i].country_code;
                                    d.fleet_id = payload.title.data.result[i].fleet_id;
                                    d.off = payload.title.data.result[i].off ? payload.title.data.result[i].off : false;
                                    d.is_available = payload.title.data.result[i].is_available;
                                    d.name = payload.title.data.result[i].name;
                                    d.status = payload.title.data.result[i].status;
                                    d.job_status = payload.title.data.result[i].job_status;
                                    d.limit = payload.title.data.limit;
                                    // d.showFlag = vm.exclude_car_id.includes(payload.title.data.result[i].unique_car_id);
                                    d.totalCount = payload.title.data.totalCount;
                                    $scope.items.allDrivers.push(d);
                                }
                            } else {
                                // vm.exclude_car_id = payload.title.data.exclude_car_id;
                                for (var i = 0; i < payload.title.data.result.length; i++) {
                                    var d = {};
                                    d.unique_car_id = payload.title.data.result[i].unique_car_id;
                                    d.last_name = payload.title.data.result[i].last_name;
                                    d.first_name = payload.title.data.result[i].first_name;
                                    d.phone = payload.title.data.result[i].phone;
                                    d.fleet_id = payload.title.data.result[i].fleet_id;
                                    d.country_code = payload.title.data.result[i].country_code;
                                    d.off = payload.title.data.result[i].off ? payload.title.data.result[i].off : false;
                                    d.is_available = payload.title.data.result[i].is_available;
                                    d.name = payload.title.data.result[i].name;
                                    d.status = payload.title.data.result[i].status;
                                    d.job_status = payload.title.data.result[i].job_status;
                                    d.limit = payload.title.data.limit;
                                    // d.showFlag = vm.exclude_car_id.includes(payload.title.data.result[i].unique_car_id);
                                    d.totalCount = payload.title.data.totalCount;
                                    $scope.items.allDrivers.push(d);
                                }
                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }
            }
        }

        function checkBeforeAssignDriver(data, $event) {
            var dataSend = {
                access_token: $cookies.get('obj'),
                group_id: Number(data.shared_service_id),
                fleet_id: Number(data.selectedDriver.fleet_id)
            };
            vm.loading = true;
            var promise = sharedRouteAssignment.checkDriverStatusForShared(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        checkDriverPop(payload.title, data, $event);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        finalSelectedDriverApi(data);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        checkDriverPop(errorPayload.data.message, data, $event);
                    }
                }
            );
        }

        // function checkDriverPop(msg, data, $event) {
        //     var confirm = $mdDialog.confirm()
        //         .title(msg)
        //         .textContent('')
        //         .ariaLabel('Lucky day')
        //         .targetEvent($event)
        //         .ok(languageBasedErrorFactory.getProperErrorMessage('yes', 0, '3'))
        //         .cancel(languageBasedErrorFactory.getProperErrorMessage('no', 0, '3'));

        //     $mdDialog.show(confirm).then(function () {
        //         finalSelectedDriverApi(data);
        //     }, function () {
        //         $log.log('not confirmed');
        //     });
        // };




        function checkDriverPop(msg, data, $event) {
            vm.items = {};
            vm.items.data = msg.data.final_response;
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/manualAssignErrors.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: ErrorDialogController
            });

            function ErrorDialogController($scope, items, $mdDialog) {
                $scope.items = items;

                $scope.confirmDialog = function () {
                    $mdDialog.hide();
                    finalSelectedDriverApi(data);
                }
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                }
            }

            //var confirm = $mdDialog.confirm()
            //    .title(msg)
            //    .textContent('')
            //    .ariaLabel('Lucky day')
            //    .targetEvent($event)
            //    .ok('CONTINUE')
            //    .cancel('CANCEL');
            //
            //$mdDialog.show(confirm).then(function () {
            //    finalSelectedDriverApi(data);
            //}, function () {
            //    $log.log('not confirmed');
            //});
        };


        function finalSelectedDriverApi(data) {
            $log.log(data);
            var dataSend = {
                access_token: $cookies.get('obj'),
                shared_service_id: Number(data.shared_service_id),
                fleet_id: Number(data.selectedDriver.fleet_id),
                booking_type: 2
            };
            vm.loading = true;
            vm.fun = false;
            var promise = sharedRouteAssignment.manualAssignBookingToFleet(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        if (payload.title.data.is_valid_pax == "true") {
                            var confirm = $mdDialog.confirm()
                                .title(payload.title.message)
                                .textContent('')
                                .ariaLabel('Lucky day')
                                .targetEvent()
                                .ok('Confirm')
                                .cancel('Close');

                            $mdDialog.show(confirm).then(function () {
                                openPopUpForAssignment(vm.assignBookingData.payload, vm.assignBookingData.event, vm.assignBookingData.data);
                            }, function () {});
                        } else {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        languageBasedErrorFactory.getProperErrorMessage('driverAssignedSucc', 0, 0);
                        vm.filterData.createdSkip = 0;
                        vm.filterData.createdLimit = 15;
                        if (vm.filterData.filter_pickup_from_date_value_package && vm.filterData.filter_pickup_from_time_value_package) {
                            var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value_package, vm.filterData.filter_pickup_from_time_value_package);
                        }
                        if (vm.filterData.filter_pickup_to_date_value_package && vm.filterData.filter_pickup_to_time_value_package) {
                            var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value_package, vm.filterData.filter_pickup_to_time_value_package);
                        }
                        getGroupedPackageList('noScroll', false, pickFromDate, pickToDate);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };




        //=============================unassign booking==========================
        function unassignBooking(data, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('unassginPop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                var dataSend = {};
                vm.fun = true;
                dataSend.access_token = $cookies.get('obj');
                dataSend.shared_service_id = Number(data.shared_service_id);
                dataSend.booking_type = 2;
                vm.loading = true;
                var promise = sharedRouteAssignment.manualUnassignBookingToFleet(dataSend);
                promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        languageBasedErrorFactory.getProperErrorMessage('unassginSucc', 0, 0);
                        vm.filterData.createdSkip = 0;
                        vm.filterData.createdLimit = 15;
                        if (vm.filterData.filter_pickup_from_date_value_package && vm.filterData.filter_pickup_from_time_value_package) {
                            var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value_package, vm.filterData.filter_pickup_from_time_value_package);
                        }
                        if (vm.filterData.filter_pickup_to_date_value_package && vm.filterData.filter_pickup_to_time_value_package) {
                            var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value_package, vm.filterData.filter_pickup_to_time_value_package);
                        }
                        getGroupedPackageList('noScroll', false, pickFromDate, pickToDate);
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        }

        // =========================== delete Booking ===========================
        function deleteBooking(data, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('deletePackagePop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));
            $mdDialog.show(confirm).then(function () {
                var dataSend = {};
                vm.fun = true;
                dataSend.access_token = $cookies.get('obj');
                dataSend.package_id = data.shared_service_id;
                var promise = sharedRouteAssignment.deletePackageBooking(dataSend);
                promise.then(
                    function (payload) {
                        if (payload.title.status == 200) {
                            $log.log('sxdsads', payload);
                            vm.loading = false;
                            newPackage();
                            if (vm.filterData.filter_pickup_from_date_value_package && vm.filterData.filter_pickup_from_time_value_package) {
                                var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value_package, vm.filterData.filter_pickup_from_time_value_package);
                            }
                            if (vm.filterData.filter_pickup_to_date_value_package && vm.filterData.filter_pickup_to_time_value_package) {
                                var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value_package, vm.filterData.filter_pickup_to_time_value_package);
                            }
                            getGroupedPackageList('noScroll', false, pickFromDate, pickToDate);
                            // getSharedPackageList('noScroll', false);
                        } else {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        }
        // =========================== delete Booking ===========================

        //===============modify booking====================
        function modifyBooking(data) {
            vm.bookingsAssignmentTab = true;
            vm.servicesCreatedTab = false;
            var firstBookingDate = new Date(data.first_pickup_time).getDate();
            var firstBookingMonth = new Date(data.first_pickup_time).getMonth();
            var firstBookingYear = new Date(data.first_pickup_time).getFullYear();
            //if((firstBookingDate < new Date().getDate()) || (firstBookingMonth < new Date().getMonth()) || (firstBookingYear < new Date().getFullYear())){
            //    errorMessageFactory.showErrorMessage('You can not modify this package', 0);
            //    return;
            //}

            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.shared_service_id = Number(data.shared_service_id);
            dataSend.booking_type = 2;
            vm.loading = true;
            var promise = sharedRouteAssignment.getPackageDetails(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.packageData = data;
                    newPackage('modify', payload, data);
                    // hitDistanceMatrixForGoogleMapsToAirport();
                    // $timeout(function () {
                    //     hitDistanceMatrixForGoogleMapsToAirport();

                    // }, 100);
                    vm.checkClickedPackage = false;
                    $('#packageFilter').hide();
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        //=======================make data for modification=====================
        function makeDataForModification(data, packageData) {
            vm.filterData.modifyFlag = true;
            vm.filterData.sharedServiceName = packageData.shared_service_id;
            vm.filterData.vehicleAssigned = packageData.unique_car_id ? packageData.unique_car_id : 'PENDING';
            vm.filterData.serviceDetailsSelected = _.where(vm.service, {
                id: data[0].type_of_service
            })[0];
            vm.filterData.totalAssignedETA = _.max(data, function (x) {
                return x.eta;
            }).eta;
            data.forEach(function (column) {
                vm.filterData.totalPassengerAssigned = vm.filterData.totalPassengerAssigned + column.number_of_passangers;
                vm.filterData.totalBookingAssigned = vm.filterData.totalBookingAssigned + 1;

                //column.is_valid_tolerance = true;
                column.job_dropoff_utc_new = column.job_delivery_datetime;
                column.newEta = column.temp_eta;
                column.job_time_new = column.job_time_utc;
                column.job_pickup_datetime_filter = $filter('date')(column.original_pickup_datetime, "HH:mm");
                //data.job_time_new = new Date(moment(new Date(data.job_dropoff_utc)).subtract(data.newEta * 60, 'seconds'));
                column.job_pickup_datetime_filter_new = $filter('date')(column.job_time_new, "HH:mm");
                if (column.job_status == 1 || column.job_status == 2) {
                    column.type = 'pickAssigned';
                } else {
                    column.type = 'pickStarted';
                }
                if (new Date(column.time_with_tolerance_before).toISOString() == new Date(column.time_with_tolerance_after).toISOString()) {
                    column.is_group_external_new = true;
                } else {
                    column.is_group_external_new = false;
                }
                column.text = '';
                vm.filterData.typeOfTripModify = column.type_of_trip;
                //data is repeating
                vm.filterData.makePackageList.push(column);
                console.log(vm.filterData.makePackageList, 'vm.filterData.makePackageList>>>>>>>>>>>>>>');

                createMarker(new google.maps.LatLng(Number(column.job_pickup_latitude), Number(column.job_pickup_longitude)), column);
                // $timeout(function () {
                //     hitDistanceMatrixForGoogleMapsToAirport();

                // }, 100);
            });
            //hitDistanceMatrixForGoogleMapsFromAirport('modify');



            vm.filterData.dropLocationArray = _.uniq(vm.filterData.makePackageList, function (x) {
                return x.job_latitude && x.job_longitude;
            });
            if (vm.filterData.dropLocationArray.length) {
                vm.filterData.dropLocationArray.forEach(function (data) {
                    data.type = 'drop';
                    createMarker(new google.maps.LatLng(data.job_latitude, data.job_longitude), data);
                })
            }
            if (vm.filterData.typeOfTripModify == 'R') {
                //setMapOnAll(null,'all');
                vm.filterData.commonPickUp = false;
                // hitDistanceMatrixForGoogleMapsToAirport('modify');
                // makePathFromGoogleToAirport('modify');
            } else if (vm.filterData.typeOfTripModify == 'Z') {
                //setMapOnAll(null,'all');
                vm.filterData.commonPickUp = true;
                // hitDistanceMatrixForGoogleMapsFromAirport('modify');
                // makePathFromGoogleFromAirport('modify');
            } else if (vm.filterData.typeOfTripModify == 'P') {
                // checkPoinToPointBookingsModify();
            }

            //========Hit Api for Validate group package=====
            setTimeout(function () {
                console.log(vm.filterData.makePackageList, 'vm.filterData.makePackageList');

                var ds = {};
                ds.access_token = $cookies.get('obj');
                ds.jobs = [];
                data.forEach(function (column, key) {
                    ds.jobs.push({
                        job_id: column.job_id,
                        new_eta: vm.filterData.makePackageList[key].newEta
                    })
                })
                if (vm.filterData.makePackageList && vm.filterData.makePackageList.length) {
                    vm.filterData.makePackageList.map(function (obj, key) {
                        ds.jobs[key].new_eta = obj.newEta;
                    })
                }
                ds.type_of_service = vm.filterData.serviceDetailsSelected.id;
                ds.is_common_pickup = vm.filterData.commonPickUp;

                vm.loading = true;
                $http({
                        url: MY_CONSTANT.url + "/validate_group_package",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: ds
                    }).then(function (newDataRes) {
                        console.log(vm.filterData.makePackageList, 'vm.filterData.makePackageList');
                        vm.loading = false;
                        var newData = [];
                        newData = newDataRes.data.jobs;
                        for (var i = 0; i < vm.filterData.makePackageList.length; i++) {
                            for (var j = 0; j < newData.length; j++) {
                                if (vm.filterData.makePackageList[i].job_id == newData[j].job_id) {
                                    vm.filterData.makePackageList[i].newEta = newData[j].new_eta;
                                    vm.filterData.makePackageList[i].job_time_new = newData[j].temp_pickup_time;
                                    vm.filterData.makePackageList[i].job_dropoff_utc_new = newData[j].temp_delivery_time;
                                    vm.filterData.makePackageList[i].is_valid_tolerance = newData[j].is_valid_tolerance;
                                }
                            }
                        }
                    })
                    .catch(function (msg) {
                        vm.loading = false;
                        // deferred.reject(msg);
                        // return deferred.promise;
                    });
            }, 2000);

        }

        //===================check modify poin to point=======================
        function checkPoinToPointBookingsModify() {
            var pickUpFlag = '';
            var dropOffFlag = '';
            vm.filterData.makePackageList.forEach(function (data) {
                var pickCheck = {
                    lat: data.job_pickup_latitude,
                    lng: data.job_pickup_longitude
                }
                var pickCenter = {
                    lat: vm.filterData.makePackageList[0].job_pickup_latitude,
                    lng: vm.filterData.makePackageList[0].job_pickup_longitude
                }
                var dropCheck = {
                    lat: data.job_latitude,
                    lng: data.job_longitude
                }
                var dropCenter = {
                    lat: vm.filterData.makePackageList[0].job_latitude,
                    lng: vm.filterData.makePackageList[0].job_longitude
                }
                pickUpFlag = arePointsNear(pickCheck, pickCenter, 0.05);
                dropOffFlag = arePointsNear(dropCheck, dropCenter, 0.05);
            });

            if (pickUpFlag && !dropOffFlag) {
                //setMapOnAll(null,'all');
                vm.filterData.commonPickUp = true;
                hitDistanceMatrixForGoogleMapsFromAirport('modify');
                makePathFromGoogleFromAirport('modify');
            } else if (!pickUpFlag && dropOffFlag) {
                //setMapOnAll(null,'all');
                vm.filterData.commonPickUp = false;
                hitDistanceMatrixForGoogleMapsToAirport('modify');
                makePathFromGoogleToAirport('modify');
            } else if (pickUpFlag && dropOffFlag) {
                //setMapOnAll(null,'all');
                vm.filterData.commonPickUp = false;
                hitDistanceMatrixForGoogleMapsToAirport('modify');
                makePathFromGoogleToAirport('modify');
            }
        }

        //=================modify hit================

        function saveModifyGroupPackage() {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.jobs = [];
            vm.filterData.makePackageList.forEach(function (column) {
                dataSend.jobs.push({
                    job_id: column.job_id,
                    new_eta: column.newEta
                })
            })
            dataSend.type_of_service = vm.filterData.serviceDetailsSelected.id;
            // dataSend.shared_service_id = vm.packageData.shared_service_id;
            dataSend.is_common_pickup = vm.filterData.commonPickUp;
            // var promise = groupedRouteAssignment.groupedModifyPackage(dataSend);
            var promise = groupedRouteAssignment.checkPassengerLimit(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    dataSend.shared_service_id = vm.packageData.shared_service_id;
                    if (payload.title.data.is_valid_pax) {
                        var confirm = $mdDialog.confirm()
                            .title('El número de pasajeros es mayor a la capacidad del vehiculo. Desea continuar?')
                            .textContent('')
                            .ariaLabel('Lucky day')
                            .targetEvent()
                            .ok('Confirm')
                            .cancel('Close');

                        $mdDialog.show(confirm).then(function () {
                            var promise = groupedRouteAssignment.groupedModifyPackage(dataSend);
                            promise.then(
                                function (payload) {
                                    $log.log('sxdsads', payload);
                                    vm.loading = false;
                                    errorMessageFactory.showErrorMessage(
                                        languageBasedErrorFactory.getProperErrorMessage('success_update_package', 0, 3), 0);
                                    vm.filterData.createdSkip = 0;
                                    vm.filterData.createdLimit = 15;
                                    vm.packageData = '';
                                    if (vm.filterData.filter_pickup_from_date_value_package && vm.filterData.filter_pickup_from_time_value_package) {
                                        var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value_package, vm.filterData.filter_pickup_from_time_value_package);
                                    }
                                    if (vm.filterData.filter_pickup_to_date_value_package && vm.filterData.filter_pickup_to_time_value_package) {
                                        var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value_package, vm.filterData.filter_pickup_to_time_value_package);
                                    }
                                    getGroupedPackageList('noScroll', false, pickFromDate, pickToDate);
                                    newPackage();
                                },
                                function (errorPayload) {
                                    $log.log(errorPayload);
                                    vm.loading = false;
                                    if (errorPayload.data.status == 401) {
                                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                                    } else {
                                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                                    }
                                }
                            );
                        }, function () {});
                    } else {
                        var promise = groupedRouteAssignment.groupedModifyPackage(dataSend);
                        promise.then(
                            function (payload) {
                                $log.log('sxdsads', payload);
                                vm.loading = false;
                                errorMessageFactory.showErrorMessage(
                                    languageBasedErrorFactory.getProperErrorMessage('success_update_package', 0, 3), 0);
                                vm.filterData.createdSkip = 0;
                                vm.filterData.createdLimit = 15;
                                vm.packageData = '';
                                if (vm.filterData.filter_pickup_from_date_value && vm.filterData.filter_pickup_from_time_value) {
                                    var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
                                }
                                if (vm.filterData.filter_pickup_to_date_value && vm.filterData.filter_pickup_to_time_value) {
                                    var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
                                }
                                getGroupedPackageList('noScroll', false, pickFromDate, pickToDate);
                                newPackage();
                            },
                            function (errorPayload) {
                                $log.log(errorPayload);
                                vm.loading = false;
                                if (errorPayload.data.status == 401) {
                                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                                } else {
                                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                                }
                            }
                        );
                    }
                    // errorMessageFactory.showErrorMessage('Package updated successfully.', 0);
                    // vm.filterData.createdSkip = 0;
                    // vm.filterData.createdLimit = 15;
                    // vm.packageData = '';
                    // getGroupedPackageList('noScroll', false);
                    // newPackage();
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        // =================== DISCARD BOOKING STATUS CHANGE ================
        function discardBookingStatusChange(status) {
            vm.discardBookingStatus = !status;
            var pickFromDate = '';
            var pickToDate = '';
            if (vm.filterData.filter_pickup_from_date_value && vm.filterData.filter_pickup_from_time_value) {
                pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            }
            if (vm.filterData.filter_pickup_to_date_value && vm.filterData.filter_pickup_to_time_value) {
                pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            }
            $timeout.cancel(vm.yourTimer);
            vm.yourTimer = $timeout(function () {
                vm.loading = true;
                vm.filterData.unassignedBookingList = [];
                vm.filterData.offset = 0;
                vm.filterData.unassignedSkip = 0;
                vm.filterData.unassignedLimit = 10;
                vm.filterData.unassignedLimitMade = 10;
                getGroupedOnly(true, pickFromDate, pickToDate, 'scroll');
            }, 1000);
        }

        // ==================== DISCARD BOOKING FUNCTION ================
        function discardBooking(data, status, index) {
            if (status == 1) {
                var confirm = $mdDialog.confirm()
                    .title('¿Está seguro de que desea descartar la Reserva para que no sea agrupada?')
                    .textContent('')
                    .ariaLabel('Lucky day')
                    .targetEvent()
                    .ok('Confirm')
                    .cancel('Close');
                $mdDialog.show(confirm).then(function () {
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.job_id = data.job_id;
                    dataSend.discard_flag = status; // 1- discard booking from grouping, 0 - undiscard booking to be grouping
                    vm.loading = true;
                    var promise = groupedRouteAssignment.discardBooking(dataSend);
                    promise.then(
                        function (payload) {
                            vm.loading = false;
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                });
            } else {
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.job_id = data.job_id;
                dataSend.discard_flag = status; // 1- discard booking from grouping, 0 - undiscard booking to be grouping
                vm.loading = true;
                var promise = groupedRouteAssignment.discardBooking(dataSend);
                promise.then(
                    function (payload) {
                        vm.loading = false;
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }

        }

        //==================== GET SOCKET CONNECTION FOR DISCARD BOOKING===================
        var discardBookingSocket = $rootScope.$on('SocketForGetDataDiscardBooking', function (evt, data) {
            console.log(data, "first");

            if (data && data.data && data.data.message && data.data.message.jobArray && data.data.message.jobArray.length > 0) {
                for (var i = 0; i < data.data.message.jobArray.length; i++) {
                    var index = vm.filterData.unassignedBookingList.findIndex(function (x) {
                        return x.job_id == data.data.message.jobArray[i].job_id;
                    });
                    if (index >= 0) {
                        console.log('debug 2', vm.discardBookingStatus);
                        if (vm.discardBookingStatus) {
                            vm.filterData.unassignedBookingList[index].discard_from_group = 1;
                            $scope.$apply();
                        } else {
                            vm.filterData.unassignedBookingList.splice(index, 1);
                            $scope.$apply();
                        }
                    }
                }
            }

        });
        $scope.$on('$destroy', discardBookingSocket);


        //==================== GET SOCKET CONNECTION FOR UNDISCARD BOOKING===================
        var unDiscardBookingSocket = $rootScope.$on('SocketForGetDataUnDiscardBooking', function (evt, data) {
            console.log(data, "2nd");
            if (data && data.data && data.data.message && data.data.message.job_id > 0) {
                var index = vm.filterData.unassignedBookingList.findIndex(function (x) {
                    return x.job_id == data.data.message.job_id;
                });
                console.log(index);

                if (index >= 0) {
                    vm.filterData.unassignedBookingList[index].discard_from_group = vm.filterData.unassignedBookingList[index].discard_from_group = 0;
                    vm.filterData.unassignedBookingList.splice(index, 1);
                    $scope.$apply();
                }
            }

        });
        $scope.$on('$destroy', unDiscardBookingSocket);

        //==================== GET UNLOCK THE BOOKING ===================
        var UnlockSocket = $rootScope.$on('SocketComesValidation', function (evt, data) {
            console.log(data, "socket data");

            var index;
            if (data && data.res && data.res.message.length > 0) {
                data.res.message.forEach(function (data) {
                    index = vm.filterData.unassignedBookingList.findIndex(function (x) {
                        return x.job_id == data.job_id;
                    });
                    if (index >= 0) {
                        vm.filterData.unassignedBookingList[index].locking_id = data.locking_id;
                        vm.filterData.unassignedBookingList[index].locking_id_name = data.locking_id_name;
                        $scope.$apply();
                        // vm.filterData.unassignedBookingList.splice(index, 1);
                    }
                    // else{
                    //     vm.filterData.unassignedBookingList.push(data);
                    // }
                })

            }

        });
        $scope.$on('$destroy', UnlockSocket);

        // var quickAssingnment = $rootScope.$on('quickScreeenBookingCreationSocket', function (evt, data) {
        //     // console.log(data, "data>>>>>>>>>>>>>>>>>>>>>");
        //     // // var index;
        //     // vm.countToSocket == 0
        //     // if (data && data.res && data.res.message && data.res.message.jobArray.length > 0) {
        //     //     data.res.message.jobArray.forEach(function (data) {
        //     //         if (vm.filterData.filter_pickup_from_date_value && vm.filterData.filter_pickup_from_time_value) {
        //     //             var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
        //     //         }
        //     //         if (vm.filterData.filter_pickup_to_date_value && vm.filterData.filter_pickup_to_time_value) {
        //     //             var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
        //     //         }
        //     //         // if (vm.filterData.unassignedBookingCountShow > vm.filterData.unassignedBookingList.length) {
        //     //         //     vm.filterData.unassignedSkip = vm.filterData.unassignedSkip + vm.filterData.unassignedLimitMade;
        //     //         //     getGroupedOnly(false, pickFromDate, pickToDate, 'scroll');
        //     //         //     //applyFilter('scroll');
        //     //         // }
        //     //         // vm.filterData.unassignedBookingList = [];
        //     //         // getGroupedOnly(false, pickFromDate, pickToDate, 'scroll');
        //     //         console.log(data, vm.countToSocket == 0, vm.filterData.filterApplied);

        //     //         if (data && vm.filterData.filterApplied) {
        //     //             vm.filterData.unassignedBookingList = [];
        //     //             getGroupedOnly(false, pickFromDate, pickToDate, 'socket');
        //     //             // vm.countToSocket = 1;
        //     //         }
        //     //     })

        //     // }

        // });
        // $scope.$on('$destroy', quickAssingnment);
        // var UnassignSocket = $rootScope.$on('quickScreeenBookingunassignedSocket', function (evt, data) {
        //     console.log(data, "socket delete", vm.filterData.createdBookingList);
        //     $log.log(evt);
        //     $log.log(data);
        //     vm.fun = true;
        //     if (data.data && vm.countToSocket == 0 && vm.filterData.filterApplied && vm.fun == true) {
        //         getGroupedPackageList('noScroll', false);
        //     }


        // });
        // $scope.$on('$destroy', UnassignSocket);
        // var assignSocket = $rootScope.$on('quickScreeenBookingAssignedSocket', function (evt, data) {
        //     console.log(data, "socket delete");
        //     $log.log(evt);
        //     $log.log(data);
        //     vm.fun = true;
        //     if (data.data && vm.countToSocket == 0 && vm.filterData.filterApplied && vm.fun == true) {
        //         getGroupedPackageList('noScroll', false);
        //     }


        // });
        // $scope.$on('$destroy', assignSocket);
        //==================== GET UNLOCK BY BUTTON THE BOOKING ===================
        var UnlockSocketByButton = $rootScope.$on('socketComesToUnlockTheBooking', function (evt, data) {
            var packageIndex;
            if (data && data.res && data.res.message.length > 0) {
                data.res.message.forEach(function (data) {
                    packageIndex = vm.filterData.makePackageList.findIndex(function (x) {
                        return x.job_id == data.job_id;
                    });
                    if (packageIndex >= 0) {
                        if (vm.filterData.makePackageList.length > 0) {
                            vm.filterData.makePackageList[packageIndex].locking_id = data.locking_id;
                            if (vm.filterData.makePackageList[packageIndex].locking_id == null) {
                                var index = vm.filterData.unassignedBookingList.findIndex(function (x) {
                                    console.log();

                                    return x.job_id == data.job_id;
                                });
                                if (index < 0) {
                                    vm.filterData.unassignedBookingList.push(data);
                                }
                                vm.filterData.makePackageList.splice(packageIndex, 1);
                                $scope.$apply();

                            }
                        }
                    }
                })

            }

        });
        $scope.$on('$destroy', UnlockSocketByButton);
        //==================== GET SOCKET CONNECTION FOR EnviarVoucher ===================
        var unDiscardBookingSocket = $rootScope.$on('SocketForGetDataEnviarVoucher', function (evt, data) {
            if (data && data.data && data.data.message && data.data.message.shared_service_id > 0) {
                var index = vm.filterData.createdBookingList.findIndex(function (x) {
                    return Number(x.shared_service_id) == Number(data.data.message.shared_service_id);
                });
                if (index >= 0) {
                    vm.filterData.createdBookingList[index].send_voucher = 1;
                }
            }

        });
        $scope.$on('$destroy', unDiscardBookingSocket);


        //==================== GROUPED PACKAGE CREATION SOCKET ===================
        var packageCreationSocket = $rootScope.$on('socketEventPackageCreationForGroupedScreen', function (evt, data) {
            if (data.res.message[0])
                data = data.res.message[0];
            var findIndexOfBookingIncreatedBookingList = _.findIndex(vm.filterData.createdBookingList, {
                shared_service_id: data.shared_service_id || 0
            })
            if (findIndexOfBookingIncreatedBookingList == -1) {
                if (checkStatusPackage(data))
                    if (data) {
                        console.log('>>>>> dtaa >>', data);
                        // data = data.res.message[0];
                        vm.filterData.createdBookingList.push({
                            eta: data.eta,
                            first_pickup_address: data.first_pickup_address,
                            first_pickup_time: data.first_pickup_time,
                            pax: data.pax,
                            shared_service_id: data.shared_service_id,
                            status: data.status,
                            total_bookings: data.total_bookings,
                            unique_car_id: data.unique_car_id
                        });
                        vm.filterData.createdBookingCount += 1;
                        $scope.$apply();
                    }
            } else {
                if (data.status == 2) {
                    // This check is to DELETE BOOKING ON BOOKING ENDED
                    vm.filterData.createdBookingList.splice(findIndexOfBookingIncreatedBookingList, 1);
                    // vm.filterData.createdBookingCount -= 1;
                } else {
                    vm.filterData.createdBookingList[findIndexOfBookingIncreatedBookingList] = {
                        eta: data.eta,
                        first_pickup_address: data.first_pickup_address,
                        first_pickup_time: data.first_pickup_time,
                        pax: data.pax,
                        shared_service_id: data.shared_service_id,
                        status: data.status,
                        total_bookings: data.total_bookings,
                        unique_car_id: data.unique_car_id
                    };
                }
                $scope.$apply();
            }

        });
        $scope.$on('$destroy', packageCreationSocket);

        //==================== PACKAGE DELETION SOCKET ===================
        var packageDeleteSocket = $rootScope.$on('socketEventPackageDeletionShared', function (evt, data) {
            if (data.res.message)
                data = data.res.message;
            var findIndexOfBookingIncreatedBookingList = _.findIndex(vm.filterData.createdBookingList, {
                shared_service_id: data || 0
            });
            console.log(findIndexOfBookingIncreatedBookingList, 'findIndexOfBookingIncreatedBookingList');
            vm.filterData.createdBookingCount -= 1;
            if (findIndexOfBookingIncreatedBookingList > -1) {
                vm.filterData.createdBookingList.splice(findIndexOfBookingIncreatedBookingList, 1);
                // console.log(vm.filterData.createdBookingList.length ,'vm.filterData.createdBookingList');
                // vm.filterData.createdBookingCount -= 1;
                $scope.$apply();
            }
        });

        $scope.$on('$destroy', packageDeleteSocket);

        // ============== search Filter =============
        function searchFilter() {
            var pickFromDate = '';
            var pickToDate = '';
            if (vm.filterData.filter_pickup_from_date_value && vm.filterData.filter_pickup_from_time_value) {
                pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            }
            if (vm.filterData.filter_pickup_to_date_value && vm.filterData.filter_pickup_to_time_value) {
                pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            }
            $timeout.cancel(vm.yourTimer);
            vm.yourTimer = $timeout(function () {
                vm.loading = true;
                vm.filterData.unassignedBookingList = [];
                vm.filterData.offset = 0;
                vm.filterData.unassignedSkip = 0;
                vm.filterData.unassignedLimit = 10;
                vm.filterData.unassignedLimitMade = 10;
                getGroupedOnly(true, pickFromDate, pickToDate, '');
            }, 1000);
        }

        // =================== enviar Voucher to send email ===========
        function enviarVoucher(data) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.shared_service_id = Number(data.shared_service_id);
            vm.loading = true;
            var promise = groupedRouteAssignment.enviarVoucherApi(dataSend);
            promise.then(
                function (payload) {
                    vm.loading = false;
                    errorMessageFactory.showErrorMessage(payload.title.message, 0);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function serviceFilterData() {
            $timeout.cancel(vm.yourTimer);
            vm.yourTimer = $timeout(function () {
                vm.loading = true;
                vm.filterData.createdBookingList = [];
                vm.filterData.createdSkip = 0;
                vm.filterData.createdLimit = 10;
                if (vm.filterData.filter_pickup_from_date_value && vm.filterData.filter_pickup_from_time_value) {
                    var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
                }
                if (vm.filterData.filter_pickup_to_date_value && vm.filterData.filter_pickup_to_time_value) {
                    var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
                }
                getGroupedPackageList('scroll', true, pickFromDate, pickToDate);
            }, 1000);
        }


        function getPackageSection(value) {
            if (value) {
                vm.checkClickedPackage = false;
                $('#packageFilter').hide();
            }
        }

        function seleccionarReserva(data, indice){
            if(data.text != "" && data.discard_from_group == 0){
                if(data.selected) {
                    data.selected = false;
                    var objetoEncontradoIndex = vm.filterData.selectedDiscard.findIndex(function(objeto) {
                        return objeto.job_id === data.job_id;
                    });
                    
                    if (objetoEncontradoIndex !== -1) {
                        vm.filterData.selectedDiscard.splice(objetoEncontradoIndex, 1);
                    }
                } else {
                    data.selected = true;
                    var objetoEncontrado = vm.filterData.selectedDiscard.find(function(objeto) {
                        return objeto.job_id === data.job_id;
                    });
                    if(!objetoEncontrado){
                        vm.filterData.selectedDiscard.push(data);
                    }
                }
                if(vm.filterData.selectedDiscard.length > 0){
                    vm.selectDisabled = false;
                } else {
                    vm.selectDisabled = true;
                }
            }
        }
    }

})();

/**
 * Created by cl-macmini-51 on 23/02/18.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('GroupMassiveQuickassignmentController', GroupMassiveQuickassignmentController);

    /** @ngInject */
    function GroupMassiveQuickassignmentController($cookies, $state, $log, $http, MY_CONSTANT, $timeout, $rootScope, $interval, $scope, $mdDialog, $document, languageBasedErrorFactory, getFilters, getBookings, errorMessageFactory) {
        console.log("i m in top of GroupMassiveQuickassignmentController");
        var vm = this;
        vm.loading = false;
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.datePickerE_3 = datePickerE_3;
        vm.applyFilter = applyFilter;
        vm.offsetSend = 0;
        vm.pickupFromToTimeChanged = pickupFromToTimeChanged;
        vm.paginationChangedForAssignedAssign = paginationChangedForAssignedAssign;
        vm.massivePushToDrivers = massivePushToDrivers;
        vm.vehicleChanged = vehicleChanged;
        vm.selectedAutoAssignBookingCount = 0;
        vm.assignBookingList = [];
        vm.resetSelectedData = resetSelectedData;
        vm.colorFlag = [];
        vm.selectedArray = [];
        vm.defaultcolorUnassign = true;
        vm.defaultcolorReload = true;
        vm.UnAssignBookingList = [];
        vm.historyData = [];
        vm.itemsPerPageGot = 25;
        vm.offsetUnsign = 0;
        vm.offsetAssign = 0;
        vm.bookingSelected = bookingSelected;
        vm.paginationChangedForUnassignedAssign = paginationChangedForUnassignedAssign;
        vm.getAllAssignBookings = getAllAssignBookings;
        vm.getAllUnAssignBookings = getAllUnAssignBookings;
        languageBasedErrorFactory.getTranslationStrings(runThis);
        vm.ismeridian = true;
        vm.globalLimit = 1000;
        vm.slideData = slideData;
        vm.globalLimitService = 1000; //by 
        vm.branchChangedFilter = branchChangedFilter;
        vm.vehicleChangedFilter = vehicleChangedFilter;
        vm.serviceChangedFilter = serviceChangedFilter;
        vm.agreementChangedFilter = agreementChangedFilter;
        vm.typeTripChangedFilter = typeTripChangedFilter;
        vm.globalOffset = 1000;
        vm.typeTripChanged = typeTripChanged;
        vm.agreementChanged = agreementChanged;
        vm.serviceChanged = serviceChanged;
        vm.branchChanged = branchChanged;
        vm.resetFilter = resetFilter;
        vm.altInputFormats = ['M!/d!/yyyy'];
        vm.datePicker_1 = {
            scheduledDate: false,
            returnDate: false
        };
        vm.agreementSearch = agreementSearch;
        vm.serviceSearch = serviceSearch;
        vm.branchSearch = branchSearch;
        vm.vehicleSearch = vehicleSearch;
        vm.filterData = {
            branch_filter: 0, //0, 1
            service_filter: 0, //0, 1
            vehicle_filter: 0, //0, 1
            aggrement_filter: 0, //0, 1
            //date_time_filter : 1,  //0, 1
            branch: 'all',
            service: [],
            vehicle: 'all',
            //date_time_value: '',
            agreement: 'all',
            unAssignBookingArray: [],
            unassignedBookingCountShow: 0,
            assignedBookingCountShow: 0,
            // type_of_trip: 'all',
            type_of_trip_filter: 1,
            //filter_pickup_date_value: getNextDate(),
            //filter_pickup_time_value: showFilterTime(),
            limit: 25,
            offset: 0,
            booking_status: 0,
            search_filter: 0,
            search_value: '',
            searchBookingId: '',
            searchPackageId: '',
            search: '',
            itemsPerPageSelected: 20,
            unassignedLimitMade: 20,
            assignedLimitMade: 20,
            filter_pickup_from_date_value: getFirstDateOfPreviousMonth(),
            filter_pickup_to_date_value: setToPickupDate(),
            filter_pickup_from_time_value: showFilterTime(1),
            filter_pickup_to_time_value: showFilterTime(2),
        };
        vm.filterData.type_of_trip = ['R','P'];
        vm.service = [];
        // vm.service.push({
        //     id: 'all',
        //     name: 'All'
        // })

        vm.vehicle = [];
        vm.vehicle.push({
            id: 'all',
            name: 'All'
        });

        vm.branchList = [];
        vm.branchList.push({
            region_name: 'All',
            region_id: 'all'
        });

        vm.agreement = [];
        // vm.agreement.push({
        //     id: 'all',
        //     name: 'All'
        // });

        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'vehicle', 'service', 'agreement', 'corporatesList', 'operation_point'];

        vm.serviceOffset = 0;
        vm.branchOffset = 0;
        vm.vehicleOffset = 0;
        vm.agreementOffset = 0;


        if ($rootScope.socket.connected == false || $rootScope.socket.connected == 'false') {
            $rootScope.socket.connect();
        }

        function clearOffset() {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                vm[vm.searchFilterArray[i] + 'Offset'] = 0;
            }

        }
        setTimeout(function () {
            document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                // if (vm.branchList && (vm.branchList.length == 0)) {
                vm.searchBranchData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });


            document.getElementsByClassName('ui-select-search')[1].addEventListener('blur', function ($event) {
                // if (vm.agreement && (vm.agreement.length == 0)) {
                vm.searchAgreementData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

            document.getElementsByClassName('ui-select-search')[2].addEventListener('blur', function ($event) {
                // if (vm.service && (vm.service.length == 0)) {
                vm.searchServiceData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

            document.getElementsByClassName('ui-select-search')[3].addEventListener('blur', function ($event) {
                // if (vm.vehicle && (vm.vehicle.length == 0)) {
                vm.searchVehicleData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

        })
        ///////////// DATe FUNCTIONS/////////////////////
        function getFirstDateOfPreviousMonth() {
            var date = new Date();
            var yesterday = new Date(date.getTime() - 24 * 60 * 60 * 1000);
            return date;
        }

        function setToPickupDate() {
            var x = new Date();
            var yesterday = new Date(x.getTime() + (24 * 60 * 60 * 1000));
            return yesterday;

        }

        function showFilterTime(type) {
            if (type == 1) {
                var x = new Date();
                x.setHours('00');
                x.setMinutes('00');
                x.setSeconds('00');
                return x;
            } else {
                var x = new Date();
                x.setHours('23');
                x.setMinutes('59');
                x.setSeconds('00');
                return x;
            }

        }

        function datePickerE_3(type) {
            if (type == 1) {
                vm.datePicker_1.pickupFromDate = true;
                vm.datePicker_1.pickupToDate = false;

            } else if (type == 2) {
                vm.datePicker_1.pickupFromDate = false;
                vm.datePicker_1.pickupToDate = true;
            }
        };
        ///////////// DATe FUNCTIONS/////////////////////

        /////////////FILTER INTO LOCALSTORGAGE/////////////////////
        if (localStorage.getItem('groupMassiveQuickAssignmentFilter')) {
            vm.filterData = JSON.parse(localStorage.getItem('groupMassiveQuickAssignmentFilter'));
            init();
        } else {
            init();
        }
        $scope.$watchCollection('vm.filterData', function (newValue, oldValue) {
            localStorage.setItem('groupMassiveQuickAssignmentFilter', JSON.stringify(newValue));
        });
        /////////////FILTER INTO LOCALSTORGAGE/////////////////////

        /////////////INIT FUNCTIONS/////////////////////
        function init() {
            vm.filterData.type_of_trip = ['R','P'];
            getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
            getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");

        };
        /////////////INIT FUNCTIONS/////////////////////

        /////////////DATE CHANGE FUNTION/////////////////////
        vm.pickupFromToDateChanged = function (data) {
            // vm.UnAssignBookingList = [];
            // vm.assignBookingList = [];
            vm.dateOptions = {
                //dateDisabled: disabled,
                formatYear: 'yy',
                // maxDate: new Date(),
                // minDate: new Date(vm.filterData.filter_pickup_from_date_value),
                startingDay: 1,
                showWeeks: false,

            };
            vm.dateOptionsForEndDate = {
                //dateDisabled: disabled,
                formatYear: 'yy',
                maxDate: addDays(vm.filterData.filter_pickup_to_date_value, 1),
                minDate: new Date(vm.filterData.filter_pickup_from_date_value),
                startingDay: 1,
                showWeeks: false,
            }
            // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
            // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "scroll");

        }


        function addDays(theDate, days) {
            return new Date(theDate).getTime() + days * 24 * 60 * 60 * 1000;
        }

        /////////////DATE CHANGE FUNTION/////////////////////

        //====================Type Of Trip list====================
        function runThis() {
            vm.typeTripFilter = [
                // {
                //     name: languageBasedErrorFactory.getProperErrorMessage('allLabel', 0, '3'),
                //     id: 'all'
                // },
                // {
                //     name: 'From Airport',
                //     id: 'Z'
                // },
                {
                    name: 'To Airport',
                    id: 'R'
                },
                {
                    name: 'Point to Point',
                    id: 'P'
                }
            ]
        }

        //====================Type Of Trip list====================
        // =================== FILTER OBJECT ===================
        vm.filterObject = {
            access_token: $cookies.get('obj'),
            branch_filter: 1,
            vehicle_filter: 1,
            service_filter: 1,
            agreement_filter: 1,
            corporate_filter: 0,
            service_category: 0,
            corporate_status: 0,
            agreement_status: 1,
            vehicle__status: 1,
            operation_point_filter: 0,
            service_limit: vm.globalLimitService,
            service_offset: vm.serviceOffset,
            branch_limit: vm.globalLimit,
            branch_offset: vm.branchOffset,
            vehicle_limit: vm.globalLimit,
            vehicle_offset: vm.vehicleOffset,
            agreement_limit: vm.globalLimit,
            agreement_offset: vm.agreementOffset,
            branch_search_filter: 0,
            vehicle_search_filter: 0,
            service_search_filter: 0,
            agreement_search_filter: 0,
            corporate_search_filter: 0,
            operation_point_search_filter: 0
        }
        // document.getElementById('boxId').style.border = "1px solid #EF7D07";
        // document.getElementById('boxId').style.backgroundColor = "transparent";
        // document.getElementById('boxId').style.color = "#EF7D07";
        // document.getElementById('boxId1').style.border = "1px solid #EF7D07";
        // document.getElementById('boxId1').style.backgroundColor = "#EF7D07";
        // document.getElementById('boxId1').style.color = "#fff";
        // //=======================Assign Booking=========================
        // function assignBooking(boxId) {
        //     document.getElementById(boxId).style.border = "1px solid #EF7D07";
        //     document.getElementById(boxId).style.backgroundColor = "#EF7D07";
        //     document.getElementById(boxId).style.color = "#fff";
        //     document.getElementById('boxId1').style.border = "1px solid #EF7D07";
        //     document.getElementById('boxId1').style.backgroundColor = "transparent";
        //     document.getElementById('boxId1').style.color = "#EF7D07";
        // }
        // //=======================Assign Booking================
        // //=======================Un Assign Booking====
        // function unAssignBooking(boxId1) { 
        //     document.getElementById(boxId1).style.border = "1px solid #EF7D07";
        //     document.getElementById(boxId1).style.backgroundColor = "#EF7D07";
        //     document.getElementById(boxId1).style.color = "#fff";
        //     document.getElementById('boxId').style.border = "1px solid #EF7D07";
        //     document.getElementById('boxId').style.backgroundColor = 'transparent';
        //     document.getElementById('boxId').style.color = "#EF7D07";
        // }
        //=======================Un Assign Booking====Î
        // =================== GET FILTER DATA ===================
        function getFilterDataFromBackend(data, type) { //Acc to Index ['branch_search', 'vehicle_search', 'service_search', 'agreement_search', 'corporate_search', 'operation_point_search']
            if (data) {
                vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
            } else {
                vm.filterObject = {
                    access_token: $cookies.get('obj'),
                    branch_filter: 1,
                    vehicle_filter: 1,
                    service_filter: 1,
                    agreement_filter: 1,
                    corporate_filter: 0,
                    service_category: 0,
                    corporate_status: 0,
                    agreement_status: 1,
                    vehicle__status: 2,
                    operation_point_filter: 0,
                    branch_search_filter: 0,
                    vehicle_search_filter: 0,
                    service_search_filter: 0,
                    agreement_search_filter: 0,
                    corporate_search_filter: 0,
                    operation_point_search_filter: 0
                }
            }

            vm.filterObject.service_limit = vm.globalLimitService;
            vm.filterObject.service_offset = vm.serviceOffset;
            vm.filterObject.branch_limit = vm.globalLimit;
            vm.filterObject.branch_offset = vm.branchOffset;
            vm.filterObject.vehicle_limit = vm.globalLimit;
            vm.filterObject.vehicle_offset = vm.vehicleOffset;
            vm.filterObject.agreement_limit = vm.globalLimit;
            vm.filterObject.agreement_offset = vm.agreementOffset;


            var promise = getFilters.getAllFilterData(vm.filterObject);
            promise.then(
                function (payload) {

                    // ********** BRANCH DATA ********
                    if (payload.title.data.branches) {
                        var index = _.findIndex(vm.branchList, {
                            region_id: 'all'
                        });
                        if (index == -1)
                            vm.branchList.push({
                                region_name: 'All',
                                region_id: 'all'
                            });
                        angular.forEach(payload.title.data.branches.data, function (column) {
                            var branchIndex = _.findIndex(vm.branchList, {
                                region_id: column.region_id
                            });
                            if (branchIndex == -1)
                                vm.branchList.push(column)
                        });
                        vm.branchTotalBackendCount = payload.title.data.branches.totalCount;
                    }

                    // ********** VEHICLE DATA ********
                    if (payload.title.data.vehicles) {
                        var index = _.findIndex(vm.vehicle, {
                            id: 'all'
                        });
                        if (index == -1)
                            vm.vehicle.push({
                                name: 'All',
                                id: 'all'
                            });
                        vm.vehicleTotalBackendCount = payload.title.data.vehicles.totalCount;
                        angular.forEach(payload.title.data.vehicles.data, function (column) {
                            // vm.vehicle.push({
                            //     id: column.id,
                            //     name: column.name
                            // })
                            var vechicleIndex = _.findIndex(vm.vehicle, {
                                id: column.id
                            });
                            if (vechicleIndex == -1)
                                vm.vehicle.push({
                                    id: column.id,
                                    name: column.name
                                })
                        });
                    }

                    // *********** SERVICE DATA *********
                    if (payload.title.data.services) {
                        // var index = _.findIndex(vm.service, {
                        //     id: 'all'
                        // });
                        // if (index == -1)
                        //     vm.service.push({
                        //         name: 'All',
                        //         id: 'all'
                        //     });
                        vm.serviceTotalBackendCount = payload.title.data.services.totalCount;
                        angular.forEach(payload.title.data.services.data, function (column) {
                            // vm.service.push({
                            //     id: column.id,
                            //     name: column.service_name
                            // });
                            var serviceIndex = _.findIndex(vm.service, {
                                id: column.id
                            });
                            if (serviceIndex == -1)
                                vm.service.push({
                                    id: column.id,
                                    name: column.service_name
                                })
                        });
                    }

                    // *********** AGREEMENT DATA *********
                    if (payload.title.data.agreements) {
                        // var index = _.findIndex(vm.agreement, {
                        //     id: 'all'
                        // });
                        // if (index == -1)
                        //     vm.agreement.push({
                        //         name: 'All',
                        //         id: 'all'
                        //     });
                        vm.agreementTotalBackendCount = payload.title.data.agreements.totalCount;
                        angular.forEach(payload.title.data.agreements.data, function (column) {
                            // vm.agreement.push({
                            //     id: column.id,
                            //     name: column.name
                            // });
                            var agreementIndex = _.findIndex(vm.agreement, {
                                id: column.id
                            });
                            if (agreementIndex == -1)
                                vm.agreement.push({
                                    id: column.id,
                                    name: column.name
                                })
                        });
                    }

                    vm.loading = false;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        }
        getFilterDataFromBackend();

        // ************ PAGINATION ON SERIVCE **************
        function paginationChangedForService() {
            var index = _.findIndex(vm[vm.searchFilterArray[2]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.serviceTotalBackendCount > (vm.service.length - index)) {
                commonFunction(2);
                vm.serviceOffset += vm.globalLimitService;
                getFilterDataFromBackend(vm.searchServiceData, 2);
            }
        }

        // ************ PAGINATION ON VEHICLE **************
        function paginationChangedForVehicle() {
            var index = _.findIndex(vm[vm.searchFilterArray[1]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.vehicleTotalBackendCount > (vm.vehicle.length - index)) {
                commonFunction(1);
                vm.vehicleOffset = vm.vehicleOffset + 10;
                getFilterDataFromBackend(vm.searchVehicleData, 1);
            }
        }

        // ************ PAGINATION ON BRANCH **************
        function paginationChangedForBranch() {
            var index = _.findIndex(vm[vm.searchFilterArray[0]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.branchTotalBackendCount > (vm.branchList.length - index)) {
                commonFunction(0);
                vm.branchOffset += 10;
                getFilterDataFromBackend(vm.searchBranchData, 0);
            }
        }

        // ************ PAGINATION ON AGREEMENT **************
        function paginationChangedForAgreement() {
            var index = _.findIndex(vm[vm.searchFilterArray[3]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.agreementTotalBackendCount > (vm.agreement.length - index)) {
                commonFunction(3);
                vm.agreementOffset += vm.globalOffset;
                getFilterDataFromBackend(vm.searchAgreementData, 3);
            }
        }

        // *********** COMMON FUNCTION FOR FILTER PAGINATION AND SEARCHING ***********
        function commonFunction(type, mode) {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                // vm['search' + vm.searchFilterArray[i] + 'Data'] = '';
                if (mode == 'search' || i != type) {
                    vm[vm.searchFilterArrayForClearArray[i]] = [];
                    // if (vm.searchFilterArrayForClearArray[i] != vm.searchFilterArrayForClearArray[0] && vm.searchFilterArrayForClearArray[i] == vm.searchFilterArrayForClearArray[3])
                    // vm[vm.searchFilterArrayForClearArray[i]].push({
                    //     id: 'all',
                    //     name: 'All'
                    // });
                    vm[vm.searchFilterArray[i] + 'Offset'] = 0;
                    vm['search' + vm.searchFilterArray[i].substring(0, 1).toUpperCase() + vm.searchFilterArray[i].substring(1) + 'Data'] = '';
                }
            }
        }

        // ************ SEARCH VEHICLE ***************
        function vehicleSearch(data, event) {
            // if (event.keyCode != 40 && event.keyCode != 38) {
            //     vm.searchVehicleData = data;
            //     $timeout.cancel($scope.timeoutSearch);
            //     commonFunction(1, 'search');
            //     $scope.timeoutSearch = $timeout(function () {
            //         getFilterDataFromBackend(data, 1);
            //     }, 2000);
            // }
            if (event.keyCode == 13) {
                vehicleChanged();
            }
        }

        // ************ SEARCH SERVICE ***************
        function serviceSearch(data, event) {
            // if (event.keyCode != 40 && event.keyCode != 38) {
            //     vm.searchServiceData = data;
            //     $timeout.cancel($scope.timeoutSearch);
            //     commonFunction(2, 'search');
            //     $scope.timeoutSearch = $timeout(function () {
            //         getFilterDataFromBackend(data, 2);
            //     }, 2000);
            // }
            if (event.keyCode == 13) {
                serviceChanged();
            }
        }

        // ************ SEARCH VEHICLE ***************
        function branchSearch(data, event) {
            // if (event.keyCode != 40 && event.keyCode != 38) {
            //     vm.searchBranchData = data;
            //     $timeout.cancel($scope.timeoutSearch);
            //     commonFunction(0, 'search');
            //     $scope.timeoutSearch = $timeout(function () {
            //         getFilterDataFromBackend(data, 0);
            //     }, 2000);
            // }
            if (event.keyCode == 13) {
                branchChanged();
            }
        }

        // ************ SEARCH AGREEMENT ***************
        function agreementSearch(data, event) {
            // if (event.keyCode != 40 && event.keyCode != 38) {
            //     vm.searchAgreementData = data;
            //     $timeout.cancel($scope.timeoutSearch);
            //     commonFunction(3, 'search');
            //     $scope.timeoutSearch = $timeout(function () {
            //         getFilterDataFromBackend(data, 3);
            //     }, 2000);
            // }
            if (event.keyCode == 13) {
                agreementChanged();
            }
        }
        //===================Reset filter====================
        function resetFilter() {
            vm.UnAssignBookingList = [];
            vm.assignBookingList = [];
            vm.filterData = {
                branch_filter: 0, //0, 1
                service_filter: 0, //0, 1
                vehicle_filter: 0, //0, 1
                aggrement_filter: 0, //0, 1
                //date_time_filter : 0,  //0, 1
                type_of_trip_filter: 0, //0, 1
                branch: 'all',
                service: [],
                vehicle: 'all',
                // type_of_trip: 'R',
                //date_time_value: '',
                agreement: [],
                //filter_pickup_date_value: getNextDate(),
                //filter_pickup_time_value: showFilterTime(),
                limit: vm.itemsPerPageGot,
                offset: 0,
                booking_status: 0,
                searchBookingId: '',
                searchPackageId: '',
                search: '',
                itemsPerPageSelected: 25,
                unassignedBookingCountShow: 0,
                assignedBookingCountShow: 0,
                unAssignBookingArray: [],
                filter_pickup_from_date_value: getFirstDateOfPreviousMonth(),
                filter_pickup_to_date_value: setToPickupDate(),
                filter_pickup_from_time_value: showFilterTime(1),
                filter_pickup_to_time_value: showFilterTime(2),
            };
            vm.filterData.type_of_trip = ['R','P']; 
            getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
            getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
            // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
        }

        function applyFilter() {
            vm.UnAssignBookingList = [];
            vm.assignBookingList = [];
            if(vm.filterData.type_of_trip.length == 0){
                vm.filterData.type_of_trip = ['R','P'];
            }           
            getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
            getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
        }
        //====================slide data======================
        $('#derp').hide();

        function slideData() {
            $('#derp').slideToggle(1000);
            document.getElementById('toDate').value = moment(vm.filterData.filter_pickup_to_date_value).format('DD-MMMM-YYYY');
            document.getElementById('fromDate').value = moment(vm.filterData.filter_pickup_from_date_value).format('DD-MMMM-YYYY');

        }

        //====================slide data======================

        //====================FILTERS FUNCTIONS======================
        function branchChangedFilter(data) {
            vm.branchChanged();
        }

        function vehicleChangedFilter(data) {
            vm.vehicleChanged();
        }

        function serviceChangedFilter(data) {
            vm.serviceChanged();
        }

        function agreementChangedFilter(data) {
            vm.agreementChanged();
        }

        function typeTripChangedFilter(data) {
            vm.typeTripChanged();
        }
        //====================FILTERS FUNCTIONS======================

        //=================filter change functions===============================================
        //===================Type of Trip====================
        function typeTripChanged() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            // vm.UnAssignBookingList = [];
            // vm.assignBookingList = [];
            vm.filterData.offset = 0;
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (vm.filterData.type_of_trip && vm.filterData.type_of_trip != 'all') {
                vm.filterData.type_of_trip_filter = 1;
                // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");

            } else {
                vm.filterData.type_of_trip_filter = 0;
                vm.filterData.type_of_trip = 'all';
                // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");

            }
        };
        //===================Type of Trip====================

        //===================Vechicle Changed====================
        function vehicleChanged() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            // vm.UnAssignBookingList = [];
            // vm.assignBookingList = [];
            vm.filterData.offset = 0;
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (vm.filterData.vehicle && vm.filterData.vehicle != 'all') {
                vm.filterData.vehicle_filter = 1;
                // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
                vm.agreement = [];
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                clearOffset();
                getFilterDataFromBackend();
            } else {
                vm.filterData.vehicle_filter = 0;
                vm.filterData.vehicle = 'all';
                // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
                vm.agreement = [];
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                clearOffset();
                getFilterDataFromBackend();
            }
        };


        //===================Vechicle Changed====================

        //===================Service Changed====================
        function serviceChanged() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            // vm.UnAssignBookingList = [];
            // vm.assignBookingList = [];
            vm.filterData.offset = 0;
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (vm.filterData.service.length > 0) {
                vm.filterData.service_filter = 1;
                // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
                vm.agreement = [];
                vm.branchList = [];
                vm.vehicle = [];
                clearOffset();
                vm.service = [];
                getFilterDataFromBackend();
            } else {
                vm.filterData.service_filter = 0;
                // vm.filterData.service = 'all';
                // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
                vm.agreement = [];
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                clearOffset();
                getFilterDataFromBackend();
            }
        };
        //===================Service Changed====================

        //===================TIME CHANGE FUNCATION====================
        function pickupFromToTimeChanged(type) {
            // vm.UnAssignBookingList = [];
            // vm.assignBookingList = [];
            // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
            // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
        }
        //===================Service Changed====================

        //===================Aggreement Changed====================
        function agreementChanged() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            // vm.UnAssignBookingList = [];
            // vm.assignBookingList = [];
            vm.filterData.offset = 0;
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;

            //if (vm.filterData.agreement && vm.filterData.agreement != 'all') {
            if (vm.filterData.agreement.length > 0) {
                vm.filterData.aggrement_filter = 1;
                // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
                vm.agreement = [];
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                clearOffset();
                getFilterDataFromBackend();
            } else {
                vm.filterData.aggrement_filter = 0;
                // vm.filterData.agreement = 'all';
                
                // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
                vm.agreement = [];
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                clearOffset();
                getFilterDataFromBackend();
            }
        };
        //===================Aggreement Changed====================    

        //===================Branch Changed====================    

        function branchChanged() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            // vm.UnAssignBookingList = [];
            // vm.assignBookingList = [];
            vm.filterData.offset = 0;
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (vm.filterData.branch && vm.filterData.branch != 'all') {
                vm.filterData.branch_filter = 1;
                // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                vm.agreement = [];
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
                clearOffset();
                getFilterDataFromBackend();
            } else {
                vm.filterData.branch_filter = 0;
                vm.filterData.branch = 'all';
                // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
                vm.agreement = [];
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                clearOffset();
                getFilterDataFromBackend();
            }
        };

        //===================Branch Changed====================    
        //=================filter change functions===============================================

        ///////////// DATe FUNCTIONS/////////////////////
        //====================date time format====================
        function dateTimeFormat(dateGot, timeGot) {
            // var dateToChange = dateGot;
            var dateToChange = new Date(dateGot);
            var timeGotChange = new Date(timeGot);
            if (timeGotChange) {
                dateToChange.setHours(timeGotChange.getHours());
                dateToChange.setMinutes(timeGotChange.getMinutes());
                dateToChange.setSeconds(timeGotChange.getSeconds());
            } else {
                dateToChange.setHours(0);
                dateToChange.setMinutes(0);
                dateToChange.setSeconds(0);
            }
            return dateToChange;
        };
        //==================get all AssignBookings=======================
        var bookingType = null;
        function getAllUnAssignBookings(skip, limit, filter, loader, type) {
            var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            if (pickFromDate > pickToDate) {
                errorMessageFactory.showErrorMessage('Por favor, elija las fechas apropiadas de filtro.', 0);
                return;
            }

            vm.countToSocket = vm.countToSocket + 1;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit;
            dataSend.offset = skip;
            dataSend.booking_status = filter.booking_status;
            dataSend.branch_filter = filter.branch_filter;
            if (filter.branch_filter == 1 && filter.branch != 'all') {
                dataSend.branch_value = filter.branch;
            }
            dataSend.service_filter = filter.service_filter;
            if (filter.service_filter == 1 && filter.service != 'all') {
                dataSend.service_value = JSON.stringify(filter.service) || [];
            }
            dataSend.vehicle_filter = filter.vehicle_filter;
            if (filter.vehicle_filter == 1 && filter.vehicle != 'all') {
                dataSend.vehicle_value = filter.vehicle;
            }
            dataSend.search_filter = filter.search_filter;
            if (filter.search_filter == 1) {
                dataSend.search_value = filter.search_value;
            }
            //dataSend.date_time_filter = filter.date_time_filter;
            //if(filter.filter_pickup_date_value && filter.filter_pickup_time_value) {
            //    dataSend.date_time_value = dateTimeFormat(filter.filter_pickup_date_value, filter.filter_pickup_time_value);
            //}
            //else if(filter.filter_pickup_date_value && !filter.filter_pickup_time_value){
            //    dataSend.date_time_value = moment(filter.filter_pickup_date_value).format('YYYY-MM-DD');
            //}

            dataSend.aggrement_filter = filter.aggrement_filter;
            if (filter.aggrement_filter == 1 && filter.agreement != 'all') {
                dataSend.aggrement_value = JSON.stringify(filter.agreement) || [];
            }

            // dataSend.type_of_trip_filter = filter.type_of_trip_filter;
            // if (filter.type_of_trip_filter == 1 && filter.type_of_trip != 'all') {
            var trip = [];
            trip.push(vm.filterData.type_of_trip);
            if (vm.filterData.type_of_trip && vm.filterData.type_of_trip.length > 0 && filter.type_of_trip != 'all') {
                dataSend.type_of_trip_filter = 1;
                dataSend.type_of_trip_value = trip;
            } else {
                dataSend.type_of_trip_filter = 0;
            }
            dataSend.date_value_from = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            dataSend.date_value_upto = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);

            // }
            vm.loading = true;
            var promise = getBookings.allUnAssignPackagesV2(dataSend);
            promise.then(
                function (payload) {
                    if(payload.title.data.result.length > 0){
                        bookingType = payload.title.data.result[0].booking_type;
                    }
                    if (payload.title.status == 200) {
                        $log.log('sxdsads', payload.title);
                        vm.countToSocket = 0;
                        vm.loading = false;
                        if (payload.title.status == 400) {

                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            // vm.filterData.unassignedBookingCountShow = payload.title.data.totalCount;
                            // vm.dataLength = payload.title.data.totalCount;
                            // vm.urgentBookingCount = payload.title.data.urgent_booking_count || 0;
                            vm.unAssignBookingArrayForCount = payload.title.data.result;
                            if (payload.title.data.totalCount == 0) {} else {
                                if (type == "scroll") {
                                    for (var i = 0; i < payload.title.data.result.length; i++) {
                                        vm.filterData.unAssignBookingArray.push(payload.title.data.result[i]);
                                    }
                                } else {
                                    vm.filterData.unAssignBookingArray = payload.title.data.result;
                                }
                                var dataArray = [];
                                if (type == 'socket') {
                                    vm.UnAssignBookingList = [];
                                }
                                vm.filterData.unAssignBookingArray = payload.title.data.result;
                                var UnAssignBookingList = payload.title.data.result;
                                UnAssignBookingList.forEach(function (column) {
                                    // this is to detect duplicate booking in array
                                    var index = _.findIndex(vm.UnAssignBookingList, {
                                        job_id: column.job_id
                                    });
                                    if (index == -1) {
                                        var d = {};
                                        d.contract_name = column.contract_name;
                                        d.estimated_payment_cost = column.estimated_payment_cost;
                                        d.is_VIP = column.is_VIP;
                                        d.is_round_trip = column.is_round_trip;
                                        d.booking_type = column.booking_type;
                                        d.branch = column.branch;
                                        d.type_of_service = column.type_of_service;
                                        d.job_address = column.job_address;
                                        d.job_id = column.job_id;
                                        d.job_pickup_address = column.job_pickup_address;
                                        d.job_pickup_name = column.job_pickup_name;
                                        d.job_pickup_phone = column.job_pickup_phone;
                                        d.job_time_utc = column.job_time_utc;
                                        d.locking_id = column.locking_id;
                                        d.service_name = column.service_name;
                                        d.locking_id_name = column.locking_id_name;
                                        d.observations = column.observations;
                                        d.reference_point = column.reference_point;
                                        d.round_trip_pickup_time_utc = column.round_trip_pickup_time_utc;
                                        d.urgent_booking_assignment = column.urgent_booking_assignment;
                                        d.latitude = column.job_pickup_latitude;
                                        d.longitude = column.job_pickup_longitude;
                                        d.is_person = true;
                                        d.shared_service_id = column.shared_service_id;
                                        d.booking_eta = column.booking_eta;
                                        d.reference_point = column.reference_point;
                                        d.color = column.urgent_booking_assignment ? '#ff4d4d' : '#333';
                                        d.booking_visibility_flag = column.booking_visibility_flag;
                                        d.auto_assignment = column.auto_assignment;
                                        vm.UnAssignBookingList.push(d);
                                        console.log(vm.UnAssignBookingList, 'vm.UnAssignBookingList');

                                    }
                                });
                                vm.historyData.push(UnAssignBookingList.length);
                            }
                            for (var i = 0; i < vm.UnAssignBookingList.length; i++) {
                                vm.UnAssignBookingList[i].index = (skip + i);
                            }
                            if (vm.dataLength <= vm.itemsPerPageGot) {
                                vm.sp_pagination = false;
                            } else {
                                vm.sp_pagination = true;
                            }
                        }
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //==================get all AssignBookings=======================
        //==================get all AssignBookings=======================
        function getAllAssignBookings(skip, limit, filter, loader, type) {
            var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            if (pickFromDate > pickToDate) {
                errorMessageFactory.showErrorMessage('Por favor, elija las fechas apropiadas de filtro.', 0);
                return;
            }
            vm.countToSocket = vm.countToSocket + 1;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit;
            dataSend.offset = skip;
            dataSend.booking_status = filter.booking_status;
            dataSend.branch_filter = filter.branch_filter;
            if (filter.branch_filter == 1 && filter.branch != 'all') {
                dataSend.branch_value = filter.branch;
            }
            dataSend.service_filter = filter.service_filter;
            if (filter.service_filter == 1 && filter.service != 'all') {
                dataSend.service_value = JSON.stringify(filter.service) || [];
            }
            dataSend.vehicle_filter = filter.vehicle_filter;
            if (filter.vehicle_filter == 1 && filter.vehicle != 'all') {
                dataSend.vehicle_value = filter.vehicle;
            }
            dataSend.search_filter = filter.search_filter;
            if (filter.search_filter == 1) {
                dataSend.search_value = filter.search_value;
            }
            //dataSend.date_time_filter = filter.date_time_filter;
            //if(filter.filter_pickup_date_value && filter.filter_pickup_time_value) {
            //    dataSend.date_time_value = dateTimeFormat(filter.filter_pickup_date_value, filter.filter_pickup_time_value);
            //}
            //else if(filter.filter_pickup_date_value && !filter.filter_pickup_time_value){
            //    dataSend.date_time_value = moment(filter.filter_pickup_date_value).format('YYYY-MM-DD');
            //}

            dataSend.aggrement_filter = filter.aggrement_filter;
            if (filter.aggrement_filter == 1 && filter.agreement != 'all') {
                dataSend.aggrement_value = JSON.stringify(filter.agreement) || [];
            }

            dataSend.date_value_from = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            dataSend.date_value_upto = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);

            // dataSend.type_of_trip_filter = filter.type_of_trip_filter;
            // if (filter.type_of_trip_filter == 1 && filter.type_of_trip != 'all') {
            var trip = [];
            trip.push(vm.filterData.type_of_trip);
            if (vm.filterData.type_of_trip && vm.filterData.type_of_trip.length > 0 && filter.type_of_trip != 'all') {
                dataSend.type_of_trip_filter = 1;
                dataSend.type_of_trip_value = trip;
            } else {
                dataSend.type_of_trip_filter = 0;
            }
            vm.loading = true;
            dataSend.date_value = vm.selectedDateForFilter;
            var promise = getBookings.allAssignPackagesV2(dataSend);
            promise.then(
                function (payload) {
                    if (payload.title.status == 200) {
                        $log.log('sxdsads', payload);
                        vm.countToSocket = 0;
                        vm.loading = false;
                        if (payload.title.status == 400) {

                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            // vm.filterData.assignedBookingCountShow = payload.title.data.totalCount;
                            // vm.totalUpcomingBookings = payload.title.data.totalCount;
                            // vm.dataLength = payload.title.data.totalCount;
                            if (payload.title.data.totalCount == 0) {
                                vm.sp_pagination = false;
                                vm.tBodyFlag = false;
                                vm.tFootFlag = true;
                                vm.filterOn = true;
                                vm.skipValueFilter = 0;
                            } else {
                                vm.sp_pagination = true;
                                vm.tBodyFlag = true;
                                vm.tFootFlag = false;
                                vm.filterOn = false;
                                vm.skipValueFilter = 0;

                                var dataArray = [];
                                if (type == 'socket') {
                                    vm.assignBookingList = [];
                                }
                                var assignBookingList = payload.title.data.result;
                                vm.assignBookingListForNewCount = payload.title.data.result;
                                assignBookingList.forEach(function (column) {
                                    // this is to detect duplicate booking in array
                                    var index = _.findIndex(vm.assignBookingList, {
                                        job_id: column.job_id
                                    });
                                    if (index == -1) {
                                        var d = {};
                                        d.contract_name = column.contract_name;
                                        d.estimated_payment_cost = column.estimated_payment_cost;
                                        d.is_VIP = column.is_VIP;
                                        d.is_round_trip = column.is_round_trip;
                                        d.booking_type = column.booking_type;
                                        d.job_address = column.job_address;
                                        d.job_status = column.job_status;
                                        d.job_id = column.job_id;
                                        d.job_pickup_address = column.job_pickup_address;
                                        d.job_pickup_name = column.job_pickup_name;
                                        d.job_pickup_phone = column.job_pickup_phone;
                                        d.unique_car_id = column.unique_car_id;
                                        d.fleet_first_name = column.fleet_first_name + '' + column.fleet_last_name;
                                        d.fleet_phone_number = column.fleet_country_code + column.fleet_phone_number;
                                        d.service_name = column.service_name;
                                        d.assignment_identity = column.assignment_identity;
                                        d.auto_assignment = column.auto_assignment;
                                        d.shared_service_id = column.shared_service_id;
                                        d.job_time_utc = column.job_time_utc;
                                        d.locking_id = column.locking_id;
                                        d.locking_id_name = column.locking_id_name;
                                        d.observations = column.observations;
                                        d.reference_point = column.reference_point;
                                        d.round_trip_pickup_time_utc = column.round_trip_pickup_time_utc;
                                        d.urgent_booking_assignment = column.urgent_booking_assignment;
                                        d.type_of_trip = column.type_of_trip;
                                        d.job_pickup_latitude = column.job_pickup_latitude;
                                        d.job_pickup_longitude = column.job_pickup_longitude;
                                        vm.assignBookingList.push(d);
                                    }
                                });
                            }
                        }
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //==================get all AssignBookings=======================

        // ========================= paginationChangedForAssignedAssign =================
        function paginationChangedForAssignedAssign() {
            if (vm.assignBookingListForNewCount.length == vm.itemsPerPageGot) {
                vm.offsetAssign = vm.offsetAssign + 25;
                getAllAssignBookings(vm.offsetAssign, vm.itemsPerPageGot, vm.filterData, true, "scroll");
            }
        }
        // ========================= paginationChangedForAssignedAssign =================

        // ========================= paginationChangedForUnassignedAssign =================
        function paginationChangedForUnassignedAssign() {
            if (vm.unAssignBookingArrayForCount.length == vm.itemsPerPageGot) {
                vm.offsetUnsign = vm.offsetUnsign + 25;
                getAllUnAssignBookings(vm.offsetUnsign, vm.itemsPerPageGot, vm.filterData, true, "scroll");
            }
        }
        // ========================= paginationChangedForUnassignedAssign =================


        function bookingSelected(data, customer_data, index) {
            if (customer_data.auto_assignment == 1 && customer_data.booking_visibility_flag == 0) {
                return;
            }
            if (!vm.colorFlag[index] && vm.selectedAutoAssignBookingCount == 25) {
                return;
            } // MAX LIMIT{}
            else {
                vm.colorFlag[index] = !vm.colorFlag[index];
                if (!vm.colorFlag[index]) {
                    vm.selectedAutoAssignBookingCount -= 1;
                    vm.selectedArray[index] = null;
                } else {
                    vm.selectedAutoAssignBookingCount += 1;
                    vm.selectedArray[index] = (customer_data)
                }
            }
        }

        function resetSelectedData() {
            vm.colorFlag = [];
            vm.selectedArray = [];
            vm.selectedAutoAssignBookingCount = 0;
        }

        function checkFilterStatus(data) {
            var flagStatus = false;
            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            var dateTo = new Date(date_time_value2).getTime();
            var dateFrom = new Date(date_time_value1).getTime();
            var booking_date = data.job_time_utc;
            booking_date = new Date(booking_date).getTime();
            console.log(data, 'data');

            if (dateFrom <= booking_date && booking_date <= dateTo) {
                console.log("date match >>>>>>>>>>>>>>>>>>>>", dateFrom, booking_date, dateTo);
                if (vm.filterData.type_of_trip_filter == [] || (vm.filterData.type_of_trip.includes(data.type_of_trip))) {
                    console.log("type of of trip match >>>>>>>>>>>>>>>>>>>>");
                    if (vm.filterData.service_filter == [] || vm.filterData.service.includes(data.type_of_service)) {
                        console.log("type of of service match >>>>>>>>>>>>>>>>>>>>");
                        if (vm.filterData.aggrement_filter == 0 || (vm.filterData.agreement == data.contract_id) || vm.filterData.agreement.includes(data.contract_id)) {
                            console.log("type of of  agreement match>>>>>>>>>>>>>>>>>>>>");
                            if (vm.filterData.branch_filter == 0 || (vm.filterData.branch == data.branch) || (vm.filterData.branch == data.branch_id)) {
                                console.log("type of of branch match >>>>>>>>>>>>>>>>>>>>");
                                flagStatus = true;
                            }
                        }
                    }
                }
            }
            return flagStatus;
        }

        // ********** INSERT INTO ARRAY **********
        Array.prototype.insert = function (index, item) {
            this.splice(index, 0, item);
        };
        //====================SOCKET CONNECTION FOR UNASSIGNBOOKING===================

        // ==================== SOCKET CONNECTION FOR CREATE THE PACKAGE /////////////
        $rootScope.$on('socketEventPackageCreationForSharedScreen', function (evt, data) {
            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            if(data.res.message[0] != undefined){
                data.res.message = data.res.message[0];
            }
            var index1 = _.findIndex(vm.UnAssignBookingList, {
                shared_service_id: data.res.message.shared_service_id
            });
            var index2 = _.findIndex(vm.assignBookingList, {
                shared_service_id: data.res.message.shared_service_id
            });
            
            if (checkFilterStatus(data.res.message)) {
                if (index1 == -1) {
                    vm.UnAssignBookingList.push({
                        "contract_name": data.res.message.contract_name,
                        "contract_id": data.res.message.contract_id,
                        "branch": data.res.message.branch_id,
                        "job_id": data.res.message.job_id,
                        "job_pickup_address": data.res.message.job_pickup_address,
                        "job_pickup_name": data.res.message.job_pickup_name,
                        "job_time_utc": data.res.message.job_time_utc,
                        "shared_service_id": data.res.message.shared_service_id,
                        "type_of_service": data.res.message.type_of_service,
                        "color": data.res.message.urgent_booking_assignment ? '#ff4d4d' : '#333',
                        "booking_visibility_flag": data.res.message.booking_visibility_flag,
                        "auto_assignment": data.res.message.auto_assignment
                    });
                } 
                if (index2 != -1) {
                    if (data.res.message.status == 6) {
                        vm.assignBookingList.splice(index2, 1);
                    }
                }
                $scope.$apply();
            }
        });

        // ==================== SOCKET CONNECTION FOR JOB MULTIPLE TO CHANGE THE STATUS /////////////
        $rootScope.$on('NotifyToAdminForJobMultiple', function (evt, data) {
            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            var dateTo = new Date(date_time_value2).getTime();
            var dateFrom = new Date(date_time_value1).getTime();
            var index1 = _.findIndex(vm.UnAssignBookingList, {
                job_id: data.res.message.job_id
            });
            if (checkFilterStatus(data.res.message)) {
                if (index1 != -1) {
                    if (data.res.message.urgent_booking_assignment == 1) {
                        var dummyObject = vm.UnAssignBookingList.splice(index1, 1);
                        vm.UnAssignBookingList.insert(0, dummyObject[0]);
                        vm.UnAssignBookingList[0].auto_assignment = data.res.message.auto_assignment;
                        vm.UnAssignBookingList[0].booking_visibility_flag = data.res.message.booking_visibility_flag;
                        vm.UnAssignBookingList[0].color = data.res.message.urgent_booking_assignment ? '#ff4d4d' : '#333';
                        if (vm.colorFlag[index1]) {
                            vm.colorFlag[0] = !vm.colorFlag[0];
                            if (vm.selectedAutoAssignBookingCount > 0)
                                vm.selectedAutoAssignBookingCount -= 1;
                        }
                        $scope.$apply();
                    } else {
                        vm.UnAssignBookingList[index1].auto_assignment = 1;
                        vm.UnAssignBookingList[index1].booking_visibility_flag = data.res.message.booking_visibility_flag;
                        vm.UnAssignBookingList[index1].color = data.res.message.urgent_booking_assignment ? '#ff4d4d' : '#333';
                        if (vm.colorFlag[index1]) {
                            vm.colorFlag[index1] = !vm.colorFlag[index1];
                            if (vm.selectedAutoAssignBookingCount > 0)
                                vm.selectedAutoAssignBookingCount -= 1;
                        }
                        $scope.$apply();
                    }
                }
            }
        });
        // ==================== SOCKET CONNECTION FOR DELETE THE PACKAGE /////////////
        $rootScope.$on('sendGroupedPakageStatusChangeSocket', function (evt, data) {
            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            var dateTo = new Date(date_time_value2).getTime();
            var dateFrom = new Date(date_time_value1).getTime();
            if (checkFilterStatus(data.res.message)) {
                var index2 = _.findIndex(vm.assignBookingList, {
                    shared_service_id: data.res.message.shared_service_id
                });
                var index1 = _.findIndex(vm.UnAssignBookingList, {
                    shared_service_id: data.res.message.shared_service_id
                });
                console.log(index2, 'index2?????', index1, 'index2>>>>>>>');

                if (index2 != -1) {
                    console.log(" i m in this >>>>>>>>>>");

                    if (data.res.message.job_status == 1 || data.res.message.job_status == 12 || data.res.message.job_status == 9) {
                        vm.assignBookingList.splice(index2, 1);
                    } else if (data.res.message.job_status == 6) {
                        vm.assignBookingList.splice(index2, 1);
                        vm.UnAssignBookingList.push({
                            "contract_name": data.res.message.contract_name,
                            "contract_id": data.res.message.contract_id,
                            "branch": data.res.message.branch,
                            "job_id": data.res.message.job_id,
                            "job_pickup_address": data.res.message.job_pickup_address,
                            "job_pickup_name": data.res.message.job_pickup_name,
                            "job_time_utc": data.res.message.job_time_utc,
                            "shared_service_id": data.res.message.shared_service_id,
                            "type_of_service": data.res.message.type_of_service,
                            "color": data.res.message.urgent_booking_assignment ? '#ff4d4d' : '#333',
                            "booking_visibility_flag": data.res.message.booking_visibility_flag,
                            "auto_assignment": data.res.message.auto_assignment
                        });
                    } else {
                        console.log(" i m in this  else >>>>>>>>>>");
                        vm.assignBookingList[index2].job_status = data.res.message.job_status;
                    }
                    $scope.$apply();
                }
                if (index2 == -1) {
                    if (index1 != -1) {
                        vm.UnAssignBookingList.splice(index1, 1);
                        $scope.$apply();
                    }
                    if (data.res.message.job_status == 0 || data.res.message.job_status == 7) {
                        vm.assignBookingList.push({
                            "contract_name": data.res.message.contract_name,
                            // "booking_type": data.res.mess.booking_type,
                            "job_addres": data.res.message.job_address,
                            "job_status": data.res.message.job_status,
                            "job_id": data.res.message.job_id,
                            "job_pickup_address": data.res.message.job_pickup_address,
                            "job_pickup_name": data.res.message.job_pickup_name,
                            "unique_car_id": data.res.message.unique_car_id,
                            "fleet_first_name": data.res.message.fleet_first_name + '' + data.res.message.fleet_last_name,
                            "fleet_phone_number": data.res.message.fleet_country_code + data.res.message.fleet_phone_number,
                            "service_name": data.res.message.service_name,
                            "auto_assignment": data.res.message.auto_assignment,
                            "shared_service_id": data.res.message.shared_service_id,
                            "job_time_utc": data.res.message.job_time_utc,
                            "urgent_booking_assignment": data.res.message.urgent_booking_assignment,
                            "type_of_trip": data.res.message.type_of_trip,
                            "assignment_identity": data.res.message.assignment_identity
                        });
                        $scope.$apply();
                    }
                }
                if (index1 == -1 && index2 == -1) {
                    if (data.res.message.job_status == 6) {
                        vm.UnAssignBookingList.push({
                            "contract_name": data.res.message.contract_name,
                            "contract_id": data.res.message.contract_id,
                            "branch": data.res.message.branch,
                            "job_id": data.res.message.job_id,
                            "job_pickup_address": data.res.message.job_pickup_address,
                            "job_pickup_name": data.res.message.job_pickup_name,
                            "job_time_utc": data.res.message.job_time_utc,
                            "shared_service_id": data.res.message.shared_service_id,
                            "type_of_service": data.res.message.type_of_service,
                            "color": data.res.message.urgent_booking_assignment ? '#ff4d4d' : '#333',
                            "booking_visibility_flag": data.res.message.booking_visibility_flag,
                            "auto_assignment": data.res.message.auto_assignment
                        });
                    } else if (data.res.message.job_status == 4) {
                        if (index1 != -1) {
                            vm.UnAssignBookingList.splice(index1, 1);
                            $scope.$apply();
                        }
                        vm.assignBookingList.push({
                            "contract_name": data.res.message.contract_name,
                            // "booking_type": data.res.mess.booking_type,
                            "job_addres": data.res.message.job_address,
                            "job_status": data.res.message.job_status,
                            "job_id": data.res.message.job_id,
                            "job_pickup_address": data.res.message.job_pickup_address,
                            "job_pickup_name": data.res.message.job_pickup_name,
                            "unique_car_id": data.res.message.unique_car_id,
                            "fleet_first_name": data.res.message.fleet_first_name + '' + data.res.message.fleet_last_name,
                            "fleet_phone_number": data.res.message.fleet_country_code + data.res.message.fleet_phone_number,
                            "service_name": data.res.message.service_name,
                            "auto_assignment": data.res.message.auto_assignment,
                            "shared_service_id": data.res.message.shared_service_id,
                            "job_time_utc": data.res.message.job_time_utc,
                            "urgent_booking_assignment": data.res.message.urgent_booking_assignment,
                            "type_of_trip": data.res.message.type_of_trip,
                            "assignment_identity": data.res.message.assignment_identity
                        });
                    }
                    $scope.$apply();
                }
            }
        });


        // ==================== SOCKET CONNECTION FOR DELETE THE PACKAGE /////////////
        $rootScope.$on('socketEventDeletion', function (evt, data) {
            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            var dateTo = new Date(date_time_value2).getTime();
            var dateFrom = new Date(date_time_value1).getTime();
            for (var i = 0; i < data.res.message.length; i++) {
                var index1 = _.findIndex(vm.UnAssignBookingList, {
                    job_id: data.res.message[i].job_id
                });
                var index2 = _.findIndex(vm.assignBookingList, {
                    job_id: data.res.message[i].job_id
                });
                if (index1 != -1) {
                    vm.UnAssignBookingList.splice(index1, 1);
                    $scope.$apply();
                }
                if (index2 != -1) {
                    vm.assignBookingList.splice(index2, 1);
                    $scope.$apply();
                }
            }
        });


        // ==================== SOCKET CONNECTION FOR MODIFICATION  THE PACKAGE /////////////
        $rootScope.$on('sendGroupedPakageBookingCancelSocket', function (evt, data) {
            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            var dateTo = new Date(date_time_value2).getTime();
            var dateFrom = new Date(date_time_value1).getTime();
            var index2 = _.findIndex(vm.UnAssignBookingList, {
                shared_service_id: data.res.message.shared_service_id
            });
            if (checkFilterStatus(data.res.message)) {
                if (index2 != -1) {
                    vm.UnAssignBookingList[index2].job_time_utc = data.res.message.job_time_utc;
                    vm.UnAssignBookingList[index2].type_of_trip = data.res.message.type_of_trip;
                    vm.UnAssignBookingList[index2].type_of_service = data.res.message.type_of_service;
                    vm.UnAssignBookingList[index2].contract_id = data.res.message.contract_id;
                    vm.UnAssignBookingList[index2].branch = data.res.message.branch;
                    vm.UnAssignBookingList[index2].shared_service_id = data.res.message.shared_service_id;
                    vm.UnAssignBookingList[index2].contract_name = data.res.message.contract_name;
                    vm.UnAssignBookingList[index2].job_pickup_name = data.res.message.job_pickup_name;
                    vm.UnAssignBookingList[index2].job_id = data.res.message.job_id;
                    vm.UnAssignBookingList[index2].job_pickup_address = data.res.message.job_pickup_address;
                    vm.UnAssignBookingList[index2].booking_visibility_flag = data.res.message.booking_visibility_flag;
                    vm.UnAssignBookingList[index2].auto_assignment = data.res.message.auto_assignment;
                    vm.UnAssignBookingList[index2].urgent_booking_assignment = data.res.message.urgent_booking_assignment;
                }
                $scope.$apply();
            }
        });
        // ==================== SOCKET CONNECTION FOR ENDED THE STATUS OF PAKCAGE  /////////////
        var deletePackageSocket = $rootScope.$on('socketEventPackageEnded', function (evt, data) {
            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            var dateTo = new Date(date_time_value2).getTime();
            var dateFrom = new Date(date_time_value1).getTime();
            var index2 = _.findIndex(vm.assignBookingList, {
                shared_service_id: data.data.message.shared_service_id
            });
            var index1 = _.findIndex(vm.UnAssignBookingList, {
                shared_service_id: data.data.message.shared_service_id
            });
            if (index2 != -1) {
                vm.assignBookingList.splice(index2, 1);
                $scope.$apply();
            }
            if (index1 != -1) {
                vm.UnAssignBookingList.splice(index1, 1);
                $scope.$apply();
            }
        });
        function massivePushToDrivers() {
            var dataSend = {};
            var dataSendShared = {};
            dataSend.job_id = [];
            dataSendShared.job_id = [] ;
            dataSend.access_token = $cookies.get('obj');
            dataSendShared.access_token = $cookies.get('obj');
            console.log(vm.selectedArray);
            vm.selectedArray.forEach(function (data) {
                if (data != null){
                    //for (var i = 0; i < vm.UnAssignBookingList.length; i++) {
                        //if (vm.UnAssignBookingList[i].job_id === data.job_id) {
                            //vm.UnAssignBookingList[i].booking_visibility_flag = 1;
                            ////$scope.$apply();
                            //break; 
                        //}
                    //}
                    if(data.booking_type == 1){
                        dataSendShared.job_id.push(data.job_id);
                    }else{
                        dataSend.job_id.push(data.job_id);
                    } 
                }       
            })
            dataSend.job_id = _.uniq(dataSend.job_id);
            dataSendShared.job_id = _.uniq(dataSendShared.job_id);
            // if (dataSend.job_id.length == 0) {
            //     return;
            // }
            // dataSend.socket_id = $rootScope.socket.id;
            vm.loading = true;
            vm.flagForLoading = false;
            if(dataSend.job_id[0]){
                var promise = getBookings.autoAssignMassivePushGrouped(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        //vm.loading = false;

                        // socketDataForAssign();
                        if (payload.title.status == 400) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            vm.loading = false;
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                            vm.loading = false;
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            vm.loading = false;
                            vm.colorFlag = [];
                            vm.selectedArray = [];
                            vm.selectedAutoAssignBookingCount = 0;
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }
            if(dataSendShared.job_id[0]){
                var send = { 
                    "job_id": dataSendShared.job_id[0],
                    "check_socket": false,
                    "access_token": $cookies.get('obj')
                }
                var promise = getBookings.autoAssignNewMassivePushShared(send);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        //vm.loading = false;

                        // socketDataForAssign();
                        if (payload.title.status == 400) {
                            console.log("no tuvo respuestas")
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            vm.loading = false;
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                            vm.loading = false;
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            vm.loading = false;
                            vm.colorFlag = [];
                            vm.selectedArray = [];
                            vm.selectedAutoAssignBookingCount = 0;
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }
        }

        //====================MASSIVE PUSH TO DRIVERS ===================
    }



})();

/**
 * Created by cl-macmini-51 on 6/22/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('SharedParametersController', SharedParametersController);

    /** @ngInject */
    function SharedParametersController($cookies, $state, $log, $rootScope, $scope, sharedParams, getDriverEarning, languageBasedErrorFactory, errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.parametersData = {};
        vm.showValue = true;
        vm.changeValues = changeValues;
        vm.addGlobalParamsFun = addGlobalParamsFun;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.globalParametersMain.configAssignment');
            }
        });


        //========================add new earning hit============================
        function getSharedParameters() {
            vm.loading = true;
            var toSend = {};
            toSend.access_token = $cookies.get('obj');
            //toSend.booking_status = 4;
            var promise = sharedParams.getSharedParams(toSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.parametersData = payload.title.data;
                    for (var i = 0; i < vm.parametersData.length; i++) {
                        vm.parametersData[i].showValue = true;
                        vm.parametersData[i].showValue1 = true;
                    }
                    //vm.value = vm.parametersData[0].ratio ;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getSharedParameters();



        function changeValues(index) {
            vm.parametersData[index].showValue = !vm.parametersData[index].showValue;
        }





        //==========================edit earning hit===========================
        function addGlobalParamsFun(data, id) {  
            if(data.type == 'CONTACT_EMAIL'){
                var re = /^([_a-zA-Z0-9-+]+)(\.[_a-zA-Z0-9-+]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*\.)+([a-zA-Z]{2,3})$/;
                if(re.test(data.value) == false){
                    errorMessageFactory.showErrorMessage('Favor ingrese un Email válido', 0);
                    return true;
                }
                // return re.test(data.value);
            }
            if(data.value == '' || data.value == null || data.value == undefined){
                return true;
            }
            if (id == 7 && data < 1) {
                errorMessageFactory.showErrorMessage('El valor debe ser mayor que cero', 0);
                return false;
            }
            if(data.type == 'POPUP_HEADER' || data.type == 'POPUP_MESSAGE' || data.type == 'POPUP_TIME') {
                if(data.value.length > 100){
                    errorMessageFactory.showErrorMessage('los personajes deben ser menos de 100', 0);
                    return false;
                }
            }
            if(data.type == 'POPUP_ADDRESS'){
                if(data.value.length > 150){
                    errorMessageFactory.showErrorMessage('los personajes deben ser menos de 150', 0);
                    return false;
                }
            }
            if(data.type == 'ALERT_EMAIL'){
                var dataAraay = data.value;
                dataAraay = dataAraay.split(";");
                if(dataAraay.length > 5){
                    return;
                }
            }
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.id = Number(id);
            dataSend.value = Number(data.value);
            vm.loading = true;
            var promise = sharedParams.addSharedParams(dataSend);
            promise.then(
                function (payload) {
                    console.log(payload);
                    vm.loading = false;
                    $log.log('sxdsads', payload);
                    if (payload.title.status == 200) {
                        languageBasedErrorFactory.getProperErrorMessage('parameterSucc', 0, 1, 'layout.globalParametersMain.configAssignment');
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }


                    //errorMessageFactory.showErrorMessage('Parameter updated.',1);
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

    }
})();

/**
 * Created by cl-macmini-51 on 6/22/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('GlobalParametersController', GlobalParametersController);

    /** @ngInject */
    function GlobalParametersController($cookies, $state, $log, $rootScope, $scope, globalParams, getDriverEarning, languageBasedErrorFactory, errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.parametersData = {};
        vm.showValue = true;
        vm.changeValues = changeValues;
        vm.addGlobalParamsFun = addGlobalParamsFun;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.globalParametersMain.globalParameters');
            }
        });


        //========================add new earning hit============================
        function getGlobalParameters() {
            vm.loading = true;
            var toSend = {};
            toSend.access_token = $cookies.get('obj');
            //toSend.booking_status = 4;
            var promise = globalParams.getGlobalParams(toSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.parametersData = payload.title.data;
                    for (var i = 0; i < vm.parametersData.length; i++) {
                        ///////////// TICKET  TV-1971 //////////////////////// 
                        if (vm.parametersData[i].is_text == 0) {
                            vm.parametersData[i].value = vm.parametersData[i].ratio;
                            vm.parametersData[i].showValue = true;
                            vm.parametersData[i].showValue1 = false;
                        } else if( vm.parametersData[i].is_text == 1 &&  vm.parametersData[i].type != 'RATE_NOT_FOUND' ){
                            vm.parametersData[i].value = vm.parametersData[i].reason;
                            vm.parametersData[i].ratio = vm.parametersData[i].reason;
                            vm.parametersData[i].showValue = true;
                            vm.parametersData[i].showValue1 = true;
                        } else if(vm.parametersData[i].is_text == 6){
                            vm.parametersData[i].value = vm.parametersData[i].ratio; 
                            vm.parametersData[i].ratio = vm.parametersData[i].ratio;
                            vm.parametersData[i].showValue = true;
                            vm.parametersData[i].showValue1 = true;
                            var optionsParam = vm.parametersData[i].options.replace(/(\w+):/g, '"$1":')
                            vm.parametersData[i].options = JSON.parse(optionsParam);
                            for(var o = 0; o < JSON.parse(optionsParam).length; o++){
                                if(JSON.parse(optionsParam)[o].id == parseInt(vm.parametersData[i].ratio)){
                                    vm.parametersData[i].optionSelected = JSON.parse(optionsParam)[o].name;
                                }
                            }
                        }else{
                            vm.parametersData[i].value = vm.parametersData[i].ratio;
                            vm.parametersData[i].ratio = vm.parametersData[i].ratio;
                            vm.parametersData[i].showValue = true;
                            vm.parametersData[i].showValue1 = true;
                        }
                        ///////////// TICKET  TV-1971 //////////////////////// 
                    }
                    //vm.value = vm.parametersData[0].ratio ;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getGlobalParameters();



        function changeValues(index) {
            vm.parametersData[index].showValue = !vm.parametersData[index].showValue;
        }





        //==========================edit earning hit===========================
        function addGlobalParamsFun(data, id) {  
            if(data.type == 'CONTACT_EMAIL'){
                var re = /^([_a-zA-Z0-9-+]+)(\.[_a-zA-Z0-9-+]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*\.)+([a-zA-Z]{2,3})$/;
                if(re.test(data.value) == false){
                    errorMessageFactory.showErrorMessage('Favor ingrese un Email válido', 0);
                    return true;
                }
                // return re.test(data.value);
            }
            if(data.value == '' || data.value == null || data.value == undefined){
                return true;
            }
            if (id == 7 && data < 1) {
                errorMessageFactory.showErrorMessage('El valor debe ser mayor que cero', 0);
                return false;
            }
            if(data.type == 'POPUP_HEADER' || data.type == 'POPUP_MESSAGE' || data.type == 'POPUP_TIME') {
                if(data.value.length > 100){
                    errorMessageFactory.showErrorMessage('los personajes deben ser menos de 100', 0);
                    return false;
                }
            }
            if(data.type == 'POPUP_ADDRESS'){
                if(data.value.length > 150){
                    errorMessageFactory.showErrorMessage('los personajes deben ser menos de 150', 0);
                    return false;
                }
            }
            if(data.type == 'ALERT_EMAIL'){
                var dataAraay = data.value;
                dataAraay = dataAraay.split(";");
                if(dataAraay.length > 5){
                    return;
                }
            }
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.id = Number(id);
            ///////////// TICKET  TV-1971 //////////////////////// 
            if (data.is_text == 0) {
                dataSend.at_position_parameter = Number(data.value);
            } else {
                dataSend.is_text = data.is_text;
                dataSend.text = (data.value);
            }
            ///////////// TICKET  TV-1971 //////////////////////// 
            vm.loading = true;
            var promise = globalParams.addGlobalParams(dataSend);
            promise.then(
                function (payload) {
                    console.log(payload);
                    vm.loading = false;
                    $log.log('sxdsads', payload);
                    if (payload.title.status == 200) {
                        languageBasedErrorFactory.getProperErrorMessage('parameterSucc', 0, 1, 'layout.globalParametersMain.globalParameters');
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }


                    //errorMessageFactory.showErrorMessage('Parameter updated.',1);
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

    }
})();

/**
 * Created by cl-macmini-51 on 7/12/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('ViewFixedRouteListController', ViewFixedRouteListController);

    /** @ngInject */
    function ViewFixedRouteListController($cookies, $state, $log, $rootScope, $timeout, getCars, $scope, filterFilter, $mdDialog,$document, getGeofence,$stateParams, languageBasedErrorFactory,errorMessageFactory,Initializer) {
        var vm = this;
        vm.loading = false;
        var myCenter;
        var zoomLevel = 8;
        var mapProp={};
        var mc=null;
        var map =null;
        var icon = {};
        var drawingManager;
        var bounds;
        var geocoder;
        var infoWindow;
        var location = "";
        var currentId = 0;
        var laArray = [];
        var poly  = '';
        var uniqueId = function() {
            return ++currentId;
        };
          // Service To Get Map Instance
          Initializer.mapsInitialized
          .then(function () {
              console.log('>>>> GOOGLE INIT', google);
              if (google) {
                 drawingManager = new google.maps.drawing.DrawingManager;
                 bounds = new google.maps.LatLngBounds();
                 geocoder = new google.maps.Geocoder();
                 infoWindow = new google.maps.InfoWindow();
                 myCenter= new google.maps.LatLng(30.741482,76.768066);
                 document.getElementById("googleMap").style.height = window.innerHeight - 200 + 'px';
                 mapInitialize();
              } else {
                  alert(languageBasedErrorFactory.getProperErrorMessage('onRoadMessage', 0, '3'));
              }
 
          });
   
        vm.getAllFixedRoutes = getAllFixedRoutes;
        vm.goBack = goBack;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.fixedRouteMain.viewFixedRoute');
            }
        });

        // If the map position is out of range, move it back
        function checkBounds(map) {
            if (typeof(map.getBounds()) == 'undefined')
                return;

            var latNorth = map.getBounds().getNorthEast().lat();
            var latSouth = map.getBounds().getSouthWest().lat();
            var newLat;

            if (latNorth < 85 && latSouth > -85) /* in both side -> it's ok */
                return;
            else {
                if (latNorth > 85 && latSouth < -85) /* out both side -> it's ok */
                    return;
                else {
                    if (latNorth > 85)
                        newLat = map.getCenter().lat() - (latNorth - 85);
                    /* too north, centering */
                    if (latSouth < -85)
                        newLat = map.getCenter().lat() - (latSouth + 85);
                    /* too south, centering */
                }
            }
            if (newLat) {
                var newCenter = new google.maps.LatLng(newLat, map.getCenter().lng());
                map.setCenter(newCenter);
            }
        }

        //==================map function======================
        function drawingFunctions(map,data){
            var triangleCoords = [];
            for(var i=0;i<data.region_data.length;i++){
                triangleCoords.push({
                    lat: Number(data.region_data[i].x), lng: Number(data.region_data[i].y)
                })
            }
            // Construct the polygon.
            var bermudaTriangle = new google.maps.Polygon({
                paths: triangleCoords,
                strokeColor: data.strokeColor,
                strokeOpacity: 1,
                strokeWeight: 2,
                fillColor: data.fillColor,
                fillOpacity: 0.5
            });
            bermudaTriangle.content = '';
            if(data.parent_id == 0){
                bermudaTriangle.content = '<div class="infoWindowContent">' +
                    '<center><b>Branch</b></center>' +
                    '<span> ' + data.region_name + '</span><br>'+
                '</div>';
            }
            else{
                bermudaTriangle.content = '<div class="infoWindowContent">' +
                    '<center><b>Geofence</b></center>' +
                    '<span> ' + data.region_name + '</span><br>'+
                '</div>';
            }

            drawingManager.setOptions({
                drawingControl: false,
                drawingMode: null
            });
            bermudaTriangle.setOptions({
                editable: false
            });
            //infoWindow.setContent(bermudaTriangle.content);
            //infoWindow.setPosition(new google.maps.LatLng(data.region_data[0].x,data.region_data[0].y));
            //infoWindow.open(map);
            google.maps.event.addListener(bermudaTriangle, 'click', function (event) {
                infoWindow.setContent(bermudaTriangle.content);
                infoWindow.setPosition(event.latLng);
                infoWindow.open(map,bermudaTriangle);
            });
            bermudaTriangle.setMap(map);
        };

        function mapInitialize()
        {
            mapProp = {
                center: myCenter,
                zoom: Number(zoomLevel),
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                minZoom: 3,
                //maxZoom: 15,
                scrollwheel: false
            };
            map=new google.maps.Map(document.getElementById("googleMap"),mapProp);
            google.maps.event.addListener(map, 'center_changed', function () {
                checkBounds(map);
            });
        };
       
        //==================get all drivers=======================
        function getAllFixedRoutes(skip, limit,filter) {
            var dataSend = {};
            //dataSend.offset = skip;
            //dataSend.limit = limit;
            //dataSend.key = filter;
            //dataSend.search_filter = 0;
            dataSend.region_id = $stateParams.id;
            dataSend.access_token = $cookies.get('obj');
            vm.loading = true;
            var promise = getGeofence.getAllFixedRouteNew(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.fixedRouteDetails = _.where(payload.title.data.result,{id:Number($stateParams.id)})[0];
                    vm.fixedRouteDetails.location1 = {};
                    vm.fixedRouteDetails.location2 = {};
                    vm.fixedRouteDetails.location1.region_id = vm.fixedRouteDetails.origin_region_id;
                    vm.fixedRouteDetails.location1.region_data = vm.fixedRouteDetails.origin_region_data;
                    vm.fixedRouteDetails.location1.parent_id = vm.fixedRouteDetails.origin_parent_id;
                    vm.fixedRouteDetails.location2.region_id = vm.fixedRouteDetails.destination_region_id;
                    vm.fixedRouteDetails.location2.region_data = vm.fixedRouteDetails.destination_region_data;
                    vm.fixedRouteDetails.location2.parent_id = vm.fixedRouteDetails.destination_parent_id;
                    getAllBranches();
                },
                function (errorPayload) {
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                });
        };
        getAllFixedRoutes(0,0,2);
        //===========================get all branches==========================
        function getAllBranches(){
            vm.loading = true;
            var promise = getGeofence.getAllBranchList(2);
            promise.then(
                function(payload) {
                    vm.loading = false;
                    var parentBranch = _.where(payload.title.data,{region_id:Number(vm.fixedRouteDetails.location1.parent_id)})[0];
                    vm.fixedRouteDetails.parentData = parentBranch;
                    vm.fixedRouteDetails.parentData.strokeColor = '#f18903';
                    vm.fixedRouteDetails.parentData.fillColor = 'transparent';
                    vm.fixedRouteDetails.location1.strokeColor = '#063c4a';
                    vm.fixedRouteDetails.location1.fillColor = '#063c4a';
                    vm.fixedRouteDetails.location2.strokeColor = '#063c4a';
                    vm.fixedRouteDetails.location2.fillColor = '#063c4a';
                    vm.fixedRouteDetails.location2.region_data = vm.fixedRouteDetails.location2.region_data[0];
                    vm.fixedRouteDetails.location1.region_data = vm.fixedRouteDetails.location1.region_data[0];
                    drawingFunctions(map,vm.fixedRouteDetails.parentData);
                    drawingFunctions(map,vm.fixedRouteDetails.location1);
                    drawingFunctions(map,vm.fixedRouteDetails.location2);
                    map.setCenter(new google.maps.LatLng(Number(vm.fixedRouteDetails.location2.region_data[0].x),Number(vm.fixedRouteDetails.location2.region_data[0].y)));
                    map.setZoom(10);
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        //====================go back===========================
        function goBack(){
            $state.go('layout.fixedRouteMain.fixedRouteList');
        }
    }
})();
/**
 * Created by cl-macmini-51 on 5/24/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('IlluminatedZoneController', IlluminatedZoneController);

    /** @ngInject */
    function IlluminatedZoneController($cookies, $state, $log, $rootScope, checkDomain, $timeout, Initializer, getCars, $scope, filterFilter, $mdDialog, $document, getGeofence, languageBasedErrorFactory, errorMessageFactory) {
        var vm = this;
        $log.log('driver');
        var myCenter;
        var zoomLevel = 8;
        var all_overlays = [];
        var coordinates_array = [];
        vm.maximum_quantity_show_driverapp = 0;
        vm.addressChange = addressChange;
        vm.pickAddressFlag = false;
        var markers = [];
        var mapProp = {};
        var drawingManager = '';
        var mc = null;
        var map = null;
        var icon = {};
        var bounds;
        var geocoder;
        var infoWindow;
        var location = "";
        var currentId = 0;
        var laArray = [];
        var poly = '';
        var uniqueId = function () {
            return ++currentId;
        };
        // Service To Get Map Instance
        Initializer.mapsInitialized
            .then(function () {
                console.log('>>>> GOOGLE INIT', google);
                if (google) {
                    myCenter = new google.maps.LatLng(-33.447487, -70.673676);
                    bounds = new google.maps.LatLngBounds();
                    geocoder = new google.maps.Geocoder();
                    infoWindow = new google.maps.InfoWindow();
                } else {
                    alert(languageBasedErrorFactory.getProperErrorMessage('onRoadMessage', 0, '3'));
                }

            });
        vm.addressHave = '';
        vm.noDataFlag = false;
        vm.addIlluminatedZoneFlag = true;
        vm.editIlluminatedZoneFlag = false;
        vm.viewIlluminatedZoneFlag = false;
        vm.isAirportService = false;
        vm.filterData = {
            geofenceStatus: '1'
        };
        vm.branchList = [];
        vm.currentPage = 0;
        vm.dataLength = 0;
        vm.skipValueFilter = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.predicate = 'index';
        vm.reverse = false;

        vm.getPagesCount = getPagesCount;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.paginationNew = paginationNew;
        vm.setMapOnAll = setMapOnAll;
        vm.drawingFunctions = drawingFunctions;
        vm.mapInitialize = mapInitialize;
        vm.latLongArrayList = latLongArrayList;
        vm.addIlluminatedZoneHit = addIlluminatedZoneHit;
        vm.getAllBranches = getAllBranches;
        vm.branchChanged = branchChanged;
        vm.editIlluminatedZoneHit = editIlluminatedZoneHit;
        vm.editIlluminatedZoneGeofence = editIlluminatedZoneGeofence;
        vm.cancelEdit = cancelEdit;
        vm.cancelIlluminatedZoneEdit = cancelIlluminatedZoneEdit;
        vm.deleteIlluminatedZone = deleteIlluminatedZone;
        vm.viewIlluminatedRegion = viewIlluminatedRegion;
        vm.goBack = goBack;
        vm.setBooleans = setBooleans;
        vm.changeFixedRegionStatus = changeFixedRegionStatus;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        //====================function for dropdown pages and page count===============
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
        vm.showAddBranchForm = false;
        vm.showMap = false;
        vm.onAddClick = onAddClick;

        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllBranches(0, vm.itemsPerPageGot, vm.filterData);
        };

        function paginationNew(page) {
            getAllBranches((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot);
        }

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            vm.filterOn = true;
            vm.currentPage = 0;
            //pendingRequests.cancelAll();
            if (vm.search.length == 0) {
                vm.filterOn = false;
                vm.watchPagination = true;
                vm.sp_pagination = true;

            }
        };

        //==========================set boolean=======================
        function setBooleans(type) {
            switch (type) {
                case 'AIRPORT_ZONE':
                    if (vm.isAirportService) {
                        vm.isAirportService = false;
                    } else {
                        vm.isAirportService = true;
                    }
                    break;
            }
        };

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.fixedRouteGeofenceMain.fixedRouteGeofenceList');
                $state.reload('layout.illuminatedZoneMain.illuminatedZone');
            }
        });
        //================set map nulll======================
        function setMapOnAll(map, id) {
            for (var i = 0; i < markers.length; i++) {
                var marker = markers[i];
                marker.setMap(map);
            }
        };
        // If the map position is out of range, move it back
        function checkBounds(map) {
            if (typeof (map.getBounds()) == 'undefined')
                return;

            var latNorth = map.getBounds().getNorthEast().lat();
            var latSouth = map.getBounds().getSouthWest().lat();
            var newLat;

            if (latNorth < 85 && latSouth > -85) /* in both side -> it's ok */
                return;
            else {
                if (latNorth > 85 && latSouth < -85) /* out both side -> it's ok */
                    return;
                else {
                    if (latNorth > 85)
                        newLat = map.getCenter().lat() - (latNorth - 85);
                    /* too north, centering */
                    if (latSouth < -85)
                        newLat = map.getCenter().lat() - (latSouth + 85);
                    /* too south, centering */
                }
            }
            if (newLat) {
                var newCenter = new google.maps.LatLng(newLat, map.getCenter().lng());
                map.setCenter(newCenter);
            }
        }
        //===========================auto complete===============================
        function addressChange(data) {
            initAutocomplete(data);

        }
        var autocomplete;
        var domain = checkDomain.getDomainName();

        function initAutocomplete(data) {
            if ((!vm.pickAddressFlag) && data && data.length >= 3) {
                vm.pickAddressFlag = true;
                autocomplete = new google.maps.places.Autocomplete(
                    (document.getElementById('addressGot')), {
                        placeIdOnly: true
                    });
                if (domain != 'dev' && domain != 'test')
                    autocomplete.setComponentRestrictions({
                        'country': ['CL']
                    });

                autocomplete.addListener('place_changed', fillInAddress);
            } else if (data && data.length < 3) {
                vm.pickAddressFlag = false;
                google.maps.event.clearInstanceListeners(addressGot);
                $(".pac-container").hide();
            }
        };

        function placeMarker(map, location) {
            if (markers.length > 1) {
                setMapOnAll(null);
            }
            var id = uniqueId();
            var marker = new google.maps.Marker({
                id: id,
                position: location,
                draggable: false,
                map: map
            });
            //bounds.extend(location);
            //map.fitBounds(bounds);
            markers.push(marker);
        };

        function fillInAddress() {
            // Get the place details from the autocomplete object.
            var place = autocomplete.getPlace();
            if (!place.place_id) {
                return;
            }
            geocoder.geocode({
                'placeId': place.place_id
            }, function (results, status) {
                if (status !== 'OK') {
                    window.alert('Geocoder failed due to: ' + status);
                    return;
                }
                var formattedAddress = results[0].formatted_address;
                vm.addressHave = formattedAddress;
                myCenter = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
                zoomLevel = 12;
                mapInitialize(vm.fixedRouteList);
                placeMarker(map, myCenter);
            });
        };
        initAutocomplete();
        //================map initialize===========================
        function drawingFunctions(map, data, type) {
            var triangleCoords = [];
            for (var i = 0; i < data.region_data.length; i++) {
                triangleCoords.push({
                    lat: data.region_data[i].x,
                    lng: data.region_data[i].y
                })
            }

            // Construct the polygon.
            var bermudaTriangle = new google.maps.Polygon({
                paths: triangleCoords,
                strokeColor: data.strokeColor,
                strokeOpacity: 1,
                strokeWeight: 2,
                fillColor: data.fillColor,
                fillOpacity: 0.5
            });
            if (type) {
                bermudaTriangle.content = '<div class="infoWindowContent">' +
                    '<center><b>Branch</b></center>' +
                    '<span> ' + data.region_name + '</span><br>'
                '</div>';
            } else {
                bermudaTriangle.content = '<div class="infoWindowContent">' +
                    '<center><b>Zone iluminadas</b></center>' +
                    '<span> ' + data.region_name + '</span><br>'
                '</div>';
            }


            if (data.edit) {
                bermudaTriangle.setOptions({
                    editable: true
                });
                drawingManager.setOptions({
                    drawingControl: false,
                    drawingMode: null
                });
            } else {
                bermudaTriangle.setOptions({
                    editable: false
                });
            }

            google.maps.event.addListener(bermudaTriangle.getPath(), 'insert_at', function () {
                var length = bermudaTriangle.getPath().getArray().length;
                coordinates_array = [];
                for (var i = 0; i < length; i++) {
                    var latlong = bermudaTriangle.getPath().getAt(i).lat() + " " + bermudaTriangle.getPath().getAt(i).lng();
                    coordinates_array.push(latlong)
                }
                latLongArrayList(coordinates_array, 'insert');
            });
            google.maps.event.addListener(bermudaTriangle.getPath(), 'set_at', function () {
                var length = bermudaTriangle.getPath().getArray().length;
                coordinates_array = [];
                for (var i = 0; i < length; i++) {
                    var latlong = bermudaTriangle.getPath().getAt(i).lat() + " " + bermudaTriangle.getPath().getAt(i).lng();
                    coordinates_array.push(latlong)
                }
                latLongArrayList(coordinates_array, 'insert');
            });

            if (data.view) {
                infoWindow.setContent(bermudaTriangle.content);
                infoWindow.setPosition(new google.maps.LatLng(data.region_data[0].x, data.region_data[0].y));
                infoWindow.open(map, bermudaTriangle);
            }

            if (data.add || data.edit) {
                $log.log('adding');
            } else {
                google.maps.event.addListener(bermudaTriangle, 'click', function (event) {
                    infoWindow.setContent(bermudaTriangle.content);
                    infoWindow.setPosition(event.latLng);
                    infoWindow.open(map, bermudaTriangle);
                });
                //google.maps.event.addListener(bermudaTriangle, 'mouseover', function (event) {
                //    infoWindow.setContent(bermudaTriangle.content);
                //    infoWindow.setPosition(event.latLng);
                //    infoWindow.open(map,bermudaTriangle);
                //});
            }
            bermudaTriangle.setMap(map);
        };

        function mapInitialize(data) {
            mapProp = {
                center: myCenter,
                zoom: Number(zoomLevel),
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                minZoom: 3,
                //maxZoom: 15,
                scrollwheel: false
            };
            document.getElementById("googleMap").style.height = window.innerHeight - 200 + 'px';
            map = new google.maps.Map(document.getElementById("googleMap"), mapProp);
            google.maps.event.addListener(map, 'center_changed', function () {
                checkBounds(map);
            });
            drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: null, //google.maps.drawing.OverlayType.MARKER
                drawingControl: true,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: ['polygon'] //'marker', 'circle', 'polyline', 'rectangle'
                },
                //markerOptions: {icon: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png'},
                polygonOptions: {
                    fillColor: '#f18903',
                    fillOpacity: 0.5,
                    strokeWeight: 1,
                    clickable: false,
                    editable: true,
                    zIndex: 1
                }
            });
            drawingManager.setMap(map);
            google.maps.event.addListener(drawingManager, 'overlaycomplete', function (event) {
                var coordinates_array = [];
                if (event.type == 'polygon') {
                    all_overlays.push(event);
                    drawingManager.setOptions({
                        drawingControl: false,
                        drawingMode: null
                    });
                    //drawingManager.setDrawingMode(null);    //hiidng the drawing tool aftre completion of polygon
                    var length = event.overlay.getPath().getArray().length;
                    for (var i = 0; i < length; i++) {
                        var latlong = event.overlay.getPath().getArray()[i].lat() + " " + event.overlay.getPath().getArray()[i].lng();
                        coordinates_array.push(latlong)
                    }
                    latLongArrayList(coordinates_array);

                }

                google.maps.event.addListener(event.overlay.getPath(), 'insert_at', function () {
                    var length = event.overlay.getPath().i.length;
                    coordinates_array = [];
                    for (var i = 0; i < length; i++) {
                        var latlong = event.overlay.getPath().i[i].lat() + " " + event.overlay.getPath().i[i].lng();
                        coordinates_array.push(latlong)
                    }
                    latLongArrayList(coordinates_array, 'insert');
                });
                google.maps.event.addListener(event.overlay.getPath(), 'set_at', function () {
                    var length = event.overlay.getPath().i.length;
                    coordinates_array = [];
                    for (var i = 0; i < length; i++) {
                        var latlong = event.overlay.getPath().i[i].lat() + " " + event.overlay.getPath().i[i].lng();
                        coordinates_array.push(latlong)
                    }
                    latLongArrayList(coordinates_array, 'insert');
                });
            });
            if (data && data.length) {
                data.forEach(function (makeMap) {
                    if (makeMap.child && makeMap.child.length) {
                        drawingFunctions(map, makeMap, 1);
                        makeMap.child.forEach(function (data) {
                            drawingFunctions(map, data, 0);
                        })
                    } else {
                        drawingFunctions(map, makeMap, 1);
                    }
                });
            } else {
                $log.log('no branch');
            }
        };

        function latLongArrayList(coordinates_array, type) {
            if (type == 'insert') {
                if (coordinates_array[0] === coordinates_array[coordinates_array.length - 1]) {
                    vm.finalArrayCordinates = coordinates_array;
                } else {
                    var newArray = coordinates_array;
                    newArray[newArray.length] = newArray[0];
                    vm.finalArrayCordinates = newArray;
                }
                $scope.$apply();
            } else {
                var str_coordinates = '';
                var arr_len = coordinates_array.length;

                var newArray = coordinates_array;
                newArray[newArray.length] = newArray[0];
                vm.finalArrayCordinates = newArray;
                //var new_arr = [];
                //for (var i = 0; i < arr_len; i++) {
                //    var val = coordinates_array[i].split(' ');
                //    var obj = {
                //        "lat": val[0],
                //        "lng": val[1]
                //    };
                //    str_coordinates += coordinates_array[i].toString() + ",";
                //    new_arr.push(obj);
                //}
                //str_coordinates += coordinates_array[0].toString() + ",";
                //str_coordinates = str_coordinates.slice(0, -1);
                //new_arr[new_arr.length] = {
                //    lat: new_arr[0].lat,
                //    lng: new_arr[0].lng
                //};
                $scope.$apply();
            }
        };

        //====================branches for adding======================
        function branchesForAdding(filter) {
            vm.loading = true;
            var promise = getGeofence.getAllBranchList(filter);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.data.length) {
                        var where = _.where(payload.title.data, {
                            parent_id: 0
                        });
                        var where1 = _.where(where, {
                            is_active: 1
                        });
                        vm.branchList = where1;
                        localStorage.setItem('branchList', JSON.stringify(vm.branchList));
                        for (var i = 0; i < vm.branchList.length; i++) {
                            vm.branchList[i].index = i;
                            vm.branchList[i].add = false;
                            vm.branchList[i].edit = false;
                            vm.branchList[i].strokeColor = '#f18903';
                            vm.branchList[i].fillColor = 'transparent';
                            vm.branchList[i].child = [];
                        }
                        var whereFixed = [];
                        for (var i = 0; i < payload.title.data.length; i++) {
                            if (payload.title.data[i].parent_id != 0) {
                                whereFixed.push(payload.title.data[i]);
                            }
                        }
                        if (whereFixed.length) {
                            var newCombinationArray = vm.branchList;
                            for (var i = 0; i < whereFixed.length; i++) {
                                whereFixed[i].index = i;
                                whereFixed[i].edit = false;
                                whereFixed[i].strokeColor = '#063c4a';
                                whereFixed[i].fillColor = '#063c4a';
                                whereFixed[i].parent = {
                                    region_name: '',
                                    region_id: '',
                                    region_data: [],
                                    strokeColor: '#f18903',
                                    fillColor: 'transparent'
                                };
                                for (var j = 0; j < vm.branchList.length; j++) {
                                    if (whereFixed[i].parent_id == vm.branchList[j].region_id) {
                                        whereFixed[i].parent.region_name = vm.branchList[j].region_name;
                                        whereFixed[i].parent.region_id = vm.branchList[j].region_id;
                                        whereFixed[i].parent.region_data = vm.branchList[j].region_data;
                                    }
                                }
                                for (var j = 0; j < newCombinationArray.length; j++) {
                                    if (whereFixed[i].parent_id == newCombinationArray[j].region_id) {
                                        newCombinationArray[j].child.push(whereFixed[i]);
                                    }
                                }
                            }
                            //vm.tableFixedRouteList = whereFixed;
                            //vm.fixedRouteList = newCombinationArray;
                            $log.log('whereFixed', newCombinationArray);
                            //mapInitialize(vm.fixedRouteList);
                        } else {
                            //vm.fixedRouteList = [];
                            //vm.noDataFlag = true;
                            //mapInitialize(vm.fixedRouteList);
                        }
                    } else {
                        vm.branchList = [];
                        //vm.fixedRouteList = [];
                        //vm.noDataFlag = true;
                        //errorMessageFactory.showErrorMessage('Please add branch first.',0);
                    }
                    getAllBranches(0, vm.itemsPerPageGot);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        branchesForAdding(2);

        //===========================get all branches==========================
        function getAllBranches(skip, limit) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.skip = skip;
            dataSend.limit = limit;
            vm.loading = true;
            var promise = getGeofence.getAllIlluminatedZoneBranchList(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.data.length) {
                        vm.allBranchList = payload.title.data;
                        vm.dataLength = payload.title.count;
                        if (payload.title.count == 0) {
                            vm.sp_pagination = false;
                            vm.tBodyFlag = false;
                            vm.tFootFlag = true;
                            vm.filterOn = true;
                            vm.skipValueFilter = 0;
                        } else {
                            vm.sp_pagination = true;
                            vm.tBodyFlag = true;
                            vm.tFootFlag = false;
                            vm.filterOn = false;
                            vm.skipValueFilter = 0;
                            for (var i = 0; i < vm.branchList.length; i++) {
                                vm.branchList[i].index = i;
                                vm.branchList[i].add = false;
                                vm.branchList[i].edit = false;
                                vm.branchList[i].strokeColor = '#f18903';
                                vm.branchList[i].fillColor = 'transparent';
                                vm.branchList[i].child = [];
                            }
                            if (vm.allBranchList.length) {

                                var newCombinationArray = vm.branchList;

                                for (var i = 0; i < vm.allBranchList.length; i++) {
                                    vm.allBranchList[i].index = i;
                                    vm.allBranchList[i].edit = false;
                                    vm.allBranchList[i].view = false;
                                    vm.allBranchList[i].strokeColor = '#063c4a';
                                    vm.allBranchList[i].fillColor = '#063c4a';
                                    vm.allBranchList[i].parent = {
                                        region_name: '',
                                        region_id: '',
                                        region_data: [],
                                        strokeColor: '#f18903',
                                        fillColor: 'transparent'
                                    };
                                    for (var j = 0; j < vm.branchList.length; j++) {
                                        if (vm.allBranchList[i].parent_id == vm.branchList[j].region_id) {
                                            vm.allBranchList[i].parent.region_name = vm.branchList[j].region_name;
                                            vm.allBranchList[i].parent.region_id = vm.branchList[j].region_id;
                                            vm.allBranchList[i].parent.region_data = vm.branchList[j].region_data;
                                        }
                                    }
                                    for (var j = 0; j < newCombinationArray.length; j++) {
                                        if (vm.allBranchList[i].parent_id == newCombinationArray[j].region_id) {
                                            newCombinationArray[j].child.push(vm.allBranchList[i]);
                                        }
                                    }
                                }
                                vm.tableFixedRouteList = vm.allBranchList;
                                for (var i = 0; i < vm.tableFixedRouteList.length; i++) {
                                    vm.tableFixedRouteList[i].index = (skip + i);
                                }
                                if (vm.dataLength <= vm.itemsPerPageGot) {
                                    vm.sp_pagination = false;
                                } else {
                                    vm.sp_pagination = true;
                                    //vm.pageCount(payload.title.data.totalCount);
                                }
                                vm.skipValue = vm.tableFixedRouteList[0].index;
                                vm.limitValue = vm.tableFixedRouteList[vm.tableFixedRouteList.length - 1].index;
                                vm.fixedRouteList = newCombinationArray;
                                $log.log('whereFixed', newCombinationArray);
                                mapInitialize(vm.fixedRouteList);
                            } else {
                                vm.fixedRouteList = [];
                                vm.tableFixedRouteList = [];
                                vm.noDataFlag = true;
                                mapInitialize(vm.fixedRouteList);
                            }
                        }
                    } else {
                        vm.allBranchList = [];
                        vm.fixedRouteList = [];
                        vm.tableFixedRouteList = [];
                        vm.noDataFlag = true;
                        languageBasedErrorFactory.getProperErrorMessage('branchReq', 0, 0);
                        //errorMessageFactory.showErrorMessage('Please add branch first.',0);
                    }

                    $scope.$watch('vm.search', function (newVal, oldVal) {
                        vm.filtered = filterFilter(vm.tableFixedRouteList, newVal);
                        vm.totalItems = vm.filtered.length;
                        if (vm.filtered.length == 0) {
                            vm.watchPagination = false;
                        } else {
                            vm.watchPagination = true;
                        }
                        if (vm.filterOn == true) {
                            vm.skipValueFilter = vm.filtered.length;
                            vm.sp_pagination = false;
                        }
                    }, true);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //getAllBranches(vm.filterData.geofenceStatus);
        //=================================branch changed============================
        function branchChanged() {
            $log.log(vm.branchName);
            var where = _.where(vm.branchList, {
                region_id: vm.branchName
            });
            $log.log(where);
            where[0].add = true;
            myCenter = new google.maps.LatLng(where[0].region_data[0].x, where[0].region_data[0].y);
            zoomLevel = 12;
            mapInitialize(vm.fixedRouteList);
        };

        //=============================add branch geofence function hit=================================
        function addIlluminatedZoneHit() {
            if (vm.maximum_quantity_show_driverapp > 999) {
                return;
            }
            $log.log(vm.finalArrayCordinates);
            $log.log(vm.name);
            $log.log(vm.description);
            $log.log(vm.branchName);
            $log.log(vm.isAirportService);
            if (!vm.finalArrayCordinates || !vm.finalArrayCordinates.length) {
                //errorMessageFactory.showErrorMessage('Please select some region from map.');
                languageBasedErrorFactory.getProperErrorMessage('branchEditPop', 0, 0);
                return;
            }

            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.region_name = vm.name.toUpperCase();
            dataSend.region_description = vm.description;
            dataSend.region_data = vm.finalArrayCordinates;
            dataSend.isAirportService = vm.isAirportService;
            dataSend.control_cantity_driver_app = Number(vm.control_cantity_driver_app);
            dataSend.maximum_quantity_show_driverapp = vm.maximum_quantity_show_driverapp;
            dataSend.parent_id = vm.branchName;
            $log.log(dataSend);
            vm.loading = true;
            var promise = getGeofence.illuminatedZoneBranchAdd(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        errorMessageFactory.showErrorMessage('Zona agregada con éxito.', 1, 'layout.illuminatedZoneMain.illuminatedZone');
                        //$state.reload('layout.illuminatedZoneMain.illuminatedZone');
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //==========================cancel========================
        function cancelEdit() {
            $state.reload('layout.illuminatedZoneMain.illuminatedZone');
        };

        function cancelIlluminatedZoneEdit() {
            $state.reload('layout.illuminatedZoneMain.illuminatedZone');
        };


        //====================edit fixed route====================
        function editIlluminatedZoneGeofence(data) {
            $log.log(data);
            vm.addIlluminatedZoneFlag = false;
            vm.editIlluminatedZoneFlag = true;
            vm.viewIlluminatedZoneFlag = false;
            vm.editName = data.region_name;
            vm.editDescription = data.region_description;
            vm.editID = data.region_id;
            vm.editRegionData = data.region_data;
            vm.isAirportService = data.isAirportService;
            vm.maximum_quantity_show_driverapp = data.maximum_quantity_show_driverapp;
            vm.control_cantity_driver_app = JSON.stringify(data.control_cantity_driver_app);
            for (var i = 0; i < vm.fixedRouteList.length; i++) {
                for (var j = 0; j < vm.fixedRouteList[i].child.length; j++) {
                    if (vm.fixedRouteList[i].child[j].region_id == data.region_id) {
                        vm.fixedRouteList[i].child[j].edit = true;
                    } else {
                        vm.fixedRouteList[i].child[j].edit = false;
                    }
                }
            }

            myCenter = new google.maps.LatLng(data.region_data[0].x, data.region_data[0].y);
            zoomLevel = 12;
            mapInitialize(vm.fixedRouteList);
        };

        function editIlluminatedZoneHit() {
            if (vm.maximum_quantity_show_driverapp > 999) {
                return;
            }
            $log.log(vm.finalArrayCordinates);
            $log.log(vm.editName);
            $log.log(vm.editDescription);
            $log.log(vm.editID);
            $log.log(vm.editRegionData);
            $log.log(vm.isAirportService);

            if (!vm.finalArrayCordinates || !vm.finalArrayCordinates.length) {
                vm.finalArrayCordinates = [];
                for (var i = 0; i < vm.editRegionData.length; i++) {
                    vm.finalArrayCordinates.push(vm.editRegionData[i].x + ' ' + vm.editRegionData[i].y);
                }
            }
            $log.log(vm.finalArrayCordinates);
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.region_name = vm.editName.toUpperCase();
            dataSend.region_description = vm.editDescription;
            dataSend.region_data = vm.finalArrayCordinates;
            dataSend.region_id = vm.editID;
            dataSend.isAirportService = vm.isAirportService;
            dataSend.control_cantity_driver_app = Number(vm.control_cantity_driver_app);
            dataSend.maximum_quantity_show_driverapp = vm.maximum_quantity_show_driverapp;
            dataSend.child = true;
            $log.log(dataSend);
            vm.loading = true;
            var promise = getGeofence.editIlluminatedZoneList(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        //var dataForSysLogs = {
                        //    access_token: $cookies.get('obj'),
                        //    id: vm.editID,
                        //    identity : 20,  // 0- driver, 1- customer , 2 -car
                        //    message : 'Fixed route geofence details updated.'
                        //};
                        //$rootScope.systemLogsAdmin(dataForSysLogs);
                        errorMessageFactory.showErrorMessage('Detalles de la zona actualizados con éxito.', 1, 'layout.illuminatedZoneMain.illuminatedZone');
                        //errorMessageFactory.showErrorMessage('Fixed route geofence details updated successfully.',1);
                        //$timeout(function() {
                        //    $mdDialog.hide();
                        //    $state.reload();
                        //}, 2000);
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //=====================to delete fixed route====================
        function deleteIlluminatedZone(id, $event) {
            var confirm = $mdDialog.confirm()
                .title("¿Desea eliminar esta zona iluminada?")
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed', id);
                //errorMessageFactory.showErrorMessage('Functionality is pending',0);
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.region_id = id.region_id;
                dataSend.is_deleted = 1;
                dataSend.parent = id.parent_id == 0 ? 0 : 1;
                vm.loading = true;
                var promise = getGeofence.removeIlluminationZone(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        //var dataForSysLogs = {
                        //    access_token: $cookies.get('obj'),
                        //    id: id.region_id,
                        //    identity : 20,  // 0- driver, 1- customer , 2 -car
                        //    message : 'Fixed route geofence deleted.'
                        //};
                        //$rootScope.systemLogsAdmin(dataForSysLogs);
                        errorMessageFactory.showErrorMessage('Zona eliminada con éxito.', 1, 'layout.illuminatedZoneMain.illuminatedZone');
                        //errorMessageFactory.showErrorMessage('Fixed route geofence deleted successfully.',1);
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        };
        //=====================to change status small geofence====================
        function changeFixedRegionStatus(id, $event) {
            var confirm = $mdDialog.confirm()
                .title('¿Quieres cambiar el estado de esta zona?')
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok('Confirmar')
                .cancel('Cerrar');

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed', id);
                //errorMessageFactory.showErrorMessage('Functionality is pending',0);
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.region_id = id.region_id;
                dataSend.parent = id.parent_id == 0 ? 0 : 1;
                dataSend.is_active = id.is_active == 0 ? 1 : 0;
                vm.loading = true;
                var promise = getGeofence.blockUnblockIlluminationZone(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        //var dataForSysLogs = {
                        //    access_token: $cookies.get('obj'),
                        //    id: id.region_id,
                        //    identity : 20,  // 0- driver, 1- customer , 2 -car
                        //    message : 'Geofence status updated.'
                        //};
                        //$rootScope.systemLogsAdmin(dataForSysLogs);
                        errorMessageFactory.showErrorMessage('El estado de la zona cambió con éxito.', 1, 'layout.illuminatedZoneMain.illuminatedZone');
                        //errorMessageFactory.showErrorMessage('Geofence status updated successfully.',1);
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        };

        //=====================view fixed route geofence=====================
        function viewIlluminatedRegion(data) {
            vm.addIlluminatedZoneFlag = false;
            vm.editIlluminatedZoneFlag = false;
            vm.viewIlluminatedZoneFlag = true;
            vm.viewFixedRouteName = data.region_name;
            vm.viewFixedRouteDescription = data.region_description;
            vm.viewFixedRouteID = data.region_id;
            vm.viewFixedRouteData = data.region_data;
            vm.viewAirportZone = data.isAirportService;
            vm.viewFixedRouteStatus = data.is_active;
            vm.viewFixedRouteParentID = data.parent_id;
            vm.viewFixedRouteParentName = data.parent.region_name;
            vm.controlCantityDriverApp = data.control_cantity_driver_app;
            vm.maximumQuantityShowDriverapp = data.maximum_quantity_show_driverapp;
            for (var i = 0; i < vm.fixedRouteList.length; i++) {
                for (var j = 0; j < vm.fixedRouteList[i].child.length; j++) {
                    if (vm.fixedRouteList[i].child[j].region_id == data.region_id) {
                        vm.fixedRouteList[i].child[j].view = true;
                    } else {
                        vm.fixedRouteList[i].child[j].view = false;
                    }
                }
            }

            myCenter = new google.maps.LatLng(data.region_data[0].x, data.region_data[0].y);
            zoomLevel = 10;
            mapInitialize(vm.fixedRouteList);
        };
        //=======================go back========================
        function goBack() {
            vm.addIlluminatedZoneFlag = true;
            vm.editIlluminatedZoneFlag = false;
            vm.viewIlluminatedZoneFlag = false;
            for (var i = 0; i < vm.fixedRouteList.length; i++) {
                for (var j = 0; j < vm.fixedRouteList[i].child.length; j++) {
                    vm.fixedRouteList[i].child[j].view = false;
                }
            }
            myCenter = new google.maps.LatLng(-33.447487, -70.673676);
            zoomLevel = 8;
            mapInitialize(vm.fixedRouteList);
        };

        function onAddClick() {
            vm.showAddBranchForm = true;
            vm.showMap = true;
            vm.addIlluminatedZoneFlag = true;
            vm.editIlluminatedZoneFlag = false;
            vm.viewIlluminatedZoneFlag = false;
        }
    }
})();

/**
 * Created by cl-macmini-51 on 5/24/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('HeatMapController', HeatMapController);

    /** @ngInject */
    function HeatMapController($cookies, $state, $log, $rootScope, checkDomain, $timeout, getCars, $scope, filterFilter, $mdDialog, $document, getGeofence, languageBasedErrorFactory, errorMessageFactory, Initializer) {
        var vm = this;
        $log.log('driver');
        var myCenter;
        var zoomLevel = 8;
        vm.clearmap = false;
        var all_overlays = [];
        var coordinates_array = [];
        vm.addressChange = addressChange;
        vm.pickAddressFlag = false;
        var markers = [];
        var mapProp = {};
        var drawingManager = '';
        var mc = null;
        var map = null;
        var icon = {};
        var bounds;
        var geocoder;
        var infoWindow;
        var location = "";
        var currentId = 0;
        var laArray = [];
        var poly = '';
        var uniqueId = function () {
            return ++currentId;
        };

        vm.addressHave = '';
        vm.noDataFlag = false;
        vm.addFixedRouteGeofenceFlag = true;
        vm.editFixedRouteGeofenceFlag = false;
        vm.viewFixedRouteGeofenceFlag = false;
        vm.isAirportService = false;
        document.getElementById("googleMap").style.height = window.innerHeight - 200 + 'px';
        vm.filterData = {
            geofenceStatus: '1'
        };
        // Service To Get Map Instance
        Initializer.mapsInitialized
            .then(function () {
                console.log('>>>> GOOGLE INIT', google);
                if (google) {
                    myCenter = new google.maps.LatLng(-33.447487, -70.673676);
                    bounds = new google.maps.LatLngBounds();
                    geocoder = new google.maps.Geocoder();
                    infoWindow = new google.maps.InfoWindow();
                } else {
                    alert(languageBasedErrorFactory.getProperErrorMessage('onRoadMessage', 0, '3'));
                }

            });
        vm.setMapOnAll = setMapOnAll;
        vm.drawingFunctions = drawingFunctions;
        vm.mapInitialize = mapInitialize;
        vm.latLongArrayList = latLongArrayList;
        vm.addFixedRouteGeofenceHit = addFixedRouteGeofenceHit;
        vm.getAllBranches = getAllBranches;
        vm.branchChanged = branchChanged;
        vm.editFixedRouteGeofenceHit = editFixedRouteGeofenceHit;
        vm.editFixedRouteGeofence = editFixedRouteGeofence;
        vm.cancelEdit = cancelEdit;
        vm.deleteFixedRouteGeofence = deleteFixedRouteGeofence;
        vm.viewFixedRouteGeofence = viewFixedRouteGeofence;
        vm.goBack = goBack;
        vm.setBooleans = setBooleans;
        vm.changeFixedRegionStatus = changeFixedRegionStatus;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();

        vm.addNewGeoFence = addNewGeoFence;
        vm.addNewGeoFenceToggle = false;
        vm.openMultipleGeofencePopup = openMultipleGeofencePopup;
        vm.checkboxToShowAllGeoFenceFunction = checkboxToShowAllGeoFenceFunction;
        vm.removeGeoFenceFromMap = removeGeoFenceFromMap;
        vm.mainPaginationChangedForMultipleGeofence = mainPaginationChangedForMultipleGeofence;
        vm.mainSearch = mainSearch;
        vm.checkboxToShowAllGeoFence = false;
        vm.openMultipleGeofencePopupButtonDisable = true;
        vm.removeGeoFenceFromMapDisableButtonStatus = false;
        vm.hideFilters = true;
        //==========================set boolean=======================
        function setBooleans(type) {
            switch (type) {
                case 'AIRPORT_ZONE':
                    if (vm.isAirportService) {
                        vm.isAirportService = false;
                    } else {
                        vm.isAirportService = true;
                    }
                    break;
            }
        };

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.heatMapMain.heatMap');
            }
        });
        //================set map nulll======================
        function setMapOnAll(map, id) {
            for (var i = 0; i < markers.length; i++) {
                var marker = markers[i];
                marker.setMap(map);
            }
        };
        // If the map position is out of range, move it back
        function checkBounds(map) {
            if (typeof (map.getBounds()) == 'undefined')
                return;

            var latNorth = map.getBounds().getNorthEast().lat();
            var latSouth = map.getBounds().getSouthWest().lat();
            var newLat;

            if (latNorth < 85 && latSouth > -85) /* in both side -> it's ok */
                return;
            else {
                if (latNorth > 85 && latSouth < -85) /* out both side -> it's ok */
                    return;
                else {
                    if (latNorth > 85)
                        newLat = map.getCenter().lat() - (latNorth - 85);
                    /* too north, centering */
                    if (latSouth < -85)
                        newLat = map.getCenter().lat() - (latSouth + 85);
                    /* too south, centering */
                }
            }
            if (newLat) {
                var newCenter = new google.maps.LatLng(newLat, map.getCenter().lng());
                map.setCenter(newCenter);
            }
        }

        //===========================auto complete===============================
        function addressChange(data) {
            initAutocomplete(data);

        }
        var autocomplete;
        var domain = checkDomain.getDomainName();

        function initAutocomplete(data) {
            if ((!vm.pickAddressFlag) && data && data.length >= 3) {
                vm.pickAddressFlag = true;
                autocomplete = new google.maps.places.Autocomplete(
                    (document.getElementById('addressGot')), {
                        placeIdOnly: true
                    });
                if (domain != 'dev' && domain != 'test')
                    autocomplete.setComponentRestrictions({
                        'country': ['CL']
                    });

                autocomplete.addListener('place_changed', fillInAddress);
            } else if (data && data.length < 3) {
                vm.pickAddressFlag = false;
                google.maps.event.clearInstanceListeners(addressGot);
                $(".pac-container").hide();
            }
        };

        function placeMarker(map, location) {
            if (markers.length > 1) {
                setMapOnAll(null);
            }
            var id = uniqueId();
            var marker = new google.maps.Marker({
                id: id,
                position: location,
                draggable: false,
                map: map
            });
            bounds = new google.maps.LatLngBounds();
            bounds.extend(location);
            map.fitBounds(bounds);
            markers.push(marker);
        };

        function fillInAddress() {
            // Get the place details from the autocomplete object.
            var place = autocomplete.getPlace();
            if (!place.place_id) {
                return;
            }
            geocoder.geocode({
                'placeId': place.place_id
            }, function (results, status) {
                if (status !== 'OK') {
                    window.alert('Geocoder failed due to: ' + status);
                    return;
                }
                var formattedAddress = results[0].formatted_address;
                vm.addressHave = formattedAddress;
                myCenter = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
                zoomLevel = 12;
                mapInitialize();
                placeMarker(map, myCenter);
            });
        };
        // initAutocomplete();
        //================map initialize===========================
        vm.bermudaTriangleArray = [];

        function drawingFunctions(map, data, type) {
            var triangleCoords = [];
            for (var i = 0; i < data.region_data[0].length; i++) {
                triangleCoords.push({
                    lat: data.region_data[0][i].x,
                    lng: data.region_data[0][i].y
                })
            }

            // bounds = new google.maps.LatLngBounds();

            // for (var i = 0; i < data.region_data.length; i++) {
            // bounds.extend(new google.maps.LatLng(data.region_data[0].x, data.region_data[0].y));
            // }

            // map.fitBounds(bounds);
            // map.setCenter(myCenter = new google.maps.LatLng(data.region_data[0].x, data.region_data[0].y));



            // Construct the polygon.
            var bermudaTriangle = new google.maps.Polygon({
                paths: triangleCoords,
                strokeColor: data.strokeColor,
                strokeOpacity: 1,
                strokeWeight: 2,
                fillColor: data.fillColor,
                fillOpacity: 0.5
            });
            if (type) {
                bermudaTriangle.content = '<div class="infoWindowContent">' +
                    '<center><b>' + data.parent_region_name + '</b></center>' +
                    '<span> ' + data.region_name + '</span><br>'
                '</div>';
            } else {
                bermudaTriangle.content = '<div class="infoWindowContent">' +
                    '<center><b>Geofence</b></center>' +
                    '<span> ' + data.region_name + '</span><br>'
                '</div>';
            }


            if (data.edit) {
                bermudaTriangle.setOptions({
                    editable: true
                });
                drawingManager.setOptions({
                    drawingControl: false,
                    drawingMode: null
                });
            } else {
                bermudaTriangle.setOptions({
                    editable: false
                });
            }

            google.maps.event.addListener(bermudaTriangle.getPath(), 'insert_at', function () {
                var length = bermudaTriangle.getPath().getArray().length;
                coordinates_array = [];
                for (var i = 0; i < length; i++) {
                    var latlong = bermudaTriangle.getPath().getAt(i).lat() + " " + bermudaTriangle.getPath().getAt(i).lng();
                    coordinates_array.push(latlong)
                }
                latLongArrayList(coordinates_array, 'insert');
            });
            google.maps.event.addListener(bermudaTriangle.getPath(), 'set_at', function () {
                var length = bermudaTriangle.getPath().getArray().length;
                coordinates_array = [];
                for (var i = 0; i < length; i++) {
                    var latlong = bermudaTriangle.getPath().getAt(i).lat() + " " + bermudaTriangle.getPath().getAt(i).lng();
                    coordinates_array.push(latlong)
                }
                latLongArrayList(coordinates_array, 'insert');
            });

            if (!vm.hideFilters) {
                if (data.view) {
                    infoWindow.setContent(bermudaTriangle.content);
                    infoWindow.setPosition(new google.maps.LatLng(data.region_data[0][0].x, data.region_data[0][0].y));
                    infoWindow.open(map, bermudaTriangle);
                }
            }
            if (vm.hideFilters) {
                if (data.view) {
                    if (vm.viewFixedRouteGeofenceFlag)
                        bermudaTriangle.setOptions({
                            visible: true
                        });
                    infoWindow.setContent(bermudaTriangle.content);
                    infoWindow.setPosition(new google.maps.LatLng(data.region_data[0][0].x, data.region_data[0][0].y));
                    infoWindow.open(map, bermudaTriangle);
                } else {
                    if (vm.viewFixedRouteGeofenceFlag)
                        bermudaTriangle.setOptions({
                            visible: false
                        });
                }
            }

            if (data.add || data.edit) {
                $log.log('adding');
            } else {
                google.maps.event.addListener(bermudaTriangle, 'click', function (event) {
                    infoWindow.setContent(bermudaTriangle.content);
                    infoWindow.setPosition(event.latLng);
                    infoWindow.open(map, bermudaTriangle);
                });
                //google.maps.event.addListener(bermudaTriangle, 'mouseover', function (event) {
                //    infoWindow.setContent(bermudaTriangle.content);
                //    infoWindow.setPosition(event.latLng);
                //    infoWindow.open(map,bermudaTriangle);
                //});
            }
            bermudaTriangle.setMap(map);
            vm.bermudaTriangleArray.push(bermudaTriangle);
        };

        function mapInitialize(data) {
            mapProp = {
                center: myCenter,
                zoom: Number(zoomLevel),
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                minZoom: 3,
                //maxZoom: 15,
                scrollwheel: false
            };
            map = new google.maps.Map(document.getElementById("googleMap"), mapProp);
            google.maps.event.addListener(map, 'center_changed', function () {
                checkBounds(map);
            });
            drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: null, //google.maps.drawing.OverlayType.MARKER
                drawingControl: true,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: ['polygon'] //'marker', 'circle', 'polyline', 'rectangle'
                },
                //markerOptions: {icon: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png'},
                polygonOptions: {
                    fillColor: '#f18903',
                    fillOpacity: 0.5,
                    strokeWeight: 1,
                    clickable: false,
                    editable: true,
                    zIndex: 1
                }
            });
            drawingManager.setMap(map);
            google.maps.event.addListener(drawingManager, 'overlaycomplete', function (event) {
                var coordinates_array = [];
                if (event.type == 'polygon') {
                    all_overlays.push(event);
                    drawingManager.setOptions({
                        drawingControl: false,
                        drawingMode: null
                    });
                    //drawingManager.setDrawingMode(null);    //hiidng the drawing tool aftre completion of polygon
                    var length = event.overlay.getPath().getArray().length;
                    for (var i = 0; i < length; i++) {
                        var latlong = event.overlay.latLngs.getPath().getArray()[i].lat() + " " + event.overlay.latLngs.getPath().getArray()[i].lng();
                        coordinates_array.push(latlong)
                    }
                    latLongArrayList(coordinates_array);

                }

                google.maps.event.addListener(event.overlay.getPath(), 'insert_at', function () {
                    var length = event.overlay.getPath().i.length;
                    coordinates_array = [];
                    for (var i = 0; i < length; i++) {
                        var latlong = event.overlay.getPath().i[i].lat() + " " + event.overlay.getPath().i[i].lng();
                        coordinates_array.push(latlong)
                    }
                    latLongArrayList(coordinates_array, 'insert');
                });
                google.maps.event.addListener(event.overlay.getPath(), 'set_at', function () {
                    var length = event.overlay.getPath().i.length;
                    coordinates_array = [];
                    for (var i = 0; i < length; i++) {
                        var latlong = event.overlay.getPath().i[i].lat() + " " + event.overlay.getPath().i[i].lng();
                        coordinates_array.push(latlong)
                    }
                    latLongArrayList(coordinates_array, 'insert');
                });
            });
            if (data && data.length) {
                data.forEach(function (makeMap) {
                    if (makeMap.child && makeMap.child.length) {
                        drawingFunctions(map, makeMap, 1);
                        makeMap.child.forEach(function (data) {
                            drawingFunctions(map, data, 0);
                        })
                    } else {
                        drawingFunctions(map, makeMap, 1);
                    }
                });
            } else {
                $log.log('no branch');
            }
        };

        function latLongArrayList(coordinates_array, type) {
            vm.removeGeoFenceFromMapDisableButtonStatus = false;
            if (type == 'insert') {
                if (coordinates_array[0] === coordinates_array[coordinates_array.length - 1]) {
                    vm.finalArrayCordinates = coordinates_array;
                } else {
                    var newArray = coordinates_array;
                    newArray[newArray.length] = newArray[0];
                    vm.finalArrayCordinates = newArray;
                }
                $scope.$apply();
            } else {
                var str_coordinates = '';
                var arr_len = coordinates_array.length;

                var newArray = coordinates_array;
                newArray[newArray.length] = newArray[0];
                vm.finalArrayCordinates = newArray;
                //var new_arr = [];
                //for (var i = 0; i < arr_len; i++) {
                //    var val = coordinates_array[i].split(' ');
                //    var obj = {
                //        "lat": val[0],
                //        "lng": val[1]
                //    };
                //    str_coordinates += coordinates_array[i].toString() + ",";
                //    new_arr.push(obj);
                //}
                //str_coordinates += coordinates_array[0].toString() + ",";
                //str_coordinates = str_coordinates.slice(0, -1);
                //new_arr[new_arr.length] = {
                //    lat: new_arr[0].lat,
                //    lng: new_arr[0].lng
                //};
                $scope.$apply();
            }
        };

        //====================branches for adding======================
        function branchesForAdding(filter) {
            vm.loading = true;
            var promise = getGeofence.getAllBranchList(filter);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.data.length) {
                        var where = _.where(payload.title.data, {
                            parent_id: 0
                        });
                        var where1 = _.where(where, {
                            is_active: 1
                        });
                        vm.branchList = where1;
                        for (var i = 0; i < vm.branchList.length; i++) {
                            vm.branchList[i].index = i;
                            vm.branchList[i].add = false;
                            vm.branchList[i].edit = false;
                            vm.branchList[i].strokeColor = '#f18903';
                            vm.branchList[i].fillColor = 'transparent';
                            vm.branchList[i].child = [];
                        }
                        var whereFixed = [];
                        for (var i = 0; i < payload.title.data.length; i++) {
                            if (payload.title.data[i].parent_id != 0) {
                                whereFixed.push(payload.title.data[i]);
                            }
                        }
                        if (whereFixed.length) {
                            var newCombinationArray = vm.branchList;
                            for (var i = 0; i < whereFixed.length; i++) {
                                whereFixed[i].index = i;
                                whereFixed[i].edit = false;
                                whereFixed[i].strokeColor = '#063c4a';
                                whereFixed[i].fillColor = '#063c4a';
                                whereFixed[i].parent = {
                                    region_name: '',
                                    region_id: '',
                                    region_data: [],
                                    strokeColor: '#f18903',
                                    fillColor: 'transparent'
                                };
                                for (var j = 0; j < vm.branchList.length; j++) {
                                    if (whereFixed[i].parent_id == vm.branchList[j].region_id) {
                                        whereFixed[i].parent.region_name = vm.branchList[j].region_name;
                                        whereFixed[i].parent.region_id = vm.branchList[j].region_id;
                                        whereFixed[i].parent.region_data = vm.branchList[j].region_data;
                                    }
                                }
                                for (var j = 0; j < newCombinationArray.length; j++) {
                                    if (whereFixed[i].parent_id == newCombinationArray[j].region_id) {
                                        newCombinationArray[j].child.push(whereFixed[i]);
                                    }
                                }
                            }
                            //vm.tableFixedRouteList = whereFixed;
                            //vm.fixedRouteList = newCombinationArray;
                            $log.log('whereFixed', newCombinationArray);
                            //mapInitialize(vm.fixedRouteList);
                        } else {
                            //vm.fixedRouteList = [];
                            //vm.noDataFlag = true;
                            //mapInitialize(vm.fixedRouteList);
                        }
                    } else {
                        vm.branchList = [];
                        //vm.fixedRouteList = [];
                        //vm.noDataFlag = true;
                        //errorMessageFactory.showErrorMessage('Please add branch first.',0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        branchesForAdding(2);


        function mainPaginationChangedForMultipleGeofence() {
            vm.mainBranchesForAddingForPopupoffset += 25;
            if (vm.mainBranchesForAddingForPopupoffset < vm.mainBranchListForPopupCount) {
                vm.getAllBranches(vm.mainShowActiveOrInactiveGeofenceStatus, vm.mainBranchesForAddingForPopupoffset, vm.mainSearchStringVariable);
            }
        }

        function mainSearch(searchString) {
            if (searchString.length >= 3) {
                vm.allBranchList = [];
                vm.tableFixedRouteList = [];
                vm.fixedRouteList = [];
                vm.mainSearchStringVariable = searchString;
                vm.mainBranchesForAddingForPopupoffset = 0;
                vm.getAllBranches(vm.mainShowActiveOrInactiveGeofenceStatus, vm.mainBranchesForAddingForPopupoffset, vm.mainSearchStringVariable.trim());
            }
            if (searchString.length == 0) {
                vm.allBranchList = [];
                vm.tableFixedRouteList = [];
                vm.fixedRouteList = [];
                vm.mainSearchStringVariable = searchString;
                vm.mainBranchesForAddingForPopupoffset = 0;
                vm.getAllBranches(vm.mainShowActiveOrInactiveGeofenceStatus, vm.mainBranchesForAddingForPopupoffset, vm.mainSearchStringVariable);
            }
        }

        //===========================get all branches==========================
        vm.allBranchList = [];
        vm.tableFixedRouteList = [];
        vm.fixedRouteList = [];
        vm.getaMainBranchesForAddingForPopupLimit = 25;
        vm.mainBranchesForAddingForPopupoffset = 0;
        vm.mainSearchStringVariable = '';
        vm.mainShowActiveOrInactiveGeofenceStatus = 1;
        vm.filterData.geofenceStatus = "1";

        function getAllBranches(filter, mainOffset, mainSearchString, changeState) {

            vm.mainShowActiveOrInactiveGeofenceStatus = filter;
            vm.loading = true;
            var promise = getGeofence.getAllBranchListForPopupHeatMap(filter, vm.getaMainBranchesForAddingForPopupLimit, mainOffset, mainSearchString);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (changeState) {
                        vm.allBranchList = [];
                        vm.tableFixedRouteList = [];
                        vm.fixedRouteList = [];
                        vm.mainBranchesForAddingForPopupoffset = 0;
                    }
                    vm.mainBranchListForPopupCount = payload.title.data.total_count;
                    if (payload.title.data.data.length) {
                        if (mainSearchString) {
                            vm.allBranchList = [];
                            vm.tableFixedRouteList = [];
                            vm.fixedRouteList = [];
                        }
                        vm.noDataFlag = false;
                        //if(filter == '0') {
                        //    var where1 = _.where(payload.title.data, {parent_id: 0});
                        //    var where = _.where(where1,{is_active: 0});
                        //}
                        //else if(filter == '1') {
                        //    var where1 = _.where(payload.title.data, {parent_id: 0});
                        //    var where = _.where(where1,{is_active: 1});
                        //}
                        //else{
                        var where = _.where(payload.title.data.data, {
                            parent_id: 0
                        });
                        //var where = _.where(where1,{is_active: 0});
                        //}
                        // where.forEach(function (geoFence) {
                        //     vm.allBranchList.push(geoFence);
                        // });
                        vm.allBranchList = where;
                        for (var i = 0; i < vm.allBranchList.length; i++) {
                            vm.allBranchList[i].index = i;
                            vm.allBranchList[i].add = false;
                            vm.allBranchList[i].edit = false;
                            vm.allBranchList[i].strokeColor = '#f18903';
                            vm.allBranchList[i].fillColor = 'transparent';
                            vm.allBranchList[i].child = [];
                        }
                        var whereFixed = [];
                        for (var i = 0; i < payload.title.data.data.length; i++) {
                            if (filter == '0') {
                                if (payload.title.data.data[i].parent_id != 0 && payload.title.data.data[i].is_active == 0) {
                                    whereFixed.push(payload.title.data.data[i]);
                                }
                            } else if (filter == '1') {
                                if (payload.title.data.data[i].parent_id != 0 && payload.title.data.data[i].is_active == 1) {
                                    whereFixed.push(payload.title.data.data[i]);
                                }
                            } else {
                                if (payload.title.data.data[i].parent_id != 0) {
                                    whereFixed.push(payload.title.data.data[i]);
                                }
                            }
                        }
                        if (whereFixed.length) {
                            var newCombinationArray = vm.allBranchList;

                            for (var i = 0; i < whereFixed.length; i++) {
                                whereFixed[i].index = i;
                                whereFixed[i].edit = false;
                                whereFixed[i].view = false;
                                // CHANGE COLOR #063c4a to transparent for child geofence on initialization
                                whereFixed[i].strokeColor = '#063c4a';
                                whereFixed[i].fillColor = '#063c4a';
                                whereFixed[i].parent = {
                                    region_name: '',
                                    region_id: '',
                                    region_data: [],
                                    strokeColor: '#f18903',
                                    fillColor: 'transparent'
                                };
                                // for (var j = 0; j < vm.allBranchList.length; j++) {
                                //     if (whereFixed[i].parent_id == vm.allBranchList[j].region_id) {
                                // whereFixed[i].parent = {};
                                whereFixed[i].parent.region_name = whereFixed[i].region_name;
                                whereFixed[i].parent.region_id = whereFixed[i].region_id;
                                whereFixed[i].parent.region_data = whereFixed[i].region_data;
                                //     }
                                // }
                                // for (var j = 0; j < newCombinationArray.length; j++) {
                                //     if (whereFixed[i].parent_id == newCombinationArray[j].region_id) {
                                //         newCombinationArray[j].child.push(whereFixed[i]);
                                //     }
                                // }
                            }
                            whereFixed.forEach(function (geoFence) {
                                vm.tableFixedRouteList.push(geoFence);
                                vm.fixedRouteList.push(geoFence);
                            });
                            // newCombinationArray.forEach(function (geoFence) {
                            //     vm.fixedRouteList.push(geoFence);
                            // });
                            $log.log('whereFixed', newCombinationArray);

                            mapInitialize();
                        } else {
                            // vm.fixedRouteList = [];
                            // vm.noDataFlag = true;
                            // mapInitialize(vm.fixedRouteList);
                        }
                    } else {
                        vm.allBranchList = [];
                        vm.fixedRouteList = [];
                        vm.noDataFlag = true;
                        // languageBasedErrorFactory.getProperErrorMessage('branchReq', 0, 0);
                        //errorMessageFactory.showErrorMessage('Please add branch first.',0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllBranches(vm.mainShowActiveOrInactiveGeofenceStatus, vm.mainBranchesForAddingForPopupoffset);
        //=================================branch changed============================
        function branchChanged() {
            $log.log(vm.branchName);
            var where = _.where(vm.branchList, {
                region_id: vm.branchName
            });
            $log.log(where);
            where[0].add = true;
            myCenter = new google.maps.LatLng(where[0].region_data[0].x, where[0].region_data[0].y);
            zoomLevel = 12;
            //obtener detalles de la zona
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.parent_id = vm.branchName;
            vm.loading = true;

            var promise = getGeofence.getParentHeatMap(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.data.length) {
                        var whereFixed = payload.title.data;
                        if (whereFixed.length) {
                            //myCenter = new google.maps.LatLng(where[0].region_data[0].x, where[0].region_data[0].y);
                            mapInitialize(whereFixed);
                        }

                    } else {

                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
            //mapInitialize(vm.fixedRouteList);
        };

        //=============================add branch geofence function hit=================================
        function addFixedRouteGeofenceHit() {
            $log.log(vm.finalArrayCordinates);
            $log.log(vm.name);
            $log.log(vm.description);
            $log.log(vm.branchName);
            $log.log(vm.isAirportService);

            if (!vm.finalArrayCordinates || !vm.finalArrayCordinates.length) {
                //errorMessageFactory.showErrorMessage('Please select some region from map.');
                languageBasedErrorFactory.getProperErrorMessage('branchEditPop', 0, 0);
                return;
            }

            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.region_name = vm.name.toUpperCase();
            dataSend.region_description = vm.description;
            dataSend.region_data = vm.finalArrayCordinates;
            // dataSend.isAirportService = vm.isAirportService;
            dataSend.parent_id = vm.branchName;
            $log.log(dataSend);
            vm.loading = true;
            var promise = getGeofence.branchGeofenceAddHeatMap(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        $state.reload('layout.heatMapMain.heatMap');
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //==========================cancel========================
        function cancelEdit() {
            $state.reload('layout.heatMapMain.heatMap');
        };

        //====================edit fixed route====================
        function editFixedRouteGeofence(data) {
            vm.editFixedRouteGeofenceIndex;
            $log.log(data);
            vm.addFixedRouteGeofenceFlag = false;
            vm.editFixedRouteGeofenceFlag = true;
            vm.viewFixedRouteGeofenceFlag = false;
            vm.editName = data.region_name;
            vm.branchNameEdit = data.parent_region_name;
            vm.parent_id_edit = data.parent_id;
            vm.editDescription = data.region_description;
            vm.editID = data.region_id;
            vm.editRegionData = data.region_data;
            vm.isAirportService = data.isAirportService;

            // for (var i = 0; i < vm.fixedRouteList.length; i++) {
            //     for (var j = 0; j < vm.fixedRouteList[i].child.length; j++) {
            //         if (vm.fixedRouteList[i].child[j].region_id == data.region_id) {
            //             vm.fixedRouteList[i].child[j].view = true;
            //             vm.fixedRouteList[i].child[j].edit = true;
            //             vm.editFixedRouteGeofenceIndex = i;
            //         } else {
            //             vm.fixedRouteList[i].child[j].view = false;
            //             vm.fixedRouteList[i].child[j].edit = false;
            //         }
            //     }
            // }

            // WIP
            for (var i = 0; i < vm.fixedRouteList.length; i++) {
                if (vm.fixedRouteList[i].region_id == data.region_id) {
                    vm.fixedRouteList[i].view = true;
                    vm.fixedRouteList[i].edit = true;
                    vm.editFixedRouteGeofenceIndex = i;
                } else {
                    vm.fixedRouteList[i].view = false;
                    vm.fixedRouteList[i].edit = false;
                }
            }

            myCenter = new google.maps.LatLng(data.region_data[0][0].x, data.region_data[0][0].y);
            zoomLevel = 8;
            if (!vm.hideFilters) {
                mapInitialize(vm.fixedRouteList);
            } else {
                mapInitialize([vm.fixedRouteList[vm.editFixedRouteGeofenceIndex]]);
            }
        };

        function editFixedRouteGeofenceHit() {
            $log.log(vm.finalArrayCordinates);
            $log.log(vm.editName);
            $log.log(vm.editDescription);
            $log.log(vm.editID);
            $log.log(vm.editRegionData);
            $log.log(vm.isAirportService);
            console.log(vm.finalArrayCordinates, 'vm.finalArrayCordinates');
            if ((!vm.finalArrayCordinates || !vm.finalArrayCordinates.length) &&   vm.clearmap) {
                //errorMessageFactory.showErrorMessage('Please select some region from map.');
                languageBasedErrorFactory.getProperErrorMessage('DeletePolygon', 0, 0);
                return;
            }

            if (!vm.finalArrayCordinates || !vm.finalArrayCordinates.length) {
                vm.finalArrayCordinates = [];
                for (var i = 0; i < vm.editRegionData[0].length; i++) {
                    vm.finalArrayCordinates.push(vm.editRegionData[0][i].x + ' ' + vm.editRegionData[0][i].y);
                }
            }
            $log.log(vm.finalArrayCordinates);
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.region_name = vm.editName.toUpperCase();
            if (vm.editDescription != '')
                dataSend.region_description = vm.editDescription;
            dataSend.region_data = vm.finalArrayCordinates;
            dataSend.region_id = vm.editID;
            dataSend.parent_id = vm.parent_id_edit;
            // dataSend.isAirportService = vm.isAirportService;
            //dataSend.child = true;
            $log.log(dataSend);
            vm.loading = true;
            var promise = getGeofence.editBranchListHeatMap(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    vm.clearmap  = false;
                    if (payload.title.status == 200) {
                        var dataForSysLogs = {
                            access_token: $cookies.get('obj'),
                            id: vm.editID,
                            identity: 28, // 0- driver, 1- customer , 2 -car
                            message: 'Heat Map Zone details updated.'
                        };
                        $rootScope.systemLogsAdmin(dataForSysLogs);
                        languageBasedErrorFactory.getProperErrorMessage('fixedGeoEditSucc', 0, 1, 'layout.heatMapMain.heatMap');
                        //errorMessageFactory.showErrorMessage('Fixed route geofence details updated successfully.',1);
                        // $timeout(function() {
                        //    $mdDialog.hide();
                        //    $state.reload();
                        // }, 2000);
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //=====================to delete fixed route====================
        function deleteFixedRouteGeofence(id, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('deleteHeatMap', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed', id);
                //errorMessageFactory.showErrorMessage('Functionality is pending',0);
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.region_id = id.region_id;
                dataSend.flag = 1;
                dataSend.parent_id = id.parent_id;
                vm.loading = true;
                var promise = getGeofence.removeRegionHeatMap(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        if (payload.title.status == 200) {
                            var dataForSysLogs = {
                                access_token: $cookies.get('obj'),
                                id: id.region_id,
                                identity: 28, // 0- driver, 1- customer , 2 -car
                                message: 'Heat Map Zone deleted.'
                            };
                            $rootScope.systemLogsAdmin(dataForSysLogs);
                            languageBasedErrorFactory.getProperErrorMessage('fixedGeoDeleteSucc2', 0, 1, 'layout.heatMapMain.heatMap');
                            //errorMessageFactory.showErrorMessage('Fixed route geofence deleted successfully.',1);
                            // $timeout(function() {
                            //     $mdDialog.hide();
                            //     $state.reload();
                            //  }, 2000);
                        } else {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        };
        //=====================to change status small geofence====================
        function changeFixedRegionStatus(id, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('fixedGeoStatusPop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed', id);
                //errorMessageFactory.showErrorMessage('Functionality is pending',0);
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.region_id = id.region_id;
                // dataSend.parent = id.parent_id == 0 ? 0 : 1;
                dataSend.parent_id = id.parent_id;
                dataSend.flag = id.is_active == 0 ? 1 : 0;
                vm.loading = true;
                var promise = getGeofence.activeInactiveRegionHeadMap(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        if (payload.title.status == 200) {
                            var dataForSysLogs = {
                                access_token: $cookies.get('obj'),
                                id: id.region_id,
                                identity: 28, // 0- driver, 1- customer , 2 -car
                                message: 'Heat Map Zone status updated.'
                            };
                            $rootScope.systemLogsAdmin(dataForSysLogs);
                            languageBasedErrorFactory.getProperErrorMessage('fixedGeoStatusSucc', 0, 1, 'layout.heatMapMain.heatMap');
                            // $timeout(function() {
                            //     $mdDialog.hide();
                            //     $state.reload();
                            //  }, 2000);
                        } else {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                        //errorMessageFactory.showErrorMessage('Geofence status updated successfully.',1);
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        };

        //=====================view fixed route geofence=====================
        function viewFixedRouteGeofence(data) {
            vm.viewFixedRouteGeofenceIndex;
            vm.addFixedRouteGeofenceFlag = false;
            vm.editFixedRouteGeofenceFlag = false;
            vm.viewFixedRouteGeofenceFlag = true;
            vm.viewFixedRouteName = data.region_name;
            vm.viewFixedRouteDescription = data.region_description;
            vm.viewFixedRouteID = data.region_id;
            vm.viewFixedRouteData = data.region_data;
            vm.viewAirportZone = data.isAirportService;
            vm.viewFixedRouteStatus = data.is_active;
            vm.viewFixedRouteParentID = data.parent_region_name;
            vm.viewFixedRouteParentName = data.parent.region_name;


            // for (var i = 0; i < vm.fixedRouteList.length; i++) {
            //     for (var j = 0; j < vm.fixedRouteList[i].child.length; j++) {
            //         if (vm.fixedRouteList[i].child[j].region_id == data.region_id) {
            //             vm.fixedRouteList[i].child[j].view = true;
            //             vm.fixedRouteList[i].child[j].edit = false;
            //             vm.viewFixedRouteGeofenceIndex = i;
            //         } else {
            //             vm.fixedRouteList[i].child[j].view = false;
            //             vm.fixedRouteList[i].child[j].edit = false;
            //         }
            //     }
            // }

            for (var i = 0; i < vm.fixedRouteList.length; i++) {
                if (vm.fixedRouteList[i].region_id == data.region_id) {
                    vm.fixedRouteList[i].view = true;
                    vm.fixedRouteList[i].edit = false;
                    vm.viewFixedRouteGeofenceIndex = i;
                } else {
                    vm.fixedRouteList[i].view = false;
                    vm.fixedRouteList[i].edit = false;
                }
            }

            myCenter = new google.maps.LatLng(data.region_data[0][0].x, data.region_data[0][0].y);
            zoomLevel = 8;
            if (!vm.hideFilters) {
                mapInitialize(vm.fixedRouteList);
            } else {
                mapInitialize([vm.fixedRouteList[vm.viewFixedRouteGeofenceIndex]]);
            }
        };
        //=======================go back========================
        function goBack() {
            // vm.addFixedRouteGeofenceFlag = true;
            // vm.editFixedRouteGeofenceFlag = false;
            // vm.viewFixedRouteGeofenceFlag = false;
            // for (var i = 0; i < vm.fixedRouteList.length; i++) {
            //     for (var j = 0; j < vm.fixedRouteList[i].child.length; j++) {
            //         vm.fixedRouteList[i].child[j].view = false;
            //     }
            // }
            // myCenter = new google.maps.LatLng(-33.447487, -70.673676);
            // zoomLevel = 8;
            // mapInitialize(vm.fixedRouteList);
            $state.reload();
        };

        // ============= TOGGLE MAP WHEN CLICK ON ADD NEW GEOFENCE =============
        function addNewGeoFence() {
            $("#showMap").slideDown("slow");
            vm.addNewGeoFenceToggle = true;
        }

        // =========== OPEN MULTIPLE GEOFENCE POPUP ===============
        function openMultipleGeofencePopup($event) {

            vm.items = {};
            $scope.branchListForPopupCount = 0;
            var parentEl = angular.element($document.body);

            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/selectMultipleGeofenceHeatMap.html',
                locals: {
                    items: $scope.branchListForPopup
                },
                bindToController: true,
                controller: DialogController
            });


            function DialogController($scope, $mdDialog, items) {
                $scope.items = $scope.branchListForPopup;
                $scope.regionIdArray = [];
                $scope.loading = false;
                $scope.activeGeoFence = 0;
                $scope.inactiveGeoFence = 0;
                $scope.showActiveOrInactiveGeofenceStatus = 1;
                $scope.searchStringVariable = '';
                vm.addFixedRouteGeofenceFlag = true;
                vm.editFixedRouteGeofenceFlag = false;
                vm.viewFixedRouteGeofenceFlag = false;
                $scope.isDesc = false;

                $scope.paginationChangedForMultipleGeofence = function () {
                    $scope.branchesForAddingForPopupoffset += 25;
                    if ($scope.branchesForAddingForPopupoffset < $scope.branchListForPopupCount) {
                        $scope.branchesForAddingForPopup($scope.showActiveOrInactiveGeofenceStatus, $scope.branchesForAddingForPopupoffset, $scope.searchStringVariable, $scope.sortStringVariable, $scope.isDescStatus);
                    }
                }

                $scope.getGeofenceRegionId = function (region_id) {
                    if ($scope.regionIdArray.indexOf(region_id) == -1) {
                        $scope.regionIdArray.push(region_id);
                    } else {
                        $scope.regionIdArray.splice($scope.regionIdArray.indexOf(region_id), 1);
                    }
                }

                $scope.showActiveOrInactiveGeofenceFunction = function (status) {
                    $scope.branchListForPopup = [];
                    $scope.branchesForAddingForPopupoffset = 0;
                    $scope.showActiveOrInactiveGeofenceStatus = status;
                    $scope.branchesForAddingForPopup($scope.showActiveOrInactiveGeofenceStatus, $scope.branchesForAddingForPopupoffset);
                }

                $scope.searchGeofenceFunction = function (string) {
                    $scope.searchStringVariable = string;
                    $scope.branchesForAddingForPopupoffset = 0;
                    $timeout.cancel($scope.yourTimer);
                    $scope.yourTimer = $timeout(function () {
                        $scope.loading = true;
                        $scope.branchListForPopup = [];
                        $scope.branchesForAddingForPopup($scope.showActiveOrInactiveGeofenceStatus, $scope.branchesForAddingForPopupoffset, string);
                    }, 1000);
                }

                $scope.sortByHead = function (sortString) {
                    $scope.loading = true;
                    $scope.sortStringVariable = sortString;
                    $scope.isDesc = !$scope.isDesc;
                    $scope.isDescStatus = $scope.isDesc == true ? 'DESC' : 'ASC';
                    $scope.branchListForPopup = [];
                    $scope.branchesForAddingForPopupoffset = 0;
                    $scope.branchesForAddingForPopup($scope.showActiveOrInactiveGeofenceStatus, $scope.branchesForAddingForPopupoffset, '', sortString, $scope.isDescStatus);
                }

                // ========== CLICK TO CLOSE DIALOG BOX ========= 
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };

                // ========== CLICK TO CLOSE DIALOG BOX AND CONFIRM RESPONSE ========= 
                $scope.confirmUpload = function (dataSend) {
                    $scope.stingRegionIdArray = "";
                    var regionIdArrayLength = $scope.regionIdArray.length;
                    for (var i = 0; i < regionIdArrayLength; i++) {
                        $scope.stingRegionIdArray += (i == 0) ? ($scope.regionIdArray[i]) : "," + ($scope.regionIdArray[i]);
                    }

                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.region_id = $scope.stingRegionIdArray;
                    $log.log(dataSend);
                    vm.loading = true;

                    var promise = getGeofence.getAllGeoFencesHeatMap(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log(payload);
                            vm.loading = false;
                            if (payload.title.data.length) {

                                var whereFixed = payload.title.data;

                                var where = _.where(payload.title.data, {
                                    parent_id: 0
                                });
                                //var where = _.where(where1,{is_active: 0});
                                //}

                                vm.allBranchList = where; //payload.title.data; //where;
                                for (var i = 0; i < vm.allBranchList.length; i++) {
                                    vm.allBranchList[i].index = i;
                                    vm.allBranchList[i].add = false;
                                    vm.allBranchList[i].edit = false;
                                    vm.allBranchList[i].strokeColor = '#f18903';
                                    vm.allBranchList[i].fillColor = 'transparent';
                                    vm.allBranchList[i].child = [];
                                }
                                if (whereFixed.length) {
                                    var newCombinationArray = vm.allBranchList;

                                    // comment code to hide geofences

                                    for (var i = 0; i < whereFixed.length; i++) {
                                        whereFixed[i].index = i;
                                        whereFixed[i].edit = false;
                                        whereFixed[i].view = false;
                                        whereFixed[i].strokeColor = '#063c4a';
                                        whereFixed[i].fillColor = '#063c4a';
                                        whereFixed[i].parent = {
                                            region_name: '',
                                            region_id: '',
                                            region_data: [],
                                            strokeColor: '#f18903',
                                            fillColor: 'transparent'
                                        };
                                        // whereFixed[i].region_data = whereFixed[i].region_data[0];

                                        // whereFixed[i].parent = {};
                                        whereFixed[i].parent.region_name = whereFixed[i].region_name;
                                        whereFixed[i].parent.region_id = whereFixed[i].region_id;
                                        whereFixed[i].parent.region_data = whereFixed[i].region_data;

                                        // for (var j = 0; j < vm.allBranchList.length; j++) {
                                        //     if (whereFixed[i].parent_id == vm.allBranchList[j].region_id) {
                                        //         whereFixed[i].parent.region_name = vm.allBranchList[j].region_name;
                                        //         whereFixed[i].parent.region_id = vm.allBranchList[j].region_id;
                                        //         whereFixed[i].parent.region_data = vm.allBranchList[j].region_data[0];
                                        //     }
                                        // }
                                        // for (var j = 0; j < newCombinationArray.length; j++) {
                                        //     if (whereFixed[i].parent_id == newCombinationArray[j].region_id) {
                                        //         newCombinationArray[j].child.push(whereFixed[i]);
                                        //     }
                                        // }
                                    }
                                    vm.tableFixedRouteList = whereFixed;
                                    vm.fixedRouteList = whereFixed; //newCombinationArray; //whereFixed
                                    // $log.log('whereFixed', newCombinationArray);
                                    myCenter = new google.maps.LatLng(vm.fixedRouteList[0].region_data[0][0].x, vm.fixedRouteList[0].region_data[0][0].y);
                                    mapInitialize(vm.fixedRouteList);
                                    vm.hideFilters = false;
                                } else {
                                    vm.fixedRouteList = [];
                                    vm.noDataFlag = true;
                                    mapInitialize(vm.fixedRouteList);
                                    vm.hideFilters = false;
                                }

                            } else {

                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );

                    $mdDialog.hide();
                };
                //====================branches for adding For Popup======================
                vm.branchesForAddingForPopupLimit = 25;
                $scope.branchesForAddingForPopupoffset = 0;
                $scope.branchListForPopup = [];
                $scope.branchListForPopupCount = 0;

                $scope.branchesForAddingForPopup = function (filter, offset, searchString, sortByString, sortByASCOrDESC) {
                    $scope.loading = true;
                    var promise = getGeofence.getAllBranchListForPopupHeatMap(filter, vm.branchesForAddingForPopupLimit, offset, searchString, sortByString, sortByASCOrDESC);
                    promise.then(
                        function (payload) {
                            $log.log(payload);
                            $scope.loading = false;
                            if (payload.title.data.data.length) {
                                payload.title.data.data.forEach(function (region) {
                                    $scope.branchListForPopup.push(region);
                                });
                                $scope.branchListForPopupCount = payload.title.data.total_count;
                            } else {
                                $scope.branchListForPopupCount = payload.title.data.total_count;
                                $scope.branchListForPopup = [];
                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            $scope.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                };
                $scope.branchesForAddingForPopup(1, $scope.branchesForAddingForPopupoffset);
            }
        }

        // ================ FUNCTION TO SHOW MULTIPLE GEOFENCE SELECTION BUTTON IS DISABLE OR ENABLE ==================
        function checkboxToShowAllGeoFenceFunction(status) {
            vm.openMultipleGeofencePopupButtonDisable = !status;
            if (vm.openMultipleGeofencePopupButtonDisable) {
                vm.addFixedRouteGeofenceFlag = true;
                vm.editFixedRouteGeofenceFlag = false;
                vm.viewFixedRouteGeofenceFlag = false;
                // getAllBranches(vm.mainShowActiveOrInactiveGeofenceStatus);
                vm.mainBranchesForAddingForPopupoffset = 0;
                vm.allBranchList = [];
                vm.tableFixedRouteList = [];
                vm.fixedRouteList = [];
                vm.getAllBranches(vm.mainShowActiveOrInactiveGeofenceStatus, vm.mainBranchesForAddingForPopupoffset);
                vm.hideFilters = true;
            }
        }

        // ================ REMOVE GEOFENCE FROM MAP WHEN ADDING A NEW ONE ==================
        function removeGeoFenceFromMap() {
            if (!vm.addFixedRouteGeofenceFlag) {
                // Hide geofence when user view or edit existing geofence
                for (var i = 0; i < vm.bermudaTriangleArray.length; i++) {
                    if (vm.bermudaTriangleArray[i].visible) {
                        vm.bermudaTriangleArray[i].visible = false;
                        infoWindow.close();
                        vm.bermudaTriangleArray[i].setMap(map);
                    }
                }
                vm.clearmap = true;
                vm.fialArrayCordinates = [];
                // vm.editRegionData[0] = [];
                // Hide geofence when user is creating New geofence
                if (all_overlays[0]) {
                    all_overlays[0].overlay.setMap(null);
                }
                all_overlays = [];

                drawingManager.setOptions({
                    drawingControl: true
                });
                drawingManager.setMap(map);
            }else{
                if (all_overlays[0]) {
                    all_overlays[0].overlay.setMap(null);
                }
                all_overlays = [];
                drawingManager.setOptions({
                    drawingControl: true
                });
                drawingManager.setMap(map);
                vm.finalArrayCordinates = [];
            }
        }
    }
})();

/**
 * Created by cl-macmini-51 on 5/24/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('FixedRouteListController', FixedRouteListController);

    /** @ngInject */
    function FixedRouteListController($cookies, $state, $log, $rootScope, $timeout, getCars, $scope, filterFilter, $mdDialog, $document, getGeofence, languageBasedErrorFactory, errorMessageFactory, pendingRequests, Initializer) {
        var vm = this;
        var myCenter;
        var zoomLevel = 8;
        var all_overlays = [];
        var coordinates_array = [];
        var markers = [];
        var mapProp = {};
        var drawingManager = '';
        var mc = null;
        var map = null;
        var icon = {};
        var bounds;
        var geocoder;
        var infoWindow;
        var bermudaTriangle;
        var location = "";
        var currentId = 0;
        var laArray = [];
        var poly = '';
        var uniqueId = function () {
            return ++currentId;
        };

        // Service To Get Map Instance
        Initializer.mapsInitialized
            .then(function () {
                console.log('>>>> GOOGLE INIT', google);
                if (google) {
                    myCenter = new google.maps.LatLng(-33.447487, -70.673676);
                    bounds = new google.maps.LatLngBounds();
                    geocoder = new google.maps.Geocoder();
                    infoWindow = new google.maps.InfoWindow();
                    bermudaTriangle = new google.maps.Polygon();
                    initAutocomplete();
                    document.getElementById("googleMap").style.height = window.innerHeight - 200 + 'px';
                } else {
                    alert(languageBasedErrorFactory.getProperErrorMessage('onRoadMessage', 0, '3'));
                }

            });
        vm.addressHave = '';
        vm.loading = false;
        vm.locationListDisbaled = true;
        vm.dataToFill = {
            name: '',
            description: '',
            branch: '',
            pickup: '',
            dropoff: '',
            status: '',
            destinationBranch: ''
        };
        vm.currentPage = 0;
        vm.totalCars = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.predicate = 'index';
        vm.reverse = false;
        vm.addFixedRouteFlag = false;
        vm.editFixedRouteFlag = false;
        vm.filterTextTimeout = '';
        var regionsArray = [];
        vm.getPagesCount = getPagesCount;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.init = init;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.branchChanged = branchChanged;
        vm.destinationBranchChanged = destinationBranchChanged;
        vm.locationChanged = locationChanged;
        vm.addFixedRouteHit = addFixedRouteHit;
        vm.getAllFixedRoutes = getAllFixedRoutes;
        vm.cancelEdit = cancelEdit;
        vm.editFixedRoute = editFixedRoute;
        vm.editFixedRouteHit = editFixedRouteHit;
        vm.deleteRoute = deleteRoute;
        vm.changeStatus = changeStatus;
        vm.createNewRoute = createNewRoute;
        vm.setMapOnAll = setMapOnAll;
        vm.drawingFunctions = drawingFunctions;
        vm.mapInitialize = mapInitialize;
        vm.refreshData = refreshData;
        vm.paginationNew = paginationNew;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.filterData = {
            fixedRouteStatus: '1',
            branchId: 'all',
            search_filter: 0,
            search_value: ''
        };
        document.getElementById("googleMap").style.height = window.innerHeight - 200 + 'px';
        //==========================cancel========================
        function cancelEdit() {
            $state.reload('layout.fixedRouteMain.fixedRouteList');
        };

        //=======================create new route=========================
        function createNewRoute() {
            myCenter = new google.maps.LatLng(-33.447487, -70.673676);
            zoomLevel = 8;
            $timeout(function () {
                mapInitialize(vm.branchList, 0);
            }, 500);
            vm.addFixedRouteFlag = true;
            vm.editFixedRouteFlag = false;
        };
        //================set map nulll======================
        function setMapOnAll(map, id) {
            for (var i = 0; i < markers.length; i++) {
                var marker = markers[i];
                marker.setMap(map);
            }
        };
        // If the map position is out of range, move it back
        function checkBounds(map) {
            if (typeof (map.getBounds()) == 'undefined')
                return;

            var latNorth = map.getBounds().getNorthEast().lat();
            var latSouth = map.getBounds().getSouthWest().lat();
            var newLat;

            if (latNorth < 85 && latSouth > -85) /* in both side -> it's ok */
                return;
            else {
                if (latNorth > 85 && latSouth < -85) /* out both side -> it's ok */
                    return;
                else {
                    if (latNorth > 85)
                        newLat = map.getCenter().lat() - (latNorth - 85);
                    /* too north, centering */
                    if (latSouth < -85)
                        newLat = map.getCenter().lat() - (latSouth + 85);
                    /* too south, centering */
                }
            }
            if (newLat) {
                var newCenter = new google.maps.LatLng(newLat, map.getCenter().lng());
                map.setCenter(newCenter);
            }
        }
        //===========================auto complete===============================
        var autocomplete;

        function initAutocomplete() {

            autocomplete = new google.maps.places.Autocomplete(
                (document.getElementById('addressGot')));
            autocomplete.addListener('place_changed', fillInAddress);
        };

        function placeMarker(map, location) {
            if (markers.length > 1) {
                setMapOnAll(null);
            }
            var id = uniqueId();
            var marker = new google.maps.Marker({
                id: id,
                position: location,
                draggable: false,
                map: map
            });
            //bounds.extend(location);
            //map.fitBounds(bounds);
            markers.push(marker);
        };

        function fillInAddress() {
            // Get the place details from the autocomplete object.
            var place = autocomplete.getPlace();
            var formattedAddress = place.formatted_address;
            vm.addressHave = formattedAddress;
            myCenter = new google.maps.LatLng(place.geometry.location.lat(), place.geometry.location.lng());
            zoomLevel = 12;
            if (vm.editFixedRouteFlag) {
                mapInitialize(vm.branchList, 0);
            } else if (vm.addFixedRouteFlag) {
                mapInitialize(vm.branchList, 0);
            }
            placeMarker(map, myCenter);
        };

        //================map initialize===========================
        function drawingFunctions(map, data, type, dType) {
            var triangleCoords = [];
            console.log(data, data.region_data, 'drwaing funca');

            for (var i = 0; i < data.region_data.length; i++) {
                triangleCoords.push({
                    lat: Number(data.region_data[i].x),
                    lng: Number(data.region_data[i].y)
                })
            }

            // Construct the polygon.
            bermudaTriangle = new google.maps.Polygon({
                paths: triangleCoords,
                strokeColor: data.strokeColor,
                strokeOpacity: 1,
                strokeWeight: 2,
                fillColor: data.fillColor,
                fillOpacity: 0.5
            });
            if (type) {
                bermudaTriangle.setOptions({
                    id: 1
                });
                bermudaTriangle.content = '<div class="infoWindowContent">' +
                    '<center><b>Branch</b></center>' +
                    '<span> ' + data.region_name + '</span><br>'
                '</div>';
            } else {
                if (dType == 'origin') {
                    bermudaTriangle.setOptions({
                        id: 0
                    });
                } else if (dType == 'destination') {
                    bermudaTriangle.setOptions({
                        id: 2
                    });
                }
                bermudaTriangle.content = '<div class="infoWindowContent">' +
                    '<center><b>Geofence</b></center>' +
                    '<span> ' + data.region_name + '</span><br>'
                '</div>';
            }

            bermudaTriangle.setOptions({
                editable: false
            });

            google.maps.event.addListener(bermudaTriangle, 'click', function (event) {
                infoWindow.setContent(bermudaTriangle.content);
                infoWindow.setPosition(event.latLng);
                infoWindow.open(map, bermudaTriangle);
            });
            bermudaTriangle.setMap(map);
            regionsArray.push(bermudaTriangle);
        };

        function mapInitialize(data, type) {
            mapProp = {
                center: myCenter,
                zoom: Number(zoomLevel),
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                minZoom: 3,
                //maxZoom: 15,
                scrollwheel: false
            };
            map = new google.maps.Map(document.getElementById("googleMap"), mapProp);
            google.maps.event.addListener(map, 'center_changed', function () {
                checkBounds(map);
            });
            if (data && data.length && type == 0) {
                console.log(data, "data ");

                data.forEach(function (makeMap) {
                    drawingFunctions(map, makeMap, 1);
                });
            } else if (data && type == 1) {
                drawingFunctions(map, data, 0);
            }
        };

        function setMapOnAllRegions(map, id) {
            for (var i = 0; i < regionsArray.length; i++) {
                if (regionsArray[i].id == id || regionsArray[i].id == id) {
                    var bermudaTriangle = regionsArray[i];
                    bermudaTriangle.setMap(map);
                }
            }
        };
        //====================function for dropdown pages and page count===============
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];

        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllFixedRoutes(0, vm.itemsPerPageGot, vm.filterData);
        };

        function paginationNew(page) {
            getAllFixedRoutes((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData);
        }

        //==================refreshData=====================
        function refreshData() {
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllFixedRoutes(vm.currentPage * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData);
        }


        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.fixedRouteMain.fixedRouteList');
            }
        });
        //==================get all drivers=======================
        function getAllFixedRoutes(skip, limit, filter) {
            var dataSend = {};
            dataSend.offset = skip;
            dataSend.limit = limit;
            dataSend.key = Number(filter.fixedRouteStatus);
            if (filter.branchId != 'all') {
                dataSend.branch_id = Number(filter.branchId);
            }
            dataSend.access_token = $cookies.get('obj');
            dataSend.search_filter = filter.search_filter;
            if (filter.search_filter == 1) {
                dataSend.search_value = filter.search_value;
            }
            vm.loading = true;
            var promise = getGeofence.getAllFixedRoute(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.totalFixedRoutes = payload.title.data.totalCount;
                    vm.dataLength = payload.title.data.totalCount;

                    if (payload.title.data.totalCount == 0) {
                        vm.sp_pagination = false;
                        vm.tBodyFlag = false;
                        vm.tFootFlag = true;
                        vm.filterOn = true;
                        vm.skipValueFilter = 0;
                    } else {
                        vm.sp_pagination = true;
                        vm.tBodyFlag = true;
                        vm.tFootFlag = false;
                        vm.filterOn = false;
                        vm.skipValueFilter = 0;

                        var dataArray = [];
                        var fixedRouteList = payload.title.data.result;
                        fixedRouteList.forEach(function (column) {
                            var d = {};
                            d.description = column.description;
                            d.id = column.id;
                            //d.location1 = column.location1;
                            //d.location2 = column.location2;
                            d.location1 = {};
                            d.location2 = {};
                            d.location1.id = column.location1;
                            d.location2.id = column.location2;
                            d.location1.region_id = column.origin_region_id;
                            //d.location1.region_data = column.origin_region_data;
                            d.location1.parent_id = column.origin_parent_id;
                            d.location2.region_id = column.destination_region_id;
                            //d.location2.region_data = column.destination_region_data;
                            d.location2.parent_id = column.destination_parent_id;

                            d.origin = column.origin;
                            d.destination = column.destination;

                            d.name = column.name;
                            d.status = column.status;
                            dataArray.push(d);
                        });
                        vm.fixedRouteListGot = dataArray;
                        for (var i = 0; i < vm.fixedRouteListGot.length; i++) {
                            vm.fixedRouteListGot[i].index = (skip + i);
                        }
                        if (vm.dataLength <= vm.fixedRouteListGot.length) {
                            vm.sp_pagination = false;
                        } else {
                            vm.sp_pagination = true;
                            //vm.pageCount(payload.title.data.totalCount);
                        }
                        vm.skipValue = vm.fixedRouteListGot[0].index;
                        vm.limitValue = vm.fixedRouteListGot[vm.fixedRouteListGot.length - 1].index;

                        //$scope.$watch('vm.search', function (newVal, oldVal) {
                        //    vm.filtered = filterFilter(vm.fixedRouteListGot, newVal);
                        //    vm.totalItems = vm.filtered.length;
                        //    if (vm.filtered.length == 0) {
                        //        vm.watchPagination = false;
                        //    }
                        //    else {
                        //        vm.watchPagination = true;
                        //    }
                        //    if (vm.filterOn == true) {
                        //        vm.skipValueFilter = vm.filtered.length;
                        //        vm.sp_pagination = false;
                        //    }
                        //}, true);

                        //range();
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };
        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    }
        //    else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        vm.getAllFixedRoutes((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        vm.currentPage++;
        //        vm.getAllFixedRoutes((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    vm.getAllFixedRoutes((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //};

        function init() {
            vm.getAllFixedRoutes(0, vm.searchModel.limit, vm.filterData);
        };
        init();

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            //vm.filterOn = true;
            vm.currentPage = 0;
            vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
            vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
            pendingRequests.cancelAll();
            if (vm.search.length == 0) {
                vm.filterData.search_filter = 0;
                vm.filterData.search_value = '';
                vm.getAllFixedRoutes(0, vm.searchModel.limit, vm.filterData);
                //vm.filterOn = false;
                //vm.watchPagination = true;
                //vm.sp_pagination = true;

            } else {
                vm.filterData.search_filter = 1;
                vm.filterData.search_value = vm.search;
                //if (vm.filterTextTimeout) $timeout.cancel(vm.filterTextTimeout);
                //vm.filterTextTimeout = $timeout(function(){
                vm.getAllFixedRoutes(0, vm.searchModel.limit, vm.filterData);
                //},500);
            }
        };
        //===========================get all branches==========================
        function getAllBranches() {
            vm.loadingNew = true;
            var promise = getGeofence.getAllBranchList(2);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    if (payload.title.status == 200) {
                        vm.loadingNew = false;
                        if (payload.title.data.length) {
                            var where = _.where(payload.title.data, {
                                parent_id: 0
                            });
                            var where1 = _.where(where, {
                                is_active: 1
                            });
                            vm.branchList = where1;
                            for (var i = 0; i < vm.branchList.length; i++) {
                                vm.branchList[i].index = i;
                                vm.branchList[i].child = [];
                                vm.branchList[i].strokeColor = '#f18903';
                                vm.branchList[i].fillColor = 'transparent';
                            }
                            var whereFixed = [];
                            for (var i = 0; i < payload.title.data.length; i++) {
                                if (payload.title.data[i].parent_id != 0) {
                                    whereFixed.push(payload.title.data[i]);
                                }
                            }
                            if (whereFixed.length) {
                                var newCombinationArray = vm.branchList;
                                for (var i = 0; i < whereFixed.length; i++) {
                                    whereFixed[i].index = i;
                                    whereFixed[i].strokeColor = '#063c4a';
                                    whereFixed[i].fillColor = '#063c4a';
                                    for (var j = 0; j < newCombinationArray.length; j++) {
                                        if (whereFixed[i].parent_id == newCombinationArray[j].region_id) {
                                            newCombinationArray[j].child.push(whereFixed[i]);
                                        }
                                    }
                                }
                                vm.fixedRouteList = newCombinationArray;
                                $log.log('whereFixed', newCombinationArray);
                            } else {
                                vm.fixedRouteList = [];
                                vm.noDataFlag = true;
                            }
                            vm.branchListFilter = where;
                            vm.branchListFilter.push({
                                region_name: 'All',
                                region_id: 'all'
                            });
                        } else {
                            vm.allBranchList = [];
                            vm.fixedRouteList = [];
                            vm.noDataFlag = true;
                            languageBasedErrorFactory.getProperErrorMessage('branchReq', 0, 0);
                            //errorMessageFactory.showErrorMessage('Please add branch first.',0);
                        }
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllBranches();
        vm.mapArrayForDrawingTool = [
            [],
            []
        ];
        //=======================selected branch childs=======================
        function branchChanged() {
            vm.dataToFill.pickup = '';
            vm.dataToFill.dropoff = '';
            var where = _.where(vm.fixedRouteList, {
                region_id: vm.dataToFill.branch
            });
            $log.log(where);
            if (where[0].child && where[0].child.length) {
                vm.locationList = where[0].child;
                vm.locationSelected = where;
                vm.locationListDisbaled = false;
                myCenter = new google.maps.LatLng(where[0].region_data[0].x, where[0].region_data[0].y);
                vm.mapArrayForDrawingTool[0] = where;
                // vm.whereArray = [];
                mapInitialize(where, 0);
                vm.whereLocation1 = where;
                map.setZoom(10);
            } else {
                vm.locationListDisbaled = true;
                languageBasedErrorFactory.getProperErrorMessage('fixedBranchError', 0, 0);
                //errorMessageFactory.showErrorMessage('Fixed route geofence not created for this branch.Please create them first or choose another branch.');
            }
        };

        function destinationBranchChanged() {
            // vm.dataToFill.pickup = '';
            vm.dataToFill.dropoff = '';
            var where = _.where(vm.fixedRouteList, {
                region_id: vm.dataToFill.destinationBranch
            });
            $log.log(where);
            if (where[0].child && where[0].child.length) {
                vm.locationList1 = where[0].child;
                vm.locationSelected = where;
                vm.locationListDisbaled = false;
                myCenter = new google.maps.LatLng(where[0].region_data[0].x, where[0].region_data[0].y);
                vm.mapArrayForDrawingTool[1] = where;
                // mapInitialize(where,0);
                $timeout(function () {
                    drawingFunctions(map, where[0], 0);
                    // var newCenter = new google.maps.LatLng(newLat, map.getCenter().lng());
                    map.setCenter(myCenter);
                })
                map.setZoom(10);
            } else {
                vm.locationListDisbaled = true;
                languageBasedErrorFactory.getProperErrorMessage('fixedBranchError', 0, 0);
                //errorMessageFactory.showErrorMessage('Fixed route geofence not created for this branch.Please create them first or choose another branch.');
            }
        };

        function locationChanged(type) {
            if (vm.dataToFill.pickup && vm.dataToFill.dropoff) {
                if (vm.dataToFill.pickup == vm.dataToFill.dropoff) {
                    vm.dataToFill.pickup = '';
                    vm.dataToFill.dropoff = '';
                    bermudaTriangle.setMap(null);
                    //drawingFunctions(map,vm.locationSelected[0],1);
                    languageBasedErrorFactory.getProperErrorMessage('bothLocationsSame', 0, 0);
                    //errorMessageFactory.showErrorMessage('Both locations can not be same.');
                    return;
                }
            }
            if (type == '1') {
                var where = _.where(vm.locationList, {
                    region_id: vm.dataToFill.pickup
                });
                myCenter = new google.maps.LatLng(where[0].region_data[0].x, where[0].region_data[0].y);
                //drawingFunctions(map,vm.locationSelected[0],1);
                //setMapOnAllRegions(null,0,function(){drawingFunctions(map,where[0],0,'origin');});
                setMapOnAllRegions(null, 0);
                $timeout(function () {
                    drawingFunctions(map, where[0], 0, 'origin');
                }, 200);

                map.setZoom(10);
            } else if (type == '2') {
                var where = _.where(vm.locationList1, {
                    region_id: vm.dataToFill.dropoff
                });
                myCenter = new google.maps.LatLng(where[0].region_data[0].x, where[0].region_data[0].y);
                //drawingFunctions(map,vm.locationSelected[0],1);
                //setMapOnAllRegions(null,2,function(){drawingFunctions(map,where[0],0,'destination');});
                setMapOnAllRegions(null, 2);
                $timeout(function () {
                    drawingFunctions(map, where[0], 0, 'destination');
                }, 200);
                map.setZoom(10);
            }
        };
        //==================add fixed route hit======================
        function addFixedRouteHit() {
            $log.log(vm.dataToFill);
            if (vm.dataToFill.pickup == vm.dataToFill.dropoff) {
                //errorMessageFactory.showErrorMessage('Both locations can not be same.');
                languageBasedErrorFactory.getProperErrorMessage('bothLocationsSame', 0, 0);
                return;
            }
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.location2 = vm.dataToFill.dropoff;
            dataSend.location1 = vm.dataToFill.pickup;
            dataSend.description = vm.dataToFill.description;
            dataSend.name = vm.dataToFill.name;
            vm.loading = true;
            var promise = getGeofence.addFixedRoute(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    //errorMessageFactory.showErrorMessage('Fixed route created successfully.',1);
                    languageBasedErrorFactory.getProperErrorMessage('fixedCreateSucc', 0, 1, 'layout.fixedRouteMain.fixedRouteList');
                    //$timeout(function() {
                    //    $mdDialog.hide();
                    //    $state.reload();
                    //}, 2000);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        //==============================edit fixed route list==========================
        function editFixedRoute(data, $event) {
            $log.log(data);
            vm.loading = true;
            var dataSend = {};
            dataSend.region_id = data.id;
            dataSend.access_token = $cookies.get('obj');
            vm.loading = true;
            var promise = getGeofence.getAllFixedRouteNew(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;

                    var singleRouteData = payload.title.data.result[0];

                    singleRouteData.location1 = {};
                    singleRouteData.location2 = {};
                    singleRouteData.location1.id = singleRouteData.location1;
                    singleRouteData.location2.id = singleRouteData.location2;
                    singleRouteData.location1.region_id = singleRouteData.origin_region_id;
                    singleRouteData.location1.region_data = singleRouteData.origin_region_data;
                    singleRouteData.location1.parent_id = singleRouteData.origin_parent_id;
                    singleRouteData.location2.region_id = singleRouteData.destination_region_id;
                    singleRouteData.location2.region_data = singleRouteData.destination_region_data;
                    singleRouteData.location2.parent_id = singleRouteData.destination_parent_id;
                    singleRouteData.location1.strokeColor = '#063c4a';
                    singleRouteData.location2.strokeColor = '#063c4a';
                    singleRouteData.location1.fillColor = '#063c4a';
                    singleRouteData.location2.fillColor = '#063c4a';

                    vm.addFixedRouteFlag = false;
                    vm.editFixedRouteFlag = true;

                    var where = _.where(vm.fixedRouteList, {
                        region_id: singleRouteData.location1.parent_id
                    });
                    $log.log(where);
                    vm.locationList = where[0].child;
                    vm.locationListDisbaled = false;

                    vm.fixedRouteId = singleRouteData.id;
                    vm.dataToFill.branch = singleRouteData.location1.parent_id;
                    vm.pickUpObject = singleRouteData.location1;
                    vm.dropOffObject = singleRouteData.location2;
                    vm.pickUpObject.region_data = vm.pickUpObject.region_data[0];
                    vm.dropOffObject.region_data = vm.dropOffObject.region_data[0];
                    vm.dataToFill.destinationBranch = singleRouteData.location2.parent_id;
                    vm.dataToFill.name = singleRouteData.name;
                    // vm.dataToFill.destinationBranch = singleRouteData.location2.parent_id;
                    vm.dataToFill.description = singleRouteData.description;
                    vm.dataToFill.status = singleRouteData.status.toString();
                    //var where = _.where(vm.locationList,{region_id:vm.dataToFill.pickup});
                    //var whereD = _.where(vm.locationList,{region_id:vm.dataToFill.dropoff});
                    //drawingFunctions(map,vm.locationSelected[0],1);
                    $timeout(function () {
                        branchChanged();
                        destinationBranchChanged();
                        drawingFunctions(map, vm.pickUpObject, 0, 'origin');
                        drawingFunctions(map, vm.dropOffObject, 0, 'destination');
                        map.setZoom(10);
                        vm.dataToFill.pickup = singleRouteData.location1.region_id;
                        vm.dataToFill.dropoff = singleRouteData.location2.region_id;
                        console.log(vm.dataToFill.dropoff, 'vm.dataToFill.dropoff');

                    }, 500);

                },
                function (errorPayload) {
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };

        function editFixedRouteHit() {
            $log.log(vm.dataToFill);
            $log.log(vm.fixedRouteId);

            if (vm.dataToFill.pickup == vm.dataToFill.dropoff) {
                //errorMessageFactory.showErrorMessage('Both locations can not be same.');
                languageBasedErrorFactory.getProperErrorMessage('bothLocationsSame', 0, 0);
                return;
            }
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.location2 = vm.dataToFill.dropoff;
            dataSend.location1 = vm.dataToFill.pickup;
            dataSend.description = vm.dataToFill.description;
            dataSend.name = vm.dataToFill.name;
            //dataSend.status = Number(vm.dataToFill.status);
            dataSend.route_id = vm.fixedRouteId;
            $log.log(dataSend);
            vm.loading = true;
            var promise = getGeofence.editFixedRoute(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    var dataForSysLogs = {
                        access_token: $cookies.get('obj'),
                        id: vm.fixedRouteId,
                        identity: 10,
                        message: 'Fixed route updated.'
                    };
                    $rootScope.systemLogsAdmin(dataForSysLogs);
                    //errorMessageFactory.showErrorMessage('Fixed route details updated successfully.',1);
                    languageBasedErrorFactory.getProperErrorMessage('fixedUpdateSucc', 0, 1, 'layout.fixedRouteMain.fixedRouteList');
                    //$timeout(function() {
                    //    $mdDialog.hide();
                    //    $state.reload();
                    //}, 2000);


                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //=====================to delete route====================
        function deleteRoute(data, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('fixedDeletePop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                //errorMessageFactory.showErrorMessage('Functionality is pending',0);
                var dataSend = {
                    deleteType: 1,
                    route_id: data.id,
                    access_token: $cookies.get('obj')
                };
                vm.loading = true;
                var promise = getGeofence.deleteFixedRoute(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        //errorMessageFactory.showErrorMessage('Fixed route deleted successfully.',1);
                        languageBasedErrorFactory.getProperErrorMessage('fixedDeleteSucc', 0, 1, 'layout.fixedRouteMain.fixedRouteList');
                        //$state.reload();
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        };
        //==================change rout status function======================
        function changeStatus($event, id, value) {
            $log.log('block_unblock');
            var parentEl = angular.element($document.body);
            var msg = languageBasedErrorFactory.getProperErrorMessage('priceRouteStatusPop', 0, '3');
            //==============dialog for confirm====================
            var confirm = $mdDialog.confirm()
                .title(msg)
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                var a = '';
                var msgSys = '';
                if (value == 0) {
                    a = 1;
                    msgSys = 'Fixed route unblocked.'
                } else if (value == 1) {
                    a = 0;
                    msgSys = 'Fixed route blocked.'
                }
                $log.log('blocked');
                //errorMessageFactory.showErrorMessage('Functionality is pending',0);
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.status = a;
                dataSend.route_id = id;
                $log.log(dataSend);
                vm.loading = true;
                var promise = getGeofence.editFixedRoute(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        var dataForSysLogs = {
                            access_token: $cookies.get('obj'),
                            id: id,
                            identity: 10,
                            message: msgSys
                        };
                        $rootScope.systemLogsAdmin(dataForSysLogs);
                        languageBasedErrorFactory.getProperErrorMessage('fixedStatusSucc', 0, 1, 'layout.fixedRouteMain.fixedRouteList');
                        //errorMessageFactory.showErrorMessage('Fixed route status updated successfully.',1);
                        //$timeout(function() {
                        //    $mdDialog.hide();
                        //    $state.reload();
                        //}, 2000);
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('unblock');
            });
        };
    }
})();
/**
 * Created by cl-macmini-51 on 5/24/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('FixedRouteGeofenceListController', FixedRouteGeofenceListController);

    /** @ngInject */
    function FixedRouteGeofenceListController($cookies, $state, $log, $rootScope, checkDomain, $timeout, getCars, $scope, filterFilter, $mdDialog, $document, getGeofence, languageBasedErrorFactory, errorMessageFactory,Initializer) {
        var vm = this;
        $log.log('driver');
        var myCenter;
        var zoomLevel = 8;
        var all_overlays = [];
        var coordinates_array = [];
        vm.addressChange = addressChange;
        vm.pickAddressFlag = false;
        var markers = [];
        var mapProp = {};
        var drawingManager = '';
        var mc = null;
        var map = null;
        var icon = {};
        var bounds;
        var geocoder;
        var infoWindow;
        var location = "";
        var currentId = 0;
        var laArray = [];
        var poly = '';
        var uniqueId = function () {
            return ++currentId;
        };

        vm.addressHave = '';
        vm.noDataFlag = false;
        vm.addFixedRouteGeofenceFlag = true;
        vm.editFixedRouteGeofenceFlag = false;
        vm.viewFixedRouteGeofenceFlag = false;
        vm.isAirportService = false;
        document.getElementById("googleMap").style.height = window.innerHeight - 200 + 'px';
        vm.filterData = {
            geofenceStatus: '1'
        };
        // Service To Get Map Instance
        Initializer.mapsInitialized
            .then(function () {
                console.log('>>>> GOOGLE INIT', google);
                if (google) {
                    myCenter = new google.maps.LatLng(-33.447487, -70.673676);
                    bounds = new google.maps.LatLngBounds();
                    geocoder = new google.maps.Geocoder();
                    infoWindow = new google.maps.InfoWindow();
                } else {
                    alert(languageBasedErrorFactory.getProperErrorMessage('onRoadMessage', 0, '3'));
                }

            });
        vm.setMapOnAll = setMapOnAll;
        vm.drawingFunctions = drawingFunctions;
        vm.mapInitialize = mapInitialize;
        vm.latLongArrayList = latLongArrayList;
        vm.addFixedRouteGeofenceHit = addFixedRouteGeofenceHit;
        vm.getAllBranches = getAllBranches;
        vm.branchChanged = branchChanged;
        vm.editFixedRouteGeofenceHit = editFixedRouteGeofenceHit;
        vm.editFixedRouteGeofence = editFixedRouteGeofence;
        vm.cancelEdit = cancelEdit;
        vm.deleteFixedRouteGeofence = deleteFixedRouteGeofence;
        vm.viewFixedRouteGeofence = viewFixedRouteGeofence;
        vm.goBack = goBack;
        vm.setBooleans = setBooleans;
        vm.changeFixedRegionStatus = changeFixedRegionStatus;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();

        vm.addNewGeoFence = addNewGeoFence;
        vm.addNewGeoFenceToggle = false;
        vm.openMultipleGeofencePopup = openMultipleGeofencePopup;
        vm.checkboxToShowAllGeoFenceFunction = checkboxToShowAllGeoFenceFunction;
        vm.removeGeoFenceFromMap = removeGeoFenceFromMap;
        vm.mainPaginationChangedForMultipleGeofence = mainPaginationChangedForMultipleGeofence;
        vm.mainSearch = mainSearch;
        vm.checkboxToShowAllGeoFence = false;
        vm.openMultipleGeofencePopupButtonDisable = true;
        vm.removeGeoFenceFromMapDisableButtonStatus = false;
        vm.hideFilters = true;
        //==========================set boolean=======================
        function setBooleans(type) {
            switch (type) {
                case 'AIRPORT_ZONE':
                    if (vm.isAirportService) {
                        vm.isAirportService = false;
                    } else {
                        vm.isAirportService = true;
                    }
                    break;
            }
        };

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.fixedRouteGeofenceMain.fixedRouteGeofenceList');
            }
        });
        //================set map nulll======================
        function setMapOnAll(map, id) {
            for (var i = 0; i < markers.length; i++) {
                var marker = markers[i];
                marker.setMap(map);
            }
        };
        // If the map position is out of range, move it back
        function checkBounds(map) {
            if (typeof (map.getBounds()) == 'undefined')
                return;

            var latNorth = map.getBounds().getNorthEast().lat();
            var latSouth = map.getBounds().getSouthWest().lat();
            var newLat;

            if (latNorth < 85 && latSouth > -85) /* in both side -> it's ok */
                return;
            else {
                if (latNorth > 85 && latSouth < -85) /* out both side -> it's ok */
                    return;
                else {
                    if (latNorth > 85)
                        newLat = map.getCenter().lat() - (latNorth - 85);
                    /* too north, centering */
                    if (latSouth < -85)
                        newLat = map.getCenter().lat() - (latSouth + 85);
                    /* too south, centering */
                }
            }
            if (newLat) {
                var newCenter = new google.maps.LatLng(newLat, map.getCenter().lng());
                map.setCenter(newCenter);
            }
        }

        //===========================auto complete===============================
        function addressChange(data) {
            initAutocomplete(data);

        }
        var autocomplete;
        var domain = checkDomain.getDomainName();

        function initAutocomplete(data) {
            if ((!vm.pickAddressFlag) && data && data.length >= 3) {
                vm.pickAddressFlag = true;
                autocomplete = new google.maps.places.Autocomplete(
                    (document.getElementById('addressGot')), {
                        placeIdOnly: true
                    });
                if (domain != 'dev' && domain != 'test')
                    autocomplete.setComponentRestrictions({
                        'country': ['CL']
                    });

                autocomplete.addListener('place_changed', fillInAddress);
            } else if (data && data.length < 3) {
                vm.pickAddressFlag = false;
                google.maps.event.clearInstanceListeners(addressGot);
                $(".pac-container").hide();
            }
        };

        function placeMarker(map, location) {
            if (markers.length > 1) {
                setMapOnAll(null);
            }
            var id = uniqueId();
            var marker = new google.maps.Marker({
                id: id,
                position: location,
                draggable: false,
                map: map
            });
            bounds = new google.maps.LatLngBounds();
            bounds.extend(location);
            map.fitBounds(bounds);
            markers.push(marker);
        };

        function fillInAddress() {
            // Get the place details from the autocomplete object.
            var place = autocomplete.getPlace();
            if (!place.place_id) {
                return;
            }
            geocoder.geocode({
                'placeId': place.place_id
            }, function (results, status) {
                if (status !== 'OK') {
                    window.alert('Geocoder failed due to: ' + status);
                    return;
                }
                var formattedAddress = results[0].formatted_address;
                vm.addressHave = formattedAddress;
                myCenter = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
                zoomLevel = 12;
                //mapInitialize();
                placeMarker(map, myCenter);
            });
        };
        // initAutocomplete();
        //================map initialize===========================
        vm.bermudaTriangleArray = [];

        function drawingFunctions(map, data, type) {
            var triangleCoords = [];
            for (var i = 0; i < data.region_data[0].length; i++) {
                triangleCoords.push({
                    lat: data.region_data[0][i].x,
                    lng: data.region_data[0][i].y
                })
            }

            // bounds = new google.maps.LatLngBounds();

            // for (var i = 0; i < data.region_data.length; i++) {
            // bounds.extend(new google.maps.LatLng(data.region_data[0].x, data.region_data[0].y));
            // }

            // map.fitBounds(bounds);
            // map.setCenter(myCenter = new google.maps.LatLng(data.region_data[0].x, data.region_data[0].y));



            // Construct the polygon.
            var bermudaTriangle = new google.maps.Polygon({
                paths: triangleCoords,
                strokeColor: data.strokeColor,
                strokeOpacity: 1,
                strokeWeight: 2,
                fillColor: data.fillColor,
                fillOpacity: 0.5
            });
            if (type) {
                bermudaTriangle.content = '<div class="infoWindowContent">' +
                    '<center><b>'+data.branch_name+'</b></center>' +
                    '<span> ' + data.region_name + '</span><br>'
                '</div>';
            } else {
                bermudaTriangle.content = '<div class="infoWindowContent">' +
                    '<center><b>Geofence</b></center>' +
                    '<span> ' + data.region_name + '</span><br>'
                '</div>';
            }


            if (data.edit) {
                bermudaTriangle.setOptions({
                    editable: true
                });
                drawingManager.setOptions({
                    drawingControl: false,
                    drawingMode: null
                });
            } else {
                bermudaTriangle.setOptions({
                    editable: false
                });
            }

            google.maps.event.addListener(bermudaTriangle.getPath(), 'insert_at', function () {
                var length = bermudaTriangle.getPath().getArray().length;
                coordinates_array = [];
                for (var i = 0; i < length; i++) {
                    console.log( bermudaTriangle.getPath(),' bermudaTriangle.getPath().');
                    
                    var latlong = bermudaTriangle.getPath().getAt(i).lat() + " " + bermudaTriangle.getPath().getAt(i).lng();
                    coordinates_array.push(latlong)
                }
                latLongArrayList(coordinates_array, 'insert');
            });
            google.maps.event.addListener(bermudaTriangle.getPath(), 'set_at', function () {
                var length = bermudaTriangle.getPath().getArray().length;
                coordinates_array = [];
                // var temp = bermudaTriangle.getPath().getAt(i).toUrlValue(5);
                for (var i = 0; i < length; i++) {
                    var latlong = bermudaTriangle.getPath().getAt(i).lat() + " " + bermudaTriangle.getPath().getAt(i).lng();
                    coordinates_array.push(latlong)
                }
                latLongArrayList(coordinates_array, 'insert');
            });

            if (!vm.hideFilters) {
                if (data.view) {
                    infoWindow.setContent(bermudaTriangle.content);
                    infoWindow.setPosition(new google.maps.LatLng(data.region_data[0][0].x, data.region_data[0][0].y));
                    infoWindow.open(map, bermudaTriangle);
                }
            }
            if (vm.hideFilters) {
                if (data.view) {
                    if (vm.viewFixedRouteGeofenceFlag)
                        bermudaTriangle.setOptions({
                            visible: true
                        });
                    infoWindow.setContent(bermudaTriangle.content);
                    infoWindow.setPosition(new google.maps.LatLng(data.region_data[0][0].x, data.region_data[0][0].y));
                    infoWindow.open(map, bermudaTriangle);
                } else {
                    if (vm.viewFixedRouteGeofenceFlag)
                        bermudaTriangle.setOptions({
                            visible: false
                        });
                }
            }

            if (data.add || data.edit) {
                $log.log('adding');
            } else {
                google.maps.event.addListener(bermudaTriangle, 'click', function (event) {
                    infoWindow.setContent(bermudaTriangle.content);
                    infoWindow.setPosition(event.latLng);
                    infoWindow.open(map, bermudaTriangle);
                });
                //google.maps.event.addListener(bermudaTriangle, 'mouseover', function (event) {
                //    infoWindow.setContent(bermudaTriangle.content);
                //    infoWindow.setPosition(event.latLng);
                //    infoWindow.open(map,bermudaTriangle);
                //});
            }
            bermudaTriangle.setMap(map);
            vm.bermudaTriangleArray.push(bermudaTriangle);
        };

        function mapInitialize(data) {
            mapProp = {
                center: myCenter,
                zoom: Number(zoomLevel),
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                minZoom: 5,
                //maxZoom: 15,
                scrollwheel: false
            };
            map = new google.maps.Map(document.getElementById("googleMap"), mapProp);
            google.maps.event.addListener(map, 'center_changed', function () {
                checkBounds(map);
            });
            drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: null, //google.maps.drawing.OverlayType.MARKER
                drawingControl: true,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: ['polygon'] //'marker', 'circle', 'polyline', 'rectangle'
                },
                //markerOptions: {icon: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png'},
                polygonOptions: {
                    fillColor: '#f18903',
                    fillOpacity: 0.5,
                    strokeWeight: 1,
                    clickable: false,
                    editable: true,
                    zIndex: 1
                }
            });
            drawingManager.setMap(map);
            google.maps.event.addListener(drawingManager, 'overlaycomplete', function (event) {
                var coordinates_array = [];
                if (event.type == 'polygon') {
                    all_overlays.push(event);
                    drawingManager.setOptions({
                        drawingControl: false,
                        drawingMode: null
                    });
                    //drawingManager.setDrawingMode(null);    //hiidng the drawing tool aftre completion of polygon
                    // console.log(event.overlay.latLngs,'event.overlay.latLngs'); // Deprecated
                    console.log(event.overlay.getPath().getArray(),'event.overlay.latLngs');
                    
                    // var length = event.overlay.latLngs.i[0].i.length;  // Deprecated
                    var length = event.overlay.getPath().getArray().length;
                    for (var i = 0; i < length; i++) {
                        var latlong = event.overlay.getPath().getArray()[i].lat() + " " + event.overlay.getPath().getArray()[i].lng();
                        coordinates_array.push(latlong)
                    }
                    latLongArrayList(coordinates_array);

                }

                google.maps.event.addListener(event.overlay.getPath(), 'insert_at', function () {
                    // var length = event.overlay.getPath().i.length; Deprecated
                    var length = event.overlay.getPath().getArray().length;
                    coordinates_array = [];
                    for (var i = 0; i < length; i++) {
                        var latlong = event.overlay.getPath().getArray()[i].lat() + " " + event.overlay.getPath().getArray()[i].lng();
                        coordinates_array.push(latlong)
                    }
                    latLongArrayList(coordinates_array, 'insert');
                });
                google.maps.event.addListener(event.overlay.getPath(), 'set_at', function () {
                    // var length = event.overlay.getPath().i.length; Deprecated
                    var length = event.overlay.getPath().getArray().length;
                    coordinates_array = [];
                    for (var i = 0; i < length; i++) {
                        var latlong = event.overlay.getPath().getArray()[i].lat() + " " + event.overlay.getPath().getArray()[i].lng();
                        coordinates_array.push(latlong)
                    }
                    latLongArrayList(coordinates_array, 'insert');
                });
            });
            if (data && data.length) {
                data.forEach(function (makeMap) {
                    if (makeMap.child && makeMap.child.length) {
                        drawingFunctions(map, makeMap, 1);
                        makeMap.child.forEach(function (data) {
                            drawingFunctions(map, data, 0);
                        })
                    } else {
                        drawingFunctions(map, makeMap, 1);
                    }
                });
            } else {
                $log.log('no branch');
            }
        };

        function latLongArrayList(coordinates_array, type) {
            vm.removeGeoFenceFromMapDisableButtonStatus = false;
            if (type == 'insert') {
                if (coordinates_array[0] === coordinates_array[coordinates_array.length - 1]) {
                    vm.finalArrayCordinates = coordinates_array;
                } else {
                    var newArray = coordinates_array;
                    newArray[newArray.length] = newArray[0];
                    vm.finalArrayCordinates = newArray;
                }
                $scope.$apply();
            } else {
                var str_coordinates = '';
                var arr_len = coordinates_array.length;

                var newArray = coordinates_array;
                newArray[newArray.length] = newArray[0];
                vm.finalArrayCordinates = newArray;
                //var new_arr = [];
                //for (var i = 0; i < arr_len; i++) {
                //    var val = coordinates_array[i].split(' ');
                //    var obj = {
                //        "lat": val[0],
                //        "lng": val[1]
                //    };
                //    str_coordinates += coordinates_array[i].toString() + ",";
                //    new_arr.push(obj);
                //}
                //str_coordinates += coordinates_array[0].toString() + ",";
                //str_coordinates = str_coordinates.slice(0, -1);
                //new_arr[new_arr.length] = {
                //    lat: new_arr[0].lat,
                //    lng: new_arr[0].lng
                //};
                $scope.$apply();
                console.log(  vm.finalArrayCordinates ,'  vm.finalArrayCordinates >>>>>>>>>');
                
            }
        };

        //====================branches for adding======================
        function branchesForAdding(filter) {
            vm.loading = true;
            var promise = getGeofence.getAllBranchList(filter);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.data.length) {
                        var where = _.where(payload.title.data, {
                            parent_id: 0
                        });
                        var where1 = _.where(where, {
                            is_active: 1
                        });
                        vm.branchList = where1;
                        for (var i = 0; i < vm.branchList.length; i++) {
                            vm.branchList[i].index = i;
                            vm.branchList[i].add = false;
                            vm.branchList[i].edit = false;
                            vm.branchList[i].strokeColor = '#f18903';
                            vm.branchList[i].fillColor = 'transparent';
                            vm.branchList[i].child = [];
                        }
                        var whereFixed = [];
                        for (var i = 0; i < payload.title.data.length; i++) {
                            if (payload.title.data[i].parent_id != 0) {
                                whereFixed.push(payload.title.data[i]);
                            }
                        }
                        if (whereFixed.length) {
                            var newCombinationArray = vm.branchList;
                            for (var i = 0; i < whereFixed.length; i++) {
                                whereFixed[i].index = i;
                                whereFixed[i].edit = false;
                                whereFixed[i].strokeColor = '#063c4a';
                                whereFixed[i].fillColor = '#063c4a';
                                whereFixed[i].parent = {
                                    region_name: '',
                                    region_id: '',
                                    region_data: [],
                                    strokeColor: '#f18903',
                                    fillColor: 'transparent'
                                };
                                for (var j = 0; j < vm.branchList.length; j++) {
                                    if (whereFixed[i].parent_id == vm.branchList[j].region_id) {
                                        whereFixed[i].parent.region_name = vm.branchList[j].region_name;
                                        whereFixed[i].parent.region_id = vm.branchList[j].region_id;
                                        whereFixed[i].parent.region_data = vm.branchList[j].region_data;
                                    }
                                }
                                for (var j = 0; j < newCombinationArray.length; j++) {
                                    if (whereFixed[i].parent_id == newCombinationArray[j].region_id) {
                                        newCombinationArray[j].child.push(whereFixed[i]);
                                    }
                                }
                            }
                            //vm.tableFixedRouteList = whereFixed;
                            //vm.fixedRouteList = newCombinationArray;
                            $log.log('whereFixed', newCombinationArray);
                            //mapInitialize(vm.fixedRouteList);
                        } else {
                            //vm.fixedRouteList = [];
                            //vm.noDataFlag = true;
                            //mapInitialize(vm.fixedRouteList);
                        }
                    } else {
                        vm.branchList = [];
                        //vm.fixedRouteList = [];
                        //vm.noDataFlag = true;
                        //errorMessageFactory.showErrorMessage('Please add branch first.',0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        branchesForAdding(2);


        function mainPaginationChangedForMultipleGeofence() {
            vm.mainBranchesForAddingForPopupoffset += 25;
            if (vm.mainBranchesForAddingForPopupoffset < vm.mainBranchListForPopupCount) {
                vm.getAllBranches(vm.mainShowActiveOrInactiveGeofenceStatus, vm.mainBranchesForAddingForPopupoffset, vm.mainSearchStringVariable);
            }
        }

        function mainSearch(searchString) {
            vm.allBranchList = [];
            vm.tableFixedRouteList = [];
            vm.fixedRouteList = [];
            vm.mainSearchStringVariable = searchString;
            vm.mainBranchesForAddingForPopupoffset = 0;
            vm.getAllBranches(vm.mainShowActiveOrInactiveGeofenceStatus, vm.mainBranchesForAddingForPopupoffset, vm.mainSearchStringVariable);
        }

        //===========================get all branches==========================
        vm.allBranchList = [];
        vm.tableFixedRouteList = [];
        vm.fixedRouteList = [];
        vm.getaMainBranchesForAddingForPopupLimit = 25;
        vm.mainBranchesForAddingForPopupoffset = 0;
        vm.mainSearchStringVariable = '';
        vm.mainShowActiveOrInactiveGeofenceStatus = 1;
        vm.filterData.geofenceStatus = "1";

        function getAllBranches(filter, mainOffset, mainSearchString, changeState) {

            vm.mainShowActiveOrInactiveGeofenceStatus = filter;
            vm.loading = true;
            var promise = getGeofence.getAllBranchListForPopup(filter, vm.getaMainBranchesForAddingForPopupLimit, mainOffset, mainSearchString);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (changeState) {
                        vm.allBranchList = [];
                        vm.tableFixedRouteList = [];
                        vm.fixedRouteList = [];
                        vm.mainBranchesForAddingForPopupoffset = 0;
                    }
                    vm.mainBranchListForPopupCount = payload.title.data.total_count;
                    if (payload.title.data.data.length) {
                        if (mainSearchString) {
                            vm.allBranchList = [];
                            vm.tableFixedRouteList = [];
                            vm.fixedRouteList = [];
                        }
                        vm.noDataFlag = false;
                        //if(filter == '0') {
                        //    var where1 = _.where(payload.title.data, {parent_id: 0});
                        //    var where = _.where(where1,{is_active: 0});
                        //}
                        //else if(filter == '1') {
                        //    var where1 = _.where(payload.title.data, {parent_id: 0});
                        //    var where = _.where(where1,{is_active: 1});
                        //}
                        //else{
                        var where = _.where(payload.title.data.data, {
                            parent_id: 0
                        });
                        //var where = _.where(where1,{is_active: 0});
                        //}
                        // where.forEach(function (geoFence) {
                        //     vm.allBranchList.push(geoFence);
                        // });
                        vm.allBranchList = where;
                        for (var i = 0; i < vm.allBranchList.length; i++) {
                            vm.allBranchList[i].index = i;
                            vm.allBranchList[i].add = false;
                            vm.allBranchList[i].edit = false;
                            vm.allBranchList[i].strokeColor = '#f18903';
                            vm.allBranchList[i].fillColor = 'transparent';
                            vm.allBranchList[i].child = [];
                        }
                        var whereFixed = [];
                        for (var i = 0; i < payload.title.data.data.length; i++) {
                            if (filter == '0') {
                                if (payload.title.data.data[i].parent_id != 0 && payload.title.data.data[i].is_active == 0) {
                                    whereFixed.push(payload.title.data.data[i]);
                                }
                            } else if (filter == '1') {
                                if (payload.title.data.data[i].parent_id != 0 && payload.title.data.data[i].is_active == 1) {
                                    whereFixed.push(payload.title.data.data[i]);
                                }
                            } else {
                                if (payload.title.data.data[i].parent_id != 0) {
                                    whereFixed.push(payload.title.data.data[i]);
                                }
                            }
                        }
                        if (whereFixed.length) {
                            var newCombinationArray = vm.allBranchList;

                            for (var i = 0; i < whereFixed.length; i++) {
                                whereFixed[i].index = i;
                                whereFixed[i].edit = false;
                                whereFixed[i].view = false;
                                // CHANGE COLOR #063c4a to transparent for child geofence on initialization
                                whereFixed[i].strokeColor = '#063c4a';
                                whereFixed[i].fillColor = '#063c4a';
                                whereFixed[i].parent = {
                                    region_name: '',
                                    region_id: '',
                                    region_data: [],
                                    strokeColor: '#f18903',
                                    fillColor: 'transparent'
                                };
                                // for (var j = 0; j < vm.allBranchList.length; j++) {
                                //     if (whereFixed[i].parent_id == vm.allBranchList[j].region_id) {
                                // whereFixed[i].parent = {};
                                whereFixed[i].parent.region_name = whereFixed[i].region_name;
                                whereFixed[i].parent.region_id = whereFixed[i].region_id;
                                whereFixed[i].parent.region_data = whereFixed[i].region_data;
                                //     }
                                // }
                                // for (var j = 0; j < newCombinationArray.length; j++) {
                                //     if (whereFixed[i].parent_id == newCombinationArray[j].region_id) {
                                //         newCombinationArray[j].child.push(whereFixed[i]);
                                //     }
                                // }
                            }
                            whereFixed.forEach(function (geoFence) {
                                vm.tableFixedRouteList.push(geoFence);
                                vm.fixedRouteList.push(geoFence);
                            });
                            // newCombinationArray.forEach(function (geoFence) {
                            //     vm.fixedRouteList.push(geoFence);
                            // });
                            $log.log('whereFixed', newCombinationArray);

                            //mapInitialize();
                        } else {
                            // vm.fixedRouteList = [];
                            // vm.noDataFlag = true;
                            // mapInitialize(vm.fixedRouteList);
                        }
                    } else {
                        vm.allBranchList = [];
                        vm.fixedRouteList = [];
                        vm.noDataFlag = true;
                        // languageBasedErrorFactory.getProperErrorMessage('branchReq', 0, 0);
                        //errorMessageFactory.showErrorMessage('Please add branch first.',0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllBranches(vm.mainShowActiveOrInactiveGeofenceStatus, vm.mainBranchesForAddingForPopupoffset);
        //=================================branch changed============================
        function branchChanged() {
            $log.log(vm.branchName);
            var where = _.where(vm.branchList, {
                region_id: vm.branchName
            });
            $log.log(where);
            where[0].add = true;
            myCenter = new google.maps.LatLng(where[0].region_data[0].x, where[0].region_data[0].y);
            zoomLevel = 12;
            mapInitialize(vm.fixedRouteList);
        };

        //=============================add branch geofence function hit=================================
        function addFixedRouteGeofenceHit() {
            $log.log(vm.finalArrayCordinates);
            $log.log(vm.name);
            $log.log(vm.description);
            $log.log(vm.branchName);
            $log.log(vm.isAirportService);
            console.log(vm.finalArrayCordinates,'vm.finalArrayCordinates');
            
            if (!vm.finalArrayCordinates || !vm.finalArrayCordinates.length) {
                //errorMessageFactory.showErrorMessage('Please select some region from map.');
                languageBasedErrorFactory.getProperErrorMessage('branchEditPop', 0, 0);
                return;
            }

            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.region_name = vm.name.toUpperCase();
            dataSend.region_description = vm.description;
            dataSend.region_data = vm.finalArrayCordinates;
            dataSend.isAirportService = vm.isAirportService;
            dataSend.parent_id = vm.branchName;
            $log.log(dataSend);
            vm.loading = true;
            var promise = getGeofence.branchGeofenceAdd(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    $state.reload('layout.fixedRouteGeofenceMain.fixedRouteGeofenceList');
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //==========================cancel========================
        function cancelEdit() {
            $state.reload('layout.fixedRouteGeofenceMain.fixedRouteGeofenceList');
        };

        //====================edit fixed route====================
        function editFixedRouteGeofence(data) {
            vm.editFixedRouteGeofenceIndex;
            $log.log(data);
            vm.addFixedRouteGeofenceFlag = false;
            vm.editFixedRouteGeofenceFlag = true;
            vm.viewFixedRouteGeofenceFlag = false;
            vm.editName = data.region_name;
            vm.editDescription = data.region_description;
            vm.editID = data.region_id;
            vm.editRegionData = data.region_data;
            vm.isAirportService = data.isAirportService;
            vm.branchNameEdit = data.parent_id;
            // for (var i = 0; i < vm.fixedRouteList.length; i++) {
            //     for (var j = 0; j < vm.fixedRouteList[i].child.length; j++) {
            //         if (vm.fixedRouteList[i].child[j].region_id == data.region_id) {
            //             vm.fixedRouteList[i].child[j].view = true;
            //             vm.fixedRouteList[i].child[j].edit = true;
            //             vm.editFixedRouteGeofenceIndex = i;
            //         } else {
            //             vm.fixedRouteList[i].child[j].view = false;
            //             vm.fixedRouteList[i].child[j].edit = false;
            //         }
            //     }
            // }

            // WIP
            for (var i = 0; i < vm.fixedRouteList.length; i++) {
                if (vm.fixedRouteList[i].region_id == data.region_id) {
                    vm.fixedRouteList[i].view = true;
                    vm.fixedRouteList[i].edit = true;
                    vm.editFixedRouteGeofenceIndex = i;
                } else {
                    vm.fixedRouteList[i].view = false;
                    vm.fixedRouteList[i].edit = false;
                }
            }

            myCenter = new google.maps.LatLng(data.region_data[0][0].x, data.region_data[0][0].y);
            zoomLevel = 12;
            if (!vm.hideFilters) {
                mapInitialize(vm.fixedRouteList);
            } else {
                mapInitialize([vm.fixedRouteList[vm.editFixedRouteGeofenceIndex]]);
            }
        };

        function editFixedRouteGeofenceHit() {
            $log.log(vm.finalArrayCordinates);
            $log.log(vm.editName);
            $log.log(vm.editDescription);
            $log.log(vm.editID);
            $log.log(vm.editRegionData);
            $log.log(vm.isAirportService);

            if (!vm.finalArrayCordinates || !vm.finalArrayCordinates.length) {
                vm.finalArrayCordinates = [];
                for (var i = 0; i < vm.editRegionData[0].length; i++) {
                    vm.finalArrayCordinates.push(vm.editRegionData[0][i].x + ' ' + vm.editRegionData[0][i].y);
                }
            }
            $log.log(vm.finalArrayCordinates);
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.region_name = vm.editName.toUpperCase();
            dataSend.region_description = vm.editDescription;
            dataSend.region_data = vm.finalArrayCordinates;
            dataSend.region_id = vm.editID;
            dataSend.isAirportService = vm.isAirportService;
            dataSend.parent_id = vm.branchNameEdit;
            dataSend.child = true;
            $log.log(dataSend);
            vm.loading = true;
            var promise = getGeofence.editBranchList(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if(payload.title.status == 200){
                        var dataForSysLogs = {
                            access_token: $cookies.get('obj'),
                            id: vm.editID,
                            identity: 20, // 0- driver, 1- customer , 2 -car
                            message: 'Fixed route geofence details updated.'
                        };
                        $rootScope.systemLogsAdmin(dataForSysLogs);
                        languageBasedErrorFactory.getProperErrorMessage('fixedGeoEditSucc', 0, 1, 'layout.fixedRouteGeofenceMain.fixedRouteGeofenceList');
                    }else{
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    //errorMessageFactory.showErrorMessage('Fixed route geofence details updated successfully.',1);
                    //$timeout(function() {
                    //    $mdDialog.hide();
                    //    $state.reload();
                    //}, 2000);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //=====================to delete fixed route====================
        function deleteFixedRouteGeofence(id, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('fixedGeoEditPop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed', id);
                //errorMessageFactory.showErrorMessage('Functionality is pending',0);
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.region_id = id.region_id;
                dataSend.is_deleted = 1;
                dataSend.parent = id.parent_id == 0 ? 0 : 1;
                vm.loading = true;
                var promise = getGeofence.removeRegion(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        if(payload.title.status == 200){
                            var dataForSysLogs = {
                                access_token: $cookies.get('obj'),
                                id: id.region_id,
                                identity: 20, // 0- driver, 1- customer , 2 -car
                                message: 'Fixed route geofence deleted.'
                            };
                            $rootScope.systemLogsAdmin(dataForSysLogs);
                            languageBasedErrorFactory.getProperErrorMessage('fixedGeoDeleteSucc', 0, 1, 'layout.fixedRouteGeofenceMain.fixedRouteGeofenceList');
                        }else{
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                        //errorMessageFactory.showErrorMessage('Fixed route geofence deleted successfully.',1);
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        };
        //=====================to change status small geofence====================
        function changeFixedRegionStatus(id, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('fixedGeoStatusPop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed', id);
                //errorMessageFactory.showErrorMessage('Functionality is pending',0);
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.region_id = id.region_id;
                dataSend.parent = id.parent_id == 0 ? 0 : 1;
                dataSend.is_active = id.is_active == 0 ? 1 : 0;
                vm.loading = true;
                var promise = getGeofence.activeInactiveRegion(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        if(payload.title.status == 200){
                            var dataForSysLogs = {
                                access_token: $cookies.get('obj'),
                                id: id.region_id,
                                identity: 20, // 0- driver, 1- customer , 2 -car
                                message: 'Geofence status updated.'
                            };
                            $rootScope.systemLogsAdmin(dataForSysLogs);
                            languageBasedErrorFactory.getProperErrorMessage('fixedGeoStatusSucc', 0, 1, 'layout.fixedRouteGeofenceMain.fixedRouteGeofenceList');
                        }else{
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                        //errorMessageFactory.showErrorMessage('Geofence status updated successfully.',1);
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        };

        //=====================view fixed route geofence=====================
        function viewFixedRouteGeofence(data) {
            vm.viewFixedRouteGeofenceIndex;
            vm.addFixedRouteGeofenceFlag = false;
            vm.editFixedRouteGeofenceFlag = false;
            vm.viewFixedRouteGeofenceFlag = true;
            vm.viewFixedRouteName = data.region_name;
            vm.viewFixedRouteDescription = data.region_description;
            vm.viewFixedRouteID = data.region_id;
            vm.viewFixedRouteData = data.region_data;
            vm.viewAirportZone = data.isAirportService;
            vm.viewFixedRouteStatus = data.is_active;
            vm.viewFixedRouteParentID = data.parent_id;
            vm.viewFixedRouteParentName = data.branch_name;

            // for (var i = 0; i < vm.fixedRouteList.length; i++) {
            //     for (var j = 0; j < vm.fixedRouteList[i].child.length; j++) {
            //         if (vm.fixedRouteList[i].child[j].region_id == data.region_id) {
            //             vm.fixedRouteList[i].child[j].view = true;
            //             vm.fixedRouteList[i].child[j].edit = false;
            //             vm.viewFixedRouteGeofenceIndex = i;
            //         } else {
            //             vm.fixedRouteList[i].child[j].view = false;
            //             vm.fixedRouteList[i].child[j].edit = false;
            //         }
            //     }
            // }

            for (var i = 0; i < vm.fixedRouteList.length; i++) {
                if (vm.fixedRouteList[i].region_id == data.region_id) {
                    vm.fixedRouteList[i].view = true;
                    vm.fixedRouteList[i].edit = false;
                    vm.viewFixedRouteGeofenceIndex = i;
                } else {
                    vm.fixedRouteList[i].view = false;
                    vm.fixedRouteList[i].edit = false;
                }
            }

            myCenter = new google.maps.LatLng(data.region_data[0][0].x, data.region_data[0][0].y);
            zoomLevel = 12;
            if (!vm.hideFilters) {
                mapInitialize(vm.fixedRouteList);
            } else {
                mapInitialize([vm.fixedRouteList[vm.viewFixedRouteGeofenceIndex]]);
            }
        };
        //=======================go back========================
        function goBack() {
            // vm.addFixedRouteGeofenceFlag = true;
            // vm.editFixedRouteGeofenceFlag = false;
            // vm.viewFixedRouteGeofenceFlag = false;
            // for (var i = 0; i < vm.fixedRouteList.length; i++) {
            //     for (var j = 0; j < vm.fixedRouteList[i].child.length; j++) {
            //         vm.fixedRouteList[i].child[j].view = false;
            //     }
            // }
            // myCenter = new google.maps.LatLng(-33.447487, -70.673676);
            // zoomLevel = 8;
            // mapInitialize(vm.fixedRouteList);
            $state.reload();

        };

        // ============= TOGGLE MAP WHEN CLICK ON ADD NEW GEOFENCE =============
        function addNewGeoFence() {
            $("#showMap").slideDown("slow");
            vm.addNewGeoFenceToggle = true;
        }

        // =========== OPEN MULTIPLE GEOFENCE POPUP ===============
        function openMultipleGeofencePopup($event) {

            vm.items = {};
            $scope.branchListForPopupCount = 0;
            var parentEl = angular.element($document.body);

            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/selectMultipleGeofence.html',
                locals: {
                    items: $scope.branchListForPopup
                },
                bindToController: true,
                controller: DialogController
            });


            function DialogController($scope, $mdDialog, items) {
                $scope.items = $scope.branchListForPopup;
                $scope.regionIdArray = [];
                $scope.loading = false;
                $scope.activeGeoFence = 0;
                $scope.inactiveGeoFence = 0;
                $scope.showActiveOrInactiveGeofenceStatus = 1;
                $scope.searchStringVariable = '';
                vm.addFixedRouteGeofenceFlag = true;
                vm.editFixedRouteGeofenceFlag = false;
                vm.viewFixedRouteGeofenceFlag = false;
                $scope.isDesc = false;

                $scope.paginationChangedForMultipleGeofence = function () {
                    $scope.branchesForAddingForPopupoffset += 25;
                    if ($scope.branchesForAddingForPopupoffset < $scope.branchListForPopupCount) {
                        $scope.branchesForAddingForPopup($scope.showActiveOrInactiveGeofenceStatus, $scope.branchesForAddingForPopupoffset, $scope.searchStringVariable, $scope.sortStringVariable, $scope.isDescStatus);
                    }
                }

                $scope.getGeofenceRegionId = function (region_id) {
                    if ($scope.regionIdArray.indexOf(region_id) == -1) {
                        $scope.regionIdArray.push(region_id);
                    } else {
                        $scope.regionIdArray.splice($scope.regionIdArray.indexOf(region_id), 1);
                    }
                }

                $scope.showActiveOrInactiveGeofenceFunction = function (status) {
                    $scope.branchListForPopup = [];
                    $scope.branchesForAddingForPopupoffset = 0;
                    $scope.showActiveOrInactiveGeofenceStatus = status;
                    $scope.branchesForAddingForPopup($scope.showActiveOrInactiveGeofenceStatus, $scope.branchesForAddingForPopupoffset);
                }

                $scope.searchGeofenceFunction = function (string) {
                    $scope.searchStringVariable = string;
                    $scope.branchesForAddingForPopupoffset = 0;
                    $timeout.cancel($scope.yourTimer);
                    $scope.yourTimer = $timeout(function () {
                        $scope.loading = true;
                        $scope.branchListForPopup = [];
                        $scope.branchesForAddingForPopup($scope.showActiveOrInactiveGeofenceStatus, $scope.branchesForAddingForPopupoffset, string);
                    }, 1000);
                }

                $scope.sortByHead = function (sortString) {
                    $scope.loading = true;
                    $scope.sortStringVariable = sortString;
                    $scope.isDesc = !$scope.isDesc;
                    $scope.isDescStatus = $scope.isDesc == true ? 'DESC' : 'ASC';
                    $scope.branchListForPopup = [];
                    $scope.branchesForAddingForPopupoffset = 0;
                    $scope.branchesForAddingForPopup($scope.showActiveOrInactiveGeofenceStatus, $scope.branchesForAddingForPopupoffset, '', sortString, $scope.isDescStatus);
                }

                // ========== CLICK TO CLOSE DIALOG BOX ========= 
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };

                // ========== CLICK TO CLOSE DIALOG BOX AND CONFIRM RESPONSE ========= 
                $scope.confirmUpload = function (dataSend) {
                    $scope.stingRegionIdArray = "";
                    var regionIdArrayLength = $scope.regionIdArray.length;
                    for (var i = 0; i < regionIdArrayLength; i++) {
                        $scope.stingRegionIdArray += (i == 0) ? ($scope.regionIdArray[i]) : "," + ($scope.regionIdArray[i]);
                    }

                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.region_id = $scope.stingRegionIdArray;
                    $log.log(dataSend);
                    vm.loading = true;

                    var promise = getGeofence.getAllGeoFences(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log(payload);
                            vm.loading = false;
                            if (payload.title.data.length) {

                                var whereFixed = payload.title.data;

                                var where = _.where(payload.title.data, {
                                    parent_id: 0
                                });
                                //var where = _.where(where1,{is_active: 0});
                                //}

                                vm.allBranchList = where; //payload.title.data; //where;
                                for (var i = 0; i < vm.allBranchList.length; i++) {
                                    vm.allBranchList[i].index = i;
                                    vm.allBranchList[i].add = false;
                                    vm.allBranchList[i].edit = false;
                                    vm.allBranchList[i].strokeColor = '#f18903';
                                    vm.allBranchList[i].fillColor = 'transparent';
                                    vm.allBranchList[i].child = [];
                                }
                                if (whereFixed.length) {
                                    var newCombinationArray = vm.allBranchList;

                                    // comment code to hide geofences

                                    for (var i = 0; i < whereFixed.length; i++) {
                                        whereFixed[i].index = i;
                                        whereFixed[i].edit = false;
                                        whereFixed[i].view = false;
                                        whereFixed[i].strokeColor = '#063c4a';
                                        whereFixed[i].fillColor = '#063c4a';
                                        whereFixed[i].parent = {
                                            region_name: '',
                                            region_id: '',
                                            region_data: [],
                                            strokeColor: '#f18903',
                                            fillColor: 'transparent'
                                        };
                                        // whereFixed[i].region_data = whereFixed[i].region_data[0];

                                        // whereFixed[i].parent = {};
                                        whereFixed[i].parent.region_name = whereFixed[i].region_name;
                                        whereFixed[i].parent.region_id = whereFixed[i].region_id;
                                        whereFixed[i].parent.region_data = whereFixed[i].region_data;

                                        // for (var j = 0; j < vm.allBranchList.length; j++) {
                                        //     if (whereFixed[i].parent_id == vm.allBranchList[j].region_id) {
                                        //         whereFixed[i].parent.region_name = vm.allBranchList[j].region_name;
                                        //         whereFixed[i].parent.region_id = vm.allBranchList[j].region_id;
                                        //         whereFixed[i].parent.region_data = vm.allBranchList[j].region_data[0];
                                        //     }
                                        // }
                                        // for (var j = 0; j < newCombinationArray.length; j++) {
                                        //     if (whereFixed[i].parent_id == newCombinationArray[j].region_id) {
                                        //         newCombinationArray[j].child.push(whereFixed[i]);
                                        //     }
                                        // }
                                    }
                                    vm.tableFixedRouteList = whereFixed;
                                    vm.fixedRouteList = whereFixed; //newCombinationArray; //whereFixed
                                    // $log.log('whereFixed', newCombinationArray);
                                    myCenter = new google.maps.LatLng(vm.fixedRouteList[0].region_data[0][0].x, vm.fixedRouteList[0].region_data[0][0].y);
                                    mapInitialize(vm.fixedRouteList);
                                    vm.hideFilters = false;
                                } else {
                                    vm.fixedRouteList = [];
                                    vm.noDataFlag = true;
                                    mapInitialize(vm.fixedRouteList);
                                    vm.hideFilters = false;
                                }

                            } else {

                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );

                    $mdDialog.hide();
                };
                //====================branches for adding For Popup======================
                vm.branchesForAddingForPopupLimit = 25;
                $scope.branchesForAddingForPopupoffset = 0;
                $scope.branchListForPopup = [];
                $scope.branchListForPopupCount = 0;

                $scope.branchesForAddingForPopup = function (filter, offset, searchString, sortByString, sortByASCOrDESC) {
                    $scope.loading = true;
                    var promise = getGeofence.getAllBranchListForPopup(filter, vm.branchesForAddingForPopupLimit, offset, searchString, sortByString, sortByASCOrDESC);
                    promise.then(
                        function (payload) {
                            $log.log(payload);
                            $scope.loading = false;
                            if (payload.title.data.data.length) {
                                payload.title.data.data.forEach(function (region) {
                                    $scope.branchListForPopup.push(region);
                                });
                                $scope.branchListForPopupCount = payload.title.data.total_count;
                            } else {
                                $scope.branchListForPopupCount = payload.title.data.total_count;
                                $scope.branchListForPopup = [];
                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            $scope.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                };
                $scope.branchesForAddingForPopup(1, $scope.branchesForAddingForPopupoffset);
            }
        }

        // ================ FUNCTION TO SHOW MULTIPLE GEOFENCE SELECTION BUTTON IS DISABLE OR ENABLE ==================
        function checkboxToShowAllGeoFenceFunction(status) {
            vm.openMultipleGeofencePopupButtonDisable = status;
            if (vm.openMultipleGeofencePopupButtonDisable) {
                vm.addFixedRouteGeofenceFlag = true;
                vm.editFixedRouteGeofenceFlag = false;
                vm.viewFixedRouteGeofenceFlag = false;
                // getAllBranches(vm.mainShowActiveOrInactiveGeofenceStatus);
                vm.mainBranchesForAddingForPopupoffset = 0;
                vm.allBranchList = [];
                vm.tableFixedRouteList = [];
                vm.fixedRouteList = [];
                vm.getAllBranches(vm.mainShowActiveOrInactiveGeofenceStatus, vm.mainBranchesForAddingForPopupoffset);
                vm.hideFilters = true;
            }
        }

        // ================ REMOVE GEOFENCE FROM MAP WHEN ADDING A NEW ONE ==================
        function removeGeoFenceFromMap() {

            // Hide geofence when user view or edit existing geofence
            for (var i = 0; i < vm.bermudaTriangleArray.length; i++) {
                if (vm.bermudaTriangleArray[i].visible) {
                    vm.bermudaTriangleArray[i].visible = false;
                    infoWindow.close();
                    vm.bermudaTriangleArray[i].setMap(map);
                }
            }
            vm.finalArrayCordinates = [];

            // Hide geofence when user is creating New geofence
            if (all_overlays[0]) {
                all_overlays[0].overlay.setMap(null);
            }
            all_overlays = [];

            drawingManager.setOptions({
                drawingControl: true
            });
            drawingManager.setMap(map);
        }
    }
})();

/**
 * Created by cl-macmini-51 on 5/19/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('BranchListController', BranchListController);

    /** @ngInject */
    function BranchListController($cookies, checkDomain, $state, $log, $rootScope, $timeout, getCars, $scope, filterFilter, $mdDialog, $document, getGeofence, languageBasedErrorFactory, errorMessageFactory, Initializer) {
        var vm = this;
        $log.log('driver');
        var myCenter;
        var zoomLevel = 8;
        var all_overlays = [];
        vm.pickAddressFlag = false;
        var coordinates_array = [];
        vm.restrictSpaceBar = restrictSpaceBar;
        vm.addressChange = addressChange;
        vm.disabledEnter = disabledEnter;
        vm.editAirportAddressChange = editAirportAddressChange;
        vm.addAirportAddressChange = addAirportAddressChange;
        var markers = [];
        var mapProp = {};
        var drawingManager = '';
        var mc = null;
        var map = null;
        var icon = {};
        var bounds
        var geocoder;
        var infoWindow;
        var location = "";
        var currentId = 0;
        var laArray = [];
        var poly = '';
        var uniqueId = function () {
            return ++currentId;
        };

        // Service To Get Map Instance
        Initializer.mapsInitialized
            .then(function () {
                console.log('>>>> GOOGLE INIT', google);
                if (google) {
                    myCenter = new google.maps.LatLng(-33.447487, -70.673676);
                    bounds = new google.maps.LatLngBounds();
                    geocoder = new google.maps.Geocoder();
                    infoWindow = new google.maps.InfoWindow();
                } else {
                    alert(languageBasedErrorFactory.getProperErrorMessage('onRoadMessage', 0, '3'));
                }

            });
        vm.addressHave = '';
        vm.noDataFlag = false;
        vm.addBranchGeofenceFlag = true;
        vm.editBranchGeofenceFlag = false;
        vm.viewBranchGeofenceFlag = false;
        // document.getElementById("googleMap").style.height = window.innerHeight - 200 + 'px';

        vm.setMapOnAll = setMapOnAll;
        vm.drawingFunctions = drawingFunctions;
        vm.mapInitialize = mapInitialize;
        vm.latLongArrayList = latLongArrayList;
        vm.addBranchGeofenceHit = addBranchGeofenceHit;
        vm.editBranchGeofenceHit = editBranchGeofenceHit;
        vm.getAllBranches = getAllBranches;
        vm.editBranchGeofence = editBranchGeofence;
        vm.cancelEdit = cancelEdit;
        vm.deleteBranchGeofence = deleteBranchGeofence;
        vm.viewBranchGeofence = viewBranchGeofence;
        vm.changeRegionStatus = changeRegionStatus;
        vm.goBack = goBack;
        vm.onAddBranchClick = onAddBranchClick;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.filterData = {
            branchStatus: '1'
        };
        vm.showAddBranchForm = false;
        vm.showMap = false;
        //================set map nulll======================
        function setMapOnAll(map, id) {
            for (var i = 0; i < markers.length; i++) {
                var marker = markers[i];
                marker.setMap(map);
            }
        };
        // If the map position is out of range, move it back
        function checkBounds(map) {
            if (typeof (map.getBounds()) == 'undefined')
                return;

            var latNorth = map.getBounds().getNorthEast().lat();
            var latSouth = map.getBounds().getSouthWest().lat();
            var newLat;

            if (latNorth < 85 && latSouth > -85) /* in both side -> it's ok */
                return;
            else {
                if (latNorth > 85 && latSouth < -85) /* out both side -> it's ok */
                    return;
                else {
                    if (latNorth > 85)
                        newLat = map.getCenter().lat() - (latNorth - 85);
                    /* too north, centering */
                    if (latSouth < -85)
                        newLat = map.getCenter().lat() - (latSouth + 85);
                    /* too south, centering */
                }
            }
            if (newLat) {
                var newCenter = new google.maps.LatLng(newLat, map.getCenter().lng());
                map.setCenter(newCenter);
            }
        }

        // =========================== auto complete for add  airport //
        var domain = checkDomain.getDomainName();

        function addAirportAddressChange(data) {
            initAutocompleteAddAirport(data);
        }
        var autocompleteAddAirport;

        function initAutocompleteAddAirport(data) {
            if ((!vm.pickAddressFlag) && data && data.length >= 3) {
                vm.pickAddressFlag = true;
                autocompleteAddAirport = new google.maps.places.Autocomplete(
                    (document.getElementById('addAirportAddressId')), {
                        place_id: true
                    });
                if (domain != 'dev' && domain != 'test')
                    autocompleteAddAirport.setComponentRestrictions({
                        'country': ['CL']
                    });
                autocompleteAddAirport.addListener('place_changed', fillInAddressAddAirport);
            } else if (data && data.length < 3) {
                vm.pickAddressFlag = false;
                google.maps.event.clearInstanceListeners(addAirportAddressId);
                $(".pac-container").hide();
            }
        }

        function fillInAddressAddAirport() {
            var placeAdd = autocompleteAddAirport.getPlace();
            if (!placeAdd.place_id) {
                return;
            }
            geocoder.geocode({
                'placeId': placeAdd.place_id
            }, function (results, status) {
                if (status !== 'OK') {
                    window.alert('Geocoder failed due to: ' + status);
                    return;
                }
                var formattedAddress = results[0].formatted_address;
                vm.addAirportAddress = formattedAddress;
                vm.latForAddAirport = results[0].geometry.location.lat();
                vm.lngForAddAirport = results[0].geometry.location.lng();
            });
        }
        initAutocompleteAddAirport();
        // =========================== auto complete for add  airport //

        // =========================== auto complete for editv  airport //
        function editAirportAddressChange(data) {
            initAutocompleteEditAirport(data);
        }
        var autocompleteEditAirport;

        function initAutocompleteEditAirport(data) {
            if ((!vm.pickAddressFlag) && data && data.length >= 3) {
                vm.pickAddressFlag = true;
                autocompleteEditAirport = new google.maps.places.Autocomplete(
                    (document.getElementById('editAirportAddressId')), {
                        place_id: true
                    });
                if (domain != 'dev' && domain != 'test')
                    autocompleteEditAirport.setComponentRestrictions({
                        'country': ['CL']
                    });
                autocompleteEditAirport.addListener('place_changed', fillInAddressEditAirport);
            } else if (data && data.length < 3) {
                vm.pickAddressFlag = false;
                google.maps.event.clearInstanceListeners(editAirportAddressId);
                $(".pac-container").hide();
            }
        }

        function fillInAddressEditAirport() {
            var placeD = autocompleteEditAirport.getPlace();
            if (!placeD.place_id) {
                return;
            }
            geocoder.geocode({
                'placeId': placeD.place_id
            }, function (results, status) {
                if (status !== 'OK') {
                    window.alert('Geocoder failed due to: ' + status);
                    return;
                }
                var formattedAddress = results[0].formatted_address;
                vm.editAirportAddress = formattedAddress;
                vm.latForEditAirport = results[0].geometry.location.lat();
                vm.lngForEditAirport = results[0].geometry.location.lng();
            });
        }
        initAutocompleteEditAirport();
        // =========================== auto complete for editv  airport //
        //===========================auto complete===============================


        function addressChange(data) {
            initAutocomplete(data);
        }
        var autocomplete;

        function initAutocomplete(data) {
            if ((!vm.pickAddressFlag) && data && data.length >= 3) {
                vm.pickAddressFlag = true;
                autocomplete = new google.maps.places.Autocomplete(
                    (document.getElementById('addressGot')), {
                        placeIdOnly: true
                    });
                if (domain != 'dev' && domain != 'test')
                    autocomplete.setComponentRestrictions({
                        'country': ['CL']
                    });

                autocomplete.addListener('place_changed', fillInAddress);
            } else if (data && data.length < 3) {
                vm.pickAddressFlag = false;
                google.maps.event.clearInstanceListeners(addressGot);
                $(".pac-container").hide();
            }
        };

        function placeMarker(map, location) {
            if (markers.length > 1) {
                setMapOnAll(null);
            }
            var id = uniqueId();
            var marker = new google.maps.Marker({
                id: id,
                position: location,
                draggable: false,
                map: map
            });
            //bounds.extend(location);
            //map.fitBounds(bounds);
            markers.push(marker);
        };

        function fillInAddress() {
            // Get the place details from the autocomplete object.
            var place = autocomplete.getPlace();
            if (!place.place_id) {
                return;
            }
            geocoder.geocode({
                'placeId': place.place_id
            }, function (results, status) {
                if (status !== 'OK') {
                    window.alert('Geocoder failed due to: ' + status);
                    return;
                }
                var formattedAddress = results[0].formatted_address;
                vm.addressHave = formattedAddress;
                myCenter = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
                zoomLevel = 12;
                mapInitialize(vm.allBranchList);
                placeMarker(map, myCenter);
            });
        };
        initAutocomplete();
        //================map initialize===========================
        function polygonCenter(poly) {
            var lowx,
                highx,
                lowy,
                highy,
                center_x,
                center_y,
                lats = [],
                lngs = [],
                vertices = poly.getPath();

            for (var i = 0; i < vertices.length; i++) {
                lngs.push(vertices.getAt(i).lng());
                lats.push(vertices.getAt(i).lat());
            }

            lats.sort();
            lngs.sort();
            lowx = lats[0];
            highx = lats[vertices.length - 1];
            lowy = lngs[0];
            highy = lngs[vertices.length - 1];
            center_x = lowx + ((highx - lowx) / 2);
            center_y = lowy + ((highy - lowy) / 2);
            return (new google.maps.LatLng(center_x, center_y));
        }

        function drawingFunctions(map, data) {
            var triangleCoords = [];
            for (var i = 0; i < data.region_data.length; i++) {
                triangleCoords.push({
                    lat: data.region_data[i].x,
                    lng: data.region_data[i].y
                })
            }

            // Construct the polygon.
            var bermudaTriangle = new google.maps.Polygon({
                paths: triangleCoords,
                strokeColor: '#f18903',
                strokeOpacity: 1,
                strokeWeight: 2,
                fillColor: '#f18903',
                fillOpacity: 0.5
            });
            bermudaTriangle.content = '<div class="infoWindowContent">' +
                '<center><b>Branch</b></center>' +
                '<span> ' + data.region_name + '</span><br>'
            '</div>';

            if (data.edit) {
                bermudaTriangle.setOptions({
                    editable: true
                });
                drawingManager.setOptions({
                    drawingControl: false,
                    drawingMode: null
                });
            } else {
                bermudaTriangle.setOptions({
                    editable: false
                });
            }
            //var pos = new google.maps.LatLng(x,y);
            //var pos = polygonCenter(bermudaTriangle);
            //var mapLabel = new MapLabel({
            //    text: data.region_name,
            //    position: pos,
            //    map: map,
            //    fontSize: 20,
            //    align: 'center'
            //});
            //mapLabel.set('position', pos);


            //var marker = new MarkerWithLabel({
            //    position: pos,
            //    map: map,
            //    labelAnchor: new google.maps.Point(3, 30),
            //    labelClass: 'Sclass', // the CSS class for the label
            //    labelInBackground: false
            //});
            google.maps.event.addListener(bermudaTriangle.getPath(), 'insert_at', function () {
                var length = bermudaTriangle.getPath().getArray().length;
                coordinates_array = [];
                for (var i = 0; i < length; i++) {
                    var latlong = bermudaTriangle.getPath().getAt(i).lat() + " " + bermudaTriangle.getPath().getAt(i).lng();
                    coordinates_array.push(latlong)
                }
                latLongArrayList(coordinates_array, 'insert');
            });
            google.maps.event.addListener(bermudaTriangle.getPath(), 'set_at', function () {
                var length = bermudaTriangle.getPath().getArray().length;
                coordinates_array = [];
                for (var i = 0; i < length; i++) {
                    var latlong = bermudaTriangle.getPath().getAt(i).lat() + " " + bermudaTriangle.getPath().getAt(i).lng();
                    coordinates_array.push(latlong)
                }
                latLongArrayList(coordinates_array, 'insert');
            });
            if (data.view) {
                infoWindow.setContent(bermudaTriangle.content);
                infoWindow.setPosition(new google.maps.LatLng(data.region_data[0].x, data.region_data[0].y));
                infoWindow.open(map, bermudaTriangle);
            }

            if (data.edit) {
                $log.log('no click');
            } else {
                google.maps.event.addListener(bermudaTriangle, 'click', function (event) {
                    infoWindow.setContent(bermudaTriangle.content);
                    infoWindow.setPosition(event.latLng);
                    infoWindow.open(map, bermudaTriangle);
                });
                google.maps.event.addListener(bermudaTriangle, 'mouseover', function (event) {
                    infoWindow.setContent(bermudaTriangle.content);
                    infoWindow.setPosition(event.latLng);
                    infoWindow.open(map, bermudaTriangle);
                });
            }
            bermudaTriangle.setMap(map);
        };

        function mapInitialize(data) {
            mapProp = {
                center: myCenter,
                zoom: Number(zoomLevel),
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                minZoom: 3,
                //maxZoom: 15,
                scrollwheel: false
            };
            document.getElementById("googleMap").style.height = window.innerHeight - 200 + 'px';
            map = new google.maps.Map(document.getElementById("googleMap"), mapProp);
            google.maps.event.addListener(map, 'center_changed', function () {
                checkBounds(map);
            });
            drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: null, //google.maps.drawing.OverlayType.MARKER
                drawingControl: true,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: ['polygon'] //'marker', 'circle', 'polyline', 'rectangle'
                },
                //markerOptions: {icon: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png'},
                polygonOptions: {
                    fillColor: '#f18903',
                    fillOpacity: 0.5,
                    strokeWeight: 1,
                    clickable: false,
                    editable: true,
                    zIndex: 1
                }
            });
            drawingManager.setMap(map);
            google.maps.event.addListener(drawingManager, 'overlaycomplete', function (event) {
                var eventGot = event;

                var coordinates_array = [];
                if (event.type == 'polygon') {
                    all_overlays.push(event);
                    drawingManager.setOptions({
                        drawingControl: false,
                        drawingMode: null
                    });
                    //drawingManager.setDrawingMode(null);    //hiidng the drawing tool aftre completion of polygon
                    //var length = event.overlay.latLngs.je[0].je.length;
                    var length = event.overlay.getPath().getArray().length;
                    for (var i = 0; i < length; i++) {
                        var latlong = event.overlay.getPath().getArray()[i].lat() + " " + event.overlay.getPath().getArray()[i].lng();
                        coordinates_array.push(latlong)
                    }
                    latLongArrayList(coordinates_array);
                }
                google.maps.event.addListener(event.overlay.getPath(), 'insert_at', function () {
                    var length = event.overlay.getPath().i.length;
                    coordinates_array = [];
                    for (var i = 0; i < length; i++) {
                        var latlong = event.overlay.getPath().i[i].lat() + " " + event.overlay.getPath().i[i].lng();
                        coordinates_array.push(latlong)
                    }
                    latLongArrayList(coordinates_array, 'insert');
                });
                google.maps.event.addListener(event.overlay.getPath(), 'set_at', function () {
                    var length = event.overlay.getPath().i.length;
                    coordinates_array = [];
                    for (var i = 0; i < length; i++) {
                        var latlong = event.overlay.getPath().i[i].lat() + " " + event.overlay.getPath().i[i].lng();
                        coordinates_array.push(latlong)
                    }
                    latLongArrayList(coordinates_array, 'insert');
                });
            });
            if (data.length) {
                data.forEach(function (makeMap) {
                    drawingFunctions(map, makeMap);
                });
            } else {
                $log.log('no branch');
            }
        };

        function latLongArrayList(coordinates_array, type) {
            if (type == 'insert') {
                if (coordinates_array[0] === coordinates_array[coordinates_array.length - 1]) {
                    vm.finalArrayCordinates = coordinates_array;
                } else {
                    var newArray = coordinates_array;
                    newArray[newArray.length] = newArray[0];
                    vm.finalArrayCordinates = newArray;
                }
                $scope.$apply();
            } else {
                var str_coordinates = '';
                var arr_len = coordinates_array.length;

                var newArray = coordinates_array;
                newArray[newArray.length] = newArray[0];
                vm.finalArrayCordinates = newArray;
                //var new_arr = [];
                //for (var i = 0; i < arr_len; i++) {
                //    var val = coordinates_array[i].split(' ');
                //    var obj = {
                //        "lat": val[0],
                //        "lng": val[1]
                //    };
                //    str_coordinates += coordinates_array[i].toString() + ",";
                //    new_arr.push(obj);
                //}
                //str_coordinates += coordinates_array[0].toString() + ",";
                //str_coordinates = str_coordinates.slice(0, -1);
                //new_arr[new_arr.length] = {
                //    lat: new_arr[0].lat,
                //    lng: new_arr[0].lng
                //};
                $scope.$apply();
            }
        };


        //===========================get all branches==========================
        function getAllBranches(filter) {
            vm.loading = true;
            var promise = getGeofence.getAllBranchList(filter);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    console.log(payload, 'payload>>>>>>>>>>>>>>>>>>>>>');

                    if (payload.title.data.length) {
                        var where = _.where(payload.title.data, {
                            parent_id: 0
                        });
                        vm.allBranchList = where;
                        for (var i = 0; i < vm.allBranchList.length; i++) {
                            vm.allBranchList[i].index = i;
                            vm.allBranchList[i].edit = false;
                            vm.allBranchList[i].view = false;
                        }
                        mapInitialize(vm.allBranchList);
                    } else {
                        vm.allBranchList = [];
                        vm.noDataFlag = true;
                        mapInitialize(vm.allBranchList);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllBranches(vm.filterData.branchStatus);
        //=============================add branch geofence function hit=================================
        function addBranchGeofenceHit() {
            $log.log(vm.finalArrayCordinates);
            $log.log(vm.name);
            $log.log(vm.description);
            console.log(vm.finalArrayCordinates, 'vm.finalArrayCordinates');

            if (!vm.finalArrayCordinates || !vm.finalArrayCordinates.length) {
                //errorMessageFactory.showErrorMessage('Please select some region from map.');
                languageBasedErrorFactory.getProperErrorMessage('branchEditPop', 0, 0);
                return;
            }
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.region_name = vm.name.toUpperCase();
            dataSend.region_description = vm.description;
            dataSend.region_data = vm.finalArrayCordinates;
            dataSend.method_range_pickup = vm.routingName.value;
            dataSend.time_trip_shared_service = vm.sharedServiceTime;
            dataSend.minimal_time_to_shared_booking_to_airport = vm.dropOfTime;
            dataSend.pickup_tolerance_time_pap = parseInt(vm.PointToPointVariable);
            dataSend.tolerance_time = Number(vm.exclusiveTime);
            dataSend.travel_time = Number(vm.exclusiveTimeDropTime);
            dataSend.airport_address = vm.addAirportAddress;
            if(vm.addAirportAddress == ''){
                dataSend.airport_longitude = '';
                dataSend.airport_latitude = '';
            } else {
                dataSend.airport_longitude =  vm.lngForAddAirport;
                dataSend.airport_latitude =  vm.latForAddAirport;
            }
            dataSend.pickup_exclusive_grouped_tolerance_time = Number(vm.exclusiveTimeGroup);
            dataSend.pickup_exclusive_grouped_travel_time = Number(vm.exclusiveTimeDropTimeGroup);
            dataSend.pap_exclusive_grouped_tolerance_time = Number(vm.PointToPointVariableGroup);
            dataSend.pap_exclusive_grouped_travel_time = Number(vm.PointToPointVariableRangeGroup);
            vm.loading = true;
            var promise = getGeofence.branchGeofenceAdd(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        $state.reload('layout.branchMain.branchList');
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };


        //=======================edit button from table====================
        function editBranchGeofence(data) {
            $log.log(data);
            vm.editBranchGeofenceFlag = true;
            vm.addBranchGeofenceFlag = false;
            vm.viewBranchGeofenceFlag = false;
            vm.editName = data.region_name;
            vm.editDescription = data.region_description;
            vm.editSharedServiceTime = data.time_trip_shared_service;
            vm.editAirportAddress = data.airport_address;
            vm.latForEditAirport = data.airport_latitude;
            vm.lngForEditAirport = data.airport_longitude;
            vm.editdropOfTime = data.minimal_time_to_shared_booking_to_airport;
            vm.PointToPointVariable = data.pickup_tolerance_time_pap;
            vm.exclusiveTimeDropTime = data.travel_time_service_pick_up || 0;
            vm.exclusiveTime = data.tolerance_time_withdrawal_pickup;
            vm.exclusiveTimeGroup = data.pickup_exclusive_grouped_tolerance_time;
            vm.exclusiveTimeDropTimeGroup = data.pickup_exclusive_grouped_travel_time;
            vm.PointToPointVariableGroup = data.pap_exclusive_grouped_tolerance_time;
            vm.PointToPointVariableRangeGroup = data.pap_exclusive_grouped_travel_time;
            vm.editID = data.region_id;
            vm.editRegionData = data.region_data;
            for (var i = 0; i < vm.allBranchList.length; i++) {
                if (data.index == vm.allBranchList[i].index) {
                    vm.allBranchList[i].edit = true;
                } else {
                    vm.allBranchList[i].edit = false;
                }
            }
            if (data.method_name != null) {
                var dataObject = {};
                dataObject = {
                    name: data.method_name,
                    value: data.method_value
                }
                vm.routingName = dataObject;
            } else {
                RoutingApi();
            }
            myCenter = new google.maps.LatLng(data.region_data[0].x, data.region_data[0].y);
            zoomLevel = 12;
            mapInitialize(vm.allBranchList);
        };

        function cancelEdit() {
            $state.reload('layout.branchMain.branchList');
        }
        //======================================edit branch geofence function==========================
        function editBranchGeofenceHit() {
            $log.log(vm.finalArrayCordinates);
            $log.log(vm.editName);
            $log.log(vm.editDescription);
            $log.log(vm.editID);
            $log.log(vm.editRegionData);

            if (!vm.finalArrayCordinates || !vm.finalArrayCordinates.length) {
                vm.finalArrayCordinates = [];
                for (var i = 0; i < vm.editRegionData.length; i++) {
                    vm.finalArrayCordinates.push(vm.editRegionData[i].x + ' ' + vm.editRegionData[i].y);
                }
            }
            $log.log(vm.finalArrayCordinates);
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.region_name = vm.editName.toUpperCase();
            dataSend.region_description = vm.editDescription;
            dataSend.region_data = vm.finalArrayCordinates;
            dataSend.region_id = vm.editID;
            dataSend.method_range_pickup = vm.routingName.value;
            dataSend.time_trip_shared_service = vm.editSharedServiceTime;
            dataSend.minimal_time_to_shared_booking_to_airport = vm.editdropOfTime;
            dataSend.pickup_tolerance_time_pap = parseInt(vm.PointToPointVariable);
            dataSend.tolerance_time = Number(vm.exclusiveTime);
            dataSend.travel_time = Number(vm.exclusiveTimeDropTime);
            dataSend.airport_address = vm.editAirportAddress;
            if(vm.editAirportAddress == ''){
                dataSend.airport_longitude = '';
                dataSend.airport_latitude = '';
            } else {
                dataSend.airport_longitude = vm.lngForEditAirport;
                dataSend.airport_latitude = vm.latForEditAirport;
            }
            dataSend.pickup_exclusive_grouped_tolerance_time = Number(vm.exclusiveTimeGroup);
            dataSend.pickup_exclusive_grouped_travel_time = Number(vm.exclusiveTimeDropTimeGroup);
            dataSend.pap_exclusive_grouped_tolerance_time = Number(vm.PointToPointVariableGroup);
            dataSend.pap_exclusive_grouped_travel_time = Number(vm.PointToPointVariableRangeGroup);
            dataSend.child = false;
            vm.loading = true;
            var promise = getGeofence.editBranchList(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if(payload.title.status == 200){
                        var dataForSysLogs = {
                            access_token: $cookies.get('obj'),
                            id: vm.editID,
                            identity: 20, // 0- driver, 1- customer , 2 -car
                            message: 'Branch details updated.'
                        };
                        $rootScope.systemLogsAdmin(dataForSysLogs);
                        languageBasedErrorFactory.getProperErrorMessage('branchEditSucc', 0, 1, 'layout.branchMain.branchList');
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    //errorMessageFactory.showErrorMessage('Branch details updated successfully.',1);
                    //$timeout(function() {
                    //    $mdDialog.hide();
                    //    $state.reload();
                    //}, 2000);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //=====================to delete branch====================
        function deleteBranchGeofence(id, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('branchDeletePop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed', id);
                //errorMessageFactory.showErrorMessage('Functionality is pending',0);
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.region_id = id.region_id;
                dataSend.is_deleted = 1;
                dataSend.parent = id.parent_id == 0 ? 0 : 1;
                vm.loading = true;
                var promise = getGeofence.removeRegion(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        var dataForSysLogs = {
                            access_token: $cookies.get('obj'),
                            id: id.region_id,
                            identity: 20, // 0- driver, 1- customer , 2 -car
                            message: 'Branch deleted.'
                        };
                        $rootScope.systemLogsAdmin(dataForSysLogs);
                        languageBasedErrorFactory.getProperErrorMessage('branchDeleteSucc', 0, 1, 'layout.branchMain.branchList');
                        //errorMessageFactory.showErrorMessage('Branch deleted successfully.',1);
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        };
        //=====================to change status branch====================
        function changeRegionStatus(id, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('branchStatusPop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed', id);
                //errorMessageFactory.showErrorMessage('Functionality is pending',0);
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.region_id = id.region_id;
                dataSend.parent = id.parent_id == 0 ? 0 : 1;
                dataSend.is_active = id.is_active == 0 ? 1 : 0;
                vm.loading = true;
                var promise = getGeofence.activeInactiveRegion(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        var dataForSysLogs = {
                            access_token: $cookies.get('obj'),
                            id: id.region_id,
                            identity: 20, // 0- driver, 1- customer , 2 -car
                            message: 'Branch status updated.'
                        };
                        $rootScope.systemLogsAdmin(dataForSysLogs);
                        languageBasedErrorFactory.getProperErrorMessage('branchStatusSucc', 0, 1, 'layout.branchMain.branchList');
                        //errorMessageFactory.showErrorMessage('Branch status changed successfully.',1);
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        };
        //=========================view branch details==========================
        function viewBranchGeofence(data) {
            console.log(data, 'viewAirportZone');
            vm.editBranchGeofenceFlag = false;
            vm.addBranchGeofenceFlag = false;
            vm.viewBranchGeofenceFlag = true;
            vm.viewBranchName = data.region_name;
            vm.viewAirportZone = data.airport_address;
            vm.viewBranchDescription = data.region_description;
            vm.viewBranchID = data.region_id;
            vm.viewBranchData = data.region_data;
            vm.viewBranchStatus = data.is_active;
            vm.viewBranchParentID = data.parent_id;
            vm.viewSharedServiceTime = data.time_trip_shared_service;
            vm.MethodRoutingName = data.method_name;
            vm.minimal_time_to_shared_booking_to_airport = data.minimal_time_to_shared_booking_to_airport;
            vm.PointToPointVariable = data.pickup_tolerance_time_pap;
            vm.exclusiveTimeDropTime = data.travel_time_service_pick_up || 0;
            vm.exclusiveTime = data.tolerance_time_withdrawal_pickup;
            vm.exclusiveTimeGroup = data.pickup_exclusive_grouped_tolerance_time;
            vm.exclusiveTimeDropTimeGroup = data.pickup_exclusive_grouped_travel_time;
            vm.PointToPointVariableGroup = data.pap_exclusive_grouped_tolerance_time;
            vm.PointToPointVariableRangeGroup = data.pap_exclusive_grouped_travel_time;
            for (var i = 0; i < vm.allBranchList.length; i++) {
                if (data.index == vm.allBranchList[i].index) {
                    vm.allBranchList[i].view = true;
                } else {
                    vm.allBranchList[i].view = false;
                }
            }
            myCenter = new google.maps.LatLng(data.region_data[0].x, data.region_data[0].y);
            zoomLevel = 9;
            mapInitialize(vm.allBranchList);
            // RoutingApi();
        };

        //======================go back=========================
        function goBack() {
            vm.editBranchGeofenceFlag = false;
            vm.addBranchGeofenceFlag = true;
            vm.viewBranchGeofenceFlag = false;
            for (var i = 0; i < vm.allBranchList.length; i++) {
                vm.allBranchList[i].view = false;
            }
            myCenter = new google.maps.LatLng(-33.447487, -70.673676);
            zoomLevel = 8;
            mapInitialize(vm.allBranchList);
        }

        function onAddBranchClick() {
            vm.showAddBranchForm = true;
            vm.showMap = true;
            vm.addBranchGeofenceFlag = true;
            vm.editBranchGeofenceFlag = false;
            vm.viewBranchGeofenceFlag = false;
            vm.PointToPointVariable = '';
            vm.exclusiveTimeDropTime = '';
            vm.exclusiveTime = '';
        }

        function RoutingApi() {
            // vm.loading = true;
            var promise = getGeofence.getRoutingApi();
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    console.log(payload, "payload");
                    if (payload.title.status == 200) {
                        if (payload && payload.title && payload.title.data.length > 0) {
                            vm.routing = payload.title.data[0];
                            vm.routingName = payload.title.data[0][0];
                            // console.log(vm.routingName,'vm.routingName');
                        }
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    //errorMessageFactory.showErrorMessage('Branch status changed successfully.',1);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        RoutingApi();
        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.branchMain.branchList');
            }
        });
         
        function disabledEnter(event){
           if(event.keyCode == 13){
            event.preventDefault();
           }
        }

        function restrictSpaceBar(event){
            console.log(event.keyCode ,'event.keyCode ');
            
            if(event.keyCode == 32){
                event.preventDefault();
            }
        }
    }
})();

/**
 * Created by cl-macmini-51 on 09/11/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('OperationalReportController', OperationalReportController);

    /** @ngInject */
    function OperationalReportController($cookies, $state, $log, $rootScope, $mdDialog, $timeout, $document, getCorporate, $scope, filterFilter, $stateParams, languageBasedErrorFactory, generatePaymentStatus, getAgreement, errorMessageFactory, getFilters) {
        var vm = this;
        vm.loading = false;
        vm.selectAllFlag = false;
        vm.flagToDisable = false;
        vm.agreementChanged = agreementChanged;
        vm.dataToFill = {
            corporate: 'all',
            aggrement: [],
            addInactive: false,
            from: moment(new Date()).subtract(7, 'day')._d,
            untill: new Date(),
            timeOptionsFrom: new Date(new Date().setHours(0, 0, 0, 0)),
            timeOptionsUntil: new Date(new Date().setHours(23, 59, 0, 0)),
        };
        vm.dateDiff = moment(vm.dataToFill.from).add(7, 'day')._d

        vm.dateOptionsFrom = {};
        vm.dateOptionsUntill = {};
        vm.datePicker_1 = {
            from: false,
            untill: false
        };
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.altInputFormats = ['M!/d!/yyyy'];
        vm.datePickerE_1 = datePickerE_1;
        vm.corporateChange = corporateChange;
        vm.addInactiveAgrrement = addInactiveAgrrement;
        vm.fromDateChange = fromDateChange;
        vm.untillDateChange = untillDateChange;
        vm.selectAll = selectAll;
        vm.add_inactive = 0;
        vm.generateOperationalReport = generateOperationalReport;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();

        //==================date picker function==================
        vm.dateOptionsFrom = {

            //dateDisabled: disabled,
            formatYear: 'yy',
            // maxDate: new Date(),
            // minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };
        vm.dateOptionsUntill = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            // maxDate: new Date(),
            // minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };

        vm.hstep = 1;
        vm.mstep = 15;
        vm.ismeridian = true;

        vm.agreementSearch = agreementSearch;
        vm.corporateSearch = corporateSearch;
        vm.agreementOffset = 0;
        vm.corporateOffset = 0;
        vm.agreetmentStatus = 1;
        vm.globalLimit = 10;
        vm.globalOffset = 10;
        vm.paginationChangedForAgreement = paginationChangedForAgreement;
        vm.paginationChangedForCorporation = paginationChangedForCorporation;
        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'vehicle', 'service', 'agreement', 'corporatesList', 'operation_point'];
        vm.agreement = [];
        vm.corporatesList = [];
        vm.corporatesList.push({
            company_name: 'All',
            id: 'all'
        });
        vm.filterObject = {
            access_token: $cookies.get('obj'),
            branch_filter: 0,
            vehicle_filter: 0,
            service_filter: 0,
            agreement_filter: 1,
            corporate_filter: 1,
            service_category: 0,
            corporate_status: 2,
            agreement_status: vm.agreetmentStatus,
            vehicle__status: 0,
            operation_point_filter: 0,
            branch_limit: 0,
            branch_offset: 0,
            corporate_limit: vm.globalLimit,
            corporate_offset: vm.corporateOffset,
            agreement_limit: vm.globalLimit,
            agreement_offset: vm.agreementOffset,
            branch_search_filter: 0,
            vehicle_search_filter: 0,
            service_search_filter: 0,
            agreement_search_filter: 0,
            corporate_search_filter: 0,
            operation_point_search_filter: 0
        }


        setTimeout(function () {
            document.getElementsByClassName('ui-select-search')[1].addEventListener('blur', function ($event) {
                // if (vm.agreement && (vm.agreement.length == 0)) {
                vm.searchAgreementData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });


            document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                // if (vm.corporatesList && (vm.corporatesList.length == 0)) {
                vm.searchCorporateData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

        })
        // =================== GET FILTER DATA ===================
        function getFilterDataFromBackend(data, type) { //Acc to Index ['branch_search', 'vehicle_search', 'service_search', 'agreement_search', 'corporate_search', 'operation_point_search']
            if (data) {
                vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
            } else {
                vm.filterObject = {
                    access_token: $cookies.get('obj'),
                    branch_filter: 0,
                    vehicle_filter: 0,
                    service_filter: 0,
                    agreement_filter: 1,
                    corporate_filter: 1,
                    service_category: 0,
                    corporate_status: 2,
                    agreement_status: vm.agreetmentStatus,
                    vehicle__status: 0,
                    operation_point_filter: 0,
                    branch_search_filter: 0,
                    vehicle_search_filter: 0,
                    service_search_filter: 0,
                    agreement_search_filter: 0,
                    corporate_search_filter: 0,
                    operation_point_search_filter: 0
                }
            }
            vm.filterObject.agreement_limit = vm.globalLimit;
            vm.filterObject.agreement_offset = vm.agreementOffset;
            vm.filterObject.corporate_limit = vm.globalLimit;
            vm.filterObject.corporate_offset = vm.corporateOffset;

            var promise = getFilters.getAllFilterData(vm.filterObject);
            promise.then(
                function (payload) {

                    // *********** AGREEMENT DATA *********
                    if (payload.title.data.agreements) {
                        angular.forEach(payload.title.data.agreements.data, function (column) {
                            //CHECK FOR DUPLICATE ENTRY
                            var agreementIndex = _.findIndex(vm.agreement, {
                                id: column.id
                            });
                            if (agreementIndex == -1)
                                vm.agreement.push({
                                    id: column.id,
                                    name: column.name
                                });
                        });
                        vm.agreementTotalBackendCount = payload.title.data.agreements.totalCount;
                    }


                    // ********** CORPORATE DATA ********
                    if (payload.title.data.corporates) {
                        // angular.forEach(payload.title.data.corporates.data, function (column) {
                        //     vm.corporatesList.push(column)
                        // });
                        // vm.corporateTotalBackendCount = payload.title.data.corporates.totalCount;
                        var index = _.findIndex(vm.corporatesList, {
                            id: 'all'
                        });
                        if (index == -1)
                            vm.corporatesList.push({
                                company_name: 'All',
                                id: 'all'
                            });
                        angular.forEach(payload.title.data.corporates.data, function (column) {
                            //CHECK FOR DUPLICATE ENTRY
                            var corporateIndex = _.findIndex(vm.corporatesList, {
                                id: column.id
                            });
                            if (corporateIndex == -1)
                                vm.corporatesList.push(column)
                        });
                        vm.corporateTotalBackendCount = payload.title.data.corporates.totalCount;
                    }

                    vm.loading = false;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        }
        getFilterDataFromBackend();


        // ************ PAGINATION ON AGREEMENT **************
        function paginationChangedForAgreement() {
            if (vm.agreementTotalBackendCount > (vm.agreement.length)) {
                commonFunction(3);
                vm.agreementOffset += vm.globalOffset;
                // vm.corporatesList  = [];
                vm.corporateOffset = 0;
                getFilterDataFromBackend(vm.searchAgreementData, 3);
            }
        }


        // ************ PAGINATION ON CORPORATE **************
        function paginationChangedForCorporation() {
            var index = _.findIndex(vm[vm.searchFilterArray[4]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.corporateTotalBackendCount > (vm.corporatesList.length - index)) {
                commonFunction(4);
                //  vm.agreement = [];
                //  vm.agreementOffset = 0;
                vm.corporateOffset += vm.globalOffset;
                getFilterDataFromBackend(vm.searchCorporateData, 4);
            }
        }
        // *********** COMMON FUNCTION FOR FILTER PAGINATION AND SEARCHING ***********
        function commonFunction(type, mode) {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                if (mode == 'search' || i != type) {
                    vm[vm.searchFilterArrayForClearArray[i]] = [];
                    // vm[vm.searchFilterArrayForClearArray[i]].push({
                    //     id: 'all',
                    //     name: 'All'
                    // });
                    vm[vm.searchFilterArray[i] + 'Offset'] = 0;
                    vm['search' + vm.searchFilterArray[i].substring(0, 1).toUpperCase() + vm.searchFilterArray[i].substring(1) + 'Data'] = '';
                }
            }
        }

        // ******** CLEAR OFFSET *******
        function clearOffset() {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                vm[vm.searchFilterArray[i] + 'Offset'] = 0;
            }
        }

        function agreementChanged() {
            vm.selectAllFlag = false;
            if (vm.agreement.length == 0) {
                vm.agreement = [];
                vm.corporatesList = [];
                clearOffset();
                getFilterDataFromBackend();
            }
        }

        // ************ SEARCH SERVICE ***************
        function corporateSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchCorporateData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(4, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 4);
                }, 2000);
            }
        }



        // ************ SEARCH AGREEMENT ***************
        function agreementSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchAgreementData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(3, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 3);
                }, 2000);
            }
        }

        //====================from date change=======================
        function fromDateChange() {

            vm.fromDate = moment(vm.dataToFill.from).format('YYYY-MM-DD')
            vm.daysAdd = moment(vm.fromDate, "YYYY-MM-DD").add('days', 7)._d;
            //vm.dateOptionsUntill.maxDate = vm.daysAdd;
            //vm.dataToFill.untill = vm.daysAdd;
            //vm.dateOptionsUntill.minDate = vm.dataToFill.from;
            if ((new Date(vm.dataToFill.untill).getDate() > new Date(vm.daysAdd).getDate()) || (new Date(vm.dataToFill.untill).getMonth() > new Date(vm.daysAdd).getMonth()) || (new Date(vm.dataToFill.untill).getFullYear() > new Date(vm.daysAdd).getFullYear())) {
                errorMessageFactory.showErrorMessage('La diferencia excede más de 7 días.', 0);
                vm.dataToFill.from = '';
            }
        }


        //====================untill date change=======================
        function untillDateChange() {
            vm.untillDate = moment(vm.dataToFill.untill).format('YYYY-MM-DD');
            vm.daysSubt = moment(vm.untillDate, "YYYY-MM-DD").subtract('days', 7)._d;
            vm.dateOptionsFrom.maxDate = vm.daysAdd;
            vm.dataToFill.from = vm.daysSubt

            vm.dateOptionsFrom.maxDate = vm.dataToFill.untill;
        }


        function datePickerE_1(type) {
            if (type == '1') {
                vm.datePicker_1.from = true;
                vm.datePicker_1.untill = false;
            } else if (type == '2') {
                vm.datePicker_1.untill = true;
                vm.datePicker_1.from = false;
            }
        };
        // //==============get all corporate=================
        // function  getAllCorporate(){
        //     vm.loading = true;
        //     var dataSend = {};
        //     dataSend.access_token = $cookies.get('obj');
        //     dataSend.limit = 0;
        //     dataSend.offset = 0;
        //     dataSend.key = 2;
        //     dataSend.search_filter = 0;
        //     var promise = getCorporate.allCorporates(dataSend);
        //     promise.then(
        //         function(payload) {
        //             $log.log('sxdsads', payload);
        //             vm.loading = false;
        //             //vm.corporatesList = _.where(payload.title.data.result,{status:1});
        //             vm.corporatesList = payload.title.data.result;
        //             vm.corporatesList.push({
        //                 company_name: 'All',
        //                 id: 'all'
        //             });
        //         },
        //         function(errorPayload) {
        //             vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
        //             }
        //         }
        //     );
        // };
        // getAllCorporate();

        // //======================get all agreements==============
        // function getAllAgreement(skip, limt) {
        //     var dataSend = {};
        //     dataSend.access_token = $cookies.get('obj');
        //     dataSend.offset = skip;
        //     dataSend.limit = limt;
        //     dataSend.key = 3;
        //     vm.loading = true;
        //     var promise = getAgreement.getAgreementListLessData(dataSend);
        //     promise.then(
        //         function(payload) {
        //             $log.log('sxdsads', payload);
        //             vm.loading = false;
        //             if(payload.title.status == 400){
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //             }
        //             else if(payload.title.status == 401){
        //                 errorMessageFactory.showErrorMessage(payload.title.message,2,'home');
        //             }
        //             else if(payload.title.status == 201 || payload.title.status == 200) {
        //                 vm.agreement = [];

        //                 angular.forEach(payload.title.data, function (column) {
        //                     if (vm.dataToFill.corporate == 'all') {
        //                         if (column.status == 1 && vm.dataToFill.addInactive == false) {
        //                             vm.agreement.push({id: column.id, name: column.name});
        //                         }
        //                         else if (vm.dataToFill.addInactive) {
        //                             vm.agreement.push({id: column.id, name: column.name});
        //                         }
        //                     }
        //                     else {
        //                         if (column.status == 1 && vm.dataToFill.addInactive == false && column.corporate_id == vm.dataToFill.corporate) {
        //                             vm.agreement.push({id: column.id, name: column.name});
        //                         }
        //                         else if (vm.dataToFill.addInactive && column.corporate_id == vm.dataToFill.corporate) {
        //                             vm.agreement.push({id: column.id, name: column.name});
        //                         }
        //                     }
        //                 });
        //             }
        //             //vm.agreement.push({
        //             //    id:'all',
        //             //    name:'All'
        //             //});
        //         },
        //         function(errorPayload) {
        //             $log.log(errorPayload);
        //             vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // };
        // getAllAgreement(0, 0);


        //===========================corporate change===========================
        function corporateChange() {
            vm.dataToFill.aggrement = [];
            vm.agreement = [];
            vm.corporatesList = [];
            clearOffset();
            getFilterDataFromBackend();
            // if(vm.dataToFill.corporate != 'all'){
            //     getAllAgreement(0, 0);
            // }
            // else{
            //     getAllAgreement(0, 0);
            // }
        }

        //====================add inactive agreements==============
        function addInactiveAgrrement() {
            if (vm.dataToFill.addInactive == false) {
                vm.agreetmentStatus = 2;
                vm.add_inactive = 1;
                getFilterDataFromBackend();
            } else {
                vm.agreetmentStatus = 1;
                vm.add_inactive = 0;
                getFilterDataFromBackend();
            }
        }


        function selectAll() {
            // vm.selectAllFlag = !vm.selectAllFlag;
            // vm.selectAllFlag = true;
            vm.dataToFill.aggrement = '';
            if (vm.selectAllFlag == false) {
                vm.flagToDisable = true;
                //     vm.agreement.push({
                //        id:'all',
                //        name:'All'
                //     });
                // vm.dataToFill.aggrement = 'all';
            } else {
                vm.flagToDisable = false;
                // var index = _.findIndex(vm.agreement, {
                //     id: 'all'
                // });
                // if(index != -1)
                // vm.agreement.splice(index, 1);
                // vm.dataToFill.aggrement = '';`
            }

        }





        //============================create csv===============================
        // function createCSV(data){
        //     var dataArray = [];
        //     data.forEach(function(column){
        //         var d = {};
        //         d['Número Reserva'] = column.job_id;
        //         d['Tipo de Viaje'] = column.type_of_trip;
        //         d['Fecha Creación Reserva'] = moment(column.creation_datetime).format('DD-MM-YYYY HH:mm');
        //         d['Tipo de Servicio solicitado'] = column.type_of_service; //name pending;
        //         d['Sucursal'] = column.branch; //branch name pending;
        //         d['Fecha y Hora Retiro'] = moment(column.job_time_utc).format('DD-MM-YYYY HH:mm'); //correct time pending
        //         d['Nombre Pasajero'] = column.customer_username;
        //         d['Telefono Pasajero'] = column.customer_phone;
        //         d['Correo del pasajero'] = column.job_pickup_email;
        //         d['Pasajero VIP (Si/No)'] = column.is_vip == 0?'No':'Si';
        //         d['Id del Solicitante'] = column.created_by;
        //         d['Nombre Solicitante'] = column.job_pickup_name;
        //         d['Telefono Solicitante'] = column.job_pickup_phone;
        //         d['Correo Solicitante'] = column.customer_email;
        //         d['Perfil del Solicitante'] = column.creator_profile == 0? 'Personal': 'Business';
        //         d['Direccion Retiro'] = column.job_pickup_address;
        //         d['Referencia a direccion de retiro'] = column.reference_point;
        //         d['Latitud Direccion Retiro'] = column.job_pickup_latitude;
        //         d['Longitud Direccion Retiro'] = column.job_pickup_longitude;
        //         d['Direccion Destino Solicitada'] = column.job_address;
        //         d['Latitud Direccion Destino Solicitada'] = column.job_latitude;
        //         d['Longitud Direccion Destino solicitada'] = column.job_longitude;
        //         d['Direccion Destino Real'] = column.actual_job_address;
        //         d['Latitud Direccion Destino Real'] = column.actual_job_latitude;
        //         d['Longitud Direccion Destino Real'] = column.actual_job_longitude;
        //         d['Numero Movil'] = column.fleet_id;
        //         d['ETA a Direccion de Destino'] = column.eta;
        //         d['Placa Patente del Mobil'] = column.transport_details;
        //         d['Tipo de vehiculo asignado'] = column.transport_type_id; //need name
        //         d['Nombre conductor'] = column.driver_name; //pending
        //         d['Numero Pasajeros Reserva'] = column.number_of_passangers;
        //         d['Observaciones del Viaje'] = column.observations?column.observations.replace(/(\r\n|\n|\r)/gm," "):"";
        //         d['Reserva para un Tercero (si/no)'] = column.booking_for == 0?'Si':'No';
        //         d['Calificacion dada por Cliente'] = column.fleet_rating;
        //         d['Comentarios dados por Cliente'] = column.fleet_comment;
        //         d['Conductor califico a cliente (si/no)'] = column.is_customer_rated == 0?'No':'Si';
        //         d['Calificacion dada por Conductor'] = column.customer_rating;
        //         d['Comentarios dados por Conductor'] = column.customer_comment;
        //         d['Fecha y Hora Evento Asignacion'] = column.accepted_datetime == '0000-00-00 00:00:00'?'0000-00-00 00:00:00':moment(column.accepted_datetime).format('DD-MM-YYYY HH:mm');
        //         d['Direccion Evento Asignacion'] = column.accepted_address;
        //         d['Latitud Evento asignacion'] = column.accepted_latitude;
        //         d['Longitud Evento asignacion'] = column.accepted_longitude;
        //         d['Fecha y Hora Evento en Camino'] = column.on_road_datetime == '0000-00-00 00:00:00'?'0000-00-00 00:00:00':moment(column.on_road_datetime).format('DD-MM-YYYY HH:mm');
        //         d['Direccion Evento En camino'] = column.on_road_address;
        //         d['Latitud Evento En Camino'] = column.on_road_latitude;
        //         d['Longitud Evento en Camino'] = column.on_road_longitude;
        //         d['Fecha y Hora Evento en Posicion'] = column.arrived_datetime == '0000-00-00 00:00:00'?'0000-00-00 00:00:00':moment(column.arrived_datetime).format('DD-MM-YYYY HH:mm');
        //         d['Direccion Evento En Posicion'] = column.arrived_address;
        //         d['Latitud Evento en posicion'] = column.arrived_latitude;
        //         d['Longitud Evento en posicion'] = column.arrived_longitude;
        //         d['Fecha y Hora Inicio Viaje'] = column.started_datetime == '0000-00-00 00:00:00'?'0000-00-00 00:00:00':moment(column.started_datetime).format('DD-MM-YYYY HH:mm');
        //         d['Direccion Viaje Iniciado'] = column.started_address;
        //         d['Latitud Inicio viaje'] = column.started_latitude;
        //         d['Longitud Inicio Viaje'] = column.started_longitude;
        //         d['Fecha y Hora Viaje Terminado'] = column.completed_datetime == '0000-00-00 00:00:00'?'0000-00-00 00:00:00':moment(column.completed_datetime).format('DD-MM-YYYY HH:mm');
        //         d['Direccion Viaje Terminado'] = column.completed_address;
        //         d['Latitud Viaje Terminado'] = column.completed_latitude;
        //         d['Longitud Viaje Terminado'] = column.completed_longitude;
        //         d['Distancia Total Viaje'] = column.total_distance_travelled;
        //         d['Tiempo Total de Viaje'] = column.total_time_travelled;
        //         d['Tiempo Espera Inicial'] = column.total_wait_time;
        //         d['Tiempo de Espera Total'] = column.wait_time;
        //         d['Metodo de Pago'] = column.payment_method; //name pending
        //         d['Tipo de Ruta usada (Fija/Variable)'] = column.route_type == 1?'Fija':'Variable';
        //         d['Nombre de ruta usada (Ruta Fija)'] = column.route_name;
        //         d['Id Name of Fixed route'] = column.route_id;
        //         d['Tipo de Tarifa usada (Fija/Variable)'] = column.type_of_agreement == 0?'Fija':'Variable';
        //         d['Monto Total Reserva'] = column.payment_amount;
        //         d['Total Reserva'] = column.ride_charges;
        //         d['Ingresos Transvip'] = column.transvip_fare;
        //         d['Ingreso Conductor'] = column.service_cost;
        //         d['Porcentaje produccion'] = column.percentage_driver_earning;
        //         d['Tarifa Base'] = column.base_fare;
        //         d['Tarifa por kilometro'] = column.fare_by_kilometer;
        //         d['Tarifa tiempo espera inicial'] = column.item_fare_by_waiting_initial_time;
        //         d['Tarifa tiempo espera'] = column.item_fare_by_waiting_time;
        //         d['Tarifa minima'] = column.item_minimal_fare;
        //         d['Valor Total kilometros'] = column.total_value_kilometers;
        //         d['Total Item adicionales'] = column.item_of_charge_amount;
        //         d['Empresa'] = column.company_name;
        //         d['ID Cuenta Corporativa Reserva'] = column.corporate_account_id;
        //         d['ID Convenio usado para la reserva'] = column.contract_id;
        //         d['Nombre Convenio usado para la reserva'] = column.agreement_name;
        //         d['Reserva recurrente (Si/No)'] = column.reaccuring_ride == 0 ? 'No': 'Si';
        //         d['Reserva de Minuto/Programada'] = column.schedule_ride == 0 ? 'Minuto':'Programada';
        //         d['Reserva Ida Vuelta (Si/no)'] = column.is_round_trip == 0? 'No':'Si';
        //         d['Reserva Ida Vuelta con tiempo espera (Si/no)'] = column.is_wait_time_included == 0 ? 'No':'Si';
        //         d['Fehcha y Hora reserva ida Vuelta'] = column.return_date_time == '0000-00-00 00:00:00'?'0000-00-00 00:00:00':moment(column.return_date_time).format('DD-MM-YYYY HH:mm');
        //         d['Id Reserva vinculada Ida Vuelta'] = column.round_trip_parent_job_id;
        //         d['Reserva Aeropuerto (si/no)'] = column.isAirportService == 0 ?'No':'Si';
        //         d['Fecha/Hora No-Show'] = column.no_show_datetime == '0000-00-00 00:00:00'?'0000-00-00 00:00:00':moment(column.no_show_datetime).format('DD-MM-YYYY HH:mm');
        //         d['Motivo No-Show'] = column.noshow_reason;
        //         d['Comentarios No-Show'] = column.noshow_comment;
        //         d['ID Usuario marco No-Show'] = column.noshow_identity;
        //         d['Usuario Anulación'] = column.cancellation_identity?column.cancellation_identity:'--';
        //         d['Fecha / Hora Anulación'] = column.cancellation_datetime == '0000-00-00 00:00:00'?'0000-00-00 00:00:00':moment(column.cancellation_datetime).format('DD-MM-YYYY HH:mm');
        //         d['Motivo Anulación'] = column.cancellation_reason?column.cancellation_reason:'--';
        //         d['Reserva requiere autorizacion (si/no)'] = column.auth_required == 0? 'No':'Si';
        //         d['Nombre autorizador'] = column.authorizer_name;
        //         d['Rut del Autorizador'] = column.auth_of;
        //         if(column.is_auth == 0){
        //             d['Estado Autorizacion'] = 'Pending';
        //         }
        //         else if(column.is_auth == 1){
        //             d['Estado Autorizacion'] = 'Authorized';
        //         }
        //         else if(column.is_auth == 2){
        //             d['Estado Autorizacion'] = 'Rejected';
        //         }
        //         else if(column.is_auth == 3){
        //             d['Estado Autorizacion'] = 'Cancelled By Customer';
        //         }
        //         d['Fecha y Hora Autorizacion'] = column.auth_timing == '0000-00-00 00:00:00'?'0000-00-00 00:00:00':moment(column.auth_timing).format('DD-MM-YYYY HH:mm');
        //         d['Reserva Retarificada (si/no)'] = column.is_adjusted = 0?'No':'Si';
        //         d['Monto a Retarificar'] = column.adjustment_amount;
        //         d['Monto Final Reserva Retarificada'] = column.adjustment_payment_amount;
        //         d['Motivo de Retarificacion'] = column.reason_for_adjustment; // name pending
        //         //d['Comentarios de Retarificacion'] = column; //pending
        //         d['Rut Pasajero'] = column.passenger_rut;
        //         d['Rut solicitante'] = column.applicant_rut;
        //         d['Centro Costo'] = column.cost_center;
        //         d['SubCentro Costo'] = column.sub_cost_center;
        //         d['Rol'] = column.rol;
        //         d['Grafo'] = column.graph;
        //         d['Orden de Trabajo'] = column.work_order;
        //         d['PEP'] = column.PEP;
        //         d['Proposito del Viaje'] = column.purpose_of_trip;
        //         d['Numero de Vale'] = column.number_of_voucher;
        //         d['Nomina'] = column.nomina?column.nomina:'--';
        //         d['Solicitud'] = column.solicitud?column.solicitud:'--';
        //         d['Reserva creada administador (Yes/no)'] = column.created_by_admin == 0 ? 'No':'Si';
        //         d['Email reserva creada administrador'] = column.admin_email;
        //         dataArray.push(d);
        //     })
        //     vm.generateReport = dataArray;
        //     var name = 'paymentStatusReport'+ new Date().getTime()+'.csv';
        //     alasql('SELECT * INTO CSV("'+name+'",{headers:true}) FROM ?',[vm.generateReport]);
        // }

        //====================date time format====================
        function dateTimeFormat(dateGot, timeGot) {
            var dateToChange = dateGot;
            if (timeGot) {
                dateToChange.setHours(timeGot.getHours());
                dateToChange.setMinutes(timeGot.getMinutes());
                dateToChange.setSeconds(timeGot.getSeconds());
            } else {
                dateToChange.setHours(0);
                dateToChange.setMinutes(0);
                dateToChange.setSeconds(0);
            }
            return dateToChange;
        };

        //=========================payment status api===========================
        function generateOperationalReport() {
            var fromTime = '';
            var untilTime = '';
            if (vm.selectAllFlag == false && vm.dataToFill.aggrement == '') {
                errorMessageFactory.showErrorMessage('Por favor seleccione acuerdo', 0);

                languageBasedErrorFactory.getProperErrorMessage('promoErr1', 0, 0);
                return;
            }
            if (vm.dataToFill.from > vm.dataToFill.untill) {
                languageBasedErrorFactory.getProperErrorMessage('promoErr1', 0, 0);
                return;
            }
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            if (vm.dataToFill.corporate != 'all') {
                dataSend.corporate_id = vm.dataToFill.corporate;
            }
            if (vm.dataToFill.aggrement.length && vm.selectAllFlag == false) {
                dataSend.agreement_id = JSON.stringify(vm.dataToFill.aggrement);

            }
            // dataSend.fromTime = moment(vm.dataToFill.from).format('YYYY-MM-DD');
            // dataSend.untilTime = moment(vm.dataToFill.untill).format('YYYY-MM-DD');

            if (vm.dataToFill.from && vm.dataToFill.timeOptionsFrom) {
                fromTime = dateTimeFormat(vm.dataToFill.from, vm.dataToFill.timeOptionsFrom);
                dataSend.fromTime = fromTime;
            }
            else {
                dataSend.fromTime = moment.utc(moment(vm.dataToFill.from).set({
                    hour: 0,
                    minute: 0,
                    second: 0,
                    millisecond: 0
                })).format('YYYY-MM-DD HH:mm:ss'); //BY DEFAULT DATEPICKER GIVE TIME 00:00:00 
            }
            if (vm.dataToFill.untill && vm.dataToFill.timeOptionsUntil) {
                untilTime = dateTimeFormat(vm.dataToFill.untill, vm.dataToFill.timeOptionsUntil);
                dataSend.untilTime = untilTime;
            }
            else {
                dataSend.untilTime = moment.utc(moment(vm.dataToFill.untill).set({
                    hour: 23,
                    minute: 59,
                    second: 59,
                    millisecond: 0
                })).format('YYYY-MM-DD HH:mm:ss'); //filter.until_date.toISOString();
            }

            dataSend.add_inactive = vm.add_inactive;
            vm.loading = true;
            var promise = generatePaymentStatus.getOperationalReport(dataSend);
            promise.then(
                function (payload) {
                    vm.loading = false;
                    errorMessageFactory.showErrorMessage('Se avisará una vez que el reporte esté listo', 0);
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        if ($rootScope.socket.connected == false || $rootScope.socket.connected == 'false') {
            $rootScope.socket.connect();
        }

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            if (data.data) {
                $state.reload('layout.generatePaymentStatusMain.generatePaymentStatus');
            }
        });
    }

})();
/**
 * Created by cl-macmini-51 on 09/11/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('GeneratePaymentStatusController', GeneratePaymentStatusController);

    /** @ngInject */
    function GeneratePaymentStatusController($cookies, $state, $log, $rootScope, $mdDialog, $timeout, $document, getCorporate, $scope, filterFilter, $stateParams, languageBasedErrorFactory, generatePaymentStatus, getAgreement, errorMessageFactory, getFilters) {
        var vm = this;
        vm.loading = false;
        vm.dataToFill = {
            corporate: 'all',
            aggrement: [],
            addInactive: false,
            from: '',
            untill: ''
        };
        vm.globalOffset = 10;
        vm.paginationChangedForAgreement = paginationChangedForAgreement;
        vm.paginationChangedForCorporation = paginationChangedForCorporation;
        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'vehicle', 'service', 'agreement', 'corporatesList', 'operation_point'];
        vm.agreement = [];
        vm.corporatesList = [];
        vm.corporatesList.push({
            company_name: 'Todos',
            id: 'all'
        });
        vm.dateOptionsFrom = {};
        vm.dateOptionsUntill = {};
        vm.datePicker_1 = {
            from: false,
            untill: false
        };
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.altInputFormats = ['M!/d!/yyyy'];
        vm.datePickerE_1 = datePickerE_1;
        vm.corporateChange = corporateChange;
        vm.addInactiveAgrrement = addInactiveAgrrement;
        vm.fromDateChange = fromDateChange;
        vm.untillDateChange = untillDateChange;
        vm.generatePaymentApi = generatePaymentApi;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.agreementChanged = agreementChanged;
        //==================date picker function==================
        vm.dateOptionsFrom = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(),
            //minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };
        vm.dateOptionsUntill = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(),
            //minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };

        function datePickerE_1(type) {
            if (type == '1') {
                vm.datePicker_1.from = true;
                vm.datePicker_1.untill = false;
            } else if (type == '2') {
                vm.datePicker_1.untill = true;
                vm.datePicker_1.from = false;
            }
        };
        vm.agreementSearch = agreementSearch;
        vm.corporateSearch = corporateSearch;
        vm.agreementOffset = 0;
        vm.corporateOffset = 0;
        vm.agreetmentStatus = 1;
        vm.globalLimit = 10;
        vm.filterObject = {
            access_token: $cookies.get('obj'),
            branch_filter: 0,
            vehicle_filter: 0,
            service_filter: 0,
            agreement_filter: 1,
            corporate_filter: 1,
            service_category: 0,
            corporate_status: 2,
            agreement_status: vm.agreetmentStatus,
            vehicle__status: 0,
            operation_point_filter: 0,
            branch_limit: 0,
            branch_offset: 0,
            corporate_limit: vm.globalLimit,
            corporate_offset: vm.corporateOffset,
            agreement_limit: vm.globalLimit,
            agreement_offset: vm.agreementOffset,
            branch_search_filter: 0,
            vehicle_search_filter: 0,
            service_search_filter: 0,
            agreement_search_filter: 0,
            corporate_search_filter: 0,
            operation_point_search_filter: 0
        }

        setTimeout(function () {
            document.getElementsByClassName('ui-select-search')[1].addEventListener('blur', function ($event) {
                // if (vm.agreement && (vm.agreement.length == 0)) {
                vm.searchAgreementData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });


            document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                // if (vm.corporatesList && (vm.corporatesList.length == 0)) {
                vm.searchCorporateData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

        })

        // =================== GET FILTER DATA ===================
        function getFilterDataFromBackend(data, type) { //Acc to Index ['branch_search', 'vehicle_search', 'service_search', 'agreement_search', 'corporate_search', 'operation_point_search']
            if (data) {
                vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
            } else {
                vm.filterObject = {
                    access_token: $cookies.get('obj'),
                    branch_filter: 0,
                    vehicle_filter: 0,
                    service_filter: 0,
                    agreement_filter: 1,
                    corporate_filter: 1,
                    service_category: 0,
                    corporate_status: 2,
                    agreement_status: vm.agreetmentStatus,
                    vehicle__status: 0,
                    operation_point_filter: 0,
                    branch_search_filter: 0,
                    vehicle_search_filter: 0,
                    service_search_filter: 0,
                    agreement_search_filter: 0,
                    corporate_search_filter: 0,
                    operation_point_search_filter: 0
                }
            }
            vm.filterObject.agreement_limit = vm.globalLimit;
            vm.filterObject.agreement_offset = vm.agreementOffset;
            vm.filterObject.corporate_limit = vm.globalLimit;
            vm.filterObject.corporate_offset = vm.corporateOffset;

            var promise = getFilters.getAllFilterData(vm.filterObject);
            promise.then(
                function (payload) {

                    // *********** AGREEMENT DATA *********
                    if (payload.title.data.agreements) {
                        angular.forEach(payload.title.data.agreements.data, function (column) {
                            //CHECK FOR DUPLICATE ENTRY
                            var agreementIndex = _.findIndex(vm.agreement, {
                                id: column.id
                            });
                            if (agreementIndex == -1)
                                vm.agreement.push({
                                    id: column.id,
                                    name: column.name
                                });
                        });
                        vm.agreementTotalBackendCount = payload.title.data.agreements.totalCount;
                    }


                    // ********** CORPORATE DATA ********
                    if (payload.title.data.corporates) {
                        // angular.forEach(payload.title.data.corporates.data, function (column) {
                        //     vm.corporatesList.push(column)
                        // });
                        // vm.corporateTotalBackendCount = payload.title.data.corporates.totalCount;
                        var index = _.findIndex(vm.corporatesList, {
                            id: 'all'
                        });
                        if (index == -1)
                            vm.corporatesList.push({
                                company_name: 'Todos',
                                id: 'all'
                            });
                        angular.forEach(payload.title.data.corporates.data, function (column) {
                            //CHECK FOR DUPLICATE ENTRY
                            var corporateIndex = _.findIndex(vm.corporatesList, {
                                id: column.id
                            });
                            if (corporateIndex == -1)
                                vm.corporatesList.push(column)
                        });
                        vm.corporateTotalBackendCount = payload.title.data.corporates.totalCount;
                    }

                    vm.loading = false;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        }
        getFilterDataFromBackend();


        // ************ PAGINATION ON AGREEMENT **************
        function paginationChangedForAgreement() {
            if (vm.agreementTotalBackendCount > (vm.agreement.length)) {
                commonFunction(3);
                vm.agreementOffset += vm.globalOffset;
                // vm.corporatesList  = [];
                // vm.agreementOffset  = 0;
                getFilterDataFromBackend(vm.searchAgreementData, 3);
            }
        }


        // ************ PAGINATION ON CORPORATE **************
        function paginationChangedForCorporation() {
            var index = _.findIndex(vm[vm.searchFilterArrayForClearArray[4]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.corporateTotalBackendCount > (vm.corporatesList.length - index)) {
                commonFunction(4);
                // vm.agreement = [];
                // vm.corporateOffset  = 0;
                vm.corporateOffset += vm.globalOffset;
                getFilterDataFromBackend(vm.searchCorporateData, 4);
            }
        }
        // *********** COMMON FUNCTION FOR FILTER PAGINATION AND SEARCHING ***********
        function commonFunction(type, mode) {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                if (mode == 'search' || i != type) {
                    vm[vm.searchFilterArrayForClearArray[i]] = [];
                    // vm[vm.searchFilterArrayForClearArray[i]].push({
                    //     id: 'all',
                    //     name: 'Todos'
                    // });
                    vm[vm.searchFilterArray[i] + 'Offset'] = 0;
                    vm['search' + vm.searchFilterArray[i].substring(0, 1).toUpperCase() + vm.searchFilterArray[i].substring(1) + 'Data'] = '';
                }
            }
        }


        // ************ SEARCH SERVICE ***************
        function corporateSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchCorporateData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(4, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 4);
                }, 2000);
            }
        }



        // ************ SEARCH AGREEMENT ***************
        function agreementSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchAgreementData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(3, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 3);
                }, 2000);
            }
        }
        // //==============get all corporate=================
        // function getAllCorporate() {
        //     vm.loading = true;
        //     var dataSend = {};
        //     dataSend.access_token = $cookies.get('obj');
        //     dataSend.limit = 0;
        //     dataSend.offset = 0;
        //     dataSend.key = 2;
        //     dataSend.search_filter = 0;
        //     var promise = getCorporate.allCorporates(dataSend);
        //     promise.then(
        //         function (payload) {
        //             $log.log('sxdsads', payload);
        //             vm.loading = false;
        //             //vm.corporatesList = _.where(payload.title.data.result,{status:1});
        //             vm.corporatesList = payload.title.data.result;
        //             vm.corporatesList.push({
        //                 company_name: 'Todos',
        //                 id: 'all'
        //             });
        //         },
        //         function (errorPayload) {
        //             vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // };
        // getAllCorporate();

        // //======================get all agreements==============
        // function getAllAgreement(skip, limt) {
        //     var dataSend = {};
        //     dataSend.access_token = $cookies.get('obj');
        //     dataSend.offset = skip;
        //     dataSend.limit = limt;
        //     dataSend.key = 3;
        //     vm.loading = true;
        //     var promise = getAgreement.getAgreementListLessData(dataSend);
        //     promise.then(
        //         function (payload) {
        //             $log.log('sxdsads', payload);
        //             vm.loading = false;
        //             if (payload.title.status == 400) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //             } else if (payload.title.status == 401) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //             } else if (payload.title.status == 201 || payload.title.status == 200) {
        //                 vm.agreement = [];

        //                 angular.forEach(payload.title.data, function (column) {
        //                     if (vm.dataToFill.corporate == 'all') {
        //                         if (column.status == 1 && vm.dataToFill.addInactive == false) {
        //                             vm.agreement.push({
        //                                 id: column.id,
        //                                 name: column.name
        //                             });
        //                         } else if (vm.dataToFill.addInactive) {
        //                             vm.agreement.push({
        //                                 id: column.id,
        //                                 name: column.name
        //                             });
        //                         }
        //                     } else {
        //                         if (column.status == 1 && vm.dataToFill.addInactive == false && column.corporate_id == vm.dataToFill.corporate) {
        //                             vm.agreement.push({
        //                                 id: column.id,
        //                                 name: column.name
        //                             });
        //                         } else if (vm.dataToFill.addInactive && column.corporate_id == vm.dataToFill.corporate) {
        //                             vm.agreement.push({
        //                                 id: column.id,
        //                                 name: column.name
        //                             });
        //                         }
        //                     }
        //                 });
        //             }
        //             //vm.agreement.push({
        //             //    id:'all',
        //             //    name:'Todos'
        //             //});
        //         },
        //         function (errorPayload) {
        //             $log.log(errorPayload);
        //             vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // };
        // getAllAgreement(0, 0);

        // ******** CLEAR OFFSET *******
        function clearOffset() {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                vm[vm.searchFilterArray[i] + 'Offset'] = 0;
            }
        }

        //===========================corporate change===========================
        function corporateChange() {
            vm.dataToFill.aggrement = [];
            vm.agreement = [];
            vm.corporatesList = [];
            clearOffset();
            getFilterDataFromBackend();
            // if (vm.dataToFill.corporate != 'all') {
            //     getAllAgreement(0, 0);
            // } else {
            //     getAllAgreement(0, 0);
            // }
        }

        function agreementChanged() {
            if (vm.agreement.length == 0) {
                vm.agreement = [];
                vm.corporatesList = [];
                clearOffset();
                getFilterDataFromBackend();
            }
        }

        //====================add inactive agreements==============
        function addInactiveAgrrement() {
            if (vm.dataToFill.addInactive == false) {
                vm.agreetmentStatus = 2;
                getFilterDataFromBackend();
            } else {
                vm.agreetmentStatus = 1;
                getFilterDataFromBackend();
            } {}
        }

        //===============add days=============
        function addDays(date, days) {
            var result = new Date(date);
            result.setDate(result.getDate() + days);
            return result;
        }
        //===============delete days=============
        function deleteDays(date, days) {
            var result = new Date(date);
            result.setDate(result.getDate() - days);
            return result;
        }
        //====================untill date change=======================
        function untillDateChange() {
            //vm.dateOptionsFrom.minDate = deleteDays(vm.dataToFill.untill,20);
            //vm.dateOptionsFrom.maxDate = vm.dataToFill.untill;
        }

        //====================from date change=======================
        function fromDateChange() {
            //vm.dateOptionsUntill.maxDate = addDays(vm.dataToFill.from,20);
            //vm.dateOptionsUntill.minDate = vm.dataToFill.from;
        }

        //======================get days differnece======================
        function getDaysDiffernce(from, untill) {
            var date1 = new Date(from);
            var date2 = new Date(untill);
            var timeDiff = Math.abs(date2.getTime() - date1.getTime());
            var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
            return diffDays;
        }

        //=========================payment status api===========================
        function generatePaymentApi() {

            var getDifference = getDaysDiffernce(vm.dataToFill.from, vm.dataToFill.untill);
            if (getDifference > 62) {
                languageBasedErrorFactory.getProperErrorMessage('differenceError', 0, 0);
                return;
            }

            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            if (vm.dataToFill.corporate != 'all') {
                dataSend.corporate_id = vm.dataToFill.corporate;
            }
            if (vm.dataToFill.aggrement.length) {
                dataSend.agreement_id = JSON.stringify(vm.dataToFill.aggrement);
            }

            dataSend.fromTime = moment(vm.dataToFill.from).format('YYYY-MM-DD') + ' 00:00:00';
            dataSend.untilTime = moment(vm.dataToFill.untill).format('YYYY-MM-DD') + ' 23:59:00';
            // dataSend.fromTime = moment(new Date((vm.dataToFill.from).setMinutes((vm.dataToFill.from).getMinutes() + new Date().getTimezoneOffset()))).format('YYYY-MM-DD HH:mm:ss');
            // moment.utc(moment(vm.dataToFill.from).set({
            //     hour: 0,
            //     minute: 0,
            //     second: 0,
            //     millisecond: 0
            // })).format('YYYY-MM-DD HH:mm:ss'); //BY DEFAULT DATEPICKER GIVE TIME 00:00:00 
            
            // dataSend.untilTime = moment(new Date((vm.dataToFill.untill).setMinutes((vm.dataToFill.untill).getMinutes() + (new Date().getTimezoneOffset() - 1)))).add(1,'days').format('YYYY-MM-DD HH:mm:ss'); //filter.until_date.toISOString();
            dataSend.timeZone = new Date().getTimezoneOffset();
            dataSend.locale = moment.tz.guess();

            vm.loading = true;
            var promise = generatePaymentStatus.getGeneratePaymentStatusList(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if(payload && payload.title && payload.title.status == 400){
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else{
                        errorMessageFactory.showErrorMessage('Se avisará una vez que el reporte esté listo', 0);
                    }
                    //  if(payload.title.data && payload.title.data.length){
                    //      createCSV(payload.title.data);
                    //  }
                    //  else{
                    //      languageBasedErrorFactory.getProperErrorMessage('queryError',0,0);
                    //  }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        if ($rootScope.socket.connected == false || $rootScope.socket.connected == 'false') {
            $rootScope.socket.connect();
        }



        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.generatePaymentStatusMain.generatePaymentStatus');
            }
        });

        //============================create csv===============================
        // function createCSV(data){
        //     var dataArray = [];
        //     data.forEach(function(column){
        //         var d = {};
        //         d['Número Reserva'] = column.job_id;
        //         d['Tipo de Viaje'] = column.type_of_trip;
        //         d['Fecha Creación Reserva'] = moment(column.creation_datetime).format('DD-MM-YYYY HH:mm');
        //         d['Tipo de Servicio solicitado'] = column.type_of_service; //name pending;
        //         d['Sucursal'] = column.branch;
        //         if(column.created_by_admin == 0){ // channel
        //             d['Canal'] = 'App';
        //         }
        //         else if(column.created_by_admin == 1){
        //             d['Canal'] = 'Panel';
        //         }
        //         else if(column.created_by_admin == 2){
        //             d['Canal'] = 'POS';
        //         }
        //         else if(column.created_by_admin == 3){
        //             d['Canal'] = 'WEB';
        //         }

        //         if(column.job_status == 0){ // state of booking
        //             d['Estado de la reserva'] = 'UPCOMING';
        //         }
        //         else if(column.job_status == 1){
        //             d['Estado de la reserva'] = 'STARTED';
        //         }
        //         else if(column.job_status == 2){
        //             d['Estado de la reserva'] = 'ENDED';
        //         }
        //         else if(column.job_status == 3){
        //             d['Estado de la reserva'] = 'FAILED';
        //         }
        //         else if(column.job_status == 4){
        //             d['Estado de la reserva'] = 'ARRIVED';
        //         }
        //         else if(column.job_status == 5){
        //             d['Estado de la reserva'] = 'PARTIAL';
        //         }
        //         else if(column.job_status == 6){
        //             d['Estado de la reserva'] = 'UNASSIGNED';
        //         }
        //         else if(column.job_status == 7){
        //             d['Estado de la reserva'] = 'ACCEPTED';
        //         }
        //         else if(column.job_status == 8){
        //             d['Estado de la reserva'] = 'DECLINE';
        //         }
        //         else if(column.job_status == 9){
        //             d['Estado de la reserva'] = 'CANCEL';
        //         }
        //         else if(column.job_status == 10){
        //             d['Estado de la reserva'] = 'DELETED';
        //         }
        //         else if(column.job_status == 11){
        //             d['Estado de la reserva'] = 'IGNORED';
        //         }
        //         else if(column.job_status == 12){
        //             d['Estado de la reserva'] = 'NOSHOW';
        //         }
        //         else if(column.job_status == 13){
        //             d['Estado de la reserva'] = 'APPROVALREQUIRED';
        //         }
        //         else if(column.job_status == 14){
        //             d['Estado de la reserva'] = 'APPROVALCANCELLEDBYCUSTOMER';
        //         }
        //         else if(column.job_status == 15){
        //             d['Estado de la reserva'] = 'ONROAD';
        //         }
        //         else if(column.job_status == 16){
        //             d['Estado de la reserva'] = 'SCANNED';
        //         }

        //         d['Fecha y Hora Retiro'] = moment(column.job_time_utc).format('DD-MM-YYYY HH:mm'); //correct time pending
        //         d['Nombre Pasajero'] = column.customer_username;
        //         d['Telefono Pasajero'] = column.customer_phone;
        //         d['Correo del pasajero'] = column.job_pickup_email;
        //         d['Pasajero VIP (Si/No)'] = column.is_vip == 0?'No':'Si';
        //         d['Id del Solicitante'] = column.created_by;
        //         d['Nombre Solicitante'] = column.job_pickup_name;
        //         d['Telefono Solicitante'] = column.job_pickup_phone;
        //         d['Correo Solicitante'] = column.customer_email;
        //         d['Perfil del Solicitante'] = column.creator_profile == 0? 'Personal': 'Business';
        //         d['Direccion Retiro'] = column.job_pickup_address;
        //         d['Referencia a direccion de retiro'] = column.reference_point;
        //         d['Latitud Direccion Retiro'] = column.job_pickup_latitude;
        //         d['Longitud Direccion Retiro'] = column.job_pickup_longitude;
        //         d['Direccion Destino Solicitada'] = column.job_address;
        //         d['Latitud Direccion Destino Solicitada'] = column.job_latitude;
        //         d['Longitud Direccion Destino solicitada'] = column.job_longitude;
        //         d['Direccion Destino Real'] = column.actual_job_address;
        //         d['Latitud Direccion Destino Real'] = column.actual_job_latitude;
        //         d['Longitud Direccion Destino Real'] = column.actual_job_longitude;
        //         d['Numero Movil'] = column.unique_car_id;
        //         d['ETA a Direccion de Destino'] = column.eta;
        //         d['Placa Patente del Mobil'] = column.transport_details;
        //         d['Tipo de vehiculo asignado'] = column.transport_type_id; //need name
        //         d['Nombre conductor'] = column.driver_name; //pending
        //         d['Numero Pasajeros Reserva'] = column.number_of_passangers;
        //         d['Observaciones del Viaje'] = column.observations?column.observations.replace(/(\r\n|\n|\r)/gm," "):"";
        //         d['Reserva para un Tercero (si/no)'] = column.booking_for == 0?'Si':'No';
        //         d['Calificacion dada por Cliente'] = column.fleet_rating;
        //         d['Comentarios dados por Cliente'] = column.fleet_comment;
        //         d['Conductor califico a cliente (si/no)'] = column.is_customer_rated == 0?'No':'Si';
        //         d['Calificacion dada por Conductor'] = column.customer_rating;
        //         d['Comentarios dados por Conductor'] = column.customer_comment;
        //         d['Fecha y Hora Evento Asignacion'] = column.accepted_datetime == '0000-00-00 00:00:00'?'0000-00-00 00:00:00':moment(column.accepted_datetime).format('DD-MM-YYYY HH:mm');
        //         d['Direccion Evento Asignacion'] = column.accepted_address;
        //         d['Latitud Evento asignacion'] = column.accepted_latitude;
        //         d['Longitud Evento asignacion'] = column.accepted_longitude;
        //         d['Fecha y Hora Evento en Camino'] = column.on_road_datetime == '0000-00-00 00:00:00'?'0000-00-00 00:00:00':moment(column.on_road_datetime).format('DD-MM-YYYY HH:mm');
        //         d['Direccion Evento En camino'] = column.on_road_address;
        //         d['Latitud Evento En Camino'] = column.on_road_latitude;
        //         d['Longitud Evento en Camino'] = column.on_road_longitude;
        //         d['Fecha y Hora Evento en Posicion'] = column.arrived_datetime == '0000-00-00 00:00:00'?'0000-00-00 00:00:00':moment(column.arrived_datetime).format('DD-MM-YYYY HH:mm');
        //         d['Direccion Evento En Posicion'] = column.arrived_address;
        //         d['Latitud Evento en posicion'] = column.arrived_latitude;
        //         d['Longitud Evento en posicion'] = column.arrived_longitude;
        //         d['Fecha y Hora Inicio Viaje'] = column.started_datetime == '0000-00-00 00:00:00'?'0000-00-00 00:00:00':moment(column.started_datetime).format('DD-MM-YYYY HH:mm');
        //         d['Direccion Viaje Iniciado'] = column.started_address;
        //         d['Latitud Inicio viaje'] = column.started_latitude;
        //         d['Longitud Inicio Viaje'] = column.started_longitude;
        //         d['Fecha y Hora Viaje Terminado'] = column.completed_datetime == '0000-00-00 00:00:00'?'0000-00-00 00:00:00':moment(column.completed_datetime).format('DD-MM-YYYY HH:mm');
        //         d['Direccion Viaje Terminado'] = column.completed_address;
        //         d['Latitud Viaje Terminado'] = column.completed_latitude;
        //         d['Longitud Viaje Terminado'] = column.completed_longitude;
        //         d['Distancia Total Viaje'] = column.total_distance_travelled;
        //         d['Tiempo Total de Viaje'] = column.total_time_travelled;
        //         d['Tiempo Espera Inicial'] = column.total_wait_time;
        //         d['Tiempo de Espera Total'] = column.wait_time;
        //         d['Metodo de Pago'] = column.payment_method; //name pending
        //         d['Tipo de Ruta usada (Fija/Variable)'] = column.route_type == 1?'Fija':'Variable';
        //         d['Nombre de ruta usada (Ruta Fija)'] = column.route_name;
        //         d['Id Name of Fixed route'] = column.route_id;
        //         d['Tipo de Tarifa usada (Fija/Variable)'] = column.type_of_agreement == 0?'Fija':'Variable';
        //         d['Monto Total Reserva'] = column.payment_amount;
        //         d['Total Reserva'] = column.ride_charges;
        //         d['Ingresos Transvip'] = column.transvip_fare;
        //         d['Ingreso Conductor'] = column.service_cost;
        //         d['Porcentaje produccion'] = column.percentage_driver_earning;
        //         d['Tarifa Base'] = column.base_fare;
        //         d['Tarifa por kilometro'] = column.fare_by_kilometer;
        //         d['Tarifa tiempo espera inicial'] = column.item_fare_by_waiting_initial_time;
        //         d['Tarifa tiempo espera'] = column.item_fare_by_waiting_time;
        //         d['Tarifa minima'] = column.item_minimal_fare;
        //         d['Valor Total kilometros'] = column.total_value_kilometers;
        //         d['Total Item adicionales'] = column.item_of_charge_amount;
        //         d['Empresa'] = column.company_name;
        //         d['ID Cuenta Corporativa Reserva'] = column.corporate_account_id;
        //         d['ID Convenio usado para la reserva'] = column.contract_id;
        //         d['Nombre Convenio usado para la reserva'] = column.agreement_name;
        //         d['Reserva recurrente (Si/No)'] = column.reaccuring_ride == 0 ? 'No': 'Si';
        //         d['Reserva de Minuto/Programada'] = column.schedule_ride == 0 ? 'Minuto':'Programada';
        //         d['Reserva Ida Vuelta (Si/no)'] = column.is_round_trip == 0? 'No':'Si';
        //         d['Reserva Ida Vuelta con tiempo espera (Si/no)'] = column.is_wait_time_included == 0 ? 'No':'Si';
        //         d['Fehcha y Hora reserva ida Vuelta'] = column.return_date_time == '0000-00-00 00:00:00'?'0000-00-00 00:00:00':moment(column.return_date_time).format('DD-MM-YYYY HH:mm');
        //         d['Id Reserva vinculada Ida Vuelta'] = column.round_trip_parent_job_id;
        //         d['Reserva Aeropuerto (si/no)'] = column.isAirportService == 0 ?'No':'Si';
        //         d['Fecha/Hora No-Show'] = column.no_show_datetime == '0000-00-00 00:00:00'?'0000-00-00 00:00:00':moment(column.no_show_datetime).format('DD-MM-YYYY HH:mm');
        //         d['Motivo No-Show'] = column.noshow_reason;
        //         d['Comentarios No-Show'] = column.noshow_comment;
        //         d['ID Usuario marco No-Show'] = column.noshow_identity;
        //         d['Usuario Anulación'] = column.cancellation_identity?column.cancellation_identity:'--';
        //         d['Fecha / Hora Anulación'] = column.cancellation_datetime == '0000-00-00 00:00:00'?'0000-00-00 00:00:00':moment(column.cancellation_datetime).format('DD-MM-YYYY HH:mm');
        //         d['Motivo Anulación'] = column.cancellation_reason?column.cancellation_reason:'--';
        //         d['Reserva requiere autorizacion (si/no)'] = column.auth_required == 0? 'No':'Si';
        //         d['Nombre autorizador'] = column.authorizer_name;
        //         d['Rut del Autorizador'] = column.auth_of;
        //         if(column.is_auth == 0){
        //             d['Estado Autorizacion'] = 'Pending';
        //         }
        //         else if(column.is_auth == 1){
        //             d['Estado Autorizacion'] = 'Authorized';
        //         }
        //         else if(column.is_auth == 2){
        //             d['Estado Autorizacion'] = 'Rejected';
        //         }
        //         else if(column.is_auth == 3){
        //             d['Estado Autorizacion'] = 'Cancelled By Customer';
        //         }
        //         d['Fecha y Hora Autorizacion'] = column.auth_timing == '0000-00-00 00:00:00'?'0000-00-00 00:00:00':moment(column.auth_timing).format('DD-MM-YYYY HH:mm');
        //         d['Reserva Retarificada (si/no)'] = column.is_adjusted = 0?'No':'Si';
        //         d['Monto a Retarificar'] = column.adjustment_amount;
        //         d['Monto Final Reserva Retarificada'] = column.adjustment_payment_amount;
        //         d['Motivo de Retarificacion'] = column.reason_for_adjustment; // name pending
        //         //d['Comentarios de Retarificacion'] = column; //pending
        //         d['Rut Pasajero'] = column.passenger_rut;
        //         d['Rut solicitante'] = column.applicant_rut;
        //         d['Centro Costo'] = column.cost_center;
        //         d['SubCentro Costo'] = column.sub_cost_center;
        //         d['Rol'] = column.rol;
        //         d['Grafo'] = column.graph;
        //         d['Orden de Trabajo'] = column.work_order;
        //         d['PEP'] = column.PEP;
        //         d['Proposito del Viaje'] = column.purpose_of_trip;
        //         d['Numero de Vale'] = column.number_of_voucher;
        //         d['Nomina'] = column.nomina?column.nomina:'--';
        //         d['Solicitud'] = column.solicitud?column.solicitud:'--';
        //         d['Reserva creada administador (Yes/no)'] = column.created_by_admin == 0 ? 'No':'Si';
        //         d['Email reserva creada administrador'] = column.admin_email;
        //         dataArray.push(d);
        //     })
        //     vm.generateReport = dataArray;
        //     var name = 'paymentStatusReport'+ new Date().getTime()+'.csv';
        //     alasql('SELECT * INTO CSV("'+name+'",{headers:true}) FROM ?',[vm.generateReport]);
        // }

        //function createCSV(data){
        //    //vm.generateReport = dataArray;
        //    var csvContent = "data:text/csv;charset=utf-8,";
        //    csvContent += data;
        //    var encodedUri = encodeURI(csvContent);
        //    var name = 'paymentStatusReport'+ new Date().getTime()+'.csv';
        //    var link = document.createElement("a");
        //    link.setAttribute("href", encodedUri);
        //    link.setAttribute("download", name);
        //    document.body.appendChild(link); // Required for FF
        //    link.click();
        //    document.body.removeChild(link);
        //    //alasql('SELECT * INTO CSV("'+name+'",{headers:true}) FROM ?',[data]);
        //}


    }

})();
/**
 * Created by cl-macmini-51 on 5/30/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('CierroPeriodeController', CierroPeriodeController);

    /** @ngInject */
    function CierroPeriodeController($cookies, $state, $log, $rootScope, $timeout, $stateParams, getDrivers, $mdDialog, $document, RutHelper, $scope, languageBasedErrorFactory, errorMessageFactory) {
        var vm = this;
        vm.CierroPeriodo = CierroPeriodo;
        vm.DateArray = [];
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.flagToShow = true;
        vm.closeProductionEmpty = false;

        //////////////// LISTING OF MONTH  //////////////
        function getCloseProducationApi() {
            vm.loading = true;
            var promise = getDrivers.getCloseProduction(2);
            promise.then(
                function (payload) {
                    vm.loading = false;
                    var count = 0;
                    if (payload && payload.title.data && payload.title.data.length > 0) {
                        count = 0;
                        var ArrayComing = payload.title.data;
                        ArrayComing.forEach(function (data) {
                            if (data.is_reopen == 1) {
                                vm.flagToShow = true;
                                vm.closeProductionEmpty = false;
                                var hello = [];
                                vm.DateArray.push({
                                    production_date: moment(data.production_date , 'YYYY/MM/DD')._d,
                                    close_production_id : data.close_production_id
                                })
                                count = 1;
                                // vm.DateArray.push(hello);
                                vm.current_date = new Date();
                                vm.past_date = new Date(data.production_date);
                                vm.monthVAlue = vm.past_date.getMonth();
                                vm.past_date.setMonth(vm.monthVAlue);
                                vm.DateArray.sort();
                            } else {
                                if (count == 0) {
                                    var date = new Date(),
                                        y = date.getFullYear(),
                                        m = date.getMonth();
                                    var firstDay = new Date(y, m, 1);
                                    var lastDay = new Date(y, m + 1, 0);
                                    // var dateShow = new Date(ArrayComing[0].production_date);
                                    var dateShow = moment(ArrayComing[0].production_date , 'YYYY/MM/DD');
                                    var NextMonthShow =  moment(ArrayComing[0].production_date , 'YYYY/MM/DD').month() + 1;
                                    var nextYearShow = moment(ArrayComing[0].production_date , 'YYYY/MM/DD').year();
                                    vm.dateToSHow = new Date();
                                    vm.dateToSHow.setMonth(NextMonthShow);
                                    console.log(dateShow,NextMonthShow,nextYearShow,'nextYearShow>>>>>>',moment('2017-09-01T00:00:00.000Z' , 'YYYY/MM/DD'));
                                    
                                    // vm.dateToSHow.setFullYear(nextYearShow);
                                    if (NextMonthShow == 12) {
                                        var nextYear = nextYearShow + 1;
                                        vm.dateToSHow.setFullYear(nextYear);

                                    } else {
                                        vm.dateToSHow.setFullYear(nextYearShow);
                                    }
                                    if (y == vm.dateToSHow.getFullYear() && m == vm.dateToSHow.getMonth()) {
                                        vm.closeProductionEmpty = true;
                                    } else {
                                        vm.closeProductionEmpty = false;
                                        vm.DateArray.push({
                                            production_date: vm.dateToSHow
                                        });
                                    }
                                    count++;
                                }
                            }
                        });
                    } else {
                        if (count == 0) {
                            vm.dateToSHow1 =  moment('2017-09-01T00:00:00.000Z' , 'YYYY/MM/DD');
                            console.log(vm.dateToSHow1,moment('2017-09-01T00:00:00.000Z' , 'YYYY/MM/DD'));
                            
                            vm.DateArray.push({
                                production_date: vm.dateToSHow1._d
                            });
                            count++;
                        }
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        getCloseProducationApi();
        //////////////// LISTING OF MONTH  //////////////


        // POPUP FOR CLOSE THE PRODUCTION OF DRIVER EARNING //////////////
        function CierroPeriodo($event, data) {
            var confirm = $mdDialog.confirm()
                .title('¿Quieres cerrar la producción de este mes?')
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('cancelButton', 0, '3'));
            $mdDialog.show(confirm).then(function () {
                vm.loading = true;
                var dataToSend = {};
                dataToSend.access_token = $cookies.get('obj');
                var newDateSend = moment(data.production_date).format('YYYY-MM-DD');
                dataToSend.date = newDateSend;
                if (data && (data.close_production_id != undefined || data.close_production_id != null)) {
                    dataToSend.close_production_id = data.close_production_id;
                    dataToSend.status = 0;
                }
                var promise = getDrivers.completeCloseProduction(dataToSend);
                promise.then(
                    function (payload) {
                        vm.loading = false;
                        vm.DateArray = [];
                        if (payload && payload.title.status == 200) {
                            $state.reload();
                            var monthMsg;
                            if (vm.closeProductionEmpty == true) {
                                var NewDate = new Date(data.production_date);
                                monthMsg = vm.dateToSHow.getMonth();
                            } else {
                                var NewDate = new Date(data.production_date);
                                monthMsg = NewDate.getMonth();
                            }
                            var msgDate = new Date();
                            msgDate.setMonth(monthMsg);
                            msgDate = moment(msgDate).format('MMMM');
                            var year;
                            if (vm.dateToSHow == undefined) {
                                year = new Date(data.production_date).getFullYear();
                            } else {
                                year = vm.dateToSHow.getFullYear()
                            }
                            var msg = 'El Período ' + msgDate + ' ' + year + ' fue cerrado exitosamente'
                            errorMessageFactory.showErrorMessage(msg, 0);
                            if (vm.dateToSHow != undefined || vm.dateToSHow != null) {
                                vm.NextMonth = vm.dateToSHow.getMonth() + 1;
                                vm.nextYear = vm.dateToSHow.getFullYear();
                                var getDate = new Date();
                                getDate.setMonth(vm.NextMonth);
                                if (vm.NextMonth == 12) {
                                    var nextYear = vm.nextYear + 1;
                                    getDate.setFullYear(nextYear);

                                } else {
                                    getDate.setFullYear(vm.nextYear);
                                }
                                vm.DateArray.push({
                                    production_date: getDate
                                });
                                vm.dateToSHow = getDate;
                            } else {
                                $state.reload();
                            }

                        } else {
                            $state.reload();
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            });
        }
        // POPUP FOR CLOSE THE PRODUCTION OF DRIVER EARNING //////////////
    }
})();
/**
 * Created by cl-macmini-51 on 5/30/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('AbrirPeriodoController', AbrirPeriodoController);

    /** @ngInject */
    function AbrirPeriodoController($cookies, $state, $log, $rootScope, $timeout, $stateParams, getDrivers, $mdDialog, $document, RutHelper, $scope, languageBasedErrorFactory, errorMessageFactory) {
        var vm = this;
        vm.AbrirPeriodo = AbrirPeriodo;
        vm.dataReopen = [];
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();

        //////////////// LISTING OF MONTH  //////////////
        function getReCloseProducationApi() {
            vm.loading = true;
            var promise = getDrivers.getCloseProduction(0);
            promise.then(
                function (payload) {
                    vm.loading = false;
                    vm.dataReopen  = [];
                    if (payload && payload.title.data && payload.title.data.length == 0) {
                        vm.flagToShow = false;
                    } else {
                        if (payload && payload.title.data && payload.title.data.length > 0) {
                            if (payload.title.data[0].is_reopen == 0) {
                                
                                vm.flagToShow = true;
                                // vm.dataReopen = payload.title.data;
                                vm.dateSend =  moment(payload.title.data[0].production_date , 'YYYY/MM/DD')
                                vm.dataReopen.push({
                                    production_date: vm.dateSend._d,
                                    close_production_id:payload.title.data[0].close_production_id
                                })
                            } else {
                                vm.dataReopen = [];
                            }
                        }
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        getReCloseProducationApi();
        //////////////// LISTING OF MONTH  //////////////

        // POPUP FOR REOPEN THE PRODUCTION OF DRIVER EARNING //////////////
        function AbrirPeriodo($event, data) {
            var confirm = $mdDialog.confirm()
                .title('¿Quieres abrir la producción de este mes?')
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('cancelButton', 0, '3'));
            $mdDialog.show(confirm).then(function () {
                vm.loading = true;
                var dataToSend = {};
                dataToSend.access_token = $cookies.get('obj');
                var newDateSend = moment(data.production_date).format('YYYY-MM-DD');
                dataToSend.date = newDateSend;
                if (data && (data.close_production_id != undefined || data.close_production_id != null)) {
                    dataToSend.close_production_id = data.close_production_id;
                    dataToSend.status = 1;
                }
                var promise = getDrivers.completeCloseProduction(dataToSend);
                promise.then(
                    function (payload) {
                        vm.loading = false;
                        vm.DateArray = [];
                        if (payload && payload.title.status == 200) {
                            var dateToMsg = new Date(data.production_date);
                            var monthMsg = dateToMsg.getMonth();
                            var msgDate = new Date();
                            msgDate.setMonth(monthMsg);
                            msgDate = moment(msgDate).format('MMMM')
                            var msg = 'El Período ' + msgDate + ' ' + dateToMsg.getFullYear() + ' fue abierto exitosamente'
                            errorMessageFactory.showErrorMessage(msg, 0);
                            if (vm.dateToSHow != undefined || vm.dateToSHow != null) {
                                vm.NextMonth = vm.dateToSHow.getMonth() + 1;
                                vm.nextYear = vm.dateToSHow.getFullYear();
                                var getDate = new Date();
                                getDate.setMonth(vm.NextMonth);
                                getDate.setFullYear(vm.nextYear);
                                vm.DateArray.push({
                                    production_date: getDate
                                });
                                vm.dateToSHow = getDate;
                            } else {
                                getReCloseProducationApi();
                            }

                        } else {
                            getReCloseProducationApi();
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            });
        }
        // POPUP FOR REOPEN THE PRODUCTION OF DRIVER EARNING //////////////
    }
})();
/**
 * Created by cl-macmini-51 on 5/18/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('gaussControlController', gaussControlController);

    /** @ngInject */
    function gaussControlController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document,
        moment, $scope, RutHelper, gaussControlService, filterFilter, getGeofence, adminAccessService, getCorporate, languageBasedErrorFactory, errorMessageFactory, pendingRequests, getFilters) {

        var vm = this;
        vm.init = init;
        vm.nfa1 = 1;
        vm.nfa2 = 1;
        vm.nfa3 = 1;
        vm.nfa4 = 1;

        vm.loading = false;
        vm.modifyGauss = false;
        vm.getGaussControlData = getGaussControlData;
        vm.saveGaussControl = saveGaussControl;
        vm.modifyGaussData = modifyGaussData;
        vm.cancelFormBalance = cancelFormBalance;
        vm.isSubmit = false;
        vm.detectInputChange = detectInputChange;
        vm.detectInputChange2 = detectInputChange2;
        vm.checkNfaValue = checkNfaValue;

        vm.showInformar1Error = false;
        vm.showDesconectar1Error = false;
        vm.showBloquear1Error = false;

        vm.showInformar2Error = false;
        vm.showDesconectar2Error = false;
        vm.showBloquear2Error = false;

        vm.showInformar3Error = false;
        vm.showDesconectar3Error = false;
        vm.showBloquear3Error = false;

        vm.showInformar4Error = false;
        vm.showDesconectar4Error = false;
        vm.showBloquear4Error = false;

        vm.tolerance1Error = false;
        vm.tolerance2Error = false;
        vm.tolerance3Error = false;
        vm.tolerance3Error = false;

        function init() {
            vm.getGaussControlData();
        };
        init();


        function getGaussControlData() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            vm.loading = true;
            var promise = gaussControlService.getGaussControlData(dataSend);
            promise.then(
                function (payload) {
                    vm.loading = false;

                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return [];
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return [];
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        console.log('debug payload', payload);
                        vm.gaussControlData = payload.title.data.gaussMatrix;
                        vm.gaussInfo = payload.title.data.gaussInfo[0];
                        for (var i = 0; i < vm.gaussControlData.length; i++) {
                            //============================ NFA1 ==================================
                            if (vm.gaussControlData[i].nfa === 1 && vm.gaussControlData[i].action === 'N') {
                                vm.nfa1 = '1';
                            }
                            if (vm.gaussControlData[i].nfa === 1 && vm.gaussControlData[i].action === 'I') {
                                vm.nfa1 = '2';
                                vm.informar1 = vm.gaussControlData[i].message;
                                vm.informar1Copy = angular.copy(vm.informar1);
                            }
                            if (vm.gaussControlData[i].nfa === 1 && vm.gaussControlData[i].action === 'D') {
                                vm.nfa1 = '3';
                                vm.desconectar1 = vm.gaussControlData[i].message;
                                vm.desconectar1Copy = angular.copy(vm.desconectar1);
                            }
                            if (vm.gaussControlData[i].nfa === 1 && vm.gaussControlData[i].action === 'B') {
                                vm.nfa1 = '4';
                                vm.bloquear1 = vm.gaussControlData[i].message;
                                vm.tolerance1 = JSON.stringify(vm.gaussControlData[i].tolerance);
                                vm.bloquear1Copy = angular.copy(vm.bloquear1);
                                vm.tolerance1Copy = angular.copy(vm.tolerance1);
                                
                            }

                            //============================ NFA2 ==================================
                            if (vm.gaussControlData[i].nfa === 2 && vm.gaussControlData[i].action === 'N') {
                                vm.nfa2 = '1';
                            }
                            if (vm.gaussControlData[i].nfa === 2 && vm.gaussControlData[i].action === 'I') {
                                vm.nfa2 = '2';
                                vm.informar2 = vm.gaussControlData[i].message;
                                vm.informar2Copy = angular.copy(vm.informar2);
                            }
                            if (vm.gaussControlData[i].nfa === 2 && vm.gaussControlData[i].action === 'D') {
                                vm.nfa2 = '3';
                                vm.desconectar2 = vm.gaussControlData[i].message;
                                vm.desconectar2Copy = angular.copy(vm.desconectar2);
                            }
                            if (vm.gaussControlData[i].nfa === 2 && vm.gaussControlData[i].action === 'B') {
                                vm.nfa2 = '4';
                                vm.bloquear2 = vm.gaussControlData[i].message;
                                vm.tolerance2 = JSON.stringify(vm.gaussControlData[i].tolerance);
                                vm.bloquear2Copy = angular.copy(vm.bloquear2);
                                vm.tolerance2Copy = angular.copy(vm.tolerance2);
                            }

                            //============================ NFA3 ==================================
                            if (vm.gaussControlData[i].nfa === 3 && vm.gaussControlData[i].action === 'N') {
                                vm.nfa3 = '1';
                            }
                            if (vm.gaussControlData[i].nfa === 3 && vm.gaussControlData[i].action === 'I') {
                                vm.nfa3 = '2';
                                vm.informar3 = vm.gaussControlData[i].message;
                                vm.informar3Copy = angular.copy(vm.informar3);
                            }
                            if (vm.gaussControlData[i].nfa === 3 && vm.gaussControlData[i].action === 'D') {
                                vm.nfa3 = '3';
                                vm.desconectar3 = vm.gaussControlData[i].message;
                                vm.desconectar3Copy = angular.copy(vm.desconectar3);
                            }
                            if (vm.gaussControlData[i].nfa === 3 && vm.gaussControlData[i].action === 'B') {
                                vm.nfa3 = '4';
                                vm.bloquear3 = vm.gaussControlData[i].message;
                                vm.tolerance3 = JSON.stringify(vm.gaussControlData[i].tolerance);
                                vm.bloquear3Copy = angular.copy(vm.bloquear3);
                                vm.tolerance3Copy = angular.copy(vm.tolerance3);
                            }

                            //============================ NFA4 ==================================
                            if (vm.gaussControlData[i].nfa === 4 && vm.gaussControlData[i].action === 'N') {
                                vm.nfa4 = '1';
                            }
                            if (vm.gaussControlData[i].nfa === 4 && vm.gaussControlData[i].action === 'I') {
                                vm.nfa4 = '2';
                                vm.informar4 = vm.gaussControlData[i].message;
                                vm.informar4Copy = angular.copy(vm.informar4);
                            }
                            if (vm.gaussControlData[i].nfa === 4 && vm.gaussControlData[i].action === 'D') {
                                vm.nfa4 = '3';
                                vm.desconectar4 = vm.gaussControlData[i].message;
                                vm.desconectar4Copy = angular.copy(vm.desconectar4);
                            }
                            if (vm.gaussControlData[i].nfa === 4 && vm.gaussControlData[i].action === 'B') {
                                vm.nfa4 = '4';
                                vm.bloquear4 = vm.gaussControlData[i].message;
                                vm.tolerance4 = JSON.stringify(vm.gaussControlData[i].tolerance);
                                vm.bloquear4Copy = angular.copy(vm.bloquear4);
                                vm.tolerance4Copy = angular.copy(vm.tolerance4);
                            }
                        }
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        function saveGaussControl() {
            //========================= NFA1 ======================//
            if (vm.nfa1 == '2' && !vm.informar1) {
                vm.showInformar1Error = true;
            }
            if (vm.nfa1 == '3' && !vm.desconectar1) {
                vm.showDesconectar1Error = true;
            }
            if (vm.nfa1 == '4' && !vm.bloquear1) {
                vm.showBloquear1Error = true;
            }
            if (vm.nfa1 == '4' && !vm.tolerance1) {
                vm.tolerance1Error = true;
            }

            //========================= NFA2 ======================//
            if (vm.nfa2 == '2' && !vm.informar2) {
                vm.showInformar2Error = true;
            }
            if (vm.nfa2 == '3' && !vm.desconectar2) {
                vm.showDesconectar2Error = true;
            }
            if (vm.nfa2 == '4' && !vm.bloquear2) {
                vm.showBloquear2Error = true;
            }
            if (vm.nfa2 == '4' && !vm.tolerance2) {
                vm.tolerance2Error = true;
            }

            //========================= NFA3 ======================//
            if (vm.nfa3 == '2' && !vm.informar3) {
                vm.showInformar3Error = true;
            }
            if (vm.nfa3 == '3' && !vm.desconectar3) {
                vm.showDesconectar3Error = true;
            }
            if (vm.nfa3 == '4' && !vm.bloquear3) {
                vm.showBloquear3Error = true;
            }
            if (vm.nfa3 == '4' && !vm.tolerance3) {
                vm.tolerance3Error = true;
            }

            //========================= NFA4 ======================//
            if (vm.nfa4 == '2' && !vm.informar4) {
                vm.showInformar4Error = true;
            }
            if (vm.nfa4 == '3' && !vm.desconectar4) {
                vm.showDesconectar4Error = true;
            }
            if (vm.nfa4 == '4' && !vm.bloquear4) {
                vm.showBloquear4Error = true;
            }
            if (vm.nfa4 == '4' && !vm.tolerance4) {
                vm.tolerance4Error = true;
            }

            if( vm.showInformar1Error || vm.showDesconectar1Error || vm.showBloquear1Error || vm.tolerance1Error ||
                vm.showInformar2Error || vm.showDesconectar2Error || vm.showBloquear2Error || vm.tolerance2Error ||
                vm.showInformar3Error || vm.showDesconectar3Error || vm.showBloquear3Error || vm.tolerance3Error ||
                vm.showInformar4Error || vm.showDesconectar4Error || vm.showBloquear4Error || vm.tolerance4Error ||
                vm.tolerance1 > 10 || vm.tolerance2 > 10 || vm.tolerance3 > 10 || vm.tolerance4 > 10) {
                    return;
                }
            var dataSend = {};
            vm.matrixArray = [];
            //============================ NFA1 =========================//
            if (vm.nfa1 === '1') {
                vm.matrixArray.push({
                    'id': 1,
                    'nfa': 1,
                    'action': 'N',
                    'message': "",
                    'tolerance':""
                })
            }
            if (vm.nfa1 === '2') {
                vm.matrixArray.push({
                    'id': 1,
                    'nfa': 1,
                    'action': 'I',
                    'message': vm.informar1,
                    'tolerance':""
                })
            }
            if (vm.nfa1 === '3') {
                vm.matrixArray.push({
                    'id': 1,
                    'nfa': 1,
                    'action': 'D',
                    'message': vm.desconectar1,
                    'tolerance':""
                })
            }
            if (vm.nfa1 === '4') {
                vm.matrixArray.push({
                    'id': 1,
                    'nfa': 1,
                    'action': 'B',
                    'message': vm.bloquear1,
                    'tolerance': (vm.tolerance1)
                })
            }

            //============================ NFA2 =========================//
            if (vm.nfa2 === '1') {
                vm.matrixArray.push({
                    'id': 2,
                    'nfa': 2,
                    'action': 'N',
                    'message': "",
                    'tolerance':""
                })
            }
            if (vm.nfa2 === '2') {
                vm.matrixArray.push({
                    'id': 2,
                    'nfa': 2,
                    'action': 'I',
                    'message': vm.informar2,
                    'tolerance':""
                })
            }
            if (vm.nfa2 === '3') {
                vm.matrixArray.push({
                    'id': 2,
                    'nfa': 2,
                    'action': 'D',
                    'message': vm.desconectar2,
                    'tolerance':""
                })
            }
            if (vm.nfa2 === '4') {
                vm.matrixArray.push({
                    'id': 2,
                    'nfa': 2,
                    'action': 'B',
                    'message': vm.bloquear2,
                    'tolerance': (vm.tolerance2)
                })
            }

            //============================ NFA3 =========================//
            if (vm.nfa3 === '1') {
                vm.matrixArray.push({
                    'id': 3,
                    'nfa': 3,
                    'action': 'N',
                    'message': "",
                    'tolerance':""
                })
            }
            if (vm.nfa3 === '2') {
                vm.matrixArray.push({
                    'id': 3,
                    'nfa': 3,
                    'action': 'I',
                    'message': vm.informar3,
                    'tolerance':""
                })
            }
            if (vm.nfa3 === '3') {
                vm.matrixArray.push({
                    'id': 3,
                    'nfa': 3,
                    'action': 'D',
                    'message': vm.desconectar3,
                    'tolerance':""
                })
            }
            if (vm.nfa3 === '4') {
                vm.matrixArray.push({
                    'id': 3,
                    'nfa': 3,
                    'action': 'B',
                    'message': vm.bloquear3,
                    'tolerance': (vm.tolerance3)
                })
            }

            //============================ NFA4 =========================//
            if (vm.nfa4 === '1') {
                vm.matrixArray.push({
                    'id': 4,
                    'nfa': 4,
                    'action': 'N',
                    'message': "",
                    'tolerance':""
                })
            }
            if (vm.nfa4 === '2') {
                vm.matrixArray.push({
                    'id': 4,
                    'nfa': 4,
                    'action': 'I',
                    'message': vm.informar4,
                    'tolerance':""
                })
            }
            if (vm.nfa4 === '3') {
                vm.matrixArray.push({
                    'id': 4,
                    'nfa': 4,
                    'action': 'D',
                    'message': vm.desconectar4,
                    'tolerance':""
                })
            }
            if (vm.nfa4 === '4') {
                vm.matrixArray.push({
                    'id': 4,
                    'nfa': 4,
                    'action': 'B',
                    'message': vm.bloquear4,
                    'tolerance': (vm.tolerance4)
                })
            }

            dataSend.access_token = $cookies.get('obj');
            dataSend.id = vm.gaussInfo.id;
            dataSend.matrixArray = vm.matrixArray;
            vm.loading = true;
            var promise = gaussControlService.updateGaussControl(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;

                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return [];
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return [];
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        $mdDialog.show({
                            templateUrl: 'app/components/dialogViews/gaussControlSuccess.html',
                            panelClass: 'gaussControlClass'
                        });
                        setTimeout(function() {
                            $mdDialog.hide();
                            $state.reload();
                        }, 3000)
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        function detectInputChange(value, type) {
            if (value && type === 'informar1') {
                vm.showInformar1Error = false;
            }
            if (value && type === 'desconectar1') {
                vm.showDesconectar1Error = false;
            }
            if (value && type === 'bloquear1') {
                vm.showBloquear1Error = false;
            }

            if (value && type === 'informar2') {
                vm.showInformar2Error = false;
            }
            if (value && type === 'desconectar2') {
                vm.showDesconectar2Error = false;
            }
            if (value && type === 'bloquear2') {
                vm.showBloquear2Error = false;
            }

            if (value && type === 'informar3') {
                vm.showInformar3Error = false;
            }
            if (value && type === 'desconectar3') {
                vm.showDesconectar3Error = false;
            }
            if (value && type === 'bloquear3') {
                vm.showBloquear3Error = false;
            }

            if (value && type === 'informar4') {
                vm.showInformar4Error = false;
            }
            if (value && type === 'desconectar4') {
                vm.showDesconectar4Error = false;
            }
            if (value && type === 'bloquear4') {
                vm.showBloquear4Error = false;
            }
        };

        function detectInputChange2(value, type) {
            if (value && type === 'tolerance1') {
                vm.tolerance1Error = false;
            }
            if (value && type === 'tolerance2') {
                vm.tolerance2Error = false;
            }
            if (value && type === 'tolerance3') {
                vm.tolerance3Error = false;
            }
            if (value && type === 'tolerance4') {
                vm.tolerance4Error = false;
            }
        };

        function checkNfaValue(nfa, value) {
            //=========================NFA1=============================//
            if (nfa === 'nfa1' && value === '1') {
                vm.informar1 = undefined;
                vm.desconectar1 = undefined;
                vm.bloquear1 = undefined;
                vm.tolerance1 = null;
                vm.showInformar1Error = false;
                vm.showDesconectar1Error = false;
                vm.showBloquear1Error = false;
                vm.tolerance1Error = false;
            }

            if (nfa === 'nfa1' && value === '2') {
                vm.desconectar1 = undefined;
                vm.bloquear1 = undefined;
                vm.tolerance1 = null;
                vm.showDesconectar1Error = false;
                vm.showBloquear1Error = false;
                vm.tolerance1Error = false;
                if(vm.gaussControlData && vm.gaussControlData.length) {
                    vm.informar1 = vm.informar1Copy;
                }
            }

            if (nfa === 'nfa1' && value === '3') {
                vm.informar1 = undefined;
                vm.bloquear1 = undefined;
                vm.tolerance1 = null;
                vm.showInformar1Error = false;
                vm.showBloquear1Error = false;
                vm.tolerance1Error = false;
                if(vm.gaussControlData && vm.gaussControlData.length) {
                    vm.desconectar1 = vm.desconectar1Copy;
                }
            }

            if (nfa === 'nfa1' && value === '4') {
                vm.informar1 = undefined;
                vm.desconectar1 = undefined;
                vm.showInformar1Error = false;
                vm.showDesconectar1Error = false;
                if(vm.gaussControlData && vm.gaussControlData.length) {
                    vm.bloquear1 = vm.bloquear1Copy;
                    vm.tolerance1 = vm.tolerance1Copy;
                }
            }

            //=========================NFA2=============================//
            if (nfa === 'nfa2' && value === '1') {
                vm.informar2 = undefined;
                vm.desconectar2 = undefined;
                vm.bloquear2 = undefined;
                vm.tolerance2 = null;
                vm.showInformar2Error = false;
                vm.showDesconectar2Error = false;
                vm.showBloquear2Error = false;
                vm.tolerance2Error = false;
            }

            if (nfa === 'nfa2' && value === '2') {
                vm.desconectar2 = undefined;
                vm.bloquear2 = undefined;
                vm.tolerance2 = null;
                vm.showDesconectar2Error = false;
                vm.showBloquear2Error = false;
                vm.tolerance2Error = false;
                if(vm.gaussControlData && vm.gaussControlData.length) {
                    vm.informar2 = vm.informar2Copy;
                }
            }

            if (nfa === 'nfa2' && value === '3') {
                vm.informar2 = undefined;
                vm.bloquear2 = undefined;
                vm.tolerance2 = null;
                vm.showInformar2Error = false;
                vm.showBloquear2Error = false;
                vm.tolerance2Error = false;
                if(vm.gaussControlData && vm.gaussControlData.length) {
                    vm.desconectar2 = vm.desconectar2Copy;
                }
            }

            if (nfa === 'nfa2' && value === '4') {
                vm.informar2 = undefined;
                vm.desconectar2 = undefined;
                vm.showInformar2Error = false;
                vm.showDesconectar2Error = false;
                if(vm.gaussControlData && vm.gaussControlData.length) {
                    vm.bloquear2 = vm.bloquear2Copy;
                    vm.tolerance2 = vm.tolerance2Copy;
                }
            }

            //=========================NFA3=============================//
            if (nfa === 'nfa3' && value === '1') {
                vm.informar3 = undefined;
                vm.desconectar3 = undefined;
                vm.bloquear3 = undefined;
                vm.tolerance3 = null;
                vm.showInformar3Error = false;
                vm.showDesconectar3Error = false;
                vm.showBloquear3Error = false;
                vm.tolerance3Error = false;
            }

            if (nfa === 'nfa3' && value === '2') {
                vm.desconectar3 = undefined;
                vm.bloquear3 = undefined;
                vm.tolerance3 = null;
                vm.showDesconectar3Error = false;
                vm.showBloquear3Error = false;
                vm.tolerance3Error = false;
                if(vm.gaussControlData && vm.gaussControlData.length) {
                    vm.informar3 = vm.informar3Copy;
                }
            }

            if (nfa === 'nfa3' && value === '3') {
                vm.informar3 = undefined;
                vm.bloquear3 = undefined;
                vm.tolerance3 = null;
                vm.showInformar3Error = false;
                vm.showBloquear3Error = false;
                vm.tolerance3Error = false;
                if(vm.gaussControlData && vm.gaussControlData.length) {
                    vm.desconectar3 = vm.desconectar3Copy;
                }
            }

            if (nfa === 'nfa3' && value === '4') {
                vm.informar3 = undefined;
                vm.desconectar3 = undefined;
                vm.showInformar3Error = false;
                vm.showDesconectar3Error = false;
                if(vm.gaussControlData && vm.gaussControlData.length) {
                    vm.bloquear3 = vm.bloquear3Copy;
                    vm.tolerance3 = vm.tolerance3Copy;
                }
            }

            //=========================NFA4=============================//
            if (nfa === 'nfa4' && value === '1') {
                vm.informar4 = undefined;
                vm.desconectar4 = undefined;
                vm.bloquear4 = undefined;
                vm.tolerance4 = null;
                vm.showInformar4Error = false;
                vm.showDesconectar4Error = false;
                vm.showBloquear4Error = false;
                vm.tolerance4Error = false;
            }

            if (nfa === 'nfa4' && value === '2') {
                vm.desconectar4 = undefined;
                vm.bloquear4 = undefined;
                vm.tolerance4 = null;
                vm.showDesconectar4Error = false;
                vm.showBloquear4Error = false;
                vm.tolerance4Error = false;
                if(vm.gaussControlData && vm.gaussControlData.length) {
                    vm.informar4 = vm.informar4Copy;
                }
            }

            if (nfa === 'nfa4' && value === '3') {
                vm.informar4 = undefined;
                vm.bloquear4 = undefined;
                vm.tolerance4 = null;
                vm.showInformar4Error = false;
                vm.showBloquear4Error = false;
                vm.tolerance4Error = false;
                if(vm.gaussControlData && vm.gaussControlData.length) {
                    vm.desconectar4 = vm.desconectar4Copy;
                }
            }

            if (nfa === 'nfa4' && value === '4') {
                vm.informar4 = undefined;
                vm.desconectar4 = undefined;
                vm.showInformar4Error = false;
                vm.showDesconectar4Error = false;
                if(vm.gaussControlData && vm.gaussControlData.length) {
                    vm.bloquear4 = vm.bloquear4Copy;
                    vm.tolerance4 = vm.tolerance4Copy;
                }
            }
        };

        function modifyGaussData() {
            vm.modifyGauss = !vm.modifyGauss;
        }

        function cancelFormBalance() {
            if(vm.modifyGauss)
            $state.reload();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('FactorMultiplicadorViewController', FactorMultiplicadorViewController);

    /** @ngInject */
    function FactorMultiplicadorViewController($cookies, $state, $log, $http, $stateParams, MY_CONSTANT, $timeout, $rootScope, $interval, $scope, adminAccessService, mapDashboard, getDrivers, getVehicles, getServices, getAgreement, getGeofence, $mdDialog, $document, $filter, factorMultiplicadorService, languageBasedErrorFactory, errorMessageFactory, getFilters, Initializer) {
        var vm = this;
        vm.event = $stateParams.event;
        vm.goBack = goBack;
        vm.viewCalendar = viewCalendar;
        vm.verExcepciones = verExcepciones;
        vm.verBloques = verBloques;
        vm.mostrarExcepciones = 0;

        getMatriz();

        function getMatriz() {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.id = $stateParams.id;
            var promise = factorMultiplicadorService.getMatriz(dataSend);
            promise.then(function (payload) {
                vm.loading = false;
                vm.matrixListOne = payload.title.data;
            }, function (errorPayload) {
                $log.log(errorPayload);
                vm.loading = false;
                if (errorPayload.data.status == 401) {
                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                } else {
                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                }
            }
            );
        }

        function goBack() {
            $state.go('layout.factorMultiplicadorMain.factorMultiplicador', {
                tipo: $stateParams.tipo,
                contractId: $stateParams.convenioId,
                corporateId: $stateParams.corporateId
            });
        }

        function viewCalendar(data) {
            $state.go('layout.factorMultiplicadorMain.factorMultiplicadorViewCalendar', {
                id: $stateParams.id,
                convenioId: $stateParams.convenioId,
                corporateId: $stateParams.corporateId,
                tipo: $stateParams.tipo,
                params: data.id
            });
        }

        function verExcepciones(){
            vm.mostrarExcepciones = 1;
        }

        function verBloques(){
            vm.mostrarExcepciones = 0;
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('factorMultiplicadorViewCalendarController', factorMultiplicadorViewCalendarController);

    /** @ngInject */
    function factorMultiplicadorViewCalendarController($cookies, $state, $log, $http, $stateParams, MY_CONSTANT, $timeout, $rootScope, $interval, $scope, adminAccessService, mapDashboard, getDrivers, getVehicles, getServices, getAgreement, getGeofence, $mdDialog, $document, $filter, factorMultiplicadorService, languageBasedErrorFactory, errorMessageFactory, getFilters, Initializer) {
        var vm = this;
        vm.event = $stateParams.event;
        vm.goBack = goBack;
        var vm = this;
        vm.count = 0;
        vm.activeFleet = [];
        vm.events = [];
        vm.params = $stateParams;
        vm.handleExceptions = handleExceptions;
        vm.exceptions = false;
        vm.handleList = handleList;
        vm.filterData = {};
        if ($cookies.get('branch')) {
            vm.filterData.branch_value = JSON.parse($cookies.get('branch'));
        }

        function goBack() {
            $state.go('layout.factorMultiplicadorMain.factorMultiplicadorView', {
                id: $stateParams.id,
                convenioId: $stateParams.convenioId,
                corporateId: $stateParams.corporateId,
                tipo: $stateParams.tipo
            });
        }

        function handleList() {
            $state.go('layout.factorMultiplicadorMain.factorMultiplicadorViewCalendar', {
                matriz: vm.params.matriz,
                sucursal: vm.sucursal
            });
        }

        function handleExceptions() {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.id = $stateParams.id;
            vm.loading = false;
            var promise = factorMultiplicadorService.getDataCalendar(dataSend);
            if (vm.exceptions === false) {
                promise.then(function (payload) {
                    vm.exceptions = true;
                    vm.loading = false;
                    vm.events = payload.title.data
                    //angular.forEach(payload.title, function (value) {
                        if (vm.events.excepciones.length > 0) {
                            angular.forEach(vm.events.excepciones, function (excepciones) {
                                $scope.events.push({
                                    id: excepciones.id,
                                    title: 'X' + excepciones.factor,
                                    start: excepciones.excepcionStart,
                                    end: excepciones.excepcionEnd,
                                    color: '#3B8C17',
                                    allDay: false
                                });
                            })
                        }
                    //});
                }, function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
                );
            }
        }

        var date = new Date();
        var d = date.getDate();
        var m = date.getMonth();
        var y = date.getFullYear();
        var w = date.getHours();

        function startAndEndOfWeek(date) {
            var now = date ? new Date(date) : new Date();
            var monday = new Date(now);
            monday.setDate(monday.getDate() - monday.getDay() + 1);
            monday.setHours(0 - 3, 0, 0)
            var sunday = new Date(now);
            sunday.setDate(sunday.getDate() - sunday.getDay() + 7);
            sunday.setHours(23 - 3, 59, 0)
            return [monday, sunday];
        }

        var week = startAndEndOfWeek(date)

        function stringToDate(stringDate) {
            var date = new Date();
            var splitDate = stringDate.split(':');
            date.setHours(splitDate[0], splitDate[1], splitDate[2]);

            return date.toLocaleTimeString();
        }

        function branchChanged(type, value) {
            console.log(value);
        }

        $scope.events = [];

        getDataCalendar();

        function getDataCalendar() {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.id = $stateParams.id;
            vm.loading = false;
            var promise = factorMultiplicadorService.getDataCalendar(dataSend);
            promise.then(function (payload) {
                vm.loading = false;
                vm.events = payload.title.data;
                //angular.forEach(payload.title, function (value) {
                    if (vm.events.bloques.length > 0) {
                        angular.forEach(vm.events.bloques, function (bloques) {
                            $scope.events.push({
                                id: bloques.id,
                                title: 'X' + bloques.factor,
                                start: bloques.bloqueStart,
                                end: bloques.bloqueEnd,
                                color: '#9C9C9C',
                                allDay: false
                            });
                        })
                    }
                //});
            }, function (errorPayload) {
                $log.log(errorPayload);
                vm.loading = false;
                if (errorPayload.data.status == 401) {
                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                } else {
                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                }
            }
            );
        }
        /* config object */
        $scope.uiConfig = {
            calendar: {
                lang: 'es',
                locale: 'es',
                height: 450,
                editable: false,
                droppable: false,
                timeFormat: 'H:mm',
                allDaySlot: false,
                nowIndicator: true,
                slotDuration: '01:00:00',
                agendaEventMinHeight: 1000,
                header: {
                    left: '',
                    center: '',
                    right: '',
                },
                allDayText: '',
                displayEventTime: false,
                displayEventEnd: true,
                slotLabelFormat: "HH:mm",
                firstDay: 1,
                scrollTime: "00:00:00",
                defaultView: 'agendaWeek',
                eventBorderColor: '#EAEAEA',
                slotEventOverlap: false,
                dayNamesShort: ['dom.', 'lun.', 'mar.', 'mié.',
                    'jue.', 'vie.', 'sáb'],
                // eventOverlap: false,
                // columnHeaderFormat: 'ddd',
                // slotLabelFormat: 'ddd',
                views: {
                    week: {
                        columnFormat: 'ddd D/M' // set format for week here
                    },
                },
            }
        };

        $scope.eventSources = [$scope.events];
    }
})();

(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('FactorMultiplicadorCreateController', FactorMultiplicadorCreateController);


    /** @ngInject */
    function FactorMultiplicadorCreateController($cookies, $state, $log, $http, $stateParams, MY_CONSTANT, $timeout, $rootScope, $interval, $scope, adminAccessService, mapDashboard, getDrivers, getVehicles, getServices, getAgreement, getGeofence, $mdDialog, $document, $filter, factorMultiplicadorService, languageBasedErrorFactory, errorMessageFactory, getFilters, Initializer, moment) {
        var vm = this;
        vm.event = $stateParams.event;
        vm.addBlock = addBlock2;
        vm.addException = addException;
        vm.handleExceptions = verExcepciones;
        vm.handleBloques = verBloques;
        vm.excepcionList = false;
        vm.goBack = goBack;
        vm.servicesList = [];
        vm.blocks = [];
        vm.exceptions = [];
        vm.removeBlock = removeBlock;
        vm.removeException = removeException;
        vm.branchChanged = branchChanged;
        vm.serviceTypeChanged = serviceTypeChanged;
        vm.date = moment().format("YYYY-MM-DD");
        vm.dataForBlock = {
            nombre: '',
            sucursal_id: undefined,
            sucursal_nb: undefined,
            type_of_service: undefined,
            type_of_service_nb: undefined,
            type_of_trip: undefined
        }
        var i = 0;
        var z = 0;
        vm.toggleCalendar = toggleCalendar;
        vm.showCalendar = false;
        console.log(vm.event);

        function getBranch() {

            vm.loading = true;
            var promise = getGeofence.branch();
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        var where = _.where(payload.title.data, {
                            parent_id: 0,
                            is_active: 1
                        });
                        vm.branchList = _.where(where, { is_active: 1 });
                        //vm.branchList = where;
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    // vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        getBranch();

        vm.type_of_trip = [
            { id: 'R' },
            { id: 'Z' },
            { id: 'P' }
        ]

        function getTypeOfService() {
            vm.loading = true;
            var promise = factorMultiplicadorService.getTypeOfService(0, 0, 2, 0);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    }
                    else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.servicesList = _.where(payload.title.data.result, { status: 1 });
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        getTypeOfService();

        function removeBlock(value) {
            var index = vm.blocks.indexOf(value);
            vm.blocks.splice(index, 1);
            if (vm.blocks.length === 0) {
                i = 0;
            }
        }

        function removeException(value) {
            var index = vm.exceptions.indexOf(value);
            vm.exceptions.splice(index, 1);
            if (vm.exceptions.length === 0) {
                z = 0;
            }
        }

        function goBack() {
            $state.go('layout.factorMultiplicadorMain.factorMultiplicador', {
                tipo: $stateParams.tipo,
                contractId: $stateParams.convenioId,
                params: {
                    corporateId: $stateParams.corporateId
                }
            });
        }


        $scope.guardar_datos = function (formInstance, e) {
            vm.obj = [];
            vm.objE = [];
            if (vm.blocks.length > 0) {

                for (var x = 0; x < vm.blocks.length; x++) {
                    var blk = vm.blocks[x];
                    if (!blk.hora_inicio || !blk.hora_fin || !blk.dia_inicio || !blk.dia_fin || !blk.factor) {
                        errorMessageFactory.showErrorMessage('Todos los campos son obligatorios.', 0);
                        return;
                    }

                    if (blk.dia_inicio > blk.dia_fin) {
                        errorMessageFactory.showErrorMessage('El día de inicio no puede ser superior al día de termino', 0);
                        return;
                    }

                    if (blk.dia_inicio == blk.dia_fin) {
                        if (blk.hora_inicio == blk.hora_fin) {
                            errorMessageFactory.showErrorMessage('La hora de termino debe ser distinta a la hora de inicio.', 0);
                            return;
                        }
                    }

                    if (vm.blocks[x + 1]) {
                        if (vm.blocks[x + 1].dia_inicio == blk.dia_inicio && vm.blocks[x + 1].dia_fin > blk.dia_inicio) {
                            if (vm.blocks[x + 1].hora_fin > blk.hora_inicio && vm.blocks[x + 1].hora_inicio < blk.hora_fin) {
                                errorMessageFactory.showErrorMessage('Ya existe un bloque horario creado entre ese rango horas.', 0);
                                return;
                            }
                        }
                    }

                    if (blk.dia_inicio == blk.dia_fin) {
                        if (blk.hora_inicio > blk.hora_fin) {
                            errorMessageFactory.showErrorMessage('La hora de termino debe ser menor a la hora de inicio.', 0);
                            return;
                        }
                    }
                }

            }

            if (vm.exceptions.length > 0) {
                for (var x = 0; x < vm.exceptions.length; x++) {
                    var blk = vm.exceptions[x];
                    var startDate = moment(blk.start_date).format("YYYY-MM-DD");
                    var endDate = moment(blk.end_date).format("YYYY-MM-DD");
                    if (!blk.hora_inicio || !blk.hora_fin || !blk.start_date || !blk.end_date || !blk.factor) {
                        errorMessageFactory.showErrorMessage('Todos los campos son obligatorios.', 0);
                        return;
                    }

                    if (blk.start_date > blk.end_date) {
                        errorMessageFactory.showErrorMessage('El día de inicio no puede ser superior al día de termino', 0);
                        return;
                    }

                    if (startDate == endDate) {
                        if (blk.hora_inicio == blk.hora_fin) {
                            errorMessageFactory.showErrorMessage('La hora de termino debe ser distinta a la hora de inicio.', 0);
                            return;
                        }
                    }


                    if (vm.exceptions[x + 1]) {
                        var start = moment(startDate + ' ' + blk.hora_inicio).format("YYYY-MM-DDTHH:mm:ss");
                        var end = moment(endDate + ' ' + blk.hora_fin).format("YYYY-MM-DDTHH:mm:ss");
                        var nextStart = moment(vm.exceptions[x + 1].start_date).format("YYYY-MM-DD");
                        var nextEnd = moment(vm.exceptions[x + 1].end_date).format("YYYY-MM-DD");
                        nextStart = moment(nextStart + ' ' + vm.exceptions[x + 1].hora_inicio).format("YYYY-MM-DDTHH:mm:ss");
                        nextEnd = moment(nextEnd + ' ' + vm.exceptions[x + 1].hora_fin).format("YYYY-MM-DDTHH:mm:ss");
                        if (start == nextStart || end == nextEnd) {
                            errorMessageFactory.showErrorMessage('Ya existe una excepción horario creado entre ese rango horas.', 0);
                            return;
                        }
                    }

                    if (startDate == endDate) {
                        if (blk.hora_inicio > blk.hora_fin) {
                            errorMessageFactory.showErrorMessage('La hora de inicio debe ser menor a la hora de termino.', 0);
                            return;
                        }
                    }
                }

            }


            for (var x = 0; x < vm.blocks.length; x++) {
                if (vm.id) {
                    vm.obj.push({ id: Number(vm.blocks[x].id), diaInicio: vm.blocks[x].dia_inicio, diaFin: vm.blocks[x].dia_fin, horaInicio: vm.blocks[x].hora_inicio, horaFin: vm.blocks[x].hora_fin, factor: vm.blocks[x].factor });
                } else {
                    vm.obj.push({ diaInicio: vm.blocks[x].dia_inicio, diaFin: vm.blocks[x].dia_fin, horaInicio: vm.blocks[x].hora_inicio, horaFin: vm.blocks[x].hora_fin, factor: vm.blocks[x].factor });
                }
            }
            for (var x = 0; x < vm.exceptions.length; x++) {
                if (vm.exceptions[x].id) {
                    vm.objE.push({ id: Number(vm.exceptions[x].id), fechaInicio: vm.exceptions[x].start_date, fechaFin: vm.exceptions[x].end_date, horaInicio: vm.exceptions[x].hora_inicio, horaFin: vm.exceptions[x].hora_fin, factor: vm.exceptions[x].factor });
                } else {
                    vm.objE.push({ fechaInicio: vm.exceptions[x].start_date, fechaFin: vm.exceptions[x].end_date, horaInicio: vm.exceptions[x].hora_inicio, horaFin: vm.exceptions[x].hora_fin, factor: vm.exceptions[x].factor });
                }
            }

            vm.loading = true;
            var toSend = {};
            var promise;
            toSend.access_token = $cookies.get('obj');
            toSend.nombre = vm.dataForBlock.nombre;
            toSend.sucursalId = vm.dataForBlock.sucursal_id;
            toSend.sucursalNb = vm.dataForBlock.sucursal_nb;
            toSend.tipoServicioId = vm.dataForBlock.type_of_service;
            toSend.tipoServicioNb = vm.dataForBlock.type_of_service_nb;
            toSend.tipoViaje = vm.dataForBlock.type_of_trip;
            toSend.convenioId = $stateParams.convenioId;
            toSend.listType = $stateParams.tipo;
            toSend.bloques = vm.obj;
            toSend.excepciones = vm.objE;
            console.log(toSend);
            if (vm.id) {
                toSend.id = vm.id;
                promise = fleetCapacityMatrixService.updateMatrix(toSend);
            } else {
                promise = factorMultiplicadorService.addMatrix(toSend);
            }
            promise.then(function (payload) {
                $log.log('sxdsads', payload);
                console.log('sxdsads', payload)
                vm.loading = false;
                // if(vm.params.exception){
                //     if(vm.id){
                //         guardarExcepcion(vm.id)
                //     }else {
                //         guardarExcepcion(payload.title.data.matriz_id)
                //     }
                // }

                if (payload.title.status == 400) {
                    errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    return [];
                } else if (payload.title.status == 401) {
                    errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    return [];
                }
                else if (payload.title.status == 200 || payload.title.status == 201) {
                    if (vm.id) {
                        languageBasedErrorFactory.getProperErrorMessage('factorMultiplicadorUpdateSucc', 0, 2, 'layout.factorMultiplicadorMain.factorMultiplicador');
                    } else {
                        languageBasedErrorFactory.getProperErrorMessage('factorMultiplicadorCreateSucc', 0, 2, 'layout.factorMultiplicadorMain.factorMultiplicador');
                    }
                    $state.go('layout.factorMultiplicadorMain.factorMultiplicador', {
                        tipo: $stateParams.tipo,
                        contractId: $stateParams.convenioId,
                        params: {
                            corporateId: $stateParams.corporateId
                        }
                    });
                    //guardarExcepcion(payload.title.data.matriz_id)
                    // if(vm.params.exception){
                    //     if(vm.id){
                    //         guardarExcepcion(vm.id)
                    //     }else {
                    //         guardarExcepcion(payload.title.data.matriz_id)
                    //     }
                    // }

                }

            }, function (errorPayload) {
                console.log(errorPayload);
                vm.loading = false;
                if (errorPayload.data.status == 401) {
                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                } else {
                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                }
            }


            );
            vm.obj = [];

        }


        function addBlock() {
            vm.isAdd = !vm.isAdd;
            vm.editBlockId = 0;
            vm.dataForBlock = {
                sucursal_id: vm.dataForBlock.sucursal_id,
                dia_inicio: '',
                dia_fin: '',
                cupos: '',
                fecha_inicio: {
                    hora: '00:00',
                    minute: '00'
                },
                fecha_fin: {
                    hora: '01:00',
                    minute: '15'
                },
            };
        }

        function addBlock2() {
            if (i == 0 || (vm.blocks[vm.blocks.length - 1].dia_inicio &&
                vm.blocks[vm.blocks.length - 1].dia_fin && vm.blocks[vm.blocks.length - 1].hora_inicio &&
                vm.blocks[vm.blocks.length - 1].hora_fin)) {
                i = i + 1;
                var dataForBlock = {
                    id: i,
                    dia_inicio: '',
                    dia_fin: '',
                    hora_inicio: '00:00',
                    hora_fin: '00:00',
                    factor: '0.00'
                };
                vm.blocks.push(dataForBlock);
            } else {
                errorMessageFactory.showErrorMessage('Debe agregar todos los datos', 0);
                return;
            }
        }

        function addException() {
            if (z == 0 || (vm.exceptions[vm.exceptions.length - 1].start_date &&
                vm.exceptions[vm.exceptions.length - 1].end_date && vm.exceptions[vm.exceptions.length - 1].hora_inicio &&
                vm.exceptions[vm.exceptions.length - 1].hora_fin)) {

                z = z + 1;
                var dataForException = {
                    start_date: '',
                    end_date: '',
                    hora_inicio: '00:00',
                    hora_fin: '00:00',
                    factor: '0.00'
                };
                vm.exceptions.push(dataForException);
            } else {
                errorMessageFactory.showErrorMessage('Debe agregar todos los datos', 0);
                return;
            }
        }

        function verExcepciones() {
            vm.excepcionList = true;
        }

        function verBloques() {
            vm.excepcionList = false;
        }

        function branchChanged(event) {
            vm.dataForBlock.sucursal_nb = event.region_name;
        }

        function serviceTypeChanged(event) {
            vm.dataForBlock.type_of_service_nb = event.service_name;
        }

        vm.hoursArray = [{
            value: 0,
            id: '00:00'
        },
        {
            value: 1,
            id: '01:00'
        },
        {
            value: 2,
            id: '02:00'
        },
        {
            value: 3,
            id: '03:00'
        },
        {
            value: 4,
            id: '04:00'
        },
        {
            value: 5,
            id: '05:00'
        },
        {
            value: 6,
            id: '06:00'
        },
        {
            value: 7,
            id: '07:00'
        },
        {
            value: 8,
            id: '08:00'
        },
        {
            value: 9,
            id: '09:00'
        },
        {
            value: 10,
            id: '10:00'
        },
        {
            value: 11,
            id: '11:00'
        },
        {
            value: 12,
            id: '12:00'
        },
        {
            value: 13,
            id: '13:00'
        },
        {
            value: 14,
            id: '14:00'
        },
        {
            value: 15,
            id: '15:00'
        },
        {
            value: 16,
            id: '16:00'
        },
        {
            value: 17,
            id: '17:00'
        },
        {
            value: 18,
            id: '18:00'
        },
        {
            value: 19,
            id: '19:00'
        },
        {
            value: 20,
            id: '20:00'
        },
        {
            value: 21,
            id: '21:00'
        },
        {
            value: 22,
            id: '22:00'
        },
        {
            value: 23,
            id: '23:00'
        }
        ]

        var date = new Date();
        var d = date.getDate();
        var m = date.getMonth();
        var y = date.getFullYear();
        var w = date.getHours();

        function startAndEndOfWeek(date) {
            var now = date ? new Date(date) : new Date();
            var monday = new Date(now);
            monday.setDate(monday.getDate() - monday.getDay() + 1);
            monday.setHours(0 - 3, 0, 0)
            var sunday = new Date(now);
            sunday.setDate(sunday.getDate() - sunday.getDay() + 7);
            sunday.setHours(23 - 3, 59, 0)
            return [monday, sunday];
        }

        var week = startAndEndOfWeek(date)

        function stringToDate(stringDate) {
            var date = new Date();
            var splitDate = stringDate.split(':');
            date.setHours(splitDate[0], splitDate[1], splitDate[2]);

            return date.toLocaleTimeString();
        }

        $scope.events = [];
        function toggleCalendar() {
            vm.showCalendar = !vm.showCalendar;
            if (vm.showCalendar == true) {
                angular.forEach(vm.blocks, function (value) {
                    if (value.dia_inicio !== '' && value.dia_fin !== '') {
                        var diaInicio = value.dia_inicio;
                        var diaFin = value.dia_fin;
                        var horaInicio = value.hora_inicio;
                        var horaFin = value.hora_fin;
                        var di = diaInicio == 7 ? 0 : diaInicio;
                        var df = diaFin == 7 ? 0 : diaFin;
                        var weekd = week;
                        if (di == 7) {
                            week++;
                        }
                        if (df == 7) {
                            weekd++
                        }
                        var fullDayI = moment().week(week).isoWeekday(diaInicio).format("YYYY-MM-DD");
                        var fullDayF = moment().week(weekd).isoWeekday(diaFin).format("YYYY-MM-DD");
                        var start = moment(fullDayI + ' ' + horaInicio).format("YYYY-MM-DDTHH:mm:ss");
                        var end = moment(fullDayF + ' ' + horaFin).format("YYYY-MM-DDTHH:mm:ss");
                        $scope.events.push({
                            idBloque: value.id,
                            title: 'X' + value.factor,
                            start: start,
                            end: end,
                            color: '#9C9C9C',
                            allDay: false
                        });
                    }
                });
                angular.forEach(vm.exceptions, function (value) {
                    if (value.start_date !== '' && value.end_date !== '') {
                        var diaInicio = value.start_date;
                        var diaFin = value.end_date;
                        var horaInicio = value.hora_inicio;
                        var horaFin = value.hora_fin;
                        var separarHoraInicio = horaInicio.split(':');
                        var separarHorafin = horaFin.split(':');
                        diaInicio = moment(diaInicio).set({ 'hour': separarHoraInicio[0], 'minute': separarHoraInicio[1], 'second': separarHoraInicio[2] }).format("YYYY-MM-DD[T]HH:mm:ss");
                        diaFin = moment(diaFin).add({ 'hour': separarHorafin[0], 'minute': separarHorafin[1], 'second': separarHorafin[2] }).format("YYYY-MM-DD[T]HH:mm:ss");
                        $scope.events.push({
                            idExcepcion: value.id,
                            title: 'X' + value.factor,
                            start: diaInicio,
                            end: diaFin,
                            color: '#3B8C17',
                            allDay: false
                        });
                    }
                });
            } else {
                $scope.events.splice(0, $scope.events.length)
            }
        }

        $scope.calendarOptions = {
            lang: 'es',
            locale: 'es',
            height: 450,
            editable: false,
            droppable: false,
            timeFormat: 'H:mm',
            allDaySlot: false,
            nowIndicator: true,
            slotDuration: '01:00:00',
            agendaEventMinHeight: 1000,
            header: {
                left: '',
                center: '',
                right: '',
            },
            allDayText: '',
            displayEventTime: false,
            displayEventEnd: true,
            slotLabelFormat: "HH:mm",
            firstDay: 1,
            scrollTime: "00:00:00",
            defaultView: 'agendaWeek',
            eventBorderColor: '#EAEAEA',
            slotEventOverlap: false,
            dayNamesShort: ['dom.', 'lun.', 'mar.', 'mié.',
                'jue.', 'vie.', 'sáb'],
            // eventOverlap: false,
            // columnHeaderFormat: 'ddd',
            // slotLabelFormat: 'ddd',
            views: {
                week: {
                    columnFormat: 'ddd D/M' // set format for week here
                },
            },
        };
        $scope.eventSources = [$scope.events];
    }


})();

(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('FactorMultiplicadorController', FactorMultiplicadorController);


    /** @ngInject */
    function FactorMultiplicadorController($cookies, $state, $log, $http, $stateParams, MY_CONSTANT, $timeout, $rootScope, $interval, $scope, adminAccessService, mapDashboard, getDrivers, getVehicles, getServices, getAgreement, getGeofence, $mdDialog, $document, $filter, factorMultiplicadorService, languageBasedErrorFactory, errorMessageFactory, getFilters, Initializer) {
        var vm = this;
        vm.event = $stateParams.event;
        vm.gotoCreate = gotoCreate;
        vm.gotoEdit = gotoEdit;
        vm.goBack = goBack;
        vm.activarMatriz = activarMatriz;
        vm.eliminarMatriz = eliminarMatriz;
        vm.viewMatriz = goToMatriz;



        console.log(vm.event);

        getMatrices();

        function getMatrices() {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.convenio_id = $stateParams.contractId;
            dataSend.tipo = $stateParams.tipo;
            var promise = factorMultiplicadorService.getMatrices(dataSend);
            promise.then(function (payload) {
                vm.loading = false;
                vm.matrixList = payload.title.data;
            }, function (errorPayload) {
                $log.log(errorPayload);
                vm.loading = false;
                if (errorPayload.data.status == 401) {
                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                } else {
                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                }
            }
            );
        }

        function gotoCreate() {
            //console.log(vm.filterData);
            //localStorage.setItem('searchingFilter', JSON.stringify(vm.filterData));
            $state.go('layout.factorMultiplicadorMain.factorMultiplicadorCreate', {
                id: 1,
                convenioId: $stateParams.contractId,
                corporateId: $stateParams.corporateId,
                tipo: $stateParams.tipo
            });
        }

        function gotoEdit() {
            errorMessageFactory.showErrorMessage('Funcionalidad pendiente');
        }

        function goBack() {
            if ($stateParams.tipo == 1) {
                $state.go('layout.agreementMain.priceListFixedAgreement', {
                    corporateId: $stateParams.corporateId,
                    contractId: $stateParams.contractId,
                });
            } else {
                $state.go('layout.agreementMain.priceListVariableAgreement', {
                    corporateId: $stateParams.corporateId,
                    contractId: $stateParams.contractId,
                });
            }
        }

        function activarMatriz(data, $event) {
            vm.loading = true;
            var promise = adminAccessService.checkStateValid('Activar factor multiplicador');
            return promise.then(
                function (payload) {
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (!payload.title.data.granted) {
                            languageBasedErrorFactory.getProperErrorMessage('optionNotAvail', 0, 0);
                            //errorMessageFactory.showErrorMessage('Option not available because you not have the right',0);
                            return false;
                        } else {
                            var dataSend = {};
                            dataSend.access_token = $cookies.get('obj');
                            dataSend.id = data.id;
                            dataSend.tipoViaje = data.tipoViaje;
                            dataSend.tipoServicioId = data.tipoServicioId;
                            dataSend.sucursalId = data.sucursalId;
                            dataSend.convenioId = $stateParams.contractId;
                            dataSend.tipo = $stateParams.tipo;
                            var promise = factorMultiplicadorService.activarMatriz(dataSend);
                            promise.then(function (payload) {
                                $log.log(payload);
                                getMatrices();
                                vm.loading = false;
                            }, function (errorPayload) {
                                $log.log(errorPayload);
                                vm.loading = false;
                                if (errorPayload.data.status == 401) {
                                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                                } else if (errorPayload.data.status == 409) {
                                    vm.loading = false;
                                    $log.log('confirmed 1', data, data.id);

                                    var confirm = $mdDialog.confirm()
                                        .title(languageBasedErrorFactory.getProperErrorMessage('matrizActive', 0, '3'))
                                        .textContent('')
                                        .ariaLabel('Lucky day')
                                        .targetEvent($event)
                                        .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                                        .cancel(languageBasedErrorFactory.getProperErrorMessage('cancelButton', 0, '3'));

                                    $mdDialog.show(confirm).then(function () {
                                        $log.log('confirmed 1', data, data.id);
                                        var dataSend = {};
                                        dataSend.access_token = $cookies.get('obj');
                                        dataSend.id = data.id;
                                        dataSend.forceId = errorPayload.data.forceId;
                                        dataSend.tipoViaje = data.tipoViaje;
                                        dataSend.tipoServicioId = data.tipoServicioId;
                                        dataSend.sucursalId = data.sucursalId;
                                        dataSend.convenioId = $stateParams.params.contractId;
                                        dataSend.tipo = $stateParams.tipo;
                                        vm.loading = true;
                                        var promise = factorMultiplicadorService.activarMatriz(dataSend);
                                        promise.then(
                                            function (payload) {
                                                $log.log(payload);
                                                getMatrices();
                                                vm.loading = false;
                                            },
                                            function (errorPayload) {
                                                $log.log(errorPayload);
                                                vm.loading = false;
                                                if (errorPayload.data.status == 401) {
                                                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                                                }
                                                else {
                                                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                                                }
                                            }
                                        );
                                    })

                                } else {
                                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                                }
                            }
                            );
                        }
                    }
                },
                function (errorPayload) {
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );

            vm.loading = true;

        }

        function eliminarMatriz(data, $event) {
            vm.loading = true;
            var promise = adminAccessService.checkStateValid('Eliminar matriz factor multiplicador');
            return promise.then(function (payload) {
                vm.loading = false;
                if (payload.title.status == 400) {
                    errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    return false;
                } else if (payload.title.status == 401) {
                    errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    return false;
                } else if (payload.title.status == 201 || payload.title.status == 200) {
                    if (!payload.title.data.granted) {
                        languageBasedErrorFactory.getProperErrorMessage('optionNotAvail', 0, 0);
                        return false;
                    } else {
                        var dialog = '';
                        if (data.isActive == 1) {
                            dialog = 'deleteMatrixActive';
                        } else {
                            dialog = 'deleteMatrixInactive';
                        }
                        var confirm = $mdDialog.confirm()
                            .title(languageBasedErrorFactory.getProperErrorMessage(dialog, 0, '3'))
                            .textContent('')
                            .ariaLabel('Lucky day')
                            .targetEvent($event)
                            .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                            .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));
                        $mdDialog.show(confirm).then(function () {
                            $log.log('confirmed 1', data, data.id);
                            var dataSend = {};
                            dataSend.access_token = $cookies.get('obj');
                            dataSend.id = data.id;
                            vm.loading = true;
                            var promise = factorMultiplicadorService.eliminarMatriz(dataSend);
                            promise.then(
                                function (payload) {
                                    $log.log(payload);
                                    getMatrices();
                                    vm.loading = false;
                                },
                                function (errorPayload) {
                                    $log.log(errorPayload);
                                    vm.loading = false;
                                    if (errorPayload.data.status == 401) {
                                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                                    }
                                    else {
                                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                                    }
                                }
                            );
                        })
                    }
                }
            })
        }

        function goToMatriz(data) {
            $state.go('layout.factorMultiplicadorMain.factorMultiplicadorView', {
                id: data.id,
                convenioId: $stateParams.contractId,
                corporateId: $stateParams.corporateId,
                tipo: $stateParams.tipo
            });
        };

    }


})();

/**
 * Created by Ashish Garg on 1/11/18.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('ExpenseControlReportController', ExpenseControlReportController);

    /** @ngInject */
    function ExpenseControlReportController($scope, $cookies, getAgreement, getFilters, $timeout, RutHelper, pendingRequests, $document, $mdDialog, getExpenseControlData, errorMessageFactory, getGeofence, $log, getServices, getVehicles, languageBasedErrorFactory) {
        var vm = this;
        vm.loading = false;
        vm.resetFilter = resetFilter;
        vm.slideData = slideData;
        vm.selectAll = selectAll;
        vm.paginationChangedForAgreement = paginationChangedForAgreement;
        vm.agreement = [];
        vm.agreementSearch = agreementSearch;
        languageBasedErrorFactory.getTranslationStrings(runThis);
        vm.selectingItemOfCharges = selectingItemOfCharges;
        vm.showGraphFunction = showGraphFunction;
        vm.back = back;
        vm.selectAllAgreement = false;
        vm.showGraph = false;
        vm.datePicker_1 = {
            pickupDate: false
        };

        Array.prototype.insert = function (index, item) {
            this.splice(index, 0, item);
        };

        vm.filterData = {
            branch_filter: 0, //0, 1
            service_filter: 0, //0, 1
            vehicle_filter: 0, //0, 1
            aggrement_filter: 0, //0, 1
            //date_time_filter : 1,  //0, 1
            branch: 'all',
            service: 'all',
            vehicle: 'all',
            //date_time_value: '',
            agreement: [],
            // type_of_trip: 'all',
            type_of_trip_filter: 0,
            limit: vm.itemsPerPageGot,
            offset: 0,
            booking_status: 0,
            search_filter: 0,
            search_value: '',
            searchBookingId: '',
            searchPackageId: '',
            agreementSearch: '',
            agreementValue: 0,
            searchByName: 0,
            search: '',
            bookingStateFilter: 0,
            bookingStateValue: -1,
            itemsPerPageSelected: 25,
            region_id: 'all',
            agreementStatus: '1',
            corporate_id: 'all'
        };

        function runThis() {
            vm.typeTripFilter = [{
                    name: languageBasedErrorFactory.getProperErrorMessage('fromAirport', 0, '3'),
                    id: 'Z'
                },
                {
                    name: languageBasedErrorFactory.getProperErrorMessage('toAirport', 0, '3'),
                    id: 'R'
                },
                {
                    name: languageBasedErrorFactory.getProperErrorMessage('pointToPoint', 0, '3'),
                    id: 'P'
                }
            ]
        }

        //====================function for dropdown pages and page count===============
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];

        vm.corporateOffset = 0;
        vm.agreementOffset = 0;
        vm.globalLimit = 25;
        vm.globalOffset = vm.globalLimit;
        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'vehicle', 'service', 'agreement', 'corporatesList', 'operation_point'];
        vm.branchList = [];
        vm.branchList.push({
            region_name: 'Todos',
            region_id: 'all'
        });

        vm.corporatesList = [];
        vm.corporatesList.push({
            company_name: 'All',
            id: 'all'
        });

        function slideData() {
            $('#derp').slideToggle(1000);
            document.getElementById('toDate').value = moment(vm.filterData.filter_pickup_to_date_value).format('DD-MMMM-YYYY');
            document.getElementById('fromDate').value = moment(vm.filterData.filter_pickup_from_date_value).format('DD-MMMM-YYYY');
            vm.filterData.searchByName = 0;
        }




        setTimeout(function () {
            document.getElementsByClassName('ui-select-search')[2].addEventListener('blur', function ($event) {
                // if (vm.agreement && (vm.agreement.length == 0)) {
                vm.searchAgreementData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

        })
        // =================== GET FILTER DATA ===================
        function getFilterDataFromBackend(data, type) { //Acc to Index ['branch_search', 'vehicle_search', 'service_search', 'agreement_search', 'corporate_search', 'operation_point_search']
            if (data) {
                vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
            } else {
                vm.filterObject = {
                    agreement_status: 2,
                    agreement_filter: 1,
                    agreement_limit: vm.globalLimit,
                    agreement_offset: vm.agreementOffset,
                    access_token: $cookies.get('obj')
                }
            }

            vm.filterObject.agreement_limit = vm.globalLimit;
            vm.filterObject.agreement_offset = vm.agreementOffset;
            var promise = getFilters.getAllFilterData(vm.filterObject);
            promise.then(
                function (payload) {
                    console.log(payload);

                    // ********** BRANCH DATA ********
                    // *********** AGREEMENT DATA *********
                    if (payload.title.data.agreements) {
                        var index = _.findIndex(vm.agreement, {
                            id: 'all'
                        });
                        if (index == -1)
                            // vm.agreement.push({
                            //     name: 'All',
                            //     id: 'all'
                            // });
                            vm.agreementTotalBackendCount = payload.title.data.agreements.totalCount;
                        angular.forEach(payload.title.data.agreements.data, function (column) {
                            //CHECK FOR DUPLICATE ENTRY
                            var agreementIndex = _.findIndex(vm.agreement, {
                                id: column.id
                            });
                            if (agreementIndex == -1)
                                vm.agreement.push({
                                    id: column.id,
                                    name: column.name
                                });
                        });
                    }

                    vm.loading = false;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        }
        getFilterDataFromBackend();


        // ************ PAGINATION ON AGREEMENT **************
        function paginationChangedForAgreement() {
            var index = _.findIndex(vm[vm.searchFilterArray[3]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.agreementTotalBackendCount > (vm.agreement.length - index)) {
                commonFunction(3);
                vm.agreementOffset += vm.globalOffset;
                getFilterDataFromBackend(vm.searchAgreementData, 3);
            }
        }

        // *********** COMMON FUNCTION FOR FILTER PAGINATION AND SEARCHING ***********
        function commonFunction(type, mode) {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                // vm['search' + vm.searchFilterArray[i] + 'Data'] = '';
                if (mode == 'search' || i != type) {
                    vm[vm.searchFilterArray[i]] = [];
                    // vm[vm.searchFilterArray[i]].push({
                    //     id: 'all',
                    //     name: 'All'
                    // });
                    vm[vm.searchFilterArray[i] + 'Offset'] = 0;
                    vm['search' + vm.searchFilterArray[i].substring(0, 1).toUpperCase() + vm.searchFilterArray[i].substring(1) + 'Data'] = '';
                }
            }
        }

        // ************ SEARCH AGREEMENT ***************
        function agreementSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchAgreementData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(3, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 3);
                }, 2000);
            }
        }

        // ******** CLEAR OFFSET *******
        function clearOffset() {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                vm[vm.searchFilterArray[i] + 'Offset'] = 0;
            }
        }
        //====================get branch list====================
        function getBranch() {
            vm.loading = true;
            var promise = getGeofence.branch();
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        var where = _.where(payload.title.data, {
                            parent_id: 0
                        });
                        vm.branchList = where;

                        vm.branchList.push({
                            region_name: 'Todos',
                            region_id: 'all'
                        });
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        getBranch();


        function resetFilter() {
            vm.currentPage = 0;
            vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            vm.filterData = {
                service_filter: 0, //0, 1
                vehicle_filter: 0, //0, 1
                aggrement: 0, //0, 1
                type_of_trip: 0, //0, 1
                branch: 'all',
                service: 'all',
                vehicle: 'all',
                agreement: [],
                limit: vm.itemsPerPageGot,
                offset: 0,
                booking_status: 0,
                searchBookingId: '',
                searchPackageId: '',
                agreementSearch: '',
                agreementValue: 0,
                searchByName: 0,
                search: '',
                itemsPerPageSelected: 25
            };
        }

        // //======================get all Agreement==============
        // function getAllAgreement(skip, limt) {
        //     var dataSend = {};
        //     dataSend.access_token = $cookies.get('obj');
        //     dataSend.offset = skip;
        //     dataSend.limit = limt;
        //     dataSend.key = 3;
        //     vm.loading = true;

        //     var promise = getAgreement.getAgreementListLessData(dataSend);
        //     promise.then(
        //         function (payload) {
        //             $log.log('sxdsads', payload);
        //             vm.loading = false;
        //             if (payload.title.status == 400) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //             } else if (payload.title.status == 401) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //             } else if (payload.title.status == 201 || payload.title.status == 200) {
        //                 vm.agreement = [];
        //                 angular.forEach(payload.title.data, function (column) {
        //                     vm.agreement.push({
        //                         id: column.id,
        //                         name: column.name
        //                     });
        //                 });
        //             }
        //         },
        //         function (errorPayload) {
        //             $log.log(errorPayload);
        //             vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // };
        // getAllAgreement(0, 0);

        $scope.getMonth = function (month) {
            var day;
            switch (month) {
                case '1':
                    day = 'ene'
                    break;
                case '2':
                    day = 'feb'
                    break;
                case '3':
                    day = 'mar'
                    break;
                case '4':
                    day = 'abr'
                    break;
                case '5':
                    day = 'Mayo'
                    break;
                case '6':
                    day = 'jun'
                    break;
                case '7':
                    day = 'jul'
                    break;
                case '8':
                    day = 'ago'
                    break;
                case '9':
                    day = 'sep'
                    break;
                case '10':
                    day = 'oct'
                    break;
                case '11':
                    day = 'nov'
                    break;
                case '12':
                    day = 'dic'
                    break;
                case '01':
                    day = 'ene'
                    break;
                case '02':
                    day = 'feb'
                    break;
                case '03':
                    day = 'mar'
                    break;
                case '04':
                    day = 'abr'
                    break;
                case '05':
                    day = 'Mayo'
                    break;
                case '06':
                    day = 'jun'
                    break;
                case '07':
                    day = 'jul'
                    break;
                case '08':
                    day = 'ago'
                    break;
                case '09':
                    day = 'sep'
                    break;
                case '10':
                    day = 'oct'
                    break;
                case '11':
                    day = 'nov'
                    break;
                case '12':
                    day = 'dic'
                    break;
                case 'ene':
                    day = '01'
                    break;
                case 'feb':
                    day = '02'
                    break;
                case 'mar':
                    day = '03'
                    break;
                case 'abr':
                    day = '04'
                    break;
                case 'Mayo':
                    day = '05'
                    break;
                case 'jun':
                    day = '06'
                    break;
                case 'jul':
                    day = '07'
                    break;
                case 'ago':
                    day = '08'
                    break;
                case 'sep':
                    day = '09'
                    break;
                case 'oct':
                    day = '10'
                    break;
                case 'nov':
                    day = '11'
                    break;
                case 'dic':
                    day = '12'
                    break;
            }
            return day;
        }
        // **************************************************************************
        // ***************** SOURCE LINK TO ACCESS ANGULAR GRAPH ********************
        // ************ http://jtblin.github.io/angular-chart.js/#top ***************
        // **************************************************************************
        $scope.colors = ['#ffff00', '#ff0000', '#000080']; // TO SET COLOR OF GRAPH
        $scope.datasetOverride = []; // TO SET BAR GRAPH AND LINE GRAPH
        $scope.data = []; // TO PASS DATA IN GRAPH
        $scope.labels = []; // TO SET LABEL OF Y AXIS
        $scope.options = {
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true
                    }
                }],
                xAxes: [{
                    ticks: {
                        autoSkip: false
                    }
                }]
            }
        };

        // ****** GET GRAPH DATA FROM BACKEND *******
        function getDataForChart(date) {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.agreements = [];
            dataSend.agreements = JSON.stringify(vm.filterData.agreement);
            if (date) {
                dataSend.month = $scope.getMonth(date.split('-')[0]);
                dataSend.year = date.split('-')[1];
            }
            if (vm.filterData.branch > 0)
                dataSend.branch = vm.filterData.branch;
            if (vm.filterData.type_of_trip)
                dataSend.trip_type = vm.filterData.type_of_trip;
            var promise = getExpenseControlData.getDataForChart(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.showGraph = false;
                    // RESET GRAPH TO CLEAR ALL DATA
                    $scope.datasetOverride = [];
                    $scope.data = [];
                    $scope.labels = [];
                    $scope.colors = ['#ffff00', '#ff0000', '#000080'];

                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (!payload.title.data.is_month) { // FOR 13 MONTH GRAPH
                            // ******** BLOCK OF CODE IS TO ADD DEFAULT 0 VALUE FOR MONTHs THAT ARE NOT COMING FROM BACKEND ******
                            var yearForThirteenMonth = new Date().getFullYear() - 1;
                            var monthForThirteenMonth;
                            for (var i = 1; i <= 13; i++) {
                                if ((new Date().getMonth() + i) < 13) {
                                    monthForThirteenMonth = yearForThirteenMonth + '-' + (new Date().getMonth() + i);
                                } else {
                                    if (yearForThirteenMonth < new Date().getFullYear())
                                        yearForThirteenMonth += 1;
                                    monthForThirteenMonth = yearForThirteenMonth + '-' + (((new Date().getMonth() + i) - 12) < 10 ? '0' + ((new Date().getMonth() + i) - 12) : ((new Date().getMonth() + i) - 12));
                                }
                                var index = _.findIndex(payload.title.data.result, {
                                    dates: monthForThirteenMonth
                                })
                                if (index == -1) {
                                    payload.title.data.result.insert(i - 1, {
                                        dates: monthForThirteenMonth,
                                        amount: 0,
                                        budget: 0,
                                        warning_budget: 0
                                    });
                                }
                            }
                            // *********** END BLOCK OF CODE IS TO ADD DEFAULT 0 VALUE FOR MONTHs THAT ARE NOT COMING FROM BACKEN *******

                            if (vm.filterData.agreement.length == 1) { // IF ONLY ONE AGREEMENT IS SELECTED

                                $scope.datasetOverride.push({
                                    label: languageBasedErrorFactory.getProperErrorMessage('warningAmount', 0, '3'),
                                    borderWidth: 2,
                                    hoverBackgroundColor: "yellow",
                                    hoverBorderColor: "yellow",
                                    type: 'line',
                                    fill: false
                                }, {
                                    label: languageBasedErrorFactory.getProperErrorMessage('budgetAmount', 0, '3'),
                                    borderWidth: 2,
                                    hoverBackgroundColor: "red",
                                    hoverBorderColor: "red",
                                    type: 'line',
                                    fill: false
                                }, {
                                    label: languageBasedErrorFactory.getProperErrorMessage('reportAmount', 0, '3'),
                                    borderWidth: 1,
                                    type: 'bar'
                                });
                                $scope.data.push([], [], []);
                                payload.title.data.result.forEach(function (object) {
                                    var date = object.dates.split('-');
                                    date[1] = $scope.getMonth(date[1]);
                                    object.dates = date[1] + '-' + date[0];
                                    $scope.labels.push(object.dates);
                                    $scope.data[0].push(object.warning_budget || 0);
                                    $scope.data[1].push(object.budget || 0);
                                    $scope.data[2].push(object.amount || 0);
                                });
                            } else {
                                $scope.colors = ['#000080'];
                                $scope.datasetOverride.push({
                                    label: languageBasedErrorFactory.getProperErrorMessage('reportAmount', 0, '3'),
                                    borderWidth: 1,
                                    type: 'bar'
                                });
                                $scope.data.push([]);
                                payload.title.data.result.forEach(function (object) {
                                    var date = object.dates.split('-');
                                    date[1] = $scope.getMonth(date[1]);
                                    object.dates = date[1] + '-' + date[0];
                                    $scope.labels.push(object.dates);
                                    $scope.data[0].push(object.amount || 0);
                                });
                            }
                            $scope.is_per_month = false;
                        } else {
                            vm.monthShowInHeader = date.split('-')[0];
                            vm.yearShowInHeader = date.split('-')[1];
                            // ******** BLOCK OF CODE IS TO ADD DEFAULT 0 VALUE FOR DAYs THAT ARE NOT COMING FROM BACKEND ******
                            var noOfDays = daysInMonth($scope.getMonth(date.split('-')[0]), date.split('-')[1]);
                            var maxBudget;
                            var maxWarning;
                            for (var i = 1; i <= noOfDays; i++) {
                                if (payload.title.data.result[i - 1] && payload.title.data.result[i - 1].amount > 0) {
                                    if (payload.title.data.result[i - 1]) {
                                        maxBudget = payload.title.data.result[i - 1].budget || 0;
                                        maxWarning = payload.title.data.result[i - 1].warning_budget || 0;
                                    }
                                }
                                var dateOfMonth = payload.title.data.result[i - 1] ? (parseInt((payload.title.data.result[i - 1].dates.split('-'))[2].split('T')[0], 10)) : -1;
                                if (i != dateOfMonth) {
                                    payload.title.data.result.insert(i - 1, {
                                        dates: (date.split('-')[1] + '-' + $scope.getMonth(date.split('-')[0]) + '-' + (i < 10 ? '0' + i : i) + 'T00:00:00.000Z'),
                                        amount: 0,
                                        budget: maxBudget,
                                        warning_budget: maxWarning
                                    });
                                }

                            }
                            // *********** END BLOCK OF CODE IS TO ADD DEFAULT 0 VALUE FOR DAYs THAT ARE NOT COMING FROM BACKEN *******

                            if (vm.filterData.agreement.length == 1) { // IF ONLY ONE AGREEMENT IS SELECTED
                                $scope.datasetOverride.push({
                                    label: languageBasedErrorFactory.getProperErrorMessage('warningAmount', 0, '3'),
                                    borderWidth: 2,
                                    hoverBackgroundColor: "yellow",
                                    hoverBorderColor: "yellow",
                                    type: 'line',
                                    fill: false
                                }, {
                                    label: languageBasedErrorFactory.getProperErrorMessage('budgetAmount', 0, '3'),
                                    borderWidth: 2,
                                    hoverBackgroundColor: "red",
                                    hoverBorderColor: "red",
                                    type: 'line',
                                    fill: false
                                }, {
                                    label: languageBasedErrorFactory.getProperErrorMessage('reportAmount', 0, '3'),
                                    borderWidth: 1,
                                    type: 'bar'
                                });
                                $scope.data.push([], [], []);
                                payload.title.data.result.forEach(function (object) {
                                    var date = object.dates.split('-');
                                    date[1] = $scope.getMonth(date[1]);
                                    object.dates = date[2].split('T')[0] + '-' + date[1] + '-' + date[0];
                                    $scope.labels.push(object.dates);
                                    $scope.data[0].push(object.warning_budget || 0);
                                    $scope.data[1].push(object.budget || 0);
                                    $scope.data[2].push(object.amount || 0);
                                });
                            } else {
                                $scope.colors = ['#000080'];
                                $scope.datasetOverride.push({
                                    label: languageBasedErrorFactory.getProperErrorMessage('reportAmount', 0, '3'),
                                    borderWidth: 1,
                                    type: 'bar'
                                });
                                $scope.data.push([]);
                                payload.title.data.result.forEach(function (object) {
                                    var date = object.dates.split('-');
                                    date[1] = $scope.getMonth(date[1]);
                                    object.dates = date[2].split('T')[0] + '-' + date[1] + '-' + date[0];
                                    $scope.labels.push(object.dates);
                                    $scope.data[0].push(object.amount || 0);
                                });
                            }
                            $scope.is_per_month = true;
                        }
                        vm.showGraph = true;
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        //======================selecting item of charges=====================
        function selectingItemOfCharges(index, type) {}

        // **** FUNCTION TO GET DAYS GRAPH TO CLICK ON 13 MONTH GRAPH ****
        $scope.onClick = function (points, evt) {
            if (points.length > 0)
                if (points[points.length - 1]._view.label.split('-').length == 2)
                    getDataForChart(points[points.length - 1]._view.label);
        };

        // *** TO GET DAYS IN MONTH ****
        function daysInMonth(month, year) {
            return new Date(year, month, 0).getDate();
        }

        // *** TO GET GRAPH ON CLICK ON APPLY BUTTON ****
        function showGraphFunction() {
            if (vm.filterData.agreement.length > 0 || vm.selectAllAgreement) {
                getDataForChart();
            } else {
                vm.showGraph = false;
            }
        }

        // *** TO GET MONTH GRAPH ON CLICK ON BACK BUTTON ****
        function back() {
            getDataForChart();
        }
        // **** SELECT ALL AGREEMENT ****
        function selectAll() {
            vm.filterData.agreement = [];
            vm.selectAllAgreement = !vm.selectAllAgreement;
            vm.showGraph = false;
        }
    }
})();
/**
 * Created by Ashish Garg on 1/11/18.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('ExpenseControlController', ExpenseControlController);

    /** @ngInject */
    function ExpenseControlController($cookies, getAgreement, getFilters, RutHelper, pendingRequests, $document, $mdDialog, getExpenseControlData, errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.getAllAgreements = getAllAgreements;
        vm.branchSearch = branchSearch;
        // vm.applyFilter =applyFilter;
        vm.corporateSearch = corporateSearch;
        vm.getPagesCount = getPagesCount;
        vm.budgetButton = budgetButton;
        vm.paginationNew = paginationNew;
        vm.paginationChangedForCorporation = paginationChangedForCorporation;
        vm.paginationChangedForBranch = paginationChangedForBranch;
        vm.maxSize = 5;
        vm.filterData = {
            region_id: 'all',
            agreementStatus: '1',
            corporate_id: 'all',
            search_filter: 0,
            search_value: ''
        };
        vm.getFilter = getFilter;

        //====================function for dropdown pages and page count===============
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];

        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllAgreements(0, vm.itemsPerPageGot, vm.filterData);
        };

        vm.corporateOffset = 0;
        vm.branchOffset = 0;
        vm.globalLimit = 10;
        vm.globalOffset = vm.globalLimit;
        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'vehicle', 'service', 'agreement', 'corporatesList', 'operation_point'];
        vm.branchList = [];
        vm.branchList.push({
            region_name: 'Todos',
            region_id: 'all'
        });

        vm.corporatesList = [];
        vm.corporatesList.push({
            company_name: 'Todos',
            id: 'all'
        });

        // function applyFilter(){
        //     vm.getAllAgreements(0, vm.searchModel.limit, vm.filterData);
        // }
        // =================== FILTER OBJECT ===================
        vm.filterObject = {
            access_token: $cookies.get('obj'),
            branch_filter: 1,
            vehicle_filter: 0,
            service_filter: 0,
            agreement_filter: 0,
            corporate_filter: 1,
            service_category: 0,
            corporate_status: 2,
            agreement_status: 0,
            vehicle__status: 0,
            operation_point_filter: 0,
            branch_limit: vm.globalLimit,
            branch_offset: vm.branchOffset,
            corporate_limit: vm.globalLimit,
            corporate_offset: vm.corporateOffset,
            branch_search_filter: 0,
            vehicle_search_filter: 0,
            service_search_filter: 0,
            agreement_search_filter: 0,
            corporate_search_filter: 0,
            operation_point_search_filter: 0
        }

        setTimeout(function () {
            document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                // if (vm.branchList && (vm.branchList.length == 0)) {
                vm.searchBranchData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

            document.getElementsByClassName('ui-select-search')[1].addEventListener('blur', function ($event) {
                // if (vm.corporatesList && (vm.corporatesList.length == 0)) {
                vm.searchCorporateData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });
        })

        // =================== GET FILTER DATA ===================
        function getFilterDataFromBackend(data, type) { //Acc to Index ['branch_search', 'vehicle_search', 'service_search', 'agreement_search', 'corporate_search', 'operation_point_search']
            if (data) {
                vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
            } else {
                vm.filterObject = {
                    access_token: $cookies.get('obj'),
                    branch_filter: 1,
                    vehicle_filter: 0,
                    service_filter: 0,
                    agreement_filter: 0,
                    corporate_filter: 1,
                    service_category: 0,
                    corporate_status: 2,
                    agreement_status: 0,
                    vehicle__status: 0,
                    operation_point_filter: 0,
                    branch_search_filter: 0,
                    vehicle_search_filter: 0,
                    service_search_filter: 0,
                    agreement_search_filter: 0,
                    corporate_search_filter: 0,
                    operation_point_search_filter: 0
                }
            }
            vm.filterObject.branch_limit = vm.globalLimit;
            vm.filterObject.branch_offset = vm.branchOffset;
            vm.filterObject.corporate_limit = vm.globalLimit;
            vm.filterObject.corporate_offset = vm.corporateOffset;

            var promise = getFilters.getAllFilterData(vm.filterObject);
            promise.then(
                function (payload) {

                    // ********** BRANCH DATA ********
                    if (payload.title.data.branches) {
                        var index = _.findIndex(vm.branchList, {
                            region_id: 'all'
                        });
                        if (index == -1)
                            vm.branchList.push({
                                region_name: 'Todos',
                                region_id: 'all'
                            });
                        angular.forEach(payload.title.data.branches.data, function (column) {
                            // vm.branchList.push(column)
                            var branchIndex = _.findIndex(vm.branchList, {
                                region_id: column.region_id
                            });
                            if (branchIndex == -1)
                                vm.branchList.push(column)

                        });
                        vm.branchTotalBackendCount = payload.title.data.branches.totalCount;
                    }

                    // ********** CORPORATE DATA ********
                    if (payload.title.data.corporates) {
                        // angular.forEach(payload.title.data.corporates.data, function (column) {
                        //     vm.corporatesList.push(column)
                        // });
                        // vm.corporateTotalBackendCount = payload.title.data.corporates.totalCount;
                        var index = _.findIndex(vm.corporatesList, {
                            id: 'all'
                        });
                        if (index == -1)
                            vm.corporatesList.push({
                                company_name: 'Todos',
                                id: 'all'
                            });
                        angular.forEach(payload.title.data.corporates.data, function (column) {
                            // vm.corporatesList.push(column)
                            var corprateIndex = _.findIndex(vm.corporatesList, {
                                id: column.id
                            });
                            if (corprateIndex == -1)
                                vm.corporatesList.push(column)

                        });
                        vm.corporateTotalBackendCount = payload.title.data.corporates.totalCount;
                    }

                    vm.loading = false;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        }
        getFilterDataFromBackend();

        // ************ PAGINATION ON BRANCH **************
        function paginationChangedForBranch() {
            var index = _.findIndex(vm[vm.searchFilterArray[0]], {
                region_id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.branchTotalBackendCount > (vm.branchList.length - index)) {
                commonFunction(0);
                vm.branchOffset += 10;
                getFilterDataFromBackend(vm.searchBranchData, 0);
            }
        }

        // ************ PAGINATION ON CORPORATE **************
        function paginationChangedForCorporation() {
            var index = _.findIndex(vm[vm.searchFilterArray[5]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.corporateTotalBackendCount > (vm.corporatesList.length - index)) {
                commonFunction(4);
                vm.corporateOffset += vm.globalOffset;
                getFilterDataFromBackend(vm.searchCorporateData, 4);
            }
        }
        // *********** COMMON FUNCTION FOR FILTER PAGINATION AND SEARCHING ***********
        function commonFunction(type, mode) {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                if (mode == 'search' || i != type) {
                    vm[vm.searchFilterArrayForClearArray[i]] = [];
                    // vm[vm.searchFilterArrayForClearArray[i]].push({
                    //     id: 'all',
                    //     name: 'All'
                    // });
                    vm[vm.searchFilterArray[i] + 'Offset'] = 0;
                    vm['search' + vm.searchFilterArray[i].substring(0, 1).toUpperCase() + vm.searchFilterArray[i].substring(1) + 'Data'] = '';
                }
            }
        }
        // ************ SEARCH VEHICLE ***************
        function branchSearch(data) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchBranchData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(0, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 0);
                }, 2000);
            }
        }

        function clearOffset() {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                vm[vm.searchFilterArray[i] + 'Offset'] = 0;
            }

        }
        // ************ SEARCH SERVICE ***************
        function corporateSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchCorporateData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(4, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 4);
                }, 2000);
            }
        }

        vm.getAllAgreements(0, vm.searchModel.limit, vm.filterData);

        //================== GET ALL AGREEMENTS=======================
        function getAllAgreements(skip, limit, filter) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.offset = skip;
            dataSend.limit = limit;
            dataSend.key = Number(filter.agreementStatus);
            if (filter.region_id != 'all') {
                dataSend.region_id = filter.region_id;
            }
            if (filter.corporate_id != 'all') {
                dataSend.corporate_id = filter.corporate_id;
            }
            dataSend.search_filter = filter.search_filter;
            if (filter.search_filter == 1) {
                dataSend.search_value = filter.search_value;
            }
            vm.loading = true;
            var promise = getAgreement.allAgreementsExpenseControl(dataSend);
            promise.then(
                function (payload) {
                    vm.loading = false;
                    console.log(payload);
                    
                    vm.totalAgreement = payload.title.data.total_count;
                    console.log(vm.totalAgreement);
                    
                    vm.dataLength = payload.title.data.total_count;
                    vm.agreement = [];
                    vm.branchList = [];
                    vm.vehicle = [];
                    vm.service = [];
                    clearOffset();
                    getFilterDataFromBackend();
                    if (payload.title.data.total_count == 0) {
                        vm.sp_pagination = false;
                        vm.tBodyFlag = false;
                        vm.tFootFlag = true;
                        vm.filterOn = true;
                        vm.skipValueFilter = 0;
                    } else {
                        vm.sp_pagination = true;
                        vm.tBodyFlag = true;
                        vm.tFootFlag = false;
                        vm.filterOn = false;
                        vm.skipValueFilter = 0;

                        var dataArray = [];

                        var agreementList = payload.title.data.result;
                        agreementList.forEach(function (column) {
                            var d = {};
                            d.typeOfService  = [];
                            d.id = column.id;
                            d.commercial_classification = column.commercial_classification;
                            d.companyRUT = RutHelper.format(column.RUT);
                            d.companyName = column.company_name;
                            d.corporateid = column.corporate_id;
                            d.name = column.name;
                            d.status = column.status;
                            d.agreement_type = column.agreement_type;
                            d.branch = column.branch;
                            d.statusNew = column.status.toString();
                            if(column.payment_type){
                                var arrayForPaymentMethod = column.payment_type.split(',');
                                d.paymentMethod = arrayForPaymentMethod;
                            }
                            d.uploadFlag = column.employee_upload_flag;
                            if(column.type_of_service){
                                var arrayForTypeOfService = column.type_of_service.split(',');
                                d.typeOfService = arrayForTypeOfService;
                            }
                            if(column.region_name){
                                var arrayForRegionName  = column.region_name.split(',');
                                d.region_name = arrayForRegionName;
                            }
                            d.created_on = column.created_on;
                            d.created_by = column.created_by;
                            d.updated_on = column.updated_on;
                            d.updated_by = column.updated_by;
                            d.rt_discount = column.rt_discount;
                            d.web_discount = column.web_discount;
                            d.fixedListUpdate = column.fixedListUpdate;
                            d.variableListUpdate = column.variableListUpdate;
                            d.budget = column.budget;
                            d.warning_budget = column.warning_budget;
                            d.is_active = column.is_active;
                            d.emails = column.emails;
                            dataArray.push(d);
                        });
                        vm.agreementList = dataArray;
                        for (var i = 0; i < vm.agreementList.length; i++) {
                            vm.agreementList[i].index = (skip + i);
                        }
                        if (vm.dataLength <= vm.itemsPerPageGot) {
                            vm.sp_pagination = false;
                        } else {
                            vm.sp_pagination = true;
                            //vm.pageCount(payload.title.data.totalCount);
                        }
                        vm.skipValue = vm.agreementList[0].index;
                        vm.limitValue = vm.agreementList[vm.agreementList.length - 1].index;

                        // USERTYPE VALUE
                        // 0 - Transvip user
                        // 1 - PET user
                        vm.userType = payload.title.data.user_type || 0;

                        //$scope.$watch('vm.search', function(newVal, oldVal) {
                        //    vm.filtered = filterFilter(vm.agreementList, newVal);
                        //    vm.totalItems = vm.filtered.length;
                        //    if (vm.filtered.length == 0) {
                        //        vm.watchPagination = false;
                        //    } else {
                        //        vm.watchPagination = true;
                        //    }
                        //    if (vm.filterOn == true) {
                        //        vm.skipValueFilter = vm.filtered.length;
                        //        vm.sp_pagination = false;
                        //    }
                        //}, true);

                        //range();
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };


        function getFilter() {
            //vm.filterOn = true;
            vm.currentPage = 0;
            vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
            vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
            pendingRequests.cancelAll();
            if (vm.search.length == 0) {
                vm.filterData.search_filter = 0;
                vm.filterData.search_value = '';
                vm.getAllAgreements(0, vm.searchModel.limit, vm.filterData);
                //vm.filterOn = false;
                //vm.watchPagination = true;
                //vm.sp_pagination = true;

            } else {
                vm.filterData.search_filter = 1;
                vm.filterData.search_value = vm.search;
                //if (vm.filterTextTimeout) $timeout.cancel(vm.filterTextTimeout);
                //vm.filterTextTimeout = $timeout(function(){
                vm.getAllAgreements(0, vm.searchModel.limit, vm.filterData);
                //},500);
            }
        };


        //========================open endowment pop p======================
        function budgetButton(data, $event) {
            vm.items = {
                agreementId: data.id,
                budgetToggleButton: data.is_active || false,
                budgetAmount: data.budget || 0,
                warningAmount: data.warning_budget || 0,
                emails: data.emails || '',
            }

            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/addBudget.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: AddEndowmentController
            });

            function AddEndowmentController($scope, $mdDialog, items) {
                console.log('>>> ITEM >>>', items);
                $scope.items = items;
                // $scope.items.budgetToggleButton = false;
                var dataGet = [];
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };

                $scope.confirmUpload = function () {
                    addBudgetAPI($scope.items);
                    $mdDialog.hide();
                };

            }
        }

        function addBudgetAPI(data) {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.is_active = data.budgetToggleButton;
            dataSend.contract_id = data.agreementId;
            dataSend.budget = data.budgetAmount;
            dataSend.warning_budget = data.warningAmount;
            dataSend.emails = (data.emails).split(',');
            var promise = getExpenseControlData.updateCorporateBudget(dataSend);
            promise.then(
                function (payload) {
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.getAllAgreements(0, vm.searchModel.limit, vm.filterData);
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function paginationNew(page){
            getAllAgreements((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData);
        }

    }
})();
/**
 * Created by cl-macmini-51 on 7/13/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .controller('ViewEmployeeDetailsController', ViewEmployeeDetailsController);

    /** @ngInject */
    function ViewEmployeeDetailsController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document, moment, getAgreement, $scope,
                                           RutHelper, filterFilter, languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.getAllEmployees = getAllEmployees;
        vm.goBack = goBack;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();

        //==================get all employees=======================
        function getAllEmployees(skip, limit) {
            vm.loading = true;
            var dataSend = {
                access_token: $cookies.get('obj'),
                limit: limit,
                offset: skip,
                contract_id: $stateParams.contractId,
                id: $stateParams.id
            };
            var promise = getAgreement.getContractRelatedEmployee(dataSend);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.employeeDetails = payload.title.data.result[0];
                    vm.employeeDetails.RUT = RutHelper.format(vm.employeeDetails.RUT);
                    if(vm.employeeDetails.approval_required == 1){
                        vm.employeeDetails.auth_RUT = RutHelper.format(vm.employeeDetails.auth_RUT);
                    }
                    else{
                        vm.employeeDetails.auth_RUT = '';
                    }
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        getAllEmployees(0,0);
        //==================get all agreements=======================
        function getAllAggrements() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.offset = 0;
            dataSend.limit = 0;
            dataSend.key = 3;
            dataSend.id = $stateParams.contractId;
            vm.loading = true;
            var promise = getAgreement.allAgreementsExpenseControl(dataSend);
            promise.then(
                function(payload) {
                    $log.log('allagree', payload);
                    vm.loading = false;
                    var where = payload.title.data.result;
                    vm.contractName = where[0].name;
                    vm.corporateName = where[0].company_name;
                    vm.agreementType = where[0].agreement_type;
                    vm.agreementStatus = where[0].status;
                    if(where[0].type_of_service){
                        var arrayForTypeOfService = where[0].type_of_service.split(',');
                        vm.agreementServices = arrayForTypeOfService;
                    }
                    if(where[0].region_name){
                        var arrayForRegionName  = where[0].region_name.split(',');
                        vm.agreementBranches = arrayForRegionName;
                    }
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        getAllAggrements();


        //=================function go back ============================
        function goBack(){
            $state.go('layout.agreementMain.manageEmployee',{corporateId:$stateParams.corporateId,contractId:$stateParams.contractId,path:'0'});
        };
    }
})();
/**
 * Created by cl-macmini-51 on 4/28/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('ManageEmployeeController', ManageEmployeeController);

    /** @ngInject */
    function ManageEmployeeController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document, moment, getAgreement, $scope, RutHelper, filterFilter, languageBasedErrorFactory, errorMessageFactory, checkDomain, anchorSmoothScroll, $location, adminAccessService, getDrivers, getCustomers) {
        var vm = this;
        vm.loading = false;
        vm.addEmployeeFlag = false;
        vm.resetPassword = resetPassword;
        vm.SendEmail = SendEmail;
        vm.currentPage = 0;
        vm.totalVehicles = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.predicate = 'index';
        vm.reverse = false;
        vm.editEmployeeFlag = false;
        vm.getPagesCount = getPagesCount;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.init = init;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.registerApi = registerApi;
        vm.setBooleanEmployee = setBooleanEmployee;
        vm.goBack = goBack;
        vm.rutChange = rutChange;
        vm.rutChangePerson = rutChangePerson;
        vm.addMoreEmployees = addMoreEmployees;
        vm.getAllEmployees = getAllEmployees;
        vm.cancel = cancel;
        vm.uploadCSVPop = uploadCSVPop;
        vm.changeEmployeeStatus = changeEmployeeStatus;
        vm.deleteEmployee = deleteEmployee;
        vm.editEmployeeDetails = editEmployeeDetails;
        vm.editApi = editApi;
        vm.storeDetails = storeDetails;
        vm.exportToCSV = exportToCSV;
        vm.onSelectingAuth = onSelectingAuth;
        vm.checkToRegisterCustomerOrNot = checkToRegisterCustomerOrNot;
        vm.refreshData = refreshData;
        vm.removeEmployees = removeEmployees;
        vm.checkForDelete = checkForDelete;
        vm.paginationNew = paginationNew;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.dataToFill = {
            contract_id: $stateParams.contractId,
            corporate_id: $stateParams.corporateId,
            search_filter: 0,
            search_value: '',
            search: '',
            employee_list: {
                "first_name": '',
                "last_name": '',
                "RUT": '',
                "approval_required": false,
                "thirdBooking": false,
                "email": '',
                "phone_number": '',
                "auth_RUT": "",
                "rutFlag_person": false,
                "rutFlag": false,
                "is_vip": false,
                "id": '',
                "position": '',
                "cost_center": '',
                "cost_subCenter": '',
                "ROL": '',
                "graph": '',
                "order_of_work": '',
                "PEP": '',
                "comments": '',
                "show_PEP": false,
                "show_cost_center": false,
                "show_cost_subCenter": false,
                "show_ROL": false,
                "show_graph": false,
                "show_order_of_work": false,
                "approval_required_booking_panel": false,
                "approval_required_booking_app": false
            }
        };
        vm.selectedEmployeeToRemove = [];
        vm.corporateID = $stateParams.corporateId;
        vm.contractID = $stateParams.contractId;
        if ($rootScope.socket.connected == false || $rootScope.socket.connected == 'false') {
            $rootScope.socket.connect();
        }

        var myListener = $rootScope.$on('SocketComesEmployee', function (evt, data) {
            if (data.data) {
                vm.headersNotPresent = [];
                vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
                vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
                getAllEmployees(0, vm.searchModel.limit, vm.dataToFill);
            }

        });
        $scope.$on('$destroy', myListener);

        $cookies.remove('setData');
        //======================cancel add and edit=========================
        function cancel() {
            $state.reload('layout.agreementMain.manageEmployee');
        };
        //====================function for dropdown pages and page count===============
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];

        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllEmployees(0, vm.itemsPerPageGot, vm.dataToFill);
        };

        function paginationNew(page) {
            getAllEmployees((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.dataToFill);
        }
        //==================refreshData=====================
        function refreshData() {
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllEmployees(vm.currentPage * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.dataToFill);
        }

        //==================get all employees=======================
        function getAllEmployees(skip, limit, filter) {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj'),
                dataSend.limit = limit,
                dataSend.offset = skip,
                dataSend.contract_id = $stateParams.contractId,
                // dataSend.search = filter.search_value,
                dataSend.search_filter = filter.search_filter;
            if (filter.search_filter == 1) {
                dataSend.search_value = filter.search_value;
            }



            var promise = getAgreement.getContractRelatedEmployee(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.totalEmployees = payload.title.data.totalCount;
                    vm.dataLength = payload.title.data.totalCount;

                    if (payload.title.data.totalCount == 0) {
                        vm.sp_pagination = false;
                        vm.tBodyFlag = false;
                        vm.tFootFlag = true;
                    } else {
                        vm.sp_pagination = true;
                        vm.tBodyFlag = true;
                        vm.tFootFlag = false;
                    }

                    var dataArray = [];

                    var employeeListGot = payload.title.data.result;
                    employeeListGot.forEach(function (column) {
                        var d = {};
                        d.id = column.id;
                        d.activation_date = column.activation_date;
                        d.approval_required = column.approval_required;
                        if (column.approval_required == 1) {
                            d.auth_RUT = RutHelper.format(column.auth_RUT);
                        } else {
                            d.auth_RUT = '';
                        }
                        d.contract_id = column.contract_id;
                        d.RUT = RutHelper.format(column.RUT);
                        d.corporate_id = column.corporate_id;
                        d.created_on = column.created_on;
                        d.email = column.email;
                        d.name = column.name;
                        d.phone_number = column.phone_number;
                        d.status = column.status;
                        d.thirdBooking = column.thirdBooking;
                        d.is_vip = column.is_vip;
                        d.uniquecode = column.uniquecode;
                        d.last_name = column.last_name;
                        d.PEP = column.PEP;
                        d.ROI = column.ROI;
                        d.comments = column.comments;
                        d.cost_center = column.cost_center;
                        d.cost_subcenter = column.cost_subcenter;
                        d.graph = column.graph;
                        d.order_of_work = column.order_of_work;
                        d.position = column.position;
                        d.checked = false;
                        d.customer_id = column.employee_id;
                        d.customer_email = column.customer_email;
                        d.panel_booking_access = column.panel_booking_access;
                        d.customer_booking_access = column.customer_booking_access;

                        dataArray.push(d);
                    });
                    vm.employeeListGot = dataArray;

                    // USERTYPE VALUE
                    // 0 - Transvip user
                    // 1 - PET user
                    vm.userType = payload.title.data.user_type || 0;

                    for (var i = 0; i < vm.employeeListGot.length; i++) {
                        vm.employeeListGot[i].index = (skip + i);

                        if (vm.selectedEmployeeToRemove.length) {
                            for (var j = 0; j < vm.selectedEmployeeToRemove.length; j++) {
                                if (vm.selectedEmployeeToRemove[j].id == vm.employeeListGot[i].id) {
                                    vm.employeeListGot[i].checked = vm.selectedEmployeeToRemove[j].checked;
                                }
                            }
                        }
                    }
                    if (vm.dataLength <= vm.itemsPerPageGot) {
                        vm.sp_pagination = false;
                    } else {
                        vm.sp_pagination = true;
                        //vm.pageCount(payload.title.data.totalCount);
                    }

                    vm.skipValue = vm.employeeListGot[0].index;
                    vm.limitValue = vm.employeeListGot[vm.employeeListGot.length - 1].index;

                    $scope.$watch('vm.search', function (newVal, oldVal) {
                        vm.filtered = filterFilter(vm.employeeListGot, newVal);
                        vm.totalItems = vm.filtered.length;
                        if (vm.filtered.length == 0) {
                            vm.watchPagination = false;
                        } else {
                            vm.watchPagination = true;
                        }
                        if (vm.filterOn == true) {
                            vm.skipValueFilter = vm.filtered.length;
                            vm.sp_pagination = false;
                        }
                    }, true);

                    //range();
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    } else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        vm.getAllEmployees((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected);
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        vm.currentPage++;
        //        vm.getAllEmployees((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected);
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    vm.getAllEmployees((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected);
        //};

        function init() {
            vm.getAllEmployees(0, vm.searchModel.limit, vm.dataToFill);
        };
        init();

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            // vm.filterOn = true;
            // if (vm.search.length == 0) {
            //     vm.filterOn = false;
            //     vm.watchPagination = true;
            //     vm.sp_pagination = true;
            // }
            //vm.filterOn = true;
            vm.currentPage = 0;
            if (vm.dataToFill.search.length == 0) {
                vm.dataToFill.search_filter = 0;
                vm.dataToFill.search_value = '';
                getAllEmployees(0, vm.itemsPerPageGot, vm.dataToFill, true);
                //vm.filterOn = false;
                //vm.watchPagination = true;
                //vm.sp_pagination = true;

            } else {
                vm.dataToFill.search_filter = 1;
                vm.dataToFill.search_value = vm.dataToFill.search;
                getAllEmployees(0, vm.itemsPerPageGot, vm.dataToFill, true);

            }
        };
        //==================add more employees======================
        function addMoreEmployees() {
            $log.log('dcsd');
            vm.dataToFill.employee_list.first_name = '';
            vm.dataToFill.employee_list.last_name = '';
            vm.dataToFill.employee_list.RUT = '';
            vm.dataToFill.employee_list.email = '';
            vm.dataToFill.employee_list.phone_number = '';
            vm.dataToFill.employee_list.auth_RUT = '';
            vm.dataToFill.employee_list.id = '';
            vm.dataToFill.employee_list.position = '';
            vm.dataToFill.employee_list.cost_center = '';
            vm.dataToFill.employee_list.cost_subCenter = '';
            vm.dataToFill.employee_list.ROL = '';
            vm.dataToFill.employee_list.graph = '';
            vm.dataToFill.employee_list.order_of_work = '';
            vm.dataToFill.employee_list.PEP = '';
            vm.dataToFill.employee_list.comments = '';
            vm.dataToFill.employee_list.approval_required = false;
            vm.dataToFill.employee_list.thirdBooking = false;
            vm.dataToFill.employee_list.rutFlag_person = false;
            vm.dataToFill.employee_list.rutFlag = false;
            vm.dataToFill.employee_list.is_vip = false;
            vm.addEmployeeFlag = true;
            vm.editEmployeeFlag = false;
        }

        function rutChange() {
            $log.log('data', vm.dataToFill.employee_list.RUT);
            if (vm.dataToFill.employee_list.RUT) {
                if (RutHelper.validate(vm.dataToFill.employee_list.RUT)) {
                    $log.log();
                    vm.dataToFill.employee_list.rutFlag = false;
                } else {
                    vm.dataToFill.employee_list.rutFlag = true;
                }
            } else if (vm.dataToFill.employee_list.RUT === null) {
                vm.dataToFill.employee_list.rutFlag = true;
            } else if (vm.dataToFill.employee_list.RUT === undefined) {
                vm.dataToFill.employee_list.rutFlag = false;
            }
        }

        function rutChangePerson(index) {
            $log.log('data', vm.dataToFill.employee_list.auth_RUT);
            if (vm.dataToFill.employee_list.auth_RUT) {
                if (RutHelper.validate(vm.dataToFill.employee_list.auth_RUT)) {
                    $log.log();
                    vm.dataToFill.employee_list.rutFlag_person = false;
                } else {
                    vm.dataToFill.employee_list.rutFlag_person = true;
                }
            } else if (vm.dataToFill.employee_list.auth_RUT === null) {
                vm.dataToFill.employee_list.rutFlag_person = true;
            } else if (vm.dataToFill.employee_list.auth_RUT === undefined) {
                vm.dataToFill.employee_list.rutFlag_person = false;
            }
        }

        //==================get all agreements=======================
        function getAllAggrements() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.offset = 0;
            dataSend.limit = 0;
            dataSend.key = 3;
            dataSend.id = $stateParams.contractId;
            vm.loading = true;
            var promise = getAgreement.allAgreementsExpenseControl(dataSend);
            promise.then(
                function (payload) {
                    $log.log('allagree', payload);
                    vm.loading = false;
                    var where = payload.title.data.result;
                    vm.contractName = where[0].name;
                    vm.corporateName = where[0].company_name;
                    vm.agreementType = where[0].agreement_type;
                    vm.agreementStatus = where[0].status;
                    // vm.agreementServices = where[0].type_of_service;
                    // vm.agreementBranches = where[0].branch;
                    if (where[0].type_of_service) {
                        var arrayForTypeOfService = where[0].type_of_service.split(',');
                        vm.agreementServices = arrayForTypeOfService;
                    }
                    if (where[0].region_name) {
                        var arrayForRegionName = where[0].region_name.split(',');
                        vm.agreementBranches = arrayForRegionName;
                    }
                    if (where[0].PEP_mandatory) {
                        vm.dataToFill.employee_list.show_PEP = true;
                    }
                    if (where[0].ROL_mandatory) {
                        vm.dataToFill.employee_list.show_ROL = true;
                    }
                    if (where[0].cost_center_mandatory) {
                        vm.dataToFill.employee_list.show_cost_center = true;
                    }
                    if (where[0].cost_sub_center_mandatory) {
                        vm.dataToFill.employee_list.show_cost_subCenter = true;
                    }
                    if (where[0].graph_mandatory) {
                        vm.dataToFill.employee_list.show_graph = true;
                    }
                    if (where[0].work_order_mandatory) {
                        vm.dataToFill.employee_list.show_order_of_work = true;
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllAggrements();


        //====================set bollean for employeee==========================
        function setBooleanEmployee(type, index) {
            switch (type) {
                case 'THIRD_BOOKING':
                    if (vm.dataToFill.employee_list.thirdBooking) {
                        vm.dataToFill.employee_list.thirdBooking = false;
                    } else {
                        vm.dataToFill.employee_list.thirdBooking = true;
                    }
                    break;
                case 'APPROVAL_REQUIRED':
                    if (vm.dataToFill.employee_list.approval_required) {
                        vm.dataToFill.employee_list.approval_required = false;
                    } else {
                        vm.dataToFill.employee_list.approval_required = true;
                    }
                    break;
                case 'VIP_EMPLOYEE':
                    if (vm.dataToFill.employee_list.is_vip) {
                        vm.dataToFill.employee_list.is_vip = false;
                    } else {
                        vm.dataToFill.employee_list.is_vip = true;
                    }
                    break;
                case 'APPROVAL_REQUIRED_BOOKING_PANEL':
                    if (vm.dataToFill.employee_list.approval_required_booking_panel) {
                        vm.dataToFill.employee_list.approval_required_booking_panel = false;
                    } else {
                        vm.dataToFill.employee_list.approval_required_booking_panel = true;
                    }
                    break;
                case 'APPROVAL_REQUIRED_BOOKING_APP':
                    if (vm.dataToFill.employee_list.approval_required_booking_app) {
                        vm.dataToFill.employee_list.approval_required_booking_app = false;
                    } else {
                        vm.dataToFill.employee_list.approval_required_booking_app = true;
                    }
                    break;
            }
        }
        //=================confirmation for to register customer or not======================
        function checkToRegisterCustomerOrNot($event, data) {
            var confirm = $mdDialog.confirm()
                .title(data.message)
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('yes', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('no', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.first_name = data.data.first_name;
                dataSend.last_name = data.data.last_name;
                dataSend.phone_number = data.data.phone_number;
                dataSend.email = data.data.email;
                dataSend.uniquecode = data.data.uniquecode;
                dataSend.domainUrl = data.data.domainUrl;
                vm.loading = true;
                var promise = getAgreement.registerCustomerFromEmployee(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        languageBasedErrorFactory.getProperErrorMessage('addEmployeeSucc', 0, 1, 'layout.agreementMain.manageEmployee');
                        //errorMessageFactory.showErrorMessage('Employee added successfully.',1);
                        //$timeout(function() {
                        //    $mdDialog.hide();
                        //    $state.reload();
                        //}, 2000);
                    },
                    function (errorPayload) {
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
                languageBasedErrorFactory.getProperErrorMessage('addEmployeeSucc', 0, 1, 'layout.agreementMain.manageEmployee');
            });
        };
        //====================registerApi==========================
        function registerApi($event) {
            vm.allAuthList.forEach(function(data){
                data.RUT =  RutHelper.clean(data.RUT)
            });
            var where = _.where(vm.allAuthList, {
                RUT: RutHelper.clean(vm.dataToFill.employee_list.auth_RUT)
            });
            if (where.length > 0) {
                vm.noResults = false;
            }
            if (vm.noResults) {
                errorMessageFactory.showErrorMessage('Rut del autorizador no pertenece al convenio', 0);
                return;
            }
            if (vm.dataToFill.employee_list.approval_required && !RutHelper.validate(vm.dataToFill.employee_list.auth_RUT)) {
                languageBasedErrorFactory.getProperErrorMessage('authRutValid1', 0, 0);
                return;
            }
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.contract_id = vm.dataToFill.contract_id;
            dataSend.corporate_id = vm.dataToFill.corporate_id;
            dataSend.domainUrl = checkDomain.getDomainName();
            dataSend.employee_list = [];

            dataSend.employee_list.push({
                name: vm.dataToFill.employee_list.first_name,
                last_name: vm.dataToFill.employee_list.last_name,
                position: vm.dataToFill.employee_list.position ? vm.dataToFill.employee_list.position : '',
                cost_center: vm.dataToFill.employee_list.cost_center ? vm.dataToFill.employee_list.cost_center : '',
                cost_subcenter: vm.dataToFill.employee_list.cost_subCenter ? vm.dataToFill.employee_list.cost_subCenter : '',
                ROI: vm.dataToFill.employee_list.ROL ? vm.dataToFill.employee_list.ROL : '',
                graph: vm.dataToFill.employee_list.graph ? vm.dataToFill.employee_list.graph : '',
                //order_of_work : vm.dataToFill.employee_list.order_of_work?vm.dataToFill.employee_list.order_of_work:'',
                PEP: vm.dataToFill.employee_list.PEP ? vm.dataToFill.employee_list.PEP : '',
                comments: vm.dataToFill.employee_list.comments ? vm.dataToFill.employee_list.comments : '',
                RUT: vm.dataToFill.employee_list.RUT ? RutHelper.clean(vm.dataToFill.employee_list.RUT) : '',
                approval_required: vm.dataToFill.employee_list.approval_required == true ? 1 : 0,
                thirdBooking: vm.dataToFill.employee_list.thirdBooking == true ? 1 : 0,
                email: vm.dataToFill.employee_list.email,
                phone_number: vm.dataToFill.employee_list.phone_number ? vm.dataToFill.employee_list.phone_number : '',
                auth_RUT: vm.dataToFill.employee_list.approval_required ? RutHelper.clean(vm.dataToFill.employee_list.auth_RUT) : '',

                panel_booking_access: vm.dataToFill.employee_list.approval_required_booking_panel == true ? 1 : 0,
                customer_booking_access: vm.dataToFill.employee_list.approval_required_booking_app == true ? 1 : 0,

                is_vip: vm.dataToFill.employee_list.is_vip == true ? 1 : 0
            });
            vm.loading = true;
            var promise = getAgreement.manageEmployees(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.data.first_name) {
                        checkToRegisterCustomerOrNot($event, payload.title);
                    } else {
                        languageBasedErrorFactory.getProperErrorMessage('addEmployeeSucc', 0, 1, 'layout.agreementMain.manageEmployee');
                    }
                    //errorMessageFactory.showErrorMessage('Employee added successfully.',1);
                    //$timeout(function() {
                    //    $mdDialog.hide();
                    //    $state.reload();
                    //}, 2000);
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //===============file for csv upload make array=============
        vm.headersNotPresent = [];

        function checkMethod(headers) {
            if (headers[0] != 'Nombres') {
                vm.headersNotPresent.push('Nombres');
                //languageBasedErrorFactory.getProperErrorMessage('headerCheckCSV',0,0);
                //errorMessageFactory.showErrorMessage('Please check your headers of CSV');
                //return languageBasedErrorFactory.getProperErrorMessage('csvFileError',0,'3');
            }
            if (headers[1] != 'Apellidos') {
                vm.headersNotPresent.push('Apellidos');
                //languageBasedErrorFactory.getProperErrorMessage('headerCheckCSV',0,0);
                //errorMessageFactory.showErrorMessage('Please check your headers of CSV');
                //return languageBasedErrorFactory.getProperErrorMessage('csvFileError',0,'3');
            }
            if (headers[2] != 'Email') {
                vm.headersNotPresent.push('Email');
                //languageBasedErrorFactory.getProperErrorMessage('headerCheckCSV',0,0);
                //errorMessageFactory.showErrorMessage('Please check your headers of CSV');
                //return languageBasedErrorFactory.getProperErrorMessage('csvFileError',0,'3');
            }
            if (headers[3] != 'Telefono') {
                vm.headersNotPresent.push('Telefono');
                //languageBasedErrorFactory.getProperErrorMessage('headerCheckCSV',0,0);
                //errorMessageFactory.showErrorMessage('Please check your headers of CSV');
                //return languageBasedErrorFactory.getProperErrorMessage('csvFileError',0,'3');
            }
            if (headers[4] != 'RUT') {
                vm.headersNotPresent.push('RUT');
                //languageBasedErrorFactory.getProperErrorMessage('headerCheckCSV',0,0);
                //errorMessageFactory.showErrorMessage('Please check your headers of CSV');
                //return languageBasedErrorFactory.getProperErrorMessage('csvFileError',0,'3');
            }
            if (headers[5] != 'Cargo') {
                vm.headersNotPresent.push('Cargo');
                //languageBasedErrorFactory.getProperErrorMessage('headerCheckCSV',0,0);
                //errorMessageFactory.showErrorMessage('Please check your headers of CSV');
                //return languageBasedErrorFactory.getProperErrorMessage('csvFileError',0,'3');
            }
            if (headers[6] != 'CentroCosto') {
                vm.headersNotPresent.push('CentroCosto');
                //languageBasedErrorFactory.getProperErrorMessage('headerCheckCSV',0,0);
                //errorMessageFactory.showErrorMessage('Please check your headers of CSV');
                //return languageBasedErrorFactory.getProperErrorMessage('csvFileError',0,'3');
            }
            if (headers[7] != 'SubCentroCosto') {
                vm.headersNotPresent.push('SubCentroCosto');
                //languageBasedErrorFactory.getProperErrorMessage('headerCheckCSV',0,0);
                //errorMessageFactory.showErrorMessage('Please check your headers of CSV');
                //return languageBasedErrorFactory.getProperErrorMessage('csvFileError',0,'3');
            }
            if (headers[8] != 'PEP') {
                vm.headersNotPresent.push('PEP');
                //languageBasedErrorFactory.getProperErrorMessage('headerCheckCSV',0,0);
                //errorMessageFactory.showErrorMessage('Please check your headers of CSV');
                //return languageBasedErrorFactory.getProperErrorMessage('csvFileError',0,'3');
            }
            if (headers[9] != 'ROL') {
                vm.headersNotPresent.push('ROL');
                //languageBasedErrorFactory.getProperErrorMessage('headerCheckCSV',0,0);
                //errorMessageFactory.showErrorMessage('Please check your headers of CSV');
                //return languageBasedErrorFactory.getProperErrorMessage('csvFileError',0,'3');
            }
            if (headers[10] != 'GRAFO') {
                vm.headersNotPresent.push('GRAFO');
                //languageBasedErrorFactory.getProperErrorMessage('headerCheckCSV',0,0);
                //errorMessageFactory.showErrorMessage('Please check your headers of CSV');
                //return languageBasedErrorFactory.getProperErrorMessage('csvFileError',0,'3');
            }
            if (headers[11] != 'PedirParaUnTercero') {
                vm.headersNotPresent.push('PedirParaUnTercero');
                //languageBasedErrorFactory.getProperErrorMessage('headerCheckCSV',0,0);
                //errorMessageFactory.showErrorMessage('Please check your headers of CSV');
                //return languageBasedErrorFactory.getProperErrorMessage('csvFileError',0,'3');
            }
            if (headers[12] != 'RequiereAutorizacion') {
                vm.headersNotPresent.push('RequiereAutorizacion');
                //languageBasedErrorFactory.getProperErrorMessage('headerCheckCSV',0,0);
                //errorMessageFactory.showErrorMessage('Please check your headers of CSV');
                //return languageBasedErrorFactory.getProperErrorMessage('csvFileError',0,'3');
            }
            if (headers[13] != 'RutAutorizador') {
                vm.headersNotPresent.push('RutAutorizador');
                //languageBasedErrorFactory.getProperErrorMessage('headerCheckCSV',0,0);
                //errorMessageFactory.showErrorMessage('Please check your headers of CSV');
                //return languageBasedErrorFactory.getProperErrorMessage('csvFileError',0,'3');
            }
            if (headers[14] != 'EmpleadoVIP') {
                vm.headersNotPresent.push('EmpleadoVIP');
                //languageBasedErrorFactory.getProperErrorMessage('headerCheckCSV',0,0);
                //errorMessageFactory.showErrorMessage('Please check your headers of CSV');
                //return languageBasedErrorFactory.getProperErrorMessage('csvFileError',0,'3');
            }
            if (headers[15] != 'Comentarios') {
                vm.headersNotPresent.push('Comentarios');
                //languageBasedErrorFactory.getProperErrorMessage('headerCheckCSV',0,0);
                //errorMessageFactory.showErrorMessage('Please check your headers of CSV');
                //return languageBasedErrorFactory.getProperErrorMessage('csvFileError',0,'3');
            }
            if (headers[16] != 'autorizadoApp') {
                vm.headersNotPresent.push('autorizadoApp');
                //languageBasedErrorFactory.getProperErrorMessage('headerCheckCSV',0,0);
                //errorMessageFactory.showErrorMessage('Please check your headers of CSV');
                //return languageBasedErrorFactory.getProperErrorMessage('csvFileError',0,'3');
            }
            if (headers[17] != 'autorizadoPanel') {
                vm.headersNotPresent.push('autorizadoPanel');
                //languageBasedErrorFactory.getProperErrorMessage('headerCheckCSV',0,0);
                //errorMessageFactory.showErrorMessage('Please check your headers of CSV');
                //return languageBasedErrorFactory.getProperErrorMessage('csvFileError',0,'3');
            }

            return vm.headersNotPresent;
        }

        function makeCsvDataInArray(data) {
            var totalLinesInCSV = data.split(/\r\n|\n/);
            $log.log(totalLinesInCSV);
            var tarr = [];
            var headers = totalLinesInCSV[0].split(',');
            $log.log(headers);
            var checkFlag = checkMethod(headers);
            if (checkFlag.length) {
                return languageBasedErrorFactory.getProperErrorMessage('csvFileError', 0, '3')
            } else {
                for (var i = 1; i < totalLinesInCSV.length; i++) {
                    var dataG = totalLinesInCSV[i].split(',');
                    if (dataG[4]) {
                        dataG[4] = RutHelper.clean(dataG[4]);
                    }
                    if (dataG.length == headers.length) {
                        tarr.push({
                            'name': dataG[0],
                            'last_name': dataG[1],
                            'email': dataG[2],
                            'phone_number': dataG[3],
                            'RUT': dataG[4],
                            'position': dataG[5],
                            'cost_center': dataG[6],
                            'cost_subcenter': dataG[7],
                            'PEP': dataG[8],
                            'ROI': dataG[9],
                            'graph': dataG[10],
                            'third_booking': dataG[11],
                            'approval_required': dataG[12],
                            'auth_RUT': dataG[13],
                            'is_vip': dataG[14],
                            'comments': dataG[15],
                            'autorizarApp': dataG[16],
                            'autorizarPanel': dataG[17]
                        });
                    } else {
                        //languageBasedErrorFactory.getProperErrorMessage('checkCSV',0,0);
                        //errorMessageFactory.showErrorMessage('Please check your CSV');
                        return languageBasedErrorFactory.getProperErrorMessage('csvFileError', 0, '3');
                    }
                }
                console.log(vm.dataGotFromCsv, 'vm.dataGotFromCsv');

                $log.log(vm.dataGotFromCsv);
                $log.log(tarr);
                return tarr;
            }
        };

        //===============file for csv upload hit=============
        function csvUploadHit(data, file) {
            var dataSend = new FormData();
            dataSend.append('access_token', $cookies.get('obj'));
            dataSend.append('contract_id', vm.dataToFill.contract_id);
            dataSend.append('corporate_id', vm.dataToFill.corporate_id);
            dataSend.append('domainUrl', checkDomain.getDomainName());
            dataSend.append('employee_list', file.fileG);
            dataSend.append('records', data.length);
            dataSend.append('socket_id', $rootScope.socket.id);
            
            $log.log(dataSend);
            vm.loading = true;
            var promise = getAgreement.manageEmployeesBulk(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 400) { 
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    //languageBasedErrorFactory.getProperErrorMessage('addEmployeeSucc',0,1);
                    //errorMessageFactory.showErrorMessage('Employee added successfully.',1);
                    //$timeout(function() {
                    //    $mdDialog.hide();
                    //    $state.reload();
                    //}, 2000);
                    return payload.title.data;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
            return promise;
        }


        //=========================edit car details pop ===============================
        function uploadCSVPop($event) {
            vm.items = {};
            vm.items.file = '';
            vm.items.fileG = '';
            vm.items.error = '';
            vm.items.success = '';
            vm.items.success_1 = '';
            vm.items.csvButtonDownloadSucc = false;
            vm.items.loadingE = false;
            vm.items.csvButtonDownloadErr = false;
            vm.items.confirmHide = false;
            vm.items.validatedArray = [];
            vm.items.simpleArray = [];
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/uploadCSVDialogEmployee.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });

            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                    vm.headersNotPresent = [];
                    vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
                    vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
                    getAllEmployees(0, vm.searchModel.limit, vm.dataToFill);
                };
                $scope.confirmUpload = function () {
                    if (!$scope.items.file) {
                        $scope.items.error = languageBasedErrorFactory.getProperErrorMessage('uploadErr', 0, '3');
                        $timeout(function () {
                            $scope.items.error = '';
                        }, 2000);
                    } else {
                        //$mdDialog.hide();
                        $scope.items.loadingE = true;
                        $scope.bulkLoadData_1 = csvUploadHit($scope.items.validatedArray, $scope.items);
                        $scope.bulkLoadData_1.then(function (payload) {
                            $scope.bulkLoadData = payload.title.data;
                            if ($scope.bulkLoadData) {
                                $scope.items.loadingE = false;
                                $scope.items.error = '';
                                $scope.items.success = languageBasedErrorFactory.getProperErrorMessage('successEmp', 0, '3');
                                $scope.items.csvButtonDownloadSucc = true;
                                $scope.items.confirmHide = true;
                                //if($scope.bulkLoadData.errored > 0){
                                //    $scope.items.loadingE = false;
                                //    $scope.items.success = '';
                                //    $scope.items.success_1 = '';
                                //    $scope.items.error = languageBasedErrorFactory.getProperErrorMessage('file',0,'3') + ': ' + $scope.items.file + ' ' + languageBasedErrorFactory.getProperErrorMessage('bulkErr1',0,'3')
                                //        + ' ' + $scope.bulkLoadData.successfull + ' ' + languageBasedErrorFactory.getProperErrorMessage('bulkErr2',0,'3');
                                //    $scope.items.csvButtonDownloadErr = true;
                                //    $scope.items.confirmHide = true;
                                //    //$timeout(function(){
                                //    //    $scope.items.error = '';
                                //    //},6000);
                                //}
                                //else if($scope.bulkLoadData.errored == 0){
                                //    $scope.items.loadingE = false;
                                //    $scope.items.error = '';
                                //    $scope.items.success = languageBasedErrorFactory.getProperErrorMessage('file',0,'3') + ': ' + $scope.items.file + ' ' + languageBasedErrorFactory.getProperErrorMessage('bulkSucc1',0,'3')
                                //        + ' ' + $scope.bulkLoadData.original_length + ' ' + languageBasedErrorFactory.getProperErrorMessage('bulkSucc2',0,'3');
                                //    $scope.items.csvButtonDownloadSucc = true;
                                //    $scope.items.confirmHide = true;
                                //    //$timeout(function(){
                                //    //    $scope.items.success = '';
                                //    //},6000);
                                //}
                            }
                        });
                    }

                };

                //$scope.exportToCSVBulk = function(){
                //    var dataArrayExport = [];
                //    $scope.bulkLoadData.employee_list.forEach(function(column) {
                //        var d = {};
                //        d['First Name'] = column.name;
                //        d['Last Name'] = column.last_name;
                //        d['Email'] = column.email;
                //        d['Phone Number'] = column.phone_number;
                //        d['RUT'] = column.RUT;
                //        d['Third Booking'] = column.thirdBooking;
                //        d['Approval Required'] = column.approval_required;
                //        d['Auth RUT'] = column.auth_RUT;
                //        d['VIP Employee'] = column.is_vip;
                //        d['Position'] = column.position;
                //        d['Cost Center'] = column.cost_center;
                //        d['Cost Sub Center'] = column.cost_subcenter;
                //        d['PEP'] = column.PEP;
                //        d['ROL'] = column.ROI;
                //        d['Graph'] = column.graph;
                //        d['Order of Work'] = column.order_of_work;
                //        d['Comments'] = column.comments;
                //        d['Status'] = column.status;
                //        d['Observation'] = column.observation;
                //        dataArrayExport.push(d);
                //    });
                //    vm.employeeListExport = dataArrayExport;
                //    alasql('SELECT * INTO CSV("employeeList.csv",{headers:true}) FROM ?',[vm.employeeListExport]);
                //};

                //==================file upload function========================
                vm.uploadName = '';

                $scope.clickTrigger = function ($event, type) {
                    $log.log('ddf');
                    $event.stopPropagation();
                    vm.uploadName = type;
                    var element = document.getElementById('documentUpload');
                    element.click();
                };

                //===============file for csv upload=============
                $scope.file_to_upload = function (File, type) {
                    $log.log('type', type);
                    var file = File[0];
                    var transcript = File[0];
                    $scope.items.file = File[0].name;
                    $scope.items.fileG = File[0];
                    vm.headersNotPresent = [];
                    $scope.$apply();
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        vm.dataGotFromCsv = reader.result;
                        $scope.items.simpleArray = makeCsvDataInArray(vm.dataGotFromCsv);
                        if ($scope.items.simpleArray == 'The file does not contain the valid columns' || $scope.items.simpleArray == 'El archivo no contiene las columnas válidas') {
                            $scope.items.success_1 = '';
                            $scope.items.success = '';
                            //$scope.items.error = languageBasedErrorFactory.getProperErrorMessage('file',0,'3') + ': ' + $scope.items.file + ' ' + languageBasedErrorFactory.getProperErrorMessage('csvFileError',0,'3');
                            $scope.items.error = 'El archivo no contiene las columnas válidas' + ': ' + vm.headersNotPresent.toString();
                            //$timeout(function(){
                            //    $scope.items.error = '';
                            //},3000);
                        } else {
                            //$scope.items.validatedArray = validateCsvArray($scope.items.simpleArray);
                            $scope.items.validatedArray = $scope.items.simpleArray;
                            //if($scope.items.validatedArray == 'is not valid, please check the columns of the file.' || $scope.items.validatedArray == 'Archivo no es válido, por favor revise las columnas del archivo.'){
                            //    $scope.items.success_1 = '';
                            //    $scope.items.success = '';
                            //    $scope.items.error = languageBasedErrorFactory.getProperErrorMessage('file',0,'3') + ': ' + $scope.items.file + ' ' + languageBasedErrorFactory.getProperErrorMessage('csvFileError',0,'3');
                            //    //$timeout(function(){
                            //    //    $scope.items.error = '';
                            //    //},3000);
                            //}
                            //else{
                            $scope.items.error = '';
                            $scope.items.success_1 = languageBasedErrorFactory.getProperErrorMessage('file', 0, '3') + ': ' + $scope.items.file;
                            $scope.items.success = languageBasedErrorFactory.getProperErrorMessage('fileValidate', 0, '3') + ' ' + $scope.items.validatedArray.length + ' ' + languageBasedErrorFactory.getProperErrorMessage('loadedResult', 0, '3');
                            //$timeout(function(){
                            //    $scope.items.success = '';
                            //    $scope.items.success_1 = '';
                            //},3000);
                            //}
                        }
                        $scope.$apply();
                        //csvUploadHit(validatedArray);
                    };
                    reader.readAsText(File[0]);
                };
            }
        };

        //===========================change employee status=========================
        function changeEmployeeStatus(data, $event) {
            $log.log(data);

            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('statusEmploPop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed', data);
                var msgSys = '';
                var dataSend = {};
                dataSend.employee_id = data.id;
                if (data.status == 1) {
                    dataSend.status = 0;
                    msgSys = 'Employee blocked.';
                } else if (data.status == 0) {
                    dataSend.status = 1;
                    msgSys = 'Employee unblocked.';
                }
                dataSend.access_token = $cookies.get('obj');
                //errorMessageFactory.showErrorMessage('Functionality is pending.',0);
                vm.loading = true;
                var promise = getAgreement.editEmployeeDetails(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        var dataForSysLogs = {
                            access_token: $cookies.get('obj'),
                            id: data.id,
                            identity: 11,
                            message: msgSys
                        };
                        $rootScope.systemLogsAdmin(dataForSysLogs);
                        languageBasedErrorFactory.getProperErrorMessage('statusEmplSucc', 0, 1, 'layout.agreementMain.manageEmployee');
                        //errorMessageFactory.showErrorMessage('Employee status updated successfully.',1);
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );

            }, function () {
                $log.log('not confirmed');
            });
        };

        //=====================to delete employee====================
        function deleteEmployee(data, $event, msg) {
            var confirm = $mdDialog.confirm()
                .title(msg ? 'Está seguro que desea eliminar los empleados seleccionados?' : languageBasedErrorFactory.getProperErrorMessage('deleteEmployeePop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('yes', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('no', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                //errorMessageFactory.showErrorMessage('Functionality is pending',0);
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.is_deleted = 1;
                dataSend.employee_id = [];
                if (!msg)
                    dataSend.employee_id.push(data.id);
                else {
                    for (var i = 0; i < data.length; i++) {
                        if (data[i].checked) {
                            dataSend.employee_id.push(data[i].id);
                        }
                    }
                }
                dataSend.contract_id = Number($stateParams.contractId);
                vm.loading = true;
                var promise = getAgreement.deleteEmployeeHit(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        if (payload && payload.title.status == 200) {
                            if (!msg)
                                languageBasedErrorFactory.getProperErrorMessage('deleteEmployeeSucc', 0, 1, 'layout.agreementMain.manageEmployee');
                            else {
                                var msgG = payload.title.data.total_deleted + ' ' + languageBasedErrorFactory.getProperErrorMessage('outOf', 0, 3) + ' ' + vm.selectedEmployeeToRemove.length + ' ' + languageBasedErrorFactory.getProperErrorMessage('deleteEmployeeSuccCount', 0, 3);
                                errorMessageFactory.showErrorMessage(msgG, 1, 'layout.agreementMain.manageEmployee');
                            }
                        } else {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                        //errorMessageFactory.showErrorMessage('Employee deleted successfully.',1);

                        //$state.reload();
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
                vm.selectedEmployeeToRemove = [];
            });
        };

        //========================edit employee deails=========================
        function editEmployeeDetails(data) {
            vm.addEmployeeFlag = false;
            vm.editEmployeeFlag = true;
            $timeout(function () {
                $location.hash('editEmployee');
                // call $anchorScroll()
                anchorSmoothScroll.scrollTo('editEmployee');
            }, 0);

            getAuthList(data.id);
            vm.dataToFill.employee_list.first_name = data.name;
            vm.dataToFill.employee_list.last_name = data.last_name;
            vm.dataToFill.employee_list.RUT = RutHelper.format(data.RUT);
            vm.dataToFill.employee_list.approval_required = data.approval_required;
            vm.dataToFill.employee_list.thirdBooking = data.thirdBooking;
            vm.dataToFill.employee_list.is_vip = data.is_vip ? data.is_vip : 0;

            vm.dataToFill.employee_list.approval_required_booking_app = data.customer_booking_access ? data.customer_booking_access : 0;
            vm.dataToFill.employee_list.approval_required_booking_panel = data.panel_booking_access ? data.panel_booking_access : 0;

            vm.dataToFill.employee_list.email = data.email;
            vm.dataToFill.employee_list.phone_number = data.phone_number;
            vm.dataToFill.employee_list.auth_RUT = data.auth_RUT ? RutHelper.format(data.auth_RUT) : '';
            vm.dataToFill.employee_list.rutFlag_person = false;
            vm.dataToFill.employee_list.rutFlag = false;
            vm.dataToFill.employee_list.id = data.id;
            vm.dataToFill.employee_list.position = data.position ? data.position : '';
            vm.dataToFill.employee_list.cost_center = data.cost_center ? data.cost_center : '';
            vm.dataToFill.employee_list.cost_subCenter = data.cost_subcenter ? data.cost_subcenter : '';
            vm.dataToFill.employee_list.ROL = data.ROI ? data.ROI : '';
            vm.dataToFill.employee_list.graph = data.graph ? data.graph : '';
            vm.dataToFill.employee_list.order_of_work = data.order_of_work ? data.order_of_work : '';
            vm.dataToFill.employee_list.PEP = data.PEP ? data.PEP : '';
            vm.dataToFill.employee_list.comments = data.comments ? data.comments : '';
        };

        function editApi() {
            vm.allAuthList.forEach(function(data){
                data.RUT =  RutHelper.clean(data.RUT)
            })
            var where = _.where(vm.allAuthList, {
                RUT: RutHelper.clean(vm.dataToFill.employee_list.auth_RUT)
            });
            if (where.length > 0) {
                vm.noResults = false;
            }
            //errorMessageFactory.showErrorMessage('Functionality is pending',0);
            if (vm.noResults || (where.length == 0 && vm.dataToFill.employee_list.approval_required == 1)) {
                errorMessageFactory.showErrorMessage('Rut del autorizador no pertenece al convenio', 0);
                return;
            }
            if (vm.dataToFill.employee_list.approval_required && !RutHelper.validate(vm.dataToFill.employee_list.auth_RUT)) {
                languageBasedErrorFactory.getProperErrorMessage('authRutValid1', 0, 0);
                return;
            }

            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.name = vm.dataToFill.employee_list.first_name;
            dataSend.phone_number = vm.dataToFill.employee_list.phone_number ? vm.dataToFill.employee_list.phone_number : '';
            dataSend.email = vm.dataToFill.employee_list.email;
            dataSend.thirdBooking = vm.dataToFill.employee_list.thirdBooking == true ? 1 : 0;
            dataSend.approval_required = vm.dataToFill.employee_list.approval_required == true ? 1 : 0;
            dataSend.is_vip = vm.dataToFill.employee_list.is_vip == true ? 1 : 0;
            dataSend.employee_id = vm.dataToFill.employee_list.id;
            dataSend.last_name = vm.dataToFill.employee_list.last_name;
            dataSend.comments = vm.dataToFill.employee_list.comments ? vm.dataToFill.employee_list.comments : '';
            dataSend.position = vm.dataToFill.employee_list.position ? vm.dataToFill.employee_list.position : '';
            dataSend.cost_center = vm.dataToFill.employee_list.cost_center ? vm.dataToFill.employee_list.cost_center : '';
            dataSend.cost_subcenter = vm.dataToFill.employee_list.cost_subCenter ? vm.dataToFill.employee_list.cost_subCenter : '';
            dataSend.ROI = vm.dataToFill.employee_list.ROL ? vm.dataToFill.employee_list.ROL : '';
            dataSend.graph = vm.dataToFill.employee_list.graph ? vm.dataToFill.employee_list.graph : '';
            //dataSend.order_of_work = vm.dataToFill.employee_list.order_of_work?vm.dataToFill.employee_list.order_of_work:'';
            dataSend.PEP = vm.dataToFill.employee_list.PEP ? vm.dataToFill.employee_list.PEP : '';

            dataSend.panel_booking_access = vm.dataToFill.employee_list.approval_required_booking_panel == true ? 1 : 0;
            dataSend.customer_booking_access = vm.dataToFill.employee_list.approval_required_booking_app == true ? 1 : 0;

            if (vm.dataToFill.employee_list.RUT)
                dataSend.RUT = RutHelper.clean(vm.dataToFill.employee_list.RUT);
            dataSend.auth_RUT = vm.dataToFill.employee_list.approval_required == true ? RutHelper.clean(vm.dataToFill.employee_list.auth_RUT) : '';

            vm.loading = true;
            var promise = getAgreement.editEmployeeDetails(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        var dataForSysLogs = {
                            access_token: $cookies.get('obj'),
                            id: vm.dataToFill.employee_list.id,
                            identity: 11,
                            message: 'Employee details updated.'
                        };
                        $rootScope.systemLogsAdmin(dataForSysLogs);
                        languageBasedErrorFactory.getProperErrorMessage('editEmploySucc', 0, 1, 'layout.agreementMain.manageEmployee');
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    //errorMessageFactory.showErrorMessage('Employee details updated successfully.',1);
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.agreementMain.manageEmployee');
            }
        });
        //=================go back================
        function goBack() {
            $state.go('layout.agreementMain.agreement');
        };
        //===================store details======================
        function storeDetails() {
            var data = {
                corporateId: $stateParams.corporateId,
                contractId: $stateParams.contractId,
                path: 0
            };
            $cookies.put('setData', JSON.stringify(data));
        }
        //==============================export csv===========================
        function exportToCSV(skip, limit) {
            vm.loading = true;
            var dataSend = {
                access_token: $cookies.get('obj'),
                limit: limit,
                offset: skip,
                contract_id: $stateParams.contractId
            };
            var promise = getAgreement.getContractRelatedEmployee(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    var dataArrayExport = [];
                    var employeeListExport = payload.title.data.result;
                    employeeListExport.forEach(function (column) {
                        var d = {};
                        d['ID'] = column.id;
                        d['Activation Date'] = moment(column.activation_date).format('lll');
                        d['Created On'] = moment(column.created_on).format('lll');
                        d['Name'] = column.last_name ? column.name + ' ' + column.last_name : column.name;
                        d['Email'] = column.email;
                        d['Mobile Number'] = column.phone_number;
                        d['Unique Code'] = column.uniquecode;
                        d['RUT'] = RutHelper.format(column.RUT);
                        d['Approval Required'] = column.approval_required;
                        if (column.approval_required == 1) {
                            d['Auth RUT'] = RutHelper.format(column.auth_RUT);
                        } else {
                            d['Auth RUT'] = '';
                        }
                        d['Third Booking'] = column.thirdBooking;
                        d['VIP'] = column.is_vip;
                        d['PEP'] = column.PEP ? column.PEP : '';
                        d['ROL'] = column.ROI ? column.ROI : '';
                        d['Cost Center'] = column.cost_center ? column.cost_center : '';
                        d['Cost Sub Center'] = column.cost_subcenter ? column.cost_subcenter : '';
                        d['Graph'] = column.graph ? column.graph : '';
                        d['Order Of Work'] = column.order_of_work ? column.order_of_work : '';
                        d['Position'] = column.position ? column.position : '';
                        d['Comments'] = column.comments ? column.comments : '';
                        d['Customer ID'] = column.employee_id;
                        d['Contract ID'] = column.contract_id;
                        d['Corporate ID'] = column.corporate_id;
                        d['Status'] = column.status == 0 ? 'Inactive' : 'Active';
                        d['Deleted'] = column.is_deleted == 0 ? 'No' : 'Yes';
                        dataArrayExport.push(d);
                    });
                    vm.employeeListExport = dataArrayExport;
                    alasql('SELECT * INTO CSV("employeeList.csv",{headers:true}) FROM ?', [vm.employeeListExport]);
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        //===========================get authorizer list==========================
        function getAuthList(data) {
            var dataToSend = {};
            dataToSend.access_token = $cookies.get('obj');
            dataToSend.contract_id = $stateParams.contractId;
            vm.loading = true;
            var promise = getAgreement.getAuthorizerList(dataToSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.allAuthList = [];
                    if (payload.title.data && payload.title.data.length) {
                        vm.allAuthList = payload.title.data;
                        for (var i = 0; i < vm.allAuthList.length; i++) {
                            vm.allAuthList[i].RUT = RutHelper.format(vm.allAuthList[i].RUT);
                            if (!vm.allAuthList[i].RUT) {
                                vm.allAuthList[i].RUT = vm.allAuthList[i].name;
                            }
                            if (vm.allAuthList[i].id == data) {
                                vm.allAuthList.splice(i, 1);
                            }
                        }
                    } else {
                        vm.allAuthList = [];
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAuthList();


        //==================remove multiple employees========================
        function removeEmployees($event) {
            if (!vm.selectedEmployeeToRemove.length) {
                languageBasedErrorFactory.getProperErrorMessage('selectEmployeeFirst', 0, 0);
                return;
            }

            deleteEmployee(vm.selectedEmployeeToRemove, $event, 1)
        }

        function checkForDelete(data) {
            if (vm.selectedEmployeeToRemove.length) {
                for (var i = 0; i < vm.selectedEmployeeToRemove.length; i++) {
                    if (vm.selectedEmployeeToRemove[i].id == data.id) {
                        vm.selectedEmployeeToRemove[i].checked = !data.checked;
                        return;
                    }
                }
                vm.selectedEmployeeToRemove.push({
                    id: data.id,
                    checked: !data.checked
                })
            } else {
                vm.selectedEmployeeToRemove.push({
                    id: data.id,
                    checked: !data.checked
                })
            }
        }

        //========================on selecting auth========================
        function onSelectingAuth() {

        }
        // =================== FUNCATION FOR RESET CUSTOMER PASSWORD BY ADMIN =================//
        function resetPassword(data, $event) {
            vm.loading = true;
            var promise = adminAccessService.checkStateValid('Cambiar Contraseña Empleado Dotación'); //$stateParams.id
            return promise.then(
                function (payload) {
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (!payload.title.data.granted) {
                            errorMessageFactory.showErrorMessage('No está autorizado para usar esta opción', 0);
                            //errorMessageFactory.showErrorMessage('Option not available because you not have the right',0);
                            return false;
                        } else {
                            vm.loading = false;
                            // blockDriverPopUp($event, id, value);
                            OpenPopForResetPassword(data, $event)
                            return true;
                        }
                    }
                },
                function (errorPayload) {
                    console.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function OpenPopForResetPassword(data, $event) {
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/resetPasswordOfCustomer.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: ResetPasswordDialogController
            });

            function ResetPasswordDialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    if ($scope.items.passwordMatchFlag) {
                        return;
                    }
                    vm.loading = true;
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.customer_id = data.customer_id;
                    dataSend.password = $scope.items.password;
                    var promise = getDrivers.resetPasswordToCustomer(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            vm.loading = false;
                            $mdDialog.hide();
                            if (payload && payload.title.status == 400) {
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            } else {
                                errorMessageFactory.showErrorMessage('Contraseña restablecida correctamente', 0);
                            }
                        },
                        function (errorPayload) {
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        });
                };
                //=======================password match function====================
                $scope.matchConfirmPassword = function (data) {
                    if (data) {
                        if (data != $scope.items.password) {
                            $scope.items.passwordMatchFlag = true;
                        } else {
                            $scope.items.passwordMatchFlag = false;
                        }
                    } else {
                        $scope.items.passwordMatchFlag = false;
                    }
                };
                $scope.matchPassword = function (data) {
                    if (data && $scope.items.confirmPassword) {
                        if (data != $scope.items.confirmPassword) {
                            $scope.items.passwordMatchFlag = true;
                        } else {
                            $scope.items.passwordMatchFlag = false;
                        }
                    }
                };
            }
        }
        // =================== FUNCATION FOR RESET CUSTOMER PASSWORD BY ADMIN =================//


        // =================== FUNCATION FOR SEND NEWPASSWORD EMAIl =================//
        function SendEmail(data, $event) {
            vm.loading = true;
            var promise = adminAccessService.checkStateValid('Cambiar Contraseña Empleado Dotación'); //$stateParams.id
            return promise.then(
                function (payload) {
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (!payload.title.data.granted) {
                            errorMessageFactory.showErrorMessage('No está autorizado para usar esta opción', 0);
                            //errorMessageFactory.showErrorMessage('Option not available because you not have the right',0);
                            return false;
                        } else {
                            vm.loading = false;
                            // blockDriverPopUp($event, id, value);
                            OpenPopForResetPasswordMail(data, $event)
                            return true;
                        }
                    }
                },
                function (errorPayload) {
                    console.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function OpenPopForResetPasswordMail(data, $event) {
            var parentEl = angular.element($document.body);
            var domain = checkDomain.getDomainName();
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/resetPasswordOfCustomerMail.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: SendResetPasswordMailDialogController
            });

            function SendResetPasswordMailDialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    vm.loading = true;
                    var dataSend = {};
                    dataSend.domainUrl = domain;
                    dataSend.login_id = data.customer_email;
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.isAdmin = 1;
                    var promise = getDrivers.sendEmailToCustomerResetPassword(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            vm.loading = false;
                            $mdDialog.hide();
                            if (payload && payload.title.status == 400) {
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            } else {
                                errorMessageFactory.showErrorMessage('Correo enviado', 0);
                            }
                        },
                        function (errorPayload) {
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        });
                };
            }
        }
        // =================== FUNCATION FOR SEND NEWPASSWORD EMAIl =================//
    }
})();

/**
 * Created by Ashish Garg.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('DriverEvaluationController', DriverEvaluationController);

    function DriverEvaluationController($cookies, $state, $log, $rootScope, $timeout, $scope, $mdDialog, getDriverEvaluation, languageBasedErrorFactory, errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.selectEmailType = '1';
        vm.sendDataAPI = sendDataAPI;
        vm.getDataAPI = getDataAPI;
        vm.deleteComment = deleteComment;
        vm.addCommentButton = addCommentButton;
        vm.changeEmailType = changeEmailType;
        vm.emailTitle = ''; // EMAIL TITLE
        vm.emailDescription = ''; // EMAIL DESCRIPTION
        vm.commentCategories = []; //EMAIL COMMENTS FOR BUTTONS
        vm.addComment = false;

        // SEND DATA TO BACKEND
        function sendDataAPI() {
            vm.loading = true;
            var sendData = {};
            sendData.access_token = $cookies.get('obj');
            sendData.template = vm.selectEmailType;
            sendData.title = vm.emailTitle || '';
            sendData.description = vm.emailDescription || '';
            sendData.categories = vm.commentCategories || [];
            var promise = getDriverEvaluation.addDriverEvaluation(sendData);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {

                        languageBasedErrorFactory.getProperErrorMessage('driverRaingEmailSuccessMessage', 0, 0)
                        getDataAPI(); // To Get Update Data

                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    vm.errMsg = errorPayload.data.message;
                    $timeout(function () {
                        vm.errMsg = '';
                    }, 2000);
                }
            );
        }

        // GET DATA FROM BACKEND
        function getDataAPI() {
            vm.loading = true;
            var promise = getDriverEvaluation.getDriverEvaluationAPI(vm.selectEmailType);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {

                        if (payload.title.status == 400) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        } else if (payload.title.status == 201 || payload.title.status == 200) {

                            vm.emailTitle = payload.title.data.title || '';
                            vm.emailDescription = payload.title.data.description || '';
                            vm.commentCategories = payload.title.data.categories || [];

                        }
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    vm.errMsg = errorPayload.data.message;
                    $timeout(function () {
                        vm.errMsg = '';
                    }, 2000);
                }
            );
        }
        getDataAPI(); // To Get Default Data

        // TO DELETE COMMENT
        function deleteComment(index) {
            vm.commentCategories.splice(index, 1);
        }

        // TO ADD NEW COMMENT
        function addCommentButton() {
            if (vm.addcommentLabel)
                vm.commentCategories.push({
                    label: vm.addcommentLabel || ''
                });
            vm.addcommentLabel = '';
        }

        // ON CHANGE IN EMAIL
        function changeEmailType() {
            getDataAPI(); // To Get Update Data
        }
    }
})();
/**
 * Created by cl-macmini-51 on 6/22/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('DriverEarningController', DriverEarningController);

    /** @ngInject */
    function DriverEarningController($cookies, $state, $log, $rootScope, $timeout, $scope, filterFilter, $mdDialog,$document, getGeofence, getServices, getDriverEarning,languageBasedErrorFactory,errorMessageFactory,getVehicles) {
        var vm = this;
        vm.loading = false;
        vm.totalEarnings = 0;
        vm.currentPage = 0;
        vm.totalCars = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.predicate = 'index';
        vm.reverse = false;
        vm.getPagesCount = getPagesCount;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.init = init;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.addNewEarning = addNewEarning;
        vm.addNewEarningHit = addNewEarningHit;
        vm.getAllDriverEarnings = getAllDriverEarnings;
        vm.editEarningPop = editEarningPop;
        vm.paginationNew = paginationNew;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.driverEarningMain.driverEarning');
            }
        });
        //====================function for dropdown pages and page count===============
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];

        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllDriverEarnings( 0, vm.itemsPerPageGot);
        };

        function paginationNew(page){
            getAllDriverEarnings((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot);
        }

        //==================get all drivers=======================
        function getAllDriverEarnings(skip, limit) {
            vm.loading = true;
            var promise = getDriverEarning.getDriverEarningList(skip, limit);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.totalEarnings = payload.title.totalCount;
                    vm.dataLength = payload.title.totalCount;

                    if (payload.title.totalCount == 0) {
                        vm.sp_pagination = false;
                        vm.tBodyFlag = false;
                        vm.tFootFlag = true;
                    } else {
                        vm.sp_pagination = true;
                        vm.tBodyFlag = true;
                        vm.tFootFlag = false;
                    }

                    var dataArray = [];
                    var erningList = payload.title.result;
                    erningList.forEach(function(column) {
                        var d = {};
                        d.airport_trip_charge = column.airport_trip_charge;
                        d.matrix_id = column.matrix_id;
                        d.name = column.name;
                        d.non_airport_trip_charge = column.non_airport_trip_charge;
                        d.region_name = column.region_name;
                        d.service_name = column.service_name;
                        d.branch = column.branch;
                        d.service_type = column.service_type;
                        d.vehicle_type = column.vehicle_type;
                        dataArray.push(d);
                    });
                    vm.erningList = dataArray;
                    for (var i = 0; i < vm.erningList.length; i++) {
                        vm.erningList[i].index = (skip + i);
                    }
                    if (vm.dataLength <= vm.itemsPerPageGot) {
                        vm.sp_pagination = false;
                    } else {
                        vm.sp_pagination = true;
                        //vm.pageCount(payload.title.totalCount);
                    }
                    vm.skipValue = vm.erningList[0].index;
                    vm.limitValue = vm.erningList[vm.erningList.length - 1].index;

                    $scope.$watch('vm.search', function(newVal, oldVal) {
                        vm.filtered = filterFilter(vm.erningList, newVal);
                        vm.totalItems = vm.filtered.length;
                        if (vm.filtered.length == 0) {
                            vm.watchPagination = false;
                        } else {
                            vm.watchPagination = true;
                        }
                        if (vm.filterOn == true) {
                            vm.skipValueFilter = vm.filtered.length;
                            vm.sp_pagination = false;
                        }
                    }, true);

                    //range();
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                });
        };
        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    } else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        vm.getAllDriverEarnings((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected);
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        vm.currentPage++;
        //        vm.getAllDriverEarnings((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected);
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    vm.getAllDriverEarnings((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected);
        //};

        function init() {
            vm.getAllDriverEarnings(0, vm.searchModel.limit);
        };
        init();

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            vm.filterOn = true;
            if (vm.search.length == 0) {
                vm.filterOn = false;
                vm.watchPagination = true;
                vm.sp_pagination = true;
            }
        };

        //====================get branch list====================
        function getBranch() {
            vm.loading = true;
            var promise = getGeofence.branch();
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if(payload.title.status == 400){
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    else if(payload.title.status == 401){
                        errorMessageFactory.showErrorMessage(payload.title.message,2,'home');
                    }
                    else if(payload.title.status == 201 || payload.title.status == 200) {
                        var where = _.where(payload.title.data, {parent_id: 0});
                        vm.branchList = _.where(where, {is_active: 1});
                    }
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        getBranch();
        //==============get all services=================
        function  getAllServices(){
            vm.loading = true;
            var promise = getServices.allServices(0, 0, 2,0);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if(payload.title.status == 400){
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    else if(payload.title.status == 401){
                        errorMessageFactory.showErrorMessage(payload.title.message,2,'home');
                    }
                    else if(payload.title.status == 201 || payload.title.status == 200) {
                        vm.servicesList = _.where(payload.title.data.result, {status: 1});
                    }
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        getAllServices();

        //========================add new earning hit============================
        function addNewEarningHit(data){
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.branch = Number(data.branchSelected);
            dataSend.service_type = Number(data.typeOfServiceSelected);
            dataSend.vehicle_type = Number(data.vehicleTypeSelected);
            dataSend.non_airport_trip_charge = data.nonAirportService;
            dataSend.airport_trip_charge = data.airportService;
            vm.loading = true;
            var promise = getDriverEarning.addDriverEarning(dataSend);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    languageBasedErrorFactory.getProperErrorMessage('driverEarningSucc',0,1,'layout.driverEarningMain.driverEarning')
                    //errorMessageFactory.showErrorMessage('Driver earning created successfully.',1);
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };

        //======================get all vehicles==============
        function getAllVehicles(skip, limt, filter) {
            //vm.loading = false;
            var promise = getVehicles.allVehicles(skip, limt, filter);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    //vm.loading = false;
                    if(payload.title.status == 400){
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    else if(payload.title.status == 401){
                        errorMessageFactory.showErrorMessage(payload.title.message,2,'home');
                    }
                    else if(payload.title.status == 201 || payload.title.status == 200) {
                        vm.vehicle = [];
                        angular.forEach(payload.title.data.result, function (column) {
                            vm.vehicle.push({id: column.id, name: column.name})
                        });
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllVehicles(0, 0, 2);

        //=============================add new earning==============================
        function addNewEarning($event){
            vm.items = {
                branchSelected: '',
                branches: vm.branchList,
                typeOfServiceSelected: '',
                typeOfService: vm.servicesList,
                vehicleTypeSelected: '',
                vehicleType: vm.vehicle,
                airportService: '',
                nonAirportService: '',
                error: ''
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/addDriverEarning.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });
            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    if($scope.items.airportService > 100){

                        $scope.items.error = languageBasedErrorFactory.getProperErrorMessage('driverEarningErr1',0,'3');
                        $timeout(function(){
                            $scope.items.error = '';
                        },1500);
                        return;
                    }
                    if($scope.items.nonAirportService > 100){
                        $scope.items.error = languageBasedErrorFactory.getProperErrorMessage('driverEarningErr2',0,'3');
                        $timeout(function(){
                            $scope.items.error = '';
                        },1500);
                        return;
                    }
                    $mdDialog.hide();
                    addNewEarningHit($scope.items);
                };
                //$scope.serviceChanged = function(){
                //    $scope.items.vehicleType = _.where($scope.items.typeOfService,{id:Number($scope.items.typeOfServiceSelected)})[0].vehicle_mapping;
                //}
            }
        };

        //==========================edit earning hit===========================
        function editEarningHit(data){
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.branch = Number(data.branchSelected);
            dataSend.service_type = Number(data.typeOfServiceSelected);
            dataSend.vehicle_type = Number(data.vehicleTypeSelected);
            dataSend.non_airport_trip_charge = data.nonAirportService;
            dataSend.airport_trip_charge = data.airportService;
            dataSend.matrix_id = data.id;
            vm.loading = true;
            var promise = getDriverEarning.editDriverEarning(dataSend);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    var dataForSysLogs = {
                        access_token: $cookies.get('obj'),
                        id: data.id,
                        identity : 4,  // 0- driver, 1- customer , 2 -car
                        message : 'Earning updated.'
                    };
                    $rootScope.systemLogsAdmin(dataForSysLogs);
                    languageBasedErrorFactory.getProperErrorMessage('editSucc',0,1,'layout.driverEarningMain.driverEarning')
                    //errorMessageFactory.showErrorMessage('Driver earning upadted successfully.',1);
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        //===========================edit driver earning pop================================
        function editEarningPop(data,$event){
            vm.items = {
                branchSelected: data.branch,
                branches: vm.branchList,
                typeOfServiceSelected: data.service_type,
                typeOfService: vm.servicesList,
                vehicleTypeSelected: data.vehicle_type,
                vehicleType: vm.vehicle,
                airportService: data.airport_trip_charge,
                nonAirportService: data.non_airport_trip_charge,
                error: '',
                id: data.matrix_id
            };

            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/editDriverEarning.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });
            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    if($scope.items.airportService > 100){
                        $scope.items.error = languageBasedErrorFactory.getProperErrorMessage('driverEarningErr1',0,'3');
                        $timeout(function(){
                            $scope.items.error = '';
                        },1500);
                        return;
                    }
                    if($scope.items.nonAirportService > 100){
                        $scope.items.error = languageBasedErrorFactory.getProperErrorMessage('driverEarningErr2',0,'3');
                        $timeout(function(){
                            $scope.items.error = '';
                        },1500);
                        return;
                    }
                    $mdDialog.hide();
                    editEarningHit($scope.items);
                };
                //$scope.serviceChanged = function(){
                //    $scope.items.vehicleType = _.where($scope.items.typeOfService,{id:Number($scope.items.typeOfServiceSelected)})[0].vehicle_mapping;
                //};
            };
        };
    }
})();
/**
 * Created by cl-macmini-51 on 4/14/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('DashboardController', DashboardController);

    /** @ngInject */
    function DashboardController($cookies, checkDomain, $state, $log, $http, MY_CONSTANT, $timeout, $rootScope, $interval, $scope, mapDashboard, getDrivers, getVehicles, getServices, getAgreement, getGeofence, $mdDialog, $document, getCars, adminAccessService, $filter, getBookings, languageBasedErrorFactory, errorMessageFactory, getFilters, Initializer) {
        var vm = this;
        var markers = [];
        var mc = null;
        var map = null;
        vm.socketFuncation = socketFuncation;
        vm.selectingBrand = selectingBrand;
        vm.socketFlag = true;
        var myCenter;
        var infowindow;
        var trafficLayer;
        var bounds;
        var bermudaTriangle;
        vm.resetFilter = resetFilter;
        vm.applyFilter = applyFilter;
        // Service To Get Map Instance
        Initializer.mapsInitialized
            .then(function () {

                if (google) {
                    console.log('>>>> GOOGLE INIT', google);
                    myCenter = new google.maps.LatLng(-33.447487, -70.673676);
                    infowindow = new google.maps.InfoWindow({
                        size: new google.maps.Size(150, 50)
                    });

                    trafficLayer = new google.maps.TrafficLayer();
                    bounds = new google.maps.LatLngBounds();
                    bermudaTriangle = new google.maps.Polygon();
                    google.maps.visualRefresh = true;
                    showDrivers(0);
                    google.maps.event.addListener(infowindow, 'domready', function () {
                        // console.log(" i m in dom ");

                        // var iwOuter = $('.gm-style-iw');
                        // var iwBackground = iwOuter.prev();
                        // iwOuter.css({
                        //     top: '36px',
                        //     left: '20px'
                        // });
                        // iwOuter.children().children(':nth-child(1)').css({
                        //     'overflow': 'hidden',
                        //     // padding: '18px'
                        // });

                        // // Remove the background shadow DIV
                        // iwBackground.children(':nth-child(2)').css({
                        //     'display': 'none'
                        // });
                        // // Remove the white background DIV
                        // iwBackground.children(':nth-child(4)').css({
                        //     'display': 'none'
                        // });
                        // //iwOuter.parent().parent().css({ left: '115px' });
                        // //// Moves the shadow of the arrow 76px to the left margin
                        // //iwBackground.children(':nth-child(1)').attr('style', function (i, s) { return s + 'left: 76px !important;' });
                        // //// Moves the arrow 76px to the left margin
                        // //iwBackground.children(':nth-child(3)').attr('style', function (i, s) { return s + 'left: 76px !important;' });
                        // iwBackground.children(':nth-child(3)').find('div').children().css({
                        //     'background-color': 'cornsilk',
                        //     'box-shadow': 'none'
                        // });
                        // var iwCloseBtn = iwOuter.next();
                        // // Apply the desired effect to the close button
                        // iwCloseBtn.css({
                        //     right: '52px',
                        //     top: '62px', // button repositioning
                        //     backgound: 'none'
                        // });
                        // // The API automatically applies 0.7 opacity to the button after the mouseout event.
                        // // This function reverses this event to the desired value.
                        // iwCloseBtn.mouseout(function () {
                        //     $(this).css({
                        //         opacity: '1'
                        //     });
                        // });
                        // $('#googleMapsDetailsWithCar').parent().addClass('col-lg-12 col-md-12 col-sm-12');
                        // iwOuter.parent().addClass('custom-iw');
                        // if (vm.jobStatusOfMarker == 1) {
                        //     $('.pickUpStatus').removeClass('onRoadAcceptedColor');
                        //     $('.pickUpStatus').removeClass('inPositionColor');
                        //     $('.pickUpStatus').addClass('startedColor');

                        //     $('.statusChangeD').removeClass('inPositionColorB');
                        //     $('.statusChangeD').addClass('completedColorB');
                        //     $('.statusChangeD').removeClass('startedColorB');
                        //     $('.statusChangeD').removeClass('onRoadAcceptedColorB');
                        // } else if (vm.jobStatusOfMarker == 7) {
                        //     $('.pickUpStatus').removeClass('startedColor');
                        //     $('.pickUpStatus').removeClass('inPositionColor');
                        //     $('.pickUpStatus').addClass('onRoadAcceptedColor');

                        //     $('.statusChangeD').removeClass('inPositionColorB');
                        //     $('.statusChangeD').removeClass('completedColorB');
                        //     $('.statusChangeD').removeClass('startedColorB');
                        //     $('.statusChangeD').addClass('onRoadAcceptedColorB');
                        // } else if (vm.jobStatusOfMarker == 4) {
                        //     $('.pickUpStatus').removeClass('startedColor');
                        //     $('.pickUpStatus').removeClass('onRoadAcceptedColor');
                        //     $('.pickUpStatus').addClass('inPositionColor');

                        //     $('.statusChangeD').removeClass('inPositionColorB');
                        //     $('.statusChangeD').removeClass('completedColorB');
                        //     $('.statusChangeD').addClass('startedColorB');
                        //     $('.statusChangeD').removeClass('onRoadAcceptedColorB');
                        // } else if (vm.jobStatusOfMarker == 15) {
                        //     $('.pickUpStatus').removeClass('startedColor');
                        //     $('.pickUpStatus').removeClass('inPositionColor');
                        //     $('.pickUpStatus').addClass('onRoadAcceptedColor');

                        //     $('.statusChangeD').addClass('inPositionColorB');
                        //     $('.statusChangeD').removeClass('completedColorB');
                        //     $('.statusChangeD').removeClass('startedColorB');
                        //     $('.statusChangeD').removeClass('onRoadAcceptedColorB');
                        // }
                        // $('#offDutyMake').off('click').on('click', function (event) {
                        //     markDriverOffDuty(vm.idOfMarker, vm.statusOfMarker);
                        // });
                        // $('#makebookingStatusChange').off('click').on('click', function (event) {
                        //     makeTheStatusChangeOfBooking(vm.jobStatusOfMarker, vm.jobIdOfMarker, event);
                        // });
                    });
                } else {
                    alert(languageBasedErrorFactory.getProperErrorMessage('onRoadMessage', 0, '3'));
                }

            });
        vm.branch = [];
        vm.branch.push({
            id: 'all',
            name: 'All'
        })
        var icon = null;
        vm.loading = true;
        vm.showFilter = false;
        vm.dataToFill = {
            total_no_of_off_duty_drivers: 0,
            total_no_of_drivers_on_duty: 0,
            total_no_of_started_drivers: 0,
            total_no_of_at_position_drivers: 0,
            total_no_of_busy_drivers: 0,
            total_no_of_drivers_available: 0,
            branch: 'all',
            vehicle: [],
            helpTraffic: false,
            service: [],
            agreement: 'all',
            tipo_contrato: 'all',
            truck: '',
            bases: '',
            filterDataDrivers: 0,
            totalData: [],
            totalBranchList: [],
            brands: []
        };
        vm.collectedData = [];
        vm.uniqueCarsArray = [];
        vm.offDuty_1 = false;
        vm.onDuty_1 = false;
        vm.started_1 = false;
        vm.inPosition_1 = false;
        vm.busy_1 = false;
        vm.all_1 = false;
        vm.countToSocket = 0;
        vm.showDrivers = showDrivers;
        //vm.showDriversWithStatus = showDriversWithStatus;
        vm.removeFilter = removeFilter;
        // vm.getAllBranches = getAllBranches;
        // vm.getAllVehicles = getAllVehicles;
        vm.initialize = initialize;
        // vm.getAllServices = getAllServices;
        // vm.getAllAgreement = getAllAgreement;
        vm.pushNotificationPop = pushNotificationPop;
        vm.showFleetsWithFilter = showFleetsWithFilter;
        vm.showDriversWithFilter = showDriversWithFilter;
        vm.setBooleans = setBooleans;
        vm.getSearchedAddress = getSearchedAddress;
        vm.ctrlFn = ctrlFn;
        // vm.onSelectingUnique = onSelectingUnique;
        vm.makeMapCenterAccToBranch = makeMapCenterAccToBranch;
        vm.changeFilter = changeFilter;
        vm.slideData = slideData;
        vm.getVehicleOnSearch = getVehicleOnSearch;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.domain = checkDomain.getDomainName();

        vm.changeFilterDate = changeFilterDate;
        vm.paginationChangedForService = paginationChangedForService;
        vm.paginationChangedForBranch = paginationChangedForBranch;
        vm.paginationChangedForVehicle = paginationChangedForVehicle;
        vm.paginationChangedForAgreement = paginationChangedForAgreement;
        vm.vehicleSearch = vehicleSearch;
        vm.serviceSearch = serviceSearch;
        vm.branchSearch = branchSearch;
        vm.agreementSearch = agreementSearch;
        vm.contratoSearch = contratoSearch;
        vm.globalLimit = 10;
        vm.globalOffset = vm.globalLimit;

        vm.service = [];
        vm.brands = [];
        // vm.service.push({
        //     id: 'all',
        //     name: 'All'
        // })
        vm.serviceOffset = 0;
        vm.service_limit = 10

        vm.vehicle = [];
        // vm.vehicle.push({
        //     id: 'all',
        //     name: 'All'
        // });
        vm.tipo_contrato=[
            {
                id: 'all',
                name: 'All'
            },
            {
                id:1,
                name:"Freelance"
            },
            {
                id:2,
                name:"Leasing"
            }
        ];


        vm.agreement = [];
        vm.agreement.push({
            id: 'all',
            name: 'All'
        });

        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];

        vm.serviceOffset = 0;
        vm.agreementOffset = 0;
        vm.vehicleOffset = 0;
        vm.branchOffset = 0;

        // =================== FILTER OBJECT ===================
        vm.filterObject = {
            access_token: $cookies.get('obj'),
            branch_filter: 1,
            vehicle_filter: 1,
            service_filter: 1,
            agreement_filter: 1,
            corporate_filter: 0,
            service_category: 0,
            corporate_status: 0,
            agreement_status: 2,
            vehicle__status: 1,
            need_lat_longs: 1,
            operation_point_filter: 0,
            service_limit: vm.globalLimit,
            service_offset: vm.serviceOffset,
            agreement_limit: vm.globalLimit,
            branch_limit: vm.globalLimit,
            branch_offset: vm.branchOffset,
            agreement_offset: vm.agreementOffset,
            vehicle_limit: vm.globalLimit,
            vehicle_offset: vm.vehicleOffset,
            branch_search_filter: 0,
            vehicle_search_filter: 0,
            service_search_filter: 0,
            agreement_search_filter: 0,
            corporate_search_filter: 0,
            operation_point_search_filter: 0,
            brandandmodel: 1
        }


        setTimeout(function () {
            document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                // if (vm.branchList && (vm.branchList.length == 0)) {
                vm.searchBranchData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

            document.getElementsByClassName('ui-select-search')[1].addEventListener('blur', function ($event) {
                // if (vm.vehicle && (vm.vehicle.length == 0)) {
                vm.searchVehicleData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

            document.getElementsByClassName('ui-select-search')[2].addEventListener('blur', function ($event) {
                // if (vm.agreement && (vm.agreement.length == 0)) {
                vm.searchAgreementData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

            document.getElementsByClassName('ui-select-search')[3].addEventListener('blur', function ($event) {
                // if (vm.service && (vm.service.length == 0)) {
                vm.searchServiceData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

        })

        // =================== GET FILTER DATA ===================
        function getFilterDataFromBackend(data, type) { //Acc to Index ['branch_search', 'vehicle_search', 'service_search', 'agreement_search', 'corporate_search', 'operation_point_search']
            if (data) {
                vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
            } else {
                vm.filterObject = {
                    access_token: $cookies.get('obj'),
                    branch_filter: 1,
                    vehicle_filter: 1,
                    service_filter: 1,
                    agreement_filter: 1,
                    corporate_filter: 0,
                    service_category: 0,
                    branch_limit: vm.globalLimit,
                    branch_offset: vm.branchOffset,
                    corporate_status: 0,
                    need_lat_longs: 1,
                    agreement_status: 2,
                    vehicle__status: 1,
                    operation_point_filter: 0,
                    branch_search_filter: 0,
                    vehicle_search_filter: 0,
                    service_search_filter: 0,
                    agreement_search_filter: 0,
                    corporate_search_filter: 0,
                    operation_point_search_filter: 0,
                    brandandmodel: 1
                }
            }

            vm.filterObject.service_limit = vm.globalLimit;
            vm.filterObject.service_offset = vm.serviceOffset;
            vm.filterObject.agreement_limit = vm.globalLimit;
            vm.filterObject.agreement_offset = vm.agreementOffset;
            vm.filterObject.vehicle_limit = vm.globalLimit;
            vm.filterObject.vehicle_offset = vm.vehicleOffset;

            var promise = getFilters.getAllFilterData(vm.filterObject);
            promise.then(
                function (payload) {

                    // ********** BRANCH DATA ********
                    if (payload.title.data.branches) {
                        var index = _.findIndex(vm.branch, {
                            region_id: 'all'
                        });
                        if (index == -1)
                            vm.branch.push({
                                region_name: 'All',
                                region_id: 'all'
                            });
                        vm.dataToFill.totalBranchList = payload.title.data.branches.data;

                        angular.forEach(payload.title.data.branches.data, function (column) {
                            //CHECK FOR DUPLICATE ENTRY
                            var branchIndex = _.findIndex(vm.branch, {
                                region_id: column.region_id
                            });
                            if (branchIndex == -1)
                                vm.branch.push(column)
                        });
                        vm.branchTotalBackendCount = payload.title.data.branches.totalCount;
                    }

                    // ********** VEHICLE DATA ********
                    if (payload.title.data.vehicles) {
                        // var index = _.findIndex(vm.vehicle, {
                        //     id: 'all'
                        // });
                        // if (index == -1)
                        //     vm.vehicle.push({
                        //         name: 'All',
                        //         id: 'all'
                        //     });
                        vm.vehicleTotalBackendCount = payload.title.data.vehicles.totalCount;
                        angular.forEach(payload.title.data.vehicles.data, function (column) {
                            //CHECK FOR DUPLICATE ENTRY
                            var vehicleIndex = _.findIndex(vm.vehicle, {
                                id: column.id
                            });
                            if (vehicleIndex == -1)
                                vm.vehicle.push({
                                    id: column.id,
                                    name: column.name
                                })
                        });
                    }

                    // *********** SERVICE DATA *********
                    if (payload.title.data.services) {
                        // var index = _.findIndex(vm.service, {
                        //     id: 'all'
                        // });
                        // if (index == -1)
                        //     vm.service.push({
                        //         name: 'All',
                        //         id: 'all'
                        //     });
                        vm.serviceTotalBackendCount = payload.title.data.services.totalCount;
                        angular.forEach(payload.title.data.services.data, function (column) {
                            //CHECK FOR DUPLICATE ENTRY
                            var serviceIndex = _.findIndex(vm.service, {
                                id: column.id
                            });
                            if (serviceIndex == -1)
                                vm.service.push({
                                    id: column.id,
                                    name: column.service_name
                                });
                        });
                    }

                    // *********** AGREEMENT DATA *********
                    if (payload.title.data.agreements) {
                        var index = _.findIndex(vm.agreement, {
                            id: 'all'
                        });
                        if (index == -1)
                            vm.agreement.push({
                                name: 'All',
                                id: 'all'
                            });
                        vm.agreementTotalBackendCount = payload.title.data.agreements.totalCount;
                        angular.forEach(payload.title.data.agreements.data, function (column) {
                            //CHECK FOR DUPLICATE ENTRY
                            var agreementIndex = _.findIndex(vm.agreement, {
                                id: column.id
                            });
                            if (agreementIndex == -1)
                                vm.agreement.push({
                                    id: column.id,
                                    name: column.name
                                });
                        });
                    }

                    // ************ MARCA Y MODELO ********
                    if (payload.title.data.brands) {
                        // var index = _.findIndex(vm.service, {
                        //     id: 'all'
                        // });
                        // if (index == -1)
                        //     vm.service.push({
                        //         name: 'All',
                        //         id: 'all'
                        //     });
                        vm.brandsTotalBackendCount = payload.title.data.brands.totalCount;
                        angular.forEach(payload.title.data.brands.data, function (column) {
                            //CHECK FOR DUPLICATE ENTRY
                            var brandsIndex = _.findIndex(vm.brands, {
                                id: column.model_id
                            });
                            if (brandsIndex == -1)
                                vm.brands.push({
                                    id: column.model_id,
                                    name: column.name
                                });
                        });
                    }

                    vm.loading = false;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        }

        // ************ PAGINATION ON BRANCH **************
        function paginationChangedForBranch() {
            var index = _.findIndex(vm[vm.searchFilterArray[0]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.branchTotalBackendCount > (vm.branchList.length - index)) {
                commonFunction(0);
                vm.branchOffset += 10;
                getFilterDataFromBackend(vm.searchBranchData, 0);
            }
        }

        // ************ PAGINATION ON SERIVCE **************
        function paginationChangedForService() {
            var index = _.findIndex(vm[vm.searchFilterArray[2]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.serviceTotalBackendCount > (vm.service.length - index)) {
                commonFunction(2);
                vm.serviceOffset += 10;
                getFilterDataFromBackend(vm.searchServiceData, 2);
            }
        }

        // ************ PAGINATION ON VEHICLE **************
        function paginationChangedForVehicle() {
            var index = _.findIndex(vm[vm.searchFilterArray[1]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.vehicleTotalBackendCount > (vm.vehicle.length - index)) {
                commonFunction(1);
                vm.vehicleOffset = vm.vehicleOffset + 10;
                getFilterDataFromBackend(vm.searchVehicleData, 1);
            }
        }

        // ************ PAGINATION ON AGREEMENT **************
        function paginationChangedForAgreement() {
            var index = _.findIndex(vm[vm.searchFilterArray[3]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.agreementTotalBackendCount > (vm.agreement.length - index)) {
                commonFunction(3);
                vm.agreementOffset += vm.globalOffset;
                getFilterDataFromBackend(vm.searchAgreementData, 3);
            }
        }
        // *********** COMMON FUNCTION FOR FILTER PAGINATION AND SEARCHING ***********
        function commonFunction(type, mode) {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                // vm['search' + vm.searchFilterArray[i] + 'Data'] = '';
                if (mode == 'search' || i != type) {
                    vm[vm.searchFilterArray[i]] = [];
                    // vm[vm.searchFilterArray[i]].push({
                    //     id: 'all',
                    //     name: 'All'
                    // });
                    vm[vm.searchFilterArray[i] + 'Offset'] = 0;
                    vm['search' + vm.searchFilterArray[i].substring(0, 1).toUpperCase() + vm.searchFilterArray[i].substring(1) + 'Data'] = '';
                }
            }
        }
        // ************ SEARCH VEHICLE ***************
        function vehicleSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchVehicleData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(1, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 1);
                }, 2000);
            }
        }

        // ************ SEARCH SERVICE ***************
        function serviceSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchServiceData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(2, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 2);
                }, 2000);
            }
            // if (event.keyCode == 13) {
            //     serviceChanged();
            // }
        }

        // ************ SEARCH BRANCH ***************
        function branchSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchBranchData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(0, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 0);
                }, 2000);
            }
        }

        // ************ SEARCH AGREEMENT ***************
        function agreementSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchAgreementData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(3, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 3);
                }, 2000);
            }
        }

        // ************ SEARCH TIPO CIONTRATO ***************
        function contratoSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchContratoData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(3, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 3);
                }, 2000);
            }
        }

        // ******** CLEAR OFFSET *******
        function clearOffset() {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                vm[vm.searchFilterArray[i] + 'Offset'] = 0;
            }
        }

        function changeFilterDate() {
            vm.agreement = [];
            vm.branch = [];
            vm.vehicle = [];
            vm.service = [];
            clearOffset();
            getFilterDataFromBackend();
        }

        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.dashboardMain.dashboard');
            }
        });

        $('#collapse').hide();
        $('#collapseNew').hide();

        function slideData() {
            $('#collapse').slideToggle(1000);
            $('#collapseNew').slideToggle(1000);
            // getAllServices(0, 0);
            // getAllVehicles(0, 0, 2);
            // getAllAgreement(0, 0);
            vm.agreement = [];
            vm.branch = [];
            vm.vehicle = [];
            vm.service = [];
            getFilterDataFromBackend();
        }
        if ($rootScope.socket.connected == false || $rootScope.socket.connected == 'false') {
            $rootScope.socket.connect();
        }

        var myListener = $rootScope.socket.on('socketEventToUser', function (res) {
            vm.socketData = res.message;
            if (vm.socketData && vm.socketFlag) {
                // console.log("<<<<<<<<<<<<<<<<<<<<<<<<< socket main hun >>>>>>>>>>>>>>>>>>>>>>>>>");

                socketHandleNew(vm.socketData);
            }
        });

        // $scope.$on('$destroy', myListener);
        //$rootScope.socket.on('socketEventToUser',function(res){
        //    showDriversWithFilterSocket(vm.dataToFill);
        //});

        function socketHandleNew(data) {
            markerGot = '';
            var markerGot = _.where(markers, {
                id: data.fleet_id
            })[0];
            var indexMarker = _.findIndex(markers, {
                id: data.fleet_id
            });
            var index = _.findIndex(vm.collectedData, {
                fleet_id: data.fleet_id
            });
            var mylatLng = new google.maps.LatLng(Number(data.latitude), Number(data.longitude));
            if (markerGot && markerGot.id) {
                if (data.is_available == 0 && data.status == 0) {
                    console.log(" in if >>>>>>>>>");
                    // markerGot.setMap(null);
                    removeDuplicateMarker(data);
                    if (index > -1) {
                        vm.collectedData.splice(index, 1);
                    }
                    if (indexMarker > -1) {
                        markers.splice(indexMarker, 1);
                    }
                    getCountOfDashboardFleets(vm.collectedData, 'socket');
                } else {
                    console.log(" in else >>>>>>>>>");
                    
                    markerGot.setPosition(mylatLng);
                    var label = {
                        text: (data.unique_car_id ? data.unique_car_id.toString() : '0')+(data.tipo_contrato && data.tipo_contrato == "Leasing"?"L":""),
                        fontSize: '10px'
                    };
                    markerGot.setOptions({
                        icon: makeIconUI(data),
                        id: data.fleet_id,
                        label: label,
                        jobId: data.job_id,
                        // status: data.is_available,
                        jobStatus: data.job_status,
                        driverStatus: data.status
                    });
                    if (vm.collectedData && vm.collectedData.length) {
                        if (index > -1) {
                            if (data.fleet_id == vm.collectedData[index].fleet_id) {
                                if (vm.collectedData[index].popInfoOpen && (data.job_status != vm.collectedData[index].job_status)) {
                                    google.maps.event.trigger(markerGot, 'click');
                                }
                            }
                            vm.collectedData[index].is_available = data.is_available;
                            vm.collectedData[index].status = data.status;
                            vm.collectedData[index].job_status = data.job_status;
                            vm.collectedData[index].unique_car_id = data.unique_car_id ? data.unique_car_id : '0';
                        }
                    }

                    //openPreviousinfoWindowOpen(markers, vm.collectedData);
                    getCountOfDashboardFleets(vm.collectedData, 'socket');
                }
            } else {
                if (data.is_available != 0) {
                    console.log(" in outside else >>>>>>>>>");
                    createMarker(new google.maps.LatLng(data.latitude, data.longitude), data);
                    vm.collectedData.push(data);
                    getCountOfDashboardFleets(vm.collectedData, 'socket');
                }
            }
        }
        //==================hours format=====================
        function changeHoursFormat(data) {
            if (data) {
                var sec_num = parseInt(data, 10); // don't forget the second param
                var hours = Math.floor(sec_num / 3600);
                var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
                var seconds = sec_num - (hours * 3600) - (minutes * 60);

                if (hours < 10) {
                    hours = "0" + hours;
                }
                if (minutes < 10) {
                    minutes = "0" + minutes;
                }
                if (seconds < 10) {
                    seconds = "0" + seconds;
                }
                return hours + ':' + minutes + ':' + seconds;
            } else {
                return '00:00:00';
            }
        }

        //=======================map=========================
        function setMapOnAll(map) {
            for (var i = 0; i < markers.length; i++) {
                //var marker = markers[i];
                markers[i].setMap(map);
            }
            markers = [];
        }

        // If the map position is out of range, move it back
        function checkBounds(map) {
            if (typeof (map.getBounds()) == 'undefined')
                return;

            var latNorth = map.getBounds().getNorthEast().lat();
            var latSouth = map.getBounds().getSouthWest().lat();
            var newLat;

            if (latNorth < 85 && latSouth > -85) /* in both side -> it's ok */
                return;
            else {
                if (latNorth > 85 && latSouth < -85) /* out both side -> it's ok */
                    return;
                else {
                    if (latNorth > 85)
                        newLat = map.getCenter().lat() - (latNorth - 85);
                    /* too north, centering */
                    if (latSouth < -85)
                        newLat = map.getCenter().lat() - (latSouth + 85);
                    /* too south, centering */
                }
            }
            if (newLat) {
                var newCenter = new google.maps.LatLng(newLat, map.getCenter().lng());
                map.setCenter(newCenter);
            }
        }

        function initialize(info, type) {
            if (markers.length) {
                setMapOnAll(null);
                if (mc)
                    mc.clearMarkers();
            }
            var mcOptions = {
                gridSize: 50,
                maxZoom: 15
            };
            if (type != 0) {
                var mapProp = {
                    center: myCenter,
                    zoom: 3,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    minZoom: 3,
                    //maxZoom: 18,
                    mapTypeControl: false
                };
                map = new google.maps.Map(document.getElementById("googleMap"), mapProp);
            }
            map.setZoom(map.getZoom());
            google.maps.event.addListener(map, 'center_changed', function () {
                checkBounds(map);
            });
            mc = new MarkerClusterer(map, [], mcOptions);
            google.maps.event.addListener(map, 'click', function () {
                infowindow.close();
                restorePreviousData();
            });
            for (var i = 0; i < info.length; i++) {
                createMarker(new google.maps.LatLng(info[i].latitude,
                    info[i].longitude), info[i]);
            }
            mc.addMarkers(markers, true);
            google.maps.event.addListener(infowindow, 'closeclick', function () {
                console.log('in function');

                restorePreviousData();
            });

        };


        //$interval(function(){
        //    showDriversWithFilterSocket(0);
        //},8000);

        //====================function for infowindows====================
        function infoWindows(data, onOffData) {
            var divWithService = '<div class="row" id="googleMapsDetailsWithCar">' +
                '  <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 paddingOnDuty1">' +
                '  <div class="pickUpText">Pickup</div>' +
                '   <div class="addressDiv"><i class="fa fa-map-marker"></i>&nbsp;&nbsp;' + onOffData.job_pickup_address + '</div>' +
                ' </div>' +
                '<div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 paddingOnDuty1">' +
                '    <div class="pickUpText">Drop off</div>' +
                '<div class="addressDiv"><i class="fa fa-map-marker"></i>&nbsp;&nbsp;' + onOffData.job_address + '</div>' +
                '</div>' +
                '<div class="col-lg-12 col-sm-12 col-xs-12 col-md-12 distanceDivP">' +
                '    <div class="distanceDiv">Distance ' + data.distance + 'KM</div>' +
                '<div class="distanceDiv">Time Approx ' + data.eta + ' min</div>' +
                '</div>' +
                ' <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 customerDriverDiv">' +
                '   <div class="customerDivP">' +
                '  <div class="customerText">Customer<i class="fa fa-star" aria-hidden="true" style="color: #ff0400"></i></div>' +
                '   <div class="customerName">' + onOffData.customer_username + '</div>' +
                ' <div class="customerName">' + onOffData.country_code + onOffData.customer_phone + '</div>' +
                ' <div class="customerName">' + (onOffData.is_vip ? "VIP" : "") + '</div>' +
                '   </div>' +
                '   <div class="driverDivP">' +
                '   <div class="driverText">Driver</div>' +
                '    <div class="driverName">' + onOffData.first_name + " " + onOffData.last_name + '</div>' +
                '<div class="driverName">' + onOffData.country_code + onOffData.phone + '</div>' +
                '   <div class="driverName">Vehicle ' + ' #' + onOffData.current_car_details + '</div>' +
                '   <div class="driverName">Unique Number' + " " + "#" + onOffData.unique_car_id + '</div>' +
                '   <div class="driverName">On Duty Date' + " " + data.since_date + '</div>' +
                '</div>' +
                '</div>' +
                ' <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 pickUpDetails">' +
                '   <div class="pickUpText1">Pickup Time</div>' +
                '<div class="pickUpTime">' + data.job_pickup_datetime_filter + '</div>' +
                '<div class="pickUpStatus">' + onOffData.job_status_string + '</div>' +
                '<div class="pickUpAgreement">' + onOffData.contract_name + '</div>' +
                '  <div class="pickUpAgreement">' + onOffData.service_name + '</div>' +
                '  </div>' +
                '  <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 paddingOnDuty pickBorder">On Duty: ' + data.difference + 'min</div>' +
                '<div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 paddingOnDuty pickBorder">Since: ' + data.since + '</div>' +
                '<div class="col-lg-12 col-sm-12 col-xs-12 col-md-12 paddingOnDuty statusChangeD" id="makebookingStatusChange">' + onOffData.text + '</div>' +
                '</div>';

            var divOnDutyFree = '<div class="row" id="googleMapsDetailsWithCar">' +
                '<div class="col-lg-12 col-sm-12 col-xs-12 col-md-12">' +
                '<div class="row">' +
                '<div class="col-lg-4 col-sm-4 col-xs-4 col-md-4">' +
                '<img src="' + onOffData.fleet_image + '" />' +
                '</div>' +
                '<div class="col-lg-8 col-sm-8 col-xs-8 col-md-8 paddingZero">' +
                '<h1 style="">Driver Free</h1>' +
                ' <p id="driver">Driver</p>' +
                ' <p class="details">' + onOffData.first_name + " " + onOffData.last_name + '</p>' +
                '<p class="details">' + onOffData.country_code + onOffData.phone + '</p>' +
                ' <p class="details">Vehicle ' + ' #' + onOffData.current_car_details + '</p>' +
                ' <p class="details">Unique Number' + " " + "#" + onOffData.unique_car_id + '</p>' +
                ' <p class="details">On Duty Date' + " " + data.since_date + '</p>' +
                ' <button class="btn btn-primary tableButton" id="offDutyMake">Off Duty</button>' +
                '</div>' +
                '<div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 paddingOnDuty">On Duty: ' + data.difference + 'min</div>' +
                '<div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 paddingOnDuty">Since: ' + data.since + '</div>' +
                '</div>' +
                '</div>' +
                '</div>';

            var divOffDuty = '<div class="row" id="googleMapsDetailsWithCar">' +
                '<div class="col-lg-12 col-sm-12 col-xs-12 col-md-12">' +
                '<div class="row">' +
                '<div class="col-lg-4 col-sm-4 col-xs-4 col-md-4">' +
                '<img src="' + onOffData.fleet_image + '" />' +
                '</div>' +
                '<div class="col-lg-8 col-sm-8 col-xs-8 col-md-8 paddingZero">' +
                '<h1 style="color:black;">Out Of Service</h1>' +
                ' <p id="driver">Driver</p>' +
                ' <p class="details">' + onOffData.first_name + " " + onOffData.last_name + '</p>' +
                '<p class="details">' + onOffData.country_code + onOffData.phone + '</p>' +
                ' <p class="details">Vehicle' + ' #' + onOffData.current_car_details + '</p>' +
                ' <p class="details">Unique Number' + " " + "#" + onOffData.unique_car_id + '</p>' +
                ' <p class="details">On Duty Date' + " " + data.since_date + '</p>' +
                '</div>' +
                '<div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 paddingOnDuty">Off Duty: ' + data.difference + 'min</div>' +
                '<div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 paddingOnDuty">Since: ' + data.since + '</div>' +
                '</div>' +
                '</div>' +
                '</div>';

            if ((data.is_available == 1 && data.status == 0) || (data.status == 1 && data.job_status == null)) {
                return divOnDutyFree;
            } else if (data.is_available == 1 && data.status == 1) {
                return divWithService;
            } else {
                return divOffDuty;
            }
        };

        function showInfoWindowWithDetails(marker, infoWindow, data) {
            var dataToSend = {
                fleet_id: marker.id,
                is_available: marker.status,
                access_token: $cookies.get('obj')
            };
            //vm.loading = true;
            var promise = mapDashboard.getOnOffData(dataToSend);
            promise.then(
                function (payload) {
                    vm.onOffData = payload.title.data.res;
                    vm.loading = false;
                    data.eta = Math.floor(payload.title.data.time / 60);
                    data.distance = (payload.title.data.distance / 1000).toFixed(2);
                    data.since_date = moment(payload.title.data.since).format('DD/MM/YY');
                    if (vm.onOffData)
                        data.job_pickup_datetime_filter = $filter('date')(vm.onOffData.job_time_utc, "hh:mm a");
                    if (payload.title.data.difference == 0) {
                        data.difference = 0;
                    } else {
                        data.difference = Math.floor(payload.title.data.difference / 60);
                    }
                    if (payload.title.data.since == "0000-00-00 00:00:00") {
                        data.since = '0';
                    } else {
                        data.since = $filter('date')(payload.title.data.since, "hh:mm a");
                    }

                    if (vm.onOffData.job_status == 1) {
                        vm.onOffData.job_status_string = 'Started';
                        vm.onOffData.text = 'End Trip';
                    } else if (vm.onOffData.job_status == 7) {
                        vm.onOffData.job_status_string = 'Accepted';
                        vm.onOffData.text = 'On Road';
                    } else if (vm.onOffData.job_status == 4) {
                        vm.onOffData.job_status_string = 'Arrived';
                        vm.onOffData.text = 'Trip Started';
                    } else if (vm.onOffData.job_status == 15) {
                        vm.onOffData.job_status_string = 'On Road';
                        vm.onOffData.text = 'Vehicle Arrived';
                    }


                    if (data.is_available == 1 && data.status == 1) {
                        marker.content = infoWindows(data, vm.onOffData);
                    } else if (data.is_available == 1 && data.status == 0) {
                        marker.content = infoWindows(data, vm.onOffData);
                    } else {
                        marker.content = infoWindows(data, vm.onOffData);
                    }
                    setTimeout(function () {
                        infoWindow.setContent(marker.content);
                        // infoWindow.close();
                        // infoWindow = new google.maps.InfoWindow({
                        //     content: marker.content
                        // });
                        infoWindow.open(map, marker);
                        setTimeout(function () {
                            setDomReady();
                        });
                    }, 100);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };


        function setDomReady() {
            console.log(" i m in dom ");
            var iwOuter = $('.gm-style-iw');
            var iwBackground = iwOuter.prev();
            iwOuter.css({
                top: '36px',
                left: '20px'
            });
            iwOuter.children().children(':nth-child(1)').css({
                'overflow': 'hidden',
                // padding: '18px'
            });

            // Remove the background shadow DIV
            iwBackground.children(':nth-child(2)').css({
                'display': 'none'
            });
            // Remove the white background DIV
            iwBackground.children(':nth-child(4)').css({
                'display': 'none'
            });
            //iwOuter.parent().parent().css({ left: '115px' });
            //// Moves the shadow of the arrow 76px to the left margin
            //iwBackground.children(':nth-child(1)').attr('style', function (i, s) { return s + 'left: 76px !important;' });
            //// Moves the arrow 76px to the left margin
            //iwBackground.children(':nth-child(3)').attr('style', function (i, s) { return s + 'left: 76px !important;' });
            iwBackground.children(':nth-child(3)').find('div').children().css({
                'background-color': 'cornsilk',
                'box-shadow': 'none'
            });
            var iwCloseBtn = iwOuter.next();
            // Apply the desired effect to the close button
            iwCloseBtn.css({
                right: '52px',
                top: '62px', // button repositioning
                backgound: 'none'
            });
            // The API automatically applies 0.7 opacity to the button after the mouseout event.
            // This function reverses this event to the desired value.
            iwCloseBtn.mouseout(function () {
                $(this).css({
                    opacity: '1'
                });
            });
            $('#googleMapsDetailsWithCar').parent().addClass('col-lg-12 col-md-12 col-sm-12');
            // iwOuter.parent().addClass('custom-iw');
            if (vm.jobStatusOfMarker == 1) {
                $('.pickUpStatus').removeClass('onRoadAcceptedColor');
                $('.pickUpStatus').removeClass('inPositionColor');
                $('.pickUpStatus').addClass('startedColor');

                $('.statusChangeD').removeClass('inPositionColorB');
                $('.statusChangeD').addClass('completedColorB');
                $('.statusChangeD').removeClass('startedColorB');
                $('.statusChangeD').removeClass('onRoadAcceptedColorB');
            } else if (vm.jobStatusOfMarker == 7) {
                $('.pickUpStatus').removeClass('startedColor');
                $('.pickUpStatus').removeClass('inPositionColor');
                $('.pickUpStatus').addClass('onRoadAcceptedColor');

                $('.statusChangeD').removeClass('inPositionColorB');
                $('.statusChangeD').removeClass('completedColorB');
                $('.statusChangeD').removeClass('startedColorB');
                $('.statusChangeD').addClass('onRoadAcceptedColorB');
            } else if (vm.jobStatusOfMarker == 4) {
                $('.pickUpStatus').removeClass('startedColor');
                $('.pickUpStatus').removeClass('onRoadAcceptedColor');
                $('.pickUpStatus').addClass('inPositionColor');

                $('.statusChangeD').removeClass('inPositionColorB');
                $('.statusChangeD').removeClass('completedColorB');
                $('.statusChangeD').addClass('startedColorB');
                $('.statusChangeD').removeClass('onRoadAcceptedColorB');
            } else if (vm.jobStatusOfMarker == 15) {
                $('.pickUpStatus').removeClass('startedColor');
                $('.pickUpStatus').removeClass('inPositionColor');
                $('.pickUpStatus').addClass('onRoadAcceptedColor');

                $('.statusChangeD').addClass('inPositionColorB');
                $('.statusChangeD').removeClass('completedColorB');
                $('.statusChangeD').removeClass('startedColorB');
                $('.statusChangeD').removeClass('onRoadAcceptedColorB');
            }
            $('#offDutyMake').on('click', function (event) {
                markDriverOffDuty(vm.idOfMarker, vm.statusOfMarker);
            });
            $('#makebookingStatusChange').on('click', function (event) {
                makeTheStatusChangeOfBooking(vm.jobStatusOfMarker, vm.jobIdOfMarker, event);
            });
        }

        function markDriverOffDuty(id, status) {
            var dataToSend = {
                fleet_id: id,
                is_available: status == 1 ? 0 : 1,
                access_token: $cookies.get('obj')
            };
            vm.loading = true;
            var promise = mapDashboard.markDriverOffDuty(dataToSend);
            promise.then(
                function (payload) {
                    vm.loading = false;
                    // showDriversWithFilterSocket(vm.dataToFill);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function makeIconUI(data) {
            // console.log(data,"createmarker");

            // if (data.is_available == 0 && data.status == 0) {
            //     var iconS = {
            //         //url: 'assets/images/off_duty.png',
            //         url: data.vehicle_img_offline?data.vehicle_img_offline:'assets/images/off_duty.png',
            //         size: new google.maps.Size(70, 70),
            //         scaledSize: new google.maps.Size(50, 50), // scaled size
            //         origin: new google.maps.Point(0, 0), // origin
            //         labelOrigin: new google.maps.Point(25, 15),
            //         anchor: new google.maps.Point(17, 34) // anchor
            //     };
            // }
            console.log(data.status);

            console.log(data.job_status);

            console.log(data.status == 1 && !data.job_status, 'sdhsjdsjhdsjhd');

            if ((data.is_available == 1 && data.status == 0) || (data.status == 1 && data.job_status == null)) {
                var iconS = {
                    //url: 'assets/images/on_duty.png',
                    url: data.vehicle_img_online ? data.vehicle_img_online : 'assets/images/on_duty.png',
                    size: new google.maps.Size(70, 70),
                    scaledSize: new google.maps.Size(50, 50), // scaled size
                    origin: new google.maps.Point(0, 0), // origin
                    labelOrigin: new google.maps.Point(25, 15),
                    anchor: new google.maps.Point(17, 34) // anchor
                };
            } else if (data.is_available == 1 && data.status == 1 && data.job_status == 15) {
                var iconS = {
                    //url: 'assets/images/in_road.png',
                    url: data.vehicle_img_road ? data.vehicle_img_road : 'assets/images/in_road.png',
                    size: new google.maps.Size(70, 70),
                    scaledSize: new google.maps.Size(50, 50), // scaled size
                    origin: new google.maps.Point(0, 0), // origin
                    labelOrigin: new google.maps.Point(25, 15),
                    anchor: new google.maps.Point(17, 34) // anchor
                };
            } else if (data.is_available == 1 && data.status == 1 && data.job_status == 7) {
                var iconS = {
                    //url: 'assets/images/in_road.png',
                    url: data.vehicle_img_accepted ? data.vehicle_img_accepted : 'assets/images/in_road.png',
                    size: new google.maps.Size(70, 70),
                    scaledSize: new google.maps.Size(50, 50), // scaled size
                    origin: new google.maps.Point(0, 0), // origin
                    labelOrigin: new google.maps.Point(25, 15),
                    anchor: new google.maps.Point(17, 34) // anchor
                };
            } else if (data.is_available == 1 && data.status == 1 && data.job_status == 4) {
                var iconS = {
                    //url: 'assets/images/at_position.png',
                    url: data.vehicle_img_position ? data.vehicle_img_position : 'assets/images/at_position.png',
                    size: new google.maps.Size(70, 70),
                    scaledSize: new google.maps.Size(50, 50), // scaled size
                    origin: new google.maps.Point(0, 0), // origin
                    labelOrigin: new google.maps.Point(25, 15),
                    anchor: new google.maps.Point(17, 34) // anchor
                };
            } else if (data.is_available == 1 && data.status == 1 && data.job_status == 1) {
                var iconS = {
                    //url: 'assets/images/service_started.png',
                    url: data.vehicle_img_busy ? data.vehicle_img_busy : 'assets/images/service_started.png',
                    size: new google.maps.Size(70, 70),
                    scaledSize: new google.maps.Size(50, 50), // scaled size
                    origin: new google.maps.Point(0, 0), // origin
                    labelOrigin: new google.maps.Point(25, 15),
                    anchor: new google.maps.Point(17, 34) // anchor
                };
            }

            return iconS;
        }

        function createMarker(latlng, data, textCar, type) {
            //info[i].first_name + ' ' + info[i].last_name,
            //    info[i].email,
            //    info[i].current_car_details,
            //    info[i].is_available,
            //    info[i].status,
            //    info[i].job_status,
            //    info[i].job_pickup_address,
            //    info[i].job_address,
            //    info[i].number_of_passangers,
            //    info[i].job_id,
            //    info[i].unique_car_id



            var label = {
                text: (data.unique_car_id ? data.unique_car_id.toString() : '0')+(data.tipo_contrato && data.tipo_contrato == "Leasing"?"L":""),
                fontSize: '10px'
            };

            var marker = new google.maps.Marker({
                position: latlng,
                map: map,
                icon: makeIconUI(data),
                label: label,
                id: data.fleet_id,
                jobId: data.job_id,
                status: data.is_available,
                jobStatus: data.job_status,
                driverStatus: data.status,
                zIndex: Math.round(latlng.lat() * -100000) << 5
            });
            //if(vm.dataToFill.branch != 'all' || vm.dataToFill.vehicle != 'all' || vm.dataToFill.service != 'all' || vm.dataToFill.agreement != 'all' || vm.dataToFill.truck != '' || vm.dataToFill.bases != '' || vm.dataToFill.filterDataDrivers != 0){
            if (vm.dataToFill.filterDataDrivers != 0) {
                // bounds.extend(latlng);
                // map.fitBounds(bounds);
            } else if (textCar && textCar == 'searchCar') {
                // bounds.extend(latlng);
                // map.fitBounds(bounds);
                map.setZoom(15)
                map.setCenter(latlng)
            }

            if (!data.current_car_details) {
                data.current_car_details = 0;
            }
            if (!data.distance) {
                data.distance = 0;
            }
            if (!data.difference) {
                data.difference = 0;
            }
            if (!data.since) {
                data.since = 0;
            }
            if (!data.fleet_image) {
                data.fleet_image = 'assets/images/noImage.jpeg';
            }
            if (!data.text)
                data.text = '--';


            google.maps.event.addListener(marker, 'click', function (event) {
                vm.idOfMarker = marker.id;
                vm.statusOfMarker = marker.status;
                vm.jobStatusOfMarker = marker.jobStatus;
                vm.jobIdOfMarker = marker.jobId;
                for (var i = 0; i < vm.collectedData.length; i++) {
                    if (vm.collectedData[i].fleet_id == marker.id)
                        vm.collectedData[i].popInfoOpen = true;
                    else vm.collectedData[i].popInfoOpen = false;
                }
                showInfoWindowWithDetails(marker, infowindow, data);
                //if (data.current_car_details && data.job_pickup_address) {
                //    marker.content = infoWindows(data);
                //}
                //else if (data.current_car_details && !data.job_pickup_address) {
                //    marker.content = infoWindows(data);
                //}
                //else {
                //    marker.content = infoWindows(data);
                //}
                //infowindow.setContent(marker.content);
                //infowindow.open(map, marker);
            });
            markers.push(marker); //push local var marker into global array
            // openPreviousinfoWindowOpen(markers, data);
        };

        function openPreviousinfoWindowOpen(markers, data) {

            for (var i = 0; i < markers.length; i++) {
                for (var j = 0; j < vm.collectedData.length; j++) {
                    if (markers[i].id == vm.collectedData[j].fleet_id) {
                        if (vm.collectedData[j].popInfoOpen) {
                            //infowindow.open(map, markers[i]);
                            google.maps.event.trigger(markers[i], 'click');
                            //showInfoWindowWithDetails(markers[i],infowindow,data);
                            return;
                        }
                    }
                }
            }
        }

        function restorePreviousData() {
            for (var i = 0; i < vm.collectedData.length; i++) {
                vm.collectedData[i].popInfoOpen = false;
            }
        }

        //=======================create search location marker============================
        function createMarkerForSearchAddress(latlng) {
            var marker_1 = new google.maps.Marker({
                position: latlng,
                map: map,
                id: 'searchedMarker'
            });
            map.setCenter(latlng);
            map.setZoom(18);
            //bounds = new google.maps.LatLngBounds();
            //bounds.extend(latlng);
            //map.fitBounds(bounds);
            markers.push(marker_1);
        }

        //=============================mark no show============================
        function makeTheStatusChangeOfBooking(js, ji, $event) {
            var msg = '';
            var jobStatus = '';
            if (js == 7) {
                //msg = 'Do you want to mark this booking as on road ?';
                msg = languageBasedErrorFactory.getProperErrorMessage('onRoadMessage', 0, '3');
                jobStatus = 15;
            } else if (js == 15) {
                //msg = 'Do you want to mark this booking as arrived ?';
                msg = languageBasedErrorFactory.getProperErrorMessage('arrivedMessage', 0, '3');
                jobStatus = 4;
            } else if (js == 4) {
                //msg = 'Do you want to mark this booking as trip started ?';
                msg = languageBasedErrorFactory.getProperErrorMessage('tripStartedMessage', 0, '3');
                jobStatus = 1;
            } else if (js == 1) {
                //msg = 'Do you want to mark this booking as completed ?';
                msg = languageBasedErrorFactory.getProperErrorMessage('completedMessage', 0, '3');
                jobStatus = 2;
            }
            var confirm = $mdDialog.confirm()
                .title(msg)
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok('Confirm')
                .cancel('Close');

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.job_id = ji;
                dataSend.job_status = jobStatus;
                vm.loading = true;
                var promise = getBookings.changeJobStatus(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        languageBasedErrorFactory.getProperErrorMessage('noShowSucc', 0, 0);

                        //errorMessageFactory.showErrorMessage('Job status changed successfully.',0);
                        // showDriversWithFilterSocket(vm.dataToFill);
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        };

        //==========================get search for unique number key's====================='
        function getEnteriesForUniqueNumber(data) {
            if (data.length) {
                for (var i = 0; i < data.length; i++) {
                    if (data[i].unique_car_id) {
                        vm.uniqueCarsArray.push(data[i])
                    }
                }
            } else {
                vm.uniqueCarsArray = [];
            }
        };


        // function onSelectingUnique(data) {
        //     if (markers.length) {
        //         setMapOnAll(null);
        //         mc.clearMarkers();
        //     }
        //     createMarker(new google.maps.LatLng(data.latitude, data.longitude), data, 'searchCar');
        // }

        //==================show drivers in map=======================
        function showDrivers(fleet_status) {
            // vm.dataToFill.total_no_of_drivers_available = 0;
            // // vm.dataToFill.total_no_of_off_duty_drivers = 0;
            // vm.dataToFill.total_no_of_drivers_on_duty = 0;
            // vm.dataToFill.total_no_of_started_drivers = 0;
            // vm.dataToFill.total_no_of_at_position_drivers = 0;
            // vm.dataToFill.total_no_of_busy_drivers = 0;

            var dataSend = {};
            dataSend.fleet_status = fleet_status;
            dataSend.access_token = $cookies.get('obj');
            vm.loading = true;
            var promise = mapDashboard.map(dataSend);
            promise.then(
                function (payload) {
                    if (payload.title.status == 200) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        vm.total_no_of_drivers = 0;
                        vm.collectedData = payload.title.data;
                        // getFilterDataFromBackend();
                        vm.agreement = [];
                        vm.branchList = [];
                        vm.vehicle = [];
                        vm.service = [];
                        getEnteriesForUniqueNumber(payload.title.data);
                        if (payload.title.data && payload.title.data.length) {
                            vm.collectedData = payload.title.data;
                            getCountOfDashboardFleets(vm.collectedData);

                            // for (var i = 0; i < payload.title.data.length; i++) {
                            //     vm.collectedData[i].popInfoOpen = false;
                            //     vm.dataToFill.total_no_of_drivers_available = vm.dataToFill.total_no_of_drivers_available + 1;
                            //     if (payload.title.data[i].is_available == 0 && payload.title.data[i].status == 0) {
                            //         vm.dataToFill.total_no_of_off_duty_drivers = vm.dataToFill.total_no_of_off_duty_drivers + 1;
                            //     }
                            //     if (payload.title.data[i].is_available == 1 && payload.title.data[i].status == 0) {
                            //         vm.dataToFill.total_no_of_drivers_on_duty = vm.dataToFill.total_no_of_drivers_on_duty + 1;
                            //     }
                            //     if (payload.title.data[i].is_available == 1 && payload.title.data[i].status == 1 && (payload.title.data[i].job_status == 15 || payload.title.data[i].job_status == 7)) {
                            //         vm.dataToFill.total_no_of_started_drivers = vm.dataToFill.total_no_of_started_drivers + 1;
                            //     }
                            //     if (payload.title.data[i].is_available == 1 && payload.title.data[i].status == 1 && payload.title.data[i].job_status == 4) {
                            //         vm.dataToFill.total_no_of_at_position_drivers = vm.dataToFill.total_no_of_at_position_drivers + 1;
                            //     }
                            //     if (payload.title.data[i].is_available == 1 && payload.title.data[i].status == 1 && payload.title.data[i].job_status == 1) {
                            //         vm.dataToFill.total_no_of_busy_drivers = vm.dataToFill.total_no_of_busy_drivers + 1;
                            //     }
                            // }
                            initialize(vm.collectedData);
                        } else {
                            vm.collectedData = [];
                            vm.dataToFill.total_no_of_drivers_available = 0;
                            vm.dataToFill.total_no_of_off_duty_drivers = 0;
                            vm.dataToFill.total_no_of_drivers_on_duty = 0;
                            vm.dataToFill.total_no_of_started_drivers = 0;
                            vm.dataToFill.total_no_of_at_position_drivers = 0;
                            vm.dataToFill.total_no_of_busy_drivers = 0;
                            initialize(vm.collectedData);
                        }
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        // showDrivers(0);

        function showFleetsWithFilter(data) {
            vm.socketFlag = false;
            vm.dataToFill.filterDataDrivers = data;
            if (data == 0) {
                vm.offDuty_1 = false;
                vm.onDuty_1 = false;
                vm.started_1 = false;
                vm.inPosition_1 = false;
                vm.busy_1 = false;
                vm.socketFlag = true;
                vm.all_1 = true;
            } else if (data == 1) {
                vm.offDuty_1 = false;
                vm.onDuty_1 = true;
                vm.started_1 = false;
                vm.inPosition_1 = false;
                vm.busy_1 = false;
                vm.all_1 = false;
            }
            // else if(data == 2){
            //     vm.offDuty_1 = true;
            //     vm.onDuty_1 = false;
            //     vm.started_1 = false;
            //     vm.inPosition_1 = false;
            //     vm.busy_1 = false;
            //     vm.all_1 = false;
            // }
            else if (data == 3) {
                vm.offDuty_1 = false;
                vm.onDuty_1 = false;
                vm.started_1 = true;
                vm.inPosition_1 = false;
                vm.busy_1 = false;
                vm.all_1 = false;
            } else if (data == 4) {
                vm.offDuty_1 = false;
                vm.onDuty_1 = false;
                vm.started_1 = false;
                vm.inPosition_1 = false;
                vm.busy_1 = true;
                vm.all_1 = false;
            } else if (data == 5) {
                vm.offDuty_1 = false;
                vm.onDuty_1 = false;
                vm.started_1 = false;
                vm.inPosition_1 = true;
                vm.busy_1 = false;
                vm.all_1 = false;
            }

            vm.showDriversWithFilter(vm.dataToFill, vm.dataToFill.filterDataDrivers);
        };
        //======================get all branches==============
        // function getAllBranches() {
        //     vm.loading = true;
        //     var promise = getGeofence.getAllBranchList(2);
        //     promise.then(
        //         function (payload) {
        //             $log.log('sxdsads', payload);
        //             //vm.loading = false;
        //             vm.branch = [];
        //             vm.dataToFill.totalBranchList = payload.title.data;
        //             angular.forEach(payload.title.data, function (column) {
        //                 if (column.is_active == 1 && column.parent_id == 0)
        //                     vm.branch.push({
        //                         id: column.region_id,
        //                         name: column.region_name
        //                     });
        //             });
        //             vm.branch.push({
        //                 id: 'all',
        //                 name: 'All'
        //             })
        //         },
        //         function (errorPayload) {
        //             $log.log(errorPayload);
        //             //vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // };
        // getAllBranches();
        //======================get all vehicles==============
        // function getAllVehicles(skip, limt, filter) {
        // vm.vehicle = [];
        // angular.forEach(getFilters.vehiclesFiltersData.data, function (column) {
        //     vm.vehicle.push({
        //         id: column.id,
        //         name: column.name
        //     })
        // });
        // vm.vehicle.push({
        //     id: 'all',
        //     name: 'All'
        // });
        // vm.loading = true;
        // var promise = getVehicles.allVehicles(skip, limt, filter);
        // promise.then(
        //     function (payload) {
        //         $log.log('sxdsads', payload);
        //         //vm.loading = false;
        //         if (payload.title.status == 400) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //         } else if (payload.title.status == 401) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //         } else if (payload.title.status == 201 || payload.title.status == 200) {
        //             vm.vehicle = [];
        //             angular.forEach(payload.title.data.result, function (column) {
        //                 if (column.status == 1)
        //                     vm.vehicle.push({
        //                         id: column.id,
        //                         name: column.name
        //                     })
        //             });
        //             vm.vehicle.push({
        //                 id: 'all',
        //                 name: 'All'
        //             });
        //         }
        //     },
        //     function (errorPayload) {
        //         $log.log(errorPayload);
        //         //vm.loading = false;
        //         if (errorPayload.data.status == 401) {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //         } else {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //         }
        //     }
        // );
        // };
        // setTimeout(function () {
        // getAllVehicles(0, 0, 2);
        // }, 1000);    
        //======================get all services==============
        // function getAllServices(skip, limit) {
        //     vm.service = [];
        //     angular.forEach(getFilters.servicesFiltersData.data, function (column) {
        //         vm.service.push({
        //             id: column.id,
        //             name: column.service_name
        //         });
        //     });
        //     vm.service.push({
        //         id: 'all',
        //         name: 'All'
        //     })
        // vm.loading = true;
        // var promise = getServices.allServices(skip, limit, 2);
        // promise.then(
        //     function (payload) {
        //         $log.log('sxdsads', payload);
        //         //vm.loading = false;
        //         if (payload.title.status == 400) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //         } else if (payload.title.status == 401) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //         } else if (payload.title.status == 201 || payload.title.status == 200) {
        //             vm.service = [];
        //             angular.forEach(payload.title.data.result, function (column) {
        //                 if (column.status == 1)
        //                     vm.service.push({
        //                         id: column.id,
        //                         name: column.service_name
        //                     });
        //             });
        //             vm.service.push({
        //                 id: 'all',
        //                 name: 'All'
        //             })
        //         }
        //     },
        //     function (errorPayload) {
        //         $log.log(errorPayload);
        //         //vm.loading = false;
        //         if (errorPayload.data.status == 401) {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //         } else {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //         }
        //     }
        // );
        // };
        // setTimeout(function () {
        //     // getAllServices(0, 0);
        // }, 1000);

        //======================get all services==============
        // function getAllAgreement(skip, limt) {
        //     vm.getVehicleDataFromAggrements = getFilters.aggrementsFiltersData;
        //     vm.agreement = [];
        //     angular.forEach(vm.getVehicleDataFromAggrements.data, function (column) {
        //         vm.agreement.push({
        //             id: column.id,
        //             name: column.name
        //         });
        //     });
        //     vm.agreement.push({
        //         id: 'all',
        //         name: 'All'
        //     });
        // var dataSend = {};
        // dataSend.access_token = $cookies.get('obj');
        // dataSend.offset = skip;
        // dataSend.limit = limt;
        // // dataSend.key = 3;
        // vm.loading = true;

        // var promise = getAgreement.getAgreementListLessData(dataSend);
        // promise.then(
        //     function (payload) {
        //         if (payload.title.status == 400) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //         } else if (payload.title.status == 401) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //         } else if (payload.title.status == 201 || payload.title.status == 200) {
        //             vm.agreement = [];
        //             angular.forEach(payload.title.data, function (column) {
        //                 if (column.status == 1) {
        //                     vm.agreement.push({
        //                         id: column.id,
        //                         name: column.name
        //                     });
        //                 }
        //             });
        //             vm.agreement.push({
        //                 id: 'all',
        //                 name: 'All'
        //             });
        //         }
        //     },
        //     function (errorPayload) {
        //         $log.log(errorPayload);
        //         //vm.loading = false;
        //         if (errorPayload.data.status == 401) {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //         } else {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //         }
        //     }
        // );
        // };
        // getAllAgreement(0, 0);

        //============push notification======================
        function pushNotificationPop($event) {
            // $log.log(data);
            vm.items = {};
            // vm.items = data;
            // vm.items.car_type = vm.items.car_type.toString();
            // vm.items.modelity = vm.items.modelity.toString();
            // vm.items.working_status = vm.items.working_status.toString();
            // vm.items.car_image_upload = '';
            // vm.items.registration_image_upload = '';
            // vm.items.travel_card_key_upload = '';
            // vm.items.passenger_insurance_key_upload = '';
            // vm.items.permission_of_circulation_upload = '';
            // vm.items.ErrMsg = '';

            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/pushNotification.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });

            function DialogController($scope, $mdDialog, items, getDrivers, mapDashboard, getCars) {
                $scope.items = items;
                $scope.drivers = true;
                $scope.virtualDrivers = false;
                $scope.carNumber = false;
                $scope.message = false;
                $scope.fleet = false;
                $scope.dataToFill = {
                    notificationFleet: [],
                    adminMessage: '',
                    notificationCar: [],
                    notify: '',
                }
                //=================get all drivers======================
                $scope.getAllDrivers = function () {
                    $scope.loading = true;
                    var promise = getDrivers.allDriversWithoutLimit();
                    promise.then(
                        function (payload) {
                            $log.log(payload);
                            $scope.loading = false;
                            $scope.allDrivers = [];
                            $scope.dataToFill.notificationFleet = [];
                            $scope.dataToFill.notificationCar = [];
                            $scope.example14settings = {
                                scrollableHeight: '200px',
                                scrollable: true,
                                enableSearch: true
                            };
                            angular.forEach(payload.title.data.driver_data, function (column) {
                                $scope.allDrivers.push({
                                    'label': column.first_name + " " + column.last_name,
                                    'id': column.fleet_id
                                });
                            });

                            // vm.allDrivers = payload.title.data.driver_data;
                        },
                        function (errorPayload) {
                            $log.log(errorPayload, 'error');
                            $scope.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message);
                            }
                        }
                    );
                }
                $scope.getAllDrivers();
                $scope.getOnlineCars = function () {
                    $scope.loading = true;
                    var promise = getCars.onlineCars();
                    promise.then(
                        function (payload) {
                            if (payload.title.status == 200) {
                                $log.log(payload);
                                //$scope.loading = false;
                                $scope.onlineCar = [];
                                angular.forEach(payload.title.data, function (column) {
                                    $scope.onlineCar.push({
                                        'label': column.unique_car_id,
                                        id: column.unique_car_id
                                    });
                                });
                            } else {
                                errorMessageFactory.showErrorMessage(payload.title.message);
                            }


                            // vm.allDrivers = payload.title.data.driver_data;
                        },
                        function (errorPayload) {
                            $log.log(errorPayload, 'error');
                            //$scope.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message);
                            }
                        }
                    );
                }
                $scope.getOnlineCars();
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };


                $scope.confirmUpload = function (dataSend) {
                    $scope.pushSelectedFleets = [];
                    for (var i = 0; i < $scope.dataToFill.notificationFleet.length; i++) {
                        $scope.pushSelectedFleets.push($scope.dataToFill.notificationFleet[i].id);
                    }
                    $scope.pushSelectedCars = [];
                    for (var i = 0; i < $scope.dataToFill.notificationCar.length; i++) {
                        $scope.pushSelectedCars.push($scope.dataToFill.notificationCar[i].id);
                    }
                    if ($scope.dataToFill.adminMessage == null || $scope.dataToFill.adminMessage == undefined || $scope.dataToFill.adminMessage == "") {
                        return false;
                    }
                    var dataSend = {};
                    dataSend.fleet_id = $scope.pushSelectedFleets;
                    dataSend.unique_car_id = $scope.pushSelectedCars;
                    dataSend.message = $scope.dataToFill.adminMessage;
                    if ($scope.dataToFill.notificationFleet == null || $scope.dataToFill.notificationFleet == undefined || $scope.dataToFill.notificationFleet == "") {
                        dataSend.notification_key = '0';
                    } else if ($scope.dataToFill.notificationCar == null || $scope.dataToFill.notificationCar == undefined || $scope.dataToFill.notificationCar == "") {
                        dataSend.notification_key = '1';
                    }
                    if (dataSend.notification_key = '0') {
                        var dataSend = {};
                        dataSend.notification_key = '0';
                        dataSend.unique_car_id = $scope.pushSelectedCars;
                        dataSend.message = $scope.dataToFill.adminMessage;
                    }
                    if (dataSend.notification_key = '1') {
                        var dataSend = {};
                        dataSend.notification_key = '1';
                        dataSend.fleet_id = $scope.pushSelectedFleets;
                        dataSend.message = $scope.dataToFill.adminMessage;
                    }

                    dataSend.access_token = $cookies.get('obj');
                    $scope.loading = true;
                    var promise = mapDashboard.notification(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            $scope.loading = false;
                            //errorMessageFactory.showErrorMessage('Message sent Successfully');
                            languageBasedErrorFactory.getProperErrorMessage('messageSentSuccess', 0, 0);
                            $timeout(function () {
                                $mdDialog.hide()
                                $state.go('layout.dashboardMain');
                            }, 5000)
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            $scope.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                    $log.log('confirmed');
                    $mdDialog.hide();
                };
                $scope.allFleet = function () {
                    $scope.drivers = true;
                    $scope.virtualDrivers = false;
                    $scope.carNumber = false;
                }
                $scope.virtualFleet = function () {
                    $scope.virtualDrivers = true;
                    $scope.drivers = false;
                    $scope.carNumber = false;
                }
                $scope.allCar = function () {
                    $scope.carNumber = true;
                    $scope.drivers = false;
                    $scope.virtualDrivers = false;
                }
            }
        };

        //==========================filter with socket============================
        // function showDriversWithFilterSocket(data, type) {
        //     vm.countToSocket += 1;

        //     var dataSend = {};
        //     if (data.branch != 'all') {
        //         dataSend.filter_branch = data.branch;
        //     }
        //     if (data.vehicle != 'all') {
        //         dataSend.filter_vehicle = data.vehicle;
        //     }
        //     if (data.service != 'all') {
        //         dataSend.filter_services = data.service;
        //     }
        //     if (data.agreement != 'all') {
        //         dataSend.filter_agreement = data.agreement;
        //     }
        //     if (type || type == 0) {
        //         dataSend.fleet_status = type;
        //     } else {
        //         dataSend.fleet_status = data.filterDataDrivers;
        //     }
        //     dataSend.access_token = $cookies.get('obj');
        //     //var dataSend = {};
        //     //dataSend.fleet_status = data;
        //     //dataSend.access_token = $cookies.get('obj');
        //     //vm.loading = true;
        //     var promise = mapDashboard.map(dataSend);
        //     promise.then(
        //         function (payload) {
        //             $log.log('sxdsads', payload);
        //             vm.countToSocket = 0;
        //             if (payload.title.data && payload.title.data.length) {
        //                 vm.total_no_of_drivers = 0;
        //                 getCountOfDashboardFleets(payload.title.data);
        //                 for (var i = 0; i < vm.collectedData.length; i++) {
        //                     if (vm.collectedData[i].popInfoOpen) {
        //                         var index = []
        //                         payload.title.data.map(function (obj, indexD) {
        //                             if (obj.fleet_id == vm.collectedData[i].fleet_id) {
        //                                 index.push(indexD);
        //                             }
        //                         });
        //                         var storeData = payload.title.data[index[0]];
        //                         payload.title.data.splice(index[0], 1);
        //                         payload.title.data[payload.title.data.length] = storeData;
        //                         break;
        //                     }
        //                 }
        //                 initialize(payload.title.data, 0);
        //             } else {
        //                 vm.dataToFill.total_no_of_drivers_available = 0;
        //                 vm.dataToFill.total_no_of_off_duty_drivers = 0;
        //                 vm.dataToFill.total_no_of_drivers_on_duty = 0;
        //                 vm.dataToFill.total_no_of_started_drivers = 0;
        //                 vm.dataToFill.total_no_of_at_position_drivers = 0;
        //                 vm.dataToFill.total_no_of_busy_drivers = 0;
        //                 initialize(payload.title.data, 0);
        //             }
        //         },
        //         function (errorPayload) {
        //             $log.log(errorPayload);
        //             //vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // };

        //==========================set boolean=======================
        function setBooleans(type) {
            switch (type) {
                case 'HELP_TRAFFIC':
                    if (vm.dataToFill.helpTraffic) {
                        vm.dataToFill.helpTraffic = false;
                        trafficLayer.setMap(null);
                    } else {
                        vm.dataToFill.helpTraffic = true;
                        trafficLayer.setMap(map);
                    }
                    break;
            }
        };
        //==============================remove filter=============================
        function removeFilter() {
            $state.reload('layout.dashboardMain.dashboard');
        };

        //=============================search box implementation========================
        function removeSearchIconFromMap() {
            for (var i = 0; i < markers.length; i++) {
                if (markers[i].id == 'searchedMarker')
                    markers[i].setMap(null);
            }
            //markers = [];
        }
        function removeDuplicateMarker(data) {
            for (var i = 0; i < markers.length; i++) {
                if (markers[i].id == data.fleet_id)
                markers[i].setVisible(false);
            }
            //markers = [];
        }
        function getSearchedAddress(data) {
            if (!data && (vm.dataToFill.branch != 'all' || vm.dataToFill.vehicle != 'all' || vm.dataToFill.agreement != 'all' || vm.dataToFill.service != 'all' || vm.dataToFill.truck != '' || vm.dataToFill.bases != '')) {
                removeSearchIconFromMap();
                // showDriversWithFilterSocket(vm.dataToFill);
            } else if (!data && (vm.dataToFill.branch == 'all' || vm.dataToFill.vehicle == 'all' || vm.dataToFill.agreement == 'all' || vm.dataToFill.service == 'all' || vm.dataToFill.truck == '' || vm.dataToFill.bases == '')) {
                removeSearchIconFromMap();
                initialize(vm.collectedData);
            }
        };

        function ctrlFn(data) {
            //map.setCenter(new google.maps.LatLng(data.geometry.location.lat(), data.geometry.location.lng()));
            //map.setZoom(12);
            removeSearchIconFromMap();
            createMarkerForSearchAddress(new google.maps.LatLng(data.geometry.location.lat(), data.geometry.location.lng()));
        };

        //==========================filter============================
        function showDriversWithFilter(data, type) {
            vm.uniqueCarNumberSearch = '';
            vm.searchedAddress = '';
            removeSearchIconFromMap();
            var dataSend = {};
            if (data.branch != 'all') {
                dataSend.filter_branch = data.branch;
            }
            if (data.vehicle.length > 0) {
                dataSend.filter_vehicle = data.vehicle;
            }
            if (data.service.length > 0) {
                dataSend.filter_services = data.service;    
            }
            if (data.agreement != 'all') {
                dataSend.filter_agreement = data.agreement;
            }
            if (data.tipo_contrato != 'all') {
                dataSend.tipo_contrato = data.tipo_contrato;
            }
            if (type || type == 0) {
                dataSend.fleet_status = type;
            } else {
                dataSend.fleet_status = data.filterDataDrivers;
            }
            dataSend.access_token = $cookies.get('obj');
            if(angular.isArray(vm.searchBrandsData)){
                dataSend.brands = [vm.searchBrandsData.map(function(obj) { return obj.id; }) ];
            }

            if (data.filterDataDrivers == 4) {
                vm.dataToFill.total_no_of_drivers_available = 0;
                vm.dataToFill.total_no_of_at_position_drivers = 0;
                vm.dataToFill.total_no_of_started_drivers = 0;
                vm.dataToFill.total_no_of_off_duty_drivers = 0;
                vm.dataToFill.total_no_of_drivers_on_duty = 0;
                //vm.dataToFill.total_no_of_busy_drivers = 0;
            } else if (data.filterDataDrivers == 5) {
                //vm.dataToFill.total_no_of_at_position_drivers = 0;
                vm.dataToFill.total_no_of_drivers_available = 0;
                vm.dataToFill.total_no_of_started_drivers = 0;
                vm.dataToFill.total_no_of_off_duty_drivers = 0;
                vm.dataToFill.total_no_of_drivers_on_duty = 0;
                vm.dataToFill.total_no_of_busy_drivers = 0;
            } else if (data.filterDataDrivers == 3) {
                //vm.dataToFill.total_no_of_started_drivers = 0;
                vm.dataToFill.total_no_of_drivers_available = 0;
                vm.dataToFill.total_no_of_at_position_drivers = 0;
                vm.dataToFill.total_no_of_off_duty_drivers = 0;
                vm.dataToFill.total_no_of_drivers_on_duty = 0;
                vm.dataToFill.total_no_of_busy_drivers = 0;
            } else if (data.filterDataDrivers == 2) {
                //vm.dataToFill.total_no_of_off_duty_drivers = 0;
                vm.dataToFill.total_no_of_drivers_available = 0;
                vm.dataToFill.total_no_of_at_position_drivers = 0;
                vm.dataToFill.total_no_of_started_drivers = 0;
                vm.dataToFill.total_no_of_drivers_on_duty = 0;
                vm.dataToFill.total_no_of_busy_drivers = 0;
            } else if (data.filterDataDrivers == 1) {
                //vm.dataToFill.total_no_of_drivers_on_duty = 0;
                vm.dataToFill.total_no_of_drivers_available = 0;
                vm.dataToFill.total_no_of_at_position_drivers = 0;
                vm.dataToFill.total_no_of_started_drivers = 0;
                vm.dataToFill.total_no_of_off_duty_drivers = 0;
                vm.dataToFill.total_no_of_busy_drivers = 0;
            }
            //vm.dataToFill.total_no_of_drivers_available = 0;
            //vm.dataToFill.total_no_of_off_duty_drivers = 0;
            //vm.dataToFill.total_no_of_drivers_on_duty = 0;
            //vm.dataToFill.total_no_of_started_drivers = 0;
            //vm.dataToFill.total_no_of_at_position_drivers = 0;
            //vm.dataToFill.total_no_of_busy_drivers = 0;
            vm.loading = true;
            var promise = mapDashboard.map(dataSend);
            promise.then(
                function (payload) {
                    $log.log('filter', payload);
                    vm.loading = false;
                    vm.collectedData = payload.title.data;
                    // vm.agreement = [];
                    // vm.branch = [];
                    // vm.vehicle = [];
                    // vm.service = [];
                    // // getFilterDataFromBackend();

                    if (payload.title.data && payload.title.data.length) {

                        if (data.filterDataDrivers == 4) {
                            vm.dataToFill.total_no_of_busy_drivers = payload.title.data.length;
                            vm.dataToFill.total_no_of_drivers_available = payload.title.data.length;
                        } else if (data.filterDataDrivers == 5) {
                            vm.dataToFill.total_no_of_at_position_drivers = payload.title.data.length;
                            vm.dataToFill.total_no_of_drivers_available = payload.title.data.length;
                        } else if (data.filterDataDrivers == 3) {
                            vm.dataToFill.total_no_of_started_drivers = payload.title.data.length;
                            vm.dataToFill.total_no_of_drivers_available = payload.title.data.length;
                        } else if (data.filterDataDrivers == 2) {
                            vm.dataToFill.total_no_of_off_duty_drivers = payload.title.data.length;
                            vm.dataToFill.total_no_of_drivers_available = payload.title.data.length;
                        } else if (data.filterDataDrivers == 1) {
                            vm.dataToFill.total_no_of_drivers_on_duty = payload.title.data.length;
                            vm.dataToFill.total_no_of_drivers_available = payload.title.data.length;
                        } else if (data.filterDataDrivers == 0) {
                            getCountOfDashboardFleets(vm.collectedData);

                            // vm.dataToFill.total_no_of_drivers_available = 0;
                            // vm.dataToFill.total_no_of_off_duty_drivers = 0;
                            // vm.dataToFill.total_no_of_drivers_on_duty = 0;
                            // vm.dataToFill.total_no_of_started_drivers = 0;
                            // vm.dataToFill.total_no_of_at_position_drivers = 0;
                            // vm.dataToFill.total_no_of_busy_drivers = 0;
                            //
                            // for (var i = 0; i < payload.title.data.length; i++) {
                            //     vm.collectedData[i].popInfoOpen = false;
                            //     vm.dataToFill.total_no_of_drivers_available = vm.dataToFill.total_no_of_drivers_available + 1;
                            //     if (payload.title.data[i].is_available == 0 && payload.title.data[i].status == 0) {
                            //         vm.dataToFill.total_no_of_off_duty_drivers = vm.dataToFill.total_no_of_off_duty_drivers + 1;
                            //     }
                            //     if (payload.title.data[i].is_available == 1 && payload.title.data[i].status == 0) {
                            //         vm.dataToFill.total_no_of_drivers_on_duty = vm.dataToFill.total_no_of_drivers_on_duty + 1;
                            //     }
                            //     if (payload.title.data[i].is_available == 1 && payload.title.data[i].status == 1 && (payload.title.data[i].job_status == 15 || payload.title.data[i].job_status == 7)) {
                            //         vm.dataToFill.total_no_of_started_drivers = vm.dataToFill.total_no_of_started_drivers + 1;
                            //     }
                            //     if (payload.title.data[i].is_available == 1 && payload.title.data[i].status == 1 && payload.title.data[i].job_status == 4) {
                            //         vm.dataToFill.total_no_of_at_position_drivers = vm.dataToFill.total_no_of_at_position_drivers + 1;
                            //     }
                            //     if (payload.title.data[i].is_available == 1 && payload.title.data[i].status == 1 && payload.title.data[i].job_status == 1) {
                            //         vm.dataToFill.total_no_of_busy_drivers = vm.dataToFill.total_no_of_busy_drivers + 1;
                            //     }
                            // }
                            //vm.dataToFill.total_no_of_drivers_available = payload.title.data.length;
                        }
                        initialize(payload.title.data, 0);
                    } else {
                        if (data.filterDataDrivers == 4) {
                            vm.dataToFill.total_no_of_busy_drivers = 0;
                            vm.dataToFill.total_no_of_drivers_available = 0;
                        } else if (data.filterDataDrivers == 5) {
                            vm.dataToFill.total_no_of_at_position_drivers = 0;
                            vm.dataToFill.total_no_of_drivers_available = 0;
                        } else if (data.filterDataDrivers == 3) {
                            vm.dataToFill.total_no_of_started_drivers = 0;
                            vm.dataToFill.total_no_of_drivers_available = 0;
                        } else if (data.filterDataDrivers == 2) {
                            vm.dataToFill.total_no_of_off_duty_drivers = 0;
                            vm.dataToFill.total_no_of_drivers_available = 0;
                        } else if (data.filterDataDrivers == 1) {
                            vm.dataToFill.total_no_of_drivers_on_duty = 0;
                            vm.dataToFill.total_no_of_drivers_available = 0;
                        } else if (data.filterDataDrivers == 0) {
                            vm.dataToFill.total_no_of_drivers_available = 0;
                            vm.dataToFill.total_no_of_drivers_on_duty = 0;
                            vm.dataToFill.total_no_of_off_duty_drivers = 0;
                            vm.dataToFill.total_no_of_started_drivers = 0;
                            vm.dataToFill.total_no_of_at_position_drivers = 0;
                            vm.dataToFill.total_no_of_busy_drivers = 0;
                        }
                        initialize(payload.title.data, 0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        //======================get center pf polygon=======================
        function polygonCenter(poly) {
            var lowx,
                highx,
                lowy,
                highy,
                center_x,
                center_y,
                lats = [],
                lngs = [],
                vertices = poly;

            for (var i = 0; i < vertices.length; i++) {
                lngs.push(Number(vertices[i].y));
                lats.push(Number(vertices[i].x));
            }

            lats.sort();
            lngs.sort();
            lowx = lats[0];
            highx = lats[vertices.length - 1];
            lowy = lngs[0];
            highy = lngs[vertices.length - 1];
            center_x = lowx + ((highx - lowx) / 2);
            center_y = lowy + ((highy - lowy) / 2);
            return (new google.maps.LatLng(center_x, center_y));
        }

        //=======================show polygon on map=========================
        function showPolygon(data) {
            var triangleCoords = [];
            for (var i = 0; i < data.length; i++) {
                triangleCoords.push({
                    lat: data[i].x,
                    lng: data[i].y
                })
            }
            if (bermudaTriangle) {
                bermudaTriangle.setMap(null);
            }
            // Construct the polygon.
            bermudaTriangle = new google.maps.Polygon({
                paths: triangleCoords,
                strokeColor: '#f18903',
                strokeOpacity: 1,
                strokeWeight: 2,
                fillColor: 'transparent',
                fillOpacity: 0.5
            });
            bermudaTriangle.setMap(map);
        }
        //=====================make the map center at branch============================
        function makeMapCenterAccToBranch(data) {
            if (data != 'all') {
                var where = _.where(vm.dataToFill.totalBranchList, {
                    region_id: data
                });
                var centerLatLng = polygonCenter(where[0].region_data[0]);
                showPolygon(where[0].region_data[0]);
                map.setCenter(centerLatLng);
                map.setZoom(10);
            } else {
                bermudaTriangle.setMap(null);
            }
        };
        //=======================change filter============================
        function changeFilter() {
            if (vm.dataToFill.branch == 'all' && vm.dataToFill.vehicle == 'all' && vm.dataToFill.service == 'all' && vm.dataToFill.agreement == 'all') {
                // vm.socketFlag = true;
                map.setCenter(myCenter);
                map.setZoom(3);
            }
        }

        //=======================search vehicle by unique car Id==============
        function getVehicleOnSearch(id) {
            var dataToSend = {
                search_id: id,
                access_token: $cookies.get('obj')
            };
            vm.loading = true;
            if (id) {
                var promise = mapDashboard.getVehicleOnSearch(dataToSend);
                promise.then(
                    function (payload) {
                        vm.loading = false;
                        if (payload.title.status == 200) {
                            if (payload.title.data.length) {
                                // restorePreviousData();
                                vm.collectedData.forEach(function (data) {
                                    data.popInfoOpen = false;
                                })
                                infowindow.close();
                                // createMarker(new google.maps.LatLng(payload.title.data[0].latitude, payload.title.data[0].longitude), payload.title.data[0]);
                                var latlng = new google.maps.LatLng(payload.title.data[0].latitude, payload.title.data[0].longitude);
                                bounds.extend(latlng);
                                map.fitBounds(bounds);
                                map.setZoom(20);
                                map.setCenter(latlng);

                            } else {
                                errorMessageFactory.showErrorMessage('El vehículo no está en servicio en este momento.', 0);
                            }
                        } else {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }

                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            } else {
                vm.loading = false;
            }
        }

        //==================for getting count of dashoard fleets================

        function getCountOfDashboardFleets(count, type) {
            vm.countOfDashboardFleets = count;
            vm.dataToFill.total_no_of_drivers_available = 0;
            vm.dataToFill.total_no_of_off_duty_drivers = 0;
            vm.dataToFill.total_no_of_drivers_on_duty = 0;
            vm.dataToFill.total_no_of_started_drivers = 0;
            vm.dataToFill.total_no_of_at_position_drivers = 0;
            vm.dataToFill.total_no_of_busy_drivers = 0;

            for (var i = 0; i < vm.countOfDashboardFleets.length; i++) {
                if (!type)
                    vm.collectedData[i].popInfoOpen = false;
                vm.dataToFill.total_no_of_drivers_available = vm.dataToFill.total_no_of_drivers_available + 1;
                if (vm.countOfDashboardFleets[i].is_available == 0 && vm.countOfDashboardFleets[i].status == 0) {
                    vm.dataToFill.total_no_of_off_duty_drivers = vm.dataToFill.total_no_of_off_duty_drivers + 1;
                }
                if (vm.countOfDashboardFleets[i].is_available == 1 && vm.countOfDashboardFleets[i].status == 0) {
                    vm.dataToFill.total_no_of_drivers_on_duty = vm.dataToFill.total_no_of_drivers_on_duty + 1;
                }
                if (vm.countOfDashboardFleets[i].is_available == 1 && vm.countOfDashboardFleets[i].status == 1 && (vm.countOfDashboardFleets[i].job_status == 15 || vm.countOfDashboardFleets[i].job_status == 7)) {
                    vm.dataToFill.total_no_of_started_drivers = vm.dataToFill.total_no_of_started_drivers + 1;
                }
                if (vm.countOfDashboardFleets[i].is_available == 1 && vm.countOfDashboardFleets[i].status == 1 && vm.countOfDashboardFleets[i].job_status == 4) {
                    vm.dataToFill.total_no_of_at_position_drivers = vm.dataToFill.total_no_of_at_position_drivers + 1;
                }
                if (vm.countOfDashboardFleets[i].is_available == 1 && vm.countOfDashboardFleets[i].status == 1 && vm.countOfDashboardFleets[i].job_status == 1) {
                    vm.dataToFill.total_no_of_busy_drivers = vm.dataToFill.total_no_of_busy_drivers + 1;
                }
            }
            $timeout(function () {
                $scope.$digest();
            }, 500);
        }



        //===================side bar filters=====================
        vm.showFilterArea = showFilterArea;
        vm.branchChangedFilter = branchChangedFilter;
        vm.vehicleChangedFilter = vehicleChangedFilter;
        vm.serviceChangedFilter = serviceChangedFilter;
        vm.agreementChangedFilter = agreementChangedFilter;
        vm.virtualFleetChangedFilter = virtualFleetChangedFilter;
        vm.operationChangedFilter = operationChangedFilter;
        vm.trafficChangedFilter = trafficChangedFilter;
        vm.showFilterFlag = false;

        vm.filterWhichToShow = {
            branchWithDashboard: true,
            service: true,
            vehicle: true,
            agreement: true,
            operation: true,
            helpTraffic: true,
            virtualFleet: true,
            approvalStage: false,
            vehicleAssigned: false,
            applicantType: false,
            tripType: false,
            modelity: false
        };


        function showFilterArea() {
            vm.showFilterFlag = !vm.showFilterFlag;
        }

        function branchChangedFilter(data) {
            // vm.showDriversWithFilter(data);
            vm.makeMapCenterAccToBranch(data.branch);
            vm.changeFilter();

        }

        function vehicleChangedFilter(data) {
            // vm.showDriversWithFilter(data);
            vm.changeFilter();
        }

        function serviceChangedFilter(data) {
            // vm.showDriversWithFilter(data);
            vm.changeFilter();
        }

        function agreementChangedFilter(data) {
            // vm.showDriversWithFilter(data);
            vm.changeFilter();
        }

        function virtualFleetChangedFilter(data) {
            // vm.showDriversWithFilter(data);
            vm.changeFilter();
        }

        function operationChangedFilter(data) {
            // vm.showDriversWithFilter(data);
            vm.changeFilter();
        }

        function trafficChangedFilter(data) {
            if (data.helpTraffic) {
                trafficLayer.setMap(map);
            } else {
                trafficLayer.setMap(null);
            }
        }

        function socketFuncation() {
            if (vm.dataToFill.branch == 'all' && vm.dataToFill.vehicle == 'all' && vm.dataToFill.service == 'all' && vm.dataToFill.agreement == 'all') {
                vm.socketFlag = true;
                map.setCenter(myCenter);
                map.setZoom(3);
            } else {
                vm.socketFlag = false;
            }

        }


        function resetFilter() {
            vm.dataToFill = {
                total_no_of_off_duty_drivers: 0,
                total_no_of_drivers_on_duty: 0,
                total_no_of_started_drivers: 0,
                total_no_of_at_position_drivers: 0,
                total_no_of_busy_drivers: 0,
                total_no_of_drivers_available: 0,
                branch: 'all',
                vehicle: [],
                helpTraffic: false,
                service: [],
                agreement: 'all',
                tipo_contrato: 'all',
                truck: '',
                bases: '',
                filterDataDrivers: 0,
                totalData: [],
                totalBranchList: []
            };
            vm.showDriversWithFilter(vm.dataToFill);
        }

        function applyFilter() {
            vm.showDriversWithFilter(vm.dataToFill);
        }

        function selectingBrand(data, evento){
            if(evento == 'select'){
                vm.searchBrandsData = data;
            } else {
                vm.searchBrandsData = data;
            }
        }

    }

})();

/**
 * Created by cl-macmini-51 on 6/10/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .controller('RegisterCustomerController', RegisterCustomerController);

    /** @ngInject */
    function RegisterCustomerController($cookies, $state, $log, $rootScope, $mdDialog, $timeout, $document, getCustomers, $scope, filterFilter, languageBasedErrorFactory,errorMessageFactory,checkDomain) {
        var vm = this;
        vm.loading = false;
        vm.passwordMatchFlag = false;
        vm.dataToFill = {
            first_name: '',
            last_name: '',
            password: '',
            confirmPassword: '',
            country_code: '+56',
            timeZone: new Date().getTimezoneOffset(),
            mobileNumber: '',
            email: '',
            profile_pic: '',
            referral_code: ''
        };

        vm.matchPassword = matchPassword;
        vm.clickTrigger = clickTrigger;
        vm.registerApi = registerApi;
        vm.goBack = goBack;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();


        //==================file upload function========================
        vm.uploadName = '';
        function clickTrigger($event, type, index) {
            $log.log('ddf');
            $event.stopPropagation();
            vm.uploadName = type;
            var element = document.getElementById('documentUpload');
            element.click();
        };
        //===============file for customer edit=============
        $scope.file_to_upload = function(File, type) {
            $log.log('type', type);
            var file = File[0];
            var transcript = File[0];
            var reader = new FileReader;
            reader.onload = function(e) {
                //    var img = new Image;
                //    img.onload = function () {
                document.getElementById('profilePic').setAttribute('src', e.target.result);
                vm.dataToFill.profile_pic = File[0];
                //};

                //    img.src = reader.result;
            };
            reader.readAsDataURL(transcript);
            $log.log(vm.dataToFill);
        };

        //=======================password match function====================
        function matchPassword(data) {
            if (data) {
                if (data != vm.dataToFill.password) {
                    vm.passwordMatchFlag = true;
                } else {
                    vm.passwordMatchFlag = false;
                }
            }
            else{
                vm.passwordMatchFlag = false;
            }
        };
        //====================register customer api=========================
        function registerApi(){
            $log.log(vm.dataToFill);
            var domain = checkDomain.getDomainName();
            var dataSend = new FormData();
            dataSend.append('access_token',$cookies.get('obj'));
            dataSend.append('first_name',vm.dataToFill.first_name);
            dataSend.append('last_name',vm.dataToFill.last_name);
            dataSend.append('email',vm.dataToFill.email);
            dataSend.append('country_code',vm.dataToFill.country_code);
            dataSend.append('phone_number',vm.dataToFill.mobileNumber);
            //dataSend.append('password',vm.dataToFill.password);
            dataSend.append('timezone',vm.dataToFill.timeZone);
            dataSend.append('domainUrl',domain);
            if(vm.dataToFill.profile_pic){
                dataSend.append('Profile_pic',vm.dataToFill.profile_pic);
            }
            if(vm.dataToFill.referral_code){
                dataSend.append('referral_code',vm.dataToFill.referral_code);
            }

            vm.loading = true;
            var promise = getCustomers.addCustomer(dataSend);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if(payload.title.status == 400){
                        errorMessageFactory.showErrorMessage(payload.title.message,0);
                    }
                    else if(payload.title.status == 401){
                        errorMessageFactory.showErrorMessage(payload.title.message,2,'home');
                    }
                    else if(payload.title.status == 201 || payload.title.status == 200){
                        languageBasedErrorFactory.getProperErrorMessage('customerRegisteredSucc',0,2,'layout.customersMain.customers');
                    }
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message);
                    }
                }
            );
        }
        //====================event for getting refreshed================
        $scope.$on('StateReload', function(evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.customersMain.customerRegister');
            }
        });
        //=================go back================
        function goBack() {
            $state.go('layout.customersMain.customers');
        };

    }
})();

/**
 * Created by cl-macmini-51 on 6/13/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('EditCustomerDetailsController', EditCustomerDetailsController);

    /** @ngInject */
    function EditCustomerDetailsController($cookies, $state, $log, $rootScope, $timeout, $stateParams, getCustomers, $mdDialog, $document,RutHelper,$scope,languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.dataToFill = {
            first_name: '',
            last_name: '',
            country_code: '+56',
            timeZone: new Date().getTimezoneOffset(),
            mobileNumber: '',
            email: '',
            profile_pic: '',
            profile_pic_upload: '',
            id: Number($stateParams.id)
        };

        vm.clickTrigger = clickTrigger;
        vm.editApi = editApi;
        vm.getCustomersHit = getCustomersHit;
        vm.goBack = goBack;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.customersMain.editCustomerDetails');
            }
        });
        //=================go back================
        function goBack() {
            $state.go('layout.customersMain.customers');
        };

        //=================get customer details================
        function getCustomersHit() {
            vm.loading = true;
            var dataSend =  {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = 0;
            dataSend.offset = 0;
            dataSend.search_filter = 0;
            dataSend.customer_id = $stateParams.id;
            var promise = getCustomers.allCustomers(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if(payload.title.status == 400){
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    else if(payload.title.status == 401){
                        errorMessageFactory.showErrorMessage(payload.title.message,2,'home');
                    }
                    else if(payload.title.status == 201 || payload.title.status == 200) {
                        vm.customerDetail = payload.title.data.result[0];
                        vm.dataToFill.first_name = vm.customerDetail.first_name;
                        vm.dataToFill.last_name = vm.customerDetail.last_name;
                        vm.dataToFill.country_code = vm.customerDetail.country_code;
                        vm.dataToFill.mobileNumber = vm.customerDetail.phone_number;
                        vm.dataToFill.email = vm.customerDetail.email;
                        vm.dataToFill.profile_pic = vm.customerDetail.profile_pic_thumb;
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        }
        getCustomersHit();
        //==================file upload function========================
        vm.uploadName = '';
        function clickTrigger($event, type, index) {
            $log.log('ddf');
            $event.stopPropagation();
            vm.uploadName = type;
            var element = document.getElementById('documentUpload');
            element.click();
        };
        //===============file for customer edit=============
        $scope.file_to_upload = function(File, type) {
            $log.log('type', type);
            var file = File[0];
            var transcript = File[0];
            var reader = new FileReader;
            reader.onload = function(e) {
                //    var img = new Image;
                //    img.onload = function () {
                document.getElementById('profilePic').setAttribute('src', e.target.result);
                vm.dataToFill.profile_pic_upload = File[0];
                //};

                //    img.src = reader.result;
            };
            reader.readAsDataURL(transcript);
            $log.log(vm.dataToFill);
        };

        //===================edit api=======================
        function editApi(){
            //errorMessageFactory.showErrorMessage('This functionality is pending.',0);

            var dataSend = new FormData();

            dataSend.append('access_token',$cookies.get('obj'));
            dataSend.append('first_name',vm.dataToFill.first_name);
            dataSend.append('last_name',vm.dataToFill.last_name);
            dataSend.append('customer_id',vm.dataToFill.id);
            dataSend.append('phone_number',vm.dataToFill.mobileNumber);
            if(vm.dataToFill.profile_pic_upload){
                dataSend.append('profile_pic',vm.dataToFill.profile_pic_upload);
            }
            vm.loading = true;
            var promise = getCustomers.editCustomerProfile(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false; 
                    if(payload.title.status == 200){
                        var dataForSysLogs = {
                            access_token: $cookies.get('obj'),
                            id: vm.dataToFill.id,
                            identity : 1,  // 0- driver, 1- customer , 2 -car
                            message : 'Customer details updated.'
                        };
                        $rootScope.systemLogsAdmin(dataForSysLogs);
                        //errorMessageFactory.showErrorMessage('Customer profile updated successfully.',2,'layout.customersMain.customers');
                        languageBasedErrorFactory.getProperErrorMessage('editCustomerSucc',0,2,'layout.customersMain.customers')
                    }else{
                        errorMessageFactory.showErrorMessage(payload.title.message,0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
    }
})();

/**
 * Created by cl-macmini-51 on 6/13/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('CustomerDetailsController', CustomerDetailsController);

    /** @ngInject */
    function CustomerDetailsController($cookies, $state, $log, $rootScope, $timeout, $stateParams, getCustomers, $mdDialog, $document,RutHelper, $scope, languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.getCustomersHit = getCustomersHit;
        vm.goBack = goBack;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        $log.log($stateParams);

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.customersMain.customerDetails');
            }
        });

        //=================go back================
        function goBack() {
            $state.go('layout.customersMain.customers');
        };

        //=================get customer details================
        function getCustomersHit() {
            vm.loading = true;
            var dataSend =  {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = 0;
            dataSend.offset = 0;
            dataSend.search_filter = 0;
            dataSend.customer_id = $stateParams.id;
            var promise = getCustomers.allCustomers(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if(payload.title.status == 400){
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    else if(payload.title.status == 401){
                        errorMessageFactory.showErrorMessage(payload.title.message,2,'home');
                    }
                    else if(payload.title.status == 201 || payload.title.status == 200) {
                        vm.customerDetail = payload.title.data.result[0];
                        for (var i = 0; i < vm.customerDetail.employee_details.length; i++) {
                            if (vm.customerDetail.employee_details[i].RUT) {
                                vm.customerDetail.employee_details[i].RUT = RutHelper.format(vm.customerDetail.employee_details[i].RUT);
                            }
                            if (vm.customerDetail.employee_details[i].auth_RUT) {
                                vm.customerDetail.employee_details[i].auth_RUT = RutHelper.format(vm.customerDetail.employee_details[i].auth_RUT);
                            }
                        }
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        }
        getCustomersHit();

    }
})();
/**
 * Created by cl-macmini-51 on 4/19/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('CustomerController', CustomerController);

    /** @ngInject */
    function CustomerController($cookies, $state, $log, $rootScope, $mdDialog, $timeout, $document, getCustomers, $scope, filterFilter, languageBasedErrorFactory, getDrivers, errorMessageFactory, pendingRequests, adminAccessService, checkDomain) {
        var vm = this;
        vm.getAllCustomers = getAllCustomers;
        vm.block_unblock = block_unblock;
        vm.resetPassword = resetPassword;
        vm.SendEmail = SendEmail;
        $log.log('driver');
        vm.loading = false;
        vm.currentPage = 0;
        vm.totalCustomers = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.filterTextTimeout = '';
        vm.getPagesCount = getPagesCount;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.init = init;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.deleteUser = deleteUser;
        vm.addCorporateProfile = addCorporateProfile;
        vm.refreshData = refreshData;
        vm.viewOTP = viewOTP;
        vm.paginationNew = paginationNew;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.predicate = 'index';
        vm.reverse = false;
        vm.filterData = {
            search_filter: 0,
            search_value: ''
        };
        //====================function for dropdown pages and page count===============
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];

        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllCustomers(0, vm.itemsPerPageGot, vm.filterData);
        };

        function paginationNew(page) {
            getAllCustomers((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData);
        }

        //==================refreshData=====================
        function refreshData() {
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllCustomers(vm.currentPage * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData);
        }


        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.customersMain.customers');
            }
        });

        //==================get all customers=======================
        function getAllCustomers(skip, limit, filter) {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit;
            dataSend.offset = skip;
            dataSend.search_filter = filter.search_filter;
            if (filter.search_filter == 1) {
                dataSend.search_value = filter.search_value;
            }
            var promise = getCustomers.allCustomers(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.totalCustomers = payload.title.data.totalCount;
                        vm.dataLength = payload.title.data.totalCount;

                        if (payload.title.data.totalCount == 0) {
                            vm.sp_pagination = false;
                            vm.tBodyFlag = false;
                            vm.tFootFlag = true;
                            vm.filterOn = true;
                            vm.skipValueFilter = 0;
                        } else {
                            vm.sp_pagination = true;
                            vm.tBodyFlag = true;
                            vm.tFootFlag = false;
                            vm.filterOn = false;
                            vm.skipValueFilter = 0;
                            var dataArray = [];
                            var customerList = payload.title.data.result;
                            customerList.forEach(function (column) {
                                var d = {};
                                d.name = column.first_name + " " + column.last_name;
                                d.email = column.email;
                                d.is_blocked = column.is_blocked;
                                d.customer_id = column.customer_id;
                                d.profile_pic_thumb = column.profile_pic_thumb;
                                d.corporate_account_id = column.corporate_account_id;
                                d.creation_datetime = column.creation_datetime;
                                d.is_corporate_profile = column.is_corporate_profile;
                                d.hasCorporateAccount = column.hasCorporateAccount;
                                d.employee_details = column.employee_details;
                                d.phoneNumber = column.phone_number;
                                d.country_code = column.country_code;
                                d.phone = column.phone_number ? column.country_code + " " + column.phone_number : column.phone;
                                dataArray.push(d);
                            });
                            vm.customerList = dataArray;

                            for (var i = 0; i < vm.customerList.length; i++) {
                                vm.customerList[i].index = (skip + i);
                            }
                            if (vm.dataLength <= vm.itemsPerPageGot) {
                                vm.sp_pagination = false;
                            } else {
                                vm.sp_pagination = true;
                                //vm.pageCount(payload.title.totalCount);
                            }
                            vm.skipValue = vm.customerList[0].index;
                            vm.limitValue = vm.customerList[vm.customerList.length - 1].index;
                            //
                            //$scope.$watch('vm.search', function(newVal, oldVal) {
                            //    vm.filtered = filterFilter(vm.customerList, newVal);
                            //    vm.totalItems = vm.filtered.length;
                            //    if (vm.filtered.length == 0) {
                            //        vm.watchPagination = false;
                            //    } else {
                            //        vm.watchPagination = true;
                            //    }
                            //    if (vm.filterOn == true) {
                            //        vm.skipValueFilter = vm.filtered.length;
                            //        vm.sp_pagination = false;
                            //    }
                            //}, true);

                            //range();
                        }
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //==================block_unblock function======================
        function block_unblock($event, id, value) {
            $log.log('block_unblock');
            var parentEl = angular.element($document.body);
            if (value == 0) {
                var msg = languageBasedErrorFactory.getProperErrorMessage('blockCustomerPop', 0, '3');
            } else if (value == 1) {
                var msg = languageBasedErrorFactory.getProperErrorMessage('unblockCustomerPop', 0, '3');
            }
            //==============dialog for confirm====================
            var confirm = $mdDialog.confirm()
                .title(msg)
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok('Confirm')
                .cancel('Close');

            $mdDialog.show(confirm).then(function () {
                vm.loading = true;
                var a = '';
                var msgSys = '';
                if (value == 0) {
                    a = 1;
                    msgSys = 'Customer blocked.';
                } else if (value == 1) {
                    a = 0;
                    msgSys = 'Customer unblocked.';
                }
                $log.log('blocked');
                var promise = getCustomers.block_unblock(id, a);
                promise.then(
                    function (payload) {
                        vm.loading = false;
                        if (payload.title.status == 400) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            $log.log('block_unblock', payload);
                            var dataForSysLogs = {
                                access_token: $cookies.get('obj'),
                                id: id,
                                identity: 1, // 0- driver, 1- customer , 2 -car
                                message: msgSys
                            };
                            $rootScope.systemLogsAdmin(dataForSysLogs);
                            $state.reload('layout.customersMain.customers');
                        }
                    },
                    function (errorPayload) {
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('unblock');
            });
        };

        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    } else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        vm.getAllCustomers((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        vm.currentPage++;
        //        vm.getAllCustomers((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    vm.getAllCustomers((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //};

        function init() {
            vm.getAllCustomers(0, vm.searchModel.limit, vm.filterData);
        };
        init();

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            //vm.filterOn = true;
            vm.currentPage = 0;
            vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
            vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
            pendingRequests.cancelAll();
            if (vm.search.length == 0) {
                vm.filterData.search_filter = 0;
                vm.filterData.search_value = '';
                vm.getAllCustomers(0, vm.searchModel.limit, vm.filterData);
                //vm.filterOn = false;
                //vm.watchPagination = true;
                //vm.sp_pagination = true;

            } else {
                vm.filterData.search_filter = 1;
                vm.filterData.search_value = vm.search;
                //if (vm.filterTextTimeout) $timeout.cancel(vm.filterTextTimeout);
                //vm.filterTextTimeout = $timeout(function(){
                vm.getAllCustomers(0, vm.searchModel.limit, vm.filterData);
                //},500);
            }
        };
        //=====================to delete driver====================
        function deleteUser(data, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('deleteCustomerPop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.customer_id = data.customer_id;
                //errorMessageFactory.showErrorMessage('Functionality is pending',0);
                vm.loading = true;
                var promise = getCustomers.deleteCustomerProfile(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        if (payload.title.status == 200) {
                            var dataForSysLogs = {
                                access_token: $cookies.get('obj'),
                                id: data.customer_id,
                                identity: 1, // 0- driver, 1- customer , 2 -car
                                message: 'Customer deleted.'
                            };
                            $rootScope.systemLogsAdmin(dataForSysLogs);
                            languageBasedErrorFactory.getProperErrorMessage('deleteCustomerSucc', 0, 1, 'layout.customersMain.customers');
                        } else {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                        //errorMessageFactory.showErrorMessage('Customer deleted successfully.',1);
                        //$state.reload();
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        };

        //===========================add corporate profile==========================
        function addCorporateProfileHit(data) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.uniquecode = data.uniqueCode;
            dataSend.customer_id = data.customer_id;
            vm.loading = true;
            var promise = getCustomers.addCustomerCorporateProfile(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        var dataForSysLogs = {
                            access_token: $cookies.get('obj'),
                            id: data.customer_id,
                            identity: 1, // 0- driver, 1- customer , 2 -car
                            message: 'Customer corporate profile added.'
                        };
                        $rootScope.systemLogsAdmin(dataForSysLogs);
                        languageBasedErrorFactory.getProperErrorMessage('coprorateProfileSucc', 0, 1, 'layout.customersMain.customers');
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        function addCorporateProfile(data, $event) {
            vm.items = data;
            vm.items.uniqueCode = '';
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/addCorporateProfile.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });

            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    $log.log(vm.items);
                    $mdDialog.hide();
                    addCorporateProfileHit($scope.items);
                };
            }
        }

        //======================view last generated otp====================
        function viewOTP(data, $event) {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.phone_number = data.phoneNumber;
            dataSend.country_code = data.country_code;
            var promise = getDrivers.viewOTP(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    var dataForSysLogs = {
                        access_token: $cookies.get('obj'),
                        id: data.customer_id,
                        identity: 1, // 0- driver, 1- customer , 2 -car
                        message: 'OTP Viewed'
                    };
                    $rootScope.systemLogsAdmin(dataForSysLogs);
                    viewOTPPop(payload.title.data, $event);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function viewOTPPop(data, $event) {
            vm.items = {
                otp: data
            };

            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/lastGeneratedOTP.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: LastOTPViewController
            });

            function LastOTPViewController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
            }
        }
        // =================== FUNCATION FOR RESET CUSTOMER PASSWORD BY ADMIN =================//
        function resetPassword(data, $event) {
            vm.loading = true;
            var promise = adminAccessService.checkStateValid('Cambiar Contraseña Cuenta Usuario Cliente'); //$stateParams.id
            return promise.then(
                function (payload) {
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (!payload.title.data.granted) {
                            errorMessageFactory.showErrorMessage('No está autorizado para usar esta opción', 0);
                            //errorMessageFactory.showErrorMessage('Option not available because you not have the right',0);
                            return false;
                        } else {
                            vm.loading = false;
                            // blockDriverPopUp($event, id, value);
                            OpenPopForResetPassword(data, $event)
                            return true;
                        }
                    }
                },
                function (errorPayload) {
                    console.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function OpenPopForResetPassword(data, $event) {
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/resetPasswordOfCustomer.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: ResetPasswordDialogController
            });

            function ResetPasswordDialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    if ($scope.items.passwordMatchFlag) {
                        return;
                    }
                    vm.loading = true;
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.customer_id = data.customer_id;
                    dataSend.password = $scope.items.password;
                    var promise = getDrivers.resetPasswordToCustomer(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            vm.loading = false;
                            $mdDialog.hide();
                            if (payload && payload.title.status == 400) {
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            } else {
                                errorMessageFactory.showErrorMessage('Contraseña restablecida correctamente', 0);
                            }
                        },
                        function (errorPayload) {
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        });
                };
                //=======================password match function====================
                $scope.matchConfirmPassword = function (data) {
                    if (data) {
                        if (data != $scope.items.password) {
                            $scope.items.passwordMatchFlag = true;
                        } else {
                            $scope.items.passwordMatchFlag = false;
                        }
                    } else {
                        $scope.items.passwordMatchFlag = false;
                    }
                };
                $scope.matchPassword = function (data) {
                    if (data && $scope.items.confirmPassword) {
                        if (data != $scope.items.confirmPassword) {
                            $scope.items.passwordMatchFlag = true;
                        } else {
                            $scope.items.passwordMatchFlag = false;
                        }
                    }
                };
            }
        }
        // =================== FUNCATION FOR RESET CUSTOMER PASSWORD BY ADMIN =================//


        // =================== FUNCATION FOR SEND NEWPASSWORD EMAIl =================//
        function SendEmail(data, $event) {
            vm.loading = true;
            var promise = adminAccessService.checkStateValid('Cambiar Contraseña Cuenta Usuario Cliente'); //$stateParams.id
            return promise.then(
                function (payload) {
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (!payload.title.data.granted) {
                            errorMessageFactory.showErrorMessage('No está autorizado para usar esta opción', 0);
                            //errorMessageFactory.showErrorMessage('Option not available because you not have the right',0);
                            return false;
                        } else {
                            vm.loading = false;
                            // blockDriverPopUp($event, id, value);
                            OpenPopForResetPasswordMail(data, $event)
                            return true;
                        }
                    }
                },
                function (errorPayload) {
                    console.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function OpenPopForResetPasswordMail(data, $event) {
            var parentEl = angular.element($document.body);
            var domain = checkDomain.getDomainName();
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/resetPasswordOfCustomerMail.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: SendResetPasswordMailDialogController
            });

            function SendResetPasswordMailDialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    vm.loading = true;
                    var dataSend = {};
                    dataSend.domainUrl = domain;
                    dataSend.login_id = data.email;
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.isAdmin = 1;
                    var promise = getDrivers.sendEmailToCustomerResetPassword(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            vm.loading = false;
                            $mdDialog.hide();
                            if (payload && payload.title.status == 400) {
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            } else {
                                errorMessageFactory.showErrorMessage('Correo enviado', 0);
                            }
                        },
                        function (errorPayload) {
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        });
                };
            }
        }
        // =================== FUNCATION FOR SEND NEWPASSWORD EMAIl =================//
    }

})();
/**
 * Created by cl-macmini-51 on 5/20/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('CreateBookingControllerHereMaps', CreateBookingControllerHereMaps);

    /** @ngInject */
    function CreateBookingControllerHereMaps($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document, moment, getCustomers, $scope, getBookingsHereMaps,
        RutHelper, errorMessageFactory, languageBasedErrorFactory, adminAccessService, hidePublicPlaces, pendingRequests, getCorporate, getAgreement, checkDomain, tmhDynamicLocale, quickSaleService, getFilters, Initializer, calenderTranslate, sharedRouteAssignmentHereMaps) {
        var vm = this;
        tmhDynamicLocale.set('en');
        vm.crossFlag = false;
        // GET USER TYPE FROM COOKIES
        vm.userType = $cookies.get('adminType') || 0;
        vm.modifyFalgNew = false;
        vm.discard_booking_flag = 0;
        vm.fillInAddressD = fillInAddressD;
        vm.fillInAddress = fillInAddress;
        vm.getFixedRoutesForPersonalFlag = false;
        vm.selectFavAddressNewPop = selectFavAddressNewPop;
        vm.pickUpaddressBlack = pickUpaddressBlack;
        vm.dropOfdAddressBlack = dropOfdAddressBlack;
        vm.ErrorFlagForNewApi = false;
        vm.flagForMarkFavAddress = false;
        vm.dateOptions = {};
        vm.CreateBookingNew = CreateBookingNew;
        vm.pickUpAddressBlank = pickUpAddressBlank;
        vm.dropOffAddressBlank = dropOffAddressBlank;
        vm.flagForPanel = true;
        vm.toAirportFlag = true;
        vm.fromAirportFlag = false;
        vm.ptopAirportFlag = false;
        vm.checkBoxCheck = false;
        vm.forTabsView = forTabsView;
        // vm.dropTimeChangedForRType = dropTimeChangedForRType;
        vm.disabledPaymentMethod = false;
        vm.couponFlag = false;
        vm.roundTripTImeLess = false;
        vm.dropaddressChange = false;
        vm.grantedCheckbox = false;
        vm.viaControlledFLag = false;
        vm.pickaddressChange = false;
        vm.checkBoxValue = checkBoxValue;
        vm.funcationif = funcationif;
        vm.flagForEditBooking = false;
        vm.disableAgreementService = false;
        vm.disabledNumberOfpassengerByCount = false;
        vm.isEmpDataChange = false; // TV-2378



        var zoomLevel = 12;
        vm.flightFLag = true;
        vm.getInfoFlag = false;
        vm.pickupFromToTimeChanged = pickupFromToTimeChanged;
        vm.returnDateChange = returnDateChange;
        vm.tillDateChange = tillDateChange;
        vm.disabledRoundTrip = false;
        vm.modifyBooking = false;
        vm.posBookingFlag = false;
        vm.scheduleFlag = false;
        ////////////////////////// CHECK STATUS FOR BWR BOOKING TICKET N0 2605 /////////////////////////
        vm.CheckBookingStatus = CheckBookingStatus;
        var all_overlays = [];
        vm.modifyFalg = false;
        vm.flagHelp = false;
        vm.flagForAirline = false;
        vm.math = window.Math;
        vm.personalFlag = false;
        vm.flagForFlightNumber = false;
        vm.flagForFlightDate = false;
        vm.flagForFlightType = false;
        vm.PickUpAddressLength = PickUpAddressLength;
        vm.DropUpAddressLength = DropUpAddressLength;
        vm.MarkfavouriteAddressPickUp = MarkfavouriteAddressPickUp;
        vm.MarkfavouriteAddressDrop = MarkfavouriteAddressDrop;
        // VARIABLES AND FUNCTIONS FOR MODIFY SPECIAL FARE - TV-1703
        vm.showEstimatePriceInHtml = showEstimatePriceInHtml;
        vm.showEstimatePriceForRoundTripInHtml = showEstimatePriceForRoundTripInHtml;
        vm.showEstimatePriceForFixedPriceInHtml = showEstimatePriceForFixedPriceInHtml;
        vm.clickFunction = clickFunction;
        vm.finalAdjustedPriceFromAdmin = 0;

        vm.viaControlled1 = 0;
        var coordinates_array = [];
        var markers = [];
        vm.hstep = 1;
        vm.mstep = 15;
        vm.ismeridian1 = false;
        var mapProp = {};
        vm.type_of_trip1;
        vm.type_of_trip;
        vm.viaControlledFLag;
        vm.viaControlledFLag1;
        vm.viaControlled2 = 0;
        var drawingManager = '';
        var mc = null;
        vm.return_flag;
        var map = null;
        // vm.corporate = corporate;
        vm.corporateOffset = 0;
        vm.agreementOffset = 0;
        vm.globalLimit = 50;
        vm.globalOffset = vm.globalLimit;
        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'vehicle', 'service', 'agreement', 'corporatesList', 'operation_point'];
        vm.corporatesList = [];
        vm.corporatesList.push({
            company_name: 'Todos',
            id: 'all'
        });

        vm.agreement = [];
        vm.agreement.push({
            name: 'Todos',
            id: 'all'
        });

        vm.isActivePick = false; // FOR PICK  UP FAVROITE ADDRESSS 
        vm.isActiveDrop = false; // FOR DROP FAVROITE ADDRESSS
        // ********** INSERT INTO ARRAY AT PARTICULAR POSITION **********
        Array.prototype.insert = function (index, item) {
            this.splice(index, 0, item);
        };

        // =================== FILTER OBJECT ===================
        vm.filterObject = {
            access_token: $cookies.get('obj'),
            branch_filter: 0,
            vehicle_filter: 0,
            service_filter: 0,
            agreement_filter: 1,
            corporate_filter: 1,
            service_category: 0,
            corporate_status: 2,
            agreement_status: 1,
            vehicle__status: 0,
            operation_point_filter: 0,
            branch_limit: 0,
            branch_offset: 0,
            agreement_limit: vm.globalLimit,
            agreement_offset: vm.agreementOffset,
            corporate_limit: vm.globalLimit,
            corporate_offset: vm.corporateOffset,
            branch_search_filter: 0,
            vehicle_search_filter: 0,
            service_search_filter: 0,
            agreement_search_filter: 0,
            corporate_search_filter: 0,
            operation_point_search_filter: 0
        }
        var icon = {};
        var bounds;
        var geocoder;
        var location = "";
        var currentId = 0;
        var laArray = [];
        var poly = '';
        vm.selectDay = selectDay;
        var uniqueId = function () {
            return ++currentId;
        };
        var infowindow;
        var directionsService;
        var directionsDisplay;
        var restriccion_flota;
        var sucursal_id;
        var cupos_fecha_global;
        vm.dateOptions = {};
        var myCenter;
        var ciclosFuncion = 0;
        var ciclosFuncionRt = 0;
        var calculaterouteEjecutado = 0; //si se ejecuta un llamado a servicio, para evitar que se ejecute 2 veces:2822
        // Service To Get Map Instance
        Initializer.mapsInitialized
            .then(function () {
                console.log('>>>> GOOGLE INIT', google);
                if (google) {
                    myCenter = new google.maps.LatLng(-33.447487, -70.673676);
                    bounds = new google.maps.LatLngBounds();
                    geocoder = new google.maps.Geocoder();
                    infowindow = new google.maps.InfoWindow({
                        size: new google.maps.Size(150, 50)
                    });
                    // directionsService = new google.maps.DirectionsService;
                    directionsDisplay = new google.maps.DirectionsRenderer;
                    google.maps.event.addListener(infowindow, 'domready', function () {
                        var iwOuter = $('.gm-style-iw');
                        var iwBackground = iwOuter.prev();
                        iwOuter.css({
                            top: '36px',
                            left: '20px'
                        });
                        iwOuter.children().children(':nth-child(1)').css({
                            'overflow': 'hidden',
                            padding: '18px'
                        });
                        // Remove the background shadow DIV
                        iwBackground.children(':nth-child(2)').css({
                            'display': 'none'
                        });
                        // Remove the white background DIV
                        iwBackground.children(':nth-child(4)').css({
                            'display': 'none'
                        });
                        iwBackground.children(':nth-child(3)').find('div').children().css({
                            'background-color': 'cornsilk',
                            'box-shadow': 'none'
                        });
                        var iwCloseBtn = iwOuter.next();
                        // Apply the desired effect to the close button
                        iwCloseBtn.css({
                            right: '52px',
                            top: '62px', // button repositioning
                            backgound: 'none'
                        });
                        // The API automatically applies 0.7 opacity to the button after the mouseout event.
                        // This function reverses this event to the desired value.
                        iwCloseBtn.mouseout(function () {
                            $(this).css({
                                opacity: '1'
                            });
                        });
                        $('#confirmDriver').off('click').on('click', function (event) {
                            vm.dataToFill.nearDriver = vm.markerFleetID;
                            infowindow.close();
                        });
                        $('#cancelDriver').off('click').on('click', function (event) {
                            vm.dataToFill.nearDriver = '';
                            infowindow.close();
                        });

                    });

                } else {
                    alert(languageBasedErrorFactory.getProperErrorMessage('onRoadMessage', 0, '3'));
                }

            });
        vm.returnDateOptions = {};

        vm.dateOption = {};
        vm.datePicker_1 = {
            scheduledDate: false,
            returnDate: false
        };
        vm.datePicker_2 = {
            tillDate: false
        };
        // vm.corporate = corporate;
        vm.corporateOffset = 0;
        vm.agreementOffset = 0;
        vm.globalLimit = 50;
        vm.globalOffset = vm.globalLimit;
        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'vehicle', 'service', 'agreement', 'corporatesList', 'operation_point'];
        vm.corporatesList = [];
        vm.corporatesList.push({
            company_name: 'Todos',
            id: 'all'
        });

        vm.agreement = [];
        vm.agreement.push({
            name: 'Todos',
            id: 'all'
        });


        // =================== FILTER OBJECT ===================
        vm.filterObject = {
            access_token: $cookies.get('obj'),
            branch_filter: 0,
            vehicle_filter: 0,
            service_filter: 0,
            agreement_filter: 1,
            corporate_filter: 1,
            service_category: 0,
            corporate_status: 2,
            agreement_status: 1,
            vehicle__status: 0,
            operation_point_filter: 0,
            branch_limit: 0,
            branch_offset: 0,
            agreement_limit: vm.globalLimit,
            agreement_offset: vm.agreementOffset,
            corporate_limit: vm.globalLimit,
            corporate_offset: vm.corporateOffset,
            branch_search_filter: 0,
            vehicle_search_filter: 0,
            service_search_filter: 0,
            agreement_search_filter: 0,
            corporate_search_filter: 0,
            operation_point_search_filter: 0
        }
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.tformat = vm.formats[0];
        vm.altInputFormats = ['M!/d!/yyyy'];
        vm.altInputFormat = ['M!/d!/yyyy'];
        vm.loading = false;
        vm.Flag;
        vm.createBookingApi = createBookingApi;
        vm.createBookingByPass = createBookingByPass;
        vm.onSelectingCustomer = onSelectingCustomer;
        vm.onSelectingPerson = onSelectingPerson;
        vm.bookingFor = bookingFor;
        vm.mapInitialize = mapInitialize;
        vm.showGoogleMap = false;
        vm.addressChange = false;
        vm.placeMarker = placeMarker;
        vm.numberOfPassenger = numberOfPassenger;
        vm.bookingType = bookingType;
        vm.datePickerE_New = datePickerE_New;
        vm.datePickerE_2 = datePickerE_2;
        vm.scheduleTimeChanged = scheduleTimeChanged;
        vm.retunrTimeChanged = retunrTimeChanged;
        vm.tillTimes = tillTimes;
        vm.setBooleans = setBooleans;
        vm.datePickerE_1 = datePickerE_1;
        vm.profileChanges = profileChanges;
        vm.agreementTypeChanged = agreementTypeChanged;
        vm.serviceTypeChanged = serviceTypeChanged;
        vm.matchPassword = matchPassword;
        vm.matchPasswordAgain = matchPasswordAgain;
        vm.addNewCustomer = addNewCustomer;
        vm.addNewPerson = addNewPerson;
        vm.pickFavAddress = pickFavAddress;
        vm.dropFavAddress = dropFavAddress;
        vm.rutChange = rutChange;
        vm.getPreviousAddressHit = getPreviousAddressHit;
        vm.selectPreviousAddress = selectPreviousAddress;
        vm.scheduleDateChanged = scheduleDateChanged;
        vm.removeSelectedDriver = removeSelectedDriver;
        vm.passengerRutChange = passengerRutChange;
        vm.applicantRutChange = applicantRutChange;
        vm.searchCustomer = searchCustomer;
        vm.searchPerson = searchPerson;
        vm.selectingItemOfCharges = selectingItemOfCharges;
        vm.addEndowment = addEndowment;
        vm.applyCoupon = applyCoupon;
        vm.dropDateChanged = dropDateChanged;
        vm.dropDateReturnChanged = dropDateReturnChanged;
        vm.dropTimeChanged = dropTimeChanged;
        vm.dropTimeReturnChanged = dropTimeReturnChanged;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.passwordMatchFlag = false;
        vm.newCustomerFlag = false;
        vm.makePhoneEditAble = true;
        vm.days = false;
        vm.favAddFlag = false;
        vm.favAddFlagI = {
            'width': '100%'
        };
        vm.crossButton = {
            'left': '529px'
        }
        vm.favAddFlagB = {
            'width': '0%'
        };
        //vm.customerProfileOption = [];
        vm.bookingTypeOptions = [];
        vm.previousAddressList = [];
        vm.nearByDriver = [];
        vm.disableSubmitButton = false;
        vm.fullCuota = false;
        vm.dataToFill = {
            first_name: '',
            last_name: '',
            password: '',
            confirmPassword: '',
            country_code: '+56',
            ReturnEstimatedDistance: 0,
            etaScheduleValueReturn: 0,
            timeZone: new Date().getTimezoneOffset(),
            customerMobile: '',
            customerMobileG: '',
            customerEmail: '',
            customerId: '',
            previousCustomerId: '',
            customerProfile: '1',
            passengerCount: '',
            bookingFor: 0,
            allowBookingWithoutRequest: 0,
            personName: '',
            personEmail: '',
            personMobile: '',
            otherBooking: false,
            carType: '',
            reference_point: '',
            pickUpAddress: '',
            dropOffAddress: '',
            pickUpLat: '',
            pickUpLng: '',
            dropOffLat: '',
            dropOffLng: '',
            numberOfPassengerError: false,
            numberOfPassengerCount: 0,
            bookingType: '',
            scheduledBooking: '',
            currentBooking: '',
            reaccurringBooking: false,
            roundTrip: false,
            scheduledDate: new Date(),
            scheduledTime: new Date(),
            dropDate: new Date(),
            dropDateReturn: new Date(),
            dropTimeReturn: new Date(),
            dropDateOfRType: new Date(),
            dropTimeOfRtype: new Date(),
            dropTime: new Date(),
            tillDate: '',
            tillTime: new Date(),
            contractIdSelected: '',
            serviceTypeSelected: '',
            corporate_account_id: '',
            route_id: '',
            route_type: '',
            type_of_agreement: '',
            is_wait_time_included: false,
            favPickLocId: '',
            favDropLocId: '',
            returnDate: new Date(),
            returnTime: new Date(),
            itemOfChargeList: [],
            itemOfChargeSelected: [],
            authRequired: '',
            authRUT: '',
            rutFlag: false,
            auther_id: '',
            employeeId: '',
            customerContarctId: '',
            contractList: [],
            contractListShowing: [],
            is_item_of_charges: 0,
            item_of_charges: [],
            bookingId: $stateParams.id,
            previousPickFlag: false,
            previousDropFlag: false,
            nearDriver: '',
            payment_method: '',
            passengerRutCheck: 0,
            applicantRutCheck: 0,
            costCenterCheck: 0,
            costSubCenterCheck: 0,
            RolCheck: 0,
            graphCheck: 0,
            workOrderCheck: 0,
            pepCheck: 0,
            purposeOfTripCheck: 0,
            noOfVoucherCheck: 0,
            nominaCheck: 0,
            solictudCheck: 0,
            passengerRut: '',
            applicantRut: '',
            costCenter: '',
            costSubCenter: '',
            Rol: '',
            graph: '',
            workOrder: '',
            pep: '',
            purposeOfTrip: '',
            noOfVoucher: '',
            nomina: '',
            solictud: '',
            passengerRUTError: false,
            applicantRUTError: false,
            observations: '',
            etaSchedule: '',
            estimatedDistance: '',
            estimatedFare: '',
            estimatedFareRoute: '',
            estimatedFareVariable: '',
            minimumFare: 0,
            airportCheck: '',
            discounts: [],
            couponValidation: false,
            roundTripDiscount: 0,
            webDiscount: 0,
            couponApplied: false,
            couponCode: '',
            paymentMethodList: [],
            selectedServiceDetails: '',
            viaControlled: 0,
            viaControlledReal: 0,
            viaControlledApply: false,
            controlledWayCheck: 0,
            controllerWayTarifa: 0,
            etaScheduleValue: 0,
            is_vip: '',
            is_POS_booking: 0,
            payment_status: 0,
            created_by_admin: 0,
            time_trip_shared_service: 0
        };
        vm.pickAddressFlag = false;
        vm.dropAddressFlag = false;
        vm.dataToFill.Return_policy = {
            first_name: '',
            last_name: '',
            password: '',
            confirmPassword: '',
            country_code: '+56',
            timeZone: new Date().getTimezoneOffset(),
            customerMobile: '',
            customerMobileG: '',
            customerEmail: '',
            customerId: '',
            previousCustomerId: '',
            customerProfile: '0',
            passengerCount: '',
            bookingFor: 0,
            personName: '',
            personEmail: '',
            personMobile: '',
            otherBooking: false,
            carType: '',
            reference_point: '',
            pickUpAddress: '',
            dropOffAddress: '',
            pickUpLat: '',
            pickUpLng: '',
            dropOffLat: '',
            dropOffLng: '',
            numberOfPassengerError: false,
            numberOfPassengerCount: 0,
            bookingType: '',
            scheduledBooking: '',
            currentBooking: '',
            reaccurringBooking: false,
            roundTrip: false,
            scheduledDate: new Date(),
            scheduledTime: new Date(),
            dropDate: new Date(),
            dropTime: new Date(),
            tillDate: '',
            tillTime: new Date(),
            contractIdSelected: '',
            serviceTypeSelected: '',
            corporate_account_id: '',
            route_id: '',
            route_type: '',
            type_of_agreement: '',
            is_wait_time_included: false,
            favPickLocId: '',
            favDropLocId: '',
            returnDate: new Date(),
            returnTime: new Date(),
            itemOfChargeList: [],
            itemOfChargeSelected: [],
            authRequired: '',
            authRUT: '',
            rutFlag: false,
            auther_id: '',
            employeeId: '',
            customerContarctId: '',
            contractList: [],
            contractListShowing: [],
            is_item_of_charges: 0,
            item_of_charges: [],
            bookingId: $stateParams.id,
            previousPickFlag: false,
            previousDropFlag: false,
            nearDriver: '',
            payment_method: '',
            passengerRutCheck: 0,
            applicantRutCheck: 0,
            costCenterCheck: 0,
            costSubCenterCheck: 0,
            RolCheck: 0,
            graphCheck: 0,
            workOrderCheck: 0,
            pepCheck: 0,
            purposeOfTripCheck: 0,
            noOfVoucherCheck: 0,
            nominaCheck: 0,
            solictudCheck: 0,
            passengerRut: '',
            applicantRut: '',
            costCenter: '',
            costSubCenter: '',
            Rol: '',
            graph: '',
            workOrder: '',
            pep: '',
            purposeOfTrip: '',
            noOfVoucher: '',
            nomina: '',
            solictud: '',
            passengerRUTError: false,
            applicantRUTError: false,
            observations: '',
            etaSchedule: '',
            estimatedDistance: '',
            estimatedFare: '',
            estimatedFareRoute: '',
            estimatedFareVariable: '',
            minimumFare: 0,
            airportCheck: '',
            discounts: [],
            couponValidation: false,
            roundTripDiscount: 0,
            webDiscount: 0,
            couponApplied: false,
            couponCode: '',
            paymentMethodList: [],
            selectedServiceDetails: '',
            viaControlled: 0,
            viaControlledReal: 0,
            viaControlledApply: false,
            controlledWayCheck: 0,
            etaScheduleValue: 0,
            is_vip: '',
            is_POS_booking: 0,
            payment_status: 0,
            created_by_admin: 0,
            time_trip_shared_service: 0
        }
        vm.filterData = {
            filter_pickup_from_date_value: new Date(),
            filter_pickup_from_time_value: new Date,
        }
        vm.changeFlightType = flightTypeChange;
        vm.changeVip = changeVip;
        var d = new Date();
        d.getHours;
        d.getMinutes;
        vm.minValue = d;
        vm.newPersonFlag = false;
        vm.is_vip = false;
        vm.accessVerifyToggle = accessVerifyToggle;
        // vm.minValue = new Date();
        vm.bookingForOptions = [{
                name: 'Para mi',
                value: 0
            },
            {
                name: 'Para alguien más',
                value: 1
            }
        ];

        if (!$stateParams.id) {
            vm.dataToFill.scheduledTime.setMinutes(vm.dataToFill.scheduledTime.getMinutes() + 35);
            vm.dataToFill.dropTime.setMinutes(vm.dataToFill.dropTime.getMinutes() + 35);
            vm.dataToFill.dropTimeOfRtype.setMinutes(vm.dataToFill.dropTimeOfRtype.getMinutes() + 35);
        }

        vm.hstep = 1;
        vm.mstep = 15;
        vm.ismeridian = false;
        // document.getElementById("googleMap").style.height = window.innerHeight - 200 + 'px';

        vm.hsteps = 1;
        vm.msteps = 15;
        vm.ismeridians = false;
        vm.disabledSubmitButton = true;
        if (!$stateParams.id) {
            if (JSON.parse($cookies.get('adminType') || 0) == 0)
                getSpotAgreement();
        }

        function accessVerifyToggle(buttonName) {
            vm.loading = true;
            var promise = adminAccessService.checkStateValid(buttonName); //$stateParams.id
            return promise.then(
                function (payload) {
                    vm.loading = false;
                    console.log(payload);
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (!payload.title.data.granted) {

                            // languageBasedErrorFactory.getProperErrorMessage('optionNotAvail', 0, 0);
                            // errorMessageFactory.showErrorMessage(' No está autorizado para usar esta opción',0);
                            return false;
                        } else {
                            vm.loading = false;
                            vm.grantedCheckbox = true;
                            // vm.showCheckbox = true;
                            // setBooleans(id , value , panelType , buttonName , index);
                            // $timeout(function (){

                            // },500)

                            // setFlagInJob(id, type)
                            // return true;
                        }
                    }
                },
                function (errorPayload) {
                    console.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        accessVerifyToggle('BWR');

        function rutChange() {
            $log.log('data', vm.dataToFill.authRUT);
            if (vm.dataToFill.authRUT) {
                if (RutHelper.validate(vm.dataToFill.authRUT)) {
                    $log.log();
                    vm.dataToFill.rutFlag = false;
                } else {
                    vm.dataToFill.rutFlag = true;
                }
            } else if (vm.dataToFill.authRUT === null) {
                vm.dataToFill.rutFlag = true;
            } else if (vm.dataToFill.authRUT === undefined) {
                vm.dataToFill.rutFlag = false;
            }
        }
        vm.getDateTime = new Date().getDate();
        vm.getMonthTime = new Date().getMonth();
        vm.getYearTime = new Date().getFullYear();
        vm.Time = new Date().getTime();
        vm.TimeChange = function () {
            var a = new Date(vm.filterData.filter_pickup_from_date_value);
            if (vm.type_of_trip1 != 'R' && a.getDate() == vm.getDateTime && a.getMonth() == vm.getMonthTime && a.getFullYear() == vm.getYearTime) {
                return vm.Time;
            } else {
                return null;
            }

        }


        function flightTypeChange(data) {
            if (data == 'I') {
                vm.international = 'I';
                vm.flightFLag = true;
                //console.log("i m in if ");

            } else {
                vm.international = null;
                vm.flightFLag = false;
                vm.national = 'N';
                //console.log("i m in else ");
            }
        }


        vm.dateOptions = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(2090, 12, 31),
            //minDate: new Date(),
            startingDay: 1,
            showWeeks: false,

        };

        function showFilterTime(type) {
            var x = new Date();
            if (type == 1) {
                x.setHours('00');
                x.setMinutes('00');
                x.setSeconds('00');
            } else if (type == 2) {
                var currentHrs = x.getHours();
                var nextTwelveHrs = currentHrs + 12;
                var currentMins = x.getMinutes();
                x.setHours(nextTwelveHrs);
                x.setMinutes(currentMins);
                x.setSeconds('00');
            }
            return x;
        }







        function datePickerE_New(type) {
            if (type == 1) {
                //console.log("heelo i m here");

                vm.datePicker_1.pickupFromDate = true;


            }


        };

        //     vm.pickupFromToDateChanged = function(data){
        //         if(data==1){
        //             vm.TimeChange  = new Date(vm.filterData.filter_pickup_from_date_value);
        //             //console.log(vm.TimeChange,'askjdhaskjdhaskhdaskdhkasj');
        //         }
        //    }

        // vm.TimeChange =   function(){
        //     var a = new Date(vm.filterData.filter_pickup_from_date_value);
        //     var b = new Date();
        //     if(a.getDate() == b.getDate() && a.getMonth() == b.getMonth()  && a.getFullYear() == b.getFullYear() ){
        //          return new Date();
        //     }
        // }



        function passengerRutChange() {
            $log.log('data', vm.dataToFill.passengerRut);
            if (vm.dataToFill.passengerRut) {
                if (RutHelper.validate(vm.dataToFill.passengerRut)) {
                    vm.dataToFill.passengerRUTError = false;
                } else {
                    vm.dataToFill.passengerRUTError = true;
                }
            } else if (vm.dataToFill.passengerRut === null) {
                vm.dataToFill.passengerRUTError = true;
            } else if (vm.dataToFill.passengerRut === undefined) {
                vm.dataToFill.passengerRUTError = false;
            }
        }




        function applicantRutChange() {
            $log.log('data', vm.dataToFill.applicantRut);
            if (vm.dataToFill.applicantRut) {
                if (RutHelper.validate(vm.dataToFill.applicantRut)) {
                    vm.dataToFill.applicantRUTError = false;
                } else {
                    vm.dataToFill.applicantRUTError = true;
                }
            } else if (vm.dataToFill.applicantRut === null) {
                vm.dataToFill.applicantRUTError = true;
            } else if (vm.dataToFill.applicantRut === undefined) {
                vm.dataToFill.applicantRUTError = false;
            }
        }

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.go('layout.createBookingMain.createBooking');
            }
        });

        //=======================password match function====================
        function matchPassword(data) {
            if (data) {
                if (data != vm.dataToFill.password) {
                    vm.passwordMatchFlag = true;
                } else {
                    vm.passwordMatchFlag = false;
                }
            } else {
                vm.passwordMatchFlag = false;
            }
        };

        function matchPasswordAgain(data) {
            if (data && vm.dataToFill.confirmPassword) {
                if (data != vm.dataToFill.confirmPassword) {
                    vm.passwordMatchFlag = true;
                } else {
                    vm.passwordMatchFlag = false;
                }
            } else {
                vm.passwordMatchFlag = false;
            }
        };

        //========================add new customer========================
        function addNewCustomer() {
            vm.newCustomerFlag = true;
            vm.makePhoneEditAble = false;
            vm.dataToFill.customerMobileG = '';
            vm.dataToFill.customerId = '';
            vm.dataToFill.previousCustomerId = '';
            vm.dataToFill.customerEmail = '';
            vm.dataToFill.employeeId = '';
            // vm.dataToFill.customerProfile = '0';
            if (vm.disableAgreementService == true) {
                vm.dataToFill.customerProfile = vm.bookingDetails.creator_profile;
            } else {
                // THIS CHECK IS FOR PET USER BECAUSE PET USER CAN ONLY MAKE CORPORATE BOOKING
                if (JSON.parse($cookies.get('adminType') || 0) == 1) {
                    vm.dataToFill.customerProfile = '1';
                } else {
                    vm.dataToFill.customerProfile = '0';
                }
            }
            //vm.dataToFill.contractIdSelected = '';
            vm.dataToFill.previousPickFlag = false;
            vm.dataToFill.previousDropFlag = false;
            vm.isEmpDataChange = false; // TV-2378
            //vm.customerProfileOption = [
            //    {
            //        name: 'Personal',
            //        value: 0
            //    },
            //    {
            //        name: 'Corporate',
            //        value: 1
            //    }
            //];
        };

        //========================add new Person========================
        function addNewPerson() {
            vm.newPersonFlag = true;
            vm.makePersonPhoneEditAble = false;
            vm.dataToFill.personSelected = '';
            vm.dataToFill.personName = '';
            vm.dataToFill.personEmail = '';
            vm.dataToFill.passengerId = null;
            vm.dataToFill.personMobile = '';
        };

        //========================search customer=========================
        function searchCustomer(data) {
            //console.log(data, "puneet");
            if (data && vm.dataToFill.customerMobile.length > 3) {
                //return vm.allCustomersList;
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.search_id = data.toString();
                var promise = getCustomers.getCustomerAccordingToSearch(dataSend);
                //console.log(promise);
                return promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        if (payload.title.status == 400) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            return [];
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                            return [];
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            if (payload)
                                return payload.title.data;
                            else return [];
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            //errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                        }
                    }
                );
            } else {
                return [];
            }
        };

        //======================== SEARCH PERSON =========================
        function searchPerson(data) {
            if (data) {
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.search_value = data.toString();
                dataSend.limit = 50;
                dataSend.offset = 0;
                if (vm.dataToFill.contractIdSelected > 0) {
                    dataSend.contract_id = vm.dataToFill.contractIdSelected;
                    var promise = getCustomers.getPersonAccordingToSearch(dataSend);
                    return promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            vm.loading = false;
                            if (payload.title.status == 400) {
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                                return [];
                            } else if (payload.title.status == 401) {
                                errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                                return [];
                            } else if (payload.title.status == 201 || payload.title.status == 200) {
                                vm.is_vip = false;
                                vm.dataToFill.personName = '';
                                vm.dataToFill.personEmail = '';
                                vm.dataToFill.personMobile = '';
                                vm.dataToFill.passengerId = null;
                                if (payload) {
                                    if (vm.employeeId)
                                        var index = _.findIndex(payload.title.data.employee_data, {
                                            employee_id: vm.employeeId
                                        });
                                    //console.log('>>>>>>>>>>> INDEX >>>>>>>>>>>>>', index, vm.employeeId);
                                    if (vm.employeeId && index > -1) {
                                        payload.title.data.employee_data.splice(index, 1);
                                    }
                                    return payload.title.data.employee_data;
                                } else return [];
                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                //errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                            }
                        }
                    );
                } else {
                    errorMessageFactory.showErrorMessage('Por favor seleccione acuerdo', 0);
                }
            } else {
                return [];
            }
        };

        //============================get all customers=============================
        function getAllCustomers(skip, limit, id) {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit;
            dataSend.offset = skip;
            dataSend.search_filter = 0;
            dataSend.customer_id = id;
            var promise = getCustomers.allCustomers(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (payload.title.data.result) {
                            vm.allCustomersList = payload.title.data.result;
                            for (var i = 0; i < vm.allCustomersList.length; i++) {
                                vm.allCustomersList[i].name = vm.allCustomersList[i].first_name + ' ' + vm.allCustomersList[i].last_name;
                            }
                        } else {
                            vm.allCustomersList = [];
                        }

                        if ($stateParams.id)
                            getSingleBooking($stateParams.id);
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        if ($stateParams.id)
            getAllCustomers(0, 0, $stateParams.custId);
        //========================splice=======================
        vm.daysList = {
            sunday: {
                value: '',
                selected: false
            },
            monday: {
                value: '',
                selected: false
            },
            tuesday: {
                value: '',
                selected: false
            },
            wednesday: {
                value: '',
                selected: false
            },
            thursday: {
                value: '',
                selected: false
            },
            friday: {
                value: '',
                selected: false
            },
            saturday: {
                value: '',
                selected: false
            }
        };

        function selectDay(value) {
            ////console.log('asdasdasdsa',vm.daysList)
            switch (value) {
                case 'Sunday':
                    if (!vm.daysList.sunday.selected) {
                        vm.daysList.sunday.value = 0;
                    } else {
                        vm.daysList.sunday.value = '';
                    }
                    break;
                case 'Monday':
                    if (!vm.daysList.monday.selected) {
                        vm.daysList.monday.value = 1;
                    } else {
                        vm.daysList.monday.value = '';
                    }
                    break;
                case 'Tuesday':
                    if (!vm.daysList.tuesday.selected) {
                        vm.daysList.tuesday.value = 2;
                    } else {
                        vm.daysList.tuesday.value = '';
                    }
                    break;
                case 'Wednesday':
                    if (!vm.daysList.wednesday.selected) {
                        vm.daysList.wednesday.value = 3;
                    } else {
                        vm.daysList.wednesday.value = '';
                    }
                    break;
                case 'Thursday':
                    if (!vm.daysList.thursday.selected) {
                        vm.daysList.thursday.value = 4;
                    } else {
                        vm.daysList.thursday.value = '';
                    }
                    break;
                case 'Friday':
                    if (!vm.daysList.friday.selected) {
                        vm.daysList.friday.value = 5;
                    } else {
                        vm.daysList.friday.value = '';
                    }
                    break;
                case 'Saturday':
                    if (!vm.daysList.saturday.selected) {
                        vm.daysList.saturday.value = 6;
                    } else {
                        vm.daysList.saturday.value = '';
                    }
                    break;
            };


            // vm.length = vm.dayList.length;
            // vm.dayList.forEach(function(column) {
            //     //console.log('hello11111111111111', value, column.dayList);
            //     if (angular.equals(value, column.dayList)) {
            //         //console.log('hello', column.dayList)
            //         vm.i = column.dayList.indexOf(value);
            //         column.dayList.splice(i, 1);
            //         return false;
            //     }
            //     //console.log("length", vm.length);
            // });
            // if (vm.length == 0) {
            //     vm.dayList.push({
            //         "value": value
            //     })
            // }


            // //console.log('daylist', vm.dayList);
            //console.log(vm.daysList);
        }

        // ************ TO ADD CONTROLLEDVIA FLAG IN ESTIMATE PRICE  **********
        function viaControlledPrice(estimatePrice, controlledVia, typeOfTrip) {
            //  console.log('>>>>>>> IN VIACONTROLLED PRICE >>>>>>', estimatePrice, controlledVia, typeOfTrip);
            if (vm.dataToFill.controllerWayTarifa == 1) {
                if (typeOfTrip == 'Z') {
                    return Math.round(estimatePrice);
                } else {
                    return Math.round(estimatePrice);
                }
            } else {
                if (typeOfTrip == 'Z') {
                    return Math.round(estimatePrice + controlledVia);
                } else {
                    return Math.round(estimatePrice);
                }
            }
        }

        function calculateDiscountPercentage(estimatePrice, controlledVia, typeOfTrip, discountValue, type) {
            // console.log('>>>>>>> IN calculateDiscountPercentage >>>>>>', estimatePrice, ' vm.dataToFill.itemOfChargeSelected',vm.dataToFill.itemOfChargeSelected,'type',type);
            if (vm.dataToFill.controllerWayTarifa == 1) {
                if (typeOfTrip == 'Z') {
                    // var newEstimate = estimatePrice;
                    var newEstimate = 0;
                    var itemOfChargePrice = 0;
                    if (vm.dataToFill.itemOfChargeSelected.length > 0) {
                        for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                            if( vm.dataToFill.itemOfChargeSelected[i].retorno == false && type == 'parent'){
                                itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                            } else if(vm.dataToFill.itemOfChargeSelected[i].retorno == true && type==undefined){
                                itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                            }
                        }
                        newEstimate = estimatePrice - itemOfChargePrice;
                    } else {
                        newEstimate = estimatePrice;
                    }
                    // console.log('>>>>>>> newEstimate >>>>', newEstimate);
                    return Math.round(((newEstimate - Math.round((newEstimate * discountValue) / 100))) < 0 ? 0 : ((newEstimate - Math.round((newEstimate * discountValue) / 100)) + itemOfChargePrice));
                } else {
                    // var newEstimate = 0;
                    var itemOfChargePrice = 0;
                    if (vm.dataToFill.itemOfChargeSelected.length > 0) {
                        for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                            if( vm.dataToFill.itemOfChargeSelected[i].retorno == false && type == 'parent'){
                                itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                            } else if(vm.dataToFill.itemOfChargeSelected[i].retorno == true && type==undefined){
                                itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                            }
                        }
                        estimatePrice = estimatePrice - itemOfChargePrice;
                    }
                    return Math.round((estimatePrice - Math.round((estimatePrice * discountValue) / 100)) < 0 ? 0 : ((estimatePrice - Math.round((estimatePrice * discountValue) / 100)) + itemOfChargePrice));
                }
            } else {
                if (typeOfTrip == 'Z') {
                    // var newEstimate = estimatePrice;
                    // console.log(newEstimate,'newEstimate>?>>>>>>>>>',((newEstimate - (newEstimate * discountValue) / 100) + controlledVia));
                    var newEstimate = 0;
                    var itemOfChargePrice = 0;
                    if (vm.dataToFill.itemOfChargeSelected.length > 0) {
                        for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                            if( vm.dataToFill.itemOfChargeSelected[i].retorno == false && type == 'parent'){
                                itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                            } else if(vm.dataToFill.itemOfChargeSelected[i].retorno == true && type==undefined){
                                itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                            }
                        }
                        newEstimate = estimatePrice - itemOfChargePrice;
                    } else {
                        newEstimate = estimatePrice;
                    }
                    return Math.round(((newEstimate - Math.round((newEstimate * discountValue) / 100))) < 0 ? 0 : ((newEstimate - Math.round((newEstimate * discountValue) / 100)) + controlledVia + itemOfChargePrice));
                } else {
                    var itemOfChargePrice = 0;
                    if (vm.dataToFill.itemOfChargeSelected.length > 0) {
                        // var itemOfChargePrice = 0;
                        for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                            if( vm.dataToFill.itemOfChargeSelected[i].retorno == false && type == 'parent'){
                                itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                            } else if(vm.dataToFill.itemOfChargeSelected[i].retorno == true && type==undefined){
                                itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                            }
                        }
                        estimatePrice = estimatePrice - itemOfChargePrice;
                    }
                    return Math.round((estimatePrice - Math.round((estimatePrice * discountValue) / 100)) < 0 ? 0 : ((estimatePrice - Math.round((estimatePrice * discountValue) / 100)) + itemOfChargePrice));
                }
            }
        }

        function calculateDiscountPercentageAmount(estimatePrice, controlledVia, typeOfTrip, discountValue, type) {
            console.log('>>>>>>> IN calculateDiscountPercentageAmount >>>>>>>', estimatePrice, type);
            if (vm.dataToFill.controllerWayTarifa == 1) {
                if (typeOfTrip == 'Z') {
                    var newEstimate = 0;
                    var itemOfChargePrice = 0;
                    if (type == 'parent' && vm.dataToFill.itemOfChargeSelected.length > 0) {
                        for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                            itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                        }
                        newEstimate = estimatePrice - itemOfChargePrice;
                    } else {
                        newEstimate = estimatePrice;
                    }
                    return Math.round((newEstimate * discountValue) / 100);
                } else {
                    var itemOfChargePrice = 0;
                    if (type == 'parent' && vm.dataToFill.itemOfChargeSelected.length > 0) {
                        for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                            itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                        }
                        estimatePrice = estimatePrice - itemOfChargePrice;
                    }
                    return Math.round((estimatePrice * discountValue) / 100);
                }
                console.log(newEstimate, 'newEstimate')
            } else {
                if (typeOfTrip == 'Z') {
                    // var newEstimate = estimatePrice;
                    var newEstimate = 0;
                    var itemOfChargePrice = 0;
                    if (type == 'parent' && vm.dataToFill.itemOfChargeSelected.length > 0) {
                        for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                            itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                        }
                        newEstimate = estimatePrice - itemOfChargePrice;
                    } else {
                        newEstimate = estimatePrice;
                    }
                    return Math.round((newEstimate * discountValue) / 100);
                } else {
                    var itemOfChargePrice = 0;
                    if (type == 'parent' && vm.dataToFill.itemOfChargeSelected.length > 0) {
                        for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                            itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                        }
                        estimatePrice = estimatePrice - itemOfChargePrice;
                    }
                    return Math.round((estimatePrice * discountValue) / 100);
                }
                console.log(newEstimate, 'newEstimate')
            }
        }

        function calculateDiscountFlat(estimatePrice, controlledVia, typeOfTrip, discountValue) {
            // console.log('>>>>>> IN calculateDiscountFlat >>>>>>', estimatePrice, controlledVia, typeOfTrip, discountValue);
            if (vm.dataToFill.controllerWayTarifa == 1) {
                if (typeOfTrip == 'Z') {
                    var newEstimate = estimatePrice;
                    return Math.round(((newEstimate - discountValue) + controlledVia) < 0 ? 0 : ((newEstimate - discountValue)));
                } else {
                    return Math.round((estimatePrice - discountValue) < 0 ? 0 : (estimatePrice - discountValue));
                }
            } else {
                if (typeOfTrip == 'Z') {
                    var newEstimate = estimatePrice;
                    return Math.round(((newEstimate - discountValue) + controlledVia) < 0 ? 0 : ((newEstimate - discountValue) + controlledVia));
                } else {
                    return Math.round((estimatePrice - discountValue) < 0 ? 0 : (estimatePrice - discountValue));
                }
            }
        }

        function calculateDiscountFlatAmount(discountValue) {
            return Math.round(discountValue);
        }

        // *************** SHOW ESTIMATE PRICE IN HTML **************
        vm.calculatedEstimatePriceFormFunction = 0;
        vm.calculatedEstimatePriceFormFunctionEstimated = -1;

        function showEstimatePriceInHtml(roundTrip, viaControlledFLag1, viaControlledFLag) {
            if (!vm.click) {
                if (roundTrip == false && viaControlledFLag1 == false && viaControlledFLag == false) {
                    vm.calculatedEstimatePriceFormFunction = vm.math.round(vm.dataToFill.estimatedFare) || 0;
                    // CONDITION TO CHANGE INPUT FIELD VALUE BECAUSE THIS FUNCTION CALLS ON EVERY ACTION ON PAGE
                    if (vm.calculatedEstimatePriceFormFunctionEstimated == -1) {
                        vm.calculatedEstimatePriceFormFunctionEstimated = vm.calculatedEstimatePriceFormFunction;
                    }
                    return true;
                }

                if (roundTrip == false && viaControlledFLag1 == true && viaControlledFLag == false) {
                    vm.calculatedEstimatePriceFormFunction = vm.math.round((vm.dataToFill.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : vm.viaControlled1)) || 0;
                    // CONDITION TO CHANGE INPUT FIELD VALUE BECAUSE THIS FUNCTION CALLS ON EVERY ACTION ON PAGE
                    if (vm.calculatedEstimatePriceFormFunctionEstimated == -1) {
                        console.log(vm.calculatedEstimatePriceFormFunction, 'vm.calculatedEstimatePriceFormFunction');

                        vm.calculatedEstimatePriceFormFunctionEstimated = vm.calculatedEstimatePriceFormFunction;
                    }
                    return true;

                }

                if (roundTrip == false && viaControlledFLag1 == false && viaControlledFLag == true) {
                    vm.calculatedEstimatePriceFormFunction = vm.math.round(vm.dataToFill.estimatedFare) || 0;
                    // CONDITION TO CHANGE INPUT FIELD VALUE BECAUSE THIS FUNCTION CALLS ON EVERY ACTION ON PAGE
                    if (vm.calculatedEstimatePriceFormFunctionEstimated == -1) {
                        vm.calculatedEstimatePriceFormFunctionEstimated = vm.calculatedEstimatePriceFormFunction;
                    }
                    return true;
                }

                if (roundTrip == true && viaControlledFLag1 == false && viaControlledFLag == false) {
                    vm.calculatedEstimatePriceFormFunction = vm.math.round((vm.dataToFill.estimatedFare) + (vm.dataToFill.Return_policy.estimatedFare)) || 0;
                    // CONDITION TO CHANGE INPUT FIELD VALUE BECAUSE THIS FUNCTION CALLS ON EVERY ACTION ON PAGE
                    if (vm.calculatedEstimatePriceFormFunctionEstimated == -1) {
                        vm.calculatedEstimatePriceFormFunctionEstimated = vm.calculatedEstimatePriceFormFunction;
                    }
                    return true;
                }

                if (roundTrip == true && viaControlledFLag1 == true && viaControlledFLag == false) {
                    vm.calculatedEstimatePriceFormFunction = vm.math.round((vm.dataToFill.estimatedFare) + (vm.dataToFill.Return_policy.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : vm.viaControlled1)) || 0;
                    // CONDITION TO CHANGE INPUT FIELD VALUE BECAUSE THIS FUNCTION CALLS ON EVERY ACTION ON PAGE
                    if (vm.calculatedEstimatePriceFormFunctionEstimated == -1) {
                        vm.calculatedEstimatePriceFormFunctionEstimated = vm.calculatedEstimatePriceFormFunction;
                    }
                    return true;
                }

                if (roundTrip == true && viaControlledFLag1 == false && viaControlledFLag == true) {
                    vm.calculatedEstimatePriceFormFunction = vm.math.round((vm.dataToFill.estimatedFare) + (vm.dataToFill.Return_policy.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : vm.viaControlled2)) || 0;
                    // CONDITION TO CHANGE INPUT FIELD VALUE BECAUSE THIS FUNCTION CALLS ON EVERY ACTION ON PAGE
                    if (vm.calculatedEstimatePriceFormFunctionEstimated == -1) {
                        vm.calculatedEstimatePriceFormFunctionEstimated = vm.calculatedEstimatePriceFormFunction;
                    }
                    return true;
                }
            } else {
                return true;
            }
        }


        // *************** SHOW ESTIMATE PRICE IN HTML FOR ROUND TRIP **************
        vm.calculatedEstimatePriceForRoundTripFormFunction = 0;
        vm.roundTripPercentageAdd = true;

        function showEstimatePriceForRoundTripInHtml(estimateFare, isRoundTrip, viaControlledFLag) {

            if (estimateFare && isRoundTrip == true && viaControlledFLag == false) {
                if (vm.dataToFill.roundTrip == true && vm.calculatedEstimatePriceForRoundTripFormFunction >= 0)
                    vm.calculatedEstimatePriceForRoundTripFormFunction = vm.math.round(vm.dataToFill.Return_policy.estimatedFare) || 0;

                // CONDITION TO CHANGE INPUT FIELD VALUE BECAUSE THIS FUNCTION CALLS ON EVERY ACTION ON PAGE
                if (vm.roundTripPercentageAdd) {
                    // vm.calculatedEstimatePriceFormFunctionEstimated += vm.calculatedEstimatePriceForRoundTripFormFunction;
                    vm.calculatedEstimatePriceFormFunctionEstimated = vm.calculatedEstimatePriceFormFunction;
                    vm.roundTripPercentageAdd = false;
                }
                return true;
            }
            if (estimateFare && isRoundTrip == true && viaControlledFLag == true) {
                if (vm.dataToFill.roundTrip == true && vm.calculatedEstimatePriceForRoundTripFormFunction >= 0)
                    vm.calculatedEstimatePriceForRoundTripFormFunction = vm.math.round(vm.dataToFill.Return_policy.estimatedFare + (vm.dataToFill.controllerWayTarifa ? 0 : vm.viaControlled2)) || 0;

                // CONDITION TO CHANGE INPUT FIELD VALUE BECAUSE THIS FUNCTION CALLS ON EVERY ACTION ON PAGE
                if (vm.roundTripPercentageAdd) {
                    // vm.calculatedEstimatePriceFormFunctionEstimated += vm.calculatedEstimatePriceForRoundTripFormFunction;
                    vm.calculatedEstimatePriceFormFunctionEstimated = vm.calculatedEstimatePriceFormFunction;
                    vm.roundTripPercentageAdd = false;
                }
                return true;
            }
        }

        // *************** SHOW ESTIMATE PRICE IN HTML FOR FIXED PRICE **************
        vm.calculatedEstimatePriceForFixedPriceFormFunction = 0;

        function showEstimatePriceForFixedPriceInHtml(estimateFare, isRoundTrip, viaControlledFLag) {
            
            if (estimateFare && isRoundTrip == true && viaControlledFLag == false) {

                // CONDITION TO CHANGE INPUT FIELD VALUE BECAUSE THIS FUNCTION CALLS ON EVERY ACTION ON PAGE
                if (vm.dataToFill.roundTrip == true && vm.calculatedEstimatePriceForFixedPriceFormFunction == 0)
                    vm.calculatedEstimatePriceForFixedPriceFormFunction = vm.math.round(vm.dataToFill.estimatedFare) || 0;
                return true;
            }
            if (estimateFare && isRoundTrip == true && viaControlledFLag == true) {

                // CONDITION TO CHANGE INPUT FIELD VALUE BECAUSE THIS FUNCTION CALLS ON EVERY ACTION ON PAGE
                if (vm.dataToFill.roundTrip == true && vm.calculatedEstimatePriceForFixedPriceFormFunction == 0)
                    vm.calculatedEstimatePriceForFixedPriceFormFunction = vm.math.round(vm.dataToFill.estimatedFare + (vm.dataToFill.controllerWayTarifa ? 0 : vm.viaControlled1));
                return true;
            }
        }

        // ***** FUNCTION RUN WHEN USER ADJUST PRICE ********
        vm.click = false;
        vm.finalAdjustedPriceFromAdmin = 0;

        function clickFunction(status) {
            // IF ROUND TRIP IS ON
            // 1703 change 
            console.log(vm.fixedPriceFromSearchFixesVariable - vm.viaControlled1, vm.fixedPriceFromSearchFixesVariable, vm.viaControlled1);

            if (vm.dataToFill.controllerWayTarifa == 1 && vm.type_of_trip_Validate_Booking == 'Z') {
                vm.fixedPriceFromSearchFixesVariable1 = vm.fixedPriceFromSearchFixesVariable - vm.viaControlled1;
            } else {
                vm.fixedPriceFromSearchFixesVariable1 = vm.fixedPriceFromSearchFixesVariable;
            }
            if (vm.dataToFill.controllerWayTarifa == 1 && vm.type_of_trip == 'Z') {
                vm.estimatedFareRouteForRoundTrip1 = vm.estimatedFareRouteForRoundTrip - vm.viaControlled2;
            } else {
                vm.estimatedFareRouteForRoundTrip1 = vm.estimatedFareRouteForRoundTrip;
            }
            // 1703 change 
            if (vm.dataToFill.roundTrip) {
                vm.fixedAmountForAdjustedPrice = vm.fixedPriceFromSearchFixesVariable1 + vm.estimatedFareRouteForRoundTrip1;
            } else {
                vm.fixedAmountForAdjustedPrice = vm.fixedPriceFromSearchFixesVariable1;
            }

            // vm.calculateEstimateFareWithOutControlledVia = vm.calculatedEstimatePriceFormFunction - vm.fixedAmountForAdjustedPrice;
            // 1703 CHeck change 
            // ***** IF ADJUSTED PRICE IS GREATER THAN ESTIMATED PRICE ******
            // if ((status === 'Done') && (vm.fixedAmountForAdjustedPrice > vm.calculatedEstimatePriceFormFunctionEstimated)) {
            // // if ((status === 'Done') && (vm.calculateEstimateFareWithOutControlledVia > vm.calculatedEstimatePriceFormFunctionEstimated)) {
            //     errorMessageFactory.showErrorMessage('Valor ingresado no válido. Valor a pagar no puede ser menor que cero', 0);
            //     return true;
            // }
            function numberWithCommas(x) {
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            };
            if ((status === 'Done') && ((vm.fixedAmountForAdjustedPrice) < (vm.calculatedEstimatePriceFormFunction - vm.calculatedEstimatePriceFormFunctionEstimated))) {
                // errorMessageFactory.showErrorMessage('Error, el descuento no puede ser mayor a $' + (vm.fixedAmountForAdjustedPrice) + ' queel el valor del Tramo', 0);
                errorMessageFactory.showErrorMessage('Error, el descuento no puede ser mayor a $' + numberWithCommas(vm.fixedAmountForAdjustedPrice), 0);
                return true;
            }
            // ***** IF ADJUSTED PRICE IS LESS THAN FIXED PRICE ******
            if ((status === 'Done') && (vm.calculatedEstimatePriceFormFunction < vm.calculatedEstimatePriceFormFunctionEstimated)) {
                errorMessageFactory.showErrorMessage('Error, el monto final no puede ser mayor al original $' + numberWithCommas(vm.calculatedEstimatePriceFormFunction), 0);
                return true;
            }
            vm.click = !vm.click;
            // ****** CHECK WHEN CONFIRM ADJUSTED PRICE *******
            if (status === 'Done') {
                vm.finalAdjustedPriceFromAdmin = (vm.calculatedEstimatePriceFormFunction - vm.calculatedEstimatePriceFormFunctionEstimated) || 0;
                vm.dataToFill.discounts = [];
                vm.dummyDiscountObject = {};

                if (vm.dataToFill.roundTrip == true) {
                    vm.calculatedEstimatePriceForFixedPriceFormFunction -= vm.finalAdjustedPriceFromAdmin / 2;
                    vm.calculatedEstimatePriceForRoundTripFormFunction -= vm.finalAdjustedPriceFromAdmin / 2;
                    vm.dummyDiscountObject.discountType = 0;
                    vm.dummyDiscountObject.discountTypeValue = vm.math.round(vm.finalAdjustedPriceFromAdmin);
                    vm.dummyDiscountObject.promoType = 'adjustedPrice';
                    vm.dummyDiscountObject.finalAmount = vm.math.round(vm.calculatedEstimatePriceForFixedPriceFormFunction);
                    vm.dummyDiscountObject.value = vm.math.round(vm.finalAdjustedPriceFromAdmin / 2);
                    vm.dummyDiscountObject.roundTripFare = vm.math.round(vm.calculatedEstimatePriceForRoundTripFormFunction);
                    vm.dummyDiscountObject.roundFinalAmount = vm.math.round(vm.calculatedEstimatePriceForRoundTripFormFunction);
                    vm.dummyDiscountObject.estimatedFare = vm.math.round(vm.calculatedEstimatePriceForFixedPriceFormFunction + vm.finalAdjustedPriceFromAdmin);
                    vm.dummyDiscountObject.returnValue = vm.math.round(vm.finalAdjustedPriceFromAdmin / 2);
                    vm.dummyDiscountObject.name = 'Special Discount';
                } else {

                    vm.dummyDiscountObject.discountType = 0;
                    vm.dummyDiscountObject.discountTypeValue = vm.finalAdjustedPriceFromAdmin;
                    vm.dummyDiscountObject.promoType = 'adjustedPrice';
                    vm.dummyDiscountObject.finalAmount = vm.calculatedEstimatePriceFormFunctionEstimated;
                    vm.dummyDiscountObject.value = vm.finalAdjustedPriceFromAdmin;
                    vm.dummyDiscountObject.name = 'Special Discount';
                }
                vm.dataToFill.discounts.push(vm.dummyDiscountObject);
            }
        }
        //========================set boolean=======================
        function setBooleans(type, flag, returnFlag) {
            // console.log("kahgkdhskjhdkjsdhkahdkhak");

            switch (type) {
                case 'REACCURING_BOOKING':
                    if (vm.disabledRoundTrip == true || vm.CheckBookingStatus(vm.bookingDetails)) {
                        return;
                    }
                    if (vm.dataToFill.reaccurringBooking) {
                        vm.dataToFill.reaccurringBooking = false;
                        if (vm.type_of_trip1 == 'R' && vm.dataToFill.selectedServiceDetails.category == 1 && vm.method_range_pickup && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                            if (vm.pickRangeSendForRouting.length > 0 && vm.etaArray.length > 0) {
                                vm.pickRangeSendForRouting.length = 1;
                                vm.etaArray.length = 1;
                            } else {
                                vm.pickRangeSendForRouting = [];
                                vm.etaArray = [];
                            }
                        }
                        vm.days = false;
                    } else {
                        vm.dataToFill.reaccurringBooking = true;
                        vm.days = true;
                    }
                    break;
                case 'ROUND_TRIP':
                    if ((vm.disabledRoundTrip == true || vm.CheckBookingStatus(vm.bookingDetails)) && returnFlag === 'return') {
                        return;
                    }
                    vm.roundTripChildJobId = 1;
                    // ********* VARIABLES ARE INITIALIZE TO AGAIN SET INPUT FIELD VARIABLE ********
                    vm.calculatedEstimatePriceFormFunctionEstimated = -1;
                    vm.finalAdjustedPriceFromAdmin = 0;
                    vm.calculatedEstimatePriceForFixedPriceFormFunction = 0;
                    vm.calculatedEstimatePriceForRoundTripFormFunction = 0;
                    vm.click = false;
                    if (vm.bookingDetails && vm.bookingDetails.return_date_time_utc == "0000-00-00 00:00:00") {
                        vm.dataToFill.dropDateReturn = new Date();
                        vm.dataToFill.dropTimeReturn = new Date();
                    }
                    if (vm.dataToFill.selectedServiceDetails.category == 1) {
                        calculateEstimatePickUpTimeReturn(vm.dataToFill.etaScheduleValueReturn);
                    }
                    console.log(vm.dataToFill.selectedServiceDetails.category, vm.type_of_trip, vm.method_range_pickup_return, ' CHECK >>>>>>>>>>>>>>>>');
                    if ((vm.dataToFill.selectedServiceDetails.category == 1) && (vm.type_of_trip == 'R') && (vm.method_range_pickup_return == 1)) {
                        RoutingApiFuncationRoundTrip(vm.dataToFill)
                    }
                    if ((vm.dataToFill.selectedServiceDetails.category == 0) && (vm.type_of_trip == 'R') && (vm.method_range_pickup_return == 1) ) {
                        calculateEstimatePickUpTimeReturn(vm.dataToFill.etaScheduleValueReturn);
                    }
                    // $timeout(function () {
                    //     if (vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                    //         calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, map, 'ROUND TRIP',  vm.payloadForsearchFixedVairable);
                    //         // getFixedRoutesForPersonal(vm.dataToFill);

                    //     }
                    // }, 1000)
                    // console.log(vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip == 'P','PPppppp');
                    if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip == 'P') {
                        calculateDateRangeOfPointToPointReturn();
                    }
                    // console.log('>>>>>>>>>>>> vm.dataToFill.roundTrip >>>>>>', vm.dataToFill.roundTrip);
                    if (vm.dataToFill.roundTrip && !flag) {
                        vm.couponType = undefined;
                        //console.log(vm.dataToFill.roundTrip, 'hello==================');
                        vm.dataToFill.roundTrip = false;
                        var index = _.findIndex(vm.dataToFill.discounts, {
                            name: 'ROUND TRIP'
                        });
                        if (index > -1) {
                            // console.log("<<<<<<<<<<<<<<<<<< Index >>>>>>>>>>>>>>>>>>", index);

                            vm.dataToFill.discounts.splice(index, 1);
                            vm.dataToFill.discounts = vm.dataToFill.discounts.sort(function (a, b) {
                                return b.value - a.value
                            })
                            // console.log(vm.dataToFill.discounts, '>>>>>>>>>>>> vm.dataToFill.discounts NIche >>>>>>>>>');
                            vm.dataToFill.discounts.forEach(function (object) {
                                // console.log(">>>>>>>>>>in ForEach>>>>>>>>>>");

                                object.roundTripFare = vm.dataToFill.roundTrip != true ? 0 : object.roundTripFare,
                                    object.returnValue = vm.dataToFill.roundTrip != true ? 0 : object.returnValue,
                                    object.roundFinalAmount = vm.dataToFill.roundTrip != true ? 0 : object.roundFinalAmount
                            });
                        }
                    } else {
                        // if ((vm.dataToFill.customerProfile == 0 || vm.dataToFill.customerProfile == '0') && vm.dataToFill.bookingType == '0') {
                        //     errorMessageFactory.showErrorMessage('No se permite crear reservas ida y vuelta sin tiempo de espera', 0);
                        //     return false;
                        // }
                        console.log(vm.return_flag, 'vm.return_flag');

                        if(vm.dataToFill.Return_policy.route_type === 1) {
                            console.log(vm.return_flag, 'debug vm.return_flag');
                            if (vm.return_flag == true) {
                                ///////////////////////////TV-1795 //////////////////////////
                                vm.dataToFill.discounts = [];
                                vm.couponType = 1;
                                if (vm.dataToFill.roundTripDiscount == 0)
                                    vm.couponType = undefined;
                                // if (vm.dataToFill.itemOfChargeList.length == 0) {
                                //     vm.calculatedEstimatePriceFormFunctionEstimated += vm.finalAdjustedPriceFromAdmin;
                                //     vm.calculatedEstimatePriceFormFunction += vm.finalAdjustedPriceFromAdmin;
                                // }
                                // if (vm.dataToFill.estimatedFare < vm.viaControlled1) {
                                //     vm.dataToFill.roundTrip = false;
                                //     errorMessageFactory.showErrorMessage('Cannot create booking as via controlled fare is greater than the stretch price', 0);
                                // } else {
                                //    
                                // }
                                // if (vm.dataToFill.controllerWayTarifa == 1) {
                                //     // type_of_trip In Return case
                                //     // vm.type_of_trip_Validate_Booking In Normal case
                                //     console.log('>>>>>>> TYPE >>>>>', vm.type_of_trip_Validate_Booking, vm.type_of_trip);
                                //     console.log('>>>>>> IN TARIFA >>>>>>>>', vm.dataToFill.estimatedFare, vm.viaControlled1);
                                //     console.log('>>>>>> IN TARIFA >>>>>>>>', vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2);
                                //     vm.estimatedFareDiscount = vm.type_of_trip_Validate_Booking == 'Z' ? (Number(vm.dataToFill.estimatedFare)) - (Number(vm.viaControlled1)) : (Number(vm.dataToFill.estimatedFare));
                                //     vm.estimatedFareDiscountRound = vm.type_of_trip == 'Z' ? (Number(vm.dataToFill.Return_policy.estimatedFare)) - (Number(vm.viaControlled2)) : (Number(vm.dataToFill.Return_policy.estimatedFare));
                                //     console.log(vm.estimatedFareDiscount, ' vm.estimatedFareDiscount');
                                //     console.log(vm.estimatedFareDiscountRound, 'vm.estimatedFareDiscountRound');
                                // } else {
                                //     console.log('>>>>>> ELSE TARIFA >>>>>>>>', vm.dataToFill.estimatedFare, vm.viaControlled1);
                                //     console.log('>>>>>> ELSE TARIFA >>>>>>>>', vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2);
                                //     vm.estimatedFareDiscount = (Number(vm.dataToFill.estimatedFare));
                                //     vm.estimatedFareDiscountRound = (Number(vm.dataToFill.Return_policy.estimatedFare));
                                // }
                                // console.log('>>>>>>>>>>. BEFORE DISCOUNT vm.dataToFill.roundTripDiscount >>>>>.', vm.dataToFill.roundTripDiscount);
                                // console.log('>>>>>>>>>>. BEFORE DISCOUNT vm.estimatedFareDiscount >>>>>.', vm.estimatedFareDiscount);
                                // console.log('>>>>>>>>>>. BEFORE DISCOUNT vm.estimatedFareDiscountRound >>>>>.', vm.estimatedFareDiscountRound);
                                // console.log('>>>>>> vm.estimatedFareDiscount >>>>>>.', vm.estimatedFareDiscount);
                                // console.log('>>>>>>>>>>>> finalAmount', (vm.estimatedFareDiscount - (vm.estimatedFareDiscount * Number(vm.dataToFill.roundTripDiscount) / 100)));
                                // console.log('>>>>>>>>>>>> roundFinalAmount', (vm.estimatedFareDiscount * Number(vm.dataToFill.roundTripDiscount) / 100));
                                ///////////////////////////TV-1795 //////////////////////////
                                vm.dataToFill.roundTrip = true;
                                vm.dataToFill.discounts.push({
                                    // estimatedFare: Math.round(Number(vm.dataToFill.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled1))),
                                    estimatedFare: viaControlledPrice(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking),
                                    // roundTripFare: Math.round(Number(vm.dataToFill.Return_policy.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled2))),
                                    roundTripFare: vm.dataToFill.roundTrip == true ? viaControlledPrice(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip) : 0,
                                    name: 'ROUND TRIP',
                                    discountType: 1,
                                    discountTypeValue: vm.dataToFill.roundTripDiscount,
                                    // value: ((Number(vm.estimatedFareDiscount) * Number(vm.dataToFill.roundTripDiscount)) / 100),
                                    value: calculateDiscountPercentageAmount(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, vm.dataToFill.roundTripDiscount,'parent'),
                                    // returnValue: ((vm.estimatedFareDiscountRound * Number(vm.dataToFill.roundTripDiscount)) / 100),
                                    returnValue: vm.dataToFill.roundTrip == true ? calculateDiscountPercentageAmount(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, vm.dataToFill.roundTripDiscount, 'parent') : 0,
                                    // finalAmount: Math.round((vm.estimatedFareDiscount - vm.estimatedFareDiscount * Number(vm.dataToFill.roundTripDiscount) / 100) + (vm.type_of_trip_Validate_Booking == 'Z' ? (Number(vm.viaControlled1)) : 0)),
                                    finalAmount: calculateDiscountPercentage(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, vm.dataToFill.roundTripDiscount,'parent'),
                                    // roundFinalAmount: Math.round((vm.estimatedFareDiscountRound - (vm.estimatedFareDiscountRound) * Number(vm.dataToFill.roundTripDiscount) / 100) + (vm.type_of_trip == 'Z' ? (Number(vm.viaControlled2)) : 0))
                                    roundFinalAmount: vm.dataToFill.roundTrip == true ? calculateDiscountPercentage(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, vm.dataToFill.roundTripDiscount) : 0
                                })
                                // console.log('>>>>> DISCOUNT >>>>>>>>>>>', vm.dataToFill.discounts);
                                vm.dataToFill.discounts.forEach(function (data) {
                                    data.finalAmount = data.finalAmount < 0 ? 0 : data.finalAmount;
                                })
                                vm.dataToFill.discounts = vm.dataToFill.discounts.sort(function (a, b) {
                                    return b.value - a.value
                                })
                            } else {
                                errorMessageFactory.showErrorMessage('Ida y vuelta de este servicio no está disponible', 0);
                            }

                        }
                        calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, map, 'ROUND TRIP');
                    }
                    $timeout(function () {
                        changeDateStringToLocalizeDropOffDate();
                    });
                    console.log(vm.dataToFill.discounts, "hdksahdaskdhakjhdajkshdjkas");
                    break;
                case 'WAIT_TIME_INCLUDED':
                    if (vm.disabledRoundTrip == true || vm.CheckBookingStatus(vm.bookingDetails)) {
                        return;
                    }
                    if (vm.dataToFill.is_wait_time_included) {
                        vm.dataToFill.is_wait_time_included = false;
                    } else {
                        vm.dataToFill.is_wait_time_included = true;
                    }
                    break;
            }
        };
        // =================watch estimated fare===============
        $scope.$watchCollection('vm.dataToFill.estimatedFare', function (newValue, oldValue) {
            console.log(newValue, 'newValue');

            if (vm.dataToFill.discounts && vm.dataToFill.discounts.length) {
                // if(vm.dataToFill.controllerWayTarifa == 1){
                //     newValue = newValue - vm.viaControlled1;
                // }else{
                //     newValue = newValue;
                // }
                // console.log(vm.type_of_trip_Validate_Booking,'vm.type_of_trip_Validate_Booking>>>>>>>>>',vm.viaControlled1);

                // vm.dataToFill.discounts.push({
                //     // estimatedFare: Math.round(Number(vm.dataToFill.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled1))),
                //     estimatedFare: viaControlledPrice(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking),
                //     // roundTripFare: Math.round(Number(vm.dataToFill.Return_policy.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled2))),
                //     roundTripFare: viaControlledPrice(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip),
                //     name: 'ROUND TRIP',
                //     discountType: 1,
                //     discountTypeValue: vm.dataToFill.roundTripDiscount,
                //     // value: ((Number(vm.estimatedFareDiscount) * Number(vm.dataToFill.roundTripDiscount)) / 100),
                //     value: calculateDiscountPercentageAmount(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, vm.dataToFill.roundTripDiscount),
                //     // returnValue: ((vm.estimatedFareDiscountRound * Number(vm.dataToFill.roundTripDiscount)) / 100),
                //     returnValue: calculateDiscountPercentageAmount(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, vm.dataToFill.roundTripDiscount),
                //     // finalAmount: Math.round((vm.estimatedFareDiscount - vm.estimatedFareDiscount * Number(vm.dataToFill.roundTripDiscount) / 100) + (vm.type_of_trip_Validate_Booking == 'Z' ? (Number(vm.viaControlled1)) : 0)),
                //     finalAmount: calculateDiscountPercentage(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, vm.dataToFill.roundTripDiscount),
                //     // roundFinalAmount: Math.round((vm.estimatedFareDiscountRound - (vm.estimatedFareDiscountRound) * Number(vm.dataToFill.roundTripDiscount) / 100) + (vm.type_of_trip == 'Z' ? (Number(vm.viaControlled2)) : 0))
                //     roundFinalAmount: calculateDiscountPercentage(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, vm.dataToFill.roundTripDiscount)
                // })

                vm.dataToFill.discounts.forEach(function (data) {
                    // console.log('>>>>> IN FOR');
                    data.estimatedFare = viaControlledPrice(newValue, vm.viaControlled1, vm.type_of_trip_Validate_Booking);
                    // data.estimatedFare = Number(newValue) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled1)) + (vm.type_of_trip_Validate_Booking == 'Z' ? (Number(vm.viaControlled1)) : 0);
                    if (data.name == 'ROUND TRIP')
                        // data.value = Math.round((Number(newValue) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled1))) * Number(vm.dataToFill.roundTripDiscount) / 100);
                        data.value = calculateDiscountPercentageAmount(newValue, vm.viaControlled1, vm.type_of_trip_Validate_Booking, vm.dataToFill.roundTripDiscount, 'parent');
                    else {
                        if (data.discountType == 0 || data.discountType == '0')
                            // data.value = Number(data.discountTypeValue);
                            data.value = calculateDiscountFlatAmount(data.discountTypeValue);
                        // else data.value = Math.round((Number(newValue) + (vm.dataToFill.controllerWayTarifa ? 0 : (Number(vm.viaControlled1)))) * Number(data.discountTypeValue) / 100);
                        else data.value = calculateDiscountPercentageAmount(newValue, vm.viaControlled1, vm.type_of_trip_Validate_Booking, data.discountTypeValue, 'parent');
                    }
                    // data.finalAmount = (Number(newValue) + (vm.dataToFill.controllerWayTarifa ? 0  : Number(vm.viaControlled1))) - Number(data.value);
                    data.finalAmount = vm.couponType ? calculateDiscountPercentage(newValue, vm.viaControlled1, vm.type_of_trip_Validate_Booking, data.discountTypeValue, 'parent') : calculateDiscountFlat(newValue, vm.viaControlled1, vm.type_of_trip_Validate_Booking, data.discountTypeValue, 'parent');
                })
                vm.dataToFill.discounts.forEach(function (data) {
                    data.finalAmount = data.finalAmount < 0 ? 0 : data.finalAmount;
                })
                vm.dataToFill.discounts = vm.dataToFill.discounts.sort(function (a, b) {
                    return b.value - a.value
                })
            }
            console.log(vm.dataToFill.discounts);
        });

        $scope.$watchCollection('vm.dataToFill.Return_policy.estimatedFare', function (newValue, oldValue) {
            if (vm.dataToFill.discounts && vm.dataToFill.discounts.length && vm.dataToFill.roundTrip == true) {
                // if(vm.dataToFill.controllerWayTarifa == 1){
                //     newValue = newValue - vm.viaControlled2;
                // }else{
                //     newValue = newValue;
                // }
                vm.dataToFill.discounts.forEach(function (data) {
                    // data.roundTripFare = Number(newValue) + (vm.dataToFill.controllerWayTarifa ? 0 :  Number(vm.viaControlled2)) + (vm.type_of_trip == 'Z'  ? (Number(vm.viaControlled2)) : 0);
                    data.roundTripFare = viaControlledPrice(newValue, vm.viaControlled2, vm.type_of_trip);
                    if (data.name == 'ROUND TRIP')
                        // data.value = Math.round((Number(newValue) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled2))) * Number(vm.dataToFill.roundTripDiscount) / 100);
                        data.returnValue = calculateDiscountPercentageAmount(newValue, vm.viaControlled2, vm.type_of_trip, vm.dataToFill.roundTripDiscount, 'parent');
                    else {
                        if (data.discountType == 0 || data.discountType == '0')
                            // data.value = Number(data.discountTypeValue);
                            data.returnValue = calculateDiscountFlatAmount(data.discountTypeValue);
                        else data.returnValue = calculateDiscountPercentageAmount(newValue, vm.viaControlled2, vm.type_of_trip, data.discountTypeValue, 'parent');
                        // else data.value = Math.round((Number(newValue) + (vm.dataToFill.controllerWayTarifa ? 0 :Number(vm.viaControlled2))) * Number(data.discountTypeValue) / 100);
                    }
                    // data.roundFinalAmount = (Number(newValue) + (vm.dataToFill.controllerWayTarifa ? 0 :   Number(vm.viaControlled2))) - Number(data.value);
                    data.roundFinalAmount = vm.couponType ? calculateDiscountPercentage(newValue, vm.viaControlled2, vm.type_of_trip, data.discountTypeValue) : calculateDiscountFlat(newValue, vm.viaControlled2, vm.type_of_trip, data.discountTypeValue);
                });
                vm.dataToFill.discounts.forEach(function (data) {
                    data.roundFinalAmount = data.roundFinalAmount < 0 ? 0 : data.roundFinalAmount;
                })
                vm.dataToFill.discounts = vm.dataToFill.discounts.sort(function (a, b) {
                    return b.returnValue - a.returnValue
                })
            }
            // console.log(vm.dataToFill.discounts);
        });


        function applyCoupon() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.coupon_number = vm.dataToFill.couponCode;
            dataSend.flag = 1;
            dataSend.contract_id = Number(vm.dataToFill.contractIdSelected);
            vm.loading = true;
            var promise = quickSaleService.applyCoupon(dataSend);
            promise.then(
                function (payload) {
                    console.log('payload', payload);
                    vm.loading = false;
                    if (payload.title.message == 'El cupón que aplicó no es válido.') {
                        vm.dataToFill.couponValidation = true;
                        return;
                    } else if (payload.title.message == 'El cupón que aplicó está vencido.') {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return;
                    } else if (payload.title && payload.title.data && payload.title.data.status === 400) {
                        errorMessageFactory.showErrorMessage(payload.title.data.message, 0);
                        return;
                    } else if (payload.title && payload.title && payload.title.status === 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return;
                    } else {
                        vm.dataToFill.couponApplied = true;
                        if (payload && payload.title.data)
                            vm.couponType = payload.title.data.type;
                        ///////////////////////////TV-1795 //////////////////////////
                        // if ((Number(vm.dataToFill.Return_policy.estimatedFare)) < (Number(vm.viaControlled2))) {
                        //     errorMessageFactory.showErrorMessage('hello', 0);
                        // } else {}
                        // if (vm.dataToFill.controllerWayTarifa == 1) {
                        //     vm.estimatedFareDiscount = (Number(vm.dataToFill.estimatedFare)) - (Number(vm.viaControlled1));
                        //     vm.estimatedFareDiscountRound = (Number(vm.dataToFill.Return_policy.estimatedFare)) - (Number(vm.viaControlled2));
                        // } else {
                        //     vm.estimatedFareDiscount = (Number(vm.dataToFill.estimatedFare)) + (Number(vm.viaControlled1));
                        //     vm.estimatedFareDiscountRound = (Number(vm.dataToFill.Return_policy.estimatedFare)) + (Number(vm.viaControlled2));
                        // }
                        // var returnValueSend = 0;
                        // var roundFinalAmountSend = 0;
                        // var roundTripFareSend = 0;
                        // if (vm.dataToFill.roundTrip == true) {
                        //     returnValueSend = payload.title.data.type ? Math.round(vm.estimatedFareDiscountRound * (payload.title.data.discount) / 100) : payload.title.data.discount;
                        //     roundFinalAmountSend = payload.title.data.type ? Math.round((vm.estimatedFareDiscountRound) - (vm.estimatedFareDiscountRound * Number(payload.title.data.discount) / 100)+  + (vm.type_of_trip == 'Z'  ? (Number(vm.viaControlled1)) : 0)) : Math.round((vm.estimatedFareDiscountRound - payload.title.data.discount) +  + (vm.type_of_trip == 'Z'  ? (Number(vm.viaControlled1)) : 0));
                        //     roundTripFareSend = Number(vm.dataToFill.Return_policy.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled2))
                        // }
                        ///////////////////////////TV-1795 //////////////////////////
                        if (!(payload.title.data.type == 0 && vm.dataToFill.roundTrip == true))
                            languageBasedErrorFactory.getProperErrorMessage('couponApplySucc', 0, 0);
                        if (payload.title.data.type == 0 && vm.dataToFill.roundTrip == true) {
                            errorMessageFactory.showErrorMessage('Flat type discount cannot be applied on round trip.', 0);
                            return false;
                        }
                        vm.dataToFill.discounts.insert(0, {
                            // estimatedFare: Number(vm.dataToFill.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled1)),
                            estimatedFare: viaControlledPrice(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking),
                            // roundTripFare: roundTripFareSend,
                            roundTripFare: vm.dataToFill.roundTrip == true ? viaControlledPrice(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip) : 0,
                            name: payload.title.data.coupon_number,
                            discountType: payload.title.data.type,
                            discountTypeValue: payload.title.data.discount,
                            // value: payload.title.data.type ? Math.round((Number(vm.estimatedFareDiscount) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled1))) * (payload.title.data.discount) / 100) : payload.title.data.discount,
                            value: payload.title.data.type ? calculateDiscountPercentageAmount(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, payload.title.data.discount, 'parent') : calculateDiscountFlatAmount(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, payload.title.data.discount),
                            // returnValue: returnValueSend,
                            returnValue: vm.dataToFill.roundTrip == true ? (payload.title.data.type ? calculateDiscountPercentageAmount(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, payload.title.data.discount, 'parent') : calculateDiscountFlatAmount(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, payload.title.data.discount)) : 0,
                            // finalAmount: payload.title.data.type ?  ((vm.estimatedFareDiscount - vm.estimatedFareDiscount * Number(payload.title.data.discount) / 100) + (vm.type_of_trip_Validate_Booking == 'Z' ? (Number(vm.viaControlled1)) : 0)) :  ((vm.estimatedFareDiscount - vm.estimatedFareDiscount * Number(payload.title.data.discount) / 100) + (vm.type_of_trip_Validate_Booking == 'Z' ? (Number(vm.viaControlled1)) : 0)),
                            finalAmount: payload.title.data.type ? calculateDiscountPercentage(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, payload.title.data.discount, 'parent') : calculateDiscountFlat(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, payload.title.data.discount, 'parent'),
                            // roundFinalAmount: roundFinalAmountSend,
                            roundFinalAmount: vm.dataToFill.roundTrip == true ? (payload.title.data.type ? calculateDiscountPercentage(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, payload.title.data.discount) : calculateDiscountFlat(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, payload.title.data.discount)) : 0
                        })
                        // vm.dataToFill.discounts.push({
                        //     // estimatedFare: Number(vm.dataToFill.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled1)),
                        //     estimatedFare: viaControlledPrice(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking),
                        //     // roundTripFare: roundTripFareSend,
                        //     roundTripFare: vm.dataToFill.roundTrip == true ? viaControlledPrice(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip) : 0,
                        //     name: payload.title.data.coupon_number,
                        //     discountType: payload.title.data.type,
                        //     discountTypeValue: payload.title.data.discount,
                        //     // value: payload.title.data.type ? Math.round((Number(vm.estimatedFareDiscount) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled1))) * (payload.title.data.discount) / 100) : payload.title.data.discount,
                        //     value: payload.title.data.type ? calculateDiscountPercentageAmount(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, payload.title.data.discount) : calculateDiscountFlatAmount(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, payload.title.data.discount),
                        //     // returnValue: returnValueSend,
                        //     returnValue: vm.dataToFill.roundTrip == true ? (payload.title.data.type ? calculateDiscountPercentageAmount(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, payload.title.data.discount) : calculateDiscountFlatAmount(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, payload.title.data.discount)) : 0,
                        //     // finalAmount: payload.title.data.type ?  ((vm.estimatedFareDiscount - vm.estimatedFareDiscount * Number(payload.title.data.discount) / 100) + (vm.type_of_trip_Validate_Booking == 'Z' ? (Number(vm.viaControlled1)) : 0)) :  ((vm.estimatedFareDiscount - vm.estimatedFareDiscount * Number(payload.title.data.discount) / 100) + (vm.type_of_trip_Validate_Booking == 'Z' ? (Number(vm.viaControlled1)) : 0)),
                        //     finalAmount: payload.title.data.type ? calculateDiscountPercentage(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, payload.title.data.discount) : calculateDiscountFlat(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, payload.title.data.discount),
                        //     // roundFinalAmount: roundFinalAmountSend,
                        //     roundFinalAmount: vm.dataToFill.roundTrip == true ? (payload.title.data.type ? calculateDiscountPercentage(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, payload.title.data.discount) : calculateDiscountFlat(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, payload.title.data.discount)) : 0
                        // });
                        // Math.round((Number(vm.estimatedFareDiscount) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled1))) - Number(Number(vm.estimatedFareDiscount)) * Number(payload.title.data.discount) / 100) : Math.round((Number(vm.estimatedFareDiscount) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled1))) - payload.title.data.discount)
                        vm.dataToFill.discounts.forEach(function (data) {
                            data.finalAmount = data.finalAmount < 0 ? 0 : data.finalAmount;
                        })
                        vm.dataToFill.discounts = vm.dataToFill.discounts.sort(function (a, b) {
                            return b.value - a.value
                        })
                    }

                    // console.log(vm.dataToFill.discounts, "second time>>>>>>");

                    //vm.dataToFill.discounts.push({
                    //    estimatedFare: vm.dataToFill.estimatedFare,
                    //    name: 'ROUND TRIP',
                    //    discountType: 1,
                    //    discountTypeValue: vm.dataToFill.roundTripDiscount,
                    //    value: ((Number(vm.dataToFill.estimatedFare) * Number(vm.dataToFill.roundTripDiscount))/100),
                    //    finalAmount: Number(vm.dataToFill.estimatedFare) - ((Number(vm.dataToFill.estimatedFare) * Number(vm.dataToFill.roundTripDiscount))/100)
                    //})

                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        //======================by pass function for fav=========================
        function makeByPassFunctionForFav(type) {
            if (type == '1') {
                var where = _.where(vm.favAddressList, {
                    location_id: Number(vm.dataToFill.favPickLocId)
                });
                //console.log('where', where, vm.dataToFill);
                vm.dataToFill.pickUpAddress = where[0].address;
                if (vm.getInfoFlag == true) {
                    var geocoder = new google.maps.Geocoder;
                    vm.pickaddressChange = true;
                    geocoder.geocode({
                        'address': vm.dataToFill.pickUpAddress
                    }, function (results, status) {
                        if (status === 'OK') {
                            var city;
                            for (var i = 0; i < results[0].address_components.length; i++) {
                                for (var j = 0; j < results[0].address_components[i].types.length; j++) {
                                    if (results[0].address_components[i].types[j] == 'locality') {
                                        city = results[0].address_components[i].short_name;
                                        vm.jobPickupComuna = city;
                                    }
                                }
                            }
                            if (vm.pickUpCity && (vm.pickUpCity != city)) {
                                errorMessageFactory.showErrorMessage('Error, esta dirección cambia el tramo original. El cambio no debe afectar la tarifa.', 0);
                                vm.dataToFill.pickUpAddress = vm.pickUpAddress;
                                return;

                            } else {
                                // reverseGeocodeForFavPickUp(vm.dataToFill.pickUpAddress);
                                vm.dataToFill.pickUpLat = where[0].latitude;
                                vm.dataToFill.pickUpLng = where[0].longtitude;
                                // var location = new google.maps.LatLng(Number(where[0].latitude), Number(where[0].longtitude));
                                if (vm.toAirportFlag) {
                                    getAirportAddressApi();
                                }
                                if (vm.ptopAirportFlag && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                                    getFixedRoutesForPersonal(vm.dataToFill);
                                }
                                if (vm.dataToFill.serviceTypeSelected) { //&& (vm.dataToFill.bookingType == '0' || vm.dataToFill.bookingType == 0)
                                    vm.dataToFill.nearDriver = '';
                                    toGetAirportService(vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.serviceTypeSelected, map);
                                    //toGetNearByDrivers(vm.dataToFill.pickUpLat,vm.dataToFill.pickUpLng,vm.dataToFill.serviceTypeSelected,map);
                                }
                            }
                        } else {
                            window.alert('Geocode was not successful for the following reason: ' +
                                status);
                        }
                    });
                } else {
                    // reverseGeocodeForFavPickUp(vm.dataToFill.pickUpAddress);
                    vm.dataToFill.pickUpLat = where[0].latitude;
                    vm.dataToFill.pickUpLng = where[0].longtitude;
                    vm.dataToFill.pickLat = where[0].latitude;
                    vm.dataToFill.pickLng = where[0].longtitude;
                    vm.jobPickupComuna = where[0].communa;
                    // var location = new google.maps.LatLng(Number(where[0].latitude), Number(where[0].longtitude));
                    // placeMarker(map, location, 'pick');
                    if (vm.toAirportFlag) {
                        getAirportAddressApi();
                    }
                    if (vm.ptopAirportFlag && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                        getFixedRoutesForPersonal(vm.dataToFill);
                    }
                    if (vm.dataToFill.serviceTypeSelected) { //&& (vm.dataToFill.bookingType == '0' || vm.dataToFill.bookingType == 0)
                        vm.dataToFill.nearDriver = '';
                        toGetAirportService(vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.serviceTypeSelected, map);
                        //toGetNearByDrivers(vm.dataToFill.pickUpLat,vm.dataToFill.pickUpLng,vm.dataToFill.serviceTypeSelected,map);
                    }
                }
                vm.getFixedRoutesForPersonalFlag = true;
                // $timeout(function () {
                //     placeMarker(map, location, 'pick');
                // }, 2000)
            } else if (type == '2') {
                var where = _.where(vm.favAddressList, {
                    location_id: Number(vm.dataToFill.favDropLocId)
                });
                //console.log('where', where, vm.dataToFill);
                vm.dataToFill.dropOffAddress = where[0].address;
                vm.dropaddressChange = true;
                if (vm.getInfoFlag == true) {
                    var geocoder = new google.maps.Geocoder;
                    geocoder.geocode({
                        'address': vm.dataToFill.dropOffAddress
                    }, function (results, status) {
                        if (status === 'OK') {
                            var city;
                            for (var i = 0; i < results[0].address_components.length; i++) {
                                for (var j = 0; j < results[0].address_components[i].types.length; j++) {
                                    if (results[0].address_components[i].types[j] == 'locality') {
                                        city = results[0].address_components[i].short_name;
                                        vm.jobDropoffComuna = city;
                                    }
                                }
                            }
                            if (vm.dropUpCity && (vm.dropUpCity != city)) {
                                errorMessageFactory.showErrorMessage('Error, esta dirección cambia el tramo original. El cambio no debe afectar la tarifa.', 0);
                                // results= '';
                                vm.dataToFill.dropOffAddress = vm.dropUpAddress;
                                return;
                            } else {
                                vm.dataToFill.dropOffLat = where[0].latitude;
                                vm.dataToFill.dropOffLng = where[0].longtitude;
                                var locationD = new google.maps.LatLng(Number(where[0].latitude), Number(where[0].longtitude));
                                if (vm.fromAirportFlag) {
                                    getAirportAddressApi();
                                }
                                if (vm.ptopAirportFlag && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                                    getFixedRoutesForPersonal(vm.dataToFill);
                                }
                            }
                        } else {
                            window.alert('Geocode was not successful for the following reason: ' +
                                status);
                        }
                    });
                } else {
                    vm.dataToFill.dropOffLat = where[0].latitude;
                    vm.dataToFill.dropOffLng = where[0].longtitude;
                    vm.dataToFill.dropLat = where[0].latitude;
                    vm.dataToFill.dropLng = where[0].longtitude;
                    vm.jobDropoffComuna = where[0].communa;
                    // var locationD = new google.maps.LatLng(Number(where[0].latitude), Number(where[0].longtitude));
                    if (vm.fromAirportFlag) {
                        getAirportAddressApi();
                    }
                    if (vm.ptopAirportFlag && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                        getFixedRoutesForPersonal(vm.dataToFill);
                    }

                }
                vm.getFixedRoutesForPersonalFlag = true;
                // reverseGeocodeForFavDropUp(vm.dataToFill.dropOffAddress);
                // $timeout(function () {
                //     placeMarker(map, locationD, 'drop');
                // }, 2000);
            }
            if ((vm.dataToFill.pickUpLng && vm.dataToFill.pickUpLat))
                getFavoriteAddress('pick');
            if ((vm.dataToFill.dropOffLng && vm.dataToFill.dropOffLat))
                getFavoriteAddress('drop');
        }
        //=====================pickupfav address =========================
        function pickFavAddress($event) {
            getCustomerFavouriteAddress('popUp');
        };


        function openPopForFavouriteAddress($event) {
            vm.pickLocationList = [];
            vm.pickLocationListAgreement = [];
            if (vm.dataToFill.favDropLocId) {
                for (var i = 0; i < vm.favAddressList.length; i++) {
                    if (Number(vm.dataToFill.favDropLocId) != vm.favAddressList[i].location_id) {
                        // if (vm.favAddressList[i].aggreement_address == 0) {
                        //     vm.pickLocationList.push(vm.favAddressList[i]);
                        // } else {
                        //     vm.pickLocationListAgreement.push(vm.favAddressList[i]);
                        // }
                        vm.pickLocationList.push(vm.favAddressList[i]);
                    }
                }
            } else {
                for (var i = 0; i < vm.favAddressList.length; i++) {
                    // if (vm.favAddressList[i].aggreement_address == 0) {
                    //     vm.pickLocationList.push(vm.favAddressList[i]);
                    // } else {
                    //     vm.pickLocationListAgreement.push(vm.favAddressList[i]);
                    // }
                    vm.pickLocationList.push(vm.favAddressList[i]);
                }
            }
            vm.items = {
                list: vm.pickLocationList,
                errMsg: '',
                selected: '',
                agreementList: vm.pickLocationListAgreement,
                searchaddress: ''
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/favAddressesViewChange.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });

            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.colorFlag = [];
                $scope.locationIds = [];
                $scope.indexNew = 0;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                    if ((vm.dataToFill.pickUpLng && vm.dataToFill.pickUpLat))
                        getFavoriteAddress('pick');
                    if ((vm.dataToFill.dropOffLng && vm.dataToFill.dropOffLat))
                        getFavoriteAddress('drop');
                };
                $scope.checkData = function (data, index) {
                    if (data.checked == undefined || data.checked == false) {
                        $scope.locationIds.push({
                            location_id: data.location_id
                        });
                    } else {
                        var indexd = _.findIndex($scope.locationIds, {
                            location_id: data.location_id
                        });
                        if (indexd > -1) {
                            $scope.locationIds.splice(indexd, 1);
                        }
                    }
                    $scope.indexNew = $scope.locationIds.length;
                }
                $scope.blackArray = function () {
                    $scope.items.list.forEach(function (data) {
                        if (data.checked) {
                            data.checked = false;
                        }
                    });
                    $scope.locationIds = [];
                    $scope.indexNew = 0;
                }
                $scope.divSelected = function (data, index) {
                    if ($scope.colorFlag[index] == true) {
                        $scope.colorFlag[index] = false;
                        $scope.items.selected = null;
                    } else {
                        $scope.colorFlag = [];
                        $scope.colorFlag[index] = true;
                        $scope.items.selected = data.location_id;
                    }
                }
                $scope.getFilter = function () {
                    $scope.items.list = [];
                    $scope.items.agreementList = [];
                    if (vm.dataToFill.customerId == null || vm.dataToFill.customerId == undefined || vm.dataToFill.customerId == '') {
                        return false;
                    }
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.customer_id = vm.dataToFill.customerId;
                    if (vm.personalFlag == true) {
                        dataSend.contract_id = vm.dataToFill.contractIdSelected;
                    } else {
                        dataSend.contract_id = vm.dataToFill.customerContarctId;
                    }
                    if ($scope.items.searchaddress != '')
                        dataSend.search_value = $scope.items.searchaddress;
                    vm.loading = true;
                    var promise = getCustomers.getFavoriteLocation(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            vm.loading = false;
                            if (payload.title.data.length) {
                                $scope.items.listarray = payload.title.data;
                                for (var i = 0; i < $scope.items.listarray.length; i++) {
                                    if ($scope.items.listarray[i].aggreement_address == 0) {
                                        $scope.items.list.push($scope.items.listarray[i]);
                                    } else {
                                        $scope.items.list.push($scope.items.listarray[i]);
                                    }
                                }
                                vm.favAddFlag = true;
                                vm.favAddFlagI = {
                                    'width': '95%'
                                };
                                vm.crossButton = {
                                    'left': '494px'
                                }
                                vm.favAddFlagB = {
                                    'width': '15%'
                                };
                                // if (type == 'popUp') {
                                //     openPopForFavouriteAddress($event);
                                // }
                            } else {
                                vm.favAddressList = [];
                                vm.favAddFlag = false;
                                vm.favAddFlagI = {
                                    'width': '100%'
                                };
                                vm.favAddFlagB = {
                                    'width': '0%'
                                };
                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }
                $scope.deleteFavouriteAddress = function (data, index) {
                    var dataSend = {};
                    var locationIdsArray = [];
                    $scope.items.list.forEach(function (data) {
                        if (data.checked) {
                            locationIdsArray.push(data.location_id);
                        }
                    });
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.location_id = locationIdsArray;
                    dataSend.is_admin = 1;
                    dataSend.customer_id = vm.dataToFill.customerId;
                    vm.loading = true;
                    var promise = getBookingsHereMaps.setUnFavouriteAddress(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            vm.loading = false;
                            if (payload.title.status == 200) {
                                $scope.items.list.splice(index, 1);
                            } else {
                                vm.isActivePick = !vm.isActivePick;
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            $scope.items.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }
                $scope.confirmUpload = function () {
                    // //console.log($scope.items.selected, '$scope.items.selected');
                    // $log.log('confirmed', $scope.items);
                    // if ($scope.items.selected == null) {
                    //     $scope.items.errMsg = languageBasedErrorFactory.getProperErrorMessage('selectLocationError', 0, '3');
                    //     $timeout(function () {
                    //         $scope.items.errMsg = '';
                    //     }, 2000);
                    // } else {
                    //     $mdDialog.hide();
                    //     vm.dataToFill.favPickLocId = $scope.items.selected;
                    //     vm.addressChange = true;
                    //     makeByPassFunctionForFav('1');
                    // }
                    var dataSend = {};
                    var locationIdsArray = [];
                    $scope.items.list.forEach(function (data) {
                        if (data.checked) {
                            locationIdsArray.push(data.location_id);
                        }
                    });
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.location_id = locationIdsArray;
                    dataSend.is_admin = 1;
                    dataSend.customer_id = vm.dataToFill.customerId;
                    vm.loading = true;
                    var promise = getBookingsHereMaps.setUnFavouriteAddress(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            vm.loading = false;
                            if (payload.title.status == 200) {
                                // vm.isActivePick = !vm.isActivePick;
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            } else {
                                vm.isActivePick = !vm.isActivePick;
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            $scope.items.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                };
            }
        }
        //=====================pickupfav address =========================
        function dropFavAddress($event) {
            getCustomerFavouriteAddress('popUpDrop');
            //console.log(vm.favAddressList);
        };

        function openPopForFavouriteAddressDrop($event) {
            vm.dropLocationList = [];
            vm.dropLocationListAgreement = [];
            if (vm.dataToFill.favPickLocId) {
                for (var i = 0; i < vm.favAddressList.length; i++) {
                    if (Number(vm.dataToFill.favPickLocId) != vm.favAddressList[i].location_id) {
                        // if (vm.favAddressList[i].aggreement_address == 0) {
                        //     vm.dropLocationList.push(vm.favAddressList[i]);
                        // } else {
                        //     vm.dropLocationListAgreement.push(vm.favAddressList[i]);
                        // }
                        vm.dropLocationList.push(vm.favAddressList[i]);
                    }
                }
            } else {
                for (var i = 0; i < vm.favAddressList.length; i++) {
                    // if (vm.favAddressList[i].aggreement_address == 0) {
                    //     vm.dropLocationList.push(vm.favAddressList[i]);
                    // } else {
                    //     vm.dropLocationListAgreement.push(vm.favAddressList[i]);
                    // }
                    vm.dropLocationList.push(vm.favAddressList[i]);
                }
            }
            vm.items = {
                list: vm.dropLocationList,
                errMsg: '',
                selected: '',
                agreementList: vm.dropLocationListAgreement,
                searchaddress: ''
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/favAddressesViewChange.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });

            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.colorFlag = [];
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                    if ((vm.dataToFill.dropOffLng && vm.dataToFill.dropOffLat))
                        getFavoriteAddress('drop');
                    if ((vm.dataToFill.pickUpLng && vm.dataToFill.pickUpLat))
                        getFavoriteAddress('pick');
                };
                $scope.divSelected = function (data, index) {
                    if ($scope.colorFlag[index] == true) {
                        $scope.colorFlag[index] = false;
                        $scope.items.selected = null;
                    } else {
                        $scope.colorFlag = [];
                        $scope.colorFlag[index] = true;
                        $scope.items.selected = data.location_id;
                    }
                }
                $scope.deleteFavouriteAddress = function (data, index) {
                    console.log(data, 'delete');
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.location_id = data.location_id;
                    dataSend.is_admin = 1;
                    dataSend.customer_id = vm.dataToFill.customerId;
                    vm.loading = true;
                    var promise = getBookingsHereMaps.setUnFavouriteAddress(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            vm.loading = false;
                            if (payload.title.status == 200) {
                                console.log(index, 'index>>>>>>>>>');
                                $scope.items.list.splice(index, 1);
                            } else {
                                vm.isActivePick = !vm.isActivePick;
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            $scope.items.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }
                $scope.getFilter = function () {
                    $scope.items.agreementList = [];
                    $scope.items.list = [];
                    if (vm.dataToFill.customerId == null || vm.dataToFill.customerId == undefined || vm.dataToFill.customerId == '') {
                        return false;
                    }
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.customer_id = vm.dataToFill.customerId;
                    if (vm.personalFlag == true) {
                        dataSend.contract_id = vm.dataToFill.contractIdSelected;
                    } else {
                        dataSend.contract_id = vm.dataToFill.customerContarctId;
                    }
                    if ($scope.items.searchaddress != '') {}
                    dataSend.search_value = $scope.items.searchaddress;
                    vm.loading = true;
                    var promise = getCustomers.getFavoriteLocation(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            vm.loading = false;
                            if (payload.title.data.length) {
                                $scope.items.listarray = payload.title.data;
                                for (var i = 0; i < $scope.items.listarray.length; i++) {
                                    if ($scope.items.listarray[i].aggreement_address == 0) {
                                        $scope.items.list.push($scope.items.listarray[i]);
                                    } else {
                                        $scope.items.list.push($scope.items.listarray[i]);
                                    }
                                }
                                vm.favAddFlag = true;
                                vm.favAddFlagI = {
                                    'width': '95%'
                                };
                                vm.crossButton = {
                                    'left': '494px'
                                }
                                vm.favAddFlagB = {
                                    'width': '15%'
                                };
                                // if (type == 'popUp') {
                                //     openPopForFavouriteAddress($event);
                                // }
                            } else {
                                vm.favAddressList = [];
                                vm.favAddFlag = false;
                                vm.favAddFlagI = {
                                    'width': '100%'
                                };
                                vm.favAddFlagB = {
                                    'width': '0%'
                                };
                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }
                $scope.confirmUpload = function () {
                    $log.log('confirmed', $scope.items);
                    if ($scope.items.selected == null) {
                        $scope.items.errMsg = languageBasedErrorFactory.getProperErrorMessage('selectLocationError', 0, '3');
                        $timeout(function () {
                            $scope.items.errMsg = '';
                        }, 2000);
                    } else {
                        $mdDialog.hide();
                        vm.dataToFill.favDropLocId = $scope.items.selected;
                        makeByPassFunctionForFav('2');
                    }
                };
            }
        }
        //==========================get customer faourite address=============================
        function getCustomerFavouriteAddress(type, $event) {
            if (vm.dataToFill.customerId == null || vm.dataToFill.customerId == undefined || vm.dataToFill.customerId == '') {
                return false;
            }
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.customer_id = vm.dataToFill.customerId;
            if (vm.personalFlag == true) {
                dataSend.contract_id = vm.dataToFill.contractIdSelected;
            } else {
                dataSend.contract_id = vm.dataToFill.customerContarctId;
            }

            vm.loading = true;
            var promise = getCustomers.getFavoriteLocation(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.data.length) {
                        vm.favAddressList = payload.title.data;
                        vm.favAddFlag = true;
                        vm.favAddFlagI = {
                            'width': '95%'
                        };
                        vm.crossButton = {
                            'left': '494px'
                        }
                        vm.favAddFlagB = {
                            'width': '15%'
                        };
                        if (type == 'popUp') {
                            openPopForFavouriteAddress($event);
                        }
                        if (type == 'popUpDrop') {
                            openPopForFavouriteAddressDrop($event);
                        }
                    } else {
                        vm.favAddressList = [];
                        vm.favAddFlag = false;
                        vm.favAddFlagI = {
                            'width': '100%'
                        };
                        vm.favAddFlagB = {
                            'width': '0%'
                        };
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        //======================selecting particular customer=========================
        vm.employeeId = 0;

        function onSelectingCustomer() {
            $log.log(vm.dataToFill);
            // //console.log('>>>>>>>>>>>> payload.title.data.employee_data', vm.dataToFill);
            vm.dataToFill.customerMobileG = vm.dataToFill.customerMobile.phone_number;
            vm.dataToFill.customerId = vm.dataToFill.customerMobile.customer_id;
            vm.dataToFill.previousCustomerId = vm.dataToFill.customerMobile.customer_id;
            vm.dataToFill.customerEmail = vm.dataToFill.customerMobile.email;
            vm.employeeId = vm.dataToFill.customerMobile.employee_id;
            //vm.dataToFill.customerContarctId = vm.dataToFill.customerMobile.contract_id;
            vm.dataToFill.employeeId = vm.dataToFill.customerMobile.customer_id;
            vm.dataToFill.authRequired = 0;
            //vm.dataToFill.auther_id = vm.dataToFill.customerMobile.employee_details.auther_id;
            //vm.dataToFill.authRUT = RutHelper.format(vm.dataToFill.customerMobile.employee_details.auth_RUT);
            // vm.dataToFill.customerProfile = '0';
            if (vm.disableAgreementService == true) {
                vm.dataToFill.customerProfile = vm.bookingDetails.creator_profile;
            } else {
                // THIS CHECK IS FOR PET USER BECAUSE PET USER CAN ONLY MAKE CORPORATE BOOKING
                if (JSON.parse($cookies.get('adminType') || 0) == 1) {
                    vm.dataToFill.customerProfile = '1';
                } else {
                    vm.dataToFill.customerProfile = '0';
                }
            }
            //vm.dataToFill.contractIdSelected = '';
            vm.dataToFill.previousPickFlag = false;
            vm.dataToFill.previousDropFlag = false;
            vm.makePhoneEditAble = false;
            //vm.customerProfileOption = [
            //    {
            //        name: 'Personal',
            //        value: 0
            //    },
            //    {
            //        name: 'Corporate',
            //        value: 1
            //    }
            //]
            if (JSON.parse($cookies.get('adminType') || 0) == 0)
                getSpotAgreement();
            getCustomerFavouriteAddress();
            if (JSON.parse($cookies.get('adminType') || 0) == 1)
                profileChanges();
        };

        //====================== selecting particular PERSON=========================
        function onSelectingPerson() {
            vm.dataToFill.personName = vm.dataToFill.personSelected.name;
            vm.dataToFill.personEmail = vm.dataToFill.personSelected.email;
            vm.dataToFill.personMobile = vm.dataToFill.personSelected.phone_number;
            vm.dataToFill.passengerId = vm.dataToFill.personSelected.employee_id;
            vm.is_vip = vm.dataToFill.personSelected.is_vip ? true : false;

        };

        function changeVip() {
            if (vm.newPersonFlag || vm.dataToFill.personFromDb)
                vm.is_vip = !vm.is_vip;
        }
        //=========================booking for=================================
        function bookingFor(type) {
            //console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>', type, "type", vm.selectedEmployeeData);
            if (vm.dataToFill.bookingFor > -1)
                if (vm.dataToFill.bookingFor == 1) {
                    vm.dataToFill.otherBooking = true;
                    vm.newPersonFlag = false;
                    vm.dataToFill.passengerRut = '';
                    // vm.dataToFill.applicantRut = '';
                    // vm.dataToFill.costCenter = '';
                    // vm.dataToFill.costSubCenter = '';
                    // vm.dataToFill.Rol = '';
                    // vm.dataToFill.graph = '';
                    // vm.dataToFill.workOrder = '';
                    // vm.dataToFill.pep = '';
                } else {
                    vm.dataToFill.otherBooking = false;
                    vm.dataToFill.passengerRut = RutHelper.format(vm.selectedEmployeeData.employee_details.RUT);
                    vm.dataToFill.applicantRut = vm.dataToFill.applicantRut || RutHelper.format(vm.selectedEmployeeData.employee_details.RUT);
                    vm.dataToFill.costCenter = vm.dataToFill.costCenter || vm.selectedEmployeeData.employee_details.cost_center;
                    vm.dataToFill.costSubCenter = vm.dataToFill.costSubCenter || vm.selectedEmployeeData.employee_details.cost_subcenter;
                    vm.dataToFill.Rol = vm.dataToFill.Rol || vm.selectedEmployeeData.employee_details.ROI;
                    vm.dataToFill.graph = vm.dataToFill.graph || vm.selectedEmployeeData.employee_details.graph;
                    //vm.dataToFill.workOrder = vm.selectedEmployeeData.employee_details.order_of_work;
                    vm.dataToFill.pep = vm.dataToFill.pep || vm.selectedEmployeeData.employee_details.PEP;

                    // ******* FOR MODIFY BOOKING ********
                    if (vm.bookingDetails && vm.bookingDetails.passenger_rut)
                        vm.dataToFill.passengerRut = RutHelper.format(vm.bookingDetails.passenger_rut);
                    if (vm.bookingDetails && vm.bookingDetails.applicant_rut)
                        vm.dataToFill.applicantRut = RutHelper.format(vm.bookingDetails.applicant_rut);
                    if (vm.bookingDetails && vm.bookingDetails.cost_center)
                        vm.dataToFill.costCenter = vm.bookingDetails.cost_center;
                    if (vm.bookingDetails && vm.bookingDetails.sub_cost_center)
                        vm.dataToFill.costSubCenter = vm.bookingDetails.sub_cost_center;
                    if (vm.bookingDetails && vm.bookingDetails.rol)
                        vm.dataToFill.Rol = vm.bookingDetails.rol;
                    if (vm.bookingDetails && vm.bookingDetails.graph)
                        vm.dataToFill.graph = vm.bookingDetails.graph;
                    if (vm.bookingDetails && vm.bookingDetails.PEP)
                        vm.dataToFill.pep = vm.bookingDetails.PEP;

                }
        };

        function bookingType() {
            if (vm.dataToFill.bookingType == '0') {
                if (vm.dataToFill.serviceTypeSelected && vm.dataToFill.pickUpLat && vm.dataToFill.airportCheck != 'Z' && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2)) {
                    vm.dataToFill.nearDriver = '';
                    toGetNearByDrivers(vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.serviceTypeSelected, map);
                }
                vm.dataToFill.currentBooking = 1;
                vm.dataToFill.scheduledBooking = 0;
            } else if (vm.dataToFill.bookingType == '1') {
                vm.dataToFill.currentBooking = 0;
                vm.dataToFill.scheduledBooking = 1;
                $timeout(function () {
                    changeDateStringToLocalizePickUpDate();
                });
                vm.dataToFill.nearDriver = '';
            }

            if (markers) {
                for (var i = 0; i < markers.length; i++) {
                    if (markers[i].id == 'driver') {
                        setMapOnAll(null, 'driver');
                    }
                }
            }
            //get_cuota();
        };

        function changeDateStringToLocalizePickUpDate() {
            if (document.getElementById('datePickerPickup')) {
                var arrayOfDate = (document.getElementById('datePickerPickup').value).split('-');
                var mesChanged = calenderTranslate.getTranslatedText(arrayOfDate[1]);
                if( mesChanged == undefined){
                    //si retorna undefined entonces el texto ya se encuentra traducido
                    mesChanged = arrayOfDate[1];
                }
                document.getElementById('datePickerPickup').value = arrayOfDate[0] + '-' + mesChanged + '-' + arrayOfDate[2];
            }
        }

        function changeDateStringToLocalizeDropOffDate() {
            if (document.getElementById('datePickerReturnDate')) {
                var arrayOfDate = (document.getElementById('datePickerReturnDate').value).split('-');
                document.getElementById('datePickerReturnDate').value = arrayOfDate[0] + '-' + calenderTranslate.getTranslatedText(arrayOfDate[1]) + '-' + arrayOfDate[2];
            }
        }

        function changeDateStringToLocalizeTillDate() {
            if (document.getElementById('datePickerTillDate')) {
                var arrayOfDate = (document.getElementById('datePickerTillDate').value).split('-');
                document.getElementById('datePickerTillDate').value = arrayOfDate[0] + '-' + calenderTranslate.getTranslatedText(arrayOfDate[1]) + '-' + arrayOfDate[2];
            }
        }

        function returnDateChange() {
            vm.modifyFalgNew = false;
            vm.dataToFill.returnTime = dateTimeFormat(vm.dataToFill.returnDate, vm.dataToFill.returnTime);
            changeDateStringToLocalizeDropOffDate();
            if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip == 'P' && vm.dataToFill.roundTrip) {
                calculateDateRangeOfPointToPointReturn();
            }
            if (vm.dataToFill.dropOffAddress != null && vm.dataToFill.pickUpAddress && vm.dataToFill.roundTrip) {
                calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, map, 'ROUND TRIP', vm.searchFixedVariablePayload);
                // $scope.$apply();
            }
            setTimeout(function () {
                getFixedRoutesForPersonal(vm.dataToFill);
            }, 1500);
        }

        function tillDateChange($event) {
            changeDateStringToLocalizeTillDate();
            if (vm.type_of_trip1 == 'R' && vm.dataToFill.selectedServiceDetails.category == 1 && vm.method_range_pickup && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                checkAndMakeBookingData($event, true);
            }
        }

        function scheduleDateChanged() {
            vm.scheduleFlag = true;
            vm.dataToFill.scheduledTime = dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime);
            if (vm.modifyFalg == false) {
                vm.dataToFill.returnDate = vm.dataToFill.bookingType == '1' ? vm.dataToFill.scheduledDate : new Date();
                vm.dataToFill.returnTime = vm.dataToFill.bookingType == '1' ? vm.dataToFill.scheduledDate : new Date();
                vm.dataToFill.dropDateReturn = vm.dataToFill.bookingType == '1' && moment(vm.dataToFill.dropDateReturn) < moment(vm.dataToFill.scheduledDate) ? vm.dataToFill.scheduledDate : vm.dataToFill.dropDateReturn;
                vm.roundTripTImeLess = false;
            } else {
                vm.roundTripTImeLess = true;
            }
            vm.modifyFalgNew = false;
            vm.returnDateOptions.minDate = vm.dataToFill.bookingType == '1' ? vm.dataToFill.scheduledDate : new Date();
            if (vm.dataToFill.dropOffAddress != null && vm.dataToFill.pickUpAddress) {
                calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, map, 'SINGLE TRIP', vm.searchFixedVariablePayload);
                // $scope.$apply();
            }
            $timeout(function () {
                changeDateStringToLocalizePickUpDate();
            });
            if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking == 'R') {
                calculateEstimatePickUpTimeForRType(vm.dataToFill.etaScheduleValue);
            }
            setTimeout(function () {                                        
	            getFixedRoutesForPersonal(vm.dataToFill);
            }, 1000);
        }

        function dropDateChanged() {
            vm.dateFlag = true;
            vm.dataToFill.dropTime = dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime);
            if (vm.modifyFalg == false) {
                vm.dataToFill.returnDate = vm.dataToFill.dropDate;
                vm.dataToFill.returnTime = vm.dataToFill.dropDate;
                vm.roundTripTImeLess = false;
            } else {
                vm.roundTripTImeLess = true;
            }

            vm.returnDateOptions.minDate = vm.dataToFill.dropDate;
            //console.log(vm.dataToFill.dropDate, 'vm.dataToFill.dropDate');
            vm.modifyFalgNew = false;
            if (vm.dataToFill.dropOffAddress != null && vm.dataToFill.pickUpAddress) {
                calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, map, 'SINGLE TRIP', vm.searchFixedVariablePayload);
                // $scope.$apply();
            }
            if (((vm.type_of_trip1 == 'R' && vm.dataToFill.selectedServiceDetails.category == 1 && vm.method_range_pickup) || (vm.routingBase && vm.routingBase.routing_base_id > 0)) && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                vm.pickRangeSendForRouting = [];
                vm.etaArray = [];
                vm.timeZoneRecurring = [];
                vm.pickup_top_range = [];
                vm.pickup_lower_range = [];
                // RoutingApiFuncation(vm.dataToFill, 0);
            }
            setTimeout(function () {                                        
    	        getFixedRoutesForPersonal(vm.dataToFill);
            }, 1000);
        }

        function dropDateReturnChanged() {
            $timeout(function(){
            vm.dataToFill.dropTimeReturn = dateTimeFormat(vm.dataToFill.dropDateReturn, vm.dataToFill.dropTimeReturn);
            //console.log(vm.dataToFill.dropDate, 'vm.dataToFill.dropDate');
            vm.modifyFalgNew = false;
            if (vm.dataToFill.dropOffAddress != null && vm.dataToFill.pickUpAddress) {
                calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, map, 'ROUND TRIP', vm.searchFixedVariablePayload);
                // $scope.$apply();
            }
            if (vm.dataToFill.selectedServiceDetails.category == 1 && vm.type_of_trip == 'R' && vm.method_range_pickup_return && vm.dataToFill.roundTrip == 1) {
                RoutingApiFuncationRoundTrip(vm.dataToFill)
            }
            })
            setTimeout(function () {
                getFixedRoutesForPersonal(vm.dataToFill);
            }, 1500);
        }

        function scheduleTimeChanged() {
            // vm.dataToFill.scheduledTime = dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime);
            $log.log(vm.dataToFill.scheduledTime);
            if(vm.dataToFill.scheduledTime == null){
                return;
            }
            vm.modifyFalgNew = false;
            if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking == 'P') {
                setTimeout(function () {
                calculateDateRangeOfPointToPoint();
                }, 600);
            }
            if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking == 'R') {
                setTimeout(function () {
                calculateEstimatePickUpTimeForRType(vm.dataToFill.etaScheduleValue); 
                //calculateDateRangeOfPointToPoint(); 
                }, 600);
            }
            if (vm.type_of_trip1 != 'P' && vm.flagForFlightDate == true) {
                setTimeout(function () {
                compareDates();
                }, 600);
            }
            if (vm.dataToFill.dropOffAddress != null && vm.dataToFill.pickUpAddress) {
                setTimeout(function () {
                calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, map, 'SINGLE TRIP', vm.searchFixedVariablePayload);
                // $scope.$apply();
                }, 600);
            }
            setTimeout(function () {
                if(vm.dataToFill.selectedServiceDetails.category == 0 || (vm.dataToFill.selectedServiceDetails.category == 1 && vm.dataToFill.airportCheck == 'Z')){
	                getFixedRoutesForPersonal(vm.dataToFill);
    	        }
            }, 1000);
        };

        // function dropTimeChangedForRType() {
        //     calculateEstimatePickUpTimeForRType(vm.dataToFill.etaScheduleValue);
        // }

        function dropTimeChanged() {
            if(vm.dataToFill.scheduledTime == null){
                return;
            }
            vm.dateFlag = true;
            // compareDates();
            vm.modifyFalgNew = false;
            if (vm.type_of_trip1 != 'P' && vm.flagForFlightDate == true) {
                setTimeout(function () {
                compareDates();
                }, 600);
            }
            $log.log(vm.dataToFill.dropTime);
            vm.dataToFill.dropTime = vm.dataToFill.dropTime;
            // vm.dataToFill.dropTime = dateTimeFormat(vm.dataToFill.dropDate,vm.dataToFill.dropTime);
            if (vm.dataToFill.selectedServiceDetails.category == 1 && vm.dataToFill.etaScheduleValue){
                setTimeout(function () {
                calculateEstimatePickUpTime(vm.dataToFill.etaScheduleValue);
                }, 600);
            }
            if (vm.dataToFill.dropOffAddress != null && vm.dataToFill.pickUpAddress) {
                setTimeout(function () {
                calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, map, 'SINGLE TRIP', vm.searchFixedVariablePayload);
                }, 600);
                // $scope.$apply();
            }
            if (((vm.type_of_trip1 == 'R' && vm.dataToFill.selectedServiceDetails.category == 1 && vm.method_range_pickup) || (vm.routingBase && vm.routingBase.routing_base_id > 0)) && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                vm.pickRangeSendForRouting = [];
                vm.etaArray = [];
                vm.timeZoneRecurring = [];
                vm.pickup_lower_range = [];
                vm.pickup_top_range = [];
                // $timeout(function () {
                //     RoutingApiFuncation(vm.dataToFill, 0);
                // }, 500);

            }
            setTimeout(function () {
                if(vm.dataToFill.selectedServiceDetails.category == 0 || (vm.dataToFill.selectedServiceDetails.category == 1 && vm.dataToFill.airportCheck == 'Z')){
	                getFixedRoutesForPersonal(vm.dataToFill);
    	        }
            }, 1000);
        };

        function dropTimeReturnChanged() {
            vm.modifyFalgNew = false;
            // vm.dataToFill.dropTimeReturn = dateTimeFormat(vm.dataToFill.dropDateReturn ,vm.dataToFill.dropTimeReturn);
            // console.log(vm.dataToFill.dropTimeReturn,'vm.dataToFill.dropTimeReturn');
            if (vm.dataToFill.selectedServiceDetails.category == 1 && vm.dataToFill.etaScheduleValueReturn)
                calculateEstimatePickUpTime(vm.dataToFill.etaScheduleValueReturn);
            if (vm.dataToFill.dropOffAddress != null && vm.dataToFill.pickUpAddress) {
                calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, map, 'ROUND TRIP', vm.searchFixedVariablePayload);
                // $scope.$apply();
            }
            if (vm.dataToFill.selectedServiceDetails.category == 1 && vm.type_of_trip == 'R' && vm.method_range_pickup_return && vm.dataToFill.roundTrip == 1) {
                $timeout(function () {
                    RoutingApiFuncationRoundTrip(vm.dataToFill)
                }, 500);
            }
            setTimeout(function () {
                getFixedRoutesForPersonal(vm.dataToFill);
            }, 1500);

        };

        function retunrTimeChanged() {
            vm.modifyFalgNew = false;
            $log.log(vm.dataToFill.returnTime);
            if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip == 'P' && vm.dataToFill.roundTrip) {
                calculateDateRangeOfPointToPointReturn();
            }
            if (vm.dataToFill.dropOffAddress != null && vm.dataToFill.pickUpAddress && vm.dataToFill.roundTrip) {
                calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, map, 'ROUND TRIP', vm.searchFixedVariablePayload);
                // $scope.$apply();
            }
            // vm.dataToFill.returnTime = dateTimeFormat(vm.dataToFill.returnDate,vm.dataToFill.returnTime);
            getFixedRoutesForPersonal(vm.dataToFill);
        };

        function tillTimes() {
            $log.log('Time', vm.dataToFill.tillTime);
        };
        //==================date picker function==================
        vm.dateOptions = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(2090, 12, 31),
            minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };
        vm.returnDateOptions = {
            formatYear: 'yy',
            maxDate: new Date(2090, 12, 31),
            minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };

        function datePickerE_1(type) {
            if (type == '1') {
                vm.datePicker_1.scheduledDate = true;
            } else if (type == '2') {
                vm.datePicker_1.returnDate = true;
            } else if (type == '3') {
                vm.datePicker_1.dropDate = true;
            } else if (type == '4') {
                vm.datePicker_1.dropDateReturn = true;
            }
            $timeout(function () {
                calenderTranslateFunction();
            }, 100);
        };

        function calenderTranslateFunction() {

            // TO CHANGE TITLE 
            if (document.getElementsByClassName('uib-title')[0])
                if (document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ').length == 2) {
                    document.getElementsByClassName('uib-title')[0].firstChild.style.display = 'none';
                    var span = document.createElement("span");
                    span.setAttribute('class', 'spanishMonth');
                    if( calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[0]) == undefined && document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[0] != undefined){
                        span.innerHTML = document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[0] + ' ' + document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[1];
                    } else {
                        span.innerHTML = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[0]) + ' ' + document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[1];
                    }
                    document.getElementsByClassName('uib-title')[0].appendChild(span);
                    // document.getElementsByClassName('uib-title')[0].firstChild.innerText = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[0]) + ' ' + document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[1];
                    // TO CHANGE DAYS OF WEEK
                    var primerDia = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-datepicker')[0].firstElementChild.firstElementChild.lastElementChild.cells[0].innerText);
                    if( primerDia != undefined ){
                        document.getElementsByClassName('uib-datepicker')[0].firstElementChild.firstElementChild.lastElementChild.cells[0].innerText = primerDia;
                    }
                    var segundoDia = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-datepicker')[0].firstElementChild.firstElementChild.lastElementChild.cells[1].innerText);
                    if( segundoDia != undefined ){
                        document.getElementsByClassName('uib-datepicker')[0].firstElementChild.firstElementChild.lastElementChild.cells[1].innerText = segundoDia;
                    }
                    var tercerDia = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-datepicker')[0].firstElementChild.firstElementChild.lastElementChild.cells[2].innerText);
                    if( tercerDia != undefined ){
                        document.getElementsByClassName('uib-datepicker')[0].firstElementChild.firstElementChild.lastElementChild.cells[2].innerText = tercerDia;
                    }
                    var cuartoDia = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-datepicker')[0].firstElementChild.firstElementChild.lastElementChild.cells[3].innerText);
                    if(cuartoDia != undefined){
                        document.getElementsByClassName('uib-datepicker')[0].firstElementChild.firstElementChild.lastElementChild.cells[3].innerText = cuartoDia;
                    }
                    var quintoDia = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-datepicker')[0].firstElementChild.firstElementChild.lastElementChild.cells[4].innerText);
                    if( quintoDia != undefined){
                        document.getElementsByClassName('uib-datepicker')[0].firstElementChild.firstElementChild.lastElementChild.cells[4].innerText = quintoDia;
                    }
                    var sextoDia = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-datepicker')[0].firstElementChild.firstElementChild.lastElementChild.cells[5].innerText);
                    if( sextoDia != undefined){
                        document.getElementsByClassName('uib-datepicker')[0].firstElementChild.firstElementChild.lastElementChild.cells[5].innerText = sextoDia;
                    }
                    var septimoDia = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-datepicker')[0].firstElementChild.firstElementChild.lastElementChild.cells[6].innerText);
                    if( septimoDia != undefined ){
                        document.getElementsByClassName('uib-datepicker')[0].firstElementChild.firstElementChild.lastElementChild.cells[6].innerText = septimoDia;
                    }
                }

            // TO CLICK ON MONTH TO CHANGE MONTH
            document.getElementsByClassName('uib-title')[0].onclick = function () {
                $timeout(function () {
                    changeMonthText();

                    // FOR YEAR VIEW
                    document.getElementsByClassName('uib-title')[0].onclick = function () {
                        $timeout(function () {
                            // FOR RIGHT CLICK
                            document.getElementsByClassName('uib-right')[0].onclick = function () {
                                $timeout(function () {
                                    calenderTranslateFunction();
                                });
                            }
                            // FOR LEFT CLICK
                            document.getElementsByClassName('uib-left')[0].onclick = function () {
                                $timeout(function () {
                                    calenderTranslateFunction();
                                });
                            }

                            // FOR CLICK ON YEAR VIEW
                            if (document.getElementsByClassName('uib-yearpicker')[0])
                                document.getElementsByClassName('uib-yearpicker')[0].lastElementChild.onclick = function () {
                                    $timeout(function () {
                                        calenderTranslateFunction();
                                        changeMonthText();
                                    });
                                }
                        });
                    }
                    // FOR RIGHT CLICK
                    document.getElementsByClassName('uib-right')[0].onclick = function () {
                        $timeout(function () {
                            calenderTranslateFunction();
                            changeMonthText();
                        });
                    }
                    // FOR LEFT CLICK
                    document.getElementsByClassName('uib-left')[0].onclick = function () {
                        $timeout(function () {
                            calenderTranslateFunction();
                            changeMonthText();
                        });
                    }

                    // FOR CLICK ON MONTH VIEW
                    document.getElementsByClassName('uib-monthpicker')[0].lastElementChild.onclick = function () {
                        $timeout(function () {
                            calenderTranslateFunction();
                        });
                    }
                });
            }
            // FOR CLICK ON MONTH VIEW DEFAULT AFTER YEAR VIEW
            if (document.getElementsByClassName('uib-monthpicker')[0])
                document.getElementsByClassName('uib-monthpicker')[0].lastElementChild.onclick = function () {
                    $timeout(function () {
                        calenderTranslateFunction();
                    });
                }
            // FOR RIGHT CLICK
            document.getElementsByClassName('uib-right')[0].onclick = function () {
                if (document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ').length == 2) {
                    document.getElementsByClassName('uib-title')[0].firstChild.style.display = 'none';
                    if (document.getElementsByClassName('spanishMonth').length) {
                        document.getElementsByClassName('spanishMonth')[0].remove();
                    }
                    var span = document.createElement("span");
                    span.setAttribute('class', 'spanishMonth');
                    //correccion de fix cuando la reserva se repite y es necesario cambiar la fecha
                    if( document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[0] != undefined && calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[0]) == undefined){
                        span.innerHTML = document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[0] + ' ' + document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[1];
                        document.getElementsByClassName('uib-title')[0].appendChild(span);
                    } else {
                        span.innerHTML = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[0]) + ' ' + document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[1];
                        document.getElementsByClassName('uib-title')[0].appendChild(span);
                    }
                } else {
                    $timeout(function () {
                        calenderTranslateFunction();
                        changeMonthText();
                    });
                }
            }

            // FOR LEFT CLICK
            document.getElementsByClassName('uib-left')[0].onclick = function () {
                if (document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ').length == 2) {
                    document.getElementsByClassName('uib-title')[0].firstChild.style.display = 'none';
                    if (document.getElementsByClassName('spanishMonth').length) {
                        document.getElementsByClassName('spanishMonth')[0].remove();
                    }
                    var span = document.createElement("span");
                    span.setAttribute('class', 'spanishMonth');
                    //correccion de fix cuando la reserva se repite y es necesario cambiar la fecha
                    if( document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[0] != undefined && calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[0]) == undefined){
                        span.innerHTML = document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[0] + ' ' + document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[1];
                    } else {
                        span.innerHTML = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[0]) + ' ' + document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[1];
                    }
                    document.getElementsByClassName('uib-title')[0].appendChild(span);
                    // document.getElementsByClassName('uib-title')[0].firstChild.innerText = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[0]) + ' ' + document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[1];
                } else {
                    $timeout(function () {
                        calenderTranslateFunction();
                        changeMonthText();
                    });
                }
            }
        }

        // FOR CHANGE MONTHS
        function changeMonthText() {
            document.getElementsByClassName('uib-month')[0].firstElementChild.innerText = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-month')[0].firstElementChild.innerText);
            document.getElementsByClassName('uib-month')[1].firstElementChild.innerText = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-month')[1].firstElementChild.innerText);
            document.getElementsByClassName('uib-month')[2].firstElementChild.innerText = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-month')[2].firstElementChild.innerText);
            document.getElementsByClassName('uib-month')[3].firstElementChild.innerText = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-month')[3].firstElementChild.innerText);
            document.getElementsByClassName('uib-month')[4].firstElementChild.innerText = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-month')[4].firstElementChild.innerText);
            document.getElementsByClassName('uib-month')[5].firstElementChild.innerText = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-month')[5].firstElementChild.innerText);
            document.getElementsByClassName('uib-month')[6].firstElementChild.innerText = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-month')[6].firstElementChild.innerText);
            document.getElementsByClassName('uib-month')[7].firstElementChild.innerText = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-month')[7].firstElementChild.innerText);
            document.getElementsByClassName('uib-month')[8].firstElementChild.innerText = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-month')[8].firstElementChild.innerText);
            document.getElementsByClassName('uib-month')[9].firstElementChild.innerText = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-month')[9].firstElementChild.innerText);
            document.getElementsByClassName('uib-month')[10].firstElementChild.innerText = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-month')[10].firstElementChild.innerText);
            document.getElementsByClassName('uib-month')[11].firstElementChild.innerText = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-month')[11].firstElementChild.innerText);
        }

        vm.dateOption = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(2090, 12, 31),
            minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };

        function datePickerE_2(type) {
            if (type == '1') {
                vm.datePicker_2.tillDate = true;
                $timeout(function () {
                    calenderTranslateFunction();
                }, 100);
            }
            //console.log('date', vm.dataToFill.tillDate)
        };
        //================set map nulll======================
        function setMapOnAll(map, id) {
            for (var i = 0; i < markers.length; i++) {
                if (markers[i].id == id) {
                    var marker = markers[i];
                    marker.setMap(map);
                }
            }
        };
        // If the map position is out of range, move it back
        function checkBounds(map) {
            if (typeof (map.getBounds()) == 'undefined')
                return;

            var latNorth = map.getBounds().getNorthEast().lat();
            var latSouth = map.getBounds().getSouthWest().lat();
            var newLat;

            if (latNorth < 85 && latSouth > -85) /* in both side -> it's ok */
                return;
            else {
                if (latNorth > 85 && latSouth < -85) /* out both side -> it's ok */
                    return;
                else {
                    if (latNorth > 85)
                        newLat = map.getCenter().lat() - (latNorth - 85);
                    /* too north, centering */
                    if (latSouth < -85)
                        newLat = map.getCenter().lat() - (latSouth + 85);
                    /* too south, centering */
                }
            }
            if (newLat) {
                var newCenter = new google.maps.LatLng(newLat, map.getCenter().lng());
                map.setCenter(newCenter);
            }
        }
        //===========================auto complete===============================
        var autocomplete, autocompleteD;
        var domain = checkDomain.getDomainName();

        function pickUpaddressBlack(data) {
            if (data == undefined) {
                $(".pac-container").hide();
            }
        }

        function dropOfdAddressBlack(data) {
            if (data == undefined) {
                $(".pac-container").hide();
            }
        }

        function PickUpAddressLength(data) {
            if (data == undefined) {
                $(".pac-container").hide();
            }
            vm.addressChange = true;
            initAutocomplete(data, '');
            //getSuggestion(data, '');
        }

        function DropUpAddressLength(data) {
            if (data == undefined) {
                $(".pac-container").hide();
            }
            vm.addressChange = true;
            initAutocomplete('', data)
            //getSuggestion('', data);
        }

        function getSuggestion(Pickdata, DropData){
            if ((Pickdata && Pickdata.length >= 3) || ((!vm.dropAddressFlag) && DropData && DropData.length >= 3)) {
                var dataSend = {}
                dataSend.at = '-33.4724228,-70.7699137';
                dataSend.channel = 1;
                vm.dataToFill.previousDropFlag = false;
                vm.dataToFill.previousPickFlag = false;
                if (Pickdata && Pickdata.length > 3)
                    dataSend.query_string = Pickdata;
                else dataSend.query_string = DropData;
                dataSend.user_id = vm.dataToFill.customerEmail;
                var promise = getBookingsHereMaps.autoSuggestAconcagua(dataSend);
                promise.then(
                    function (response) {
                        vm.loading = false;
                        console.log(response)
                        var obj = JSON.parse(response.response);
                        if(response.status == 200){
                            vm.addressPickUpArray = [];
                            vm.addressDropArray = [];
                            if(obj.items && obj.items.length > 0 ){
                                //obj.data.forEach(function (data) {
                                for(i=0;i<obj.items.length; i++){
                                    var data = obj.items[i];
                                    data.type = 1; //0 local, 1 heremaps
                                    if (Pickdata && Pickdata.length > 3) {
                                        vm.addressPickUpArray.push({
                                            label: data.title,
                                            id_origin: data.id,
                                        })
                                    } else{
                                        vm.addressDropArray.push({
                                            label: data.title,
                                            id_origin: data.id,
                                        })

                                    }
                                //})
                                }
                                $scope.$apply();
                            }
                        } else {
                            vm.addressPickUpArray = [];
                            vm.addressDropArray = [];
                            $log.log(obj.details);
                            errorMessageFactory.showErrorMessage("Error al obtener los datos", 0);
                        }
                    }, 
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                    }
                );
            } else if ((Pickdata == undefined || (Pickdata && Pickdata.length < 3)) || (DropData == undefined || (DropData && DropData.length < 3))) {
                vm.addressDropArray = [];
                vm.addressPickUpArray = [];
            }
        }

        function initAutocomplete(Pickdata, DropData) {
            //console.log(Pickdata, DropData, 'Pickdata, DropData');
            var pickup = document.getElementById('pickUpAddress');
            var dropAddresss = document.getElementById('dropOffAddress');
            if ((Pickdata && Pickdata.length >= 3) || ((!vm.dropAddressFlag) && DropData && DropData.length >= 3)) {
                // TDM-35
                var dataSend = {}
                //lat/log santiago
                dataSend.latitud = '-33.4724228';
                dataSend.longitud = '-70.7699137';
                vm.dataToFill.previousDropFlag = false;
                vm.dataToFill.previousPickFlag = false;
                if (Pickdata && Pickdata.length > 3)
                    dataSend.query = Pickdata;
                else dataSend.query = DropData;
                //var promise = getBookingsHereMaps.autoCompleteHereMaps(dataSend);
                var promise = getBookingsHereMaps.autoSuggestHereMaps(dataSend);
                promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        if (payload.title.success) {
                            vm.addressPickUpArray = [];
                            vm.addressDropArray = [];
                            if(payload.title && payload.title.data.local && payload.title.data.local.length > 0){
                                if (Pickdata && Pickdata.length > 3) {
                                    payload.title.data.local.forEach(function (data) {
                                        data.type = 0; //0 local, 1 heremaps
                                        vm.addressPickUpArray.push({
                                            label: data.full_address,
                                            type: data.type,
                                            latitude: data.latitude,
                                            longitude: data.longitude
                                        })
                                    })
                                } else{
                                    payload.title.data.local.forEach(function (data) {
                                        data.type = 0; //0 local, 1 heremaps
                                        vm.addressDropArray.push({
                                            label: data.full_address,
                                            type: data.type,
                                            latitude: data.latitude,
                                            longitude: data.longitude
                                        })
                                    })
                                }
                            } 
                            if (payload.title && payload.title.data.here && payload.title.data.here.length > 0) {
                                if (Pickdata && Pickdata.length > 3) {
                                    vm.addressDropArray = [];
                                    payload.title.data.here.forEach(function (data) {
                                        data.type = 1; //0 local, 1 heremaps
                                        vm.addressPickUpArray.push({
                                            label: data.address.label,
                                            type: data.type,
                                            latitude: data.position.lat,
                                            longitude: data.position.lng,
                                            locationId: data.id
                                        })
                                    })
                                } else {
                                    vm.addressPickUpArray = [];
                                    payload.title.data.here.forEach(function (data) {
                                        data.type = 1; //0 local, 1 heremaps
                                        vm.addressDropArray.push({
                                            label: data.address.label,
                                            type: data.type,
                                            latitude: data.position.lat,
                                            longitude: data.position.lng
                                        })
                                    })
                                    // vm.addressDropArray = payload.title.data;
                                }
                            } else {
                                if (DropData && DropData.length > 3) {
                                    vm.addressDropArray = [];
                                    // $scope.$apply();
                                } else {
                                    vm.addressPickUpArray = [];
                                    // $scope.$apply();
                                }
                            }
                        } else {
                            vm.addressPickUpArray = [];
                            vm.addressDropArray = [];
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            } else if ((Pickdata == undefined || (Pickdata && Pickdata.length < 3)) || (DropData == undefined || (DropData && DropData.length < 3))) {
                // vm.pickAddressFlag = false;
                // google.maps.event.clearInstanceListeners(pickup);
                // $(".pac-container").hide();
                vm.addressDropArray = [];
                vm.addressPickUpArray = [];
            }

            // else if (Pickdata && Pickdata.length < 3) {
            //     // vm.pickAddressFlag = false;
            //     vm.addressPickUpArray = [];
            //     // google.maps.event.clearInstanceListeners(pickup);
            //     // $(".pac-container").hide();
            // }
            console.log('>>>>> IN INIT >>>>>', vm.dropAddressFlag, DropData);
            // if ((!vm.dropAddressFlag) && DropData && DropData.length >= 3) {
            //     vm.dropAddressFlag = true;
            //     //console.log(DropData.length, 'length');
            //     autocompleteD = new google.maps.places.Autocomplete(
            //         dropAddresss, {
            //             placeIdOnly: true
            //         });
            //     if (domain != 'dev' && domain != 'test')
            //         autocompleteD.setComponentRestrictions({
            //             'country': ['CL']
            //         });
            //     autocompleteD.addListener('place_changed', fillInAddressD);

            // } else if (DropData && DropData.length < 3) {
            //     vm.dropAddressFlag = false;
            //     google.maps.event.clearInstanceListeners(dropAddresss);
            //     $(".pac-container").hide();
            // }

        };


        //function getFormattedAddress(place){
        //    var street,route,city,formattedAddress;
        //
        //    for(var i=0;i<place.address_components.length;i++){
        //        for(var j=0;j<place.address_components[i].types.length;j++){
        //            if(place.address_components[i].types[j] == 'street_number'){
        //                street = place.address_components[i].short_name;
        //            }
        //            if(place.address_components[i].types[j] == 'route'){
        //                route = place.address_components[i].short_name;
        //            }
        //            if(place.address_components[i].types[j] == 'locality'){
        //                city = place.address_components[i].short_name;
        //            }
        //        }
        //    }
        //
        //    //var formattedAddress = place.formatted_address;
        //    if(street){
        //        if(route){
        //            if(city){
        //                formattedAddress = route + ' ' + street + ', ' + city;
        //            }
        //            else{
        //                formattedAddress = route + ' ' + street;
        //            }
        //        }
        //        else{
        //            if(city){
        //                formattedAddress = street + ', ' + city;
        //            }
        //            else{
        //                formattedAddress = street;
        //            }
        //        }
        //    }
        //    else{
        //        if(route){
        //            if(city){
        //                formattedAddress = route + ', ' + city;
        //            }
        //            else{
        //                formattedAddress = route;
        //            }
        //        }
        //        else{
        //            if(city){
        //                formattedAddress = city;
        //            }
        //            else{
        //                formattedAddress = '';
        //            }
        //        }
        //    }
        //    return formattedAddress;
        //}

        function fillInAddress(data) {
            // $(".pac-container").hide();
            // // Get the place details from the autocomplete object.

            // var place = autocomplete.getPlace();
            // geocoder.geocode({
            //     'placeId': place.place_id
            // }, function (results, status) {
            //     //console.log(results, status, "geocode ----------------")
            //     //console.log(results[0].geometry.location.lat(), results[0].geometry.location.lng(), 'results[0].geometry.location.lat()');

            //     if (status !== 'OK') {
            //         window.alert('Geocoder failed due to: ' + status);
            //         return;
            //     }
            //     var city;
            //     for (var i = 0; i < results[0].address_components.length; i++) {
            //         for (var j = 0; j < results[0].address_components[i].types.length; j++) {
            //             if (results[0].address_components[i].types[j] == 'locality') {
            //                 city = results[0].address_components[i].short_name;
            //             }
            //         }
            //     }

            //     if (vm.pickUpCity && (vm.pickUpCity != city)) {
            //         errorMessageFactory.showErrorMessage('Error, esta dirección cambia el tramo original. El cambio no debe afectar la tarifa.', 0);
            //         // results= '';
            //         vm.dataToFill.pickUpAddress = vm.pickUpAddress;
            //         vm.addressChange = false;
            //         return;
            //     }
            //     $scope.addressPick = hidePublicPlaces.formattedAddress(results[0]);
            //     $scope.addressLat = results[0].geometry.location.lat();
            //     $scope.addressLng = results[0].geometry.location.lng();
            //     var string = results[0].formatted_address;
            //     var address = string.replace(", Chile", " ");
            //     vm.dataToFill.pickUpAddress = address;
            //     vm.dataToFill.pickUpLat = $scope.addressLat;
            //     vm.dataToFill.pickUpLng = $scope.addressLng;
            //     vm.dataToFill.pickLat = $scope.addressLat;
            //     vm.dataToFill.pickLng = $scope.addressLng;
            //     vm.dataToFill.previousPickFlag = false;
            //     vm.pickaddressChange = true;
            //     vm.dataToFill.previousDropFlag = false;
            //     getFavoriteAddress('pick');
            //     // ********** TO GET CITY OF ADDRESS **********
            //     results[0].address_components.forEach(function (data) {
            //         if (data.types[0] == 'locality') {
            //             vm.jobPickupComuna = data.long_name || null;
            //         }
            //     });

            //     $scope.$apply();
            //     vm.getFixedRoutesForPersonalFlag = true;
            //     var location = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
            //     //zoomLevel = 12;
            //     // $timeout(function () {
            //     //     placeMarker(map, location, 'pick');
            //     // }, 2000);
            //     if (vm.toAirportFlag) {
            //         getAirportAddressApi();
            //     }
            //     if (vm.ptopAirportFlag && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
            //         getFixedRoutesForPersonal(vm.dataToFill);
            //     }
            //     if (vm.dataToFill.serviceTypeSelected) { //&& (vm.dataToFill.bookingType == '0' || vm.dataToFill.bookingType == 0)
            //         vm.dataToFill.nearDriver = '';
            //         toGetAirportService(results[0].geometry.location.lat(), results[0].geometry.location.lng(), vm.dataToFill.serviceTypeSelected, map);
            //         //toGetNearByDrivers(vm.dataToFill.pickUpLat,vm.dataToFill.pickUpLng,vm.dataToFill.serviceTypeSelected,map);
            //     }
            // });
            //if (data.type == 0) { // for local DB Address type = 0 For typ = 1 for heremaps
                vm.addressPickUpArray = [];
                var dataSend = {};
                dataSend.latitude = data.latitude;
                dataSend.longitude = data.longitude;
                vm.dataToFill.pickUpAddress = data.label;
                // vm.loading = true;
                var promise = getBookingsHereMaps.reverseGeocoding(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        var response = payload.title.data;
                        if (response.items.length > 0) {
                            var city;
                            city = response.items[0].address.city;
                            if (vm.pickUpCity && (vm.pickUpCity != city)) {
                                errorMessageFactory.showErrorMessage('Error, esta dirección cambia el tramo original. El cambio no debe afectar la tarifa.', 0);
                                // results= '';
                                vm.dataToFill.pickUpAddress = vm.pickUpAddress;
                                vm.addressChange = false;
                                return;
                            }
                            $scope.addressPick = vm.dataToFill.pickUpAddress;
                            // $scope.addressLat = data.latitude;
                            // $scope.addressLng = data.longitude;
                            if( data.latitude == '-33.391800' && data.longitude == '-70.79269' ){
                                $scope.addressLat = data.latitude;
                                $scope.addressLng = data.longitude;
                            } else {
                                $scope.addressLat = response.items[0].position.lat;
                                $scope.addressLng = response.items[0].position.lng;
                            }
                            // var string = response.Response.View[0].Result[0].Location.Address.Label;
                            // var address = string.replace(", Chile", " ");
                            // vm.dataToFill.pickUpAddress = vm.addressHave;
                            vm.dataToFill.pickUpLat = $scope.addressLat;
                            vm.dataToFill.pickUpLng = $scope.addressLng;
                            vm.dataToFill.pickLat = $scope.addressLat;
                            vm.dataToFill.pickLng = $scope.addressLng;
                            vm.dataToFill.previousPickFlag = false;
                            vm.pickaddressChange = true;
                            vm.dataToFill.previousDropFlag = false;
                            getFavoriteAddress('pick');
                            // ********** TO GET CITY OF ADDRESS **********
                            vm.jobPickupComuna = response.items[0].address.city;
                            if(!$scope.$$phase) {
                                $scope.$apply();
                            }
                            vm.getFixedRoutesForPersonalFlag = true;
                            var location = new google.maps.LatLng(data.latitude, data.longtitude);
                            if (vm.toAirportFlag) {
                                getAirportAddressApi();
                            }
                            if (vm.ptopAirportFlag && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                                getFixedRoutesForPersonal(vm.dataToFill);
                            }
                            if (vm.dataToFill.serviceTypeSelected) { //&& (vm.dataToFill.bookingType == '0' || vm.dataToFill.bookingType == 0)
                                vm.dataToFill.nearDriver = '';
                                toGetAirportService(response.items[0].position.lat, response.items[0].position.lng, vm.dataToFill.serviceTypeSelected, map);
                            }
                            var location = new google.maps.LatLng(Number($scope.addressLat), Number($scope.addressLng));
                            $timeout(function () {
                                placeMarker(map, location, 'pick');
                            }, 2000);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                    }
                );
            //} else {
                //vm.addressPickUpArray = [];
                //var dataSend = {};
                //vm.dataToFill.pickUpAddress = data.label;
                //dataSend.searchtext = encodeURI(data.label);
                //// vm.loading = true;
                //var promise = getBookingsHereMaps.gecodeApiNewText(dataSend);
                //promise.then(
                    //function (payload) {
                        //$log.log(payload);
                        //vm.loading = false;
                        //var response = JSON.parse(payload.response);
                        //if (response.Response.View.length > 0) {
                            //var city;
                            //city = response.Response.View[0].Result[0].Location.Address.City;
                            //if (vm.pickUpCity && (vm.pickUpCity != city)) {
                                //errorMessageFactory.showErrorMessage('Error, esta dirección cambia el tramo original. El cambio no debe afectar la tarifa.', 0);
                                //// results= '';
                                //vm.dataToFill.pickUpAddress = vm.pickUpAddress;
                                //vm.addressChange = false;
                                //return;
                            //}
                            //$scope.addressPick = vm.dataToFill.pickUpAddress;
                            //$scope.addressLat = response.Response.View[0].Result[0].Location.DisplayPosition.Latitude;
                            //$scope.addressLng = response.Response.View[0].Result[0].Location.DisplayPosition.Longitude;
                            //// var string = response.Response.View[0].Result[0].Location.Address.Label;
                            //// var address = string.replace(", Chile", " ");
                            //// vm.dataToFill.pickUpAddress = vm.addressHave;
                            //vm.dataToFill.pickUpLat = $scope.addressLat;
                            //vm.dataToFill.pickUpLng = $scope.addressLng;
                            //vm.dataToFill.pickLat = $scope.addressLat;
                            //vm.dataToFill.pickLng = $scope.addressLng;
                            //vm.dataToFill.previousPickFlag = false;
                            //vm.pickaddressChange = true;
                            //vm.dataToFill.previousDropFlag = false;
                            //getFavoriteAddress('pick');
                            //// ********** TO GET CITY OF ADDRESS **********
                            //vm.jobPickupComuna = response.Response.View[0].Result[0].Location.Address.City;
                            //$scope.$apply();
                            //vm.getFixedRoutesForPersonalFlag = true;
                            //var location = new google.maps.LatLng(response.Response.View[0].Result[0].Location.DisplayPosition.Latitude, response.Response.View[0].Result[0].Location.DisplayPosition.Longitude);
                            //if (vm.toAirportFlag) {
                                //getAirportAddressApi();
                            //}
                            //if (vm.ptopAirportFlag && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                                //getFixedRoutesForPersonal(vm.dataToFill);
                            //}
                            //if (vm.dataToFill.serviceTypeSelected) { //&& (vm.dataToFill.bookingType == '0' || vm.dataToFill.bookingType == 0)
                                //vm.dataToFill.nearDriver = '';
                                //toGetAirportService(response.Response.View[0].Result[0].Location.DisplayPosition.Latitude, response.Response.View[0].Result[0].Location.DisplayPosition.Longitude, vm.dataToFill.serviceTypeSelected, map);
                            //}
                            //var location = new google.maps.LatLng(Number($scope.addressLat), Number($scope.addressLng));
                            //$timeout(function () {
                                //placeMarker(map, location, 'pick');
                            //}, 2000);
                        //}
                    //},
                    //function (errorPayload) {
                        //$log.log(errorPayload);
                        //vm.loading = false;
                    //}
                //);
            //}
        };

        function fillInAddressOld(data) {
            // $(".pac-container").hide();
            // // Get the place details from the autocomplete object.

            // var place = autocomplete.getPlace();
            // geocoder.geocode({
            //     'placeId': place.place_id
            // }, function (results, status) {
            //     //console.log(results, status, "geocode ----------------")
            //     //console.log(results[0].geometry.location.lat(), results[0].geometry.location.lng(), 'results[0].geometry.location.lat()');

            //     if (status !== 'OK') {
            //         window.alert('Geocoder failed due to: ' + status);
            //         return;
            //     }
            //     var city;
            //     for (var i = 0; i < results[0].address_components.length; i++) {
            //         for (var j = 0; j < results[0].address_components[i].types.length; j++) {
            //             if (results[0].address_components[i].types[j] == 'locality') {
            //                 city = results[0].address_components[i].short_name;
            //             }
            //         }
            //     }

            //     if (vm.pickUpCity && (vm.pickUpCity != city)) {
            //         errorMessageFactory.showErrorMessage('Error, esta dirección cambia el tramo original. El cambio no debe afectar la tarifa.', 0);
            //         // results= '';
            //         vm.dataToFill.pickUpAddress = vm.pickUpAddress;
            //         vm.addressChange = false;
            //         return;
            //     }
            //     $scope.addressPick = hidePublicPlaces.formattedAddress(results[0]);
            //     $scope.addressLat = results[0].geometry.location.lat();
            //     $scope.addressLng = results[0].geometry.location.lng();
            //     var string = results[0].formatted_address;
            //     var address = string.replace(", Chile", " ");
            //     vm.dataToFill.pickUpAddress = address;
            //     vm.dataToFill.pickUpLat = $scope.addressLat;
            //     vm.dataToFill.pickUpLng = $scope.addressLng;
            //     vm.dataToFill.pickLat = $scope.addressLat;
            //     vm.dataToFill.pickLng = $scope.addressLng;
            //     vm.dataToFill.previousPickFlag = false;
            //     vm.pickaddressChange = true;
            //     vm.dataToFill.previousDropFlag = false;
            //     getFavoriteAddress('pick');
            //     // ********** TO GET CITY OF ADDRESS **********
            //     results[0].address_components.forEach(function (data) {
            //         if (data.types[0] == 'locality') {
            //             vm.jobPickupComuna = data.long_name || null;
            //         }
            //     });

            //     $scope.$apply();
            //     vm.getFixedRoutesForPersonalFlag = true;
            //     var location = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
            //     //zoomLevel = 12;
            //     // $timeout(function () {
            //     //     placeMarker(map, location, 'pick');
            //     // }, 2000);
            //     if (vm.toAirportFlag) {
            //         getAirportAddressApi();
            //     }
            //     if (vm.ptopAirportFlag && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
            //         getFixedRoutesForPersonal(vm.dataToFill);
            //     }
            //     if (vm.dataToFill.serviceTypeSelected) { //&& (vm.dataToFill.bookingType == '0' || vm.dataToFill.bookingType == 0)
            //         vm.dataToFill.nearDriver = '';
            //         toGetAirportService(results[0].geometry.location.lat(), results[0].geometry.location.lng(), vm.dataToFill.serviceTypeSelected, map);
            //         //toGetNearByDrivers(vm.dataToFill.pickUpLat,vm.dataToFill.pickUpLng,vm.dataToFill.serviceTypeSelected,map);
            //     }
            // });
            //if (data.type == 0) { // for local DB Address type = 0 For typ = 1 for heremaps
                vm.addressPickUpArray = [];
                var dataSend = {};
                dataSend.channel = 1;
                dataSend.label = data.label;
                dataSend.origin = data.origin;
                dataSend.id_origin = data.id_origin;
                dataSend.user_id = vm.dataToFill.customerEmail;
                vm.dataToFill.pickUpAddress = data.label;
                var promise = getBookingsHereMaps.autoSuggestDetailsAconcagua(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        var response = JSON.parse(payload.response);
                        if (response) {
                            var salida = response;
                            var city;
                            city = salida.county;
                            if (vm.pickUpCity && (vm.pickUpCity != city)) {
                                errorMessageFactory.showErrorMessage('Error, esta dirección cambia el tramo original. El cambio no debe afectar la tarifa.', 0);
                                // results= '';
                                vm.dataToFill.pickUpAddress = vm.pickUpAddress;
                                vm.addressChange = false;
                                return;
                            }
                            $scope.addressPick = vm.dataToFill.pickUpAddress;
                            // $scope.addressLat = data.latitude;
                            // $scope.addressLng = data.longitude;
                            $scope.addressLat = salida.position.lat;
                            $scope.addressLng = salida.position.lng;
                            // var string = response.Response.View[0].Result[0].Location.Address.Label;
                            // var address = string.replace(", Chile", " ");
                            // vm.dataToFill.pickUpAddress = vm.addressHave;
                            vm.dataToFill.pickUpLat = $scope.addressLat;
                            vm.dataToFill.pickUpLng = $scope.addressLng;
                            vm.dataToFill.pickLat = $scope.addressLat;
                            vm.dataToFill.pickLng = $scope.addressLng;
                            vm.dataToFill.previousPickFlag = false;
                            vm.pickaddressChange = true;
                            vm.dataToFill.previousDropFlag = false;
                            getFavoriteAddress('pick');
                            // ********** TO GET CITY OF ADDRESS **********
                            vm.jobPickupComuna = response.county;
                            $scope.$apply();
                            vm.getFixedRoutesForPersonalFlag = true;
                            var location = new google.maps.LatLng(salida.position.lat, salida.position.lng);
                            if (vm.toAirportFlag) {
                                getAirportAddressApi();
                            }
                            if (vm.ptopAirportFlag && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                                getFixedRoutesForPersonal(vm.dataToFill);
                            }
                            if (vm.dataToFill.serviceTypeSelected) { //&& (vm.dataToFill.bookingType == '0' || vm.dataToFill.bookingType == 0)
                                vm.dataToFill.nearDriver = '';
                                toGetAirportService(salida.position.lat, salida.position.lng, vm.dataToFill.serviceTypeSelected, map);
                            }
                            var location = new google.maps.LatLng(Number($scope.addressLat), Number($scope.addressLng));
                            $timeout(function () {
                                placeMarker(map, location, 'pick');
                            }, 2000);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                    }
                );
            //} else {
                //vm.addressPickUpArray = [];
                //var dataSend = {};
                //vm.dataToFill.pickUpAddress = data.label;
                //dataSend.searchtext = encodeURI(data.label);
                //// vm.loading = true;
                //var promise = getBookingsHereMaps.gecodeApiNewText(dataSend);
                //promise.then(
                    //function (payload) {
                        //$log.log(payload);
                        //vm.loading = false;
                        //var response = JSON.parse(payload.response);
                        //if (response.Response.View.length > 0) {
                            //var city;
                            //city = response.Response.View[0].Result[0].Location.Address.City;
                            //if (vm.pickUpCity && (vm.pickUpCity != city)) {
                                //errorMessageFactory.showErrorMessage('Error, esta dirección cambia el tramo original. El cambio no debe afectar la tarifa.', 0);
                                //// results= '';
                                //vm.dataToFill.pickUpAddress = vm.pickUpAddress;
                                //vm.addressChange = false;
                                //return;
                            //}
                            //$scope.addressPick = vm.dataToFill.pickUpAddress;
                            //$scope.addressLat = response.Response.View[0].Result[0].Location.DisplayPosition.Latitude;
                            //$scope.addressLng = response.Response.View[0].Result[0].Location.DisplayPosition.Longitude;
                            //// var string = response.Response.View[0].Result[0].Location.Address.Label;
                            //// var address = string.replace(", Chile", " ");
                            //// vm.dataToFill.pickUpAddress = vm.addressHave;
                            //vm.dataToFill.pickUpLat = $scope.addressLat;
                            //vm.dataToFill.pickUpLng = $scope.addressLng;
                            //vm.dataToFill.pickLat = $scope.addressLat;
                            //vm.dataToFill.pickLng = $scope.addressLng;
                            //vm.dataToFill.previousPickFlag = false;
                            //vm.pickaddressChange = true;
                            //vm.dataToFill.previousDropFlag = false;
                            //getFavoriteAddress('pick');
                            //// ********** TO GET CITY OF ADDRESS **********
                            //vm.jobPickupComuna = response.Response.View[0].Result[0].Location.Address.City;
                            //$scope.$apply();
                            //vm.getFixedRoutesForPersonalFlag = true;
                            //var location = new google.maps.LatLng(response.Response.View[0].Result[0].Location.DisplayPosition.Latitude, response.Response.View[0].Result[0].Location.DisplayPosition.Longitude);
                            //if (vm.toAirportFlag) {
                                //getAirportAddressApi();
                            //}
                            //if (vm.ptopAirportFlag && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                                //getFixedRoutesForPersonal(vm.dataToFill);
                            //}
                            //if (vm.dataToFill.serviceTypeSelected) { //&& (vm.dataToFill.bookingType == '0' || vm.dataToFill.bookingType == 0)
                                //vm.dataToFill.nearDriver = '';
                                //toGetAirportService(response.Response.View[0].Result[0].Location.DisplayPosition.Latitude, response.Response.View[0].Result[0].Location.DisplayPosition.Longitude, vm.dataToFill.serviceTypeSelected, map);
                            //}
                            //var location = new google.maps.LatLng(Number($scope.addressLat), Number($scope.addressLng));
                            //$timeout(function () {
                                //placeMarker(map, location, 'pick');
                            //}, 2000);
                        //}
                    //},
                    //function (errorPayload) {
                        //$log.log(errorPayload);
                        //vm.loading = false;
                    //}
                //);
            //}
        };

      
        function reverseGeocodeForPickUp() {
            var geocoder = new google.maps.Geocoder;
            geocoder.geocode({
                'address': vm.pickUpAddress
            }, function (results, status) {
                if (status === 'OK') {
                    for (var i = 0; i < results[0].address_components.length; i++) {
                        for (var j = 0; j < results[0].address_components[i].types.length; j++) {
                            if (results[0].address_components[i].types[j] == 'locality') {
                                vm.pickUpCity = results[0].address_components[i].short_name;
                            }
                        }
                    }
                } else {
                    window.alert('Geocode was not successful for the following reason: ' +
                        status);
                }
            });
        }





        function reverseGeocodeForDropUp() {
            var geocoder = new google.maps.Geocoder;
            geocoder.geocode({
                'address': vm.pickUpAddress
            }, function (results, status) {
                if (status === 'OK') {
                    for (var i = 0; i < results[0].address_components.length; i++) {
                        for (var j = 0; j < results[0].address_components[i].types.length; j++) {
                            if (results[0].address_components[i].types[j] == 'locality') {
                                vm.dropUpCity = results[0].address_components[i].short_name;
                            }
                        }
                    }
                } else {
                    window.alert('Geocode was not successful for the following reason: ' +
                        status);
                }
            });
        }

        function fillInAddressD(data) {
            // $(".pac-container").hide();
            // var placeD = autocompleteD.getPlace();
            // geocoder.geocode({
            //     'placeId': placeD.place_id
            // }, function (results, status) {

            //     if (status !== 'OK') {
            //         window.alert('Geocoder failed due to: ' + status);
            //         return;
            //     }
            //     var city;
            //     for (var i = 0; i < results[0].address_components.length; i++) {
            //         for (var j = 0; j < results[0].address_components[i].types.length; j++) {
            //             if (results[0].address_components[i].types[j] == 'locality') {
            //                 city = results[0].address_components[i].short_name;
            //             }
            //         }
            //     }
            //     if (vm.dropUpCity && (vm.dropUpCity != city)) {
            //         errorMessageFactory.showErrorMessage('Error, esta dirección cambia el tramo original. El cambio no debe afectar la tarifa.', 0);
            //         // results= '';
            //         vm.dataToFill.dropOffAddress = vm.dropUpAddress;
            //         vm.addressChange = false;
            //         return;
            //     }
            //     $scope.addressDrop = hidePublicPlaces.formattedAddress(results[0]);
            //     $scope.addressDLat = results[0].geometry.location.lat();
            //     $scope.addressDLng = results[0].geometry.location.lng();
            //     var string1 = results[0].formatted_address;
            //     var address1 = string1.replace(", Chile", " ");
            //     vm.dataToFill.dropOffAddress = address1;
            //     vm.dataToFill.dropOffLat = $scope.addressDLat;
            //     vm.dataToFill.dropOffLng = $scope.addressDLng;
            //     vm.dataToFill.dropLat = $scope.addressDLat;
            //     vm.dataToFill.dropLng = $scope.addressDLng;
            //     vm.dataToFill.previousPickFlag = false;
            //     vm.dataToFill.previousDropFlag = false;
            //     vm.dropaddressChange = true;

            //     // ********** TO GET CITY OF ADDRESS **********
            //     results[0].address_components.forEach(function (data) {
            //         if (data.types[0] == 'locality') {
            //             vm.jobDropoffComuna = data.long_name || null;
            //         }
            //     });
            //     getFavoriteAddress('drop');
            //     $scope.$apply();
            //     vm.getFixedRoutesForPersonalFlag = true;
            //     var locationD = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
            //     //zoomLevel = 12;
            //     // $timeout(function () {
            //     //     placeMarker(map, locationD, 'drop');
            //     // }, 2000)
            //     if (vm.fromAirportFlag) {
            //         getAirportAddressApi();
            //     }
            //     if (vm.ptopAirportFlag && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
            //         getFixedRoutesForPersonal(vm.dataToFill);
            //     }

            // });
            //if (data.type == 0) {
                vm.addressDropArray = [];
                var dataSend = {};
                dataSend.latitude = data.latitude;
                dataSend.longitude = data.longitude;
                vm.dataToFill.dropOffAddress = data.label;
                var promise = getBookingsHereMaps.reverseGeocoding(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        var response = payload.title.data;
                        if (response.items.length > 0) {
                            var city;
                            city = response.items[0].address.city;
                            if (vm.dropUpCity && (vm.dropUpCity != city)) {
                                errorMessageFactory.showErrorMessage('Error, esta dirección cambia el tramo original. El cambio no debe afectar la tarifa.', 0);
                                // results= '';
                                vm.dataToFill.dropOffAddress = vm.dropUpAddress;
                                vm.addressChange = false;
                                return;
                            }
                            $scope.addressDrop = vm.dataToFill.dropOffAddress;
                            $scope.addressDLat = data.latitude;
                            $scope.addressDLng = data.longitude;
                            // var string1 = response.Response.View[0].Result[0].Location.Address.Label;
                            // var address1 = string1.replace(", Chile", " ");
                            // vm.dataToFill.dropOffAddress = address1;
                            vm.dataToFill.dropOffLat = $scope.addressDLat;
                            vm.dataToFill.dropOffLng = $scope.addressDLng;
                            vm.dataToFill.dropLat = $scope.addressDLat;
                            vm.dataToFill.dropLng = $scope.addressDLng;
                            vm.dropaddressChange = true;
                            vm.jobDropoffComuna = response.items[0].address.city;
                            // ********** TO GET CITY OF ADDRESS **********
                            // results[0].address_components.forEach(function (data) {
                            //     if (data.types[0] == 'locality') {
                            //         vm.jobDropoffComuna = data.long_name || null;
                            //     }
                            // });
                            getFavoriteAddress('drop');
                            if(!$scope.$$phase) {
                                $scope.$apply();
                            }
                            vm.getFixedRoutesForPersonalFlag = true;
                            var locationD = new google.maps.LatLng(data.latitude, data.longtitude);
                            //zoomLevel = 12;
                            // $timeout(function () {
                            //     placeMarker(map, locationD, 'drop');
                            // }, 2000)
                            if (vm.fromAirportFlag) {
                                getAirportAddressApi();
                            }
                            if (vm.ptopAirportFlag && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                                getFixedRoutesForPersonal(vm.dataToFill);
                            }
                            var locationD = new google.maps.LatLng(Number($scope.addressDLat), Number($scope.addressDLng));
                            $timeout(function () {
                                placeMarker(map, locationD, 'drop');
                            }, 2000);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                    }
                );
            //} else {
                //vm.addressDropArray = [];
                //var dataSend = {};
                ////dataSend.locationId = data.locationId;
                //vm.dataToFill.dropOffAddress = data.label;
                ////var promise = getBookingsHereMaps.gecodeApiNew(dataSend);
                //dataSend.searchtext = encodeURI(data.label);
                //var promise = getBookingsHereMaps.gecodeApiNewText(dataSend);

                //promise.then(
                    //function (payload) {
                        //$log.log(payload);
                        //vm.loading = false;
                        //var response = JSON.parse(payload.response);
                        //if (response.Response.View.length > 0) {
                            //var city;
                            //city = response.Response.View[0].Result[0].Location.Address.City;
                            //if (vm.dropUpCity && (vm.dropUpCity != city)) {
                                //errorMessageFactory.showErrorMessage('Error, esta dirección cambia el tramo original. El cambio no debe afectar la tarifa.', 0);
                                //// results= '';
                                //vm.dataToFill.dropOffAddress = vm.dropUpAddress;
                                //vm.addressChange = false;
                                //return;
                            //}
                            //$scope.addressDrop = vm.dataToFill.dropOffAddress;
                            //$scope.addressDLat = response.Response.View[0].Result[0].Location.DisplayPosition.Latitude;
                            //$scope.addressDLng = response.Response.View[0].Result[0].Location.DisplayPosition.Longitude;
                            //// var string1 = response.Response.View[0].Result[0].Location.Address.Label;
                            //// var address1 = string1.replace(", Chile", " ");
                            //// vm.dataToFill.dropOffAddress = address1;
                            //vm.dataToFill.dropOffLat = $scope.addressDLat;
                            //vm.dataToFill.dropOffLng = $scope.addressDLng;
                            //vm.dataToFill.dropLat = $scope.addressDLat;
                            //vm.dataToFill.dropLng = $scope.addressDLng;
                            //vm.dropaddressChange = true;
                            //vm.jobDropoffComuna = response.Response.View[0].Result[0].Location.Address.City;
                            //// ********** TO GET CITY OF ADDRESS **********
                            //// results[0].address_components.forEach(function (data) {
                            ////     if (data.types[0] == 'locality') {
                            ////         vm.jobDropoffComuna = data.long_name || null;
                            ////     }
                            //// });
                            //getFavoriteAddress('drop');
                            //$scope.$apply();
                            //vm.getFixedRoutesForPersonalFlag = true;
                            //var locationD = new google.maps.LatLng(response.Response.View[0].Result[0].Location.DisplayPosition.Latitude, response.Response.View[0].Result[0].Location.DisplayPosition.Longitude);
                            ////zoomLevel = 12;
                            //// $timeout(function () {
                            ////     placeMarker(map, locationD, 'drop');
                            //// }, 2000)
                            //if (vm.fromAirportFlag) {
                                //getAirportAddressApi();
                            //}
                            //if (vm.ptopAirportFlag && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                                //getFixedRoutesForPersonal(vm.dataToFill);
                            //}
                            //var locationD = new google.maps.LatLng(Number($scope.addressDLat), Number($scope.addressDLng));
                            //$timeout(function () {
                                //placeMarker(map, locationD, 'drop');
                            //}, 2000);
                        //}
                    //},
                    //function (errorPayload) {
                        //$log.log(errorPayload);
                        //vm.loading = false;
                    //}
                //);
            //}

        };


        function fillInAddressDAdressword(data) {
            // $(".pac-container").hide();
            // var placeD = autocompleteD.getPlace();
            // geocoder.geocode({
            //     'placeId': placeD.place_id
            // }, function (results, status) {

            //     if (status !== 'OK') {
            //         window.alert('Geocoder failed due to: ' + status);
            //         return;
            //     }
            //     var city;
            //     for (var i = 0; i < results[0].address_components.length; i++) {
            //         for (var j = 0; j < results[0].address_components[i].types.length; j++) {
            //             if (results[0].address_components[i].types[j] == 'locality') {
            //                 city = results[0].address_components[i].short_name;
            //             }
            //         }
            //     }
            //     if (vm.dropUpCity && (vm.dropUpCity != city)) {
            //         errorMessageFactory.showErrorMessage('Error, esta dirección cambia el tramo original. El cambio no debe afectar la tarifa.', 0);
            //         // results= '';
            //         vm.dataToFill.dropOffAddress = vm.dropUpAddress;
            //         vm.addressChange = false;
            //         return;
            //     }
            //     $scope.addressDrop = hidePublicPlaces.formattedAddress(results[0]);
            //     $scope.addressDLat = results[0].geometry.location.lat();
            //     $scope.addressDLng = results[0].geometry.location.lng();
            //     var string1 = results[0].formatted_address;
            //     var address1 = string1.replace(", Chile", " ");
            //     vm.dataToFill.dropOffAddress = address1;
            //     vm.dataToFill.dropOffLat = $scope.addressDLat;
            //     vm.dataToFill.dropOffLng = $scope.addressDLng;
            //     vm.dataToFill.dropLat = $scope.addressDLat;
            //     vm.dataToFill.dropLng = $scope.addressDLng;
            //     vm.dataToFill.previousPickFlag = false;
            //     vm.dataToFill.previousDropFlag = false;
            //     vm.dropaddressChange = true;

            //     // ********** TO GET CITY OF ADDRESS **********
            //     results[0].address_components.forEach(function (data) {
            //         if (data.types[0] == 'locality') {
            //             vm.jobDropoffComuna = data.long_name || null;
            //         }
            //     });
            //     getFavoriteAddress('drop');
            //     $scope.$apply();
            //     vm.getFixedRoutesForPersonalFlag = true;
            //     var locationD = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
            //     //zoomLevel = 12;
            //     // $timeout(function () {
            //     //     placeMarker(map, locationD, 'drop');
            //     // }, 2000)
            //     if (vm.fromAirportFlag) {
            //         getAirportAddressApi();
            //     }
            //     if (vm.ptopAirportFlag && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
            //         getFixedRoutesForPersonal(vm.dataToFill);
            //     }

            // });
            //if (data.type == 0) {
                vm.addressDropArray = [];
                var dataSend = {};
                dataSend.channel = 'ACME_1';
                dataSend.label = data.label;
                dataSend.origin = data.origin;
                dataSend.id_origin = data.id_origin;
                dataSend.user_id = vm.dataToFill.customerEmail;
                vm.dataToFill.dropOffAddress = data.label;
                var promise = getBookingsHereMaps.autoSuggestDetailsAconcagua(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        var response = JSON.parse(payload.response);
                        console.log(response, 'reverseGeocoding>>>>>>>>>>>');

                        if (response.data.length > 0) {
                            var salida = response.data[0];
                            var city;
                            city = salida.city_name;
                            if (vm.dropUpCity && (vm.dropUpCity != city)) {
                                errorMessageFactory.showErrorMessage('Error, esta dirección cambia el tramo original. El cambio no debe afectar la tarifa.', 0);
                                // results= '';
                                vm.dataToFill.dropOffAddress = vm.dropUpAddress;
                                vm.addressChange = false;
                                return;
                            }
                            $scope.addressDrop = vm.dataToFill.dropOffAddress;
                            $scope.addressDLat = salida.latitude;
                            $scope.addressDLng = salida.longitude;
                            // var string1 = response.Response.View[0].Result[0].Location.Address.Label;
                            // var address1 = string1.replace(", Chile", " ");
                            // vm.dataToFill.dropOffAddress = address1;
                            vm.dataToFill.dropOffLat = $scope.addressDLat;
                            vm.dataToFill.dropOffLng = $scope.addressDLng;
                            vm.dataToFill.dropLat = $scope.addressDLat;
                            vm.dataToFill.dropLng = $scope.addressDLng;
                            vm.dropaddressChange = true;
                            vm.jobDropoffComuna = salida.city_name;
                            // ********** TO GET CITY OF ADDRESS **********
                            // results[0].address_components.forEach(function (data) {
                            //     if (data.types[0] == 'locality') {
                            //         vm.jobDropoffComuna = data.long_name || null;
                            //     }
                            // });
                            getFavoriteAddress('drop');
                            $scope.$apply();
                            vm.getFixedRoutesForPersonalFlag = true;
                            var locationD = new google.maps.LatLng(salida.latitude, salida.longitude);
                            //zoomLevel = 12;
                            // $timeout(function () {
                            //     placeMarker(map, locationD, 'drop');
                            // }, 2000)
                            if (vm.fromAirportFlag) {
                                getAirportAddressApi();
                            }
                            if (vm.ptopAirportFlag && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                                getFixedRoutesForPersonal(vm.dataToFill);
                            }
                            var locationD = new google.maps.LatLng(Number($scope.addressDLat), Number($scope.addressDLng));
                            $timeout(function () {
                                placeMarker(map, locationD, 'drop');
                            }, 2000);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                    }
                );
            //} else {
                //vm.addressDropArray = [];
                //var dataSend = {};
                ////dataSend.locationId = data.locationId;
                //vm.dataToFill.dropOffAddress = data.label;
                ////var promise = getBookingsHereMaps.gecodeApiNew(dataSend);
                //dataSend.searchtext = encodeURI(data.label);
                //var promise = getBookingsHereMaps.gecodeApiNewText(dataSend);

                //promise.then(
                    //function (payload) {
                        //$log.log(payload);
                        //vm.loading = false;
                        //var response = JSON.parse(payload.response);
                        //if (response.Response.View.length > 0) {
                            //var city;
                            //city = response.Response.View[0].Result[0].Location.Address.City;
                            //if (vm.dropUpCity && (vm.dropUpCity != city)) {
                                //errorMessageFactory.showErrorMessage('Error, esta dirección cambia el tramo original. El cambio no debe afectar la tarifa.', 0);
                                //// results= '';
                                //vm.dataToFill.dropOffAddress = vm.dropUpAddress;
                                //vm.addressChange = false;
                                //return;
                            //}
                            //$scope.addressDrop = vm.dataToFill.dropOffAddress;
                            //$scope.addressDLat = response.Response.View[0].Result[0].Location.DisplayPosition.Latitude;
                            //$scope.addressDLng = response.Response.View[0].Result[0].Location.DisplayPosition.Longitude;
                            //// var string1 = response.Response.View[0].Result[0].Location.Address.Label;
                            //// var address1 = string1.replace(", Chile", " ");
                            //// vm.dataToFill.dropOffAddress = address1;
                            //vm.dataToFill.dropOffLat = $scope.addressDLat;
                            //vm.dataToFill.dropOffLng = $scope.addressDLng;
                            //vm.dataToFill.dropLat = $scope.addressDLat;
                            //vm.dataToFill.dropLng = $scope.addressDLng;
                            //vm.dropaddressChange = true;
                            //vm.jobDropoffComuna = response.Response.View[0].Result[0].Location.Address.City;
                            //// ********** TO GET CITY OF ADDRESS **********
                            //// results[0].address_components.forEach(function (data) {
                            ////     if (data.types[0] == 'locality') {
                            ////         vm.jobDropoffComuna = data.long_name || null;
                            ////     }
                            //// });
                            //getFavoriteAddress('drop');
                            //$scope.$apply();
                            //vm.getFixedRoutesForPersonalFlag = true;
                            //var locationD = new google.maps.LatLng(response.Response.View[0].Result[0].Location.DisplayPosition.Latitude, response.Response.View[0].Result[0].Location.DisplayPosition.Longitude);
                            ////zoomLevel = 12;
                            //// $timeout(function () {
                            ////     placeMarker(map, locationD, 'drop');
                            //// }, 2000)
                            //if (vm.fromAirportFlag) {
                                //getAirportAddressApi();
                            //}
                            //if (vm.ptopAirportFlag && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                                //getFixedRoutesForPersonal(vm.dataToFill);
                            //}
                            //var locationD = new google.maps.LatLng(Number($scope.addressDLat), Number($scope.addressDLng));
                            //$timeout(function () {
                                //placeMarker(map, locationD, 'drop');
                            //}, 2000);
                        //}
                    //},
                    //function (errorPayload) {
                        //$log.log(errorPayload);
                        //vm.loading = false;
                    //}
                //);
            //}

        };
      

        function calculatePrice(payload) {
            vm.toll_price = 0;
            vm.toll_id = false;
            for (var i = 0; i < payload.title.data.price_list.itemOfCharge.length; i++) {
                if (payload.title.data.price_list.itemOfCharge[i].item_of_charge_id === 2) {
                    vm.toll_id = true;
                    vm.tollChargeWay = payload.title.data.price_list.itemOfCharge[i].toll_charge_way;
                    vm.toll_price = payload.title.data.price_list.itemOfCharge[i].price;
                }
            }
            if (payload.title.data.apply_charge_by_toll && vm.toll_id && !vm.modifyFalgNew) {
                if (vm.tollChargeWay == 1) {
                    vm.tollPriceToAdd = Math.round(vm.toll_price);
                    vm.estimated_toll_price = vm.tollPriceToAdd * vm.tollCount;
                }
                else if (vm.tollChargeWay == 2) {
                    vm.tollPriceToAdd = Math.round(vm.tollPrice);
                    vm.estimated_toll_price = vm.tollPriceToAdd;
                }
                else {
                    vm.estimated_toll_price = 0;
                }
            } else {
                vm.estimated_toll_price = vm.bookingDetails ? vm.bookingDetails.estimated_toll_price : 0;
            }
            if (vm.dataToFill.route_type == 1) {
                vm.dataToFill.estimatedFareVariable = vm.dataToFill.selectedServiceDetails.fare_type ? Number(payload.title.data.price) * Number(vm.dataToFill.passengerCount) : payload.title.data.price + vm.estimated_toll_price;
                vm.dataToFill.estimatedFareRoute = vm.dataToFill.selectedServiceDetails.fare_type ? Number(payload.title.data.price) * Number(vm.dataToFill.passengerCount) : payload.title.data.price + vm.estimated_toll_price;
                if (vm.dataToFill.itemOfChargeSelected.length > 0) {
                    for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                        if(vm.dataToFill.itemOfChargeSelected[i].retorno == false) {
                            vm.dataToFill.estimatedFareRoute = vm.dataToFill.estimatedFareRoute + Number(vm.dataToFill.itemOfChargeSelected[i].price) + vm.estimated_toll_price;
                        }
                    }
                }

                vm.dataToFill.estimatedFare = vm.dataToFill.estimatedFareRoute;
                vm.fixedPriceFromSearchFixesVariable = vm.dataToFill.selectedServiceDetails.fare_type ? Number(payload.title.data.price) * Number(vm.dataToFill.passengerCount) : payload.title.data.price + vm.estimated_toll_price || 0;
                vm.dataToFill.estimatedFareRoute = Number(payload.title.data.price) + vm.estimated_toll_price;
                vm.dataToFill.minimumFare = 0;
                vm.calculatedEstimatePriceFormFunctionEstimated = -1;
                // showEstimatePriceInHtml(vm.dataToFill.roundTrip, vm.viaControlledFLag1, vm.viaControlledFLag);

            } else {
                if (vm.dataToFill.estimatedDistance != undefined && vm.dataToFill.etaScheduleValue != undefined) {
                    vm.toll_price = 0;
                    if(payload.title.data.apply_charge_by_toll && !vm.modifyFalgNew) {
                        for(var i = 0; i < payload.title.data.price_list.itemOfCharge.length; i++) {
                            if(payload.title.data.price_list.itemOfCharge[i].item_of_charge_id === 2 && payload.title.data.price_list.itemOfCharge[i].price) {
                                vm.toll_price = payload.title.data.price_list.itemOfCharge[i].price;
                            }
                        } 
                        if(vm.toll_price) {
                            vm.tollPriceToAdd = Math.round(vm.toll_price);
                            vm.estimated_toll_price = vm.tollPriceToAdd*vm.tollCount;
                        }
                        else {
                            vm.tollPriceToAdd = Math.round(vm.tollPrice);
                            vm.estimated_toll_price = vm.tollPriceToAdd;
                        }
                    }
                    else {
                        vm.estimated_toll_price = 0;
                    }
                    
                    vm.estimated_eta = (vm.dataToFill.etaScheduleValue * payload.title.data.time_of_trip_price);
                    vm.estimated_distance = (vm.dataToFill.estimatedDistance * payload.title.data.perKMChanges);
                    var calEstFare = Number(vm.estimated_distance + vm.estimated_eta + vm.estimated_toll_price + payload.title.data.baseFare);
                }

                // console.log('calEstFarecalEstFarecalEstFare', calEstFare);
                if (vm.dataToFill.selectedServiceDetails.fare_type) {
                    if ((Number(calEstFare) * Number(vm.dataToFill.passengerCount)) < Number(payload.title.data.minimumFare)) {
                        if (vm.dataToFill.factor_value) {
                            vm.dataToFill.estimatedFareRoute = Number(payload.title.data.minimumFare) * vm.dataToFill.factor_value;
                        } else {
                            vm.dataToFill.estimatedFareRoute = payload.title.data.minimumFare;
                        }
                    } else {
                        vm.dataToFill.estimatedFareRoute = Number(calEstFare) * Number(vm.dataToFill.passengerCount);
                    }
                } else {
                    if (calEstFare <= Number(payload.title.data.minimumFare)) {
                        if (vm.dataToFill.factor_value) {
                            vm.dataToFill.estimatedFareRoute = Number(payload.title.data.minimumFare) * vm.dataToFill.factor_value;
                        } else {
                            vm.dataToFill.estimatedFareRoute = payload.title.data.minimumFare;
                        }
                    } else {
                        vm.dataToFill.estimatedFareRoute = calEstFare;
                    }
                }
                vm.dataToFill.estimatedFare = vm.dataToFill.estimatedFareRoute;
                vm.dataToFill.estimatedFareVariable = calEstFare;
                vm.dataToFill.estimatedFareRoute = calEstFare;
                vm.dataToFill.minimumFare = payload.title.data.minimumFare;
                vm.calculatedEstimatePriceFormFunctionEstimated = -1;
                // showEstimatePriceInHtml(vm.dataToFill.roundTrip, vm.viaControlledFLag1, vm.viaControlledFLag);

            }
            if(vm.dataToFill.roundTrip) {
                setBooleans('ROUND_TRIP', true);
            }
        }

        function toGetAirportServiceNew(lat, lng, service, map) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.latitude = lat;
            dataSend.longitude = lng;
            dataSend.service_id = service;
            vm.loading = true;
            var promise = getBookingsHereMaps.getAirportZone(dataSend);
            promise.then(
                function (payload) {
                    if (payload.title.data.time_trip_shared_service) {
                        vm.dataToFill.time_trip_shared_service = payload.title.data.time_trip_shared_service;
                    } else vm.dataToFill.time_trip_shared_service = 0;
                },
                function (errorPayload) {
                    vm.loading = false;

                    if (errorPayload.data.status == 400) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                    if (markers.length) {
                        for (var i = 0; i < markers.length; i++) {
                            if (markers[i].id == 'driver') {
                                setMapOnAll(null, 'driver');
                            }
                        }
                    }
                    $log.log(errorPayload);
                }
            );
        }

        // ============================= Rounding Function ============================= //
        function roundToTwo(num) {
            console.log('debug num', num, +(Math.round(num + "e+2")  + "e-2"));    
            return +(Math.round(num + "e+2")  + "e-2");
        }

        function calculateAndDisplayRoute(directionsService, directionsDisplay, lat1, lng1, lat2, lng2, map, type, payload) {
            console.log('>>>>>>>>>>>>>>>>>>>calculateAndDisplayRoute>>>>>>>>>>>>>>>>>>');

            directionsDisplay.setMap(map);
            directionsDisplay.setOptions({
                suppressMarkers: true
            });
            var myLatlng = new google.maps.LatLng(lat1, lng1);
            var myLatlng1 = new google.maps.LatLng(lat2, lng2);
            var sendDate;
            if (type == 'ROUND TRIP') {
                if (vm.bookingDetails) {
                    if (new Date(vm.bookingDetails.return_date_time_utc) != 'Invalid Date') {

                        if (moment(dateTimeFormat(vm.dataToFill.dropDateReturn, vm.dataToFill.dropTimeReturn)).isAfter(new Date()))
                            sendDate = dateTimeFormat(vm.dataToFill.dropDateReturn, vm.dataToFill.dropTimeReturn);
                        else
                            sendDate = new Date();
                    } else {
                        sendDate = new Date();
                    }
                } else {
                    if(new Date(vm.dataToFill.returnDate) != 'Invalid Date' && new Date(vm.dataToFill.returnTime) != 'Invalid Date'){
                        if (moment(dateTimeFormat(vm.dataToFill.returnDate, vm.dataToFill.returnTime)).isAfter(new Date())) {
                            sendDate = dateTimeFormat(vm.dataToFill.returnDate, vm.dataToFill.returnTime);
                        }
                        else {
                            sendDate = new Date();
                        }
                    }
                }
            }
            else {
                if (vm.scheduleFlag == true && new Date(vm.dataToFill.scheduledDate) != 'Invalid Date' && new Date(vm.dataToFill.scheduledTime) != 'Invalid Date') {
                    var schuduleDate = dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime);

                    if (moment(dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime)).isAfter(new Date()))
                        sendDate = dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime);
                    else
                        sendDate = new Date();

                } 
                else if (vm.dateFlag == true && new Date(vm.dataToFill.dropDate) != 'Invalid Date' && new Date(vm.dataToFill.dropTime) != 'Invalid Date ') {
                    if (moment(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime)).isAfter(new Date()))
                        sendDate = dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime);
                    else
                        sendDate = new Date();
                } 
                else if (new Date(vm.dataToFill.dropDate) == 'Invalid Date' && new Date(vm.dataToFill.dropTime) == 'Invalid Date ') {
                    sendDate = new Date();
                } 
                else if (vm.flagHelp == true && new Date(vm.bookingDetails.job_delivery_datetime) != 'Invalid Date' && (vm.bookingDetails && vm.bookingDetails.schedule_ride == 1)) {
                    if (!vm.modifyFalgNew){
                        sendDate =dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime);
                    }
                    else if (vm.modifyFalgNew){
                        sendDate = new Date(vm.bookingDetails.job_delivery_datetime);
                    }
                    else
                        sendDate = new Date();    
                } 
                else {
                    sendDate = new Date(vm.dataToFill.scheduledDate);
                }

                if (vm.bookingDetails != undefined && vm.bookingDetails.job_delivery_datetime == "0000-00-00 00:00:00") {
                    sendDate = new Date();
                }
                if (vm.bookingDetails != undefined && vm.bookingDetails.schedule_ride == 0) {
                    sendDate = new Date();
                }
            }
            if (!vm.modifyFalgNew) {
                var dataSend = {};
                dataSend.picklat = lat1;
                dataSend.picklng = lng1;
                dataSend.droplat = lat2;
                dataSend.droplng = lng2;
                if (vm.modifyFalg) {
                    toGetAirportServiceNew(vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.serviceTypeSelected, map);
                }
                dataSend.departure = new Date(sendDate).toISOString();
                            tollCostEstimatedRouteHereMaps(lat1, lng1, lat2, lng2, sendDate, type, payload); 
            } else {
                if (type == 'ROUND TRIP') {
                    vm.dataToFill.etaScheduleValueReturn = vm.bookingDetails.eta;
                    vm.dataToFill.etaScheduleReturn = vm.bookingDetails.eta;
                    vm.dataToFill.ReturnEstimatedDistance = roundToTwo((vm.bookingDetails.estimated_distance / 1000));
                } else {
                    vm.dataToFill.etaSchedule = vm.bookingDetails.eta;
                    vm.dataToFill.etaScheduleValue = vm.bookingDetails.eta;
                    if (vm.dataToFill.selectedServiceDetails.category == 1) {
                        vm.dataToFill.time_trip_shared_service = 0;
                    }
                    vm.dataToFill.estimatedDistance = roundToTwo((vm.bookingDetails.estimated_distance ? vm.bookingDetails.estimated_distance : 0 / 1000));
                    vm.estimated_toll_price = vm.bookingDetails.estimated_toll_price;
                }
                if (type == 'ROUND TRIP') {
                    if (vm.dataToFill.selectedServiceDetails.category == 1)
                        calculateEstimatePickUpTimeReturn(vm.dataToFill.etaScheduleValueReturn);
                    if ((vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip == 'R')) {
                        $timeout(function () {
                            calculateEstimatePickUpTimeForRTypeReturn(vm.dataToFill.etaScheduleValueReturn);
                        }, 800)
                    }
                }
                if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking == 'R') {
                    calculateEstimatePickUpTimeForRType(vm.dataToFill.etaScheduleValue); 
                    //calculateDateRangeOfPointToPoint(); 
                }
                if (vm.dataToFill.selectedServiceDetails.category == 1)
                    calculateEstimatePickUpTime(vm.dataToFill.etaScheduleValue);
                if (payload)
                    calculatePrice(payload);
                // directionsDisplay.setDirections(response);
                // $scope.$apply();
            }

            if(type == 'ROUND TRIP'){
                if( ciclosFuncionRt == 0 ){
                    setTimeout(function () {
                    get_cuota_rt();
                    }, 2000);
                }
                ciclosFuncionRt++;
                setTimeout(function () {
                    ciclosFuncionRt = 0;
                }, 2000);
                
            }else {
                if( ciclosFuncion == 0 ){
                    //getFixedRoutesForPersonal(vm.dataToFill);
                    get_cuota();
                }
                ciclosFuncion++;
                setTimeout(function () {
                    ciclosFuncion = 0;
                }, 2000);
            }
        }

        function tollCostEstimatedRouteHereMaps(lat1, lng1, lat2, lng2, sendDate, type, payloadSearchFixedVariable) {
            var dataSend = {};
            dataSend.waypoint0 = lat1 + ',' + lng1;
            dataSend.waypoint1 = lat2 + ',' + lng2;
            dataSend.departure_date = moment().utc(sendDate).format('YYYY-MM-DDTHH:mm:ss-00');
            dataSend.origen = 'panel-heremaps';
            var promise = getBookingsHereMaps.tollCostEstimatedRouteHereMaps(dataSend);
            vm.loading = true;
                promise.then(
                    function (payload) {
                        vm.loading = false;
                        console.log('debug tollCostEstimatedRouteHereMaps payload', payload);
                        if (payload.title.status == 400) {
                            if (payload.title.data && payload.title.data.custom_error) {
                                openPopForErrorAddress(payload);
                            } else {
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            }
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            if (type == 'ROUND TRIP') {
                                vm.tollPriceReturn = payload.title.data.tollPrice;
                                vm.tollCountReturn = payload.title.data.tollCount;
                                vm.dataToFill.etaScheduleValueReturn = Math.round(payload.title.data.etaInSeconds / 60);
                                vm.dataToFill.etaScheduleReturn = Math.round(payload.title.data.etaInSeconds / 60);
                                vm.dataToFill.ReturnEstimatedDistance = roundToTwo((payload.title.data.distanceInMeters / 1000));
                                vm.heremaps_toll_details_return = payload.title.data;
                            } else {
                                vm.tollPrice = payload.title.data.tollPrice;
                                vm.tollCount = payload.title.data.tollCount;
                                vm.dataToFill.etaSchedule = Math.round(payload.title.data.etaInSeconds / 60);
                                vm.dataToFill.etaScheduleValue = Math.round(payload.title.data.etaInSeconds / 60);
                                vm.dataToFill.estimatedDistance = roundToTwo((payload.title.data.distanceInMeters / 1000));
                                vm.heremaps_toll_details = payload.title.data;
                            }
        
                            if (type == 'ROUND TRIP') {
                                if (vm.dataToFill.selectedServiceDetails.category == 1)
                                    calculateEstimatePickUpTimeReturn(vm.dataToFill.etaScheduleValueReturn);
                                if ((vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip == 'R')) {
                                    $timeout(function () {
                                        calculateEstimatePickUpTimeForRTypeReturn(vm.dataToFill.etaScheduleValueReturn);
                                    }, 800)
                                }
                            }
                            if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking == 'R') {
                                calculateEstimatePickUpTimeForRType(vm.dataToFill.etaScheduleValue); 
                                //calculateDateRangeOfPointToPoint(); 
                            }
                            if (vm.dataToFill.selectedServiceDetails.category == 1)
                                calculateEstimatePickUpTime(vm.dataToFill.etaScheduleValue);
                            if(payloadSearchFixedVariable) {
                                calculatePrice(payloadSearchFixedVariable);
                            }
                            // directionsDisplay.setDirections(response);
                            // $scope.$apply();
                            // vm.loading = false;
                            //console.log(vm.dataToFill.etaSchedule, vm.dataToFill.etaScheduleValue)
                            if ((vm.type_of_trip1 == 'R' && vm.dataToFill.selectedServiceDetails.category == 1 && vm.method_range_pickup) || (vm.routingBase && vm.routingBase.routing_base_id > 0)) {
                                RoutingApiFuncation(vm.dataToFill, 0);
                            }
                            setTimeout(function(){
                                vm.disabledSubmitButton1 = false;
                            }, 1500);
                            if(type === 'ROUND TRIP' && vm.searchFixedVariablePayload) {
                                if (vm.dataToFill.Return_policy.route_type === 0) {
                                    //=========================Return========================
                                    if (vm.dataToFill.ReturnEstimatedDistance != undefined && vm.dataToFill.etaScheduleValueReturn != undefined) {
                                        console.log('debug vm.searchFixedVariablePayload', vm.searchFixedVariablePayload);
                                        console.log('debug vm.searchFixedVariablePayload.title.data.finalResult_return.price_list', vm.searchFixedVariablePayload.title.data.finalResult_return.price_list);
                                        
                                        if(vm.searchFixedVariablePayload.title.data.apply_charge_by_toll) {
                                            vm.toll_price_return = 0;
                                            for (var i = 0; i < vm.searchFixedVariablePayload.title.data.finalResult_return.price_list.itemOfCharge.length; i++) {
                                                if (vm.searchFixedVariablePayload.title.data.finalResult_return.price_list.itemOfCharge[i].item_of_charge_id === 2 && vm.searchFixedVariablePayload.title.data.finalResult_return.price_list.itemOfCharge[i].price) {
                                                    vm.toll_price_return = vm.searchFixedVariablePayload.title.data.finalResult_return.price_list.itemOfCharge[i].price;
                                                }
                                            }
                                            if (vm.toll_price_return) {
                                                vm.tollPriceReturnToAdd = Math.round(vm.toll_price_return);
                                                vm.estimated_toll_price_return = vm.tollPriceReturnToAdd * vm.tollCountReturn;
                                            }
                                            else {
                                                vm.tollPriceReturnToAdd = Math.round(vm.tollPriceReturn);
                                                vm.estimated_toll_price_return = vm.tollPriceReturnToAdd;
                                            }                   
                                        }
                                        else {
                                            vm.estimated_toll_price_return = 0;
                                        }
                                        
                
                                        vm.estimated_eta_return = (vm.dataToFill.etaScheduleValueReturn * vm.searchFixedVariablePayload.title.data.finalResult_return.time_of_trip_price);
                
                                        vm.estimated_distance_return = (vm.dataToFill.ReturnEstimatedDistance * vm.searchFixedVariablePayload.title.data.finalResult_return.perKMChanges);

                                        console.log('debug vm.estimated_toll_price_return vm.estimated_eta_return vm.estimated_distance_return', vm.estimated_toll_price_return, vm.estimated_eta_return, vm.estimated_distance_return, vm.tollPriceReturnToAdd, vm.tollCountReturn);
                
                                        var Return_calEstFare = Number(vm.estimated_distance_return + vm.estimated_eta_return + vm.estimated_toll_price_return + vm.searchFixedVariablePayload.title.data.finalResult_return.baseFare);
                                        console.log('debug Return_calEstFare', Return_calEstFare);
                                    }
                                    if (vm.dataToFill.selectedServiceDetails.fare_type) {
                                        if ((Number(Return_calEstFare) * Number(vm.dataToFill.passengerCount)) < vm.searchFixedVariablePayload.title.data.finalResult_return.minimumFare) {
                                            if(vm.dataToFill.factor_return_value){
                                                vm.dataToFill.Return_policy.estimatedFareRoute = Number(vm.searchFixedVariablePayload.title.data.finalResult_return.minimumFare) * vm.dataToFill.factor_return_value;
                                            } else {
                                                vm.dataToFill.Return_policy.estimatedFareRoute = vm.searchFixedVariablePayload.title.data.finalResult_return.minimumFare;
                                            }
                                        } else {
                                            vm.dataToFill.Return_policy.estimatedFareRoute = Number(Return_calEstFare) * Number(vm.dataToFill.passengerCount);
                                        }
                                    } else {
                                        if (Return_calEstFare <= vm.searchFixedVariablePayload.title.data.finalResult_return.minimumFare) {
                                            if(vm.dataToFill.factor_return_value){
                                                vm.dataToFill.Return_policy.estimatedFareRoute = Number(vm.searchFixedVariablePayload.title.data.finalResult_return.minimumFare) * vm.dataToFill.factor_return_value;
                                            } else {
                                                vm.dataToFill.Return_policy.estimatedFareRoute = vm.searchFixedVariablePayload.title.data.finalResult_return.minimumFare;
                                            }
                                        } else {
                                            vm.dataToFill.Return_policy.estimatedFareRoute = Return_calEstFare;
                                        }
                                    }
                                    vm.dataToFill.Return_policy.estimatedFare = vm.dataToFill.Return_policy.estimatedFareRoute;
                                    vm.dataToFill.Return_policy.estimatedFareVariable = Return_calEstFare;
                                    vm.dataToFill.Return_policy.estimatedFareRoute = Return_calEstFare;
                                    vm.dataToFill.minimumFare = vm.searchFixedVariablePayload.title.data.finalResult_return.minimumFare;

                                    vm.dataToFill.estimatedFare = vm.dataToFill.estimatedFareRoute;
                                    console.log('debug vm.dataToFill.itemOfChargeSelected', vm.dataToFill.itemOfChargeSelected, vm.dataToFill.itemOfChargeList);
                                    if(vm.dataToFill.itemOfChargeSelected && vm.dataToFill.itemOfChargeSelected.length)
                                    for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                                        if(vm.dataToFill.itemOfChargeSelected[i].retorno == true) {
                                            vm.dataToFill.Return_policy.estimatedFare = vm.dataToFill.Return_policy.estimatedFare + Number(vm.dataToFill.itemOfChargeSelected[i].price);
                                        } else {
                                            vm.dataToFill.estimatedFare = vm.dataToFill.estimatedFare + Number(vm.dataToFill.itemOfChargeSelected[i].price);
                                        }
                                    }

                                    if (vm.return_flag == true) {
                                        console.log('debug vm.return_flag', vm.return_flag);
                                        vm.dataToFill.discounts = [];
                                        vm.couponType = 1;
                                        if (vm.dataToFill.roundTripDiscount == 0)
                                            vm.couponType = undefined;
                                        vm.dataToFill.roundTrip = true;
                                        vm.dataToFill.discounts.push({
                                            estimatedFare: viaControlledPrice(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking),
                                            roundTripFare: vm.dataToFill.roundTrip == true ? viaControlledPrice(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip) : 0,
                                            name: 'ROUND TRIP',
                                            discountType: 1,
                                            discountTypeValue: vm.dataToFill.roundTripDiscount,
                                            value: calculateDiscountPercentageAmount(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, vm.dataToFill.roundTripDiscount,'parent'),
                                            returnValue: vm.dataToFill.roundTrip == true ? calculateDiscountPercentageAmount(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, vm.dataToFill.roundTripDiscount, 'parent') : 0,
                                            finalAmount: calculateDiscountPercentage(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, vm.dataToFill.roundTripDiscount,'parent'),
                                            roundFinalAmount: vm.dataToFill.roundTrip == true ? calculateDiscountPercentage(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, vm.dataToFill.roundTripDiscount) : 0
                                        })
                                        // console.log('>>>>> DISCOUNT >>>>>>>>>>>', vm.dataToFill.discounts);
                                        vm.dataToFill.discounts.forEach(function (data) {
                                            data.finalAmount = data.finalAmount < 0 ? 0 : data.finalAmount;
                                        })
                                        vm.dataToFill.discounts = vm.dataToFill.discounts.sort(function (a, b) {
                                            return b.value - a.value
                                        })
                                    } else {
                                        errorMessageFactory.showErrorMessage('Ida y vuelta de este servicio no está disponible', 0);
                                    }
                                }
                            }
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            //errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            if (type == 'ROUND TRIP') {
                get_cuota_rt();
            }
        };

        function get_cuota(){
            if(restriccion_flota == 1 && vm.type_of_trip_Validate_Booking != 'Z' && !vm.modifyFalgNew){
                //el convenio tiene restriccion de flota, se debe consultar la cuota
                setTimeout(function(){ 
                var tipo_servicio = vm.dataToFill.serviceTypeSelected;
                var fecha;
                var pasajeros = vm.dataToFill.passengerCount || 1;
                if(vm.dataToFill.selectedServiceDetails.category == 1 && vm.pickRange1 && vm.pickRange2 && vm.dataToFill.airportCheck != 'Z'  &&  vm.method_range_pickup){
                    fecha = moment(vm.dataToFill.dropDate).format('YYYY-MM-DD') +' '+ vm.pickRangeForRouting;
                } else if(vm.dataToFill.selectedServiceDetails.category == 1 && vm.pickRange1 && vm.pickRange2 && vm.dataToFill.airportCheck != 'Z'  &&  !vm.method_range_pickup && vm.showToleranceFlag == 0){
                    fecha = moment(vm.dataToFill.dropDate).format('YYYY-MM-DD') +' '+ vm.npickRange3;
                } else if(vm.dataToFill.selectedServiceDetails.category == 1 && vm.pickRange1 && vm.pickRange2 && vm.dataToFill.airportCheck != 'Z'  &&  !vm.method_range_pickup && vm.showToleranceFlag != 0){
                    fecha = moment(vm.dataToFill.dropDate).format('YYYY-MM-DD') +' '+ vm.newPickRange3;
                } else if(vm.dataToFill.scheduledBooking && vm.dataToFill.selectedServiceDetails.category == 1){
                    fecha = vm.dataToFill.dropDate;
                } else {
                    if(vm.dataToFill.selectedServiceDetails.category == 1){
                        if(vm.pickRange3)
                        fecha = moment(vm.dataToFill.scheduledTime).format('YYYY-MM-DD') +' '+ vm.pickRange3;
                    } else {
                        if(vm.dataToFill.scheduledBooking == 1){
                            fecha = vm.dataToFill.scheduledTime;
                        } else {
                            fecha = vm.dataToFill.dropDate;
                        } 
                    }
                }
                console.log(sucursal_id, tipo_servicio, fecha);
                if( sucursal_id && tipo_servicio && fecha ){
                    vm.loading = true;
                    cupos_fecha_global = moment(fecha).format('YYYY-MM-DD');
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.fecha = moment(fecha).format('YYYY-MM-DDTHH:mm:ss');
                    dataSend.tipo_servicio = tipo_servicio;
                    dataSend.sucursal_id = sucursal_id;
                    dataSend.pasajeros = pasajeros;
                    var promise = getBookingsHereMaps.getFlotaCuota(dataSend);
                    promise.then(
                        function (payload) {
                            vm.loading = false;
                            var response = JSON.parse(payload.response);
                            if (response.data) {
                                if(response.data.bloqueado == 1){
                                    errorMessageFactory.showErrorMessage("No hay disponibilidad del servicio seleccionado para el horario requerido. Revisa otras alternativas de horario", 0);
                                    vm.disabledSubmitButton = false;
                                    vm.fullCuota = true;
                                    return false;
                                }
                                vm.disabledSubmitButton = true;
                                vm.fullCuota = false;
                                return true;
                            }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );

                }
                return true;
                }, 2000);
            }
            return true;
        }
        
        function get_cuota_rt(){
            if(restriccion_flota == 1 && vm.dataToFill.roundTrip && vm.type_of_trip_Validate_Booking == 'Z' && !vm.modifyFalgNew){
                //el convenio tiene restriccion de flota, se debe consultar la cuota
                setTimeout(function(){
                var tipo_servicio = vm.dataToFill.serviceTypeSelected;
                var pasajeros = vm.dataToFill.passengerCount || 1;
                var fecha;
                if(vm.dataToFill.selectedServiceDetails.category == 1  && vm.method_range_pickup_return){
                    if(vm.pickRangeForRoutingReturn){
                        fecha = moment(vm.dataToFill.dropDateReturn).format('YYYY-MM-DD') +' '+ vm.pickRangeForRoutingReturn;
                    }
                } else if(!vm.method_range_pickup_return && vm.dataToFill.selectedServiceDetails.category == 1){
                    if(vm.pickRange5){
                        fecha = moment(vm.dataToFill.dropDateReturn).format('YYYY-MM-DD') +' '+ vm.pickRange5;
                    }
                } else if(vm.dataToFill.scheduledBooking && vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip == 'R' && vm.pickRange2){
                    fecha = moment(vm.dataToFill.dropDateReturn).format('YYYY-MM-DD') +' '+ vm.pickRange2;
                } else{
                    fecha = moment(vm.dataToFill.dropDateReturn).format('YYYY-MM-DD H:mm:ss');
                }
                console.log(sucursal_id, tipo_servicio, fecha);
                if( sucursal_id && tipo_servicio && fecha ){
                    vm.loading = true;
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.fecha = moment(fecha).format('YYYY-MM-DDTHH:mm:ss');
                    dataSend.tipo_servicio = tipo_servicio;
                    dataSend.sucursal_id = sucursal_id;
                    dataSend.pasajeros = pasajeros;
                    var promise = getBookingsHereMaps.getFlotaCuota(dataSend);
                    promise.then(
                        function (payload) {
                            vm.loading = false;
                            var response = JSON.parse(payload.response);
                            if (response.data && vm.dataToFill.roundTrip) {
                                if(cupos_fecha_global == moment(vm.dataToFill.returnDate).format('YYYY-MM-DD')){
                                    response.data.cupos = response.data.cupos;
                                }
                                if(response.data.bloqueado == 1){
                                    errorMessageFactory.showErrorMessage("No hay disponibilidad del servicio seleccionado para el horario RT requerido. Revisa otras alternativas de horario.", 0);
                                    vm.disabledSubmitButton = false;
                                    vm.fullCuotaRT = true;
                                    return false;
                                }
                                if(vm.fullCuota){
                                    vm.disabledSubmitButton = false;
                                } else {
                                    vm.disabledSubmitButton = true;
                                }
                                vm.fullCuotaRT = false;
                                return true;
                            }
                            if(vm.fullCuota){
                                vm.disabledSubmitButton = false;
                            } else {
                                vm.disabledSubmitButton = true;
                            }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );

                }
                return true;
                }, 2000);
            }
            return true;
        }
        function geocodePosition(pos, type, marker) {
            //console.log("second //console");

            geocoder.geocode({
                latLng: pos
            }, function (results) {
                if (results && results.length > 0) {
                    //console.log(results[0]);
                    if (type == 'pick') {
                        $scope.addressPick = hidePublicPlaces.formattedAddress(results[0]);
                        var city;
                        for (var i = 0; i < results[0].address_components.length; i++) {
                            for (var j = 0; j < results[0].address_components[i].types.length; j++) {
                                if (results[0].address_components[i].types[j] == 'locality') {
                                    city = results[0].address_components[i].short_name;
                                    vm.jobPickupComuna = city;
                                }
                            }
                        }
                        if (vm.pickUpCity && (vm.pickUpCity != city)) {
                            errorMessageFactory.showErrorMessage('Error, esta dirección cambia el tramo original. El cambio no debe afectar la tarifa.', 0);
                            // results= '';
                            vm.dataToFill.pickUpAddress = vm.pickUpAddress;
                            vm.dataToFill.pickUpLat = vm.bookingDetails.job_pickup_latitude;
                            vm.dataToFill.pickUpLng = vm.bookingDetails.job_pickup_longitude;
                            marker.setPosition(new google.maps.LatLng(vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng))
                            return;
                        } else {
                            vm.dataToFill.pickUpAddress = $scope.addressPick;
                        }

                        $scope.$apply();
                    } else if (type == 'drop') {
                        $scope.addressDrop = hidePublicPlaces.formattedAddress(results[0]);

                        var city;
                        for (var i = 0; i < results[0].address_components.length; i++) {
                            for (var j = 0; j < results[0].address_components[i].types.length; j++) {
                                if (results[0].address_components[i].types[j] == 'locality') {
                                    city = results[0].address_components[i].short_name;
                                    vm.jobDropoffComuna = city;
                                }
                            }
                        }
                        if (vm.pickUpCity && (vm.pickUpCity != city)) {
                            errorMessageFactory.showErrorMessage('Error, esta dirección cambia el tramo original. El cambio no debe afectar la tarifa.', 0);
                            // results= '';
                            vm.dataToFill.dropOffAddress = vm.dropUpAddress;
                            vm.dataToFill.dropOffLat = vm.bookingDetails.job_latitude;
                            vm.dataToFill.dropOffLng = vm.bookingDetails.job_longitude;
                            marker.setPosition(new google.maps.LatLng(vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng))
                            return;
                        } else {
                            vm.dataToFill.dropOffAddress = $scope.addressDrop;
                        }
                        $scope.$apply();
                    }
                }
            })
        };

        // var marker = {};
        function placeMarker(map, location, data, driverData) {
            console.log('placemarker', data, map);
            //var id = uniqueId();
            var id;
            if (data == 'pick') {
                id = 'pick';
                if (markers.length) {
                    for (var i = 0; i < markers.length; i++) {
                        if (markers[i].id == 'pick') {
                            setMapOnAll(null, 'pick');
                        }
                    }
                } else {
                    id = 'pick';
                }
            } else if (data == 'drop') {
                id = 'drop';
                if (markers.length) {
                    for (var i = 0; i < markers.length; i++) {
                        if (markers[i].id == 'drop') {
                            setMapOnAll(null, 'drop');
                        }
                    }
                } else {
                    id = 'drop';
                }
            } else if (data == 'driver') {
                id = 'driver';
                var icon = {
                    url: '',
                    size: new google.maps.Size(70, 70),
                    scaledSize: new google.maps.Size(50, 50), // scaled size
                    origin: new google.maps.Point(0, 0), // origin
                    labelOrigin: new google.maps.Point(25, 15),
                    anchor: new google.maps.Point(17, 34) // anchor
                };
                var label = {
                    text: Math.floor(driverData.eta / 60).toString(),
                    fontSize: '10px'
                };
            }
            if (driverData) {
                if (driverData.status == 0 && driverData.is_available == 1) {
                    //icon.url = 'assets/images/on_duty.png';
                    icon.url = driverData.vehicle_img_online ? driverData.vehicle_img_online : 'assets/images/on_duty.png';
                } else if (driverData.status == 1 && driverData.is_available == 1 && driverData.job_status == 15) {
                    //icon.url = 'assets/images/in_road.png';
                    icon.url = driverData.vehicle_img_road ? driverData.vehicle_img_road : 'assets/images/in_road.png';
                } else if (driverData.status == 1 && driverData.is_available == 1 && driverData.job_status == 7) {
                    //icon.url = 'assets/images/in_road.png';
                    icon.url = driverData.vehicle_img_accepted ? driverData.vehicle_img_accepted : 'assets/images/in_road.png';
                } else if (driverData.status == 1 && driverData.is_available == 1 && driverData.job_status == 1) {
                    //icon.url = 'assets/images/at_position.png';
                    icon.url = driverData.vehicle_img_position ? driverData.vehicle_img_position : 'assets/images/at_position.png';
                } else if (driverData.status == 1 && driverData.is_available == 1 && driverData.job_status == 4) {
                    //icon.url = 'assets/images/service_started.png';
                    icon.url = driverData.vehicle_img_busy ? driverData.vehicle_img_busy : 'assets/images/service_started.png';
                }
            }
            var marker = new google.maps.Marker({
                id: id,
                position: location,
                draggable: id == 'driver' ? false : true,
                map: map,
                fleetId: data == 'driver' ? driverData.fleet_id : '',
                label: data == 'driver' ? label : '',
                icon: data == 'driver' ? icon : ''
            });
            if (map) {
                bounds.extend(location);
                map.fitBounds(bounds);
                markers.push(marker);
            }
            //console.log(markers);
            if (data == 'driver') {
                marker.content = '<div class="row" id="googleMapsDetailsWithCar">' +
                    '<div class="col-lg-12 col-sm-12 col-xs-12 col-md-12">' +
                    '<div class="row">' +
                    '<div class="col-lg-12 col-sm-12 col-xs-12 col-md-12">' +
                    '<p class="toAssignText">To Assign</p>' +
                    '</div>' +
                    '<div class="col-lg-12 col-sm-12 col-xs-12 col-md-12">' +
                    '<p class="toAssignTextETA"> ETA:' + Math.floor(driverData.eta / 60) + 'min</p>' +
                    '</div>' +
                    '<div class="col-lg-12 col-sm-12 col-xs-12 col-md-12 paddinButtonD">' +
                    '<button class="btn btn-primary tableButton" type="button" id="confirmDriver">Confirm</button>' +
                    '<button class="btn btn-primary tableButton" type="button" id="cancelDriver">Cancel</button>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>';
            }
            google.maps.event.addListener(marker, 'click', function (event) {
                //console.log(marker, marker.id);
                if (marker.id == 'driver') {
                    vm.markerFleetID = marker.fleetId;
                    infowindow.setContent(marker.content);
                    infowindow.open(map, marker);
                }
            });
            google.maps.event.addListener(marker, 'dragend', function (event) {
                //console.log(marker,"marker");

                //console.log(event);
                //console.log(this);
                if (this.id == 'pick') {
                    $scope.addressLat = this.getPosition().lat();
                    $scope.addressLng = this.getPosition().lng();
                    vm.dataToFill.pickUpLat = $scope.addressLat;
                    vm.dataToFill.pickUpLng = $scope.addressLng;
                    geocodePosition(this.getPosition(), 'pick', marker);
                    if (vm.dataToFill.serviceTypeSelected) { //&& (vm.dataToFill.bookingType == '0' || vm.dataToFill.bookingType == 0)
                        vm.dataToFill.nearDriver = '';
                        toGetAirportService(vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.serviceTypeSelected, map);
                        //toGetNearByDrivers(vm.dataToFill.pickUpLat,vm.dataToFill.pickUpLng,vm.dataToFill.serviceTypeSelected,map);
                    }
                    $scope.$apply();
                } else if (this.id == 'drop') {
                    $scope.addressDLat = this.getPosition().lat();
                    $scope.addressDLng = this.getPosition().lng();
                    vm.dataToFill.dropOffLat = $scope.addressDLat;
                    vm.dataToFill.dropOffLng = $scope.addressDLng;
                    geocodePosition(this.getPosition(), 'drop', marker);
                    //getFixedRoutesForPersonal(vm.dataToFill);
                    $scope.$apply();
                }
                $timeout(function () {
                    if (vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                        calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, map);
                        getFixedRoutesForPersonal(vm.dataToFill);
                    }
                }, 2000)


            });
            if (vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat && id != 'driver') {
                calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, map);
                getFixedRoutesForPersonal(vm.dataToFill);
            }
        };

        function mapInitialize(data) {
            console.log(vm.flightDateValidation, vm.scheduleDateValidation, vm.dropoffDateValidation,
                'vm.flightDateValidation || vm.scheduleDateValidation || vm.dropoffDateValidation');
            vm.showGoogleMap = true;
            mapProp = {
                center: myCenter,
                zoom: Number(zoomLevel),
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                minZoom: 3,
                maxZoom: 18,
                scrollwheel: false
            };
            document.getElementById("googleMap").style.height = window.innerHeight - 200 + 'px';
            map = new google.maps.Map(document.getElementById("googleMap"), mapProp);
            map.setOptions({
                styles: hidePublicPlaces.hidePublic()
            });
            google.maps.event.addListener(map, 'center_changed', function () {
                checkBounds(map);
            });
            var location;
            var type;
            if (vm.dropaddressChange = true) {
                location = new google.maps.LatLng(vm.dataToFill.dropLat, vm.dataToFill.dropLng);
                type = 'drop';
                placeMarker(map, location, type);
            }
            if (vm.pickaddressChange = true) {
                location = new google.maps.LatLng(vm.dataToFill.pickLat, vm.dataToFill.pickLng);
                type = 'pick';
                placeMarker(map, location, type);
            }
        };
        initAutocomplete();
        // mapInitialize();

        //=======================number of passenger============================
        function numberOfPassenger(data) {
            vm.disabledSubmitButton1 = true;
            vm.addressChange = true;
            if (vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, map);
                getFixedRoutesForPersonal(vm.dataToFill);
            }
            var where = _.where(vm.serviceTypeList, {
                id: Number(vm.dataToFill.serviceTypeSelected)
            });

            if (data > where[0].max_limit) {
                vm.dataToFill.numberOfPassengerError = true;
                vm.dataToFill.numberOfPassengerCount = where[0].max_limit;
            } else {
                vm.dataToFill.numberOfPassengerError = false;
                vm.dataToFill.numberOfPassengerCount = 0;
            }
            if (vm.dataToFill.selectedServiceDetails.fare_type == 1) {
                vm.dataToFill.viaControlled = Number(vm.dataToFill.viaControlledReal) * Number(vm.dataToFill.passengerCount);
            } else {
                vm.dataToFill.viaControlled = Number(vm.dataToFill.viaControlledReal);
            }
            $timeout(function () {
                if (vm.dataToFill.route_type == 1) {

                    vm.dataToFill.estimatedFare = 0;
                    vm.dataToFill.Return_policy.estimatedFare = 0;
                    for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                        vm.dataToFill.estimatedFare = vm.dataToFill.estimatedFare + Number(vm.dataToFill.itemOfChargeSelected[i].price);
                    }
                    vm.dataToFill.estimatedFare = vm.dataToFill.selectedServiceDetails.fare_type ? Number(vm.dataToFill.estimatedFareRoute) * Number(vm.dataToFill.passengerCount) + Number(vm.dataToFill.estimatedFare) : Number(vm.dataToFill.estimatedFare) + Number(vm.dataToFill.estimatedFareRoute);
                    vm.dataToFill.Return_policy.estimatedFare = vm.dataToFill.selectedServiceDetails.fare_type ? Number(vm.dataToFill.Return_policy.estimatedFareRoute) * Number(vm.dataToFill.passengerCount) + Number(vm.dataToFill.Return_policy.estimatedFare) : Number(vm.dataToFill.Return_policy.estimatedFare) + Number(vm.dataToFill.Return_policy.estimatedFareRoute);
                    //vm.dataToFill.estimatedFareRoute =  vm.dataToFill.estimatedFare;

                } else {
                    //var calEstFare = vm.dataToFill.selectedServiceDetails.fare_type?Number((vm.dataToFill.estimatedDistance * payload.title.data[0].perKMChanges.toFixed(2))+payload.title.data[0].baseFare) * Number(vm.dataToFill.passengerCount):Number((vm.dataToFill.estimatedDistance * payload.title.data[0].perKMChanges.toFixed(2))+payload.title.data[0].baseFare);
                    //vm.dataToFill.estimatedFareRoute = calEstFare < payload.title.data[0].minimumFare ? payload.title.data[0].minimumFare : calEstFare;
                    //vm.dataToFill.estimatedFare = vm.dataToFill.estimatedFareRoute;
                    //vm.dataToFill.estimatedFareVariable = calEstFare;
                    //vm.dataToFill.estimatedFareRoute = calEstFare;
                    //vm.dataToFill.minimumFare = payload.title.data[0].minimumFare;
                    vm.dataToFill.estimatedFare = 0;
                    vm.dataToFill.Return_policy.estimatedFare = 0;
                    for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                        vm.dataToFill.estimatedFare = vm.dataToFill.estimatedFare + Number(vm.dataToFill.itemOfChargeSelected[i].price);
                    }
                    var calFare = vm.dataToFill.selectedServiceDetails.fare_type ? Number(vm.dataToFill.estimatedFareRoute) * Number(vm.dataToFill.passengerCount) + Number(vm.dataToFill.estimatedFare) : Number(vm.dataToFill.estimatedFare) + Number(vm.dataToFill.estimatedFareRoute);
                    var calFareReturn = vm.dataToFill.selectedServiceDetails.fare_type ? Number(vm.dataToFill.Return_policy.estimatedFareRoute) * Number(vm.dataToFill.passengerCount) + Number(vm.dataToFill.Return_policy.estimatedFare) : Number(vm.dataToFill.Return_policy.estimatedFare) + Number(vm.dataToFill.Return_policy.estimatedFareRoute);
                    vm.dataToFill.estimatedFare = calFare < vm.dataToFill.minimumFare ? vm.dataToFill.minimumFare : calFare;
                    vm.dataToFill.Return_policy.estimatedFare = calFareReturn < vm.dataToFill.minimumFare ? vm.dataToFill.minimumFare : calFareReturn;
                    // if (vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                    //     calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, map);
                    //     getFixedRoutesForPersonal(vm.dataToFill);
                    // }
                }
                vm.disabledSubmitButton1 = false;
            }, 3000)

        };

        function calculateDateRangeOfPointToPoint() {
            var datePointToPoint = dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime)
            // var pickRangeForRtypeReturn = moment(datePointToPoint).subtract((((vm.pickup_travel_time_pap != 0 ? vm.dataToFill.etaScheduleValue : 0)  + vm.pickup_travel_time_pap) * 60), 'seconds');
            var newpickRangeForRtypeReturn = '';
            if (vm.is_group_allowed == 1) {
                newpickRangeForRtypeReturn = moment(datePointToPoint).subtract((vm.time_trip_shared_service_point_to_point * 60), 'seconds');
            } else {
                newpickRangeForRtypeReturn = datePointToPoint;
            }
            if (vm.modifyFalgNew) {
                vm.ptoptravelTime = moment(vm.bookingDetails.time_with_tolerance_before).format('HH:mm');
            } else {
                vm.ptoptravelTime = moment(newpickRangeForRtypeReturn).format('HH:mm');
            }
            var rangePointToPoint = moment(datePointToPoint).add((vm.time_trip_shared_service_point_to_point * 60), 'seconds');
            vm.rangeOfPointToPoint = moment(rangePointToPoint).format('HH:mm');
        }

        function calculateDateRangeOfPointToPointReturn() {
            var datePointToPoint = dateTimeFormat(vm.dataToFill.returnDate, vm.dataToFill.returnTime);
            // var pickRangeForRtypeReturn = moment(datePointToPoint).subtract((((vm.pickup_travel_time_pap !=0 ? vm.dataToFill.etaScheduleValueReturn : 0) + vm.pickup_travel_time_pap) * 60), 'seconds');
            var newpickRangeForRtypeReturn = '';
            if (vm.is_group_allowed == 1) {
                newpickRangeForRtypeReturn = moment(datePointToPoint).subtract((vm.time_trip_shared_service_point_to_point * 60), 'seconds');
            } else {
                newpickRangeForRtypeReturn = datePointToPoint;
            }
            if (vm.modifyFalgNew) {
                vm.ptoptravelTimeReturn = moment(vm.bookingDetails.time_with_tolerance_before).format('HH:mm');
            } else {
                vm.ptoptravelTimeReturn = moment(newpickRangeForRtypeReturn).format('HH:mm');
            }
            // vm.ptoptravelTimeReturn = moment(newpickRangeForRtypeReturn).format('HH:mm');
            var rangePointToPoint = moment(datePointToPoint).add((vm.time_trip_shared_service_point_to_point * 60), 'seconds')
            vm.rangeOfPointToPointReturn = moment(rangePointToPoint).format('HH:mm');
            console.log(vm.rangeOfPointToPointReturn, vm.ptoptravelTimeReturn, 'vm.rangeOfPointToPointReturn');

        }
        //=======================RoutingApiFuncation ========================
        var index = 1;
        var indexReturn = 1;
        vm.pickRangeSendForRouting = [];
        vm.etaArray = [];
        vm.timeZoneRecurring = [];
        vm.pickup_top_range = [];
        vm.pickup_lower_range = [];
        vm.bookingEta = false;
        vm.bookingError = false;

        function RoutingApiFuncation(data, index, type) {
            var dataSend = {};
            var tz = moment.tz.guess();
            dataSend.access_token = $cookies.get('obj');;
            dataSend.origin_longitude = data.pickUpLng;
            dataSend.origin_latitude = data.pickUpLat;
            dataSend.destination_latitude = data.dropOffLat;
            dataSend.destination_longitude = data.dropOffLng;
            dataSend.is_admin = 1;
            var convert_date = dateTimeFormat(type != 'recurring' ? vm.dataToFill.dropDate : vm.dataToFill.tillDate, vm.dataToFill.dropTime).toISOString();
            convert_date = moment(convert_date).valueOf();
            dataSend.destination_at = moment(convert_date).format('YYYY-MM-DDTHH:mm:ssZ');
            if(vm.routingBase && vm.routingBase.zone_bucket)
                dataSend.zone_bucket = vm.routingBase.zone_bucket;
            vm.loading = true;
            var promise = getBookingsHereMaps.RoutingApi(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    setTimeout(function(){
                        vm.disabledSubmitButton1 = false;
                    }, 1500);
                    console.log(payload, 'payload');
                    // vm.dataToFill.ReturnEstimatedDistance
                    // vm.dataToFill.estimatedDistance
                    if (payload && payload.title.status == 200) {
                        vm.etaArray[index] = (payload.title.data.estimated_travel_time)
                        vm.dataToFill.etaSchedule = vm.etaArray[0];
                        vm.bookingEta = true;
                        vm.timeZoneRecurring[index] = (moment.tz.zone(tz).utcOffset(moment(new Date(payload.title.data.estimated_pickup_datetime).toISOString())));
                        vm.pickRangeSendForRouting[index] = (new Date(payload.title.data.estimated_pickup_datetime).toISOString());
                        vm.pickup_lower_range[index] = (new Date(payload.title.data.pickup_lower_range).toISOString());
                        vm.pickup_top_range[index] = (new Date(payload.title.data.pickup_top_range).toISOString());
                        vm.dataToFill.estimatedDistance = 0;
                        vm.dataToFill.estimatedDistance = roundToTwo(((payload.title.data.travel_distance) / 1000));
                        vm.distanceRoutingApi = (payload.title.data.travel_distance);
                        vm.pickRangeForRouting = moment(vm.pickRangeSendForRouting[0]).format('HH:mm');

                    } else {
                        if (index == 1) {
                            vm.dataToFill.etaSchedule = 0;
                            vm.bookingEta = false;
                            RoutingApiFuncation(vm.dataToFill, 0);
                            index++;
                        } else {
                            vm.bookingEta = false;
                            vm.bookingError = true;
                            errorMessageFactory.showErrorMessage('Error al calcular el Retiro. Error en la llamada a la API', 0);
                        }
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function RoutingApiFuncationRoundTrip(data) {
            var dataSend = {};
            var tz = moment.tz.guess();
            dataSend.access_token = $cookies.get('obj');;
            dataSend.origin_longitude = data.dropOffLng;
            dataSend.origin_latitude = data.dropOffLat;
            dataSend.destination_latitude = data.pickUpLat;
            dataSend.destination_longitude = data.pickUpLng;
            dataSend.is_admin = 1;
            vm.pickRangeSendForRoutingReturn = '';
            vm.pickRangeForRoutingReturn = '';
            var convert_date = dateTimeFormat(vm.dataToFill.dropDateReturn, vm.dataToFill.dropTimeReturn).toISOString();
            convert_date = moment(convert_date).valueOf();
            dataSend.destination_at = moment(convert_date).format('YYYY-MM-DDTHH:mm:ssZ');
            vm.loading = true;
            var promise = getBookingsHereMaps.RoutingApi(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload && payload.title.status == 200) {
                        vm.bookingEta = true;
                        vm.timeZoneRRoundReturn = (moment.tz.zone(tz).utcOffset(moment(new Date(payload.title.data.estimated_pickup_datetime).toISOString())));
                        vm.dataToFill.etaScheduleValueReturn = (payload.title.data.estimated_travel_time);
                        vm.pickRangeSendForRoutingReturn = (new Date(payload.title.data.estimated_pickup_datetime).toISOString());
                        vm.pickup_lower_range_return = (new Date(payload.title.data.pickup_lower_range).toISOString());
                        vm.dataToFill.ReturnEstimatedDistance = 0;
                        vm.dataToFill.ReturnEstimatedDistance = roundToTwo(((payload.title.data.travel_distance) / 1000));
                        vm.distanceRoutingApiReturn = (payload.title.data.travel_distance);
                        vm.pickup_top_range_return = (new Date(payload.title.data.pickup_top_range).toISOString());
                        vm.pickRangeForRoutingReturn = moment(vm.pickRangeSendForRoutingReturn).format('HH:mm');
                    } else {
                        if (indexReturn == 1) {
                            vm.dataToFill.etaSchedule = 0;
                            vm.bookingEta = false;
                            RoutingApiFuncationRoundTrip(vm.dataToFill, 0);
                            indexReturn++;
                        } else {
                            vm.bookingEta = false;
                            vm.bookingError = true;
                            errorMessageFactory.showErrorMessage('Error al calcular el Retiro. Error en la llamada a la API', 0);
                        }
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }


        //=======================get fixed routes for personal========================
        function getFixedRoutesForPersonal(data) {
            console.log(data, 'data>>>>>>>>>>>>>');
            // vm.modifyFalgNew = false;
            $log.log(data);
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.pickup_lat = data.pickUpLat;
            dataSend.pickup_long = data.pickUpLng;
            dataSend.drop_lat = data.dropOffLat;
            dataSend.drop_long = data.dropOffLng;
            dataSend.passenger_count = data.passengerCount;
            if(data.selectedServiceDetails == "" || data.pickUpLat == '' || data.dropOffLat == ''){
                return;
            }
            var fecha;
            if(data.selectedServiceDetails.category == 1 && data.airportCheck != 'Z'  &&  vm.method_range_pickup){
                if(vm.pickRangeForRouting){
                    fecha = moment(data.dropDate).format('YYYY-MM-DD') +' '+ vm.pickRangeForRouting;
                }
            } else if(data.selectedServiceDetails.category == 1 && vm.pickRange1 && vm.pickRange2 && data.airportCheck != 'Z'  &&  !vm.method_range_pickup){
                fecha = moment(data.dropDate).format('YYYY-MM-DD') +' '+ vm.newPickRange3;
            } else if(data.scheduledBooking && data.selectedServiceDetails.category == 1){
                fecha = data.dropTime;
            } else {
                if(data.bookingType == '0'){
                    fecha = data.dropDate;
                } else {
                    if(data.scheduledBooking == 1){
                        fecha = data.scheduledTime;
                    } else {
                        fecha = data.dropDate;
                    } 
                }
            }
            if(fecha == null){
                return;
            }
            dataSend.pickup_datetime = moment(fecha).format('YYYY-MM-DDTHH:mm:ss');
            var fecha_return;
            if(vm.dataToFill.selectedServiceDetails.category == 1  && vm.method_range_pickup_return){
                if(vm.pickRangeForRoutingReturn){
                    fecha_return = moment(vm.dataToFill.dropDateReturn).format('YYYY-MM-DD') +' '+ vm.pickRangeForRoutingReturn;
                }
                else if(vm.pickRange5){
                    fecha_return = moment(vm.dataToFill.dropDateReturn).format('YYYY-MM-DD') +' '+ vm.pickRange5;
                }
            } else if(!vm.method_range_pickup_return && vm.dataToFill.selectedServiceDetails.category == 1){
                if(vm.pickRange5){
                    fecha_return = moment(vm.dataToFill.dropDateReturn).format('YYYY-MM-DD') +' '+ vm.pickRange5;
                }
            } else if(vm.dataToFill.scheduledBooking && vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip == 'R' && vm.pickRange2){
                fecha_return = moment(vm.dataToFill.dropDateReturn).format('YYYY-MM-DD') +' '+ vm.pickRange2;
            } else{
                fecha_return = moment(vm.dataToFill.returnDate).format('YYYY-MM-DD HH:mm:ss');
            }
            dataSend.pickup_datetime_return = moment(fecha_return).format('YYYY-MM-DDTHH:mm:ss');
            if (vm.modifyFalg == true && vm.bookingDetails != undefined) {
                dataSend.job_id = vm.bookingDetails.job_id;
            }
            var isAirportFlag = 0;
            if (vm.fromAirportFlag) {
                isAirportFlag = 1;
            } else if (vm.toAirportFlag) {
                isAirportFlag = 2;
            }
            dataSend.airport = Number(isAirportFlag);
            if (vm.getInfoFlag == true) {
                dataSend.contract_id = vm.bookingDetails.contract_id
            } else {
                dataSend.contract_id = data.contractIdSelected;
            }
            dataSend.service_type = data.serviceTypeSelected;
            vm.loading = true;
            if (data.serviceTypeSelected) {
                var promise = getBookingsHereMaps.getFixedRoutesForPersonal(dataSend);
                promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        console.log(payload, 'payload>>>>>>>>>>>SearchFixedVariable');
                        vm.searchFixedVariablePayload = payload;
                        vm.routingBase = payload.title.data.routing_base;
                        // Enabled category for routing base
                        if(vm.routingBase && vm.routingBase.routing_base_id > 0) {
                            vm.dataToFill.selectedServiceDetails.category = 1;
                            vm.method_range_pickup = 1;
                        }
                        if (payload.title.status == 400) {
                            vm.dataToFill.favPickLocId = '';
                            vm.dataToFill.favDropLocId = '';
                            vm.dataToFill.route_id = '';
                            vm.Flag = false;
                            vm.dataToFill.itemOfChargeList = [];
                            vm.dataToFill.itemOfChargeSelected = [];
                            if (payload.title.data && payload.title.data.custom_error) {
                                openPopForErrorAddress(payload);
                            } else {
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            }
                        } else if (payload.title.status == 401) {

                            //console.log(vm.dataToFill.route_id, 'vm.dataToFill.route_id123');
                            vm.dataToFill.favPickLocId = '';
                            vm.dataToFill.favDropLocId = '';
                            vm.Flag = false;
                            vm.dataToFill.route_id = '';
                            vm.dataToFill.itemOfChargeList = [];
                            vm.dataToFill.itemOfChargeSelected = [];
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            // if(!vm.modifyFalg) {
                                $timeout(function () {
                                    if (vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                                        calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, map, 'SINGLE TRIP', payload);
                                        // getFixedRoutesForPersonal(vm.dataToFill);
    
                                    }
                                }, 1000)
                            // }
                            vm.payloadForsearchFixedVairable = payload;
                            vm.dataToFill.route_id = payload.title.data.id;
                            sucursal_id = payload.title.data.branch;
                            if(payload.title.data.factor){
                                if(payload.title.data.factor.excepciones){
                                    vm.dataToFill.factor_value = payload.title.data.factor.excepciones[0].factor;
                                    vm.dataToFill.factor_tipo = 1;
                                    vm.dataToFill.factor_id = payload.title.data.factor.excepciones[0].id;
                                } else if(payload.title.data.factor.bloques){
                                    vm.dataToFill.factor_value = payload.title.data.factor.bloques[0].factor;
                                    vm.dataToFill.factor_tipo = 0;
                                    vm.dataToFill.factor_id = payload.title.data.factor.bloques[0].id;
                                }
                            } else {
                                delete vm.dataToFill.factor_value;
                                delete vm.dataToFill.factor_tipo;
                                delete vm.dataToFill.factor_id;
                            }
                            if(payload.title.data.finalResult_return.factor){
                                if(payload.title.data.finalResult_return.factor.excepciones){
                                    vm.dataToFill.factor_return_value = payload.title.data.finalResult_return.factor.excepciones[0].factor;
                                    vm.dataToFill.factor_return_tipo = 1;
                                    vm.dataToFill.factor_return_id = payload.title.data.finalResult_return.factor.excepciones[0].id;
                                } else if(payload.title.data.finalResult_return.factor.bloques){
                                    vm.dataToFill.factor_return_value = payload.title.data.finalResult_return.factor.bloques[0].factor;
                                    vm.dataToFill.factor_return_tipo = 0;
                                    vm.dataToFill.factor_return_id = payload.title.data.finalResult_return.factor.bloques[0].id;
                                }
                            } else {
                                delete vm.dataToFill.factor_return_value;
                                delete vm.dataToFill.factor_return_tipo;
                                delete vm.dataToFill.factor_return_id;
                            }
                            if (payload.title.data.id) {
                                vm.Flag = true;
                            } else {
                                vm.Flag = false;
                            }
                            vm.couponFlag = true;
                            $timeout(function (data) {
                                vm.getFixedRoutesForPersonalFlag = false;
                            }, 4000)
                            vm.type_of_trip1 = payload.title.data.type_of_trip;
                            vm.method_range_pickup = payload.title.data.method_range_pickup;
                            vm.method_range_pickup_return = payload.title.data.method_range_pickup;
                            vm.tolerance_for_shared_R = payload.title.data.tolerance;
                            vm.tolerance_time_withdrawal_pickup = payload.title.data.tolerance_time_withdrawal_pickup;
                            vm.travel_time_service_pick_up = payload.title.data.travel_time_service_pick_up;
                            //restriccion_flota = payload.title.data.restriccion_flota;
                            if (payload.title.data.type_of_trip == "Z") {
                                //console.log("yahan hun ma ");

                                vm.viaControlledFLag1 = true;
                                // vm.dataToFill.viaControlledApply = true;
                            } else {
                                vm.viaControlledFLag1 = false;
                                // vm.dataToFill.viaControlledApply = false;
                                // && vm.dataToFill.controlledWayCheck == 1
                            }
                            if (payload.title.data.pickup_tolerance_time_pap) {
                                vm.time_trip_shared_service_point_to_point = payload.title.data.pickup_tolerance_time_pap;
                                vm.pickup_travel_time_pap = payload.title.data.pickup_travel_time_pap;
                            } else {
                                vm.time_trip_shared_service_point_to_point = 0;
                                vm.pickup_travel_time_pap = 0;
                            }
                            vm.is_group_allowed = payload.title.data.is_group_allowed;
                            vm.is_group_external = payload.title.data.is_grouped_external;
                            vm.type_of_trip_Validate_Booking = payload.title.data.type_of_trip;
                            if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking == 'P') {
                                calculateDateRangeOfPointToPoint();
                            }
                            if (payload.title.data.type_of_trip == "Z" && payload.title.data.controlled_way_flag == 1 && vm.dataToFill.controlledWayCheck == 1) {
                                // vm.viaControlled1 = payload.title.data.via_controlled_price;
                                if (vm.dataToFill.selectedServiceDetails.fare_type == 1 &&
                                    vm.dataToFill.selectedServiceDetails.category == 1) {
                                    vm.viaControlled1 = payload.title.data.via_controlled_price + (payload.title.data.via_controlled_price * (vm.dataToFill.passengerCount - 1));
                                    console.log(vm.viaControlled1, ' vm.viaControlled1');

                                    // vm.addViaControlled = 0;
                                } else {
                                    vm.viaControlled1 = payload.title.data.via_controlled_price;
                                    // vm.addViaControlled = 0;
                                }


                            } else {
                                vm.viaControlled1 = 0;
                            }
                            vm.dataToFill.route_type = payload.title.data.type_of_route;
                            console.log("1352254", vm.dataToFill.route_type);

                            vm.dataToFill.type_of_agreement = vm.dataToFill.customerProfile == 0 || vm.dataToFill.customerProfile == '0' ? 0 : 1;
                            vm.dataToFill.itemOfChargeList = [];
                            vm.dataToFill.itemOfChargeSelected = [];
                            vm.showToleranceFlag = payload.title.data.price_list.typeOfService.show_time_range;
                            if (payload.title.data.price_list.itemOfCharge && payload.title.data.price_list.itemOfCharge.length) {
                                for (var i = 0; i < payload.title.data.price_list.itemOfCharge.length; i++) {
                                    payload.title.data.price_list.itemOfCharge[i].quantity = 1;
                                    payload.title.data.price_list.itemOfCharge[i].oldPrice = payload.title.data.price_list.itemOfCharge[i].price;
                                    if (payload.title.data.price_list.itemOfCharge[i].tic_manually == 1) {
                                        var itemRet = payload.title.data.price_list.itemOfCharge[i];
                                        itemRet.tic_long_name = itemRet.tic_long_name + ' (Ida)';
                                        itemRet.retorno = false;
                                        vm.dataToFill.itemOfChargeList.push(itemRet);
                                    }
                                }
                            } else {
                                vm.dataToFill.itemOfChargeList = [];
                            }
                            // ********** ESTIMATE PRICE SHOW ********* 
                            // $timeout(function () {
                            //     if (vm.dataToFill.route_type == 1) {
                            //         vm.dataToFill.estimatedFareVariable = vm.dataToFill.selectedServiceDetails.fare_type ? Number(payload.title.data.price) * Number(vm.dataToFill.passengerCount) : payload.title.data.price;
                            //         vm.dataToFill.estimatedFareRoute = vm.dataToFill.selectedServiceDetails.fare_type ? Number(payload.title.data.price) * Number(vm.dataToFill.passengerCount) : payload.title.data.price;
                            //         vm.dataToFill.estimatedFare = vm.dataToFill.estimatedFareRoute;
                            //         vm.dataToFill.estimatedFareRoute = Number(payload.title.data.price);
                            //         vm.dataToFill.minimumFare = 0;

                            //     } else {
                            //         if (vm.dataToFill.estimatedDistance != undefined)
                            //         var calEstFare = Number((vm.dataToFill.estimatedDistance * payload.title.data.perKMChanges.toFixed(2)) + payload.title.data.baseFare);
                            //         // console.log('calEstFarecalEstFarecalEstFare', calEstFare);
                            //         vm.dataToFill.estimatedFareRoute = vm.dataToFill.selectedServiceDetails.fare_type ? ((Number(calEstFare) * Number(vm.dataToFill.passengerCount)) < payload.title.data.minimumFare ? payload.title.data.minimumFare : (Number(calEstFare) * Number(vm.dataToFill.passengerCount))) : (calEstFare < payload.title.data.minimumFare ? payload.title.data.minimumFare : calEstFare);
                            //         vm.dataToFill.estimatedFare = vm.dataToFill.estimatedFareRoute;
                            //         vm.dataToFill.estimatedFareVariable = calEstFare;
                            //         vm.dataToFill.estimatedFareRoute = calEstFare;
                            //         vm.dataToFill.minimumFare = payload.title.data.minimumFare;

                            //     }
                            // }, 800)
                            // if (vm.type_of_trip1 != 'P' && vm.flagForFlightDate == true) {
                            //     compareDates();
                            // }
                            if (vm.type_of_trip1 != 'P' && vm.flagForFlightDate == true) {
                                compareDates();
                            }

                            if ($stateParams.id) {
                                //console.log(vm.dataToFill.itemOfChargeList);
                                //console.log(vm.bookingDetails.item_of_charge);
                                for (var i = 0; i < vm.dataToFill.itemOfChargeList.length; i++) {
                                    if (vm.bookingDetails.item_of_charge && vm.bookingDetails.item_of_charge.length) {
                                        for (var j = 0; j < vm.bookingDetails.item_of_charge.length; j++) {
                                            console.log("I m in this ", vm.bookingDetails.item_of_charge[j].long_name, vm.dataToFill.itemOfChargeList[i].tic_long_name);

                                            if (vm.bookingDetails.item_of_charge[j].long_name == vm.dataToFill.itemOfChargeList[i].tic_long_name) {
                                                if (vm.bookingDetails.item_of_charge[j].quantity) {
                                                    vm.dataToFill.itemOfChargeList[i].quantity = vm.dataToFill.itemOfChargeList[i].quantity;
                                                } else {
                                                    vm.dataToFill.itemOfChargeList[i].quantity = 1;
                                                }
                                                vm.dataToFill.itemOfChargeList[i].price = vm.bookingDetails.item_of_charge[j].price;
                                                vm.dataToFill.itemOfChargeSelected.push(vm.dataToFill.itemOfChargeList[i]);
                                            }
                                        }
                                    }
                                }
                                // vm.dataToFill.estimatedFareVariable = 0;
                                // if(vm.bookingDetails.item_of_charge.length)
                                selectingItemOfCharges(vm.dataToFill.itemOfChargeList)
                            }
                            if (payload.title.data.return_flag == true) {
                                //console.log(payload.title.data.finalResult_return.id, '++++++++++++++++++++++++++++');
                                vm.return_flag = payload.title.data.return_flag;
                                vm.dataToFill.Return_policy.route_id = payload.title.data.finalResult_return.id;
                                // vm.tolerance_time_withdrawal_pickup_return = payload.title.data.finalResult_return.tolerance_time_withdrawal_pickup;
                                vm.dataToFill.Return_policy.route_type = payload.title.data.finalResult_return.type_of_route;
                                vm.dataToFill.Return_policy.type_of_agreement = vm.dataToFill.customerProfile == 0 || vm.dataToFill.customerProfile == '0' ? 0 : 1;
                                vm.dataToFill.Return_policy.itemOfChargeList = [];
                                vm.dataToFill.Return_policy.itemOfChargeSelected = [];
                                if (payload.title.data.finalResult_return.price_list.itemOfCharge && payload.title.data.finalResult_return.price_list.itemOfCharge.length) {
                                    for (var i = 0; i < payload.title.data.finalResult_return.price_list.itemOfCharge.length; i++) {
                                        payload.title.data.finalResult_return.price_list.itemOfCharge[i].quantity = 1;
                                        payload.title.data.finalResult_return.price_list.itemOfCharge[i].oldPrice = payload.title.data.finalResult_return.price_list.itemOfCharge[i].price;
                                        if (payload.title.data.finalResult_return.price_list.itemOfCharge[i].tic_manually == 1) {
                                            var itemRet = payload.title.data.finalResult_return.price_list.itemOfCharge[i];
                                            itemRet.tic_long_name = itemRet.tic_long_name + ' (Vuelta)';
                                            itemRet.retorno = true;
                                            vm.dataToFill.itemOfChargeList.push(itemRet);
                                        }
                                    }
                                } else {
                                    vm.dataToFill.Return_policy.itemOfChargeList = [];
                                }

                                if (payload.title.data.finalResult_return.type_of_trip == "Z" && payload.title.data.finalResult_return.controlled_way_flag == 1 &&
                                    vm.dataToFill.controlledWayCheck == 1) {
                                    // vm.viaControlled2 = payload.title.data.finalResult_return.via_controlled_price;
                                    if (vm.dataToFill.selectedServiceDetails.fare_type == 1 &&
                                        vm.dataToFill.selectedServiceDetails.category == 1) {
                                        vm.viaControlled2 = payload.title.data.finalResult_return.via_controlled_price + (payload.title.data.finalResult_return.via_controlled_price * (vm.dataToFill.passengerCount - 1));
                                        // vm.addViaControlled = 0;
                                    } else {
                                        vm.viaControlled2 = payload.title.data.finalResult_return.via_controlled_price;
                                        // vm.addViaControlled = 0;
                                    }
                                    vm.SendTrip = payload.title.data.finalResult_return.type_of_trip;

                                } else {
                                    vm.viaControlled2 = 0;
                                }
                                vm.type_of_trip = payload.title.data.finalResult_return.type_of_trip;
                                if (payload.title.data.finalResult_return.type_of_trip == "Z") {
                                    vm.viaControlledFLag = true;
                                    vm.dataToFill.viaControlledApply = true;
                                } else {
                                    vm.viaControlledFLag = false;
                                    vm.dataToFill.viaControlledApply = false;
                                }
                                console.log(vm.type_of_trip1, vm.dataToFill.selectedServiceDetails.category, vm.method_range_pickup, 'test');
                                $timeout(function () {
                                    if (vm.dataToFill.Return_policy.route_type == 1) {
                                        vm.dataToFill.Return_policy.estimatedFareVariable = vm.dataToFill.selectedServiceDetails.fare_type ? Number(payload.title.data.finalResult_return.price) * Number(vm.dataToFill.passengerCount) : payload.title.data.finalResult_return.price;
                                        vm.dataToFill.Return_policy.estimatedFareRoute = vm.dataToFill.selectedServiceDetails.fare_type ? Number(payload.title.data.finalResult_return.price) * Number(vm.dataToFill.passengerCount) : payload.title.data.finalResult_return.price;
                                        vm.dataToFill.Return_policy.estimatedFare = vm.dataToFill.Return_policy.estimatedFareRoute;
                                        vm.dataToFill.Return_policy.estimatedFareRoute = Number(payload.title.data.finalResult_return.price);
                                        vm.estimatedFareRouteForRoundTrip = Number(vm.dataToFill.selectedServiceDetails.fare_type ? Number(payload.title.data.finalResult_return.price) * Number(vm.dataToFill.passengerCount) : payload.title.data.finalResult_return.price);
                                    } 
                                    // else {
                                    //     if (vm.dataToFill.ReturnEstimatedDistance != undefined && vm.dataToFill.etaScheduleValueReturn != undefined) {
                                    //         console.log('debug vm.dataToFill.etaScheduleValueReturn', vm.dataToFill.etaScheduleValueReturn, vm.dataToFill.ReturnEstimatedDistance);
                                    //         // var Return_calEstFare = Number((vm.dataToFill.ReturnEstimatedDistance * payload.title.data.finalResult_return.perKMChanges.toFixed(2)) + payload.title.data.finalResult_return.baseFare);
                                    //         var Return_calEstFare = Number((vm.dataToFill.ReturnEstimatedDistance * payload.title.data.finalResult_return.perKMChanges.toFixed(2)) + (vm.dataToFill.etaScheduleValueReturn * payload.title.data.finalResult_return.time_of_trip_price) + payload.title.data.finalResult_return.baseFare);
                                    //     }
                                    //     vm.dataToFill.Return_policy.estimatedFareRoute = vm.dataToFill.selectedServiceDetails.fare_type ? ((Number(Return_calEstFare) * Number(vm.dataToFill.passengerCount)) < payload.title.data.finalResult_return.minimumFare ? payload.title.data.finalResult_return.minimumFare : (Number(Return_calEstFare) * Number(vm.dataToFill.passengerCount))) : (Return_calEstFare < payload.title.data.finalResult_return.minimumFare ? payload.title.data.finalResult_return.minimumFare : Return_calEstFare);
                                    //     vm.dataToFill.Return_policy.estimatedFare = vm.dataToFill.Return_policy.estimatedFareRoute;
                                    //     vm.dataToFill.Return_policy.estimatedFareVariable = Return_calEstFare;
                                    //     vm.dataToFill.Return_policy.estimatedFareRoute = Return_calEstFare;
                                    //     vm.dataToFill.minimumFare = payload.title.data.finalResult_return.minimumFare;
                                    // }

                                    $timeout(function () {
                                        vm.loading = false;
                                    }, 200);
                                }, 800)

                                if ($stateParams.id) {
                                    //console.log(vm.dataToFill.Return_policy.itemOfChargeList);
                                    //console.log(vm.dataToFill.Return_policy.item_of_charge);
                                    for (var i = 0; i < vm.dataToFill.Return_policy.itemOfChargeList.length; i++) {
                                        if (vm.bookingDetails.item_of_charge && vm.bookingDetails.item_of_charge.length) {
                                            for (var j = 0; j < vm.bookingDetails.item_of_charge.length; j++) {
                                                if (vm.bookingDetails.item_of_charge[j].long_name == vm.dataToFill.Return_policy.itemOfChargeList[i].tic_long_name) {
                                                    if (vm.bookingDetails.item_of_charge[j].quantity) {
                                                        vm.dataToFill.Return_policy.itemOfChargeList[i].quantity = vm.dataToFill.Return_policy.itemOfChargeList[i].quantity;
                                                    } else {
                                                        vm.dataToFill.Return_policy.itemOfChargeList[i].quantity = 1;
                                                    }
                                                    vm.dataToFill.Return_policy.itemOfChargeList[i].price = vm.bookingDetails.item_of_charge[j].price;
                                                    vm.dataToFill.Return_policy.itemOfChargeSelected.push(vm.dataToFill.Return_policy.itemOfChargeList[i]);
                                                }
                                            }
                                        }
                                    }
                                    // if(vm.bookingDetails.item_of_charge.length)
                                    selectingItemOfCharges(vm.dataToFill.Return_policy.itemOfChargeList)
                                }
                            }
                            var timeoutNew = 0;
                            if (vm.modifyFalg == true) {
                                timeoutNew = 3000;
                            } else {
                                timeoutNew = 0;
                            }
                            $timeout(function () {
                                if ((vm.type_of_trip1 == 'R' && vm.dataToFill.selectedServiceDetails.category == 1 && vm.method_range_pickup) || (vm.routingBase && vm.routingBase.routing_base_id > 0)) {
                                    RoutingApiFuncation(vm.dataToFill, 0);
                                } else {
                                    vm.method_range_pickup = 0
                                }
                                if (vm.type_of_trip == 'R' && vm.dataToFill.selectedServiceDetails.category == 1 && vm.method_range_pickup_return && vm.dataToFill.roundTrip == 1) {
                                    RoutingApiFuncationRoundTrip(vm.dataToFill);
                                }
                            }, timeoutNew);
                            if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip == 'P') {
                                calculateDateRangeOfPointToPointReturn();
                            }
                            // ********* VARIABLES ARE INITIALIZE TO AGAIN SET INPUT FIELD VARIABLE ********
                            vm.calculatedEstimatePriceFormFunctionEstimated = -1;
                            vm.finalAdjustedPriceFromAdmin = 0;
                            vm.calculatedEstimatePriceForFixedPriceFormFunction = 0;
                            vm.calculatedEstimatePriceForRoundTripFormFunction = 0;
                            vm.click = false;
                            if (vm.toAirportFlag && payload.title.data.type_of_trip != 'R') {
                                openPopForWaringMessage(vm.type_of_trip1)
                            } else if (vm.fromAirportFlag && payload.title.data.type_of_trip != 'Z') {
                                openPopForWaringMessage(vm.type_of_trip1)
                            } else if (vm.ptopAirportFlag && payload.title.data.type_of_trip != 'P') {
                                openPopForWaringMessage(vm.type_of_trip1)
                            }
                        }
                        if(!vm.method_range_pickup) {
                            setTimeout(function(){
                                vm.disabledSubmitButton1 = false;
                            }, 1500);
                        }
                        //get_cuota();
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        vm.dataToFill.favPickLocId = '';
                        vm.dataToFill.favDropLocId = '';
                        vm.dataToFill.route_id = '';
                        vm.Flag = false;
                        //console.log(vm.dataToFill.route_id, 'vm.dataToFill.route_id_Error')
                        vm.dataToFill.itemOfChargeList = [];
                        vm.dataToFill.itemOfChargeSelected = [];
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            //errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            } else {
                vm.loading = false;
                errorMessageFactory.showErrorMessage("Por favor seleccione el servicio primero", 0);
            }

        };

        //=======================get spot agreement for personal======================
        function getSpotAgreement() {
            vm.loading = true;
            vm.dataToFill.contractIdSelected = 0;
            vm.dataToFill.is_vip = 0;
            var promise = getBookingsHereMaps.getSpotAgreementForBooking();
            promise.then(
                function (payload) {
                    //console.log('payment methods==========', payload.title);
                    vm.loading = false;
                    if (payload.title.data) {
                        vm.personalFlag = true;
                        // vm.flagForAirline = true;
                        vm.dataToFill.contractIdSelected = payload.title.data.contract_id.id;
                        restriccion_flota = payload.title.data.contract_id.restriccion_flota;
                        getCustomerFavouriteAddress();
                        if (!$stateParams.id)
                            vm.dataToFill.payment_method = payload.title.data.contract_id.payment_method_default;
                        if (payload.title.data.contract_id.airline_mandatory == 1) {
                            vm.flagForAirline = true;
                        }
                        if (payload.title.data.contract_id.flight_number_mandatory == 1) {
                            vm.flagForFlightNumber = true;
                        }
                        if (payload.title.data.contract_id.flight_date_mandatory == 1) {
                            vm.flagForFlightDate = true;
                        }
                        if (payload.title.data.contract_id.flight_type_mandatory == 1) {
                            vm.flagForFlightType = true;
                        }
                        vm.airlineMandatory = payload.title.data.contract_id.airline_mandatory;
                        vm.flightNumberMandatory = payload.title.data.contract_id.flight_number_mandatory;
                        vm.flightDateMandatory = payload.title.data.contract_id.flight_date_mandatory;
                        vm.flightTypeMandatory = payload.title.data.contract_id.flight_type_mandatory;
                        vm.serviceTypeList = payload.title.data.service_types;
                        //getFixedRoutesForPersonal(payload.title.data);
                        vm.dataToFill.passengerRutCheck = payload.title.data.contract_id.RUT_mendatory;
                        vm.dataToFill.applicantRutCheck = payload.title.data.contract_id.applicant_RUT_mendatory;
                        vm.dataToFill.costCenterCheck = payload.title.data.contract_id.cost_center_mandatory;
                        vm.dataToFill.costSubCenterCheck = payload.title.data.contract_id.cost_sub_center_mandatory;
                        vm.dataToFill.RolCheck = payload.title.data.contract_id.ROL_mandatory;
                        vm.dataToFill.graphCheck = payload.title.data.contract_id.graph_mandatory;
                        vm.dataToFill.workOrderCheck = payload.title.data.contract_id.work_order_mandatory;
                        vm.dataToFill.pepCheck = payload.title.data.contract_id.PEP_mandatory;
                        vm.dataToFill.purposeOfTripCheck = payload.title.data.contract_id.purpose_of_trip_mandatory;
                        vm.dataToFill.noOfVoucherCheck = payload.title.data.contract_id.number_of_voucher_mandatory;
                        vm.dataToFill.nominaCheck = payload.title.data.contract_id.nomina_mandatory;
                        vm.dataToFill.controlledWayCheck = payload.title.data.contract_id.controlled_way;
                        vm.dataToFill.controllerWayTarifa = payload.title.data.contract_id.via_control_include_in_tarifa;
                        vm.dataToFill.solictudCheck = payload.title.data.contract_id.solicitud_mandatory;
                        vm.dataToFill.roundTripDiscount = payload.title.data.contract_id.rt_discount;
                        vm.dataToFill.webDiscount = payload.title.data.contract_id.web_discount;
                        vm.dataToFill.allowChangeFarePanel = payload.title.data.contract_id.allow_change_fare_panel || 0;
                        vm.click = false; //Because after click on modify input field will change when personal or corporate changes
                        vm.dataToFill.allowBookingWithoutRequest = payload.title.data.contract_id.is_bwr;
                        vm.dataToFill.paymentMethodList = [];
                        // ON CHANGE AGREEMENT MODIFY INPUT FILED CHANGE INTO STATIC VALUE
                        vm.click = false;

                        for (var i = 0; i < payload.title.data.payment.length; i++) {
                            for (var j = 0; j < payload.title.data.payment[i].mapping.length; j++) {
                                if (payload.title.data.payment[i].mapping[j].channel_name == 'pannel') {
                                    vm.dataToFill.paymentMethodList.push(payload.title.data.payment[i]);
                                }
                            }
                        }
                        if (vm.dataToFill.paymentMethodList.length == 0) {
                            var where = _.where(payload.title.data.payment, {
                                id: Number(vm.dataToFill.payment_method)
                            })[0];
                            vm.dataToFill.paymentMethodList.push(where);
                        } else {
                            var where = _.where(vm.dataToFill.paymentMethodList, {
                                id: Number(vm.dataToFill.payment_method)
                            });
                            if (where.length == 0) {
                                vm.dataToFill.payment_method = '';
                            }
                        }
                        if ($stateParams.id) {
                            serviceTypeChanged();
                        }
                        //console.log('vm.dataToFill.paymentMethodList', vm.dataToFill.paymentMethodList);
                    } else {
                        vm.dataToFill.contractIdSelected = '';
                        vm.serviceTypeList = [];
                        vm.dataToFill.paymentMethodList = [];
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function getCorporateAgreement() {
            vm.dataToFill.contractList = [];
            vm.dataToFill.contractListShowing = [];
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.employee_id = vm.dataToFill.employeeId;
            //dataSend.contract_id = vm.dataToFill.customerContarctId;
            vm.loading = true;
            var promise = getBookingsHereMaps.getCorporateAgreementForBooking(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    console.log(payload);

                    if (payload.title.data) {

                        //  vm.flagForAirline = true;
                        for (var i = 0; i < payload.title.data.length; i++) {
                            vm.dataToFill.contractList.push(payload.title.data[i]);
                            vm.dataToFill.contractListShowing.push({
                                id: payload.title.data[i].id,
                                name: payload.title.data[i].name,
                                is_block: payload.title.data[i].employee_details.panel_booking_access || 0
                            })
                        }
                        //vm.dataToFill.contractIdSelected = payload.title.data.contract_id.id;
                        //vm.serviceTypeList = payload.title.data.service_types;
                        //getFixedRoutesForPersonal(payload.title.data);
                    } else {
                        vm.dataToFill.contractList = [];
                        vm.dataToFill.contractListShowing = [];
                        //vm.serviceTypeList = [];
                    }
                    if (vm.dataToFill.bookingId) {
                        agreementTypeChanged();
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function agreementTypeChanged() {
            var isAgreementBlock = 0;
            var isAgreementBlockIndex = _.findIndex(vm.dataToFill.contractListShowing, {
                id: vm.dataToFill.contractIdSelected
            })
            if (isAgreementBlockIndex > -1) {
                isAgreementBlock = vm.dataToFill.contractListShowing[isAgreementBlockIndex].is_block;
                if (isAgreementBlock == 0) {
                    errorMessageFactory.showErrorMessage('Este cliente no está autorizado para crear reservas desde el panel', 0);
                    vm.dataToFill.contractIdSelected = '';
                    return;
                }
            }
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.offset = 0;
            dataSend.limit = 0;
            dataSend.key = 3;
            dataSend.id = vm.dataToFill.contractIdSelected;
            vm.loading = true;
            var promise = getAgreement.allAgreementBooking(dataSend);
            promise.then(
                function (payload) {
                    vm.loading = false;
                    vm.finalAgreement = payload.title.data.result;
                    //console.log('final Agreement', vm.finalAgreement);
                    vm.serviceTypeList = [];
                    for (var i = 0; i < payload.title.data.result[0].type_of_service.length; i++) {
                        vm.serviceTypeList.push(payload.title.data.result[0].type_of_service[i]);
                    }
                    vm.dataToFill.customerContarctId = payload.title.data.result[0].id;
                    restriccion_flota = payload.title.data.result[0].restriccion_flota;
                    console.log('hello')
                    getCustomerFavouriteAddress();
                    if (!$stateParams.id)
                        vm.dataToFill.payment_method = payload.title.data.result[0].payment_method_default;
                    if (payload.title.data.result[0].airline_mandatory == 1) {
                        vm.flagForAirline = true;
                    }
                    if (payload.title.data.result[0].flight_number_mandatory == 1) {
                        vm.flagForFlightNumber = true;
                    }
                    if (payload.title.data.result[0].flight_date_mandatory == 1) {
                        vm.flagForFlightDate = true;
                    }
                    if (payload.title.data.result[0].flight_type_mandatory == 1) {
                        vm.flagForFlightType = true;
                    }
                    vm.airlineMandatory = payload.title.data.result[0].airline_mandatory;
                    vm.flightNumberMandatory = payload.title.data.result[0].flight_number_mandatory;
                    vm.flightDateMandatory = payload.title.data.result[0].flight_date_mandatory;
                    vm.flightTypeMandatory = payload.title.data.result[0].flight_type_mandatory;
                    vm.dataToFill.passengerRutCheck = payload.title.data.result[0].RUT_mendatory;
                    vm.dataToFill.applicantRutCheck = payload.title.data.result[0].applicant_RUT_mendatory;
                    vm.dataToFill.costCenterCheck = payload.title.data.result[0].cost_center_mandatory;
                    vm.dataToFill.costSubCenterCheck = payload.title.data.result[0].cost_sub_center_mandatory;
                    vm.dataToFill.RolCheck = payload.title.data.result[0].ROL_mandatory;
                    vm.dataToFill.graphCheck = payload.title.data.result[0].graph_mandatory;
                    vm.dataToFill.workOrderCheck = payload.title.data.result[0].work_order_mandatory;
                    vm.dataToFill.pepCheck = payload.title.data.result[0].PEP_mandatory;
                    vm.dataToFill.purposeOfTripCheck = payload.title.data.result[0].purpose_of_trip_mandatory;
                    vm.dataToFill.noOfVoucherCheck = payload.title.data.result[0].number_of_voucher_mandatory;
                    vm.dataToFill.nominaCheck = payload.title.data.result[0].nomina_mandatory;
                    vm.dataToFill.controlledWayCheck = payload.title.data.result[0].controlled_way;
                    vm.dataToFill.controllerWayTarifa = payload.title.data.result[0].via_control_include_in_tarifa;
                    vm.dataToFill.solictudCheck = payload.title.data.result[0].solicitud_mandatory;
                    vm.dataToFill.roundTripDiscount = payload.title.data.result[0].rt_discount;
                    vm.dataToFill.webDiscount = payload.title.data.result[0].web_discount;
                    vm.dataToFill.allowChangeFarePanel = payload.title.data.result[0].allow_change_fare_panel || 0;
                    vm.dataToFill.allowBookingWithoutRequest = payload.title.data.result[0].is_bwr;
                    // ON CHANGE AGREEMENT MODIFY INPUT FILED CHANGE INTO STATIC VALUE
                    vm.click = false;

                    vm.addressChange = true;

                    vm.dataToFill.roundTrip == false;

                    vm.dataToFill.paymentMethodList = [];

                    for (var i = 0; i < payload.title.data.result[0].payment.length; i++) {
                        if (payload.title.data.result[0].payment[i].channel_name == 'pannel') {
                            vm.dataToFill.paymentMethodList.push(payload.title.data.result[0].payment[i]);
                        }
                    }

                    if (vm.dataToFill.paymentMethodList.length == 0) {
                        for (var i = 0; i < payload.title.data.result[0].payment.length; i++) {
                            if (payload.title.data.result[0].payment[i].id == Number(vm.dataToFill.payment_method)) {
                                vm.dataToFill.paymentMethodList.push(payload.title.data.result[0].payment[i]);
                            }
                        }
                    } else {
                        var where = _.where(vm.dataToFill.paymentMethodList, {
                            id: Number(vm.dataToFill.payment_method)
                        });
                        console.log(!where, where.length == 0, '!where && where.length == 0');

                        if (where.length == 0) {
                            console.log(vm.dataToFill.payment_method, 'vm.dataToFill.payment_method');

                            vm.dataToFill.payment_method = '';
                            console.log(vm.dataToFill.payment_method, 'vm.dataToFill.payment_method');
                        }
                    }


                    var where = _.where(vm.dataToFill.contractList, {
                        id: Number(vm.dataToFill.contractIdSelected)
                    });
                    vm.selectedEmployeeData = where[0];
                    if (!payload.title.data.result[0].employee_details) {
                        if (where.length) {
                            vm.dataToFill.corporate_account_id = where[0].employee_details.corporate_id;
                            vm.dataToFill.authRequired = where[0].employee_details.approval_required;
                            vm.dataToFill.auther_id = where[0].employee_details.auther_id; //auth_RUT
                            vm.dataToFill.authRUT = RutHelper.format(where[0].employee_details.auth_RUT);
                            vm.dataToFill.authName = where[0].employee_details.auth_name;
                            if (vm.modifyFalg == false) {
                                vm.dataToFill.passengerRut = RutHelper.format(where[0].employee_details.RUT);
                                vm.dataToFill.applicantRut = RutHelper.format(where[0].employee_details.RUT);
                                vm.dataToFill.costCenter = where[0].employee_details.cost_center;
                                vm.dataToFill.costSubCenter = where[0].employee_details.cost_subcenter;
                                vm.dataToFill.Rol = where[0].employee_details.ROI;
                                vm.dataToFill.graph = where[0].employee_details.graph;
                                vm.dataToFill.workOrder = where[0].employee_details.order_of_work;
                                vm.dataToFill.pep = where[0].employee_details.PEP;
                                vm.dataToFill.is_vip = where[0].employee_details.is_vip;
                            }


                            if (where[0].employee_details.thirdBooking == 1) {
                                vm.bookingForOptions = [{
                                        // name: 'Self',
                                        name:'Para mi',
                                        value: 0
                                    },
                                    {
                                        // name: 'Someone else',
                                        name:'Alguien más',
                                        value: 1
                                    }
                                ];
                            } else {
                                vm.bookingForOptions = [{
                                    name: 'Para mi',
                                    value: 0
                                }];
                            }
                        } else {
                            vm.dataToFill.corporate_account_id = payload.title.data.result[0].corporate_id.id;
                            vm.dataToFill.authRequired = 0;
                            vm.dataToFill.auther_id = '';
                            vm.dataToFill.authRUT = '';
                            vm.dataToFill.authName = '';
                            // vm.dataToFill.passengerRut = '';
                            vm.dataToFill.applicantRut = '';
                            vm.dataToFill.costCenter = '';
                            vm.dataToFill.costSubCenter = '';
                            vm.dataToFill.Rol = '';
                            vm.dataToFill.graph = '';
                            vm.dataToFill.workOrder = '';
                            vm.dataToFill.pep = '';
                            vm.dataToFill.is_vip = 0;
                            vm.bookingForOptions = [{
                                name: 'Para mi',
                                value: 0
                            }];
                        }
                    }
                    if (vm.dataToFill.bookingId) {
                        serviceTypeChanged();
                    }

                    if (vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                        vm.dataToFill.discounts = [];
                        vm.dataToFill.couponValidation = false;
                        vm.dataToFill.couponCode = '';
                        getFixedRoutesForPersonal(vm.dataToFill);
                    }

                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
            //var where = _.where(vm.dataToFill.contractList,{id:Number(vm.dataToFill.contractIdSelected)});
            //vm.serviceTypeList = where[0].type_of_service;
            //vm.dataToFill.corporate_account_id = where[0].employee_details.corporate_id;
            //vm.dataToFill.customerContarctId = where[0].contract_id;
            //vm.dataToFill.payment_method = where[0].payment_method_default;
            //vm.dataToFill.authRequired = where[0].employee_details.approval_required;
            //vm.dataToFill.auther_id = where[0].employee_details.auther_id; //auth_RUT
            //vm.dataToFill.authRUT = RutHelper.format(where[0].employee_details.auth_RUT);
            //vm.dataToFill.authName = where[0].employee_details.auth_name;
            //vm.dataToFill.passengerRutCheck = where[0].RUT_mendatory;
            //vm.dataToFill.applicantRutCheck = where[0].applicant_RUT_mendatory;
            //vm.dataToFill.costCenterCheck = where[0].cost_center_mandatory;
            //vm.dataToFill.costSubCenterCheck = where[0].cost_sub_center_mandatory;
            //vm.dataToFill.RolCheck = where[0].ROL_mandatory;
            //vm.dataToFill.graphCheck = where[0].graph_mandatory;
            //vm.dataToFill.workOrderCheck = where[0].work_order_mandatory;
            //vm.dataToFill.pepCheck = where[0].PEP_mandatory;
            //vm.dataToFill.purposeOfTripCheck = where[0].purpose_of_trip_mandatory;
            //vm.dataToFill.noOfVoucherCheck = where[0].number_of_voucher_mandatory;
            //vm.dataToFill.nominaCheck = where[0].nomina_mandatory;
            //vm.dataToFill.solictudCheck = where[0].solicitud_mandatory;

            //vm.dataToFill.passengerRut = RutHelper.format(where[0].employee_details.RUT);
            //vm.dataToFill.applicantRut = RutHelper.format(where[0].employee_details.RUT);
            //vm.dataToFill.costCenter = where[0].employee_details.cost_center;
            //vm.dataToFill.costSubCenter = where[0].employee_details.cost_subcenter;
            //vm.dataToFill.Rol = where[0].employee_details.ROI;
            //vm.dataToFill.graph = where[0].employee_details.graph;
            //vm.dataToFill.workOrder = where[0].employee_details.order_of_work;
            //vm.dataToFill.pep = where[0].employee_details.PEP;

            //if(where[0].employee_details.thirdBooking == 1){
            //    vm.bookingForOptions = [
            //        {
            //            name: 'Self',
            //            value: 0
            //        },
            //        {
            //            name: 'Para alguien más',
            //            value: 1
            //        }
            //    ];
            //}
            //else{
            //    vm.bookingForOptions = [
            //        {
            //            name: 'Self',
            //            value: 0
            //        }
            //    ];
            //}
            //if(vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat)
            //    getFixedRoutesForPersonal(vm.dataToFill);

            // // THIS CHECK IS FOR PET USER
            if ((JSON.parse($cookies.get('adminType') || 0) == 1) && (vm.dataToFill.customerId > 0)) {
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.customer_id = vm.dataToFill.customerId;
                dataSend.contract_id = vm.dataToFill.contractIdSelected;
                dataSend.is_customer = 0; // 0-frontend ,1- customerApp
                var promise = getAgreement.getDetailsForPET(dataSend);
                promise.then(
                    function (payload) {

                        vm.loading = false;
                        if (payload.title.status == 400) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            if (payload.title && payload.title.data && payload.title.data.phone_number && payload.title.data.email) {
                                vm.isEmpDataChange = true; // TV-2378
                                vm.dataToFill.customerMobileG = payload.title.data.phone_number;
                                vm.dataToFill.customerEmail = payload.title.data.email;
                                vm.dataToFill.customerMobile = payload.title.data.name + ' ' + payload.title.data.last_name;
                            }
                        }
                    },
                    function (errorPayload) {
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }
        }
        //=====================profile changes function ===============================
        function profileChanges() {
            $log.log(vm.dataToFill);
            vm.dataToFill.itemOfChargeSelected = [];
            vm.dataToFill.item_of_charges = [];
            vm.dataToFill.is_item_of_charges = 0;
            vm.dataToFill.itemOfChargeSelected = [];
            vm.dataToFill.pickUpAddress = '';
            vm.dataToFill.dropOffAddress = '';
            vm.dataToFill.pickUpLat = '';
            vm.dataToFill.pickUpLng = '';
            vm.dataToFill.dropOffLat = '';
            vm.dataToFill.dropOffLng = '';
            vm.dataToFill.favDropLocId = '';
            vm.dataToFill.favPickLocId = '';
            vm.dataToFill.authRequired = 0;
            vm.dataToFill.passengerRutCheck = 0;
            vm.dataToFill.applicantRutCheck = 0;
            vm.dataToFill.costCenterCheck = 0;
            vm.dataToFill.costSubCenterCheck = 0;
            vm.dataToFill.RolCheck = 0;
            vm.dataToFill.graphCheck = 0;
            vm.dataToFill.workOrderCheck = 0;
            vm.dataToFill.pepCheck = 0;
            vm.dataToFill.purposeOfTripCheck = 0;
            vm.dataToFill.noOfVoucherCheck = 0;
            vm.dataToFill.nominaCheck = 0;
            vm.dataToFill.controlledWayCheck = 0;
            vm.dataToFill.controllerWayTarifa = 0;
            vm.dataToFill.solictudCheck = 0;
            vm.dataToFill.passengerRut = '';
            vm.dataToFill.applicantRut = '';
            vm.dataToFill.costCenter = '';
            vm.dataToFill.costSubCenter = '';
            vm.dataToFill.Rol = '';
            vm.dataToFill.is_vip = 0;
            vm.dataToFill.graph = '';
            vm.dataToFill.workOrder = '';
            vm.dataToFill.pep = '';
            vm.dataToFill.purposeOfTrip = '';
            vm.dataToFill.noOfVoucher = '';
            vm.dataToFill.estimatedFare = '';
            vm.dataToFill.estimatedFareRoute = '';
            vm.dataToFill.estimatedFareVariable = '';

            vm.dataToFill.contractIdSelected = 0;
            vm.dataToFill.personName = '';
            vm.dataToFill.personEmail = '';
            vm.dataToFill.discounts = [];
            vm.dataToFill.couponValidation = false;
            vm.dataToFill.couponCode = '';
            vm.dataToFill.personMobile = '';
            // mapInitialize();

            if (vm.dataToFill.customerProfile == 0 || vm.dataToFill.customerProfile == '0') {
                vm.newPersonFlag = true;
                getSpotAgreement();

            } else if (vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == '1') {
                vm.newPersonFlag = false;
                getCorporateAgreement();
            }
            //get_cuota();
        };

        //===================service type changed =========================
        function serviceTypeChanged() {
            vm.addressChange = true;
            if (vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                getFixedRoutesForPersonal(vm.dataToFill);
            } else {

            }

            if (vm.dataToFill.pickUpLat && (vm.dataToFill.bookingType == '0' || vm.dataToFill.bookingType == 0) && vm.dataToFill.airportCheck != 'Z' && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2)) {
                vm.dataToFill.nearDriver = '';
                toGetNearByDrivers(vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.serviceTypeSelected, map);
            }

            vm.dataToFill.selectedServiceDetails = _.where(vm.serviceTypeList, {
                id: vm.dataToFill.serviceTypeSelected
            })[0];
            vm.bookingTypeOptions = [];
            //console.log('sasda', vm.serviceTypeList);
            if (vm.dataToFill.selectedServiceDetails.is_current) {
                vm.bookingTypeOptions.push({
                    name: "De Minuto",
                    value: "0"
                })
            }
            if (vm.dataToFill.selectedServiceDetails.is_scheduled) {
                vm.bookingTypeOptions.push({
                    name: "Programada",
                    value: "1"
                })
            }

            if (vm.dataToFill.selectedServiceDetails.category == 1 && vm.dataToFill.etaScheduleValue)
                calculateEstimatePickUpTime(vm.dataToFill.etaScheduleValue);

            //get_cuota();
        }
        //============================date time format==============================
        function calculateEstimatePickUpTime(eta) {
            //console.log(eta, vm.dataToFill.selectedServiceDetails,"phata");
            var etaSeconds;
            if (vm.dataToFill.selectedServiceDetails.category == 1) {
                etaSeconds = Math.round(eta) * 60 + vm.dataToFill.time_trip_shared_service * 60;
            } else {
                etaSeconds = Math.round(eta) * 60;
            }
            var addEtaSeconds = vm.tolerance_for_shared_R * 60;
            vm.etaSeconds = etaSeconds;
            var tolerance = vm.dataToFill.selectedServiceDetails.tolerance * 60;
            if (new Date(vm.dataToFill.dropDate) != 'Invalid Date' && new Date(vm.dataToFill.dropTime) != 'Invalid Date') {
                var dropDateTimeNewFormat = dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime);
            } else {
                var dropDateTimeNewFormat = new Date();
            }
            var addEtaSeconds = vm.tolerance_for_shared_R * 60;
            var pickRange3 = moment(dropDateTimeNewFormat).subtract(etaSeconds, 'seconds');
            // var pickRange3 = moment(dropDateTimeNewFormat).subtract(etaSeconds, 'seconds');
            // vm.pickUpTime = pickRange3;
            var pickRange2 = moment(dropDateTimeNewFormat).subtract(etaSeconds, 'seconds').add(tolerance, 'seconds');
            var pickRange1 = moment(dropDateTimeNewFormat).subtract(etaSeconds, 'seconds').subtract(tolerance, 'seconds');
            vm.pickRange1 = moment(pickRange1).format('HH:mm');
            vm.pickRange2 = moment(pickRange2).format('HH:mm');
            var newPickRange3 = moment(pickRange3).subtract(addEtaSeconds, 'seconds');
            vm.pickRange3 = moment(pickRange3).format('HH:mm');
            vm.newPickRange3 = moment(newPickRange3).format('HH:mm');
            var pickRange3ToShowAdd = moment(pickRange3).add(addEtaSeconds, 'seconds');
            vm.pickRange3ToShowAdd = moment(pickRange3ToShowAdd).format('HH:mm');
            if (vm.modifyFalgNew) {
                vm.newPickRange3 = moment(vm.bookingDetails.time_with_tolerance_before).format('HH:mm');
                vm.pickRange3ToShowAdd = moment(vm.bookingDetails.time_with_tolerance_after).format('HH:mm');
            }
            // vm.pickRange4 = module().format('HH:mm');
            // //console.log("Puneet changes");
            var pickRange4 = moment(dropDateTimeNewFormat).subtract(vm.dataToFill.time_trip_shared_service, 'minutes');
            vm.pickRange4 = moment(pickRange4).format('HH:mm');
        }


        function calculateEstimatePickUpTimeForRTypeReturn(eta) {
            var etaSeconds;
            console.log("in case of return", eta);

            etaSeconds = Math.round(eta) * 60;
            var tolerance = vm.travel_time_service_pick_up * 60;
            var addTolerance = vm.tolerance_time_withdrawal_pickup * 60;
            var dropDateTimeNewFormat;
            if (new Date(vm.dataToFill.dropDateReturn) != 'Invalid Date' && new Date(vm.dataToFill.dropTimeReturn) != 'Invalid Date') {
                dropDateTimeNewFormat = dateTimeFormat(vm.dataToFill.dropDateReturn, vm.dataToFill.dropTimeReturn);
            } else {
                dropDateTimeNewFormat = new Date();
            }
            var pickRangeForRtypeReturn = moment(dropDateTimeNewFormat).subtract(etaSeconds, 'seconds').subtract(tolerance, 'seconds');
            vm.errorShowDateForRTypeReturn = pickRangeForRtypeReturn;
            if (vm.is_group_allowed == 1 && vm.discard_booking_flag != 1) {
                var newpickRangeForRtypeReturn = moment(pickRangeForRtypeReturn).subtract(addTolerance, 'seconds');
                vm.pickRangeForRTypeReturn = moment(newpickRangeForRtypeReturn).format('HH:mm');
            } else {
                vm.pickRangeForRTypeReturn = moment(pickRangeForRtypeReturn).format('HH:mm');
            }
            // vm.pickRangeForRTypeReturn = moment(pickRangeForRtypeReturn).format('HH:mm');
            var pickRangeForEstimatedReturn = moment(pickRangeForRtypeReturn).add(addTolerance, 'seconds');
            vm.pickRangeForEstimatedReturn = moment(pickRangeForEstimatedReturn).format('HH:mm');
            if (vm.modifyFalgNew) {
                vm.pickRangeForRTypeReturn = moment(vm.bookingDetails.time_with_tolerance_before).format('HH:mm');
                vm.pickRangeForEstimatedReturn = moment(vm.bookingDetails.time_with_tolerance_after).format('HH:mm');
            }
        }
        //============================date time format==============================
        function calculateEstimatePickUpTimeForRType(eta) {
            var datePointToPoint = dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime)

            var newpickRangeForRtypeReturn = '';
            if (vm.is_group_allowed == 1) {
                newpickRangeForRtypeReturn = moment(datePointToPoint).subtract((vm.tolerance_time_withdrawal_pickup * 60), 'seconds');
            } else {
                newpickRangeForRtypeReturn = datePointToPoint;
            }
            if (vm.modifyFalgNew) {
                vm.pickRangeForRType = moment(vm.bookingDetails.time_with_tolerance_before).format('HH:mm');
            } else {
                vm.pickRangeForRType = moment(newpickRangeForRtypeReturn).format('HH:mm');
            }
            var rangePointToPoint = moment(datePointToPoint).add((vm.tolerance_time_withdrawal_pickup * 60), 'seconds');
            vm.pickRangeForEstimated = moment(rangePointToPoint).format('HH:mm');
        }

        function calculateEstimatePickUpTimeReturn(eta) {
            var etaSeconds;
            if (vm.dataToFill.selectedServiceDetails.category == 1) {
                etaSeconds = Math.round(eta) * 60 + vm.dataToFill.time_trip_shared_service * 60;
            } else {
                etaSeconds = Math.round(eta) * 60;
            }
            vm.etaSeconds = etaSeconds;
            var addEtaSeconds = vm.tolerance_for_shared_R * 60;
            //var tolerance = vm.dataToFill.selectedServiceDetails.tolerance * 60;
            var tolerance = vm.tolerance_time_withdrawal_pickup * 60;
            if (new Date(vm.dataToFill.dropDateReturn) != 'Invalid Date' && new Date(vm.dataToFill.dropTimeReturn) != 'Invalid Date') {
                var dropDateTimeNewFormat = dateTimeFormat(vm.dataToFill.dropDateReturn, vm.dataToFill.dropTimeReturn);
            } else {
                var dropDateTimeNewFormat = new Date();
            }
            var pickRange3 = moment(dropDateTimeNewFormat).subtract(etaSeconds, 'seconds');
            var pickRange1 = moment(dropDateTimeNewFormat).add(tolerance, 'seconds');
            var pickRange10 = moment(pickRange1).format('HH:mm');
            // var pickRange3 = moment(dropDateTimeNewFormat).subtract(etaSeconds, 'seconds');
            // vm.pickUpTime = pickRange3;
            //var pickRange2 = moment(dropDateTimeNewFormat).subtract(etaSeconds, 'seconds').add(tolerance, 'seconds');
            //var pickRange1 = moment(dropDateTimeNewFormat).subtract(etaSeconds, 'seconds').subtract(tolerance, 'seconds');
            // vm.pickRange1 = moment(pickRange1).format('HH:mm');
            var pickRange2 = moment(dropDateTimeNewFormat).format('HH:mm');
            // vm.pickRange4 = moment(pickRange3).format('HH:mm');
            // vm.pickRange4 = module().format('HH:mm');
            // //console.log("Puneet changes");
            // var pickRange4 = moment(dropDateTimeNewFormat).subtract(vm.dataToFill.time_trip_shared_service, 'minutes');
            var newpickRange3 = moment(pickRange3).subtract(addEtaSeconds, 'seconds');
            vm.pickRange5 = moment(newpickRange3).format('HH:mm');
            vm.pickRange2 = pickRange2;
            var pickRange3ToShowAdd = moment(pickRange3).add(addEtaSeconds, 'seconds');
            vm.pickRange3ToShowAddReturn = moment(pickRange3ToShowAdd).format('HH:mm');
            vm.pickRange10 = pickRange10;
            if (vm.modifyFalgNew) {
                vm.pickRange5 = moment(vm.bookingDetails.time_with_tolerance_before).format('HH:mm');
                vm.pickRange3ToShowAddReturn = moment(vm.bookingDetails.time_with_tolerance_after).format('HH:mm');
            }
            //get_cuota_rt();
        }
        //function calculateEstimateDropOffTime(eta){
        //    //console.log(eta,vm.dataToFill.selectedServiceDetails);
        //    var etaSeconds = Math.round(eta/60) * 60;
        //    var tolerance = vm.dataToFill.selectedServiceDetails.tolerance * 60;
        //    var dropDateTimeNewFormat = dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime);
        //    var pickRange2 = moment(dropDateTimeNewFormat).subtract(etaSeconds, 'seconds');
        //    var pickRange1 = moment(pickRange2).subtract(tolerance, 'seconds');
        //    vm.pickRange1 = moment(pickRange1).format('HH:mm');
        //    vm.pickRange2 = moment(pickRange2).format('HH:mm');
        //    //console.log(vm.pickRange1);
        //    //console.log(vm.pickRange2);
        //}
        function pickupFromToTimeChanged() {
            // compareDates();
            if (vm.type_of_trip1 != 'P' && vm.flagForFlightDate == true) {
                compareDates();
            }
        }

        function dateTimeFormat(dateGot, timeGot) {
            var dateToChange = dateGot;
            dateToChange.setHours(0);
            dateToChange.setMinutes(0);
            dateToChange.setSeconds(0);
            dateToChange.setHours(timeGot.getHours());
            dateToChange.setMinutes(timeGot.getMinutes());
            dateToChange.setSeconds(0);
            if (dateToChange != 'Invalid Date' && timeGot != '00:00:00')
                return new Date(dateToChange);
        };


        //=======================get previous address hit=======================
        $document.on('click', function (e) {
            //console.log('ddddd', e);
            //console.log('ddddd', e.toElement.id);
            if (e.target && e.target.id != 'pickUpAddress' && e.target.id != 'dropOffAddress') {
                vm.dataToFill.previousPickFlag = false;
                vm.dataToFill.previousDropFlag = false;
                //$scope.$apply();
                if(!$scope.$$phase){
                    $scope.$apply();
                }
            }
        });

        //console.log($document);

        function getPreviousAddressHit(type) {
            vm.modifyFalgNew = false;
            if (!vm.dataToFill.customerId && !vm.newCustomerFlag) {
                languageBasedErrorFactory.getProperErrorMessage('selectCustomerf', 0, 0);
                //errorMessageFactory.showErrorMessage('Please fill customer details first',0);
                return;
            }
            if (vm.newCustomerFlag) {
                vm.previousAddressList = [];
                return;
            }
            if (type == 1) {
                vm.dataToFill.previousPickFlag = true;
                vm.dataToFill.previousDropFlag = false;
            } else if (type == 2) {
                vm.dataToFill.previousDropFlag = true;
                vm.dataToFill.previousPickFlag = false;
            }
            // if (vm.dataToFill.previousCustomerId == vm.dataToFill.customerId && !vm.newCustomerFlag) {
            //     return;
            // } // 3975 ticket
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.customer_id = vm.dataToFill.customerId;
            dataSend.address_type = type == 1 ? 0 : 1; // 3975 ticket
            //dataSend.contract_id = vm.dataToFill.customerContarctId;
            vm.loading = true;
            var promise = getBookingsHereMaps.getPreviousAddress(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.data.addresses) {
                        if (type == 1) {
                            vm.dataToFill.previousPickFlag = true;
                            vm.dataToFill.previousDropFlag = false;
                        } else if (type == 2) {
                            vm.dataToFill.previousDropFlag = true;
                            vm.dataToFill.previousPickFlag = false;
                        }
                        vm.previousAddressList = payload.title.data.addresses;
                    } else {
                        vm.previousAddressList = [];
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        vm.onclickErrorPickDrop = errorPayload.data.message;
                        //errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };

        //=======================select previous address=========================
        function selectPreviousAddress(data, type) {
            //console.log(data);
            if (type == 1) {
                vm.addressChange = true;
                vm.getFixedRoutesForPersonalFlag = true;
                vm.dataToFill.previousPickFlag = false;
                vm.dataToFill.pickUpAddress = data.address;
                vm.dataToFill.pickUpLat = data.latitude;
                vm.dataToFill.pickUpLng = data.longitude;
                vm.dataToFill.pickLat = data.latitude;
                vm.dataToFill.pickLng = data.longitude;
                vm.jobPickupComuna = data.communa || null;
                // var location = new google.maps.LatLng(Number(data.latitude), Number(data.longitude));
                vm.pickaddressChange = true;
                getFavoriteAddress('pick');
                if (vm.dataToFill.serviceTypeSelected) { //&& (vm.dataToFill.bookingType == '0' || vm.dataToFill.bookingType == 0)
                    vm.dataToFill.nearDriver = '';
                    toGetAirportService(vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.serviceTypeSelected, map);
                    //toGetNearByDrivers(vm.dataToFill.pickUpLat,vm.dataToFill.pickUpLng,vm.dataToFill.serviceTypeSelected,map);
                }
                if (vm.toAirportFlag) {
                    getAirportAddressApi();
                }
                if (vm.ptopAirportFlag && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                    getFixedRoutesForPersonal(vm.dataToFill);
                }
                // $timeout(function () {
                //     placeMarker(map, location, 'pick');
                // }, 2000);
            } else if (type == 2) {
                vm.dataToFill.previousDropFlag = false;
                vm.addressChange = true;
                vm.getFixedRoutesForPersonalFlag = true;
                vm.dataToFill.dropOffAddress = data.address;
                vm.dataToFill.dropOffLat = data.latitude;
                vm.dataToFill.dropOffLng = data.longitude;
                vm.dataToFill.dropLat = data.latitude;
                vm.dataToFill.dropLng = data.longitude;
                vm.dropaddressChange = true;
                vm.jobDropoffComuna = data.communa || null;
                getFavoriteAddress('drop');
                // var locationD = new google.maps.LatLng(Number(data.latitude), Number(data.longitude));
                if (vm.fromAirportFlag) {
                    getAirportAddressApi();
                }
                if (vm.ptopAirportFlag && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                    getFixedRoutesForPersonal(vm.dataToFill);
                }
                // $timeout(function () {
                //     placeMarker(map, locationD, 'drop');
                // }, 2000)
            }
        };

        $scope.$watchCollection('vm.pickRangeForRouting', function (newValue, oldValue) {
            //console.log('being watched oldValue:', oldValue, 'newValue:', newValue);
            getFixedRoutesForPersonal(vm.dataToFill);
        }, true);


        //===================to get airport service==================
        $scope.$watchCollection('vm.dataToFill.selectedServiceDetails', function (newValue, oldValue) {
            //console.log('being watched oldValue:', oldValue, 'newValue:', newValue);
            if (oldValue) {
                vm.dataToFill.viaControlledReal = vm.dataToFill.controlledWayCheck && vm.dataToFill.viaControlledApply ? newValue.controlled_way : 0;
                if (newValue.fare_type == 1) {
                    vm.dataToFill.viaControlled = Number(vm.dataToFill.viaControlledReal) * Number(vm.dataToFill.passengerCount);
                } else {
                    vm.dataToFill.viaControlled = Number(vm.dataToFill.viaControlledReal);
                }
            }
        }, true);
        $scope.$watchCollection('vm.dataToFill.controlledWayCheck', function (newValue, oldValue) {
            //console.log('being watched oldValue:', oldValue, 'newValue:', newValue);
            vm.dataToFill.viaControlledReal = newValue && vm.dataToFill.viaControlledApply ? vm.dataToFill.selectedServiceDetails.controlled_way : 0;
            if (vm.dataToFill.selectedServiceDetails.fare_type == 1) {
                vm.dataToFill.viaControlled = Number(vm.dataToFill.viaControlledReal) * Number(vm.dataToFill.passengerCount);
            } else {
                vm.dataToFill.viaControlled = Number(vm.dataToFill.viaControlledReal);
            }
        }, true);
        $scope.$watchCollection('vm.dataToFill.viaControlledApply', function (newValue, oldValue) {
            //console.log('being watched oldValue:', oldValue, 'newValue:', newValue);
            vm.dataToFill.viaControlledReal = vm.dataToFill.controlledWayCheck && newValue ? vm.dataToFill.selectedServiceDetails.controlled_way : 0;
            if (vm.dataToFill.selectedServiceDetails.fare_type == 1) {
                vm.dataToFill.viaControlled = Number(vm.dataToFill.viaControlledReal) * Number(vm.dataToFill.passengerCount);
            } else {
                vm.dataToFill.viaControlled = Number(vm.dataToFill.viaControlledReal);
            }
        }, true);

        function toGetAirportService(lat, lng, service, map) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.latitude = lat;
            dataSend.longitude = lng;
            dataSend.service_id = service;
            vm.loading = true;
            var promise = getBookingsHereMaps.getAirportZone(dataSend);
            promise.then(
                function (payload) {

                    $log.log(payload);
                    vm.loading = false;
                    //console.log(payload, "airportzone");

                    vm.dataToFill.airportCheck = payload.title.data.type_of_trip;
                    if (payload.title.data.time_trip_shared_service) {
                        vm.dataToFill.time_trip_shared_service = payload.title.data.time_trip_shared_service;
                    } else vm.dataToFill.time_trip_shared_service = 0;

                    if (payload.title.data.type_of_trip == 'Z') {
                        vm.dataToFill.viaControlledApply = true;
                    } else vm.dataToFill.viaControlledApply = false;

                    if (markers.length) {
                        for (var i = 0; i < markers.length; i++) {
                            if (markers[i].id == 'driver') {
                                setMapOnAll(null, 'driver');
                            }
                        }
                    }
                    if (vm.dataToFill.airportCheck != 'Z' && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2)) {
                        toGetNearByDrivers(vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.serviceTypeSelected, map);
                    } else {
                        vm.dataToFill.viaControlledReal = vm.dataToFill.controlledWayCheck && vm.dataToFill.viaControlledApply ? vm.dataToFill.selectedServiceDetails.controlled_way : 0;
                        if (vm.dataToFill.selectedServiceDetails.fare_type == 1) {
                            vm.dataToFill.viaControlled = Number(vm.dataToFill.viaControlledReal) * Number(vm.dataToFill.passengerCount);
                        } else {
                            vm.dataToFill.viaControlled = Number(vm.dataToFill.viaControlledReal);
                        }
                    }

                    //console.log('ddssds', vm.dataToFill.viaControlled, vm.dataToFill.airportCheck);
                },
                function (errorPayload) {
                    vm.loading = false;

                    if (errorPayload.data.status == 400) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                    if (markers.length) {
                        for (var i = 0; i < markers.length; i++) {
                            if (markers[i].id == 'driver') {
                                setMapOnAll(null, 'driver');
                            }
                        }
                    }
                    $log.log(errorPayload);
                }
            );
        }

        //============================get near by drivers=========================
        function toGetNearByDrivers(lat, lng, service, map) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.currLat = lat;
            dataSend.currLong = lng;
            dataSend.service_type = service;
            vm.loading = true;
            var promise = getBookingsHereMaps.getNearDriver(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (markers.length) {
                        for (var i = 0; i < markers.length; i++) {
                            if (markers[i].id == 'driver') {
                                setMapOnAll(null, 'driver');
                            }
                        }
                    }
                    if (payload.title.data.SelecteddriversList && payload.title.data.SelecteddriversList.length) {
                        vm.nearByDriver = payload.title.data.SelecteddriversList;
                        if (vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                            calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, map);
                            getFixedRoutesForPersonal(vm.dataToFill);
                        }
                        for (var i = 0; i < payload.title.data.SelecteddriversList.length; i++) {
                            location = new google.maps.LatLng(Number(payload.title.data.SelecteddriversList[i].latitude), Number(payload.title.data.SelecteddriversList[i].longitude));
                            placeMarker(map, location, 'driver', payload.title.data.SelecteddriversList[i]);
                        }
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (markers.length) {
                        for (var i = 0; i < markers.length; i++) {
                            if (markers[i].id == 'driver') {
                                setMapOnAll(null, 'driver');
                            }
                        }
                    }
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        //errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        }
        //===================remove selected address========================
        function removeSelectedDriver() {
            vm.dataToFill.nearDriver = '';
        }

        //======================selecting item of charges=====================
        function selectingItemOfCharges(index, type) {
            console.log('debug selectingItemOfCharges');
            vm.dataToFill.estimatedFare = 0;
            vm.dataToFill.estimatedFareVariableReturn = 0;
            vm.click = false;
            //  vm.dataToFill.estimatedFareRoute = 0;
            //console.log(vm.dataToFill.estimatedFareRoute, ' vm.dataToFill.estimatedFareRoute');

            vm.dataToFill.estimatedFareVariable = vm.dataToFill.selectedServiceDetails.fare_type ? Number(vm.dataToFill.estimatedFareRoute) * Number(vm.dataToFill.passengerCount) : Number(vm.dataToFill.estimatedFareRoute);
            vm.dataToFill.estimatedFareVariableReturn = vm.dataToFill.selectedServiceDetails.fare_type ? Number(vm.dataToFill.Return_policy.estimatedFareRoute) * Number(vm.dataToFill.passengerCount) : Number(vm.dataToFill.Return_policy.estimatedFareRoute);

            if (type == 'select') {
                for (var i = 0; i < index.length; i++) {
                    if( index[i].retorno == false ){
                        vm.dataToFill.estimatedFareVariable = vm.dataToFill.estimatedFareVariable + Number(index[i].price);
                    } else if( index[i].retorno == true ){
                        vm.dataToFill.estimatedFareVariableReturn = vm.dataToFill.estimatedFareVariableReturn + Number(index[i].price);
                    }
                }
            } else if (type == 'remove') {
                for (var i = 0; i < index.length; i++) {
                    if( index[i].retorno == false ){
                        vm.dataToFill.estimatedFareVariable = vm.dataToFill.estimatedFareVariable + Number(index[i].price);
                    } else if( index[i].retorno == true ){
                        vm.dataToFill.estimatedFareVariableReturn = vm.dataToFill.estimatedFareVariableReturn + Number(index[i].price);
                    }
                }
            } else {
                for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                    if( vm.dataToFill.itemOfChargeSelected[i].retorno == false ){
                        vm.dataToFill.estimatedFareVariable = vm.dataToFill.estimatedFareVariable + Number(vm.dataToFill.itemOfChargeSelected[i].price);
                    } else if( vm.dataToFill.itemOfChargeSelected[i].retorno == true ){
                        vm.dataToFill.estimatedFareVariableReturn = vm.dataToFill.estimatedFareVariableReturn + Number(vm.dataToFill.itemOfChargeSelected[i].price);
                    }
                }
            }
            // console.log('>>>>> IN SELECT >>>>>>>>', vm.calculatedEstimatePriceFormFunctionEstimated, vm.dataToFill.estimatedFare)
            // if (vm.dataToFill.minimumFare) {
                vm.dataToFill.estimatedFare = vm.dataToFill.estimatedFareVariable < vm.dataToFill.minimumFare ? vm.dataToFill.minimumFare : vm.dataToFill.estimatedFareVariable;
            // } else {
                vm.dataToFill.estimatedFare = vm.dataToFill.estimatedFareVariable;

            if (vm.dataToFill.estimatedFareVariableReturn) {
                vm.dataToFill.Return_policy.estimatedFare = vm.dataToFill.estimatedFareVariableReturn;
            }

                // ********* VARIABLES ARE INITIALIZE TO AGAIN SET INPUT FIELD VARIABLE ********
                vm.calculatedEstimatePriceFormFunctionEstimated = -1;
                vm.finalAdjustedPriceFromAdmin = 0;
                vm.calculatedEstimatePriceForFixedPriceFormFunction = 0;
                vm.calculatedEstimatePriceForRoundTripFormFunction = 0;
                vm.click = false;

                // ******* WHEN ADJUSTED PRICE IS REMOVED WE hAVE TO SHOW OLDER DISCOUND OF ROUND TRIP ******
                vm.dataToFill.discounts = [];
                // test issue due to round trip disocunt
                var discountNew ;
                // = ((vm.dataToFill.roundTrip || (vm.bookingDetails && vm.bookingDetails.round_trip_parent_job_id > 0)) ? vm.dataToFill.roundTripDiscount : vm.bookingDetails.discount_amount);
                if((vm.dataToFill.roundTrip || (vm.bookingDetails && vm.bookingDetails.round_trip_parent_job_id > 0))) {
                    discountNew = vm.dataToFill.roundTripDiscount;
                }
                else if(vm.bookingDetails && vm.bookingDetails.discount_amount) {
                    discountNew = vm.bookingDetails.discount_amount;
                }

                if (vm.dataToFill.roundTrip == true) {
                    name = 'ROUND TRIP'
                }
                // test issue due to round trip disocunt
                // var name = vm.bookingDetails.promo_type == '0' ? vm.bookingDetails.promo_id : vm.bookingDetails.promo_type == '1' ? 'ROUND TRIP' : vm.bookingDetails.promo_type == '2' ? 'Web Discount' : vm.bookingDetails.promo_type == '3' ? 'Bin' : 'NA';
                vm.dataToFill.discounts.push({
                    // estimatedFare: Math.round(Number(vm.dataToFill.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled1))),
                    estimatedFare: viaControlledPrice(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking),
                    // roundTripFare: Math.round(Number(vm.dataToFill.Return_policy.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled2))),
                    roundTripFare: viaControlledPrice(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip),
                    name: name,
                    discountType: 1,
                    // Change by nakul sir
                    discountTypeValue: ((vm.dataToFill.roundTrip || (vm.bookingDetails && vm.bookingDetails.round_trip_parent_job_id > 0)) ? vm.dataToFill.roundTripDiscount : 0),
                    // discountTypeValue: vm.dataToFill.roundTripDiscount,
                    // value: ((Number(vm.estimatedFareDiscount) * Number(vm.dataToFill.roundTripDiscount)) / 100),
                    value: calculateDiscountPercentageAmount(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, discountNew, 'parent'),
                    // returnValue: ((vm.estimatedFareDiscountRound * Number(vm.dataToFill.roundTripDiscount)) / 100),
                    returnValue: calculateDiscountPercentageAmount(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, discountNew, 'parent'),
                    // finalAmount: Math.round((vm.estimatedFareDiscount - vm.estimatedFareDiscount * Number(vm.dataToFill.roundTripDiscount) / 100) + (vm.type_of_trip_Validate_Booking == 'Z' ? (Number(vm.viaControlled1)) : 0)),
                    finalAmount: calculateDiscountPercentage(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, discountNew, 'parent'),
                    // roundFinalAmount: Math.round((vm.estimatedFareDiscountRound - (vm.estimatedFareDiscountRound) * Number(vm.dataToFill.roundTripDiscount) / 100) + (vm.type_of_trip == 'Z' ? (Number(vm.viaControlled2)) : 0))
                    roundFinalAmount: calculateDiscountPercentage(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, discountNew)
                })
                // console.log('>>>>> DISCOUNT >>>>>>>>>>>', vm.dataToFill.discounts);
                vm.dataToFill.discounts.forEach(function (data) {
                    data.finalAmount = data.finalAmount < 0 ? 0 : data.finalAmount;
                })
                vm.dataToFill.discounts = vm.dataToFill.discounts.sort(function (a, b) {
                    return b.value - a.value
                })
                console.log(vm.dataToFill.discounts, 'vm.dataToFill.discountsafter');

                // vm.calculatedEstimatePriceFormFunctionEstimated += vm.dataToFill.estimatedFare;
            // }
            //console.log('ccc12', vm.dataToFill.estimatedFare);
            //console.log('ccc12', vm.dataToFill.estimatedFareVariable);
            //console.log('ccc12', vm.dataToFill.estimatedFareRoute);
        }

        // //==============get all corporate=================
        // function getAllCorporate() {
        //     vm.loading = true;
        //     var dataSend = {};
        //     dataSend.access_token = $cookies.get('obj');
        //     dataSend.limit = 0;
        //     dataSend.offset = 0;
        //     dataSend.key = 2;
        //     dataSend.search_filter = 0;
        //     var promise = getCorporate.allCorporates(dataSend);
        //     promise.then(
        //         function (payload) {
        //             $log.log('sxdsads', payload);
        //             vm.loading = false;
        //             vm.corporatesList = [];
        //             vm.corporatesList = payload.title.data.result;
        //             vm.corporatesList.push({
        //                 id: 'all',
        //                 company_name: 'Todos'
        //             });
        //         },
        //         function (errorPayload) {
        //             vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // };
        // getAllCorporate();

        // //======================get all agreements==============
        // function getAllAgreement() {
        //     var dataSend = {};
        //     dataSend.access_token = $cookies.get('obj');
        //     vm.loading = true;
        //     var promise = getAgreement.getAgreementListLessData(dataSend);
        //     promise.then(
        //         function (payload) {
        //             $log.log('sxdsads', payload);
        //             vm.loading = false;
        //             if (payload.title.status == 400) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //             } else if (payload.title.status == 401) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //             } else if (payload.title.status == 201 || payload.title.status == 200) {
        //                 vm.agreement = [];
        //                 //vm.tableAgreement = [];
        //                 for (var i = 0; i < payload.title.data.length; i++) {
        //                     if (payload.title.data[i].agreement_type == 'CORPORATE' && payload.title.data[i].status == 1) {
        //                         vm.agreement.push({
        //                             name: payload.title.data[i].name,
        //                             id: payload.title.data[i].id
        //                         });

        //                     }

        //                     //if(payload.title.data.contracts[i].employee_endowment == 1){
        //                     //    payload.title.data.contracts[i].color = 'lightgrey';
        //                     //}
        //                     //else{
        //                     //    payload.title.data.contracts[i].color = 'white';
        //                     //}
        //                 }
        //                 vm.agreement.push({
        //                     id: 'all',
        //                     name: 'Todos'
        //                 });
        //             }
        //             //vm.tableAgreement = _.where(payload.title.data,{agreement_type:'CORPORATE'});
        //         },
        //         function (errorPayload) {
        //             $log.log(errorPayload);
        //             vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // };
        // getAllAgreement();

        //========================open endowment pop p======================
        function addEndowment($event) {
            vm.items = {
                agreement: vm.agreement,
                tableAgreement: [],
                corporatesList: vm.corporatesList,
                rutFilter: '',
                agreementSelected: 'all',
                corporateSelected: 'all',
                finalAgreement: '',
                errorMsg: false,
                rutInvalid: false,
                loading: false,
                agreementToSend: [],
                limit: 10,
                offset: 0,
                totalCount: 0,
                backgroundColor: 'grey',
                internetFlag: true
            }

            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/addEndowmentOfNewCustomer.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: AddEndowmentController
            });

            function AddEndowmentController($scope, $mdDialog, items) {
                $scope.items = items;
                var dataGet = [];
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                // INTERNET ISSUE TIKCET 4187
                window.addEventListener('online', function (event) {
                    $scope.items.internetFlag = true;
                });
                window.addEventListener('offline', function (event) {
                    $scope.items.internetFlag = false;
                });
                // =================== GET FILTER DATA ===================
                function getFilterDataFromBackend(data, type) {
                    if (data) {
                        vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                        vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
                    } else {
                        vm.filterObject = {
                            access_token: $cookies.get('obj'),
                            branch_filter: 0,
                            vehicle_filter: 0,
                            service_filter: 0,
                            agreement_filter: 1,
                            corporate_filter: 1,
                            service_category: 0,
                            corporate_status: 2,
                            agreement_status: 1,
                            vehicle__status: 0,
                            operation_point_filter: 0,
                            branch_search_filter: 0,
                            vehicle_search_filter: 0,
                            service_search_filter: 0,
                            agreement_search_filter: 0,
                            corporate_search_filter: 0,
                            operation_point_search_filter: 0,
                            agreement_type: 'CORPORATE'
                        }
                    }
                    vm.filterObject.agreement_limit = vm.globalLimit;
                    vm.filterObject.agreement_offset = vm.agreementOffset;
                    vm.filterObject.corporate_limit = vm.globalLimit;
                    vm.filterObject.corporate_offset = vm.corporateOffset;
                    $scope.agreementShowArray;
                    $scope.coprateListShow;
                    var promise = getFilters.getAllFilterData(vm.filterObject);
                    promise.then(
                        function (payload) {

                            // ********** Agrrement DATA ********
                            if (payload.title.data.agreements) {
                                var index = _.findIndex(vm.agreement, {
                                    id: 'all'
                                });
                                if (index == -1)
                                    vm.agreement.push({
                                        name: 'Todos',
                                        id: 'all'
                                    });
                                angular.forEach(payload.title.data.agreements.data, function (column) {
                                    // vm.corporatesList.push(column)
                                    var agreement = _.findIndex(vm.agreement, {
                                        id: column.id
                                    });
                                    if (agreement == -1)
                                        vm.agreement.push(column)

                                });
                                vm.agreementTotalBackendCount = payload.title.data.agreements.totalCount;
                                $scope.agreementShowArray = vm.agreement;
                            }
                            // ********** CORPORATE DATA ********
                            if (payload.title.data.corporates) {
                                var index = _.findIndex(vm.corporatesList, {
                                    id: 'all'
                                });
                                if (index == -1)
                                    vm.corporatesList.push({
                                        company_name: 'Todos',
                                        id: 'all'
                                    });
                                angular.forEach(payload.title.data.corporates.data, function (column) {
                                    // vm.corporatesList.push(column)
                                    var corprateIndex = _.findIndex(vm.corporatesList, {
                                        id: column.id
                                    });
                                    if (corprateIndex == -1)
                                        vm.corporatesList.push(column)

                                });
                                console.log(vm.corporatesList.length, 'vm.corporatesList');
                                $scope.coprateListShow = vm.corporatesList;
                                vm.corporateTotalBackendCount = payload.title.data.corporates.totalCount;
                            }
                            $timeout(function () {
                                $scope.$apply();
                            })
                            vm.loading = false;
                        },
                        function (errorPayload) {
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        });
                }

                $scope.corporate = function (data) {
                    setTimeout(function () {
                        // document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                        //     // if (vm.branchList && (vm.branchList.length == 0)) {
                        //     vm.searchCorporateData = '';
                        //     vm.agreementOffset = 0;
                        //     vm.agreement = [];
                        //     getFilterDataFromBackend(0, 0);
                        // });

                        document.getElementsByClassName('ui-select-search')[1].addEventListener('blur', function ($event) {
                            // if (vm.corporatesList && (vm.corporatesList.length == 0)) {
                            vm.searchCorporateData = '';
                            vm.corporatesList = [];
                            vm.corporateOffset = 0;
                            getFilterDataFromBackend(0, 0);
                            // }
                        });
                    })
                }
                $scope.aggrementchange = function () {
                    setTimeout(function () {
                        document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                            // if (vm.branchList && (vm.branchList.length == 0)) {
                            vm.searchCorporateData = '';
                            vm.agreementOffset = 0;
                            vm.agreement = [];
                            getFilterDataFromBackend(0, 0);
                        });

                        // document.getElementsByClassName('ui-select-search')[1].addEventListener('blur', function ($event) {
                        //     // if (vm.corporatesList && (vm.corporatesList.length == 0)) {
                        //     vm.searchCorporateData = '';
                        //     vm.corporatesList = [];
                        //     vm.corporateOffset = 0;
                        //     getFilterDataFromBackend(0, 0);
                        //     // }
                        // });
                    })
                }
                // *********** COMMON FUNCTION FOR FILTER PAGINATION AND SEARCHING ***********
                function commonFunction(type, mode) {

                    for (var i = 0; i < vm.searchFilterArray.length; i++) {
                        console.log("searching ..........");

                        if (mode == 'search' || i != type) {
                            vm[vm.searchFilterArrayForClearArray[i]] = [];
                            // vm[vm.searchFilterArrayForClearArray[i]].push({
                            //     id: 'all',
                            //     name: 'Todos'
                            // });
                            vm[vm.searchFilterArray[i] + 'Offset'] = 0;
                            vm['search' + vm.searchFilterArray[i].substring(0, 1).toUpperCase() + vm.searchFilterArray[i].substring(1) + 'Data'] = '';
                        }
                    }
                }
                getFilterDataFromBackend(0, 0);
                setTimeout(function () {
                    document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                        // if (vm.branchList && (vm.branchList.length == 0)) {
                        vm.searchCorporateData = '';
                        vm.agreementOffset = 0;
                        vm.agreement = [];
                        getFilterDataFromBackend(0, 0);
                    });

                    document.getElementsByClassName('ui-select-search')[1].addEventListener('blur', function ($event) {
                        // if (vm.corporatesList && (vm.corporatesList.length == 0)) {
                        vm.searchCorporateData = '';
                        vm.corporatesList = [];
                        vm.corporateOffset = 0;
                        getFilterDataFromBackend(0, 0);
                        // }
                    });
                })
                // ************ PAGINATION ON CORPORATE **************
                $scope.paginationChangedForCorporation = function () {
                    var index = _.findIndex(vm[vm.searchFilterArray[5]], {
                        id: 'all'
                    });
                    index = (index == -1 ? 0 : 1);
                    if (vm.corporateTotalBackendCount > (vm.corporatesList.length - index)) {
                        commonFunction(4);
                        vm.corporateOffset += vm.globalOffset;
                        getFilterDataFromBackend(vm.searchCorporateData, 4);
                    }
                }

                // ************ PAGINATION ON AGREEMENT **************
                $scope.paginationChangedForAgreement = function () {
                    var index = _.findIndex(vm[vm.searchFilterArray[3]], {
                        id: 'all'
                    });
                    index = (index == -1 ? 0 : 1);
                    if (vm.agreementTotalBackendCount > (vm.agreement.length - index)) {
                        commonFunction(3);
                        vm.agreementOffset += vm.globalOffset;
                        getFilterDataFromBackend(vm.searchAgreementData, 3);
                    }
                }

                // ************ SEARCH SERVICE ***************
                $scope.corporateSearch = function (data, event) {
                    if (event.keyCode != 40 && event.keyCode != 38) {
                        vm.searchCorporateData = data;
                        $timeout.cancel($scope.timeoutSearch);
                        commonFunction(4, 'search');
                        $scope.timeoutSearch = $timeout(function () {
                            getFilterDataFromBackend(data, 4);
                        }, 2000);
                    }
                }

                // ************ SEARCH AGREEMENT ***************
                $scope.agreementSearch = function (data, event) {
                    if (event.keyCode != 40 && event.keyCode != 38) {
                        vm.searchAgreementData = data;
                        $timeout.cancel($scope.timeoutSearch);
                        commonFunction(3, 'search');
                        $scope.timeoutSearch = $timeout(function () {
                            getFilterDataFromBackend(data, 3);
                        }, 2000);
                    }
                }
                $scope.confirmUpload = function () {
                    if (!$scope.items.internetFlag) {
                        return;
                    }
                    if ($scope.items.agreementToSend.length == 0) {
                        $scope.items.errorMsg = true;
                        $timeout(function () {
                            $scope.items.errorMsg = false;
                        }, 2000);
                    } else {
                        $mdDialog.hide();
                        makeNewAgreementInList($scope.items.agreementToSend);
                    }

                };
                $scope.selectParticularEndowment = function (index) {
                    $scope.items.agreementToSend = $scope.items.tableAgreement[index];
                }
                $scope.rutChange = function () {
                    if ($scope.items.rutFilter) {
                        if (RutHelper.validate($scope.items.rutFilter)) {
                            $log.log();
                            $scope.items.rutInvalid = false;
                        } else {
                            $scope.items.rutInvalid = true;
                        }
                    } else if ($scope.items.rutFilter === null) {
                        $scope.items.rutInvalid = true;
                    } else if ($scope.items.rutFilter === undefined) {
                        $scope.items.rutInvalid = false;
                    }
                }

                $scope.paginationChanged = function () {
                    if ($scope.items.totalCount != $scope.items.tableAgreement.length) {
                        $scope.items.offset = $scope.items.offset + $scope.items.limit;
                        $scope.getFilterDataForEndowment();
                    }
                }

                $scope.getFilterChange = function () {
                    $scope.items.tableAgreement = [];
                    dataGet = [];
                    $scope.items.offset = 0;
                    $scope.items.limit = 10;
                }

                $scope.getFilterDataForEndowment = function () {
                    if ($scope.items.rutInvalid) {
                        return;
                    }
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.limit = $scope.items.limit;
                    dataSend.offset = $scope.items.offset;
                    if ($scope.items.agreementSelected && $scope.items.agreementSelected != 'all') {
                        dataSend.agreement_id = Number($scope.items.agreementSelected);
                        $scope.items.tableAgreement = [];
                        dataGet = [];
                    }
                    if ($scope.items.corporateSelected && $scope.items.corporateSelected != 'all') {
                        dataSend.corporate_id = Number($scope.items.corporateSelected);
                        $scope.items.tableAgreement = [];
                        dataGet = [];
                    }

                    if ($scope.items.rutFilter) {
                        dataSend.corporate_rut = RutHelper.clean($scope.items.rutFilter);
                        $scope.items.tableAgreement = [];
                        dataGet = [];
                    }
                    //console.log(dataSend);
                    $scope.items.loading = true;
                    var promise = getAgreement.getAgreementListLessDataWithFilters(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            $scope.items.loading = false;
                            for (var i = 0; i < payload.title.data.contracts.result.length; i++) {
                                payload.title.data.contracts.result[i].selected = false;
                                if (payload.title.data.contracts.result[i].employee_endowment == 1) {
                                    payload.title.data.contracts.result[i].color = 'lightgrey';
                                } else {
                                    payload.title.data.contracts.result[i].color = 'white';
                                }
                                dataGet.push(payload.title.data.contracts.result[i]);
                            }
                            $scope.items.totalCount = payload.title.data.contracts.totalCount;
                            $scope.items.tableAgreement = _.where(dataGet, {
                                agreement_type: 'CORPORATE'
                            });
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            $scope.items.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }
                $scope.getFilterDataForEndowment();
            }
        }

        //==========================make new agreement in new list======================
        function makeNewAgreementInList(data) {
            //console.log(data);
            vm.dataToFill.contractIdSelected = data.contract_id;
            var where = _.where(vm.dataToFill.contractListShowing, {
                id: data.contract_id
            });
            var a = '';
            for (var i = 0; i < vm.dataToFill.contractListShowing.length; i++) {
                if (vm.dataToFill.contractListShowing[i].name.indexOf("*") > -1) {
                    a = i;
                    vm.dataToFill.contractListShowing.splice(a, 1);
                }
            }
            agreementTypeChanged();
            if (where.length) {
                return;
            } else {
                vm.dataToFill.contractListShowing.push({
                    name: data.name + '*',
                    id: data.contract_id
                });
            }
        }

        //======================create booking by pass because of new customer register===========================
        function createBookingByPass($event, reaccurringKey, createBookingKey) {
            vm.disableSubmitButton = false;
            get_cuota();
            console.log(vm.dataToFill, $event, 'Puuneeet i m here');
            if (vm.bookingDetails && vm.bookingDetails.sin_respaldo == 0)
                checkAndMakeBookingData($event, reaccurringKey, createBookingKey);
            else if (!vm.bookingDetails)
                checkAndMakeBookingData($event, reaccurringKey, createBookingKey);
            // else editBookingApi($event);
            //if(vm.dataToFill.first_name && (vm.dataToFill.customerProfile == '1' || vm.dataToFill.customerProfile == 1)){
            //    createEmployeeNew($event);
            //}
            //else if(vm.dataToFill.first_name && (vm.dataToFill.customerProfile == '0' || vm.dataToFill.customerProfile == 0)){
            //    createCustomerNew($event);
            //}
            //else {
            //    checkAndMakeBookingData($event);
            //}

        };

        function createEmployeeNew($event, arrayFDatesMade) {
            // if($event.validate == undefined){
            //     return true;
            // }
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('newUserPop1', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('cancelButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.contract_id = vm.dataToFill.contractIdSelected;
                dataSend.corporate_id = vm.dataToFill.corporate_account_id;
                dataSend.domainUrl = checkDomain.getDomainName();
                dataSend.employee_list = {
                    name: vm.dataToFill.first_name ? vm.dataToFill.first_name : vm.dataToFill.customerMobile.first_name,
                    last_name: vm.dataToFill.last_name ? vm.dataToFill.last_name : vm.dataToFill.customerMobile.last_name,
                    cost_center: vm.dataToFill.costCenter ? vm.dataToFill.costCenter : '',
                    cost_subcenter: vm.dataToFill.costSubCenter ? vm.dataToFill.costSubCenter : '',
                    ROI: vm.dataToFill.Rol ? vm.dataToFill.Rol : '',
                    graph: vm.dataToFill.graph ? vm.dataToFill.graph : '',
                    order_of_work: vm.dataToFill.workOrder ? vm.dataToFill.workOrder : '',
                    PEP: vm.dataToFill.pep ? vm.dataToFill.pep : '',
                    email: vm.dataToFill.customerEmail,
                    phone_number: vm.dataToFill.customerMobileG,
                    //password:  vm.dataToFill.password?vm.dataToFill.password:'',
                    country_code: vm.dataToFill.country_code
                };

                //console.log(dataSend);
                vm.loading = true;
                var promise = getAgreement.manageEmployeesFromCreateBooking(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        languageBasedErrorFactory.getProperErrorMessage('userRegSucc1', 0, 0)
                        //errorMessageFactory.showErrorMessage('User registered successfully',0);
                        $timeout(function () {
                            $mdDialog.hide();
                            if (vm.dataToFill.nearDriver && vm.flagForEditBooking == false) {
                                //checkBeforeAssignDriver($event,arrayFDatesMade);
                                createBookingApi($event, arrayFDatesMade);
                            } else if (vm.flagForEditBooking == false) {
                                createBookingApi($event, arrayFDatesMade);
                            } else if (vm.flagForEditBooking = true) {
                                editBookingApi($event, arrayFDatesMade);
                            }
                        }, 1500);
                        //$state.reload();
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        vm.disableSubmitButton = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        }

        function createCustomerNew($event, arrayFDatesMade) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('newUserPop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('cancelButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                var dataSend = new FormData();
                var domain = checkDomain.getDomainName();
                dataSend.append('access_token', $cookies.get('obj'));
                dataSend.append('first_name', vm.dataToFill.first_name);
                dataSend.append('last_name', vm.dataToFill.last_name);
                dataSend.append('email', vm.dataToFill.customerEmail);
                dataSend.append('country_code', vm.dataToFill.country_code);
                dataSend.append('phone_number', vm.dataToFill.customerMobileG);
                //dataSend.append('password',vm.dataToFill.password);
                dataSend.append('timezone', vm.dataToFill.timeZone);
                dataSend.append('domainUrl', domain);
                //console.log(dataSend);
                vm.loading = true;
                var promise = getCustomers.addCustomer(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        if (payload.title.status == 400) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            languageBasedErrorFactory.getProperErrorMessage('userRegSucc', 0, 0)
                            //errorMessageFactory.showErrorMessage('User registered successfully',0);
                            $timeout(function () {
                                $mdDialog.hide();
                                if (vm.dataToFill.nearDriver) {
                                    //checkBeforeAssignDriver($event,arrayFDatesMade);
                                    createBookingApi($event, arrayFDatesMade);
                                } else {
                                    createBookingApi($event, arrayFDatesMade);
                                }
                            }, 1500);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        vm.disableSubmitButton = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        }

        //===========================check before assigning driver=====================
        //function checkBeforeAssignDriver($event,arrayFDatesMade){
        //    var dataSend = {
        //        access_token: $cookies.get('obj'),
        //        pickup_lat : vm.dataToFill.pickUpLat,
        //        pickup_long : vm.dataToFill.pickUpLng,
        //        drop_lat : vm.dataToFill.dropOffLat,
        //        drop_long : vm.dataToFill.dropOffLng,
        //        fleet_id : vm.dataToFill.nearDriver
        //    };
        //    vm.loading = true;
        //    var promise = getBookingsHereMaps.checkBeforeAssignDriverToJobApi(dataSend);
        //    promise.then(
        //        function (payload) {
        //            $log.log('sxdsads', payload);
        //            vm.loading = false;
        //            if(!$stateParams.id){
        //                createBookingApi($event,arrayFDatesMade);
        //            }
        //            else if($stateParams.id){
        //                editBookingApi($event,arrayFDatesMade);
        //            }
        //
        //        },
        //        function (errorPayload) {
        //            $log.log(errorPayload);
        //            vm.loading = false;
        //            if(errorPayload.data.status == 401){
        //                errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
        //            }
        //            else{
        //                checkDriverPop(errorPayload.data.message,$event,arrayFDatesMade);
        //            }
        //        }
        //    );
        //}
        //
        //function checkDriverPop(msg,$event,arrayFDatesMade) {
        //    var confirm = $mdDialog.confirm()
        //        .title(msg)
        //        .textContent('')
        //        .ariaLabel('Lucky day')
        //        .targetEvent($event)
        //        .ok('SI')
        //        .cancel('NO');
        //
        //    $mdDialog.show(confirm).then(function () {
        //        if(!$stateParams.id){
        //            createBookingApi($event,arrayFDatesMade);
        //        }
        //        else if($stateParams.id){
        //            editBookingApi($event,arrayFDatesMade);
        //        }
        //    }, function () {
        //        $log.log('not confirmed');
        //    });
        //};
        function funcationif() {
            if (vm.grantedCheckbox && vm.dataToFill.allowBookingWithoutRequest == 1) {
                return true;
            } else {
                return false;
            }
        }
        //====================================check and make booking data================================
        function checkAndMakeBookingData($event, data, key) {
            console.log("puneet here >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>", $event)

            var returnDateTimeFormat = '';
            var scheduledDateTimeFormat = '';
            // var scheduledDateTimeFormatForRType = '';
            var dropDateTimeFormat = '';
            vm.errorFlagForDate = false;
            ///////////////////////////// TV-2893 //////////////////////////////////////////
            //if (vm.dataToFill.scheduledBooking == 1 && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2) && vm.type_of_trip_Validate_Booking == 'R') {
                //var DateForTypeOfTripR = '';
                //DateForTypeOfTripR = vm.errorShowDateForRType._d;
                //var TimeForTypeOfTripR = new Date(DateForTypeOfTripR).getTime();
                //var CurrentTimeForR = new Date().getTime();
                //var differenceInMinutes = parseInt((TimeForTypeOfTripR - CurrentTimeForR) / 60000);
                //if (DateForTypeOfTripR < new Date()) {
                    //vm.errorFlagForDate = true;
                    //errorMessageFactory.showErrorMessage('La reserva no puede ser creada porque la Hora de Retiro es inferior a la hora actual', 0)
                    //return;
                //}
                //// console.log(differenceInMinutes, 'differenceInMinutes');
                //// if (differenceInMinutes <= 30) {
                ////     errorMessageFactory.showErrorMessage('La reserva no puede ser creada por encontrarse muy cerca la hora de retiro', 0)
                ////     return;
                //// }
            //}
            ///////////////////////////// TV-2893 //////////////////////////////////////////
            if (vm.modifyBooking == true && new Date(vm.bookingDetails.return_date_time_utc) == 'Invalid Date' && vm.dataToFill.returnDate == '' && vm.dataToFill.returnTime == '') {
                vm.dataToFill.returnDate = new Date(vm.bookingDetails.return_date_time_utc) == 'Invalid Date' ? '' : new Date(vm.bookingDetails.return_date_time_utc);
                vm.dataToFill.returnTime = new Date(vm.bookingDetails.return_date_time_utc) == 'Invalid Date' ? '' : new Date(vm.bookingDetails.return_date_time_utc);
            }
            if (vm.dataToFill.returnDate != '' && vm.dataToFill.returnTime != '' && vm.dataToFill.selectedServiceDetails.category != 1) {
                returnDateTimeFormat = dateTimeFormat(vm.dataToFill.returnDate, vm.dataToFill.returnTime);
            } else {
                returnDateTimeFormat = dateTimeFormat(vm.dataToFill.dropDateReturn, vm.dataToFill.dropTimeReturn);
            }
            if (vm.modifyBooking == true && new Date(vm.dataToFill.dropDate) == 'Invalid Date' && vm.dataToFill.dropDate == '' && vm.dataToFill.dropTime == '') {
                dropDateTimeFormat = new Date(vm.dataToFill.dropDate) == 'Invalid Date' ? '' : dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime);
            }
            if (vm.dataToFill.dropDate != '' && vm.dataToFill.dropTime != '') {
                dropDateTimeFormat = dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime);
            }
            if (vm.modifyBooking == true && new Date(vm.dataToFill.scheduledDate) == 'Invalid Date' && vm.dataToFill.scheduledDate == '' && vm.dataToFill.scheduledTime == '') {
                scheduledDateTimeFormat = new Date(vm.dataToFill.scheduledDate) == 'Invalid Date' ? '' : dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime);
                // scheduledDateTimeFormat = dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime);
            }
            if (vm.dataToFill.scheduledDate != '' && vm.dataToFill.scheduledTime != '') {
                scheduledDateTimeFormat = dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime);
            }
            if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking != 'R') {
                scheduledDateTimeFormat = dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime);
            }
            // if (vm.dataToFill.bookingType == '1' && vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking == 'R') {
            //     scheduledDateTimeFormatForRType = dateTimeFormat(vm.dataToFill.dropDateOfRType, vm.dataToFill.dropTimeOfRtype);
            // }
            if (vm.roundTripTImeLess == true && vm.dataToFill.roundTrip == true) {
                if ((returnDateTimeFormat < scheduledDateTimeFormat) && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2) ||
                    ((returnDateTimeFormat < dropDateTimeFormat) && vm.dataToFill.selectedServiceDetails.category == 1) ||
                    ((returnDateTimeFormat < dropDateTimeFormat) && vm.dataToFill.selectedServiceDetails.category == 1 ||
                        ((returnDateTimeFormat < new Date()) && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2)))) {
                    // languageBasedErrorFactory.getProperErrorMessage('returnDateTimeError', 0, 0)
                    // errorMessageFactory.showErrorMessage('heello');
                    var msg = 'Reserva RT ' + vm.bookingDetails.round_trip_child_job_id + ' tiene fecha de retiro inferior'
                    var confirm = $mdDialog.confirm()
                        .title(msg)
                        .textContent('')
                        .ariaLabel('Lucky day')
                        .targetEvent($event)
                        .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                        .cancel(languageBasedErrorFactory.getProperErrorMessage('cancelButton', 0, '3'));

                    $mdDialog.show(confirm).then(function () {
                            editBookingApi($event);
                        },
                        function () {
                            $log.log('not confirmed');
                        });

                }
                editBookingApi($event);
                return
            }

            if (vm.dataToFill.selectedServiceDetails.category == 1 && (vm.dataToFill.bookingType == '0' || vm.dataToFill.bookingType == 0)) {
                var checkDropTime = moment(moment(dropDateTimeFormat)).isAfter(moment());
                if (dropDateTimeFormat.getDate() > new Date().getDate()) {
                    vm.errorFlagForDate = true;
                    languageBasedErrorFactory.getProperErrorMessage('approDateTime', 0, 0)
                    //errorMessageFactory.showErrorMessage('Please select appropriate date & time.');
                    return;
                }
                if (!checkDropTime) {
                    vm.errorFlagForDate = true;
                    errorMessageFactory.showErrorMessage('Hora de recogida debe ser mayor a la hora actual.', 0)
                    //errorMessageFactory.showErrorMessage('Please select appropriate date & time.');
                    return;
                }
            }
            if (vm.dataToFill.selectedServiceDetails.category == 1 && (vm.dataToFill.bookingType == '1' || vm.dataToFill.bookingType == 1)) {
                var checkDropTime = moment(moment(dropDateTimeFormat)).isAfter(moment());
                if (!checkDropTime) {
                    vm.errorFlagForDate = true;
                    errorMessageFactory.showErrorMessage('Hora de recogida debe ser mayor a la hora actual.', 0)
                    //errorMessageFactory.showErrorMessage('Please select appropriate date & time.');
                    return;
                }
            }

            if (vm.dataToFill.roundTrip && vm.dataToFill.reaccurringBooking) {
                vm.errorFlagForDate = true;
                languageBasedErrorFactory.getProperErrorMessage('bookingError', 0, 0)
                //errorMessageFactory.showErrorMessage('This type of booking is not allowed.');
                return;
            }
            if (!vm.dataToFill.payment_method && !vm.modifyFalg) {
                vm.errorFlagForDate = true;
                errorMessageFactory.showErrorMessage('Please select payment method.', 0, 0);
                //errorMessageFactory.showErrorMessage("Selected customer don't have any corporate account");
                return;
            }

            if (vm.dataToFill.roundTrip && vm.dataToFill.is_wait_time_included && vm.dataToFill.selectedServiceDetails.category == 1) {
                vm.errorFlagForDate = true;
                languageBasedErrorFactory.getProperErrorMessage('bookingError', 0, 0)
                //errorMessageFactory.showErrorMessage('This type of booking is not allowed.');
                return;
            }
            var check = moment(moment(scheduledDateTimeFormat)).isAfter(moment());
            if ((vm.dataToFill.bookingType == '1' && !check) && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2)) {
                vm.errorFlagForDate = true;
                languageBasedErrorFactory.getProperErrorMessage('approDateTime', 0, 0)
                //errorMessageFactory.showErrorMessage('Please select appropriate date & time.');
                return;
            }
            // if ((vm.dataToFill.bookingType == '1' && scheduledDateTimeFormatForRType <= new Date()) && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2) && vm.type_of_trip_Validate_Booking == 'R') {
            //     languageBasedErrorFactory.getProperErrorMessage('approDateTime', 0, 0)
            //     //errorMessageFactory.showErrorMessage('Please select appropriate date & time.');
            //     return;
            // }

            if (vm.dataToFill.tillDate <= new Date() && vm.dataToFill.reaccurringBooking == true) {
                vm.errorFlagForDate = true;
                languageBasedErrorFactory.getProperErrorMessage('tillDateErr', 0, 0)
                //errorMessageFactory.showErrorMessage('Please select till date with at least 7 days difference.');
                return;
            }
            if ((vm.Flag == false) && (vm.dataToFill.route_id == '' || vm.dataToFill.route_id == undefined || vm.dataToFill.route_id == null)) {
                //console.log("i m in error ====================================");
                vm.errorFlagForDate = true;
                languageBasedErrorFactory.getProperErrorMessage('validPickDrop', 0, 0)
                //errorMessageFactory.showErrorMessage('Please choose valid pickup and drop off locations');
                return;
            }
            if ((vm.dataToFill.corporate_account_id == '' || vm.dataToFill.corporate_account_id == undefined || vm.dataToFill.corporate_account_id == null) && (vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == '1')) {
                vm.errorFlagForDate = true;
                languageBasedErrorFactory.getProperErrorMessage('custCorpoNot', 0, 0)
                //errorMessageFactory.showErrorMessage("Selected customer don't have any corporate account");
                return;
            }
            if (vm.dataToFill.roundTrip && !vm.dataToFill.is_wait_time_included && (vm.posBookingFlag == false) && (vm.type_of_trip != 'R' && vm.dataToFill.selectedServiceDetails.category != 1)) {
                if ((returnDateTimeFormat < new Date()) && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2)) {
                    vm.errorFlagForDate = true;
                    languageBasedErrorFactory.getProperErrorMessage('returnDateTimeError', 0, 0)
                    //errorMessageFactory.showErrorMessage("Please select appropriate return date & time.");
                    return;
                } else if ((returnDateTimeFormat < dropDateTimeFormat) && vm.dataToFill.selectedServiceDetails.category == 1) {
                    vm.errorFlagForDate = true;
                    languageBasedErrorFactory.getProperErrorMessage('returnDateTimeError', 0, 0)
                    //errorMessageFactory.showErrorMessage("Please select appropriate return date & time.");
                    return;
                }
                if (vm.dataToFill.bookingType == '1') {
                    if ((returnDateTimeFormat < scheduledDateTimeFormat) && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2)) {
                        vm.errorFlagForDate = true;
                        languageBasedErrorFactory.getProperErrorMessage('returnDateTimeError', 0, 0)
                        //errorMessageFactory.showErrorMessage('Please select appropriate return date & time.');
                        return;
                    } else if ((returnDateTimeFormat < dropDateTimeFormat) && vm.dataToFill.selectedServiceDetails.category == 1) {
                        vm.errorFlagForDate = true;
                        languageBasedErrorFactory.getProperErrorMessage('returnDateTimeError', 0, 0)
                        //errorMessageFactory.showErrorMessage('Please select appropriate return date & time.');
                        return;
                    }
                }



            }
            if (vm.dataToFill.roundTrip && !vm.dataToFill.is_wait_time_included && (vm.posBookingFlag == false) && ((vm.type_of_trip == 'R' && vm.dataToFill.selectedServiceDetails.category == 1))) {
                if ((returnDateTimeFormat < new Date()) && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2)) {
                    vm.errorFlagForDate = true;
                    languageBasedErrorFactory.getProperErrorMessage('returnDateTimeError', 0, 0)
                    //errorMessageFactory.showErrorMessage("Please select appropriate return date & time.");
                    return;
                } else if ((returnDateTimeFormat < dropDateTimeFormat) && vm.dataToFill.selectedServiceDetails.category == 1) {
                    vm.errorFlagForDate = true;
                    languageBasedErrorFactory.getProperErrorMessage('returnDateTimeError', 0, 0)
                    //errorMessageFactory.showErrorMessage("Please select appropriate return date & time.");
                    return;
                }
                if (vm.dataToFill.bookingType == '1') {
                    if ((returnDateTimeFormat < scheduledDateTimeFormat) && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2)) {
                        vm.errorFlagForDate = true;
                        languageBasedErrorFactory.getProperErrorMessage('returnDateTimeError', 0, 0)
                        //errorMessageFactory.showErrorMessage('Please select appropriate return date & time.');
                        return;
                    } else if ((returnDateTimeFormat < dropDateTimeFormat) && vm.dataToFill.selectedServiceDetails.category == 1) {
                        vm.errorFlagForDate = true;
                        languageBasedErrorFactory.getProperErrorMessage('returnDateTimeError', 0, 0)
                        //errorMessageFactory.showErrorMessage('Please select appropriate return date & time.');
                        return;
                    }
                }



            }

            var where = _.where(vm.serviceTypeList, {
                id: Number(vm.dataToFill.serviceTypeSelected)
            });
            if (vm.dataToFill.passengerCount > where[0].max_limit) {
                vm.errorFlagForDate = true;
                languageBasedErrorFactory.getProperErrorMessage('noOfPassErr', 0, 0)
                //errorMessageFactory.showErrorMessage("Please enter correct no. of passengers.");
                return;
            }

            Date.prototype.addDays = function (days) {
                this.setDate(this.getDate() + parseInt(days));
                return this;
            };
            if (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2) {
                if (vm.dataToFill.bookingType == '1') {
                    var currentDate = dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime);
                } else {
                    var currentDate = new Date();
                }
            } else if (vm.dataToFill.selectedServiceDetails.category == 1) {
                var currentDate = dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime);
            }
            //var currentDate = new Date();
            var lastDate = vm.dataToFill.tillDate;
            var arrayDatesMade = [];

            while (currentDate <= lastDate) {
                arrayDatesMade.push(new Date(currentDate));
                currentDate = currentDate.addDays(1);
                $log.log(currentDate);
            }
            arrayDatesMade.push(new Date(lastDate));
            //console.log('asdsadasdas', arrayDatesMade);
            for (var i = 0; i < arrayDatesMade.length; i++) {
                if ((vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2))
                    arrayDatesMade[i] = dateTimeFormat(arrayDatesMade[i], vm.dataToFill.bookingType == '1' ? vm.dataToFill.scheduledTime : new Date());
                else if (vm.dataToFill.selectedServiceDetails.category == 1) {
                    if (data == true) {
                        // vm.dataToFill.dropDate = arrayDatesMade[i];
                        vm.dataToFill.tillDate = arrayDatesMade[i];
                        vm.dataToFill.dropTime = vm.dataToFill.dropTime;
                        vm.pickRangeSendForRouting.length = 1;
                        vm.etaArray.length = 1;
                        vm.pickup_lower_range.length = 1;
                        vm.pickup_top_range.length = 1;
                        console.log(vm.pickRangeSendForRouting, vm.etaArray);
                        RoutingApiFuncation(vm.dataToFill, i, 'recurring');
                    }
                    arrayDatesMade[i] = dateTimeFormat(arrayDatesMade[i], vm.dataToFill.dropTime);
                }
            }

            $log.log(vm.daysList);
            var arrayFDatesMade = [];
            for (var i = 0; i < arrayDatesMade.length; i++) {
                if (vm.daysList.sunday.selected && vm.daysList.sunday.value == 0) {
                    if (vm.daysList.sunday.value == arrayDatesMade[i].getDay()) {
                        arrayFDatesMade.push(arrayDatesMade[i].toISOString());
                    }
                }
                if (vm.daysList.monday.selected && vm.daysList.monday.value) {
                    if (vm.daysList.monday.value == arrayDatesMade[i].getDay()) {
                        arrayFDatesMade.push(arrayDatesMade[i].toISOString());
                    }
                }
                if (vm.daysList.tuesday.selected && vm.daysList.tuesday.value) {
                    if (vm.daysList.tuesday.value == arrayDatesMade[i].getDay()) {
                        arrayFDatesMade.push(arrayDatesMade[i].toISOString());
                    }
                }
                if (vm.daysList.wednesday.selected && vm.daysList.wednesday.value) {
                    if (vm.daysList.wednesday.value == arrayDatesMade[i].getDay()) {
                        arrayFDatesMade.push(arrayDatesMade[i].toISOString());
                    }
                }
                if (vm.daysList.thursday.selected && vm.daysList.thursday.value) {
                    if (vm.daysList.thursday.value == arrayDatesMade[i].getDay()) {
                        arrayFDatesMade.push(arrayDatesMade[i].toISOString());
                    }
                }
                if (vm.daysList.friday.selected && vm.daysList.friday.value) {
                    if (vm.daysList.friday.value == arrayDatesMade[i].getDay()) {
                        arrayFDatesMade.push(arrayDatesMade[i].toISOString());
                    }
                }
                if (vm.daysList.saturday.selected && vm.daysList.saturday.value) {
                    if (vm.daysList.saturday.value == arrayDatesMade[i].getDay()) {
                        arrayFDatesMade.push(arrayDatesMade[i].toISOString());
                    }
                }

            }
            if (vm.dataToFill.pickUpLat == vm.dataToFill.dropOffLat && vm.dataToFill.pickUpLng == vm.dataToFill.dropOffLng && !vm.ErrorFlagForNewApi) {
                vm.errorFlagForDate = true;
                languageBasedErrorFactory.getProperErrorMessage('dropPick', 0, 0)
                //errorMessageFactory.showErrorMessage("Drop-off location must be different from Pickup location");
                return;
            }
            //console.log('arrayDatesMade121212', arrayFDatesMade);
            for (var i = 0; i < arrayFDatesMade.length; i++) {
                if (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2) {
                    if (new Date(arrayFDatesMade[i]).getDate() == new Date().getDate() && new Date(arrayFDatesMade[i]).getMonth() == new Date().getMonth() && new Date(arrayFDatesMade[i]).getFullYear() == new Date().getFullYear()) {
                        arrayFDatesMade.splice(i, 1);
                    } else if (new Date(arrayFDatesMade[i]).getDate() == scheduledDateTimeFormat.getDate() && new Date(arrayFDatesMade[i]).getMonth() == scheduledDateTimeFormat.getMonth() && new Date(arrayFDatesMade[i]).getFullYear() == scheduledDateTimeFormat.getFullYear()) {
                        arrayFDatesMade.splice(i, 1);
                    }
                } else if (vm.dataToFill.selectedServiceDetails.category == 1) {
                    if (new Date(arrayFDatesMade[i]).getDate() == dropDateTimeFormat.getDate() && new Date(arrayFDatesMade[i]).getMonth() == dropDateTimeFormat.getMonth() && new Date(arrayFDatesMade[i]).getFullYear() == dropDateTimeFormat.getFullYear()) {
                        arrayFDatesMade.splice(i, 1);
                    }
                }
            }
            //console.log('arrayDatesMade', arrayFDatesMade);
            vm.disableSubmitButton = true;
            vm.arrayFDatesMadeNew = arrayFDatesMade;
        }

        function CreateBookingNew(createBookingByPass, $event) {
            vm.disabledSubmitButton = false;
            vm.loading = true;
            $timeout(function () {
            if (createBookingByPass.$valid == false) {
                vm.disabledSubmitButton = true;
                vm.loading = false;
                return;
            }
            if(vm.fullCuota){
                vm.disabledSubmitButton = true;
                vm.loading = false;
                return;
            }
            if (!$stateParams.id) {
                var where = _.where(vm.dataToFill.contractList, {
                    id: Number(vm.dataToFill.contractIdSelected)
                });
                if (vm.dataToFill.customerProfile == '1' || vm.dataToFill.customerProfile == 1) {
                    if (vm.dataToFill.first_name) {
                        createEmployeeNew($event, vm.arrayFDatesMadeNew);
                    } else if (where.length == 0) {
                        createEmployeeNew($event, vm.arrayFDatesMadeNew);
                    } else {
                        if ((vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == '1') && vm.dataToFill.bookingFor == 0)
                            updateEmployeeProfile($event, vm.arrayFDatesMadeNew);
                        // if(!vm.method_range_pickup)
                        createBookingApi($event, vm.arrayFDatesMadeNew);
                    }
                } else if ((vm.dataToFill.first_name && (vm.dataToFill.customerProfile == '0' || vm.dataToFill.customerProfile == 0))) {
                    createCustomerNew($event, vm.arrayFDatesMadeNew);
                } else {
                    if ((vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == '1') && vm.dataToFill.bookingFor == 0)
                        updateEmployeeProfile($event, vm.arrayFDatesMadeNew);
                    // if(!vm.method_range_pickup)
                    createBookingApi($event, vm.arrayFDatesMadeNew);
                }
                // if(vm.method_range_pickup && Number(vm.dataToFill.reaccurringBooking) == 1 && !key){
                //     $timeout(function () {
                //         createBookingApi($event, vm.arrayFDatesMadeNew );
                //     }, 3000);
                // }else if(vm.method_range_pickup || key){
                //         createBookingApi($event, vm.arrayFDatesMadeNew );
                // }
            } else if ($stateParams.id) {
                console.log("puneet here else if ");
                if (vm.dataToFill.nearDriver) {
                    //checkBeforeAssignDriver($event,arrayFDatesMade);
                    if ((vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == '1') && vm.dataToFill.bookingFor == 0) {
                        console.log("puneet here if ");
                        updateEmployeeProfile($event, vm.arrayFDatesMadeNew);
                    } else {
                        console.log("puneet here else first");
                        editBookingApi($event, vm.arrayFDatesMadeNew);
                    }
                } else {
                    console.log("puneet else here ");
                    if ((vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == '1') && vm.dataToFill.bookingFor == 0) {
                        console.log("puneet here  if second");
                        updateEmployeeProfile($event, vm.arrayFDatesMadeNew);
                    } else {
                        console.log("puneet here else seconf");
                        editBookingApi($event, vm.arrayFDatesMadeNew);
                    }

                }
            }
            }, 3000);
        }

        //====================update employee details api=======================
        function updateEmployeeProfile($event, arrayFDatesMade) {
            console.log(arrayFDatesMade, ">>>>>>>>>>>>>>>>>>>>>>>>please come");
            vm.checkDataChanged = {
                rut: false,
                costCenter: false,
                costSbCenter: false,
                rol: false,
                graph: false,
                pep: false
            };
            if (vm.selectedEmployeeData != undefined) {
                vm.selectedEmployeeData.employee_details.RUT = vm.selectedEmployeeData.employee_details.RUT ? vm.selectedEmployeeData.employee_details.RUT : '';
                if (RutHelper.clean(vm.dataToFill.applicantRut) != vm.selectedEmployeeData.employee_details.RUT)
                    vm.checkDataChanged.rut = true;
                else vm.checkDataChanged.rut = false;
                if (vm.dataToFill.costCenter != vm.selectedEmployeeData.employee_details.cost_center)
                    vm.checkDataChanged.costCenter = true;
                else vm.checkDataChanged.costCenter = false;
                if (vm.dataToFill.costSubCenter != vm.selectedEmployeeData.employee_details.cost_subcenter)
                    vm.checkDataChanged.costSbCenter = true;
                else vm.checkDataChanged.costSbCenter = false;
                if (vm.dataToFill.Rol != vm.selectedEmployeeData.employee_details.ROI)
                    vm.checkDataChanged.rol = true;
                else vm.checkDataChanged.rol = false;
                if (vm.dataToFill.graph != vm.selectedEmployeeData.employee_details.graph)
                    vm.checkDataChanged.graph = true;
                else vm.checkDataChanged.graph = false;
                if (vm.dataToFill.pep != vm.selectedEmployeeData.employee_details.PEP)
                    vm.checkDataChanged.pep = true;
                else vm.checkDataChanged.pep = false;
                if (vm.modifyFalg == true)
                    editBookingApi($event, arrayFDatesMade)
                //console.log(vm.checkDataChanged);
                if (vm.checkDataChanged.rut || vm.checkDataChanged.costCenter || vm.checkDataChanged.costSbCenter || vm.checkDataChanged.rol || vm.checkDataChanged.graph || vm.checkDataChanged.pep) {
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.employee_id = vm.selectedEmployeeData.employee_details.id;
                    dataSend.RUT = RutHelper.clean(vm.dataToFill.applicantRut);
                    dataSend.cost_center = vm.dataToFill.costCenter;
                    dataSend.cost_subcenter = vm.dataToFill.costSubCenter;
                    dataSend.ROI = vm.dataToFill.Rol;
                    dataSend.graph = vm.dataToFill.graph;
                    dataSend.PEP = vm.dataToFill.pep;

                    var promise = getAgreement.updateEmployeeAdditionalFields(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log(payload);
                            if (payload.title.status == 400) {
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            } else if (payload.title.status == 401) {
                                errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                            } else if (payload.title.status == 201 || payload.title.status == 200) {
                                // editBookingApi($event, arrayFDatesMade);
                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.disableSubmitButton = false;
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }
            } else {
                createEmployeeNew($event, arrayFDatesMade);
                vm.flagForEditBooking = true;
                return false;
            }


        }


        // //=======================Validate Edit booking api==========================
        // function ValidateEditBookingApi($event, arrayFDatesMade) {
        //     // TV-1345  CCOMMENT BY NAKUL
        //     // if(vm.dataToFill.bookingType == '0' && !vm.dataToFill.is_wait_time_included && vm.dataToFill.roundTrip){
        //     //     errorMessageFactory.showErrorMessage('No se permite crear reservas ida y vuelta sin tiempo de espera', 0);
        //     //     return false;
        //     // }
        //     // $log.log(dataSend);
        //     vm.loading = true;
        //     var dataSend = {};
        //     dataSend.time = [];
        //     dataSend.access_token = $cookies.get('obj');
        //     dataSend.customer_email = vm.dataToFill.customerEmail;
        //     if (vm.dataToFill.selectedServiceDetails.category == 1 && vm.pickRange1 && vm.pickRange2 && vm.dataToFill.airportCheck != 'Z') {
        //         dataSend.is_shared_service = 1;
        //     } else {
        //         dataSend.is_shared_service = 0;
        //     }
        //     if (vm.dataToFill.selectedServiceDetails.category == 1) {
        //         dataSend.booking_eta = vm.dataToFill.etaScheduleValue + vm.dataToFill.time_trip_shared_service;
        //     } else {
        //         dataSend.booking_eta = vm.dataToFill.etaSchedule;
        //     }
        //     dataSend.type_of_trip = vm.type_of_trip_Validate_Booking;
        //     dataSend.timezone = new Date().getTimezoneOffset();
        //     dataSend.modify_booking = 1;
        //     dataSend.job_id = vm.dataToFill.bookingId;
        //     dataSend.booking_for = Number(vm.dataToFill.bookingFor);
        //     if (vm.dataToFill.bookingFor == 1) {
        //         dataSend.full_name = vm.dataToFill.personName;
        //         dataSend.phone_number = vm.dataToFill.personMobile;
        //         dataSend.email = vm.dataToFill.personEmail;
        //     }
        //     if (vm.dataToFill.bookingType == '1' && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2)) {
        //         dataSend.schedule_ride = 1;
        //         dataSend.time.push(dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime).toISOString());
        //     } else if (vm.dataToFill.bookingType == '1' && vm.dataToFill.selectedServiceDetails.category == 1) {
        //         dataSend.schedule_ride = 1;
        //         dataSend.time.push(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString());
        //     } else if (vm.dataToFill.bookingType == '0' && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2)) {
        //         dataSend.schedule_ride = 0;
        //     } else if (vm.dataToFill.bookingType == '0' && vm.dataToFill.selectedServiceDetails.category == 1) {
        //         dataSend.schedule_ride = 0;
        //         dataSend.time.push(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString());
        //     }
        //     dataSend.reaccurring = Number(vm.dataToFill.reaccurringBooking);
        //     if (vm.dataToFill.reaccurringBooking == '1') {
        //         for (var i = 0; i < arrayFDatesMade.length; i++) {
        //             dataSend.time.push(arrayFDatesMade[i]);
        //         }
        //     }
        //     dataSend.round_trip = Number(vm.dataToFill.roundTrip);
        //     if (vm.dataToFill.roundTrip && !vm.dataToFill.is_wait_time_included) {
        //         dataSend.return_date_time = dateTimeFormat(vm.dataToFill.returnDate, vm.dataToFill.returnTime).toISOString();
        //     }
        //     dataSend.is_wait_time_included = vm.dataToFill.is_wait_time_included ? 1 : 0;
        //     var promise = getBookingsHereMaps.ValidateCreateBooking(dataSend);
        //     promise.then(
        //         function (payload) {
        //             $log.log(payload);
        //             vm.loading = false;
        //             if (payload.title.status == 200) {
        //                 if (payload.title.data.flag == true) {
        //                     // var confirm = $mdDialog.confirm()
        //                     //     .textContent(payload.title.message)
        //                     //         .ariaLabel('Lucky day')
        //                     //         .targetEvent($event)
        //                     //         .ok('Confirmar')
        //                     //         .cancel('Cancelar'); 
        //                     //         $mdDialog.show(confirm).then(function () {
        //                     //             editBookingApi($event, arrayFDatesMade);
        //                     //         }, function () {
        //                     //             vm.disableSubmitButton = true;
        //                     //             $log.log('not confirmed');
        //                     //         });
        //                     bookingValidateCreationSuccess(payload, 'NoAuth', $event);
        //                 } else {
        //                     editBookingApi($event, arrayFDatesMade);
        //                 }
        //             }
        //         },
        //         function (errorPayload) {
        //             $log.log(errorPayload);
        //             vm.loading = false;
        //             // vm.disableSubmitButton = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // };




        //=======================Validate Edit booking api==========================

        //=======================create booking api==========================
        function createBookingApi($event, arrayFDatesMade) {
            if(vm.routingBase && vm.routingBase.routing_base_id > 0) {
                vm.dataToFill.selectedServiceDetails.category = 0;
                vm.method_range_pickup = 0;
            }
            if (vm.bookingError == true) {
                errorMessageFactory.showErrorMessage('Error al calcular el Retiro. Error en la llamada a la API', 0);
                return;
            }
            if (vm.errorFlagForDate == true || (vm.dataToFill.passengerCount == 0 || vm.dataToFill.passengerCount == null || vm.dataToFill.passengerCount == undefined) || vm.ErrorFlagForNewApi) {
                return;
            }
            vm.currentTime = new Date();
            vm.claenderTime = moment(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime)).subtract(vm.etaSeconds, 'seconds');
            vm.timeFlight = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            vm.currentTimeFlight = new Date(dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value));
            vm.checkFlag = moment(vm.timeFlight).isAfter(vm.claenderTime);
            vm.currentBookingSchudule = dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime);
            vm.currentCheckFlag = moment(vm.currentTimeFlight).isAfter(vm.currentTime);
            vm.checkFlagCurrentBookingSchudule = moment(vm.currentTimeFlight).isAfter(vm.currentBookingSchudule);
            // Tv-2176
            // if (vm.type_of_trip1 == 'R' && vm.checkFlag == false && vm.flagForFlightDate == true && vm.type_of_trip1 != 'P') {
            //     // languageBasedErrorFactory.getProperErrorMessage('greaterCheck', 0, 0)
            //     vm.disableSubmitButton = false;
            //     return false;
            // }
            // if (vm.currentCheckFlag == false && vm.flagForFlightDate == true && vm.type_of_trip1 != 'P') {
            //     // languageBasedErrorFactory.getProperErrorMessage('greaterCheck', 0, 0)
            //     vm.disableSubmitButton = false;
            //     return false;
            // }
            // if (vm.checkFlagCurrentBookingSchudule == false && vm.flagForFlightDate == true && vm.type_of_trip1 != 'P') {
            //     languageBasedErrorFactory.getProperErrorMessage('greaterCheck', 0, 0)
            //     vm.disableSubmitButton = false;
            //     return false;
            // }
            if (((Number(vm.dataToFill.estimatedFare)) < (Number(vm.viaControlled1))) || (Number(vm.dataToFill.estimatedFare)) < (Number(vm.viaControlled2))) {
                errorMessageFactory.showErrorMessage('Reserva no puede ser creada debido a que Via controlada es mayor que valor del tramo', 0);
                return false;
            }
            vm.disabledSubmitButton = false;
            $log.log(vm.dataToFill);
            $log.log(vm.daysList);
            vm.loading = true;
            var dataSend = {};
            dataSend.time = [];
            var tz = moment.tz.guess();
            // dataSend.time_pickup_array  = [];/
            dataSend.reaccurringTimeZone = [];
            dataSend.access_token = $cookies.get('obj');
            dataSend.customer_email = vm.dataToFill.customerEmail;
            dataSend.customer_phone_number = vm.dataToFill.customerMobileG;
            dataSend.profile = Number(vm.dataToFill.customerProfile);
            dataSend.number_of_passangers = Number(vm.dataToFill.passengerCount);
            dataSend.timezone = new Date().getTimezoneOffset();
            dataSend.booking_for = Number(vm.dataToFill.bookingFor);
            ///////////////////////////TV-1795 //////////////////////////
            // if (vm.dataToFill.controllerWayTarifa == 1) {
            //     vm.viaControlled1 = 0;
            //     vm.viaControlled2 = 0;
            // }
            if (vm.dataToFill.bookingFor == 1) {
                dataSend.full_name = vm.dataToFill.personName;
                dataSend.phone_number = vm.dataToFill.personMobile;
                dataSend.email = vm.dataToFill.personEmail;
                if (vm.dataToFill.passengerId != null)
                    dataSend.passenger_id = vm.dataToFill.passengerId;
            }
            // vm.dataToFill.pickUpAddress
            dataSend.pickup_location = vm.dataToFill.pickUpAddress;
            dataSend.job_pickup_comuna = vm.jobPickupComuna || null; // Send CITY of PICKUP ADDRESS
            dataSend.drop_location = vm.dataToFill.dropOffAddress;
            dataSend.job_dropoff_comuna = vm.jobDropoffComuna || null; // Send CITY of DROPOFF ADDRESS
            dataSend.pickup_lat = vm.dataToFill.pickUpLat;
            dataSend.pickup_long = vm.dataToFill.pickUpLng;
            dataSend.drop_lat = vm.dataToFill.dropOffLat;
            dataSend.drop_long = vm.dataToFill.dropOffLng;
            if (vm.airlineMandatory == 1 && vm.type_of_trip1 != 'P') {
                dataSend.airline = vm.dataToFill.airline;
            }
            if (vm.flightNumberMandatory == 1 && vm.type_of_trip1 != 'P') {
                dataSend.flight_number = vm.dataToFill.flightNumber;
            }
            if (vm.flightDateMandatory == 1 && vm.type_of_trip1 != 'P') {
                dataSend.flight_date = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            }
            if (vm.flightTypeMandatory == 1 && vm.type_of_trip1 != 'P') {
                if (vm.international && vm.flightFLag) {
                    dataSend.flight_type = vm.international;
                } else {
                    dataSend.flight_type = vm.national;
                }

            }
            if ((vm.type_of_trip1 == 'R' && vm.dataToFill.selectedServiceDetails.category == 1 && vm.method_range_pickup) || (vm.routingBase && vm.routingBase.routing_base_id > 0)) {
                dataSend.is_routing = 1;
                dataSend.time_pickup_array = (vm.pickRangeSendForRouting);
                dataSend.reaccurringTimeZone = vm.timeZoneRecurring;
                dataSend.tolerance_after_route_array = vm.pickup_top_range; // after
                dataSend.tolerance_before_route_array = vm.pickup_lower_range; // before 
                dataSend.travel_distance_route = vm.distanceRoutingApi;
            }
            if (vm.type_of_trip == 'R' && vm.dataToFill.selectedServiceDetails.category == 1 && vm.method_range_pickup_return && vm.dataToFill.roundTrip == 1) {
                dataSend.is_routing = 1;
                dataSend.time_pickup_return_route = (vm.pickRangeSendForRoutingReturn);
                dataSend.returnTimeZone = vm.timeZoneRRoundReturn;
                dataSend.tolerance_before_route_return = vm.pickup_lower_range_return;
                dataSend.tolerance_after_route_return = vm.pickup_top_range_return;
                dataSend.travel_distance_route_return = vm.distanceRoutingApiReturn;
            }
            if (vm.checkBoxCheck) {
                dataSend.sin_respaldo = vm.checkBoxValueIs ? 1 : 0;
            }
            if (vm.dataToFill.selectedServiceDetails.category == 1 && !vm.method_range_pickup) {
                dataSend.booking_eta = vm.dataToFill.etaScheduleValue + vm.dataToFill.time_trip_shared_service;
            } else {
                dataSend.booking_eta = vm.dataToFill.etaSchedule;
            }
            if (vm.bookingEta && Number(vm.dataToFill.reaccurringBooking) == 1 && !vm.modifyFalg) {
                dataSend.booking_eta_array = vm.etaArray;
            }
            if (vm.dataToFill.selectedServiceDetails.category == 1 && !vm.method_range_pickup_return) {
                dataSend.return_booking_eta = vm.dataToFill.etaScheduleValueReturn + vm.dataToFill.time_trip_shared_service;
            } else {
                dataSend.return_booking_eta = vm.dataToFill.etaScheduleValueReturn;
            }
            dataSend.transport_type_id = Number(vm.dataToFill.carType);
            if ((vm.dataToFill.bookingType == '1' && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2)) && !vm.routingBase) {
                dataSend.schedule_ride = 1;
                dataSend.timezone = moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime).toISOString()));
                dataSend.reaccurringTimeZone.push(moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime).toISOString())));
                // dataSend.timezone = new Date(dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime).toISOString()).getTimezoneOffset();
                dataSend.time.push(dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime).toISOString());

            } else if ((vm.dataToFill.bookingType == '1' && ((vm.dataToFill.selectedServiceDetails.category == 1) || (vm.routingBase && vm.routingBase.routing_base_id > 0)))) {
                dataSend.schedule_ride = 1;
                dataSend.timezone = moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString()));
                dataSend.reaccurringTimeZone.push(moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString())));
                // dataSend.timezone = new Date(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString()).getTimezoneOffset();
                dataSend.time.push(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString());
            } else if (vm.dataToFill.bookingType == '0' && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2) && vm.type_of_trip_Validate_Booking != 'R') {
                dataSend.schedule_ride = 0;
            } else if (vm.dataToFill.bookingType == '0' && vm.dataToFill.selectedServiceDetails.category == 1) {
                dataSend.schedule_ride = 0;
                dataSend.timezone = moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString()));
                dataSend.reaccurringTimeZone.push(moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString())));
                // dataSend.timezone = new Date(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString()).getTimezoneOffset();
                dataSend.time.push(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString());
            }
            // else if (vm.dataToFill.bookingType == '1' && vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking == 'R') {
            //     dataSend.schedule_ride = 1;
            //     dataSend.timezone = new Date(dateTimeFormat(vm.dataToFill.dropDateOfRType, vm.dataToFill.dropTimeOfRtype).toISOString()).getTimezoneOffset();
            //     dataSend.time.push(dateTimeFormat(vm.dataToFill.dropDateOfRType, vm.dataToFill.dropTimeOfRtype).toISOString());
            // }
            else if (vm.dataToFill.bookingType == '0' && vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking == 'R') {
                dataSend.schedule_ride = 0;
            }
            dataSend.round_trip = Number(vm.dataToFill.roundTrip);
            if (vm.dataToFill.roundTrip) {
                if (((!vm.dataToFill.is_wait_time_included && vm.dataToFill.selectedServiceDetails.category != 1) || (vm.dataToFill.roundTrip && vm.dataToFill.selectedServiceDetails.category == 1 && vm.type_of_trip != 'R')) &&
                    ((!vm.dataToFill.is_wait_time_included && vm.type_of_trip != 'R') || vm.dataToFill.selectedServiceDetails.category != 0 && vm.type_of_trip != 'R')) {
                    dataSend.returnTimeZone = moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.returnDate, vm.dataToFill.returnTime).toISOString()));
                    dataSend.return_date_time = dateTimeFormat(vm.dataToFill.returnDate, vm.dataToFill.returnTime).toISOString();
                } else if ((!vm.dataToFill.is_wait_time_included && vm.dataToFill.selectedServiceDetails.category == 1) || (vm.dataToFill.roundTrip && vm.dataToFill.selectedServiceDetails.category == 1 && vm.type_of_trip != 'R') ||
                    (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip == 'R')) {
                    dataSend.returnTimeZone = moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.dropDateReturn, vm.dataToFill.dropTimeReturn).toISOString()));
                    dataSend.return_date_time = dateTimeFormat(vm.dataToFill.dropDateReturn, vm.dataToFill.dropTimeReturn).toISOString();
                }
                if (vm.estimated_toll_price_return !== undefined) {
                    dataSend.estimated_toll_price_return = vm.estimated_toll_price_return;
                }
                // if (vm.heremaps_toll_details_return && vm.dataToFill.route_type === 0) {
                if (vm.heremaps_toll_details_return && vm.searchFixedVariablePayload.title.data.apply_charge_by_toll) {
                    dataSend.heremaps_toll_details_return = JSON.stringify(vm.heremaps_toll_details_return.heremaps_response['detail-cost']);
                    dataSend.heremaps_estimated_tolls_return = vm.tollCountReturn;
                    dataSend.item_of_charge_tolls_price_return = vm.toll_price_return || 0;
                }
                if (vm.ReturnEstimatedDistanceToSend && vm.dataToFill.route_type === 0) {
                    dataSend.est_distance_return = vm.ReturnEstimatedDistanceToSend;
                }
            }
            if(vm.heremaps_toll_details && vm.toll_id) {
                dataSend.heremaps_toll_details = JSON.stringify(vm.heremaps_toll_details.heremaps_response['detail-cost']);
                dataSend.heremaps_estimated_tolls = vm.tollCount;
                dataSend.item_of_charge_tolls_price = vm.toll_price || 0;
            }
            dataSend.reaccurring = Number(vm.dataToFill.reaccurringBooking);
            if (vm.dataToFill.reaccurringBooking == '1') {
                if (arrayFDatesMade.length != 0) {
                    for (var i = 0; i < arrayFDatesMade.length; i++) {
                        dataSend.time.push(arrayFDatesMade[i]);
                        dataSend.reaccurringTimeZone.push(moment.tz.zone(tz).utcOffset(moment(arrayFDatesMade[i])));
                    }
                } else {
                    dataSend.reaccurringTimeZone.push(moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.dropDateReturn, vm.dataToFill.dropTimeReturn).toISOString())));
                }
            } else {
                dataSend.reaccurringTimeZone = []; // TV-3659 change in parent booking timezone is not consider by backend in case of recurring 
            }
            if (vm.dataToFill.reference_point) {
                dataSend.reference_point = vm.dataToFill.reference_point;
            }
            if (vm.dataToFill.corporate_account_id && (vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == '1')) {
                dataSend.corporate_account_id = vm.dataToFill.corporate_account_id;
            }
            dataSend.route_id = vm.dataToFill.route_id;
            dataSend.route_type = vm.dataToFill.route_type;
            dataSend.type_of_agreement = vm.dataToFill.type_of_agreement;
            if (vm.dataToFill.type_of_agreement == 1) // THIRD PERSON BOOKING IS VIP OR NOT IN CORPORATE AGGREMENT
                dataSend.isVIP_someone = vm.is_vip ? 1 : 0;
            dataSend.is_wait_time_included = vm.dataToFill.is_wait_time_included ? 1 : 0;
            dataSend.contract_id = vm.dataToFill.contractIdSelected;
            dataSend.service_type = Number(vm.dataToFill.serviceTypeSelected);

            if (vm.dataToFill.authRequired == '1' && (vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == '1')) {
                dataSend.auth_required = Number(vm.dataToFill.authRequired);
                dataSend.auth_of = RutHelper.clean(vm.dataToFill.authRUT);
            } else {
                dataSend.auth_required = 0;
            }
            var isAirportFlag = 0;
            if (vm.fromAirportFlag) {
                isAirportFlag = 1;
            } else if (vm.toAirportFlag) {
                isAirportFlag = 2;
            }
            dataSend.airport = Number(isAirportFlag);
            if (vm.dataToFill.itemOfChargeSelected.length) {
                vm.dataToFill.item_of_charges = [];
                vm.dataToFill.is_item_of_charges = 1;
                for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                    vm.dataToFill.item_of_charges.push({
                        "fixed_pricing_id": vm.dataToFill.itemOfChargeSelected[i].fixed_pricing_id ? vm.dataToFill.itemOfChargeSelected[i].fixed_pricing_id : vm.dataToFill.itemOfChargeSelected[i].variable_pricing_id,
                        "id": vm.dataToFill.itemOfChargeSelected[i].tic_id,
                        "item_of_charge_id": vm.dataToFill.itemOfChargeSelected[i].id,
                        "description": vm.dataToFill.itemOfChargeSelected[i].tic_description,
                        "long_name": vm.dataToFill.itemOfChargeSelected[i].tic_long_name,
                        "manually": vm.dataToFill.itemOfChargeSelected[i].tic_manually,
                        "price": vm.dataToFill.itemOfChargeSelected[i].price,
                        "short_name": vm.dataToFill.itemOfChargeSelected[i].tic_short_name,
                        "quantity": vm.dataToFill.itemOfChargeSelected[i].quantity,
                        "retorno": vm.dataToFill.itemOfChargeSelected[i].retorno
                    })
                }
                dataSend.is_item_of_charges = Number(vm.dataToFill.is_item_of_charges);
                var items_ida = vm.dataToFill.item_of_charges.filter(function(itm){ return itm.retorno == false });
                var items_vuelta = vm.dataToFill.item_of_charges.filter(function(itm){ return itm.retorno == true });
                dataSend.item_of_charges = items_ida;
                dataSend.item_of_charges_return = items_vuelta;
            } else {
                dataSend.is_item_of_charges = 0;
            }
            if (vm.dataToFill.nearDriver)
                dataSend.favourite_driver_id = Number(vm.dataToFill.nearDriver);

            dataSend.payment_method = vm.dataToFill.payment_method;
            //console.log(vm.dataToFill.pepCheck, 'pepCheck');
            if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking == 'P') {
                dataSend.pickup_tolerance_time_pap = vm.time_trip_shared_service_point_to_point;
                dataSend.pickup_travel_time_pap = vm.pickup_travel_time_pap;
            }
            if ((vm.dataToFill.selectedServiceDetails.category == 0) && (vm.type_of_trip_Validate_Booking == 'R' || (vm.dataToFill.roundTrip && vm.type_of_trip == 'R'))){
                dataSend.travel_time = vm.travel_time_service_pick_up; 
                dataSend.tolerance_time = vm.tolerance_time_withdrawal_pickup; 
            } 
            if (vm.dataToFill.passengerRutCheck == 1)
                dataSend.passenger_rut = RutHelper.clean(vm.dataToFill.passengerRut);
            if (vm.dataToFill.applicantRutCheck == 1)
                dataSend.applicant_rut = RutHelper.clean(vm.dataToFill.applicantRut);
            if (vm.dataToFill.costCenterCheck == 1)
                dataSend.cost_center = vm.dataToFill.costCenter;
            if (vm.dataToFill.costSubCenterCheck == 1)
                dataSend.sub_cost_center = vm.dataToFill.costSubCenter;
            if (vm.dataToFill.RolCheck == 1)
                dataSend.rol = vm.dataToFill.Rol;
            if (vm.dataToFill.graphCheck == 1)
                dataSend.graph = vm.dataToFill.graph;
            if (vm.dataToFill.workOrderCheck == 1)
                dataSend.work_order = vm.dataToFill.workOrder;
            if (vm.dataToFill.pepCheck == 1)
                dataSend.PEP = vm.dataToFill.pep;
            if (vm.dataToFill.purposeOfTripCheck == 1)
                dataSend.purpose_of_trip = vm.dataToFill.purposeOfTrip;
            if (vm.dataToFill.noOfVoucherCheck == 1)
                dataSend.number_of_voucher = vm.dataToFill.noOfVoucher;
            if (vm.dataToFill.nominaCheck == 1)
                dataSend.nomina = vm.dataToFill.nomina;
            if (vm.dataToFill.solictudCheck == 1)
                dataSend.solicitud = vm.dataToFill.solictud;

            dataSend.observations = vm.dataToFill.observations;
            if (vm.viaControlledFLag1 == true && vm.type_of_trip1 == 'Z') {
                if (vm.dataToFill.controllerWayTarifa == 1) {
                    // if (vm.dataToFill.selectedServiceDetails.fare_type == 1) {
                    //     dataSend.via_controlled_price = Number(vm.viaControlled1) + (vm.viaControlled1 * (vm.dataToFill.passengerCount - 1));
                    //     vm.addViaControlled = 0;
                    // } else {
                    dataSend.via_controlled_price = Number(vm.viaControlled1);
                    vm.addViaControlled = 0;
                    // }
                } else {
                    // if (vm.dataToFill.selectedServiceDetails.fare_type == 1) {
                    //     dataSend.via_controlled_price = Number(vm.viaControlled1) + (vm.viaControlled1 * (vm.dataToFill.passengerCount - 1));
                    //     vm.addViaControlled = 0;
                    // } else {
                    dataSend.via_controlled_price = Number(vm.viaControlled1);
                    vm.addViaControlled = 0;
                    // }
                }
            } else {
                vm.addViaControlled = 0;
            }
            if (vm.viaControlledFLag == true && vm.dataToFill.roundTrip == true) {
                if (vm.dataToFill.controllerWayTarifa == 1) {
                    // if (vm.dataToFill.selectedServiceDetails.fare_type == 1) {
                    //     dataSend.via_controlled_price = Number(vm.viaControlled2) + (vm.viaControlled2 * (vm.dataToFill.passengerCount - 1));
                    //     vm.addViaControlledRound = 0;
                    // } else {
                    dataSend.via_controlled_price_return = Number(vm.viaControlled2);
                    vm.addViaControlledRound = 0;
                    // }
                } else {
                    // if (vm.dataToFill.selectedServiceDetails.fare_type == 1) {
                    //     dataSend.via_controlled_price = Number(vm.viaControlled2) + (vm.viaControlled2 * (vm.dataToFill.passengerCount - 1));
                    //     vm.addViaControlledRound = 0;
                    // } else {
                    dataSend.via_controlled_price_return = Number(vm.viaControlled2);
                    vm.addViaControlledRound = 0;
                    // }
                }
            } else {
                vm.addViaControlledRound = 0;
            }
            if (vm.dataToFill.controllerWayTarifa == 1) {
                vm.viaControlled1 = 0;
                vm.viaControlled2 = 0;
            }
            if (vm.dataToFill.discounts.length) {
                if (vm.dataToFill.controllerWayTarifa == 1) {
                    console.log('>>>>>>>> vm.addViaControlled >>>>>>>>>', vm.addViaControlled);
                    dataSend.estimated_payment_cost = Math.round(vm.dataToFill.discounts[0].finalAmount + vm.addViaControlled);
                } else {
                    dataSend.estimated_payment_cost = Math.round(vm.dataToFill.discounts[0].finalAmount);
                }
            } else {
                dataSend.estimated_payment_cost = Math.round(vm.dataToFill.estimatedFare + Number(vm.viaControlled1));
                // dataSend.estimated_payment_cost_return = vm.dataToFill.Return_policy.estimatedFare +  Number(vm.dataToFill.viaControlled);
            }
            if (vm.return_flag == true) {
                if (vm.dataToFill.discounts.length) {
                    dataSend.route_id_return = vm.dataToFill.Return_policy.route_id;
                    dataSend.route_type_return = vm.dataToFill.Return_policy.route_type;
                    if (vm.dataToFill.controllerWayTarifa == 1) {
                        console.log('>>>>>>>> vm.addViaControlledRound >>>>>>>>>', vm.addViaControlledRound);
                        dataSend.estimated_payment_cost_return = Math.round(vm.dataToFill.discounts[0].roundFinalAmount + vm.addViaControlledRound);
                    } else {
                        dataSend.estimated_payment_cost_return = Math.round(vm.dataToFill.discounts[0].roundFinalAmount);
                    }
                } else {
                    dataSend.route_id_return = vm.dataToFill.Return_policy.route_id;
                    dataSend.route_type_return = vm.dataToFill.Return_policy.route_type;
                    dataSend.estimated_payment_cost_return = Math.round(vm.dataToFill.Return_policy.estimatedFare + Number(vm.viaControlled2));
                }
            }

            if(vm.estimated_toll_price !== undefined) {
                dataSend.estimated_toll_price = vm.estimated_toll_price;
            }



            if (vm.dataToFill.selectedServiceDetails.category == 0) { //exclusive
                dataSend.booking_type = 0; //Normal
            } else if (vm.dataToFill.selectedServiceDetails.category == 1) { //shared
                dataSend.booking_type = 1; //shared
            }
            //else if(vm.dataToFill.selectedServiceDetails.category == 2){ //Normal
            //    dataSend.booking_type = 0; //Normal
            //}
            dataSend.is_POS_booking = 0;
            dataSend.payment_status = 0;
            dataSend.created_by_admin = 1;
            dataSend.is_adjusted_discounted_amount = 0;

            if (vm.dataToFill.discounts.length) {
                if (vm.dataToFill.discounts[0].name == 'ROUND TRIP') {
                    dataSend.promo_type = 1;
                } else {
                    dataSend.promo_type = 0;
                    dataSend.promo_id = vm.dataToFill.discounts[0].name;

                }
                if (vm.dataToFill.discounts[0].promoType === 'adjustedPrice') {
                    dataSend.promo_type = 0;
                    dataSend.is_adjusted_discounted_amount = 1;
                }
                dataSend.discount_type = Number(vm.dataToFill.discounts[0].discountType);
                dataSend.discount_amount = ((dataSend.is_adjusted_discounted_amount == 1) && (dataSend.is_wait_time_included == 0) && (dataSend.round_trip == 1)) ? Number(vm.dataToFill.discounts[0].discountTypeValue / 2) : Number(vm.dataToFill.discounts[0].discountTypeValue);
                dataSend.discount_code = vm.dataToFill.couponCode;
                dataSend.final_discount_amount = vm.dataToFill.discounts[0].value;
                dataSend.final_discount_amount_return = vm.dataToFill.discounts[0].returnValue;
            }
            dataSend.apply_charge_by_toll = vm.searchFixedVariablePayload.title.data.apply_charge_by_toll;
            dataSend.collect_estimated_tag = vm.searchFixedVariablePayload.title.data.collect_estimated_tag;
            if(vm.dataToFill.route_type === 0) {
                dataSend.apply_estimated_distance_variable_fare = vm.searchFixedVariablePayload.title.data.apply_estimated_distance_variable_fare;
            }
            if ((JSON.parse($cookies.get('adminType') || 0) == 1) && vm.isEmpDataChange)
                dataSend.is_emp_data = vm.isEmpDataChange; // TV-2378
            
            if(vm.routingBase && vm.routingBase.depot_id)
                dataSend.depot_id = vm.routingBase.depot_id;

            dataSend.factor_value = vm.dataToFill.factor_value;
            dataSend.factor_type = vm.dataToFill.factor_tipo;
            dataSend.factor_id = vm.dataToFill.factor_id;
            if(vm.dataToFill.roundTrip){
                dataSend.factor_return_value = vm.dataToFill.factor_return_value;
                dataSend.factor_return_type = vm.dataToFill.factor_return_tipo;
                dataSend.factor_return_id = vm.dataToFill.factor_return_id;
            }


            $log.log(dataSend);
            console.log(dataSend, "datasend");
            var promise = getBookingsHereMaps.createBooking(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    //console.log(payload, "payload = =======");
                    vm.loading = false;
                    if (payload.title.data.flag == 'pending_payment') {
                        vm.disableSubmitButton = false;
                        openPopPendingPayment(payload.title, $event);
                    } else {

                        if (vm.dataToFill.authRequired == '1' || vm.dataToFill.authRequired == 1) {
                            // bookingValidateCreationSuccess(payload, 'Auth', $event);
                            if (payload.title.status == 400 && payload.title.data.key == true) {
                                vm.disabledSubmitButton = true;
                                bookingValidateCreationSuccess(payload.title, 'NoAuth', $event);
                            } else {
                                if (payload.title.status == 400) {
                                    vm.disabledSubmitButton = true;
                                    errorMessageFactory.showErrorMessage(payload.title.message, 0);
                                } else if (payload.title.status == 201) {
                                    vm.disabledSubmitButton = true;
                                    errorMessageFactory.showErrorMessage(payload.title.message, 0);
                                } else {
                                    vm.disabledSubmitButton = true;
                                    bookingCreationSuccess(payload, 'Auth', $event);
                                }
                            }
                            //languageBasedErrorFactory.getProperErrorMessage('bookingSuccA',0,1)
                            //errorMessageFactory.sowErrorMessage('Booking created successfully.But the Reserve will remain pending until Authorized.',1);
                        } else {
                            if (payload.title.status == 400 && payload.title.data.key == true) {
                                vm.isEmpDataChange = false; // TV-2378
                                vm.disabledSubmitButton = true;
                                bookingValidateCreationSuccess(payload.title, 'NoAuth', $event);
                            } else {
                                if (payload.title.status == 400) {
                                    vm.disabledSubmitButton = true;
                                    errorMessageFactory.showErrorMessage(payload.title.message, 0);
                                } else if (payload.title.status == 201) {
                                    vm.disabledSubmitButton = true;
                                    errorMessageFactory.showErrorMessage(payload.title.message, 0);
                                } else {
                                    vm.disabledSubmitButton = true;
                                    vm.isEmpDataChange = false; // TV-2378
                                    bookingCreationSuccess(payload, 'NoAuth', $event);
                                }
                            }

                            //languageBasedErrorFactory.getProperErrorMessage('bookingSucc',0,1)
                            //errorMessageFactory.showErrorMessage('Booking created successfully.',1);
                        }
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    vm.disableSubmitButton = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        //=================open pop for pending payment=====================
        function openPopPendingPayment(data, $event) {
            vm.items = {};
            vm.items.data = data;

            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/openPopForPendingPayment.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                escapeToClose: false,
                controller: PendingPaymentController
            });

            function PendingPaymentController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };

                $scope.gotToPreviousBooking = function (items) {
                    $mdDialog.hide();
                    $state.go('layout.completedBookingsMain.completedBookingDetailsNew', {
                        id: items.data.data.job_id,
                        type: '2'
                    });
                }
            }
        }


        //=======================open pop up after booking creation============================
        function bookingValidateCreationSuccess(data, text, $event) {
            vm.items = {};
            vm.items.authPending = text == 'Auth' ? true : false;
            vm.items.tableData = data.data.jobs;
            vm.items.Template = data.data.pdf_data_resp;
            //console.log(vm.items.tableData, 'vm.items.tableData', data);

            vm.items.copied = false;
            vm.items.loading = false;
            // if (data.data.jobs.key == 0) {
            //     vm.items.singleBooking = true;
            // } else {
            //     vm.items.singleBooking = false;
            // }
            // if (data.data.jobs.key == 0 || data.data.jobs.key == 2) {
            //     vm.items.roundTrip = false;
            // } else {
            //     vm.items.roundTrip = true;
            // }

            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/validateBooking.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                escapeToClose: false,
                controller: CreateBookingSuccessController
            });


            function CreateBookingSuccessController($scope, $mdDialog, items, tmhDynamicLocale) {
                $scope.items = items;
                tmhDynamicLocale.set('es');
                var win = '';
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                    if (win) {
                        win.close();
                    }
                    // $timeout(function () {
                    $state.reload('layout.createBookingHereMapsMain.createBookingHereMaps');
                    // }, 0);x

                };
                $scope.cancelValidatePopUp = function () {
                    $mdDialog.hide();
                }


                $scope.openPdf = function (data) {
                    //console.log(data);
                    $log.log(data);
                    $scope.items.loading = true;
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.job_id = Number(data.job_id);
                    var promise = getBookingsHereMaps.makeCreateBookingPdfHeight(dataSend);
                    promise.then(function (payload) {
                            $log.log('sxdsads', payload);
                            document.getElementById('showPrint').innerHTML = payload.title.data.pdf_html;
                            vm.OpenLink = payload.title.data.pdf_html;
                            // //console.log("Puneet changes in html");
                            win = window.open('', "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=" + (screen.width) + ",height=" + (screen.height) + ",top=0,left=0");
                            $scope.items.loading = false;
                            $timeout(function () {
                                win.document.body.innerHTML = payload.title.data.pdf_html;
                                // $scope.getVoucherLink(data, payload.title.data);
                            }, 1000);
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            $scope.items.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }

                $scope.getVoucherLink = function (data, pdfData) {
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.job_id = Number(data.job_id);
                    //dataSend.pdf_html = pdfData.pdf_html;
                    dataSend.height = $('#showPrint').height() + 200;
                    $scope.items.loading = true;
                    var promise = getBookingsHereMaps.makeCreateBookingPdf(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            $scope.items.loading = false;
                            if (win) {
                                win.close();
                            }
                            win = window.open(payload.title.data.pdfLink, "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=" + (screen.width) + ",height=" + (screen.height) + ",top=0,left=0");
                            win.document.body.innerHTML = '<iframe src="' + payload.title.data.pdfLink + '" height=' + screen.height + ' width=' + screen.width + '></ifrmae>';
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            $scope.items.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }

            }
        }




        //=======================open pop up after booking creation============================
        function bookingCreationSuccess(data, text, $event) {
            vm.items = {};
            vm.items.authPending = text == 'Auth' ? true : false;
            //console.log(data, "jshjkhkajhdsjkadhkdhaskjdhaskjdhkjasdhj");

            vm.items.tableData = data.title.jobs.data;
            vm.items.Template = data.title.pdf_data_resp;
            vm.items.copied = false;
            vm.items.loading = false;
            if (data.title.jobs.key == 0) {
                vm.items.singleBooking = true;
            } else {
                vm.items.singleBooking = false;
            }
            if (data.title.jobs.key == 0 || data.title.jobs.key == 2) {
                vm.items.roundTrip = false;
            } else {
                vm.items.roundTrip = true;
            }

            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/createBookingSuccess.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                escapeToClose: false,
                controller: CreateBookingSuccessController
            });

            function CreateBookingSuccessController($scope, $mdDialog, items, tmhDynamicLocale) {
                $scope.items = items;
                tmhDynamicLocale.set('es');
                var win = '';
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                    if (win) {
                        win.close();
                    }
                    // $timeout(function () {
                    $state.reload('layout.createBookingHereMapsMain.createBookingHereMaps');
                    // }, 0);

                };
                $scope.getIndex = function (index) {
                    $scope.copyTemplate(vm.items.Template[index]);

                }
                $scope.copyTemplate = function (data) {
                    vm.templateString = '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 ' +
                        '                Transitional//EN" ' +
                        '                "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">' +
                        '<html>' +
                        '' +
                        '<head>' +
                        '    <meta charset="UTF-8">' +
                        '    <meta name="viewport" content="width=device-width, ' +
                        '                initial-scale=1.0">' +
                        '    <title>Ride Over</title>' +
                        '' +
                        '    <style type="text/css">' +
                        '        .mainheader {' +
                        '            margin: 0 auto;' +
                        '            padding: 0 20px;' +
                        '            background-color: rgb(6, 60, 74);' +
                        '            width: 750px;' +
                        '        }' +
                        '' +
                        '        .mainLogoTd {' +
                        '            height: 80px;' +
                        '            border: none;' +
                        '        }' +
                        '' +
                        '        .tableStyle {' +
                        '            padding: 0 25px;' +
                        '            width: 100%;' +
                        '        }' +
                        '' +
                        '        .LeftTextWidth {' +
                        '            width: 70%;' +
                        '            padding-top: 15px;' +
                        '        }' +
                        '' +
                        '        .RightTextWidth {' +
                        '            width: 30%;' +
                        '            padding-top: 15px;' +
                        '        }' +
                        '' +
                        '        .LogotableStyle {' +
                        '            border: 0;' +
                        '            width: 100%;' +
                        '            text-align: center;' +
                        '            padding-top: 0;' +
                        '            padding-bottom: 0;' +
                        '        }' +
                        '' +
                        '        .padding30 {' +
                        '            padding-top: 30px;' +
                        '        }' +
                        '' +
                        '        .Hey-cutomer {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 22px;' +
                        '            font-weight: 500;' +
                        '            letter-spacing: 1px;' +
                        '            text-align: left;' +
                        '            color: #1f1f1f;' +
                        '        }' +
                        '' +
                        '        .Trip-Details {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 24px;' +
                        '            line-height: 1.4;' +
                        '            letter-spacing: 1px;' +
                        '            text-align: left;' +
                        '            font-weight: bold;' +
                        '            color: #242424;' +
                        '        }' +
                        '' +
                        '        .pickAddress {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 18px;' +
                        '            letter-spacing: 1.1px;' +
                        '            text-align: left;' +
                        '            color: #262626;' +
                        '        }' +
                        '' +
                        '        .You-Rode-with-James {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 18px;' +
                        '            font-weight: 600;' +
                        '            line-height: 1.4;' +
                        '            text-align: left;' +
                        '            color: #070707;' +
                        '        }' +
                        '' +
                        '        .LeftText {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 20px;' +
                        '            letter-spacing: 1.1px;' +
                        '            text-align: left;' +
                        '            color: #000000;' +
                        '        }' +
                        '' +
                        '        .RightText {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 20px;' +
                        '            font-weight: bold;' +
                        '            letter-spacing: 1.1px;' +
                        '            text-align: right;' +
                        '            color: #000000;' +
                        '        }' +
                        '' +
                        '        .Fare-Breakdown {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 18px;' +
                        '            font-weight: 600;' +
                        '            line-height: 1.4;' +
                        '            text-align: left;' +
                        '            color: #000000;' +
                        '        }' +
                        '' +
                        '        .TOTAL-FARE-Tk-880 {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 23px;' +
                        '            font-weight: bold;' +
                        '            line-height: .87;' +
                        '            text-align: right;' +
                        '            color: #a5a1ff;' +
                        '        }' +
                        '' +
                        '        .Fare-Details {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 18px;' +
                        '            line-height: .87;' +
                        '            color: #1f1f1f;' +
                        '        }' +
                        '' +
                        '        .straightLine {' +
                        '            padding-top: 20px;' +
                        '            border-bottom: 1px solid #b3b3b3;' +
                        '        }' +
                        '' +
                        '        .footerTable {' +
                        '            border: 0;' +
                        '            background-color: rgb(6, 60, 74);' +
                        '            width: 100%;' +
                        '        }' +
                        '' +
                        '        .Float-text {' +
                        '            float: right;' +
                        '        }' +
                        '' +
                        '        .Clear-all {' +
                        '            clear: both;' +
                        '        }' +
                        '' +
                        '        .Fair-full-details {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 17px;' +
                        '            line-height: .87;' +
                        '            text-align: right;' +
                        '            color: #1f1f1f;' +
                        '        }' +
                        '' +
                        '        .Visibilty {' +
                        '            visibility: hidden;' +
                        '        }' +
                        '' +
                        '        .Background-adjust {' +
                        '            background-color: lightgray;' +
                        '            padding: 5px;' +
                        '        }' +
                        '' +
                        '        .Total-Fair {' +
                        '            font-size: 35px;' +
                        '            font-weight: 600;' +
                        '            text-align: left;' +
                        '            padding-top: 5px;' +
                        '        }' +
                        '' +
                        '        .Total-Fair-1 {' +
                        '            font-size: 35px;' +
                        '            font-weight: 600;' +
                        '            text-align: right;' +
                        '            padding-top: 5px;' +
                        '        }' +
                        '' +
                        '        .Text-Align {' +
                        '            text-align: left;' +
                        '        }' +
                        '' +
                        '        .Text-Right {' +
                        '            text-align: right;' +
                        '        }' +
                        '' +
                        '        .Font-Size-Adjust {' +
                        '            font-size: 12px;' +
                        '        }' +
                        '' +
                        '        .Font-Size-Customer {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 22px;' +
                        '            line-height: .87;' +
                        '            text-align: left;' +
                        '            color: #1f1f1f;' +
                        '        }' +
                        '' +
                        '        .AddressDetails {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 22px;' +
                        '            line-height: .87;' +
                        '            text-align: left;' +
                        '            font-weight: bold;' +
                        '            color: #1f1f1f;' +
                        '        }' +
                        '' +
                        '        .padding10 {' +
                        '            padding-top: 10px;' +
                        '        }' +
                        '' +
                        '        .disance-Details {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 20px;' +
                        '            line-height: .87;' +
                        '            text-align: left;' +
                        '            color: #1f1f1f;' +
                        '        }' +
                        '' +
                        '        .Marker-image {' +
                        '            width: 30px;' +
                        '        }' +
                        '' +
                        '        .Tarifa-text {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 22px;' +
                        '            line-height: .87;' +
                        '            text-align: left;' +
                        '            font-weight: bold;' +
                        '            color: #1f1f1f;' +
                        '        }' +
                        '' +
                        '        .ObservationText {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 14px;' +
                        '            line-height: .87;' +
                        '            text-align: left;' +
                        '            color: #1f1f1f;' +
                        '            border: 2px solid #1f1f1f;' +
                        '        }' +
                        '' +
                        '        .bottomtext {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 15px;' +
                        '            line-height: .87;' +
                        '            text-align: left;' +
                        '            color: #1f1f1f;' +
                        '        }' +
                        '' +
                        '        .footerImage {' +
                        '            display: block;' +
                        '            margin: 0 auto;' +
                        '        }' +
                        '' +
                        '        .footerImageText {' +
                        '            color: #FFFFFF;' +
                        '            margin-top: 7px;' +
                        '            text-align: center;' +
                        '        }' +
                        '' +
                        '        .tableStyleWithoutPadding {' +
                        '            width: 100%;' +
                        '        }' +
                        '' +
                        '        pre {' +
                        '            font-family: sans-serif;' +
                        '            padding: 4px;' +
                        '            margin: 4px;' +
                        '        }' +
                        '' +
                        '        .createdText {' +
                        '            color: orange;' +
                        '            font-size: 18px;' +
                        '        }' +
                        '' +
                        '        .heading {' +
                        '            color: black;' +
                        '            font-weight: bold;' +
                        '            padding-left: 20px;' +
                        '            font-size: 18px;' +
                        '        }' +
                        '' +
                        '        .vip {' +
                        '            float: right;' +
                        '            color: red;' +
                        '            font-weight: bold;' +
                        '            font-size: 16px;' +
                        '            padding-right: 30px;' +
                        '            padding-bottom: 20px;' +
                        '        }' +
                        '' +
                        '        .headingRight {' +
                        '            float: right;' +
                        '            color: black;' +
                        '            /* font-weight: bold; */' +
                        '            font-size: 18px;' +
                        '            padding-right: 50px;' +
                        '            padding: 8px 20px 8px 0px;' +
                        '            min-height: 16px;' +
                        '        }' +
                        '    </style>' +
                        '</head>' +
                        '' +
                        '<body>' +
                        '    <table style=" margin: 0 auto;padding: 20px 20px; background-color: rgb(6, 60, 74);width: 600px;">' +
                        '        <tbody>' +
                        '            <tr style="background-color:#fff;color:#FFFFFF;">' +
                        '                <td style="padding:10px">' +
                        '                    <table style="border:0;width:100%;">' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold;font-size: 16px;">' +
                        '                                Reserva:' +
                        '                            </td>' +
                        '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.job_id}}' +
                        '' + '                       <td style="color: red;font-weight: bold;font-size: 14px;padding-right: 30px;">' +
                        '                                {{vip}}' +
                        '                            </td>' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr  style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold;font-size: 16px;">' +
                        '                                Nombre:' +
                        '                            </td>' +
                        '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.customer_username}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold; font-size: 16px;">' +
                        '                                Telefono:' +
                        '                            </td>' +
                        '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.customer_phone}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold; font-size: 16px;">' +
                        '                                Correo:' +
                        '                            </td>' +
                        '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.customer_email}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold; font-size: 16px;">' +
                        '                                Origen:' +
                        '                            </td>' +
                        '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.job_pickup_address}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold; font-size: 16px;width:200px">' +
                        '                                Fecha Retiro:' +
                        '                            </td>' +
                        '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.date}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold;font-size: 16px;width:200px">' +
                        '                                Hora retiro:' +
                        '                            </td>' +
                        '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.time}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold; font-size: 16px;">' +
                        '                                Destino:' +
                        '                            </td>' +
                        '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.job_address}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold; font-size: 16px;width:200px">' +
                        '                                Tipo Servicio:' +
                        '                            </td>' +
                        '                            <td style="color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.service_name}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold;font-size: 16px;width:200px">' +
                        '                                Num. Pasajeros:' +
                        '                            </td>' +
                        '                            <td style="color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.number_of_passangers}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold; font-size: 16px;">' +
                        '                                Estado:' +
                        '                            </td>' +
                        '                            <td style="color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.Estado}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold; font-size: 16px;">' +
                        '                                Convenio:' +
                        '                            </td>' +
                        '                            <td style="color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.contract_name}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold;font-size: 16px;width:200px">' +
                        '                                Tarifa estimada:' +
                        '                            </td>' +
                        '                            <td style="color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.estimated_payment_cost}} / {{vm.bookingDetails.fare}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                    </table>' +
                        '' +
                        '                </td>' +
                        '            </tr>' +
                        '        </tbody>' +
                        '    </table>' +
                        '</body>' +
                        '' +
                        '</html>';
                    vm.string = vm.templateString;
                    if (data.payment_status == 1 || data.payment_status == 1) {
                        vm.string = vm.string.replace('{{vm.bookingDetails.Estado}}', 'PAGADA');
                    } else {
                        vm.string = vm.string.replace('{{vm.bookingDetails.Estado}}', 'NO PAGADA');
                    }
                    if (data.job_time_utc) {
                        var time = moment(new Date(data.job_time_utc)).format('HH:mm')
                        vm.string = vm.string.replace('{{vm.bookingDetails.time}}', time);
                    }
                    if (data.job_time_utc) {


                        var date = moment(data.job_time_utc).format('MMMM DD YYYY')
                        console.log(date, "date");
                        vm.string = vm.string.replace('{{vm.bookingDetails.date}}', date);
                    }
                    if (data.route_type == 1) {
                        vm.string = vm.string.replace('{{vm.bookingDetails.fare}}', 'FIJA');
                    } else {
                        vm.string = vm.string.replace('{{vm.bookingDetails.fare}}', 'Variable');
                    }
                    if (data.is_vip && data.is_vip == 1) {
                        vm.string = vm.string.replace('{{vip}}', 'VIP');
                    } else {
                        vm.string = vm.string.replace('{{vip}}', '')
                    }

                    function numberWithCommas(x) {
                        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                    };
                    vm.string = vm.string.replace('{{vm.bookingDetails.job_id}}', JSON.stringify(data.job_id));
                    vm.string = vm.string.replace('{{vm.bookingDetails.customer_phone}}', data.customer_phone);
                    vm.string = vm.string.replace('{{vm.bookingDetails.customer_username}}', data.customer_username);
                    vm.string = vm.string.replace('{{vm.bookingDetails.job_pickup_address}}', data.job_pickup_address);
                    vm.string = vm.string.replace('{{vm.bookingDetails.customer_email}}', data.customer_email);
                    vm.string = vm.string.replace('{{vm.bookingDetails.job_address}}', data.job_address);
                    vm.string = vm.string.replace('{{vm.bookingDetails.service_name}}', data.service_name);
                    vm.string = vm.string.replace('{{vm.bookingDetails.contract_name}}', data.contract_name);
                    vm.string = vm.string.replace('{{vm.bookingDetails.number_of_passangers}}', data.number_of_passangers);
                    vm.string = vm.string.replace('{{vm.bookingDetails.estimated_payment_cost}}', '$' + numberWithCommas(data.estimated_payment_cost));
                    console.log(vm.string, "string");

                    document.getElementById('copy').value = vm.string;
                    var copyText = document.getElementById('copy');
                    console.log(document.getElementById("copy"));
                    copyText.select();
                    document.execCommand("copy");
                    if (document.execCommand('copy') == true) {
                        $scope.items.copied = true;
                        $timeout(function () {
                            $scope.items.copied = false;
                        }, 2000);
                    }

                }
                $scope.copyText = function (data) {
                    var el = document.getElementById('copyData')
                    var body = document.body,
                        range, sel;
                    if (document.createRange && window.getSelection) {
                        range = document.createRange();
                        sel = window.getSelection();
                        sel.removeAllRanges();
                        try {
                            range.selectNodeContents(el);
                            sel.addRange(range);
                            document.execCommand("Copy");
                        } catch (e) {
                            range.selectNode(el);
                            sel.addRange(range);
                            document.execCommand("Copy");
                        }
                    } else if (body.createTextRange) {
                        range = body.createTextRange();
                        range.moveToElementText(el);
                        range.select();
                        document.execCommand("Copy");
                    }

                    $scope.items.copied = true;
                    $timeout(function () {
                        $scope.items.copied = false;
                    }, 2000);
                };

                $scope.openPdf = function (data) {
                    //console.log(data);
                    $log.log(data);
                    $scope.items.loading = true;
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.job_id = Number(data.job_id);
                    var promise = getBookingsHereMaps.makeCreateBookingPdfHeight(dataSend);
                    promise.then(function (payload) {
                            $log.log('sxdsads', payload);
                            document.getElementById('showPrint').innerHTML = payload.title.data.pdf_html;
                            vm.OpenLink = payload.title.data.pdf_html;
                            win = window.open('', "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=" + (screen.width) + ",height=" + (screen.height) + ",top=0,left=0");
                            $scope.items.loading = false;
                            $timeout(function () {
                                win.document.body.innerHTML = payload.title.data.pdf_html;
                                //  $scope.getVoucherLink(data, payload.title.data);
                            }, 1000);
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            $scope.items.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }

                $scope.getVoucherLink = function (data, pdfData) {
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.job_id = Number(data.job_id);
                    //dataSend.pdf_html = pdfData.pdf_html;
                    dataSend.height = $('#showPrint').height() + 200;
                    $scope.items.loading = true;
                    var promise = getBookingsHereMaps.makeCreateBookingPdf(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            $scope.items.loading = false;
                            if (win) {
                                win.close();
                            }
                            win = window.open(payload.title.data.pdfLink, "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=" + (screen.width) + ",height=" + (screen.height) + ",top=0,left=0");
                            win.document.body.innerHTML = '<iframe src="' + payload.title.data.pdfLink + '" height=' + screen.height + ' width=' + screen.width + '></ifrmae>';
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            $scope.items.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }

            }
        }
        //====================edit booking api=======================
        function editBookingApi($event, arrayFDatesMade) {
            if(vm.routingBase && vm.routingBase.routing_base_id > 0) {
                vm.dataToFill.selectedServiceDetails.category = 0;
                vm.method_range_pickup = 0;
            }
            if (vm.errorFlagForDate == true) {
                return;
            }
            if (vm.bookingError == true) {
                errorMessageFactory.showErrorMessage('Error al calcular el Retiro. Error en la llamada a la API', 0);
                return;
            }
            if (vm.errorFlagForDate == true || (vm.dataToFill.passengerCount == 0 || vm.dataToFill.passengerCount == null || vm.dataToFill.passengerCount == undefined) || vm.ErrorFlagForNewApi) {
                return;
            }
            vm.currentTime = new Date();
            // if (vm.dataToFill.dropDate == 'Invalid Date' && vm.dataToFill.dropTime == 'Invalid Date') {
            //     vm.dataToFill.dropDate = new Date();
            //     vm.dataToFill.dropTime = new Date();
            // }
            // //console.log(moment(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime)),'dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime)');
            if (new Date(vm.dataToFill.scheduledDate) != 'Invalid Date' && new Date(vm.dataToFill.scheduledTime) != 'Invalid Date') {
                vm.currentBookingSchudule = dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime);
            } else {
                vm.currentBookingSchudule = new Date();
            }
            if (new Date(vm.dataToFill.dropDate) != 'Invalid Date' && new Date(vm.dataToFill.dropDate) != 'Invalid Date') {
                vm.claenderTime = dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropDate);
            } else {
                vm.claenderTime = new Date();
            }
            // vm.claenderTime = moment(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime)).subtract(vm.etaSeconds, 'seconds');
            vm.timeFlight = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            vm.currentTimeFlight = new Date(dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value));
            vm.checkFlag = moment(vm.timeFlight).isAfter(vm.claenderTime);

            vm.currentCheckFlag = moment(vm.currentTimeFlight).isAfter(vm.currentTime);
            vm.checkFlagCurrentBookingSchudule = moment(vm.currentTimeFlight).isAfter(vm.currentBookingSchudule);

            //console.log(vm.currentTimeFlight, vm.currentBookingSchudule, 'claenderTime');
            // Tv-2176 
            // if (vm.type_of_trip1 == 'R' && vm.checkFlag == false && vm.flagForFlightDate == true && vm.type_of_trip1 != 'P') {
            //     languageBasedErrorFactory.getProperErrorMessage('greaterCheck', 0, 0)
            //     vm.disableSubmitButton = false;
            //     return false;
            // }
            // if (vm.currentCheckFlag == false && vm.flagForFlightDate == true && vm.type_of_trip1 != 'P') {
            //     languageBasedErrorFactory.getProperErrorMessage('greaterCheck', 0, 0)
            //     vm.disableSubmitButton = false;
            //     return false;
            // }
            // if (vm.checkFlagCurrentBookingSchudule == false && vm.flagForFlightDate == true && vm.type_of_trip1 != 'P') {
            //     languageBasedErrorFactory.getProperErrorMessage('greaterCheck', 0, 0)
            //     vm.disableSubmitButton = false;
            //     return false;
            // }
            $log.log(vm.dataToFill);
            $log.log(vm.daysList);
            var dataSend = {};
            dataSend.time = [];
            dataSend.reaccurringTimeZone = [];
            var tz = moment.tz.guess();
            dataSend.access_token = $cookies.get('obj');
            dataSend.booking_id = vm.dataToFill.bookingId;
            dataSend.customer_email = vm.dataToFill.customerEmail;
            dataSend.customer_phone_number = vm.dataToFill.customerMobileG;
            dataSend.profile = Number(vm.dataToFill.customerProfile);
            dataSend.number_of_passangers = Number(vm.dataToFill.passengerCount);
            dataSend.timezone = new Date().getTimezoneOffset();
            dataSend.booking_for = Number(vm.dataToFill.bookingFor);
            ///////////////////////////TV-1795 //////////////////////////
            // if (vm.dataToFill.controllerWayTarifa == 1) {
            //     vm.viaControlled1 = 0;
            //     vm.viaControlled2 = 0;
            // }
            if (vm.dataToFill.bookingFor == 1) {
                dataSend.full_name = vm.dataToFill.personName;
                dataSend.phone_number = vm.dataToFill.personMobile;
                dataSend.email = vm.dataToFill.personEmail;
                if (vm.dataToFill.passengerId != null)
                    dataSend.passenger_id = vm.dataToFill.passengerId;
            }
            dataSend.pickup_location = vm.dataToFill.pickUpAddress;
            dataSend.job_pickup_comuna = vm.jobPickupComuna || null; // Send CITY of PICKUP ADDRESS
            dataSend.drop_location = vm.dataToFill.dropOffAddress;
            dataSend.job_dropoff_comuna = vm.jobDropoffComuna || null; // Send CITY of DROPOFF ADDRESS
            dataSend.pickup_lat = vm.dataToFill.pickUpLat;
            dataSend.pickup_long = vm.dataToFill.pickUpLng;
            dataSend.drop_lat = vm.dataToFill.dropOffLat;
            dataSend.drop_long = vm.dataToFill.dropOffLng;
            dataSend.transport_type_id = Number(vm.dataToFill.carType);
            dataSend.observations = vm.dataToFill.observations;
            //if (vm.dataToFill.bookingType == '1') {
            //    dataSend.schedule_ride = 1;
            //    dataSend.time.push(dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime).toISOString());
            //} else if (vm.dataToFill.bookingType == '0') {
            //    dataSend.schedule_ride = 0;
            //}
            var isAirportFlag = 0;
            if (vm.fromAirportFlag) {
                isAirportFlag = 1;
            } else if (vm.toAirportFlag) {
                isAirportFlag = 2;
            }
            dataSend.airport = Number(isAirportFlag);
            if (vm.checkBoxCheck) {
                dataSend.sin_respaldo = vm.checkBoxValueIs ? 1 : 0;
            }
            if ((vm.dataToFill.bookingType == '1' && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2)) && !vm.routingBase) {
                dataSend.schedule_ride = 1;
                console.log(dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime), 'datetTime');
                dataSend.timezone = moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime).toISOString()));
                dataSend.reaccurringTimeZone.push(moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime).toISOString())));
                // dataSend.timezone = new Date(dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime).toISOString()).getTimezoneOffset();
                dataSend.time.push(dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime).toISOString());
            } else if ((vm.dataToFill.bookingType == '1' && ((vm.dataToFill.selectedServiceDetails.category == 1) || (vm.routingBase && vm.routingBase.routing_base_id > 0)))) {
                dataSend.schedule_ride = 1;
                dataSend.timezone = moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString()));
                dataSend.reaccurringTimeZone.push(moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString())));
                // dataSend.timezone = new Date(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString()).getTimezoneOffset();
                dataSend.time.push(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString());
            } else if (vm.dataToFill.bookingType == '0' && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2) && vm.type_of_trip_Validate_Booking != 'R') {
                dataSend.schedule_ride = 0;
            } else if (vm.dataToFill.bookingType == '0' && vm.dataToFill.selectedServiceDetails.category == 1) {
                dataSend.schedule_ride = 0;
                dataSend.timezone = moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString()));
                dataSend.reaccurringTimeZone.push(moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString())));
                // dataSend.timezone = new Date(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString()).getTimezoneOffset();
                dataSend.time.push(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString());
            }
            if ((vm.type_of_trip1 == 'R' && vm.dataToFill.selectedServiceDetails.category == 1 && vm.method_range_pickup) || (vm.routingBase && vm.routingBase.routing_base_id > 0)) {
                dataSend.is_routing = 1;
                dataSend.time_pickup_array = (vm.pickRangeSendForRouting);
                dataSend.reaccurringTimeZone = vm.timeZoneRecurring;
                dataSend.pickup_top_range = vm.pickup_top_range;
                dataSend.pickup_lower_range = vm.pickup_lower_range;
                dataSend.travel_distance_route = vm.distanceRoutingApi;
            }
            // if (vm.type_of_trip == 'R' && vm.dataToFill.selectedServiceDetails.category == 1 && vm.method_range_pickup_return && vm.dataToFill.roundTrip == 1) {
            //     dataSend.is_routing = 1;
            //     dataSend.time_pickup_return_route = (vm.pickRangeSendForRoutingReturn);
            //     dataSend.returnTimeZone = vm.timeZoneRRoundReturn;
            //     dataSend.pickup_top_range_return = vm.pickup_lower_range_return;
            //     dataSend.pickup_lower_range_return = vm.pickup_top_range_return;
            // }
            // else if (vm.dataToFill.bookingType == '1' && vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking == 'R') {
            //     dataSend.schedule_ride = 1;
            //     dataSend.timezone = new Date(dateTimeFormat(vm.dataToFill.dropDateOfRType, vm.dataToFill.dropTimeOfRtype).toISOString()).getTimezoneOffset();
            //     dataSend.time.push(dateTimeFormat(vm.dataToFill.dropDateOfRType, vm.dataToFill.dropTimeOfRtype).toISOString());
            // }
            else if (vm.dataToFill.bookingType == '0' && vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking == 'R') {
                dataSend.schedule_ride = 0;
            }
            if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking == 'P') {
                dataSend.pickup_tolerance_time_pap = vm.time_trip_shared_service_point_to_point;
                dataSend.pickup_travel_time_pap = vm.pickup_travel_time_pap;
            }
            dataSend.round_trip = Number(vm.dataToFill.roundTrip);
            if(vm.dataToFill.roundTrip) {
                if(vm.estimated_toll_price_return !== undefined && vm.dataToFill.Return_policy.route_type === 0) {
                    dataSend.estimated_toll_price_return = vm.estimated_toll_price_return;
                }
                if(vm.heremaps_toll_details_return && vm.dataToFill.route_type === 0) {
                    dataSend.heremaps_toll_details_return = vm.heremaps_toll_details_return;
                }
            }
            if(vm.heremaps_toll_details && vm.dataToFill.route_type === 0) {
                dataSend.heremaps_toll_details = vm.heremaps_toll_details;
                dataSend.heremaps_estimated_tolls = vm.tollCount;
            }
            console.log(vm.dataToFill.roundTrip, !vm.dataToFill.is_wait_time_included, new Date(vm.dataToFill.returnDate), "gashdsdgsbdsd")
            // && new Date(vm.bookingDetails.return_date_time_utc) != 'Invalid Date'
            if ((new Date(vm.dataToFill.returnDate) != 'Invalid Date') && (vm.dataToFill.roundTrip && !vm.dataToFill.is_wait_time_included && vm.dataToFill.selectedServiceDetails.category != 1) || (vm.dataToFill.selectedServiceDetails.category == 1 && vm.type_of_trip != 'R')) {
                dataSend.returnTimeZone = moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.returnDate, vm.dataToFill.returnTime).toISOString()));
                dataSend.return_date_time = dateTimeFormat(vm.dataToFill.returnDate, vm.dataToFill.returnTime).toISOString();
            } else if ((vm.dataToFill.roundTrip && !vm.dataToFill.is_wait_time_included && vm.dataToFill.selectedServiceDetails.category == 1) || (vm.dataToFill.selectedServiceDetails.category == 1 && vm.type_of_trip != 'R')) {
                dataSend.returnTimeZone = moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.dropDateReturn, vm.dataToFill.dropTimeReturn).toISOString()));
                dataSend.return_date_time = dateTimeFormat(vm.dataToFill.dropDateReturn, vm.dataToFill.dropTimeReturn).toISOString();
            } else if (vm.bookingDetails.is_POS_booking != 1) {
                dataSend.returnTimeZone = moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.returnDate, vm.dataToFill.returnTime).toISOString()));
                dataSend.return_date_time = dateTimeFormat(vm.dataToFill.returnDate, vm.dataToFill.returnTime).toISOString();
            }
            // if ((vm.dataToFill.roundTrip && !vm.dataToFill.is_wait_time_included && vm.dataToFill.selectedServiceDetails.category != 1) || (vm.dataToFill.selectedServiceDetails.category ==1 &&  vm.type_of_trip != 'R')) {
            //     dataSend.return_date_time = dateTimeFormat(vm.dataToFill.returnDate, vm.dataToFill.returnTime).toISOString();
            // }else if((vm.dataToFill.roundTrip && !vm.dataToFill.is_wait_time_included && vm.dataToFill.selectedServiceDetails.category == 1) || (vm.dataToFill.selectedServiceDetails.category ==1 &&  vm.type_of_trip != 'R')){
            //     dataSend.return_date_time = dateTimeFormat(vm.dataToFill.dropDateReturn, vm.dataToFill.dropTimeReturn).toISOString();
            // }
            // else if(vm.bookingDetails.is_POS_booking == 1 && vm.bookingDetails.return_date_time_utc == '0000-00-00 00:00:00'){
            //     dataSend.return_date_time = dateTimeFormat(vm.dataToFill.returnDate, vm.dataToFill.returnTime).toISOString();
            // }
            dataSend.reaccurring = Number(vm.dataToFill.reaccurringBooking);
            if (vm.dataToFill.reaccurringBooking == '1') {
                if (arrayFDatesMade.length != 0) {
                    for (var i = 0; i < arrayFDatesMade.length; i++) {
                        dataSend.reaccurringTimeZone.push(moment.tz.zone(tz).utcOffset(moment(arrayFDatesMade[i])));
                        dataSend.time.push(arrayFDatesMade[i]);
                    }
                } else {
                    dataSend.reaccurringTimeZone.push(moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.dropDateReturn, vm.dataToFill.dropTimeReturn).toISOString())));
                }
            } else {
                dataSend.reaccurringTimeZone = []; // TV-3659 change in parent booking timezone is not consider by backend in case of recurring 
            }
            if (vm.dataToFill.reference_point) {
                dataSend.reference_point = vm.dataToFill.reference_point;
            }
            if (vm.dataToFill.corporate_account_id && (vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == '1')) {
                dataSend.corporate_account_id = vm.dataToFill.corporate_account_id;
            }
            dataSend.route_id = vm.dataToFill.route_id;
            console.log(vm.dataToFill.route_type, 'vm.dataToFill.route_type');

            dataSend.route_type = vm.dataToFill.route_type;
            dataSend.type_of_agreement = vm.dataToFill.type_of_agreement;
            if (vm.dataToFill.type_of_agreement == 1) // THIRD PERSON BOOKING IS VIP OR NOT IN CORPORATE AGGREMENT
                dataSend.isVIP_someone = vm.is_vip ? 1 : 0;
            dataSend.is_wait_time_included = vm.dataToFill.is_wait_time_included ? 1 : 0;
            // if (vm.getInfoFlag == true) {
            //     dataSend.contract_id = vm.bookingDetails.contract_id
            // } else {
            //     dataSend.contract_id = vm.dataToFill.contractIdSelected;
            // }
            dataSend.contract_id = vm.dataToFill.contractIdSelected;
            dataSend.service_type = Number(vm.dataToFill.serviceTypeSelected);

            if (vm.dataToFill.authRequired == '1' && (vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == '1')) {
                dataSend.auth_required = Number(vm.dataToFill.authRequired);
                dataSend.auth_of = RutHelper.clean(vm.dataToFill.authRUT);
            }

            if (vm.dataToFill.itemOfChargeSelected.length) {
                vm.dataToFill.item_of_charges = [];
                vm.dataToFill.is_item_of_charges = 1;
                for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                    vm.dataToFill.item_of_charges.push({
                        "fixed_pricing_id": vm.dataToFill.itemOfChargeSelected[i].fixed_pricing_id ? vm.dataToFill.itemOfChargeSelected[i].fixed_pricing_id : vm.dataToFill.itemOfChargeSelected[i].variable_pricing_id,
                        "id": vm.dataToFill.itemOfChargeSelected[i].tic_id,
                        "item_of_charge_id": vm.dataToFill.itemOfChargeSelected[i].id,
                        "description": vm.dataToFill.itemOfChargeSelected[i].tic_description,
                        "long_name": vm.dataToFill.itemOfChargeSelected[i].tic_long_name,
                        "manually": vm.dataToFill.itemOfChargeSelected[i].tic_manually,
                        "price": vm.dataToFill.itemOfChargeSelected[i].price,
                        "short_name": vm.dataToFill.itemOfChargeSelected[i].tic_short_name,
                        "quantity": vm.dataToFill.itemOfChargeSelected[i].quantity,
                        "retorno": vm.dataToFill.itemOfChargeSelected[i].retorno
                    })
                }
                dataSend.is_item_of_charges = Number(vm.dataToFill.is_item_of_charges);
                var items_ida = vm.dataToFill.item_of_charges.filter(function(itm){ return itm.retorno == false });
                var items_vuelta = vm.dataToFill.item_of_charges.filter(function(itm){ return itm.retorno == true });
                dataSend.item_of_charges = items_ida;
                dataSend.item_of_charges_return = items_vuelta;
            } else {
                dataSend.is_item_of_charges = 0;
            }
            if (vm.dataToFill.nearDriver)
                dataSend.favourite_driver_id = Number(vm.dataToFill.nearDriver);

            dataSend.payment_method = vm.dataToFill.payment_method ? vm.dataToFill.payment_method : vm.bookingDetails.payment_method;

            if (vm.dataToFill.passengerRutCheck == 1)
                dataSend.passenger_rut = RutHelper.clean(vm.dataToFill.passengerRut);
            if (vm.dataToFill.applicantRutCheck == 1)
                dataSend.applicant_rut = RutHelper.clean(vm.dataToFill.applicantRut);
            if (vm.dataToFill.costCenterCheck == 1)
                dataSend.cost_center = vm.dataToFill.costCenter;
            if (vm.dataToFill.costSubCenterCheck == 1)
                dataSend.sub_cost_center = vm.dataToFill.costSubCenter;
            if (vm.dataToFill.RolCheck == 1)
                dataSend.rol = vm.dataToFill.Rol;
            if (vm.dataToFill.graphCheck == 1)
                dataSend.graph = vm.dataToFill.graph;
            if (vm.dataToFill.workOrderCheck == 1)
                dataSend.work_order = vm.dataToFill.workOrder;
            if (vm.dataToFill.pepCheck == 1)
                dataSend.PEP = vm.dataToFill.pep;
            if (vm.dataToFill.purposeOfTripCheck == 1)
                dataSend.purpose_of_trip = vm.dataToFill.purposeOfTrip;
            if (vm.dataToFill.noOfVoucherCheck == 1)
                dataSend.number_of_voucher = vm.dataToFill.noOfVoucher;
            if (vm.dataToFill.nominaCheck == 1)
                dataSend.nomina = vm.dataToFill.nomina;
            if (vm.dataToFill.solictudCheck == 1)
                dataSend.solicitud = vm.dataToFill.solictud;
            //console.log(vm.dataToFill.pepCheck, 'pepCheck');
            if (vm.viaControlledFLag1 == true && vm.type_of_trip1 == 'Z') {
                if (vm.dataToFill.controllerWayTarifa == 1) {
                    dataSend.via_controlled_price = Number(vm.viaControlled1);
                    vm.addViaControlled = 0;
                } else {
                    dataSend.via_controlled_price = Number(vm.viaControlled1);
                    vm.addViaControlled = Number(vm.viaControlled1);
                }
            } else {
                vm.addViaControlled = 0;
            }
            // if (vm.viaControlledFLag == true && vm.dataToFill.roundTrip == true) {
            //     dataSend.via_controlled_price_return = Number(vm.viaControlled2);
            //     vm.addViaControlledRound = Number(vm.viaControlled2);
            // } else {
            //     vm.addViaControlledRound = 0;
            // }
            if (vm.viaControlledFLag == true && vm.dataToFill.roundTrip == true) {
                if (vm.dataToFill.controllerWayTarifa == 1) {
                    // if (vm.dataToFill.selectedServiceDetails.fare_type == 1) {
                    //     dataSend.via_controlled_price = Number(vm.viaControlled2) + (vm.viaControlled2 * (vm.dataToFill.passengerCount - 1));
                    //     vm.addViaControlledRound = 0;
                    // } else {
                    dataSend.via_controlled_price_return = Number(vm.viaControlled2);
                    vm.addViaControlledRound = 0;
                    // }
                } else {
                    // if (vm.dataToFill.selectedServiceDetails.fare_type == 1) {
                    //     dataSend.via_controlled_price = Number(vm.viaControlled2) + (vm.viaControlled2 * (vm.dataToFill.passengerCount - 1));
                    //     vm.addViaControlledRound = 0;
                    // } else {
                    dataSend.via_controlled_price_return = Number(vm.viaControlled2);
                    vm.addViaControlledRound = 0;
                    // }
                }
            } else {
                vm.addViaControlledRound = 0;
            }
            if (vm.dataToFill.controllerWayTarifa == 1) {
                vm.viaControlled1 = 0;
                vm.viaControlled2 = 0;
            }
            if (vm.dataToFill.discounts.length) {
                console.log('>>>>>>>>. DISCOUNT >>>>>>>>', vm.dataToFill.discounts);
                if (vm.dataToFill.controllerWayTarifa == 1) {
                    dataSend.estimated_payment_cost = Math.round(vm.dataToFill.discounts[0].finalAmount + vm.addViaControlled);
                } else {
                    dataSend.estimated_payment_cost = Math.round(vm.dataToFill.discounts[0].finalAmount);
                }
            } else if (vm.addressChange == true) {
                dataSend.estimated_payment_cost = Math.round(vm.dataToFill.estimatedFare + Number(vm.viaControlled1));
            }
            if (vm.addressChange == false) {
                dataSend.estimated_payment_cost = Math.round(vm.bookingDetails.estimated_payment_cost);
            }
            console.log('>>>>>>>>> vm.return_flag >>>>>>>', vm.return_flag);
            if (vm.return_flag == true) {
                if (vm.dataToFill.discounts.length) {
                    dataSend.route_id_return = vm.dataToFill.Return_policy.route_id;
                    dataSend.route_type_return = vm.dataToFill.Return_policy.route_type;
                    if (vm.dataToFill.controllerWayTarifa == 1) {
                        console.log("dkhakdhakhdkashdaskhd", vm.dataToFill.discounts[0].roundFinalAmount, vm.addViaControlledRound);

                        dataSend.estimated_payment_cost_return = Math.round(vm.dataToFill.discounts[0].roundFinalAmount + vm.addViaControlledRound);
                    } else {
                        dataSend.estimated_payment_cost_return = Math.round(vm.dataToFill.discounts[0].roundFinalAmount);
                    }
                } else {
                    dataSend.route_id_return = vm.dataToFill.Return_policy.route_id;
                    dataSend.route_type_return = vm.dataToFill.Return_policy.route_type;
                    dataSend.estimated_payment_cost_return = Math.round(vm.dataToFill.Return_policy.estimatedFare + Number(vm.viaControlled2));
                }
                dataSend.child_booking_id = vm.bookingDetails.round_trip_child_job_id;
            }

            if(vm.estimated_toll_price !== undefined && vm.dataToFill.route_type === 0) {
                dataSend.estimated_toll_price = vm.estimated_toll_price;
            }
            if ((vm.dataToFill.selectedServiceDetails.category == 0) && (vm.type_of_trip_Validate_Booking == 'R' || (vm.dataToFill.roundTrip && vm.type_of_trip == 'R'))) {
                dataSend.travel_time = vm.travel_time_service_pick_up;
                dataSend.tolerance_time = vm.tolerance_time_withdrawal_pickup;
            }
            ///////////////////////////TV-1795 //////////////////////////
            // dataSend.via_controlled_price = Number(vm.viaControlled1);
            if (vm.dataToFill.selectedServiceDetails.category == 0) { //exclusive
                dataSend.booking_type = 0; //Normal
            } else if (vm.dataToFill.selectedServiceDetails.category == 1) { //shared
                dataSend.booking_type = 1; //shared
            }
            //else if(vm.dataToFill.selectedServiceDetails.category == 2){ //Normal
            //    dataSend.booking_type = 0; //Normal
            //}

            dataSend.is_POS_booking = 0;
            dataSend.payment_status = 0;
            dataSend.created_by_admin = 1;

            if (vm.dataToFill.discounts.length) {
                if (vm.dataToFill.discounts[0].name == 'ROUND TRIP') {
                    dataSend.promo_type = 1;
                } 
                else if(vm.modifyFalg && vm.bookingDetails.promo_type == 4) {
                    console.log('debug vm.bookingDetails.promo_type', vm.bookingDetails.promo_type);
                    dataSend.promo_type = vm.bookingDetails.promo_type;
                    // return;
                }
                else {
                    dataSend.promo_type = 0;
                    dataSend.promo_id = vm.dataToFill.discounts[0].name;

                }
                dataSend.discount_type = Number(vm.dataToFill.discounts[0].discountType);
                if(vm.modifyFalg && vm.bookingDetails.promo_type == 4) {
                    console.log('debug vm.bookingDetails.discount_amount', Number(vm.bookingDetails.discount_amount));
                    // return;
                    dataSend.discount_amount = Number(vm.bookingDetails.discount_amount);
                }
                else {
                    dataSend.discount_amount = Number(vm.dataToFill.discounts[0].discountTypeValue);
                }
                dataSend.discount_code = vm.dataToFill.couponCode;
                dataSend.final_discount_amount = vm.dataToFill.discounts[0].value;

            }

            if (vm.dataToFill.selectedServiceDetails.category == 1 && !vm.method_range_pickup) {
                dataSend.booking_eta = vm.dataToFill.etaScheduleValue + vm.dataToFill.time_trip_shared_service;
            } else {
                dataSend.booking_eta = vm.dataToFill.etaSchedule;
            }
            if (vm.dataToFill.selectedServiceDetails.category == 1) {
                console.log(vm.dataToFill.etaScheduleValueReturn, vm.dataToFill.time_trip_shared_service, ' vm.dataToFill.etaScheduleValueReturn + vm.dataToFill.time_trip_shared_service');

                dataSend.return_booking_eta = vm.dataToFill.etaScheduleValueReturn + vm.dataToFill.time_trip_shared_service;
            } else {
                dataSend.return_booking_eta = vm.dataToFill.etaScheduleValueReturn;
            }
            if (vm.airlineMandatory == 1 && vm.SendTrip != 'P') {
                dataSend.airline = vm.dataToFill.airline;
            }
            if (vm.flightNumberMandatory == 1 && vm.SendTrip != 'P') {
                dataSend.flight_number = vm.dataToFill.flightNumber;
            }
            if (vm.flightDateMandatory == 1 && vm.SendTrip != 'P') {
                dataSend.flight_date = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            }
            if (vm.flightTypeMandatory == 1 && vm.SendTrip != 'P') {
                if (vm.international) {
                    dataSend.flight_type = vm.international;
                } else {
                    dataSend.flight_type = vm.national;
                }

            }
            if(vm.dataToFill.route_type === 0) {
                dataSend.apply_charge_by_toll = vm.searchFixedVariablePayload.title.data.apply_charge_by_toll;
                dataSend.apply_estimated_distance_variable_fare = vm.searchFixedVariablePayload.title.data.apply_estimated_distance_variable_fare;
                dataSend.collect_estimated_tag = vm.searchFixedVariablePayload.title.data.collect_estimated_tag;
            }
            if ((JSON.parse($cookies.get('adminType') || 0) == 1) && vm.isEmpDataChange)
                dataSend.is_emp_data = vm.isEmpDataChange; // TV-2378

            if(vm.routingBase && vm.routingBase.depot_id)
                dataSend.depot_id = vm.routingBase.depot_id;

            $log.log(dataSend);
            console.log(dataSend, "modify");

            vm.loading = true;
            var promise = getBookingsHereMaps.modifyBooking(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    //console.log(payload, "<edit payload>>>>>>>>>>>");

                    if (payload.title.status == 400) {
                        if (payload.title != null && payload.title.data && payload.title.data.key == true) {
                            bookingValidateCreationSuccess(payload.title, 'NoAuth', $event);
                        } else {
                            //console.log(payload.title.message, 'payload.title.message');

                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }


                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        console.log(vm.dataToFill.authRequired, 'vm.dataToFill.authRequired ');

                        if (vm.dataToFill.authRequired == '1' || vm.dataToFill.authRequired == 1) {
                            languageBasedErrorFactory.getProperErrorMessage('bookingSuccUA', 0, 2, 'layout.upcomingBookingsMain.upcomingBookings')
                            //errorMessageFactory.showErrorMessage('Booking updated successfully.But the Reserve will remain pending until Authorized.',2,'layout.upcomingBookingsMain.upcomingBookings');
                        } else {
                            languageBasedErrorFactory.getProperErrorMessage('bookingSuccU', 0, 2, 'layout.upcomingBookingsMain.upcomingBookings')


                            //errorMessageFactory.showErrorMessage('Booking updated successfully.',2,'layout.upcomingBookingsMain.upcomingBookings');
                        }
                    }
                    //$timeout(function() {
                    //    $mdDialog.hide();
                    //     $state.reload();
                    //}, 2000);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    vm.disableSubmitButton = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }


        function stopRKey(evt) {
            var evt = (evt) ? evt : ((event) ? event : null);
            var node = (evt.target) ? evt.target : ((evt.srcElement) ? evt.srcElement : null);
            if ((evt.keyCode == 13) && (node.type == "text")) {
                return false;
            }
        }

        document.onkeypress = stopRKey;

        // Variable to Contain Child Job Id
        // Default value is 1
        vm.roundTripChildJobId = 1;

        function checkBoxValue(data) {
            vm.checkBoxCheck = true;
        }
        //===========================modify booking===========================
        function getSingleBooking(id) {
            vm.loading = true;
            vm.disabledSubmitButton = true;
            var promise = getBookingsHereMaps.singleBooking(id);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    vm.bookingDetails = payload.title.data;
                    vm.getInfoFlag = true;
                    vm.modifyFalgNew = true;
                    //console.log(vm.bookingDetails.round_trip_child_job_id, 'vm.bookingDetails.round_trip_child_job_id');
                    if (vm.bookingDetails.round_trip_child_job_id > 0 || vm.bookingDetails.round_trip_parent_job_id > 0 ||
                        (vm.bookingDetails.is_round_trip == 1 && vm.bookingDetails.is_wait_time_included == 1)) {

                        vm.disabledRoundTrip = true;

                    } else {
                        vm.disabledRoundTrip = false;
                    }
                    var type;
                    if (vm.bookingDetails.type_of_trip == 'Z') {
                        type = 2;
                        forTabsView(type);
                    } else if (vm.bookingDetails.type_of_trip == 'R') {
                        type = 1;
                        forTabsView(type);
                    } else {
                        type = 3;
                        forTabsView(type);
                    }

                    //console.log(vm.bookingDetails);
                    //console.log('vm.allCustomersList', vm.allCustomersList);

                    var whereCustomer = _.where(vm.allCustomersList, {
                        customer_id: vm.bookingDetails.created_by
                    })[0];
                    vm.flagHelp = true;
                    vm.dataToFill.customerMobile = whereCustomer;

                    // Variable to Contain Child Job Id
                    vm.roundTripChildJobId = vm.bookingDetails.round_trip_child_job_id || 0;

                    vm.isAdjustedDiscountedAmount = vm.bookingDetails.is_adjusted_discounted_amount;
                    //console.log(whereCustomer);
                    vm.makePhoneEditAble = false;
                    vm.dataToFill.customerMobile.phone_number = vm.bookingDetails.customer_phone_number;
                    vm.dataToFill.customerMobileG = vm.bookingDetails.customer_phone_number;
                    vm.dataToFill.customerId = vm.dataToFill.customerMobile.customer_id;
                    vm.dataToFill.previousCustomerId = vm.dataToFill.customerMobile.customer_id;
                    vm.dataToFill.customerEmail = vm.dataToFill.customerMobile.email;
                    vm.dataToFill.employeeId = vm.dataToFill.customerMobile.customer_id;
                    vm.checkBoxValueIs = vm.bookingDetails.sin_respaldo == 1 ? true : false;
                    console.log(vm.checkBoxValueIsToShow, 'vm.checkBoxValueIsToShow');
                    vm.dataToFill.passengerId = vm.bookingDetails.passenger_id;
                    console.log(vm.bookingDetails.passenger_id, 'vm.bookingDetails.passenger_id');

                    if (vm.bookingDetails.flight_date != null) {
                        vm.filterData.filter_pickup_from_date_value = new Date(vm.bookingDetails.flight_date);
                        vm.filterData.filter_pickup_from_time_value = new Date(vm.bookingDetails.flight_date);
                    }
                    vm.modifyFalg = true;

                    // vm.filterData.filter_pickup_from_time_value = new Date(vm.bookingDetails.flight_date);
                    vm.dataToFill.flightNumber = vm.bookingDetails.flight_number;
                    vm.dataToFill.airline = vm.bookingDetails.airline;
                    vm.TypeToShow = vm.bookingDetails.flight_type;
                    if (vm.TypeToShow == 'I') {
                        vm.international = 'I';
                    } else {
                        vm.national = 'N';
                    }


                    //vm.customerProfileOption = [
                    //    {
                    //        name: 'Personal',
                    //        value: 0
                    //    },
                    //    {
                    //        name: 'Corporate',
                    //        value: 1
                    //    }
                    //]
                    getCustomerFavouriteAddress();
                    vm.modifyBooking = true;
                    vm.dataToFill.customerProfile = vm.bookingDetails.creator_profile.toString();
                    profileChanges();
                    vm.dataToFill.contractIdSelected = vm.bookingDetails.contract_id;
                    console.log(vm.dataToFill.contractIdSelected, 'vm.dataToFill.contractIdSelected');

                    vm.dataToFill.bookingType = vm.bookingDetails.schedule_ride.toString();
                    bookingType();
                    //if(vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == '1'){
                    //    agreementTypeChanged();
                    //}
                    vm.dataToFill.serviceTypeSelected = vm.bookingDetails.type_of_service;
                    vm.dataToFill.passengerCount = vm.bookingDetails.number_of_passangers;
                    vm.discard_booking_flag = vm.bookingDetails.discard_from_group;
                    //numberOfPassenger(vm.dataToFill.passengerCount);
                    vm.dataToFill.pickUpAddress = vm.bookingDetails.job_pickup_address;
                    vm.dataToFill.pickUpLat = vm.bookingDetails.job_pickup_latitude;
                    vm.dataToFill.pickUpLng = vm.bookingDetails.job_pickup_longitude;
                    vm.dataToFill.dropLng = vm.bookingDetails.job_longitude;
                    vm.dataToFill.dropLat = vm.bookingDetails.job_latitude;
                    vm.dataToFill.pickLat = vm.bookingDetails.job_pickup_latitude;
                    vm.dataToFill.pickLng = vm.bookingDetails.job_pickup_longitude;
                    // vm.pickaddressChange = true;
                    // vm.dropaddressChange = true;
                    var location = new google.maps.LatLng(Number(vm.bookingDetails.job_pickup_latitude), Number(vm.bookingDetails.job_pickup_longitude));
                    getFavoriteAddress('pick');
                    // placeMarker(map, location, 'pick');
                    vm.dataToFill.dropOffAddress = vm.bookingDetails.job_address;
                    vm.dataToFill.dropOffLat = vm.bookingDetails.job_latitude;
                    vm.dataToFill.dropOffLng = vm.bookingDetails.job_longitude;
                    vm.dataToFill.payment_method = Number(vm.bookingDetails.payment_method);
                    console.log(vm.dataToFill.payment_method, 'vm.dataToFill.payment_method', vm.bookingDetails.payment_method);

                    var locationD = new google.maps.LatLng(Number(vm.bookingDetails.job_latitude), Number(vm.bookingDetails.job_longitude));
                    getFavoriteAddress('drop');
                    // placeMarker(map, locationD, 'drop');
                    vm.dataToFill.bookingFor = vm.bookingDetails.booking_for;
                    vm.dataToFill.otherBooking = vm.dataToFill.bookingFor == 1 ? true : false;
                    vm.dataToFill.isEmpDataChange = vm.bookingDetails.is_emp_data || false;
                    //console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>');
                    // bookingFor(vm.dataToFill.bookingFor);
                    
                    vm.dataToFill.dropDate = new Date(vm.bookingDetails.job_time_utc);
                    vm.dataToFill.dropTime = new Date(vm.bookingDetails.job_time_utc);
                    vm.dataToFill.scheduledTime = new Date(vm.bookingDetails.job_time_utc);
                    vm.dataToFill.returnDate = new Date(vm.bookingDetails.job_delivery_datetime);
                    vm.dataToFill.returnTime = new Date(vm.bookingDetails.job_delivery_datetime);

                    $timeout(function () {


                        if ((vm.dataToFill.bookingType == 1 || vm.dataToFill.bookingType == '1') && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2) &&
                            (new Date(vm.bookingDetails.job_delivery_datetime) != 'Invalid Date') && (new Date(vm.bookingDetails.job_time_utc) != 'Invalid Date')) {
                            vm.dataToFill.scheduledDate = new Date(vm.bookingDetails.job_time_utc);
                            vm.dataToFill.scheduledTime = new Date(vm.bookingDetails.job_time_utc);
                            // vm.dataToFill.returnDate = new Date(vm.bookingDetails.job_time_utc);
                            // vm.dataToFill.returnTime = new Date(vm.bookingDetails.job_time_utc);\

                            vm.dataToFill.dropDate = vm.bookingDetails.job_delivery_datetime ? new Date(vm.bookingDetails.job_delivery_datetime) : '';
                            vm.dataToFill.dropTime = vm.bookingDetails.job_delivery_datetime ? new Date(vm.bookingDetails.job_delivery_datetime) : '';
                            vm.returnDateOptions.minDate = vm.dataToFill.scheduledBooking == 1 ? vm.dataToFill.scheduledDate : new Date();
                        } else if ((vm.dataToFill.bookingType == 1 || vm.dataToFill.bookingType == '1') && vm.dataToFill.selectedServiceDetails.category == 1 &&
                            (new Date(vm.bookingDetails.job_delivery_datetime) != 'Invalid Date') && (new Date(vm.bookingDetails.job_time_utc) != 'Invalid Date')) {
                            vm.dataToFill.scheduledDate = new Date(vm.bookingDetails.job_time_utc);
                            vm.dataToFill.scheduledTime = new Date(vm.bookingDetails.job_time_utc);
                            vm.dataToFill.dropDate = new Date(vm.bookingDetails.job_delivery_datetime);
                            vm.dataToFill.dropTime = new Date(vm.bookingDetails.job_delivery_datetime);
                            vm.pickRange3 = moment(vm.bookingDetails.job_time_utc).format('HH:mm');
                            vm.dataToFill.returnDate = new Date(vm.bookingDetails.job_delivery_datetime);
                            vm.dataToFill.returnTime = new Date(vm.bookingDetails.job_delivery_datetime);
                            vm.dataToFill.dropDateReturn = new Date(vm.bookingDetails.return_date_time_utc);
                            vm.dataToFill.dropTimeReturn = new Date(vm.bookingDetails.return_date_time_utc);
                            vm.returnDateOptions.minDate = vm.dataToFill.scheduledBooking == 1 ? vm.dataToFill.dropDate : new Date();
                        } else if ((vm.dataToFill.bookingType == '0' || vm.dataToFill.bookingType == 0) && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2)) {
                            vm.dataToFill.scheduledBooking = 0;
                        } else if ((vm.dataToFill.bookingType == '0' || vm.dataToFill.bookingType == 0) && vm.dataToFill.selectedServiceDetails.category == 1 &&
                            (new Date(vm.bookingDetails.job_delivery_datetime) != 'Invalid Date') && (new Date(vm.bookingDetails.job_time_utc) != 'Invalid Date')) {
                            vm.dataToFill.scheduledBooking = 0;
                            vm.dataToFill.scheduledDate = new Date(vm.bookingDetails.job_time_utc);
                            vm.dataToFill.scheduledTime = new Date(vm.bookingDetails.job_time_utc);
                            vm.dataToFill.dropDate = new Date(vm.bookingDetails.job_delivery_datetime);
                            vm.dataToFill.dropTime = new Date(vm.bookingDetails.job_delivery_datetime);
                            vm.dataToFill.returnDate = new Date(vm.bookingDetails.job_delivery_datetime);
                            vm.dataToFill.returnTime = new Date(vm.bookingDetails.job_delivery_datetime);
                            vm.dataToFill.dropDateReturn = new Date(vm.bookingDetails.return_date_time_utc);
                            vm.dataToFill.dropTimeReturn = new Date(vm.bookingDetails.return_date_time_utc);
                            vm.returnDateOptions.minDate = vm.dataToFill.scheduledBooking == 1 ? vm.dataToFill.dropDate : new Date();
                        }

                        if (vm.bookingDetails.is_round_trip == 1) {
                            vm.posBookingFlag = true;
                        }
                        if (vm.bookingDetails.is_POS_booking == 1 && vm.bookingDetails.round_trip_parent_job_id > 0 &&
                            vm.bookingDetails.job_time_utc == '0000-00-00 00:00:00') {
                            vm.dataToFill.scheduledTime = '';
                        }
                        // vm.bookingDetails.is_POS_booking == 1 &&
                        //  vm.bookingDetails.is_POS_booking == 1 &&
                        if ((vm.bookingDetails.round_trip_parent_job_id > 0 || vm.bookingDetails.round_trip_child_job_id > 0)) {
                            vm.disableAgreementService = true;
                            vm.pickUpAddress = vm.bookingDetails.job_pickup_address;
                            reverseGeocodeForPickUp();
                            vm.dropUpAddress = vm.bookingDetails.job_address;
                            reverseGeocodeForDropUp();
                            // $timeout(function () {
                            //     if (vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                            //         calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, map, 'ROUND TRIP', vm.payloadForsearchFixedVairable);
                            //         // getFixedRoutesForPersonal(vm.dataToFill);

                            //     }
                            // }, 1000)
                        }
                        // tv-1885
                        if (vm.dataToFill.selectedServiceDetails.fare_type == 1) {
                            vm.disabledNumberOfpassengerByCount = true;
                        }

                        //if (vm.dataToFill.scheduledBooking == 1) {
                        //    vm.dataToFill.scheduledDate = new Date(vm.bookingDetails.job_time_utc);
                        //    vm.dataToFill.scheduledTime = new Date(vm.bookingDetails.job_time_utc);
                        //    vm.dataToFill.returnDate = new Date(vm.bookingDetails.job_time_utc);
                        //    vm.dataToFill.returnTime = new Date(vm.bookingDetails.job_time_utc);
                        //    vm.returnDateOptions.minDate = vm.dataToFill.scheduledBooking == 1 ? vm.dataToFill.scheduledDate : new Date();
                        //}
                        if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking == 'P') {
                            calculateDateRangeOfPointToPoint();
                        }
                        // calculateDateRangeOfPointToPoint();
                        // if (vm.dataToFill.selectedServiceDetails.category == 0 && (vm.type_of_trip_Validate_Booking == 'R' || vm.type_of_trip == 'R')) {
                        //     vm.dataToFill.scheduledTime = new Date(vm.bookingDetails.job_time_utc);
                        //     vm.dataToFill.scheduledDate = new Date(vm.bookingDetails.job_time_utc);
                        //     calculateEstimatePickUpTimeForRType(vm.dataToFill.etaScheduleValue);
                        // }
                        // if (vm.dataToFill.selectedServiceDetails.category == 0 && (vm.type_of_trip_Validate_Booking == 'R' || (vm.dataToFill.round_trip && vm.type_of_trip == 'R'))) {
                        //     console.log(" i m in this >>>>>>>>>>>>>>>>>>>>>>>>>>>",vm.type_of_trip_Validate_Booking == 'R' ,(vm.dataToFill.round_trip && vm.type_of_trip == 'R'));

                        //     vm.dataToFill.scheduledDate = new Date(vm.bookingDetails.job_delivery_datetime);
                        //     vm.dataToFill.scheduledTime = new Date(vm.bookingDetails.job_delivery_datetime);
                        //     // calculateEstimatePickUpTimeForRType(vm.dataToFill.etaScheduleValue);
                        // }
                        console.log(vm.dataToFill.returnDate, 'vm.dataToFill.returnDate>>>>>>>>>>>>>>>>LAst');
                        if (vm.type_of_trip1 != 'P' && vm.flagForFlightDate == true) {
                            compareDates();
                        }
                    }, 3000);

                    if (vm.bookingDetails.payment_state == 1 || vm.bookingDetails.payment_status == 1) {
                        vm.disabledPaymentMethod = true;
                    } else {
                        vm.disabledPaymentMethod = false;
                    }
                    if (vm.dataToFill.otherBooking) {
                        vm.is_vip = vm.bookingDetails.is_vip ? true : false;
                        vm.dataToFill.personSelected = vm.bookingDetails.job_pickup_name;
                        vm.dataToFill.personName = vm.bookingDetails.job_pickup_name;
                        if (vm.bookingDetails.job_pickup_email != "null") {
                            //console.log("i m here puneet");
                            vm.dataToFill.personEmail = vm.bookingDetails.job_pickup_email;
                        } else {
                            vm.dataToFill.personEmail = '';
                        }

                        vm.dataToFill.personMobile = vm.bookingDetails.job_pickup_phone;
                        vm.dataToFill.personFromDb = !vm.bookingDetails.person_from_db;
                    }
                    vm.dataToFill.reference_point = vm.bookingDetails.reference_point;
                    var timeOutSet = 0;

                    if (vm.bookingDetails.is_round_trip || vm.bookingDetails.is_POS_booking == 1 || (vm.bookingDetails.is_round_trip && (vm.dataToFill.customerProfile == '1'))) {
                        timeOutSet = 3000;
                    } else {
                        timeOutSet = 0;
                    }
                    console.log(timeOutSet, 'timeOutSet');

                    $timeout(function () {
                        if (vm.bookingDetails.is_round_trip) {
                            vm.dataToFill.roundTrip = true;
                            vm.dataToFill.returnDate = new Date(vm.bookingDetails.return_date_time_utc) == 'Invalid Date' ? '' : new Date(vm.bookingDetails.return_date_time_utc);
                            vm.dataToFill.returnTime = new Date(vm.bookingDetails.return_date_time_utc) == 'Invalid Date' ? '' : new Date(vm.bookingDetails.return_date_time_utc);
                            vm.dataToFill.dropDateReturn = new Date(vm.bookingDetails.return_date_time_utc) == 'Invalid Date' ? '' : new Date(vm.bookingDetails.return_date_time_utc);
                            vm.dataToFill.dropTimeReturn = new Date(vm.bookingDetails.return_date_time_utc) == 'Invalid Date' ? '' : new Date(vm.bookingDetails.return_date_time_utc);
                        }
                        if (vm.bookingDetails.is_POS_booking == 1) {
                            vm.dataToFill.dropDate = new Date(vm.bookingDetails.job_delivery_datetime) == 'Invalid Date' ? '' : new Date(vm.bookingDetails.job_delivery_datetime);
                            vm.dataToFill.dropTime = new Date(vm.bookingDetails.job_delivery_datetime) == 'Invalid Date' ? '' : new Date(vm.bookingDetails.job_delivery_datetime);
                            vm.dataToFill.scheduledDate = new Date(vm.bookingDetails.job_time_utc) == 'Invalid Date' ? '' : new Date(vm.bookingDetails.job_time_utc);
                            vm.dataToFill.scheduledTime = new Date(vm.bookingDetails.job_time_utc) == 'Invalid Date' ? '' : new Date(vm.bookingDetails.job_time_utc);
                        }
                        if (vm.bookingDetails.is_round_trip && (vm.dataToFill.customerProfile == '1')) {
                            vm.dataToFill.is_wait_time_included = vm.bookingDetails.is_wait_time_included;
                        }
                    }, timeOutSet);

                    if (vm.bookingDetails.reaccuring_ride) {
                        vm.dataToFill.reaccurringBooking = false;
                    }
                    $timeout(function () {
                        if ((vm.dataToFill.selectedServiceDetails.category == 0 && (vm.type_of_trip_Validate_Booking == 'R' || (vm.dataToFill.round_trip && vm.type_of_trip == 'R')) && new Date(vm.bookingDetails.job_delivery_datetime) != 'Invalid Date')) {
                            vm.dataToFill.scheduledDate = new Date(vm.bookingDetails.job_delivery_datetime);
                            vm.dataToFill.scheduledTime = new Date(vm.bookingDetails.job_delivery_datetime);
                            calculateEstimatePickUpTimeForRType(vm.dataToFill.etaScheduleValue);
                        }
                    }, 3000)
                    //if (vm.dataToFill.bookingType == '0') {
                    vm.dataToFill.nearDriver = '';
                    toGetAirportService(vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.serviceTypeSelected, map);
                    //toGetNearByDrivers(vm.dataToFill.pickUpLat,vm.dataToFill.pickUpLng,vm.dataToFill.serviceTypeSelected,map);
                    //}

                    // $timeout(function () {
                    if (vm.bookingDetails.passenger_rut)
                        vm.dataToFill.passengerRut = RutHelper.format(vm.bookingDetails.passenger_rut);
                    //console.log(vm.dataToFill.passengerRut, 'vm.dataToFill.passengerRut');
                    if (vm.bookingDetails.applicant_rut)
                        vm.dataToFill.applicantRut = RutHelper.format(vm.bookingDetails.applicant_rut);
                    if (vm.bookingDetails.cost_center)
                        vm.dataToFill.costCenter = vm.bookingDetails.cost_center;
                    if (vm.bookingDetails.sub_cost_center)
                        vm.dataToFill.costSubCenter = vm.bookingDetails.sub_cost_center;
                    if (vm.bookingDetails.rol)
                        vm.dataToFill.Rol = vm.bookingDetails.rol;
                    if (vm.bookingDetails.graph)
                        vm.dataToFill.graph = vm.bookingDetails.graph;
                    if (vm.bookingDetails.work_order)
                        vm.dataToFill.workOrder = vm.bookingDetails.work_order;
                    if (vm.bookingDetails.PEP)
                        vm.dataToFill.pep = vm.bookingDetails.PEP;
                    if (vm.bookingDetails.purpose_of_trip)
                        vm.dataToFill.purposeOfTrip = vm.bookingDetails.purpose_of_trip;
                    if (vm.bookingDetails.number_of_voucher)
                        vm.dataToFill.noOfVoucher = vm.bookingDetails.number_of_voucher;
                    if (vm.bookingDetails.nomina)
                        vm.dataToFill.nomina = vm.bookingDetails.nomina;
                    if (vm.bookingDetails.solicitud)
                        vm.dataToFill.solictud = vm.bookingDetails.solicitud;

                    vm.dataToFill.discounts = [];
                    $timeout(function () {
                        if (vm.bookingDetails.discount_amount > 0) {
                            vm.dataToFill.couponApplied = true;
                            var name = vm.bookingDetails.promo_type == '0' ? vm.bookingDetails.promo_id : vm.bookingDetails.promo_type == '1' ? 'ROUND TRIP' : vm.bookingDetails.promo_type == '2' ? 'Web Discount' : vm.bookingDetails.promo_type == '3' ? 'Bin' : 'NA';
                            var discountType = vm.bookingDetails.discount_type;
                            vm.couponType = discountType;
                            if (vm.bookingDetails.promo_type == 0 || vm.bookingDetails.promo_type == '0') {
                                var discountTypeValue = vm.bookingDetails.discount_amount;
                            } else if (vm.bookingDetails.promo_type == '1' || vm.bookingDetails.promo_type == 1) {
                                var discountTypeValue = vm.dataToFill.roundTripDiscount;
                            } else if (vm.bookingDetails.promo_type == '2' || vm.bookingDetails.promo_type == 2) {
                                var discountTypeValue = vm.dataToFill.webDiscount;
                            }
                            var value;
                            var returnValue;
                            if (vm.bookingDetails.discount_type == 0 || vm.bookingDetails.discount_type == '0') {
                                value = Number(vm.bookingDetails.discount_amount);
                            } else {
                                // if(vm.dataToFill.controllerWayTarifa == 0){
                                value = ((Number(vm.dataToFill.estimatedFare) * Number(vm.bookingDetails.discount_amount)) / 100);
                                // }else{
                                //      value = ((Number(vm.dataToFill.estimatedFare - vm.viaControlled1) * Number(vm.bookingDetails.discount_amount)) / 100)
                                // }

                            }
                            if (vm.bookingDetails.discount_type == 0 || vm.bookingDetails.discount_type == '0') {
                                returnValue = Number(vm.bookingDetails.discount_amount);
                            } else {
                                // if(vm.dataToFill.controllerWayTarifa == 0){
                                returnValue = ((Number(vm.dataToFill.Return_policy.estimatedFare) * Number(vm.bookingDetails.discount_amount)) / 100);
                                // }else{
                                //     returnValue   = ((Number(vm.dataToFill.Return_policy.estimatedFare - vm.viaControlled2) * Number(vm.bookingDetails.discount_amount)) / 100);
                                // }

                            }
                            var final = Number((Number(vm.dataToFill.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled1))) - value);

                            // vm.dataToFill.discounts.push({
                            //     // estimatedFare: Number(vm.dataToFill.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled1)),
                            //     estimatedFare: viaControlledPrice(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking),
                            //     // roundTripFare: roundTripFareSend,
                            //     roundTripFare: vm.dataToFill.roundTrip == true ? viaControlledPrice(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip) : 0,
                            //     name: payload.title.data.coupon_number,
                            //     discountType: payload.title.data.type,
                            //     discountTypeValue: payload.title.data.discount,
                            //     // value: payload.title.data.type ? Math.round((Number(vm.estimatedFareDiscount) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled1))) * (payload.title.data.discount) / 100) : payload.title.data.discount,
                            //     value: payload.title.data.type ? calculateDiscountPercentage(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, payload.title.data.discount) : calculateDiscountFlat(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, payload.title.data.discount),
                            //     // returnValue: returnValueSend,
                            //     returnValue: vm.dataToFill.roundTrip == true ? (payload.title.data.type ? calculateDiscountPercentage(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, payload.title.data.discount) : calculateDiscountFlat(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, payload.title.data.discount)) : 0,
                            //     // finalAmount: payload.title.data.type ?  ((vm.estimatedFareDiscount - vm.estimatedFareDiscount * Number(payload.title.data.discount) / 100) + (vm.type_of_trip_Validate_Booking == 'Z' ? (Number(vm.viaControlled1)) : 0)) :  ((vm.estimatedFareDiscount - vm.estimatedFareDiscount * Number(payload.title.data.discount) / 100) + (vm.type_of_trip_Validate_Booking == 'Z' ? (Number(vm.viaControlled1)) : 0)),
                            //     finalAmount: payload.title.data.type ? calculateDiscountPercentage(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, payload.title.data.discount) : calculateDiscountFlat(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, payload.title.data.discount),
                            //     // roundFinalAmount: roundFinalAmountSend,
                            //     roundFinalAmount: vm.dataToFill.roundTrip == true ? (payload.title.data.type ? calculateDiscountPercentage(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, payload.title.data.discount) : calculateDiscountFlat(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, payload.title.data.discount)) : 0
                            // });


                            vm.dataToFill.discounts = [];
                            vm.dataToFill.discounts.push({
                                // estimatedFare: Number(vm.dataToFill.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled1)),
                                estimatedFare: viaControlledPrice(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking),
                                // roundTripFare: Number(vm.dataToFill.Return_policy.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled2)),
                                roundTripFare: vm.dataToFill.roundTrip == true ? viaControlledPrice(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip) : 0,
                                name: name,
                                discountType: discountType,
                                discountTypeValue: discountTypeValue,
                                // value: value,
                                value: vm.bookingDetails.discount_type ? calculateDiscountPercentageAmount(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, vm.bookingDetails.discount_amount, 'parent') : calculateDiscountFlatAmount(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, vm.bookingDetails.discount_amount),
                                // returnValue: returnValue,
                                returnValue: vm.dataToFill.roundTrip == true ? (vm.bookingDetails.discount_type ? calculateDiscountPercentageAmount(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, vm.bookingDetails.discount_amount, 'parent') : calculateDiscountFlatAmount(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, vm.bookingDetails.discount_amount)) : 0,
                                finalAmount: vm.bookingDetails.discount_type ? calculateDiscountPercentage(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, vm.bookingDetails.discount_amount, 'parent') : calculateDiscountFlat(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, vm.bookingDetails.discount_amount, 'parent'),
                                // roundFinalAmount: Number((Number(vm.dataToFill.Return_policy.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled2))) - returnValue)
                                roundFinalAmount: vm.dataToFill.roundTrip == true ? (vm.bookingDetails.discount_type ? calculateDiscountPercentage(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, vm.bookingDetails.discount_amount, 'parent') : calculateDiscountFlat(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, vm.bookingDetails.discount_amount)) : 0
                            })

                            console.log(vm.dataToFill.discounts, 'first time araay is >>>>>>>');
                        }
                        console.log(vm.dataToFill.discounts, 'modify>>>>>>>>>>>>>>>>>');
                    }, 3000)

                    if (vm.dataToFill.selectedServiceDetails.fare_type == 1) {
                        vm.dataToFill.viaControlledReal = Number(vm.bookingDetails.via_controlled_price) / Number(vm.dataToFill.passengerCount);
                    } else {
                        vm.dataToFill.viaControlledReal = Number(vm.bookingDetails.via_controlled_price);
                    }
                    vm.dataToFill.viaControlled = Number(vm.dataToFill.viaControlledReal);
                    // }, 2000);
                    $timeout(function () {
                        if (vm.bookingDetails.is_round_trip == 1) {
                            //console.log($scope.createBookingForm.returnDate.$error, "asmgdgjhasdgsajdgasgd");
                            $scope.createBookingForm.returnDate.$error.date = false;
                            $scope.createBookingForm.returnDate.$error.required = false;
                            $scope.createBookingForm.returnTime.$error.date = false;
                            $scope.createBookingForm.returnTime.$error.required = false;
                            //console.log($scope.createBookingForm.returnDate.$error, "asmgdgjhasdgsajdgasgd");
                        }
                    }, 1000)
                    if (vm.toAirportFlag || vm.fromAirportFlag) {
                        getAirportAddressApi();
                    }
                    if (vm.bookingDetails.type_of_trip == 'P' && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                        getFixedRoutesForPersonal(vm.dataToFill);
                    }
                    vm.dataToFill.observations = vm.bookingDetails.observations;
                    vm.dataToFill.estimatedFare = vm.bookingDetails.estimated_payment_cost;
                    // if(vm.bookingDetails.eta) {
                    //     vm.dataToFill.etaSchedule = vm.bookingDetails.eta;
                    // }
                    // if(vm.bookingDetails.route_type) {
                    //     vm.dataToFill.route_type = vm.bookingDetails.route_type;
                    // }
                    // setTimeout(function(){
                    //     if (vm.dataToFill && vm.dataToFill.selectedServiceDetails && vm.dataToFill.selectedServiceDetails.category == 1)
                    //     calculateEstimatePickUpTime(vm.bookingDetails.eta);
                    //     vm.pickRangeForRouting = moment(new Date(vm.bookingDetails.job_time_utc)).format('HH:mm')
                    // }, 1000);
                    vm.dataToFill.is_POS_booking = 0;
                    vm.dataToFill.payment_status = vm.bookingDetails.payment_status;
                    vm.dataToFill.created_by_admin = vm.bookingDetails.created_by_admin;
                    vm.isAdjustedDiscountedAmount = vm.bookingDetails.is_adjusted_discounted_amount || 0;
                    console.log(vm.dataToFill.selectedServiceDetails.category, vm.type_of_trip_Validate_Booking, ' type_of_trip_Validate_Booking');


                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        vm.compareDates = compareDates;
        vm.flightDateValidation = false;
        vm.scheduleDateValidation = false;
        vm.dropoffDateValidation = false;
        // =============Compare Schedule date and Flight Date
        function compareDates() {
            //pickup date is greater = flightDate -> true
            vm.flightDateValidation = false;
            vm.scheduleDateValidation = false;
            vm.dropoffDateValidation = false;
            var flightDateAndTime = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var scheduleDateAndTime = dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime);
            if (new Date(vm.dataToFill.dropDate) != 'Invalid Date' && new Date(vm.dataToFill.dropTime) != 'Invalid Date')
                var dropDateAndTime = dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime)
            if (vm.dataToFill.selectedServiceDetails.category == 0) {
                var flightDateGreater = (moment(new Date(scheduleDateAndTime)).isAfter(new Date(flightDateAndTime)));
                var scheduleDateGreater = (moment(new Date(scheduleDateAndTime)).isBefore(new Date(flightDateAndTime)));
            }
            if (vm.dataToFill.selectedServiceDetails.category == 1) {
                var dropOffGreater = (moment(new Date(dropDateAndTime)).isBefore(new Date(flightDateAndTime)));
                var dropOffSmaller = (moment(new Date(dropDateAndTime)).isAfter(new Date(flightDateAndTime)));
            }
            // is Before
            console.log(flightDateGreater, dropOffGreater, vm.dataToFill.scheduledDate, vm.filterData.filter_pickup_from_date_value, vm.dataToFill.dropDate);

            if (vm.type_of_trip1 == 'Z' && (scheduleDateGreater || dropOffGreater) && (vm.type_of_trip1 != 'P' && vm.flagForFlightDate == true)) {
                vm.flightDateValidation = false;
                vm.scheduleDateValidation = true;
                vm.dropoffDateValidation = true;
            }
            // // // is After
            else if (vm.type_of_trip1 == 'R' && (flightDateGreater || dropOffSmaller) && (vm.type_of_trip1 != 'P' && vm.flagForFlightDate == true)) {
                vm.flightDateValidation = true;
                vm.scheduleDateValidation = false;
                vm.dropoffDateValidation = false;
            }
            //get_cuota();
        }
        //////// FUNCATION TO MARK HEART FARVORITE NOT ////////////////
        function MarkfavouriteAddressPickUp(data) {
            if (data == false)
                vm.isActivePick = !vm.isActivePick;
            else vm.isActivePick = !vm.isActivePick;
            if (vm.isActivePick) {
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.address = vm.dataToFill.pickUpAddress;
                dataSend.latitude = vm.dataToFill.pickUpLat;
                dataSend.longitude = vm.dataToFill.pickUpLng;
                dataSend.communa = vm.jobPickupComuna;
                dataSend.is_admin = 1;
                dataSend.customer_id = vm.dataToFill.customerId;
                vm.loading = true;
                var promise = getBookingsHereMaps.setFavouriteAddress(dataSend);
                promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        if (payload.title.status == 200) {
                            vm.flagForMarkFavAddress = true;
                            setTimeout(function () {
                                vm.flagForMarkFavAddress = false;
                                $scope.$apply();
                            }, 5000)
                            // vm.isActivePick = !vm.isActivePick;
                            vm.dataToFill.location_id_address = payload.title.data.location_id;
                            getCustomerFavouriteAddress('')
                        } else {
                            vm.isActivePick = !vm.isActivePick;
                            vm.dataToFill.location_id_address = payload.title.data.location_id;
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        $scope.items.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            } else {
                var dataSend = {};
                var array = [];
                array.push(vm.dataToFill.location_id_address);
                dataSend.access_token = $cookies.get('obj');
                dataSend.location_id = array;
                dataSend.is_admin = 1;
                dataSend.customer_id = vm.dataToFill.customerId;
                vm.loading = true;
                var promise = getBookingsHereMaps.setUnFavouriteAddress(dataSend);
                promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        if (payload.title.status == 200) {
                            getCustomerFavouriteAddress('')
                        } else {
                            vm.isActivePick = !vm.isActivePick;
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        $scope.items.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }
        }
        //////// FUNCATION TO MARK HEART FARVORITE NOT ////////////////


        //////// FUNCATION TO MARK HEART FARVORITE NOT ////////////////
        function MarkfavouriteAddressDrop(data) {
            if (data == false)
                vm.isActiveDrop = !vm.isActiveDrop;
            else vm.isActiveDrop = !vm.isActiveDrop;
            if (vm.isActiveDrop) {
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.address = vm.dataToFill.dropOffAddress;
                dataSend.latitude = vm.dataToFill.dropOffLat;
                dataSend.longitude = vm.dataToFill.dropOffLng;
                dataSend.communa = vm.jobDropoffComuna;
                dataSend.is_admin = 1;
                dataSend.customer_id = vm.dataToFill.customerId;
                vm.loading = true;
                var promise = getBookingsHereMaps.setFavouriteAddress(dataSend);
                promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        if (payload.title.status == 200) {
                            vm.flagForMarkFavAddress = true;
                            setTimeout(function () {
                                vm.flagForMarkFavAddress = false;
                                $scope.$apply();
                            }, 5000)
                            vm.dataToFill.location_id_address = payload.title.data.location_id;
                            getCustomerFavouriteAddress('')
                        } else {
                            vm.isActiveDrop = !vm.isActiveDrop;
                            vm.dataToFill.location_id_address = payload.title.data.location_id;
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        $scope.items.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            } else {
                var dataSend = {};
                var array = [];
                array.push(vm.dataToFill.location_id_address);
                dataSend.access_token = $cookies.get('obj');
                dataSend.location_id = array;
                dataSend.is_admin = 1;
                dataSend.customer_id = vm.dataToFill.customerId;
                vm.loading = true;
                var promise = getBookingsHereMaps.setUnFavouriteAddress(dataSend);
                promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        if (payload.title.status == 200) {
                            getCustomerFavouriteAddress('');
                        } else {
                            vm.isActivePick = !vm.isActivePick;
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        $scope.items.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }
        }

        //////// FUNCATION TO MARK HEART FARVORITE NOT ////////////////



        //////// FUNCATION TO GET THE ADDRESS IS FAVORITE OR NOT ////////////////
        function getFavoriteAddress(type) {
            var dataSend = {}
            if (type == 'pick') {
                dataSend.address = vm.dataToFill.pickUpAddress;
            } else {
                dataSend.address = vm.dataToFill.dropOffAddress;
            }
            dataSend.customer_id = vm.dataToFill.customerId;
            vm.loading = true;
            var promise = getBookingsHereMaps.getFavouriteAddress(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        if (type == 'pick') {
                            vm.isActivePick = payload.title.data.is_favourite;
                            vm.dataToFill.location_id_address = payload.title.data.location_id;
                        } else {
                            vm.isActiveDrop = payload.title.data.is_favourite;
                            vm.dataToFill.location_id_address = payload.title.data.location_id;
                        }
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    $scope.items.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        //////// FUNCATION TO GET THE ADDRESS IS FAVORITE OR NOT ////////////////


        ////////////////////////// CHECK STATUS FOR BWR BOOKING /////////////////////////
        function CheckBookingStatus(data) {
            if (data) {
                if (data.sin_respaldo == 1) {
                    if (data.job_status == '0' || data.job_status == '1' || data.job_status == '2' || data.job_status == '4' ||
                        data.job_status == '7' || data.job_status == '9' || data.job_status == '12' || data.job_status == '14' || data.job_status == '15') {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }

            } else {
                return false;
            }
        }
        ////////////////////////// CHECK STATUS FOR BWR BOOKING /////////////////////////

        ////////////////////////// TAB VIEW ADDED OR REMOVING CLASS /////////////////////////
        function forTabsView(type) {
            if (type == 1) {
                vm.toAirportFlag = true;
                vm.flagForPanel = true;
                vm.fromAirportFlag = false;
                vm.flagForMarkFavAddress = false;
                vm.ptopAirportFlag = false;
                if (!vm.modifyFalg) {
                    vm.dataToFill.pickUpLat = '';
                    vm.dataToFill.pickUpLng = '';
                    vm.dataToFill.dropOffLat = '';
                    vm.dataToFill.dropOffLng = '';
                    vm.isActiveDrop = false;
                    vm.dataToFill.pickUpAddress = '';
                    vm.dataToFill.dropOffAddress = '';
                    // vm.isActivePick = false;
                    vm.ErrorFlagForNewApi = false;
                }
                if (vm.modifyFalg) {
                    if (vm.bookingDetails.type_of_trip != 'R') {
                        vm.dataToFill.pickUpLat = '';
                        vm.dataToFill.pickUpLng = '';
                        vm.dataToFill.dropOffLat = '';
                        vm.dataToFill.dropOffLng = '';
                        // vm.isActiveDrop = false;
                        vm.dataToFill.pickUpAddress = '';
                        vm.dataToFill.dropOffAddress = '';
                        // vm.isActivePick = false;
                        vm.ErrorFlagForNewApi = false;
                    } else {
                        vm.dataToFill.pickUpLat = vm.bookingDetails.job_pickup_latitude;
                        vm.dataToFill.pickUpLng = vm.bookingDetails.job_pickup_longitude;
                        vm.dataToFill.dropOffLat = vm.airportLatitude;
                        vm.dataToFill.dropOffLng = vm.airportLongitude;
                        vm.dataToFill.pickUpAddress = vm.bookingDetails.job_pickup_address;

                        vm.dataToFill.dropOffAddress = vm.bookingDetails.job_address;
                    }
                }
                var elementR = document.getElementById("toAirport");
                elementR.classList.add("active");
                var element = document.getElementById("fromAirport");
                element.classList.remove("active");
                var elementP = document.getElementById("pointToPoint");
                elementP.classList.remove("active");
            } else if (type == 2) {
                vm.flagForPanel = true;
                vm.toAirportFlag = false;
                vm.fromAirportFlag = true;
                vm.ptopAirportFlag = false;
                vm.flagForMarkFavAddress = false;
                if (!vm.modifyFalg) {
                    vm.dataToFill.pickUpAddress = '';
                    vm.dataToFill.dropOffAddress = '';
                    vm.dataToFill.pickUpLat = '';
                    vm.dataToFill.pickUpLng = '';
                    vm.dataToFill.dropOffLat = '';
                    vm.dataToFill.dropOffLng = '';
                    // vm.isActivePick = false;
                    vm.ErrorFlagForNewApi = false;
                    // vm.isActiveDrop = false;
                }
                if (vm.modifyFalg) {
                    if (vm.bookingDetails.type_of_trip != 'Z') {
                        vm.dataToFill.pickUpLat = '';
                        vm.dataToFill.pickUpLng = '';
                        vm.dataToFill.dropOffLat = '';
                        vm.dataToFill.dropOffLng = '';
                        // vm.isActiveDrop = false;
                        vm.dataToFill.pickUpAddress = '';
                        vm.dataToFill.dropOffAddress = '';
                        // vm.isActivePick = false;
                        vm.ErrorFlagForNewApi = false;
                    } else {
                        vm.dataToFill.pickUpLat = vm.airportLatitude;
                        vm.dataToFill.pickUpLng = vm.airportLongitude;
                        vm.dataToFill.dropOffLat = vm.bookingDetails.job_latitude;
                        vm.dataToFill.dropOffLng = vm.bookingDetails.job_longitude;
                        vm.dataToFill.pickUpAddress = vm.bookingDetails.job_pickup_address;
                        vm.dataToFill.dropOffAddress = vm.bookingDetails.job_address;
                    }
                }
                var elementR = document.getElementById("fromAirport");
                elementR.classList.add("active");
                var element = document.getElementById("toAirport");
                element.classList.remove("active");
                var elementP = document.getElementById("pointToPoint");
                elementP.classList.remove("active");
            } else {
                vm.flagForPanel = true;
                vm.toAirportFlag = false;
                vm.fromAirportFlag = false;
                vm.flagForMarkFavAddress = false;
                vm.ptopAirportFlag = true;
                if (!vm.modifyFalg) {
                    vm.dataToFill.pickUpLat = '';
                    vm.dataToFill.pickUpLng = '';
                    vm.dataToFill.dropOffLat = '';
                    vm.dataToFill.pickUpAddress = '';
                    vm.dataToFill.dropOffAddress = '';
                    vm.dataToFill.dropOffLng = '';
                    vm.ErrorFlagForNewApi = false;
                    // vm.isActivePick = false;
                    // vm.isActiveDrop = false;
                    vm.ErrorFlagForNewApi = false;
                }
                if (vm.modifyFalg) {
                    if (vm.bookingDetails.type_of_trip != 'P') {
                        vm.dataToFill.pickUpLat = '';
                        vm.dataToFill.pickUpLng = '';
                        vm.dataToFill.dropOffLat = '';
                        vm.dataToFill.dropOffLng = '';
                        vm.dataToFill.pickUpAddress = '';
                        vm.dataToFill.dropOffAddress = '';
                    } else {
                        vm.dataToFill.pickUpLat = vm.bookingDetails.job_pickup_latitude;
                        vm.dataToFill.pickUpLng = vm.bookingDetails.job_pickup_longitude;
                        vm.dataToFill.dropOffLat = vm.bookingDetails.job_latitude;
                        vm.dataToFill.dropOffLng = vm.bookingDetails.job_longitude;
                        vm.dataToFill.pickUpAddress = vm.bookingDetails.job_pickup_address;
                        vm.dataToFill.dropOffAddress = vm.bookingDetails.job_address;
                    }
                }
                var element = document.getElementById("toAirport");
                element.classList.remove("active");
                var elementP = document.getElementById("fromAirport");
                elementP.classList.remove("active");
                var elementR = document.getElementById("pointToPoint");
                elementR.classList.add("active");
            }
            vm.disabledSubmitButton = true;
            vm.fullCuota = false;
        }
        ////////////////////////// TAB VIEW ADDED OR REMOVING CLASS /////////////////////////

        function pickUpAddressBlank() {
            vm.crossFlag = true;
            vm.ErrorFlagForNewApi = false;
            vm.addressPickUpArray = [];
            if (vm.modifyFalg) {
                if (vm.toAirportFlag || vm.fromAirportFlag) {
                    vm.dataToFill.pickUpAddress = '';
                    vm.dataToFill.dropOffAddress = '';
                    vm.dataToFill.pickUpLat = '';
                    vm.dataToFill.pickUpLng = '';
                    vm.dataToFill.dropOffLat = '';
                    vm.dataToFill.dropOffLng = '';
                    vm.isActivePick = false;
                    // vm.isActiveDrop = false;
                } else {
                    vm.dataToFill.pickUpAddress = '';
                    vm.dataToFill.pickUpLat = '';
                    vm.dataToFill.pickUpLng = '';
                }
            } else {
                vm.dataToFill.pickUpAddress = '';
                vm.dataToFill.pickUpLat = '';
                vm.dataToFill.pickUpLng = '';
                getPreviousAddressHit(1);
            }
        }

        function dropOffAddressBlank() {
            vm.crossFlag = true;
            vm.ErrorFlagForNewApi = false;
            vm.addressDropArray = [];
            if (vm.modifyFalg) {
                if (vm.toAirportFlag || vm.fromAirportFlag) {
                    vm.dataToFill.pickUpAddress = '';
                    vm.dataToFill.dropOffAddress = '';
                    vm.dataToFill.pickUpLat = '';
                    vm.dataToFill.pickUpLng = '';
                    vm.dataToFill.dropOffLat = '';
                    vm.dataToFill.dropOffLng = '';
                    // vm.isActivePick = false;
                    vm.isActiveDrop = false;
                } else {
                    vm.dataToFill.dropOffAddress = '';
                    vm.dataToFill.dropOffLat = '';
                    vm.dataToFill.dropOffLng = '';
                }
            } else {
                vm.dataToFill.dropOffAddress = '';
                vm.dataToFill.dropOffLat = '';
                vm.dataToFill.dropOffLng = '';
                getPreviousAddressHit(2)
            }
        }

        function selectFavAddressNewPop(type, data) {
            if (type == 1) {
                vm.dataToFill.pickUpAddress = data.address;
                vm.dataToFill.favPickLocId = data.location_id;
                vm.addressChange = true;
                makeByPassFunctionForFav('1');
            } else {
                vm.dataToFill.dropOffAddress = data.address;
                vm.dataToFill.favDropLocId = data.location_id;
                makeByPassFunctionForFav('2');
            }
            vm.disabledSubmitButton1 = true;
        }

        function getAirportAddressApi() {
            var dataSend = {};
            var latitude, longitude;
            if (vm.toAirportFlag) {
                latitude = vm.dataToFill.pickUpLat;
                longitude = vm.dataToFill.pickUpLng;
            } else if (vm.fromAirportFlag) {
                latitude = vm.dataToFill.dropOffLat;
                longitude = vm.dataToFill.dropOffLng;
            }
            dataSend.type_of_trip = vm.toAirportFlag ? 'R' : 'Z';
            dataSend.lat = latitude;
            dataSend.long = longitude;
            vm.loading = true;
            var promise = getBookingsHereMaps.getAirportAddress(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        vm.ErrorFlagForNewApi = false;
                        if (vm.toAirportFlag) {
                            vm.dataToFill.dropOffLat = payload.title.data.airport_latitude;
                            vm.dataToFill.dropOffLng = payload.title.data.airport_longitude;
                            vm.dataToFill.dropLat = payload.title.data.airport_latitude;
                            vm.dataToFill.dropLng = payload.title.data.airport_longitude;
                            vm.dataToFill.dropOffAddress = payload.title.data.airport_address;
                        } else {
                            vm.dataToFill.pickUpLat = payload.title.data.airport_latitude;
                            vm.dataToFill.pickUpLng = payload.title.data.airport_longitude;
                            vm.dataToFill.pickLat = payload.title.data.airport_latitude;
                            vm.dataToFill.pickLng = payload.title.data.airport_longitude;
                            vm.dataToFill.pickUpAddress = payload.title.data.airport_address;
                            if (vm.dataToFill.serviceTypeSelected) { //&& (vm.dataToFill.bookingType == '0' || vm.dataToFill.bookingType == 0)
                                vm.dataToFill.nearDriver = '';
                                toGetAirportService(vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.serviceTypeSelected, map);
                                //toGetNearByDrivers(vm.dataToFill.pickUpLat,vm.dataToFill.pickUpLng,vm.dataToFill.serviceTypeSelected,map);
                            }
                        }
                        if (vm.modifyFalg) {
                            vm.airportAddress = payload.title.data.airport_address;
                            vm.airportLatitude = payload.title.data.airport_latitude;
                            vm.airportLongitude = payload.title.data.airport_longitude;
                        }

                        vm.dropaddressChange = true;
                        vm.pickaddressChange = true;
                        vm.dataToFill.previousDropFlag = false;
                        vm.dataToFill.previousDropFlag = false;
                        if (!vm.modifyFalg || vm.getFixedRoutesForPersonalFlag)
                            getFixedRoutesForPersonal(vm.dataToFill);
                    } else if (payload.title.status == 800) {
                        // vm.dataToFill.dropOffAddress = '';
                        vm.dataToFill.dropOffLng = '';
                        vm.dataToFill.dropOffLat = '';
                        vm.dataToFill.dropOffAddress = '';
                        vm.dataToFill.pickUpLng = '';
                        vm.dataToFill.pickUpLat = '';
                        // vm.dataToFill.pickUpAddress = '';
                        vm.ErrorFlagForNewApi = true;
                        vm.ErrorFlagForNewApiMessage = payload.title.message;
                        openPopForErrorAddress(payload);
                    } else {
                        // vm.dataToFill.dropOffAddress = '';
                        vm.dataToFill.dropOffLng = '';
                        // vm.dataToFill.dropOffAddress = '';
                        vm.dataToFill.pickUpLng = '';
                        vm.dataToFill.dropOffLat = '';
                        vm.dataToFill.pickUpLat = '';
                        // vm.dataToFill.pickUpAddress = '';
                        vm.ErrorFlagForNewApi = true;
                        vm.ErrorFlagForNewApiMessage = payload.title.message;
                        // setTimeout(function () {
                        //     vm.ErrorFlagForNewApi = false;
                        //     vm.ErrorFlagForNewApiMessage = '';
                        //     $scope.$apply();
                        // }, 5000);
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    $scope.items.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function openPopForErrorAddress(data) {
            vm.items = {
                data: data.title.message
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                // targetEvent: $event,
                templateUrl: 'app/components/dialogViews/errorForCreateBooking.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });

            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    if(!$scope.$$phase) {
                        $mdDialog.hide();
                        vm.dataToFill.serviceTypeSelected = '';
                        vm.loading = false;
                    }
                };
                $scope.confirmUpload = function () {}
            }
        }

        function openPopForWaringMessage(trip) {
            vm.items = {
                trip: trip
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                // targetEvent: $event,
                templateUrl: 'app/components/dialogViews/waringMessageForCreateBooking.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });

            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {}
            }
        }
    }



})();

/**
 * Created by cl-macmini-51 on 5/20/17.
 */
 (function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('CreateBookingController', CreateBookingController);

    /** @ngInject */
    function CreateBookingController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document, moment, getCustomers, $scope, getBookings,
        RutHelper, errorMessageFactory, languageBasedErrorFactory, adminAccessService, hidePublicPlaces, pendingRequests, getCorporate, getAgreement, checkDomain, tmhDynamicLocale, quickSaleService, getFilters, Initializer, calenderTranslate, sharedRouteAssignment) {
        var vm = this;
        tmhDynamicLocale.set('en');
        vm.crossFlag = false;
        // GET USER TYPE FROM COOKIES
        vm.userType = $cookies.get('adminType') || 0;
        vm.modifyFalgNew = false;
        vm.discard_booking_flag = 0;
        vm.getFixedRoutesForPersonalFlag = false;
        vm.selectFavAddressNewPop = selectFavAddressNewPop;
        vm.pickUpaddressBlack = pickUpaddressBlack;
        vm.dropOfdAddressBlack = dropOfdAddressBlack;
        vm.ErrorFlagForNewApi = false;
        vm.flagForMarkFavAddress = false;
        vm.dateOptions = {};
        vm.CreateBookingNew = CreateBookingNew;
        vm.pickUpAddressBlank = pickUpAddressBlank;
        vm.dropOffAddressBlank = dropOffAddressBlank;
        vm.flagForPanel = true;
        vm.toAirportFlag = true;
        vm.fromAirportFlag = false;
        vm.ptopAirportFlag = false;
        vm.checkBoxCheck = false;
        vm.forTabsView = forTabsView;
        // vm.dropTimeChangedForRType = dropTimeChangedForRType;
        vm.disabledPaymentMethod = false;
        vm.couponFlag = false;
        vm.roundTripTImeLess = false;
        vm.dropaddressChange = false;
        vm.grantedCheckbox = false;
        vm.viaControlledFLag = false;
        vm.pickaddressChange = false;
        vm.checkBoxValue = checkBoxValue;
        vm.funcationif = funcationif;
        vm.flagForEditBooking = false;
        vm.disableAgreementService = false;
        vm.disabledNumberOfpassengerByCount = false;
        vm.isEmpDataChange = false; // TV-2378



        var zoomLevel = 12;
        vm.flightFLag = true;
        vm.getInfoFlag = false;
        vm.pickupFromToTimeChanged = pickupFromToTimeChanged;
        vm.returnDateChange = returnDateChange;
        vm.tillDateChange = tillDateChange;
        vm.disabledRoundTrip = false;
        vm.modifyBooking = false;
        vm.posBookingFlag = false;
        vm.scheduleFlag = false;
        ////////////////////////// CHECK STATUS FOR BWR BOOKING TICKET N0 2605 /////////////////////////
        vm.CheckBookingStatus = CheckBookingStatus;
        var all_overlays = [];
        vm.modifyFalg = false;
        vm.flagHelp = false;
        vm.flagForAirline = false;
        vm.math = window.Math;
        vm.personalFlag = false;
        vm.flagForFlightNumber = false;
        vm.flagForFlightDate = false;
        vm.flagForFlightType = false;
        vm.PickUpAddressLength = PickUpAddressLength;
        vm.DropUpAddressLength = DropUpAddressLength;
        vm.MarkfavouriteAddressPickUp = MarkfavouriteAddressPickUp;
        vm.MarkfavouriteAddressDrop = MarkfavouriteAddressDrop;
        // VARIABLES AND FUNCTIONS FOR MODIFY SPECIAL FARE - TV-1703
        vm.showEstimatePriceInHtml = showEstimatePriceInHtml;
        vm.showEstimatePriceForRoundTripInHtml = showEstimatePriceForRoundTripInHtml;
        vm.showEstimatePriceForFixedPriceInHtml = showEstimatePriceForFixedPriceInHtml;
        vm.clickFunction = clickFunction;
        vm.finalAdjustedPriceFromAdmin = 0;

        vm.viaControlled1 = 0;
        var coordinates_array = [];
        var markers = [];
        vm.hstep = 1;
        vm.mstep = 15;
        vm.ismeridian1 = false;
        var mapProp = {};
        vm.type_of_trip1;
        vm.type_of_trip;
        vm.viaControlledFLag;
        vm.viaControlledFLag1;
        vm.viaControlled2 = 0;
        var drawingManager = '';
        var mc = null;
        vm.return_flag;
        var map = null;
        // vm.corporate = corporate;
        vm.corporateOffset = 0;
        vm.agreementOffset = 0;
        vm.globalLimit = 50;
        vm.globalOffset = vm.globalLimit;
        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'vehicle', 'service', 'agreement', 'corporatesList', 'operation_point'];
        vm.corporatesList = [];
        vm.corporatesList.push({
            company_name: 'Todos',
            id: 'all'
        });

        vm.agreement = [];
        vm.agreement.push({
            name: 'Todos',
            id: 'all'
        });

        vm.isActivePick = false; // FOR PICK  UP FAVROITE ADDRESSS 
        vm.isActiveDrop = false; // FOR DROP FAVROITE ADDRESSS
        vm.errorDateRT = false;
        // ********** INSERT INTO ARRAY AT PARTICULAR POSITION **********
        Array.prototype.insert = function (index, item) {
            this.splice(index, 0, item);
        };

        // =================== FILTER OBJECT ===================
        vm.filterObject = {
            access_token: $cookies.get('obj'),
            branch_filter: 0,
            vehicle_filter: 0,
            service_filter: 0,
            agreement_filter: 1,
            corporate_filter: 1,
            service_category: 0,
            corporate_status: 2,
            agreement_status: 1,
            vehicle__status: 0,
            operation_point_filter: 0,
            branch_limit: 0,
            branch_offset: 0,
            agreement_limit: vm.globalLimit,
            agreement_offset: vm.agreementOffset,
            corporate_limit: vm.globalLimit,
            corporate_offset: vm.corporateOffset,
            branch_search_filter: 0,
            vehicle_search_filter: 0,
            service_search_filter: 0,
            agreement_search_filter: 0,
            corporate_search_filter: 0,
            operation_point_search_filter: 0
        }
        var icon = {};
        var bounds;
        var geocoder;
        var location = "";
        var currentId = 0;
        var laArray = [];
        var poly = '';
        vm.selectDay = selectDay;
        var uniqueId = function () {
            return ++currentId;
        };
        var infowindow;
        var directionsService;
        var directionsDisplay;
        vm.dateOptions = {};
        var myCenter;
        var restriccion_flota;
        var sucursal_id;
        var ciclosFuncion = 0;
        var ciclosFuncionRt = 0;
        var bloqueUsado = {};
        var bloqueUsadoRt = {};
        var originalPassengerCount = 0;
        var originalBranch = 0;
        var originalTypeOfService = 0;
        // Service To Get Map Instance
        Initializer.mapsInitialized
            .then(function () {
                console.log('>>>> GOOGLE INIT', google);
                if (google) {
                    myCenter = new google.maps.LatLng(-33.447487, -70.673676);
                    bounds = new google.maps.LatLngBounds();
                    geocoder = new google.maps.Geocoder();
                    infowindow = new google.maps.InfoWindow({
                        size: new google.maps.Size(150, 50)
                    });
                    // directionsService = new google.maps.DirectionsService;
                    directionsDisplay = new google.maps.DirectionsRenderer;
                    google.maps.event.addListener(infowindow, 'domready', function () {
                        var iwOuter = $('.gm-style-iw');
                        var iwBackground = iwOuter.prev();
                        iwOuter.css({
                            top: '36px',
                            left: '20px'
                        });
                        iwOuter.children().children(':nth-child(1)').css({
                            'overflow': 'hidden',
                            padding: '18px'
                        });
                        // Remove the background shadow DIV
                        iwBackground.children(':nth-child(2)').css({
                            'display': 'none'
                        });
                        // Remove the white background DIV
                        iwBackground.children(':nth-child(4)').css({
                            'display': 'none'
                        });
                        iwBackground.children(':nth-child(3)').find('div').children().css({
                            'background-color': 'cornsilk',
                            'box-shadow': 'none'
                        });
                        var iwCloseBtn = iwOuter.next();
                        // Apply the desired effect to the close button
                        iwCloseBtn.css({
                            right: '52px',
                            top: '62px', // button repositioning
                            backgound: 'none'
                        });
                        // The API automatically applies 0.7 opacity to the button after the mouseout event.
                        // This function reverses this event to the desired value.
                        iwCloseBtn.mouseout(function () {
                            $(this).css({
                                opacity: '1'
                            });
                        });
                        $('#confirmDriver').off('click').on('click', function (event) {
                            vm.dataToFill.nearDriver = vm.markerFleetID;
                            infowindow.close();
                        });
                        $('#cancelDriver').off('click').on('click', function (event) {
                            vm.dataToFill.nearDriver = '';
                            infowindow.close();
                        });

                    });

                } else {
                    alert(languageBasedErrorFactory.getProperErrorMessage('onRoadMessage', 0, '3'));
                }

            });
        vm.returnDateOptions = {};

        vm.dateOption = {};
        vm.datePicker_1 = {
            scheduledDate: false,
            returnDate: false
        };
        vm.datePicker_2 = {
            tillDate: false
        };
        // vm.corporate = corporate;
        vm.corporateOffset = 0;
        vm.agreementOffset = 0;
        vm.globalLimit = 50;
        vm.globalOffset = vm.globalLimit;
        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'vehicle', 'service', 'agreement', 'corporatesList', 'operation_point'];
        vm.corporatesList = [];
        vm.corporatesList.push({
            company_name: 'Todos',
            id: 'all'
        });

        vm.agreement = [];
        vm.agreement.push({
            name: 'Todos',
            id: 'all'
        });


        // =================== FILTER OBJECT ===================
        vm.filterObject = {
            access_token: $cookies.get('obj'),
            branch_filter: 0,
            vehicle_filter: 0,
            service_filter: 0,
            agreement_filter: 1,
            corporate_filter: 1,
            service_category: 0,
            corporate_status: 2,
            agreement_status: 1,
            vehicle__status: 0,
            operation_point_filter: 0,
            branch_limit: 0,
            branch_offset: 0,
            agreement_limit: vm.globalLimit,
            agreement_offset: vm.agreementOffset,
            corporate_limit: vm.globalLimit,
            corporate_offset: vm.corporateOffset,
            branch_search_filter: 0,
            vehicle_search_filter: 0,
            service_search_filter: 0,
            agreement_search_filter: 0,
            corporate_search_filter: 0,
            operation_point_search_filter: 0
        }
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.tformat = vm.formats[0];
        vm.altInputFormats = ['M!/d!/yyyy'];
        vm.altInputFormat = ['M!/d!/yyyy'];
        vm.loading = false;
        vm.Flag;
        vm.createBookingApi = createBookingApi;
        vm.createBookingByPass = createBookingByPass;
        vm.onSelectingCustomer = onSelectingCustomer;
        vm.onSelectingPerson = onSelectingPerson;
        vm.bookingFor = bookingFor;
        vm.mapInitialize = mapInitialize;
        vm.showGoogleMap = false;
        vm.addressChange = false;
        vm.placeMarker = placeMarker;
        vm.numberOfPassenger = numberOfPassenger;
        vm.bookingType = bookingType;
        vm.datePickerE_New = datePickerE_New;
        vm.datePickerE_2 = datePickerE_2;
        vm.scheduleTimeChanged = scheduleTimeChanged;
        vm.retunrTimeChanged = retunrTimeChanged;
        vm.tillTimes = tillTimes;
        vm.setBooleans = setBooleans;
        vm.datePickerE_1 = datePickerE_1;
        vm.profileChanges = profileChanges;
        vm.agreementTypeChanged = agreementTypeChanged;
        vm.serviceTypeChanged = serviceTypeChanged;
        vm.matchPassword = matchPassword;
        vm.matchPasswordAgain = matchPasswordAgain;
        vm.addNewCustomer = addNewCustomer;
        vm.addNewPerson = addNewPerson;
        vm.pickFavAddress = pickFavAddress;
        vm.dropFavAddress = dropFavAddress;
        vm.rutChange = rutChange;
        vm.getPreviousAddressHit = getPreviousAddressHit;
        vm.selectPreviousAddress = selectPreviousAddress;
        vm.scheduleDateChanged = scheduleDateChanged;
        vm.removeSelectedDriver = removeSelectedDriver;
        vm.passengerRutChange = passengerRutChange;
        vm.applicantRutChange = applicantRutChange;
        vm.searchCustomer = searchCustomer;
        vm.searchPerson = searchPerson;
        vm.selectingItemOfCharges = selectingItemOfCharges;
        vm.addEndowment = addEndowment;
        vm.applyCoupon = applyCoupon;
        vm.dropDateChanged = dropDateChanged;
        vm.dropDateReturnChanged = dropDateReturnChanged;
        vm.dropTimeChanged = dropTimeChanged;
        vm.dropTimeReturnChanged = dropTimeReturnChanged;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.passwordMatchFlag = false;
        vm.newCustomerFlag = false;
        vm.makePhoneEditAble = true;
        vm.days = false;
        vm.favAddFlag = false;
        vm.favAddFlagI = {
            'width': '100%'
        };
        vm.crossButton = {
            'left': '529px'
        }
        vm.favAddFlagB = {
            'width': '0%'
        };
        //vm.customerProfileOption = [];
        vm.bookingTypeOptions = [];
        vm.previousAddressList = [];
        vm.nearByDriver = [];
        vm.disableSubmitButton = false;
        vm.fullCuota = false;
        vm.dataToFill = {
            first_name: '',
            last_name: '',
            password: '',
            confirmPassword: '',
            country_code: '+56',
            ReturnEstimatedDistance: 0,
            etaScheduleValueReturn: 0,
            timeZone: new Date().getTimezoneOffset(),
            customerMobile: '',
            customerMobileG: '',
            customerEmail: '',
            customerId: '',
            previousCustomerId: '',
            customerProfile: '1',
            passengerCount: '',
            bookingFor: 0,
            allowBookingWithoutRequest: 0,
            personName: '',
            personEmail: '',
            personMobile: '',
            otherBooking: false,
            carType: '',
            reference_point: '',
            pickUpAddress: '',
            dropOffAddress: '',
            pickUpLat: '',
            pickUpLng: '',
            dropOffLat: '',
            dropOffLng: '',
            numberOfPassengerError: false,
            numberOfPassengerCount: 0,
            bookingType: '',
            scheduledBooking: '',
            currentBooking: '',
            reaccurringBooking: false,
            roundTrip: false,
            scheduledDate: new Date(),
            scheduledTime: new Date(),
            dropDate: new Date(),
            dropDateReturn: new Date(),
            dropTimeReturn: new Date(),
            dropDateOfRType: new Date(),
            dropTimeOfRtype: new Date(),
            dropTime: new Date(),
            tillDate: '',
            tillTime: new Date(),
            contractIdSelected: '',
            serviceTypeSelected: '',
            corporate_account_id: '',
            route_id: '',
            route_type: '',
            type_of_agreement: '',
            is_wait_time_included: false,
            favPickLocId: '',
            favDropLocId: '',
            returnDate: new Date(),
            returnTime: new Date(),
            itemOfChargeList: [],
            itemOfChargeSelected: [],
            authRequired: '',
            authRUT: '',
            rutFlag: false,
            auther_id: '',
            employeeId: '',
            customerContarctId: '',
            contractList: [],
            contractListShowing: [],
            is_item_of_charges: 0,
            item_of_charges: [],
            bookingId: $stateParams.id,
            previousPickFlag: false,
            previousDropFlag: false,
            nearDriver: '',
            payment_method: '',
            passengerRutCheck: 0,
            applicantRutCheck: 0,
            costCenterCheck: 0,
            costSubCenterCheck: 0,
            RolCheck: 0,
            graphCheck: 0,
            workOrderCheck: 0,
            pepCheck: 0,
            purposeOfTripCheck: 0,
            noOfVoucherCheck: 0,
            nominaCheck: 0,
            solictudCheck: 0,
            passengerRut: '',
            applicantRut: '',
            costCenter: '',
            costSubCenter: '',
            Rol: '',
            graph: '',
            workOrder: '',
            pep: '',
            purposeOfTrip: '',
            noOfVoucher: '',
            nomina: '',
            solictud: '',
            passengerRUTError: false,
            applicantRUTError: false,
            observations: '',
            etaSchedule: '',
            estimatedDistance: '',
            estimatedFare: '',
            estimatedFareRoute: '',
            estimatedFareVariable: '',
            onlyPrice:'',
            minimumFare: 0,
            airportCheck: '',
            discounts: [],
            couponValidation: false,
            roundTripDiscount: 0,
            webDiscount: 0,
            couponApplied: false,
            couponCode: '',
            paymentMethodList: [],
            selectedServiceDetails: '',
            viaControlled: 0,
            viaControlledReal: 0,
            viaControlledApply: false,
            controlledWayCheck: 0,
            controllerWayTarifa: 0,
            etaScheduleValue: 0,
            is_vip: '',
            is_POS_booking: 0,
            payment_status: 0,
            created_by_admin: 0,
            time_trip_shared_service: 0
        };
        vm.pickAddressFlag = false;
        vm.dropAddressFlag = false;
        vm.dataToFill.Return_policy = {
            first_name: '',
            last_name: '',
            password: '',
            confirmPassword: '',
            country_code: '+56',
            timeZone: new Date().getTimezoneOffset(),
            customerMobile: '',
            customerMobileG: '',
            customerEmail: '',
            customerId: '',
            previousCustomerId: '',
            customerProfile: '0',
            passengerCount: '',
            bookingFor: 0,
            personName: '',
            personEmail: '',
            personMobile: '',
            otherBooking: false,
            carType: '',
            reference_point: '',
            pickUpAddress: '',
            dropOffAddress: '',
            pickUpLat: '',
            pickUpLng: '',
            dropOffLat: '',
            dropOffLng: '',
            numberOfPassengerError: false,
            numberOfPassengerCount: 0,
            bookingType: '',
            scheduledBooking: '',
            currentBooking: '',
            reaccurringBooking: false,
            roundTrip: false,
            scheduledDate: new Date(),
            scheduledTime: new Date(),
            dropDate: new Date(),
            dropTime: new Date(),
            tillDate: '',
            tillTime: new Date(),
            contractIdSelected: '',
            serviceTypeSelected: '',
            corporate_account_id: '',
            route_id: '',
            route_type: '',
            type_of_agreement: '',
            is_wait_time_included: false,
            favPickLocId: '',
            favDropLocId: '',
            returnDate: new Date(),
            returnTime: new Date(),
            itemOfChargeList: [],
            itemOfChargeSelected: [],
            authRequired: '',
            authRUT: '',
            rutFlag: false,
            auther_id: '',
            employeeId: '',
            customerContarctId: '',
            contractList: [],
            contractListShowing: [],
            is_item_of_charges: 0,
            item_of_charges: [],
            bookingId: $stateParams.id,
            previousPickFlag: false,
            previousDropFlag: false,
            nearDriver: '',
            payment_method: '',
            passengerRutCheck: 0,
            applicantRutCheck: 0,
            costCenterCheck: 0,
            costSubCenterCheck: 0,
            RolCheck: 0,
            graphCheck: 0,
            workOrderCheck: 0,
            pepCheck: 0,
            purposeOfTripCheck: 0,
            noOfVoucherCheck: 0,
            nominaCheck: 0,
            solictudCheck: 0,
            passengerRut: '',
            applicantRut: '',
            costCenter: '',
            costSubCenter: '',
            Rol: '',
            graph: '',
            workOrder: '',
            pep: '',
            purposeOfTrip: '',
            noOfVoucher: '',
            nomina: '',
            solictud: '',
            passengerRUTError: false,
            applicantRUTError: false,
            observations: '',
            etaSchedule: '',
            estimatedDistance: '',
            estimatedFare: '',
            estimatedFareRoute: '',
            estimatedFareVariable: '',
            minimumFare: 0,
            airportCheck: '',
            discounts: [],
            couponValidation: false,
            roundTripDiscount: 0,
            webDiscount: 0,
            couponApplied: false,
            couponCode: '',
            paymentMethodList: [],
            selectedServiceDetails: '',
            viaControlled: 0,
            viaControlledReal: 0,
            viaControlledApply: false,
            controlledWayCheck: 0,
            etaScheduleValue: 0,
            is_vip: '',
            is_POS_booking: 0,
            payment_status: 0,
            created_by_admin: 0,
            time_trip_shared_service: 0
        }
        vm.filterData = {
            filter_pickup_from_date_value: new Date(),
            filter_pickup_from_time_value: new Date,
        }
        vm.changeFlightType = flightTypeChange;
        vm.changeVip = changeVip;
        var d = new Date();
        d.getHours;
        d.getMinutes;
        vm.minValue = d;
        vm.newPersonFlag = false;
        vm.is_vip = false;
        vm.accessVerifyToggle = accessVerifyToggle;
        // vm.minValue = new Date();
        vm.bookingForOptions = [{
            name: 'Para mi',
            value: 0
        },
        {
            name: 'Para alguien más',
            value: 1
        }
        ];

        if (!$stateParams.id) {
            vm.dataToFill.scheduledTime.setMinutes(vm.dataToFill.scheduledTime.getMinutes() + 35);
            vm.dataToFill.dropTime.setMinutes(vm.dataToFill.dropTime.getMinutes() + 35);
            vm.dataToFill.dropTimeOfRtype.setMinutes(vm.dataToFill.dropTimeOfRtype.getMinutes() + 35);
        }

        vm.hstep = 1;
        vm.mstep = 15;
        vm.ismeridian = false;
        // document.getElementById("googleMap").style.height = window.innerHeight - 200 + 'px';

        vm.hsteps = 1;
        vm.msteps = 15;
        vm.ismeridians = false;
        vm.disabledSubmitButton = true;
        if (!$stateParams.id) {
            if (JSON.parse($cookies.get('adminType') || 0) == 0)
                getSpotAgreement();
        }

        function accessVerifyToggle(buttonName) {
            vm.loading = true;
            var promise = adminAccessService.checkStateValid(buttonName); //$stateParams.id
            return promise.then(
                function (payload) {
                    vm.loading = false;
                    console.log(payload);
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (!payload.title.data.granted) {

                            // languageBasedErrorFactory.getProperErrorMessage('optionNotAvail', 0, 0);
                            // errorMessageFactory.showErrorMessage(' No está autorizado para usar esta opción',0);
                            return false;
                        } else {
                            vm.loading = false;
                            vm.grantedCheckbox = true;
                            // vm.showCheckbox = true;
                            // setBooleans(id , value , panelType , buttonName , index);
                            // $timeout(function (){

                            // },500)

                            // setFlagInJob(id, type)
                            // return true;
                        }
                    }
                },
                function (errorPayload) {
                    console.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        accessVerifyToggle('BWR');

        function rutChange() {
            $log.log('data', vm.dataToFill.authRUT);
            if (vm.dataToFill.authRUT) {
                if (RutHelper.validate(vm.dataToFill.authRUT)) {
                    $log.log();
                    vm.dataToFill.rutFlag = false;
                } else {
                    vm.dataToFill.rutFlag = true;
                }
            } else if (vm.dataToFill.authRUT === null) {
                vm.dataToFill.rutFlag = true;
            } else if (vm.dataToFill.authRUT === undefined) {
                vm.dataToFill.rutFlag = false;
            }
        }
        vm.getDateTime = new Date().getDate();
        vm.getMonthTime = new Date().getMonth();
        vm.getYearTime = new Date().getFullYear();
        vm.Time = new Date().getTime();
        vm.TimeChange = function () {
            var a = new Date(vm.filterData.filter_pickup_from_date_value);
            if (vm.type_of_trip1 != 'R' && a.getDate() == vm.getDateTime && a.getMonth() == vm.getMonthTime && a.getFullYear() == vm.getYearTime) {
                return vm.Time;
            } else {
                return null;
            }

        }


        function flightTypeChange(data) {
            if (data == 'I') {
                vm.international = 'I';
                vm.flightFLag = true;
                //console.log("i m in if ");

            } else {
                vm.international = null;
                vm.flightFLag = false;
                vm.national = 'N';
                //console.log("i m in else ");
            }
        }


        vm.dateOptions = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(2090, 12, 31),
            //minDate: new Date(),
            startingDay: 1,
            showWeeks: false,

        };

        function showFilterTime(type) {
            var x = new Date();
            if (type == 1) {
                x.setHours('00');
                x.setMinutes('00');
                x.setSeconds('00');
            } else if (type == 2) {
                var currentHrs = x.getHours();
                var nextTwelveHrs = currentHrs + 12;
                var currentMins = x.getMinutes();
                x.setHours(nextTwelveHrs);
                x.setMinutes(currentMins);
                x.setSeconds('00');
            }
            return x;
        }







        function datePickerE_New(type) {
            if (type == 1) {
                //console.log("heelo i m here");

                vm.datePicker_1.pickupFromDate = true;


            }


        };

        //     vm.pickupFromToDateChanged = function(data){
        //         if(data==1){
        //             vm.TimeChange  = new Date(vm.filterData.filter_pickup_from_date_value);
        //             //console.log(vm.TimeChange,'askjdhaskjdhaskhdaskdhkasj');
        //         }
        //    }

        // vm.TimeChange =   function(){
        //     var a = new Date(vm.filterData.filter_pickup_from_date_value);
        //     var b = new Date();
        //     if(a.getDate() == b.getDate() && a.getMonth() == b.getMonth()  && a.getFullYear() == b.getFullYear() ){
        //          return new Date();
        //     }
        // }



        function passengerRutChange() {
            $log.log('data', vm.dataToFill.passengerRut);
            if (vm.dataToFill.passengerRut) {
                if (RutHelper.validate(vm.dataToFill.passengerRut)) {
                    vm.dataToFill.passengerRUTError = false;
                } else {
                    vm.dataToFill.passengerRUTError = true;
                }
            } else if (vm.dataToFill.passengerRut === null) {
                vm.dataToFill.passengerRUTError = true;
            } else if (vm.dataToFill.passengerRut === undefined) {
                vm.dataToFill.passengerRUTError = false;
            }
        }




        function applicantRutChange() {
            $log.log('data', vm.dataToFill.applicantRut);
            if (vm.dataToFill.applicantRut) {
                if (RutHelper.validate(vm.dataToFill.applicantRut)) {
                    vm.dataToFill.applicantRUTError = false;
                } else {
                    vm.dataToFill.applicantRUTError = true;
                }
            } else if (vm.dataToFill.applicantRut === null) {
                vm.dataToFill.applicantRUTError = true;
            } else if (vm.dataToFill.applicantRut === undefined) {
                vm.dataToFill.applicantRUTError = false;
            }
        }

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.go('layout.createBookingMain.createBooking');
            }
        });

        //=======================password match function====================
        function matchPassword(data) {
            if (data) {
                if (data != vm.dataToFill.password) {
                    vm.passwordMatchFlag = true;
                } else {
                    vm.passwordMatchFlag = false;
                }
            } else {
                vm.passwordMatchFlag = false;
            }
        };

        function matchPasswordAgain(data) {
            if (data && vm.dataToFill.confirmPassword) {
                if (data != vm.dataToFill.confirmPassword) {
                    vm.passwordMatchFlag = true;
                } else {
                    vm.passwordMatchFlag = false;
                }
            } else {
                vm.passwordMatchFlag = false;
            }
        };

        //========================add new customer========================
        function addNewCustomer() {
            vm.newCustomerFlag = true;
            vm.makePhoneEditAble = false;
            vm.dataToFill.customerMobileG = '';
            vm.dataToFill.customerId = '';
            vm.dataToFill.previousCustomerId = '';
            vm.dataToFill.customerEmail = '';
            vm.dataToFill.employeeId = '';
            // vm.dataToFill.customerProfile = '0';
            if (vm.disableAgreementService == true) {
                vm.dataToFill.customerProfile = vm.bookingDetails.creator_profile;
            } else {
                // THIS CHECK IS FOR PET USER BECAUSE PET USER CAN ONLY MAKE CORPORATE BOOKING
                if (JSON.parse($cookies.get('adminType') || 0) == 1) {
                    vm.dataToFill.customerProfile = '1';
                } else {
                    vm.dataToFill.customerProfile = '0';
                }
            }
            //vm.dataToFill.contractIdSelected = '';
            vm.dataToFill.previousPickFlag = false;
            vm.dataToFill.previousDropFlag = false;
            vm.isEmpDataChange = false; // TV-2378
            //vm.customerProfileOption = [
            //    {
            //        name: 'Personal',
            //        value: 0
            //    },
            //    {
            //        name: 'Corporate',
            //        value: 1
            //    }
            //];
        };

        //========================add new Person========================
        function addNewPerson() {
            vm.newPersonFlag = true;
            vm.makePersonPhoneEditAble = false;
            vm.dataToFill.personSelected = '';
            vm.dataToFill.personName = '';
            vm.dataToFill.personEmail = '';
            vm.dataToFill.passengerId = null;
            vm.dataToFill.personMobile = '';
        };

        //========================search customer=========================
        function searchCustomer(data) {
            //console.log(data, "puneet");
            if (data && vm.dataToFill.customerMobile.length > 3) {
                //return vm.allCustomersList;
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.search_id = data.toString();
                var promise = getCustomers.getCustomerAccordingToSearch(dataSend);
                //console.log(promise);
                return promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        if (payload.title.status == 400) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            return [];
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                            return [];
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            if (payload)
                                return payload.title.data;
                            else return [];
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            //errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                        }
                    }
                );
            } else {
                return [];
            }
        };

        //======================== SEARCH PERSON =========================
        function searchPerson(data) {
            if (data) {
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.search_value = data.toString();
                dataSend.limit = 50;
                dataSend.offset = 0;
                if (vm.dataToFill.contractIdSelected > 0) {
                    dataSend.contract_id = vm.dataToFill.contractIdSelected;
                    var promise = getCustomers.getPersonAccordingToSearch(dataSend);
                    return promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            vm.loading = false;
                            if (payload.title.status == 400) {
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                                return [];
                            } else if (payload.title.status == 401) {
                                errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                                return [];
                            } else if (payload.title.status == 201 || payload.title.status == 200) {
                                vm.is_vip = false;
                                vm.dataToFill.personName = '';
                                vm.dataToFill.personEmail = '';
                                vm.dataToFill.personMobile = '';
                                vm.dataToFill.passengerId = null;
                                if (payload) {
                                    if (vm.employeeId)
                                        var index = _.findIndex(payload.title.data.employee_data, {
                                            employee_id: vm.employeeId
                                        });
                                    //console.log('>>>>>>>>>>> INDEX >>>>>>>>>>>>>', index, vm.employeeId);
                                    if (vm.employeeId && index > -1) {
                                        payload.title.data.employee_data.splice(index, 1);
                                    }
                                    return payload.title.data.employee_data;
                                } else return [];
                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                //errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                            }
                        }
                    );
                } else {
                    errorMessageFactory.showErrorMessage('Por favor seleccione acuerdo', 0);
                }
            } else {
                return [];
            }
        };

        //============================get all customers=============================
        function getAllCustomers(skip, limit, id) {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit;
            dataSend.offset = skip;
            dataSend.search_filter = 0;
            dataSend.customer_id = id;
            var promise = getCustomers.allCustomers(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (payload.title.data.result) {
                            vm.allCustomersList = payload.title.data.result;
                            for (var i = 0; i < vm.allCustomersList.length; i++) {
                                vm.allCustomersList[i].name = vm.allCustomersList[i].first_name + ' ' + vm.allCustomersList[i].last_name;
                            }
                        } else {
                            vm.allCustomersList = [];
                        }

                        if ($stateParams.id)
                            getSingleBooking($stateParams.id);
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        if ($stateParams.id)
            getAllCustomers(0, 0, $stateParams.custId);
        //========================splice=======================
        vm.daysList = {
            sunday: {
                value: '',
                selected: false
            },
            monday: {
                value: '',
                selected: false
            },
            tuesday: {
                value: '',
                selected: false
            },
            wednesday: {
                value: '',
                selected: false
            },
            thursday: {
                value: '',
                selected: false
            },
            friday: {
                value: '',
                selected: false
            },
            saturday: {
                value: '',
                selected: false
            }
        };

        function selectDay(value) {
            ////console.log('asdasdasdsa',vm.daysList)
            switch (value) {
                case 'Sunday':
                    if (!vm.daysList.sunday.selected) {
                        vm.daysList.sunday.value = 0;
                    } else {
                        vm.daysList.sunday.value = '';
                    }
                    break;
                case 'Monday':
                    if (!vm.daysList.monday.selected) {
                        vm.daysList.monday.value = 1;
                    } else {
                        vm.daysList.monday.value = '';
                    }
                    break;
                case 'Tuesday':
                    if (!vm.daysList.tuesday.selected) {
                        vm.daysList.tuesday.value = 2;
                    } else {
                        vm.daysList.tuesday.value = '';
                    }
                    break;
                case 'Wednesday':
                    if (!vm.daysList.wednesday.selected) {
                        vm.daysList.wednesday.value = 3;
                    } else {
                        vm.daysList.wednesday.value = '';
                    }
                    break;
                case 'Thursday':
                    if (!vm.daysList.thursday.selected) {
                        vm.daysList.thursday.value = 4;
                    } else {
                        vm.daysList.thursday.value = '';
                    }
                    break;
                case 'Friday':
                    if (!vm.daysList.friday.selected) {
                        vm.daysList.friday.value = 5;
                    } else {
                        vm.daysList.friday.value = '';
                    }
                    break;
                case 'Saturday':
                    if (!vm.daysList.saturday.selected) {
                        vm.daysList.saturday.value = 6;
                    } else {
                        vm.daysList.saturday.value = '';
                    }
                    break;
            };


            // vm.length = vm.dayList.length;
            // vm.dayList.forEach(function(column) {
            //     //console.log('hello11111111111111', value, column.dayList);
            //     if (angular.equals(value, column.dayList)) {
            //         //console.log('hello', column.dayList)
            //         vm.i = column.dayList.indexOf(value);
            //         column.dayList.splice(i, 1);
            //         return false;
            //     }
            //     //console.log("length", vm.length);
            // });
            // if (vm.length == 0) {
            //     vm.dayList.push({
            //         "value": value
            //     })
            // }


            // //console.log('daylist', vm.dayList);
            //console.log(vm.daysList);
        }

        // ************ TO ADD CONTROLLEDVIA FLAG IN ESTIMATE PRICE  **********
        function viaControlledPrice(estimatePrice, controlledVia, typeOfTrip) {
            //  console.log('>>>>>>> IN VIACONTROLLED PRICE >>>>>>', estimatePrice, controlledVia, typeOfTrip);
            var estimatePriceRound = Math.round(estimatePrice);
            if (vm.dataToFill.controllerWayTarifa == 1) {
                if (typeOfTrip == 'Z') {
                    return estimatePriceRound;
                } else {
                    return estimatePriceRound;
                }
            } else {
                if (typeOfTrip == 'Z') {
                    return Math.round(estimatePriceRound + controlledVia);
                } else {
                    return estimatePriceRound;
                }
            }
        }

        function calculateDiscountPercentage(estimatedPrice, controlledVia, typeOfTrip, discountValue, tope_maximo, type) {
            console.log('>>>>>>> IN calculateDiscountPercentage >>>>>>', estimatedPrice, ' vm.dataToFill.itemOfChargeSelected', vm.dataToFill.itemOfChargeSelected, 'type', type);
            if (!discountValue)
                discountValue = 0;
            var estimatePriceRound = Math.round(estimatedPrice);
            if (vm.dataToFill.controllerWayTarifa == 1) {
                if (typeOfTrip == 'Z') {
                    // var newEstimate = estimatePrice;
                    var newEstimate = 0;
                    var itemOfChargePrice = 0;
                    if (vm.dataToFill.itemOfChargeSelected.length > 0) {
                        for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                            if( vm.dataToFill.itemOfChargeSelected[i].retorno == false && type == 'parent'){
                                itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                            } else if(vm.dataToFill.itemOfChargeSelected[i].retorno == true && type==undefined){
                                itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                            }
                        }
                        newEstimate = estimatePriceRound - itemOfChargePrice;
                    } else {
                        newEstimate = estimatePriceRound;
                    }
                    // console.log('>>>>>>> newEstimate >>>>', newEstimate);
                    if(tope_maximo){
                        return Math.round(((newEstimate - tope_maximo)) < 0 ? 0 : ((newEstimate - tope_maximo) + itemOfChargePrice));
                    } else {
                        return Math.round(((newEstimate - Math.round((newEstimate * discountValue) / 100))) < 0 ? 0 : ((newEstimate - Math.round((newEstimate * discountValue) / 100)) + itemOfChargePrice));
                    }
                } else {
                    // var newEstimate = 0;
                    var itemOfChargePrice = 0;
                    if (vm.dataToFill.itemOfChargeSelected.length > 0) {
                        for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                            if( vm.dataToFill.itemOfChargeSelected[i].retorno == false && type == 'parent'){
                                itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                            } else if(vm.dataToFill.itemOfChargeSelected[i].retorno == true && type==undefined){
                                itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                            }
                        }
                        estimatePriceRound = estimatePriceRound - itemOfChargePrice;
                    }
                    if(tope_maximo){
                        return Math.round((estimatePriceRound - tope_maximo) < 0 ? 0 : ((estimatePriceRound - tope_maximo) + itemOfChargePrice));
                    } else {
                        return Math.round((estimatePriceRound - Math.round((estimatePriceRound * discountValue) / 100)) < 0 ? 0 : ((estimatePriceRound - Math.round((estimatePriceRound * discountValue) / 100)) + itemOfChargePrice));
                    }
                }
            } else {
                if (typeOfTrip == 'Z') {
                    // var newEstimate = estimatePrice;
                    // console.log(newEstimate,'newEstimate>?>>>>>>>>>',((newEstimate - (newEstimate * discountValue) / 100) + controlledVia));
                    var newEstimate = 0;
                    var itemOfChargePrice = 0;
                    if (vm.dataToFill.itemOfChargeSelected.length > 0) {
                        for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                            if( vm.dataToFill.itemOfChargeSelected[i].retorno == false && type == 'parent'){
                                itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                            } else if(vm.dataToFill.itemOfChargeSelected[i].retorno == true && type==undefined){
                                itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                            }
                        }
                        newEstimate = estimatePriceRound - itemOfChargePrice;
                    } else {
                        newEstimate = estimatePriceRound;
                    }
                    if(tope_maximo){  
                        return Math.round(((newEstimate - tope_maximo)) < 0 ? 0 : ((newEstimate - tope_maximo) + controlledVia + itemOfChargePrice));
                    } else {
                        return Math.round(((newEstimate - Math.round((newEstimate * discountValue) / 100))) < 0 ? 0 : ((newEstimate - Math.round((newEstimate * discountValue) / 100)) + controlledVia + itemOfChargePrice));
                    }
                } else {
                    var itemOfChargePrice = 0;
                    if (vm.dataToFill.itemOfChargeSelected.length > 0) {
                        // var itemOfChargePrice = 0;
                        for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                            if( vm.dataToFill.itemOfChargeSelected[i].retorno == false && type == 'parent' ){
                                itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                            } else if(vm.dataToFill.itemOfChargeSelected[i].retorno == true && type==undefined){
                                itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                            }
                        }
                        estimatePriceRound = estimatePriceRound - itemOfChargePrice;
                    }
                    if(tope_maximo){ 
                        return Math.round((estimatePriceRound - tope_maximo) < 0 ? 0 : ((estimatePriceRound - tope_maximo) + itemOfChargePrice));
                    } else {
                        return Math.round((estimatePriceRound - Math.round((estimatePriceRound * discountValue) / 100)) < 0 ? 0 : ((estimatePriceRound - Math.round((estimatePriceRound * discountValue) / 100)) + itemOfChargePrice));
                    }
                }
            }
        }

        function calculateDiscountPercentageAmount(estimatedPrice, controlledVia, typeOfTrip, discountValue, type) {
            // console.log('>>>>>>> IN calculateDiscountPercentageAmount >>>>>>>',estimatedPrice,type );
            if (!discountValue)
                discountValue = 0;
            var estimatePriceRound = Math.round(estimatedPrice);
            if (vm.dataToFill.controllerWayTarifa == 1) {
                if (typeOfTrip == 'Z') {
                    var newEstimate = 0;
                    var itemOfChargePrice = 0;
                    if (type == 'parent' && vm.dataToFill.itemOfChargeSelected.length > 0) {
                        for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                            itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                        }
                        newEstimate = estimatePriceRound - itemOfChargePrice;
                    } else {
                        newEstimate = estimatePriceRound;
                    }
                    return Math.round((newEstimate * discountValue) / 100);
                } else {
                    var itemOfChargePrice = 0;
                    if (type == 'parent' && vm.dataToFill.itemOfChargeSelected.length > 0) {
                        for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                            itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                        }
                        estimatePriceRound = estimatePriceRound - itemOfChargePrice;
                    }
                    return Math.round((estimatePriceRound * discountValue) / 100);
                }
            } else {
                if (typeOfTrip == 'Z') {
                    // var newEstimate = estimatePrice;
                    var newEstimate = 0;
                    var itemOfChargePrice = 0;
                    if (type == 'parent' && vm.dataToFill.itemOfChargeSelected.length > 0) {
                        for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                            itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                        }
                        newEstimate = estimatePriceRound - itemOfChargePrice;
                    } else {
                        newEstimate = estimatePriceRound;
                    }
                    return Math.round((newEstimate * discountValue) / 100);
                } else {
                    var itemOfChargePrice = 0;
                    if (type == 'parent' && vm.dataToFill.itemOfChargeSelected.length > 0) {
                        for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                            itemOfChargePrice += Number(vm.dataToFill.itemOfChargeSelected[i].price);
                        }
                        estimatePriceRound = estimatePriceRound - itemOfChargePrice;
                    }
                    return Math.round((estimatePriceRound * discountValue) / 100);
                }
            }
        }

        function calculateDiscountFlat(estimatedPrice, controlledVia, typeOfTrip, discountValue) {
            // console.log('>>>>>> IN calculateDiscountFlat >>>>>>', estimatePrice, controlledVia, typeOfTrip, discountValue);
            if (!discountValue)
                discountValue = 0;
            var estimatePriceRound = Math.round(estimatedPrice);
            if (vm.dataToFill.controllerWayTarifa == 1) {
                if (typeOfTrip == 'Z') {
                    var newEstimate = estimatePriceRound;
                    return Math.round(((newEstimate - discountValue) + controlledVia) < 0 ? 0 : ((newEstimate - discountValue)));
                } else {
                    return Math.round((estimatePriceRound - discountValue) < 0 ? 0 : (estimatePriceRound - discountValue));
                }
            } else {
                if (typeOfTrip == 'Z') {
                    var newEstimate = estimatePriceRound;
                    return Math.round(((newEstimate - discountValue) + controlledVia) < 0 ? 0 : ((newEstimate - discountValue) + controlledVia));
                } else {
                    return Math.round((estimatePriceRound - discountValue) < 0 ? 0 : (estimatePriceRound - discountValue));
                }
            }
        }

        function calculateDiscountFlatAmount(discountValue) {
            return Math.round(discountValue);
        }

        // *************** SHOW ESTIMATE PRICE IN HTML **************
        vm.calculatedEstimatePriceFormFunction = 0;
        vm.calculatedEstimatePriceFormFunctionEstimated = -1;

        function showEstimatePriceInHtml(roundTrip, viaControlledFLag1, viaControlledFLag) {
            if (!vm.click) {
                if (roundTrip == false && viaControlledFLag1 == false && viaControlledFLag == false) {
                    vm.calculatedEstimatePriceFormFunction = vm.math.round(vm.dataToFill.estimatedFare) || 0;
                    // CONDITION TO CHANGE INPUT FIELD VALUE BECAUSE THIS FUNCTION CALLS ON EVERY ACTION ON PAGE
                    if (vm.calculatedEstimatePriceFormFunctionEstimated == -1) {
                        vm.calculatedEstimatePriceFormFunctionEstimated = vm.calculatedEstimatePriceFormFunction;
                    }
                    return true;
                }

                if (roundTrip == false && viaControlledFLag1 == true && viaControlledFLag == false) {
                    vm.calculatedEstimatePriceFormFunction = vm.math.round((vm.dataToFill.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : vm.viaControlled1)) || 0;
                    // CONDITION TO CHANGE INPUT FIELD VALUE BECAUSE THIS FUNCTION CALLS ON EVERY ACTION ON PAGE
                    if (vm.calculatedEstimatePriceFormFunctionEstimated == -1) {
                        console.log(vm.calculatedEstimatePriceFormFunction, 'vm.calculatedEstimatePriceFormFunction');

                        vm.calculatedEstimatePriceFormFunctionEstimated = vm.calculatedEstimatePriceFormFunction;
                    }
                    return true;

                }

                if (roundTrip == false && viaControlledFLag1 == false && viaControlledFLag == true) {
                    vm.calculatedEstimatePriceFormFunction = vm.math.round(vm.dataToFill.estimatedFare) || 0;
                    // CONDITION TO CHANGE INPUT FIELD VALUE BECAUSE THIS FUNCTION CALLS ON EVERY ACTION ON PAGE
                    if (vm.calculatedEstimatePriceFormFunctionEstimated == -1) {
                        vm.calculatedEstimatePriceFormFunctionEstimated = vm.calculatedEstimatePriceFormFunction;
                    }
                    return true;
                }

                if (roundTrip == true && viaControlledFLag1 == false && viaControlledFLag == false) {
                    vm.calculatedEstimatePriceFormFunction = vm.math.round((vm.dataToFill.estimatedFare) + (vm.dataToFill.Return_policy.estimatedFare)) || 0;
                    // CONDITION TO CHANGE INPUT FIELD VALUE BECAUSE THIS FUNCTION CALLS ON EVERY ACTION ON PAGE
                    if (vm.calculatedEstimatePriceFormFunctionEstimated == -1) {
                        vm.calculatedEstimatePriceFormFunctionEstimated = vm.calculatedEstimatePriceFormFunction;
                    }
                    return true;
                }

                if (roundTrip == true && viaControlledFLag1 == true && viaControlledFLag == false) {
                    vm.calculatedEstimatePriceFormFunction = vm.math.round((vm.dataToFill.estimatedFare) + Number(vm.dataToFill.Return_policy.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : vm.viaControlled1)) || 0;
                    // CONDITION TO CHANGE INPUT FIELD VALUE BECAUSE THIS FUNCTION CALLS ON EVERY ACTION ON PAGE
                    if (vm.calculatedEstimatePriceFormFunctionEstimated == -1) {
                        vm.calculatedEstimatePriceFormFunctionEstimated = vm.calculatedEstimatePriceFormFunction;
                    }
                    return true;
                }

                if (roundTrip == true && viaControlledFLag1 == false && viaControlledFLag == true) {
                    vm.calculatedEstimatePriceFormFunction = vm.math.round((vm.dataToFill.estimatedFare) + Number(vm.dataToFill.Return_policy.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : vm.viaControlled2)) || 0;
                    // CONDITION TO CHANGE INPUT FIELD VALUE BECAUSE THIS FUNCTION CALLS ON EVERY ACTION ON PAGE
                    if (vm.calculatedEstimatePriceFormFunctionEstimated == -1) {
                        vm.calculatedEstimatePriceFormFunctionEstimated = vm.calculatedEstimatePriceFormFunction;
                    }
                    return true;
                }
            } else {
                return true;
            }
        }


        // *************** SHOW ESTIMATE PRICE IN HTML FOR ROUND TRIP **************
        vm.calculatedEstimatePriceForRoundTripFormFunction = 0;
        vm.roundTripPercentageAdd = true;

        function showEstimatePriceForRoundTripInHtml(estimateFare, isRoundTrip, viaControlledFLag) {

            if (estimateFare && isRoundTrip == true && viaControlledFLag == false) {
                if (vm.dataToFill.roundTrip == true && vm.calculatedEstimatePriceForRoundTripFormFunction >= 0)
                    vm.calculatedEstimatePriceForRoundTripFormFunction = vm.math.round(vm.dataToFill.Return_policy.estimatedFare) || 0;

                // CONDITION TO CHANGE INPUT FIELD VALUE BECAUSE THIS FUNCTION CALLS ON EVERY ACTION ON PAGE
                if (vm.roundTripPercentageAdd) {
                    // vm.calculatedEstimatePriceFormFunctionEstimated += vm.calculatedEstimatePriceForRoundTripFormFunction;
                    vm.calculatedEstimatePriceFormFunctionEstimated = vm.calculatedEstimatePriceFormFunction;
                    vm.roundTripPercentageAdd = false;
                }
                return true;
            }
            if (estimateFare && isRoundTrip == true && viaControlledFLag == true) {
                if (vm.dataToFill.roundTrip == true && vm.calculatedEstimatePriceForRoundTripFormFunction >= 0)
                    vm.calculatedEstimatePriceForRoundTripFormFunction = vm.math.round(vm.dataToFill.Return_policy.estimatedFare + (vm.dataToFill.controllerWayTarifa ? 0 : vm.viaControlled2)) || 0;

                // CONDITION TO CHANGE INPUT FIELD VALUE BECAUSE THIS FUNCTION CALLS ON EVERY ACTION ON PAGE
                if (vm.roundTripPercentageAdd) {
                    // vm.calculatedEstimatePriceFormFunctionEstimated += vm.calculatedEstimatePriceForRoundTripFormFunction;
                    vm.calculatedEstimatePriceFormFunctionEstimated = vm.calculatedEstimatePriceFormFunction;
                    vm.roundTripPercentageAdd = false;
                }
                return true;
            }
        }

        // *************** SHOW ESTIMATE PRICE IN HTML FOR FIXED PRICE **************
        vm.calculatedEstimatePriceForFixedPriceFormFunction = 0;

        function showEstimatePriceForFixedPriceInHtml(estimateFare, isRoundTrip, viaControlledFLag) {

            if (estimateFare && isRoundTrip == true && viaControlledFLag == false) {

                // CONDITION TO CHANGE INPUT FIELD VALUE BECAUSE THIS FUNCTION CALLS ON EVERY ACTION ON PAGE
                if (vm.dataToFill.roundTrip == true && vm.calculatedEstimatePriceForFixedPriceFormFunction == 0)
                    vm.calculatedEstimatePriceForFixedPriceFormFunction = vm.math.round(vm.dataToFill.estimatedFare) || 0;
                return true;
            }
            if (estimateFare && isRoundTrip == true && viaControlledFLag == true) {

                // CONDITION TO CHANGE INPUT FIELD VALUE BECAUSE THIS FUNCTION CALLS ON EVERY ACTION ON PAGE
                if (vm.dataToFill.roundTrip == true && vm.calculatedEstimatePriceForFixedPriceFormFunction == 0)
                    vm.calculatedEstimatePriceForFixedPriceFormFunction = vm.math.round(vm.dataToFill.estimatedFare + (vm.dataToFill.controllerWayTarifa ? 0 : vm.viaControlled1));
                return true;
            }
        }

        // ***** FUNCTION RUN WHEN USER ADJUST PRICE ********
        vm.click = false;
        vm.finalAdjustedPriceFromAdmin = 0;

        function clickFunction(status) {
            // IF ROUND TRIP IS ON
            // 1703 change 
            console.log(vm.fixedPriceFromSearchFixesVariable - vm.viaControlled1, vm.fixedPriceFromSearchFixesVariable, vm.viaControlled1);

            if (vm.dataToFill.controllerWayTarifa == 1 && vm.type_of_trip_Validate_Booking == 'Z') {
                vm.fixedPriceFromSearchFixesVariable1 = vm.fixedPriceFromSearchFixesVariable - vm.viaControlled1;
            } else {
                vm.fixedPriceFromSearchFixesVariable1 = vm.fixedPriceFromSearchFixesVariable;
            }
            if (vm.dataToFill.controllerWayTarifa == 1 && vm.type_of_trip == 'Z') {
                vm.estimatedFareRouteForRoundTrip1 = vm.estimatedFareRouteForRoundTrip - vm.viaControlled2;
            } else {
                vm.estimatedFareRouteForRoundTrip1 = vm.estimatedFareRouteForRoundTrip;
            }
            // 1703 change 
            if (vm.dataToFill.roundTrip) {
                vm.fixedAmountForAdjustedPrice = vm.fixedPriceFromSearchFixesVariable1 + vm.estimatedFareRouteForRoundTrip1;
            } else {
                vm.fixedAmountForAdjustedPrice = vm.fixedPriceFromSearchFixesVariable1;
            }

            // vm.calculateEstimateFareWithOutControlledVia = vm.calculatedEstimatePriceFormFunction - vm.fixedAmountForAdjustedPrice;
            // 1703 CHeck change 
            // ***** IF ADJUSTED PRICE IS GREATER THAN ESTIMATED PRICE ******
            // if ((status === 'Done') && (vm.fixedAmountForAdjustedPrice > vm.calculatedEstimatePriceFormFunctionEstimated)) {
            // // if ((status === 'Done') && (vm.calculateEstimateFareWithOutControlledVia > vm.calculatedEstimatePriceFormFunctionEstimated)) {
            //     errorMessageFactory.showErrorMessage('Valor ingresado no válido. Valor a pagar no puede ser menor que cero', 0);
            //     return true;
            // }
            function numberWithCommas(x) {
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            };
            if ((status === 'Done') && ((vm.fixedAmountForAdjustedPrice) < (vm.calculatedEstimatePriceFormFunction - vm.calculatedEstimatePriceFormFunctionEstimated))) {
                // errorMessageFactory.showErrorMessage('Error, el descuento no puede ser mayor a $' + (vm.fixedAmountForAdjustedPrice) + ' queel el valor del Tramo', 0);
                errorMessageFactory.showErrorMessage('Error, el descuento no puede ser mayor a $' + numberWithCommas(vm.fixedAmountForAdjustedPrice), 0);
                return true;
            }
            // ***** IF ADJUSTED PRICE IS LESS THAN FIXED PRICE ******
            if ((status === 'Done') && (vm.calculatedEstimatePriceFormFunction < vm.calculatedEstimatePriceFormFunctionEstimated)) {
                errorMessageFactory.showErrorMessage('Error, el monto final no puede ser mayor al original $' + numberWithCommas(vm.calculatedEstimatePriceFormFunction), 0);
                return true;
            }
            vm.click = !vm.click;
            // ****** CHECK WHEN CONFIRM ADJUSTED PRICE *******
            if (status === 'Done') {
                vm.finalAdjustedPriceFromAdmin = (vm.calculatedEstimatePriceFormFunction - vm.calculatedEstimatePriceFormFunctionEstimated) || 0;
                vm.dataToFill.discounts = [];
                vm.dummyDiscountObject = {};

                if (vm.dataToFill.roundTrip == true) {
                    vm.calculatedEstimatePriceForFixedPriceFormFunction -= vm.finalAdjustedPriceFromAdmin / 2;
                    vm.calculatedEstimatePriceForRoundTripFormFunction -= vm.finalAdjustedPriceFromAdmin / 2;
                    vm.dummyDiscountObject.discountType = 0;
                    vm.dummyDiscountObject.discountTypeValue = vm.math.round(vm.finalAdjustedPriceFromAdmin);
                    vm.dummyDiscountObject.promoType = 'adjustedPrice';
                    vm.dummyDiscountObject.finalAmount = vm.math.round(vm.calculatedEstimatePriceForFixedPriceFormFunction);
                    vm.dummyDiscountObject.value = vm.math.round(vm.finalAdjustedPriceFromAdmin / 2);
                    vm.dummyDiscountObject.roundTripFare = vm.math.round(vm.calculatedEstimatePriceForRoundTripFormFunction);
                    vm.dummyDiscountObject.roundFinalAmount = vm.math.round(vm.calculatedEstimatePriceForRoundTripFormFunction);
                    vm.dummyDiscountObject.estimatedFare = vm.math.round(vm.calculatedEstimatePriceForFixedPriceFormFunction + vm.finalAdjustedPriceFromAdmin);
                    vm.dummyDiscountObject.returnValue = vm.math.round(vm.finalAdjustedPriceFromAdmin / 2);
                    vm.dummyDiscountObject.name = 'Special Discount';
                } else {

                    vm.dummyDiscountObject.discountType = 0;
                    vm.dummyDiscountObject.discountTypeValue = vm.finalAdjustedPriceFromAdmin;
                    vm.dummyDiscountObject.promoType = 'adjustedPrice';
                    vm.dummyDiscountObject.finalAmount = vm.calculatedEstimatePriceFormFunctionEstimated;
                    vm.dummyDiscountObject.value = vm.finalAdjustedPriceFromAdmin;
                    vm.dummyDiscountObject.name = 'Special Discount';
                }
                vm.dataToFill.discounts.push(vm.dummyDiscountObject);
            }
        }
        //========================set boolean=======================
        function setBooleans(type, flag, returnFlag) {
            console.log('debug setBooleans', flag);
            // console.log("kahgkdhskjhdkjsdhkahdkhak");

            switch (type) {
                case 'REACCURING_BOOKING':
                    if (vm.disabledRoundTrip == true || vm.CheckBookingStatus(vm.bookingDetails)) {
                        return;
                    }
                    if (vm.dataToFill.reaccurringBooking) {
                        vm.dataToFill.reaccurringBooking = false;
                        if (vm.type_of_trip1 == 'R' && vm.dataToFill.selectedServiceDetails.category == 1 && vm.method_range_pickup && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                            if (vm.pickRangeSendForRouting.length > 0 && vm.etaArray.length > 0) {
                                vm.pickRangeSendForRouting.length = 1;
                                vm.etaArray.length = 1;
                            } else {
                                vm.pickRangeSendForRouting = [];
                                vm.etaArray = [];
                            }
                        }
                        vm.days = false;
                    } else {
                        vm.dataToFill.reaccurringBooking = true;
                        vm.days = true;
                    }
                    break;
                case 'ROUND_TRIP':
                    console.log('debug ROUND_TRIP');
                    if ((vm.disabledRoundTrip == true || vm.CheckBookingStatus(vm.bookingDetails)) && returnFlag === 'return') {
                        return;
                    }
                    vm.roundTripChildJobId = 1;
                    // ********* VARIABLES ARE INITIALIZE TO AGAIN SET INPUT FIELD VARIABLE ********
                    vm.calculatedEstimatePriceFormFunctionEstimated = -1;
                    vm.finalAdjustedPriceFromAdmin = 0;
                    vm.calculatedEstimatePriceForFixedPriceFormFunction = 0;
                    vm.calculatedEstimatePriceForRoundTripFormFunction = 0;
                    vm.click = false;
                    if (vm.bookingDetails && vm.bookingDetails.return_date_time_utc == "0000-00-00 00:00:00") {
                        //vm.dataToFill.dropDateReturn = new Date();
                        //vm.dataToFill.dropTimeReturn = new Date();
                    }
                    if (vm.dataToFill.selectedServiceDetails.category == 1) {
                        calculateEstimatePickUpTimeReturn(vm.dataToFill.etaScheduleValueReturn);
                    }
                    console.log(vm.dataToFill.selectedServiceDetails.category, vm.type_of_trip, vm.method_range_pickup_return, ' CHECK >>>>>>>>>>>>>>>>');
                    if ((vm.dataToFill.selectedServiceDetails.category == 1) && (vm.type_of_trip == 'R') && (vm.method_range_pickup_return == 1)) {
                        RoutingApiFuncationRoundTrip(vm.dataToFill)
                    }
                    if ((vm.dataToFill.selectedServiceDetails.category == 0) && (vm.type_of_trip == 'R') && (vm.method_range_pickup_return == 1) ) {
                        calculateEstimatePickUpTimeReturn(vm.dataToFill.etaScheduleValueReturn);
                    }
                    // $timeout(function () {
                    //     if (vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                    //         calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, map, 'ROUND TRIP',  vm.payloadForsearchFixedVairable);
                    //         // getFixedRoutesForPersonal(vm.dataToFill);

                    //     }
                    // }, 1000)
                    // console.log(vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip == 'P','PPppppp');
                    if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip == 'P') {
                        calculateDateRangeOfPointToPointReturn();
                    }
                    // console.log('>>>>>>>>>>>> vm.dataToFill.roundTrip >>>>>>', vm.dataToFill.roundTrip);
                    if (vm.dataToFill.roundTrip && !flag) {
                        console.log(vm.return_flag, 'debug vm.return_flag');
                        vm.couponType = undefined;
                        //console.log(vm.dataToFill.roundTrip, 'hello==================');
                        vm.dataToFill.roundTrip = false;
                        var index = _.findIndex(vm.dataToFill.discounts, {
                            name: 'ROUND TRIP'
                        });
                        if (index > -1) {
                            // console.log("<<<<<<<<<<<<<<<<<< Index >>>>>>>>>>>>>>>>>>", index);

                            vm.dataToFill.discounts.splice(index, 1);
                            vm.dataToFill.discounts = vm.dataToFill.discounts.sort(function (a, b) {
                                return b.value - a.value
                            })
                            // console.log(vm.dataToFill.discounts, '>>>>>>>>>>>> vm.dataToFill.discounts NIche >>>>>>>>>');
                            vm.dataToFill.discounts.forEach(function (object) {
                                // console.log(">>>>>>>>>>in ForEach>>>>>>>>>>");

                                object.roundTripFare = vm.dataToFill.roundTrip != true ? 0 : object.roundTripFare,
                                    object.returnValue = vm.dataToFill.roundTrip != true ? 0 : object.returnValue,
                                    object.roundFinalAmount = vm.dataToFill.roundTrip != true ? 0 : object.roundFinalAmount
                            });
                        }
                    } else {
                        // if ((vm.dataToFill.customerProfile == 0 || vm.dataToFill.customerProfile == '0') && vm.dataToFill.bookingType == '0') {
                        //     errorMessageFactory.showErrorMessage('No se permite crear reservas ida y vuelta sin tiempo de espera', 0);
                        //     return false;
                        // }
                        console.log(vm.return_flag, 'debug vm.return_flag');
                        // if (vm.dataToFill.Return_policy.route_type === 1) {
                        //     console.log(vm.return_flag, 'debug vm.return_flag');
                        //     if (vm.return_flag == true) {
                        //         ///////////////////////////TV-1795 //////////////////////////
                        //         vm.dataToFill.discounts = [];
                        //         vm.couponType = 1;
                        //         if (vm.dataToFill.roundTripDiscount == 0)
                        //             vm.couponType = undefined;
                        //         // if (vm.dataToFill.itemOfChargeList.length == 0) {
                        //         //     vm.calculatedEstimatePriceFormFunctionEstimated += vm.finalAdjustedPriceFromAdmin;
                        //         //     vm.calculatedEstimatePriceFormFunction += vm.finalAdjustedPriceFromAdmin;
                        //         // }
                        //         // if (vm.dataToFill.estimatedFare < vm.viaControlled1) {
                        //         //     vm.dataToFill.roundTrip = false;
                        //         //     errorMessageFactory.showErrorMessage('Cannot create booking as via controlled fare is greater than the stretch price', 0);
                        //         // } else {
                        //         //    
                        //         // }
                        //         // if (vm.dataToFill.controllerWayTarifa == 1) {
                        //         //     // type_of_trip In Return case
                        //         //     // vm.type_of_trip_Validate_Booking In Normal case
                        //         //     console.log('>>>>>>> TYPE >>>>>', vm.type_of_trip_Validate_Booking, vm.type_of_trip);
                        //         //     console.log('>>>>>> IN TARIFA >>>>>>>>', vm.dataToFill.estimatedFare, vm.viaControlled1);
                        //         //     console.log('>>>>>> IN TARIFA >>>>>>>>', vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2);
                        //         //     vm.estimatedFareDiscount = vm.type_of_trip_Validate_Booking == 'Z' ? (Number(vm.dataToFill.estimatedFare)) - (Number(vm.viaControlled1)) : (Number(vm.dataToFill.estimatedFare));
                        //         //     vm.estimatedFareDiscountRound = vm.type_of_trip == 'Z' ? (Number(vm.dataToFill.Return_policy.estimatedFare)) - (Number(vm.viaControlled2)) : (Number(vm.dataToFill.Return_policy.estimatedFare));
                        //         //     console.log(vm.estimatedFareDiscount, ' vm.estimatedFareDiscount');
                        //         //     console.log(vm.estimatedFareDiscountRound, 'vm.estimatedFareDiscountRound');
                        //         // } else {
                        //         //     console.log('>>>>>> ELSE TARIFA >>>>>>>>', vm.dataToFill.estimatedFare, vm.viaControlled1);
                        //         //     console.log('>>>>>> ELSE TARIFA >>>>>>>>', vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2);
                        //         //     vm.estimatedFareDiscount = (Number(vm.dataToFill.estimatedFare));
                        //         //     vm.estimatedFareDiscountRound = (Number(vm.dataToFill.Return_policy.estimatedFare));
                        //         // }
                        //         // console.log('>>>>>>>>>>. BEFORE DISCOUNT vm.dataToFill.roundTripDiscount >>>>>.', vm.dataToFill.roundTripDiscount);
                        //         // console.log('>>>>>>>>>>. BEFORE DISCOUNT vm.estimatedFareDiscount >>>>>.', vm.estimatedFareDiscount);
                        //         // console.log('>>>>>>>>>>. BEFORE DISCOUNT vm.estimatedFareDiscountRound >>>>>.', vm.estimatedFareDiscountRound);
                        //         // console.log('>>>>>> vm.estimatedFareDiscount >>>>>>.', vm.estimatedFareDiscount);
                        //         // console.log('>>>>>>>>>>>> finalAmount', (vm.estimatedFareDiscount - (vm.estimatedFareDiscount * Number(vm.dataToFill.roundTripDiscount) / 100)));
                        //         // console.log('>>>>>>>>>>>> roundFinalAmount', (vm.estimatedFareDiscount * Number(vm.dataToFill.roundTripDiscount) / 100));
                        //         ///////////////////////////TV-1795 //////////////////////////
                        //         vm.dataToFill.roundTrip = true;
                        //         vm.dataToFill.discounts.push({
                        //             // estimatedFare: Math.round(Number(vm.dataToFill.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled1))),
                        //             estimatedFare: viaControlledPrice(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking),
                        //             // roundTripFare: Math.round(Number(vm.dataToFill.Return_policy.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled2))),
                        //             roundTripFare: vm.dataToFill.roundTrip == true ? viaControlledPrice(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip) : 0,
                        //             name: 'ROUND TRIP',
                        //             discountType: 1,
                        //             discountTypeValue: vm.dataToFill.roundTripDiscount,
                        //             // value: ((Number(vm.estimatedFareDiscount) * Number(vm.dataToFill.roundTripDiscount)) / 100),
                        //             value: calculateDiscountPercentageAmount(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, vm.dataToFill.roundTripDiscount, 'parent'),
                        //             // returnValue: ((vm.estimatedFareDiscountRound * Number(vm.dataToFill.roundTripDiscount)) / 100),
                        //             returnValue: vm.dataToFill.roundTrip == true ? calculateDiscountPercentageAmount(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, vm.dataToFill.roundTripDiscount, 'parent') : 0,
                        //             // finalAmount: Math.round((vm.estimatedFareDiscount - vm.estimatedFareDiscount * Number(vm.dataToFill.roundTripDiscount) / 100) + (vm.type_of_trip_Validate_Booking == 'Z' ? (Number(vm.viaControlled1)) : 0)),
                        //             finalAmount: calculateDiscountPercentage(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, vm.dataToFill.roundTripDiscount, 'parent'),
                        //             // roundFinalAmount: Math.round((vm.estimatedFareDiscountRound - (vm.estimatedFareDiscountRound) * Number(vm.dataToFill.roundTripDiscount) / 100) + (vm.type_of_trip == 'Z' ? (Number(vm.viaControlled2)) : 0))
                        //             roundFinalAmount: vm.dataToFill.roundTrip == true ? calculateDiscountPercentage(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, vm.dataToFill.roundTripDiscount, 'parent') : 0
                        //         })
                        //         // console.log('>>>>> DISCOUNT >>>>>>>>>>>', vm.dataToFill.discounts);
                        //         vm.dataToFill.discounts.forEach(function (data) {
                        //             data.finalAmount = data.finalAmount < 0 ? 0 : data.finalAmount;
                        //         })
                        //         vm.dataToFill.discounts = vm.dataToFill.discounts.sort(function (a, b) {
                        //             return b.value - a.value
                        //         })
                        //     } else {
                        //         errorMessageFactory.showErrorMessage('Ida y vuelta de este servicio no está disponible', 0);
                        //     }
                        // }
                        console.log('debug setBooleans calculateAndDisplayRoute');
                        calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, map, 'ROUND TRIP');
                    }
                    $timeout(function () {
                        changeDateStringToLocalizeDropOffDate();
                    });
                    console.log(vm.dataToFill.discounts, "hdksahdaskdhakjhdajkshdjkas");
                    break;
                case 'WAIT_TIME_INCLUDED':
                    if (vm.disabledRoundTrip == true || vm.CheckBookingStatus(vm.bookingDetails)) {
                        return;
                    }
                    if (vm.dataToFill.is_wait_time_included) {
                        vm.dataToFill.is_wait_time_included = false;
                    } else {
                        vm.dataToFill.is_wait_time_included = true;
                    }
                    break;
            }
        };
        // =================watch estimated fare===============
        $scope.$watchCollection('vm.dataToFill.estimatedFare', function (newValue, oldValue) {
            console.log(newValue, 'newValue');

            if (vm.dataToFill.discounts && vm.dataToFill.discounts.length) {
                // if(vm.dataToFill.controllerWayTarifa == 1){
                //     newValue = newValue - vm.viaControlled1;
                // }else{
                //     newValue = newValue;
                // }
                // console.log(vm.type_of_trip_Validate_Booking,'vm.type_of_trip_Validate_Booking>>>>>>>>>',vm.viaControlled1);

                // vm.dataToFill.discounts.push({
                //     // estimatedFare: Math.round(Number(vm.dataToFill.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled1))),
                //     estimatedFare: viaControlledPrice(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking),
                //     // roundTripFare: Math.round(Number(vm.dataToFill.Return_policy.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled2))),
                //     roundTripFare: viaControlledPrice(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip),
                //     name: 'ROUND TRIP',
                //     discountType: 1,
                //     discountTypeValue: vm.dataToFill.roundTripDiscount,
                //     // value: ((Number(vm.estimatedFareDiscount) * Number(vm.dataToFill.roundTripDiscount)) / 100),
                //     value: calculateDiscountPercentageAmount(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, vm.dataToFill.roundTripDiscount),
                //     // returnValue: ((vm.estimatedFareDiscountRound * Number(vm.dataToFill.roundTripDiscount)) / 100),
                //     returnValue: calculateDiscountPercentageAmount(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, vm.dataToFill.roundTripDiscount),
                //     // finalAmount: Math.round((vm.estimatedFareDiscount - vm.estimatedFareDiscount * Number(vm.dataToFill.roundTripDiscount) / 100) + (vm.type_of_trip_Validate_Booking == 'Z' ? (Number(vm.viaControlled1)) : 0)),
                //     finalAmount: calculateDiscountPercentage(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, vm.dataToFill.roundTripDiscount),
                //     // roundFinalAmount: Math.round((vm.estimatedFareDiscountRound - (vm.estimatedFareDiscountRound) * Number(vm.dataToFill.roundTripDiscount) / 100) + (vm.type_of_trip == 'Z' ? (Number(vm.viaControlled2)) : 0))
                //     roundFinalAmount: calculateDiscountPercentage(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, vm.dataToFill.roundTripDiscount)
                // })

                vm.dataToFill.discounts.forEach(function (data) {
                    // console.log('>>>>> IN FOR');
                    data.estimatedFare = viaControlledPrice(newValue, vm.viaControlled1, vm.type_of_trip_Validate_Booking);
                    // data.estimatedFare = Number(newValue) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled1)) + (vm.type_of_trip_Validate_Booking == 'Z' ? (Number(vm.viaControlled1)) : 0);
                    if (data.name == 'ROUND TRIP')
                        // data.value = Math.round((Number(newValue) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled1))) * Number(vm.dataToFill.roundTripDiscount) / 100);
                        data.value = calculateDiscountPercentageAmount(newValue, vm.viaControlled1, vm.type_of_trip_Validate_Booking, vm.dataToFill.roundTripDiscount, 'parent');
                    else {
                        if (data.discountType == 0 || data.discountType == '0')
                            // data.value = Number(data.discountTypeValue);
                            data.value = calculateDiscountFlatAmount(data.discountTypeValue);
                        // else data.value = Math.round((Number(newValue) + (vm.dataToFill.controllerWayTarifa ? 0 : (Number(vm.viaControlled1)))) * Number(data.discountTypeValue) / 100);
                        else data.value = calculateDiscountPercentageAmount(newValue, vm.viaControlled1, vm.type_of_trip_Validate_Booking, data.discountTypeValue, 'parent');
                    }
                    // data.finalAmount = (Number(newValue) + (vm.dataToFill.controllerWayTarifa ? 0  : Number(vm.viaControlled1))) - Number(data.value);
                    data.finalAmount = vm.couponType ? calculateDiscountPercentage(newValue, vm.viaControlled1, vm.type_of_trip_Validate_Booking, data.discountTypeValue, vm.tope_maximo ,'parent') : calculateDiscountFlat(newValue, vm.viaControlled1, vm.type_of_trip_Validate_Booking, data.discountTypeValue, 'parent');
                })
                vm.dataToFill.discounts.forEach(function (data) {
                    data.finalAmount = data.finalAmount < 0 ? 0 : data.finalAmount;
                })
                vm.dataToFill.discounts = vm.dataToFill.discounts.sort(function (a, b) {
                    return b.value - a.value
                })
            }
            console.log(vm.dataToFill.discounts);
        });

        $scope.$watchCollection('vm.dataToFill.Return_policy.estimatedFare', function (newValue, oldValue) {
            if (vm.dataToFill.discounts && vm.dataToFill.discounts.length && vm.dataToFill.roundTrip == true) {
                // if(vm.dataToFill.controllerWayTarifa == 1){
                //     newValue = newValue - vm.viaControlled2;
                // }else{
                //     newValue = newValue;
                // }
                vm.dataToFill.discounts.forEach(function (data) {
                    // data.roundTripFare = Number(newValue) + (vm.dataToFill.controllerWayTarifa ? 0 :  Number(vm.viaControlled2)) + (vm.type_of_trip == 'Z'  ? (Number(vm.viaControlled2)) : 0);
                    data.roundTripFare = viaControlledPrice(newValue, vm.viaControlled2, vm.type_of_trip);
                    if (data.name == 'ROUND TRIP')
                        // data.value = Math.round((Number(newValue) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled2))) * Number(vm.dataToFill.roundTripDiscount) / 100);
                        data.returnValue = calculateDiscountPercentageAmount(newValue, vm.viaControlled2, vm.type_of_trip, vm.dataToFill.roundTripDiscount, 'parent');
                    else {
                        if (data.discountType == 0 || data.discountType == '0')
                            // data.value = Number(data.discountTypeValue);
                            data.returnValue = calculateDiscountFlatAmount(data.discountTypeValue);
                        else data.returnValue = calculateDiscountPercentageAmount(newValue, vm.viaControlled2, vm.type_of_trip, data.discountTypeValue, 'parent');
                        // else data.value = Math.round((Number(newValue) + (vm.dataToFill.controllerWayTarifa ? 0 :Number(vm.viaControlled2))) * Number(data.discountTypeValue) / 100);
                    }
                    // data.roundFinalAmount = (Number(newValue) + (vm.dataToFill.controllerWayTarifa ? 0 :   Number(vm.viaControlled2))) - Number(data.value);
                    data.roundFinalAmount = vm.couponType ? calculateDiscountPercentage(newValue, vm.viaControlled2, vm.type_of_trip, data.discountTypeValue) : calculateDiscountFlat(newValue, vm.viaControlled2, vm.type_of_trip, data.discountTypeValue, vm.tope_maximo);
                });
                vm.dataToFill.discounts.forEach(function (data) {
                    data.roundFinalAmount = data.roundFinalAmount < 0 ? 0 : data.roundFinalAmount;
                })
                vm.dataToFill.discounts = vm.dataToFill.discounts.sort(function (a, b) {
                    return b.returnValue - a.returnValue
                })
            }
            // console.log(vm.dataToFill.discounts);
        });


        function applyCoupon() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.coupon_number = vm.dataToFill.couponCode;
            dataSend.flag = 1;
            dataSend.contract_id = Number(vm.dataToFill.contractIdSelected);
            vm.loading = true;
            var promise = quickSaleService.applyCoupon(dataSend);
            promise.then(
                function (payload) {
                    console.log('payload', payload);
                    vm.loading = false;
                    if (payload.title.message == 'El cupón que aplicó no es válido.') {
                        vm.dataToFill.couponValidation = true;
                        return;
                    } else if (payload.title.message == 'El cupón que aplicó está vencido.') {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return;
                    } else if (payload.title && payload.title.data && payload.title.data.status === 400) {
                        errorMessageFactory.showErrorMessage(payload.title.data.message, 0);
                        return;
                    } else if (payload.title && payload.title && payload.title.status === 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return;
                    } else {
                        vm.dataToFill.couponApplied = true;
                        if (payload && payload.title.data)
                            vm.couponType = payload.title.data.type;
                            vm.tope_maximo = payload.title.data.tope_maximo || undefined;
                        ///////////////////////////TV-1795 //////////////////////////
                        // if ((Number(vm.dataToFill.Return_policy.estimatedFare)) < (Number(vm.viaControlled2))) {
                        //     errorMessageFactory.showErrorMessage('hello', 0);
                        // } else {}
                        // if (vm.dataToFill.controllerWayTarifa == 1) {
                        //     vm.estimatedFareDiscount = (Number(vm.dataToFill.estimatedFare)) - (Number(vm.viaControlled1));
                        //     vm.estimatedFareDiscountRound = (Number(vm.dataToFill.Return_policy.estimatedFare)) - (Number(vm.viaControlled2));
                        // } else {
                        //     vm.estimatedFareDiscount = (Number(vm.dataToFill.estimatedFare)) + (Number(vm.viaControlled1));
                        //     vm.estimatedFareDiscountRound = (Number(vm.dataToFill.Return_policy.estimatedFare)) + (Number(vm.viaControlled2));
                        // }
                        // var returnValueSend = 0;
                        // var roundFinalAmountSend = 0;
                        // var roundTripFareSend = 0;
                        // if (vm.dataToFill.roundTrip == true) {
                        //     returnValueSend = payload.title.data.type ? Math.round(vm.estimatedFareDiscountRound * (payload.title.data.discount) / 100) : payload.title.data.discount;
                        //     roundFinalAmountSend = payload.title.data.type ? Math.round((vm.estimatedFareDiscountRound) - (vm.estimatedFareDiscountRound * Number(payload.title.data.discount) / 100)+  + (vm.type_of_trip == 'Z'  ? (Number(vm.viaControlled1)) : 0)) : Math.round((vm.estimatedFareDiscountRound - payload.title.data.discount) +  + (vm.type_of_trip == 'Z'  ? (Number(vm.viaControlled1)) : 0));
                        //     roundTripFareSend = Number(vm.dataToFill.Return_policy.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled2))
                        // }
                        ///////////////////////////TV-1795 //////////////////////////
                        if (!(payload.title.data.type == 0 && vm.dataToFill.roundTrip == true))
                            languageBasedErrorFactory.getProperErrorMessage('couponApplySucc', 0, 0);
                        if (payload.title.data.type == 0 && vm.dataToFill.roundTrip == true) {
                            errorMessageFactory.showErrorMessage('Flat type discount cannot be applied on round trip.', 0);
                            return false;
                        }
                        vm.dataToFill.discounts.insert(0, {
                            // estimatedFare: Number(vm.dataToFill.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled1)),
                            estimatedFare: viaControlledPrice(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking),
                            // roundTripFare: roundTripFareSend,
                            roundTripFare: vm.dataToFill.roundTrip == true ? viaControlledPrice(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip) : 0,
                            name: payload.title.data.coupon_number,
                            discountType: payload.title.data.type,
                            discountTypeValue: payload.title.data.discount,
                            // value: payload.title.data.type ? Math.round((Number(vm.estimatedFareDiscount) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled1))) * (payload.title.data.discount) / 100) : payload.title.data.discount,
                            value: payload.title.data.type ? calculateDiscountPercentageAmount(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, payload.title.data.discount, 'parent') : calculateDiscountFlatAmount(payload.title.data.discount),
                            // returnValue: returnValueSend,
                            returnValue: vm.dataToFill.roundTrip == true ? (payload.title.data.type ? calculateDiscountPercentageAmount(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, payload.title.data.discount, 'parent') : calculateDiscountFlatAmount(payload.title.data.discount)) : 0,
                            // finalAmount: payload.title.data.type ?  ((vm.estimatedFareDiscount - vm.estimatedFareDiscount * Number(payload.title.data.discount) / 100) + (vm.type_of_trip_Validate_Booking == 'Z' ? (Number(vm.viaControlled1)) : 0)) :  ((vm.estimatedFareDiscount - vm.estimatedFareDiscount * Number(payload.title.data.discount) / 100) + (vm.type_of_trip_Validate_Booking == 'Z' ? (Number(vm.viaControlled1)) : 0)),
                            finalAmount: payload.title.data.type ? calculateDiscountPercentage(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, payload.title.data.discount, payload.title.data.tope_maximo, 'parent') : calculateDiscountFlat(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, payload.title.data.discount, 'parent'),
                            // roundFinalAmount: roundFinalAmountSend,
                            roundFinalAmount: vm.dataToFill.roundTrip == true ? (payload.title.data.type ? calculateDiscountPercentage(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, payload.title.data.discount, payload.title.data.tope_maximo) : calculateDiscountFlat(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, payload.title.data.discount)) : 0
                        })
                        if( payload.title.data.tope_maximo ){
                            vm.dataToFill.discounts[0].tope_maximo = payload.title.data.tope_maximo;
                        }
                        // vm.dataToFill.discounts.push({
                        //     // estimatedFare: Number(vm.dataToFill.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled1)),
                        //     estimatedFare: viaControlledPrice(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking),
                        //     // roundTripFare: roundTripFareSend,
                        //     roundTripFare: vm.dataToFill.roundTrip == true ? viaControlledPrice(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip) : 0,
                        //     name: payload.title.data.coupon_number,
                        //     discountType: payload.title.data.type,
                        //     discountTypeValue: payload.title.data.discount,
                        //     // value: payload.title.data.type ? Math.round((Number(vm.estimatedFareDiscount) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled1))) * (payload.title.data.discount) / 100) : payload.title.data.discount,
                        //     value: payload.title.data.type ? calculateDiscountPercentageAmount(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, payload.title.data.discount) : calculateDiscountFlatAmount(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, payload.title.data.discount),
                        //     // returnValue: returnValueSend,
                        //     returnValue: vm.dataToFill.roundTrip == true ? (payload.title.data.type ? calculateDiscountPercentageAmount(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, payload.title.data.discount) : calculateDiscountFlatAmount(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, payload.title.data.discount)) : 0,
                        //     // finalAmount: payload.title.data.type ?  ((vm.estimatedFareDiscount - vm.estimatedFareDiscount * Number(payload.title.data.discount) / 100) + (vm.type_of_trip_Validate_Booking == 'Z' ? (Number(vm.viaControlled1)) : 0)) :  ((vm.estimatedFareDiscount - vm.estimatedFareDiscount * Number(payload.title.data.discount) / 100) + (vm.type_of_trip_Validate_Booking == 'Z' ? (Number(vm.viaControlled1)) : 0)),
                        //     finalAmount: payload.title.data.type ? calculateDiscountPercentage(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, payload.title.data.discount) : calculateDiscountFlat(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, payload.title.data.discount),
                        //     // roundFinalAmount: roundFinalAmountSend,
                        //     roundFinalAmount: vm.dataToFill.roundTrip == true ? (payload.title.data.type ? calculateDiscountPercentage(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, payload.title.data.discount) : calculateDiscountFlat(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, payload.title.data.discount)) : 0
                        // });
                        // Math.round((Number(vm.estimatedFareDiscount) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled1))) - Number(Number(vm.estimatedFareDiscount)) * Number(payload.title.data.discount) / 100) : Math.round((Number(vm.estimatedFareDiscount) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled1))) - payload.title.data.discount)
                        vm.dataToFill.discounts.forEach(function (data) {
                            data.finalAmount = data.finalAmount < 0 ? 0 : data.finalAmount;
                        })
                        vm.dataToFill.discounts = vm.dataToFill.discounts.sort(function (a, b) {
                            return b.value - a.value
                        })
                    }

                    // console.log(vm.dataToFill.discounts, "second time>>>>>>");

                    //vm.dataToFill.discounts.push({
                    //    estimatedFare: vm.dataToFill.estimatedFare,
                    //    name: 'ROUND TRIP',
                    //    discountType: 1,
                    //    discountTypeValue: vm.dataToFill.roundTripDiscount,
                    //    value: ((Number(vm.dataToFill.estimatedFare) * Number(vm.dataToFill.roundTripDiscount))/100),
                    //    finalAmount: Number(vm.dataToFill.estimatedFare) - ((Number(vm.dataToFill.estimatedFare) * Number(vm.dataToFill.roundTripDiscount))/100)
                    //})

                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        //======================by pass function for fav=========================
        function makeByPassFunctionForFav(type) {
            if (type == '1') {
                var where = _.where(vm.favAddressList, {
                    location_id: Number(vm.dataToFill.favPickLocId)
                });
                //console.log('where', where, vm.dataToFill);
                vm.dataToFill.pickUpAddress = where[0].address;
                if (vm.getInfoFlag == true) {
                    var geocoder = new google.maps.Geocoder;
                    vm.pickaddressChange = true;
                    geocoder.geocode({
                        'address': vm.dataToFill.pickUpAddress
                    }, function (results, status) {
                        if (status === 'OK') {
                            var city;
                            for (var i = 0; i < results[0].address_components.length; i++) {
                                for (var j = 0; j < results[0].address_components[i].types.length; j++) {
                                    if (results[0].address_components[i].types[j] == 'locality') {
                                        city = results[0].address_components[i].short_name;
                                        vm.jobPickupComuna = city;
                                    }
                                }
                            }
                            if (vm.pickUpCity && (vm.pickUpCity != city)) {
                                errorMessageFactory.showErrorMessage('Error, esta dirección cambia el tramo original. El cambio no debe afectar la tarifa.', 0);
                                vm.dataToFill.pickUpAddress = vm.pickUpAddress;
                                return;

                            } else {
                                // reverseGeocodeForFavPickUp(vm.dataToFill.pickUpAddress);
                                vm.dataToFill.pickUpLat = where[0].latitude;
                                vm.dataToFill.pickUpLng = where[0].longtitude;
                                // var location = new google.maps.LatLng(Number(where[0].latitude), Number(where[0].longtitude));
                                if (vm.toAirportFlag) {
                                    getAirportAddressApi();
                                }
                                if (vm.ptopAirportFlag && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                                    getFixedRoutesForPersonal(vm.dataToFill);
                                }
                                if (vm.dataToFill.serviceTypeSelected) { //&& (vm.dataToFill.bookingType == '0' || vm.dataToFill.bookingType == 0)
                                    vm.dataToFill.nearDriver = '';
                                    toGetAirportService(vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.serviceTypeSelected, map);
                                    //toGetNearByDrivers(vm.dataToFill.pickUpLat,vm.dataToFill.pickUpLng,vm.dataToFill.serviceTypeSelected,map);
                                }
                            }
                        } else {
                            window.alert('Geocode was not successful for the following reason: ' +
                                status);
                        }
                    });
                } else {
                    // reverseGeocodeForFavPickUp(vm.dataToFill.pickUpAddress);
                    vm.dataToFill.pickUpLat = where[0].latitude;
                    vm.dataToFill.pickUpLng = where[0].longtitude;
                    vm.dataToFill.pickLat = where[0].latitude;
                    vm.dataToFill.pickLng = where[0].longtitude;
                    vm.jobPickupComuna = where[0].communa;
                    // var location = new google.maps.LatLng(Number(where[0].latitude), Number(where[0].longtitude));
                    // placeMarker(map, location, 'pick');
                    if (vm.toAirportFlag) {
                        getAirportAddressApi();
                    }
                    if (vm.ptopAirportFlag && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                        getFixedRoutesForPersonal(vm.dataToFill);
                    }
                    if (vm.dataToFill.serviceTypeSelected) { //&& (vm.dataToFill.bookingType == '0' || vm.dataToFill.bookingType == 0)
                        vm.dataToFill.nearDriver = '';
                        toGetAirportService(vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.serviceTypeSelected, map);
                        //toGetNearByDrivers(vm.dataToFill.pickUpLat,vm.dataToFill.pickUpLng,vm.dataToFill.serviceTypeSelected,map);
                    }
                }
                vm.getFixedRoutesForPersonalFlag = true;
                // $timeout(function () {
                //     placeMarker(map, location, 'pick');
                // }, 2000)
            } else if (type == '2') {
                var where = _.where(vm.favAddressList, {
                    location_id: Number(vm.dataToFill.favDropLocId)
                });
                //console.log('where', where, vm.dataToFill);
                vm.dataToFill.dropOffAddress = where[0].address;
                vm.dropaddressChange = true;
                if (vm.getInfoFlag == true) {
                    var geocoder = new google.maps.Geocoder;
                    geocoder.geocode({
                        'address': vm.dataToFill.dropOffAddress
                    }, function (results, status) {
                        if (status === 'OK') {
                            var city;
                            for (var i = 0; i < results[0].address_components.length; i++) {
                                for (var j = 0; j < results[0].address_components[i].types.length; j++) {
                                    if (results[0].address_components[i].types[j] == 'locality') {
                                        city = results[0].address_components[i].short_name;
                                        vm.jobDropoffComuna = city;
                                    }
                                }
                            }
                            if (vm.dropUpCity && (vm.dropUpCity != city)) {
                                errorMessageFactory.showErrorMessage('Error, esta dirección cambia el tramo original. El cambio no debe afectar la tarifa.', 0);
                                // results= '';
                                vm.dataToFill.dropOffAddress = vm.dropUpAddress;
                                return;
                            } else {
                                vm.dataToFill.dropOffLat = where[0].latitude;
                                vm.dataToFill.dropOffLng = where[0].longtitude;
                                var locationD = new google.maps.LatLng(Number(where[0].latitude), Number(where[0].longtitude));
                                if (vm.fromAirportFlag) {
                                    getAirportAddressApi();
                                }
                                if (vm.ptopAirportFlag && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                                    getFixedRoutesForPersonal(vm.dataToFill);
                                }
                            }
                        } else {
                            window.alert('Geocode was not successful for the following reason: ' +
                                status);
                        }
                    });
                } else {
                    vm.dataToFill.dropOffLat = where[0].latitude;
                    vm.dataToFill.dropOffLng = where[0].longtitude;
                    vm.dataToFill.dropLat = where[0].latitude;
                    vm.dataToFill.dropLng = where[0].longtitude;
                    vm.jobDropoffComuna = where[0].communa;
                    // var locationD = new google.maps.LatLng(Number(where[0].latitude), Number(where[0].longtitude));
                    if (vm.fromAirportFlag) {
                        getAirportAddressApi();
                    }
                    if (vm.ptopAirportFlag && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                        getFixedRoutesForPersonal(vm.dataToFill);
                    }

                }
                vm.getFixedRoutesForPersonalFlag = true;
                // reverseGeocodeForFavDropUp(vm.dataToFill.dropOffAddress);
                // $timeout(function () {
                //     placeMarker(map, locationD, 'drop');
                // }, 2000);
            }
            if ((vm.dataToFill.pickUpLng && vm.dataToFill.pickUpLat))
                getFavoriteAddress('pick');
            if ((vm.dataToFill.dropOffLng && vm.dataToFill.dropOffLat))
                getFavoriteAddress('drop');
        }
        //=====================pickupfav address =========================
        function pickFavAddress($event) {
            getCustomerFavouriteAddress('popUp');
        };


        function openPopForFavouriteAddress($event) {
            vm.pickLocationList = [];
            vm.pickLocationListAgreement = [];
            if (vm.dataToFill.favDropLocId) {
                for (var i = 0; i < vm.favAddressList.length; i++) {
                    if (Number(vm.dataToFill.favDropLocId) != vm.favAddressList[i].location_id) {
                        // if (vm.favAddressList[i].aggreement_address == 0) {
                        //     vm.pickLocationList.push(vm.favAddressList[i]);
                        // } else {
                        //     vm.pickLocationListAgreement.push(vm.favAddressList[i]);
                        // }
                        vm.pickLocationList.push(vm.favAddressList[i]);
                    }
                }
            } else {
                for (var i = 0; i < vm.favAddressList.length; i++) {
                    // if (vm.favAddressList[i].aggreement_address == 0) {
                    //     vm.pickLocationList.push(vm.favAddressList[i]);
                    // } else {
                    //     vm.pickLocationListAgreement.push(vm.favAddressList[i]);
                    // }
                    vm.pickLocationList.push(vm.favAddressList[i]);
                }
            }
            vm.items = {
                list: vm.pickLocationList,
                errMsg: '',
                selected: '',
                agreementList: vm.pickLocationListAgreement,
                searchaddress: ''
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/favAddressesViewChange.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });

            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.colorFlag = [];
                $scope.locationIds = [];
                $scope.indexNew = 0;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                    if ((vm.dataToFill.pickUpLng && vm.dataToFill.pickUpLat))
                        getFavoriteAddress('pick');
                    if ((vm.dataToFill.dropOffLng && vm.dataToFill.dropOffLat))
                        getFavoriteAddress('drop');
                };
                $scope.checkData = function (data, index) {
                    if (data.checked == undefined || data.checked == false) {
                        $scope.locationIds.push({
                            location_id: data.location_id
                        });
                    } else {
                        var indexd = _.findIndex($scope.locationIds, {
                            location_id: data.location_id
                        });
                        if (indexd > -1) {
                            $scope.locationIds.splice(indexd, 1);
                        }
                    }
                    $scope.indexNew = $scope.locationIds.length;
                }
                $scope.blackArray = function () {
                    $scope.items.list.forEach(function (data) {
                        if (data.checked) {
                            data.checked = false;
                        }
                    });
                    $scope.locationIds = [];
                    $scope.indexNew = 0;
                }
                $scope.divSelected = function (data, index) {
                    if ($scope.colorFlag[index] == true) {
                        $scope.colorFlag[index] = false;
                        $scope.items.selected = null;
                    } else {
                        $scope.colorFlag = [];
                        $scope.colorFlag[index] = true;
                        $scope.items.selected = data.location_id;
                    }
                }
                $scope.getFilter = function () {
                    $scope.items.list = [];
                    $scope.items.agreementList = [];
                    if (vm.dataToFill.customerId == null || vm.dataToFill.customerId == undefined || vm.dataToFill.customerId == '') {
                        return false;
                    }
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.customer_id = vm.dataToFill.customerId;
                    if (vm.personalFlag == true) {
                        dataSend.contract_id = vm.dataToFill.contractIdSelected;
                    } else {
                        dataSend.contract_id = vm.dataToFill.customerContarctId;
                    }
                    if ($scope.items.searchaddress != '')
                        dataSend.search_value = $scope.items.searchaddress;
                    vm.loading = true;
                    var promise = getCustomers.getFavoriteLocation(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            vm.loading = false;
                            if (payload.title.data.length) {
                                $scope.items.listarray = payload.title.data;
                                for (var i = 0; i < $scope.items.listarray.length; i++) {
                                    if ($scope.items.listarray[i].aggreement_address == 0) {
                                        $scope.items.list.push($scope.items.listarray[i]);
                                    } else {
                                        $scope.items.list.push($scope.items.listarray[i]);
                                    }
                                }
                                vm.favAddFlag = true;
                                vm.favAddFlagI = {
                                    'width': '95%'
                                };
                                vm.crossButton = {
                                    'left': '494px'
                                }
                                vm.favAddFlagB = {
                                    'width': '15%'
                                };
                                // if (type == 'popUp') {
                                //     openPopForFavouriteAddress($event);
                                // }
                            } else {
                                vm.favAddressList = [];
                                vm.favAddFlag = false;
                                vm.favAddFlagI = {
                                    'width': '100%'
                                };
                                vm.favAddFlagB = {
                                    'width': '0%'
                                };
                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }
                $scope.deleteFavouriteAddress = function (data, index) {
                    var dataSend = {};
                    var locationIdsArray = [];
                    $scope.items.list.forEach(function (data) {
                        if (data.checked) {
                            locationIdsArray.push(data.location_id);
                        }
                    });
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.location_id = locationIdsArray;
                    dataSend.is_admin = 1;
                    dataSend.customer_id = vm.dataToFill.customerId;
                    vm.loading = true;
                    var promise = getBookings.setUnFavouriteAddress(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            vm.loading = false;
                            if (payload.title.status == 200) {
                                $scope.items.list.splice(index, 1);
                            } else {
                                vm.isActivePick = !vm.isActivePick;
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            $scope.items.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }
                $scope.confirmUpload = function () {
                    // //console.log($scope.items.selected, '$scope.items.selected');
                    // $log.log('confirmed', $scope.items);
                    // if ($scope.items.selected == null) {
                    //     $scope.items.errMsg = languageBasedErrorFactory.getProperErrorMessage('selectLocationError', 0, '3');
                    //     $timeout(function () {
                    //         $scope.items.errMsg = '';
                    //     }, 2000);
                    // } else {
                    //     $mdDialog.hide();
                    //     vm.dataToFill.favPickLocId = $scope.items.selected;
                    //     vm.addressChange = true;
                    //     makeByPassFunctionForFav('1');
                    // }
                    var dataSend = {};
                    var locationIdsArray = [];
                    $scope.items.list.forEach(function (data) {
                        if (data.checked) {
                            locationIdsArray.push(data.location_id);
                        }
                    });
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.location_id = locationIdsArray;
                    dataSend.is_admin = 1;
                    dataSend.customer_id = vm.dataToFill.customerId;
                    vm.loading = true;
                    var promise = getBookings.setUnFavouriteAddress(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            vm.loading = false;
                            if (payload.title.status == 200) {
                                // vm.isActivePick = !vm.isActivePick;
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            } else {
                                vm.isActivePick = !vm.isActivePick;
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            $scope.items.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                };
            }
        }
        //=====================pickupfav address =========================
        function dropFavAddress($event) {
            getCustomerFavouriteAddress('popUpDrop');
            //console.log(vm.favAddressList);
        };

        function openPopForFavouriteAddressDrop($event) {
            vm.dropLocationList = [];
            vm.dropLocationListAgreement = [];
            if (vm.dataToFill.favPickLocId) {
                for (var i = 0; i < vm.favAddressList.length; i++) {
                    if (Number(vm.dataToFill.favPickLocId) != vm.favAddressList[i].location_id) {
                        // if (vm.favAddressList[i].aggreement_address == 0) {
                        //     vm.dropLocationList.push(vm.favAddressList[i]);
                        // } else {
                        //     vm.dropLocationListAgreement.push(vm.favAddressList[i]);
                        // }
                        vm.dropLocationList.push(vm.favAddressList[i]);
                    }
                }
            } else {
                for (var i = 0; i < vm.favAddressList.length; i++) {
                    // if (vm.favAddressList[i].aggreement_address == 0) {
                    //     vm.dropLocationList.push(vm.favAddressList[i]);
                    // } else {
                    //     vm.dropLocationListAgreement.push(vm.favAddressList[i]);
                    // }
                    vm.dropLocationList.push(vm.favAddressList[i]);
                }
            }
            vm.items = {
                list: vm.dropLocationList,
                errMsg: '',
                selected: '',
                agreementList: vm.dropLocationListAgreement,
                searchaddress: ''
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/favAddressesViewChange.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });

            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.colorFlag = [];
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                    if ((vm.dataToFill.dropOffLng && vm.dataToFill.dropOffLat))
                        getFavoriteAddress('drop');
                    if ((vm.dataToFill.pickUpLng && vm.dataToFill.pickUpLat))
                        getFavoriteAddress('pick');
                };
                $scope.divSelected = function (data, index) {
                    if ($scope.colorFlag[index] == true) {
                        $scope.colorFlag[index] = false;
                        $scope.items.selected = null;
                    } else {
                        $scope.colorFlag = [];
                        $scope.colorFlag[index] = true;
                        $scope.items.selected = data.location_id;
                    }
                }
                $scope.deleteFavouriteAddress = function (data, index) {
                    console.log(data, 'delete');
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.location_id = data.location_id;
                    dataSend.is_admin = 1;
                    dataSend.customer_id = vm.dataToFill.customerId;
                    vm.loading = true;
                    var promise = getBookings.setUnFavouriteAddress(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            vm.loading = false;
                            if (payload.title.status == 200) {
                                console.log(index, 'index>>>>>>>>>');
                                $scope.items.list.splice(index, 1);
                            } else {
                                vm.isActivePick = !vm.isActivePick;
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            $scope.items.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }
                $scope.getFilter = function () {
                    $scope.items.agreementList = [];
                    $scope.items.list = [];
                    if (vm.dataToFill.customerId == null || vm.dataToFill.customerId == undefined || vm.dataToFill.customerId == '') {
                        return false;
                    }
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.customer_id = vm.dataToFill.customerId;
                    if (vm.personalFlag == true) {
                        dataSend.contract_id = vm.dataToFill.contractIdSelected;
                    } else {
                        dataSend.contract_id = vm.dataToFill.customerContarctId;
                    }
                    if ($scope.items.searchaddress != '') { }
                    dataSend.search_value = $scope.items.searchaddress;
                    vm.loading = true;
                    var promise = getCustomers.getFavoriteLocation(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            vm.loading = false;
                            if (payload.title.data.length) {
                                $scope.items.listarray = payload.title.data;
                                for (var i = 0; i < $scope.items.listarray.length; i++) {
                                    if ($scope.items.listarray[i].aggreement_address == 0) {
                                        $scope.items.list.push($scope.items.listarray[i]);
                                    } else {
                                        $scope.items.list.push($scope.items.listarray[i]);
                                    }
                                }
                                vm.favAddFlag = true;
                                vm.favAddFlagI = {
                                    'width': '95%'
                                };
                                vm.crossButton = {
                                    'left': '494px'
                                }
                                vm.favAddFlagB = {
                                    'width': '15%'
                                };
                                // if (type == 'popUp') {
                                //     openPopForFavouriteAddress($event);
                                // }
                            } else {
                                vm.favAddressList = [];
                                vm.favAddFlag = false;
                                vm.favAddFlagI = {
                                    'width': '100%'
                                };
                                vm.favAddFlagB = {
                                    'width': '0%'
                                };
                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }
                $scope.confirmUpload = function () {
                    $log.log('confirmed', $scope.items);
                    if ($scope.items.selected == null) {
                        $scope.items.errMsg = languageBasedErrorFactory.getProperErrorMessage('selectLocationError', 0, '3');
                        $timeout(function () {
                            $scope.items.errMsg = '';
                        }, 2000);
                    } else {
                        $mdDialog.hide();
                        vm.dataToFill.favDropLocId = $scope.items.selected;
                        makeByPassFunctionForFav('2');
                    }
                };
            }
        }
        //==========================get customer faourite address=============================
        function getCustomerFavouriteAddress(type, $event) {
            if (vm.dataToFill.customerId == null || vm.dataToFill.customerId == undefined || vm.dataToFill.customerId == '') {
                return false;
            }
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.customer_id = vm.dataToFill.customerId;
            if (vm.personalFlag == true) {
                dataSend.contract_id = vm.dataToFill.contractIdSelected;
            } else {
                dataSend.contract_id = vm.dataToFill.customerContarctId;
            }

            vm.loading = true;
            var promise = getCustomers.getFavoriteLocation(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.data.length) {
                        vm.favAddressList = payload.title.data;
                        vm.favAddFlag = true;
                        vm.favAddFlagI = {
                            'width': '95%'
                        };
                        vm.crossButton = {
                            'left': '494px'
                        }
                        vm.favAddFlagB = {
                            'width': '15%'
                        };
                        if (type == 'popUp') {
                            openPopForFavouriteAddress($event);
                        }
                        if (type == 'popUpDrop') {
                            openPopForFavouriteAddressDrop($event);
                        }
                    } else {
                        vm.favAddressList = [];
                        vm.favAddFlag = false;
                        vm.favAddFlagI = {
                            'width': '100%'
                        };
                        vm.favAddFlagB = {
                            'width': '0%'
                        };
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        //======================selecting particular customer=========================
        vm.employeeId = 0;

        function onSelectingCustomer() {
            $log.log(vm.dataToFill);
            // //console.log('>>>>>>>>>>>> payload.title.data.employee_data', vm.dataToFill);
            vm.dataToFill.customerMobileG = vm.dataToFill.customerMobile.phone_number;
            vm.dataToFill.customerId = vm.dataToFill.customerMobile.customer_id;
            vm.dataToFill.previousCustomerId = vm.dataToFill.customerMobile.customer_id;
            vm.dataToFill.customerEmail = vm.dataToFill.customerMobile.email;
            vm.employeeId = vm.dataToFill.customerMobile.employee_id;
            //vm.dataToFill.customerContarctId = vm.dataToFill.customerMobile.contract_id;
            vm.dataToFill.employeeId = vm.dataToFill.customerMobile.customer_id;
            vm.dataToFill.authRequired = 0;
            //vm.dataToFill.auther_id = vm.dataToFill.customerMobile.employee_details.auther_id;
            //vm.dataToFill.authRUT = RutHelper.format(vm.dataToFill.customerMobile.employee_details.auth_RUT);
            // vm.dataToFill.customerProfile = '0';
            if (vm.disableAgreementService == true) {
                vm.dataToFill.customerProfile = vm.bookingDetails.creator_profile;
            } else {
                // THIS CHECK IS FOR PET USER BECAUSE PET USER CAN ONLY MAKE CORPORATE BOOKING
                if (JSON.parse($cookies.get('adminType') || 0) == 1) {
                    vm.dataToFill.customerProfile = '1';
                } else {
                    vm.dataToFill.customerProfile = '0';
                }
            }
            //vm.dataToFill.contractIdSelected = '';
            vm.dataToFill.previousPickFlag = false;
            vm.dataToFill.previousDropFlag = false;
            vm.makePhoneEditAble = false;
            //vm.customerProfileOption = [
            //    {
            //        name: 'Personal',
            //        value: 0
            //    },
            //    {
            //        name: 'Corporate',
            //        value: 1
            //    }
            //]
            if (JSON.parse($cookies.get('adminType') || 0) == 0)
                getSpotAgreement();
            getCustomerFavouriteAddress();
            if (JSON.parse($cookies.get('adminType') || 0) == 1)
                profileChanges();
        };

        //====================== selecting particular PERSON=========================
        function onSelectingPerson() {
            vm.dataToFill.personName = vm.dataToFill.personSelected.name;
            vm.dataToFill.personEmail = vm.dataToFill.personSelected.email;
            vm.dataToFill.personMobile = vm.dataToFill.personSelected.phone_number;
            vm.dataToFill.passengerId = vm.dataToFill.personSelected.employee_id;
            vm.is_vip = vm.dataToFill.personSelected.is_vip ? true : false;

        };

        function changeVip() {
            if (vm.newPersonFlag || vm.dataToFill.personFromDb)
                vm.is_vip = !vm.is_vip;
        }
        //=========================booking for=================================
        function bookingFor(type) {
            //console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>', type, "type", vm.selectedEmployeeData);
            if (vm.dataToFill.bookingFor > -1)
                if (vm.dataToFill.bookingFor == 1) {
                    vm.dataToFill.otherBooking = true;
                    vm.newPersonFlag = false;
                    vm.dataToFill.passengerRut = '';
                    // vm.dataToFill.applicantRut = '';
                    // vm.dataToFill.costCenter = '';
                    // vm.dataToFill.costSubCenter = '';
                    // vm.dataToFill.Rol = '';
                    // vm.dataToFill.graph = '';
                    // vm.dataToFill.workOrder = '';
                    // vm.dataToFill.pep = '';
                } else {
                    vm.dataToFill.otherBooking = false;
                    vm.dataToFill.passengerRut = RutHelper.format(vm.selectedEmployeeData.employee_details.RUT);
                    vm.dataToFill.applicantRut = vm.dataToFill.applicantRut || RutHelper.format(vm.selectedEmployeeData.employee_details.RUT);
                    vm.dataToFill.costCenter = vm.dataToFill.costCenter || vm.selectedEmployeeData.employee_details.cost_center;
                    vm.dataToFill.costSubCenter = vm.dataToFill.costSubCenter || vm.selectedEmployeeData.employee_details.cost_subcenter;
                    vm.dataToFill.Rol = vm.dataToFill.Rol || vm.selectedEmployeeData.employee_details.ROI;
                    vm.dataToFill.graph = vm.dataToFill.graph || vm.selectedEmployeeData.employee_details.graph;
                    //vm.dataToFill.workOrder = vm.selectedEmployeeData.employee_details.order_of_work;
                    vm.dataToFill.pep = vm.dataToFill.pep || vm.selectedEmployeeData.employee_details.PEP;

                    // ******* FOR MODIFY BOOKING ********
                    if (vm.bookingDetails && vm.bookingDetails.passenger_rut)
                        vm.dataToFill.passengerRut = RutHelper.format(vm.bookingDetails.passenger_rut);
                    if (vm.bookingDetails && vm.bookingDetails.applicant_rut)
                        vm.dataToFill.applicantRut = RutHelper.format(vm.bookingDetails.applicant_rut);
                    if (vm.bookingDetails && vm.bookingDetails.cost_center)
                        vm.dataToFill.costCenter = vm.bookingDetails.cost_center;
                    if (vm.bookingDetails && vm.bookingDetails.sub_cost_center)
                        vm.dataToFill.costSubCenter = vm.bookingDetails.sub_cost_center;
                    if (vm.bookingDetails && vm.bookingDetails.rol)
                        vm.dataToFill.Rol = vm.bookingDetails.rol;
                    if (vm.bookingDetails && vm.bookingDetails.graph)
                        vm.dataToFill.graph = vm.bookingDetails.graph;
                    if (vm.bookingDetails && vm.bookingDetails.PEP)
                        vm.dataToFill.pep = vm.bookingDetails.PEP;

                }
        };

        function bookingType() {
            if (vm.dataToFill.bookingType == '0') {
                if (vm.dataToFill.serviceTypeSelected && vm.dataToFill.pickUpLat && vm.dataToFill.airportCheck != 'Z' && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2)) {
                    vm.dataToFill.nearDriver = '';
                    toGetNearByDrivers(vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.serviceTypeSelected, map);
                }
                vm.dataToFill.currentBooking = 1;
                vm.dataToFill.scheduledBooking = 0;
            } else if (vm.dataToFill.bookingType == '1') {
                vm.dataToFill.currentBooking = 0;
                vm.dataToFill.scheduledBooking = 1;
                $timeout(function () {
                    changeDateStringToLocalizePickUpDate();
                });
                vm.dataToFill.nearDriver = '';
            }

            if (markers) {
                for (var i = 0; i < markers.length; i++) {
                    if (markers[i].id == 'driver') {
                        setMapOnAll(null, 'driver');
                    }
                }
            }
            //get_cuota();
        };

        function changeDateStringToLocalizePickUpDate() {
            if (document.getElementById('datePickerPickup')) {
                var arrayOfDate = (document.getElementById('datePickerPickup').value).split('-');
                var mesChanged = calenderTranslate.getTranslatedText(arrayOfDate[1]);
                if( mesChanged == undefined){
                    //si retorna undefined entonces el texto ya se encuentra traducido
                    mesChanged = arrayOfDate[1];
                }
                document.getElementById('datePickerPickup').value = arrayOfDate[0] + '-' + mesChanged + '-' + arrayOfDate[2];
            }
        }

        function changeDateStringToLocalizeDropOffDate() {
            if (document.getElementById('datePickerReturnDate')) {
                var arrayOfDate = (document.getElementById('datePickerReturnDate').value).split('-');
                document.getElementById('datePickerReturnDate').value = arrayOfDate[0] + '-' + calenderTranslate.getTranslatedText(arrayOfDate[1]) + '-' + arrayOfDate[2];
            }
        }

        function changeDateStringToLocalizeTillDate() {
            if (document.getElementById('datePickerTillDate')) {
                var arrayOfDate = (document.getElementById('datePickerTillDate').value).split('-');
                document.getElementById('datePickerTillDate').value = arrayOfDate[0] + '-' + calenderTranslate.getTranslatedText(arrayOfDate[1]) + '-' + arrayOfDate[2];
            }
        }

        function returnDateChange() {
            vm.modifyFalgNew = false;
            vm.dataToFill.returnTime = dateTimeFormat(vm.dataToFill.returnDate, vm.dataToFill.returnTime);
            changeDateStringToLocalizeDropOffDate();
            if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip == 'P' && vm.dataToFill.roundTrip) {
                calculateDateRangeOfPointToPointReturn();
            }
            if (vm.dataToFill.dropOffAddress != null && vm.dataToFill.pickUpAddress && vm.dataToFill.roundTrip) {
                calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, map, 'ROUND TRIP', vm.searchFixedVariablePayload);
                // $scope.$apply();
            }

             getFixedRoutesForPersonal(vm.dataToFill);
        }

        function tillDateChange($event) {
            changeDateStringToLocalizeTillDate();
            if (vm.type_of_trip1 == 'R' && vm.dataToFill.selectedServiceDetails.category == 1 && vm.method_range_pickup && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                checkAndMakeBookingData($event, true);
            }
        }

        function scheduleDateChanged() {
            vm.scheduleFlag = true;
            vm.dataToFill.scheduledTime = dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime);

            if(vm.disabledSubmitButton == false){
                setTimeout(function(){
                    vm.disabledSubmitButton = true;
                }, 1500);
            }
            if (vm.modifyFalg == false) {
                vm.dataToFill.returnDate = vm.dataToFill.bookingType == '1' ? vm.dataToFill.scheduledDate : new Date();
                vm.dataToFill.returnTime = vm.dataToFill.bookingType == '1' ? vm.dataToFill.scheduledDate : new Date();
                vm.dataToFill.dropDateReturn = vm.dataToFill.bookingType == '1' && moment(vm.dataToFill.dropDateReturn) < moment(vm.dataToFill.scheduledDate) ? vm.dataToFill.scheduledDate : vm.dataToFill.dropDateReturn;
                vm.roundTripTImeLess = false;
            } else {
                vm.roundTripTImeLess = true;
            }
            vm.modifyFalgNew = false;
            if (vm.modifyFalg == false) {
                vm.returnDateOptions.minDate = vm.dataToFill.bookingType == '1' ? vm.dataToFill.scheduledDate : new Date();
            }
            if (vm.dataToFill.dropOffAddress != null && vm.dataToFill.pickUpAddress) {
                calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, map, 'SINGLE TRIP', vm.searchFixedVariablePayload);
                // $scope.$apply();
            }
            $timeout(function () {
                changeDateStringToLocalizePickUpDate();
            });
            if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking == 'R') {
                calculateEstimatePickUpTimeForRType(vm.dataToFill.etaScheduleValue); 
                //calculateDateRangeOfPointToPoint(); 
            }
            vm.dataToFill.dropDate = vm.dataToFill.scheduledDate;
            setTimeout(function () {
                getFixedRoutesForPersonal(vm.dataToFill);
            }, 1000);
        }

        function dropDateChanged() {
            vm.dateFlag = true;
            vm.dataToFill.dropTime = dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime);
            if (vm.modifyFalg == false) {
                vm.dataToFill.returnDate = vm.dataToFill.dropDate;
                vm.dataToFill.returnTime = vm.dataToFill.dropDate;
                vm.roundTripTImeLess = false;
            } else {
                vm.roundTripTImeLess = true;
            }

            vm.returnDateOptions.minDate = vm.dataToFill.dropDate;
            //console.log(vm.dataToFill.dropDate, 'vm.dataToFill.dropDate');
            vm.modifyFalgNew = false;
            if (vm.dataToFill.dropOffAddress != null && vm.dataToFill.pickUpAddress) {
                calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, map, 'SINGLE TRIP', vm.searchFixedVariablePayload);
                // $scope.$apply();
            }
            if (((vm.type_of_trip1 == 'R' && vm.dataToFill.selectedServiceDetails.category == 1 && vm.method_range_pickup) || (vm.routingBase && vm.routingBase.routing_base_id > 0)) && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                vm.pickRangeSendForRouting = [];
                vm.etaArray = [];
                vm.timeZoneRecurring = [];
                vm.pickup_top_range = [];
                vm.pickup_lower_range = [];
                // RoutingApiFuncation(vm.dataToFill, 0);
            }
            setTimeout(function () {
                getFixedRoutesForPersonal(vm.dataToFill);
            }, 1000);
        }

        function dropDateReturnChanged() {
            vm.dataToFill.dropTimeReturn = dateTimeFormat(vm.dataToFill.dropDateReturn, vm.dataToFill.dropTimeReturn);
            //console.log(vm.dataToFill.dropDate, 'vm.dataToFill.dropDate');
            vm.modifyFalgNew = false;
            if (vm.dataToFill.dropOffAddress != null && vm.dataToFill.pickUpAddress) {
                calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, map, 'ROUND TRIP', vm.searchFixedVariablePayload);
                setTimeout(function () {
                    getFixedRoutesForPersonal(vm.dataToFill);
                }, 1000);

                // $scope.$apply();
            }
            if (vm.dataToFill.selectedServiceDetails.category == 1 && vm.type_of_trip == 'R' && vm.method_range_pickup_return && vm.dataToFill.roundTrip == 1) {
                RoutingApiFuncationRoundTrip(vm.dataToFill)
            }
        }

        function scheduleTimeChanged() {
            // vm.dataToFill.scheduledTime = dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime);
            $log.log(vm.dataToFill.scheduledTime);
            if(vm.dataToFill.scheduledTime == null){
                return;
            }
            if(vm.dataToFill.scheduledDate == ""){
                vm.dataToFill.scheduledDate = new Date();
            }
            vm.modifyFalgNew = false;
            vm.dataToFill.itemOfChargeSelected = [];
            if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking == 'P') {
                setTimeout(function () {
                calculateDateRangeOfPointToPoint();
                }, 600);
            }
            if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking == 'R') {
                setTimeout(function () {
                calculateEstimatePickUpTimeForRType(vm.dataToFill.etaScheduleValue); 
                //calculateDateRangeOfPointToPoint(); 
                }, 600);
            }
            if (vm.type_of_trip1 != 'P' && vm.flagForFlightDate == true) {
                setTimeout(function () {
                compareDates();
                }, 600);
            }
            if (vm.dataToFill.dropOffAddress != null && vm.dataToFill.pickUpAddress) {
                setTimeout(function () {
                calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, map, 'SINGLE TRIP', vm.searchFixedVariablePayload);
                // $scope.$apply();
                }, 600);
            }
            //get_cuota();
            vm.dataToFill.dropTime = vm.dataToFill.scheduledTime;
            setTimeout(function () {
                if(vm.dataToFill.selectedServiceDetails.category == 0 || (vm.dataToFill.selectedServiceDetails.category == 1 && vm.dataToFill.airportCheck == 'Z')){
                    getFixedRoutesForPersonal(vm.dataToFill);
                }
            }, 1000);
 
        };

        // function dropTimeChangedForRType() {
        //     calculateEstimatePickUpTimeForRType(vm.dataToFill.etaScheduleValue);
        // }

        function dropTimeChanged() {
            if(vm.dataToFill.scheduledTime == null){
                return;
            }
            vm.dateFlag = true;
            // compareDates();
            vm.modifyFalgNew = false;
            if (vm.type_of_trip1 != 'P' && vm.flagForFlightDate == true) {
                setTimeout(function () {
                compareDates();
                }, 600);
            }
            $log.log(vm.dataToFill.dropTime);
            vm.dataToFill.dropTime = vm.dataToFill.dropTime;
            // vm.dataToFill.dropTime = dateTimeFormat(vm.dataToFill.dropDate,vm.dataToFill.dropTime);
            if (vm.dataToFill.selectedServiceDetails.category == 1 && vm.dataToFill.etaScheduleValue){
                setTimeout(function () {
                calculateEstimatePickUpTime(vm.dataToFill.etaScheduleValue);
                }, 600);
            }
            if (vm.dataToFill.dropOffAddress != null && vm.dataToFill.pickUpAddress) {
                setTimeout(function () {
                calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, map, 'SINGLE TRIP', vm.searchFixedVariablePayload);
                }, 600);
                // $scope.$apply();
            }
            if (((vm.type_of_trip1 == 'R' && vm.dataToFill.selectedServiceDetails.category == 1 && vm.method_range_pickup) || (vm.routingBase && vm.routingBase.routing_base_id > 0)) && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                vm.pickRangeSendForRouting = [];
                vm.etaArray = [];
                vm.timeZoneRecurring = [];
                vm.pickup_lower_range = [];
                vm.pickup_top_range = [];
                // $timeout(function () {
                //     RoutingApiFuncation(vm.dataToFill, 0);
                // }, 500);

            }
            setTimeout(function () {
                if(vm.dataToFill.selectedServiceDetails.category == 0 || (vm.dataToFill.selectedServiceDetails.category == 1 && vm.dataToFill.airportCheck == 'Z') || vm.modifyBooking){
                    getFixedRoutesForPersonal(vm.dataToFill);
                }
            }, 1000);
        };

        function dropTimeReturnChanged() {
            vm.modifyFalgNew = false;
            // vm.dataToFill.dropTimeReturn = dateTimeFormat(vm.dataToFill.dropDateReturn ,vm.dataToFill.dropTimeReturn);
            // console.log(vm.dataToFill.dropTimeReturn,'vm.dataToFill.dropTimeReturn');
            if (vm.dataToFill.selectedServiceDetails.category == 1 && vm.dataToFill.etaScheduleValueReturn)
                calculateEstimatePickUpTime(vm.dataToFill.etaScheduleValueReturn);
            if (vm.dataToFill.dropOffAddress != null && vm.dataToFill.pickUpAddress) {
                calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, map, 'ROUND TRIP', vm.searchFixedVariablePayload);
                // $scope.$apply();
            }
            if (vm.dataToFill.selectedServiceDetails.category == 1 && vm.type_of_trip == 'R' && vm.method_range_pickup_return && vm.dataToFill.roundTrip == 1) {
                $timeout(function () {
                    RoutingApiFuncationRoundTrip(vm.dataToFill)
                }, 500);
                
            }

            setTimeout(function () {
                getFixedRoutesForPersonal(vm.dataToFill);
            }, 1000);
        };

        function retunrTimeChanged() {
            vm.modifyFalgNew = false;
            $log.log(vm.dataToFill.returnTime);
            if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip == 'P' && vm.dataToFill.roundTrip) {
                calculateDateRangeOfPointToPointReturn();
            }
            if (vm.dataToFill.dropOffAddress != null && vm.dataToFill.pickUpAddress && vm.dataToFill.roundTrip) {
                calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, map, 'ROUND TRIP', vm.searchFixedVariablePayload);
                // $scope.$apply();
            }
            getFixedRoutesForPersonal(vm.dataToFill);
            // vm.dataToFill.returnTime = dateTimeFormat(vm.dataToFill.returnDate,vm.dataToFill.returnTime);
        };

        function tillTimes() {
            $log.log('Time', vm.dataToFill.tillTime);
        };
        //==================date picker function==================
        vm.dateOptions = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(2090, 12, 31),
            minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };
        vm.returnDateOptions = {
            formatYear: 'yy',
            maxDate: new Date(2090, 12, 31),
            minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };

        function datePickerE_1(type) {
            if (type == '1') {
                vm.datePicker_1.scheduledDate = true;
            } else if (type == '2') {
                vm.datePicker_1.returnDate = true;
            } else if (type == '3') {
                vm.datePicker_1.dropDate = true;
            } else if (type == '4') {
                vm.datePicker_1.dropDateReturn = true;
            }
            $timeout(function () {
                calenderTranslateFunction();
            }, 100);
        };

        function calenderTranslateFunction() {

            // TO CHANGE TITLE 
            if (document.getElementsByClassName('uib-title')[0])
                if (document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ').length == 2) {
                    document.getElementsByClassName('uib-title')[0].firstChild.style.display = 'none';
                    var span = document.createElement("span");
                    span.setAttribute('class', 'spanishMonth');
                    if( calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[0]) == undefined && document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[0] != undefined){
                        span.innerHTML = document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[0] + ' ' + document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[1];
                    } else {
                        span.innerHTML = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[0]) + ' ' + document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[1];
                    }
                    document.getElementsByClassName('uib-title')[0].appendChild(span);
                    // document.getElementsByClassName('uib-title')[0].firstChild.innerText = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[0]) + ' ' + document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[1];
                    // TO CHANGE DAYS OF WEEK
                    var primerDia = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-datepicker')[0].firstElementChild.firstElementChild.lastElementChild.cells[0].innerText);
                    if( primerDia != undefined ){
                        document.getElementsByClassName('uib-datepicker')[0].firstElementChild.firstElementChild.lastElementChild.cells[0].innerText = primerDia;
                    }
                    var segundoDia = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-datepicker')[0].firstElementChild.firstElementChild.lastElementChild.cells[1].innerText);
                    if( segundoDia != undefined ){
                        document.getElementsByClassName('uib-datepicker')[0].firstElementChild.firstElementChild.lastElementChild.cells[1].innerText = segundoDia;
                    }
                    var tercerDia = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-datepicker')[0].firstElementChild.firstElementChild.lastElementChild.cells[2].innerText);
                    if( tercerDia != undefined ){
                        document.getElementsByClassName('uib-datepicker')[0].firstElementChild.firstElementChild.lastElementChild.cells[2].innerText = tercerDia;
                    }
                    var cuartoDia = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-datepicker')[0].firstElementChild.firstElementChild.lastElementChild.cells[3].innerText);
                    if(cuartoDia != undefined){
                        document.getElementsByClassName('uib-datepicker')[0].firstElementChild.firstElementChild.lastElementChild.cells[3].innerText = cuartoDia;
                    }
                    var quintoDia = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-datepicker')[0].firstElementChild.firstElementChild.lastElementChild.cells[4].innerText);
                    if( quintoDia != undefined){
                        document.getElementsByClassName('uib-datepicker')[0].firstElementChild.firstElementChild.lastElementChild.cells[4].innerText = quintoDia;
                    }
                    var sextoDia = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-datepicker')[0].firstElementChild.firstElementChild.lastElementChild.cells[5].innerText);
                    if( sextoDia != undefined){
                        document.getElementsByClassName('uib-datepicker')[0].firstElementChild.firstElementChild.lastElementChild.cells[5].innerText = sextoDia;
                    }
                    var septimoDia = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-datepicker')[0].firstElementChild.firstElementChild.lastElementChild.cells[6].innerText);
                    if( septimoDia != undefined ){
                        document.getElementsByClassName('uib-datepicker')[0].firstElementChild.firstElementChild.lastElementChild.cells[6].innerText = septimoDia;
                    }
                }

            // TO CLICK ON MONTH TO CHANGE MONTH
            document.getElementsByClassName('uib-title')[0].onclick = function () {
                $timeout(function () {
                    changeMonthText();

                    // FOR YEAR VIEW
                    document.getElementsByClassName('uib-title')[0].onclick = function () {
                        $timeout(function () {
                            // FOR RIGHT CLICK
                            document.getElementsByClassName('uib-right')[0].onclick = function () {
                                $timeout(function () {
                                    calenderTranslateFunction();
                                });
                            }
                            // FOR LEFT CLICK
                            document.getElementsByClassName('uib-left')[0].onclick = function () {
                                $timeout(function () {
                                    calenderTranslateFunction();
                                });
                            }

                            // FOR CLICK ON YEAR VIEW
                            if (document.getElementsByClassName('uib-yearpicker')[0])
                                document.getElementsByClassName('uib-yearpicker')[0].lastElementChild.onclick = function () {
                                    $timeout(function () {
                                        calenderTranslateFunction();
                                        changeMonthText();
                                    });
                                }
                        });
                    }
                    // FOR RIGHT CLICK
                    document.getElementsByClassName('uib-right')[0].onclick = function () {
                        $timeout(function () {
                            calenderTranslateFunction();
                            changeMonthText();
                        });
                    }
                    // FOR LEFT CLICK
                    document.getElementsByClassName('uib-left')[0].onclick = function () {
                        $timeout(function () {
                            calenderTranslateFunction();
                            changeMonthText();
                        });
                    }

                    // FOR CLICK ON MONTH VIEW
                    document.getElementsByClassName('uib-monthpicker')[0].lastElementChild.onclick = function () {
                        $timeout(function () {
                            calenderTranslateFunction();
                        });
                    }
                });
            }
            // FOR CLICK ON MONTH VIEW DEFAULT AFTER YEAR VIEW
            if (document.getElementsByClassName('uib-monthpicker')[0])
                document.getElementsByClassName('uib-monthpicker')[0].lastElementChild.onclick = function () {
                    $timeout(function () {
                        calenderTranslateFunction();
                    });
                }
            // FOR RIGHT CLICK
            document.getElementsByClassName('uib-right')[0].onclick = function () {
                if (document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ').length == 2) {
                    document.getElementsByClassName('uib-title')[0].firstChild.style.display = 'none';
                    if (document.getElementsByClassName('spanishMonth').length) {
                        document.getElementsByClassName('spanishMonth')[0].remove();
                    }
                    var span = document.createElement("span");
                    span.setAttribute('class', 'spanishMonth');
                    //correccion de fix cuando la reserva se repite y es necesario cambiar la fecha
                    if( document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[0] != undefined && calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[0]) == undefined){
                        span.innerHTML = document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[0] + ' ' + document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[1];
                        document.getElementsByClassName('uib-title')[0].appendChild(span);
                    } else {
                        span.innerHTML = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[0]) + ' ' + document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[1];
                        document.getElementsByClassName('uib-title')[0].appendChild(span);
                    }
                } else {
                    $timeout(function () {
                        calenderTranslateFunction();
                        changeMonthText();
                    });
                }
            }

            // FOR LEFT CLICK
            document.getElementsByClassName('uib-left')[0].onclick = function () {
                if (document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ').length == 2) {
                    document.getElementsByClassName('uib-title')[0].firstChild.style.display = 'none';
                    if (document.getElementsByClassName('spanishMonth').length) {
                        document.getElementsByClassName('spanishMonth')[0].remove();
                    }
                    var span = document.createElement("span");
                    span.setAttribute('class', 'spanishMonth');
                    //correccion de fix cuando la reserva se repite y es necesario cambiar la fecha
                    if( document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[0] != undefined && calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[0]) == undefined){
                        span.innerHTML = document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[0] + ' ' + document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[1];
                    } else {
                        span.innerHTML = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[0]) + ' ' + document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[1];
                    }
                    document.getElementsByClassName('uib-title')[0].appendChild(span);
                    // document.getElementsByClassName('uib-title')[0].firstChild.innerText = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[0]) + ' ' + document.getElementsByClassName('uib-title')[0].firstChild.textContent.split(' ')[1];
                } else {
                    $timeout(function () {
                        calenderTranslateFunction();
                        changeMonthText();
                    });
                }
            }

        }

        // FOR CHANGE MONTHS
        function changeMonthText() {
            var nbMonthEne = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-month')[0].firstElementChild.innerText);
            var nbMonthFeb = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-month')[1].firstElementChild.innerText);
            var nbMonthMar = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-month')[2].firstElementChild.innerText);
            var nbMonthAbr = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-month')[3].firstElementChild.innerText);
            var nbMonthMay = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-month')[4].firstElementChild.innerText);
            var nbMonthJun = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-month')[5].firstElementChild.innerText);
            var nbMonthJul = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-month')[6].firstElementChild.innerText);
            var nbMonthAgo = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-month')[7].firstElementChild.innerText);
            var nbMonthSep = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-month')[8].firstElementChild.innerText);
            var nbMonthOct = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-month')[9].firstElementChild.innerText);
            var nbMonthNov = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-month')[10].firstElementChild.innerText);
            var nbMonthDic = calenderTranslate.getTranslatedText(document.getElementsByClassName('uib-month')[11].firstElementChild.innerText);
            if( nbMonthEne != undefined){
                document.getElementsByClassName('uib-month')[0].firstElementChild.innerText = nbMonthEne;
            }
            if( nbMonthFeb != undefined ){
                document.getElementsByClassName('uib-month')[1].firstElementChild.innerText = nbMonthFeb;
            }
            if( nbMonthMar != undefined ){
                document.getElementsByClassName('uib-month')[2].firstElementChild.innerText = nbMonthMar;
            }
            if( nbMonthAbr != undefined ){
                document.getElementsByClassName('uib-month')[3].firstElementChild.innerText = nbMonthAbr;
            }
            if( nbMonthMay != undefined ){
                document.getElementsByClassName('uib-month')[4].firstElementChild.innerText = nbMonthMay;
            }
            if( nbMonthJun != undefined ){
                document.getElementsByClassName('uib-month')[5].firstElementChild.innerText = nbMonthJun;
            }
            if( nbMonthJul != undefined ){
                document.getElementsByClassName('uib-month')[6].firstElementChild.innerText = nbMonthJul;
            }
            if( nbMonthAgo != undefined ){
                document.getElementsByClassName('uib-month')[7].firstElementChild.innerText = nbMonthAgo;
            }
            if( nbMonthSep != undefined ){
                document.getElementsByClassName('uib-month')[8].firstElementChild.innerText = nbMonthSep;
            }
            if( nbMonthOct != undefined ){
                document.getElementsByClassName('uib-month')[9].firstElementChild.innerText = nbMonthOct;
            }
            if( nbMonthNov != undefined ){
                document.getElementsByClassName('uib-month')[10].firstElementChild.innerText = nbMonthNov;
            }
            if( nbMonthDic != undefined ){
                document.getElementsByClassName('uib-month')[11].firstElementChild.innerText = nbMonthDic;
            }

        }

        vm.dateOption = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(2090, 12, 31),
            minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };

        function datePickerE_2(type) {
            if (type == '1') {
                vm.datePicker_2.tillDate = true;
                $timeout(function () {
                    calenderTranslateFunction();
                }, 100);
            }
            //console.log('date', vm.dataToFill.tillDate)
        };
        //================set map nulll======================
        function setMapOnAll(map, id) {
            for (var i = 0; i < markers.length; i++) {
                if (markers[i].id == id) {
                    var marker = markers[i];
                    marker.setMap(map);
                }
            }
        };
        // If the map position is out of range, move it back
        function checkBounds(map) {
            if (typeof (map.getBounds()) == 'undefined')
                return;

            var latNorth = map.getBounds().getNorthEast().lat();
            var latSouth = map.getBounds().getSouthWest().lat();
            var newLat;

            if (latNorth < 85 && latSouth > -85) /* in both side -> it's ok */
                return;
            else {
                if (latNorth > 85 && latSouth < -85) /* out both side -> it's ok */
                    return;
                else {
                    if (latNorth > 85)
                        newLat = map.getCenter().lat() - (latNorth - 85);
                    /* too north, centering */
                    if (latSouth < -85)
                        newLat = map.getCenter().lat() - (latSouth + 85);
                    /* too south, centering */
                }
            }
            if (newLat) {
                var newCenter = new google.maps.LatLng(newLat, map.getCenter().lng());
                map.setCenter(newCenter);
            }
        }
        //===========================auto complete===============================
        var autocomplete, autocompleteD;
        var domain = checkDomain.getDomainName();

        function pickUpaddressBlack(data) {
            if (data == undefined) {
                $(".pac-container").hide();
            }
        }

        function dropOfdAddressBlack(data) {
            if (data == undefined) {
                $(".pac-container").hide();
            }
        }

        function PickUpAddressLength(data) {
            if (data == undefined) {
                $(".pac-container").hide();
            }
            vm.addressChange = true;
            initAutocomplete(data, '');
        }

        function DropUpAddressLength(data) {
            if (data == undefined) {
                $(".pac-container").hide();
            }
            vm.addressChange = true;
            initAutocomplete('', data)
        }


        function initAutocomplete(Pickdata, DropData) {
            //console.log(Pickdata, DropData, 'Pickdata, DropData');
            var pickup = document.getElementById('pickUpAddress');
            var dropAddresss = document.getElementById('dropOffAddress');
            if ((!vm.pickAddressFlag) && Pickdata && Pickdata.length >= 3) {
                //console.log(Pickdata.length, "pickdata");
                vm.pickAddressFlag = true;
                autocomplete = new google.maps.places.Autocomplete(
                    pickup, {
                    placeIdOnly: true
                });
                if (domain != 'dev' && domain != 'test') {
                    autocomplete.setComponentRestrictions({
                        'country': ['CL']
                    });
                }
                autocomplete.addListener('place_changed', fillInAddress);

            } else if (Pickdata && Pickdata.length < 3) {
                vm.pickAddressFlag = false;
                google.maps.event.clearInstanceListeners(pickup);
                $(".pac-container").hide();
            }
            console.log('>>>>> IN INIT >>>>>', vm.dropAddressFlag, DropData);
            if ((!vm.dropAddressFlag) && DropData && DropData.length >= 3) {
                vm.dropAddressFlag = true;
                //console.log(DropData.length, 'length');
                autocompleteD = new google.maps.places.Autocomplete(
                    dropAddresss, {
                    placeIdOnly: true
                });
                if (domain != 'dev' && domain != 'test')
                    autocompleteD.setComponentRestrictions({
                        'country': ['CL']
                    });
                autocompleteD.addListener('place_changed', fillInAddressD);

            } else if (DropData && DropData.length < 3) {
                vm.dropAddressFlag = false;
                google.maps.event.clearInstanceListeners(dropAddresss);
                $(".pac-container").hide();
            }
        };


        //function getFormattedAddress(place){
        //    var street,route,city,formattedAddress;
        //
        //    for(var i=0;i<place.address_components.length;i++){
        //        for(var j=0;j<place.address_components[i].types.length;j++){
        //            if(place.address_components[i].types[j] == 'street_number'){
        //                street = place.address_components[i].short_name;
        //            }
        //            if(place.address_components[i].types[j] == 'route'){
        //                route = place.address_components[i].short_name;
        //            }
        //            if(place.address_components[i].types[j] == 'locality'){
        //                city = place.address_components[i].short_name;
        //            }
        //        }
        //    }
        //
        //    //var formattedAddress = place.formatted_address;
        //    if(street){
        //        if(route){
        //            if(city){
        //                formattedAddress = route + ' ' + street + ', ' + city;
        //            }
        //            else{
        //                formattedAddress = route + ' ' + street;
        //            }
        //        }
        //        else{
        //            if(city){
        //                formattedAddress = street + ', ' + city;
        //            }
        //            else{
        //                formattedAddress = street;
        //            }
        //        }
        //    }
        //    else{
        //        if(route){
        //            if(city){
        //                formattedAddress = route + ', ' + city;
        //            }
        //            else{
        //                formattedAddress = route;
        //            }
        //        }
        //        else{
        //            if(city){
        //                formattedAddress = city;
        //            }
        //            else{
        //                formattedAddress = '';
        //            }
        //        }
        //    }
        //    return formattedAddress;
        //}

        function fillInAddress(data) {
            $(".pac-container").hide();
            // Get the place details from the autocomplete object.

            var place = autocomplete.getPlace();
            geocoder.geocode({
                'placeId': place.place_id
            }, function (results, status) {
                //console.log(results, status, "geocode ----------------")
                //console.log(results[0].geometry.location.lat(), results[0].geometry.location.lng(), 'results[0].geometry.location.lat()');

                if (status !== 'OK') {
                    window.alert('Geocoder failed due to: ' + status);
                    return;
                }
                var city;
                for (var i = 0; i < results[0].address_components.length; i++) {
                    for (var j = 0; j < results[0].address_components[i].types.length; j++) {
                        if (results[0].address_components[i].types[j] == 'locality') {
                            city = results[0].address_components[i].short_name;
                        }
                    }
                }

                if (vm.pickUpCity && (vm.pickUpCity != city)) {
                    errorMessageFactory.showErrorMessage('Error, esta dirección cambia el tramo original. El cambio no debe afectar la tarifa.', 0);
                    // results= '';
                    vm.dataToFill.pickUpAddress = vm.pickUpAddress;
                    vm.addressChange = false;
                    return;
                }
                $scope.addressPick = hidePublicPlaces.formattedAddress(results[0]);
                $scope.addressLat = results[0].geometry.location.lat();
                $scope.addressLng = results[0].geometry.location.lng();
                var string = results[0].formatted_address;
                var address = string.replace(", Chile", " ");
                vm.dataToFill.pickUpAddress = address;
                vm.dataToFill.pickUpLat = $scope.addressLat;
                vm.dataToFill.pickUpLng = $scope.addressLng;
                vm.dataToFill.pickLat = $scope.addressLat;
                vm.dataToFill.pickLng = $scope.addressLng;
                vm.dataToFill.previousPickFlag = false;
                vm.pickaddressChange = true;
                vm.dataToFill.previousDropFlag = false;
                getFavoriteAddress('pick');
                // ********** TO GET CITY OF ADDRESS **********
                results[0].address_components.forEach(function (data) {
                    if (data.types[0] == 'locality') {
                        vm.jobPickupComuna = data.long_name || null;
                    }
                });

                $scope.$apply();
                vm.getFixedRoutesForPersonalFlag = true;
                var location = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
                //zoomLevel = 12;
                // $timeout(function () {
                //     placeMarker(map, location, 'pick');
                // }, 2000);
                if (vm.toAirportFlag) {
                    getAirportAddressApi();
                }
                if (vm.ptopAirportFlag && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                    getFixedRoutesForPersonal(vm.dataToFill);
                }
                if (vm.dataToFill.serviceTypeSelected) { //&& (vm.dataToFill.bookingType == '0' || vm.dataToFill.bookingType == 0)
                    vm.dataToFill.nearDriver = '';
                    toGetAirportService(results[0].geometry.location.lat(), results[0].geometry.location.lng(), vm.dataToFill.serviceTypeSelected, map);
                    //toGetNearByDrivers(vm.dataToFill.pickUpLat,vm.dataToFill.pickUpLng,vm.dataToFill.serviceTypeSelected,map);
                }
            });
        };

        function reverseGeocodeForPickUp() {
            var geocoder = new google.maps.Geocoder;
            geocoder.geocode({
                'address': vm.pickUpAddress
            }, function (results, status) {
                if (status === 'OK') {
                    for (var i = 0; i < results[0].address_components.length; i++) {
                        for (var j = 0; j < results[0].address_components[i].types.length; j++) {
                            if (results[0].address_components[i].types[j] == 'locality') {
                                vm.pickUpCity = results[0].address_components[i].short_name;
                            }
                        }
                    }
                } else {
                    window.alert('Geocode was not successful for the following reason: ' +
                        status);
                }
            });
        }





        function reverseGeocodeForDropUp() {
            var geocoder = new google.maps.Geocoder;
            geocoder.geocode({
                'address': vm.pickUpAddress
            }, function (results, status) {
                if (status === 'OK') {
                    for (var i = 0; i < results[0].address_components.length; i++) {
                        for (var j = 0; j < results[0].address_components[i].types.length; j++) {
                            if (results[0].address_components[i].types[j] == 'locality') {
                                vm.dropUpCity = results[0].address_components[i].short_name;
                            }
                        }
                    }
                } else {
                    window.alert('Geocode was not successful for the following reason: ' +
                        status);
                }
            });
        }

        function fillInAddressD() {
            $(".pac-container").hide();
            var placeD = autocompleteD.getPlace();
            geocoder.geocode({
                'placeId': placeD.place_id
            }, function (results, status) {

                if (status !== 'OK') {
                    window.alert('Geocoder failed due to: ' + status);
                    return;
                }
                var city;
                for (var i = 0; i < results[0].address_components.length; i++) {
                    for (var j = 0; j < results[0].address_components[i].types.length; j++) {
                        if (results[0].address_components[i].types[j] == 'locality') {
                            city = results[0].address_components[i].short_name;
                        }
                    }
                }
                if (vm.dropUpCity && (vm.dropUpCity != city)) {
                    errorMessageFactory.showErrorMessage('Error, esta dirección cambia el tramo original. El cambio no debe afectar la tarifa.', 0);
                    // results= '';
                    vm.dataToFill.dropOffAddress = vm.dropUpAddress;
                    vm.addressChange = false;
                    return;
                }
                $scope.addressDrop = hidePublicPlaces.formattedAddress(results[0]);
                $scope.addressDLat = results[0].geometry.location.lat();
                $scope.addressDLng = results[0].geometry.location.lng();
                var string1 = results[0].formatted_address;
                var address1 = string1.replace(", Chile", " ");
                vm.dataToFill.dropOffAddress = address1;
                vm.dataToFill.dropOffLat = $scope.addressDLat;
                vm.dataToFill.dropOffLng = $scope.addressDLng;
                vm.dataToFill.dropLat = $scope.addressDLat;
                vm.dataToFill.dropLng = $scope.addressDLng;
                vm.dataToFill.previousPickFlag = false;
                vm.dataToFill.previousDropFlag = false;
                vm.dropaddressChange = true;

                // ********** TO GET CITY OF ADDRESS **********
                results[0].address_components.forEach(function (data) {
                    if (data.types[0] == 'locality') {
                        vm.jobDropoffComuna = data.long_name || null;
                    }
                });
                getFavoriteAddress('drop');
                $scope.$apply();
                vm.getFixedRoutesForPersonalFlag = true;
                var locationD = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
                //zoomLevel = 12;
                // $timeout(function () {
                //     placeMarker(map, locationD, 'drop');
                // }, 2000)
                if (vm.fromAirportFlag) {
                    getAirportAddressApi();
                }
                if (vm.ptopAirportFlag && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                    getFixedRoutesForPersonal(vm.dataToFill);
                }

            });


        };

        function calculatePrice(payload) {
            //TDM213 BOTH FOR FIXED AND VARIABLE
            vm.toll_price = 0;
            vm.toll_id = false;
            for (var i = 0; i < payload.title.data.price_list.itemOfCharge.length; i++) {
                if (payload.title.data.price_list.itemOfCharge[i].itemOfChargeId === 2) {
                    vm.toll_id = true;
                    vm.tollChargeWay = payload.title.data.price_list.itemOfCharge[i].tollChargeWay;
                    vm.toll_price = payload.title.data.price_list.itemOfCharge[i].price;
                }
            }
            if (payload.title.data.apply_charge_by_toll && vm.toll_id && !vm.modifyFalgNew) {
                if (vm.tollChargeWay == 1) {
                    vm.tollPriceToAdd = Math.round(vm.toll_price);
                    vm.estimated_toll_price = vm.tollPriceToAdd * vm.tollCount;
                }
                else if (vm.tollChargeWay == 2) {
                    vm.tollPriceToAdd = Math.round(vm.tollPrice);
                    vm.estimated_toll_price = vm.tollPriceToAdd;
                }
                else {
                    vm.estimated_toll_price = 0;
                }
            } else {
                if(vm.modifyBooking && !vm.toll_id){
                    vm.estimated_toll_price = 0;
                } else {
                    vm.estimated_toll_price = vm.bookingDetails ? vm.bookingDetails.estimated_toll_price : 0;
                }
            }
            //TDM213 BOTH FOR FIXED AND VARIABLE

            console.log('debug calculatePrice', vm.dataToFill.roundTrip);
            if (vm.dataToFill.route_type == 1) //fixed
            {

                vm.dataToFill.estimatedFareVariable = (vm.dataToFill.selectedServiceDetails.fare_type ? 
                    Number(payload.title.data.price) * Number(vm.dataToFill.passengerCount) : payload.title.data.price)
                    + vm.estimated_toll_price;

                vm.dataToFill.estimatedFareRoute = (vm.dataToFill.selectedServiceDetails.fare_type ? 
                    Number(payload.title.data.price) * Number(vm.dataToFill.passengerCount) : payload.title.data.price)
                    + vm.estimated_toll_price;
        
                if (vm.dataToFill.itemOfChargeSelected.length > 0) {
                    for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                        if(vm.dataToFill.itemOfChargeSelected[i].retorno == false) {
                            vm.dataToFill.estimatedFareRoute = (vm.dataToFill.estimatedFareRoute + 
                                Number(vm.dataToFill.itemOfChargeSelected[i].price)) + vm.estimated_toll_price;
                        }
    
                    }
                }

                vm.dataToFill.onlyPrice = Number(payload.title.data.price);
                vm.dataToFill.estimatedFare = vm.dataToFill.estimatedFareRoute;
                vm.fixedPriceFromSearchFixesVariable = (vm.dataToFill.selectedServiceDetails.fare_type ? 
                    Number(payload.title.data.price) * Number(vm.dataToFill.passengerCount) : payload.title.data.price)
                    + vm.estimated_toll_price || 0;
    
                vm.dataToFill.estimatedFareRoute = Number(payload.title.data.price) + vm.estimated_toll_price;
                vm.dataToFill.onlyPrice = Number(payload.title.data.price);

                vm.dataToFill.minimumFare = 0;
                vm.calculatedEstimatePriceFormFunctionEstimated = -1;

                //TDM 213 TOLL PRICE IN FIXED

            }
            // variable
            else {
                if (vm.dataToFill.estimatedDistance != undefined && vm.dataToFill.etaScheduleValue != undefined) {
                    vm.estimated_eta = (vm.dataToFill.etaScheduleValue * payload.title.data.time_of_trip_price);
                    vm.estimated_distance = (vm.dataToFill.estimatedDistance * payload.title.data.perKMChanges);
                    var calEstFare = Number(vm.estimated_distance + vm.estimated_eta + vm.estimated_toll_price + payload.title.data.baseFare);
                }
                // console.log('calEstFarecalEstFarecalEstFare', calEstFare);
                if (vm.dataToFill.selectedServiceDetails.fare_type) {
                    if ((Number(calEstFare) * Number(vm.dataToFill.passengerCount)) < Number(payload.title.data.minimumFare)) {
                        if (vm.dataToFill.factor_value) {
                            vm.dataToFill.estimatedFareRoute = Number(payload.title.data.minimumFare) * vm.dataToFill.factor_value;
                        } else {
                            vm.dataToFill.estimatedFareRoute = payload.title.data.minimumFare;
                        }
                    } else {
                        vm.dataToFill.estimatedFareRoute = Number(calEstFare) * Number(vm.dataToFill.passengerCount);
                    }
                } else {
                    if (calEstFare <= Number(payload.title.data.minimumFare)) {
                        if (vm.dataToFill.factor_value) {
                            vm.dataToFill.estimatedFareRoute = Number(payload.title.data.minimumFare) * vm.dataToFill.factor_value;
                        } else {
                            vm.dataToFill.estimatedFareRoute = payload.title.data.minimumFare;
                        }
                    } else {
                        vm.dataToFill.estimatedFareRoute = calEstFare;
                    }
                }
                vm.dataToFill.estimatedFare = vm.dataToFill.estimatedFareRoute;
                vm.dataToFill.estimatedFareVariable = calEstFare;
                vm.dataToFill.estimatedFareRoute = calEstFare;
                vm.dataToFill.minimumFare = payload.title.data.minimumFare;
                vm.calculatedEstimatePriceFormFunctionEstimated = -1;
                // showEstimatePriceInHtml(vm.dataToFill.roundTrip, vm.viaControlledFLag1, vm.viaControlledFLag);
                console.log('debug vm.dataToFill.route_type', vm.dataToFill.route_type, vm.dataToFill.estimatedFareRoute, vm.dataToFill.estimatedFare, vm.dataToFill.estimatedFareVariable, vm.dataToFill.estimatedFareRoute, vm.dataToFill.minimumFare, vm.calculatedEstimatePriceFormFunctionEstimate, calEstFare);
            }
            if (vm.dataToFill.roundTrip) {
                setBooleans('ROUND_TRIP', true);
            }
        }

        function toGetAirportServiceNew(lat, lng, service, map) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.latitude = lat;
            dataSend.longitude = lng;
            dataSend.service_id = service;
            vm.loading = true;
            var promise = getBookings.getAirportZone(dataSend);
            promise.then(
                function (payload) {
                    if (payload.title.data.time_trip_shared_service) {
                        vm.dataToFill.time_trip_shared_service = payload.title.data.time_trip_shared_service;
                    } else vm.dataToFill.time_trip_shared_service = 0;
                },
                function (errorPayload) {
                    vm.loading = false;

                    if (errorPayload.data.status == 400) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                    if (markers.length) {
                        for (var i = 0; i < markers.length; i++) {
                            if (markers[i].id == 'driver') {
                                setMapOnAll(null, 'driver');
                            }
                        }
                    }
                    $log.log(errorPayload);
                }
            );
        }
        // ============================= Rounding Function ============================= //
        function roundToTwo(num) {
            console.log('debug num', num, +(Math.round(num + "e+2") + "e-2"));
            return +(Math.round(num + "e+2") + "e-2");
        }

        function calculateAndDisplayRoute(directionsService, directionsDisplay, lat1, lng1, lat2, lng2, map, type, payload) {
            console.log('>>>>>>>>>>>>>>>>>>>calculateAndDisplayRoute>>>>>>>>>>>>>>>>>>');

            directionsDisplay.setMap(map);
            directionsDisplay.setOptions({
                suppressMarkers: true
            });
            var myLatlng = new google.maps.LatLng(lat1, lng1);
            var myLatlng1 = new google.maps.LatLng(lat2, lng2);
            var sendDate;
            if (type == 'ROUND TRIP') {
                if (vm.bookingDetails) {
                    if (new Date(vm.bookingDetails.return_date_time_utc) != 'Invalid Date') {

                        if (moment(dateTimeFormat(vm.dataToFill.dropDateReturn, vm.dataToFill.dropTimeReturn)).isAfter(new Date()))
                            sendDate = dateTimeFormat(vm.dataToFill.dropDateReturn, vm.dataToFill.dropTimeReturn);
                        else
                            sendDate = new Date();
                    } else {
                        sendDate = new Date();
                    }
                } else {
                    if(vm.type_of_trip == 'R'){
                        if (new Date(vm.dataToFill.dropDateReturn) != 'Invalid Date' && new Date(vm.dataToFill.dropTimeReturn) != 'Invalid Date') {
                            if (moment(dateTimeFormat(vm.dataToFill.dropDateReturn, vm.dataToFill.dropTimeReturn)).isAfter(new Date())) {
                                sendDate = dateTimeFormat(vm.dataToFill.dropDateReturn, vm.dataToFill.dropTimeReturn);
                            }
                            else {
                                sendDate = new Date();
                            }
                        }
                    }else{
                        if (new Date(vm.dataToFill.returnDate) != 'Invalid Date' && new Date(vm.dataToFill.returnTime) != 'Invalid Date') {
                            if (moment(dateTimeFormat(vm.dataToFill.returnDate, vm.dataToFill.returnTime)).isAfter(new Date())) {
                                sendDate = dateTimeFormat(vm.dataToFill.returnDate, vm.dataToFill.returnTime);
                            }
                            else {
                                sendDate = new Date();
                            }
                        }
                    }
                }
            }
            else {
                if (vm.scheduleFlag == true && new Date(vm.dataToFill.scheduledDate) != 'Invalid Date' && new Date(vm.dataToFill.scheduledTime) != 'Invalid Date') {
                    var schuduleDate = dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime);

                    if (moment(dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime)).isAfter(new Date()))
                        sendDate = dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime);
                    else
                        sendDate = new Date();

                }
                else if (vm.dateFlag == true && new Date(vm.dataToFill.dropDate) != 'Invalid Date' && new Date(vm.dataToFill.dropTime) != 'Invalid Date ') {
                    if (moment(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime)).isAfter(new Date()))
                        sendDate = dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime);
                    else
                        sendDate = new Date();
                }
                else if (new Date(vm.dataToFill.dropDate) == 'Invalid Date' && new Date(vm.dataToFill.dropTime) == 'Invalid Date ') {
                    sendDate = new Date();
                }
                else if (vm.flagHelp == true && new Date(vm.bookingDetails.job_delivery_datetime) != 'Invalid Date' && (vm.bookingDetails && vm.bookingDetails.schedule_ride == 1)) {
                    if (moment(new Date(vm.bookingDetails.job_delivery_datetime)).isAfter(new Date()))
                        sendDate = new Date(vm.bookingDetails.job_delivery_datetime);
                    else
                        sendDate = new Date();

                }
                else {
                    if (moment(dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime)).isAfter(new Date()) && !vm.dataToFill.currentBooking)
                        sendDate = dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime);
                    else
                        sendDate = new Date();
                }

                if (vm.bookingDetails != undefined && vm.bookingDetails.job_delivery_datetime == "0000-00-00 00:00:00") {
                    sendDate = new Date();
                }
                if (vm.bookingDetails != undefined && vm.bookingDetails.schedule_ride == 0) {
                    sendDate = new Date();
                }
            }
            if (!vm.modifyFalgNew) {
                var dataSend = {};
                dataSend.picklat = lat1;
                dataSend.picklng = lng1;
                dataSend.droplat = lat2;
                dataSend.droplng = lng2;
                if (vm.modifyFalg) {
                    toGetAirportServiceNew(vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.serviceTypeSelected, map);
                }
                dataSend.departure = new Date(sendDate).toISOString();
                tollCostEstimatedRouteHereMaps(lat1, lng1, lat2, lng2, sendDate, type, payload);
            } else {
                if (type == 'ROUND TRIP') {
                    vm.dataToFill.etaScheduleValueReturn = vm.bookingDetails.eta;
                    vm.dataToFill.etaScheduleReturn = vm.bookingDetails.eta;
                    vm.dataToFill.ReturnEstimatedDistance = roundToTwo(vm.bookingDetails.estimated_distance ? vm.bookingDetails.estimated_distance / 1000 : 0 / 1000);
                    vm.ReturnEstimatedDistanceToSend = vm.bookingDetails.estimated_distance ? vm.bookingDetails.estimated_distance : 0;
                } else {
                    vm.dataToFill.etaSchedule = vm.bookingDetails.eta;
                    vm.dataToFill.etaScheduleValue = vm.bookingDetails.eta;
                    if (vm.dataToFill.selectedServiceDetails.category == 1) {
                        vm.dataToFill.time_trip_shared_service = 0;
                    }
                    vm.dataToFill.estimatedDistance = roundToTwo(vm.bookingDetails.estimated_distance ? vm.bookingDetails.estimated_distance / 1000 : 0 / 1000);
                    vm.estimatedDistanceToSend = vm.bookingDetails.estimated_distance ? vm.bookingDetails.estimated_distance : 0;
                    vm.estimated_toll_price = vm.bookingDetails.estimated_toll_price;
                }
                if (type == 'ROUND TRIP') {
                    if (vm.dataToFill.selectedServiceDetails.category == 1)
                        calculateEstimatePickUpTimeReturn(vm.dataToFill.etaScheduleValueReturn);
                    if ((vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip == 'R')) {
                        $timeout(function () {
                            calculateEstimatePickUpTimeForRTypeReturn(vm.dataToFill.etaScheduleValueReturn);
                        }, 800)
                    }
                }
                if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking == 'R') {
                    calculateEstimatePickUpTimeForRType(vm.dataToFill.etaScheduleValue); 
                    //calculateDateRangeOfPointToPoint(); 
                }
                if (vm.dataToFill.selectedServiceDetails.category == 1)
                    calculateEstimatePickUpTime(vm.dataToFill.etaScheduleValue);
                if (payload)
                    calculatePrice(payload);
                // directionsDisplay.setDirections(response);
                // $scope.$apply();
            }

            if(type == 'ROUND TRIP'){
                if( ciclosFuncionRt == 0 ){
                    get_cuota_rt();
                }
                ciclosFuncionRt++;
                setTimeout(function () {
                    ciclosFuncionRt = 0;
                }, 2000);
            }else {
                if( ciclosFuncion == 0 ){
                    //getFixedRoutesForPersonal(vm.dataToFill);
                    get_cuota();
                }
                ciclosFuncion++;
                setTimeout(function () {
                    ciclosFuncion = 0;
                }, 2000);
            }

            //if( ciclosFuncion == 0 && vm.dataToFill.selectedServiceDetails.category != 1){
                //get_cuota();
            //}
            //ciclosFuncion++;
            //setTimeout(function () {
                //ciclosFuncion = 0;
            //}, 2000);
            ////get_cuota_rt();
        }

        function tollCostEstimatedRouteHereMaps(lat1, lng1, lat2, lng2, sendDate, type, payloadSearchFixedVariable) {
            var dataSend = {};
            dataSend.waypoint0 = lat1 + ',' + lng1;
            dataSend.waypoint1 = lat2 + ',' + lng2;
            dataSend.departure_date = moment.utc(sendDate).format('YYYY-MM-DDTHH:mm:ss-00');
            dataSend.origen = 'panel-normal';
            var promise = getBookings.tollCostEstimatedRouteHereMaps(dataSend);
            vm.loading = true;
            promise.then(
                function (payload) {
                    vm.loading = false;
                    console.log('debug tollCostEstimatedRouteHereMaps payload', payload);
                    if (payload.title.status == 400) {
                        if (payload.title.data && payload.title.data.custom_error) {
                            openPopForErrorAddress(payload);
                        } else {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (type == 'ROUND TRIP') {
                            vm.tollPriceReturn = payload.title.data.tollPrice;
                            vm.tollCountReturn = payload.title.data.tollCount;
                            vm.dataToFill.etaScheduleValueReturn = Math.round(payload.title.data.etaInSeconds / 60);
                            vm.dataToFill.etaScheduleReturn = Math.round(payload.title.data.etaInSeconds / 60);
                            vm.dataToFill.ReturnEstimatedDistance = roundToTwo((payload.title.data.distanceInMeters / 1000));
                            vm.ReturnEstimatedDistanceToSend = payload.title.data.distanceInMeters;
                            vm.heremaps_toll_details_return = payload.title.data;
                        } else {
                            vm.tollPrice = payload.title.data.tollPrice;
                            vm.tollCount = payload.title.data.tollCount;
                            vm.dataToFill.etaSchedule = Math.round(payload.title.data.etaInSeconds / 60);
                            vm.dataToFill.etaScheduleValue = Math.round(payload.title.data.etaInSeconds / 60);
                            vm.dataToFill.estimatedDistance = roundToTwo((payload.title.data.distanceInMeters / 1000));
                            vm.estimatedDistanceToSend = payload.title.data.distanceInMeters;
                            vm.heremaps_toll_details = payload.title.data;
                        }

                        if (type == 'ROUND TRIP') {
                            if (vm.dataToFill.selectedServiceDetails.category == 1)
                                calculateEstimatePickUpTimeReturn(vm.dataToFill.etaScheduleValueReturn);
                            if ((vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip == 'R')) {
                                $timeout(function () {
                                    calculateEstimatePickUpTimeForRTypeReturn(vm.dataToFill.etaScheduleValueReturn);
                                }, 800)
                            }
                        }
                        if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking == 'R') {
                            calculateEstimatePickUpTimeForRType(vm.dataToFill.etaScheduleValue); 
                            //calculateDateRangeOfPointToPoint(); 
                        }
                        if (vm.dataToFill.selectedServiceDetails.category == 1)
                            calculateEstimatePickUpTime(vm.dataToFill.etaScheduleValue);
                        if (payloadSearchFixedVariable) {
                            calculatePrice(payloadSearchFixedVariable);
                        }
                        // directionsDisplay.setDirections(response);
                        // $scope.$apply();
                        // vm.loading = false;
                        //console.log(vm.dataToFill.etaSchedule, vm.dataToFill.etaScheduleValue)
                        if ((vm.type_of_trip1 == 'R' && vm.dataToFill.selectedServiceDetails.category == 1 && vm.method_range_pickup) || (vm.routingBase && vm.routingBase.routing_base_id > 0)) {
                            RoutingApiFuncation(vm.dataToFill, 0);
                        }
                        setTimeout(function () {
                            vm.disabledSubmitButton1 = false;
                            console.log('debug digest cycle toll');
                            $scope.$apply();
                        }, 1500);
                        if (type === 'ROUND TRIP' && vm.searchFixedVariablePayload) {

                            //TDM 213
                            vm.toll_price_return = 0;
                            vm.toll_id_return = false;
                            for (var i = 0; i < vm.searchFixedVariablePayload.title.data.finalResult_return.price_list.itemOfCharge.length; i++) {
                                if (vm.searchFixedVariablePayload.title.data.finalResult_return.price_list.itemOfCharge[i].item_of_charge_id === 2) {
                                    vm.toll_id_return = true;
                                    vm.tollChargeWayReturn = vm.searchFixedVariablePayload.title.data.finalResult_return.price_list.itemOfCharge[i].toll_charge_way;
                                    vm.toll_price_return = vm.searchFixedVariablePayload.title.data.finalResult_return.price_list.itemOfCharge[i].price;
                                }
                            }
                            if (vm.searchFixedVariablePayload.title.data.apply_charge_by_toll && vm.toll_id_return) {
                                if (vm.tollChargeWayReturn == 1) {
                                    vm.tollPriceReturnToAdd = Math.round(vm.toll_price_return);
                                    vm.estimated_toll_price_return = vm.tollPriceReturnToAdd * vm.tollCountReturn;
                                }
                                else if (vm.tollChargeWayReturn == 2) {
                                    vm.tollPriceReturnToAdd = Math.round(vm.tollPriceReturn);
                                    vm.estimated_toll_price_return = vm.tollPriceReturnToAdd;
                                }
                                else {

                                }
                            } else {
                                vm.estimated_toll_price_return = 0;
                            }

                            //TDM 213


                            if (vm.dataToFill.Return_policy.route_type === 0) {
                                //=========================Return========================

                                if (vm.dataToFill.ReturnEstimatedDistance != undefined && vm.dataToFill.etaScheduleValueReturn != undefined) {
                                    console.log('debug vm.searchFixedVariablePayload', vm.searchFixedVariablePayload);
                                    console.log('debug vm.searchFixedVariablePayload.title.data.finalResult_return.price_list', vm.searchFixedVariablePayload.title.data.finalResult_return.price_list);


                                    vm.estimated_eta_return = (vm.dataToFill.etaScheduleValueReturn * vm.searchFixedVariablePayload.title.data.finalResult_return.time_of_trip_price);

                                    vm.estimated_distance_return = (vm.dataToFill.ReturnEstimatedDistance * vm.searchFixedVariablePayload.title.data.finalResult_return.perKMChanges);

                                    var Return_calEstFare = Number(vm.estimated_distance_return + vm.estimated_eta_return + vm.estimated_toll_price_return + vm.searchFixedVariablePayload.title.data.finalResult_return.baseFare);
                                    console.log('debug Return_calEstFare', Return_calEstFare);
                                }
                                if (vm.dataToFill.selectedServiceDetails.fare_type) {
                                    if ((Number(Return_calEstFare) * Number(vm.dataToFill.passengerCount)) < vm.searchFixedVariablePayload.title.data.finalResult_return.minimumFare) {
                                        if(vm.dataToFill.factor_return_value){
                                            vm.dataToFill.Return_policy.estimatedFareRoute = Number(vm.searchFixedVariablePayload.title.data.finalResult_return.minimumFare) * vm.dataToFill.factor_return_value;
                                        } else {
                                            vm.dataToFill.Return_policy.estimatedFareRoute = vm.searchFixedVariablePayload.title.data.finalResult_return.minimumFare;
                                        }
                                    } else {
                                        vm.dataToFill.Return_policy.estimatedFareRoute = Number(Return_calEstFare) * Number(vm.dataToFill.passengerCount);
                                    }
                                } else {
                                    if (Return_calEstFare <= vm.searchFixedVariablePayload.title.data.finalResult_return.minimumFare) {
                                        if(vm.dataToFill.factor_return_value){
                                            vm.dataToFill.Return_policy.estimatedFareRoute = Number(vm.searchFixedVariablePayload.title.data.finalResult_return.minimumFare) * vm.dataToFill.factor_return_value;
                                        } else {
                                            vm.dataToFill.Return_policy.estimatedFareRoute = vm.searchFixedVariablePayload.title.data.finalResult_return.minimumFare;
                                        }
                                    } else {
                                        vm.dataToFill.Return_policy.estimatedFareRoute = Return_calEstFare;
                                    }
                                }
                                vm.dataToFill.Return_policy.estimatedFare = vm.dataToFill.Return_policy.estimatedFareRoute;
                                vm.dataToFill.Return_policy.estimatedFareVariable = Return_calEstFare;
                                vm.dataToFill.Return_policy.estimatedFareRoute = Return_calEstFare;
                                vm.dataToFill.minimumFare = vm.searchFixedVariablePayload.title.data.finalResult_return.minimumFare;
                                vm.dataToFill.estimatedFare = vm.dataToFill.estimatedFareRoute;
                                if (vm.dataToFill.itemOfChargeSelected && vm.dataToFill.itemOfChargeSelected.length)
                                    for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                                        if(vm.dataToFill.itemOfChargeSelected[i].retorno == true) {
                                            vm.dataToFill.Return_policy.estimatedFare = vm.dataToFill.Return_policy.estimatedFare + Number(vm.dataToFill.itemOfChargeSelected[i].price);
                                        } else {
                                            vm.dataToFill.estimatedFare = vm.dataToFill.estimatedFare + Number(vm.dataToFill.itemOfChargeSelected[i].price);
                                        }
                                    }
                                if (vm.return_flag == true) {
                                    console.log('debug vm.return_flag', vm.return_flag);
                                    vm.dataToFill.discounts = [];
                                    vm.couponType = 1;
                                    if (vm.dataToFill.roundTripDiscount == 0)
                                        vm.couponType = undefined;
                                    vm.dataToFill.roundTrip = true;
                                    vm.dataToFill.discounts.push({
                                        estimatedFare: viaControlledPrice(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking),
                                        roundTripFare: vm.dataToFill.roundTrip == true ? viaControlledPrice(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip) : 0,
                                        name: 'ROUND TRIP',
                                        discountType: 1,
                                        discountTypeValue: vm.dataToFill.roundTripDiscount,
                                        value: calculateDiscountPercentageAmount(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, vm.dataToFill.roundTripDiscount, 'parent'),
                                        returnValue: vm.dataToFill.roundTrip == true ? calculateDiscountPercentageAmount(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, vm.dataToFill.roundTripDiscount, 'parent') : 0,
                                        finalAmount: calculateDiscountPercentage(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, vm.dataToFill.roundTripDiscount, vm.tope_maximo, 'parent'),
                                        roundFinalAmount: vm.dataToFill.roundTrip == true ? calculateDiscountPercentage(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, vm.dataToFill.roundTripDiscount, vm.tope_maximo, 'parent') : 0
                                    })
                                    // console.log('>>>>> DISCOUNT >>>>>>>>>>>', vm.dataToFill.discounts);
                                    vm.dataToFill.discounts.forEach(function (data) {
                                        data.finalAmount = data.finalAmount < 0 ? 0 : data.finalAmount;
                                    })
                                    vm.dataToFill.discounts = vm.dataToFill.discounts.sort(function (a, b) {
                                        return b.value - a.value
                                    })
                                } else {
                                    errorMessageFactory.showErrorMessage('Ida y vuelta de este servicio no está disponible', 0);
                                }
                            }

                            // if (vm.dataToFill.Return_policy.route_type == 1) {
                            //     vm.dataToFill.Return_policy.estimatedFareVariable = vm.dataToFill.selectedServiceDetails.fare_type ?
                            //         (Number(vm.searchFixedVariablePayload.title.data.finalResult_return.price) * Number(vm.dataToFill.passengerCount)) + vm.estimated_toll_price_return
                            //         : vm.searchFixedVariablePayload.title.data.finalResult_return.price + vm.estimated_toll_price_return;

                            //     vm.dataToFill.Return_policy.estimatedFareRoute = vm.dataToFill.selectedServiceDetails.fare_type ?
                            //         (Number(vm.searchFixedVariablePayload.title.data.finalResult_return.price) * Number(vm.dataToFill.passengerCount)) + vm.estimated_toll_price_return
                            //         : vm.searchFixedVariablePayload.title.data.finalResult_return.price + vm.estimated_toll_price_return;

                            //     vm.dataToFill.Return_policy.estimatedFare = vm.dataToFill.Return_policy.estimatedFareRoute;

                            //     vm.dataToFill.Return_policy.estimatedFareRoute = Number(vm.searchFixedVariablePayload.title.data.finalResult_return.price) + vm.estimated_toll_price_return;

                            //     vm.estimatedFareRouteForRoundTrip = vm.dataToFill.selectedServiceDetails.fare_type ?
                            //         (Number(vm.searchFixedVariablePayload.title.data.finalResult_return.price) * Number(vm.dataToFill.passengerCount)) + vm.estimated_toll_price_return
                            //         : vm.searchFixedVariablePayload.title.data.finalResult_return.price + vm.estimated_toll_price_return;

                            if (vm.dataToFill.Return_policy.route_type == 1) {

                                vm.dataToFill.Return_policy.estimatedFareVariable = vm.dataToFill.selectedServiceDetails.fare_type ? (Number(vm.searchFixedVariablePayload.title.data.finalResult_return.price) * Number(vm.dataToFill.passengerCount)) + vm.estimated_toll_price_return : vm.searchFixedVariablePayload.title.data.finalResult_return.price + vm.estimated_toll_price_return;

                                vm.dataToFill.Return_policy.estimatedFareRoute = vm.dataToFill.selectedServiceDetails.fare_type ? (Number(vm.searchFixedVariablePayload.title.data.finalResult_return.price) * Number(vm.dataToFill.passengerCount)) + vm.estimated_toll_price_return : vm.searchFixedVariablePayload.title.data.finalResult_return.price + vm.estimated_toll_price_return

                                vm.dataToFill.Return_policy.estimatedFare = vm.dataToFill.Return_policy.estimatedFareRoute;

                                vm.dataToFill.Return_policy.estimatedFareRoute = Number(vm.searchFixedVariablePayload.title.data.finalResult_return.price) + vm.estimated_toll_price_return;

                                vm.estimatedFareRouteForRoundTrip = Number(vm.dataToFill.selectedServiceDetails.fare_type ? (Number(vm.searchFixedVariablePayload.title.data.finalResult_return.price) * Number(vm.dataToFill.passengerCount)) + vm.estimated_toll_price_return  : (vm.searchFixedVariablePayload.title.data.finalResult_return.price + vm.estimated_toll_price_return));

                                  // PF-242
                                if(vm.dataToFill.itemOfChargeSelected){
                                    for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                                        if(vm.dataToFill.itemOfChargeSelected[i].retorno == true) {
                                            vm.dataToFill.Return_policy.estimatedFare +=  Number(vm.dataToFill.itemOfChargeSelected[i].price);
                                        }
                                    }
                                }
                                //PF-242


                                if (vm.return_flag == true) {
                                    ///////////////////////////TV-1795 //////////////////////////
                                    vm.dataToFill.discounts = [];
                                    vm.couponType = 1;
                                    if (vm.dataToFill.roundTripDiscount == 0)
                                        vm.couponType = undefined;
                                    ///////////////////////////TV-1795 //////////////////////////
                                    vm.dataToFill.roundTrip = true;
                                    vm.dataToFill.discounts.push({
                                        // estimatedFare: Math.round(Number(vm.dataToFill.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled1))),
                                        estimatedFare: viaControlledPrice(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking),
                                        // roundTripFare: Math.round(Number(vm.dataToFill.Return_policy.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled2))),
                                        roundTripFare: vm.dataToFill.roundTrip == true ? viaControlledPrice(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip) : 0,
                                        name: 'ROUND TRIP',
                                        discountType: 1,
                                        discountTypeValue: vm.dataToFill.roundTripDiscount,
                                        // value: ((Number(vm.estimatedFareDiscount) * Number(vm.dataToFill.roundTripDiscount)) / 100),
                                        value: calculateDiscountPercentageAmount(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, vm.dataToFill.roundTripDiscount, 'parent'),
                                        // returnValue: ((vm.estimatedFareDiscountRound * Number(vm.dataToFill.roundTripDiscount)) / 100),
                                        returnValue: vm.dataToFill.roundTrip == true ? calculateDiscountPercentageAmount(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, vm.dataToFill.roundTripDiscount, 'parent') : 0,
                                        // finalAmount: Math.round((vm.estimatedFareDiscount - vm.estimatedFareDiscount * Number(vm.dataToFill.roundTripDiscount) / 100) + (vm.type_of_trip_Validate_Booking == 'Z' ? (Number(vm.viaControlled1)) : 0)),
                                        finalAmount: calculateDiscountPercentage(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, vm.dataToFill.roundTripDiscount, vm.tope_maximo, 'parent'),
                                        // roundFinalAmount: Math.round((vm.estimatedFareDiscountRound - (vm.estimatedFareDiscountRound) * Number(vm.dataToFill.roundTripDiscount) / 100) + (vm.type_of_trip == 'Z' ? (Number(vm.viaControlled2)) : 0))
                                        roundFinalAmount: vm.dataToFill.roundTrip == true ? calculateDiscountPercentage(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, vm.dataToFill.roundTripDiscount, vm.tope_maximo) : 0
                                    })
                                    // console.log('>>>>> DISCOUNT >>>>>>>>>>>', vm.dataToFill.discounts);
                                    vm.dataToFill.discounts.forEach(function (data) {
                                        data.finalAmount = data.finalAmount < 0 ? 0 : data.finalAmount;
                                    })
                                    vm.dataToFill.discounts = vm.dataToFill.discounts.sort(function (a, b) {
                                        return b.value - a.value
                                    })
                                } else {
                                    errorMessageFactory.showErrorMessage('Ida y vuelta de este servicio no está disponible', 0);
                                }
                            }



                        }
                    }
                    //get_cuota();
                    //get_cuota_rt();
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        //errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
            //if (type == 'ROUND TRIP') {
                //get_cuota_rt();
            //}
        };

        function geocodePosition(pos, type, marker) {
            //console.log("second //console");

            geocoder.geocode({
                latLng: pos
            }, function (results) {
                if (results && results.length > 0) {
                    //console.log(results[0]);
                    if (type == 'pick') {
                        $scope.addressPick = hidePublicPlaces.formattedAddress(results[0]);
                        var city;
                        for (var i = 0; i < results[0].address_components.length; i++) {
                            for (var j = 0; j < results[0].address_components[i].types.length; j++) {
                                if (results[0].address_components[i].types[j] == 'locality') {
                                    city = results[0].address_components[i].short_name;
                                    vm.jobPickupComuna = city;
                                }
                            }
                        }
                        if (vm.pickUpCity && (vm.pickUpCity != city)) {
                            errorMessageFactory.showErrorMessage('Error, esta dirección cambia el tramo original. El cambio no debe afectar la tarifa.', 0);
                            // results= '';
                            vm.dataToFill.pickUpAddress = vm.pickUpAddress;
                            vm.dataToFill.pickUpLat = vm.bookingDetails.job_pickup_latitude;
                            vm.dataToFill.pickUpLng = vm.bookingDetails.job_pickup_longitude;
                            marker.setPosition(new google.maps.LatLng(vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng))
                            return;
                        } else {
                            vm.dataToFill.pickUpAddress = $scope.addressPick;
                        }

                        $scope.$apply();
                    } else if (type == 'drop') {
                        $scope.addressDrop = hidePublicPlaces.formattedAddress(results[0]);

                        var city;
                        for (var i = 0; i < results[0].address_components.length; i++) {
                            for (var j = 0; j < results[0].address_components[i].types.length; j++) {
                                if (results[0].address_components[i].types[j] == 'locality') {
                                    city = results[0].address_components[i].short_name;
                                    vm.jobDropoffComuna = city;
                                }
                            }
                        }
                        if (vm.pickUpCity && (vm.pickUpCity != city)) {
                            errorMessageFactory.showErrorMessage('Error, esta dirección cambia el tramo original. El cambio no debe afectar la tarifa.', 0);
                            // results= '';
                            vm.dataToFill.dropOffAddress = vm.dropUpAddress;
                            vm.dataToFill.dropOffLat = vm.bookingDetails.job_latitude;
                            vm.dataToFill.dropOffLng = vm.bookingDetails.job_longitude;
                            marker.setPosition(new google.maps.LatLng(vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng))
                            return;
                        } else {
                            vm.dataToFill.dropOffAddress = $scope.addressDrop;
                        }
                        $scope.$apply();
                    }
                }
            })
        };

        // var marker = {};
        function placeMarker(map, location, data, driverData) {
            console.log('placemarker', data, map);
            //var id = uniqueId();
            var id;
            if (data == 'pick') {
                id = 'pick';
                if (markers.length) {
                    for (var i = 0; i < markers.length; i++) {
                        if (markers[i].id == 'pick') {
                            setMapOnAll(null, 'pick');
                        }
                    }
                } else {
                    id = 'pick';
                }
            } else if (data == 'drop') {
                id = 'drop';
                if (markers.length) {
                    for (var i = 0; i < markers.length; i++) {
                        if (markers[i].id == 'drop') {
                            setMapOnAll(null, 'drop');
                        }
                    }
                } else {
                    id = 'drop';
                }
            } else if (data == 'driver') {
                id = 'driver';
                var icon = {
                    url: '',
                    size: new google.maps.Size(70, 70),
                    scaledSize: new google.maps.Size(50, 50), // scaled size
                    origin: new google.maps.Point(0, 0), // origin
                    labelOrigin: new google.maps.Point(25, 15),
                    anchor: new google.maps.Point(17, 34) // anchor
                };
                var label = {
                    text: Math.floor(driverData.eta / 60).toString(),
                    fontSize: '10px'
                };
            }
            if (driverData) {
                if (driverData.status == 0 && driverData.is_available == 1) {
                    //icon.url = 'assets/images/on_duty.png';
                    icon.url = driverData.vehicle_img_online ? driverData.vehicle_img_online : 'assets/images/on_duty.png';
                } else if (driverData.status == 1 && driverData.is_available == 1 && driverData.job_status == 15) {
                    //icon.url = 'assets/images/in_road.png';
                    icon.url = driverData.vehicle_img_road ? driverData.vehicle_img_road : 'assets/images/in_road.png';
                } else if (driverData.status == 1 && driverData.is_available == 1 && driverData.job_status == 7) {
                    //icon.url = 'assets/images/in_road.png';
                    icon.url = driverData.vehicle_img_accepted ? driverData.vehicle_img_accepted : 'assets/images/in_road.png';
                } else if (driverData.status == 1 && driverData.is_available == 1 && driverData.job_status == 1) {
                    //icon.url = 'assets/images/at_position.png';
                    icon.url = driverData.vehicle_img_position ? driverData.vehicle_img_position : 'assets/images/at_position.png';
                } else if (driverData.status == 1 && driverData.is_available == 1 && driverData.job_status == 4) {
                    //icon.url = 'assets/images/service_started.png';
                    icon.url = driverData.vehicle_img_busy ? driverData.vehicle_img_busy : 'assets/images/service_started.png';
                }
            }
            var marker = new google.maps.Marker({
                id: id,
                position: location,
                draggable: id == 'driver' ? false : true,
                map: map,
                fleetId: data == 'driver' ? driverData.fleet_id : '',
                label: data == 'driver' ? label : '',
                icon: data == 'driver' ? icon : ''
            });
            if (map) {
                bounds.extend(location);
                map.fitBounds(bounds);
                markers.push(marker);
            }
            //console.log(markers);
            if (data == 'driver') {
                marker.content = '<div class="row" id="googleMapsDetailsWithCar">' +
                    '<div class="col-lg-12 col-sm-12 col-xs-12 col-md-12">' +
                    '<div class="row">' +
                    '<div class="col-lg-12 col-sm-12 col-xs-12 col-md-12">' +
                    '<p class="toAssignText">To Assign</p>' +
                    '</div>' +
                    '<div class="col-lg-12 col-sm-12 col-xs-12 col-md-12">' +
                    '<p class="toAssignTextETA"> ETA:' + Math.floor(driverData.eta / 60) + 'min</p>' +
                    '</div>' +
                    '<div class="col-lg-12 col-sm-12 col-xs-12 col-md-12 paddinButtonD">' +
                    '<button class="btn btn-primary tableButton" type="button" id="confirmDriver">Confirm</button>' +
                    '<button class="btn btn-primary tableButton" type="button" id="cancelDriver">Cancel</button>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>';
            }
            google.maps.event.addListener(marker, 'click', function (event) {
                //console.log(marker, marker.id);
                if (marker.id == 'driver') {
                    vm.markerFleetID = marker.fleetId;
                    infowindow.setContent(marker.content);
                    infowindow.open(map, marker);
                }
            });
            google.maps.event.addListener(marker, 'dragend', function (event) {
                //console.log(marker,"marker");

                //console.log(event);
                //console.log(this);
                if (this.id == 'pick') {
                    $scope.addressLat = this.getPosition().lat();
                    $scope.addressLng = this.getPosition().lng();
                    vm.dataToFill.pickUpLat = $scope.addressLat;
                    vm.dataToFill.pickUpLng = $scope.addressLng;
                    geocodePosition(this.getPosition(), 'pick', marker);
                    if (vm.dataToFill.serviceTypeSelected) { //&& (vm.dataToFill.bookingType == '0' || vm.dataToFill.bookingType == 0)
                        vm.dataToFill.nearDriver = '';
                        toGetAirportService(vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.serviceTypeSelected, map);
                        //toGetNearByDrivers(vm.dataToFill.pickUpLat,vm.dataToFill.pickUpLng,vm.dataToFill.serviceTypeSelected,map);
                    }
                    $scope.$apply();
                } else if (this.id == 'drop') {
                    $scope.addressDLat = this.getPosition().lat();
                    $scope.addressDLng = this.getPosition().lng();
                    vm.dataToFill.dropOffLat = $scope.addressDLat;
                    vm.dataToFill.dropOffLng = $scope.addressDLng;
                    geocodePosition(this.getPosition(), 'drop', marker);
                    //getFixedRoutesForPersonal(vm.dataToFill);
                    $scope.$apply();
                }
                $timeout(function () {
                    if (vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                        calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, map);
                        getFixedRoutesForPersonal(vm.dataToFill);
                    }
                }, 2000)


            });
            if (vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat && id != 'driver') {
                calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, map);
                getFixedRoutesForPersonal(vm.dataToFill);
            }
        };

        function mapInitialize(data) {
            console.log(vm.flightDateValidation, vm.scheduleDateValidation, vm.dropoffDateValidation,
                'vm.flightDateValidation || vm.scheduleDateValidation || vm.dropoffDateValidation');
            vm.showGoogleMap = true;
            mapProp = {
                center: myCenter,
                zoom: Number(zoomLevel),
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                minZoom: 3,
                maxZoom: 18,
                scrollwheel: false
            };
            document.getElementById("googleMap").style.height = window.innerHeight - 200 + 'px';
            map = new google.maps.Map(document.getElementById("googleMap"), mapProp);
            map.setOptions({
                styles: hidePublicPlaces.hidePublic()
            });
            google.maps.event.addListener(map, 'center_changed', function () {
                checkBounds(map);
            });
            var location;
            var type;
            if (vm.dropaddressChange = true) {
                location = new google.maps.LatLng(vm.dataToFill.dropLat, vm.dataToFill.dropLng);
                type = 'drop';
                placeMarker(map, location, type);
            }
            if (vm.pickaddressChange = true) {
                location = new google.maps.LatLng(vm.dataToFill.pickLat, vm.dataToFill.pickLng);
                type = 'pick';
                placeMarker(map, location, type);
            }
        };
        initAutocomplete();
        // mapInitialize();

        //=======================number of passenger============================
        function numberOfPassenger(data) {
            vm.disabledSubmitButton1 = true;
            vm.addressChange = true;
            if (vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, map);
                getFixedRoutesForPersonal(vm.dataToFill);
            }
            var where = _.where(vm.serviceTypeList, {
                id: Number(vm.dataToFill.serviceTypeSelected)
            });

            if (data > where[0].max_limit) {
                vm.dataToFill.numberOfPassengerError = true;
                vm.dataToFill.numberOfPassengerCount = where[0].max_limit;
            } else {
                vm.dataToFill.numberOfPassengerError = false;
                vm.dataToFill.numberOfPassengerCount = 0;
            }
            if (vm.dataToFill.selectedServiceDetails.fare_type == 1) {
                vm.dataToFill.viaControlled = Number(vm.dataToFill.viaControlledReal) * Number(vm.dataToFill.passengerCount);
            } else {
                vm.dataToFill.viaControlled = Number(vm.dataToFill.viaControlledReal);
            }
            $timeout(function () {
                if (vm.dataToFill.route_type == 1) {

                    vm.dataToFill.estimatedFare = 0;
                    vm.dataToFill.Return_policy.estimatedFare = 0;
                    for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                        vm.dataToFill.estimatedFare = vm.dataToFill.estimatedFare + Number(vm.dataToFill.itemOfChargeSelected[i].price);
                    }
                    vm.dataToFill.estimatedFare = vm.dataToFill.selectedServiceDetails.fare_type ? (Number(vm.dataToFill.estimatedFareRoute) * Number(vm.dataToFill.passengerCount)) + Number(vm.dataToFill.estimatedFare) : Number(vm.dataToFill.estimatedFare) + Number(vm.dataToFill.estimatedFareRoute);
                    vm.dataToFill.Return_policy.estimatedFare = vm.dataToFill.selectedServiceDetails.fare_type ? Number(vm.dataToFill.Return_policy.estimatedFareRoute) * Number(vm.dataToFill.passengerCount) + Number(vm.dataToFill.Return_policy.estimatedFare) : Number(vm.dataToFill.Return_policy.estimatedFare) + Number(vm.dataToFill.Return_policy.estimatedFareRoute);

                } else {
                    //var calEstFare = vm.dataToFill.selectedServiceDetails.fare_type?Number((vm.dataToFill.estimatedDistance * payload.title.data[0].perKMChanges.toFixed(2))+payload.title.data[0].baseFare) * Number(vm.dataToFill.passengerCount):Number((vm.dataToFill.estimatedDistance * payload.title.data[0].perKMChanges.toFixed(2))+payload.title.data[0].baseFare);
                    //vm.dataToFill.estimatedFareRoute = calEstFare < payload.title.data[0].minimumFare ? payload.title.data[0].minimumFare : calEstFare;
                    //vm.dataToFill.estimatedFare = vm.dataToFill.estimatedFareRoute;
                    //vm.dataToFill.estimatedFareVariable = calEstFare;
                    //vm.dataToFill.estimatedFareRoute = calEstFare;
                    //vm.dataToFill.minimumFare = payload.title.data[0].minimumFare;
                    vm.dataToFill.estimatedFare = 0;
                    vm.dataToFill.Return_policy.estimatedFare = 0;
                    for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                        vm.dataToFill.estimatedFare = vm.dataToFill.estimatedFare + Number(vm.dataToFill.itemOfChargeSelected[i].price);
                    }
                    var calFare = vm.dataToFill.selectedServiceDetails.fare_type ? (Number(vm.dataToFill.estimatedFareRoute) * Number(vm.dataToFill.passengerCount)) + Number(vm.dataToFill.estimatedFare) : Number(vm.dataToFill.estimatedFare) + Number(vm.dataToFill.estimatedFareRoute);
                    var calFareReturn = vm.dataToFill.selectedServiceDetails.fare_type ? Number(vm.dataToFill.Return_policy.estimatedFareRoute) * Number(vm.dataToFill.passengerCount) + Number(vm.dataToFill.Return_policy.estimatedFare) : Number(vm.dataToFill.Return_policy.estimatedFare) + Number(vm.dataToFill.Return_policy.estimatedFareRoute);
                    vm.dataToFill.estimatedFare = calFare < vm.dataToFill.minimumFare ? vm.dataToFill.minimumFare : calFare;
                    vm.dataToFill.Return_policy.estimatedFare = calFareReturn < vm.dataToFill.minimumFare ? vm.dataToFill.minimumFare : calFareReturn;
                    // if (vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                    //     calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, map);
                    //     getFixedRoutesForPersonal(vm.dataToFill);
                    // }
                }
                vm.disabledSubmitButton1 = false;
            }, 1000)

        };

        function calculateDateRangeOfPointToPoint() {
            var datePointToPoint = dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime)
            // var pickRangeForRtypeReturn = moment(datePointToPoint).subtract((((vm.pickup_travel_time_pap != 0 ? vm.dataToFill.etaScheduleValue : 0)  + vm.pickup_travel_time_pap) * 60), 'seconds');
            var newpickRangeForRtypeReturn = '';
            if (vm.is_group_allowed == 1) {
                newpickRangeForRtypeReturn = moment(datePointToPoint).subtract((vm.time_trip_shared_service_point_to_point * 60), 'seconds');
            } else {
                newpickRangeForRtypeReturn = datePointToPoint;
            }
            if (vm.modifyFalgNew) {
                vm.ptoptravelTime = moment(vm.bookingDetails.time_with_tolerance_before).format('HH:mm');
            } else {
                vm.ptoptravelTime = moment(newpickRangeForRtypeReturn).format('HH:mm');
            }
            var rangePointToPoint = moment(datePointToPoint).add((vm.time_trip_shared_service_point_to_point * 60), 'seconds');
            vm.rangeOfPointToPoint = moment(rangePointToPoint).format('HH:mm');
        }

        function calculateDateRangeOfPointToPointReturn() {
            var datePointToPoint = dateTimeFormat(vm.dataToFill.returnDate, vm.dataToFill.returnTime);
            // var pickRangeForRtypeReturn = moment(datePointToPoint).subtract((((vm.pickup_travel_time_pap !=0 ? vm.dataToFill.etaScheduleValueReturn : 0) + vm.pickup_travel_time_pap) * 60), 'seconds');
            var newpickRangeForRtypeReturn = '';
            if (vm.is_group_allowed == 1) {
                newpickRangeForRtypeReturn = moment(datePointToPoint).subtract((vm.time_trip_shared_service_point_to_point * 60), 'seconds');
            } else {
                newpickRangeForRtypeReturn = datePointToPoint;
            }
            if (vm.modifyFalgNew) {
                vm.ptoptravelTimeReturn = moment(vm.bookingDetails.time_with_tolerance_before).format('HH:mm');
            } else {
                vm.ptoptravelTimeReturn = moment(newpickRangeForRtypeReturn).format('HH:mm');
            }
            // vm.ptoptravelTimeReturn = moment(newpickRangeForRtypeReturn).format('HH:mm');
            var rangePointToPoint = moment(datePointToPoint).add((vm.time_trip_shared_service_point_to_point * 60), 'seconds')
            vm.rangeOfPointToPointReturn = moment(rangePointToPoint).format('HH:mm');
            console.log(vm.rangeOfPointToPointReturn, vm.ptoptravelTimeReturn, 'vm.rangeOfPointToPointReturn');

        }
        //=======================RoutingApiFuncation ========================
        var index = 1;
        var indexReturn = 1;
        vm.pickRangeSendForRouting = [];
        vm.etaArray = [];
        vm.timeZoneRecurring = [];
        vm.pickup_top_range = [];
        vm.pickup_lower_range = [];
        vm.bookingEta = false;
        vm.bookingError = false;

        function RoutingApiFuncation(data, index, type) {
            var dataSend = {};
            var tz = moment.tz.guess();
            dataSend.access_token = $cookies.get('obj');;
            dataSend.origin_longitude = data.pickUpLng;
            dataSend.origin_latitude = data.pickUpLat;
            dataSend.destination_latitude = data.dropOffLat;
            dataSend.destination_longitude = data.dropOffLng;
            dataSend.is_admin = 1;
            var convert_date = dateTimeFormat(type != 'recurring' ? vm.dataToFill.dropDate : vm.dataToFill.tillDate, vm.dataToFill.dropTime).toISOString();
            convert_date = moment(convert_date).valueOf();
            dataSend.destination_at = moment(convert_date).format('YYYY-MM-DDTHH:mm:ssZ');
            if(vm.routingBase && vm.routingBase.zone_bucket)
                dataSend.zone_bucket = vm.routingBase.zone_bucket;
            vm.loading = true;
            var promise = getBookings.RoutingApi(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    setTimeout(function () {
                        vm.disabledSubmitButton1 = false;
                    }, 1500);
                    console.log(payload, 'payload');
                    // vm.dataToFill.ReturnEstimatedDistance
                    // vm.dataToFill.estimatedDistance
                    if (payload && payload.title.status == 200) {
                        vm.etaArray[index] = (payload.title.data.estimated_travel_time)
                        vm.dataToFill.etaSchedule = vm.etaArray[0];
                        vm.bookingEta = true;
                        vm.timeZoneRecurring[index] = (moment.tz.zone(tz).utcOffset(moment(new Date(payload.title.data.estimated_pickup_datetime).toISOString())));
                        vm.pickRangeSendForRouting[index] = (new Date(payload.title.data.estimated_pickup_datetime).toISOString());
                        vm.pickup_lower_range[index] = (new Date(payload.title.data.pickup_lower_range).toISOString());
                        vm.pickup_top_range[index] = (new Date(payload.title.data.pickup_top_range).toISOString());
                        vm.dataToFill.estimatedDistance = 0;
                        vm.dataToFill.estimatedDistance = roundToTwo(((payload.title.data.travel_distance) / 1000));
                        vm.estimatedDistanceToSend = payload.title.data.travel_distance;
                        vm.distanceRoutingApi = (payload.title.data.travel_distance);
                        vm.pickRangeForRouting = moment(vm.pickRangeSendForRouting[0]).format('HH:mm');
                        if( ciclosFuncion == 0){
                            get_cuota();
                        }
                        ciclosFuncion++;
                        setTimeout(function () {
                            ciclosFuncion = 0;
                        }, 2000);
                    } else {
                        if (index == 1) {
                            vm.dataToFill.etaSchedule = 0;
                            vm.bookingEta = false;
                            RoutingApiFuncation(vm.dataToFill, 0);
                            index++;
                        } else {
                            vm.bookingEta = false;
                            vm.bookingError = true;
                            errorMessageFactory.showErrorMessage('Error al calcular el Retiro. Error en la llamada a la API', 0);
                        }
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function RoutingApiFuncationRoundTrip(data) {
            var dataSend = {};
            var tz = moment.tz.guess();
            dataSend.access_token = $cookies.get('obj');;
            dataSend.origin_longitude = data.dropOffLng;
            dataSend.origin_latitude = data.dropOffLat;
            dataSend.destination_latitude = data.pickUpLat;
            dataSend.destination_longitude = data.pickUpLng;
            dataSend.is_admin = 1;
            vm.pickRangeSendForRoutingReturn = '';
            vm.pickRangeForRoutingReturn = '';
            var convert_date = dateTimeFormat(vm.dataToFill.dropDateReturn, vm.dataToFill.dropTimeReturn).toISOString();
            convert_date = moment(convert_date).valueOf();
            dataSend.destination_at = moment(convert_date).format('YYYY-MM-DDTHH:mm:ssZ');
            vm.loading = true;
            var promise = getBookings.RoutingApi(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload && payload.title.status == 200) {
                        vm.bookingEta = true;
                        vm.timeZoneRRoundReturn = (moment.tz.zone(tz).utcOffset(moment(new Date(payload.title.data.estimated_pickup_datetime).toISOString())));
                        vm.dataToFill.etaScheduleValueReturn = (payload.title.data.estimated_travel_time);
                        vm.pickRangeSendForRoutingReturn = (new Date(payload.title.data.estimated_pickup_datetime).toISOString());
                        vm.pickup_lower_range_return = (new Date(payload.title.data.pickup_lower_range).toISOString());
                        vm.dataToFill.ReturnEstimatedDistance = 0;
                        vm.dataToFill.ReturnEstimatedDistance = roundToTwo(((payload.title.data.travel_distance) / 1000));
                        vm.ReturnEstimatedDistanceToSend = payload.title.data.travel_distance;
                        vm.distanceRoutingApiReturn = (payload.title.data.travel_distance);
                        vm.pickup_top_range_return = (new Date(payload.title.data.pickup_top_range).toISOString());
                        vm.pickRangeForRoutingReturn = moment(vm.pickRangeSendForRoutingReturn).format('HH:mm');
                    } else {
                        if (indexReturn == 1) {
                            vm.dataToFill.etaSchedule = 0;
                            vm.bookingEta = false;
                            RoutingApiFuncationRoundTrip(vm.dataToFill, 0);
                            indexReturn++;
                        } else {
                            vm.bookingEta = false;
                            vm.bookingError = true;
                            errorMessageFactory.showErrorMessage('Error al calcular el Retiro. Error en la llamada a la API', 0);
                        }
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }


        //=======================get fixed routes for personal========================
        function getFixedRoutesForPersonal(data) {
            console.log(data, 'data>>>>>>>>>>>>>');
            // vm.modifyFalgNew = false;
            $log.log(data);
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.pickup_lat = data.pickUpLat;
            dataSend.pickup_long = data.pickUpLng;
            dataSend.drop_lat = data.dropOffLat;
            dataSend.drop_long = data.dropOffLng;
            dataSend.passenger_count = data.passengerCount;
            if(data.selectedServiceDetails == "" || data.pickUpLat == '' || data.dropOffLat == ''){
                return;
            }
            var fecha;
            if(data.selectedServiceDetails.category == 1 && data.airportCheck != 'Z'  &&  vm.method_range_pickup){
                if(vm.pickRangeForRouting){
                    fecha = moment(data.dropDate).format('YYYY-MM-DD') +' '+ vm.pickRangeForRouting;
                }
            } else if(data.selectedServiceDetails.category == 1 && vm.pickRange1 && vm.pickRange2 && data.airportCheck != 'Z'  &&  !vm.method_range_pickup){
                fecha = moment(data.dropDate).format('YYYY-MM-DD') +' '+ vm.newPickRange3;
            } else if(data.scheduledBooking && data.selectedServiceDetails.category == 1){
                fecha = data.dropTime;
            } else {
                if(data.bookingType == '0'){
                    fecha = data.dropDate;
                } else {
                    if(data.scheduledBooking == 1){
                        fecha = data.scheduledTime;
                    } else {
                        fecha = data.dropDate;
                    } 
                }
            }
            if(fecha == null || !moment(fecha).isValid()){
                return;
            }
            dataSend.pickup_datetime = moment(fecha).format('YYYY-MM-DDTHH:mm:ss');
            var fecha_return;
            if(vm.dataToFill.selectedServiceDetails.category == 1  && vm.method_range_pickup_return){
                if(vm.pickRangeForRoutingReturn){
                    fecha_return = moment(vm.dataToFill.dropDateReturn).format('YYYY-MM-DD') +' '+ vm.pickRangeForRoutingReturn;
                }
                else if(vm.pickRange5){
                    fecha_return = moment(vm.dataToFill.dropDateReturn).format('YYYY-MM-DD') +' '+ vm.pickRange5;
                }
            } else if(!vm.method_range_pickup_return && vm.dataToFill.selectedServiceDetails.category == 1){
                if(vm.pickRange5){
                    fecha_return = moment(vm.dataToFill.dropDateReturn).format('YYYY-MM-DD') +' '+ vm.pickRange5;
                }
            } else if(vm.dataToFill.scheduledBooking && vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip == 'R' && vm.pickRange2){
                fecha_return = moment(vm.dataToFill.dropDateReturn).format('YYYY-MM-DD') +' '+ vm.pickRange2;
            } else{
                fecha_return = moment(vm.dataToFill.returnDate).format('YYYY-MM-DD HH:mm:ss');
            }
            dataSend.pickup_datetime_return = moment(fecha_return).format('YYYY-MM-DDTHH:mm:ss');
            if (vm.modifyFalg == true && vm.bookingDetails != undefined) {
                dataSend.job_id = vm.bookingDetails.job_id;
            }
            var isAirportFlag = 0;
            if (vm.fromAirportFlag) {
                isAirportFlag = 1;
            } else if (vm.toAirportFlag) {
                isAirportFlag = 2;
            }
            dataSend.airport = Number(isAirportFlag);
            if (vm.getInfoFlag == true) {
                dataSend.contract_id = vm.dataToFill.contractIdSelected;
            } else {
                dataSend.contract_id = data.contractIdSelected;
            }
            dataSend.service_type = data.serviceTypeSelected;
            vm.loading = true;
            if (data.serviceTypeSelected) {
                var promise = getBookings.getFixedRoutesForPersonal(dataSend);
                promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        console.log(payload, 'payload>>>>>>>>>>>SearchFixedVariable');
                        vm.searchFixedVariablePayload = payload;
                        vm.routingBase = payload.title.data.routing_base;
                        // Enabled category for routing base
                        if(vm.routingBase && vm.routingBase.routing_base_id > 0) {
                            vm.dataToFill.selectedServiceDetails.category = 1;
                            vm.method_range_pickup = 1;
                        }
                        if (payload.title.status == 400) {
                            vm.dataToFill.favPickLocId = '';
                            vm.dataToFill.favDropLocId = '';
                            vm.dataToFill.route_id = '';
                            vm.Flag = false;
                            vm.dataToFill.itemOfChargeList = [];
                            vm.dataToFill.itemOfChargeSelected = [];
                            if (payload.title.data && payload.title.data.custom_error) {
                                openPopForErrorAddress(payload);
                            } else {
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            }
                        } else if (payload.title.status == 401) {

                            //console.log(vm.dataToFill.route_id, 'vm.dataToFill.route_id123');
                            vm.dataToFill.favPickLocId = '';
                            vm.dataToFill.favDropLocId = '';
                            vm.Flag = false;
                            vm.dataToFill.route_id = '';
                            vm.dataToFill.itemOfChargeList = [];
                            vm.dataToFill.itemOfChargeSelected = [];
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            // if(!vm.modifyFalg) {
                            $timeout(function () {
                                if (vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                                    calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, map, 'SINGLE TRIP', payload);
                                    // getFixedRoutesForPersonal(vm.dataToFill);

                                }
                            }, 1000)
                            // }
                            vm.payloadForsearchFixedVairable = payload;
                            vm.dataToFill.route_id = payload.title.data.id;
                            sucursal_id = payload.title.data.branch;
                            if(payload.title.data.factor){
                                if(payload.title.data.factor.excepciones){
                                    vm.dataToFill.factor_value = payload.title.data.factor.excepciones[0].factor;
                                    vm.dataToFill.factor_tipo = 1;
                                    vm.dataToFill.factor_id = payload.title.data.factor.excepciones[0].id;
                                } else if(payload.title.data.factor.bloques){
                                    vm.dataToFill.factor_value = payload.title.data.factor.bloques[0].factor;
                                    vm.dataToFill.factor_tipo = 0;
                                    vm.dataToFill.factor_id = payload.title.data.factor.bloques[0].id;
                                }
                            } else {
                                delete vm.dataToFill.factor_value;
                                delete vm.dataToFill.factor_tipo;
                                delete vm.dataToFill.factor_id;
                            }
                            if(payload.title.data.finalResult_return.factor){
                                if(payload.title.data.finalResult_return.factor.excepciones){
                                    vm.dataToFill.factor_return_value = payload.title.data.finalResult_return.factor.excepciones[0].factor;
                                    vm.dataToFill.factor_return_tipo = 1;
                                    vm.dataToFill.factor_return_id = payload.title.data.finalResult_return.factor.excepciones[0].id;
                                } else if(payload.title.data.finalResult_return.factor.bloques){
                                    vm.dataToFill.factor_return_value = payload.title.data.finalResult_return.factor.bloques[0].factor;
                                    vm.dataToFill.factor_return_tipo = 0;
                                    vm.dataToFill.factor_return_id = payload.title.data.finalResult_return.factor.bloques[0].id;
                                }
                            } else {
                                delete vm.dataToFill.factor_return_value;
                                delete vm.dataToFill.factor_return_tipo;
                                delete vm.dataToFill.factor_return_id;
                            }

                            if (payload.title.data.id) {
                                vm.Flag = true;
                            } else {
                                vm.Flag = false;
                            }
                            vm.couponFlag = true;
                            $timeout(function (data) {
                                vm.getFixedRoutesForPersonalFlag = false;
                            }, 4000)
                            vm.type_of_trip1 = payload.title.data.type_of_trip;
                            vm.method_range_pickup = payload.title.data.method_range_pickup;
                            vm.method_range_pickup_return = payload.title.data.method_range_pickup;
                            vm.tolerance_for_shared_R = payload.title.data.tolerance;
                            vm.tolerance_time_withdrawal_pickup = payload.title.data.tolerance_time_withdrawal_pickup;
                            vm.travel_time_service_pick_up = payload.title.data.travel_time_service_pick_up;
                            //restriccion_flota = payload.title.data.restriccion_flota;
                            if (payload.title.data.type_of_trip == "Z") {
                                //console.log("yahan hun ma ");

                                vm.viaControlledFLag1 = true;
                                // vm.dataToFill.viaControlledApply = true;
                            } else {
                                vm.viaControlledFLag1 = false;
                                // vm.dataToFill.viaControlledApply = false;
                                // && vm.dataToFill.controlledWayCheck == 1
                            }
                            if (payload.title.data.pickup_tolerance_time_pap) {
                                vm.time_trip_shared_service_point_to_point = payload.title.data.pickup_tolerance_time_pap;
                                vm.pickup_travel_time_pap = payload.title.data.pickup_travel_time_pap;
                            } else {
                                vm.time_trip_shared_service_point_to_point = 0;
                                vm.pickup_travel_time_pap = 0;
                            }
                            vm.is_group_allowed = payload.title.data.is_group_allowed;
                            vm.is_group_external = payload.title.data.is_grouped_external;
                            vm.type_of_trip_Validate_Booking = payload.title.data.type_of_trip;
                            if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking == 'P') {
                                calculateDateRangeOfPointToPoint();
                            }
                            if (payload.title.data.type_of_trip == "Z" && payload.title.data.controlled_way_flag == 1 && vm.dataToFill.controlledWayCheck == 1) {
                                // vm.viaControlled1 = payload.title.data.via_controlled_price;
                                //if (vm.dataToFill.selectedServiceDetails.fare_type == 1 &&
                                    //vm.dataToFill.selectedServiceDetails.category == 1) {
                                    //vm.viaControlled1 = payload.title.data.via_controlled_price + (payload.title.data.via_controlled_price * (vm.dataToFill.passengerCount - 1));
                                    //console.log(vm.viaControlled1, ' vm.viaControlled1');

                                    //// vm.addViaControlled = 0;
                                //} else {
                                    vm.viaControlled1 = payload.title.data.via_controlled_price;
                                    // vm.addViaControlled = 0;
                                //}


                            } else {
                                vm.viaControlled1 = 0;
                            }
                            vm.dataToFill.route_type = payload.title.data.type_of_route;
                            console.log("1352254", vm.dataToFill.route_type);

                            vm.dataToFill.type_of_agreement = vm.dataToFill.customerProfile == 0 || vm.dataToFill.customerProfile == '0' ? 0 : 1;
                            vm.dataToFill.itemOfChargeList = [];
                            vm.dataToFill.itemOfChargeSelected = [];
                            vm.showToleranceFlag = payload.title.data.price_list.typeOfService.show_time_range;
                            if (payload.title.data.price_list.itemOfCharge && payload.title.data.price_list.itemOfCharge.length) {
                                for (var i = 0; i < payload.title.data.price_list.itemOfCharge.length; i++) {
                                    payload.title.data.price_list.itemOfCharge[i].quantity = 1;
                                    payload.title.data.price_list.itemOfCharge[i].oldPrice = payload.title.data.price_list.itemOfCharge[i].price;
                                    if (payload.title.data.price_list.itemOfCharge[i].tic_manually == 1) {
                                        var itemRet = payload.title.data.price_list.itemOfCharge[i];
                                        itemRet.tic_long_name = itemRet.tic_long_name + ' (Ida)';
                                        itemRet.retorno = false;
                                        vm.dataToFill.itemOfChargeList.push(itemRet);
                                    }
                                }
                            } else {
                                vm.dataToFill.itemOfChargeList = [];
                            }
                            // ********** ESTIMATE PRICE SHOW ********* 
                            if (vm.type_of_trip1 != 'P' && vm.flagForFlightDate == true) {
                                compareDates();
                            }

                            if ($stateParams.id) {
                                for (var i = 0; i < vm.dataToFill.itemOfChargeList.length; i++) {
                                    if (vm.bookingDetails.item_of_charge && vm.bookingDetails.item_of_charge.length) {
                                        for (var j = 0; j < vm.bookingDetails.item_of_charge.length; j++) {
                                            console.log("I m in this ", vm.bookingDetails.item_of_charge[j].long_name, vm.dataToFill.itemOfChargeList[i].tic_long_name);

                                            if (vm.bookingDetails.item_of_charge[j].long_name == vm.dataToFill.itemOfChargeList[i].tic_long_name) {
                                                if (vm.bookingDetails.item_of_charge[j].quantity) {
                                                    vm.dataToFill.itemOfChargeList[i].quantity = vm.dataToFill.itemOfChargeList[i].quantity;
                                                } else {
                                                    vm.dataToFill.itemOfChargeList[i].quantity = 1;
                                                }
                                                vm.dataToFill.itemOfChargeList[i].price = vm.bookingDetails.item_of_charge[j].price;
                                                vm.dataToFill.itemOfChargeSelected.push(vm.dataToFill.itemOfChargeList[i]);
                                            }
                                        }
                                    }
                                }
                                // vm.dataToFill.estimatedFareVariable = 0;
                                // if(vm.bookingDetails.item_of_charge.length)
                                selectingItemOfCharges(vm.dataToFill.itemOfChargeList)
                            }
                            if (payload.title.data.return_flag == true) {
                                //console.log(payload.title.data.finalResult_return.id, '++++++++++++++++++++++++++++');
                                vm.return_flag = payload.title.data.return_flag;
                                vm.dataToFill.Return_policy.route_id = payload.title.data.finalResult_return.id;
                                // vm.tolerance_time_withdrawal_pickup_return = payload.title.data.finalResult_return.tolerance_time_withdrawal_pickup;
                                vm.dataToFill.Return_policy.route_type = payload.title.data.finalResult_return.type_of_route;
                                vm.dataToFill.Return_policy.type_of_agreement = vm.dataToFill.customerProfile == 0 || vm.dataToFill.customerProfile == '0' ? 0 : 1;
                                vm.dataToFill.Return_policy.itemOfChargeList = [];
                                vm.dataToFill.Return_policy.itemOfChargeSelected = [];
                                if (payload.title.data.finalResult_return.price_list.itemOfCharge && payload.title.data.finalResult_return.price_list.itemOfCharge.length) {
                                    for (var i = 0; i < payload.title.data.finalResult_return.price_list.itemOfCharge.length; i++) {
                                        payload.title.data.finalResult_return.price_list.itemOfCharge[i].quantity = 1;
                                        payload.title.data.finalResult_return.price_list.itemOfCharge[i].oldPrice = payload.title.data.finalResult_return.price_list.itemOfCharge[i].price;
                                        if (payload.title.data.finalResult_return.price_list.itemOfCharge[i].tic_manually == 1) {
                                            var itemRet = payload.title.data.finalResult_return.price_list.itemOfCharge[i];
                                            itemRet.tic_long_name = itemRet.tic_long_name + ' (Vuelta)';
                                            itemRet.retorno = true;
                                            vm.dataToFill.itemOfChargeList.push(itemRet);
                                        }
                                    }
                                } else {
                                    vm.dataToFill.Return_policy.itemOfChargeList = [];
                                }

                                if (payload.title.data.finalResult_return.type_of_trip == "Z" && payload.title.data.finalResult_return.controlled_way_flag == 1 &&
                                    vm.dataToFill.controlledWayCheck == 1) {
                                    // vm.viaControlled2 = payload.title.data.finalResult_return.via_controlled_price;
                                    if (vm.dataToFill.selectedServiceDetails.fare_type == 1 &&
                                        vm.dataToFill.selectedServiceDetails.category == 1) {
                                        vm.viaControlled2 = payload.title.data.finalResult_return.via_controlled_price + (payload.title.data.finalResult_return.via_controlled_price * (vm.dataToFill.passengerCount - 1));
                                        // vm.addViaControlled = 0;
                                    } else {
                                        vm.viaControlled2 = payload.title.data.finalResult_return.via_controlled_price;
                                        // vm.addViaControlled = 0;
                                    }
                                    vm.SendTrip = payload.title.data.finalResult_return.type_of_trip;

                                } else {
                                    vm.viaControlled2 = 0;
                                }
                                vm.type_of_trip = payload.title.data.finalResult_return.type_of_trip;
                                if (payload.title.data.finalResult_return.type_of_trip == "Z") {
                                    vm.viaControlledFLag = true;
                                    vm.dataToFill.viaControlledApply = true;
                                } else {
                                    vm.viaControlledFLag = false;
                                    vm.dataToFill.viaControlledApply = false;
                                }
                                console.log(vm.type_of_trip1, vm.dataToFill.selectedServiceDetails.category, vm.method_range_pickup, 'test');
                                $timeout(function () {
                                    $timeout(function () {
                                        vm.loading = false;
                                    }, 200);
                                }, 800)

                                if ($stateParams.id) {
                                    //console.log(vm.dataToFill.Return_policy.itemOfChargeList);
                                    //console.log(vm.dataToFill.Return_policy.item_of_charge);
                                    for (var i = 0; i < vm.dataToFill.Return_policy.itemOfChargeList.length; i++) {
                                        if (vm.bookingDetails.item_of_charge && vm.bookingDetails.item_of_charge.length) {
                                            for (var j = 0; j < vm.bookingDetails.item_of_charge.length; j++) {
                                                if (vm.bookingDetails.item_of_charge[j].long_name == vm.dataToFill.Return_policy.itemOfChargeList[i].tic_long_name) {
                                                    if (vm.bookingDetails.item_of_charge[j].quantity) {
                                                        vm.dataToFill.Return_policy.itemOfChargeList[i].quantity = vm.dataToFill.Return_policy.itemOfChargeList[i].quantity;
                                                    } else {
                                                        vm.dataToFill.Return_policy.itemOfChargeList[i].quantity = 1;
                                                    }
                                                    vm.dataToFill.Return_policy.itemOfChargeList[i].price = vm.bookingDetails.item_of_charge[j].price;
                                                    vm.dataToFill.Return_policy.itemOfChargeSelected.push(vm.dataToFill.Return_policy.itemOfChargeList[i]);
                                                }
                                            }
                                        }
                                    }
                                    // if(vm.bookingDetails.item_of_charge.length)
                                    selectingItemOfCharges(vm.dataToFill.Return_policy.itemOfChargeList)
                                }
                            }
                            var timeoutNew = 0;
                            if (vm.modifyFalg == true) {
                                timeoutNew = 3000;
                            } else {
                                timeoutNew = 0;
                            }
                            $timeout(function () {
                                if ((vm.type_of_trip1 == 'R' && vm.dataToFill.selectedServiceDetails.category == 1 && vm.method_range_pickup) || (vm.routingBase && vm.routingBase.routing_base_id > 0)) {
                                    RoutingApiFuncation(vm.dataToFill, 0);
                                } else {
                                    vm.method_range_pickup = 0
                                }
                                if (vm.type_of_trip == 'R' && vm.dataToFill.selectedServiceDetails.category == 1 && vm.method_range_pickup_return && vm.dataToFill.roundTrip == 1) {
                                    RoutingApiFuncationRoundTrip(vm.dataToFill);
                                }
                            }, timeoutNew);
                            if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip == 'P') {
                                calculateDateRangeOfPointToPointReturn();
                            }
                            // ********* VARIABLES ARE INITIALIZE TO AGAIN SET INPUT FIELD VARIABLE ********
                            vm.calculatedEstimatePriceFormFunctionEstimated = -1;
                            vm.finalAdjustedPriceFromAdmin = 0;
                            vm.calculatedEstimatePriceForFixedPriceFormFunction = 0;
                            vm.calculatedEstimatePriceForRoundTripFormFunction = 0;
                            vm.click = false;
                            if (vm.toAirportFlag && payload.title.data.type_of_trip != 'R') {
                                openPopForWaringMessage(vm.type_of_trip1)
                            } else if (vm.fromAirportFlag && payload.title.data.type_of_trip != 'Z') {
                                openPopForWaringMessage(vm.type_of_trip1)
                            } else if (vm.ptopAirportFlag && payload.title.data.type_of_trip != 'P') {
                                openPopForWaringMessage(vm.type_of_trip1)
                            }
                        }
                        if (!vm.method_range_pickup) {
                            setTimeout(function () {
                                vm.disabledSubmitButton1 = false;
                            }, 1500)
                        }
                        //get_cuota();
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        vm.dataToFill.favPickLocId = '';
                        vm.dataToFill.favDropLocId = '';
                        vm.dataToFill.route_id = '';
                        vm.Flag = false;
                        //console.log(vm.dataToFill.route_id, 'vm.dataToFill.route_id_Error')
                        vm.dataToFill.itemOfChargeList = [];
                        vm.dataToFill.itemOfChargeSelected = [];
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            //errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            } else {
                vm.loading = false;
                errorMessageFactory.showErrorMessage("Por favor seleccione el servicio primero", 0);
            }

        };

        function get_cuota() {
            if(restriccion_flota == 1 && vm.type_of_trip_Validate_Booking != 'Z'){
                //el convenio tiene restriccion de flota, se debe consultar la cuota
                setTimeout(function(){ 
                var tipo_servicio = vm.dataToFill.serviceTypeSelected;
                var pasajeros = vm.dataToFill.passengerCount || 1; 
                var modificadaCuota = false;
                var fecha;
                if(vm.dataToFill.selectedServiceDetails.category == 1 && vm.pickRange1 && vm.pickRange2 && vm.dataToFill.airportCheck != 'Z'  &&  vm.method_range_pickup){
                    if(vm.pickRangeForRouting){
                        fecha = moment(vm.dataToFill.dropDate).format('YYYY-MM-DD') +' '+ vm.pickRangeForRouting;
                    }
                } else if(vm.dataToFill.selectedServiceDetails.category == 1 && vm.pickRange1 && vm.pickRange2 && vm.dataToFill.airportCheck != 'Z'  &&  !vm.method_range_pickup){
                    fecha = moment(vm.dataToFill.dropDate).format('YYYY-MM-DD') +' '+ vm.newPickRange3;
                } else if(vm.dataToFill.scheduledBooking && vm.dataToFill.selectedServiceDetails.category == 1){
                    fecha = vm.dataToFill.dropDate;
                } else {
                    if(vm.dataToFill.bookingType == '0'){
                        fecha = vm.dataToFill.dropDate;
                    } else {
                        if(vm.dataToFill.scheduledBooking == 1){
                            fecha = vm.dataToFill.scheduledTime;
                        } else {
                            fecha = vm.dataToFill.dropDate;
                        } 
                    }
                }
                if(vm.modifyFalgNew){
                    if(bloqueUsado.id == undefined || moment(fecha).isBetween(bloqueUsado.inicio, bloqueUsado.fin) ){
                        pasajeros = pasajeros - originalPassengerCount;
                        modificadaCuota = true;
                    }
                }
                console.log(sucursal_id, tipo_servicio, fecha);
                if( sucursal_id && tipo_servicio && fecha ){
                    vm.loading = true;
                    var d_cuota = moment(fecha);
                    var week_cuota = d_cuota.week();
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.fecha = moment(fecha).format('YYYY-MM-DDTHH:mm:ss');
                    dataSend.tipo_servicio = tipo_servicio;
                    dataSend.sucursal_id = sucursal_id;
                    dataSend.pasajeros = pasajeros;
                    dataSend.edit = modificadaCuota;
                    dataSend.original_tipo_servicio = originalTypeOfService;
                    dataSend.original_sucursal_id = originalBranch;
                    if (vm.bookingDetails){
                        dataSend.job_id = vm.bookingDetails.job_id;
                    }
                    var promise = getBookings.getFlotaCuota(dataSend);
                    promise.then(
                        function (payload) {
                            vm.loading = false;
                            var response = JSON.parse(payload.response);
                            if (response.data) {
                                //si esta editando se guarda el id del bloque si es que tiene
                                if(bloqueUsado.id == undefined && vm.modifyFalgNew){
                                    if(Object.keys(response.data.bloque) != 0){
                                        bloqueUsado.id = response.data.bloque.bloque_id;
                                        if(response.data.bloque.hora_inicio != undefined && response.data.bloque.hora_fin != undefined){
                                            var di_cuota = response.data.bloque.dia_inicio == 7 ? 0 : response.data.bloque.dia_inicio;
                                            var df_cuota = response.data.bloque.dia_fin == 7 ? 0 : response.data.bloque.dia_fin;
                                            var fullDayI_cuota = moment().week(week_cuota).isoWeekday(di_cuota).format("YYYY-MM-DD");
                                            var fullDayF_cuota = moment().week(week_cuota).isoWeekday(df_cuota).format("YYYY-MM-DD");
                                            bloqueUsado.inicio = moment(fullDayI_cuota+' '+response.data.bloque.hora_inicio).format("YYYY-MM-DDTHH:mm:ss");
                                            bloqueUsado.fin = moment(fullDayF_cuota+' '+response.data.bloque.hora_fin).format("YYYY-MM-DDTHH:mm:ss");
                                        } else {
                                            bloqueUsado.inicio = moment.utc(response.data.bloque.fecha_inicio).format("YYYY-MM-DDTHH:mm:ss");;
                                            bloqueUsado.fin = moment.utc(response.data.bloque.fecha_fin).format("YYYY-MM-DDTHH:mm:ss");
                                        }
                                    } else {
                                        bloqueUsado.id = 0;
                                    }
                                }
                                //solo si esta editando comparamos si cambia de bloque
                                if(response.data.bloqueado == 1 && vm.modifyFalgNew && bloqueUsado.id != undefined){

                                    errorMessageFactory.showErrorMessage("No hay disponibilidad del servicio seleccionado para el horario requerido. Revisa otras alternativas de horario.", 0);
                                    vm.disabledSubmitButton = false;
                                    return false;
                                }
                                //creacion de reserva flujo normal
                                if(response.data.bloqueado == 1 && !vm.modifyFalgNew){
                                    errorMessageFactory.showErrorMessage("No hay disponibilidad del servicio seleccionado para el horario requerido. Revisa otras alternativas de horario.", 0);
                                    vm.disabledSubmitButton = false;
                                    vm.fullCuota = true;
                                    return false;
                                }
                                vm.disabledSubmitButton = true;
                                vm.fullCuota = false;
                                return true;
                            }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );

                }
                return true;
                }, 2000);
            }
            return true;
        }

        function get_cuota_rt(){
            setTimeout(function(){
            if(restriccion_flota == 1 && vm.dataToFill.roundTrip && vm.type_of_trip_Validate_Booking == 'Z'){
                //el convenio tiene restriccion de flota, se debe consultar la cuota
                var tipo_servicio = vm.dataToFill.serviceTypeSelected;
                var pasajeros = vm.dataToFill.passengerCount || 1;
                var modificadaCuota = false;
                var fecha;
                if(vm.dataToFill.selectedServiceDetails.category == 1  && vm.method_range_pickup_return){
                    if(vm.pickRangeForRoutingReturn){
                        fecha = moment(vm.dataToFill.dropDateReturn).format('YYYY-MM-DD') +' '+ vm.pickRangeForRoutingReturn;
                    }
                } else if(!vm.method_range_pickup_return && vm.dataToFill.selectedServiceDetails.category == 1){
                    if(vm.pickRange5){
                        fecha = moment(vm.dataToFill.dropDateReturn).format('YYYY-MM-DD') +' '+ vm.pickRange5;
                    }
                } else if(vm.dataToFill.scheduledBooking && vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip == 'R' && vm.pickRange2){
                    fecha = moment(vm.dataToFill.dropDateReturn).format('YYYY-MM-DD') +' '+ vm.pickRange2;
                } else{
                    fecha = moment(vm.dataToFill.dropDateReturn).format('YYYY-MM-DD H:mm:ss');
                }
                if(vm.modifyFalgNew){
                    if(bloqueUsadoRt.id == undefined || moment(fecha).isBetween(bloqueUsadoRt.inicio, bloqueUsadoRt.fin) ){
                        pasajeros = pasajeros - originalPassengerCount;
                        modificadaCuota = true;
                    }
            }
            console.log(sucursal_id, tipo_servicio, fecha);
                if( sucursal_id && tipo_servicio && fecha ){
                    vm.loading = true;
                    var d_cuota = moment(fecha);
                    var week_cuota = d_cuota.week();
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.fecha = moment(fecha).format('YYYY-MM-DDTHH:mm:ss');
                    dataSend.tipo_servicio = tipo_servicio;
                    dataSend.sucursal_id = sucursal_id;
                    dataSend.pasajeros = pasajeros;
                    dataSend.edit = modificadaCuota;
                    dataSend.original_tipo_servicio = originalTypeOfService;
                    dataSend.original_sucursal_id = originalBranch;
                    var promise = getBookings.getFlotaCuota(dataSend);
                    promise.then(
                        function (payload) {
                            vm.loading = false;
                            var response = JSON.parse(payload.response);
                            if (response.data && vm.dataToFill.roundTrip) {
                                //si esta editando se guarda el id del bloque si es que tiene
                                if(bloqueUsadoRt.id == undefined && vm.modifyFalgNew){
                                    if(Object.keys(response.data.bloque) != 0){
                                        bloqueUsadoRt.id = response.data.bloque.bloque_id;
                                        if(response.data.bloque.hora_inicio != undefined && response.data.bloque.hora_fin != undefined){
                                            var di_cuota = response.data.bloque.dia_inicio == 7 ? 0 : response.data.bloque.dia_inicio;
                                            var df_cuota = response.data.bloque.dia_fin == 7 ? 0 : response.data.bloque.dia_fin;
                                            var fullDayI_cuota = moment().week(week_cuota).isoWeekday(di_cuota).format("YYYY-MM-DD");
                                            var fullDayF_cuota = moment().week(week_cuota).isoWeekday(df_cuota).format("YYYY-MM-DD");
                                            bloqueUsadort.inicio = moment(fullDayI_cuota+' '+response.data.bloque.hora_inicio).format("YYYY-MM-DDTHH:mm:ss");
                                            bloqueUsadoRt.fin = moment(fullDayF_cuota+' '+response.data.bloque.hora_fin).format("YYYY-MM-DDTHH:mm:ss");
                                        } else {
                                            bloqueUsadoRt.inicio = moment.utc(response.data.bloque.fecha_inicio).format("YYYY-MM-DDTHH:mm:ss");;
                                            bloqueUsadoRt.fin = moment.utc(response.data.bloque.fecha_fin).format("YYYY-MM-DDTHH:mm:ss");
                                        }
                                    } else {
                                        bloqueUsadoRt.id = 0;
                                    }
                                }
                                //solo si esta editando comparamos si cambia de bloque
                                if(response.data.bloqueado == 1 && vm.modifyFalgNew && bloqueUsadoRt.id != undefined){
                                        errorMessageFactory.showErrorMessage("No hay disponibilidad del servicio seleccionado para el horario RT requerido. Revisa otras alternativas de horario.", 0);
                                        vm.disabledSubmitButton = false;
                                        return false;
                                }
                                //creacion de reserva - flujo normal
                                if(response.data.bloqueado == 1 && !vm.modifyFalgNew){
                                    errorMessageFactory.showErrorMessage("No hay disponibilidad del servicio seleccionado para el horario RT requerido. Revisa otras alternativas de horario.", 0);
                                    vm.disabledSubmitButton = false;
                                    vm.fullCuotaRT = true;
                                    return false;
                                }
                                if(vm.fullCuota){
                                    vm.disabledSubmitButton = false;
                                } else {
                                    vm.disabledSubmitButton = true;
                                }
                                vm.fullCuotaRT = false;
                                return true;
                            }
                            if(vm.fullCuota){
                                vm.disabledSubmitButton = false;
                            } else {
                                vm.disabledSubmitButton = true;
                            }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );

                }
                return true;
            }
            return true;
            }, 3000)
        }

        //=======================get spot agreement for personal======================
        function getSpotAgreement() {
            vm.loading = true;
            vm.dataToFill.contractIdSelected = 0;
            vm.dataToFill.contractIdSelectedQREnabled = 0;
            vm.dataToFill.is_vip = 0;
            var promise = getBookings.getSpotAgreementForBooking();
            promise.then(
                function (payload) {
                    //console.log('payment methods==========', payload.title);
                    vm.loading = false;
                    if (payload.title.data) {
                        vm.personalFlag = true;
                        // vm.flagForAirline = true;
                        vm.dataToFill.contractIdSelected = payload.title.data.contract_id.id;
                        vm.dataToFill.contractIdSelectedQREnabled = payload.title.data.contract_id.qrcode_status;
                        restriccion_flota = payload.title.data.contract_id.restriccion_flota;
                        getCustomerFavouriteAddress();
                        if (!$stateParams.id)
                            vm.dataToFill.payment_method = payload.title.data.contract_id.payment_method_default;
                        if (payload.title.data.contract_id.airline_mandatory == 1) {
                            vm.flagForAirline = true;
                        }
                        if (payload.title.data.contract_id.flight_number_mandatory == 1) {
                            vm.flagForFlightNumber = true;
                        }
                        if (payload.title.data.contract_id.flight_date_mandatory == 1) {
                            vm.flagForFlightDate = true;
                        }
                        if (payload.title.data.contract_id.flight_type_mandatory == 1) {
                            vm.flagForFlightType = true;
                        }
                        vm.airlineMandatory = payload.title.data.contract_id.airline_mandatory;
                        vm.flightNumberMandatory = payload.title.data.contract_id.flight_number_mandatory;
                        vm.flightDateMandatory = payload.title.data.contract_id.flight_date_mandatory;
                        vm.flightTypeMandatory = payload.title.data.contract_id.flight_type_mandatory;
                        vm.serviceTypeList = payload.title.data.service_types;
                        //getFixedRoutesForPersonal(payload.title.data);
                        vm.dataToFill.passengerRutCheck = payload.title.data.contract_id.RUT_mendatory;
                        vm.dataToFill.applicantRutCheck = payload.title.data.contract_id.applicant_RUT_mendatory;
                        vm.dataToFill.costCenterCheck = payload.title.data.contract_id.cost_center_mandatory;
                        vm.dataToFill.costSubCenterCheck = payload.title.data.contract_id.cost_sub_center_mandatory;
                        vm.dataToFill.RolCheck = payload.title.data.contract_id.ROL_mandatory;
                        vm.dataToFill.graphCheck = payload.title.data.contract_id.graph_mandatory;
                        vm.dataToFill.workOrderCheck = payload.title.data.contract_id.work_order_mandatory;
                        vm.dataToFill.pepCheck = payload.title.data.contract_id.PEP_mandatory;
                        vm.dataToFill.purposeOfTripCheck = payload.title.data.contract_id.purpose_of_trip_mandatory;
                        vm.dataToFill.noOfVoucherCheck = payload.title.data.contract_id.number_of_voucher_mandatory;
                        vm.dataToFill.nominaCheck = payload.title.data.contract_id.nomina_mandatory;
                        vm.dataToFill.controlledWayCheck = payload.title.data.contract_id.controlled_way;
                        vm.dataToFill.controllerWayTarifa = payload.title.data.contract_id.via_control_include_in_tarifa;
                        vm.dataToFill.solictudCheck = payload.title.data.contract_id.solicitud_mandatory;
                        vm.dataToFill.roundTripDiscount = payload.title.data.contract_id.rt_discount;
                        vm.dataToFill.webDiscount = payload.title.data.contract_id.web_discount;
                        vm.dataToFill.allowChangeFarePanel = payload.title.data.contract_id.allow_change_fare_panel || 0;
                        vm.click = false; //Because after click on modify input field will change when personal or corporate changes
                        vm.dataToFill.allowBookingWithoutRequest = payload.title.data.contract_id.is_bwr;
                        vm.dataToFill.paymentMethodList = [];
                        // ON CHANGE AGREEMENT MODIFY INPUT FILED CHANGE INTO STATIC VALUE
                        vm.click = false;

                        for (var i = 0; i < payload.title.data.payment.length; i++) {
                            for (var j = 0; j < payload.title.data.payment[i].mapping.length; j++) {
                                if (payload.title.data.payment[i].mapping[j].channel_name == 'pannel') {
                                    vm.dataToFill.paymentMethodList.push(payload.title.data.payment[i]);
                                }
                            }
                        }
                        if (vm.dataToFill.paymentMethodList.length == 0) {
                            var where = _.where(payload.title.data.payment, {
                                id: Number(vm.dataToFill.payment_method)
                            })[0];
                            vm.dataToFill.paymentMethodList.push(where);
                        } else {
                            var where = _.where(vm.dataToFill.paymentMethodList, {
                                id: Number(vm.dataToFill.payment_method)
                            });
                            if (where.length == 0) {
                                vm.dataToFill.payment_method = '';
                            }
                        }
                        if ($stateParams.id) {
                            serviceTypeChanged();
                        }
                        //console.log('vm.dataToFill.paymentMethodList', vm.dataToFill.paymentMethodList);
                    } else {
                        vm.dataToFill.contractIdSelected = '';
                        vm.dataToFill.contractIdSelectedQREnabled = 0;
                        vm.serviceTypeList = [];
                        vm.dataToFill.paymentMethodList = [];
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function getCorporateAgreement() {
            vm.dataToFill.contractList = [];
            vm.dataToFill.contractListShowing = [];
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.employee_id = vm.dataToFill.employeeId;
            //dataSend.contract_id = vm.dataToFill.customerContarctId;
            vm.loading = true;
            var promise = getBookings.getCorporateAgreementForBooking(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    console.log(payload);

                    if (payload.title.data) {

                        //  vm.flagForAirline = true;
                        for (var i = 0; i < payload.title.data.length; i++) {
                            vm.dataToFill.contractList.push(payload.title.data[i]);
                            vm.dataToFill.contractListShowing.push({
                                id: payload.title.data[i].id,
                                name: payload.title.data[i].name,
                                is_block: payload.title.data[i].employee_details.panel_booking_access || 0
                            })
                        }
                        //vm.dataToFill.contractIdSelected = payload.title.data.contract_id.id;
                        //vm.serviceTypeList = payload.title.data.service_types;
                        //getFixedRoutesForPersonal(payload.title.data);
                    } else {
                        vm.dataToFill.contractList = [];
                        vm.dataToFill.contractListShowing = [];
                        //vm.serviceTypeList = [];
                    }
                    if (vm.dataToFill.bookingId) {
                        agreementTypeChanged();
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function agreementTypeChanged() {
            var isAgreementBlock = 0;
            var isAgreementBlockIndex = _.findIndex(vm.dataToFill.contractListShowing, {
                id: vm.dataToFill.contractIdSelected
            })
            if (isAgreementBlockIndex > -1) {
                isAgreementBlock = vm.dataToFill.contractListShowing[isAgreementBlockIndex].is_block;
                if (isAgreementBlock == 0) {
                    errorMessageFactory.showErrorMessage('Este cliente no está autorizado para crear reservas desde el panel', 0);
                    vm.dataToFill.contractIdSelected = '';
                    vm.dataToFill.contractIdSelectedQREnabled = 0;
                    return;
                }
            }
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.offset = 0;
            dataSend.limit = 0;
            dataSend.key = 3;
            dataSend.id = vm.dataToFill.contractIdSelected;
            vm.loading = true;
            var promise = getAgreement.allAgreementBooking(dataSend);
            promise.then(
                function (payload) {
                    vm.loading = false;
                    vm.finalAgreement = payload.title.data.result;
                    //console.log('final Agreement', vm.finalAgreement);
                    vm.serviceTypeList = [];
                    for (var i = 0; i < payload.title.data.result[0].type_of_service.length; i++) {
                        vm.serviceTypeList.push(payload.title.data.result[0].type_of_service[i]);
                    }
                    vm.dataToFill.customerContarctId = payload.title.data.result[0].id;
                    restriccion_flota = payload.title.data.result[0].restriccion_flota;
                    console.log('hello')
                    getCustomerFavouriteAddress();
                    if (!$stateParams.id)
                        vm.dataToFill.payment_method = payload.title.data.result[0].payment_method_default;
                    if (payload.title.data.result[0].airline_mandatory == 1) {
                        vm.flagForAirline = true;
                    }
                    if (payload.title.data.result[0].flight_number_mandatory == 1) {
                        vm.flagForFlightNumber = true;
                    }
                    if (payload.title.data.result[0].flight_date_mandatory == 1) {
                        vm.flagForFlightDate = true;
                    }
                    if (payload.title.data.result[0].flight_type_mandatory == 1) {
                        vm.flagForFlightType = true;
                    }
                    vm.airlineMandatory = payload.title.data.result[0].airline_mandatory;
                    vm.flightNumberMandatory = payload.title.data.result[0].flight_number_mandatory;
                    vm.flightDateMandatory = payload.title.data.result[0].flight_date_mandatory;
                    vm.flightTypeMandatory = payload.title.data.result[0].flight_type_mandatory;
                    vm.dataToFill.passengerRutCheck = payload.title.data.result[0].RUT_mendatory;
                    vm.dataToFill.applicantRutCheck = payload.title.data.result[0].applicant_RUT_mendatory;
                    vm.dataToFill.costCenterCheck = payload.title.data.result[0].cost_center_mandatory;
                    vm.dataToFill.costSubCenterCheck = payload.title.data.result[0].cost_sub_center_mandatory;
                    vm.dataToFill.RolCheck = payload.title.data.result[0].ROL_mandatory;
                    vm.dataToFill.graphCheck = payload.title.data.result[0].graph_mandatory;
                    vm.dataToFill.workOrderCheck = payload.title.data.result[0].work_order_mandatory;
                    vm.dataToFill.pepCheck = payload.title.data.result[0].PEP_mandatory;
                    vm.dataToFill.purposeOfTripCheck = payload.title.data.result[0].purpose_of_trip_mandatory;
                    vm.dataToFill.noOfVoucherCheck = payload.title.data.result[0].number_of_voucher_mandatory;
                    vm.dataToFill.nominaCheck = payload.title.data.result[0].nomina_mandatory;
                    vm.dataToFill.controlledWayCheck = payload.title.data.result[0].controlled_way;
                    vm.dataToFill.controllerWayTarifa = payload.title.data.result[0].via_control_include_in_tarifa;
                    vm.dataToFill.solictudCheck = payload.title.data.result[0].solicitud_mandatory;
                    vm.dataToFill.roundTripDiscount = payload.title.data.result[0].rt_discount;
                    vm.dataToFill.webDiscount = payload.title.data.result[0].web_discount;
                    vm.dataToFill.allowChangeFarePanel = payload.title.data.result[0].allow_change_fare_panel || 0;
                    vm.dataToFill.allowBookingWithoutRequest = payload.title.data.result[0].is_bwr;
                    vm.dataToFill.contractIdSelectedQREnabled  = payload.title.data.result[0].qrcode_status;
                    // ON CHANGE AGREEMENT MODIFY INPUT FILED CHANGE INTO STATIC VALUE
                    vm.click = false;

                    vm.addressChange = true;

                    vm.dataToFill.roundTrip == false;

                    vm.dataToFill.paymentMethodList = [];

                    for (var i = 0; i < payload.title.data.result[0].payment.length; i++) {
                        if (payload.title.data.result[0].payment[i].channel_name == 'pannel') {
                            vm.dataToFill.paymentMethodList.push(payload.title.data.result[0].payment[i]);
                        }
                    }

                    if (vm.dataToFill.paymentMethodList.length == 0) {
                        for (var i = 0; i < payload.title.data.result[0].payment.length; i++) {
                            if (payload.title.data.result[0].payment[i].id == Number(vm.dataToFill.payment_method)) {
                                vm.dataToFill.paymentMethodList.push(payload.title.data.result[0].payment[i]);
                            }
                        }
                    } else {
                        var where = _.where(vm.dataToFill.paymentMethodList, {
                            id: Number(vm.dataToFill.payment_method)
                        });
                        console.log(!where, where.length == 0, '!where && where.length == 0');

                        if (where.length == 0) {
                            console.log(vm.dataToFill.payment_method, 'vm.dataToFill.payment_method');

                            vm.dataToFill.payment_method = '';
                            console.log(vm.dataToFill.payment_method, 'vm.dataToFill.payment_method');
                        }
                    }


                    var where = _.where(vm.dataToFill.contractList, {
                        id: Number(vm.dataToFill.contractIdSelected)
                    });
                    vm.selectedEmployeeData = where[0];
                    if (!payload.title.data.result[0].employee_details) {
                        if (where.length) {
                            vm.dataToFill.corporate_account_id = where[0].employee_details.corporate_id;
                            vm.dataToFill.authRequired = where[0].employee_details.approval_required;
                            vm.dataToFill.auther_id = where[0].employee_details.auther_id; //auth_RUT
                            vm.dataToFill.authRUT = RutHelper.format(where[0].employee_details.auth_RUT);
                            vm.dataToFill.authName = where[0].employee_details.auth_name;
                            if (vm.modifyFalg == false) {
                                vm.dataToFill.passengerRut = RutHelper.format(where[0].employee_details.RUT);
                                vm.dataToFill.applicantRut = RutHelper.format(where[0].employee_details.RUT);
                                vm.dataToFill.costCenter = where[0].employee_details.cost_center;
                                vm.dataToFill.costSubCenter = where[0].employee_details.cost_subcenter;
                                vm.dataToFill.Rol = where[0].employee_details.ROI;
                                vm.dataToFill.graph = where[0].employee_details.graph;
                                vm.dataToFill.workOrder = where[0].employee_details.order_of_work;
                                vm.dataToFill.pep = where[0].employee_details.PEP;
                                vm.dataToFill.is_vip = where[0].employee_details.is_vip;
                            }


                            if (where[0].employee_details.thirdBooking == 1) {
                                vm.bookingForOptions = [{
                                    // name: 'Self',
                                    name:'Para mi',
                                    value: 0
                                },
                                {
                                    //name: 'Someone else',
                                    name:'Alguien más',
                                    value: 1
                                }
                                ];
                            } else {
                                vm.bookingForOptions = [{
                                    name: 'Para mi',
                                    value: 0
                                }];
                            }
                        } else {
                            vm.dataToFill.corporate_account_id = payload.title.data.result[0].corporate_id.id;
                            vm.dataToFill.authRequired = 0;
                            vm.dataToFill.auther_id = '';
                            vm.dataToFill.authRUT = '';
                            vm.dataToFill.authName = '';
                            // vm.dataToFill.passengerRut = '';
                            vm.dataToFill.applicantRut = '';
                            vm.dataToFill.costCenter = '';
                            vm.dataToFill.costSubCenter = '';
                            vm.dataToFill.Rol = '';
                            vm.dataToFill.graph = '';
                            vm.dataToFill.workOrder = '';
                            vm.dataToFill.pep = '';
                            vm.dataToFill.is_vip = 0;
                            vm.bookingForOptions = [{
                                name: 'Para mi',
                                value: 0
                            }];
                        }
                    }
                    if (vm.dataToFill.bookingId) {
                        serviceTypeChanged();
                    }

                    if (vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                        vm.dataToFill.discounts = [];
                        vm.dataToFill.couponValidation = false;
                        vm.dataToFill.couponCode = '';
                        getFixedRoutesForPersonal(vm.dataToFill);
                    }

                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
            //var where = _.where(vm.dataToFill.contractList,{id:Number(vm.dataToFill.contractIdSelected)});
            //vm.serviceTypeList = where[0].type_of_service;
            //vm.dataToFill.corporate_account_id = where[0].employee_details.corporate_id;
            //vm.dataToFill.customerContarctId = where[0].contract_id;
            //vm.dataToFill.payment_method = where[0].payment_method_default;
            //vm.dataToFill.authRequired = where[0].employee_details.approval_required;
            //vm.dataToFill.auther_id = where[0].employee_details.auther_id; //auth_RUT
            //vm.dataToFill.authRUT = RutHelper.format(where[0].employee_details.auth_RUT);
            //vm.dataToFill.authName = where[0].employee_details.auth_name;
            //vm.dataToFill.passengerRutCheck = where[0].RUT_mendatory;
            //vm.dataToFill.applicantRutCheck = where[0].applicant_RUT_mendatory;
            //vm.dataToFill.costCenterCheck = where[0].cost_center_mandatory;
            //vm.dataToFill.costSubCenterCheck = where[0].cost_sub_center_mandatory;
            //vm.dataToFill.RolCheck = where[0].ROL_mandatory;
            //vm.dataToFill.graphCheck = where[0].graph_mandatory;
            //vm.dataToFill.workOrderCheck = where[0].work_order_mandatory;
            //vm.dataToFill.pepCheck = where[0].PEP_mandatory;
            //vm.dataToFill.purposeOfTripCheck = where[0].purpose_of_trip_mandatory;
            //vm.dataToFill.noOfVoucherCheck = where[0].number_of_voucher_mandatory;
            //vm.dataToFill.nominaCheck = where[0].nomina_mandatory;
            //vm.dataToFill.solictudCheck = where[0].solicitud_mandatory;

            //vm.dataToFill.passengerRut = RutHelper.format(where[0].employee_details.RUT);
            //vm.dataToFill.applicantRut = RutHelper.format(where[0].employee_details.RUT);
            //vm.dataToFill.costCenter = where[0].employee_details.cost_center;
            //vm.dataToFill.costSubCenter = where[0].employee_details.cost_subcenter;
            //vm.dataToFill.Rol = where[0].employee_details.ROI;
            //vm.dataToFill.graph = where[0].employee_details.graph;
            //vm.dataToFill.workOrder = where[0].employee_details.order_of_work;
            //vm.dataToFill.pep = where[0].employee_details.PEP;

            //if(where[0].employee_details.thirdBooking == 1){
            //    vm.bookingForOptions = [
            //        {
            //            name: 'Self',
            //            value: 0
            //        },
            //        {
            //            name: 'Para alguien más',
            //            value: 1
            //        }
            //    ];
            //}
            //else{
            //    vm.bookingForOptions = [
            //        {
            //            name: 'Self',
            //            value: 0
            //        }
            //    ];
            //}
            //if(vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat)
            //    getFixedRoutesForPersonal(vm.dataToFill);

            // // THIS CHECK IS FOR PET USER
            if ((JSON.parse($cookies.get('adminType') || 0) == 1) && (vm.dataToFill.customerId > 0)) {
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.customer_id = vm.dataToFill.customerId;
                dataSend.contract_id = vm.dataToFill.contractIdSelected;
                dataSend.is_customer = 0; // 0-frontend ,1- customerApp
                var promise = getAgreement.getDetailsForPET(dataSend);
                promise.then(
                    function (payload) {

                        vm.loading = false;
                        if (payload.title.status == 400) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            if (payload.title && payload.title.data && payload.title.data.phone_number && payload.title.data.email) {
                                vm.isEmpDataChange = true; // TV-2378
                                vm.dataToFill.customerMobileG = payload.title.data.phone_number;
                                vm.dataToFill.customerEmail = payload.title.data.email;
                                vm.dataToFill.customerMobile = payload.title.data.name + ' ' + payload.title.data.last_name;
                            }
                        }
                    },
                    function (errorPayload) {
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }
        }
        //=====================profile changes function ===============================
        function profileChanges() {
            $log.log(vm.dataToFill);
            vm.dataToFill.itemOfChargeSelected = [];
            vm.dataToFill.item_of_charges = [];
            vm.dataToFill.is_item_of_charges = 0;
            vm.dataToFill.itemOfChargeSelected = [];
            vm.dataToFill.pickUpAddress = '';
            vm.dataToFill.dropOffAddress = '';
            vm.dataToFill.pickUpLat = '';
            vm.dataToFill.pickUpLng = '';
            vm.dataToFill.dropOffLat = '';
            vm.dataToFill.dropOffLng = '';
            vm.dataToFill.favDropLocId = '';
            vm.dataToFill.favPickLocId = '';
            vm.dataToFill.authRequired = 0;
            vm.dataToFill.passengerRutCheck = 0;
            vm.dataToFill.applicantRutCheck = 0;
            vm.dataToFill.costCenterCheck = 0;
            vm.dataToFill.costSubCenterCheck = 0;
            vm.dataToFill.RolCheck = 0;
            vm.dataToFill.graphCheck = 0;
            vm.dataToFill.workOrderCheck = 0;
            vm.dataToFill.pepCheck = 0;
            vm.dataToFill.purposeOfTripCheck = 0;
            vm.dataToFill.noOfVoucherCheck = 0;
            vm.dataToFill.nominaCheck = 0;
            vm.dataToFill.controlledWayCheck = 0;
            vm.dataToFill.controllerWayTarifa = 0;
            vm.dataToFill.solictudCheck = 0;
            vm.dataToFill.passengerRut = '';
            vm.dataToFill.applicantRut = '';
            vm.dataToFill.costCenter = '';
            vm.dataToFill.costSubCenter = '';
            vm.dataToFill.Rol = '';
            vm.dataToFill.is_vip = 0;
            vm.dataToFill.graph = '';
            vm.dataToFill.workOrder = '';
            vm.dataToFill.pep = '';
            vm.dataToFill.purposeOfTrip = '';
            vm.dataToFill.noOfVoucher = '';
            vm.dataToFill.estimatedFare = '';
            vm.dataToFill.estimatedFareRoute = '';
            vm.dataToFill.estimatedFareVariable = '';

            vm.dataToFill.contractIdSelected = 0;
            vm.dataToFill.contractIdSelectedQREnabled = 0;
            vm.dataToFill.personName = '';
            vm.dataToFill.personEmail = '';
            vm.dataToFill.discounts = [];
            vm.dataToFill.couponValidation = false;
            vm.dataToFill.couponCode = '';
            vm.dataToFill.personMobile = '';
            // mapInitialize();

            if (vm.dataToFill.customerProfile == 0 || vm.dataToFill.customerProfile == '0') {
                vm.newPersonFlag = true;
                getSpotAgreement();

            } else if (vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == '1') {
                vm.newPersonFlag = false;
                getCorporateAgreement();
            }

            //get_cuota();
        };

        //===================service type changed =========================
        function serviceTypeChanged() {
            vm.addressChange = true;
            if (vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                setTimeout(function () {
                    getFixedRoutesForPersonal(vm.dataToFill);
                }, 2000);
            } else {

            }

            if (vm.dataToFill.pickUpLat && (vm.dataToFill.bookingType == '0' || vm.dataToFill.bookingType == 0) && vm.dataToFill.airportCheck != 'Z' && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2)) {
                vm.dataToFill.nearDriver = '';
                toGetNearByDrivers(vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.serviceTypeSelected, map);
            }

            vm.dataToFill.selectedServiceDetails = _.where(vm.serviceTypeList, {
                id: vm.dataToFill.serviceTypeSelected
            })[0];
            vm.bookingTypeOptions = [];
            //console.log('sasda', vm.serviceTypeList);
            if (vm.dataToFill.selectedServiceDetails.is_current) {
                vm.bookingTypeOptions.push({
                    name: "De Minuto",
                    value: "0"
                })
            }
            if (vm.dataToFill.selectedServiceDetails.is_scheduled) {
                vm.bookingTypeOptions.push({
                    name: "Programada",
                    value: "1"
                })
            }

            if (vm.dataToFill.selectedServiceDetails.category == 1 && vm.dataToFill.etaScheduleValue)
                calculateEstimatePickUpTime(vm.dataToFill.etaScheduleValue);

        }
        //============================date time format==============================
        function calculateEstimatePickUpTime(eta) {
            //console.log(eta, vm.dataToFill.selectedServiceDetails,"phata");
            var etaSeconds;
            if (vm.dataToFill.selectedServiceDetails.category == 1) {
                etaSeconds = Math.round(eta) * 60 + vm.dataToFill.time_trip_shared_service * 60;
            } else {
                etaSeconds = Math.round(eta) * 60;
            }
            var addEtaSeconds = vm.tolerance_for_shared_R * 60;
            vm.etaSeconds = etaSeconds;
            var tolerance = vm.dataToFill.selectedServiceDetails.tolerance * 60;
            if (new Date(vm.dataToFill.dropDate) != 'Invalid Date' && new Date(vm.dataToFill.dropTime) != 'Invalid Date') {
                var dropDateTimeNewFormat = dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime);
            } else {
                var dropDateTimeNewFormat = new Date();
            }
            var addEtaSeconds = vm.tolerance_for_shared_R * 60;
            var pickRange3 = moment(dropDateTimeNewFormat).subtract(etaSeconds, 'seconds');
            // var pickRange3 = moment(dropDateTimeNewFormat).subtract(etaSeconds, 'seconds');
            // vm.pickUpTime = pickRange3;
            var pickRange2 = moment(dropDateTimeNewFormat).subtract(etaSeconds, 'seconds').add(tolerance, 'seconds');
            var pickRange1 = moment(dropDateTimeNewFormat).subtract(etaSeconds, 'seconds').subtract(tolerance, 'seconds');
            vm.pickRange1 = moment(pickRange1).format('HH:mm');
            vm.pickRange2 = moment(pickRange2).format('HH:mm');
            var newPickRange3 = moment(pickRange3).subtract(addEtaSeconds, 'seconds');
            vm.pickRange3 = moment(pickRange3).format('HH:mm');
            vm.newPickRange3 = moment(newPickRange3).format('HH:mm');
            var pickRange3ToShowAdd = moment(pickRange3).add(addEtaSeconds, 'seconds');
            vm.pickRange3ToShowAdd = moment(pickRange3ToShowAdd).format('HH:mm');
            if (vm.modifyFalgNew) {
                vm.newPickRange3 = moment(vm.bookingDetails.time_with_tolerance_before).format('HH:mm');
                vm.pickRange3ToShowAdd = moment(vm.bookingDetails.time_with_tolerance_after).format('HH:mm');
            }
            // vm.pickRange4 = module().format('HH:mm');
            // //console.log("Puneet changes");
            var pickRange4 = moment(dropDateTimeNewFormat).subtract(vm.dataToFill.time_trip_shared_service, 'minutes');
            vm.pickRange4 = moment(pickRange4).format('HH:mm');
        }


        function calculateEstimatePickUpTimeForRTypeReturn(eta) {
            var etaSeconds;
            console.log("in case of return", eta);

            etaSeconds = Math.round(eta) * 60;
            var tolerance = vm.travel_time_service_pick_up * 60;
            var addTolerance = vm.tolerance_time_withdrawal_pickup * 60;
            var dropDateTimeNewFormat;
            if (new Date(vm.dataToFill.dropDateReturn) != 'Invalid Date' && new Date(vm.dataToFill.dropTimeReturn) != 'Invalid Date') {
                dropDateTimeNewFormat = dateTimeFormat(vm.dataToFill.dropDateReturn, vm.dataToFill.dropTimeReturn);
            } else {
                dropDateTimeNewFormat = new Date();
            }
            var pickRangeForRtypeReturn = moment(dropDateTimeNewFormat).subtract(etaSeconds, 'seconds').subtract(tolerance, 'seconds');
            vm.errorShowDateForRTypeReturn = pickRangeForRtypeReturn;
            if (vm.is_group_allowed == 1 && vm.discard_booking_flag != 1) {
                var newpickRangeForRtypeReturn = moment(pickRangeForRtypeReturn).subtract(addTolerance, 'seconds');
                vm.pickRangeForRTypeReturn = moment(newpickRangeForRtypeReturn).format('HH:mm');
            } else {
                vm.pickRangeForRTypeReturn = moment(pickRangeForRtypeReturn).format('HH:mm');
            }
            // vm.pickRangeForRTypeReturn = moment(pickRangeForRtypeReturn).format('HH:mm');
            var pickRangeForEstimatedReturn = moment(pickRangeForRtypeReturn).add(addTolerance, 'seconds');
            vm.pickRangeForEstimatedReturn = moment(pickRangeForEstimatedReturn).format('HH:mm');
            if (vm.modifyFalgNew) {
                vm.pickRangeForRTypeReturn = moment(vm.bookingDetails.time_with_tolerance_before).format('HH:mm');
                vm.pickRangeForEstimatedReturn = moment(vm.bookingDetails.time_with_tolerance_after).format('HH:mm');
            }
        }
        //============================date time format==============================
        function calculateEstimatePickUpTimeForRType(eta) {
            var datePointToPoint = dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime)

            var newpickRangeForRtypeReturn = '';
            if (vm.is_group_allowed == 1) {
                newpickRangeForRtypeReturn = moment(datePointToPoint).subtract((vm.tolerance_time_withdrawal_pickup * 60), 'seconds');
            } else {
                newpickRangeForRtypeReturn = datePointToPoint;
            }
            if (vm.modifyFalgNew) {
                vm.pickRangeForRType = moment(vm.bookingDetails.time_with_tolerance_before).format('HH:mm');
            } else {
                vm.pickRangeForRType = moment(newpickRangeForRtypeReturn).format('HH:mm');
            }
            var rangePointToPoint = moment(datePointToPoint).add((vm.tolerance_time_withdrawal_pickup * 60), 'seconds');
            vm.pickRangeForEstimated = moment(rangePointToPoint).format('HH:mm');
        }

        function calculateEstimatePickUpTimeReturn(eta) {
            var etaSeconds;
            if (vm.dataToFill.selectedServiceDetails.category == 1) {
                etaSeconds = Math.round(eta) * 60 + vm.dataToFill.time_trip_shared_service * 60;
            } else {
                etaSeconds = Math.round(eta) * 60;
            }
            vm.etaSeconds = etaSeconds;
            var addEtaSeconds = vm.tolerance_for_shared_R * 60;
            var tolerance = vm.tolerance_time_withdrawal_pickup * 60;
            if (new Date(vm.dataToFill.dropDateReturn) != 'Invalid Date' && new Date(vm.dataToFill.dropTimeReturn) != 'Invalid Date') {
                var dropDateTimeNewFormat = dateTimeFormat(vm.dataToFill.dropDateReturn, vm.dataToFill.dropTimeReturn);
            } else {
                var dropDateTimeNewFormat = new Date();
            }
            var pickRange3 = moment(dropDateTimeNewFormat).subtract(etaSeconds, 'seconds');
            var pickRange2 = moment(dropDateTimeNewFormat).format('HH:mm');
            var pickRange1 = moment(dropDateTimeNewFormat).add(tolerance, 'seconds');
            var pickRange10 = moment(pickRange1).format('HH:mm');
            var pickRange3 = moment(dropDateTimeNewFormat).subtract(etaSeconds, 'seconds').subtract(tolerance, 'seconds');
            var pickRange4 = moment(pickRange3).format('HH:mm');
            var newpickRange3 = moment(pickRange3).subtract(addEtaSeconds, 'seconds');
            vm.pickRange5 = moment(newpickRange3).format('HH:mm');
            vm.pickRange2 = pickRange2;
            var pickRange3ToShowAdd = moment(pickRange3).add(addEtaSeconds, 'seconds');
            vm.pickRange3ToShowAddReturn = moment(pickRange3ToShowAdd).format('HH:mm');
            vm.pickRange10 = pickRange10;
            if (vm.modifyFalgNew) {
                vm.pickRange5 = moment(vm.bookingDetails.time_with_tolerance_before).format('HH:mm');
                vm.pickRange3ToShowAddReturn = moment(vm.bookingDetails.time_with_tolerance_after).format('HH:mm');
           
            }


        }
        //function calculateEstimateDropOffTime(eta){
        //    //console.log(eta,vm.dataToFill.selectedServiceDetails);
        //    var etaSeconds = Math.round(eta/60) * 60;
        //    var tolerance = vm.dataToFill.selectedServiceDetails.tolerance * 60;
        //    var dropDateTimeNewFormat = dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime);
        //    var pickRange2 = moment(dropDateTimeNewFormat).subtract(etaSeconds, 'seconds');
        //    var pickRange1 = moment(pickRange2).subtract(tolerance, 'seconds');
        //    vm.pickRange1 = moment(pickRange1).format('HH:mm');
        //    vm.pickRange2 = moment(pickRange2).format('HH:mm');
        //    //console.log(vm.pickRange1);
        //    //console.log(vm.pickRange2);
        //}
        function pickupFromToTimeChanged() {
            // compareDates();
            if (vm.type_of_trip1 != 'P' && vm.flagForFlightDate == true) {
                compareDates();
            }
        }

        function dateTimeFormat(dateGot, timeGot) {
            var dateToChange = dateGot;
            dateToChange.setHours(0);
            dateToChange.setMinutes(0);
            dateToChange.setSeconds(0);
            dateToChange.setHours(timeGot.getHours());
            dateToChange.setMinutes(timeGot.getMinutes());
            dateToChange.setSeconds(0);
            if (dateToChange != 'Invalid Date' && timeGot != '00:00:00')
                return new Date(dateToChange);
        };


        //=======================get previous address hit=======================
        $document.on('click', function (e) {
            //console.log('ddddd', e);
            //console.log('ddddd', e.toElement.id);
            if ( e.target && e.target.id != 'pickUpAddress' && e.target.id != 'dropOffAddress') {
                vm.dataToFill.previousPickFlag = false;
                vm.dataToFill.previousDropFlag = false;
                if(!$scope.$$phase) {
                    $scope.$apply();
                }
            }
        });

        //console.log($document);

        function getPreviousAddressHit(type) {
            vm.modifyFalgNew = false;
            if (!vm.dataToFill.customerId && !vm.newCustomerFlag) {
                languageBasedErrorFactory.getProperErrorMessage('selectCustomerf', 0, 0);
                //errorMessageFactory.showErrorMessage('Please fill customer details first',0);
                return;
            }
            if (vm.newCustomerFlag) {
                vm.previousAddressList = [];
                return;
            }
            if (type == 1) {
                vm.dataToFill.previousPickFlag = true;
                vm.dataToFill.previousDropFlag = false;
            } else if (type == 2) {
                vm.dataToFill.previousDropFlag = true;
                vm.dataToFill.previousPickFlag = false;
            }
            // if (vm.dataToFill.previousCustomerId == vm.dataToFill.customerId && !vm.newCustomerFlag) {
            //     return;
            // } // 3975 ticket
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.customer_id = vm.dataToFill.customerId;
            dataSend.address_type = type == 1 ? 0 : 1; // 3975 ticket
            //dataSend.contract_id = vm.dataToFill.customerContarctId;
            vm.loading = true;
            var promise = getBookings.getPreviousAddress(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.data.addresses) {
                        if (type == 1) {
                            vm.dataToFill.previousPickFlag = true;
                            vm.dataToFill.previousDropFlag = false;
                        } else if (type == 2) {
                            vm.dataToFill.previousDropFlag = true;
                            vm.dataToFill.previousPickFlag = false;
                        }
                        vm.previousAddressList = payload.title.data.addresses;
                    } else {
                        vm.previousAddressList = [];
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        vm.onclickErrorPickDrop = errorPayload.data.message;
                        //errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };

        //=======================select previous address=========================
        function selectPreviousAddress(data, type) {
            //console.log(data);
            if (type == 1) {
                vm.addressChange = true;
                vm.getFixedRoutesForPersonalFlag = true;
                vm.dataToFill.previousPickFlag = false;
                vm.dataToFill.pickUpAddress = data.address;
                vm.dataToFill.pickUpLat = data.latitude;
                vm.dataToFill.pickUpLng = data.longitude;
                vm.dataToFill.pickLat = data.latitude;
                vm.dataToFill.pickLng = data.longitude;
                vm.jobPickupComuna = data.communa || null;
                // var location = new google.maps.LatLng(Number(data.latitude), Number(data.longitude));
                vm.pickaddressChange = true;
                getFavoriteAddress('pick');
                if (vm.dataToFill.serviceTypeSelected) { //&& (vm.dataToFill.bookingType == '0' || vm.dataToFill.bookingType == 0)
                    vm.dataToFill.nearDriver = '';
                    toGetAirportService(vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.serviceTypeSelected, map);
                    //toGetNearByDrivers(vm.dataToFill.pickUpLat,vm.dataToFill.pickUpLng,vm.dataToFill.serviceTypeSelected,map);
                }
                if (vm.toAirportFlag) {
                    getAirportAddressApi();
                }
                if (vm.ptopAirportFlag && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                    getFixedRoutesForPersonal(vm.dataToFill);
                }
                // $timeout(function () {
                //     placeMarker(map, location, 'pick');
                // }, 2000);
            } else if (type == 2) {
                vm.dataToFill.previousDropFlag = false;
                vm.addressChange = true;
                vm.getFixedRoutesForPersonalFlag = true;
                vm.dataToFill.dropOffAddress = data.address;
                vm.dataToFill.dropOffLat = data.latitude;
                vm.dataToFill.dropOffLng = data.longitude;
                vm.dataToFill.dropLat = data.latitude;
                vm.dataToFill.dropLng = data.longitude;
                vm.dropaddressChange = true;
                vm.jobDropoffComuna = data.communa || null;
                getFavoriteAddress('drop');
                // var locationD = new google.maps.LatLng(Number(data.latitude), Number(data.longitude));
                if (vm.fromAirportFlag) {
                    getAirportAddressApi();
                }
                if (vm.ptopAirportFlag && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                    getFixedRoutesForPersonal(vm.dataToFill);
                }
                // $timeout(function () {
                //     placeMarker(map, locationD, 'drop');
                // }, 2000)
            }
        };
        $scope.$watchCollection('vm.pickRangeForRouting', function (newValue, oldValue) {
            //console.log('being watched oldValue:', oldValue, 'newValue:', newValue);
            getFixedRoutesForPersonal(vm.dataToFill);
        }, true);

        //===================to get airport service==================
        $scope.$watchCollection('vm.dataToFill.selectedServiceDetails', function (newValue, oldValue) {
            //console.log('being watched oldValue:', oldValue, 'newValue:', newValue);
            if (oldValue) {
                vm.dataToFill.viaControlledReal = vm.dataToFill.controlledWayCheck && vm.dataToFill.viaControlledApply ? newValue.controlled_way : 0;
                if (newValue.fare_type == 1) {
                    vm.dataToFill.viaControlled = Number(vm.dataToFill.viaControlledReal) * Number(vm.dataToFill.passengerCount);
                } else {
                    vm.dataToFill.viaControlled = Number(vm.dataToFill.viaControlledReal);
                }
            }
        }, true);
        $scope.$watchCollection('vm.dataToFill.controlledWayCheck', function (newValue, oldValue) {
            //console.log('being watched oldValue:', oldValue, 'newValue:', newValue);
            vm.dataToFill.viaControlledReal = newValue && vm.dataToFill.viaControlledApply ? vm.dataToFill.selectedServiceDetails.controlled_way : 0;
            if (vm.dataToFill.selectedServiceDetails.fare_type == 1) {
                vm.dataToFill.viaControlled = Number(vm.dataToFill.viaControlledReal) * Number(vm.dataToFill.passengerCount);
            } else {
                vm.dataToFill.viaControlled = Number(vm.dataToFill.viaControlledReal);
            }
        }, true);
        $scope.$watchCollection('vm.dataToFill.viaControlledApply', function (newValue, oldValue) {
            //console.log('being watched oldValue:', oldValue, 'newValue:', newValue);
            vm.dataToFill.viaControlledReal = vm.dataToFill.controlledWayCheck && newValue ? vm.dataToFill.selectedServiceDetails.controlled_way : 0;
            if (vm.dataToFill.selectedServiceDetails.fare_type == 1) {
                vm.dataToFill.viaControlled = Number(vm.dataToFill.viaControlledReal) * Number(vm.dataToFill.passengerCount);
            } else {
                vm.dataToFill.viaControlled = Number(vm.dataToFill.viaControlledReal);
            }
        }, true);

        function toGetAirportService(lat, lng, service, map) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.latitude = lat;
            dataSend.longitude = lng;
            dataSend.service_id = service;
            vm.loading = true;
            var promise = getBookings.getAirportZone(dataSend);
            promise.then(
                function (payload) {

                    $log.log(payload);
                    vm.loading = false;
                    //console.log(payload, "airportzone");

                    vm.dataToFill.airportCheck = payload.title.data.type_of_trip;
                    if (payload.title.data.time_trip_shared_service) {
                        vm.dataToFill.time_trip_shared_service = payload.title.data.time_trip_shared_service;
                    } else vm.dataToFill.time_trip_shared_service = 0;

                    if (payload.title.data.type_of_trip == 'Z') {
                        vm.dataToFill.viaControlledApply = true;
                    } else vm.dataToFill.viaControlledApply = false;

                    if (markers.length) {
                        for (var i = 0; i < markers.length; i++) {
                            if (markers[i].id == 'driver') {
                                setMapOnAll(null, 'driver');
                            }
                        }
                    }
                    if (vm.dataToFill.airportCheck != 'Z' && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2)) {
                        toGetNearByDrivers(vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.serviceTypeSelected, map);
                    } else {
                        vm.dataToFill.viaControlledReal = vm.dataToFill.controlledWayCheck && vm.dataToFill.viaControlledApply ? vm.dataToFill.selectedServiceDetails.controlled_way : 0;
                        if (vm.dataToFill.selectedServiceDetails.fare_type == 1) {
                            vm.dataToFill.viaControlled = Number(vm.dataToFill.viaControlledReal) * Number(vm.dataToFill.passengerCount);
                        } else {
                            vm.dataToFill.viaControlled = Number(vm.dataToFill.viaControlledReal);
                        }
                    }

                    //console.log('ddssds', vm.dataToFill.viaControlled, vm.dataToFill.airportCheck);
                },
                function (errorPayload) {
                    vm.loading = false;

                    if (errorPayload.data.status == 400) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                    if (markers.length) {
                        for (var i = 0; i < markers.length; i++) {
                            if (markers[i].id == 'driver') {
                                setMapOnAll(null, 'driver');
                            }
                        }
                    }
                    $log.log(errorPayload);
                }
            );
        }

        //============================get near by drivers=========================
        function toGetNearByDrivers(lat, lng, service, map) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.currLat = lat;
            dataSend.currLong = lng;
            dataSend.service_type = service;
            vm.loading = true;
            var promise = getBookings.getNearDriver(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (markers.length) {
                        for (var i = 0; i < markers.length; i++) {
                            if (markers[i].id == 'driver') {
                                setMapOnAll(null, 'driver');
                            }
                        }
                    }
                    if (payload.title.data.SelecteddriversList && payload.title.data.SelecteddriversList.length) {
                        vm.nearByDriver = payload.title.data.SelecteddriversList;
                        if (vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                            calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, map);
                            getFixedRoutesForPersonal(vm.dataToFill);
                        }
                        for (var i = 0; i < payload.title.data.SelecteddriversList.length; i++) {
                            location = new google.maps.LatLng(Number(payload.title.data.SelecteddriversList[i].latitude), Number(payload.title.data.SelecteddriversList[i].longitude));
                            placeMarker(map, location, 'driver', payload.title.data.SelecteddriversList[i]);
                        }
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (markers.length) {
                        for (var i = 0; i < markers.length; i++) {
                            if (markers[i].id == 'driver') {
                                setMapOnAll(null, 'driver');
                            }
                        }
                    }
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        //errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        }
        //===================remove selected address========================
        function removeSelectedDriver() {
            vm.dataToFill.nearDriver = '';
        }

        //======================selecting item of charges=====================
        function selectingItemOfCharges(index, type) {
            vm.dataToFill.estimatedFare = 0;
            vm.dataToFill.estimatedFareVariableReturn = 0;
            vm.click = false; 
            vm.dataToFill.estimatedFareVariable = vm.dataToFill.selectedServiceDetails.fare_type ? (Number(vm.dataToFill.onlyPrice) * Number(vm.dataToFill.passengerCount)) +  vm.estimated_toll_price : Number(vm.dataToFill.estimatedFareRoute);
            vm.dataToFill.estimatedFareVariableReturn = vm.dataToFill.selectedServiceDetails.fare_type ? Number(vm.dataToFill.Return_policy.estimatedFareRoute) * Number(vm.dataToFill.passengerCount) : Number(vm.dataToFill.Return_policy.estimatedFareRoute);

            if (type == 'select') {
                for (var i = 0; i < index.length; i++) {
                    if( index[i].retorno == false ){
                        vm.dataToFill.estimatedFareVariable = vm.dataToFill.estimatedFareVariable + Number(index[i].price);
                    } else if( index[i].retorno == true ){
                        vm.dataToFill.estimatedFareVariableReturn = vm.dataToFill.estimatedFareVariableReturn + Number(index[i].price);
                    }
                }
            } else if (type == 'remove') {
                for (var i = 0; i < index.length; i++) {
                    if( index[i].retorno == false ){
                        vm.dataToFill.estimatedFareVariable = vm.dataToFill.estimatedFareVariable + Number(index[i].price);
                    } else if( index[i].retorno == true ){
                        vm.dataToFill.estimatedFareVariableReturn = vm.dataToFill.estimatedFareVariableReturn + Number(index[i].price);
                    }
                }
            } else {
                for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                    if( vm.dataToFill.itemOfChargeSelected[i].retorno == false ){
                        vm.dataToFill.estimatedFareVariable = vm.dataToFill.estimatedFareVariable + Number(vm.dataToFill.itemOfChargeSelected[i].price);
                    } else if( vm.dataToFill.itemOfChargeSelected[i].retorno == true ){
                        vm.dataToFill.estimatedFareVariableReturn = vm.dataToFill.estimatedFareVariableReturn + Number(vm.dataToFill.itemOfChargeSelected[i].price);
                    }
                }
            }
            // console.log('>>>>> IN SELECT >>>>>>>>', vm.calculatedEstimatePriceFormFunctionEstimated, vm.dataToFill.estimatedFare)
            // if (vm.dataToFill.minimumFare) {
            vm.dataToFill.estimatedFare = vm.dataToFill.estimatedFareVariable < vm.dataToFill.minimumFare ? vm.dataToFill.minimumFare : vm.dataToFill.estimatedFareVariable;
            // } else {
            vm.dataToFill.estimatedFare = vm.dataToFill.estimatedFareVariable;

            if (vm.dataToFill.estimatedFareVariableReturn) {
                vm.dataToFill.Return_policy.estimatedFare = vm.dataToFill.estimatedFareVariableReturn;
            }

            // ********* VARIABLES ARE INITIALIZE TO AGAIN SET INPUT FIELD VARIABLE ********
            vm.calculatedEstimatePriceFormFunctionEstimated = -1;
            vm.finalAdjustedPriceFromAdmin = 0;
            vm.calculatedEstimatePriceForFixedPriceFormFunction = 0;
            vm.calculatedEstimatePriceForRoundTripFormFunction = 0;
            vm.click = false;

            // ******* WHEN ADJUSTED PRICE IS REMOVED WE hAVE TO SHOW OLDER DISCOUND OF ROUND TRIP ******
            vm.dataToFill.discounts = [];
            // test issue due to round trip disocunt
            var discountNew = 0;
            // = ((vm.dataToFill.roundTrip || (vm.bookingDetails && vm.bookingDetails.round_trip_parent_job_id > 0)) ? vm.dataToFill.roundTripDiscount : vm.bookingDetails.discount_amount);
            if ((vm.dataToFill.roundTrip || (vm.bookingDetails && vm.bookingDetails.round_trip_parent_job_id > 0))) {
                discountNew = vm.dataToFill.roundTripDiscount;
            }
            else if (vm.bookingDetails && vm.bookingDetails.discount_amount) {
                discountNew = vm.bookingDetails.discount_amount;
            }
            if (vm.dataToFill.roundTrip == true) {
                name = 'ROUND TRIP'
            }
            // test issue due to round trip disocunt
            var name = vm.bookingDetails.promo_type == '0' ? vm.bookingDetails.promo_id : vm.bookingDetails.promo_type == '1' ? 'ROUND TRIP' : vm.bookingDetails.promo_type == '2' ? 'Web Discount' : vm.bookingDetails.promo_type == '3' ? 'Bin' : 'NA';
            var discountType = vm.bookingDetails.discount_type;
            if(discountNew > 0){
            vm.dataToFill.discounts.push({
                // estimatedFare: Math.round(Number(vm.dataToFill.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled1))),
                estimatedFare: viaControlledPrice(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking),
                // roundTripFare: Math.round(Number(vm.dataToFill.Return_policy.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled2))),
                roundTripFare: viaControlledPrice(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip),
                name: name,
                discountType: discountType,
                // Change by nakul sir
                discountTypeValue: ((vm.dataToFill.roundTrip || (vm.bookingDetails && vm.bookingDetails.round_trip_parent_job_id > 0)) ? vm.dataToFill.roundTripDiscount : discountNew),
                // discountTypeValue: vm.dataToFill.roundTripDiscount,
                // value: ((Number(vm.estimatedFareDiscount) * Number(vm.dataToFill.roundTripDiscount)) / 100),
                value: discountType ? calculateDiscountPercentageAmount(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, discountNew, 'parent') : calculateDiscountFlatAmount(discountNew),
                // returnValue: ((vm.estimatedFareDiscountRound * Number(vm.dataToFill.roundTripDiscount)) / 100),
                returnValue: calculateDiscountPercentageAmount(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, discountNew, 'parent'),
                // finalAmount: Math.round((vm.estimatedFareDiscount - vm.estimatedFareDiscount * Number(vm.dataToFill.roundTripDiscount) / 100) + (vm.type_of_trip_Validate_Booking == 'Z' ? (Number(vm.viaControlled1)) : 0)),
                finalAmount: discountType ? calculateDiscountPercentage(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, discountNew, vm.tope_maximo, 'parent') : calculateDiscountFlat(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, discountNew, 'parent'),
                // roundFinalAmount: Math.round((vm.estimatedFareDiscountRound - (vm.estimatedFareDiscountRound) * Number(vm.dataToFill.roundTripDiscount) / 100) + (vm.type_of_trip == 'Z' ? (Number(vm.viaControlled2)) : 0))
                roundFinalAmount: vm.dataToFill.roundTrip == true ? (vm.bookingDetails.discount_type ? calculateDiscountPercentage(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, discountNew, vm.tope_maximo) :  calculateDiscountFlat(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, vm.bookingDetails.discount_amount)) : 0

            })
            if( vm.tope_maximo ){
                vm.dataToFill.discounts[0].tope_maximo = vm.tope_maximo;
            }
            }
            // console.log('>>>>> DISCOUNT >>>>>>>>>>>', vm.dataToFill.discounts);
            vm.dataToFill.discounts.forEach(function (data) {
                data.finalAmount = data.finalAmount < 0 ? 0 : data.finalAmount;
            })
            vm.dataToFill.discounts = vm.dataToFill.discounts.sort(function (a, b) {
                return b.value - a.value
            })
            console.log(vm.dataToFill.discounts, 'vm.dataToFill.discountsafter');

            // vm.calculatedEstimatePriceFormFunctionEstimated += vm.dataToFill.estimatedFare;
            // }
        }

        // //==============get all corporate=================
        // function getAllCorporate() {
        //     vm.loading = true;
        //     var dataSend = {};
        //     dataSend.access_token = $cookies.get('obj');
        //     dataSend.limit = 0;
        //     dataSend.offset = 0;
        //     dataSend.key = 2;
        //     dataSend.search_filter = 0;
        //     var promise = getCorporate.allCorporates(dataSend);
        //     promise.then(
        //         function (payload) {
        //             $log.log('sxdsads', payload);
        //             vm.loading = false;
        //             vm.corporatesList = [];
        //             vm.corporatesList = payload.title.data.result;
        //             vm.corporatesList.push({
        //                 id: 'all',
        //                 company_name: 'Todos'
        //             });
        //         },
        //         function (errorPayload) {
        //             vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // };
        // getAllCorporate();

        // //======================get all agreements==============
        // function getAllAgreement() {
        //     var dataSend = {};
        //     dataSend.access_token = $cookies.get('obj');
        //     vm.loading = true;
        //     var promise = getAgreement.getAgreementListLessData(dataSend);
        //     promise.then(
        //         function (payload) {
        //             $log.log('sxdsads', payload);
        //             vm.loading = false;
        //             if (payload.title.status == 400) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //             } else if (payload.title.status == 401) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //             } else if (payload.title.status == 201 || payload.title.status == 200) {
        //                 vm.agreement = [];
        //                 //vm.tableAgreement = [];
        //                 for (var i = 0; i < payload.title.data.length; i++) {
        //                     if (payload.title.data[i].agreement_type == 'CORPORATE' && payload.title.data[i].status == 1) {
        //                         vm.agreement.push({
        //                             name: payload.title.data[i].name,
        //                             id: payload.title.data[i].id
        //                         });

        //                     }

        //                     //if(payload.title.data.contracts[i].employee_endowment == 1){
        //                     //    payload.title.data.contracts[i].color = 'lightgrey';
        //                     //}
        //                     //else{
        //                     //    payload.title.data.contracts[i].color = 'white';
        //                     //}
        //                 }
        //                 vm.agreement.push({
        //                     id: 'all',
        //                     name: 'Todos'
        //                 });
        //             }
        //             //vm.tableAgreement = _.where(payload.title.data,{agreement_type:'CORPORATE'});
        //         },
        //         function (errorPayload) {
        //             $log.log(errorPayload);
        //             vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // };
        // getAllAgreement();

        //========================open endowment pop p======================
        function addEndowment($event) {
            vm.items = {
                agreement: vm.agreement,
                tableAgreement: [],
                corporatesList: vm.corporatesList,
                rutFilter: '',
                agreementSelected: 'all',
                corporateSelected: 'all',
                finalAgreement: '',
                errorMsg: false,
                rutInvalid: false,
                loading: false,
                agreementToSend: [],
                limit: 10,
                offset: 0,
                totalCount: 0,
                backgroundColor: 'grey',
                internetFlag: true
            }

            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/addEndowmentOfNewCustomer.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: AddEndowmentController
            });

            function AddEndowmentController($scope, $mdDialog, items) {
                $scope.items = items;
                var dataGet = [];
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                // INTERNET ISSUE TIKCET 4187
                window.addEventListener('online', function (event) {
                    $scope.items.internetFlag = true;
                });
                window.addEventListener('offline', function (event) {
                    $scope.items.internetFlag = false;
                });
                // =================== GET FILTER DATA ===================
                function getFilterDataFromBackend(data, type) {
                    if (data) {
                        vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                        vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
                    } else {
                        vm.filterObject = {
                            access_token: $cookies.get('obj'),
                            branch_filter: 0,
                            vehicle_filter: 0,
                            service_filter: 0,
                            agreement_filter: 1,
                            corporate_filter: 1,
                            service_category: 0,
                            corporate_status: 2,
                            agreement_status: 1,
                            vehicle__status: 0,
                            operation_point_filter: 0,
                            branch_search_filter: 0,
                            vehicle_search_filter: 0,
                            service_search_filter: 0,
                            agreement_search_filter: 0,
                            corporate_search_filter: 0,
                            operation_point_search_filter: 0,
                            agreement_type: 'CORPORATE'
                        }
                    }
                    vm.filterObject.agreement_limit = vm.globalLimit;
                    vm.filterObject.agreement_offset = vm.agreementOffset;
                    vm.filterObject.corporate_limit = vm.globalLimit;
                    vm.filterObject.corporate_offset = vm.corporateOffset;
                    $scope.agreementShowArray;
                    $scope.coprateListShow;
                    var promise = getFilters.getAllFilterData(vm.filterObject);
                    promise.then(
                        function (payload) {

                            // ********** Agrrement DATA ********
                            if (payload.title.data.agreements) {
                                var index = _.findIndex(vm.agreement, {
                                    id: 'all'
                                });
                                if (index == -1)
                                    vm.agreement.push({
                                        name: 'Todos',
                                        id: 'all'
                                    });
                                angular.forEach(payload.title.data.agreements.data, function (column) {
                                    // vm.corporatesList.push(column)
                                    var agreement = _.findIndex(vm.agreement, {
                                        id: column.id
                                    });
                                    if (agreement == -1)
                                        vm.agreement.push(column)

                                });
                                vm.agreementTotalBackendCount = payload.title.data.agreements.totalCount;
                                $scope.agreementShowArray = vm.agreement;
                            }
                            // ********** CORPORATE DATA ********
                            if (payload.title.data.corporates) {
                                var index = _.findIndex(vm.corporatesList, {
                                    id: 'all'
                                });
                                if (index == -1)
                                    vm.corporatesList.push({
                                        company_name: 'Todos',
                                        id: 'all'
                                    });
                                angular.forEach(payload.title.data.corporates.data, function (column) {
                                    // vm.corporatesList.push(column)
                                    var corprateIndex = _.findIndex(vm.corporatesList, {
                                        id: column.id
                                    });
                                    if (corprateIndex == -1)
                                        vm.corporatesList.push(column)

                                });
                                console.log(vm.corporatesList.length, 'vm.corporatesList');
                                $scope.coprateListShow = vm.corporatesList;
                                vm.corporateTotalBackendCount = payload.title.data.corporates.totalCount;
                            }
                            $timeout(function () {
                                $scope.$apply();
                            })
                            vm.loading = false;
                        },
                        function (errorPayload) {
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        });
                }

                $scope.corporate = function (data) {
                    setTimeout(function () {
                        // document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                        //     // if (vm.branchList && (vm.branchList.length == 0)) {
                        //     vm.searchCorporateData = '';
                        //     vm.agreementOffset = 0;
                        //     vm.agreement = [];
                        //     getFilterDataFromBackend(0, 0);
                        // });

                        document.getElementsByClassName('ui-select-search')[1].addEventListener('blur', function ($event) {
                            // if (vm.corporatesList && (vm.corporatesList.length == 0)) {
                            vm.searchCorporateData = '';
                            vm.corporatesList = [];
                            vm.corporateOffset = 0;
                            getFilterDataFromBackend(0, 0);
                            // }
                        });
                    })
                }
                $scope.aggrementchange = function () {
                    setTimeout(function () {
                        document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                            // if (vm.branchList && (vm.branchList.length == 0)) {
                            vm.searchCorporateData = '';
                            vm.agreementOffset = 0;
                            vm.agreement = [];
                            getFilterDataFromBackend(0, 0);
                        });

                        // document.getElementsByClassName('ui-select-search')[1].addEventListener('blur', function ($event) {
                        //     // if (vm.corporatesList && (vm.corporatesList.length == 0)) {
                        //     vm.searchCorporateData = '';
                        //     vm.corporatesList = [];
                        //     vm.corporateOffset = 0;
                        //     getFilterDataFromBackend(0, 0);
                        //     // }
                        // });
                    })
                }
                // *********** COMMON FUNCTION FOR FILTER PAGINATION AND SEARCHING ***********
                function commonFunction(type, mode) {

                    for (var i = 0; i < vm.searchFilterArray.length; i++) {
                        console.log("searching ..........");

                        if (mode == 'search' || i != type) {
                            vm[vm.searchFilterArrayForClearArray[i]] = [];
                            // vm[vm.searchFilterArrayForClearArray[i]].push({
                            //     id: 'all',
                            //     name: 'Todos'
                            // });
                            vm[vm.searchFilterArray[i] + 'Offset'] = 0;
                            vm['search' + vm.searchFilterArray[i].substring(0, 1).toUpperCase() + vm.searchFilterArray[i].substring(1) + 'Data'] = '';
                        }
                    }
                }
                getFilterDataFromBackend(0, 0);
                setTimeout(function () {
                    document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                        // if (vm.branchList && (vm.branchList.length == 0)) {
                        vm.searchCorporateData = '';
                        vm.agreementOffset = 0;
                        vm.agreement = [];
                        getFilterDataFromBackend(0, 0);
                    });

                    document.getElementsByClassName('ui-select-search')[1].addEventListener('blur', function ($event) {
                        // if (vm.corporatesList && (vm.corporatesList.length == 0)) {
                        vm.searchCorporateData = '';
                        vm.corporatesList = [];
                        vm.corporateOffset = 0;
                        getFilterDataFromBackend(0, 0);
                        // }
                    });
                })
                // ************ PAGINATION ON CORPORATE **************
                $scope.paginationChangedForCorporation = function () {
                    var index = _.findIndex(vm[vm.searchFilterArray[5]], {
                        id: 'all'
                    });
                    index = (index == -1 ? 0 : 1);
                    if (vm.corporateTotalBackendCount > (vm.corporatesList.length - index)) {
                        commonFunction(4);
                        vm.corporateOffset += vm.globalOffset;
                        getFilterDataFromBackend(vm.searchCorporateData, 4);
                    }
                }

                // ************ PAGINATION ON AGREEMENT **************
                $scope.paginationChangedForAgreement = function () {
                    var index = _.findIndex(vm[vm.searchFilterArray[3]], {
                        id: 'all'
                    });
                    index = (index == -1 ? 0 : 1);
                    if (vm.agreementTotalBackendCount > (vm.agreement.length - index)) {
                        commonFunction(3);
                        vm.agreementOffset += vm.globalOffset;
                        getFilterDataFromBackend(vm.searchAgreementData, 3);
                    }
                }

                // ************ SEARCH SERVICE ***************
                $scope.corporateSearch = function (data, event) {
                    if (event.keyCode != 40 && event.keyCode != 38) {
                        vm.searchCorporateData = data;
                        $timeout.cancel($scope.timeoutSearch);
                        commonFunction(4, 'search');
                        $scope.timeoutSearch = $timeout(function () {
                            getFilterDataFromBackend(data, 4);
                        }, 2000);
                    }
                }

                // ************ SEARCH AGREEMENT ***************
                $scope.agreementSearch = function (data, event) {
                    if (event.keyCode != 40 && event.keyCode != 38) {
                        vm.searchAgreementData = data;
                        $timeout.cancel($scope.timeoutSearch);
                        commonFunction(3, 'search');
                        $scope.timeoutSearch = $timeout(function () {
                            getFilterDataFromBackend(data, 3);
                        }, 2000);
                    }
                }
                $scope.confirmUpload = function () {
                    if (!$scope.items.internetFlag) {
                        return;
                    }
                    if ($scope.items.agreementToSend.length == 0) {
                        $scope.items.errorMsg = true;
                        $timeout(function () {
                            $scope.items.errorMsg = false;
                        }, 2000);
                    } else {
                        $mdDialog.hide();
                        makeNewAgreementInList($scope.items.agreementToSend);
                    }

                };
                $scope.selectParticularEndowment = function (index) {
                    $scope.items.agreementToSend = $scope.items.tableAgreement[index];
                }
                $scope.rutChange = function () {
                    if ($scope.items.rutFilter) {
                        if (RutHelper.validate($scope.items.rutFilter)) {
                            $log.log();
                            $scope.items.rutInvalid = false;
                        } else {
                            $scope.items.rutInvalid = true;
                        }
                    } else if ($scope.items.rutFilter === null) {
                        $scope.items.rutInvalid = true;
                    } else if ($scope.items.rutFilter === undefined) {
                        $scope.items.rutInvalid = false;
                    }
                }

                $scope.paginationChanged = function () {
                    if ($scope.items.totalCount != $scope.items.tableAgreement.length) {
                        $scope.items.offset = $scope.items.offset + $scope.items.limit;
                        $scope.getFilterDataForEndowment();
                    }
                }

                $scope.getFilterChange = function () {
                    $scope.items.tableAgreement = [];
                    dataGet = [];
                    $scope.items.offset = 0;
                    $scope.items.limit = 10;
                }

                $scope.getFilterDataForEndowment = function () {
                    if ($scope.items.rutInvalid) {
                        return;
                    }
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.limit = $scope.items.limit;
                    dataSend.offset = $scope.items.offset;
                    if ($scope.items.agreementSelected && $scope.items.agreementSelected != 'all') {
                        dataSend.agreement_id = Number($scope.items.agreementSelected);
                        $scope.items.tableAgreement = [];
                        dataGet = [];
                    }
                    if ($scope.items.corporateSelected && $scope.items.corporateSelected != 'all') {
                        dataSend.corporate_id = Number($scope.items.corporateSelected);
                        $scope.items.tableAgreement = [];
                        dataGet = [];
                    }

                    if ($scope.items.rutFilter) {
                        dataSend.corporate_rut = RutHelper.clean($scope.items.rutFilter);
                        $scope.items.tableAgreement = [];
                        dataGet = [];
                    }
                    //console.log(dataSend);
                    $scope.items.loading = true;
                    var promise = getAgreement.getAgreementListLessDataWithFilters(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            $scope.items.loading = false;
                            for (var i = 0; i < payload.title.data.contracts.result.length; i++) {
                                payload.title.data.contracts.result[i].selected = false;
                                if (payload.title.data.contracts.result[i].employee_endowment == 1) {
                                    payload.title.data.contracts.result[i].color = 'lightgrey';
                                } else {
                                    payload.title.data.contracts.result[i].color = 'white';
                                }
                                dataGet.push(payload.title.data.contracts.result[i]);
                            }
                            $scope.items.totalCount = payload.title.data.contracts.totalCount;
                            $scope.items.tableAgreement = _.where(dataGet, {
                                agreement_type: 'CORPORATE'
                            });
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            $scope.items.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }
                $scope.getFilterDataForEndowment();
            }
        }

        //==========================make new agreement in new list======================
        function makeNewAgreementInList(data) {
            //console.log(data);
            vm.dataToFill.contractIdSelected = data.contract_id;
            var where = _.where(vm.dataToFill.contractListShowing, {
                id: data.contract_id
            });
            var a = '';
            for (var i = 0; i < vm.dataToFill.contractListShowing.length; i++) {
                if (vm.dataToFill.contractListShowing[i].name.indexOf("*") > -1) {
                    a = i;
                    vm.dataToFill.contractListShowing.splice(a, 1);
                }
            }
            agreementTypeChanged();
            if (where.length) {
                return;
            } else {
                vm.dataToFill.contractListShowing.push({
                    name: data.name + '*',
                    id: data.contract_id
                });
            }
        }

        //======================create booking by pass because of new customer register===========================
        function createBookingByPass($event, reaccurringKey, createBookingKey) {
            vm.disableSubmitButton = false;
            get_cuota();
            console.log(vm.dataToFill, $event, 'Puuneeet i m here');
            if (vm.bookingDetails && vm.bookingDetails.sin_respaldo == 0)
                checkAndMakeBookingData($event, reaccurringKey, createBookingKey);
            else if (!vm.bookingDetails)
                checkAndMakeBookingData($event, reaccurringKey, createBookingKey);
            // else editBookingApi($event);
            //if(vm.dataToFill.first_name && (vm.dataToFill.customerProfile == '1' || vm.dataToFill.customerProfile == 1)){
            //    createEmployeeNew($event);
            //}
            //else if(vm.dataToFill.first_name && (vm.dataToFill.customerProfile == '0' || vm.dataToFill.customerProfile == 0)){
            //    createCustomerNew($event);
            //}
            //else {
            //    checkAndMakeBookingData($event);
            //}

        };

        function createEmployeeNew($event, arrayFDatesMade) {
            // if($event.validate == undefined){
            //     return true;
            // }
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('newUserPop1', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('cancelButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.contract_id = vm.dataToFill.contractIdSelected;
                dataSend.corporate_id = vm.dataToFill.corporate_account_id;
                dataSend.domainUrl = checkDomain.getDomainName();
                dataSend.employee_list = {
                    name: vm.dataToFill.first_name ? vm.dataToFill.first_name : vm.dataToFill.customerMobile.first_name,
                    last_name: vm.dataToFill.last_name ? vm.dataToFill.last_name : vm.dataToFill.customerMobile.last_name,
                    cost_center: vm.dataToFill.costCenter ? vm.dataToFill.costCenter : '',
                    cost_subcenter: vm.dataToFill.costSubCenter ? vm.dataToFill.costSubCenter : '',
                    ROI: vm.dataToFill.Rol ? vm.dataToFill.Rol : '',
                    graph: vm.dataToFill.graph ? vm.dataToFill.graph : '',
                    order_of_work: vm.dataToFill.workOrder ? vm.dataToFill.workOrder : '',
                    PEP: vm.dataToFill.pep ? vm.dataToFill.pep : '',
                    email: vm.dataToFill.customerEmail,
                    phone_number: vm.dataToFill.customerMobileG,
                    //password:  vm.dataToFill.password?vm.dataToFill.password:'',
                    country_code: vm.dataToFill.country_code
                };

                //console.log(dataSend);
                vm.loading = true;
                var promise = getAgreement.manageEmployeesFromCreateBooking(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        languageBasedErrorFactory.getProperErrorMessage('userRegSucc1', 0, 0)
                        //errorMessageFactory.showErrorMessage('User registered successfully',0);
                        $timeout(function () {
                            $mdDialog.hide();
                            if (vm.dataToFill.nearDriver && vm.flagForEditBooking == false) {
                                //checkBeforeAssignDriver($event,arrayFDatesMade);
                                createBookingApi($event, arrayFDatesMade);
                            } else if (vm.flagForEditBooking == false) {
                                createBookingApi($event, arrayFDatesMade);
                            } else if (vm.flagForEditBooking = true) {
                                editBookingApi($event, arrayFDatesMade);
                            }
                        }, 1500);
                        //$state.reload();
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        vm.disableSubmitButton = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        }

        function createCustomerNew($event, arrayFDatesMade) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('newUserPop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('cancelButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                var dataSend = new FormData();
                var domain = checkDomain.getDomainName();
                dataSend.append('access_token', $cookies.get('obj'));
                dataSend.append('first_name', vm.dataToFill.first_name);
                dataSend.append('last_name', vm.dataToFill.last_name);
                dataSend.append('email', vm.dataToFill.customerEmail);
                dataSend.append('country_code', vm.dataToFill.country_code);
                dataSend.append('phone_number', vm.dataToFill.customerMobileG);
                //dataSend.append('password',vm.dataToFill.password);
                dataSend.append('timezone', vm.dataToFill.timeZone);
                dataSend.append('domainUrl', domain);
                //console.log(dataSend);
                vm.loading = true;
                var promise = getCustomers.addCustomer(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        if (payload.title.status == 400) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            languageBasedErrorFactory.getProperErrorMessage('userRegSucc', 0, 0)
                            //errorMessageFactory.showErrorMessage('User registered successfully',0);
                            $timeout(function () {
                                $mdDialog.hide();
                                if (vm.dataToFill.nearDriver) {
                                    //checkBeforeAssignDriver($event,arrayFDatesMade);
                                    createBookingApi($event, arrayFDatesMade);
                                } else {
                                    createBookingApi($event, arrayFDatesMade);
                                }
                            }, 1500);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        vm.disableSubmitButton = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        }

        //===========================check before assigning driver=====================
        //function checkBeforeAssignDriver($event,arrayFDatesMade){
        //    var dataSend = {
        //        access_token: $cookies.get('obj'),
        //        pickup_lat : vm.dataToFill.pickUpLat,
        //        pickup_long : vm.dataToFill.pickUpLng,
        //        drop_lat : vm.dataToFill.dropOffLat,
        //        drop_long : vm.dataToFill.dropOffLng,
        //        fleet_id : vm.dataToFill.nearDriver
        //    };
        //    vm.loading = true;
        //    var promise = getBookings.checkBeforeAssignDriverToJobApi(dataSend);
        //    promise.then(
        //        function (payload) {
        //            $log.log('sxdsads', payload);
        //            vm.loading = false;
        //            if(!$stateParams.id){
        //                createBookingApi($event,arrayFDatesMade);
        //            }
        //            else if($stateParams.id){
        //                editBookingApi($event,arrayFDatesMade);
        //            }
        //
        //        },
        //        function (errorPayload) {
        //            $log.log(errorPayload);
        //            vm.loading = false;
        //            if(errorPayload.data.status == 401){
        //                errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
        //            }
        //            else{
        //                checkDriverPop(errorPayload.data.message,$event,arrayFDatesMade);
        //            }
        //        }
        //    );
        //}
        //
        //function checkDriverPop(msg,$event,arrayFDatesMade) {
        //    var confirm = $mdDialog.confirm()
        //        .title(msg)
        //        .textContent('')
        //        .ariaLabel('Lucky day')
        //        .targetEvent($event)
        //        .ok('SI')
        //        .cancel('NO');
        //
        //    $mdDialog.show(confirm).then(function () {
        //        if(!$stateParams.id){
        //            createBookingApi($event,arrayFDatesMade);
        //        }
        //        else if($stateParams.id){
        //            editBookingApi($event,arrayFDatesMade);
        //        }
        //    }, function () {
        //        $log.log('not confirmed');
        //    });
        //};
        function funcationif() {
            if (vm.grantedCheckbox && vm.dataToFill.allowBookingWithoutRequest == 1) {
                return true;
            } else {
                return false;
            }
        }
        //====================================check and make booking data================================
        function checkAndMakeBookingData($event, data, key) {
            console.log("puneet here >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>", $event)

            var returnDateTimeFormat = '';
            var scheduledDateTimeFormat = '';
            // var scheduledDateTimeFormatForRType = '';
            var dropDateTimeFormat = '';
            vm.errorFlagForDate = false;

            ///////////////////////////// TV-2893 //////////////////////////////////////////
            if (vm.modifyBooking == true && new Date(vm.bookingDetails.return_date_time_utc) == 'Invalid Date' && vm.dataToFill.returnDate == '' && vm.dataToFill.returnTime == '') {
                vm.dataToFill.returnDate = new Date(vm.bookingDetails.return_date_time_utc) == 'Invalid Date' ? '' : new Date(vm.bookingDetails.return_date_time_utc);
                vm.dataToFill.returnTime = new Date(vm.bookingDetails.return_date_time_utc) == 'Invalid Date' ? '' : new Date(vm.bookingDetails.return_date_time_utc);
            }
            if (vm.dataToFill.returnDate != '' && vm.dataToFill.returnTime != '' && vm.dataToFill.selectedServiceDetails.category != 1) {
                returnDateTimeFormat = dateTimeFormat(vm.dataToFill.returnDate, vm.dataToFill.returnTime);
            } else {
                returnDateTimeFormat = dateTimeFormat(vm.dataToFill.dropDateReturn, vm.dataToFill.dropTimeReturn);
            }
            if (vm.modifyBooking == true && new Date(vm.dataToFill.dropDate) == 'Invalid Date' && vm.dataToFill.dropDate == '' && vm.dataToFill.dropTime == '') {
                dropDateTimeFormat = new Date(vm.dataToFill.dropDate) == 'Invalid Date' ? '' : dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime);
            }
            if (vm.dataToFill.dropDate != '' && vm.dataToFill.dropTime != '') {
                dropDateTimeFormat = dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime);
            }
            if (vm.modifyBooking == true && new Date(vm.dataToFill.scheduledDate) == 'Invalid Date' && vm.dataToFill.scheduledDate == '' && vm.dataToFill.scheduledTime == '') {
                scheduledDateTimeFormat = new Date(vm.dataToFill.scheduledDate) == 'Invalid Date' ? '' : dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime);
                // scheduledDateTimeFormat = dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime);
            }
            if (vm.dataToFill.scheduledDate != '' && vm.dataToFill.scheduledTime != '') {
                scheduledDateTimeFormat = dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime);
            }
            if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking != 'R') {
                scheduledDateTimeFormat = dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime);
            }

            if (vm.roundTripTImeLess == true && vm.dataToFill.roundTrip == true) {
                if ((returnDateTimeFormat < scheduledDateTimeFormat) && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2) ||
                    ((returnDateTimeFormat < dropDateTimeFormat) && vm.dataToFill.selectedServiceDetails.category == 1) ||
                    ((returnDateTimeFormat < dropDateTimeFormat) && vm.dataToFill.selectedServiceDetails.category == 1 ||
                        ((returnDateTimeFormat < new Date()) && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2)))) {

                    vm.errorDateRT = true;
                    var msg = 'Reserva RT ' + vm.bookingDetails.round_trip_child_job_id + ' tiene fecha de retiro inferior'
                    var confirm = $mdDialog.confirm()
                        .title(msg)
                        .textContent('')
                        .ariaLabel('Lucky day')
                        .targetEvent($event)
                        .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                        .cancel(languageBasedErrorFactory.getProperErrorMessage('cancelButton', 0, '3'));

                    $mdDialog.show(confirm).then(function () {
                        editBookingApi($event);
                    }, function () {
                        $log.log('not confirmed');
                    });

                } else {
                    editBookingApi($event);
                }
                return;
            }

            if (vm.dataToFill.selectedServiceDetails.category == 1 && (vm.dataToFill.bookingType == '0' || vm.dataToFill.bookingType == 0)) {
                var checkDropTime = moment(moment(dropDateTimeFormat)).isAfter(moment());
                if (dropDateTimeFormat.getDate() > new Date().getDate()) {
                    vm.errorFlagForDate = true;
                    languageBasedErrorFactory.getProperErrorMessage('approDateTime', 0, 0)
                    //errorMessageFactory.showErrorMessage('Please select appropriate date & time.');
                    return;
                }
                if (!checkDropTime) {
                    vm.errorFlagForDate = true;
                    errorMessageFactory.showErrorMessage('Hora de recogida debe ser mayor a la hora actual.', 0)
                    //errorMessageFactory.showErrorMessage('Please select appropriate date & time.');
                    return;
                }
            }
            if (vm.dataToFill.selectedServiceDetails.category == 1 && (vm.dataToFill.bookingType == '1' || vm.dataToFill.bookingType == 1)) {
                var checkDropTime = moment(moment(dropDateTimeFormat)).isAfter(moment());
                if (!checkDropTime) {
                    vm.errorFlagForDate = true;
                    errorMessageFactory.showErrorMessage('Hora de recogida debe ser mayor a la hora actual.', 0)
                    //errorMessageFactory.showErrorMessage('Please select appropriate date & time.');
                    return;
                }
            }

            if (vm.dataToFill.roundTrip && vm.dataToFill.reaccurringBooking) {
                vm.errorFlagForDate = true;
                languageBasedErrorFactory.getProperErrorMessage('bookingError', 0, 0)
                //errorMessageFactory.showErrorMessage('This type of booking is not allowed.');
                return;
            }
            if (!vm.dataToFill.payment_method && !vm.modifyFalg) {
                vm.errorFlagForDate = true;
                errorMessageFactory.showErrorMessage('Please select payment method.', 0, 0);
                //errorMessageFactory.showErrorMessage("Selected customer don't have any corporate account");
                return;
            }

            if (vm.dataToFill.roundTrip && vm.dataToFill.is_wait_time_included && vm.dataToFill.selectedServiceDetails.category == 1) {
                vm.errorFlagForDate = true;
                languageBasedErrorFactory.getProperErrorMessage('bookingError', 0, 0)
                //errorMessageFactory.showErrorMessage('This type of booking is not allowed.');
                return;
            }
            var check = moment(moment(scheduledDateTimeFormat)).isAfter(moment());
            if ((vm.dataToFill.bookingType == '1' && !check) && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2)) {
                vm.errorFlagForDate = true;
                languageBasedErrorFactory.getProperErrorMessage('approDateTime', 0, 0)
                //errorMessageFactory.showErrorMessage('Please select appropriate date & time.');
                return;
            }
            // if ((vm.dataToFill.bookingType == '1' && scheduledDateTimeFormatForRType <= new Date()) && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2) && vm.type_of_trip_Validate_Booking == 'R') {
            //     languageBasedErrorFactory.getProperErrorMessage('approDateTime', 0, 0)
            //     //errorMessageFactory.showErrorMessage('Please select appropriate date & time.');
            //     return;
            // }

            if (vm.dataToFill.tillDate <= new Date() && vm.dataToFill.reaccurringBooking == true) {
                vm.errorFlagForDate = true;
                languageBasedErrorFactory.getProperErrorMessage('tillDateErr', 0, 0)
                //errorMessageFactory.showErrorMessage('Please select till date with at least 7 days difference.');
                return;
            }
            if ((vm.Flag == false) && (vm.dataToFill.route_id == '' || vm.dataToFill.route_id == undefined || vm.dataToFill.route_id == null)) {
                //console.log("i m in error ====================================");
                vm.errorFlagForDate = true;
                languageBasedErrorFactory.getProperErrorMessage('validPickDrop', 0, 0)
                //errorMessageFactory.showErrorMessage('Please choose valid pickup and drop off locations');
                return;
            }
            if ((vm.dataToFill.corporate_account_id == '' || vm.dataToFill.corporate_account_id == undefined || vm.dataToFill.corporate_account_id == null) && (vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == '1')) {
                vm.errorFlagForDate = true;
                languageBasedErrorFactory.getProperErrorMessage('custCorpoNot', 0, 0)
                //errorMessageFactory.showErrorMessage("Selected customer don't have any corporate account");
                return;
            }
            if (vm.dataToFill.roundTrip && !vm.dataToFill.is_wait_time_included && (vm.posBookingFlag == false) && (vm.type_of_trip != 'R' && vm.dataToFill.selectedServiceDetails.category != 1)) {
                if ((returnDateTimeFormat < new Date()) && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2)) {
                    vm.errorFlagForDate = true;
                    languageBasedErrorFactory.getProperErrorMessage('returnDateTimeError', 0, 0)
                    //errorMessageFactory.showErrorMessage("Please select appropriate return date & time.");
                    return;
                } else if ((returnDateTimeFormat < dropDateTimeFormat) && vm.dataToFill.selectedServiceDetails.category == 1) {
                    vm.errorFlagForDate = true;
                    languageBasedErrorFactory.getProperErrorMessage('returnDateTimeError', 0, 0)
                    //errorMessageFactory.showErrorMessage("Please select appropriate return date & time.");
                    return;
                }
                if (vm.dataToFill.bookingType == '1') {
                    if ((returnDateTimeFormat < scheduledDateTimeFormat) && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2)) {
                        vm.errorFlagForDate = true;
                        languageBasedErrorFactory.getProperErrorMessage('returnDateTimeError', 0, 0)
                        //errorMessageFactory.showErrorMessage('Please select appropriate return date & time.');
                        return;
                    } else if ((returnDateTimeFormat < dropDateTimeFormat) && vm.dataToFill.selectedServiceDetails.category == 1) {
                        vm.errorFlagForDate = true;
                        languageBasedErrorFactory.getProperErrorMessage('returnDateTimeError', 0, 0)
                        //errorMessageFactory.showErrorMessage('Please select appropriate return date & time.');
                        return;
                    }
                }



            }
            if (vm.dataToFill.roundTrip && !vm.dataToFill.is_wait_time_included && (vm.posBookingFlag == false) && ((vm.type_of_trip == 'R' && vm.dataToFill.selectedServiceDetails.category == 1))) {
                if ((returnDateTimeFormat < new Date()) && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2)) {
                    vm.errorFlagForDate = true;
                    languageBasedErrorFactory.getProperErrorMessage('returnDateTimeError', 0, 0)
                    //errorMessageFactory.showErrorMessage("Please select appropriate return date & time.");
                    return;
                } else if ((returnDateTimeFormat < dropDateTimeFormat) && vm.dataToFill.selectedServiceDetails.category == 1) {
                    vm.errorFlagForDate = true;
                    languageBasedErrorFactory.getProperErrorMessage('returnDateTimeError', 0, 0)
                    //errorMessageFactory.showErrorMessage("Please select appropriate return date & time.");
                    return;
                }
                if (vm.dataToFill.bookingType == '1') {
                    if ((returnDateTimeFormat < scheduledDateTimeFormat) && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2)) {
                        vm.errorFlagForDate = true;
                        languageBasedErrorFactory.getProperErrorMessage('returnDateTimeError', 0, 0)
                        //errorMessageFactory.showErrorMessage('Please select appropriate return date & time.');
                        return;
                    } else if ((returnDateTimeFormat < dropDateTimeFormat) && vm.dataToFill.selectedServiceDetails.category == 1) {
                        vm.errorFlagForDate = true;
                        languageBasedErrorFactory.getProperErrorMessage('returnDateTimeError', 0, 0)
                        //errorMessageFactory.showErrorMessage('Please select appropriate return date & time.');
                        return;
                    }
                }



            }

            var where = _.where(vm.serviceTypeList, {
                id: Number(vm.dataToFill.serviceTypeSelected)
            });
            if (vm.dataToFill.passengerCount > where[0].max_limit) {
                vm.errorFlagForDate = true;
                languageBasedErrorFactory.getProperErrorMessage('noOfPassErr', 0, 0)
                //errorMessageFactory.showErrorMessage("Please enter correct no. of passengers.");
                return;
            }

            Date.prototype.addDays = function (days) {
                this.setDate(this.getDate() + parseInt(days));
                return this;
            };
            if (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2) {
                if (vm.dataToFill.bookingType == '1') {
                    var currentDate = dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime);
                } else {
                    var currentDate = new Date();
                }
            } else if (vm.dataToFill.selectedServiceDetails.category == 1) {
                var currentDate = dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime);
            }
            //var currentDate = new Date();
            var lastDate = vm.dataToFill.tillDate;
            var arrayDatesMade = [];

            while (currentDate <= lastDate) {
                arrayDatesMade.push(new Date(currentDate));
                currentDate = currentDate.addDays(1);
                $log.log(currentDate);
            }
            arrayDatesMade.push(new Date(lastDate));
            //console.log('asdsadasdas', arrayDatesMade);
            for (var i = 0; i < arrayDatesMade.length; i++) {
                if ((vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2))
                    arrayDatesMade[i] = dateTimeFormat(arrayDatesMade[i], vm.dataToFill.bookingType == '1' ? vm.dataToFill.scheduledTime : new Date());
                else if (vm.dataToFill.selectedServiceDetails.category == 1) {
                    if (data == true) {
                        // vm.dataToFill.dropDate = arrayDatesMade[i];
                        vm.dataToFill.tillDate = arrayDatesMade[i];
                        vm.dataToFill.dropTime = vm.dataToFill.dropTime;
                        vm.pickRangeSendForRouting.length = 1;
                        vm.etaArray.length = 1;
                        vm.pickup_lower_range.length = 1;
                        vm.pickup_top_range.length = 1;
                        console.log(vm.pickRangeSendForRouting, vm.etaArray);
                        RoutingApiFuncation(vm.dataToFill, i, 'recurring');
                    }
                    arrayDatesMade[i] = dateTimeFormat(arrayDatesMade[i], vm.dataToFill.dropTime);
                }
            }

            $log.log(vm.daysList);
            var arrayFDatesMade = [];
            for (var i = 0; i < arrayDatesMade.length; i++) {
                if (vm.daysList.sunday.selected && vm.daysList.sunday.value == 0) {
                    if (vm.daysList.sunday.value == arrayDatesMade[i].getDay()) {
                        arrayFDatesMade.push(arrayDatesMade[i].toISOString());
                    }
                }
                if (vm.daysList.monday.selected && vm.daysList.monday.value) {
                    if (vm.daysList.monday.value == arrayDatesMade[i].getDay()) {
                        arrayFDatesMade.push(arrayDatesMade[i].toISOString());
                    }
                }
                if (vm.daysList.tuesday.selected && vm.daysList.tuesday.value) {
                    if (vm.daysList.tuesday.value == arrayDatesMade[i].getDay()) {
                        arrayFDatesMade.push(arrayDatesMade[i].toISOString());
                    }
                }
                if (vm.daysList.wednesday.selected && vm.daysList.wednesday.value) {
                    if (vm.daysList.wednesday.value == arrayDatesMade[i].getDay()) {
                        arrayFDatesMade.push(arrayDatesMade[i].toISOString());
                    }
                }
                if (vm.daysList.thursday.selected && vm.daysList.thursday.value) {
                    if (vm.daysList.thursday.value == arrayDatesMade[i].getDay()) {
                        arrayFDatesMade.push(arrayDatesMade[i].toISOString());
                    }
                }
                if (vm.daysList.friday.selected && vm.daysList.friday.value) {
                    if (vm.daysList.friday.value == arrayDatesMade[i].getDay()) {
                        arrayFDatesMade.push(arrayDatesMade[i].toISOString());
                    }
                }
                if (vm.daysList.saturday.selected && vm.daysList.saturday.value) {
                    if (vm.daysList.saturday.value == arrayDatesMade[i].getDay()) {
                        arrayFDatesMade.push(arrayDatesMade[i].toISOString());
                    }
                }

            }
            if (vm.dataToFill.pickUpLat == vm.dataToFill.dropOffLat && vm.dataToFill.pickUpLng == vm.dataToFill.dropOffLng && !vm.ErrorFlagForNewApi) {
                vm.errorFlagForDate = true;
                languageBasedErrorFactory.getProperErrorMessage('dropPick', 0, 0)
                //errorMessageFactory.showErrorMessage("Drop-off location must be different from Pickup location");
                return;
            }
            //console.log('arrayDatesMade121212', arrayFDatesMade);
            for (var i = 0; i < arrayFDatesMade.length; i++) {
                if (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2) {
                    if (new Date(arrayFDatesMade[i]).getDate() == new Date().getDate() && new Date(arrayFDatesMade[i]).getMonth() == new Date().getMonth() && new Date(arrayFDatesMade[i]).getFullYear() == new Date().getFullYear()) {
                        arrayFDatesMade.splice(i, 1);
                    } else if (new Date(arrayFDatesMade[i]).getDate() == scheduledDateTimeFormat.getDate() && new Date(arrayFDatesMade[i]).getMonth() == scheduledDateTimeFormat.getMonth() && new Date(arrayFDatesMade[i]).getFullYear() == scheduledDateTimeFormat.getFullYear()) {
                        arrayFDatesMade.splice(i, 1);
                    }
                } else if (vm.dataToFill.selectedServiceDetails.category == 1) {
                    if (new Date(arrayFDatesMade[i]).getDate() == dropDateTimeFormat.getDate() && new Date(arrayFDatesMade[i]).getMonth() == dropDateTimeFormat.getMonth() && new Date(arrayFDatesMade[i]).getFullYear() == dropDateTimeFormat.getFullYear()) {
                        arrayFDatesMade.splice(i, 1);
                    }
                }
            }
            //console.log('arrayDatesMade', arrayFDatesMade);
            vm.disableSubmitButton = true;
            vm.arrayFDatesMadeNew = arrayFDatesMade;
        }

        function CreateBookingNew(createBookingByPass, $event) {
            vm.disabledSubmitButton = false;
            vm.loading = true;
            $timeout(function () {
            if (createBookingByPass.$valid == false) {
                vm.disabledSubmitButton = true;
                vm.loading = false;
                return;
            }
            if(vm.fullCuota){
                vm.disabledSubmitButton = true;
                vm.loading = false;
                return;
            }
            if (!$stateParams.id) {
                var where = _.where(vm.dataToFill.contractList, {
                    id: Number(vm.dataToFill.contractIdSelected)
                });
                if (vm.dataToFill.customerProfile == '1' || vm.dataToFill.customerProfile == 1) {
                    if (vm.dataToFill.first_name) {
                        createEmployeeNew($event, vm.arrayFDatesMadeNew);
                    } else if (where.length == 0) {
                        createEmployeeNew($event, vm.arrayFDatesMadeNew);
                    } else {
                        if ((vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == '1') && vm.dataToFill.bookingFor == 0)
                            updateEmployeeProfile($event, vm.arrayFDatesMadeNew);
                        // if(!vm.method_range_pickup)
                        createBookingApi($event, vm.arrayFDatesMadeNew);
                    }
                } else if ((vm.dataToFill.first_name && (vm.dataToFill.customerProfile == '0' || vm.dataToFill.customerProfile == 0))) {
                    createCustomerNew($event, vm.arrayFDatesMadeNew);
                } else {
                    if ((vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == '1') && vm.dataToFill.bookingFor == 0)
                        updateEmployeeProfile($event, vm.arrayFDatesMadeNew);
                    // if(!vm.method_range_pickup)
                    createBookingApi($event, vm.arrayFDatesMadeNew);
                }
                // if(vm.method_range_pickup && Number(vm.dataToFill.reaccurringBooking) == 1 && !key){
                //     $timeout(function () {
                //         createBookingApi($event, vm.arrayFDatesMadeNew );
                //     }, 3000);
                // }else if(vm.method_range_pickup || key){
                //         createBookingApi($event, vm.arrayFDatesMadeNew );
                // }
            } else if ($stateParams.id) {
                console.log("puneet here else if ");
                if (vm.dataToFill.nearDriver) {
                    //checkBeforeAssignDriver($event,arrayFDatesMade);
                    if ((vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == '1') && vm.dataToFill.bookingFor == 0) {
                        console.log("puneet here if ");
                        updateEmployeeProfile($event, vm.arrayFDatesMadeNew);
                    } else {
                        console.log("puneet here else first");
                        editBookingApi($event, vm.arrayFDatesMadeNew);
                    }
                } else {
                    console.log("puneet else here ");
                    if ((vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == '1') && vm.dataToFill.bookingFor == 0) {
                        console.log("puneet here  if second");
                        updateEmployeeProfile($event, vm.arrayFDatesMadeNew);
                    } else {
                        console.log("puneet here else seconf");
                        editBookingApi($event, vm.arrayFDatesMadeNew);
                    }




                }
            }
            }, 3000);
        }

        //====================update employee details api=======================
        function updateEmployeeProfile($event, arrayFDatesMade) {
            console.log(arrayFDatesMade, ">>>>>>>>>>>>>>>>>>>>>>>>please come");
            vm.checkDataChanged = {
                rut: false,
                costCenter: false,
                costSbCenter: false,
                rol: false,
                graph: false,
                pep: false
            };
            if (vm.selectedEmployeeData != undefined) {
                vm.selectedEmployeeData.employee_details.RUT = vm.selectedEmployeeData.employee_details.RUT ? vm.selectedEmployeeData.employee_details.RUT : '';
                if (RutHelper.clean(vm.dataToFill.applicantRut) != vm.selectedEmployeeData.employee_details.RUT)
                    vm.checkDataChanged.rut = true;
                else vm.checkDataChanged.rut = false;
                if (vm.dataToFill.costCenter != vm.selectedEmployeeData.employee_details.cost_center)
                    vm.checkDataChanged.costCenter = true;
                else vm.checkDataChanged.costCenter = false;
                if (vm.dataToFill.costSubCenter != vm.selectedEmployeeData.employee_details.cost_subcenter)
                    vm.checkDataChanged.costSbCenter = true;
                else vm.checkDataChanged.costSbCenter = false;
                if (vm.dataToFill.Rol != vm.selectedEmployeeData.employee_details.ROI)
                    vm.checkDataChanged.rol = true;
                else vm.checkDataChanged.rol = false;
                if (vm.dataToFill.graph != vm.selectedEmployeeData.employee_details.graph)
                    vm.checkDataChanged.graph = true;
                else vm.checkDataChanged.graph = false;
                if (vm.dataToFill.pep != vm.selectedEmployeeData.employee_details.PEP)
                    vm.checkDataChanged.pep = true;
                else vm.checkDataChanged.pep = false;
                if (vm.modifyFalg == true && vm.errorDateRT == false)
                    editBookingApi($event, arrayFDatesMade)
                //console.log(vm.checkDataChanged);
                if (vm.checkDataChanged.rut || vm.checkDataChanged.costCenter || vm.checkDataChanged.costSbCenter || vm.checkDataChanged.rol || vm.checkDataChanged.graph || vm.checkDataChanged.pep) {
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.employee_id = vm.selectedEmployeeData.employee_details.id;
                    dataSend.RUT = RutHelper.clean(vm.dataToFill.applicantRut);
                    dataSend.cost_center = vm.dataToFill.costCenter;
                    dataSend.cost_subcenter = vm.dataToFill.costSubCenter;
                    dataSend.ROI = vm.dataToFill.Rol;
                    dataSend.graph = vm.dataToFill.graph;
                    dataSend.PEP = vm.dataToFill.pep;

                    var promise = getAgreement.updateEmployeeAdditionalFields(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log(payload);
                            if (payload.title.status == 400) {
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            } else if (payload.title.status == 401) {
                                errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                            } else if (payload.title.status == 201 || payload.title.status == 200) {
                                // editBookingApi($event, arrayFDatesMade);
                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.disableSubmitButton = false;
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }
            } else {
                createEmployeeNew($event, arrayFDatesMade);
                vm.flagForEditBooking = true;
                return false;
            }


        }


        // //=======================Validate Edit booking api==========================
        // function ValidateEditBookingApi($event, arrayFDatesMade) {
        //     // TV-1345  CCOMMENT BY NAKUL
        //     // if(vm.dataToFill.bookingType == '0' && !vm.dataToFill.is_wait_time_included && vm.dataToFill.roundTrip){
        //     //     errorMessageFactory.showErrorMessage('No se permite crear reservas ida y vuelta sin tiempo de espera', 0);
        //     //     return false;
        //     // }
        //     // $log.log(dataSend);
        //     vm.loading = true;
        //     var dataSend = {};
        //     dataSend.time = [];
        //     dataSend.access_token = $cookies.get('obj');
        //     dataSend.customer_email = vm.dataToFill.customerEmail;
        //     if (vm.dataToFill.selectedServiceDetails.category == 1 && vm.pickRange1 && vm.pickRange2 && vm.dataToFill.airportCheck != 'Z') {
        //         dataSend.is_shared_service = 1;
        //     } else {
        //         dataSend.is_shared_service = 0;
        //     }
        //     if (vm.dataToFill.selectedServiceDetails.category == 1) {
        //         dataSend.booking_eta = vm.dataToFill.etaScheduleValue + vm.dataToFill.time_trip_shared_service;
        //     } else {
        //         dataSend.booking_eta = vm.dataToFill.etaSchedule;
        //     }
        //     dataSend.type_of_trip = vm.type_of_trip_Validate_Booking;
        //     dataSend.timezone = new Date().getTimezoneOffset();
        //     dataSend.modify_booking = 1;
        //     dataSend.job_id = vm.dataToFill.bookingId;
        //     dataSend.booking_for = Number(vm.dataToFill.bookingFor);
        //     if (vm.dataToFill.bookingFor == 1) {
        //         dataSend.full_name = vm.dataToFill.personName;
        //         dataSend.phone_number = vm.dataToFill.personMobile;
        //         dataSend.email = vm.dataToFill.personEmail;
        //     }
        //     if (vm.dataToFill.bookingType == '1' && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2)) {
        //         dataSend.schedule_ride = 1;
        //         dataSend.time.push(dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime).toISOString());
        //     } else if (vm.dataToFill.bookingType == '1' && vm.dataToFill.selectedServiceDetails.category == 1) {
        //         dataSend.schedule_ride = 1;
        //         dataSend.time.push(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString());
        //     } else if (vm.dataToFill.bookingType == '0' && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2)) {
        //         dataSend.schedule_ride = 0;
        //     } else if (vm.dataToFill.bookingType == '0' && vm.dataToFill.selectedServiceDetails.category == 1) {
        //         dataSend.schedule_ride = 0;
        //         dataSend.time.push(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString());
        //     }
        //     dataSend.reaccurring = Number(vm.dataToFill.reaccurringBooking);
        //     if (vm.dataToFill.reaccurringBooking == '1') {
        //         for (var i = 0; i < arrayFDatesMade.length; i++) {
        //             dataSend.time.push(arrayFDatesMade[i]);
        //         }
        //     }
        //     dataSend.round_trip = Number(vm.dataToFill.roundTrip);
        //     if (vm.dataToFill.roundTrip && !vm.dataToFill.is_wait_time_included) {
        //         dataSend.return_date_time = dateTimeFormat(vm.dataToFill.returnDate, vm.dataToFill.returnTime).toISOString();
        //     }
        //     dataSend.is_wait_time_included = vm.dataToFill.is_wait_time_included ? 1 : 0;
        //     var promise = getBookings.ValidateCreateBooking(dataSend);
        //     promise.then(
        //         function (payload) {
        //             $log.log(payload);
        //             vm.loading = false;
        //             if (payload.title.status == 200) {
        //                 if (payload.title.data.flag == true) {
        //                     // var confirm = $mdDialog.confirm()
        //                     //     .textContent(payload.title.message)
        //                     //         .ariaLabel('Lucky day')
        //                     //         .targetEvent($event)
        //                     //         .ok('Confirmar')
        //                     //         .cancel('Cancelar'); 
        //                     //         $mdDialog.show(confirm).then(function () {
        //                     //             editBookingApi($event, arrayFDatesMade);
        //                     //         }, function () {
        //                     //             vm.disableSubmitButton = true;
        //                     //             $log.log('not confirmed');
        //                     //         });
        //                     bookingValidateCreationSuccess(payload, 'NoAuth', $event);
        //                 } else {
        //                     editBookingApi($event, arrayFDatesMade);
        //                 }
        //             }
        //         },
        //         function (errorPayload) {
        //             $log.log(errorPayload);
        //             vm.loading = false;
        //             // vm.disableSubmitButton = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // };




        //=======================Validate Edit booking api==========================

        //=======================create booking api==========================
        function createBookingApi($event, arrayFDatesMade) {
            if(vm.routingBase && vm.routingBase.routing_base_id > 0) {
                vm.dataToFill.selectedServiceDetails.category = 0;
                vm.method_range_pickup = 0;
            }
            if (vm.bookingError == true) {
                errorMessageFactory.showErrorMessage('Error al calcular el Retiro. Error en la llamada a la API', 0);
                return;
            }
            if (vm.errorFlagForDate == true || (vm.dataToFill.passengerCount == 0 || vm.dataToFill.passengerCount == null || vm.dataToFill.passengerCount == undefined) || vm.ErrorFlagForNewApi) {
                return;
            }
            vm.currentTime = new Date();
            vm.claenderTime = moment(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime)).subtract(vm.etaSeconds, 'seconds');
            vm.timeFlight = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            vm.currentTimeFlight = new Date(dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value));
            vm.checkFlag = moment(vm.timeFlight).isAfter(vm.claenderTime);
            vm.currentBookingSchudule = dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime);
            vm.currentCheckFlag = moment(vm.currentTimeFlight).isAfter(vm.currentTime);
            vm.checkFlagCurrentBookingSchudule = moment(vm.currentTimeFlight).isAfter(vm.currentBookingSchudule);
            // Tv-2176
            // if (vm.type_of_trip1 == 'R' && vm.checkFlag == false && vm.flagForFlightDate == true && vm.type_of_trip1 != 'P') {
            //     // languageBasedErrorFactory.getProperErrorMessage('greaterCheck', 0, 0)
            //     vm.disableSubmitButton = false;
            //     return false;
            // }
            // if (vm.currentCheckFlag == false && vm.flagForFlightDate == true && vm.type_of_trip1 != 'P') {
            //     // languageBasedErrorFactory.getProperErrorMessage('greaterCheck', 0, 0)
            //     vm.disableSubmitButton = false;
            //     return false;
            // }
            // if (vm.checkFlagCurrentBookingSchudule == false && vm.flagForFlightDate == true && vm.type_of_trip1 != 'P') {
            //     languageBasedErrorFactory.getProperErrorMessage('greaterCheck', 0, 0)
            //     vm.disableSubmitButton = false;
            //     return false;
            // }
            if (((Number(vm.dataToFill.estimatedFare)) < (Number(vm.viaControlled1))) || (Number(vm.dataToFill.estimatedFare)) < (Number(vm.viaControlled2))) {
                errorMessageFactory.showErrorMessage('Reserva no puede ser creada debido a que Via controlada es mayor que valor del tramo', 0);
                return false;
            }
            vm.disabledSubmitButton = false;
            $log.log(vm.dataToFill);
            $log.log(vm.daysList);
            vm.loading = true;
            var dataSend = {};
            dataSend.time = [];
            var tz = moment.tz.guess();
            // dataSend.time_pickup_array  = [];/
            dataSend.reaccurringTimeZone = [];
            dataSend.access_token = $cookies.get('obj');
            dataSend.customer_email = vm.dataToFill.customerEmail;
            dataSend.customer_phone_number = vm.dataToFill.customerMobileG;
            dataSend.profile = Number(vm.dataToFill.customerProfile);
            dataSend.number_of_passangers = Number(vm.dataToFill.passengerCount);
            dataSend.timezone = new Date().getTimezoneOffset();
            dataSend.booking_for = Number(vm.dataToFill.bookingFor);
            ///////////////////////////TV-1795 //////////////////////////
            // if (vm.dataToFill.controllerWayTarifa == 1) {
            //     vm.viaControlled1 = 0;
            //     vm.viaControlled2 = 0;
            // }
            if (vm.dataToFill.bookingFor == 1) {
                dataSend.full_name = vm.dataToFill.personName;
                dataSend.phone_number = vm.dataToFill.personMobile;
                dataSend.email = vm.dataToFill.personEmail;
                if (vm.dataToFill.passengerId != null)
                    dataSend.passenger_id = vm.dataToFill.passengerId;
            }
            // vm.dataToFill.pickUpAddress
            dataSend.pickup_location = vm.dataToFill.pickUpAddress;
            dataSend.job_pickup_comuna = vm.jobPickupComuna || null; // Send CITY of PICKUP ADDRESS
            dataSend.drop_location = vm.dataToFill.dropOffAddress;
            dataSend.job_dropoff_comuna = vm.jobDropoffComuna || null; // Send CITY of DROPOFF ADDRESS
            dataSend.pickup_lat = vm.dataToFill.pickUpLat;
            dataSend.pickup_long = vm.dataToFill.pickUpLng;
            dataSend.drop_lat = vm.dataToFill.dropOffLat;
            dataSend.drop_long = vm.dataToFill.dropOffLng;
            if (vm.airlineMandatory == 1 && vm.type_of_trip1 != 'P') {
                dataSend.airline = vm.dataToFill.airline;
            }
            if (vm.flightNumberMandatory == 1 && vm.type_of_trip1 != 'P') {
                dataSend.flight_number = vm.dataToFill.flightNumber;
            }
            if (vm.flightDateMandatory == 1 && vm.type_of_trip1 != 'P') {
                dataSend.flight_date = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            }
            if (vm.flightTypeMandatory == 1 && vm.type_of_trip1 != 'P') {
                if (vm.international && vm.flightFLag) {
                    dataSend.flight_type = vm.international;
                } else {
                    dataSend.flight_type = vm.national;
                }

            }
            if ((vm.type_of_trip1 == 'R' && vm.dataToFill.selectedServiceDetails.category == 1 && vm.method_range_pickup) || (vm.routingBase && vm.routingBase.routing_base_id > 0)) {
                dataSend.is_routing = 1;
                dataSend.time_pickup_array = (vm.pickRangeSendForRouting);
                dataSend.reaccurringTimeZone = vm.timeZoneRecurring;
                dataSend.tolerance_after_route_array = vm.pickup_top_range; // after
                dataSend.tolerance_before_route_array = vm.pickup_lower_range; // before 
                dataSend.travel_distance_route = vm.distanceRoutingApi;
            }
            if (vm.type_of_trip == 'R' && vm.dataToFill.selectedServiceDetails.category == 1 && vm.method_range_pickup_return && vm.dataToFill.roundTrip == 1) {
                dataSend.is_routing = 1;
                dataSend.time_pickup_return_route = (vm.pickRangeSendForRoutingReturn);
                dataSend.returnTimeZone = vm.timeZoneRRoundReturn;
                dataSend.tolerance_before_route_return = vm.pickup_lower_range_return;
                dataSend.tolerance_after_route_return = vm.pickup_top_range_return;
                dataSend.travel_distance_route_return = vm.distanceRoutingApiReturn;
            }
            if (vm.checkBoxCheck) {
                dataSend.sin_respaldo = vm.checkBoxValueIs ? 1 : 0;
            }
            if (vm.dataToFill.selectedServiceDetails.category == 1 && !vm.method_range_pickup) {
                dataSend.booking_eta = vm.dataToFill.etaScheduleValue + vm.dataToFill.time_trip_shared_service;
            } else {
                dataSend.booking_eta = vm.dataToFill.etaSchedule;
            }
            if (vm.dataToFill.route_type === 0 && vm.estimatedDistanceToSend)
                dataSend.est_distance = vm.estimatedDistanceToSend;
            if (vm.bookingEta && Number(vm.dataToFill.reaccurringBooking) == 1 && !vm.modifyFalg) {
                dataSend.booking_eta_array = vm.etaArray;
            }
            if (vm.dataToFill.selectedServiceDetails.category == 1 && !vm.method_range_pickup_return) {
                dataSend.return_booking_eta = vm.dataToFill.etaScheduleValueReturn + vm.dataToFill.time_trip_shared_service;
            } else {
                dataSend.return_booking_eta = vm.dataToFill.etaScheduleValueReturn;
            }
            dataSend.transport_type_id = Number(vm.dataToFill.carType);
            if ((vm.dataToFill.bookingType == '1' && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2)) && !vm.routingBase) {
                dataSend.schedule_ride = 1;
                dataSend.timezone = moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime).toISOString()));
                dataSend.reaccurringTimeZone.push(moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime).toISOString())));
                // dataSend.timezone = new Date(dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime).toISOString()).getTimezoneOffset();
                dataSend.time.push(dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime).toISOString());

            } else if ((vm.dataToFill.bookingType == '1' && ((vm.dataToFill.selectedServiceDetails.category == 1) || (vm.routingBase && vm.routingBase.routing_base_id > 0)))) {
                dataSend.schedule_ride = 1;
                dataSend.timezone = moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString()));
                dataSend.reaccurringTimeZone.push(moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString())));
                // dataSend.timezone = new Date(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString()).getTimezoneOffset();
                dataSend.time.push(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString());
            } else if (vm.dataToFill.bookingType == '0' && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2) && vm.type_of_trip_Validate_Booking != 'R') {
                dataSend.schedule_ride = 0;
            } else if (vm.dataToFill.bookingType == '0' && vm.dataToFill.selectedServiceDetails.category == 1) {
                dataSend.schedule_ride = 0;
                dataSend.timezone = moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString()));
                dataSend.reaccurringTimeZone.push(moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString())));
                // dataSend.timezone = new Date(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString()).getTimezoneOffset();
                dataSend.time.push(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString());
            }
            // else if (vm.dataToFill.bookingType == '1' && vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking == 'R') {
            //     dataSend.schedule_ride = 1;
            //     dataSend.timezone = new Date(dateTimeFormat(vm.dataToFill.dropDateOfRType, vm.dataToFill.dropTimeOfRtype).toISOString()).getTimezoneOffset();
            //     dataSend.time.push(dateTimeFormat(vm.dataToFill.dropDateOfRType, vm.dataToFill.dropTimeOfRtype).toISOString());
            // }
            else if (vm.dataToFill.bookingType == '0' && vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking == 'R') {
                dataSend.schedule_ride = 0;
            }
            dataSend.round_trip = Number(vm.dataToFill.roundTrip);
            if (vm.dataToFill.roundTrip) {
                if (((!vm.dataToFill.is_wait_time_included && vm.dataToFill.selectedServiceDetails.category != 1) || (vm.dataToFill.roundTrip && vm.dataToFill.selectedServiceDetails.category == 1 && vm.type_of_trip != 'R')) &&
                    ((!vm.dataToFill.is_wait_time_included && vm.type_of_trip != 'R') || vm.dataToFill.selectedServiceDetails.category != 0 && vm.type_of_trip != 'R')) {
                    dataSend.returnTimeZone = moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.returnDate, vm.dataToFill.returnTime).toISOString()));
                    dataSend.return_date_time = dateTimeFormat(vm.dataToFill.returnDate, vm.dataToFill.returnTime).toISOString();
                } else if ((!vm.dataToFill.is_wait_time_included && vm.dataToFill.selectedServiceDetails.category == 1) || (vm.dataToFill.roundTrip && vm.dataToFill.selectedServiceDetails.category == 1 && vm.type_of_trip != 'R') ||
                    (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip == 'R')) {
                    dataSend.returnTimeZone = moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.dropDateReturn, vm.dataToFill.dropTimeReturn).toISOString()));
                    dataSend.return_date_time = dateTimeFormat(vm.dataToFill.dropDateReturn, vm.dataToFill.dropTimeReturn).toISOString();
                }
                // if (vm.estimated_toll_price_return !== undefined && vm.dataToFill.Return_policy.route_type === 0) {
                if (vm.estimated_toll_price_return !== undefined) {
                    dataSend.estimated_toll_price_return = vm.estimated_toll_price_return;
                }
                // if (vm.heremaps_toll_details_return && vm.dataToFill.route_type === 0) {
                if (vm.heremaps_toll_details_return && vm.searchFixedVariablePayload.title.data.apply_charge_by_toll) {
                    dataSend.heremaps_toll_details_return = JSON.stringify(vm.heremaps_toll_details_return.heremaps_response['detail-cost']);
                    dataSend.heremaps_estimated_tolls_return = vm.tollCountReturn;
                    dataSend.item_of_charge_tolls_price_return = vm.toll_price_return || 0;
                }
                if (vm.ReturnEstimatedDistanceToSend && vm.dataToFill.route_type === 0) {
                    dataSend.est_distance_return = vm.ReturnEstimatedDistanceToSend;
                }
            }
            if (vm.heremaps_toll_details && vm.toll_id) {
                // if (vm.heremaps_toll_details && vm.dataToFill.route_type === 0) {
                dataSend.heremaps_toll_details = JSON.stringify(vm.heremaps_toll_details.heremaps_response['detail-cost']);
                dataSend.heremaps_estimated_tolls = vm.tollCount;
                dataSend.item_of_charge_tolls_price = vm.toll_price || 0;
            }
            dataSend.reaccurring = Number(vm.dataToFill.reaccurringBooking);
            if (vm.dataToFill.reaccurringBooking == '1') {
                if (arrayFDatesMade.length != 0) {
                    for (var i = 0; i < arrayFDatesMade.length; i++) {
                        dataSend.time.push(arrayFDatesMade[i]);
                        dataSend.reaccurringTimeZone.push(moment.tz.zone(tz).utcOffset(moment(arrayFDatesMade[i])));
                    }
                } else {
                    dataSend.reaccurringTimeZone.push(moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.dropDateReturn, vm.dataToFill.dropTimeReturn).toISOString())));
                }
            } else {
                dataSend.reaccurringTimeZone = []; // TV-3659 change in parent booking timezone is not consider by backend in case of recurring 
            }
            if (vm.dataToFill.reference_point) {
                dataSend.reference_point = vm.dataToFill.reference_point;
            }
            if (vm.dataToFill.corporate_account_id && (vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == '1')) {
                dataSend.corporate_account_id = vm.dataToFill.corporate_account_id;
            }
            dataSend.route_id = vm.dataToFill.route_id;
            dataSend.route_type = vm.dataToFill.route_type;
            dataSend.type_of_agreement = vm.dataToFill.type_of_agreement;
            if (vm.dataToFill.type_of_agreement == 1) // THIRD PERSON BOOKING IS VIP OR NOT IN CORPORATE AGGREMENT
                dataSend.isVIP_someone = vm.is_vip ? 1 : 0;
            dataSend.is_wait_time_included = vm.dataToFill.is_wait_time_included ? 1 : 0;
            dataSend.contract_id = vm.dataToFill.contractIdSelected;
            dataSend.service_type = Number(vm.dataToFill.serviceTypeSelected);

            if (vm.dataToFill.authRequired == '1' && (vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == '1')) {
                dataSend.auth_required = Number(vm.dataToFill.authRequired);
                dataSend.auth_of = RutHelper.clean(vm.dataToFill.authRUT);
            } else {
                dataSend.auth_required = 0;
            }
            var isAirportFlag = 0;
            if (vm.fromAirportFlag) {
                isAirportFlag = 1;
            } else if (vm.toAirportFlag) {
                isAirportFlag = 2;
            }
            dataSend.airport = Number(isAirportFlag);
            if (vm.dataToFill.itemOfChargeSelected.length) {
                vm.dataToFill.item_of_charges = [];
                vm.dataToFill.is_item_of_charges = 1;
                for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                    vm.dataToFill.item_of_charges.push({
                        "fixed_pricing_id": vm.dataToFill.itemOfChargeSelected[i].fixed_pricing_id ? vm.dataToFill.itemOfChargeSelected[i].fixed_pricing_id : vm.dataToFill.itemOfChargeSelected[i].variable_pricing_id,
                        "id": vm.dataToFill.itemOfChargeSelected[i].tic_id,
                        "item_of_charge_id": vm.dataToFill.itemOfChargeSelected[i].id,
                        "description": vm.dataToFill.itemOfChargeSelected[i].tic_description,
                        "long_name": vm.dataToFill.itemOfChargeSelected[i].tic_long_name,
                        "manually": vm.dataToFill.itemOfChargeSelected[i].tic_manually,
                        "price": vm.dataToFill.itemOfChargeSelected[i].price,
                        "short_name": vm.dataToFill.itemOfChargeSelected[i].tic_short_name,
                        "quantity": vm.dataToFill.itemOfChargeSelected[i].quantity,
                        "retorno": vm.dataToFill.itemOfChargeSelected[i].retorno
                    })
                }
                dataSend.is_item_of_charges = Number(vm.dataToFill.is_item_of_charges);
                var items_ida = vm.dataToFill.item_of_charges.filter(function(itm){ return itm.retorno == false })
                var items_vuelta = vm.dataToFill.item_of_charges.filter(function(itm){ return itm.retorno == true })
                dataSend.item_of_charges = items_ida;
                dataSend.item_of_charges_return = items_vuelta;
            } else {
                dataSend.is_item_of_charges = 0;
            }
            if (vm.dataToFill.nearDriver)
                dataSend.favourite_driver_id = Number(vm.dataToFill.nearDriver);

            dataSend.payment_method = vm.dataToFill.payment_method;
            //console.log(vm.dataToFill.pepCheck, 'pepCheck');
            if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking == 'P'){
                dataSend.pickup_tolerance_time_pap = vm.time_trip_shared_service_point_to_point;
                dataSend.pickup_travel_time_pap = vm.pickup_travel_time_pap;
            }
            if ((vm.dataToFill.selectedServiceDetails.category == 0) && (vm.type_of_trip_Validate_Booking == 'R' || (vm.dataToFill.roundTrip && vm.type_of_trip == 'R'))){
                dataSend.travel_time = vm.travel_time_service_pick_up; 
                dataSend.tolerance_time = vm.tolerance_time_withdrawal_pickup; 
            } 
            if (vm.dataToFill.passengerRutCheck == 1)
                dataSend.passenger_rut = RutHelper.clean(vm.dataToFill.passengerRut);
            if (vm.dataToFill.applicantRutCheck == 1)
                dataSend.applicant_rut = RutHelper.clean(vm.dataToFill.applicantRut);
            if (vm.dataToFill.costCenterCheck == 1)
                dataSend.cost_center = vm.dataToFill.costCenter;
            if (vm.dataToFill.costSubCenterCheck == 1)
                dataSend.sub_cost_center = vm.dataToFill.costSubCenter;
            if (vm.dataToFill.RolCheck == 1)
                dataSend.rol = vm.dataToFill.Rol;
            if (vm.dataToFill.graphCheck == 1)
                dataSend.graph = vm.dataToFill.graph;
            if (vm.dataToFill.workOrderCheck == 1)
                dataSend.work_order = vm.dataToFill.workOrder;
            if (vm.dataToFill.pepCheck == 1)
                dataSend.PEP = vm.dataToFill.pep;
            if (vm.dataToFill.purposeOfTripCheck == 1)
                dataSend.purpose_of_trip = vm.dataToFill.purposeOfTrip;
            if (vm.dataToFill.noOfVoucherCheck == 1)
                dataSend.number_of_voucher = vm.dataToFill.noOfVoucher;
            if (vm.dataToFill.nominaCheck == 1)
                dataSend.nomina = vm.dataToFill.nomina;
            if (vm.dataToFill.solictudCheck == 1)
                dataSend.solicitud = vm.dataToFill.solictud;

            dataSend.observations = vm.dataToFill.observations;
            if (vm.viaControlledFLag1 == true && vm.type_of_trip1 == 'Z') {
                if (vm.dataToFill.controllerWayTarifa == 1) {
                    // if (vm.dataToFill.selectedServiceDetails.fare_type == 1) {
                    //     dataSend.via_controlled_price = Number(vm.viaControlled1) + (vm.viaControlled1 * (vm.dataToFill.passengerCount - 1));
                    //     vm.addViaControlled = 0;
                    // } else {
                    dataSend.via_controlled_price = Number(vm.viaControlled1);
                    vm.addViaControlled = 0;
                    // }
                } else {
                    // if (vm.dataToFill.selectedServiceDetails.fare_type == 1) {
                    //     dataSend.via_controlled_price = Number(vm.viaControlled1) + (vm.viaControlled1 * (vm.dataToFill.passengerCount - 1));
                    //     vm.addViaControlled = 0;
                    // } else {
                    dataSend.via_controlled_price = Number(vm.viaControlled1);
                    vm.addViaControlled = 0;
                    // }
                }
            } else {
                vm.addViaControlled = 0;
            }
            if (vm.viaControlledFLag == true && vm.dataToFill.roundTrip == true) {
                if (vm.dataToFill.controllerWayTarifa == 1) {
                    // if (vm.dataToFill.selectedServiceDetails.fare_type == 1) {
                    //     dataSend.via_controlled_price = Number(vm.viaControlled2) + (vm.viaControlled2 * (vm.dataToFill.passengerCount - 1));
                    //     vm.addViaControlledRound = 0;
                    // } else {
                    dataSend.via_controlled_price_return = Number(vm.viaControlled2);
                    vm.addViaControlledRound = 0;
                    // }
                } else {
                    // if (vm.dataToFill.selectedServiceDetails.fare_type == 1) {
                    //     dataSend.via_controlled_price = Number(vm.viaControlled2) + (vm.viaControlled2 * (vm.dataToFill.passengerCount - 1));
                    //     vm.addViaControlledRound = 0;
                    // } else {
                    dataSend.via_controlled_price_return = Number(vm.viaControlled2);
                    vm.addViaControlledRound = 0;
                    // }
                }
            } else {
                vm.addViaControlledRound = 0;
            }
            if (vm.dataToFill.controllerWayTarifa == 1) {
                vm.viaControlled1 = 0;
                vm.viaControlled2 = 0;
            }
            if (vm.dataToFill.discounts.length) {
                if (vm.dataToFill.controllerWayTarifa == 1) {
                    console.log('>>>>>>>> vm.addViaControlled >>>>>>>>>', vm.addViaControlled);
                    dataSend.estimated_payment_cost = Math.round(vm.dataToFill.discounts[0].finalAmount + vm.addViaControlled);
                } else {
                    dataSend.estimated_payment_cost = Math.round(vm.dataToFill.discounts[0].finalAmount);
                }
            } else {
                dataSend.estimated_payment_cost = Math.round(vm.dataToFill.estimatedFare + Number(vm.viaControlled1));
                // dataSend.estimated_payment_cost_return = vm.dataToFill.Return_policy.estimatedFare +  Number(vm.dataToFill.viaControlled);
            }
            if (vm.return_flag == true) {
                if (vm.dataToFill.discounts.length) {
                    dataSend.route_id_return = vm.dataToFill.Return_policy.route_id;
                    dataSend.route_type_return = vm.dataToFill.Return_policy.route_type;
                    if (vm.dataToFill.controllerWayTarifa == 1) {
                        console.log('>>>>>>>> vm.addViaControlledRound >>>>>>>>>', vm.addViaControlledRound);
                        dataSend.estimated_payment_cost_return = Math.round(vm.dataToFill.discounts[0].roundFinalAmount + vm.addViaControlledRound);
                    } else {
                        dataSend.estimated_payment_cost_return = Math.round(vm.dataToFill.discounts[0].roundFinalAmount);
                    }
                } else {
                    dataSend.route_id_return = vm.dataToFill.Return_policy.route_id;
                    dataSend.route_type_return = vm.dataToFill.Return_policy.route_type;
                    dataSend.estimated_payment_cost_return = Math.round(vm.dataToFill.Return_policy.estimatedFare + Number(vm.viaControlled2));
                }
            }

            // if (vm.estimated_toll_price !== undefined && vm.dataToFill.route_type === 0) {
            if (vm.estimated_toll_price !== undefined) {
                dataSend.estimated_toll_price = vm.estimated_toll_price;
            }

            //if (vm.dataToFill.selectedServiceDetails.category == 0 && 
                 //vm.type_of_trip_Validate_Booking == 'P' && vm.dataToFill.contractIdSelectedQREnabled == 1 && vm.dataToFill.scheduledBooking == 1){
                //dataSend.booking_type = 2; //socofar - agrupado/exclusivo
            //}
            //else 
            if (vm.dataToFill.selectedServiceDetails.category == 0) { //exclusive
                dataSend.booking_type = 0; //Normal
            } else if (vm.dataToFill.selectedServiceDetails.category == 1) { //shared
                dataSend.booking_type = 1; //shared
            }
            //else if(vm.dataToFill.selectedServiceDetails.category == 2){ //Normal
            //    dataSend.booking_type = 0; //Normal
            //}
            dataSend.is_POS_booking = 0;
            dataSend.payment_status = 0;
            dataSend.created_by_admin = 1;
            dataSend.is_adjusted_discounted_amount = 0;
            dataSend.apply_charge_by_toll = vm.searchFixedVariablePayload.title.data.apply_charge_by_toll;
            dataSend.collect_estimated_tag = vm.searchFixedVariablePayload.title.data.collect_estimated_tag;
            if (vm.dataToFill.route_type === 0) {
                dataSend.apply_estimated_distance_variable_fare = vm.searchFixedVariablePayload.title.data.apply_estimated_distance_variable_fare;

            }

            if (vm.dataToFill.discounts.length) {
                if (vm.dataToFill.discounts[0].name == 'ROUND TRIP') {
                    dataSend.promo_type = 1;
                } else {
                    dataSend.promo_type = 0;
                    dataSend.promo_id = vm.dataToFill.discounts[0].name;

                }
                if (vm.dataToFill.discounts[0].promoType === 'adjustedPrice') {
                    dataSend.promo_type = 0;
                    dataSend.is_adjusted_discounted_amount = 1;
                }
                if(vm.dataToFill.discounts[0].tope_maximo){
                    dataSend.tope_maximo = vm.dataToFill.discounts[0].tope_maximo;
                    if( vm.dataToFill.discounts[0].value > dataSend.tope_maximo ){
                        vm.dataToFill.discounts[0].value = dataSend.tope_maximo;
                    }
                }
                dataSend.discount_type = Number(vm.dataToFill.discounts[0].discountType);
                dataSend.discount_amount = ((dataSend.is_adjusted_discounted_amount == 1) && (dataSend.is_wait_time_included == 0) && (dataSend.round_trip == 1)) ? Number(vm.dataToFill.discounts[0].discountTypeValue / 2) : Number(vm.dataToFill.discounts[0].discountTypeValue);
                dataSend.discount_code = vm.dataToFill.couponCode;
                dataSend.final_discount_amount = vm.dataToFill.discounts[0].value;
                dataSend.final_discount_amount_return = vm.dataToFill.discounts[0].returnValue;
            }
            if ((JSON.parse($cookies.get('adminType') || 0) == 1) && vm.isEmpDataChange)
                dataSend.is_emp_data = vm.isEmpDataChange; // TV-2378
            dataSend.factor_value = vm.dataToFill.factor_value;
            dataSend.factor_type = vm.dataToFill.factor_tipo;
            dataSend.factor_id = vm.dataToFill.factor_id;
            if(vm.dataToFill.roundTrip){
                dataSend.factor_return_value = vm.dataToFill.factor_return_value;
                dataSend.factor_return_type = vm.dataToFill.factor_return_tipo;
                dataSend.factor_return_id = vm.dataToFill.factor_return_id;
            }

            if(vm.routingBase && vm.routingBase.depot_id)
                dataSend.depot_id = vm.routingBase.depot_id;

            $log.log(dataSend);
            console.log(dataSend, "datasend");
            var promise = getBookings.createBooking(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    //console.log(payload, "payload = =======");
                    vm.loading = false;
                    if (payload.title.data.flag == 'pending_payment') {
                        vm.disableSubmitButton = false;
                        openPopPendingPayment(payload.title, $event);
                    } else {

                        if (vm.dataToFill.authRequired == '1' || vm.dataToFill.authRequired == 1) {
                            // bookingValidateCreationSuccess(payload, 'Auth', $event);
                            if (payload.title.status == 400 && payload.title.data.key == true) {
                                vm.disabledSubmitButton = true;
                                bookingValidateCreationSuccess(payload.title, 'NoAuth', $event);
                            } else {
                                if (payload.title.status == 400) {
                                    vm.disabledSubmitButton = true;
                                    errorMessageFactory.showErrorMessage(payload.title.message, 0);
                                } else if (payload.title.status == 201) {
                                    vm.disabledSubmitButton = true;
                                    errorMessageFactory.showErrorMessage(payload.title.message, 0);
                                } else {
                                    vm.disabledSubmitButton = true;
                                    bookingCreationSuccess(payload, 'Auth', $event);
                                }
                            }
                            //languageBasedErrorFactory.getProperErrorMessage('bookingSuccA',0,1)
                            //errorMessageFactory.sowErrorMessage('Booking created successfully.But the Reserve will remain pending until Authorized.',1);
                        } else {
                            if (payload.title.status == 400 && payload.title.data.key == true) {
                                vm.isEmpDataChange = false; // TV-2378
                                vm.disabledSubmitButton = true;
                                bookingValidateCreationSuccess(payload.title, 'NoAuth', $event);
                            } else {
                                if (payload.title.status == 400) {
                                    vm.disabledSubmitButton = true;
                                    errorMessageFactory.showErrorMessage(payload.title.message, 0);
                                } else if (payload.title.status == 201) {
                                    vm.disabledSubmitButton = true;
                                    errorMessageFactory.showErrorMessage(payload.title.message, 0);
                                } else {
                                    vm.disabledSubmitButton = true;
                                    vm.isEmpDataChange = false; // TV-2378
                                    bookingCreationSuccess(payload, 'NoAuth', $event);
                                }
                            }

                            //languageBasedErrorFactory.getProperErrorMessage('bookingSucc',0,1)
                            //errorMessageFactory.showErrorMessage('Booking created successfully.',1);
                        }
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    vm.disableSubmitButton = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        //=================open pop for pending payment=====================
        function openPopPendingPayment(data, $event) {
            vm.items = {};
            vm.items.data = data;

            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/openPopForPendingPayment.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                escapeToClose: false,
                controller: PendingPaymentController
            });

            function PendingPaymentController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };

                $scope.gotToPreviousBooking = function (items) {
                    $mdDialog.hide();
                    $state.go('layout.completedBookingsMain.completedBookingDetailsNew', {
                        id: items.data.data.job_id,
                        type: '2'
                    });
                }
            }
        }


        //=======================open pop up after booking creation============================
        function bookingValidateCreationSuccess(data, text, $event) {
            vm.items = {};
            vm.items.authPending = text == 'Auth' ? true : false;
            vm.items.tableData = data.data.jobs;
            vm.items.Template = data.data.pdf_data_resp;
            //console.log(vm.items.tableData, 'vm.items.tableData', data);

            vm.items.copied = false;
            vm.items.loading = false;
            // if (data.data.jobs.key == 0) {
            //     vm.items.singleBooking = true;
            // } else {
            //     vm.items.singleBooking = false;
            // }
            // if (data.data.jobs.key == 0 || data.data.jobs.key == 2) {
            //     vm.items.roundTrip = false;
            // } else {
            //     vm.items.roundTrip = true;
            // }

            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/validateBooking.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                escapeToClose: false,
                controller: CreateBookingSuccessController
            });


            function CreateBookingSuccessController($scope, $mdDialog, items, tmhDynamicLocale) {
                $scope.items = items;
                tmhDynamicLocale.set('es');
                var win = '';
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                    if (win) {
                        win.close();
                    }
                    // $timeout(function () {
                    $state.reload('layout.createBookingMain.createBooking');
                    // }, 0);x

                };
                $scope.cancelValidatePopUp = function () {
                    $mdDialog.hide();
                }


                $scope.openPdf = function (data) {
                    //console.log(data);
                    $log.log(data);
                    $scope.items.loading = true;
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.job_id = Number(data.job_id);
                    var promise = getBookings.makeCreateBookingPdfHeight(dataSend);
                    promise.then(function (payload) {
                        $log.log('sxdsads', payload);
                        document.getElementById('showPrint').innerHTML = payload.title.data.pdf_html;
                        vm.OpenLink = payload.title.data.pdf_html;
                        // //console.log("Puneet changes in html");
                        win = window.open('', "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=" + (screen.width) + ",height=" + (screen.height) + ",top=0,left=0");
                        $scope.items.loading = false;
                        $timeout(function () {
                            win.document.body.innerHTML = payload.title.data.pdf_html;
                            // $scope.getVoucherLink(data, payload.title.data);
                        }, 1000);
                    },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            $scope.items.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }

                $scope.getVoucherLink = function (data, pdfData) {
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.job_id = Number(data.job_id);
                    //dataSend.pdf_html = pdfData.pdf_html;
                    dataSend.height = $('#showPrint').height() + 200;
                    $scope.items.loading = true;
                    var promise = getBookings.makeCreateBookingPdf(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            $scope.items.loading = false;
                            if (win) {
                                win.close();
                            }
                            win = window.open(payload.title.data.pdfLink, "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=" + (screen.width) + ",height=" + (screen.height) + ",top=0,left=0");
                            win.document.body.innerHTML = '<iframe src="' + payload.title.data.pdfLink + '" height=' + screen.height + ' width=' + screen.width + '></ifrmae>';
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            $scope.items.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }

            }
        }




        //=======================open pop up after booking creation============================
        function bookingCreationSuccess(data, text, $event) {
            vm.items = {};
            vm.items.authPending = text == 'Auth' ? true : false;
            //console.log(data, "jshjkhkajhdsjkadhkdhaskjdhaskjdhkjasdhj");

            vm.items.tableData = data.title.jobs.data;
            vm.items.Template = data.title.pdf_data_resp;
            vm.items.copied = false;
            vm.items.loading = false;
            if (data.title.jobs.key == 0) {
                vm.items.singleBooking = true;
            } else {
                vm.items.singleBooking = false;
            }
            if (data.title.jobs.key == 0 || data.title.jobs.key == 2) {
                vm.items.roundTrip = false;
            } else {
                vm.items.roundTrip = true;
            }

            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/createBookingSuccess.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                escapeToClose: false,
                controller: CreateBookingSuccessController
            });

            function CreateBookingSuccessController($scope, $mdDialog, items, tmhDynamicLocale) {
                $scope.items = items;
                tmhDynamicLocale.set('es');
                var win = '';
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                    if (win) {
                        win.close();
                    }
                    // $timeout(function () {
                    $state.reload('layout.createBookingMain.createBooking');
                    // }, 0);

                };
                $scope.getIndex = function (index) {
                    $scope.copyTemplate(vm.items.Template[index]);

                }
                $scope.copyTemplate = function (data) {
                    vm.templateString = '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 ' +
                        '                Transitional//EN" ' +
                        '                "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">' +
                        '<html>' +
                        '' +
                        '<head>' +
                        '    <meta charset="UTF-8">' +
                        '    <meta name="viewport" content="width=device-width, ' +
                        '                initial-scale=1.0">' +
                        '    <title>Ride Over</title>' +
                        '' +
                        '    <style type="text/css">' +
                        '        .mainheader {' +
                        '            margin: 0 auto;' +
                        '            padding: 0 20px;' +
                        '            background-color: rgb(6, 60, 74);' +
                        '            width: 750px;' +
                        '        }' +
                        '' +
                        '        .mainLogoTd {' +
                        '            height: 80px;' +
                        '            border: none;' +
                        '        }' +
                        '' +
                        '        .tableStyle {' +
                        '            padding: 0 25px;' +
                        '            width: 100%;' +
                        '        }' +
                        '' +
                        '        .LeftTextWidth {' +
                        '            width: 70%;' +
                        '            padding-top: 15px;' +
                        '        }' +
                        '' +
                        '        .RightTextWidth {' +
                        '            width: 30%;' +
                        '            padding-top: 15px;' +
                        '        }' +
                        '' +
                        '        .LogotableStyle {' +
                        '            border: 0;' +
                        '            width: 100%;' +
                        '            text-align: center;' +
                        '            padding-top: 0;' +
                        '            padding-bottom: 0;' +
                        '        }' +
                        '' +
                        '        .padding30 {' +
                        '            padding-top: 30px;' +
                        '        }' +
                        '' +
                        '        .Hey-cutomer {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 22px;' +
                        '            font-weight: 500;' +
                        '            letter-spacing: 1px;' +
                        '            text-align: left;' +
                        '            color: #1f1f1f;' +
                        '        }' +
                        '' +
                        '        .Trip-Details {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 24px;' +
                        '            line-height: 1.4;' +
                        '            letter-spacing: 1px;' +
                        '            text-align: left;' +
                        '            font-weight: bold;' +
                        '            color: #242424;' +
                        '        }' +
                        '' +
                        '        .pickAddress {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 18px;' +
                        '            letter-spacing: 1.1px;' +
                        '            text-align: left;' +
                        '            color: #262626;' +
                        '        }' +
                        '' +
                        '        .You-Rode-with-James {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 18px;' +
                        '            font-weight: 600;' +
                        '            line-height: 1.4;' +
                        '            text-align: left;' +
                        '            color: #070707;' +
                        '        }' +
                        '' +
                        '        .LeftText {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 20px;' +
                        '            letter-spacing: 1.1px;' +
                        '            text-align: left;' +
                        '            color: #000000;' +
                        '        }' +
                        '' +
                        '        .RightText {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 20px;' +
                        '            font-weight: bold;' +
                        '            letter-spacing: 1.1px;' +
                        '            text-align: right;' +
                        '            color: #000000;' +
                        '        }' +
                        '' +
                        '        .Fare-Breakdown {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 18px;' +
                        '            font-weight: 600;' +
                        '            line-height: 1.4;' +
                        '            text-align: left;' +
                        '            color: #000000;' +
                        '        }' +
                        '' +
                        '        .TOTAL-FARE-Tk-880 {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 23px;' +
                        '            font-weight: bold;' +
                        '            line-height: .87;' +
                        '            text-align: right;' +
                        '            color: #a5a1ff;' +
                        '        }' +
                        '' +
                        '        .Fare-Details {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 18px;' +
                        '            line-height: .87;' +
                        '            color: #1f1f1f;' +
                        '        }' +
                        '' +
                        '        .straightLine {' +
                        '            padding-top: 20px;' +
                        '            border-bottom: 1px solid #b3b3b3;' +
                        '        }' +
                        '' +
                        '        .footerTable {' +
                        '            border: 0;' +
                        '            background-color: rgb(6, 60, 74);' +
                        '            width: 100%;' +
                        '        }' +
                        '' +
                        '        .Float-text {' +
                        '            float: right;' +
                        '        }' +
                        '' +
                        '        .Clear-all {' +
                        '            clear: both;' +
                        '        }' +
                        '' +
                        '        .Fair-full-details {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 17px;' +
                        '            line-height: .87;' +
                        '            text-align: right;' +
                        '            color: #1f1f1f;' +
                        '        }' +
                        '' +
                        '        .Visibilty {' +
                        '            visibility: hidden;' +
                        '        }' +
                        '' +
                        '        .Background-adjust {' +
                        '            background-color: lightgray;' +
                        '            padding: 5px;' +
                        '        }' +
                        '' +
                        '        .Total-Fair {' +
                        '            font-size: 35px;' +
                        '            font-weight: 600;' +
                        '            text-align: left;' +
                        '            padding-top: 5px;' +
                        '        }' +
                        '' +
                        '        .Total-Fair-1 {' +
                        '            font-size: 35px;' +
                        '            font-weight: 600;' +
                        '            text-align: right;' +
                        '            padding-top: 5px;' +
                        '        }' +
                        '' +
                        '        .Text-Align {' +
                        '            text-align: left;' +
                        '        }' +
                        '' +
                        '        .Text-Right {' +
                        '            text-align: right;' +
                        '        }' +
                        '' +
                        '        .Font-Size-Adjust {' +
                        '            font-size: 12px;' +
                        '        }' +
                        '' +
                        '        .Font-Size-Customer {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 22px;' +
                        '            line-height: .87;' +
                        '            text-align: left;' +
                        '            color: #1f1f1f;' +
                        '        }' +
                        '' +
                        '        .AddressDetails {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 22px;' +
                        '            line-height: .87;' +
                        '            text-align: left;' +
                        '            font-weight: bold;' +
                        '            color: #1f1f1f;' +
                        '        }' +
                        '' +
                        '        .padding10 {' +
                        '            padding-top: 10px;' +
                        '        }' +
                        '' +
                        '        .disance-Details {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 20px;' +
                        '            line-height: .87;' +
                        '            text-align: left;' +
                        '            color: #1f1f1f;' +
                        '        }' +
                        '' +
                        '        .Marker-image {' +
                        '            width: 30px;' +
                        '        }' +
                        '' +
                        '        .Tarifa-text {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 22px;' +
                        '            line-height: .87;' +
                        '            text-align: left;' +
                        '            font-weight: bold;' +
                        '            color: #1f1f1f;' +
                        '        }' +
                        '' +
                        '        .ObservationText {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 14px;' +
                        '            line-height: .87;' +
                        '            text-align: left;' +
                        '            color: #1f1f1f;' +
                        '            border: 2px solid #1f1f1f;' +
                        '        }' +
                        '' +
                        '        .bottomtext {' +
                        '            font-family: sans-serif;' +
                        '            font-size: 15px;' +
                        '            line-height: .87;' +
                        '            text-align: left;' +
                        '            color: #1f1f1f;' +
                        '        }' +
                        '' +
                        '        .footerImage {' +
                        '            display: block;' +
                        '            margin: 0 auto;' +
                        '        }' +
                        '' +
                        '        .footerImageText {' +
                        '            color: #FFFFFF;' +
                        '            margin-top: 7px;' +
                        '            text-align: center;' +
                        '        }' +
                        '' +
                        '        .tableStyleWithoutPadding {' +
                        '            width: 100%;' +
                        '        }' +
                        '' +
                        '        pre {' +
                        '            font-family: sans-serif;' +
                        '            padding: 4px;' +
                        '            margin: 4px;' +
                        '        }' +
                        '' +
                        '        .createdText {' +
                        '            color: orange;' +
                        '            font-size: 18px;' +
                        '        }' +
                        '' +
                        '        .heading {' +
                        '            color: black;' +
                        '            font-weight: bold;' +
                        '            padding-left: 20px;' +
                        '            font-size: 18px;' +
                        '        }' +
                        '' +
                        '        .vip {' +
                        '            float: right;' +
                        '            color: red;' +
                        '            font-weight: bold;' +
                        '            font-size: 16px;' +
                        '            padding-right: 30px;' +
                        '            padding-bottom: 20px;' +
                        '        }' +
                        '' +
                        '        .headingRight {' +
                        '            float: right;' +
                        '            color: black;' +
                        '            /* font-weight: bold; */' +
                        '            font-size: 18px;' +
                        '            padding-right: 50px;' +
                        '            padding: 8px 20px 8px 0px;' +
                        '            min-height: 16px;' +
                        '        }' +
                        '    </style>' +
                        '</head>' +
                        '' +
                        '<body>' +
                        '    <table style=" margin: 0 auto;padding: 20px 20px; background-color: rgb(6, 60, 74);width: 600px;">' +
                        '        <tbody>' +
                        '            <tr style="background-color:#fff;color:#FFFFFF;">' +
                        '                <td style="padding:10px">' +
                        '                    <table style="border:0;width:100%;">' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold;font-size: 16px;">' +
                        '                                Reserva:' +
                        '                            </td>' +
                        '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.job_id}}' +
                        '' + '                       <td style="color: red;font-weight: bold;font-size: 14px;padding-right: 30px;">' +
                        '                                {{vip}}' +
                        '                            </td>' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr  style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold;font-size: 16px;">' +
                        '                                Nombre:' +
                        '                            </td>' +
                        '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.customer_username}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold; font-size: 16px;">' +
                        '                                Telefono:' +
                        '                            </td>' +
                        '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.customer_phone}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold; font-size: 16px;">' +
                        '                                Correo:' +
                        '                            </td>' +
                        '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.customer_email}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold; font-size: 16px;">' +
                        '                                Origen:' +
                        '                            </td>' +
                        '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.job_pickup_address}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold; font-size: 16px;width:200px">' +
                        '                                Fecha Retiro:' +
                        '                            </td>' +
                        '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.date}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold;font-size: 16px;width:200px">' +
                        '                                Hora retiro:' +
                        '                            </td>' +
                        '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.time}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold; font-size: 16px;">' +
                        '                                Destino:' +
                        '                            </td>' +
                        '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.job_address}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold; font-size: 16px;width:200px">' +
                        '                                Tipo Servicio:' +
                        '                            </td>' +
                        '                            <td style="color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.service_name}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold;font-size: 16px;width:200px">' +
                        '                                Num. Pasajeros:' +
                        '                            </td>' +
                        '                            <td style="color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.number_of_passangers}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold; font-size: 16px;">' +
                        '                                Estado:' +
                        '                            </td>' +
                        '                            <td style="color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.Estado}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold; font-size: 16px;">' +
                        '                                Convenio:' +
                        '                            </td>' +
                        '                            <td style="color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.contract_name}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                        <tr style= "font-style:normal;line-height:15px">' +
                        '                            <td style="color: black;font-weight: bold;font-size: 16px;width:200px">' +
                        '                                Tarifa estimada:' +
                        '                            </td>' +
                        '                            <td style="color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                        '                                {{vm.bookingDetails.estimated_payment_cost}} / {{vm.bookingDetails.fare}}' +
                        '                            </td>' +
                        '                        </tr>' +
                        '                    </table>' +
                        '' +
                        '                </td>' +
                        '            </tr>' +
                        '        </tbody>' +
                        '    </table>' +
                        '</body>' +
                        '' +
                        '</html>';
                    vm.string = vm.templateString;
                    if (data.payment_status == 1 || data.payment_status == 1) {
                        vm.string = vm.string.replace('{{vm.bookingDetails.Estado}}', 'PAGADA');
                    } else {
                        vm.string = vm.string.replace('{{vm.bookingDetails.Estado}}', 'NO PAGADA');
                    }
                    if (data.job_time_utc) {
                        var time = moment(new Date(data.job_time_utc)).format('HH:mm')
                        vm.string = vm.string.replace('{{vm.bookingDetails.time}}', time);
                    }
                    if (data.job_time_utc) {


                        var date = moment(data.job_time_utc).format('MMMM DD YYYY')
                        console.log(date, "date");
                        vm.string = vm.string.replace('{{vm.bookingDetails.date}}', date);
                    }
                    if (data.route_type == 1) {
                        vm.string = vm.string.replace('{{vm.bookingDetails.fare}}', 'FIJA');
                    } else {
                        vm.string = vm.string.replace('{{vm.bookingDetails.fare}}', 'Variable');
                    }
                    if (data.is_vip && data.is_vip == 1) {
                        vm.string = vm.string.replace('{{vip}}', 'VIP');
                    } else {
                        vm.string = vm.string.replace('{{vip}}', '')
                    }

                    function numberWithCommas(x) {
                        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                    };
                    vm.string = vm.string.replace('{{vm.bookingDetails.job_id}}', JSON.stringify(data.job_id));
                    vm.string = vm.string.replace('{{vm.bookingDetails.customer_phone}}', data.customer_phone);
                    vm.string = vm.string.replace('{{vm.bookingDetails.customer_username}}', data.customer_username);
                    vm.string = vm.string.replace('{{vm.bookingDetails.job_pickup_address}}', data.job_pickup_address);
                    vm.string = vm.string.replace('{{vm.bookingDetails.customer_email}}', data.customer_email);
                    vm.string = vm.string.replace('{{vm.bookingDetails.job_address}}', data.job_address);
                    vm.string = vm.string.replace('{{vm.bookingDetails.service_name}}', data.service_name);
                    vm.string = vm.string.replace('{{vm.bookingDetails.contract_name}}', data.contract_name);
                    vm.string = vm.string.replace('{{vm.bookingDetails.number_of_passangers}}', data.number_of_passangers);
                    vm.string = vm.string.replace('{{vm.bookingDetails.estimated_payment_cost}}', '$' + numberWithCommas(data.estimated_payment_cost));
                    console.log(vm.string, "string");

                    document.getElementById('copy').value = vm.string;
                    var copyText = document.getElementById('copy');
                    console.log(document.getElementById("copy"));
                    copyText.select();
                    document.execCommand("copy");
                    if (document.execCommand('copy') == true) {
                        $scope.items.copied = true;
                        $timeout(function () {
                            $scope.items.copied = false;
                        }, 2000);
                    }

                }
                $scope.copyText = function (data) {
                    var el = document.getElementById('copyData')
                    var body = document.body,
                        range, sel;
                    if (document.createRange && window.getSelection) {
                        range = document.createRange();
                        sel = window.getSelection();
                        sel.removeAllRanges();
                        try {
                            range.selectNodeContents(el);
                            sel.addRange(range);
                            document.execCommand("Copy");
                        } catch (e) {
                            range.selectNode(el);
                            sel.addRange(range);
                            document.execCommand("Copy");
                        }
                    } else if (body.createTextRange) {
                        range = body.createTextRange();
                        range.moveToElementText(el);
                        range.select();
                        document.execCommand("Copy");
                    }

                    $scope.items.copied = true;
                    $timeout(function () {
                        $scope.items.copied = false;
                    }, 2000);
                };

                $scope.openPdf = function (data) {
                    //console.log(data);
                    $log.log(data);
                    $scope.items.loading = true;
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.job_id = Number(data.job_id);
                    var promise = getBookings.makeCreateBookingPdfHeight(dataSend);
                    promise.then(function (payload) {
                        $log.log('sxdsads', payload);
                        document.getElementById('showPrint').innerHTML = payload.title.data.pdf_html;
                        vm.OpenLink = payload.title.data.pdf_html;
                        win = window.open('', "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=" + (screen.width) + ",height=" + (screen.height) + ",top=0,left=0");
                        $scope.items.loading = false;
                        $timeout(function () {
                            win.document.body.innerHTML = payload.title.data.pdf_html;
                            //  $scope.getVoucherLink(data, payload.title.data);
                        }, 1000);
                    },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            $scope.items.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }

                $scope.getVoucherLink = function (data, pdfData) {
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.job_id = Number(data.job_id);
                    //dataSend.pdf_html = pdfData.pdf_html;
                    dataSend.height = $('#showPrint').height() + 200;
                    $scope.items.loading = true;
                    var promise = getBookings.makeCreateBookingPdf(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            $scope.items.loading = false;
                            if (win) {
                                win.close();
                            }
                            win = window.open(payload.title.data.pdfLink, "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=" + (screen.width) + ",height=" + (screen.height) + ",top=0,left=0");
                            win.document.body.innerHTML = '<iframe src="' + payload.title.data.pdfLink + '" height=' + screen.height + ' width=' + screen.width + '></ifrmae>';
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            $scope.items.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }

            }
        }
        //====================edit booking api=======================
        function editBookingApi($event, arrayFDatesMade) {
            if(vm.routingBase && vm.routingBase.routing_base_id > 0) {
                vm.dataToFill.selectedServiceDetails.category = 0;
                vm.method_range_pickup = 0;
            }
            if (vm.errorFlagForDate == true) {
                return;
            }
            if (vm.bookingError == true) {
                errorMessageFactory.showErrorMessage('Error al calcular el Retiro. Error en la llamada a la API', 0);
                return;
            }
            if (vm.errorFlagForDate == true || (vm.dataToFill.passengerCount == 0 || vm.dataToFill.passengerCount == null || vm.dataToFill.passengerCount == undefined) || vm.ErrorFlagForNewApi) {
                return;
            }
            vm.currentTime = new Date();
            // if (vm.dataToFill.dropDate == 'Invalid Date' && vm.dataToFill.dropTime == 'Invalid Date') {
            //     vm.dataToFill.dropDate = new Date();
            //     vm.dataToFill.dropTime = new Date();
            // }
            // //console.log(moment(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime)),'dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime)');
            if (new Date(vm.dataToFill.scheduledDate) != 'Invalid Date' && new Date(vm.dataToFill.scheduledTime) != 'Invalid Date') {
                vm.currentBookingSchudule = dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime);
            } else {
                vm.currentBookingSchudule = new Date();
            }
            if (new Date(vm.dataToFill.dropDate) != 'Invalid Date' && new Date(vm.dataToFill.dropDate) != 'Invalid Date') {
                vm.claenderTime = dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropDate);
            } else {
                vm.claenderTime = new Date();
            }
            // vm.claenderTime = moment(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime)).subtract(vm.etaSeconds, 'seconds');
            vm.timeFlight = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            vm.currentTimeFlight = new Date(dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value));
            vm.checkFlag = moment(vm.timeFlight).isAfter(vm.claenderTime);

            vm.currentCheckFlag = moment(vm.currentTimeFlight).isAfter(vm.currentTime);
            vm.checkFlagCurrentBookingSchudule = moment(vm.currentTimeFlight).isAfter(vm.currentBookingSchudule);

            //console.log(vm.currentTimeFlight, vm.currentBookingSchudule, 'claenderTime');
            // Tv-2176 
            // if (vm.type_of_trip1 == 'R' && vm.checkFlag == false && vm.flagForFlightDate == true && vm.type_of_trip1 != 'P') {
            //     languageBasedErrorFactory.getProperErrorMessage('greaterCheck', 0, 0)
            //     vm.disableSubmitButton = false;
            //     return false;
            // }
            // if (vm.currentCheckFlag == false && vm.flagForFlightDate == true && vm.type_of_trip1 != 'P') {
            //     languageBasedErrorFactory.getProperErrorMessage('greaterCheck', 0, 0)
            //     vm.disableSubmitButton = false;
            //     return false;
            // }
            // if (vm.checkFlagCurrentBookingSchudule == false && vm.flagForFlightDate == true && vm.type_of_trip1 != 'P') {
            //     languageBasedErrorFactory.getProperErrorMessage('greaterCheck', 0, 0)
            //     vm.disableSubmitButton = false;
            //     return false;
            // }
            $log.log(vm.dataToFill);
            $log.log(vm.daysList);
            var dataSend = {};
            dataSend.time = [];
            dataSend.reaccurringTimeZone = [];
            var tz = moment.tz.guess();
            dataSend.access_token = $cookies.get('obj');
            dataSend.booking_id = vm.dataToFill.bookingId;
            dataSend.customer_email = vm.dataToFill.customerEmail;
            dataSend.customer_phone_number = vm.dataToFill.customerMobileG;
            dataSend.profile = Number(vm.dataToFill.customerProfile);
            dataSend.number_of_passangers = Number(vm.dataToFill.passengerCount);
            dataSend.timezone = new Date().getTimezoneOffset();
            dataSend.booking_for = Number(vm.dataToFill.bookingFor);
            ///////////////////////////TV-1795 //////////////////////////
            // if (vm.dataToFill.controllerWayTarifa == 1) {
            //     vm.viaControlled1 = 0;
            //     vm.viaControlled2 = 0;
            // }
            if (vm.dataToFill.bookingFor == 1) {
                dataSend.full_name = vm.dataToFill.personName;
                dataSend.phone_number = vm.dataToFill.personMobile;
                dataSend.email = vm.dataToFill.personEmail;
                if (vm.dataToFill.passengerId != null)
                    dataSend.passenger_id = vm.dataToFill.passengerId;
            }
            dataSend.pickup_location = vm.dataToFill.pickUpAddress;
            dataSend.job_pickup_comuna = vm.jobPickupComuna || null; // Send CITY of PICKUP ADDRESS
            dataSend.drop_location = vm.dataToFill.dropOffAddress;
            dataSend.job_dropoff_comuna = vm.jobDropoffComuna || null; // Send CITY of DROPOFF ADDRESS
            dataSend.pickup_lat = vm.dataToFill.pickUpLat;
            dataSend.pickup_long = vm.dataToFill.pickUpLng;
            dataSend.drop_lat = vm.dataToFill.dropOffLat;
            dataSend.drop_long = vm.dataToFill.dropOffLng;
            dataSend.transport_type_id = Number(vm.dataToFill.carType);
            dataSend.observations = vm.dataToFill.observations;
            //if (vm.dataToFill.bookingType == '1') {
            //    dataSend.schedule_ride = 1;
            //    dataSend.time.push(dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime).toISOString());
            //} else if (vm.dataToFill.bookingType == '0') {
            //    dataSend.schedule_ride = 0;
            //}
            var isAirportFlag = 0;
            if (vm.fromAirportFlag) {
                isAirportFlag = 1;
            } else if (vm.toAirportFlag) {
                isAirportFlag = 2;
            }
            dataSend.airport = Number(isAirportFlag);
            if (vm.checkBoxCheck) {
                dataSend.sin_respaldo = vm.checkBoxValueIs ? 1 : 0;
            }
            if ((vm.dataToFill.bookingType == '1' && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2)) && !vm.routingBase) {
                dataSend.schedule_ride = 1;
                console.log(dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime), 'datetTime');
                dataSend.timezone = moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime).toISOString()));
                dataSend.reaccurringTimeZone.push(moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime).toISOString())));
                // dataSend.timezone = new Date(dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime).toISOString()).getTimezoneOffset();
                dataSend.time.push(dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime).toISOString());
            } else if ((vm.dataToFill.bookingType == '1' && ((vm.dataToFill.selectedServiceDetails.category == 1) || (vm.routingBase && vm.routingBase.routing_base_id > 0)))) {
                dataSend.schedule_ride = 1;
                dataSend.timezone = moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString()));
                dataSend.reaccurringTimeZone.push(moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString())));
                // dataSend.timezone = new Date(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString()).getTimezoneOffset();
                dataSend.time.push(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString());
            } else if (vm.dataToFill.bookingType == '0' && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2) && vm.type_of_trip_Validate_Booking != 'R') {
                dataSend.schedule_ride = 0;
            } else if (vm.dataToFill.bookingType == '0' && vm.dataToFill.selectedServiceDetails.category == 1) {
                dataSend.schedule_ride = 0;
                dataSend.timezone = moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString()));
                dataSend.reaccurringTimeZone.push(moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString())));
                // dataSend.timezone = new Date(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString()).getTimezoneOffset();
                dataSend.time.push(dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime).toISOString());
            }
            if ((vm.type_of_trip1 == 'R' && vm.dataToFill.selectedServiceDetails.category == 1 && vm.method_range_pickup) || (vm.routingBase && vm.routingBase.routing_base_id > 0)) {
                dataSend.is_routing = 1;
                dataSend.time_pickup_array = (vm.pickRangeSendForRouting);
                dataSend.reaccurringTimeZone = vm.timeZoneRecurring;
                dataSend.pickup_top_range = vm.pickup_top_range;
                dataSend.pickup_lower_range = vm.pickup_lower_range;
                dataSend.travel_distance_route = vm.distanceRoutingApi;
            }
            // if (vm.type_of_trip == 'R' && vm.dataToFill.selectedServiceDetails.category == 1 && vm.method_range_pickup_return && vm.dataToFill.roundTrip == 1) {
            //     dataSend.is_routing = 1;
            //     dataSend.time_pickup_return_route = (vm.pickRangeSendForRoutingReturn);
            //     dataSend.returnTimeZone = vm.timeZoneRRoundReturn;
            //     dataSend.pickup_top_range_return = vm.pickup_lower_range_return;
            //     dataSend.pickup_lower_range_return = vm.pickup_top_range_return;
            // }
            // else if (vm.dataToFill.bookingType == '1' && vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking == 'R') {
            //     dataSend.schedule_ride = 1;
            //     dataSend.timezone = new Date(dateTimeFormat(vm.dataToFill.dropDateOfRType, vm.dataToFill.dropTimeOfRtype).toISOString()).getTimezoneOffset();
            //     dataSend.time.push(dateTimeFormat(vm.dataToFill.dropDateOfRType, vm.dataToFill.dropTimeOfRtype).toISOString());
            // }
            else if (vm.dataToFill.bookingType == '0' && vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking == 'R') {
                dataSend.schedule_ride = 0;
            }
            if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking == 'P') {
                dataSend.pickup_tolerance_time_pap = vm.time_trip_shared_service_point_to_point;
                dataSend.pickup_travel_time_pap = vm.pickup_travel_time_pap;
            }
            if (vm.heremaps_toll_details && vm.toll_id) {
                // if (vm.heremaps_toll_details && vm.dataToFill.route_type === 0) {
                dataSend.heremaps_toll_details = JSON.stringify(vm.heremaps_toll_details.heremaps_response['detail-cost']);
                dataSend.heremaps_estimated_tolls = vm.tollCount;
                dataSend.item_of_charge_tolls_price = vm.toll_price || 0;
            }
            dataSend.round_trip = Number(vm.dataToFill.roundTrip);
            if (vm.dataToFill.roundTrip) {
                // if (vm.estimated_toll_price_return !== undefined && vm.dataToFill.Return_policy.route_type === 0) {
                if (vm.estimated_toll_price_return !== undefined) {
                    dataSend.estimated_toll_price_return = vm.estimated_toll_price_return;
                }
                // if (vm.heremaps_toll_details_return && vm.dataToFill.route_type === 0) {
                if (vm.heremaps_toll_details_return) {
                    dataSend.heremaps_toll_details_return = JSON.stringify(vm.heremaps_toll_details_return.heremaps_response['detail-cost']);
                }
                if (vm.bookingDetails.heremaps_estimated_tolls_return !== undefined || vm.bookingDetails.heremaps_estimated_tolls_return !== null || vm.bookingDetails.heremaps_estimated_tolls_return !== '') {
                    dataSend.heremaps_estimated_tolls_return = vm.bookingDetails.heremaps_estimated_tolls_return;
                }
                if (vm.bookingDetails.item_of_charge_toll_price_return !== undefined || vm.bookingDetails.item_of_charge_toll_price_return !== null || vm.bookingDetails.item_of_charge_toll_price_return !== '')
                    dataSend.item_of_charge_tolls_price_return = vm.bookingDetails.item_of_charge_toll_price_return || 0;
            }
            // if (vm.heremaps_toll_details && vm.dataToFill.route_type === 0) {
            // if (vm.heremaps_toll_details) {
            //     dataSend.heremaps_toll_details = JSON.stringify(vm.heremaps_toll_details.heremaps_response['detail-cost']);
            // }
            // if (vm.bookingDetails.heremaps_estimated_tolls !== undefined || vm.bookingDetails.heremaps_estimated_tolls !== null || vm.bookingDetails.heremaps_estimated_tolls !== '') {
            //     dataSend.heremaps_estimated_tolls = vm.bookingDetails.heremaps_estimated_tolls;
            // }
            // if (vm.bookingDetails.item_of_charge_toll_price !== undefined || vm.bookingDetails.item_of_charge_toll_price !== null || vm.bookingDetails.item_of_charge_toll_price !== '')
            //     dataSend.item_of_charge_tolls_price = vm.bookingDetails.item_of_charge_toll_price || 0;

            console.log(vm.dataToFill.roundTrip, !vm.dataToFill.is_wait_time_included, new Date(vm.dataToFill.returnDate), "gashdsdgsbdsd")
            // && new Date(vm.bookingDetails.return_date_time_utc) != 'Invalid Date'
            if ((new Date(vm.dataToFill.returnDate) != 'Invalid Date') && (vm.dataToFill.roundTrip && !vm.dataToFill.is_wait_time_included && vm.dataToFill.selectedServiceDetails.category != 1) || (vm.dataToFill.selectedServiceDetails.category == 1 && vm.type_of_trip != 'R')) {
                dataSend.returnTimeZone = moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.returnDate, vm.dataToFill.returnTime).toISOString()));
                dataSend.return_date_time = dateTimeFormat(vm.dataToFill.returnDate, vm.dataToFill.returnTime).toISOString();
            } else if ((vm.dataToFill.roundTrip && !vm.dataToFill.is_wait_time_included && vm.dataToFill.selectedServiceDetails.category == 1) || (vm.dataToFill.selectedServiceDetails.category == 1 && vm.type_of_trip != 'R')) {
                dataSend.returnTimeZone = moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.dropDateReturn, vm.dataToFill.dropTimeReturn).toISOString()));
                dataSend.return_date_time = dateTimeFormat(vm.dataToFill.dropDateReturn, vm.dataToFill.dropTimeReturn).toISOString();
            } else if (vm.bookingDetails.is_POS_booking != 1) {
                dataSend.returnTimeZone = moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.returnDate, vm.dataToFill.returnTime).toISOString()));
                dataSend.return_date_time = dateTimeFormat(vm.dataToFill.returnDate, vm.dataToFill.returnTime).toISOString();
            }
            // if ((vm.dataToFill.roundTrip && !vm.dataToFill.is_wait_time_included && vm.dataToFill.selectedServiceDetails.category != 1) || (vm.dataToFill.selectedServiceDetails.category ==1 &&  vm.type_of_trip != 'R')) {
            //     dataSend.return_date_time = dateTimeFormat(vm.dataToFill.returnDate, vm.dataToFill.returnTime).toISOString();
            // }else if((vm.dataToFill.roundTrip && !vm.dataToFill.is_wait_time_included && vm.dataToFill.selectedServiceDetails.category == 1) || (vm.dataToFill.selectedServiceDetails.category ==1 &&  vm.type_of_trip != 'R')){
            //     dataSend.return_date_time = dateTimeFormat(vm.dataToFill.dropDateReturn, vm.dataToFill.dropTimeReturn).toISOString();
            // }
            // else if(vm.bookingDetails.is_POS_booking == 1 && vm.bookingDetails.return_date_time_utc == '0000-00-00 00:00:00'){
            //     dataSend.return_date_time = dateTimeFormat(vm.dataToFill.returnDate, vm.dataToFill.returnTime).toISOString();
            // }
            dataSend.reaccurring = Number(vm.dataToFill.reaccurringBooking);
            if (vm.dataToFill.reaccurringBooking == '1') {
                if (arrayFDatesMade.length != 0) {
                    for (var i = 0; i < arrayFDatesMade.length; i++) {
                        dataSend.reaccurringTimeZone.push(moment.tz.zone(tz).utcOffset(moment(arrayFDatesMade[i])));
                        dataSend.time.push(arrayFDatesMade[i]);
                    }
                } else {
                    dataSend.reaccurringTimeZone.push(moment.tz.zone(tz).utcOffset(moment(dateTimeFormat(vm.dataToFill.dropDateReturn, vm.dataToFill.dropTimeReturn).toISOString())));
                }
            } else {
                dataSend.reaccurringTimeZone = []; // TV-3659 change in parent booking timezone is not consider by backend in case of recurring 
            }
            if (vm.dataToFill.reference_point) {
                dataSend.reference_point = vm.dataToFill.reference_point;
            }
            if (vm.dataToFill.corporate_account_id && (vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == '1')) {
                dataSend.corporate_account_id = vm.dataToFill.corporate_account_id;
            }
            dataSend.route_id = vm.dataToFill.route_id;
            console.log(vm.dataToFill.route_type, 'vm.dataToFill.route_type');

            dataSend.route_type = vm.dataToFill.route_type;
            dataSend.type_of_agreement = vm.dataToFill.type_of_agreement;
            if (vm.dataToFill.type_of_agreement == 1) // THIRD PERSON BOOKING IS VIP OR NOT IN CORPORATE AGGREMENT
                dataSend.isVIP_someone = vm.is_vip ? 1 : 0;
            dataSend.is_wait_time_included = vm.dataToFill.is_wait_time_included ? 1 : 0;
            // if (vm.getInfoFlag == true) {
            //     dataSend.contract_id = vm.bookingDetails.contract_id
            // } else {
            //     dataSend.contract_id = vm.dataToFill.contractIdSelected;
            // }
            dataSend.contract_id = vm.dataToFill.contractIdSelected;
            dataSend.service_type = Number(vm.dataToFill.serviceTypeSelected);

            if (vm.dataToFill.authRequired == '1' && (vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == '1')) {
                dataSend.auth_required = Number(vm.dataToFill.authRequired);
                dataSend.auth_of = RutHelper.clean(vm.dataToFill.authRUT);
            }

            if (vm.dataToFill.itemOfChargeSelected.length) {
                vm.dataToFill.item_of_charges = [];
                vm.dataToFill.is_item_of_charges = 1;
                for (var i = 0; i < vm.dataToFill.itemOfChargeSelected.length; i++) {
                    vm.dataToFill.item_of_charges.push({
                        "fixed_pricing_id": vm.dataToFill.itemOfChargeSelected[i].fixed_pricing_id ? vm.dataToFill.itemOfChargeSelected[i].fixed_pricing_id : vm.dataToFill.itemOfChargeSelected[i].variable_pricing_id,
                        "id": vm.dataToFill.itemOfChargeSelected[i].tic_id,
                        "item_of_charge_id": vm.dataToFill.itemOfChargeSelected[i].id,
                        "description": vm.dataToFill.itemOfChargeSelected[i].tic_description,
                        "long_name": vm.dataToFill.itemOfChargeSelected[i].tic_long_name,
                        "manually": vm.dataToFill.itemOfChargeSelected[i].tic_manually,
                        "price": vm.dataToFill.itemOfChargeSelected[i].price,
                        "short_name": vm.dataToFill.itemOfChargeSelected[i].tic_short_name,
                        "quantity": vm.dataToFill.itemOfChargeSelected[i].quantity,
                        "retorno": vm.dataToFill.itemOfChargeSelected[i].retorno
                    })
                }
                dataSend.is_item_of_charges = Number(vm.dataToFill.is_item_of_charges);
                var items_ida = vm.dataToFill.item_of_charges.filter(function(itm){ return itm.retorno == false })
                var items_vuelta = vm.dataToFill.item_of_charges.filter(function(itm){ return itm.retorno == true })
                dataSend.item_of_charges = items_ida;
                dataSend.item_of_charges_return = items_vuelta;
            } else {
                dataSend.is_item_of_charges = 0;
            }
            if (vm.dataToFill.nearDriver)
                dataSend.favourite_driver_id = Number(vm.dataToFill.nearDriver);

            dataSend.payment_method = vm.dataToFill.payment_method ? vm.dataToFill.payment_method : vm.bookingDetails.payment_method;

            if (vm.dataToFill.passengerRutCheck == 1)
                dataSend.passenger_rut = RutHelper.clean(vm.dataToFill.passengerRut);
            if (vm.dataToFill.applicantRutCheck == 1)
                dataSend.applicant_rut = RutHelper.clean(vm.dataToFill.applicantRut);
            if (vm.dataToFill.costCenterCheck == 1)
                dataSend.cost_center = vm.dataToFill.costCenter;
            if (vm.dataToFill.costSubCenterCheck == 1)
                dataSend.sub_cost_center = vm.dataToFill.costSubCenter;
            if (vm.dataToFill.RolCheck == 1)
                dataSend.rol = vm.dataToFill.Rol;
            if (vm.dataToFill.graphCheck == 1)
                dataSend.graph = vm.dataToFill.graph;
            if (vm.dataToFill.workOrderCheck == 1)
                dataSend.work_order = vm.dataToFill.workOrder;
            if (vm.dataToFill.pepCheck == 1)
                dataSend.PEP = vm.dataToFill.pep;
            if (vm.dataToFill.purposeOfTripCheck == 1)
                dataSend.purpose_of_trip = vm.dataToFill.purposeOfTrip;
            if (vm.dataToFill.noOfVoucherCheck == 1)
                dataSend.number_of_voucher = vm.dataToFill.noOfVoucher;
            if (vm.dataToFill.nominaCheck == 1)
                dataSend.nomina = vm.dataToFill.nomina;
            if (vm.dataToFill.solictudCheck == 1)
                dataSend.solicitud = vm.dataToFill.solictud;
            //console.log(vm.dataToFill.pepCheck, 'pepCheck');
            if (vm.viaControlledFLag1 == true && vm.type_of_trip1 == 'Z') {
                if (vm.dataToFill.controllerWayTarifa == 1) {
                    dataSend.via_controlled_price = Number(vm.viaControlled1);
                    vm.addViaControlled = 0;
                } else {
                    dataSend.via_controlled_price = Number(vm.viaControlled1);
                    vm.addViaControlled = Number(vm.viaControlled1);
                }
            } else {
                vm.addViaControlled = 0;
            }
            // if (vm.viaControlledFLag == true && vm.dataToFill.roundTrip == true) {
            //     dataSend.via_controlled_price_return = Number(vm.viaControlled2);
            //     vm.addViaControlledRound = Number(vm.viaControlled2);
            // } else {
            //     vm.addViaControlledRound = 0;
            // }
            if (vm.viaControlledFLag == true && vm.dataToFill.roundTrip == true) {
                if (vm.dataToFill.controllerWayTarifa == 1) {
                    // if (vm.dataToFill.selectedServiceDetails.fare_type == 1) {
                    //     dataSend.via_controlled_price = Number(vm.viaControlled2) + (vm.viaControlled2 * (vm.dataToFill.passengerCount - 1));
                    //     vm.addViaControlledRound = 0;
                    // } else {
                    dataSend.via_controlled_price_return = Number(vm.viaControlled2);
                    vm.addViaControlledRound = 0;
                    // }
                } else {
                    // if (vm.dataToFill.selectedServiceDetails.fare_type == 1) {
                    //     dataSend.via_controlled_price = Number(vm.viaControlled2) + (vm.viaControlled2 * (vm.dataToFill.passengerCount - 1));
                    //     vm.addViaControlledRound = 0;
                    // } else {
                    dataSend.via_controlled_price_return = Number(vm.viaControlled2);
                    vm.addViaControlledRound = 0;
                    // }
                }
            } else {
                vm.addViaControlledRound = 0;
            }
            if (vm.dataToFill.controllerWayTarifa == 1) {
                vm.viaControlled1 = 0;
                vm.viaControlled2 = 0;
            }
            if (vm.dataToFill.discounts.length) {
                console.log('>>>>>>>>. DISCOUNT >>>>>>>>', vm.dataToFill.discounts);
                if (vm.dataToFill.controllerWayTarifa == 1) {
                    dataSend.estimated_payment_cost = Math.round(vm.dataToFill.discounts[0].finalAmount + vm.addViaControlled);
                } else {
                    dataSend.estimated_payment_cost = Math.round(vm.dataToFill.discounts[0].finalAmount);
                }
            } else if (vm.addressChange == true) {
                dataSend.estimated_payment_cost = Math.round(vm.dataToFill.estimatedFare + Number(vm.viaControlled1));
            }
            if (vm.addressChange == false) {
                dataSend.estimated_payment_cost = Math.round(vm.bookingDetails.estimated_payment_cost);
            }
            console.log('>>>>>>>>> vm.return_flag >>>>>>>', vm.return_flag);
            if (vm.return_flag == true) {
                if (vm.dataToFill.discounts.length) {
                    dataSend.route_id_return = vm.dataToFill.Return_policy.route_id;
                    dataSend.route_type_return = vm.dataToFill.Return_policy.route_type;
                    if (vm.dataToFill.controllerWayTarifa == 1) {
                        console.log("dkhakdhakhdkashdaskhd", vm.dataToFill.discounts[0].roundFinalAmount, vm.addViaControlledRound);

                        dataSend.estimated_payment_cost_return = Math.round(vm.dataToFill.discounts[0].roundFinalAmount + vm.addViaControlledRound);
                    } else {
                        dataSend.estimated_payment_cost_return = Math.round(vm.dataToFill.discounts[0].roundFinalAmount);
                    }
                } else {
                    dataSend.route_id_return = vm.dataToFill.Return_policy.route_id;
                    dataSend.route_type_return = vm.dataToFill.Return_policy.route_type;
                    dataSend.estimated_payment_cost_return = Math.round(vm.dataToFill.Return_policy.estimatedFare + Number(vm.viaControlled2));
                }
                dataSend.child_booking_id = vm.bookingDetails.round_trip_child_job_id;
            }

            // if (vm.estimated_toll_price !== undefined && vm.dataToFill.route_type === 0) {
            if (vm.estimated_toll_price !== undefined) {
                dataSend.estimated_toll_price = vm.estimated_toll_price;
            }

            if ((vm.dataToFill.selectedServiceDetails.category == 0) && (vm.type_of_trip_Validate_Booking == 'R' || (vm.dataToFill.roundTrip && vm.type_of_trip == 'R'))) {
                dataSend.travel_time = vm.travel_time_service_pick_up;
                dataSend.tolerance_time = vm.tolerance_time_withdrawal_pickup;
            }
            ///////////////////////////TV-1795 //////////////////////////
            // dataSend.via_controlled_price = Number(vm.viaControlled1);
            if(vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking == 'P' && vm.dataToFill.contractIdSelectedQREnabled == 1 && vm.dataToFill.scheduledBooking == 1){
                dataSend.booking_type = 2; //socofar - agrupado/exclusivo
            }
            else if (vm.dataToFill.selectedServiceDetails.category == 0) { //exclusive
                dataSend.booking_type = 0; //Normal
            } else if (vm.dataToFill.selectedServiceDetails.category == 1) { //shared
                dataSend.booking_type = 1; //shared
            }
            //else if(vm.dataToFill.selectedServiceDetails.category == 2){ //Normal
            //    dataSend.booking_type = 0; //Normal
            //}

            dataSend.is_POS_booking = 0;
            dataSend.payment_status = 0;
            dataSend.created_by_admin = 1;

            if (vm.dataToFill.discounts.length) {
                if (vm.dataToFill.discounts[0].name == 'ROUND TRIP') {
                    dataSend.promo_type = 1;
                }
                else if (vm.modifyFalg && vm.bookingDetails.promo_type == 4) {
                    console.log('debug vm.bookingDetails.promo_type', vm.bookingDetails.promo_type);
                    dataSend.promo_type = vm.bookingDetails.promo_type;
                    // return;
                }
                else {
                    dataSend.promo_type = 0;
                    dataSend.promo_id = vm.dataToFill.discounts[0].name;

                }
                if(vm.dataToFill.discounts[0].tope_maximo){
                    dataSend.tope_maximo = vm.dataToFill.discounts[0].tope_maximo;
                    if( vm.dataToFill.discounts[0].value > dataSend.tope_maximo ){
                        vm.dataToFill.discounts[0].value = dataSend.tope_maximo;
                    }
                }
                dataSend.discount_type = Number(vm.dataToFill.discounts[0].discountType);
                if (vm.modifyFalg && vm.bookingDetails.promo_type == 4) {
                    console.log('debug vm.bookingDetails.discount_amount', Number(vm.bookingDetails.discount_amount));
                    // return;
                    dataSend.discount_amount = Number(vm.bookingDetails.discount_amount);
                }
                else {
                    dataSend.discount_amount = Number(vm.dataToFill.discounts[0].discountTypeValue);
                }
                dataSend.discount_code = vm.dataToFill.couponCode;
                dataSend.final_discount_amount = vm.dataToFill.discounts[0].value;

            }

            if (vm.dataToFill.selectedServiceDetails.category == 1 && !vm.method_range_pickup) {
                dataSend.booking_eta = vm.dataToFill.etaScheduleValue + vm.dataToFill.time_trip_shared_service;
            } else {
                dataSend.booking_eta = vm.dataToFill.etaSchedule;
            }
            if (vm.dataToFill.route_type === 0 && vm.estimatedDistanceToSend)
                dataSend.est_distance = vm.estimatedDistanceToSend;
            if (vm.dataToFill.selectedServiceDetails.category == 1) {
                console.log(vm.dataToFill.etaScheduleValueReturn, vm.dataToFill.time_trip_shared_service, ' vm.dataToFill.etaScheduleValueReturn + vm.dataToFill.time_trip_shared_service');

                dataSend.return_booking_eta = vm.dataToFill.etaScheduleValueReturn + vm.dataToFill.time_trip_shared_service;
            } else {
                dataSend.return_booking_eta = vm.dataToFill.etaScheduleValueReturn;
            }
            if (vm.airlineMandatory == 1 && vm.SendTrip != 'P') {
                dataSend.airline = vm.dataToFill.airline;
            }
            if (vm.flightNumberMandatory == 1 && vm.SendTrip != 'P') {
                dataSend.flight_number = vm.dataToFill.flightNumber;
            }
            if (vm.flightDateMandatory == 1 && vm.SendTrip != 'P') {
                dataSend.flight_date = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            }
            if (vm.flightTypeMandatory == 1 && vm.SendTrip != 'P') {
                if (vm.international) {
                    dataSend.flight_type = vm.international;
                } else {
                    dataSend.flight_type = vm.national;
                }

            }
            dataSend.apply_charge_by_toll = vm.searchFixedVariablePayload.title.data.apply_charge_by_toll;
            dataSend.collect_estimated_tag = vm.searchFixedVariablePayload.title.data.collect_estimated_tag;
            if (vm.dataToFill.route_type === 0) {
                dataSend.apply_estimated_distance_variable_fare = vm.searchFixedVariablePayload.title.data.apply_estimated_distance_variable_fare;

            }
            if ((JSON.parse($cookies.get('adminType') || 0) == 1) && vm.isEmpDataChange)
                dataSend.is_emp_data = vm.isEmpDataChange; // TV-2378
            
            if(vm.routingBase && vm.routingBase.depot_id)
                dataSend.depot_id = vm.routingBase.depot_id;

            if(vm.routingBase && vm.routingBase.depot_id)
                dataSend.depot_id = vm.routingBase.depot_id;

            dataSend.factor_value = vm.dataToFill.factor_value;
            dataSend.factor_type = vm.dataToFill.factor_tipo;
            dataSend.factor_id = vm.dataToFill.factor_id;
            $log.log(dataSend);
            console.log(dataSend, "modify");
            
            vm.loading = true;
            var promise = getBookings.modifyBooking(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    //console.log(payload, "<edit payload>>>>>>>>>>>");

                    if (payload.title.status == 400) {
                        if (payload.title != null && payload.title.data && payload.title.data.key == true) {
                            bookingValidateCreationSuccess(payload.title, 'NoAuth', $event);
                        } else {
                            //console.log(payload.title.message, 'payload.title.message');

                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }


                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        console.log(vm.dataToFill.authRequired, 'vm.dataToFill.authRequired ');

                        if (vm.dataToFill.authRequired == '1' || vm.dataToFill.authRequired == 1) {
                            languageBasedErrorFactory.getProperErrorMessage('bookingSuccUA', 0, 2, 'layout.upcomingBookingsMain.upcomingBookings')
                            //errorMessageFactory.showErrorMessage('Booking updated successfully.But the Reserve will remain pending until Authorized.',2,'layout.upcomingBookingsMain.upcomingBookings');
                        } else {
                            languageBasedErrorFactory.getProperErrorMessage('bookingSuccU', 0, 2, 'layout.upcomingBookingsMain.upcomingBookings')


                            //errorMessageFactory.showErrorMessage('Booking updated successfully.',2,'layout.upcomingBookingsMain.upcomingBookings');
                        }
                    }
                    //$timeout(function() {
                    //    $mdDialog.hide();
                    //     $state.reload();
                    //}, 2000);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    vm.disableSubmitButton = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }


        function stopRKey(evt) {
            var evt = (evt) ? evt : ((event) ? event : null);
            var node = (evt.target) ? evt.target : ((evt.srcElement) ? evt.srcElement : null);
            if ((evt.keyCode == 13) && (node.type == "text")) {
                return false;
            }
        }

        document.onkeypress = stopRKey;

        // Variable to Contain Child Job Id
        // Default value is 1
        vm.roundTripChildJobId = 1;

        function checkBoxValue(data) {
            vm.checkBoxCheck = true;
        }
        //===========================modify booking===========================
        function getSingleBooking(id) {
            vm.loading = true;
            vm.disabledSubmitButton = true;
            var promise = getBookings.singleBooking(id);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    vm.bookingDetails = payload.title.data;
                    vm.getInfoFlag = true;
                    vm.modifyFalgNew = true;
                    //console.log(vm.bookingDetails.round_trip_child_job_id, 'vm.bookingDetails.round_trip_child_job_id');
                    if (vm.bookingDetails.round_trip_child_job_id > 0 || vm.bookingDetails.round_trip_parent_job_id > 0 ||
                        (vm.bookingDetails.is_round_trip == 1 && vm.bookingDetails.is_wait_time_included == 1)) {

                        vm.disabledRoundTrip = true;

                    } else {
                        vm.disabledRoundTrip = false;
                    }
                    var type;
                    if (vm.bookingDetails.type_of_trip == 'Z') {
                        type = 2;
                        forTabsView(type);
                    } else if (vm.bookingDetails.type_of_trip == 'R') {
                        type = 1;
                        forTabsView(type);
                    } else {
                        type = 3;
                        forTabsView(type);
                    }

                    //console.log(vm.bookingDetails);
                    //console.log('vm.allCustomersList', vm.allCustomersList);

                    var whereCustomer = _.where(vm.allCustomersList, {
                        customer_id: vm.bookingDetails.created_by
                    })[0];
                    vm.flagHelp = true;
                    vm.dataToFill.customerMobile = whereCustomer;

                    // Variable to Contain Child Job Id
                    vm.roundTripChildJobId = vm.bookingDetails.round_trip_child_job_id || 0;

                    vm.isAdjustedDiscountedAmount = vm.bookingDetails.is_adjusted_discounted_amount;
                    //console.log(whereCustomer);
                    vm.makePhoneEditAble = false;
                    vm.dataToFill.customerMobile.phone_number = vm.bookingDetails.customer_phone_number;
                    vm.dataToFill.customerMobileG = vm.bookingDetails.customer_phone_number;
                    vm.dataToFill.customerId = vm.dataToFill.customerMobile.customer_id;
                    vm.dataToFill.previousCustomerId = vm.dataToFill.customerMobile.customer_id;
                    vm.dataToFill.customerEmail = vm.dataToFill.customerMobile.email;
                    vm.dataToFill.employeeId = vm.dataToFill.customerMobile.customer_id;
                    vm.checkBoxValueIs = vm.bookingDetails.sin_respaldo == 1 ? true : false;
                    console.log(vm.checkBoxValueIsToShow, 'vm.checkBoxValueIsToShow');
                    vm.dataToFill.passengerId = vm.bookingDetails.passenger_id;
                    console.log(vm.bookingDetails.passenger_id, 'vm.bookingDetails.passenger_id');

                    if (vm.bookingDetails.flight_date != null) {
                        vm.filterData.filter_pickup_from_date_value = new Date(vm.bookingDetails.flight_date);
                        vm.filterData.filter_pickup_from_time_value = new Date(vm.bookingDetails.flight_date);
                    }
                    vm.modifyFalg = true;

                    // vm.filterData.filter_pickup_from_time_value = new Date(vm.bookingDetails.flight_date);
                    vm.dataToFill.flightNumber = vm.bookingDetails.flight_number;
                    vm.dataToFill.airline = vm.bookingDetails.airline;
                    vm.TypeToShow = vm.bookingDetails.flight_type;
                    if (vm.TypeToShow == 'I') {
                        vm.international = 'I';
                    } else {
                        vm.national = 'N';
                    }


                    //vm.customerProfileOption = [
                    //    {
                    //        name: 'Personal',
                    //        value: 0
                    //    },
                    //    {
                    //        name: 'Corporate',
                    //        value: 1
                    //    }
                    //]
                    getCustomerFavouriteAddress();
                    vm.modifyBooking = true;
                    vm.dataToFill.customerProfile = vm.bookingDetails.creator_profile.toString();
                    profileChanges();
                    vm.dataToFill.contractIdSelected = vm.bookingDetails.contract_id;
                    console.log(vm.dataToFill.contractIdSelected, 'vm.dataToFill.contractIdSelected');

                    vm.dataToFill.bookingType = vm.bookingDetails.schedule_ride.toString();
                    bookingType();
                    //if(vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == '1'){
                    //    agreementTypeChanged();
                    //}
                    vm.dataToFill.serviceTypeSelected = vm.bookingDetails.type_of_service;
                    originalTypeOfService = vm.bookingDetails.type_of_service;
                    vm.dataToFill.passengerCount = vm.bookingDetails.number_of_passangers;
                    originalPassengerCount = vm.bookingDetails.number_of_passangers;
                    originalBranch = vm.bookingDetails.branch;
                    vm.discard_booking_flag = vm.bookingDetails.discard_from_group;
                    //numberOfPassenger(vm.dataToFill.passengerCount);
                    vm.dataToFill.pickUpAddress = vm.bookingDetails.job_pickup_address;
                    vm.dataToFill.pickUpLat = vm.bookingDetails.job_pickup_latitude;
                    vm.dataToFill.pickUpLng = vm.bookingDetails.job_pickup_longitude;
                    vm.dataToFill.dropLng = vm.bookingDetails.job_longitude;
                    vm.dataToFill.dropLat = vm.bookingDetails.job_latitude;
                    vm.dataToFill.pickLat = vm.bookingDetails.job_pickup_latitude;
                    vm.dataToFill.pickLng = vm.bookingDetails.job_pickup_longitude;
                    // vm.pickaddressChange = true;
                    // vm.dropaddressChange = true;
                    var location = new google.maps.LatLng(Number(vm.bookingDetails.job_pickup_latitude), Number(vm.bookingDetails.job_pickup_longitude));
                    getFavoriteAddress('pick');
                    // placeMarker(map, location, 'pick');
                    vm.dataToFill.dropOffAddress = vm.bookingDetails.job_address;
                    vm.dataToFill.dropOffLat = vm.bookingDetails.job_latitude;
                    vm.dataToFill.dropOffLng = vm.bookingDetails.job_longitude;
                    vm.dataToFill.payment_method = Number(vm.bookingDetails.payment_method);
                    console.log(vm.dataToFill.payment_method, 'vm.dataToFill.payment_method', vm.bookingDetails.payment_method);

                    var locationD = new google.maps.LatLng(Number(vm.bookingDetails.job_latitude), Number(vm.bookingDetails.job_longitude));
                    getFavoriteAddress('drop');
                    // placeMarker(map, locationD, 'drop');
                    vm.dataToFill.bookingFor = vm.bookingDetails.booking_for;
                    vm.dataToFill.otherBooking = vm.dataToFill.bookingFor == 1 ? true : false;
                    vm.dataToFill.isEmpDataChange = vm.bookingDetails.is_emp_data || false;
                    //console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>');
                    // bookingFor(vm.dataToFill.bookingFor);
                    
                    vm.dataToFill.dropDate = new Date(vm.bookingDetails.job_time_utc);
                    vm.dataToFill.dropTime = new Date(vm.bookingDetails.job_time_utc);
                    vm.dataToFill.scheduledTime = new Date(vm.bookingDetails.job_time_utc);
                    if (new Date(vm.bookingDetails.job_delivery_datetime) != 'Invalid Date'){
                        vm.dataToFill.returnDate = new Date(vm.bookingDetails.job_delivery_datetime);
                        vm.dataToFill.returnTime = new Date(vm.bookingDetails.job_delivery_datetime);
                    }

                    $timeout(function () {


                        if ((vm.dataToFill.bookingType == 1 || vm.dataToFill.bookingType == '1') && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2) &&
                            (new Date(vm.bookingDetails.job_delivery_datetime) != 'Invalid Date') && (new Date(vm.bookingDetails.job_time_utc) != 'Invalid Date')) {
                            vm.dataToFill.scheduledDate = new Date(vm.bookingDetails.job_time_utc);
                            vm.dataToFill.scheduledTime = new Date(vm.bookingDetails.job_time_utc);
                            // vm.dataToFill.returnDate = new Date(vm.bookingDetails.job_time_utc);
                            // vm.dataToFill.returnTime = new Date(vm.bookingDetails.job_time_utc);\

                            vm.dataToFill.dropDate = vm.bookingDetails.job_delivery_datetime ? new Date(vm.bookingDetails.job_delivery_datetime) : '';
                            vm.dataToFill.dropTime = vm.bookingDetails.job_delivery_datetime ? new Date(vm.bookingDetails.job_delivery_datetime) : '';
                            vm.returnDateOptions.minDate = vm.dataToFill.scheduledBooking == 1 ? vm.dataToFill.scheduledDate : new Date();
                        } else if ((vm.dataToFill.bookingType == 1 || vm.dataToFill.bookingType == '1') && vm.dataToFill.selectedServiceDetails.category == 1 &&
                            (new Date(vm.bookingDetails.job_delivery_datetime) != 'Invalid Date') && (new Date(vm.bookingDetails.job_time_utc) != 'Invalid Date')) {
                            vm.dataToFill.scheduledDate = new Date(vm.bookingDetails.job_time_utc);
                            vm.dataToFill.scheduledTime = new Date(vm.bookingDetails.job_time_utc);
                            vm.dataToFill.dropDate = new Date(vm.bookingDetails.job_delivery_datetime);
                            vm.dataToFill.dropTime = new Date(vm.bookingDetails.job_delivery_datetime);
                            vm.pickRange3 = moment(vm.bookingDetails.job_time_utc).format('HH:mm');
                            vm.dataToFill.returnDate = new Date(vm.bookingDetails.job_delivery_datetime);
                            vm.dataToFill.returnTime = new Date(vm.bookingDetails.job_delivery_datetime);
                            vm.dataToFill.dropDateReturn = new Date(vm.bookingDetails.return_date_time_utc);
                            vm.dataToFill.dropTimeReturn = new Date(vm.bookingDetails.return_date_time_utc);
                            vm.returnDateOptions.minDate = vm.dataToFill.scheduledBooking == 1 ? vm.dataToFill.dropDate : new Date();
                        } else if ((vm.dataToFill.bookingType == '0' || vm.dataToFill.bookingType == 0) && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2)) {
                            vm.dataToFill.scheduledBooking = 0;
                        } else if ((vm.dataToFill.bookingType == '0' || vm.dataToFill.bookingType == 0) && vm.dataToFill.selectedServiceDetails.category == 1 &&
                            (new Date(vm.bookingDetails.job_delivery_datetime) != 'Invalid Date') && (new Date(vm.bookingDetails.job_time_utc) != 'Invalid Date')) {
                            vm.dataToFill.scheduledBooking = 0;
                            vm.dataToFill.scheduledDate = new Date(vm.bookingDetails.job_time_utc);
                            vm.dataToFill.scheduledTime = new Date(vm.bookingDetails.job_time_utc);
                            vm.dataToFill.dropDate = new Date(vm.bookingDetails.job_delivery_datetime);
                            vm.dataToFill.dropTime = new Date(vm.bookingDetails.job_delivery_datetime);
                            vm.dataToFill.returnDate = new Date(vm.bookingDetails.job_delivery_datetime);
                            vm.dataToFill.returnTime = new Date(vm.bookingDetails.job_delivery_datetime);
                            vm.dataToFill.dropDateReturn = new Date(vm.bookingDetails.return_date_time_utc);
                            vm.dataToFill.dropTimeReturn = new Date(vm.bookingDetails.return_date_time_utc);
                            vm.returnDateOptions.minDate = vm.dataToFill.scheduledBooking == 1 ? vm.dataToFill.dropDate : new Date();
                        }

                        if (vm.bookingDetails.is_round_trip == 1) {
                            vm.posBookingFlag = true;
                        }
                        if (vm.bookingDetails.is_POS_booking == 1 && vm.bookingDetails.round_trip_parent_job_id > 0 &&
                            vm.bookingDetails.job_time_utc == '0000-00-00 00:00:00') {
                            vm.dataToFill.scheduledTime = '';
                        }
                        // vm.bookingDetails.is_POS_booking == 1 &&
                        //  vm.bookingDetails.is_POS_booking == 1 &&
                        if ((vm.bookingDetails.round_trip_parent_job_id > 0 || vm.bookingDetails.round_trip_child_job_id > 0)) {
                            vm.disableAgreementService = true;
                            vm.pickUpAddress = vm.bookingDetails.job_pickup_address;
                            reverseGeocodeForPickUp();
                            vm.dropUpAddress = vm.bookingDetails.job_address;
                            reverseGeocodeForDropUp();
                            // $timeout(function () {
                            //     if (vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                            //         calculateAndDisplayRoute(directionsService, directionsDisplay, vm.dataToFill.dropOffLat, vm.dataToFill.dropOffLng, vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, map, 'ROUND TRIP', vm.payloadForsearchFixedVairable);
                            //         // getFixedRoutesForPersonal(vm.dataToFill);

                            //     }
                            // }, 1000)
                        }
                        // tv-1885
                        if (vm.dataToFill.selectedServiceDetails.fare_type == 1) {
                            vm.disabledNumberOfpassengerByCount = true;
                        }

                        //if (vm.dataToFill.scheduledBooking == 1) {
                        //    vm.dataToFill.scheduledDate = new Date(vm.bookingDetails.job_time_utc);
                        //    vm.dataToFill.scheduledTime = new Date(vm.bookingDetails.job_time_utc);
                        //    vm.dataToFill.returnDate = new Date(vm.bookingDetails.job_time_utc);
                        //    vm.dataToFill.returnTime = new Date(vm.bookingDetails.job_time_utc);
                        //    vm.returnDateOptions.minDate = vm.dataToFill.scheduledBooking == 1 ? vm.dataToFill.scheduledDate : new Date();
                        //}
                        if (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking == 'P') {
                            calculateDateRangeOfPointToPoint();
                        }
                        // calculateDateRangeOfPointToPoint();
                        // if (vm.dataToFill.selectedServiceDetails.category == 0 && (vm.type_of_trip_Validate_Booking == 'R' || vm.type_of_trip == 'R')) {
                        //     vm.dataToFill.scheduledTime = new Date(vm.bookingDetails.job_time_utc);
                        //     vm.dataToFill.scheduledDate = new Date(vm.bookingDetails.job_time_utc);
                        //     calculateEstimatePickUpTimeForRType(vm.dataToFill.etaScheduleValue);
                        // }
                        // if (vm.dataToFill.selectedServiceDetails.category == 0 && (vm.type_of_trip_Validate_Booking == 'R' || (vm.dataToFill.round_trip && vm.type_of_trip == 'R'))) {
                        //     console.log(" i m in this >>>>>>>>>>>>>>>>>>>>>>>>>>>",vm.type_of_trip_Validate_Booking == 'R' ,(vm.dataToFill.round_trip && vm.type_of_trip == 'R'));

                        //     vm.dataToFill.scheduledDate = new Date(vm.bookingDetails.job_delivery_datetime);
                        //     vm.dataToFill.scheduledTime = new Date(vm.bookingDetails.job_delivery_datetime);
                        //     // calculateEstimatePickUpTimeForRType(vm.dataToFill.etaScheduleValue);
                        // }
                        console.log(vm.dataToFill.returnDate, 'vm.dataToFill.returnDate>>>>>>>>>>>>>>>>LAst');
                        if (vm.type_of_trip1 != 'P' && vm.flagForFlightDate == true) {
                            compareDates();
                        }
                    }, 3000);

                    if (vm.bookingDetails.payment_state == 1 || vm.bookingDetails.payment_status == 1) {
                        vm.disabledPaymentMethod = true;
                    } else {
                        vm.disabledPaymentMethod = false;
                    }
                    if (vm.dataToFill.otherBooking) {
                        vm.is_vip = vm.bookingDetails.is_vip ? true : false;
                        vm.dataToFill.personSelected = vm.bookingDetails.job_pickup_name;
                        vm.dataToFill.personName = vm.bookingDetails.job_pickup_name;
                        if (vm.bookingDetails.job_pickup_email != "null") {
                            //console.log("i m here puneet");
                            vm.dataToFill.personEmail = vm.bookingDetails.job_pickup_email;
                        } else {
                            vm.dataToFill.personEmail = '';
                        }

                        vm.dataToFill.personMobile = vm.bookingDetails.job_pickup_phone;
                        vm.dataToFill.personFromDb = !vm.bookingDetails.person_from_db;
                    }
                    vm.dataToFill.reference_point = vm.bookingDetails.reference_point;
                    var timeOutSet = 0;

                    if (vm.bookingDetails.is_round_trip || vm.bookingDetails.is_POS_booking == 1 || (vm.bookingDetails.is_round_trip && (vm.dataToFill.customerProfile == '1'))) {
                        timeOutSet = 3000;
                    } else {
                        timeOutSet = 0;
                    }
                    console.log(timeOutSet, 'timeOutSet');

                    $timeout(function () {
                        if (vm.bookingDetails.is_round_trip) {
                            vm.dataToFill.roundTrip = true;
                            vm.dataToFill.returnDate = new Date(vm.bookingDetails.return_date_time_utc) == 'Invalid Date' ? '' : new Date(vm.bookingDetails.return_date_time_utc);
                            vm.dataToFill.returnTime = new Date(vm.bookingDetails.return_date_time_utc) == 'Invalid Date' ? '' : new Date(vm.bookingDetails.return_date_time_utc);
                            vm.dataToFill.dropDateReturn = new Date(vm.bookingDetails.return_date_time_utc) == 'Invalid Date' ? '' : new Date(vm.bookingDetails.return_date_time_utc);
                            vm.dataToFill.dropTimeReturn = new Date(vm.bookingDetails.return_date_time_utc) == 'Invalid Date' ? '' : new Date(vm.bookingDetails.return_date_time_utc);
                        }
                        if (vm.bookingDetails.is_POS_booking == 1) {
                            vm.dataToFill.dropDate = new Date(vm.bookingDetails.job_delivery_datetime) == 'Invalid Date' ? '' : new Date(vm.bookingDetails.job_delivery_datetime);
                            vm.dataToFill.dropTime = new Date(vm.bookingDetails.job_delivery_datetime) == 'Invalid Date' ? '' : new Date(vm.bookingDetails.job_delivery_datetime);
                            vm.dataToFill.scheduledDate = new Date(vm.bookingDetails.job_time_utc) == 'Invalid Date' ? '' : new Date(vm.bookingDetails.job_time_utc);
                            vm.dataToFill.scheduledTime = new Date(vm.bookingDetails.job_time_utc) == 'Invalid Date' ? '' : new Date(vm.bookingDetails.job_time_utc);
                        }
                        if (vm.bookingDetails.is_round_trip && (vm.dataToFill.customerProfile == '1')) {
                            vm.dataToFill.is_wait_time_included = vm.bookingDetails.is_wait_time_included;
                        }
                    }, timeOutSet);

                    if (vm.bookingDetails.reaccuring_ride) {
                        vm.dataToFill.reaccurringBooking = false;
                    }
                    $timeout(function () {
                        if ((vm.dataToFill.selectedServiceDetails.category == 0 && (vm.type_of_trip_Validate_Booking == 'R' || (vm.dataToFill.round_trip && vm.type_of_trip == 'R')) && new Date(vm.bookingDetails.job_delivery_datetime) != 'Invalid Date')) {
                            vm.dataToFill.scheduledDate = new Date(vm.bookingDetails.job_time_utc);
                            vm.dataToFill.scheduledTime = new Date(vm.bookingDetails.job_time_utc);
                            calculateEstimatePickUpTimeForRType(vm.dataToFill.etaScheduleValue); 
                            //calculateDateRangeOfPointToPoint(); 
                        }
                    }, 3000)
                    //if (vm.dataToFill.bookingType == '0') {
                    vm.dataToFill.nearDriver = '';
                    toGetAirportService(vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.serviceTypeSelected, map);
                    //toGetNearByDrivers(vm.dataToFill.pickUpLat,vm.dataToFill.pickUpLng,vm.dataToFill.serviceTypeSelected,map);
                    //}

                    // $timeout(function () {
                    if (vm.bookingDetails.passenger_rut)
                        vm.dataToFill.passengerRut = RutHelper.format(vm.bookingDetails.passenger_rut);
                    //console.log(vm.dataToFill.passengerRut, 'vm.dataToFill.passengerRut');
                    if (vm.bookingDetails.applicant_rut)
                        vm.dataToFill.applicantRut = RutHelper.format(vm.bookingDetails.applicant_rut);
                    if (vm.bookingDetails.cost_center)
                        vm.dataToFill.costCenter = vm.bookingDetails.cost_center;
                    if (vm.bookingDetails.sub_cost_center)
                        vm.dataToFill.costSubCenter = vm.bookingDetails.sub_cost_center;
                    if (vm.bookingDetails.rol)
                        vm.dataToFill.Rol = vm.bookingDetails.rol;
                    if (vm.bookingDetails.graph)
                        vm.dataToFill.graph = vm.bookingDetails.graph;
                    if (vm.bookingDetails.work_order)
                        vm.dataToFill.workOrder = vm.bookingDetails.work_order;
                    if (vm.bookingDetails.PEP)
                        vm.dataToFill.pep = vm.bookingDetails.PEP;
                    if (vm.bookingDetails.purpose_of_trip)
                        vm.dataToFill.purposeOfTrip = vm.bookingDetails.purpose_of_trip;
                    if (vm.bookingDetails.number_of_voucher)
                        vm.dataToFill.noOfVoucher = vm.bookingDetails.number_of_voucher;
                    if (vm.bookingDetails.nomina)
                        vm.dataToFill.nomina = vm.bookingDetails.nomina;
                    if (vm.bookingDetails.solicitud)
                        vm.dataToFill.solictud = vm.bookingDetails.solicitud;

                    vm.dataToFill.discounts = [];
                    $timeout(function () {
                        if (vm.bookingDetails.discount_amount > 0) {
                            vm.dataToFill.couponApplied = true;
                            var name = vm.bookingDetails.promo_type == '0' ? vm.bookingDetails.promo_id : vm.bookingDetails.promo_type == '1' ? 'ROUND TRIP' : vm.bookingDetails.promo_type == '2' ? 'Web Discount' : vm.bookingDetails.promo_type == '3' ? 'Bin' : 'NA';
                            var discountType = vm.bookingDetails.discount_type;
                            vm.couponType = discountType;
                            if (vm.bookingDetails.promo_type == 0 || vm.bookingDetails.promo_type == '0') {
                                var discountTypeValue = vm.bookingDetails.discount_amount;
                            } else if (vm.bookingDetails.promo_type == '1' || vm.bookingDetails.promo_type == 1) {
                                var discountTypeValue = vm.dataToFill.roundTripDiscount;
                            } else if (vm.bookingDetails.promo_type == '2' || vm.bookingDetails.promo_type == 2) {
                                var discountTypeValue = vm.dataToFill.webDiscount;
                            }
                            vm.tope_maximo = (vm.bookingDetails.discount_tope == 1) ? vm.bookingDetails.discount_tope_value : undefined;
                            var value;
                            var returnValue;
                            if (vm.bookingDetails.discount_type == 0 || vm.bookingDetails.discount_type == '0') {
                                value = Number(vm.bookingDetails.discount_amount);
                            } else {
                                // if(vm.dataToFill.controllerWayTarifa == 0){
                                value = ((Number(vm.dataToFill.estimatedFare) * Number(vm.bookingDetails.discount_amount)) / 100);
                                // }else{
                                //      value = ((Number(vm.dataToFill.estimatedFare - vm.viaControlled1) * Number(vm.bookingDetails.discount_amount)) / 100)
                                // }

                            }
                            if (vm.bookingDetails.discount_type == 0 || vm.bookingDetails.discount_type == '0') {
                                returnValue = Number(vm.bookingDetails.discount_amount);
                            } else {
                                // if(vm.dataToFill.controllerWayTarifa == 0){
                                returnValue = ((Number(vm.dataToFill.Return_policy.estimatedFare) * Number(vm.bookingDetails.discount_amount)) / 100);
                                // }else{
                                //     returnValue   = ((Number(vm.dataToFill.Return_policy.estimatedFare - vm.viaControlled2) * Number(vm.bookingDetails.discount_amount)) / 100);
                                // }

                            }
                            var final = Number((Number(vm.dataToFill.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled1))) - value);

                            // vm.dataToFill.discounts.push({
                            //     // estimatedFare: Number(vm.dataToFill.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled1)),
                            //     estimatedFare: viaControlledPrice(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking),
                            //     // roundTripFare: roundTripFareSend,
                            //     roundTripFare: vm.dataToFill.roundTrip == true ? viaControlledPrice(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip) : 0,
                            //     name: payload.title.data.coupon_number,
                            //     discountType: payload.title.data.type,
                            //     discountTypeValue: payload.title.data.discount,
                            //     // value: payload.title.data.type ? Math.round((Number(vm.estimatedFareDiscount) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled1))) * (payload.title.data.discount) / 100) : payload.title.data.discount,
                            //     value: payload.title.data.type ? calculateDiscountPercentage(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, payload.title.data.discount) : calculateDiscountFlat(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, payload.title.data.discount),
                            //     // returnValue: returnValueSend,
                            //     returnValue: vm.dataToFill.roundTrip == true ? (payload.title.data.type ? calculateDiscountPercentage(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, payload.title.data.discount) : calculateDiscountFlat(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, payload.title.data.discount)) : 0,
                            //     // finalAmount: payload.title.data.type ?  ((vm.estimatedFareDiscount - vm.estimatedFareDiscount * Number(payload.title.data.discount) / 100) + (vm.type_of_trip_Validate_Booking == 'Z' ? (Number(vm.viaControlled1)) : 0)) :  ((vm.estimatedFareDiscount - vm.estimatedFareDiscount * Number(payload.title.data.discount) / 100) + (vm.type_of_trip_Validate_Booking == 'Z' ? (Number(vm.viaControlled1)) : 0)),
                            //     finalAmount: payload.title.data.type ? calculateDiscountPercentage(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, payload.title.data.discount) : calculateDiscountFlat(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, payload.title.data.discount),
                            //     // roundFinalAmount: roundFinalAmountSend,
                            //     roundFinalAmount: vm.dataToFill.roundTrip == true ? (payload.title.data.type ? calculateDiscountPercentage(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, payload.title.data.discount) : calculateDiscountFlat(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, payload.title.data.discount)) : 0
                            // });

                            vm.dataToFill.discounts = [];
                            vm.dataToFill.discounts.push({
                                // estimatedFare: Number(vm.dataToFill.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled1)),
                                estimatedFare: viaControlledPrice(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking),
                                // roundTripFare: Number(vm.dataToFill.Return_policy.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled2)),
                                roundTripFare: vm.dataToFill.roundTrip == true ? viaControlledPrice(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip) : 0,
                                name: name,
                                discountType: discountType,
                                discountTypeValue: discountTypeValue,
                                // value: value,
                                value: vm.bookingDetails.discount_type ? calculateDiscountPercentageAmount(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, vm.bookingDetails.discount_amount, 'parent') : calculateDiscountFlatAmount(vm.bookingDetails.discount_amount),
                                // returnValue: returnValue,
                                returnValue: vm.dataToFill.roundTrip == true ? (vm.bookingDetails.discount_type ? calculateDiscountPercentageAmount(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, vm.bookingDetails.discount_amount, 'parent') : calculateDiscountFlatAmount( vm.bookingDetails.discount_amount)) : 0,
                                finalAmount: vm.bookingDetails.discount_type ? calculateDiscountPercentage(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, vm.bookingDetails.discount_amount, vm.tope_maximo, 'parent') : calculateDiscountFlat(vm.dataToFill.estimatedFare, vm.viaControlled1, vm.type_of_trip_Validate_Booking, vm.bookingDetails.discount_amount, 'parent'),
                                // roundFinalAmount: Number((Number(vm.dataToFill.Return_policy.estimatedFare) + (vm.dataToFill.controllerWayTarifa ? 0 : Number(vm.viaControlled2))) - returnValue)
                                roundFinalAmount: vm.dataToFill.roundTrip == true ? (vm.bookingDetails.discount_type ? calculateDiscountPercentage(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, vm.bookingDetails.discount_amount, vm.tope_maximo, 'parent') : calculateDiscountFlat(vm.dataToFill.Return_policy.estimatedFare, vm.viaControlled2, vm.type_of_trip, vm.bookingDetails.discount_amount)) : 0
                            })
                            if( vm.tope_maximo ){
                                vm.dataToFill.discounts[0].tope_maximo = vm.tope_maximo;
                            }

                            console.log(vm.dataToFill.discounts, 'first time araay is >>>>>>>');
                        }
                        console.log(vm.dataToFill.discounts, 'modify>>>>>>>>>>>>>>>>>');
                    }, 3000)

                    if (vm.dataToFill.selectedServiceDetails.fare_type == 1) {
                        vm.dataToFill.viaControlledReal = Number(vm.bookingDetails.via_controlled_price) / Number(vm.dataToFill.passengerCount);
                    } else {
                        vm.dataToFill.viaControlledReal = Number(vm.bookingDetails.via_controlled_price);
                    }
                    vm.dataToFill.viaControlled = Number(vm.dataToFill.viaControlledReal);
                    // }, 2000);
                    $timeout(function () {
                        if (vm.bookingDetails.is_round_trip == 1) {
                            //console.log($scope.createBookingForm.returnDate.$error, "asmgdgjhasdgsajdgasgd");
                            $scope.createBookingForm.returnDate.$error.date = false;
                            $scope.createBookingForm.returnDate.$error.required = false;
                            $scope.createBookingForm.returnTime.$error.date = false;
                            $scope.createBookingForm.returnTime.$error.required = false;
                            //console.log($scope.createBookingForm.returnDate.$error, "asmgdgjhasdgsajdgasgd");
                        }
                    }, 1000)
                    if (vm.toAirportFlag || vm.fromAirportFlag) {
                        getAirportAddressApi();
                    }
                    if (vm.bookingDetails.type_of_trip == 'P' && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) {
                        getFixedRoutesForPersonal(vm.dataToFill);
                    }
                    vm.dataToFill.observations = vm.bookingDetails.observations;
                    vm.dataToFill.estimatedFare = vm.bookingDetails.estimated_payment_cost;
                    // if(vm.bookingDetails.eta) {
                    //     vm.dataToFill.etaSchedule = vm.bookingDetails.eta;
                    // }
                    // if(vm.bookingDetails.route_type) {
                    //     vm.dataToFill.route_type = vm.bookingDetails.route_type;
                    // }
                    // setTimeout(function(){
                    //     if (vm.dataToFill && vm.dataToFill.selectedServiceDetails && vm.dataToFill.selectedServiceDetails.category == 1)
                    //     calculateEstimatePickUpTime(vm.bookingDetails.eta);
                    //     vm.pickRangeForRouting = moment(new Date(vm.bookingDetails.job_time_utc)).format('HH:mm')
                    // }, 1000);
                    vm.dataToFill.is_POS_booking = 0;
                    vm.dataToFill.payment_status = vm.bookingDetails.payment_status;
                    vm.dataToFill.created_by_admin = vm.bookingDetails.created_by_admin;
                    vm.isAdjustedDiscountedAmount = vm.bookingDetails.is_adjusted_discounted_amount || 0;
                    console.log(vm.dataToFill.selectedServiceDetails.category, vm.type_of_trip_Validate_Booking, ' type_of_trip_Validate_Booking');


                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        vm.compareDates = compareDates;
        vm.flightDateValidation = false;
        vm.scheduleDateValidation = false;
        vm.dropoffDateValidation = false;
        // =============Compare Schedule date and Flight Date
        function compareDates() {
            //pickup date is greater = flightDate -> true
            vm.flightDateValidation = false;
            vm.scheduleDateValidation = false;
            vm.dropoffDateValidation = false;
            var flightDateAndTime = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var scheduleDateAndTime = dateTimeFormat(vm.dataToFill.scheduledDate, vm.dataToFill.scheduledTime);
            if (new Date(vm.dataToFill.dropDate) != 'Invalid Date' && new Date(vm.dataToFill.dropTime) != 'Invalid Date')
                var dropDateAndTime = dateTimeFormat(vm.dataToFill.dropDate, vm.dataToFill.dropTime)
            if (vm.dataToFill.selectedServiceDetails.category == 0) {
                var flightDateGreater = (moment(new Date(scheduleDateAndTime)).isAfter(new Date(flightDateAndTime)));
                var scheduleDateGreater = (moment(new Date(scheduleDateAndTime)).isBefore(new Date(flightDateAndTime)));
            }
            if (vm.dataToFill.selectedServiceDetails.category == 1) {
                var dropOffGreater = (moment(new Date(dropDateAndTime)).isBefore(new Date(flightDateAndTime)));
                var dropOffSmaller = (moment(new Date(dropDateAndTime)).isAfter(new Date(flightDateAndTime)));
            }
            // is Before
            console.log(flightDateGreater, dropOffGreater, vm.dataToFill.scheduledDate, vm.filterData.filter_pickup_from_date_value, vm.dataToFill.dropDate);

            if (vm.type_of_trip1 == 'Z' && (scheduleDateGreater || dropOffGreater) && (vm.type_of_trip1 != 'P' && vm.flagForFlightDate == true)) {
                vm.flightDateValidation = false;
                vm.scheduleDateValidation = true;
                vm.dropoffDateValidation = true;
            }
            // // // is After
            else if (vm.type_of_trip1 == 'R' && (flightDateGreater || dropOffSmaller) && (vm.type_of_trip1 != 'P' && vm.flagForFlightDate == true)) {
                vm.flightDateValidation = true;
                vm.scheduleDateValidation = false;
                vm.dropoffDateValidation = false;
            }

            //get_cuota();
        }
        //////// FUNCATION TO MARK HEART FARVORITE NOT ////////////////
        function MarkfavouriteAddressPickUp(data) {
            if (data == false)
                vm.isActivePick = !vm.isActivePick;
            else vm.isActivePick = !vm.isActivePick;
            if (vm.isActivePick) {
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.address = vm.dataToFill.pickUpAddress;
                dataSend.latitude = vm.dataToFill.pickUpLat;
                dataSend.longitude = vm.dataToFill.pickUpLng;
                dataSend.communa = vm.jobPickupComuna;
                dataSend.is_admin = 1;
                dataSend.customer_id = vm.dataToFill.customerId;
                vm.loading = true;
                var promise = getBookings.setFavouriteAddress(dataSend);
                promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        if (payload.title.status == 200) {
                            vm.flagForMarkFavAddress = true;
                            setTimeout(function () {
                                vm.flagForMarkFavAddress = false;
                                $scope.$apply();
                            }, 5000)
                            // vm.isActivePick = !vm.isActivePick;
                            vm.dataToFill.location_id_address = payload.title.data.location_id;
                            getCustomerFavouriteAddress('')
                        } else {
                            vm.isActivePick = !vm.isActivePick;
                            vm.dataToFill.location_id_address = payload.title.data.location_id;
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        $scope.items.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            } else {
                var dataSend = {};
                var array = [];
                array.push(vm.dataToFill.location_id_address);
                dataSend.access_token = $cookies.get('obj');
                dataSend.location_id = array;
                dataSend.is_admin = 1;
                dataSend.customer_id = vm.dataToFill.customerId;
                vm.loading = true;
                var promise = getBookings.setUnFavouriteAddress(dataSend);
                promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        if (payload.title.status == 200) {
                            getCustomerFavouriteAddress('')
                        } else {
                            vm.isActivePick = !vm.isActivePick;
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        $scope.items.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }
        }
        //////// FUNCATION TO MARK HEART FARVORITE NOT ////////////////


        //////// FUNCATION TO MARK HEART FARVORITE NOT ////////////////
        function MarkfavouriteAddressDrop(data) {
            if (data == false)
                vm.isActiveDrop = !vm.isActiveDrop;
            else vm.isActiveDrop = !vm.isActiveDrop;
            if (vm.isActiveDrop) {
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.address = vm.dataToFill.dropOffAddress;
                dataSend.latitude = vm.dataToFill.dropOffLat;
                dataSend.longitude = vm.dataToFill.dropOffLng;
                dataSend.communa = vm.jobDropoffComuna;
                dataSend.is_admin = 1;
                dataSend.customer_id = vm.dataToFill.customerId;
                vm.loading = true;
                var promise = getBookings.setFavouriteAddress(dataSend);
                promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        if (payload.title.status == 200) {
                            vm.flagForMarkFavAddress = true;
                            setTimeout(function () {
                                vm.flagForMarkFavAddress = false;
                                $scope.$apply();
                            }, 5000)
                            vm.dataToFill.location_id_address = payload.title.data.location_id;
                            getCustomerFavouriteAddress('')
                        } else {
                            vm.isActiveDrop = !vm.isActiveDrop;
                            vm.dataToFill.location_id_address = payload.title.data.location_id;
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        $scope.items.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            } else {
                var dataSend = {};
                var array = [];
                array.push(vm.dataToFill.location_id_address);
                dataSend.access_token = $cookies.get('obj');
                dataSend.location_id = array;
                dataSend.is_admin = 1;
                dataSend.customer_id = vm.dataToFill.customerId;
                vm.loading = true;
                var promise = getBookings.setUnFavouriteAddress(dataSend);
                promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        if (payload.title.status == 200) {
                            getCustomerFavouriteAddress('');
                        } else {
                            vm.isActivePick = !vm.isActivePick;
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        $scope.items.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }
        }

        //////// FUNCATION TO MARK HEART FARVORITE NOT ////////////////



        //////// FUNCATION TO GET THE ADDRESS IS FAVORITE OR NOT ////////////////
        function getFavoriteAddress(type) {
            var dataSend = {}
            if (type == 'pick') {
                dataSend.address = vm.dataToFill.pickUpAddress;
            } else {
                dataSend.address = vm.dataToFill.dropOffAddress;
            }
            dataSend.customer_id = vm.dataToFill.customerId;
            vm.loading = true;
            var promise = getBookings.getFavouriteAddress(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        if (type == 'pick') {
                            vm.isActivePick = payload.title.data.is_favourite;
                            vm.dataToFill.location_id_address = payload.title.data.location_id;
                        } else {
                            vm.isActiveDrop = payload.title.data.is_favourite;
                            vm.dataToFill.location_id_address = payload.title.data.location_id;
                        }
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    $scope.items.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        //////// FUNCATION TO GET THE ADDRESS IS FAVORITE OR NOT ////////////////


        ////////////////////////// CHECK STATUS FOR BWR BOOKING /////////////////////////
        function CheckBookingStatus(data) {
            if (data) {
                if (data.sin_respaldo == 1) {
                    if (data.job_status == '0' || data.job_status == '1' || data.job_status == '2' || data.job_status == '4' ||
                        data.job_status == '7' || data.job_status == '9' || data.job_status == '12' || data.job_status == '14' || data.job_status == '15') {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }

            } else {
                return false;
            }
        }
        ////////////////////////// CHECK STATUS FOR BWR BOOKING /////////////////////////

        ////////////////////////// TAB VIEW ADDED OR REMOVING CLASS /////////////////////////
        function forTabsView(type) {
            if (type == 1) {
                vm.toAirportFlag = true;
                vm.flagForPanel = true;
                vm.fromAirportFlag = false;
                vm.flagForMarkFavAddress = false;
                vm.ptopAirportFlag = false;
                if (!vm.modifyFalg) {
                    vm.dataToFill.pickUpLat = '';
                    vm.dataToFill.pickUpLng = '';
                    vm.dataToFill.dropOffLat = '';
                    vm.dataToFill.dropOffLng = '';
                    vm.isActiveDrop = false;
                    vm.dataToFill.pickUpAddress = '';
                    vm.dataToFill.dropOffAddress = '';
                    // vm.isActivePick = false;
                    vm.ErrorFlagForNewApi = false;
                }
                if (vm.modifyFalg) {
                    if (vm.bookingDetails.type_of_trip != 'R') {
                        vm.dataToFill.pickUpLat = '';
                        vm.dataToFill.pickUpLng = '';
                        vm.dataToFill.dropOffLat = '';
                        vm.dataToFill.dropOffLng = '';
                        // vm.isActiveDrop = false;
                        vm.dataToFill.pickUpAddress = '';
                        vm.dataToFill.dropOffAddress = '';
                        // vm.isActivePick = false;
                        vm.ErrorFlagForNewApi = false;
                    } else {
                        vm.dataToFill.pickUpLat = vm.bookingDetails.job_pickup_latitude;
                        vm.dataToFill.pickUpLng = vm.bookingDetails.job_pickup_longitude;
                        vm.dataToFill.dropOffLat = vm.airportLatitude;
                        vm.dataToFill.dropOffLng = vm.airportLongitude;
                        vm.dataToFill.pickUpAddress = vm.bookingDetails.job_pickup_address;

                        vm.dataToFill.dropOffAddress = vm.bookingDetails.job_address;
                    }
                }
                var elementR = document.getElementById("toAirport");
                elementR.classList.add("active");
                var element = document.getElementById("fromAirport");
                element.classList.remove("active");
                var elementP = document.getElementById("pointToPoint");
                elementP.classList.remove("active");
            } else if (type == 2) {
                vm.flagForPanel = true;
                vm.toAirportFlag = false;
                vm.fromAirportFlag = true;
                vm.ptopAirportFlag = false;
                vm.flagForMarkFavAddress = false;
                if (!vm.modifyFalg) {
                    vm.dataToFill.pickUpAddress = '';
                    vm.dataToFill.dropOffAddress = '';
                    vm.dataToFill.pickUpLat = '';
                    vm.dataToFill.pickUpLng = '';
                    vm.dataToFill.dropOffLat = '';
                    vm.dataToFill.dropOffLng = '';
                    // vm.isActivePick = false;
                    vm.ErrorFlagForNewApi = false;
                    // vm.isActiveDrop = false;
                }
                if (vm.modifyFalg) {
                    if (vm.bookingDetails.type_of_trip != 'Z') {
                        vm.dataToFill.pickUpLat = '';
                        vm.dataToFill.pickUpLng = '';
                        vm.dataToFill.dropOffLat = '';
                        vm.dataToFill.dropOffLng = '';
                        // vm.isActiveDrop = false;
                        vm.dataToFill.pickUpAddress = '';
                        vm.dataToFill.dropOffAddress = '';
                        // vm.isActivePick = false;
                        vm.ErrorFlagForNewApi = false;
                    } else {
                        vm.dataToFill.pickUpLat = vm.airportLatitude;
                        vm.dataToFill.pickUpLng = vm.airportLongitude;
                        vm.dataToFill.dropOffLat = vm.bookingDetails.job_latitude;
                        vm.dataToFill.dropOffLng = vm.bookingDetails.job_longitude;
                        vm.dataToFill.pickUpAddress = vm.bookingDetails.job_pickup_address;
                        vm.dataToFill.dropOffAddress = vm.bookingDetails.job_address;
                    }
                }
                var elementR = document.getElementById("fromAirport");
                elementR.classList.add("active");
                var element = document.getElementById("toAirport");
                element.classList.remove("active");
                var elementP = document.getElementById("pointToPoint");
                elementP.classList.remove("active");
            } else {
                vm.flagForPanel = true;
                vm.toAirportFlag = false;
                vm.fromAirportFlag = false;
                vm.flagForMarkFavAddress = false;
                vm.ptopAirportFlag = true;
                if (!vm.modifyFalg) {
                    vm.dataToFill.pickUpLat = '';
                    vm.dataToFill.pickUpLng = '';
                    vm.dataToFill.dropOffLat = '';
                    vm.dataToFill.pickUpAddress = '';
                    vm.dataToFill.dropOffAddress = '';
                    vm.dataToFill.dropOffLng = '';
                    vm.ErrorFlagForNewApi = false;
                    // vm.isActivePick = false;
                    // vm.isActiveDrop = false;
                    vm.ErrorFlagForNewApi = false;
                }
                if (vm.modifyFalg) {
                    if (vm.bookingDetails.type_of_trip != 'P') {
                        vm.dataToFill.pickUpLat = '';
                        vm.dataToFill.pickUpLng = '';
                        vm.dataToFill.dropOffLat = '';
                        vm.dataToFill.dropOffLng = '';
                        vm.dataToFill.pickUpAddress = '';
                        vm.dataToFill.dropOffAddress = '';
                    } else {
                        vm.dataToFill.pickUpLat = vm.bookingDetails.job_pickup_latitude;
                        vm.dataToFill.pickUpLng = vm.bookingDetails.job_pickup_longitude;
                        vm.dataToFill.dropOffLat = vm.bookingDetails.job_latitude;
                        vm.dataToFill.dropOffLng = vm.bookingDetails.job_longitude;
                        vm.dataToFill.pickUpAddress = vm.bookingDetails.job_pickup_address;
                        vm.dataToFill.dropOffAddress = vm.bookingDetails.job_address;
                    }
                }
                var element = document.getElementById("toAirport");
                element.classList.remove("active");
                var elementP = document.getElementById("fromAirport");
                elementP.classList.remove("active");
                var elementR = document.getElementById("pointToPoint");
                elementR.classList.add("active");
            }
            vm.disabledSubmitButton = true;
            vm.fullCuota = false;
        }
        ////////////////////////// TAB VIEW ADDED OR REMOVING CLASS /////////////////////////

        function pickUpAddressBlank() {
            vm.crossFlag = true;
            vm.ErrorFlagForNewApi = false;
            if (vm.modifyFalg) {
                if (vm.toAirportFlag || vm.fromAirportFlag) {
                    vm.dataToFill.pickUpAddress = '';
                    vm.dataToFill.dropOffAddress = '';
                    vm.dataToFill.pickUpLat = '';
                    vm.dataToFill.pickUpLng = '';
                    vm.dataToFill.dropOffLat = '';
                    vm.dataToFill.dropOffLng = '';
                    vm.isActivePick = false;
                    // vm.isActiveDrop = false;
                } else {
                    vm.dataToFill.pickUpAddress = '';
                    vm.dataToFill.pickUpLat = '';
                    vm.dataToFill.pickUpLng = '';
                }
            } else {
                vm.dataToFill.pickUpAddress = '';
                vm.dataToFill.pickUpLat = '';
                vm.dataToFill.pickUpLng = '';
                getPreviousAddressHit(1);
            }
        }

        function dropOffAddressBlank() {
            vm.crossFlag = true;
            vm.ErrorFlagForNewApi = false;
            if (vm.modifyFalg) {
                if (vm.toAirportFlag || vm.fromAirportFlag) {
                    vm.dataToFill.pickUpAddress = '';
                    vm.dataToFill.dropOffAddress = '';
                    vm.dataToFill.pickUpLat = '';
                    vm.dataToFill.pickUpLng = '';
                    vm.dataToFill.dropOffLat = '';
                    vm.dataToFill.dropOffLng = '';
                    // vm.isActivePick = false;
                    vm.isActiveDrop = false;
                } else {
                    vm.dataToFill.dropOffAddress = '';
                    vm.dataToFill.dropOffLat = '';
                    vm.dataToFill.dropOffLng = '';
                }
            } else {
                vm.dataToFill.dropOffAddress = '';
                vm.dataToFill.dropOffLat = '';
                vm.dataToFill.dropOffLng = '';
                getPreviousAddressHit(2)
            }
        }

        function selectFavAddressNewPop(type, data) {
            if (type == 1) {
                vm.dataToFill.pickUpAddress = data.address;
                vm.dataToFill.favPickLocId = data.location_id;
                vm.addressChange = true;
                makeByPassFunctionForFav('1');
            } else {
                vm.dataToFill.dropOffAddress = data.address;
                vm.dataToFill.favDropLocId = data.location_id;
                makeByPassFunctionForFav('2');
            }
            vm.disabledSubmitButton1 = true;
        }

        function getAirportAddressApi() {
            var dataSend = {};
            var latitude, longitude;
            if (vm.toAirportFlag) {
                latitude = vm.dataToFill.pickUpLat;
                longitude = vm.dataToFill.pickUpLng;
            } else if (vm.fromAirportFlag) {
                latitude = vm.dataToFill.dropOffLat;
                longitude = vm.dataToFill.dropOffLng;
            }
            dataSend.type_of_trip = vm.toAirportFlag ? 'R' : 'Z';
            dataSend.lat = latitude;
            dataSend.long = longitude;
            vm.loading = true;
            var promise = getBookings.getAirportAddress(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        vm.ErrorFlagForNewApi = false;
                        if (vm.toAirportFlag) {
                            vm.dataToFill.dropOffLat = payload.title.data.airport_latitude;
                            vm.dataToFill.dropOffLng = payload.title.data.airport_longitude;
                            vm.dataToFill.dropLat = payload.title.data.airport_latitude;
                            vm.dataToFill.dropLng = payload.title.data.airport_longitude;
                            vm.dataToFill.dropOffAddress = payload.title.data.airport_address;
                            vm.dropOffLat = payload.title.data.airport_latitude;
                            vm.dropOffLng = payload.title.data.airport_longitude;
                        } else {
                            vm.dataToFill.pickUpLat = payload.title.data.airport_latitude;
                            vm.dataToFill.pickUpLng = payload.title.data.airport_longitude;
                            vm.dataToFill.pickLat = payload.title.data.airport_latitude;
                            vm.dataToFill.pickLng = payload.title.data.airport_longitude;
                            vm.dataToFill.pickUpAddress = payload.title.data.airport_address;
                            vm.pickUpLat = payload.title.data.airport_latitude;
                            vm.pickUpLng = payload.title.data.airport_longitude;
                            if (vm.dataToFill.serviceTypeSelected) { //&& (vm.dataToFill.bookingType == '0' || vm.dataToFill.bookingType == 0)
                                vm.dataToFill.nearDriver = '';
                                toGetAirportService(vm.dataToFill.pickUpLat, vm.dataToFill.pickUpLng, vm.dataToFill.serviceTypeSelected, map);
                                //toGetNearByDrivers(vm.dataToFill.pickUpLat,vm.dataToFill.pickUpLng,vm.dataToFill.serviceTypeSelected,map);
                            }
                        }
                        if (vm.modifyFalg) {
                            vm.airportAddress = payload.title.data.airport_address;
                            vm.airportLatitude = payload.title.data.airport_latitude;
                            vm.airportLongitude = payload.title.data.airport_longitude;
                        }

                        vm.dropaddressChange = true;
                        vm.pickaddressChange = true;
                        vm.dataToFill.previousDropFlag = false;
                        vm.dataToFill.previousDropFlag = false;
                        if (!vm.modifyFalg || vm.getFixedRoutesForPersonalFlag)
                            getFixedRoutesForPersonal(vm.dataToFill);
                    } else if (payload.title.status == 800) {
                        // vm.dataToFill.dropOffAddress = '';
                        vm.dataToFill.dropOffLng = '';
                        vm.dataToFill.dropOffLat = '';
                        vm.dataToFill.dropOffAddress = '';
                        vm.dataToFill.pickUpLng = '';
                        vm.dataToFill.pickUpLat = '';
                        // vm.dataToFill.pickUpAddress = '';
                        vm.ErrorFlagForNewApi = true;
                        vm.ErrorFlagForNewApiMessage = payload.title.message;
                        openPopForErrorAddress(payload);
                    } else {
                        // vm.dataToFill.dropOffAddress = '';
                        vm.dataToFill.dropOffLng = '';
                        // vm.dataToFill.dropOffAddress = '';
                        vm.dataToFill.pickUpLng = '';
                        vm.dataToFill.dropOffLat = '';
                        vm.dataToFill.pickUpLat = '';
                        // vm.dataToFill.pickUpAddress = '';
                        vm.ErrorFlagForNewApi = true;
                        vm.ErrorFlagForNewApiMessage = payload.title.message;
                        // setTimeout(function () {
                        //     vm.ErrorFlagForNewApi = false;
                        //     vm.ErrorFlagForNewApiMessage = '';
                        //     $scope.$apply();
                        // }, 5000);
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    $scope.items.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function openPopForErrorAddress(data) {
            vm.items = {
                data: data.title.message
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                // targetEvent: $event,
                templateUrl: 'app/components/dialogViews/errorForCreateBooking.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });

            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    if(!$scope.$$phase) {
                        $mdDialog.hide();
                        vm.dataToFill.serviceTypeSelected = '';
                        vm.loading = false;
                    }
                };
                $scope.confirmUpload = function () { }
            }
        }

        function openPopForWaringMessage(trip) {
            vm.items = {
                trip: trip
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                // targetEvent: $event,
                templateUrl: 'app/components/dialogViews/waringMessageForCreateBooking.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });

            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () { }
            }
        }
    }



})();

/**
 * Created by cl-macmini-51 on 11/10/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('ViewCorrectFareReasonController', ViewCorrectFareReasonController);

    /** @ngInject */
    function ViewCorrectFareReasonController($cookies, $state, $log, $rootScope, $timeout, getCars, $scope, filterFilter, $mdDialog,$document, getCorrectFareReason,$stateParams,
                                             languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.getCorrectFareReasonHit = getCorrectFareReasonHit;
        vm.goBack = goBack;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.correctFareReasonMain.viewCorrectFareReason');
            }
        });
        //=====================add new reason hit=========================
        function getCorrectFareReasonHit(){
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = 0;
            dataSend.offset = 0;
            dataSend.reason_id = Number($stateParams.id);
            var promise = getCorrectFareReason.getCorrectFareReasonList(dataSend);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    vm.correctFareReasonDetail = payload.title.data.result[0];
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        getCorrectFareReasonHit();

        //=================go back================
        function goBack() {
            $state.go('layout.correctFareReasonMain.correctFareReason');
        };
    }
})();

/**
 * Created by cl-macmini-51 on 11/10/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('CorrectFareReasonController', CorrectFareReasonController);

    /** @ngInject */
    function CorrectFareReasonController($cookies, $state, $log, $rootScope, $timeout, getCars, $scope, filterFilter, $mdDialog,$document, getCorrectFareReason, languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.totalReasons = 0;
        vm.currentPage = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.getPagesCount = getPagesCount;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.init = init;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.noDataFlag = false;
        vm.predicate = 'index';
        vm.reverse = false;
        vm.addNewReason = addNewReason;
        vm.sort = sort;
        vm.getCorrectFareReasonHit = getCorrectFareReasonHit;
        vm.changeReasonStatus = changeReasonStatus;
        vm.editReasonPop = editReasonPop;
        vm.deleteReason = deleteReason;
        vm.paginationNew = paginationNew;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.filterData = {
            correctFareStatus: '0'
        };

        //====================function for dropdown pages and page count===============
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];

        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getCorrectFareReasonHit(0, vm.itemsPerPageGot,vm.filterData.correctFareStatus);
        };

        function paginationNew(page){
            getCorrectFareReasonHit((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot,vm.filterData.correctFareStatus);
        }

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.correctFareReasonMain.correctFareReason');
            }
        });
        //=====================add new reason hit=========================
        function getCorrectFareReasonHit(skip, limit,filter){
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit;
            dataSend.offset = skip;
            dataSend.status = Number(filter);
            var promise = getCorrectFareReason.getCorrectFareReasonList(dataSend);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    vm.totalReasons = payload.title.data.totalCount;
                    vm.dataLength = payload.title.data.totalCount;

                    if (payload.title.data.totalCount == 0) {
                        vm.sp_pagination = false;
                        vm.tBodyFlag = false;
                        vm.tFootFlag = true;
                        vm.filterOn = true;
                        vm.skipValueFilter = 0;
                    } else {
                        vm.sp_pagination = true;
                        vm.tBodyFlag = true;
                        vm.tFootFlag = false;
                        vm.filterOn = false;
                        vm.skipValueFilter = 0;

                        var dataArray = [];

                        var correctFareReasonList = payload.title.data.result;
                        correctFareReasonList.forEach(function(column) {
                            var d = {};
                            d.id = column.reason_id;
                            d.reason = column.reason;
                            d.status = column.block_status;
                            d.description = column.description;
                            dataArray.push(d);
                        });
                        vm.correctFareReasonList = dataArray;

                        for (var i = 0; i < vm.correctFareReasonList.length; i++) {
                            vm.correctFareReasonList[i].index = (skip + i);
                        }
                        if (vm.dataLength <= vm.itemsPerPageGot) {
                            vm.sp_pagination = false;
                        } else {
                            vm.sp_pagination = true;
                            //vm.pageCount(payload.title.data.totalCount);
                        }
                        vm.skipValue = vm.correctFareReasonList[0].index;
                        vm.limitValue = vm.correctFareReasonList[vm.correctFareReasonList.length - 1].index;

                        $scope.$watch('vm.search', function(newVal, oldVal) {
                            vm.filtered = filterFilter(vm.correctFareReasonList, newVal);
                            vm.totalItems = vm.filtered.length;
                            if (vm.filtered.length == 0) {
                                vm.watchPagination = false;
                            } else {
                                vm.watchPagination = true;
                            }
                            if (vm.filterOn == true) {
                                vm.skipValueFilter = vm.filtered.length;
                                vm.sp_pagination = false;
                            }
                        }, true);

                        //range();
                    }
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    } else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        vm.getCorrectFareReasonHit((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData.correctFareStatus);
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        vm.currentPage++;
        //        vm.getCorrectFareReasonHit((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData.correctFareStatus);
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    vm.getCorrectFareReasonHit((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData.correctFareStatus);
        //};

        function init() {
            vm.getCorrectFareReasonHit(0, vm.searchModel.limit,vm.filterData.correctFareStatus);
        };
        init();

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            vm.filterOn = true;
            if (vm.search.length == 0) {
                vm.filterOn = false;
                vm.watchPagination = true;
                vm.sp_pagination = true;
            }
        };

        //===========================change price list status=========================
        function changeReasonStatus(id,value,$event){
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('statusReasonPop',0,'3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton',0,'3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton',0,'3'));

            $mdDialog.show(confirm).then(function() {
                var a = '';
                var msgSys = '';
                if (value == 0) {
                    a = 1;
                    msgSys = 'Reason blocked';
                } else if (value == 1) {
                    a = 0;
                    msgSys = 'Reason unblocked';
                }
                //errorMessageFactory.showErrorMessage('Functionality is pending.',0);
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.blocking_status = a;
                dataSend.reason_id = id;
                vm.loading = true;
                var promise = getCorrectFareReason.statusCorrectFareReason(dataSend);
                promise.then(
                    function(payload) {
                        $log.log(payload);
                        vm.loading = false;
                        var dataForSysLogs = {
                            access_token: $cookies.get('obj'),
                            id: id,
                            identity : 23,  // 0- driver, 1- customer , 2 -car,3-cancel reason
                            message : msgSys
                        };
                        $rootScope.systemLogsAdmin(dataForSysLogs);
                        languageBasedErrorFactory.getProperErrorMessage('statusReasonSucc',0,1,'layout.correctFareReasonMain.correctFareReason')
                        //errorMessageFactory.showErrorMessage('Reason status updated successfully.',1);
                        //$timeout(function() {
                        //    $mdDialog.hide();
                        //    $state.reload();
                        //}, 2000);
                    },
                    function(errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if(errorPayload.data.status == 401){
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                        }
                        else{
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                        }
                    }
                );

            }, function() {
                $log.log('not confirmed');
            });
        };

        //=====================add new reason hit=========================
        function addNewReasonHit(data){
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.reason = data.reason;
            dataSend.description = data.description;

            vm.loading = true;
            var promise = getCorrectFareReason.addCorrectFareReason(dataSend);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    languageBasedErrorFactory.getProperErrorMessage('addReasonSucc',0,1,'layout.correctFareReasonMain.correctFareReason')
                    //errorMessageFactory.showErrorMessage('Reason added successfully.',1);
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };

        //========================add new reason pop==========================
        function addNewReason($event){
            vm.items = {
                reason: '',
                description: ''
            }
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/addCorrectFareReason.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });
            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    $mdDialog.hide();
                    addNewReasonHit($scope.items);
                };
            }
        };

        //===================edit reason hit======================
        function editReasonHit(data){
            var dataSend = {};
            dataSend = data;
            dataSend.access_token = $cookies.get('obj');


            vm.loading = true;
            var promise = getCorrectFareReason.editCorrectFareReason(dataSend);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    var dataForSysLogs = {
                        access_token: $cookies.get('obj'),
                        id: data.reason_id,
                        identity : 23,  // 0- driver, 1- customer , 2 -car,3-cancel reason
                        message : 'Reason updated.'
                    };
                    $rootScope.systemLogsAdmin(dataForSysLogs);
                    languageBasedErrorFactory.getProperErrorMessage('editReasonSucc',0,1,'layout.correctFareReasonMain.correctFareReason')
                    //errorMessageFactory.showErrorMessage('Reason updated successfully.',1);
                    //$timeout(function() {
                    //    $mdDialog.hide();
                    //    $state.reload();
                    //}, 2000);
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        //===============edit reason pop=====================
        function editReasonPop(data,$event){
            vm.items = {
                reason: data.reason,
                description: data.description,
                reason_id: data.id
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/editCorrectFareReason.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });
            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    $mdDialog.hide();
                    editReasonHit($scope.items);
                };
            }
        };
        //======================delete reason hit===========================
        function deleteReason(data, $event) {
            var confirm = $mdDialog.confirm()
                .title( languageBasedErrorFactory.getProperErrorMessage('deleteReasonPop',0,'3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok( languageBasedErrorFactory.getProperErrorMessage('confirmButton',0,'3'))
                .cancel( languageBasedErrorFactory.getProperErrorMessage('CloseButton',0,'3'));

            $mdDialog.show(confirm).then(function() {
                $log.log('confirmed');
                var dataSend = {
                    access_token: $cookies.get('obj'),
                    reason_id: data.id
                };
                //errorMessageFactory.showErrorMessage('Functionality is pending.',0);
                vm.loading = true;
                var promise = getCorrectFareReason.deleteCorrectFareReason(dataSend);
                promise.then(
                    function(payload) {
                        $log.log(payload);
                        vm.loading = false;
                        languageBasedErrorFactory.getProperErrorMessage('deleteReasonSucc',0,1,'layout.correctFareReasonMain.correctFareReason')
                        //errorMessageFactory.showErrorMessage('Reason deleted successfully.',1);
                    },
                    function(errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if(errorPayload.data.status == 401){
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                        }
                        else{
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                        }
                    }
                );
            }, function() {
                $log.log('not confirmed');
            });
        }
    }
})();

/**
 * Created by cl-macmini-51 on 7/13/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .controller('ViewCorporateDetailsController', ViewCorporateDetailsController);

    /** @ngInject */
    function ViewCorporateDetailsController($cookies, $state, $log, $rootScope, $mdDialog, $timeout, $document, getCorporate, $scope, filterFilter, RutHelper,$stateParams,languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.getAllCorporates = getAllCorporates;
        vm.goBack = goBack;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.loading = false;

        //====================event for getting refreshed================
        $scope.$on('StateReload', function(evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.corporateMain.viewCorporate');
            }
        });
        //==================get all corporates=======================
        function getAllCorporates(skip, limit,filter) {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit;
            dataSend.offset = skip;
            dataSend.key = filter;
            dataSend.search_filter = 0;
            var promise = getCorporate.allCorporates(dataSend);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.corporateDetails = _.where(payload.title.data.result,{id:Number($stateParams.id)})[0];
                    if(vm.corporateDetails.RUT){
                        vm.corporateDetails.RUT = RutHelper.format(vm.corporateDetails.RUT);
                    }
                    if(vm.corporateDetails.contactPersonData && vm.corporateDetails.contactPersonData.person_RUT){
                        vm.corporateDetails.contactPersonData.person_RUT = RutHelper.format(vm.corporateDetails.contactPersonData.person_RUT);
                    }
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        getAllCorporates(0,0,2);

        //===================function go back========================
        function goBack(){
            $state.go('layout.corporateMain.corporate');
        };
    }
})();
/**
 * Created by cl-macmini-51 on 5/29/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .controller('EditCorporateController', EditCorporateController);

    /** @ngInject */
    function EditCorporateController($cookies, $state, $log, $rootScope, $mdDialog, $timeout, $document, getCorporate, $scope, filterFilter, $stateParams, RutHelper,languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.dataToFill = {
            company_name: '',
            type_of_company: '',
            latitude: '',
            longitude: '',
            state: '',
            city: '',
            street: '',
            flat_no: '',
            RUT: '',
            contact_person_name: '',
            designation: '',
            contact_person_phone_number: '',
            contact_person_email_id: '',
            contact_person_RUT: '',
            fullAddress: '',
            status: '',
            address: '',
            company_holding: '',
            company_holding_name: '',
            holding: ''
        };
        vm.componentForm = {
            street_number: 'short_name',
            locality: 'long_name',
            postal_code: 'short_name',
            country: 'long_name',
            administrative_area_level_1: 'long_name'
        };
        vm.companyHoldingList = [];
        vm.errorFlag = '';
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.rutChange = rutChange;
        vm.rutChangePerson = rutChangePerson;
        vm.getAllCorporates = getAllCorporates;
        vm.goBack = goBack;
        vm.ctrlFn = ctrlFn;
        vm.editApi = editApi;
        vm.selectHolding = selectHolding;
        //====================event for getting refreshed================
        $scope.$on('StateReload', function(evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.corporateMain.editCorporate');
            }
        });

        function goBack(){
            $state.go('layout.corporateMain.corporate');
        };

        //===================select holding=================
        function selectHolding(){
            if(vm.dataToFill.holding == '1'){
                vm.dataToFill.company_holding = 0;
            }
            else{
                //vm.dataToFill.company_holding = 0;
                //getAllCorporates(0,0,2);
            }
        }

        //==================get all corporates=======================
        function getAllCorporates(skip, limit,filter) {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit;
            dataSend.offset = skip;
            dataSend.key = filter;
            dataSend.search_filter = 0;
            var promise = getCorporate.allCorporates(dataSend);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    var where = _.where(payload.title.data.result,{id: Number($stateParams.id)});
                    $log.log('where', where);
                    vm.dataToFill = {
                        company_name: where[0].company_name,
                        type_of_company: where[0].type_of_company,
                        latitude: where[0].latitude,
                        longitude: where[0].longitude,
                        state: where[0].state,
                        city: where[0].city,
                        street: where[0].street,
                        flat_no: where[0].flat_no,
                        RUT: RutHelper.format(where[0].RUT),
                        contact_person_name: where[0].contactPersonData && where[0].contactPersonData.person_name ? where[0].contactPersonData.person_name : '',
                        designation: where[0].contactPersonData && where[0].contactPersonData.designation ? where[0].contactPersonData.designation : '',
                        contact_person_phone_number: where[0].contactPersonData && where[0].contactPersonData.person_phone_number ? where[0].contactPersonData.person_phone_number : '',
                        contact_person_email_id: where[0].contactPersonData && where[0].contactPersonData.person_email_id ? where[0].contactPersonData.person_email_id : '',
                        contact_person_RUT: where[0].contactPersonData && where[0].contactPersonData.person_RUT ? RutHelper.format(where[0].contactPersonData.person_RUT) : '',
                        fullAddress: '',
                        status: where[0].status,
                        address: where[0].address?where[0].address:'',
                        company_holding: where[0].company_holding==null?0:where[0].company_holding,
                        company_holding_name: where[0].company_holding_name,
                        holding: where[0].holding.toString()

                    };

                    var where1 = _.where(payload.title.data.result,{holding: 1});
                    $log.log('where', where1);
                    vm.companyHoldingList = [];
                    vm.companyHoldingList.push(
                        {
                            name: $cookies.get('language') == 'en'?'Not Applicable':'No Aplica',
                            id: 0
                        }
                    );
                    for(var i=0;i<where1.length;i++){
                        if(where1[i].id != $stateParams.id){
                            vm.companyHoldingList.push({
                                name: where1[i].company_name,
                                id: where1[i].id
                            })
                        }
                    }
                    if(vm.companyHoldingList.length == 1){
                        vm.errorFlag = languageBasedErrorFactory.getProperErrorMessage('noHoldingCompany',0,'3');
                    }
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        getAllCorporates(0,0,2);

        //=====================function for changing address===========================
        function ctrlFn(data) {
            vm.dataToFill.address = data.formatted_address;
            for (var i = 0; i < data.address_components.length; i++) {
                for (var j = 0; j <= data.address_components[i].types.length; j++) {
                    var addressType = data.address_components[i].types[j];
                    if (addressType == 'street_number') {
                        var street_number = data.address_components[i][vm.componentForm[addressType]];
                    } else if (addressType == 'locality') {
                        var locality = data.address_components[i][vm.componentForm[addressType]];
                    } else if (addressType == 'country') {
                        var country = data.address_components[i][vm.componentForm[addressType]];
                    } else if (addressType == 'administrative_area_level_1') {
                        var state = data.address_components[i][vm.componentForm[addressType]];
                    }
                    if (addressType == 'postal_code') {
                        var postalCode = data.address_components[i][vm.componentForm[addressType]];
                    } else {
                    }
                }
            }

            if (data.geometry.location.lat()) {
                vm.dataToFill.latitude = data.geometry.location.lat();
            }
            if (data.geometry.location.lng()) {
                vm.dataToFill.longitude = data.geometry.location.lng();
            }

            if (locality) {
                vm.dataToFill.city = locality;
            } else {
                vm.dataToFill.city = '';
            }
            if (state) {
                vm.dataToFill.state = state;
            } else {
                vm.dataToFill.state = '';
            }
            if (street_number) {
                vm.dataToFill.street = street_number;
            } else {
                vm.dataToFill.street = '';
            }
        }

        //=====================function for changing rut===========================
        function rutChange() {
            $log.log('data', vm.dataToFill.RUT);
            if (vm.dataToFill.RUT) {
                if (RutHelper.validate(vm.dataToFill.RUT)) {
                    $log.log();
                    vm.rutFlag = false;
                } else {
                    vm.rutFlag = true;
                }
            } else if (vm.dataToFill.RUT === null) {
                vm.rutFlag = true;
            } else if (vm.dataToFill.RUT === undefined) {
                vm.rutFlag = false;
            }
        };

        function rutChangePerson() {
            $log.log('data', vm.dataToFill.contact_person_RUT);
            if (vm.dataToFill.contact_person_RUT) {
                if (RutHelper.validate(vm.dataToFill.contact_person_RUT)) {
                    $log.log();
                    vm.rutFlag_person = false;
                } else {
                    vm.rutFlag_person = true;
                }
            } else if (vm.dataToFill.contact_person_RUT === null) {
                vm.rutFlag_person = true;
            } else if (vm.dataToFill.contact_person_RUT === undefined) {
                vm.rutFlag_person = false;
            }
        };

        //=====================edit api hit======================
        function editApi(){
            $log.log(vm.dataToFill);

            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.corporate_id = Number($stateParams.id);
            //dataSend.street = vm.dataToFill.street;
            //dataSend.city = vm.dataToFill.city;
            //dataSend.flat_no = vm.dataToFill.flat_no;
            //dataSend.status = Number(vm.dataToFill.status);
            //dataSend.state = vm.dataToFill.state;
            dataSend.company_name = vm.dataToFill.company_name;
            dataSend.holding = vm.dataToFill.holding;
            dataSend.company_holding = vm.dataToFill.company_holding;
            dataSend.company_holding_name = _.where(vm.companyHoldingList,{id:dataSend.company_holding})[0].name;
            //dataSend.type_of_company = vm.dataToFill.type_of_company;
            //dataSend.latitude = vm.dataToFill.latitude;
            //dataSend.longitude = vm.dataToFill.longitude;
            dataSend.RUT = RutHelper.clean(vm.dataToFill.RUT);
            //dataSend.designation = vm.dataToFill.designation;
            //dataSend.contact_person_name = vm.dataToFill.contact_person_name;
            //dataSend.contact_person_email_id = vm.dataToFill.contact_person_email_id;
            //dataSend.contact_person_phone_number = vm.dataToFill.contact_person_phone_number;
            //dataSend.contact_person_RUT = RutHelper.clean(vm.dataToFill.contact_person_RUT);
            //dataSend.address = vm.dataToFill.address;
            $log.log(dataSend);
            vm.loading = true;
            var promise = getCorporate.editCorporate(dataSend);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    var dataForSysLogs = {
                        access_token: $cookies.get('obj'),
                        id: $stateParams.id,
                        identity : 6,
                        message : 'Corporate details updated.'
                    };
                    $rootScope.systemLogsAdmin(dataForSysLogs);
                    languageBasedErrorFactory.getProperErrorMessage('corpoEditSucc',0,2,'layout.corporateMain.corporate');
                    //errorMessageFactory.showErrorMessage('Corporate details updated successfully.',2,'layout.corporateMain.corporate');
                    //$timeout(function() {
                    //    $mdDialog.hide();
                    //    $state.reload();
                    //}, 2000);
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
    }

})();
/**
 * Created by cl-macmini-51 on 4/19/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('CorporateController', CorporateController);

    /** @ngInject */
    function CorporateController($cookies, $state, $log, $rootScope, $mdDialog, $timeout, $document, getCorporate, $scope, filterFilter, RutHelper, languageBasedErrorFactory, errorMessageFactory, pendingRequests) {
        var vm = this;
        vm.getAllCorporates = getAllCorporates;
        vm.loading = false;
        vm.currentPage = 0;
        vm.totalCorporates = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.filterTextTimeout = '';
        vm.getPagesCount = getPagesCount;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.init = init;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.deleteCorporate = deleteCorporate;
        vm.changeCorporateStatus = changeCorporateStatus;
        vm.exportToCSV = exportToCSV;
        vm.refreshData = refreshData;
        vm.paginationNew = paginationNew;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.predicate = 'index';
        vm.reverse = false;
        vm.filterData = {
            corporateStatus: '1',
            search_filter: 0,
            search_value: ''
        };
        //====================function for dropdown pages and page count===============
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];

        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllCorporates(0, vm.itemsPerPageGot, vm.filterData);
        };

        function paginationNew(page) {
            getAllCorporates((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData);
        }

        //==================refreshData=====================
        function refreshData() {
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllCorporates(vm.currentPage * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData);
        }


        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.corporateMain.corporate');
            }
        });

        //==================get all corporates=======================
        function getAllCorporates(skip, limit, filter) {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = Number(limit);
            dataSend.offset = Number(skip);
            dataSend.key = Number(filter.corporateStatus);
            dataSend.search_filter = filter.search_filter;
            if (filter.search_filter == 1) {
                dataSend.search_value = filter.search_value;
            }
            var promise = getCorporate.allCorporates(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return [];
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return [];
                    } else if (payload.title.status == 201 || payload.title.status == 200) {

                        vm.totalCorporates = payload.title.data.totalCount;
                        vm.dataLength = payload.title.data.totalCount;

                        if (payload.title.data.totalCount == 0) {
                            vm.sp_pagination = false;
                            vm.tBodyFlag = false;
                            vm.tFootFlag = true;
                            vm.filterOn = true;
                            vm.skipValueFilter = 0;
                        } else {
                            vm.sp_pagination = true;
                            vm.tBodyFlag = true;
                            vm.tFootFlag = false;
                            vm.filterOn = false;
                            vm.skipValueFilter = 0;

                            var dataArray = [];

                            var corporateList = payload.title.data.result || [];
                            corporateList.forEach(function (column) {
                                var d = {};
                                d.id = column.id;
                                d.company_name = column.company_name;
                                d.type_of_company = column.type_of_company;
                                d.flat_no = column.flat_no;
                                d.street = column.street;
                                d.state = column.state;
                                d.city = column.city;
                                d.status = column.status;
                                d.statusNew = column.status.toString();
                                d.RUT = RutHelper.format(column.RUT);
                                d.created_on = column.created_on;
                                d.created_by = column.created_by;
                                d.updated_on = column.updated_on;
                                d.updated_by = column.updated_by;
                                d.address = column.address;
                                d.holding = column.holding;
                                d.company_holding = column.company_holding;
                                d.company_holding_name = column.company_holding_name;
                                dataArray.push(d);
                            });
                            vm.corporateList = dataArray;

                            // USERTYPE VALUE
                            // 0 - Transvip user
                            // 1 - PET user
                            vm.userType = payload.title.data.user_type || 0;

                            for (var i = 0; i < vm.corporateList.length; i++) {
                                vm.corporateList[i].index = (skip + i);
                            }
                            if (vm.dataLength <= vm.itemsPerPageGot) {
                                vm.sp_pagination = false;
                            } else {
                                vm.sp_pagination = true;
                                //vm.pageCount(payload.title.data.totalCount);
                            }
                            vm.skipValue = vm.corporateList[0].index;
                            vm.limitValue = vm.corporateList[vm.corporateList.length - 1].index;

                            //$scope.$watch('vm.search', function(newVal, oldVal) {
                            //    vm.filtered = filterFilter(vm.corporateList, newVal);
                            //    vm.totalItems = vm.filtered.length;
                            //    if (vm.filtered.length == 0) {
                            //        vm.watchPagination = false;
                            //    } else {
                            //        vm.watchPagination = true;
                            //    }
                            //    if (vm.filterOn == true) {
                            //        vm.skipValueFilter = vm.filtered.length;
                            //        vm.sp_pagination = false;
                            //    }
                            //}, true);

                            //range();
                        }
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    } else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        vm.getAllCorporates((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        vm.currentPage++;
        //        vm.getAllCorporates((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    vm.getAllCorporates((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //};

        function init() {
            vm.getAllCorporates(0, vm.searchModel.limit, vm.filterData);
        };
        init();

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            //vm.filterOn = true;
            vm.currentPage = 0;
            vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
            vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
            pendingRequests.cancelAll();
            if (vm.search.length == 0) {
                vm.filterData.search_filter = 0;
                vm.filterData.search_value = '';
                vm.getAllCorporates(0, vm.searchModel.limit, vm.filterData);
                //vm.filterOn = false;
                //vm.watchPagination = true;
                //vm.sp_pagination = true;

            } else {
                vm.filterData.search_filter = 1;
                vm.filterData.search_value = vm.search;
                //if (vm.filterTextTimeout) $timeout.cancel(vm.filterTextTimeout);
                //vm.filterTextTimeout = $timeout(function(){
                vm.getAllCorporates(0, vm.searchModel.limit, vm.filterData);
                //},500);
            }
        };
        //=====================to delete driver====================
        function deleteCorporate(id, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('deleteCorpoPop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                errorMessageFactory.showErrorMessage('Functionality is pending.', 0);
                //vm.loading = true;
                //var promise = getDrivers.deleteUser(id);
                //promise.then(
                //    function(payload) {
                //        $log.log(payload);
                //        vm.loading = false;
                //        errorMessageFactory.showErrorMessage('Corporate deleted successfully.',1);
                //    },
                //    function(errorPayload) {
                //        $log.log(errorPayload);
                //        vm.loading = false;
                //        if(errorPayload.data.status == 401){
                //            errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                //        }
                //        else{
                //            errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                //        }
                //    }
                //);
            }, function () {
                $log.log('not confirmed');
            });
        }
        //===========================change corporate status=========================
        function changeCorporateStatus(data, $event) {
            $log.log(data);

            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('statusCorpoPop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed', data);
                var msgSys = '';
                var dataSend = {};
                dataSend.corporate_id = data.id;
                if (data.status == 1) {
                    dataSend.status = 0;
                    msgSys = 'Corporate blocked.';
                } else if (data.status == 0) {
                    dataSend.status = 1;
                    msgSys = 'Corporate unblocked.';
                }
                dataSend.access_token = $cookies.get('obj');

                vm.loading = true;
                var promise = getCorporate.editCorporate(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        if (payload.title.status == 400) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            return [];
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                            return [];
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            var dataForSysLogs = {
                                access_token: $cookies.get('obj'),
                                id: data.id,
                                identity: 6,
                                message: msgSys
                            };
                            $rootScope.systemLogsAdmin(dataForSysLogs);
                            languageBasedErrorFactory.getProperErrorMessage('statusCorpoSucc', 0, 1, 'layout.corporateMain.corporate');
                            //errorMessageFactory.showErrorMessage('Corporate status updated successfully.',1);
                            //$timeout(function() {
                            //    $mdDialog.hide();
                            //    $state.reload();
                            //}, 2000);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        };

        //===============export to csv==================
        function exportToCSV(skip, limit, filter) {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = Number(limit);
            dataSend.offset = Number(skip);
            dataSend.key = Number(filter.corporateStatus);
            dataSend.search_filter = 0;
            var promise = getCorporate.allCorporates(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    var dataArrayExport = [];
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return [];
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return [];
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        var corporateListExport = payload.title.data.result;
                        corporateListExport.forEach(function (column) {
                            var d = {};
                            d['ID'] = column.id;
                            d['Company Name'] = column.company_name;
                            //d['Type of Company'] = column.type_of_company;
                            //d['Flat No.'] = column.flat_no;
                            //d['Street'] = column.street;
                            //d['State'] = column.state;
                            //d['City'] = column.city;
                            //d['Address'] = column.address;
                            d['RUT'] = RutHelper.format(column.RUT);
                            //if(column.contactPersonData){
                            //    d['Contact Person Name'] = column.contactPersonData.person_name ;
                            //    d['Contact Person Email'] = column.contactPersonData.person_email_id ;
                            //    d['Contact Person Mobile'] = column.contactPersonData.person_phone_number ;
                            //    d['Contact Person RUT'] = RutHelper.format(column.contactPersonData.person_RUT) ;
                            //    d['Contact Person Designation'] = column.contactPersonData.designation ;
                            //}
                            d['Holding?'] = column.holding == 0 ? 'No' : 'Yes';
                            d['Company Holding'] = column.company_holding == 0 || column.company_holding == null ? 'Not Applicable' : column.company_holding_name;
                            d['Status'] = column.status == 0 ? 'Inactive' : 'Active';
                            d['Deleted'] = column.is_deleted == 0 ? 'No' : 'Yes';
                            dataArrayExport.push(d);
                        });
                        vm.corporateListExport = dataArrayExport;
                        alasql('SELECT * INTO CSV("corporateList.csv",{headers:true}) FROM ?', [vm.corporateListExport]);

                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
    }

})();
/**
 * Created by cl-macmini-51 on 4/28/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .controller('AddCorporateController', AddCorporateController);

    /** @ngInject */
    function AddCorporateController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document, moment, getCorporate, $scope, RutHelper,languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.registerApi = registerApi;
        vm.goBack = goBack;
        vm.rutChange = rutChange;
        vm.rutChangePerson = rutChangePerson;
        vm.ctrlFn = ctrlFn;
        vm.selectHolding = selectHolding;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings(runThis);
        vm.companyHoldingList = [];
        vm.componentForm = {
            street_number: 'short_name',
            locality: 'long_name',
            postal_code: 'short_name',
            country: 'long_name',
            administrative_area_level_1: 'long_name'
        };
        vm.errorFlag = '';
        function runThis(){
            vm.dataToFill = {
                company_name: '',
                RUT: '',
                holding: '0',
                company_holding: 0,
                company_holding_name: ''
            };
        }

        function ctrlFn(data) {
            vm.dataToFill.address = data.formatted_address;

            for (var i = 0; i < data.address_components.length; i++) {
                for (var j = 0; j <= data.address_components[i].types.length; j++) {
                    var addressType = data.address_components[i].types[j];
                    if (addressType == 'street_number') {
                        var street_number = data.address_components[i][vm.componentForm[addressType]];
                    } else if (addressType == 'locality') {
                        var locality = data.address_components[i][vm.componentForm[addressType]];
                    } else if (addressType == 'country') {
                        var country = data.address_components[i][vm.componentForm[addressType]];
                    } else if (addressType == 'administrative_area_level_1') {
                        var state = data.address_components[i][vm.componentForm[addressType]];
                    }
                    if (addressType == 'postal_code') {
                        var postalCode = data.address_components[i][vm.componentForm[addressType]];
                    } else {
                    }
                }
            }

            if (data.geometry.location.lat()) {
                vm.dataToFill.latitude = data.geometry.location.lat();
            }
            if (data.geometry.location.lng()) {
                vm.dataToFill.longitude = data.geometry.location.lng();
            }

            if (locality) {
                vm.dataToFill.city = locality;
            } else {
                vm.dataToFill.city = '';
            }
            if (state) {
                vm.dataToFill.state = state;
            } else {
                vm.dataToFill.state = '';
            }
            if (street_number) {
                vm.dataToFill.street = street_number;
            } else {
                vm.dataToFill.street = '';
            }
        }


        function rutChange() {
            $log.log('data', vm.dataToFill.RUT);
            if (vm.dataToFill.RUT) {
                if (RutHelper.validate(vm.dataToFill.RUT)) {
                    $log.log();
                    vm.rutFlag = false;
                } else {
                    vm.rutFlag = true;
                }
            } else if (vm.dataToFill.RUT === null) {
                vm.rutFlag = true;
            } else if (vm.dataToFill.RUT === undefined) {
                vm.rutFlag = false;
            }
        }

        function rutChangePerson() {
            $log.log('data', vm.dataToFill.contact_person_RUT);
            if (vm.dataToFill.contact_person_RUT) {
                if (RutHelper.validate(vm.dataToFill.contact_person_RUT)) {
                    $log.log();
                    vm.rutFlag_person = false;
                } else {
                    vm.rutFlag_person = true;
                }
            } else if (vm.dataToFill.contact_person_RUT === null) {
                vm.rutFlag_person = true;
            } else if (vm.dataToFill.contact_person_RUT === undefined) {
                vm.rutFlag_person = false;
            }
        }

        //=====================get all corporates======================
        function getAllCorporates(skip, limit,filter) {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit;
            dataSend.offset = skip;
            dataSend.key = filter;
            dataSend.search_filter = 0;
            var promise = getCorporate.allCorporates(dataSend);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    var where = _.where(payload.title.data.result,{holding: 1});
                    $log.log('where', where);
                    //vm.companyHoldingList = vm.companyHoldingList[0];
                    //languageBasedErrorFactory.getTranslationStrings(runThisIndividual);
                    vm.companyHoldingList = [];
                    vm.companyHoldingList.push(
                        {
                            name: $cookies.get('language') == 'en'?'Not Applicable':'No Aplica',
                            id: 0
                        }
                    );
                    for(var i=0;i<where.length;i++){
                        vm.companyHoldingList.push({
                            name: where[i].company_name,
                            id: where[i].id
                        })
                    }
                    if(vm.companyHoldingList.length == 1){
                       vm.errorFlag = languageBasedErrorFactory.getProperErrorMessage('noHoldingCompany',0,'3');
                    }
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        getAllCorporates(0,0,2);
        //===================select holding=================
        function selectHolding(){
            if(vm.dataToFill.holding == '1'){
                vm.dataToFill.company_holding = 0;
            }
            else{
                //vm.dataToFill.company_holding = 0;
                getAllCorporates(0,0,2);
            }
        }

        //====================event for getting refreshed================
        $scope.$on('StateReload', function(evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.corporateMain.addCorporate');
            }
        });
        //=================go back================
        function goBack() {
            $state.go('layout.corporateMain.corporate');
        };
        //======================submit form====================
        function registerApi() {
            $log.log('12344', vm.dataToFill);

            var dataSend = vm.dataToFill;
            dataSend.company_holding_name = _.where(vm.companyHoldingList,{id:dataSend.company_holding})[0].name;
            dataSend.RUT = RutHelper.clean(dataSend.RUT);
            dataSend.access_token = $cookies.get('obj');
            vm.loading = true;
            var promise = getCorporate.addCorporate(dataSend);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    languageBasedErrorFactory.getProperErrorMessage('corpoAddSucc',0,2,'layout.corporateMain.corporate');
                    //errorMessageFactory.showErrorMessage('Corporate added successfully.',2,'layout.corporateMain.corporate');
                },
                function(errorPayload) {
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
    }
})();
/**
 * Created by cl-macmini-51 on 5/18/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('controlledWayController', controlledWayController);

    /** @ngInject */
    function controlledWayController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document,
        moment, $scope, RutHelper, controlledWayService, filterFilter, getGeofence,adminAccessService , getCorporate, languageBasedErrorFactory, errorMessageFactory, pendingRequests, getFilters) {

            var vm = this;
            vm.init = init;
            vm.getAllControlledWay = getAllControlledWay;
            vm.loading = false;
            vm.controlledWayData = [];
            vm.tBodyFlag = true;
            vm.tFootFlag = false;
            vm.changeDateIntoSpanish = changeDateIntoSpanish;
            vm.changeDateFormat = changeDateFormat;
            vm.numberWithCommas = numberWithCommas;

            function init() {
                console.log('debug', $cookies.get('obj'));
                vm.getAllControlledWay();
            };
            init();


            function getAllControlledWay() {
                console.log('debug');
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                vm.loading = true;
                var promise = controlledWayService.getControlledWayData(dataSend);
                promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
    
                        if (payload.title.status == 400) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            return [];
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                            return [];
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            console.log('debug', payload);
                            vm.controlledWayData = payload.title.data;
                            if(!vm.controlledWayData.length) {
                                vm.tBodyFlag = false;
                                vm.tFootFlag = true;
                            }
                            else {
                                vm.tBodyFlag = true;
                                vm.tFootFlag = false;
                            }
                        }
                    },
                    function (errorPayload) {
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            };

            function changeDateFormat(date) {
                // console.log(date);
                var data = date.split('T')[0];
                var newDate = new Date(data);
                //console.log(newDate,date.split('T')[1].split(':')[0],Number(date.split('T')[1].split(':')[1]));
                newDate.setHours(Number(date.split('T')[1].split(':')[0]));
                newDate.setMinutes(Number(date.split('T')[1].split(':')[1]));
                newDate.setSeconds(0);
                // console.log(newDate);
                return newDate;
            };

            function changeDateIntoSpanish(date) {
                var options = {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric'
                };
                return new Date(date).toLocaleString($cookies.get('language') == 'spanish' ? 'es' : 'en', options)
            }

            function numberWithCommas(x) {
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            };

    }
})();
/**
 * Created by cl-macmini-51 on 08/02/18.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('NewMessageController', NewMessageController);

    /** @ngInject */
    function NewMessageController($state, $timeout, languageBasedErrorFactory, $scope, $log, errorMessageFactory, getVehicles, getGeofence, DriverPushesService, $cookies, $document, $mdDialog, getFilters) {
        var vm = this;
        vm.unselected = false;
        vm.unselected1 = true;
        vm.destinationVechiloDriverArray = [];
        vm.checkGroupDriver = checkGroupDriver;
        vm.deleteTipoDriver = deleteTipoDriver;
        vm.groupDriver = [];
        vm.PopForDetails = PopForDetails;
        vm.driverGroupArray = [];
        vm.paginationChangedForGroupDriver = paginationChangedForGroupDriver;
        vm.unselected2 = true;
        vm.hideAddButton = false;
        vm.messageToSend = false;
        vm.globalLimit = 1000;
        vm.branchOffset = 0;
        vm.vehicleOffset = 0;

        vm.vehicle = [];
        vm.vehicle.push({
            id: 'all',
            name: 'Todos'
        });
        vm.branchList = [];
        vm.branchList.push({
            region_name: 'Todos',
            region_id: 'all'
        });
        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'vehicle', 'service', 'agreement', 'corporatesList', 'operation_point'];
        vm.changeMessageError = changeMessageError;
        vm.vechicle = vechicle;
        vm.AdTipoTheVechilo = AdTipoTheVechilo;
        vm.groups = groups;
        vm.selected = true;
        vm.buscar = buscar;
        vm.uploadMessageIcon = uploadMessageIcon;
        vm.sendPushToDrivers = sendPushToDrivers;
        vm.getDriverBuscarData = getDriverBuscarData;
        vm.getDriverBuscarDataByUniqueCarId = getDriverBuscarDataByUniqueCarId;
        vm.AddBuscarVechicle = AddBuscarVechicle;
        vm.deleteBuscarDriver = deleteBuscarDriver;
        vm.filterData = {
            UniqueCarId: '',
            Driver: '',
            vehicle: '',
            branch: '',
            limit: 10,
            offset: 0,
            offsetMade: 10,
            newMessage: '',
            Message: '',
            titleMessage: '',
            offsetViewDriver: 0
        }
        vm.destinationBuscarDriverArray = [];





        ///////////////  PAGINTAION FOR GROUP DRIVERS ////////////
        function paginationChangedForGroupDriver() {
            if (vm.dataLength > vm.groupDriver.length) {
                vm.filterData.offset = vm.filterData.offset + 10;
                getGroupDrivers(vm.filterData.offset, vm.filterData, 'scroll', false);
            }

        }
        ////////////////// CHECK GROUP DRIVER  //////////////////
        function checkGroupDriver(data) {
            vm.driverGroupArray.push(data);
            console.log(vm.driverGroupArray, 'vm.driverGroupArray');



        }

        function changeMessageError() {
            if (vm.filterData.Message != null || vm.filterData.Message != '' || vm.filterData.Message != "") {
                vm.messageToSend = false;
            } else {
                vm.messageToSend = true;
            }
        }

        ////////////////// Destination Data TO add Buscar Vechicle //////////////////
        var index = -1;

        function AddBuscarVechicle(data) {
            index = -1;
            index = _.findIndex(vm.destinationBuscarDriverArray, { // function to check weather the value alerady in destination section then return this 
                email: data.email
            });
            if (index == -1)
                vm.destinationBuscarDriverArray.push(data);
        }
        ////////////////// Destination Data TO add Buscar Vechicle //////////////////

        ////////////////// Destination Data TO delete Buscar Vechicle //////////////////
        function deleteBuscarDriver(index) {
            vm.destinationBuscarDriverArray.splice(index, 1); //  funtion to delete the driver from destionation sector 
        }
        ////////////////// Destination Data TO delete Buscar Vechicle //////////////////

        ////////////////// GET BUSCAR VALUE BY SEARCH  //////////////////
        function getDriverBuscarData(data) {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            if (vm.filterData.Driver != '')
                dataSend.search_value = vm.filterData.Driver;
            if (vm.filterData.UniqueCarId != '')
                dataSend.unique_car_id = Number(vm.filterData.UniqueCarId);
            var promise = DriverPushesService.getBuscarDriverData(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    vm.buscarDriverData = payload.title.data;
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        ////////////////// GET BUSCAR VALUE BY SEARCH  //////////////////


        ////////////////// GET BUSCAR VALUE BY UNIQUE CAR ID  //////////////////
        var filterTextTimeout = '';
        function getDriverBuscarDataByUniqueCarId(data) {
            if (vm.filterData.UniqueCarId != '') {
                if (filterTextTimeout) $timeout.cancel(filterTextTimeout);
                filterTextTimeout = $timeout(function () {
                    SearchByUniqueCar();
                }, 500);
            } else {
                // vm.buscarDriverData = [];
                SearchByUniqueCar();
            }
        }

        function SearchByUniqueCar() {
            vm.loading = true;
            var dataSend = {};
            var filterTextTimeout = '';
            dataSend.access_token = $cookies.get('obj');
            if (vm.filterData.Driver != '')
                dataSend.search_value = vm.filterData.Driver;
            if (vm.filterData.UniqueCarId != '')
                dataSend.unique_car_id = Number(vm.filterData.UniqueCarId);
            var promise = DriverPushesService.getBuscarDriverData(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    vm.buscarDriverData = payload.title.data;
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        ////////////////// GET BUSCAR VALUE BY UNIQUE CAR ID  //////////////////

        function PopForDetails(data, $event, type) {
            console.log(data, 'type', type);

            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.group_id = Number(data.group_id);
            var promise = DriverPushesService.DriverDetails(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    console.log(payload);

                    if (payload.title.status == 200) {
                        vm.nameData = payload.title.data[0];
                        openPopForDetails(payload.title.data[0], data, 0, $event, type);
                        // PopForDetails1(payload.title.data[0] , data, 0, $event, type)
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );

        }

        // function PopForDetails1(nameArray,data,count, $event, type , UniqueCar , search) {
        //     // vm.loading = true;
        //     console.log('type>>>>>>>',type);
        //     var dataSend = {};
        //     vm.count = 0;
        //     dataSend.access_token = $cookies.get('obj');
        //     dataSend.group_id = data.group_id;
        //     dataSend.limit = vm.filterData.limit;
        //     dataSend.offset = vm.filterData.offset;
        //     if(search){
        //         dataSend.search_value = search;
        //     }
        //     if(UniqueCar){
        //         dataSend.unique_car_id = UniqueCar;
        //     }
        //     var promise = DriverPushesService.getGroupDriversVeiw(dataSend);
        //     promise.then(
        //         function (payload) {
        //             $log.log(payload);
        //             vm.loading = false;
        //             console.log(payload, 'payload');
        //             if (payload.title.status == 200) {
        //                 console.log(payload,'type>>>>>>>>>><<<<<<<<<<<<<<<<<s   ', type);

        //                 vm.count = payload.title.data.total_count;
        //                 if (type == 'scroll') {
        //                     for (var i = 0; i < payload.title.data.data.length; i++) {
        //                         vm.FleetArray.push(payload.title.data.data[i]);
        //                     }
        //                 } else if(type == 'unscroll') {
        //                     vm.FleetArray = payload.title.data.data;
        //                     console.log(vm.FleetArray,'type>>>>>>>>>>',vm.count);
        //                     openPopForDetails(nameArray, data, vm.count, $event);
        //                 }else{
        //                     vm.FleetArray = [];
        //                     console.log(vm.FleetArray,'type>>>>>>>>>>',vm.count);
        //                     // vm.FleetArray = payload.title.data.data;
        //                     vm.count = payload.title.data.total_count;
        //                     for (var i = 0; i < payload.title.data.data.length; i++) {
        //                         vm.FleetArray.push(payload.title.data.data[i]);
        //                     }
        //                 }

        //             }
        //         },
        //         function (errorPayload) {
        //             $log.log(errorPayload);
        //             vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // }

        function openPopForDetails(nameArray, data, count, $event, type) {
            vm.items = {
                group_name: nameArray.group_name,
                group_description: nameArray.group_description,
                fleet_list: [],
                fleetCount: 0,
                UniqueCar: null,
                search: ''
            }
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/ViewGroupDetails.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });

            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.app = false;
                var filterTextTimeout = '';
                $scope.closeDialog = function () {
                    vm.filterData.offsetViewDriver = 0;
                    $mdDialog.hide();
                };

                function PopForDetails1(data, count, $event, type, UniqueCar, search) {
                    var dataSend = {};
                    vm.count = 0;
                    $scope.items.loading = true;
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.group_id = data.group_id;
                    dataSend.limit = vm.filterData.limit;
                    dataSend.offset = vm.filterData.offsetViewDriver;
                    console.log(search, 'search', UniqueCar, 'UniqueCar');

                    if (search != '') {
                        dataSend.search_value = search;
                    }
                    if (UniqueCar != null) {
                        dataSend.unique_car_id = UniqueCar;
                    }
                    var promise = DriverPushesService.getGroupDriversVeiw(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log(payload);
                            $scope.items.loading = false;
                            if (payload.title.status == 200) {
                                $scope.items.fleetCount = payload.title.data.total_count;
                                if (type == 'scroll') {
                                    for (var i = 0; i < payload.title.data.data.length; i++) {
                                        $scope.items.fleet_list.push(payload.title.data.data[i]);
                                    }
                                } else if (type == 'unscroll') {
                                    $scope.items.fleet_list = payload.title.data.data;
                                } else {
                                    $scope.items.fleetCount = payload.title.data.total_count;
                                    $scope.items.fleet_list = payload.title.data.data;
                                }

                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }
                PopForDetails1(data, count, $event, type, null, '');
                $scope.items.paginationChangedForVeiwDriverInGroup = function () {
                    if ($scope.items.fleetCount > $scope.items.fleet_list.length) {
                        vm.filterData.offsetViewDriver = vm.filterData.offsetViewDriver + 10;
                        PopForDetails1(data, $scope.items.count, $event, 'scroll', null, $scope.items.search);
                    }
                }
                $scope.items.getFilter = function () {
                    vm.FleetArray = [];
                    vm.filterData.offsetViewDriver = 0;
                    if ($scope.items.UniqueCar) {
                        if (filterTextTimeout) $timeout.cancel(filterTextTimeout);
                        filterTextTimeout = $timeout(function () {
                            vm.filterData.offsetViewDriver = 0;
                            PopForDetails1(data, $scope.items.count, $event, 'search', $scope.items.UniqueCar, $scope.items.search);
                        }, 500);
                        // dataSend.search_value = items.searchLogFleet;
                    } else {
                        // vm.FleetArray = [];
                        vm.filterData.offsetViewDriver = 0;
                        PopForDetails1(data, $scope.items.count, $event, 'search', null, $scope.items.search);
                    }
                    // PopForDetails1(data, $scope.items.count, $event, 'search', $scope.items.UniqueCar, $scope.items.search);
                }
                $scope.confirmUpload = function () {};
            }
        }

        ////////////////// FOR GROUP FUNCATION CODE IS HERE //////////////////
        function groups() {
            vm.unselected = true;
            vm.destinationVechiloDriverArray = [];
            vm.destinationBuscarDriverArray = [];
            vm.buscarDriverData = [];
            vm.unselected1 = true;
            vm.selected = false;
            vm.selected1 = true;
            vm.selected2 = false;
            vm.unselected2 = true;
            vm.filterData.branch = '';
            vm.filterData.vehicle = '';
            vm.filterData.UniqueCarId = '';
            vm.filterData.Driver = '';
            getGroupDrivers(vm.filterData.offset, vm.filterData, 'unscroll', true);
        }


        function getGroupDrivers(offset, limit, type, load) {
            vm.loading = load;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit.limit;
            dataSend.offset = offset;
            if (vm.filterData.serachGroupDriver)
                dataSend.search_value = vm.filterData.serachGroupDriver;
            var promise = DriverPushesService.getGroupDrivers(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    console.log(payload, 'payload');
                    if (payload.title.status == 200) {
                        if (payload && payload.title.data)
                            if (type == 'scroll') {
                                for (var i = 0; i < payload.title.data.data.length; i++) {
                                    vm.groupDriver.push(payload.title.data.data[i]);
                                }
                            } else {
                                vm.groupDriver = payload.title.data.data;
                            }
                        // vm.groupDriver = payload.title.data.data;
                        vm.dataLength = payload.title.data.total_count;

                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }


        ////////////////// FOR VECHICLE FUNCATION CODE IS HERE //////////////////
        function vechicle() {
            vm.destinationBuscarDriverArray = [];
            vm.destinationVechiloDriverArray = [];
            vm.buscarDriverData = [];
            // vm.destinationVechiloDriverArray  = 
            vm.driverGroupArray = [];
            vm.buscarDriverData = '';
            vm.filterData.UniqueCarId = '';
            vm.filterData.Driver = '';
            vm.unselected = true;
            vm.unselected2 = false;
            vm.filterData.offset = 0;
            vm.selected2 = true;
            vm.hideAddButton = false;
            vm.selected = false;
            vm.selected1 = false;
            vm.loading = false;
            getFilterDataFromBackend();
        }
        // ////////////////// FOR BRANCH LIST HERE  //////////////////
        // function branch() {
        //     vm.loading = true;
        //     var promise = getGeofence.branch();
        //     promise.then(
        //         function (payload) {
        //             $log.log(payload);
        //             vm.loading = false;
        //             if (payload.title.status == 400) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //             } else if (payload.title.status == 401) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //             } else if (payload.title.status == 201 || payload.title.status == 200) {
        //                 var where = _.where(payload.title.data, {
        //                     parent_id: 0
        //                 });
        //                 //vm.branchList = _.where(where, { is_active: 1 });
        //                 vm.branchList = where;

        //                 vm.branchList.push({
        //                     region_name: 'Todos',
        //                     region_id: 'all'
        //                 });
        //             }
        //         },
        //         function (errorPayload) {
        //             $log.log(errorPayload);
        //             vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // }

        // ////////////////// FOR VECHICLE LIST HERE //////////////////
        // function getVechicle() {
        //     var promise = getVehicles.allVehicles(0, 0, 2);
        //     promise.then(
        //         function (payload) {
        //             $log.log('sxdsads', payload);
        //             //vm.loading = false;
        //             if (payload.title.status == 400) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //             } else if (payload.title.status == 401) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //             } else if (payload.title.status == 201 || payload.title.status == 200) {
        //                 vm.vehicle = [];
        //                 angular.forEach(payload.title.data.result, function (column) {
        //                     vm.vehicle.push({
        //                         id: column.id,
        //                         name: column.name
        //                     })
        //                 });
        //                 vm.vehicle.push({
        //                     id: 'all',
        //                     name: 'Todos'
        //                 });
        //             }
        //         },
        //         function (errorPayload) {
        //             $log.log(errorPayload);
        //             //vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // }

        vm.filterObject = {
            access_token: $cookies.get('obj'),
            branch_filter: 1,
            vehicle_filter: 1,
            vehicle__status: 1,
            branch_limit: vm.globalLimit,
            branch_offset: vm.branchOffset,
            vehicle_limit: vm.globalLimit,
            vehicle_offset: vm.vehicleOffset,
            branch_search_filter: 0,
            vehicle_search_filter: 0,
        }

        function getFilterDataFromBackend(data, type) { //Acc to Index ['branch_search', 'vehicle_search', 'service_search', 'agreement_search', 'corporate_search', 'operation_point_search']
            if (data) {
                vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
            } else {
                vm.filterObject = {
                    access_token: $cookies.get('obj'),
                    branch_filter: 1,
                    vehicle_filter: 1,
                    vehicle__status: 1,
                    branch_search_filter: 0,
                    vehicle_search_filter: 0,
                }
            }

            // vm.filterObject.service_limit = vm.globalLimitService;
            // vm.filterObject.service_offset = vm.serviceOffset;
            vm.filterObject.branch_limit = vm.globalLimit;
            vm.filterObject.branch_offset = vm.branchOffset;
            vm.filterObject.vehicle_limit = vm.globalLimit;
            vm.filterObject.vehicle_offset = vm.vehicleOffset;
            // vm.filterObject.agreement_limit = vm.globalLimit;
            // vm.filterObject.agreement_offset = vm.agreementOffset;


            var promise = getFilters.getAllFilterData(vm.filterObject);
            promise.then(
                function (payload) {

                    // ********** BRANCH DATA ********
                    if (payload.title.data.branches) {
                        var index = _.findIndex(vm.branchList, {
                            region_id: 'all'
                        });
                        if (index == -1)
                            vm.branchList.push({
                                region_name: 'Todos',
                                region_id: 'all'
                            });
                        angular.forEach(payload.title.data.branches.data, function (column) {
                            var branchIndex = _.findIndex(vm.branchList, {
                                region_id: column.region_id
                            });
                            if (branchIndex == -1)
                                vm.branchList.push(column)
                        });
                        vm.branchTotalBackendCount = payload.title.data.branches.totalCount;
                    }

                    // ********** VEHICLE DATA ********
                    if (payload.title.data.vehicles) {
                        var index = _.findIndex(vm.vehicle, {
                            id: 'all'
                        });
                        if (index == -1)
                            vm.vehicle.push({
                                name: 'Todos',
                                id: 'all'
                            });
                        vm.vehicleTotalBackendCount = payload.title.data.vehicles.totalCount;
                        angular.forEach(payload.title.data.vehicles.data, function (column) {
                            // vm.vehicle.push({
                            //     id: column.id,
                            //     name: column.name
                            // })
                            var vechicleIndex = _.findIndex(vm.vehicle, {
                                id: column.id
                            });
                            if (vechicleIndex == -1)
                                vm.vehicle.push({
                                    id: column.id,
                                    name: column.name
                                })
                        });
                    }
                    vm.loading = false;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        }

        ////////////////// FOR BUSCAR FUNCATION CODE IS HERE //////////////////
        function buscar() {
            vm.filterData.branch = '';
            vm.driverGroupArray = [];
            vm.filterData.vehicle = '';
            vm.destinationVechiloDriverArray = [];
            vm.unselected = true;
            vm.selected = true;
            vm.unselected1 = true;
            vm.unselected2 = true;
            vm.unselected2 = true;
            vm.selected1 = false;
            vm.selected2 = false;
            vm.filterData.offset = 0;
        }

        ////////////////// FOR UPLOAD MESSAGE ICON FUNCATION CODE IS HERE //////////////////
        function uploadMessageIcon($event) {
            $log.log('ddf');
            $event.stopPropagation();
            // // vm.uploadName = type;
            // if (index != null || index != '' || index != undefined) {
            //     vm.indexGot = index;
            // }
            var element = document.getElementById('documentUpload');
            element.click();
        }

        $scope.file_to_upload = function (File) {
            var transcript = File[0];
            var reader = new FileReader;
            reader.onload = function (e) {
                document.getElementById('profilePic').setAttribute('src', e.target.result);
                vm.fileToSend = File[0];
            }
            var size = (File[0].size / 1024);
            if (size / 1024 > 3) {
                errorMessageFactory.showErrorMessage('Tamaño del icono del mensaje debe ser inferior a 3 MB.', 0);
                return;
            }
            reader.readAsDataURL(transcript);
        }

        ////////////////// TO VALIDATE DRIVER FOR TYPE OF VECHICLE  //////////////////
        function validateDriver(vechicle, branch) {
            if (vechicle.id != null && branch.region_id != null) {
                vm.loading = true;
                var dataSend = {};
                dataSend.id = vechicle.id;
                dataSend.region_id = branch.region_id;
                var promise = DriverPushesService.getValidateDriverForVechicle(dataSend);
                promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        if (payload.title.status == 200) {
                            if (payload.title.data.is_valid == 1) {
                                var index = -1;
                                var indexVechicle = -1;
                                index = _.findIndex(vm.destinationVechiloDriverArray, { // function to check weather the value alerady in destination section then return this 
                                    region_id: branch.region_id
                                });
                                indexVechicle = _.findIndex(vm.destinationVechiloDriverArray, { // function to check weather the value alerady in destination section then return this 
                                    id: vechicle.id
                                });
                                if (vm.filterData.vehicle.id == 'all' && vm.filterData.branch.region_id == 'all') {
                                    vm.destinationVechiloDriverArray = [];
                                    vm.hideAddButton = true;
                                }
                                if (vm.filterData.vehicle.id != null && vm.filterData.branch.region_id != null) {
                                    if (index == -1 && indexVechicle == -1) {
                                        vm.destinationVechiloDriverArray.push({
                                            name: vm.filterData.vehicle.name,
                                            region_name: vm.filterData.branch.region_name,
                                            id: vm.filterData.vehicle.id,
                                            region_id: vm.filterData.branch.region_id
                                        });
                                    } else if (index != -1 && indexVechicle == -1) {
                                        vm.destinationVechiloDriverArray.push({
                                            name: vm.filterData.vehicle.name,
                                            region_name: vm.filterData.branch.region_name,
                                            id: vm.filterData.vehicle.id,
                                            region_id: vm.filterData.branch.region_id
                                        });
                                    } else if (index == -1 && indexVechicle != -1) {
                                        vm.destinationVechiloDriverArray.push({
                                            name: vm.filterData.vehicle.name,
                                            region_name: vm.filterData.branch.region_name,
                                            id: vm.filterData.vehicle.id,
                                            region_id: vm.filterData.branch.region_id
                                        });
                                    }
                                }
                            }
                        } else {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        //vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }
        }
        ////////////////// FOR DESTINATION TIPO VECHICLE DATA  //////////////////
        function AdTipoTheVechilo(vechicle, branch) {
            validateDriver(vechicle, branch);
        }
        ////////////////// FOR DESTINATION TIPO VECHICLE DATA  //////////////////


        ////////////////// FOR DESTINATION  TIPO DELETE VECHICLE DATA  //////////////////
        function deleteTipoDriver(data) {
            vm.destinationVechiloDriverArray.splice(data, 1);
            vm.hideAddButton = false;
        }
        ////////////////// FOR DESTINATION TIPO DELTE VECHICLE DATA  //////////////////

        ////////////////// FOR PUSH TO DRIVER FUNCATION CODE IS HERE //////////////////
        function sendPushToDrivers() {
            if (vm.filterData.Message == '' || vm.filterData.Message == null || vm.filterData.Message == "") {
                vm.messageToSend = true;
                return;
            }
            vm.pushArray = [];
            if (vm.fileToSend == undefined) {
                errorMessageFactory.showErrorMessage('Ingresa un icono para el mensaje. ', 0);
                return;
            }
            if (vm.selected) {
                if (vm.destinationBuscarDriverArray.length == 0) {
                    errorMessageFactory.showErrorMessage('Ingresa un destinatario ', 0);
                    return;
                }
            } else if (vm.selected1) {
                vm.driverGroupArray.forEach(function (data) {
                    if (data.checked) {
                        vm.pushArray.push({
                            group_id: data.group_id
                        })
                    }
                });
                if (vm.pushArray.length == 0) {
                    errorMessageFactory.showErrorMessage('Selecciona un grupo ', 0);
                    return;
                }
            } else {
                console.log(vm.destinationVechiloDriverArray, 'vm.destinationVechiloDriverArray ');

                if (vm.destinationVechiloDriverArray.length == 0) {
                    errorMessageFactory.showErrorMessage('Ingresa tipo de servicio y sucursal', 0);
                    return;
                }
            }
            vm.loading = true;
            vm.sendArray = [];
            var dataSend = new FormData();
            var bulkNotificationType;
            if (vm.selected) {
                bulkNotificationType = 0;
                vm.destinationBuscarDriverArray.forEach(function (data) {
                    vm.sendArray.push({
                        fleet_id: data.fleet_id
                    });
                })
                dataSend.append('fleet_list', JSON.stringify(vm.sendArray));
            } else if (vm.selected1) {
                bulkNotificationType = 1;
                vm.driverGroupArray.forEach(function (data) {
                    var index = _.findIndex(vm.sendArray, {
                        group_id: data.group_id,
                    });
                    if (data.checked && index == -1) {
                        vm.sendArray.push({
                            group_id: data.group_id
                        });
                    }
                });
                dataSend.append('group_list', JSON.stringify(vm.sendArray));
            } else {
                bulkNotificationType = 2;
                vm.destinationVechiloDriverArray.forEach(function (data) {
                    vm.sendArray.push({
                        id: data.id,
                        region_id: data.region_id
                    })
                });
                dataSend.append('type_of_vehicle_list', JSON.stringify(vm.sendArray));
            }
            dataSend.append('access_token', $cookies.get('obj'));
            dataSend.append('bulk_notification_type', bulkNotificationType);
            dataSend.append('sender', vm.filterData.newMessage);
            dataSend.append('title', vm.filterData.titleMessage);
            dataSend.append('message', vm.filterData.Message);
            dataSend.append('image', vm.fileToSend);

            var promise = DriverPushesService.sendPushToDriver(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload && payload.title.status == 200) {
                        // $state.reload();
                        languageBasedErrorFactory.getProperErrorMessage('MessageSendSuccess', 0, 1, 'layout.newMessageMain.newMessage');
                        $state.reload();
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
    }
})();
/**
 * Created by cl-macmini-51 on 08/02/18.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('DriverMailController', DriverMailController);

    /** @ngInject */
    function DriverMailController($timeout, $document, $scope, $state, adminAccessService, errorMessageFactory, $mdDialog, languageBasedErrorFactory, $log, DriverPushesService, $cookies) {
        var vm = this;
        vm.max = 2;
        vm.filterData = {
            Message: '',
        }
        vm.uploadMessageIcon = uploadMessageIcon;
        vm.changeMessageError = changeMessageError;
        vm.mailToDriver = mailToDriver;
        vm.FixedTemplate =
            '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">' +
            '<html>' +
            '' +
            '<head>' +
            '<title>Welcome</title>' +
            '<style>' +
            '.topClassNew{' +
            'border:2px solid lightgrey;' +
            'border-radius:10px;' +
            'width:800px;' +
            '}' +
            '' +
            '.text-alignNew{' +
            'text-align:left;' +
            'color:#FF6900;' +
            'padding-left:30px;' +
            'font-size:40px;' +
            'font-family: Arial, Helvetica, sans-serif' +
            '}' +
            '' +
            '.textNew{' +
            'text-align:left;' +
            'color:black;' +
            'padding-left:30px;' +
            'font-size:34px;' +
            'font-family: Arial, Helvetica, sans-serif' +
            '}' +
            '' +
            '.simpletext{' +
            'text-align:left;' +
            'padding-left:30px;' +
            'color:black;' +
            'font-weight:normal;' +
            'font-size:22px;' +
            'font-family: Arial, Helvetica, sans-serif' +
            '}' +
            '' +
            'h1{' +
            'padding-left:30px;' +
            'padding-right:30px;' +
            'color:black;' +
            '}' +
            'h2{' +
            'padding-left:30px;' +
            'padding-right:30px;' +
            'color:black;' +
            '}' +
            'h3{' +
            'padding-left:30px;' +
            'padding-right:30px;'+
            'color:black;' +
            '}' +
            'h4{' +
            'padding-left:30px;' +
            'padding-right:30px;'+
            'color:black;' +
            '}' +
            'h5{' +
            'padding-left:30px;' +
            'padding-right:30px;'+
            'color:black;' +
            '}' +
            'h6{' +
            'padding-left:30px;' +
            'padding-right:30px;'+
            'color:black;' +
            '}' +
            'p{' +
            'padding-left:30px;' +
            'padding-right:30px;'+
            'color:black;' +
            '}' +
            'pre{' +
            'padding-left:30px;' +
            'padding-right:30px;'+
            'color:black;' +
            '}' +
            'li{' +
            'color:black;' +
            '}' +
            'ul{' +
            'color:black;' +
            '}' +
            'div{' +
            'max-width: 800px;' +
            '}' +
            'img{' +
            'max-width: 740px;' +
            '}' +
            '</style>' +
            '</head>' +
            '' +
            '<body>' +
            '<div class="topClassNew">' +
            '' +
            '<div>' +
            '<div>';

        function changeMessageError() {
            if (vm.filterData.Message != null || vm.filterData.Message != '' || vm.filterData.Message != "") {
                vm.messageToSend = false;
            } else {
                vm.messageToSend = true;
            }
        }

        function mailToDriver() {
            if (vm.filterData.Message == '' || vm.filterData.Message == null || vm.filterData.Message == "") {
                vm.messageToSend = true;
                return;
            }
            if (vm.getBodyData != undefined) {
                for (var i = 0; i < vm.getBodyData.length; i++) {
                    if (vm.getBodyData[i].type == "SIGN_UP_DRIVER") {
                        editMailToDriver(vm.getBodyData[i]);
                        // vm.filterData.Message = vm.getBodyData[0].body;
                    } else {
                        addMailToDriver();
                    }
                }
            } else {
                addMailToDriver();
            }

        }

        function addMailToDriver() {
            var docLength = parseInt($("#toolbarCC").find("span")[0].innerHTML);
            if(docLength > 2000){
                errorMessageFactory.showErrorMessage('La longitud máxima permitida para el mensaje son 2000 caracteres.', 0);
                return;
            }
            var dataSend = {};
            var footerImage = vm.fotterImage!= undefined ? vm.fotterImage : '';
            dataSend.access_token = $cookies.get('obj');
            dataSend.subject = 'TRANSVIP - Gracias por tu inscripción';
            dataSend.static = vm.FixedTemplate;
            dataSend.dynamic = vm.filterData.Message;
            // vm.FixedTemplate + cleint requiredment
            dataSend.fully_html =  vm.FixedTemplate+  vm.filterData.Message + footerImage  + '</div>' + '</body>' + '' + '</html>';
            dataSend.type = 'SIGN_UP_DRIVER';
            dataSend.image_url = vm.ImageOfFotter;
            vm.loading = true;
            var promise = DriverPushesService.addDriverMail(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    console.log(payload, 'pya');
                    if (payload.title.status == 200) {
                        // $state.reload();
                        errorMessageFactory.showErrorMessage(payload.title.message, 1);
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }


        function getEmail() {
            vm.loading = true;
            var promise = DriverPushesService.getDriverMail();
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        if (payload.title.data.length > 0 && payload.title.data[0].type) {
                            vm.getBodyData = payload.title.data;
                            vm.filterData.Message = payload.title.data[0].body;
                            vm.ImageOfFotter = payload.title.data[0].image_url;
                            if(vm.ImageOfFotter != null)
                            vm.fotterImage =  '<img  style="background-color:red;border-radius: 0px 0px 10px 10px;width: 800px; max-width: 800px;padding-top:30px;padding-bottom:30px;background-color:white;max-width:800px" src='+vm.ImageOfFotter+'>';
                        }
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        getEmail();


        function editMailToDriver(data) {
            console.log(vm.fotterImage,'vm.fotterImage');
            
            var dataSend = {};
            var docLength = parseInt($("#toolbarCC").find("span")[0].innerHTML);
            if(docLength > 2000){
                errorMessageFactory.showErrorMessage('La longitud máxima permitida para el mensaje son 2000 caracteres.', 0);
                return;
            }
            var footerImage = vm.fotterImage!= undefined ? vm.fotterImage : '';
            dataSend.access_token = $cookies.get('obj');
            dataSend.subject = 'TRANSVIP - Gracias por tu inscripción';
            dataSend.static = vm.FixedTemplate;
            dataSend.dynamic = vm.filterData.Message;
            // vm.FixedTemplate + client required ment
            dataSend.fully_html =  vm.FixedTemplate + vm.filterData.Message + footerImage  + '</div>' + '</body>' + '' + '</html>';
            dataSend.type = 'SIGN_UP_DRIVER';
            dataSend.template_id = data.template_id;
            if(vm.ImageOfFotter != null)
            dataSend.image_url = vm.ImageOfFotter;
            vm.loading = true;
            console.log(dataSend.fully_html);
            
            var promise = DriverPushesService.editDriverMail(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    console.log(payload, 'pya');
                    if (payload.title.status == 200) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 1);
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }


        ////////////////// FOR UPLOAD MESSAGE ICON FUNCATION CODE IS HERE //////////////////
        function uploadMessageIcon($event) {
            $log.log('ddf');
            $event.stopPropagation();
            // // vm.uploadName = type;
            // if (index != null || index != '' || index != undefined) {
            //     vm.indexGot = index;
            // }
            var element = document.getElementById('uploadFooter');
            element.click();
        }

        $scope.file_to_upload = function (File) {
            var transcript = File[0];
            var reader = new FileReader;
            reader.onload = function (e) {
                document.getElementById('profilePic').setAttribute('src', e.target.result);
                vm.fileToSend = File[0];
            }
            vm.fileToSend = File[0];
            var size = (File[0].size / 1024);
            if (size / 1024 > 3) {
                errorMessageFactory.showErrorMessage('Tamaño del icono del mensaje debe ser inferior a 3 MB.', 0);
                return;
            }
            reader.readAsDataURL(transcript);
            imageUpload()
        }

        function imageUpload(){
            var dataSend = new FormData();
            dataSend.append('image', vm.fileToSend);
            dataSend.append('access_token',  $cookies.get('obj'));
            vm.loading = true;
            var promise = DriverPushesService.imageUploadApi(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if(payload.title.status == 200){
                        vm.ImageOfFotter  = payload.title.data;
                        vm.fotterImage =  '<img  style="background-color:red;border-radius: 10px;width: 800px;padding-top:30px;padding-bottom:30px;background-color:white;max-width:800px" src='+vm.ImageOfFotter+'>';
                    }else{
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                  
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
    }
})();
/**
 * Created by cl-macmini-51 on 08/02/18.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('HistoryMessageController', HistoryMessageController);

    /** @ngInject */
    function HistoryMessageController($timeout, $document, $scope, $state, adminAccessService, errorMessageFactory, $mdDialog, languageBasedErrorFactory, $log, DriverPushesService, $cookies) {
        var vm = this;
        vm.filterData = {
            serachHistory: '',
            limit: 25,
            offset: 0,
            Driverlimit: 15,
            Driveroffset: 0,
        }
        vm.FleetArray = [];
        vm.currentPage = 0;
        vm.maxSize = 5;
        vm.searchModel = {
            limit: 25,
            limitOptions: [25, 50, 100, 250]
        };
        vm.paginationNew = paginationNew;
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
        vm.serachHistoryMessage = serachHistoryMessage;
        vm.openPopForMessageDetails = openPopForMessageDetails;
        vm.getReceptorDetails = getReceptorDetails;
        // vm.openPopForReceptorDetails = openPopForReceptorDetails;
        vm.changeDateIntoSpanish = changeDateIntoSpanish;


        //////////////// FUNCTION TO CHECK THE DATE IS IN ENGLISH OR SPANISH //////////////////
        function changeDateIntoSpanish(date) {
            var options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            };
            return new Date(date).toLocaleString($cookies.get('language') == 'spanish' ? 'es' : 'en', options)
        }

        /////////////////////// FUNCTION TO GET THE HISTORY OF PUSH MESSAGES //////////////////////
        function getHistoryLogs(offset, limit) {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit.limit;
            dataSend.offset = offset;
            if (vm.filterData.serachHistory)
                dataSend.search_value = vm.filterData.serachHistory;
            var promise = DriverPushesService.getHistoryLogs(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        console.log(payload, "history payload");
                        if (payload && payload.title.data.total_count == 0) {
                            vm.skipValue = -1;
                            vm.limitValue = -1;
                            vm.dataLength  = 0;
                            vm.historyMessage  = [];
                            vm.sp_pagination = false;
                            vm.tFootFlag = true;
                        } else {
                            vm.historyMessage = payload.title.data.data;
                            vm.dataLength = payload.title.data.total_count;
                            for (var i = 0; i < vm.historyMessage.length; i++) {
                                vm.historyMessage[i].index = (offset + i);
                            }
                            if (vm.dataLength <= vm.itemsPerPageGot) {
                                vm.sp_pagination = false;
                            } else {
                                vm.sp_pagination = true;
                                //vm.pageCount(payload.title.totalCount);
                            }
                            vm.skipValue = vm.historyMessage[0].index;
                            vm.limitValue = vm.historyMessage[vm.historyMessage.length - 1].index;
                            vm.tFootFlag = false;
                        }
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        getHistoryLogs(vm.filterData.offset, vm.filterData);



        //=========================GET Driver For Gourp PAGINATION=============================
        function paginationNew(page) {
            getHistoryLogs((page - 1) * vm.itemsPerPageGot, vm.filterData);
        }
        //////////////////////////// GET SEARCH OF VALUE ////////////////////////////////////////
        function serachHistoryMessage() {
            getHistoryLogs(vm.filterData.offset, vm.filterData);
        }


        ////////////////////////////  FUNCATION TO OPEN MESSAGE DETAILS /////////////////////
        function openPopForMessageDetails(data, $event) {
            vm.items = {
                html_data: data.message,
                title: data.title,
                created_at: data.created_at
            }
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/MessageDetails.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });

            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.copymessage = false;
                console.log($scope.items, 'items');

                $scope.app = false;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.changeDateIntoSpanish = function (date) {
                    var options = {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric'
                    };
                    return new Date(date).toLocaleString($cookies.get('language') == 'spanish' ? 'es' : 'en', options)
                }
                $scope.copyMessage = function (data) {
                    document.getElementById('copy').value = data;
                    var copyText = document.getElementById('copy');
                    console.log(document.getElementById("copy"));
                    copyText.select();
                    document.execCommand("copy");
                    $scope.copymessage = true;
                    $timeout(function () {
                        $scope.copymessage = false;
                    }, 2000);
                    if (document.execCommand('copy') == true) {
                        $scope.items.copied = true;
                        $timeout(function () {
                            $scope.items.copied = false;
                        }, 2000);
                    }
                }
                $scope.confirmUpload = function () {};
            }
        }

        ////////////////////////////  FUNCATION TO OPEN RRECEPTOR DETAILS /////////////////////
        function getReceptorDetails(data, $event, type, load) {
            if (type == 'unscroll')
                vm.filterData.Driveroffset = 0;
            vm.loading = load;
            vm.datalog = data;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = vm.filterData.Driverlimit;
            dataSend.offset = vm.filterData.Driveroffset;
            dataSend.log_id = data.log_id;
            var promise = DriverPushesService.getBulkNotificationFleetLogsApi(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload && payload.title.data) {
                        vm.FleetArray = [];
                        // if (type == 'scroll') {
                        //     for (var i = 0; i < payload.title.data.data.length; i++) {
                        //         vm.FleetArray.push(payload.title.data.data[i]);
                        //     }
                        // } else{
                        //     vm.FleetArray = payload.title.data.data;
                        //     openPopForReceptorDetails(payload.title.data, $event);
                        // }
                        for (var i = 0; i < payload.title.data.data.length; i++) {
                            vm.FleetArray.push(payload.title.data.data[i]);
                        }
                        openPopForReceptorDetails(vm.FleetArray, payload.title.data.total_count, $event);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function openPopForReceptorDetails(array, count, $event) {
            vm.items = {
                driverList: array,
                driver_count: count,
                UniqueCarLogFleet: '',
                searchLogFleet: '',
                limit: 15,
                offset: 0,
            }
            console.log(array, 'array', count);

            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/ReceptorDetails.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: ReceptorController
            });

            function ReceptorController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.app = false;
                var filterTextTimeout = '';
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.changeDateIntoSpanish = function (date) {
                    var options = {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric'
                    };
                    return new Date(date).toLocaleString($cookies.get('language') == 'spanish' ? 'es' : 'en', options)
                }

                $scope.getDriverDetails = function (type1, search, uniqueId) {
                    // vm.filterData.Driveroffset = 0;
                    $scope.items.loading = true;
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.limit = $scope.items.limit;
                    dataSend.offset = $scope.items.offset;
                    dataSend.log_id = vm.datalog.log_id;
                    if (search) {
                        dataSend.search_value = search;
                    }
                    if (uniqueId) {
                        dataSend.unique_car_id = uniqueId;
                    }
                    var promise = DriverPushesService.getBulkNotificationFleetLogsApi(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log(payload);
                            $scope.items.loading = false;
                            if (payload && payload.title.data) {
                                if (type1 == 'scroll') {
                                    $scope.items.driver_count = payload.title.data.total_count;
                                    for (var i = 0; i < payload.title.data.data.length; i++) {
                                        $scope.items.driverList.push(payload.title.data.data[i]);
                                    }
                                }
                                if (search || uniqueId) {
                                    $scope.items.driverList = [];
                                    $scope.items.driverList = payload.title.data.data;
                                    $scope.items.driver_count = payload.title.data.total_count;
                                }
                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                };
                $scope.items.paginationChangedForLogDriverList = function () {
                    if ($scope.items.driver_count > $scope.items.driverList.length) {
                        $scope.items.offset = $scope.items.offset + 15;
                        $scope.getDriverDetails('scroll');
                    }

                }
                $scope.items.getFillter = function () {
                    $scope.items.offset = 0;
                    $scope.items.limit = 25;
                    if ($scope.items.searchLogFleet || $scope.items.UniqueCarLogFleet) {
                        if (filterTextTimeout) $timeout.cancel(filterTextTimeout);
                        filterTextTimeout = $timeout(function () {
                            $scope.getDriverDetails('unscroll', $scope.items.searchLogFleet, $scope.items.UniqueCarLogFleet);
                        }, 500);
                        // dataSend.search_value = items.searchLogFleet;
                    } else {
                        $scope.getDriverDetails('scroll');
                    }
                }
                // $scope.items.getFillter = function () {
                //     // vm.filterData.Driveroffset = 0;
                //     vm.loading = true;
                //     var dataSend = {};
                //     dataSend.access_token = $cookies.get('obj');
                //     dataSend.limit = 25;
                //     dataSend.offset = 0;
                //     dataSend.log_id = vm.datalog.log_id;
                //     if ($scope.items.searchLogFleet) {
                //         dataSend.search_value = items.searchLogFleet;
                //     }
                //     if ($scope.items.UniqueCarLogFleet){
                //         dataSend.unique_car_id = Number(items.UniqueCarLogFleet)
                //     }
                //     var promise = DriverPushesService.getBulkNotificationFleetLogsApi(dataSend);
                //     promise.then(
                //         function (payload) {
                //             $log.log(payload);
                //             vm.loading = false;
                //             if (payload && payload.title.data) {
                //                 vm.filterData.Driveroffset = 0;
                //                 $scope.items.driverList = payload.title.data.data;
                //                 $scope.items.driver_count = payload.title.data.total_count;
                //             }
                //         },
                //         function (errorPayload) {
                //             $log.log(errorPayload);
                //             vm.loading = false;
                //             if (errorPayload.data.status == 401) {
                //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                //             } else {
                //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                //             }
                //         }
                //     );
                // }
                $scope.confirmUpload = function () {};
            }
        }
    }
})();
/**
 * Created by cl-macmini-51 on 08/02/18.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('GroupDriverController', GroupDriverController);

    /** @ngInject */
    function GroupDriverController($scope, $state, $timeout, adminAccessService, errorMessageFactory, $mdDialog, languageBasedErrorFactory, $log, DriverPushesService, $cookies) {
        var vm = this;
        vm.goBack = goBack;
        vm.DriverList = [];
        vm.currentPage = 0;
        vm.maxSize = 5;
        vm.searchModel = {
            limit: 25,
            limitOptions: [25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
        vm.paginationNew = paginationNew;
        vm.deleteGroupDrivers = deleteGroupDrivers;
        vm.getDriverBuscarData = getDriverBuscarData;
        vm.getDriverBuscarDataUniqueCar = getDriverBuscarDataUniqueCar;
        vm.goBackToGroup = goBackToGroup;
        vm.addGroupForDriver = addGroupForDriver;
        vm.AddBuscarVechicle = AddBuscarVechicle;
        vm.SubmitDriverList = SubmitDriverList;
        vm.deleteBuscarDriver = deleteBuscarDriver;
        vm.destinationBuscarDriverArray = [];
        // vm.destinationBuscarDriverArrayActualAdd = [];
        // vm.paginationChangedForDriverList = paginationChangedForDriverList;
        // vm.getFilter = getFilter;
        vm.AddGroupOfDriver = AddGroupOfDriver;
        vm.showDriverList = false;
        vm.filterData = {
            limit: 25,
            offset: 0,
            offsetMade: 25,
            search: '',
            UniqueCar: '',
            GroupName: '',
            description: '',
            searchDriver: '',
            UniqueCarDriver: '',
            serachGroupDriver: ''
        }
        vm.serachGroupDriver = serachGroupDriver;

        ////////////////// Destination Data TO add Buscar Vechicle //////////////////
        var index = -1;

        function AddBuscarVechicle(data) {
            console.log(data);
            //  index = -1;
            index = _.findIndex(vm.destinationBuscarDriverArray, { // function to check weather the value alerady in destination section then return this 
                email: data.email
            });
            if (index == -1)
                vm.destinationBuscarDriverArray.push(data);

        }

        ////////////////// Destination Data TO delete Buscar Vechicle //////////////////
        function deleteBuscarDriver(index) {
            vm.destinationBuscarDriverArray.splice(index, 1); //  funtion to delete the driver from destionation sector 
        }
        ////////////////// Destination Data TO delete Buscar Vechicle //////////////////

        //=========================go back=============================
        function goBack() {
            $state.go('layout.groupDriversMain.groupDrivers');
        };

        function goBackToGroup() {
            console.log('destinationBuscarDriverArrayActualAdd');
            vm.showDriverList = false;
            // $scope.$apply();
        }

        function SubmitDriverList() {
            if (vm.destinationBuscarDriverArray.length == 0) {
                errorMessageFactory.showErrorMessage('Agrega un conductor');
                return;
            }
            vm.showDriverList = false;
            vm.destinationBuscarDriverArrayActualAdd = vm.destinationBuscarDriverArray;
        }

        //=========================DELETE DRIVERS GROUP  =============================
        function deleteGroupDrivers($event, data) {
            vm.loading = true;
            var promise = adminAccessService.checkStateValid('Eliminar grupo de difusión'); //$stateParams.id
            return promise.then(
                function (payload) {
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (!payload.title.data.granted) {
                            // languageBasedErrorFactory.getProperErrorMessage('optionNotAvail', 0, 0);
                            errorMessageFactory.showErrorMessage('No tiene permiso para ejecutar esta opción', 0);
                            return false;
                        } else {
                            vm.loading = false;
                            deletePopUp($event, data);
                        }
                    }
                },
                function (errorPayload) {
                    console.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function deletePopUp($event, data) {
            var confirm = $mdDialog.confirm()
                .title('¿Desea eliminar grupo de difusión?')
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                vm.loading = true;
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.group_id = data.group_id;
                var promise = DriverPushesService.deleteGroupDrivers(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        console.log(payload, 'payload');
                        if (payload && payload.title.status == 200) {
                            getGroupDrivers(vm.filterData.offset, vm.filterData);
                        } else {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        }


        //=========================SEARCH VALUE =============================
        function AddGroupOfDriver() {
            vm.showDriverList = true;
            vm.filterData.search = '';
            vm.filterData.UniqueCar = '';
            // vm.destinationBuscarDriverArray = [];
            vm.buscarDriverData = [];
        }


        ////////////////// GET BUSCAR VALUE BY SEARCH  //////////////////
        function getDriverBuscarData(data) {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            if (vm.filterData.search != '')
                dataSend.search_value = vm.filterData.search;
            if (vm.filterData.UniqueCar != '')
                dataSend.unique_car_id = Number(vm.filterData.UniqueCar);
            var promise = DriverPushesService.getBuscarDriverData(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    vm.buscarDriverData = payload.title.data;
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        var filterTextTimeout = '';

        function getDriverBuscarDataUniqueCar(data) {
            if (vm.filterData.UniqueCarId != '') {
                if (filterTextTimeout) $timeout.cancel(filterTextTimeout);
                filterTextTimeout = $timeout(function () {
                    SearchByUniqueCar();
                }, 500);
            } else {
                // vm.buscarDriverData = [];
                SearchByUniqueCar();
            }
        }

        function SearchByUniqueCar() {
            vm.loading = true;
            var dataSend = {};
            var filterTextTimeout = '';
            dataSend.access_token = $cookies.get('obj');
            if (vm.filterData.search != '')
                dataSend.search_value = vm.filterData.search;
            if (vm.filterData.UniqueCar != '')
                dataSend.unique_car_id = Number(vm.filterData.UniqueCar);
            var promise = DriverPushesService.getBuscarDriverData(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    vm.buscarDriverData = payload.title.data;
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        ////////////////// GET BUSCAR VALUE BY SEARCH  //////////////////


        //=========================Add Driver For Gourp =============================
        function addGroupForDriver() {
            if (vm.destinationBuscarDriverArray.length == 0) {
                errorMessageFactory.showErrorMessage('Agrega un conductor');
                return;
            }
            vm.loading = true;
            var dataSend = {};
            var SendArray = [];
            vm.destinationBuscarDriverArrayActualAdd.forEach(function (data) {
                SendArray.push({
                    fleet_id: data.fleet_id
                });
            });
            dataSend.access_token = $cookies.get('obj');
            dataSend.group_name = vm.filterData.GroupName;
            if (vm.filterData.description != '')
                dataSend.group_description = vm.filterData.description;
            dataSend.fleet_list = SendArray;
            var promise = DriverPushesService.addGroupDrivers(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        $state.go('layout.groupDriversMain.groupDrivers');
                        getGroupDrivers(vm.filterData.offset, vm.filterData);
                        // $state.reload();
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        //=========================GET Driver For Gourp =============================
        getGroupDrivers(vm.filterData.offset, vm.filterData);

        function getGroupDrivers(offset, limit) {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit.limit;
            dataSend.offset = offset;
            if (vm.filterData.serachGroupDriver)
                dataSend.search_value = vm.filterData.serachGroupDriver;
            var promise = DriverPushesService.getGroupDrivers(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    console.log(payload, 'payload');
                    if (payload.title.status == 200) {
                        if (payload && payload.title.data.total_count == 0) {
                            vm.skipValue = -1;
                            vm.limitValue = -1;
                            vm.dataLength = 0;
                            vm.groupDriver = [];
                            vm.sp_pagination = false;
                            vm.tFootFlag = true;
                        } else {
                            vm.groupDriver = payload.title.data.data;
                            vm.dataLength = payload.title.data.total_count;
                            console.log(vm.dataLength);
                            for (var i = 0; i < vm.groupDriver.length; i++) {
                                vm.groupDriver[i].index = (offset + i);
                            }
                            if (vm.dataLength <= vm.itemsPerPageGot) {
                                vm.sp_pagination = false;
                            } else {
                                vm.sp_pagination = true;
                            }
                            vm.skipValue = vm.groupDriver[0].index;
                            vm.limitValue = vm.groupDriver[vm.groupDriver.length - 1].index;
                        }
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        //=========================GET Driver For Gourp PAGINATION=============================
        function paginationNew(page) {
            getGroupDrivers((page - 1) * vm.itemsPerPageGot, vm.filterData)
        }

        //=========================GET Driver For Gourp SERCH =============================
        function serachGroupDriver() {
            getGroupDrivers(0, vm.filterData);
        }

    }
})();

/**
 * Created by cl-macmini-51 on 08/02/18.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('EditGroupController', EditGroupController);

    /** @ngInject */
    function EditGroupController($cookies, $state,$timeout, $log, $stateParams, errorMessageFactory, DriverPushesService) {
        var vm = this;
        vm.dataToFill = {
            description: '',
            roleName: ''
        }
        vm.goBack = goBack;
        vm.goBackFirst = goBackFirst;
        vm.editGroupDriver = editGroupDriver;
        vm.AddGroupOfDriver = AddGroupOfDriver;
        vm.showDriverList = false;
        vm.getDriverBuscarData = getDriverBuscarData;
        vm.AddBuscarVechicle = AddBuscarVechicle;
        vm.getDriverBuscarDataUniqueCar = getDriverBuscarDataUniqueCar;
        vm.deleteBuscarDriver = deleteBuscarDriver;
        vm.goBackToGroup = goBackToGroup;
        vm.getFilterForUniqueCar = getFilterForUniqueCar;
        vm.destinationBuscarDriverArray = [];
        // vm.checkEnter = checkEnter;
        vm.filterData = {
            UniqueCar: '',
            search: '',
            limit: 10,
            offset: 0,
            offsetMade: 10,
            uniqueCarSearch: ''
        }
        vm.SubmitDriverList = SubmitDriverList;
        vm.editGroupApi = editGroupApi;
        vm.getFilter = getFilter;
        vm.paginationChangedForVeiwDriverInGroup = paginationChangedForVeiwDriverInGroup;



        function paginationChangedForVeiwDriverInGroup() {
            if (vm.fleetCount > vm.FleetArray.length) {
                vm.filterData.offset = vm.filterData.offset + 10;
                viewGroupDetails($stateParams.id, vm.filterData, 'scroll', false);
            }

        }
        //=========================FUNCTION TO GET FILTER =============================
        function getFilter(event) {
            // console.log("event", event);
            vm.filterData.offset = 0;
            viewGroupDetails($stateParams.id, vm.filterData, 'unscroll', true);
            // vm.loading = true;
            // var dataSend = {};
            // vm.filterData.offset = 0;
            // dataSend.access_token = $cookies.get('obj');
            // dataSend.group_id = Number($stateParams.id);
            // if (vm.filterData.uniqueCarSearch != '' && vm.filterData.uniqueCarSearch != null)
            //     dataSend.unique_car_id = (vm.filterData.uniqueCarSearch);
            // if (vm.search != '')
            //     dataSend.search_value = vm.search;
            // var promise = DriverPushesService.searchParticularGroupDriver(dataSend);
            // promise.then(
            //     function (payload) {
            //         $log.log(payload);
            //         vm.loading = false;
            //         if (payload.title.status == 200) {
            //             vm.FleetArray = payload.title.data;
            //             for (var i = 0; i < vm.FleetArray.length; i++) {
            //                 vm.FleetArray[i].flag = false;
            //             }
            //         }
            //         // vm.FleetArray.push(...vm.destinationBuscarDriverArray);
            //     },
            //     function (errorPayload) {
            //         $log.log(errorPayload);
            //         vm.loading = false;
            //         if (errorPayload.data.status == 401) {
            //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
            //         } else {
            //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
            //         }
            //     }
            // );
        }

        var filterTextTimeout = '';
        function getFilterForUniqueCar(event){
            if (vm.filterData.uniqueCarSearch != '') {
                if (filterTextTimeout) $timeout.cancel(filterTextTimeout);
                filterTextTimeout = $timeout(function () {
                    vm.filterData.offset = 0;
                    viewGroupDetails($stateParams.id, vm.filterData, 'unscroll', true);
                }, 500);
            } else {
                // vm.buscarDriverData = [];
                vm.filterData.offset = 0;
                viewGroupDetails($stateParams.id, vm.filterData, 'unscroll', true);
            }
        }



        //=========================SEARCH VALUE =============================
        function AddGroupOfDriver() {
            vm.showDriverList = true;
            vm.destinationBuscarDriverArray = [];
        }
        //=========================go back=============================
        function goBack() {
            $state.go('layout.groupDriversMain.groupDrivers');
        };

        function goBackFirst(){
            if (vm.destinationBuscarDriverArray.length == 0  && vm.FleetArray.length == 0 && vm.search == undefined  && vm.filterData.uniqueCarSearch == '') {
                errorMessageFactory.showErrorMessage('Agrega un conductor');
                return;
            }
            $state.go('layout.groupDriversMain.groupDrivers');
        }

        function SubmitDriverList() {
            if (vm.destinationBuscarDriverArray.length == 0) {
                errorMessageFactory.showErrorMessage('Agrega un conductor');
                return;
            }
            vm.loading = true;
            var dataSend = {};
            var SendArray = [];
            vm.destinationBuscarDriverArray.forEach(function (data) {
                SendArray.push({
                    fleet_id: data.fleet_id
                });
            });
            dataSend.access_token = $cookies.get('obj');
            dataSend.group_id = Number($stateParams.id);
            dataSend.fleet_list = SendArray;
            var promise = DriverPushesService.addDriverToGroup(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        // $state.go('layout.groupDriversMain.groupDrivers');
                        // getGroupDrivers(vm.filterData.offset, vm.filterData);
                        viewGroupDetails($stateParams.id, vm.filterData, 'unscroll', false);
                        vm.showDriverList = false;
                        // $state.reload();
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function viewGroupDetailsForName() {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.group_id = Number($stateParams.id);
            var promise = DriverPushesService.DriverDetails(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    console.log(payload);

                    if (payload.title.status == 200) {
                        vm.dataToFill.roleName = payload.title.data[0].group_name;
                        vm.dataToFill.description = payload.title.data[0].group_description;
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );

        }
        viewGroupDetailsForName();
        //=========================GROUP DETAILS  =============================
        function viewGroupDetails(data, filterData, type, load) {
            vm.loading = load;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = filterData.limit;
            dataSend.offset = filterData.offset;
            dataSend.group_id = Number(data);
            if (vm.filterData.uniqueCarSearch != '' && vm.filterData.uniqueCarSearch != null)
                dataSend.unique_car_id = (vm.filterData.uniqueCarSearch);
            if (vm.search != '')
                dataSend.search_value = vm.search;
            var promise = DriverPushesService.getGroupDriversVeiw(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        // vm.dataToFill.roleName = payload.title.data.group_name;
                        // vm.dataToFill.description = payload.title.data.group_description;
                        vm.fleetCount = payload.title.data.total_count;
                        if (type == 'scroll') {
                            for (var i = 0; i < payload.title.data.data.length; i++) {
                                vm.FleetArray.push(payload.title.data.data[i]);
                                vm.FleetArray[i].flag = false;
                            }
                        } else {
                            vm.FleetArray = payload.title.data.data;
                            for (var i = 0; i < vm.FleetArray.length; i++) {
                                vm.FleetArray[i].flag = false;
                            }
                        }
                        //vm.FleetArray = payload.title.data.fleet_list;


                        // vm.destinationBuscarDriverArray = payload.title.data.fleet_list;
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        viewGroupDetails($stateParams.id, vm.filterData, 'unscroll', true);


        function editGroupDriver(data, index) {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.group_id = Number($stateParams.id);
            dataSend.fleet_id = Number(data.fleet_id);
            var promise = DriverPushesService.deleteParticularGroupDriver(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        viewGroupDetails($stateParams.id, vm.filterData, ' unscroll', true);
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            ); //  funtion to delete the driver from destionation sector 
        }

        ////////////////// GET BUSCAR VALUE BY SEARCH  //////////////////
        function getDriverBuscarData(data) {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.group_id = Number($stateParams.id);
            if (vm.filterData.search != '')
                dataSend.search_value = vm.filterData.search;
            if (vm.filterData.UniqueCar != '')
                dataSend.unique_car_id = Number(vm.filterData.UniqueCar);
            var promise = DriverPushesService.getBuscarDriverData(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    vm.buscarDriverData = payload.title.data;
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        var filterTextTimeout = '';
        function getDriverBuscarDataUniqueCar(data){
            if (vm.filterData.UniqueCarId != '') {
                if (filterTextTimeout) $timeout.cancel(filterTextTimeout);
                filterTextTimeout = $timeout(function () {
                    SearchByUniqueCar(data);
                }, 500);
            } else {
                // vm.buscarDriverData = [];
                SearchByUniqueCar(data);
            }
        }

        function SearchByUniqueCar() {
            vm.loading = true;
            var dataSend = {};
            var filterTextTimeout = '';
            dataSend.access_token = $cookies.get('obj');
            dataSend.group_id = Number($stateParams.id);
            if (vm.filterData.search != '')
            dataSend.search_value = vm.filterData.search;
            if (vm.filterData.UniqueCar!= '')
                dataSend.unique_car_id = Number(vm.filterData.UniqueCar);
            var promise = DriverPushesService.getBuscarDriverData(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    vm.buscarDriverData = payload.title.data;
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        ////////////////// GET BUSCAR VALUE BY SEARCH  //////////////////

        ////////////////// Destination Data TO add Buscar Vechicle //////////////////
        var index = -1;

        function AddBuscarVechicle(data) {
            data.flag = true;
            index = _.findIndex(vm.destinationBuscarDriverArray, { // function to check weather the value alerady in destination section then return this 
                email: data.email
            });
            if (index == -1) {
                vm.destinationBuscarDriverArray.push(data);
                // vm.FleetArray.push(data);
            }

        }

        ////////////////// Destination Data TO delete Buscar Vechicle //////////////////
        function deleteBuscarDriver(index) {
            vm.destinationBuscarDriverArray.splice(index, 1); //  funtion to delete the driver from destionation sector 
        }
        ////////////////// Destination Data TO delete Buscar Vechicle //////////////////


        function goBackToGroup() {
            vm.showDriverList = false;
            // $scope.$apply();
        }
        ////////////////// EDIT GROUP API //////////////////
        function editGroupApi() {
            if (vm.FleetArray.length == 0) {
                errorMessageFactory.showErrorMessage('Agrega un conductor');
                return;
            }
            vm.loading = true;
            var dataSend = {};
            var SendArray = [];
            vm.FleetArray.forEach(function (data) {
                SendArray.push({
                    fleet_id: data.fleet_id
                });
            });
            dataSend.access_token = $cookies.get('obj');
            dataSend.group_id = Number($stateParams.id);
            dataSend.group_name = vm.dataToFill.roleName;
            if (vm.dataToFill.description != '')
                dataSend.group_description = vm.dataToFill.description;
            // dataSend.fleet_list = SendArray;
            var promise = DriverPushesService.editGroupDrivers(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        $state.go('layout.groupDriversMain.groupDrivers');
                        getGroupDrivers(vm.filterData.offset, vm.filterData);
                        // $state.reload();
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

    }
})();
/**
 * Created by cl-macmini-51 on 08/02/18.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('VeiwGroupDetailsController', VeiwGroupDetailsController);

    /** @ngInject */
    function VeiwGroupDetailsController($cookies, $timeout, $state, $log, $stateParams, errorMessageFactory, DriverPushesService) {
        var vm = this;
        vm.dataToFill = {
            description: '',
            roleName: '',
            limit: 10,
            offset: 0,
            offsetMade: 10,
            UniqueCar: ''
        }
        vm.getFilterForUniqueCar = getFilterForUniqueCar;
        vm.goBack = goBack;
        vm.FleetArray = [];
        vm.getFilter = getFilter;
        vm.paginationChangedForVeiwDriverInGroup = paginationChangedForVeiwDriverInGroup;

        /////////// PAGINATION FOR VEIW DRIVER FOR PARTICULAR GROUP ///////////////////////
        function paginationChangedForVeiwDriverInGroup() {
            if (vm.fleetCount > vm.FleetArray.length) {
                console.log("i m inside the if");
                vm.dataToFill.offset = vm.dataToFill.offset + 10;
                viewGroupDetails($stateParams.id, vm.dataToFill, 'scroll', false);
            }

        }


        function viewGroupDetailsForName() {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.group_id = Number($stateParams.id);
            var promise = DriverPushesService.DriverDetails(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    console.log(payload);

                    if (payload.title.status == 200) {
                        vm.dataToFill.roleName = payload.title.data[0].group_name;
                        vm.dataToFill.description = payload.title.data[0].group_description;
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );

        }
        viewGroupDetailsForName();
        //=========================FUNCTION TO GET FILTER =============================
        function getFilter() {
            vm.dataToFill.offset = 0;
            viewGroupDetails($stateParams.id, vm.dataToFill, 'unscroll', true);
            // vm.loading = true;
            // vm.dataToFill.offset = 0;
            // var dataSend = {};
            // dataSend.access_token = $cookies.get('obj');
            // dataSend.group_id = Number($stateParams.id);
            // if (vm.dataToFill.UniqueCar != '' && vm.dataToFill.UniqueCar != null)
            //     dataSend.unique_car_id = (vm.dataToFill.UniqueCar);
            // if (vm.search != '')
            //     dataSend.search_value = vm.search;
            // var promise = DriverPushesService.searchParticularGroupDriver(dataSend);
            // promise.then(
            //     function (payload) {
            //         $log.log(payload);
            //         vm.loading = false;
            //         console.log(payload);

            //         if (payload.title.status == 200) {
            //             vm.FleetArray = payload.title.data;
            //         }


            //     },
            //     function (errorPayload) {
            //         $log.log(errorPayload);
            //         vm.loading = false;
            //         if (errorPayload.data.status == 401) {
            //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
            //         } else {
            //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
            //         }
            //     }
            // );
        }

        var filterTextTimeout = '';
        function getFilterForUniqueCar(event){
            if (vm.dataToFill.UniqueCar != '') {
                if (filterTextTimeout) $timeout.cancel(filterTextTimeout);
                filterTextTimeout = $timeout(function () {
                    vm.dataToFill.offset = 0;
                    vm.dataToFill.limit = 10;
                    viewGroupDetails($stateParams.id, vm.dataToFill, 'unscroll', true);
                }, 500);
            } else {
                // vm.buscarDriverData = [];
                vm.dataToFill.offset = 0;
                viewGroupDetails($stateParams.id, vm.dataToFill, 'unscroll', true);
            }
        }
        //=========================go back=============================
        function goBack() {
            $state.go('layout.groupDriversMain.groupDrivers');
        };

        //=========================GROUP DETAILS  =============================
        function viewGroupDetails(data, filterData, type, load) {
            vm.loading = load;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = filterData.limit;
            dataSend.offset = filterData.offset;
            dataSend.group_id = data;
            if (vm.dataToFill.UniqueCar != '' && vm.dataToFill.UniqueCar != null)
                dataSend.unique_car_id = (vm.dataToFill.UniqueCar);
            if (vm.search != '')
                dataSend.search_value = vm.search;
            var promise = DriverPushesService.getGroupDriversVeiw(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    console.log(payload, 'payload');
                    if (payload.title.status == 200) {
                        // vm.dataToFill.roleName = payload.title.data.group_name;
                        // vm.dataToFill.description = payload.title.data.group_description;
                        // vm.FleetArray = payload.title.data.fleet_list;
                        vm.fleetCount = payload.title.data.total_count;
                        if (type == 'scroll') {
                            for (var i = 0; i < payload.title.data.data.length; i++) {
                                vm.FleetArray.push(payload.title.data.data[i]);
                            }
                        } else {
                            vm.FleetArray = payload.title.data.data;
                        }
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        viewGroupDetails($stateParams.id, vm.dataToFill, 'unscroll', true);


        // function getFilter() {
        //     vm.filterOn = true;
        //     if (vm.search.length == 0) {
        //         vm.filterOn = false;
        //         vm.watchPagination = true;
        //         vm.sp_pagination = true;
        //     }
        // };
    }
})();
/**
 * Created by cl-macmini-51 on 7/13/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('ViewCarDetailsController', ViewCarDetailsController);

    /** @ngInject */
    function ViewCarDetailsController($cookies, $state, $log, $rootScope, $timeout, getCars, $scope, filterFilter, $mdDialog, $document, getVehicles, $stateParams, languageBasedErrorFactory, errorMessageFactory) {
        var vm = this;
        vm.getAllCars = getAllCars;
        vm.goBack = goBack;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        $log.log('driver');
        vm.loading = false;
        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.carMain.viewCarDetails');
            }
        });
        //==================get all drivers=======================
        function getAllCars(filter, skip, limit) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit;
            dataSend.offset = skip;
            dataSend.car_status = filter;
            dataSend.search_filter = 0;
            vm.loading = true;
            var promise = getCars.allCars(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.carDetails = _.where(payload.title.data.final_data.result, {
                        id: Number($stateParams.id)
                    })[0];
                    if (vm.carDetails.image_contrato != null) {
                        if (vm.carDetails.image_contrato.split('.')[3] == 'jpeg' || vm.carDetails.image_contrato.split('.')[3] == 'jpg') {
                            vm.carDetails.image_contrato = vm.carDetails.image_contrato;
                        } else {
                            vm.carDetails.image_contrato = 'https://s3.amazonaws.com/transvip/email_images/pdf.png';
                        }
                    }


                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };
        getAllCars(1, 0, 0);

        //===================go back function========================
        function goBack() {
            $state.go('layout.carMain.carsList');
        };
    }
})();
/**
 * Created by cl-macmini-51 on 5/3/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('VechicleBalanceController', VechicleBalanceController);

    /** @ngInject */
    function VechicleBalanceController($cookies, $state, $log, $rootScope, $timeout, $scope, filterFilter, $mdDialog, $document, getVehiclesBalance, languageBasedErrorFactory, errorMessageFactory, moment, getFilters, adminAccessService) {
        var vm = this;
        vm.addVechicleBalance = addVechicleBalance;
        vm.generalIsSelected = true;
        vm.expectationsIsSelected = false;
        vm.editVechicleBalance = editVechicleBalance;
        vm.cancelEditButton = cancelEditButton;
        vm.EditcancelFormBalanceDynamic = EditcancelFormBalanceDynamic;
        vm.general = general;
        vm.expectations = expectations;
        vm.flagError = false;
        vm.deleteVechicleBalance = deleteVechicleBalance;
        vm.integersCheck = integersCheck;
        vm.showAddFields = false;
        vm.cancelFormBalance = cancelFormBalance;
        vm.globalLimit = 1000;
        vm.editVechicleBalanceFlag = false;
        vm.paginationChangedForVehicleBalance = paginationChangedForVehicleBalance;
        vm.globalOffset = vm.globalLimit;
        vm.serviceOffset = 0;
        vm.dataToFill = {
            service_type: '',
            contrato_name: '',
            balanceAmount: '',
            skipVehicleBalance: 0,
            limitVehicleBalance: 10,
            mini_balance_id: '',
            balanceAmountDynamic: '',
            service_type_dynamice: '',
            contrato_name_dynamic: '',
            weekDay: '',
            hastaMinutes: '',
            hastaHours: '',
            desdeMinutes: '',
            desdeHours: '',
            skipVehicleBalanceDynamic: 0,
            limitVehicleBalanceDynamic: 10,
        }
        vm.addFormBalance = addFormBalance;
        /////////////////////// FUNCATIONS FOR DYNAMIC BALANCE  //////////////////////
        vm.addVechicleBalanceDynamice = addVechicleBalanceDynamice;
        vm.showAddFieldsDynamic = false;
        vm.addFormBalanceDynamic = addFormBalanceDynamic;
        vm.cancelFormBalanceDynamic = cancelFormBalanceDynamic;
        vm.flagErrorDynamic = false;
        vm.paginationChangedForVehicleBalanceDynamic = paginationChangedForVehicleBalanceDynamic;
        vm.editVechicleBalanceDynamicFlag = false;
        vm.deleteVechicleBalanceDynamic = deleteVechicleBalanceDynamic;
        vm.editVechicleBalanceDynamic = editVechicleBalanceDynamic;
        vm.weekDayArray = [{
                id: 1,
                name: 'Lunes'
            },
            {
                id: 2,
                name: 'Martes'
            },
            {
                id: 3,
                name: 'Miércoles'
            },
            {
                id: 4,
                name: 'Jueves'
            },
            {
                id: 5,
                name: 'Viernes'
            },
            {
                id: 6,
                name: 'Sábado'
            },
            {
                id: 0,
                name: 'Domingo'
            }
        ]



        // =================== INTERGER CHECK ===================
        function integersCheck(data, $event) {
            if (($event.keyCode) == 46 || ($event.keyCode) == 110 || ($event.keyCode) == 190) {
                $event.preventDefault();
            }
        }
        // =================== INTERGER CHECK ===================


        // =================== CANCEL FORM FOR EDIT  ===================
        function cancelEditButton() {
            vm.flagEdit = [];
        }
        // =================== CANCEL FORM FOR EDIT  ===================

        function general() {
            vm.expectationsIsSelected = false;
            vm.generalIsSelected = true;
            vm.dataToFill.limitVehicleBalance = 10;
            vm.dataToFill.skipVehicleBalance = 0;
            vm.flagEdit = [];
            vm.showAddFields = false;
            getVehicleBalance(vm.dataToFill, 'unscroll');
        }

        function expectations() {
            vm.expectationsIsSelected = true;
            vm.generalIsSelected = false;
            vm.showAddFieldsDynamic = false;
            vm.dataToFill.limitVehicleBalanceDynamic = 10;
            vm.dataToFill.skipVehicleBalanceDynamic = 0;
            vm.flagEditDynamic = [];
            getVehicleBalanceException(vm.dataToFill, 'unscroll');
        }

        // =================== INTERGER CHECK ===================

        // =================== FILTER OBJECT ===================
        vm.filterObject = {
            access_token: $cookies.get('obj'),
            service_filter: 1,
            service_category: 0,
            service_limit: vm.globalLimit,
            service_offset: vm.serviceOffset,
            service_search_filter: 0,
        }


        /////////////////////// TO ADD THE VEHICLE BALANCE //////////////////////
        function addVechicleBalance() {
            vm.loading = true;
            var promise = adminAccessService.checkStateValid('Agregar balance general'); //$stateParams.id
            return promise.then(
                function (payload) {
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (!payload.title.data.granted) {
                            // languageBasedErrorFactory.getProperErrorMessage('optionNotAvail', 0, 0);
                            errorMessageFactory.showErrorMessage(' No está autorizado para usar esta opción', 0);
                            return false;
                        } else {
                            vm.dataToFill.service_type = '';
                            vm.dataToFill.contrato_name = '';
                            vm.dataToFill.balanceAmount = '';
                            vm.editVechicleBalanceFlag = false;
                            vm.showAddFields = true;
                            vm.flagError  = false;
                            vm.flagEdit = [];
                        }
                    }
                },
                function (errorPayload) {
                    console.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        /////////////////////// TO ADD THE VEHICLE BALANCE //////////////////////

        /////////////////////// TO CANCEL THE VEHICLE BALANCE //////////////////////
        function cancelFormBalance() {
            vm.showAddFields = false;
        }
        /////////////////////// TO CANCEL THE VEHICLE BALANCE //////////////////////



        /////////////////////// PAGINATION FUNCTION FOR VEHICLE BALANCE //////////////////////
        function paginationChangedForVehicleBalance() {
            if (vm.vehicleBalanceListCount.length == vm.dataToFill.limitVehicleBalance) {
                vm.dataToFill.skipVehicleBalance = vm.dataToFill.skipVehicleBalance + 10;
                getVehicleBalance(vm.dataToFill, 'scroll');
            }
        }
        /////////////////////// PAGINATION FUNCTION FOR VEHICLE BALANCE //////////////////////

        /////////////////////// TO SAVE THE VEHICLE BALANCE //////////////////////
        function addFormBalance() {
            if (vm.dataToFill.contrato_name == '' || vm.dataToFill.balanceAmount == '' || vm.dataToFill.balanceAmount == null ||
                vm.dataToFill.service_type == '' || vm.dataToFill.service_type == []) {
                vm.flagError = true;
                return;
            }
            if (!vm.editVechicleBalanceFlag) {
                vm.loading = true;
                var dataSend = {};
                dataSend.tipo_contrato = [];
                if(vm.dataToFill.contrato_name == 'all'){
                    dataSend.tipo_contrato.push('Freelance');
                    dataSend.tipo_contrato.push('Leasing');
                }else {
                    dataSend.tipo_contrato.push(vm.dataToFill.contrato_name);
                }
                // dataSend.tipo_contrato = vm.dataToFill.contrato_name;
                dataSend.balance_amount = vm.dataToFill.balanceAmount;
                dataSend.service_id = vm.dataToFill.service_type;
                dataSend.access_token = $cookies.get('obj');
                var promise = getVehiclesBalance.addVechicleBalanceApi(dataSend); //$stateParams.id
                return promise.then(
                    function (payload) {
                        vm.loading = false;
                        if (payload.title.status == 200) {
                            languageBasedErrorFactory.getProperErrorMessage('successMessageVehicleBalance', 0, 1, 'layout.vechicleBalanceMain.vechicleBalance');
                            // $state.reload();
                        } else {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        console.log(errorPayload);
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            } else {
                vm.loading = true;
                var dataSend = {};
                dataSend.tipo_contrato = [];
                if(vm.dataToFill.contrato_name == 'all'){
                    dataSend.tipo_contrato.push('Freelance');
                    dataSend.tipo_contrato.push('Leasing');
                }else {
                    dataSend.tipo_contrato.push(vm.dataToFill.contrato_name);
                }
                dataSend.balance_amount = vm.dataToFill.balanceAmount;
                dataSend.service_id = vm.dataToFill.service_type;
                dataSend.mini_balance_id = vm.dataToFill.mini_balance_id;
                dataSend.access_token = $cookies.get('obj');
                var promise = getVehiclesBalance.editVechicleBalanceApi(dataSend); //$stateParams.id
                return promise.then(
                    function (payload) {
                        vm.loading = false;
                        if (payload.title.status == 200) {
                            // $state.reload();
                            languageBasedErrorFactory.getProperErrorMessage('successMessageVehicleBalance', 0, 1, 'layout.vechicleBalanceMain.vechicleBalance');
                        } else {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        console.log(errorPayload);
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }
        }
        /////////////////////// TO SAVE THE VEHICLE BALANCE //////////////////////


        /////////////////////// TO GET THE VEHICLE BALANCE LIST //////////////////////
        function getVehicleBalance(data, type) {
            vm.loading = true;
            var dataSend = {};
            dataSend.limit = data.limitVehicleBalance;
            dataSend.skip = data.skipVehicleBalance;
            dataSend.access_token = $cookies.get('obj');
            var promise = getVehiclesBalance.getVehicleBalanceApi(dataSend); //$stateParams.id
            return promise.then(
                function (payload) {
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        if (type == 'scroll') {
                            for (var i = 0; i < payload.title.data.length; i++) {
                                vm.vehicleBalanceList.push(payload.title.data[i]);
                            }
                        } else {
                            vm.vehicleBalanceList = payload.title.data;
                        }
                        vm.vehicleBalanceListCount = payload.title.data;
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    console.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        getVehicleBalance(vm.dataToFill, 'unscroll');
        /////////////////////// TO GET THE VEHICLE BALANCE LIST //////////////////////




        // =================== GET FILTER DATA ===================
        function getFilterDataFromBackend(data, type) { //Acc to Index ['branch_search', 'vehicle_search', 'service_search', 'agreement_search', 'corporate_search', 'operation_point_search']
            if (data) {
                vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
            } else {
                vm.filterObject = {
                    access_token: $cookies.get('obj'),
                    service_filter: 1,
                    service_category: 0,
                    service_search_filter: 0,
                }
            }
            vm.filterObject.service_limit = vm.globalLimit;
            vm.filterObject.service_offset = vm.serviceOffset;
            var promise = getFilters.getAllFilterData(vm.filterObject);
            promise.then(
                function (payload) {
                    vm.loading = false;
                    vm.service = [];
                    // *********** SERVICE DATA *********
                    if (payload.title.data.services) {
                        angular.forEach(payload.title.data.services.data, function (column) {
                            vm.service.push({
                                id: column.id,
                                name: column.service_name
                            })
                        });
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        }

        getFilterDataFromBackend();
        // =================== GET FILTER DATA ===================

        // =================== DELETE THE VECHICLE BALANCE  ===================
        function deleteVechicleBalance(data, event) {
            vm.loading = true;
            var promise = adminAccessService.checkStateValid('Borrar balance mínimo general'); //$stateParams.id
            return promise.then(
                function (payload) {
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (!payload.title.data.granted) {
                            // languageBasedErrorFactory.getProperErrorMessage('optionNotAvail', 0, 0);
                            errorMessageFactory.showErrorMessage(' No está autorizado para usar esta opción', 0);
                            return false;
                        } else {
                            openPopUpForDelete(data, event);
                        }
                    }
                },
                function (errorPayload) {
                    console.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function openPopUpForDelete(data, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('deleteVehicleBalance', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                var dataSend = {
                    access_token: $cookies.get('obj'),
                    mini_balance_id: Number(data.mini_balance_id)
                };
                //errorMessageFactory.showErrorMessage('Functionality is pending.',0);
                vm.loading = true;
                var promise = getVehiclesBalance.deleteVechicleBalanceApi(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        if (payload.title.status == 200) {
                            languageBasedErrorFactory.getProperErrorMessage('successMessageVehicleBalanceDelete', 0, 1, 'layout.vechicleBalanceMain.vechicleBalance');
                            //errorMessageFactory.showErrorMessage('Car deleted successfully.',1);
                        } else {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        }
        // =================== DELETE THE VECHICLE BALANCE  ===================

        // =================== EDIT THE VECHICLE BALANCE  ===================
        function editVechicleBalance(event, data, index) {
            vm.flagEdit = [];
            vm.loading = true;
            var promise = adminAccessService.checkStateValid('Editar balance mínimo general'); //$stateParams.id
            return promise.then(
                function (payload) {
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (!payload.title.data.granted) {
                            // languageBasedErrorFactory.getProperErrorMessage('optionNotAvail', 0, 0);
                            errorMessageFactory.showErrorMessage(' No está autorizado para usar esta opción', 0);
                            return false;
                        } else {
                            vm.showAddFields = false;
                            vm.flagEdit[index] = true;
                            vm.editVechicleBalanceFlag = true;
                            if(data.tipo_contrato.split(',').length > 1){
                                vm.dataToFill.contrato_name = 'all';
                            }else{
                                vm.dataToFill.contrato_name = data.tipo_contrato;
                            }
                            vm.dataToFill.balanceAmount = data.balance_amount;
                            vm.dataToFill.service_type = (data.service).split(',');
                            vm.dataToFill.service_type = vm.dataToFill.service_type.map(function (i) {
                                return Number(i);
                            });
                            vm.dataToFill.mini_balance_id = data.mini_balance_id;
                            console.log(vm.flagEdit, 'vm.flagEdit');

                        }
                    }
                },
                function (errorPayload) {
                    console.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        // =================== EDIT THE VECHICLE BALANCE  ===================



        /////////////////////// TO ADD THE VEHICLE DYNAMIC BALANCE //////////////////////
        function addVechicleBalanceDynamice() {
            vm.loading = true;
            var promise = adminAccessService.checkStateValid('Agregar balance dínamico'); //$stateParams.id
            return promise.then(
                function (payload) {
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (!payload.title.data.granted) {
                            // languageBasedErrorFactory.getProperErrorMessage('optionNotAvail', 0, 0);
                            errorMessageFactory.showErrorMessage(' No está autorizado para usar esta opción', 0);
                            return false;
                        } else {
                            vm.dataToFill.service_type_dynamice = '';
                            vm.dataToFill.contrato_name_dynamic = '';
                            vm.dataToFill.balanceAmountDynamic = '';
                            vm.dataToFill.hastaMinutes = '';
                            vm.dataToFill.hastaHours = '';
                            vm.dataToFill.desdeMinutes = '';
                            vm.dataToFill.desdeHours = '';
                            vm.dataToFill.weekDay = '';
                            vm.flagError = false;
                            vm.flagErrorDynamic = false;
                            vm.editVechicleBalanceDynamicFlag = false;
                            vm.showAddFieldsDynamic = true;
                            vm.flagEditDynamic = [];
                        }
                    }
                },
                function (errorPayload) {
                    console.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        /////////////////////// TO ADD THE VEHICLE DYNAMIC BALANCE //////////////////////


        /////////////////////// TO SAVE THE VEHICLE DYNAMIC BALANCE //////////////////////
        function addFormBalanceDynamic() {
            if (vm.dataToFill.contrato_name_dynamic == '' || vm.dataToFill.balanceAmountDynamic == '' || vm.dataToFill.balanceAmountDynamic == null ||
                vm.dataToFill.service_type_dynamice == '' || vm.dataToFill.service_type_dynamice == [] || vm.dataToFill.weekDay == '' || vm.dataToFill.weekDay == [] || vm.dataToFill.desdeHours == '' ||
                vm.dataToFill.hastaHours == '' || vm.dataToFill.hastaMinutes == '' || vm.dataToFill.hastaMinutes == '') {
                vm.flagErrorDynamic = true;
                return;
            }
            if((vm.dataToFill.hastaHours < vm.dataToFill.desdeHours) ){
                errorMessageFactory.showErrorMessage('Formato de hora es incorrecto.', 0);
                return;
            }
            if (!vm.editVechicleBalanceDynamicFlag) {
                // vm.loading = true;
                var dataSend = {};
                dataSend.tipo_contrato = [];
                if(vm.dataToFill.contrato_name_dynamic == 'all'){
                    dataSend.tipo_contrato.push('Freelance');
                    dataSend.tipo_contrato.push('Leasing');
                }else {
                    dataSend.tipo_contrato.push(vm.dataToFill.contrato_name_dynamic);
                }
                // dataSend.tipo_contrato = vm.dataToFill.contrato_name_dynamic;
                dataSend.balance_amount = vm.dataToFill.balanceAmountDynamic;
                dataSend.service_id = vm.dataToFill.service_type_dynamice;
                dataSend.day = vm.dataToFill.weekDay;
                if (vm.dataToFill.desdeHours.length == 1) {
                    vm.dataToFill.desdeHours = '0' + vm.dataToFill.desdeHours;
                }
                if (vm.dataToFill.desdeMinutes.length == 1) {
                    vm.dataToFill.desdeMinutes = '0' + vm.dataToFill.desdeMinutes;
                }
                if (vm.dataToFill.hastaHours.length == 1) {
                    vm.dataToFill.hastaHours = '0' + vm.dataToFill.hastaHours;
                }
                if (vm.dataToFill.hastaMinutes.length == 1) {
                    vm.dataToFill.hastaMinutes = '0' + vm.dataToFill.hastaMinutes;
                }
                if(vm.dataToFill.hastaHours == vm.dataToFill.desdeHours){
                    if(vm.dataToFill.desdeMinutes > vm.dataToFill.hastaMinutes){
                        errorMessageFactory.showErrorMessage('Formato de hora es incorrecto.', 0);
                        return;
                    }
                }
                if(vm.dataToFill.hastaHours == vm.dataToFill.desdeHours){
                    if(vm.dataToFill.desdeMinutes == vm.dataToFill.hastaMinutes){
                        errorMessageFactory.showErrorMessage('Formato de hora es incorrecto.', 0);
                        return;
                    }
                }
                dataSend.start_time = vm.dataToFill.desdeHours + ':' + vm.dataToFill.desdeMinutes + ':' + '00';
                dataSend.end_time = vm.dataToFill.hastaHours + ':' + vm.dataToFill.hastaMinutes + ':' + '00';;
                dataSend.access_token = $cookies.get('obj');
                vm.loading = true;
                var promise = getVehiclesBalance.addVechicleBalanceExceptionApi(dataSend); //$stateParams.id
                return promise.then(
                    function (payload) {
                        vm.loading = false;
                        if (payload.title.status == 200) {
                            errorMessageFactory.showErrorMessage('Balance mínimo guardado', 0);
                            // languageBasedErrorFactory.getProperErrorMessage('successMessageVehicleBalance', 0, 1, 'layout.vechicleBalanceMain.vechicleBalance');
                            vm.expectationsIsSelected = true;
                            vm.generalIsSelected = false;
                            vm.showAddFieldsDynamic = false;
                            vm.dataToFill.limitVehicleBalanceDynamic = 10;
                            vm.dataToFill.skipVehicleBalanceDynamic = 0;
                            vm.flagEditDynamic = [];
                            getVehicleBalanceException(vm.dataToFill, 'unscroll');
                            // $state.reload();
                        } else {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        console.log(errorPayload);
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            } else {
                var dataSend = {};
                dataSend.tipo_contrato = [];
                if(vm.dataToFill.contrato_name_dynamic == 'all'){
                    dataSend.tipo_contrato.push('Leasing');
                    dataSend.tipo_contrato.push('Freelance');
                }else {
                    dataSend.tipo_contrato.push(vm.dataToFill.contrato_name_dynamic);
                }
                // dataSend.tipo_contrato = vm.dataToFill.contrato_name_dynamic;
                dataSend.balance_amount = vm.dataToFill.balanceAmountDynamic;
                dataSend.service_id = vm.dataToFill.service_type_dynamice;
                dataSend.day = vm.dataToFill.weekDay;
                if (vm.dataToFill.desdeHours.length == 1) {
                    vm.dataToFill.desdeHours = '0' + vm.dataToFill.desdeHours;
                }
                if (vm.dataToFill.desdeMinutes.length == 1) {
                    vm.dataToFill.desdeMinutes = '0' + vm.dataToFill.desdeMinutes;
                }
                if (vm.dataToFill.hastaHours.length == 1) {
                    vm.dataToFill.hastaHours = '0' + vm.dataToFill.hastaHours;
                }
                if (vm.dataToFill.hastaMinutes.length == 1) {
                    vm.dataToFill.hastaMinutes = '0' + vm.dataToFill.hastaMinutes;
                }
                if(vm.dataToFill.hastaHours == vm.dataToFill.desdeHours){
                    if(vm.dataToFill.desdeMinutes > vm.dataToFill.hastaMinutes){
                        errorMessageFactory.showErrorMessage('Formato de hora es incorrecto.', 0);
                        return;
                    }
                }
                if(vm.dataToFill.hastaHours == vm.dataToFill.desdeHours){
                    if(vm.dataToFill.desdeMinutes == vm.dataToFill.hastaMinutes){
                        errorMessageFactory.showErrorMessage('Formato de hora es incorrecto.', 0);
                        return;
                    }
                }
                dataSend.start_time = vm.dataToFill.desdeHours + ':' + vm.dataToFill.desdeMinutes + ':' + '00';
                dataSend.end_time = vm.dataToFill.hastaHours + ':' + vm.dataToFill.hastaMinutes + ':' + '00';
                dataSend.mini_balance_exception_id = vm.dataToFill.mini_balance_exception_id;
                dataSend.access_token = $cookies.get('obj');
                vm.loading = true;
                var promise = getVehiclesBalance.editVechicleBalanceExceptionApi(dataSend); //$stateParams.id
                return promise.then(
                    function (payload) {
                        vm.loading = false;
                        if (payload.title.status == 200) {
                            // $state.reload();
                            errorMessageFactory.showErrorMessage('Balance mínimo guardado', 0);
                            // languageBasedErrorFactory.getProperErrorMessage('successMessageVehicleBalance', 0, 1, 'layout.vechicleBalanceMain.vechicleBalance');
                            vm.expectationsIsSelected = true;
                            vm.generalIsSelected = false;
                            vm.showAddFieldsDynamic = false;
                            vm.dataToFill.limitVehicleBalanceDynamic = 10;
                            vm.dataToFill.skipVehicleBalanceDynamic = 0;
                            vm.flagEditDynamic = [];
                            getVehicleBalanceException(vm.dataToFill, 'unscroll');
                        } else {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        console.log(errorPayload);
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }
        }
        /////////////////////// TO SAVE THE VEHICLE DYNAMIC BALANCE //////////////////////


        /////////////////////// TO CANCEL THE VEHICLE BALANCE //////////////////////
        function cancelFormBalanceDynamic() {
            vm.showAddFieldsDynamic = false;
        }
        /////////////////////// TO CANCEL THE VEHICLE BALANCE //////////////////////



        /////////////////////// PAGINATION FUNCTION FOR VEHICLE BALANCE  DYNAMIC//////////////////////
        function paginationChangedForVehicleBalanceDynamic() {
            if (vm.vehicleBalanceDynamicListCount.length == vm.dataToFill.limitVehicleBalanceDynamic) {
                vm.dataToFill.skipVehicleBalanceDynamic = vm.dataToFill.skipVehicleBalanceDynamic + 10;
                getVehicleBalanceException(vm.dataToFill, 'scroll');
            }
        }
        /////////////////////// PAGINATION FUNCTION FOR VEHICLE BALANCE  DYNAMIC //////////////////////


        /////////////////////// TO GET THE VEHICLE BALANCE LIST EXCEPTION//////////////////////
        function getVehicleBalanceException(data, type) {
            vm.loading = true;
            var dataSend = {};
            dataSend.limit = data.limitVehicleBalanceDynamic;
            dataSend.skip = data.skipVehicleBalanceDynamic;
            dataSend.access_token = $cookies.get('obj');
            var promise = getVehiclesBalance.getVehicleBalanceExceptionApi(dataSend); //$stateParams.id
            return promise.then(
                function (payload) {
                    vm.loading = false;
                    var dataShow = [];
                    if (payload.title.status == 200) {
                        if (type == 'scroll') {
                            for (var i = 0; i < payload.title.data.length; i++) {
                                var d = {}
                                d.mini_balance_exception_id = payload.title.data[i].mini_balance_exception_id;
                                d.tipo_contrato = payload.title.data[i].tipo_contrato;
                                d.service_name = payload.title.data[i].service_name;
                                d.day_name = payload.title.data[i].day_name;
                                var weekDays = [];
                                if (payload.title.data[i].day_name != null) {
                                    var day = payload.title.data[i].day_name.split(',');
                                    day.forEach(function (week) {
                                        if (week == '1') {
                                            weekDays.push('Lunes');
                                        } else if (week == '2') {
                                            weekDays.push('Martes');
                                        } else if (week == '3') {
                                            weekDays.push('Miércoles');
                                        } else if (week == '4') {
                                            weekDays.push('Jueves');
                                        } else if (week == '5') {
                                            weekDays.push('Viernes');
                                        } else if (week == '6') {
                                            weekDays.push('Sábado');
                                        } else if (week == '0') {
                                            weekDays.push('Domingo');
                                        }
                                    })
                                }
                                d.day_name_week = weekDays.join();
                                if (payload.title.data[i].end_time)
                                    d.end_time = payload.title.data[i].end_time.substring(0, 5);
                                if (payload.title.data[i].start_time)
                                    d.start_time = payload.title.data[i].start_time.substring(0, 5);
                                d.balance_amount = payload.title.data[i].balance_amount;
                                d.service = payload.title.data[i].service;
                                vm.vehicleBalanceDynamicList.push(d);
                            }
                        } else {
                            payload.title.data.forEach(function (data) {
                                var d = {}
                                d.mini_balance_exception_id = data.mini_balance_exception_id;
                                d.tipo_contrato = data.tipo_contrato;
                                d.service_name = data.service_name;
                                var weekDays = [];
                                if (data.day_name != null) {
                                    var day = data.day_name.split(',');
                                    day.forEach(function (week) {
                                        if (week == '1') {
                                            weekDays.push('Lunes');
                                        } else if (week == '2') {
                                            weekDays.push('Martes');
                                        } else if (week == '3') {
                                            weekDays.push('Miércoles');
                                        } else if (week == '4') {
                                            weekDays.push('Jueves');
                                        } else if (week == '5') {
                                            weekDays.push('Viernes');
                                        } else if (week == '6') {
                                            weekDays.push('Sábado');
                                        } else if (week == '0') {
                                            weekDays.push('Domingo');
                                        }
                                    })
                                }
                                d.day_name_week = weekDays.join();
                                d.balance_amount = data.balance_amount;
                                d.service = data.service;
                                d.day_name = data.day_name;
                                if (data.end_time)
                                    d.end_time = data.end_time.substring(0, 5);
                                if (data.start_time)
                                    d.start_time = data.start_time.substring(0, 5);
                                dataShow.push(d);
                                vm.vehicleBalanceDynamicList = dataShow;
                            })
                        }
                        vm.vehicleBalanceDynamicListCount = payload.title.data;
                        console.log(vm.vehicleBalanceDynamicList, 'vm.vehicleBalanceDynamicList');

                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    console.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        // getVehicleBalanceException(vm.dataToFill, 'unscroll');
        /////////////////////// TO GET THE VEHICLE BALANCE LIST EXCEPTION//////////////////////



        // =================== DELETE THE VECHICLE BALANCE Dynamic ===================
        function deleteVechicleBalanceDynamic(data, event) {
            vm.loading = true;
            var promise = adminAccessService.checkStateValid('Borrar balance mínimo dinámico'); //$stateParams.id
            return promise.then(
                function (payload) {
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (!payload.title.data.granted) {
                            // languageBasedErrorFactory.getProperErrorMessage('optionNotAvail', 0, 0);
                            errorMessageFactory.showErrorMessage(' No está autorizado para usar esta opción', 0);
                            return false;
                        } else {
                            openPopUpForDeleteDynamic(data, event);
                        }
                    }
                },
                function (errorPayload) {
                    console.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function openPopUpForDeleteDynamic(data, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('deleteVehicleBalanceDynamic', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                var dataSend = {
                    access_token: $cookies.get('obj'),
                    mini_balance_exception_id: Number(data.mini_balance_exception_id)
                };
                //errorMessageFactory.showErrorMessage('Functionality is pending.',0);
                vm.loading = true;
                var promise = getVehiclesBalance.deleteVechicleBalanceExceptionApi(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        if (payload.title.status == 200) {
                            languageBasedErrorFactory.getProperErrorMessage('successMessageVehicleBalanceDelete', 0, 1, 'layout.vechicleBalanceMain.vechicleBalance');
                            //errorMessageFactory.showErrorMessage('Car deleted successfully.',1);
                        } else {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        }
        // =================== DELETE THE VECHICLE BALANCE  Dynamic ===================


        // =================== EDIT THE VECHICLE BALANCE  Dynamic ===================
        function editVechicleBalanceDynamic(event, data, index) {
            vm.flagEditDynamic = [];
            vm.loading = true;
            var promise = adminAccessService.checkStateValid('Editar balance mínimo dinámico'); //$stateParams.id
            return promise.then(
                function (payload) {
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (!payload.title.data.granted) {
                            // languageBasedErrorFactory.getProperErrorMessage('optionNotAvail', 0, 0);
                            errorMessageFactory.showErrorMessage(' No está autorizado para usar esta opción', 0);
                            return false;
                        } else {
                            vm.showAddFields = false;
                            vm.showAddFieldsDynamic = false;
                            vm.flagEditDynamic[index] = true;
                            vm.editVechicleBalanceDynamicFlag = true;
                            if(data.tipo_contrato.split(',').length > 1){
                                vm.dataToFill.contrato_name_dynamic = 'all';
                            }else{
                                vm.dataToFill.contrato_name_dynamic = data.tipo_contrato;
                            }
                            vm.dataToFill.balanceAmountDynamic = data.balance_amount;
                            if (data.service != null) {
                                vm.dataToFill.service_type_dynamice = (data.service).split(',');
                                vm.dataToFill.service_type_dynamice = vm.dataToFill.service_type_dynamice.map(function (i) {
                                    return Number(i);
                                });
                            }
                            vm.dataToFill.weekDay = (data.day_name).split(',');
                            vm.dataToFill.weekDay = vm.dataToFill.weekDay.map(function (i) {
                                return Number(i);
                            });
                            vm.dataToFill.desdeMinutes = (data.start_time).substring(3, 5);
                            vm.dataToFill.desdeHours = (data.start_time).substring(0, 2);
                            vm.dataToFill.hastaMinutes = (data.end_time).substring(3, 5);
                            vm.dataToFill.hastaHours = (data.end_time).substring(0, 2);
                            vm.dataToFill.mini_balance_exception_id = data.mini_balance_exception_id;
                        }
                    }
                },
                function (errorPayload) {
                    console.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        // =================== EDIT THE VECHICLE BALANCE  Dynamic ===================


        // =================== EDIT THE VECHICLE BALANCE  Dynamic CANCEL ===================
        function EditcancelFormBalanceDynamic() {
            vm.flagEditDynamic = [];
        }
        // =================== EDIT THE VECHICLE BALANCE  Dynamic CANCEL ===================
    }
})();
/**
 * Created by cl-macmini-51 on 5/19/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .controller('UnassignDriverToCarController', UnassignDriverToCarController);

    /** @ngInject */
    function UnassignDriverToCarController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document, moment, getCars, getDrivers, getVehicles,
                                           $scope, languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.tFootFlag = false;
        vm.goBack = goBack;
        vm.unassignDriver = unassignDriver;
        vm.getAllDrivers = getAllDrivers;
        vm.getAllAssignedCars = getAllAssignedCars;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.carType = $stateParams.carType;
        vm.carNumber= $stateParams.carNumber;
        vm.carId= $stateParams.id;
        $log.log('Car_id', $stateParams);

        //====================event for getting refreshed================
        $scope.$on('StateReload', function(evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.carMain.unassignDriver');
            }
        });

        //=================go back================
        function goBack() {
            $state.go('layout.carMain.carsList');
        };
        //=================get all drivers======================
        function getAllDrivers() {
            vm.loading = true;
            var promise = getDrivers.allDriversWithoutLimit();
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    vm.allDrivers = payload.title.data.driver_data;
                },
                function(errorPayload) {
                    $log.log(errorPayload,'error');
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        }
        getAllDrivers();

        //=================get all drivers======================
        function getAllAssignedCars(skip,limit) {
            vm.loading = true;
            var promise = getCars.assignedDrivers(skip,limit);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    if(payload.title.status==200){
                        vm.loading = false;
                        vm.assignedCarList = payload.title.data.final_data.result;
                        vm.singleCarAssignedDetails = _.where(vm.assignedCarList,{id:Number($stateParams.id)});
                        if(!vm.singleCarAssignedDetails.length){
                            vm.tFootFlag = true;
                        }
                        else{
                            vm.tFootFlag = false;
                            for(var i=0;i<vm.singleCarAssignedDetails.length;i++){
                                vm.singleCarAssignedDetails[i].checked = true;
                            }
                        }
                    }else{
                        errorMessageFactory.showErrorMessage(payload.title.message,0);
                    }
                    
                },
                function(errorPayload) {
                    $log.log(errorPayload,'error');
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        }
        getAllAssignedCars(0,0);
        //================select driver from list=======================
        function unassignDriver(data,$event,index) {
            $log.log(data);
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('carUnassignedMsg',0,'3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton',0,'3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton',0,'3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                $log.log(data);

                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.fleet_id = data.fleet_id;
                dataSend.car_id = Number($stateParams.id);
                vm.loading = true;
                var promise = getCars.unassignCarToDriver(dataSend);
                promise.then(
                    function(payload) {
                        $log.log(payload);
                        vm.loading = false;
                        if(payload.title.status == 400){
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                        else if(payload.title.status == 401){
                            errorMessageFactory.showErrorMessage(payload.title.message,2,'home');
                        }
                        else if(payload.title.status == 201 || payload.title.status == 200) {
                            //errorMessageFactory.showErrorMessage('Car assigned successfully.');
                            //$timeout(function(){
                            //    $mdDialog.hide();
                            var dataForSysLogs = {
                                access_token: $cookies.get('obj'),
                                id: $stateParams.id,
                                identity: 2,  // 0- driver, 1- customer , 2 -car
                                message: 'Car unassigned from driver.'
                            };
                            $rootScope.systemLogsAdmin(dataForSysLogs);
                            $state.reload('layout.carMain.unassignDriver');
                        }
                        //$state.go('layout.carMain.carsList');
                        //},2000);
                    },
                    function(errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if(!vm.singleCarAssignedDetails[index].checked){
                            vm.singleCarAssignedDetails[index].checked = true;
                        }
                        if(errorPayload.data.status == 401){
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                        }
                        else{
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
                if(!vm.singleCarAssignedDetails[index].checked){
                    vm.singleCarAssignedDetails[index].checked = true;
                }
            });
        };
        //======================get all vehicles==============
        function getAllVehicles(skip, limt,filter) {
            vm.loading = true;
            var promise = getVehicles.allVehicles(skip, limt,filter);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    //vm.loading = false;
                    if(payload.title.status == 400){
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    else if(payload.title.status == 401){
                        errorMessageFactory.showErrorMessage(payload.title.message,2,'home');
                    }
                    else if(payload.title.status == 201 || payload.title.status == 200) {
                        vm.vehicle = [];
                        angular.forEach(payload.title.data.result, function (column) {
                            vm.vehicle.push({id: column.id, name: column.name});
                        });

                        for (var i = 0; i < vm.vehicle.length; i++) {
                            if ($stateParams.carType == vm.vehicle[i].id) {
                                vm.carNameGot = vm.vehicle[i].name;
                            }
                        }
                    }
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllVehicles(0, 0,2);
    }
})();
/**
 * Created by cl-macmini-51 on 5/3/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('CarsListController', CarsListController);

    /** @ngInject */
    function CarsListController($cookies, $state, $log, $rootScope, $timeout, getCars, $scope, filterFilter, $mdDialog, $document, getVehicles, getGeofence, languageBasedErrorFactory, errorMessageFactory, pendingRequests, moment, getFilters) {
        var vm = this;
        vm.getAllCars = getAllCars;
        $scope.carId = true;
        $log.log('driver');
        vm.loading = false;
        vm.currentPage = 0;
        vm.totalCars = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterTextTimeout = '';
        vm.filterOn = false;
        vm.getPagesCount = getPagesCount;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.init = init;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.editCarDetailsPop = editCarDetailsPop;
        vm.editCarDetailsApi = editCarDetailsApi;
        vm.approveUnapproverCar = approveUnapproverCar;
        vm.exportToCSV = exportToCSV;
        vm.deleteVehicle = deleteVehicle;
        vm.refreshData = refreshData;
        vm.paginationNew = paginationNew;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.predicate = 'index';
        vm.reverse = false;
        vm.filterData = {
            carStatus: '1',
            branch: 'all',
            search_filter: 0,
            search_value: ''
        };

        vm.paginationChangedForBranch = paginationChangedForBranch;
        vm.branchSearch = branchSearch;

        vm.branchList = [];
        vm.branchList.push({
            region_name: 'All',
            region_id: 'all'
        });

        vm.searchFilterArray = ['branch', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'service', 'agreement', 'corporatesList', 'operation_point'];

        vm.globalLimit = 10;
        vm.globalOffset = vm.globalLimit;

        vm.branchOffset = 0;

        setTimeout(function () {
            document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                // if (vm.branchList && (vm.branchList.length == 0)) {
                vm.searchBranchData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

        })

        // =================== FILTER OBJECT ===================
        vm.filterObject = {
            access_token: $cookies.get('obj'),
            branch_filter: 1,
            vehicle_filter: 0,
            service_filter: 0,
            agreement_filter: 0,
            corporate_filter: 0,
            service_category: 0,
            corporate_status: 0,
            agreement_status: 0,
            vehicle__status: 1,
            operation_point_filter: 0,
            branch_limit: vm.globalLimit,
            branch_offset: vm.branchOffset,
            branch_search_filter: 0,
            vehicle_search_filter: 0,
            service_search_filter: 0,
            agreement_search_filter: 0,
            corporate_search_filter: 0,
            operation_point_search_filter: 0
        }

        // =================== GET FILTER DATA ===================
        function getFilterDataFromBackend(data, type) { //Acc to Index ['branch_search', 'vehicle_search', 'service_search', 'agreement_search', 'corporate_search', 'operation_point_search']
            if (data) {
                vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
            } else {
                vm.filterObject = {
                    access_token: $cookies.get('obj'),
                    branch_filter: 1,
                    vehicle_filter: 0,
                    service_filter: 0,
                    agreement_filter: 0,
                    corporate_filter: 0,
                    service_category: 0,
                    corporate_status: 0,
                    agreement_status: 2,
                    vehicle__status: 2,
                    operation_point_filter: 0,
                    branch_search_filter: 0,
                    vehicle_search_filter: 0,
                    service_search_filter: 0,
                    agreement_search_filter: 0,
                    corporate_search_filter: 0,
                    operation_point_search_filter: 0
                }
            }

            vm.filterObject.branch_limit = vm.globalLimit;
            vm.filterObject.branch_offset = vm.branchOffset;

            var promise = getFilters.getAllFilterData(vm.filterObject);
            promise.then(
                function (payload) {

                    // ********** BRANCH DATA ********
                    if (payload.title.data.branches) {
                        var index = _.findIndex(vm.branchList, {
                            region_id: 'all'
                        });
                        if (index == -1)
                            vm.branchList.push({
                                region_name: 'All',
                                region_id: 'all'
                            });
                        angular.forEach(payload.title.data.branches.data, function (column) {

                            //CHECK FOR DUPLICATE ENTRY
                            var branchIndex = _.findIndex(vm.branchList, {
                                region_id: column.region_id
                            });
                            if (branchIndex == -1)
                                vm.branchList.push(column)
                        });
                        vm.branchTotalBackendCount = payload.title.data.branches.totalCount;
                    }

                    vm.loading = false;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        }
        getFilterDataFromBackend();

        // ************ PAGINATION ON BRANCH **************
        function paginationChangedForBranch() {
            var index = _.findIndex(vm[vm.searchFilterArray[0]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.branchTotalBackendCount > (vm.branchList.length - index)) {
                commonFunction(0);
                vm.branchOffset += 10;
                getFilterDataFromBackend(vm.searchBranchData, 0);
            }
        }

        // *********** COMMON FUNCTION FOR FILTER PAGINATION AND SEARCHING ***********
        function commonFunction(type, mode) {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                // vm['search' + vm.searchFilterArray[i] + 'Data'] = '';
                if (mode == 'search' || i != type) {
                    vm[vm.searchFilterArrayForClearArray[i]] = [];
                    // vm[vm.searchFilterArrayForClearArray[i]].push({
                    //     id: 'all',
                    //     name: 'All'
                    // });
                    vm[vm.searchFilterArray[i] + 'Offset'] = 0;
                    vm['search' + vm.searchFilterArray[i].substring(0, 1).toUpperCase() + vm.searchFilterArray[i].substring(1) + 'Data'] = '';
                }
            }
        }

        // ************ SEARCH BRANCH ***************
        function branchSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchBranchData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(0, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 0);
                }, 2000);
            }
        }

        // ******** CLEAR OFFSET *******
        function clearOffset() {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                vm[vm.searchFilterArray[i] + 'Offset'] = 0;
            }
        }

        // ********** ON BRANCH CHANGE **********
        vm.branchChanged = function () {
            clearOffset();
            vm.branchList = [];
            getFilterDataFromBackend();
        }
        //====================function for dropdown pages and page count===============
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];

        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllCars(vm.filterData, 0, vm.itemsPerPageGot);
        };

        function paginationNew(page) {
            getAllCars(vm.filterData, (page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot);
        }

        //==================refreshData=====================
        function refreshData() {
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllCars(vm.filterData, vm.currentPage * vm.itemsPerPageGot, vm.itemsPerPageGot);
        }

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.carMain.carsList');
            }
        });
        //==================get all drivers=======================
        function getAllCars(filter, skip, limit) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit;
            dataSend.offset = skip;
            dataSend.car_status = Number(filter.carStatus);
            if (filter.branch != 'all') {
                dataSend.branch = Number(filter.branch);
            }
            dataSend.search_filter = filter.search_filter;
            if (filter.search_filter == 1) {
                dataSend.search_value = filter.search_value;
            }
            vm.loading = true;
            var promise = getCars.allCars(dataSend);
            promise.then(
                function (payload) {
                    if (payload.title.status == 200) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        vm.agreement = [];
                        vm.branchList = [];
                        // vm.vehicle = [];
                        vm.service = [];
                        getFilterDataFromBackend();
                        vm.totalCars = payload.title.data.final_data.totalCount;
                        vm.dataLength = payload.title.data.final_data.totalCount;
                        if (payload.title.data.final_data.totalCount == 0) {
                            vm.sp_pagination = false;
                            vm.tBodyFlag = false;
                            vm.tFootFlag = true;
                            vm.filterOn = true;
                            vm.skipValueFilter = 0;
                        } else {
                            vm.sp_pagination = true;
                            vm.tBodyFlag = true;
                            vm.tFootFlag = false;
                            vm.filterOn = false;
                            vm.skipValueFilter = 0;

                            var dataArray = [];
                            var carsList = payload.title.data.final_data.result;
                            carsList.forEach(function (column) {
                                var d = {};
                                d.added_at = column.added_at;
                                d.car_photo = column.car_photo;
                                d.travel_card_key = column.travel_card_key;
                                d.permission_of_circulation = column.permission_of_circulation;
                                d.transportation_permit = column.transportation_permit;
                                d.passenger_insurance_key = column.passenger_insurance_key;
                                d.car_status = column.car_status;
                                d.car_type = column.car_type;
                                d.carName = column.carName;
                                d.id = column.id;
                                d.model_name = column.model_name;
                                d.color_name = column.color_name;
                                d.color_code = column.color_code;
                                d.model_id = column.model_id;
                                d.color_id = column.color_id;
                                d.tipo_contrato = column.tipo_contrato;
                                d.occupied_by = column.occupied_by;
                                d.owner_id = column.owner_id;
                                d.owner_type = column.owner_type;
                                d.registration_image = column.registration_image;
                                d.image_contrato = column.image_contrato;
                                d.registration_number = column.registration_number;
                                d.first_name = column.first_name;
                                d.last_name = column.last_name;
                                d.verification_comment = column.verification_comment;
                                d.verification_status = column.verification_status;
                                d.working_status = column.working_status;
                                d.modelity = column.modelity;
                                d.unique_car_id = column.unique_car_id;
                                d.branch = column.branch;
                                d.assigned_drivers = column.assigned_drivers;
                                d.society_id = column.society_id;
                                dataArray.push(d);
                                
                                
                            });
                            vm.carsList = dataArray;
                            for (var i = 0; i < vm.carsList.length; i++) {
                                vm.carsList[i].index = (skip + i);
                            }
                            if (vm.dataLength <= vm.itemsPerPageGot) {
                                vm.sp_pagination = false;
                            } else {
                                vm.sp_pagination = true;
                                //vm.pageCount(payload.title.totalCount);
                            }
                            vm.skipValue = vm.carsList[0].index;
                            vm.limitValue = vm.carsList[vm.carsList.length - 1].index;

                            //$scope.$watch('vm.search', function(newVal, oldVal) {
                            //    vm.filtered = filterFilter(vm.carsList, newVal);
                            //    vm.totalItems = vm.filtered.length;
                            //    if (vm.filtered.length == 0) {
                            //        vm.watchPagination = false;
                            //    } else {
                            //        vm.watchPagination = true;
                            //    }
                            //    if (vm.filterOn == true) {
                            //        vm.skipValueFilter = vm.filtered.length;
                            //        vm.sp_pagination = false;
                            //    }
                            //}, true);

                            //range();
                        }
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }

                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };
        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    } else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        vm.getAllCars(vm.filterData, (b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected);
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    //console.log($scope.totalPages);
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        //console.log($scope.currentPage);
        //        vm.currentPage++;
        //        vm.getAllCars(vm.filterData, (a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected);
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    vm.getAllCars(vm.filterData, (m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected);
        //};

        function init() {
            vm.getAllCars(vm.filterData, 0, vm.searchModel.limit);
        };
        init();

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            //vm.filterOn = true;
            vm.currentPage = 0;
            vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
            vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
            pendingRequests.cancelAll();
            if (vm.search.length == 0) {
                vm.filterData.search_filter = 0;
                vm.filterData.search_value = '';
                vm.getAllCars(vm.filterData, 0, vm.searchModel.limit);
                //vm.filterOn = false;
                //vm.watchPagination = true;
                //vm.sp_pagination = true;

            } else {
                vm.filterData.search_filter = 1;
                vm.filterData.search_value = vm.search;
                //if (vm.filterTextTimeout) $timeout.cancel(vm.filterTextTimeout);
                //vm.filterTextTimeout = $timeout(function(){
                vm.getAllCars(vm.filterData, 0, vm.searchModel.limit);
                //},500)
            }
        };

        //=========================edit car details pop ===============================
        function editCarDetailsPop(data, $event) {
            $log.log(data);
            $log.log(vm.vehicle);
            vm.items = data;
            for (var j = 0; j < vm.vehicle.length; j++) {
                if (vm.vehicle[j].name == data.carName) {
                    vm.items.car_type = vm.vehicle[j].id;
                    break;
                } else {
                    vm.items.car_type = '';
                }
            }
            vm.items.modelity = vm.items.modelity.toString();
            vm.items.working_status = vm.items.working_status.toString();
            vm.items.car_image_upload = '';
            vm.items.registration_image_upload = '';
            vm.items.contrato_name = data.tipo_contrato;
            // var modelObject = {
            //     model_id: data.model_id,
            //     name: data.model_name
            // }
            vm.items.model = data.model_id;
            var colorObject = {
                color_id: data.color_id,
                name: data.color_name,
                code: data.color_code
            }
            vm.items.color = colorObject;
            if(data.image_contrato != null){
                if(data.image_contrato.split('.')[3] == 'jpeg' || data.image_contrato.split('.')[3] == 'jpg'){
                    vm.items.contrato = data.image_contrato;
                }else{
                    vm.items.contrato = 'https://s3.amazonaws.com/transvip/email_images/pdf.png';
                }
            }
            vm.items.travel_card_key_upload = '';
            // vm.items.verification_comment = ' ';
            vm.items.passenger_insurance_key_upload = '';
            vm.items.permission_of_circulation_upload = '';
            vm.items.transportation_permit_upload = '';
            vm.items.contrato_image_upload = '';
            vm.items.uniqueCarId = data.unique_car_id ? data.unique_car_id : '';
            vm.items.ErrMsg = '';
            vm.items.vehicleList = vm.vehicle;
            vm.items.modelList = vm.vehicleModel;
            vm.items.vehicleColorList = vm.vehicleColor;
            vm.items.societies = vm.societies;
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/editCarDetailsPop.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });

            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.errorMessage = false;
                $scope.errorMessageSize = false;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    $log.log(vm.items);
                    // if ((vm.items.car_photo == null || vm.items.car_photo == undefined || vm.items.car_photo == "") && (vm.items.car_image_upload == null || vm.items.car_image_upload == undefined || vm.items.car_image_upload == "")) {
                    //     vm.items.ErrMsg = languageBasedErrorFactory.getProperErrorMessage('carImageCheck', 0, '3');
                    //     $timeout(function () {
                    //         vm.items.ErrMsg = '';
                    //     }, 2000);
                    //     return;
                    // }
                    if ((vm.items.permission_of_circulation_upload == null || vm.items.permission_of_circulation_upload == undefined || vm.items.permission_of_circulation_upload == "") && (vm.items.permission_of_circulation == null || vm.items.permission_of_circulation == undefined || vm.items.permission_of_circulation == "")) {
                        vm.items.ErrMsg = languageBasedErrorFactory.getProperErrorMessage('carCirculationImage', 0, '3');
                        $timeout(function () {
                            vm.items.ErrMsg = '';
                        }, 2000);
                        return;
                    }
                    // else if ((vm.items.transportation_permit_upload == null || vm.items.transportation_permit_upload == undefined || vm.items.transportation_permit_upload == "") && (vm.items.transportation_permit == null || vm.items.transportation_permit == undefined || vm.items.transportation_permit == "")) {
                    //     vm.items.ErrMsg = languageBasedErrorFactory.getProperErrorMessage('transportationPermit', 0, '3');
                    //     $timeout(function () {
                    //         vm.items.ErrMsg = '';
                    //     }, 2000);
                    //     return;
                    // }
                    //  else if ((vm.items.travel_card_key_upload == null || vm.items.travel_card_key_upload == undefined || vm.items.travel_card_key_upload == "") && (vm.items.travel_card_key == null || vm.items.travel_card_key == undefined || vm.items.travel_card_key == "")) {
                    //     vm.items.ErrMsg = languageBasedErrorFactory.getProperErrorMessage('carTravelKeyImage', 0, '3');
                    //     $timeout(function () {
                    //         vm.items.ErrMsg = '';
                    //     }, 2000);
                    //     return;
                    // }
                    //  else if ((vm.items.passenger_insurance_key_upload == null || vm.items.passenger_insurance_key_upload == undefined || vm.items.passenger_insurance_key_upload == "") && (vm.items.passenger_insurance_key == null || vm.items.passenger_insurance_key == undefined || vm.items.passenger_insurance_key == "")) {
                    //     vm.items.ErrMsg = languageBasedErrorFactory.getProperErrorMessage('carPassengerImage', 0, '3');
                    //     $timeout(function () {
                    //         vm.items.ErrMsg = '';
                    //     }, 2000);
                    //     return;
                    // } 
                    // else if ((vm.items.registration_image_upload == null || vm.items.registration_image_upload == undefined || vm.items.registration_image_upload == "") && (vm.items.registration_image == null || vm.items.registration_image == undefined || vm.items.registration_image == "")) {
                    //     vm.items.ErrMsg = languageBasedErrorFactory.getProperErrorMessage('carRegistrationImage', 0, '3');
                    //     $timeout(function () {
                    //         vm.items.ErrMsg = '';
                    //     }, 2000);
                    //     return;
                    // }
                    else {
                        $mdDialog.hide();
                        editCarDetailsApi(vm.items);
                    }

                };

                $scope.uploadName = '';
                $scope.clickTrigger = function ($event, type) {
                    $log.log('ddf');
                    // $scope.errorMessage = false;
                    // $scope.errorMessageSize = false;
                    $event.stopPropagation();
                    $scope.uploadName = type;
                    var element = document.getElementById('documentUpload');
                    element.click();
                };

                $scope.file_to_upload = function (File, type) {
                    $log.log('type', type);
                    var file = File[0];
                    var transcript = File[0];
                    var reader = new FileReader;
                    reader.onload = function (e) {
                        //    var img = new Image;
                        //    img.onload = function () {
                        //////////////// TICKET 2807 //////////////////
                        // if (type == 'CAR_IMAGE') {
                        //     $scope.items.car_image_upload = File[0];
                        //     document.getElementById('carImage').setAttribute('src', e.target.result);
                        // } 
                        // else if (type == 'REGISTER_IMAGE') {
                        //     $scope.items.registration_image_upload = File[0];
                        //     document.getElementById('registerImage').setAttribute('src', e.target.result);
                        // }
                        if (type == 'PERMISSION_OF_CIRCULATION') {
                            $scope.items.permission_of_circulation_upload = File[0];
                            document.getElementById('permission').setAttribute('src', e.target.result);
                        } else if (type == 'TRANSPORTATION_PERMIT') {
                            $scope.items.transportation_permit_upload = File[0];
                            document.getElementById('transportation_permit').setAttribute('src', e.target.result);
                        } else if (type == 'PERMISSION_OF_CONTRATO') {
                            var size = (File[0].size / 1024);
                            if (size / 1024 > 5) {
                                $scope.errorMessageSize = true;
                                $scope.errorMessage = false;
                                $scope.$apply();
                                // errorMessageFactory.showErrorMessage('el tamaño del archivo debe ser inferior a 5 MB.', 0);
                                return;
                            } else {
                                $scope.errorMessageSize = false;
                                $scope.$apply();
                            }
                            console.log(File[0].name);
                            
                            if (File[0].type.split('/')[1] == 'jpeg' || File[0].type.split('/')[1] == 'pdf') {
                                $scope.errorMessage = false;
                                $scope.$apply();
                            } else {
                                $scope.errorMessage = true;
                                $scope.errorMessageSize = false;
                                $scope.$apply();
                                return;
                            }
                            if(File[0].type.split('/')[1] == 'pdf'){
                                // File[0].name = 'assets/images/noImage.jpeg';
                                var imageUrl = 'https://s3.amazonaws.com/transvip/email_images/pdf.png'
                                $scope.items.contrato_image_upload = File[0];
                                document.getElementById('contrato_image').setAttribute('src', imageUrl);
                            }else{
                                $scope.items.contrato_image_upload = File[0];
                                document.getElementById('contrato_image').setAttribute('src', e.target.result);
                            }
                        }
                        // else if (type == 'TRAVEL_CARD_KEY') {
                        //     $scope.items.travel_card_key_upload = File[0];
                        //     document.getElementById('travel').setAttribute('src', e.target.result);
                        // }
                        //  else if (type == 'PASSENGER_INSURANCE_KEY') {
                        //     $scope.items.passenger_insurance_key_upload = File[0];
                        //     document.getElementById('seatInsurance').setAttribute('src', e.target.result);
                        // }
                        //};

                        //    img.src = reader.result;
                    };
                    reader.readAsDataURL(transcript);
                    $log.log($scope.items);
                };
            }
        };

        //=====================edit car api hit=============================
        function editCarDetailsApi(data) {
            $log.log(data);

            var dataSendCar = new FormData();
            dataSendCar.append('access_token', $cookies.get('obj'));
            dataSendCar.append('fleet_id', data.owner_id);
            dataSendCar.append('car_id', data.id);
            dataSendCar.append('registration_number', data.registration_number);
            dataSendCar.append('car_type', Number(data.car_type));
            dataSendCar.append('working_status', Number(data.working_status));
            dataSendCar.append('modelity', Number(data.modelity));
            dataSendCar.append('verification_comment', (data.verification_comment ? data.verification_comment : ' '));
            dataSendCar.append('unique_car_id', Number(data.uniqueCarId));
            dataSendCar.append('model_id', Number(data.model));
            dataSendCar.append('color_id', Number(data.color.color_id));
            dataSendCar.append('tipo_contrato', (data.contrato_name));
            if (data.car_image_upload) {
                dataSendCar.append('car_photo', data.car_image_upload);
            }
            if (data.registration_image_upload) {
                dataSendCar.append('registration_image', data.registration_image_upload);
            }
            if (data.permission_of_circulation_upload) {
                dataSendCar.append('permission_of_circulation', data.permission_of_circulation_upload);
            }
            if (data.transportation_permit_upload) {
                dataSendCar.append('transportation_permit', data.transportation_permit_upload);
            }
            if (data.travel_card_key_upload) {
                dataSendCar.append('travel_card_key', data.travel_card_key_upload);
            }
            if (data.passenger_insurance_key_upload) {
                dataSendCar.append('passenger_insurance_key', data.passenger_insurance_key_upload);
            }
            if (data.contrato_image_upload) {
                dataSendCar.append('image_contrato', data.contrato_image_upload);
            }
            if (data.society_id) {
                dataSendCar.append('society_id', Number(data.society_id));
            }
            vm.loading = true;
            var promise = getCars.editCarDetails(dataSendCar);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    var dataForSysLogs = {
                        access_token: $cookies.get('obj'),
                        id: data.id,
                        identity: 2, // 0- driver, 1- customer , 2 -car
                        message: payload.title.message
                    };
                    $rootScope.systemLogsAdmin(dataForSysLogs);
                    if( payload.title.message == "Exitoso" ){
                        languageBasedErrorFactory.getProperErrorMessage('carDetailsUpdated', 0, 1, 'layout.carMain.carsList');
                    } else { 
                        errorMessageFactory.showErrorMessage(payload.title.message, 1, 'layout.carMain.carsList');
                    }
                    //errorMessageFactory.showErrorMessage('Car details updated successfully.',1);
                    //$timeout(function() {
                    //    $mdDialog.hide();
                    //    $state.reload();
                    //}, 2000);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //==============================approve unapprove car=========================
        function approveUnapproverCar(id, $event) {
            var msg = '';
            var msgSys = '';
            var flag = '';
            if (id.verification_status == '0' || id.verification_status == 0) {
                msg = languageBasedErrorFactory.getProperErrorMessage('approveCarText', 0, '3');
                msgSys = 'Car approved.';
                flag = 1;
            } else {
                msg = languageBasedErrorFactory.getProperErrorMessage('unapproveCarText', 0, '3');
                msgSys = 'Car disapprovd.';
                flag = 0;
            }
            vm.items = {
                id: id.id,
                comments: '',
                unique_car_id: '',
                value: flag,
                message: msg
            };

            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/approveCar.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });

            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    $log.log('confirmed');
                    if (vm.items.unique_car_id == null || vm.items.unique_car_id == undefined || vm.items.unique_car_id == "") {
                        $scope.carId = true;
                        return false;
                    }
                    $mdDialog.hide();
                    vm.loading = true;
                    var promise = getCars.approveUnapprove(id.id, flag, vm.items.comments, vm.items.unique_car_id);
                    promise.then(
                        function (payload) {
                            $log.log(payload);
                            vm.loading = false;
                            var dataForSysLogs = {
                                access_token: $cookies.get('obj'),
                                id: id,
                                identity: 2, // 0- driver, 1- customer , 2 -car
                                message: msgSys
                            };
                            $rootScope.systemLogsAdmin(dataForSysLogs);
                            $state.reload('layout.carMain.carsList');
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                };
            }
        };
        //======================get all vehicles==============
        function getAllVehicles(skip, limt, filter) {

            vm.loading = true;
            var promise = getVehicles.allVehicles(skip, limt, filter);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    //vm.loading = false;
                    console.log(payload, "payload");

                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.vehicle = [];
                        angular.forEach(payload.title.data.result, function (column) {
                            if (column.status == 1)
                                vm.vehicle.push({
                                    id: column.id,
                                    name: column.name
                                });
                        });
                    }
                    // console.log('vehicle', vm.vehicle)
                    // console.log('data', payload.title.data.result)
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllVehicles(0, 0, 2);

        function ModelList() {
            vm.loading = true;
            var dataSend = {}
            dataSend.limit = 5000;
            dataSend.offset = 0;
            dataSend.is_active = 1;
            var promise = getCars.carModelList(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    console.log(payload, 'payload');
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.vehicleModel = [];
                        angular.forEach(payload.title.data.result, function (column) {
                            // if (column.status == 1)
                            vm.vehicleModel.push({
                                model_id: column.model_id,
                                name: column.name
                            });
                        });
                    }
                    // console.log('vehicle', vm.vehicle)
                    // console.log('data', payload.title.data.result)
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        ModelList();


        function colorList() {
            vm.loading = true;
            var dataSend = {}
            dataSend.limit = 5000;
            dataSend.offset = 0;
            dataSend.is_active = 1;
            var promise = getCars.carcolorList(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    console.log(payload, 'payloadcolor');
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.vehicleColor = [];
                        angular.forEach(payload.title.data.result, function (column) {
                            // if (column.status == 1)
                            vm.vehicleColor.push({
                                color_id: column.color_id,
                                name: column.name,
                                code: column.code
                            });
                        });
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        colorList();

        //=================================export to csv==============================
        function exportToCSV(filter, skip, limit) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit;
            dataSend.offset = skip;
            dataSend.car_status = Number(filter.carStatus);
            vm.loading = true;
            var promise = getCars.allCars(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    console.log(payload, 'payload');

                    var dataArrayE = [];
                    var carListExport = payload.title.data.final_data.result;
                    carListExport.forEach(function (column) {
                        var d = {};
                        d['Car ID'] = column.id;
                        d['Car Type'] = column.carName;
                        d['Registration Number'] = column.registration_number;
                        d['Unique No.'] = column.unique_car_id;
                        d['Date of Joining'] = moment(column.added_at).format('lll');
                        d['Added By Admin'] = column.added_by_admin == 0 || column.added_by_admin == '0' ? 'NO' : 'YES';
                        d['Admin Email'] = column.admin_email;
                        // d['Car Photo'] = column.car_photo;
                        // d['Registration Image'] = column.registration_image;
                        // d['Travel Card Key'] = column.travel_card_key;
                        d['Permission of Circulation'] = column.permission_of_circulation;
                        d['Transportation Permission'] = column.transportation_permit;
                        // d['Passenger Insurance Key'] = column.passenger_insurance_key;
                        d['Owner ID'] = column.owner_id;
                        d['Owner Name'] = column.first_name + " " + column.last_name;
                        d['Car Verification Comments'] = column.verification_comment;
                        d['Car Verification Status'] = column.verification_status == 0 || column.verification_status == '0' ? 'Not Verified' : 'Verified';
                        d['Car Working Status'] = column.working_status == 0 || column.working_status == '0' ? 'Not Active' : 'Active';
                        //d.fleet_route = column.fleet_route;
                        dataArrayE.push(d);
                    });
                    vm.carListExport = dataArrayE;
                    alasql('SELECT * INTO CSV("carList.csv",{headers:true}) FROM ?', [vm.carListExport]);

                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };
        //======================delete car hit===========================
        function deleteVehicle(data, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('deleteCarPop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                var dataSend = {
                    access_token: $cookies.get('obj'),
                    car_id: Number(data.id)
                };
                //errorMessageFactory.showErrorMessage('Functionality is pending.',0);
                vm.loading = true;
                var promise = getCars.deleteCar(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        languageBasedErrorFactory.getProperErrorMessage('deleteCarSucc', 0, 1, 'layout.carMain.carsList');
                        //errorMessageFactory.showErrorMessage('Car deleted successfully.',1);
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        };

        //====================get branch list====================
        // function getBranch() {

        // vm.branchList = [];
        // vm.branchList = JSON.parse(JSON.stringify(getFilters.branchesFiltersData.data));
        // vm.branchList.push({
        //     region_name: 'All',
        //     region_id: 'all'
        // });
        // $scope.$apply();


        // vm.loading = true;
        // var promise = getGeofence.branch();
        // promise.then(
        //     function(payload) {
        //         $log.log(payload);
        //         vm.loading = false;
        //         if(payload.title.status == 400){
        //             errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //         }
        //         else if(payload.title.status == 401){
        //             errorMessageFactory.showErrorMessage(payload.title.message,2,'home');
        //         }
        //         else if(payload.title.status == 201 || payload.title.status == 200) {
        //             var where = _.where(payload.title.data, {parent_id: 0});
        //             //vm.branchList = _.where(where, { is_active: 1 });
        //             vm.branchList = where;

        //             vm.branchList.push({
        //                 region_name: 'All',
        //                 region_id: 'all'
        //             });
        //         }
        //     },
        //     function(errorPayload) {
        //         $log.log(errorPayload);
        // vm.loading = false;
        //         if (errorPayload.data.status == 401) {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
        //         } else {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //         }
        //     }
        // );
        // }
        // WHen Page refresh service take time to get data from backend
        // setTimeout(function () {
        //     getBranch();
        // }, 1000);
        // ***** GET SOCIETIES *********
        function getAllSocieties() {
            var dataSend = {};
            // dataSend.access_token = $cookies.get('obj');
            vm.loading = true;
            var promise = getCars.societiesList();
            promise.then(
                function (payload) {
                    if (payload.title.status == 200) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        vm.societies = payload.title.data;       
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }

                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };
        getAllSocieties();
    }
})();
/**
 * Created by cl-macmini-51 on 5/3/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('CarsModelsController', CarsModelsController);

    /** @ngInject */
    function CarsModelsController($cookies, $state, $log, $rootScope, $timeout, getCars, $scope, filterFilter, $mdDialog, $document, getVehicles, getGeofence, languageBasedErrorFactory, errorMessageFactory, pendingRequests, moment, getFilters) {
        var vm = this;
        vm.getAllModelsCars = getAllModelsCars;
        vm.blockModel = blockModel;
        $scope.carId = true;
        $log.log('driver');
        vm.loading = false;
        vm.currentPage = 0;
        vm.totalCars = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.searchModel = {
            limit: 100,
            limitOptions: [100, 200 , 300 ,400 , 500]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
        vm.filterTextTimeout = '';
        vm.filterOn = false;
        vm.getPagesCount = getPagesCount;
        vm.init = init;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.deleteVehicleModel = deleteVehicleModel;
        vm.refreshData = refreshData;
        vm.paginationNew = paginationNew;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.predicate = 'index';
        vm.reverse = false;
        vm.filterData = {
            carStatus: '1',
            branch: 'all',
            search_filter: 0,
            search_value: ''
        };
        vm.openPopForAdd = openPopForAdd;




        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllModelsCars(vm.filterData, 0, vm.itemsPerPageGot);
        };

        function paginationNew(page) {
            getAllModelsCars(vm.filterData, (page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot);
        }

        //==================refreshData=====================
        function refreshData() {
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllModelsCars(vm.filterData, vm.currentPage * vm.itemsPerPageGot, vm.itemsPerPageGot);
        }

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.carMain.carsList');
            }
        });
        //==================get all drivers=======================
        function getAllModelsCars(filter, skip, limit) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit;
            dataSend.offset = skip;
            dataSend.is_active = Number(filter.carStatus);
            // dataSend.search_filter = filter.search_filter;
            if (filter.search_filter == 1) {
                dataSend.search_value = filter.search_value;
            }
            vm.loading = true;
            var promise = getCars.carModelList(dataSend);
            promise.then(
                function (payload) {
                    if (payload.title.status == 200) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        vm.totalCars = payload.title.data.count[0].count;
                        vm.dataLength = payload.title.data.count[0].count;
                        if (payload.title.data.count[0].count == 0) {
                            vm.sp_pagination = false;
                            vm.tBodyFlag = false;
                            vm.tFootFlag = true;
                            vm.filterOn = true;
                            vm.skipValueFilter = 0;
                        } else {
                            vm.sp_pagination = true;
                            vm.tBodyFlag = true;
                            vm.tFootFlag = false;
                            vm.filterOn = false;
                            vm.skipValueFilter = 0;
                            var dataArray = [];
                            var carsModelsList = payload.title.data.result;
                            carsModelsList.forEach(function (column) {
                                var d = {};
                                d.model_id = column.model_id;
                                d.name = column.name;
                                d.is_blocked = column.active;
                                dataArray.push(d);
                            });
                            vm.carsModelList = dataArray;
                            for (var i = 0; i < vm.carsModelList.length; i++) {
                                vm.carsModelList[i].index = (skip + i);
                            }
                            if (vm.dataLength <= vm.itemsPerPageGot) {
                                vm.sp_pagination = false;
                            } else {
                                vm.sp_pagination = true;
                                //vm.pageCount(payload.title.totalCount);
                            }
                            vm.skipValue = vm.carsModelList[0].index;
                            vm.limitValue = vm.carsModelList[vm.carsModelList.length - 1].index;
                            console.log(vm.skipValue, 'limitValue', vm.limitValue, vm.sp_pagination, vm.itemsPerPageGot);

                        }
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }

                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };

        function init() {
            vm.getAllModelsCars(vm.filterData, 0, vm.searchModel.limit);
        };
        init();

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            //vm.filterOn = true;
            vm.currentPage = 0;
            vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
            vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
            pendingRequests.cancelAll();
            if (vm.search.length == 0) {
                vm.filterData.search_filter = 0;
                vm.filterData.search_value = '';
                vm.getAllModelsCars(vm.filterData, 0, vm.searchModel.limit);

            } else {
                vm.filterData.search_filter = 1;
                vm.filterData.search_value = vm.search;
                //if (vm.filterTextTimeout) $timeout.cancel(vm.filterTextTimeout);
                //vm.filterTextTimeout = $timeout(function(){
                vm.getAllModelsCars(vm.filterData, 0, vm.searchModel.limit);
                //},500)
            }
        };

        // //======================get all vehicles==============
        // function getAllVehicles(skip, limt, filter) {

        //     vm.loading = true;
        //     var promise = getVehicles.allVehicles(skip, limt, filter);
        //     promise.then(
        //         function (payload) {
        //             $log.log('sxdsads', payload);
        //             //vm.loading = false;
        //             console.log(payload,"payload");

        //             if (payload.title.status == 400) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //             } else if (payload.title.status == 401) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //             } else if (payload.title.status == 201 || payload.title.status == 200) {
        //                 vm.vehicle = [];
        //                 angular.forEach(payload.title.data.result, function (column) {
        //                     if (column.status == 1)
        //                         vm.vehicle.push({
        //                             id: column.id,
        //                             name: column.name
        //                         });
        //                 });
        //             }
        //             // console.log('vehicle', vm.vehicle)
        //             // console.log('data', payload.title.data.result)
        //         },
        //         function (errorPayload) {
        //             $log.log(errorPayload);
        //             //vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // };
        // getAllVehicles(0, 0, 2);
        //======================delete car hit===========================
        function deleteVehicleModel(data, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('deleteModel', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                var dataSend = {
                    access_token: $cookies.get('obj'),
                    model_id: Number(data.model_id),
                    is_deleted : 1
                };
                //errorMessageFactory.showErrorMessage('Functionality is pending.',0);
                vm.loading = true;
                var promise = getCars.editCarModelList(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        if(payload.title.status == 200){
                            $mdDialog.hide();
                            $state.reload();
                        }else{
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        };

        function blockModel($event,data){
            var msg;
            var block = 0;
            if(data.is_blocked == 1){
                msg = languageBasedErrorFactory.getProperErrorMessage('activeModel', 0, '3');
                block = 0 ;
            }else{
                msg = languageBasedErrorFactory.getProperErrorMessage('InactiveModel', 0, '3');
                block = 1;
            }
            var confirm = $mdDialog.confirm()
                .title(msg)
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                var dataSend = {
                    access_token: $cookies.get('obj'),
                    model_id: Number(data.model_id),
                    is_active : Number(block),
                };
                //errorMessageFactory.showErrorMessage('Functionality is pending.',0);
                vm.loading = true;
                var promise = getCars.editCarModelList(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        if(payload.title.status == 200){
                            $mdDialog.hide();
                            $state.reload();
                        }else{
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        }
        function openPopForAdd($event, key, data) {
            //  key is 1 for add and 2 is for edit  and 3 veiw 
            vm.items = {
                key: key,
                data: data
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/addModelVechicles.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });

            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                if (key == 2 || key == 3) {
                    $scope.items.name = data.name;
                }
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    if (key == 1) {
                        $log.log('confirmed');
                        var dataSend = {
                            access_token: $cookies.get('obj'),
                            name: ($scope.items.name)
                        };
                        //errorMessageFactory.showErrorMessage('Functionality is pending.',0);
                        vm.loading = true;
                        var promise = getCars.addCarModelList(dataSend);
                        promise.then(
                            function (payload) {
                                vm.loading = false;
                                if(payload.title.status == 200){
                                    $mdDialog.hide();
                                    $state.reload();
                                }else{
                                    errorMessageFactory.showErrorMessage(payload.title.message, 0);
                                }
                            },
                            function (errorPayload) {
                                $log.log(errorPayload);
                                vm.loading = false;
                                if (errorPayload.data.status == 401) {
                                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                                } else {
                                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                                }
                            }
                        );
                    } else {
                        var dataSend = {
                            access_token: $cookies.get('obj'),
                            name: ($scope.items.name),
                            model_id : data.model_id
                        };
                        //errorMessageFactory.showErrorMessage('Functionality is pending.',0);
                        vm.loading = true;
                        var promise = getCars.editCarModelList(dataSend);
                        promise.then(
                            function (payload) {
                                vm.loading = false;
                                if(payload.title.status == 200){
                                    $mdDialog.hide();
                                    $state.reload();
                                }else{
                                    errorMessageFactory.showErrorMessage(payload.title.message, 0);
                                }
                            },
                            function (errorPayload) {
                                $log.log(errorPayload);
                                vm.loading = false;
                                if (errorPayload.data.status == 401) {
                                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                                } else {
                                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                                }
                            }
                        );
                    }
                };
            }
        }
    }
})();
/**
 * Created by cl-macmini-51 on 5/3/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('CarsColorController', CarsColorController);

    /** @ngInject */
    function CarsColorController($cookies, $state, $log, $rootScope, $timeout, getCars, $scope, filterFilter, $mdDialog, $document, getVehicles, getGeofence, languageBasedErrorFactory, errorMessageFactory, pendingRequests, moment, getFilters) {
        var vm = this;
        vm.getAllColorCars = getAllColorCars;
        vm.blockModel = blockModel;
        $scope.carId = true;
        $log.log('driver');
        vm.loading = false;
        vm.currentPage = 0;
        vm.totalCars = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.searchModel = {
            limit: 100,
            limitOptions: [100, 200 , 300 ,400 , 500]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
        vm.filterTextTimeout = '';
        vm.filterOn = false;
        vm.getPagesCount = getPagesCount;
        vm.init = init;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.deleteVehicleColor = deleteVehicleColor;
        vm.refreshData = refreshData;
        vm.paginationNew = paginationNew;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.predicate = 'index';
        vm.reverse = false;
        vm.filterData = {
            carStatus: '1',
            branch: 'all',
            search_filter: 0,
            search_value: ''
        };
        vm.openPopForAdd = openPopForAdd;




        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllColorCars(vm.filterData, 0, vm.itemsPerPageGot);
        };

        function paginationNew(page) {
            getAllColorCars(vm.filterData, (page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot);
        }

        //==================refreshData=====================
        function refreshData() {
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllColorCars(vm.filterData, vm.currentPage * vm.itemsPerPageGot, vm.itemsPerPageGot);
        }

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.carMain.carsList');
            }
        });
        //==================get all drivers=======================
        function getAllColorCars(filter, skip, limit) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit;
            dataSend.offset = skip;
            dataSend.is_active = Number(filter.carStatus);
            // dataSend.search_filter = filter.search_filter;
            if (filter.search_filter == 1) {
                dataSend.search_value = filter.search_value;
            }
            // vm.loading = true;
            var promise = getCars.carcolorList(dataSend);
            promise.then(
                function (payload) {
                    if (payload.title.status == 200) {
                        $log.log('sxdsads', payload);
                        // vm.loading = false;
                        vm.totalCars = payload.title.data.count[0].count;
                        vm.dataLength = payload.title.data.count[0].count;
                        if (payload.title.data.count[0].count == 0) {
                            vm.sp_pagination = false;
                            vm.tBodyFlag = false;
                            vm.tFootFlag = true;
                            vm.filterOn = true;
                            vm.skipValueFilter = 0;
                        } else {
                            vm.sp_pagination = true;
                            vm.tBodyFlag = true;
                            vm.tFootFlag = false;
                            vm.filterOn = false;
                            vm.skipValueFilter = 0;
                            var dataArray = [];
                            var carsModelsList = payload.title.data.result;
                            carsModelsList.forEach(function (column) {
                                var d = {};
                                d.color_id = column.color_id;
                                d.code = column.code;
                                d.name = column.name;
                                d.is_blocked = column.status;
                                dataArray.push(d);
                            });
                            vm.carsModelList = dataArray;
                            for (var i = 0; i < vm.carsModelList.length; i++) {
                                vm.carsModelList[i].index = (skip + i);
                            }
                            if (vm.dataLength <= vm.itemsPerPageGot) {
                                vm.sp_pagination = false;
                            } else {
                                vm.sp_pagination = true;
                                //vm.pageCount(payload.title.totalCount);
                            }
                            vm.skipValue = vm.carsModelList[0].index;
                            vm.limitValue = vm.carsModelList[vm.carsModelList.length - 1].index;
                            console.log(vm.skipValue, 'limitValue', vm.limitValue, vm.sp_pagination, vm.itemsPerPageGot);

                        }
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }

                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };

        function init() {
            vm.getAllColorCars(vm.filterData, 0, vm.searchModel.limit);
        };
        init();

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            //vm.filterOn = true;
            vm.currentPage = 0;
            vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
            vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
            pendingRequests.cancelAll();
            if (vm.search.length == 0) {
                vm.filterData.search_filter = 0;
                vm.filterData.search_value = '';
                vm.getAllColorCars(vm.filterData, 0, vm.searchModel.limit);

            } else {
                vm.filterData.search_filter = 1;
                vm.filterData.search_value = vm.search;
                //if (vm.filterTextTimeout) $timeout.cancel(vm.filterTextTimeout);
                //vm.filterTextTimeout = $timeout(function(){
                vm.getAllColorCars(vm.filterData, 0, vm.searchModel.limit);
                //},500)
            }
        };

        // //======================get all vehicles==============
        // function getAllVehicles(skip, limt, filter) {

        //     vm.loading = true;
        //     var promise = getVehicles.allVehicles(skip, limt, filter);
        //     promise.then(
        //         function (payload) {
        //             $log.log('sxdsads', payload);
        //             //vm.loading = false;
        //             console.log(payload,"payload");

        //             if (payload.title.status == 400) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //             } else if (payload.title.status == 401) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //             } else if (payload.title.status == 201 || payload.title.status == 200) {
        //                 vm.vehicle = [];
        //                 angular.forEach(payload.title.data.result, function (column) {
        //                     if (column.status == 1)
        //                         vm.vehicle.push({
        //                             id: column.id,
        //                             name: column.name
        //                         });
        //                 });
        //             }
        //             // console.log('vehicle', vm.vehicle)
        //             // console.log('data', payload.title.data.result)
        //         },
        //         function (errorPayload) {
        //             $log.log(errorPayload);
        //             //vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // };
        // getAllVehicles(0, 0, 2);
        //======================delete car hit===========================
        function deleteVehicleColor(data, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('deleteColor', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                var dataSend = {
                    access_token: $cookies.get('obj'),
                    color_id: Number(data.color_id),
                    is_deleted : 1
                };
                //errorMessageFactory.showErrorMessage('Functionality is pending.',0);
                vm.loading = true;
                var promise = getCars.editCarColorList(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        if(payload.title.status == 200){
                            $mdDialog.hide();
                            $state.reload();
                        }else{
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        };

        function blockModel($event,data){
            var msg;
            var block = 0;
            if(data.is_blocked == 1){
                msg = languageBasedErrorFactory.getProperErrorMessage('activeColor', 0, '3');
                block = 0 ;
            }else{
                msg = languageBasedErrorFactory.getProperErrorMessage('InactiveColor', 0, '3');
                block = 1;
            }
            var confirm = $mdDialog.confirm()
                .title(msg)
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                var dataSend = {
                    access_token: $cookies.get('obj'),
                    color_id: Number(data.color_id),
                    is_active : Number(block),
                };
                //errorMessageFactory.showErrorMessage('Functionality is pending.',0);
                vm.loading = true;
                var promise = getCars.editCarColorList(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        if(payload.title.status == 200){
                            $mdDialog.hide();
                            $state.reload();
                        }else{
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        }
        function openPopForAdd($event, key, data) {
            //  key is 1 for add and 2 is for edit  and 3 veiw 
            vm.items = {
                key: key,
                data: data
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/addcolorVechicles.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });

            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.hexaError = false;
                if (key == 2 || key == 3) {
                    $scope.items.name = data.name;
                    $scope.items.HexaCode = data.code;
                }
                $scope.hexaEnter = function(){
                    if($scope.items.HexaCode){
                        if($scope.items.HexaCode.charAt(0) != '#'){
                            $scope.hexaError = true;
                        }else{
                            $scope.hexaError = false;
                        }
                    }else{
                        $scope.hexaError = false;
                    }
                }
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    if($scope.hexaError == true){
                        return true;
                    }
                    if (key == 1) {
                        $log.log('confirmed');
                        var dataSend = {
                            access_token: $cookies.get('obj'),
                            name: ($scope.items.name),
                            code: $scope.items.HexaCode
                        };
                        //errorMessageFactory.showErrorMessage('Functionality is pending.',0);
                        vm.loading = true;
                        var promise = getCars.addCarColorList(dataSend);
                        promise.then(
                            function (payload) {
                                vm.loading = false;
                                if(payload.title.status == 200){
                                    $mdDialog.hide();
                                    $state.reload();
                                }else{
                                    errorMessageFactory.showErrorMessage(payload.title.message, 0);
                                }
                            },
                            function (errorPayload) {
                                $log.log(errorPayload);
                                vm.loading = false;
                                if (errorPayload.data.status == 401) {
                                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                                } else {
                                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                                }
                            }
                        );
                    } else {
                        var dataSend = {
                            access_token: $cookies.get('obj'),
                            name: ($scope.items.name),
                            color_id : data.color_id,
                            code: $scope.items.HexaCode
                        };
                        //errorMessageFactory.showErrorMessage('Functionality is pending.',0);
                        vm.loading = true;
                        var promise = getCars.editCarColorList(dataSend);
                        promise.then(
                            function (payload) {
                                vm.loading = false;
                                if(payload.title.status == 200){
                                    $mdDialog.hide();
                                    $state.reload();
                                }else{
                                    errorMessageFactory.showErrorMessage(payload.title.message, 0);
                                }
                            },
                            function (errorPayload) {
                                $log.log(errorPayload);
                                vm.loading = false;
                                if (errorPayload.data.status == 401) {
                                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                                } else {
                                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                                }
                            }
                        );
                    }
                };
            }
        }
    }
})();
/**
 * Created by cl-macmini-51 on 5/18/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .controller('AssignDriverToCarController', AssignDriverToCarController);

    /** @ngInject */
    function AssignDriverToCarController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document, moment, getCars, getDrivers, getVehicles,$scope,languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.tFootFlag = false;
        vm.goBack = goBack;
        vm.selectDriver = selectDriver;
        vm.getAllDrivers = getAllDrivers;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.carType = $stateParams.carType;
        vm.carNumber= $stateParams.carNumber;
        vm.carId= $stateParams.id;
        $log.log('Car_id', $stateParams);

        //====================event for getting refreshed================
        $scope.$on('StateReload', function(evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.carMain.assignDriver');
            }
        });

        //=================go back================
        function goBack() {
            $state.go('layout.carMain.carsList');
        };
        //=================get all drivers======================
        function getAllDrivers() {
            vm.loading = true;
            var promise = getDrivers.allDriversWithoutLimit();
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    vm.allDrivers = payload.title.data.driver_data;
                    if(!vm.allDrivers.length){
                        vm.tFootFlag = true;
                    }
                    else{
                        vm.tFootFlag = false;
                        for(var i=0;i<vm.allDrivers.length;i++){
                            vm.allDrivers[i].checked = false;
                        }
                    }
                },
                function(errorPayload) {
                    $log.log(errorPayload,'error');
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        }
        getAllDrivers();

        //================select driver from list=======================
        function selectDriver(data,$event) {
            $log.log(data);
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('carAssignedMsg',0,'3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton',0,'3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton',0,'3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                $log.log(data);

                var dataSend = {};
                dataSend.fleet_id = [];
                for(var i=0;i<data.length;i++){
                    if(data[i].checked){
                        dataSend.fleet_id.push(data[i].fleet_id);
                    }
                }
                dataSend.access_token = $cookies.get('obj');
                dataSend.car_id = $stateParams.id;
                dataSend.car_number = $stateParams.carNumber;
                dataSend.car_type = $stateParams.carType;
                $log.log(dataSend);
                vm.loading = true;
                var promise = getCars.assignCarToDriver(dataSend);
                promise.then(
                    function(payload) {
                        $log.log(payload);
                        vm.loading = false;
                        if(payload.title.status == 400){
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                        else if(payload.title.status == 401){
                            errorMessageFactory.showErrorMessage(payload.title.message,2,'home');
                        }
                        else if(payload.title.status == 201 || payload.title.status == 200) {
                            var dataForSysLogs = {
                                access_token: $cookies.get('obj'),
                                id: $stateParams.id,
                                identity: 2,  // 0- driver, 1- customer , 2 -car
                                message: 'Car assigned to driver.'
                            };
                            $rootScope.systemLogsAdmin(dataForSysLogs);
                            languageBasedErrorFactory.getProperErrorMessage('carAssignedSucc', 0, 2, 'layout.carMain.carsList');
                        }
                        //errorMessageFactory.showErrorMessage('Driver/s assigned successfully.',2,'layout.carMain.carsList');
                        //$timeout(function(){
                        //    $mdDialog.hide();
                        //    //$state.reload();
                        //$state.go('layout.assignedCarsMain.assignedCarList');
                        //},2000);
                    },
                    function(errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if(errorPayload.data.status == 401){
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                        }
                        else{
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        };
        //======================get all vehicles==============
        function getAllVehicles(skip, limt,filter) {
            vm.loading = true;
            var promise = getVehicles.allVehicles(skip, limt,filter);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    //vm.loading = false;
                    if(payload.title.status == 400){
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    else if(payload.title.status == 401){
                        errorMessageFactory.showErrorMessage(payload.title.message,2,'home');
                    }
                    else if(payload.title.status == 201 || payload.title.status == 200) {
                        vm.vehicle = [];
                        angular.forEach(payload.title.data.result, function (column) {
                            vm.vehicle.push({id: column.id, name: column.name});
                        });

                        for (var i = 0; i < vm.vehicle.length; i++) {
                            if ($stateParams.carType == vm.vehicle[i].id) {
                                vm.carNameGot = vm.vehicle[i].name;
                            }
                        }
                    }
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllVehicles(0, 0, 2);
    }
})();
/**
 * Created by cl-macmini-51 on 7/11/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('ViewCancelReasonController', ViewCancelReasonController);

    /** @ngInject */
    function ViewCancelReasonController($cookies, $state, $log, $rootScope, $timeout, getCars, $scope, filterFilter, $mdDialog,$document, getCancelReason,$stateParams,languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.getCancelReasonHit = getCancelReasonHit;
        vm.goBack = goBack;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.cancelReasonMain.viewCancelReason');
            }
        });
        //=====================add new reason hit=========================
        function getCancelReasonHit(filter){
            vm.loading = true;
            var dataSend = {};
            dataSend.key = 0;
            var promise = getCancelReason.getCancelReasonList(dataSend);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    vm.cancelReasonDetail = _.where(payload.title.data,{reason_id:Number($stateParams.id)})[0];
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        getCancelReasonHit(1);

        //=================go back================
        function goBack() {
            $state.go('layout.cancelReasonMain.cancelReason');
        };
    }
})();

/**
 * Created by cl-macmini-51 on 6/7/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('CancelReasonController', CancelReasonController);

    /** @ngInject */
    function CancelReasonController($cookies, $state, $log, $rootScope, $timeout, getCars, $scope, filterFilter, $mdDialog, $document, getCancelReason, languageBasedErrorFactory, errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.totalReasons = 0;
        vm.noDataFlag = false;
        vm.predicate = 'index';
        vm.reverse = false;
        vm.addNewReason = addNewReason;
        vm.sort = sort;
        vm.getCancelReasonHit = getCancelReasonHit;
        vm.changeReasonStatus = changeReasonStatus;
        vm.editReasonPop = editReasonPop;
        vm.deleteReason = deleteReason;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.filterData = {
            cancelStatus: '0'
        };
        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.cancelReasonMain.cancelReason');
            }
        });

        //=================sort======================
        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };
        //=====================add new reason hit=========================
        function getCancelReasonHit(filter) {
            vm.loading = true;
            var dataSend = {};
            dataSend.key =  vm.filterData.cancelStatus; // chaman added this on 03-10
            var promise = getCancelReason.getCancelReasonList(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (typeof (payload.title.data == 'Array') && payload.title.data.length) {
                        vm.totalReasons = payload.title.data.length;
                        vm.noDataFlag = false;
                        var dataArray = [];
                        var cancelReasonList = payload.title.data;
                        cancelReasonList.forEach(function (column) {
                            var d = {};
                            d.reason_id = column.reason_id;
                            d.reason = column.reason;
                            d.reason_name_english = column.reason_name_english;
                            d.description = column.description;
                            d.status = column.status;
                            // ticket Tv-1931 handle toggle buttons

                            d.is_visible_on_app = column.is_visible_on_app;
                            d.is_visible_on_panel = column.is_visible_on_panel;
                            d.is_visible_on_web = column.is_visible_on_web;
                            d.is_visible_on_pos = column.is_visible_on_pos;

                            dataArray.push(d);
                        });
                        console.log('>>>>>>>>> IN  >>>>>>>>', dataArray);
                        vm.cancelReasonList = dataArray;

                        for (var i = 0; i < vm.cancelReasonList.length; i++) {
                            vm.cancelReasonList[i].index = i;
                        }
                    }
                    else {
                        vm.totalReasons = 0;
                        vm.noDataFlag = true;
                        vm.cancelReasonList = [];
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    }
                    else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getCancelReasonHit(vm.filterData.cancelStatus);

        //===========================change price list status=========================
        function changeReasonStatus(id, value, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('statusReasonPop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                var a = '';
                var msgSys = '';
                if (value == 0) {
                    a = 1;
                    msgSys = 'Reason unblocked';
                } else if (value == 1) {
                    a = 0;
                    msgSys = 'Reason blocked';
                }
                //errorMessageFactory.showErrorMessage('Functionality is pending.',0);
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');

                dataSend.status = a;
                dataSend.reason_id = id;
                vm.loading = true;
                var promise = getCancelReason.editCancelReason(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        var dataForSysLogs = {
                            access_token: $cookies.get('obj'),
                            id: id,
                            identity: 3,  // 0- driver, 1- customer , 2 -car,3-cancel reason
                            message: msgSys
                        };
                        $rootScope.systemLogsAdmin(dataForSysLogs);
                        languageBasedErrorFactory.getProperErrorMessage('statusReasonSucc', 0, 1, 'layout.cancelReasonMain.cancelReason')
                        //errorMessageFactory.showErrorMessage('Reason status updated successfully.',1);
                        //$timeout(function() {
                        //    $mdDialog.hide();
                        //    $state.reload();
                        //}, 2000);
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        }
                        else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );

            }, function () {
                $log.log('not confirmed');
            });
        };

        //=====================add new reason hit=========================
        function addNewReasonHit(data) {
            var dataSend = {};
            dataSend.cancel_reason = [];
            dataSend.access_token = $cookies.get('obj');
            dataSend.cancel_reason.push(data);
            vm.loading = true;
            var promise = getCancelReason.addCancelReason(dataSend);
            promise.then(
                function (payload) {

                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        languageBasedErrorFactory.getProperErrorMessage('addReasonSucc', 0, 1, 'layout.cancelReasonMain.cancelReason')
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    }
                    else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        //========================add new reason pop==========================
        function addNewReason($event) {
            vm.items = {
                reason: '',
                description: '',
                reason_name_english : '',
                // ticket Tv-1931 handle toggle buttons
                is_visible_on_app: 0,
                is_visible_on_panel: 0,
                is_visible_on_web: 0,
                is_visible_on_pos: 0
            }
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/addCancelReason.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });
            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.app = false;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                // ticket Tv-1931 handle toggle buttons
                $scope.changeToggle = function (toggle) {
                    switch (toggle) {
                        case 'app':
                            $scope.app = !$scope.app;
                            vm.items.is_visible_on_app = +(!vm.items.is_visible_on_app);
                            break;
                        case 'panel':
                            $scope.panel = !$scope.panel;
                            vm.items.is_visible_on_panel = +(!vm.items.is_visible_on_panel);
                            break;
                        case 'pos':
                            $scope.pos = !$scope.pos;
                            vm.items.is_visible_on_pos = +(!vm.items.is_visible_on_pos);
                            break;
                        case 'web':
                            $scope.web = !$scope.web;
                            vm.items.is_visible_on_web = +(!vm.items.is_visible_on_web);
                            break;
                    }
                }
                $scope.confirmUpload = function () {
                    $mdDialog.hide();
                    addNewReasonHit($scope.items);
                };
            }
        };

        //===================edit reason hit======================
        function editReasonHit(data) {
            var dataSend = {};
            dataSend = data;
            dataSend.access_token = $cookies.get('obj');

            vm.loading = true;
            var promise = getCancelReason.editCancelReason(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    var dataForSysLogs = {
                        access_token: $cookies.get('obj'),
                        id: data.reason_id,
                        identity: 3,  // 0- driver, 1- customer , 2 -car,3-cancel reason
                        message: 'Reason updated.'
                    };
                    $rootScope.systemLogsAdmin(dataForSysLogs);
                    languageBasedErrorFactory.getProperErrorMessage('editReasonSucc', 0, 1, 'layout.cancelReasonMain.cancelReason')
                    //errorMessageFactory.showErrorMessage('Reason updated successfully.',1);
                    //$timeout(function() {
                    //    $mdDialog.hide();
                    //    $state.reload();
                    //}, 2000);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    }
                    else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //===============edit reason pop=====================
        function editReasonPop(data, $event) {
            console.log('>>>>>>>>>> IN  >>>>>>>', data);
            vm.items = {
                reason: data.reason,
                reason_name_english : data.reason_name_english,
                description: data.description,
                reason_id: data.reason_id,
                // ticket Tv-1931 toggle buttons
                is_visible_on_app: data.is_visible_on_app,
                is_visible_on_panel: data.is_visible_on_panel,
                is_visible_on_web: data.is_visible_on_web,
                is_visible_on_pos: data.is_visible_on_pos
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/editCancelReason.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });
            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                // ticket Tv-1931 handle toggle buttons
                $scope.changeToggle = function (toggle) {
                    switch (toggle) {
                        case 'app':
                            $scope.app = !$scope.app;
                            vm.items.is_visible_on_app = !vm.items.is_visible_on_app;
                            break;
                        case 'panel':
                            $scope.panel = !$scope.panel;
                            vm.items.is_visible_on_panel = !vm.items.is_visible_on_panel;
                            break;
                        case 'pos':
                            $scope.pos = !$scope.pos;
                            vm.items.is_visible_on_pos = !vm.items.is_visible_on_pos;
                            break;
                        case 'web':
                            $scope.web = !$scope.web;
                            vm.items.is_visible_on_web = !vm.items.is_visible_on_web;
                            break;
                    }
                }
                $scope.confirmUpload = function () {
                    $mdDialog.hide();
                    // ticket Tv-1931 handle toggle buttons
                    vm.items.is_visible_on_app ? vm.items.is_visible_on_app = 1 :vm.items.is_visible_on_app = 0;
                    vm.items.is_visible_on_panel ? vm.items.is_visible_on_panel = 1 :vm.items.is_visible_on_panel = 0;
                    vm.items.is_visible_on_pos ? vm.items.is_visible_on_pos = 1 :vm.items.is_visible_on_pos = 0;
                    vm.items.is_visible_on_web ? vm.items.is_visible_on_web = 1 :vm.items.is_visible_on_web = 0;
                    editReasonHit($scope.items);
                };
            }
        };
        //======================delete reason hit===========================
        function deleteReason(data, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('deleteReasonPop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                var dataSend = {
                    access_token: $cookies.get('obj'),
                    reason_id: data.reason_id
                };
                //errorMessageFactory.showErrorMessage('Functionality is pending.',0);
                vm.loading = true;
                var promise = getCancelReason.deleteCancelReason(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        //errorMessageFactory.showErrorMessage('Reason deleted successfully.',1);
                        languageBasedErrorFactory.getProperErrorMessage('deleteReasonSucc', 0, 1, 'layout.cancelReasonMain.cancelReason')
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        }
                        else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        }
    }
})();

/**
 * Created by cl-macmini-51 on 5/2/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('UpcomingBookingsController', UpcomingBookingsController);

    /** @ngInject */
    function UpcomingBookingsController($cookies, $state, $log, $filter, $rootScope, $mdDialog, $timeout, $document, $scope, filterFilter, getBookings, getGeofence, getAgreement, getServices, getVehicles, getNoShowReason, errorMessageFactory, languageBasedErrorFactory, moment, adminAccessService, pendingRequests, getCancelReason, checkDomain, getFilters) {
        var vm = this;
        $log.log('upcomingBookings');
        vm.loading = false;
        vm.currentPage = 0;
        vm.applyFilter = applyFilter;
        vm.AssignButtonRole = false;
        vm.openHit = false;
        vm.unAssignButtonRole = false;
        vm.shiftIdStatus = $cookies.get('saleShiftId');
        vm.agreementIds = [];
        vm.totalUpcomingBookings = 0;
        vm.cancelarAsignacion = cancelarAsignacion;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.datePickerE_3 = datePickerE_3;
        vm.pickupFromToTimeChanged = pickupFromToTimeChanged;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.filterTextTimeout = '';
        vm.getAllUpcomingBookings = getAllUpcomingBookings;
        vm.changeDateIntoSpanish = changeDateIntoSpanish;
        vm.getPagesCount = getPagesCount;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.searchBookingField = true;
        var domain = checkDomain.getDomainName();
        if (domain != 'dev' && domain != 'test') {
            vm.searchBookingField = false;
        }
        vm.init = init;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.getFilterForAgreement = getFilterForAgreement;
        vm.getFilterForSearchByNameFilter = getFilterForSearchByNameFilter;
        vm.searchByNameRadioButtonChange = searchByNameRadioButtonChange;

        vm.bookingStatusChange = bookingStatusChange;

        vm.manualAssignBooking = manualAssignBooking;
        vm.makeBookingStatusChange = makeBookingStatusChange;
        vm.markNoShow = markNoShow;
        vm.datePickerE_1 = datePickerE_1;
        vm.branchChanged = branchChanged;
        vm.agreementChanged = agreementChanged;
        vm.serviceChanged = serviceChanged;
        vm.vehicleChanged = vehicleChanged;
        //vm.pickupTimeChanged = pickupTimeChanged;
        //vm.pickupDateChanged = pickupDateChanged;
        vm.resetFilter = resetFilter;
        vm.getFilterBookingId = getFilterBookingId;
        vm.modifyBooking = modifyBooking;
        vm.manualUnassignBooking = manualUnassignBooking;
        vm.typeTripChanged = typeTripChanged;
        vm.printReceiptApi = printReceiptApi;
        vm.slideData = slideData;
        vm.paginationNew = paginationNew;
        vm.bookingDetails = bookingDetails;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings(runThis);
        vm.countToSocket = 0;
        // vm.dateOptions = {};
        vm.datePicker_1 = {
            pickupDate: false
        };

        vm.stateOfBookingArray = [{
                name: 'Todos',
                id: -1
            },
            {
                name: 'Asignada', //Rename of upcoming status
                id: 0
            },
            {
                name: 'No Asignada',
                id: 6
            },
            {
                name: 'Aceptada',
                id: 7
            },
            {
                name: 'Cancelar Asignación',
                id: 17
            }
        ]

        // ********** INSERT INTO ARRAY AT PARTICULAR POSITION **********
        Array.prototype.insert = function (index, item) {
            this.splice(index, 0, item);
        };

        vm.altInputFormats = ['M!/d!/yyyy'];
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.predicate = null;
        vm.reverse = null;
        vm.hstep = 1;
        vm.mstep = 15;
        vm.ismeridian = true;
        vm.searchModel = {
            limit: 25,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.upcomingBookingList = [];


        vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
        vm.filterData = {
            branch_filter: 0, //0, 1
            service_filter: 0, //0, 1
            vehicle_filter: 0, //0, 1
            aggrement_filter: 0, //0, 1
            //date_time_filter : 1,  //0, 1
            branch: 'all',
            service: 'all',
            vehicle: 'all',
            //date_time_value: '',
            agreement: 'all',
            // type_of_trip: 'all',
            type_of_trip_filter: 0,
            //filter_pickup_date_value: getNextDate(),
            //filter_pickup_time_value: showFilterTime(),
            limit: vm.itemsPerPageGot,
            offset: 0,
            booking_status: 0,
            search_filter: 0,
            search_value: '',
            searchBookingId: '',
            searchPackageId: '',
            agreementSearch: '',
            agreementValue: 0,
            searchByName: 0,
            search: '',
            bookingStateFilter: 0,
            bookingStateValue: -1,
            itemsPerPageSelected: 25,
            filter_pickup_from_date_value: getFirstDateOfPreviousMonth(),
            filter_pickup_to_date_value: setToPickupDate(),
            filter_pickup_from_time_value: showFilterTime(1),
            filter_pickup_to_time_value: showFilterTime(2),
        };

        vm.paginationChangedForService = paginationChangedForService;
        vm.paginationChangedForVehicle = paginationChangedForVehicle;
        vm.paginationChangedForBranch = paginationChangedForBranch;
        vm.paginationChangedForAgreement = paginationChangedForAgreement;
        vm.vehicleSearch = vehicleSearch;
        vm.serviceSearch = serviceSearch;
        vm.branchSearch = branchSearch;
        vm.agreementSearch = agreementSearch;
        vm.globalLimit = 1000;
        vm.globalOffset = vm.globalLimit;

        vm.service = [];
        vm.service.push({
            id: 'all',
            name: 'Todos'
        })

        vm.vehicle = [];
        vm.vehicle.push({
            id: 'all',
            name: 'Todos'
        });

        vm.branchList = [];
        vm.branchList.push({
            region_name: 'Todos',
            region_id: 'all'
        });

        vm.agreement = [];
        vm.agreement.push({
            id: 'all',
            name: 'Todos'
        });

        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'vehicle', 'service', 'agreement', 'corporatesList', 'operation_point'];

        vm.serviceOffset = 0;
        vm.branchOffset = 0;
        vm.vehicleOffset = 0;
        vm.agreementOffset = 0;

        setTimeout(function () {
            document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                // if (vm.branchList && (vm.branchList.length == 0)) {
                vm.searchBranchData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });


            document.getElementsByClassName('ui-select-search')[1].addEventListener('blur', function ($event) {
                // if (vm.agreement && (vm.agreement.length == 0)) {
                vm.searchAgreementData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

            document.getElementsByClassName('ui-select-search')[2].addEventListener('blur', function ($event) {
                // if (vm.service && (vm.service.length == 0)) {
                vm.searchServiceData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

            document.getElementsByClassName('ui-select-search')[3].addEventListener('blur', function ($event) {
                // if (vm.vehicle && (vm.vehicle.length == 0)) {
                vm.searchVehicleData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

        })
        // =================== FILTER OBJECT ===================
        vm.filterObject = {
            access_token: $cookies.get('obj'),
            branch_filter: 1,
            vehicle_filter: 1,
            service_filter: 1,
            agreement_filter: 1,
            corporate_filter: 0,
            service_category: 0,
            corporate_status: 0,
            agreement_status: 2,
            vehicle__status: 2,
            operation_point_filter: 0,
            service_limit: vm.globalLimit,
            service_offset: vm.serviceOffset,
            branch_limit: vm.globalLimit,
            branch_offset: vm.branchOffset,
            vehicle_limit: vm.globalLimit,
            vehicle_offset: vm.vehicleOffset,
            agreement_limit: vm.globalLimit,
            agreement_offset: vm.agreementOffset,
            branch_search_filter: 0,
            vehicle_search_filter: 0,
            service_search_filter: 0,
            agreement_search_filter: 0,
            corporate_search_filter: 0,
            operation_point_search_filter: 0
        }

        // =================== GET FILTER DATA ===================
        function getFilterDataFromBackend(data, type) { //Acc to Index ['branch_search', 'vehicle_search', 'service_search', 'agreement_search', 'corporate_search', 'operation_point_search']
            console.log('>>>>>> IN BACKEND', data, type);
            if (data) {
                vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
            } else {
                vm.filterObject = {
                    access_token: $cookies.get('obj'),
                    branch_filter: 1,
                    vehicle_filter: 1,
                    service_filter: 1,
                    agreement_filter: 1,
                    corporate_filter: 0,
                    service_category: 0,
                    corporate_status: 0,
                    agreement_status: 2,
                    vehicle__status: 2,
                    operation_point_filter: 0,
                    branch_search_filter: 0,
                    vehicle_search_filter: 0,
                    service_search_filter: 0,
                    agreement_search_filter: 0,
                    corporate_search_filter: 0,
                    operation_point_search_filter: 0
                }
            }

            vm.filterObject.service_limit = vm.globalLimit;
            vm.filterObject.service_offset = vm.serviceOffset;
            vm.filterObject.branch_limit = vm.globalLimit;
            vm.filterObject.branch_offset = vm.branchOffset;
            vm.filterObject.vehicle_limit = vm.globalLimit;
            vm.filterObject.vehicle_offset = vm.vehicleOffset;
            vm.filterObject.agreement_limit = vm.globalLimit;
            vm.filterObject.agreement_offset = vm.agreementOffset;

            var promise = getFilters.getAllFilterData(vm.filterObject);
            promise.then(
                function (payload) {

                    // ********** BRANCH DATA ********
                    if (payload.title.data.branches) {
                        var index = _.findIndex(vm.branchList, {
                            region_id: 'all'
                        });
                        if (index == -1)
                            vm.branchList.push({
                                region_name: 'Todos',
                                region_id: 'all'
                            });
                        angular.forEach(payload.title.data.branches.data, function (column) {
                            var branchIndex = _.findIndex(vm.branchList, {
                                region_id: column.region_id
                            });
                            if (branchIndex == -1)
                                vm.branchList.push(column)
                        });
                        vm.branchTotalBackendCount = payload.title.data.branches.totalCount;
                    }

                    // ********** VEHICLE DATA ********
                    if (payload.title.data.vehicles) {
                        var index = _.findIndex(vm.vehicle, {
                            id: 'all'
                        });
                        if (index == -1)
                            vm.vehicle.push({
                                name: 'Todos',
                                id: 'all'
                            });
                        vm.vehicleTotalBackendCount = payload.title.data.vehicles.totalCount;
                        angular.forEach(payload.title.data.vehicles.data, function (column) {
                            // vm.vehicle.push({
                            //     id: column.id,
                            //     name: column.name
                            // })
                            var vechicleIndex = _.findIndex(vm.vehicle, {
                                id: column.id
                            });
                            if (vechicleIndex == -1)
                                vm.vehicle.push({
                                    id: column.id,
                                    name: column.name
                                })
                        });
                    }

                    // *********** SERVICE DATA *********
                    if (payload.title.data.services) {
                        var index = _.findIndex(vm.service, {
                            id: 'all'
                        });
                        if (index == -1)
                            vm.service.push({
                                name: 'Todos',
                                id: 'all'
                            });
                        vm.serviceTotalBackendCount = payload.title.data.services.totalCount;
                        angular.forEach(payload.title.data.services.data, function (column) {
                            // vm.service.push({
                            //     id: column.id,
                            //     name: column.service_name
                            // });
                            var serviceIndex = _.findIndex(vm.service, {
                                id: column.id
                            });
                            if (serviceIndex == -1)
                                vm.service.push({
                                    id: column.id,
                                    name: column.service_name
                                })
                        });
                    }

                    // *********** AGREEMENT DATA *********
                    if (payload.title.data.agreements) {
                        var index = _.findIndex(vm.agreement, {
                            id: 'all'
                        });
                        if (index == -1)
                            vm.agreement.push({
                                name: 'Todos',
                                id: 'all'
                            });
                        vm.agreementTotalBackendCount = payload.title.data.agreements.totalCount;
                        angular.forEach(payload.title.data.agreements.data, function (column) {
                            // vm.agreement.push({
                            //     id: column.id,
                            //     name: column.name
                            // });
                            var agreementIndex = _.findIndex(vm.agreement, {
                                id: column.id
                            });
                            if (agreementIndex == -1)
                                vm.agreement.push({
                                    id: column.id,
                                    name: column.name
                                })
                        });
                    }


                    vm.loading = false;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        }

        getFilterDataFromBackend();
        // ************ PAGINATION ON SERIVCE **************
        function paginationChangedForService() {
            var index = _.findIndex(vm[vm.searchFilterArray[2]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.serviceTotalBackendCount > (vm.service.length - index)) {
                commonFunction(2);
                vm.serviceOffset += 10;
                getFilterDataFromBackend(vm.searchServiceData, 2);
            }
        }

        // ************ PAGINATION ON VEHICLE **************
        function paginationChangedForVehicle() {
            var index = _.findIndex(vm[vm.searchFilterArray[1]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.vehicleTotalBackendCount > (vm.vehicle.length - index)) {
                commonFunction(1);
                vm.vehicleOffset = vm.vehicleOffset + 10;
                getFilterDataFromBackend(vm.searchVehicleData, 1);
            }
        }

        // ************ PAGINATION ON BRANCH **************
        function paginationChangedForBranch() {
            var index = _.findIndex(vm[vm.searchFilterArray[0]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.branchTotalBackendCount > (vm.branchList.length - index)) {
                commonFunction(0);
                vm.branchOffset += 10;
                getFilterDataFromBackend(vm.searchBranchData, 0);
            }
        }

        // ************ PAGINATION ON AGREEMENT **************
        function paginationChangedForAgreement() {
            var index = _.findIndex(vm[vm.searchFilterArray[3]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.agreementTotalBackendCount > (vm.agreement.length - index)) {
                commonFunction(3);
                vm.agreementOffset += vm.globalOffset;
                getFilterDataFromBackend(vm.searchAgreementData, 3);
            }
        }

        // *********** COMMON FUNCTION FOR FILTER PAGINATION AND SEARCHING ***********
        function commonFunction(type, mode) {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                // vm['search' + vm.searchFilterArray[i] + 'Data'] = '';
                if (mode == 'search' || i != type) {
                    vm[vm.searchFilterArrayForClearArray[i]] = [];
                    // vm[vm.searchFilterArrayForClearArray[i]].push({
                    //     id: 'all',
                    //     name: 'Todos'
                    // });
                    vm[vm.searchFilterArray[i] + 'Offset'] = 0;
                    vm['search' + vm.searchFilterArray[i].substring(0, 1).toUpperCase() + vm.searchFilterArray[i].substring(1) + 'Data'] = '';
                }
            }
        }

        // ************ SEARCH VEHICLE ***************
        function vehicleSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchVehicleData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(1, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 1);
                }, 2000);
            }
        }

        // ************ SEARCH SERVICE ***************
        function serviceSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchServiceData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(2, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 2);
                }, 2000);
            }
        }

        // ************ SEARCH VEHICLE ***************
        function branchSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchBranchData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(0, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 0);
                }, 2000);
            }
        }

        // ************ SEARCH AGREEMENT ***************
        function agreementSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchAgreementData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(3, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 3);
                }, 2000);
            }
        }


        function getNextDate() {
            var x = new Date();
            var a = new Date().getDate() + 1;
            x.setDate(a);
            return x;


        }

        function setToPickupDate() {
            var x = new Date();
            var yesterday = new Date(x.getTime() + (24 * 60 * 60 * 1000));

            return yesterday;

        }

        function getFirstDateOfPreviousMonth() {
            var date = new Date();
            var yesterday = new Date(date.getTime() - 24 * 60 * 60 * 1000);
            return yesterday;
        }

        function showFilterTime(type) {
            if (type == 1) {
                var x = new Date();
                x.setHours('00');
                x.setMinutes('00');
                x.setSeconds('00');
                return x;
            } else {
                var x = new Date();
                x.setHours('23');
                x.setMinutes('59');
                x.setSeconds('00');
                return x;
            }

        }

        function pickupFromToTimeChanged(type) {
            // getAllUpcomingBookings(0, vm.itemsPerPageGot, vm.filterData, true);

        }

        function datePickerE_3(type) {
            if (type == 1) {
                vm.datePicker_1.pickupFromDate = true;
                vm.datePicker_1.pickupToDate = false;

            } else if (type == 2) {
                vm.datePicker_1.pickupFromDate = false;
                vm.datePicker_1.pickupToDate = true;
            }
        };

        vm.pickupFromToDateChanged = function (data) {
            vm.dateOptions = {
                //dateDisabled: disabled,
                formatYear: 'yy',
                // maxDate: new Date(),
                // minDate: new Date(vm.filterData.filter_pickup_from_date_value),
                startingDay: 1,
                showWeeks: false,

            };
            // getAllUpcomingBookings(0, vm.itemsPerPageGot, vm.filterData, true);

        }

        function runThis() {
            vm.typeTripFilter = [
                // {
                //     name: languageBasedErrorFactory.getProperErrorMessage('allLabel', 0, '3'),
                //     id: 'all'
                // },
                {
                    name: 'From Airport',
                    id: 'Z'
                },
                {
                    name: 'To Airport',
                    id: 'R'
                },
                {
                    name: 'Point to Point',
                    id: 'P'
                }
            ]
        }

        if (localStorage.getItem('upcomingFilter')) {
            vm.filterData = JSON.parse(localStorage.getItem('upcomingFilter'));
            vm.itemsPerPageSelected = vm.filterData.itemsPerPageSelected ? vm.filterData.itemsPerPageSelected : 25;
            vm.itemsPerPageGot = vm.filterData.itemsPerPageSelected ? vm.filterData.itemsPerPageSelected : 25;
            vm.filterData.itemsPerPageSelected = vm.filterData.itemsPerPageSelected ? vm.filterData.itemsPerPageSelected : 25;
            if (vm.filterData.searchBookingId || vm.filterData.searchPackageId) {
                getBookingIdResults(vm.filterData);
            } else {
                init();
            }
        } else {
            init();
        }

        //==============booking details================
        function bookingDetails(data) {
            localStorage.setItem('upcomingFilter', JSON.stringify(vm.filterData));
            $state.go('layout.upcomingBookingsMain.upcomingBookingDetailsNew', {
                id: data.job_id,
                type: '0'
            });
        }

        //$scope.$on('$destroy',function(){
        //    localStorage.removeItem('upcomingFilter');
        //})

        $scope.$watchCollection('vm.filterData', function (newValue, oldValue) {
            localStorage.setItem('upcomingFilter', JSON.stringify(newValue));
        })

        vm.filterObject = {
            contract_id: vm.filterData.agreement,
            branch_id: vm.filterData.branch,
            service_id: vm.filterData.service,
            vehicle_id: vm.filterData.vehicle,
            type_of_trip: vm.filterData.type_of_trip,
            job_status: vm.filterData.bookingStateValue,
            search_by: vm.filterData.searchByName

        };

        /////////////////////////////// check FIlter is Equal Or Not //////////////////////////
        function checkStatus(bookingArray) {
            var flagStatus = false;
            console.log('I M HERE TO CHECK THE STATUS', vm.filterData.bookingStateValue);
            var job_status_filter = vm.filterData.bookingStateValue < -2 ? 1 : 0;
            if (vm.filterData.branch_filter == 0 || vm.filterData.branch == bookingArray.branch_id) {
                console.log("branch_filter", vm.filterData.branch_filter, vm.filterData.branch, bookingArray.branch_id, job_status_filter);
                if (vm.agreementIds[0] == 0 || vm.agreementIds.includes(bookingArray.contract_id)) {
                    console.log("aggrement_filter", vm.filterData.aggrement_filter, vm.filterData.agreement, bookingArray.contract_id, job_status_filter);
                    if (vm.filterData.service_filter == 0 || vm.filterData.service == bookingArray.service_id) {
                        console.log("service_filter", vm.filterData.service_filter, vm.filterData.service, bookingArray.service_id, job_status_filter);
                        if (vm.filterData.vehicle_filter == 0 || vm.filterData.vehicle == bookingArray.vehicle_id) {
                            console.log("vehicle_filter", vm.filterData.vehicle_filter, vm.filterData.vehicle, bookingArray.vehicle_id, job_status_filter, job_status_filter);
                            if (job_status_filter == 0 || vm.filterData.bookingStateValue == bookingArray.job_status) {
                                console.log("job_status_filter", vm.filterData.job_status_filter, vm.filterData.bookingStateValue, bookingArray.job_status);
                                if (vm.filterData.type_of_trip && vm.filterData.type_of_trip.length > 0) {
                                    vm.filterData.type_of_trip.forEach(function (data) {
                                        console.log("type_of_trip", vm.filterData.type_of_trip, data, bookingArray.type_of_trip);
                                        if (vm.filterData.type_of_trip_filter == 0 || data == bookingArray.type_of_trip) {
                                            console.log("type_of_trip", vm.filterData.type_of_trip, data, bookingArray.type_of_trip);
                                            flagStatus = true;
                                        }
                                    });
                                } else {
                                    flagStatus = true;
                                }
                            }
                        }
                    }
                }
            }
            return flagStatus;
        }
        /////////////////////////////// check FIlter is Equal Or Not //////////////////////////
        // *************** SOCKET FOR UPCOMING BOOKING *************
        var myListener = $rootScope.$on('SocketComesUpcoming', function (evt, data) {
            console.log('>>>>>>>>>>>>>>>>>>> IN SocketComesUpcoming >>>>>>>>>>>>>>', data);
            $log.log(evt);
            $log.log(data);
            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            var DatetoSend = new Date(date_time_value2).getTime();
            var dateFrom = new Date(date_time_value1).getTime();
            var dateTo = DatetoSend;
            var type = typeof data.res.message;
            var deleteBookingFromArrayJobStatus = [4, 9, 12, 15];

            if (data && data.res && data.res.message && data.res.message.jobArray && data.res.message.jobArray.length > 0) {

                if (data.res.message.is_group_allowed && data.res.message.is_group_allowed == 1) {
                    console.log("Value True");

                    var index;
                    if (data && data.res && data.res.message.jobArray && data.res.message.jobArray.length > 0) {
                        var value = data.res.message;
                        data.res.message.jobArray.forEach(function (data) {
                            index = vm.upcomingBookingList.findIndex(function (x) {
                                return x.job_id == data;
                            });
                            if (index >= 0) {
                                vm.upcomingBookingList[index].dicardFlag = value.is_group_allowed == 1 ? 0 : 1;
                                // vm.upcomingBookingList[index].locking_id_name = data.locking_id_name;
                                $scope.$apply();
                                // vm.filterData.unassignedBookingList.splice(index, 1);
                                console.log(vm.upcomingBookingList, 'vm.upcomingBookingList');

                            }
                        })

                    }

                } else {
                    var bookingArray = data.res.message.jobArray;
                    console.log(bookingArray.length);

                    for (var i = 0; i < bookingArray.length; i++) {
                        var booking_date = bookingArray[i].job_time_utc;
                        // booking_date = booking_date.split('T')[0];
                        booking_date = new Date(booking_date).getTime();
                        // console.log(dateFrom <= booking_date && booking_date <= dateTo, 'dateFrom <= booking_date && booking_date <= dateTo');
                        // console.log(dateFrom, booking_date, dateTo);

                        if (dateFrom <= booking_date && booking_date <= dateTo) {
                            checkStatus(bookingArray[i]);
                            console.log(checkStatus(bookingArray[i]), 'checkStatus');

                            if (checkStatus(bookingArray[i])) {
                                if (data.data && vm.countToSocket == 0 && vm.filterData && (!vm.filterData.searchBookingId && !vm.filterData.searchPackageId)) {
                                    // console.log('>>>>>>>>>>>>>>> IN MAIN IF >>>>>>>>>>');
                                    vm.itemsPerPageGot = vm.itemsPerPageSelected;
                                    // getAllUpcomingBookings(vm.currentPage > 0 ? (vm.currentPage - 1) * vm.itemsPerPageGot : 0, vm.itemsPerPageGot, vm.filterData, false);
                                    var index = _.findIndex(vm.upcomingBookingList, {
                                        job_id: bookingArray[i].job_id
                                    });

                                    // ********** TO CHECK INDEX OF SOCKET JOB IN UPCOMING JOB LIST **********
                                    if (index > -1) {
                                        // console.log('>>>>>>> IN IF >>>>>>>>', index, bookingArray[i]);

                                        // ******** TO CHECK STATUS AND REMOVE BOOKING FROM LIST *************
                                        if (deleteBookingFromArrayJobStatus.includes(bookingArray[i].job_status) || bookingArray[i].booking_visibility_flag == 0) {
                                            //FOR booking_visibility_flag 1- visibility ON 0 - visibility OFF
                                            getAllUpcomingBookings(vm.currentPage > 0 ? (vm.currentPage - 1) * vm.itemsPerPageGot : 0, vm.itemsPerPageGot, vm.filterData, false);
                                        } else {
                                            socketDate(index, bookingArray[i]);
                                        }
                                        // socketDate(index, bookingArray[i]);
                                    } else if (index == -1) {
                                        for (var j = 0; j < vm.upcomingBookingList.length; j++) {
                                            // console.log('>>>>>>>> J >>>>>', j, '>>>>>>> vm.upcomingBookingList[j].job_time >>>', vm.upcomingBookingList[j].job_time, '>>>>>>>> bookingArray[i].job_time_utc >>>', bookingArray[i].job_time_utc)
                                            // console.log('>>>>>>>> new Date(vm.upcomingBookingList[j].job_time).getTime() > new Date(bookingArray[i].job_time_utc).getTime() >>>>>', new Date(vm.upcomingBookingList[j].job_time).getTime() > new Date(bookingArray[i].job_time_utc).getTime())
                                            if (new Date(vm.upcomingBookingList[j].job_time).getTime() > new Date(bookingArray[i].job_time_utc).getTime()) {
                                                if (bookingArray[i].urgent_booking_assignment == 1 && vm.currentPage == 0) {
                                                    addNewDataInList(0, bookingArray[i]);
                                                } else if (bookingArray[i].urgent_booking_assignment == 0) {
                                                    addNewDataInList(j, bookingArray[i]);
                                                }
                                                if (vm.upcomingBookingList.length) {
                                                    vm.sp_pagination = true;
                                                    vm.tBodyFlag = true;
                                                    vm.tFootFlag = false;
                                                    vm.filterOn = false;
                                                    vm.skipValueFilter = 0;
                                                }
                                                $scope.$apply();
                                                break;
                                            }
                                        }

                                        // ********** TO CHECK INDEX OF SOCKET JOB IN UPCOMING JOB LIST **********
                                        var index = _.findIndex(vm.upcomingBookingList, {
                                            job_id: bookingArray[i].job_id
                                        });
                                        if (index == -1) {
                                            if (bookingArray[i].urgent_booking_assignment == 1 && vm.currentPage == 0) {
                                                addNewDataInList(0, bookingArray[i]);
                                                if (vm.upcomingBookingList.length) {
                                                    vm.sp_pagination = true;
                                                    vm.tBodyFlag = true;
                                                    vm.tFootFlag = false;
                                                    vm.filterOn = false;
                                                    vm.skipValueFilter = 0;
                                                }
                                            } else if (bookingArray[i].urgent_booking_assignment == 0) {
                                                addNewDataInList(j, bookingArray[i]);

                                                // addNewDataInList(0, bookingArray[i]);

                                                if (vm.upcomingBookingList.length) {
                                                    vm.sp_pagination = true;
                                                    vm.tBodyFlag = true;
                                                    vm.tFootFlag = false;
                                                    vm.filterOn = false;
                                                    vm.skipValueFilter = 0;
                                                }

                                                $scope.$apply();
                                            }
                                        }

                                    }
                                } else if (data.data && vm.countToSocket == 0 && vm.filterData && (vm.filterData.searchBookingId || vm.filterData.searchPackageId)) {
                                    // console.log('>>>>>>>>>>>>>>> IN MAIN ELSE >>>>>>>>>>');
                                    // getBookingIdResults(vm.filterData);


                                    // ********** TO CHECK INDEX OF SOCKET JOB IN UPCOMING JOB LIST **********
                                    var index = _.findIndex(vm.upcomingBookingList, {
                                        job_id: bookingArray[i].job_id
                                    });
                                    if (index > -1) {
                                        // console.log('>>>>>>> IN INDEX >>>>>>>>', index, bookingArray[i]);

                                        // ******** TO CHECK STATUS AND REMOVE BOOKING FROM LIST *************
                                        if (deleteBookingFromArrayJobStatus.includes(bookingArray[i].job_status) || bookingArray[i].booking_visibility_flag == 0) {
                                            getBookingIdResults(vm.filterData);
                                        } else {
                                            socketDate(index, bookingArray[i]);
                                        }
                                        // socketDate(index, bookingArray[i]);
                                    }
                                }
                                break;
                            }

                        }

                    }
                }

            }
            //  else if (data && data.res && type == 'object') {
            //     var booking_date = data.res.message.job_time_utc;
            //     // booking_date = booking_date.split('T')[0];
            //     booking_date = new Date(booking_date).getTime();
            //     console.log(dateFrom <= booking_date && booking_date <= dateTo, 'dateFrom <= booking_date && booking_date <= dateTo');
            //     if (dateFrom <= booking_date && booking_date <= dateTo) {
            //         if (data.data && vm.countToSocket == 0 && (!vm.filterData.searchBookingId && !vm.filterData.searchPackageId)) {
            //             // console.log(vm.currentPage);
            //             vm.itemsPerPageGot = vm.itemsPerPageSelected;
            //             getAllUpcomingBookings(vm.currentPage > 0 ? (vm.currentPage - 1) * vm.itemsPerPageGot : 0, vm.itemsPerPageGot, vm.filterData, false);
            //         } else if (data.data && vm.countToSocket == 0 && (vm.filterData.searchBookingId || vm.filterData.searchPackageId)) {
            //             getBookingIdResults(vm.filterData);
            //         }
            //     }
            // } else {
            //     if (data.data && vm.countToSocket == 0 && (!vm.filterData.searchBookingId && !vm.filterData.searchPackageId)) {
            //         // console.log(vm.currentPage);
            //         vm.itemsPerPageGot = vm.itemsPerPageSelected;
            //         getAllUpcomingBookings(vm.currentPage > 0 ? (vm.currentPage - 1) * vm.itemsPerPageGot : 0, vm.itemsPerPageGot, vm.filterData, false);
            //     } else if (data.data && vm.countToSocket == 0 && (vm.filterData.searchBookingId || vm.filterData.searchPackageId)) {
            //         getBookingIdResults(vm.filterData);
            //     }
            // }
        });
        // ********** ADD JOB IN UPCOMING LIST FROM SOCKET ****************
        function addNewDataInList(index, data) {
            index = index || 0;
            if (data) {
                console.log(data, "socket DATA >>>>>>>>>>>>>>>>>>>>>>");

                vm.upcomingBookingList.insert(index || 0, {
                    'job_id': data.job_id,
                    'job_status': data.job_status,
                    'created_by': data.created_by,
                    'booking_for': data.booking_for,
                    'is_vip': data.is_VIP,
                    'job_pickup_name': data.job_pickup_name,
                    'job_pickup_phone': data.job_pickup_phone,
                    'job_pickup_email': data.job_pickup_email,
                    'job_pickup_address': data.job_pickup_address,
                    'job_address': data.job_address, //destination
                    'number_of_passangers': data.number_of_passangers,
                    'creation_datetime': data.creation_datetime,
                    'fleet_id': data.fleet_id,
                    'transport_details': data.transport_details, //CAR number
                    'fleet_first_name': data.fleet_first_name,
                    'fleet_last_name': data.fleet_last_name,
                    'fleet_country_code': data.fleet_country_code,
                    'fleet_phone_number': data.fleet_phone_number,
                    'customer_first_name': data.customer_first_name,
                    'customer_last_name': data.customer_last_name,
                    'customer_country_code': data.customer_country_code,
                    'customer_phone_number': data.customer_phone_number,
                    'is_round_trip': data.is_round_trip,
                    'round_trip_parent_job_id': data.round_trip_parent_job_id,
                    // 'auth_of': data.auth_of,
                    'dicardFlag': data.discard_from_group == 0 ? true : false,
                    'branch': data.branch_name,
                    'type_of_service': data.service_name,
                    'agreement': data.contract_name,
                    'unique_car_id': data.unique_car_id,
                    'estimated_payment_cost': data.estimated_payment_cost,
                    'type_of_trip': data.type_of_trip,
                    'is_POS_booking': data.is_POS_booking,
                    'shared_service_status': data.shared_service_status,
                    'flight_number': data.flight_number,
                    'is_wait_time_included': data.is_wait_time_included,
                    'job_time': data.job_time_utc,
                    'job_time_filtered': $filter('date')(data.job_time_utc, "MMM d, yyyy HH:mm'"),
                    'locking_id': data.locking_id,
                    'locking_name': data.locking_id_name,
                    'return_date_time_utc': data.return_date_time,
                    'return_date_time': data.return_date_time_utc,
                    'urgent_booking_assignment': data.urgent_booking_assignment,
                    'color': data.urgent_booking_assignment ? '#ff4d4d' : '#333',
                    'shared_service_id': data.shared_service_id,
                    'auth_required': data.auth_required,
                    'is_auth': data.is_auth,
                    'booking_type': data.booking_type,
                    'manual_rejection': data.manual_rejection
                });
                if (new Date(data.job_time_utc).getDate() == new Date().getDate() && new Date(data.job_time_utc).getMonth() == new Date().getMonth() && new Date(data.job_time_utc).getFullYear() == new Date().getFullYear()) {
                    vm.upcomingBookingList[index].dateFlagForShow = true;
                } else {
                    vm.upcomingBookingList[index].dateFlagForShow = false;
                }
                vm.dataLength += 1;
                vm.totalUpcomingBookings += 1;

                if (vm.upcomingBookingList.length > vm.itemsPerPageGot)
                    vm.upcomingBookingList.pop();
                $scope.$apply();
            }
        }

        // *************** SOCKET FOR PACKAGE CREATION *************
        var myListenerShared = $rootScope.$on('SocketComesShared', function (evt, data) {
            // console.log('>>>>>>>>>>>>>>>>>>> IN SocketComesShared socketEventPackageCreation >>>>>>>>>>>>>>', evt, data);
            $log.log(evt);
            $log.log(data);
            var deleteBookingFromArrayJobStatus = [4, 9, 12, 15];
            if (data.data && vm.countToSocket == 0 && vm.filterData && (!vm.filterData.searchBookingId && !vm.filterData.searchPackageId)) {
                vm.itemsPerPageGot = vm.itemsPerPageSelected;
                // getAllUpcomingBookings(vm.currentPage > 0 ? (vm.currentPage - 1) * vm.itemsPerPageGot : 0, vm.itemsPerPageGot, vm.filterData, false);
                if (data.res && data.res.message)
                    for (var i = 0; i < data.res.message.length; i++) {

                        // ********** TO CHECK INDEX OF SOCKET JOB IN UPCOMING JOB LIST **********
                        var index = _.findIndex(vm.upcomingBookingList, {
                            job_id: data.res.message[i].job_id
                        });
                        if (index > -1) {
                            // console.log('>>>>>>> IN IF >>>>>>>>', index, data.res.message[i]);
                            // socketDate(index, data.res.message[i]);

                            // ******** TO CHECK STATUS AND REMOVE BOOKING FROM LIST *************
                            if (deleteBookingFromArrayJobStatus.includes(data.res.message[i].job_status)) {
                                getAllUpcomingBookings(vm.currentPage > 0 ? (vm.currentPage - 1) * vm.itemsPerPageGot : 0, vm.itemsPerPageGot, vm.filterData, false);
                            } else {
                                socketDate(index, data.res.message[i]);
                            }
                        }
                    }
            } else if (data.data && vm.countToSocket == 0 && vm.filterData && (vm.filterData.searchBookingId || vm.filterData.searchPackageId)) {
                // getBookingIdResults(vm.filterData);
                if (data.res && data.res.message)
                    for (var i = 0; i < data.res.message.length; i++) {

                        // ********** TO CHECK INDEX OF SOCKET JOB IN UPCOMING JOB LIST **********
                        var index = _.findIndex(vm.upcomingBookingList, {
                            job_id: data.res.message[i].job_id
                        });
                        if (index > -1) {
                            // console.log('>>>>>>> IN ELSE >>>>>>>>', index, data.res.message[i]);
                            // socketDate(index, data.res.message[i]);

                            // ******** TO CHECK STATUS AND REMOVE BOOKING FROM LIST *************
                            if (deleteBookingFromArrayJobStatus.includes(data.res.message[i].job_status)) {
                                getBookingIdResults(vm.filterData);
                            } else {
                                socketDate(index, data.res.message[i]);
                            }
                        }
                    }
            }

        });

        // *************** SOCKET FOR PACKAGE VALIDATION *************
        var myListenerValidation = $rootScope.$on('SocketComesValidation', function (evt, data) {
            // console.log('>>>>>>>>>>>>>>>>>>> IN SocketComesValidation socketEventPackageValidation >>>>>>>>>>>>>>', evt, data);
            $log.log(evt);
            $log.log(data);
            var deleteBookingFromArrayJobStatus = [4, 9, 12, 15];

            if (data.data && vm.countToSocket == 0 && vm.filterData && (!vm.filterData.searchBookingId && !vm.filterData.searchPackageId)) {
                vm.itemsPerPageGot = vm.itemsPerPageSelected;
                // getAllUpcomingBookings(vm.currentPage > 0 ? (vm.currentPage - 1) * vm.itemsPerPageGot : 0, vm.itemsPerPageGot, vm.filterData, false);

                if (data.res && data.res.message)
                    for (var i = 0; i < data.res.message.length; i++) {

                        // ********** TO CHECK INDEX OF SOCKET JOB IN UPCOMING JOB LIST **********
                        var index = _.findIndex(vm.upcomingBookingList, {
                            job_id: data.res.message[i].job_id
                        });
                        if (index > -1) {
                            // socketDate(index, data.res.message[i]);

                            // ******** TO CHECK STATUS AND REMOVE BOOKING FROM LIST *************
                            if (deleteBookingFromArrayJobStatus.includes(data.res.message[i].job_status)) {
                                getAllUpcomingBookings(vm.currentPage > 0 ? (vm.currentPage - 1) * vm.itemsPerPageGot : 0, vm.itemsPerPageGot, vm.filterData, false);
                            } else {
                                socketDate(index, data.res.message[i]);
                            }
                        }
                    }

            } else if (data.data && vm.countToSocket == 0 && vm.filterData && (vm.filterData.searchBookingId || vm.filterData.searchPackageId)) {
                // getBookingIdResults(vm.filterData);
                if (data.res && data.res.message)
                    for (var i = 0; i < data.res.message.length; i++) {

                        // ********** TO CHECK INDEX OF SOCKET JOB IN UPCOMING JOB LIST **********
                        var index = _.findIndex(vm.upcomingBookingList, {
                            job_id: data.res.message[i].job_id
                        });
                        if (index > -1) {
                            // socketDate(index, data.res.message[i]);

                            // ******** TO CHECK STATUS AND REMOVE BOOKING FROM LIST *************
                            if (deleteBookingFromArrayJobStatus.includes(data.res.message[i].job_status)) {
                                getBookingIdResults(vm.filterData);
                            } else {
                                socketDate(index, data.res.message[i]);
                            }
                        }
                    }
            }

        });
        $scope.$on('$destroy', myListenerShared);
        $scope.$on('$destroy', myListenerValidation);
        $scope.$on('$destroy', myListener);
        //$rootScope.socket.on('socketEventToUser',function(res){
        //    showDriversWithFilterSocket(vm.dataToFill);
        //});

        function socketDate(index, data) {
            index = index || 0;
            if (data) {
                vm.upcomingBookingList[index].creation_datetime = data.creation_datetime;
                vm.upcomingBookingList[index].is_wait_time_included = data.is_wait_time_included;
                vm.upcomingBookingList[index].job_time = data.job_time_utc;
                vm.upcomingBookingList[index].job_time_filtered = $filter('date')(data.job_time_utc, "MMM d, yyyy HH:mm'"); //actual start time
                if (new Date(data.job_time_utc).getDate() == new Date().getDate() && new Date(data.job_time_utc).getMonth() == new Date().getMonth() && new Date(data.job_time_utc).getFullYear() == new Date().getFullYear()) {
                    vm.upcomingBookingList[index].dateFlagForShow = true;
                } else {
                    vm.upcomingBookingList[index].dateFlagForShow = false;
                }
                vm.upcomingBookingList[index].locking_id = data.locking_id;
                vm.upcomingBookingList[index].locking_name = data.locking_id_name;
                vm.upcomingBookingList[index].return_date_time_utc = data.return_date_time;
                vm.upcomingBookingList[index].return_date_time = data.return_date_time_utc;
                vm.upcomingBookingList[index].urgent_booking_assignment = data.urgent_booking_assignment;
                vm.upcomingBookingList[index].color = data.urgent_booking_assignment ? '#ff4d4d' : '#333';
                vm.upcomingBookingList[index].shared_service_id = data.shared_service_id;
                vm.upcomingBookingList[index].job_status = data.job_status;
                vm.upcomingBookingList[index].manual_rejection = data.manual_rejection;
                vm.upcomingBookingList[index].auth_required = data.auth_required;
                vm.upcomingBookingList[index].is_auth = data.is_auth;
                vm.upcomingBookingList[index].booking_type = data.booking_type;

                vm.upcomingBookingList[index].transport_details = data.transport_details;
                vm.upcomingBookingList[index].fleet_first_name = data.fleet_first_name;
                vm.upcomingBookingList[index].fleet_last_name = data.fleet_last_name;
                vm.upcomingBookingList[index].fleet_country_code = data.fleet_country_code;
                vm.upcomingBookingList[index].fleet_phone_number = data.fleet_phone_number;
                vm.upcomingBookingList[index].unique_car_id = data.unique_car_id;

                $scope.$apply();
            }
        }

        if ($rootScope.socket.connected == false || $rootScope.socket.connected == 'false') {
            $rootScope.socket.connect();
        }

        //====================slide data======================
        $('#derp').hide();

        function slideData() {
            // vm.agreement = [];
            // vm.branchList = [];
            // vm.vehicle = [];
            // vm.service = [];
            // getFilterDataFromBackend();
            $('#derp').slideToggle(1000);
            document.getElementById('toDate').value = moment(vm.filterData.filter_pickup_to_date_value).format('DD-MMMM-YYYY');
            document.getElementById('fromDate').value = moment(vm.filterData.filter_pickup_from_date_value).format('DD-MMMM-YYYY');
            vm.filterData.searchByName = 0;
        }

        vm.dateOptions = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            // maxDate: new Date(),
            // minDate: new Date(vm.filterData.filter_pickup_from_date_value),
            startingDay: 1,
            showWeeks: false,

        };
        // //==================date picker function==================
        // vm.dateOptions = {
        //     //dateDisabled: disabled,
        //     formatYear: 'yy',
        //     maxDate: new Date(2090, 12, 31),
        //     //minDate: new Date(),
        //     startingDay: 1,
        //     showWeeks: false
        // };

        function datePickerE_1() {
            vm.datePicker_1.pickupDate = true;
        };

        //====================function for dropdown pages and page count===============
        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            getAllUpcomingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
        };

        function paginationNew(page) {
            getAllUpcomingBookings((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData, true);
        }

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.upcomingBookingsMain.upcomingBookings');
            }
        });

        //===============================function to change date============================
        function changeDateFormat(date) {
            var data = date.split('T')[0];
            var newDate = new Date(data);
            newDate.setHours(Number(date.split('T')[1].split(':')[0]));
            newDate.setMinutes(Number(date.split('T')[1].split(':')[1]));
            newDate.setSeconds(0);
            return newDate;
        };

        //====================date time format====================
        function dateTimeFormat(dateGot, timeGot) {
            var dateToChange = new Date(dateGot);
            var timeGotChange = new Date(timeGot);
            if (timeGotChange) {
                dateToChange.setHours(timeGotChange.getHours());
                dateToChange.setMinutes(timeGotChange.getMinutes());
                dateToChange.setSeconds(timeGotChange.getSeconds());
            } else {
                dateToChange.setHours(0);
                dateToChange.setMinutes(0);
                dateToChange.setSeconds(0);
            }
            return dateToChange;

        };
        //==================get all drivers=======================
        function getAllUpcomingBookings(skip, limit, filter, loader) {
            var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            if (pickFromDate > pickToDate) {
                errorMessageFactory.showErrorMessage('Por favor, elija las fechas apropiadas de filtro.', 0);
                return;
            }
            vm.countToSocket = vm.countToSocket + 1;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit;
            dataSend.offset = skip;
            dataSend.booking_status = filter.booking_status;
            dataSend.branch_filter = filter.branch_filter;
            if (filter.branch_filter == 1 && filter.branch != 'all') {
                dataSend.branch_value = filter.branch;
            }
            dataSend.service_filter = filter.service_filter;
            if (filter.service_filter == 1 && filter.service != 'all') {
                dataSend.service_value = filter.service;
            }
            dataSend.vehicle_filter = filter.vehicle_filter;
            if (filter.vehicle_filter == 1 && filter.vehicle != 'all') {
                dataSend.vehicle_value = filter.vehicle;
            }
            dataSend.search_filter = filter.search_filter;
            if (filter.search_filter == 1) {
                dataSend.search_value = filter.search_value;
            }
            // ****** VARIABLE FOR AGREEMENT FILTERS *******
            dataSend.search_by_agreement_filter = filter.agreementValue || 0;
            if (filter.agreementValue == 1) {
                dataSend.search_agreement_value = filter.agreementSearch;
            }
            // ****** VARIABLE FOR SEARCH BY NAME FILTERS *******
            dataSend.search_user_filter = filter.searchByNameFilterValue || 0;
            if (filter.searchByNameFilterValue == 1) {
                dataSend.search_by_user_filter = filter.searchByName;
                dataSend.search_user_value = filter.searchByNameFilter;
            }
            // ******* VARIABLE FOR BOOKING STATE FILTER ********
            dataSend.job_status_filter = filter.bookingStateValue > -2 ? 1 : 0;
            if (dataSend.job_status_filter == 1) {
                dataSend.job_status_value = [];
                if (filter.bookingStateValue == -1) {
                    var dummyArray = [];
                    // ***** SELECT ALL ******
                    vm.stateOfBookingArray.forEach(function (object) {
                        if (object.id != -1)
                            dummyArray.push(object.id)
                    });
                    dataSend.job_status_value = JSON.stringify(dummyArray);
                } else {
                    dataSend.job_status_value.push(JSON.stringify(filter.bookingStateValue));
                }
            }
            //dataSend.date_time_filter = filter.date_time_filter;
            //if(filter.filter_pickup_date_value && filter.filter_pickup_time_value) {
            //    dataSend.date_time_value = dateTimeFormat(filter.filter_pickup_date_value, filter.filter_pickup_time_value);
            //}
            //else if(filter.filter_pickup_date_value && !filter.filter_pickup_time_value){
            //    dataSend.date_time_value = moment(filter.filter_pickup_date_value).format('YYYY-MM-DD');
            //}

            dataSend.aggrement_filter = filter.aggrement_filter;
            if (filter.aggrement_filter == 1 && filter.agreement != 'all') {
                dataSend.aggrement_value = filter.agreement;
            }

            // dataSend.type_of_trip_filter = filter.type_of_trip_filter;
            // if (filter.type_of_trip_filter == 1 && filter.type_of_trip != 'all') {
            var trip = [];
            trip.push(vm.filterData.type_of_trip);
            if (vm.filterData.type_of_trip && vm.filterData.type_of_trip.length > 0 && filter.type_of_trip != 'all') {
                dataSend.type_of_trip_filter = 1;
                dataSend.type_of_trip_value = trip;
            } else {
                dataSend.type_of_trip_filter = 0;
            }
            dataSend.date_time_filter = 1;
            dataSend.date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            dataSend.date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);


            // }
            vm.loading = loader;
            var promise = getBookings.allBookings(dataSend);
            promise.then(
                function (payload) {
                    if (payload.title.status == 200) {
                        $log.log('sxdsads', payload);
                        vm.countToSocket = 0;
                        vm.loading = false;
                        if (payload.title.status == 400) {

                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            vm.totalUpcomingBookings = payload.title.data.totalCount;
                            vm.dataLength = payload.title.data.totalCount;

                            if (payload.title.data.totalCount == 0) {
                                vm.sp_pagination = false;
                                vm.tBodyFlag = false;
                                vm.tFootFlag = true;
                                vm.filterOn = true;
                                vm.skipValueFilter = 0;
                                vm.upcomingBookingList = [];
                            } else {
                                vm.sp_pagination = true;
                                vm.tBodyFlag = true;
                                vm.tFootFlag = false;
                                vm.filterOn = false;
                                vm.skipValueFilter = 0;

                                var dataArray = [];
                                var upcomingBookingList = payload.title.data.result;
                                upcomingBookingList.forEach(function (column) {
                                    var d = {};
                                    d.job_id = column.job_id;
                                    d.job_status = column.job_status;
                                    d.created_by = column.created_by;
                                    d.booking_for = column.booking_for;
                                    d.is_vip = column.is_VIP;

                                    //0 owner, 1- other
                                    //d.job_pickup_datetime = changeDateFormat(column.job_pickup_datetime);
                                    d.job_pickup_name = column.job_pickup_name;
                                    d.job_pickup_phone = column.job_pickup_phone;
                                    d.job_pickup_email = column.job_pickup_email;
                                    d.job_pickup_address = column.job_pickup_address;
                                    d.job_address = column.job_address; //destination
                                    d.number_of_passangers = column.number_of_passangers;
                                    d.creation_datetime = column.creation_datetime;
                                    d.fleet_id = column.fleet_id;
                                    //d.job_time_utc = column.job_time; //actual start time
                                    d.job_time = column.job_time_utc; //actual start time
                                    d.job_time_filtered = $filter('date')(column.job_time_utc, "MMM d, yyyy HH:mm'"); //actual start time
                                    if (new Date(column.job_time_utc).getDate() == new Date().getDate() && new Date(column.job_time_utc).getMonth() == new Date().getMonth() && new Date(column.job_time_utc).getFullYear() == new Date().getFullYear()) {
                                        d.dateFlagForShow = true;
                                    } else {
                                        d.dateFlagForShow = false;
                                    }
                                    d.transport_details = column.transport_details; //CAR number
                                    d.fleet_first_name = column.fleet_first_name;
                                    d.fleet_last_name = column.fleet_last_name;
                                    d.fleet_country_code = column.fleet_country_code;
                                    d.fleet_phone_number = column.fleet_phone_number;
                                    d.customer_first_name = column.customer_first_name;
                                    d.customer_last_name = column.customer_last_name;
                                    d.customer_country_code = column.customer_country_code;
                                    d.customer_phone_number = column.customer_phone_number;
                                    d.is_round_trip = column.is_round_trip;
                                    d.is_wait_time_included = column.is_wait_time_included;
                                    d.return_date_time_utc = column.return_date_time;
                                    d.return_date_time = column.return_date_time_utc;
                                    d.round_trip_parent_job_id = column.round_trip_parent_job_id;
                                    d.auth_required = column.auth_required;
                                    d.auth_of = column.auth_of;
                                    d.is_auth = column.is_auth;
                                    d.branch = column.branch_name;
                                    d.type_of_service = column.service_name;
                                    d.agreement = column.contract_name;
                                    d.unique_car_id = column.unique_car_id;
                                    d.estimated_payment_cost = column.estimated_payment_cost;
                                    d.type_of_trip = column.type_of_trip;
                                    d.is_POS_booking = column.is_POS_booking;
                                    d.shared_service_id = column.shared_service_id;
                                    d.shared_service_status = column.shared_service_status;
                                    d.booking_type = column.booking_type;
                                    d.locking_id = column.locking_id;
                                    d.locking_name = column.locking_id_name;
                                    d.urgent_booking_assignment = column.urgent_booking_assignment;
                                    d.flight_number = column.flight_number;
                                    d.sin_respaldo = column.sin_respaldo;
                                    d.manual_rejection = column.manual_rejection;
                                    d.shift_id = column.shift_id;
                                    d.payment_method = column.payment_method;
                                    d.payment_status = column.payment_status;
                                    d.color = column.urgent_booking_assignment ? '#ff4d4d' : '#333';
                                    d.thermal_print_cancel = column.thermal_print_cancel;
                                    d.admin_fullyname = column.admin_fullyname;
                                    d.total_refund_amount = column.total_refund_amount;
                                    d.total_estimated_payment_cost = column.total_estimated_payment_cost;
                                    d.round_trip = column.round_trip;
                                    if (column.is_group_allowed == 1) {
                                        if (column.discard_from_group != null && column.discard_from_group == 0 && column.schedule_ride == 1 && column.booking_type == 0) {
                                            d.dicardFlag = true;
                                        } else if( column.discard_from_group != null && column.discard_from_group == 0 && column.schedule_ride == 1 && column.booking_type == 2 && column.is_qrcode_enabled == 1){
                                            d.dicardFlag = true;
                                        } else {
                                            d.dicardFlag = false;
                                        }
                                    }

                                    d.not_valid_address = column.not_valid_address || 0;

                                    dataArray.push(d);
                                });
                                vm.upcomingBookingList = dataArray;

                                // USERTYPE VALUE
                                // 0 - Transvip user
                                // 1 - PET user
                                vm.userType = payload.title.data.user_type || 0;

                                for (var i = 0; i < vm.upcomingBookingList.length; i++) {
                                    vm.upcomingBookingList[i].index = (skip + i);
                                }
                                if (vm.dataLength <= vm.itemsPerPageGot) {
                                    vm.sp_pagination = false;
                                } else {
                                    vm.sp_pagination = true;
                                    //vm.pageCount(payload.title.totalCount);
                                }
                                vm.skipValue = vm.upcomingBookingList[0].index;
                                vm.limitValue = vm.upcomingBookingList[vm.upcomingBookingList.length - 1].index;

                                //$scope.$watch('vm.search', function (newVal, oldVal) {
                                //    vm.filtered = filterFilter(vm.upcomingBookingList, newVal);
                                //    vm.totalItems = vm.filtered.length;
                                //    console.log('vm.filtered',vm.filtered);
                                //    if (vm.filtered.length == 0) {
                                //        vm.watchPagination = false;
                                //    } else {
                                //        vm.watchPagination = true;
                                //    }
                                //    if (vm.filterOn == true) {
                                //        vm.skipValueFilter = vm.filtered.length;
                                //        console.log('vm.skipValueFilter',vm.skipValueFilter);
                                //        vm.sp_pagination = false;
                                //    }
                                //}, true);

                                //range();
                            }
                        }
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        //===========================get filters by booking id=========================
        function getFilterBookingId(data) {
            vm.currentPage = 0;
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (!data) {
                vm.getAllUpcomingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
            } else {
                //if (vm.filterTextTimeout) $timeout.cancel(vm.filterTextTimeout);
                //vm.filterTextTimeout = $timeout(function(){
                getBookingIdResults(vm.filterData);
                //},500);
            }
        };

        function getBookingIdResults(data) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            if (data.searchBookingId)
                dataSend.booking_id = data.searchBookingId;
            if (data.searchPackageId)
                dataSend.package_id = data.searchPackageId;
            dataSend.booking_status = 0;
            //vm.loading = true;
            var promise = getBookings.getBookingById(dataSend);
            promise.then(
                function (payload) {
                    console.log(payload, "payload");

                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {

                        if (payload.title.data.result.length) {
                            vm.totalUpcomingBookings = payload.title.data.totalCount;
                            vm.dataLength = payload.title.data.totalCount;

                            if (payload.title.data.totalCount == 0) {
                                vm.sp_pagination = false;
                                vm.tBodyFlag = false;
                                vm.tFootFlag = true;
                                vm.filterOn = true;
                                vm.skipValueFilter = 0;
                            } else {
                                vm.sp_pagination = true;
                                vm.tBodyFlag = true;
                                vm.tFootFlag = false;
                                vm.filterOn = false;
                                vm.skipValueFilter = 0;

                                var dataArray = [];
                                var upcomingBookingList = payload.title.data.result;
                                upcomingBookingList.forEach(function (column) {
                                    var d = {};
                                    d.job_id = column.job_id;
                                    d.job_status = column.job_status;
                                    d.created_by = column.created_by;
                                    d.booking_for = column.booking_for; //0 owner, 1- other
                                    d.is_vip = column.is_VIP;
                                    //d.job_pickup_datetime = changeDateFormat(column.job_pickup_datetime);
                                    d.job_pickup_name = column.job_pickup_name;
                                    d.job_pickup_phone = column.job_pickup_phone;
                                    d.job_pickup_email = column.job_pickup_email;
                                    d.job_pickup_address = column.job_pickup_address;
                                    d.job_address = column.job_address; //destination
                                    d.number_of_passangers = column.number_of_passangers;
                                    d.creation_datetime = column.creation_datetime;
                                    d.fleet_id = column.fleet_id;
                                    //d.job_time_utc = column.job_time; //actual start time
                                    d.job_time = column.job_time_utc; //actual start time
                                    d.job_time_filtered = $filter('date')(column.job_time_utc, "MMM d, yyyy HH:mm'"); //actual start time
                                    if (new Date(column.job_time_utc).getDate() == new Date().getDate() && new Date(column.job_time_utc).getMonth() == new Date().getMonth() && new Date(column.job_time_utc).getFullYear() == new Date().getFullYear()) {
                                        d.dateFlagForShow = true;
                                    } else {
                                        d.dateFlagForShow = false;
                                    }
                                    d.transport_details = column.transport_details; //CAR number
                                    d.fleet_first_name = column.fleet_first_name;
                                    d.fleet_last_name = column.fleet_last_name;
                                    d.fleet_country_code = column.fleet_country_code;
                                    d.fleet_phone_number = column.fleet_phone_number;
                                    d.customer_first_name = column.customer_first_name;
                                    d.customer_last_name = column.customer_last_name;
                                    d.customer_country_code = column.customer_country_code;
                                    d.customer_phone_number = column.customer_phone_number;
                                    d.is_round_trip = column.is_round_trip;
                                    d.return_date_time_utc = column.return_date_time;
                                    d.return_date_time = column.return_date_time_utc;
                                    d.round_trip_parent_job_id = column.round_trip_parent_job_id;
                                    d.auth_required = column.auth_required;
                                    d.auth_of = column.auth_of;
                                    d.is_auth = column.is_auth;
                                    d.branch = column.branch_name;
                                    d.type_of_service = column.service_name;
                                    d.agreement = column.contract_name;
                                    d.unique_car_id = column.unique_car_id;
                                    d.estimated_payment_cost = column.estimated_payment_cost;
                                    d.type_of_trip = column.type_of_trip;
                                    d.is_wait_time_included = column.is_wait_time_included;
                                    d.is_POS_booking = column.is_POS_booking;
                                    d.shared_service_id = column.shared_service_id;
                                    d.shared_service_status = column.shared_service_status;
                                    d.booking_type = column.booking_type;
                                    d.locking_id = column.locking_id;
                                    d.locking_name = column.locking_id_name;
                                    d.urgent_booking_assignment = column.urgent_booking_assignment;
                                    d.flight_number = column.flight_number;
                                    d.sin_respaldo = column.sin_respaldo;
                                    d.manual_rejection = column.manual_rejection;
                                    d.color = column.urgent_booking_assignment ? '#ff4d4d' : '#333';
                                    d.shift_id = column.shift_id;
                                    d.payment_method = column.payment_method;
                                    d.payment_status = column.payment_status;
                                    d.not_valid_address = column.not_valid_address || 0;
                                    d.thermal_print_cancel = column.thermal_print_cancel;
                                    d.admin_fullyname = column.admin_fullyname;
                                    d.total_refund_amount = column.total_refund_amount;
                                    d.total_estimated_payment_cost = column.total_estimated_payment_cost;
                                    d.round_trip = column.round_trip;
                                    if (column.is_group_allowed == 1) {
                                        if (column.discard_from_group != null && column.discard_from_group == 0 && column.schedule_ride == 1 && column.booking_type == 0) {
                                            d.dicardFlag = true;
                                        } else if( column.discard_from_group != null && column.discard_from_group == 0 && column.schedule_ride == 1 && column.booking_type == 2 && column.is_qrcode_enabled == 1){
                                            d.dicardFlag = true;
                                        } else {
                                            d.dicardFlag = false;
                                        }
                                    }
                                    dataArray.push(d);
                                    console.log(dataArray);

                                });
                                vm.upcomingBookingList = dataArray;

                                // USERTYPE VALUE
                                // 0 - Transvip user
                                // 1 - PET user
                                vm.userType = payload.title.data.user_type || 0;

                                for (var i = 0; i < vm.upcomingBookingList.length; i++) {
                                    vm.upcomingBookingList[i].index = (i);
                                }
                                if (vm.dataLength <= vm.itemsPerPageGot) {
                                    vm.sp_pagination = false;
                                } else {
                                    vm.sp_pagination = true;
                                    //vm.pageCount(payload.title.totalCount);
                                }
                                vm.skipValue = vm.upcomingBookingList[0].index;
                                vm.limitValue = vm.upcomingBookingList[vm.upcomingBookingList.length - 1].index;
                                //range();
                            }
                        } else {
                            vm.upcomingBookingList = [];
                            vm.sp_pagination = false;
                            vm.tBodyFlag = false;
                            vm.tFootFlag = true;
                            vm.filterOn = true;
                            vm.skipValueFilter = 0;
                            vm.totalUpcomingBookings = 0;
                            vm.dataLength = 0;
                        }
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    } else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        vm.getAllUpcomingBookings((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData,true);
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    //console.log($scope.totalPages);
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        //console.log($scope.currentPage);
        //        vm.currentPage++;
        //        vm.getAllUpcomingBookings((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData,true);
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    vm.getAllUpcomingBookings((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData,true);
        //};

        function init() {
            // console.log(vm.filterData);
            // debugger;
            var obj = angular.copy(vm.filterData);
            vm.getAllUpcomingBookings(0, vm.filterData.itemsPerPageSelected, vm.filterData, true);
        };

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            //vm.filterOn = true;
            vm.currentPage = 0;
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            pendingRequests.cancelAll();
            if (vm.filterData.search.length == 0) {
                vm.filterData.search_filter = 0;
                vm.filterData.search_value = '';
                vm.getAllUpcomingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                //vm.filterOn = false;
                //vm.watchPagination = true;
                //vm.sp_pagination = true;

            } else {
                vm.filterData.search_filter = 1;
                vm.filterData.search_value = vm.filterData.search;
                //if (vm.filterTextTimeout) $timeout.cancel(vm.filterTextTimeout);
                //vm.filterTextTimeout = $timeout(function(){
                vm.getAllUpcomingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                //},500);

            }
        };

        // ****** FUNCTION FOR AGREEMENT FILTER ********
        function getFilterForAgreement() {
            //vm.filterOn = true;
            vm.currentPage = 0;
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            pendingRequests.cancelAll();
            if (vm.filterData.agreementSearch.length == 0) {
                vm.filterData.agreementValue = 0;
                vm.filterData.agreementSearch = '';
                getAllUpcomingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                //vm.filterOn = false;
                //vm.watchPagination = true;
                //vm.sp_pagination = true;

            } else {
                vm.filterData.agreementValue = 1;
                vm.filterData.agreementSearch = vm.filterData.agreementSearch;
                //if (vm.filterTextTimeout) $timeout.cancel(vm.filterTextTimeout);
                //vm.filterTextTimeout = $timeout(function(){
                getAllUpcomingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                //},500);

            }
        };

        // ****** FUNCTION FOR SEARCH BY NAME FILTER ********
        function getFilterForSearchByNameFilter() {
            //vm.filterOn = true;
            vm.currentPage = 0;
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            pendingRequests.cancelAll();
            if (vm.filterData.searchByNameFilter.length == 0) {
                vm.filterData.searchByNameFilterValue = 0;
                vm.filterData.searchByNameFilter = '';
                // getAllUpcomingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                //vm.filterOn = false;
                //vm.watchPagination = true;
                //vm.sp_pagination = true;

            } else {
                vm.filterData.searchByNameFilterValue = 1;
                vm.filterData.searchByNameFilter = vm.filterData.searchByNameFilter;
                //if (vm.filterTextTimeout) $timeout.cancel(vm.filterTextTimeout);
                //vm.filterTextTimeout = $timeout(function(){
                // getAllUpcomingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                //},500);

            }
        };

        //=====================get available drivers for manual assign===========================
        function driverGetFromManual(data, $event, jobData) {
            $log.log(data);
            vm.items = {
                allDrivers: data,
                selectedDriver: {},
                ShiftErrMsg: '',
                job_id: jobData.job_id,
                jobData: jobData,
                limit: data.length > 0 ? data[0].limit : 10,
                offset: 0,
                total: data.length > 0 ? data[0].totalCount : 10,
                searchDriver: '',
                onOffDuty: '0',
                allVehicle: '0'
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/selectDriverForCarShift.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });

            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };

                $scope.confirmUpload = function () {
                    console.log($scope.items, '$scope.items');

                    if ($scope.items.selectedDriver.fleet_id) {
                        //finalSelectedDriverApi($scope.items);
                        checkBeforeAssignDriver($scope.items, $event);
                        $mdDialog.hide();
                    } else {
                        $scope.items.ShiftErrMsg = languageBasedErrorFactory.getProperErrorMessage('assignPopError', 0, '3');
                        $timeout(function () {
                            $scope.items.ShiftErrMsg = '';
                        }, 2000);
                    }
                };
                $scope.selectDriver = function (data) {
                    $log.log(data);
                    $scope.items.selectedDriver = data;
                };
                var filterTextTimeout = '';
                $scope.getAssignDriverSearch = function (data) {
                    $scope.items.offset = 0;
                    if (data && data.length) {
                        if (filterTextTimeout) $timeout.cancel(filterTextTimeout);
                        filterTextTimeout = $timeout(function () {
                            $scope.getDataDriver('search');
                        }, 500);
                    } else {
                        $scope.items.allDrivers = [];
                        $scope.getDataDriver();
                    }
                };

                $scope.paginationFunction = function () {
                    if ($scope.items.allDrivers.length == $scope.items.total) {
                        return;
                    }
                    $scope.items.offset = $scope.items.offset + 10;
                    $scope.getDataDriver();
                }

                $scope.getDataDriverChange = function () {
                    $scope.items.allDrivers = [];
                    $scope.items.offset = 0;
                    $scope.getDataDriver();
                }

                $scope.getDataDriver = function (type) {
                    var dataSend = {
                        access_token: $cookies.get('obj'),
                        job_id: Number(jobData.job_id),
                        limit: $scope.items.limit,
                        offset: $scope.items.offset,
                        item: $scope.items.searchDriver ? $scope.items.searchDriver : '',
                        search_id: $scope.items.searchDriverbyVehicleId ? $scope.items.searchDriverbyVehicleId : '',
                        key: $scope.items.onOffDuty,
                        all_vehicles: $scope.items.allVehicle
                    };
                    vm.loading = true;
                    var promise = getBookings.manualAssignBooking(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            vm.loading = false;
                            $scope.items.total = payload.title.data.totalCount;
                            if (type == 'search') {
                                $scope.items.allDrivers = [];
                                // vm.exclude_car_id = payload.title.data.exclude_car_id;
                                for (var i = 0; i < payload.title.data.result.length; i++) {
                                    var d = {};
                                    d.unique_car_id = payload.title.data.result[i].unique_car_id;
                                    d.last_name = payload.title.data.result[i].last_name;
                                    d.first_name = payload.title.data.result[i].first_name;
                                    d.phone = payload.title.data.result[i].phone;
                                    d.country_code = payload.title.data.result[i].country_code;
                                    d.is_available = payload.title.data.result[i].is_available;
                                    d.name = payload.title.data.result[i].name;
                                    d.status = payload.title.data.result[i].status;
                                    d.job_status = payload.title.data.result[i].job_status;
                                    d.fleet_id = payload.title.data.result[i].fleet_id;
                                    d.off = payload.title.data.result[i].off ? payload.title.data.result[i].off : false;
                                    d.limit = payload.title.data.limit;
                                    // d.showFlag = vm.exclude_car_id.includes(payload.title.data.result[i].unique_car_id);
                                    d.totalCount = payload.title.data.totalCount;
                                    $scope.items.allDrivers.push(d);
                                }
                            } else {
                                // vm.exclude_car_id = payload.title.data.exclude_car_id;
                                for (var i = 0; i < payload.title.data.result.length; i++) {
                                    var d = {};
                                    d.unique_car_id = payload.title.data.result[i].unique_car_id;
                                    d.last_name = payload.title.data.result[i].last_name;
                                    d.first_name = payload.title.data.result[i].first_name;
                                    d.phone = payload.title.data.result[i].phone;
                                    d.country_code = payload.title.data.result[i].country_code;
                                    d.is_available = payload.title.data.result[i].is_available;
                                    d.name = payload.title.data.result[i].name;
                                    d.status = payload.title.data.result[i].status;
                                    d.job_status = payload.title.data.result[i].job_status;
                                    d.fleet_id = payload.title.data.result[i].fleet_id;
                                    d.off = payload.title.data.result[i].off ? payload.title.data.result[i].off : false;
                                    d.limit = payload.title.data.limit;
                                    // d.showFlag = vm.exclude_car_id.includes(payload.title.data.result[i].unique_car_id);
                                    d.totalCount = payload.title.data.totalCount;
                                    $scope.items.allDrivers.push(d);
                                }
                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }
            }
        };

        function checkBeforeAssignDriver(data, $event) {
            var dataSend = {
                access_token: $cookies.get('obj'),
                job_id: Number(data.job_id),
                fleet_id: Number(data.selectedDriver.fleet_id)
            };
            vm.loading = true;
            var promise = getBookings.checkBeforeAssignDriverApi(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        checkDriverPop(payload.title, data, $event);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        finalSelectedDriverApi(data);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        checkDriverPop(errorPayload.data, data, $event);
                    }
                }
            );
        }

        function checkDriverPop(msg, data, $event) {
            vm.items = {};
            vm.items.data = msg.data.final_response;

            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/manualAssignErrors.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: ErrorDialogController
            });

            function ErrorDialogController($scope, items, $mdDialog) {
                $scope.items = items;

                $scope.confirmDialog = function () {
                    $mdDialog.hide();
                    finalSelectedDriverApi(data);
                }
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                }
            }

            //var confirm = $mdDialog.confirm()
            //    .title(msg)
            //    .textContent('')
            //    .ariaLabel('Lucky day')
            //    .targetEvent($event)
            //    .ok('CONTINUE')
            //    .cancel('CANCEL');
            //
            //$mdDialog.show(confirm).then(function () {
            //    finalSelectedDriverApi(data);
            //}, function () {
            //    $log.log('not confirmed');
            //});
        };

        function finalSelectedDriverApi(data) {
            $log.log(data);
            var dataSend = {
                access_token: $cookies.get('obj'),
                job_id: Number(data.job_id),
                fleet_id: Number(data.selectedDriver.fleet_id)
            };
            vm.loading = true;
            var promise = getBookings.manualAssignBookingToFleet(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        languageBasedErrorFactory.getProperErrorMessage('driverAssignedSucc', 0, 0);
                        $timeout(function () {
                            if (vm.filterData.searchBookingId) {
                                getFilterBookingId(vm.filterData.searchBookingId);
                            } else if (vm.filterData.searchPackageId) {
                                getFilterBookingId(vm.filterData.searchPackageId);
                            } else {
                                getAllUpcomingBookings(vm.currentPage > 0 ? (vm.currentPage - 1) * vm.itemsPerPageGot : 0, vm.itemsPerPageGot, vm.filterData, true);
                            }
                        }, 100);

                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        function verifyAssignButton(data) {
            vm.loading = true;
            var promise = adminAccessService.checkStateValid(data); //$stateParams.id
            return promise.then(
                function (payload) {
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (data == 'Asignar Manualmente') {
                            if (!payload.title.data.granted) {
                                vm.AssignButtonRole = false;
                                vm.unAssignButtonRole = false;
                                // errorMessageFactory.showErrorMessage('No está autorizado para usar esta opción', 0);
                                //errorMessageFactory.showErrorMessage('Option not available because you not have the right',0);
                                return false;
                            } else {
                                vm.loading = false;
                                vm.AssignButtonRole = true;
                                vm.unAssignButtonRole = true;
                            }
                        }
                    }
                },
                function (errorPayload) {
                    console.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        verifyAssignButton('Asignar Manualmente');

        //===========================manual assign booking=================================
        function manualAssignBooking(data, $event) {
            $log.log(data);
            if (!vm.AssignButtonRole) {
                errorMessageFactory.showErrorMessage('No tiene permiso para ejecutar esta opción', 0);
                return;
            }

            if (data.shared_service_id) {
                if (data.booking_type == 1 || data.booking_type == '1') {
                    var msg = 'La reserva no se puede asignar porque es parte del servicio compartido #' + data.shared_service_id + ' ya enrutado. Puede solicitar que se elimine del servicio compartido enrutado y luego asignarlo'
                } else if (data.booking_type == 2 || data.booking_type == '2') {
                    var msg = 'La reserva no se puede asignar porque es parte del servicio agrupado #' + data.shared_service_id + ' ya creado. Puede solicitar que se elimine del servicio agrupado y luego asignarlo'
                } else if (data.booking_type == 0 || data.booking_type == '0') {
                    var msg = 'La reserva no se puede asignar porque es parte del servicio agrupado #' + data.shared_service_id + ' ya creado. Puede solicitar que se elimine del servicio agrupado y luego asignarlo'
                }
                errorMessageFactory.showErrorMessage(msg, 0);
                return;
            } else if ((data.booking_type == 1 || data.booking_type == '1') && !data.locking_id && !data.shared_service_id) {
                var msg = 'La reserva no se puede asignar porque se está convirtiendo en parte del nuevo servicio compartido ya enrutado. Solicita que se elimine del servicio compartido enrutado y luego se lo asigna';
                errorMessageFactory.showErrorMessage(msg, 0);
                return;
            } else if (data.locking_id) {
                if (data.booking_type == 1 || data.booking_type == '1') {
                    var msg = 'La reserva está bloqueada por usuario' + ' ' + data.locking_name + ' ' + 'para la creación o modificación del paquete';
                    // var msg = 'La reserva no se puede asignar porque se está convirtiendo en parte del nuevo servicio compartido ya enrutado. Solicita que se elimine del servicio compartido enrutado y luego se lo asigna';
                    //var msg = 'El viaje ya no está disponible';
                } else if (data.booking_type == 2 || data.booking_type == '2') {
                    var msg = 'La reserva está bloqueada por usuario' + ' ' + data.locking_name + ' ' + 'para la creación o modificación del paquete';
                    // var msg = 'La reserva no se puede asignar porque se está convirtiendo en parte del nuevo servicio agrupado ya enrutado. Puede solicitar que se elimine del servicio agrupado y luego asignarlo';
                    //var msg = 'El viaje ya no está disponible';
                } else if (data.booking_type == 0 || data.booking_type == '0') {
                    var msg = 'La reserva está bloqueada por usuario' + ' ' + data.locking_name + ' ' + 'para la creación o modificación del paquete';
                    // var msg = 'La reserva no se puede asignar porque se está convirtiendo en parte del nuevo servicio agrupado ya enrutado. Puede solicitar que se elimine del servicio agrupado y luego asignarlo';
                    //var msg = 'El viaje ya no está disponible';
                }
                errorMessageFactory.showErrorMessage(msg, 0);
                return;
            }

            var dataSend = {
                access_token: $cookies.get('obj'),
                job_id: Number(data.job_id),
                limit: 10,
                offset: 0,
                search_id: '',
                key: 0,
                all_vehicles: 0
            };
            vm.loading = true;
            var promise = getBookings.manualAssignBooking(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.arrayToshow = [];
                    // vm.exclude_car_id = _.uniq(payload.title.data.exclude_car_id);
                    for (var i = 0; i < payload.title.data.result.length; i++) {
                        var d = {};
                        d.unique_car_id = payload.title.data.result[i].unique_car_id;
                        d.last_name = payload.title.data.result[i].last_name;
                        d.first_name = payload.title.data.result[i].first_name;
                        d.phone = payload.title.data.result[i].phone;
                        d.country_code = payload.title.data.result[i].country_code;
                        d.is_available = payload.title.data.result[i].is_available;
                        d.name = payload.title.data.result[i].name;
                        d.status = payload.title.data.result[i].status;
                        d.job_status = payload.title.data.result[i].job_status;
                        d.fleet_id = payload.title.data.result[i].fleet_id;
                        d.off = payload.title.data.result[i].off ? payload.title.data.result[i].off : false;
                        d.limit = payload.title.data.limit;
                        // d.showFlag = vm.exclude_car_id.includes(payload.title.data.result[i].unique_car_id);
                        d.totalCount = payload.title.data.totalCount;
                        vm.arrayToshow.push(d);
                    }
                    driverGetFromManual(vm.arrayToshow, $event, data);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        //===================get ALL no show reasons=========================
        function getAllNoShowReasonHit() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = 0;
            dataSend.offset = 0;
            dataSend.status = 0;

            var promise = getNoShowReason.getNoShowReasonList(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    //vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.noShowReason = payload.title.data.result;
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        getAllNoShowReasonHit();

        //=============================mark no show============================
        function markNoShow(data, $event) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.job_id = data.job_id;
            vm.loading = true;
            var promise = getBookings.getNoShowData(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    markNoShowPopup(data, $event, payload.title.data);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        function markNoShowPopup(data, $event, noShowData) {
            vm.noShowitems = {
                job_id: data.job_id,
                jobData: data,
                noShowReasonData: vm.noShowReason,
                noShowData: noShowData,
                description: '',
                reasonSelected: '',
                errorMsg: '',
                loading: false
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/noShowMark.html',
                locals: {
                    items: vm.noShowitems
                },
                bindToController: true,
                controller: NoShowMarkController
            });

            function NoShowMarkController($scope, $mdDialog, items) {
                $scope.noShowitems = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    changeJobStatusOfBooking($scope.noShowitems, 12);
                };
            }
        }

        //=========================get cancel reason hit=========================
        function getCancelReasonHit($event, data, jobStatus) {
            vm.loading = true;
            var dataSend = {};
            dataSend.key = 0;
            dataSend.channel = 2;
            dataSend.payment_method = data.payment_method;
            var promise = getCancelReason.getCancelReasonList(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.data && payload.title.data.length) {
                        vm.cancelReasonList = payload.title.data;
                    } else {
                        vm.cancelReasonList = [];
                    }
                    openCancelPopup($event, data, jobStatus, vm.cancelReasonList);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };


        function getAdminListAccordingToRoleApi() {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.access = 'Autorizar Anulación de Reserva';
            var promise = getBookings.getAdminListAccordingToRole(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    console.log(payload, 'payload');

                    if (payload.title.status == 200) {
                        vm.adminList = payload.title.data;
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        getAdminListAccordingToRoleApi();

        function openCancelPopup($event, data, jobStatus, cancelList) {
            var popUpToOpen = '';
            vm.cancelPopItems = {
                jobData: data,
                job_id: data.job_id,
                cancelReasonList: cancelList,
                reasonSelected: '',
                jobStatus: jobStatus,
                adminList: vm.adminList,
                cancellation_description: '',
                flagForConfirm: false,
                flagForValidateButton: false,
                message: '',
                password: '',
                authorize_id: null,
                RequiredMessage: '',
                RequiredMessageEmail: ''
            };
            var currentShiftId = $cookies.get('saleShiftId');
            console.log(currentShiftId, 'currentShiftId');
            console.log(data.shift_id, currentShiftId, data.shift_id == currentShiftId);
            if (data.shift_id != null && currentShiftId != undefined && data.shift_id == currentShiftId) {
                if (cancelList[0].payment_data.is_refund == 1) {
                    if (data.payment_status == 1) {
                        vm.openHit = true;
                        popUpToOpen = 'app/components/dialogViews/cancelBookingPopUpNew.html';
                    }
                } else {
                    vm.openHit = false;
                    popUpToOpen = 'app/components/dialogViews/cancelBookingPopUp.html';
                }
            } else if (data.shift_id != null && currentShiftId != undefined && data.shift_id != currentShiftId) {
                if (cancelList[0].payment_data.is_refund == 1) {
                    if (data.payment_status == 1) {
                        vm.cancelPopItems.flagForConfirm = true;
                        vm.openHit = true;
                        popUpToOpen = 'app/components/dialogViews/cancelBookingPopUpAuthorization.html';
                    }
                } else {
                    vm.openHit = false;
                    popUpToOpen = 'app/components/dialogViews/cancelBookingPopUp.html';
                }
            } else {
                vm.openHit = false;
                popUpToOpen = 'app/components/dialogViews/cancelBookingPopUp.html';
            }

            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: popUpToOpen,
                locals: {
                    items: vm.cancelPopItems
                },
                bindToController: true,
                controller: CancelMarkController
            });

            function CancelMarkController($scope, $mdDialog, items) {
                $scope.cancelPopItems = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    changeJobStatusOfBooking($scope.cancelPopItems, jobStatus);
                };
                $scope.validatorAutorizator = function () {
                    if ($scope.cancelPopItems.password == '' || $scope.cancelPopItems.password == undefined || $scope.cancelPopItems.password == null) {
                        $scope.cancelPopItems.RequiredMessage = 'This feild is required'
                        $timeout(function () {
                            $scope.cancelPopItems.RequiredMessage = '';
                        }, 2000)
                    }
                    if ($scope.cancelPopItems.email == '' || $scope.cancelPopItems.email == undefined ||
                        $scope.cancelPopItems.email == null) {
                        $scope.cancelPopItems.RequiredMessageEmail = 'This feild is required'
                        $timeout(function () {
                            $scope.cancelPopItems.RequiredMessageEmail = '';
                        }, 2000)
                    }
                    if ($scope.cancelPopItems.email == '' || $scope.cancelPopItems.password == '' || $scope.cancelPopItems.email == undefined ||
                        $scope.cancelPopItems.email == null || $scope.cancelPopItems.password == undefined || $scope.cancelPopItems.password == null) {
                        return true;
                    }
                    // vm.loading = true;
                    var dataSend = {};
                    dataSend.email = $scope.cancelPopItems.email;
                    dataSend.password = $scope.cancelPopItems.password;
                    var promise = getBookings.validatePassword(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log(payload);
                            // vm.loading = false;
                            console.log(payload, 'authorize_id');

                            if (payload.title.status == 200) {
                                $scope.cancelPopItems.flagForConfirm = false;
                                $scope.cancelPopItems.flagForValidateButton = true;
                                $scope.cancelPopItems.authorize_id = payload.title.data[0].admin_id;
                                $scope.cancelPopItems.message = '';
                                $scope.cancelPopItems.RequiredMessage = '';
                                $scope.cancelPopItems.RequiredMessageEmail = '';
                            } else {
                                $scope.cancelPopItems.message = payload.title.message;
                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }
            }
        }


        //=============================make job status change============================
        function makeBookingStatusChange(data, $event, type) {

            var msg = '';
            var jobStatus = '';
            if (type == 'onroad') {
                msg = languageBasedErrorFactory.getProperErrorMessage('onRoadMessage', 0, '3');
                jobStatus = 15;
            } else if (type == 'cancel') {
                //msg = languageBasedErrorFactory.getProperErrorMessage('cancelledMessage',0,'3');
                if (data.locking_id) {
                    if (data.booking_type == 1 || data.booking_type == '1') {
                        // var msg = 'La reserva no se puede cancelar porque se está convirtiendo en parte del nuevo servicio compartido ya enrutado. Puede crear uno nuevo o solicitar que se elimine del servicio compartido enrutado y luego cancelarlo';
                        var msg = 'La reserva está bloqueada por usuario' + ' ' + data.locking_name + ' ' + 'para la creación o modificación del paquete';
                    } else if (data.booking_type == 2 || data.booking_type == '2') {
                        // var msg = 'La reserva no se puede cancelar porque se está convirtiendo en parte del nuevo servicio agrupado ya enrutado. Puede crear uno nuevo o solicitar que se elimine del servicio agrupado y luego cancelarlo';
                        var msg = 'La reserva está bloqueada por usuario' + ' ' + data.locking_name + ' ' + 'para la creación o modificación del paquete';
                    } else if (data.booking_type == 0 || data.booking_type == '0') {
                        var msg = 'La reserva está bloqueada por usuario' + ' ' + data.locking_name + ' ' + 'para la creación o modificación del paquete';
                        // var msg = 'La reserva no se puede modificar porque se está convirtiendo en parte del nuevo servicio agrupado ya enrutado. Puede cancelar la reserva y crear una nueva, o solicitar que se elimine del servicio agrupado y luego modificarla';
                    }
                    errorMessageFactory.showErrorMessage(msg, 0);
                    return;
                } else {
                    jobStatus = 9;
                    getCancelReasonHit($event, data, jobStatus);
                    return;
                }
            } else {
                msg = languageBasedErrorFactory.getProperErrorMessage('noShowPop', 0, '3');
                jobStatus = 12;
            }
            var confirm = $mdDialog.confirm()
                .title(msg)
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                changeJobStatusOfBooking(data, jobStatus);
            }, function () {
                $log.log('not confirmed');
            });
        };


        function changeJobStatusOfBooking(data, jobStatus) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.job_id = data.job_id;
            dataSend.job_status = jobStatus;
            if (jobStatus == 12) {
                dataSend.noshow_reason = data.reasonSelected;
                dataSend.noshow_comment = data.description;
            }
            if (jobStatus == 9) {
                dataSend.cancellation_reason = data.reasonSelected.reason;
                dataSend.cancellation_reason_id = data.reasonSelected.reason_id;
                dataSend.cancellation_description = data.cancellation_description;
                if (data.cancelReasonList[0].payment_data.is_refund == 1 || data.cancelReasonList[0].payment_data.is_refund == 0) {
                    dataSend.cancellation_method_id = data.cancelReasonList[0].payment_data.refund_payment_id;
                    dataSend.cancellation_payment_amount = data.jobData.round_trip ? data.jobData.total_refund_amount : data.jobData.estimated_payment_cost;
                    if (($cookies.get('saleShiftId')) != undefined || ($cookies.get('saleShiftId')) != null)
                        dataSend.cancellation_shift_id = Number($cookies.get('saleShiftId'));
                }
                if (data.authorize_id)
                    dataSend.authorize_id = data.authorize_id;
            }
            vm.loading = true;
            var promise = getBookings.changeJobStatus(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    // languageBasedErrorFactory.getProperErrorMessage('noShowSucc', 0, 0);
                    if (payload.title.status == 200) {
                        if (vm.openHit)
                            getThermalPrintHeightCancel(data);
                        else errorMessageFactory.showErrorMessage('Estado cambiado exitosamente', 1);
                        if (vm.filterData.searchBookingId) {
                            getFilterBookingId(vm.filterData.searchBookingId);
                        } else if (vm.filterData.searchPackageId) {
                            getFilterBookingId(vm.filterData.searchPackageId);
                        }
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        if (jobStatus == 12) {
                            data.errorMsg = errorPayload.data.message;
                            $timeout(function () {
                                data.errorMsg = '';
                            }, 3000);
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                }
            );
        }


        function getThermalPrintHeightCancel(data) {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.job_id = data.jobData.job_id;
            var promise = getBookings.getCancelThermalPrint(dataSend);
            promise.then(function (payload) {
                    $log.log('sxdsads', payload);
                    console.log(payload, 'booking pdf');
                    if (payload.title.status == 200) {
                        document.getElementById('cancelPrint').innerHTML = payload.title.data;
                        setTimeout(function () {
                            document.querySelector('table.mainHeader-3').style.width = '100%';
                            document.querySelector('table.mainHeader-2').style.width = '100%';
                        }, 500);
                        $timeout(function () {
                            getThermalPrintCancel(data, payload.title.data);
                        }, 100);
                    } else {
                        vm.loading = false;
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function getThermalPrintCancel(data, payload) {
            $log.log(data);
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.job_id = Number(data.jobData.job_id);
            dataSend.timezone = new Date().getTimezoneOffset();
            dataSend.height = $('#cancelPrint').height() + 200;
            dataSend.variableDetailsThermal = payload;
            vm.loading = true;
            var promise = getBookings.printReceipt(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;

                    function PrintDiv() {
                        var contents = document.getElementById("cancelPrint").innerHTML;
                        var frame1 = document.createElement('iframe');
                        frame1.name = "frame1";
                        // frame1.value = "frame12"
                        frame1.style.position = "absolute";
                        frame1.style.top = "-1000000px";
                        document.body.appendChild(frame1);
                        var frameDoc = frame1.contentWindow ? frame1.contentWindow : frame1.contentDocument.document ? frame1.contentDocument.document : frame1.contentDocument;
                        frameDoc.document.open();
                        // frameDoc.document
                        frameDoc.document.write();
                        frameDoc.document.write();
                        frameDoc.document.write(contents);
                        frameDoc.document.write();
                        frameDoc.document.close();
                        // setTimeout(function () {
                        //     window.frames["frame1"].focus();
                        //     window.frames["frame1"].print();
                        //     document.body.removeChild(frame1);
                        //     if (vm.printCount == 0) {
                        //         getPrintReceiptHeight(vm.secondPrint, 'SecondPrint');
                        //         vm.printCount++;
                        //     }
                        // }, 500);
                        // return false;

                        frame1.onload = function () {
                            // setTimeout(function () {
                            window.frames["frame1"].focus();
                            window.frames["frame1"].print();
                            document.body.removeChild(frame1);
                            // }, 500);
                            return false;
                        };
                        frame1.onerror = function () {
                            errorMessageFactory.showErrorMessage('Please try again', 0);
                            return false;
                        };
                    }
                    PrintDiv();
                    errorMessageFactory.showErrorMessage('Estado cambiado exitosamente', 1);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            )
        }
        //====================get branch list====================
        // function getBranch() {
        //     //     vm.branchList = [];
        //     //     vm.branchList = JSON.parse(JSON.stringify(getFilters.branchesFiltersData.data));
        //     //     vm.branchList.push({
        //     //         region_name: 'Todos',
        //     //         region_id: 'all'
        //     //     });
        //     // $scope.$apply();


        //     vm.loading = true;
        //     var promise = getGeofence.branch();
        //     promise.then(
        //         function (payload) {
        //             $log.log(payload);
        //             //vm.loading = false;
        //             if (payload.title.status == 400) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //             } else if (payload.title.status == 401) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //             } else if (payload.title.status == 201 || payload.title.status == 200) {
        //                 var where = _.where(payload.title.data, {
        //                     parent_id: 0
        //                 });
        //                 //vm.branchList = _.where(where, { is_active: 1 });
        //                 vm.branchList = where;

        //                 vm.branchList.push({
        //                     region_name: 'Todos',
        //                     region_id: 'all'
        //                 });
        //             }
        //         },
        //         function (errorPayload) {
        //             $log.log(errorPayload);
        //             vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // }
        // // WHen Page refresh service take time to get data from backend
        // // setTimeout(function () {
        // getBranch();
        // }, 1000);
        //======================get all vehicles==============
        // function getAllVehicles(skip, limt, filter) {
        //     // vm.vehicle = [];
        //     // angular.forEach(getFilters.vehiclesFiltersData.data, function (column) {
        //     //     vm.vehicle.push({
        //     //         id: column.id,
        //     //         name: column.name
        //     //     })
        //     // });
        //     // vm.vehicle.push({
        //     //     id: 'all',
        //     //     name: 'Todos'
        //     // });
        //     vm.loading = false;
        //     var promise = getVehicles.allVehicles(skip, limt, filter);
        //     promise.then(
        //         function (payload) {
        //             $log.log('sxdsads', payload);
        //             //vm.loading = false;
        //             if (payload.title.status == 400) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //             } else if (payload.title.status == 401) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //             } else if (payload.title.status == 201 || payload.title.status == 200) {
        //                 vm.vehicle = [];
        //                 angular.forEach(payload.title.data.result, function (column) {
        //                     vm.vehicle.push({
        //                         id: column.id,
        //                         name: column.name
        //                     })
        //                 });
        //                 vm.vehicle.push({
        //                     id: 'all',
        //                     name: 'Todos'
        //                 });
        //             }
        //         },
        //         function (errorPayload) {
        //             $log.log(errorPayload);
        //             //vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // };
        // // WHen Page refresh service take time to get data from backend
        // // setTimeout(function () {
        // getAllVehicles(0, 0, 2);
        // }, 1000);
        //======================get all services==============
        // function getAllServices(skip, limit) {
        //     // vm.service = [];
        //     // angular.forEach(getFilters.servicesFiltersData.data, function (column) {
        //     //     vm.service.push({
        //     //         id: column.id,
        //     //         name: column.service_name
        //     //     });
        //     // });
        //     // vm.service.push({
        //     //     id: 'all',
        //     //     name: 'Todos'
        //     // });

        //     vm.loading = false;
        //     var promise = getServices.allServices(skip, limit, 2, 0);
        //     promise.then(
        //         function (payload) {
        //             $log.log('sxdsads', payload);
        //             //vm.loading = false;
        //             if (payload.title.status == 400) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //             } else if (payload.title.status == 401) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //             } else if (payload.title.status == 201 || payload.title.status == 200) {
        //                 vm.service = [];
        //                 angular.forEach(payload.title.data.result, function (column) {
        //                     vm.service.push({
        //                         id: column.id,
        //                         name: column.service_name
        //                     });
        //                 });
        //                 vm.service.push({
        //                     id: 'all',
        //                     name: 'Todos'
        //                 })
        //             }
        //         },
        //         function (errorPayload) {
        //             $log.log(errorPayload);
        //             vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // };
        // // WHen Page refresh service take time to get data from backend
        // // setTimeout(function () {
        // getAllServices(0, 0);
        // }, 1000);

        //======================get all Agreement==============
        // function getAllAgreement(skip, limt) {
        //     var dataSend = {};
        //     dataSend.access_token = $cookies.get('obj');
        //     dataSend.offset = skip;
        //     dataSend.limit = limt;
        //     dataSend.key = 3;
        //     //vm.loading = false;

        //     var promise = getAgreement.getAgreementListLessData(dataSend);
        //     promise.then(
        //         function (payload) {
        //             $log.log('sxdsads', payload);
        //             //vm.loading = false;
        //             if (payload.title.status == 400) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //             } else if (payload.title.status == 401) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //             } else if (payload.title.status == 201 || payload.title.status == 200) {
        //                 vm.agreement = [];
        //                 angular.forEach(payload.title.data, function (column) {
        //                     vm.agreement.push({
        //                         id: column.id,
        //                         name: column.name
        //                     });
        //                 });
        //                 vm.agreement.push({
        //                     id: 'all',
        //                     name: 'Todos'
        //                 });
        //             }
        //         },
        //         function (errorPayload) {
        //             $log.log(errorPayload);
        //             //vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // };
        // getAllAgreement(0, 0);

        // ******** CLEAR OFFSET *******
        // function clearOffset() {
        //     for (var i = 0; i < vm.searchFilterArray.length; i++) {
        //         vm[vm.searchFilterArray[i] + 'Offset'] = 0;
        //     }
        // }
        //=================filter change functions=================
        function branchChanged() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            // clearOffset();
            if (vm.filterData.branch && vm.filterData.branch != 'all') {
                vm.filterData.branch_filter = 1;
                // getAllUpcomingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // vm.agreement = [];
                // vm.branchList = [];
                // vm.vehicle = [];
                // vm.service = [];
                // getFilterDataFromBackend();
            } else {
                vm.filterData.branch_filter = 0;
                vm.filterData.branch = 'all';
                // getAllUpcomingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // vm.agreement = [];
                // vm.branchList = [];
                // vm.vehicle = [];
                // vm.service = [];
                // getFilterDataFromBackend();
            }
        };

        function agreementChanged() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            // clearOffset();
            if (vm.filterData.agreement && vm.filterData.agreement != 'all') {
                vm.filterData.aggrement_filter = 1;
                // getAllUpcomingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // vm.filterData.agreement = [];
                vm.agreementIds = [];
                vm.agreementIds[0] = vm.filterData.agreement;
                // vm.agreement = [];
                // vm.branchList = [];
                // vm.vehicle = [];
                // vm.service = [];
                // getFilterDataFromBackend();
            } else {
                vm.filterData.aggrement_filter = 0;
                vm.filterData.agreement = 'all';
                vm.agreementIds = [];
                if (JSON.parse($cookies.get('adminType') || 0) == 1) {
                    vm.agreementIds = vm.agreementDummyIds;
                } else {
                    vm.agreementIds[0] = 0;
                }
                // getAllUpcomingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // vm.agreement = [];
                // vm.branchList = [];
                // vm.vehicle = [];
                // vm.service = [];
                // getFilterDataFromBackend();
            }
        };

        function serviceChanged() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            // clearOffset();
            if (vm.filterData.service && vm.filterData.service != 'all') {
                vm.filterData.service_filter = 1;
                // getAllUpcomingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // vm.agreement = [];
                // vm.branchList = [];
                // vm.vehicle = [];
                // vm.service = [];
                // getFilterDataFromBackend();
            } else {
                vm.filterData.service_filter = 0;
                vm.filterData.service = 'all';
                // getAllUpcomingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // vm.agreement = [];
                // vm.branchList = [];
                // vm.vehicle = [];
                // vm.service = [];
                // getFilterDataFromBackend();
            }
        };

        function vehicleChanged() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            // clearOffset();
            if (vm.filterData.vehicle && vm.filterData.vehicle != 'all') {
                vm.filterData.vehicle_filter = 1;
                // getAllUpcomingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // vm.agreement = [];
                // vm.branchList = [];
                // vm.vehicle = [];
                // vm.service = [];
                // getFilterDataFromBackend();
            } else {
                vm.filterData.vehicle_filter = 0;
                vm.filterData.vehicle = 'all';
                // getAllUpcomingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // vm.agreement = [];
                // vm.branchList = [];
                // vm.vehicle = [];
                // vm.service = [];
                // getFilterDataFromBackend();
            }
        };

        function typeTripChanged() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (vm.filterData.type_of_trip && vm.filterData.type_of_trip != 'all') {
                vm.filterData.type_of_trip_filter = 1;
                // getAllUpcomingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // vm.agreement = [];
                // vm.branchList = [];
                // vm.vehicle = [];
                // vm.service = [];
                // getFilterDataFromBackend();
            } else {
                vm.filterData.type_of_trip_filter = 0;
                vm.filterData.type_of_trip = 'all';
                // getAllUpcomingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // vm.agreement = [];
                // vm.branchList = [];
                // vm.vehicle = [];
                // vm.service = [];
                // getFilterDataFromBackend();
            }
        };

        console.log(vm.filterData, 'vm.filterData.searchByNameFilter');

        //function pickupDateChanged(){
        //    vm.currentPage = 0;
        //    console.log(vm.filterData.filter_pickup_date_value);
        //    if(vm.filterData.filter_pickup_date_value){
        //        vm.filterData.date_time_filter = 1;
        //        getAllUpcomingBookings(0,vm.itemsPerPageGot,vm.filterData);
        //    }
        //    else{
        //        vm.filterData.date_time_filter = 0;
        //        vm.filterData.filter_pickup_date_value = '';
        //        getAllUpcomingBookings(0,vm.itemsPerPageGot,vm.filterData);
        //    }
        //};
        //
        //function pickupTimeChanged(){
        //    vm.currentPage = 0;
        //    console.log(vm.filterData.filter_pickup_time_value);
        //    if(vm.filterData.filter_pickup_time_value && vm.filterData.filter_pickup_date_value){
        //        vm.filterData.date_time_filter = 1;
        //        getAllUpcomingBookings(0,vm.itemsPerPageGot,vm.filterData);
        //    }
        //    else if(vm.filterData.filter_pickup_date_value){
        //        vm.filterData.date_time_filter = 1;
        //        //vm.filterData.filter_pickup_time_value = '';
        //        //if(vm.filterData.filter_pickup_date_value)
        //            getAllUpcomingBookings(0,vm.itemsPerPageGot,vm.filterData);
        //    }
        //    else{
        //        vm.filterData.date_time_filter = 0;
        //        //vm.filterData.filter_pickup_time_value = '';
        //        //if(vm.filterData.filter_pickup_date_value)
        //        getAllUpcomingBookings(0,vm.itemsPerPageGot,vm.filterData);
        //    }
        //};

        function resetFilter() {
            vm.currentPage = 0;
            vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            vm.filterData = {
                branch_filter: 0, //0, 1
                service_filter: 0, //0, 1
                vehicle_filter: 0, //0, 1
                aggrement_filter: 0, //0, 1
                //date_time_filter : 0,  //0, 1
                type_of_trip_filter: 0, //0, 1
                branch: 'all',
                service: 'all',
                vehicle: 'all',
                // type_of_trip: 'From Airport',
                //date_time_value: '',
                agreement: 'all',
                //filter_pickup_date_value: getNextDate(),
                //filter_pickup_time_value: showFilterTime(),
                limit: vm.itemsPerPageGot,
                offset: 0,
                booking_status: 0,
                searchBookingId: '',
                searchPackageId: '',
                agreementSearch: '',
                agreementValue: 0,
                searchByName: 0,
                search: '',
                itemsPerPageSelected: 25,
                filter_pickup_from_date_value: getFirstDateOfPreviousMonth(),
                filter_pickup_to_date_value: setToPickupDate(),
                filter_pickup_from_time_value: showFilterTime(1),
                filter_pickup_to_time_value: showFilterTime(2),
            };

            vm.dateOptions = {
                //dateDisabled: disabled,
                formatYear: 'yy',
                // maxDate: new Date(),
                // minDate: new Date(vm.filterData.filter_pickup_from_date_value),
                startingDay: 1,
                showWeeks: false,

            };
            getAllUpcomingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
        }

        function applyFilter(){
            vm.getAllUpcomingBookings(0, vm.filterData.itemsPerPageSelected, vm.filterData, true);
        }
        //======================modify booking======================
        function modifyBooking(data) {
            if (data.sin_respaldo == 1) {
                vm.loading = true;
                var promise = adminAccessService.checkStateValid('BWR'); //$stateParams.id
                return promise.then(
                    function (payload) {
                        vm.loading = false;
                        if (payload.title.status == 400) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            return false;
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                            return false;
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            if (!payload.title.data.granted) {
                                // languageBasedErrorFactory.getProperErrorMessage('optionNotAvail', 0, 0);
                                errorMessageFactory.showErrorMessage(' No está autorizado para usar esta opción', 0);
                                return false;
                            } else {
                                vm.loading = false;
                                pageRedirectToModify(data);
                                // vm.grantedCheckbox =  true;
                                // vm.showCheckbox = true;
                                // setBooleans(id , value , panelType , buttonName , index);
                                // $timeout(function (){

                                // },500)

                                // setFlagInJob(id, type)
                                // return true;
                            }
                        }
                    },
                    function (errorPayload) {
                        console.log(errorPayload);
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            } else {
                pageRedirectToModify(data);
            }
        };

        function pageRedirectToModify(data) {
            if (data.sin_respaldo == 1) {
                $state.go('layout.upcomingBookingsMain.modifyBooking', {
                    id: data.job_id,
                    custId: data.created_by
                });
            } else {
                if (data.fleet_first_name) {
                    languageBasedErrorFactory.getProperErrorMessage('modifyError1', 0, 0);
                    //errorMessageFactory.showErrorMessage('Error, impossible to modify the booking because it is already assigned to a vehicle.',0);
                    return;
                } else if (data.auth_required == 1) {
                    languageBasedErrorFactory.getProperErrorMessage('modifyError2', 0, 0);
                    //errorMessageFactory.showErrorMessage('Error, impossible to modify the booking because it is under the authorization model.',0);
                    return;
                }
                // Tv-1885
                // else if (data.is_round_trip == 1 && data.is_POS_booking != 1 || data.round_trip_parent_job_id > 0 && data.is_POS_booking != 1) {
                //     languageBasedErrorFactory.getProperErrorMessage('modifyError3', 0, 0);
                //     //errorMessageFactory.showErrorMessage('Error, impossible to modify the booking because it is round trip.',0);
                //     return;
                // }
                else if (data.shared_service_id) {
                    if (data.booking_type == 1 || data.booking_type == '1') {
                        var msg = 'La reserva no puede ser modificada porque forma parte del servicio compartido #' + data.shared_service_id + ' ya ruteado. Puede cancelar la reserva y hacer una nueva, o solicitar que se saque del servicio compartido ruteado y luego modificarla'
                    } else if (data.booking_type == 2 || data.booking_type == '2') {
                        var msg = 'La reserva no puede ser modificada porque forma parte del servicio agrupado #' + data.shared_service_id + ' ya creado. Puede cancelar la reserva y hacer una nueva, o solicitar que se saque del servicio agrupado y luego modificarla'
                    } else if (data.booking_type == 0 || data.booking_type == '0') {
                        var msg = 'La reserva no puede ser modificada porque forma parte del servicio agrupado #' + data.shared_service_id + ' ya creado. Puede cancelar la reserva y hacer una nueva, o solicitar que se saque del servicio agrupado y luego modificarla'
                    }
                    errorMessageFactory.showErrorMessage(msg, 0);
                    return;
                } else if (data.locking_id) {
                    if (data.booking_type == 1 || data.booking_type == '1') {
                        var msg = 'La reserva está bloqueada por usuario' + ' ' + data.locking_name + ' ' + 'para la creación o modificación del paquete';
                        // var msg = 'La reserva no se puede modificar porque se está convirtiendo en parte del nuevo servicio compartido ya enrutado. Puede cancelar la reserva y crear una nueva, o solicitar que se elimine del servicio compartido enrutado y luego modificarlo';
                    } else if (data.booking_type == 2 || data.booking_type == '2') {
                        var msg = 'La reserva está bloqueada por usuario' + ' ' + data.locking_name + ' ' + 'para la creación o modificación del paquete';
                        // var msg = 'La reserva no se puede modificar porque se está convirtiendo en parte del nuevo servicio agrupado ya enrutado. Puede cancelar la reserva y crear una nueva, o solicitar que se elimine del servicio agrupado y luego modificarla';
                    } else if (data.booking_type == 0 || data.booking_type == '0') {
                        var msg = 'La reserva está bloqueada por usuario' + ' ' + data.locking_name + ' ' + 'para la creación o modificación del paquete';
                        // var msg = 'La reserva no se puede modificar porque se está convirtiendo en parte del nuevo servicio agrupado ya enrutado. Puede cancelar la reserva y crear una nueva, o solicitar que se elimine del servicio agrupado y luego modificarla';
                    }
                    errorMessageFactory.showErrorMessage(msg, 0);
                    return;
                } else {
                    $state.go('layout.upcomingBookingsMain.modifyBooking', {
                        id: data.job_id,
                        custId: data.created_by
                    });
                }
            }

        }
        //======================modify booking======================

        //=============================unassign booking==========================
        function manualUnassignBooking(data, $event) {
            if (!vm.unAssignButtonRole) {
                errorMessageFactory.showErrorMessage('No tiene permiso para ejecutar esta opción', 0);
                return;
            }
            if (data.shared_service_id) {
                if (data.booking_type == 1 || data.booking_type == '1') {
                    var msg = 'La reserva no se puede desasignar porque es parte del servicio compartido #' + data.shared_service_id + ' ya enrutado. Puede cancelar la reserva y crear una nueva, o solicitar que se elimine del servicio compartido enrutado y luego anular la asignación.';
                } else if (data.booking_type == 2 || data.booking_type == '2') {
                    var msg = 'La reserva no se puede cancelar debido a que forma parte del servicio agrupado #' + data.shared_service_id + ' ya creado. Puede cancelar la reserva y crear una nueva, o solicitar que se elimine del servicio agrupado y luego desasignarla';
                }
                errorMessageFactory.showErrorMessage(msg, 0);
                return;
            }

            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('unassginPop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.job_id = Number(data.job_id);
                vm.loading = true;
                var promise = getBookings.unassignBookingDriver(dataSend);
                promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        if (payload.title.status == 200) {
                            languageBasedErrorFactory.getProperErrorMessage('unassginSucc', 0, 0);
                            if (vm.filterData.searchBookingId) {
                                getFilterBookingId(vm.filterData.searchBookingId);
                            } else if (vm.filterData.searchPackageId) {
                                getFilterBookingId(vm.filterData.searchPackageId);
                            } else {
                                getAllUpcomingBookings(vm.currentPage > 0 ? (vm.currentPage - 1) * vm.itemsPerPageGot : 0, vm.itemsPerPageGot, vm.filterData, true);
                            }
                        } else {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }

                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        }

        //======================print receipt api=============================
        function printReceiptApi(data) {
            // if(data.type_of_trip != 'Z'){
            //     errorMessageFactory.showErrorMessage("¡Lo siento! no está permitido imprimir este comprobante", 0);
            //     return false
            // }
            $log.log(data);
            vm.loading = true;
            var promise = adminAccessService.checkStateValid('Print Receipt'); //$stateParams.id
            return promise.then(
                function (payload) {
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (!payload.title.data.granted) {
                            languageBasedErrorFactory.getProperErrorMessage('optionNotAvail', 0, 0);
                            //errorMessageFactory.showErrorMessage('Option not available because you not have the right',0);
                            return false;
                        } else {
                            vm.loading = false;
                            getPrintReceiptHeight(data);
                            return true;
                        }
                    }
                },
                function (errorPayload) {
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function getPrintReceiptHeight(data) {
            $log.log(data);
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.job_id = Number(data.job_id);
            dataSend.timezone = new Date().getTimezoneOffset();
            vm.loading = true;
            var promise = getBookings.getHeightForPrint(dataSend);
            promise.then(function (payload) {
                    $log.log('sxdsads', payload);
                    if (payload.title.status == 200) {
                        document.getElementById('showPrint').innerHTML = payload.title.data;
                        $timeout(function () {
                            getPrintReceiptLink(data, payload.title.data);
                            document.querySelector('table.mainHeader-1').style.width = '100%';
                        }, 0);
                    } else {
                        vm.loading = false;
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        var win = '';

        function getPrintReceiptLink(data, payload) {
            $log.log(data);
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.job_id = Number(data.job_id);
            dataSend.timezone = new Date().getTimezoneOffset();
            dataSend.height = $('#showPrint').height() + 200;
            dataSend.variableDetailsThermal = payload;
            vm.loading = true;
            var promise = getBookings.printReceipt(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    // document.getElementById('showPrint').innerHTML = '';
                    // if (win) {
                    //     win.close();
                    // }
                    // win = window.open("", "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=" + (screen.width) + ",height=" + (screen.height) + ",top=0,left=0");
                    // win.document.body.innerHTML = '<iframe src="' + payload.title.data + '" height=' + screen.height + ' width=' + screen.width + '></ifrmae>';
                    function PrintDiv() {
                        var contents = document.getElementById("showPrint").innerHTML;
                        var frame1 = document.createElement('iframe');
                        frame1.name = "frame1";
                        // frame1.value = "frame12"
                        frame1.style.position = "absolute";
                        frame1.style.top = "-1000000px";
                        document.body.appendChild(frame1);
                        var frameDoc = frame1.contentWindow ? frame1.contentWindow : frame1.contentDocument.document ? frame1.contentDocument.document : frame1.contentDocument;
                        frameDoc.document.open();
                        // frameDoc.document
                        frameDoc.document.write();
                        frameDoc.document.write();
                        frameDoc.document.write(contents);
                        frameDoc.document.write();
                        frameDoc.document.close();
                        frame1.onload = function () {
                            // setTimeout(function () {
                            window.frames["frame1"].focus();
                            window.frames["frame1"].print();
                            document.body.removeChild(frame1);
                            // }, 500);
                            return false;
                        };
                        frame1.onerror = function () {
                            errorMessageFactory.showErrorMessage('Please try again', 0);
                            return false;
                        };
                    }
                    PrintDiv();
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            )

        }


        //===================side bar filters=====================
        vm.showFilterArea = showFilterArea;
        vm.branchChangedFilter = branchChangedFilter;
        vm.vehicleChangedFilter = vehicleChangedFilter;
        vm.serviceChangedFilter = serviceChangedFilter;
        vm.agreementChangedFilter = agreementChangedFilter;
        vm.removeFilter = removeFilter;
        vm.typeTripChangedFilter = typeTripChangedFilter;
        vm.showFilterFlag = false;

        vm.filterWhichToShow = {
            branchWithDashboard: false,
            service: true,
            vehicle: true,
            agreement: true,
            operation: false,
            helpTraffic: false,
            virtualFleet: false,
            approvalStage: false,
            vehicleAssigned: false,
            applicantType: false,
            modelity: false,
            tripType: true
        };

        function removeFilter() {
            $state.reload('layout.upcomingBookingsMain.upcomingBookings');
        }

        function showFilterArea() {
            vm.showFilterFlag = !vm.showFilterFlag;
        }

        function branchChangedFilter(data) {
            vm.branchChanged();
        }

        function vehicleChangedFilter(data) {
            vm.vehicleChanged();
        }

        function serviceChangedFilter(data) {
            vm.serviceChanged();
        }

        function agreementChangedFilter(data) {
            vm.agreementChanged();
        }

        function typeTripChangedFilter(data) {
            vm.typeTripChanged();
        }

        function bookingStatusChange() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            // getAllUpcomingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
        }

        function searchByNameRadioButtonChange() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            // getAllUpcomingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
        }

        function changeDateIntoSpanish(date) {
            var options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            };
            return new Date(date).toLocaleString($cookies.get('language') == 'spanish' ? 'es' : 'en', options)
        }

        if (JSON.parse($cookies.get('adminType') || 0) == 1) {
            getFilterDataFromBackend();
        } else {
            if (vm.filterData.aggrement_filter == 0) {
                vm.agreementIds[0] = 0;
            } else {
                vm.agreementIds[0] = vm.filterData.agreement;
            }
        }

        // function getFilterDataFromBackend(data, type) { //Acc to Index ['branch_search', 'vehicle_search', 'service_search', 'agreement_search', 'corporate_search', 'operation_point_search']
        //     vm.agreementDummyIds = [];
        //     var promise = getFilters.getAllFilterData({
        //         agreement_status: 2,
        //         agreement_filter: 1,
        //         agreement_limit: 1000,
        //         agreement_offset: 0,
        //         access_token: $cookies.get('obj')
        //     });
        //     promise.then(
        //         function (payload) {
        //             console.log(payload, "payload`");

        //             // *********** AGREEMENT DATA *********
        //             if (payload.title.data.agreements) {
        //                 angular.forEach(payload.title.data.agreements.data, function (column) {
        //                     vm.agreementDummyIds.push(column.id);
        //                 });
        //                 if (vm.filterData.aggrement_filter == 0) {
        //                     vm.agreementIds = vm.agreementDummyIds;
        //                 } else {
        //                     vm.agreementIds[0] = vm.filterData.agreement;
        //                 }
        //             }




        //             vm.loading = false;
        //         },
        //         function (errorPayload) {
        //             vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         });
        // }


        //////////////////  cancelar Asignacion FOR NEW STATUS 17 TICKET NO 2818 /////////////////////////
        function cancelarAsignacion(data, $event) {
            $log.log(data);
            if (!vm.AssignButtonRole) {
                errorMessageFactory.showErrorMessage('No tiene permiso para ejecutar esta opción', 0);
                return;
            }
            var confirm = $mdDialog.confirm()
                .title('¿Cancelar asignación manual?')
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                changeJobStatusOfBooking(data, 6);
            }, function () {
                $log.log('not confirmed');
            });
        }
        //////////////////  cancelar Asignacion FOR NEW STATUS 17 TICKET NO 2818 /////////////////////////


        //// //////////////  SOCKET TO HANDLE ASSIGN UNASSIGN  ////////////////////////////////////////
        var myListener = $rootScope.$on('quickScreeenBookingAssignedSocket', function (evt, data) {
            console.log('>>>>>>>>>>>>>>>>>>> IN quickScreeenBookingAssignedSocket >>>>>>>>>>>>>>', data);
            $log.log(evt);
            $log.log(data);
            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            var DatetoSend = new Date(date_time_value2).getTime();
            var dateFrom = new Date(date_time_value1).getTime();
            var dateTo = DatetoSend;
            var type = typeof data.res.message;
            var deleteBookingFromArrayJobStatus = [4, 9, 12, 15];

            if (data && data.res && data.res.message && data.res.message.jobArray && data.res.message.jobArray.length > 0) {

                if (data.res.message.is_group_allowed && data.res.message.is_group_allowed == 1) {
                    console.log("Value True");

                    var index;
                    if (data && data.res && data.res.message.jobArray && data.res.message.jobArray.length > 0) {
                        var value = data.res.message;
                        data.res.message.jobArray.forEach(function (data) {
                            index = vm.upcomingBookingList.findIndex(function (x) {
                                return x.job_id == data;
                            });
                            if (index >= 0) {
                                vm.upcomingBookingList[index].dicardFlag = value.is_group_allowed == 1 ? 0 : 1;
                                // vm.upcomingBookingList[index].locking_id_name = data.locking_id_name;
                                $scope.$apply();
                                // vm.filterData.unassignedBookingList.splice(index, 1);
                                console.log(vm.upcomingBookingList, 'vm.upcomingBookingList');

                            }
                        })

                    }

                } else {
                    var bookingArray = data.res.message.jobArray;
                    console.log(bookingArray.length);

                    for (var i = 0; i < bookingArray.length; i++) {
                        var booking_date = bookingArray[i].job_time_utc;
                        // booking_date = booking_date.split('T')[0];
                        booking_date = new Date(booking_date).getTime();
                        // console.log(dateFrom <= booking_date && booking_date <= dateTo, 'dateFrom <= booking_date && booking_date <= dateTo');
                        // console.log(dateFrom, booking_date, dateTo);
                        console.log(dateFrom, booking_date, dateTo, 'first ');
                        console.log(dateFrom <= booking_date && booking_date <= dateTo, 'check');


                        if (dateFrom <= booking_date && booking_date <= dateTo) {
                            checkStatus(bookingArray[i]);
                            console.log(checkStatus(bookingArray[i]), 'checkStatus');

                            if (checkStatus(bookingArray[i])) {
                                if (data.data && vm.countToSocket == 0 && vm.filterData && (!vm.filterData.searchBookingId && !vm.filterData.searchPackageId)) {
                                    // console.log('>>>>>>>>>>>>>>> IN MAIN IF >>>>>>>>>>');
                                    vm.itemsPerPageGot = vm.itemsPerPageSelected;
                                    // getAllUpcomingBookings(vm.currentPage > 0 ? (vm.currentPage - 1) * vm.itemsPerPageGot : 0, vm.itemsPerPageGot, vm.filterData, false);
                                    var index = _.findIndex(vm.upcomingBookingList, {
                                        job_id: bookingArray[i].job_id
                                    });

                                    // ********** TO CHECK INDEX OF SOCKET JOB IN UPCOMING JOB LIST **********
                                    if (index > -1) {
                                        // console.log('>>>>>>> IN IF >>>>>>>>', index, bookingArray[i]);

                                        // ******** TO CHECK STATUS AND REMOVE BOOKING FROM LIST *************
                                        if (deleteBookingFromArrayJobStatus.includes(bookingArray[i].job_status) || bookingArray[i].booking_visibility_flag == 0) {
                                            //FOR booking_visibility_flag 1- visibility ON 0 - visibility OFF
                                            getAllUpcomingBookings(vm.currentPage > 0 ? (vm.currentPage - 1) * vm.itemsPerPageGot : 0, vm.itemsPerPageGot, vm.filterData, false);
                                        } else {
                                            socketDate(index, bookingArray[i]);
                                        }
                                        // socketDate(index, bookingArray[i]);
                                    } else if (index == -1) {
                                        for (var j = 0; j < vm.upcomingBookingList.length; j++) {
                                            // console.log('>>>>>>>> J >>>>>', j, '>>>>>>> vm.upcomingBookingList[j].job_time >>>', vm.upcomingBookingList[j].job_time, '>>>>>>>> bookingArray[i].job_time_utc >>>', bookingArray[i].job_time_utc)
                                            // console.log('>>>>>>>> new Date(vm.upcomingBookingList[j].job_time).getTime() > new Date(bookingArray[i].job_time_utc).getTime() >>>>>', new Date(vm.upcomingBookingList[j].job_time).getTime() > new Date(bookingArray[i].job_time_utc).getTime())
                                            if (new Date(vm.upcomingBookingList[j].job_time).getTime() > new Date(bookingArray[i].job_time_utc).getTime()) {
                                                if (bookingArray[i].urgent_booking_assignment == 1 && vm.currentPage == 0) {
                                                    addNewDataInList(0, bookingArray[i]);
                                                } else if (bookingArray[i].urgent_booking_assignment == 0) {
                                                    addNewDataInList(j, bookingArray[i]);
                                                }
                                                if (vm.upcomingBookingList.length) {
                                                    vm.sp_pagination = true;
                                                    vm.tBodyFlag = true;
                                                    vm.tFootFlag = false;
                                                    vm.filterOn = false;
                                                    vm.skipValueFilter = 0;
                                                }
                                                $scope.$apply();
                                                break;
                                            }
                                        }

                                        // ********** TO CHECK INDEX OF SOCKET JOB IN UPCOMING JOB LIST **********
                                        var index = _.findIndex(vm.upcomingBookingList, {
                                            job_id: bookingArray[i].job_id
                                        });
                                        if (index == -1) {
                                            if (bookingArray[i].urgent_booking_assignment == 1 && vm.currentPage == 0) {
                                                addNewDataInList(0, bookingArray[i]);
                                                if (vm.upcomingBookingList.length) {
                                                    vm.sp_pagination = true;
                                                    vm.tBodyFlag = true;
                                                    vm.tFootFlag = false;
                                                    vm.filterOn = false;
                                                    vm.skipValueFilter = 0;
                                                }
                                            } else if (bookingArray[i].urgent_booking_assignment == 0) {
                                                addNewDataInList(j, bookingArray[i]);

                                                // addNewDataInList(0, bookingArray[i]);

                                                if (vm.upcomingBookingList.length) {
                                                    vm.sp_pagination = true;
                                                    vm.tBodyFlag = true;
                                                    vm.tFootFlag = false;
                                                    vm.filterOn = false;
                                                    vm.skipValueFilter = 0;
                                                }

                                                $scope.$apply();
                                            }
                                        }

                                    }
                                } else if (data.data && vm.countToSocket == 0 && vm.filterData && (vm.filterData.searchBookingId || vm.filterData.searchPackageId)) {
                                    // console.log('>>>>>>>>>>>>>>> IN MAIN ELSE >>>>>>>>>>');
                                    // getBookingIdResults(vm.filterData);


                                    // ********** TO CHECK INDEX OF SOCKET JOB IN UPCOMING JOB LIST **********
                                    var index = _.findIndex(vm.upcomingBookingList, {
                                        job_id: bookingArray[i].job_id
                                    });
                                    if (index > -1) {
                                        // console.log('>>>>>>> IN INDEX >>>>>>>>', index, bookingArray[i]);

                                        // ******** TO CHECK STATUS AND REMOVE BOOKING FROM LIST *************
                                        if (deleteBookingFromArrayJobStatus.includes(bookingArray[i].job_status) || bookingArray[i].booking_visibility_flag == 0) {
                                            getBookingIdResults(vm.filterData);
                                        } else {
                                            socketDate(index, bookingArray[i]);
                                        }
                                        // socketDate(index, bookingArray[i]);
                                    }
                                }
                                break;
                            }

                        }

                    }
                }

            }
        });
        //// //////////////  SOCKET TO HANDLE ASSIGN UNASSIGN  ////////////////////////////////////////

    }
})();

/**
 * Created by cl-macmini-51 on 28/03/18.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('SharedGroupListController', SharedGroupListController);

    /** @ngInject */
    function SharedGroupListController($cookies, $state, $log, $rootScope, $filter, $mdDialog, $timeout, $document, $scope, filterFilter, getBookings, getGeofence,
        getAgreement, getServices, getVehicles, errorMessageFactory, languageBasedErrorFactory, moment, pendingRequests, getFilters) {
        var vm = this;
        $log.log('completedBookings');
        vm.loading = false;
        vm.currentPage = 0;
        vm.totalPackages = 0;
        vm.sp_pagination = false;
        vm.applyFilter = applyFilter;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.filterTextTimeout = '';
        vm.getAllSharedGroupedPackage = getAllSharedGroupedPackage;
        vm.getPagesCount = getPagesCount;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.init = init;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.datePickerE_1 = datePickerE_1;
        vm.branchChanged = branchChanged;
        //vm.agreementChanged = agreementChanged;
        vm.serviceChanged = serviceChanged;
        vm.vehicleChanged = vehicleChanged;
        vm.resetFilter = resetFilter;
        vm.getFilterBookingId = getFilterBookingId;
        vm.typeTripChanged = typeTripChanged;
        vm.slideData = slideData;
        vm.pickupFromToDateChanged = pickupFromToDateChanged;
        vm.pickupFromToTimeChanged = pickupFromToTimeChanged;
        vm.paginationNew = paginationNew;
        vm.packageTypeChanged = packageTypeChanged;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings(runThis);
        vm.countToSocket = 0;
        vm.dateOptions = {};
        vm.datePicker_1 = {
            pickupFromDate: false,
            pickupToDate: false,
        };
        vm.altInputFormats = ['M!/d!/yyyy'];
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.predicate = 'index';
        vm.reverse = false;
        vm.hstep = 1;
        vm.mstep = 15;
        vm.ismeridian = true;
        vm.searchModel = {
            limit: 25,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
        vm.filterData = {
            branch_filter: 0, //0, 1
            service_filter: 0, //0, 1
            vehicle_filter: 0, //0, 1
            aggrement_filter: 0, //0, 1
            package_filter: 0, //0, 1
            date_time_filter: 1, //0, 1
            branch_value: 'all',
            service_value: 'all',
            vehicle_value: 'all',
            date_time_value1: '',
            date_time_value2: '',
            aggrement_value: 'all',
            package_type_value: 'all',
            type_of_trip_value: 'all',
            type_of_trip_filter: 0,
            filter_pickup_from_date_value: getFirstDateOfPreviousMonth(),
            filter_pickup_from_time_value: showFilterTime(1),
            filter_pickup_to_date_value: new Date(),
            filter_pickup_to_time_value: showFilterTime(2),
            limit: vm.itemsPerPageGot,
            offset: 0,
            search_filter: 0,
            search_value: '',
            search: '',
            searchBookingId: '',
            itemsPerPageSelected: 25
        };

        vm.paginationChangedForService = paginationChangedForService;
        vm.paginationChangedForVehicle = paginationChangedForVehicle;
        vm.paginationChangedForBranch = paginationChangedForBranch;
        vm.vehicleSearch = vehicleSearch;
        vm.serviceSearch = serviceSearch;
        vm.branchSearch = branchSearch;
        vm.globalLimit = 10;
        vm.globalOffset = vm.globalLimit;

        vm.service = [];
        vm.service.push({
            id: 'all',
            name: 'All'
        })

        vm.vehicle = [];
        vm.vehicle.push({
            id: 'all',
            name: 'All'
        });

        vm.branchList = [];
        vm.branchList.push({
            region_name: 'All',
            region_id: 'all'
        });

        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'vehicle', 'service', 'agreement', 'corporatesList', 'operation_point'];

        vm.serviceOffset = 0;
        vm.branchOffset = 0;
        vm.vehicleOffset = 0;

        function clearOffset() {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                vm[vm.searchFilterArray[i] + 'Offset'] = 0;
            }

        }
        // =================== FILTER OBJECT ===================
        vm.filterObject = {
            access_token: $cookies.get('obj'),
            branch_filter: 1,
            vehicle_filter: 1,
            service_filter: 1,
            agreement_filter: 0,
            corporate_filter: 0,
            service_category: 0,
            corporate_status: 0,
            agreement_status: 0,
            vehicle__status: 2,
            operation_point_filter: 0,
            service_limit: vm.globalLimit,
            service_offset: vm.serviceOffset,
            branch_limit: vm.globalLimit,
            branch_offset: vm.branchOffset,
            vehicle_limit: vm.globalLimit,
            vehicle_offset: vm.vehicleOffset,
            agreement_limit: vm.globalLimit,
            agreement_offset: vm.agreementOffset,
            branch_search_filter: 0,
            vehicle_search_filter: 0,
            service_search_filter: 0,
            agreement_search_filter: 0,
            corporate_search_filter: 0,
            operation_point_search_filter: 0
        }

        setTimeout(function () {
            document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                // if (vm.branchList && (vm.branchList.length == 0)) {
                vm.searchBranchData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });


            document.getElementsByClassName('ui-select-search')[1].addEventListener('blur', function ($event) {
                // if (vm.service && (vm.service.length == 0)) {
                vm.searchServiceData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

            document.getElementsByClassName('ui-select-search')[2].addEventListener('blur', function ($event) {
                // if (vm.vehicle && (vm.vehicle.length == 0)) {
                vm.searchVehicleData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });


        })
        // =================== GET FILTER DATA ===================
        function getFilterDataFromBackend(data, type) { //Acc to Index ['branch_search', 'vehicle_search', 'service_search', 'agreement_search', 'corporate_search', 'operation_point_search']
            if (data) {
                vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
            } else {
                vm.filterObject = {
                    access_token: $cookies.get('obj'),
                    branch_filter: 1,
                    vehicle_filter: 1,
                    service_filter: 1,
                    agreement_filter: 0,
                    corporate_filter: 0,
                    service_category: 0,
                    corporate_status: 0,
                    agreement_status: 2,
                    vehicle__status: 2,
                    operation_point_filter: 0,
                    branch_search_filter: 0,
                    vehicle_search_filter: 0,
                    service_search_filter: 0,
                    agreement_search_filter: 0,
                    corporate_search_filter: 0,
                    operation_point_search_filter: 0
                }
            }

            vm.filterObject.service_limit = vm.globalLimit;
            vm.filterObject.service_offset = vm.serviceOffset;
            vm.filterObject.branch_limit = vm.globalLimit;
            vm.filterObject.branch_offset = vm.branchOffset;
            vm.filterObject.vehicle_limit = vm.globalLimit;
            vm.filterObject.vehicle_offset = vm.vehicleOffset;
            var promise = getFilters.getAllFilterData(vm.filterObject);
            promise.then(
                function (payload) {

                    // ********** BRANCH DATA ********
                    if (payload.title.data.branches) {
                        var index = _.findIndex(vm.branchList, {
                            region_id: 'all'
                        });
                        if (index == -1)
                            vm.branchList.push({
                                region_name: 'All',
                                region_id: 'all'
                            });
                        angular.forEach(payload.title.data.branches.data, function (column) {
                            var branchIndex = _.findIndex(vm.branchList, {
                                region_id: column.region_id
                            });
                            if (branchIndex == -1)
                                vm.branchList.push(column)
                        });
                        vm.branchTotalBackendCount = payload.title.data.branches.totalCount;
                    }

                    // ********** VEHICLE DATA ********
                    if (payload.title.data.vehicles) {
                        var index = _.findIndex(vm.vehicle, {
                            id: 'all'
                        });
                        if (index == -1)
                            vm.vehicle.push({
                                name: 'All',
                                id: 'all'
                            });
                        vm.vehicleTotalBackendCount = payload.title.data.vehicles.totalCount;
                        angular.forEach(payload.title.data.vehicles.data, function (column) {
                            // vm.vehicle.push({
                            //     id: column.id,
                            //     name: column.name
                            // })
                            var vechicleIndex = _.findIndex(vm.vehicle, {
                                id: column.id
                            });
                            if (vechicleIndex == -1)
                                vm.vehicle.push({
                                    id: column.id,
                                    name: column.name
                                })
                        });
                    }

                    // *********** SERVICE DATA *********
                    if (payload.title.data.services) {
                        var index = _.findIndex(vm.service, {
                            id: 'all'
                        });
                        if (index == -1)
                            vm.service.push({
                                name: 'All',
                                id: 'all'
                            });
                        vm.serviceTotalBackendCount = payload.title.data.services.totalCount;
                        angular.forEach(payload.title.data.services.data, function (column) {
                            // vm.service.push({
                            //     id: column.id,
                            //     name: column.service_name
                            // });
                            var serviceIndex = _.findIndex(vm.service, {
                                id: column.id
                            });
                            if (serviceIndex == -1)
                                vm.service.push({
                                    id: column.id,
                                    name: column.service_name
                                })
                        });
                    
                    }

                    vm.loading = false;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        }

        // ************ PAGINATION ON SERIVCE **************
        function paginationChangedForService() {
            var index = _.findIndex(vm[vm.searchFilterArray[2]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.serviceTotalBackendCount > (vm.service.length - index)) {
                commonFunction(2);
                vm.serviceOffset += 10;
                getFilterDataFromBackend(vm.searchServiceData, 2);
            }
        }

        // ************ PAGINATION ON VEHICLE **************
        function paginationChangedForVehicle() {
            var index = _.findIndex(vm[vm.searchFilterArray[1]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.vehicleTotalBackendCount > (vm.vehicle.length - index)) {
                commonFunction(1);
                vm.vehicleOffset = vm.vehicleOffset + 10;
                getFilterDataFromBackend(vm.searchVehicleData, 1);
            }
        }

        // ************ PAGINATION ON BRANCH **************
        function paginationChangedForBranch() {
            var index = _.findIndex(vm[vm.searchFilterArray[0]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.branchTotalBackendCount > (vm.branchList.length - index)) {
                commonFunction(0);
                vm.branchOffset += 10;
                getFilterDataFromBackend(vm.searchBranchData, 0);
            }
        }

        // *********** COMMON FUNCTION FOR FILTER PAGINATION AND SEARCHING ***********
        function commonFunction(type, mode) {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                // vm['search' + vm.searchFilterArray[i] + 'Data'] = '';
                if (mode == 'search' || i != type) {
                    vm[vm.searchFilterArrayForClearArray[i]] = [];
                    // vm[vm.searchFilterArrayForClearArray[i]].push({
                    //     id: 'all',
                    //     name: 'All'
                    // });
                    vm[vm.searchFilterArray[i] + 'Offset'] = 0;
                    vm['search' + vm.searchFilterArray[i].substring(0, 1).toUpperCase() + vm.searchFilterArray[i].substring(1) + 'Data'] = '';
                }
            }
        }

        // ************ SEARCH VEHICLE ***************
        function vehicleSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchVehicleData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(1, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 1);
                }, 2000);
            }
        }

        // ************ SEARCH SERVICE ***************
        function serviceSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchServiceData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(2, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 2);
                }, 2000);
            }
        }

        // ************ SEARCH VEHICLE ***************
        function branchSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchBranchData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(0, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 0);
                }, 2000);
            }
        }

        function showFilterTime(type) {
            var x = new Date();
            if (type == 1) {
                x.setHours('00');
                x.setMinutes('00');
                x.setSeconds('00');
            } else if (type == 2) {
                x.setHours('23');
                x.setMinutes('59');
                x.setSeconds('00');
            }
            return x;
        }

        function getFirstDateOfPreviousMonth() {
            var x = new Date();
            x.setDate(1);
            x.setMonth(x.getMonth() - 1);
            return x;
        }

        function runThis() {
            vm.typeTripFilter = [{
                    text: languageBasedErrorFactory.getProperErrorMessage('allLabel', 0, '3'),
                    id: 'all'
                },
                {
                    text: 'From Airport',
                    id: 'Z'
                },
                {
                    text: 'To Airport',
                    id: 'R'
                },
                {
                    text: 'Point to Point',
                    id: 'P'
                }
            ]
        }

        if (localStorage.getItem('sharedFilter')) {
            vm.filterData = JSON.parse(localStorage.getItem('sharedFilter'));
            vm.filterData.filter_pickup_from_date_value = new Date(vm.filterData.filter_pickup_from_date_value);
            vm.filterData.filter_pickup_from_time_value = new Date(vm.filterData.filter_pickup_from_time_value);
            vm.filterData.filter_pickup_to_date_value = new Date(vm.filterData.filter_pickup_to_date_value);
            vm.filterData.filter_pickup_to_time_value = new Date(vm.filterData.filter_pickup_to_time_value);
            vm.itemsPerPageSelected = vm.filterData.itemsPerPageSelected ? vm.filterData.itemsPerPageSelected : 25;
            vm.itemsPerPageGot = vm.filterData.itemsPerPageSelected ? vm.filterData.itemsPerPageSelected : 25;
            vm.filterData.itemsPerPageSelected = vm.filterData.itemsPerPageSelected ? vm.filterData.itemsPerPageSelected : 25;
            if (vm.filterData.searchBookingId) {
                getBookingIdResults(vm.filterData.searchBookingId);
            } else {
                init();
            }
        } else {
            init();
        }

        //==============filter store details================
        //$scope.$on('$destroy',function(){
        //    localStorage.removeItem('upcomingFilter');
        //})

        $scope.$watchCollection('vm.filterData', function (newValue, oldValue) {
            console.log('newValue', newValue);
            console.log('oldValue', oldValue);
            localStorage.setItem('sharedFilter', JSON.stringify(newValue));
        })

        //====================socket connection===================
        var myListener = $rootScope.$on('SocketComesShared', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data && vm.countToSocket == 0 && !vm.filterData.searchBookingId) {
                console.log(vm.currentPage);
                vm.itemsPerPageGot = vm.itemsPerPageSelected;
                getAllSharedGroupedPackage(vm.currentPage * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData, false);
            }

        });
        $scope.$on('$destroy', myListener);


        if ($rootScope.socket.connected == false || $rootScope.socket.connected == 'false') {
            $rootScope.socket.connect();
        }

        //====================slide data======================
        $('#derp').hide();

        function slideData() {
            vm.agreement = [];
            vm.branchList = [];
            vm.vehicle = [];
            vm.service = [];
            // getBranch();
            getFilterDataFromBackend();
            $('#derp').slideToggle(1000);
        }


        //==================date picker function==================
        vm.dateOptions = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(2090, 12, 31),
            //minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };
        vm.dateOptionsT = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(),
            //minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };

        function datePickerE_1(type) {
            if (type == 1) {
                vm.datePicker_1.pickupFromDate = true;
                vm.datePicker_1.pickupToDate = false;
            } else if (type == 2) {
                vm.datePicker_1.pickupFromDate = false;
                vm.datePicker_1.pickupToDate = true;
            }
        };
        //====================function for dropdown pages and page count===============
        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            getAllSharedGroupedPackage(0, vm.itemsPerPageGot, vm.filterData, true);
        };

        function paginationNew(page) {
            console.log(page);
            getAllSharedGroupedPackage((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData, true);
        }
        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.completedBookingsMain.completedBookings');
            }
        });
        //===============================function to change date============================
        function changeDateFormat(date) {
            console.log(date);
            var data = date.split('T')[0];
            var newDate = new Date(data);
            //console.log(newDate,date.split('T')[1].split(':')[0],Number(date.split('T')[1].split(':')[1]));
            newDate.setHours(Number(date.split('T')[1].split(':')[0]));
            newDate.setMinutes(Number(date.split('T')[1].split(':')[1]));
            newDate.setSeconds(0);
            console.log(newDate);
            return newDate;
        };
        //====================date time format====================
        function dateTimeFormat(dateGot, timeGot) {
            console.log(dateGot, timeGot);
            var dateToChange = dateGot;
            if (timeGot) {
                dateToChange.setHours(timeGot.getHours());
                dateToChange.setMinutes(timeGot.getMinutes());
                dateToChange.setSeconds(timeGot.getSeconds());
            } else {
                dateToChange.setHours(0);
                dateToChange.setMinutes(0);
                dateToChange.setSeconds(0);
            }
            console.log(dateToChange);
            return dateToChange;
        };
        //==================get all drivers=======================
        function getAllSharedGroupedPackage(skip, limit, filter, loader) {
            if (filter.filter_pickup_from_date_value && filter.filter_pickup_from_time_value) {
                var pickFromDate = dateTimeFormat(filter.filter_pickup_from_date_value, filter.filter_pickup_from_time_value);
            } else if (filter.filter_pickup_from_date_value && !filter.filter_pickup_from_time_value) {
                var pickFromDate = filter.filter_pickup_from_date_value;
            }

            if (filter.filter_pickup_to_date_value && filter.filter_pickup_to_time_value) {
                var pickToDate = dateTimeFormat(filter.filter_pickup_to_date_value, filter.filter_pickup_to_time_value);
            } else if (filter.filter_pickup_to_date_value && !filter.filter_pickup_to_time_value) {
                var pickToDate = filter.filter_pickup_to_date_value;
            }

            if (pickFromDate > pickToDate) {
                languageBasedErrorFactory.getProperErrorMessage('appropriateFilter', 0, 0);
                return;
            }

            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit;
            dataSend.offset = skip;
            dataSend.branch_filter = filter.branch_filter;
            if (filter.branch_filter == 1 && filter.branch_value != 'all') {
                dataSend.branch_value = filter.branch_value;
            }
            dataSend.service_filter = filter.service_filter;
            if (filter.service_filter == 1 && filter.service_value != 'all') {
                dataSend.service_value = filter.service_value;
            }
            dataSend.vehicle_filter = filter.vehicle_filter;
            if (filter.vehicle_filter == 1 && filter.vehicle_value != 'all') {
                dataSend.vehicle_value = filter.vehicle_value;
            }
            dataSend.date_time_filter = filter.date_time_filter;
            if (filter.filter_pickup_from_date_value && filter.filter_pickup_from_time_value) {
                dataSend.date_time_value1 = pickFromDate;
            } else if (filter.filter_pickup_from_date_value && !filter.filter_pickup_from_time_value) {
                dataSend.date_time_value1 = moment(pickFromDate).format('YYYY-MM-DD');
            }

            if (filter.filter_pickup_to_date_value && filter.filter_pickup_to_time_value) {
                dataSend.date_time_value2 = pickToDate;
            } else if (filter.filter_pickup_to_date_value && !filter.filter_pickup_to_time_value) {
                dataSend.date_time_value2 = moment(pickToDate).format('YYYY-MM-DD');
            }

            //dataSend.aggrement_filter = filter.aggrement_filter;
            //if(filter.aggrement_filter == 1 && filter.aggrement_value != 'all'){
            //    dataSend.aggrement_value = filter.aggrement_value;
            //}

            dataSend.type_of_trip_filter = filter.type_of_trip_filter;
            if (filter.type_of_trip_filter == 1 && filter.type_of_trip_value != 'all') {
                dataSend.type_of_trip_value = filter.type_of_trip_value;
            }

            dataSend.package_filter = filter.package_filter;
            if (filter.package_filter == 1 && filter.package_type_value != 'all') {
                dataSend.package_type_value = filter.package_type_value;
            }

            dataSend.search_filter = filter.search_filter;
            if (filter.search_filter == 1) {
                dataSend.search_value = filter.search_value;
            }

            vm.loading = loader;
            vm.countToSocket += 1;
            var promise = getBookings.sharedGroupBookings(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.countToSocket = 0;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.totalPackages = payload.title.data.totalCount;
                        vm.dataLength = payload.title.data.totalCount;

                        if (payload.title.data.totalCount == 0) {
                            vm.sp_pagination = false;
                            vm.tBodyFlag = false;
                            vm.tFootFlag = true;
                            vm.filterOn = true;
                            vm.skipValueFilter = 0;
                        } else {
                            vm.sp_pagination = true;
                            vm.tBodyFlag = true;
                            vm.tFootFlag = false;
                            var dataArray = [];
                            var sharedGroupList = payload.title.data.result;
                            sharedGroupList.forEach(function (column) {
                                var d = {};
                                d.booking_type = column.booking_type;
                                d.car_id = column.car_id;
                                d.creation_datetime = column.creation_datetime;
                                d.first_name = column.first_name;
                                d.fleet_id = column.fleet_id;
                                d.last_name = column.last_name;
                                d.number_of_bookings_in_package = column.number_of_bookings_in_package;
                                d.number_of_passengres_in_package = column.number_of_passengres_in_package;
                                d.shared_service_id = column.shared_service_id;
                                d.status = column.status;
                                d.type_of_trip = column.type_of_trip;
                                d.unique_car_id = column.unique_car_id;
                                dataArray.push(d);
                            });
                            vm.sharedGroupList = dataArray;

                            for (var i = 0; i < vm.sharedGroupList.length; i++) {
                                vm.sharedGroupList[i].index = (skip + i);
                            }
                            if (vm.dataLength <= vm.itemsPerPageGot) {
                                vm.sp_pagination = false;
                            } else {
                                vm.sp_pagination = true;
                                //vm.pageCount(payload.title.totalCount);
                            }
                            vm.skipValue = vm.sharedGroupList[0].index;
                            vm.limitValue = vm.sharedGroupList[vm.sharedGroupList.length - 1].index;
                            vm.filterOn = false;
                            vm.skipValueFilter = 0;
                            //$scope.$watch('vm.search', function (newVal, oldVal) {
                            //    vm.filtered = filterFilter(vm.sharedGroupList, newVal);
                            //    vm.totalItems = vm.filtered.length;
                            //    if (vm.filtered.length == 0) {
                            //        vm.watchPagination = false;
                            //    } else {
                            //        vm.watchPagination = true;
                            //    }
                            //    if (vm.filterOn == true) {
                            //        vm.skipValueFilter = vm.filtered.length;
                            //        vm.sp_pagination = false;
                            //    }
                            //}, true);
                            //range();
                        }
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        //===========================get filters by booking id=========================
        function getFilterBookingId(data) {
            console.log(data);
            if (!data) {
                vm.getAllSharedGroupedPackage(0, vm.itemsPerPageGot, vm.filterData, true);
            } else {
                //if (vm.filterTextTimeout) $timeout.cancel(vm.filterTextTimeout);
                //vm.filterTextTimeout = $timeout(function(){
                getBookingIdResults(data);
                //},500);
            }
        };

        function getBookingIdResults(data) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.package_id = data;
            //vm.loading = true;
            var promise = getBookings.sharedGroupBookingsById(dataSend);
            promise.then(
                function (payload) {
                    console.log(payload);
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (payload.title.data.result.length) {
                            vm.loading = false;
                            vm.totalPackages = payload.title.data.totalCount;
                            vm.dataLength = payload.title.data.totalCount;

                            if (payload.title.data.totalCount == 0) {
                                vm.sp_pagination = false;
                                vm.tBodyFlag = false;
                                vm.tFootFlag = true;
                                vm.filterOn = true;
                                vm.skipValueFilter = 0;
                            } else {
                                vm.sp_pagination = true;
                                vm.tBodyFlag = true;
                                vm.tFootFlag = false;
                                vm.filterOn = false;
                                vm.skipValueFilter = 0;
                                var dataArray = [];
                                var sharedGroupList = payload.title.data.result;
                                sharedGroupList.forEach(function (column) {
                                    var d = {};
                                    d.booking_type = column.booking_type;
                                    d.car_id = column.car_id;
                                    d.creation_datetime = column.creation_datetime;
                                    d.first_name = column.first_name;
                                    d.fleet_id = column.fleet_id;
                                    d.last_name = column.last_name;
                                    d.number_of_bookings_in_package = column.number_of_bookings_in_package;
                                    d.number_of_passengres_in_package = column.number_of_passengres_in_package;
                                    d.shared_service_id = column.shared_service_id;
                                    d.status = column.status;
                                    d.type_of_trip = column.type_of_trip;
                                    d.unique_car_id = column.unique_car_id;
                                    dataArray.push(d);
                                });
                                vm.sharedGroupList = dataArray;

                                for (var i = 0; i < vm.sharedGroupList.length; i++) {
                                    vm.sharedGroupList[i].index = (i);
                                }
                                if (vm.dataLength <= vm.itemsPerPageGot) {
                                    vm.sp_pagination = false;
                                } else {
                                    vm.sp_pagination = true;
                                    //vm.pageCount(payload.title.totalCount);
                                }
                                vm.skipValue = vm.sharedGroupList[0].index;
                                vm.limitValue = vm.sharedGroupList[vm.sharedGroupList.length - 1].index;
                                //range();
                            }
                        } else {
                            vm.sharedGroupList = [];
                            vm.sp_pagination = false;
                            vm.tBodyFlag = false;
                            vm.tFootFlag = true;
                            vm.filterOn = true;
                            vm.skipValueFilter = 0;
                            vm.totalPackages = 0;
                            vm.dataLength = 0;
                        }
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    } else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        vm.getAllSharedGroupedPackage((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData,true);
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    //console.log($scope.totalPages);
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        //console.log($scope.currentPage);
        //        vm.currentPage++;
        //        vm.getAllSharedGroupedPackage((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData,true);
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    vm.getAllSharedGroupedPackage((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData,true);
        //};

        function init() {
            vm.getAllSharedGroupedPackage(0, vm.filterData.itemsPerPageSelected, vm.filterData, true);
        };

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            //vm.filterOn = true;
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            pendingRequests.cancelAll();
            if (vm.filterData.search.length == 0) {
                vm.filterData.search_filter = 0;
                vm.filterData.search_value = '';
                vm.getAllSharedGroupedPackage(0, vm.itemsPerPageGot, vm.filterData, true);
                //vm.filterOn = false;
                //vm.watchPagination = true;
                //vm.sp_pagination = true;
            } else {
                vm.filterData.search_filter = 1;
                vm.filterData.search_value = vm.filterData.search;
                //if (vm.filterTextTimeout) $timeout.cancel(vm.filterTextTimeout);
                //vm.filterTextTimeout = $timeout(function(){
                vm.getAllSharedGroupedPackage(0, vm.itemsPerPageGot, vm.filterData, true);
                //},500);
            }
        };
        //====================get branch list====================
        // function getBranch() {

        //     vm.branchList = [];
        //     vm.branchList = JSON.parse(JSON.stringify(getFilters.branchesFiltersData.data));
        //     vm.branchList.push({
        //         region_name: 'All',
        //         region_id: 'all'
        //     });


        //vm.loading = true;
        // var promise = getGeofence.branch();
        // promise.then(
        //     function (payload) {
        //         $log.log(payload);
        //         //vm.loading = false;
        //         if (payload.title.status == 400) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //         } else if (payload.title.status == 401) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //         } else if (payload.title.status == 201 || payload.title.status == 200) {
        //             var where = _.where(payload.title.data, {
        //                 parent_id: 0
        //             });
        //             //vm.branchList = _.where(where, { is_active: 1 });
        //             vm.branchList = where;

        //             vm.branchList.push({
        //                 region_name: 'All',
        //                 region_id: 'all'
        //             });
        //         }
        //     },
        //     function (errorPayload) {
        //         $log.log(errorPayload);
        // vm.loading = false;
        //         if (errorPayload.data.status == 401) {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //         } else {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //         }
        //     }
        // );
        // }
        // getBranch();
        //======================get all vehicles==============
        // function getAllVehicles(skip, limt, filter) {
        //     vm.vehicle = [];
        //     angular.forEach(getFilters.vehiclesFiltersData.data, function (column) {
        //         vm.vehicle.push({
        //             id: column.id,
        //             name: column.name
        //         })
        //     });
        //     vm.vehicle.push({
        //         id: 'all',
        //         name: 'All'
        //     });

        //vm.loading = false;
        // var promise = getVehicles.allVehicles(skip, limt, filter);
        // promise.then(
        //     function (payload) {
        //         $log.log('sxdsads', payload);
        //         //vm.loading = false;
        //         if (payload.title.status == 400) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //         } else if (payload.title.status == 401) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //         } else if (payload.title.status == 201 || payload.title.status == 200) {
        //             vm.vehicle = [];
        //             angular.forEach(payload.title.data.result, function (column) {
        //                 vm.vehicle.push({
        //                     id: column.id,
        //                     name: column.name
        //                 })
        //             });
        //             vm.vehicle.push({
        //                 id: 'all',
        //                 name: 'All'
        //             });
        //         }
        //     },
        //     function (errorPayload) {
        //         $log.log(errorPayload);
        //         //vm.loading = false;
        //         if (errorPayload.data.status == 401) {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //         } else {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //         }
        //     }
        // );
        // };
        // WHen Page refresh service take time to get data from backend
        // setTimeout(function () {
        //     getAllVehicles(0, 0, 2);
        // }, 1000);
        //======================get all services==============
        // function getAllServices(skip, limit) {
        //     vm.service = [];
        //     angular.forEach(getFilters.servicesFiltersData.data, function (column) {
        //         vm.service.push({
        //             id: column.id,
        //             name: column.service_name
        //         });
        //     });
        //     vm.service.push({
        //         id: 'all',
        //         name: 'All'
        //     });

        //vm.loading = false;
        // var promise = getServices.allServices(skip, limit, 2);
        // promise.then(
        //     function (payload) {
        //         $log.log('sxdsads', payload);
        //         //vm.loading = false;
        //         if (payload.title.status == 400) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //         } else if (payload.title.status == 401) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //         } else if (payload.title.status == 201 || payload.title.status == 200) {
        //             vm.service = [];
        //             angular.forEach(payload.title.data.result, function (column) {
        //                 vm.service.push({
        //                     id: column.id,
        //                     name: column.service_name
        //                 });
        //             });
        //             vm.service.push({
        //                 id: 'all',
        //                 name: 'All'
        //             })
        //         }
        //     },
        //     function (errorPayload) {
        //         $log.log(errorPayload);
        // vm.loading = false;
        //         if (errorPayload.data.status == 401) {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //         } else {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //         }
        //     }
        // );
        // };
        // WHen Page refresh service take time to get data from backend
        // setTimeout(function () {
        //     getAllServices(0, 0);
        // }, 1000);

        //======================get all services==============
        //function getAllAgreement(skip, limt) {
        //    var dataSend = {};
        //    dataSend.access_token = $cookies.get('obj');
        //    dataSend.offset = skip;
        //    dataSend.limit = limt;
        //    dataSend.key = 3;
        //    //vm.loading = false;
        //    var promise = getAgreement.getAgreementListLessData(dataSend);
        //    promise.then(
        //        function(payload) {
        //            $log.log('sxdsads', payload);
        //            //vm.loading = false;
        //            if(payload.title.status == 400){
        //                errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //            }
        //            else if(payload.title.status == 401){
        //                errorMessageFactory.showErrorMessage(payload.title.message,2,'home');
        //            }
        //            else if(payload.title.status == 201 || payload.title.status == 200) {
        //                vm.agreement = [];
        //                angular.forEach(payload.title.data, function (column) {
        //                    vm.agreement.push({id: column.id, name: column.name});
        //                });
        //                vm.agreement.push({
        //                    id: 'all',
        //                    name: 'All'
        //                });
        //            }
        //        },
        //        function(errorPayload) {
        //            $log.log(errorPayload);
        //            //vm.loading = false;
        //            if (errorPayload.data.status == 401) {
        //                errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
        //            } else {
        //                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //            }
        //        }
        //    );
        //};
        //getAllAgreement(0, 0);

        //=================filter change functions=================
        function branchChanged() {
            console.log(" i m here");

            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.agreement = [];
            vm.branchList = [];
            vm.vehicle = [];
            vm.service = [];
            clearOffset();
            vm.branchOffset = 0;
            getFilterDataFromBackend();
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (vm.filterData.branch_value && vm.filterData.branch_value != 'all') {
                vm.filterData.branch_filter = 1;
                // getAllSharedGroupedPackage(0, vm.itemsPerPageGot, vm.filterData, true);
            } else {
                vm.filterData.branch_filter = 0;
                vm.filterData.branch_value = 'all';
                // getAllSharedGroupedPackage(0, vm.itemsPerPageGot, vm.filterData, true);
            }
        };

        //function agreementChanged(){
        //    vm.currentPage = 0;
        //    vm.filterData.searchBookingId = '';
        //    vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
        //    vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
        //    if(vm.filterData.aggrement_value && vm.filterData.aggrement_value != 'all'){
        //        vm.filterData.aggrement_filter = 1;
        //        getAllSharedGroupedPackage(0,vm.itemsPerPageGot,vm.filterData,true);
        //    }
        //    else{
        //        vm.filterData.aggrement_filter = 0;
        //        vm.filterData.aggrement_value = 'all';
        //        getAllSharedGroupedPackage(0,vm.itemsPerPageGot,vm.filterData,true);
        //    }
        //};

        function packageTypeChanged() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (vm.filterData.package_type_value && vm.filterData.package_type_value != 'all') {
                vm.filterData.package_filter = 1;
                // getAllSharedGroupedPackage(0, vm.itemsPerPageGot, vm.filterData, true);
            } else {
                vm.filterData.package_filter = 0;
                vm.filterData.package_type_value = 'all';
                // getAllSharedGroupedPackage(0, vm.itemsPerPageGot, vm.filterData, true);
            }
        }

        function serviceChanged() {
            console.log("i m here");

            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.agreement = [];
            vm.branchList = [];
            vm.vehicle = [];
            vm.service = [];
            clearOffset();
            getFilterDataFromBackend();
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (vm.filterData.service_value && vm.filterData.service_value != 'all') {
                vm.filterData.service_filter = 1;
                // getAllSharedGroupedPackage(0, vm.itemsPerPageGot, vm.filterData, true);
            } else {
                vm.filterData.service_filter = 0;
                vm.filterData.service_value = 'all';
                // getAllSharedGroupedPackage(0, vm.itemsPerPageGot, vm.filterData, true);
            }
        };

        function vehicleChanged() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.agreement = [];
            vm.branchList = [];
            vm.vehicle = [];
            vm.service = [];
            clearOffset();
            vm.vehicleOffset = 0;
            getFilterDataFromBackend();
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (vm.filterData.vehicle_value && vm.filterData.vehicle_value != 'all') {
                vm.filterData.vehicle_filter = 1;
                // getAllSharedGroupedPackage(0, vm.itemsPerPageGot, vm.filterData, true);

            } else {
                vm.filterData.vehicle_filter = 0;
                vm.filterData.vehicle_value = 'all';
                // getAllSharedGroupedPackage(0, vm.itemsPerPageGot, vm.filterData, true);
            }
        };

        function typeTripChanged() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (vm.filterData.type_of_trip_value && vm.filterData.type_of_trip_value != 'all') {
                vm.filterData.type_of_trip_filter = 1;
                // getAllSharedGroupedPackage(0, vm.itemsPerPageGot, vm.filterData, true);
            } else {
                vm.filterData.type_of_trip_filter = 0;
                vm.filterData.type_of_trip_value = 'all';
                // getAllSharedGroupedPackage(0, vm.itemsPerPageGot, vm.filterData, true);
            }
        };

        function pickupFromToDateChanged(type) {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (type == 1) {
                if (vm.filterData.filter_pickup_from_date_value) {
                    vm.filterData.date_time_filter = 1;
                    // getAllSharedGroupedPackage(0, vm.itemsPerPageGot, vm.filterData, true);
                } else {
                    vm.filterData.date_time_filter = 0;
                    vm.filterData.filter_pickup_from_date_value = '';
                    // getAllSharedGroupedPackage(0, vm.itemsPerPageGot, vm.filterData, true);
                }
            } else if (type == 2) {
                if (vm.filterData.filter_pickup_to_date_value) {
                    vm.filterData.date_time_filter = 1;
                    // getAllSharedGroupedPackage(0, vm.itemsPerPageGot, vm.filterData, true);
                } else {
                    vm.filterData.date_time_filter = 0;
                    vm.filterData.filter_pickup_to_date_value = '';
                    // getAllSharedGroupedPackage(0, vm.itemsPerPageGot, vm.filterData, true);
                }
            }
        }

        function pickupFromToTimeChanged(type) {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (type == 1) {
                if (vm.filterData.filter_pickup_from_time_value) {
                    vm.filterData.date_time_filter = 1;
                    // getAllSharedGroupedPackage(0, vm.itemsPerPageGot, vm.filterData, true);
                } else if (vm.filterData.filter_pickup_from_date_value) {
                    vm.filterData.date_time_filter = 1;
                    //vm.filterData.filter_pickup_time_value = '';
                    // getAllSharedGroupedPackage(0, vm.itemsPerPageGot, vm.filterData, true);
                } else {
                    vm.filterData.date_time_filter = 0;
                    //vm.filterData.filter_pickup_time_value = '';
                    // getAllSharedGroupedPackage(0, vm.itemsPerPageGot, vm.filterData, true);
                }
            } else if (type == 2) {
                if (vm.filterData.filter_pickup_to_time_value) {
                    vm.filterData.date_time_filter = 1;
                    // getAllSharedGroupedPackage(0, vm.itemsPerPageGot, vm.filterData, true);
                } else if (vm.filterData.filter_pickup_to_date_value) {
                    vm.filterData.date_time_filter = 1;
                    //vm.filterData.filter_pickup_time_value = '';
                    // getAllSharedGroupedPackage(0, vm.itemsPerPageGot, vm.filterData, true);
                } else {
                    vm.filterData.date_time_filter = 0;
                    //vm.filterData.filter_pickup_time_value = '';
                    // getAllSharedGroupedPackage(0, vm.itemsPerPageGot, vm.filterData, true);
                }
            }
        }

        function resetFilter() {
            vm.currentPage = 0;
            vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            vm.filterData = {
                branch_filter: 0, //0, 1
                service_filter: 0, //0, 1
                vehicle_filter: 0, //0, 1
                aggrement_filter: 0, //0, 1
                package_filter: 0, //0, 1
                date_time_filter: 0, //0, 1
                type_of_trip_filter: 0, //0, 1
                branch_value: 'all',
                service_value: 'all',
                vehicle_value: 'all',
                package_type_value: 'all',
                date_time_value1: '',
                date_time_value2: '',
                aggrement_value: 'all',
                type_of_trip_value: 'all',
                filter_pickup_from_date_value: getFirstDateOfPreviousMonth(),
                filter_pickup_from_time_value: showFilterTime(1),
                filter_pickup_to_date_value: new Date(),
                filter_pickup_to_time_value: showFilterTime(2),
                limit: vm.itemsPerPageGot,
                offset: 0,
                searchBookingId: '',
                search: '',
                itemsPerPageSelected: 25
            };
            getAllSharedGroupedPackage(0, vm.itemsPerPageGot, vm.filterData, true);
        }

        function applyFilter(){
            vm.getAllSharedGroupedPackage(0, vm.filterData.itemsPerPageSelected, vm.filterData, true);
        }
    }

})();
/**
 * Created by cl-macmini-51 on 4/14/17.
 */
 (function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('SelfAssignmentEditController', SelfAssignmentEditController);

    /** @ngInject */
    function SelfAssignmentEditController($cookies, $state, $log, $stateParams, $scope, $mdDialog, $timeout, languageBasedErrorFactory, errorMessageFactory, selfAssignmentEditService) {
        var vm = this;
        console.log('edit');
     
        vm.mapLoadsFlag = false;
        vm.ismeridian = true;
        vm.socketHandleMarker = false;
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        // vm.datePickerE_3 = datePickerE_3;
        vm.loading = false;
        vm.parametersData = {};
        console.log(vm.parametersData)
        vm.showValue = true;
        vm.changeValues = changeValues;
        vm.addGlobalParamsFun = addGlobalParamsFun;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.approvalValueChanged = approvalValueChanged;
        vm.addInstance = addInstance;
        vm.saveBlock = saveBlock;
        vm.saveInstance = saveInstance;
        vm.isError = false;
        vm.isAdd = false;
        vm.isTouched = false;
        vm.blocks = [];
        vm.zones = [];
        vm.selectedZones = [];
        vm.blocksUpdate = [];
        vm.searchZoneData = [];
        vm.selectingZones = selectingZones;
        vm.dataForBlock = {
            instancia_id: '',
            dia: '',
            fecha_inicio: {
                hora: '00',
                minute: '00'
            },
            fecha_fin: {
                hora: '00',
                minute: '15'
            },
        };

        // vm.dataForInstance = {
        //     access_token : '',
        //     nombre: '',
        //     params: '',
        //     booking_type: 1
        // };

        vm.onchange = onchange;
        vm.onblur = onblur;
        vm.id = $stateParams.id;
        console.log(vm.id)
        vm.filterDay = filterDay;
        vm.removeBlock = removeBlock;
        vm.array = [];
        vm.cancel = cancel;
        vm.filterInstanceEdit = filterInstanceEdit;
        vm.type_id = '';
        vm.typeId = '';
        vm.eliminable = 0;

        
        $scope.daysArray = [
            {id: "1", nombre: 'Lunes'},
            {id: "2", nombre: 'Martes'},
            {id: "3", nombre: 'Miércoles'},
            {id: "4", nombre: 'Jueves'},
            {id: "5", nombre: 'Viernes'},
            {id: "6", nombre: 'Sábado'},
            {id: "7", nombre: 'Domingo'},
        ];
        
        $scope.diaSeleccionado = {id: "", nombre: ''};

        vm.hoursArray = [{
            value: 0,
            id: '00'
        },
        {
            value: 1,
            id: '01'
        },
        {
            value: 2,
            id: '02'
        },
        {
            value: 3,
            id: '03'
        },
        {
            value: 4,
            id: '04'
        },
        {
            value: 5,
            id: '05'
        },
        {
            value: 6,
            id: '06'
        },
        {
            value: 7,
            id: '07'
        },
        {
            value: 8,
            id: '08'
        },
        {
            value: 9,
            id: '09'
        },
        {
            value: 10,
            id: '10'
        },
        {
            value: 11,
            id: '11'
        },
        {
            value: 12,
            id: '12'
        },
        {
            value: 13,
            id: '13'
        },
        {
            value: 14,
            id: '14'
        },
        {
            value: 15,
            id: '15'
        },
        {
            value: 16,
            id: '16'
        },
        {
            value: 17,
            id: '17'
        },
        {
            value: 18,
            id: '18'
        },
        {
            value: 19,
            id: '19'
        },
        {
            value: 20,
            id: '20'
        },
        {
            value: 21,
            id: '21'
        },
        {
            value: 22,
            id: '22'
        },
        {
            value: 23,
            id: '23'
        }
    ]


    vm.minutesArray = [{
        value: 0,
        id: '00'
    },
    {
        value: 1,
        id: '15'
    },
    {
        value: 2,
        id: '30'
    },
    {
        value: 3,
        id: '45'
    },
]

function cancel() {
    $state.go('layout.selfAssignmentMain.selfAssignment', {
        typeSelected:vm.typeId
    });

}


    getZoneData();
    $timeout(function(){
        getDetails();
    }, 1000);
        
function getDetails() {
    vm.loading = true;
    //var dataSend = {};
    //dataSend.access_token = $cookies.get('obj');
    //dataSend.instance_id = Number(vm.id);
    var promise = selfAssignmentEditService.getDetailUpdate(Number(vm.id));
    promise.then(function (payload) {
        // console.log('kk---------', payload);
        vm.loading = false;
        vm.type_id = payload.title.data.tbBookingTypeId;
        vm.typeId = payload.title.data.bookingTypes.typeId;
        vm.eliminable = payload.title.data.eliminable;
        vm.sucursal = (payload.title.data.sucursal) ? payload.title.data.sucursal.regionName : '';
        vm.parametersData = payload.title.data.params;
        $scope.dataForInstance.nombre = payload.title.data.nombre;
      
    
        for (var i = 0; i < vm.parametersData.length; i++) {
            vm.array[vm.parametersData[i].id] = Number(vm.parametersData[i].value);
        }

        vm.selectedZones = payload.title.data.zones.filter(function(i) {
            if(!i.autoAssignRegions){ 
                return;
            } 
            //else {
                //delete i.autoAssignRegions.regions;
            //}
            return i.autoAssignRegions;
        });
        vm.searchZoneData = vm.selectedZones;


        for (var i = 0; i < payload.title.data.blocks.length; i++) {
            vm.blocksUpdate.push({ 
                id: payload.title.data.blocks[i].id.toString(),
                dia: payload.title.data.blocks[i].dia.toString(),
                hora_inicio:{
                    hora:payload.title.data.blocks[i].horaDesde.slice(0,2),
                    minute:payload.title.data.blocks[i].horaDesde.slice(3,5)
                },
                hora_fin: {
                    hora:payload.title.data.blocks[i].horaHasta.slice(0,2),
                    minute:payload.title.data.blocks[i].horaHasta.slice(3,5)
                },
            })
        }

    }, function (errorPayload) {
            $log.log(errorPayload);
            vm.loading = false;
            if (errorPayload.data.status == 401) {
                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
            } else {
                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
            }
        }
    );
}





        function onchange(e) {
            if(!e) return;
            if(e.length > 0) {
                vm.isError = false;
            }
        }


        function onblur(e) {
            vm.isTouched = true
            // $e.onBlur = function($event) {
            //     console.log($event);
            // }
            console.log(e)
            // if(e.length > 0) {
            //     vm.isError = false;
            // }
        }



        function addInstance() {
            vm.isAdd = !vm.isAdd;
        }


        function saveBlock(data) {
            for (var i = 0; i < vm.blocksUpdate.length; i++) {
                if(vm.blocksUpdate[i].dia == data.dia){
                    if([vm.blocksUpdate[i].hora_fin.hora, ':', vm.blocksUpdate[i].hora_fin.minute].join('') > [data.fecha_inicio.hora, ':', data.fecha_inicio.minute].join('') && [vm.blocksUpdate[i].hora_inicio.hora, ':', vm.blocksUpdate[i].hora_inicio.minute].join('') < [data.fecha_fin.hora, ':', data.fecha_fin.minute].join('')) {
                        errorMessageFactory.showErrorMessage('Ya existe un bloque horario creado entre ese rango horas.', 0);
                        return;
                    }
                }

            }

            if(!data.dia || !data.fecha_inicio.hora || !data.fecha_inicio.minute || !data.fecha_fin.hora || !data.fecha_fin.minute) {
              errorMessageFactory.showErrorMessage('Todos los campos son obligatorios.', 0);
              return;
            }
            if(data.fecha_inicio.hora >= data.fecha_fin.hora) {
                if(data.fecha_inicio.minute >= data.fecha_fin.minute ){
                    errorMessageFactory.showErrorMessage('La hora de inicio debe ser superior a la hora de termino.', 0);
                    return;
                }
              }
            vm.addInstance();
            var dataSend = {
                dia: data.dia,
                hora_inicio:{
                    hora: data.fecha_inicio.hora,
                    minute: data.fecha_inicio.minute
                },
                hora_fin:{
                    hora: data.fecha_fin.hora,
                    minute: data.fecha_fin.minute
                }
            };
    
            vm.blocksUpdate.push(dataSend);
            vm.dataForBlock = {
                instancia_id: '',
                dia: '',
                fecha_inicio: {
                    hora: '',
                    minute: ''
                },
                fecha_fin: {
                    hora: '',
                    minute: ''
                },
            };
        }


        function removeBlock(value) {
            var index = vm.blocksUpdate.indexOf(value);
            vm.blocksUpdate.splice(index, 1); 
        }
 


        function filterDay(day) {
            var dia = '';
            if(day == '1') dia = 'Lunes'
            else if(day == '2') dia = 'Martes'
            else if(day == '3') dia = 'Miércoles'
            else if(day == '4') dia = 'Jueves'
            else if(day == '5') dia = 'Viernes'
            else if(day == '6') dia = 'Sábado'
            else if(day == '7') dia = 'Domingo'

            return dia;
        }

        function filterInstanceEdit(i) {
            var title = 'Exclusivos';
            if(i == '1') title = 'Exclusivos'
            else if(i == '2') title = 'Compartidos'
            else if(i == '3') title = 'Agrupados'
            return title;
        }

        function saveInstance(e) {
            console.log(e.target.value)
            console.log(vm.dataForInstance)
            console.log(vm.parametersData)
        }

        $scope.dataForInstance = {
            params: vm.array
        };

        $scope.isTest = false;
        vm.prioridadOptions = [
            { name: 'Sin Prioridad', value: 0 },
            { name: 'Prioridad Leasing', value: 1 }
        ];

        $scope.guardar_datos = function(formInstance, e) {
            vm.obj = [];
            vm.obj2 = [];
            vm.obj3 = [];

            if(!formInstance.nombre.$valid) {
                vm.isError = true;
            }
            if(!formInstance.$valid) {
                return;
            }

            if(vm.blocksUpdate.length < 1 && vm.eliminable) {
                errorMessageFactory.showErrorMessage('Debe agregar un bloque horario', 0);
                return;
            }

            if(vm.searchZoneData.length < 1 && vm.eliminable) {
                errorMessageFactory.showErrorMessage('Debe agregar a lo menos una zona', 0);
                return;
            }
            $scope.dataForInstance.params.forEach( function(instance, index){
                vm.obj.push({ id:index, value: instance}) 
            });

            for (var i = 0; i < vm.blocksUpdate.length; i++) {
                if(vm.blocksUpdate[i].id) {
                    vm.obj2.push({id:Number(vm.blocksUpdate[i].id), dia:Number(vm.blocksUpdate[i].dia), horaDesde:vm.blocksUpdate[i].hora_inicio.hora + ':' + vm.blocksUpdate[i].hora_inicio.minute, horaHasta:vm.blocksUpdate[i].hora_fin.hora + ':' + vm.blocksUpdate[i].hora_fin.minute})
                }else {
                    vm.obj2.push({dia:Number(vm.blocksUpdate[i].dia), horaDesde:vm.blocksUpdate[i].hora_inicio.hora + ':' + vm.blocksUpdate[i].hora_inicio.minute, horaHasta:vm.blocksUpdate[i].hora_fin.hora + ':' + vm.blocksUpdate[i].hora_fin.minute})
                }   
            }

            for (var i = 0; i < vm.searchZoneData.length; i++) {
                if(vm.searchZoneData[i].autoAssignInstancesId){
                    vm.obj3.push({ id: vm.searchZoneData[i].id, autoAssignmentRegionId: vm.searchZoneData[i].autoAssignmentRegionId, autoAssignInstancesId: vm.searchZoneData[i].autoAssignInstancesId, regionName: vm.searchZoneData[i].regionName })
                } else {
                    vm.obj3.push({ autoAssignmentRegionId: vm.searchZoneData[i].id, autoAssignInstancesId:Number(vm.id), regionName: vm.searchZoneData[i].regionName })
                }
            }

            vm.loading = true;
            var toSend = {};
            toSend.access_token = $cookies.get('obj');
            toSend.nombre = $scope.dataForInstance.nombre;
            toSend.tbBookingTypeId = vm.type_id;
            //toSend.instance_id = Number(vm.id);
            toSend.params = vm.obj;
            toSend.blocks = vm.obj2;
            toSend.zones = vm.obj3;


            var promise = selfAssignmentEditService.updateInstance(Number(vm.id), toSend);
            promise.then(function (payload) {
                console.log('sxdsads', payload)
                vm.loading = false;
                if (payload.title.status == 210) {
                    //var msgErrorOverInstance = payload.title.message;
                    var msgErrorOverInstance = "";
                    for(var i=0; i<payload.title.data.length; i++ ){
                        msgErrorOverInstance += '\n';
                        msgErrorOverInstance += 'Sucursal: '+ payload.title.data[i].sucursal;
                        msgErrorOverInstance += '   ';
                        msgErrorOverInstance += 'Zona: '+ payload.title.data[i].zona;
                        msgErrorOverInstance += '   ';
                        msgErrorOverInstance += 'Nombre: '+ payload.title.data[i].nombre;
                        msgErrorOverInstance += '   ';
                        msgErrorOverInstance += payload.title.data[i].bloque;
                    }
                    activeModal(e,payload.title.message, msgErrorOverInstance)
                    // errorMessageFactory.showErrorMessage("Hello again! This is how we \n add line breaks to an alert box!", 0);
                    return [];
                } else if (payload.title.status == 401) {
                    errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    return [];
                } else if (payload.title.status == 201 || payload.title.status == 200) {
                    languageBasedErrorFactory.getProperErrorMessage('selfAssignmentInstanceEditSucc', 0, 2, 'layout.selfAssignmentMain.selfAssignment');
                    $state.go('layout.selfAssignmentMain.selfAssignment', {
                        typeSelected:vm.typeId
                    });
                }

               
            }, function (errorPayload) {
                    console.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            
            );
            vm.obj = [];
            vm.obj2 = [];
        }



        function approvalValueChanged() {
            // vm.currentPage = 0;
            // if (vm.filterData.verification_stage && vm.filterData.verification_stage != 'all') {
            //     vm.filterData.filter_verification_stage = 1;
            //     getFilterDriverHit(0, vm.itemsPerPageGot, vm.filterData);
            // } else {
            //     vm.filterData.filter_verification_stage = 0;
            //     vm.filterData.verification_stage = 'all';
            //     getFilterDriverHit(0, vm.itemsPerPageGot, vm.filterData);
            // }
        };










          //====================event for getting refreshed================
          $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.selfAssignmentMain.selfAssignment');
            }
        });


        //========================add new earning hit============================
        // function getGlobalParameters() {
        //     vm.loading = true;
        //     var toSend = {};
        //     toSend.access_token = $cookies.get('obj');
        //     //toSend.booking_status = 4;
        //     var promise = selfAssignmentEditService.getGlobalParams(toSend);
        //     promise.then(
        //         function (payload) {
        //             $log.log('sxdsads', payload);
        //             vm.loading = false;
        //             vm.parametersData = payload.title.data;
        //         },
        //         function (errorPayload) {
        //             vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // };
        // getGlobalParameters();



        function changeValues(index) {
            vm.parametersData[index].showValue = !vm.parametersData[index].showValue;
        }





        //==========================edit earning hit===========================
        function addGlobalParamsFun(data, id) {  
            if(data.type == 'CONTACT_EMAIL'){
                var re = /^([_a-zA-Z0-9-+]+)(\.[_a-zA-Z0-9-+]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*\.)+([a-zA-Z]{2,3})$/;
                if(re.test(data.value) == false){
                    errorMessageFactory.showErrorMessage('Favor ingrese un Email válido', 0);
                    return true;
                }
                // return re.test(data.value);
            }
            if(data.value == '' || data.value == null || data.value == undefined){
                return true;
            }
            if (id == 7 && data < 1) {
                errorMessageFactory.showErrorMessage('El valor debe ser mayor que cero', 0);
                return false;
            }
            if(data.type == 'POPUP_HEADER' || data.type == 'POPUP_MESSAGE' || data.type == 'POPUP_TIME') {
                if(data.value.length > 100){
                    errorMessageFactory.showErrorMessage('los personajes deben ser menos de 100', 0);
                    return false;
                }
            }
            if(data.type == 'POPUP_ADDRESS'){
                if(data.value.length > 150){
                    errorMessageFactory.showErrorMessage('los personajes deben ser menos de 150', 0);
                    return false;
                }
            }
            if(data.type == 'ALERT_EMAIL'){
                var dataAraay = data.value;
                dataAraay = dataAraay.split(";");
                if(dataAraay.length > 5){
                    return;
                }
            }
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.id = Number(id);
            ///////////// TICKET  TV-1971 //////////////////////// 
            if (data.is_text == 0) {
                dataSend.at_position_parameter = Number(data.value);
            } else {
                dataSend.is_text = data.is_text;
                dataSend.text = (data.value);
            }
            ///////////// TICKET  TV-1971 //////////////////////// 
            vm.loading = true;
            var promise = selfAssignmentEditService.addGlobalParams(dataSend);
            promise.then(
                function (payload) {
                    console.log(payload);
                    vm.loading = false;
                    $log.log('sxdsads', payload);
                    if (payload.title.status == 200) {
                        languageBasedErrorFactory.getProperErrorMessage('parameterSucc', 0, 1, 'layout.globalParametersMain.globalParameters');
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }


                    //errorMessageFactory.showErrorMessage('Parameter updated.',1);
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        function activeModal(e,titulo, contenido) {
            var confirm = $mdDialog.confirm()
            .title(titulo)
            .textContent(contenido)
            .ariaLabel('Lucky day')
            .targetEvent(e)
            .ok('Entendido')
    
            $mdDialog.show(confirm).then(function () {
    
            }, function () {
                console.log('unblock');
            });
        }

        function getZoneData(){
            //return vm.allCustomersList;
            //var dataSend = {};
            //dataSend.access_token = $cookies.get('obj');
            //dataSend.nombre = nombre;
            var promise = selfAssignmentEditService.getAutoassignRegions();
            return promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        vm.zones = [];
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        vm.zones = [];
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (payload.title.data.length > 0) {
                            vm.zones = payload.title.data;
                        } else {
                            vm.flagforError = true;
                            vm.zones = [];
                        }
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        //errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        }

        function selectingZones(data, evento){
            if(evento == 'select'){
                vm.searchZoneData = data;
            } else {
                vm.searchZoneData = data;
            }
        }

        $scope.restrictDecimals = function(event, data) {
            var keyCode = event.which ? event.which : event.keyCode;
            var inputValue = event.target.value;
            var decimalSeparator = '.';
            var maxDecimals = 3

            if( data.displayName == 'Radio Inicial' || data.displayName == 'Radio máximo de búsqueda' || data.displayName == 'Incremento de radio por iteración'  ){
                // Verificar si se presionó el punto decimal
                if (keyCode === 46 || keyCode === 44 || keyCode === 110 || keyCode === 188) {
                    // Verificar si ya hay un punto decimal en el valor actual
                    if (inputValue.indexOf(decimalSeparator) !== -1) {
                        event.preventDefault();
                    }
                } else if (keyCode >= 48 && keyCode <= 57) {
                    // Verificar si el valor actual ya tiene el máximo de decimales permitidos
                    var decimalIndex = inputValue.indexOf(decimalSeparator);
                    if (decimalIndex !== -1 && inputValue.length - decimalIndex > maxDecimals) {
                        event.preventDefault();
                    }
                } else {
                // Ignorar otros caracteres no numéricos
                    event.preventDefault();
                }
                
            } else {
                if (keyCode === 46 || keyCode === 44 || keyCode === 110 || keyCode === 188) {
                    event.preventDefault();
                }
            }
        };

        vm.isZoneSelected = function(z) {
            for (var i = 0; i < vm.selectedZones.length; i++) {
                if(!vm.selectedZones[i].autoAssignRegions || !vm.selectedZones[i].autoAssignRegions.id){
                    return false;
                }
                else if (vm.selectedZones[i].autoAssignRegions.id === z.id) {
                    return true;
                }
            }
            return false;
        };

        $scope.filterZones = function (zone) {
            return !vm.isZoneSelected(zone);
        };

    }

})();

/**
 * Created by cl-macmini-51 on 4/14/17.
 */
 (function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('SelfAssignmentDetailsController', SelfAssignmentDetailsController);

    /** @ngInject */
    function SelfAssignmentDetailsController($cookies, $state, $log, $http, MY_CONSTANT, $timeout, $stateParams, $rootScope, $interval, $scope, mapDashboard, getDrivers, getVehicles, getServices, getAgreement, getGeofence, $mdDialog, $document, getCars, adminAccessService, $filter, selfAssignmentDetailsService, languageBasedErrorFactory, errorMessageFactory, getFilters, Initializer) {
        var vm = this;
        vm.count = 0;
        // vm.applyFilter = applyFilter;
        // vm.colorFlag = false;
        vm.colorFlag = [];
        // vm.resetFilter = resetFilter;
        vm.mapLoadsFlag = false;
        vm.ismeridian = true;
        vm.socketHandleMarker = false;
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.id = $stateParams.id;
        vm.nombre_instancia;
        vm.eliminable;
        vm.booking_type = "";
        vm.parametros = [];
        vm.horarios = [];
        vm.payload = {};
        vm.cancel = cancel;
        vm.instanceDelete = deleteInstance;
        vm.cancel = cancel;
        vm.type_id = 0;

        getDetails();
        
        function getDetails() {
            vm.loading = true;
            //var dataSend = {};
            //dataSend.access_token = $cookies.get('obj');
            //dataSend.instance_id = Number(vm.id);
            var promise = selfAssignmentDetailsService.getDetails(Number(vm.id));
            promise.then(function (payload) {
                $log.log('sxdsads', payload);

                vm.loading = false;
                vm.payload = payload.title.data;
                vm.nombre_instancia = payload.title.data.nombre;
                vm.eliminable = payload.title.data.eliminable;
                vm.sucursal = (payload.title.data.sucursal) ? payload.title.data.sucursal.regionName : '';
                vm.parametros = payload.title.data.params;
                vm.horarios = payload.title.data.blocks;
                vm.type_id = payload.title.data.bookingTypes.typeId;
                vm.booking_type = vm.type_id == 0 ? 'Exclusivos' : vm.type_id == 1 ? 'Compartidos' : "Agrupados";
                vm.selectedZones = payload.title.data.zones.filter(function(i) {
                    if(!i.autoAssignRegions){ 
                        return;
                    } 
                    //else {
                        //delete i.autoAssignRegions.regions;
                    //}
                    return i.autoAssignRegions;
                });
                vm.searchZoneData = vm.selectedZones;

            }, function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }


        function cancel() {
            $state.go('layout.selfAssignmentMain.selfAssignment', {
                typeSelected:vm.type_id
            });

        }


        function deleteInstance(data,$event) {

            var toSend = {};
            toSend.access_token = $cookies.get('obj');
            toSend.instance_id = data.id;

                vm.loading = false;

                $state.go('layout.selfAssignmentMain.selfAssignmentDelete', {
                    id: data.id,
                    event: $event,
                    refresh: false,
                    data:data,
                    serviceSelected: data.type_id 
                });

         
        }





    }

})();

/**
 * Created by cl-macmini-51 on 4/14/17.
 */
 (function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('SelfAssignmentCreateController', SelfAssignmentCreateController);

    /** @ngInject */
    function SelfAssignmentCreateController($cookies, $state, $log, $http, $stateParams,MY_CONSTANT, $timeout, $rootScope, $interval, $scope, mapDashboard, getDrivers, getVehicles, getServices, getAgreement, getGeofence, $mdDialog, $document, getCars, $filter,languageBasedErrorFactory, errorMessageFactory, getFilters, Initializer, selfAssignmentCreateService) {
        var vm = this;
        console.log('create');
     
        vm.mapLoadsFlag = false;
        vm.ismeridian = true;
        vm.socketHandleMarker = false;
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        // vm.datePickerE_3 = datePickerE_3;
        vm.loading = false;
        vm.parametersData = {};
        console.log($rootScope)
        vm.showValue = true;
        vm.changeValues = changeValues;
        vm.addGlobalParamsFun = addGlobalParamsFun;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.approvalValueChanged = approvalValueChanged;
        vm.addInstance = addInstance;
        vm.saveBlock = saveBlock;
        vm.saveInstance = saveInstance;
        vm.nombreZona = buscarZoneNombre;
        vm.onSelectingZone = onSelectingZone;
        vm.onRemoveZone = onRemoveZone;
        vm.isError = false;
        vm.flagforError = false;
        vm.listaZonas = [];
        vm.isAdd = false;
        vm.isTouched = false;
        vm.blocks = [];
        vm.zones = [];
        vm.selectedZones = [];
        vm.searchZoneData = [];
        vm.zoneSearch = zoneSearch;
        vm.selectingZones = selectingZones;
        vm.dataForBlock = {
            instancia_id: '',
            dia: '',
            fecha_inicio: {
                hora: '00',
                minute: '00'
            },
            fecha_fin: {
                hora: '00',
                minute: '15'
            },
        };

        // vm.dataForInstance = {
        //     access_token : '',
        //     nombre: '',
        //     params: '',
        //     booking_type: 1
        // };

        vm.onchange = onchange;
        vm.onblur = onblur;
        vm.id = $stateParams.id;
        vm.filterDay = filterDay;
        vm.filterInstance = filterInstance;
        vm.removeBlock = removeBlock;
        vm.cancel = cancel;

        
        $scope.daysArray = [
            {id: "1", nombre: 'Lunes'},
            {id: "2", nombre: 'Martes'},
            {id: "3", nombre: 'Miércoles'},
            {id: "4", nombre: 'Jueves'},
            {id: "5", nombre: 'Viernes'},
            {id: "6", nombre: 'Sábado'},
            {id: "7", nombre: 'Domingo'},
        ];
        
        $scope.diaSeleccionado = {id: "", nombre: ''};

        vm.hoursArray = [{
            value: 0,
            id: '00'
        },
        {
            value: 1,
            id: '01'
        },
        {
            value: 2,
            id: '02'
        },
        {
            value: 3,
            id: '03'
        },
        {
            value: 4,
            id: '04'
        },
        {
            value: 5,
            id: '05'
        },
        {
            value: 6,
            id: '06'
        },
        {
            value: 7,
            id: '07'
        },
        {
            value: 8,
            id: '08'
        },
        {
            value: 9,
            id: '09'
        },
        {
            value: 10,
            id: '10'
        },
        {
            value: 11,
            id: '11'
        },
        {
            value: 12,
            id: '12'
        },
        {
            value: 13,
            id: '13'
        },
        {
            value: 14,
            id: '14'
        },
        {
            value: 15,
            id: '15'
        },
        {
            value: 16,
            id: '16'
        },
        {
            value: 17,
            id: '17'
        },
        {
            value: 18,
            id: '18'
        },
        {
            value: 19,
            id: '19'
        },
        {
            value: 20,
            id: '20'
        },
        {
            value: 21,
            id: '21'
        },
        {
            value: 22,
            id: '22'
        },
        {
            value: 23,
            id: '23'
        }
    ]


    vm.minutesArray = [{
        value: 0,
        id: '00'
    },
    {
        value: 1,
        id: '15'
    },
    {
        value: 2,
        id: '30'
    },
    {
        value: 3,
        id: '45'
    },
    ]

    vm.prioridadOptions = [
        { name: 'Sin Prioridad', value: 0 },
        { name: 'Prioridad Leasing', value: 1 }
    ];


        function cancel() {
            $state.go('layout.selfAssignmentMain.selfAssignment', {
                typeSelected:vm.id
            });
        }


        function onchange(e) {
            if(!e) return;
            if(e.length > 0) {
                vm.isError = false;
            }
        }


        function onblur(e) {
            vm.isTouched = true
            // $e.onBlur = function($event) {
            //     console.log($event);
            // }
            console.log(e)
            // if(e.length > 0) {
            //     vm.isError = false;
            // }
        }



        function addInstance() {
            vm.isAdd = !vm.isAdd;
        }


        function saveBlock(data) {
         
            for (var i = 0; i < vm.blocks.length; i++) {
                if(vm.blocks[i].dia == data.dia){
                    if(vm.blocks[i].hora_fin > [data.fecha_inicio.hora, ':', data.fecha_inicio.minute].join('') && vm.blocks[i].hora_inicio < [data.fecha_fin.hora, ':', data.fecha_fin.minute].join('')) {
                        errorMessageFactory.showErrorMessage('Ya existe un bloque horario creado entre ese rango horas.', 0);
                        return;
                    }
                }

            }
            

            if(!data.dia || !data.fecha_inicio.hora || !data.fecha_inicio.minute || !data.fecha_fin.hora || !data.fecha_fin.minute) {
              errorMessageFactory.showErrorMessage('Todos los campos son obligatorios.', 0);
              return;
            }
            if(data.fecha_inicio.hora >= data.fecha_fin.hora) {
                if(data.fecha_inicio.minute >= data.fecha_fin.minute ){
                    errorMessageFactory.showErrorMessage('La hora de inicio debe ser superior a la hora de termino.', 0);
                    return;
                }
              }
            vm.addInstance();
            var dataSend = {
                dia: Number(data.dia),
                hora_inicio:data.fecha_inicio.hora ? data.fecha_inicio.hora + ':' + data.fecha_inicio.minute : '',
                hora_fin: data.fecha_fin.hora ? data.fecha_fin.hora + ':' + data.fecha_fin.minute : '',
            };
    
            vm.blocks.push(dataSend);
            vm.dataForBlock = {
                instancia_id: '',
                dia: '',
                fecha_inicio: {
                    hora: '',
                    minute: ''
                },
                fecha_fin: {
                    hora: '',
                    minute: ''
                },
            };
        }


        function removeBlock(value) {
            var index = vm.blocks.indexOf(value);
            vm.blocks.splice(index, 1); 
        }
 


        function filterDay(day) {
            var dia = '';
            if(day == '1') dia = 'Lunes'
            else if(day == '2') dia = 'Martes'
            else if(day == '3') dia = 'Miércoles'
            else if(day == '4') dia = 'Jueves'
            else if(day == '5') dia = 'Viernes'
            else if(day == '6') dia = 'Sábado'
            else if(day == '7') dia = 'Domingo'

            return dia;
        }

        function filterInstance(i) {
            var title = '0';
            if(i == '0') title = 'Exclusivos'
            else if(i == '1') title = 'Compartidos'
            else if(i == '2') title = 'Agrupados'
            return title;
        }

        function saveInstance(e) {
            console.log(e.target.value)
            console.log(vm.dataForInstance)
            console.log(vm.parametersData)
        }

        //$scope.dataForInstance = {
            //params: [0,0,0,0,0,0,0,0,0,0]
        //};

        $scope.dataForInstance = {
            params: {}
        };
        
        $scope.isTest = false;

        $scope.guardar_datos = function(formInstance,e) {
            if(!formInstance.nombre.$valid) {
                vm.isError = true;
            }
            if(!formInstance.$valid) {
                return;
            }
            
            if(vm.blocks.length < 1) {
                errorMessageFactory.showErrorMessage('Debe agregar un bloque horario', 0);
                return;
            }

            if(vm.searchZoneData.length < 1) {
                errorMessageFactory.showErrorMessage('Debe agregar a lo menos una zona', 0);
                return;
            }
            vm.obj = [];
            vm.obj2 = [];
            vm.obj3 = [];

            for (var i = 0; i < Object.keys($scope.dataForInstance.params).length; i++) {
                var key = parseInt(Object.keys($scope.dataForInstance.params)[i]);
                vm.obj.push({ autoAssignParamsId: key, value: $scope.dataForInstance.params[key] });
            }

            for (var i = 0; i < vm.blocks.length; i++) {
                vm.obj2.push({ dia:vm.blocks[i].dia, horaDesde:vm.blocks[i].hora_inicio, horaHasta:vm.blocks[i].hora_fin })
            }

            for (var i = 0; i < vm.searchZoneData.length; i++) {
                vm.obj3.push({ autoAssignmentRegionId: vm.searchZoneData[i].id, regionName: vm.searchZoneData[i].regionName })
            }

            vm.loading = true;
            var toSend = {};
            toSend.access_token = $cookies.get('obj');
            toSend.nombre = $scope.dataForInstance.nombre;
            toSend.bookingTypes = { typeId: Number(vm.id) };
            toSend.params = vm.obj;
            toSend.blocks = vm.obj2;
            toSend.zones = vm.obj3;

            var promise = selfAssignmentCreateService.addInstance(toSend);
            promise.then(function (payload) {
                $log.log('sxdsads', payload);
                console.log('sxdsads', payload)
                vm.loading = false;
                
                if (payload.title.status == 210) {
                    //var msgErrorOverInstance = payload.title.message;
                    var msgErrorOverInstance = "";
                    for(var i=0; i<payload.title.data.length; i++ ){
                        msgErrorOverInstance += '\n';
                        msgErrorOverInstance += 'Sucursal: '+ payload.title.data[i].sucursal;
                        msgErrorOverInstance += '   ';
                        msgErrorOverInstance += 'Zona: '+ payload.title.data[i].zona;
                        msgErrorOverInstance += '   ';
                        msgErrorOverInstance += 'Nombre: '+ payload.title.data[i].nombre;
                        msgErrorOverInstance += '   ';
                        msgErrorOverInstance += payload.title.data[i].bloque;
                    }
                    activeModal(e,payload.title.message, msgErrorOverInstance)
                    // errorMessageFactory.showErrorMessage("Hello again! This is how we \n add line breaks to an alert box!", 0);
                    return [];
                } else if (payload.title.status == 401) {
                    errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    return [];
                }else if(payload.title.status == 201){
                    errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    return [];
                }
                else if (payload.title.status == 200) {
                    languageBasedErrorFactory.getProperErrorMessage('selfAssignmentInstanceCreateSucc', 0, 2, 'layout.selfAssignmentMain.selfAssignment');
                    $state.go('layout.selfAssignmentMain.selfAssignment', {
                        typeSelected:vm.id
                    });
                }
                //$state.go('layout.selfAssignmentMain.selfAssignment');
               
            }, function (errorPayload) {
                    console.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }

            
            );
            vm.obj = [];
            vm.obj2 = [];
        }


        function approvalValueChanged() {
            // vm.currentPage = 0;
            // if (vm.filterData.verification_stage && vm.filterData.verification_stage != 'all') {
            //     vm.filterData.filter_verification_stage = 1;
            //     getFilterDriverHit(0, vm.itemsPerPageGot, vm.filterData);
            // } else {
            //     vm.filterData.filter_verification_stage = 0;
            //     vm.filterData.verification_stage = 'all';
            //     getFilterDriverHit(0, vm.itemsPerPageGot, vm.filterData);
            // }
        };






        function activeModal(e,titulo, contenido) {
            var confirm = $mdDialog.confirm()
            .title(titulo)
            .textContent(contenido)
            .ariaLabel('Lucky day')
            .targetEvent(e)
            .ok('Entendido')
    
        $mdDialog.show(confirm).then(function () {
    
        }, function () {
            console.log('unblock');
        });

        }










          //====================event for getting refreshed================
          $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.selfAssignmentMain.selfAssignment');
            }
        });


        //========================add new earning hit============================
        function getGlobalParameters() {
            vm.loading = true;
            var toSend = {};
            toSend.access_token = $cookies.get('obj');
            //toSend.booking_status = 4;
            var promise = selfAssignmentCreateService.getGlobalParams(toSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.parametersData = payload.title.data;
                    angular.forEach(vm.parametersData, function(data) {
                        //if (data.param == 'TYPE_DRIVER_ORDER') {
                            $scope.dataForInstance.params[data.id] = 0;
                        //}
                    });
                    console.log('$scope.dataForInstance.params inicializado:', $scope.dataForInstance.params);
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getGlobalParameters();



        function changeValues(index) {
            vm.parametersData[index].showValue = !vm.parametersData[index].showValue;
        }





        //==========================edit earning hit===========================
        function addGlobalParamsFun(data, id) {
            if(data.type == 'CONTACT_EMAIL'){
                var re = /^([_a-zA-Z0-9-+]+)(\.[_a-zA-Z0-9-+]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*\.)+([a-zA-Z]{2,3})$/;
                if(re.test(data.value) == false){
                    errorMessageFactory.showErrorMessage('Favor ingrese un Email válido', 0);
                    return true;
                }
                // return re.test(data.value);
            }
            if(data.value == '' || data.value == null || data.value == undefined){
                return true;
            }
            if (id == 7 && data < 1) {
                errorMessageFactory.showErrorMessage('El valor debe ser mayor que cero', 0);
                return false;
            }
            if(data.type == 'POPUP_HEADER' || data.type == 'POPUP_MESSAGE' || data.type == 'POPUP_TIME') {
                if(data.value.length > 100){
                    errorMessageFactory.showErrorMessage('los personajes deben ser menos de 100', 0);
                    return false;
                }
            }
            if(data.type == 'POPUP_ADDRESS'){
                if(data.value.length > 150){
                    errorMessageFactory.showErrorMessage('los personajes deben ser menos de 150', 0);
                    return false;
                }
            }
            if(data.type == 'ALERT_EMAIL'){
                var dataAraay = data.value;
                dataAraay = dataAraay.split(";");
                if(dataAraay.length > 5){
                    return;
                }
            }
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.id = Number(id);
            ///////////// TICKET  TV-1971 //////////////////////// 
            if (data.is_text == 0) {
                dataSend.at_position_parameter = Number(data.value);
            } else {
                dataSend.is_text = data.is_text;
                dataSend.text = (data.value);
            }
            ///////////// TICKET  TV-1971 //////////////////////// 
            vm.loading = true;
            var promise = selfAssignmentCreateService.addGlobalParams(dataSend);
            promise.then(
                function (payload) {
                    console.log(payload);
                    vm.loading = false;
                    $log.log('sxdsads', payload);
                    if (payload.title.status == 200) {
                        languageBasedErrorFactory.getProperErrorMessage('parameterSucc', 0, 1, 'layout.globalParametersMain.globalParameters');
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }


                    //errorMessageFactory.showErrorMessage('Parameter updated.',1);
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        function buscarZoneNombre(nombre){
            console.log(nombre);
            if (nombre && nombre.length > 2) {
                //return vm.allCustomersList;
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.nombre = nombre;
                var promise = getGeofence.getByNameBranchList(dataSend);
                return promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        if (payload.title.status == 400) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            return [];
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                            return [];
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            if (payload.title.data.length > 0) {
                                return payload.title.data;
                            } else {
                                vm.flagforError = true;
                                return [];
                            }
                        }

                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            //errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                        }
                    }
                );
            } else {
                return [];
            }
        }

        function onSelectingZone(data) {
            vm.flagforError = false;
            if ((vm.listaZonas.filter(function(el){ return el.auto_assignment_region_id === data.auto_assignment_region_id })).length == 0) {
                vm.listaZonas.push(data);
            }
            $scope.dataForInstance.nombreZona = null;

        }

        function onRemoveZone(data) {
            vm.listaZonas = vm.listaZonas.filter(function(el) { return el.auto_assignment_region_id != data.auto_assignment_region_id; }); 
        }

        function zoneSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchZoneData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(1, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 1);
                }, 2000);
            }
        }

        function selectingZones(data, evento){
            if(evento == 'select'){
                vm.searchZoneData = data;
            } else {
                vm.searchZoneData = data;
            }
        }


        function getZoneData(){
            //return vm.allCustomersList;
            //var dataSend = {};
            //dataSend.access_token = $cookies.get('obj');
            //dataSend.nombre = nombre;
            var promise = selfAssignmentCreateService.getAutoassignRegions();
            return promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        vm.zones = [];
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        vm.zones = [];
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (payload.title.data.length > 0) {
                            vm.zones = payload.title.data;
                        } else {
                            vm.flagforError = true;
                            vm.zones = [];
                        }
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        //errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        }

        getZoneData();

        $scope.restrictDecimals = function(event, data) {
            var keyCode = event.which ? event.which : event.keyCode;
            var inputValue = event.target.value;
            var decimalSeparator = '.';
            var maxDecimals = 3

            if( data.display_name == 'Radio Inicial' || data.display_name == 'Radio máximo de búsqueda' || data.display_name == 'Incremento de radio por iteración'  ){
                // Verificar si se presionó el punto decimal
                if (keyCode === 46 || keyCode === 44 || keyCode === 110 || keyCode === 188) {
                    // Verificar si ya hay un punto decimal en el valor actual
                    if (inputValue.indexOf(decimalSeparator) !== -1) {
                        event.preventDefault();
                    }
                } else if (keyCode >= 48 && keyCode <= 57) {
                    // Verificar si el valor actual ya tiene el máximo de decimales permitidos
                    var decimalIndex = inputValue.indexOf(decimalSeparator);
                    if (decimalIndex !== -1 && inputValue.length - decimalIndex > maxDecimals) {
                        event.preventDefault();
                    }
                } else {
                // Ignorar otros caracteres no numéricos
                    event.preventDefault();
                }
                
            } else {
                if (keyCode === 46 || keyCode === 44 || keyCode === 110 || keyCode === 188) {
                    event.preventDefault();
                }
            }
        };

    }

})();

/**
 * Created by cl-macmini-51 on 4/14/17.
 */
 (function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('SelfAssignmentController', SelfAssignmentController);

    /** @ngInject */
    function SelfAssignmentController($cookies, $state, $log, $http,$stateParams,MY_CONSTANT, $timeout, $rootScope, $interval, $scope, adminAccessService,mapDashboard, getDrivers, getVehicles, getServices, getAgreement, getGeofence, $mdDialog, $document, selfAssignmentService, $filter, getBookings, languageBasedErrorFactory, errorMessageFactory, getFilters, Initializer) {
        var vm = this;
        var markers = [];
        var mc = null;
        vm.count = 0;
        // vm.applyFilter = applyFilter;
        // vm.colorFlag = false;
        vm.colorFlag = [];
        // vm.resetFilter = resetFilter;
        var map = null;
        vm.mapLoadsFlag = false;
        vm.ismeridian = true;
        vm.socketHandleMarker = false;
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        // vm.datePickerE_3 = datePickerE_3;
        vm.block_unblock = block_unblock;
        vm.instanceDetails = instanceDetails;
        vm.serviceSelected =$stateParams.typeSelected;
        vm.selected = $stateParams.typeSelected;
        vm.servicioSeleccionado = servicioSeleccionado;
        vm.servicioSeleccionado2 = servicioSeleccionado2;
        vm.instanceEdit = instanceEdit;
        vm.instanceCreate = instanceCreate;
        vm.tipoServicios = [];
        vm.instancias = [];
        vm.loading = true;
        vm.instanceDelete = deleteInstance;

        getServices();


        function getServices(){
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            var promise = selfAssignmentService.getServicios(dataSend);
            promise.then(function (payload) {
                $log.log('sxdsads', payload);
                vm.loading = false;
                vm.tipoServicios = payload.title.data;
                 getDataInstances(vm.selected);
                servicioSeleccionado2(vm.selected)
            }, function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function getBranch() {
            vm.loading = true;
            var promise = getGeofence.branch();
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        var where = _.where(payload.title.data, {
                            parent_id: 0,
                            is_active: 1
                        });
                        vm.branchList = _.where(where, { is_active: 1 });
                        //vm.branchList = where;
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    // vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        // WHen Page refresh service take time to get data from backend
        // setTimeout(function () {
        getBranch();

        
        function instanceDetails(data) {
            //console.log(vm.filterData);
            //localStorage.setItem('searchingFilter', JSON.stringify(vm.filterData));
            $state.go('layout.selfAssignmentMain.selfAssignmentDetails', {
                id: data.id
            });
        }


        function deleteInstance(data,$event) {

            var toSend = {};
            toSend.access_token = $cookies.get('obj');
            toSend.instance_id = data.id;
                vm.loading = false;

                $state.go('layout.selfAssignmentMain.selfAssignmentDelete', {
                    id: data.id,
                    event: $event,
                    refresh:true,
                    data:data,
                    serviceSelected:vm.serviceSelected 
                });
         
        }

        function servicioSeleccionado(id){
            vm.serviceSelected = id;
            getDataInstances(id);

        }

        // servicioSeleccionado2(vm.selected)
        
        function servicioSeleccionado2(id){
            if(id > 0) {
                vm.serviceSelected = id;
                getDataInstances(id);
            }

        }

        function getDataInstances(service_id) {
            vm.loading = true;
            //var dataSend = {};
            //dataSend.access_token = $cookies.get('obj');
            //dataSend.service_type_id = service_id;
            var promise = selfAssignmentService.getExclusivos(service_id);
            promise.then(function (payload) {
                // console.log('4444444444444444444', payload);
                vm.loading = false;
                vm.instancias = payload.title.data;
            }, function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }


        function instanceEdit(data) {
            $state.go('layout.selfAssignmentMain.selfAssignmentEdit', {
                id: data.id
            });
        }

        function instanceCreate() {
            $state.go('layout.selfAssignmentMain.selfAssignmentCreate', {
                id: vm.serviceSelected
            });
        }



          //==================block_unblock function======================
          function block_unblock($event, id, value, name) {
            $log.log('block_unblock');
            var parentEl = angular.element($document.body);
            if (value == 0) {
                var msg = languageBasedErrorFactory.getProperErrorMessage('blockCustomerPop', 0, '3');
            } else if (value == 1) {
                var msg = languageBasedErrorFactory.getProperErrorMessage('unblockCustomerPop', 0, '3');
            }
            //==============dialog for confirm====================
            var confirm = $mdDialog.confirm()
                .title('¿Desea inactivar esta instancia de configuración?')
                .textContent('Nombre: ' + name)
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok('Inactivar')
                .cancel('Cancelar');

            $mdDialog.show(confirm).then(function () {
                vm.loading = true;
                var a = '';
                var msgSys = '';
                if (value == 0) {
                    value = 1
                    a = 1;
                    msgSys = 'Customer blocked.';
                } else if (value == 1) {
                    value = 0
                    a = 0;
                    msgSys = 'Customer unblocked.';
                }
                $log.log('blocked');
                vm.loading = false;
                // var promise = getCustomers.block_unblock(id, a);
                // promise.then(
                //     function (payload) {
                //         vm.loading = false;
                //         if (payload.title.status == 400) {
                //             errorMessageFactory.showErrorMessage(payload.title.message, 0);
                //         } else if (payload.title.status == 401) {
                //             errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                //         } else if (payload.title.status == 201 || payload.title.status == 200) {
                //             $log.log('block_unblock', payload);
                //             var dataForSysLogs = {
                //                 access_token: $cookies.get('obj'),
                //                 id: id,
                //                 identity: 1, // 0- driver, 1- customer , 2 -car
                //                 message: msgSys
                //             };
                //             $rootScope.systemLogsAdmin(dataForSysLogs);
                //             $state.reload('layout.customersMain.customers');
                //         }
                //     },
                //     function (errorPayload) {
                //         vm.loading = false;
                //         if (errorPayload.data.status == 401) {
                //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                //         } else {
                //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                //         }
                //     }
                // );
            }, function () {
                $log.log('unblock');
            });
        };


    }

})();

/**
 * Created by cl-macmini-51 on 4/14/17.
 */
 (function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('SelfAssignmentDeleteController', SelfAssignmentDeleteController);

    /** @ngInject */
    function SelfAssignmentDeleteController($cookies, $state, $log, $http, $stateParams,MY_CONSTANT, $timeout, $rootScope, $interval, $scope, mapDashboard, adminAccessService, getAgreement, getGeofence, $mdDialog, $document, getCars, $filter,languageBasedErrorFactory, errorMessageFactory, getFilters, Initializer, selfAssignmentService) {
        var vm = this;
        console.log('delete');
        vm.mapLoadsFlag = false;
        vm.ismeridian = true;
        vm.socketHandleMarker = false;
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.loading = false;
        vm.parametersData = {};
        vm.showValue = true;
        vm.isError = false;
        vm.isAdd = false;
        vm.isTouched = false;
        vm.blocks = [];
        vm.blocksUpdate = [];
        vm.id = $stateParams.id;
        vm.event = $stateParams.event;
        vm.refresh = $stateParams.refresh;
        vm.data = $stateParams.data;
        vm.selected = $stateParams.serviceSelected;
        vm.obj = [];
        vm.obj2 = [];
        vm.array = [];
        vm.type_id = '';
        vm.eliminable = 0;
        vm.instanceDelete = deleteInstance;
   




// function deleteInstance() {
//     var toSend = {};
//     toSend.access_token = $cookies.get('obj');
//     toSend.instance_id = vm.id;

//     console.log(toSend)

//     var promise = selfAssignmentService.deleteInstance(toSend);
//     promise.then(function (payload) {
//         console.log('lalalaal', payload)
//         vm.loading = false;
//         if (payload.title.status == 400) {
//             errorMessageFactory.showErrorMessage(payload.title.message, 0);
//             return [];
//         } else if (payload.title.status == 401) {
//             errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
//             return [];
//         } else if (payload.title.status == 201 || payload.title.status == 200) {
//             languageBasedErrorFactory.getProperErrorMessage('selfAssignmentInstanceDelSucc', 0, 2, 'layout.selfAssignmentMain.selfAssignment');
//             $state.reload('layout.selfAssignmentMain.selfAssignment');
//         }
       
//     }, function (errorPayload) {
//             console.log(errorPayload);
//             vm.loading = false;
//             if (errorPayload.data.status == 401) {
//                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
//             } else {
//                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
//             }
//         }
    
//     );
 
// }


deleteInstance(vm.event);

function deleteInstance(event) {

    if(adminAccessService.getAdminAccess().indexOf('Inactivar instancia autoasignacion') < 0){
        return;
    }

    vm.loading = true;
    var toSend = {};
    toSend.access_token = $cookies.get('obj');
    toSend.instance_id = vm.id;

    var confirm = $mdDialog.confirm()
        .title('¿Desea inactivar esta instancia de configuración?')
        .textContent('Nombre: ' + vm.data.nombre)
        .ariaLabel('Lucky day')
        .targetEvent(event)
        .ok('Inactivar')
        .cancel('Cancelar');

    $mdDialog.show(confirm).then(function () {
        // vm.loading = true;
        
        vm.loading = false;
        console.log(confirm);
   

    var promise = selfAssignmentService.deleteInstance(toSend);
    promise.then(function (payload) {
        vm.loading = false;
        if (payload.title.status == 400) {
            errorMessageFactory.showErrorMessage(payload.title.message, 0);
            return [];
        } else if (payload.title.status == 401) {
            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
            return [];
        } else if (payload.title.status == 201 || payload.title.status == 200) {
            languageBasedErrorFactory.getProperErrorMessage('selfAssignmentInstanceDelSucc', 0, 2, 'layout.selfAssignmentMain.selfAssignment');
            // $state.reload('layout.selfAssignmentMain.selfAssignment');
            $state.go('layout.selfAssignmentMain.selfAssignment', {
                typeSelected:vm.selected
            });
        }
       
    }, function (errorPayload) {
            vm.loading = false;
            if (errorPayload.data.status == 401) {
                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
            } else {
                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
            }
        }
    );

    }, function () {
        console.log('unblock');
        if(vm.refresh){
            $state.go('layout.selfAssignmentMain.selfAssignment', {
                typeSelected:vm.selected
            });
        } else {
            $state.go('layout.selfAssignmentMain.selfAssignmentDetails', {
                id: vm.data.id
            });
        }
    });
 
}





}

})();

/**
 * Created by cl-macmini-51 on 15/11/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('SearchBookingController', SearchBookingController);

    /** @ngInject */
    function SearchBookingController($cookies, $state, adminAccessService, $log, $filter, $rootScope, $mdDialog, $timeout, $document, $scope, filterFilter, getBookings, errorMessageFactory, languageBasedErrorFactory, pendingRequests, getCancelReason, getAgreement, checkDomain, getGeofence, getVehicles, getServices, quickSaleService) {
        var vm = this;
        $log.log('searchBookings');
        vm.loading = false;
        vm.currentPage = 0;
        vm.printReceiptApi = printReceiptApi;
        vm.totalSearchedBookings = 0;
        vm.openHit = false;
        vm.checkModifyStatus = checkModifyStatus;
        vm.copyTemplate = copyTemplate;
        vm.changeDateIntoSpanish = changeDateIntoSpanish;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterTextTimeout = '';
        vm.sp_pagination = false;
        vm.shiftIdStatus = $cookies.get('saleShiftId');
        vm.tBodyFlag = false;
        vm.tFootFlag = true;
        vm.filterOn = true;
        vm.skipValueFilter = 0;
        vm.dataLength = 0;

        // // Filter Tab Function
        // vm.slideData = slideData;
        // vm.datePickerE_1 = datePickerE_1;
        // vm.branchChanged = branchChanged;
        // vm.agreementChanged = agreementChanged;
        // vm.serviceChanged = serviceChanged;
        // vm.vehicleChanged = vehicleChanged;
        // //vm.pickupTimeChanged = pickupTimeChanged;
        // //vm.pickupDateChanged = pickupDateChanged;
        // vm.resetFilter = resetFilter;
        // vm.datePickerE_3 = datePickerE_3;

        // vm.altInputFormats = ['M!/d!/yyyy'];
        // vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        // vm.format = vm.formats[0];
        // vm.hstep = 1;
        // vm.mstep = 15;
        // vm.ismeridian = true;

        // vm.datePicker_1 = {
        //     pickupDate: false
        // };

        vm.getAllSearchedBookings = getAllSearchedBookings;
        vm.getPagesCount = getPagesCount;
        //vm.init = init;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.paginationNew = paginationNew;
        vm.modifyBooking = modifyBooking;
        vm.makeBookingStatusChange = makeBookingStatusChange;
        vm.getFilterBookingId = getFilterBookingId;
        vm.getPrintReceiptHeight = getPrintReceiptHeight;
        vm.makePayment = makePayment;
        vm.bookingDetails = bookingDetails;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.searchBookingField = true;
        var domain = checkDomain.getDomainName();
        if (domain != 'dev' && domain != 'test') {
            vm.searchBookingField = false;
        }
        vm.searchModel = {
            limit: 25,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
        vm.filterData = {
            limit: vm.itemsPerPageGot,
            offset: 0,
            search_field: '',
            searchBookingId: '',
            searchPackageId: '',
            searchCUD:'',
            searchOrderService:'',
            search: '',
            itemsPerPageSelected: 25
        };
        vm.searchedBookingList = [];
        // if ($cookies.get('saleShift')) {
        //     vm.showPaidButton = false;
        // } else {
        //     vm.showPaidButton = true;
        // }
        if (localStorage.getItem('searchingFilter') && localStorage.getItem('searchingFilter') != 'undefined') {
            vm.filterData = JSON.parse(localStorage.getItem('searchingFilter'));
            vm.itemsPerPageSelected = vm.filterData.itemsPerPageSelected ? vm.filterData.itemsPerPageSelected : 25;
            vm.itemsPerPageGot = vm.filterData.itemsPerPageSelected ? vm.filterData.itemsPerPageSelected : 25;
            vm.filterData.itemsPerPageSelected = vm.filterData.itemsPerPageSelected ? vm.filterData.itemsPerPageSelected : 25;
            if (vm.filterData.searchBookingId || vm.filterData.searchPackageId || vm.filterData.searchCUD || vm.filterData.searchOrderService) {
                getBookingIdResults(vm.filterData);
            } else if (vm.filterData.search) {
                // vm.getAllSearchedBookings(0, vm.filterData.itemsPerPageSelected, vm.filterData, true);
            }
        }
        //==============booking details================
        function bookingDetails(data) {
            console.log(vm.filterData);
            localStorage.setItem('searchingFilter', JSON.stringify(vm.filterData));
            $state.go('layout.searchBookingMain.searchBookingDetailsNew', {
                id: data.job_id,
                type: '3'
            });
        }

        //$scope.$on('$destroy',function(){
        //    localStorage.removeItem('upcomingFilter');
        //})

        $scope.$watchCollection('vm.filterData', function (newValue, oldValue) {
            console.log('newValue', newValue);
            console.log('oldValue', oldValue);
            localStorage.setItem('searchingFilter', JSON.stringify(newValue));
        })

        // *************** SOCKET FOR SocketStartEndShift *************
        var SocketStartEndShift = $rootScope.$on('SocketForStartEndShift', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.res && data.res.message && data.res.message.flag == true) {
                vm.showPaidButton = false;
            } else {
                vm.showPaidButton = true;
            }
            $scope.$apply();
        });
        // *************** SOCKET FOR SocketStartEndShift *************

        // *************** SOCKET FOR MARK BOOKING PAID *************
        var SocketStartEndShift = $rootScope.$on('SocketForBookingPaid', function (evt, data) {
            console.log(data, "data>>>>>>>>>>>>>>>>>>>>>>>>>");

            $log.log(evt);
            $log.log(data);
            if (data.res && data.res.message && data.res.message.flag == true) {
                vm.showPaidButton = true;
            }
            $scope.$apply();
        });
        // *************** SOCKET FOR MARK BOOKING PAID *************


        // *************** SOCKET FOR UPCOMING BOOKING *************
        var myListener = $rootScope.$on('SocketComesUpcoming', function (evt, data) {
            // console.log('>>>>>>>>>>>>>>>>>>> IN SocketComesUpcoming >>>>>>>>>>>>>>', data);
            $log.log(evt);
            $log.log(data);

            if (data && data.res && data.res.message && data.res.message.jobArray && data.res.message.jobArray.length > 0) {

                var bookingArray = data.res.message.jobArray;
                for (var i = 0; i < bookingArray.length; i++) {
                    if (data.data && (vm.filterData.searchBookingId || vm.filterData.searchPackageId || vm.filterData.searchCUD || vm.filterData.searchOrderService) && !vm.filterData.search) {
                        // console.log('>>>>>>>>>>>>>>> IN MAIN ELSE >>>>>>>>>>');
                        // getBookingIdResults(vm.filterData);

                        // ********** TO CHECK INDEX OF SOCKET JOB IN UPCOMING JOB LIST **********
                        var index = _.findIndex(vm.searchedBookingList, {
                            job_id: bookingArray[i].job_id
                        });
                        if (index > -1) {
                            // console.log('>>>>>>> IN ELSE >>>>>>>>', index, bookingArray[i]);
                            socketDate(index, bookingArray[i]);
                        }
                    }
                    break;
                }
            }
        });

        //====================get shift data for sale=====================
        function getShiftResponse() {
            console.log(vm.searchedBookingList, 'vm.searchedBookingList');

            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            var promise = quickSaleService.getShift(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.data.flag == 'FALSE') {
                        vm.showPaidButton = true;
                    } else {
                        vm.showPaidButton = false;
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        //==================socket========================
        // var myListenerShared = $rootScope.$on('SocketComesShared', function (evt, data) {
        //     $log.log(evt);
        //     $log.log(data);
        //     if (data.data && (!vm.filterData.searchBookingId && !vm.filterData.searchPackageId) && vm.filterData.search) {
        //         console.log(vm.currentPage);
        //         vm.getAllSearchedBookings(0, vm.filterData.itemsPerPageSelected, vm.filterData, false);
        //     } else if (data.data && (vm.filterData.searchBookingId || vm.filterData.searchPackageId) && !vm.filterData.search) {
        //         getBookingIdResults(vm.filterData);
        //     }
        // });


        var myListenerShared = $rootScope.$on('SocketComesShared', function (evt, data) {
            // console.log('>>>>>>>>>>>>>>>>>>> IN SocketComesShared socketEventPackageCreation >>>>>>>>>>>>>>', evt, data);
            $log.log(evt);
            $log.log(data);

            if (data.data && (vm.filterData.searchBookingId || vm.filterData.searchPackageId || vm.filterData.searchCUD || vm.filterData.searchOrderService) && !vm.filterData.search) {
                // getBookingIdResults(vm.filterData);
                if (data.res && data.res.message)
                    for (var i = 0; i < data.res.message.length; i++) {
                        var index = _.findIndex(vm.searchedBookingList, {
                            job_id: data.res.message[i].job_id
                        });
                        if (index > -1) {
                            // console.log('>>>>>>> IN ELSE >>>>>>>>', index, data.res.message[i]);
                            socketDate(index, data.res.message[i]);
                        }
                    }
            }
        });

        // var myListenerValidation = $rootScope.$on('SocketComesValidation', function (evt, data) {
        //     $log.log(evt);
        //     $log.log(data);
        //     if (data.data && (!vm.filterData.searchBookingId && !vm.filterData.searchPackageId) && vm.filterData.search) {
        //         console.log(vm.currentPage);
        //         vm.getAllSearchedBookings(0, vm.filterData.itemsPerPageSelected, vm.filterData, false);
        //     } else if (data.data && (vm.filterData.searchBookingId || vm.filterData.searchPackageId) && !vm.filterData.search) {
        //         getBookingIdResults(vm.filterData);
        //     }
        // });

        var myListenerValidation = $rootScope.$on('SocketComesValidation', function (evt, data) {
            // console.log('>>>>>>>>>>>>>>>>>>> IN SocketComesValidation socketEventPackageValidation >>>>>>>>>>>>>>', evt, data);
            $log.log(evt);
            $log.log(data);
            if (data.data && (vm.filterData.searchBookingId || vm.filterData.searchPackageId || vm.filterData.searchCUD || vm.filterData.searchOrderService) && !vm.filterData.search) {
                // getBookingIdResults(vm.filterData);
                if (data.res && data.res.message)
                    for (var i = 0; i < data.res.message.length; i++) {
                        var index = _.findIndex(vm.searchedBookingList, {
                            job_id: data.res.message[i].job_id
                        });
                        if (index > -1) {
                            // console.log('>>>>>>> IN ELSE >>>>>>>>', index, data.res.message[i]);
                            socketDate(index, data.res.message[i]);
                        }
                    }
            }

        });
        $scope.$on('$destroy', myListenerValidation);
        $scope.$on('$destroy', myListenerShared);
        $scope.$on('$destroy', SocketStartEndShift);

        function socketDate(index, data) {
            index = index || 0;
            if (data) {
                vm.searchedBookingList[index].creation_datetime = data.creation_datetime;
                vm.searchedBookingList[index].is_wait_time_included = data.is_wait_time_included;
                vm.searchedBookingList[index].job_time = data.job_time_utc;
                vm.searchedBookingList[index].job_time_filtered = $filter('date')(data.job_time_utc, "MMM d, yyyy HH:mm'"); //actual start time
                if (new Date(data.job_time_utc).getDate() == new Date().getDate() && new Date(data.job_time_utc).getMonth() == new Date().getMonth() && new Date(data.job_time_utc).getFullYear() == new Date().getFullYear()) {
                    vm.searchedBookingList[index].dateFlagForShow = true;
                } else {
                    vm.searchedBookingList[index].dateFlagForShow = false;
                }
                vm.searchedBookingList[index].locking_id = data.locking_id;
                vm.searchedBookingList[index].locking_name = data.locking_id_name;
                vm.searchedBookingList[index].return_date_time_utc = data.return_date_time;
                vm.searchedBookingList[index].return_date_time = data.return_date_time_utc;
                vm.searchedBookingList[index].urgent_booking_assignment = data.urgent_booking_assignment;
                vm.searchedBookingList[index].color = data.urgent_booking_assignment ? '#ff4d4d' : '#333';
                vm.searchedBookingList[index].shared_service_id = data.shared_service_id;
                vm.searchedBookingList[index].job_status = data.job_status;
                vm.searchedBookingList[index].auth_required = data.auth_required;
                vm.searchedBookingList[index].is_auth = data.is_auth;
                vm.searchedBookingList[index].booking_type = data.booking_type;

                vm.searchedBookingList[index].transport_details = data.transport_details;
                vm.searchedBookingList[index].fleet_first_name = data.fleet_first_name;
                vm.searchedBookingList[index].fleet_last_name = data.fleet_last_name;
                vm.searchedBookingList[index].fleet_country_code = data.fleet_country_code;
                vm.searchedBookingList[index].fleet_phone_number = data.fleet_phone_number;
                vm.searchedBookingList[index].unique_car_id = data.unique_car_id;

                $scope.$apply();
            }
        }

        if ($rootScope.socket.connected == false || $rootScope.socket.connected == 'false') {
            $rootScope.socket.connect();
        }

        //==================== SLIDE FILTER DATA TAB ======================
        $('#filterPanel').hide();

        function slideData() {
            // vm.agreement = [];
            // vm.branchList = [];
            // vm.vehicle = [];
            // vm.service = [];
            // getFilterDataFromBackend();
            $('#filterPanel').slideToggle(1000);
            document.getElementById('toDate').value = moment(vm.filterData.filter_pickup_to_date_value).format('DD-MMMM-YYYY');
            document.getElementById('fromDate').value = moment(vm.filterData.filter_pickup_from_date_value).format('DD-MMMM-YYYY');

        }

        vm.dateOptions = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            // maxDate: new Date(),
            // minDate: new Date(vm.filterData.filter_pickup_from_date_value),
            startingDay: 1,
            showWeeks: false,

        };

        //====================function for dropdown pages and page count===============
        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            // if (vm.filterData.search || vm.filterData.searchBookingId || vm.filterData.searchPackageId)
            // getAllSearchedBookings(0, vm.itemsPerPageGot, vm.filterData, true);
        };

        function paginationNew(page) {
            console.log(page);
            // getAllSearchedBookings((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData, true);
        }

        //===============================function to change date============================
        function changeDateFormat(date) {
            //console.log(date);
            var data = date.split('T')[0];
            //console.log(data);
            var newDate = new Date(data);
            //console.log(newDate);
            newDate.setHours(Number(date.split('T')[1].split(':')[0]));
            newDate.setMinutes(Number(date.split('T')[1].split(':')[1]));
            newDate.setSeconds(0);
            //console.log(newDate);
            return newDate;
        };


        function copyTemplate(data) {
            vm.templateString = '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 ' +
                '                Transitional//EN" ' +
                '                "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">' +
                '<html>' +
                '' +
                '<head>' +
                '    <meta charset="UTF-8">' +
                '    <meta name="viewport" content="width=device-width, ' +
                '                initial-scale=1.0">' +
                '    <title>Ride Over</title>' +
                '' +
                '    <style type="text/css">' +
                '        .mainheader {' +
                '            margin: 0 auto;' +
                '            padding: 0 20px;' +
                '            background-color: rgb(6, 60, 74);' +
                '            width: 750px;' +
                '        }' +
                '' +
                '        .mainLogoTd {' +
                '            height: 80px;' +
                '            border: none;' +
                '        }' +
                '' +
                '        .tableStyle {' +
                '            padding: 0 25px;' +
                '            width: 100%;' +
                '        }' +
                '' +
                '        .LeftTextWidth {' +
                '            width: 70%;' +
                '            padding-top: 15px;' +
                '        }' +
                '' +
                '        .RightTextWidth {' +
                '            width: 30%;' +
                '            padding-top: 15px;' +
                '        }' +
                '' +
                '        .LogotableStyle {' +
                '            border: 0;' +
                '            width: 100%;' +
                '            text-align: center;' +
                '            padding-top: 0;' +
                '            padding-bottom: 0;' +
                '        }' +
                '' +
                '        .padding30 {' +
                '            padding-top: 30px;' +
                '        }' +
                '' +
                '        .Hey-cutomer {' +
                '            font-family: sans-serif;' +
                '            font-size: 22px;' +
                '            font-weight: 500;' +
                '            letter-spacing: 1px;' +
                '            text-align: left;' +
                '            color: #1f1f1f;' +
                '        }' +
                '' +
                '        .Trip-Details {' +
                '            font-family: sans-serif;' +
                '            font-size: 24px;' +
                '            line-height: 1.4;' +
                '            letter-spacing: 1px;' +
                '            text-align: left;' +
                '            font-weight: bold;' +
                '            color: #242424;' +
                '        }' +
                '' +
                '        .pickAddress {' +
                '            font-family: sans-serif;' +
                '            font-size: 18px;' +
                '            letter-spacing: 1.1px;' +
                '            text-align: left;' +
                '            color: #262626;' +
                '        }' +
                '' +
                '        .You-Rode-with-James {' +
                '            font-family: sans-serif;' +
                '            font-size: 18px;' +
                '            font-weight: 600;' +
                '            line-height: 1.4;' +
                '            text-align: left;' +
                '            color: #070707;' +
                '        }' +
                '' +
                '        .LeftText {' +
                '            font-family: sans-serif;' +
                '            font-size: 20px;' +
                '            letter-spacing: 1.1px;' +
                '            text-align: left;' +
                '            color: #000000;' +
                '        }' +
                '' +
                '        .RightText {' +
                '            font-family: sans-serif;' +
                '            font-size: 20px;' +
                '            font-weight: bold;' +
                '            letter-spacing: 1.1px;' +
                '            text-align: right;' +
                '            color: #000000;' +
                '        }' +
                '' +
                '        .Fare-Breakdown {' +
                '            font-family: sans-serif;' +
                '            font-size: 18px;' +
                '            font-weight: 600;' +
                '            line-height: 1.4;' +
                '            text-align: left;' +
                '            color: #000000;' +
                '        }' +
                '' +
                '        .TOTAL-FARE-Tk-880 {' +
                '            font-family: sans-serif;' +
                '            font-size: 23px;' +
                '            font-weight: bold;' +
                '            line-height: .87;' +
                '            text-align: right;' +
                '            color: #a5a1ff;' +
                '        }' +
                '' +
                '        .Fare-Details {' +
                '            font-family: sans-serif;' +
                '            font-size: 18px;' +
                '            line-height: .87;' +
                '            color: #1f1f1f;' +
                '        }' +
                '' +
                '        .straightLine {' +
                '            padding-top: 20px;' +
                '            border-bottom: 1px solid #b3b3b3;' +
                '        }' +
                '' +
                '        .footerTable {' +
                '            border: 0;' +
                '            background-color: rgb(6, 60, 74);' +
                '            width: 100%;' +
                '        }' +
                '' +
                '        .Float-text {' +
                '            float: right;' +
                '        }' +
                '' +
                '        .Clear-all {' +
                '            clear: both;' +
                '        }' +
                '' +
                '        .Fair-full-details {' +
                '            font-family: sans-serif;' +
                '            font-size: 17px;' +
                '            line-height: .87;' +
                '            text-align: right;' +
                '            color: #1f1f1f;' +
                '        }' +
                '' +
                '        .Visibilty {' +
                '            visibility: hidden;' +
                '        }' +
                '' +
                '        .Background-adjust {' +
                '            background-color: lightgray;' +
                '            padding: 5px;' +
                '        }' +
                '' +
                '        .Total-Fair {' +
                '            font-size: 35px;' +
                '            font-weight: 600;' +
                '            text-align: left;' +
                '            padding-top: 5px;' +
                '        }' +
                '' +
                '        .Total-Fair-1 {' +
                '            font-size: 35px;' +
                '            font-weight: 600;' +
                '            text-align: right;' +
                '            padding-top: 5px;' +
                '        }' +
                '' +
                '        .Text-Align {' +
                '            text-align: left;' +
                '        }' +
                '' +
                '        .Text-Right {' +
                '            text-align: right;' +
                '        }' +
                '' +
                '        .Font-Size-Adjust {' +
                '            font-size: 12px;' +
                '        }' +
                '' +
                '        .Font-Size-Customer {' +
                '            font-family: sans-serif;' +
                '            font-size: 22px;' +
                '            line-height: .87;' +
                '            text-align: left;' +
                '            color: #1f1f1f;' +
                '        }' +
                '' +
                '        .AddressDetails {' +
                '            font-family: sans-serif;' +
                '            font-size: 22px;' +
                '            line-height: .87;' +
                '            text-align: left;' +
                '            font-weight: bold;' +
                '            color: #1f1f1f;' +
                '        }' +
                '' +
                '        .padding10 {' +
                '            padding-top: 10px;' +
                '        }' +
                '' +
                '        .disance-Details {' +
                '            font-family: sans-serif;' +
                '            font-size: 20px;' +
                '            line-height: .87;' +
                '            text-align: left;' +
                '            color: #1f1f1f;' +
                '        }' +
                '' +
                '        .Marker-image {' +
                '            width: 30px;' +
                '        }' +
                '' +
                '        .Tarifa-text {' +
                '            font-family: sans-serif;' +
                '            font-size: 22px;' +
                '            line-height: .87;' +
                '            text-align: left;' +
                '            font-weight: bold;' +
                '            color: #1f1f1f;' +
                '        }' +
                '' +
                '        .ObservationText {' +
                '            font-family: sans-serif;' +
                '            font-size: 14px;' +
                '            line-height: .87;' +
                '            text-align: left;' +
                '            color: #1f1f1f;' +
                '            border: 2px solid #1f1f1f;' +
                '        }' +
                '' +
                '        .bottomtext {' +
                '            font-family: sans-serif;' +
                '            font-size: 15px;' +
                '            line-height: .87;' +
                '            text-align: left;' +
                '            color: #1f1f1f;' +
                '        }' +
                '' +
                '        .footerImage {' +
                '            display: block;' +
                '            margin: 0 auto;' +
                '        }' +
                '' +
                '        .footerImageText {' +
                '            color: #FFFFFF;' +
                '            margin-top: 7px;' +
                '            text-align: center;' +
                '        }' +
                '' +
                '        .tableStyleWithoutPadding {' +
                '            width: 100%;' +
                '        }' +
                '' +
                '        pre {' +
                '            font-family: sans-serif;' +
                '            padding: 4px;' +
                '            margin: 4px;' +
                '        }' +
                '' +
                '        .createdText {' +
                '            color: orange;' +
                '            font-size: 18px;' +
                '        }' +
                '' +
                '        .heading {' +
                '            color: black;' +
                '            font-weight: bold;' +
                '            padding-left: 20px;' +
                '            font-size: 18px;' +
                '        }' +
                '' +
                '        .vip {' +
                '            float: right;' +
                '            color: red;' +
                '            font-weight: bold;' +
                '            font-size: 16px;' +
                '            padding-right: 30px;' +
                '            padding-bottom: 20px;' +
                '        }' +
                '' +
                '        .headingRight {' +
                '            float: right;' +
                '            color: black;' +
                '            /* font-weight: bold; */' +
                '            font-size: 18px;' +
                '            padding-right: 50px;' +
                '            padding: 8px 20px 8px 0px;' +
                '            min-height: 16px;' +
                '        }' +
                '    </style>' +
                '</head>' +
                '' +
                '<body>' +
                '    <table style=" margin: 0 auto;padding: 20px 20px; background-color: rgb(6, 60, 74);width: 600px;">' +
                '        <tbody>' +
                '            <tr style="background-color:#fff;color:#FFFFFF;">' +
                '                <td style="padding:10px">' +
                '                    <table style="border:0;width:100%;">' +
                '                        <tr style= "font-style:normal;line-height:15px">' +
                '                            <td style="color: black;font-weight: bold;font-size: 16px;">' +
                '                                Reserva:' +
                '                            </td>' +
                '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                '                                {{vm.bookingDetails.job_id}}' +
                '' + '                       <td style="color: red;font-weight: bold;font-size: 14px;padding-right: 30px;">' +
                '                                {{vip}}' +
                '                            </td>' +
                '                            </td>' +
                '                        </tr>' +
                '                        <tr  style= "font-style:normal;line-height:15px">' +
                '                            <td style="color: black;font-weight: bold;font-size: 16px;">' +
                '                                Nombre:' +
                '                            </td>' +
                '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                '                                {{vm.bookingDetails.customer_username}}' +
                '                            </td>' +
                '                        </tr>' +
                '                        <tr style= "font-style:normal;line-height:15px">' +
                '                            <td style="color: black;font-weight: bold; font-size: 16px;">' +
                '                                Telefono:' +
                '                            </td>' +
                '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                '                                {{vm.bookingDetails.customer_phone}}' +
                '                            </td>' +
                '                        </tr>' +
                '                        <tr style= "font-style:normal;line-height:15px">' +
                '                            <td style="color: black;font-weight: bold; font-size: 16px;">' +
                '                                Correo:' +
                '                            </td>' +
                '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                '                                {{vm.bookingDetails.customer_email}}' +
                '                            </td>' +
                '                        </tr>' +
                '                        <tr style= "font-style:normal;line-height:15px">' +
                '                            <td style="color: black;font-weight: bold; font-size: 16px;">' +
                '                                Origen:' +
                '                            </td>' +
                '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                '                                {{vm.bookingDetails.job_pickup_address}}' +
                '                            </td>' +
                '                        </tr>' +
                '                        <tr style= "font-style:normal;line-height:15px">' +
                '                            <td style="color: black;font-weight: bold; font-size: 16px;width:200px">' +
                '                                Fecha Retiro:' +
                '                            </td>' +
                '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                '                                {{vm.bookingDetails.date}}' +
                '                            </td>' +
                '                        </tr>' +
                '                        <tr style= "font-style:normal;line-height:15px">' +
                '                            <td style="color: black;font-weight: bold;font-size: 16px;width:200px">' +
                '                                Hora retiro:' +
                '                            </td>' +
                '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                '                                {{vm.bookingDetails.time}}' +
                '                            </td>' +
                '                        </tr>' +
                '                        <tr style= "font-style:normal;line-height:15px">' +
                '                            <td style="color: black;font-weight: bold; font-size: 16px;">' +
                '                                Destino:' +
                '                            </td>' +
                '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                '                                {{vm.bookingDetails.job_address}}' +
                '                            </td>' +
                '                        </tr>' +
                '                        <tr style= "font-style:normal;line-height:15px">' +
                '                            <td style="color: black;font-weight: bold; font-size: 16px;width:200px">' +
                '                                Tipo Servicio:' +
                '                            </td>' +
                '                            <td style="color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                '                                {{vm.bookingDetails.service_name}}' +
                '                            </td>' +
                '                        </tr>' +
                '                        <tr style= "font-style:normal;line-height:15px">' +
                '                            <td style="color: black;font-weight: bold;font-size: 16px;width:200px">' +
                '                                Num. Pasajeros:' +
                '                            </td>' +
                '                            <td style="color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                '                                {{vm.bookingDetails.number_of_passangers}}' +
                '                            </td>' +
                '                        </tr>' +
                '                        <tr style= "font-style:normal;line-height:15px">' +
                '                            <td style="color: black;font-weight: bold; font-size: 16px;">' +
                '                                Estado:' +
                '                            </td>' +
                '                            <td style="color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                '                                {{vm.bookingDetails.Estado}}' +
                '                            </td>' +
                '                        </tr>' +
                '                        <tr style= "font-style:normal;line-height:15px">' +
                '                            <td style="color: black;font-weight: bold; font-size: 16px;">' +
                '                                Convenio:' +
                '                            </td>' +
                '                            <td style="color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                '                                {{vm.bookingDetails.contract_name}}' +
                '                            </td>' +
                '                        </tr>' +
                '                        <tr style= "font-style:normal;line-height:15px">' +
                '                            <td style="color: black;font-weight: bold;font-size: 16px;width:200px">' +
                '                                Tarifa estimada:' +
                '                            </td>' +
                '                            <td style="color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                '                                {{vm.bookingDetails.estimated_payment_cost}} / {{vm.bookingDetails.fare}}' +
                '                            </td>' +
                '                        </tr>' +
                '                    </table>' +
                '' +
                '                </td>' +
                '            </tr>' +
                '        </tbody>' +
                '    </table>' +
                '</body>' +
                '' +
                '</html>';
            vm.string = vm.templateString;
            console.log(data, "data aa gaya");

            if (data.payment_status == 1 || data.payment_status == 1) {
                vm.string = vm.string.replace('{{vm.bookingDetails.Estado}}', 'PAGADA');
            } else {
                vm.string = vm.string.replace('{{vm.bookingDetails.Estado}}', 'NO PAGADA');
            }
            if (data.job_time && data.job_time != '0000-00-00 00:00:00') {
                var time = moment(data.job_time).format('HH:mm')
                vm.string = vm.string.replace('{{vm.bookingDetails.time}}', time);
            } else {
                vm.string = vm.string.replace('{{vm.bookingDetails.time}}', '--');
            }
            if (data.job_time && data.job_time != '0000-00-00 00:00:00') {
                var date = moment(data.job_time).format('MMMM DD YYYY')
                vm.string = vm.string.replace('{{vm.bookingDetails.date}}', date);
            } else {
                vm.string = vm.string.replace('{{vm.bookingDetails.date}}', '--');
            }
            if (data.route_type == 1) {
                vm.string = vm.string.replace('{{vm.bookingDetails.fare}}', 'FIJA');
            } else {
                vm.string = vm.string.replace('{{vm.bookingDetails.fare}}', 'Variable');
            }
            if (data.is_vip && data.is_vip == 1) {
                vm.string = vm.string.replace('{{vip}}', 'VIP');
            } else {
                vm.string = vm.string.replace('{{vip}}', '')
            }

            function numberWithCommas(x) {
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            };
            vm.string = vm.string.replace('{{vm.bookingDetails.job_id}}', JSON.stringify(data.job_id));
            vm.string = vm.string.replace('{{vm.bookingDetails.customer_phone}}', data.customer_phone_number);
            vm.string = vm.string.replace('{{vm.bookingDetails.customer_username}}', data.job_pickup_name);
            vm.string = vm.string.replace('{{vm.bookingDetails.job_pickup_address}}', data.job_pickup_address);
            vm.string = vm.string.replace('{{vm.bookingDetails.customer_email}}', data.job_pickup_email);
            vm.string = vm.string.replace('{{vm.bookingDetails.job_address}}', data.job_address);
            vm.string = vm.string.replace('{{vm.bookingDetails.service_name}}', data.agreement);
            vm.string = vm.string.replace('{{vm.bookingDetails.contract_name}}', data.agreement);
            vm.string = vm.string.replace('{{vm.bookingDetails.number_of_passangers}}', data.number_of_passangers);
            vm.string = vm.string.replace('{{vm.bookingDetails.estimated_payment_cost}}', '$' + numberWithCommas(data.estimated_payment_cost));
            document.getElementById('copy').value = vm.string;
            var copyText = document.getElementById('copy');
            copyText.select();
            document.execCommand("copy");
            if (document.execCommand("copy") == true) {
                errorMessageFactory.showErrorMessage("Resumen copiado correctamente", 0);
            }

        }
        //==================get all searched bookings=======================
        function getAllSearchedBookings(skip, limit, filter, loader) {
            // console.log(filter);
            // var dataSend = {};
            // dataSend.access_token = $cookies.get('obj');
            // dataSend.limit = limit;
            // dataSend.offset = skip;
            // dataSend.search_field = filter.search_field;
            // vm.loading = loader;
            // var promise = getBookings.searchBookings(dataSend);
            // promise.then(
            //     function (payload) {
            //         $log.log('sxdsads', payload);
            //         vm.loading = false;
            //         if (payload.title.status == 400) {
            //             errorMessageFactory.showErrorMessage(payload.title.message, 0);
            //         } else if (payload.title.status == 401) {
            //             errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
            //         } else if (payload.title.status == 201 || payload.title.status == 200) {
            //             vm.totalSearchedBookings = payload.title.data.totalCount;
            //             vm.dataLength = payload.title.data.totalCount;
            //             console.log(payload);

            //             if (payload.title.data.totalCount == 0) {
            //                 vm.sp_pagination = false;
            //                 vm.tBodyFlag = false;
            //                 vm.tFootFlag = true;
            //                 vm.filterOn = true;
            //                 vm.skipValueFilter = 0;
            //             } else {
            //                 vm.sp_pagination = true;
            //                 vm.tBodyFlag = true;
            //                 vm.tFootFlag = false;
            //                 vm.filterOn = false;
            //                 vm.skipValueFilter = 0;

            //                 var dataArray = [];
            //                 var searchedBookingList = payload.title.data.result;
            //                 searchedBookingList.forEach(function (column) {
            //                     var d = {};
            //                     d.job_id = column.job_id;
            //                     d.job_status = column.job_status;
            //                     d.created_by = column.created_by;
            //                     d.booking_for = column.booking_for; //0 owner, 1- other
            //                     d.is_vip = column.is_VIP;
            //                     //d.job_pickup_datetime = changeDateFormat(column.job_pickup_datetime);
            //                     d.job_pickup_name = column.job_pickup_name;
            //                     d.job_pickup_phone = column.job_pickup_phone;
            //                     d.job_pickup_email = column.job_pickup_email;
            //                     d.job_pickup_address = column.job_pickup_address;
            //                     d.job_address = column.job_address; //destination
            //                     d.number_of_passangers = column.number_of_passangers;
            //                     d.creation_datetime = column.creation_datetime;
            //                     d.fleet_id = column.fleet_id;
            //                     //d.job_time_utc = column.job_time; //actual start time
            //                     d.job_time = column.job_time_utc; //actual start time
            //                     d.job_time_filtered = $filter('date')(column.job_time_utc, "MMM d, yyyy HH:mm'"); //actual start time
            //                     if (new Date(column.job_time_utc).getDate() == new Date().getDate() && new Date(column.job_time_utc).getMonth() == new Date().getMonth() && new Date(column.job_time_utc).getFullYear() == new Date().getFullYear()) {
            //                         d.dateFlagForShow = true;
            //                     } else {
            //                         d.dateFlagForShow = false;
            //                     }
            //                     d.transport_details = column.transport_details; //CAR number
            //                     d.fleet_first_name = column.fleet_first_name;
            //                     d.fleet_last_name = column.fleet_last_name;
            //                     d.fleet_country_code = column.fleet_country_code;
            //                     d.fleet_phone_number = column.fleet_phone_number;
            //                     d.customer_first_name = column.customer_first_name;
            //                     d.customer_last_name = column.customer_last_name;
            //                     d.customer_country_code = column.customer_country_code;
            //                     d.customer_phone_number = column.customer_phone_number;
            //                     d.contract_name = column.contract_name;
            //                     d.is_round_trip = column.is_round_trip;
            //                     d.is_wait_time_included = column.is_wait_time_included;
            //                     d.return_date_time_utc = column.return_date_time;
            //                     d.return_date_time = column.return_date_time_utc;
            //                     d.round_trip_parent_job_id = column.round_trip_parent_job_id;
            //                     d.auth_required = column.auth_required;
            //                     d.auth_of = column.auth_of;
            //                     d.is_auth = column.is_auth;
            //                     d.branch = column.branch_name;
            //                     d.type_of_service = column.service_name;
            //                     d.agreement = column.contract_name;
            //                     d.agreementId = column.contract_id;
            //                     d.unique_car_id = column.unique_car_id;
            //                     d.estimated_payment_cost = column.estimated_payment_cost;
            //                     d.type_of_trip = column.type_of_trip;
            //                     d.payment_status = column.payment_status;
            //                     d.is_POS_booking = column.is_POS_booking;
            //                     d.urgent_booking_assignment = column.urgent_booking_assignment;
            //                     d.shared_service_id = column.shared_service_id;
            //                     d.shared_service_status = column.shared_service_status;
            //                     d.booking_type = column.booking_type;
            //                     d.locking_id = column.locking_id;
            //                     d.is_wait_time_included = column.is_wait_time_included;
            //                     d.locking_name = column.locking_id_name;
            //                     d.color = column.urgent_booking_assignment ? '#ff4d4d' : '#333';
            //                     d.flight_number = column.flight_number;
            //                     d.sin_respaldo = column.sin_respaldo;
            //                     dataArray.push(d);
            //                 });
            //                 vm.searchedBookingList = dataArray;

            //                 for (var i = 0; i < vm.searchedBookingList.length; i++) {
            //                     vm.searchedBookingList[i].index = (skip + i);
            //                 }
            //                 if (vm.dataLength <= vm.itemsPerPageGot) {
            //                     vm.sp_pagination = false;
            //                 } else {
            //                     vm.sp_pagination = true;
            //                 }
            //                 vm.skipValue = vm.searchedBookingList[0].index;
            //                 vm.limitValue = vm.searchedBookingList[vm.searchedBookingList.length - 1].index;

            //             }
            //         }
            //     },
            //     function (errorPayload) {
            //         $log.log(errorPayload);
            //         vm.loading = false;
            //         if (errorPayload.data.status == 401) {
            //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
            //         } else {
            //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
            //         }
            //     }
            // );
        };


        //function init() {
        //    vm.getAllSearchedBookings(0, vm.itemsPerPageGot,vm.filterData,true);
        //};
        //init();

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            //vm.filterOn = true;
            vm.currentPage = 0;
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            vm.filterData.searchCUD ='';
            vm.filterData.searchOrderService = '';
            pendingRequests.cancelAll();
            if (vm.filterData.search.length == 0) {
                vm.filterData.search_field = '';
                vm.searchedBookingList = [];
                vm.sp_pagination = false;
                vm.tBodyFlag = false;
                vm.tFootFlag = true;
                vm.filterOn = true;
                vm.skipValueFilter = 0;
                vm.dataLength = 0;
                vm.totalSearchedBookings = 0;
                //vm.getAllSearchedBookings(0, vm.itemsPerPageGot,vm.filterData,true);
                //vm.filterOn = false;
                //vm.watchPagination = true;
                //vm.sp_pagination = true;
            } else {
                vm.filterData.search_field = vm.filterData.search;
                //if (vm.filterTextTimeout) $timeout.cancel(vm.filterTextTimeout);
                //vm.filterTextTimeout = $timeout(function(){
                // vm.getAllSearchedBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                //},500);

            }
        };

        //===========================get filters by booking id=========================
        function getFilterBookingId(data) {
            console.log(data);
            vm.filterData.search = '';
            if (!data) {
                vm.filterData.search_field = '';
                vm.searchedBookingList = [];
                vm.sp_pagination = false;
                vm.tBodyFlag = false;
                vm.tFootFlag = true;
                vm.filterOn = true;
                vm.skipValueFilter = 0;
                vm.dataLength = 0;
            } else {
                //if (vm.filterTextTimeout) $timeout.cancel(vm.filterTextTimeout);
                //vm.filterTextTimeout = $timeout(function(){
                getBookingIdResults(vm.filterData);
                //},500);
            }
        };

        function getBookingIdResults(data) {
            console.log(data,'/////')
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            if (data.searchBookingId)
                dataSend.booking_id = data.searchBookingId;
            if (data.searchPackageId)
                dataSend.package_id = data.searchPackageId;
            if (data.searchCUD)
                dataSend.cud_id = data.searchCUD;
            if (data.searchOrderService)
                dataSend.service_order_id = data.searchOrderService;
            //dataSend.booking_status = 0;
            //vm.loading = true;
            var promise = getBookings.getBookingById(dataSend);
            promise.then(
                function (payload) {
                    console.log(payload);
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (payload.title.data.result.length) {
                            vm.totalSearchedBookings = payload.title.data.totalCount;
                            vm.dataLength = payload.title.data.totalCount;

                            if (payload.title.data.totalCount == 0) {
                                console.log('gya');
                                vm.sp_pagination = false;
                                vm.tBodyFlag = false;
                                vm.tFootFlag = true;
                                vm.filterOn = true;
                                vm.skipValueFilter = 0;
                            } else {
                                console.log('121212');
                                vm.sp_pagination = true;
                                vm.tBodyFlag = true;
                                vm.tFootFlag = false;
                                vm.filterOn = false;
                                vm.skipValueFilter = 0;

                                var dataArray = [];
                                var searchedBookingList = payload.title.data.result;
                                searchedBookingList.forEach(function (column) {
                                    var d = {};
                                    d.job_id = column.job_id;
                                    d.job_status = column.job_status;
                                    d.created_by = column.created_by;
                                    d.booking_for = column.booking_for; //0 owner, 1- other
                                    d.is_vip = column.is_VIP;
                                    //d.job_pickup_datetime = changeDateFormat(column.job_pickup_datetime);
                                    d.job_pickup_name = column.job_pickup_name;
                                    d.job_pickup_phone = column.job_pickup_phone;
                                    d.job_pickup_email = column.job_pickup_email;
                                    d.job_pickup_address = column.job_pickup_address;
                                    d.job_address = column.job_address; //destination
                                    d.number_of_passangers = column.number_of_passangers;
                                    d.creation_datetime = column.creation_datetime;
                                    d.fleet_id = column.fleet_id;
                                    //d.job_time_utc = column.job_time; //actual start time
                                    d.job_time = column.job_time_utc; //actual start time
                                    d.job_time_filtered = $filter('date')(column.job_time_utc, "MMM d, yyyy HH:mm'"); //actual start time
                                    if (new Date(column.job_time_utc).getDate() == new Date().getDate() && new Date(column.job_time_utc).getMonth() == new Date().getMonth() && new Date(column.job_time_utc).getFullYear() == new Date().getFullYear()) {
                                        d.dateFlagForShow = true;
                                    } else {
                                        d.dateFlagForShow = false;
                                    }
                                    d.transport_details = column.transport_details; //CAR number
                                    d.fleet_first_name = column.fleet_first_name;
                                    d.fleet_last_name = column.fleet_last_name;
                                    d.fleet_country_code = column.fleet_country_code;
                                    d.fleet_phone_number = column.fleet_phone_number;
                                    d.customer_first_name = column.customer_first_name;
                                    d.customer_last_name = column.customer_last_name;
                                    d.customer_country_code = column.customer_country_code;
                                    d.customer_phone_number = column.customer_phone_number;
                                    d.is_round_trip = column.is_round_trip;
                                    d.return_date_time_utc = column.return_date_time;
                                    d.return_date_time = column.return_date_time_utc;
                                    d.round_trip_parent_job_id = column.round_trip_parent_job_id;
                                    d.auth_required = column.auth_required;
                                    d.auth_of = column.auth_of;
                                    d.is_auth = column.is_auth;
                                    d.branch = column.branch_name;
                                    d.type_of_service = column.service_name;
                                    d.agreement = column.new_contract_name ? column.new_contract_name : column.contract_name;
                                    d.unique_car_id = column.unique_car_id;
                                    d.estimated_payment_cost = column.estimated_payment_cost;
                                    d.type_of_trip = column.type_of_trip;
                                    d.agreementId = column.contract_id;
                                    d.payment_status = column.payment_status;
                                    d.is_POS_booking = column.is_POS_booking;
                                    d.urgent_booking_assignment = column.urgent_booking_assignment;
                                    d.shared_service_id = column.shared_service_id;
                                    d.shared_service_status = column.shared_service_status;
                                    d.booking_type = column.booking_type;
                                    d.locking_id = column.locking_id;
                                    d.locking_name = column.locking_id_name;
                                    d.flight_number = column.flight_number;
                                    d.sin_respaldo = column.sin_respaldo;
                                    d.is_wait_time_included = column.is_wait_time_included;
                                    d.color = column.urgent_booking_assignment ? '#ff4d4d' : '#333';
                                    d.shift_id = column.shift_id;
                                    d.payment_method = column.payment_method;
                                    d.payment_status = column.payment_status;
                                    d.admin_fullyname = column.admin_fullyname;
                                    d.total_refund_amount = column.total_refund_amount;
                                    d.total_estimated_payment_cost = column.total_estimated_payment_cost;
                                    d.round_trip = column.round_trip;
                                    dataArray.push(d);
                                });
                                vm.searchedBookingList = dataArray;
                                getShiftResponse();

                                // USERTYPE VALUE
                                // 0 - Transvip user
                                // 1 - PET user
                                vm.userType = payload.title.data.user_type || 0;

                                console.log(vm.searchedBookingList)

                                for (var i = 0; i < vm.searchedBookingList.length; i++) {
                                    vm.searchedBookingList[i].index = (i);
                                }
                                if (vm.dataLength <= vm.itemsPerPageGot) {
                                    vm.sp_pagination = false;
                                } else {
                                    vm.sp_pagination = true;
                                    //vm.pageCount(payload.title.totalCount);
                                }
                                vm.skipValue = vm.searchedBookingList[0].index;
                                vm.limitValue = vm.searchedBookingList[vm.searchedBookingList.length - 1].index;
                                //range();
                            }
                        } else {
                            vm.searchedBookingList = [];
                            vm.sp_pagination = false;
                            vm.tBodyFlag = false;
                            vm.tFootFlag = true;
                            vm.filterOn = true;
                            vm.skipValueFilter = 0;
                            vm.dataLength = 0;
                            vm.totalSearchedBookings = 0;
                        }
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        // // **************  GET BOOKING API FOR FILTERS  ******************
        // function getAllBooking(data) {
        //     console.log('****** IN getAllBooking *********', data);
        //     var dataSend = {};
        //     dataSend.access_token = $cookies.get('obj');
        //     if (data.searchBookingId)
        //         dataSend.booking_id = data.searchBookingId;
        //     if (data.searchPackageId)
        //         dataSend.package_id = data.searchPackageId;

        //     var pickFromDate = dateTimeFormat(data.filter_pickup_from_date_value, data.filter_pickup_from_time_value);
        //     var pickToDate = dateTimeFormat(data.filter_pickup_to_date_value, data.filter_pickup_to_time_value);
        //     if (pickFromDate > pickToDate) {
        //         errorMessageFactory.showErrorMessage('Por favor, elija las fechas apropiadas de filtro.', 0);
        //         return;
        //     }
        //     vm.countToSocket = vm.countToSocket + 1;
        //     dataSend.limit = vm.limitValue || 10;
        //     dataSend.offset = vm.skipValue || 0;
        //     dataSend.booking_status = data.booking_status;
        //     dataSend.branch_filter = data.branch_filter;
        //     if (data.branch_filter == 1 && data.branch != 'all') {
        //         dataSend.branch_value = data.branch;
        //     }
        //     dataSend.service_filter = data.service_filter;
        //     if (data.service_filter == 1 && data.service != 'all') {
        //         dataSend.service_value = data.service;
        //     }
        //     dataSend.vehicle_filter = data.vehicle_filter;
        //     if (data.vehicle_filter == 1 && data.vehicle != 'all') {
        //         dataSend.vehicle_value = data.vehicle;
        //     }
        //     dataSend.search_filter = data.search_filter;
        //     if (data.search_filter == 1) {
        //         dataSend.search_value = data.search_value;
        //     }
        //     //dataSend.date_time_filter = data.date_time_filter;
        //     //if(data.filter_pickup_date_value && data.filter_pickup_time_value) {
        //     //    dataSend.date_time_value = dateTimeFormat(data.filter_pickup_date_value, data.filter_pickup_time_value);
        //     //}
        //     //else if(data.filter_pickup_date_value && !data.filter_pickup_time_value){
        //     //    dataSend.date_time_value = moment(data.filter_pickup_date_value).format('YYYY-MM-DD');
        //     //}

        //     dataSend.aggrement_filter = data.aggrement_filter;
        //     if (data.aggrement_filter == 1 && data.agreement != 'all') {
        //         dataSend.aggrement_value = data.agreement;
        //     }

        //     // dataSend.type_of_trip_filter = data.type_of_trip_filter;
        //     // if (data.type_of_trip_filter == 1 && data.type_of_trip != 'all') {
        //     var trip = [];
        //     trip.push(data.type_of_trip);
        //     if (data.type_of_trip && data.type_of_trip.length > 0 && data.type_of_trip != 'all') {
        //         dataSend.type_of_trip_filter = 1;
        //         dataSend.type_of_trip_value = trip;
        //     } else {
        //         dataSend.type_of_trip_filter = 0;
        //     }
        //     dataSend.date_time_filter = 1;
        //     dataSend.date_time_value1 = dateTimeFormat(data.filter_pickup_from_date_value, data.filter_pickup_from_time_value);
        //     dataSend.date_time_value2 = dateTimeFormat(data.filter_pickup_to_date_value, data.filter_pickup_to_time_value);

        //     //dataSend.booking_status = 0;
        //     //vm.loading = true;
        //     var promise = getBookings.allBookings(dataSend);
        //     promise.then(
        //         function (payload) {
        //             console.log(payload);
        //             if (payload.title.status == 400) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //             } else if (payload.title.status == 401) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //             } else if (payload.title.status == 201 || payload.title.status == 200) {
        //                 if (payload.title.data.result.length) {
        //                     vm.totalSearchedBookings = payload.title.data.totalCount;
        //                     vm.dataLength = payload.title.data.totalCount;

        //                     if (payload.title.data.totalCount == 0) {
        //                         vm.sp_pagination = false;
        //                         vm.tBodyFlag = false;
        //                         vm.tFootFlag = true;
        //                         vm.filterOn = true;
        //                         vm.skipValueFilter = 0;
        //                     } else {
        //                         vm.sp_pagination = true;
        //                         vm.tBodyFlag = true;
        //                         vm.tFootFlag = false;
        //                         vm.filterOn = false;
        //                         vm.skipValueFilter = 0;

        //                         var dataArray = [];
        //                         var searchedBookingList = payload.title.data.result;
        //                         searchedBookingList.forEach(function (column) {
        //                             var d = {};
        //                             d.job_id = column.job_id;
        //                             d.job_status = column.job_status;
        //                             d.created_by = column.created_by;
        //                             d.booking_for = column.booking_for; //0 owner, 1- other
        //                             d.is_vip = column.is_VIP;
        //                             //d.job_pickup_datetime = changeDateFormat(column.job_pickup_datetime);
        //                             d.job_pickup_name = column.job_pickup_name;
        //                             d.job_pickup_phone = column.job_pickup_phone;
        //                             d.job_pickup_email = column.job_pickup_email;
        //                             d.job_pickup_address = column.job_pickup_address;
        //                             d.job_address = column.job_address; //destination
        //                             d.number_of_passangers = column.number_of_passangers;
        //                             d.creation_datetime = column.creation_datetime;
        //                             d.fleet_id = column.fleet_id;
        //                             //d.job_time_utc = column.job_time; //actual start time
        //                             d.job_time = column.job_time_utc; //actual start time
        //                             d.job_time_filtered = $filter('date')(column.job_time_utc, "MMM d, yyyy HH:mm'"); //actual start time
        //                             if (new Date(column.job_time_utc).getDate() == new Date().getDate() && new Date(column.job_time_utc).getMonth() == new Date().getMonth() && new Date(column.job_time_utc).getFullYear() == new Date().getFullYear()) {
        //                                 d.dateFlagForShow = true;
        //                             } else {
        //                                 d.dateFlagForShow = false;
        //                             }
        //                             d.transport_details = column.transport_details; //CAR number
        //                             d.fleet_first_name = column.fleet_first_name;
        //                             d.fleet_last_name = column.fleet_last_name;
        //                             d.fleet_country_code = column.fleet_country_code;
        //                             d.fleet_phone_number = column.fleet_phone_number;
        //                             d.customer_first_name = column.customer_first_name;
        //                             d.customer_last_name = column.customer_last_name;
        //                             d.customer_country_code = column.customer_country_code;
        //                             d.customer_phone_number = column.customer_phone_number;
        //                             d.is_round_trip = column.is_round_trip;
        //                             d.return_date_time_utc = column.return_date_time;
        //                             d.return_date_time = column.return_date_time_utc;
        //                             d.round_trip_parent_job_id = column.round_trip_parent_job_id;
        //                             d.auth_required = column.auth_required;
        //                             d.auth_of = column.auth_of;
        //                             d.is_auth = column.is_auth;
        //                             d.branch = column.branch_name;
        //                             d.type_of_service = column.service_name;
        //                             d.agreement = column.contract_name;
        //                             d.unique_car_id = column.unique_car_id;
        //                             d.estimated_payment_cost = column.estimated_payment_cost;
        //                             d.type_of_trip = column.type_of_trip;
        //                             d.agreementId = column.contract_id;
        //                             d.payment_status = column.payment_status;
        //                             d.is_POS_booking = column.is_POS_booking;
        //                             d.urgent_booking_assignment = column.urgent_booking_assignment;
        //                             d.shared_service_id = column.shared_service_id;
        //                             d.shared_service_status = column.shared_service_status;
        //                             d.booking_type = column.booking_type;
        //                             d.locking_id = column.locking_id;
        //                             d.locking_name = column.locking_id_name;
        //                             d.flight_number = column.flight_number;
        //                             d.is_wait_time_included = column.is_wait_time_included;
        //                             d.color = column.urgent_booking_assignment ? '#ff4d4d' : '#333';
        //                             dataArray.push(d);
        //                         });
        //                         vm.searchedBookingList = dataArray;

        //                         for (var i = 0; i < vm.searchedBookingList.length; i++) {
        //                             vm.searchedBookingList[i].index = (i);
        //                         }
        //                         if (vm.dataLength <= vm.itemsPerPageGot) {
        //                             vm.sp_pagination = false;
        //                         } else {
        //                             vm.sp_pagination = true;
        //                             //vm.pageCount(payload.title.totalCount);
        //                         }
        //                         vm.skipValue = vm.searchedBookingList[0].index;
        //                         vm.limitValue = vm.searchedBookingList[vm.searchedBookingList.length - 1].index;
        //                         //range();
        //                     }
        //                 } else {
        //                     vm.searchedBookingList = [];
        //                     vm.sp_pagination = false;
        //                     vm.tBodyFlag = false;
        //                     vm.tFootFlag = true;
        //                     vm.filterOn = true;
        //                     vm.skipValueFilter = 0;
        //                     vm.dataLength = 0;
        //                     vm.totalSearchedBookings = 0;
        //                 }
        //             }
        //         },
        //         function (errorPayload) {
        //             $log.log(errorPayload);
        //             vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // }


        //======================modify booking======================
        function modifyBooking(data) {
            if (data.sin_respaldo == 1) {
                vm.loading = true;
                var promise = adminAccessService.checkStateValid('BWR'); //$stateParams.id
                return promise.then(
                    function (payload) {
                        vm.loading = false;
                        if (payload.title.status == 400) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            return false;
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                            return false;
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            if (!payload.title.data.granted) {
                                // languageBasedErrorFactory.getProperErrorMessage('optionNotAvail', 0, 0);
                                errorMessageFactory.showErrorMessage(' No está autorizado para usar esta opción', 0);
                                return false;
                            } else {
                                vm.loading = false;
                                pageRedirectToModify(data);
                                // vm.grantedCheckbox =  true;
                                // vm.showCheckbox = true;
                                // setBooleans(id , value , panelType , buttonName , index);
                                // $timeout(function (){

                                // },500)

                                // setFlagInJob(id, type)
                                // return true;
                            }
                        }
                    },
                    function (errorPayload) {
                        console.log(errorPayload);
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            } else {
                pageRedirectToModify(data);
            }
        };

        function pageRedirectToModify(data) {
            if (data.sin_respaldo == 1) {
                $state.go('layout.searchBookingMain.modifyBooking', {
                    id: data.job_id,
                    custId: data.created_by
                });
            } else {
                if (data.fleet_first_name) {
                    languageBasedErrorFactory.getProperErrorMessage('modifyError1', 0, 0);
                    //errorMessageFactory.showErrorMessage('Error, impossible to modify the booking because it is already assigned to a vehicle.',0);
                    return;
                } else if (data.auth_required == 1) {
                    languageBasedErrorFactory.getProperErrorMessage('modifyError2', 0, 0);
                    //errorMessageFactory.showErrorMessage('Error, impossible to modify the booking because it is under the authorization model.',0);
                    return;
                }
                // Tv-1885
                //  else if (data.is_round_trip == 1 && data.is_POS_booking != 1 || data.round_trip_parent_job_id > 0 && data.is_POS_booking != 1) {
                //     languageBasedErrorFactory.getProperErrorMessage('modifyError3', 0, 0);
                //     //errorMessageFactory.showErrorMessage('Error, impossible to modify the booking because it is round trip.',0);
                //     return;
                // }
                else if (data.shared_service_id) {
                    if (data.booking_type == 1 || data.booking_type == '1') {
                        var msg = 'La reserva no puede ser modificada porque forma parte del servicio compartido #' + data.shared_service_id + ' ya ruteado. Puede cancelar la reserva y hacer una nueva, o solicitar que se saque del servicio compartido ruteado y luego modificarla'
                    } else if (data.booking_type == 2 || data.booking_type == '2') {
                        var msg = 'La reserva no puede ser modificada porque forma parte del servicio agrupado #' + data.shared_service_id + ' ya creado. Puede cancelar la reserva y hacer una nueva, o solicitar que se saque del servicio agrupado y luego modificarla'
                    }
                    errorMessageFactory.showErrorMessage(msg, 0);
                    return;
                } else if (data.locking_id) {
                    if (data.booking_type == 1 || data.booking_type == '1') {
                        var msg = 'La reserva está bloqueada por usuario' + ' ' + data.locking_name + ' ' + 'para la creación o modificación del paquete';
                        // var msg = 'La reserva no se puede modificar porque se está convirtiendo en parte del nuevo servicio compartido ya enrutado. Puede cancelar la reserva y crear una nueva, o solicitar que se elimine del servicio compartido enrutado y luego modificarlo';
                    } else if (data.booking_type == 2 || data.booking_type == '2') {
                        var msg = 'La reserva está bloqueada por usuario' + ' ' + data.locking_name + ' ' + 'para la creación o modificación del paquete';
                        // var msg = 'La reserva no se puede modificar porque se está convirtiendo en parte del nuevo servicio agrupado ya enrutado. Puede cancelar la reserva y crear una nueva, o solicitar que se elimine del servicio agrupado y luego modificarla';
                    }
                    errorMessageFactory.showErrorMessage(msg, 0);
                    return;
                } else {
                    $state.go('layout.searchBookingMain.modifyBooking', {
                        id: data.job_id,
                        custId: data.created_by
                    });
                }
            }
        }
        //======================modify booking======================
        //=============================make job status change============================
        function makeBookingStatusChange(data, $event, type) {
            var msg = '';
            var jobStatus = '';
            if (type == 'cancel') {
                //msg = languageBasedErrorFactory.getProperErrorMessage('cancelledMessage',0,'3');
                if (data.locking_id) {
                    if (data.booking_type == 1 || data.booking_type == '1') {
                        var msg = 'La reserva está bloqueada por usuario' + ' ' + data.locking_name + ' ' + 'para la creación o modificación del paquete';
                        // var msg = 'La reserva no se puede cancelar porque se está convirtiendo en parte del nuevo servicio compartido ya enrutado. Puede crear uno nuevo o solicitar que se elimine del servicio compartido enrutado y luego cancelarlo';
                    } else if (data.booking_type == 2 || data.booking_type == '2') {
                        var msg = 'La reserva está bloqueada por usuario' + ' ' + data.locking_name + ' ' + 'para la creación o modificación del paquete';
                        // var msg = 'La reserva no se puede cancelar porque se está convirtiendo en parte del nuevo servicio agrupado ya enrutado. Puede crear uno nuevo o solicitar que se elimine del servicio agrupado y luego cancelarlo';
                    } else if (data.booking_type == 0 || data.booking_type == '0') {
                        var msg = 'La reserva está bloqueada por usuario' + ' ' + data.locking_name + ' ' + 'para la creación o modificación del paquete';
                        // var msg = 'La reserva no se puede modificar porque se está convirtiendo en parte del nuevo servicio agrupado ya enrutado. Puede cancelar la reserva y crear una nueva, o solicitar que se elimine del servicio agrupado y luego modificarla';
                    }
                    errorMessageFactory.showErrorMessage(msg, 0);
                    return;
                } else {
                    jobStatus = 9;
                    getCancelReasonHit($event, data, jobStatus);
                }
            }
        };
        //=========================get cancel reason hit=========================
        function getCancelReasonHit($event, data, jobStatus) {
            vm.loading = true;
            var dataSend = {};
            dataSend.key = 0;
            dataSend.channel = 2;
            dataSend.payment_method = data.payment_method;
            var promise = getCancelReason.getCancelReasonList(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.data && payload.title.data.length) {
                        vm.cancelReasonList = payload.title.data;
                    } else {
                        vm.cancelReasonList = [];
                    }
                    openCancelPopup($event, data, jobStatus, vm.cancelReasonList);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        function getAdminListAccordingToRoleApi() {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.access = 'Autorizar Anulación de Reserva';
            var promise = getBookings.getAdminListAccordingToRole(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    console.log(payload, 'payload');

                    if (payload.title.status == 200) {
                        vm.adminList = payload.title.data;
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        getAdminListAccordingToRoleApi();

        function openCancelPopup($event, data, jobStatus, cancelList) {
            var popUpToOpen = '';
            vm.cancelPopItems = {
                jobData: data,
                job_id: data.job_id,
                cancelReasonList: cancelList,
                reasonSelected: '',
                jobStatus: jobStatus,
                adminList: vm.adminList,
                cancellation_description: '',
                flagForConfirm: false,
                flagForValidateButton: false,
                message: '',
                password: '',
                authorize_id: null,
                RequiredMessage: '',
                RequiredMessageEmail: ''
            };
            var currentShiftId = $cookies.get('saleShiftId');
            if (data.shift_id != null && currentShiftId != undefined && data.shift_id == currentShiftId) {
                if (cancelList[0].payment_data.is_refund == 1) {
                    if (data.payment_status == 1) {
                        vm.openHit = true;
                        popUpToOpen = 'app/components/dialogViews/cancelBookingPopUpNew.html';
                    }
                } else {
                    vm.openHit = false;
                    popUpToOpen = 'app/components/dialogViews/cancelBookingPopUp.html';
                }
            } else if (data.shift_id != null && currentShiftId != undefined && data.shift_id != currentShiftId) {
                if (cancelList[0].payment_data.is_refund == 1) {
                    if (data.payment_status == 1) {
                        vm.cancelPopItems.flagForConfirm = true;
                        vm.openHit = true;
                        popUpToOpen = 'app/components/dialogViews/cancelBookingPopUpAuthorization.html';
                    }
                } else {
                    vm.openHit = false;
                    popUpToOpen = 'app/components/dialogViews/cancelBookingPopUp.html';
                }
            } else {
                vm.openHit = false;
                popUpToOpen = 'app/components/dialogViews/cancelBookingPopUp.html';
            }

            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: popUpToOpen,
                locals: {
                    items: vm.cancelPopItems
                },
                bindToController: true,
                controller: CancelMarkController
            });

            function CancelMarkController($scope, $mdDialog, items) {
                $scope.cancelPopItems = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    changeJobStatusOfBooking($scope.cancelPopItems, jobStatus);
                };
                $scope.validatorAutorizator = function () {
                    if ($scope.cancelPopItems.password == '' || $scope.cancelPopItems.password == undefined || $scope.cancelPopItems.password == null) {
                        $scope.cancelPopItems.RequiredMessage = 'This feild is required'
                        $timeout(function () {
                            $scope.cancelPopItems.RequiredMessage = '';
                        }, 2000)
                    }
                    if ($scope.cancelPopItems.email == '' || $scope.cancelPopItems.email == undefined ||
                        $scope.cancelPopItems.email == null) {
                        $scope.cancelPopItems.RequiredMessageEmail = 'This feild is required'
                        $timeout(function () {
                            $scope.cancelPopItems.RequiredMessageEmail = '';
                        }, 2000)
                    }
                    if ($scope.cancelPopItems.email == '' || $scope.cancelPopItems.password == '' || $scope.cancelPopItems.email == undefined ||
                        $scope.cancelPopItems.email == null || $scope.cancelPopItems.password == undefined || $scope.cancelPopItems.password == null) {
                        return true;
                    }
                    // vm.loading = true;
                    var dataSend = {};
                    dataSend.email = $scope.cancelPopItems.email;
                    dataSend.password = $scope.cancelPopItems.password;
                    var promise = getBookings.validatePassword(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log(payload);
                            // vm.loading = false;
                            if (payload.title.status == 200) {
                                $scope.cancelPopItems.flagForConfirm = false;
                                $scope.cancelPopItems.flagForValidateButton = true;
                                $scope.cancelPopItems.authorize_id = payload.title.data[0].admin_id;
                                $scope.cancelPopItems.message = '';
                                $scope.cancelPopItems.RequiredMessage = '';
                                $scope.cancelPopItems.RequiredMessageEmail = '';
                            } else {
                                $scope.cancelPopItems.message = payload.title.message;
                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }
            }
        }

        function changeJobStatusOfBooking(data, jobStatus) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.job_id = data.job_id;
            dataSend.job_status = jobStatus;
            if (jobStatus == 9) {
                dataSend.cancellation_reason = data.reasonSelected.reason;
                dataSend.cancellation_reason_id = data.reasonSelected.reason_id;
                dataSend.cancellation_description = data.cancellation_description;
                if (data.cancelReasonList[0].payment_data.is_refund == 1 || data.cancelReasonList[0].payment_data.is_refund == 0) {
                    dataSend.cancellation_method_id = data.cancelReasonList[0].payment_data.refund_payment_id;
                    dataSend.cancellation_payment_amount = data.jobData.round_trip ? data.jobData.total_refund_amount : data.jobData.estimated_payment_cost;
                    if (($cookies.get('saleShiftId')) != undefined || ($cookies.get('saleShiftId')) != null)
                        dataSend.cancellation_shift_id = Number($cookies.get('saleShiftId'));
                }
                if (data.authorize_id)
                    dataSend.authorize_id = data.authorize_id;
            }
            vm.loading = true;
            var promise = getBookings.changeJobStatus(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    // languageBasedErrorFactory.getProperErrorMessage('noShowSucc', 0, 1, 'layout.searchBookingMain.searchBooking')
                    if (payload.title.status == 200) {
                        if (vm.openHit)
                            getThermalPrintHeightCancel(data);
                        else errorMessageFactory.showErrorMessage('Estado cambiado exitosamente', 1);
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    //errorMessageFactory.showErrorMessage('Job status changed successfully.',1);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        /// print pop for cancel popUp
        function getThermalPrintHeightCancel(data) {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.job_id = data.jobData.job_id;
            var promise = getBookings.getCancelThermalPrint(dataSend);
            promise.then(function (payload) {
                    $log.log('sxdsads', payload);
                    console.log(payload, 'booking pdf');
                    if (payload.title.status == 200) {
                        document.getElementById('cancelPrint').innerHTML = payload.title.data;
                        setTimeout(function () {
                            document.querySelector('table.mainHeader-3').style.width = '100%';
                            document.querySelector('table.mainHeader-2').style.width = '100%';
                        }, 500);
                        $timeout(function () {
                            getThermalPrintCancel(data, payload.title.data);
                        }, 100);
                    } else {
                        vm.loading = false;
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function getThermalPrintCancel(data, payload) {
            $log.log(data);
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.job_id = Number(data.jobData.job_id);
            dataSend.timezone = new Date().getTimezoneOffset();
            dataSend.height = $('#cancelPrint').height() + 200;
            dataSend.variableDetailsThermal = payload;
            vm.loading = true;
            var promise = getBookings.printReceipt(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;

                    function PrintDiv() {
                        var contents = document.getElementById("cancelPrint").innerHTML;
                        var frame1 = document.createElement('iframe');
                        frame1.name = "frame1";
                        // frame1.value = "frame12"
                        frame1.style.position = "absolute";
                        frame1.style.top = "-1000000px";
                        document.body.appendChild(frame1);
                        var frameDoc = frame1.contentWindow ? frame1.contentWindow : frame1.contentDocument.document ? frame1.contentDocument.document : frame1.contentDocument;
                        frameDoc.document.open();
                        // frameDoc.document
                        frameDoc.document.write();
                        frameDoc.document.write();
                        frameDoc.document.write(contents);
                        frameDoc.document.write();
                        frameDoc.document.close();
                        // setTimeout(function () {
                        //     window.frames["frame1"].focus();
                        //     window.frames["frame1"].print();
                        //     document.body.removeChild(frame1);
                        //     if (vm.printCount == 0) {
                        //         getPrintReceiptHeight(vm.secondPrint, 'SecondPrint');
                        //         vm.printCount++;
                        //     }
                        // }, 500);
                        // return false;

                        frame1.onload = function () {
                            // setTimeout(function () {
                            window.frames["frame1"].focus();
                            window.frames["frame1"].print();
                            document.body.removeChild(frame1);
                            // }, 500);
                            return false;
                        };
                        frame1.onerror = function () {
                            errorMessageFactory.showErrorMessage('Please try again', 0);
                            return false;
                        };
                    }
                    PrintDiv();
                    errorMessageFactory.showErrorMessage('Estado cambiado exitosamente', 1);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            )
        }

        //======================print receipt api=============================
        function printReceiptApi(data) {
            // if(data.type_of_trip != 'Z'){
            //     errorMessageFactory.showErrorMessage("¡Lo siento! no está permitido imprimir este comprobante", 0);
            //     return false
            // }
            $log.log(data);
            vm.loading = true;
            var promise = adminAccessService.checkStateValid('Print Receipt'); //$stateParams.id
            return promise.then(
                function (payload) {
                    vm.loading = false;
                    console.log(payload);
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (!payload.title.data.granted) {
                            languageBasedErrorFactory.getProperErrorMessage('optionNotAvail', 0, 0);
                            //errorMessageFactory.showErrorMessage('Option not available because you not have the right',0);
                            return false;
                        } else {
                            vm.loading = false;
                            getPrintReceiptHeight(data);
                            return true;
                        }
                    }
                },
                function (errorPayload) {
                    console.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        //======================print receipt=========================
        function getPrintReceiptHeight(data) {
            console.log(data, 'data====================');

            // if(data.type_of_trip != 'Z'){
            //     errorMessageFactory.showErrorMessage("¡Lo siento! no está permitido imprimir este comprobante", 0);
            //     return false
            // }
            $log.log(data);
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.job_id = Number(data.job_id);
            dataSend.timezone = new Date().getTimezoneOffset();
            vm.loading = true;
            var promise = getBookings.getHeightForPrint(dataSend);
            promise.then(function (payload) {
                    if (payload.title.status == 200) {
                        vm.loading = false;
                        $log.log('sxdsads', payload);
                        document.getElementById('showPrint').innerHTML = payload.title.data;
                        // ticket 1702
                        setTimeout(function () {
                            document.querySelector('table.mainHeader-1').style.width = '100%';
                        }, 500);
                        $timeout(function () {
                            getPrintReceiptLink(data, payload.title.data);
                            document.querySelector('table.mainHeader-1').style.width = '100%';
                        }, 0);
                        // $timeout(function () {
                        //     getPrintReceiptLink(data, payload.title.data);
                        // }, 0);
                    } else {
                        vm.loading = false;
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        var win = '';

        function getPrintReceiptLink(data, payload) {
            $log.log(data);
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.job_id = Number(data.job_id);
            dataSend.timezone = new Date().getTimezoneOffset();
            dataSend.height = $('#showPrint').height() + 200;
            dataSend.variableDetailsThermal = payload;
            vm.loading = true;
            var promise = getBookings.printReceipt(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    // document.getElementById('showPrint').innerHTML = '';
                    // if (win) {
                    //     win.close();
                    // }
                    // win = window.open("", "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=" + (screen.width) + ",height=" + (screen.height) + ",top=0,left=0");
                    // win.document.body.innerHTML = '<iframe src="' + payload.title.data + '" height=' + screen.height + ' width=' + screen.width + '></ifrmae>';
                    // ticket 1702
                    function PrintDiv() {
                        var contents = document.getElementById("showPrint").innerHTML;
                        var frame1 = document.createElement('iframe');
                        frame1.name = "frame1";
                        // frame1.value = "frame12"
                        frame1.style.position = "absolute";
                        frame1.style.top = "-1000000px";
                        document.body.appendChild(frame1);
                        var frameDoc = frame1.contentWindow ? frame1.contentWindow : frame1.contentDocument.document ? frame1.contentDocument.document : frame1.contentDocument;
                        frameDoc.document.open();
                        // frameDoc.document
                        frameDoc.document.write();
                        frameDoc.document.write();
                        frameDoc.document.write(contents);
                        frameDoc.document.write();
                        frameDoc.document.close();
                        // setTimeout(function () {
                        //     window.frames["frame1"].focus();
                        //     window.frames["frame1"].print();
                        //     document.body.removeChild(frame1);

                        // }, 500);
                        // return false;

                        frame1.onload = function () {
                            // setTimeout(function () {
                            window.frames["frame1"].focus();
                            window.frames["frame1"].print();
                            document.body.removeChild(frame1);
                            // }, 500);
                            return false;
                        };
                        frame1.onerror = function () {
                            errorMessageFactory.showErrorMessage('Please try again', 0);
                            return false;
                        };


                    }
                    PrintDiv();
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            )
        }

        //=======================make payment==========================
        function makePayment(data, $event) {
            console.log(data);
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.offset = 0;
            dataSend.limit = 0;
            dataSend.key = 3;
            dataSend.id = data.agreementId;
            vm.loading = true;
            var promise = getAgreement.allAgreementBooking(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    payload.title.data.result[0].paymentNew = [];
                    var index = -1;
                    for (var i = 0; i < payload.title.data.result[0].payment.length; i++) {
                        payload.title.data.result[0].payment[i].selected = false;
                        index = -1;
                        index = _.findIndex(payload.title.data.result[0].paymentNew, {
                            id: payload.title.data.result[0].payment[i].id
                        });
                        if (index == -1)
                            payload.title.data.result[0].paymentNew.push(payload.title.data.result[0].payment[i]);
                    }
                    for (var i = 0; i < payload.title.data.result[0].paymentNew.length; i++) {
                        if (payload.title.data.result[0].paymentNew[i].id == payload.title.data.result[0].payment_method_default.id) {
                            payload.title.data.result[0].paymentNew[i].selected = true;
                        }
                    }
                    openPopForPayment(payload.title.data.result[0], data, $event);
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function openPopForPayment(agreementData, data, $event) {
            vm.items = {
                job_id: data.job_id,
                jobData: data,
                agreementData: agreementData,
                print: false,
                loading: false,
                paymentSelected: agreementData.payment_method_default
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/makePaymentForSearch.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: PaymentMarkController
            });

            function PaymentMarkController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    console.log($scope.items);
                    $mdDialog.hide();
                    makeSearchedBookingPaid($scope.items);
                };

                $scope.selectParticularPayment = function (data) {
                    $scope.items.paymentSelected = data;
                    for (var i = 0; i < $scope.items.agreementData.paymentNew.length; i++) {
                        if ($scope.items.agreementData.paymentNew[i].id != $scope.items.paymentSelected.id) {
                            $scope.items.agreementData.paymentNew[i].selected = false;
                        }
                    }
                }
            }
        }


        function checkModifyStatus(data) {
            if (data.sin_respaldo == 1) {
                if (data.job_status == '0' || data.job_status == '1' || data.job_status == '2' || data.job_status == '4' ||
                    data.job_status == '7' || data.job_status == '9' || data.job_status == '12' || data.job_status == '14' || data.job_status == '15') {
                    return false;
                } else {
                    return true;
                }

            } else {
                if (data.job_status == '2' || data.job_status == '3' || data.job_status == '9' || data.job_status == '10' ||
                    data.job_status == '11' || data.job_status == '12') {
                    return true;
                } else {
                    return false;
                }
            }
        }

        //================================make api hit============================
        function makeSearchedBookingPaid(data) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.payment_status = 1;
            dataSend.job_id = data.job_id;
            //dataSend.POS_payment_method = data.paymentSelected.id;
            dataSend.payment_method = data.paymentSelected.id;
            vm.loading = true;
            var promise = getBookings.makePaymentFromSearchApi(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    errorMessageFactory.showErrorMessage('Pago realizado con éxito');
                    vm.showPaidButton = true;
                    if (data.print) {
                        getPrintReceiptHeight(data);
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        // // GET FILTERS DATA FROM BACKEND    
        // //====================get branch list====================
        // function getBranch() {
        //     //     vm.branchList = [];
        //     //     vm.branchList = JSON.parse(JSON.stringify(getFilters.branchesFiltersData.data));
        //     //     vm.branchList.push({
        //     //         region_name: 'All',
        //     //         region_id: 'all'
        //     //     });
        //     // $scope.$apply();


        //     vm.loading = true;
        //     var promise = getGeofence.branch();
        //     promise.then(
        //         function (payload) {
        //             $log.log(payload);
        //             //vm.loading = false;
        //             if (payload.title.status == 400) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //             } else if (payload.title.status == 401) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //             } else if (payload.title.status == 201 || payload.title.status == 200) {
        //                 var where = _.where(payload.title.data, {
        //                     parent_id: 0
        //                 });
        //                 //vm.branchList = _.where(where, { is_active: 1 });
        //                 vm.branchList = where;

        //                 vm.branchList.push({
        //                     region_name: 'All',
        //                     region_id: 'all'
        //                 });
        //             }
        //         },
        //         function (errorPayload) {
        //             $log.log(errorPayload);
        //             vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // }
        // // WHen Page refresh service take time to get data from backend
        // // setTimeout(function () {
        // getBranch();
        // // }, 1000);
        // //======================get all vehicles==============
        // function getAllVehicles(skip, limt, filter) {
        //     // vm.vehicle = [];
        //     // angular.forEach(getFilters.vehiclesFiltersData.data, function (column) {
        //     //     vm.vehicle.push({
        //     //         id: column.id,
        //     //         name: column.name
        //     //     })
        //     // });
        //     // vm.vehicle.push({
        //     //     id: 'all',
        //     //     name: 'All'
        //     // });
        //     vm.loading = false;
        //     var promise = getVehicles.allVehicles(skip, limt, filter);
        //     promise.then(
        //         function (payload) {
        //             $log.log('sxdsads', payload);
        //             //vm.loading = false;
        //             if (payload.title.status == 400) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //             } else if (payload.title.status == 401) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //             } else if (payload.title.status == 201 || payload.title.status == 200) {
        //                 vm.vehicle = [];
        //                 angular.forEach(payload.title.data.result, function (column) {
        //                     vm.vehicle.push({
        //                         id: column.id,
        //                         name: column.name
        //                     })
        //                 });
        //                 vm.vehicle.push({
        //                     id: 'all',
        //                     name: 'All'
        //                 });
        //             }
        //         },
        //         function (errorPayload) {
        //             $log.log(errorPayload);
        //             //vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // };
        // // WHen Page refresh service take time to get data from backend
        // // setTimeout(function () {
        // getAllVehicles(0, 0, 2);
        // // }, 1000);
        // //======================get all services==============
        // function getAllServices(skip, limit) {
        //     // vm.service = [];
        //     // angular.forEach(getFilters.servicesFiltersData.data, function (column) {
        //     //     vm.service.push({
        //     //         id: column.id,
        //     //         name: column.service_name
        //     //     });
        //     // });
        //     // vm.service.push({
        //     //     id: 'all',
        //     //     name: 'All'
        //     // });

        //     vm.loading = false;
        //     var promise = getServices.allServices(skip, limit, 2);
        //     promise.then(
        //         function (payload) {
        //             $log.log('sxdsads', payload);
        //             //vm.loading = false;
        //             if (payload.title.status == 400) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //             } else if (payload.title.status == 401) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //             } else if (payload.title.status == 201 || payload.title.status == 200) {
        //                 vm.service = [];
        //                 angular.forEach(payload.title.data.result, function (column) {
        //                     vm.service.push({
        //                         id: column.id,
        //                         name: column.service_name
        //                     });
        //                 });
        //                 vm.service.push({
        //                     id: 'all',
        //                     name: 'All'
        //                 })
        //             }
        //         },
        //         function (errorPayload) {
        //             $log.log(errorPayload);
        //             vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // };
        // // WHen Page refresh service take time to get data from backend
        // // setTimeout(function () {
        // getAllServices(0, 0);
        // // }, 1000);

        // //======================get all Agreement==============
        // function getAllAgreement(skip, limt) {
        //     var dataSend = {};
        //     dataSend.access_token = $cookies.get('obj');
        //     dataSend.offset = skip;
        //     dataSend.limit = limt;
        //     dataSend.key = 3;
        //     //vm.loading = false;

        //     var promise = getAgreement.getAgreementListLessData(dataSend);
        //     promise.then(
        //         function (payload) {
        //             $log.log('sxdsads', payload);
        //             //vm.loading = false;
        //             if (payload.title.status == 400) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //             } else if (payload.title.status == 401) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //             } else if (payload.title.status == 201 || payload.title.status == 200) {
        //                 vm.agreement = [];
        //                 angular.forEach(payload.title.data, function (column) {
        //                     vm.agreement.push({
        //                         id: column.id,
        //                         name: column.name
        //                     });
        //                 });
        //                 vm.agreement.push({
        //                     id: 'all',
        //                     name: 'All'
        //                 });
        //             }
        //         },
        //         function (errorPayload) {
        //             $log.log(errorPayload);
        //             //vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // };
        // getAllAgreement(0, 0);

        // // ******** CLEAR OFFSET *******
        // // function clearOffset() {
        // //     for (var i = 0; i < vm.searchFilterArray.length; i++) {
        // //         vm[vm.searchFilterArray[i] + 'Offset'] = 0;
        // //     }
        // // }
        // //=================filter change functions=================
        // function branchChanged() {
        //     console.log('>>>> vm.filterData.searchPackageId >>>>>.', vm.filterData.searchPackageId);
        //     console.log('>>>> vm.filterData.searchBookingId >>>>>.', vm.filterData.searchBookingId);
        //     vm.currentPage = 0;

        //     // vm.filterData.searchBookingId = '';
        //     // vm.filterData.searchPackageId = '';

        //     //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
        //     //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
        //     //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
        //     // clearOffset();
        //     if (vm.filterData.branch && vm.filterData.branch != 'all') {
        //         vm.filterData.branch_filter = 1;
        //         if (vm.filterData.searchPackageId || vm.filterData.searchBookingId)
        //             getAllBooking(vm.filterData);
        //         // vm.agreement = [];
        //         // vm.branchList = [];
        //         // vm.vehicle = [];
        //         // vm.service = [];
        //         // getFilterDataFromBackend();
        //     } else {
        //         vm.filterData.branch_filter = 0;
        //         vm.filterData.branch = 'all';
        //         if (vm.filterData.searchPackageId || vm.filterData.searchBookingId)
        //             getAllBooking(vm.filterData);
        //         // vm.agreement = [];
        //         // vm.branchList = [];
        //         // vm.vehicle = [];
        //         // vm.service = [];
        //         // getFilterDataFromBackend();
        //     }
        // };

        // function agreementChanged() {
        //     vm.currentPage = 0;

        //     // vm.filterData.searchBookingId = '';
        //     // vm.filterData.searchPackageId = '';

        //     //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
        //     //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
        //     //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
        //     // clearOffset();
        //     if (vm.filterData.agreement && vm.filterData.agreement != 'all') {
        //         vm.filterData.aggrement_filter = 1;
        //         if (vm.filterData.searchPackageId || vm.filterData.searchBookingId)
        //             getAllBooking(vm.filterData);
        //         // vm.agreement = [];
        //         // vm.branchList = [];
        //         // vm.vehicle = [];
        //         // vm.service = [];
        //         // getFilterDataFromBackend();
        //     } else {
        //         vm.filterData.aggrement_filter = 0;
        //         vm.filterData.agreement = 'all';
        //         if (vm.filterData.searchPackageId || vm.filterData.searchBookingId)
        //             getAllBooking(vm.filterData);
        //         // vm.agreement = [];
        //         // vm.branchList = [];
        //         // vm.vehicle = [];
        //         // vm.service = [];
        //         // getFilterDataFromBackend();
        //     }
        // };

        // function serviceChanged() {
        //     vm.currentPage = 0;

        //     // vm.filterData.searchBookingId = '';
        //     // vm.filterData.searchPackageId = '';

        //     //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
        //     //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
        //     //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
        //     // clearOffset();
        //     if (vm.filterData.service && vm.filterData.service != 'all') {
        //         vm.filterData.service_filter = 1;
        //         if (vm.filterData.searchPackageId || vm.filterData.searchBookingId)
        //             getAllBooking(vm.filterData);
        //         // vm.agreement = [];
        //         // vm.branchList = [];
        //         // vm.vehicle = [];
        //         // vm.service = [];
        //         // getFilterDataFromBackend();
        //     } else {
        //         vm.filterData.service_filter = 0;
        //         vm.filterData.service = 'all';
        //         if (vm.filterData.searchPackageId || vm.filterData.searchBookingId)
        //             getAllBooking(vm.filterData);
        //         // vm.agreement = [];
        //         // vm.branchList = [];
        //         // vm.vehicle = [];
        //         // vm.service = [];
        //         // getFilterDataFromBackend();
        //     }
        // };

        // function vehicleChanged() {
        //     vm.currentPage = 0;

        //     // vm.filterData.searchBookingId = '';
        //     // vm.filterData.searchPackageId = '';

        //     //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
        //     //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
        //     //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
        //     // clearOffset();
        //     if (vm.filterData.vehicle && vm.filterData.vehicle != 'all') {
        //         vm.filterData.vehicle_filter = 1;
        //         if (vm.filterData.searchPackageId || vm.filterData.searchBookingId)
        //             getAllBooking(vm.filterData);
        //         // vm.agreement = [];
        //         // vm.branchList = [];
        //         // vm.vehicle = [];
        //         // vm.service = [];
        //         // getFilterDataFromBackend();
        //     } else {
        //         vm.filterData.vehicle_filter = 0;
        //         vm.filterData.vehicle = 'all';
        //         if (vm.filterData.searchPackageId || vm.filterData.searchBookingId)
        //             getAllBooking(vm.filterData);
        //         // vm.agreement = [];
        //         // vm.branchList = [];
        //         // vm.vehicle = [];
        //         // vm.service = [];
        //         // getFilterDataFromBackend();
        //     }
        // };

        // function typeTripChanged() {
        //     vm.currentPage = 0;

        //     // vm.filterData.searchBookingId = '';
        //     // vm.filterData.searchPackageId = '';

        //     //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
        //     //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
        //     //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
        //     if (vm.filterData.type_of_trip && vm.filterData.type_of_trip != 'all') {
        //         vm.filterData.type_of_trip_filter = 1;
        //         if (vm.filterData.searchPackageId || vm.filterData.searchBookingId)
        //             getAllBooking(vm.filterData);
        //         // vm.agreement = [];
        //         // vm.branchList = [];
        //         // vm.vehicle = [];
        //         // vm.service = [];
        //         // getFilterDataFromBackend();
        //     } else {
        //         vm.filterData.type_of_trip_filter = 0;
        //         vm.filterData.type_of_trip = 'all';
        //         if (vm.filterData.searchPackageId || vm.filterData.searchBookingId)
        //             getAllBooking(vm.filterData);
        //         // vm.agreement = [];
        //         // vm.branchList = [];
        //         // vm.vehicle = [];
        //         // vm.service = [];
        //         // getFilterDataFromBackend();
        //     }
        // };

        // //function pickupDateChanged(){
        // //    vm.currentPage = 0;
        // //    console.log(vm.filterData.filter_pickup_date_value);
        // //    if(vm.filterData.filter_pickup_date_value){
        // //        vm.filterData.date_time_filter = 1;
        // //        getAllBooking(vm.filterData); 
        // //    }
        // //    else{
        // //        vm.filterData.date_time_filter = 0;
        // //        vm.filterData.filter_pickup_date_value = '';
        // //        getAllBooking(vm.filterData); 
        // //    }
        // //};
        // //
        // //function pickupTimeChanged(){
        // //    vm.currentPage = 0;
        // //    console.log(vm.filterData.filter_pickup_time_value);
        // //    if(vm.filterData.filter_pickup_time_value && vm.filterData.filter_pickup_date_value){
        // //        vm.filterData.date_time_filter = 1;
        // //        getAllBooking(vm.filterData); 
        // //    }
        // //    else if(vm.filterData.filter_pickup_date_value){
        // //        vm.filterData.date_time_filter = 1;
        // //        //vm.filterData.filter_pickup_time_value = '';
        // //        //if(vm.filterData.filter_pickup_date_value)
        // //            getAllBooking(vm.filterData); 
        // //    }
        // //    else{
        // //        vm.filterData.date_time_filter = 0;
        // //        //vm.filterData.filter_pickup_time_value = '';
        // //        //if(vm.filterData.filter_pickup_date_value)
        // //        getAllBooking(vm.filterData); 
        // //    }
        // //};

        // function resetFilter() {
        //     vm.currentPage = 0;
        //     vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
        //     vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
        //     vm.filterData = {
        //         branch_filter: 0, //0, 1
        //         service_filter: 0, //0, 1
        //         vehicle_filter: 0, //0, 1
        //         aggrement_filter: 0, //0, 1
        //         //date_time_filter : 0,  //0, 1
        //         type_of_trip_filter: 0, //0, 1
        //         branch: 'all',
        //         service: 'all',
        //         vehicle: 'all',
        //         // type_of_trip: 'From Airport',
        //         //date_time_value: '',
        //         agreement: 'all',
        //         //filter_pickup_date_value: getNextDate(),
        //         //filter_pickup_time_value: showFilterTime(),
        //         limit: vm.itemsPerPageGot,
        //         offset: 0,
        //         booking_status: 0,
        //         searchBookingId: '',
        //         searchPackageId: '',
        //         search: '',
        //         itemsPerPageSelected: 25,
        //         filter_pickup_from_date_value: getFirstDateOfPreviousMonth(),
        //         filter_pickup_to_date_value: setToPickupDate(),
        //         filter_pickup_from_time_value: showFilterTime(1),
        //         filter_pickup_to_time_value: showFilterTime(2),
        //     };
        //     console.log(vm.filterData, ' vm.filterData ===========');

        //     vm.dateOptions = {
        //         //dateDisabled: disabled,
        //         formatYear: 'yy',
        //         // maxDate: new Date(),
        //         // minDate: new Date(vm.filterData.filter_pickup_from_date_value),
        //         startingDay: 1,
        //         showWeeks: false,

        //     };
        //     if (vm.filterData.searchPackageId || vm.filterData.searchBookingId)
        //         getAllBooking(vm.filterData);
        // }

        // vm.pickupFromToDateChanged = function (data) {
        //     vm.dateOptions = {
        //         //dateDisabled: disabled,
        //         formatYear: 'yy',
        //         // maxDate: new Date(),
        //         // minDate: new Date(vm.filterData.filter_pickup_from_date_value),
        //         startingDay: 1,
        //         showWeeks: false,

        //     };
        //     if (vm.filterData.searchPackageId || vm.filterData.searchBookingId)
        //         getAllBooking(vm.filterData);

        // }

        // function setToPickupDate() {
        //     var x = new Date();
        //     var yesterday = new Date(x.getTime() + (24 * 60 * 60 * 1000));

        //     return yesterday;

        // }

        // function getFirstDateOfPreviousMonth() {
        //     var date = new Date();
        //     var yesterday = new Date(date.getTime() - 24 * 60 * 60 * 1000);
        //     return yesterday;
        // }

        // function showFilterTime(type) {
        //     if (type == 1) {
        //         var x = new Date();
        //         x.setHours('00');
        //         x.setMinutes('00');
        //         x.setSeconds('00');
        //         return x;
        //     } else {
        //         var x = new Date();
        //         x.setHours('23');
        //         x.setMinutes('59');
        //         x.setSeconds('00');
        //         return x;
        //     }

        // }

        // function datePickerE_3(type) {
        //     if (type == 1) {
        //         vm.datePicker_1.pickupFromDate = true;
        //         vm.datePicker_1.pickupToDate = false;

        //     } else if (type == 2) {
        //         vm.datePicker_1.pickupFromDate = false;
        //         vm.datePicker_1.pickupToDate = true;
        //     }
        // };

        // function datePickerE_1() {
        //     vm.datePicker_1.pickupDate = true;
        // };

        // //====================date time format====================
        // function dateTimeFormat(dateGot, timeGot) {
        //     var dateToChange = new Date(dateGot);
        //     var timeGotChange = new Date(timeGot);
        //     if (timeGotChange) {
        //         dateToChange.setHours(timeGotChange.getHours());
        //         dateToChange.setMinutes(timeGotChange.getMinutes());
        //         dateToChange.setSeconds(timeGotChange.getSeconds());
        //     } else {
        //         dateToChange.setHours(0);
        //         dateToChange.setMinutes(0);
        //         dateToChange.setSeconds(0);
        //     }
        //     return dateToChange;

        // };


        function changeDateIntoSpanish(date) {
            var options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            };
            return new Date(date).toLocaleString($cookies.get('language') == 'spanish' ? 'es' : 'en', options)
        }
    }
})();

/**
 * Created by cl-macmini-51 on 4/14/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('QuickAssignmentController', QuickAssignmentController);

    /** @ngInject */
    function QuickAssignmentController($cookies, $state, $log, $http, MY_CONSTANT, $timeout, $rootScope, $interval, $scope, mapDashboard, getDrivers, getVehicles, getServices, getAgreement, getGeofence, $mdDialog, $document, getCars, adminAccessService, $filter, getBookings, languageBasedErrorFactory, errorMessageFactory, getFilters, Initializer) {
        var vm = this;
        var markers = [];
        var mc = null;
        vm.count = 0;
        vm.applyFilter = applyFilter;
        // vm.colorFlag = false;
        vm.colorFlag = [];
        vm.resetFilter = resetFilter;
        var map = null;
        vm.mapLoadsFlag = false;
        vm.ismeridian = true;
        vm.socketHandleMarker = false;
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.datePickerE_3 = datePickerE_3;
        vm.datePicker_1 = {
            scheduledDate: false,
            returnDate: false
        };
        // vm.dateOptions = {
        //     //dateDisabled: disabled,
        //     formatYear: 'yy',
        //     maxDate: new Date(2090, 12, 31),
        //     //minDate: new Date(),
        //     startingDay: 1,
        //     showWeeks: false,

        // };

        var myCenter;
        var infowindow;
        var trafficLayer;
        var bounds;
        var bermudaTriangle;

        // Service To Get Map Instance
        Initializer.mapsInitialized
            .then(function () {
                console.log('>>>> GOOGLE INIT', google);
                if (google) {
                    myCenter = new google.maps.LatLng(-33.447487, -70.673676);
                    infowindow = new google.maps.InfoWindow({
                        size: new google.maps.Size(150, 50)
                    });
                    trafficLayer = new google.maps.TrafficLayer();
                    bounds = new google.maps.LatLngBounds();
                    bermudaTriangle = new google.maps.Polygon();

                    showDrivers(0);

                    google.maps.event.addListener(infowindow, 'domready', function () {
                        //     var iwOuter = $('.gm-style-iw');
                        //     var iwBackground = iwOuter.prev();
                        //     // iwBackground.css({
                        //     //     heigth: '183px'
                        //     // });
                        //     // // iwOuter.css({
                        //     // //     top: '36px',
                        //     // //     left: '20px'
                        //     // // });
                        //     // iwOuter.css({
                        //     //     top: '0px',
                        //     //     left: '0px'
                        //     // });
                        //     // iwOuter.children().children(':nth-child(1)').css({
                        //     //     'overflow': 'hidden',
                        //     //     padding: '0px 18px'
                        //     // });

                        //     // iwOuter.css({
                        //     //     top: '36px',
                        //     //     left: '20px'
                        //     // });
                        //     iwOuter.children().children(':nth-child(1)').css({
                        //         'overflow': 'hidden',
                        //         // padding: '18px'
                        //     });

                        //     // Remove the background shadow DIV
                        //     iwBackground.children(':nth-child(2)').css({
                        //         'display': 'none'
                        //     });
                        //     // Remove the white background DIV
                        //     iwBackground.children(':nth-child(4)').css({
                        //         'display': 'none'
                        //     });
                        //     //iwOuter.parent().parent().css({ left: '115px' });
                        //     //// Moves the shadow of the arrow 76px to the left margin
                        //     //iwBackground.children(':nth-child(1)').attr('style', function (i, s) { return s + 'left: 76px !important;' });
                        //     //// Moves the arrow 76px to the left margin
                        //     //iwBackground.children(':nth-child(3)').attr('style', function (i, s) { return s + 'left: 76px !important;' });
                        //     iwBackground.children(':nth-child(3)').find('div').children().css({
                        //         'background-color': 'cornsilk',
                        //         'box-shadow': 'none'
                        //     });
                        //     var iwCloseBtn = iwOuter.next();
                        //     // Apply the desired effect to the close button
                        //     iwCloseBtn.css({
                        //         right: '52px',
                        //         top: '62px', // button repositioning
                        //         backgound: 'none'
                        //     });
                        //     // The API automatically applies 0.7 opacity to the button after the mouseout event.
                        //     // This function reverses this event to the desired value.
                        //     iwCloseBtn.mouseout(function () {
                        //         $(this).css({
                        //             opacity: '1'
                        //         });
                        //     });
                        //     $('#googleMapsDetailsWithCar').parent().addClass('col-lg-12 col-md-12 col-sm-12');
                        //     $('#googleMapsDetailsWithCar1').parent().addClass('col-lg-12 col-md-12 col-sm-12');
                        //     iwOuter.parent().addClass('custom-iw');
                        //     iwOuter.parent().parent().parent().css({
                        //         left: '51%'
                        //     });
                        //     if (vm.jobStatusOfMarker == 1) {
                        //         $('.pickUpStatus').removeClass('onRoadAcceptedColor');
                        //         $('.pickUpStatus').removeClass('inPositionColor');
                        //         $('.pickUpStatus').addClass('startedColor');

                        //         $('.statusChangeD').removeClass('inPositionColorB');
                        //         $('.statusChangeD').addClass('completedColorB');
                        //         $('.statusChangeD').removeClass('startedColorB');
                        //         $('.statusChangeD').removeClass('onRoadAcceptedColorB');
                        //     } else if (vm.jobStatusOfMarker == 7) {
                        //         $('.pickUpStatus').removeClass('startedColor');
                        //         $('.pickUpStatus').removeClass('inPositionColor');
                        //         $('.pickUpStatus').addClass('onRoadAcceptedColor');

                        //         $('.statusChangeD').removeClass('inPositionColorB');
                        //         $('.statusChangeD').removeClass('completedColorB');
                        //         $('.statusChangeD').removeClass('startedColorB');
                        //         $('.statusChangeD').addClass('onRoadAcceptedColorB');
                        //     } else if (vm.jobStatusOfMarker == 4) {
                        //         $('.pickUpStatus').removeClass('startedColor');
                        //         $('.pickUpStatus').removeClass('onRoadAcceptedColor');
                        //         $('.pickUpStatus').addClass('inPositionColor');

                        //         $('.statusChangeD').removeClass('inPositionColorB');
                        //         $('.statusChangeD').removeClass('completedColorB');
                        //         $('.statusChangeD').addClass('startedColorB');
                        //         $('.statusChangeD').removeClass('onRoadAcceptedColorB');
                        //     } else if (vm.jobStatusOfMarker == 15) {
                        //         $('.pickUpStatus').removeClass('startedColor');
                        //         $('.pickUpStatus').removeClass('inPositionColor');
                        //         $('.pickUpStatus').addClass('onRoadAcceptedColor');

                        //         $('.statusChangeD').addClass('inPositionColorB');
                        //         $('.statusChangeD').removeClass('completedColorB');
                        //         $('.statusChangeD').removeClass('startedColorB');
                        //         $('.statusChangeD').removeClass('onRoadAcceptedColorB');
                        //     }
                        // });

                        // google.maps.event.addListener(infowindow, 'domready', function () {
                        //     var iwOuter = $('.gm-style-iw');
                        //     var iwBackground = iwOuter.prev();
                        //     // iwBackground.css({
                        //     //     heigth: '183px'
                        //     // });
                        //     // // iwOuter.css({
                        //     // //     top: '36px',
                        //     // //     left: '20px'
                        //     // // });
                        //     // iwOuter.css({
                        //     //     top: '0px',
                        //     //     left: '0px'
                        //     // });
                        //     // iwOuter.children().children(':nth-child(1)').css({
                        //     //     'overflow': 'hidden',
                        //     //     padding: '0px 18px'
                        //     // });

                        //     // // iwOuter.css({
                        //     // //     top: '36px',
                        //     // //     left: '20px'
                        //     // // });
                        //     iwOuter.children().children(':nth-child(1)').css({
                        //         'overflow': 'hidden',
                        //         // padding: '18px'
                        //     });

                        //     // Remove the background shadow DIV
                        //     iwBackground.children(':nth-child(2)').css({
                        //         'display': 'none'
                        //     });
                        //     // Remove the white background DIV
                        //     iwBackground.children(':nth-child(4)').css({
                        //         'display': 'none'
                        //     });
                        //     //iwOuter.parent().parent().css({ left: '115px' });
                        //     //// Moves the shadow of the arrow 76px to the left margin
                        //     //iwBackground.children(':nth-child(1)').attr('style', function (i, s) { return s + 'left: 76px !important;' });
                        //     //// Moves the arrow 76px to the left margin
                        //     //iwBackground.children(':nth-child(3)').attr('style', function (i, s) { return s + 'left: 76px !important;' });
                        //     iwBackground.children(':nth-child(3)').find('div').children().css({
                        //         'background-color': 'cornsilk',
                        //         'box-shadow': 'none'
                        //     });
                        //     var iwCloseBtn = iwOuter.next();
                        //     // Apply the desired effect to the close button
                        //     iwCloseBtn.css({
                        //         right: '0px',
                        //         top: '15px', // button repositioning
                        //         backgound: 'none'
                        //     });
                        //     // The API automatically applies 0.7 opacity to the button after the mouseout event.
                        //     // This function reverses this event to the desired value.
                        //     iwCloseBtn.mouseout(function () {
                        //         $(this).css({
                        //             opacity: '1'
                        //         });
                        //     });
                        //     $('#googleMapsDetailsWithCar').parent().addClass('col-lg-12 col-md-12 col-sm-12');
                        //     $('#googleMapsDetailsWithCar1').parent().addClass('col-lg-12 col-md-12 col-sm-12');
                        //     iwOuter.parent().addClass('custom-iw');
                        //     iwOuter.parent().parent().parent().css({
                        //         left: '51%'
                        //     });
                        //     if (vm.jobStatusOfMarker == 1) {
                        //         $('.pickUpStatus').removeClass('onRoadAcceptedColor');
                        //         $('.pickUpStatus').removeClass('inPositionColor');
                        //         $('.pickUpStatus').addClass('startedColor');

                        //         $('.statusChangeD').removeClass('inPositionColorB');
                        //         $('.statusChangeD').addClass('completedColorB');
                        //         $('.statusChangeD').removeClass('startedColorB');
                        //         $('.statusChangeD').removeClass('onRoadAcceptedColorB');
                        //     } else if (vm.jobStatusOfMarker == 7) {
                        //         $('.pickUpStatus').removeClass('startedColor');
                        //         $('.pickUpStatus').removeClass('inPositionColor');
                        //         $('.pickUpStatus').addClass('onRoadAcceptedColor');

                        //         $('.statusChangeD').removeClass('inPositionColorB');
                        //         $('.statusChangeD').removeClass('completedColorB');
                        //         $('.statusChangeD').removeClass('startedColorB');
                        //         $('.statusChangeD').addClass('onRoadAcceptedColorB');
                        //     } else if (vm.jobStatusOfMarker == 4) {
                        //         $('.pickUpStatus').removeClass('startedColor');
                        //         $('.pickUpStatus').removeClass('onRoadAcceptedColor');
                        //         $('.pickUpStatus').addClass('inPositionColor');

                        //         $('.statusChangeD').removeClass('inPositionColorB');
                        //         $('.statusChangeD').removeClass('completedColorB');
                        //         $('.statusChangeD').addClass('startedColorB');
                        //         $('.statusChangeD').removeClass('onRoadAcceptedColorB');
                        //     } else if (vm.jobStatusOfMarker == 15) {
                        //         $('.pickUpStatus').removeClass('startedColor');
                        //         $('.pickUpStatus').removeClass('inPositionColor');
                        //         $('.pickUpStatus').addClass('onRoadAcceptedColor');

                        //         $('.statusChangeD').addClass('inPositionColorB');
                        //         $('.statusChangeD').removeClass('completedColorB');
                        //         $('.statusChangeD').removeClass('startedColorB');
                        //         $('.statusChangeD').removeClass('onRoadAcceptedColorB');
                        //     }

                    });
                } else {
                    alert(languageBasedErrorFactory.getProperErrorMessage('onRoadMessage', 0, '3'));
                }

            });
        vm.datePickerE_1 = datePickerE_1;
        vm.scheduleDateChanged = scheduleDateChanged;
        vm.altInputFormats = ['M!/d!/yyyy'];
        vm.historyData = [];
        vm.flagForLoading = true;
        vm.assignBookingList = [];
        vm.flagforDriverStatus = false;
        vm.getAllUnAssignBookings = getAllUnAssignBookings;
        vm.UnAssignBookingList = [];
        vm.getAllAssignBookings = getAllAssignBookings;
        vm.paginationChangedForUnassigned = paginationChangedForUnassigned;
        vm.paginationChangedForUnassignedAssign = paginationChangedForUnassignedAssign;
        var icon = null;
        vm.hstep = 1;
        vm.mstep = 15;
        vm.loading = true;
        vm.assignBooking = assignBooking;
        vm.assignBookingCustomer = assignBookingCustomer;
        vm.assignBookingFlag = false;
        vm.UnassignBookingFlag = true;
        languageBasedErrorFactory.getTranslationStrings(runThis);
        vm.unAssignBooking = unAssignBooking;
        vm.showFilter = false;
        vm.typeTripChanged = typeTripChanged;
        vm.agreementChanged = agreementChanged;
        vm.serviceChanged = serviceChanged;
        vm.branchChanged = branchChanged;

        vm.dataToFill = {
            total_no_of_off_duty_drivers: 0,
            total_no_of_drivers_on_duty: 0,
            total_no_of_started_drivers: 0,
            total_no_of_at_position_drivers: 0,
            total_no_of_busy_drivers: 0,
            total_no_of_drivers_available: 0,
            total_no_of_drivers_available1: 0,
            branch: 'all',
            vehicle: 'all',
            helpTraffic: false,
            service: 'all',
            agreement: 'all',
            truck: '',
            bases: '',
            filterDataDrivers: 1,
            totalData: [],
            totalBranchList: [],
            selectedDate: localStorage.getItem('quickAssignmentDateFilter') ? new Date(localStorage.getItem('quickAssignmentDateFilter')) : new Date()
        };
        vm.selectedDateForFilter = localStorage.getItem('quickAssignmentDateFilter') ? (new Date(localStorage.getItem('quickAssignmentDateFilter')).getFullYear() + '-' + ('0' + (new Date(localStorage.getItem('quickAssignmentDateFilter')).getMonth() + 1)).slice(-2) + '-' + ('0' + new Date(localStorage.getItem('quickAssignmentDateFilter')).getDate()).slice(-2)) : (new Date().getFullYear() + '-' + ('0' + (new Date().getMonth() + 1)).slice(-2) + '-' + ('0' + new Date().getDate()).slice(-2));

        vm.filterData = {
            branch_filter: 0, //0, 1
            service_filter: 0, //0, 1
            vehicle_filter: 0, //0, 1
            aggrement_filter: 0, //0, 1
            //date_time_filter : 1,  //0, 1
            branch: 'all',
            service: [],
            vehicle: 'all',
            //date_time_value: '',
            agreement: 'all',
            unAssignBookingArray: [],
            unassignedBookingCountShow: 0,
            assignedBookingCountShow: 0,
            // type_of_trip: 'all',
            type_of_trip_filter: 1,
            //filter_pickup_date_value: getNextDate(),
            //filter_pickup_time_value: showFilterTime(),
            limit: vm.itemsPerPageGot,
            offset: 0,
            booking_status: 0,
            search_filter: 0,
            search_value: '',
            searchBookingId: '',
            searchPackageId: '',
            search: '',
            itemsPerPageSelected: 20,
            unassignedLimitMade: 20,
            assignedLimitMade: 20,
            filter_pickup_from_date_value: getFirstDateOfPreviousMonth(),
            filter_pickup_to_date_value: setToPickupDate(),
            filter_pickup_from_time_value: showFilterTime(1),
            filter_pickup_to_time_value: showFilterTime(2),
        };
        vm.filterData.type_of_trip = ['R','P'];
        vm.itemsPerPageGot = 25;
        vm.collectedData = [];
        vm.uniqueCarsArray = [];
        vm.offDuty_1 = false;
        vm.pickupFromToTimeChanged = pickupFromToTimeChanged;
        vm.onDuty_1 = true;
        vm.started_1 = false;
        vm.inPosition_1 = false;
        vm.busy_1 = false;
        vm.all_1 = false;
        vm.countToSocket = 0;
        vm.showDrivers = showDrivers;
        //vm.showDriversWithStatus = showDriversWithStatus;
        vm.branchChangedFilter = branchChangedFilter;
        vm.vehicleChangedFilter = vehicleChangedFilter;
        vm.serviceChangedFilter = serviceChangedFilter;
        vm.agreementChangedFilter = agreementChangedFilter;
        vm.typeTripChangedFilter = typeTripChangedFilter;
        vm.vehicleChanged = vehicleChanged;
        vm.removeFilter = removeFilter;
        vm.getAllBranches = getAllBranches;
        // vm.getAllVehicles = getAllVehicles;
        vm.initialize = initialize;
        // vm.getAllServices = getAllServices;
        // vm.getAllAgreement = getAllAgreement;
        // vm.pushNotificationPop = pushNotificationPop;
        vm.showFleetsWithFilter = showFleetsWithFilter;
        vm.getEstimateEtaForNearestDriver = getEstimateEtaForNearestDriver;
        vm.showDriversWithFilter = showDriversWithFilter;
        vm.setBooleans = setBooleans;
        vm.getSearchedAddress = getSearchedAddress;
        vm.ctrlFn = ctrlFn;
        // vm.onSelectingUnique = onSelectingUnique;
        vm.makeMapCenterAccToBranch = makeMapCenterAccToBranch;
        vm.changeFilter = changeFilter;
        vm.slideData = slideData;
        vm.getVehicleOnSearch = getVehicleOnSearch;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();

        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.dashboardMain.dashboard');
            }
        });

        // ********** INSERT INTO ARRAY **********
        Array.prototype.insert = function (index, item) {
            this.splice(index, 0, item);
        };

        // ******** FOR LOAD MORE BOOKINGS **********
        // vm.loadMore = 0;
        // vm.loadMoreAssigned = 0;
        vm.loadMoreBookings = loadMoreBookings;

        vm.paginationChangedForService = paginationChangedForService;
        vm.paginationChangedForVehicle = paginationChangedForVehicle;
        vm.paginationChangedForBranch = paginationChangedForBranch;
        vm.paginationChangedForAgreement = paginationChangedForAgreement;
        vm.vehicleSearch = vehicleSearch;
        vm.serviceSearch = serviceSearch;
        vm.branchSearch = branchSearch;
        vm.agreementSearch = agreementSearch;
        vm.globalLimit = 1000;
        vm.globalLimitService = 1000; //by client
        vm.globalOffset = vm.globalLimit;

        vm.service = [];
        // vm.service.push({
        //     id: 'all',
        //     name: 'All'
        // })

        vm.vehicle = [];
        vm.vehicle.push({
            id: 'all',
            name: 'All'
        });

        vm.branchList = [];
        vm.branchList.push({
            region_name: 'All',
            region_id: 'all'
        });

        vm.agreement = [];
        vm.agreement.push({
            id: 'all',
            name: 'All'
        });

        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'vehicle', 'service', 'agreement', 'corporatesList', 'operation_point'];

        vm.serviceOffset = 0;
        vm.branchOffset = 0;
        vm.vehicleOffset = 0;
        vm.agreementOffset = 0;


        function clearOffset() {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                vm[vm.searchFilterArray[i] + 'Offset'] = 0;
            }

        }
        // =================== FILTER OBJECT ===================
        vm.filterObject = {
            access_token: $cookies.get('obj'),
            branch_filter: 1,
            vehicle_filter: 1,
            service_filter: 1,
            agreement_filter: 1,
            corporate_filter: 0,
            service_category: 0,
            corporate_status: 0,
            agreement_status: 1,
            vehicle__status: 1,
            operation_point_filter: 0,
            service_limit: vm.globalLimitService,
            service_offset: vm.serviceOffset,
            branch_limit: vm.globalLimit,
            branch_offset: vm.branchOffset,
            vehicle_limit: vm.globalLimit,
            vehicle_offset: vm.vehicleOffset,
            agreement_limit: vm.globalLimit,
            agreement_offset: vm.agreementOffset,
            branch_search_filter: 0,
            vehicle_search_filter: 0,
            service_search_filter: 0,
            agreement_search_filter: 0,
            corporate_search_filter: 0,
            operation_point_search_filter: 0
        }


        setTimeout(function () {
            document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                // if (vm.branchList && (vm.branchList.length == 0)) {
                vm.searchBranchData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });


            document.getElementsByClassName('ui-select-search')[1].addEventListener('blur', function ($event) {
                // if (vm.agreement && (vm.agreement.length == 0)) {
                vm.searchAgreementData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

            document.getElementsByClassName('ui-select-search')[2].addEventListener('blur', function ($event) {
                // if (vm.service && (vm.service.length == 0)) {
                vm.searchServiceData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

            document.getElementsByClassName('ui-select-search')[3].addEventListener('blur', function ($event) {
                // if (vm.vehicle && (vm.vehicle.length == 0)) {
                vm.searchVehicleData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

        })
        // =================== GET FILTER DATA ===================
        function getFilterDataFromBackend(data, type) { //Acc to Index ['branch_search', 'vehicle_search', 'service_search', 'agreement_search', 'corporate_search', 'operation_point_search']
            if (data) {
                vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
            } else {
                vm.filterObject = {
                    access_token: $cookies.get('obj'),
                    branch_filter: 1,
                    vehicle_filter: 1,
                    service_filter: 1,
                    agreement_filter: 1,
                    corporate_filter: 0,
                    service_category: 0,
                    corporate_status: 0,
                    agreement_status: 1,
                    vehicle__status: 2,
                    operation_point_filter: 0,
                    branch_search_filter: 0,
                    vehicle_search_filter: 0,
                    service_search_filter: 0,
                    agreement_search_filter: 0,
                    corporate_search_filter: 0,
                    operation_point_search_filter: 0
                }
            }

            vm.filterObject.service_limit = vm.globalLimitService;
            vm.filterObject.service_offset = vm.serviceOffset;
            vm.filterObject.branch_limit = vm.globalLimit;
            vm.filterObject.branch_offset = vm.branchOffset;
            vm.filterObject.vehicle_limit = vm.globalLimit;
            vm.filterObject.vehicle_offset = vm.vehicleOffset;
            vm.filterObject.agreement_limit = vm.globalLimit;
            vm.filterObject.agreement_offset = vm.agreementOffset;


            var promise = getFilters.getAllFilterData(vm.filterObject);
            promise.then(
                function (payload) {

                    // ********** BRANCH DATA ********
                    if (payload.title.data.branches) {
                        var index = _.findIndex(vm.branchList, {
                            region_id: 'all'
                        });
                        if (index == -1)
                            vm.branchList.push({
                                region_name: 'All',
                                region_id: 'all'
                            });
                        angular.forEach(payload.title.data.branches.data, function (column) {
                            var branchIndex = _.findIndex(vm.branchList, {
                                region_id: column.region_id
                            });
                            if (branchIndex == -1)
                                vm.branchList.push(column)
                        });
                        vm.branchTotalBackendCount = payload.title.data.branches.totalCount;
                    }

                    // ********** VEHICLE DATA ********
                    if (payload.title.data.vehicles) {
                        var index = _.findIndex(vm.vehicle, {
                            id: 'all'
                        });
                        if (index == -1)
                            vm.vehicle.push({
                                name: 'All',
                                id: 'all'
                            });
                        vm.vehicleTotalBackendCount = payload.title.data.vehicles.totalCount;
                        angular.forEach(payload.title.data.vehicles.data, function (column) {
                            // vm.vehicle.push({
                            //     id: column.id,
                            //     name: column.name
                            // })
                            var vechicleIndex = _.findIndex(vm.vehicle, {
                                id: column.id
                            });
                            if (vechicleIndex == -1)
                                vm.vehicle.push({
                                    id: column.id,
                                    name: column.name
                                })
                        });
                    }

                    // *********** SERVICE DATA *********
                    if (payload.title.data.services) {
                        // var index = _.findIndex(vm.service, {
                        //     id: 'all'
                        // });
                        // if (index == -1)
                        //     vm.service.push({
                        //         name: 'All',
                        //         id: 'all'
                        //     });
                        vm.serviceTotalBackendCount = payload.title.data.services.totalCount;
                        angular.forEach(payload.title.data.services.data, function (column) {
                            // vm.service.push({
                            //     id: column.id,
                            //     name: column.service_name
                            // });
                            var serviceIndex = _.findIndex(vm.service, {
                                id: column.id
                            });
                            if (serviceIndex == -1)
                                vm.service.push({
                                    id: column.id,
                                    name: column.service_name
                                })
                        });
                    }

                    // *********** AGREEMENT DATA *********
                    if (payload.title.data.agreements) {
                        var index = _.findIndex(vm.agreement, {
                            id: 'all'
                        });
                        if (index == -1)
                            vm.agreement.push({
                                name: 'All',
                                id: 'all'
                            });
                        vm.agreementTotalBackendCount = payload.title.data.agreements.totalCount;
                        angular.forEach(payload.title.data.agreements.data, function (column) {
                            // vm.agreement.push({
                            //     id: column.id,
                            //     name: column.name
                            // });
                            var agreementIndex = _.findIndex(vm.agreement, {
                                id: column.id
                            });
                            if (agreementIndex == -1)
                                vm.agreement.push({
                                    id: column.id,
                                    name: column.name
                                })
                        });
                    }

                    vm.loading = false;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        }
        getFilterDataFromBackend();

        // ************ PAGINATION ON SERIVCE **************
        function paginationChangedForService() {
            var index = _.findIndex(vm[vm.searchFilterArray[2]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.serviceTotalBackendCount > (vm.service.length - index)) {
                commonFunction(2);
                vm.serviceOffset += vm.globalLimitService;
                getFilterDataFromBackend(vm.searchServiceData, 2);
            }
        }

        // ************ PAGINATION ON VEHICLE **************
        function paginationChangedForVehicle() {
            var index = _.findIndex(vm[vm.searchFilterArray[1]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.vehicleTotalBackendCount > (vm.vehicle.length - index)) {
                commonFunction(1);
                vm.vehicleOffset = vm.vehicleOffset + 10;
                getFilterDataFromBackend(vm.searchVehicleData, 1);
            }
        }

        // ************ PAGINATION ON BRANCH **************
        function paginationChangedForBranch() {
            var index = _.findIndex(vm[vm.searchFilterArray[0]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.branchTotalBackendCount > (vm.branchList.length - index)) {
                commonFunction(0);
                vm.branchOffset += 10;
                getFilterDataFromBackend(vm.searchBranchData, 0);
            }
        }

        // ************ PAGINATION ON AGREEMENT **************
        function paginationChangedForAgreement() {
            var index = _.findIndex(vm[vm.searchFilterArray[3]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.agreementTotalBackendCount > (vm.agreement.length - index)) {
                commonFunction(3);
                vm.agreementOffset += vm.globalOffset;
                getFilterDataFromBackend(vm.searchAgreementData, 3);
            }
        }

        // *********** COMMON FUNCTION FOR FILTER PAGINATION AND SEARCHING ***********
        function commonFunction(type, mode) {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                // vm['search' + vm.searchFilterArray[i] + 'Data'] = '';
                if (mode == 'search' || i != type) {
                    vm[vm.searchFilterArrayForClearArray[i]] = [];
                    // if (vm.searchFilterArrayForClearArray[i] != vm.searchFilterArrayForClearArray[0] && vm.searchFilterArrayForClearArray[i] == vm.searchFilterArrayForClearArray[3])
                    // vm[vm.searchFilterArrayForClearArray[i]].push({
                    //     id: 'all',
                    //     name: 'All'
                    // });
                    vm[vm.searchFilterArray[i] + 'Offset'] = 0;
                    vm['search' + vm.searchFilterArray[i].substring(0, 1).toUpperCase() + vm.searchFilterArray[i].substring(1) + 'Data'] = '';
                }
            }
        }

        // ************ SEARCH VEHICLE ***************
        function vehicleSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchVehicleData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(1, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 1);
                }, 2000);
            }
            if (event.keyCode == 13) {
                vehicleChanged();
            }
        }

        // ************ SEARCH SERVICE ***************
        function serviceSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchServiceData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(2, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 2);
                }, 2000);
            }
            if (event.keyCode == 13) {
                serviceChanged();
            }
        }

        // ************ SEARCH VEHICLE ***************
        function branchSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchBranchData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(0, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 0);
                }, 2000);
            }
            if (event.keyCode == 13) {
                branchChanged();
            }
        }

        // ************ SEARCH AGREEMENT ***************
        function agreementSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchAgreementData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(3, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 3);
                }, 2000);
            }
            if (event.keyCode == 13) {
                agreementChanged();
            }
        }


        ///////////// DATe FUNCTIONS/////////////////////
        function showFilterTime(type) {
            if (type == 1) {
                var x = new Date();
                x.setHours('00');
                x.setMinutes('00');
                x.setSeconds('00');
                return x;
            } else {
                var x = new Date();
                x.setHours('23');
                x.setMinutes('59');
                x.setSeconds('00');
                return x;
            }

        }

        function getFirstDateOfPreviousMonth() {
            var date = new Date();
            var yesterday = new Date(date.getTime() - 24 * 60 * 60 * 1000);
            return date;
        }

        function setToPickupDate() {
            var x = new Date();
            var yesterday = new Date(x.getTime() + (24 * 60 * 60 * 1000));
            return yesterday;

        }

        function datePickerE_3(type) {
            if (type == 1) {
                vm.datePicker_1.pickupFromDate = true;
                vm.datePicker_1.pickupToDate = false;

            } else if (type == 2) {
                vm.datePicker_1.pickupFromDate = false;
                vm.datePicker_1.pickupToDate = true;
            }
        };


        function pickupFromToTimeChanged(type) {
            // vm.UnAssignBookingList = [];
            // vm.assignBookingList = [];
            // if (vm.assignBookingFlag == true) {
            //     getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
            // } else {
            //     getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
            // }
        }

        vm.dateOptionsForEndDate = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: vm.filterData.filter_pickup_from_date_value,
            minDate: new Date(),
            startingDay: 1,
            showWeeks: false,
        }

        vm.pickupFromToDateChanged = function (data) {
            // vm.UnAssignBookingList = [];
            // vm.assignBookingList = [];
            vm.dateOptions = {
                //dateDisabled: disabled,
                formatYear: 'yy',
                // maxDate: new Date(),
                // minDate: new Date(vm.filterData.filter_pickup_from_date_value),
                startingDay: 1,
                showWeeks: false,

            };
            vm.dateOptionsForEndDate = {
                //dateDisabled: disabled,
                formatYear: 'yy',
                maxDate: addDays(vm.filterData.filter_pickup_to_date_value, 1),
                minDate: new Date(vm.filterData.filter_pickup_from_date_value),
                startingDay: 1,
                showWeeks: false,
            }

            // if (vm.assignBookingFlag == true) {
            //     getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
            // } else {
            //     getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "scroll");
            // }

        }

        function addDays(theDate, days) {
            return new Date(theDate).getTime() + days * 24 * 60 * 60 * 1000;
        }

        ///////////// DATe FUNCTIONS/////////////////////
        //====================date time format====================
        function dateTimeFormat(dateGot, timeGot) {
            // var dateToChange = dateGot;
            var dateToChange = new Date(dateGot);
            var timeGotChange = new Date(timeGot);
            if (timeGotChange) {
                dateToChange.setHours(timeGotChange.getHours());
                dateToChange.setMinutes(timeGotChange.getMinutes());
                dateToChange.setSeconds(timeGotChange.getSeconds());
            } else {
                dateToChange.setHours(0);
                dateToChange.setMinutes(0);
                dateToChange.setSeconds(0);
            }
            return dateToChange;
        };
        //====================slide data======================
        $('#derp').hide();

        function slideData() {
            $('#derp').slideToggle(1000);
            document.getElementById('toDate').value = moment(vm.filterData.filter_pickup_to_date_value).format('DD-MMMM-YYYY');
            document.getElementById('fromDate').value = moment(vm.filterData.filter_pickup_from_date_value).format('DD-MMMM-YYYY');

        }

        //====================slide data======================

        // ========================= paginationChangedForUnassigned =================
        function paginationChangedForUnassigned() {

            if (vm.filterData.unassignedBookingCountShow > vm.UnAssignBookingList.length + 1) {
                vm.filterData.offset = vm.filterData.offset + 25;
                getAllUnAssignBookings(vm.filterData.offset, vm.itemsPerPageGot, vm.filterData, true, "scroll");
            }
        }


        // ========================= paginationChangedForUnassignedAssign =================
        function paginationChangedForUnassignedAssign() {
            if (vm.filterData.assignedBookingCountShow > vm.assignBookingList.length + 1) {
                vm.filterData.offset = vm.filterData.offset + vm.filterData.itemsPerPageSelected;
                getAllAssignBookings(vm.filterData.offset, vm.itemsPerPageGot, vm.filterData, true, "scroll");
            }
        }

        //===================side bar filters=====================
        vm.showFilterArea = showFilterArea;
        vm.branchChangedFilter = branchChangedFilter;
        vm.vehicleChangedFilter = vehicleChangedFilter;
        vm.serviceChangedFilter = serviceChangedFilter;
        vm.agreementChangedFilter = agreementChangedFilter;
        vm.removeFilter = removeFilter;
        vm.typeTripChangedFilter = typeTripChangedFilter;
        vm.showFilterFlag = false;

        vm.filterWhichToShow = {
            branchWithDashboard: false,
            service: true,
            vehicle: true,
            agreement: true,
            operation: false,
            helpTraffic: false,
            virtualFleet: false,
            approvalStage: false,
            vehicleAssigned: false,
            applicantType: false,
            modelity: false,
            tripType: true
        };



        function branchChangedFilter(data) {
            vm.branchChanged();
        }

        function vehicleChangedFilter(data) {
            vm.vehicleChanged();
        }

        function serviceChangedFilter(data) {
            vm.serviceChanged();
        }

        function agreementChangedFilter(data) {
            vm.agreementChanged();
        }

        function typeTripChangedFilter(data) {
            vm.typeTripChanged();
        }





        if ($rootScope.socket.connected == false || $rootScope.socket.connected == 'false') {
            $rootScope.socket.connect();
        }
        var myListener = $rootScope.socket.on('socketEventToUser', function (res) {
            vm.socketData = res.message;
            if (vm.socketData) {
                socketHandleNew(vm.socketData);
            }
        });


        var myListener1 = $rootScope.socket.on('socketEventToUserFreeDriver', function (res) {
            vm.socketDataForFreeDrivers = res.message;
            if (vm.socketDataForFreeDrivers) {
                socketHandleNewDrivers(vm.socketDataForFreeDrivers);
            }
        });

        function socketHandleNewDrivers(data) {
            markerGot = '';
            var markerGot = _.where(markers, {
                id: data.fleet_id
            })[0];
            var indexMarker = _.findIndex(markers, {
                id: data.fleet_id
            });
            var index = _.findIndex(vm.collectedData, {
                fleet_id: data.fleet_id
            });
            var mylatLng = new google.maps.LatLng(Number(data.latitude), Number(data.longitude));
            if (markerGot && markerGot.id) {
                if (data.bookingHasNextTime == false) {
                    markerGot.setMap(null);
                    if (index > -1) {
                        vm.collectedData.splice(index, 1);
                    }
                    if (indexMarker > -1) {
                        markers.splice(indexMarker, 1);
                    }
                    getCountOfDashboardFleetsSocket(vm.collectedData, 'socket', data);
                } else {
                    if (vm.socketHandleMarker == false) {
                        markerGot.setPosition(mylatLng);
                        var label = {
                            text: data.unique_car_id ? data.unique_car_id.toString() : '0',
                            fontSize: '10px'
                        };

                        markerGot.setOptions({
                            icon: makeIconUI(data),
                            id: data.fleet_id,
                            label: label,
                            jobId: data.job_id,
                            jobStatus: data.job_status,
                            driverStatus: data.status
                        });
                    }
                    if (vm.collectedData && vm.collectedData.length) {
                        if (index > -1) {
                            if (data.fleet_id == vm.collectedData[index].fleet_id) {
                                if (vm.collectedData[index].popInfoOpen && (data.job_status != vm.collectedData[index].job_status)) {
                                    google.maps.event.trigger(markerGot, 'click');
                                }
                            }
                            vm.collectedData[index].is_available = data.is_available;
                            vm.collectedData[index].status = data.status;
                            vm.collectedData[index].job_status = data.job_status;
                            vm.collectedData[index].unique_car_id = data.unique_car_id ? data.unique_car_id : '0';
                        }
                    }

                    //openPreviousinfoWindowOpen(markers, vm.collectedData);
                    getCountOfDashboardFleetsSocket(vm.collectedData, 'socket', data);
                }
            } else {
                if (data.is_available != 0) {
                    if (vm.socketHandleMarker == false) {
                        createMarker(new google.maps.LatLng(data.latitude, data.longitude), data);
                    }
                    vm.collectedData.push(data);
                    getCountOfDashboardFleetsSocket(vm.collectedData, 'socket', data);
                }
            }
        }

        $scope.$on('$destroy', myListener);
        $scope.$on('$destroy', myListener1);
        // $scope.$on('$destroy', myListener);
        //$rootScope.socket.on('socketEventToUser',function(res){
        //    showDriversWithFilterSocket(vm.dataToFill);
        //});

        function socketHandleNew(data) {

            markerGot = '';
            var markerGot = _.where(markers, {
                id: data.fleet_id
            })[0];
            var indexMarker = _.findIndex(markers, {
                id: data.fleet_id
            });
            var index = _.findIndex(vm.collectedData, {
                fleet_id: data.fleet_id
            });
            var mylatLng = new google.maps.LatLng(Number(data.latitude), Number(data.longitude));
            if (markerGot && markerGot.id) {
                if (data.is_available == 0 && data.status == 0) {
                    if (mc)
                        mc.removeMarker(markers[indexMarker]);
                    markerGot.setMap(null);
                    if (index > -1) {
                        vm.collectedData.splice(index, 1);
                    }
                    if (indexMarker > -1) {
                        markers.splice(indexMarker, 1);
                    }
                    getCountOfDashboardFleets(vm.collectedData, 'socket');
                } else {
                    markerGot.setPosition(mylatLng);
                    var label = {
                        text: data.unique_car_id ? data.unique_car_id.toString() : '0',
                        fontSize: '10px'
                    };
                    markerGot.setOptions({
                        icon: makeIconUI(data),
                        id: data.fleet_id,
                        label: label,
                        jobId: data.job_id,
                        jobStatus: data.job_status,
                        driverStatus: data.status
                    });

                    if (vm.collectedData && vm.collectedData.length) {
                        if (index > -1) {
                            if (data.fleet_id == vm.collectedData[index].fleet_id) {
                                if (vm.collectedData[index].popInfoOpen && (data.job_status != vm.collectedData[index].job_status)) {
                                    google.maps.event.trigger(markerGot, 'click');
                                }
                            }
                            vm.collectedData[index].is_available = data.is_available;
                            vm.collectedData[index].status = data.status;
                            vm.collectedData[index].job_status = data.job_status;
                            vm.collectedData[index].unique_car_id = data.unique_car_id ? data.unique_car_id : '0';
                        }
                    }
                    getCountOfDashboardFleets(vm.collectedData, 'socket');
                }
            } else {
                if (data.is_available != 0) {
                    createMarker(new google.maps.LatLng(data.latitude, data.longitude), data);
                    if (mc)
                        mc.addMarkers(markers);
                    vm.collectedData.push(data);
                    getCountOfDashboardFleets(vm.collectedData, 'socket');
                }
            }
        }
        //==================hours format=====================
        function changeHoursFormat(data) {
            if (data) {
                var sec_num = parseInt(data, 10); // don't forget the second param
                var hours = Math.floor(sec_num / 3600);
                var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
                var seconds = sec_num - (hours * 3600) - (minutes * 60);

                if (hours < 10) {
                    hours = "0" + hours;
                }
                if (minutes < 10) {
                    minutes = "0" + minutes;
                }
                if (seconds < 10) {
                    seconds = "0" + seconds;
                }
                return hours + ':' + minutes + ':' + seconds;
            } else {
                return '00:00:00';
            }
        }
        document.getElementById('boxId').style.border = "1px solid #EF7D07";
        document.getElementById('boxId').style.backgroundColor = "transparent";
        document.getElementById('boxId').style.color = "#EF7D07";
        document.getElementById('boxId1').style.border = "1px solid #EF7D07";
        document.getElementById('boxId1').style.backgroundColor = "#EF7D07";
        document.getElementById('boxId1').style.color = "#fff";
        //=======================Assign Booking=========================
        function assignBooking(boxId) {
            vm.assignBookingList = [];
            vm.assignBookingFlag = true;
            vm.UnassignBookingFlag = false;
            vm.filterData.offset = 0;
            getAllAssignBookings(0, vm.filterData.itemsPerPageSelected, vm.filterData, true);
            document.getElementById(boxId).style.border = "1px solid #EF7D07";
            document.getElementById(boxId).style.backgroundColor = "#EF7D07";
            document.getElementById(boxId).style.color = "#fff";
            document.getElementById('boxId1').style.border = "1px solid #EF7D07";
            document.getElementById('boxId1').style.backgroundColor = "transparent";
            document.getElementById('boxId1').style.color = "#EF7D07";
        }
        //=======================Assign Booking================
        //=======================Assign Booking Customer=========================
        function assignBookingCustomer(data) {
            vm.colorFlag = [];
            // var dataTosend = [];
            // dataTosend.push(data);
            // initialize(dataTosend);
            vm.showDriversWithFilter(vm.dataToFill, 1, data);
        }
        //=======================Assign Booking Customer =========================
        //=======================Un Assign Booking====
        function unAssignBooking(boxId1) {
            vm.UnAssignBookingList = [];
            vm.assignBookingFlag = false;
            vm.UnassignBookingFlag = true;
            vm.filterData.offset = 0;
            vm.colorFlag = [];
            getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
            document.getElementById(boxId1).style.border = "1px solid #EF7D07";
            document.getElementById(boxId1).style.backgroundColor = "#EF7D07";
            document.getElementById(boxId1).style.color = "#fff";
            document.getElementById('boxId').style.border = "1px solid #EF7D07";
            document.getElementById('boxId').style.backgroundColor = 'transparent';
            document.getElementById('boxId').style.color = "#EF7D07";
        }
        //=======================Un Assign Booking====


        //====================get branch list====================
        // function getBranch() {

        //     vm.branchList = [];
        //     vm.branchList = JSON.parse(JSON.stringify(getFilters.branchesFiltersData.data));
        //     vm.branchList.push({
        //         region_name: 'All',
        //         region_id: 'all'
        //     });
        //     $scope.$apply();


        //vm.loading = true;
        // var promise = getGeofence.branch();
        // promise.then(
        //     function (payload) {
        //         $log.log(payload);
        //         //vm.loading = false;
        //         if (payload.title.status == 400) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //         } else if (payload.title.status == 401) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //         } else if (payload.title.status == 201 || payload.title.status == 200) {
        //             vm.getAllUnAssignBookings(0, vm.filterData.itemsPerPageSelected, vm.filterData, true, 'unScroll');
        //             var where = _.where(payload.title.data, {
        //                 parent_id: 0
        //             });
        //             //vm.branchList = _.where(where, { is_active: 1 });
        //             vm.branchList = where;

        //             vm.branchList.push({
        //                 region_name: 'All',
        //                 region_id: 'all'
        //             });
        //         }
        //     },
        //     function (errorPayload) {
        //         $log.log(errorPayload);
        //         //vm.loading = false;
        //         if (errorPayload.data.status == 401) {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //         } else {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //         }
        //     }
        // );
        // }
        // WHen Page refresh service take time to get data from backend
        // setTimeout(function () {
        //     getBranch();
        // }, 1000);
        //====================get branch list====================
        //====================Type Of Trip list====================
        function runThis() {
            vm.typeTripFilter = [
                // {
                //     name: languageBasedErrorFactory.getProperErrorMessage('allLabel', 0, '3'),
                //     id: 'all'
                // },
                // {
                //     name: 'From Airport',
                //     id: 'Z'
                // },
                {
                    name: 'To Airport',
                    id: 'R'
                },
                {
                    name: 'Point to Point',
                    id: 'P'
                }
            ]
        }

        //====================Type Of Trip list====================


        //==================get all AssignBookings=======================
        function getAllAssignBookings(skip, limit, filter, loader, type) {
            var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            if (pickFromDate > pickToDate) {
                errorMessageFactory.showErrorMessage('Por favor, elija las fechas apropiadas de filtro.', 0);
                return;
            }
            vm.countToSocket = vm.countToSocket + 1;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit;
            dataSend.offset = skip;
            dataSend.booking_status = filter.booking_status;
            dataSend.branch_filter = filter.branch_filter;
            if (filter.branch_filter == 1 && filter.branch != 'all') {
                dataSend.branch_value = filter.branch;
            }
            dataSend.service_filter = filter.service_filter;
            if (filter.service_filter == 1 && filter.service != 'all') {
                dataSend.service_value = JSON.stringify(filter.service) || [];
            }
            dataSend.vehicle_filter = filter.vehicle_filter;
            if (filter.vehicle_filter == 1 && filter.vehicle != 'all') {
                dataSend.vehicle_value = filter.vehicle;
            }
            dataSend.search_filter = filter.search_filter;
            if (filter.search_filter == 1) {
                dataSend.search_value = filter.search_value;
            }
            //dataSend.date_time_filter = filter.date_time_filter;
            //if(filter.filter_pickup_date_value && filter.filter_pickup_time_value) {
            //    dataSend.date_time_value = dateTimeFormat(filter.filter_pickup_date_value, filter.filter_pickup_time_value);
            //}
            //else if(filter.filter_pickup_date_value && !filter.filter_pickup_time_value){
            //    dataSend.date_time_value = moment(filter.filter_pickup_date_value).format('YYYY-MM-DD');
            //}

            dataSend.aggrement_filter = filter.aggrement_filter;
            if (filter.aggrement_filter == 1 && filter.agreement != 'all') {
                dataSend.aggrement_value = filter.agreement;
            }

            dataSend.date_value_from = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            dataSend.date_value_upto = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);

            // dataSend.type_of_trip_filter = filter.type_of_trip_filter;
            // if (filter.type_of_trip_filter == 1 && filter.type_of_trip != 'all') {
            var trip = [];
            trip.push(vm.filterData.type_of_trip);
            if (vm.filterData.type_of_trip && vm.filterData.type_of_trip.length > 0 && filter.type_of_trip != 'all') {
                dataSend.type_of_trip_filter = 1;
                dataSend.type_of_trip_value = trip;
            } else {
                dataSend.type_of_trip_filter = 0;
            }

            // }
            if (vm.flagForLoading == true) {
                // vm.loading = loader;
                vm.loading = loader;
            }
            dataSend.date_value = vm.selectedDateForFilter;
            var promise = getBookings.allAssignBookings(dataSend);
            promise.then(
                function (payload) {
                    if (payload.title.status == 200) {
                        $log.log('sxdsads', payload);
                        vm.countToSocket = 0;
                        if (vm.flagForLoading == true) {
                            // vm.loading = false;
                            vm.loading = false;
                            // vm.loading1 = false;
                        }
                        if (payload.title.status == 400) {

                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            vm.filterData.assignedBookingCountShow = payload.title.data.totalCount;
                            vm.totalUpcomingBookings = payload.title.data.totalCount;
                            vm.dataLength = payload.title.data.totalCount;

                            if (payload.title.data.totalCount == 0) {
                                vm.sp_pagination = false;
                                vm.tBodyFlag = false;
                                vm.tFootFlag = true;
                                vm.filterOn = true;
                                vm.skipValueFilter = 0;
                            } else {
                                vm.sp_pagination = true;
                                vm.tBodyFlag = true;
                                vm.tFootFlag = false;
                                vm.filterOn = false;
                                vm.skipValueFilter = 0;

                                var dataArray = [];
                                if (type == 'socket') {
                                    vm.assignBookingList = [];
                                }
                                // vm.UnAssignBookingList = [];
                                var assignBookingList = payload.title.data.result;
                                // showNewDrivers(vm.dataToFill , 0);
                                if (vm.filterData.assignedBookingCountShow > vm.assignBookingList.length) {
                                    assignBookingList.forEach(function (column) {
                                        // this is to detect duplicate booking in array
                                        var index = _.findIndex(vm.assignBookingList, {
                                            job_id: column.job_id
                                        });
                                        if (index == -1) {
                                            var d = {};
                                            d.contract_name = column.contract_name;
                                            d.estimated_payment_cost = column.estimated_payment_cost;
                                            d.is_VIP = column.is_VIP;
                                            d.is_round_trip = column.is_round_trip;
                                            d.booking_type = column.booking_type;
                                            d.job_address = column.job_address;
                                            d.job_id = column.job_id;
                                            d.job_pickup_address = column.job_pickup_address;
                                            d.job_pickup_name = column.job_pickup_name;
                                            d.job_pickup_phone = column.job_pickup_phone;
                                            d.service_name = column.service_name;
                                            d.job_time_utc = column.job_time_utc;
                                            d.locking_id = column.locking_id;
                                            d.locking_id_name = column.locking_id_name;
                                            d.observations = column.observations;
                                            d.reference_point = column.reference_point;
                                            d.round_trip_pickup_time_utc = column.round_trip_pickup_time_utc;
                                            d.urgent_booking_assignment = column.urgent_booking_assignment;
                                            d.type_of_trip = column.type_of_trip;
                                            d.job_pickup_latitude = column.job_pickup_latitude;
                                            d.job_pickup_longitude = column.job_pickup_longitude;
                                            vm.assignBookingList.push(d);
                                        }
                                    });
                                }
                                // vm.UnAssignBookingList = [];
                                // vm.assignBookingList = dataArray;

                                for (var i = 0; i < vm.assignBookingList.length; i++) {
                                    vm.assignBookingList[i].index = (skip + i);
                                }
                                if (vm.dataLength <= vm.itemsPerPageGot) {
                                    vm.sp_pagination = false;
                                } else {
                                    vm.sp_pagination = true;
                                    //vm.pageCount(payload.title.totalCount);
                                }
                                vm.skipValue = vm.assignBookingList[0].index;
                                vm.limitValue = vm.assignBookingList[vm.assignBookingList.length - 1].index;

                                //$scope.$watch('vm.search', function (newVal, oldVal) {
                                //    vm.filtered = filterFilter(vm.upcomingBookingList, newVal);
                                //    vm.totalItems = vm.filtered.length;
                                //    if (vm.filtered.length == 0) {
                                //        vm.watchPagination = false;
                                //    } else {
                                //        vm.watchPagination = true;
                                //    }
                                //    if (vm.filterOn == true) {
                                //        vm.skipValueFilter = vm.filtered.length;
                                //        vm.sp_pagination = false;
                                //    }
                                //}, true);

                                //range();
                            }
                        }
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };


        //==================get all AssignBookings=======================
        function getAllUnAssignBookings(skip, limit, filter, loader, type) {
            var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            if (pickFromDate > pickToDate) {
                errorMessageFactory.showErrorMessage('Por favor, elija las fechas apropiadas de filtro.', 0);
                return;
            }

            vm.countToSocket = vm.countToSocket + 1;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit;
            dataSend.offset = skip;
            dataSend.booking_status = filter.booking_status;
            dataSend.branch_filter = filter.branch_filter;
            if (filter.branch_filter == 1 && filter.branch != 'all') {
                dataSend.branch_value = filter.branch;
            }
            dataSend.service_filter = filter.service_filter;
            if (filter.service_filter == 1 && filter.service != 'all') {
                dataSend.service_value = JSON.stringify(filter.service) || [];
            }
            dataSend.vehicle_filter = filter.vehicle_filter;
            if (filter.vehicle_filter == 1 && filter.vehicle != 'all') {
                dataSend.vehicle_value = filter.vehicle;
            }
            dataSend.search_filter = filter.search_filter;
            if (filter.search_filter == 1) {
                dataSend.search_value = filter.search_value;
            }
            //dataSend.date_time_filter = filter.date_time_filter;
            //if(filter.filter_pickup_date_value && filter.filter_pickup_time_value) {
            //    dataSend.date_time_value = dateTimeFormat(filter.filter_pickup_date_value, filter.filter_pickup_time_value);
            //}
            //else if(filter.filter_pickup_date_value && !filter.filter_pickup_time_value){
            //    dataSend.date_time_value = moment(filter.filter_pickup_date_value).format('YYYY-MM-DD');
            //}

            dataSend.aggrement_filter = filter.aggrement_filter;
            if (filter.aggrement_filter == 1 && filter.agreement != 'all') {
                dataSend.aggrement_value = filter.agreement;
            }

            // dataSend.type_of_trip_filter = filter.type_of_trip_filter;
            // if (filter.type_of_trip_filter == 1 && filter.type_of_trip != 'all') {
            var trip = [];
            trip.push(vm.filterData.type_of_trip);
            if (vm.filterData.type_of_trip && vm.filterData.type_of_trip.length > 0 && filter.type_of_trip != 'all') {
                dataSend.type_of_trip_filter = 1;
                dataSend.type_of_trip_value = trip;
            } else {
                dataSend.type_of_trip_filter = 0;
            }
            dataSend.date_value_from = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            dataSend.date_value_upto = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);

            // }
            if (vm.flagForLoading == true) {
                // vm.loading = loader;
                vm.loading = loader;
            }
            var promise = getBookings.allUnAssignBookings(dataSend);
            promise.then(
                function (payload) {
                    if (payload.title.status == 200) {
                        $log.log('sxdsads', payload);
                        vm.countToSocket = 0;
                        if (vm.flagForLoading == true) {
                            // vm.loading = false;
                            vm.loading = false;
                        }


                        if (payload.title.status == 400) {

                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        } else if (payload.title.status == 201 || payload.title.status == 200) {

                            vm.filterData.unassignedBookingCountShow = payload.title.data.totalCount;
                            vm.dataLength = payload.title.data.totalCount;
                            vm.urgentBookingCount = payload.title.data.urgent_booking_count || 0;

                            if (payload.title.data.totalCount == 0) {
                                // vm.sp_pagination = false;
                                // vm.tBodyFlag = false;
                                // vm.tFootFlag = true;
                                // vm.filterOn = true;
                                // vm.skipValueFilter = 0;
                            } else {
                                // vm.sp_pagination = true;
                                // vm.tBodyFlag = true;
                                // vm.tFootFlag = false;
                                // vm.filterOn = false;
                                // vm.skipValueFilter = 0;


                                if (type == "scroll") {
                                    for (var i = 0; i < payload.title.data.result.length; i++) {

                                        vm.filterData.unAssignBookingArray.push(payload.title.data.result[i]);
                                    }
                                } else {
                                    vm.filterData.unAssignBookingArray = payload.title.data.result;
                                }

                                // showNewDrivers(vm.dataToFill , 0);
                                var dataArray = [];
                                if (type == 'socket') {
                                    vm.UnAssignBookingList = [];
                                }
                                // vm.UnAssignBookingList = [];
                                vm.filterData.unAssignBookingArray = payload.title.data.result;
                                if (vm.filterData.unassignedBookingCountShow > vm.UnAssignBookingList.length) {
                                    var UnAssignBookingList = payload.title.data.result;
                                    UnAssignBookingList.forEach(function (column) {
                                        // this is to detect duplicate booking in array
                                        var index = _.findIndex(vm.UnAssignBookingList, {
                                            job_id: column.job_id
                                        });
                                        if (index == -1) {
                                            var d = {};
                                            d.contract_name = column.contract_name;
                                            d.estimated_payment_cost = column.estimated_payment_cost;
                                            d.is_VIP = column.is_VIP;
                                            d.is_round_trip = column.is_round_trip;
                                            d.booking_type = column.booking_type;
                                            d.branch = column.branch;
                                            d.type_of_service = column.type_of_service;
                                            d.job_address = column.job_address;
                                            d.job_id = column.job_id;
                                            d.job_pickup_address = column.job_pickup_address;
                                            d.job_pickup_name = column.job_pickup_name;
                                            d.job_pickup_phone = column.job_pickup_phone;
                                            d.job_time_utc = column.job_time_utc;
                                            d.locking_id = column.locking_id;
                                            d.service_name = column.service_name;
                                            d.locking_id_name = column.locking_id_name;
                                            d.observations = column.observations;
                                            d.reference_point = column.reference_point;
                                            d.round_trip_pickup_time_utc = column.round_trip_pickup_time_utc;
                                            d.urgent_booking_assignment = column.urgent_booking_assignment;
                                            d.latitude = column.job_pickup_latitude;
                                            d.longitude = column.job_pickup_longitude;
                                            d.is_person = true;
                                            d.booking_eta = column.booking_eta;
                                            d.reference_point = column.reference_point;
                                            d.color = column.urgent_booking_assignment ? '#ff4d4d' : '#333';
                                            // dataArray.push(d);
                                            vm.UnAssignBookingList.push(d);
                                        }
                                    });
                                    vm.historyData.push(UnAssignBookingList.length);
                                }
                                // vm.UnAssignBookingList.push(dataArray);
                                // vm.assignBookingList = [];
                                for (var i = 0; i < vm.UnAssignBookingList.length; i++) {
                                    vm.UnAssignBookingList[i].index = (skip + i);
                                }
                                if (vm.dataLength <= vm.itemsPerPageGot) {
                                    vm.sp_pagination = false;
                                } else {
                                    vm.sp_pagination = true;
                                    //vm.pageCount(payload.title.totalCount);
                                }
                                // vm.skipValue = vm.UnAssignBookingList[0].index;
                                // vm.limitValue = vm.UnAssignBookingList[vm.UnAssignBookingList.length - 1].index;



                                //$scope.$watch('vm.search', function (newVal, oldVal) {
                                //    vm.filtered = filterFilter(vm.upcomingBookingList, newVal);
                                //    vm.totalItems = vm.filtered.length;
                                //    if (vm.filtered.length == 0) {
                                //        vm.watchPagination = false;
                                //    } else {
                                //        vm.watchPagination = true;
                                //    }
                                //    if (vm.filterOn == true) {
                                //        vm.skipValueFilter = vm.filtered.length;
                                //        vm.sp_pagination = false;
                                //    }
                                //}, true);

                                //range();
                            }
                        }
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        //=================filter change functions===============================================
        //===================Reset filter====================
        function resetFilter() {
            vm.filterData = {
                branch_filter: 0, //0, 1
                service_filter: 0, //0, 1
                vehicle_filter: 0, //0, 1
                aggrement_filter: 0, //0, 1
                //date_time_filter : 0,  //0, 1
                type_of_trip_filter: 0, //0, 1
                branch: 'all',
                service: [],
                vehicle: 'all',
                // type_of_trip: 'R',
                //date_time_value: '',
                agreement: 'all',
                //filter_pickup_date_value: getNextDate(),
                //filter_pickup_time_value: showFilterTime(),
                limit: vm.itemsPerPageGot,
                offset: 0,
                booking_status: 0,
                searchBookingId: '',
                searchPackageId: '',
                search: '',
                itemsPerPageSelected: 25,
                unassignedBookingCountShow: 0,
                assignedBookingCountShow: 0,
                unAssignBookingArray: [],
                filter_pickup_from_date_value: getFirstDateOfPreviousMonth(),
                filter_pickup_to_date_value: setToPickupDate(),
                filter_pickup_from_time_value: showFilterTime(1),
                filter_pickup_to_time_value: showFilterTime(2),
            };
            vm.filterData.type_of_trip = ['R','P']; 
            if (vm.assignBookingFlag == true) {
                getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
            } else {
                getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
            }
            // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
        }
        //===================Reset filter====================
        //===================Apply filter====================
        function applyFilter() {
            vm.UnAssignBookingList = [];
            vm.assignBookingList = [];
            if(vm.filterData.type_of_trip.length == 0){
                vm.filterData.type_of_trip = ['R','P']; 
            } 
            if (vm.assignBookingFlag == true) {
                getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
            } else {
                getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
            }
        }
        //===================Apply filter====================
        //===================Type of Trip====================
        function typeTripChanged() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            // vm.UnAssignBookingList = [];
            // vm.assignBookingList = [];
            vm.filterData.offset = 0;
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (vm.filterData.type_of_trip && vm.filterData.type_of_trip != 'all') {
                vm.filterData.type_of_trip_filter = 1;
                // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");

            } else {
                vm.filterData.type_of_trip_filter = 0;
                vm.filterData.type_of_trip = 'all';
                // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");

            }
        };
        //===================Type of Trip====================

        //===================Vechicle Changed====================
        function vehicleChanged() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            // vm.UnAssignBookingList = [];
            // vm.assignBookingList = [];
            vm.filterData.offset = 0;
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (vm.filterData.vehicle && vm.filterData.vehicle != 'all') {
                vm.filterData.vehicle_filter = 1;
                // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
                vm.agreement = [];
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                clearOffset();
                getFilterDataFromBackend();
            } else {
                vm.filterData.vehicle_filter = 0;
                vm.filterData.vehicle = 'all';
                // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
                vm.agreement = [];
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                clearOffset();
                getFilterDataFromBackend();
            }
        };


        //===================Vechicle Changed====================

        //===================Service Changed====================
        function serviceChanged() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            // vm.UnAssignBookingList = [];
            // vm.assignBookingList = [];
            vm.filterData.offset = 0;
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (vm.filterData.service.length > 0) {
                vm.filterData.service_filter = 1;
                // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
                vm.agreement = [];
                vm.branchList = [];
                vm.vehicle = [];
                clearOffset();
                vm.service = [];
                getFilterDataFromBackend();
            } else {
                vm.filterData.service_filter = 0;
                // vm.filterData.service = 'all';
                // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
                vm.agreement = [];
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                clearOffset();
                getFilterDataFromBackend();
            }
        };
        //===================Service Changed====================

        //===================Aggreement Changed====================
        function agreementChanged() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            // vm.UnAssignBookingList = [];
            // vm.assignBookingList = [];
            vm.filterData.offset = 0;
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (vm.filterData.agreement && vm.filterData.agreement != 'all') {
                vm.filterData.aggrement_filter = 1;
                // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
                vm.agreement = [];
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                clearOffset();
                getFilterDataFromBackend();
            } else {
                vm.filterData.aggrement_filter = 0;
                vm.filterData.agreement = 'all';
                // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
                vm.agreement = [];
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                clearOffset();
                getFilterDataFromBackend();
            }
        };
        //===================Aggreement Changed====================    

        //===================Branch Changed====================    

        function branchChanged() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            // vm.UnAssignBookingList = [];
            // vm.assignBookingList = [];
            vm.filterData.offset = 0;
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (vm.filterData.branch && vm.filterData.branch != 'all') {
                vm.filterData.branch_filter = 1;
                // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                vm.agreement = [];
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
                clearOffset();
                getFilterDataFromBackend();
            } else {
                vm.filterData.branch_filter = 0;
                vm.filterData.branch = 'all';
                // getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
                vm.agreement = [];
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                clearOffset();
                getFilterDataFromBackend();
            }
        };

        //===================Branch Changed====================    
        //=================filter change functions===============================================


        //=======================map=========================
        function setMapOnAll(map) {
            for (var i = 0; i < markers.length; i++) {
                //var marker = markers[i];
                markers[i].setMap(map);
            }
            markers = [];
        }

        // If the map position is out of range, move it back
        function checkBounds(map) {
            if (typeof (map.getBounds()) == 'undefined')
                return;

            var latNorth = map.getBounds().getNorthEast().lat();
            var latSouth = map.getBounds().getSouthWest().lat();
            var newLat;

            if (latNorth < 85 && latSouth > -85) /* in both side -> it's ok */
                return;
            else {
                if (latNorth > 85 && latSouth < -85) /* out both side -> it's ok */
                    return;
                else {
                    if (latNorth > 85)
                        newLat = map.getCenter().lat() - (latNorth - 85);
                    /* too north, centering */
                    if (latSouth < -85)
                        newLat = map.getCenter().lat() - (latSouth + 85);
                    /* too south, centering */
                }
            }
            if (newLat) {
                var newCenter = new google.maps.LatLng(newLat, map.getCenter().lng());
                map.setCenter(newCenter);
            }
        }

        function initialize(info, type) {
            // vm.loading = true;
            type = 1;

            if (markers.length) {
                setMapOnAll(null);
                if (mc)
                    mc.clearMarkers();
            }
            var mcOptions = {
                gridSize: 50,
                maxZoom: 15
            };
            // if (info && info.length) {
            //     for (var i = 0; i < info.length; i++) {
            //         if (info[i].contract_name != null) {
            //             myCenter = new google.maps.LatLng(info[i].latitude, info[i].longitude);

            //         }
            //     }

            // }
            if (type != 0) {
                var mapProp = {
                    center: myCenter,
                    zoom: 3,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    minZoom: 3,
                    //maxZoom: 18,
                    mapTypeControl: false
                };

                map = new google.maps.Map(document.getElementById("googleMap"), mapProp);
            }
            map.setZoom(map.getZoom());
            google.maps.event.addListener(map, 'center_changed', function () {
                checkBounds(map);
            });
            mc = new MarkerClusterer(map, [], mcOptions);
            google.maps.event.addListener(map, 'click', function () {
                infowindow.close();
                restorePreviousData();
            });

            google.maps.event.addListenerOnce(map, 'tilesloaded', function () {
                //this part runs when the mapobject is created and rendered
                vm.mapLoadsFlag = true;
            });

            // if(fleet_status && fleet_status!=0){
            for (var i = 0; i < info.length; i++) {
                createMarker(new google.maps.LatLng(info[i].latitude,
                    info[i].longitude), info[i]);
            }
            // }

            mc.addMarkers(markers, true);
            google.maps.event.addListener(infowindow, 'closeclick', function () {
                restorePreviousData();
            });

        };

        //$interval(function(){
        //    showDriversWithFilterSocket(0);
        //},8000);

        //====================function for infowindows====================
        function infoWindows(data) {
            // || data.booking_eta
            var divWithService = '<div id="googleMapsDetailsWithCar" class="row" style = "max-height:200px !important; overflow:scroll !important;max-width:250px !important;min-width:290px !important" id="googleMapsDetailsWithCar1">' +
                '  <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 paddingOnDuty1">' +
                '  <div class="pickUpText">Pickup</div>' +
                '   <div class="addressDiv1" style="font-weight: bold;color:grey"><i class="fa fa-map-marker"></i>&nbsp;&nbsp;' + data.job_pickup_address + '</div>' +
                ' </div>' +
                '<div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 paddingOnDuty1">' +
                '    <div class="pickUpText">Drop off</div>' +
                '<div class="addressDiv1" style="font-weight: bold;color:grey"><i class="fa fa-map-marker"></i>&nbsp;&nbsp;' + data.job_address + '</div>' +
                '</div>' +

                '  <div class="col-lg-12 col-sm-12 col-xs-12 col-md-12 paddingOnDuty1" id="referencePoint">' +
                '  <div class="pickUpText"> Reference Pickup</div>' +
                '   <div class="addressDiv1" style="height:30px"><i class="fa fa-map-marker"></i>&nbsp;&nbsp;' + data.reference_point + '</div>' +
                ' </div>' +

                ' <div  class="col-lg-12 col-sm-12 col-xs-12 col-md-12 " style= "padding:10px;border-bottom: 3px solid grey;">' +
                '  <div  class="col-lg-6 col-sm-6 col-xs-6 col-md-6 " style="margin-right: 137px; font-size: 14px;font-weight: bold;">Booking ETA</div>' +
                '   <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 " style="margin-left: 145px; margin-top: -15px;font-weight: bold;color: grey;">' + (vm.nearestDriverETA || 0) + ' Mins' + '</div>' +

                '</div>' +
                ' <div  class="col-lg-12 col-sm-12 col-xs-12 col-md-12 " style= "padding:10px;border-bottom: 3px solid grey;">' +

                '  <div  class="col-lg-6 col-sm-6 col-xs-6 col-md-6 " style="margin-right: 105px; font-size: 14px;font-weight: bold;">Tarifa Aproximada</div>' +
                '   <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 " style="margin-left: 145px; margin-top: -15px;font-weight: bold;color: grey;">' + '$' + data.estimated_payment_cost + '</div>' +

                '</div>' +
                ' <div  class="col-lg-12 col-sm-12 col-xs-12 col-md-12 " style= "padding:10px;border-bottom: 3px solid grey;">' +

                '  <div  class="col-lg-6 col-sm-6 col-xs-6 col-md-6 " style="margin-right: 158px; font-size: 14px;font-weight: bold;"> Telefono</div>' +
                '   <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 " style="margin-left: 145px; margin-top: -15px;font-weight: bold;color: grey;">' + data.job_pickup_phone + '</div>' +

                '</div>' +
                ' <div  class="col-lg-12 col-sm-12 col-xs-12 col-md-12 " style= "padding:20px;border-bottom: 3px solid grey;" id="Observanciones">' +

                '  <div  class="col-lg-6 col-sm-6 col-xs-6 col-md-6 " style="margin-right: 113px; font-size: 14px;font-weight: bold;" >Observanciones</div>' +
                '   <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 " style="margin-left: 145px; margin-top: -15px;font-weight: bold;color: grey;">' + data.observations + '</div>' +

                '</div>' +
                '  <div class="col-lg-12 col-sm-12 col-xs-12 col-md-12 " style="padding:0px"> <button id="asignarManual" class="col-lg-6 col-sm-6 col-xs-6 col-md-6 " style="background-color: blue;font-weight: bold;border-right: 2px solid grey;font-size: 15px;padding: 14px;width: 50%;color:white">Asignar</button> <button id="autoAsignarManual" class="col-lg-6 col-sm-6 col-xs-6 col-md-6 " style="background-color: blue;font-weight: bold;font-size: 15px;padding: 14px;width: 50%;color:white">Auto Asignar</button> </div>' +
                '  <div class="col-lg-12 col-sm-12 col-xs-12 col-md-12 " style="padding:0px;width:101%;margin-left:-1px" id="InputBoxShow"> <input class=form-control  type="number" style="border-radius:0px" placeholder="Identificación única del automóvil"> </div>' +


                // '  <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 paddingOnDuty pickBorder">On Duty: ' + data.difference + 'min</div>' +
                // '<div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 paddingOnDuty pickBorder">Since: ' + data.since + '</div>' +
                // '<div class="col-lg-12 col-sm-12 col-xs-12 col-md-12 paddingOnDuty statusChangeD" id="makebookingStatusChange">' + onOffData.text + '</div>' +
                '</div>';



            if (data.is_person == 1) {
                $timeout(function () {
                    $('#autoAsignarManual').prop('disabled', false);
                    $('#asignarManual').prop('disabled', false);
                    $('#InputBoxShow').css('display', 'none');
                }, 1000)
                return divWithService;
            }
        };

        function infoWindows1(data, onOffData, onOffData1) {
            data.since_date = moment(onOffData1.since).format('DD/MM/YY');
            onOffData1 = onOffData1.res;
            var divWithService1 = '<div class="row" id="googleMapsDetailsWithCar">' +
                '<div class="col-lg-12 col-sm-12 col-xs-12 col-md-12">' +
                '<div class="row">' +
                '<div class="col-lg-4 col-sm-4 col-xs-4 col-md-4">' +
                '<img src="' + onOffData1.fleet_image + '" />' +
                '</div>' +
                '<div class="col-lg-8 col-sm-8 col-xs-8 col-md-8 paddingZero" style="text-align:initial">' +
                '<h1 style="">Driver Free</h1>' +
                ' <p id="driver">Driver</p>' +
                ' <p class="details">' + onOffData1.first_name + " " + onOffData1.last_name + '</p>' +
                '<p class="details">' + onOffData1.country_code + onOffData1.phone + '</p>' +
                ' <p class="details">Vehicle ' + ' #' + onOffData1.current_car_details + '</p>' +
                ' <p class="details">Unique Number' + " " + "#" + onOffData1.unique_car_id + '</p>' +
                ' <p class="details">On Duty Date' + " " + data.since_date + '</p>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '<div class="col-lg-12 col-sm-12 col-xs-12 col-md-12"   id="ManualAssign" style="margin-top: 10px;background-color: #7ed321;font-weight: bold;border: #7ed321;font-size: 15px;padding: 14px;width: 100%;color:white">Asignar</div>' +
                '</div>';

            // 



            if (vm.flagforDriverStatus == true)
                return divWithService1;

        };

        function infoWindows2(data, onOffData, onOffData1) {
            data.job_pickup_datetime_filter = $filter('date')(onOffData1.res.job_time_utc, "hh:mm a");
            data.since_date = moment(data.since).format('DD/MM/YY');
            if (onOffData1.res.job_status == 1) {
                data.job_status_string = 'Started';
            } else if (onOffData1.res.job_status == 7) {
                data.job_status_string = 'Accepted';
            } else if (onOffData1.res.job_status == 4) {
                data.job_status_string = 'Arrived';
            } else if (onOffData1.res.job_status == 15) {
                data.job_status_string = 'On Road';
            }
            data.eta = Math.floor(onOffData1.time / 60);
            data.distance = (onOffData1.distance / 1000).toFixed(2);
            data.since_date = moment(onOffData1.since).format('DD/MM/YY');
            if (onOffData1.difference == 0) {
                data.difference = 0;
            } else {
                data.difference = Math.floor(onOffData1.difference / 60);
            }
            if (onOffData1.since == "0000-00-00 00:00:00") {
                data.since = '0';
            } else {
                data.since = $filter('date')(onOffData1.since, "hh:mm a");
            }
            var divWithService2 = '<div class="row" id="googleMapsDetailsWithCar">' +
                '  <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 paddingOnDuty1">' +
                '  <div class="pickUpText">Pickup</div>' +
                '   <div class="addressDiv"><i class="fa fa-map-marker"></i>&nbsp;&nbsp;' + onOffData1.res.job_pickup_address + '</div>' +
                ' </div>' +
                '<div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 paddingOnDuty1">' +
                '    <div class="pickUpText">Drop off</div>' +
                '<div class="addressDiv"><i class="fa fa-map-marker"></i>&nbsp;&nbsp;' + onOffData1.res.job_address + '</div>' +
                '</div>' +
                '<div class="col-lg-12 col-sm-12 col-xs-12 col-md-12 distanceDivP">' +
                '    <div class="distanceDiv">Distance ' + data.distance + 'KM</div>' +
                '<div class="distanceDiv">Time Approx ' + data.eta + ' min</div>' +
                '</div>' +
                ' <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 customerDriverDiv">' +
                '   <div class="customerDivP">' +
                '  <div class="customerText">Customer</div>' +
                '   <div class="customerName">' + onOffData1.res.customer_username + '</div>' +
                ' <div class="customerName">' + onOffData1.res.country_code + onOffData1.res.customer_phone + '</div>' +
                '   </div>' +
                '   <div class="driverDivP">' +
                '   <div class="driverText">Driver</div>' +
                '    <div class="driverName">' + onOffData1.res.first_name + " " + onOffData1.res.last_name + '</div>' +
                '<div class="driverName">' + onOffData1.res.country_code + onOffData1.res.phone + '</div>' +
                '   <div class="driverName">Vehicle ' + ' #' + onOffData1.res.current_car_details + '</div>' +
                '   <div class="driverName">Unique Number' + " " + "#" + onOffData1.res.unique_car_id + '</div>' +
                '   <div class="driverName">On Duty Date' + " " + data.since_date + '</div>' +
                '</div>' +
                '</div>' +
                ' <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 pickUpDetails">' +
                '   <div class="pickUpText1">Pickup Time</div>' +
                '<div class="pickUpTime">' + data.job_pickup_datetime_filter + '</div>' +
                '<div class="pickUpStatus">' + data.job_status_string + '</div>' +
                '<div class="pickUpAgreement">' + onOffData1.res.contract_name + '</div>' +
                '  <div class="pickUpAgreement">' + onOffData1.res.service_name + '</div>' +
                '  </div>' +
                '  <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 paddingOnDuty pickBorder">On Duty: ' + data.difference + 'min</div>' +
                '<div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 paddingOnDuty pickBorder">Since: ' + data.since + '</div>' +
                '<div class="col-lg-12 col-sm-12 col-xs-12 col-md-12"   id="ManualAssign" style="margin-top: 10px;background-color: #7ed321;font-weight: bold;border: #7ed321;font-size: 15px;padding: 14px;width: 100%;color:white">Asignar</div>' +
                '</div>';

            // 


            if (vm.flagforDriverStatus == true && data.busyDriver && data.busyDriver == true)
                return divWithService2;



        };

        function infoWindows3(data, onOffData) {
            var divWithService3 = '<div class="row" id="googleMapsDetailsWithCar">' +
                '  <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 paddingOnDuty1">' +
                '  <div class="pickUpText">Pickup</div>' +
                '   <div class="addressDiv"><i class="fa fa-map-marker"></i>&nbsp;&nbsp;' + onOffData.job_pickup_address + '</div>' +
                ' </div>' +
                '<div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 paddingOnDuty1">' +
                '    <div class="pickUpText">Drop off</div>' +
                '<div class="addressDiv"><i class="fa fa-map-marker"></i>&nbsp;&nbsp;' + onOffData.job_address + '</div>' +
                '</div>' +
                '<div class="col-lg-12 col-sm-12 col-xs-12 col-md-12 distanceDivP">' +
                '    <div class="distanceDiv">Distance ' + data.distance + 'KM</div>' +
                '<div class="distanceDiv">Time Approx ' + data.eta + ' min</div>' +
                '</div>' +
                ' <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 customerDriverDiv">' +
                '   <div class="customerDivP">' +
                '  <div class="customerText">Customer</div>' +
                '   <div class="customerName">' + onOffData.customer_username + '</div>' +
                ' <div class="customerName">' + onOffData.country_code + onOffData.customer_phone + '</div>' +
                '   </div>' +
                '   <div class="driverDivP">' +
                '   <div class="driverText">Driver</div>' +
                '    <div class="driverName">' + onOffData.first_name + " " + onOffData.last_name + '</div>' +
                '<div class="driverName">' + onOffData.country_code + onOffData.phone + '</div>' +
                '   <div class="driverName">Vehicle ' + ' #' + onOffData.current_car_details + '</div>' +
                '   <div class="driverName">Unique Number' + " " + "#" + onOffData.unique_car_id + '</div>' +
                '   <div class="driverName">On Duty Date' + " " + data.since_date + '</div>' +
                '</div>' +
                '</div>' +
                ' <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 pickUpDetails">' +
                '   <div class="pickUpText1">Pickup Time</div>' +
                '<div class="pickUpTime">' + data.job_pickup_datetime_filter + '</div>' +
                '<div class="pickUpStatus">' + onOffData.job_status_string + '</div>' +
                '<div class="pickUpAgreement">' + onOffData.contract_name + '</div>' +
                '  <div class="pickUpAgreement">' + onOffData.service_name + '</div>' +
                '  </div>' +
                '  <div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 paddingOnDuty pickBorder">On Duty: ' + data.difference + 'min</div>' +
                '<div class="col-lg-6 col-sm-6 col-xs-6 col-md-6 paddingOnDuty pickBorder">Since: ' + data.since + '</div>' +
                '<div class="col-lg-12 col-sm-12 col-xs-12 col-md-12"   id="ManualAssign" style="margin-top: 10px;background-color: #7ed321;font-weight: bold;border: #7ed321;font-size: 15px;padding: 14px;width: 100%;color:white">Asignar</div>' +
                '</div>';

            // 



            if (vm.flagforDriverStatus == true && data.bookingHasNextTime && data.bookingHasNextTime == true)
                return divWithService3;

        };




        function showInfoWindowWithDetails(marker, infoWindow, data) {
            if (data.is_person == true) {
                marker.content = infoWindows(data, vm.onOffData);
                setTimeout(function () {
                    infoWindow.setContent(marker.content);
                    // infowindow.close();
                    // infowindow = new google.maps.InfoWindow({
                    //     content: marker.content
                    // });
                    infowindow.open(map, marker);

                    setTimeout(function () {
                        setDomReady();
                    }, 100);
                }, 100);
                $timeout(function () {
                    if (data.observations == "") {
                        $('#Observanciones').css('display', 'none');
                    }
                    if (data.reference_point == "") {
                        $('#referencePoint').css('display', 'none');

                    }
                }, 500);

            }

        };
        vm.loadingOnMap = false;

        function setDomReady() {
            console.log(" i m in dom ");
            var iwOuter = $('.gm-style-iw');
            var iwBackground = iwOuter.prev();
            iwOuter.css({
                top: '36px',
                left: '20px'
            });
            iwOuter.children().children(':nth-child(1)').css({
                'overflow': 'hidden',
                // padding: '18px'
            });

            // Remove the background shadow DIV
            iwBackground.children(':nth-child(2)').css({
                'display': 'none'
            });
            // Remove the white background DIV
            iwBackground.children(':nth-child(4)').css({
                'display': 'none'
            });
            //iwOuter.parent().parent().css({ left: '115px' });
            //// Moves the shadow of the arrow 76px to the left margin
            //iwBackground.children(':nth-child(1)').attr('style', function (i, s) { return s + 'left: 76px !important;' });
            //// Moves the arrow 76px to the left margin
            //iwBackground.children(':nth-child(3)').attr('style', function (i, s) { return s + 'left: 76px !important;' });
            iwBackground.children(':nth-child(3)').find('div').children().css({
                'background-color': 'cornsilk',
                'box-shadow': 'none'
            });
            var iwCloseBtn = iwOuter.next();
            // Apply the desired effect to the close button
            iwCloseBtn.css({
                right: '52px',
                top: '62px', // button repositioning
                backgound: 'none'
            });
            // The API automatically applies 0.7 opacity to the button after the mouseout event.
            // This function reverses this event to the desired value.
            iwCloseBtn.mouseout(function () {
                $(this).css({
                    opacity: '1'
                });
            });
            $('#googleMapsDetailsWithCar').parent().addClass('col-lg-12 col-md-12 col-sm-12');
            // iwOuter.parent().addClass('custom-iw');
            if (vm.jobStatusOfMarker == 1) {
                $('.pickUpStatus').removeClass('onRoadAcceptedColor');
                $('.pickUpStatus').removeClass('inPositionColor');
                $('.pickUpStatus').addClass('startedColor');

                $('.statusChangeD').removeClass('inPositionColorB');
                $('.statusChangeD').addClass('completedColorB');
                $('.statusChangeD').removeClass('startedColorB');
                $('.statusChangeD').removeClass('onRoadAcceptedColorB');
            } else if (vm.jobStatusOfMarker == 7) {
                $('.pickUpStatus').removeClass('startedColor');
                $('.pickUpStatus').removeClass('inPositionColor');
                $('.pickUpStatus').addClass('onRoadAcceptedColor');

                $('.statusChangeD').removeClass('inPositionColorB');
                $('.statusChangeD').removeClass('completedColorB');
                $('.statusChangeD').removeClass('startedColorB');
                $('.statusChangeD').addClass('onRoadAcceptedColorB');
            } else if (vm.jobStatusOfMarker == 4) {
                $('.pickUpStatus').removeClass('startedColor');
                $('.pickUpStatus').removeClass('onRoadAcceptedColor');
                $('.pickUpStatus').addClass('inPositionColor');

                $('.statusChangeD').removeClass('inPositionColorB');
                $('.statusChangeD').removeClass('completedColorB');
                $('.statusChangeD').addClass('startedColorB');
                $('.statusChangeD').removeClass('onRoadAcceptedColorB');
            } else if (vm.jobStatusOfMarker == 15) {
                $('.pickUpStatus').removeClass('startedColor');
                $('.pickUpStatus').removeClass('inPositionColor');
                $('.pickUpStatus').addClass('onRoadAcceptedColor');

                $('.statusChangeD').addClass('inPositionColorB');
                $('.statusChangeD').removeClass('completedColorB');
                $('.statusChangeD').removeClass('startedColorB');
                $('.statusChangeD').removeClass('onRoadAcceptedColorB');
            }
        }

        function showInfoWindowWithDetails1(marker, infoWindow, data) {
            var dataSend = {
                fleet_id: marker.id,
                status: marker.status
            }

            // getFleetOnOffData(dataSend);
            vm.loadingOnMap = true;
            var dataToSend = {
                fleet_id: dataSend.fleet_id,
                is_available: dataSend.status,
                access_token: $cookies.get('obj')
            };
            var promise = mapDashboard.getOnOffData(dataToSend);
            promise.then(
                function (payload) {
                    vm.onOffData1 = payload.title.data;
                    vm.loadingOnMap = false;

                    //    if(vm.searchVechileData){
                    // vm.searchVechileData.forEach(function(searchData){
                    //     searchData.popforShow = true;
                    // });
                    // data.since_date = moment(data.since).format('DD/MM/YY');
                    // for (var i = 0; i < vm.collectedData.length; i++) {
                    if (vm.flagforDriverStatus == true && !data.busyDriver && vm.onOffData1) {
                        setTimeout(function () {
                            marker.content = infoWindows1(data, vm.onOffData, vm.onOffData1);
                            infoWindow.setContent(marker.content);
                            infoWindow.open(map, marker);
                            setTimeout(function () {
                                $('#ManualAssign').click(function () {
                                    console.log(" i m in thi fun");
                                    if (vm.storeData.booking_type == 0 && vm.storeData.locking_id == null) {
                                        checkBeforeAssignDriver(vm.storeData, data)
                                    } else {
                                        if (vm.storeData.locking_id != null) {
                                            errorMessageFactory.showErrorMessage("La reserva está bloqueada por usuario" + vm.storeData.locking_id_name + " para la creación o modificación del paquete", 0)
                                        } else {
                                            errorMessageFactory.showErrorMessage("La reserva no se puede asignar porque se está convirtiendo en parte del nuevo servicio compartido ya enrutado. Solicita que se elimine del servicio compartido enrutado y luego se lo asigna", 0);
                                        }
                                    }

                                });
                            }, 500)
                        }, 1500)
                    }

                    if (data.busyDriver && data.busyDriver == true && vm.flagforDriverStatus == true && vm.onOffData1 && vm.onOffData1.res.job_pickup_address != null) {
                        setTimeout(function () {
                            marker.content = infoWindows2(data, vm.onOffData, vm.onOffData1);
                            infoWindow.setContent(marker.content);
                            infoWindow.open(map, marker);
                            setTimeout(function () {
                                $('#ManualAssign').click(function () {
                                    console.log("I M IN THIS 2");
                                    if (vm.storeData.booking_type == 0 && vm.storeData.locking_id == null) {
                                        checkBeforeAssignDriver(vm.storeData, data)
                                    } else {
                                        if (vm.storeData.locking_id != null) {
                                            errorMessageFactory.showErrorMessage("La reserva está bloqueada por usuario" + vm.storeData.locking_id_name + " para la creación o modificación del paquete", 0)
                                        } else {
                                            errorMessageFactory.showErrorMessage("La reserva no se puede asignar porque se está convirtiendo en parte del nuevo servicio compartido ya enrutado. Solicita que se elimine del servicio compartido enrutado y luego se lo asigna", 0);
                                        }
                                    }
                                });
                            }, 500)
                        }, 1500);

                    }
                    if (data.bookingHasNextTime && data.bookingHasNextTime == true && vm.flagforDriverStatus == true && vm.onOffData1) {
                        setTimeout(function () {
                            marker.content = infoWindows1(data, vm.onOffData, vm.onOffData1);
                            infoWindow.setContent(marker.content);
                            infoWindow.open(map, marker);
                            setTimeout(function () {
                                $('#ManualAssign').click(function () {
                                    if (vm.storeData.booking_type == 0 && vm.storeData.locking_id == null) {
                                        checkBeforeAssignDriver(vm.storeData, data)
                                    } else {
                                        if (vm.storeData.locking_id != null) {
                                            errorMessageFactory.showErrorMessage("La reserva está bloqueada por usuario" + vm.storeData.locking_id_name + " para la creación o modificación del paquete", 0)
                                        } else {
                                            errorMessageFactory.showErrorMessage("La reserva no se puede asignar porque se está convirtiendo en parte del nuevo servicio compartido ya enrutado. Solicita que se elimine del servicio compartido enrutado y luego se lo asigna", 0);
                                        }
                                    }
                                });
                            })
                        }, 1500);
                    }

                    // ********** CHECK BOOKING IS SELECTED OR NOT *************
                    if (!vm.flagforDriverStatus) {
                        errorMessageFactory.showErrorMessage('Primero debes seleccionar una Reserva.', 0);
                    }
                    // }
                    //    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loadingOnMap = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );

        }


        //====================socket connection===================
        var myListener = $rootScope.$on('quickScreeenBookingCreationSocket', function (evt, data) {
            console.log('debug', data);
            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            var dateTo = new Date(date_time_value2).getTime();
            var dateFrom = new Date(date_time_value1).getTime();
            for (var i = 0; i < data.res.message.jobArray.length; i++) {

                var booking_date = data.res.message.jobArray[i].job_time_utc;
                booking_date = new Date(booking_date).getTime();

                if (dateFrom <= booking_date && booking_date <= dateTo) {
                    if (vm.filterData.type_of_trip_filter == [] || (vm.filterData.type_of_trip.includes(data.res.message.jobArray[i].type_of_trip))) {
                        if (vm.filterData.service_filter == [] || vm.filterData.service.includes(data.res.message.jobArray[i].type_of_service)) {
                            if (vm.filterData.aggrement_filter == 0 || (vm.filterData.agreement == data.res.message.jobArray[i].contract_id)) {
                                if (vm.filterData.branch_filter == 0 || (vm.filterData.branch == data.res.message.jobArray[i].branch)) {
                                    var index = _.findIndex(vm.UnAssignBookingList, {
                                        job_id: data.res.message.jobArray[i].job_id
                                    });
                                    if (index == -1) {
                                        if (vm.UnAssignBookingList.length == 0 && data.res.message.jobArray[i].discard_from_group) {
                                            vm.UnAssignBookingList.push({
                                                "contract_name": data.res.message.jobArray[i].contract_name,
                                                "estimated_payment_cost": data.res.message.jobArray[i].estimated_payment_cost,
                                                "is_VIP": data.res.message.jobArray[i].is_VIP,
                                                "is_round_trip": data.res.message.jobArray[i].is_round_trip,
                                                "booking_type": data.res.message.jobArray[i].booking_type,
                                                "branch": data.res.message.jobArray[i].branch,
                                                "type_of_service": data.res.message.jobArray[i].type_of_service,
                                                "job_address": data.res.message.jobArray[i].job_address,
                                                "job_id": data.res.message.jobArray[i].job_id,
                                                "job_pickup_address": data.res.message.jobArray[i].job_pickup_address,
                                                "job_pickup_name": data.res.message.jobArray[i].job_pickup_name,
                                                "job_pickup_phone": data.res.message.jobArray[i].job_pickup_phone,
                                                "job_time_utc": data.res.message.jobArray[i].job_time_utc,
                                                "locking_id": data.res.message.jobArray[i].locking_id,
                                                "service_name": data.res.message.jobArray[i].service_name,
                                                "locking_id_name": data.res.message.jobArray[i].locking_id_name,
                                                "observations": data.res.message.jobArray[i].observations,
                                                "reference_point": data.res.message.jobArray[i].reference_point,
                                                "round_trip_pickup_time_utc": data.res.message.jobArray[i].round_trip_pickup_time_utc,
                                                "urgent_booking_assignment": data.res.message.jobArray[i].urgent_booking_assignment,
                                                "latitude": data.res.message.jobArray[i].latitude,
                                                "longitude": data.res.message.jobArray[i].longitude,
                                                "is_person": true,
                                                "booking_eta": data.res.message.jobArray[i].booking_eta,
                                                "color": "#333"
                                            });
                                            $scope.$apply();
                                        } else {
                                            for (var j = 0; j < vm.UnAssignBookingList.length; j++) {
                                                if (new Date(vm.UnAssignBookingList[j].job_time_utc).getTime() > new Date(data.res.message.jobArray[i].job_time_utc).getTime() && data.res.message.jobArray[i].discard_from_group) {
                                                    vm.UnAssignBookingList.insert(j, {
                                                        "contract_name": data.res.message.jobArray[i].contract_name,
                                                        "estimated_payment_cost": data.res.message.jobArray[i].estimated_payment_cost,
                                                        "is_VIP": data.res.message.jobArray[i].is_VIP,
                                                        "is_round_trip": data.res.message.jobArray[i].is_round_trip,
                                                        "booking_type": data.res.message.jobArray[i].booking_type,
                                                        "branch": data.res.message.jobArray[i].branch,
                                                        "type_of_service": data.res.message.jobArray[i].type_of_service,
                                                        "job_address": data.res.message.jobArray[i].job_address,
                                                        "job_id": data.res.message.jobArray[i].job_id,
                                                        "job_pickup_address": data.res.message.jobArray[i].job_pickup_address,
                                                        "job_pickup_name": data.res.message.jobArray[i].job_pickup_name,
                                                        "job_pickup_phone": data.res.message.jobArray[i].job_pickup_phone,
                                                        "job_time_utc": data.res.message.jobArray[i].job_time_utc,
                                                        "locking_id": data.res.message.jobArray[i].locking_id,
                                                        "service_name": data.res.message.jobArray[i].service_name,
                                                        "locking_id_name": data.res.message.jobArray[i].locking_id_name,
                                                        "observations": data.res.message.jobArray[i].observations,
                                                        "reference_point": data.res.message.jobArray[i].reference_point,
                                                        "round_trip_pickup_time_utc": data.res.message.jobArray[i].round_trip_pickup_time_utc,
                                                        "urgent_booking_assignment": data.res.message.jobArray[i].urgent_booking_assignment,
                                                        "latitude": data.res.message.jobArray[i].latitude,
                                                        "longitude": data.res.message.jobArray[i].longitude,
                                                        "is_person": true,
                                                        "booking_eta": data.res.message.jobArray[i].booking_eta,
                                                        "color": "#333"
                                                    });
                                                    $scope.$apply();
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

            }
        });

        //====================socket connection===================
        $rootScope.$on('quickScreeenBookingunassignedSocket', function (evt, data) {
            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            var dateTo = new Date(date_time_value2).getTime();
            var dateFrom = new Date(date_time_value1).getTime();
            for (var i = 0; i < data.res.message.jobArray.length; i++) {

                var booking_date = data.res.message.jobArray[i].job_time_utc;
                booking_date = new Date(booking_date).getTime();

                if (dateFrom <= booking_date && booking_date <= dateTo) {

                    if (vm.filterData.type_of_trip_filter == [] || (vm.filterData.type_of_trip.includes(data.res.message.jobArray[i].type_of_trip))) {

                        if (vm.filterData.service_filter == [] || vm.filterData.service.includes(data.res.message.jobArray[i].type_of_service)) {

                            if (vm.filterData.aggrement_filter == 0 || (vm.filterData.agreement == data.res.message.jobArray[i].contract_id)) {

                                if (vm.filterData.branch_filter == 0 || (vm.filterData.branch == data.res.message.jobArray[i].branch)) {
                                    var index = _.findIndex(vm.UnAssignBookingList, {
                                        job_id: data.res.message.jobArray[i].job_id
                                    });
                                    if (index == -1) {
                                        // vm.loadMore = 1;
                                        if (vm.UnAssignBookingList.length == 0) {
                                            vm.UnAssignBookingList.push({
                                                "contract_name": data.res.message.jobArray[i].contract_name,
                                                "estimated_payment_cost": data.res.message.jobArray[i].estimated_payment_cost,
                                                "is_VIP": data.res.message.jobArray[i].is_VIP,
                                                "is_round_trip": data.res.message.jobArray[i].is_round_trip,
                                                "booking_type": data.res.message.jobArray[i].booking_type,
                                                "branch": data.res.message.jobArray[i].branch,
                                                "type_of_service": data.res.message.jobArray[i].type_of_service,
                                                "job_address": data.res.message.jobArray[i].job_address,
                                                "job_id": data.res.message.jobArray[i].job_id,
                                                "job_pickup_address": data.res.message.jobArray[i].job_pickup_address,
                                                "job_pickup_name": data.res.message.jobArray[i].job_pickup_name,
                                                "job_pickup_phone": data.res.message.jobArray[i].job_pickup_phone,
                                                "job_time_utc": data.res.message.jobArray[i].job_time_utc,
                                                "locking_id": data.res.message.jobArray[i].locking_id,
                                                "service_name": data.res.message.jobArray[i].service_name,
                                                "locking_id_name": data.res.message.jobArray[i].locking_id_name,
                                                "observations": data.res.message.jobArray[i].observations,
                                                "reference_point": data.res.message.jobArray[i].reference_point,
                                                "round_trip_pickup_time_utc": data.res.message.jobArray[i].round_trip_pickup_time_utc,
                                                "urgent_booking_assignment": data.res.message.jobArray[i].urgent_booking_assignment,
                                                "latitude": data.res.message.jobArray[i].latitude,
                                                "longitude": data.res.message.jobArray[i].longitude,
                                                "is_person": true,
                                                "booking_eta": data.res.message.jobArray[i].booking_eta,
                                                "color": "#333"
                                            });
                                            $scope.$apply();
                                        } else {
                                            for (var j = 0; j < vm.UnAssignBookingList.length; j++) {
                                                if (new Date(vm.UnAssignBookingList[j].job_time_utc).getTime() > new Date(data.res.message.jobArray[i].job_time_utc).getTime()) {
                                                    vm.UnAssignBookingList.insert(j, {
                                                        "contract_name": data.res.message.jobArray[i].contract_name,
                                                        "estimated_payment_cost": data.res.message.jobArray[i].estimated_payment_cost,
                                                        "is_VIP": data.res.message.jobArray[i].is_VIP,
                                                        "is_round_trip": data.res.message.jobArray[i].is_round_trip,
                                                        "booking_type": data.res.message.jobArray[i].booking_type,
                                                        "branch": data.res.message.jobArray[i].branch,
                                                        "type_of_service": data.res.message.jobArray[i].type_of_service,
                                                        "job_address": data.res.message.jobArray[i].job_address,
                                                        "job_id": data.res.message.jobArray[i].job_id,
                                                        "job_pickup_address": data.res.message.jobArray[i].job_pickup_address,
                                                        "job_pickup_name": data.res.message.jobArray[i].job_pickup_name,
                                                        "job_pickup_phone": data.res.message.jobArray[i].job_pickup_phone,
                                                        "job_time_utc": data.res.message.jobArray[i].job_time_utc,
                                                        "locking_id": data.res.message.jobArray[i].locking_id,
                                                        "service_name": data.res.message.jobArray[i].service_name,
                                                        "locking_id_name": data.res.message.jobArray[i].locking_id_name,
                                                        "observations": data.res.message.jobArray[i].observations,
                                                        "reference_point": data.res.message.jobArray[i].reference_point,
                                                        "round_trip_pickup_time_utc": data.res.message.jobArray[i].round_trip_pickup_time_utc,
                                                        "urgent_booking_assignment": data.res.message.jobArray[i].urgent_booking_assignment,
                                                        "latitude": data.res.message.jobArray[i].latitude,
                                                        "longitude": data.res.message.jobArray[i].longitude,
                                                        "is_person": true,
                                                        "booking_eta": data.res.message.jobArray[i].booking_eta,
                                                        "color": "#333"
                                                    });
                                                    $scope.$apply();
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

            }
        });

        //====================socket connection===================
        $rootScope.$on('quickScreeenBookingScanneddSocket', function (evt, data) {
            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            var dateTo = new Date(date_time_value2).getTime();
            var dateFrom = new Date(date_time_value1).getTime();
            for (var i = 0; i < data.res.message.jobArray.length; i++) {

                var booking_date = data.res.message.jobArray[i].job_time_utc;
                booking_date = new Date(booking_date).getTime();

                if (dateFrom <= booking_date && booking_date <= dateTo) {

                    if (vm.filterData.type_of_trip_filter == [] || (vm.filterData.type_of_trip.includes(data.res.message.jobArray[i].type_of_trip))) {

                        if (vm.filterData.service_filter == [] || vm.filterData.service.includes(data.res.message.jobArray[i].type_of_service)) {

                            if (vm.filterData.aggrement_filter == 0 || (vm.filterData.agreement == data.res.message.jobArray[i].contract_id)) {

                                if (vm.filterData.branch_filter == 0 || (vm.filterData.branch == data.res.message.jobArray[i].branch)) {
                                    var index = _.findIndex(vm.UnAssignBookingList, {
                                        job_id: data.res.message.jobArray[i].job_id
                                    });
                                    if (index != -1) {
                                        vm.UnAssignBookingList.splice(index, 1);
                                        $scope.$apply();
                                    }
                                }
                            }
                        }
                    }
                }

            }
        });

        var assignSocket = $rootScope.$on('quickScreeenBookingAssignedSocket', function (evt, data) {
            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            var dateTo = new Date(date_time_value2).getTime();
            var dateFrom = new Date(date_time_value1).getTime();

            for (var i = 0; i < data.res.message.jobArray.length; i++) {

                var booking_date = data.res.message.jobArray[i].job_time_utc;
                booking_date = new Date(booking_date).getTime();

                if (dateFrom <= booking_date && booking_date <= dateTo) {
                    console.log("i m in socket type of date", dateFrom <= booking_date && booking_date <= dateTo);
                    if (vm.filterData.type_of_trip_filter == [] || (vm.filterData.type_of_trip.includes(data.res.message.jobArray[i].type_of_trip))) {
                        console.log("i m in socket type of trip", vm.filterData.type_of_trip);
                        if (vm.filterData.service_filter == [] || vm.filterData.service.includes(data.res.message.jobArray[i].type_of_service)) {
                            console.log("i m in socket service");
                            if (vm.filterData.aggrement_filter == 0 || (vm.filterData.agreement == data.res.message.jobArray[i].contract_id)) {
                                console.log("i m in socket agreement");
                                if (vm.filterData.branch_filter == 0 || (vm.filterData.branch == data.res.message.jobArray[i].branch)) {
                                    console.log("i m in socket branch");

                                    var index = _.findIndex(vm.UnAssignBookingList, {
                                        job_id: data.res.message.jobArray[i].job_id
                                    });
                                    console.log(index, "i m in socket index");
                                    if (index != -1) {
                                        vm.UnAssignBookingList.splice(index, 1);
                                        console.log("i m in socket splice");
                                        $scope.$apply();
                                    } else {
                                        if (data.res.message.jobArray[i].job_status == 6) {
                                            vm.UnAssignBookingList.push({
                                                "contract_name": data.res.message.jobArray[i].contract_name,
                                                "estimated_payment_cost": data.res.message.jobArray[i].estimated_payment_cost,
                                                "is_VIP": data.res.message.jobArray[i].is_VIP,
                                                "is_round_trip": data.res.message.jobArray[i].is_round_trip,
                                                "booking_type": data.res.message.jobArray[i].booking_type,
                                                "branch": data.res.message.jobArray[i].branch,
                                                "type_of_service": data.res.message.jobArray[i].type_of_service,
                                                "job_address": data.res.message.jobArray[i].job_address,
                                                "job_id": data.res.message.jobArray[i].job_id,
                                                "job_pickup_address": data.res.message.jobArray[i].job_pickup_address,
                                                "job_pickup_name": data.res.message.jobArray[i].job_pickup_name,
                                                "job_pickup_phone": data.res.message.jobArray[i].job_pickup_phone,
                                                "job_time_utc": data.res.message.jobArray[i].job_time_utc,
                                                "locking_id": data.res.message.jobArray[i].locking_id,
                                                "service_name": data.res.message.jobArray[i].service_name,
                                                "locking_id_name": data.res.message.jobArray[i].locking_id_name,
                                                "observations": data.res.message.jobArray[i].observations,
                                                "reference_point": data.res.message.jobArray[i].reference_point,
                                                "round_trip_pickup_time_utc": data.res.message.jobArray[i].round_trip_pickup_time_utc,
                                                "urgent_booking_assignment": data.res.message.jobArray[i].urgent_booking_assignment,
                                                "latitude": data.res.message.jobArray[i].latitude,
                                                "longitude": data.res.message.jobArray[i].longitude,
                                                "is_person": true,
                                                "booking_eta": data.res.message.jobArray[i].booking_eta,
                                                "color": "#333"
                                            });
                                            $scope.$apply();
                                        }
                                    }

                                    var index = _.findIndex(vm.assignBookingList, {
                                        job_id: data.res.message.jobArray[i].job_id
                                    });
                                    if (index == -1) {
                                        // vm.loadMore = 1;
                                        if (vm.assignBookingList.length == 0) {
                                            vm.assignBookingList.push({
                                                "contract_name": data.res.message.jobArray[i].contract_name,
                                                "estimated_payment_cost": data.res.message.jobArray[i].estimated_payment_cost,
                                                "is_VIP": data.res.message.jobArray[i].is_VIP,
                                                "is_round_trip": data.res.message.jobArray[i].is_round_trip,
                                                "booking_type": data.res.message.jobArray[i].booking_type,
                                                "branch": data.res.message.jobArray[i].branch,
                                                "type_of_service": data.res.message.jobArray[i].type_of_service,
                                                "job_address": data.res.message.jobArray[i].job_address,
                                                "job_id": data.res.message.jobArray[i].job_id,
                                                "job_pickup_address": data.res.message.jobArray[i].job_pickup_address,
                                                "job_pickup_name": data.res.message.jobArray[i].job_pickup_name,
                                                "job_pickup_phone": data.res.message.jobArray[i].job_pickup_phone,
                                                "job_time_utc": data.res.message.jobArray[i].job_time_utc,
                                                "locking_id": data.res.message.jobArray[i].locking_id,
                                                "service_name": data.res.message.jobArray[i].service_name,
                                                "locking_id_name": data.res.message.jobArray[i].locking_id_name,
                                                "observations": data.res.message.jobArray[i].observations,
                                                "reference_point": data.res.message.jobArray[i].reference_point,
                                                "round_trip_pickup_time_utc": data.res.message.jobArray[i].round_trip_pickup_time_utc,
                                                "urgent_booking_assignment": data.res.message.jobArray[i].urgent_booking_assignment,
                                                "latitude": data.res.message.jobArray[i].latitude,
                                                "longitude": data.res.message.jobArray[i].longitude,
                                                "is_person": true,
                                                "booking_eta": data.res.message.jobArray[i].booking_eta,
                                                "color": "#333"
                                            });
                                            $scope.$apply();
                                        } else {
                                            for (var j = 0; j < vm.assignBookingList.length; j++) {
                                                if (new Date(vm.assignBookingList[j].job_time_utc).getTime() > new Date(data.res.message.jobArray[i].job_time_utc).getTime()) {
                                                    vm.assignBookingList.insert(j, {
                                                        "contract_name": data.res.message.jobArray[i].contract_name,
                                                        "estimated_payment_cost": data.res.message.jobArray[i].estimated_payment_cost,
                                                        "is_VIP": data.res.message.jobArray[i].is_VIP,
                                                        "is_round_trip": data.res.message.jobArray[i].is_round_trip,
                                                        "booking_type": data.res.message.jobArray[i].booking_type,
                                                        "branch": data.res.message.jobArray[i].branch,
                                                        "type_of_service": data.res.message.jobArray[i].type_of_service,
                                                        "job_address": data.res.message.jobArray[i].job_address,
                                                        "job_id": data.res.message.jobArray[i].job_id,
                                                        "job_pickup_address": data.res.message.jobArray[i].job_pickup_address,
                                                        "job_pickup_name": data.res.message.jobArray[i].job_pickup_name,
                                                        "job_pickup_phone": data.res.message.jobArray[i].job_pickup_phone,
                                                        "job_time_utc": data.res.message.jobArray[i].job_time_utc,
                                                        "locking_id": data.res.message.jobArray[i].locking_id,
                                                        "service_name": data.res.message.jobArray[i].service_name,
                                                        "locking_id_name": data.res.message.jobArray[i].locking_id_name,
                                                        "observations": data.res.message.jobArray[i].observations,
                                                        "reference_point": data.res.message.jobArray[i].reference_point,
                                                        "round_trip_pickup_time_utc": data.res.message.jobArray[i].round_trip_pickup_time_utc,
                                                        "urgent_booking_assignment": data.res.message.jobArray[i].urgent_booking_assignment,
                                                        "latitude": data.res.message.jobArray[i].latitude,
                                                        "longitude": data.res.message.jobArray[i].longitude,
                                                        "is_person": true,
                                                        "booking_eta": data.res.message.jobArray[i].booking_eta,
                                                        "color": "#333"
                                                    });
                                                    $scope.$apply();
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

            }
        });


        var assignSocket = $rootScope.$on('quickScreeenBookingGroupedSocket', function (evt, data) {
            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            var dateTo = new Date(date_time_value2).getTime();
            var dateFrom = new Date(date_time_value1).getTime();

            for (var i = 0; i < data.res.message.jobArray.length; i++) {

                var booking_date = data.res.message.jobArray[i].job_time_utc;
                booking_date = new Date(booking_date).getTime();

                // DATE FILTER
                if (dateFrom <= booking_date && booking_date <= dateTo) {

                    // TRIP FILTER
                    if (vm.filterData.type_of_trip_filter == [] || (vm.filterData.type_of_trip.includes(data.res.message.jobArray[i].type_of_trip))) {

                        // SERVICE FILTER
                        if (vm.filterData.service_filter == [] || vm.filterData.service.includes(data.res.message.jobArray[i].type_of_service)) {

                            // AGREEMENT FILTER
                            if (vm.filterData.aggrement_filter == 0 || (vm.filterData.agreement == data.res.message.jobArray[i].contract_id)) {

                                // BRANCH FILTER
                                if (vm.filterData.branch_filter == 0 || (vm.filterData.branch == data.res.message.jobArray[i].branch)) {

                                    var index = _.findIndex(vm.UnAssignBookingList, {
                                        job_id: data.res.message.jobArray[i].job_id
                                    });
                                    if (index != -1) {
                                        vm.UnAssignBookingList.splice(index, 1);
                                        $scope.$apply();
                                    }
                                }
                            }
                        }
                    }
                }

            }

        });

        //====================socket connection===================
        var myListener = $rootScope.$on('SocketComesOngoing', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            var DatetoSend = new Date(date_time_value2).getTime();
            var dateFrom = new Date(date_time_value1).getTime();
            var dateTo = DatetoSend;
            var type = typeof data.res.message;
            if (data && data.res.message.multi && data.res.message.multi == true) {
                var bookingArray = data.res.message.jobArray;
                for (var i = 0; i < bookingArray.length; i++) {
                    var booking_date = bookingArray[i].job_time_utc;
                    // booking_date = booking_date.split('T')[0];
                    booking_date = new Date(booking_date).getTime();
                    if (dateFrom <= booking_date && booking_date <= dateTo) {
                        var index = _.findIndex(vm.assignBookingList, {
                            job_id: bookingArray[i].job_id
                        });
                        if (index != -1) {
                            vm.assignBookingList.splice(index, 1);
                            $scope.$apply();
                        }
                        // if (data.data && vm.countToSocket == 0 && (!vm.filterData.searchBookingId && !vm.filterData.searchPackageId)) {
                        //     vm.itemsPerPageGot = vm.itemsPerPageSelected;
                        //     getAllOngoingBookings(vm.currentPage > 0 ? vm.currentPage - 1 * vm.itemsPerPageGot : 0, vm.itemsPerPageGot, vm.filterData, false);
                        // } else if (data.data && vm.countToSocket == 0 && (vm.filterData.searchBookingId || vm.filterData.searchPackageId)) {
                        //     getBookingIdResults(vm.filterData);
                        // }
                        // break;
                    }
                }
            } else if (data && data.res && type == 'object') {
                var booking_date = data.res.message.job_time_utc;
                // booking_date = booking_date.split('T')[0];
                booking_date = new Date(booking_date).getTime();
                if ((dateFrom <= booking_date) && (booking_date <= dateTo)) {
                    var index = _.findIndex(vm.assignBookingList, {
                        job_id: data.res.message.job_id
                    });
                    if (index != -1) {
                        vm.assignBookingList.splice(index, 1);
                        $scope.$apply();
                    }
                    // if (data.data && vm.countToSocket == 0 && (!vm.filterData.searchBookingId && !vm.filterData.searchPackageId)) {
                    //     vm.itemsPerPageGot = vm.itemsPerPageSelected;
                    //     getAllOngoingBookings(vm.currentPage > 0 ? vm.currentPage - 1 * vm.itemsPerPageGot : 0, vm.itemsPerPageGot, vm.filterData, false);
                    // } else if (data.data && vm.countToSocket == 0 && (vm.filterData.searchBookingId || vm.filterData.searchPackageId)) {
                    //     getBookingIdResults(vm.filterData);
                    // }
                }
            } else {
                var index = _.findIndex(vm.assignBookingList, {
                    job_id: data.res.message.job_id
                });
                if (index != -1) {
                    vm.assignBookingList.splice(index, 1);
                    $scope.$apply();
                }
                // if (data.data && vm.countToSocket == 0 && (!vm.filterData.searchBookingId && !vm.filterData.searchPackageId)) {
                //     vm.itemsPerPageGot = vm.itemsPerPageSelected;
                //     getAllOngoingBookings(vm.currentPage > 0 ? vm.currentPage - 1 * vm.itemsPerPageGot : 0, vm.itemsPerPageGot, vm.filterData, false);
                // } else if (data.data && vm.countToSocket == 0 && (vm.filterData.searchBookingId || vm.filterData.searchPackageId)) {
                //     getBookingIdResults(vm.filterData);
                // }
            }


        });

        //====================socket connection===================
        var myListener = $rootScope.$on('quickScreeenBookingModifySocket', function (evt, data) {
            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            var dateTo = new Date(date_time_value2).getTime();
            var dateFrom = new Date(date_time_value1).getTime();

            for (var i = 0; i < data.res.message.jobArray.length; i++) {

                var booking_date = data.res.message.jobArray[i].job_time_utc;
                booking_date = new Date(booking_date).getTime();
                if (dateFrom <= booking_date && booking_date <= dateTo) {

                    if (vm.filterData.type_of_trip_filter == [] || (vm.filterData.type_of_trip.includes(data.res.message.jobArray[i].type_of_trip))) {

                        if (vm.filterData.service_filter == [] || vm.filterData.service.includes(data.res.message.jobArray[i].type_of_service)) {

                            if (vm.filterData.aggrement_filter == 0 || (vm.filterData.agreement == data.res.message.jobArray[i].contract_id)) {

                                if (vm.filterData.branch_filter == 0 || (vm.filterData.branch == data.res.message.jobArray[i].branch)) {

                                    var index = _.findIndex(vm.UnAssignBookingList, {
                                        job_id: data.res.message.jobArray[i].job_id
                                    });
                                    if (index != -1) {
                                        vm.UnAssignBookingList.splice(index, 1);
                                        if (vm.UnAssignBookingList.length == 0) {
                                            vm.UnAssignBookingList.push({
                                                "contract_name": data.res.message.jobArray[i].contract_name,
                                                "estimated_payment_cost": data.res.message.jobArray[i].estimated_payment_cost,
                                                "is_VIP": data.res.message.jobArray[i].is_VIP,
                                                "is_round_trip": data.res.message.jobArray[i].is_round_trip,
                                                "booking_type": data.res.message.jobArray[i].booking_type,
                                                "branch": data.res.message.jobArray[i].branch,
                                                "type_of_service": data.res.message.jobArray[i].type_of_service,
                                                "job_address": data.res.message.jobArray[i].job_address,
                                                "job_id": data.res.message.jobArray[i].job_id,
                                                "job_pickup_address": data.res.message.jobArray[i].job_pickup_address,
                                                "job_pickup_name": data.res.message.jobArray[i].job_pickup_name,
                                                "job_pickup_phone": data.res.message.jobArray[i].job_pickup_phone,
                                                "job_time_utc": data.res.message.jobArray[i].job_time_utc,
                                                "locking_id": data.res.message.jobArray[i].locking_id,
                                                "service_name": data.res.message.jobArray[i].service_name,
                                                "locking_id_name": data.res.message.jobArray[i].locking_id_name,
                                                "observations": data.res.message.jobArray[i].observations,
                                                "reference_point": data.res.message.jobArray[i].reference_point,
                                                "round_trip_pickup_time_utc": data.res.message.jobArray[i].round_trip_pickup_time_utc,
                                                "urgent_booking_assignment": data.res.message.jobArray[i].urgent_booking_assignment,
                                                "latitude": data.res.message.jobArray[i].latitude,
                                                "longitude": data.res.message.jobArray[i].longitude,
                                                "is_person": true,
                                                "booking_eta": data.res.message.jobArray[i].booking_eta,
                                                "color": "#333"
                                            });
                                            $scope.$apply();
                                        } else {
                                            for (var j = 0; j < vm.UnAssignBookingList.length; j++) {
                                                if (new Date(vm.UnAssignBookingList[j].job_time_utc).getTime() > new Date(data.res.message.jobArray[i].job_time_utc).getTime()) {
                                                    vm.UnAssignBookingList.insert(j, {
                                                        "contract_name": data.res.message.jobArray[i].contract_name,
                                                        "estimated_payment_cost": data.res.message.jobArray[i].estimated_payment_cost,
                                                        "is_VIP": data.res.message.jobArray[i].is_VIP,
                                                        "is_round_trip": data.res.message.jobArray[i].is_round_trip,
                                                        "booking_type": data.res.message.jobArray[i].booking_type,
                                                        "branch": data.res.message.jobArray[i].branch,
                                                        "type_of_service": data.res.message.jobArray[i].type_of_service,
                                                        "job_address": data.res.message.jobArray[i].job_address,
                                                        "job_id": data.res.message.jobArray[i].job_id,
                                                        "job_pickup_address": data.res.message.jobArray[i].job_pickup_address,
                                                        "job_pickup_name": data.res.message.jobArray[i].job_pickup_name,
                                                        "job_pickup_phone": data.res.message.jobArray[i].job_pickup_phone,
                                                        "job_time_utc": data.res.message.jobArray[i].job_time_utc,
                                                        "locking_id": data.res.message.jobArray[i].locking_id,
                                                        "service_name": data.res.message.jobArray[i].service_name,
                                                        "locking_id_name": data.res.message.jobArray[i].locking_id_name,
                                                        "observations": data.res.message.jobArray[i].observations,
                                                        "reference_point": data.res.message.jobArray[i].reference_point,
                                                        "round_trip_pickup_time_utc": data.res.message.jobArray[i].round_trip_pickup_time_utc,
                                                        "urgent_booking_assignment": data.res.message.jobArray[i].urgent_booking_assignment,
                                                        "latitude": data.res.message.jobArray[i].latitude,
                                                        "longitude": data.res.message.jobArray[i].longitude,
                                                        "is_person": true,
                                                        "booking_eta": data.res.message.jobArray[i].booking_eta,
                                                        "color": "#333"
                                                    });
                                                    $scope.$apply();
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

            }
        });


        $rootScope.$on('quickScreeenUrgentBookingSocket', function (evt, data) {
            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            var dateTo = new Date(date_time_value2).getTime();
            var dateFrom = new Date(date_time_value1).getTime();

            for (var i = 0; i < data.res.message.jobArray.length; i++) {

                var booking_date = data.res.message.jobArray[i].job_time_utc;
                booking_date = new Date(booking_date).getTime();
                if (dateFrom <= booking_date && booking_date <= dateTo) {

                    if (vm.filterData.type_of_trip_filter == [] || (vm.filterData.type_of_trip.includes(data.res.message.jobArray[i].type_of_trip))) {

                        if (vm.filterData.service_filter == [] || vm.filterData.service.includes(data.res.message.jobArray[i].type_of_service)) {

                            if (vm.filterData.aggrement_filter == 0 || (vm.filterData.agreement == data.res.message.jobArray[i].contract_id)) {

                                if (vm.filterData.branch_filter == 0 || (vm.dataToFill.branch == data.res.message.jobArray[i].branch)) {

                                    var index = _.findIndex(vm.UnAssignBookingList, {
                                        job_id: data.res.message.jobArray[i].job_id
                                    });
                                    if (index == -1) {
                                        vm.urgentBookingCount++;
                                        vm.UnAssignBookingList.unshift({
                                            "contract_name": data.res.message.jobArray[i].contract_name,
                                            "estimated_payment_cost": data.res.message.jobArray[i].estimated_payment_cost,
                                            "is_VIP": data.res.message.jobArray[i].is_VIP,
                                            "is_round_trip": data.res.message.jobArray[i].is_round_trip,
                                            "booking_type": data.res.message.jobArray[i].booking_type,
                                            "branch": data.res.message.jobArray[i].branch,
                                            "type_of_service": data.res.message.jobArray[i].type_of_service,
                                            "job_address": data.res.message.jobArray[i].job_address,
                                            "job_id": data.res.message.jobArray[i].job_id,
                                            "job_pickup_address": data.res.message.jobArray[i].job_pickup_address,
                                            "job_pickup_name": data.res.message.jobArray[i].job_pickup_name,
                                            "job_pickup_phone": data.res.message.jobArray[i].job_pickup_phone,
                                            "job_time_utc": data.res.message.jobArray[i].job_time_utc,
                                            "locking_id": data.res.message.jobArray[i].locking_id,
                                            "service_name": data.res.message.jobArray[i].service_name,
                                            "locking_id_name": data.res.message.jobArray[i].locking_id_name,
                                            "observations": data.res.message.jobArray[i].observations,
                                            "reference_point": data.res.message.jobArray[i].reference_point,
                                            "round_trip_pickup_time_utc": data.res.message.jobArray[i].round_trip_pickup_time_utc,
                                            "urgent_booking_assignment": data.res.message.jobArray[i].urgent_booking_assignment,
                                            "latitude": data.res.message.jobArray[i].latitude,
                                            "longitude": data.res.message.jobArray[i].longitude,
                                            "is_person": true,
                                            "booking_eta": data.res.message.jobArray[i].booking_eta,
                                            "color": "rgb(255, 77, 77)"
                                        });
                                        $scope.$apply();
                                    }
                                }
                            }
                        }
                    }
                }

            }

        });

        // $scope.$on('$destroy', BookingSocket);
        // $scope.$on('$destroy', assignSocket);
        function markDriverOffDuty(id, status) {
            var dataToSend = {
                fleet_id: id,
                is_available: status == 1 ? 0 : 1,
                access_token: $cookies.get('obj')
            };
            vm.loading = true;
            var promise = mapDashboard.markDriverOffDuty(dataToSend);
            promise.then(
                function (payload) {
                    vm.loading = false;
                    // showDriversWithFilterSocket(vm.dataToFill);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function makeIconUI(data) {

            // if (data.is_available == 0 && data.status == 0) {
            //     var iconS = {
            //         //url: 'assets/images/off_duty.png',
            //         url: data.vehicle_img_offline?data.vehicle_img_offline:'assets/images/off_duty.png',
            //         size: new google.maps.Size(70, 70),
            //         scaledSize: new google.maps.Size(50, 50), // scaled size
            //         origin: new google.maps.Point(0, 0), // origin
            //         labelOrigin: new google.maps.Point(25, 15),
            //         anchor: new google.maps.Point(17, 34) // anchor
            //     };
            // }
            if (data.is_person == true) {
                var iconS = {
                    //url: 'assets/images/in_road.png',
                    url: 'assets/images/human_pin.png',
                    //size: new google.maps.Size(20  , 70),
                    //scaledSize: new google.maps.Size(50, 50), // scaled size
                    origin: new google.maps.Point(0, 0), // origin
                    // labelOrigin: new google.maps.Point(25, 15),
                    anchor: new google.maps.Point(0, 34) // anchor
                };
            }
            if ((!data.bookingHasNextTime && !data.busyDriver && !data.is_person && data.is_available == 1 &&
                    data.status != 1 && data.job_status != 15 && data.job_status != 7) || (data.bookingHasNextTime == false && data.decrease == true) || (data.bookingHasNextTime == false)) {
                // (data.is_available == 1 && data.status == 0)
                var iconS = {
                    //url: 'assets/images/on_duty.png',
                    url: 'assets/images/on_duty.png',
                    size: new google.maps.Size(45, 50),
                    scaledSize: new google.maps.Size(45, 50), // scaled size
                    origin: new google.maps.Point(0, 0), // origin
                    labelOrigin: new google.maps.Point(22, 15),
                    anchor: new google.maps.Point(0, 32) // anchor
                };
            } else if (data.is_available == 1 && data.status == 1 && data.job_status == 15) {
                var iconS = {
                    //url: 'assets/images/in_road.png',
                    url: data.vehicle_img_road ? data.vehicle_img_road : 'assets/images/in_road.png',
                    size: new google.maps.Size(45, 50),
                    scaledSize: new google.maps.Size(45, 50), // scaled size
                    origin: new google.maps.Point(0, 0), // origin
                    labelOrigin: new google.maps.Point(22, 15),
                    anchor: new google.maps.Point(0, 32) // anchor
                };
            } else if ((data.bookingHasNextTime && data.bookingHasNextTime == true) || (data.bookingHasNextTime == true)) {
                var iconS = {
                    //url: 'assets/images/in_road.png',
                    url: 'assets/images/car_puprple.png',
                    size: new google.maps.Size(45, 50),
                    scaledSize: new google.maps.Size(45, 50), // scaled size
                    origin: new google.maps.Point(0, 0), // origin
                    labelOrigin: new google.maps.Point(22, 15),
                    anchor: new google.maps.Point(0, 32) // anchor
                };
            } else if (data.is_available == 1 && data.status == 1 && data.job_status == 7) {
                var iconS = {
                    //url: 'assets/images/in_road.png',
                    url: data.vehicle_img_accepted ? data.vehicle_img_accepted : 'assets/images/in_road.png',
                    size: new google.maps.Size(45, 50),
                    scaledSize: new google.maps.Size(45, 50), // scaled size
                    origin: new google.maps.Point(0, 0), // origin
                    labelOrigin: new google.maps.Point(22, 15),
                    anchor: new google.maps.Point(0, 32) // anchor
                };
            } else if (data.is_available == 1 && data.status == 1 && data.job_status == 4) {
                var iconS = {
                    //url: 'assets/images/at_position.png',
                    url: data.vehicle_img_position ? data.vehicle_img_position : 'assets/images/at_position.png',
                    size: new google.maps.Size(45, 50),
                    scaledSize: new google.maps.Size(45, 50), // scaled size
                    origin: new google.maps.Point(0, 0), // origin
                    labelOrigin: new google.maps.Point(22, 15),
                    anchor: new google.maps.Point(0, 32) // anchor
                };
            } else if ((data.is_available == 1 && data.status == 1 && data.job_status == 1) || (data.busyDriver && data.busyDriver == true) || (data.busy == true)) {
                var iconS = {
                    // /Users/puneetgupta/Desktop/TransVIP-AdminPanel/src/assets/images/service_started.png
                    //url: 'assets/images/service_started.png',
                    url: 'assets/images/service_started.png',
                    size: new google.maps.Size(45, 50),
                    scaledSize: new google.maps.Size(45, 50), // scaled size
                    origin: new google.maps.Point(0, 0), // origin
                    labelOrigin: new google.maps.Point(22, 15),
                    anchor: new google.maps.Point(0, 32) // anchor
                };

            }
            return iconS;
        }

        function createMarkerForPerson(latlng, data, textCar, type) {

            var label = {
                text: data.unique_car_id ? data.unique_car_id.toString() : '0',
                fontSize: '10px'
            };


            var marker = new google.maps.Marker({
                position: latlng,
                map: map,
                icon: makeIconUI(data),
                label: label,
                id: data.fleet_id,
                jobId: data.job_id,
                status: data.is_available,
                jobStatus: data.job_status,
                driverStatus: data.status,
                zIndex: Math.round(latlng.lat() * -100000) << 5
            });


            //if(vm.dataToFill.branch != 'all' || vm.dataToFill.vehicle != 'all' || vm.dataToFill.service != 'all' || vm.dataToFill.agreement != 'all' || vm.dataToFill.truck != '' || vm.dataToFill.bases != '' || vm.dataToFill.filterDataDrivers != 0){
            if (vm.dataToFill.filterDataDrivers != 0) {
                vm.offDuty_1 = false;
                vm.onDuty_1 = true;
                vm.started_1 = false;
                vm.inPosition_1 = false;
                vm.busy_1 = false;
                vm.all_1 = false;
                // bounds.extend(latlng);
                // map.fitBounds(bounds);
                // map.setZoom(15);
                var founds = new google.maps.LatLngBounds();
                founds.extend(latlng);
                if (map) {
                    map.fitBounds(founds);
                    map.setZoom(15);
                }


            } else if (textCar && textCar == 'searchCar') {
                // bounds.extend(latlng);
                // map.fitBounds(bounds);
                map.setZoom(15)
                map.setCenter(latlng)
            }

            if (!data.current_car_details) {
                data.current_car_details = 0;
            }
            if (!data.distance) {
                data.distance = 0;
            }
            if (!data.difference) {
                data.difference = 0;
            }
            if (!data.since) {
                data.since = 0;
            }
            if (!data.fleet_image) {
                data.fleet_image = 'assets/images/noImage.jpeg';
            }
            if (!data.text)
                data.text = '--';


            google.maps.event.addListener(marker, 'click', function (event) {
                vm.idOfMarker = marker.id;
                vm.statusOfMarker = marker.status;
                vm.jobStatusOfMarker = marker.jobStatus;
                vm.jobIdOfMarker = marker.jobId;
                for (var i = 0; i < vm.collectedData.length; i++) {
                    if (vm.collectedData[i].fleet_id == marker.id)
                        vm.collectedData[i].popInfoOpen = true;
                    else vm.collectedData[i].popInfoOpen = false;
                }

                console.log('>>>>>>> perSON >>>>>', data.is_person);
                if (data.is_person == 1) {
                    showInfoWindowWithDetails(marker, infowindow, data);
                    $('#InputBoxShow').css('display', 'none');
                    // =======================  Asignar ==============================
                    $timeout(function () {
                        $('#asignarManual').click(function () {
                            $('#InputBoxShow').css('display', 'block');
                            var searchInput = document.getElementById("InputBoxShow");
                            searchInput.addEventListener("keyup", function (event) {
                                event.preventDefault();
                                if (event.keyCode === 13) {
                                    var SearchId = event.target.value;
                                    getVehicleOnSearch(SearchId);
                                    vm.flagforDriverStatus = true;
                                    $('#InputBoxShow').click(function () {
                                        vm.flagforDriverStatus = true;
                                        getVehicleOnSearch(SearchId);
                                    });
                                }

                            });
                        });
                    }, 2000);
                } else {
                    // vm.flagforDriverStatus = true;
                    showInfoWindowWithDetails1(marker, infowindow, data);
                }
                $timeout(function () {
                    $('#autoAsignarManual').click(function () {
                        $('#autoAsignarManual').prop('disabled', true);
                        $('#InputBoxShow').css('display', 'none');
                        var dataSend = {};
                        dataSend.access_token = $cookies.get('obj');
                        dataSend.job_id = data.job_id;
                        dataSend.socket_id = $rootScope.socket.id;
                        vm.loading = true;
                        vm.flagForLoading = false;
                        if (vm.storeData.booking_type == 0 && vm.storeData.locking_id == null) {
                            var promise = getGeofence.autoAssign(dataSend);
                            promise.then(
                                function (payload) {
                                    $log.log(payload);
                                    //vm.loading = false;

                                    // socketDataForAssign();
                                    if (payload.title.status == 400) {
                                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                                        vm.loading = false;
                                    } else if (payload.title.status == 401) {
                                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                                        vm.loading = false;
                                    } else if (payload.title.status == 201 || payload.title.status == 200) {

                                    }
                                },
                                function (errorPayload) {
                                    $log.log(errorPayload);
                                    vm.loading = false;
                                    if (errorPayload.data.status == 401) {
                                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                                    } else {
                                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                                    }
                                }
                            );

                        } else {
                            if (vm.storeData.booking_type != 0) {
                                vm.loading = false;
                                errorMessageFactory.showErrorMessage("La reserva no se puede asignar porque se está convirtiendo en parte del nuevo servicio compartido ya enrutado. Solicita que se elimine del servicio compartido enrutado y luego se lo asigna", 0);
                            } else {
                                vm.loading = false;
                                errorMessageFactory.showErrorMessage("La reserva está bloqueada por usuario" + vm.storeData.locking_id_name + " para la creación o modificación del paquete", 0)
                            }

                        }

                    });
                }, 2000);


            });
            removePersonIconForMap();
            markers.push(marker); //push local var marker into global array
            // openPreviousinfoWindowOpen(markers, data);
        };


        function removePersonIconForMap() {
            for (var i = 0; i < markers.length; i++) {
                markers[i].setMap(null);
            }
        }


        function createMarker(latlng, data, textCar, type) {

            var label = {
                text: data.unique_car_id ? data.unique_car_id.toString() : '0',
                fontSize: '10px'
            };


            var marker = new google.maps.Marker({
                position: latlng,
                map: map,
                icon: makeIconUI(data),
                label: label,
                id: data.fleet_id,
                jobId: data.job_id,
                status: data.is_available,
                jobStatus: data.job_status,
                driverStatus: data.status,
                zIndex: Math.round(latlng.lat() * -100000) << 5
            });


            //if(vm.dataToFill.branch != 'all' || vm.dataToFill.vehicle != 'all' || vm.dataToFill.service != 'all' || vm.dataToFill.agreement != 'all' || vm.dataToFill.truck != '' || vm.dataToFill.bases != '' || vm.dataToFill.filterDataDrivers != 0){
            if (vm.dataToFill.filterDataDrivers != 1) {
                vm.offDuty_1 = false;
                vm.onDuty_1 = true;
                vm.started_1 = false;
                vm.inPosition_1 = false;
                vm.busy_1 = false;
                vm.all_1 = false;
                // bounds.extend(latlng);
                // map.fitBounds(bounds);
                // map.setZoom(15);
                var founds = new google.maps.LatLngBounds();

                if (map) {
                    founds.extend(latlng);
                    map.fitBounds(founds);
                    map.setZoom(15);
                }


            } else if (textCar && textCar == 'searchCar') {
                // bounds.extend(latlng);
                // map.fitBounds(bounds);
                map.setZoom(15)
                map.setCenter(latlng)
            }

            if (!data.current_car_details) {
                data.current_car_details = 0;
            }
            if (!data.distance) {
                data.distance = 0;
            }
            if (!data.difference) {
                data.difference = 0;
            }
            if (!data.since) {
                data.since = 0;
            }
            if (!data.fleet_image) {
                data.fleet_image = 'assets/images/noImage.jpeg';
            }
            if (!data.text)
                data.text = '--';


            google.maps.event.addListener(marker, 'click', function (event) {
                vm.idOfMarker = marker.id;
                vm.statusOfMarker = marker.status;
                vm.jobStatusOfMarker = marker.jobStatus;
                vm.jobIdOfMarker = marker.jobId;
                for (var i = 0; i < vm.collectedData.length; i++) {
                    if (vm.collectedData[i].fleet_id == marker.id)
                        vm.collectedData[i].popInfoOpen = true;
                    else vm.collectedData[i].popInfoOpen = false;
                }

                console.log('>>>>>>> create marker >>>>>', data.is_person);
                if (data.is_person == 1) {
                    showInfoWindowWithDetails(marker, infowindow, data);
                    $('#InputBoxShow').css('display', 'none');
                    // =======================  Asignar ==============================
                    $('#asignarManual').click(function () {
                        $('#InputBoxShow').css('display', 'block');
                        var searchInput = document.getElementById("InputBoxShow");
                        searchInput.addEventListener("keyup", function (event) {
                            event.preventDefault();
                            if (event.keyCode === 13) {
                                var SearchId = event.target.value;
                                getVehicleOnSearch(SearchId);
                                vm.flagforDriverStatus = true;
                                $('#InputBoxShow').click(function () {
                                    vm.flagforDriverStatus = true;
                                    getVehicleOnSearch(SearchId);
                                });
                            }

                        });

                    });
                } else {
                    // vm.flagforDriverStatus = true;
                    showInfoWindowWithDetails1(marker, infowindow, data);
                }
                $('#autoAsignarManual').click(function () {
                    $('#InputBoxShow').css('display', 'none');
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.job_id = data.job_id;
                    dataSend.socket_id = $rootScope.socket.id;
                    vm.loading = true;
                    vm.flagForLoading = false;
                    if (vm.storeData.booking_type == 0 && vm.storeData.locking_id == null) {
                        var promise = getGeofence.autoAssign(dataSend);
                        promise.then(
                            function (payload) {
                                $log.log(payload);
                                //vm.loading = false;

                                // socketDataForAssign();
                                if (payload.title.status == 400) {
                                    errorMessageFactory.showErrorMessage(payload.title.message, 0);
                                } else if (payload.title.status == 401) {
                                    errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                                } else if (payload.title.status == 201 || payload.title.status == 200) {

                                }
                            },
                            function (errorPayload) {
                                $log.log(errorPayload);
                                vm.loading = false;
                                if (errorPayload.data.status == 401) {
                                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                                } else {
                                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                                }
                            }
                        );

                    } else {
                        if (vm.storeData.booking_type != 0) {
                            vm.loading = false;
                            errorMessageFactory.showErrorMessage("La reserva no se puede asignar porque se está convirtiendo en parte del nuevo servicio compartido ya enrutado. Solicita que se elimine del servicio compartido enrutado y luego se lo asigna", 0);
                        } else {
                            vm.loading = false;
                            errorMessageFactory.showErrorMessage("La reserva está bloqueada por usuario" + vm.storeData.locking_id_name + " para la creación o modificación del paquete", 0)
                        }

                    }

                });


            });
            markers.push(marker); //push local var marker into global array
            // openPreviousinfoWindowOpen(markers, data);
        };

        var myListener2 = $rootScope.$on('NotifyToAdminForJobAccepted', function (evt, res) {
            console.log(res, "<<<<<<<<<<<<<<<<NotifyToAdminForJobAccepted>>>>>>>>>>>>>>>>>>>");

            var socketData1 = res.res.message;
            var count = 0;
            $('#autoAsignarManual').prop('disabled', false);
            vm.loading = false;
            vm.flagForLoading = true;
            if (count == 0) {
                errorMessageFactory.showErrorMessage(socketData1.message, 0);
                count++
            }

        });
        $scope.$on('$destroy', myListener2);
        var myListener3 = $rootScope.$on('NotifyToAdminForJob', function (evt, res) {
            console.log(res, "<<<<<<<<<<<<<<<<NotifyToAdminForJob>>>>>>>>>>>>>>>>>>>");
            var count1 = 0;
            if (count1 == 0) {
                $('#autoAsignarManual').prop('disabled', false);
                var socketData2 = res.res.message;
                vm.loading = false;
                vm.flagForLoading = true;

                // errorMessageFactory.showErrorMessage(socketData2.message, 0);
                var confirm = $mdDialog.confirm()
                    .title(socketData2.message)
                    .textContent('')
                    .ariaLabel('Lucky day')
                    // .targetEvent($event)
                    .ok('Confirm')
                    .cancel('Close');

                $mdDialog.show(confirm).then(function () {
                    $log.log('confirmed');
                    $('#InputBoxShow').css('display', 'block');
                    var searchInput = document.getElementById("InputBoxShow");
                    searchInput.addEventListener("keyup", function (event) {
                        event.preventDefault();
                        if (event.keyCode === 13) {
                            var SearchId = event.target.value;
                            getVehicleOnSearch(SearchId);
                            vm.flagforDriverStatus = true;
                            $('#InputBoxShow').click(function () {
                                vm.flagforDriverStatus = true;
                                getVehicleOnSearch(SearchId);
                            });
                        }
                    });
                });
                count1++;
            }
        });
        $scope.$on('$destroy', myListener3);


        function openPreviousinfoWindowOpen(markers, data) {

            for (var i = 0; i < markers.length; i++) {
                for (var j = 0; j < vm.collectedData.length; j++) {
                    if (markers[i].id == vm.collectedData[j].fleet_id) {
                        if (vm.collectedData[j].popInfoOpen) {
                            //infowindow.open(map, markers[i]);
                            google.maps.event.trigger(markers[i], 'click');
                            //showInfoWindowWithDetails(markers[i],infowindow,data);
                            return;
                        }
                    }
                }
            }
        }

        function restorePreviousData() {
            for (var i = 0; i < vm.collectedData.length; i++) {
                vm.collectedData[i].popInfoOpen = false;
            }
        }

        //=======================create search location marker============================
        function createMarkerForSearchAddress(latlng) {
            var marker_1 = new google.maps.Marker({
                position: latlng,
                map: map,
                id: 'searchedMarker'
            });
            map.setCenter(latlng);
            map.setZoom(18);
            //bounds = new google.maps.LatLngBounds();
            //bounds.extend(latlng);
            //map.fitBounds(bounds);
            markers.push(marker_1);
        }

        //=============================mark no show============================
        function makeTheStatusChangeOfBooking(js, ji, $event) {

            var msg = '';
            var jobStatus = '';
            if (js == 7) {
                //msg = 'Do you want to mark this booking as on road ?';
                msg = languageBasedErrorFactory.getProperErrorMessage('onRoadMessage', 0, '3');
                jobStatus = 15;
            } else if (js == 15) {
                //msg = 'Do you want to mark this booking as arrived ?';
                msg = languageBasedErrorFactory.getProperErrorMessage('arrivedMessage', 0, '3');
                jobStatus = 4;
            } else if (js == 4) {
                //msg = 'Do you want to mark this booking as trip started ?';
                msg = languageBasedErrorFactory.getProperErrorMessage('tripStartedMessage', 0, '3');
                jobStatus = 1;
            } else if (js == 1) {
                //msg = 'Do you want to mark this booking as completed ?';
                msg = languageBasedErrorFactory.getProperErrorMessage('completedMessage', 0, '3');
                jobStatus = 2;
            }
            var confirm = $mdDialog.confirm()
                .title(msg)
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok('Confirm')
                .cancel('Close');

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.job_id = ji;
                dataSend.job_status = jobStatus;
                vm.loading = true;
                var promise = getBookings.changeJobStatus(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        languageBasedErrorFactory.getProperErrorMessage('noShowSucc', 0, 0);
                        //errorMessageFactory.showErrorMessage('Job status changed successfully.',0);
                        // showDriversWithFilterSocket(vm.dataToFill);
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        };

        //==========================get search for unique number key's====================='
        function getEnteriesForUniqueNumber(data) {
            if (data.length) {
                for (var i = 0; i < data.length; i++) {
                    if (data[i].unique_car_id) {
                        vm.uniqueCarsArray.push(data[i])
                    }
                }
            } else {
                vm.uniqueCarsArray = [];
            }
        };


        // function onSelectingUnique(data) {
        //     if (markers.length) {
        //         setMapOnAll(null);
        //         mc.clearMarkers();
        //     }
        //     createMarker(new google.maps.LatLng(data.latitude, data.longitude), data, 'searchCar');
        // }

        //==================show drivers in map=======================
        function showDrivers(fleet_status) {
            // vm.dataToFill.total_no_of_drivers_available = 0;
            // // vm.dataToFill.total_no_of_off_duty_drivers = 0;
            // vm.dataToFill.total_no_of_drivers_on_duty = 0;
            // vm.dataToFill.total_no_of_started_drivers = 0;
            // vm.dataToFill.total_no_of_at_position_drivers = 0;
            // vm.dataToFill.total_no_of_busy_drivers = 0;

            var dataSend = {};
            dataSend.fleet_status = fleet_status;
            dataSend.access_token = $cookies.get('obj');
            vm.loading = true;
            var promise = mapDashboard.map(dataSend);
            promise.then(
                function (payload) {
                    if (payload.title.status == 200) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        vm.total_no_of_drivers = 0;
                        vm.collectedData = payload.title.data;
                        getEnteriesForUniqueNumber(payload.title.data);
                        if (payload.title.data && payload.title.data.length) {
                            vm.collectedData = payload.title.data;
                            getCountOfDashboardFleets(vm.collectedData);

                            // for (var i = 0; i < payload.title.data.length; i++) {
                            //     vm.collectedData[i].popInfoOpen = false;
                            //     vm.dataToFill.total_no_of_drivers_available = vm.dataToFill.total_no_of_drivers_available + 1;
                            //     if (payload.title.data[i].is_available == 0 && payload.title.data[i].status == 0) {
                            //         vm.dataToFill.total_no_of_off_duty_drivers = vm.dataToFill.total_no_of_off_duty_drivers + 1;
                            //     }
                            //     if (payload.title.data[i].is_available == 1 && payload.title.data[i].status == 0) {
                            //         vm.dataToFill.total_no_of_drivers_on_duty = vm.dataToFill.total_no_of_drivers_on_duty + 1;
                            //     }
                            //     if (payload.title.data[i].is_available == 1 && payload.title.data[i].status == 1 && (payload.title.data[i].job_status == 15 || payload.title.data[i].job_status == 7)) {
                            //         vm.dataToFill.total_no_of_started_drivers = vm.dataToFill.total_no_of_started_drivers + 1;
                            //     }
                            //     if (payload.title.data[i].is_available == 1 && payload.title.data[i].status == 1 && payload.title.data[i].job_status == 4) {
                            //         vm.dataToFill.total_no_of_at_position_drivers = vm.dataToFill.total_no_of_at_position_drivers + 1;
                            //     }
                            //     if (payload.title.data[i].is_available == 1 && payload.title.data[i].status == 1 && payload.title.data[i].job_status == 1) {
                            //         vm.dataToFill.total_no_of_busy_drivers = vm.dataToFill.total_no_of_busy_drivers + 1;
                            //     }
                            // }
                            if (vm.count == 0) {
                                initialize(vm.collectedData);
                                vm.count++;
                            }

                        } else {
                            vm.collectedData = [];
                            vm.dataToFill.total_no_of_drivers_available = 0;
                            vm.dataToFill.total_no_of_off_duty_drivers = 0;
                            vm.dataToFill.total_no_of_drivers_on_duty = 0;
                            vm.dataToFill.total_no_of_started_drivers = 0;
                            vm.dataToFill.total_no_of_at_position_drivers = 0;
                            vm.dataToFill.total_no_of_busy_drivers = 0;
                            initialize(vm.collectedData);
                        }
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        // showDrivers(0);


        //==================show drivers in map=======================
        function showNewDrivers(data, fleet_status) {

            if (data.filterDataDrivers == 4) {
                vm.dataToFill.total_no_of_drivers_available = 0;
                vm.dataToFill.total_no_of_drivers_available1 = 0;
                vm.dataToFill.total_no_of_at_position_drivers = 0;
                vm.dataToFill.total_no_of_started_drivers = 0;
                vm.dataToFill.total_no_of_off_duty_drivers = 0;
                vm.dataToFill.total_no_of_drivers_on_duty = 0;
                //vm.dataToFill.total_no_of_busy_drivers = 0;
            } else if (data.filterDataDrivers == 5) {
                //vm.dataToFill.total_no_of_at_position_drivers = 0;
                vm.dataToFill.total_no_of_drivers_available = 0;
                vm.dataToFill.total_no_of_drivers_available1 = 0;
                vm.dataToFill.total_no_of_started_drivers = 0;
                vm.dataToFill.total_no_of_off_duty_drivers = 0;
                vm.dataToFill.total_no_of_drivers_on_duty = 0;
                vm.dataToFill.total_no_of_busy_drivers = 0;
            } else if (data.filterDataDrivers == 3) {
                // vm.dataToFill.total_no_of_started_drivers = 0;
                vm.dataToFill.total_no_of_drivers_available = 0;
                vm.dataToFill.total_no_of_at_position_drivers = 0;
                vm.dataToFill.total_no_of_drivers_available1 = 0;
                vm.dataToFill.total_no_of_off_duty_drivers = 0;
                vm.dataToFill.total_no_of_drivers_on_duty = 0;
                vm.dataToFill.total_no_of_busy_drivers = 0;
            } else if (data.filterDataDrivers == 2) {
                //vm.dataToFill.total_no_of_off_duty_drivers = 0;
                vm.dataToFill.total_no_of_drivers_available = 0;
                vm.dataToFill.total_no_of_drivers_available1 = 0;

                vm.dataToFill.total_no_of_at_position_drivers = 0;
                vm.dataToFill.total_no_of_started_drivers = 0;
                vm.dataToFill.total_no_of_drivers_on_duty = 0;
                vm.dataToFill.total_no_of_busy_drivers = 0;
            } else if (data.filterDataDrivers == 1) {
                //vm.dataToFill.total_no_of_drivers_on_duty = 0;
                vm.dataToFill.total_no_of_drivers_available1 = 0;
                vm.dataToFill.total_no_of_drivers_available = 0;
                vm.dataToFill.total_no_of_at_position_drivers = 0;
                vm.dataToFill.total_no_of_started_drivers = 0;
                vm.dataToFill.total_no_of_off_duty_drivers = 0;
                vm.dataToFill.total_no_of_busy_drivers = 0;
            } else if (data.filterDataDrivers == 0) {
                //vm.dataToFill.total_no_of_at_position_drivers = 0;
                // vm.dataToFill.total_no_of_drivers_available1 = 0;
                // vm.dataToFill.total_no_of_drivers_on_duty = 0;
                vm.dataToFill.total_no_of_started_drivers = 0;
                vm.dataToFill.total_no_of_off_duty_drivers = 0;
                vm.dataToFill.total_no_of_drivers_on_duty = 0;

                vm.dataToFill.total_no_of_busy_drivers = 0;
            }
            // vm.dataToFill.total_no_of_drivers_available = 0;
            // // vm.dataToFill.total_no_of_off_duty_drivers = 0;
            // vm.dataToFill.total_no_of_drivers_on_duty = 0;
            // vm.dataToFill.total_no_of_started_drivers = 0;
            // vm.dataToFill.total_no_of_at_position_drivers = 0;
            // vm.dataToFill.total_no_of_busy_drivers = 0;

            var dataSend = {};
            dataSend.fleet_status = fleet_status;
            dataSend.access_token = $cookies.get('obj');
            vm.loading = true;
            var promise = mapDashboard.newMap(dataSend);
            promise.then(
                function (payload) {
                    if (payload.title.status == 200) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        vm.total_no_of_drivers = 0;
                        vm.collectedData = payload.title.data;
                        // if (payload.title.data && payload.title.data.length) {
                        //     if (vm.customerData)
                        //         payload.title.data.push(customer_data);
                        // }
                        getEnteriesForUniqueNumber(payload.title.data);
                        if (payload.title.data && payload.title.data.length) {
                            vm.collectedData = payload.title.data;
                            getCountOfDashboardFleets1(vm.collectedData);

                            // 

                            // for (var i = 0; i < payload.title.data.length; i++) {
                            //     vm.collectedData[i].popInfoOpen = false;
                            //     vm.dataToFill.total_no_of_drivers_available = vm.dataToFill.total_no_of_drivers_available + 1;
                            //     if (payload.title.data[i].is_available == 0 && payload.title.data[i].status == 0) {
                            //         vm.dataToFill.total_no_of_off_duty_drivers = vm.dataToFill.total_no_of_off_duty_drivers + 1;
                            //     }
                            //     if (payload.title.data[i].is_available == 1 && payload.title.data[i].status == 0) {
                            //         vm.dataToFill.total_no_of_drivers_on_duty = vm.dataToFill.total_no_of_drivers_on_duty + 1;
                            //     }
                            //     if (payload.title.data[i].is_available == 1 && payload.title.data[i].status == 1 && (payload.title.data[i].job_status == 15 || payload.title.data[i].job_status == 7)) {
                            //         vm.dataToFill.total_no_of_started_drivers = vm.dataToFill.total_no_of_started_drivers + 1;
                            //     }
                            //     if (payload.title.data[i].is_available == 1 && payload.title.data[i].status == 1 && payload.title.data[i].job_status == 4) {
                            //         vm.dataToFill.total_no_of_at_position_drivers = vm.dataToFill.total_no_of_at_position_drivers + 1;
                            //     }
                            //     if (payload.title.data[i].is_available == 1 && payload.title.data[i].status == 1 && payload.title.data[i].job_status == 1) {
                            //         vm.dataToFill.total_no_of_busy_drivers = vm.dataToFill.total_no_of_busy_drivers + 1;
                            //     }
                            // }
                            // if(fleet_status !=0){
                            // initialize(vm.collectedData);


                        } else {;
                            vm.collectedData = [];
                            vm.dataToFill.total_no_of_drivers_available = 0;
                            vm.dataToFill.total_no_of_off_duty_drivers = 0;
                            vm.dataToFill.total_no_of_drivers_on_duty = 0;
                            vm.dataToFill.total_no_of_started_drivers = 0;
                            vm.dataToFill.total_no_of_at_position_drivers = 0;
                            vm.dataToFill.total_no_of_busy_drivers = 0;
                            // initialize(vm.collectedData);
                        }
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        showNewDrivers(vm.dataToFill, 0);


        // ================= GTE NEAREST DRIVER ETA ==================
        function getEstimateEtaForNearestDriver(customer_data) {
            console.log(customer_data);

            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.latitude = customer_data.latitude;
            dataSend.longitude = customer_data.longitude;
            dataSend.branch = customer_data.branch;
            dataSend.type_of_service = customer_data.type_of_service;
            vm.loading = true;
            var promise = mapDashboard.getNearestETAApi(dataSend);
            promise.then(
                function (payload) {
                    if (payload.title.status == 200) {
                        vm.loading = false;
                        vm.nearestDriverETA = parseInt(payload.title.data.eta.eta / 60) || 0;
                    } else {
                        vm.loading = false;
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function showFleetsWithFilter(data, customer_data, index) {

            vm.dataToFill.filterDataDrivers = data;
            if (data == 6) {
                vm.offDuty_1 = false;
                vm.onDuty_1 = false;
                vm.boundsCheck = data;
                vm.started_1 = false;
                vm.inPosition_1 = false;
                vm.busy_1 = false;
                vm.all_1 = true;
                showNewDrivers(vm.dataToFill, 2, customer_data);
                // vm.showDriversWithFilter(vm.dataToFill, vm.dataToFill.filterDataDrivers);
            } else if (data == 1) {
                vm.colorFlag = [];
                if (vm.mapLoadsFlag == false) {
                    errorMessageFactory.showErrorMessage('Please wait while map loads', 0);
                } else {
                    vm.colorFlag[index] = true;
                }

                vm.offDuty_1 = false;
                vm.onDuty_1 = true;
                vm.boundsCheck = data;
                vm.started_1 = false;
                vm.inPosition_1 = false;
                vm.busy_1 = false;
                vm.all_1 = false;

                vm.storeData = customer_data;
                vm.flagforDriverStatus = true;
                vm.socketHandleMarker = true;
                if (customer_data) {
                    createMarkerForPerson(new google.maps.LatLng(customer_data.latitude, customer_data.longitude), customer_data)
                    getEstimateEtaForNearestDriver(customer_data);
                }
                // showNewDrivers(vm.dataToFill, 0, customer_data);
                // getEstimateEtaForNearestDriver(customer_data);
                // vm.showDriversWithFilter(vm.dataToFill, vm.dataToFill.filterDataDrivers);
            } else if (data == 7) {
                vm.offDuty_1 = false;
                vm.onDuty_1 = true;
                vm.boundsCheck = data;
                vm.started_1 = false;
                vm.inPosition_1 = false;
                vm.busy_1 = false;
                vm.all_1 = false;
                showNewDrivers(vm.dataToFill, 1, customer_data);
                // vm.showDriversWithFilter(vm.dataToFill, vm.dataToFill.filterDataDrivers);
            }

            // else if(data == 2){
            //     vm.offDuty_1 = true;
            //     vm.onDuty_1 = false;
            //     vm.started_1 = false;
            //     vm.inPosition_1 = false;
            //     vm.busy_1 = false;
            //     vm.all_1 = false;
            // }
            else if (data == 3) {
                vm.offDuty_1 = false;
                vm.onDuty_1 = false;
                vm.boundsCheck = data;
                vm.started_1 = true;
                vm.inPosition_1 = false;
                vm.busy_1 = false;
                vm.all_1 = false;
                vm.count = 1;
                vm.showDriversWithFilter(vm.dataToFill, vm.dataToFill.filterDataDrivers);
            } else if (data == 4) {
                vm.offDuty_1 = false;
                vm.onDuty_1 = false;
                vm.boundsCheck = data;
                vm.started_1 = false;
                vm.inPosition_1 = false;
                vm.busy_1 = true;
                vm.all_1 = false;
                showNewDrivers(vm.dataToFill, 3, customer_data);
                // vm.showDriversWithFilter(vm.dataToFill, vm.dataToFill.filterDataDrivers);
            } else if (data == 5) {
                vm.offDuty_1 = false;
                vm.onDuty_1 = false;
                vm.boundsCheck = data;
                vm.started_1 = false;
                vm.inPosition_1 = true;
                vm.busy_1 = false;
                vm.all_1 = false;
                vm.showDriversWithFilter(vm.dataToFill, vm.dataToFill.filterDataDrivers);
            }


        };

        function getAllBranches() {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            var promise = getGeofence.getAllBranchListNew(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    //vm.loading = false;
                    vm.branch = [];
                    vm.dataToFill.totalBranchList = payload.title.data;
                    angular.forEach(payload.title.data, function (column) {
                        // if (column.is_active == 1 && column.parent_id == 0)
                        vm.branch.push({
                            id: column.region_id,
                            name: column.region_name
                        });
                    });
                    vm.branch.push({
                        id: 'all',
                        name: 'All'
                    })
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;`
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllBranches();
        //======================get all vehicles==============
        // function getAllVehicles(skip, limt, filter) {
        //     vm.vehicle = [];
        //     angular.forEach(getFilters.vehiclesFiltersData.data, function (column) {
        //         vm.vehicle.push({
        //             id: column.id,
        //             name: column.name
        //         })
        //     });
        //     vm.vehicle.push({
        //         id: 'all',
        //         name: 'All'
        //     });

        // vm.loading = true;
        // var promise = getVehicles.allVehicles(skip, limt, filter);
        // promise.then(
        //     function (payload) {
        //         $log.log('sxdsads', payload);
        //         //vm.loading = false;
        //         if (payload.title.status == 400) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //         } else if (payload.title.status == 401) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //         } else if (payload.title.status == 201 || payload.title.status == 200) {
        //             vm.vehicle = [];
        //             angular.forEach(payload.title.data.result, function (column) {
        //                 if (column.status == 1)
        //                     vm.vehicle.push({
        //                         id: column.id,
        //                         name: column.name
        //                     })
        //             });
        //             vm.vehicle.push({
        //                 id: 'all',
        //                 name: 'All'
        //             });
        //         }
        //     },
        //     function (errorPayload) {
        //         $log.log(errorPayload);
        //         //vm.loading = false;
        //         if (errorPayload.data.status == 401) {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //         } else {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //         }
        //     }
        // );
        // };
        // WHen Page refresh service take time to get data from backend
        // setTimeout(function () {
        //     getAllVehicles(0, 0, 2);
        // }, 1000);
        // ---------------------------- Manual Assignmnt -------------------------
        function checkBeforeAssignDriver(Jobdata, fleetData, $event) {
            var dataSend = {
                access_token: $cookies.get('obj'),
                job_id: Number(Jobdata.job_id),
                fleet_id: Number(fleetData.fleet_id)
            };
            vm.loading = true;
            var promise = getBookings.checkBeforeAssignDriverApi(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {

                        checkDriverPop(payload.title, Jobdata, fleetData, $event);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        finalSelectedDriverApi(Jobdata, fleetData);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        checkDriverPop(errorPayload.data, data, $event);
                    }
                }
            );
        }


        function finalSelectedDriverApi(Jobdata, fleetData) {
            // $log.log(data);

            var dataSend = {
                access_token: $cookies.get('obj'),
                job_id: Number(Jobdata.job_id),
                fleet_id: Number(fleetData.fleet_id)
            };
            vm.loading = true;
            var promise = getBookings.manualAssignBookingToFleet(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        errorMessageFactory.showErrorMessage('Reserve Assigned successfully', 0);
                        // $timeout(function () {
                        $state.reload();
                        // if(vm.filterData.searchBookingId){
                        //     getFilterBookingId(vm.filterData.searchBookingId);
                        // }
                        // else if(vm.filterData.searchPackageId){
                        //     getFilterBookingId(vm.filterData.searchPackageId);
                        // }
                        // else{
                        //     $state.reload();
                        // // getAllUpcomingBookings(vm.currentPage>0?(vm.currentPage - 1) * vm.itemsPerPageGot:0, vm.itemsPerPageGot,vm.filterData,true);
                        // }
                        // }, 100);

                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };


        function checkDriverPop(msg, Jobdata, fleetData, $event) {
            vm.items = {};
            vm.items.data = msg.data.final_response;
            console.log(vm.items.data, 'vm.items.data');

            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/manualAssignErrors.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: ErrorDialogController
            });

            function ErrorDialogController($scope, items, $mdDialog) {
                $scope.items = items;

                $scope.confirmDialog = function () {
                    $mdDialog.hide();
                    finalSelectedDriverApi(Jobdata, fleetData);
                }
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                }
            }

            //var confirm = $mdDialog.confirm()
            //    .title(msg)
            //    .textContent('')
            //    .ariaLabel('Lucky day')
            //    .targetEvent($event)
            //    .ok('CONTINUE')
            //    .cancel('CANCEL');
            //
            //$mdDialog.show(confirm).then(function () {
            //    finalSelectedDriverApi(data);
            //}, function () {
            //    $log.log('not confirmed');
            //});
        };



        // ---------------------------- Manual Assignmnt -------------------------
        //======================get all services==============
        // function getAllServices(skip, limit) {
        //     vm.service = [];
        //     angular.forEach(getFilters.servicesFiltersData.data, function (column) {
        //         vm.service.push({
        //             id: column.id,
        //             name: column.service_name
        //         });
        //     });
        //     vm.service.push({
        //         id: 'all',
        //         name: 'All'
        //     });

        // vm.loading = true;
        // var promise = getServices.allServices(skip, limit, 2);
        // promise.then(
        //     function (payload) {
        //         $log.log('sxdsads', payload);
        //         //vm.loading = false;
        //         if (payload.title.status == 400) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //         } else if (payload.title.status == 401) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //         } else if (payload.title.status == 201 || payload.title.status == 200) {
        //             vm.service = [];
        //             angular.forEach(payload.title.data.result, function (column) {
        //                 if (column.status == 1)
        //                     vm.service.push({
        //                         id: column.id,
        //                         name: column.service_name
        //                     });
        //             });
        //             vm.service.push({
        //                 id: 'all',
        //                 name: 'All'
        //             })
        //         }
        //     },
        //     function (errorPayload) {
        //         $log.log(errorPayload);
        // vm.loading = false;
        //         if (errorPayload.data.status == 401) {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //         } else {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //         }
        //     }
        // );
        // };
        // WHen Page refresh service take time to get data from backend
        // setTimeout(function () {
        //     getAllServices(0, 0);
        // }, 1000);

        //======================get all services==============
        // function getAllAgreement(skip, limt) {
        //     var dataSend = {};
        //     dataSend.access_token = $cookies.get('obj');
        //     dataSend.offset = skip;
        //     dataSend.limit = limt;
        //     // dataSend.key = 3;
        //     vm.loading = true;

        //     var promise = getAgreement.getAgreementListLessData(dataSend);
        //     promise.then(
        //         function (payload) {
        //             if (payload.title.status == 400) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //             } else if (payload.title.status == 401) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //             } else if (payload.title.status == 201 || payload.title.status == 200) {
        //                 vm.agreement = [];
        //                 angular.forEach(payload.title.data, function (column) {
        //                     if (column.status == 1) {
        //                         vm.agreement.push({
        //                             id: column.id,
        //                             name: column.name
        //                         });
        //                     }
        //                 });
        //                 vm.agreement.push({
        //                     id: 'all',
        //                     name: 'All'
        //                 });
        //             }
        //         },
        //         function (errorPayload) {
        //             $log.log(errorPayload);
        //             //vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // };
        // getAllAgreement(0, 0);

        // //============push notification======================
        // function pushNotificationPop($event) {
        //     // $log.log(data);
        //     vm.items = {};
        //     // vm.items = data;
        //     // vm.items.car_type = vm.items.car_type.toString();
        //     // vm.items.modelity = vm.items.modelity.toString();
        //     // vm.items.working_status = vm.items.working_status.toString();
        //     // vm.items.car_image_upload = '';
        //     // vm.items.registration_image_upload = '';
        //     // vm.items.travel_card_key_upload = '';
        //     // vm.items.passenger_insurance_key_upload = '';
        //     // vm.items.permission_of_circulation_upload = '';
        //     // vm.items.ErrMsg = '';

        //     var parentEl = angular.element($document.body);
        //     $mdDialog.show({
        //         parent: parentEl,
        //         targetEvent: $event,
        //         templateUrl: 'app/components/dialogViews/pushNotification.html',
        //         locals: {
        //             items: vm.items
        //         },
        //         bindToController: true,
        //         controller: DialogController
        //     });

        //     function DialogController($scope, $mdDialog, items, getDrivers, mapDashboard, getCars) {
        //         $scope.items = items;
        //         $scope.drivers = true;
        //         $scope.virtualDrivers = false;
        //         $scope.carNumber = false;
        //         $scope.message = false;
        //         $scope.fleet = false;
        //         $scope.dataToFill = {
        //             notificationFleet: [],
        //             adminMessage: '',
        //             notificationCar: [],
        //             notify: '',
        //         }
        //         //=================get all drivers======================
        //         $scope.getAllDrivers = function () {
        //             $scope.loading = true;
        //             var promise = getDrivers.allDriversWithoutLimit();
        //             promise.then(
        //                 function (payload) {
        //                     $log.log(payload);
        //                     $scope.loading = false;
        //                     $scope.allDrivers = [];
        //                     $scope.dataToFill.notificationFleet = [];
        //                     $scope.dataToFill.notificationCar = [];
        //                     $scope.example14settings = {
        //                         scrollableHeight: '200px',
        //                         scrollable: true,
        //                         enableSearch: true
        //                     };
        //                     angular.forEach(payload.title.data.driver_data, function (column) {
        //                         $scope.allDrivers.push({
        //                             'label': column.first_name + " " + column.last_name,
        //                             'id': column.fleet_id
        //                         });
        //                     });

        //                     // vm.allDrivers = payload.title.data.driver_data;
        //                 },
        //                 function (errorPayload) {
        //                     $log.log(errorPayload, 'error');
        //                     $scope.loading = false;
        //                     if (errorPayload.data.status == 401) {
        //                         errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //                     } else {
        //                         errorMessageFactory.showErrorMessage(errorPayload.data.message);
        //                     }
        //                 }
        //             );
        //         }
        //         $scope.getAllDrivers();
        //         $scope.getOnlineCars = function () {
        //             $scope.loading = true;
        //             var promise = getCars.onlineCars();
        //             promise.then(
        //                 function (payload) {
        //                     if (payload.title.status == 200) {
        //                         $log.log(payload);
        //                         //$scope.loading = false;
        //                         $scope.onlineCar = [];
        //                         angular.forEach(payload.title.data, function (column) {
        //                             $scope.onlineCar.push({
        //                                 'label': column.unique_car_id,
        //                                 id: column.unique_car_id
        //                             });
        //                         });
        //                     } else {
        //                         errorMessageFactory.showErrorMessage(payload.title.message);
        //                     }


        //                     // vm.allDrivers = payload.title.data.driver_data;
        //                 },
        //                 function (errorPayload) {
        //                     $log.log(errorPayload, 'error');
        //                     //$scope.loading = false;
        //                     if (errorPayload.data.status == 401) {
        //                         errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //                     } else {
        //                         errorMessageFactory.showErrorMessage(errorPayload.data.message);
        //                     }
        //                 }
        //             );
        //         }
        //         $scope.getOnlineCars();
        //         $scope.closeDialog = function () {
        //             $mdDialog.hide();
        //         };


        //         $scope.confirmUpload = function (dataSend) {
        //             $scope.pushSelectedFleets = [];
        //             for (var i = 0; i < $scope.dataToFill.notificationFleet.length; i++) {
        //                 $scope.pushSelectedFleets.push($scope.dataToFill.notificationFleet[i].id);
        //             }
        //             $scope.pushSelectedCars = [];
        //             for (var i = 0; i < $scope.dataToFill.notificationCar.length; i++) {
        //                 $scope.pushSelectedCars.push($scope.dataToFill.notificationCar[i].id);
        //             }
        //             if ($scope.dataToFill.adminMessage == null || $scope.dataToFill.adminMessage == undefined || $scope.dataToFill.adminMessage == "") {
        //                 return false;
        //             }
        //             var dataSend = {};
        //             dataSend.fleet_id = $scope.pushSelectedFleets;
        //             dataSend.unique_car_id = $scope.pushSelectedCars;
        //             dataSend.message = $scope.dataToFill.adminMessage;
        //             if ($scope.dataToFill.notificationFleet == null || $scope.dataToFill.notificationFleet == undefined || $scope.dataToFill.notificationFleet == "") {
        //                 dataSend.notification_key = '0';
        //             } else if ($scope.dataToFill.notificationCar == null || $scope.dataToFill.notificationCar == undefined || $scope.dataToFill.notificationCar == "") {
        //                 dataSend.notification_key = '1';
        //             }
        //             if (dataSend.notification_key = '0') {
        //                 var dataSend = {};
        //                 dataSend.notification_key = '0';
        //                 dataSend.unique_car_id = $scope.pushSelectedCars;
        //                 dataSend.message = $scope.dataToFill.adminMessage;
        //             }
        //             if (dataSend.notification_key = '1') {
        //                 var dataSend = {};
        //                 dataSend.notification_key = '1';
        //                 dataSend.fleet_id = $scope.pushSelectedFleets;
        //                 dataSend.message = $scope.dataToFill.adminMessage;
        //             }

        //             dataSend.access_token = $cookies.get('obj');
        //             $scope.loading = true;
        //             var promise = mapDashboard.notification(dataSend);
        //             promise.then(
        //                 function (payload) {
        //                     $log.log('sxdsads', payload);
        //                     $scope.loading = false;
        //                     //errorMessageFactory.showErrorMessage('Message sent Successfully');
        //                     languageBasedErrorFactory.getProperErrorMessage('messageSentSuccess', 0, 0);
        //                     $timeout(function () {
        //                         $mdDialog.hide()
        //                         $state.go('layout.dashboardMain');
        //                     }, 5000)
        //                 },
        //                 function (errorPayload) {
        //                     $log.log(errorPayload);
        //                     $scope.loading = false;
        //                     if (errorPayload.data.status == 401) {
        //                         errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //                     } else {
        //                         errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //                     }
        //                 }
        //             );
        //             $log.log('confirmed');
        //             $mdDialog.hide();
        //         };
        //         $scope.allFleet = function () {
        //             $scope.drivers = true;
        //             $scope.virtualDrivers = false;
        //             $scope.carNumber = false;
        //         }
        //         $scope.virtualFleet = function () {
        //             $scope.virtualDrivers = true;
        //             $scope.drivers = false;
        //             $scope.carNumber = false;
        //         }
        //         $scope.allCar = function () {
        //             $scope.carNumber = true;
        //             $scope.drivers = false;
        //             $scope.virtualDrivers = false;
        //         }
        //     }
        // };

        //==========================filter with socket============================
        // function showDriversWithFilterSocket(data, type) {
        //     vm.countToSocket += 1;

        //     var dataSend = {};
        //     if (data.branch != 'all') {
        //         dataSend.filter_branch = data.branch;
        //     }
        //     if (data.vehicle != 'all') {
        //         dataSend.filter_vehicle = data.vehicle;
        //     }
        //     if (data.service != 'all') {
        //         dataSend.filter_services = data.service;
        //     }
        //     if (data.agreement != 'all') {
        //         dataSend.filter_agreement = data.agreement;
        //     }
        //     if (type || type == 0) {
        //         dataSend.fleet_status = type;
        //     } else {
        //         dataSend.fleet_status = data.filterDataDrivers;
        //     }
        //     dataSend.access_token = $cookies.get('obj');
        //     //var dataSend = {};
        //     //dataSend.fleet_status = data;
        //     //dataSend.access_token = $cookies.get('obj');
        //     //vm.loading = true;
        //     var promise = mapDashboard.map(dataSend);
        //     promise.then(
        //         function (payload) {
        //             $log.log('sxdsads', payload);
        //             vm.countToSocket = 0;
        //             if (payload.title.data && payload.title.data.length) {
        //                 vm.total_no_of_drivers = 0;
        //                 getCountOfDashboardFleets(payload.title.data);
        //                 for (var i = 0; i < vm.collectedData.length; i++) {
        //                     if (vm.collectedData[i].popInfoOpen) {
        //                         var index = []
        //                         payload.title.data.map(function (obj, indexD) {
        //                             if (obj.fleet_id == vm.collectedData[i].fleet_id) {
        //                                 index.push(indexD);
        //                             }
        //                         });
        //                         var storeData = payload.title.data[index[0]];
        //                         payload.title.data.splice(index[0], 1);
        //                         payload.title.data[payload.title.data.length] = storeData;
        //                         break;
        //                     }
        //                 }
        //                 initialize(payload.title.data, 0);
        //             } else {
        //                 vm.dataToFill.total_no_of_drivers_available = 0;
        //                 vm.dataToFill.total_no_of_off_duty_drivers = 0;
        //                 vm.dataToFill.total_no_of_drivers_on_duty = 0;
        //                 vm.dataToFill.total_no_of_started_drivers = 0;
        //                 vm.dataToFill.total_no_of_at_position_drivers = 0;
        //                 vm.dataToFill.total_no_of_busy_drivers = 0;
        //                 initialize(payload.title.data, 0);
        //             }
        //         },
        //         function (errorPayload) {
        //             $log.log(errorPayload);
        //             //vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // };

        function init() {
            vm.filterData.type_of_trip = ['R','P'];
            if (vm.assignBookingFlag == true) {
                getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
            } else {
                getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
            }
            // vm.getAllAssignBookings(0, vm.filterData.itemsPerPageSelected, vm.filterData, true);
        };

        //==========================set boolean=======================
        function setBooleans(type) {
            switch (type) {
                case 'HELP_TRAFFIC':
                    if (vm.dataToFill.helpTraffic) {
                        vm.dataToFill.helpTraffic = false;
                        trafficLayer.setMap(null);
                    } else {
                        vm.dataToFill.helpTraffic = true;
                        trafficLayer.setMap(map);
                    }
                    break;
            }
        };
        //==============================remove filter=============================
        function removeFilter() {
            $state.reload('layout.dashboardMain.dashboard');
        };

        //=============================search box implementation========================
        function removeSearchIconFromMap() {
            for (var i = 0; i < markers.length; i++) {
                if (markers[i].id == 'searchedMarker')
                    markers[i].setMap(null);
            }
            //markers = [];
        }

        function getSearchedAddress(data) {
            if (!data && (vm.dataToFill.branch != 'all' || vm.dataToFill.vehicle != 'all' || vm.dataToFill.agreement != 'all' || vm.dataToFill.service.length > 0 || vm.dataToFill.truck != '' || vm.dataToFill.bases != '')) {
                removeSearchIconFromMap();
                // showDriversWithFilterSocket(vm.dataToFill);
            } else if (!data && (vm.dataToFill.branch == 'all' || vm.dataToFill.vehicle == 'all' || vm.dataToFill.agreement == 'all' || vm.dataToFill.service.length > 0 || vm.dataToFill.truck == '' || vm.dataToFill.bases == '')) {
                removeSearchIconFromMap();
                initialize(vm.collectedData);
            }
        };

        function ctrlFn(data) {
            //map.setCenter(new google.maps.LatLng(data.geometry.location.lat(), data.geometry.location.lng()));
            //map.setZoom(12);
            removeSearchIconFromMap();
            createMarkerForSearchAddress(new google.maps.LatLng(data.geometry.location.lat(), data.geometry.location.lng()));
        };

        //==========================filter============================
        function showDriversWithFilter(data, type, customer_data) {

            vm.uniqueCarNumberSearch = '';
            vm.searchedAddress = '';
            removeSearchIconFromMap();
            var dataSend = {};
            if (data.branch != 'all') {
                dataSend.filter_branch = data.branch;
            }
            if (data.vehicle != 'all') {
                dataSend.filter_vehicle = data.vehicle;
            }
            if (data.service != 'all') {
                dataSend.filter_services = data.service;
            }
            if (data.agreement != 'all') {
                dataSend.filter_agreement = data.agreement;
            }
            if (type || type == 0) {
                dataSend.fleet_status = type;
            } else {
                dataSend.fleet_status = data.filterDataDrivers;
            }
            dataSend.access_token = $cookies.get('obj');

            if (data.filterDataDrivers == 4) {
                vm.dataToFill.total_no_of_drivers_available = 0;
                vm.dataToFill.total_no_of_at_position_drivers = 0;
                vm.dataToFill.total_no_of_started_drivers = 0;
                vm.dataToFill.total_no_of_off_duty_drivers = 0;
                vm.dataToFill.total_no_of_drivers_on_duty = 0;
                //vm.dataToFill.total_no_of_busy_drivers = 0;
            } else if (data.filterDataDrivers == 5) {
                //vm.dataToFill.total_no_of_at_position_drivers = 0;
                vm.dataToFill.total_no_of_drivers_available = 0;
                vm.dataToFill.total_no_of_started_drivers = 0;
                vm.dataToFill.total_no_of_off_duty_drivers = 0;
                vm.dataToFill.total_no_of_drivers_on_duty = 0;
                vm.dataToFill.total_no_of_busy_drivers = 0;
            } else if (data.filterDataDrivers == 3) {
                //vm.dataToFill.total_no_of_started_drivers = 0;
                vm.dataToFill.total_no_of_drivers_available = 0;
                vm.dataToFill.total_no_of_at_position_drivers = 0;
                vm.dataToFill.total_no_of_off_duty_drivers = 0;
                vm.dataToFill.total_no_of_drivers_on_duty = 0;
                vm.dataToFill.total_no_of_busy_drivers = 0;
            } else if (data.filterDataDrivers == 2) {
                //vm.dataToFill.total_no_of_off_duty_drivers = 0;
                vm.dataToFill.total_no_of_drivers_available = 0;
                vm.dataToFill.total_no_of_at_position_drivers = 0;
                vm.dataToFill.total_no_of_started_drivers = 0;
                vm.dataToFill.total_no_of_drivers_on_duty = 0;
                vm.dataToFill.total_no_of_busy_drivers = 0;
            } else if (data.filterDataDrivers == 1) {
                //vm.dataToFill.total_no_of_drivers_on_duty = 0;
                vm.dataToFill.total_no_of_drivers_available = 0;
                vm.dataToFill.total_no_of_at_position_drivers = 0;
                vm.dataToFill.total_no_of_started_drivers = 0;
                vm.dataToFill.total_no_of_off_duty_drivers = 0;
                vm.dataToFill.total_no_of_busy_drivers = 0;
            }

            //vm.dataToFill.total_no_of_drivers_available = 0;
            //vm.dataToFill.total_no_of_off_duty_drivers = 0;
            //vm.dataToFill.total_no_of_drivers_on_duty = 0;
            //vm.dataToFill.total_no_of_started_drivers = 0;
            //vm.dataToFill.total_no_of_at_position_drivers = 0;
            //vm.dataToFill.total_no_of_busy_drivers = 0;
            vm.loading = true;
            var promise = mapDashboard.map(dataSend);
            promise.then(
                function (payload) {
                    if (payload.title.data && payload.title.data.length) {
                        if (customer_data)
                            payload.title.data.push(customer_data);
                    }
                    $log.log('filter', payload);
                    vm.loading = false;
                    vm.collectedData = payload.title.data;
                    // if(customer_data)
                    // vm.collectedData.push(customer_data);
                    if (payload.title.data && payload.title.data.length) {
                        // if (customer_data)
                        // payload.title.data.push(customer_data);
                        // if (data.filterDataDrivers == 4) {
                        //     vm.dataToFill.total_no_of_busy_drivers = payload.title.data.length;
                        //     vm.dataToFill.total_no_of_drivers_available = payload.title.data.length;
                        // } 
                        if (data.filterDataDrivers == 5) {
                            vm.dataToFill.total_no_of_at_position_drivers = payload.title.data.length;
                            vm.dataToFill.total_no_of_drivers_available = payload.title.data.length;
                        } else if (data.filterDataDrivers == 3) {
                            vm.dataToFill.total_no_of_started_drivers = payload.title.data.length;
                            vm.dataToFill.total_no_of_drivers_available = payload.title.data.length;
                        } else if (data.filterDataDrivers == 2) {
                            vm.dataToFill.total_no_of_off_duty_drivers = payload.title.data.length;
                            vm.dataToFill.total_no_of_drivers_available = payload.title.data.length;
                        }
                        if (vm.count == 0) {
                            initialize(payload.title.data, 0);
                            vm.count++;
                        }
                    } else {
                        if (data.filterDataDrivers == 4) {
                            vm.dataToFill.total_no_of_busy_drivers = 0;
                            vm.dataToFill.total_no_of_drivers_available = 0;
                        } else if (data.filterDataDrivers == 5) {
                            vm.dataToFill.total_no_of_at_position_drivers = 0;
                            vm.dataToFill.total_no_of_drivers_available = 0;
                        } else if (data.filterDataDrivers == 3) {
                            vm.dataToFill.total_no_of_started_drivers = 0;
                            vm.dataToFill.total_no_of_drivers_available = 0;
                        } else if (data.filterDataDrivers == 2) {
                            vm.dataToFill.total_no_of_off_duty_drivers = 0;
                            vm.dataToFill.total_no_of_drivers_available = 0;
                        } else if (data.filterDataDrivers == 1) {
                            vm.dataToFill.total_no_of_drivers_on_duty = 0;
                            vm.dataToFill.total_no_of_drivers_available = 0;
                        } else if (data.filterDataDrivers == 0) {
                            vm.dataToFill.total_no_of_drivers_available = 0;
                            vm.dataToFill.total_no_of_drivers_on_duty = 0;
                            vm.dataToFill.total_no_of_off_duty_drivers = 0;
                            vm.dataToFill.total_no_of_started_drivers = 0;
                            vm.dataToFill.total_no_of_at_position_drivers = 0;
                            vm.dataToFill.total_no_of_busy_drivers = 0;
                        }
                        if (vm.count == 0) {
                            initialize(payload.title.data, 0);
                            vm.count++;
                        }
                        // initialize(payload.title.data, 0);
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        //======================get center pf polygon=======================
        function polygonCenter(poly) {
            var lowx,
                highx,
                lowy,
                highy,
                center_x,
                center_y,
                lats = [],
                lngs = [],
                vertices = poly;

            for (var i = 0; i < vertices.length; i++) {
                lngs.push(Number(vertices[i].y));
                lats.push(Number(vertices[i].x));
            }

            lats.sort();
            lngs.sort();
            lowx = lats[0];
            highx = lats[vertices.length - 1];
            lowy = lngs[0];
            highy = lngs[vertices.length - 1];
            center_x = lowx + ((highx - lowx) / 2);
            center_y = lowy + ((highy - lowy) / 2);
            return (new google.maps.LatLng(center_x, center_y));
        }

        //=======================show polygon on map=========================
        function showPolygon(data) {
            var triangleCoords = [];
            for (var i = 0; i < data.length; i++) {
                triangleCoords.push({
                    lat: data[i].x,
                    lng: data[i].y
                })
            }
            if (bermudaTriangle) {
                bermudaTriangle.setMap(null);
            }
            // Construct the polygon.
            bermudaTriangle = new google.maps.Polygon({
                paths: triangleCoords,
                strokeColor: '#f18903',
                strokeOpacity: 1,
                strokeWeight: 2,
                fillColor: 'transparent',
                fillOpacity: 0.5
            });
            bermudaTriangle.setMap(map);
        }
        //=====================make the map center at branch============================
        function makeMapCenterAccToBranch(data) {
            if (data != 'all') {
                var where = _.where(vm.dataToFill.totalBranchList, {
                    region_id: data
                });
                var centerLatLng = polygonCenter(where[0].region_data);
                showPolygon(where[0].region_data);
                map.setCenter(centerLatLng);
                map.setZoom(10);
            } else {
                bermudaTriangle.setMap(null);
            }
        };
        //=======================change filter============================
        function changeFilter() {
            if (vm.dataToFill.branch == 'all' && vm.dataToFill.vehicle == 'all' && vm.dataToFill.service.length > 0 && vm.dataToFill.agreement == 'all') {
                map.setCenter(myCenter);
                map.setZoom(3);
            }
        }

        function getFleetOnOffData(data) {
            var dataToSend = {
                fleet_id: data.fleet_id,
                is_available: data.status,
                access_token: $cookies.get('obj')
            };
            var promise = mapDashboard.getOnOffData(dataToSend);
            promise.then(
                function (payload) {
                    vm.onOffData1 = payload.title.data;
                    vm.loading = false;
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        //=======================search vehicle by unique car Id==============
        function getVehicleOnSearch(id) {
            var dataToSend = {
                search_id: id,
                access_token: $cookies.get('obj')
            };
            vm.loading = true;
            if (id) {
                var promise = mapDashboard.getVehicleOnSearch(dataToSend);
                promise.then(
                    function (payload) {
                        if (payload.title.status == 200) {
                            vm.loading = false;
                            if (payload.title.data.length) {
                                // restorePreviousData();
                                vm.collectedData.forEach(function (data) {
                                    data.popInfoOpen = false;
                                })
                                vm.searchVechileData = payload.title.data;
                                if (vm.searchVechileData.length)
                                    infowindow.close();
                                if (payload.title.data[0].first_name.length > 12) {
                                    vm.Fleetname = payload.title.data[0].first_name.substring(0, 13) + '...';
                                } else {
                                    vm.Fleetname = payload.title.data[0].first_name;
                                }

                                // vm.Fleetname = payload.title.data[0].first_name;
                                var latlng = new google.maps.LatLng(payload.title.data[0].latitude, payload.title.data[0].longitude);
                                bounds.extend(latlng);
                                map.fitBounds(bounds);
                                map.setZoom(18);
                                map.setCenter(latlng);

                            } else {
                                errorMessageFactory.showErrorMessage('El vehículo no está en servicio en este momento.', 0);
                            }
                        } else {
                            vm.loading = false;
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }

                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            } else {
                vm.loading = false;
            }
        }


        if (localStorage.getItem('quickAssignmentFilter')) {
            vm.filterData = JSON.parse(localStorage.getItem('quickAssignmentFilter'));
            vm.filterData.offset = 0;
            vm.itemsPerPageSelected = vm.filterData.itemsPerPageSelected ? vm.filterData.itemsPerPageSelected : 25;
            vm.itemsPerPageGot = 25;
            vm.filterData.itemsPerPageSelected = vm.filterData.itemsPerPageSelected ? vm.filterData.itemsPerPageSelected : 25;
            if (vm.filterData.searchBookingId || vm.filterData.searchPackageId) {
                getBookingIdResults(vm.filterData);
            } else {
                init();
            }
        } else {
            init();
        }


        // function bookingDetails(data){
        //     localStorage.setItem('quickAssignmentFilter',JSON.stringify(vm.filterData));
        //     // $state.go('layout.upcomingBookingsMain.upcomingBookingDetailsNew',{id:data.job_id,type:'0'});
        // }

        //$scope.$on('$destroy',function(){
        //    localStorage.removeItem('upcomingFilter');
        //})

        $scope.$watchCollection('vm.filterData', function (newValue, oldValue) {
            localStorage.setItem('quickAssignmentFilter', JSON.stringify(newValue));
        })


        function getCountOfDashboardFleets(count, type) {
            vm.countOfDashboardFleets = count;
            vm.dataToFill.total_no_of_drivers_available = 0;
            vm.dataToFill.total_no_of_off_duty_drivers = 0;
            vm.dataToFill.total_no_of_drivers_on_duty = 0;
            vm.dataToFill.total_no_of_started_drivers = 0;
            vm.dataToFill.total_no_of_at_position_drivers = 0;
            // vm.dataToFill.total_no_of_busy_drivers = 0;

            for (var i = 0; i < vm.countOfDashboardFleets.length; i++) {
                if (!type)
                    vm.collectedData[i].popInfoOpen = false;
                vm.dataToFill.total_no_of_drivers_available = vm.dataToFill.total_no_of_drivers_available + 1;
                if (vm.countOfDashboardFleets[i].is_available == 0 && vm.countOfDashboardFleets[i].status == 0) {
                    vm.dataToFill.total_no_of_off_duty_drivers = vm.dataToFill.total_no_of_off_duty_drivers + 1;
                }
                if (vm.countOfDashboardFleets[i].is_available == 1 && vm.countOfDashboardFleets[i].status == 0) {
                    vm.dataToFill.total_no_of_drivers_on_duty = vm.dataToFill.total_no_of_drivers_on_duty + 1;
                }
                if (vm.countOfDashboardFleets[i].is_available == 1 && vm.countOfDashboardFleets[i].status == 1 && (vm.countOfDashboardFleets[i].job_status == 15 || vm.countOfDashboardFleets[i].job_status == 7)) {


                    vm.dataToFill.total_no_of_started_drivers = vm.dataToFill.total_no_of_started_drivers + 1;
                }
                if (vm.countOfDashboardFleets[i].is_available == 1 && vm.countOfDashboardFleets[i].status == 1 && vm.countOfDashboardFleets[i].job_status == 4) {
                    vm.dataToFill.total_no_of_at_position_drivers = vm.dataToFill.total_no_of_at_position_drivers + 1;
                }
                // if (vm.countOfDashboardFleets[i].is_available == 1 && vm.countOfDashboardFleets[i].status == 1 && vm.countOfDashboardFleets[i].job_status == 1) {
                //     vm.dataToFill.total_no_of_busy_drivers = vm.dataToFill.total_no_of_busy_drivers + 1;
                // }
            }
            $timeout(function () {
                $scope.$digest();
            }, 500);
        }


        function getCountOfDashboardFleets1(count, type, data) {
            if (data)
                vm.countOfDashboardFleets = count;

            // vm.dataToFill.total_no_of_drivers_available = 0;
            // vm.dataToFill.total_no_of_off_duty_drivers = 0;

            vm.dataToFill.total_no_of_drivers_on_duty = 0;
            vm.dataToFill.total_no_of_drivers_available1 = 0;
            vm.dataToFill.total_no_of_busy_drivers = 0;


            vm.dataToFill.total_no_of_started_drivers = 0;
            // vm.dataToFill.total_no_of_at_position_drivers = 0;
            // vm.dataToFill.total_no_of_busy_drivers = 0;

            for (var i = 0; i < count.length; i++) {
                if (!type)
                    // vm.collectedData[i].popInfoOpen = false;
                    vm.dataToFill.total_no_of_drivers_available = vm.dataToFill.total_no_of_drivers_available + 1;
                if (!count[i].bookingHasNextTime && !count[i].busyDriver && !count[i].is_person) {
                    vm.dataToFill.total_no_of_drivers_on_duty = vm.dataToFill.total_no_of_drivers_on_duty + 1;
                    vm.ShowDataToGreen = vm.dataToFill.total_no_of_drivers_on_duty;
                }
                if (count[i].bookingHasNextTime && count[i].bookingHasNextTime == true && !count[i].is_person) {
                    vm.dataToFill.total_no_of_drivers_available1 = vm.dataToFill.total_no_of_drivers_available1 + 1;
                }
                if (count[i].busyDriver && count[i].busyDriver == true && !count[i].is_person) {
                    vm.dataToFill.total_no_of_busy_drivers = vm.dataToFill.total_no_of_busy_drivers + 1;
                }
            }

            $timeout(function () {
                $scope.$digest();
            }, 500);
        }

        function getCountOfDashboardFleetsSocket(count, type, data) {
            if (data && data.bookingHasNextTime == false && data.decrease == true) {
                vm.dataToFill.total_no_of_drivers_on_duty = vm.dataToFill.total_no_of_drivers_on_duty + 1;
            }
            if (data && data.bookingHasNextTime == true) {
                vm.dataToFill.total_no_of_drivers_on_duty = vm.ShowDataToGreen - 1;
                vm.dataToFill.total_no_of_drivers_available1 = vm.dataToFill.total_no_of_drivers_available1 + 1;
            }
            if (data && data.busy == true) {
                vm.dataToFill.total_no_of_drivers_on_duty = vm.ShowDataToGreen - 1;
                vm.dataToFill.total_no_of_busy_drivers = vm.dataToFill.total_no_of_busy_drivers + 1;
            }
            if ((data && data.bookingHasNextTime == false)) {
                vm.dataToFill.total_no_of_drivers_on_duty = vm.dataToFill.total_no_of_drivers_on_duty + 1;
                vm.dataToFill.total_no_of_busy_drivers = vm.dataToFill.total_no_of_busy_drivers - 1;
                // showNewDrivers(vm.dataToFill,0)
            }
            if (vm.dataToFill.total_no_of_busy_drivers < 0) {
                vm.dataToFill.total_no_of_busy_drivers = 0;
            }
            if (vm.dataToFill.total_no_of_drivers_on_duty < 0) {
                vm.dataToFill.total_no_of_drivers_on_duty = 0;
            }
            if (vm.dataToFill.total_no_of_drivers_available1 < 0) {
                vm.dataToFill.total_no_of_drivers_available1 = 0;
            }


            $timeout(function () {
                $scope.$digest();
            }, 500);

        }


        //===================side bar filters=====================
        vm.showFilterArea = showFilterArea;
        vm.branchChangedFilter = branchChangedFilter;
        vm.vehicleChangedFilter = vehicleChangedFilter;
        vm.serviceChangedFilter = serviceChangedFilter;
        vm.agreementChangedFilter = agreementChangedFilter;
        vm.virtualFleetChangedFilter = virtualFleetChangedFilter;
        vm.operationChangedFilter = operationChangedFilter;
        vm.trafficChangedFilter = trafficChangedFilter;
        vm.showFilterFlag = false;

        vm.filterWhichToShow = {
            branchWithDashboard: true,
            service: true,
            vehicle: true,
            agreement: true,
            operation: true,
            helpTraffic: true,
            virtualFleet: true,
            approvalStage: false,
            vehicleAssigned: false,
            applicantType: false,
            tripType: false,
            modelity: false
        };


        function showFilterArea() {
            vm.showFilterFlag = !vm.showFilterFlag;
        }

        function branchChangedFilter(data) {
            vm.showDriversWithFilter(data);
            vm.makeMapCenterAccToBranch(data.branch);
            vm.changeFilter();
        }

        function vehicleChangedFilter(data) {
            vm.showDriversWithFilter(data);
            vm.changeFilter();
        }

        function serviceChangedFilter(data) {
            vm.showDriversWithFilter(data);
            vm.changeFilter();
        }

        function agreementChangedFilter(data) {
            vm.showDriversWithFilter(data);
            vm.changeFilter();
        }

        function virtualFleetChangedFilter(data) {
            vm.showDriversWithFilter(data);
            vm.changeFilter();
        }

        function operationChangedFilter(data) {
            vm.showDriversWithFilter(data);
            vm.changeFilter();
        }

        function trafficChangedFilter(data) {
            if (data.helpTraffic) {
                trafficLayer.setMap(map);
            } else {
                trafficLayer.setMap(null);
            }
        }

        function datePickerE_1(type) {
            if (type == '1') {
                vm.datePicker_1.scheduledDate = true;
            }
        };

        function scheduleDateChanged() {
            vm.selectedDateForFilter = new Date(vm.dataToFill.selectedDate).getFullYear() + '-' + ('0' + (new Date(vm.dataToFill.selectedDate).getMonth() + 1)).slice(-2) + '-' + ('0' + new Date(vm.dataToFill.selectedDate).getDate()).slice(-2);
            localStorage.setItem('quickAssignmentDateFilter', vm.selectedDateForFilter);
            if (vm.assignBookingFlag)
                vm.assignBooking('boxId');
            if (vm.UnassignBookingFlag)
                vm.unAssignBooking('boxId1');
        }
        // ******** LOAD MORE BOOKINGS FUNCTION *********
        function loadMoreBookings() {
            $('.main-bookings-div').animate({
                scrollTop: 0
            }, 'slow');
            // vm.loadMore = 0;
            // vm.loadMoreAssigned = 0;
            if (vm.assignBookingFlag == true) {
                getAllAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                vm.assignBookingList = [];
            } else {
                getAllUnAssignBookings(0, vm.itemsPerPageGot, vm.filterData, true, "unScroll");
                vm.UnAssignBookingList = [];
            }
        }

    }

})();

/**
 * Created by cl-macmini-51 on 5/2/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('OngoingBookingsController', OngoingBookingsController);

    /** @ngInject */
    function OngoingBookingsController($cookies, $state, $log, $rootScope, $filter, $mdDialog, $timeout, $document, $scope, filterFilter,
        getBookings, getGeofence, getAgreement, getServices, getVehicles, getNoShowReason, errorMessageFactory, languageBasedErrorFactory, moment, pendingRequests, getCancelReason, checkDomain, getFilters, adminAccessService) {
        var vm = this;
        $log.log('ongoingBookings');
        vm.loading = false;
        vm.applyFilter = applyFilter;
        vm.currentPage = 0;
        vm.totalOngoingBookings = 0;
        vm.shiftIdStatus = $cookies.get('saleShiftId');
        vm.sp_pagination = false;
        vm.unAssignButtonRole = false;
        vm.openHit = false;
        vm.tBodyFlag = true;
        vm.datePickerE_3 = datePickerE_3;
        vm.pickupFromToTimeChanged = pickupFromToTimeChanged;
        vm.changeDateIntoSpanish = changeDateIntoSpanish;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.filterTextTimeout = '';
        vm.getAllOngoingBookings = getAllOngoingBookings;
        vm.getPagesCount = getPagesCount;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.init = init;
        vm.sort = sort;
        vm.getFilter = getFilter;

        vm.getFilterForAgreement = getFilterForAgreement;
        vm.getFilterForSearchByNameFilter = getFilterForSearchByNameFilter;
        vm.searchByNameRadioButtonChange = searchByNameRadioButtonChange;

        vm.branchChanged = branchChanged;
        vm.agreementChanged = agreementChanged;
        vm.serviceChanged = serviceChanged;
        vm.vehicleChanged = vehicleChanged;
        //vm.pickupTimeChanged = pickupTimeChanged;
        //vm.pickupDateChanged = pickupDateChanged;
        vm.searchBookingField = true;
        var domain = checkDomain.getDomainName();
        if (domain != 'dev' && domain != 'test') {
            vm.searchBookingField = false;
        }
        vm.resetFilter = resetFilter;
        vm.markNoShow = markNoShow;
        vm.makeBookingStatusChange = makeBookingStatusChange;
        vm.getFilterBookingId = getFilterBookingId;
        vm.manualUnassignBooking = manualUnassignBooking;
        vm.typeTripChanged = typeTripChanged;
        vm.slideData = slideData;
        vm.paginationNew = paginationNew;
        vm.bookingDetails = bookingDetails;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings(runThis);
        vm.dateOptions = {};
        vm.countToSocket = 0;
        vm.datePicker_1 = {
            pickupDate: false
        };

        vm.bookingStatusChange = bookingStatusChange;
        vm.stateOfBookingArray = [{
                name: 'Todos',
                id: -1
            },
            {
                name: 'Started',
                id: 1
            },
            {
                name: 'Arrived',
                id: 4
            },
            {
                name: 'On Road',
                id: 15
            }
        ]

        vm.altInputFormats = ['M!/d!/yyyy'];
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.predicate = 'index';
        vm.reverse = false;
        vm.hstep = 1;
        vm.mstep = 15;
        vm.ismeridian = true;
        vm.searchModel = {
            limit: 25,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
        vm.filterData = {
            branch_filter: 0, //0, 1
            service_filter: 0, //0, 1
            vehicle_filter: 0, //0, 1
            aggrement_filter: 0, //0, 1
            //date_time_filter : 0,  //0, 1
            branch: 'all',
            service: 'all',
            vehicle: 'all',
            //date_time_value: '',
            agreement: 'all',
            // type_of_trip: 'all',
            type_of_trip_filter: 0,
            filter_pickup_date_value: '',
            filter_pickup_time_value: new Date(),
            limit: vm.itemsPerPageGot,
            offset: 0,
            booking_status: 1,
            search_filter: 0,
            bookingStateFilter: 0,
            bookingStateValue: -1,
            search_value: '',
            searchBookingId: '',
            searchPackageId: '',
            search: '',
            agreementSearch: '',
            agreementValue: 0,
            searchByName: 0,
            itemsPerPageSelected: 25,
            filter_pickup_from_date_value: getFirstDateOfPreviousMonth(),
            filter_pickup_to_date_value: setToPickupDate(),
            filter_pickup_from_time_value: showFilterTime(1),
            filter_pickup_to_time_value: showFilterTime(2),
        };
        ///////////// DATe FUNCTIONS/////////////////////
        function showFilterTime(type) {
            if (type == 1) {
                var x = new Date();
                x.setHours('00');
                x.setMinutes('00');
                x.setSeconds('00');
                return x;
            } else {
                var x = new Date();
                x.setHours('23');
                x.setMinutes('59');
                x.setSeconds('00');
                return x;
            }
        }

        vm.paginationChangedForService = paginationChangedForService;
        vm.paginationChangedForVehicle = paginationChangedForVehicle;
        vm.paginationChangedForBranch = paginationChangedForBranch;
        vm.paginationChangedForAgreement = paginationChangedForAgreement;
        vm.vehicleSearch = vehicleSearch;
        vm.serviceSearch = serviceSearch;
        vm.branchSearch = branchSearch;
        vm.agreementSearch = agreementSearch;
        vm.globalLimit = 1000;
        vm.globalOffset = vm.globalLimit;

        vm.service = [];
        vm.service.push({
            id: 'all',
            name: 'Todos'
        })

        vm.vehicle = [];
        vm.vehicle.push({
            id: 'all',
            name: 'Todos'
        });

        vm.branchList = [];
        vm.branchList.push({
            region_name: 'Todos',
            region_id: 'all'
        });

        vm.agreement = [];
        vm.agreement.push({
            id: 'all',
            name: 'Todos'
        });

        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'vehicle', 'service', 'agreement', 'corporatesList', 'operation_point'];

        vm.serviceOffset = 0;
        vm.branchOffset = 0;
        vm.vehicleOffset = 0;
        vm.agreementOffset = 0;

        function clearOffset() {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                vm[vm.searchFilterArray[i] + 'Offset'] = 0;
            }

        }

        // =================== FILTER OBJECT ===================
        vm.filterObject = {
            access_token: $cookies.get('obj'),
            branch_filter: 1,
            vehicle_filter: 1,
            service_filter: 1,
            agreement_filter: 1,
            corporate_filter: 0,
            service_category: 0,
            corporate_status: 0,
            agreement_status: 2,
            vehicle__status: 2,
            operation_point_filter: 0,
            service_limit: vm.globalLimit,
            service_offset: vm.serviceOffset,
            branch_limit: vm.globalLimit,
            branch_offset: vm.branchOffset,
            vehicle_limit: vm.globalLimit,
            vehicle_offset: vm.vehicleOffset,
            agreement_limit: vm.globalLimit,
            agreement_offset: vm.agreementOffset,
            branch_search_filter: 0,
            vehicle_search_filter: 0,
            service_search_filter: 0,
            agreement_search_filter: 0,
            corporate_search_filter: 0,
            operation_point_search_filter: 0
        }
        setTimeout(function () {
            document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                // if (vm.branchList && (vm.branchList.length == 0)) {
                vm.searchBranchData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });


            document.getElementsByClassName('ui-select-search')[1].addEventListener('blur', function ($event) {
                // if (vm.agreement && (vm.agreement.length == 0)) {
                vm.searchAgreementData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

            document.getElementsByClassName('ui-select-search')[2].addEventListener('blur', function ($event) {
                // if (vm.service && (vm.service.length == 0)) {
                vm.searchServiceData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

            document.getElementsByClassName('ui-select-search')[3].addEventListener('blur', function ($event) {
                // if (vm.vehicle && (vm.vehicle.length == 0)) {
                vm.searchVehicleData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

        })

        // =================== GET FILTER DATA ===================
        function getFilterDataFromBackend(data, type) { //Acc to Index ['branch_search', 'vehicle_search', 'service_search', 'agreement_search', 'corporate_search', 'operation_point_search']
            if (data) {
                vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
            } else {
                vm.filterObject = {
                    access_token: $cookies.get('obj'),
                    branch_filter: 1,
                    vehicle_filter: 1,
                    service_filter: 1,
                    agreement_filter: 1,
                    corporate_filter: 0,
                    service_category: 0,
                    corporate_status: 0,
                    agreement_status: 2,
                    vehicle__status: 2,
                    operation_point_filter: 0,
                    branch_search_filter: 0,
                    vehicle_search_filter: 0,
                    service_search_filter: 0,
                    agreement_search_filter: 0,
                    corporate_search_filter: 0,
                    operation_point_search_filter: 0
                }
            }

            vm.filterObject.service_limit = vm.globalLimit;
            vm.filterObject.service_offset = vm.serviceOffset;
            vm.filterObject.branch_limit = vm.globalLimit;
            vm.filterObject.branch_offset = vm.branchOffset;
            vm.filterObject.vehicle_limit = vm.globalLimit;
            vm.filterObject.vehicle_offset = vm.vehicleOffset;
            vm.filterObject.agreement_limit = vm.globalLimit;
            vm.filterObject.agreement_offset = vm.agreementOffset;

            var promise = getFilters.getAllFilterData(vm.filterObject);
            promise.then(
                function (payload) {
                    // ********** BRANCH DATA ********
                    if (payload.title.data.branches) {
                        var index = _.findIndex(vm.branchList, {
                            region_id: 'all'
                        });
                        if (index == -1)
                            vm.branchList.push({
                                region_name: 'Todos',
                                region_id: 'all'
                            });
                        angular.forEach(payload.title.data.branches.data, function (column) {
                            var branchIndex = _.findIndex(vm.branchList, {
                                region_id: column.region_id
                            });
                            if (branchIndex == -1)
                                vm.branchList.push(column)
                        });
                        vm.branchTotalBackendCount = payload.title.data.branches.totalCount;
                    }

                    // ********** VEHICLE DATA ********
                    if (payload.title.data.vehicles) {
                        var index = _.findIndex(vm.vehicle, {
                            id: 'all'
                        });
                        if (index == -1)
                            vm.vehicle.push({
                                name: 'Todos',
                                id: 'all'
                            });
                        vm.vehicleTotalBackendCount = payload.title.data.vehicles.totalCount;
                        angular.forEach(payload.title.data.vehicles.data, function (column) {
                            // vm.vehicle.push({
                            //     id: column.id,
                            //     name: column.name
                            // })
                            var vechicleIndex = _.findIndex(vm.vehicle, {
                                id: column.id
                            });
                            if (vechicleIndex == -1)
                                vm.vehicle.push({
                                    id: column.id,
                                    name: column.name
                                })
                        });
                    }

                    // *********** SERVICE DATA *********
                    if (payload.title.data.services) {
                        var index = _.findIndex(vm.service, {
                            id: 'all'
                        });
                        if (index == -1)
                            vm.service.push({
                                name: 'Todos',
                                id: 'all'
                            });
                        vm.serviceTotalBackendCount = payload.title.data.services.totalCount;
                        angular.forEach(payload.title.data.services.data, function (column) {
                            // vm.service.push({
                            //     id: column.id,
                            //     name: column.service_name
                            // });
                            var serviceIndex = _.findIndex(vm.service, {
                                id: column.id
                            });
                            if (serviceIndex == -1)
                                vm.service.push({
                                    id: column.id,
                                    name: column.service_name
                                })
                        });
                    }

                    // *********** AGREEMENT DATA *********
                    if (payload.title.data.agreements) {
                        var index = _.findIndex(vm.agreement, {
                            id: 'all'
                        });
                        if (index == -1)
                            vm.agreement.push({
                                name: 'Todos',
                                id: 'all'
                            });
                        vm.agreementTotalBackendCount = payload.title.data.agreements.totalCount;
                        angular.forEach(payload.title.data.agreements.data, function (column) {
                            // vm.agreement.push({
                            //     id: column.id,
                            //     name: column.name
                            // });
                            var agreementIndex = _.findIndex(vm.agreement, {
                                id: column.id
                            });
                            if (agreementIndex == -1)
                                vm.agreement.push({
                                    id: column.id,
                                    name: column.name
                                })
                        });
                    }

                    vm.loading = false;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        }

        getFilterDataFromBackend();
        // ************ PAGINATION ON SERIVCE **************
        function paginationChangedForService() {
            var index = _.findIndex(vm[vm.searchFilterArray[2]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.serviceTotalBackendCount > (vm.service.length - index)) {
                commonFunction(2);
                vm.serviceOffset += 10;
                getFilterDataFromBackend(vm.searchServiceData, 2);
            }
        }

        // ************ PAGINATION ON VEHICLE **************
        function paginationChangedForVehicle() {
            var index = _.findIndex(vm[vm.searchFilterArray[1]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.vehicleTotalBackendCount > (vm.vehicle.length - index)) {
                commonFunction(1);
                vm.vehicleOffset = vm.vehicleOffset + 10;
                getFilterDataFromBackend(vm.searchVehicleData, 1);
            }
        }

        // ************ PAGINATION ON BRANCH **************
        function paginationChangedForBranch() {
            var index = _.findIndex(vm[vm.searchFilterArray[0]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.branchTotalBackendCount > (vm.branchList.length - index)) {
                commonFunction(0);
                vm.branchOffset += 10;
                getFilterDataFromBackend(vm.searchBranchData, 0);
            }
        }

        // ************ PAGINATION ON AGREEMENT **************
        function paginationChangedForAgreement() {
            var index = _.findIndex(vm[vm.searchFilterArray[3]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.agreementTotalBackendCount > (vm.agreement.length - index)) {
                commonFunction(3);
                vm.agreementOffset += vm.globalOffset;
                getFilterDataFromBackend(vm.searchAgreementData, 3);
            }
        }

        // *********** COMMON FUNCTION FOR FILTER PAGINATION AND SEARCHING ***********
        function commonFunction(type, mode) {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                // vm['search' + vm.searchFilterArray[i] + 'Data'] = '';
                if (mode == 'search' || i != type) {
                    vm[vm.searchFilterArrayForClearArray[i]] = [];
                    // vm[vm.searchFilterArrayForClearArray[i]].push({
                    //     id: 'all',
                    //     name: 'Todos'
                    // });
                    vm[vm.searchFilterArray[i] + 'Offset'] = 0;
                    vm['search' + vm.searchFilterArray[i].substring(0, 1).toUpperCase() + vm.searchFilterArray[i].substring(1) + 'Data'] = '';
                }
            }
        }

        // ************ SEARCH VEHICLE ***************
        function vehicleSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchVehicleData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(1, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 1);
                }, 2000);
            }
        }

        // ************ SEARCH SERVICE ***************
        function serviceSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchServiceData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(2, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 2);
                }, 2000);
            }
        }

        // ************ SEARCH VEHICLE ***************
        function branchSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchBranchData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(0, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 0);
                }, 2000);
            }
        }

        // ************ SEARCH AGREEMENT ***************
        function agreementSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchAgreementData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(3, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 3);
                }, 2000);
            }
        }




        function getFirstDateOfPreviousMonth() {
            var date = new Date();
            var yesterday = new Date(date.getTime() - 24 * 60 * 60 * 1000);
            return yesterday;
        }

        function setToPickupDate() {
            var x = new Date();
            var yesterday = new Date(x.getTime() + (24 * 60 * 60 * 1000));

            return yesterday;

        }

        function datePickerE_3(type) {
            if (type == 1) {
                vm.datePicker_1.pickupFromDate = true;
                vm.datePicker_1.pickupToDate = false;

            } else if (type == 2) {
                vm.datePicker_1.pickupFromDate = false;
                vm.datePicker_1.pickupToDate = true;
            }
        };



        vm.pickupFromToDateChanged = function (data) {
            vm.dateOptions = {
                //dateDisabled: disabled,
                formatYear: 'yy',
                // maxDate: new Date(),
                // minDate: new Date(vm.filterData.filter_pickup_from_date_value),
                startingDay: 1,
                showWeeks: false,

            };
            // getAllOngoingBookings(0, vm.itemsPerPageGot, vm.filterData, true);

        }

        function pickupFromToTimeChanged(type) {
            // getAllOngoingBookings(0, vm.itemsPerPageGot, vm.filterData, true);

        }
        ///////////// DATe FUNCTIONS/////////////////////
        function runThis() {
            vm.typeTripFilter = [
                // {
                //     name: languageBasedErrorFactory.getProperErrorMessage('allLabel',0,'3'),
                //     id: 'all'
                // },
                {
                    name: 'From Airport',
                    id: 'Z'
                },
                {
                    name: 'To Airport',
                    id: 'R'
                },
                {
                    name: 'Point to Point',
                    id: 'P'
                }
            ]
        }


        // console.log(localStorage.getItem('ongoingFilter'));
        if (localStorage.getItem('ongoingFilter')) {
            vm.filterData = JSON.parse(localStorage.getItem('ongoingFilter'));
            vm.itemsPerPageSelected = vm.filterData.itemsPerPageSelected ? vm.filterData.itemsPerPageSelected : 25;
            vm.itemsPerPageGot = vm.filterData.itemsPerPageSelected ? vm.filterData.itemsPerPageSelected : 25;
            vm.filterData.itemsPerPageSelected = vm.filterData.itemsPerPageSelected ? vm.filterData.itemsPerPageSelected : 25;
            if (vm.filterData.searchBookingId || vm.filterData.searchPackageId) {
                getBookingIdResults(vm.filterData);
            } else {
                init();
            }
        } else {
            init();
        }

        //==============booking details================
        function bookingDetails(data) {
            localStorage.setItem('ongoingFilter', JSON.stringify(vm.filterData));
            $state.go('layout.ongoingBookingsMain.ongoingBookingDetailsNew', {
                id: data.job_id,
                type: '1'
            });
        }

        //$scope.$on('$destroy',function(){
        //    localStorage.removeItem('upcomingFilter');
        //})

        $scope.$watchCollection('vm.filterData', function (newValue, oldValue) {
            localStorage.setItem('ongoingFilter', JSON.stringify(newValue));
        })

        //====================socket connection===================
        var myListener = $rootScope.$on('SocketComesOngoing', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            var DatetoSend = new Date(date_time_value2).getTime();
            var dateFrom = new Date(date_time_value1).getTime();
            var dateTo = DatetoSend;
            var type = typeof data.res.message;
            if (data && data.res.message.multi && data.res.message.multi == true) {
                var bookingArray = data.res.message.jobArray;
                for (var i = 0; i < bookingArray.length; i++) {
                    var booking_date = bookingArray[i].job_time_utc;
                    // booking_date = booking_date.split('T')[0];
                    booking_date = new Date(booking_date).getTime();
                    if (dateFrom <= booking_date && booking_date <= dateTo) {
                        if (data.data && vm.countToSocket == 0 && (!vm.filterData.searchBookingId && !vm.filterData.searchPackageId)) {
                            vm.itemsPerPageGot = vm.itemsPerPageSelected;
                            getAllOngoingBookings(vm.currentPage > 0 ? vm.currentPage * vm.itemsPerPageGot : 0, vm.itemsPerPageGot, vm.filterData, false);
                        } else if (data.data && vm.countToSocket == 0 && (vm.filterData.searchBookingId || vm.filterData.searchPackageId)) {
                            getBookingIdResults(vm.filterData);
                        }
                        break;
                    }
                }
            } else if (data && data.res && type == 'object') {
                var booking_date = data.res.message.job_time_utc;
                // booking_date = booking_date.split('T')[0];
                booking_date = new Date(booking_date).getTime();
                if ((dateFrom <= booking_date) && (booking_date <= dateTo)) {
                    if (data.data && vm.countToSocket == 0 && (!vm.filterData.searchBookingId && !vm.filterData.searchPackageId)) {
                        vm.itemsPerPageGot = vm.itemsPerPageSelected;
                        console.log("i m in the second if of socket");
                        getAllOngoingBookings(vm.currentPage > 0 ? vm.currentPage * vm.itemsPerPageGot : 0, vm.itemsPerPageGot, vm.filterData, false);
                    } else if (data.data && vm.countToSocket == 0 && (vm.filterData.searchBookingId || vm.filterData.searchPackageId)) {
                        getBookingIdResults(vm.filterData);
                    }
                }
            } else {
                if (data.data && vm.countToSocket == 0 && (!vm.filterData.searchBookingId && !vm.filterData.searchPackageId)) {
                    vm.itemsPerPageGot = vm.itemsPerPageSelected;
                    console.log("i m in the third if of socket");
                    getAllOngoingBookings(vm.currentPage > 0 ? vm.currentPage  * vm.itemsPerPageGot : 0, vm.itemsPerPageGot, vm.filterData, false);
                } else if (data.data && vm.countToSocket == 0 && (vm.filterData.searchBookingId || vm.filterData.searchPackageId)) {
                    getBookingIdResults(vm.filterData);
                }
            }


        });

        var myListenerValidation = $rootScope.$on('SocketComesValidation', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data && vm.countToSocket == 0 && (!vm.filterData.searchBookingId && !vm.filterData.searchPackageId)) {
                vm.itemsPerPageGot = vm.itemsPerPageSelected;
                getAllOngoingBookings(vm.currentPage > 0 ? vm.currentPage * vm.itemsPerPageGot : 0, vm.itemsPerPageGot, vm.filterData, false);
            } else if (data.data && vm.countToSocket == 0 && (vm.filterData.searchBookingId || vm.filterData.searchPackageId)) {
                getBookingIdResults(vm.filterData);
            }
        });

        $scope.$on('$destroy', myListener);
        $scope.$on('$destroy', myListenerValidation);
        //$rootScope.socket.on('socketEventToUser',function(res){
        //    showDriversWithFilterSocket(vm.dataToFill);
        //});


        if ($rootScope.socket.connected == false || $rootScope.socket.connected == 'false') {
            $rootScope.socket.connect();
        }


        //====================slide data======================
        $('#derp').hide();

        function slideData() {
            // getBranch();
            // vm.agreement = [];
            // vm.branchList = [];
            // vm.vehicle = [];
            // vm.service = [];
            // getFilterDataFromBackend();
            $('#derp').slideToggle(1000);
            document.getElementById('toDate').value = moment(vm.filterData.filter_pickup_to_date_value).format('DD-MMMM-YYYY');
            document.getElementById('fromDate').value = moment(vm.filterData.filter_pickup_from_date_value).format('DD-MMMM-YYYY');
            vm.filterData.searchByName = 0;

        }


        //====================function for dropdown pages and page count===============
        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            getAllOngoingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
        };

        function paginationNew(page) {
            console.log((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData, true,'ongoing >>>>>>');
            
            getAllOngoingBookings((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData, true);
        }
        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.ongoingBookingsMain.ongoingBookings');
            }
        });
        //===============================function to change date============================
        function changeDateFormat(date) {
            var data = date.split('T')[0];
            var newDate = new Date(data);
            newDate.setHours(Number(date.split('T')[1].split(':')[0]));
            newDate.setMinutes(Number(date.split('T')[1].split(':')[1]));
            newDate.setSeconds(0);
            return newDate;
        };
        //====================date time format====================
        function dateTimeFormat(dateGot, timeGot) {
            // var dateToChange = dateGot;
            var dateToChange = new Date(dateGot);
            var timeGotChange = new Date(timeGot);
            if (timeGotChange) {
                dateToChange.setHours(timeGotChange.getHours());
                dateToChange.setMinutes(timeGotChange.getMinutes());
                dateToChange.setSeconds(timeGotChange.getSeconds());
            } else {
                dateToChange.setHours(0);
                dateToChange.setMinutes(0);
                dateToChange.setSeconds(0);
            }
            return dateToChange;
        };
        //==================get all drivers=======================
        function getAllOngoingBookings(skip, limit, filter, loader) {
            var pickFromDate = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var pickToDate = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            if (pickFromDate > pickToDate) {
                errorMessageFactory.showErrorMessage('Por favor, elija las fechas apropiadas de filtro.', 0);
                return;
            }
            vm.countToSocket = vm.countToSocket + 1;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit;
            dataSend.offset = skip;
            dataSend.booking_status = filter.booking_status;
            dataSend.branch_filter = filter.branch_filter;
            if (filter.branch_filter == 1 && filter.branch != 'all') {
                dataSend.branch_value = filter.branch;
            }
            dataSend.service_filter = filter.service_filter;
            if (filter.service_filter == 1 && filter.service != 'all') {
                dataSend.service_value = filter.service;
            }
            dataSend.vehicle_filter = filter.vehicle_filter;
            if (filter.vehicle_filter == 1 && filter.vehicle != 'all') {
                dataSend.vehicle_value = filter.vehicle;
            }
            //dataSend.date_time_filter = filter.date_time_filter;
            //if(filter.filter_pickup_date_value && filter.filter_pickup_time_value) {
            //    dataSend.date_time_value = dateTimeFormat(filter.filter_pickup_date_value, filter.filter_pickup_time_value);
            //}
            //else if(filter.filter_pickup_date_value && !filter.filter_pickup_time_value){
            //    dataSend.date_time_value = moment(filter.filter_pickup_date_value).format('YYYY-MM-DD');
            //}

            dataSend.aggrement_filter = filter.aggrement_filter;
            if (filter.aggrement_filter == 1 && filter.agreement != 'all') {
                dataSend.aggrement_value = filter.agreement;
            }
            // ****** VARIABLE FOR AGREEMENT FILTERS *******
            dataSend.search_by_agreement_filter = filter.agreementValue || 0;
            if (filter.agreementValue == 1) {
                dataSend.search_agreement_value = filter.agreementSearch;
            }
            // ****** VARIABLE FOR SEARCH BY NAME FILTERS *******
            dataSend.search_user_filter = filter.searchByNameFilterValue || 0;
            if (filter.searchByNameFilterValue == 1) {
                dataSend.search_by_user_filter = filter.searchByName;
                dataSend.search_user_value = filter.searchByNameFilter;
            }
            // ******* VARIABLE FOR BOOKING STATE FILTER ********
            dataSend.job_status_filter = filter.bookingStateValue > -2 ? 1 : 0;
            if (dataSend.job_status_filter == 1) {
                dataSend.job_status_value = [];
                if (filter.bookingStateValue == -1) {
                    var dummyArray = [];
                    // ***** SELECT ALL ******
                    vm.stateOfBookingArray.forEach(function (object) {
                        if (object.id != -1)
                            dummyArray.push(object.id)
                    });
                    dataSend.job_status_value = JSON.stringify(dummyArray);
                } else {
                    dataSend.job_status_value.push(JSON.stringify(filter.bookingStateValue));
                }
            }
            // dataSend.type_of_trip_filter = filter.type_of_trip_filter;
            // if(filter.type_of_trip_filter == 1 && filter.type_of_trip != 'all'){
            //     // dataSend.type_of_trip_value = filter.type_of_trip;
            //     var trip = [];
            //     trip.push(vm.filterData.type_of_trip);
            //     if(vm.filterData.type_of_trip.length > 0){
            //         dataSend.type_of_trip_value = trip;
            //     }
            // }
            dataSend.date_time_filter = 1;
            dataSend.date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            dataSend.date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);

            var trip = [];
            trip.push(vm.filterData.type_of_trip);
            if (vm.filterData.type_of_trip && vm.filterData.type_of_trip.length > 0 && filter.type_of_trip != 'all') {
                dataSend.type_of_trip_filter = 1;
                dataSend.type_of_trip_value = trip;
            } else {
                dataSend.type_of_trip_filter = 0;
            }
            dataSend.search_filter = filter.search_filter;
            if (filter.search_filter == 1) {
                dataSend.search_value = filter.search_value;

            }

            vm.loading = loader;
            var promise = getBookings.allBookings(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.countToSocket = 0;
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.totalOngoingBookings = payload.title.data.totalCount;
                        vm.dataLength = payload.title.data.totalCount;

                        if (payload.title.data.totalCount == 0) {
                            vm.sp_pagination = false;
                            vm.tBodyFlag = false;
                            vm.tFootFlag = true;
                            vm.filterOn = true;
                            vm.skipValueFilter = 0;
                        } else {
                            vm.sp_pagination = true;
                            vm.tBodyFlag = true;
                            vm.tFootFlag = false;
                            vm.filterOn = false;
                            vm.skipValueFilter = 0;

                            var dataArray = [];
                            var ongoingBookingsList = payload.title.data.result;
                            ongoingBookingsList.forEach(function (column) {
                                var d = {};
                                d.job_id = column.job_id;
                                d.job_status = column.job_status;
                                d.created_by = column.created_by;
                                d.booking_for = column.booking_for; //0 owner, 1- other
                                d.is_vip = column.is_VIP;
                                //d.job_pickup_datetime = changeDateFormat(column.job_pickup_datetime);
                                d.job_pickup_name = column.job_pickup_name;
                                d.job_pickup_phone = column.job_pickup_phone;
                                d.job_pickup_email = column.job_pickup_email;
                                d.job_pickup_address = column.job_pickup_address;
                                d.job_address = column.job_address; //destination
                                d.number_of_passangers = column.number_of_passangers;
                                d.creation_datetime = column.creation_datetime;
                                d.fleet_id = column.fleet_id;
                                d.job_time_utc = column.job_time_utc; //actual start time
                                d.job_time = column.job_time_utc; //actual start time
                                d.job_time_filtered = $filter('date')(column.job_time_utc, "MMM d, yyyy HH:mm'"); //actual start time
                                if (new Date(column.job_time_utc).getDate() == new Date().getDate() && new Date(column.job_time_utc).getMonth() == new Date().getMonth() && new Date(column.job_time_utc).getFullYear() == new Date().getFullYear()) {
                                    d.dateFlagForShow = true;
                                } else {
                                    d.dateFlagForShow = false;
                                }
                                d.transport_details = column.transport_details; //CAR number
                                d.fleet_first_name = column.fleet_first_name;
                                d.fleet_last_name = column.fleet_last_name;
                                d.fleet_country_code = column.fleet_country_code;
                                d.fleet_phone_number = column.fleet_phone_number;
                                d.customer_first_name = column.customer_first_name;
                                d.customer_last_name = column.customer_last_name;
                                d.customer_country_code = column.customer_country_code;
                                d.customer_phone_number = column.customer_phone_number;
                                d.is_round_trip = column.is_round_trip;
                                d.return_date_time_utc = column.return_date_time;
                                d.return_date_time = column.return_date_time_utc;
                                d.round_trip_parent_job_id = column.round_trip_parent_job_id;
                                d.auth_required = column.auth_required;
                                d.auth_of = column.auth_of;
                                d.is_auth = column.is_auth;
                                d.etaPickUp = column.eta_pickup;
                                d.etaDropoff = column.eta;
                                d.branch = column.branch_name;
                                d.type_of_service = column.service_name;
                                d.agreement = column.contract_name;
                                d.unique_car_id = column.unique_car_id;
                                d.estimated_payment_cost = column.estimated_payment_cost;
                                d.type_of_trip = column.type_of_trip;
                                d.shared_service_id = column.shared_service_id;
                                d.shared_service_status = column.shared_service_status;
                                d.booking_type = column.booking_type;
                                d.locking_id = column.locking_id;
                                d.locking_name = column.locking_id_name;
                                d.flight_number = column.flight_number;
                                d.shift_id = column.shift_id;
                                d.payment_method = column.payment_method;
                                d.payment_status = column.payment_status;
                                d.admin_fullyname = column.admin_fullyname;
                                d.total_refund_amount = column.total_refund_amount;
                                d.total_estimated_payment_cost = column.total_estimated_payment_cost;
                                d.round_trip = column.round_trip;
                                dataArray.push(d);
                            });
                            vm.ongoingBookingsList = dataArray;

                            // USERTYPE VALUE
                            // 0 - Transvip user
                            // 1 - PET user
                            vm.userType = payload.title.data.user_type || 0;

                            for (var i = 0; i < vm.ongoingBookingsList.length; i++) {
                                vm.ongoingBookingsList[i].index = (skip + i);
                            }
                            if (vm.dataLength <= vm.itemsPerPageGot) {
                                vm.sp_pagination = false;
                            } else {
                                vm.sp_pagination = true;
                                //vm.pageCount(payload.title.totalCount);
                            }
                            vm.skipValue = vm.ongoingBookingsList[0].index;
                            vm.limitValue = vm.ongoingBookingsList[vm.ongoingBookingsList.length - 1].index;

                            //$scope.$watch('vm.search', function (newVal, oldVal) {
                            //    vm.filtered = filterFilter(vm.ongoingBookingsList, newVal);
                            //    vm.totalItems = vm.filtered.length;
                            //    if (vm.filtered.length == 0) {
                            //        vm.watchPagination = false;
                            //    } else {
                            //        vm.watchPagination = true;
                            //    }
                            //    if (vm.filterOn == true) {
                            //        vm.skipValueFilter = vm.filtered.length;
                            //        vm.sp_pagination = false;
                            //    }
                            //}, true);

                            //range();
                        }
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        //===========================get filters by booking id=========================
        function getFilterBookingId(data) {
            vm.currentPage = 0;
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (!data) {
                vm.getAllOngoingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
            } else {
                //if (vm.filterTextTimeout) $timeout.cancel(vm.filterTextTimeout);
                //vm.filterTextTimeout = $timeout(function(){
                getBookingIdResults(vm.filterData);
                //},500);
            }
        };

        function getBookingIdResults(data) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            if (data.searchBookingId)
                dataSend.booking_id = data.searchBookingId;
            if (data.searchPackageId)
                dataSend.package_id = data.searchPackageId;
            dataSend.booking_status = 1;
            //vm.loading = true;
            var promise = getBookings.getBookingById(dataSend);
            promise.then(
                function (payload) {
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (payload.title.data.result.length) {
                            vm.loading = false;
                            vm.totalOngoingBookings = payload.title.data.totalCount;
                            vm.dataLength = payload.title.data.totalCount;

                            if (payload.title.data.totalCount == 0) {
                                vm.sp_pagination = false;
                                vm.tBodyFlag = false;
                                vm.tFootFlag = true;
                                vm.filterOn = true;
                                vm.skipValueFilter = 0;
                            } else {
                                vm.sp_pagination = true;
                                vm.tBodyFlag = true;
                                vm.tFootFlag = false;
                                vm.filterOn = false;
                                vm.skipValueFilter = 0;

                                var dataArray = [];
                                var ongoingBookingsList = payload.title.data.result;
                                ongoingBookingsList.forEach(function (column) {
                                    var d = {};
                                    d.job_id = column.job_id;
                                    d.job_status = column.job_status;
                                    d.created_by = column.created_by;
                                    d.booking_for = column.booking_for; //0 owner, 1- other
                                    d.is_vip = column.is_VIP;
                                    //d.job_pickup_datetime = changeDateFormat(column.job_pickup_datetime);
                                    d.job_pickup_name = column.job_pickup_name;
                                    d.job_pickup_phone = column.job_pickup_phone;
                                    d.job_pickup_email = column.job_pickup_email;
                                    d.job_pickup_address = column.job_pickup_address;
                                    d.job_address = column.job_address; //destination
                                    d.number_of_passangers = column.number_of_passangers;
                                    d.creation_datetime = column.creation_datetime;
                                    d.fleet_id = column.fleet_id;
                                    d.job_time_utc = column.job_time_utc; //actual start time
                                    d.job_time = column.job_time_utc; //actual start time
                                    d.job_time_filtered = $filter('date')(column.job_time_utc, "MMM d, yyyy HH:mm'"); //actual start time
                                    if (new Date(column.job_time_utc).getDate() == new Date().getDate() && new Date(column.job_time_utc).getMonth() == new Date().getMonth() && new Date(column.job_time_utc).getFullYear() == new Date().getFullYear()) {
                                        d.dateFlagForShow = true;
                                    } else {
                                        d.dateFlagForShow = false;
                                    }
                                    d.transport_details = column.transport_details; //CAR number
                                    d.fleet_first_name = column.fleet_first_name;
                                    d.fleet_last_name = column.fleet_last_name;
                                    d.fleet_country_code = column.fleet_country_code;
                                    d.fleet_phone_number = column.fleet_phone_number;
                                    d.customer_first_name = column.customer_first_name;
                                    d.customer_last_name = column.customer_last_name;
                                    d.customer_country_code = column.customer_country_code;
                                    d.customer_phone_number = column.customer_phone_number;
                                    d.is_round_trip = column.is_round_trip;
                                    d.return_date_time_utc = column.return_date_time;
                                    d.return_date_time = column.return_date_time_utc;
                                    d.round_trip_parent_job_id = column.round_trip_parent_job_id;
                                    d.auth_required = column.auth_required;
                                    d.auth_of = column.auth_of;
                                    d.is_auth = column.is_auth;
                                    d.etaPickUp = column.eta_pickup;
                                    d.etaDropoff = column.eta;
                                    d.branch = column.branch_name;
                                    d.type_of_service = column.service_name;
                                    d.agreement = column.contract_name;
                                    d.unique_car_id = column.unique_car_id;
                                    d.estimated_payment_cost = column.estimated_payment_cost;
                                    d.type_of_trip = column.type_of_trip;
                                    d.shared_service_id = column.shared_service_id;
                                    d.shared_service_status = column.shared_service_status;
                                    d.booking_type = column.booking_type;
                                    d.locking_id = column.locking_id;
                                    d.locking_name = column.locking_id_name;
                                    d.flight_number = column.flight_number;
                                    d.shift_id = column.shift_id;
                                    d.payment_method = column.payment_method;
                                    d.payment_status = column.payment_status;
                                    d.admin_fullyname = column.admin_fullyname;
                                    d.total_refund_amount = column.total_refund_amount;
                                    d.total_estimated_payment_cost = column.total_estimated_payment_cost;
                                    d.round_trip = column.round_trip;
                                    dataArray.push(d);
                                });
                                vm.ongoingBookingsList = dataArray;

                                // USERTYPE VALUE
                                // 0 - Transvip user
                                // 1 - PET user
                                vm.userType = payload.title.data.user_type || 0;

                                for (var i = 0; i < vm.ongoingBookingsList.length; i++) {
                                    vm.ongoingBookingsList[i].index = (i);
                                }
                                if (vm.dataLength <= vm.itemsPerPageGot) {
                                    vm.sp_pagination = false;
                                } else {
                                    vm.sp_pagination = true;
                                    //vm.pageCount(payload.title.totalCount);
                                }
                                vm.skipValue = vm.ongoingBookingsList[0].index;
                                vm.limitValue = vm.ongoingBookingsList[vm.ongoingBookingsList.length - 1].index;
                                //range();
                            }
                        } else {
                            vm.ongoingBookingsList = [];
                            vm.sp_pagination = false;
                            vm.tBodyFlag = false;
                            vm.tFootFlag = true;
                            vm.filterOn = true;
                            vm.skipValueFilter = 0;
                            vm.totalOngoingBookings = 0;
                            vm.dataLength = 0;
                        }
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    } else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        vm.getAllOngoingBookings((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData,true);
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    //console.log($scope.totalPages);
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        //console.log($scope.currentPage);
        //        vm.currentPage++;
        //        vm.getAllOngoingBookings((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData,true);
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    vm.getAllOngoingBookings((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData,true);
        //};

        function init() {
            vm.getAllOngoingBookings(0, vm.filterData.itemsPerPageSelected, vm.filterData, true);
        };

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            //vm.filterOn = true;
            vm.currentPage = 0;
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            pendingRequests.cancelAll();
            if (vm.filterData.search.length == 0) {
                vm.filterData.search_filter = 0;
                vm.filterData.search_value = '';
                vm.getAllOngoingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                //vm.filterOn = false;
                //vm.watchPagination = true;
                //vm.sp_pagination = true;

            } else {
                vm.filterData.search_filter = 1;
                vm.filterData.search_value = vm.filterData.search;
                //if (vm.filterTextTimeout) $timeout.cancel(vm.filterTextTimeout);
                //vm.filterTextTimeout = $timeout(function(){
                vm.getAllOngoingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                //},500);
            }
        };

        //====================get branch list====================
        // function getBranch() {
        //     // vm.branchList = [];
        //     // vm.branchList = JSON.parse(JSON.stringify(getFilters.branchesFiltersData.data));
        //     // vm.branchList.push({
        //     //     region_name: 'Todos',
        //     //     region_id: 'all'
        //     // });

        //     //vm.loading = true;
        //     var promise = getGeofence.branch();
        //     promise.then(
        //         function (payload) {
        //             $log.log(payload);
        //             //vm.loading = false;
        //             if (payload.title.status == 400) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //             } else if (payload.title.status == 401) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //             } else if (payload.title.status == 201 || payload.title.status == 200) {
        //                 var where = _.where(payload.title.data, {
        //                     parent_id: 0
        //                 });
        //                 //vm.branchList = _.where(where, { is_active: 1 });
        //                 vm.branchList = where;

        //                 vm.branchList.push({
        //                     region_name: 'Todos',
        //                     region_id: 'all'
        //                 });
        //             }
        //         },
        //         function (errorPayload) {
        //             $log.log(errorPayload);
        //             vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // }
        // getBranch();
        //======================get all vehicles==============
        // function getAllVehicles(skip, limt, filter) {
        //     // vm.vehicle = [];
        //     // angular.forEach(getFilters.vehiclesFiltersData.data, function (column) {
        //     //     vm.vehicle.push({
        //     //         id: column.id,
        //     //         name: column.name
        //     //     })
        //     // });
        //     // vm.vehicle.push({
        //     //     id: 'all',
        //     //     name: 'Todos'
        //     // });
        //     vm.loading = false;
        //     var promise = getVehicles.allVehicles(skip, limt, filter);
        //     promise.then(
        //         function (payload) {
        //             $log.log('sxdsads', payload);
        //             //vm.loading = false;
        //             if (payload.title.status == 400) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //             } else if (payload.title.status == 401) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //             } else if (payload.title.status == 201 || payload.title.status == 200) {
        //                 vm.vehicle = [];
        //                 angular.forEach(payload.title.data.result, function (column) {
        //                     vm.vehicle.push({
        //                         id: column.id,
        //                         name: column.name
        //                     })
        //                 });
        //                 vm.vehicle.push({
        //                     id: 'all',
        //                     name: 'Todos'
        //                 });
        //             }
        //         },
        //         function (errorPayload) {
        //             $log.log(errorPayload);
        //             //vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // };
        // // WHen Page refresh service take time to get data from backend
        // // setTimeout(function () {
        // getAllVehicles(0, 0, 2);
        // }, 1000);
        //======================get all services==============
        // function getAllServices(skip, limit) {
        //     // vm.service = [];
        //     // angular.forEach(getFilters.servicesFiltersData.data, function (column) {
        //     // vm.service.push({
        //     // id: column.id,
        //     // name: column.service_name
        //     // });
        //     // });
        //     // vm.service.push({
        //     // id: 'all',
        //     // name: 'All'
        //     // })

        //     vm.loading = false;
        //     var promise = getServices.allServices(skip, limit, 2, 0);
        //     promise.then(
        //         function (payload) {
        //             $log.log('sxdsads', payload);
        //             //vm.loading = false;
        //             if (payload.title.status == 400) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //             } else if (payload.title.status == 401) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //             } else if (payload.title.status == 201 || payload.title.status == 200) {
        //                 vm.service = [];
        //                 angular.forEach(payload.title.data.result, function (column) {
        //                     vm.service.push({
        //                         id: column.id,
        //                         name: column.service_name
        //                     });
        //                 });
        //                 vm.service.push({
        //                     id: 'all',
        //                     name: 'All'
        //                 })
        //             }
        //         },
        //         function (errorPayload) {
        //             $log.log(errorPayload);
        //             vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // };
        // // WHen Page refresh service take time to get data from backend
        // // setTimeout(function () {
        // getAllServices(0, 0);
        // }, 1000);
        //======================get all services==============
        // function getAllAgreement(skip, limt) {
        //     var dataSend = {};
        //     dataSend.access_token = $cookies.get('obj');
        //     dataSend.offset = skip;
        //     dataSend.limit = limt;
        //     dataSend.key = 3;
        //     //vm.loading = false;
        //     var promise = getAgreement.getAgreementListLessData(dataSend);
        //     promise.then(
        //         function (payload) {
        //             $log.log('sxdsads', payload);
        //             //vm.loading = false;
        //             if (payload.title.status == 400) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //             } else if (payload.title.status == 401) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //             } else if (payload.title.status == 201 || payload.title.status == 200) {
        //                 vm.agreement = [];
        //                 angular.forEach(payload.title.data, function (column) {
        //                     vm.agreement.push({
        //                         id: column.id,
        //                         name: column.name
        //                     });
        //                 });
        //                 vm.agreement.push({
        //                     id: 'all',
        //                     name: 'Todos'
        //                 });
        //             }
        //         },
        //         function (errorPayload) {
        //             $log.log(errorPayload);
        //             //vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // };
        // getAllAgreement(0, 0);

        //=================filter change functions=================
        function branchChanged() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (vm.filterData.branch && vm.filterData.branch != 'all') {
                vm.filterData.branch_filter = 1;
                // getAllOngoingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // vm.agreement = [];
                // vm.branchList = [];
                // vm.vehicle = [];
                // vm.service = [];
                // clearOffset();
                // getFilterDataFromBackend();
            } else {
                vm.filterData.branch_filter = 0;
                vm.filterData.branch = 'all';
                // getAllOngoingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // vm.agreement = [];
                // vm.branchList = [];
                // vm.vehicle = [];
                // vm.service = [];
                // clearOffset();
                // getFilterDataFromBackend();
            }
        };

        function agreementChanged() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (vm.filterData.agreement && vm.filterData.agreement != 'all') {
                vm.filterData.aggrement_filter = 1;
                // getAllOngoingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // vm.agreement = [];
                // vm.branchList = [];
                // vm.vehicle = [];
                // vm.service = [];
                // clearOffset();
                // getFilterDataFromBackend();
            } else {
                vm.filterData.aggrement_filter = 0;
                vm.filterData.agreement = 'all';
                // getAllOngoingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // vm.agreement = [];
                // vm.branchList = [];
                // vm.vehicle = [];
                // vm.service = [];
                // clearOffset();
                // getFilterDataFromBackend();
            }
        };

        function serviceChanged() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (vm.filterData.service && vm.filterData.service != 'all') {
                vm.filterData.service_filter = 1;
                // getAllOngoingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // vm.agreement = [];
                // vm.branchList = [];
                // vm.vehicle = [];
                // clearOffset();
                // vm.service = [];
                // getFilterDataFromBackend();
            } else {
                vm.filterData.service_filter = 0;
                vm.filterData.service = 'all';
                // getAllOngoingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // vm.agreement = [];
                // vm.branchList = [];
                // vm.vehicle = [];
                // vm.service = [];
                // clearOffset();
                // getFilterDataFromBackend();
            }
        };

        function vehicleChanged() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (vm.filterData.vehicle && vm.filterData.vehicle != 'all') {
                vm.filterData.vehicle_filter = 1;
                // getAllOngoingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // vm.agreement = [];
                // vm.branchList = [];
                // vm.vehicle = [];
                // clearOffset();
                // vm.service = [];
                // getFilterDataFromBackend();
            } else {
                vm.filterData.vehicle_filter = 0;
                vm.filterData.vehicle = 'all';
                // getAllOngoingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // vm.agreement = [];
                // vm.branchList = [];
                // vm.vehicle = [];
                // clearOffset();
                // vm.service = [];
                // getFilterDataFromBackend();
            }
        };

        function typeTripChanged() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (vm.filterData.type_of_trip && vm.filterData.type_of_trip != 'all') {
                vm.filterData.type_of_trip_filter = 1;
                // getAllOngoingBookings(0, vm.itemsPerPageGot, vm.filterData, true);

            } else {
                vm.filterData.type_of_trip_filter = 0;
                vm.filterData.type_of_trip = 'all';
                // getAllOngoingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
            }
        };

        //function pickupDateChanged(){
        //    vm.currentPage = 0;
        //    console.log(vm.filterData.filter_pickup_date_value);
        //    if(vm.filterData.filter_pickup_date_value){
        //        vm.filterData.date_time_filter = 1;
        //        getAllOngoingBookings(0,vm.itemsPerPageGot,vm.filterData);
        //    }
        //    else{
        //        vm.filterData.date_time_filter = 0;
        //        vm.filterData.filter_pickup_date_value = '';
        //        getAllOngoingBookings(0,vm.itemsPerPageGot,vm.filterData);
        //    }
        //};
        //
        //function pickupTimeChanged(){
        //    vm.currentPage = 0;
        //    console.log(vm.filterData.filter_pickup_time_value);
        //    if(vm.filterData.filter_pickup_time_value && vm.filterData.filter_pickup_date_value){
        //        vm.filterData.date_time_filter = 1;
        //        getAllOngoingBookings(0,vm.itemsPerPageGot,vm.filterData);
        //    }
        //    else if(vm.filterData.filter_pickup_date_value){
        //        vm.filterData.date_time_filter = 1;
        //        //vm.filterData.filter_pickup_time_value = '';
        //        //if(vm.filterData.filter_pickup_date_value)
        //        getAllOngoingBookings(0,vm.itemsPerPageGot,vm.filterData);
        //    }
        //    else{
        //        vm.filterData.date_time_filter = 0;
        //        //vm.filterData.filter_pickup_time_value = '';
        //        //if(vm.filterData.filter_pickup_date_value)
        //            getAllOngoingBookings(0,vm.itemsPerPageGot,vm.filterData);
        //    }
        //};

        function resetFilter() {
            vm.currentPage = 0;
            vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            vm.filterData = {
                branch_filter: 0, //0, 1
                service_filter: 0, //0, 1
                vehicle_filter: 0, //0, 1
                aggrement_filter: 0, //0, 1
                //date_time_filter : 0,  //0, 1
                type_of_trip_filter: 0, //0, 1
                branch: 'all',
                service: 'all',
                vehicle: 'all',
                //date_time_value: '',
                agreement: 'all',
                // type_of_trip: 'From Airport',
                filter_pickup_date_value: '',
                filter_pickup_time_value: new Date(),
                limit: vm.itemsPerPageGot,
                offset: 0,
                booking_status: 1,
                search: '',
                searchBookingId: '',
                searchPackageId: '',
                agreementSearch: '',
                agreementValue: 0,
                searchByName: 0,
                itemsPerPageSelected: 25,
                filter_pickup_from_date_value: getFirstDateOfPreviousMonth(),
                filter_pickup_to_date_value: setToPickupDate(),
                filter_pickup_from_time_value: showFilterTime(1),
                filter_pickup_to_time_value: showFilterTime(2),
            };
            vm.dateOptions = {
                //dateDisabled: disabled,
                formatYear: 'yy',
                // maxDate: new Date(),
                // minDate: new Date(vm.filterData.filter_pickup_from_date_value),
                startingDay: 1,
                showWeeks: false,

            };
            getAllOngoingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
        }

        function applyFilter(){
            vm.getAllOngoingBookings(0, vm.filterData.itemsPerPageSelected, vm.filterData, true);
        }

        //===================get ALL no show reasons=========================
        function getAllNoShowReasonHit() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = 0;
            dataSend.offset = 0;
            dataSend.status = 0;

            var promise = getNoShowReason.getNoShowReasonList(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    //vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.noShowReason = payload.title.data.result;
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        getAllNoShowReasonHit();

        //=============================mark no show============================
        function markNoShow(data, $event) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.job_id = data.job_id;
            vm.loading = true;
            var promise = getBookings.getNoShowData(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    markNoShowPopup(data, $event, payload.title.data);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        function markNoShowPopup(data, $event, noShowData) {
            vm.noShowitems = {
                job_id: data.job_id,
                jobData: data,
                noShowReasonData: vm.noShowReason,
                noShowData: noShowData,
                description: '',
                reasonSelected: '',
                errorMsg: '',
                loading: false
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/noShowMark.html',
                locals: {
                    items: vm.noShowitems
                },
                bindToController: true,
                controller: NoShowMarkController
            });

            function NoShowMarkController($scope, $mdDialog, items) {
                $scope.noShowitems = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    changeJobStatusOfBooking($scope.noShowitems, 12);
                };
            }
        }

        function getAdminListAccordingToRoleApi() {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.access = 'Autorizar Anulación de Reserva';
            var promise = getBookings.getAdminListAccordingToRole(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    console.log(payload, 'payload');

                    if (payload.title.status == 200) {
                        vm.adminList = payload.title.data;
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        getAdminListAccordingToRoleApi();

        //=========================get cancel reason hit=========================
        function getCancelReasonHit($event, data, jobStatus) {
            vm.loading = true;
            var dataSend = {};
            dataSend.key = 0;
            dataSend.channel = 2;
            dataSend.payment_method = data.payment_method;
            var promise = getCancelReason.getCancelReasonList(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.data && payload.title.data.length) {
                        vm.cancelReasonList = payload.title.data;
                    } else {
                        vm.cancelReasonList = [];
                    }
                    openCancelPopup($event, data, jobStatus, vm.cancelReasonList);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };


        function openCancelPopup($event, data, jobStatus, cancelList) {
            var popUpToOpen = '';
            vm.cancelPopItems = {
                jobData: data,
                job_id: data.job_id,
                cancelReasonList: cancelList,
                reasonSelected: '',
                jobStatus: jobStatus,
                adminList: vm.adminList,
                cancellation_description: '',
                flagForConfirm: false,
                flagForValidateButton: false,
                message: '',
                password: '',
                authorize_id: null,
                RequiredMessage: '',
                RequiredMessageEmail: ''
            };
            var currentShiftId = $cookies.get('saleShiftId');
            console.log(data.shift_id, currentShiftId);

            if (data.shift_id != null && currentShiftId != undefined && data.shift_id == currentShiftId) {
                if (cancelList[0].payment_data.is_refund == 1) {
                    if (data.payment_status == 1) {
                        vm.openHit = true;
                        popUpToOpen = 'app/components/dialogViews/cancelBookingPopUpNew.html';
                    }
                } else {
                    vm.openHit = false;
                    popUpToOpen = 'app/components/dialogViews/cancelBookingPopUp.html';
                }
            } else if (data.shift_id != null && currentShiftId != undefined && data.shift_id != currentShiftId) {
                if (cancelList[0].payment_data.is_refund == 1) {
                    if (data.payment_status == 1) {
                        vm.openHit = true;
                        vm.cancelPopItems.flagForConfirm = true;
                        popUpToOpen = 'app/components/dialogViews/cancelBookingPopUpAuthorization.html';
                    }
                } else {
                    vm.openHit = false;
                    popUpToOpen = 'app/components/dialogViews/cancelBookingPopUp.html';
                }
            } else {
                vm.openHit = false;
                popUpToOpen = 'app/components/dialogViews/cancelBookingPopUp.html';
            }

            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: popUpToOpen,
                locals: {
                    items: vm.cancelPopItems
                },
                bindToController: true,
                controller: CancelMarkController
            });

            function CancelMarkController($scope, $mdDialog, items) {
                $scope.cancelPopItems = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    changeJobStatusOfBooking($scope.cancelPopItems, jobStatus);
                };
                $scope.validatorAutorizator = function () {
                    if ($scope.cancelPopItems.password == '' || $scope.cancelPopItems.password == undefined || $scope.cancelPopItems.password == null) {
                        $scope.cancelPopItems.RequiredMessage = 'This feild is required'
                        $timeout(function () {
                            $scope.cancelPopItems.RequiredMessage = '';
                        }, 2000)
                    }
                    if ($scope.cancelPopItems.email == '' || $scope.cancelPopItems.email == undefined ||
                        $scope.cancelPopItems.email == null) {
                        $scope.cancelPopItems.RequiredMessageEmail = 'This feild is required'
                        $timeout(function () {
                            $scope.cancelPopItems.RequiredMessageEmail = '';
                        }, 2000)
                    }
                    if ($scope.cancelPopItems.email == '' || $scope.cancelPopItems.password == '' || $scope.cancelPopItems.email == undefined ||
                        $scope.cancelPopItems.email == null || $scope.cancelPopItems.password == undefined || $scope.cancelPopItems.password == null) {
                        return true;
                    }
                    // vm.loading = true;
                    var dataSend = {};
                    dataSend.email = $scope.cancelPopItems.email;
                    dataSend.password = $scope.cancelPopItems.password;
                    var promise = getBookings.validatePassword(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log(payload);
                            // vm.loading = false;
                            if (payload.title.status == 200) {
                                $scope.cancelPopItems.flagForConfirm = false;
                                $scope.cancelPopItems.flagForValidateButton = true;
                                $scope.cancelPopItems.message = '';
                                $scope.cancelPopItems.RequiredMessage = '';
                                $scope.cancelPopItems.RequiredMessageEmail = '';
                                $scope.cancelPopItems.authorize_id = payload.title.data[0].admin_id;
                            } else {
                                $scope.cancelPopItems.message = payload.title.message;
                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }
            }
        }

        //=============================mark no show============================
        function makeBookingStatusChange(data, $event, type) {
            var msg = '';
            var jobStatus = '';
            if (type == 'arrived') {
                msg = languageBasedErrorFactory.getProperErrorMessage('arrivedMessage', 0, '3');
                jobStatus = 4;
            } else if (type == 'started') {
                msg = languageBasedErrorFactory.getProperErrorMessage('tripStartedMessage', 0, '3');
                jobStatus = 1;
            } else if (type == 'completed') {
                msg = languageBasedErrorFactory.getProperErrorMessage('completedMessage', 0, '3');
                jobStatus = 2;
            } else if (type == 'cancel') {
                if (data.locking_id) {
                    if (data.booking_type == 1 || data.booking_type == '1') {
                        var msg = 'La reserva está bloqueada por usuario' + ' ' + data.locking_name + ' ' + 'para la creación o modificación del paquete';
                        // var msg = 'La reserva no se puede cancelar porque se está convirtiendo en parte del nuevo servicio compartido ya enrutado. Puede crear uno nuevo o solicitar que se elimine del servicio compartido enrutado y luego cancelarlo';
                    } else if (data.booking_type == 2 || data.booking_type == '2') {
                        var msg = 'La reserva está bloqueada por usuario' + ' ' + data.locking_name + ' ' + 'para la creación o modificación del paquete';
                        // var msg = 'La reserva no se puede cancelar porque se está convirtiendo en parte del nuevo servicio agrupado ya enrutado. Puede crear uno nuevo o solicitar que se elimine del servicio agrupado y luego cancelarlo';
                    }
                    errorMessageFactory.showErrorMessage(msg, 0);
                    return;
                } else {
                    //msg = languageBasedErrorFactory.getProperErrorMessage('cancelledMessage',0,'3');
                    jobStatus = 9;
                    getCancelReasonHit($event, data, jobStatus);
                    return;
                }
            } else {
                msg = languageBasedErrorFactory.getProperErrorMessage('noShowPop', 0, '3');
                jobStatus = 12;
            }
            var confirm = $mdDialog.confirm()
                .title(msg)
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                changeJobStatusOfBooking(data, jobStatus);
            }, function () {
                $log.log('not confirmed');
            });
        };

        var timezone = moment.tz.guess();
        console.log(moment().tz(timezone).format(), moment().tz(timezone).format("YYYY-MM-DD HH:mm ZZ"));

        function changeJobStatusOfBooking(data, jobStatus) {
            var timezone = moment.tz.guess();
            console.log(moment().tz(timezone).format());

            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.job_id = data.job_id;
            dataSend.job_status = jobStatus;
            if (jobStatus == 2) {

            }
            if (jobStatus == 12) {
                dataSend.noshow_reason = data.reasonSelected;
                dataSend.noshow_comment = data.description;
            }
            if (jobStatus == 9) {
                dataSend.cancellation_reason = data.reasonSelected.reason;
                dataSend.cancellation_reason_id = data.reasonSelected.reason_id;
                dataSend.cancellation_description = data.cancellation_description;
                if (data.cancelReasonList[0].payment_data.is_refund == 1 || data.cancelReasonList[0].payment_data.is_refund == 0) {
                    dataSend.cancellation_method_id = data.cancelReasonList[0].payment_data.refund_payment_id;
                    dataSend.cancellation_payment_amount = data.jobData.round_trip ? data.jobData.total_refund_amount : data.jobData.estimated_payment_cost;
                    if (($cookies.get('saleShiftId')) != undefined || ($cookies.get('saleShiftId')) != null)
                        console.log(Number($cookies.get('saleShiftId')), 'shidt id');

                    dataSend.cancellation_shift_id = Number($cookies.get('saleShiftId'));
                }
                if (data.authorize_id)
                    dataSend.authorize_id = data.authorize_id;
            }
            vm.loading = true;
            var promise = getBookings.changeJobStatus(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    // languageBasedErrorFactory.getProperErrorMessage('noShowSucc', 0, 0)
                    if (payload.title.status == 200) {
                        if (vm.openHit)
                            getThermalPrintHeightCancel(data);
                        else errorMessageFactory.showErrorMessage('Estado cambiado exitosamente', 1);
                        if (vm.filterData.searchBookingId) {
                            getFilterBookingId(vm.filterData.searchBookingId);
                        } else if (vm.filterData.searchPackageId) {
                            getFilterBookingId(vm.filterData.searchPackageId);
                        }
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    //errorMessageFactory.showErrorMessage('Job status changed successfully.',1);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        if (jobStatus == 12) {
                            data.errorMsg = errorPayload.data.message;
                            $timeout(function () {
                                data.errorMsg = '';
                            }, 3000);
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                }
            );
        }
        /// print pop for cancel popUp
        function getThermalPrintHeightCancel(data) {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.job_id = data.jobData.job_id;
            var promise = getBookings.getCancelThermalPrint(dataSend);
            promise.then(function (payload) {
                    $log.log('sxdsads', payload);
                    console.log(payload, 'booking pdf');
                    if (payload.title.status == 200) {
                        document.getElementById('cancelPrint').innerHTML = payload.title.data;
                        setTimeout(function () {
                            document.querySelector('table.mainHeader-3').style.width = '100%';
                            document.querySelector('table.mainHeader-2').style.width = '100%';
                        }, 500);
                        $timeout(function () {
                            getThermalPrintCancel(data, payload.title.data);
                        }, 100);
                    } else {
                        vm.loading = false;
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function getThermalPrintCancel(data, payload) {
            $log.log(data);
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.job_id = Number(data.jobData.job_id);
            dataSend.timezone = new Date().getTimezoneOffset();
            dataSend.height = $('#cancelPrint').height() + 200;
            dataSend.variableDetailsThermal = payload;
            vm.loading = true;
            var promise = getBookings.printReceipt(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;

                    function PrintDiv() {
                        var contents = document.getElementById("cancelPrint").innerHTML;
                        var frame1 = document.createElement('iframe');
                        frame1.name = "frame1";
                        // frame1.value = "frame12"
                        frame1.style.position = "absolute";
                        frame1.style.top = "-1000000px";
                        document.body.appendChild(frame1);
                        var frameDoc = frame1.contentWindow ? frame1.contentWindow : frame1.contentDocument.document ? frame1.contentDocument.document : frame1.contentDocument;
                        frameDoc.document.open();
                        // frameDoc.document
                        frameDoc.document.write();
                        frameDoc.document.write();
                        frameDoc.document.write(contents);
                        frameDoc.document.write();
                        frameDoc.document.close();
                        // setTimeout(function () {
                        //     window.frames["frame1"].focus();
                        //     window.frames["frame1"].print();
                        //     document.body.removeChild(frame1);
                        //     if (vm.printCount == 0) {
                        //         getPrintReceiptHeight(vm.secondPrint, 'SecondPrint');
                        //         vm.printCount++;
                        //     }
                        // }, 500);
                        // return false;

                        frame1.onload = function () {
                            // setTimeout(function () {
                            window.frames["frame1"].focus();
                            window.frames["frame1"].print();
                            document.body.removeChild(frame1);
                            // }, 500);
                            return false;
                        };
                        frame1.onerror = function () {
                            errorMessageFactory.showErrorMessage('Please try again', 0);
                            return false;
                        };
                    }
                    PrintDiv();
                    errorMessageFactory.showErrorMessage('Estado cambiado exitosamente', 1);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            )
        }
        //=============================unassign booking==========================
        function manualUnassignBooking(data, $event) {
            if (!vm.unAssignButtonRole) {
                errorMessageFactory.showErrorMessage('No tiene permiso para ejecutar esta opción', 0);
                return;
            }
            if (data.shared_service_id) {
                if (data.booking_type == 1 || data.booking_type == '1') {
                    var msg = 'La reserva no se puede desasignar porque es parte del servicio compartido #' + data.shared_service_id + ' ya enrutado. Puede cancelar la reserva y crear una nueva, o solicitar que se elimine del servicio compartido enrutado y luego anular la asignación.';
                } else if (data.booking_type == 2 || data.booking_type == '2') {
                    var msg = 'La reserva no se puede cancelar debido a que forma parte del servicio agrupado #' + data.shared_service_id + ' ya creado. Puede cancelar la reserva y crear una nueva, o solicitar que se elimine del servicio agrupado y luego desasignarla';
                }
                errorMessageFactory.showErrorMessage(msg, 0);
                return;
            }

            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('unassginPop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.job_id = Number(data.job_id);
                vm.loading = false;
                var promise = getBookings.unassignBookingDriver(dataSend);
                promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        if (payload.title.status == 200) {
                            languageBasedErrorFactory.getProperErrorMessage('unassginSucc', 0, 0)
                            if (vm.filterData.searchBookingId) {
                                getFilterBookingId(vm.filterData.searchBookingId);
                            } else if (vm.filterData.searchPackageId) {
                                getFilterBookingId(vm.filterData.searchPackageId);
                            } else {
                                getAllOngoingBookings(vm.currentPage > 0 ? vm.currentPage - 1 * vm.itemsPerPageGot : 0, vm.itemsPerPageGot, vm.filterData, true);
                            }
                        } else {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        }

        //===================side bar filters=====================
        vm.showFilterArea = showFilterArea;
        vm.branchChangedFilter = branchChangedFilter;
        vm.vehicleChangedFilter = vehicleChangedFilter;
        vm.serviceChangedFilter = serviceChangedFilter;
        vm.agreementChangedFilter = agreementChangedFilter;
        vm.removeFilter = removeFilter;
        vm.typeTripChangedFilter = typeTripChangedFilter;
        vm.showFilterFlag = false;

        vm.filterWhichToShow = {
            branchWithDashboard: false,
            service: true,
            vehicle: true,
            agreement: true,
            operation: false,
            helpTraffic: false,
            virtualFleet: false,
            approvalStage: false,
            vehicleAssigned: false,
            applicantType: false,
            modelity: false,
            tripType: true
        };

        function removeFilter() {
            $state.reload('layout.ongoingBookingsMain.ongoingBookings');
        }

        function showFilterArea() {
            vm.showFilterFlag = !vm.showFilterFlag;
        }

        function branchChangedFilter(data) {
            vm.branchChanged();
        }

        function vehicleChangedFilter(data) {
            vm.vehicleChanged();
        }

        function serviceChangedFilter(data) {
            vm.serviceChanged();
        }

        function agreementChangedFilter(data) {
            vm.agreementChanged();
        }

        function typeTripChangedFilter(data) {
            vm.typeTripChanged();
        }

        function bookingStatusChange() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            // getAllOngoingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
        }

        // ****** FUNCTION FOR AGREEMENT FILTER ********
        function getFilterForAgreement() {
            //vm.filterOn = true;
            vm.currentPage = 0;
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            pendingRequests.cancelAll();
            if (vm.filterData.agreementSearch.length == 0) {
                vm.filterData.agreementValue = 0;
                vm.filterData.agreementSearch = '';
                // getAllOngoingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                //vm.filterOn = false;
                //vm.watchPagination = true;
                //vm.sp_pagination = true;

            } else {
                vm.filterData.agreementValue = 1;
                vm.filterData.agreementSearch = vm.filterData.agreementSearch;
                //if (vm.filterTextTimeout) $timeout.cancel(vm.filterTextTimeout);
                //vm.filterTextTimeout = $timeout(function(){
                // getAllOngoingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                //},500);

            }
        };


        // ****** FUNCTION FOR SEARCH BY NAME FILTER ********
        function getFilterForSearchByNameFilter() {
            //vm.filterOn = true;
            vm.currentPage = 0;
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            pendingRequests.cancelAll();
            if (vm.filterData.searchByNameFilter.length == 0) {
                vm.filterData.searchByNameFilterValue = 0;
                vm.filterData.searchByNameFilter = '';
                // getAllOngoingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                //vm.filterOn = false;
                //vm.watchPagination = true;
                //vm.sp_pagination = true;

            } else {
                vm.filterData.searchByNameFilterValue = 1;
                vm.filterData.searchByNameFilter = vm.filterData.searchByNameFilter;
                //if (vm.filterTextTimeout) $timeout.cancel(vm.filterTextTimeout);
                //vm.filterTextTimeout = $timeout(function(){
                // getAllOngoingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                //},500);

            }
        };

        function searchByNameRadioButtonChange() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            // getAllOngoingBookings(0, vm.itemsPerPageGot, vm.filterData, true);
        }

        function changeDateIntoSpanish(date) {
            var options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            };
            return new Date(date).toLocaleString($cookies.get('language') == 'spanish' ? 'es' : 'en', options)
        }


        function verifyAssignButton(data) {
            vm.loading = true;
            var promise = adminAccessService.checkStateValid(data); //$stateParams.id
            return promise.then(
                function (payload) {
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (data == 'Asignar Manualmente') {
                            if (!payload.title.data.granted) {
                                vm.unAssignButtonRole = false;
                                // errorMessageFactory.showErrorMessage('No está autorizado para usar esta opción', 0);
                                //errorMessageFactory.showErrorMessage('Option not available because you not have the right',0);
                                return false;
                            } else {
                                vm.loading = false;
                                vm.unAssignButtonRole = true;
                            }
                        }
                    }
                },
                function (errorPayload) {
                    console.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        verifyAssignButton('Asignar Manualmente');

    }

})();

/**
 * Created by cl-macmini-51 on 5/2/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('CompletedBookingsController', CompletedBookingsController);

    /** @ngInject */
    function CompletedBookingsController($cookies, $state, $log, $rootScope, $filter, $mdDialog, $timeout, $document, $scope, filterFilter, getBookings, getGeofence,
        getAgreement, getServices, getVehicles, errorMessageFactory, languageBasedErrorFactory, moment, pendingRequests, checkDomain, getFilters) {
        var vm = this;
        $log.log('completedBookings');
        vm.applyFilter = applyFilter;
        vm.loading = false;
        vm.currentPage = 0;
        vm.totalCompletedBookings = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.filterTextTimeout = '';
        vm.getAllCompletedBookings = getAllCompletedBookings;
        vm.textChangeIntoSpanishForDate = textChangeIntoSpanishForDate;
        vm.changeDateIntoSpanish = changeDateIntoSpanish;
        vm.getPagesCount = getPagesCount;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.searchBookingField = true;
        var domain = checkDomain.getDomainName();
        if (domain != 'dev' && domain != 'test') {
            vm.searchBookingField = false;
        }
        vm.init = init;
        vm.sort = sort;
        vm.getFilter = getFilter;

        vm.getFilterForAgreement = getFilterForAgreement;
        vm.getFilterForSearchByNameFilter = getFilterForSearchByNameFilter;
        vm.searchByNameRadioButtonChange = searchByNameRadioButtonChange;

        vm.datePickerE_1 = datePickerE_1;
        vm.branchChanged = branchChanged;
        vm.agreementChanged = agreementChanged;
        vm.serviceChanged = serviceChanged;
        vm.vehicleChanged = vehicleChanged;
        vm.resetFilter = resetFilter;
        vm.getFilterBookingId = getFilterBookingId;
        vm.typeTripChanged = typeTripChanged;
        vm.slideData = slideData;
        vm.pickupFromToDateChanged = pickupFromToDateChanged;
        vm.pickupFromToTimeChanged = pickupFromToTimeChanged;
        vm.paginationNew = paginationNew;
        vm.bookingDetails = bookingDetails;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings(runThis);
        vm.countToSocket = 0;
        vm.dateOptions = {};
        vm.datePicker_1 = {
            pickupFromDate: false,
            pickupToDate: false,
        };

        vm.bookingStatusChange = bookingStatusChange;
        vm.stateOfBookingArray = [{
                name: 'Todos',
                id: -1
            },
            {
                name: 'Ended',
                id: 2
            },
            {
                name: 'Failed',
                id: 3
            },
            {
                name: 'Cancel',
                id: 9
            },
            {
                name: 'No Show',
                id: 12
            }
        ]

        vm.altInputFormats = ['M!/d!/yyyy'];
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.predicate = 'index';
        vm.reverse = false;
        vm.hstep = 1;
        vm.mstep = 15;
        vm.ismeridian = true;
        vm.searchModel = {
            limit: 25,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
        vm.filterData = {
            branch_filter: 0, //0, 1
            service_filter: 0, //0, 1
            vehicle_filter: 0, //0, 1
            aggrement_filter: 0, //0, 1
            date_time_filter: 1, //0, 1
            branch: 'all',
            service: 'all',
            vehicle: 'all',
            date_time_value1: '',
            date_time_value2: '',
            agreement: 'all',
            // type_of_trip: 'all',
            type_of_trip_filter: 0,
            agreementSearch: '',
            agreementValue: 0,
            searchByName: 0,
            filter_pickup_from_date_value: getFirstDateOfPreviousMonth(),
            filter_pickup_from_time_value: showFilterTime(1),
            filter_pickup_to_date_value: new Date(),
            filter_pickup_to_time_value: showFilterTime(2),
            limit: vm.itemsPerPageGot,
            offset: 0,
            booking_status: 2,
            search_filter: 0,
            search_value: '',
            search: '',
            searchBookingId: '',
            searchPackageId: '',
            itemsPerPageSelected: 25
        };

        vm.paginationChangedForService = paginationChangedForService;
        vm.paginationChangedForVehicle = paginationChangedForVehicle;
        vm.paginationChangedForBranch = paginationChangedForBranch;
        vm.paginationChangedForAgreement = paginationChangedForAgreement;
        vm.vehicleSearch = vehicleSearch;
        vm.serviceSearch = serviceSearch;
        vm.branchSearch = branchSearch;
        vm.agreementSearch = agreementSearch;
        vm.globalLimit = 1000;
        vm.globalOffset = vm.globalLimit;

        vm.service = [];
        vm.service.push({
            id: 'all',
            name: 'Todos'
        })

        vm.vehicle = [];
        vm.vehicle.push({
            id: 'all',
            name: 'Todos'
        });

        vm.branchList = [];
        vm.branchList.push({
            region_name: 'Todos',
            region_id: 'all'
        });

        vm.agreement = [];
        vm.agreement.push({
            id: 'all',
            name: 'Todos'
        });

        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'vehicle', 'service', 'agreement', 'corporatesList', 'operation_point'];

        vm.serviceOffset = 0;
        vm.branchOffset = 0;
        vm.vehicleOffset = 0;
        vm.agreementOffset = 0;
        // ********** INSERT INTO ARRAY **********
        Array.prototype.insert = function (index, item) {
            this.splice(index, 0, item);
        };
        // =================== FILTER OBJECT ===================
        vm.filterObject = {
            access_token: $cookies.get('obj'),
            branch_filter: 1,
            vehicle_filter: 1,
            service_filter: 1,
            agreement_filter: 1,
            corporate_filter: 0,
            service_category: 0,
            corporate_status: 0,
            agreement_status: 2,
            vehicle__status: 2,
            operation_point_filter: 0,
            service_limit: vm.globalLimit,
            service_offset: vm.serviceOffset,
            branch_limit: vm.globalLimit,
            branch_offset: vm.branchOffset,
            vehicle_limit: vm.globalLimit,
            vehicle_offset: vm.vehicleOffset,
            agreement_limit: vm.globalLimit,
            agreement_offset: vm.agreementOffset,
            branch_search_filter: 0,
            vehicle_search_filter: 0,
            service_search_filter: 0,
            agreement_search_filter: 0,
            corporate_search_filter: 0,
            operation_point_search_filter: 0
        }

        setTimeout(function () {
            document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                // if (vm.branchList && (vm.branchList.length == 0)) {
                vm.searchBranchData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });


            document.getElementsByClassName('ui-select-search')[1].addEventListener('blur', function ($event) {
                // if (vm.agreement && (vm.agreement.length == 0)) {
                vm.searchAgreementData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

            document.getElementsByClassName('ui-select-search')[2].addEventListener('blur', function ($event) {
                // if (vm.service && (vm.service.length == 0)) {
                vm.searchServiceData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

            document.getElementsByClassName('ui-select-search')[3].addEventListener('blur', function ($event) {
                // if (vm.vehicle && (vm.vehicle.length == 0)) {
                vm.searchVehicleData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });




        })



        function clearOffset() {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                vm[vm.searchFilterArray[i] + 'Offset'] = 0;
            }

        }
        // =================== GET FILTER DATA ===================
        function getFilterDataFromBackend(data, type) { //Acc to Index ['branch_search', 'vehicle_search', 'service_search', 'agreement_search', 'corporate_search', 'operation_point_search']
            if (data) {
                vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
            } else {
                vm.filterObject = {
                    access_token: $cookies.get('obj'),
                    branch_filter: 1,
                    vehicle_filter: 1,
                    service_filter: 1,
                    agreement_filter: 1,
                    corporate_filter: 0,
                    service_category: 0,
                    corporate_status: 0,
                    agreement_status: 2,
                    vehicle__status: 2,
                    operation_point_filter: 0,
                    branch_search_filter: 0,
                    vehicle_search_filter: 0,
                    service_search_filter: 0,
                    agreement_search_filter: 0,
                    corporate_search_filter: 0,
                    operation_point_search_filter: 0
                }
            }

            vm.filterObject.service_limit = vm.globalLimit;
            vm.filterObject.service_offset = vm.serviceOffset;
            vm.filterObject.branch_limit = vm.globalLimit;
            vm.filterObject.branch_offset = vm.branchOffset;
            vm.filterObject.vehicle_limit = vm.globalLimit;
            vm.filterObject.vehicle_offset = vm.vehicleOffset;
            vm.filterObject.agreement_limit = vm.globalLimit;
            vm.filterObject.agreement_offset = vm.agreementOffset;

            var promise = getFilters.getAllFilterData(vm.filterObject);
            promise.then(
                function (payload) {

                    // ********** BRANCH DATA ********
                    if (payload.title.data.branches) {
                        var index = _.findIndex(vm.branchList, {
                            region_id: 'all'
                        });
                        if (index == -1)
                            vm.branchList.push({
                                region_name: 'Todos',
                                region_id: 'all'
                            });
                        angular.forEach(payload.title.data.branches.data, function (column) {
                            var branchIndex = _.findIndex(vm.branchList, {
                                region_id: column.region_id
                            });
                            if (branchIndex == -1)
                                vm.branchList.push(column)
                        });
                        vm.branchTotalBackendCount = payload.title.data.branches.totalCount;
                    }

                    // ********** VEHICLE DATA ********
                    if (payload.title.data.vehicles) {
                        var index = _.findIndex(vm.vehicle, {
                            id: 'all'
                        });
                        if (index == -1)
                            vm.vehicle.push({
                                name: 'Todos',
                                id: 'all'
                            });
                        vm.vehicleTotalBackendCount = payload.title.data.vehicles.totalCount;
                        angular.forEach(payload.title.data.vehicles.data, function (column) {
                            // vm.vehicle.push({
                            //     id: column.id,
                            //     name: column.name
                            // })
                            var vechicleIndex = _.findIndex(vm.vehicle, {
                                id: column.id
                            });
                            if (vechicleIndex == -1)
                                vm.vehicle.push({
                                    id: column.id,
                                    name: column.name
                                })
                        });
                    }

                    // *********** SERVICE DATA *********
                    if (payload.title.data.services) {
                        var index = _.findIndex(vm.service, {
                            id: 'all'
                        });
                        if (index == -1)
                            vm.service.push({
                                name: 'Todos',
                                id: 'all'
                            });
                        vm.serviceTotalBackendCount = payload.title.data.services.totalCount;
                        angular.forEach(payload.title.data.services.data, function (column) {
                            // vm.service.push({
                            //     id: column.id,
                            //     name: column.service_name
                            // });
                            var serviceIndex = _.findIndex(vm.service, {
                                id: column.id
                            });
                            if (serviceIndex == -1)
                                vm.service.push({
                                    id: column.id,
                                    name: column.service_name
                                })
                        });
                    }

                    // *********** AGREEMENT DATA *********
                    if (payload.title.data.agreements) {
                        var index = _.findIndex(vm.agreement, {
                            id: 'all'
                        });
                        if (index == -1)
                            vm.agreement.push({
                                name: 'Todos',
                                id: 'all'
                            });
                        vm.agreementTotalBackendCount = payload.title.data.agreements.totalCount;
                        angular.forEach(payload.title.data.agreements.data, function (column) {
                            // vm.agreement.push({
                            //     id: column.id,
                            //     name: column.name
                            // });
                            var agreementIndex = _.findIndex(vm.agreement, {
                                id: column.id
                            });
                            if (agreementIndex == -1)
                                vm.agreement.push({
                                    id: column.id,
                                    name: column.name
                                })
                        });
                    }

                    vm.loading = false;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        }
        getFilterDataFromBackend();
        // ************ PAGINATION ON SERIVCE **************
        function paginationChangedForService() {
            var index = _.findIndex(vm[vm.searchFilterArray[2]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.serviceTotalBackendCount > (vm.service.length - index)) {
                commonFunction(2);
                vm.serviceOffset += 10;
                getFilterDataFromBackend(vm.searchServiceData, 2);
            }
        }

        // ************ PAGINATION ON VEHICLE **************
        function paginationChangedForVehicle() {
            var index = _.findIndex(vm[vm.searchFilterArray[1]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.vehicleTotalBackendCount > (vm.vehicle.length - index)) {
                commonFunction(1);
                vm.vehicleOffset = vm.vehicleOffset + 10;
                getFilterDataFromBackend(vm.searchVehicleData, 1);
            }
        }

        // ************ PAGINATION ON BRANCH **************
        function paginationChangedForBranch() {
            var index = _.findIndex(vm[vm.searchFilterArray[0]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.branchTotalBackendCount > (vm.branchList.length - index)) {
                commonFunction(0);
                vm.branchOffset += 10;
                getFilterDataFromBackend(vm.searchBranchData, 0);
            }
        }

        // ************ PAGINATION ON AGREEMENT **************
        function paginationChangedForAgreement() {
            var index = _.findIndex(vm[vm.searchFilterArray[3]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.agreementTotalBackendCount > (vm.agreement.length - index)) {
                commonFunction(3);
                vm.agreementOffset += vm.globalOffset;
                getFilterDataFromBackend(vm.searchAgreementData, 3);
            }
        }

        // *********** COMMON FUNCTION FOR FILTER PAGINATION AND SEARCHING ***********
        function commonFunction(type, mode) {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                // vm['search' + vm.searchFilterArray[i] + 'Data'] = '';
                if (mode == 'search' || i != type) {
                    vm[vm.searchFilterArrayForClearArray[i]] = [];
                    // vm[vm.searchFilterArrayForClearArray[i]].push({
                    //     id: 'all',
                    //     name: 'Todos'
                    // });
                    vm[vm.searchFilterArray[i] + 'Offset'] = 0;
                    vm['search' + vm.searchFilterArray[i].substring(0, 1).toUpperCase() + vm.searchFilterArray[i].substring(1) + 'Data'] = '';
                }
            }
        }

        // ************ SEARCH VEHICLE ***************
        function vehicleSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchVehicleData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(1, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 1);
                }, 2000);
            }
        }

        // ************ SEARCH SERVICE ***************
        function serviceSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchServiceData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(2, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 2);
                }, 2000);
            }
        }

        // ************ SEARCH BRANCH ***************
        function branchSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchBranchData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(0, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 0);
                }, 2000);
            }
        }

        // ************ SEARCH AGREEMENT ***************
        function agreementSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchAgreementData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(3, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 3);
                }, 2000);
            }
        }


        function showFilterTime(type) {
            var x = new Date();
            if (type == 1) {
                x.setHours('00');
                x.setMinutes('00');
                x.setSeconds('00');
            } else if (type == 2) {
                x.setHours('23');
                x.setMinutes('59');
                x.setSeconds('00');
            }
            return x;
        }

        function getFirstDateOfPreviousMonth() {
            var x = new Date();
            x.setDate(1);
            x.setMonth(x.getMonth() - 1);
            return x;
        }

        function runThis() {
            vm.typeTripFilter = [
                // {
                //     name: languageBasedErrorFactory.getProperErrorMessage('allLabel',0,'3'),
                //     id: 'all'
                // },
                {
                    name: 'From Airport',
                    id: 'Z'
                },
                {
                    name: 'To Airport',
                    id: 'R'
                },
                {
                    name: 'Point to Point',
                    id: 'P'
                }
            ]
        }

        if (localStorage.getItem('completedFilter')) {
            vm.filterData = JSON.parse(localStorage.getItem('completedFilter'));
            vm.filterData.filter_pickup_from_date_value = new Date(vm.filterData.filter_pickup_from_date_value);
            vm.filterData.filter_pickup_from_time_value = new Date(vm.filterData.filter_pickup_from_time_value);
            vm.filterData.filter_pickup_to_date_value = new Date(vm.filterData.filter_pickup_to_date_value);
            vm.filterData.filter_pickup_to_time_value = new Date(vm.filterData.filter_pickup_to_time_value);
            vm.itemsPerPageSelected = vm.filterData.itemsPerPageSelected ? vm.filterData.itemsPerPageSelected : 25;
            vm.itemsPerPageGot = vm.filterData.itemsPerPageSelected ? vm.filterData.itemsPerPageSelected : 25;
            vm.filterData.itemsPerPageSelected = vm.filterData.itemsPerPageSelected ? vm.filterData.itemsPerPageSelected : 25;
            if (vm.filterData.searchBookingId || vm.filterData.searchPackageId) {
                getBookingIdResults(vm.filterData);
            } else {
                init();
            }
        } else {
            init();
        }

        //==============booking details================
        function bookingDetails(data) {
            console.log(vm.filterData);
            localStorage.setItem('completedFilter', JSON.stringify(vm.filterData));
            $state.go('layout.completedBookingsMain.completedBookingDetailsNew', {
                id: data.job_id,
                type: '2'
            });
        }

        //$scope.$on('$destroy',function(){
        //    localStorage.removeItem('upcomingFilter');
        //})

        $scope.$watchCollection('vm.filterData', function (newValue, oldValue) {
            console.log('newValue', newValue);
            console.log('oldValue', oldValue);
            localStorage.setItem('completedFilter', JSON.stringify(newValue));
        })

        //====================socket connection===================
        var myListener = $rootScope.$on('SocketComesCompleted', function (evt, data) {
            console.log('debug', data);
            $log.log(evt);
            $log.log(data);
            // if (data.data && vm.countToSocket == 0 && (!vm.filterData.searchBookingId && !vm.filterData.searchPackageId)) {
            //     console.log(vm.currentPage);
            //     vm.itemsPerPageGot = vm.itemsPerPageSelected;
            //     getAllCompletedBookings(vm.currentPage * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData, false);
            // } else 

            // if (data.data && vm.countToSocket == 0) {
            //     getBookingIdResults(vm.filterData, data.res.message.job_id ,  data.res.message.job_status);
            // }

        });
        $scope.$on('$destroy', myListener);
        //$rootScope.socket.on('socketEventToUser',function(res){
        //    showDriversWithFilterSocket(vm.dataToFill);
        //});


        if ($rootScope.socket.connected == false || $rootScope.socket.connected == 'false') {
            $rootScope.socket.connect();
        }

        //====================slide data======================
        $('#derp').hide();

        function slideData() {
            // vm.agreement = [];
            // vm.branchList = [];
            // vm.vehicle = [];
            // vm.service = [];
            // getFilterDataFromBackend();
            $('#derp').slideToggle(1000);
            vm.filterData.searchByName = 0;
        }


        //==================date picker function==================
        vm.dateOptions = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(2090, 12, 31),
            //minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };
        vm.dateOptionsT = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(),
            //minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };

        function datePickerE_1(type) {
            if (type == 1) {
                vm.datePicker_1.pickupFromDate = true;
                vm.datePicker_1.pickupToDate = false;
            } else if (type == 2) {
                vm.datePicker_1.pickupFromDate = false;
                vm.datePicker_1.pickupToDate = true;
            }
        };
        //====================function for dropdown pages and page count===============
        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            getAllCompletedBookings(0, vm.itemsPerPageGot, vm.filterData, true);
        };

        function paginationNew(page) {
            console.log(page);
            getAllCompletedBookings((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData, true);
        }
        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.completedBookingsMain.completedBookings');
            }
        });
        //===============================function to change date============================
        function changeDateFormat(date) {
            console.log(date);
            var data = date.split('T')[0];
            var newDate = new Date(data);
            //console.log(newDate,date.split('T')[1].split(':')[0],Number(date.split('T')[1].split(':')[1]));
            newDate.setHours(Number(date.split('T')[1].split(':')[0]));
            newDate.setMinutes(Number(date.split('T')[1].split(':')[1]));
            newDate.setSeconds(0);
            console.log(newDate);
            return newDate;
        };
        //====================date time format====================
        function dateTimeFormat(dateGot, timeGot) {
            console.log(dateGot, timeGot);
            var dateToChange = dateGot;
            if (timeGot) {
                dateToChange.setHours(timeGot.getHours());
                dateToChange.setMinutes(timeGot.getMinutes());
                dateToChange.setSeconds(timeGot.getSeconds());
            } else {
                dateToChange.setHours(0);
                dateToChange.setMinutes(0);
                dateToChange.setSeconds(0);
            }
            console.log(dateToChange);
            return dateToChange;
        };
        //==================get all drivers=======================
        function getAllCompletedBookings(skip, limit, filter, loader) {
            if (filter.filter_pickup_from_date_value && filter.filter_pickup_from_time_value) {
                var pickFromDate = dateTimeFormat(filter.filter_pickup_from_date_value, filter.filter_pickup_from_time_value);
            } else if (filter.filter_pickup_from_date_value && !filter.filter_pickup_from_time_value) {
                var pickFromDate = filter.filter_pickup_from_date_value;
            }

            if (filter.filter_pickup_to_date_value && filter.filter_pickup_to_time_value) {
                var pickToDate = dateTimeFormat(filter.filter_pickup_to_date_value, filter.filter_pickup_to_time_value);
            } else if (filter.filter_pickup_to_date_value && !filter.filter_pickup_to_time_value) {
                var pickToDate = filter.filter_pickup_to_date_value;
            }

            if (pickFromDate > pickToDate) {
                languageBasedErrorFactory.getProperErrorMessage('appropriateFilter', 0, 0);
                return;
            }

            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit;
            dataSend.offset = skip;
            dataSend.booking_status = filter.booking_status;
            dataSend.branch_filter = filter.branch_filter;
            if (filter.branch_filter == 1 && filter.branch != 'all') {
                dataSend.branch_value = filter.branch;
            }
            dataSend.service_filter = filter.service_filter;
            if (filter.service_filter == 1 && filter.service != 'all') {
                dataSend.service_value = filter.service;
            }
            dataSend.vehicle_filter = filter.vehicle_filter;
            if (filter.vehicle_filter == 1 && filter.vehicle != 'all') {
                dataSend.vehicle_value = filter.vehicle;
            }
            // dataSend.date_time_filter = filter.date_time_filter;
            dataSend.date_time_filter = 1; //0 for all data and 1 for spefic data for dates
            if (filter.filter_pickup_from_date_value && filter.filter_pickup_from_time_value) {
                dataSend.date_time_value1 = pickFromDate;
            } else if (filter.filter_pickup_from_date_value && !filter.filter_pickup_from_time_value) {
                dataSend.date_time_value1 = moment(pickFromDate).format('YYYY-MM-DD');
            }

            if (filter.filter_pickup_to_date_value && filter.filter_pickup_to_time_value) {
                dataSend.date_time_value2 = pickToDate;
            } else if (filter.filter_pickup_to_date_value && !filter.filter_pickup_to_time_value) {
                dataSend.date_time_value2 = moment(pickToDate).format('YYYY-MM-DD');
            }

            dataSend.aggrement_filter = filter.aggrement_filter;
            if (filter.aggrement_filter == 1 && filter.agreement != 'all') {
                dataSend.aggrement_value = filter.agreement;
            }
            // ****** VARIABLE FOR AGREEMENT FILTERS *******
            dataSend.search_by_agreement_filter = filter.agreementValue || 0;
            if (filter.agreementValue == 1) {
                dataSend.search_agreement_value = filter.agreementSearch;
            }
            // ****** VARIABLE FOR SEARCH BY NAME FILTERS *******
            dataSend.search_user_filter = filter.searchByNameFilterValue || 0;
            if (filter.searchByNameFilterValue == 1) {
                dataSend.search_by_user_filter = filter.searchByName;
                dataSend.search_user_value = filter.searchByNameFilter;
            }
            // ******* VARIABLE FOR BOOKING STATE FILTER ********
            dataSend.job_status_filter = filter.bookingStateValue > -2 ? 1 : 0;
            if (dataSend.job_status_filter == 1) {
                dataSend.job_status_value = [];
                if (filter.bookingStateValue == -1) {
                    var dummyArray = [];
                    // ***** SELECT ALL ******
                    vm.stateOfBookingArray.forEach(function (object) {
                        if (object.id != -1)
                            dummyArray.push(object.id)
                    });
                    dataSend.job_status_value = JSON.stringify(dummyArray);
                } else {
                    dataSend.job_status_value.push(JSON.stringify(filter.bookingStateValue));
                }
            }
            // dataSend.type_of_trip_filter = filter.type_of_trip_filter;
            // if(filter.type_of_trip_filter == 1 && filter.type_of_trip != 'all'){
            //     // dataSend.type_of_trip_value = filter.type_of_trip;
            //     var trip = [];
            //     trip.push(vm.filterData.type_of_trip);
            //     if(vm.filterData.type_of_trip.length > 0){
            //         dataSend.type_of_trip_value = trip;
            //     }
            // }
            var trip = [];
            trip.push(vm.filterData.type_of_trip);
            if (vm.filterData.type_of_trip && vm.filterData.type_of_trip.length > 0 && filter.type_of_trip != 'all') {
                dataSend.type_of_trip_filter = 1;
                dataSend.type_of_trip_value = trip;
            } else {
                dataSend.type_of_trip_filter = 0;
            }

            dataSend.search_filter = filter.search_filter;
            if (filter.search_filter == 1) {
                dataSend.search_value = filter.search_value;

            }

            vm.loading = loader;
            var promise = getBookings.allBookings(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.totalCompletedBookings = payload.title.data.totalCount;
                        vm.dataLength = payload.title.data.totalCount;

                        if (payload.title.data.totalCount == 0) {
                            vm.sp_pagination = false;
                            vm.tBodyFlag = false;
                            vm.tFootFlag = true;
                            vm.filterOn = true;
                            vm.skipValueFilter = 0;
                        } else {
                            vm.sp_pagination = true;
                            vm.tBodyFlag = true;
                            vm.tFootFlag = false;
                            var dataArray = [];
                            var completedBookingsList = payload.title.data.result;
                            completedBookingsList.forEach(function (column) {
                                var d = {};
                                d.job_id = column.job_id;
                                d.job_status = column.job_status;
                                d.created_by = column.created_by;
                                d.booking_for = column.booking_for; //0 owner, 1- other
                                //d.job_pickup_datetime = changeDateFormat(column.job_pickup_datetime);
                                d.job_pickup_name = column.job_pickup_name;
                                d.job_pickup_phone = column.job_pickup_phone;
                                d.job_pickup_email = column.job_pickup_email;
                                d.job_pickup_address = column.job_pickup_address;
                                d.job_address = column.job_address; //destination
                                d.number_of_passangers = column.number_of_passangers;
                                d.creation_datetime = column.creation_datetime;
                                d.fleet_id = column.fleet_id;
                                d.job_time_utc = column.job_time; //actual start time
                                d.job_time = column.job_time_utc; //actual start time
                                d.job_time_filtered = $filter('date')(column.job_time_utc, "MMM d, yyyy HH:mm'"); //actual start time
                                if (new Date(column.job_time_utc).getDate() == new Date().getDate() && new Date(column.job_time_utc).getMonth() == new Date().getMonth() && new Date(column.job_time_utc).getFullYear() == new Date().getFullYear()) {
                                    d.dateFlagForShow = true;
                                } else {
                                    d.dateFlagForShow = false;
                                }
                                d.fleet_first_name = column.fleet_first_name;
                                d.fleet_last_name = column.fleet_last_name;
                                d.fleet_country_code = column.fleet_country_code;
                                d.fleet_phone_number = column.fleet_phone_number;
                                d.customer_first_name = column.customer_first_name;
                                d.customer_last_name = column.customer_last_name;
                                d.customer_country_code = column.customer_country_code;
                                d.customer_phone_number = column.customer_phone_number;
                                d.unique_car_id = column.unique_car_id;
                                d.is_adjusted = column.is_adjusted;
                                d.type_of_trip = column.type_of_trip;
                                d.shared_service_id = column.shared_service_id;
                                d.shared_service_status = column.shared_service_status;
                                d.booking_type = column.booking_type;
                                dataArray.push(d);
                            });
                            vm.completedBookingsList = dataArray;

                            for (var i = 0; i < vm.completedBookingsList.length; i++) {
                                vm.completedBookingsList[i].index = (skip + i);
                            }
                            if (vm.dataLength <= vm.itemsPerPageGot) {
                                vm.sp_pagination = false;
                            } else {
                                vm.sp_pagination = true;
                                //vm.pageCount(payload.title.totalCount);
                            }
                            vm.skipValue = vm.completedBookingsList[0].index;
                            vm.limitValue = vm.completedBookingsList[vm.completedBookingsList.length - 1].index;
                            vm.filterOn = false;
                            vm.skipValueFilter = 0;
                            //$scope.$watch('vm.search', function (newVal, oldVal) {
                            //    vm.filtered = filterFilter(vm.completedBookingsList, newVal);
                            //    vm.totalItems = vm.filtered.length;
                            //    if (vm.filtered.length == 0) {
                            //        vm.watchPagination = false;
                            //    } else {
                            //        vm.watchPagination = true;
                            //    }
                            //    if (vm.filterOn == true) {
                            //        vm.skipValueFilter = vm.filtered.length;
                            //        vm.sp_pagination = false;
                            //    }
                            //}, true);
                            //range();
                        }
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        function checkFilterStatus(data) {
            console.log("checkFilterStatus>>>>>>>>>>>>>>>>>", data);
            var flagStatus = false;
            var date_time_value1 = dateTimeFormat(vm.filterData.filter_pickup_from_date_value, vm.filterData.filter_pickup_from_time_value);
            var date_time_value2 = dateTimeFormat(vm.filterData.filter_pickup_to_date_value, vm.filterData.filter_pickup_to_time_value);
            var dateTo = new Date(date_time_value2).getTime();
            var dateFrom = new Date(date_time_value1).getTime();
            var booking_date = data.job_time_utc;
            var job_status_filter = vm.filterData.bookingStateValue;
            booking_date = new Date(booking_date).getTime();
            if (dateFrom <= booking_date && booking_date <= dateTo) {
                console.log("date match >>>>>>>>>>>>>>>>>>>>", dateFrom, booking_date, dateTo);
                if (vm.filterData.type_of_trip_filter == [] || (vm.filterData.type_of_trip == data.type_of_trip)) {
                    console.log("type of of trip match >>>>>>>>>>>>>>>>>>>>",vm.filterData.service,data.type_of_service);
                    if (vm.filterData.service_filter == [] || vm.filterData.service == data.type_of_service) {
                        console.log("type of of service match >>>>>>>>>>>>>>>>>>>>");
                        if (vm.filterData.aggrement_filter == 0 || (vm.filterData.agreement == data.contract_id)) {
                            console.log("type of of  agreement match>>>>>>>>>>>>>>>>>>>>");
                            if (vm.filterData.branch_filter == 0 || (vm.filterData.branch == data.branch)) {
                                console.log("type of of branch match >>>>>>>>>>>>>>>>>>>>",job_status_filter , vm.filterData.bookingStateValue == data.job_status);
                                if ((job_status_filter == -1 || job_status_filter == undefined) || vm.filterData.bookingStateValue == data.job_status) {
                                    console.log("bookingArray.job_status");
                                    flagStatus = true;
                                }
                            }
                        }
                    }
                }
            }
            return flagStatus;
        }

        //===========================get filters by booking id=========================
        function getFilterBookingId(data) {
            console.log(data);
            if (!data) {
                vm.getAllCompletedBookings(0, vm.itemsPerPageGot, vm.filterData, true);
            } else {
                //if (vm.filterTextTimeout) $timeout.cancel(vm.filterTextTimeout);
                //vm.filterTextTimeout = $timeout(function(){
                getBookingIdResults(vm.filterData);
                //},500);
            }
        };

        function getBookingIdResults(data, job_id,job_status) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            if (data.searchBookingId)
                dataSend.booking_id = data.searchBookingId;
            if (data.searchPackageId)
                dataSend.package_id = data.searchPackageId;

            if (job_id){
            dataSend.booking_id = job_id;
            dataSend.booking_status = job_status;
            } else {
                dataSend.booking_status = 2;
            }

            //vm.loading = true;
            var promise = getBookings.getBookingById(dataSend);
            promise.then(
                function (payload) {
                    console.log(payload);
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (payload.title.data.result.length) {
                            vm.loading = false;
                            if (payload.title.data.totalCount == 0) {
                                vm.sp_pagination = false;
                                vm.tBodyFlag = false;
                                vm.tFootFlag = true;
                                vm.filterOn = true;
                                vm.skipValueFilter = 0;
                            } else {
                                vm.tBodyFlag = true;
                                vm.tFootFlag = false;
                                vm.filterOn = false;
                                vm.skipValueFilter = 0;
                                var dataArray = [];
                                if (job_id && (vm.completedBookingsList == undefined ||vm.completedBookingsList != undefined && vm.completedBookingsList.length)) {
                                    // for (var j = 0; j < vm.completedBookingsList.length; j++) {
                                    if (checkFilterStatus(payload.title.data.result[0])) {
                                        var index = _.findIndex(vm.completedBookingsList, {
                                            job_id: payload.title.data.result[0].job_id
                                        });
                                        if (index == -1 && vm.completedBookingsList != undefined) {
                                            for (var j = 0; j < vm.completedBookingsList.length; j++) {
                                                if (new Date(payload.title.data.result[0].job_time_utc).getTime() > new Date(vm.completedBookingsList[j].job_time).getTime()) {
                                                    vm.dataLength += 1;
                                                    vm.totalCompletedBookings += 1;
                                                    vm.completedBookingsList.insert(j, {
                                                        "job_id": payload.title.data.result[0].job_id,
                                                        "job_status": payload.title.data.result[0].job_status,
                                                        "created_by": payload.title.data.result[0].created_by,
                                                        "booking_for": payload.title.data.result[0].booking_for, //0 owner, 1- other
                                                        //d.job_pickup_datetime = changeDateFormat(column.job_pickup_datetime);
                                                        "job_pickup_name": payload.title.data.result[0].job_pickup_name,
                                                        "job_pickup_phone": payload.title.data.result[0].job_pickup_phone,
                                                        "job_pickup_email": payload.title.data.result[0].job_pickup_email,
                                                        "job_pickup_address": payload.title.data.result[0].job_pickup_address,
                                                        "job_address": payload.title.data.result[0].job_address, //destination
                                                        "number_of_passangers": payload.title.data.result[0].number_of_passangers,
                                                        "creation_datetime": payload.title.data.result[0].creation_datetime,
                                                        "fleet_id": payload.title.data.result[0].fleet_id,
                                                        "job_time_utc": payload.title.data.result[0].job_time, //actual start time
                                                        "job_time": payload.title.data.result[0].job_time_utc, //actual start time
                                                        "job_time_filtered": $filter('date')(payload.title.data.result[0].job_time_utc, "MMM d, yyyy HH:mm'"), //actual start time
                                                        "dateFlagForShow": new Date(payload.title.data.result[0].job_time_utc).getDate() == new Date().getDate() && new Date(payload.title.data.result[0].job_time_utc).getMonth() == new Date().getMonth() && new Date(payload.title.data.result[0].job_time_utc).getFullYear() == new Date().getFullYear() ? true : false,
                                                        "fleet_first_name": payload.title.data.result[0].fleet_first_name,
                                                        "fleet_last_name": payload.title.data.result[0].fleet_last_name,
                                                        "fleet_country_code": payload.title.data.result[0].fleet_country_code,
                                                        "fleet_phone_number": payload.title.data.result[0].fleet_phone_number,
                                                        "customer_first_name": payload.title.data.result[0].customer_first_name,
                                                        "customer_last_name": payload.title.data.result[0].customer_last_name,
                                                        "customer_country_code": payload.title.data.result[0].customer_country_code,
                                                        "customer_phone_number": payload.title.data.result[0].customer_phone_number,
                                                        "unique_car_id": payload.title.data.result[0].unique_car_id,
                                                        "is_adjusted": payload.title.data.result[0].is_adjusted,
                                                        "type_of_trip": payload.title.data.result[0].type_of_trip,
                                                        "shared_service_id": payload.title.data.result[0].shared_service_id,
                                                        "shared_service_status": payload.title.data.result[0].shared_service_status,
                                                        "booking_type": payload.title.data.result[0].booking_type,
                                                    });
                                                    break;
                                                } 
                                            } 
                                            var indexNew = _.findIndex(vm.completedBookingsList, {
                                                job_id: payload.title.data.result[0].job_id
                                            });
                                            if(indexNew == -1){
                                                vm.dataLength += 1;
                                                vm.totalCompletedBookings += 1;
                                                vm.completedBookingsList.push({
                                                    "job_id": payload.title.data.result[0].job_id,
                                                    "job_status": payload.title.data.result[0].job_status,
                                                    "created_by": payload.title.data.result[0].created_by,
                                                    "booking_for": payload.title.data.result[0].booking_for, //0 owner, 1- other
                                                    //d.job_pickup_datetime = changeDateFormat(column.job_pickup_datetime);
                                                    "job_pickup_name": payload.title.data.result[0].job_pickup_name,
                                                    "job_pickup_phone": payload.title.data.result[0].job_pickup_phone,
                                                    "job_pickup_email": payload.title.data.result[0].job_pickup_email,
                                                    "job_pickup_address": payload.title.data.result[0].job_pickup_address,
                                                    "job_address": payload.title.data.result[0].job_address, //destination
                                                    "number_of_passangers": payload.title.data.result[0].number_of_passangers,
                                                    "creation_datetime": payload.title.data.result[0].creation_datetime,
                                                    "fleet_id": payload.title.data.result[0].fleet_id,
                                                    "job_time_utc": payload.title.data.result[0].job_time, //actual start time
                                                    "job_time": payload.title.data.result[0].job_time_utc, //actual start time
                                                    "job_time_filtered": $filter('date')(payload.title.data.result[0].job_time_utc, "MMM d, yyyy HH:mm'"), //actual start time
                                                    "dateFlagForShow": new Date(payload.title.data.result[0].job_time_utc).getDate() == new Date().getDate() && new Date(payload.title.data.result[0].job_time_utc).getMonth() == new Date().getMonth() && new Date(payload.title.data.result[0].job_time_utc).getFullYear() == new Date().getFullYear() ? true : false,
                                                    "fleet_first_name": payload.title.data.result[0].fleet_first_name,
                                                    "fleet_last_name": payload.title.data.result[0].fleet_last_name,
                                                    "fleet_country_code": payload.title.data.result[0].fleet_country_code,
                                                    "fleet_phone_number": payload.title.data.result[0].fleet_phone_number,
                                                    "customer_first_name": payload.title.data.result[0].customer_first_name,
                                                    "customer_last_name": payload.title.data.result[0].customer_last_name,
                                                    "customer_country_code": payload.title.data.result[0].customer_country_code,
                                                    "customer_phone_number": payload.title.data.result[0].customer_phone_number,
                                                    "unique_car_id": payload.title.data.result[0].unique_car_id,
                                                    "is_adjusted": payload.title.data.result[0].is_adjusted,
                                                    "type_of_trip": payload.title.data.result[0].type_of_trip,
                                                    "shared_service_id": payload.title.data.result[0].shared_service_id,
                                                    "shared_service_status": payload.title.data.result[0].shared_service_status,
                                                    "booking_type": payload.title.data.result[0].booking_type,
                                                });
                                            }
                                        }
                                    }
                                    // }
                                } else {
                                    vm.totalCompletedBookings = payload.title.data.totalCount;
                                    vm.dataLength = payload.title.data.totalCount;
                                    var completedBookingsList = payload.title.data.result;
                                    completedBookingsList.forEach(function (column) {
                                        var d = {};
                                        d.job_id = column.job_id;
                                        d.job_status = column.job_status;
                                        d.created_by = column.created_by;
                                        d.booking_for = column.booking_for; //0 owner, 1- other
                                        //d.job_pickup_datetime = changeDateFormat(column.job_pickup_datetime);
                                        d.job_pickup_name = column.job_pickup_name;
                                        d.job_pickup_phone = column.job_pickup_phone;
                                        d.job_pickup_email = column.job_pickup_email;
                                        d.job_pickup_address = column.job_pickup_address;
                                        d.job_address = column.job_address; //destination
                                        d.number_of_passangers = column.number_of_passangers;
                                        d.creation_datetime = column.creation_datetime;
                                        d.fleet_id = column.fleet_id;
                                        d.job_time_utc = column.job_time; //actual start time
                                        d.job_time = column.job_time_utc; //actual start time
                                        d.job_time_filtered = $filter('date')(column.job_time_utc, "MMM d, yyyy HH:mm'"); //actual start time
                                        if (new Date(column.job_time_utc).getDate() == new Date().getDate() && new Date(column.job_time_utc).getMonth() == new Date().getMonth() && new Date(column.job_time_utc).getFullYear() == new Date().getFullYear()) {
                                            d.dateFlagForShow = true;
                                        } else {
                                            d.dateFlagForShow = false;
                                        }
                                        d.fleet_first_name = column.fleet_first_name;
                                        d.fleet_last_name = column.fleet_last_name;
                                        d.fleet_country_code = column.fleet_country_code;
                                        d.fleet_phone_number = column.fleet_phone_number;
                                        d.customer_first_name = column.customer_first_name;
                                        d.customer_last_name = column.customer_last_name;
                                        d.customer_country_code = column.customer_country_code;
                                        d.customer_phone_number = column.customer_phone_number;
                                        d.unique_car_id = column.unique_car_id;
                                        d.is_adjusted = column.is_adjusted;
                                        d.type_of_trip = column.type_of_trip;
                                        d.shared_service_id = column.shared_service_id;
                                        d.shared_service_status = column.shared_service_status;
                                        d.booking_type = column.booking_type;
                                        dataArray.push(d);
                                    });
                                    vm.completedBookingsList = dataArray;
                                }
                                console.log(vm.completedBookingsList, 'vm.completedBookingsList');
                                if(vm.completedBookingsList != undefined && vm.completedBookingsList.length){
                                    for (var i = 0; i < vm.completedBookingsList.length; i++) {
                                        vm.completedBookingsList[i].index = (i);
                                    }
                                    if (vm.dataLength <= vm.itemsPerPageGot) {
                                        vm.sp_pagination = false;
                                    } else {
                                        vm.sp_pagination = true;
                                        //vm.pageCount(payload.title.totalCount);
                                    }
                                    vm.skipValue = vm.completedBookingsList[0].index;
                                    vm.limitValue = vm.completedBookingsList[vm.completedBookingsList.length - 1].index;
                                    //range();
                                    vm.sp_pagination = true;
                                }
                            }
                        } else {
                            vm.completedBookingsList = [];
                            vm.sp_pagination = false;
                            vm.tBodyFlag = false;
                            vm.tFootFlag = true;
                            vm.filterOn = true;
                            vm.skipValueFilter = 0;
                            vm.totalCompletedBookings = 0;
                            vm.dataLength = 0;
                        }
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    } else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        vm.getAllCompletedBookings((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData,true);
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    //console.log($scope.totalPages);
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        //console.log($scope.currentPage);
        //        vm.currentPage++;
        //        vm.getAllCompletedBookings((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData,true);
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    vm.getAllCompletedBookings((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData,true);
        //};

        function init() {
            vm.getAllCompletedBookings(0, vm.filterData.itemsPerPageSelected, vm.filterData, true);
        };

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            //vm.filterOn = true;
            vm.currentPage = 0;
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            pendingRequests.cancelAll();
            if (vm.filterData.search.length == 0) {
                vm.filterData.search_filter = 0;
                vm.filterData.search_value = '';
                vm.getAllCompletedBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                //vm.filterOn = false;
                //vm.watchPagination = true;
                //vm.sp_pagination = true;
            } else {
                vm.filterData.search_filter = 1;
                vm.filterData.search_value = vm.filterData.search;
                //if (vm.filterTextTimeout) $timeout.cancel(vm.filterTextTimeout);
                //vm.filterTextTimeout = $timeout(function(){
                vm.getAllCompletedBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                //},500);
            }
        };
        //====================get branch list====================
        // function getBranch() {
        //     // vm.branchList = [];
        //     // vm.branchList = JSON.parse(JSON.stringify(getFilters.branchesFiltersData.data));
        //     // vm.branchList.push({
        //     //     region_name: 'Todos',
        //     //     region_id: 'all'
        //     // });

        //     vm.loading = true;
        //     var promise = getGeofence.branch();
        //     promise.then(
        //         function (payload) {
        //             $log.log(payload);
        //             //vm.loading = false;
        //             if (payload.title.status == 400) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //             } else if (payload.title.status == 401) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //             } else if (payload.title.status == 201 || payload.title.status == 200) {
        //                 var where = _.where(payload.title.data, {
        //                     parent_id: 0
        //                 });
        //                 //vm.branchList = _.where(where, { is_active: 1 });
        //                 vm.branchList = where;

        //                 vm.branchList.push({
        //                     region_name: 'Todos',
        //                     region_id: 'all'
        //                 });
        //             }
        //         },
        //         function (errorPayload) {
        //             $log.log(errorPayload);
        //             vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // }
        // getBranch();
        //======================get all vehicles==============
        // function getAllVehicles(skip, limt, filter) {
        //     // vm.vehicle = [];
        //     // angular.forEach(getFilters.vehiclesFiltersData.data, function (column) {
        //     //     vm.vehicle.push({
        //     //         id: column.id,
        //     //         name: column.name
        //     //     })
        //     // });
        //     // vm.vehicle.push({
        //     //     id: 'all',
        //     //     name: 'Todos'
        //     // });

        //     vm.loading = false;
        //     var promise = getVehicles.allVehicles(skip, limt, filter);
        //     promise.then(
        //         function (payload) {
        //             $log.log('sxdsads', payload);
        //             //vm.loading = false;
        //             if (payload.title.status == 400) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //             } else if (payload.title.status == 401) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //             } else if (payload.title.status == 201 || payload.title.status == 200) {
        //                 vm.vehicle = [];
        //                 angular.forEach(payload.title.data.result, function (column) {
        //                     vm.vehicle.push({
        //                         id: column.id,
        //                         name: column.name
        //                     })
        //                 });
        //                 vm.vehicle.push({
        //                     id: 'all',
        //                     name: 'Todos'
        //                 });
        //             }
        //         },
        //         function (errorPayload) {
        //             $log.log(errorPayload);
        //             //vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // };
        // // WHen Page refresh service take time to get data from backend
        // // setTimeout(function () {
        // getAllVehicles(0, 0, 2);
        // }, 1000);
        //======================get all services==============
        // function getAllServices(skip, limit) {
        //     // vm.service = [];
        //     // angular.forEach(getFilters.servicesFiltersData.data, function (column) {
        //     // vm.service.push({
        //     // id: column.id,
        //     // name: column.service_name
        //     // });
        //     // });
        //     // vm.service.push({
        //     // id: 'all',
        //     // name: 'All'
        //     // })

        //     vm.loading = false;
        //     var promise = getServices.allServices(skip, limit, 2, 0);
        //     promise.then(
        //         function (payload) {
        //             $log.log('sxdsads', payload);
        //             //vm.loading = false;
        //             if (payload.title.status == 400) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //             } else if (payload.title.status == 401) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //             } else if (payload.title.status == 201 || payload.title.status == 200) {
        //                 vm.service = [];
        //                 angular.forEach(payload.title.data.result, function (column) {
        //                     vm.service.push({
        //                         id: column.id,
        //                         name: column.service_name
        //                     });
        //                 });
        //                 vm.service.push({
        //                     id: 'all',
        //                     name: 'All'
        //                 })
        //             }
        //         },
        //         function (errorPayload) {
        //             $log.log(errorPayload);
        //             vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // };
        // // WHen Page refresh service take time to get data from backend
        // // setTimeout(function () {
        // getAllServices(0, 0);
        // }, 1000);

        //======================get all services==============
        // function getAllAgreement(skip, limt) {
        //     var dataSend = {};
        //     dataSend.access_token = $cookies.get('obj');
        //     dataSend.offset = skip;
        //     dataSend.limit = limt;
        //     dataSend.key = 3;
        //     //vm.loading = false;
        //     var promise = getAgreement.getAgreementListLessData(dataSend);
        //     promise.then(
        //         function (payload) {
        //             $log.log('sxdsads', payload);
        //             //vm.loading = false;
        //             if (payload.title.status == 400) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //             } else if (payload.title.status == 401) {
        //                 errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //             } else if (payload.title.status == 201 || payload.title.status == 200) {
        //                 vm.agreement = [];
        //                 angular.forEach(payload.title.data, function (column) {
        //                     vm.agreement.push({
        //                         id: column.id,
        //                         name: column.name
        //                     });
        //                 });
        //                 vm.agreement.push({
        //                     id: 'all',
        //                     name: 'Todos'
        //                 });
        //             }
        //         },
        //         function (errorPayload) {
        //             $log.log(errorPayload);
        //             //vm.loading = false;
        //             if (errorPayload.data.status == 401) {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //             } else {
        //                 errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //             }
        //         }
        //     );
        // };
        // getAllAgreement(0, 0);

        //=================filter change functions=================
        function branchChanged() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (vm.filterData.branch && vm.filterData.branch != 'all') {
                vm.filterData.branch_filter = 1;
                // getAllCompletedBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // vm.agreement = [];
                // vm.branchList = [];
                // vm.vehicle = [];
                // vm.service = [];
                // clearOffset();
                // getFilterDataFromBackend();
            } else {
                vm.filterData.branch_filter = 0;
                vm.filterData.branch = 'all';
                // getAllCompletedBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // vm.agreement = [];
                // vm.branchList = [];
                // vm.vehicle = [];
                // vm.service = [];
                // clearOffset();
                // getFilterDataFromBackend();
            }
        };

        function agreementChanged() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (vm.filterData.agreement && vm.filterData.agreement != 'all') {
                vm.filterData.aggrement_filter = 1;
                // getAllCompletedBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // vm.agreement = [];
                // vm.branchList = [];
                // vm.vehicle = [];
                // vm.service = [];
                // clearOffset();
                // getFilterDataFromBackend();
            } else {
                vm.filterData.aggrement_filter = 0;
                vm.filterData.agreement = 'all';
                // getAllCompletedBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // vm.agreement = [];
                // vm.branchList = [];
                // vm.vehicle = [];
                // vm.service = [];
                // clearOffset();
                // getFilterDataFromBackend();
            }
        };

        function serviceChanged() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (vm.filterData.service && vm.filterData.service != 'all') {
                vm.filterData.service_filter = 1;
                // getAllCompletedBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // vm.agreement = [];
                // vm.branchList = [];
                // vm.vehicle = [];
                // vm.service = [];
                // clearOffset();
                // getFilterDataFromBackend();
            } else {
                vm.filterData.service_filter = 0;
                vm.filterData.service = 'all';
                // getAllCompletedBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // vm.agreement = [];
                // vm.branchList = [];
                // vm.vehicle = [];
                // vm.service = [];
                // clearOffset();
                // getFilterDataFromBackend();
            }
        };

        function vehicleChanged() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (vm.filterData.vehicle && vm.filterData.vehicle != 'all') {
                vm.filterData.vehicle_filter = 1;
                // getAllCompletedBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // vm.agreement = [];
                // vm.branchList = [];
                // vm.vehicle = [];
                // vm.service = [];
                // clearOffset();
                // getFilterDataFromBackend();
            } else {
                vm.filterData.vehicle_filter = 0;
                vm.filterData.vehicle = 'all';
                // getAllCompletedBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                // vm.agreement = [];
                // vm.branchList = [];
                // vm.vehicle = [];
                // vm.service = [];
                // clearOffset();
                // getFilterDataFromBackend();
            }
        };

        function typeTripChanged() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (vm.filterData.type_of_trip && vm.filterData.type_of_trip != 'all') {
                vm.filterData.type_of_trip_filter = 1;
                // getAllCompletedBookings(0, vm.itemsPerPageGot, vm.filterData, true);

            } else {
                vm.filterData.type_of_trip_filter = 0;
                vm.filterData.type_of_trip = 'all';
                // getAllCompletedBookings(0, vm.itemsPerPageGot, vm.filterData, true);

            }
        };

        function pickupFromToDateChanged(type) {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (type == 1) {
                if (vm.filterData.filter_pickup_from_date_value) {
                    vm.filterData.date_time_filter = 1;
                    // getAllCompletedBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                } else {
                    vm.filterData.date_time_filter = 0;
                    vm.filterData.filter_pickup_from_date_value = '';
                    // getAllCompletedBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                }
            } else if (type == 2) {
                if (vm.filterData.filter_pickup_to_date_value) {
                    vm.filterData.date_time_filter = 1;
                    // getAllCompletedBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                } else {
                    vm.filterData.date_time_filter = 0;
                    vm.filterData.filter_pickup_to_date_value = '';
                    // getAllCompletedBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                }
            }
        }

        function pickupFromToTimeChanged(type) {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            if (type == 1) {
                if (vm.filterData.filter_pickup_from_time_value) {
                    vm.filterData.date_time_filter = 1;
                    // getAllCompletedBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                } else if (vm.filterData.filter_pickup_from_date_value) {
                    vm.filterData.date_time_filter = 1;
                    //vm.filterData.filter_pickup_time_value = '';
                    // getAllCompletedBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                } else {
                    vm.filterData.date_time_filter = 0;
                    //vm.filterData.filter_pickup_time_value = '';
                    // getAllCompletedBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                }
            } else if (type == 2) {
                if (vm.filterData.filter_pickup_to_time_value) {
                    vm.filterData.date_time_filter = 1;
                    // getAllCompletedBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                } else if (vm.filterData.filter_pickup_to_date_value) {
                    vm.filterData.date_time_filter = 1;
                    //vm.filterData.filter_pickup_time_value = '';
                    // getAllCompletedBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                } else {
                    vm.filterData.date_time_filter = 0;
                    //vm.filterData.filter_pickup_time_value = '';
                    // getAllCompletedBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                }
            }
        }

        function resetFilter() {
            vm.currentPage = 0;
            vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            vm.filterData = {
                branch_filter: 0, //0, 1
                service_filter: 0, //0, 1
                vehicle_filter: 0, //0, 1
                aggrement_filter: 0, //0, 1
                // date_time_filter: 0, //0, 1
                type_of_trip_filter: 0, //0, 1
                branch: 'all',
                service: 'all',
                vehicle: 'all',
                date_time_value1: '',
                date_time_value2: '',
                agreement: 'all',
                agreementSearch: '',
                agreementValue: 0,
                searchByName: 0,
                // type_of_trip: 'From Airport',
                filter_pickup_from_date_value: getFirstDateOfPreviousMonth(),
                filter_pickup_from_time_value: showFilterTime(1),
                filter_pickup_to_date_value: new Date(),
                filter_pickup_to_time_value: showFilterTime(2),
                limit: vm.itemsPerPageGot,
                offset: 0,
                booking_status: 2,
                searchBookingId: '',
                searchPackageId: '',
                search: '',
                itemsPerPageSelected: 25
            };
            getAllCompletedBookings(0, vm.itemsPerPageGot, vm.filterData, true);
        }

        function applyFilter() {
            vm.getAllCompletedBookings(0, vm.filterData.itemsPerPageSelected, vm.filterData, true);
        }
        //===================side bar filters=====================
        vm.showFilterArea = showFilterArea;
        vm.branchChangedFilter = branchChangedFilter;
        vm.vehicleChangedFilter = vehicleChangedFilter;
        vm.serviceChangedFilter = serviceChangedFilter;
        vm.agreementChangedFilter = agreementChangedFilter;
        vm.removeFilter = removeFilter;
        vm.typeTripChangedFilter = typeTripChangedFilter;
        vm.showFilterFlag = false;

        vm.filterWhichToShow = {
            branchWithDashboard: false,
            service: true,
            vehicle: true,
            agreement: true,
            operation: false,
            helpTraffic: false,
            virtualFleet: false,
            approvalStage: false,
            vehicleAssigned: false,
            applicantType: false,
            modelity: false,
            tripType: true
        };

        function removeFilter() {
            $state.reload('layout.completedBookingsMain.completedBookings');
        }

        function showFilterArea() {
            vm.showFilterFlag = !vm.showFilterFlag;
        }

        function branchChangedFilter(data) {
            console.log(data);
            vm.branchChanged();
        }

        function vehicleChangedFilter(data) {
            console.log(data);
            vm.vehicleChanged();
        }

        function serviceChangedFilter(data) {
            console.log(data);
            vm.serviceChanged();
        }

        function agreementChangedFilter(data) {
            console.log(data);
            vm.agreementChanged();
        }

        function typeTripChangedFilter(data) {
            vm.typeTripChanged();
        }

        function bookingStatusChange() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            // getAllCompletedBookings(0, vm.itemsPerPageGot, vm.filterData, true);
        }

        // ****** FUNCTION FOR AGREEMENT FILTER ********
        function getFilterForAgreement() {
            //vm.filterOn = true;
            vm.currentPage = 0;
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            pendingRequests.cancelAll();
            if (vm.filterData.agreementSearch.length == 0) {
                vm.filterData.agreementValue = 0;
                vm.filterData.agreementSearch = '';
                // getAllCompletedBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                //vm.filterOn = false;
                //vm.watchPagination = true;
                //vm.sp_pagination = true;

            } else {
                vm.filterData.agreementValue = 1;
                vm.filterData.agreementSearch = vm.filterData.agreementSearch;
                //if (vm.filterTextTimeout) $timeout.cancel(vm.filterTextTimeout);
                //vm.filterTextTimeout = $timeout(function(){
                // getAllCompletedBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                //},500);

            }
        };

        // ****** FUNCTION FOR SEARCH BY NAME FILTER ********
        function getFilterForSearchByNameFilter() {
            //vm.filterOn = true;
            vm.currentPage = 0;
            //vm.itemsPerPageSelected = vm.searchModel.limitOptions[1];
            //vm.itemsPerPageGot = vm.searchModel.limitOptions[1];
            //vm.filterData.itemsPerPageSelected = vm.itemsPerPageSelected;
            pendingRequests.cancelAll();
            if (vm.filterData.searchByNameFilter.length == 0) {
                vm.filterData.searchByNameFilterValue = 0;
                vm.filterData.searchByNameFilter = '';
                // getAllCompletedBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                //vm.filterOn = false;
                //vm.watchPagination = true;
                //vm.sp_pagination = true;

            } else {
                vm.filterData.searchByNameFilterValue = 1;
                vm.filterData.searchByNameFilter = vm.filterData.searchByNameFilter;
                //if (vm.filterTextTimeout) $timeout.cancel(vm.filterTextTimeout);
                //vm.filterTextTimeout = $timeout(function(){
                // getAllCompletedBookings(0, vm.itemsPerPageGot, vm.filterData, true);
                //},500);

            }
        };


        function searchByNameRadioButtonChange() {
            vm.currentPage = 0;
            vm.filterData.searchBookingId = '';
            vm.filterData.searchPackageId = '';
            // getAllCompletedBookings(0, vm.itemsPerPageGot, vm.filterData, true);
        }

        function textChangeIntoSpanishForDate(date) {
            var options = {
                month: 'short',
                year: 'numeric',
                day: 'numeric'
            };
            return new Date(date).toLocaleDateString('es', options)
        }


        function changeDateIntoSpanish(date) {
            var options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            };
            return new Date(date).toLocaleString($cookies.get('language') == 'spanish' ? 'es' : 'en', options)
        }
    }

})();

/**
 * Created by cl-macmini-51 on 5/2/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('BookingDetailsControllerNew', BookingDetailsController);

    /** @ngInject */
    function BookingDetailsController($cookies, checkDomain, $state, $log, $rootScope, $timeout, $stateParams, getBookings, $mdDialog, $document, $scope, $filter, getCorrectFareReason, adminAccessService, getNoShowReason, RutHelper, errorMessageFactory, languageBasedErrorFactory, getServices, Initializer) {
        var vm = this;
        var myCenter;
        var zoomLevel = 12;
        var all_overlays = [];
        var coordinates_array = [];
        var markers = [];
        var mapProp = {};
        vm.validateAuthForCorrectAgreement = validateAuthForCorrectAgreement;
        vm.changeDateIntoSpanish = changeDateIntoSpanish;
        vm.downloadVocher = downloadVocher;
        vm.showEvidenceDeliver = showEvidenceDeliver;
        vm.showEvidenceNoDeliver = showEvidenceNoDeliver;
        vm.showMore = showMore;
        vm.showLess = showLess;
        vm.copy = copy;
        vm.vermapa = vermapa;
        var drawingManager = '';
        var mc = null;
        var map = null;
        var icon = {};
        vm.mapshow = false;
        vm.buttonmap = false;
        vm.showAllBookings = false;
        vm.onlyShowThreeBookings = [];
        var bounds;
        var geocoder;
        var infoWindow;
        var infowindow;
        var location = "";
        var currentId = 0;
        var laArray = [];
        var poly = '';
        vm.unAssignButtonRole = false;
        var uniqueId = function () {
            return ++currentId;
        };
        var directionsService;
        var directionsDisplay;

        // TV-2669
        if (JSON.parse($cookies.get('adminType') || 0) == 1) {
            vm.PetUser = true;
        } else {
            vm.PetUser = false;
        }
        // Service To Get Map Instance
        Initializer.mapsInitialized
            .then(function () {
                console.log('>>>> GOOGLE INIT', google);
                if (google) {
                    myCenter = new google.maps.LatLng(-33.447487, -70.673676);
                    bounds = new google.maps.LatLngBounds();
                    geocoder = new google.maps.Geocoder();
                    infoWindow = new google.maps.InfoWindow();
                    directionsService = new google.maps.DirectionsService;
                    directionsDisplay = new google.maps.DirectionsRenderer;
                    getSingleBooking($stateParams.id, true);
                } else {
                    alert(languageBasedErrorFactory.getProperErrorMessage('onRoadMessage', 0, '3'));
                }

            });
        vm.loading = false;
        vm.showDriverData = {};
        vm.goBack = goBack;
        vm.getSingleBooking = getSingleBooking;
        vm.markNoShow = markNoShow;
        vm.ShowPopUpForPush = ShowPopUpForPush;
        vm.manualAssignBooking = manualAssignBooking;
        vm.checkForEvents = checkForEvents;
        vm.getSearchedAddress = getSearchedAddress;
        vm.manualUnassignBooking = manualUnassignBooking;
        vm.validateAuthForCorrectFare = validateAuthForCorrectFare;
        vm.validateAuthForCorrectFareNew = validateAuthForCorrectFareNew;
        // vm.isNumberKey = isNumberKey;
        vm.ctrlFn = ctrlFn;
        vm.sendVoucher = sendVoucher;
        vm.viewVoucher = viewVoucher;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        $log.log($stateParams);
        vm.typeFromParam = $stateParams.type;
        vm.id = $stateParams.id;
        vm.showAllEvents = false;
        vm.countToSocket = 0;
        vm.domain = checkDomain.getDomainName();
        vm.collectedData = [];
        $scope.addItemPopup = false;
        $scope.amountIsSelected = true;
        // $scope.applicableItemOfChargeList = [];

        //====================socket connection===================
        var myListener = $rootScope.$on('SocketComesDetailsBooking', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data && vm.countToSocket == 0) {
                if (data.res && data.res.message)
                    if ($stateParams.id == data.res.message.booking_id) {
                        vm.labelShowAfterPayment = true;
                        getSingleBooking($stateParams.id, false);
                    }
            }

        });
        $scope.$on('$destroy', myListener);
        //$rootScope.socket.on('socketEventToUser',function(res){
        //    showDriversWithFilterSocket(vm.dataToFill);
        //});


        if ($rootScope.socket.connected == false || $rootScope.socket.connected == 'false') {
            $rootScope.socket.connect();
        }
        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                if ($stateParams.type == '0') {
                    $state.reload('layout.upcomingBookingsMain.upcomingBookings');
                } else if ($stateParams.type == '1') {
                    $state.reload('layout.ongoingBookingsMain.ongoingBookings');
                } else if ($stateParams.type == '2') {
                    $state.reload('layout.completedBookingsMain.completedBookings');
                }
            }
        });

        function vermapa() {
            vm.buttonmap = true;
            vm.mapshow = true;
            setTimeout(function () {
                mapInitialize();
                // getSingleBooking();
                getSingleBooking($stateParams.id, true);
            }, 200)

            // checkForEvents();
        }
        //===============================function to change date============================
        function changeDateFormat(date) {
            // console.log(date);
            var data = date.split('T')[0];
            var newDate = new Date(data);
            //console.log(newDate,date.split('T')[1].split(':')[0],Number(date.split('T')[1].split(':')[1]));
            newDate.setHours(Number(date.split('T')[1].split(':')[0]));
            newDate.setMinutes(Number(date.split('T')[1].split(':')[1]));
            newDate.setSeconds(0);
            // console.log(newDate);
            return newDate;
        };
        //==================hours format=====================
        function changeHoursFormat(data) {
            if (data) {
                var sec_num = parseInt(data, 10); // don't forget the second param
                var hours = Math.floor(sec_num / 3600);
                var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
                var seconds = sec_num - (hours * 3600) - (minutes * 60);

                if (hours < 10) {
                    hours = "0" + hours;
                }
                if (minutes < 10) {
                    minutes = "0" + minutes;
                }
                if (seconds < 10) {
                    seconds = "0" + seconds;
                }
                return hours + ':' + minutes + ':' + seconds;
            } else {
                return '00:00:00';
            }
        }
        function showMore(){
            vm.showAllBookings =  true;
        }
        function showLess(){
            vm.showAllBookings =  false;
        }

        // ============================= Rounding Function ============================= //
        function roundToTwo(num) {
            console.log('debug num', num, +(Math.round(num + "e+2") + "e-2"));
            return +(Math.round(num + "e+2") + "e-2");
        }
        //=================get driver details================
        function getSingleBooking(id, loading) {
            vm.loading = loading;
            vm.countToSocket = vm.countToSocket + 1;
            var promise = getBookings.singleBooking(id);
            promise.then(
                function (payload) {
                    if (payload.title.status == 200) {
                        vm.loading = false;
                        vm.bookingDetails = payload.title.data;
                        vm.onlyShowThreeBookings = vm.bookingDetails.section_details && JSON.parse(JSON.stringify(vm.bookingDetails.section_details));
                        if(vm.bookingDetails.section_details && vm.bookingDetails.section_details.length>3){
                            vm.onlyShowThreeBookings = vm.onlyShowThreeBookings.splice(0, 3);
                        }
                        console.log(vm.onlyShowThreeBookings,vm.bookingDetails.section_details,'asdfasdf')
                        if (vm.bookingDetails && vm.bookingDetails.estimated_distance)
                            vm.estimated_distanceRounded = roundToTwo((vm.bookingDetails.estimated_distance / 1000));
                        vm.countToSocket = 0;
                        // if(vm.bookingDetails.job_status == 1 ||vm.bookingDetails.job_status == 6)
                        checkForEvents(true);
                        //vm.bookingDetails.job_pickup_datetime = changeDateFormat(vm.bookingDetails.job_pickup_datetime);
                        vm.bookingDetails.total_time_travelled_foramtted = changeHoursFormat(vm.bookingDetails.total_time_travelled);
                        vm.bookingDetails.finalRoute = [];
                        vm.total_time_travelled_new = Math.round((vm.bookingDetails.is_adjusted ||
                            (!vm.bookingDetails.is_adjusted && !vm.bookingDetails.charge_for_estimated_travel_time)) ?
                            (vm.bookingDetails.total_time_travelled / 60) : vm.bookingDetails.eta);
                        vm.perKMChanges_new = Math.round(vm.bookingDetails.route_details.perKMChanges *
                            Number((vm.bookingDetails.total_distance_travelled_updated ?
                                vm.bookingDetails.total_distance_travelled_updated :
                                vm.bookingDetails.apply_estimated_distance_variable_fare ?
                                    vm.estimated_distanceRounded :
                                    vm.bookingDetails.total_distance_travelled)));
                        vm.bookingDetails.item_of_chargeBefore = 0;
                        if (vm.bookingDetails.route_details.baseFare) {
                            vm.bookingDetails.route_details.baseFare = parseFloat((vm.bookingDetails.route_details.baseFare).toFixed(2));
                            vm.bookingDetails.total_distance_travelled = parseFloat((vm.bookingDetails.total_distance_travelled).toFixed(2));
                            vm.bookingDetails.route_details.perKMChanges = parseFloat((vm.bookingDetails.route_details.perKMChanges).toFixed(2));
                            vm.bookingDetails.route_details.waitTimeCharges = parseFloat((vm.bookingDetails.route_details.waitTimeCharges).toFixed(2));
                            vm.bookingDetails.route_details.waitTimeInTrip = parseFloat((vm.bookingDetails.route_details.waitTimeInTrip).toFixed(2));
                            vm.bookingDetails.route_details.minimumFare = parseFloat((vm.bookingDetails.route_details.minimumFare).toFixed(2));
                        }
                        console.log('>>>>>>>>>. PAYLOAD >>>>>>>>>>>>', payload.title.data);

                        vm.bookingDetails.total_wait_time = Math.round(vm.bookingDetails.total_wait_time);
                        vm.bookingDetails.wait_time = Math.round(vm.bookingDetails.wait_time);
                        vm.bookingDetails.item_of_charge_amount = Math.round((vm.bookingDetails.item_of_charge_amount));
                        vm.bookingDetails.payment_amount = Math.round((vm.bookingDetails.payment_amount));
                        vm.bookingDetails.item_of_chargeBefore = Math.round((vm.bookingDetails.item_of_chargeBefore));
                        vm.bookingDetails.adjustment_payment_amount = Math.round((vm.bookingDetails.adjustment_payment_amount));
                        vm.bookingDetails.adjustment_amount = Math.round((vm.bookingDetails.adjustment_amount));
                        vm.bookingDetails.promo_type = vm.bookingDetails.promo_type;
                        vm.bookingDetails.discount_amount = vm.bookingDetails.discount_amount;
                        vm.bookingDetails.promo_id = vm.bookingDetails.promo_id;
                        vm.bookingDetails.discount_type = vm.bookingDetails.discount_type;
                        vm.bookingDetails.shared_service_id = vm.bookingDetails.shared_service_id;
                        if (vm.bookingDetails.shared_service_id != null) {
                            vm.tempPickFlag = true;
                        } else {
                            vm.tempPickFlag = false;
                        }
                        vm.bookingDetails.temp_pickup_time = vm.bookingDetails.temp_pickup_time;
                        if (vm.bookingDetails.reasonsForCorrection.length && vm.bookingDetails.job_status == '2') {
                            vm.bookingDetails.newPaymentTotal = vm.bookingDetails.adjustment_payment_amount < 0 ? 0 : Math.round(vm.bookingDetails.adjustment_payment_amount);
                        } else {
                            vm.bookingDetails.newPaymentTotal = Math.round(vm.bookingDetails.payment_amount);
                        }
                        if (vm.bookingDetails.route_type == 0) {
                            vm.bookingDetails.subTotalFare = Number(vm.bookingDetails.route_details.baseFare ? vm.bookingDetails.route_details.baseFare : 0) +
                                Math.round((vm.bookingDetails.route_details.perKMChanges *
                                    (vm.bookingDetails.total_distance_travelled_updated ?
                                        vm.bookingDetails.total_distance_travelled_updated :
                                        vm.bookingDetails.apply_estimated_distance_variable_fare ?
                                            vm.estimated_distanceRounded :
                                            vm.bookingDetails.total_distance_travelled))) +
                                Math.round((vm.bookingDetails.total_wait_time * vm.bookingDetails.route_details.waitTimeCharges)) +
                                Math.round((vm.bookingDetails.wait_time * vm.bookingDetails.route_details.waitTimeInTrip)) +
                                Math.round(((vm.total_time_travelled_new) * vm.bookingDetails.route_details.time_of_trip_price)) +
                                Math.round((vm.bookingDetails.apply_charge_by_toll && vm.bookingDetails.item_of_charge_toll_price ? (vm.bookingDetails.final_heremaps_toll_count * vm.bookingDetails.item_of_charge_toll_price) : vm.bookingDetails.apply_charge_by_toll ? vm.bookingDetails.final_heremaps_total_toll_price : 0));
                        } else {
                            // vm.bookingDetails.subTotalFare = Math.round((vm.bookingDetails.payment_amount - vm.bookingDetails.item_of_charge_amount));
                        }
                        for (var i in vm.bookingDetails.item_of_charge) {
                            vm.bookingDetails.item_of_charge[i].price = Math.round(vm.bookingDetails.item_of_charge[i].price);
                            vm.bookingDetails.item_of_chargeBefore = Math.round((Number(vm.bookingDetails.item_of_chargeBefore) + Number(vm.bookingDetails.item_of_charge[i].price)));
                        }
                        if (vm.bookingDetails.passenger_rut) {
                            vm.bookingDetails.passenger_rut = RutHelper.format(vm.bookingDetails.passenger_rut);
                        }
                        if (vm.bookingDetails.applicant_rut) {
                            vm.bookingDetails.applicant_rut = RutHelper.format(vm.bookingDetails.applicant_rut);
                        }
                        if (vm.bookingDetails.sender_rut) {
                            vm.bookingDetails.sender_rut = RutHelper.format(vm.bookingDetails.sender_rut);
                        }
                        if (vm.bookingDetails.discount_type == 1 && vm.bookingDetails.route_type == 1) {
                            // vm.bookingDetails.net_discount = Math.round((Number(vm.bookingDetails.ride_charges)) * (vm.bookingDetails.discount_amount / 100));
                            vm.bookingDetails.net_discount = vm.bookingDetails.final_discount_amount;

                        } else if (vm.bookingDetails.discount_type == 1 && vm.bookingDetails.route_type == 0) {
                            vm.bookingDetails.net_discount = vm.bookingDetails.final_discount_amount;
                       }
                        vm.bookingDetails.AllRoute = vm.bookingDetails.all_route;

                        if (vm.bookingDetails.job_status == 1 || vm.bookingDetails.job_status == 4 || vm.bookingDetails.job_status == 5 || vm.bookingDetails.job_status == 7 || vm.bookingDetails.job_status == 15) {
                            getBookingLocationApi();
                        } else {
                            console.log('>>>> IN SINGLE >>>');
                            if (vm.bookingDetails.all_route)
                                getCompletedBookingLocation();
                            // else getBookingLocationApi();
                        }

                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }


                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        // ========================show evidence delivery================== //
        function showEvidenceDeliver($event, data) {
            vm.items = data
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/evidenceDeliveryPopUp.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });
            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.showEvidenceOne = true;
                $scope.showEvidenceTwo = false;
                console.log('debug', items);
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
            }
        };

        // ========================show evidence no delivery================== //
        function showEvidenceNoDeliver($event, data) {
            vm.items = data
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/evidenceNoDeliveryPopUp.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });
            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                console.log('debug', items);
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
            }
        };




        function downloadVocher(data) {
            var promise = adminAccessService.checkStateValid('Descargar Voucher'); //$stateParams.id
            return promise.then(
                function (payload) {
                    // console.log(payload);
                    // console.log('aaaaa', adminAccessService.getPreviousState());
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (!payload.title.data.granted) {
                            errorMessageFactory.showErrorMessage('No tiene permiso para ejecutar esta opción', 0);
                            //errorMessageFactory.showErrorMessage('Option not available because you not have the right',0);
                            return false;
                        } else {
                            downloadVocherAfterAccess(data);
                            return true;
                        }
                    }
                },
                function (errorPayload) {
                    // console.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
            // console.log(data);
        }


        function downloadVocherAfterAccess(data) {
            vm.loading = true;
            var win = '';
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.job_id = Number(data.job_id);
            var promise = getBookings.makeCreateBookingPdfHeight(dataSend);
            promise.then(function (payload) {
                $log.log('sxdsads', payload);
                vm.loading = false;
                document.getElementById('showPrint').innerHTML = payload.title.data.pdf_html;
                // win = window.open('',"Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=" + (screen.width) + ",height=" + (screen.height) + ",top=0,left=0");
                // $scope.items.loading = false;
                $timeout(function () {
                    // win.document.body.innerHTML = payload.title.data.pdf_html;
                    downloadVocherLink(data, payload.title.data);
                }, 1000);
            },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function copy(data, $element) {
            vm.templateString = '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 ' +
                '                Transitional//EN" ' +
                '                "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">' +
                '<html>' +
                '' +
                '<head>' +
                '    <meta charset="UTF-8">' +
                '    <meta name="viewport" content="width=device-width, ' +
                '                initial-scale=1.0">' +
                '    <title>Ride Over</title>' +
                '' +
                '    <style type="text/css">' +
                '        .mainheader {' +
                '            margin: 0 auto;' +
                '            padding: 0 20px;' +
                '            background-color: rgb(6, 60, 74);' +
                '            width: 750px;' +
                '        }' +
                '' +
                '        .mainLogoTd {' +
                '            height: 80px;' +
                '            border: none;' +
                '        }' +
                '' +
                '        .tableStyle {' +
                '            padding: 0 25px;' +
                '            width: 100%;' +
                '        }' +
                '' +
                '        .LeftTextWidth {' +
                '            width: 70%;' +
                '            padding-top: 15px;' +
                '        }' +
                '' +
                '        .RightTextWidth {' +
                '            width: 30%;' +
                '            padding-top: 15px;' +
                '        }' +
                '' +
                '        .LogotableStyle {' +
                '            border: 0;' +
                '            width: 100%;' +
                '            text-align: center;' +
                '            padding-top: 0;' +
                '            padding-bottom: 0;' +
                '        }' +
                '' +
                '        .padding30 {' +
                '            padding-top: 30px;' +
                '        }' +
                '' +
                '        .Hey-cutomer {' +
                '            font-family: sans-serif;' +
                '            font-size: 22px;' +
                '            font-weight: 500;' +
                '            letter-spacing: 1px;' +
                '            text-align: left;' +
                '            color: #1f1f1f;' +
                '        }' +
                '' +
                '        .Trip-Details {' +
                '            font-family: sans-serif;' +
                '            font-size: 24px;' +
                '            line-height: 1.4;' +
                '            letter-spacing: 1px;' +
                '            text-align: left;' +
                '            font-weight: bold;' +
                '            color: #242424;' +
                '        }' +
                '' +
                '        .pickAddress {' +
                '            font-family: sans-serif;' +
                '            font-size: 18px;' +
                '            letter-spacing: 1.1px;' +
                '            text-align: left;' +
                '            color: #262626;' +
                '        }' +
                '' +
                '        .You-Rode-with-James {' +
                '            font-family: sans-serif;' +
                '            font-size: 18px;' +
                '            font-weight: 600;' +
                '            line-height: 1.4;' +
                '            text-align: left;' +
                '            color: #070707;' +
                '        }' +
                '' +
                '        .LeftText {' +
                '            font-family: sans-serif;' +
                '            font-size: 20px;' +
                '            letter-spacing: 1.1px;' +
                '            text-align: left;' +
                '            color: #000000;' +
                '        }' +
                '' +
                '        .RightText {' +
                '            font-family: sans-serif;' +
                '            font-size: 20px;' +
                '            font-weight: bold;' +
                '            letter-spacing: 1.1px;' +
                '            text-align: right;' +
                '            color: #000000;' +
                '        }' +
                '' +
                '        .Fare-Breakdown {' +
                '            font-family: sans-serif;' +
                '            font-size: 18px;' +
                '            font-weight: 600;' +
                '            line-height: 1.4;' +
                '            text-align: left;' +
                '            color: #000000;' +
                '        }' +
                '' +
                '        .TOTAL-FARE-Tk-880 {' +
                '            font-family: sans-serif;' +
                '            font-size: 23px;' +
                '            font-weight: bold;' +
                '            line-height: .87;' +
                '            text-align: right;' +
                '            color: #a5a1ff;' +
                '        }' +
                '' +
                '        .Fare-Details {' +
                '            font-family: sans-serif;' +
                '            font-size: 18px;' +
                '            line-height: .87;' +
                '            color: #1f1f1f;' +
                '        }' +
                '' +
                '        .straightLine {' +
                '            padding-top: 20px;' +
                '            border-bottom: 1px solid #b3b3b3;' +
                '        }' +
                '' +
                '        .footerTable {' +
                '            border: 0;' +
                '            background-color: rgb(6, 60, 74);' +
                '            width: 100%;' +
                '        }' +
                '' +
                '        .Float-text {' +
                '            float: right;' +
                '        }' +
                '' +
                '        .Clear-all {' +
                '            clear: both;' +
                '        }' +
                '' +
                '        .Fair-full-details {' +
                '            font-family: sans-serif;' +
                '            font-size: 17px;' +
                '            line-height: .87;' +
                '            text-align: right;' +
                '            color: #1f1f1f;' +
                '        }' +
                '' +
                '        .Visibilty {' +
                '            visibility: hidden;' +
                '        }' +
                '' +
                '        .Background-adjust {' +
                '            background-color: lightgray;' +
                '            padding: 5px;' +
                '        }' +
                '' +
                '        .Total-Fair {' +
                '            font-size: 35px;' +
                '            font-weight: 600;' +
                '            text-align: left;' +
                '            padding-top: 5px;' +
                '        }' +
                '' +
                '        .Total-Fair-1 {' +
                '            font-size: 35px;' +
                '            font-weight: 600;' +
                '            text-align: right;' +
                '            padding-top: 5px;' +
                '        }' +
                '' +
                '        .Text-Align {' +
                '            text-align: left;' +
                '        }' +
                '' +
                '        .Text-Right {' +
                '            text-align: right;' +
                '        }' +
                '' +
                '        .Font-Size-Adjust {' +
                '            font-size: 12px;' +
                '        }' +
                '' +
                '        .Font-Size-Customer {' +
                '            font-family: sans-serif;' +
                '            font-size: 22px;' +
                '            line-height: .87;' +
                '            text-align: left;' +
                '            color: #1f1f1f;' +
                '        }' +
                '' +
                '        .AddressDetails {' +
                '            font-family: sans-serif;' +
                '            font-size: 22px;' +
                '            line-height: .87;' +
                '            text-align: left;' +
                '            font-weight: bold;' +
                '            color: #1f1f1f;' +
                '        }' +
                '' +
                '        .padding10 {' +
                '            padding-top: 10px;' +
                '        }' +
                '' +
                '        .disance-Details {' +
                '            font-family: sans-serif;' +
                '            font-size: 20px;' +
                '            line-height: .87;' +
                '            text-align: left;' +
                '            color: #1f1f1f;' +
                '        }' +
                '' +
                '        .Marker-image {' +
                '            width: 30px;' +
                '        }' +
                '' +
                '        .Tarifa-text {' +
                '            font-family: sans-serif;' +
                '            font-size: 22px;' +
                '            line-height: .87;' +
                '            text-align: left;' +
                '            font-weight: bold;' +
                '            color: #1f1f1f;' +
                '        }' +
                '' +
                '        .ObservationText {' +
                '            font-family: sans-serif;' +
                '            font-size: 14px;' +
                '            line-height: .87;' +
                '            text-align: left;' +
                '            color: #1f1f1f;' +
                '            border: 2px solid #1f1f1f;' +
                '        }' +
                '' +
                '        .bottomtext {' +
                '            font-family: sans-serif;' +
                '            font-size: 15px;' +
                '            line-height: .87;' +
                '            text-align: left;' +
                '            color: #1f1f1f;' +
                '        }' +
                '' +
                '        .footerImage {' +
                '            display: block;' +
                '            margin: 0 auto;' +
                '        }' +
                '' +
                '        .footerImageText {' +
                '            color: #FFFFFF;' +
                '            margin-top: 7px;' +
                '            text-align: center;' +
                '        }' +
                '' +
                '        .tableStyleWithoutPadding {' +
                '            width: 100%;' +
                '        }' +
                '' +
                '        pre {' +
                '            font-family: sans-serif;' +
                '            padding: 4px;' +
                '            margin: 4px;' +
                '        }' +
                '' +
                '        .createdText {' +
                '            color: orange;' +
                '            font-size: 18px;' +
                '        }' +
                '' +
                '        .heading {' +
                '            color: black;' +
                '            font-weight: bold;' +
                '            padding-left: 20px;' +
                '            font-size: 18px;' +
                '        }' +
                '' +
                '        .vip {' +
                '            float: right;' +
                '            color: red;' +
                '            font-weight: bold;' +
                '            font-size: 16px;' +
                '            padding-right: 30px;' +
                '            padding-bottom: 20px;' +
                '        }' +
                '' +
                '        .headingRight {' +
                '            float: right;' +
                '            color: black;' +
                '            /* font-weight: bold; */' +
                '            font-size: 18px;' +
                '            padding-right: 50px;' +
                '            padding: 8px 20px 8px 0px;' +
                '            min-height: 16px;' +
                '        }' +
                '    </style>' +
                '</head>' +
                '' +
                '<body>' +
                '    <table style=" margin: 0 auto;padding: 20px 20px; background-color: rgb(6, 60, 74);width: 600px;">' +
                '        <tbody>' +
                '            <tr style="background-color:#fff;color:#FFFFFF;">' +
                '                <td style="padding:10px">' +
                '                    <table style="border:0;width:100%;">' +
                '                        <tr style= "font-style:normal;line-height:15px">' +
                '                            <td style="color: black;font-weight: bold;font-size: 16px;">' +
                '                                Reserva:' +
                '                            </td>' +
                '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                '                                {{vm.bookingDetails.job_id}}' +
                '' + '                       <td style="color: red;font-weight: bold;font-size: 14px;padding-right: 30px;">' +
                '                                {{vip}}' +
                '                            </td>' +
                '                            </td>' +
                '                        </tr>' +
                '                        <tr  style= "font-style:normal;line-height:15px">' +
                '                            <td style="color: black;font-weight: bold;font-size: 16px;">' +
                '                                Nombre:' +
                '                            </td>' +
                '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                '                                {{vm.bookingDetails.customer_username}}' +
                '                            </td>' +
                '                        </tr>' +
                '                        <tr style= "font-style:normal;line-height:15px">' +
                '                            <td style="color: black;font-weight: bold; font-size: 16px;">' +
                '                                Telefono:' +
                '                            </td>' +
                '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                '                                {{vm.bookingDetails.customer_phone}}' +
                '                            </td>' +
                '                        </tr>' +
                '                        <tr style= "font-style:normal;line-height:15px">' +
                '                            <td style="color: black;font-weight: bold; font-size: 16px;">' +
                '                                Correo:' +
                '                            </td>' +
                '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                '                                {{vm.bookingDetails.customer_email}}' +
                '                            </td>' +
                '                        </tr>' +
                '                        <tr style= "font-style:normal;line-height:15px">' +
                '                            <td style="color: black;font-weight: bold; font-size: 16px;">' +
                '                                Origen:' +
                '                            </td>' +
                '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                '                                {{vm.bookingDetails.job_pickup_address}}' +
                '                            </td>' +
                '                        </tr>' +
                '                        <tr style= "font-style:normal;line-height:15px">' +
                '                            <td style="color: black;font-weight: bold; font-size: 16px;width:200px">' +
                '                                Fecha Retiro:' +
                '                            </td>' +
                '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                '                                {{vm.bookingDetails.date}}' +
                '                            </td>' +
                '                        </tr>' +
                '                        <tr style= "font-style:normal;line-height:15px">' +
                '                            <td style="color: black;font-weight: bold;font-size: 16px;width:200px">' +
                '                                Hora retiro:' +
                '                            </td>' +
                '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                '                                {{vm.bookingDetails.time}}' +
                '                            </td>' +
                '                        </tr>' +
                '                        <tr style= "font-style:normal;line-height:15px">' +
                '                            <td style="color: black;font-weight: bold; font-size: 16px;">' +
                '                                Destino:' +
                '                            </td>' +
                '                            <td style=" color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                '                                {{vm.bookingDetails.job_address}}' +
                '                            </td>' +
                '                        </tr>' +
                '                        <tr style= "font-style:normal;line-height:15px">' +
                '                            <td style="color: black;font-weight: bold; font-size: 16px;width:200px">' +
                '                                Tipo Servicio:' +
                '                            </td>' +
                '                            <td style="color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                '                                {{vm.bookingDetails.service_name}}' +
                '                            </td>' +
                '                        </tr>' +
                '                        <tr style= "font-style:normal;line-height:15px">' +
                '                            <td style="color: black;font-weight: bold;font-size: 16px;width:200px">' +
                '                                Num. Pasajeros:' +
                '                            </td>' +
                '                            <td style="color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                '                                {{vm.bookingDetails.number_of_passangers}}' +
                '                            </td>' +
                '                        </tr>' +
                '                        <tr style= "font-style:normal;line-height:15px">' +
                '                            <td style="color: black;font-weight: bold; font-size: 16px;">' +
                '                                Estado:' +
                '                            </td>' +
                '                            <td style="color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                '                                {{vm.bookingDetails.Estado}}' +
                '                            </td>' +
                '                        </tr>' +
                '                        <tr style= "font-style:normal;line-height:15px">' +
                '                            <td style="color: black;font-weight: bold; font-size: 16px;">' +
                '                                Convenio:' +
                '                            </td>' +
                '                            <td style="color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                '                                {{vm.bookingDetails.contract_name}}' +
                '                            </td>' +
                '                        </tr>' +
                '                        <tr style= "font-style:normal;line-height:15px">' +
                '                            <td style="color: black;font-weight: bold;font-size: 16px;width:200px">' +
                '                                Tarifa estimada:' +
                '                            </td>' +
                '                            <td style="color: black; font-size: 16px;padding-right: 50px;padding: 8px 20px 0px 0px;">' +
                '                                {{vm.bookingDetails.estimated_payment_cost}} / {{vm.bookingDetails.fare}}' +
                '                            </td>' +
                '                        </tr>' +
                '                    </table>' +
                '' +
                '                </td>' +
                '            </tr>' +
                '        </tbody>' +
                '    </table>' +
                '</body>' +
                '' +
                '</html>';
            vm.string = vm.templateString;
            if (vm.bookingDetails.payment_status == 1 || vm.bookingDetails.payment_status == 1) {
                vm.string = vm.string.replace('{{vm.bookingDetails.Estado}}', 'PAGADA');
            } else {
                vm.string = vm.string.replace('{{vm.bookingDetails.Estado}}', 'NO PAGADA');
            }
            if (vm.bookingDetails.job_time_utc) {
                var time = moment(vm.bookingDetails.job_time_utc).format('HH:mm')
                vm.string = vm.string.replace('{{vm.bookingDetails.time}}', time);
            }
            if (vm.bookingDetails.job_time_utc) {
                var date = moment(vm.bookingDetails.job_time_utc).format('MMMM Do YYYY')
                vm.string = vm.string.replace('{{vm.bookingDetails.date}}', date);
            }
            if (vm.bookingDetails.route_type == 1) {
                vm.string = vm.string.replace('{{vm.bookingDetails.fare}}', 'FIJA');
            } else {
                vm.string = vm.string.replace('{{vm.bookingDetails.fare}}', 'Variable');
            }
            if (vm.bookingDetails.is_vip && vm.bookingDetails.is_vip == 1) {
                vm.string = vm.string.replace('{{vip}}', 'VIP');
            } else {
                vm.string = vm.string.replace('{{vip}}', '')
            }

            function numberWithCommas(x) {
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            };
            vm.string = vm.string.replace('{{vm.bookingDetails.job_id}}', JSON.stringify(vm.bookingDetails.job_id));
            vm.string = vm.string.replace('{{vm.bookingDetails.customer_phone}}', vm.bookingDetails.customer_phone);
            vm.string = vm.string.replace('{{vm.bookingDetails.customer_username}}', vm.bookingDetails.customer_username);
            vm.string = vm.string.replace('{{vm.bookingDetails.job_pickup_address}}', vm.bookingDetails.job_pickup_address);
            vm.string = vm.string.replace('{{vm.bookingDetails.customer_email}}', vm.bookingDetails.customer_email);
            vm.string = vm.string.replace('{{vm.bookingDetails.job_address}}', vm.bookingDetails.job_address);
            vm.string = vm.string.replace('{{vm.bookingDetails.service_name}}', vm.bookingDetails.service_name);
            vm.string = vm.string.replace('{{vm.bookingDetails.contract_name}}', vm.bookingDetails.contract_name);
            vm.string = vm.string.replace('{{vm.bookingDetails.number_of_passangers}}', vm.bookingDetails.number_of_passangers);
            vm.string = vm.string.replace('{{vm.bookingDetails.estimated_payment_cost}}', '$' + numberWithCommas(vm.bookingDetails.estimated_payment_cost));
            document.getElementById('copy').value = vm.string;
            var copyText = document.getElementById('copy');
            // console.log(document.getElementById("copy"));
            copyText.select();
            document.execCommand("copy");
            if (document.execCommand("copy") == true) {
                errorMessageFactory.showErrorMessage("Resumen copiado correctamente", 0);
            }

        }

        function downloadVocherLink(data) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.job_id = Number(data.job_id);
            //dataSend.pdf_html = pdfData.pdf_html;
            dataSend.height = $('#showPrint').height() + 300;
            vm.loading = true;
            var parentEl = angular.element($document.body);
            var promise = getBookings.makeCreateBookingPdf(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    console.log(payload, 'payload puneet');
                    vm.loading = false;
                    download_file(payload.title.data.pdfLink, 'Voucher_Reserva_' + data.job_id + '.pdf');
                    // var link = 'https://s3-sa-east-1.amazonaws.com/testattattachment/booking_1151.pdf';
                    // var link = document.createElement("a");
                    // link.download = 'https://s3-sa-east-1.amazonaws.com/testattattachment/booking_1151.pdf';
                    // link.href = 'Voucher_Reserva_' + data.job_id + '.pdf';
                    // link.click();

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function download_file(fileURL, fileName) {
            // for non-IE
            // console.log(fileName, 'name');

            if (!window.ActiveXObject) {
                var save = document.createElement('a');
                save.href = fileURL;
                save.target = '_blank';
                var filename = fileURL.substring(fileURL.lastIndexOf('/') + 1);
                save.download = fileName || filename;
                if (navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                    document.location = save.href;
                    // window event not working here
                } else {
                    var evt = new MouseEvent('click', {
                        'view': window,
                        'bubbles': true,
                        'cancelable': false
                    });
                    save.dispatchEvent(evt);
                    (window.URL || window.webkitURL).revokeObjectURL(save.href);
                }
            }

            // for IE < 11
            else if (!!window.ActiveXObject && document.execCommand) {
                var _window = window.open(fileURL, '_blank');
                _window.document.close();
                _window.document.execCommand('SaveAs', true, fileName || fileURL)
                _window.close();
            }
        }
        //=======================get completed booking location===================
        function getCompletedBookingLocation() {
            console.log("fat ja");
            if(vm.bookingDetails.is_telephonica){
                //drawSectionMarkers(vm.bookingDetails);
                lineaRutaCondutorIncompleta(map, vm.bookingDetails, true);
                return;
            }
            var location = new google.maps.LatLng(vm.bookingDetails.job_pickup_latitude, vm.bookingDetails.job_pickup_longitude);
            placeMarker(map, 'http://labs.google.com/ridefinder/images/mm_20_green.png', location, 'pick', vm.bookingDetails.job_pickup_address);
            if (vm.bookingDetails.actual_job_longitude != '00.00000' && vm.bookingDetails.actual_job_latitude != '00.00000' && vm.bookingDetails.actual_job_latitude != null && vm.bookingDetails.actual_job_longitude != null) {
                if (vm.bookingDetails.actual_job_longitude == vm.bookingDetails.job_longitude && vm.bookingDetails.actual_job_latitude == vm.bookingDetails.job_latitude) {
                    var location = new google.maps.LatLng(vm.bookingDetails.job_latitude, vm.bookingDetails.job_longitude);
                    placeMarker(map, 'http://labs.google.com/ridefinder/images/mm_20_red.png', location, 'drop', vm.bookingDetails.job_address, vm.bookingDetails.completed_datetime);
                } else {
                    var location = new google.maps.LatLng(vm.bookingDetails.job_latitude, vm.bookingDetails.job_longitude);
                    placeMarker(map, 'http://labs.google.com/ridefinder/images/mm_20_red.png', location, 'drop', vm.bookingDetails.job_address);
                    var location = new google.maps.LatLng(vm.bookingDetails.actual_job_latitude, vm.bookingDetails.actual_job_longitude);
                    placeMarker(map, 'http://labs.google.com/ridefinder/images/mm_20_purple.png', location, 'adrop', vm.bookingDetails.actual_job_address, vm.bookingDetails.completed_datetime);
                }
            } else {
                var location = new google.maps.LatLng(vm.bookingDetails.job_latitude, vm.bookingDetails.job_longitude);
                placeMarker(map, 'http://labs.google.com/ridefinder/images/mm_20_red.png', location, 'drop', vm.bookingDetails.job_address);
            }

        }

        //===============get booking location=====================
        function getBookingLocationApi() {
            console.log('>>>>>> in API >>>');
            vm.loading2 = true;
            var dataSend = {};
            dataSend.job_id = Number($stateParams.id);
            dataSend.access_token = $cookies.get('obj');
            var promise = getBookings.getBookingLocation(dataSend);
            promise.then(
                function (payload) {
                    if (payload.title.status == 200) {
                        vm.loading2 = false;
                        vm.bookingDetails.AllRoute = payload.title.data.AllRoute;
                        vm.bookingDetails.route = payload.title.data.route;
                        if (vm.bookingDetails.AllRoute && vm.bookingDetails.AllRoute.length) {
                            vm.bookingDetails.finalRouteNew = vm.bookingDetails.AllRoute;
                        }
                        if (vm.bookingDetails.route && vm.bookingDetails.route.length) {
                            vm.bookingDetails.finalRoute = vm.bookingDetails.route;
                        }
                        if(vm.bookingDetails.is_telephonica){
                            //drawSectionMarkers(vm.bookingDetails);
                            lineaRutaCondutorIncompleta(map, vm.bookingDetails, false);
                            return;
                        }
                        var location = new google.maps.LatLng(vm.bookingDetails.job_pickup_latitude, vm.bookingDetails.job_pickup_longitude);
                        placeMarker(map, 'http://labs.google.com/ridefinder/images/mm_20_green.png', location, 'pick', vm.bookingDetails.job_pickup_address);
                        if (vm.bookingDetails.actual_job_longitude != '00.00000' && vm.bookingDetails.actual_job_latitude != '00.00000' && vm.bookingDetails.actual_job_latitude != null && vm.bookingDetails.actual_job_longitude != null) {
                            if (vm.bookingDetails.actual_job_longitude == vm.bookingDetails.job_longitude && vm.bookingDetails.actual_job_latitude == vm.bookingDetails.job_latitude) {
                                var location = new google.maps.LatLng(vm.bookingDetails.job_latitude, vm.bookingDetails.job_longitude);
                                placeMarker(map, 'http://labs.google.com/ridefinder/images/mm_20_red.png', location, 'drop', vm.bookingDetails.job_address, vm.bookingDetails.completed_datetime);
                            } else {
                                var location = new google.maps.LatLng(vm.bookingDetails.job_latitude, vm.bookingDetails.job_longitude);
                                placeMarker(map, 'http://labs.google.com/ridefinder/images/mm_20_red.png', location, 'drop', vm.bookingDetails.job_address);
                                var location = new google.maps.LatLng(vm.bookingDetails.actual_job_latitude, vm.bookingDetails.actual_job_longitude);
                                placeMarker(map, 'http://labs.google.com/ridefinder/images/mm_20_purple.png', location, 'adrop', vm.bookingDetails.actual_job_address, vm.bookingDetails.completed_datetime);
                            }
                        } else {
                            var location = new google.maps.LatLng(vm.bookingDetails.job_latitude, vm.bookingDetails.job_longitude);
                            placeMarker(map, 'http://labs.google.com/ridefinder/images/mm_20_red.png', location, 'drop', vm.bookingDetails.job_address);
                        }
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading2 = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        //=================go back================
        function goBack() {
            if ($stateParams.type == '0') {
                $state.go('layout.upcomingBookingsMain.upcomingBookings');
            } else if ($stateParams.type == '1') {
                $state.go('layout.ongoingBookingsMain.ongoingBookings');
            } else if ($stateParams.type == '2') {
                $state.go('layout.completedBookingsMain.completedBookings');
            } else if ($stateParams.type == '3') {
                $state.go('layout.searchBookingMain.searchBooking');
            }
        };
        //===================get ALL no show reasons=========================
        function getAllNoShowReasonHit() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = 0;
            dataSend.offset = 0;
            dataSend.status = 0;

            var promise = getNoShowReason.getNoShowReasonList(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    //vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.noShowReason = payload.title.data.result;
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        getAllNoShowReasonHit();
        //=============================mark no show============================
        function markNoShow(data, $event) {
            // console.log(data);
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.job_id = data.job_id;
            vm.loading = true;
            var promise = getBookings.getNoShowData(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    markNoShowPopup(data, $event, payload.title.data);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        function markNoShowPopup(data, $event, noShowData) {
            vm.noShowitems = {
                job_id: data.job_id,
                jobData: data,
                noShowReasonData: vm.noShowReason,
                noShowData: noShowData,
                description: '',
                reasonSelected: '',
                errorMsg: '',
                loading: false
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/noShowMark.html',
                locals: {
                    items: vm.noShowitems
                },
                bindToController: true,
                controller: NoShowMarkController
            });

            function NoShowMarkController($scope, $mdDialog, items) {
                $scope.noShowitems = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    // console.log($scope.noShowitems);
                    changeJobStatusOfBooking($scope.noShowitems, 12);
                };
            }
        }

        function changeJobStatusOfBooking(data, jobStatus) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.job_id = data.job_id;
            dataSend.job_status = jobStatus;
            if (jobStatus == 12) {
                dataSend.noshow_reason = data.reasonSelected;
                dataSend.noshow_comment = data.description;
            }
            vm.loading = true;
            var promise = getBookings.changeJobStatus(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (vm.bookingDetails.job_status == '4' || vm.bookingDetails.job_status == '15') {
                        languageBasedErrorFactory.getProperErrorMessage('noShowSucc', 0, 2, 'layout.ongoingBookingsMain.ongoingBookings');
                        //errorMessageFactory.showErrorMessage('Job status changed successfully.',2,'layout.ongoingBookingsMain.ongoingBookings');
                    } else {
                        languageBasedErrorFactory.getProperErrorMessage('noShowSucc', 0, 2, 'layout.upcomingBookingsMain.upcomingBookings');
                        //errorMessageFactory.showErrorMessage('Job status changed successfully.',2,'layout.upcomingBookingsMain.upcomingBookings');
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        if (jobStatus == 12) {
                            data.errorMsg = errorPayload.data.message;
                            $timeout(function () {
                                data.errorMsg = '';
                            }, 3000);
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                }
            );
        }
        //================set map nulll======================
        function setMapOnAll(map, id) {
            for (var i = 0; i < markers.length; i++) {
                if (markers[i].id == id) {
                    var marker = markers[i];
                    marker.setMap(map);
                }
            }
        };
        // If the map position is out of range, move it back
        function checkBounds(map) {
            if (typeof (map.getBounds()) == 'undefined')
                return;

            var latNorth = map.getBounds().getNorthEast().lat();
            var latSouth = map.getBounds().getSouthWest().lat();
            var newLat;

            if (latNorth < 85 && latSouth > -85) /* in both side -> it's ok */
                return;
            else {
                if (latNorth > 85 && latSouth < -85) /* out both side -> it's ok */
                    return;
                else {
                    if (latNorth > 85)
                        newLat = map.getCenter().lat() - (latNorth - 85);
                    /* too north, centering */
                    if (latSouth < -85)
                        newLat = map.getCenter().lat() - (latSouth + 85);
                    /* too south, centering */
                }
            }
            if (newLat) {
                var newCenter = new google.maps.LatLng(newLat, map.getCenter().lng());
                map.setCenter(newCenter);
            }
        };

        function forCreatingGoogleProposalPath(directionsService, directionsDisplay, lat1, lng1, lat2, lng2, map, allData) {
            var waypts = [];
            directionsDisplay.setMap(map);
            directionsDisplay.setOptions({
                suppressMarkers: true
            });
            var myLatlng = new google.maps.LatLng(lat1, lng1);
            var myLatlng1 = new google.maps.LatLng(lat2, lng2);
            // console.log(directionsService.route);
            directionsService.route({
                origin: myLatlng,
                waypoints: waypts.length ? waypts : [],
                destination: myLatlng1,
                travelMode: 'DRIVING'
            }, function (response, status) {
                if (status === 'OK') {
                    directionsDisplay.setDirections(response);
                    // console.log(response);
                } else {
                    window.alert('Directions request failed due to ' + status);
                }
            });
        }

        function pathActualFollowedByDriver(map, allData) {
            var colorPolyLine = vm.bookingDetails.is_telephonica ? '#ff6900':'#ff0000';
            var poly = new google.maps.Polyline({
                strokeColor: colorPolyLine,
                strokeOpacity: 1,
                strokeWeight: 3,
                map: map
            });
            var path = poly.getPath();
            if (allData.section_details && allData.section_details.length) {
                allData.section_details.forEach(function (section, i) {
                    path.push(new google.maps.LatLng(Number(section.job_real_pickup_latitude), Number(section.job_real_pickup_longitude)));
                });
            }
            if (allData.finalRouteNew && allData.finalRouteNew.length) {
                if (vm.showAllEvents == true) {
                    // console.log('asdsdasdsadsadasdaasdasdsadsadsdasr3423r3');
                    allData.finalRouteNew.forEach(function (data, i) {
                        path.push(new google.maps.LatLng(Number(data.latitude), Number(data.longitude)));
                    });
                } else {
                    allData.finalRoute.forEach(function (data, i) {
                        path.push(new google.maps.LatLng(Number(data.latitude), Number(data.longitude)));
                    });
                }
            }
        }

        function pathActualFollowedByDriverInComplete(map, allData) {
            //var decodedLevels = decodeLevels("BBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB");
            var decodePath = '';
            var colorPolyLine = vm.bookingDetails.is_telephonica ? '#ff6900':'#ff0000';
            if (poly)
                poly.setMap(null);
            if (vm.showAllEvents == true) {
                decodePath = google.maps.geometry.encoding.decodePath(allData.AllRoute);
                var poly = new google.maps.Polyline({
                    //levels: decodedLevels,
                    path: decodePath,
                    strokeColor: colorPolyLine,
                    strokeOpacity: 1,
                    strokeWeight: 3,
                    map: map
                });
                poly.setMap(map);
            } else {
                if (allData.route) {
                    decodePath = google.maps.geometry.encoding.decodePath(allData.route);
                    var poly = new google.maps.Polyline({
                        //levels: decodedLevels,
                        path: decodePath,
                        strokeColor: colorPolyLine,
                        strokeOpacity: 1,
                        strokeWeight: 3,
                        map: map
                    });
                    poly.setMap(map);

                    if(allData.section_details && allData.section_details.length){
                        // Adds Section End Circle to the map.
                        var shape = {
                            coords: [1, 1, 1, 20, 18, 20, 18, 1],
                            type: "poly",
                        };
                        if(allData.is_telephonica){
                            destinoTelefonica(allData, map);
                        } else {
                            for (var i = 0; i < allData.section_details.length; i++) {
                                var section = allData.section_details[i];
                                new google.maps.Marker({
                                  position: { lat: Number(section.job_dropoff_latitude), lng: Number(section.job_dropoff_longitude) },
                                  map: map,
                                  icon: { path: google.maps.SymbolPath.CIRCLE, scale: 4},
                                  shape: shape
                                });
                            } 
                        }
                    }
                }
            }
        }

        function destinoTelefonica(allData, map, click){
            //mostrar solo los puntos de destino cuando es telefonica
            var shape = {
                coords: [1, 1, 1, 20, 18, 20, 18, 1],
                type: "poly",
            };
            for (var i = 0; i < allData.section_details.length; i++) {
                var section = allData.section_details[i];
                var marker = new google.maps.Marker({
                  position: { lat: Number(section.job_dropoff_latitude), lng: Number(section.job_dropoff_longitude) },
                  map: map,
                  icon: { path: google.maps.SymbolPath.CIRCLE, scale: 4},
                  shape: shape
                });

                var fecha = section.job_dropoff_datetime;
                var address = section.job_real_dropoff_address;
                var newContent = '<div class="infoWindowContent">' + '<p><b>Dirección Destino: </b></p>' + '<p>' + address + '</p>';
                if (fecha) {
                    var dateAndTime = $filter('date')(fecha, "medium");
                    newContent += '<p>Fecha y Hora: ' + dateAndTime + '</p>';
                }
                marker.info = new google.maps.InfoWindow({
                    content: newContent 
                });
                google.maps.event.addListener(marker, 'click', function() {
                    marker.info.open(map, marker);
                });
                if(click){
                    google.maps.event.trigger(marker, 'click');
                }
            }
        }

        function lineaRutaCondutorIncompleta(map, allData, complete) {
            var colorPolyLine = vm.bookingDetails.is_telephonica ? '#ff6900':'#ff0000';
            if (allData.route) {
                if( complete ){
                    var decodePath = google.maps.geometry.encoding.decodePath(allData.route);
                } else{
                    var decodePath = [];
                    for (var i in allData.route) {
                        var lat = parseFloat(allData.route[i].latitude);
                        var lon = parseFloat(allData.route[i].longitude);
                        var aux = {lat:lat, lng:lon};
                        decodePath.push(aux);
                    }
                }
                var poly = new google.maps.Polyline({
                    //levels: decodedLevels,
                    path: decodePath,
                    strokeColor: colorPolyLine,
                        strokeOpacity: 1,
                        strokeWeight: 3,
                        map: map
                    });
                    poly.setMap(map);

                if(allData.section_details.length){
                    destinoTelefonica(allData, map);
                }
                drawSectionMarkers(allData);
            }
        }

        function calculateAndDisplayRoute(directionsService, directionsDisplay, lat1, lng1, lat2, lng2, map, allData) {
            // console.log('allData', allData);
            if (allData.job_status == 2 || allData.job_status == 3 || allData.job_status == 8 || allData.job_status == 9 || allData.job_status == 10 || allData.job_status == 11 || allData.job_status == 12) { //completed
                if (allData.all_route)
                    pathActualFollowedByDriverInComplete(map, allData);
                else pathActualFollowedByDriver(map, allData);
            } else if (allData.job_status == 1 || allData.job_status == 4 || allData.job_status == 15) {
                pathActualFollowedByDriver(map, allData);
            } else {
                forCreatingGoogleProposalPath(directionsService, directionsDisplay, lat1, lng1, lat2, lng2, map, allData)
            }
        };
        vm.currentDriverDetailsForMarker = {};

        function placeMarker(map, image, location, data, addressHere, date, indice) {
            var address;
            var imageMarker;
            var labelMarker;

            address = addressHere;
            if (date)
                var dateAndTime = $filter('date')(date, "medium");
            var label = {
                text: data == 'currentDriver' ? address.carUnique.toString() : (vm.labelShowAfterPayment ? JSON.stringify(vm.bookingDetails.uniqueNo) : ''),
                fontSize: '10px'
            };

            if(vm.bookingDetails.is_telephonica && indice != undefined){
                imageMarker = "/assets/images/marker.png";
                var textoMaker = (indice+1).toString();
                labelMarker = { text: textoMaker, fontSize: '11px', fontWeight: "bold", color:'black'};
            } else {
                imageMarker = image == '0' ? '' : image;
                labelMarker = data == 'currentDriver' ? label : '';
            }

            var marker = new google.maps.Marker({
                position: location,
                draggable: false,
                map: map,
                icon: imageMarker,
                id: data,
                label: labelMarker,
                uniqueCarId: data == 'currentDriver' ? address.carUnique.toString() : (vm.labelShowAfterPayment ? JSON.stringify(vm.bookingDetails.uniqueNo) : '')
            });
            bounds.extend(location);
            if (map)
                map.fitBounds(bounds);
            markers.push(marker);
                if (data == 'drop' || data == 'section') {
                calculateAndDisplayRoute(directionsService, directionsDisplay, vm.bookingDetails.job_pickup_latitude, vm.bookingDetails.job_pickup_longitude, vm.bookingDetails.job_latitude, vm.bookingDetails.job_longitude, map, vm.bookingDetails);
            }
            var newContent = '';
            if (data == 'NoShow') {
                newContent = '<div class="infoWindowContent">' + '<p><b>No Show Location: </b></p>' + '<p>' + vm.bookingDetails.noshow_address + '</p>';
                if (date) {
                    newContent += '<p>Fecha y Hora: ' + dateAndTime + '</p>';
                }
                newContent += '</div>';
            }
            if (data == 'drop') {
                newContent = '<div class="infoWindowContent">' + '<p><b>Dirección Destino: </b></p>' + '<p>' + address + '</p>';
                if (date) {
                    newContent += '<p>Fecha y Hora: ' + dateAndTime + '</p>';
                }
                newContent += '</div>';
            } else if (data == 'adrop') {
                newContent = '<div class="infoWindowContent">' + '<p><b>Dirección real de destino: </b></p>' + '<p>' + address + '</p>';
                if (date) {
                    newContent += '<p>Fecha y Hora: ' + dateAndTime + '</p>';
                }
                newContent += '</div>';
            } else if (data == 'pick') {
                newContent = '<div class="infoWindowContent">' + '<p><b>Dirección Retiro: </b></p>' + '<p>' + address + '</p>';
                if (date) {
                    newContent += '<p>Fecha y Hora: ' + dateAndTime + '</p>';
                }
                newContent += '</div>';
            } else if (data == 'accepted') {
                newContent = '<div class="infoWindowContent">' + '<p><b>Viaje aceptado: </b></p>' + '<p>' + address + '</p>';
                if (date) {
                    newContent += '<p>Fecha y Hora: ' + dateAndTime + '</p>';
                }
                newContent += '</div>';
            } else if (data == 'onRoad') {
                newContent = '<div class="infoWindowContent">' + '<p><b>En camino: </b></p>' + '<p>' + address + '</p>';
                if (date) {
                    newContent += '<p>Fecha y Hora: ' + dateAndTime + '</p>';
                }
                newContent += '</div>';
            } else if (data == 'arrived') {
                newContent = '<div class="infoWindowContent">' + '<p><b>En posición: </b></p>' + '<p>' + address + '</p>';
                if (date) {
                    newContent += '<p>Fecha y Hora: ' + dateAndTime + '</p>';
                }
                newContent += '</div>';
            } else if (data == 'started') {
                newContent = '<div class="infoWindowContent">' + '<p><b>Viaje iniciado: </b></p>' + '<p>' + address + '</p>';
                if (date) {
                    newContent += '<p>Fecha y Hora: ' + dateAndTime + '</p>';
                }
                newContent += '</div>';
            } else if (data == 'searchAddress') {
                newContent = '<div class="infoWindowContent">' + '<p><b>Searched Location: </b></p>' + '<p>' + address + '</p>';
                if (date) {
                    newContent += '<p>Fecha y Hora: ' + dateAndTime + '</p>';
                }
                newContent += '</div>';
            } else if (data == 'currentDriver') {
                vm.currentDriverDetailsForMarker = {
                    map: map,
                    image: image,
                    location: location,
                    data: data,
                    addressHere: addressHere,
                    date: date,
                    label: data == 'currentDriver' ? label : '',
                    carUnique: data == 'currentDriver' ? address.carUnique.toString() : (vm.labelShowAfterPayment ? JSON.stringify(vm.bookingDetails.uniqueNo) : '')
                }
                newContent = '<div class="infoWindowContent">' + '<p class="vehicleBD"><b>Vehicle: ' + address.carUnique + '</b></p>' +
                    '<p class="etaBD"> Llegada estimada: ' + address.eta + ' min</p>' +
                    '<p class="etaBD">' + address.speed + ' Km/h</p>' +
                    '<p class="addressBD">Address: ' + address.address + '</p>';
                if (date) {
                    newContent += '<p class="text-center">Fecha y Hora: ' + dateAndTime + '</p>';
                }
                newContent += '</div>';
            } else if (data == 'section') {
                var sectionNumber = address+1;
                newContent = '<div class="sectionTrip infoWindowContent">' + '<p><b>' + sectionNumber + '</p></b>';
                newContent += '</div>';
            }
            infowindow = new google.maps.InfoWindow({
                content: newContent //'<div class="infoWindowContent">' + '<p><b>Drop off Location: </b></p>' + '<p>' + address + '</p>' + '</div>',
                // maxWidth: 160
            });
            infowindow.open(map, marker);
            google.maps.event.addListener(marker, 'click', function () {
                infowindow.setContent(newContent);
                infowindow.open(map, marker);
            });

        };

        // checkForEvents();
        function mapInitialize() {
            mapProp = {
                center: myCenter,
                zoom: Number(zoomLevel),
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                minZoom: 3,
                maxZoom: 18,
                scrollwheel: false,
                fullscreenControl: false
            };

            map = new google.maps.Map(document.getElementById("googleMapBookingDetails"), mapProp);
            google.maps.event.addListener(map, 'center_changed', function () {
                checkBounds(map);
            });
        };

        function drawSectionMarkers(data) {
            if (data && data.section_details.length) {
                for (var i = 0; i < markers.length; i++) {
                    markers[i].setMap(null);
                }
                markers = []
                data.section_details.forEach(function (section, index) {
                    var locPick = new google.maps.LatLng(section.job_real_pickup_latitude, section.job_real_pickup_longitude);
                    //let locDrop = new google.maps.LatLng(section.job_dropoff_latitude, section.job_dropoff_longitude);
                    placeMarker(map, 'http://labs.google.com/ridefinder/images/mm_20_red.png', locPick, 'pick', section.job_real_pickup_address, section.job_pickup_datetime, index);
                });
            }   
        }


        //=======================show map events=============================
        function checkForEvents(data) {
            // console.log(data, vm.bookingDetails);
            console.log("puneet here in veiw");

            if (data) {
                for (var i = 0; i < markers.length; i++) {
                    markers[i].setMap(null);
                }
                markers = [];
                if(vm.bookingDetails.is_telephonica){
                    if (vm.bookingDetails && vm.bookingDetails.section_details.length) {
                        destinoTelefonica(vm.bookingDetails, map, true);
                        vm.bookingDetails.section_details.forEach(function (section, index) {
                            var locPick = new google.maps.LatLng(section.job_real_pickup_latitude, section.job_real_pickup_longitude);
                            //let locDrop = new google.maps.LatLng(section.job_dropoff_latitude, section.job_dropoff_longitude);
                            placeMarker(map, 'http://labs.google.com/ridefinder/images/mm_20_red.png', locPick, 'pick', section.job_real_pickup_address, section.job_pickup_datetime, index, true);
                            //placeMarker(map, 'http://labs.google.com/ridefinder/images/mm_20_red.png', locDrop, 'drop', section.job_pickup_address, section.job_dropoff_datetime, index);
                        });
                    }  
                    return;
                }
                // mapInitialize();
                var location = new google.maps.LatLng(vm.bookingDetails.job_pickup_latitude, vm.bookingDetails.job_pickup_longitude);
                placeMarker(map, 'http://labs.google.com/ridefinder/images/mm_20_green.png', location, 'pick', vm.bookingDetails.job_pickup_address);
                if (vm.bookingDetails.job_status == 12) {
                    if (vm.bookingDetails.noshow_latitude != null && vm.bookingDetails.noshow_longitude != null) {
                        var location = new google.maps.LatLng(vm.bookingDetails.noshow_latitude, vm.bookingDetails.noshow_longitude);
                        placeMarker(map, 'http://labs.google.com/ridefinder/images/mm_20_purple.png', location, 'NoShow', vm.bookingDetails.noshow_address, vm.bookingDetails.no_show_datetime);
                    }
                }
                if (vm.bookingDetails.actual_job_longitude != '00.00000' && vm.bookingDetails.actual_job_latitude != '00.00000' && vm.bookingDetails.actual_job_latitude != null && vm.bookingDetails.actual_job_longitude != null) {
                    if (vm.bookingDetails.actual_job_longitude == vm.bookingDetails.job_longitude && vm.bookingDetails.actual_job_latitude == vm.bookingDetails.job_latitude) {
                        var location = new google.maps.LatLng(vm.bookingDetails.job_latitude, vm.bookingDetails.job_longitude);
                        placeMarker(map, 'http://labs.google.com/ridefinder/images/mm_20_red.png', location, 'drop', vm.bookingDetails.job_address, vm.bookingDetails.completed_datetime);
                    } else {
                        var location = new google.maps.LatLng(vm.bookingDetails.job_latitude, vm.bookingDetails.job_longitude);
                        placeMarker(map, 'http://labs.google.com/ridefinder/images/mm_20_red.png', location, 'drop', vm.bookingDetails.job_address);
                        var location = new google.maps.LatLng(vm.bookingDetails.actual_job_latitude, vm.bookingDetails.actual_job_longitude);
                        placeMarker(map, 'http://labs.google.com/ridefinder/images/mm_20_purple.png', location, 'adrop', vm.bookingDetails.actual_job_address, vm.bookingDetails.completed_datetime);
                    }
                } else {
                    var location = new google.maps.LatLng(vm.bookingDetails.job_latitude, vm.bookingDetails.job_longitude);
                    placeMarker(map, 'http://labs.google.com/ridefinder/images/mm_20_red.png', location, 'drop', vm.bookingDetails.job_address);
                }
                if (vm.bookingDetails.accepted_latitude != '00.00000' && vm.bookingDetails.accepted_longitude != '00.00000' && vm.bookingDetails.accepted_latitude != null && vm.bookingDetails.accepted_longitude != null) {
                    var location = new google.maps.LatLng(vm.bookingDetails.accepted_latitude, vm.bookingDetails.accepted_longitude);
                    placeMarker(map, 'http://labs.google.com/ridefinder/images/mm_20_yellow.png', location, 'accepted', vm.bookingDetails.accepted_address, vm.bookingDetails.acknowledged_datetime);
                }
                if (vm.bookingDetails.arrived_latitude != '00.00000' && vm.bookingDetails.arrived_longitude != '00.00000' && vm.bookingDetails.arrived_latitude != null && vm.bookingDetails.arrived_longitude != null) {
                    var location = new google.maps.LatLng(vm.bookingDetails.arrived_latitude, vm.bookingDetails.arrived_longitude);
                    placeMarker(map, 'http://labs.google.com/ridefinder/images/mm_20_blue.png', location, 'arrived', vm.bookingDetails.arrived_address, vm.bookingDetails.arrived_datetime);
                }
                if (vm.bookingDetails.on_road_latitude != '00.00000' && vm.bookingDetails.on_road_longitude != '00.00000' && vm.bookingDetails.on_road_latitude != null && vm.bookingDetails.on_road_longitude != null) {
                    var location = new google.maps.LatLng(vm.bookingDetails.on_road_latitude, vm.bookingDetails.on_road_longitude);
                    placeMarker(map, 'http://labs.google.com/ridefinder/images/mm_20_brown.png', location, 'onRoad', vm.bookingDetails.on_road_address, vm.bookingDetails.on_road_datetime);
                }
                if (vm.bookingDetails.started_latitude != '00.00000' && vm.bookingDetails.started_longitude != '00.00000' && vm.bookingDetails.started_latitude != null && vm.bookingDetails.started_longitude != null) {
                    var location = new google.maps.LatLng(vm.bookingDetails.started_latitude, vm.bookingDetails.started_longitude);
                    placeMarker(map, 'http://labs.google.com/ridefinder/images/mm_20_gray.png', location, 'started', vm.bookingDetails.started_address, vm.bookingDetails.started_datetime);
                }
                if (vm.bookingDetails.finalRouteNew && vm.bookingDetails.finalRouteNew.length && (vm.bookingDetails.job_status == 1 || vm.bookingDetails.job_status == 4 || vm.bookingDetails.job_status == 15)) {
                    //if(vm.bookingDetails.finalRouteNew && vm.bookingDetails.finalRouteNew.length){
                    toShowDriverCurrentLocation();
                }
            } else {
                // mapInitialize();
                for (var i = 0; i < markers.length; i++) {
                    markers[i].setMap(null);
                }
                markers = []
                if(vm.bookingDetails.is_telephonica){
                    if (vm.bookingDetails && vm.bookingDetails.section_details.length) {
                        vm.bookingDetails.section_details.forEach(function (section, index) {
                            var locPick = new google.maps.LatLng(section.job_real_pickup_latitude, section.job_real_pickup_longitude);
                            //let locDrop = new google.maps.LatLng(section.job_dropoff_latitude, section.job_dropoff_longitude);
                            placeMarker(map, 'http://labs.google.com/ridefinder/images/mm_20_red.png', locPick, 'pick', section.job_real_pickup_address, section.job_pickup_datetime, index);
                            //placeMarker(map, 'http://labs.google.com/ridefinder/images/mm_20_red.png', locDrop, 'drop', section.job_dropoff_address, section.job_dropoff_datetime, index);
                        });
                    }  
                    return;
                }
                var location = new google.maps.LatLng(vm.bookingDetails.job_pickup_latitude, vm.bookingDetails.job_pickup_longitude);
                placeMarker(map, 'http://labs.google.com/ridefinder/images/mm_20_green.png', location, 'pick', vm.bookingDetails.job_pickup_address);
                if (vm.bookingDetails.job_status == 12) {
                    if (vm.bookingDetails.noshow_latitude != null && vm.bookingDetails.noshow_longitude != null) {
                        var location = new google.maps.LatLng(vm.bookingDetails.noshow_latitude, vm.bookingDetails.noshow_longitude);
                        placeMarker(map, 'http://labs.google.com/ridefinder/images/mm_20_purple.png', location, 'NoShow', vm.bookingDetails.noshow_address, vm.bookingDetails.no_show_datetime);
                    }
                }
                if (vm.bookingDetails.actual_job_longitude != '00.00000' && vm.bookingDetails.actual_job_latitude != '00.00000' && vm.bookingDetails.actual_job_latitude != null && vm.bookingDetails.actual_job_longitude != null) {
                    if (vm.bookingDetails.actual_job_longitude == vm.bookingDetails.job_longitude && vm.bookingDetails.actual_job_latitude == vm.bookingDetails.job_latitude) {
                        var location = new google.maps.LatLng(vm.bookingDetails.job_latitude, vm.bookingDetails.job_longitude);
                        placeMarker(map, 'http://labs.google.com/ridefinder/images/mm_20_red.png', location, 'drop', vm.bookingDetails.job_address, vm.bookingDetails.completed_datetime);
                    } else {
                        var location = new google.maps.LatLng(vm.bookingDetails.job_latitude, vm.bookingDetails.job_longitude);
                        placeMarker(map, 'http://labs.google.com/ridefinder/images/mm_20_red.png', location, 'drop', vm.bookingDetails.job_address);
                        var location = new google.maps.LatLng(vm.bookingDetails.actual_job_latitude, vm.bookingDetails.actual_job_longitude);
                        placeMarker(map, 'http://labs.google.com/ridefinder/images/mm_20_purple.png', location, 'adrop', vm.bookingDetails.actual_job_address, vm.bookingDetails.completed_datetime);
                    }
                } else {
                    var location = new google.maps.LatLng(vm.bookingDetails.job_latitude, vm.bookingDetails.job_longitude);
                    placeMarker(map, 'http://labs.google.com/ridefinder/images/mm_20_red.png', location, 'drop', vm.bookingDetails.job_address);
                }
            }
        }

        function getAddress(data, icon, driverData) {
            var geocoder = geocoder = new google.maps.Geocoder();
            geocoder.geocode({
                'latLng': data
            }, function (results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                    if (results[0]) {
                        $scope.addressGot = results[0].formatted_address;
                        vm.showDriverData.address = $scope.addressGot;
                        placeMarker(map, icon, data, 'currentDriver', driverData, driverData.date);
                        $scope.$apply();
                    }
                }
            });
        }

        function toShowDriverCurrentLocation() {
            var icon = {
                url: '',
                size: new google.maps.Size(70, 70),
                scaledSize: new google.maps.Size(50, 50), // scaled size
                origin: new google.maps.Point(0, 0), // origin
                labelOrigin: new google.maps.Point(25, 15),
                anchor: new google.maps.Point(17, 34) // anchor
            };
            if (vm.bookingDetails.job_status == 7 || vm.bookingDetails.job_status == 15) {
                //icon.url = 'assets/images/on_duty.png';
                icon.url = vm.bookingDetails.vehicle_img_online ? vm.bookingDetails.vehicle_img_online : 'assets/images/on_duty.png';
            } else if (vm.bookingDetails.job_status == 1) {
                //icon.url = 'assets/images/service_started.png';
                icon.url = vm.bookingDetails.vehicle_img_busy ? vm.bookingDetails.vehicle_img_busy : 'assets/images/service_started.png';
            } else if (vm.bookingDetails.job_status == 4) {
                //icon.url = 'assets/images/at_position.png';
                icon.url = vm.bookingDetails.vehicle_img_position ? vm.bookingDetails.vehicle_img_position : 'assets/images/at_position.png';
            }
            vm.showDriverData = {
                address: '',
                eta: vm.bookingDetails.eta,
                carUnique: vm.bookingDetails.uniqueNo,
                speed: ((vm.bookingDetails.finalRouteNew[vm.bookingDetails.finalRouteNew.length - 1].speed) * (3.6)).toFixed(2),
                date: new Date()
            };
            var location = new google.maps.LatLng(vm.bookingDetails.finalRouteNew[vm.bookingDetails.finalRouteNew.length - 1].latitude, vm.bookingDetails.finalRouteNew[vm.bookingDetails.finalRouteNew.length - 1].longitude);
            getAddress(location, icon, vm.showDriverData);
        }

        function getSearchedAddress(data) {

            if (!data) {
                if (markers && markers.length) {
                    for (var i = 0; i < markers.length; i++) {
                        if (markers[i].id == 'searchAddress')
                            markers[i].setMap(null);
                    }
                }
                bounds = new google.maps.LatLngBounds();
                checkForEvents(vm.showAllEvents);
            }
        }

        function ctrlFn(data) {

            if (markers && markers.length) {
                for (var i = 0; i < markers.length; i++) {
                    if (markers[i].id == 'searchAddress')
                        markers[i].setMap(null);
                }
            }
            var location = new google.maps.LatLng(data.geometry.location.lat(), data.geometry.location.lng());
            placeMarker(map, '0', location, 'searchAddress', data.formatted_address);
        };

        //=====================get available drivers for manual assign===========================
        function driverGetFromManual(data, $event, jobData) {
            $log.log(data);
            vm.items = {
                allDrivers: data.title.data.result,
                selectedDriver: {},
                ShiftErrMsg: '',
                job_id: jobData.job_id,
                jobData: jobData,
                limit: data.title.data.limit,
                offset: 0,
                total: data.title.data.totalCount,
                searchDriver: '',
                onOffDuty: '0',
                allVehicle: '0'
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/selectDriverForCarShift.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });

            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };

                $scope.confirmUpload = function () {
                    if ($scope.items.selectedDriver.fleet_id) {
                        //finalSelectedDriverApi($scope.items);
                        checkBeforeAssignDriver($scope.items, $event);
                        $mdDialog.hide();
                    } else {
                        $scope.items.ShiftErrMsg = languageBasedErrorFactory.getProperErrorMessage('assignPopError', 0, '3');
                        $timeout(function () {
                            $scope.items.ShiftErrMsg = '';
                        }, 2000);
                    }
                };
                $scope.selectDriver = function (data) {
                    $log.log(data);
                    $scope.items.selectedDriver = data;
                };
                var filterTextTimeout = '';
                $scope.getAssignDriverSearch = function (data) {
                    $scope.items.offset = 0;
                    if (data && data.length) {
                        if (filterTextTimeout) $timeout.cancel(filterTextTimeout);
                        filterTextTimeout = $timeout(function () {
                            $scope.getDataDriver('search');
                        }, 500);
                    } else {
                        $scope.items.allDrivers = [];
                        $scope.getDataDriver();
                    }
                };

                $scope.paginationFunction = function () {
                    // console.log($scope.items.allDrivers.length, $scope.items.total);
                    if ($scope.items.allDrivers.length == $scope.items.total) {
                        return;
                    }
                    $scope.items.offset = $scope.items.offset + 10;
                    $scope.getDataDriver();
                }

                $scope.getDataDriverChange = function () {
                    $scope.items.allDrivers = [];
                    $scope.items.offset = 0;
                    $scope.getDataDriver();
                }

                $scope.getDataDriver = function (type) {
                    var dataSend = {
                        access_token: $cookies.get('obj'),
                        job_id: Number(jobData.job_id),
                        limit: $scope.items.limit,
                        offset: $scope.items.offset,
                        item: $scope.items.searchDriver ? $scope.items.searchDriver : '',
                        search_id: $scope.items.searchDriverbyVehicleId ? $scope.items.searchDriverbyVehicleId : '',
                        key: $scope.items.onOffDuty,
                        all_vehicles: $scope.items.allVehicle
                    };
                    vm.loading = true;
                    var promise = getBookings.manualAssignBooking(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            vm.loading = false;
                            $scope.items.total = payload.title.data.totalCount;
                            if (type == 'search') {

                                $scope.items.allDrivers = payload.title.data.result;
                            } else {
                                for (var i = 0; i < payload.title.data.result.length; i++) {
                                    $scope.items.allDrivers.push(payload.title.data.result[i]);
                                }
                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }
            }
        };

        function finalSelectedDriverApi(data) {
            $log.log(data);
            var dataSend = {
                access_token: $cookies.get('obj'),
                job_id: Number(data.job_id),
                fleet_id: Number(data.selectedDriver.fleet_id)
            };
            vm.loading = true;
            var promise = getBookings.manualReassignBookingToFleet(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if ($stateParams.type == '0') {
                        languageBasedErrorFactory.getProperErrorMessage('driverAssignedSucc', 0, 1, 'layout.upcomingBookingsMain.upcomingBookings');
                    } else if ($stateParams.type == '1') {
                        languageBasedErrorFactory.getProperErrorMessage('driverAssignedSucc', 0, 1, 'layout.ongoingBookingsMain.ongoingBookings');
                    } else if ($stateParams.type == '2') {
                        languageBasedErrorFactory.getProperErrorMessage('driverAssignedSucc', 0, 1, 'layout.completedBookingsMain.completedBookings');
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        //===========================manual assign booking=================================
        function manualAssignBooking(data, $event) {
            $log.log(data);
            var dataSend = {
                access_token: $cookies.get('obj'),
                job_id: Number(data.job_id),
                limit: 10,
                offset: 0,
                search_id: '',
                key: 0,
                all_vehicles: 0
            };
            vm.loading = true;
            var promise = getBookings.manualAssignBooking(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    driverGetFromManual(payload, $event, data);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };




        //=====================ShowPopUpForPush ===================
        function ShowPopUpForPush(data, $event) {
            $log.log(vm.bookingDetails, data, $event);

            vm.items = {};
            // vm.items = data;
            vm.items.adminMessageEmpty = false
            vm.items.userName = vm.bookingDetails.customer_first_name + " " + vm.bookingDetails.customer_last_name;
            // console.log(vm.items)

            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/pushNotificationToCustomer.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });

            function DialogController($scope, $mdDialog, items, getDrivers, mapDashboard, getCars) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmSendNotification = function (message) {
                    if (message == '' || message === undefined) {
                        $scope.items.adminMessageEmpty = true;
                        return
                    }
                    $log.log(message);
                    var dataSend = {
                        access_token: $cookies.get('obj'),
                        message: message,
                        customersArray: [vm.bookingDetails.created_by]
                    };
                    vm.loading = true;
                    var promise = getBookings.sendMassivePush(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            vm.loading = false;
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }
            }
        }

        //=============================unassign booking==========================
        function manualUnassignBooking(data, $event) {

            if (data.shared_service_id) {
                if (data.booking_type == 1 || data.booking_type == '1') {
                    var msg = 'La reserva no se puede desasignar porque es parte del servicio compartido #' + data.shared_service_id + ' ya enrutado. Puede cancelar la reserva y crear una nueva, o solicitar que se elimine del servicio compartido enrutado y luego anular la asignación.';
                } else if (data.booking_type == 2 || data.booking_type == '2') {
                    var msg = 'La reserva no se puede cancelar debido a que forma parte del servicio agrupado #' + data.shared_service_id + ' ya creado. Puede cancelar la reserva y crear una nueva, o solicitar que se elimine del servicio agrupado y luego desasignarla';
                }
                errorMessageFactory.showErrorMessage(msg, 0);
                return;
            }

            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('unassginPop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                // console.log('data');
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.job_id = Number(data.job_id);
                vm.loading = false;
                var promise = getBookings.unassignBookingDriver(dataSend);
                promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        if (payload.title.status == 200) {
                            if ($stateParams.type == '0') {
                                languageBasedErrorFactory.getProperErrorMessage('unassginSucc', 0, 1, 'layout.upcomingBookingsMain.upcomingBookings');
                            } else if ($stateParams.type == '1') {
                                languageBasedErrorFactory.getProperErrorMessage('unassginSucc', 0, 1, 'layout.ongoingBookingsMain.ongoingBookings');
                            } else if ($stateParams.type == '2') {
                                languageBasedErrorFactory.getProperErrorMessage('unassginSucc', 0, 1, 'layout.completedBookingsMain.completedBookings');
                            }
                        } else {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                        //errorMessageFactory.showErrorMessage('Driver unassigned from this booking successfully.', 1);
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        };

        //===============get correct fare reason=====================
        function getCorrectFareReasonListApi() {
            var dataSend = {
                access_token: $cookies.get('obj'),
                limit: 0,
                offset: 0,
                status: 0
            };
            var promise = getCorrectFareReason.getCorrectFareReasonList(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    //vm.loading = false;
                    vm.reasonListCorrectFare = payload.title.data.result;
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        getCorrectFareReasonListApi();


        //======================correct fare pop up for new role==========================
        function validateAuthForCorrectFareNew(data, $event, type, newRole) {
            if (type == 'Unassign') {
                if (!vm.unAssignButtonRole) {
                    errorMessageFactory.showErrorMessage('No tiene permiso para ejecutar esta opción', 0);
                    return;
                }
            }
            vm.flagforAdjustFareOldRole = false;
            var promise = adminAccessService.checkStateValid(type); //$stateParams.id
            return promise.then(
                function (payload) {
                    // console.log(payload);
                    // console.log('aaaaa', adminAccessService.getPreviousState());
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (!payload.title.data.granted) {
                            vm.flagforAdjustFareOldRole = false;
                            errorMessageFactory.showErrorMessage('No tiene permiso para ejecutar esta opción', 0);
                            //errorMessageFactory.showErrorMessage('Option not available because you not have the right',0);
                            return false;
                        } else {
                            vm.flagforAdjustFareOldRole = true;
                            newRoleForAdjustFare(data, $event, type, newRole)
                            // openCorrectFarePopUp(data, $event);
                            // return true;
                        }
                    }
                },
                function (errorPayload) {
                    // console.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function newRoleForAdjustFare(data, $event, type, newRole) {
            var domain = checkDomain.getDomainName();
            var payment_id_flag = false;
            if (domain == 'dev' && data.payment_method == 35) {
                payment_id_flag = true;
            } else if (domain == 'test' && data.payment_method == 11) {
                payment_id_flag = true;
            } else if (domain == 'staging' && data.payment_method == 3) {
                payment_id_flag = true;
            } else if (domain == 'production' && data.payment_method == 3) {
                payment_id_flag = true;
            } else if (domain == 'pre-production' && data.payment_method == 3) {
                payment_id_flag = true;
            } else {
                payment_id_flag = false;
            }
            var promise = adminAccessService.checkStateValid(newRole); //$stateParams.id
            return promise.then(
                function (payload) {
                    // console.log(payload);
                    // console.log('aaaaa', adminAccessService.getPreviousState());
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (!payload.title.data.granted) {
                            if (vm.flagforAdjustFareOldRole == true && payment_id_flag == false) {
                                openCorrectFarePopUp(data, $event);
                            } else {
                                errorMessageFactory.showErrorMessage('No tiene permiso para ejecutar esta opción', 0);
                                return false;
                            }
                        } else {
                            if (vm.flagforAdjustFareOldRole == true && payment_id_flag == true) {
                                openCorrectFarePopUp(data, $event);
                            }
                            if (vm.flagforAdjustFareOldRole == true && payment_id_flag == false) {
                                openCorrectFarePopUp(data, $event);
                            }
                            // openCorrectFarePopUp(data, $event);
                            // return true;
                        }
                    }
                },
                function (errorPayload) {
                    // console.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        //======================correct fare pop up for new role==========================


        //======================correct fare pop up==========================
        function validateAuthForCorrectFare(data, $event, type) {
            if (type == 'Unassign') {
                if (!vm.unAssignButtonRole) {
                    errorMessageFactory.showErrorMessage('No tiene permiso para ejecutar esta opción', 0);
                    return;
                }
            }
            var promise = adminAccessService.checkStateValid(type); //$stateParams.id
            return promise.then(
                function (payload) {
                    // console.log(payload);
                    // console.log('aaaaa', adminAccessService.getPreviousState());
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (!payload.title.data.granted) {
                            errorMessageFactory.showErrorMessage('No tiene permiso para ejecutar esta opción', 0);
                            //errorMessageFactory.showErrorMessage('Option not available because you not have the right',0);
                            return false;
                        } else {
                            if (type == 'Unassign') {
                                manualUnassignBooking(data, $event);
                            } else if (type == 'No Show') {
                                markNoShow(data, $event);
                            } else if (type == 'Ver voucher') {
                                viewVoucher(data, $event);
                            } else if (type == 'Enviar voucher') {
                                sendVoucher(data, $event);
                            } else if (type == 'Message To Client') {
                                ShowPopUpForPush(data, $event);
                            }
                            return true;
                        }
                    }
                },
                function (errorPayload) {
                    // console.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        function correctFareApiHit(data, correctFareByItemData, value, sin_pago_noshow, con_pago_noshow) {
            console.log(data);
            data.loading = true;

            var dataSend = {
                access_token: $cookies.get('obj'),
                adjustment_amount: data.settledAmount,
                adjustment_final_amount: data.newAmount,
                reason_for_adjustment: data.reasonSelected,
                comment_for_adjustment: data.comment,
                job_id: data.jobData.job_id,
            };
            var dataToSend = {
                access_token: $cookies.get('obj'),
                reason_for_adjustment: data.reasonSelected,
                comment_for_adjustment: data.comment,
                job_id: data.jobData.job_id,
            };

            if (value === 'amountIsSelected') {
                var promise = getBookings.adjustFareHit(dataSend);
            }
            else if (value === 'itemIsSelected') {
                correctFareByItemData.appliedItemOfCharge.forEach(function (item) {
                    if (item.isItemOfCharge != 0)
                        correctFareByItemData.itemOfChargesFinal.push(item);
                });
                if (correctFareByItemData.selectedItemOfCharges.length > 0) {
                    correctFareByItemData.selectedItemOfCharges.forEach(function (item) {
                        correctFareByItemData.itemOfChargesFinal.push(item);
                    });
                }

                if ((correctFareByItemData.final_toll_price !== null || correctFareByItemData.final_toll_price !== undefined ||
                    correctFareByItemData.final_toll_price !== '') &&
                    (correctFareByItemData.tolls_count !== null || correctFareByItemData.tolls_count !== undefined ||
                        correctFareByItemData.tolls_count !== '')) {
                    dataSend.final_toll_price = correctFareByItemData.final_toll_price;
                    dataSend.tolls_count = correctFareByItemData.tolls_count
                }

                dataSend.route_type = correctFareByItemData.bookingPaymentDataFromApi.job_data.route_type
                // if (correctFareByItemData.selectedItemOfCharges.length > 0)
                dataSend.item_of_charges = correctFareByItemData.itemOfChargesFinal;
                console.log('>>>>>>>>>> LAST >>>>>>>>>>', dataSend.item_of_charges);
                dataSend.item_of_charges.forEach(function (object) {
                    // if(object.is_driver) {
                    $scope.price = object.total;
                    object.total = object.price;
                    object.price = $scope.price;
                    // }
                });
                if (correctFareByItemData.bookingPaymentDataFromApi.job_data.route_type == 0) {
                    dataSend.total_distance_travelled = +(correctFareByItemData.appliedItemOfCharge[0].quantity);
                    dataSend.initialWaitTime = +(correctFareByItemData.appliedItemOfCharge[1].quantity);
                    dataSend.inTripWaitTime = +(correctFareByItemData.appliedItemOfCharge[2].quantity);
                    dataSend.total_time_travelled = +(correctFareByItemData.appliedItemOfCharge[3].quantity);
                } else if (correctFareByItemData.bookingPaymentDataFromApi.job_data.route_type == 1) {
                    dataSend.fixed_charges = +(correctFareByItemData.appliedItemOfCharge[0].total);
                }

                console.log('>>>>>>>>>>>> IN IF >>>>>>>>>', dataSend);
                var promise = getBookings.correctTripPaymentAmountByItem(dataSend);
            } else if (value === 'noShowIsSelected') {
                dataToSend.no_show = 1;
                dataToSend.cancel = 0;
                dataToSend.sin_pago_noshow = sin_pago_noshow;
                dataToSend.con_pago_noshow = con_pago_noshow;
                var promise = getBookings.correctTripPaymentAmountNoshowCancel(dataToSend);
            } else if (value === 'setCancelIsSelected') {
                dataToSend.no_show = 0;
                dataToSend.cancel = 1;
                dataToSend.sin_pago_noshow = sin_pago_noshow;
                dataToSend.con_pago_noshow = con_pago_noshow;
                var promise = getBookings.correctTripPaymentAmountNoshowCancel(dataToSend);
            }
            else if (value === 'noShowIsSelected') {
                dataToSend.no_show = 1;
                dataToSend.cancel = 0;
                dataToSend.sin_pago_noshow = sin_pago_noshow;
                dataToSend.con_pago_noshow = con_pago_noshow;
                var promise = getBookings.correctTripPaymentAmountNoshowCancel(dataToSend);
            }

            else if (value === 'setCancelIsSelected') {
                dataToSend.no_show = 0;
                dataToSend.cancel = 1;
                dataToSend.sin_pago_noshow = sin_pago_noshow;
                dataToSend.con_pago_noshow = con_pago_noshow;
                var promise = getBookings.correctTripPaymentAmountNoshowCancel(dataToSend);
            }

            promise.then(
                function (payload) {
                    $log.log(payload);
                    data.loading = false;
                    $mdDialog.hide();
                    console.log(payload, 'payload');
                    if (payload && payload.title.status == 200) {
                        if ($stateParams.type == '0') {
                            languageBasedErrorFactory.getProperErrorMessage('fareAdjustSuccess', 0, 1, 'layout.upcomingBookingsMain.upcomingBookingDetailsNew');
                        } else if ($stateParams.type == '1') {
                            languageBasedErrorFactory.getProperErrorMessage('fareAdjustSuccess', 0, 1, 'layout.ongoingBookingsMain.ongoingBookingDetailsNew');
                        } else if ($stateParams.type == '2') {
                            languageBasedErrorFactory.getProperErrorMessage('fareAdjustSuccess', 0, 1, 'layout.completedBookingsMain.completedBookingDetailsNew');
                        }
                        $state.reload();
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } //errorMessageFactory.showErrorMessage('Fare adjusted successfully.',1);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    data.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        function openCorrectFarePopUp(data, $event) {
            console.log(vm.reasonListCorrectFare);
            vm.items = {
                loading: false,
                jobData: data,
                settledAmount: 0,
                newAmount: Number(data.newPaymentTotal),
                reasons: vm.reasonListCorrectFare,
                comment: '',
                reasonSelected: '',
                minimumAmount: false,
                quantity: 0,
                unitValue: 0,
                totalItemFare: 0,
                totalAdjustedFare: 0,
                totalAfterAdjustedFare: 0,
                totalAfterItemFare: 0,
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/correctFareBooking.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: CorrectFareController,
                panelClass: 'customDialogWidth'
            });


            function CorrectFareController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.amountIsSelected = true;
                $scope.selectedValue = 'amountIsSelected';
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };

                $scope.amountValue = function (data) {
                    $scope.amountIsSelected = true;
                    $scope.noShowIsSelected = false;
                    $scope.itemIsSelected = false;
                    $scope.setCancelIsSelected = false;
                    $scope.selectedValue = 'amountIsSelected';
                }

                $scope.itemValue = function (data) {
                    $scope.itemIsSelected = true;
                    $scope.amountIsSelected = false;
                    $scope.noShowIsSelected = false;
                    $scope.setCancelIsSelected = false;
                    $scope.selectedValue = 'itemIsSelected';
                    dataForBookingPayment();
                }

                $scope.noShowValue = function (data) {
                    $scope.noShowIsSelected = true;
                    $scope.amountIsSelected = false;
                    $scope.itemIsSelected = false;
                    $scope.setCancelIsSelected = false;
                    $scope.selectedValue = 'noShowIsSelected';
                    $scope.sin_pago_noshow = 1;
                    $scope.con_pago_noshow = 0;
                };

                $scope.cancelValue = function (data) {
                    $scope.setCancelIsSelected = true;
                    $scope.amountIsSelected = false;
                    $scope.noShowIsSelected = false;
                    $scope.itemIsSelected = false;
                    $scope.selectedValue = 'setCancelIsSelected';
                    $scope.sin_pago_noshow = 0;
                    $scope.con_pago_noshow = 0;
                };

                $scope.selectnoDriverNoShowPayment = function (value) {
                    if (value === 'noDriverNoShowPayment') {
                        $scope.sin_pago_noshow = 1;
                        $scope.con_pago_noshow = 0;
                    }
                    else if (value === 'withNoShowPaymentToTheDriver') {
                        $scope.sin_pago_noshow = 0;
                        $scope.con_pago_noshow = 1;
                    }
                }
                $scope.addItem = function () {
                    $scope.addItemPopup = true;
                }

                $scope.applicableItemOfChargeList = [];
                $scope.itemOfChargeSelected = [];

                // $scope.isNumberKey = function (evt) {
                //     var charCode = (evt.which) ? evt.which : evt.keyCode
                //     return !(charCode > 31 && (charCode < 48 || charCode > 57));
                // }

                function dataForBookingPayment() {
                    // $stateParams.id
                    var promise = getServices.dataForBookingPaymentCorrection($stateParams.id);
                    promise.then(
                        function (payload) {
                            $log.log(payload);
                            $scope.bookingPaymentDataFromApi = payload.title.data;
                            $scope.appliedItemOfCharge = [];
                            if ($scope.bookingPaymentDataFromApi && $scope.bookingPaymentDataFromApi.job_data && $scope.bookingPaymentDataFromApi.job_data.route_type == 1)
                                $scope.appliedItemOfCharge.push({
                                    long_name: 'Fixed Fare',
                                    quantity: '-',
                                    price: '-',
                                    total: $scope.bookingPaymentDataFromApi.job_data.ride_charges || 0,
                                    totalAdjustment: $scope.bookingPaymentDataFromApi.job_data.ride_charges || 0,
                                    mode: 1,
                                    isItemOfCharge: 0,
                                });

                            if ($scope.bookingPaymentDataFromApi && $scope.bookingPaymentDataFromApi.job_data && $scope.bookingPaymentDataFromApi.job_data.route_type == 0) {
                                $scope.appliedItemOfCharge.push({
                                    long_name: 'Fare By Kilometer',
                                    quantity: +($scope.bookingPaymentDataFromApi.job_data.is_adjusted ? $scope.bookingPaymentDataFromApi.job_data.total_distance_travelled : $scope.bookingPaymentDataFromApi.job_data.apply_estimated_distance_variable_fare ? $scope.bookingPaymentDataFromApi.job_data.estimated_distance : $scope.bookingPaymentDataFromApi.job_data.total_distance_travelled),
                                    price: +($scope.bookingPaymentDataFromApi.job_data.route_details.perKMChanges) || 0,
                                    total: +(($scope.bookingPaymentDataFromApi.job_data.is_adjusted ? $scope.bookingPaymentDataFromApi.job_data.total_distance_travelled : $scope.bookingPaymentDataFromApi.job_data.apply_estimated_distance_variable_fare ? $scope.bookingPaymentDataFromApi.job_data.estimated_distance : $scope.bookingPaymentDataFromApi.job_data.total_distance_travelled) * $scope.bookingPaymentDataFromApi.job_data.route_details.perKMChanges) || 0,
                                    totalAdjustment: +(($scope.bookingPaymentDataFromApi.job_data.is_adjusted ? $scope.bookingPaymentDataFromApi.job_data.total_distance_travelled : $scope.bookingPaymentDataFromApi.job_data.apply_estimated_distance_variable_fare ? $scope.bookingPaymentDataFromApi.job_data.estimated_distance : $scope.bookingPaymentDataFromApi.job_data.total_distance_travelled) * $scope.bookingPaymentDataFromApi.job_data.route_details.perKMChanges) || 0,
                                    mode: 1,
                                    isItemOfCharge: 0
                                });

                                $scope.appliedItemOfCharge.push({
                                    long_name: 'Fare By Waiting Initial Time',
                                    quantity: +($scope.bookingPaymentDataFromApi.job_data.initialWaitTime) || 0,
                                    price: +($scope.bookingPaymentDataFromApi.job_data.route_details.waitTimeCharges) || 0,
                                    total: +($scope.bookingPaymentDataFromApi.job_data.initialWaitTime * $scope.bookingPaymentDataFromApi.job_data.route_details.waitTimeCharges) || 0,
                                    totalAdjustment: +($scope.bookingPaymentDataFromApi.job_data.initialWaitTime * $scope.bookingPaymentDataFromApi.job_data.route_details.waitTimeCharges) || 0,
                                    mode: 1,
                                    isItemOfCharge: 0
                                });

                                $scope.appliedItemOfCharge.push({
                                    long_name: 'Fare By Waiting Trip Time',
                                    quantity: +($scope.bookingPaymentDataFromApi.job_data.inTripWaitTime) || 0,
                                    price: +($scope.bookingPaymentDataFromApi.job_data.route_details.waitTimeInTrip) || 0,
                                    total: +($scope.bookingPaymentDataFromApi.job_data.inTripWaitTime * $scope.bookingPaymentDataFromApi.job_data.route_details.waitTimeInTrip) || 0,
                                    totalAdjustment: +($scope.bookingPaymentDataFromApi.job_data.inTripWaitTime * $scope.bookingPaymentDataFromApi.job_data.route_details.waitTimeInTrip) || 0,
                                    mode: 1,
                                    isItemOfCharge: 0
                                });

                                $scope.appliedItemOfCharge.push({
                                    long_name: $filter('translate')('byTotalTravelTime'),
                                    quantity: +($scope.bookingPaymentDataFromApi.job_data.total_time_travelled) || 0,
                                    price: +($scope.bookingPaymentDataFromApi.job_data.route_details.time_of_trip_price) || 0,
                                    total: +($scope.bookingPaymentDataFromApi.job_data.total_time_travelled * $scope.bookingPaymentDataFromApi.job_data.route_details.time_of_trip_price) || 0,
                                    totalAdjustment: +($scope.bookingPaymentDataFromApi.job_data.total_time_travelled * $scope.bookingPaymentDataFromApi.job_data.route_details.time_of_trip_price) || 0,
                                    mode: 1,
                                    isItemOfCharge: 0
                                });
                            }
                            if ($scope.bookingPaymentDataFromApi && $scope.bookingPaymentDataFromApi.job_data && $scope.bookingPaymentDataFromApi.job_data.applied_item_of_charges)
                                $scope.bookingPaymentDataFromApi.job_data.applied_item_of_charges.forEach(function (object) {
                                    $scope.appliedItemOfCharge.push({
                                        short_name: object.short_name || '',
                                        quantity: object.quantity,
                                        mode: object.mode,
                                        manually: object.manually,
                                        description: object.description,
                                        fixed_pricing_id: object.fixed_pricing_id,
                                        id: object.id,
                                        item_of_charge_id: object.item_of_charge_id,
                                        long_name: object.long_name,
                                        isItemOfCharge: 1
                                    });
                                    // $scope.appliedItemOfCharge[$scope.appliedItemOfCharge.length - 1].quantity = object.quantity;
                                    if (object.manually == 1) {
                                        // FOR ADMIN
                                        $scope.appliedItemOfCharge[$scope.appliedItemOfCharge.length - 1].is_admin = true;
                                        $scope.appliedItemOfCharge[$scope.appliedItemOfCharge.length - 1].is_driver = false;
                                        $scope.appliedItemOfCharge[$scope.appliedItemOfCharge.length - 1].price = (object.price / parseInt(object.quantity, 10)) || 0;
                                        $scope.appliedItemOfCharge[$scope.appliedItemOfCharge.length - 1].total = object.price || 0;
                                        $scope.appliedItemOfCharge[$scope.appliedItemOfCharge.length - 1].totalAdjustment = object.price || 0;
                                    } else if (object.manually == 0) {

                                        // FOR DRIVER
                                        $scope.appliedItemOfCharge[$scope.appliedItemOfCharge.length - 1].is_admin = false;
                                        $scope.appliedItemOfCharge[$scope.appliedItemOfCharge.length - 1].is_driver = true;
                                        if (object.quantity)
                                            $scope.appliedItemOfCharge[$scope.appliedItemOfCharge.length - 1].price = (object.price / object.quantity) || 0;
                                        else
                                            $scope.appliedItemOfCharge[$scope.appliedItemOfCharge.length - 1].price = (object.price) || 0;

                                        $scope.appliedItemOfCharge[$scope.appliedItemOfCharge.length - 1].total = object.price || 0;
                                        $scope.appliedItemOfCharge[$scope.appliedItemOfCharge.length - 1].totalAdjustment = object.price || 0;
                                    }

                                    if (object.heremapsTolls) {
                                        $scope.appliedItemOfCharge[$scope.appliedItemOfCharge.length - 1].total = object.price || 0;
                                        $scope.appliedItemOfCharge[$scope.appliedItemOfCharge.length - 1].price = object.unitPrice || '-';
                                        $scope.appliedItemOfCharge[$scope.appliedItemOfCharge.length - 1].totalAdjustment = object.price || 0;
                                        $scope.appliedItemOfCharge[$scope.appliedItemOfCharge.length - 1].heremapsTolls = object.heremapsTolls;
                                    }

                                });

                            $scope.route_type = $scope.bookingPaymentDataFromApi.job_data.route_type;
                            $scope.bookingPaymentDataFromApi.job_data.applicable_item_of_charges.forEach(function (data) {
                                $scope.applicableItemOfChargeList.push(data)
                            });
                            calculatePaymentTotal();

                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    )
                }
                $scope.notIncludeDotForKilometer = function ($event, data) {
                    // if (data.long_name == 'Fare By Kilometer')
                    //     if (isNaN(String.fromCharCode($event.keyCode))) {
                    //         $event.preventDefault();
                    //     }
                };

                $scope.notIncludeDotAmount = function ($event, data) {
                    if (data == 'Amount' || data.long_name == 'Fare By Waiting Initial Time' || data.long_name == 'Fare By Waiting Trip Time' || data.id != undefined)
                        if (($event.keyCode) == 46 || ($event.keyCode) == 110 || ($event.keyCode) == 190) {
                            $event.preventDefault();
                        }
                };

                function calculatePaymentTotal() {
                    $scope.newPaymentTotal = 0;
                    $scope.appliedItemOfCharge.forEach(function (item) {
                        $scope.newPaymentTotal += +Math.round(item.totalAdjustment);
                    })
                }
                $scope.removeItemOfCharge = function (item_id) {
                    $scope.appliedItemOfCharge.splice(item_id, 1);

                    calculatePaymentTotal();
                }



                $scope.calculateFare = function (value, index, type) {
                    switch (type) {
                        case 'quantity':
                            $scope.appliedItemOfCharge[index].total = value * $scope.appliedItemOfCharge[index].price;
                            $scope.appliedItemOfCharge[index].totalAdjustment = $scope.appliedItemOfCharge[index].total;
                            break;
                        case 'unitValue':
                            if (value == '') {
                                // $scope.appliedItemOfCharge[index].unitValue = 0;
                                $scope.appliedItemOfCharge[index].total = 0;
                                $scope.appliedItemOfCharge[index].totalAdjustment = 0;
                            } else {
                                $scope.appliedItemOfCharge[index].total = value;
                                $scope.appliedItemOfCharge[index].totalAdjustment = value;
                            }
                            break;
                        case 'total':
                            if (value == '')
                                $scope.appliedItemOfCharge[index].totalAdjustment = 0;
                            else
                                $scope.appliedItemOfCharge[index].totalAdjustment = value;
                            break;
                        default:
                            $scope.appliedItemOfCharge[index].total = (value * $scope.appliedItemOfCharge[index].price) || 0
                            $scope.appliedItemOfCharge[index].totalAdjustment = (value * $scope.appliedItemOfCharge[index].total) || 0;
                            break
                    }
                    calculatePaymentTotal();
                }
                $scope.countOfItemOfCharge = 0;
                $scope.selectingItemOfCharges = function (item, type) {
                    var itemfromdata = item[item.length - 1];
                    var index = $scope.appliedItemOfCharge.indexOf(itemfromdata);
                    if (index == -1 && type == 'add' && !itemfromdata.heremapsTolls) {
                        $scope.appliedItemOfCharge.push({
                            "fixed_pricing_id": itemfromdata.fixed_pricing_id ? itemfromdata.fixed_pricing_id : itemfromdata.variable_pricing_id,
                            "id": itemfromdata.item_of_charge_id.id || 0,
                            "item_of_charge_id": itemfromdata.id || 0,
                            "description": itemfromdata.item_of_charge_id.description,
                            "long_name": itemfromdata.item_of_charge_id.long_name,
                            "manually": itemfromdata.item_of_charge_id.manually,
                            "price": itemfromdata.price || 0,
                            "short_name": itemfromdata.item_of_charge_id.short_name,
                            "mode": itemfromdata.item_of_charge_id.mode,
                            "quantity": itemfromdata.quantity || 1,
                            "isItemOfCharge": 1
                        });
                        $scope.countOfItemOfCharge += 1;
                    }
                    else if (index == -1 && type == 'add' && itemfromdata.heremapsTolls) {
                        $scope.appliedItemOfCharge.push({
                            "id": itemfromdata.item_of_charge_id.id || 0,
                            "item_of_charge_id": itemfromdata.id || 0,
                            "long_name": itemfromdata.item_of_charge_id.long_name,
                            "price": itemfromdata.price || '-',
                            "short_name": itemfromdata.item_of_charge_id.short_name,
                            "quantity": itemfromdata.quantity || 1,
                            "isItemOfCharge": 1,
                            "heremapsTolls": 1,
                            "mode": 1
                        });
                        $scope.countOfItemOfCharge += 1;
                    }


                    // else {
                    // vm.applicableItemOfChargeList.forEach(function (object) {
                    //     $scope.appliedItemOfCharge.forEach(function (innerObject) {
                    //         if (object.id == innerObject.id) {
                    //             $scope.appliedItemOfCharge.splice(innerObject);
                    //         }
                    //     });
                    // });
                    if (type == 'remove') {
                        // appliedItemOfCharge
                        // applicableItemOfChargeLists
                        // $scope.appliedItemOfCharge.length - $scope.countOfItemOfCharge;
                        // $scope.appliedItemOfCharge.forEach(function(object) {
                        //     item.forEach(function(subObject){
                        //         console.log();
                        //     });
                        // });
                        for (var i = ($scope.appliedItemOfCharge.length - $scope.countOfItemOfCharge); i < $scope.appliedItemOfCharge.length; i++) {
                            if (item.length == 0) {
                                $scope.appliedItemOfCharge.pop();
                                $scope.countOfItemOfCharge -= 1;
                                calculatePaymentTotal();
                            } else {
                                var flag = false;
                                item.forEach(function (subObject) {
                                    if (subObject.id == $scope.appliedItemOfCharge[i].item_of_charge_id) {
                                        flag = true;
                                    }
                                });
                                if (!flag) {
                                    $scope.appliedItemOfCharge.splice(i, 1);
                                    $scope.countOfItemOfCharge -= 1;
                                    calculatePaymentTotal();
                                }
                            }
                        }
                    }

                    $scope.calculateFare($scope.appliedItemOfCharge[$scope.appliedItemOfCharge.length - 1].quantity, $scope.appliedItemOfCharge.length - 1)
                }

                $scope.fixedFareValidation = false;
                $scope.confirmUpload = function () {
                    if ($scope.amountIsSelected) {
                        if ($scope.items.newAmount < 0) {
                            $scope.items.minimumAmount = true;
                            $timeout(function () {
                                $scope.items.minimumAmount = false;
                            }, 4000);
                            return;
                        } else {
                            $scope.correctFareByItemData = {
                                booleanValue: $scope.amountIsSelected,
                            }
                            correctFareApiHit($scope.items, $scope.correctFareByItemData, $scope.selectedValue, $scope.sin_pago_noshow, $scope.con_pago_noshow)
                        }
                    } else {
                        if (!$scope.amountIsSelected && $scope.route_type == 1 && $scope.appliedItemOfCharge[0].total < 0) {
                            $scope.fixedFareValidation = true;
                            $timeout(function () {
                                $scope.fixedFareValidation = false;
                            }, 4000);
                            return;
                        } else {
                            $scope.appliedItemOfChargeCopy = angular.copy($scope.appliedItemOfCharge);
                            for (var i = 0; i < $scope.appliedItemOfCharge.length; i++) {
                                if ($scope.appliedItemOfCharge[i].heremapsTolls) {
                                    $scope.final_toll_price = $scope.appliedItemOfCharge[i].total;
                                    $scope.tolls_count = $scope.appliedItemOfCharge[i].quantity;
                                    $scope.appliedItemOfChargeCopy.splice(i, 1);
                                }
                            }
                            $scope.correctFareByItemData = {
                                booleanValue: $scope.amountIsSelected,
                                bookingPaymentDataFromApi: $scope.bookingPaymentDataFromApi,
                                selectedItemOfCharges: $scope.itemOfChargeSelected,
                                appliedItemOfCharge: $scope.appliedItemOfChargeCopy,
                                itemOfChargesFinal: $scope.itemOfChargesFinal
                            }
                            if (($scope.final_toll_price !== null || $scope.final_toll_price !== undefined ||
                                $scope.final_toll_price !== '') && ($scope.tolls_count !== null || $scope.tolls_count !== undefined ||
                                    $scope.tolls_count !== '')) {
                                $scope.correctFareByItemData.final_toll_price = $scope.final_toll_price;
                                $scope.correctFareByItemData.tolls_count = $scope.tolls_count;
                            }
                            console.log('debug $scope.correctFareByItemData', $scope.correctFareByItemData, $scope.appliedItemOfCharge);
                            // return;
                            correctFareApiHit($scope.items, $scope.correctFareByItemData, $scope.selectedValue, $scope.sin_pago_noshow, $scope.con_pago_noshow)
                        }
                    }


                };



                $scope.itemOfChargesFinal = [];
                $scope.makePendingAmountUpdate = function (data) {
                    $scope.items.newAmount = Number($scope.items.jobData.newPaymentTotal);
                    if (data) {
                        $scope.items.newAmount = Number(($scope.items.newAmount + data).toFixed(2));
                    } else {
                        $scope.items.newAmount = Number($scope.items.newAmount.toFixed(2));
                    }
                }
            }
        }

        //=======================send voucher to customer===================
        function sendVoucher(data, $event) {
            console.log(data);

            vm.items = {};
            vm.items.loading = false;
            vm.items.bookingData = data;
            vm.items.emailToSendVoucher = data.job_pickup_email ? data.job_pickup_email : '';

            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/sendVoucherToCustomer.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: SendVoucherController
            });

            function SendVoucherController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };

                $scope.confirmUpload = function () {

                    console.log($scope.items);
                    $scope.items.loading = true;
                    var dataSend = {
                        access_token: $cookies.get('obj'),
                        job_id: $scope.items.bookingData.job_id,
                        email: $scope.items.emailToSendVoucher
                    };
                    var promise = getBookings.sendVoucherToCustomer(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log(payload);
                            $scope.items.loading = false;
                            $mdDialog.hide();
                            languageBasedErrorFactory.getProperErrorMessage('sendVoucherSucc', 0, 0);
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            $scope.items.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }
            }
        }

        //===========================view voucher========================

        function viewVoucher(data, $event) {
            console.log(data);
            vm.loading = true;
            var win = '';
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.job_id = Number(data.job_id);
            var promise = getBookings.makeCreateBookingPdfHeight(dataSend);
            promise.then(function (payload) {
                $log.log('sxdsads', payload);
                vm.loading = false;
                document.getElementById('showPrint').innerHTML = payload.title.data.pdf_html;
                win = window.open('', "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=" + (screen.width) + ",height=" + (screen.height) + ",top=0,left=0");
                // $scope.items.loading = false;
                $timeout(function () {
                    win.document.body.innerHTML = payload.title.data.pdf_html;
                    //  getVoucherLink(data, payload.title.data);
                }, 1000);
            },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function getVoucherLink(data, pdfData) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.job_id = Number(data.job_id);
            //dataSend.pdf_html = pdfData.pdf_html;
            dataSend.height = $('#showPrint').height() + 300;
            vm.loading = true;
            var promise = getBookings.makeCreateBookingPdf(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    window.open(payload.title.data.pdfLink, '_blank');
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        // ************ SOCKET ON MAP FOR LIVE TRACKING ***********
        var trackingSocket = $rootScope.socket.on('socketEventToUser', function (res) {
            vm.socketData = res.message;
            if (vm.socketData && vm.bookingDetails) {
                // FILTER SOCKET DATA
                // CHECK SO THAT BOOKING CAR ID IS EQUAL TO SOCKET ID
                if (vm.bookingDetails.uniqueNo == vm.socketData.unique_car_id) {
                    if ((vm.socketData.job_id == JSON.stringify(vm.bookingDetails.job_id)) && (vm.socketData.job_status != 2))
                        trackingFunction(vm.socketData);
                }
            }
        });

        $scope.$on('$destroy', trackingSocket);
        vm.storeLatAndLong = {
            lat: 0,
            long: 0
        }
        // TRACKING FUNCTION ON MAP FOR ONGOING SCREEN
        function trackingFunction(data) {
            markerGot = '';
            var markerGot = _.where(markers, {
                uniqueCarId: data.unique_car_id
            })[0];
            vm.storeLatAndLong = {
                lat: Number(data.latitude) || 0,
                long: Number(data.longitude) || 0
            }
            var mylatLng = new google.maps.LatLng(Number(data.latitude), Number(data.longitude));
            if (data.job_id && (data.job_status != 2))
                if (markerGot && mylatLng) {
                    // LAT, LONG OBJECT PUSH IN PATH ARRAY OF MAP
                    vm.bookingDetails.finalRouteNew.push({
                        latitude: data.latitude || 0,
                        longitude: data.longitude || 0,
                        speed: data.speed || 0
                    });
                    var estimateDropTime = new Date(new Date(vm.bookingDetails.started_datetime).getTime() + (vm.bookingDetails.eta * 60000));
                    estimateDropTime = $filter('date')(estimateDropTime, "HH:mm");
                    var newContent = '<div class="infoWindowContent">' + '<p class="vehicleBD"><b>Vehicle: ' + data.unique_car_id + '</b></p>' +
                        '<p class="etaBD"> Estimated arrival: ' + estimateDropTime + '</p>' +
                        '<p class="etaBD">' + (data.speed || 0) + ' Km/h</p>';
                    // if (vm.bookingDetails.started_datetime) {
                    //     newContent += '<p class="text-center">Fecha y Hora: ' + $filter('date')(vm.bookingDetails.started_datetime, "medium") + '</p>';
                    // }
                    newContent += '</div>';
                    infowindow.close();
                    infowindow = new google.maps.InfoWindow({
                        content: newContent
                    });
                    infowindow.open(map, markerGot);
                    google.maps.event.addListener(markerGot, 'click', function () {
                        infowindow.close();
                        infowindow.setContent(newContent);
                        infowindow.open(map, markerGot);
                    });
                    pathActualFollowedByDriver(map, vm.bookingDetails)
                    markerGot.setPosition(mylatLng);
                    markers.push(markerGot);
                    vm.collectedData.push(markerGot);
                } else {
                    if (vm.currentDriverDetailsForMarker.location) {
                        var marker = new google.maps.Marker({
                            position: vm.currentDriverDetailsForMarker.location,
                            draggable: false,
                            map: vm.currentDriverDetailsForMarker.map,
                            icon: vm.currentDriverDetailsForMarker.image == '0' ? '' : vm.currentDriverDetailsForMarker.image,
                            id: vm.currentDriverDetailsForMarker.data,
                            label: vm.currentDriverDetailsForMarker.data == 'currentDriver' ? vm.currentDriverDetailsForMarker.label : '',
                            uniqueCarId: vm.currentDriverDetailsForMarker.data == 'currentDriver' ? vm.currentDriverDetailsForMarker.carUnique : ''
                        });
                        bounds.extend(vm.currentDriverDetailsForMarker.location);
                        if (vm.currentDriverDetailsForMarker.map)
                            vm.currentDriverDetailsForMarker.map.fitBounds(bounds);
                        markers.push(marker);

                        markerGot = '';
                        var markerGot = _.where(markers, {
                            uniqueCarId: data.unique_car_id
                        })[0];
                        vm.storeLatAndLong = {
                            lat: Number(data.latitude) || 0,
                            long: Number(data.longitude) || 0
                        }
                        if (data.job_id)
                            if (markerGot && mylatLng) {
                                vm.bookingDetails.finalRouteNew = [];
                                // LAT, LONG OBJECT PUSH IN PATH ARRAY OF MAP
                                vm.bookingDetails.finalRouteNew.push({
                                    latitude: data.latitude || 0,
                                    longitude: data.longitude || 0,
                                    speed: data.speed || 0
                                });
                                var estimateDropTime = new Date(new Date(vm.bookingDetails.started_datetime).getTime() + (vm.bookingDetails.eta * 60000));
                                estimateDropTime = $filter('date')(estimateDropTime, "HH:mm");
                                var newContent = '<div class="infoWindowContent">' + '<p class="vehicleBD"><b>Vehicle: ' + data.unique_car_id + '</b></p>' +
                                    '<p class="etaBD"> Estimated arrival: ' + estimateDropTime + '</p>' +
                                    '<p class="etaBD">' + (data.speed || 0) + ' Km/h</p>';
                                // if (vm.bookingDetails.started_datetime) {
                                //     newContent += '<p class="text-center">Fecha y Hora: ' + $filter('date')(vm.bookingDetails.started_datetime, "medium") + '</p>';
                                // }
                                newContent += '</div>';
                                infowindow.close();
                                infowindow = new google.maps.InfoWindow({
                                    content: newContent
                                });
                                infowindow.open(map, markerGot);
                                google.maps.event.addListener(markerGot, 'click', function () {
                                    infowindow.close();
                                    infowindow.setContent(newContent);
                                    infowindow.open(map, markerGot);
                                });
                                pathActualFollowedByDriver(map, vm.bookingDetails)
                                markerGot.setPosition(mylatLng);
                                markers.push(markerGot);
                                vm.collectedData.push(markerGot);
                            }
                    }
                }
        }
        // ******* FOR GET COMPLETED BOOKING STATUS *******
        var completedSocket = $rootScope.$on('SocketComesCompleted', function (evt, data) {
            vm.labelShowAfterPayment = false;
            if (data.res && data.res.message)
                if ((data.res.message.job_id == JSON.stringify(vm.bookingDetails.job_id)) && data.res.message.job_status == 2) {
                    errorMessageFactory.showErrorMessage('El viaje fue finalizado.', 0);
                    markerGot = '';
                    var markerGot = _.where(markers, {
                        uniqueCarId: vm.bookingDetails.uniqueNo
                    })[0];
                    var mylatLng = new google.maps.LatLng(Number(vm.storeLatAndLong.lat), Number(vm.storeLatAndLong.long));
                    if (markerGot && mylatLng) {
                        var estimateDropTime = new Date(new Date(vm.bookingDetails.started_datetime).getTime() + (vm.bookingDetails.eta * 60000));
                        estimateDropTime = $filter('date')(estimateDropTime, "HH:mm");
                        var newContent = '<div class="infoWindowContent">' + '<p class="vehicleBD"><b>Vehicle: ' + vm.bookingDetails.uniqueNo + '</b></p>' +
                            '<p class="etaBD"> El viaje fue finalizado. </p>';
                        newContent += '</div>';
                        infowindow.close();
                        infowindow = new google.maps.InfoWindow({
                            content: newContent
                        });
                        infowindow.open(map, markerGot);
                        google.maps.event.addListener(markerGot, 'click', function () {
                            infowindow.close();
                            infowindow.setContent(newContent);
                            infowindow.open(map, markerGot);
                        });
                        pathActualFollowedByDriver(map, vm.bookingDetails)
                        markerGot.setPosition(mylatLng);
                        markers.push(markerGot);
                        vm.collectedData.push(markerGot);
                    }
                }

        });

        $scope.$on('$destroy', completedSocket);

        //======================Adjust Agreement pop up==========================
        function validateAuthForCorrectAgreement(data, $event, type) {
            var promise = adminAccessService.checkStateValid(type); //$stateParams.id
            return promise.then(
                function (payload) {
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (!payload.title.data.granted) {
                            languageBasedErrorFactory.getProperErrorMessage('optionNotAvail', 0, 0);
                            //errorMessageFactory.showErrorMessage('Option not available because you not have the right',0);
                            return false;
                        } else {
                            getAgreement(data, $event);
                            return true;
                        }
                    }
                },
                function (errorPayload) {
                    console.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        function getAgreement(data, $event) {
            var dataSend = {
                access_token: $cookies.get('obj'),
                created_by: data.created_by,
            };
            vm.loading = true;
            var promise = getBookings.getCustomerAdjustAgreemtent(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload && payload.title.data.length > 0) {
                        openPopForAdjustAgreement(data, payload.title.data, $event)
                    }
                    // openPopForAdjustAgreement(data,$event);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    $scope.items.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function openPopForAdjustAgreement(bookingData, data, $event) {
            vm.items = {
                loading: false,
                Agreements: data,
                settledAmount: 0,
                jobData: bookingData,
                newAmount: Number(data.newPaymentTotal),
                reasons: vm.reasonListCorrectFare,
                comment: '',
                AgreementsSelected: '',
                minimumAmount: false
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/correctAgreement.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: AdjustAgreementController
            });

            function AdjustAgreementController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    var dataSend = {
                        access_token: $cookies.get('obj'),
                        created_by: Number(bookingData.created_by),
                        job_id: Number(bookingData.job_id),
                        new_agreement_id: Number($scope.items.AgreementsSelected),
                        reason: $scope.items.comment,
                        old_agreement_id: Number(bookingData.contract_id),
                    };
                    console.log(dataSend, 'dataSend');
                    vm.loading = true;
                    var promise = getBookings.AdjustAgreement(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log(payload);
                            vm.loading = false;
                            if (payload && payload.title.status == 200) {
                                getSingleBooking($stateParams.id, false);
                                $mdDialog.hide();
                            }
                            // if (payload && payload.title.data.length > 0) {
                            //     openPopForAdjustAgreement(payload.title.data, $event)
                            // }
                            // openPopForAdjustAgreement(data,$event);
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            $scope.items.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                };
            }
        }
        //======================Adjust Agreement pop up==========================

        function changeDateIntoSpanish(date) {
            var options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            };
            return new Date(date).toLocaleString($cookies.get('language') == 'spanish' ? 'es' : 'en', options)
        }

        function verifyAssignButton(data) {
            vm.loading = true;
            var promise = adminAccessService.checkStateValid(data); //$stateParams.id
            return promise.then(
                function (payload) {
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (data == 'Asignar Manualmente') {
                            vm.loading = false;
                            if (!payload.title.data.granted) {
                                vm.unAssignButtonRole = false;
                                return false;
                            } else {
                                vm.unAssignButtonRole = true;
                            }
                        }
                    }
                },
                function (errorPayload) {
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        verifyAssignButton('Asignar Manualmente');
    }
})();

/**
 * Created by cl-macmini-51 on 5/15/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('EditInvestorDetailsController', EditInvestorDetailsController);

    /** @ngInject */
    function EditInvestorDetailsController($cookies, $state, $log, $rootScope, $timeout, $stateParams, getDrivers, $mdDialog, $document, getCommuna, $scope, moment, getCars,
        RutHelper, getGeofence, getVehicles, languageBasedErrorFactory, errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.getDriver = getDriver;
        vm.goBack = goBack;
        vm.datePickerE_1 = datePickerE_1;
        vm.getComuna = getComuna;
        vm.clickTrigger = clickTrigger;
        vm.editBasicApi = editBasicApi;
        vm.editCarApi = editCarApi;
        vm.rutChange = rutChange;
        vm.rutChange1 = rutChange1
        vm.rutChange2 = rutChange2
        vm.addCarApi = addCarApi;
        vm.addVehicle = addVehicle;
        vm.deleteVehicleType = deleteVehicleType;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.dateOptions = {};
        vm.datePicker_1 = {
            end: false
        };
        vm.driverBankNamesArray = [];
        vm.societies = [];
        vm.getAllVehicles = getAllVehicles;
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.altInputFormats = ['M!/d!/yyyy'];
        $log.log($stateParams);

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.approvedInvestorsMain.editInvestorDetails');
            }
        });

        function rutChange() {
            $log.log('data', vm.dataToFill.RUT);
            if (vm.dataToFill.RUT) {
                if (RutHelper.validate(vm.dataToFill.RUT)) {
                    $log.log();
                    vm.rutFlag = false;
                } else {
                    vm.rutFlag = true;
                }
            } else if (vm.dataToFill.RUT === null) {
                vm.rutFlag = true;
            } else if (vm.dataToFill.RUT === undefined) {
                vm.rutFlag = false;
            }
        }

        function rutChange1() {
            $log.log('data', vm.dataToFill.invoice_rut);
            if (vm.dataToFill.invoice_rut) {
                if (RutHelper.validate(vm.dataToFill.invoice_rut)) {
                    $log.log();
                    vm.rutFlag1 = false;
                } else {
                    vm.rutFlag1 = true;
                }
            } else if (vm.dataToFill.invoice_rut === null) {
                vm.rutFlag1 = true;
            } else if (vm.dataToFill.invoice_rut === undefined) {
                vm.rutFlag1 = false;
            }
        }
        function rutChange2() {
            $log.log('data', vm.dataToFill.account_rut);
            if (vm.dataToFill.account_rut) {
                if (RutHelper.validate(vm.dataToFill.account_rut)) {
                    $log.log();
                    vm.rutFlag = false;
                } else {
                    vm.rutFlag = true;
                }
            } else if (vm.dataToFill.account_rut === null) {
                vm.rutFlag = true;
            } else if (vm.dataToFill.account_rut === undefined) {
                vm.rutFlag = false;
            }
        }
        //======================get all vehicles==============
        function getAllVehicles(skip, limt, filter) {
            vm.loading = true;
            var promise = getVehicles.allVehicles(skip, limt, filter);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    //vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.vehicle = [];
                        angular.forEach(payload.title.data.result, function (column) {
                            if (column.status == 1)
                                vm.vehicle.push({
                                    id: column.id,
                                    name: column.name
                                });
                        });
                        for (var i = 0; i < vm.carDetails.length; i++) {
                            for (var j = 0; j < vm.vehicle.length; j++) {
                                if (vm.vehicle[j].name == vm.carDetails[i].carName) {
                                    vm.carDetails[i].car_type = vm.vehicle[j].id;
                                    break;
                                } else {
                                    vm.carDetails[i].car_type = '';
                                }
                            }
                        }
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //=================get driver details================
        function getDriver(id) {
            vm.loading = true;
            var promise = getDrivers.singleDriver(id);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    //vm.loading = false;
                    vm.driverDetails = payload.title.data.driver_detail;


                    vm.dataToFill = {
                        username: vm.driverDetails.username,
                        fleet_type: vm.driverDetails.fleet_type.toString(),
                        first_name: vm.driverDetails.first_name,
                        last_name: vm.driverDetails.last_name,
                        email: vm.driverDetails.email,
                        country_code: vm.driverDetails.country_code,
                        phone_number: vm.driverDetails.phone,
                        number: vm.driverDetails.number ? vm.driverDetails.number : '',
                        apartment: vm.driverDetails.apartment ? vm.driverDetails.apartment : '',
                        street: vm.driverDetails.street,
                        //sector: vm.driverDetails.sector,
                        region: vm.driverDetails.region,
                        RUT: RutHelper.format(vm.driverDetails.RUT),
                        license_type: vm.driverDetails.license_type,
                        license_expiry_date: new Date(vm.driverDetails.license_expiry_date),
                        branch: Number(vm.driverDetails.branch),
                        fleet_img: '',
                        RUT_img: '',
                        life_sheet_img: '',
                        license_img: '',
                        antecents_certificate: '',
                        company_identity_card: '',
                        company_constitution: '',
                        invoice_rut_image: '',
                        account_rut:vm.driverDetails.account_rut,
                        business_name: vm.driverDetails.business_name,
                        invoice_rut: vm.driverDetails.invoice_rut,
                        payment_modulity: vm.driverDetails.payment_modulity ? vm.driverDetails.payment_modulity.toString() : '',
                        bank_name: vm.driverDetails.bank_name,
                        account_type: vm.driverDetails.account_type ? vm.driverDetails.account_type.toString() : '',
                        account_number: vm.driverDetails.account_number,
                        invoice_stamping: '',
                        start_activities: '',
                        // fleet_route: vm.driverDetails.fleet_route != null ? vm.driverDetails.fleet_route.toString() : vm.driverDetails.fleet_route,
                        work_schedule: vm.driverDetails.work_schedule != null ? vm.driverDetails.work_schedule.toString() : vm.driverDetails.work_schedule,
                        company_type: vm.driverDetails.company_type,
                        addNewCar: [{
                            car_type: '',
                            registration_image_upload: '',
                            car_image_upload: '',
                            registration_number: '',
                            modelity: '',
                            travel_card_key_upload: '',
                            passenger_insurance_key_upload: '',
                            permission_of_circulation_upload: '',
                            transportation_permit_upload: ''
                        }],
                        addNewCarFlag: false
                    };

                    vm.carDetails = vm.driverDetails.car_details;

                    for (var i = 0; i < vm.carDetails.length; i++) {
                        //vm.carDetails[i].car_type = vm.carDetails[i].car_type;
                        vm.carDetails[i].modelity = vm.carDetails[i].modelity.toString();
                        vm.carDetails[i].working_status = vm.carDetails[i].working_status.toString();
                        vm.carDetails[i].registration_image_upload = '';
                        vm.carDetails[i].car_image_upload = '';
                        vm.carDetails[i].travel_card_key_upload = '';
                        vm.carDetails[i].passenger_insurance_key_upload = '';
                        vm.carDetails[i].permission_of_circulation_upload = '';
                        vm.carDetails[i].transportation_permit_upload = '';

                    }
                    getAllVehicles(0, 0, 2);
                    getBranch();
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        getDriver($stateParams.id);

        //==================date picker function==================
        vm.dateOptions = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(2090, 12, 31),
            minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };

        function datePickerE_1() {
            vm.datePicker_1.end = true;
        };
        //====================get comuna list====================
        function getComuna() {
            vm.loading = true;
            var promise = getCommuna.communaList();
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    vm.communaList = payload.title.data;
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        //getComuna();
        //====================get branch list====================
        function getBranch() {
            vm.loading = true;
            var promise = getGeofence.branch();
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        var where = _.where(payload.title.data, {
                            parent_id: 0
                        });
                        vm.branchList = _.where(where, {
                            is_active: 1
                        });
                        var actualBranchGot = '';
                        for (var i = 0; i < vm.branchList.length; i++) {
                            if (vm.dataToFill.branch == vm.branchList[i].region_id) {
                                actualBranchGot = vm.branchList[i].region_id;
                                break;
                            } else {
                                actualBranchGot = '';
                            }
                        }
                        vm.dataToFill.branch = Number(actualBranchGot);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        //==================file upload function========================
        vm.uploadName = '';

        function clickTrigger($event, type, index) {
            $log.log('ddf');
            $event.stopPropagation();
            vm.uploadName = type;
            if (index != null || index != '' || index != undefined) {
                vm.indexGot = index;
            }
            var element = document.getElementById('documentUpload');
            element.click();
        };

        //===============file for customer edit=============
        $scope.file_to_upload = function (File, type) {
            $log.log(type);
            var file = File[0];
            var transcript = File[0];
            var reader = new FileReader;
            reader.onload = function (e) {
                //    var img = new Image;
                //    img.onload = function () {
                if (type == 'PROFILE') {
                    document.getElementById('profilePic').setAttribute('src', e.target.result);
                    vm.dataToFill.fleet_img = File[0];
                } else if (type == 'INVOICE') {
                    document.getElementById('invoice').setAttribute('src', e.target.result);
                    vm.dataToFill.invoice_stamping = File[0];
                } else if (type == 'INVOICE_RUT') {
                    document.getElementById('invoiceRUT').setAttribute('src', e.target.result);
                    vm.dataToFill.invoice_rut_image = File[0];
                } else if (type == 'ACTIVITY') {
                    document.getElementById('activity').setAttribute('src', e.target.result);
                    vm.dataToFill.start_activities = File[0];
                } else if (type == 'CONSTITUTION') {
                    document.getElementById('constitution').setAttribute('src', e.target.result);
                    vm.dataToFill.company_constitution = File[0];
                } else if (type == 'COMPANY_IDENTITY_CARD') {
                    document.getElementById('companyIdentity').setAttribute('src', e.target.result);
                    vm.dataToFill.company_identity_card = File[0];
                } else if (type == 'ANTECENTS') {
                    document.getElementById('antecents').setAttribute('src', e.target.result);
                    vm.dataToFill.antecents_certificate = File[0];
                } else if (type == 'LIFE_SHEET') {
                    document.getElementById('lifeSheet').setAttribute('src', e.target.result);
                    vm.dataToFill.life_sheet_img = File[0];
                } else if (type == 'LICENSE') {
                    document.getElementById('licenseImage').setAttribute('src', e.target.result);
                    vm.dataToFill.license_img = File[0];
                } else if (type == 'RUT') {
                    document.getElementById('rutImage').setAttribute('src', e.target.result);
                    vm.dataToFill.RUT_img = File[0];
                } else if (type == 'CAR_IMAGE') {
                    $log.log(vm.indexGot);
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'carImage' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.carDetails[vm.indexGot].car_image_upload = File[0];
                    }
                } else if (type == 'REGISTER_IMAGE') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'registerImage' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.carDetails[vm.indexGot].registration_image_upload = File[0];
                    }
                } else if (type == 'ADD_CAR_IMAGE') {
                    $log.log(vm.indexGot);
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'addCarImage' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.dataToFill.addNewCar[vm.indexGot].car_image_upload = File[0];
                    }
                } else if (type == 'ADD_REGISTER_IMAGE') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'addRegisterImage' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.dataToFill.addNewCar[vm.indexGot].registration_image_upload = File[0];
                    }
                } else if (type == 'PASSENGER_INSURANCE_KEY') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'seatInsurance' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.carDetails[vm.indexGot].passenger_insurance_key_upload = File[0];
                    }
                } else if (type == 'TRAVEL_CARD_KEY') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'travel' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.carDetails[vm.indexGot].travel_card_key_upload = File[0];
                    }
                } else if (type == 'PERMISSION_OF_CIRCULATION') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'permission' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.carDetails[vm.indexGot].permission_of_circulation_upload = File[0];
                    }
                } else if (type == 'TRANSPORTATION_PERMIT') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'transportation_permit' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.carDetails[vm.indexGot].transportation_permit_upload = File[0];
                    }
                } else if (type == 'ADD_PASSENGER_INSURANCE_KEY') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'addSeatInsurance' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.dataToFill.addNewCar[vm.indexGot].passenger_insurance_key_upload = File[0];
                    }
                } else if (type == 'ADD_TRAVEL_CARD_KEY') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'addTravel' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.dataToFill.addNewCar[vm.indexGot].travel_card_key_upload = File[0];
                    }
                } else if (type == 'ADD_PERMISSION_OF_CIRCULATION') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'addPermission' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.dataToFill.addNewCar[vm.indexGot].permission_of_circulation_upload = File[0];
                    }
                } else if (type == 'ADD_TRANSPORTATION_PERMIT') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'addTransportationPermit' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.dataToFill.addNewCar[vm.indexGot].transportation_permit_upload = File[0];
                    }
                }
                //};

                //    img.src = reader.result;
            };
            reader.readAsDataURL(transcript);
            $log.log(vm.dataToFill);
            $log.log(vm.carDetails);
        };
        //=======================submit basic form===============================
        function editBasicApi() {
            $log.log(vm.dataToFill);
            $log.log(vm.driverDetails);
            if (vm.dataToFill.fleet_type != '2') {
                //if((vm.dataToFill.fleet_img == undefined || vm.dataToFill.fleet_img == null || vm.dataToFill.fleet_img == '') && (vm.driverDetails.fleet_image == undefined || vm.driverDetails.fleet_image == null || vm.driverDetails.fleet_image == '')){
                //    errorMessageFactory.showErrorMessage('Please upload profile pic.');
                //    return;
                //}
                if ((vm.dataToFill.RUT_img == undefined || vm.dataToFill.RUT_img == null || vm.dataToFill.RUT_img == '') && (vm.driverDetails.RUT_image == undefined || vm.driverDetails.RUT_image == null || vm.driverDetails.RUT_image == '')) {
                    //errorMessageFactory.showErrorMessage('Please upload RUT image.');
                    languageBasedErrorFactory.getProperErrorMessage('uploadRUTImage', 0, 0);
                    return;
                }
                if ((vm.dataToFill.license_img == undefined || vm.dataToFill.license_img == null || vm.dataToFill.license_img == '') && (vm.driverDetails.license_img == undefined || vm.driverDetails.license_img == null || vm.driverDetails.license_img == '')) {
                    //errorMessageFactory.showErrorMessage('Please upload license image.');
                    languageBasedErrorFactory.getProperErrorMessage('uploadLicenseImage', 0, 0);
                    return;
                }
                if ((vm.dataToFill.life_sheet_img == undefined || vm.dataToFill.life_sheet_img == null || vm.dataToFill.life_sheet_img == '') && (vm.driverDetails.life_sheet_img == undefined || vm.driverDetails.life_sheet_img == null || vm.driverDetails.life_sheet_img == '')) {
                    //errorMessageFactory.showErrorMessage('Please upload life sheet image.');
                    languageBasedErrorFactory.getProperErrorMessage('uploadLifeSheetImage', 0, 0);
                    return;
                }
                if ((vm.dataToFill.antecents_certificate == undefined || vm.dataToFill.antecents_certificate == null || vm.dataToFill.antecents_certificate == '') && (vm.driverDetails.antecents_certificate == undefined || vm.driverDetails.antecents_certificate == null || vm.driverDetails.antecents_certificate == '')) {
                    //errorMessageFactory.showErrorMessage('Please upload antecedents certificate.');
                    languageBasedErrorFactory.getProperErrorMessage('uploadAntecedentImage', 0, 0);
                    return;
                }
                //if ((vm.dataToFill.company_identity_card == undefined || vm.dataToFill.company_identity_card == null || vm.dataToFill.company_identity_card == '') && (vm.driverDetails.company_identity_card == undefined || vm.driverDetails.company_identity_card == null || vm.driverDetails.company_identity_card == '')) {
                //    errorMessageFactory.showErrorMessage('Please upload company identity card.');
                //    return;
                //}
                //if ((vm.dataToFill.company_constitution == undefined || vm.dataToFill.company_constitution == null || vm.dataToFill.company_constitution == '') && (vm.driverDetails.company_constitution == undefined || vm.driverDetails.company_constitution == null || vm.driverDetails.company_constitution == '')) {
                //    errorMessageFactory.showErrorMessage('Please upload company constitution.');
                //    return;
                //}
                //if ((vm.dataToFill.start_activities == undefined || vm.dataToFill.start_activities == null || vm.dataToFill.start_activities == '') && (vm.driverDetails.start_activities == undefined || vm.driverDetails.start_activities == null || vm.driverDetails.start_activities == '')) {
                //    errorMessageFactory.showErrorMessage('Please upload start activities.');
                //    return;
                //}
                //if ((vm.dataToFill.invoice_stamping == undefined || vm.dataToFill.invoice_stamping == null || vm.dataToFill.invoice_stamping == '') && (vm.driverDetails.invoice_stamping == undefined || vm.driverDetails.invoice_stamping == null || vm.driverDetails.invoice_stamping == '')) {
                //    errorMessageFactory.showErrorMessage('Please upload invoice stamping.');
                //    return;
                //}
            }
            //if (vm.dataToFill.fleet_type == '2') {
            //if((vm.dataToFill.fleet_img == undefined || vm.dataToFill.fleet_img == null || vm.dataToFill.fleet_img == '') && (vm.driverDetails.fleet_image == undefined || vm.driverDetails.fleet_image == null || vm.driverDetails.fleet_image == '')){
            //    errorMessageFactory.showErrorMessage('Please upload profile pic.');
            //    return;
            //}
            //    if ((vm.dataToFill.company_identity_card == undefined || vm.dataToFill.company_identity_card == null || vm.dataToFill.company_identity_card == '') && (vm.driverDetails.company_identity_card == undefined || vm.driverDetails.company_identity_card == null || vm.driverDetails.company_identity_card == '')) {
            //        errorMessageFactory.showErrorMessage('Please upload company identity card.');
            //        return;
            //    }
            //    if ((vm.dataToFill.company_constitution == undefined || vm.dataToFill.company_constitution == null || vm.dataToFill.company_constitution == '') && (vm.driverDetails.company_constitution == undefined || vm.driverDetails.company_constitution == null || vm.driverDetails.company_constitution == '')) {
            //        errorMessageFactory.showErrorMessage('Please upload company constitution.');
            //        return;
            //    }
            //    if ((vm.dataToFill.start_activities == undefined || vm.dataToFill.start_activities == null || vm.dataToFill.start_activities == '') && (vm.driverDetails.start_activities == undefined || vm.driverDetails.start_activities == null || vm.driverDetails.start_activities == '')) {
            //        errorMessageFactory.showErrorMessage('Please upload start activities.');
            //        return;
            //    }
            //    if ((vm.dataToFill.invoice_stamping == undefined || vm.dataToFill.invoice_stamping == null || vm.dataToFill.invoice_stamping == '') && (vm.driverDetails.invoice_stamping == undefined || vm.driverDetails.invoice_stamping == null || vm.driverDetails.invoice_stamping == '')) {
            //        errorMessageFactory.showErrorMessage('Please upload invoice stamping.');
            //        return;
            //    }
            //}
            var dataSend = new FormData();
            dataSend.append('access_token', $cookies.get('obj'));
            dataSend.append('fleet_id', Number($stateParams.id));
            dataSend.append('fleet_type', Number(vm.dataToFill.fleet_type));
            dataSend.append('first_name', vm.dataToFill.first_name);
            dataSend.append('last_name', vm.dataToFill.last_name);
            dataSend.append('email', vm.dataToFill.email);
            dataSend.append('country_code', vm.dataToFill.country_code);
            dataSend.append('phone_number', vm.dataToFill.phone_number);
            dataSend.append('company_type', vm.dataToFill.company_type);
            dataSend.append('street', vm.dataToFill.street);
            //dataSend.append('sector', vm.dataToFill.sector);
            dataSend.append('username', vm.dataToFill.username);
            //dataSend.append('region', vm.dataToFill.region);
            if (vm.dataToFill.fleet_type != '1') {
                dataSend.append('payment_modulity', vm.dataToFill.payment_modulity);
                dataSend.append('account_type', vm.dataToFill.account_type);
                dataSend.append('account_rut', vm.dataToFill.account_rut);
                dataSend.append('account_number', vm.dataToFill.account_number);
                dataSend.append('bank_name', vm.dataToFill.bank_name);
                dataSend.append('invoice_rut', RutHelper.clean(vm.dataToFill.invoice_rut));
                dataSend.append('business_name', vm.dataToFill.business_name);
            }

            if (vm.dataToFill.number) {
                dataSend.append('number', vm.dataToFill.number);
            }
            if (vm.dataToFill.apartment) {
                dataSend.append('apartment', vm.dataToFill.apartment);
            }
            if (vm.dataToFill.invoice_rut_image) {
                dataSend.append('invoice_rut_image', vm.dataToFill.invoice_rut_image);
            }
            if (vm.dataToFill.fleet_type != '2') {
                dataSend.append('work_schedule', Number(vm.dataToFill.work_schedule));
                dataSend.append('RUT', vm.dataToFill.RUT);
                dataSend.append('license_type', vm.dataToFill.license_type);
                dataSend.append('license_expiry_date', moment(vm.dataToFill.license_expiry_date).format('YYYY-MM-DD'));
            }
            //if (vm.dataToFill.fleet_type != '2') {
            //    dataSend.append('RUT', vm.dataToFill.RUT);
            //    dataSend.append('license_type', vm.dataToFill.license_type);
            //    dataSend.append('license_expiry_date', moment(vm.dataToFill.license_expiry_date).format('YYYY-MM-DD'));
            //}
            dataSend.append('branch', vm.dataToFill.branch);
            // dataSend.append('fleet_route', Number(vm.dataToFill.fleet_route));
            if (vm.dataToFill.fleet_img) {
                dataSend.append('fleet_img', vm.dataToFill.fleet_img);
            }
            if (vm.dataToFill.fleet_type != '2') {
                if (vm.dataToFill.RUT_img) {
                    dataSend.append('RUT_img', vm.dataToFill.RUT_img);
                }
                if (vm.dataToFill.license_img) {
                    dataSend.append('license_img', vm.dataToFill.license_img);
                }
                if (vm.dataToFill.life_sheet_img) {
                    dataSend.append('life_sheet_img', vm.dataToFill.life_sheet_img);
                }
                if (vm.dataToFill.antecents_certificate) {
                    dataSend.append('antecents_certificate', vm.dataToFill.antecents_certificate);
                }
                //if (vm.dataToFill.company_identity_card) {
                //    dataSend.append('company_identity_card', vm.dataToFill.company_identity_card);
                //}
                //if (vm.dataToFill.company_constitution) {
                //    dataSend.append('company_constitution', vm.dataToFill.company_constitution);
                //}
                //if (vm.dataToFill.start_activities) {
                //    dataSend.append('start_activities', vm.dataToFill.start_activities);
                //}
                //if (vm.dataToFill.invoice_stamping) {
                //    dataSend.append('invoice_stamping', vm.dataToFill.invoice_stamping);
                //}
            }
            //if (vm.dataToFill.fleet_type == '2') {
            //    if (vm.dataToFill.company_identity_card) {
            //        dataSend.append('company_identity_card', vm.dataToFill.company_identity_card);
            //    }
            //    if (vm.dataToFill.company_constitution) {
            //        dataSend.append('company_constitution', vm.dataToFill.company_constitution);
            //    }
            //    if (vm.dataToFill.start_activities) {
            //        dataSend.append('start_activities', vm.dataToFill.start_activities);
            //    }
            //    if (vm.dataToFill.invoice_stamping) {
            //        dataSend.append('invoice_stamping', vm.dataToFill.invoice_stamping);
            //    }
            //}

            vm.loading = true;
            var promise = getDrivers.editDriver(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        var dataForSysLogs = {
                            access_token: $cookies.get('obj'),
                            id: $stateParams.id,
                            identity: 0, // 0- driver, 1- customer , 2 -car
                            message: 'Investor profile updated.'
                        };
                        $rootScope.systemLogsAdmin(dataForSysLogs);
                        languageBasedErrorFactory.getProperErrorMessage('carInvestorSuccess', 0, 1, 'layout.approvedInvestorsMain.editInvestorDetails');
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    //errorMessageFactory.showErrorMessage('Car investor profile updated successfully.', 1);
                    //$timeout(function() {
                    //    $mdDialog.hide();
                    //    $state.reload();
                    //}, 2000);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );

        };
        //=============================edit car details==============================
        function editCarApi(index, data) {
            $log.log(index);
            $log.log(data);

            // if ((data.car_image_upload == undefined || data.car_image_upload == null || data.car_image_upload == '') && (data.car_photo == undefined || data.car_photo == null || data.car_photo == '')) {
            //     //errorMessageFactory.showErrorMessage('Please upload car image.');
            //     languageBasedErrorFactory.getProperErrorMessage('carImageCheck', 0, 0);
            //     return;
            // }
            // if ((data.registration_image_upload == undefined || data.registration_image_upload == null || data.registration_image_upload == '') && (data.registration_image == undefined || data.registration_image == null || data.registration_image == '')) {
            //     //errorMessageFactory.showErrorMessage('Please upload car registration image.');
            //     languageBasedErrorFactory.getProperErrorMessage('carRegistrationImage', 0, 0);
            //     return;
            // }
            // if ((data.passenger_insurance_key_upload == undefined || data.passenger_insurance_key_upload == null || data.passenger_insurance_key_upload == '') && (data.passenger_insurance_key == undefined || data.passenger_insurance_key == null || data.passenger_insurance_key == '')) {
            //     //errorMessageFactory.showErrorMessage('Please upload passenger seat insurance.');
            //     languageBasedErrorFactory.getProperErrorMessage('carPassengerImage', 0, 0);
            //     return;
            // }
            // if ((data.travel_card_key_upload == undefined || data.travel_card_key_upload == null || data.travel_card_key_upload == '') && (data.travel_card_key == undefined || data.travel_card_key == null || data.travel_card_key == '')) {
            //     //errorMessageFactory.showErrorMessage('Please upload travel card key.');
            //     languageBasedErrorFactory.getProperErrorMessage('carTravelKeyImage', 0, 0);
            //     return;
            // }
            if ((data.permission_of_circulation_upload == undefined || data.permission_of_circulation_upload == null || data.permission_of_circulation_upload == '') && (data.permission_of_circulation == undefined || data.permission_of_circulation == null || data.permission_of_circulation == '')) {
                //errorMessageFactory.showErrorMessage('Please upload permission of circulation.');
                languageBasedErrorFactory.getProperErrorMessage('carCirculationImage', 0, 0);
                return;
            }
            // if ((data.transportation_permit_upload == undefined || data.transportation_permit_upload == null || data.transportation_permit_upload == '') && (data.transportation_permit == undefined || data.transportation_permit == null || data.transportation_permit == '')) {
            //     //errorMessageFactory.showErrorMessage('Please upload permission of circulation.');
            //     languageBasedErrorFactory.getProperErrorMessage('carCirculationImage',0,0);
            //     return;
            // }

            var dataSendCar = new FormData();
            dataSendCar.append('access_token', $cookies.get('obj'));
            dataSendCar.append('fleet_id', $stateParams.id);
            dataSendCar.append('car_id', data.id);
            dataSendCar.append('registration_number', data.registration_number.replace(/ /g, '').toUpperCase());
            dataSendCar.append('car_type', Number(data.car_type));
            dataSendCar.append('modelity', Number(data.modelity));
            dataSendCar.append('working_status', Number(data.working_status));

            // if (data.car_image_upload) {
            //     dataSendCar.append('car_photo', data.car_image_upload);
            // }
            // if (data.registration_image_upload) {
            //     dataSendCar.append('registration_image', data.registration_image_upload);
            // }
            // if (data.passenger_insurance_key_upload) {
            //     dataSendCar.append('passenger_insurance_key', data.passenger_insurance_key_upload);
            // }
            // if (data.travel_card_key_upload) {
            //     dataSendCar.append('travel_card_key', data.travel_card_key_upload);
            // }
            if (data.permission_of_circulation_upload) {
                dataSendCar.append('permission_of_circulation', data.permission_of_circulation_upload);
            }
            if (data.transportation_permit_upload) {
                dataSendCar.append('transportation_permit', data.transportation_permit_upload);
            }
            if (data.society_id) {
                dataSendCar.append('society_id', Number(data.society_id));
            }
            vm.loading = true;
            var promise = getCars.editCarDetails(dataSendCar);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    var dataForSysLogs = {
                        access_token: $cookies.get('obj'),
                        id: data.id,
                        identity: 0, // 0- driver, 1- customer , 2 -car
                        message: 'Investor car details updated.'
                    };
                    $rootScope.systemLogsAdmin(dataForSysLogs);
                    if (payload.title.status == 200) {
                        languageBasedErrorFactory.getProperErrorMessage('carDetailsUpdated', 0, 1, 'layout.approvedInvestorsMain.editInvestorDetails');
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //===================add vehicles======================
        function addVehicle(index) {
            $log.log(index);
            vm.dataToFill.addNewCar.push({
                car_type: '',
                registration_image_upload: '',
                car_image_upload: '',
                registration_number: '',
                travel_card_key_upload: '',
                passenger_insurance_key_upload: '',
                permission_of_circulation_upload: '',
                transportation_permit_upload: ''
            });
        };

        function deleteVehicleType(index) {
            $log.log(index);
            vm.dataToFill.addNewCar.splice(index, 1);
        };

        //====================add new cars api ================================
        function addCarApi() {
            $log.log(vm.dataToFill);
            for (var i = 0; i < vm.dataToFill.addNewCar.length; i++) {
                //   TICKET 2807
                // if (vm.dataToFill.addNewCar[i].car_image_upload == undefined || vm.dataToFill.addNewCar[i].car_image_upload == null || vm.dataToFill.addNewCar[i].car_image_upload == '') {
                //     //errorMessageFactory.showErrorMessage('Please upload car image.');
                //     languageBasedErrorFactory.getProperErrorMessage('carImageCheck', 0, 0);
                //     return;
                // }
                // if (vm.dataToFill.addNewCar[i].registration_image_upload == undefined || vm.dataToFill.addNewCar[i].registration_image_upload == null || vm.dataToFill.addNewCar[i].registration_image_upload == '') {
                //     //errorMessageFactory.showErrorMessage('Please upload car registration image.');
                //     languageBasedErrorFactory.getProperErrorMessage('carRegistrationImage', 0, 0);
                //     return;
                // }
                // if (vm.dataToFill.addNewCar[i].passenger_insurance_key_upload == undefined || vm.dataToFill.addNewCar[i].passenger_insurance_key_upload == null || vm.dataToFill.addNewCar[i].passenger_insurance_key_upload == '') {
                //     //errorMessageFactory.showErrorMessage('Please upload car image.');
                //     languageBasedErrorFactory.getProperErrorMessage('carPassengerImage', 0, 0);
                //     return;
                // }
                // if (vm.dataToFill.addNewCar[i].travel_card_key_upload == undefined || vm.dataToFill.addNewCar[i].travel_card_key_upload == null || vm.dataToFill.addNewCar[i].travel_card_key_upload == '') {
                //     //errorMessageFactory.showErrorMessage('Please upload car registration image.');
                //     languageBasedErrorFactory.getProperErrorMessage('carTravelKeyImage', 0, 0);
                //     return;
                // }
                if (vm.dataToFill.addNewCar[i].permission_of_circulation_upload == undefined || vm.dataToFill.addNewCar[i].permission_of_circulation_upload == null || vm.dataToFill.addNewCar[i].permission_of_circulation_upload == '') {
                    //errorMessageFactory.showErrorMessage('Please upload car registration image.');
                    languageBasedErrorFactory.getProperErrorMessage('carCirculationImage', 0, 0);
                    return;
                }
                // if (vm.dataToFill.addNewCar[i].transportation_permit_upload == undefined || vm.dataToFill.addNewCar[i].transportation_permit_upload == null || vm.dataToFill.addNewCar[i].transportation_permit_upload == '') {
                //     //errorMessageFactory.showErrorMessage('Please upload car registration image.');
                //     languageBasedErrorFactory.getProperErrorMessage('carCirculationImage',0,0);
                //     return;
                // }
            }

            var carArray = [];
            var dataSend = new FormData();
            dataSend.append('fleet_id', $stateParams.id);
            dataSend.append('access_token', $cookies.get('obj'));
            for (var i = 0; i < vm.dataToFill.addNewCar.length; i++) {
                carArray.push({
                    car_type: Number(vm.dataToFill.addNewCar[i].car_type),
                    modelity: Number(vm.dataToFill.addNewCar[i].modelity),
                    registration_number: vm.dataToFill.addNewCar[i].registration_number.replace(/ /g, '').toUpperCase()
                });
                // if (vm.dataToFill.addNewCar[i].car_image_upload) {
                //     dataSend.append('car_photo[]', vm.dataToFill.addNewCar[i].car_image_upload);

                // }
                // if (vm.dataToFill.addNewCar[i].registration_image_upload) {
                //     dataSend.append('registration_image[]', vm.dataToFill.addNewCar[i].registration_image_upload);
                // }
                // if (vm.dataToFill.addNewCar[i].passenger_insurance_key_upload) {
                //     dataSend.append('passenger_insurance_key[]', vm.dataToFill.addNewCar[i].passenger_insurance_key_upload);
                // }
                // if (vm.dataToFill.addNewCar[i].travel_card_key_upload) {
                //     dataSend.append('travel_card_key[]', vm.dataToFill.addNewCar[i].travel_card_key_upload);
                // }
                if (vm.dataToFill.addNewCar[i].permission_of_circulation_upload) {
                    dataSend.append('permission_of_circulation[]', vm.dataToFill.addNewCar[i].permission_of_circulation_upload);
                }
                if (vm.dataToFill.addNewCar[i].transportation_permit_upload) {
                    dataSend.append('transportation_permit[]', vm.dataToFill.addNewCar[i].transportation_permit_upload);
                }
            }
            dataSend.append('car_details', JSON.stringify(carArray));
            vm.loading = true;
            var promise = getCars.addCarDetails(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    //errorMessageFactory.showErrorMessage('Car added successfully.', 1);
                    languageBasedErrorFactory.getProperErrorMessage('carAddedSuccess', 0, 0);
                    //$timeout(function() {
                    //    $mdDialog.hide();
                    //    $state.reload();
                    //}, 2000);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //=================go back================
        function goBack() {
            if ($stateParams.path == '1') {
                $state.go('layout.approvedInvestorsMain.approvedInvestor');
            } else if ($stateParams.path == '0') {
                $state.go('layout.pendingInvestorsMain.pendingInvestor');
            }
        };

        // ***** GET DRIVER BACK NAMES *********
        function getDriverBankNames() {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            var promise = getDrivers.driverBankNames(dataSend);
            promise.then(
                function (payload) {
                    vm.loading = false;
                    vm.driverBankNamesArray = payload.title || [];
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }

            );
        }
        getDriverBankNames();

        // ***** GET SOCIETIES *********
         function getAllSocieties() {
            var dataSend = {};
            // dataSend.access_token = $cookies.get('obj');
            vm.loading = true;
            var promise = getDrivers.societiesList();
            promise.then(
                function (payload) {
                    if (payload.title.status == 200) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        vm.societies = payload.title.data;       
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }

                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };
        getAllSocieties();
    }
})();

/**
 * Created by cl-macmini-51 on 5/12/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('InvestorDetailsController', InvestorDetailsController);

    /** @ngInject */
    function InvestorDetailsController($cookies, $state, $log, $rootScope, $timeout, $stateParams, getDrivers, $mdDialog, $document,RutHelper,$scope,languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.getDriver = getDriver;
        vm.goBack = goBack;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        $log.log($stateParams);

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.approvedInvestorsMain.investorDetails');
            }
        });

        //=================get driver details================
        function getDriver(id) {
            vm.loading = true;
            var promise = getDrivers.singleDriver(id);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    vm.driverDetail = payload.title.data.driver_detail;
                    vm.driverDetail.RUT = RutHelper.format(vm.driverDetail.RUT);
                    vm.driverDetail.invoice_rut = RutHelper.format(vm.driverDetail.invoice_rut);
                    vm.driverDetail.account_rut = RutHelper.format(vm.driverDetail.account_rut);
                    if(vm.driverDetail.apartment){
                        if(vm.driverDetail.number){
                            vm.driverDetail.addressFormed = vm.driverDetail.street + ', ' + vm.driverDetail.number + ', ' + vm.driverDetail.apartment;
                        }
                        else{
                            vm.driverDetail.addressFormed = vm.driverDetail.street + ', ' + vm.driverDetail.apartment;
                        }
                    }
                    else{
                        if(vm.driverDetail.number){
                            vm.driverDetail.addressFormed = vm.driverDetail.street + ', ' + vm.driverDetail.number;
                        }
                        else{
                            vm.driverDetail.addressFormed = vm.driverDetail.street;
                        }
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        }
        getDriver($stateParams.id);
        //=================go back================
        function goBack() {
            if($stateParams.path == '1'){
                $state.go('layout.approvedInvestorsMain.approvedInvestor');
            }
            else if($stateParams.path == '0'){
                $state.go('layout.pendingInvestorsMain.pendingInvestor');
            }
        };
    }
})();
/**
 * Created by cl-macmini-51 on 5/12/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('ApprovedInvestorController', ApprovedInvestorController);

    /** @ngInject */
    function ApprovedInvestorController($cookies, $state, $log, $rootScope, $timeout, getDrivers, $scope, filterFilter, $mdDialog, $document, getGeofence, languageBasedErrorFactory, errorMessageFactory, pendingRequests, moment, getFilters) {
        var vm = this;
        vm.getAllDrivers = getAllDrivers;
        $log.log('driver');
        vm.loading = false;
        vm.currentPage = 0;
        vm.totalDrivers = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.filterTextTimeout = '';
        vm.getPagesCount = getPagesCount;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.init = init;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.blockUnblockDriver = blockUnblockDriver;
        vm.deleteUser = deleteUser;
        vm.exportToCSV = exportToCSV;
        vm.branchChanged = branchChanged;
        vm.vehicleChanged = vehicleChanged;
        vm.refreshData = refreshData;
        vm.getUniqueNumber = getUniqueNumber;
        vm.paginationNew = paginationNew;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.predicate = 'index';
        vm.reverse = false;
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
        vm.filterData = {
            filter_branch: 0, //0, 1
            filter_modelity: 0, //0, 1
            filter_vehicle: 0, //0, 1
            branch: 'all',
            vehicle_unique: '',
            limit: vm.itemsPerPageGot,
            offset: 0,
            driver: 1,
            search_filter: 0,
            search_value: ''
        };

        vm.paginationChangedForBranch = paginationChangedForBranch;
        vm.branchSearch = branchSearch;
        vm.branchOffset = 0;
        vm.globalLimit = 10;
        vm.globalOffset = vm.globalLimit;
        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'vehicle', 'service', 'agreement', 'corporatesList', 'operation_point'];

        vm.branchList = [];
        vm.branchList.push({
            region_name: 'All',
            region_id: 'all'
        });

        if ($rootScope.socket.connected == false || $rootScope.socket.connected == 'false') {
            $rootScope.socket.connect();
        }

        // =================== FILTER OBJECT ===================
        vm.filterObject = {
            access_token: $cookies.get('obj'),
            branch_filter: 1,
            vehicle_filter: 0,
            service_filter: 0,
            agreement_filter: 0,
            corporate_filter: 0,
            service_category: 0,
            corporate_status: 0,
            agreement_status: 0,
            vehicle__status: 0,
            operation_point_filter: 0,
            branch_limit: vm.globalLimit,
            branch_offset: vm.branchOffset
        }

        setTimeout(function () {
            document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                // if (vm.branchList && (vm.branchList.length == 0)) {
                vm.searchBranchData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

        })

        function clearOffset() {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                vm[vm.searchFilterArray[i] + 'Offset'] = 0;
            }

        }
        // =================== GET FILTER DATA ===================
        function getFilterDataFromBackend(data, type) { //Acc to Index ['branch_search', 'vehicle_search', 'service_search', 'agreement_search', 'corporate_search', 'operation_point_search']
            if (data) {
                vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
            } else {
                vm.filterObject = {
                    access_token: $cookies.get('obj'),
                    branch_filter: 1,
                    vehicle_filter: 0,
                    service_filter: 0,
                    agreement_filter: 0,
                    corporate_filter: 0,
                    service_category: 0,
                    corporate_status: 0,
                    agreement_status: 0,
                    vehicle__status: 0,
                    operation_point_filter: 0,
                    branch_search_filter: 0,
                    vehicle_search_filter: 0,
                    service_search_filter: 0,
                    agreement_search_filter: 0,
                    corporate_search_filter: 0,
                    operation_point_search_filter: 0
                }
            }

            vm.filterObject.branch_limit = vm.globalLimit;
            vm.filterObject.branch_offset = vm.branchOffset;

            var promise = getFilters.getAllFilterData(vm.filterObject);
            promise.then(
                function (payload) {

                    // ********** BRANCH DATA ********
                    if (payload.title.data.branches) {
                        var index = _.findIndex(vm.branchList, {
                            region_id: 'all'
                        });
                        if (index == -1)
                            vm.branchList.push({
                                region_name: 'All',
                                region_id: 'all'
                            });
                        angular.forEach(payload.title.data.branches.data, function (column) {
                            var branchIndex = _.findIndex(vm.branchList, {
                                region_id: column.region_id
                            });
                            if (branchIndex == -1)
                                vm.branchList.push(column)
                        });
                        vm.branchTotalBackendCount = payload.title.data.branches.totalCount;
                    }

                    vm.loading = false;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        }
        getFilterDataFromBackend();

        // ************ PAGINATION ON BRANCH **************
        function paginationChangedForBranch() {
            var index = _.findIndex(vm[vm.searchFilterArray[0]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.branchTotalBackendCount > (vm.branchList.length - index)) {
                commonFunction(0, 'pagination');
                vm.branchOffset += 10;
                getFilterDataFromBackend(vm.searchBranchData, 0);
            }
        }

        // *********** COMMON FUNCTION FOR FILTER PAGINATION AND SEARCHING ***********
        function commonFunction(type, mode) {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                if (mode == 'search' || i != type) {
                    vm[vm.searchFilterArrayForClearArray[i]] = [];
                    // vm[vm.searchFilterArrayForClearArray[i]].push({
                    //     id: 'all',
                    //     name: 'All'
                    // });
                    vm[vm.searchFilterArray[i] + 'Offset'] = 0;
                    vm['search' + vm.searchFilterArray[i].substring(0, 1).toUpperCase() + vm.searchFilterArray[i].substring(1) + 'Data'] = '';
                }
            }
        }

        // ************ SEARCH VEHICLE ***************
        function branchSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchBranchData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(0, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 0);
                }, 2000);
            }
        }

        //====================function for dropdown pages and page count===============
        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            if (vm.filterData.filter_branch == 0 && vm.filterData.filter_vehicle == 0) {
                vm.getAllDrivers(0, vm.itemsPerPageGot);
            } else {
                getFilterDriverHit(0, vm.itemsPerPageGot, vm.filterData);
            }
        };

        function paginationNew(page) {
            if (vm.filterData.filter_branch == 0 && vm.filterData.filter_vehicle == 0) {
                getAllDrivers((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot);
            } else {
                getFilterDriverHit((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData);
            }
        }

        //==================refreshData=====================
        function refreshData() {
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            if (vm.filterData.filter_branch == 0 && vm.filterData.filter_vehicle == 0) {
                vm.getAllDrivers(vm.currentPage * vm.itemsPerPageGot, vm.itemsPerPageGot);
            } else {
                getFilterDriverHit(vm.currentPage * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData);
            }
        }

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.approvedInvestorsMain.approvedInvestor');
            }
        });

        //==================get all drivers=======================
        function getAllDrivers(skip, limit) {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit;
            dataSend.offset = skip;
            dataSend.driver_status = 1;
            dataSend.driver_type = 1;
            dataSend.search_filter = vm.filterData.search_filter;
            if (vm.filterData.search_filter == 1) {
                dataSend.search_value = vm.filterData.search_value;
            }
            var promise = getDrivers.allDrivers(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.totalDrivers = payload.title.data.totalCount;
                        vm.dataLength = payload.title.data.totalCount;

                        if (payload.title.data.totalCount == 0) {
                            vm.sp_pagination = false;
                            vm.tBodyFlag = false;
                            vm.tFootFlag = true;
                            vm.filterOn = true;
                            vm.skipValueFilter = 0;
                        } else {
                            vm.sp_pagination = true;
                            vm.tBodyFlag = true;
                            vm.tFootFlag = false;
                            vm.filterOn = false;
                            vm.skipValueFilter = 0;

                            var dataArray = [];
                            var driverList = payload.title.data.result;
                            driverList.forEach(function (column) {
                                var d = {};
                                d.name = column.first_name + " " + column.last_name;
                                d.email = column.email;
                                d.fleet_type = column.fleet_type;
                                d.fleet_route = column.fleet_route;
                                d.work_schedule = column.work_schedule;
                                d.fleet_id = column.fleet_id;
                                d.creation_datetime = column.creation_datetime;
                                d.is_blocked = column.is_blocked;
                                d.branch_name = column.branch_name;
                                d.car_details = column.car_details;
                                d.phone = column.country_code ? column.country_code + column.phone : column.phone;
                                dataArray.push(d);
                            });
                            vm.driverList = dataArray;

                            for (var i = 0; i < vm.driverList.length; i++) {
                                vm.driverList[i].index = (skip + i);
                            }
                            if (vm.dataLength <= vm.itemsPerPageGot) {
                                vm.sp_pagination = false;
                            } else {
                                vm.sp_pagination = true;
                                //vm.pageCount(payload.title.totalCount);
                            }
                            vm.skipValue = vm.driverList[0].index;
                            vm.limitValue = vm.driverList[vm.driverList.length - 1].index;

                            //$scope.$watch('vm.search', function(newVal, oldVal) {
                            //    vm.filtered = filterFilter(vm.driverList, newVal);
                            //    vm.totalItems = vm.filtered.length;
                            //    if (vm.filtered.length == 0) {
                            //        vm.watchPagination = false;
                            //    } else {
                            //        vm.watchPagination = true;
                            //    }
                            //    if (vm.filterOn == true) {
                            //        vm.skipValueFilter = vm.filtered.length;
                            //        vm.sp_pagination = false;
                            //    }
                            //}, true);

                            //range();
                        }
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };
        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    } else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        if(vm.filterData.filter_branch == 0 && vm.filterData.filter_vehicle == 0){
        //            vm.getAllDrivers((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected);
        //        }
        //        else{
        //            getFilterDriverHit((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected);
        //        }
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        vm.currentPage++;
        //        if(vm.filterData.filter_branch == 0 && vm.filterData.filter_vehicle == 0){
        //            vm.getAllDrivers((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected);
        //        }
        //        else{
        //            getFilterDriverHit((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //        }
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if(vm.filterData.filter_branch == 0 && vm.filterData.filter_vehicle == 0){
        //        vm.getAllDrivers((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected);
        //    }
        //    else{
        //        getFilterDriverHit((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //    }
        //};

        function init() {
            vm.getAllDrivers(0, vm.searchModel.limit);
        };
        init();

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            //vm.filterOn = true;
            vm.currentPage = 0;
            vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
            vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
            pendingRequests.cancelAll();
            if (vm.search.length == 0) {
                vm.filterData.search_filter = 0;
                vm.filterData.search_value = '';
                if (vm.filterData.filter_branch == 0 && vm.filterData.filter_vehicle == 0) {
                    vm.getAllDrivers(0, vm.itemsPerPageGot);
                } else {
                    getFilterDriverHit(0, vm.itemsPerPageGot, vm.filterData);
                }
                //vm.filterOn = false;
                //vm.watchPagination = true;
                //vm.sp_pagination = true;

            } else {
                vm.filterData.search_filter = 1;
                vm.filterData.search_value = vm.search;
                //if (vm.filterTextTimeout) $timeout.cancel(vm.filterTextTimeout);
                if (vm.filterData.filter_branch == 0 && vm.filterData.filter_vehicle == 0) {
                    //vm.filterTextTimeout = $timeout(function () {
                    vm.getAllDrivers(0, vm.itemsPerPageGot);
                    //},500);
                } else {
                    //vm.filterTextTimeout = $timeout(function() {
                    getFilterDriverHit(0, vm.itemsPerPageGot, vm.filterData);
                    //},500);
                }
            }
        };

        //===================block unblock driver========================
        function blockUnblockDriver($event, id, value) {
            var msg = '';
            var msgSys = '';
            var flag = '';
            if (value == 0) {
                msg = languageBasedErrorFactory.getProperErrorMessage('investorBlockPop', 0, '3');
                msgSys = 'Investor blocked.';
                flag = 1;
            } else {
                msg = languageBasedErrorFactory.getProperErrorMessage('investorUnblockPop', 0, '3');
                msgSys = 'Investor unblocked.';
                flag = 0;
            }
            vm.items = {
                id: id,
                comments: '',
                value: flag,
                message: msg
            };

            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/blockUnblockPop.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });

            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    $log.log('confirmed');
                    $mdDialog.hide();
                    vm.loading = true;
                    var promise = getDrivers.blockUnblockDriver(id, flag, vm.items.comments);
                    promise.then(
                        function (payload) {
                            $log.log(payload);
                            vm.loading = false;
                            if (payload.title.status == 400) {
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            } else if (payload.title.status == 401) {
                                errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                            } else if (payload.title.status == 201 || payload.title.status == 200) {
                                var dataForSysLogs = {
                                    access_token: $cookies.get('obj'),
                                    id: id,
                                    identity: 0, // 0- driver, 1- customer , 2 -car
                                    message: msgSys
                                };
                                $rootScope.systemLogsAdmin(dataForSysLogs);
                                $state.reload('layout.approvedInvestorsMain.approvedInvestor');
                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                };
            }
        };

        //=====================to delete driver====================
        function deleteUser(id, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('deleteInvestorPop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('cancelButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                vm.loading = true;
                var promise = getDrivers.deleteUser(id);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        var dataForSysLogs = {
                            access_token: $cookies.get('obj'),
                            id: id,
                            identity: 0, // 0- driver, 1- customer , 2 -car
                            message: 'Investor deleted.'
                        };
                        $rootScope.systemLogsAdmin(dataForSysLogs);
                        languageBasedErrorFactory.getProperErrorMessage('deleteInvestorSucc', 0, 1, 'layout.approvedInvestorsMain.approvedInvestor');
                        //errorMessageFactory.showErrorMessage('Investor deleted successfully.',1);
                        //$state.reload();
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        };
        //=================================export to csv==============================
        function exportToCSV(s, l, st, t) {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            // dataSend.limit = l;
            // dataSend.offset = s;
            dataSend.driver_status = st;
            dataSend.driver_type = t;
            // dataSend.search_filter = vm.filterData.search_filter;
            var promise = getDrivers.allDriversCsv(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    // if (payload.title.status == 400) {
                    //     errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    // } else if (payload.title.status == 401) {
                    //     errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    // } else if (payload.title.status == 201 || payload.title.status == 200) {
                    //     var dataArrayE = [];
                    //     var driverListExport = payload.title.data.result;
                    //     driverListExport.forEach(function (column) {
                    //         var d = {};
                    //         d['Fleet ID'] = column.fleet_id;
                    //         d['Name'] = column.first_name + " " + column.last_name;
                    //         d['Email'] = column.email;
                    //         d['Mobile No.'] = column.country_code ? column.country_code + column.phone : column.phone;
                    //         d['Date of Joining'] = moment(column.creation_datetime).format('lll');
                    //         d['Work Schedule'] = column.work_schedule;
                    //         d['Branch Name'] = column.branch_name;
                    //         d['Blocked'] = column.is_blocked == 0 || column.is_blocked == '0' ? 'Unblocked' : 'Blocked';
                    //         d['RUT'] = column.invoice_rut;
                    //         //d.fleet_route = column.fleet_route;
                    //         dataArrayE.push(d);
                    //     });
                    //     vm.driverListExport = dataArrayE;
                    //     alasql('SELECT * INTO CSV("carInvestors.csv",{headers:true}) FROM ?', [vm.driverListExport]);
                    // }
                    if (payload.title.status == 200) {

                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };

        //====================get branch list====================
        // function getBranch() {
        //     vm.branchList = [];
        //     vm.branchList = JSON.parse(JSON.stringify(getFilters.branchesFiltersData.data));
        //     vm.branchList.push({
        //         region_name: 'All',
        //         region_id: 'all'
        //     });
        //     $scope.$apply();
        // vm.loading = true;
        // var promise = getGeofence.branch();
        // promise.then(
        //     function (payload) {
        //         $log.log(payload);
        //         vm.loading = false;
        //         if (payload.title.status == 400) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //         } else if (payload.title.status == 401) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //         } else if (payload.title.status == 201 || payload.title.status == 200) {
        //             var where = _.where(payload.title.data, {
        //                 parent_id: 0
        //             });
        //             //vm.branchList = _.where(where, { is_active: 1 });
        //             vm.branchList = where;

        //             vm.branchList.push({
        //                 region_name: 'All',
        //                 region_id: 'all'
        //             });
        //         }
        //     },
        //     function (errorPayload) {
        //         $log.log(errorPayload);
        // vm.loading = false;
        //         if (errorPayload.data.status == 401) {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //         } else {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //         }
        //     }
        // );
        // }
        // WHen Page refresh service take time to get data from backend
        // setTimeout(function () {
        //     getBranch();
        // }, 1000);


        //========================get filter driver hit=======================
        function getFilterDriverHit(skip, limit, data) {
            if (data.filter_branch == 0 && data.filter_vehicle == 0) {
                vm.getAllDrivers(0, vm.itemsPerPageGot);
                return;
            }
            var dataSend = {};
            dataSend.offset = skip;
            dataSend.limit = limit;
            dataSend.driver = data.driver;
            dataSend.filter_modelity = data.filter_modelity;
            dataSend.filter_branch = data.filter_branch;
            if (data.filter_branch && data.branch != 'all') {
                dataSend.filter_branch_value = data.branch;
            }
            dataSend.filter_vehicle = data.filter_vehicle;
            if (data.filter_vehicle && data.vehicle_unique) {
                dataSend.filter_vehicle_value = data.vehicle_unique;
            }
            dataSend.search_filter = data.search_filter;
            if (data.search_filter == 1) {
                dataSend.search_value = data.search_value;
            }
            dataSend.access_token = $cookies.get('obj');
            vm.loading = true;
            var promise = getDrivers.driverFilter(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.totalDrivers = payload.title.data.totalCount;
                        vm.dataLength = payload.title.data.totalCount;

                        if (payload.title.data.totalCount == 0) {
                            vm.sp_pagination = false;
                            vm.tBodyFlag = false;
                            vm.tFootFlag = true;
                            vm.filterOn = true;
                            vm.skipValueFilter = 0;
                        } else {
                            vm.sp_pagination = true;
                            vm.tBodyFlag = true;
                            vm.tFootFlag = false;
                            vm.filterOn = false;
                            vm.skipValueFilter = 0;

                            var dataArray = [];
                            var driverList = payload.title.data.result;
                            driverList.forEach(function (column) {
                                var d = {};
                                d.name = column.first_name + " " + column.last_name;
                                d.email = column.email;
                                d.fleet_type = column.fleet_type;
                                d.fleet_route = column.fleet_route;
                                d.work_schedule = column.work_schedule;
                                d.fleet_id = column.fleet_id;
                                d.creation_datetime = column.creation_datetime;
                                d.is_blocked = column.is_blocked;
                                d.branch_name = column.branch_name;
                                d.assigned_cars = column.assigned_cars;
                                d.car_details = column.car_details;
                                d.phone = column.country_code ? column.country_code + column.phone : column.phone;
                                dataArray.push(d);
                            });
                            vm.driverList = dataArray;

                            for (var i = 0; i < vm.driverList.length; i++) {
                                vm.driverList[i].index = (skip + i);
                            }
                            if (vm.dataLength <= vm.itemsPerPageGot) {
                                vm.sp_pagination = false;
                            } else {
                                vm.sp_pagination = true;
                                //vm.pageCount(payload.title.totalCount);
                            }
                            vm.skipValue = vm.driverList[0].index;
                            vm.limitValue = vm.driverList[vm.driverList.length - 1].index;

                            //$scope.$watch('vm.search', function(newVal, oldVal) {
                            //    vm.filtered = filterFilter(vm.driverList, newVal);
                            //    vm.totalItems = vm.filtered.length;
                            //    if (vm.filtered.length == 0) {
                            //        vm.watchPagination = false;
                            //    } else {
                            //        vm.watchPagination = true;
                            //    }
                            //    if (vm.filterOn == true) {
                            //        vm.skipValueFilter = vm.filtered.length;
                            //        vm.sp_pagination = false;
                            //    }
                            //}, true);

                            //range();
                        }
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };

        //==================filter change functions===================
        function branchChanged() {
            vm.currentPage = 0;
            if (vm.filterData.branch && vm.filterData.branch != 'all') {
                vm.filterData.filter_branch = 1;
                getFilterDriverHit(0, vm.itemsPerPageGot, vm.filterData);
                vm.agreement = [];
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                clearOffset();
                getFilterDataFromBackend();
            } else {
                vm.filterData.filter_branch = 0;
                vm.filterData.branch = 'all';
                getFilterDriverHit(0, vm.itemsPerPageGot, vm.filterData);
                vm.agreement = [];
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                clearOffset();
                getFilterDataFromBackend();
            }
        };

        function vehicleChanged(data) {
            vm.currentPage = 0;
            if (data) {
                vm.filterData.filter_vehicle = 1;
                vm.filterData.vehicle_unique = Number(vm.filterData.vehicle_unique);
            } else {
                vm.filterData.filter_vehicle = 0;
                vm.filterData.vehicle_unique = '';
            }
            //getUniqueNumber();
        };

        function getUniqueNumber() {
            vm.currentPage = 0;
            getFilterDriverHit(0, vm.itemsPerPageGot, vm.filterData);
        };

        //===================side bar filters=====================
        vm.showFilterArea = showFilterArea;
        vm.branchChangedFilter = branchChangedFilter;
        vm.removeFilter = removeFilter;
        vm.vehicleAssignChangedFilter = vehicleAssignChangedFilter;
        vm.showFilterFlag = false;

        vm.filterWhichToShow = {
            branchWithDashboard: false,
            service: false,
            vehicle: false,
            agreement: false,
            operation: false,
            helpTraffic: false,
            virtualFleet: false,
            approvalStage: false,
            vehicleAssigned: true,
            applicantType: false,
            tripType: false,
            modelity: false
        };

        function removeFilter() {
            $state.reload('layout.approvedInvestorsMain.approvedInvestor');
        }

        function showFilterArea() {
            vm.showFilterFlag = !vm.showFilterFlag;
        }

        function branchChangedFilter(data) {
            vm.branchChanged();
        }

        function vehicleAssignChangedFilter(data) {
            vehicleChanged(data.vehicle_unique);
        }
    }
})();
/**
 * Created by cl-macmini-51 on 5/15/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('AddMoreCarController', AddMoreCarController);

    /** @ngInject */
    function AddMoreCarController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document, moment, getCars, getDrivers, $scope, getVehicles, languageBasedErrorFactory, errorMessageFactory, getFilters) {
        var vm = this;
        vm.loading = false;
        vm.goBack = goBack;
        $log.log($stateParams);
        vm.path = $stateParams.path;
        vm.car_details = [{
            car_photo: '',
            register_image: '',
            car_type: '',
            register_number: '',
            modelity: '',
            travel_card_key: '',
            passenger_insurance_key: '',
            permission_of_circulation: '',
            transportation_permit: ''
        }];
        vm.goBack = goBack;
        vm.addVehicle = addVehicle;
        vm.deleteVehicleType = deleteVehicleType;
        vm.clickTrigger = clickTrigger;
        vm.addCarApi = addCarApi;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();

        vm.paginationChangedForVehicle = paginationChangedForVehicle;
        vm.vehicleSearch = vehicleSearch;

        vm.globalLimit = 10;
        vm.globalOffset = vm.globalLimit;
        vm.vehicleOffset = 0;

        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'vehicle', 'service', 'agreement', 'corporatesList', 'operation_point'];

        vm.vehicle = [];
        vm.vehicle.push({
            id: 'all',
            name: 'All'
        });
        // vm.vechileChanged = vechileChanged;
        // =================== FILTER OBJECT ===================
        vm.filterObject = {
            access_token: $cookies.get('obj'),
            branch_filter: 0,
            vehicle_filter: 1,
            service_filter: 0,
            agreement_filter: 0,
            corporate_filter: 0,
            service_category: 0,
            corporate_status: 0,
            agreement_status: 0,
            vehicle__status: 1,
            operation_point_filter: 0,
            vehicle_limit: vm.globalLimit,
            vehicle_offset: vm.vehicleOffset
        }

        setTimeout(function () {
            document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                // if (vm.vehicle && (vm.vehicle.length == 0)) {
                    vm.searchVehicleData = '';
                    getFilterDataFromBackend(0, 0);
                // }
            });

        })


        function clearOffset() {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                vm[vm.searchFilterArray[i] + 'Offset'] = 0;
            }

        }
        // function vechileChanged(){
        //     getFilterDataFromBackend();
        // }
        // =================== GET FILTER DATA ===================
        function getFilterDataFromBackend(data, type) { //Acc to Index ['branch_search', 'vehicle_search', 'service_search', 'agreement_search', 'corporate_search', 'operation_point_search']
            if (data) {
                vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
            } else {
                vm.filterObject = {
                    access_token: $cookies.get('obj'),
                    branch_filter: 0,
                    vehicle_filter: 1,
                    service_filter: 0,
                    agreement_filter: 0,
                    corporate_filter: 0,
                    service_category: 0,
                    corporate_status: 0,
                    agreement_status: 0,
                    vehicle__status: 1,
                    operation_point_filter: 0,
                    branch_search_filter: 0,
                    vehicle_search_filter: 0,
                    service_search_filter: 0,
                    agreement_search_filter: 0,
                    corporate_search_filter: 0,
                    operation_point_search_filter: 0
                }
            }

            vm.filterObject.vehicle_limit = vm.globalLimit;
            vm.filterObject.vehicle_offset = vm.vehicleOffset;

            var promise = getFilters.getAllFilterData(vm.filterObject);
            promise.then(
                function (payload) {

                    // ********** VEHICLE DATA ********
                    if (payload.title.data.vehicles) {
                        var index = _.findIndex(vm.vehicle, {
                            id: 'all'
                        });
                        if (index == -1)
                            vm.vehicle.push({
                                id: 'all',
                                name: 'All'
                            });
                        angular.forEach(payload.title.data.vehicles.data, function (column) {
                            // vm.vehicle.push({
                            //     id: column.id,
                            //     name: column.name
                            // })
                            var branchIndex = _.findIndex(vm.vehicle, {
                                id: column.id
                            });
                            if (branchIndex == -1)
                                 vm.vehicle.push({
                                    id: column.id,
                                    name: column.name
                                 })
                        });
                        vm.vehicleTotalBackendCount = payload.title.data.vehicles.totalCount;
                    }

                    vm.loading = false;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        }
        getFilterDataFromBackend();

        // ************ PAGINATION ON VEHICLE **************
        function paginationChangedForVehicle() {
            var index = _.findIndex(vm[vm.searchFilterArray[1]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.vehicleTotalBackendCount > (vm.vehicle.length - index)) {
                commonFunction(1, 'pagination');
                vm.vehicleOffset = vm.vehicleOffset + 10;
                getFilterDataFromBackend(vm.searchVehicleData, 1);
            }
        }

        // *********** COMMON FUNCTION FOR FILTER PAGINATION AND SEARCHING ***********
        function commonFunction(type, mode) {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                // vm['search' + vm.searchFilterArray[i] + 'Data'] = '';
                if (mode == 'search' || i != type) {
                    vm[vm.searchFilterArray[i]] = [];
                    // vm[vm.searchFilterArray[i]].push({
                    //     id: 'all',
                    //     name: 'All'
                    // });
                    vm[vm.searchFilterArray[i] + 'Offset'] = 0;
                    vm['search' + vm.searchFilterArray[i].substring(0, 1).toUpperCase() + vm.searchFilterArray[i].substring(1) + 'Data'] = '';
                }
            }
        }
        // ************ SEARCH VEHICLE ***************
        function vehicleSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchVehicleData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(1, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 1);
                }, 2000);
            }
        }

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.approvedInvestorsMain.addCars');
            }
        });
        //=================go back================
        function goBack() {
            if ($stateParams.path == '0') {
                $state.go('layout.approvedDriverMain.approvedDriver');
            } else if ($stateParams.path == '1') {
                $state.go('layout.approvedInvestorsMain.approvedInvestor');
            }
        };
        //===================add vehicles======================
        function addVehicle(index) {
            $log.log(index);
            vm.car_details.push({
                car_photo: '',
                register_image: '',
                car_type: '',
                register_number: '',
                modelity: '',
                travel_card_key: '',
                passenger_insurance_key: '',
                permission_of_circulation: '',
                transportation_permit: ''
            });
        };

        function deleteVehicleType(index) {
            $log.log(index);
            vm.car_details.splice(index, 1);
        };
        //==================file upload function========================
        vm.uploadName = '';

        function clickTrigger($event, type, index) {
            $log.log('ddf');
            $event.stopPropagation();
            vm.uploadName = type;
            if (index != null || index != '' || index != undefined) {
                vm.indexGot = index;
            }
            var element = document.getElementById('documentUpload');
            element.click();
        };

        //===============file for customer edit=============
        $scope.file_to_upload = function (File, type) {
            $log.log('type', type);
            var file = File[0];
            var transcript = File[0];
            var reader = new FileReader;
            reader.onload = function (e) {
                //    var img = new Image;
                //    img.onload = function () {
                if (type == 'CAR_IMAGE') {
                    $log.log(vm.indexGot);
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'carImage' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.car_details[vm.indexGot].car_photo = File[0];
                    }
                } else if (type == 'REGISTER_IMAGE') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'registerImage' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.car_details[vm.indexGot].register_image = File[0];
                    }
                } else if (type == 'TRAVEL_CARD_KEY') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'travel' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.car_details[vm.indexGot].travel_card_key = File[0];
                    }
                } else if (type == 'PASSENGER_INSURANCE_KEY') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'seatInsurance' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.car_details[vm.indexGot].passenger_insurance_key = File[0];
                    }
                } else if (type == 'PERMISSION_OF_CIRCULATION') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'permission' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.car_details[vm.indexGot].permission_of_circulation = File[0];
                    }
                } else if (type == 'TRANSPORTATION_PERMIT') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'transportation_permit' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.car_details[vm.indexGot].transportation_permit = File[0];
                    }
                }
                //};

                //    img.src = reader.result;
            };
            reader.readAsDataURL(transcript);
            $log.log(vm.car_details);
        };
        //=====================add car api function========================
        function addCarApi() {
            $log.log(vm.car_details);

            for (var i = 0; i < vm.car_details.length; i++) {
                // TICKET 2807
                // if (vm.car_details[i].car_photo == undefined || vm.car_details[i].car_photo == null || vm.car_details[i].car_photo == '') {
                //     //errorMessageFactory.showErrorMessage('Please upload car image.');
                //     languageBasedErrorFactory.getProperErrorMessage('carImageCheck', 0, 0);
                //     return;
                // }
                // if (vm.car_details[i].register_image == undefined || vm.car_details[i].register_image == null || vm.car_details[i].register_image == '') {
                //     //errorMessageFactory.showErrorMessage('Please upload car registration image.');
                //     languageBasedErrorFactory.getProperErrorMessage('carRegistrationImage', 0, 0);
                //     return;
                // }
                // if (vm.car_details[i].travel_card_key == undefined || vm.car_details[i].travel_card_key == null || vm.car_details[i].travel_card_key == '') {
                //     //errorMessageFactory.showErrorMessage('Please upload travel card key.');
                //     languageBasedErrorFactory.getProperErrorMessage('carTravelKeyImage', 0, 0);
                //     return;
                // }
                // if (vm.car_details[i].passenger_insurance_key == undefined || vm.car_details[i].passenger_insurance_key == null || vm.car_details[i].passenger_insurance_key == '') {
                //     //errorMessageFactory.showErrorMessage('Please upload passenger insurance key.');
                //     languageBasedErrorFactory.getProperErrorMessage('carPassengerImage', 0, 0);
                //     return;
                // }
                if (vm.car_details[i].permission_of_circulation == undefined || vm.car_details[i].permission_of_circulation == null || vm.car_details[i].permission_of_circulation == '') {
                    //errorMessageFactory.showErrorMessage('Please upload permission of circulation.');
                    languageBasedErrorFactory.getProperErrorMessage('carCirculationImage', 0, 0);
                    return;
                }
                // if (vm.car_details[i].transportation_permit == undefined || vm.car_details[i].transportation_permit == null || vm.car_details[i].transportation_permit == '') {
                //     //errorMessageFactory.showErrorMessage('Please upload permission of circulation.');
                //     languageBasedErrorFactory.getProperErrorMessage('transportationPermit', 0, 0);
                //     return;
                // }
            }
            var carArray = [];
            var dataSend = new FormData();
            for (var i = 0; i < vm.car_details.length; i++) {
                carArray.push({
                    car_type: Number(vm.car_details[i].car_type),
                    modelity: Number(vm.car_details[i].modelity),
                    registration_number: vm.car_details[i].register_number.replace(/ /g, '').toUpperCase(),
                    society_id: Number(vm.car_details[i].society_id)
                });
                // if (vm.car_details[i].car_photo) {
                //     dataSend.append('car_photo[]', vm.car_details[i].car_photo);

                // }
                // if (vm.car_details[i].register_image) {
                //     dataSend.append('registration_image[]', vm.car_details[i].register_image);
                // }
                // if (vm.car_details[i].travel_card_key) {
                //     dataSend.append('travel_card_key[]', vm.car_details[i].travel_card_key);
                // }
                // if (vm.car_details[i].passenger_insurance_key) {
                //     dataSend.append('passenger_insurance_key[]', vm.car_details[i].passenger_insurance_key);
                // }
                if (vm.car_details[i].permission_of_circulation) {
                    dataSend.append('permission_of_circulation[]', vm.car_details[i].permission_of_circulation);
                }
                if (vm.car_details[i].transportation_permit) {
                    dataSend.append('transportation_permit[]', vm.car_details[i].transportation_permit);
                }
                //carPhotoArray.push(vm.dataToFill.car_details[i].car_photo);
                //registerPhotoArray.push(vm.dataToFill.car_details[i].register_image);
            }
            dataSend.append('car_details', JSON.stringify(carArray));
            dataSend.append('fleet_id', $stateParams.id);
            dataSend.append('access_token', $cookies.get('obj'));

            vm.loading = true;
            var promise = getCars.addCarDetails(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    //errorMessageFactory.showErrorMessage('Cars added successfully.',1);
                    if (payload.title.status == 200) {
                        languageBasedErrorFactory.getProperErrorMessage('carsAddSucc', 0, 1, 'layout.approvedInvestorsMain.addCars');
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        // ***** GET SOCIETIES *********
        function getAllSocieties() {
            var dataSend = {};
            // dataSend.access_token = $cookies.get('obj');
            vm.loading = true;
            var promise = getDrivers.societiesList();
            promise.then(
                function (payload) {
                    if (payload.title.status == 200) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        vm.societies = payload.title.data;       
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllSocieties();
    }
})();

/**
 * Created by cl-macmini-51 on 5/3/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .controller('EditDriverDetailsController', EditDriverDetailsController);

    /** @ngInject */
    function EditDriverDetailsController($cookies, $state, $log, $rootScope, $timeout, $stateParams, getDrivers, $mdDialog, $document,
                                         getCommuna, $scope, moment, getCars, RutHelper, getGeofence, getVehicles, languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.loading = true;
        vm.getDriver = getDriver;
        vm.goBack = goBack;
        vm.datePickerE_1 = datePickerE_1;
        vm.getComuna = getComuna;
        vm.clickTrigger = clickTrigger;
        vm.editBasicApi = editBasicApi;
        vm.editCarApi = editCarApi;
        vm.rutChange = rutChange;
        vm.addCarApi = addCarApi;
        vm.addVehicle = addVehicle;
        vm.deleteVehicleType = deleteVehicleType;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.dateOptions = {};
        vm.datePicker_1 = {
            end: false
        };
        vm.getAllVehicles = getAllVehicles;
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.altInputFormats = ['M!/d!/yyyy'];
        $log.log($stateParams);

        //====================event for getting refreshed================
        $scope.$on('StateReload', function(evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.approvedDriverMain.editDriverDetails');
            }
        });

        function rutChange() {
            $log.log('data', vm.dataToFill.RUT);
            if (vm.dataToFill.RUT) {
                if (RutHelper.validate(vm.dataToFill.RUT)) {
                    $log.log();
                    vm.rutFlag = false;
                } else {
                    vm.rutFlag = true;
                }
            } else if (vm.dataToFill.RUT === null) {
                vm.rutFlag = true;
            } else if (vm.dataToFill.RUT === undefined) {
                vm.rutFlag = false;
            }
        }
        //======================get all vehicles==============
        function getAllVehicles(skip, limt,filter) {
            vm.loading = true;
            var promise = getVehicles.allVehicles(skip, limt,filter);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    //vm.loading = false;
                    if(payload.title.status == 400){
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    else if(payload.title.status == 401){
                        errorMessageFactory.showErrorMessage(payload.title.message,2,'home');
                    }
                    else if(payload.title.status == 201 || payload.title.status == 200) {
                        vm.vehicle = [];
                        angular.forEach(payload.title.data.result, function (column) {
                            if (column.status == 1)
                                vm.vehicle.push({id: column.id, name: column.name});
                        });
                        for (var i = 0; i < vm.carDetails.length; i++) {
                            for (var j = 0; j < vm.vehicle.length; j++) {
                                if (vm.vehicle[j].name == vm.carDetails[i].carName) {
                                    vm.carDetails[i].car_type = vm.vehicle[j].id;
                                    break;
                                }
                                else {
                                    vm.carDetails[i].car_type = '';
                                }
                            }
                        }
                    }
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        //=================get driver details================
        function getDriver(id) {
            vm.loading = true;
            var promise = getDrivers.singleDriver(id);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    //vm.loading = false;
                    vm.driverDetails = payload.title.data.driver_detail;


                    vm.dataToFill = {
                        username: vm.driverDetails.username,
                        fleet_type: vm.driverDetails.fleet_type.toString(),
                        first_name: vm.driverDetails.first_name,
                        last_name: vm.driverDetails.last_name,
                        email: vm.driverDetails.email,
                        country_code: vm.driverDetails.country_code,
                        phone_number: vm.driverDetails.phone,
                        number: vm.driverDetails.number ? vm.driverDetails.number : '',
                        apartment: vm.driverDetails.apartment ? vm.driverDetails.apartment : '',
                        street: vm.driverDetails.street,
                        //sector: vm.driverDetails.sector,
                        region: vm.driverDetails.region,
                        RUT: RutHelper.format(vm.driverDetails.RUT),
                        license_type: vm.driverDetails.license_type,
                        license_expiry_date: new Date(vm.driverDetails.license_expiry_date),
                        branch: Number(vm.driverDetails.branch),
                        fleet_img: '',
                        RUT_img: '',
                        life_sheet_img: '',
                        license_img: '',
                        antecents_certificate: '',
                        invoice_rut: vm.driverDetails.invoice_rut,
                        // company_identity_card: '',
                        // company_constitution: '',
                        // invoice_stamping: '',
                        // start_activities: '',
                        // fleet_route: vm.driverDetails.fleet_route != null ? vm.driverDetails.fleet_route.toString() : vm.driverDetails.fleet_route,
                        //TV_2680
                        // work_schedule: vm.driverDetails.work_schedule != null ? vm.driverDetails.work_schedule.toString() : vm.driverDetails.work_schedule,
                        company_type: vm.driverDetails.company_type,
                        addNewCar: [{
                            car_type: '',
                            registration_image_upload: '',
                            car_image_upload: '',
                            registration_number: '',
                            modelity: '',
                            travel_card_key_upload: '',
                            passenger_insurance_key_upload: '',
                            permission_of_circulation_upload: '',
                            transportation_permit_upload: ''
                        }],
                        addNewCarFlag: false
                    };

                    vm.carDetails = vm.driverDetails.car_details;
                    console.log( vm.carDetails,' vm.carDetailsafter',vm.driverDetails);
                    

                    for (var i = 0; i < vm.carDetails.length; i++) {
                        console.log("i m ere e");
                        
                        //vm.carDetails[i].car_type = vm.carDetails[i].car_type;
                        vm.carDetails[i].working_status = vm.carDetails[i].working_status.toString();
                        vm.carDetails[i].modelity = vm.carDetails[i].modelity.toString();
                        vm.carDetails[i].registration_image_upload = '';
                        vm.carDetails[i].car_image_upload = '';
                        vm.carDetails[i].travel_card_key_upload = '';
                        vm.carDetails[i].passenger_insurance_key_upload = '';
                        vm.carDetails[i].permission_of_circulation_upload = '';
                        vm.carDetails[i].transportation_permit_upload = '';
                        console.log("before ",vm.carDetails);
                        

                    }
                    getAllVehicles(0, 0,2);
                    getBranch();
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        getDriver($stateParams.id);

        //==================date picker function==================
        vm.dateOptions = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(2090, 12, 31),
            minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };

        function datePickerE_1() {
            vm.datePicker_1.end = true;
        };
        //====================get comuna list====================
        function getComuna() {
            vm.loading = true;
            var promise = getCommuna.communaList();
            promise.then(
                function(payload) {
                    $log.log(payload);
                    //vm.loading = false;
                    vm.communaList = payload.title.data;
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        //getComuna();
        //====================get branch list====================
        function getBranch() {
            vm.loading = true;
            var promise = getGeofence.branch();
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if(payload.title.status == 400){
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    else if(payload.title.status == 401){
                        errorMessageFactory.showErrorMessage(payload.title.message,2,'home');
                    }
                    else if(payload.title.status == 201 || payload.title.status == 200) {
                        var where = _.where(payload.title.data, {parent_id: 0});
                        vm.branchList = _.where(where, {is_active: 1});
                        var actualBranchGot = '';
                        for (var i = 0; i < vm.branchList.length; i++) {
                            if (vm.dataToFill.branch == vm.branchList[i].region_id) {
                                actualBranchGot = vm.branchList[i].region_id;
                                break;
                            }
                            else {
                                actualBranchGot = '';
                            }
                        }
                        vm.dataToFill.branch = Number(actualBranchGot);
                    }
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        //==================file upload function========================
        vm.uploadName = '';

        function clickTrigger($event, type, index) {
            $log.log('ddf');
            $event.stopPropagation();
            vm.uploadName = type;
            if (index != null || index != '' || index != undefined) {
                vm.indexGot = index;
            }
            var element = document.getElementById('documentUpload');
            element.click();
        };

        //===============file for customer edit=============
        $scope.file_to_upload = function(File, type) {
            $log.log(type);
            var file = File[0];
            var transcript = File[0];
            var reader = new FileReader;
            reader.onload = function(e) {
                //    var img = new Image;
                //    img.onload = function () {
                if (type == 'PROFILE') {
                    document.getElementById('profilePic').setAttribute('src', e.target.result);
                    vm.dataToFill.fleet_img = File[0];
                    // } else if (type == 'INVOICE') {
                    //     document.getElementById('invoice').setAttribute('src', e.target.result);
                    //     vm.dataToFill.invoice_stamping = File[0];
                    // } else if (type == 'ACTIVITY') {
                    //     document.getElementById('activity').setAttribute('src', e.target.result);
                    //     vm.dataToFill.start_activities = File[0];
                    // } else if (type == 'CONSTITUTION') {
                    //     document.getElementById('constitution').setAttribute('src', e.target.result);
                    //     vm.dataToFill.company_constitution = File[0];
                    // } else if (type == 'COMPANY_IDENTITY_CARD') {
                    //     document.getElementById('companyIdentity').setAttribute('src', e.target.result);
                    //     vm.dataToFill.company_identity_card = File[0];
                } else if (type == 'ANTECENTS') {
                    document.getElementById('antecents').setAttribute('src', e.target.result);
                    vm.dataToFill.antecents_certificate = File[0];
                } else if (type == 'LIFE_SHEET') {
                    document.getElementById('lifeSheet').setAttribute('src', e.target.result);
                    vm.dataToFill.life_sheet_img = File[0];
                } else if (type == 'LICENSE') {
                    document.getElementById('licenseImage').setAttribute('src', e.target.result);
                    vm.dataToFill.license_img = File[0];
                } else if (type == 'RUT') {
                    document.getElementById('rutImage').setAttribute('src', e.target.result);
                    vm.dataToFill.RUT_img = File[0];
                } else if (type == 'CAR_IMAGE') {
                    $log.log(vm.indexGot);
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'carImage' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.carDetails[vm.indexGot].car_image_upload = File[0];
                    }
                } else if (type == 'REGISTER_IMAGE') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'registerImage' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.carDetails[vm.indexGot].registration_image_upload = File[0];
                    }
                } else if (type == 'ADD_CAR_IMAGE') {
                    $log.log(vm.indexGot);
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'addCarImage' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.dataToFill.addNewCar[vm.indexGot].car_image_upload = File[0];
                    }
                } else if (type == 'ADD_REGISTER_IMAGE') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'addRegisterImage' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.dataToFill.addNewCar[vm.indexGot].registration_image_upload = File[0];
                    }
                } else if (type == 'PASSENGER_INSURANCE_KEY') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'seatInsurance' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.carDetails[vm.indexGot].passenger_insurance_key_upload = File[0];
                    }
                } else if (type == 'TRAVEL_CARD_KEY') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'travel' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.carDetails[vm.indexGot].travel_card_key_upload = File[0];
                    }
                } else if (type == 'PERMISSION_OF_CIRCULATION') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'permission' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.carDetails[vm.indexGot].permission_of_circulation_upload = File[0];
                    }
                }
                else if (type == 'TRANSPORTATION_PERMIT') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'transportation_permit' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.carDetails[vm.indexGot].transportation_permit_upload = File[0];
                    }
                }
                 else if (type == 'ADD_PASSENGER_INSURANCE_KEY') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'addSeatInsurance' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.dataToFill.addNewCar[vm.indexGot].passenger_insurance_key_upload = File[0];
                    }
                } else if (type == 'ADD_TRAVEL_CARD_KEY') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'addTravel' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.dataToFill.addNewCar[vm.indexGot].travel_card_key_upload = File[0];
                    }
                } else if (type == 'ADD_PERMISSION_OF_CIRCULATION') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'addPermission' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.dataToFill.addNewCar[vm.indexGot].permission_of_circulation_upload = File[0];
                    }
                }
                else if (type == 'ADD_TRANSPORTATION_PERMIT') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'addTransportationPermit' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.dataToFill.addNewCar[vm.indexGot].transportation_permit_upload = File[0];
                    }
                }
                //};

                //    img.src = reader.result;
            };
            reader.readAsDataURL(transcript);
            $log.log(vm.dataToFill);
            $log.log(vm.carDetails);
        };
        //=======================submit basic form===============================
        function editBasicApi() {
            $log.log(vm.dataToFill);
            $log.log(vm.driverDetails);
            console.log();
            
            if (vm.dataToFill.fleet_type != '2') {
                //if((vm.dataToFill.fleet_img == undefined || vm.dataToFill.fleet_img == null || vm.dataToFill.fleet_img == '') && (vm.driverDetails.fleet_image == undefined || vm.driverDetails.fleet_image == null || vm.driverDetails.fleet_image == '')){
                //    errorMessageFactory.showErrorMessage('Please upload profile pic.');
                //    return;
                //}
                if ((vm.dataToFill.RUT_img == undefined || vm.dataToFill.RUT_img == null || vm.dataToFill.RUT_img == '') && (vm.driverDetails.RUT_image == undefined || vm.driverDetails.RUT_image == null || vm.driverDetails.RUT_image == '')) {
                    languageBasedErrorFactory.getProperErrorMessage('uploadRUTImage',0,0);
                    //errorMessageFactory.showErrorMessage('');
                    return;
                }
                if ((vm.dataToFill.license_img == undefined || vm.dataToFill.license_img == null || vm.dataToFill.license_img == '') && (vm.driverDetails.license_img == undefined || vm.driverDetails.license_img == null || vm.driverDetails.license_img == '')) {
                    //errorMessageFactory.showErrorMessage('Please upload license image.');
                    languageBasedErrorFactory.getProperErrorMessage('uploadLicenseImage',0,0);
                    return;
                }
                if ((vm.dataToFill.life_sheet_img == undefined || vm.dataToFill.life_sheet_img == null || vm.dataToFill.life_sheet_img == '') && (vm.driverDetails.life_sheet_img == undefined || vm.driverDetails.life_sheet_img == null || vm.driverDetails.life_sheet_img == '')) {
                    //errorMessageFactory.showErrorMessage('Please upload life sheet image.');
                    languageBasedErrorFactory.getProperErrorMessage('uploadLifeSheetImage',0,0);
                    return;
                }
                if ((vm.dataToFill.antecents_certificate == undefined || vm.dataToFill.antecents_certificate == null || vm.dataToFill.antecents_certificate == '') && (vm.driverDetails.antecents_certificate == undefined || vm.driverDetails.antecents_certificate == null || vm.driverDetails.antecents_certificate == '')) {
                    //errorMessageFactory.showErrorMessage('Please upload antecedents certificate.');
                    languageBasedErrorFactory.getProperErrorMessage('uploadAntecedentImage',0,0);
                    return;
                }
                // if ((vm.dataToFill.company_identity_card == undefined || vm.dataToFill.company_identity_card == null || vm.dataToFill.company_identity_card == '') && (vm.driverDetails.company_identity_card == undefined || vm.driverDetails.company_identity_card == null || vm.driverDetails.company_identity_card == '')) {
                //     errorMessageFactory.showErrorMessage('Please upload company identity card.');
                //     return;
                // }
                // if ((vm.dataToFill.company_constitution == undefined || vm.dataToFill.company_constitution == null || vm.dataToFill.company_constitution == '') && (vm.driverDetails.company_constitution == undefined || vm.driverDetails.company_constitution == null || vm.driverDetails.company_constitution == '')) {
                //     errorMessageFactory.showErrorMessage('Please upload company constitution.');
                //     return;
                // }
                // if ((vm.dataToFill.start_activities == undefined || vm.dataToFill.start_activities == null || vm.dataToFill.start_activities == '') && (vm.driverDetails.start_activities == undefined || vm.driverDetails.start_activities == null || vm.driverDetails.start_activities == '')) {
                //     errorMessageFactory.showErrorMessage('Please upload start activities.');
                //     return;
                // }
                // if ((vm.dataToFill.invoice_stamping == undefined || vm.dataToFill.invoice_stamping == null || vm.dataToFill.invoice_stamping == '') && (vm.driverDetails.invoice_stamping == undefined || vm.driverDetails.invoice_stamping == null || vm.driverDetails.invoice_stamping == '')) {
                //     errorMessageFactory.showErrorMessage('Please upload invoice stamping.');
                //     return;
                // }
            }
            //if (vm.dataToFill.fleet_type == '2') {
            //    //if((vm.dataToFill.fleet_img == undefined || vm.dataToFill.fleet_img == null || vm.dataToFill.fleet_img == '') && (vm.driverDetails.fleet_image == undefined || vm.driverDetails.fleet_image == null || vm.driverDetails.fleet_image == '')){
            //    //    errorMessageFactory.showErrorMessage('Please upload profile pic.');
            //    //    return;
            //    //}
            //    if ((vm.dataToFill.company_identity_card == undefined || vm.dataToFill.company_identity_card == null || vm.dataToFill.company_identity_card == '') && (vm.driverDetails.company_identity_card == undefined || vm.driverDetails.company_identity_card == null || vm.driverDetails.company_identity_card == '')) {
            //        errorMessageFactory.showErrorMessage('Please upload company identity card.');
            //        return;
            //    }
            //    if ((vm.dataToFill.company_constitution == undefined || vm.dataToFill.company_constitution == null || vm.dataToFill.company_constitution == '') && (vm.driverDetails.company_constitution == undefined || vm.driverDetails.company_constitution == null || vm.driverDetails.company_constitution == '')) {
            //        errorMessageFactory.showErrorMessage('Please upload company constitution.');
            //        return;
            //    }
            //    if ((vm.dataToFill.start_activities == undefined || vm.dataToFill.start_activities == null || vm.dataToFill.start_activities == '') && (vm.driverDetails.start_activities == undefined || vm.driverDetails.start_activities == null || vm.driverDetails.start_activities == '')) {
            //        errorMessageFactory.showErrorMessage('Please upload start activities.');
            //        return;
            //    }
            //    if ((vm.dataToFill.invoice_stamping == undefined || vm.dataToFill.invoice_stamping == null || vm.dataToFill.invoice_stamping == '') && (vm.driverDetails.invoice_stamping == undefined || vm.driverDetails.invoice_stamping == null || vm.driverDetails.invoice_stamping == '')) {
            //        errorMessageFactory.showErrorMessage('Please upload invoice stamping.');
            //        return;
            //    }
            //}
            var dataSend = new FormData();
            dataSend.append('access_token', $cookies.get('obj'));
            dataSend.append('fleet_id', Number($stateParams.id));
            dataSend.append('fleet_type', Number(vm.dataToFill.fleet_type));
            dataSend.append('first_name', vm.dataToFill.first_name);
            dataSend.append('last_name', vm.dataToFill.last_name);
            dataSend.append('username', vm.dataToFill.username);
            dataSend.append('email', vm.dataToFill.email);
            dataSend.append('country_code', vm.dataToFill.country_code);
            dataSend.append('phone_number', vm.dataToFill.phone_number);
            dataSend.append('company_type', vm.dataToFill.company_type);
            dataSend.append('street', vm.dataToFill.street);
            //dataSend.append('sector', vm.dataToFill.sector);
            //dataSend.append('region', vm.dataToFill.region);
            if (vm.dataToFill.number) {
                dataSend.append('number', vm.dataToFill.number);
            }
            if (vm.dataToFill.apartment) {
                dataSend.append('apartment', vm.dataToFill.apartment);
            }
            //TV_2680
            // if (vm.dataToFill.fleet_type == '0') {
            //     //if (vm.dataToFill.work_schedule != '0' || vm.dataToFill.work_schedule != '1') {
            //     //    dataSend.append('work_schedule', '');
            //     //} else {
            //     dataSend.append('work_schedule', Number(vm.dataToFill.work_schedule));
            //     //}
            // }
            if (vm.dataToFill.fleet_type != '2') {
                dataSend.append('RUT', RutHelper.clean(vm.dataToFill.RUT));
                dataSend.append('license_type', vm.dataToFill.license_type);
                dataSend.append('license_expiry_date', moment(vm.dataToFill.license_expiry_date).format('YYYY-MM-DD'));
            }
            dataSend.append('branch', vm.dataToFill.branch);
            // dataSend.append('fleet_route', Number(vm.dataToFill.fleet_route));
            if (vm.dataToFill.fleet_img) {
                dataSend.append('fleet_img', vm.dataToFill.fleet_img);
            }
            if (vm.dataToFill.fleet_type != '2') {
                if (vm.dataToFill.RUT_img) {
                    dataSend.append('RUT_img', vm.dataToFill.RUT_img);
                }
                if (vm.dataToFill.license_img) {
                    dataSend.append('license_img', vm.dataToFill.license_img);
                }
                if (vm.dataToFill.life_sheet_img) {
                    dataSend.append('life_sheet_img', vm.dataToFill.life_sheet_img);
                }
                if (vm.dataToFill.antecents_certificate) {
                    dataSend.append('antecents_certificate', vm.dataToFill.antecents_certificate);
                }
                // if (vm.dataToFill.company_identity_card) {
                //     dataSend.append('company_identity_card', vm.dataToFill.company_identity_card);
                // }
                // if (vm.dataToFill.company_constitution) {
                //     dataSend.append('company_constitution', vm.dataToFill.company_constitution);
                // }
                // if (vm.dataToFill.start_activities) {
                //     dataSend.append('start_activities', vm.dataToFill.start_activities);
                // }
                // if (vm.dataToFill.invoice_stamping) {
                //     dataSend.append('invoice_stamping', vm.dataToFill.invoice_stamping);
                // }

            }
            dataSend.append('invoice_rut', vm.driverDetails.invoice_rut);
            //if (vm.dataToFill.fleet_type == '2') {
            //    if (vm.dataToFill.company_identity_card) {
            //        dataSend.append('company_identity_card', vm.dataToFill.company_identity_card);
            //    }
            //    if (vm.dataToFill.company_constitution) {
            //        dataSend.append('company_constitution', vm.dataToFill.company_constitution);
            //    }
            //    if (vm.dataToFill.start_activities) {
            //        dataSend.append('start_activities', vm.dataToFill.start_activities);
            //    }
            //    if (vm.dataToFill.invoice_stamping) {
            //        dataSend.append('invoice_stamping', vm.dataToFill.invoice_stamping);
            //    }
            //}

            vm.loading = true;
            var promise = getDrivers.editDriver(dataSend);
            promise.then(
                function(payload) {
                    vm.loading = false;
                    if(payload.title.status==200){
                        $log.log(payload);
                        var dataForSysLogs = {
                            access_token: $cookies.get('obj'),
                            id: $stateParams.id,
                            identity : 0,  // 0- driver, 1- customer , 2 -car
                            message : 'Driver profile updated.'
                        };
                        $rootScope.systemLogsAdmin(dataForSysLogs);
                        languageBasedErrorFactory.getProperErrorMessage('driverEditSucc',0,1,'layout.approvedDriverMain.editDriverDetails');
                        //errorMessageFactory.showErrorMessage('Driver profile updated successfully.', 1);
                        //$timeout(function() {
                        //    $mdDialog.hide();
                        //    $state.reload();
                        //}, 2000);
                    }else{
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                   
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //=============================edit car details==============================
        function editCarApi(index, data) {
            $log.log(index);
            $log.log(data);


            // if ((data.car_image_upload == undefined || data.car_image_upload == null || data.car_image_upload == '') && (data.car_photo == undefined || data.car_photo == null || data.car_photo == '')) {
            //     languageBasedErrorFactory.getProperErrorMessage('carImageCheck',0,0);
            //     //errorMessageFactory.showErrorMessage('Please upload car image.');
            //     return;
            // }
            // if ((data.registration_image_upload == undefined || data.registration_image_upload == null || data.registration_image_upload == '') && (data.registration_image == undefined || data.registration_image == null || data.registration_image == '')) {
            //     //errorMessageFactory.showErrorMessage('Please upload car registration image.');
            //     languageBasedErrorFactory.getProperErrorMessage('carRegistrationImage',0,0);
            //     return;
            // }
            // if ((data.passenger_insurance_key_upload == undefined || data.passenger_insurance_key_upload == null || data.passenger_insurance_key_upload == '') && (data.passenger_insurance_key == undefined || data.passenger_insurance_key == null || data.passenger_insurance_key == '')) {
            //     //errorMessageFactory.showErrorMessage('Please upload passenger seat insurance.');
            //     languageBasedErrorFactory.getProperErrorMessage('carPassengerImage',0,0);
            //     return;
            // }
            // if ((data.travel_card_key_upload == undefined || data.travel_card_key_upload == null || data.travel_card_key_upload == '') && (data.travel_card_key == undefined || data.travel_card_key == null || data.travel_card_key == '')) {
            //     //errorMessageFactory.showErrorMessage('Please upload travel card key.');
            //     languageBasedErrorFactory.getProperErrorMessage('carTravelKeyImage',0,0);
            //     return;
            // }
            if ((data.permission_of_circulation_upload == undefined || data.permission_of_circulation_upload == null || data.permission_of_circulation_upload == '') && (data.permission_of_circulation == undefined || data.permission_of_circulation == null || data.permission_of_circulation == '')) {
                //errorMessageFactory.showErrorMessage('Please upload permission of circulation.');
                languageBasedErrorFactory.getProperErrorMessage('carCirculationImage',0,0);
                return;
            }
            // if ((data.transportation_permit_upload == undefined || data.transportation_permit_upload == null || data.transportation_permit_upload == '') && (data.transportation_permit == undefined || data.transportation_permit == null || data.transportation_permit == '')) {
            //     //errorMessageFactory.showErrorMessage('Please upload permission of circulation.');
            //     languageBasedErrorFactory.getProperErrorMessage('transportationPermit', 0, 0);
            //     return;
            // }

            var dataSendCar = new FormData();
            dataSendCar.append('access_token', $cookies.get('obj'));
            dataSendCar.append('fleet_id', $stateParams.id);
            dataSendCar.append('car_id', data.id);
            dataSendCar.append('registration_number', data.registration_number.replace(/ /g, '').toUpperCase());
            dataSendCar.append('car_type', Number(data.car_type));
            dataSendCar.append('modelity', Number(data.modelity));
            dataSendCar.append('working_status', Number(data.working_status));

            // if (data.car_image_upload) {
            //     dataSendCar.append('car_photo', data.car_image_upload);
            // }
            // if (data.passenger_insurance_key_upload) {
            //     dataSendCar.append('passenger_insurance_key', data.passenger_insurance_key_upload);
            // }
            // if (data.travel_card_key_upload) {
            //     dataSendCar.append('travel_card_key', data.travel_card_key_upload);
            // }
            if (data.permission_of_circulation_upload) {
                dataSendCar.append('permission_of_circulation', data.permission_of_circulation_upload);
            }
            if (data.transportation_permit_upload) {
                dataSendCar.append('transportation_permit', data.transportation_permit_upload);
            }
            if (data.society_id) {
                dataSendCar.append('society_id', Number(data.society_id));
            }
            vm.loading = true;
            var promise = getCars.editCarDetails(dataSendCar);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    var dataForSysLogs = {
                        access_token: $cookies.get('obj'),
                        id: data.id,
                        identity : 0,  // 0- driver, 1- customer , 2 -car
                        message : 'Driver car details updated.'
                    };
                    $rootScope.systemLogsAdmin(dataForSysLogs);
                    languageBasedErrorFactory.getProperErrorMessage('carDetailsUpdated',0,1,'layout.approvedDriverMain.editDriverDetails');
                    //errorMessageFactory.showErrorMessage('Car details updated successfully.', 1);
                    //$timeout(function() {
                    //    $mdDialog.hide();
                    //    $state.reload();
                    //}, 2000);
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //===================add vehicles======================
        function addVehicle(index) {
            $log.log(index);
            vm.dataToFill.addNewCar.push({
                car_type: '',
                registration_image_upload: '',
                car_image_upload: '',
                registration_number: '',
                modelity: '',
                travel_card_key_upload: '',
                passenger_insurance_key_upload: '',
                permission_of_circulation_upload: '',
                transportation_permit_upload: ''
            });
        };

        function deleteVehicleType(index) {
            $log.log(index);
            vm.dataToFill.addNewCar.splice(index, 1);
        };

        //====================add new cars api ================================
        function addCarApi() {
            $log.log(vm.dataToFill);
            for (var i = 0; i < vm.dataToFill.addNewCar.length; i++) {
                // TICKET 2807
                // if (vm.dataToFill.addNewCar[i].car_image_upload == undefined || vm.dataToFill.addNewCar[i].car_image_upload == null || vm.dataToFill.addNewCar[i].car_image_upload == '') {
                //     //errorMessageFactory.showErrorMessage('Please upload car image.');
                //     languageBasedErrorFactory.getProperErrorMessage('carImageCheck',0,0);
                //     return;
                // }
                // if (vm.dataToFill.addNewCar[i].registration_image_upload == undefined || vm.dataToFill.addNewCar[i].registration_image_upload == null || vm.dataToFill.addNewCar[i].registration_image_upload == '') {
                //     //errorMessageFactory.showErrorMessage('Please upload car registration image.');
                //     languageBasedErrorFactory.getProperErrorMessage('carRegistrationImage',0,0);
                //     return;
                // }
                // if (vm.dataToFill.addNewCar[i].passenger_insurance_key_upload == undefined || vm.dataToFill.addNewCar[i].passenger_insurance_key_upload == null || vm.dataToFill.addNewCar[i].passenger_insurance_key_upload == '') {
                //     //errorMessageFactory.showErrorMessage('Please upload car image.');
                //     languageBasedErrorFactory.getProperErrorMessage('carPassengerImage',0,0);
                //     return;
                // }
                // if (vm.dataToFill.addNewCar[i].travel_card_key_upload == undefined || vm.dataToFill.addNewCar[i].travel_card_key_upload == null || vm.dataToFill.addNewCar[i].travel_card_key_upload == '') {
                //     //errorMessageFactory.showErrorMessage('Please upload car registration image.');
                //     languageBasedErrorFactory.getProperErrorMessage('carTravelKeyImage',0,0);
                //     return;
                // }
                if (vm.dataToFill.addNewCar[i].permission_of_circulation_upload == undefined || vm.dataToFill.addNewCar[i].permission_of_circulation_upload == null || vm.dataToFill.addNewCar[i].permission_of_circulation_upload == '') {
                    //errorMessageFactory.showErrorMessage('Please upload car registration image.');
                    languageBasedErrorFactory.getProperErrorMessage('carCirculationImage',0,0);
                    return;
                }
                // if (vm.dataToFill.addNewCar[i].transportation_permit_upload == undefined || vm.dataToFill.addNewCar[i].transportation_permit_upload == null || vm.dataToFill.addNewCar[i].transportation_permit_upload == '') {
                //     //errorMessageFactory.showErrorMessage('Please upload car registration image.');
                //     languageBasedErrorFactory.getProperErrorMessage('carCirculationImage',0,0);
                //     return;
                // }
            }

            var carArray = [];
            var dataSend = new FormData();
            dataSend.append('fleet_id', $stateParams.id);
            dataSend.append('access_token', $cookies.get('obj'));
            for (var i = 0; i < vm.dataToFill.addNewCar.length; i++) {
                carArray.push({
                    car_type: Number(vm.dataToFill.addNewCar[i].car_type),
                    modelity: Number(vm.dataToFill.addNewCar[i].modelity),
                    registration_number: vm.dataToFill.addNewCar[i].registration_number.replace(/ /g, '').toUpperCase()
                });
                // if (vm.dataToFill.addNewCar[i].car_image_upload) {
                //     dataSend.append('car_photo[]', vm.dataToFill.addNewCar[i].car_image_upload);

                // }
                // if (vm.dataToFill.addNewCar[i].registration_image_upload) {
                //     dataSend.append('registration_image[]', vm.dataToFill.addNewCar[i].registration_image_upload);
                // }
                // if (vm.dataToFill.addNewCar[i].passenger_insurance_key_upload) {
                //     dataSend.append('passenger_insurance_key[]', vm.dataToFill.addNewCar[i].passenger_insurance_key_upload);
                // }
                // if (vm.dataToFill.addNewCar[i].travel_card_key_upload) {
                //     dataSend.append('travel_card_key[]', vm.dataToFill.addNewCar[i].travel_card_key_upload);
                // }
                if (vm.dataToFill.addNewCar[i].permission_of_circulation_upload) {
                    dataSend.append('permission_of_circulation[]', vm.dataToFill.addNewCar[i].permission_of_circulation_upload);
                }
                if (vm.dataToFill.addNewCar[i].transportation_permit_upload) {
                    dataSend.append('transportation_permit[]', vm.dataToFill.addNewCar[i].transportation_permit_upload);
                }
            }
            dataSend.append('car_details', JSON.stringify(carArray));
            vm.loading = true;
            var promise = getCars.addCarDetails(dataSend);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    languageBasedErrorFactory.getProperErrorMessage('carAddedSuccess',0,1,'layout.approvedDriverMain.editDriverDetails');
                    //errorMessageFactory.showErrorMessage('Car added successfully.', 1);
                    //$timeout(function() {
                    //    $mdDialog.hide();
                    //    $state.reload();
                    //}, 2000);
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //=================go back================
        function goBack() {
            if ($stateParams.path == '1') {
                $state.go('layout.approvedDriverMain.approvedDriver');
            } else if ($stateParams.path == '0') {
                $state.go('layout.pendingDriverMain.pendingDriver');
            }
        };
        vm.licenceTypesData = [];
        function licenseTypes() {
            vm.loading = true;
            var promise = getVehicles.getLicenseType();
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    //vm.loading = false;
                    if(payload.title.status == 400){
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    else if(payload.title.status == 401){
                        errorMessageFactory.showErrorMessage(payload.title.message,2,'home');
                    }
                    else if(payload.title.status == 201 || payload.title.status == 200) {
                        vm.licenseTypes = [];
                        vm.licenseTypes = payload.title;
                        angular.forEach(vm.licenseTypes.data, function (data) {
                                vm.licenceTypesData.push(data.license_class_type);
                        });
                    }
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        licenseTypes();
        
         // ***** GET SOCIETIES *********
         function getAllSocieties() {
            var dataSend = {};
            // dataSend.access_token = $cookies.get('obj');
            vm.loading = true;
            var promise = getDrivers.societiesList();
            promise.then(
                function (payload) {
                    if (payload.title.status == 200) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        vm.societies = payload.title.data;       
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }

                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };
        getAllSocieties();
    }
})();
/**
 * Created by cl-macmini-51 on 4/26/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('DriverDetailsController', DriverDetailsController);

    /** @ngInject */
    function DriverDetailsController($cookies, $state, $log, $rootScope, $timeout, $stateParams, getDrivers, $mdDialog, $document,RutHelper, $scope, $location, $anchorScroll,
                                     languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.loading = true;
        vm.getDriver = getDriver;
        vm.goBack = goBack;
        vm.showCustomerRating = showCustomerRating;
        vm.exportToCSVDriverRatings = exportToCSVDriverRatings;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.driverRatingArray = [];
        vm.monthRange = [];
        vm.selectedMonth = '';
        vm.currentSelectedMonth = '';
        $log.log($stateParams);

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.approvedDriverMain.driverDetails');
            }
        });



        //=================get months array================
        vm.newArrayMonth = [];
        var monthsRangeMoment = moment.months()
        for(var i in monthsRangeMoment){
            vm.newArrayMonth.push({
                value:Number(i)+1,
                name : monthsRangeMoment[i]
            })
        }

        var startDate = moment([moment().year(), moment().month()]);
        var endDate = moment(startDate).endOf('month');
        $scope.datePicker = {};
        $scope.datePicker.date = {startDate:moment(startDate.toDate()).format('YYYY-MM-DD'), endDate:moment(endDate.toDate()).format('YYYY-MM-DD')};



        vm.gotoRattings = function() {
            // set the location.hash to the id of
            // the element you wish to scroll to.
            $location.hash('rattings');

            // call $anchorScroll()
            $anchorScroll();
        };




        //=================get driver details================
        function getDriver(id) {
            vm.loading = true;
            var promise = getDrivers.singleDriver(id);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    vm.driverDetail = payload.title.data.driver_detail;
                    vm.driverDetail.RUT = RutHelper.format(vm.driverDetail.RUT);

                    if(vm.driverDetail.apartment){
                        if(vm.driverDetail.number){
                            vm.driverDetail.addressFormed = vm.driverDetail.street + ', ' + vm.driverDetail.number + ', ' + vm.driverDetail.apartment;
                        }
                        else{
                            vm.driverDetail.addressFormed = vm.driverDetail.street + ', ' + vm.driverDetail.apartment;
                        }
                    }
                    else{
                        if(vm.driverDetail.number){
                            vm.driverDetail.addressFormed = vm.driverDetail.street + ', ' + vm.driverDetail.number;
                        }
                        else{
                            vm.driverDetail.addressFormed = vm.driverDetail.street;
                        }
                    }
                    for(var i in vm.newArrayMonth){
                        if(vm.newArrayMonth[i].value == new Date().getMonth() + 1){
                            vm.currentSelectedMonth = i;
                            vm.selectedMonth = vm.newArrayMonth[vm.currentSelectedMonth];
                        }
                    }
                    showCustomerRating( vm.driverDetail.fleet_id, $scope.datePicker.date.startDate, ($scope.datePicker.date.endDate))
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        }
        getDriver($stateParams.id);
        //=================go back================
        function goBack() {
            if($stateParams.path == '1'){
                $state.go('layout.approvedDriverMain.approvedDriver');
            }
            else if($stateParams.path == '0'){
                $state.go('layout.pendingDriverMain.pendingDriver');
            }
        };


        $scope.options = {
            eventHandlers: {
                'apply.daterangepicker': function (ev, picker) {
                    showCustomerRating( vm.driverDetail.fleet_id, ($scope.datePicker.date.startDate).format('YYYY-MM-DD'), ($scope.datePicker.date.endDate).format('YYYY-MM-DD'))
                }
            }
        };


        function showCustomerRating(fleet_id, start, end) {
            var promise = getDrivers.getDriverRatingFilteres({fleet_id:fleet_id, startDate:start, endDate:end, access_token: $cookies.get('obj')});
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.driverRatingArray = payload.title.data
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };


        function exportToCSVDriverRatings(array){
            // showCustomerRating( vm.driverDetail.fleet_id, ($scope.datePicker.date.startDate).format('YYYY-MM-DD'), ($scope.datePicker.date.endDate).format('YYYY-MM-DD'))
            // vm.loading = true;
            // var promise = getDrivers.allDrivers(s,l,st,t);
            var dataArrayE = [];
            var driverListExport = array;
            driverListExport.forEach(function(column) {
                var d = {};
                d['Fleet ID'] = vm.driverDetail.fleet_id;
                d['Job ID'] = column.job_id;
                d['Rating']  = column.fleet_rating;
                d['Customer Comment']  = column.fleet_comment;
                d['Customer Name']  = column.job_pickup_name;
                d['Agreement Name']  = column.contract_name;
                d['Date & Time Pickup']  = moment(column.job_pickup_datetime).format('lll');
                //d.fleet_route = column.fleet_route;
                dataArrayE.push(d);
            });
            vm.driverListExport = dataArrayE;
            alasql('SELECT * INTO CSV("driversRatings.csv",{headers:true}) FROM ?',[vm.driverListExport]);
        };



    }
})();
/**
 * Created by cl-macmini-51 on 4/18/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('ApprovedDriverController', ApprovedDriverController);

    /** @ngInject */
    function ApprovedDriverController($cookies, $state, adminAccessService, $log, $rootScope, $timeout, checkDomain, getDrivers, $scope, filterFilter, $mdDialog, $document, getGeofence, languageBasedErrorFactory, errorMessageFactory, pendingRequests, moment, getFilters, $interval) {
        var vm = this;
        vm.getAllDrivers = getAllDrivers;
        $log.log('driver');
        vm.loading = true;
        vm.currentPage = 0;
        vm.totalDrivers = 0;
        vm.sp_pagination = false;
        vm.resetPassword = resetPassword;
        vm.SendEmail = SendEmail;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.getPagesCount = getPagesCount;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.init = init;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.blockUnblockDriver = blockUnblockDriver;
        vm.deleteUser = deleteUser;
        vm.exportToCSV = exportToCSV;
        vm.branchChanged = branchChanged;
        vm.modelityValueChanged = modelityValueChanged;
        vm.vehicleChanged = vehicleChanged;
        vm.getUniqueNumber = getUniqueNumber;
        vm.refreshData = refreshData;
        vm.paginationNew = paginationNew;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.predicate = 'index';
        vm.filterTextTimeout = '';
        vm.reverse = false;
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
        vm.filterData = {
            filter_branch: 0, //0, 1
            filter_modelity: 0, //0, 1
            filter_vehicle: 0, //0, 1
            branch: 'all',
            modelity: 'all',
            vehicle_unique: '',
            limit: vm.itemsPerPageGot,
            offset: 0,
            driver: 0,
            search_filter: 0,
            search_value: ''
        };

        vm.paginationChangedForBranch = paginationChangedForBranch;
        vm.branchSearch = branchSearch;
        vm.branchOffset = 0;
        vm.globalLimit = 10;
        vm.globalOffset = vm.globalLimit;
        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'vehicle', 'service', 'agreement', 'corporatesList', 'operation_point'];

        vm.branchList = [];
        vm.branchList.push({
            region_name: 'All',
            region_id: 'all'
        });

        // =================== FILTER OBJECT ===================
        vm.filterObject = {
            access_token: $cookies.get('obj'),
            branch_filter: 1,
            vehicle_filter: 0,
            service_filter: 0,
            agreement_filter: 0,
            corporate_filter: 0,
            service_category: 0,
            corporate_status: 0,
            agreement_status: 0,
            vehicle__status: 0,
            operation_point_filter: 0,
            branch_limit: vm.globalLimit,
            branch_offset: vm.branchOffset
        }

        setTimeout(function () {
            document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                // if (vm.branchList && (vm.branchList.length == 0)) {
                vm.searchBranchData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

        })

        function clearOffset() {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                vm[vm.searchFilterArray[i] + 'Offset'] = 0;
            }

        }
        // =================== GET FILTER DATA ===================
        function getFilterDataFromBackend(data, type) { //Acc to Index ['branch_search', 'vehicle_search', 'service_search', 'agreement_search', 'corporate_search', 'operation_point_search']
            if (data) {
                vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
            } else {
                vm.filterObject = {
                    access_token: $cookies.get('obj'),
                    branch_filter: 1,
                    vehicle_filter: 0,
                    service_filter: 0,
                    agreement_filter: 0,
                    corporate_filter: 0,
                    service_category: 0,
                    corporate_status: 2,
                    agreement_status: 0,
                    vehicle__status: 0,
                    operation_point_filter: 0,
                    branch_search_filter: 0,
                    vehicle_search_filter: 0,
                    service_search_filter: 0,
                    agreement_search_filter: 0,
                    corporate_search_filter: 0,
                    operation_point_search_filter: 0
                }
            }

            vm.filterObject.branch_limit = vm.globalLimit;
            vm.filterObject.branch_offset = vm.branchOffset;

            var promise = getFilters.getAllFilterData(vm.filterObject);
            promise.then(
                function (payload) {

                    // ********** BRANCH DATA ********
                    if (payload.title.data.branches) {
                        var index = _.findIndex(vm.branchList, {
                            region_id: 'all'
                        });
                        if (index == -1)
                            vm.branchList.push({
                                region_name: 'All',
                                region_id: 'all'
                            });
                        angular.forEach(payload.title.data.branches.data, function (column) {
                            var branchIndex = _.findIndex(vm.branchList, {
                                region_id: column.region_id
                            });
                            if (branchIndex == -1)
                                vm.branchList.push(column)
                        });
                        vm.branchTotalBackendCount = payload.title.data.branches.totalCount;
                    }
                    vm.loading = false;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        }
        getFilterDataFromBackend();

        // ************ PAGINATION ON BRANCH **************
        function paginationChangedForBranch() {
            var index = _.findIndex(vm[vm.searchFilterArray[0]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.branchTotalBackendCount > (vm.branchList.length - index)) {
                commonFunction(0, 'pagination');
                vm.branchOffset += 10;
                getFilterDataFromBackend(vm.searchBranchData, 0);
            }
        }

        // *********** COMMON FUNCTION FOR FILTER PAGINATION AND SEARCHING ***********
        function commonFunction(type, mode) {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                if (mode == 'search' || i != type) {
                    vm[vm.searchFilterArrayForClearArray[i]] = [];
                    // vm[vm.searchFilterArrayForClearArray[i]].push({
                    //     id: 'all',
                    //     name: 'All'
                    // });
                    vm[vm.searchFilterArray[i] + 'Offset'] = 0;
                    vm['search' + vm.searchFilterArray[i].substring(0, 1).toUpperCase() + vm.searchFilterArray[i].substring(1) + 'Data'] = '';
                }
            }
        }

        // ************ SEARCH VEHICLE ***************
        function branchSearch(data) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchBranchData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(0, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 0);
                }, 2000);
            }
        }



        // =================== FUNCATION FOR RESET DRIVER PASSWORD BY ADMIN =================//
        function resetPassword(data, $event) {
            vm.loading = true;
            var promise = adminAccessService.checkStateValid('Restablecer'); //$stateParams.id
            return promise.then(
                function (payload) {
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (!payload.title.data.granted) {
                            errorMessageFactory.showErrorMessage('No está autorizado para usar esta opción', 0);
                            //errorMessageFactory.showErrorMessage('Option not available because you not have the right',0);
                            return false;
                        } else {
                            vm.loading = false;
                            // blockDriverPopUp($event, id, value);
                            OpenPopForResetPassword(data, $event)
                            return true;
                        }
                    }
                },
                function (errorPayload) {
                    console.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function OpenPopForResetPassword(data, $event) {
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/resetPassWordDriver.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: ResetPasswordDialogController
            });

            function ResetPasswordDialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    if ($scope.items.passwordMatchFlag) {
                        return;
                    }
                    vm.loading = true;
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.email = data.email;
                    dataSend.new_password = $scope.items.password;
                    var promise = getDrivers.resetPasswordDriverThroughAdmin(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            vm.loading = false;
                            $mdDialog.hide();
                            if (payload && payload.title.status == 400) {
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            } else {
                                errorMessageFactory.showErrorMessage('Contraseña restablecida correctamente', 0);
                            }
                        },
                        function (errorPayload) {
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        });
                };
                //=======================password match function====================
                $scope.matchConfirmPassword = function (data) {
                    if (data) {
                        if (data != $scope.items.password) {
                            $scope.items.passwordMatchFlag = true;
                        } else {
                            $scope.items.passwordMatchFlag = false;
                        }
                    } else {
                        $scope.items.passwordMatchFlag = false;
                    }
                };
                $scope.matchPassword = function (data) {
                    if (data && $scope.items.confirmPassword) {
                        if (data != $scope.items.confirmPassword) {
                            $scope.items.passwordMatchFlag = true;
                        } else {
                            $scope.items.passwordMatchFlag = false;
                        }
                    }
                };
            }
        }

        // =================== FUNCATION FOR RESET DRIVER PASSWORD BY ADMIN =================//


        // =================== FUNCATION FOR SEND NEWPASSWORD EMAIl =================//
        function SendEmail(data, $event) {
            var parentEl = angular.element($document.body);
            var domain = checkDomain.getDomainName();
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/resetPassWordDriverMail.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: SendResetPasswordMailDialogController
            });

            function SendResetPasswordMailDialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    vm.loading = true;
                    var dataSend = {};
                    dataSend.domainUrl = domain;
                    dataSend.login_id = data.email;
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.isAdmin = 1;
                    var promise = getDrivers.sendEmailToDriverResetPassword(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            vm.loading = false;
                            $mdDialog.hide();
                            if (payload && payload.title.status == 400) {
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            } else {
                                errorMessageFactory.showErrorMessage('Correo enviado', 0);
                            }
                        },
                        function (errorPayload) {
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        });
                };
            }
        }
        // =================== FUNCATION FOR SEND NEWPASSWORD EMAIl =================//



        //====================function for dropdown pages and page count===============
        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            if (vm.filterData.filter_branch == 0 && vm.filterData.filter_modelity == 0 && vm.filterData.filter_vehicle == 0) {
                getAllDrivers(0, vm.itemsPerPageGot, true);
            } else {
                getFilterDriverHit(0, vm.itemsPerPageGot, vm.filterData);
            }
        };

        function paginationNew(page) {
            if (vm.filterData.filter_branch == 0 && vm.filterData.filter_modelity == 0 && vm.filterData.filter_vehicle == 0) {
                getAllDrivers((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot, true);
            } else {
                getFilterDriverHit((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData);
            }
        }

        //==================refreshData=====================
        function refreshData() {
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            if (vm.filterData.filter_branch == 0 && vm.filterData.filter_modelity == 0 && vm.filterData.filter_vehicle == 0) {
                getAllDrivers(vm.currentPage * vm.itemsPerPageGot, vm.itemsPerPageGot, true);
            } else {
                getFilterDriverHit(vm.currentPage * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData);
            }
        }

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.approvedDriverMain.approvedDriver');
            }
        });

        //==================get all drivers=======================
        function getAllDrivers(skip, limit, socket) {
            if (socket == true)
                vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit;
            dataSend.offset = skip;
            dataSend.driver_status = 1;
            dataSend.driver_type = 0;
            dataSend.search_filter = vm.filterData.search_filter;
            if (vm.filterData.search_filter == 1) {
                dataSend.search_value = vm.filterData.search_value;
            }
            var promise = getDrivers.allDrivers(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.totalDrivers = payload.title.data.totalCount;
                        vm.dataLength = payload.title.data.totalCount;

                        if (payload.title.data.totalCount == 0) {
                            vm.sp_pagination = false;
                            vm.tBodyFlag = false;
                            vm.tFootFlag = true;
                            vm.filterOn = true;
                            vm.skipValueFilter = 0;
                        } else {
                            vm.sp_pagination = true;
                            vm.tBodyFlag = true;
                            vm.tFootFlag = false;
                            vm.filterOn = false;
                            vm.skipValueFilter = 0;

                            var dataArray = [];
                            var driverList = payload.title.data.result;
                            driverList.forEach(function (column) {
                                var d = {};
                                d.name = column.first_name + " " + column.last_name;
                                d.email = column.email;
                                d.fleet_type = column.fleet_type;
                                d.fleet_route = column.fleet_route;
                                // d.work_schedule = column.work_schedule;  //TV_2680
                                d.fleet_id = column.fleet_id;
                                d.creation_datetime = column.creation_datetime;
                                d.is_blocked = column.is_blocked;
                                d.branch_name = column.branch_name;
                                d.assigned_cars = column.assigned_cars;
                                d.phone = column.country_code ? column.country_code + column.phone : column.phone;
                                d.block_hours = column.block_hours;
                                console.log(column.blocked_upto_time, 'column.blocked_upto_time');

                                if (column.blocked_upto_time != null && column.block_hours != 0) {
                                    var countDownDate = new Date(column.blocked_upto_time);
                                    var now = new Date().getTime();
                                    var difference = countDownDate - now;
                                    var hours = Math.floor((difference % (1000 * 60 * 60 * column.block_hours)) / (1000 * 60 * 60));
                                    var minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
                                    if (hours <= 9) {
                                        if (hours < 0) {
                                            hours = '00';
                                        } else {
                                            hours = '0' + hours;
                                        }
                                    }
                                    if (minutes <= 9) {
                                        if (minutes < 0) {
                                            minutes = '00';
                                        } else {
                                            minutes = '0' + minutes;
                                        }
                                    }
                                    d.block_Time_left = hours + ":" + minutes;
                                    if (vm.promise1) {
                                        $interval.cancel(vm.promise1);
                                    }
                                    vm.promise1 = $interval(function () {
                                        countDownDate = new Date(column.blocked_upto_time);
                                        now = new Date().getTime();
                                        difference = countDownDate - now;
                                        hours = Math.floor((difference % (1000 * 60 * 60 * column.block_hours)) / (1000 * 60 * 60));
                                        minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
                                        hours = Math.floor((difference % (1000 * 60 * 60 * column.block_hours)) / (1000 * 60 * 60));
                                        minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
                                        if (hours <= 9) {
                                            hours = '0' + hours;
                                        }
                                        if (minutes <= 9) {
                                            minutes = '0' + minutes;
                                        }
                                        d.block_Time_left = hours + ":" + minutes;

                                    }, 60000);
                                }
                                dataArray.push(d);
                            });
                            vm.driverList = dataArray;

                            for (var i = 0; i < vm.driverList.length; i++) {
                                vm.driverList[i].index = (skip + i);
                            }
                            if (vm.dataLength <= vm.itemsPerPageGot) {
                                vm.sp_pagination = false;
                            } else {
                                vm.sp_pagination = true;
                                //vm.pageCount(payload.title.totalCount);
                            }
                            vm.skipValue = vm.driverList[0].index;
                            vm.limitValue = vm.driverList[vm.driverList.length - 1].index;

                            //$scope.$watch('vm.search', function(newVal, oldVal) {
                            //    vm.filtered = filterFilter(vm.driverList, newVal);
                            //    vm.totalItems = vm.filtered.length;
                            //    if (vm.filtered.length == 0) {
                            //        vm.watchPagination = false;
                            //    } else {
                            //        vm.watchPagination = true;
                            //    }
                            //    if (vm.filterOn == true) {
                            //        vm.skipValueFilter = vm.filtered.length;
                            //        vm.sp_pagination = false;
                            //    }
                            //}, true);

                            //range();
                        }
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };
        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    } else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        if(vm.filterData.filter_branch == 0 && vm.filterData.filter_modelity == 0 && vm.filterData.filter_vehicle == 0){
        //            vm.getAllDrivers((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected);
        //        }
        //        else{
        //            getFilterDriverHit((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //        }
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        vm.currentPage++;
        //        if(vm.filterData.filter_branch == 0 && vm.filterData.filter_modelity == 0 && vm.filterData.filter_vehicle == 0){
        //            vm.getAllDrivers((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected);
        //        }
        //        else{
        //            getFilterDriverHit((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //        }
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if(vm.filterData.filter_branch == 0 && vm.filterData.filter_modelity == 0 && vm.filterData.filter_vehicle == 0){
        //        vm.getAllDrivers((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected);
        //    }
        //    else{
        //        getFilterDriverHit((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //    }
        //};

        function init() {
            vm.getAllDrivers(0, vm.searchModel.limit, true);
        };
        init();

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            //vm.filterOn = true;
            vm.currentPage = 0;
            vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
            vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
            pendingRequests.cancelAll();
            if (vm.search.length == 0) {
                vm.filterData.search_filter = 0;
                vm.filterData.search_value = '';
                if (vm.filterData.filter_branch == 0 && vm.filterData.filter_modelity == 0 && vm.filterData.filter_vehicle == 0) {
                    getAllDrivers(0, vm.itemsPerPageGot, true);
                } else {
                    getFilterDriverHit(0, vm.itemsPerPageGot, vm.filterData);
                }
                //vm.filterOn = false;
                //vm.watchPagination = true;
                //vm.sp_pagination = true;

            } else {
                vm.filterData.search_filter = 1;
                vm.filterData.search_value = vm.search;
                //if (vm.filterTextTimeout) $timeout.cancel(vm.filterTextTimeout);
                if (vm.filterData.filter_branch == 0 && vm.filterData.filter_modelity == 0 && vm.filterData.filter_vehicle == 0) {
                    //vm.filterTextTimeout = $timeout(function(){
                    getAllDrivers(0, vm.itemsPerPageGot, true);
                    //},500)
                } else {
                    //vm.filterTextTimeout = $timeout(function() {
                    getFilterDriverHit(0, vm.itemsPerPageGot, vm.filterData);
                    //},500);
                }
            }
        };
        // ==========================pagination ends=========================

        //===================block unblock driver========================
        function blockUnblockDriver($event, id, value) {
            vm.loading = true;
            var promise = adminAccessService.checkStateValid('Activar / Inactivar Conductor'); //$stateParams.id
            return promise.then(
                function (payload) {
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (!payload.title.data.granted) {
                            errorMessageFactory.showErrorMessage('No está autorizado para usar esta opción', 0);
                            //errorMessageFactory.showErrorMessage('Option not available because you not have the right',0);
                            return false;
                        } else {
                            vm.loading = false;
                            blockDriverPopUp($event, id, value);
                            return true;
                        }
                    }
                },
                function (errorPayload) {
                    console.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        function blockDriverPopUp($event, id, value) {
            var msg = '';
            var msgSys = '';
            var flag = '';
            if (value == 0) {
                msg = languageBasedErrorFactory.getProperErrorMessage('blockDriver1', 0, '3');
                msgSys = 'Driver blocked.';
                flag = 1;
            } else {
                msg = languageBasedErrorFactory.getProperErrorMessage('unblockDriver', 0, '3');
                msgSys = 'Driver unblocked.';
                flag = 0;
            }
            vm.items = {
                id: id,
                comments: '',
                value: flag,
                message: msg
            };
            var timeZone = new Date().getTimezoneOffset();
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/blockUnblockPop.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });

            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.items.FlagBlocked = value;
                $scope.items.hours = [];
                // $scope.HourValue  = '';
                var dataHour = {
                    0: {
                        id: 0,
                        name: 'Indefinido'
                    },
                    1: {
                        id: 24,
                        name: '24 horas'
                    },
                    2: {
                        id: 48,
                        name: '48 horas'
                    },
                    3: {
                        id: 72,
                        name: '72 horas'
                    },
                    4: {
                        id: 1,
                        name: '1 horas'
                    }
                }
                // var domain = checkDomain.getDomainName();
                // if (domain == 'dev' || domain == 'test') {
                //     dataHour['4'] = {
                //         id: 5,
                //         name: '1 horas'
                //     }
                // }
                $scope.items.hours = dataHour;

                $scope.hours = function (data) {
                    $scope.HourValue = data;

                }
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    if ($scope.HourValue == undefined && value == 0) {
                        return;
                    } else {
                        $log.log('confirmed');
                        $mdDialog.hide();
                        vm.loading = true;
                        var promise = getDrivers.blockUnblockDriver(id, flag, vm.items.comments, $scope.HourValue, timeZone);
                        promise.then(
                            function (payload) {
                                console.log(payload, 'payload');

                                $log.log(payload);
                                vm.loading = false;
                                if (payload.title.status == 400) {
                                    if (payload.title.data.length > 0) {
                                        jobIdForDriverBlock(payload, $event);
                                    } else {
                                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                                    }
                                } else if (payload.title.status == 401) {
                                    errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                                } else if (payload.title.status == 201 || payload.title.status == 200) {
                                    var dataForSysLogs = {
                                        access_token: $cookies.get('obj'),
                                        id: id,
                                        identity: 0, // 0- driver, 1- customer , 2 -car
                                        message: msgSys
                                    };
                                    $rootScope.systemLogsAdmin(dataForSysLogs);
                                    // $state.reload('layout.approvedDriverMain.approvedDriver');

                                }
                            },
                            function (errorPayload) {
                                $log.log(errorPayload);
                                vm.loading = false;
                                if (errorPayload.data.status == 401) {
                                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                                } else {
                                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                                }
                            }
                        );
                    }
                };
            }
        }

        //=======================open pop up after booking creation============================
        function jobIdForDriverBlock(data, text, $event) {
            vm.items = {};
            // vm.items.authPending = text == 'Auth' ? true : false;
            //console.log(data, "jshjkhkajhdsjkadhkdhaskjdhaskjdhkjasdhj");
            vm.items.tableData = data.title.data;
            console.log(vm.items.tableData, 'vm.items.tableData');
            vm.items.message = data.title.message;
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/blockUblockDriverJobIds.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                escapeToClose: false,
                controller: CreateBookingSuccessController
            });

            function CreateBookingSuccessController($scope, $mdDialog, items, tmhDynamicLocale) {
                $scope.items = items;
                tmhDynamicLocale.set('es');
                var win = '';
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };

            }
        }

        //=====================to delete driver====================
        function deleteUser(id, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('deleteDriver', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                vm.loading = true;
                var promise = getDrivers.deleteUser(id);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        var dataForSysLogs = {
                            access_token: $cookies.get('obj'),
                            id: id,
                            identity: 0, // 0- driver, 1- customer , 2 -car
                            message: 'Driver deleted.'
                        };
                        $rootScope.systemLogsAdmin(dataForSysLogs);
                        languageBasedErrorFactory.getProperErrorMessage('deleteDriverSucc', 0, 1, 'layout.approvedDriverMain.approvedDriver');
                        //errorMessageFactory.showErrorMessage('Driver deleted successfully.',1);
                        //$state.reload();
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        };

        if ($rootScope.socket.connected == false || $rootScope.socket.connected == 'false') {
            $rootScope.socket.connect();
        }

        //==================== SOCKET EVENT TO BLOCK UNBLOCK EVENT ===================
        var myListener1 = $rootScope.$on('driverBlockUnblockSocket', function (evt, data) {
            if (data.res.message)
                data = data.res.message;
            var index = vm.driverList.findIndex(function (x) {
                return x.fleet_id == data.fleet_id;
            });
            if (index >= 0) {
                vm.driverList[index].is_blocked = data.is_blocked;
                if (data.block_hours != null) {
                    vm.driverList[index].block_hours = data.block_hours;
                } else {
                    vm.driverList[index].block_hours = '--';
                    vm.driverList[index].block_Time_left = '--';
                }
                if (vm.driverList[index].is_blocked == 0 || vm.driverList[index].is_blocked == 1) {
                    if (vm.currentPage == 0 && vm.itemsPerPageSelected != 10) {
                        if (vm.itemsPerPageSelected > 250) {
                            getAllDrivers((vm.currentPage - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected, false);
                        } else {
                            getAllDrivers(0, vm.itemsPerPageSelected, false);
                        }
                    } else {
                        if (vm.search == '')
                            getAllDrivers((vm.currentPage - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot, false);
                        else getAllDrivers(0, vm.itemsPerPageSelected, false);
                    }
                    // }
                    // if (vm.driverList[index].is_blocked == 1) {
                    //     if (data.blocked_upto_time == null) {
                    //         if (vm.driverList[index].block_Time_left == '00:00') {
                    //             vm.driverList[index].block_Time_left = '--';
                    //             $interval.cancel(vm.promiseSocket);
                    //             $scope.$apply();
                    //         } else {
                    //             vm.driverList[index].block_Time_left = '--';
                    //             $interval.cancel(vm.promiseSocket);
                    //             $scope.$apply();
                    //         }
                    //     } else {
                    //         var countDownDate = new Date(data.blocked_upto_time);
                    //         var now = new Date().getTime();
                    //         // var duration = moment.duration(end.diff(startTime));
                    //         // var hours = duration.asHours();
                    //         var difference = countDownDate - now;
                    //         var hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    //         var minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
                    //         console.log(minutes, 'minutes', hours, 'hours');

                    //         if (hours <= 9) {
                    //             if (hours < 0) {
                    //                 hours = '00';
                    //             } else {
                    //                 hours = '0' + hours;
                    //             }
                    //         }
                    //         if (minutes <= 9) {
                    //             if (minutes < 0) {
                    //                 minutes = '00';
                    //             } else {
                    //                 minutes = '0' + minutes;
                    //             }
                    //         }
                    //         if (vm.driverList[index].block_Time_left == '00:00') {
                    //             vm.driverList[index].block_Time_left = '--';
                    //         } else {
                    //             vm.driverList[index].block_Time_left = hours + ":" + minutes;
                    //         }
                    //         vm.promiseSocket = $interval(function () {
                    //             now = new Date().getTime();
                    //             difference = countDownDate - now;
                    //             hours = Math.floor((difference % (1000 * 60 * 60 * vm.driverList[index].block_hours)) / (1000 * 60 * 60));
                    //             minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
                    //             // var seconds = Math.floor((difference % (1000 * 60) / 1000));
                    //             console.log(minutes, 'minutes', hours, 'hours');
                    //             if (hours <= 9) {
                    //                 if (hours < 0) {
                    //                     hours = '00';
                    //                 } else {
                    //                     hours = '0' + hours;
                    //                 }
                    //             }
                    //             if (minutes <= 9) {
                    //                 if (minutes < 0) {
                    //                     minutes = '00';
                    //                 } else {
                    //                     minutes = '0' + minutes;
                    //                 }
                    //             }
                    //             if (vm.driverList[index].block_Time_left == '00:00') {
                    //                 vm.driverList[index].block_Time_left = '--';
                    //             } else {
                    //                 vm.driverList[index].block_Time_left = hours + ":" + minutes;
                    //             }
                    //         }, 60000);
                    //     }
                }

            }
            $scope.$apply();
        });
        $scope.$on('$destroy', myListener1);

        //==================== SOCKET EVENT TO BLOCK UNBLOCK EVENT ===================
        //=================================export to csv==============================
        function exportToCSV(s, l, st, t) {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            // dataSend.limit = l;
            // dataSend.offset = s;
            dataSend.driver_status = st;
            dataSend.driver_type = t;
            // dataSend.search_filter = 0;
            var promise = getDrivers.allDriversCsv(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    // if (payload.title.status == 400) {
                    //     errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    // } else if (payload.title.status == 401) {
                    //     errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    // } else if (payload.title.status == 201 || payload.title.status == 200) {

                    //     var dataArrayE = [];
                    //     var driverListExport = payload.title.data.result;
                    //     driverListExport.forEach(function (column) {
                    //         var d = {};
                    //         d['Fleet ID'] = column.fleet_id;
                    //         d['Name'] = column.first_name + " " + column.last_name;
                    //         d['Email'] = column.email;
                    //         d['Fleet Type'] = column.fleet_type == 0 || column.fleet_type == '0' ? 'Driver with car.' : 'Driver without car.';
                    //         d['Mobile No.'] = column.country_code ? column.country_code + column.phone : column.phone;
                    //         d['Date of Joining'] = moment(column.creation_datetime).format('lll');
                    //         // d['Work Schedule'] = column.work_schedule; //TV_2680
                    //         d['Branch Name'] = column.branch_name;
                    //         d['Blocked'] = column.is_blocked == 0 || column.is_blocked == '0' ? 'Unblocked' : 'Blocked';
                    //         d['RUT'] = column.RUT;
                    //         //d.fleet_route = column.fleet_route;
                    //         dataArrayE.push(d);
                    //     });
                    //     vm.driverListExport = dataArrayE;
                    //     alasql('SELECT * INTO CSV("drivers.csv",{headers:true}) FROM ?', [vm.driverListExport]);
                    // }
                    if (payload.title.status == 200) {

                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };
        //====================get branch list====================
        // function getBranch() {
        //     vm.branchList = [];
        //     vm.branchList = JSON.parse(JSON.stringify(getFilters.branchesFiltersData.data));

        //     vm.branchList.push({
        //         region_name: 'All',
        //         region_id: 'all'
        //     });
        //     $scope.$apply();

        // vm.loading = true;
        // var promise = getGeofence.branch();
        // promise.then(
        //     function (payload) {
        //         $log.log(payload);
        //         //vm.loading = false;
        //         if (payload.title.status == 400) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //         } else if (payload.title.status == 401) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //         } else if (payload.title.status == 201 || payload.title.status == 200) {
        //             var where = _.where(payload.title.data, {
        //                 parent_id: 0
        //             });
        //             //vm.branchList = _.where(where, { is_active: 1 });
        //             vm.branchList = where;

        //             vm.branchList.push({
        //                 region_name: 'All',
        //                 region_id: 'all'
        //             });
        //         }
        //     },
        //     function (errorPayload) {
        //         $log.log(errorPayload);
        //         //vm.loading = false;
        //         if (errorPayload.data.status == 401) {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //         } else {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //         }
        //     }
        // );
        // }
        // WHen Page refresh service take time to get data from backend
        // setTimeout(function () {
        //     getBranch();
        // }, 1000);


        //========================get filter driver hit=======================
        function getFilterDriverHit(skip, limit, data) {
            if (data.filter_branch == 0 && data.filter_modelity == 0 && data.filter_vehicle == 0) {
                vm.getAllDrivers(0, vm.itemsPerPageGot, true);
                return;
            }
            var dataSend = {};
            dataSend.offset = skip;
            dataSend.limit = limit;
            dataSend.driver = data.driver;
            dataSend.filter_branch = data.filter_branch;
            if (data.filter_branch && data.branch != 'all') {
                dataSend.filter_branch_value = data.branch;
            }
            dataSend.filter_modelity = data.filter_modelity;
            if (data.filter_modelity && data.modelity != 'all') {
                dataSend.filter_modelity_value = Number(data.modelity);
            }
            dataSend.filter_vehicle = data.filter_vehicle;
            if (data.filter_vehicle && data.vehicle_unique) {
                dataSend.filter_vehicle_value = data.vehicle_unique;
            }
            dataSend.search_filter = data.search_filter;
            if (data.search_filter == 1) {
                dataSend.search_value = data.search_value;
            }
            dataSend.access_token = $cookies.get('obj');
            vm.loading = true;
            var promise = getDrivers.driverFilter(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.totalDrivers = payload.title.data.totalCount;
                        vm.dataLength = payload.title.data.totalCount;

                        if (payload.title.data.totalCount == 0) {
                            vm.sp_pagination = false;
                            vm.tBodyFlag = false;
                            vm.tFootFlag = true;
                            vm.filterOn = true;
                            vm.skipValueFilter = 0;
                        } else {
                            vm.sp_pagination = true;
                            vm.tBodyFlag = true;
                            vm.tFootFlag = false;
                            vm.filterOn = false;
                            vm.skipValueFilter = 0;

                            var dataArray = [];
                            var driverList = payload.title.data.result;
                            driverList.forEach(function (column) {
                                var d = {};
                                d.name = column.first_name + " " + column.last_name;
                                d.email = column.email;
                                d.fleet_type = column.fleet_type;
                                d.fleet_route = column.fleet_route;
                                // d.work_schedule = column.work_schedule;  //TV_2680
                                d.fleet_id = column.fleet_id;
                                d.creation_datetime = column.creation_datetime;
                                d.is_blocked = column.is_blocked;
                                d.branch_name = column.branch_name;
                                d.assigned_cars = column.assigned_cars;
                                d.phone = column.country_code ? column.country_code + column.phone : column.phone;
                                dataArray.push(d);
                            });
                            vm.driverList = dataArray;

                            for (var i = 0; i < vm.driverList.length; i++) {
                                vm.driverList[i].index = (skip + i);
                            }
                            if (vm.dataLength <= vm.itemsPerPageGot) {
                                vm.sp_pagination = false;
                            } else {
                                vm.sp_pagination = true;
                                //vm.pageCount(payload.title.totalCount);
                            }
                            vm.skipValue = vm.driverList[0].index;
                            vm.limitValue = vm.driverList[vm.driverList.length - 1].index;

                            //$scope.$watch('vm.search', function(newVal, oldVal) {
                            //    vm.filtered = filterFilter(vm.driverList, newVal);
                            //    vm.totalItems = vm.filtered.length;
                            //    if (vm.filtered.length == 0) {
                            //        vm.watchPagination = false;
                            //    } else {
                            //        vm.watchPagination = true;
                            //    }
                            //    if (vm.filterOn == true) {
                            //        vm.skipValueFilter = vm.filtered.length;
                            //        vm.sp_pagination = false;
                            //    }
                            //}, true);

                            //range();
                        }
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };

        //==================filter change functions===================
        function branchChanged() {
            vm.currentPage = 0;
            if (vm.filterData.branch && vm.filterData.branch != 'all') {
                vm.filterData.filter_branch = 1;
                getFilterDriverHit(0, vm.itemsPerPageGot, vm.filterData);
                vm.agreement = [];
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                clearOffset();
                getFilterDataFromBackend();
            } else {
                vm.filterData.filter_branch = 0;
                vm.filterData.branch = 'all';
                getFilterDriverHit(0, vm.itemsPerPageGot, vm.filterData);
                vm.agreement = [];
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                clearOffset();
                getFilterDataFromBackend();
            }
        };

        function modelityValueChanged() {
            // TV_2680
            // vm.currentPage = 0;
            // if (vm.filterData.modelity && vm.filterData.modelity != 'all') {
            //     vm.filterData.filter_modelity = 1;
            //     getFilterDriverHit(0, vm.itemsPerPageGot, vm.filterData);
            // } else {
            //     vm.filterData.filter_modelity = 0;
            //     vm.filterData.modelity = 'all';
            //     getFilterDriverHit(0, vm.itemsPerPageGot, vm.filterData);
            // }
        };

        function vehicleChanged(data) {
            vm.currentPage = 0;
            if (data) {
                vm.filterData.filter_vehicle = 1;
                vm.filterData.vehicle_unique = Number(vm.filterData.vehicle_unique);
            } else {
                vm.filterData.filter_vehicle = 0;
                vm.filterData.vehicle_unique = '';
            }
            //getUniqueNumber();
        };

        function getUniqueNumber() {
            vm.currentPage = 0;
            getFilterDriverHit(0, vm.itemsPerPageGot, vm.filterData);
        };


        //===================side bar filters=====================
        vm.showFilterArea = showFilterArea;
        vm.branchChangedFilter = branchChangedFilter;
        vm.modelityChangedFilter = modelityChangedFilter;
        vm.removeFilter = removeFilter;
        vm.vehicleAssignChangedFilter = vehicleAssignChangedFilter;
        vm.showFilterFlag = false;

        vm.filterWhichToShow = {
            branchWithDashboard: false,
            service: false,
            vehicle: false,
            agreement: false,
            operation: false,
            helpTraffic: false,
            virtualFleet: false,
            approvalStage: false,
            applicantType: false,
            tripType: false,
            modelity: true,
            vehicleAssigned: true
        };


        function removeFilter() {
            $state.reload('layout.approvedDriverMain.approvedDriver');
        }

        function showFilterArea() {
            vm.showFilterFlag = !vm.showFilterFlag;
        }

        function branchChangedFilter(data) {
            vm.branchChanged();
        }

        function modelityChangedFilter(data) {
            vm.modelityValueChanged();
        }

        function vehicleAssignChangedFilter(data) {
            vehicleChanged(data.vehicle_unique);
        }

    }
})();
/**
 * Created by cl-macmini-51 on 4/28/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('RegisterApplicantController', RegisterApplicantController);

    /** @ngInject */
    function RegisterApplicantController($cookies, $state, $log, $rootScope, $timeout, $stateParams, getCommuna, $mdDialog, $document, moment, getDrivers, $scope,
        RutHelper, getGeofence, getVehicles, languageBasedErrorFactory, errorMessageFactory) {
        var vm = this;
        vm.loading = true;
        vm.registerApi = registerApi;
        vm.goBack = goBack;
        vm.datePickerE_1 = datePickerE_1;
        vm.getComuna = getComuna;
        vm.clickTrigger = clickTrigger;
        vm.matchPassword = matchPassword;
        vm.matchPasswordAgain = matchPasswordAgain;
        vm.addVehicle = addVehicle;
        vm.deleteVehicleType = deleteVehicleType;
        vm.rutChange = rutChange;
        vm.rutChange2 = rutChange2
        vm.rutChange1 = rutChange1;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.passwordMatchFlag = false;
        vm.dateOptions = {};
        vm.driverBankNamesArray = [];
        vm.datePicker_1 = {
            end: false
        };
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.altInputFormats = ['M!/d!/yyyy'];
        vm.dataToFill = {
            registration_flag: '',
            first_name: '',
            last_name: '',
            email: '',
            invoice_rut_image: '',
            business_name: '',
            invoice_rut: '',
            payment_modulity: '',
            bank_name: '',
            account_type: '',
            account_number: '',
            password: '',
            confirm_password: '',
            country_code: '+56',
            phone_number: '',
            username: '',
            latitude: '',
            longitude: '',
            device_type: '',
            device_token: '',
            number: '',
            apartment: '',
            street: '',
            sector: '',
            // region: '',
            RUT: '',
            account_rut:'',
            license_type: '',
            license_expiry_date: new Date(),
            branch: '',
            fleet_img: '',
            RUT_img: '',
            life_sheet_img: '',
            license_img: '',
            antecents_certificate: '',
            company_identity_card: '',
            company_constitution: '',
            invoice_stamping: '',
            activity_start: '',
            work_schedule: '',
            // company_type: '',
            car_details: [{
                car_photo: '',
                register_image: '',
                car_type: '',
                register_number: '',
                modelity: '',
                travel_card_key: '',
                passenger_insurance_key: '',
                permission_of_circulation: '',
                transportation_permit: '',
                verification_comment: ' ',
                society_id: ''
            }]
        };

        function rutChange() {
            $log.log('data', vm.dataToFill.RUT);
            if (vm.dataToFill.RUT) {
                if (RutHelper.validate(vm.dataToFill.RUT)) {
                    $log.log();
                    vm.rutFlag = false;
                } else {
                    vm.rutFlag = true;
                }
            } else if (vm.dataToFill.RUT === null) {
                vm.rutFlag = true;
            } else if (vm.dataToFill.RUT === undefined) {
                vm.rutFlag = false;
            }
        }

        function rutChange2() {
            $log.log('data', vm.dataToFill.account_rut);
            if (vm.dataToFill.account_rut) {
                if (RutHelper.validate(vm.dataToFill.account_rut)) {
                    $log.log();
                    vm.rutFlag = false;
                } else {
                    vm.rutFlag = true;
                }
            } else if (vm.dataToFill.account_rut === null) {
                vm.rutFlag = true;
            } else if (vm.dataToFill.account_rut === undefined) {
                vm.rutFlag = false;
            }
        }

        function rutChange1() {
            $log.log('data', vm.dataToFill.invoice_rut);
            if (vm.dataToFill.invoice_rut) {
                if (RutHelper.validate(vm.dataToFill.invoice_rut)) {
                    $log.log();
                    vm.rutFlag1 = false;
                } else {
                    vm.rutFlag1 = true;
                }
            } else if (vm.dataToFill.invoice_rut === null) {
                vm.rutFlag1 = true;
            } else if (vm.dataToFill.invoice_rut === undefined) {
                vm.rutFlag1 = false;
            }
        }

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.applicantsMain.registerApplicant');
            }
        });
        //=================go back================
        function goBack() {
            $state.go('layout.applicantsMain.applicants');
        };

        //==================date picker function==================
        vm.dateOptions = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(2090, 12, 31),
            minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };

        function datePickerE_1() {
            vm.datePicker_1.end = true;
        };
        //======================get all vehicles==============
        function getAllVehicles(skip, limt, filter) {
            vm.loading = true;
            var promise = getVehicles.allVehicles(skip, limt, filter);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    //vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.vehicle = [];
                        angular.forEach(payload.title.data.result, function (column) {
                            if (column.status == 1)
                                vm.vehicle.push({
                                    id: column.id,
                                    name: column.name
                                });
                        });
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllVehicles(0, 0, 2);

        //====================get comuna list====================
        function getComuna() {
            vm.loading = true;
            var promise = getCommuna.communaList();
            promise.then(
                function (payload) {
                    $log.log(payload);
                    //vm.loading = false;
                    vm.communaList = payload.title.data;
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        //getComuna();
        //====================get branch list====================
        function getBranch() {
            vm.loading = true;
            var promise = getGeofence.branch();
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        var where = _.where(payload.title.data, {
                            parent_id: 0
                        });
                        vm.branchList = _.where(where, {
                            is_active: 1
                        });
                        console.log(vm.branchList,'vm.branchList');
                        
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        getBranch();
        //=======================licence types function====================

        vm.licenceTypesData = [];

        function licenseTypes() {
            vm.loading = true;
            var promise = getVehicles.getLicenseType();
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    //vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.licenseTypes = [];
                        vm.licenseTypes = payload.title;
                        angular.forEach(vm.licenseTypes.data, function (data) {
                            vm.licenceTypesData.push(data.license_class_type);
                        });
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        licenseTypes();

        //=======================password match function====================
        function matchPassword(data) {
            if (data) {
                if (data != vm.dataToFill.password) {
                    vm.passwordMatchFlag = true;
                } else {
                    vm.passwordMatchFlag = false;
                }
            }
        };

        function matchPasswordAgain(data) {
            if (data && vm.dataToFill.confirm_password) {
                if (data != vm.dataToFill.confirm_password) {
                    vm.passwordMatchFlag = true;
                } else {
                    vm.passwordMatchFlag = false;
                }
            }
        };
        //==================file upload function========================
        vm.uploadName = '';

        function clickTrigger($event, type, index) {
            $log.log('ddf');
            $event.stopPropagation();
            vm.uploadName = type;
            if (index != null || index != '' || index != undefined) {
                vm.indexGot = index;
            }
            var element = document.getElementById('documentUpload');
            element.click();
        };

        //===============file for customer edit=============
        $scope.file_to_upload = function (File, type) {
            $log.log('type', type);
            var file = File[0];
            var transcript = File[0];
            var reader = new FileReader;
            reader.onload = function (e) {
                //    var img = new Image;
                //    img.onload = function () {
                if (type == 'PROFILE') {
                    document.getElementById('profilePic').setAttribute('src', e.target.result);
                    vm.dataToFill.fleet_img = File[0];
                } else if (type == 'INVOICE') {
                    document.getElementById('invoiceRUT').setAttribute('src', e.target.result);
                    vm.dataToFill.invoice_rut_image = File[0];
                } else if (type == 'ACTIVITY') {
                    document.getElementById('activity').setAttribute('src', e.target.result);
                    vm.dataToFill.activity_start = File[0];
                } else if (type == 'CONSTITUTION') {
                    document.getElementById('constitution').setAttribute('src', e.target.result);
                    vm.dataToFill.company_constitution = File[0];
                } else if (type == 'COMPANY_IDENTITY_CARD') {
                    document.getElementById('companyIdentity').setAttribute('src', e.target.result);
                    vm.dataToFill.company_identity_card = File[0];
                } else if (type == 'ANTECENTS') {
                    document.getElementById('antecents').setAttribute('src', e.target.result);
                    vm.dataToFill.antecents_certificate = File[0];
                } else if (type == 'LIFE_SHEET') {
                    document.getElementById('lifeSheet').setAttribute('src', e.target.result);
                    vm.dataToFill.life_sheet_img = File[0];
                } else if (type == 'LICENSE') {
                    document.getElementById('licenseImage').setAttribute('src', e.target.result);
                    vm.dataToFill.license_img = File[0];
                } else if (type == 'RUT') {
                    document.getElementById('rutImage').setAttribute('src', e.target.result);
                    vm.dataToFill.RUT_img = File[0];
                } else if (type == 'CAR_IMAGE') {
                    $log.log(vm.indexGot);
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'carImage' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.dataToFill.car_details[vm.indexGot].car_photo = File[0];
                    }
                } else if (type == 'REGISTER_IMAGE') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'registerImage' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.dataToFill.car_details[vm.indexGot].register_image = File[0];
                    }
                } else if (type == 'PASSENGER_INSURANCE_KEY') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'seatInsurance' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.dataToFill.car_details[vm.indexGot].passenger_insurance_key = File[0];
                    }
                } else if (type == 'TRAVEL_CARD_KEY') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'travel' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.dataToFill.car_details[vm.indexGot].travel_card_key = File[0];
                    }
                } else if (type == 'PERMISSION_OF_CIRCULATION') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'permission' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.dataToFill.car_details[vm.indexGot].permission_of_circulation = File[0];
                    }
                } else if (type == 'TRANSPORTATION_PERMIT') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'transportation_permit' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.dataToFill.car_details[vm.indexGot].transportation_permit = File[0];
                    }
                }

                //};

                //    img.src = reader.result;
            };
            reader.readAsDataURL(transcript);
            $log.log(vm.dataToFill);
        };

        //===================add vehicles======================
        function addVehicle(index) {
            $log.log(index);
            vm.dataToFill.car_details.push({
                car_photo: '',
                register_image: '',
                car_type: '',
                register_number: '',
                modelity: '',
                travel_card_key: '',
                passenger_insurance_key: '',
                permission_of_circulation: '',
                transportation_permit: '',
                verification_comment: ' ',
                society_id:''
            });
        };

        function deleteVehicleType(index) {
            $log.log(index);
            vm.dataToFill.car_details.splice(index, 1);
        };
        //======================submit form====================
        function registerApi() {

            if (vm.passwordMatchFlag) {
                // errorMessageFactory.showErrorMessage("Password doesnot match", 0);
                return false
            }

            $log.log(vm.dataToFill);
            if (vm.dataToFill.registration_flag != '2') {
                //if(vm.dataToFill.fleet_img == undefined || vm.dataToFill.fleet_img == null || vm.dataToFill.fleet_img == ''){
                //    errorMessageFactory.showErrorMessage('Please upload profile pic.');
                //    return;
                //}
                // if (vm.dataToFill.RUT_img == undefined || vm.dataToFill.RUT_img == null || vm.dataToFill.RUT_img == '') {
                //     //errorMessageFactory.showErrorMessage('Please upload RUT image.');
                //     languageBasedErrorFactory.getProperErrorMessage('uploadRUTImage', 0, 0);
                //     return;
                // }
                if (vm.dataToFill.license_img == undefined || vm.dataToFill.license_img == null || vm.dataToFill.license_img == '') {
                    //errorMessageFactory.showErrorMessage('Please upload license image.');
                    languageBasedErrorFactory.getProperErrorMessage('uploadLicenseImage', 0, 0);
                    return;
                }
                if (vm.dataToFill.life_sheet_img == undefined || vm.dataToFill.life_sheet_img == null || vm.dataToFill.life_sheet_img == '') {
                    //errorMessageFactory.showErrorMessage('Please upload life sheet image.');
                    languageBasedErrorFactory.getProperErrorMessage('uploadLifeSheetImage', 0, 0);
                    return;
                }
                if (vm.dataToFill.antecents_certificate == undefined || vm.dataToFill.antecents_certificate == null || vm.dataToFill.antecents_certificate == '') {
                    //errorMessageFactory.showErrorMessage('Please upload antecedents certificate.');
                    languageBasedErrorFactory.getProperErrorMessage('uploadAntecedentImage', 0, 0);
                    return;
                }

            }
            // TV_2680
            // if (vm.dataToFill.registration_flag == '0') {
            //     if (vm.dataToFill.work_schedule == undefined || vm.dataToFill.work_schedule == null || vm.dataToFill.work_schedule == '') {
            //         //errorMessageFactory.showErrorMessage('Please select work schedule.');
            //         languageBasedErrorFactory.getProperErrorMessage('workScheduleCheck', 0, 0);
            //         return;
            //     }
            // }

            if (vm.dataToFill.registration_flag == '0' || vm.dataToFill.registration_flag == '2') { //|| vm.dataToFill.registration_flag == '2'
                for (var i = 0; i < vm.dataToFill.car_details.length; i++) {
                    /////////// TICKET 2807 ///////////
                    // if (vm.dataToFill.car_details[i].car_photo == undefined || vm.dataToFill.car_details[i].car_photo == null || vm.dataToFill.car_details[i].car_photo == '') {
                    //     //errorMessageFactory.showErrorMessage('Please upload car image.');
                    //     languageBasedErrorFactory.getProperErrorMessage('carImageCheck', 0, 0);
                    //     return;
                    // }
                    // if (vm.dataToFill.car_details[i].register_image == undefined || vm.dataToFill.car_details[i].register_image == null || vm.dataToFill.car_details[i].register_image == '') {
                    //     //errorMessageFactory.showErrorMessage('Please upload car registration image.');
                    //     languageBasedErrorFactory.getProperErrorMessage('carRegistrationImage', 0, 0);
                    //     return;
                    // }
                    // if (vm.dataToFill.car_details[i].passenger_insurance_key == undefined || vm.dataToFill.car_details[i].passenger_insurance_key == null || vm.dataToFill.car_details[i].passenger_insurance_key == '') {
                    //     //errorMessageFactory.showErrorMessage('Please upload car passenger insurance image.');
                    //     languageBasedErrorFactory.getProperErrorMessage('carPassengerImage', 0, 0);
                    //     return;
                    // }
                    // if (vm.dataToFill.car_details[i].travel_card_key == undefined || vm.dataToFill.car_details[i].travel_card_key == null || vm.dataToFill.car_details[i].travel_card_key == '') {
                    //     //errorMessageFactory.showErrorMessage('Please upload car travel card key.');
                    //     languageBasedErrorFactory.getProperErrorMessage('carTravelKeyImage', 0, 0);
                    //     return;
                    // }
                    if (vm.dataToFill.car_details[i].permission_of_circulation == undefined || vm.dataToFill.car_details[i].permission_of_circulation == null || vm.dataToFill.car_details[i].permission_of_circulation == '') {
                        //errorMessageFactory.showErrorMessage('Please upload permission of circulation.');
                        languageBasedErrorFactory.getProperErrorMessage('carCirculationImage', 0, 0);
                        return;
                    }
                    // if (vm.dataToFill.car_details[i].transportation_permit == undefined || vm.dataToFill.car_details[i].transportation_permit == null || vm.dataToFill.car_details[i].transportation_permit == '') {
                    //     //errorMessageFactory.showErrorMessage('Please upload permission of circulation.');
                    //     languageBasedErrorFactory.getProperErrorMessage('transportationImage', 0, 0);
                    //     return;
                    // }
                }
            }

            $log.log(vm.dataToFill);
            var dataSend = new FormData();
            dataSend.append('access_token', $cookies.get('obj'));
            dataSend.append('registration_flag', Number(vm.dataToFill.registration_flag));
            dataSend.append('first_name', vm.dataToFill.first_name);
            dataSend.append('last_name', vm.dataToFill.last_name);
            dataSend.append('email', vm.dataToFill.email);
            dataSend.append('password', vm.dataToFill.password);
            dataSend.append('country_code', vm.dataToFill.country_code);
            dataSend.append('phone_number', vm.dataToFill.phone_number);
            dataSend.append('username', vm.dataToFill.username);
            dataSend.append('device_type', 2);
            dataSend.append('device_token', 'web');
            dataSend.append('street', vm.dataToFill.street);
            //dataSend.append('sector', vm.dataToFill.sector);
            // dataSend.append('region', vm.dataToFill.region);
            dataSend.append('branch', vm.dataToFill.branch);
            dataSend.append('timezone', new Date().getTimezoneOffset());

            // TV_2680
            // if (vm.dataToFill.registration_flag == '0') {
            //     dataSend.append('work_schedule', Number(vm.dataToFill.work_schedule)); // only for driver with car
            // }

            if (vm.dataToFill.registration_flag != '2') {
                dataSend.append('RUT_img', vm.dataToFill.RUT_img);
                dataSend.append('life_sheet_img', vm.dataToFill.life_sheet_img);
                dataSend.append('license_img', vm.dataToFill.license_img);
                dataSend.append('antecents_certificate', vm.dataToFill.antecents_certificate);
                dataSend.append('RUT', vm.dataToFill.RUT); // not for car investor
                dataSend.append('license_expiry_date', moment(vm.dataToFill.license_expiry_date).format('YYYY-MM-DD')); // not for car investor
                dataSend.append('license_type', vm.dataToFill.license_type); // not for car investor
            }

            if (vm.dataToFill.registration_flag != '1') {
                if (vm.dataToFill.business_name)
                    dataSend.append('business_name', vm.dataToFill.business_name);
                if (vm.dataToFill.invoice_rut)
                    dataSend.append('invoice_rut', vm.dataToFill.invoice_rut);
                if (vm.dataToFill.payment_modulity)
                    dataSend.append('payment_modulity', vm.dataToFill.payment_modulity);
                if (vm.dataToFill.account_type)
                    dataSend.append('account_type', vm.dataToFill.account_type);
                if (vm.dataToFill.account_rut)
                    dataSend.append('account_rut', vm.dataToFill.account_rut);
                if (vm.dataToFill.account_number)
                    dataSend.append('account_number', vm.dataToFill.account_number);
                if (vm.dataToFill.bank_name)
                    dataSend.append('bank_name', vm.dataToFill.bank_name);
            }

            if (vm.dataToFill.number) {
                dataSend.append('number', vm.dataToFill.number);
            }
            if (vm.dataToFill.apartment) {
                dataSend.append('apartment', vm.dataToFill.apartment);
            }
            // if(vm.dataToFill.company_type){
            //     dataSend.append('company_type', vm.dataToFill.company_type);
            // }
            if (vm.dataToFill.fleet_img) {
                dataSend.append('fleet_img', vm.dataToFill.fleet_img);
            }
            if (vm.dataToFill.invoice_rut_image) {
                dataSend.append('invoice_rut_image', vm.dataToFill.invoice_rut_image);
            }
            if (vm.dataToFill.registration_flag != '1') {
                var carArray = [];
                for (var i = 0; i < vm.dataToFill.car_details.length; i++) {
                    carArray.push({
                        car_type: Number(vm.dataToFill.car_details[i].car_type.id),
                        modelity: Number(vm.dataToFill.car_details[i].modelity),
                        verification_comment:  (vm.dataToFill.car_details[i].verification_comment),
                        registration_number: vm.dataToFill.car_details[i].register_number.replace(/ /g, '').toUpperCase(),
                        society_id: Number(vm.dataToFill.car_details[i].society_id)
                    });
                    // if (vm.dataToFill.car_details[i].car_photo) {
                    //     dataSend.append('car_photo[]', vm.dataToFill.car_details[i].car_photo);
                    // }
                    // if (vm.dataToFill.car_details[i].register_image) {
                    //     dataSend.append('registration_image[]', vm.dataToFill.car_details[i].register_image);
                    // }
                    // if (vm.dataToFill.car_details[i].travel_card_key) {
                    //     dataSend.append('travel_card_key[]', vm.dataToFill.car_details[i].travel_card_key);
                    // }
                    // if (vm.dataToFill.car_details[i].passenger_insurance_key) {
                    //     dataSend.append('passenger_insurance_key[]', vm.dataToFill.car_details[i].passenger_insurance_key);
                    // }
                    if (vm.dataToFill.car_details[i].permission_of_circulation) {
                        dataSend.append('permission_of_circulation[]', vm.dataToFill.car_details[i].permission_of_circulation);
                    }
                    if (vm.dataToFill.car_details[i].transportation_permit) {
                        dataSend.append('transportation_permit[]', vm.dataToFill.car_details[i].transportation_permit);
                    }
                }
                dataSend.append('car_details', JSON.stringify(carArray));
            }


            vm.loading = true;
            var promise = getDrivers.registerDriver(dataSend);
            promise.then(
                function (payload) {
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        $log.log(payload);
                        if (vm.dataToFill.registration_flag == '0') {
                            languageBasedErrorFactory.getProperErrorMessage('registerApplicantSuccess1', 0, 2, 'layout.applicantsMain.applicants');
                            //errorMessageFactory.showErrorMessage('The application of the driver with car has been successful.', 2, 'layout.applicantsMain.applicants');
                        } else if (vm.dataToFill.registration_flag == '1') {
                            languageBasedErrorFactory.getProperErrorMessage('registerApplicantSuccess2', 0, 2, 'layout.applicantsMain.applicants');
                            //errorMessageFactory.showErrorMessage('The application of the driver without car has been successful.', 2, 'layout.applicantsMain.applicants');
                        } else if (vm.dataToFill.registration_flag == '2') {
                            languageBasedErrorFactory.getProperErrorMessage('registerApplicantSuccess3', 0, 2, 'layout.applicantsMain.applicants');
                            //errorMessageFactory.showErrorMessage('The application of the car investor has been successful.', 2, 'layout.applicantsMain.applicants');
                        }
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }

                    //$timeout(function() {
                    //    $mdDialog.hide();
                    //    $state.go('layout.applicantsMain.applicants');
                    //}, 2000);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }

            );
        };

        // ***** GET DRIVER BACK NAMES *********
        function getDriverBankNames() {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            var promise = getDrivers.driverBankNames(dataSend);
            promise.then(
                function (payload) {
                    vm.loading = false;
                    vm.driverBankNamesArray = payload.title || [];
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }

            );
        }
        getDriverBankNames();
        
        // ***** GET SOCIETIES *********
        function getAllSocieties() {
            var dataSend = {};
            // dataSend.access_token = $cookies.get('obj');
            vm.loading = true;
            var promise = getDrivers.societiesList();
            promise.then(
                function (payload) {
                    if (payload.title.status == 200) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        vm.societies = payload.title.data;       
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }

                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };
        getAllSocieties();
    }
})();
/**
 * Created by cl-macmini-51 on 5/30/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('EditApplicantDetailsController', EditApplicantDetailsController);

    /** @ngInject */
    function EditApplicantDetailsController($cookies, $state, $log, $rootScope, $timeout, $stateParams, getDrivers, $mdDialog, $document, getCommuna, $scope, moment, getCars,
        RutHelper, getGeofence, getVehicles, languageBasedErrorFactory, errorMessageFactory) {
        var vm = this;
        vm.loading = true;
        vm.getDriver = getDriver;
        vm.goBack = goBack;
        vm.datePickerE_1 = datePickerE_1;
        vm.getComuna = getComuna;
        vm.clickTrigger = clickTrigger;
        vm.editBasicApi = editBasicApi;
        vm.editCarApi = editCarApi;
        vm.rutChange = rutChange;
        vm.rutChange2 = rutChange2;
        vm.rutChange1 = rutChange1;
        vm.addCarApi = addCarApi;
        vm.addVehicle = addVehicle;
        vm.deleteVehicleType = deleteVehicleType;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.dateOptions = {};
        vm.driverBankNamesArray = [];
        vm.datePicker_1 = {
            end: false
        };
        vm.getAllVehicles = getAllVehicles;
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.altInputFormats = ['M!/d!/yyyy'];
        $log.log($stateParams);
        vm.licenseTypes = [];

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.applicantsMain.editApplicantsDetails');
            }
        });

        function rutChange() {
            $log.log('data', vm.dataToFill.RUT);
            if (vm.dataToFill.RUT) {
                if (RutHelper.validate(vm.dataToFill.RUT)) {
                    $log.log();
                    vm.rutFlag = false;
                } else {
                    vm.rutFlag = true;
                }
            } else if (vm.dataToFill.RUT === null) {
                vm.rutFlag = true;
            } else if (vm.dataToFill.RUT === undefined) {
                vm.rutFlag = false;
            }
        }
        function rutChange2() {
            $log.log('data', vm.dataToFill.account_rut);
            if (vm.dataToFill.account_rut) {
                if (RutHelper.validate(vm.dataToFill.account_rut)) {
                    $log.log();
                    vm.rutFlag = false;
                } else {
                    vm.rutFlag = true;
                }
            } else if (vm.dataToFill.account_rut === null) {
                vm.rutFlag = true;
            } else if (vm.dataToFill.account_rut === undefined) {
                vm.rutFlag = false;
            }
        }

        function rutChange1() {
            $log.log('data', vm.dataToFill.invoice_rut);
            if (vm.dataToFill.invoice_rut) {
                if (RutHelper.validate(vm.dataToFill.invoice_rut)) {
                    $log.log();
                    vm.rutFlag1 = false;
                } else {
                    vm.rutFlag1 = true;
                }
            } else if (vm.dataToFill.invoice_rut === null) {
                vm.rutFlag1 = true;
            } else if (vm.dataToFill.invoice_rut === undefined) {
                vm.rutFlag1 = false;
            }
        }

        //=================get driver details================
        function getDriver(id) {
            vm.loading = true;
            var promise = getDrivers.singleDriver(id);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    //vm.loading = false;
                    vm.driverDetails = payload.title.data.driver_detail;


                    vm.dataToFill = {
                        fleet_type: vm.driverDetails.fleet_type.toString(),
                        first_name: vm.driverDetails.first_name,
                        last_name: vm.driverDetails.last_name,
                        email: vm.driverDetails.email,
                        country_code: vm.driverDetails.country_code,
                        phone_number: vm.driverDetails.phone,
                        username: vm.driverDetails.username,
                        number: vm.driverDetails.number ? vm.driverDetails.number : '',
                        apartment: vm.driverDetails.apartment ? vm.driverDetails.apartment : '',
                        street: vm.driverDetails.street,
                        //sector: vm.driverDetails.sector,
                        region: vm.driverDetails.region,
                        RUT: RutHelper.format(vm.driverDetails.RUT),
                        license_type: vm.driverDetails.license_type,
                        // license_expiry_date: vm.driverDetails.license_expiry_date ? new Date(vm.driverDetails.license_expiry_date) : '',
                        branch: vm.driverDetails.branch ? Number(vm.driverDetails.branch) : '',
                        fleet_img: '',
                        RUT_img: '',
                        life_sheet_img: '',
                        license_img: '',
                        antecents_certificate: '',
                        // company_identity_card: '',
                        invoice_rut_image: '',
                        business_name: vm.driverDetails.business_name,
                        invoice_rut: vm.driverDetails.invoice_rut,
                        payment_modulity: vm.driverDetails.payment_modulity ? vm.driverDetails.payment_modulity.toString() : '',
                        bank_name: vm.driverDetails.bank_name,
                        account_type: vm.driverDetails.account_type ? vm.driverDetails.account_type.toString() : '',
                        account_rut: vm.driverDetails.account_rut,
                        account_number: vm.driverDetails.account_number,
                        // company_constitution: '',
                        // invoice_stamping: '',
                        // start_activities: '',
                        // fleet_route: vm.driverDetails.fleet_route != null ? vm.driverDetails.fleet_route.toString() : vm.driverDetails.fleet_route,
                        // TV-2680    // work_schedule: vm.driverDetails.work_schedule != null ? vm.driverDetails.work_schedule.toString() : vm.driverDetails.work_schedule,
                        // company_type: vm.driverDetails.company_type,
                        addNewCar: [{
                            car_type: '',
                            registration_image_upload: '',
                            car_image_upload: '',
                            registration_number: '',
                            verification_comment: ' ',
                            modelity: '',
                            travel_card_key_upload: '',
                            passenger_insurance_key_upload: '',
                            permission_of_circulation_upload: '',
                            transportation_permit_upload: ''
                        }],
                        addNewCarFlag: false
                    };
                    // To check if license date is null or not
                    if (vm.driverDetails.license_expiry_date && vm.driverDetails.license_expiry_date != "0000-00-00 00:00:00")
                        vm.dataToFill.license_expiry_date = new Date(vm.driverDetails.license_expiry_date);

                    vm.carDetails = vm.driverDetails.car_details;

                    for (var i = 0; i < vm.carDetails.length; i++) {
                        //vm.carDetails[i].car_type = vm.carDetails[i].car_type;
                        vm.carDetails[i].working_status = vm.carDetails[i].working_status.toString();
                        vm.carDetails[i].modelity = vm.carDetails[i].modelity.toString();
                        vm.carDetails[i].verification_comment = vm.carDetails[i].verification_comment.toString();
                        vm.carDetails[i].registration_image_upload = '';
                        vm.carDetails[i].car_image_upload = '';
                        vm.carDetails[i].travel_card_key_upload = '';
                        vm.carDetails[i].passenger_insurance_key_upload = '';
                        vm.carDetails[i].permission_of_circulation_upload = '';
                        vm.carDetails[i].transportation_permit_upload = '';

                    }
                    getAllVehicles(0, 0, 2);
                    getBranch();
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        getDriver($stateParams.id);

        //==================date picker function==================
        vm.dateOptions = {
            // dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(2090, 12, 31),
            minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };

        function datePickerE_1() {
            vm.datePicker_1.end = true;
        };
        //====================get comuna list====================
        function getComuna() {
            vm.loading = true;
            var promise = getCommuna.communaList();
            promise.then(
                function (payload) {
                    $log.log(payload);
                    //vm.loading = false;
                    vm.communaList = payload.title.data;
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        //getComuna();
        //====================get branch list====================
        function getBranch() {
            vm.loading = true;
            var promise = getGeofence.branch();
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        var where = _.where(payload.title.data, {
                            parent_id: 0
                        });
                        vm.branchList = _.where(where, {
                            is_active: 1
                        });
                        var actualBranchGot = '';
                        for (var i = 0; i < vm.branchList.length; i++) {
                            if (vm.dataToFill.branch == vm.branchList[i].region_id) {
                                actualBranchGot = vm.branchList[i].region_id;
                                break;
                            } else {
                                actualBranchGot = '';
                            }
                        }
                        vm.dataToFill.branch = Number(actualBranchGot);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        getBranch();
        //==================file upload function========================
        vm.uploadName = '';

        function clickTrigger($event, type, index) {
            $log.log('ddf');
            $event.stopPropagation();
            vm.uploadName = type;
            if (index != null || index != '' || index != undefined) {
                vm.indexGot = index;
            }
            var element = document.getElementById('documentUpload');
            element.click();
        };


        //===============file for customer edit=============
        $scope.file_to_upload = function (File, type) {
            $log.log(type);
            var file = File[0];
            var transcript = File[0];
            var reader = new FileReader;
            reader.onload = function (e) {
                //    var img = new Image;
                //    img.onload = function () {
                if (type == 'PROFILE') {
                    document.getElementById('profilePic').setAttribute('src', e.target.result);
                    vm.dataToFill.fleet_img = File[0];
                    // } else if (type == 'INVOICE') {
                    //     document.getElementById('invoice').setAttribute('src', e.target.result);
                    //     vm.dataToFill.invoice_stamping = File[0];
                    // } else if (type == 'ACTIVITY') {
                    //     document.getElementById('activity').setAttribute('src', e.target.result);
                    //     vm.dataToFill.start_activities = File[0];
                } else if (type == 'INVOICE_RUT') {
                    document.getElementById('invoiceRUT').setAttribute('src', e.target.result);
                    vm.dataToFill.invoice_rut_image = File[0];
                    // } else if (type == 'CONSTITUTION') {
                    //     document.getElementById('constitution').setAttribute('src', e.target.result);
                    //     vm.dataToFill.company_constitution = File[0];
                    // } else if (type == 'COMPANY_IDENTITY_CARD') {
                    //     document.getElementById('companyIdentity').setAttribute('src', e.target.result);
                    //     vm.dataToFill.company_identity_card = File[0];
                } else if (type == 'ANTECENTS') {
                    document.getElementById('antecents').setAttribute('src', e.target.result);
                    vm.dataToFill.antecents_certificate = File[0];
                } else if (type == 'LIFE_SHEET') {
                    document.getElementById('lifeSheet').setAttribute('src', e.target.result);
                    vm.dataToFill.life_sheet_img = File[0];
                } else if (type == 'LICENSE') {
                    document.getElementById('licenseImage').setAttribute('src', e.target.result);
                    vm.dataToFill.license_img = File[0];
                } else if (type == 'RUT') {
                    document.getElementById('rutImage').setAttribute('src', e.target.result);
                    vm.dataToFill.RUT_img = File[0];
                } else if (type == 'CAR_IMAGE') {
                    $log.log(vm.indexGot);
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'carImage' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.carDetails[vm.indexGot].car_image_upload = File[0];
                    }
                } else if (type == 'REGISTER_IMAGE') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'registerImage' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.carDetails[vm.indexGot].registration_image_upload = File[0];
                    }
                } else if (type == 'ADD_CAR_IMAGE') {
                    $log.log(vm.indexGot);
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'addCarImage' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.dataToFill.addNewCar[vm.indexGot].car_image_upload = File[0];
                    }
                } else if (type == 'ADD_REGISTER_IMAGE') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'addRegisterImage' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.dataToFill.addNewCar[vm.indexGot].registration_image_upload = File[0];
                    }
                } else if (type == 'PASSENGER_INSURANCE_KEY') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'seatInsurance' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.carDetails[vm.indexGot].passenger_insurance_key_upload = File[0];
                    }
                } else if (type == 'TRAVEL_CARD_KEY') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'travel' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.carDetails[vm.indexGot].travel_card_key_upload = File[0];
                    }
                } else if (type == 'PERMISSION_OF_CIRCULATION') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'permission' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.carDetails[vm.indexGot].permission_of_circulation_upload = File[0];
                    }
                } else if (type == 'TRANSPORTATION_PERMIT') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'transportation_permit' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.carDetails[vm.indexGot].transportation_permit_upload = File[0];
                    }
                } else if (type == 'ADD_PASSENGER_INSURANCE_KEY') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'addSeatInsurance' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.dataToFill.addNewCar[vm.indexGot].passenger_insurance_key_upload = File[0];
                    }
                } else if (type == 'ADD_TRAVEL_CARD_KEY') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'addTravel' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.dataToFill.addNewCar[vm.indexGot].travel_card_key_upload = File[0];
                    }
                } else if (type == 'ADD_PERMISSION_OF_CIRCULATION') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'addPermission' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.dataToFill.addNewCar[vm.indexGot].permission_of_circulation_upload = File[0];
                    }
                } else if (type == 'ADD_TRANSPORTATION_PERMIT') {
                    if (vm.indexGot != null || vm.indexGot != '' || vm.indexGot != undefined) {
                        var id = 'addTransportationPermit' + vm.indexGot;
                        document.getElementById(id).setAttribute('src', e.target.result);
                        vm.dataToFill.addNewCar[vm.indexGot].transportation_permit_upload = File[0];
                    }
                }
                //};

                //    img.src = reader.result;
            };
            reader.readAsDataURL(transcript);
            $log.log(vm.dataToFill);
            $log.log(vm.carDetails);
        };
        //=======================submit basic form===============================
        function editBasicApi() {
            $log.log(vm.dataToFill);
            $log.log(vm.driverDetails);
            if (vm.dataToFill.fleet_type != '2') {
                //if((vm.dataToFill.fleet_img == undefined || vm.dataToFill.fleet_img == null || vm.dataToFill.fleet_img == '') && (vm.driverDetails.fleet_image == undefined || vm.driverDetails.fleet_image == null || vm.driverDetails.fleet_image == '')){
                //    errorMessageFactory.showErrorMessage('Please upload profile pic.');
                //    return;
                //}
                // if ((vm.dataToFill.RUT_img == undefined || vm.dataToFill.RUT_img == null || vm.dataToFill.RUT_img == '') && (vm.driverDetails.RUT_image == undefined || vm.driverDetails.RUT_image == null || vm.driverDetails.RUT_image == '')) {
                //     //errorMessageFactory.showErrorMessage('Please upload RUT image.');
                //     languageBasedErrorFactory.getProperErrorMessage('uploadRUTImage', 0, 0);
                //     return;
                // }
                if ((vm.dataToFill.license_img == undefined || vm.dataToFill.license_img == null || vm.dataToFill.license_img == '') && (vm.driverDetails.license_img == undefined || vm.driverDetails.license_img == null || vm.driverDetails.license_img == '')) {
                    //errorMessageFactory.showErrorMessage('Please upload license image.');
                    languageBasedErrorFactory.getProperErrorMessage('uploadLicenseImage', 0, 0);
                    return;
                }
                if ((vm.dataToFill.life_sheet_img == undefined || vm.dataToFill.life_sheet_img == null || vm.dataToFill.life_sheet_img == '') && (vm.driverDetails.life_sheet_img == undefined || vm.driverDetails.life_sheet_img == null || vm.driverDetails.life_sheet_img == '')) {
                    //errorMessageFactory.showErrorMessage('Please upload life sheet image.');
                    languageBasedErrorFactory.getProperErrorMessage('uploadLifeSheetImage', 0, 0);
                    return;
                }
                if ((vm.dataToFill.antecents_certificate == undefined || vm.dataToFill.antecents_certificate == null || vm.dataToFill.antecents_certificate == '') && (vm.driverDetails.antecents_certificate == undefined || vm.driverDetails.antecents_certificate == null || vm.driverDetails.antecents_certificate == '')) {
                    //errorMessageFactory.showErrorMessage('Please upload antecedents certificate.');
                    languageBasedErrorFactory.getProperErrorMessage('uploadAntecedentImage', 0, 0);
                    return;
                }
                // if ((vm.dataToFill.company_identity_card == undefined || vm.dataToFill.company_identity_card == null || vm.dataToFill.company_identity_card == '') && (vm.driverDetails.company_identity_card == undefined || vm.driverDetails.company_identity_card == null || vm.driverDetails.company_identity_card == '')) {
                //     errorMessageFactory.showErrorMessage('Please upload company identity card.');
                //     return;
                // }
                // if ((vm.dataToFill.company_constitution == undefined || vm.dataToFill.company_constitution == null || vm.dataToFill.company_constitution == '') && (vm.driverDetails.company_constitution == undefined || vm.driverDetails.company_constitution == null || vm.driverDetails.company_constitution == '')) {
                //     errorMessageFactory.showErrorMessage('Please upload company constitution.');
                //     return;
                // }
                // if ((vm.dataToFill.start_activities == undefined || vm.dataToFill.start_activities == null || vm.dataToFill.start_activities == '') && (vm.driverDetails.start_activities == undefined || vm.driverDetails.start_activities == null || vm.driverDetails.start_activities == '')) {
                //     errorMessageFactory.showErrorMessage('Please upload start activities.');
                //     return;
                // }
                // if ((vm.dataToFill.invoice_stamping == undefined || vm.dataToFill.invoice_stamping == null || vm.dataToFill.invoice_stamping == '') && (vm.driverDetails.invoice_stamping == undefined || vm.driverDetails.invoice_stamping == null || vm.driverDetails.invoice_stamping == '')) {
                //     errorMessageFactory.showErrorMessage('Please upload invoice stamping.');
                //     return;
                // }
            }
            if (vm.dataToFill.fleet_type == '2') {
                //if((vm.dataToFill.fleet_img == undefined || vm.dataToFill.fleet_img == null || vm.dataToFill.fleet_img == '') && (vm.driverDetails.fleet_image == undefined || vm.driverDetails.fleet_image == null || vm.driverDetails.fleet_image == '')){
                //    errorMessageFactory.showErrorMessage('Please upload profile pic.');
                //    return;
                //}
                // if ((vm.dataToFill.company_identity_card == undefined || vm.dataToFill.company_identity_card == null || vm.dataToFill.company_identity_card == '') && (vm.driverDetails.company_identity_card == undefined || vm.driverDetails.company_identity_card == null || vm.driverDetails.company_identity_card == '')) {
                //     errorMessageFactory.showErrorMessage('Please upload company identity card.');
                //     return;
                // }
                // if ((vm.dataToFill.company_constitution == undefined || vm.dataToFill.company_constitution == null || vm.dataToFill.company_constitution == '') && (vm.driverDetails.company_constitution == undefined || vm.driverDetails.company_constitution == null || vm.driverDetails.company_constitution == '')) {
                //     errorMessageFactory.showErrorMessage('Please upload company constitution.');
                //     return;
                // }
                // if ((vm.dataToFill.start_activities == undefined || vm.dataToFill.start_activities == null || vm.dataToFill.start_activities == '') && (vm.driverDetails.start_activities == undefined || vm.driverDetails.start_activities == null || vm.driverDetails.start_activities == '')) {
                //     errorMessageFactory.showErrorMessage('Please upload start activities.');
                //     return;
                // }
                // if ((vm.dataToFill.invoice_stamping == undefined || vm.dataToFill.invoice_stamping == null || vm.dataToFill.invoice_stamping == '') && (vm.driverDetails.invoice_stamping == undefined || vm.driverDetails.invoice_stamping == null || vm.driverDetails.invoice_stamping == '')) {
                //     errorMessageFactory.showErrorMessage('Please upload invoice stamping.');
                //     return;
                // }
            }
            var dataSend = new FormData();
            dataSend.append('access_token', $cookies.get('obj'));
            dataSend.append('fleet_id', Number($stateParams.id));
            dataSend.append('fleet_type', Number(vm.dataToFill.fleet_type));
            dataSend.append('first_name', vm.dataToFill.first_name);
            dataSend.append('last_name', vm.dataToFill.last_name);
            dataSend.append('email', vm.dataToFill.email);
            dataSend.append('country_code', vm.dataToFill.country_code);
            dataSend.append('phone_number', vm.dataToFill.phone_number);
            dataSend.append('username', vm.dataToFill.username);
            // dataSend.append('company_type', vm.dataToFill.company_type);
            dataSend.append('street', vm.dataToFill.street);
            //dataSend.append('sector', vm.dataToFill.sector);
            //dataSend.append('region', vm.dataToFill.region);

            if (vm.dataToFill.fleet_type != '1') {
                if (vm.dataToFill.invoice_rut)
                    dataSend.append('invoice_rut', RutHelper.clean(vm.dataToFill.invoice_rut));
                if (vm.dataToFill.business_name)
                    dataSend.append('business_name', vm.dataToFill.business_name);
                if (vm.dataToFill.payment_modulity)
                    dataSend.append('payment_modulity', vm.dataToFill.payment_modulity);
                if (vm.dataToFill.account_type)
                    dataSend.append('account_type', vm.dataToFill.account_type);
                if (vm.dataToFill.account_rut)
                    dataSend.append('account_rut', vm.dataToFill.account_rut)
                if (vm.dataToFill.account_number)
                    dataSend.append('account_number', vm.dataToFill.account_number);
                if (vm.dataToFill.bank_name)
                    dataSend.append('bank_name', vm.dataToFill.bank_name);
            }
            if (vm.dataToFill.number) {
                dataSend.append('number', vm.dataToFill.number);
            }
            if (vm.dataToFill.apartment) {
                dataSend.append('apartment', vm.dataToFill.apartment);
            }
            if (vm.dataToFill.invoice_rut_image) {
                dataSend.append('invoice_rut_image', vm.dataToFill.invoice_rut_image);
            }
            // TV_2680
            // if (vm.dataToFill.fleet_type == '0') {
            //     //if (vm.dataToFill.work_schedule == 'null' || vm.dataToFill.work_schedule == null || vm.dataToFill.work_schedule != undefined || vm.dataToFill.work_schedule != 'undefined') {
            //     //    alert(vm.dataToFill.work_schedule);
            //     //    dataSend.append('work_schedule', '');
            //     //} else {
            //     dataSend.append('work_schedule', Number(vm.dataToFill.work_schedule));
            //     //}
            // }
            if (vm.dataToFill.fleet_type != '2') {
                dataSend.append('RUT', RutHelper.clean(vm.dataToFill.RUT));
                dataSend.append('license_type', vm.dataToFill.license_type);
                if (vm.dataToFill.license_expiry_date)
                    dataSend.append('license_expiry_date', moment(vm.dataToFill.license_expiry_date).format('YYYY-MM-DD'));
            }
            dataSend.append('branch', Number(vm.dataToFill.branch));
            // dataSend.append('fleet_route', Number(vm.dataToFill.fleet_route));
            if (vm.dataToFill.fleet_img) {
                dataSend.append('fleet_img', vm.dataToFill.fleet_img);
            }
            if (vm.dataToFill.fleet_type != '2') {
                if (vm.dataToFill.RUT_img) {
                    dataSend.append('RUT_img', vm.dataToFill.RUT_img);
                }
                if (vm.dataToFill.license_img) {
                    dataSend.append('license_img', vm.dataToFill.license_img);
                }
                if (vm.dataToFill.life_sheet_img) {
                    dataSend.append('life_sheet_img', vm.dataToFill.life_sheet_img);
                }
                if (vm.dataToFill.antecents_certificate) {
                    dataSend.append('antecents_certificate', vm.dataToFill.antecents_certificate);
                }
                // if (vm.dataToFill.company_identity_card) {
                //     dataSend.append('company_identity_card', vm.dataToFill.company_identity_card);
                // }
                // if (vm.dataToFill.company_constitution) {
                //     dataSend.append('company_constitution', vm.dataToFill.company_constitution);
                // }
                // if (vm.dataToFill.start_activities) {
                //     dataSend.append('start_activities', vm.dataToFill.start_activities);
                // }
                // if (vm.dataToFill.invoice_stamping) {
                //     dataSend.append('invoice_stamping', vm.dataToFill.invoice_stamping);
                // }
            }
            if (vm.dataToFill.fleet_type == '2') {
                // if (vm.dataToFill.company_identity_card) {
                //     dataSend.append('company_identity_card', vm.dataToFill.company_identity_card);
                // }
                // if (vm.dataToFill.company_constitution) {
                //     dataSend.append('company_constitution', vm.dataToFill.company_constitution);
                // }
                // if (vm.dataToFill.start_activities) {
                //     dataSend.append('start_activities', vm.dataToFill.start_activities);
                // }
                // if (vm.dataToFill.invoice_stamping) {
                //     dataSend.append('invoice_stamping', vm.dataToFill.invoice_stamping);
                // }
            }

            vm.loading = true;
            var promise = getDrivers.editDriver(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        var dataForSysLogs = {
                            access_token: $cookies.get('obj'),
                            id: $stateParams.id,
                            identity: 0, // 0- driver, 1- customer , 2 -car
                            message: 'Applicant profile updated.'
                        };
                        $rootScope.systemLogsAdmin(dataForSysLogs);
                        languageBasedErrorFactory.getProperErrorMessage('applicantEditSuccess', 0, 1, 'layout.applicantsMain.editApplicantsDetails');
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    //errorMessageFactory.showErrorMessage('Applicant profile updated successfully.', 1);
                    //$timeout(function() {
                    //    $mdDialog.hide();
                    //    $state.reload();
                    //}, 2000);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //=============================edit car details==============================
        function editCarApi(index, data) {
            $log.log(index);
            $log.log(data);
            ///////// TIKCET 2807 ///////////////////////////
            // if ((data.car_image_upload == undefined || data.car_image_upload == null || data.car_image_upload == '') && (data.car_photo == undefined || data.car_photo == null || data.car_photo == '')) {
            //     //errorMessageFactory.showErrorMessage('Please upload car image.');
            //     languageBasedErrorFactory.getProperErrorMessage('carImageCheck', 0, 0);
            //     return;
            // }
            // if ((data.registration_image_upload == undefined || data.registration_image_upload == null || data.registration_image_upload == '') && (data.registration_image == undefined || data.registration_image == null || data.registration_image == '')) {
            //     //errorMessageFactory.showErrorMessage('Please upload car registration image.');
            //     languageBasedErrorFactory.getProperErrorMessage('carRegistrationImage', 0, 0);
            //     return;
            // }
            // if ((data.passenger_insurance_key_upload == undefined || data.passenger_insurance_key_upload == null || data.passenger_insurance_key_upload == '') && (data.passenger_insurance_key == undefined || data.passenger_insurance_key == null || data.passenger_insurance_key == '')) {
            //     //errorMessageFactory.showErrorMessage('Please upload passenger seat insurance.');
            //     languageBasedErrorFactory.getProperErrorMessage('carPassengerImage', 0, 0);
            //     return;
            // }
            // if ((data.travel_card_key_upload == undefined || data.travel_card_key_upload == null || data.travel_card_key_upload == '') && (data.travel_card_key == undefined || data.travel_card_key == null || data.travel_card_key == '')) {
            //     //errorMessageFactory.showErrorMessage('Please upload travel card key.');
            //     languageBasedErrorFactory.getProperErrorMessage('carTravelKeyImage', 0, 0);
            //     return;
            // }
            if ((data.permission_of_circulation_upload == undefined || data.permission_of_circulation_upload == null || data.permission_of_circulation_upload == '') && (data.permission_of_circulation == undefined || data.permission_of_circulation == null || data.permission_of_circulation == '')) {
                //errorMessageFactory.showErrorMessage('Please upload permission of circulation.');
                languageBasedErrorFactory.getProperErrorMessage('carCirculationImage', 0, 0);
                return;
            }
            // if ((data.transportation_permit_upload == undefined || data.transportation_permit_upload == null || data.transportation_permit_upload == '') && (data.transportation_permit == undefined || data.transportation_permit == null || data.transportation_permit == '')) {
            //     //errorMessageFactory.showErrorMessage('Please upload permission of circulation.');
            //     languageBasedErrorFactory.getProperErrorMessage('transportationPermit', 0, 0);
            //     return;
            // }


            var dataSendCar = new FormData();
            dataSendCar.append('access_token', $cookies.get('obj'));
            dataSendCar.append('fleet_id', $stateParams.id);
            dataSendCar.append('car_id', data.id);
            dataSendCar.append('registration_number', data.registration_number.replace(/ /g, '').toUpperCase());
            dataSendCar.append('car_type', Number(data.car_type));
            dataSendCar.append('modelity', Number(data.modelity));
            dataSendCar.append('working_status', Number(data.working_status));
            dataSendCar.append('verification_comment', (data.verification_comment));

            // if (data.car_image_upload) {
            //     dataSendCar.append('car_photo', data.car_image_upload);
            // }
            // if (data.registration_image_upload) {
            //     dataSendCar.append('registration_image', data.registration_image_upload);
            // }
            // if (data.passenger_insurance_key_upload) {
            //     dataSendCar.append('passenger_insurance_key', data.passenger_insurance_key_upload);
            // }
            // if (data.travel_card_key_upload) {
            //     dataSendCar.append('travel_card_key', data.travel_card_key_upload);
            // }
            if (data.permission_of_circulation_upload) {
                dataSendCar.append('permission_of_circulation', data.permission_of_circulation_upload);
            }
            if (data.transportation_permit_upload) {
                dataSendCar.append('transportation_permit', data.transportation_permit_upload);
            }
            if (data.society_id) {
                dataSendCar.append('society_id', Number(data.society_id));
            }
            vm.loading = true;
            var promise = getCars.editCarDetails(dataSendCar);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    var dataForSysLogs = {
                        access_token: $cookies.get('obj'),
                        id: data.id,
                        identity: 0, // 0- driver, 1- customer , 2 -car
                        message: 'Applicant car details updated.'
                    };
                    $rootScope.systemLogsAdmin(dataForSysLogs);
                    languageBasedErrorFactory.getProperErrorMessage('carDetailsUpdated', 0, 1, 'layout.applicantsMain.editApplicantsDetails');
                    //errorMessageFactory.showErrorMessage('Car details updated successfully.', 1);
                    //$timeout(function() {
                    //    $mdDialog.hide();
                    //    $state.reload();
                    //}, 2000);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message);
                    }
                }
            );
        };
        //===================add vehicles======================
        function addVehicle(index) {
            $log.log(index);
            vm.dataToFill.addNewCar.push({
                car_type: '',
                registration_image_upload: '',
                car_image_upload: '',
                registration_number: '',
                modelity: '',
                verification_comment: ' ',
                travel_card_key_upload: '',
                passenger_insurance_key_upload: '',
                permission_of_circulation_upload: '',
                transportation_permit_upload: ''
            });
        };

        function deleteVehicleType(index) {
            $log.log(index);
            vm.dataToFill.addNewCar.splice(index, 1);
        };
        //======================get all vehicles==============
        function getAllVehicles(skip, limt, filter) {
            vm.loading = true;
            var promise = getVehicles.allVehicles(skip, limt, filter);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    //vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.vehicle = [];
                        angular.forEach(payload.title.data.result, function (column) {
                            if (column.status == 1)
                                vm.vehicle.push({
                                    id: column.id,
                                    name: column.name
                                });
                        });
                        for (var i = 0; i < vm.carDetails.length; i++) {
                            for (var j = 0; j < vm.vehicle.length; j++) {
                                if (vm.vehicle[j].name == vm.carDetails[i].carName) {
                                    vm.carDetails[i].car_type = vm.vehicle[j].id;
                                    break;
                                } else {
                                    vm.carDetails[i].car_type = '';
                                }
                            }
                        }
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //getAllVehicles(0, 0, 2);
        //====================add new cars api ================================
        function addCarApi() {
            $log.log(vm.dataToFill);
            for (var i = 0; i < vm.dataToFill.addNewCar.length; i++) {
                // TICKET 2807
                // if (vm.dataToFill.addNewCar[i].car_image_upload == undefined || vm.dataToFill.addNewCar[i].car_image_upload == null || vm.dataToFill.addNewCar[i].car_image_upload == '') {
                //     //errorMessageFactory.showErrorMessage('Please upload car image.');
                //     languageBasedErrorFactory.getProperErrorMessage('carImageCheck', 0, 0);
                //     return;
                // }
                // if (vm.dataToFill.addNewCar[i].registration_image_upload == undefined || vm.dataToFill.addNewCar[i].registration_image_upload == null || vm.dataToFill.addNewCar[i].registration_image_upload == '') {
                //     //errorMessageFactory.showErrorMessage('Please upload car registration image.');
                //     languageBasedErrorFactory.getProperErrorMessage('carRegistrationImage', 0, 0);
                //     return;
                // }
                // if (vm.dataToFill.addNewCar[i].passenger_insurance_key_upload == undefined || vm.dataToFill.addNewCar[i].passenger_insurance_key_upload == null || vm.dataToFill.addNewCar[i].passenger_insurance_key_upload == '') {
                //     //errorMessageFactory.showErrorMessage('Please upload car image.');
                //     languageBasedErrorFactory.getProperErrorMessage('carPassengerImage', 0, 0);
                //     return;
                // }
                // if (vm.dataToFill.addNewCar[i].travel_card_key_upload == undefined || vm.dataToFill.addNewCar[i].travel_card_key_upload == null || vm.dataToFill.addNewCar[i].travel_card_key_upload == '') {
                //     //errorMessageFactory.showErrorMessage('Please upload car registration image.');
                //     languageBasedErrorFactory.getProperErrorMessage('carTravelKeyImage', 0, 0);
                //     return;
                // }
                if (vm.dataToFill.addNewCar[i].permission_of_circulation_upload == undefined || vm.dataToFill.addNewCar[i].permission_of_circulation_upload == null || vm.dataToFill.addNewCar[i].permission_of_circulation_upload == '') {
                    //errorMessageFactory.showErrorMessage('Please upload car registration image.');
                    languageBasedErrorFactory.getProperErrorMessage('carCirculationImage', 0, 0);
                    return;
                }
                // if (vm.dataToFill.addNewCar[i].transportation_permit_upload == undefined || vm.dataToFill.addNewCar[i].transportation_permit_upload == null || vm.dataToFill.addNewCar[i].transportation_permit_upload == '') {
                //     //errorMessageFactory.showErrorMessage('Please upload car registration image.');
                //     languageBasedErrorFactory.getProperErrorMessage('transportationPermit', 0, 0);
                //     return;
                // }
            }

            var carArray = [];
            var dataSend = new FormData();
            dataSend.append('fleet_id', $stateParams.id);
            dataSend.append('access_token', $cookies.get('obj'));
            for (var i = 0; i < vm.dataToFill.addNewCar.length; i++) {
                carArray.push({
                    car_type: Number(vm.dataToFill.addNewCar[i].car_type),
                    modelity: Number(vm.dataToFill.addNewCar[i].modelity),
                    verification_comment:  (vm.dataToFill.car_details[i].verification_comment),
                    registration_number: vm.dataToFill.addNewCar[i].registration_number.replace(/ /g, '').toUpperCase()
                });
                if (vm.dataToFill.addNewCar[i].car_image_upload) {
                    dataSend.append('car_photo[]', vm.dataToFill.addNewCar[i].car_image_upload);

                }
                if (vm.dataToFill.addNewCar[i].registration_image_upload) {
                    dataSend.append('registration_image[]', vm.dataToFill.addNewCar[i].registration_image_upload);
                }
                if (vm.dataToFill.addNewCar[i].passenger_insurance_key_upload) {
                    dataSend.append('passenger_insurance_key[]', vm.dataToFill.addNewCar[i].passenger_insurance_key_upload);
                }
                if (vm.dataToFill.addNewCar[i].travel_card_key_upload) {
                    dataSend.append('travel_card_key[]', vm.dataToFill.addNewCar[i].travel_card_key_upload);
                }
                if (vm.dataToFill.addNewCar[i].permission_of_circulation_upload) {
                    dataSend.append('permission_of_circulation[]', vm.dataToFill.addNewCar[i].permission_of_circulation_upload);
                }
                if (vm.dataToFill.addNewCar[i].transportation_permit_upload) {
                    dataSend.append('transportation_permit[]', vm.dataToFill.addNewCar[i].transportation_permit_upload);
                }
            }
            dataSend.append('car_details', JSON.stringify(carArray));
            vm.loading = true;
            var promise = getCars.addCarDetails(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    //errorMessageFactory.showErrorMessage('Car added successfully.', 1);
                    languageBasedErrorFactory.getProperErrorMessage('carAddedSuccess', 0, 1, 'layout.applicantsMain.editApplicantsDetails');
                    //$timeout(function() {
                    //    $mdDialog.hide();
                    //    $state.reload();
                    //}, 2000);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message);
                    }
                }
            );
        };
        //=================go back================
        function goBack() {
            $state.go('layout.applicantsMain.applicants');
        };
        vm.licenceTypesData = [];

        function licenseTypes() {
            vm.loading = true;
            var promise = getVehicles.getLicenseType();
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    //vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.licenseTypes = [];
                        vm.licenseTypes = payload.title;
                        angular.forEach(vm.licenseTypes.data, function (data) {
                            vm.licenceTypesData.push(data.license_class_type);
                        });
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        licenseTypes();

        // ***** GET DRIVER BACK NAMES *********
        function getDriverBankNames() {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            var promise = getDrivers.driverBankNames(dataSend);
            promise.then(
                function (payload) {
                    vm.loading = false;
                    vm.driverBankNamesArray = payload.title || [];
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }

            );
        }
        getDriverBankNames();

         // ***** GET SOCIETIES *********
         function getAllSocieties() {
            var dataSend = {};
            // dataSend.access_token = $cookies.get('obj');
            vm.loading = true;
            var promise = getDrivers.societiesList();
            promise.then(
                function (payload) {
                    if (payload.title.status == 200) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        vm.societies = payload.title.data;       
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }

                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };
        getAllSocieties();
    }
})();
/**
 * Created by cl-macmini-51 on 4/14/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('ApplicantsController', ApplicantsController);

    /** @ngInject */
    function ApplicantsController($cookies, $state, $log, $rootScope, $timeout, getDrivers, $scope, $mdDialog, filterFilter, getGeofence, languageBasedErrorFactory, $document, errorMessageFactory, pendingRequests, getFilters) {
        var vm = this;
        $log.log('driver');
        vm.loading = false;
        vm.currentPage = 0;
        vm.totalDrivers = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.filterTextTimeout = '';
        vm.getAllDrivers = getAllDrivers;
        vm.getPagesCount = getPagesCount;
        vm.deleteUser = deleteUser;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.init = init;
        //vm.sort = sort;
        vm.getFilter = getFilter;
        vm.branchChanged = branchChanged;
        vm.modelityValueChanged = modelityValueChanged;
        vm.approvalValueChanged = approvalValueChanged;
        vm.applicantTypeChanged = applicantTypeChanged;
        vm.viewOTP = viewOTP;
        vm.refreshData = refreshData;
        vm.paginationNew = paginationNew;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.predicate = 'index';
        vm.reverse = false;
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
        vm.filterData = {
            filter_branch: 0, //0, 1
            filter_modelity: 0, //0, 1
            filter_verification_stage: 0, //0, 1
            driver_type: 0, //0, 1
            branch: 'all',
            driver: 'all',
            modelity: 'all',
            verification_stage: 'all',
            limit: vm.itemsPerPageGot,
            offset: 0,
            search_filter: 0,
            search_value: ''
        };
        vm.paginationChangedForBranch = paginationChangedForBranch;
        vm.branchSearch = branchSearch;
        vm.branchOffset = 0;
        vm.globalLimit = 10;

        vm.globalOffset = vm.globalLimit;
        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'vehicle', 'service', 'agreement', 'corporatesList', 'operation_point'];

        vm.branchList = [];
        vm.branchList.push({
            region_name: 'All',
            region_id: 'all'
        });

        setTimeout(function () {
            document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                // if (vm.branchList && (vm.branchList.length == 0)) {
                vm.searchBranchData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

        })


        // =================== FILTER OBJECT ===================
        vm.filterObject = {
            access_token: $cookies.get('obj'),
            branch_filter: 1,
            vehicle_filter: 0,
            service_filter: 0,
            agreement_filter: 0,
            corporate_filter: 0,
            service_category: 0,
            corporate_status: 0,
            agreement_status: 0,
            vehicle__status: 0,
            operation_point_filter: 0,
            branch_limit: vm.globalLimit,
            branch_offset: vm.branchOffset
        }



        function clearOffset() {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                vm[vm.searchFilterArray[i] + 'Offset'] = 0;
            }

        }


        // =================== GET FILTER DATA ===================
        function getFilterDataFromBackend(data, type) { //Acc to Index ['branch_search', 'vehicle_search', 'service_search', 'agreement_search', 'corporate_search', 'operation_point_search']
            if (data) {
                vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
            } else {
                vm.filterObject = {
                    access_token: $cookies.get('obj'),
                    branch_filter: 1,
                    vehicle_filter: 0,
                    service_filter: 0,
                    agreement_filter: 0,
                    corporate_filter: 0,
                    service_category: 0,
                    corporate_status: 2,
                    agreement_status: 0,
                    vehicle__status: 0,
                    operation_point_filter: 0,
                    branch_search_filter: 0,
                    vehicle_search_filter: 0,
                    service_search_filter: 0,
                    agreement_search_filter: 0,
                    corporate_search_filter: 0,
                    operation_point_search_filter: 0
                }
            }

            vm.filterObject.branch_limit = vm.globalLimit;
            vm.filterObject.branch_offset = vm.branchOffset;

            var promise = getFilters.getAllFilterData(vm.filterObject);
            promise.then(
                function (payload) {

                    // ********** BRANCH DATA ********
                    if (payload.title.data.branches) {
                        var index = _.findIndex(vm.branchList, {
                            region_id: 'all'
                        });
                        if (index == -1)
                            vm.branchList.push({
                                region_name: 'All',
                                region_id: 'all'
                            });
                        angular.forEach(payload.title.data.branches.data, function (column) {
                            var branchIndex = _.findIndex(vm.branchList, {
                                region_id: column.region_id
                            });
                            if (branchIndex == -1)
                                vm.branchList.push(column)
                        });
                        vm.branchTotalBackendCount = payload.title.data.branches.totalCount;
                    }

                    vm.loading = false;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        }
        getFilterDataFromBackend();
        // ************ PAGINATION ON BRANCH **************
        function paginationChangedForBranch() {
            var index = _.findIndex(vm[vm.searchFilterArray[0]], {
                region_id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.branchTotalBackendCount > (vm.branchList.length - index)) {
                commonFunction(0);
                vm.branchOffset += 10;
                getFilterDataFromBackend(vm.searchBranchData, 0);
            }
        }

        // *********** COMMON FUNCTION FOR FILTER PAGINATION AND SEARCHING ***********
        function commonFunction(type, mode) {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                if (mode == 'search' || i != type) {
                    vm[vm.searchFilterArrayForClearArray[i]] = [];
                    // vm[vm.searchFilterArrayForClearArray[i]].push({
                    // region_name: 'All',
                    // region_id: 'all'
                    // });
                    vm[vm.searchFilterArray[i] + 'Offset'] = 0;
                    vm['search' + vm.searchFilterArray[i].substring(0, 1).toUpperCase() + vm.searchFilterArray[i].substring(1) + 'Data'] = '';
                }
            }
        }

        // ************ SEARCH VEHICLE ***************
        function branchSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchBranchData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(0, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 0);
                }, 2000);
            }
        }



        //====================function for dropdown pages and page count===============
        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            if (vm.filterData.filter_branch == 0 && vm.filterData.filter_modelity == 0 && vm.filterData.filter_verification_stage == 0 && vm.filterData.driver_type == 0) {
                getAllDrivers(0, vm.itemsPerPageGot);
            } else {
                getFilterDriverHit(0, vm.itemsPerPageGot, vm.filterData);
            }
        };

        //==================refreshData=====================
        function refreshData() {
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            if (vm.filterData.filter_branch == 0 && vm.filterData.filter_modelity == 0 && vm.filterData.filter_verification_stage == 0 && vm.filterData.driver_type == 0) {
                getAllDrivers(vm.currentPage * vm.itemsPerPageGot, vm.itemsPerPageGot);
            } else {
                getFilterDriverHit(vm.currentPage * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData);
            }
        }


        function paginationNew(page) {
            if (vm.filterData.filter_branch == 0 && vm.filterData.filter_modelity == 0 && vm.filterData.filter_verification_stage == 0 && vm.filterData.driver_type == 0) {
                getAllDrivers((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot);
            } else {
                getFilterDriverHit((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData);
            }
        }


        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.applicantsMain.applicants');
            }
        });

        //==================get all drivers=======================
        function getAllDrivers(skip, limit) {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit;
            dataSend.offset = skip;
            dataSend.driver_status = 0;
            dataSend.driver_type = 2;
            dataSend.search_filter = vm.filterData.search_filter;
            if (vm.filterData.search_filter == 1) {
                dataSend.search_value = vm.filterData.search_value;
            }
            var promise = getDrivers.allDrivers(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.totalDrivers = payload.title.data.totalCount;
                        vm.dataLength = payload.title.data.totalCount;

                        if (payload.title.data.totalCount == 0) {
                            vm.sp_pagination = false;
                            vm.tBodyFlag = false;
                            vm.tFootFlag = true;
                            vm.filterOn = true;
                            vm.skipValueFilter = 0;
                        } else {
                            vm.sp_pagination = true;
                            vm.tBodyFlag = true;
                            vm.tFootFlag = false;
                            vm.filterOn = false;
                            vm.skipValueFilter = 0;
                            var dataArray = [];
                            var driverList = payload.title.data.result;
                            driverList.forEach(function (column) {
                                var d = {};
                                d.name = column.first_name + " " + column.last_name;
                                d.email = column.email;
                                d.fleet_type = column.fleet_type;
                                d.fleet_route = column.fleet_route;
                                // d.work_schedule = column.work_schedule; //TV_2680
                                d.fleet_id = column.fleet_id;
                                d.creation_datetime = column.creation_datetime;
                                d.activation_status = column.activation_status;
                                d.admin_verified = column.admin_verified;
                                d.branch_name = column.branch_name;
                                d.country_code = column.country_code;
                                d.phoneNumber = column.phone;
                                if (column.admin_verified != 1 && column.activation_status == 1 && column.verification_status == 1) {
                                    d.verification_status = 6;
                                } else {
                                    d.verification_status = column.verification_status;
                                }
                                d.phone = column.country_code ? column.country_code + column.phone : column.phone;
                                dataArray.push(d);
                            });
                            vm.driverList = dataArray;

                            for (var i = 0; i < vm.driverList.length; i++) {
                                vm.driverList[i].index = (skip + i);
                            }
                            if (vm.dataLength <= vm.itemsPerPageGot) {
                                vm.sp_pagination = false;
                            } else {
                                vm.sp_pagination = true;
                                //vm.pageCount(payload.title.totalCount);
                            }
                            vm.skipValue = vm.driverList[0].index;
                            vm.limitValue = vm.driverList[vm.driverList.length - 1].index;

                            //$scope.$watch('vm.search', function(newVal, oldVal) {
                            //    vm.filtered = filterFilter(vm.driverList, newVal);
                            //    vm.totalItems = vm.filtered.length;
                            //    if (vm.filtered.length == 0) {
                            //        vm.watchPagination = false;
                            //    } else {
                            //        vm.watchPagination = true;
                            //    }
                            //    if (vm.filterOn == true) {
                            //        vm.skipValueFilter = vm.filtered.length;
                            //        vm.sp_pagination = false;
                            //    }
                            //}, true);

                            //range();
                        }
                    }

                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };
        //=====================to delete driver====================
        function deleteUser(id, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('deleteApplicant', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                vm.loading = true;
                var promise = getDrivers.deleteUser(id);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        var dataForSysLogs = {
                            access_token: $cookies.get('obj'),
                            id: id,
                            identity: 0, // 0- driver, 1- customer , 2 -car
                            message: 'Applicant deleted.'
                        };
                        $rootScope.systemLogsAdmin(dataForSysLogs);
                        languageBasedErrorFactory.getProperErrorMessage('applicantDeletedSuccess', 0, 1, 'layout.applicantsMain.applicants');
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        }
        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    } else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        if(vm.filterData.filter_branch == 0 && vm.filterData.filter_modelity == 0 && vm.filterData.filter_verification_stage == 0 && vm.filterData.driver_type == 0){
        //            vm.getAllDrivers((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected);
        //        }
        //        else{
        //            getFilterDriverHit((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //        }
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        vm.currentPage++;
        //        if(vm.filterData.filter_branch == 0 && vm.filterData.filter_modelity == 0 && vm.filterData.filter_verification_stage == 0 && vm.filterData.driver_type == 0){
        //            vm.getAllDrivers((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected);
        //        }
        //        else{
        //            getFilterDriverHit((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //        }
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if(vm.filterData.filter_branch == 0 && vm.filterData.filter_modelity == 0 && vm.filterData.filter_verification_stage == 0 && vm.filterData.driver_type == 0){
        //        vm.getAllDrivers((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected);
        //    }
        //    else{
        //        getFilterDriverHit((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //    }
        //};

        function init() {
            vm.getAllDrivers(0, vm.searchModel.limit);
        };
        init();

        //function sort(type) {
        //    vm.predicate = type;
        //    vm.reverse = !vm.reverse;
        //};

        function getFilter() {
            //vm.filterOn = true;
            vm.currentPage = 0;
            vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
            vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
            pendingRequests.cancelAll();
            if (vm.search.length == 0) {
                vm.filterData.search_filter = 0;
                vm.filterData.search_value = '';
                if (vm.filterData.filter_branch == 0 && vm.filterData.filter_modelity == 0 && vm.filterData.filter_verification_stage == 0 && vm.filterData.driver_type == 0) {
                    getAllDrivers(0, vm.itemsPerPageGot);
                } else {
                    getFilterDriverHit(0, vm.itemsPerPageGot, vm.filterData);
                }
                //vm.filterOn = false;
                //vm.watchPagination = true;
                //vm.sp_pagination = true;

            } else {
                vm.filterData.search_filter = 1;
                vm.filterData.search_value = vm.search;
                //if (vm.filterTextTimeout) $timeout.cancel(vm.filterTextTimeout);
                if (vm.filterData.filter_branch == 0 && vm.filterData.filter_modelity == 0 && vm.filterData.filter_verification_stage == 0 && vm.filterData.driver_type == 0) {
                    //vm.filterTextTimeout = $timeout(function(){
                    getAllDrivers(0, vm.itemsPerPageGot);
                    //},500);
                } else {
                    //vm.filterTextTimeout = $timeout(function(){
                    getFilterDriverHit(0, vm.itemsPerPageGot, vm.filterData);
                    //},500);
                }
            }
        };

        //====================get branch list====================

        // function getBranch() {
        //     vm.branchList = [];
        //     vm.branchList = JSON.parse(JSON.stringify(getFilters.branchesFiltersData.data));
        //     vm.branchList.push({
        //         region_name: 'All',
        //         region_id: 'all'
        //     });
        //     $scope.$apply();
        // vm.loading = true;
        // var promise = getGeofence.branch();
        // promise.then(
        //     function (payload) {
        //         $log.log(payload);
        //         //vm.loading = false;
        //         if (payload.title.status == 400) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //         } else if (payload.title.status == 401) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //         } else if (payload.title.status == 201 || payload.title.status == 200) {
        //             var where = _.where(payload.title.data, {
        //                 parent_id: 0
        //             });
        //             //vm.branchList = _.where(where, { is_active: 1 });
        //             vm.branchList = where;

        //             vm.branchList.push({
        //                 region_name: 'All',
        //                 region_id: 'all'
        //             });
        //         }
        //     },
        //     function (errorPayload) {
        //         $log.log(errorPayload);
        // vm.loading = false;
        //         if (errorPayload.data.status == 401) {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //         } else {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //         }
        //     }
        // );
        // }
        // WHen Page refresh service take time to get data from backend
        // setTimeout(function () {
        //     getBranch();
        // }, 1000);


        //========================get filter driver hit=======================
        function getFilterDriverHit(skip, limit, data) {
            if (data.filter_branch == 0 && data.filter_modelity == 0 && data.filter_verification_stage == 0 && data.driver_type == 0) {
                vm.getAllDrivers(0, vm.itemsPerPageGot);
                return;
            }
            var dataSend = {};
            dataSend.offset = skip;
            dataSend.limit = limit;
            dataSend.filter_branch = data.filter_branch;
            if (data.filter_branch && data.branch != 'all') {
                dataSend.filter_branch_value = data.branch;
            }
            dataSend.filter_modelity = data.filter_modelity;
            if (data.filter_modelity && data.modelity != 'all') {
                dataSend.filter_modelity_value = Number(data.modelity);
            }
            dataSend.filter_verification_stage = data.filter_verification_stage;
            if (data.filter_verification_stage && data.verification_stage != 'all') {
                dataSend.filter_verification_stage_value = data.verification_stage;
            }
            dataSend.driver_type = data.driver_type;
            dataSend.driver_status = 0;
            if (data.driver_type && data.driver != 'all') {
                dataSend.driver_type_value = data.driver;
            }
            dataSend.search_filter = data.search_filter;
            if (data.search_filter == 1) {
                dataSend.search_value = data.search_value;
            }
            dataSend.access_token = $cookies.get('obj');
            vm.loading = true;
            var promise = getDrivers.applicantFilter(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.totalDrivers = payload.title.data.totalCount;
                        vm.dataLength = payload.title.data.totalCount;

                        if (payload.title.data.totalCount == 0) {
                            vm.sp_pagination = false;
                            vm.tBodyFlag = false;
                            vm.tFootFlag = true;
                            vm.filterOn = true;
                            vm.skipValueFilter = 0;
                        } else {
                            vm.sp_pagination = true;
                            vm.tBodyFlag = true;
                            vm.tFootFlag = false;
                            vm.filterOn = false;
                            vm.skipValueFilter = 0;
                            var dataArray = [];
                            var driverList = payload.title.data.result;
                            driverList.forEach(function (column) {
                                var d = {};
                                d.name = column.first_name + " " + column.last_name;
                                d.email = column.email;
                                d.fleet_type = column.fleet_type;
                                d.fleet_route = column.fleet_route;
                                // d.work_schedule = column.work_schedule; //TV_2680
                                d.fleet_id = column.fleet_id;
                                d.creation_datetime = column.creation_datetime;
                                d.activation_status = column.activation_status;
                                d.admin_verified = column.admin_verified;
                                d.branch_name = column.branch_name;
                                if (column.admin_verified != 1 && column.activation_status == 1 && column.verification_status == 1) {
                                    d.verification_status = 6;
                                } else {
                                    d.verification_status = column.verification_status;
                                }
                                d.phone = column.country_code ? column.country_code + column.phone : column.phone;
                                dataArray.push(d);
                            });
                            vm.driverList = dataArray;

                            for (var i = 0; i < vm.driverList.length; i++) {
                                vm.driverList[i].index = (skip + i);
                            }
                            if (vm.dataLength <= vm.itemsPerPageGot) {
                                vm.sp_pagination = false;
                            } else {
                                vm.sp_pagination = true;
                                //vm.pageCount(payload.title.totalCount);
                            }
                            vm.skipValue = vm.driverList[0].index;
                            vm.limitValue = vm.driverList[vm.driverList.length - 1].index;

                            //$scope.$watch('vm.search', function(newVal, oldVal) {
                            //    vm.filtered = filterFilter(vm.driverList, newVal);
                            //    vm.totalItems = vm.filtered.length;
                            //    if (vm.filtered.length == 0) {
                            //        vm.watchPagination = false;
                            //    } else {
                            //        vm.watchPagination = true;
                            //    }
                            //    if (vm.filterOn == true) {
                            //        vm.skipValueFilter = vm.filtered.length;
                            //        vm.sp_pagination = false;
                            //    }
                            //}, true);

                            //range();
                        }
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };

        //==================filter change functions===================
        function branchChanged() {
            vm.currentPage = 0;
            if (vm.filterData.branch && vm.filterData.branch != 'all') {
                vm.filterData.filter_branch = 1;
                getFilterDriverHit(0, vm.itemsPerPageGot, vm.filterData);
                vm.agreement = [];
                vm.branchList = [];
                vm.vehicle = [];
                vm.service = [];
                clearOffset();
                getFilterDataFromBackend();
            } else {
                vm.filterData.filter_branch = 0;
                vm.filterData.branch = 'all';
                getFilterDriverHit(0, vm.itemsPerPageGot, vm.filterData);
                vm.agreement = [];
                vm.branchList = [];
                vm.vehicle = [];
                clearOffset();
                vm.service = [];
                getFilterDataFromBackend();
            }
        };

        function modelityValueChanged() {
            // vm.currentPage = 0;
            // if (vm.filterData.modelity && vm.filterData.modelity != 'all') {
            //     vm.filterData.filter_modelity = 1;
            //     getFilterDriverHit(0, vm.itemsPerPageGot, vm.filterData);
            // } else {
            //     vm.filterData.filter_modelity = 0;
            //     vm.filterData.modelity = 'all';
            //     getFilterDriverHit(0, vm.itemsPerPageGot, vm.filterData);
            // }
        };

        function approvalValueChanged() {
            vm.currentPage = 0;
            if (vm.filterData.verification_stage && vm.filterData.verification_stage != 'all') {
                vm.filterData.filter_verification_stage = 1;
                getFilterDriverHit(0, vm.itemsPerPageGot, vm.filterData);
            } else {
                vm.filterData.filter_verification_stage = 0;
                vm.filterData.verification_stage = 'all';
                getFilterDriverHit(0, vm.itemsPerPageGot, vm.filterData);
            }
        };

        function applicantTypeChanged() {
            vm.currentPage = 0;
            if (vm.filterData.driver && vm.filterData.driver != 'all') {
                vm.filterData.driver_type = 1;
                getFilterDriverHit(0, vm.itemsPerPageGot, vm.filterData);
            } else {
                vm.filterData.driver_type = 0;
                vm.filterData.driver = 'all';
                getFilterDriverHit(0, vm.itemsPerPageGot, vm.filterData);
            }
        };

        //======================view last generated otp====================
        function viewOTP(data, $event) {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.phone_number = data.phoneNumber;
            dataSend.country_code = data.country_code;
            var promise = getDrivers.viewOTP(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    var dataForSysLogs = {
                        access_token: $cookies.get('obj'),
                        id: data.fleet_id,
                        identity: 0, // 0- driver, 1- customer , 2 -car
                        message: 'OTP Viewed'
                    };
                    $rootScope.systemLogsAdmin(dataForSysLogs);
                    viewOTPPop(payload.title.data, $event);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function viewOTPPop(data, $event) {
            vm.items = {
                otp: data
            };

            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/lastGeneratedOTP.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: LastOTPViewController
            });

            function LastOTPViewController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
            }
        }

        //=====================side bar filter====================
        vm.showFilterArea = showFilterArea;
        vm.branchChangedFilter = branchChangedFilter;
        vm.removeFilter = removeFilter;
        vm.modelityChangedFilter = modelityChangedFilter;
        vm.approvalChangedFilter = approvalChangedFilter;
        vm.applicantChangedFilter = applicantChangedFilter;
        vm.showFilterFlag = false;
        vm.filterWhichToShow = {
            branchWithDashboard: false,
            service: false,
            vehicle: false,
            agreement: false,
            operation: false,
            helpTraffic: false,
            virtualFleet: false,
            vehicleAssigned: false,
            tripType: false,
            approvalStage: true,
            applicantType: true,
            modelity: true
        };

        function removeFilter() {
            $state.reload('layout.applicantsMain.applicants');
        }

        function showFilterArea() {
            vm.showFilterFlag = !vm.showFilterFlag;
        }

        function branchChangedFilter(data) {
            vm.branchChanged();
            getFilterDataFromBackend();
        }

        function modelityChangedFilter(data) {
            vm.modelityValueChanged();
        }

        function approvalChangedFilter(data) {
            vm.approvalValueChanged();
        }

        function applicantChangedFilter(data) {
            vm.applicantTypeChanged();
        }


    }
})();
/**
 * Created by cl-macmini-51 on 5/30/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('ApplicantDetailsController', ApplicantDetailsController);

    /** @ngInject */
    function ApplicantDetailsController($cookies, $state, $log, $rootScope, $timeout, $stateParams, getDrivers, $mdDialog, $document,RutHelper,$scope,languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.loading = true;
        vm.getDriver = getDriver;
        vm.goBack = goBack;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        $log.log($stateParams);

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.applicantsMain.applicantsDetails');
            }
        });

        //=================get driver details================
        function getDriver(id) {
            vm.loading = true;
            var promise = getDrivers.singleDriver(id);

            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    vm.driverDetail = payload.title.data.driver_detail;
                    vm.driverDetail.RUT = RutHelper.format(vm.driverDetail.RUT);
                    vm.driverDetail.invoice_rut = RutHelper.format(vm.driverDetail.invoice_rut);
                    vm.driverDetail.account_rut = RutHelper.format(vm.driverDetail.account_rut);
                    if(payload.title.status=200){
                        if(vm.driverDetail.apartment){
                            if(vm.driverDetail.number){
                                vm.driverDetail.addressFormed = vm.driverDetail.street + ', ' + vm.driverDetail.number + ', ' + vm.driverDetail.apartment;
                            }
                            else{
                                vm.driverDetail.addressFormed = vm.driverDetail.street + ', ' + vm.driverDetail.apartment;
                            }
                        }
                        else{
                            if(vm.driverDetail.number){
                                vm.driverDetail.addressFormed = vm.driverDetail.street + ', ' + vm.driverDetail.number;
                            }
                            else{
                                vm.driverDetail.addressFormed = vm.driverDetail.street;
                            }
                        }
                    }else{
                        errorMessageFactory.showErrorMessage(payload.title.message,0);
                    }
                  
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        }
        getDriver($stateParams.id);
        //=================go back================
        function goBack() {
            $state.go('layout.applicantsMain.applicants');
        };
    }
})();
/**
 * Created by cl-macmini-51 on 5/30/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('ApplicantApprovalProcessController', ApplicantApprovalProcessController);

    /** @ngInject */
    function ApplicantApprovalProcessController($cookies, $state, $log, $rootScope, $timeout, $stateParams, getDrivers, $mdDialog, $document, RutHelper, $scope, languageBasedErrorFactory, errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.getDriver = getDriver;
        vm.goBack = goBack;
        vm.showEditDocumentDialog = showEditDocumentDialog;
        vm.approveDisapproveSteps = approveDisapproveSteps;
        vm.approveDocument = approveDocument;
        vm.editDocumentHit = editDocumentHit;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.editDocument = {};
        vm.background = true;
        vm.fleet_id = $stateParams.id;
        $log.log($stateParams);

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.applicantsMain.applicantsApproval');
            }
        });

        //=================get driver details================
        function getDriver(id) {
            vm.loading = true;
            var promise = getDrivers.singleDriver(id);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    vm.driverDetail = payload.title.data.driver_detail;
                    vm.carDetail = [];
                    if (payload.title.data.driver_detail)
                        vm.carDetail = payload.title.data.driver_detail.car_details || [];

                    vm.driverDetail.RUT = RutHelper.format(vm.driverDetail.RUT);
                    vm.driverDetail.invoice_rut = RutHelper.format(vm.driverDetail.invoice_rut);
                    vm.driverDetail.account_rut = RutHelper.format(vm.driverDetail.account_rut);

                    if (vm.driverDetail.apartment) {
                        if (vm.driverDetail.number) {
                            vm.driverDetail.addressFormed = vm.driverDetail.street + ', ' + vm.driverDetail.number + ', ' + vm.driverDetail.apartment;
                        } else {
                            vm.driverDetail.addressFormed = vm.driverDetail.street + ', ' + vm.driverDetail.apartment;
                        }
                    } else {
                        if (vm.driverDetail.number) {
                            vm.driverDetail.addressFormed = vm.driverDetail.street + ', ' + vm.driverDetail.number;
                        } else {
                            vm.driverDetail.addressFormed = vm.driverDetail.street;
                        }
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        getDriver($stateParams.id);

        //=================approve driver steps========================
        function approveDisapproveSteps(approveFlag, stepType, $event, comments) {

            var commentsSend = comments ? comments : '';

            var msg = '';
            switch (stepType) {
                case 'BASIC':
                    if (approveFlag == 1) {
                        msg = languageBasedErrorFactory.getProperErrorMessage('basicApprov', 0, '3');
                        //msg = '¿Quiere aprobar la etapa de registro básico?';
                        var msgSys = 'Basic registration approved';
                    } else {
                        msg = languageBasedErrorFactory.getProperErrorMessage('basicUnapprov', 0, '3');
                        //msg = '¿Quiere rechazar la Postulacion?';
                        var msgSys = 'Basic registration disapproved';
                    }
                    break;
                case 'DOCS':
                    if (approveFlag == 1) {
                        var msgSys = 'Documents approved';
                        msg = languageBasedErrorFactory.getProperErrorMessage('docApprov', 0, '3');
                        //msg = '¿Quiere aprobar la etapa de documentos?';
                    } else {
                        var msgSys = 'Documents disapproved';
                        msg = languageBasedErrorFactory.getProperErrorMessage('docUnapprov', 0, '3');
                        //msg = '¿Quiere rechazar la Postulacion?';
                    }
                    break;
                // case 'INTERVIEW':
                //     if (approveFlag == 1) {
                //         var msgSys = 'Interview approved';
                //         msg = languageBasedErrorFactory.getProperErrorMessage('interviewApprov', 0, '3');
                //         //msg = '¿Quieres aprobar la entrevista?';
                //     } else {
                //         var msgSys = 'Interview disapproved';
                //         msg = languageBasedErrorFactory.getProperErrorMessage('interviewUnapprov', 0, '3');
                //         //msg = '¿Quiere rechazar la Postulacion?';
                //     }
                //     break;
                case 'TRAINING':
                    if (approveFlag == 1) {
                        var msgSys = 'Training approved';
                        msg = languageBasedErrorFactory.getProperErrorMessage('trainingApprov', 0, '3');
                        //msg = '¿Quieres aprobar el entrenamiento?';
                    } else {
                        var msgSys = 'Training disapproved';
                        msg = languageBasedErrorFactory.getProperErrorMessage('trainingUnapprov', 0, '3');
                        //msg = '¿Quiere rechazar la Postulacion?';
                    }
                    break;
                // case 'SIGN':
                //     if (approveFlag == 1) {
                //         var msgSys = 'Sign of contract approved';
                //         msg = languageBasedErrorFactory.getProperErrorMessage('signUnapprov', 0, '3');
                //         //msg = '¿Quiere aprobar la firma del contrato?';
                //     } else {
                //         var msgSys = 'Sign of contract disapproved';
                //         msg = languageBasedErrorFactory.getProperErrorMessage('signApprov', 0, '3');
                //         //msg = '¿Quiere rechazar la Postulacion?';
                //     }
                //     break;
                case 'ACCOUNT':
                    if (approveFlag == 1) {
                        var msgSys = 'Account verification approved';
                        msg = languageBasedErrorFactory.getProperErrorMessage('accApprov', 0, '3');
                        //msg = '¿Quieres aprobar la etapa de activacion?';
                    } else {
                        var msgSys = 'Account verification disapproved';
                        msg = languageBasedErrorFactory.getProperErrorMessage('accUnapprov', 0, '3');
                        //msg = '¿Quiere rechazar la Postulacion?';
                    }
                    break;
                case 'FULL':
                    if (approveFlag == 1) {
                        var msgSys = 'Applicant fully approved';
                        msg = languageBasedErrorFactory.getProperErrorMessage('accFApprov', 0, '3');
                        //msg = '¿Quiere aprobar el postulacion?';
                    }
                    break;
            }
            var confirm = $mdDialog.confirm()
                .title(msg)
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('cancelButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');

                var dataSend = {};

                if (stepType == 'BASIC') {
                    dataSend = {
                        access_token: $cookies.get('obj'),
                        fleet_id: $stateParams.id,
                        basicRegistration: [{
                            basicRegistration_status: approveFlag,
                            basicRegistration_comments: commentsSend,
                            modified_by: $cookies.get('adminEmail'),
                            modified_at: new Date().toISOString()
                        }],
                        //documentation: [{
                        //    documentation_status: vm.driverDetail.documentation_status,
                        //    documentation_comments: vm.driverDetail.documentation_comments?vm.driverDetail.documentation_comments:'',
                        //    modified_by: vm.driverDetail.documentation_modified_by?vm.driverDetail.documentation_modified_by:'',
                        //    modified_at: vm.driverDetail.documentation_modified_at?vm.driverDetail.documentation_modified_at:''
                        //}],
                        //interview: [{
                        //    interview_status: vm.driverDetail.interview_status,
                        //    interview_comments: vm.driverDetail.interview_comments?vm.driverDetail.interview_comments:'',
                        //    modified_by: vm.driverDetail.interview_modified_by?vm.driverDetail.interview_modified_by:'',
                        //    modified_at: vm.driverDetail.interview_modified_at?vm.driverDetail.interview_modified_at:''
                        //}],
                        //training: [{
                        //    training_status: vm.driverDetail.training_status,
                        //    training_comments: vm.driverDetail.training_comments?vm.driverDetail.training_comments:'',
                        //    modified_by: vm.driverDetail.training_modified_by?vm.driverDetail.training_modified_by:'',
                        //    modified_at: vm.driverDetail.training_modified_at?vm.driverDetail.training_modified_at:''
                        //}],
                        //signOfContract: [{
                        //    signOfContract_status: vm.driverDetail.signOfContract_status,
                        //    signOfContract_comments: vm.driverDetail.signOfContract_comments?vm.driverDetail.signOfContract_comments:'',
                        //    modified_by: vm.driverDetail.signOfContract_modified_by?vm.driverDetail.signOfContract_modified_by:'',
                        //    modified_at: vm.driverDetail.signOfContract_modified_at?vm.driverDetail.signOfContract_modified_at:''
                        //}],
                        //activation: [{
                        //    activation_status: vm.driverDetail.activation_status,
                        //    activation_comments: vm.driverDetail.activation_comments?vm.driverDetail.activation_comments:'',
                        //    modified_by: vm.driverDetail.activation_modified_by?vm.driverDetail.activation_modified_by:'',
                        //    modified_at: vm.driverDetail.activation_modified_at?vm.driverDetail.activation_modified_at:''
                        //}],
                        admin_verified_status: vm.driverDetail.admin_verified,
                        verification_status: approveFlag == 1 ? 1 : 0
                    }

                } else if (stepType == 'DOCS') {

                    dataSend = {
                        access_token: $cookies.get('obj'),
                        fleet_id: $stateParams.id,
                        //basicRegistration: [{
                        //    basicRegistration_status: vm.driverDetail.basicRegistration_status,
                        //    basicRegistration_comments: vm.driverDetail.basicRegistration_comments?vm.driverDetail.basicRegistration_comments:'',
                        //    modified_by: vm.driverDetail.basicRegistration_modified_by?vm.driverDetail.basicRegistration_modified_by:'',
                        //    modified_at: vm.driverDetail.basicRegistration_modified_at?vm.driverDetail.basicRegistration_modified_at:''
                        //}],
                        documentation: [{
                            documentation_status: approveFlag,
                            documentation_comments: commentsSend,
                            modified_by: $cookies.get('adminEmail'),
                            modified_at: new Date().toISOString()
                        }],
                        //interview: [{
                        //    interview_status: vm.driverDetail.interview_status,
                        //    interview_comments: vm.driverDetail.interview_comments?vm.driverDetail.interview_comments:'',
                        //    modified_by: vm.driverDetail.interview_modified_by?vm.driverDetail.interview_modified_by:'',
                        //    modified_at: vm.driverDetail.interview_modified_at?vm.driverDetail.interview_modified_at:''
                        //}],
                        //training: [{
                        //    training_status: vm.driverDetail.training_status,
                        //    training_comments: vm.driverDetail.training_comments?vm.driverDetail.training_comments:'',
                        //    modified_by: vm.driverDetail.training_modified_by?vm.driverDetail.training_modified_by:'',
                        //    modified_at: vm.driverDetail.training_modified_at?vm.driverDetail.training_modified_at:''
                        //}],
                        //signOfContract: [{
                        //    signOfContract_status: vm.driverDetail.signOfContract_status,
                        //    signOfContract_comments: vm.driverDetail.signOfContract_comments?vm.driverDetail.signOfContract_comments:'',
                        //    modified_by: vm.driverDetail.signOfContract_modified_by?vm.driverDetail.signOfContract_modified_by:'',
                        //    modified_at: vm.driverDetail.signOfContract_modified_at?vm.driverDetail.signOfContract_modified_at:''
                        //}],
                        //activation: [{
                        //    activation_status: vm.driverDetail.activation_status,
                        //    activation_comments: vm.driverDetail.activation_comments?vm.driverDetail.activation_comments:'',
                        //    modified_by: vm.driverDetail.activation_modified_by?vm.driverDetail.activation_modified_by:'',
                        //    modified_at: vm.driverDetail.activation_modified_at?vm.driverDetail.activation_modified_at:''
                        //}],
                        admin_verified_status: vm.driverDetail.admin_verified,
                        verification_status: approveFlag == 1 ? 2 : 1
                    }
                } 
                // else if (stepType == 'INTERVIEW') {

                //     dataSend = {
                //         access_token: $cookies.get('obj'),
                //         fleet_id: $stateParams.id,
                //         //basicRegistration: [{
                //         //    basicRegistration_status: vm.driverDetail.basicRegistration_status,
                //         //    basicRegistration_comments: vm.driverDetail.basicRegistration_comments?vm.driverDetail.basicRegistration_comments:'',
                //         //    modified_by: vm.driverDetail.basicRegistration_modified_by?vm.driverDetail.basicRegistration_modified_by:'',
                //         //    modified_at: vm.driverDetail.basicRegistration_modified_at?vm.driverDetail.basicRegistration_modified_at:''
                //         //}],
                //         //documentation: [{
                //         //    documentation_status: vm.driverDetail.documentation_status,
                //         //    documentation_comments: vm.driverDetail.documentation_comments?vm.driverDetail.documentation_comments:'',
                //         //    modified_by: vm.driverDetail.documentation_modified_by?vm.driverDetail.documentation_modified_by:'',
                //         //    modified_at: vm.driverDetail.documentation_modified_at?vm.driverDetail.documentation_modified_at:''
                //         //}],
                //         interview: [{
                //             interview_status: approveFlag,
                //             interview_comments: commentsSend,
                //             modified_by: $cookies.get('adminEmail'),
                //             modified_at: new Date().toISOString()
                //         }],
                //         //training: [{
                //         //    training_status: vm.driverDetail.training_status,
                //         //    training_comments: vm.driverDetail.training_comments?vm.driverDetail.training_comments:'',
                //         //    modified_by: vm.driverDetail.training_modified_by?vm.driverDetail.training_modified_by:'',
                //         //    modified_at: vm.driverDetail.training_modified_at?vm.driverDetail.training_modified_at:''
                //         //}],
                //         //signOfContract: [{
                //         //    signOfContract_status: vm.driverDetail.signOfContract_status,
                //         //    signOfContract_comments: vm.driverDetail.signOfContract_comments?vm.driverDetail.signOfContract_comments:'',
                //         //    modified_by: vm.driverDetail.signOfContract_modified_by?vm.driverDetail.signOfContract_modified_by:'',
                //         //    modified_at: vm.driverDetail.signOfContract_modified_at?vm.driverDetail.signOfContract_modified_at:''
                //         //}],
                //         //activation: [{
                //         //    activation_status: vm.driverDetail.activation_status,
                //         //    activation_comments: vm.driverDetail.activation_comments?vm.driverDetail.activation_comments:'',
                //         //    modified_by: vm.driverDetail.activation_modified_by?vm.driverDetail.activation_modified_by:'',
                //         //    modified_at: vm.driverDetail.activation_modified_at?vm.driverDetail.activation_modified_at:''
                //         //}],
                //         admin_verified_status: vm.driverDetail.admin_verified,
                //         verification_status: approveFlag == 1 ? 4 : 3
                //     }
                // } 
                else if (stepType == 'TRAINING') {

                    dataSend = {
                        access_token: $cookies.get('obj'),
                        fleet_id: $stateParams.id,
                        //basicRegistration: [{
                        //    basicRegistration_status: vm.driverDetail.basicRegistration_status,
                        //    basicRegistration_comments: vm.driverDetail.basicRegistration_comments?vm.driverDetail.basicRegistration_comments:'',
                        //    modified_by: vm.driverDetail.basicRegistration_modified_by?vm.driverDetail.basicRegistration_modified_by:'',
                        //    modified_at: vm.driverDetail.basicRegistration_modified_at?vm.driverDetail.basicRegistration_modified_at:''
                        //}],
                        //documentation: [{
                        //    documentation_status: vm.driverDetail.documentation_status,
                        //    documentation_comments: vm.driverDetail.documentation_comments?vm.driverDetail.documentation_comments:'',
                        //    modified_by: vm.driverDetail.documentation_modified_by?vm.driverDetail.documentation_modified_by:'',
                        //    modified_at: vm.driverDetail.documentation_modified_at?vm.driverDetail.documentation_modified_at:''
                        //}],
                        //interview: [{
                        //    interview_status: vm.driverDetail.interview_status,
                        //    interview_comments: vm.driverDetail.interview_comments?vm.driverDetail.interview_comments:'',
                        //    modified_by: vm.driverDetail.interview_modified_by?vm.driverDetail.interview_modified_by:'',
                        //    modified_at: vm.driverDetail.interview_modified_at?vm.driverDetail.interview_modified_at:''
                        //}],
                        training: [{
                            training_status: approveFlag,
                            training_comments: commentsSend,
                            modified_by: $cookies.get('adminEmail'),
                            modified_at: new Date().toISOString()
                        }],
                        //signOfContract: [{
                        //    signOfContract_status: vm.driverDetail.signOfContract_status,
                        //    signOfContract_comments: vm.driverDetail.signOfContract_comments?vm.driverDetail.signOfContract_comments:'',
                        //    modified_by: vm.driverDetail.signOfContract_modified_by?vm.driverDetail.signOfContract_modified_by:'',
                        //    modified_at: vm.driverDetail.signOfContract_modified_at?vm.driverDetail.signOfContract_modified_at:''
                        //}],
                        //activation: [{
                        //    activation_status: vm.driverDetail.activation_status,
                        //    activation_comments: vm.driverDetail.activation_comments?vm.driverDetail.activation_comments:'',
                        //    modified_by: vm.driverDetail.activation_modified_by?vm.driverDetail.activation_modified_by:'',
                        //    modified_at: vm.driverDetail.activation_modified_at?vm.driverDetail.activation_modified_at:''
                        //}],
                        admin_verified_status: vm.driverDetail.admin_verified,
                        verification_status: approveFlag == 1 ? 3 : 2
                    }
                } 
                // else if (stepType == 'SIGN') {

                //     dataSend = {
                //         access_token: $cookies.get('obj'),
                //         fleet_id: $stateParams.id,
                //         //basicRegistration: [{
                //         //    basicRegistration_status: vm.driverDetail.basicRegistration_status,
                //         //    basicRegistration_comments: vm.driverDetail.basicRegistration_comments?vm.driverDetail.basicRegistration_comments:'',
                //         //    modified_by: vm.driverDetail.basicRegistration_modified_by?vm.driverDetail.basicRegistration_modified_by:'',
                //         //    modified_at: vm.driverDetail.basicRegistration_modified_at?vm.driverDetail.basicRegistration_modified_at:''
                //         //}],
                //         //documentation: [{
                //         //    documentation_status: vm.driverDetail.documentation_status,
                //         //    documentation_comments: vm.driverDetail.documentation_comments?vm.driverDetail.documentation_comments:'',
                //         //    modified_by: vm.driverDetail.documentation_modified_by?vm.driverDetail.documentation_modified_by:'',
                //         //    modified_at: vm.driverDetail.documentation_modified_at?vm.driverDetail.documentation_modified_at:''
                //         //}],
                //         //interview: [{
                //         //    interview_status: vm.driverDetail.interview_status,
                //         //    interview_comments: vm.driverDetail.interview_comments?vm.driverDetail.interview_comments:'',
                //         //    modified_by: vm.driverDetail.interview_modified_by?vm.driverDetail.interview_modified_by:'',
                //         //    modified_at: vm.driverDetail.interview_modified_at?vm.driverDetail.interview_modified_at:''
                //         //}],
                //         //training: [{
                //         //    training_status: vm.driverDetail.training_status,
                //         //    training_comments: vm.driverDetail.training_comments?vm.driverDetail.training_comments:'',
                //         //    modified_by: vm.driverDetail.training_modified_by?vm.driverDetail.training_modified_by:'',
                //         //    modified_at: vm.driverDetail.training_modified_at?vm.driverDetail.training_modified_at:''
                //         //}],
                //         signOfContract: [{
                //             signOfContract_status: approveFlag,
                //             signOfContract_comments: commentsSend,
                //             modified_by: $cookies.get('adminEmail'),
                //             modified_at: new Date().toISOString()
                //         }],
                //         //activation: [{
                //         //    activation_status: vm.driverDetail.activation_status,
                //         //    activation_comments: vm.driverDetail.activation_comments?vm.driverDetail.activation_comments:'',
                //         //    modified_by: vm.driverDetail.activation_modified_by?vm.driverDetail.activation_modified_by:'',
                //         //    modified_at: vm.driverDetail.activation_modified_at?vm.driverDetail.activation_modified_at:''
                //         //}],
                //         admin_verified_status: vm.driverDetail.admin_verified,
                //         verification_status: approveFlag == 1 ? 6 : 5
                //     }
                // } 
                else if (stepType == 'ACCOUNT') {

                    dataSend = {
                        access_token: $cookies.get('obj'),
                        fleet_id: $stateParams.id,
                        //basicRegistration: [{
                        //    basicRegistration_status: vm.driverDetail.basicRegistration_status,
                        //    basicRegistration_comments: vm.driverDetail.basicRegistration_comments?vm.driverDetail.basicRegistration_comments:'',
                        //    modified_by: vm.driverDetail.basicRegistration_modified_by?vm.driverDetail.basicRegistration_modified_by:'',
                        //    modified_at: vm.driverDetail.basicRegistration_modified_at?vm.driverDetail.basicRegistration_modified_at:''
                        //}],
                        //documentation: [{
                        //    documentation_status: vm.driverDetail.documentation_status,
                        //    documentation_comments: vm.driverDetail.documentation_comments?vm.driverDetail.documentation_comments:'',
                        //    modified_by: vm.driverDetail.documentation_modified_by?vm.driverDetail.documentation_modified_by:'',
                        //    modified_at: vm.driverDetail.documentation_modified_at?vm.driverDetail.documentation_modified_at:''
                        //}],
                        //interview: [{
                        //    interview_status: vm.driverDetail.interview_status,
                        //    interview_comments: vm.driverDetail.interview_comments?vm.driverDetail.interview_comments:'',
                        //    modified_by: vm.driverDetail.interview_modified_by?vm.driverDetail.interview_modified_by:'',
                        //    modified_at: vm.driverDetail.interview_modified_at?vm.driverDetail.interview_modified_at:''
                        //}],
                        //training: [{
                        //    training_status: vm.driverDetail.training_status,
                        //    training_comments: vm.driverDetail.training_comments?vm.driverDetail.training_comments:'',
                        //    modified_by: vm.driverDetail.training_modified_by?vm.driverDetail.training_modified_by:'',
                        //    modified_at: vm.driverDetail.training_modified_at?vm.driverDetail.training_modified_at:''
                        //}],
                        //signOfContract: [{
                        //    signOfContract_status: vm.driverDetail.signOfContract_status,
                        //    signOfContract_comments: vm.driverDetail.signOfContract_comments?vm.driverDetail.signOfContract_comments:'',
                        //    modified_by: vm.driverDetail.signOfContract_modified_by?vm.driverDetail.signOfContract_modified_by:'',
                        //    modified_at: vm.driverDetail.signOfContract_modified_at?vm.driverDetail.signOfContract_modified_at:''
                        //}],
                        activation: [{
                            activation_status: approveFlag,
                            activation_comments: commentsSend,
                            modified_by: $cookies.get('adminEmail'),
                            modified_at: new Date().toISOString()
                        }],
                        admin_verified_status: vm.driverDetail.admin_verified,
                        verification_status: approveFlag == 1 ? 4 : 3
                    }
                } else if (stepType == 'FULL') {

                    if (vm.driverDetail.fleet_type == 1) {
                        dataSend = {
                            access_token: $cookies.get('obj'),
                            fleet_id: $stateParams.id,
                            basicRegistration: [{
                                basicRegistration_status: vm.driverDetail.basicRegistration_status,
                                basicRegistration_comments: vm.driverDetail.basicRegistration_comments ? vm.driverDetail.basicRegistration_comments : '',
                                modified_by: vm.driverDetail.basicRegistration_modified_by ? vm.driverDetail.basicRegistration_modified_by : '',
                                modified_at: vm.driverDetail.basicRegistration_modified_at ? vm.driverDetail.basicRegistration_modified_at : ''
                            }],
                            documentation: [{
                                documentation_status: vm.driverDetail.documentation_status,
                                documentation_comments: vm.driverDetail.documentation_comments ? vm.driverDetail.documentation_comments : '',
                                modified_by: vm.driverDetail.documentation_modified_by ? vm.driverDetail.documentation_modified_by : '',
                                modified_at: vm.driverDetail.documentation_modified_at ? vm.driverDetail.documentation_modified_at : ''
                            }],
                            // interview: [{
                            //     interview_status: vm.driverDetail.interview_status,
                            //     interview_comments: vm.driverDetail.interview_comments ? vm.driverDetail.interview_comments : '',
                            //     modified_by: vm.driverDetail.interview_modified_by ? vm.driverDetail.interview_modified_by : '',
                            //     modified_at: vm.driverDetail.interview_modified_at ? vm.driverDetail.interview_modified_at : ''
                            // }],
                            training: [{
                                training_status: vm.driverDetail.training_status,
                                training_comments: vm.driverDetail.training_comments ? vm.driverDetail.training_comments : '',
                                modified_by: vm.driverDetail.training_modified_by ? vm.driverDetail.training_modified_by : '',
                                modified_at: vm.driverDetail.training_modified_at ? vm.driverDetail.training_modified_at : ''
                            }],
                            activation: [{
                                activation_status: vm.driverDetail.activation_status,
                                activation_comments: vm.driverDetail.activation_comments ? vm.driverDetail.activation_comments : '',
                                modified_by: vm.driverDetail.activation_modified_by ? vm.driverDetail.activation_modified_by : '',
                                modified_at: vm.driverDetail.activation_modified_at ? vm.driverDetail.activation_modified_at : ''
                            }],
                            admin_verified_status: approveFlag,
                            verification_status: approveFlag == 1 ? 4 : 4
                        }
                    } else {
                        dataSend = {
                            access_token: $cookies.get('obj'),
                            fleet_id: $stateParams.id,
                            basicRegistration: [{
                                basicRegistration_status: vm.driverDetail.basicRegistration_status,
                                basicRegistration_comments: vm.driverDetail.basicRegistration_comments ? vm.driverDetail.basicRegistration_comments : '',
                                modified_by: vm.driverDetail.basicRegistration_modified_by ? vm.driverDetail.basicRegistration_modified_by : '',
                                modified_at: vm.driverDetail.basicRegistration_modified_at ? vm.driverDetail.basicRegistration_modified_at : ''
                            }],
                            documentation: [{
                                documentation_status: vm.driverDetail.documentation_status,
                                documentation_comments: vm.driverDetail.documentation_comments ? vm.driverDetail.documentation_comments : '',
                                modified_by: vm.driverDetail.documentation_modified_by ? vm.driverDetail.documentation_modified_by : '',
                                modified_at: vm.driverDetail.documentation_modified_at ? vm.driverDetail.documentation_modified_at : ''
                            }],
                            // interview: [{
                            //     interview_status: vm.driverDetail.interview_status,
                            //     interview_comments: vm.driverDetail.interview_comments ? vm.driverDetail.interview_comments : '',
                            //     modified_by: vm.driverDetail.interview_modified_by ? vm.driverDetail.interview_modified_by : '',
                            //     modified_at: vm.driverDetail.interview_modified_at ? vm.driverDetail.interview_modified_at : ''
                            // }],
                            training: [{
                                training_status: vm.driverDetail.training_status,
                                training_comments: vm.driverDetail.training_comments ? vm.driverDetail.training_comments : '',
                                modified_by: vm.driverDetail.training_modified_by ? vm.driverDetail.training_modified_by : '',
                                modified_at: vm.driverDetail.training_modified_at ? vm.driverDetail.training_modified_at : ''
                            }],
                            // signOfContract: [{
                            //     signOfContract_status: vm.driverDetail.signOfContract_status,
                            //     signOfContract_comments: vm.driverDetail.signOfContract_comments ? vm.driverDetail.signOfContract_comments : '',
                            //     modified_by: vm.driverDetail.signOfContract_modified_by ? vm.driverDetail.signOfContract_modified_by : '',
                            //     modified_at: vm.driverDetail.signOfContract_modified_at ? vm.driverDetail.signOfContract_modified_at : ''
                            // }],
                            activation: [{
                                activation_status: vm.driverDetail.activation_status,
                                activation_comments: vm.driverDetail.activation_comments ? vm.driverDetail.activation_comments : '',
                                modified_by: vm.driverDetail.activation_modified_by ? vm.driverDetail.activation_modified_by : '',
                                modified_at: vm.driverDetail.activation_modified_at ? vm.driverDetail.activation_modified_at : ''
                            }],
                            admin_verified_status: approveFlag,
                            verification_status: approveFlag == 1 ? 4 : 4
                        }
                    }

                }

                $log.log(dataSend);
                vm.loading = true;
                var promise = getDrivers.approveDriverSteps(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        if (payload.title.status == 400) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            var dataForSysLogs = {
                                access_token: $cookies.get('obj'),
                                id: $stateParams.id,
                                identity: 0, // 0- driver, 1- customer , 2 -car
                                message: msgSys
                            };
                            $rootScope.systemLogsAdmin(dataForSysLogs);
                            if (stepType == 'FULL') {
                                if (vm.driverDetail.fleet_type == 1) {
                                    //errorMessageFactory.showErrorMessage('La Postulacion del conductor sin auto ha sido exitosa',2,'layout.applicantsMain.applicants');
                                    languageBasedErrorFactory.getProperErrorMessage('applicantApprovSucc1', 0, 2, 'layout.applicantsMain.applicants');
                                    //errorMessageFactory.showErrorMessage('The application of the driver without car has been successful',2,'layout.applicantsMain.applicants');
                                } else if (vm.driverDetail.fleet_type == 0) {
                                    //errorMessageFactory.showErrorMessage('La postulación del conductor con coche ha sido exitosa',2,'layout.applicantsMain.applicants');
                                    languageBasedErrorFactory.getProperErrorMessage('applicantApprovSucc2', 0, 2, 'layout.applicantsMain.applicants');
                                    //errorMessageFactory.showErrorMessage('The application of the driver with car has been successful',2,'layout.applicantsMain.applicants');
                                } else if (vm.driverDetail.fleet_type == 2) {
                                    //errorMessageFactory.showErrorMessage('La postulación del inversor automovilístico ha tenido éxito',2,'layout.applicantsMain.applicants');
                                    languageBasedErrorFactory.getProperErrorMessage('applicantApprovSucc3', 0, 2, 'layout.applicantsMain.applicants');
                                    //errorMessageFactory.showErrorMessage('The application of the car investor has been successful',2,'layout.applicantsMain.applicants');
                                }
                                //$timeout(function() {
                                //    $mdDialog.hide()
                                //    $state.go('layout.applicantsMain.applicants');
                                //}, 2000)

                            } else {
                                $state.reload('layout.applicantsMain.applicantsApproval');
                            }
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );


            }, function () {
                $log.log('not confirmed');
            });
        };

        //===================approve documents======================
        function approveDocument(approveFlag, type, $event, data) {
            var msg = '';
            switch (type) {
                case 'RUT':
                    if (approveFlag == 1) {
                        msg = languageBasedErrorFactory.getProperErrorMessage('rutApprov', 0, '3');
                        var msgSys = 'RUT approved.';
                        //msg = '¿Quiere aprobar RUT ?';
                    } else if (approveFlag == 2) {
                        msg = languageBasedErrorFactory.getProperErrorMessage('rutUnapprov', 0, '3');
                        var msgSys = 'RUT disapproved.';
                        //msg = '¿No quieres aprobar RUT?';
                    } else {
                        var msgSys = 'RUT upload again.';
                        msg = languageBasedErrorFactory.getProperErrorMessage('rutUpload', 0, '3');
                        //msg = '¿No desea que el controlador vuelva a cargar el RUT?';
                    }
                    break;
                case 'LICENSE':
                    if (approveFlag == 1) {
                        var msgSys = 'License approved.';
                        msg = languageBasedErrorFactory.getProperErrorMessage('licenseApprov', 0, '3');
                        //msg = '¿Quieres aprobar la licencia?';
                    } else if (approveFlag == 2) {
                        var msgSys = 'License disapproved.';
                        msg = languageBasedErrorFactory.getProperErrorMessage('licenseUnapprov', 0, '3');
                        //msg = '¿No quieres aprobar la licencia?';
                    } else {
                        var msgSys = 'License upload again.';
                        msg = languageBasedErrorFactory.getProperErrorMessage('licenseUpload', 0, '3');
                        //msg = '¿No desea que el controlador vuelva a subir la licencia?';
                    }
                    break;
                case 'CARD':
                    if (approveFlag == 1) {
                        var msgSys = 'Identity card approved.';
                        msg = languageBasedErrorFactory.getProperErrorMessage('identityApprov', 0, '3');
                        //msg = '¿Quiere aprobar la tarjeta de identidad de la empresa?';
                    } else if (approveFlag == 2) {
                        var msgSys = 'Identity card disapproved.';
                        msg = languageBasedErrorFactory.getProperErrorMessage('identityUnapprov', 0, '3');
                        //msg = '¿No desea aprobar la tarjeta de identidad de la empresa?';
                    } else {
                        var msgSys = 'Identity card upload again.';
                        msg = languageBasedErrorFactory.getProperErrorMessage('identityUpload', 0, '3');
                        //msg = '¿No quiere que el conductor vuelva a cargar la tarjeta de identidad de la empresa?';
                    }
                    break;
                case 'CONSTITUTION':
                    if (approveFlag == 1) {
                        var msgSys = 'Company constitution approved.';
                        msg = languageBasedErrorFactory.getProperErrorMessage('constitutionApprov', 0, '3');
                        //msg = '¿Quiere aprobar el documento de constitución de la empresa?';
                    } else if (approveFlag == 2) {
                        var msgSys = 'Company constitution disapproved.';
                        msg = languageBasedErrorFactory.getProperErrorMessage('constitutionUnapprov', 0, '3');
                        //msg = '¿No desea aprobar el documento de constitución de la empresa?';
                    } else {
                        var msgSys = 'Company constitution upload again.';
                        msg = languageBasedErrorFactory.getProperErrorMessage('constitutionUpload', 0, '3');
                        //msg = '¿No quiere que el controlador vuelva a cargar el documento de constitución de la empresa?';
                    }
                    break;
                case 'ACTIVITY':
                    if (approveFlag == 1) {
                        var msgSys = 'Start activity approved.';
                        msg = languageBasedErrorFactory.getProperErrorMessage('activityApprov', 0, '3');
                        //msg = '¿Desea aprobar el documento de actividad de inicio?';
                    } else if (approveFlag == 2) {
                        var msgSys = 'Start activity disapproved.';
                        msg = languageBasedErrorFactory.getProperErrorMessage('activityUnapprov', 0, '3');
                        //msg = '¿No desea aprobar el documento de actividad de inicio?';
                    } else {
                        var msgSys = 'Start activity upload again.';
                        msg = languageBasedErrorFactory.getProperErrorMessage('activityUpload', 0, '3');
                        //msg = '¿No desea que el controlador cargue de nuevo el documento de actividad de inicio?';
                    }
                    break;
                case 'INVOICE':
                    if (approveFlag == 1) {
                        var msgSys = 'Company invoice approved.';
                        msg = languageBasedErrorFactory.getProperErrorMessage('invoiceApprov', 0, '3');
                        //msg = '¿Desea aprobar el documento de factura?';
                    } else if (approveFlag == 2) {
                        var msgSys = 'Company invoice disapproved.';
                        msg = languageBasedErrorFactory.getProperErrorMessage('invoiceUnapprov', 0, '3');
                        //msg = '¿No desea aprobar el documento de factura?';
                    } else {
                        var msgSys = 'Company invoice upload again.';
                        msg = languageBasedErrorFactory.getProperErrorMessage('invoiceUpload', 0, '3');
                        //msg = '¿No desea que el controlador vuelva a cargar el documento de facturación?';
                    }
                    break;
                case 'LIFE_SHEET':
                    if (approveFlag == 1) {
                        var msgSys = 'Life sheet approved.';
                        msg = languageBasedErrorFactory.getProperErrorMessage('lifeSheetApprov', 0, '3');
                        //msg = '¿Quiere aprobar un documento de hoja de vida?';
                    } else if (approveFlag == 2) {
                        var msgSys = 'Life sheet disapproved.';
                        msg = languageBasedErrorFactory.getProperErrorMessage('lifeSheetUnapprov', 0, '3');
                        //msg = '¿No quieres aprobar un documento de hoja de vida?';
                    } else {
                        var msgSys = 'Life sheet upload again.';
                        msg = languageBasedErrorFactory.getProperErrorMessage('lifeSheetUpload', 0, '3');
                        //msg = '¿No desea que el controlador cargue el documento de hoja de vida de nuevo?';
                    }
                    break;
                case 'ANTECENTS':
                    if (approveFlag == 1) {
                        var msgSys = 'Certicate of antcedents approved.';
                        msg = languageBasedErrorFactory.getProperErrorMessage('antecedentsApprov', 0, '3');
                        //msg = '¿Desea aprobar un documento antecedentes?';
                    } else if (approveFlag == 2) {
                        var msgSys = 'Certicate of antcedents disapproved.';
                        msg = languageBasedErrorFactory.getProperErrorMessage('antecedentsUnapprov', 0, '3');
                        //msg = '¿No quieres aprobar el documento antecedentes?';
                    } else {
                        var msgSys = 'Certicate of antcedents upload again.';
                        msg = languageBasedErrorFactory.getProperErrorMessage('antecedentsUpload', 0, '3');
                        //msg = '¿No desea que el controlador cargue el documento de antecedentes de nuevo?';
                    }
                    break;
                case 'Permiso Ministerio de Transporte':
                    if (approveFlag == 1) {
                        var msgSys = 'Permiso Ministerio de Transporte approved.';
                        // msg = languageBasedErrorFactory.getProperErrorMessage('Permiso Ministerio de Transporte approved.', 0, '3');
                        msg = 'Permiso Ministerio de Transporte approved.';
                    } else if (approveFlag == 2) {
                        var msgSys = 'Permiso Ministerio de Transporte disapproved.';
                        // msg = languageBasedErrorFactory.getProperErrorMessage('Permiso Ministerio de Transporte disapproved.', 0, '3');
                        msg = 'Permiso Ministerio de Transporte disapproved.';
                    } else {
                        var msgSys = 'Permiso Ministerio de Transporte upload again.';
                        // msg = languageBasedErrorFactory.getProperErrorMessage('Permiso Ministerio de Transporte upload again.', 0, '3');
                        msg = 'Permiso Ministerio de Transporte upload again.';
                    }
                    break;
                case 'Permiso de Circulación':
                    if (approveFlag == 1) {
                        var msgSys = 'Permiso de Circulación approved.';
                        // msg = languageBasedErrorFactory.getProperErrorMessage('Permiso de Circulación approved.', 0, '3');
                        msg = 'Permiso de Circulación approved.';
                    } else if (approveFlag == 2) {
                        var msgSys = 'Permiso de Circulación disapproved.';
                        // msg = languageBasedErrorFactory.getProperErrorMessage('Permiso de Circulación disapproved.', 0, '3');
                        msg = 'Permiso de Circulación disapproved.';
                    } else {
                        var msgSys = 'Permiso de Circulación upload again.';
                        // msg = languageBasedErrorFactory.getProperErrorMessage('Permiso de Circulación upload again.', 0, '3');
                        msg = 'Permiso de Circulación upload again.';
                    }
                    break;
            }
            var confirm = $mdDialog.confirm()
                .title(msg)
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('cancelButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');

                var dataSend = {};

                if (type == 'RUT') {
                    dataSend = {
                        access_token: $cookies.get('obj'),
                        fleet_id: $stateParams.id,
                        identity_card_RUT_status: approveFlag,
                        driver_license_status: vm.driverDetail.driver_license_status,
                        identity_card_company_status: vm.driverDetail.identity_card_company_status,
                        constitution_company_status: vm.driverDetail.constitution_company_status,
                        start_activities_status: vm.driverDetail.start_activities_status,
                        stamping_invoice_status: vm.driverDetail.stamping_invoice_status,
                        antecents_certificate_status: vm.driverDetail.antecents_certificate_status,
                        life_sheet_img_status: vm.driverDetail.life_sheet_img_status,
                        permission_of_circulation_status: vm.carDetail.permission_of_circulation_status,
                        transportation_permit_status: vm.carDetail.transportation_permit_status
                    }

                } else if (type == 'LICENSE') {

                    dataSend = {
                        access_token: $cookies.get('obj'),
                        fleet_id: $stateParams.id,
                        identity_card_RUT_status: vm.driverDetail.identity_card_RUT_status,
                        driver_license_status: approveFlag,
                        identity_card_company_status: vm.driverDetail.identity_card_company_status,
                        constitution_company_status: vm.driverDetail.constitution_company_status,
                        start_activities_status: vm.driverDetail.start_activities_status,
                        stamping_invoice_status: vm.driverDetail.stamping_invoice_status,
                        antecents_certificate_status: vm.driverDetail.antecents_certificate_status,
                        life_sheet_img_status: vm.driverDetail.life_sheet_img_status,
                        permission_of_circulation_status: vm.carDetail.permission_of_circulation_status,
                        transportation_permit_status: vm.carDetail.transportation_permit_status
                    }
                } else if (type == 'CARD') {

                    dataSend = {
                        access_token: $cookies.get('obj'),
                        fleet_id: $stateParams.id,
                        identity_card_RUT_status: vm.driverDetail.identity_card_RUT_status,
                        driver_license_status: vm.driverDetail.driver_license_status,
                        identity_card_company_status: approveFlag,
                        constitution_company_status: vm.driverDetail.constitution_company_status,
                        start_activities_status: vm.driverDetail.start_activities_status,
                        stamping_invoice_status: vm.driverDetail.stamping_invoice_status,
                        antecents_certificate_status: vm.driverDetail.antecents_certificate_status,
                        life_sheet_img_status: vm.driverDetail.life_sheet_img_status,
                        permission_of_circulation_status: vm.carDetail.permission_of_circulation_status,
                        transportation_permit_status: vm.carDetail.transportation_permit_status
                    }
                } else if (type == 'CONSTITUTION') {

                    dataSend = {
                        access_token: $cookies.get('obj'),
                        fleet_id: $stateParams.id,
                        identity_card_RUT_status: vm.driverDetail.identity_card_RUT_status,
                        driver_license_status: vm.driverDetail.driver_license_status,
                        identity_card_company_status: vm.driverDetail.identity_card_company_status,
                        constitution_company_status: approveFlag,
                        start_activities_status: vm.driverDetail.start_activities_status,
                        stamping_invoice_status: vm.driverDetail.stamping_invoice_status,
                        antecents_certificate_status: vm.driverDetail.antecents_certificate_status,
                        life_sheet_img_status: vm.driverDetail.life_sheet_img_status,
                        permission_of_circulation_status: vm.carDetail.permission_of_circulation_status,
                        transportation_permit_status: vm.carDetail.transportation_permit_status
                    }
                } else if (type == 'ACTIVITY') {

                    dataSend = {
                        access_token: $cookies.get('obj'),
                        fleet_id: $stateParams.id,
                        identity_card_RUT_status: vm.driverDetail.identity_card_RUT_status,
                        driver_license_status: vm.driverDetail.driver_license_status,
                        identity_card_company_status: vm.driverDetail.identity_card_company_status,
                        constitution_company_status: vm.driverDetail.constitution_company_status,
                        start_activities_status: approveFlag,
                        stamping_invoice_status: vm.driverDetail.stamping_invoice_status,
                        antecents_certificate_status: vm.driverDetail.antecents_certificate_status,
                        life_sheet_img_status: vm.driverDetail.life_sheet_img_status,
                        permission_of_circulation_status: vm.carDetail.permission_of_circulation_status,
                        transportation_permit_status: vm.carDetail.transportation_permit_status
                    }
                } else if (type == 'INVOICE') {

                    dataSend = {
                        access_token: $cookies.get('obj'),
                        fleet_id: $stateParams.id,
                        identity_card_RUT_status: vm.driverDetail.identity_card_RUT_status,
                        driver_license_status: vm.driverDetail.driver_license_status,
                        identity_card_company_status: vm.driverDetail.identity_card_company_status,
                        constitution_company_status: vm.driverDetail.constitution_company_status,
                        start_activities_status: vm.driverDetail.start_activities_status,
                        stamping_invoice_status: approveFlag,
                        antecents_certificate_status: vm.driverDetail.antecents_certificate_status,
                        life_sheet_img_status: vm.driverDetail.life_sheet_img_status,
                        permission_of_circulation_status: vm.carDetail.permission_of_circulation_status,
                        transportation_permit_status: vm.carDetail.transportation_permit_status
                    }
                } else if (type == 'ANTECENTS') {

                    dataSend = {
                        access_token: $cookies.get('obj'),
                        fleet_id: $stateParams.id,
                        identity_card_RUT_status: vm.driverDetail.identity_card_RUT_status,
                        driver_license_status: vm.driverDetail.driver_license_status,
                        identity_card_company_status: vm.driverDetail.identity_card_company_status,
                        constitution_company_status: vm.driverDetail.constitution_company_status,
                        start_activities_status: vm.driverDetail.start_activities_status,
                        stamping_invoice_status: vm.driverDetail.stamping_invoice_status,
                        antecents_certificate_status: approveFlag,
                        life_sheet_img_status: vm.driverDetail.life_sheet_img_status,
                        permission_of_circulation_status: vm.carDetail.permission_of_circulation_status,
                        transportation_permit_status: vm.carDetail.transportation_permit_status
                    }
                } else if (type == 'LIFE_SHEET') {

                    dataSend = {
                        access_token: $cookies.get('obj'),
                        fleet_id: $stateParams.id,
                        identity_card_RUT_status: vm.driverDetail.identity_card_RUT_status,
                        driver_license_status: vm.driverDetail.driver_license_status,
                        identity_card_company_status: vm.driverDetail.identity_card_company_status,
                        constitution_company_status: vm.driverDetail.constitution_company_status,
                        start_activities_status: vm.driverDetail.start_activities_status,
                        stamping_invoice_status: vm.driverDetail.stamping_invoice_status,
                        antecents_certificate_status: vm.driverDetail.antecents_certificate_status,
                        life_sheet_img_status: approveFlag,
                        permission_of_circulation_status: vm.carDetail.permission_of_circulation_status,
                        transportation_permit_status: vm.carDetail.transportation_permit_status
                    }
                } else if (type == 'Permiso de Circulación') {

                    dataSend = {
                        access_token: $cookies.get('obj'),
                        fleet_id: $stateParams.id,
                        identity_card_RUT_status: vm.driverDetail.identity_card_RUT_status,
                        driver_license_status: vm.driverDetail.driver_license_status,
                        identity_card_company_status: vm.driverDetail.identity_card_company_status,
                        constitution_company_status: vm.driverDetail.constitution_company_status,
                        start_activities_status: vm.driverDetail.start_activities_status,
                        stamping_invoice_status: vm.driverDetail.stamping_invoice_status,
                        antecents_certificate_status: vm.driverDetail.antecents_certificate_status,
                        life_sheet_img_status: vm.driverDetail.life_sheet_img_status,
                        permission_of_circulation_status: approveFlag,
                        transportation_permit_status: data.transportation_permit_status
                    }
                    if (data.registration_number)
                        dataSend.registration_number = data.registration_number;
                } else if (type == 'Permiso Ministerio de Transporte') {
                    dataSend = {
                        access_token: $cookies.get('obj'),
                        fleet_id: $stateParams.id,
                        identity_card_RUT_status: vm.driverDetail.identity_card_RUT_status,
                        driver_license_status: vm.driverDetail.driver_license_status,
                        identity_card_company_status: vm.driverDetail.identity_card_company_status,
                        constitution_company_status: vm.driverDetail.constitution_company_status,
                        start_activities_status: vm.driverDetail.start_activities_status,
                        stamping_invoice_status: vm.driverDetail.stamping_invoice_status,
                        antecents_certificate_status: vm.driverDetail.antecents_certificate_status,
                        life_sheet_img_status: vm.driverDetail.life_sheet_img_status,
                        permission_of_circulation_status: data.permission_of_circulation_status,
                        transportation_permit_status: approveFlag
                    }
                    if (data.registration_number)
                        dataSend.registration_number = data.registration_number;
                }

                $log.log(dataSend);
                vm.loading = true;
                var promise = getDrivers.approveDriverDocuments(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        if (payload.title.status == 400) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            var dataForSysLogs = {
                                access_token: $cookies.get('obj'),
                                id: $stateParams.id,
                                identity: 0, // 0- driver, 1- customer , 2 -car
                                message: msgSys
                            };
                            $rootScope.systemLogsAdmin(dataForSysLogs);
                            $state.reload('layout.applicantsMain.applicantsApproval');
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );


            }, function () {
                $log.log('not confirmed');
            });
        }


        //=================go back================
        function goBack() {
            $state.go('layout.applicantsMain.applicants');
        };

        //=============edit driver document================
        function showEditDocumentDialog($event, url, name, registrationNumber) {
            vm.editDocument = {
                name: name,
                url: url,
                ErrMsg: '',
                btnDisable: true,
                registrationNumber: registrationNumber || ''
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/editDriverDocument.html',
                locals: {
                    items: vm.editDocument
                },
                bindToController: true,
                controller: DialogController
            });

            function DialogController($scope, $mdDialog, items) {
                $scope.editDocument = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function (File, type) {
                    $log.log('confirmed');
                    if (File) {
                        $mdDialog.hide();
                        editDocumentHit(File, type, $scope.editDocument.registrationNumber);
                    } else {
                        vm.editDocument.ErrMsg = languageBasedErrorFactory.getProperErrorMessage('editDocumenetError', 0, '3');
                        $timeout(function () {
                            vm.editDocument.ErrMsg = '';
                        }, 2000);
                    }
                };
                $scope.clickTrigger = function ($event) {
                    $log.log('ddf');
                    $event.stopPropagation();
                    var element = document.getElementById('editDocumentType');
                    element.click();
                };

                //===============file for customer edit=============
                $scope.file_to_upload = function (File, type) {
                    var file = File[0];
                    var transcript = File[0];
                    var reader = new FileReader;
                    $scope.editDocument.btnDisable = false;
                    $scope.$apply();
                    reader.onload = function (e) {
                        var img = new Image;
                        document.getElementById('editDocument').setAttribute('src', e.target.result);
                        img.onload = function () {
                            $scope.FileUploaded = File[0];
                            $scope.type = type;
                        };

                        img.src = reader.result;
                    };
                    reader.readAsDataURL(transcript);
                };
            }
        };


        function editDocumentHit(data, type, registrationNumber) {
            $log.log(data, type);
            var dataSend = new FormData();
            vm.loading = true;
            if (type == 'RUT') {
                var msgSys = 'RUT document edited.';
                if (data) {
                    dataSend.append('RUT_img', data);
                }
                //dataSend ={
                //    access_token: $cookies.get('obj'),
                //    fleet_id: $stateParams.id,
                //    RUT_img: data
                //}
                dataSend.append('access_token', $cookies.get('obj'));
                dataSend.append('fleet_id', $stateParams.id);

            } else if (type == 'LICENSE') {
                var msgSys = 'License document edited.';
                if (data) {
                    dataSend.append('license_img', data);
                }
                //dataSend ={
                //    access_token: $cookies.get('obj'),
                //    fleet_id: $stateParams.id,
                //    license_img: data
                //}
                dataSend.append('access_token', $cookies.get('obj'));
                dataSend.append('fleet_id', $stateParams.id);

            } else if (type == 'ANTECENTS') {
                var msgSys = 'Antecedents document edited.';
                if (data) {
                    dataSend.append('antecents_certificate', data);
                }
                //dataSend ={
                //    access_token: $cookies.get('obj'),
                //    fleet_id: $stateParams.id,
                //    //company_identity_card: data
                //}
                dataSend.append('access_token', $cookies.get('obj'));
                dataSend.append('fleet_id', $stateParams.id);

            } else if (type == 'LIFE_SHEET') {
                var msgSys = 'Life sheet document edited.';
                if (data) {
                    dataSend.append('life_sheet_img', data);
                }
                //dataSend ={
                //    access_token: $cookies.get('obj'),
                //    fleet_id: $stateParams.id,
                //    //RUT_img: data
                //}
                dataSend.append('access_token', $cookies.get('obj'));
                dataSend.append('fleet_id', $stateParams.id);

            } else if (type == 'COMPANY_IDENTITY') {
                var msgSys = 'Compnay identity card document edited.';
                if (data) {
                    dataSend.append('company_identity_card', data);
                }
                dataSend.append('access_token', $cookies.get('obj'));
                dataSend.append('fleet_id', $stateParams.id);

                //dataSend ={
                //    access_token: $cookies.get('obj'),
                //    fleet_id: $stateParams.id,
                //    company_identity_card: data
                //}
            } else if (type == 'COMPANY_CONSTITUTION') {
                var msgSys = 'Company constitution document edited.';
                if (data) {
                    dataSend.append('company_constitution', data);
                }
                //dataSend ={
                //    access_token: $cookies.get('obj'),
                //    fleet_id: $stateParams.id,
                //    company_constitution: data
                //}
                dataSend.append('access_token', $cookies.get('obj'));
                dataSend.append('fleet_id', $stateParams.id);
            } else if (type == 'ACTIVITY') {
                var msgSys = 'Start activity document edited.';
                if (data) {
                    dataSend.append('start_activities', data);
                }
                //dataSend ={
                //    access_token: $cookies.get('obj'),
                //    fleet_id: $stateParams.id,
                //    start_activities: data
                //}
                dataSend.append('access_token', $cookies.get('obj'));
                dataSend.append('fleet_id', $stateParams.id);
            } else if (type == 'INVOICE') {
                var msgSys = 'Company invoice document edited.';
                if (data) {
                    dataSend.append('invoice_stamping', data);
                }
                //dataSend ={
                //    access_token: $cookies.get('obj'),
                //    fleet_id: $stateParams.id,
                //    invoice_stamping: data
                //}
                dataSend.append('access_token', $cookies.get('obj'));
                dataSend.append('fleet_id', $stateParams.id);
            } else if (type == 'Permiso de Circulación') {
                var msgSys = 'Permiso de Circulación document edited.';
                if (data) {
                    dataSend.append('permission_of_circulation', data);
                }
                dataSend.append('access_token', $cookies.get('obj'));
                dataSend.append('fleet_id', $stateParams.id);
                dataSend.append('registration_number', registrationNumber);

            } else if (type == 'Permiso Ministerio de Transporte') {
                var msgSys = 'Permiso Ministerio de Transporte document edited.';
                if (data) {
                    dataSend.append('transportation_permit', data);
                }
                dataSend.append('access_token', $cookies.get('obj'));
                dataSend.append('fleet_id', $stateParams.id);
                dataSend.append('registration_number', registrationNumber);

            } else {
                dataSend.append('access_token', $cookies.get('obj'));
                dataSend.append('fleet_id', $stateParams.id);
            }


            var promise = getDrivers.editDocument(dataSend);
            promise.then(
                function (payload) {
                    if (payload.title.status == 200) {
                        $log.log(payload);
                        vm.loading = false;
                        var dataForSysLogs = {
                            access_token: $cookies.get('obj'),
                            id: $stateParams.id,
                            identity: 0, // 0- driver, 1- customer , 2 -car
                            message: msgSys
                        };
                        $rootScope.systemLogsAdmin(dataForSysLogs);
                        $state.reload('layout.applicantsMain.applicantsApproval');
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
    }
})();
/**
 * Created by cl-macmini-51 on 22/12/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .controller('VariablePriceListRouteDetailsController', VariablePriceListRouteDetailsController);


      
    /** @ngInject */
    function VariablePriceListRouteDetailsController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document,
                                              moment, getAgreement, $scope, RutHelper, filterFilter, getGeofence, getItemOfCharge, getServices, languageBasedErrorFactory,errorMessageFactory,Initializer) {
        var vm = this;
        var myCenter;
        var zoomLevel = 8;
        var all_overlays = [];
        var coordinates_array = [];
        var markers=[];
        var mapProp={};
        vm.Geocercas = Geocercas;
        vm.GeocercasView = GeocercasView;
        var drawingManager = '';
        var mc=null;
        var map =null;
        var icon = {};
        var bounds;
        var geocoder;
        var infoWindow;
        var location = "";
        var currentId = 0;
        var laArray = [];
        var poly  = '';
        var branchCount = 0;
        var bermudaTriangle;
        var regionsArray = [];
        var uniqueId = function() {
            return ++currentId;
        };
        vm.loading = false;
        vm.currentPage = 0;
        vm.totalVariableRoutePriceList = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.goBack = goBack;
        vm.cancel = cancel;
        vm.getPagesCount = getPagesCount;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;

        // Service To Get Map Instance
        Initializer.mapsInitialized
            .then(function () {
                console.log('>>>> GOOGLE INIT', google);
                if (google) {
                     bounds = new google.maps.LatLngBounds();
                     geocoder = new google.maps.Geocoder();
                     infoWindow = new google.maps.InfoWindow(); 
                     myCenter= new google.maps.LatLng(-33.447487, -70.673676);
                     bermudaTriangle = new google.maps.Polygon();
                } else {
                    alert(languageBasedErrorFactory.getProperErrorMessage('onRoadMessage', 0, '3'));
                }

            });
        vm.init = init;
        vm.getFilter = getFilter;
        vm.sort = sort;
        vm.getVariableRoutePriceList = getVariableRoutePriceList;
        vm.storeDetails = storeDetails;
        vm.paginationNew = paginationNew;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.variableRouteFlag = false;
        vm.routeDisabled = true;
        vm.dataToFill = {
            type_of_service_id: [],
            route_id: '',
            price_list_id: Number($stateParams.priceListId),
            comments: '',
            price: '',
            branch: '',
            branchDetails: '',
            routeDetails: '',
            id: '',
            perKMChanges: '',
            waitTimeCharges: '0',
            waitTimeInTrip: '0',
            baseFare: '0',
            minimumFare: '0',
            time_of_trip_price: '0'

        };
        vm.editVariableRouteDetailsFlag = false;
        vm.predicate = 'index';
        vm.reverse = false;
        $cookies.remove('setData');
        vm.filterData = {
            priceListRouteStatus: '1',
            type_of_service: 'all',
            branch_id: 'all'
        };
        //====================function for dropdown pages and page count===============
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];

        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getVariableRoutePriceList(0, vm.itemsPerPageGot,vm.filterData);
        };
        function paginationNew(page){
            getVariableRoutePriceList((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot,vm.filterData.priceListStatus);
        }
        //=================sort======================
        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };
        //==================get all Vehicles=======================
        function getAllAggrements() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.offset = 0;
            dataSend.limit = 0;
            dataSend.key = 3;
            dataSend.id = $stateParams.contractId;
            vm.loading = true;
            var promise = getAgreement.allAgreementsExpenseControl(dataSend);
            promise.then(
                function(payload) {
                    $log.log('allagree', payload);
                    vm.loading = false;
                    var where = payload.title.data.result;
                    vm.contractName = where[0].name;
                    vm.corporateName = where[0].company_name;
                    vm.agreementType = where[0].agreement_type;
                    vm.agreementStatus = where[0].status;
                    if(where[0].type_of_service){
                        var arrayForTypeOfService = where[0].type_of_service.split(',');
                        vm.agreementServices = arrayForTypeOfService;
                    }
                    if(where[0].region_name){
                        var arrayForRegionName  = where[0].region_name.split(',');
                        vm.agreementBranches = arrayForRegionName;
                    }
                    // vm.agreementServices = where[0].type_of_service;
                    // vm.agreementBranches = where[0].branch;
                    // if(vm.agreementBranches && vm.agreementBranches.length){
                    //     for(var i=0;i<vm.agreementBranches.length;i++){
                    //         vm.agreementBranches[i].region_data = vm.agreementBranches[i].region_data[0];
                    //         vm.agreementBranches[i].strokeColor = '#f18903';
                    //         vm.agreementBranches[i].fillColor = 'transparent';
                    //     }
                    // }
                    vm.serviceList = where[0].type_of_service;
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        getAllAggrements();
        //======================get variable route price list===================
        function getVariableRoutePriceList(skip,limit,filter){
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.price_list_id = $stateParams.priceListId;
            dataSend.limit = Number(limit);
            dataSend.offset = Number(skip);
            dataSend.key = Number(filter.priceListRouteStatus);
            if(filter.branch_id != 'all'){
                dataSend.branch_id = filter.branch_id;
            }
            if(filter.type_of_service != 'all'){
                dataSend.type_of_service = filter.type_of_service;
            }
            var promise = getAgreement.getVariableRoutePriceList(dataSend);
            promise.then(
                function(payload) {
                    $log.log('sxdsads123', payload);
                    vm.loading = false;
                    vm.totalVariableRoutePriceList = payload.title.data.totalCount;
                    vm.dataLength = payload.title.data.totalCount;

                    if (payload.title.data.totalCount == 0) {
                        vm.sp_pagination = false;
                        vm.tBodyFlag = false;
                        vm.tFootFlag = true;
                    } else {
                        vm.sp_pagination = true;
                        vm.tBodyFlag = true;
                        vm.tFootFlag = false;
                    }

                    var dataArray = [];

                    var variableRoutePriceList = payload.title.data.result;
                    variableRoutePriceList.forEach(function(column) {
                        var d = {};
                        d.baseFare = column.baseFare;
                        d.comments = column.comments;
                        d.coverage_area_data = column.coverage_area_data;
                        d.coverage_area_id = column.coverage_area_id;
                        d.id = column.id;
                        d.is_deleted = column.is_deleted;
                        d.minimumFare = column.minimumFare;
                        d.time_of_trip_price = column.time_of_trip_price;
                        d.perKMChanges = column.perKMChanges;
                        d.price = column.price;
                        d.price_list_data = column.price_list_data;
                        d.price_list_id = column.price_list_id;
                        d.status = column.status;
                        d.typeOfService = column.typeOfService;
                        d.waitTimeCharges = column.waitTimeCharges;
                        d.waitTimeInTrip = column.waitTimeInTrip;
                        d.item_of_charge = column.item_of_charge;
                        if(column.item != null){
                            var items  = column.item.split(',');
                            d.itemsCount = items.length;
                        }else{
                            d.itemsCount = 0;
                        }
                        dataArray.push(d);
                    });
                    vm.variableRoutePriceGot = dataArray;

                    for (var i = 0; i < vm.variableRoutePriceGot.length; i++) {
                        vm.variableRoutePriceGot[i].index = (skip + i);
                    }
                    if (vm.dataLength <= vm.itemsPerPageGot) {
                        vm.sp_pagination = false;
                    } else {
                        vm.sp_pagination = true;
                        //vm.pageCount(payload.title.data.totalCount);
                    }
                    vm.skipValue = vm.variableRoutePriceGot[0].index;
                    vm.limitValue = vm.variableRoutePriceGot[vm.variableRoutePriceGot.length - 1].index;

                    $scope.$watch('vm.search', function(newVal, oldVal) {
                        vm.filtered = filterFilter(vm.variableRoutePriceGot, newVal);
                        vm.totalItems = vm.filtered.length;
                        if (vm.filtered.length == 0) {
                            vm.watchPagination = false;
                        } else {
                            vm.watchPagination = true;
                        }
                        if (vm.filterOn == true) {
                            vm.skipValueFilter = vm.filtered.length;
                            vm.sp_pagination = false;
                        }
                    }, true);

                    //range();
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    } else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        vm.getVariableRoutePriceList((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        vm.currentPage++;
        //        vm.getVariableRoutePriceList((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    vm.getVariableRoutePriceList((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //};

        function init() {
            getAllPriceList();
        };
        init();

        function getFilter() {
            vm.filterOn = true;
            if (vm.search.length == 0) {
                vm.filterOn = false;
                vm.watchPagination = true;
                vm.sp_pagination = true;
            }
        };
        //==================get all price list=======================
        function getAllPriceList() {
            vm.loading = true;
            var dataSend = {
                access_token: $cookies.get('obj'),
                contract_id: $stateParams.contractId,
                id: $stateParams.priceListId,
                key:3
            };
            var promise = getAgreement.getPriceListDetailId(dataSend);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.variableRouteListG = payload.title.data;
                    vm.selectedPriceList = Number($stateParams.priceListId);
                    vm.startDate = payload.title.data.date_of_start;
                    vm.endDate = payload.title.data.date_of_end;
                    vm.name = payload.title.data.name;
                    vm.status = payload.title.data.status;
                    getVariableRoutePriceList(0,10,vm.filterData);
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        //===========================get all branches==========================
        function getAllBranches(){
            vm.loading = true;
            var promise = getGeofence.getAllBranchList(2);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if(payload.title.data.length) {
                        var where = _.where(payload.title.data, {parent_id: 0});
                        vm.branchList = where;
                        vm.branchListFilterGot = where;
                        vm.branchListFilterGot.push({
                            region_id:'all',
                            region_name:'All'
                        });
                        for(var i=0;i<vm.branchList.length;i++){
                            vm.branchList[i].strokeColor = '#f18903';
                            vm.branchList[i].fillColor = 'transparent';
                        }
                    }
                    else{
                        vm.branchList = [];
                        languageBasedErrorFactory.getProperErrorMessage('branchReq',0,0);
                        //errorMessageFactory.showErrorMessage('Please add branch first.',0);
                    }
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        getAllBranches();
        //======================get all services==============
        function getAllServices(skip, limit) {
            vm.loading = false;
            var promise = getServices.allServices(skip, limit,2,0);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if(payload.title.status == 400){
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    else if(payload.title.status == 401){
                        errorMessageFactory.showErrorMessage(payload.title.message,2,'home');
                    }
                    else if(payload.title.status == 201 || payload.title.status == 200) {
                        vm.serviceListFilterGot = [];
                        angular.forEach(payload.title.data.result, function (column) {
                            vm.serviceListFilterGot.push({id: column.id, name: column.service_name});
                        });
                        vm.serviceListFilterGot.push({
                            id: 'all',
                            name: 'All'
                        })
                    }
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllServices(0, 0);



        function GeocercasView(data , $event){
            vm.contract_variable_pricing_id = data.id;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.region_id = data.coverage_area_data.region_id;
            dataSend.contract_variable_pricing_id = data.id;
            // loading = true;
            var promise = getItemOfCharge.geofenceForParticularAgreemnt(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        vm.geofance_data = payload.title.data.geofance_data;
                        vm.geofance_data_in = payload.title.data.geofance_data_in;
                        openPopUpGeoFenceView(vm.geofance_data, $event, vm.geofance_data_in)
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function openPopUpGeoFenceView(data_out, $event, data_in){
            vm.items = {
                geofance_data: data_out != null ? data_out : [],
                geofance_data_in: data_in != null ? data_in : []
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/enableDisableGeoFenceVeiw.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });

            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.rightSideArray = [];
                $scope.leftSideArray = [];
                $scope.sendArrayRight = [];
                $scope.sendArrayLeft = [];
                var indexcheck = -1;
                var rightIndex = -1;
                var indexSend = -1;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };

            }
        }
        function Geocercas(data, $event) {
            vm.contract_variable_pricing_id = data.id;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.region_id = data.coverage_area_data.region_id;
            dataSend.contract_variable_pricing_id = data.id;
            // loading = true;
            var promise = getItemOfCharge.geofenceForParticularAgreemnt(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        vm.geofance_data = payload.title.data.geofance_data;
                        vm.geofance_data_in = payload.title.data.geofance_data_in;
                        openPopUpGeoFence(vm.geofance_data, $event, vm.geofance_data_in)
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function openPopUpGeoFence(data_out, $event, data_in) {
            vm.items = {
                geofance_data: data_out != null ? data_out : [],
                geofance_data_in: data_in != null ? data_in : []
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/enableDisableGeoFence.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });

            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.rightSideArray = [];
                $scope.leftSideArray = [];
                $scope.sendArrayRight = [];
                $scope.sendArrayLeft = [];
                var indexcheck = -1;
                var rightIndex = -1;
                var indexSend = -1;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    var dataSend = {};
                    // vm.loading = true;
                    if ($scope.sendArrayRight.length == 0 && $scope.sendArrayLeft.length == 0) {
                        return;
                    }
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.remove_array = $scope.sendArrayRight;
                    // dataSend.add_array = $scope.sendArrayLeft;
                    if(data_in == null){
                        var sendArray = [];
                        $scope.items.geofance_data_in.forEach(function (data){
                            sendArray.push({
                                contract_variable_pricing_id: vm.contract_variable_pricing_id,
                                regions_id: data.region_id
                            })
                        })
                        dataSend.add_array = sendArray;
                    }else{
                        dataSend.add_array = $scope.sendArrayLeft;
                    }
                    var promise = getItemOfCharge.addGeofenceForParticularVariable(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log(payload);
                            vm.loading = false;
                            if (payload.title.status == 200) {
                                $mdDialog.hide();
                                getVariableRoutePriceList(0, 10, vm.filterData);
                            } else {
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            }

                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );

                };
                $scope.checkData = function (data, index) {
                    data.index = index;
                    $scope.rightSideArray.push(data);
                }
                $scope.checkDataIn = function (data, index) {
                    data.index = index;
                    $scope.leftSideArray.push(data);
                }
                $scope.rightSide = function () {
                    $scope.rightSideArray.sort(function (x, y) {
                        return x.index > y.index ? 1 : -1;
                    });
                    var rightSideArrayNew = data_out;
                    $scope.rightSideArray.forEach(function (rightData, index) {
                        indexcheck = _.findIndex($scope.items.geofance_data_in, { // function to check weather the value alerady in destination section then return this 
                            region_id: rightData.region_id
                        });
                        if (indexcheck == -1) {
                            if (rightData.checked == true) {
                                $scope.items.geofance_data_in.push({
                                    region_name: rightData.region_name,
                                    branch_name: rightData.branch_name,
                                    region_id: rightData.region_id,
                                    isAirportService: rightData.isAirportService
                                });
                                rightSideArrayNew.splice(rightData.index - index, 1);
                                vm.items.geofance_data = rightSideArrayNew;
                                $scope.sendArrayLeft.push({
                                    contract_variable_pricing_id: vm.contract_variable_pricing_id,
                                    regions_id: rightData.region_id
                                });
                            }
                        }
                    });
                    $scope.rightSideArray = [];
                }
                $scope.leftSide = function () {
                    $scope.leftSideArray.sort(function (x, y) {
                        return x.index > y.index ? 1 : -1;
                    });
                    var leftSideArrayNew = $scope.items.geofance_data_in;
                    $scope.leftSideArray.forEach(function (leftData, index) {
                        rightIndex = _.findIndex($scope.items.geofance_data, { // function to check weather the value alerady in destination section then return this 
                            region_id: leftData.region_id
                        });
                        if (rightIndex == -1) {
                            if (leftData.checkedLeft == true) {
                                $scope.items.geofance_data.push({
                                    region_name: leftData.region_name,
                                    branch_name: leftData.branch_name,
                                    region_id: leftData.region_id,
                                    isAirportService: leftData.isAirportService
                                });
                                leftSideArrayNew.splice(leftData.index - index, 1);
                                $scope.items.geofance_data_in = leftSideArrayNew;
                                $scope.sendArrayRight.push(leftData.variable_pricing_geofence_id);
                            }
                        }

                    });
                    console.log($scope.rightSideArray,'$scope.leftSideArray');
                    
                    if($scope.rightSideArray.length == 0){
                        $scope.sendArrayLeft = [];
                    }
                    $scope.leftSideArray = [];
                }
            }
        }

        //====================event for getting refreshed================
        $scope.$on('StateReload', function(evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.agreementMain.variablePriceListRouteDetails');
            }
        });
        //=================go back================
        function goBack() {
            if($stateParams.path == '0'){
                $state.go('layout.agreementMain.priceListFixedAgreement',{corporateId:$stateParams.corporateId,contractId:$stateParams.contractId,path:1});
            }
            else{
                $state.go('layout.agreementMain.priceListVariableAgreement',{corporateId:$stateParams.corporateId,contractId:$stateParams.contractId,path:2});
            }
        };
        function cancel(){
            $state.reload('layout.agreementMain.variablePriceListRouteDetails');
        };
        //===================store details======================
        function storeDetails(){
            var data = {
                corporateId: $stateParams.corporateId,
                contractId: $stateParams.contractId,
                priceListId: $stateParams.priceListId,
                path: $stateParams.path
            };
            $cookies.put('setData',JSON.stringify(data));
        }
    }
})();
/**
 * Created by cl-macmini-51 on 22/12/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('VariablePriceListRouteController', VariablePriceListRouteController);

    /** @ngInject */
    function VariablePriceListRouteController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document,
        moment, getAgreement, $scope, RutHelper, filterFilter, getGeofence, getItemOfCharge, getServices, languageBasedErrorFactory, errorMessageFactory, Initializer) {
        var vm = this;
        var myCenter;
        var zoomLevel = 8;
        var all_overlays = [];
        var coordinates_array = [];
        var markers = [];
        vm.Geocercas = Geocercas;
        var mapProp = {};
        var drawingManager = '';
        var mc = null;
        var map = null;
        var icon = {};
        var bounds;
        var geocoder;
        var infowindow;
        var location = "";
        var currentId = 0;
        var laArray = [];
        var poly = '';
        var branchCount = 0;
        var bermudaTriangle;
        var regionsArray = [];
        var uniqueId = function () {
            return ++currentId;
        };
        Initializer.mapsInitialized
            .then(function () {
                console.log('>>>> GOOGLE INIT', google);
                if (google) {
                    myCenter = new google.maps.LatLng(-33.447487, -70.673676);
                    bounds = new google.maps.LatLngBounds();
                    geocoder = new google.maps.Geocoder();
                    infowindow = new google.maps.InfoWindow();
                    bermudaTriangle = new google.maps.Polygon();

                } else {
                    alert(languageBasedErrorFactory.getProperErrorMessage('onRoadMessage', 0, '3'));
                }

            });
        vm.loading = false;
        vm.currentPage = 0;
        vm.totalVariableRoutePriceList = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.goBack = goBack;
        vm.cancel = cancel;
        vm.getPagesCount = getPagesCount;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.init = init;
        vm.getFilter = getFilter;
        vm.addMoreRoutes = addMoreRoutes;
        vm.sort = sort;
        vm.branchChanged = branchChanged;
        vm.addVariableRouteHit = addVariableRouteHit;
        vm.getVariableRoutePriceList = getVariableRoutePriceList;
        vm.addItemOfCharge = addItemOfCharge;
        vm.getAllItemOfCharges = getAllItemOfCharges;
        vm.addItemOfChargeVariableHit = addItemOfChargeVariableHit;
        vm.changePriceListRouteStatus = changePriceListRouteStatus;
        vm.selectedRouteFromList = selectedRouteFromList;
        vm.deleteRouteAndBranch = deleteRouteAndBranch;
        vm.editRouteBranchDetails = editRouteBranchDetails;
        vm.editVariableRouteDetailsHit = editVariableRouteDetailsHit;
        vm.deleteItemOfCharge = deleteItemOfCharge;
        vm.storeDetails = storeDetails;
        vm.paginationNew = paginationNew;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.variableRouteFlag = false;
        vm.routeDisabled = true;
        vm.dataToFill = {
            type_of_service_id: [],
            route_id: '',
            price_list_id: Number($stateParams.priceListId),
            comments: '',
            price: '',
            branch: '',
            branchDetails: '',
            routeDetails: '',
            id: '',
            perKMChanges: '',
            waitTimeCharges: '0',
            waitTimeInTrip: '0',
            baseFare: '0',
            minimumFare: '0',
            time_of_trip_price: '0'

        };
        vm.editVariableRouteDetailsFlag = false;
        vm.predicate = 'index';
        vm.reverse = false;
        $cookies.remove('setData');
        vm.filterData = {
            priceListRouteStatus: '1',
            type_of_service: 'all',
            branch_id: 'all'
        };
        //====================function for dropdown pages and page count===============
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];

        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getVariableRoutePriceList(0, vm.itemsPerPageGot, vm.filterData);
        };

        function paginationNew(page) {
            getVariableRoutePriceList((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData);
        }
        //=================sort======================
        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };
        //==================get all Vehicles=======================
        function getAllAggrements() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.offset = 0;
            dataSend.limit = 0;
            dataSend.key = 3;
            dataSend.id = $stateParams.contractId;
            vm.loading = true;
            var promise = getAgreement.allAgreements(dataSend);
            promise.then(
                function (payload) {
                    $log.log('allagree', payload);
                    vm.loading = false;
                    var where = payload.title.data.result;
                    vm.contractName = where[0].name;
                    vm.corporateName = where[0].corporate_id.company_name;
                    vm.agreementType = where[0].agreement_type;
                    vm.agreementStatus = where[0].status;
                    // if(where[0].type_of_service){
                    //     var arrayForTypeOfService = where[0].type_of_service.split(',');
                    //     vm.agreementServices = arrayForTypeOfService;
                    // }
                    // if(where[0].region_name){
                    //     var arrayForRegionName  = where[0].region_name.split(',');
                    //     vm.agreementBranches = arrayForRegionName;
                    // }
                    vm.agreementServices = where[0].type_of_service;
                    vm.agreementBranches = where[0].branch;
                    if(vm.agreementBranches && vm.agreementBranches.length){
                        for(var i=0;i<vm.agreementBranches.length;i++){
                            vm.agreementBranches[i].region_data = vm.agreementBranches[i].region_data[0];
                            vm.agreementBranches[i].strokeColor = '#f18903';
                            vm.agreementBranches[i].fillColor = 'transparent';
                        }
                    }
                    vm.serviceList = where[0].type_of_service;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllAggrements();
        //======================get variable route price list===================
        function getVariableRoutePriceList(skip, limit, filter) {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.price_list_id = $stateParams.priceListId;
            dataSend.limit = Number(limit);
            dataSend.offset = Number(skip);
            dataSend.key = Number(filter.priceListRouteStatus);
            if (filter.branch_id != 'all') {
                dataSend.branch_id = filter.branch_id;
            }
            if (filter.type_of_service != 'all') {
                dataSend.type_of_service = filter.type_of_service;
            }
            var promise = getAgreement.getVariableRoutePriceList(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads123', payload);
                    vm.loading = false;
                    vm.totalVariableRoutePriceList = payload.title.data.totalCount;
                    vm.dataLength = payload.title.data.totalCount;

                    if (payload.title.data.totalCount == 0) {
                        vm.sp_pagination = false;
                        vm.tBodyFlag = false;
                        vm.tFootFlag = true;
                    } else {
                        vm.sp_pagination = true;
                        vm.tBodyFlag = true;
                        vm.tFootFlag = false;
                    }

                    var dataArray = [];

                    var variableRoutePriceList = payload.title.data.result;
                    variableRoutePriceList.forEach(function (column) {
                        var d = {};
                        d.baseFare = column.baseFare;
                        d.comments = column.comments;
                        d.coverage_area_data = column.coverage_area_data;
                        d.coverage_area_id = column.coverage_area_id;
                        d.id = column.id;
                        d.is_deleted = column.is_deleted;
                        d.minimumFare = column.minimumFare;
                        d.time_of_trip_price = column.time_of_trip_price;
                        d.perKMChanges = column.perKMChanges;
                        d.price = column.price;
                        d.price_list_data = column.price_list_data;
                        d.price_list_id = column.price_list_id;
                        d.status = column.status;
                        d.typeOfService = column.typeOfService;
                        d.waitTimeCharges = column.waitTimeCharges;
                        d.waitTimeInTrip = column.waitTimeInTrip;
                        d.item_of_charge = column.item_of_charge;
                        if(column.item != null){
                            var items  = column.item.split(',');
                            d.itemsCount = items.length;
                        }else{
                            d.itemsCount = 0;
                        }
                        dataArray.push(d);
                    });
                    vm.variableRoutePriceGot = dataArray;
                 
                    for (var i = 0; i < vm.variableRoutePriceGot.length; i++) {
                        vm.variableRoutePriceGot[i].index = (skip + i);
                    }
                    if (vm.dataLength <= vm.itemsPerPageGot) {
                        vm.sp_pagination = false;
                    } else {
                        vm.sp_pagination = true;
                        //vm.pageCount(payload.title.data.totalCount);
                    }
                    vm.skipValue = vm.variableRoutePriceGot[0].index;
                    vm.limitValue = vm.variableRoutePriceGot[vm.variableRoutePriceGot.length - 1].index;

                    $scope.$watch('vm.search', function (newVal, oldVal) {
                        vm.filtered = filterFilter(vm.variableRoutePriceGot, newVal);
                        vm.totalItems = vm.filtered.length;
                        if (vm.filtered.length == 0) {
                            vm.watchPagination = false;
                        } else {
                            vm.watchPagination = true;
                        }
                        if (vm.filterOn == true) {
                            vm.skipValueFilter = vm.filtered.length;
                            vm.sp_pagination = false;
                        }
                    }, true);
                    listOfEnableGeofence(payload.title.data.result);
                    //range();
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };


        function listOfEnableGeofence(data){
            console.log(data,'data',data.coverage_area_data);
            
            // vm.contract_variable_pricing_id = data.id;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.region_id = data[0].coverage_area_data.region_id;
            dataSend.contract_variable_pricing_id = data[0].id;
            // loading = true;
            var promise = getItemOfCharge.geofenceForParticularAgreemnt(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        // vm.geofance_data = payload.title.data.geofance_data;
                        vm.enableGeofence = payload.title.data.geofance_data_in;
                        // console.log(vm.enableGeofence);
                        // $state.reload();
                        // openPopUpGeoFence(vm.geofance_data, $event, vm.geofance_data_in)
                    } else {
                        // errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    } else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        vm.getVariableRoutePriceList((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        vm.currentPage++;
        //        vm.getVariableRoutePriceList((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    vm.getVariableRoutePriceList((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //};

        function init() {
            getAllPriceList();
        };
        init();

        function getFilter() {
            vm.filterOn = true;
            if (vm.search.length == 0) {
                vm.filterOn = false;
                vm.watchPagination = true;
                vm.sp_pagination = true;
            }
        };
        //==================get all price list=======================
        function getAllPriceList() {
            vm.loading = true;
            var dataSend = {
                access_token: $cookies.get('obj'),
                contract_id: $stateParams.contractId,
                id: $stateParams.priceListId,
                key: 3
            };
            var promise = getAgreement.getPriceListDetailId(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.variableRouteListG = payload.title.data;
                    vm.selectedPriceList = Number($stateParams.priceListId);
                    vm.startDate = payload.title.data.date_of_start;
                    vm.endDate = payload.title.data.date_of_end;
                    vm.name = payload.title.data.name;
                    vm.status = payload.title.data.status;
                    getVariableRoutePriceList(0, 10, vm.filterData);
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //===========================get all branches==========================
        function getAllBranches() {
            vm.loading = true;
            var promise = getGeofence.getAllBranchList(2);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.data.length) {
                        var where = _.where(payload.title.data, {
                            parent_id: 0
                        });
                        vm.branchList = where;
                        vm.branchListFilterGot = where;
                        vm.branchListFilterGot.push({
                            region_id: 'all',
                            region_name: 'All'
                        });
                        for (var i = 0; i < vm.branchList.length; i++) {
                            vm.branchList[i].strokeColor = '#f18903';
                            vm.branchList[i].fillColor = 'transparent';
                        }
                    } else {
                        vm.branchList = [];
                        languageBasedErrorFactory.getProperErrorMessage('branchReq', 0, 0);
                        //errorMessageFactory.showErrorMessage('Please add branch first.',0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllBranches();

        //==========================branch selected==========================
        function branchChanged(type) {
            //var dataSend = {};
            //dataSend.offset = 0;
            //dataSend.limit = 0;
            //dataSend.key = 2;
            //dataSend.search_filter = 0;
            //dataSend.branch_id = Number(vm.dataToFill.branch);
            //dataSend.access_token = $cookies.get('obj');
            //
            //vm.loading = true;
            //var promise = getGeofence.getAllFixedRoute(dataSend);
            //promise.then(
            //    function (payload) {
            //        $log.log('sxdsads', payload);
            //        vm.loading = false;
            //        vm.routeList = [];
            //        for(var i=0;i<payload.title.data.result.length;i++){
            //            if(payload.title.data.result[i].status == 1){
            //                vm.routeList.push(payload.title.data.result[i]);
            //            }
            //        }
            //
            //        if(vm.routeList.length){
            //            for(var i=0;i<vm.routeList.length;i++){
            //                vm.routeList[i].strokeColor = '#063c4a';
            //                vm.routeList[i].fillColor = '#063c4a';
            //            }
            //            vm.routeDisabled = false;
            //        }
            //        else{
            //            vm.routeDisabled = true;
            //            languageBasedErrorFactory.getProperErrorMessage('branchRouteNo',0,0);
            //            //errorMessageFactory.showErrorMessage('This branch does not have any route.',0);
            //        }
            //    },
            //    function (errorPayload) {
            //        vm.loading = false;
            //        if(errorPayload.data.status == 401){
            //            errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
            //        }
            //        else{
            //            errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
            //        }
            //    });
        };
        //=======================route selected===========================
        function selectedRouteFromList(type) {
            if (vm.dataToFill.routeDetails || vm.dataToFill.route_id) {
                if (type) {
                    vm.dataToFill.routeDetails = _.where(vm.routeList, {
                        id: Number(vm.dataToFill.route_id)
                    })[0];
                }
                if (regionsArray && regionsArray.length) {
                    setMapOnAll(null, 0);
                }
                vm.dataToFill.route_id = vm.dataToFill.routeDetails.id;
                var dataPick = {
                    fillColor: "#063c4a",
                    name: vm.dataToFill.routeDetails.location1.region_name,
                    id: vm.dataToFill.routeDetails.id,
                    strokeColor: "#063c4a",
                    region_data: vm.dataToFill.routeDetails.location1.region_data[0]
                };
                drawingFunctions(map, dataPick);
                var dataDrop = {
                    fillColor: "#063c4a",
                    name: vm.dataToFill.routeDetails.location2.region_name,
                    id: vm.dataToFill.routeDetails.id,
                    strokeColor: "#063c4a",
                    region_data: vm.dataToFill.routeDetails.location2.region_data[0]
                };
                drawingFunctions(map, dataDrop);
            }
        };
        //========================add more routes flag ==================================
        function addMoreRoutes(type) {
            vm.dataToFill = {
                type_of_service_id: [],
                route_id: '',
                price_list_id: Number($stateParams.priceListId),
                comments: '',
                price: '',
                branch: '',
                branchDetails: '',
                routeDetails: '',
                id: ''
            };
            vm.editVariableRouteDetailsFlag = false;
            vm.variableRouteFlag = true;
        };

        function addVariableRouteHit() {

            //if(Number(vm.dataToFill.perKMChanges) == 0){
            //    languageBasedErrorFactory.getProperErrorMessage('kmFareErr',0,0);
            //    //errorMessageFactory.showErrorMessage('Per KM fare can not be 0.',0);
            //    return;
            //}

            if (Number(vm.dataToFill.minimumFare) < Number(vm.dataToFill.baseFare)) {
                languageBasedErrorFactory.getProperErrorMessage('baseFareErr', 0, 0);
                //errorMessageFactory.showErrorMessage('Base fare can not be greater than minimal fare.',0);
                return;
            }
            var dataSend = {};
            dataSend.contract_id = $stateParams.contractId;
            dataSend.access_token = $cookies.get('obj');

            dataSend.variable_pricing = [];

            dataSend.variable_pricing.push({
                type_of_service_id: vm.dataToFill.type_of_service_id,
                coverage_area_id: vm.dataToFill.branch,
                price_list_id: vm.dataToFill.price_list_id,
                comments: vm.dataToFill.comments,
                //price:  vm.dataToFill.price
                baseFare: vm.dataToFill.baseFare ? Number(vm.dataToFill.baseFare) : 0,
                perKMChanges: vm.dataToFill.perKMChanges ? Number(vm.dataToFill.perKMChanges) : 0,
                waitTimeCharges: vm.dataToFill.waitTimeCharges ? Number(vm.dataToFill.waitTimeCharges) : 0,
                waitTimeInTrip: vm.dataToFill.waitTimeInTrip ? Number(vm.dataToFill.waitTimeInTrip) : 0,
                minimumFare: vm.dataToFill.minimumFare ? Number(vm.dataToFill.minimumFare) : 0,
                time_of_trip_price: vm.dataToFill.time_of_trip_price ? Number(vm.dataToFill.time_of_trip_price) : 0,
            });


            vm.loading = true;
            var promise = getAgreement.addPriceListRouteVariable(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    languageBasedErrorFactory.getProperErrorMessage('variableRouteSucc', 0, 1, 'layout.agreementMain.variablePriceListRoute');
                    //errorMessageFactory.showErrorMessage('Price for variable route added successfully.',1);
                    //$timeout(function() {
                    //    $mdDialog.hide();
                    //    $state.reload();
                    //}, 2000);
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        //===========================get all itemof charges==========================
        function getAllItemOfCharges() {
            vm.loading = true;
            var promise = getItemOfCharge.getItemOfChargePagination(0, 0, 2);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.data.result.length) {
                        var where = _.where(payload.title.data.result, {
                            state: 1
                        });
                        vm.itemOfChargeList = where;
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllItemOfCharges();
        //========================function to add item of charge============================
        function addItemOfCharge(data, $event, type) {
            if (vm.itemOfChargeList && vm.itemOfChargeList.length == 0) {
                vm.itemOfChargeList = [];
                languageBasedErrorFactory.getProperErrorMessage('itemErr', 0, 0);
                //errorMessageFactory.showErrorMessage('Please add items of charge first.');
                return;
            }
            vm.finalGotItemOfCharges = [];
            if (type) {
                vm.finalGotItemOfCharges = vm.itemOfChargeList.reduce(function (prev, value) {
                    var isDuplicate = false;
                    if (data.item_of_charge && data.item_of_charge.length) {
                        for (var i = 0; i < data.item_of_charge.length; i++) {
                            if (value.id == data.item_of_charge[i].id) {
                                isDuplicate = true;
                                break;
                            }
                        }
                        if (!isDuplicate) {
                            prev.push(value);
                        }

                        return prev;
                    } else {
                        prev.push(value);
                        return prev;
                    }
                }, []);
            } else {
                vm.finalGotItemOfCharges = vm.itemOfChargeList.reduce(function (prev, value) {
                    var isDuplicate = false;
                    if (data.item_of_charge && data.item_of_charge.length) {
                        for (var i = 0; i < data.item_of_charge.length; i++) {
                            if (value.id == data.item_of_charge[i].id) {
                                isDuplicate = true;
                                break;
                            }
                        }
                        if (!isDuplicate) {
                            prev.push(value);
                        }

                        return prev;
                    } else {
                        prev.push(value);
                        return prev;
                    }
                }, []);
            }

            if (vm.finalGotItemOfCharges && vm.finalGotItemOfCharges.length == 0) {
                vm.finalGotItemOfCharges = [];
                languageBasedErrorFactory.getProperErrorMessage('itemErr', 0, 0);
                //errorMessageFactory.showErrorMessage('Please add items of charge first.');
                return;
            }
            vm.items = {
                priceListId: data.id,
                allItemsOfCharges: vm.finalGotItemOfCharges,
                selectedItem: '',
                price: '0',
                toll:'',
                disablePrice: true,
                showPrice: true
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/addItemOfChargeInPrice.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });

            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    $mdDialog.hide();
                    addItemOfChargeVariableHit(vm.items);
                };

                $scope.checkItem = function (data) {
                    $scope.checkItemOfChargeCallCenter = _.where($scope.items.allItemsOfCharges, {
                        id: data
                    });
                    if ($scope.checkItemOfChargeCallCenter[0].manually) {
                        $scope.items.disablePrice = false;
                        $scope.items.showPrice = true;
                    } else if ($scope.checkItemOfChargeCallCenter[0].manually == 0 && $scope.checkItemOfChargeCallCenter[0].mode == 1) {
                        $scope.items.disablePrice = false;
                        $scope.items.showPrice = true;
                    } else {
                        $scope.items.disablePrice = true;
                        $scope.items.showPrice = false;
                    }
                }
            }
        };


        function Geocercas(data, $event) {
            vm.contract_variable_pricing_id = data.id;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.region_id = data.coverage_area_data.region_id;
            dataSend.contract_variable_pricing_id = data.id;
            // loading = true;
            var promise = getItemOfCharge.geofenceForParticularAgreemnt(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        vm.geofance_data = payload.title.data.geofance_data;
                        vm.geofance_data_in = payload.title.data.geofance_data_in;
                        openPopUpGeoFence(vm.geofance_data, $event, vm.geofance_data_in)
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }


        function openPopUpGeoFence(data_out, $event, data_in) {
            vm.items = {
                geofance_data: data_out != null ? data_out : [],
                geofance_data_in: data_in != null ? data_in : []
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/enableDisableGeoFence.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });

            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.rightSideArray = [];
                $scope.leftSideArray = [];
                $scope.sendArrayRight = [];
                $scope.sendArrayLeft = [];
                var indexcheck = -1;
                var rightIndex = -1;
                var indexSend = -1;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    var dataSend = {};
                    // vm.loading = true;
                    if ($scope.sendArrayRight.length == 0 && $scope.sendArrayLeft.length == 0) {
                        return;
                    }
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.remove_array = $scope.sendArrayRight;
                    // dataSend.add_array = $scope.sendArrayLeft;
                    if(data_in == null){
                        var sendArray = [];
                        $scope.items.geofance_data_in.forEach(function (data){
                            sendArray.push({
                                contract_variable_pricing_id: vm.contract_variable_pricing_id,
                                regions_id: data.region_id
                            })
                        })
                        dataSend.add_array = sendArray;
                    }else{
                        dataSend.add_array = $scope.sendArrayLeft;
                    }
                    var promise = getItemOfCharge.addGeofenceForParticularVariable(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log(payload);
                            vm.loading = false;
                            if (payload.title.status == 200) {
                                $mdDialog.hide();
                                getVariableRoutePriceList(0, 10, vm.filterData);
                            } else {
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            }

                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );

                };
                $scope.checkData = function (data, index) {
                    data.index = index;
                    $scope.rightSideArray.push(data);
                }
                $scope.checkDataIn = function (data, index) {
                    data.index = index;
                    $scope.leftSideArray.push(data);
                }
                $scope.rightSide = function () {
                    $scope.rightSideArray.sort(function (x, y) {
                        return x.index > y.index ? 1 : -1;
                    });
                    var rightSideArrayNew = data_out;
                    $scope.rightSideArray.forEach(function (rightData, index) {
                        indexcheck = _.findIndex($scope.items.geofance_data_in, { // function to check weather the value alerady in destination section then return this 
                            region_id: rightData.region_id
                        });
                        if (indexcheck == -1) {
                            if (rightData.checked == true) {
                                $scope.items.geofance_data_in.push({
                                    region_name: rightData.region_name,
                                    branch_name: rightData.branch_name,
                                    region_id: rightData.region_id,
                                    isAirportService: rightData.isAirportService
                                });
                                rightSideArrayNew.splice(rightData.index - index, 1);
                                vm.items.geofance_data = rightSideArrayNew;
                                $scope.sendArrayLeft.push({
                                    contract_variable_pricing_id: vm.contract_variable_pricing_id,
                                    regions_id: rightData.region_id
                                });
                            }
                        }
                    });
                    $scope.rightSideArray = [];
                }
                $scope.leftSide = function () {
                    $scope.leftSideArray.sort(function (x, y) {
                        return x.index > y.index ? 1 : -1;
                    });
                    var leftSideArrayNew = $scope.items.geofance_data_in;
                    $scope.leftSideArray.forEach(function (leftData, index) {
                        rightIndex = _.findIndex($scope.items.geofance_data, { // function to check weather the value alerady in destination section then return this 
                            region_id: leftData.region_id
                        });
                        if (rightIndex == -1) {
                            if (leftData.checkedLeft == true) {
                                $scope.items.geofance_data.push({
                                    region_name: leftData.region_name,
                                    branch_name: leftData.branch_name,
                                    region_id: leftData.region_id,
                                    isAirportService: leftData.isAirportService
                                });
                                leftSideArrayNew.splice(leftData.index - index, 1);
                                $scope.items.geofance_data_in = leftSideArrayNew;
                                $scope.sendArrayRight.push(leftData.variable_pricing_geofence_id);
                            }
                        }

                    });
                    console.log($scope.rightSideArray,'$scope.leftSideArray');
                    
                    if($scope.rightSideArray.length == 0){
                        $scope.sendArrayLeft = [];
                    }
                    $scope.leftSideArray = [];
                }
            }
        }

        //=================item of charge for variable============================
        function addItemOfChargeVariableHit(data) {
            $log.log(data);

            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.transvip_contract_variable_pricing_id = data.priceListId;
            dataSend.item_charge_id = data.selectedItem;
            if(data.selectedItem == 2){
                dataSend.toll_charge_way = data.toll;
                if(data.toll != "2"){
                    dataSend.price = data.price ? data.price : 0;
                }
            }else{
                dataSend.price = data.price ? data.price : 0;
            }

            vm.loading = true;
            var promise = getItemOfCharge.addVariableItemOfCharge(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    var dataForSysLogs = {
                        access_token: $cookies.get('obj'),
                        id: data.priceListId,
                        identity: 8,
                        message: 'Variable route item of charge added.'
                    };
                    $rootScope.systemLogsAdmin(dataForSysLogs);
                    languageBasedErrorFactory.getProperErrorMessage('itemSucc', 0, 1, 'layout.agreementMain.variablePriceListRoute');
                    //errorMessageFactory.showErrorMessage('Item of charge added successfully.',1);
                    //$timeout(function() {
                    //    $mdDialog.hide();
                    //    $state.reload();
                    //}, 2000);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        //===========================change price list status=========================
        function changePriceListRouteStatus(data, $event) {
            $log.log(data);

            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('priceRouteStatusPop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed', data);
                if (data.status == 0 || data.status == '0') {
                    var a = 1;
                } else if (data.status == 1 || data.status == '1') {
                    var a = 0;
                }
                var dataSend = {};
                dataSend.fixed_route_id = data.id;
                dataSend.access_token = $cookies.get('obj');
                dataSend.status = a;
                dataSend.type_of_service = [];
                //errorMessageFactory.showErrorMessage('Functionality is pending.',0);
                vm.loading = true;
                var promise = getAgreement.editAgreementVariableRoutePriceList(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        var dataForSysLogs = {
                            access_token: $cookies.get('obj'),
                            id: data.id,
                            identity: 8,
                            message: 'Variable route status edited.'
                        };
                        $rootScope.systemLogsAdmin(dataForSysLogs);
                        $state.reload('layout.agreementMain.variablePriceListRoute');
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );

            }, function () {
                $log.log('not confirmed');
            });
        };
        //=====================to delete route and branch====================
        function deleteRouteAndBranch($event, data) {

            var msg = languageBasedErrorFactory.getProperErrorMessage('deleteVariableRoutePop', 0, '3');

            var confirm = $mdDialog.confirm()
                .title(msg)
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                errorMessageFactory.showErrorMessage('Functionality is pending.', 0);
                //vm.loading = true;
                //var promise = getDrivers.deleteUser(id);
                //promise.then(
                //    function(payload) {
                //        $log.log(payload);
                //        vm.loading = false;
                //        errorMessageFactory.showErrorMessage('Route deleted successfully.',1);
                //    },
                //    function(errorPayload) {
                //        $log.log(errorPayload);
                //        vm.loading = false;
                //        if(errorPayload.data.status == 401){
                //            errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                //        }
                //        else{
                //            errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                //        }
                //    }
                //);
            }, function () {
                $log.log('not confirmed');
            });
        };


        //==========================edit details of route=====================================
        function editRouteBranchDetails(data) {
            vm.variableRouteFlag = false;
            vm.editVariableRouteDetailsFlag = true;
            vm.dataToFill.comments = data.comments;
            //vm.dataToFill.price = data.price;
            vm.dataToFill.id = data.id;
            vm.dataToFill.baseFare = data.baseFare;
            vm.dataToFill.perKMChanges = data.perKMChanges;
            vm.dataToFill.waitTimeCharges = data.waitTimeCharges;
            vm.dataToFill.waitTimeInTrip = data.waitTimeInTrip;
            vm.dataToFill.minimumFare = data.minimumFare;
            vm.dataToFill.time_of_trip_price = data.time_of_trip_price;
            vm.dataToFill.type_of_service_id = [];
            if (data.typeOfService && data.typeOfService.length) {
                for (var i = 0; i < data.typeOfService.length; i++) {
                    vm.dataToFill.type_of_service_id.push(data.typeOfService[i].id);
                }
            } else {
                vm.dataToFill.type_of_service_id = [];
            }
            vm.dataToFill.branch = data.coverage_area_data.region_id;
            branchChanged('1');
        };

        function editVariableRouteDetailsHit() {
            //errorMessageFactory.showErrorMessage('Functionality is pending.',0);
            $log.log(vm.dataToFill);
            //if(Number(vm.dataToFill.perKMChanges) == 0){
            //    languageBasedErrorFactory.getProperErrorMessage('kmFareErr',0,0);
            //    //errorMessageFactory.showErrorMessage('Per KM fare can not be 0.',0);
            //    return;
            //}

            if (Number(vm.dataToFill.minimumFare) < Number(vm.dataToFill.baseFare)) {
                languageBasedErrorFactory.getProperErrorMessage('baseFareErr', 0, 0);
                //errorMessageFactory.showErrorMessage('Base fare can not be greater than minimal fare.',0);
                return;
            }
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.fixed_route_id = vm.dataToFill.id;
            dataSend.type_of_service = vm.dataToFill.type_of_service_id;
            dataSend.comments = vm.dataToFill.comments;
            dataSend.coverage_area_id = vm.dataToFill.branch;
            //dataSend.price = vm.dataToFill.price;
            dataSend.fixed_pricing_id = vm.dataToFill.price_list_id;
            dataSend.baseFare = vm.dataToFill.baseFare ? Number(vm.dataToFill.baseFare) : 0;
            dataSend.perKMChanges = vm.dataToFill.perKMChanges ? Number(vm.dataToFill.perKMChanges) : 0;
            dataSend.waitTimeCharges = vm.dataToFill.waitTimeCharges ? Number(vm.dataToFill.waitTimeCharges) : 0;
            dataSend.waitTimeInTrip = vm.dataToFill.waitTimeInTrip ? Number(vm.dataToFill.waitTimeInTrip) : 0;
            dataSend.minimumFare = vm.dataToFill.minimumFare ? Number(vm.dataToFill.minimumFare) : 0;
            dataSend.time_of_trip_price = vm.dataToFill.time_of_trip_price ? Number(vm.dataToFill.time_of_trip_price) : 0;

            vm.loading = true;
            var promise = getAgreement.editAgreementVariableRoutePriceList(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    var dataForSysLogs = {
                        access_token: $cookies.get('obj'),
                        id: vm.dataToFill.id,
                        identity: 8,
                        message: 'Variable route edited.'
                    };
                    $rootScope.systemLogsAdmin(dataForSysLogs);
                    languageBasedErrorFactory.getProperErrorMessage('routeUpdatedSuccV', 0, 1, 'layout.agreementMain.variablePriceListRoute');
                    //errorMessageFactory.showErrorMessage('Variable route price updated successfully.',1);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );

        };

        //=====================to delete item of charge====================
        function deleteItemOfCharge($event, data, item) {

            var msg = languageBasedErrorFactory.getProperErrorMessage('deleteItemPop', 0, '3');

            var confirm = $mdDialog.confirm()
                .title(msg)
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed', data, item);
                //errorMessageFactory.showErrorMessage('Functionality is pending.',0);

                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.item_of_charge_variable_id = item.item_of_charge_variable_id;

                vm.loading = true;
                var promise = getAgreement.deleteItemOfChargeVariable(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        var dataForSysLogs = {
                            access_token: $cookies.get('obj'),
                            id: data.id,
                            identity: 8, //16
                            message: 'Variable route item of charge deleted.'
                        };
                        $rootScope.systemLogsAdmin(dataForSysLogs);
                        languageBasedErrorFactory.getProperErrorMessage('deletedItemSucc', 0, 1, 'layout.agreementMain.variablePriceListRoute');
                        //errorMessageFactory.showErrorMessage('Item of charge deleted successfully.',1);
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        };

        //======================get all services==============
        function getAllServices(skip, limit) {
            vm.loading = false;
            var promise = getServices.allServices(skip, limit, 2, 0);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.serviceListFilterGot = [];
                        angular.forEach(payload.title.data.result, function (column) {
                            vm.serviceListFilterGot.push({
                                id: column.id,
                                name: column.service_name
                            });
                        });
                        vm.serviceListFilterGot.push({
                            id: 'all',
                            name: 'All'
                        })
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllServices(0, 0);

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.agreementMain.variablePriceListRoute');
            }
        });
        //=================go back================
        function goBack() {
            if ($stateParams.path == '0') {
                $state.go('layout.agreementMain.priceListFixedAgreement', {
                    corporateId: $stateParams.corporateId,
                    contractId: $stateParams.contractId,
                    path: 1
                });
            } else {
                $state.go('layout.agreementMain.priceListVariableAgreement', {
                    corporateId: $stateParams.corporateId,
                    contractId: $stateParams.contractId,
                    path: 2
                });
            }
        };

        function cancel() {
            $state.reload('layout.agreementMain.variablePriceListRoute');
        };
        //===================store details======================
        function storeDetails() {
            var data = {
                corporateId: $stateParams.corporateId,
                contractId: $stateParams.contractId,
                priceListId: $stateParams.priceListId,
                path: $stateParams.path
            };
            $cookies.put('setData', JSON.stringify(data));
        }
    }
})();
/**
 * Created by cl-macmini-51 on 22/12/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('VariablePriceListAgreementController', VariablePriceListAgreementController);

    /** @ngInject */
    function VariablePriceListAgreementController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document, moment, getAgreement, $scope, RutHelper, filterFilter, languageBasedErrorFactory, errorMessageFactory) {

        var vm = this;
        vm.loading = false;
        vm.currentPage = 0;
        vm.totalVariablePriceList = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.getPagesCount = getPagesCount;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.init = init;
        vm.sort = sort;
        vm.goBack = goBack;
        vm.goToFactor = goToFactor;
        vm.getFilter = getFilter;
        vm.getAllVariablePriceList = getAllVariablePriceList;
        vm.storeDetails = storeDetails;
        vm.cancel = cancel;
        vm.datePickerE_1 = datePickerE_1;
        vm.newListByPass = newListByPass;
        vm.readjustPrice = readjustPrice;
        vm.addHeadersPriceDetails = addHeadersPriceDetails;
        vm.decidePopUpToOpen = decidePopUpToOpen;
        vm.addHeadersHitF = addHeadersHitF;
        vm.editVariableList = editVariableList;
        vm.changePriceListStatus = changePriceListStatus;
        vm.deletePriceList = deletePriceList;
        vm.editPriceListDetails = editPriceListDetails;
        vm.exportPriceList = exportPriceList;
        vm.copyPriceListVariable = copyPriceListVariable;
        vm.paginationNew = paginationNew;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.predicate = 'index';
        vm.reverse = false;
        vm.filterData = {
            priceListStatus: '1'
        };
        vm.variableNewListButtons = false;
        vm.dataToFillHeader = {
            type_of_pricing_list_percentage_of_price_adj: '',
            type_of_pricing_list_name: '',
            type_of_pricing_date_of_start: new Date(),
            type_of_pricing_date_of_end: new Date(),
            type_of_pricing_comments: '',
            type_of_price_type: '',
            type_of_price_status: 2,
            priceListId: ''
        };
        vm.dateOptions = {};
        vm.datePicker_1 = {
            startPriceH: false,
            endPriceH: false
        };
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.altInputFormats = ['M!/d!/yyyy'];
        vm.corporateId = $stateParams.corporateId;
        vm.contractId = $stateParams.contractId;
        vm.copyBasedFilter = {
            agreementFilter: 'all',
            statusFilter: 2,
            fixedVariableCheck: ''
        };
        $cookies.remove('setData');

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.agreementMain.priceListVariableAgreement');
            }
        });
        //==================date picker function==================
        vm.dateOptions = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(2090, 12, 31),
            //minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };

        function datePickerE_1(type) {
            if (type == '1') {
                vm.datePicker_1.endPriceH = false;
                vm.datePicker_1.startPriceH = true;
            } else if (type == '2') {
                vm.datePicker_1.endPriceH = true;
                vm.datePicker_1.startPriceH = false;
            }
        };
        //====================function for dropdown pages and page count===============
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];

        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllVariablePriceList(0, vm.itemsPerPageGot, vm.filterData.priceListStatus);
        };

        function paginationNew(page) {
            getAllVariablePriceList((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData.priceListStatus);
        }
        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.agreementMain.priceListVariableAgreement');
            }
        });

        //==================get all services=======================
        function getAllVariablePriceList(skip, limit, filter) {
            vm.loading = true;
            var dataSend = {
                access_token: $cookies.get('obj'),
                contract_id: $stateParams.contractId,
                key: Number(filter),
                limit: Number(limit),
                offset: Number(skip)
            };
            var promise = getAgreement.getVariablePriceListContract(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads121212121', payload);
                    vm.loading = false;
                    vm.totalVariablePriceList = payload.title.data.totalCount;
                    vm.dataLength = payload.title.data.totalCount;
                    if (payload.title.data.extraData) {
                        if (payload.title.data.extraData.via_control_include_in_tarifa &&
                            payload.title.data.extraData.via_control_include_in_tarifa == 1) {
                            vm.tarifaKey = 'SI';
                        } else {
                            vm.tarifaKey = 'NO';
                        }
                    }
                    if (payload.title.data.totalCount == 0) {
                        vm.sp_pagination = false;
                        vm.tBodyFlag = false;
                        vm.tFootFlag = true;
                    } else {
                        vm.sp_pagination = true;
                        vm.tBodyFlag = true;
                        vm.tFootFlag = false;
                    }

                    var dataArray = [];

                    var variablePriceList = payload.title.data.result;
                    variablePriceList.forEach(function (column) {
                        var d = {};
                        d.comments = column.comments;
                        d.contract_id = column.contract_id;
                        d.creation_date = column.creation_date;
                        d.date_of_end = column.date_of_end;
                        d.date_of_start = column.date_of_start;
                        d.id = column.id;
                        d.is_deleted = column.is_deleted;
                        d.name = column.name;
                        d.percentage_of_price_adj = column.percentage_of_price_adj;
                        d.status = column.status;
                        d.type = column.type;
                        dataArray.push(d);
                    });
                    vm.variableRouteListG = dataArray;

                    // USERTYPE VALUE
                    // 0 - Transvip user
                    // 1 - PET user
                    vm.userType = payload.title.data.user_type || 0;
                    
                    for (var i = 0; i < vm.variableRouteListG.length; i++) {
                        vm.variableRouteListG[i].index = (skip + i);
                    }
                    if (vm.dataLength <= vm.itemsPerPageGot) {
                        vm.sp_pagination = false;
                    } else {
                        vm.sp_pagination = true;
                        //vm.pageCount(payload.title.data.totalCount);
                    }
                    vm.skipValue = vm.variableRouteListG[0].index;
                    vm.limitValue = vm.variableRouteListG[vm.variableRouteListG.length - 1].index;

                    $scope.$watch('vm.search', function (newVal, oldVal) {
                        vm.filtered = filterFilter(vm.variableRouteListG, newVal);
                        vm.totalItems = vm.filtered.length;
                        if (vm.filtered.length == 0) {
                            vm.watchPagination = false;
                        } else {
                            vm.watchPagination = true;
                        }
                        if (vm.filterOn == true) {
                            vm.skipValueFilter = vm.filtered.length;
                            vm.sp_pagination = false;
                        }
                    }, true);

                    //range();
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    } else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        vm.getAllVariablePriceList((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData.priceListStatus);
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        vm.currentPage++;
        //        vm.getAllVariablePriceList((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData.priceListStatus);
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    vm.getAllVariablePriceList((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData.priceListStatus);
        //};

        function init() {
            vm.getAllVariablePriceList(0, vm.searchModel.limit, vm.filterData.priceListStatus);
        };
        init();

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            vm.filterOn = true;
            if (vm.search.length == 0) {
                vm.filterOn = false;
                vm.watchPagination = true;
                vm.sp_pagination = true;
            }
        };

        //==================get all Vehicles=======================
        function getAllAggrements() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.offset = 0;
            dataSend.limit = 0;
            dataSend.key = 3;
            dataSend.id = Number($stateParams.contractId);
            vm.loading = true;
            var promise = getAgreement.allAgreementsExpenseControl(dataSend);
            promise.then(
                function (payload) {
                    $log.log('allagree', payload);
                    vm.loading = false;
                    var where = payload.title.data.result;
                    vm.contractName = where[0].name;
                    vm.corporateName = where[0].company_name;
                    vm.agreementType = where[0].agreement_type;
                    vm.agreementStatus = where[0].status;
                    if(where[0].type_of_service){
                        var arrayForTypeOfService = where[0].type_of_service.split(',');
                        vm.agreementServices = arrayForTypeOfService;
                    }
                    if(where[0].region_name){
                        var arrayForRegionName  = where[0].region_name.split(',');
                        vm.agreementBranches = arrayForRegionName;
                    }
                    // vm.agreementServices = where[0].type_of_service;
                    // vm.agreementBranches = where[0].branch;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllAggrements();

        function getAllAggrementsLessData() {
            var promise = getAgreement.getAgreementListLessData();
            promise.then(
                function (payload) {
                    $log.log('allagree', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.agreementListForCopy = [];
                        vm.agreementListForCopy.push({
                            id: 'all',
                            name: 'All',
                            type: 'CORPORATE'
                        });
                        for (var i = 0; i < payload.title.data.length; i++) {
                            vm.agreementListForCopy.push({
                                id: payload.title.data[i].id,
                                name: payload.title.data[i].name,
                                type: payload.title.data[i].agreement_type
                            })
                        }
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllAggrementsLessData();
        //=========================new list bypass======================
        function newListByPass() {
            vm.editHeaderVFlag = false;
            vm.addHeaderVFlag = false;
            vm.fixedNewListButtons = false;
            vm.variableNewListButtons = !vm.variableNewListButtons;
        };
        //============================readjust price==============================
        function readjustPrice() {
            errorMessageFactory.showErrorMessage('Functionality is pending');
        };
        //====================headers for price list=============================
        function addHeadersPriceDetails() {
            vm.dataToFillHeader = {
                type_of_pricing_list_percentage_of_price_adj: '',
                type_of_pricing_list_name: '',
                type_of_pricing_date_of_start: new Date(),
                type_of_pricing_date_of_end: new Date(),
                type_of_pricing_comments: '',
                type_of_price_type: '',
                type_of_price_status: 2,
                priceListId: ''
            };
            vm.variableNewListButtons = false;
            vm.addHeaderFFlag = false;
            vm.addHeaderVFlag = true;
            vm.editHeaderFFlag = false;
            vm.editHeaderVFlag = false;
            vm.dataToFillHeader.type_of_price_type = 1;
        };

        function addHeadersHitF() {
            $log.log(vm.dataToFillHeader);
            if (vm.dataToFillHeader.type_of_pricing_date_of_start > vm.dataToFillHeader.type_of_pricing_date_of_end) {
                languageBasedErrorFactory.getProperErrorMessage('appropriateDateErr', 0, 0);
                //errorMessageFactory.showErrorMessage('Please choose appropriate dates.');
                return;
            }
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.contract_id = Number($stateParams.contractId);
            //dataSend.type_of_pricing_list_percentage_of_price_adj = vm.dataToFillHeader.type_of_pricing_list_percentage_of_price_adj;
            dataSend.type_of_pricing_list_name = vm.dataToFillHeader.type_of_pricing_list_name;
            dataSend.type_of_pricing_date_of_start = moment(vm.dataToFillHeader.type_of_pricing_date_of_start).format('YYYY-MM-DD HH:mm:ss');
            dataSend.type_of_pricing_date_of_end = moment(vm.dataToFillHeader.type_of_pricing_date_of_end).format('YYYY-MM-DD HH:mm:ss');
            dataSend.type_of_pricing_comments = vm.dataToFillHeader.type_of_pricing_comments;
            dataSend.type_of_price_type = Number(vm.dataToFillHeader.type_of_price_type);
            dataSend.type_of_price_status = Number(vm.dataToFillHeader.type_of_price_status);
            dataSend.timezone = new Date().getTimezoneOffset();
            vm.loading = true;
            var promise = getAgreement.addHeadersOfPriceList(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    languageBasedErrorFactory.getProperErrorMessage('priceListAddedSucc', 0, 1, 'layout.agreementMain.priceListVariableAgreement');
                    //errorMessageFactory.showErrorMessage('Price list added successfully.',1);
                    //$timeout(function() {
                    //    $mdDialog.hide();
                    //    $state.reload();
                    //}, 2000);
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };


        //====================open pop up to decide for copy or new===================
        function decidePopUpToOpen($event) {
            vm.copyBasedFilter = {
                agreementFilter: 'all',
                statusFilter: 2,
                fixedVariableCheck: ''
            };
            openVariableBasedPopup(vm.copyBasedFilter, $event);
        };

        function openVariableBasedPopup(filterData, $event) {
            vm.copyBasedFilter.fixedVariableCheck = 1;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.list_key = 1;
            dataSend.state = Number(filterData.statusFilter);
            if (filterData.agreementFilter != 'all')
                dataSend.contact_id = Number(filterData.agreementFilter);
            vm.loading = true;
            var promise = getAgreement.getBasedPriceListData(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    copyBasedPriceListPop(payload.title.data, $event);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        function copyBasedPriceListPop(data, $event) {
            if (vm.copyBasedFilter.fixedVariableCheck == 1 || vm.copyBasedFilter.fixedVariableCheck == '1') {
                vm.agreementListForCopy_1 = _.where(vm.agreementListForCopy, {
                    type: 'CORPORATE'
                });
            } else {
                vm.agreementListForCopy_1 = vm.agreementListForCopy;
            }
            vm.items = {
                agreementListForCopy: vm.agreementListForCopy_1,
                agreementFilter: 'all',
                statusFilter: '2',
                priceListData: data,
                filterData: vm.copyBasedFilter
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/copyBasedPriceList.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: CopyBasedPriceListController
            });

            function CopyBasedPriceListController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    newListByPass();
                    $mdDialog.hide();
                };
                $scope.agreementChangeFilter = function (data) {
                    $scope.items.filterData.agreementFilter = data;
                    $scope.makeApiHit($scope.items.filterData);
                };
                $scope.statusChangeFilter = function (data) {
                    $scope.items.filterData.statusFilter = data;
                    $scope.makeApiHit($scope.items.filterData);
                };

                $scope.makeApiHit = function (filterData) {
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.list_key = Number(filterData.fixedVariableCheck);
                    dataSend.state = Number(filterData.statusFilter);
                    if (filterData.agreementFilter != 'all')
                        dataSend.contact_id = Number(filterData.agreementFilter);
                    $scope.loading1 = true;
                    var promise = getAgreement.getBasedPriceListData(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log(payload);
                            $scope.loading1 = false;
                            $scope.items.priceListData = payload.title.data;
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            $scope.loading1 = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                };

                $scope.copyBasedPriceList = function (data, $event) {
                    confirmPopUpForCopy(data, $event);
                }
            }
        }

        function confirmPopUpForCopy(data, $event) {
            var msg = languageBasedErrorFactory.getProperErrorMessage('copyBasedMsg', 0, '3');
            var confirm = $mdDialog.confirm()
                .title(msg)
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('yes', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('no', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                //errorMessageFactory.showErrorMessage('Functionality is pending');
                copyVariablePriceListHit(data);

            }, function () {
                $log.log('not confirmed');
                openVariableBasedPopup(vm.copyBasedFilter, $event);
            });
        }

        function copyPriceListVariable(data, $event) {
            var msg = languageBasedErrorFactory.getProperErrorMessage('copyPop', 0, '3');
            var confirm = $mdDialog.confirm()
                .title(msg)
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                //errorMessageFactory.showErrorMessage('Functionality is pending');
                copyVariablePriceListHit(data.id);
            }, function () {
                $log.log('not confirmed');
            });
        };

        function copyVariablePriceListHit(data) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.price_list_id = data.id ? data.id : data;
            if (data.contract_id)
                dataSend.agreement_id = $stateParams.contractId;

            vm.loading = true;
            var promise = getAgreement.copyVariablePriceList(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    var dataForSysLogs = {
                        access_token: $cookies.get('obj'),
                        id: data.id ? data.id : data,
                        identity: 18,
                        message: 'Variable price list copied.'
                    };
                    $rootScope.systemLogsAdmin(dataForSysLogs);
                    languageBasedErrorFactory.getProperErrorMessage('copyPopSucc', 0, 1, 'layout.agreementMain.priceListVariableAgreement');
                    //errorMessageFactory.showErrorMessage('List copied successfully.',1);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        //===========================change price list status=========================
        function changePriceListStatus(data, $event) {
            $log.log(data);

            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('priceListStatusPop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed', data);
                var dataSend = {};
                dataSend.contract_id = data.contract_id;
                dataSend.access_token = $cookies.get('obj');
                dataSend.price_list_id = data.id;
                dataSend.type_of_price_list = data.type;
                if (data.status == '2' || data.status == 2) {
                    vm.loading = true;
                    var promise = getAgreement.changeStatusPriceListActive(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log(payload);
                            vm.loading = false;
                            var dataForSysLogs = {
                                access_token: $cookies.get('obj'),
                                id: data.id,
                                identity: 18,
                                message: 'Price list activated.'
                            };
                            $rootScope.systemLogsAdmin(dataForSysLogs);
                            $state.reload('layout.agreementMain.priceListVariableAgreement');
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                } else if (data.status == '0' || data.status == 0) {
                    vm.loading = true;
                    var promise = getAgreement.changeStatusPriceListInActive(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log(payload);
                            vm.loading = false;
                            var dataForSysLogs = {
                                access_token: $cookies.get('obj'),
                                id: data.id,
                                identity: 18,
                                message: 'Price list deactivated.'
                            };
                            $rootScope.systemLogsAdmin(dataForSysLogs);
                            $state.reload('layout.agreementMain.priceListVariableAgreement');
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }

            }, function () {
                $log.log('not confirmed');
            });
        };

        //===========================edit price list details=========================
        function editPriceListDetails(data) {
            vm.variableNewListButtons = false;
            vm.editHeaderVFlag = true;
            vm.addHeaderVFlag = false;
            vm.dataToFillHeader.type_of_pricing_list_name = data.name;
            vm.dataToFillHeader.type_of_pricing_list_percentage_of_price_adj = data.percentage_of_price_adj;
            vm.dataToFillHeader.type_of_pricing_date_of_start = new Date(data.date_of_start);
            vm.dataToFillHeader.type_of_pricing_date_of_end = new Date(data.date_of_end);
            vm.dataToFillHeader.type_of_pricing_comments = data.comments;
            vm.dataToFillHeader.type_of_price_type = data.type;
            vm.dataToFillHeader.type_of_price_status = data.status;
            vm.dataToFillHeader.priceListId = data.id;

        };

        function editVariableList() {
            $log.log(vm.dataToFillHeader);
            if (vm.dataToFillHeader.type_of_pricing_date_of_start > vm.dataToFillHeader.type_of_pricing_date_of_end) {
                //errorMessageFactory.showErrorMessage('Please choose appropriate dates.');
                languageBasedErrorFactory.getProperErrorMessage('appropriateDateErr', 0, 0);
                return;
            }
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.pricing_list_id = vm.dataToFillHeader.priceListId;
            dataSend.name = vm.dataToFillHeader.type_of_pricing_list_name;
            dataSend.comments = vm.dataToFillHeader.type_of_pricing_comments;
            dataSend.date_of_end = moment(vm.dataToFillHeader.type_of_pricing_date_of_end).format('YYYY-MM-DD HH:mm:ss');
            //dataSend.percentage_of_price_adj = vm.dataToFillHeader.type_of_pricing_list_percentage_of_price_adj;
            dataSend.date_of_start = moment(vm.dataToFillHeader.type_of_pricing_date_of_start).format('YYYY-MM-DD HH:mm:ss');
            dataSend.timezone = new Date().getTimezoneOffset();

            vm.loading = true;
            var promise = getAgreement.editAgreementPriceList(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    var dataForSysLogs = {
                        access_token: $cookies.get('obj'),
                        id: vm.dataToFillHeader.priceListId,
                        identity: 18,
                        message: 'Price list updated.'
                    };
                    $rootScope.systemLogsAdmin(dataForSysLogs);
                    languageBasedErrorFactory.getProperErrorMessage('priceListEditSucc', 0, 1, 'layout.agreementMain.priceListVariableAgreement');
                    //errorMessageFactory.showErrorMessage('List updated successfully.',1);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        //=====================to delete route and branch====================
        function deletePriceList($event, data) {

            var msg = languageBasedErrorFactory.getProperErrorMessage('priceListDeletePopV', 0, '3');

            var confirm = $mdDialog.confirm()
                .title(msg)
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                var dataSend = {
                    is_deleted: 1,
                    price_list_id: data.id,
                    access_token: $cookies.get('obj')
                };
                //errorMessageFactory.showErrorMessage('Functionality is pending');
                vm.loading = true;
                var promise = getAgreement.deleteVariablePriceList(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        languageBasedErrorFactory.getProperErrorMessage('priceListDeleteSuccV', 0, 1, 'layout.agreementMain.priceListVariableAgreement');
                        //errorMessageFactory.showErrorMessage('Variable price list deleted successfully.',1);
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        };

        //============================export prce list===============================
        function exportPriceList(data, $event, type) {
            vm.loading = true;
            var dataSend = {
                access_token: $cookies.get('obj'),
                price_list_id: data.id,
                key: 2
            };
            var promise = getAgreement.getVariableRoutePriceList(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads123', payload);
                    if (payload.title.data.length == 0) {
                        languageBasedErrorFactory.getProperErrorMessage('exportErr', 0, 0);
                        //errorMessageFactory.showErrorMessage('No data available to export.',0);
                        vm.loading = false;
                        return;
                    } else {
                        var dataArray = [];
                        var exportList = payload.title.data.result;
                        exportList.forEach(function (column) {
                            var d = {};
                            d['Price List ID'] = column.price_list_data.id;
                            d['Price List Name'] = column.price_list_data.name;
                            d['Price List Type'] = column.price_list_data.type == 0 ? 'Fixed' : 'Variable';
                            d['Percentage Price Adjustment'] = column.price_list_data.percentage_of_price_adj;
                            d['Price List Start Date'] = moment(column.price_list_data.date_of_start).format('lll');
                            d['Price List End Date'] = moment(column.price_list_data.date_of_end).format('lll');
                            d['Price List Comments'] = column.price_list_data.comments;
                            if (column.price_list_data.status == 0) {
                                d['Price List Status'] = 'Active';
                            } else if (column.price_list_data.status == 1) {
                                d['Price List Status'] = 'Inactive';
                            } else if (column.price_list_data.status == 2) {
                                d['Price List Status'] = 'In Progress';
                            }
                            d['Variable Route ID'] = column.id;
                            d['Variable Route Price'] = column.price;
                            d['Variable Route Branch'] = column.coverage_area_data.region_name;
                            d['Variable Route Status'] = column.status == 0 ? 'Inactive' : 'Active';
                            d['Variable Route Services'] = [];
                            if (column.typeOfService && column.typeOfService.length) {
                                for (var i = 0; i < column.typeOfService.length; i++) {
                                    d['Variable Route Services'].push(column.typeOfService[i].service_name);
                                }
                            } else {
                                d['Variable Route Services'] = [];
                            }
                            d['Item of Charge Name'] = [];
                            d['Item of Charge Price'] = [];
                            if (column.item_of_charge && column.item_of_charge.length) {
                                for (var i = 0; i < column.item_of_charge.length; i++) {
                                    d['Item of Charge Name'].push(column.item_of_charge[i].long_name);
                                    d['Item of Charge Price'].push(column.item_of_charge[i].price);
                                }
                            } else {
                                d['Item of Charge Name'] = [];
                                d['Item of Charge Price'] = [];
                            }
                            d['Variable Route Comments'] = column.comments;
                            dataArray.push(d);
                        });
                        vm.exportList = dataArray;
                        alasql('SELECT * INTO CSV("variablePriceList.csv",{headers:true}) FROM ?', [vm.exportList]);
                        //if(format == 'csv'){
                        //
                        //}
                        //else if(format == 'excel'){
                        //    alasql('SELECT * INTO XLS("carrier.xls",{headers:true}) FROM ?',[$scope.exportList]);
                        //}
                        vm.loading = false;
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //=================go back================
        function goBack() {
            $state.go('layout.agreementMain.agreement');
        };

        function goToFactor() {
            $state.go('layout.factorMultiplicadorMain.factorMultiplicador', {
                params: $stateParams,
                tipo: 0, //tipo variable
                contractId: $stateParams.contractId,
                corporateId: $stateParams.corporateId,
            });
        };

        function cancel() {
            $state.reload('layout.agreementMain.priceListVariableAgreement');
        };
        //===================store details======================
        function storeDetails() {
            var data = {
                corporateId: $stateParams.corporateId,
                contractId: $stateParams.contractId,
                path: $stateParams.path
            };
            $cookies.put('setData', JSON.stringify(data));
        }
    }
})();

/**
 * Created by cl-macmini-51 on 22/12/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .controller('FixedPriceListRouteDetailsController', FixedPriceListRouteDetailsController);

    /** @ngInject */
    function FixedPriceListRouteDetailsController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document,
                                           moment, getAgreement, $scope, RutHelper, filterFilter, getGeofence, getItemOfCharge, getServices, languageBasedErrorFactory,errorMessageFactory,Initializer) {
        var vm = this;
        var myCenter;
        var zoomLevel = 8;
        var all_overlays = [];
        var coordinates_array = [];
        var markers=[];
        var mapProp={};
        var drawingManager = '';
        var mc=null;
        var map =null;
        var icon = {};
        var bounds;
        var geocoder;
        var infoWindow;
        var location = "";
        var currentId = 0;
        var laArray = [];
        var poly  = '';
        var branchCount = 0;
        var bermudaTriangle;
        var regionsArray = [];
        var uniqueId = function() {
            return ++currentId;
        };
        Initializer.mapsInitialized
        .then(function () {
            console.log('>>>> GOOGLE INIT', google);
            if (google) {
                 bounds = new google.maps.LatLngBounds();
                 geocoder = new google.maps.Geocoder();
                 infoWindow = new google.maps.InfoWindow(); 
                 myCenter= new google.maps.LatLng(-33.447487, -70.673676);
                 bermudaTriangle = new google.maps.Polygon();
            } else {
                alert(languageBasedErrorFactory.getProperErrorMessage('onRoadMessage', 0, '3'));
            }

        });
        vm.loading = false;
        vm.currentPage = 0;
        vm.totalFixedRoutePriceList = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.goBack = goBack;
        vm.cancel = cancel;
        vm.getPagesCount = getPagesCount;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.init = init;
        vm.getFilter = getFilter;
        vm.sort = sort;
        vm.getFixedRoutePriceList = getFixedRoutePriceList;
        vm.storeDetails = storeDetails;
        vm.paginationNew = paginationNew;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.fixedRouteFlag = false;
        vm.routeDisabled = true;
        vm.dataToFill = {
            type_of_service_id: [],
            route_id: '',
            price_list_id: Number($stateParams.priceListId),
            comments: '',
            price: '',
            branch: '',
            branchDetails: '',
            routeDetails: '',
            id: '',
            perKMChanges: '',
            waitTimeCharges: '0',
            waitTimeInTrip: '0',
            baseFare: '0',
            minimumFare: '0'

        };
        vm.editFixedRouteDetailsFlag = false;
        vm.predicate = 'index';
        vm.reverse = false;
        $cookies.remove('setData');
        vm.filterData = {
            priceListRouteStatus: '1',
            type_of_service: 'all',
            branch_id: 'all'
        };
        //====================function for dropdown pages and page count===============
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];

        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getFixedRoutePriceList(0, vm.itemsPerPageGot,vm.filterData);
        };

        function paginationNew(page){
            getFixedRoutePriceList((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot,vm.filterData);
        }
        //=================sort======================
        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };
        //==================get all Vehicles=======================
        function getAllAggrements() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.offset = 0;
            dataSend.limit = 0;
            dataSend.key = 3;
            dataSend.id = $stateParams.contractId;
            vm.loading = true;
            var promise = getAgreement.allAgreementsExpenseControl(dataSend);
            promise.then(
                function(payload) {
                    $log.log('allagree', payload);
                    vm.loading = false;
                    var where = payload.title.data.result;
                    vm.contractName = where[0].name;
                    vm.corporateName = where[0].company_name;
                    vm.agreementType = where[0].agreement_type;
                    vm.agreementStatus = where[0].status;
                    if(where[0].type_of_service){
                        var arrayForTypeOfService = where[0].type_of_service.split(',');
                        vm.agreementServices = arrayForTypeOfService;
                    }
                    if(where[0].region_name){
                        var arrayForRegionName  = where[0].region_name.split(',');
                        vm.agreementBranches = arrayForRegionName;
                    }
                    //// TV-2682 ////////////////////////////////////
                    // if(vm.agreementBranches && vm.agreementBranches.length){
                    //     for(var i=0;i<vm.agreementBranches.length;i++){
                    //         vm.agreementBranches[i].region_data = vm.agreementBranches[i].region_data[0];
                    //         vm.agreementBranches[i].strokeColor = '#f18903';
                    //         vm.agreementBranches[i].fillColor = 'transparent';
                    //     }
                    // }
                    //// TV-2682 ////////////////////////////////////
                    vm.serviceList = where[0].type_of_service;
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        getAllAggrements();

        //======================get fixed route price list===================
        function getFixedRoutePriceList(skip,limit,filter){
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.price_list_id = Number($stateParams.priceListId);
            dataSend.key = Number(filter.priceListRouteStatus);
            dataSend.limit = Number(limit);
            dataSend.offset = Number(skip);
            if(filter.branch_id != 'all'){
                dataSend.branch_id = filter.branch_id;
            }
            if(filter.type_of_service != 'all'){
                dataSend.type_of_service = filter.type_of_service;
            }
            if (vm.search) {
                dataSend.search_filter = 1;
                dataSend.search_value = vm.search
            } else {
                dataSend.search_filter = 0;
            }
            var promise = getAgreement.getFixedRoutePriceList(dataSend);
            promise.then(
                function(payload) {
                    $log.log('sxdsads12332423423423', payload);
                    vm.loading = false;
                    vm.totalFixedRoutePriceList = payload.title.data.totalCount;
                    vm.dataLength = payload.title.data.totalCount;

                    if (payload.title.data.totalCount == 0) {
                        vm.sp_pagination = false;
                        vm.tBodyFlag = false;
                        vm.tFootFlag = true;
                    } else {
                        vm.sp_pagination = true;
                        vm.tBodyFlag = true;
                        vm.tFootFlag = false;
                    }

                    if (payload.title.data.totalCount == 0) {
                        vm.watchPagination = false;
                    } else {
                        vm.watchPagination = true;
                    }
                    if (vm.filterOn == true) {
                        vm.skipValueFilter = payload.title.data.totalCount;
                        vm.sp_pagination = false;
                    }

                    var dataArray = [];

                    var fixedRoutePriceList = payload.title.data.result;
                    fixedRoutePriceList.forEach(function(column) {
                        var d = {};
                        d.comments = column.comments;
                        d.item_of_charge = column.item_of_charge;
                        d.price = column.price;
                        d.price_list_id = column.price_list_id;
                        d.route_id = column.route_id;
                        d.id = column.id;
                        d.is_deleted = column.is_deleted;
                        d.status = column.status;
                        d.typeOfService = column.typeOfService;
                        dataArray.push(d);
                    });
                    vm.fixedRoutePriceGot = dataArray;

                    for (var i = 0; i < vm.fixedRoutePriceGot.length; i++) {
                        vm.fixedRoutePriceGot[i].index = (skip + i);
                    }
                    if (vm.dataLength <= vm.itemsPerPageGot) {
                        vm.sp_pagination = false;
                    } else {
                        vm.sp_pagination = true;
                        //vm.pageCount(payload.title.data.totalCount);
                    }
                    vm.skipValue = vm.fixedRoutePriceGot[0].index;
                    vm.limitValue = vm.fixedRoutePriceGot[vm.fixedRoutePriceGot.length - 1].index;

                    // $scope.$watch('vm.search', function(newVal, oldVal) {
                        // vm.filtered = filterFilter(vm.fixedRoutePriceGot, newVal);
                        // vm.totalItems = vm.filtered.length;
                        // if (vm.filtered.length == 0) {
                        //     vm.watchPagination = false;
                        // } else {
                        //     vm.watchPagination = true;
                        // }
                        // if (vm.filterOn == true) {
                        //     vm.skipValueFilter = vm.filtered.length;
                        //     vm.sp_pagination = false;
                        // }
                    // }, true);

                    //range();
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    } else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        vm.getFixedRoutePriceList((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        vm.currentPage++;
        //        vm.getFixedRoutePriceList((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    vm.getFixedRoutePriceList((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //};

        function init() {
            getAllPriceList();
        };
        init();

        function getFilter() {
            vm.filterOn = true;
            if (vm.search.length == 0) {
                vm.filterOn = false;
                vm.watchPagination = true;
                vm.sp_pagination = true;
            }
            $timeout.cancel(vm.yourTimer);
            vm.yourTimer = $timeout(function(){
                getFixedRoutePriceList(0, vm.itemsPerPageGot, vm.filterData);
            }, 1000);
        };
        //==================get all price list=======================
        function getAllPriceList() {
            vm.loading = true;
            var dataSend = {
                access_token: $cookies.get('obj'),
                contract_id: $stateParams.contractId,
                id: $stateParams.priceListId,
                key:3
            };
            var promise = getAgreement.getPriceListDetailId(dataSend);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.fixedRouteListG = payload.title.data;
                    vm.selectedPriceList = Number($stateParams.priceListId);
                    vm.startDate = payload.title.data.date_of_start;
                    vm.endDate = payload.title.data.date_of_end;
                    vm.name = payload.title.data.name;
                    vm.status = payload.title.data.status;
                    getFixedRoutePriceList(0,10,vm.filterData);
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        //===========================get all branches==========================
        function getAllBranches(){
            vm.loading = true;
            var promise = getGeofence.getAllBranchList(2);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if(payload.title.data.length) {
                        var where = _.where(payload.title.data, {parent_id: 0});
                        vm.branchList = where;
                        vm.branchListFilterGot = where;
                        vm.branchListFilterGot.push({
                            region_id:'all',
                            region_name:'All'
                        });
                        for(var i=0;i<vm.branchList.length;i++){
                            vm.branchList[i].strokeColor = '#f18903';
                            vm.branchList[i].fillColor = 'transparent';
                        }
                    }
                    else{
                        vm.branchList = [];
                        languageBasedErrorFactory.getProperErrorMessage('branchReq',0,0);
                        //errorMessageFactory.showErrorMessage('Please add branch first.',0);
                    }
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        getAllBranches();
        //======================get all services==============
        function getAllServices(skip, limit) {
            vm.loading = false;
            var promise = getServices.allServices(skip, limit,2,0);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if(payload.title.status == 400){
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    else if(payload.title.status == 401){
                        errorMessageFactory.showErrorMessage(payload.title.message,2,'home');
                    }
                    else if(payload.title.status == 201 || payload.title.status == 200) {
                        vm.serviceListFilterGot = [];
                        angular.forEach(payload.title.data.result, function (column) {
                            vm.serviceListFilterGot.push({id: column.id, name: column.service_name});
                        });
                        vm.serviceListFilterGot.push({
                            id: 'all',
                            name: 'All'
                        })
                    }
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllServices(0, 0);

        //====================event for getting refreshed================
        $scope.$on('StateReload', function(evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.agreementMain.fixedPriceListRouteDetails');
            }
        });
        //=================go back================
        function goBack() {
            if($stateParams.path == '0'){
                $state.go('layout.agreementMain.priceListFixedAgreement',{corporateId:$stateParams.corporateId,contractId:$stateParams.contractId,path:1});
            }
            else{
                $state.go('layout.agreementMain.priceListVariableAgreement',{corporateId:$stateParams.corporateId,contractId:$stateParams.contractId,path:2});
            }
        };
        function cancel(){
            $state.reload('layout.agreementMain.fixedPriceListRouteDetails');
        };
        //===================store details======================
        function storeDetails(){
            var data = {
                corporateId: $stateParams.corporateId,
                contractId: $stateParams.contractId,
                priceListId: $stateParams.priceListId,
                path: $stateParams.path
            };
            $cookies.put('setData',JSON.stringify(data));
        }
    }
})();
/**
 * Created by cl-macmini-51 on 5/26/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .controller('FixedPriceListRouteController', FixedPriceListRouteController);

    /** @ngInject */
    function FixedPriceListRouteController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document,
                                      moment, getAgreement,Initializer, $scope, RutHelper, filterFilter, getGeofence, getItemOfCharge, getServices, languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        var myCenter;
        var zoomLevel = 8;
        var all_overlays = [];
        var coordinates_array = [];
        var markers=[];
        var mapProp={};
        var drawingManager = '';
        var mc=null;
        var map =null;
        var icon = {};
        var bounds;
        var geocoder;
        var infoWindow;
        var location = "";
        var currentId = 0;
        var laArray = [];
        var poly  = '';
        var branchCount = 0;
        var bermudaTriangle;
        var regionsArray = [];
        var uniqueId = function() {
            return ++currentId;
        };
          // Service To Get Map Instance
          Initializer.mapsInitialized
          .then(function () {
              console.log('>>>> GOOGLE INIT', google);
              if (google) {
                  myCenter = new google.maps.LatLng(-33.447487, -70.673676);
                  bounds = new google.maps.LatLngBounds();
                  geocoder = new google.maps.Geocoder();
                  infoWindow = new google.maps.InfoWindow();
                  bermudaTriangle = new google.maps.Polygon();
              } else {
                  alert(languageBasedErrorFactory.getProperErrorMessage('onRoadMessage', 0, '3'));
              }
 
          });
        vm.loading = false;
        vm.currentPage = 0;
        vm.totalFixedRoutePriceList = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.goBack = goBack;
        vm.cancel = cancel;
        vm.getPagesCount = getPagesCount;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.init = init;
        vm.getFilter = getFilter;
        vm.addMoreRoutes = addMoreRoutes;
        vm.sort = sort;
        vm.branchChanged = branchChanged;
        vm.addFixedRouteHit = addFixedRouteHit;
        vm.getFixedRoutePriceList = getFixedRoutePriceList;
        vm.addItemOfCharge = addItemOfCharge;
        vm.getAllItemOfCharges = getAllItemOfCharges;
        vm.addItemOfChargeFixedHit = addItemOfChargeFixedHit;
        vm.changePriceListRouteStatus = changePriceListRouteStatus;
        vm.setMapOnAll = setMapOnAll;
        vm.drawingFunctions = drawingFunctions;
        vm.mapInitialize = mapInitialize;
        vm.selectedRouteFromList = selectedRouteFromList;
        vm.showBranchOnMap = showBranchOnMap;
        vm.deleteRouteAndBranch = deleteRouteAndBranch;
        vm.editRouteBranchDetails = editRouteBranchDetails;
        vm.editFixedRouteDetailsHit = editFixedRouteDetailsHit;
        vm.deleteItemOfCharge = deleteItemOfCharge;
        vm.storeDetails = storeDetails;
        vm.searchRoutesInput = searchRoutesInput;
        vm.onSelectingRoute = onSelectingRoute;
        vm.paginationNew = paginationNew;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.fixedRouteFlag = false;
        vm.routeDisabled = true;
        vm.dataToFill = {
            type_of_service_id: [],
            route_id: '',
            price_list_id: Number($stateParams.priceListId),
            comments: '',
            price: '',
            branch: '',
            branchDetails: '',
            routeDetails: '',
            id: '',
            perKMChanges: '',
            waitTimeCharges: '0',
            waitTimeInTrip: '0',
            baseFare: '0',
            minimumFare: '0',
            actualRoute:''

        };
        vm.editFixedRouteDetailsFlag = false;
        vm.predicate = 'index';
        vm.reverse = false;
        $cookies.remove('setData');
        vm.filterData = {
            priceListRouteStatus: '1',
            type_of_service: 'all',
            branch_id: 'all'
        };
        //====================function for dropdown pages and page count===============
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];

        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getFixedRoutePriceList(0, vm.itemsPerPageGot,vm.filterData);
        };

        function paginationNew(page){
            getFixedRoutePriceList((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot,vm.filterData);
        }

        //=================sort======================
        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };
        //==================get all Vehicles=======================
        function getAllAggrements() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.offset = 0;
            dataSend.limit = 0;
            dataSend.key = 3;
            dataSend.id = $stateParams.contractId;
            vm.loading = true;
            var promise = getAgreement.allAgreements(dataSend);
            promise.then(
                function(payload) {
                    $log.log('allagree', payload);
                    vm.loading = false;
                    var where = payload.title.data.result;
                    console.log(where,'where');
                    
                    vm.contractName = where[0].name;
                    vm.corporateName = where[0].corporate_id.company_name;
                    vm.agreementType = where[0].agreement_type;
                    vm.agreementStatus = where[0].status;
                    // if(where[0].type_of_service){
                    //     var arrayForTypeOfService = where[0].type_of_service.split(',');
                    //     vm.agreementServices = arrayForTypeOfService;
                    // }
                    // if(where[0].region_name){
                    //     var arrayForRegionName  = where[0].region_name.split(',');
                    //     vm.agreementBranches = arrayForRegionName;
                    // }
                    vm.agreementServices = where[0].type_of_service;
                    vm.agreementBranches = where[0].branch;
                    if(vm.agreementBranches && vm.agreementBranches.length){
                        for(var i=0;i<vm.agreementBranches.length;i++){
                            vm.agreementBranches[i].region_data = vm.agreementBranches[i].region_data[0];
                            vm.agreementBranches[i].strokeColor = '#f18903';
                            vm.agreementBranches[i].fillColor = 'transparent';
                        }
                    }
                    console.log(vm.agreementServices,'agreementBranches');
                    
                    vm.serviceList = where[0].type_of_service;
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        getAllAggrements();

        //======================get fixed route price list===================
        function getFixedRoutePriceList(skip,limit,filter){
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.price_list_id = Number($stateParams.priceListId);
            dataSend.key = Number(filter.priceListRouteStatus);
            dataSend.limit = Number(limit);
            dataSend.offset = Number(skip);
            if(filter.branch_id != 'all'){
                dataSend.branch_id = filter.branch_id;
            }
            if(filter.type_of_service != 'all'){
                dataSend.type_of_service = filter.type_of_service;
            }
            var promise = getAgreement.getFixedRoutePriceList(dataSend);
            promise.then(
                function(payload) {
                    $log.log('sxdsads12332423423423', payload);
                    vm.loading = false;
                    vm.totalFixedRoutePriceList = payload.title.data.totalCount;
                    vm.dataLength = payload.title.data.totalCount;

                    if (payload.title.data.totalCount == 0) {
                        vm.sp_pagination = false;
                        vm.tBodyFlag = false;
                        vm.tFootFlag = true;
                    } else {
                        vm.sp_pagination = true;
                        vm.tBodyFlag = true;
                        vm.tFootFlag = false;
                    }

                    var dataArray = [];

                    var fixedRoutePriceList = payload.title.data.result;
                    fixedRoutePriceList.forEach(function(column) {
                        var d = {};
                        d.comments = column.comments;
                        d.item_of_charge = column.item_of_charge;
                        d.price = column.price;
                        d.price_list_id = column.price_list_id;
                        d.route_id = column.route_id;
                        d.id = column.id;
                        d.is_deleted = column.is_deleted;
                        d.status = column.status;
                        d.typeOfService = column.typeOfService;
                        dataArray.push(d);
                    });
                    vm.fixedRoutePriceGot = dataArray;

                    for (var i = 0; i < vm.fixedRoutePriceGot.length; i++) {
                        vm.fixedRoutePriceGot[i].index = (skip + i);
                    }
                    if (vm.dataLength <= vm.itemsPerPageGot) {
                        vm.sp_pagination = false;
                    } else {
                        vm.sp_pagination = true;
                        //vm.pageCount(payload.title.data.totalCount);
                    }
                    vm.skipValue = vm.fixedRoutePriceGot[0].index;
                    vm.limitValue = vm.fixedRoutePriceGot[vm.fixedRoutePriceGot.length - 1].index;

                    $scope.$watch('vm.search', function(newVal, oldVal) {
                        vm.filtered = filterFilter(vm.fixedRoutePriceGot, newVal);
                        vm.totalItems = vm.filtered.length;
                        if (vm.filtered.length == 0) {
                            vm.watchPagination = false;
                        } else {
                            vm.watchPagination = true;
                        }
                        if (vm.filterOn == true) {
                            vm.skipValueFilter = vm.filtered.length;
                            vm.sp_pagination = false;
                        }
                    }, true);

                    //range();
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    } else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        vm.getFixedRoutePriceList((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        vm.currentPage++;
        //        vm.getFixedRoutePriceList((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    vm.getFixedRoutePriceList((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //};

        function init() {
            getAllPriceList();
        };
        init();

        function getFilter() {
            vm.filterOn = true;
            if (vm.search.length == 0) {
                vm.filterOn = false;
                vm.watchPagination = true;
                vm.sp_pagination = true;
            }
        };
        //==================get all price list=======================
        function getAllPriceList() {
            vm.loading = true;
            var dataSend = {
                access_token: $cookies.get('obj'),
                contract_id: $stateParams.contractId,
                id: $stateParams.priceListId,
                key:3
            };
            var promise = getAgreement.getPriceListDetailId(dataSend);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.fixedRouteListG = payload.title.data;
                    vm.selectedPriceList = Number($stateParams.priceListId);
                    vm.startDate = payload.title.data.date_of_start;
                    vm.endDate = payload.title.data.date_of_end;
                    vm.name = payload.title.data.name;
                    vm.status = payload.title.data.status;
                    getFixedRoutePriceList(0,10,vm.filterData);
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        //===========================get all branches==========================
        function getAllBranches(){
            vm.loading = true;
            var promise = getGeofence.getAllBranchList(2);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if(payload.title.data.length) {
                        console.log(" i m in this");
                        
                        var where = _.where(payload.title.data, {parent_id: 0});
                        console.log(where,'where');
                        
                        vm.branchList = where;
                        vm.branchListFilterGot = where;
                        vm.branchListFilterGot.push({
                            region_id:'all',
                            region_name:'All'
                        });
                        for(var i=0;i<vm.branchList.length;i++){
                            vm.branchList[i].strokeColor = '#f18903';
                            vm.branchList[i].fillColor = 'transparent';
                        }
                    }
                    else{
                        vm.branchList = [];
                        languageBasedErrorFactory.getProperErrorMessage('branchReq',0,0);
                        //errorMessageFactory.showErrorMessage('Please add branch first.',0);
                    }
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        getAllBranches();
        //================set map nulll======================
        function setMapOnAll(map,id) {
            for(var i=0;i<regionsArray.length;i++)
            {
                if(id == 0 || id == '0'){
                    if(regionsArray[i].id == 'child'){
                        var bermudaTriangle = regionsArray[i];
                        bermudaTriangle.setMap(map);
                    }
                }
                if(id == 1 || id == '1'){
                    var bermudaTriangle = regionsArray[i];
                    bermudaTriangle.setMap(map);
                }
            }
        };
        // If the map position is out of range, move it back
        function checkBounds(map) {
            if (typeof(map.getBounds()) == 'undefined')
                return;

            var latNorth = map.getBounds().getNorthEast().lat();
            var latSouth = map.getBounds().getSouthWest().lat();
            var newLat;

            if (latNorth < 85 && latSouth > -85) /* in both side -> it's ok */
                return;
            else {
                if (latNorth > 85 && latSouth < -85) /* out both side -> it's ok */
                    return;
                else {
                    if (latNorth > 85)
                        newLat = map.getCenter().lat() - (latNorth - 85);
                    /* too north, centering */
                    if (latSouth < -85)
                        newLat = map.getCenter().lat() - (latSouth + 85);
                    /* too south, centering */
                }
            }
            if (newLat) {
                var newCenter = new google.maps.LatLng(newLat, map.getCenter().lng());
                map.setCenter(newCenter);
            }
        }
        //================map initialize===========================
        function drawingFunctions(map,data){
            map.setCenter(new google.maps.LatLng(Number(data.region_data[0].x),Number(data.region_data[0].y)));
            map.setZoom(12);
            var triangleCoords = [];
            for(var i=0;i<data.region_data.length;i++){
                triangleCoords.push({
                    lat: Number(data.region_data[i].x), lng: Number(data.region_data[i].y)
                })
            }
            // Construct the polygon.
            bermudaTriangle = new google.maps.Polygon({
                paths: triangleCoords,
                strokeColor: data.strokeColor,
                strokeOpacity: 1,
                strokeWeight: 2,
                fillColor: data.fillColor,
                fillOpacity: 0.5,
                id: data.fillColor == 'transparent' ?'parent':'child'
            });
            bermudaTriangle.setOptions({
                editable: false
            });
            bermudaTriangle.setMap(map);
            regionsArray.push(bermudaTriangle)
        };
        function mapInitialize(type)
        {
            mapProp = {
                center: myCenter,
                zoom: Number(zoomLevel),
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                minZoom: 3,
                maxZoom: 15,
                scrollwheel: false
            };
            if(type == '1'){
                map=new google.maps.Map(document.getElementById("googleMap"),mapProp);
            }
            else if(type == '2'){
                map=new google.maps.Map(document.getElementById("googleMapPop"),mapProp);
            }
            else if(type == '3'){
                map=new google.maps.Map(document.getElementById("googleMapEdit"),mapProp);
            }
            google.maps.event.addListener(map, 'center_changed', function () {
                checkBounds(map);
            });
        };
        //==========================branch selected==========================
        function branchChanged(type){
            if(type == '0'){
                vm.dataToFill.actualRoute = '';
            }
            if(regionsArray && regionsArray.length){
                setMapOnAll(null,1);
            }
            branchCount = branchCount + 1;
            vm.dataToFill.branch = vm.dataToFill.branchDetails.region_id;
            drawingFunctions(map,vm.dataToFill.branchDetails);
            vm.routeDisabled = false;

            //var dataSend = {};
            //dataSend.offset = 0;
            //dataSend.limit = 0;
            //dataSend.key = 2;
            //dataSend.search_filter = 0;
            //dataSend.branch_id = Number(vm.dataToFill.branch);
            //dataSend.access_token = $cookies.get('obj');
            //
            //vm.loading = true;
            //var promise = getGeofence.getAllFixedRoute(dataSend);
            //promise.then(
            //    function (payload) {
            //        $log.log('sxdsads', payload);
            //        vm.loading = false;
            //        vm.routeList = [];
            //        for(var i=0;i<payload.title.data.result.length;i++){
            //            if(payload.title.data.result[i].status == 1){
            //                vm.routeList.push(payload.title.data.result[i]);
            //            }
            //        }
            //        if(vm.routeList.length){
            //            for(var i=0;i<vm.routeList.length;i++){
            //                vm.routeList[i].location1 = {};
            //                vm.routeList[i].location2 = {};
            //                vm.routeList[i].location1.region_id = vm.routeList[i].origin_region_id;
            //                vm.routeList[i].location1.region_data = vm.routeList[i].origin_region_data;
            //                vm.routeList[i].location1.parent_id = vm.routeList[i].origin_parent_id;
            //                vm.routeList[i].location2.region_id = vm.routeList[i].destination_region_id;
            //                vm.routeList[i].location2.region_data = vm.routeList[i].destination_region_data;
            //                vm.routeList[i].location2.parent_id = vm.routeList[i].destination_parent_id;
            //                vm.routeList[i].strokeColor = '#063c4a';
            //                vm.routeList[i].fillColor = '#063c4a';
            //            }
            //            vm.routeDisabled = false;
            //        }
            //        else{
            //            vm.routeDisabled = true;
            //            languageBasedErrorFactory.getProperErrorMessage('branchRouteNo',0,0);
            //            //errorMessageFactory.showErrorMessage('This branch does not have any route.',0);
            //        }
            //    },
            //    function (errorPayload) {
            //        vm.loading = false;
            //        if(errorPayload.data.status == 401){
            //            errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
            //        }
            //        else{
            //            errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
            //        }
            //    });
        };

        //===========================search routes=================================
        vm.paginationFunction = paginationFunction;
        vm.skipSearchRoute = 0;
        vm.limitSearchRoute = 30;
        vm.routeList = [];
        //
        function paginationFunction(){
            vm.skipSearchRoute = vm.skipSearchRoute + 30;
            searchRoutesInput(vm.dataToFill.actualRoute,'page',vm.skipSearchRoute,vm.limitSearchRoute,false);
        }

        function searchRoutesInput(data,type,skip,limit,load){
            var dataSend = {};
            dataSend.offset = skip;
            dataSend.limit = limit;
            dataSend.key = 2;
            dataSend.search_filter = 1;
            dataSend.search_value = data;
            dataSend.branch_id = Number(vm.dataToFill.branch);
            dataSend.access_token = $cookies.get('obj');

            vm.loading = load;
            var promise = getGeofence.getAllFixedRoute(dataSend);
            return promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if(type != 'page'){
                        vm.routeList = [];
                    }

                    if(type == 'edit'){
                        vm.dataToFill.routeDetails = '';
                    }
                    for(var i=0;i<payload.title.data.result.length;i++){
                        if(payload.title.data.result[i].status == 1){
                            vm.routeList.push(payload.title.data.result[i]);
                        }
                    }
                    if(vm.routeList.length){
                        for(var i=0;i<vm.routeList.length;i++){
                            vm.routeList[i].location1 = {};
                            vm.routeList[i].location2 = {};
                            vm.routeList[i].location1.region_id = vm.routeList[i].origin_region_id;
                            vm.routeList[i].location1.region_data = vm.routeList[i].origin_region_data;
                            vm.routeList[i].location1.parent_id = vm.routeList[i].origin_parent_id;
                            vm.routeList[i].location2.region_id = vm.routeList[i].destination_region_id;
                            vm.routeList[i].location2.region_data = vm.routeList[i].destination_region_data;
                            vm.routeList[i].location2.parent_id = vm.routeList[i].destination_parent_id;
                            vm.routeList[i].strokeColor = '#063c4a';
                            vm.routeList[i].fillColor = '#063c4a';
                        }
                        vm.routeDisabled = false;
                        return vm.routeList;
                    }
                    else{
                        vm.routeDisabled = false;
                        //languageBasedErrorFactory.getProperErrorMessage('branchRouteNo',0,0);
                        //errorMessageFactory.showErrorMessage('This branch does not have any route.',0);
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                });
        };


        function onSelectingRoute(){
            var dataSend = {};
            dataSend.region_id = vm.dataToFill.actualRoute.id;
            dataSend.access_token = $cookies.get('obj');
            vm.loading = true;
            var promise = getGeofence.getAllFixedRouteNew(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    var data = payload.title.data.result[0];
                    vm.dataToFill.routeDetails = data;
                    vm.dataToFill.routeDetails.location1 = {};
                    vm.dataToFill.routeDetails.location2 = {};
                    vm.dataToFill.routeDetails.strokeColor = '#063c4a';
                    vm.dataToFill.routeDetails.fillColor = '#063c4a';
                    vm.dataToFill.routeDetails.location1.region_id = data.origin_region_id;
                    vm.dataToFill.routeDetails.location1.region_data = data.origin_region_data;
                    vm.dataToFill.routeDetails.location1.parent_id = data.origin_parent_id;
                    vm.dataToFill.routeDetails.location2.region_id = data.destination_region_id;
                    vm.dataToFill.routeDetails.location2.region_data = data.destination_region_data;
                    vm.dataToFill.routeDetails.location2.parent_id = data.destination_parent_id;
                    selectedRouteFromList();
                },
                function (errorPayload) {
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                });
        }

        //=======================route selected===========================
        function selectedRouteFromList(type){
            if(vm.dataToFill.routeDetails || vm.dataToFill.route_id){
                if(type){
                    vm.dataToFill.routeDetails = _.where(vm.routeList,{id: Number(vm.dataToFill.route_id)})[0];
                }
                if(regionsArray && regionsArray.length){
                    setMapOnAll(null,0);
                }
                vm.dataToFill.route_id = vm.dataToFill.routeDetails.id;
                var dataPick = {
                    fillColor: "#063c4a",
                    name: vm.dataToFill.routeDetails.location1.region_name,
                    id: vm.dataToFill.routeDetails.id,
                    strokeColor: "#063c4a",
                    region_data: vm.dataToFill.routeDetails.location1.region_data[0]
                };
                drawingFunctions(map,dataPick);
                var dataDrop = {
                    fillColor: "#063c4a",
                    name: vm.dataToFill.routeDetails.location2.region_name,
                    id: vm.dataToFill.routeDetails.id,
                    strokeColor: "#063c4a",
                    region_data: vm.dataToFill.routeDetails.location2.region_data[0]
                };
                drawingFunctions(map,dataDrop);
            }
        };
        //========================add more routes flag ==================================
        function addMoreRoutes(){
            vm.dataToFill = {
                type_of_service_id: [],
                route_id: '',
                price_list_id: Number($stateParams.priceListId),
                comments: '',
                price: '',
                branch: '',
                branchDetails: '',
                routeDetails: '',
                id: ''
            };
            vm.editFixedRouteDetailsFlag = false;
            vm.fixedRouteFlag = true;
            $timeout(function(){
                mapInitialize(1);
            },100);
        };

        function addFixedRouteHit(){
            $log.log(vm.dataToFill);
            if(!vm.dataToFill.routeDetails){
                languageBasedErrorFactory.getProperErrorMessage('routesReq',0,0);
                return;
            }
            var dataSend = {};
            dataSend.contract_id = $stateParams.contractId;
            dataSend.access_token = $cookies.get('obj');

            dataSend.variable_pricing = [];

            dataSend.variable_pricing.push({
                type_of_service_id : vm.dataToFill.type_of_service_id,
                route_id: vm.dataToFill.route_id,
                price_list_id: vm.dataToFill.price_list_id,
                comments: vm.dataToFill.comments,
                price:  vm.dataToFill.price
            });
            vm.loading = true;
            var promise = getAgreement.addPriceListRouteFixed(dataSend);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    languageBasedErrorFactory.getProperErrorMessage('fixedPriceSucc',0,1,'layout.agreementMain.fixedPriceListRoute');
                    //errorMessageFactory.showErrorMessage('Price for fixed route added successfully.',1);
                    //$timeout(function() {
                    //    $mdDialog.hide();
                    //    $state.reload();
                    //}, 2000);
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        //===========================get all itemof charges==========================
        function getAllItemOfCharges(){
            vm.loading = true;
            var promise = getItemOfCharge.getItemOfChargePagination(0, 0, 2);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if(payload.title.data.result.length) {
                        var where = _.where(payload.title.data.result, {state: 1});
                        vm.itemOfChargeList = where;
                    }
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        getAllItemOfCharges();
        //========================function to add item of charge============================
        function addItemOfCharge(data,$event,type){
            if(vm.itemOfChargeList && vm.itemOfChargeList.length == 0) {
                vm.itemOfChargeList = [];
                languageBasedErrorFactory.getProperErrorMessage('itemErr',0,0);
                //errorMessageFactory.showErrorMessage('Please add items of charge first.');
                return;
            }
            vm.finalGotItemOfCharges = [];
            if(type){
                vm.finalGotItemOfCharges = vm.itemOfChargeList.reduce(function (prev, value) {
                    var isDuplicate = false;
                    if(data.item_of_charge && data.item_of_charge.length){
                        for (var i = 0; i < data.item_of_charge.length; i++) {
                            if (value.id == data.item_of_charge[i].id) {
                                isDuplicate = true;
                                break;
                            }
                        }
                        if (!isDuplicate) {
                            prev.push(value);
                        }

                        return prev;
                    }
                    else{
                        prev.push(value);
                        return prev;
                    }
                }, []);
            }
            else{
                vm.finalGotItemOfCharges = vm.itemOfChargeList.reduce(function (prev, value) {
                    var isDuplicate = false;
                    if(data.item_of_charge && data.item_of_charge.length){
                        for (var i = 0; i < data.item_of_charge.length; i++) {
                            if (value.id == data.item_of_charge[i].id) {
                                isDuplicate = true;
                                break;
                            }
                        }
                        if (!isDuplicate) {
                            prev.push(value);
                        }

                        return prev;
                    }
                    else{
                        prev.push(value);
                        return prev;
                    }
                }, []);
            }


            if(vm.finalGotItemOfCharges && vm.finalGotItemOfCharges.length == 0) {
                vm.finalGotItemOfCharges = [];
                languageBasedErrorFactory.getProperErrorMessage('itemErr',0,0);
                //errorMessageFactory.showErrorMessage('Please add items of charge first.');
                return;
            }
            vm.items = {
                priceListId: data.id,
                allItemsOfCharges: vm.finalGotItemOfCharges,
                selectedItem: '',
                price: '0',
                disablePrice: true,
                showPrice: true
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/addItemOfChargeInPrice.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });
            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    $mdDialog.hide();
                    addItemOfChargeFixedHit(vm.items);
                };

                $scope.checkItem = function(data){
                    $scope.checkItemOfChargeCallCenter = _.where($scope.items.allItemsOfCharges,{id:data});
                    if($scope.checkItemOfChargeCallCenter[0].manually){
                        $scope.items.disablePrice = false;
                        $scope.items.showPrice = true;
                    }
                    else if($scope.checkItemOfChargeCallCenter[0].manually == 0 && $scope.checkItemOfChargeCallCenter[0].mode == 1){
                        $scope.items.disablePrice = false;
                        $scope.items.showPrice = true;
                    }
                    else{
                        $scope.items.disablePrice = true;
                        $scope.items.showPrice = false;
                    }
                }
            }
        };

        //=====================item of charge for fixed=============================
        function addItemOfChargeFixedHit(data){
            $log.log(data);

            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.transvip_contract_fixed_pricing_id = data.priceListId;
            dataSend.item_charge_id = data.selectedItem;
            if(data.selectedItem == 2){
                dataSend.toll_charge_way = data.toll;
                if(data.toll != "2"){
                    dataSend.price = data.price ? data.price : 0;
                }
            }else{
                dataSend.price = data.price ? data.price : 0;
            }

            vm.loading = true;
            var promise = getItemOfCharge.addFixedItemOfCharge(dataSend);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    var dataForSysLogs = {
                        access_token: $cookies.get('obj'),
                        id: data.priceListId,
                        identity : 9,
                        message : 'Fixed route item of charge added.'
                    };
                    $rootScope.systemLogsAdmin(dataForSysLogs);
                    languageBasedErrorFactory.getProperErrorMessage('itemSucc',0,1,'layout.agreementMain.fixedPriceListRoute');
                    //errorMessageFactory.showErrorMessage('Item of charge added successfully.',1);
                    //$timeout(function() {
                    //    $mdDialog.hide();
                    //    $state.reload();
                    //}, 2000);
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );
        };
        //===========================change price list status=========================
        function changePriceListRouteStatus(data,$event){
            $log.log(data);

            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('priceRouteStatusPop',0,'3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton',0,'3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton',0,'3'));

            $mdDialog.show(confirm).then(function() {
                $log.log('confirmed',data);
                if(data.status == 0 || data.status == '0'){
                    var a = 1;
                }
                else if(data.status == 1 || data.status == '1'){
                    var a = 0;
                }
                var dataSend = {};
                dataSend.fixed_route_id = data.id;
                dataSend.access_token = $cookies.get('obj');
                dataSend.status = a;
                dataSend.type_of_service = [];
                //errorMessageFactory.showErrorMessage('Functionality is pending.',0);
                vm.loading = true;
                var promise = getAgreement.editAgreementFixedRoutePriceList(dataSend);
                promise.then(
                    function(payload) {
                        $log.log(payload);
                        vm.loading = false;
                        var dataForSysLogs = {
                            access_token: $cookies.get('obj'),
                            id: data.id,
                            identity : 9,
                            message : 'Fixed route status edited.'
                        };
                        $rootScope.systemLogsAdmin(dataForSysLogs);

                        $state.reload('layout.agreementMain.fixedPriceListRoute');
                    },
                    function(errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if(errorPayload.data.status == 401){
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                        }
                        else{
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                        }
                    }
                );

            }, function() {
                $log.log('not confirmed');
            });
        };

        //====================show branch on map pop up=============================
        function showBranchOnMap(data,$event){
            var where = _.where(vm.branchList,{region_id:data.route_id.location1.parent_id});
            var pickUp = {
                fillColor: "#063c4a",
                name: data.route_id.location1.region_name,
                id: data.route_id.location1.region_id,
                strokeColor: "#063c4a",
                region_data: data.route_id.location1.region_data[0]
            };
            var dropOff = {
                fillColor: "#063c4a",
                name: data.route_id.location2.region_name,
                id: data.route_id.location2.region_id,
                strokeColor: "#063c4a",
                region_data: data.route_id.location2.region_data[0]
            };

            vm.items = {
                parent: where[0],
                child1: pickUp,
                child2: dropOff
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/agreementFixedRouteMapView.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });
            function DialogController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.callMap = function(){
                    $timeout(function(){
                        mapInitialize(2);
                        drawingFunctions(map,$scope.items.parent);
                        drawingFunctions(map,$scope.items.child1);
                        drawingFunctions(map,$scope.items.child2);
                    },500);
                };
                $scope.callMap();
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
            }
        };

        //=====================to delete route and branch====================
        function deleteRouteAndBranch($event,data) {

            var msg = languageBasedErrorFactory.getProperErrorMessage('deleteFixedRoutePop',0,'3');

            var confirm = $mdDialog.confirm()
                .title(msg)
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton',0,'3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton',0,'3'));

            $mdDialog.show(confirm).then(function() {
                $log.log('confirmed');
                errorMessageFactory.showErrorMessage('Functionality is pending.',0);
                //vm.loading = true;
                //var promise = getDrivers.deleteUser(id);
                //promise.then(
                //    function(payload) {
                //        $log.log(payload);
                //        vm.loading = false;
                //        errorMessageFactory.showErrorMessage('Route deleted successfully.',1);
                //    },
                //    function(errorPayload) {
                //        $log.log(errorPayload);
                //        vm.loading = false;
                //        if(errorPayload.data.status == 401){
                //            errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                //        }
                //        else{
                //            errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                //        }
                //    }
                //);
            }, function() {
                $log.log('not confirmed');
            });
        };


        //==========================edit details of route=====================================
        function editRouteBranchDetails(data){
            vm.fixedRouteFlag = false;
            vm.editFixedRouteDetailsFlag = true;

            vm.dataToFill.comments = data.comments;
            vm.dataToFill.actualRoute = data.route_id;
            //vm.dataToFill.route_id = data.route_id.id;
            //vm.dataToFill.routeDetails = data.route_id;
            //vm.dataToFill.routeDetails.strokeColor = '#063c4a';
            //vm.dataToFill.routeDetails.fillColor = '#063c4a';
            vm.dataToFill.price = data.price;
            vm.dataToFill.id = data.id;
            vm.dataToFill.type_of_service_id = [];
            if(data.typeOfService && data.typeOfService.length){
                for(var i=0;i<data.typeOfService.length;i++){
                    vm.dataToFill.type_of_service_id.push(data.typeOfService[i].id);
                }
            }
            else{
                vm.dataToFill.type_of_service_id = [];
            }
            vm.dataToFill.branch = data.route_id.location1.parent_id;
            vm.dataToFill.branchDetails = _.where(vm.agreementBranches,{region_id:data.route_id.location1.parent_id})[0];//agreementBranches
            $timeout(function(){
                mapInitialize(3);
                branchChanged();
                onSelectingRoute();
                //selectedRouteFromList();
            },100);
        };

        function editFixedRouteDetailsHit(){
            //errorMessageFactory.showErrorMessage('Functionality is pending.',0);
            if(!vm.dataToFill.routeDetails){
                languageBasedErrorFactory.getProperErrorMessage('routesReq',0,0);
                return;
            }
            $log.log(vm.dataToFill);
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.fixed_route_id = vm.dataToFill.id;
            dataSend.type_of_service = vm.dataToFill.type_of_service_id;
            dataSend.comments = vm.dataToFill.comments;
            dataSend.route_id = vm.dataToFill.route_id;
            dataSend.price = vm.dataToFill.price;
            dataSend.fixed_pricing_id = vm.dataToFill.price_list_id;

            vm.loading = true;
            var promise = getAgreement.editAgreementFixedRoutePriceList(dataSend);
            promise.then(
                function(payload) {
                    $log.log(payload);
                    vm.loading = false;
                    var dataForSysLogs = {
                        access_token: $cookies.get('obj'),
                        id: vm.dataToFill.id,
                        identity : 9,
                        message : 'Fixed route edited.'
                    };
                    $rootScope.systemLogsAdmin(dataForSysLogs);
                    languageBasedErrorFactory.getProperErrorMessage('routeUpdatedSuccF',0,1,'layout.agreementMain.fixedPriceListRoute');
                    //errorMessageFactory.showErrorMessage('Fixed route price updated successfully.',1);
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if(errorPayload.data.status == 401){
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    }
                    else{
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                }
            );

        };
        //=====================to delete item of charge====================
        function deleteItemOfCharge($event,data,item) {

            var msg = languageBasedErrorFactory.getProperErrorMessage('deleteItemPop',0,'3');

            var confirm = $mdDialog.confirm()
                .title(msg)
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton',0,'3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton',0,'3'));

            $mdDialog.show(confirm).then(function() {
                $log.log('confirmed',data,item);
                //errorMessageFactory.showErrorMessage('Functionality is pending.',0);

                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.item_of_charge_fixed_id = item.item_of_charge_fixed_id;

                vm.loading = true;
                var promise = getAgreement.deleteItemOfChargeFixed(dataSend);
                promise.then(
                    function(payload) {
                        $log.log(payload);
                        vm.loading = false;
                        var dataForSysLogs = {
                            access_token: $cookies.get('obj'),
                            id: data.id,
                            identity : 9, //17
                            message : 'Fixed route item of charge deleted.'
                        };
                        $rootScope.systemLogsAdmin(dataForSysLogs);
                        languageBasedErrorFactory.getProperErrorMessage('deletedItemSucc',0,1,'layout.agreementMain.fixedPriceListRoute');
                        //errorMessageFactory.showErrorMessage('Item of charge deleted successfully.',1);
                    },
                    function(errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if(errorPayload.data.status == 401){
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                        }
                        else{
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                        }
                    }
                );
            }, function() {
                $log.log('not confirmed');
            });
        };

        //======================get all services==============
        function getAllServices(skip, limit) {
            vm.loading = false;
            var promise = getServices.allServices(skip,limit,2,0);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if(payload.title.status == 400){
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    else if(payload.title.status == 401){
                        errorMessageFactory.showErrorMessage(payload.title.message,2,'home');
                    }
                    else if(payload.title.status == 201 || payload.title.status == 200) {
                        vm.serviceListFilterGot = [];
                        angular.forEach(payload.title.data.result, function (column) {
                            vm.serviceListFilterGot.push({id: column.id, name: column.service_name});
                        });
                        vm.serviceListFilterGot.push({
                            id: 'all',
                            name: 'All'
                        })
                    }
                },
                function(errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllServices(0, 0);

        //====================event for getting refreshed================
        $scope.$on('StateReload', function(evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.agreementMain.fixedPriceListRoute');
            }
        });
        //=================go back================
        function goBack() {
            if($stateParams.path == '0'){
                $state.go('layout.agreementMain.priceListFixedAgreement',{corporateId:$stateParams.corporateId,contractId:$stateParams.contractId,path:1});
            }
            else{
                $state.go('layout.agreementMain.priceListVariableAgreement',{corporateId:$stateParams.corporateId,contractId:$stateParams.contractId,path:2});
            }
        };
        function cancel(){
            $state.reload('layout.agreementMain.fixedPriceListRoute');
        };
        //===================store details======================
        function storeDetails(){
            var data = {
                corporateId: $stateParams.corporateId,
                contractId: $stateParams.contractId,
                priceListId: $stateParams.priceListId,
                path: $stateParams.path
            };
            $cookies.put('setData',JSON.stringify(data));
        }
    }
})();
/**
 * Created by cl-macmini-51 on 22/12/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('FixedPriceListAgreementController', FixedPriceListAgreementController);

    /** @ngInject */
    function FixedPriceListAgreementController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document, moment, getAgreement, $scope, RutHelper, filterFilter, languageBasedErrorFactory, errorMessageFactory) {

        var vm = this;
        vm.loading = false;
        vm.currentPage = 0;
        vm.totalFixedPriceList = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.getPagesCount = getPagesCount;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.init = init;
        vm.sort = sort;
        vm.goBack = goBack;
        vm.goToFactor = goToFactor;
        vm.getFilter = getFilter;
        vm.readjustPrice = readjustPrice;
        vm.newListByPass = newListByPass;
        vm.getAllFixedPriceList = getAllFixedPriceList;
        vm.addHeadersPriceDetails = addHeadersPriceDetails;
        vm.decidePopUpToOpen = decidePopUpToOpen;
        vm.storeDetails = storeDetails;
        vm.cancel = cancel;
        vm.changePriceListStatus = changePriceListStatus;
        vm.editPriceListFixedApi = editPriceListFixedApi;
        vm.datePickerE_1 = datePickerE_1;
        vm.addHeadersHitF = addHeadersHitF;
        vm.editPriceListDetails = editPriceListDetails;
        vm.deletePriceList = deletePriceList;
        vm.copyPriceList = copyPriceList;
        vm.exportPriceList = exportPriceList;
        vm.paginationNew = paginationNew;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.predicate = 'index';
        vm.reverse = false;
        vm.filterData = {
            priceListStatus: '1'
        };
        vm.fixedNewListButtons = false;
        vm.dataToFillHeader = {
            type_of_pricing_list_percentage_of_price_adj: '',
            type_of_pricing_list_name: '',
            type_of_pricing_date_of_start: new Date(),
            type_of_pricing_date_of_end: new Date(),
            type_of_pricing_comments: '',
            type_of_price_type: '',
            type_of_price_status: 2,
            priceListId: ''
        };
        vm.dateOptions = {};
        vm.datePicker_1 = {
            startPriceH: false,
            endPriceH: false
        };
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.altInputFormats = ['M!/d!/yyyy'];
        vm.corporateId = $stateParams.corporateId;
        vm.contractId = $stateParams.contractId;
        vm.copyBasedFilter = {
            agreementFilter: 'all',
            statusFilter: 2,
            fixedVariableCheck: ''
        };
        $cookies.remove('setData');

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.agreementMain.priceListFixedAgreement');
            }
        });
        //==================date picker function==================
        vm.dateOptions = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(2090, 12, 31),
            //minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };

        function datePickerE_1(type) {
            if (type == '1') {
                vm.datePicker_1.endPriceH = false;
                vm.datePicker_1.startPriceH = true;
            } else if (type == '2') {
                vm.datePicker_1.endPriceH = true;
                vm.datePicker_1.startPriceH = false;
            }
        };
        //====================function for dropdown pages and page count===============
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];

        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllFixedPriceList(0, vm.itemsPerPageGot, vm.filterData.priceListStatus);
        };

        function paginationNew(page) {
            getAllFixedPriceList((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData.priceListStatus);
        }

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.agreementMain.priceListFixedAgreement');
            }
        });

        //==================get all services=======================
        function getAllFixedPriceList(skip, limit, filter) {
            vm.loading = true;
            var dataSend = {
                access_token: $cookies.get('obj'),
                contract_id: $stateParams.contractId,
                key: Number(filter),
                limit: Number(limit),
                offset: Number(skip)
            };
            var promise = getAgreement.getFixedPriceListContract(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads121212121', payload);
                    vm.loading = false;
                    vm.totalFixedPriceList = payload.title.data.totalCount;
                    vm.dataLength = payload.title.data.totalCount;
                    if (payload.title.data.extraData) {
                        if (payload.title.data.extraData.via_control_include_in_tarifa &&
                            payload.title.data.extraData.via_control_include_in_tarifa == 1) {
                            vm.tarifaKey = 'SI';
                        } else {
                            vm.tarifaKey = 'NO';
                        }
                    }
                    if (payload.title.data.totalCount == 0) {
                        vm.sp_pagination = false;
                        vm.tBodyFlag = false;
                        vm.tFootFlag = true;
                    } else {
                        vm.sp_pagination = true;
                        vm.tBodyFlag = true;
                        vm.tFootFlag = false;
                    }

                    var dataArray = [];

                    var fixedPriceList = payload.title.data.result;
                    fixedPriceList.forEach(function (column) {
                        var d = {};
                        d.comments = column.comments;
                        d.contract_id = column.contract_id;
                        d.creation_date = column.creation_date;
                        d.date_of_end = column.date_of_end;
                        d.date_of_start = column.date_of_start;
                        d.id = column.id;
                        d.is_deleted = column.is_deleted;
                        d.name = column.name;
                        d.percentage_of_price_adj = column.percentage_of_price_adj;
                        d.status = column.status;
                        d.type = column.type;
                        dataArray.push(d);
                    });
                    vm.fixedRouteListG = dataArray;

                    // USERTYPE VALUE
                    // 0 - Transvip user
                    // 1 - PET user
                    vm.userType = payload.title.data.user_type || 0;
                   
                    for (var i = 0; i < vm.fixedRouteListG.length; i++) {
                        vm.fixedRouteListG[i].index = (skip + i);
                    }
                    if (vm.dataLength <= vm.itemsPerPageGot) {
                        vm.sp_pagination = false;
                    } else {
                        vm.sp_pagination = true;
                        //vm.pageCount(payload.title.data.totalCount);
                    }
                    if (vm.fixedRouteListG.length > 0) {
                        vm.skipValue = vm.fixedRouteListG[0].index;
                        vm.limitValue = vm.fixedRouteListG[vm.fixedRouteListG.length - 1].index;
                    }

                    $scope.$watch('vm.search', function (newVal, oldVal) {
                        vm.filtered = filterFilter(vm.fixedRouteListG, newVal);
                        vm.totalItems = vm.filtered.length;
                        if (vm.filtered.length == 0) {
                            vm.watchPagination = false;
                        } else {
                            vm.watchPagination = true;
                        }
                        if (vm.filterOn == true) {
                            vm.skipValueFilter = vm.filtered.length;
                            vm.sp_pagination = false;
                        }
                    }, true);

                    //range();
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    } else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        vm.getAllFixedPriceList((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData.priceListStatus);
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        vm.currentPage++;
        //        vm.getAllFixedPriceList((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData.priceListStatus);
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    vm.getAllFixedPriceList((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData.priceListStatus);
        //};

        function init() {
            vm.getAllFixedPriceList(0, vm.searchModel.limit, vm.filterData.priceListStatus);
        };
        init();

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            vm.filterOn = true;
            if (vm.search.length == 0) {
                vm.filterOn = false;
                vm.watchPagination = true;
                vm.sp_pagination = true;
            }
        };

        //==================get all Vehicles=======================
        function getAllAggrements() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.offset = 0;
            dataSend.limit = 0;
            dataSend.key = 3;
            dataSend.id = Number($stateParams.contractId);
            vm.loading = true;
            var promise = getAgreement.allAgreementsExpenseControl(dataSend);
            promise.then(
                function (payload) {
                    $log.log('allagree', payload);
                    vm.loading = false;
                    var where = payload.title.data.result;
                    vm.contractName = where[0].name;
                    vm.corporateName = where[0].company_name;
                    vm.agreementType = where[0].agreement_type;
                    vm.agreementStatus = where[0].status;
                    if(where[0].type_of_service){
                        var arrayForTypeOfService = where[0].type_of_service.split(',');
                        vm.agreementServices = arrayForTypeOfService;
                    }
                    if(where[0].region_name){
                        var arrayForRegionName  = where[0].region_name.split(',');
                        vm.agreementBranches = arrayForRegionName;
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllAggrements();

        function getAllAggrementsLessData() {
            var promise = getAgreement.getAgreementListLessData();
            promise.then(
                function (payload) {
                    $log.log('allagree', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {

                        vm.agreementListForCopy = [];
                        vm.agreementListForCopy.push({
                            id: 'all',
                            name: 'All',
                            type: 'CORPORATE'
                        });
                        for (var i = 0; i < payload.title.data.length; i++) {
                            vm.agreementListForCopy.push({
                                id: payload.title.data[i].id,
                                name: payload.title.data[i].name,
                                type: payload.title.data[i].agreement_type
                            })
                        }
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllAggrementsLessData();
        //============================readjust price==============================
        function readjustPrice($event) {
            // errorMessageFactory.showErrorMessage('Functionality is pending');


            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/readjustPrice.html',
                locals: {
                    items: ''
                },
                bindToController: true,
                controller: reAdjustPrice
            });

            function reAdjustPrice($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.messageToShow = false;
                $scope.messageToShowInvalid = false;
                $scope.messageToShowInvalidMonto = false
                $scope.validNumber = false;
                $scope.showInputBox - false;
                $scope.messageInvalid = false;
                $scope.max = 9999;
                $scope.closeDialog = function () {
                    // newListByPass()
                    $mdDialog.hide();
                };
                $scope.MontoFija = function (value) {
                    $scope.valueRadioButton = value;
                    $scope.valuePricePercentageValue = 0 ;
                    var dataSend = {
                        access_token: $cookies.get('obj'),
                        price_list_id: vm.fixedRouteListG[0].id
                        // contract_id: $stateParams.contractId,
                        // key: Number(filter),
                        // limit: Number(limit),
                        // offset: Number(skip)
                    };
                    var promise = getAgreement.minimumPrice(dataSend);
                    promise.then(
                        function (payload) {
                            if (payload && payload.title.data) {
                                if (payload.title.status == 200) {
                                    $scope.priceValue = payload.title.data.minimum;
                                    $scope.showInputBox = true;
                                } else {
                                    errorMessageFactory.showErrorMessage(payload.title.message, 0);
                                }
                            }

                        },
                        function (errorPayload) {
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }
                $scope.valuePricePercentage = function (value) {
                    $scope.valuePricePercentageValue = (value);

                    // if ($scope.valuePricePercentageValue && ($scope.valuePricePercentageValue.indexOf('-') == 0)) {
                    if ($scope.valuePricePercentageValue < -100 || $scope.valuePricePercentageValue == -100) {

                        $scope.messageToShowInvalid = true;
                        // return false;
                    } else {
                        $scope.messageToShowInvalid = false;
                    }
                    // } 
                }
                $scope.percentage = function (value) {
                    $scope.valueRadioButton = value;
                    $scope.valuePriceMonto = 0;
                    $scope.showInputBox = false;

                }
                $scope.valuePrice = function (value, event) {
                    $scope.valuePriceMonto = (value);
                    if ($scope.valuePriceMonto && ($scope.valuePriceMonto.indexOf('-') == 0)) {
                        // $scope.valuePriceMonto = parseInt($scope.valuePriceMonto);
                        if ($scope.valuePriceMonto <= -$scope.priceValue) {
                            $scope.messageToShowInvalidMonto = true;
                            // return false;
                        } else {
                            $scope.messageToShowInvalidMonto = false;
                        }

                    }

                }


                $scope.confirmUpload = function (form) {
                    if (form.$valid == false) {
                        return false;
                    } else {
                        if ($scope.valuePriceMonto && ($scope.valuePriceMonto.indexOf('-') == 0)) {
                            if ($scope.valuePriceMonto <= -$scope.priceValue) {
                                $scope.messageToShowInvalidMonto = true;
                                return false;
                            } else {
                                $scope.messageToShowInvalidMonto = false;
                            }

                        }
                        // if ($scope.valuePricePercentageValue && ($scope.valuePricePercentageValue.indexOf('-') == 0)) {
                        if ($scope.valuePricePercentageValue < -100 || $scope.valuePricePercentageValue == -100) {
                            $scope.messageToShowInvalid = true;
                            return false;
                        } else {
                            $scope.messageToShowInvalid = false;
                        }
                        // }
                        var value;
                        if ($scope.valueRadioButton == 'monto') {
                            value = $scope.valuePriceMonto;
                        } else {
                            value = $scope.valuePricePercentageValue;
                        }
                        var type;
                        if($scope.valueRadioButton == "percentage"){
                            type = 1;
                        }   else{
                            type = 0;
                        }
                        if(value == undefined || value == '' || value == 'undefined'){
                            return false;
                        }
                        var dataSend = {
                            access_token: $cookies.get('obj'),
                            price_list_id: vm.fixedRouteListG[0].id,
                            contract_id: $stateParams.contractId,
                            adjustment_type: type,
                            adjustment_value: value,
                        };
                        var promise = getAgreement.AdjustPrice(dataSend);
                        promise.then(
                            function (payload) {
                                if (payload && payload.title.data) {
                                    if (payload.title.status == 200) {
                                        $mdDialog.hide();
                                        errorMessageFactory.showErrorMessage('Ajuste realizado correctamente. Nueva lista de precios ha sido creada en "In Progress" ', 0);
                                    } else {
                                        $mdDialog.hide();
                                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                                    }
                                }

                            },
                            function (errorPayload) {
                                vm.loading = false;
                                if (errorPayload.data.status == 401) {
                                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                                } else {
                                    errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                                }
                            }
                        );
                    }

                }

            }

        };

        //=========================new list bypass======================
        function newListByPass() {
            vm.editHeaderFFlag = false;
            vm.addHeaderFFlag = false;
            vm.fixedNewListButtons = !vm.fixedNewListButtons;
        };

        //====================headers for price list=============================
        function addHeadersPriceDetails() {
            vm.dataToFillHeader = {
                type_of_pricing_list_percentage_of_price_adj: '',
                type_of_pricing_list_name: '',
                type_of_pricing_date_of_start: new Date(),
                type_of_pricing_date_of_end: new Date(),
                type_of_pricing_comments: '',
                type_of_price_type: '',
                type_of_price_status: 2,
                priceListId: ''
            };
            vm.fixedNewListButtons = false;
            vm.addHeaderFFlag = true;
            vm.addHeaderVFlag = false;
            vm.editHeaderFFlag = false;
            vm.editHeaderVFlag = false;
            vm.dataToFillHeader.type_of_price_type = 0;
        };
        //====================headers for price list hit=============================
        function addHeadersHitF() {
            $log.log(vm.dataToFillHeader);
            if (vm.dataToFillHeader.type_of_pricing_date_of_start > vm.dataToFillHeader.type_of_pricing_date_of_end) {
                languageBasedErrorFactory.getProperErrorMessage('appropriateDateErr', 0, 0);
                //errorMessageFactory.showErrorMessage('Please choose appropriate dates.');
                return;
            }
            //if(vm.dataToFillHeader.type_of_pricing_list_percentage_of_price_adj > 100){
            //    errorMessageFactory.showErrorMessage('Please enter adjustment price less than 100.');
            //    return;
            //}

            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.contract_id = Number($stateParams.contractId);
            //dataSend.type_of_pricing_list_percentage_of_price_adj = vm.dataToFillHeader.type_of_pricing_list_percentage_of_price_adj;
            dataSend.type_of_pricing_list_name = vm.dataToFillHeader.type_of_pricing_list_name;
            dataSend.type_of_pricing_date_of_start = moment(vm.dataToFillHeader.type_of_pricing_date_of_start).format('YYYY-MM-DD HH:mm:ss');
            dataSend.type_of_pricing_date_of_end = moment(vm.dataToFillHeader.type_of_pricing_date_of_end).format('YYYY-MM-DD HH:mm:ss');
            dataSend.type_of_pricing_comments = vm.dataToFillHeader.type_of_pricing_comments;
            dataSend.type_of_price_type = Number(vm.dataToFillHeader.type_of_price_type);
            dataSend.type_of_price_status = Number(vm.dataToFillHeader.type_of_price_status);
            dataSend.timezone = new Date().getTimezoneOffset();
            vm.loading = true;
            var promise = getAgreement.addHeadersOfPriceList(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    languageBasedErrorFactory.getProperErrorMessage('priceListAddedSucc', 0, 1, 'layout.agreementMain.priceListFixedAgreement');
                    //errorMessageFactory.showErrorMessage('Price list added successfully.',1);
                    //$timeout(function() {
                    //    $mdDialog.hide();
                    //    $state.reload();
                    //}, 2000);
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        function decidePopUpToOpen($event) {
            vm.copyBasedFilter = {
                agreementFilter: 'all',
                statusFilter: 2,
                fixedVariableCheck: ''
            };
            openFixedBasedPopup(vm.copyBasedFilter, $event);
        };

        function copyBasedPriceListPop(data, $event) {
            if (vm.copyBasedFilter.fixedVariableCheck == 1 || vm.copyBasedFilter.fixedVariableCheck == '1') {
                vm.agreementListForCopy_1 = _.where(vm.agreementListForCopy, {
                    type: 'CORPORATE'
                });
            } else {
                vm.agreementListForCopy_1 = vm.agreementListForCopy;
            }
            vm.items = {
                agreementListForCopy: vm.agreementListForCopy_1,
                agreementFilter: 'all',
                statusFilter: '2',
                priceListData: data,
                filterData: vm.copyBasedFilter
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/copyBasedPriceList.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: CopyBasedPriceListController
            });

            function CopyBasedPriceListController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    newListByPass()
                    $mdDialog.hide();
                };
                $scope.agreementChangeFilter = function (data) {
                    $scope.items.filterData.agreementFilter = data;
                    $scope.makeApiHit($scope.items.filterData);
                };
                $scope.statusChangeFilter = function (data) {
                    $scope.items.filterData.statusFilter = data;
                    $scope.makeApiHit($scope.items.filterData);
                };

                $scope.makeApiHit = function (filterData) {
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.list_key = Number(filterData.fixedVariableCheck);
                    dataSend.state = Number(filterData.statusFilter);
                    if (filterData.agreementFilter != 'all')
                        dataSend.contact_id = Number(filterData.agreementFilter);
                    $scope.loading1 = true;
                    var promise = getAgreement.getBasedPriceListData(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log(payload);
                            $scope.loading1 = false;
                            $scope.items.priceListData = payload.title.data;
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            $scope.loading1 = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                };

                $scope.copyBasedPriceList = function (data, $event) {
                    confirmPopUpForCopy(data, $event);
                }
            }
        }

        function confirmPopUpForCopy(data, $event) {
            var msg = languageBasedErrorFactory.getProperErrorMessage('copyBasedMsg', 0, '3');
            var confirm = $mdDialog.confirm()
                .title(msg)
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('yes', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('no', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                //errorMessageFactory.showErrorMessage('Functionality is pending');
                if (data.type == 0) {
                    copyFixedPriceListHit(data);
                }

            }, function () {
                $log.log('not confirmed');
                openFixedBasedPopup(vm.copyBasedFilter, $event);
            });
        }
        //==========================copy price list===========================
        function copyPriceList(data, $event) {
            var msg = languageBasedErrorFactory.getProperErrorMessage('copyPop', 0, '3');
            var confirm = $mdDialog.confirm()
                .title(msg)
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                //errorMessageFactory.showErrorMessage('Functionality is pending');
                copyFixedPriceListHit(data.id);

            }, function () {
                $log.log('not confirmed');
            });
        };

        function copyFixedPriceListHit(data) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.price_list_id = data.id ? data.id : data;
            if (data.contract_id)
                dataSend.agreement_id = $stateParams.contractId;

            vm.loading = true;
            var promise = getAgreement.copyPriceList(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    var dataForSysLogs = {
                        access_token: $cookies.get('obj'),
                        id: data.id ? data.id : data,
                        identity: 18,
                        message: 'Fixed price list copied.'
                    };
                    $rootScope.systemLogsAdmin(dataForSysLogs);
                    languageBasedErrorFactory.getProperErrorMessage('copyPopSucc', 0, 1, 'layout.agreementMain.priceListFixedAgreement');
                    //errorMessageFactory.showErrorMessage('List copied successfully.',1);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }


        function openFixedBasedPopup(filterData, $event) {
            vm.copyBasedFilter.fixedVariableCheck = 0;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.list_key = 0;
            dataSend.state = Number(filterData.statusFilter);
            if (filterData.agreementFilter != 'all')
                dataSend.contact_id = Number(filterData.agreementFilter);
            vm.loading = true;
            var promise = getAgreement.getBasedPriceListData(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    copyBasedPriceListPop(payload.title.data, $event);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        //===========================change price list status=========================
        function changePriceListStatus(data, $event) {
            $log.log(data);

            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('priceListStatusPop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed', data);
                var dataSend = {};
                dataSend.contract_id = data.contract_id;
                dataSend.access_token = $cookies.get('obj');
                dataSend.price_list_id = data.id;
                dataSend.type_of_price_list = data.type;
                if (data.status == '2' || data.status == 2) {
                    vm.loading = true;
                    var promise = getAgreement.changeStatusPriceListActive(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log(payload);
                            vm.loading = false;
                            var dataForSysLogs = {
                                access_token: $cookies.get('obj'),
                                id: data.id,
                                identity: 18,
                                message: 'Price list activated.'
                            };
                            $rootScope.systemLogsAdmin(dataForSysLogs);
                            $state.reload('layout.agreementMain.priceListFixedAgreement');
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                } else if (data.status == '0' || data.status == 0) {
                    vm.loading = true;
                    var promise = getAgreement.changeStatusPriceListInActive(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log(payload);
                            vm.loading = false;
                            var dataForSysLogs = {
                                access_token: $cookies.get('obj'),
                                id: data.id,
                                identity: 18,
                                message: 'Price list deactivated.'
                            };
                            $rootScope.systemLogsAdmin(dataForSysLogs);
                            $state.reload('layout.agreementMain.priceListFixedAgreement');
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }

            }, function () {
                $log.log('not confirmed');
            });
        };

        //===========================edit price list details=========================
        function editPriceListDetails(data) {
            vm.fixedNewListButtons = false;
            vm.editHeaderFFlag = true;
            vm.addHeaderFFlag = false;
            vm.dataToFillHeader.type_of_pricing_list_name = data.name;
            vm.dataToFillHeader.type_of_pricing_list_percentage_of_price_adj = data.percentage_of_price_adj;
            vm.dataToFillHeader.type_of_pricing_date_of_start = new Date(data.date_of_start);
            vm.dataToFillHeader.type_of_pricing_date_of_end = new Date(data.date_of_end);
            vm.dataToFillHeader.type_of_pricing_comments = data.comments;
            vm.dataToFillHeader.type_of_price_type = data.type;
            vm.dataToFillHeader.type_of_price_status = data.status;
            vm.dataToFillHeader.priceListId = data.id;
        };

        function editPriceListFixedApi() {
            $log.log(vm.dataToFillHeader);
            if (vm.dataToFillHeader.type_of_pricing_date_of_start > vm.dataToFillHeader.type_of_pricing_date_of_end) {
                //errorMessageFactory.showErrorMessage('Please choose appropriate dates.');
                languageBasedErrorFactory.getProperErrorMessage('appropriateDateErr', 0, 0);
                return;
            }
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.pricing_list_id = vm.dataToFillHeader.priceListId;
            dataSend.name = vm.dataToFillHeader.type_of_pricing_list_name;
            dataSend.comments = vm.dataToFillHeader.type_of_pricing_comments;
            dataSend.date_of_end = moment(vm.dataToFillHeader.type_of_pricing_date_of_end).format('YYYY-MM-DD HH:mm:ss');
            //dataSend.percentage_of_price_adj = vm.dataToFillHeader.type_of_pricing_list_percentage_of_price_adj;
            dataSend.date_of_start = moment(vm.dataToFillHeader.type_of_pricing_date_of_start).format('YYYY-MM-DD HH:mm:ss');
            dataSend.timezone = new Date().getTimezoneOffset();

            vm.loading = true;
            var promise = getAgreement.editAgreementPriceList(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    var dataForSysLogs = {
                        access_token: $cookies.get('obj'),
                        id: vm.dataToFillHeader.priceListId,
                        identity: 18,
                        message: 'Price list updated.'
                    };
                    $rootScope.systemLogsAdmin(dataForSysLogs);
                    languageBasedErrorFactory.getProperErrorMessage('priceListEditSucc', 0, 1, 'layout.agreementMain.priceListFixedAgreement');
                    //errorMessageFactory.showErrorMessage('List updated successfully.',1);
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        //=====================to delete route and branch====================
        function deletePriceList($event, data) {

            var msg = languageBasedErrorFactory.getProperErrorMessage('priceListDeletePopF', 0, '3');

            var confirm = $mdDialog.confirm()
                .title(msg)
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                var dataSend = {
                    is_deleted: 1,
                    price_list_id: data.id,
                    access_token: $cookies.get('obj')
                };
                vm.loading = true;
                var promise = getAgreement.deleteFixedPriceList(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        languageBasedErrorFactory.getProperErrorMessage('priceListDeleteSuccF', 0, 1, 'layout.agreementMain.priceListFixedAgreement');
                        //errorMessageFactory.showErrorMessage('Fixed price list deleted successfully.',1);
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        };

        //============================export prce list===============================
        function exportPriceList(data, $event) {
            vm.loading = true;
            var dataSend = {
                access_token: $cookies.get('obj'),
                price_list_id: data.id,
                key: 2
            };
            var promise = getAgreement.getFixedRoutePriceList(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads123', payload);
                    if (payload.title.data.length == 0) {
                        languageBasedErrorFactory.getProperErrorMessage('exportErr', 0, 0);
                        //errorMessageFactory.showErrorMessage('No data available to export.',0);
                        vm.loading = false;
                        return;
                    } else {
                        var dataArray = [];
                        var exportList = payload.title.data.result;
                        exportList.forEach(function (column) {
                            var d = {};
                            d['Price List ID'] = column.price_list_id.id;
                            d['Price List Name'] = column.price_list_id.name;
                            d['Price List Type'] = column.price_list_id.type == 0 ? 'Fixed' : 'Variable';
                            d['Percentage Price Adjustment'] = column.price_list_id.percentage_of_price_adj;
                            d['Price List Start Date'] = moment(column.price_list_id.date_of_start).format('lll');
                            d['Price List End Date'] = moment(column.price_list_id.date_of_end).format('lll');
                            d['Price List Comments'] = column.price_list_id.comments;
                            if (column.price_list_id.status == 0) {
                                d['Price List Status'] = 'Active';
                            } else if (column.price_list_id.status == 1) {
                                d['Price List Status'] = 'Inactive';
                            } else if (column.price_list_id.status == 2) {
                                d['Price List Status'] = 'In Progress';
                            }
                            d['Stretch ID'] = column.id;
                            d['Stretch Price'] = column.price;
                            d['Stretch Status'] = column.status == 0 ? 'Inactive' : 'Active';
                            d['Stretch Services'] = [];
                            if (column.typeOfService && column.typeOfService.length) {
                                for (var i = 0; i < column.typeOfService.length; i++) {
                                    d['Stretch Services'].push(column.typeOfService[i].service_name);
                                }
                            } else {
                                d['Stretch Services'] = [];
                            }
                            d['Stretch Item of Charge Name'] = [];
                            d['Stretch Item of Charge Price'] = [];
                            if (column.item_of_charge && column.item_of_charge.length) {
                                for (var i = 0; i < column.item_of_charge.length; i++) {
                                    d['Stretch Item of Charge Name'].push(column.item_of_charge[i].long_name);
                                    d['Stretch Item of Charge Price'].push(column.item_of_charge[i].price);
                                }
                            } else {
                                d['Stretch Item of Charge Name'] = [];
                                d['Stretch Item of Charge Price'] = [];
                            }
                            d['Stretch Comments'] = column.comments;
                            dataArray.push(d);
                        });
                        vm.exportList = dataArray;
                        alasql('SELECT * INTO CSV("fixedPriceList.csv",{headers:true}) FROM ?', [vm.exportList]);
                        //if(format == 'csv'){
                        //
                        //}
                        //else if(format == 'excel'){
                        //    alasql('SELECT * INTO XLS("carrier.xls",{headers:true}) FROM ?',[$scope.exportList]);
                        //}
                        vm.loading = false;
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //=================go back================
        function goBack() {
            $state.go('layout.agreementMain.agreement');
        };

        function goToFactor() {
            $state.go('layout.factorMultiplicadorMain.factorMultiplicador', {
                params: $stateParams,
                tipo: 1, //tipo fijo
                contractId: $stateParams.contractId,
                corporateId: $stateParams.corporateId,
            });
        };

        function cancel() {
            $state.reload('layout.agreementMain.priceListFixedAgreement');
        };
        //===================store details======================
        function storeDetails() {
            var data = {
                corporateId: $stateParams.corporateId,
                contractId: $stateParams.contractId,
                path: $stateParams.path
            };
            $cookies.put('setData', JSON.stringify(data));
        }
    }
})();

/**
 * Created by cl-macmini-51 on 6/13/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('ViewAgreementDetailsController', ViewAgreementDetailsController);

    /** @ngInject */
    function ViewAgreementDetailsController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document, moment,
        $scope, RutHelper, getCorporate, getServices, getPaymentMethods, getAgreement, languageBasedErrorFactory, errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.goBack = goBack;
        vm.getParticularAgreementDetails = getParticularAgreementDetails;
        vm.dataToFill = {
            startDate: new Date(),
            endDate: new Date(),
            agreementName: '',
            agreementType: '',
            corporateName: '',
            typeOfService: [],
            noShowCharges: '',
            waitTolerance: '',
            waitTimeFree: '',
            waitRoute: '',
            baseFareDiscount: '',
            commercialClassification: '',
            paymentMethod: '',
            payment_method_id: [],
            virtualFleet: '',
            comments: '',
            contractAdmin: '',
            fareToCustomer: false,
            fareToDriver: false,
            passengerRut: false,
            applicantRut: false,
            authrizerRut: false,
            invoiceCustomer: false,
            invoiceApplicant: false,
            invoiceContactPerson: false,
            invoiceContractPerson: false,
            invoiceEmployee: false,
            roundTripWaitTime: false,
            costCenter: false,
            costSubCenter: false,
            rol: false,
            graph: false,
            workOrder: false,
            pep: false,
            numberVoucher: false,
            nomina: false,
            solicitude: false,
            purpouseOfTrip: false,
            authLoadProfile: false,
            employeeData: [],
            id: '',
            branch: [],
            employeeEndowment: '0',
            emailAdministrator: '',
            controlledWay: '',
            roundTripDiscount: '',
            webPayDiscount: '',
            sharedServices: false,
            groupServices: false,
            groupExternal: false,
            chargeFullPath:false,
            chargeEachReservation:false,
            enableSMS: false,
            applyCharge: false,
            collectEstimatedTag: false,
            charge_for_estimated_travel_time: false,
            apply_qr_p: false,
            disable_sms_customer: false,
            applyEstimatedFare: false,
            crearReserva: false,
            finalizarReserva: false,
            anularReserva: false,
            marcarReserva: false,
            retarificarReserva: false,
            crearReservaSolicitante: false,
            finalizarReservaSolicitante: false,
            anularReservaSolicitante: false,
            marcarReservaSolicitante: false,
            retarificarReservaSolicitante: false,
            crearReservaAdministrador: false,
            finalizarReservaAdministrador: false,
            anularReservaAdministrador: false,
            marcarReservaAdministrador: false,
            retarificarReservaAdministrador: false,
            paraCalificarConductor : false,
            paraCalificarConductorSolicitante: false
        };
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.onScrollAddressBody = onScrollAddressBody;
        
        // Tv-2360 - On scrolling favorite addresses 
        // FOR ENDLESS SCROLLING IN ADDRESS
        function onScrollAddressBody() {
            if (vm.addressArray.length > 9)
                if (vm.addressArrayCount > vm.addressArray.length) {
                    vm.favouriteAddressesOffset += 10;
                    getAddressApi();
                }
        }
        vm.addressArrayCount = 0;
        vm.addressArray = [];
        vm.favouriteAddressesOffset = 0;
        // =====================get Address ============================
        function getAddressApi() {
            vm.loading = true;
            var dataSend = {};
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.contract_id = vm.finalAgreement[0].id;
            dataSend.limit = 10;
            dataSend.offset = vm.favouriteAddressesOffset;
            var promise = getServices.getAddress(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        payload.title.data.addresses.forEach(function(address) {
                            vm.addressArray.push(address);
                        });
                        // vm.addressArray = payload.title.data.addresses;
                        vm.addressArrayCount = payload.title.data.total_count || 0;
                        if (vm.addressArray.length == 8) {
                            vm.addressButton = false;
                        }
                    }
                    // $mdDialog.hide();
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );

        };
        // 

        //===========================get particular agreement details=============================
        function getParticularAgreementDetails() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.offset = 0;
            dataSend.limit = 0;
            dataSend.key = 3;
            dataSend.id = $stateParams.id;
            vm.loading = true;
            var promise = getAgreement.allAgreements(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.finalAgreement = payload.title.data.result;
                    getAddressApi();
                    vm.dataToFill.startDate = new Date(vm.finalAgreement[0].start_date_validity);
                    vm.dataToFill.endDate = new Date(vm.finalAgreement[0].end_date_validity);
                    vm.dataToFill.agreementName = vm.finalAgreement[0].name;
                    vm.dataToFill.agreementType = vm.finalAgreement[0].agreement_type;
                    vm.dataToFill.corporateName = vm.finalAgreement[0].corporate_id.company_name;
                    if (vm.finalAgreement[0].type_of_service && vm.finalAgreement[0].type_of_service.length) {
                        for (var i = 0; i < vm.finalAgreement[0].type_of_service.length; i++) {
                            vm.dataToFill.typeOfService.push(vm.finalAgreement[0].type_of_service[i].type_of_service_id.service_name);
                        }
                    } else {
                        vm.dataToFill.typeOfService = [];
                    }

                    vm.dataToFill.noShowCharges = vm.finalAgreement[0].charges_for_no_show;
                    vm.dataToFill.waitTolerance = vm.finalAgreement[0].max_wait_time_tolerance;
                    vm.dataToFill.waitTimeFree = vm.finalAgreement[0].max_wait_time_free;
                    vm.dataToFill.waitRoute = vm.finalAgreement[0].max_wait_time_en_route;
                    vm.dataToFill.baseFareDiscount = vm.finalAgreement[0].discount_based_fare;
                    vm.dataToFill.commercialClassification = vm.finalAgreement[0].commercial_classification;
                    vm.dataToFill.paymentMethod = vm.finalAgreement[0].payment_method_default ? vm.finalAgreement[0].payment_method_default.type : '';

                    if (vm.finalAgreement[0].payment && vm.finalAgreement[0].payment.length) {
                        for (var i = 0; i < vm.finalAgreement[0].payment.length; i++) {
                            vm.dataToFill.payment_method_id.push(vm.finalAgreement[0].payment[i][0].type);
                        }
                    } else {
                        vm.dataToFill.payment_method_id = [];
                    }
                    if (vm.finalAgreement[0].branch && vm.finalAgreement[0].branch.length) {
                        for (var i = 0; i < vm.finalAgreement[0].branch.length; i++) {
                            vm.dataToFill.branch.push(vm.finalAgreement[0].branch[i].region_name);
                        }
                    } else {
                        vm.dataToFill.branch = [];
                    }

                    vm.dataToFill.virtualFleet = vm.finalAgreement[0].virtual_fleet;
                    vm.dataToFill.comments = vm.finalAgreement[0].comments;
                    vm.dataToFill.contractAdmin = vm.finalAgreement[0].contract_admin;
                    vm.dataToFill.fareToCustomer = vm.finalAgreement[0].fare_to_customer;
                    vm.dataToFill.fareToDriver = vm.finalAgreement[0].fare_to_driver;
                    vm.dataToFill.passengerRut = vm.finalAgreement[0].RUT_mendatory;
                    vm.dataToFill.applicantRut = vm.finalAgreement[0].applicant_RUT_mendatory;
                    vm.dataToFill.authrizerRut = vm.finalAgreement[0].auth_RUT_mendatory;
                    vm.dataToFill.invoiceCustomer = vm.finalAgreement[0].invoice_to_customer;
                    vm.dataToFill.invoiceApplicant = vm.finalAgreement[0].invoice_to_applicant;
                    vm.dataToFill.roundTripWaitTime = vm.finalAgreement[0].round_trip_wait_time;
                    vm.dataToFill.invoiceContactPerson = vm.finalAgreement[0].invoice_to_contact_person;
                    //vm.dataToFill.invoiceContractPerson = vm.finalAgreement[0].start_date_validity;
                    //vm.dataToFill.invoiceEmployee = vm.finalAgreement[0].invoice_to_employee;
                    vm.dataToFill.costCenter = vm.finalAgreement[0].cost_center_mandatory;
                    vm.dataToFill.costSubCenter = vm.finalAgreement[0].cost_sub_center_mandatory;
                    vm.dataToFill.rol = vm.finalAgreement[0].ROL_mandatory;
                    vm.dataToFill.graph = vm.finalAgreement[0].graph_mandatory;
                    vm.dataToFill.workOrder = vm.finalAgreement[0].work_order_mandatory;
                    vm.dataToFill.pep = vm.finalAgreement[0].PEP_mandatory;
                    vm.dataToFill.numberVoucher = vm.finalAgreement[0].number_of_voucher_mandatory;
                    vm.dataToFill.purpouseOfTrip = vm.finalAgreement[0].purpose_of_trip_mandatory;
                    vm.dataToFill.solicitude = vm.finalAgreement[0].solicitud_mandatory;
                    vm.dataToFill.nomina = vm.finalAgreement[0].nomina_mandatory;
                    vm.dataToFill.authLoadProfile = vm.finalAgreement[0].require_auth_load_profile;
                    vm.dataToFill.airline = vm.finalAgreement[0].airline_mandatory;
                    vm.dataToFill.flight = vm.finalAgreement[0].flight_number_mandatory;
                    vm.dataToFill.flightDate = vm.finalAgreement[0].flight_date_mandatory;
                    vm.dataToFill.flightType = vm.finalAgreement[0].flight_type_mandatory;
                    vm.dataToFill.allowBookingWithoutRequest = vm.finalAgreement[0].is_bwr;
                    vm.dataToFill.monitoringServices = vm.finalAgreement[0].monitoring_services_wisetrack;
                    vm.dataToFill.id = vm.finalAgreement[0].id;
                    vm.dataToFill.controlledWay = vm.finalAgreement[0].controlled_way;
                    vm.dataToFill.viaControlled = vm.finalAgreement[0].show_via_control_in_voucher;
                    vm.dataToFill.viaControlledTarifa = vm.finalAgreement[0].via_control_include_in_tarifa;
                    vm.dataToFill.status = vm.finalAgreement[0].status;
                    vm.dataToFill.enableVaribleRate = vm.finalAgreement[0].enable_variable_rate;
                    console.log(vm.dataToFill.enableVaribleRate,'vm.dataToFill.enableVaribleRate');
                    vm.dataToFill.emailAdministrator = vm.finalAgreement[0].administrator_email ? vm.finalAgreement[0].administrator_email : '';
                    vm.dataToFill.employeeEndowment = vm.finalAgreement[0].employee_endowment.toString();
                    vm.dataToFill.sharedServices = vm.finalAgreement[0].is_mix_shared;
                    vm.dataToFill.groupServices = vm.finalAgreement[0].is_group_allowed;
                    vm.dataToFill.groupExternal = vm.finalAgreement[0].is_grouped_external;
                    vm.dataToFill.chargeFullPath = vm.finalAgreement[0].charge_for_each_reservation_grouped ? 0 : 1;
                    vm.dataToFill.chargeEachReservation = vm.finalAgreement[0].charge_for_each_reservation_grouped ? 1:0;
                    vm.dataToFill.enableSMS = vm.finalAgreement[0].enable_sms_option;
                    vm.dataToFill.applyCharge = vm.finalAgreement[0].apply_charge_by_toll;
                    vm.dataToFill.collectEstimatedTag = vm.finalAgreement[0].collect_estimated_tag;
                    vm.dataToFill.charge_for_estimated_travel_time = vm.finalAgreement[0].charge_for_estimated_travel_time;
                    vm.dataToFill.apply_qr_p = vm.finalAgreement[0].qrcode_status;
                    vm.dataToFill.sms_minutes_qr_p = vm.finalAgreement[0].sms_minutes_qr_p;
                    vm.dataToFill.restriccion_flota = vm.finalAgreement[0].restriccion_flota;
                    vm.dataToFill.disable_sms_customer = vm.finalAgreement[0].disable_sms_customer
                    vm.dataToFill.applyEstimatedFare = vm.finalAgreement[0].apply_estimated_distance_variable_fare;
                    vm.dataToFill.QTH_factor = vm.finalAgreement[0].QTH_factor;
                    vm.dataToFill.roundTripDiscount = vm.finalAgreement[0].rt_discount;
                    vm.dataToFill.webPayDiscount = vm.finalAgreement[0].web_discount;
                    vm.dataToFill.crearReserva = vm.finalAgreement[0].passenger_create_booking;
                    vm.dataToFill.finalizarReserva = vm.finalAgreement[0].passenger_end_booking;
                    vm.dataToFill.anularReserva = vm.finalAgreement[0].passenger_cancel_booking;
                    vm.dataToFill.marcarReserva = vm.finalAgreement[0].passenger_noshow_booking;
                    vm.dataToFill.retarificarReserva = vm.finalAgreement[0].passenger_correct_fare_booking;
                    vm.dataToFill.crearReservaSolicitante = vm.finalAgreement[0].applicant_create_booking;
                    vm.dataToFill.finalizarReservaSolicitante = vm.finalAgreement[0].applicant_end_booking;
                    vm.dataToFill.anularReservaSolicitante = vm.finalAgreement[0].applicant_cancel_booking;
                    vm.dataToFill.marcarReservaSolicitante = vm.finalAgreement[0].applicant_noshow_booking;
                    vm.dataToFill.retarificarReservaSolicitante = vm.finalAgreement[0].applicant_correct_fare_booking;
                    vm.dataToFill.crearReservaAdministrador = vm.finalAgreement[0].administrator_create_booking;
                    vm.dataToFill.finalizarReservaAdministrador = vm.finalAgreement[0].administrator_end_booking;
                    vm.dataToFill.anularReservaAdministrador = vm.finalAgreement[0].administrator_cancel_booking;
                    vm.dataToFill.marcarReservaAdministrador = vm.finalAgreement[0].administrator_noshow_booking;
                    vm.dataToFill.retarificarReservaAdministrador = vm.finalAgreement[0].administrator_correct_fare_booking;
                    vm.dataToFill.paraCalificarConductor = vm.finalAgreement[0].passenger_rate_driver_booking;
                    vm.dataToFill.paraCalificarConductorSolicitante = vm.finalAgreement[0].applicant_rate_driver_booking;
                    vm.dataToFill.automaticGrouping = vm.finalAgreement[0].service_grouping_type == 2 ? 1 : 0;
                    // // KEYS TO ALLOW MODIFY AMOUNT
                    // vm.dataToFill.changeFareForPos = vm.finalAgreement[0].allow_change_fare_POS;
                    // vm.dataToFill.changeFareForCreateBooking = vm.finalAgreement[0].allow_change_fare_panel;

                    vm.dataToFill.groupThreshold = vm.finalAgreement[0].threshold_value ? vm.finalAgreement[0].threshold_value : 0;
                    $log.log('sxdsads', vm.finalAgreement);
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getParticularAgreementDetails();

        //========================function to go back==========================
        function goBack() {
            $state.go('layout.agreementMain.agreement');
        }
    }
})();

/**
 * Created by cl-macmini-51 on 5/17/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('NewAgreementController', NewAgreementController);

    /** @ngInject */
    function NewAgreementController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document, moment, $scope, RutHelper,
        getCorporate, getServices, getPaymentMethods, getAgreement, getGeofence, hidePublicPlaces, languageBasedErrorFactory, errorMessageFactory, Initializer) {
        var vm = this;
        vm.loading = false;
        vm.goBack = goBack;
        vm.datePickerE_1 = datePickerE_1;
        vm.setBooleans = setBooleans;
        vm.rutChange = rutChange;
        // vm.buttonDisabled = false;
        vm.addressArray = [];
        vm.mapFn = mapFn;
        vm.deleteAddress = deleteAddress;
        vm.openPopUpForAdding = openPopUpForAdding;
        //vm.addEmployee = addEmployee;
        //vm.deleteEmployee = deleteEmployee;
        vm.setBooleanEmployee = setBooleanEmployee;
        vm.addAgreementApi = addAgreementApi;
        vm.getAllCorporate = getAllCorporate;
        vm.getAllServices = getAllServices;
        vm.getAllPaymentTypes = getAllPaymentTypes;
        vm.paymentMethodChange = paymentMethodChange;
        //vm.addVariablePrice = addVariablePrice;
        //vm.deleteVariablePrice = deleteVariablePrice;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.dateOptions = {};
        vm.datePicker_1 = {
            end: false,
            start: false,
            startPrice: false,
            endPrice: false
        };

        // Service To Get Map Instance
        Initializer.mapsInitialized
            .then(function () {
                if (google) {
                    if (document.getElementById('pickAddress') != null) {
                        var input = document.getElementById('pickAddress');
                        google.maps.event.addDomListener(input, 'keydown', function (event) {
                            if (event.keyCode === 13) {
                                event.preventDefault();

                            }
                        });
                    }
                }
            });

        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.altInputFormats = ['M!/d!/yyyy'];
        vm.dataToFill = {
            startDate: new Date(),
            endDate: new Date(),
            agreementName: '',
            groupThreshold: 0,
            agreementType: '',
            corporateName: '',
            typeOfService: [],
            noShowCharges: 0,
            waitTolerance: 0,
            waitTimeFree: 0,
            waitRoute: 0,
            baseFareDiscount: 0,
            commercialClassification: '',
            paymentMethod: '',
            payment_method_id: [],
            paymentMethodSelected: [],
            virtualFleet: '',
            comments: '',
            contractAdmin: '',
            corporateContractPerson: '',
            fareToCustomer: false,
            fareToDriver: false,
            passengerRut: false,
            applicantRut: false,
            authrizerRut: false,
            invoiceCustomer: false,
            invoiceApplicant: false,
            invoiceContactPerson: false,
            invoiceContractPerson: false,
            roundTripWaitTime: false,
            invoiceEmployee: false,
            costCenter: false,
            costSubCenter: false,
            rol: false,
            graph: false,
            workOrder: false,
            pep: false,
            numberVoucher: false,
            purpouseOfTrip: false,
            nomina: false,
            solicitude: false,
            authLoadProfile: false,
            employeeData: [{
                name: '',
                RUT: '',
                email: '',
                approval_required: false,
                thirdBooking: false,
                rutFlag: false
            }],
            type_of_pricing_list_percentage_of_price_adj: '',
            type_of_pricing_list_name: '',
            type_of_pricing_date_of_start: new Date(),
            type_of_pricing_date_of_end: new Date(),
            type_of_pricing_comments: '',
            variable_pricing: {
                type_of_service_id: "",
                coverage_area_id: "",
                comments: "",
                price: ""
            },
            branch: [],
            employeeEndowment: '0',
            controlledWay: false,
            emailAdministrator: '',
            roundTripDiscount: 0,
            webPayDiscount: 0,
            sharedServices: false,
            viaControlled: false,
            groupServices: false,
            groupExternal: false,
            chargeFullPath: false,
            chargeEachReservation: false,
            automaticGrouping: false,
            enableSMS: false,
            applyCharge: false,
            applyEstimatedFare: false,
            qthFactor: 0,
            pickUpDefault1: '',
            crearReserva: false,
            finalizarReserva: false,
            anularReserva: false,
            marcarReserva: false,
            retarificarReserva: false,
            crearReservaSolicitante: false,
            finalizarReservaSolicitante: false,
            anularReservaSolicitante: false,
            marcarReservaSolicitante: false,
            retarificarReservaSolicitante: false,
            crearReservaAdministrador: false,
            finalizarReservaAdministrador: false,
            anularReservaAdministrador: false,
            marcarReservaAdministrador: false,
            retarificarReservaAdministrador: false,
            paraCalificarConductor: false,
            paraCalificarConductorSolicitante: false
        };
        //========================function to go back==========================
        function goBack() {
            $state.go('layout.agreementMain.agreement');
        }
        //==================date picker function==================
        vm.dateOptions = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(2090, 12, 31),
            //minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };

        function datePickerE_1(type) {
            if (type == '1') {
                vm.datePicker_1.start = true;
                vm.datePicker_1.end = false;
                vm.datePicker_1.endPrice = false;
                vm.datePicker_1.startPrice = false;
            } else if (type == '2') {
                vm.datePicker_1.end = true;
                vm.datePicker_1.start = false;
                vm.datePicker_1.endPrice = false;
                vm.datePicker_1.startPrice = false;
            } else if (type == '3') {
                vm.datePicker_1.startPrice = true;
                vm.datePicker_1.start = false;
                vm.datePicker_1.end = false;
                vm.datePicker_1.endPrice = false;
            } else if (type == '4') {
                vm.datePicker_1.endPrice = true;
                vm.datePicker_1.startPrice = false;
                vm.datePicker_1.start = false;
                vm.datePicker_1.end = false;
            }
        };
        //=================validate rut=====================
        function rutChange(index) {
            $log.log(vm.dataToFill.employeeData[index].RUT);
            if (vm.dataToFill.employeeData[index].RUT) {
                if (RutHelper.validate(vm.dataToFill.employeeData[index].RUT)) {
                    $log.log();
                    vm.dataToFill.employeeData[index].rutFlag = false;
                } else {
                    vm.dataToFill.employeeData[index].rutFlag = true;
                }
            } else if (vm.dataToFill.employeeData[index].RUT === null) {
                vm.dataToFill.employeeData[index].rutFlag = true;
            } else if (vm.dataToFill.employeeData[index].RUT === undefined) {
                vm.dataToFill.employeeData[index].rutFlag = false;
            }
        };


        //=======================payment method change========================
        function paymentMethodChange(data, type) {

        };
        //===================add extras======================
        //function addEmployee(index) {
        //    $log.log(index);
        //    vm.dataToFill.employeeData.push({
        //        name: '',
        //        RUT: '',
        //        email: '',
        //        approval_required: false,
        //        thirdBooking: false,
        //        rutFlag: false
        //    });
        //};
        //
        //function deleteEmployee(index) {
        //    $log.log(index);
        //    vm.dataToFill.employeeData.splice(index, 1);
        //};
        //function addVariablePrice(index) {
        //    $log.log(index);
        //    vm.dataToFill.variable_pricing.push({
        //        type_of_service_id:"",
        //        coverage_area_id:"",
        //        comments:"",
        //        price:""
        //    });
        //};
        //
        //function deleteVariablePrice(index) {
        //    $log.log(index);
        //    vm.dataToFill.variable_pricing.splice(index, 1);
        //};
        //====================set bollean for employeee==========================


        //==================map function=======================

        // if (document.getElementById('pickAddress') != null) {
        //     var input = document.getElementById('pickAddress');
        //     google.maps.event.addDomListener(input, 'keydown', function (event) {
        //         if (event.keyCode === 13) {
        //             event.preventDefault();

        //         }
        //     });
        // }

        function mapFn(data) {
            $(".pac-container").hide();
            // $scope.address = hidePublicPlaces.formattedAddress(data);
            var string = data.formatted_address;
            var address = string.replace(", Chile", " ");
            // vm.dataToFill.pickUpAddress = address;
            vm.dataToFill.pickUpDefault = address;
            vm.dataToFill.pickUpDefault1 = address;
            // vm.dataToFill.pickUpDefault = $scope.address;
            // vm.dataToFill.pickUpDefault1 = $scope.address;
            vm.dataToFill.lattitude = data.geometry.location.lat();
            vm.dataToFill.longitude = data.geometry.location.lng();
            // $scope.$apply();
        }


        function mapFn1(data) {
            $scope.address = hidePublicPlaces.formattedAddress(data);
            $scope.lat = data.geometry.location.lat();
            $scope.lng = data.geometry.location.lng();
            var string = data.formatted_address;
            var address = string.replace(", Chile", " ");
            // vm.dataToFill.pickUpAddress = address;
            vm.dataToFill.pickUpDefault = address;
            vm.dataToFill.pickUpDefault1 = address;
            vm.dataToFill.lattitude = $scope.lat;
            vm.dataToFill.longitude = $scope.lng;

            // ********** TO GET CITY OF ADDRESS **********
            data.address_components.forEach(function (component) {
                if (component.types[0] == 'locality') {
                    vm.addressComuna = component.long_name || null;
                }
            });

            $scope.$apply();
        }

        function openPopUpForAdding($event, form) {

            if (form.$invalid == true) {
                errorMessageFactory.showErrorMessage('Please fill basic details first', 0);
                return false;
            }
            vm.items = {
                pointName1 :''
            }
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/addOperationPointRegesiter.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: AddToOperationPointRegester
            });

            function AddToOperationPointRegester($scope, $mdDialog, items) {
                $scope.items = items;
                var filterTextTimeout = '';
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.mapFn1 = function (data) {
                    mapFn1(data);
                }

                function stopRKey(evt) {
                    var evt = (evt) ? evt : ((event) ? event : null);
                    var node = (evt.target) ? evt.target : ((evt.srcElement) ? evt.srcElement : null);
                    if ((evt.keyCode == 13) && (node.type == "text")) {
                        return false;
                    }
                }

                document.onkeypress = stopRKey;
                $scope.confirmUpload = function () {
                    if (vm.dataToFill.pickUpDefault1 == undefined || vm.dataToFill.pickUpDefault1 == null) {
                        errorMessageFactory.showErrorMessage('Seleccione una dirección válida', 0);
                        return false;
                    }
                    if (vm.dataToFill.lattitude && vm.dataToFill.longitude) {
                        vm.addressArray.push({
                            address_nick_name: $scope.items.pointName1,
                            address_location: vm.dataToFill.pickUpDefault1,
                            address_latitude: vm.dataToFill.lattitude,
                            address_longitude: vm.dataToFill.longitude,
                            communa: vm.addressComuna
                        });
                    } else {
                        errorMessageFactory.showErrorMessage('Seleccione una dirección válida', 0);
                    }

                    // if (vm.addressArray.length > 9) {
                    //     vm.buttonDisabled = true;
                    // }

                    // $timeout(function(){
                    $mdDialog.hide();
                    // }, 200);

                };





            }
        }


        function deleteAddress(index) {
            vm.addressArray.splice(index, 1);
            // if (vm.addressArray.length > 9) {
            //     vm.buttonDisabled = true;
            // } else {
            //     vm.buttonDisabled = false;
            // }

        }



        function setBooleanEmployee(type, index) {
            switch (type) {
                case 'THIRD_BOOKING':
                    if (vm.dataToFill.employeeData[index].thirdBooking) {
                        vm.dataToFill.employeeData[index].thirdBooking = false;
                    } else {
                        vm.dataToFill.employeeData[index].thirdBooking = true;
                    }
                    break;
                case 'APPROVAL_REQUIRED':
                    if (vm.dataToFill.employeeData[index].approval_required) {
                        vm.dataToFill.employeeData[index].approval_required = false;
                    } else {
                        vm.dataToFill.employeeData[index].approval_required = true;
                    }
                    break;
            }
        }
        //====================function setBolleans========================
        function setBooleans(type) {
            switch (type) {
                case 'FARE_TO_CUSTOMER':
                    if (vm.dataToFill.fareToCustomer) {
                        vm.dataToFill.fareToCustomer = false;
                    } else {
                        vm.dataToFill.fareToCustomer = true;
                    }
                    break;
                case 'FARE_TO_DRIVER':
                    if (vm.dataToFill.fareToDriver) {
                        vm.dataToFill.fareToDriver = false;
                    } else {
                        vm.dataToFill.fareToDriver = true;
                    }
                    break;
                case 'PASSANGER_RUT':
                    if (vm.dataToFill.passengerRut) {
                        vm.dataToFill.passengerRut = false;
                    } else {
                        vm.dataToFill.passengerRut = true;
                    }
                    break;
                case 'APPLICANT_RUT':
                    if (vm.dataToFill.applicantRut) {
                        vm.dataToFill.applicantRut = false;
                    } else {
                        vm.dataToFill.applicantRut = true;
                    }
                    break;
                case 'AUTHERIZER_RUT':
                    if (vm.dataToFill.authrizerRut) {
                        vm.dataToFill.authrizerRut = false;
                    } else {
                        vm.dataToFill.authrizerRut = true;
                    }
                    break;
                case 'INVOICE_CUSTOMER':
                    if (vm.dataToFill.invoiceCustomer) {
                        vm.dataToFill.invoiceCustomer = false;
                    } else {
                        vm.dataToFill.invoiceCustomer = true;
                    }
                    break;
                case 'INVOICE_APPLICANT':
                    if (vm.dataToFill.invoiceApplicant) {
                        vm.dataToFill.invoiceApplicant = false;
                    } else {
                        vm.dataToFill.invoiceApplicant = true;
                    }
                    break;
                case 'INVOICE_CONTACT_PERSON':
                    if (vm.dataToFill.invoiceContactPerson) {
                        vm.dataToFill.invoiceContactPerson = false;
                        vm.dataToFill.emailAdministrator = '';
                    } else {
                        vm.dataToFill.invoiceContactPerson = true;
                    }
                    break;
                case 'INVOICE_CONTRACT_PERSON':
                    if (vm.dataToFill.invoiceContractPerson) {
                        vm.dataToFill.invoiceContractPerson = false;
                    } else {
                        vm.dataToFill.invoiceContractPerson = true;
                    }
                    break;
                //case 'INVOICE_EMPLOYEE':
                //    if (vm.dataToFill.invoiceEmployee) {
                //        vm.dataToFill.invoiceEmployee = false;
                //    } else {
                //        vm.dataToFill.invoiceEmployee = true;
                //    }
                //    break;
                case 'PICKUP_FIXED':
                    if (vm.dataToFill.pickupFixed) {
                        vm.dataToFill.pickupFixed = false;
                    } else {
                        vm.dataToFill.pickupFixed = true;
                    }
                    break;
                case 'DROPOFF_FIXED':
                    if (vm.dataToFill.dropOffFixed) {
                        vm.dataToFill.dropOffFixed = false;
                    } else {
                        vm.dataToFill.dropOffFixed = true;
                    }
                    break;
                case 'COST_CENTER':
                    if (vm.dataToFill.costCenter) {
                        vm.dataToFill.costCenter = false;
                    } else {
                        vm.dataToFill.costCenter = true;
                    }
                    break;
                case 'COST_SUB_CENTER':
                    if (vm.dataToFill.costSubCenter) {
                        vm.dataToFill.costSubCenter = false;
                    } else {
                        vm.dataToFill.costSubCenter = true;
                    }
                    break;
                case 'ROL':
                    if (vm.dataToFill.rol) {
                        vm.dataToFill.rol = false;
                    } else {
                        vm.dataToFill.rol = true;
                    }
                    break;
                case 'GRAPH':
                    if (vm.dataToFill.graph) {
                        vm.dataToFill.graph = false;
                    } else {
                        vm.dataToFill.graph = true;
                    }
                    break;
                case 'WORK_ORDER':
                    if (vm.dataToFill.workOrder) {
                        vm.dataToFill.workOrder = false;
                    } else {
                        vm.dataToFill.workOrder = true;
                    }
                    break;
                case 'PEP':
                    if (vm.dataToFill.pep) {
                        vm.dataToFill.pep = false;
                    } else {
                        vm.dataToFill.pep = true;
                    }
                    break;
                case 'NUMBER_VOUCHERS':
                    if (vm.dataToFill.numberVoucher) {
                        vm.dataToFill.numberVoucher = false;
                    } else {
                        vm.dataToFill.numberVoucher = true;
                    }
                    break;
                case 'PURPOSE_TRIP':
                    if (vm.dataToFill.purpouseOfTrip) {
                        vm.dataToFill.purpouseOfTrip = false;
                    } else {
                        vm.dataToFill.purpouseOfTrip = true;
                    }
                    break;
                case 'NOMINA':
                    if (vm.dataToFill.nomina) {
                        vm.dataToFill.nomina = false;
                    } else {
                        vm.dataToFill.nomina = true;
                    }
                    break;
                case 'SOLICITUDE':
                    if (vm.dataToFill.solicitude) {
                        vm.dataToFill.solicitude = false;
                    } else {
                        vm.dataToFill.solicitude = true;
                    }
                    break;
                case 'AUTH_LOAD_PROFILE':
                    if (vm.dataToFill.authLoadProfile) {
                        vm.dataToFill.authLoadProfile = false;
                    } else {
                        vm.dataToFill.authLoadProfile = true;
                    }
                    break;
                case 'Mandatory_Airline':
                    if (vm.dataToFill.airline) {
                        vm.dataToFill.airline = false;
                    } else {
                        vm.dataToFill.airline = true;
                    }
                    break;
                case 'Mandatory_Flight':
                    if (vm.dataToFill.flight) {
                        vm.dataToFill.flight = false;
                    } else {
                        vm.dataToFill.flight = true;
                    }
                    break;
                case 'Mandatory_Flight_Date':
                    if (vm.dataToFill.flightDate) {
                        vm.dataToFill.flightDate = false;
                    } else {
                        vm.dataToFill.flightDate = true;
                    }
                    break;
                case 'Mandatory_Flight_Type':
                    if (vm.dataToFill.flightType) {
                        vm.dataToFill.flightType = false;
                    } else {
                        vm.dataToFill.flightType = true;
                    }
                    break;
                case 'ROUND_TRIP_WAIT_TIME':
                    if (vm.dataToFill.roundTripWaitTime) {
                        vm.dataToFill.roundTripWaitTime = false;
                    } else {
                        vm.dataToFill.roundTripWaitTime = true;
                    }
                    break;
                case 'CONTROLLED_WAY':
                    if (vm.dataToFill.controlledWay) {
                        vm.dataToFill.controlledWay = false;
                        vm.dataToFill.viaControlled = false;
                        vm.dataToFill.viaControlledTarifa = false;
                    } else {
                        vm.dataToFill.controlledWay = true;
                    }
                    break;
                case 'SHARED_SERVICES':
                    if (vm.dataToFill.sharedServices) {
                        vm.dataToFill.sharedServices = false;
                    } else {
                        vm.dataToFill.sharedServices = true;
                    }
                    break;
                case 'ALLOW_BOOKINGS_WITHOUT_REQUEST':
                    if (vm.dataToFill.allowBookingWithoutRequest) {
                        vm.dataToFill.allowBookingWithoutRequest = false;
                    } else {
                        vm.dataToFill.allowBookingWithoutRequest = true;
                    }
                    break;
                case 'GROUP_SERVICES':
                    if (vm.dataToFill.groupServices) {
                        vm.dataToFill.groupServices = false;
                        vm.dataToFill.chargeFullPath = false;
                        vm.dataToFill.chargeEachReservation = false;
                        vm.dataToFill.automaticGrouping = false;
                    } else {
                        vm.dataToFill.groupServices = true;
                        vm.dataToFill.chargeFullPath = true;
                    }
                    break;
                case 'GROUP_EXTERNAL':
                    if (vm.dataToFill.groupExternal) {
                        vm.dataToFill.groupExternal = false;
                    } else {
                        vm.dataToFill.groupExternal = true;
                    }
                    break;
                case 'charge_Full_Path':
                    if (vm.dataToFill.chargeFullPath) {
                        vm.dataToFill.chargeFullPath = false;
                        vm.dataToFill.chargeEachReservation = true;
                    } else {
                        vm.dataToFill.chargeFullPath = true;
                        vm.dataToFill.chargeEachReservation = false;
                    }
                    break;
                case 'charge_Each_Reservation':
                    if (vm.dataToFill.chargeEachReservation) {
                        vm.dataToFill.chargeEachReservation = false;
                        vm.dataToFill.chargeFullPath = true;
                    } else {
                        vm.dataToFill.chargeEachReservation = true;
                        vm.dataToFill.chargeFullPath = false;
                    }
                    break;
                case 'AUTOMATIC_GROUPING':
                    if (vm.dataToFill.automaticGrouping) {
                        vm.dataToFill.automaticGrouping = false;
                    } else {
                        vm.dataToFill.automaticGrouping = true;
                    }    
                    break;
                case 'Monitoring_Services':
                    if (vm.dataToFill.monitoringServices) {
                        vm.dataToFill.monitoringServices = false;
                    } else {
                        vm.dataToFill.monitoringServices = true;
                    }
                    break;
                case 'VIA_CONTROLLED':
                    if (vm.dataToFill.viaControlled) {
                        vm.dataToFill.viaControlled = false;
                    } else {
                        ///////////////////////////TV-1795 //////////////////////////
                        if (vm.dataToFill.controlledWay == true) {
                            vm.dataToFill.viaControlled = true;
                        } else {
                            vm.dataToFill.viaControlled = false;
                        }
                        ///////////////////////////TV-1795 //////////////////////////
                    }
                    break;
                case 'VIA_CONTROLLED_TARIFA':
                    if (vm.dataToFill.viaControlledTarifa) {
                        vm.dataToFill.viaControlledTarifa = false;
                    } else {
                        ///////////////////////////TV-1795 //////////////////////////
                        if (vm.dataToFill.controlledWay == true) {
                            vm.dataToFill.viaControlledTarifa = true;
                        } else {
                            vm.dataToFill.viaControlledTarifa = false;
                        }
                        ///////////////////////////TV-1795 ////////////////////////// 
                    }
                    break;
                case 'ENABLE_VARIBLE_RATE':
                    if (vm.dataToFill.enableVaribleRate) {
                        vm.dataToFill.enableVaribleRate = false;
                    } else {
                        vm.dataToFill.enableVaribleRate = true;

                    }
                    break;
                case 'ENABLE_SMS':
                    if (vm.dataToFill.enableSMS) {
                        vm.dataToFill.enableSMS = false;
                    } else {
                        vm.dataToFill.enableSMS = true;

                    }
                    break;
                case 'APPLY_CHARGE':
                    if (vm.dataToFill.applyCharge) {
                        vm.dataToFill.applyCharge = false;
                        vm.dataToFill.collectEstimatedTag = false;
                    } else {
                        vm.dataToFill.applyCharge = true;

                    }
                    break;
                case 'APPLY_ESTIMATED_FARE':
                    if (vm.dataToFill.applyEstimatedFare) {
                        vm.dataToFill.applyEstimatedFare = false;
                    } else {
                        vm.dataToFill.applyEstimatedFare = true;

                    }
                    break;
                case 'COLLECT_ESTIMATED_TAG':
                    if (vm.dataToFill.collectEstimatedTag) {
                        vm.dataToFill.collectEstimatedTag = false;
                    } else {
                        vm.dataToFill.collectEstimatedTag = true;
                    }
                    break;
                case 'APPLY_REAL_TIME_TRAVEL':
                    if (vm.dataToFill.charge_for_estimated_travel_time) {
                        vm.dataToFill.charge_for_estimated_travel_time = false;
                    } else {
                        vm.dataToFill.charge_for_estimated_travel_time = true;
                    }
                    break;
                case 'APPLY_QR_P':
                    if (vm.dataToFill.apply_qr_p) {
                        vm.dataToFill.apply_qr_p = false;
                    } else {
                        vm.dataToFill.apply_qr_p = true;
                    }
                    break;
                case 'DISABLE_SMS_CUSTOMER':
                    if (vm.dataToFill.disable_sms_customer) {
                        vm.dataToFill.disable_sms_customer = false;
                    } else {
                        vm.dataToFill.disable_sms_customer = true;
                    }
                    break;
                case 'Allow_Change_Fare_POS':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.changeFareForPos) {
                        vm.dataToFill.changeFareForPos = false;
                    } else {
                        vm.dataToFill.changeFareForPos = true;
                    }
                    break;

                case 'Allow_Change_Fare_Create_Booking':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.changeFareForCreateBooking) {
                        vm.dataToFill.changeFareForCreateBooking = false;
                    } else {
                        vm.dataToFill.changeFareForCreateBooking = true;
                    }
                    break;
                case 'crear_reserva':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.crearReserva) {
                        vm.dataToFill.crearReserva = false;
                    } else {
                        vm.dataToFill.crearReserva = true;
                    }
                    break;
                case 'finalizar_reserva':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.finalizarReserva) {
                        vm.dataToFill.finalizarReserva = false;
                    } else {
                        vm.dataToFill.finalizarReserva = true;
                    }
                    break;
                case 'anular_reserva':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.anularReserva) {
                        vm.dataToFill.anularReserva = false;
                    } else {
                        vm.dataToFill.anularReserva = true;
                    }
                    break;
                case 'marcar_reserva':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.marcarReserva) {
                        vm.dataToFill.marcarReserva = false;
                    } else {
                        vm.dataToFill.marcarReserva = true;
                    }
                    break;
                case 'retarificar_reserva':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.retarificarReserva) {
                        vm.dataToFill.retarificarReserva = false;
                    } else {
                        vm.dataToFill.retarificarReserva = true;
                    }
                    break;
                case 'crear_reserva_solicitante':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.crearReservaSolicitante) {
                        vm.dataToFill.crearReservaSolicitante = false;
                    } else {
                        vm.dataToFill.crearReservaSolicitante = true;
                    }
                    break;
                case 'finalizar_reserva_solicitante':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.finalizarReservaSolicitante) {
                        vm.dataToFill.finalizarReservaSolicitante = false;
                    } else {
                        vm.dataToFill.finalizarReservaSolicitante = true;
                    }
                    break;
                case 'anular_reserva_solicitante':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.anularReservaSolicitante) {
                        vm.dataToFill.anularReservaSolicitante = false;
                    } else {
                        vm.dataToFill.anularReservaSolicitante = true;
                    }
                    break;
                case 'marcar_reserva_solicitante':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.marcarReservaSolicitante) {
                        vm.dataToFill.marcarReservaSolicitante = false;
                    } else {
                        vm.dataToFill.marcarReservaSolicitante = true;
                    }
                    break;
                case 'retarificar_reserva_solicitante':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.retarificarReservaSolicitante) {
                        vm.dataToFill.retarificarReservaSolicitante = false;
                    } else {
                        vm.dataToFill.retarificarReservaSolicitante = true;
                    }
                    break;
                case 'crear_reserva_administrador':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.crearReservaAdministrador) {
                        vm.dataToFill.crearReservaAdministrador = false;
                    } else {
                        vm.dataToFill.crearReservaAdministrador = true;
                    }
                    break;
                case 'finalizar_reserva_administrador':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.finalizarReservaAdministrador) {
                        vm.dataToFill.finalizarReservaAdministrador = false;
                    } else {
                        vm.dataToFill.finalizarReservaAdministrador = true;
                    }
                    break;
                case 'anular_reserva_administrador':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.anularReservaAdministrador) {
                        vm.dataToFill.anularReservaAdministrador = false;
                    } else {
                        vm.dataToFill.anularReservaAdministrador = true;
                    }
                    break;
                case 'marcar_reserva_administrador':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.marcarReservaAdministrador) {
                        vm.dataToFill.marcarReservaAdministrador = false;
                    } else {
                        vm.dataToFill.marcarReservaAdministrador = true;
                    }
                    break;
                case 'retarificar_reserva_administrador':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.retarificarReservaAdministrador) {
                        vm.dataToFill.retarificarReservaAdministrador = false;
                    } else {
                        vm.dataToFill.retarificarReservaAdministrador = true;
                    }
                    break;
                case 'para_calificar_conductor':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.paraCalificarConductor) {
                        vm.dataToFill.paraCalificarConductor = false;
                    } else {
                        vm.dataToFill.paraCalificarConductor = true;
                    }
                    break;
                case 'para_calificar_conductor_solicitante':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.paraCalificarConductorSolicitante) {
                        vm.dataToFill.paraCalificarConductorSolicitante = false;
                    } else {
                        vm.dataToFill.paraCalificarConductorSolicitante = true;
                    }
                    break;
                case 'restriccion_flota':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.restriccion_flota) {
                        vm.dataToFill.restriccion_flota = false;
                    } else {
                        vm.dataToFill.restriccion_flota = true;
                    }
                    break;
            }
        };

        //==============get all corporate=================
        function getAllCorporate() {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = 0;
            dataSend.offset = 0;
            dataSend.key = 2;
            dataSend.search_filter = 0;
            var promise = getCorporate.allCorporates(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.corporatesList = _.where(payload.title.data.result, {
                        status: 1
                    });
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllCorporate();
        //==============get all services=================
        function getAllServices() {
            vm.loading = true;
            var promise = getServices.allServices(0, 0, 2, 0);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.servicesList = _.where(payload.title.data.result, {
                            status: 1
                        });
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllServices();
        //==============get all payment types=================
        function getAllPaymentTypes() {
            vm.loading = true;
            var promise = getPaymentMethods.allMethods(2, 0, 0);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.paymentTypesList = _.where(payload.title.data.result, {
                        status: 1
                    });
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllPaymentTypes();

        //====================get branch list====================
        function getBranch() {
            vm.loading = true;
            var promise = getGeofence.branch();
            promise.then(
                function (payload) {
                    $log.log('branch', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        var where = _.where(payload.title.data, {
                            is_active: 1
                        });
                        vm.branchList = _.where(where, {
                            parent_id: 0
                        });
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        getBranch();

        //=======================add agreement api=============================
        function addAgreementApi() {
            $log.log(vm.dataToFill);

            if (vm.dataToFill.roundTripDiscount > 100) {
                languageBasedErrorFactory.getProperErrorMessage('agreementErrPop', 0, 0);
                return;
            }
            if (vm.dataToFill.webPayDiscount > 100) {
                languageBasedErrorFactory.getProperErrorMessage('agreementErrPop1', 0, 0);
                return;
            }

            if (vm.dataToFill.startDate > vm.dataToFill.endDate) {
                languageBasedErrorFactory.getProperErrorMessage('approValidDates', 0, 0);
                //errorMessageFactory.showErrorMessage('Please select appropriate validity dates.');
                return;
            }
            if (vm.dataToFill.invoiceContactPerson && !vm.dataToFill.emailAdministrator) {
                errorMessageFactory.showErrorMessage('El email del administrador del contrato está pendiente, Favor ingresar.', 0);
                return;
            }
            //if(vm.dataToFill.baseFareDiscount > 100){
            //    errorMessageFactory.showErrorMessage('Please enter base fare discount less than 100%');
            //    return;
            //}
            //if(vm.dataToFill.paymentMethod == vm.dataToFill.payment_method_id){
            //    errorMessageFactory.showErrorMessage('Please select proper payment methods.');
            //    return;
            //}

            //if(vm.dataToFill.type_of_pricing_list_percentage_of_price_adj > 100){
            //    errorMessageFactory.showErrorMessage('Please enter pricing list percentage adjustment less than 100%');
            //    return;
            //}
            //if(vm.dataToFill.type_of_pricing_date_of_start > vm.dataToFill.type_of_pricing_date_of_end){
            //    errorMessageFactory.showErrorMessage('Please select appropriate pricing dates.');
            //    return;
            //}

            vm.finalDataSend = {};
            vm.finalDataSend.start_date_validity = moment(vm.dataToFill.startDate).format('YYYY-MM-DD HH:mm:ss');
            vm.finalDataSend.end_date_validity = moment(vm.dataToFill.endDate).format('YYYY-MM-DD HH:mm:ss');
            vm.finalDataSend.name = vm.dataToFill.agreementName;
            vm.finalDataSend.agreement_type = vm.dataToFill.agreementType;
            vm.finalDataSend.corporate_id = vm.dataToFill.corporateName;
            vm.finalDataSend.type_of_service_id = vm.dataToFill.typeOfService;
            vm.finalDataSend.charges_for_no_show = vm.dataToFill.noShowCharges;
            vm.finalDataSend.max_wait_time_tolerance = vm.dataToFill.waitTolerance;
            vm.finalDataSend.max_wait_time_free = vm.dataToFill.waitTimeFree;
            vm.finalDataSend.max_wait_time_en_route = vm.dataToFill.waitRoute;
            vm.finalDataSend.administrator_email = vm.dataToFill.emailAdministrator ? vm.dataToFill.emailAdministrator : '';
            //vm.finalDataSend.discount_based_fare = vm.dataToFill.baseFareDiscount;
            vm.finalDataSend.commercial_classification = vm.dataToFill.commercialClassification;
            vm.finalDataSend.payment_method_default = vm.dataToFill.paymentMethod;
            vm.dataToFill.payment_method_id = [];
            for (var i = 0; i < vm.dataToFill.paymentMethodSelected.length; i++) {
                vm.dataToFill.payment_method_id.push(vm.dataToFill.paymentMethodSelected[i].id);
            }
            vm.finalDataSend.payment_method_id = vm.dataToFill.payment_method_id;
            if (vm.dataToFill.virtualFleet || vm.dataToFill.virtualFleet === 0 || vm.dataToFill.virtualFleet === '0') {
                vm.finalDataSend.virtual_fleet = vm.dataToFill.virtualFleet;
            }
            vm.finalDataSend.comments = vm.dataToFill.comments;
            vm.finalDataSend.contractAdmin = vm.dataToFill.contractAdmin;
            vm.finalDataSend.fare_to_customer = vm.dataToFill.fareToCustomer ? 1 : 0;
            vm.finalDataSend.fare_to_driver = vm.dataToFill.fareToDriver ? 1 : 0;
            vm.finalDataSend.RUT_mendatory = vm.dataToFill.passengerRut ? 1 : 0;
            vm.finalDataSend.applicant_RUT_mendatory = vm.dataToFill.applicantRut ? 1 : 0;
            vm.finalDataSend.auth_RUT_mendatory = vm.dataToFill.authrizerRut ? 1 : 0;
            vm.finalDataSend.invoice_to_customer = 0; // vm.dataToFill.invoiceCustomer ? 1 :
            vm.finalDataSend.invoice_to_applicant = 0; //vm.dataToFill.invoiceApplicant ? 1 :
            vm.finalDataSend.invoice_to_contact_person = 0; //vm.dataToFill.invoiceContactPerson ? 1 :
            vm.finalDataSend.enable_variable_rate = vm.dataToFill.enableVaribleRate ? 1 : 0;
            //vm.finalDataSend.invoice_to_contact_persion = vm.dataToFill.invoiceContractPerson?1:0;
            //vm.finalDataSend.invoice_to_employee = vm.dataToFill.invoiceEmployee?1:0;
            vm.finalDataSend.cost_center_mandatory = vm.dataToFill.costCenter ? 1 : 0;
            vm.finalDataSend.cost_sub_center_mandatory = vm.dataToFill.costSubCenter ? 1 : 0;
            vm.finalDataSend.ROL_mandatory = vm.dataToFill.rol ? 1 : 0;
            vm.finalDataSend.graph_mandatory = vm.dataToFill.graph ? 1 : 0;
            vm.finalDataSend.work_order_mandatory = vm.dataToFill.workOrder ? 1 : 0;
            vm.finalDataSend.PEP_mandatory = vm.dataToFill.pep ? 1 : 0;
            vm.finalDataSend.number_of_voucher_mandatory = vm.dataToFill.numberVoucher ? 1 : 0;
            vm.finalDataSend.purpose_of_trip_mandatory = vm.dataToFill.purpouseOfTrip ? 1 : 0;
            vm.finalDataSend.solicitud = vm.dataToFill.solicitude ? 1 : 0;
            vm.finalDataSend.nomina = vm.dataToFill.nomina ? 1 : 0;
            vm.finalDataSend.require_auth_load_profile = vm.dataToFill.authLoadProfile ? 1 : 0;
            vm.finalDataSend.airline_mandatory = vm.dataToFill.airline ? 1 : 0;
            vm.finalDataSend.flight_number_mandatory = vm.dataToFill.flight ? 1 : 0;
            vm.finalDataSend.flight_date_mandatory = vm.dataToFill.flightDate ? 1 : 0;
            vm.finalDataSend.flight_type_mandatory = vm.dataToFill.flightType ? 1 : 0;
            vm.finalDataSend.monitoring_services_wisetrack = vm.dataToFill.monitoringServices ? 1 : 0;
            vm.finalDataSend.round_trip_wait_time = vm.dataToFill.roundTripWaitTime ? 1 : 0;
            vm.finalDataSend.access_token = $cookies.get('obj');
            vm.finalDataSend.contract_admin = 1;
            vm.finalDataSend.employee_endowment = Number(vm.dataToFill.employeeEndowment);
            vm.finalDataSend.branch_id = vm.dataToFill.branch;
            vm.finalDataSend.controlled_way = vm.dataToFill.controlledWay ? 1 : 0;
            vm.finalDataSend.is_mix_shared = vm.dataToFill.sharedServices ? 1 : 0;
            vm.finalDataSend.is_group_allowed = vm.dataToFill.groupServices ? 1 : 0;
            vm.finalDataSend.is_grouped_external = vm.dataToFill.groupExternal ? 1 : 0;
            vm.finalDataSend.charge_for_each_reservation_grouped = vm.dataToFill.groupServices ? (vm.dataToFill.chargeFullPath ? 0 : ( vm.dataToFill.chargeEachReservation ? 1 : 0 )) : 0;
            vm.finalDataSend.service_grouping_type = vm.dataToFill.groupServices ? (vm.dataToFill.automaticGrouping ? 2 : 1) : 1;
            vm.finalDataSend.enable_sms_option = vm.dataToFill.enableSMS ? 1 : 0;
            vm.finalDataSend.apply_charge_by_toll = vm.dataToFill.applyCharge ? 1 : 0;
            vm.finalDataSend.collect_estimated_tag = vm.dataToFill.collectEstimatedTag ? 1 : 0;
            vm.finalDataSend.charge_for_estimated_travel_time = vm.dataToFill.charge_for_estimated_travel_time ? 1 : 0;
            vm.finalDataSend.apply_qr_p = vm.dataToFill.apply_qr_p ? 1 : 0;
            vm.finalDataSend.sms_minutes_qr_p = vm.dataToFill.sms_minutes_qr_p;
            vm.finalDataSend.restriccion_flota = vm.dataToFill.restriccion_flota;
            vm.finalDataSend.disable_sms_customer = vm.dataToFill.disable_sms_customer ? 1 : 0;
            vm.finalDataSend.apply_estimated_distance_variable_fare = vm.dataToFill.applyEstimatedFare ? 1 : 0;
            vm.finalDataSend.is_bwr = vm.dataToFill.allowBookingWithoutRequest ? 1 : 0;
            vm.finalDataSend.QTH_factor = vm.dataToFill.qthFactor;
            vm.finalDataSend.rt_discount = vm.dataToFill.roundTripDiscount;
            vm.finalDataSend.web_discount = vm.dataToFill.webPayDiscount;
            vm.finalDataSend.aggreement_addresses = vm.addressArray;
            vm.finalDataSend.show_via_control_in_voucher = vm.dataToFill.viaControlled ? 1 : 0;
            vm.finalDataSend.via_control_include_in_tarifa = vm.dataToFill.viaControlledTarifa ? 1 : 0;
            vm.finalDataSend.passenger_create_booking = vm.dataToFill.crearReserva ? 1 : 0;
            vm.finalDataSend.passenger_end_booking = vm.dataToFill.finalizarReserva ? 1 : 0;
            vm.finalDataSend.passenger_cancel_booking = vm.dataToFill.anularReserva ? 1 : 0;
            vm.finalDataSend.passenger_noshow_booking = vm.dataToFill.marcarReserva ? 1 : 0;
            vm.finalDataSend.passenger_correct_fare_booking = vm.dataToFill.retarificarReserva ? 1 : 0;
            vm.finalDataSend.applicant_create_booking = vm.dataToFill.crearReservaSolicitante ? 1 : 0;
            vm.finalDataSend.applicant_end_booking = vm.dataToFill.finalizarReservaSolicitante ? 1 : 0;
            vm.finalDataSend.applicant_cancel_booking = vm.dataToFill.anularReservaSolicitante ? 1 : 0;
            vm.finalDataSend.applicant_noshow_booking = vm.dataToFill.marcarReservaSolicitante ? 1 : 0;
            vm.finalDataSend.applicant_correct_fare_booking = vm.dataToFill.retarificarReservaSolicitante ? 1 : 0;
            vm.finalDataSend.administrator_create_booking = vm.dataToFill.crearReservaAdministrador ? 1 : 0;
            vm.finalDataSend.administrator_end_booking = vm.dataToFill.finalizarReservaAdministrador ? 1 : 0;
            vm.finalDataSend.administrator_cancel_booking = vm.dataToFill.anularReservaAdministrador ? 1 : 0;
            vm.finalDataSend.administrator_noshow_booking = vm.dataToFill.marcarReservaAdministrador ? 1 : 0;
            vm.finalDataSend.administrator_correct_fare_booking = vm.dataToFill.retarificarReservaAdministrador ? 1 : 0;
            vm.finalDataSend.passenger_rate_driver_booking = vm.dataToFill.paraCalificarConductor ? 1 : 0;
            vm.finalDataSend.applicant_rate_driver_booking = vm.dataToFill.paraCalificarConductorSolicitante ? 1 : 0;
            // // KEYS TO ALLOW MODIFY AMOUNT
            // vm.finalDataSend.allow_change_fare_POS = vm.dataToFill.changeFareForPos ? 1 : 0;
            // vm.finalDataSend.allow_change_fare_panel = vm.dataToFill.changeFareForCreateBooking ? 1 : 0;
            vm.finalDataSend.threshold_value = Number(vm.dataToFill.groupThreshold);

            $log.log(vm.finalDataSend);
            vm.loading = true;
            var promise = getAgreement.newAgreement(vm.finalDataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        languageBasedErrorFactory.getProperErrorMessage('aggrementSucc', 0, 2, 'layout.agreementMain.agreement');
                    }
                    //errorMessageFactory.showErrorMessage('Agreement submitted successfully.',2,'layout.agreementMain.agreement');

                    //$timeout(function(){
                    //    $mdDialog.hide();
                    //    $state.reload();
                    //},2000);
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
    }
})();

/**
 * Created by cl-macmini-51 on 5/18/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('EditAgreementController', EditAgreementController);

    /** @ngInject */
    function EditAgreementController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog,
        $document, moment, $scope, RutHelper, getGeofence, hidePublicPlaces, getCorporate, getServices, getPaymentMethods, getAgreement, languageBasedErrorFactory, errorMessageFactory, Initializer) {
        var vm = this;
        vm.getAddressApi = getAddressApi;
        vm.favouriteAddressesOffset = 0;
        vm.onScrollAddressBody = onScrollAddressBody;
        vm.loading = false;
        vm.goBack = goBack;
        vm.datePickerE_1 = datePickerE_1;
        vm.openPopUpForEdit = openPopUpForEdit;
        // vm.buttonDisabled = false;
        vm.setBooleans = setBooleans;
        vm.deleteAddress = deleteAddress;
        vm.rutChange = rutChange;
        vm.addEmployee = addEmployee;
        vm.deleteEmployee = deleteEmployee;
        vm.setBooleanEmployee = setBooleanEmployee;
        vm.editAgreementApi = editAgreementApi;
        vm.getAllCorporate = getAllCorporate;
        vm.getAllServices = getAllServices;
        vm.getAllPaymentTypes = getAllPaymentTypes;
        vm.getParticularAgreementDetails = getParticularAgreementDetails;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.dateOptions = {};
        vm.datePicker_1 = {
            end: false,
            start: false
        };
        vm.redirectToConfigure = redirectToConfigure;

        // Service To Get Map Instance
        Initializer.mapsInitialized
            .then(function () {
                if (google) {
                    if (document.getElementById('pickAddress') != null) {
                        var input = document.getElementById('pickAddress');
                        google.maps.event.addDomListener(input, 'keydown', function (event) {
                            if (event.keyCode === 13) {
                                event.preventDefault();

                            }
                        });
                    }
                }
            });
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.altInputFormats = ['M!/d!/yyyy'];
        vm.dataToFill = {
            startDate: new Date(),
            endDate: new Date(),
            agreementName: '',
            agreementType: '',
            corporateName: '',
            typeOfService: [],
            fullTypeOfService: [],
            noShowCharges: '',
            waitTolerance: '',
            waitTimeFree: '',
            waitRoute: '',
            baseFareDiscount: '',
            commercialClassification: '',
            paymentMethod: '',
            payment_method_id: [],
            paymentMethodSelected: [],
            fullPaymentMethodSelected: [],
            virtualFleet: '',
            groupThreshold: 0,
            comments: '',
            contractAdmin: '',
            fareToCustomer: false,
            fareToDriver: false,
            passengerRut: false,
            applicantRut: false,
            authrizerRut: false,
            invoiceCustomer: false,
            invoiceApplicant: false,
            invoiceContactPerson: false,
            invoiceContractPerson: false,
            invoiceEmployee: false,
            roundTripWaitTime: false,
            costCenter: false,
            costSubCenter: false,
            rol: false,
            graph: false,
            workOrder: false,
            nomina: false,
            solicitude: false,
            pep: false,
            numberVoucher: false,
            purpouseOfTrip: false,
            authLoadProfile: false,
            employeeData: [],
            id: '',
            branch: [],
            fullBranch: [],
            employeeEndowment: '0',
            emailAdministrator: '',
            emailAdministratorBack: '',
            controlledWay: '',
            roundTripDiscount: 0,
            webPayDiscount: 0,
            sharedServices: false,
            groupServices: false,
            groupExternal: false,
            chargeFullPath:false,
            chargeEachReservation:false,
            automaticGrouping:false,
            qthFactor: 0,
            pickUpDefault1: '',
            crearReserva: false,
            finalizarReserva: false,
            anularReserva: false,
            marcarReserva: false,
            retarificarReserva: false,
            crearReservaSolicitante: false,
            finalizarReservaSolicitante: false,
            anularReservaSolicitante: false,
            marcarReservaSolicitante: false,
            retarificarReservaSolicitante: false,
            crearReservaAdministrador: false,
            finalizarReservaAdministrador: false,
            anularReservaAdministrador: false,
            marcarReservaAdministrador: false,
            retarificarReservaAdministrador: false,
            paraCalificarConductor: false,
            paraCalificarConductorSolicitante: false
        };

        //===========================get particular agreement details=============================
        function getParticularAgreementDetails() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.id = $stateParams.id;
            vm.loading = true;
            var promise = getAgreement.oneAgreement(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.finalAgreement = payload.title.data;
                    getAddressApi();
                    vm.dataToFill.startDate = new Date(vm.finalAgreement.startDateValidity);
                    vm.dataToFill.endDate = new Date(vm.finalAgreement.endDateValidity);
                    vm.dataToFill.agreementName = vm.finalAgreement.name;
                    vm.dataToFill.agreementType = vm.finalAgreement.agreement_type;

                    if (vm.finalAgreement.corporate.status == 1) {
                        vm.dataToFill.corporateName = vm.finalAgreement.corporate.id;
                    } else {
                        vm.dataToFill.corporateName = '';
                    }
                    if (vm.finalAgreement.typeOfServices && vm.finalAgreement.typeOfServices.length) {
                        for (var i = 0; i < vm.finalAgreement.typeOfServices.length; i++) {
                            if (vm.finalAgreement.typeOfServices[i].typeOfService.status == 1) {
                                vm.dataToFill.fullTypeOfService.push(vm.finalAgreement.typeOfServices[i]);
                                vm.dataToFill.typeOfService.push(vm.finalAgreement.typeOfServices[i].typeOfService.id);
                            }
                        }
                    } else {
                        vm.dataToFill.typeOfService = [];
                    }

                    vm.dataToFill.noShowCharges = vm.finalAgreement.chargesForNoShow;
                    vm.dataToFill.waitTolerance = vm.finalAgreement.maxWaitTimeTolerance;
                    vm.dataToFill.waitTimeFree = vm.finalAgreement.maxWaitTimeFree;
                    vm.dataToFill.waitRoute = vm.finalAgreement.maxWaitTimeEnRoute;
                    //vm.dataToFill.baseFareDiscount = vm.finalAgreement.discount_based_fare;
                    vm.dataToFill.commercialClassification = vm.finalAgreement.commercialClassification;
                    vm.dataToFill.paymentMethod = vm.finalAgreement.paymentMethodDefault ? vm.finalAgreement.paymentMethodDefault : '';

                    if (vm.finalAgreement.payments && vm.finalAgreement.payments.length) {
                        for (var i = 0; i < vm.finalAgreement.payments.length; i++) {
                            if (vm.finalAgreement.payments[i].payment_method.status == 1) {
                                vm.dataToFill.fullPaymentMethodSelected.push(vm.finalAgreement.payments[i]);
                                vm.dataToFill.paymentMethodSelected.push(vm.finalAgreement.payments[i].payment_method);
                            }
                        }
                    } else {
                        vm.dataToFill.paymentMethodSelected = [];
                    }

                    vm.dataToFill.virtualFleet = vm.finalAgreement.virtualFleet;
                    vm.dataToFill.comments = vm.finalAgreement.comments;
                    vm.dataToFill.contractAdmin = vm.finalAgreement.contractAdmin;
                    vm.dataToFill.fareToCustomer = vm.finalAgreement.fareToCustomer;
                    vm.dataToFill.fareToDriver = vm.finalAgreement.fareToDriver;
                    vm.dataToFill.passengerRut = vm.finalAgreement.rutMendatory;
                    vm.dataToFill.applicantRut = vm.finalAgreement.applicantRutMendatory;
                    vm.dataToFill.authrizerRut = vm.finalAgreement.authRutMendatory;
                    vm.dataToFill.invoiceCustomer = vm.finalAgreement.invoiceToCustomer;
                    vm.dataToFill.invoiceApplicant = vm.finalAgreement.invoiceToApplicant;
                    vm.dataToFill.invoiceContactPerson = vm.finalAgreement.invoiceToContactPerson;
                    //vm.dataToFill.groupThreshold = vm.finalAgreement.thresholdValue ? 1 : 0;
                    vm.dataToFill.groupThreshold = vm.finalAgreement.thresholdValue || 0;
                    //vm.dataToFill.invoiceContractPerson = vm.finalAgreement.start_date_validity;
                    //vm.dataToFill.invoiceEmployee = vm.finalAgreement.invoice_to_employee;
                    vm.dataToFill.roundTripWaitTime = vm.finalAgreement.roundTripWaitTime;
                    vm.dataToFill.costCenter = vm.finalAgreement.costCenterMandatory;
                    vm.dataToFill.costSubCenter = vm.finalAgreement.costSubCenterMandatory;
                    vm.dataToFill.rol = vm.finalAgreement.rolMandatory;
                    vm.dataToFill.graph = vm.finalAgreement.graphMandatory;
                    vm.dataToFill.workOrder = vm.finalAgreement.workOrderMandatory;
                    vm.dataToFill.pep = vm.finalAgreement.pepMandatory;
                    vm.dataToFill.numberVoucher = vm.finalAgreement.numberOfVoucherMandatory;
                    vm.dataToFill.purpouseOfTrip = vm.finalAgreement.purposeOfTripMandatory;
                    vm.dataToFill.solicitude = vm.finalAgreement.solicitudMandatory;
                    vm.dataToFill.nomina = vm.finalAgreement.nominaMandatory;
                    vm.dataToFill.authLoadProfile = vm.finalAgreement.requireAuthLoadProfile;
                    vm.dataToFill.airline = vm.finalAgreement.airlineMandatory;
                    vm.dataToFill.flight = vm.finalAgreement.flightNumberMandatory;
                    vm.dataToFill.flightDate = vm.finalAgreement.flightDateMandatory;
                    vm.dataToFill.flightType = vm.finalAgreement.flightTypeMandatory;
                    vm.dataToFill.monitoringServices = vm.finalAgreement.monitoringServicesWisetrack;
                    vm.dataToFill.id = vm.finalAgreement.id;
                    vm.dataToFill.status = vm.finalAgreement.status;
                    vm.dataToFill.emailAdministrator = vm.finalAgreement.administratorEmail ? vm.finalAgreement.administratorEmail : '';
                    vm.dataToFill.emailAdministratorBack = vm.finalAgreement.administratorEmail ? vm.finalAgreement.administratorEmail : '';
                    vm.dataToFill.employeeEndowment = vm.finalAgreement.employeeEndowment ? '1': '0';
                    if (vm.finalAgreement.branches && vm.finalAgreement.branches.length) {
                        for (var i = 0; i < vm.finalAgreement.branches.length; i++) {
                            if (vm.finalAgreement.branches[i].region.is_active == 1) {
                                vm.dataToFill.fullBranch.push(vm.finalAgreement.branches[i]);
                                vm.dataToFill.branch.push(vm.finalAgreement.branches[i].region.region_id);
                            }
                        }
                    } else {
                        vm.dataToFill.branch = [];
                    }
                    vm.dataToFill.controlledWay = vm.finalAgreement.controlledWay;
                    vm.dataToFill.roundTripDiscount = vm.finalAgreement.rtDiscount;
                    vm.dataToFill.webPayDiscount = vm.finalAgreement.webDiscount;
                    vm.dataToFill.sharedServices = vm.finalAgreement.isMixShared;
                    vm.dataToFill.groupServices = vm.finalAgreement.isGroupAllowed;
                    vm.dataToFill.groupExternal = vm.finalAgreement.isGroupedExternal;
                    vm.dataToFill.chargeFullPath = vm.finalAgreement.chargeForEachReservationGrouped ? 0 : 1;
                    vm.dataToFill.chargeEachReservation = vm.finalAgreement.chargeForEachReservationGrouped ? 1:0;
                    vm.dataToFill.automaticGrouping = vm.finalAgreement.serviceGroupingType == 2 ? 1 : 0;
                    if(vm.finalAgreement.metaData){
                        vm.dataToFill.smsToPass = vm.finalAgreement.metaData.sms_to_passenger_on_grouping;
                        vm.dataToFill.smsToAppl = vm.finalAgreement.metaData.sms_to_applicant_on_grouping;
                        vm.dataToFill.emailToPass = vm.finalAgreement.metaData.email_to_passenger_on_grouping;
                        vm.dataToFill.emailToAppl = vm.finalAgreement.metaData.email_to_applicant_on_grouping;
                    }
                    vm.dataToFill.enableSMS = vm.finalAgreement.enableSmsOption;
                    vm.dataToFill.applyCharge = vm.finalAgreement.applyChargeByToll;
                    vm.dataToFill.collectEstimatedTag = vm.finalAgreement.collectEstimatedTag;
                    vm.dataToFill.charge_for_estimated_travel_time = vm.finalAgreement.chargeForEstimatedTravelTime;
                    vm.dataToFill.apply_qr_p = vm.finalAgreement.qrcodeStatus;
                    vm.dataToFill.sms_minutes_qr_p = vm.finalAgreement.smsMinutesQrP;
                    vm.dataToFill.restriccion_flota = vm.finalAgreement.restriccionFlota;
                    vm.dataToFill.disable_sms_customer = vm.finalAgreement.disableSmsCustomer;
                    vm.dataToFill.applyEstimatedFare = vm.finalAgreement.applyEstimatedDistanceVariableFare;
                    vm.dataToFill.enableVaribleRate = vm.finalAgreement.enableVariableRate;
                    vm.dataToFill.allowBookingWithoutRequest = vm.finalAgreement.isBwr;
                    vm.dataToFill.qthFactor = vm.finalAgreement.qthFactor;
                    vm.dataToFill.crearReserva = vm.finalAgreement.passengerCreateBooking;
                    vm.dataToFill.finalizarReserva = vm.finalAgreement.passengerEndBooking;
                    vm.dataToFill.anularReserva = vm.finalAgreement.passengerCancelBooking;
                    vm.dataToFill.marcarReserva = vm.finalAgreement.passengerNoshowBooking;
                    vm.dataToFill.retarificarReserva = vm.finalAgreement.passengerCorrectFareBooking;
                    vm.dataToFill.crearReservaSolicitante = vm.finalAgreement.applicantCreateBooking;
                    vm.dataToFill.finalizarReservaSolicitante = vm.finalAgreement.applicantEndBooking;
                    vm.dataToFill.anularReservaSolicitante = vm.finalAgreement.applicantCancelBooking;
                    vm.dataToFill.marcarReservaSolicitante = vm.finalAgreement.applicantNoshowBooking;
                    vm.dataToFill.retarificarReservaSolicitante = vm.finalAgreement.applicantCorrectFareBooking;
                    vm.dataToFill.crearReservaAdministrador = vm.finalAgreement.administratorCreateBooking;
                    vm.dataToFill.finalizarReservaAdministrador = vm.finalAgreement.administratorEndBooking;
                    vm.dataToFill.anularReservaAdministrador = vm.finalAgreement.administratorCancelBooking;
                    vm.dataToFill.marcarReservaAdministrador = vm.finalAgreement.administratorNoshowBooking;
                    vm.dataToFill.retarificarReservaAdministrador = vm.finalAgreement.administratorCorrectFareBooking;
                    vm.dataToFill.paraCalificarConductor = vm.finalAgreement.passengerRateDriverBooking;
                    vm.dataToFill.paraCalificarConductorSolicitante = vm.finalAgreement.applicantRateDriverBooking;
                    ///////////////////////////TV-1795 //////////////////////////
                    if (vm.dataToFill.controlledWay == 1) {
                        vm.dataToFill.viaControlled = vm.finalAgreement.showViaControlInVoucher;
                        vm.dataToFill.viaControlledTarifa = vm.finalAgreement.viaControlIncludeInTarifa;
                    } else {
                        vm.dataToFill.viaControlled = 0;
                        vm.dataToFill.viaControlledTarifa = 0;
                    }
                    ///////////////////////////TV-1795 //////////////////////////

                    // // KEYS TO ALLOW MODIFY AMOUNT
                    // vm.dataToFill.changeFareForPos = vm.finalAgreement.allow_change_fare_POS;
                    // vm.dataToFill.changeFareForCreateBooking = vm.finalAgreement.allow_change_fare_panel;

                    $log.log('sxdsads', vm.finalAgreement);
                    getAllCorporate();
                    getAllServices();
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getParticularAgreementDetails();

        //========================function to go back==========================
        function goBack() {
            $state.go('layout.agreementMain.agreement');
        }
        //==================date picker function==================
        vm.dateOptions = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(2090, 12, 31),
            minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };

        function datePickerE_1(type) {
            if (type == '1') {
                vm.datePicker_1.start = true;
                vm.datePicker_1.end = false;
            } else if (type == '2') {
                vm.datePicker_1.end = true;
                vm.datePicker_1.start = false;
            }
        };




        // =====================delete Address ============================
        function deleteAddress(data, $event) {
            var confirm = $mdDialog.confirm()
                .title('¿Desea eliminar esta dirección?')
                // .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok('Confirmar')
                .cancel('Cerca');

            $mdDialog.show(confirm).then(function () {
                vm.loading = true;
                var dataSend = {};
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.contract_id = vm.finalAgreement.id;
                dataSend.address_id = data.address_id;
                var promise = getServices.deleteAddress(dataSend);
                promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        if (payload.title.status == 200) {
                            vm.loading = false;
                            getAddressApi();
                            errorMessageFactory.showErrorMessage('Dirección eliminada con éxito', 0);
                        }
                        // $mdDialog.hide();
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        //vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        }

        //==================map function=======================


        // if (document.getElementById('pickAddress') != null) {
        //     var input = document.getElementById('pickAddress');
        //     google.maps.event.addDomListener(input, 'keydown', function (event) {
        //         if (event.keyCode === 13) {
        //             event.preventDefault();

        //         }
        //     });
        // }

        function mapFn1(data) {
            $scope.address = hidePublicPlaces.formattedAddress(data);
            $scope.lat = data.geometry.location.lat();
            $scope.lng = data.geometry.location.lng();
            var string = data.formatted_address;
            var address = string.replace(", Chile", " ");
            // vm.dataToFill.pickUpAddress = address;
            vm.dataToFill.pickUpDefault = address;
            vm.dataToFill.pickUpDefault1 = address;
            vm.dataToFill.lattitude = $scope.lat;
            vm.dataToFill.longitude = $scope.lng;

            // ********** TO GET CITY OF ADDRESS **********
            data.address_components.forEach(function (component) {
                if (component.types[0] == 'locality') {
                    vm.addressComuna = component.long_name || null;
                }
            });

            $scope.$apply();
        }





        function openPopUpForEdit($event, form) {
            if (form.$invalid == true) {
                errorMessageFactory.showErrorMessage('Please fill basic details first', 0);
                return false;
            }
            // if (vm.addressArray.length > 9) {
            //     vm.buttonDisabled = true;
            // }
            vm.items ={
                pointName1:''
            }
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/addOperationPointRegesiter.html',
                locals: {
                    items:  vm.items
                },
                bindToController: true,
                controller: AddToOperationPointRegester
            });

            function AddToOperationPointRegester($scope, $mdDialog, items) {
                $scope.items = items;
                var filterTextTimeout = '';
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.mapFn1 = function (data) {
                    mapFn1(data);
                }

                function stopRKey(evt) {
                    var evt = (evt) ? evt : ((event) ? event : null);
                    var node = (evt.target) ? evt.target : ((evt.srcElement) ? evt.srcElement : null);
                    if ((evt.keyCode == 13) && (node.type == "text")) {
                        return false;
                    }
                }

                document.onkeypress = stopRKey;
                $scope.confirmUpload = function () {
                    if (vm.dataToFill.pickUpDefault1 == undefined || vm.dataToFill.pickUpDefault1 == null) {
                        errorMessageFactory.showErrorMessage('Seleccione una dirección válida', 0);
                        return false;
                    }
                    vm.loading = true;
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.contract_id = vm.finalAgreement.id;
                    dataSend.address_nick_name = $scope.items.pointName1;
                    dataSend.address_location = vm.dataToFill.pickUpDefault1;
                    dataSend.communa = vm.addressComuna || null;
                    dataSend.address_latitude = vm.dataToFill.lattitude;
                    dataSend.address_longitude = vm.dataToFill.longitude;
                    var promise = getServices.addAddress(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            vm.loading = false;
                            if (payload.title.status == 200) {

                                vm.favouriteAddressesOffset = 0;
                                getAddressApi();
                            } else {
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            }

                            $mdDialog.hide();

                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            //vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );

                };




            }
        }
        // Tv-2360 - On scrolling favorite addresses 
        // FOR ENDLESS SCROLLING IN ADDRESS
        function onScrollAddressBody() {
            if (vm.addressArray.length > 9)
                if (vm.addressArrayCount > vm.addressArray.length) {
                    vm.favouriteAddressesOffset += 10;
                    getAddressApi('fromScroll');
                }
        }
        vm.addressArrayCount = 0;
        vm.addressArray = [];
        // =====================get Address ============================
        function getAddressApi(string) {
            console.log('>>>>> STRING >>>>>', string);
            if (!string)
                vm.addressArray = [];
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.contract_id = vm.finalAgreement.id;
            dataSend.limit = 10;
            dataSend.offset = vm.favouriteAddressesOffset;
            var promise = getServices.getAddress(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        payload.title.data.addresses.forEach(function (address) {
                            vm.addressArray.push(address);
                        });
                        // vm.addressArray = payload.title.data.addresses || [];
                        vm.addressArrayCount = payload.title.data.total_count || 0;
                        if (vm.addressArray.length == 8) {
                            vm.addressButton = false;
                        }
                        // if (vm.addressArray.length > 9) {
                        //     vm.buttonDisabled = true;
                        // }
                    }
                    // $mdDialog.hide();
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    //vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };



        //=================validate rut=====================
        function rutChange(index) {
            $log.log(vm.dataToFill.employeeData[index].RUT);
            if (vm.dataToFill.employeeData[index].RUT) {
                if (RutHelper.validate(vm.dataToFill.employeeData[index].RUT)) {
                    $log.log();
                    vm.dataToFill.employeeData[index].rutFlag = false;
                } else {
                    vm.dataToFill.employeeData[index].rutFlag = true;
                }
            } else if (vm.dataToFill.employeeData[index].RUT === null) {
                vm.dataToFill.employeeData[index].rutFlag = true;
            } else if (vm.dataToFill.employeeData[index].RUT === undefined) {
                vm.dataToFill.employeeData[index].rutFlag = false;
            }
        }
        //===================add vehicles======================
        function addEmployee(index) {
            $log.log(index);
            vm.dataToFill.employeeData.push({
                name: '',
                RUT: '',
                approval_required: false,
                thirdBooking: false,
                rutFlag: false
            });
        };

        function deleteEmployee(index) {
            $log.log(index);
            vm.dataToFill.employeeData.splice(index, 1);
        };
        //====================set bollean for employeee==========================
        function setBooleanEmployee(type, index) {
            switch (type) {
                case 'THIRD_BOOKING':
                    if (vm.dataToFill.employeeData[index].thirdBooking) {
                        vm.dataToFill.employeeData[index].thirdBooking = false;
                    } else {
                        vm.dataToFill.employeeData[index].thirdBooking = true;
                    }
                    break;
                case 'APPROVAL_REQUIRED':
                    if (vm.dataToFill.employeeData[index].approval_required) {
                        vm.dataToFill.employeeData[index].approval_required = false;
                    } else {
                        vm.dataToFill.employeeData[index].approval_required = true;
                    }
                    break;
            }
        }
        //====================function setBolleans========================
        function setBooleans(type) {
            switch (type) {
                case 'FARE_TO_CUSTOMER':
                    if (vm.dataToFill.fareToCustomer) {
                        vm.dataToFill.fareToCustomer = false;
                    } else {
                        vm.dataToFill.fareToCustomer = true;
                    }
                    break;
                case 'FARE_TO_DRIVER':
                    if (vm.dataToFill.fareToDriver) {
                        vm.dataToFill.fareToDriver = false;
                    } else {
                        vm.dataToFill.fareToDriver = true;
                    }
                    break;
                case 'PASSANGER_RUT':
                    if (vm.dataToFill.passengerRut) {
                        vm.dataToFill.passengerRut = false;
                    } else {
                        vm.dataToFill.passengerRut = true;
                    }
                    break;
                case 'APPLICANT_RUT':
                    if (vm.dataToFill.applicantRut) {
                        vm.dataToFill.applicantRut = false;
                    } else {
                        vm.dataToFill.applicantRut = true;
                    }
                    break;
                case 'AUTHERIZER_RUT':
                    if (vm.dataToFill.authrizerRut) {
                        vm.dataToFill.authrizerRut = false;
                    } else {
                        vm.dataToFill.authrizerRut = true;
                    }
                    break;
                case 'INVOICE_CUSTOMER':
                    if (vm.dataToFill.invoiceCustomer) {
                        vm.dataToFill.invoiceCustomer = false;
                    } else {
                        vm.dataToFill.invoiceCustomer = true;
                    }
                    break;
                case 'INVOICE_APPLICANT':
                    if (vm.dataToFill.invoiceApplicant) {
                        vm.dataToFill.invoiceApplicant = false;
                    } else {
                        vm.dataToFill.invoiceApplicant = true;
                    }
                    break;
                case 'INVOICE_CONTACT_PERSON':
                    if (vm.dataToFill.invoiceContactPerson) {
                        vm.dataToFill.invoiceContactPerson = false;
                        vm.dataToFill.emailAdministrator = '';
                    } else {
                        vm.dataToFill.invoiceContactPerson = true;
                        vm.dataToFill.emailAdministrator = vm.dataToFill.emailAdministratorBack ? vm.dataToFill.emailAdministratorBack : vm.dataToFill.emailAdministrator;
                    }
                    break;
                case 'INVOICE_CONTRACT_PERSON':
                    if (vm.dataToFill.invoiceContractPerson) {
                        vm.dataToFill.invoiceContractPerson = false;
                    } else {
                        vm.dataToFill.invoiceContractPerson = true;
                    }
                    break;
                    //case 'INVOICE_EMPLOYEE':
                    //    if (vm.dataToFill.invoiceEmployee) {
                    //        vm.dataToFill.invoiceEmployee = false;
                    //    } else {
                    //        vm.dataToFill.invoiceEmployee = true;
                    //    }
                    //    break;
                case 'PICKUP_FIXED':
                    if (vm.dataToFill.pickupFixed) {
                        vm.dataToFill.pickupFixed = false;
                    } else {
                        vm.dataToFill.pickupFixed = true;
                    }
                    break;
                case 'DROPOFF_FIXED':
                    if (vm.dataToFill.dropOffFixed) {
                        vm.dataToFill.dropOffFixed = false;
                    } else {
                        vm.dataToFill.dropOffFixed = true;
                    }
                    break;
                case 'COST_CENTER':
                    if (vm.dataToFill.costCenter) {
                        vm.dataToFill.costCenter = false;
                    } else {
                        vm.dataToFill.costCenter = true;
                    }
                    break;
                case 'COST_SUB_CENTER':
                    if (vm.dataToFill.costSubCenter) {
                        vm.dataToFill.costSubCenter = false;
                    } else {
                        vm.dataToFill.costSubCenter = true;
                    }
                    break;
                case 'ROL':
                    if (vm.dataToFill.rol) {
                        vm.dataToFill.rol = false;
                    } else {
                        vm.dataToFill.rol = true;
                    }
                    break;
                case 'GRAPH':
                    if (vm.dataToFill.graph) {
                        vm.dataToFill.graph = false;
                    } else {
                        vm.dataToFill.graph = true;
                    }
                    break;
                case 'WORK_ORDER':
                    if (vm.dataToFill.workOrder) {
                        vm.dataToFill.workOrder = false;
                    } else {
                        vm.dataToFill.workOrder = true;
                    }
                    break;
                case 'PEP':
                    if (vm.dataToFill.pep) {
                        vm.dataToFill.pep = false;
                    } else {
                        vm.dataToFill.pep = true;
                    }
                    break;
                case 'NUMBER_VOUCHERS':
                    if (vm.dataToFill.numberVoucher) {
                        vm.dataToFill.numberVoucher = false;
                    } else {
                        vm.dataToFill.numberVoucher = true;
                    }
                    break;
                case 'PURPOSE_TRIP':
                    if (vm.dataToFill.purpouseOfTrip) {
                        vm.dataToFill.purpouseOfTrip = false;
                    } else {
                        vm.dataToFill.purpouseOfTrip = true;
                    }
                    break;
                case 'NOMINA':
                    if (vm.dataToFill.nomina) {
                        vm.dataToFill.nomina = false;
                    } else {
                        vm.dataToFill.nomina = true;
                    }
                    break;
                case 'SOLICITUDE':
                    if (vm.dataToFill.solicitude) {
                        vm.dataToFill.solicitude = false;
                    } else {
                        vm.dataToFill.solicitude = true;
                    }
                    break;
                case 'AUTH_LOAD_PROFILE':
                    if (vm.dataToFill.authLoadProfile) {
                        vm.dataToFill.authLoadProfile = false;
                    } else {
                        vm.dataToFill.authLoadProfile = true;
                    }
                    break;
                case 'Mandatory_Airline':
                    if (vm.dataToFill.airline) {
                        vm.dataToFill.airline = false;
                    } else {
                        vm.dataToFill.airline = true;
                    }
                    break;
                case 'Mandatory_Flight':
                    if (vm.dataToFill.flight) {
                        vm.dataToFill.flight = false;
                    } else {
                        vm.dataToFill.flight = true;
                    }
                    break;
                case 'Mandatory_Flight_Date':
                    if (vm.dataToFill.flightDate) {
                        vm.dataToFill.flightDate = false;
                    } else {
                        vm.dataToFill.flightDate = true;
                    }
                    break;
                case 'Mandatory_Flight_Type':
                    if (vm.dataToFill.flightType) {
                        vm.dataToFill.flightType = false;
                    } else {
                        vm.dataToFill.flightType = true;
                    }
                    break;
                case 'ROUND_TRIP_WAIT_TIME':
                    if (vm.dataToFill.roundTripWaitTime) {
                        vm.dataToFill.roundTripWaitTime = false;
                    } else {
                        vm.dataToFill.roundTripWaitTime = true;
                    }
                    break;
                case 'CONTROLLED_WAY':
                    if (vm.dataToFill.controlledWay) {
                        vm.dataToFill.controlledWay = false;
                        vm.dataToFill.viaControlled = false;
                        vm.dataToFill.viaControlledTarifa = false;
                    } else {
                        vm.dataToFill.controlledWay = true;
                    }
                    break;
                case 'SHARED_SERVICES':
                    if (vm.dataToFill.sharedServices) {
                        vm.dataToFill.sharedServices = false;
                    } else {
                        vm.dataToFill.sharedServices = true;
                    }
                    break;
                case 'ALLOW_BOOKINGS_WITHOUT_REQUEST':
                    if (vm.dataToFill.allowBookingWithoutRequest) {
                        vm.dataToFill.allowBookingWithoutRequest = false;
                    } else {
                        vm.dataToFill.allowBookingWithoutRequest = true;
                    }
                    break;
                case 'GROUP_SERVICES':
                    if (vm.dataToFill.groupServices) {
                        vm.dataToFill.groupServices = false;
                        vm.dataToFill.chargeFullPath = false;
                        vm.dataToFill.chargeEachReservation = false;
                        vm.dataToFill.automaticGrouping = false
                    } else {
                        vm.dataToFill.groupServices = true;
                        vm.dataToFill.chargeFullPath = true;
                    }
                    break;
                case 'GROUP_EXTERNAL':
                    if (vm.dataToFill.groupExternal) {
                        vm.dataToFill.groupExternal = false;
                    } else {
                        vm.dataToFill.groupExternal = true;
                    }
                    break;
                case 'charge_Full_Path':
                    if (vm.dataToFill.chargeFullPath) {
                        vm.dataToFill.chargeFullPath = false;
                        vm.dataToFill.chargeEachReservation = true;
                    } else {
                        vm.dataToFill.chargeFullPath = true;
                        vm.dataToFill.chargeEachReservation = false;
                    }    
                    break;
                case 'charge_Each_Reservation':
                    if (vm.dataToFill.chargeEachReservation) {
                        vm.dataToFill.chargeEachReservation = false;
                        vm.dataToFill.chargeFullPath = true;
                    } else {
                        vm.dataToFill.chargeEachReservation = true;
                        vm.dataToFill.chargeFullPath = false;
                    }    
                    break;
                case 'sms_to_passenger_on_grouping':
                    if (vm.dataToFill.smsToPass) {
                        vm.dataToFill.smsToPass = false;
                    } else {
                        vm.dataToFill.smsToPass = true;
                    }    
                    break;
                case 'sms_to_applicant_on_grouping':
                    if (vm.dataToFill.smsToAppl) {
                        vm.dataToFill.smsToAppl = false;
                    } else {
                        vm.dataToFill.smsToAppl = true;
                    }    
                    break;
                case 'email_to_passenger_on_grouping':
                    if (vm.dataToFill.emailToPass) {
                        vm.dataToFill.emailToPass = false;
                    } else {
                        vm.dataToFill.emailToPass = true;
                    }    
                    break;
                case 'email_to_applicant_on_grouping':
                    if (vm.dataToFill.emailToAppl) {
                        vm.dataToFill.emailToAppl = false;
                    } else {
                        vm.dataToFill.emailToAppl = true;
                    }    
                    break;
                case 'AUTOMATIC_GROUPING':
                    if (vm.dataToFill.automaticGrouping) {
                        vm.dataToFill.automaticGrouping = false;
                    } else {
                        vm.dataToFill.automaticGrouping = true;
                    }    
                    break;
                case 'Monitoring_Services':
                    if (vm.dataToFill.monitoringServices) {
                        vm.dataToFill.monitoringServices = false;
                    } else {
                        vm.dataToFill.monitoringServices = true;
                    }
                    break;
                case 'VIA_CONTROLLED':
                    if (vm.dataToFill.viaControlled) {
                        vm.dataToFill.viaControlled = false;
                    } else {
                        ///////////////////////////TV-1795 //////////////////////////
                        if (vm.dataToFill.controlledWay == true) {
                            vm.dataToFill.viaControlled = true;
                        } else {
                            vm.dataToFill.viaControlled = false;
                        }
                        ///////////////////////////TV-1795 //////////////////////////
                    }
                    break;
                case 'VIA_CONTROLLED_TARIFA':
                    if (vm.dataToFill.viaControlledTarifa) {
                        vm.dataToFill.viaControlledTarifa = false;
                    } else {
                        ///////////////////////////TV-1795 //////////////////////////
                        if (vm.dataToFill.controlledWay == true) {
                            vm.dataToFill.viaControlledTarifa = true;
                        } else {
                            vm.dataToFill.viaControlledTarifa = false;
                        }
                        ///////////////////////////TV-1795 ////////////////////////// 
                    }
                    break;
                case 'ENABLE_VARIBLE_RATE':
                    if (vm.dataToFill.enableVaribleRate) {
                        vm.dataToFill.enableVaribleRate = false;
                    } else {
                        vm.dataToFill.enableVaribleRate = true;

                    }
                    break;
                case 'ENABLE_SMS':
                    if (vm.dataToFill.enableSMS) {
                        vm.dataToFill.enableSMS = false;
                    } else {
                        vm.dataToFill.enableSMS = true;
    
                    }
                    break;
                case 'APPLY_CHARGE':
                    if (vm.dataToFill.applyCharge) {
                        vm.dataToFill.applyCharge = false;
                        vm.dataToFill.collectEstimatedTag = false;
                    } else {
                        vm.dataToFill.applyCharge = true;
        
                    }
                    break;
                case 'APPLY_ESTIMATED_FARE':
                    if (vm.dataToFill.applyEstimatedFare) {
                        vm.dataToFill.applyEstimatedFare = false;
                    } else {
                        vm.dataToFill.applyEstimatedFare = true;
        
                    }
                    break;
                case 'COLLECT_ESTIMATED_TAG':
                    if (vm.dataToFill.collectEstimatedTag) {
                        vm.dataToFill.collectEstimatedTag = false;
                    } else {
                        vm.dataToFill.collectEstimatedTag = true;
                    }
                    break;
                case 'APPLY_REAL_TIME_TRAVEL':
                    if (vm.dataToFill.charge_for_estimated_travel_time) {
                        vm.dataToFill.charge_for_estimated_travel_time = false;
                    } else {
                        vm.dataToFill.charge_for_estimated_travel_time = true;
                    }
                    break;
                case 'APPLY_QR_P':
                    if (vm.dataToFill.apply_qr_p) {
                        vm.dataToFill.apply_qr_p = false;
                    } else {
                        vm.dataToFill.apply_qr_p = true;
                    }
                    break;
                case 'DISABLE_SMS_CUSTOMER':
                    if (vm.dataToFill.disable_sms_customer) {
                        vm.dataToFill.disable_sms_customer = false;
                    } else {
                        vm.dataToFill.disable_sms_customer = true;
                    }
                    break;
                case 'crear_reserva':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.crearReserva) {
                        vm.dataToFill.crearReserva = false;
                    } else {
                        vm.dataToFill.crearReserva = true;
                    }
                    break;
                case 'finalizar_reserva':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.finalizarReserva) {
                        vm.dataToFill.finalizarReserva = false;
                    } else {
                        vm.dataToFill.finalizarReserva = true;
                    }
                    break;
                case 'anular_reserva':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.anularReserva) {
                        vm.dataToFill.anularReserva = false;
                    } else {
                        vm.dataToFill.anularReserva = true;
                    }
                    break;
                case 'marcar_reserva':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.marcarReserva) {
                        vm.dataToFill.marcarReserva = false;
                    } else {
                        vm.dataToFill.marcarReserva = true;
                    }
                    break;
                case 'retarificar_reserva':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.retarificarReserva) {
                        vm.dataToFill.retarificarReserva = false;
                    } else {
                        vm.dataToFill.retarificarReserva = true;
                    }
                    break;
                case 'crear_reserva_solicitante':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.crearReservaSolicitante) {
                        vm.dataToFill.crearReservaSolicitante = false;
                    } else {
                        vm.dataToFill.crearReservaSolicitante = true;
                    }
                    break;
                case 'finalizar_reserva_solicitante':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.finalizarReservaSolicitante) {
                        vm.dataToFill.finalizarReservaSolicitante = false;
                    } else {
                        vm.dataToFill.finalizarReservaSolicitante = true;
                    }
                    break;
                case 'anular_reserva_solicitante':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.anularReservaSolicitante) {
                        vm.dataToFill.anularReservaSolicitante = false;
                    } else {
                        vm.dataToFill.anularReservaSolicitante = true;
                    }
                    break;
                case 'marcar_reserva_solicitante':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.marcarReservaSolicitante) {
                        vm.dataToFill.marcarReservaSolicitante = false;
                    } else {
                        vm.dataToFill.marcarReservaSolicitante = true;
                    }
                    break;
                case 'retarificar_reserva_solicitante':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.retarificarReservaSolicitante) {
                        vm.dataToFill.retarificarReservaSolicitante = false;
                    } else {
                        vm.dataToFill.retarificarReservaSolicitante = true;
                    }
                    break;
                case 'crear_reserva_administrador':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.crearReservaAdministrador) {
                        vm.dataToFill.crearReservaAdministrador = false;
                    } else {
                        vm.dataToFill.crearReservaAdministrador = true;
                    }
                    break;
                case 'finalizar_reserva_administrador':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.finalizarReservaAdministrador) {
                        vm.dataToFill.finalizarReservaAdministrador = false;
                    } else {
                        vm.dataToFill.finalizarReservaAdministrador = true;
                    }
                    break;
                case 'anular_reserva_administrador':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.anularReservaAdministrador) {
                        vm.dataToFill.anularReservaAdministrador = false;
                    } else {
                        vm.dataToFill.anularReservaAdministrador = true;
                    }
                    break;
                case 'marcar_reserva_administrador':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.marcarReservaAdministrador) {
                        vm.dataToFill.marcarReservaAdministrador = false;
                    } else {
                        vm.dataToFill.marcarReservaAdministrador = true;
                    }
                    break;
                case 'retarificar_reserva_administrador':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.retarificarReservaAdministrador) {
                        vm.dataToFill.retarificarReservaAdministrador = false;
                    } else {
                        vm.dataToFill.retarificarReservaAdministrador = true;
                    }
                    break;
                case 'para_calificar_conductor':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.paraCalificarConductor) {
                        vm.dataToFill.paraCalificarConductor = false;
                    } else {
                        vm.dataToFill.paraCalificarConductor = true;
                    }
                    break;
                case 'para_calificar_conductor_solicitante':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.paraCalificarConductorSolicitante) {
                        vm.dataToFill.paraCalificarConductorSolicitante = false;
                    } else {
                        vm.dataToFill.paraCalificarConductorSolicitante = true;
                    }
                    break;
                case 'restriccion_flota':
                    // ************ TV-1703 ***********
                    if (vm.dataToFill.restriccion_flota) {
                        vm.dataToFill.restriccion_flota = false;
                    } else {
                        vm.dataToFill.restriccion_flota = true;
                    }
                    break;

                    // case 'Allow_Change_Fare_POS':
                    //     // ************ TV-1703 ***********
                    //     if (vm.dataToFill.changeFareForPos) {
                    //         vm.dataToFill.changeFareForPos = false;
                    //     } else {
                    //         vm.dataToFill.changeFareForPos = true;
                    //     }
                    //     break;

                    // case 'Allow_Change_Fare_Create_Booking':
                    //     // ************ TV-1703 ***********
                    //     if (vm.dataToFill.changeFareForCreateBooking) {
                    //         vm.dataToFill.changeFareForCreateBooking = false;
                    //     } else {
                    //         vm.dataToFill.changeFareForCreateBooking = true;
                    //     }
                    //     break;

                    // case 'Allow_Change_Fare_Create_Booking':
                    //     // ************ TV-1703 ***********
                    //     if (vm.dataToFill.changeFareForCreateBooking) {
                    //         vm.dataToFill.changeFareForCreateBooking = false;
                    //     } else {
                    //         vm.dataToFill.changeFareForCreateBooking = true;
                    //     }
                    //     break;

            }
        };

        //==============get all corporate=================
        function getAllCorporate() {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = 0;
            dataSend.offset = 0;
            dataSend.key = 2;
            dataSend.search_filter = 0;
            var promise = getCorporate.allCorporates(dataSend);
            promise.then(
                function (payload) {
                    vm.loading = false;
                    vm.corporatesList = _.where(payload.title.data.result, {
                        status: 1
                    });
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        //==============get all services=================
        function getAllServices() {
            vm.loading = true;
            var promise = getServices.allServices(0, 0, 2, 0);
            promise.then(
                function (payload) {
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.servicesList = _.where(payload.title.data.result, {
                            status: 1
                        });
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        //==============get all payment types=================
        function getAllPaymentTypes() {
            vm.loading = true;
            var promise = getPaymentMethods.allMethods(2, 0, 0);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.paymentTypesList = _.where(payload.title.data.result, {
                        status: 1
                    });
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getAllPaymentTypes();
        //====================get branch list====================
        function getBranch() {
            vm.loading = true;
            var promise = getGeofence.branch();
            promise.then(
                function (payload) {
                    $log.log('branch', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        var where = _.where(payload.title.data, {
                            is_active: 1
                        });
                        vm.branchList = _.where(where, {
                            parent_id: 0
                        });
                    }
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        getBranch();

        //=======================add agreement api=============================
        function editAgreementApi() {
            $log.log(vm.dataToFill);

            if (vm.dataToFill.roundTripDiscount > 100) {
                languageBasedErrorFactory.getProperErrorMessage('agreementErrPop', 0, 0);
                return;
            }
            if (vm.dataToFill.webPayDiscount > 100) {
                languageBasedErrorFactory.getProperErrorMessage('agreementErrPop1', 0, 0);
                return;
            }

            if (vm.dataToFill.startDate > vm.dataToFill.endDate) {
                languageBasedErrorFactory.getProperErrorMessage('approValidDates', 0, 0);
                //errorMessageFactory.showErrorMessage('Please select appropriate validity dates.');
                return;
            }
            if (vm.dataToFill.invoiceContactPerson && !vm.dataToFill.emailAdministrator) {
                errorMessageFactory.showErrorMessage('El email del administrador del contrato está pendiente, Favor ingresar.', 0);
                return;
            }
            //if(vm.dataToFill.baseFareDiscount > 100){
            //    errorMessageFactory.showErrorMessage('Please enter base fare discount less than 100%');
            //    return;
            //}

            vm.finalDataSend = {};
            vm.finalDataSend.startDateValidity = moment(vm.dataToFill.startDate).format('YYYY-MM-DD HH:mm:ss');
            vm.finalDataSend.endDateValidity = moment(vm.dataToFill.endDate).format('YYYY-MM-DD HH:mm:ss');
            vm.finalDataSend.name = vm.dataToFill.agreementName;
            vm.finalDataSend.agreement_type = vm.dataToFill.agreementType;
            vm.finalDataSend.corporate_id = vm.dataToFill.corporateName;
            vm.finalDataSend.typeOfServices = [];
            for (var i = 0; i < vm.dataToFill.fullTypeOfService.length; i++) {
                var fullTypeOfService = vm.dataToFill.fullTypeOfService[i];
                if (!vm.dataToFill.typeOfService.includes(fullTypeOfService.typeOfService.id)) {
                    fullTypeOfService.is_deleted = true;
                }
            }
            for (var i = 0; i < vm.dataToFill.typeOfService.length; i++) {
                var id = vm.dataToFill.typeOfService[i];
                var objetoExistente = vm.dataToFill.fullTypeOfService.find(function (objeto) {
                    if(objeto.typeOfService){
                        return objeto.typeOfService.id === id;
                    }
                });

                if (!objetoExistente) {
                    // Si el objeto no existe, agregar un nuevo objeto con ese ID y estado (status) en 0
                    vm.dataToFill.fullTypeOfService.push({ type_of_service_id: id, contract_id: vm.dataToFill.id, is_deleted: false });
                }
            }
            vm.finalDataSend.typeOfServices = vm.dataToFill.fullTypeOfService;
            //vm.finalDataSend.type_of_service_id = vm.dataToFill.typeOfService;
            vm.finalDataSend.payments = [];
            for (var i = 0; i < vm.dataToFill.fullPaymentMethodSelected.length; i++) {
                var fullPaymentMethodSelected = vm.dataToFill.fullPaymentMethodSelected[i];
                var objetoExistente = vm.dataToFill.paymentMethodSelected.find(function (idObj) {
                    return idObj.id === fullPaymentMethodSelected.payment_method.id;
                });
            
                if (!objetoExistente) {
                    fullPaymentMethodSelected.is_deleted = 1;
                }
            }
            for (var i = 0; i < vm.dataToFill.paymentMethodSelected.length; i++) {
                var idObj = vm.dataToFill.paymentMethodSelected[i];
                var objetoExistente = vm.dataToFill.fullPaymentMethodSelected.find(function (objeto) {
                    if(objeto.payment_method){
                        return objeto.payment_method.id === idObj.id;
                    }
                });

                if (!objetoExistente) {
                    // Si el objeto no existe, agregar un nuevo objeto con ese ID y estado (status) en 0
                    vm.dataToFill.fullPaymentMethodSelected.push({ payment_method_id: idObj.id, contract_id: vm.dataToFill.id, is_deleted: false });
                }
            }
            vm.finalDataSend.payments = vm.dataToFill.fullPaymentMethodSelected;
            vm.finalDataSend.branches = [];
            for (var i = 0; i < vm.dataToFill.fullBranch.length; i++) {
                var fullBranch = vm.dataToFill.fullBranch[i];
                if (!vm.dataToFill.branch.includes(fullBranch.region.region_id)) {
                    fullBranch.is_deleted = true;
                }
            }
            for (var i = 0; i < vm.dataToFill.branch.length; i++) {
                var id = vm.dataToFill.branch[i];
                var objetoExistente = vm.dataToFill.fullBranch.find(function (objeto) {
                    if(objeto.region){
                        return objeto.region.region_id === id;
                    }
                });

                if (!objetoExistente) {
                    // Si el objeto no existe, agregar un nuevo objeto con ese ID y estado (status) en 0
                    vm.dataToFill.fullBranch.push({ region_id: id, status:1, is_deleted: false, contract_id: vm.dataToFill.id });
                }
            }
            vm.finalDataSend.branches = vm.dataToFill.fullBranch;
            //vm.finalDataSend.payment_method_id = vm.dataToFill.payment_method_id;
            vm.finalDataSend.chargesForNoShow = vm.dataToFill.noShowCharges;
            vm.finalDataSend.maxWaitTimeTolerance = vm.dataToFill.waitTolerance;
            vm.finalDataSend.maxWaitTimeFree = vm.dataToFill.waitTimeFree;
            vm.finalDataSend.maxWaitTimeEnRoute = vm.dataToFill.waitRoute;
            //vm.finalDataSend.discount_based_fare = vm.dataToFill.baseFareDiscount;
            vm.finalDataSend.commercialClassification = vm.dataToFill.commercialClassification;
            vm.finalDataSend.paymentMethodDefault = vm.dataToFill.paymentMethod;
            if (vm.dataToFill.virtualFleet || vm.dataToFill.virtualFleet === 0 || vm.dataToFill.virtualFleet === '0') {
                vm.finalDataSend.virtualFleet = vm.dataToFill.virtualFleet;
            }
            vm.finalDataSend.comments = vm.dataToFill.comments;
            vm.finalDataSend.fareToCustomer = vm.dataToFill.fareToCustomer ? true : false;
            vm.finalDataSend.fareToDriver = vm.dataToFill.fareToDriver ? true : false;
            vm.finalDataSend.rutMendatory = vm.dataToFill.passengerRut ? true : false;
            vm.finalDataSend.applicantRutMendatory = vm.dataToFill.applicantRut ? true : false;
            vm.finalDataSend.authRutMendatory = vm.dataToFill.authrizerRut ? true : false;
            vm.finalDataSend.invoiceToCustomer = 0; //vm.dataToFill.invoiceCustomer ? 1 :
            vm.finalDataSend.invoiceToApplicant = 0; //  vm.dataToFill.invoiceApplicant ? 1 :
            vm.finalDataSend.invoiceToContactPerson = 0; //vm.dataToFill.invoiceContactPerson ? 1 :
            //vm.finalDataSend.invoice_to_contact_persion = vm.dataToFill.invoiceContractPerson?1:0;
            //vm.finalDataSend.invoice_to_employee = vm.dataToFill.invoiceEmployee?1:0;
            vm.finalDataSend.costCenterMandatory = vm.dataToFill.costCenter ? true : false;
            vm.finalDataSend.costSubCenterMandatory = vm.dataToFill.costSubCenter ? true : false;
            vm.finalDataSend.rolMandatory = vm.dataToFill.rol ? true : false;
            vm.finalDataSend.graphMandatory = vm.dataToFill.graph ? true : false;
            vm.finalDataSend.workOrderMandatory = vm.dataToFill.workOrder ? true : false;
            vm.finalDataSend.pepMandatory = vm.dataToFill.pep ? true : false;
            vm.finalDataSend.numberOfVoucherMandatory = vm.dataToFill.numberVoucher ? true : false;
            vm.finalDataSend.purposeOfTripMandatory = vm.dataToFill.purpouseOfTrip ? true : false;
            vm.finalDataSend.requireAuthLoadProfile = vm.dataToFill.authLoadProfile ? true : false;
            vm.finalDataSend.airlineMandatory = vm.dataToFill.airline ? true : false;
            vm.finalDataSend.flightNumberMandatory = vm.dataToFill.flight ? true : false;
            vm.finalDataSend.flightDateMandatory = vm.dataToFill.flightDate ? true : false;
            vm.finalDataSend.flightTypeMandatory = vm.dataToFill.flightType ? true : false;
            vm.finalDataSend.monitoringServicesWisetrack = vm.dataToFill.monitoringServices ? true : false;
            vm.finalDataSend.roundTripWaitTime = vm.dataToFill.roundTripWaitTime ? true : false;
            vm.finalDataSend.access_token = $cookies.get('obj');
            vm.finalDataSend.contractAdmin = vm.dataToFill.contractAdmin;
            vm.finalDataSend.contract_id = vm.dataToFill.id;
            console.log(vm.finalDataSend.contract_id, 'vm.finalDataSend.contract_id');
            vm.finalDataSend.solicitudMandatory = vm.dataToFill.solicitude ? true : false;
            vm.finalDataSend.nominaMandatory = vm.dataToFill.nomina ? true : false;
            vm.finalDataSend.controlledWay = vm.dataToFill.controlledWay ? true : false;
            vm.finalDataSend.isMixShared = vm.dataToFill.sharedServices ? true : false;
            vm.finalDataSend.isGroupAllowed = vm.dataToFill.groupServices ? true : false;
            vm.finalDataSend.isGroupedExternal = vm.dataToFill.groupExternal ? true : false;
            vm.finalDataSend.chargeForEachReservationGrouped = vm.dataToFill.groupServices ? (vm.dataToFill.chargeFullPath ? 0 : ( vm.dataToFill.chargeEachReservation ? 1 : 0 )) : 0;
            vm.finalDataSend.serviceGroupingType = vm.dataToFill.groupServices ? (vm.dataToFill.automaticGrouping ? 2 : 1) : 1;
            vm.finalDataSend.metaData = {};
            vm.finalDataSend.metaData.sms_to_passenger_on_grouping = vm.dataToFill.smsToPass ? true : false;
            vm.finalDataSend.metaData.sms_to_applicant_on_grouping =  vm.dataToFill.smsToAppl ? true : false;
            vm.finalDataSend.metaData.email_to_passenger_on_grouping =  vm.dataToFill.emailToPass ? true : false;
            vm.finalDataSend.metaData.email_to_applicant_on_grouping =  vm.dataToFill.emailToAppl ? true : false;
            vm.finalDataSend.enableSmsOption = vm.dataToFill.enableSMS ? true : false;
            vm.finalDataSend.applyChargeByToll = vm.dataToFill.applyCharge ? true : false;
            vm.finalDataSend.collectEstimatedTag = vm.dataToFill.collectEstimatedTag ? true : false;
            vm.finalDataSend.chargeForEstimatedTravelTime = vm.dataToFill.charge_for_estimated_travel_time ? true : false;
            vm.finalDataSend.qrcodeStatus = vm.dataToFill.apply_qr_p ? true : false;
            vm.finalDataSend.smsMinutesQrP = vm.dataToFill.sms_minutes_qr_p;
            vm.finalDataSend.restriccionFlota = vm.dataToFill.restriccion_flota;
            vm.finalDataSend.disableSmsCustomer = vm.dataToFill.disable_sms_customer ? true : false;
            vm.finalDataSend.applyEstimatedDistanceVariableFare = vm.dataToFill.applyEstimatedFare ? true : false;
            vm.finalDataSend.isBwr = vm.dataToFill.allowBookingWithoutRequest ? true : false;
            vm.finalDataSend.employeeEndowment = Number(vm.dataToFill.employeeEndowment);
            vm.finalDataSend.rtDiscount = vm.dataToFill.roundTripDiscount;
            vm.finalDataSend.webDiscount = vm.dataToFill.webPayDiscount;
            vm.finalDataSend.administratorEmail = vm.dataToFill.emailAdministrator ? vm.dataToFill.emailAdministrator : '';
            vm.finalDataSend.qthFactor = vm.dataToFill.qthFactor;
            vm.finalDataSend.showViaControlInVoucher = vm.dataToFill.viaControlled ? true : false;
            vm.finalDataSend.viaControlIncludeInTarifa = vm.dataToFill.viaControlledTarifa ? true : false;
            vm.finalDataSend.enableVariableRate = vm.dataToFill.enableVaribleRate ? true : false;
            vm.finalDataSend.passengerCreateBooking = vm.dataToFill.crearReserva ? true : false;
            vm.finalDataSend.passengerEndBooking = vm.dataToFill.finalizarReserva ? true : false;
            vm.finalDataSend.passengerCancelBooking = vm.dataToFill.anularReserva ? true : false;
            vm.finalDataSend.passengerNoshowBooking = vm.dataToFill.marcarReserva ? true : false;
            vm.finalDataSend.passengerCorrectFareBooking = vm.dataToFill.retarificarReserva ? true : false;
            vm.finalDataSend.applicantCreateBooking = vm.dataToFill.crearReservaSolicitante ? true : false;
            vm.finalDataSend.applicantEndBooking = vm.dataToFill.finalizarReservaSolicitante ? true : false;
            vm.finalDataSend.applicantCancelBooking = vm.dataToFill.anularReservaSolicitante ? true : false;
            vm.finalDataSend.applicantNoshowBooking = vm.dataToFill.marcarReservaSolicitante ? true : false;
            vm.finalDataSend.applicantCorrectFareBooking = vm.dataToFill.retarificarReservaSolicitante ? true : false;
            vm.finalDataSend.administratorCreateBooking = vm.dataToFill.crearReservaAdministrador ? true : false;
            vm.finalDataSend.administratorEndBooking = vm.dataToFill.finalizarReservaAdministrador ? true : false;
            vm.finalDataSend.administratorCancelBooking = vm.dataToFill.anularReservaAdministrador ? true : false;
            vm.finalDataSend.administratorNoshowBooking = vm.dataToFill.marcarReservaAdministrador ? true : false;
            vm.finalDataSend.administratorCorrectFareBooking = vm.dataToFill.retarificarReservaAdministrador ? true : false;
            vm.finalDataSend.passengerRateDriverBooking = vm.dataToFill.paraCalificarConductor ? true : false;
            vm.finalDataSend.applicantRateDriverBooking = vm.dataToFill.paraCalificarConductorSolicitante ? true : false;
            // KEYS TO ALLOW MODIFY AMOUNT
            // vm.finalDataSend.allow_change_fare_POS = vm.dataToFill.changeFareForPos ? true : false;
            // vm.finalDataSend.allow_change_fare_panel = vm.dataToFill.changeFareForCreateBooking ? true : false;

            vm.finalDataSend.thresholdValue = Number(vm.dataToFill.groupThreshold);

            //vm.finalDataSend.status = vm.dataToFill.status;
            //vm.finalDataSend.employee_list = [];
            //for(var i=0;i<vm.dataToFill.employeeData.length;i++){
            //    vm.finalDataSend.employee_list.push({
            //        name: vm.dataToFill.employeeData[i].name,
            //        RUT: vm.dataToFill.employeeData[i].RUT,
            //        email: vm.dataToFill.employeeData[i].email,
            //        approval_required: vm.dataToFill.employeeData[i].approval_required?1:0,
            //        thirdBooking: vm.dataToFill.employeeData[i].thirdBooking?1:0
            //    })
            //}

            $log.log(vm.finalDataSend);
            vm.loading = true;
            var promise = getAgreement.newEditAgreement(vm.finalDataSend, vm.dataToFill.id);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    var dataForSysLogs = {
                        access_token: $cookies.get('obj'),
                        id: vm.dataToFill.id,
                        identity: 7,
                        message: 'Agreement updated.'
                    };
                    $rootScope.systemLogsAdmin(dataForSysLogs);
                    languageBasedErrorFactory.getProperErrorMessage('editAgreementSucc', 0, 2, 'layout.agreementMain.agreement');
                    //errorMessageFactory.showErrorMessage('Agreement details updated successfully.',2,'layout.agreementMain.agreement');

                    //$timeout(function(){
                    //    $mdDialog.hide();
                    //    $state.reload();
                    //},2000);
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        function redirectToConfigure() {
            localStorage.setItem('agreementBranches', JSON.stringify(vm.finalAgreement.branches));
            $state.go('layout.agreementMain.configureAgreement',{id:vm.finalAgreement.id});
        }

        $scope.isPaymentSelected = function(item) {
            if (!item) return false;
            return !$scope.vm.dataToFill.paymentMethodSelected.some(function(selectedItem) {
                return selectedItem.id === item.id;
            });
        };
    }
})();

/**
 * Created by rahul on 20/09/22.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('ConfigureAgreementController', ConfigureAgreementController);

    /** @ngInject */
    function ConfigureAgreementController($cookies, $state, $log, $stateParams, $mdDialog, getAgreement, languageBasedErrorFactory, errorMessageFactory) {
        var vm = this;
        vm.onSubmit = onSubmit;
        vm.getDestinationBases = getDestinationBases;
        vm.openAddEdit = openAddEdit;
        vm.closeAddEdit = closeAddEdit;
        vm.loading = false;
        vm.goBack = goBack;
        vm.deleteDestinationBase = deleteDestinationBase;
        vm.enableDisableDestinationBase = enableDisableDestinationBase;
        vm.getTypeOfServices = getTypeOfServices;
        vm.onServicesSubmit = onServicesSubmit;

        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();

        vm.forTabsView = 1;
        vm.contractId = $stateParams.id;
        vm.showAddEdit = false;
        vm.isEdit = false;
        vm.dataToFill = {
            contract_id: vm.contractId,
            branch_id : '',
            depot_id : '',
            zone_bucket : '',
            address : '',
            latitude : '',
            longitude :''
        };

        vm.branchesArray = JSON.parse(localStorage.getItem('agreementBranches'));

        //===========================get all destination bases=============================
        function getDestinationBases() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.contract_id = vm.contractId;
            dataSend.skip = 0;
            dataSend.limit = 10;
            vm.loading = true;
            var promise = getAgreement.getDestinationBases(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if(payload.title.data.bases && payload.title.data.bases.length) {
                        vm.basesArray = payload.title.data.bases.map(
                            function(t1){
                                 return (Object.assign(t1, {
                                    'region_name' : vm.branchesArray.find(
                                        function(t2) {
                                            return (t2.region_id === t1.branch_id);
                                     }).region.region_name}))
                            });
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        getDestinationBases();

        //========================function to go back==========================
        function goBack() {
            $state.go('layout.agreementMain.editAgreement', {
                id : vm.contractId
            });
        }

        // =====================enable disable destination base ============================
        function enableDisableDestinationBase($event, data) {
            var confirm = $mdDialog.confirm()
                .title('¿Está seguro de que desea cambiar el estado de la base de destino?')
                // .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok('Confirmar')
                .cancel('Cerca');

            $mdDialog.show(confirm).then(function () {
                vm.loading = true;
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.contract_id = vm.contractId;
                dataSend.base_id = data.base_id;
                dataSend.is_active = data.is_active ? 0 : 1;
                var promise = getAgreement.enableDisableDestinationBase(dataSend);
                promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        if (payload.title.status == 200) {
                            vm.loading = false;
                            getDestinationBases();
                            errorMessageFactory.showErrorMessage('Estado base de destino modificado con éxito', 0);
                        }
                        // $mdDialog.hide();
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        //vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        }
 
        // =====================delete destination base ============================
        function deleteDestinationBase($event, data) {
            var confirm = $mdDialog.confirm()
                .title('¿Desea eliminar esta base de destino?')
                // .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok('Confirmar')
                .cancel('Cerca');

            $mdDialog.show(confirm).then(function () {
                vm.loading = true;
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.contract_id = vm.contractId;
                dataSend.base_id = data.base_id;
                var promise = getAgreement.deleteDestinationBase(dataSend);
                promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        if (payload.title.status == 200) {
                            vm.loading = false;
                            getDestinationBases();
                            errorMessageFactory.showErrorMessage('Base de destino eliminada con éxito', 0);
                        }
                        // $mdDialog.hide();
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        //vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        }

        //=======================open add/edit destination base =============================
        function openAddEdit(isEdit, data) {
            vm.loading = true;
            vm.showAddEdit = true;
            if(isEdit) {
                vm.isEdit = true;
                vm.dataToFill = {
                    base_id: data.base_id,
                    contract_id: data.contract_id || '',
                    branch_id : data.branch_id || '',
                    depot_id : data.depot_id || '',
                    zone_bucket : data.zone_bucket || '',
                    address : data.address || '',
                    latitude : data.latitude || '',
                    longitude : data.longitude || ''
                };
            } else {
                vm.isEdit = false;
                vm.dataToFill = {
                    contract_id: vm.contractId,
                    branch_id : '',
                    depot_id : '',
                    zone_bucket : '',
                    address : '',
                    latitude : '',
                    longitude :''
                };
            }
            vm.loading = false;
        }

        //=======================close add/edit destination base =============================
        function closeAddEdit() {
            vm.showAddEdit = false;
        }

        //=======================add/edit destination base api=============================
        function onSubmit() {
            $log.log(vm.dataToFill);
            vm.finalDataSend = Object.assign(vm.dataToFill, { access_token: $cookies.get('obj') })
            $log.log(vm.finalDataSend);
            vm.loading = true;
            var promise = getAgreement.addEditDestinationBase(vm.finalDataSend, vm.isEdit);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    if (payload.title.status == 200) {
                        getDestinationBases();
                        if(vm.isEdit)
                            errorMessageFactory.showErrorMessage('Base de destino actualizada con éxito',2,'layout.agreementMain.configureAgreement');
                        else
                            errorMessageFactory.showErrorMessage('Base de destino añadida con éxito',2,'layout.agreementMain.configureAgreement');
                            
                        vm.showAddEdit = false;
                    }
                    vm.loading = false;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        /****************************Type of Services Logic********************************/

        //===========================get all type of services=============================
        function getTypeOfServices() {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.contract_id = vm.contractId;
            vm.loading = true;
            var promise = getAgreement.getTypeOfServices(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.contractServicesArray = payload.title.data.contract_services;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

         //=======================update type of services=============================
         function onServicesSubmit() {
            $log.log(vm.dataToFill);
            var tempArr = JSON.parse(JSON.stringify(vm.contractServicesArray));
            var servicesArr = tempArr.map(function(item){ delete item.service_name; return item; })
            vm.servicesData = {
                access_token: $cookies.get('obj'),
                contract_id: vm.contractId,
                contract_services: servicesArr
            };
            $log.log(vm.servicesData);
            vm.loading = true;
            var promise = getAgreement.updateTypeOfServices(vm.servicesData);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    if (payload.title.status == 200) {
                        getTypeOfServices();
                        errorMessageFactory.showErrorMessage('Tipo de servicio actualizado con éxito',2,'layout.agreementMain.configureAgreement');
                    }
                    if (payload.title.status == 404) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }
                    vm.loading = false;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
    }
})();
/**
 * Created by cl-macmini-51 on 5/18/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('AgreementController', AgreementController);

    /** @ngInject */
    function AgreementController($cookies, $state, $log, $rootScope, $timeout, $stateParams, $mdDialog, $document,
        moment, $scope, RutHelper, getAgreement, filterFilter, getGeofence,adminAccessService , getCorporate, languageBasedErrorFactory, errorMessageFactory, pendingRequests, getFilters) {
        var vm = this;
        vm.getAllAgreements = getAllAgreements;
        vm.loading = false;
        vm.currentPage = 0;
        vm.totalVehicles = 0;
        vm.editAgreementApi = editAgreementApi;
        vm.sp_pagination = false;
        vm.setBooleans = setBooleans;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.filterTextTimeout = '';
        vm.getPagesCount = getPagesCount;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.init = init;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.changeAgreementStatus = changeAgreementStatus;
        vm.deleteAgreement = deleteAgreement;
        vm.exportToCSV = exportToCSV;
        vm.inactivateFlag = inactivateFlag;
        vm.paginationNew = paginationNew;
        vm.refreshData = refreshData;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.predicate = 'index';
        vm.reverse = false;
        vm.filterData = {
            region_id: 'all',
            agreementStatus: '1',
            corporate_id: 'all',
            search_filter: 0,
            search_value: ''
        };
        vm.branchSearch = branchSearch;
        vm.corporateSearch = corporateSearch;
        vm.paginationChangedForBranch = paginationChangedForBranch;
        vm.paginationChangedForCorporation = paginationChangedForCorporation;

        //====================function for dropdown pages and page count===============
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];

        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllAgreements(0, vm.itemsPerPageGot, vm.filterData);
        };

        function paginationNew(page) {
            getAllAgreements((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData);
        }

        vm.corporate = corporate;
        vm.corporateOffset = 0;
        vm.branchOffset = 0;
        vm.globalLimit = 10;
        vm.globalOffset = vm.globalLimit;
        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'vehicle', 'service', 'agreement', 'corporatesList', 'operation_point'];
        vm.branchList = [];
        vm.branchList.push({
            region_name: 'Todos',
            region_id: 'all'
        });

        vm.corporatesList = [];
        vm.corporatesList.push({
            company_name: 'Todos',
            id: 'all'
        });

        // =================== FILTER OBJECT ===================
        vm.filterObject = {
            access_token: $cookies.get('obj'),
            branch_filter: 1,
            vehicle_filter: 0,
            service_filter: 0,
            agreement_filter: 0,
            corporate_filter: 1,
            service_category: 0,
            corporate_status: 2,
            agreement_status: 0,
            vehicle__status: 0,
            operation_point_filter: 0,
            branch_limit: vm.globalLimit,
            branch_offset: vm.branchOffset,
            corporate_limit: vm.globalLimit,
            corporate_offset: vm.corporateOffset,
            branch_search_filter: 0,
            vehicle_search_filter: 0,
            service_search_filter: 0,
            agreement_search_filter: 0,
            corporate_search_filter: 0,
            operation_point_search_filter: 0
        }

        setTimeout(function () {
            document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                // if (vm.branchList && (vm.branchList.length == 0)) {
                vm.searchBranchData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });

            document.getElementsByClassName('ui-select-search')[1].addEventListener('blur', function ($event) {
                // if (vm.corporatesList && (vm.corporatesList.length == 0)) {
                vm.searchCorporateData = '';
                getFilterDataFromBackend(0, 0);
                // }
            });




        })


        function corporate() {
            clearOffset();
            getFilterDataFromBackend();
        }
        // =================== GET FILTER DATA ===================
        function getFilterDataFromBackend(data, type) { //Acc to Index ['branch_search', 'vehicle_search', 'service_search', 'agreement_search', 'corporate_search', 'operation_point_search']
            if (data) {
                vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
            } else {
                vm.filterObject = {
                    access_token: $cookies.get('obj'),
                    branch_filter: 1,
                    vehicle_filter: 0,
                    service_filter: 0,
                    agreement_filter: 0,
                    corporate_filter: 1,
                    service_category: 0,
                    corporate_status: 2,
                    agreement_status: 0,
                    vehicle__status: 0,
                    operation_point_filter: 0,
                    branch_search_filter: 0,
                    vehicle_search_filter: 0,
                    service_search_filter: 0,
                    agreement_search_filter: 0,
                    corporate_search_filter: 0,
                    operation_point_search_filter: 0
                }
            }
            vm.filterObject.branch_limit = vm.globalLimit;
            vm.filterObject.branch_offset = vm.branchOffset;
            vm.filterObject.corporate_limit = vm.globalLimit;
            vm.filterObject.corporate_offset = vm.corporateOffset;

            var promise = getFilters.getAllFilterData(vm.filterObject);
            promise.then(
                function (payload) {

                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return [];
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return [];
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        // ********** BRANCH DATA ********
                        if (payload.title.data.branches) {
                            var index = _.findIndex(vm.branchList, {
                                region_id: 'all'
                            });
                            if (index == -1)
                                vm.branchList.push({
                                    region_name: 'Todos',
                                    region_id: 'all'
                                });
                            angular.forEach(payload.title.data.branches.data, function (column) {
                                // vm.branchList.push(column)
                                var branchIndex = _.findIndex(vm.branchList, {
                                    region_id: column.region_id
                                });
                                if (branchIndex == -1)
                                    vm.branchList.push(column)

                            });
                            vm.branchTotalBackendCount = payload.title.data.branches.totalCount;
                        }

                        // ********** CORPORATE DATA ********
                        if (payload.title.data.corporates) {
                            // angular.forEach(payload.title.data.corporates.data, function (column) {
                            //     vm.corporatesList.push(column)
                            // });
                            // vm.corporateTotalBackendCount = payload.title.data.corporates.totalCount;
                            var index = _.findIndex(vm.corporatesList, {
                                id: 'all'
                            });
                            if (index == -1)
                                vm.corporatesList.push({
                                    company_name: 'Todos',
                                    id: 'all'
                                });
                            angular.forEach(payload.title.data.corporates.data, function (column) {
                                // vm.corporatesList.push(column)
                                var corprateIndex = _.findIndex(vm.corporatesList, {
                                    id: column.id
                                });
                                if (corprateIndex == -1)
                                    vm.corporatesList.push(column)

                            });
                            vm.corporateTotalBackendCount = payload.title.data.corporates.totalCount;
                        }
                    }

                    vm.loading = false;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        }
        getFilterDataFromBackend();

        // ************ PAGINATION ON BRANCH **************
        function paginationChangedForBranch() {
            var index = _.findIndex(vm[vm.searchFilterArray[0]], {
                region_id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.branchTotalBackendCount > (vm.branchList.length - index)) {
                commonFunction(0);
                vm.branchOffset += 10;
                getFilterDataFromBackend(vm.searchBranchData, 0);
            }
        }

        // ************ PAGINATION ON CORPORATE **************
        function paginationChangedForCorporation() {
            var index = _.findIndex(vm[vm.searchFilterArray[5]], {
                id: 'all'
            });
            index = (index == -1 ? 0 : 1);
            if (vm.corporateTotalBackendCount > (vm.corporatesList.length - index)) {
                commonFunction(4);
                vm.corporateOffset += vm.globalOffset;
                getFilterDataFromBackend(vm.searchCorporateData, 4);
            }
        }
        // *********** COMMON FUNCTION FOR FILTER PAGINATION AND SEARCHING ***********
        function commonFunction(type, mode) {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                if (mode == 'search' || i != type) {
                    vm[vm.searchFilterArrayForClearArray[i]] = [];
                    // vm[vm.searchFilterArrayForClearArray[i]].push({
                    //     id: 'all',
                    //     name: 'All'
                    // });
                    vm[vm.searchFilterArray[i] + 'Offset'] = 0;
                    vm['search' + vm.searchFilterArray[i].substring(0, 1).toUpperCase() + vm.searchFilterArray[i].substring(1) + 'Data'] = '';
                }
            }
        }
        // ************ SEARCH VEHICLE ***************
        function branchSearch(data) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchBranchData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(0, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 0);
                }, 2000);
            }
        }

        function clearOffset() {
            for (var i = 0; i < vm.searchFilterArray.length; i++) {
                vm[vm.searchFilterArray[i] + 'Offset'] = 0;
            }

        }
        // ************ SEARCH SERVICE ***************
        function corporateSearch(data, event) {
            if (event.keyCode != 40 && event.keyCode != 38) {
                vm.searchCorporateData = data;
                $timeout.cancel($scope.timeoutSearch);
                commonFunction(4, 'search');
                $scope.timeoutSearch = $timeout(function () {
                    getFilterDataFromBackend(data, 4);
                }, 2000);
            }
        }

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.agreementMain.agreement');
            }
        });

        //==================refreshData=====================
        function refreshData() {
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllAgreements(vm.currentPage * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData);
        }

        //==================get all Vehicles=======================
        function getAllAgreements(skip, limit, filter) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.offset = skip;
            dataSend.limit = limit;
            dataSend.key = Number(filter.agreementStatus);
            if (filter.region_id != 'all') {
                dataSend.region_id = filter.region_id;
            }
            if (filter.corporate_id != 'all') {
                dataSend.corporate_id = filter.corporate_id;
            }
            dataSend.search_filter = filter.search_filter;
            if (filter.search_filter == 1) {
                dataSend.search_value = filter.search_value;
            }
            vm.loading = true;
            var promise = getAgreement.allAgreements(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;

                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return [];
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return [];
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.totalAgreement = payload.title.data.totalCount;
                        vm.dataLength = payload.title.data.totalCount;
                        vm.agreement = [];
                        vm.branchList = [];
                        vm.vehicle = [];
                        vm.service = [];
                        clearOffset();
                        getFilterDataFromBackend();
                        if (payload.title.data.totalCount == 0) {
                            vm.sp_pagination = false;
                            vm.tBodyFlag = false;
                            vm.tFootFlag = true;
                            vm.filterOn = true;
                            vm.skipValueFilter = 0;
                        } else {
                            vm.sp_pagination = true;
                            vm.tBodyFlag = true;
                            vm.tFootFlag = false;
                            vm.filterOn = false;
                            vm.skipValueFilter = 0;

                            var dataArray = [];

                            var agreementList = payload.title.data.result;
                            agreementList.forEach(function (column) {
                                var d = {};
                                d.id = column.id;
                                d.commercial_classification = column.commercial_classification;
                                d.companyRUT = RutHelper.format(column.corporate_id.RUT);
                                d.companyName = column.corporate_id.company_name;
                                d.corporateid = column.corporate_id.id;
                                d.name = column.name;
                                d.status = column.status;
                                d.agreement_type = column.agreement_type;
                                d.branch = column.branch;
                                d.statusNew = column.status.toString();
                                d.paymentMethod = column.payment;
                                d.uploadFlag = column.employee_upload_flag;
                                if (column.type_of_service && column.type_of_service.length) {
                                    d.typeOfService = column.type_of_service;
                                } else {
                                    d.typeOfService = '';
                                }
                                d.created_on = column.created_on;
                                d.created_by = column.created_by;
                                d.updated_on = column.updated_on;
                                d.updated_by = column.updated_by;
                                d.rt_discount = column.rt_discount;
                                d.web_discount = column.web_discount;
                                d.fixedListUpdate = column.fixedListUpdate;
                                d.variableListUpdate = column.variableListUpdate;
                                d.allow_change_fare_POS = column.allow_change_fare_POS;
                                d.allow_change_fare_panel = column.allow_change_fare_panel;
                                dataArray.push(d);
                            });
                            vm.agreementList = dataArray;
                            for (var i = 0; i < vm.agreementList.length; i++) {
                                vm.agreementList[i].index = (skip + i);
                            }
                            if (vm.dataLength <= vm.itemsPerPageGot) {
                                vm.sp_pagination = false;
                            } else {
                                vm.sp_pagination = true;
                                //vm.pageCount(payload.title.data.totalCount);
                            }
                            vm.skipValue = vm.agreementList[0].index;
                            vm.limitValue = vm.agreementList[vm.agreementList.length - 1].index;

                            // USERTYPE VALUE
                            // 0 - Transvip user
                            // 1 - PET user
                            vm.userType = payload.title.data.user_type || 0;

                            //$scope.$watch('vm.search', function(newVal, oldVal) {
                            //    vm.filtered = filterFilter(vm.agreementList, newVal);
                            //    vm.totalItems = vm.filtered.length;
                            //    if (vm.filtered.length == 0) {
                            //        vm.watchPagination = false;
                            //    } else {
                            //        vm.watchPagination = true;
                            //    }
                            //    if (vm.filterOn == true) {
                            //        vm.skipValueFilter = vm.filtered.length;
                            //        vm.sp_pagination = false;
                            //    }
                            //}, true);

                            //range();
                        }
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    } else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        vm.getAllAgreements((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        vm.currentPage++;
        //        vm.getAllAgreements((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    vm.getAllAgreements((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //};

        function init() {
            vm.getAllAgreements(0, vm.searchModel.limit, vm.filterData);
        };
        init();

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function setBooleans(id , value , panelType , buttonName , index){
            console.log(id , value , panelType , buttonName , index);
            
            switch (panelType) {
                case 'Allow_Change_Fare_Create_Booking':
                    if (value == true) {
                        vm.agreementList[index].allow_change_fare_panel = false;
                        apiEdit(id , vm.agreementList[index].allow_change_fare_panel , panelType , buttonName , index);
                    } else {
                        vm.agreementList[index].allow_change_fare_panel = true;
                        apiEdit(id , vm.agreementList[index].allow_change_fare_panel , panelType , buttonName , index);
                        
                    }
                    break;
                case 'Allow_Change_Fare_POS':
                    if (value == true) {
                        vm.agreementList[index].allow_change_fare_POS = false;
                        apiEdit(id , vm.agreementList[index].allow_change_fare_POS , panelType , buttonName , index);
                    } else {
                        vm.agreementList[index].allow_change_fare_POS = true;
                        apiEdit(id , vm.agreementList[index].allow_change_fare_POS , panelType , buttonName , index);
                    }
                    break;
            }
        }

        function editAgreementApi(id , value , panelType , buttonName , index){
            console.log(id , value , panelType , buttonName , index);
            
            vm.loading = true;
            var promise = adminAccessService.checkStateValid(buttonName); //$stateParams.id
            return promise.then(
                function (payload) {
                    vm.loading = false;
                    console.log(payload);
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (!payload.title.data.granted) {
                            // languageBasedErrorFactory.getProperErrorMessage('optionNotAvail', 0, 0);
                            errorMessageFactory.showErrorMessage(' No está autorizado para usar esta opción',0);
                            return false;
                        } else {
                            vm.loading = false;
                            setBooleans(id , value , panelType , buttonName , index);
                            // $timeout(function (){
                                
                            // },500)
                       
                            // setFlagInJob(id, type)
                            // return true;
                        }
                    }
                },
                function (errorPayload) {
                    console.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        //=======================add agreement api=============================
        function apiEdit(id , value , panelType , buttonName , index) {
            console.log(id , value , panelType , buttonName , index,'id , value , panelType , buttonName , index');
            
            vm.finalDataSend = {};
            // KEYS TO ALLOW MODIFY AMOUNT
            vm.finalDataSend.contract_id = id;
            if(panelType == 'Allow_Change_Fare_POS')
            vm.finalDataSend.allow_change_fare_POS = value  ? 1 : 0;
            if(panelType == 'Allow_Change_Fare_Create_Booking' )
            vm.finalDataSend.allow_change_fare_panel = value ? 1 : 0;
            $log.log(vm.finalDataSend);
            vm.loading = true;
            var promise = getAgreement.editAgreement(vm.finalDataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    // var dataForSysLogs = {
                    //     access_token: $cookies.get('obj'),
                    //     id: vm.dataToFill.id,
                    //     identity: 7,
                    //     message: 'Agreement updated.'
                    // };
                    // $rootScope.systemLogsAdmin(dataForSysLogs);
                    // languageBasedErrorFactory.getProperErrorMessage('editAgreementSucc', 0, 2, 'layout.agreementMain.agreement');
                    //errorMessageFactory.showErrorMessage('Agreement details updated successfully.',2,'layout.agreementMain.agreement');

                    //$timeout(function(){
                    //    $mdDialog.hide();
                    //    $state.reload();
                    //},2000);
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        function getFilter() {
            //vm.filterOn = true;
            vm.currentPage = 0;
            vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
            vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
            pendingRequests.cancelAll();
            if (vm.search.length == 0) {
                vm.filterData.search_filter = 0;
                vm.filterData.search_value = '';
                vm.getAllAgreements(0, vm.searchModel.limit, vm.filterData);
                //vm.filterOn = false;
                //vm.watchPagination = true;
                //vm.sp_pagination = true;

            } else {
                vm.filterData.search_filter = 1;
                vm.filterData.search_value = vm.search;
                //if (vm.filterTextTimeout) $timeout.cancel(vm.filterTextTimeout);
                //vm.filterTextTimeout = $timeout(function(){
                vm.getAllAgreements(0, vm.searchModel.limit, vm.filterData);
                //},500);
            }
        };
        //===========================change agreement status=========================
        function changeAgreementStatus(data, $event) {
            $log.log(data);

            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('statusPop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed', data);
                var msgSys = '';
                var dataSend = {};
                dataSend.contract_id = data.id;
                if (data.status == 1) {
                    dataSend.status = 0;
                    msgSys = 'Agreement blocked.'
                } else if (data.status == 0 || data.status == 2) {
                    dataSend.status = 1;
                    msgSys = 'Agreement unblocked.'
                }
                dataSend.access_token = $cookies.get('obj');
                vm.loading = true;
                var promise = getAgreement.editAgreementStatus(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;

                        if (payload.title.status == 400) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            return [];
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                            return [];
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            var dataForSysLogs = {
                                access_token: $cookies.get('obj'),
                                id: data.id,
                                identity: 7,
                                message: msgSys
                            };
                            $rootScope.systemLogsAdmin(dataForSysLogs);
                            languageBasedErrorFactory.getProperErrorMessage('agreementStatusSucc', 0, 1, 'layout.agreementMain.agreement');
                            //errorMessageFactory.showErrorMessage('Agreement status updated successfully.',1);

                            //$timeout(function(){
                            //    $mdDialog.hide();
                            //    $state.reload();
                            //},2000);
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );

            }, function () {
                $log.log('not confirmed');
            });
        };
        //=====================to delete agreement====================
        function deleteAgreement(data, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('agreementDelPop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.contract_id = data.id;
                //errorMessageFactory.showErrorMessage('Functionality is pending',0);
                vm.loading = true;
                var promise = getAgreement.deleteContract(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;

                        if (payload.title.status == 400) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                            return [];
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                            return [];
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            var dataForSysLogs = {
                                access_token: $cookies.get('obj'),
                                id: data.id,
                                identity: 7,
                                message: 'Agreement deleted'
                            };
                            $rootScope.systemLogsAdmin(dataForSysLogs);
                            languageBasedErrorFactory.getProperErrorMessage('agreementDelSucc', 0, 1, 'layout.agreementMain.agreement');
                            //errorMessageFactory.showErrorMessage('Agreement deleted successfully.',1);
                            //$state.reload();
                        }
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        };
        //===============export to csv==================
        function exportToCSV(filter, skip, limit) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.offset = skip;
            dataSend.limit = limit;
            dataSend.key = 3;
            //if(filter.region_id != 'all'){
            //    dataSend.region_id = filter.region_id;
            //}
            //if(filter.corporate_id != 'all'){
            //    dataSend.corporate_id = filter.corporate_id;
            //}
            vm.loading = true;
            var promise = getAgreement.allAgreements(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    var dataArrayExport = [];
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return [];
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return [];
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        var agreementListExport = payload.title.data.result;
                        agreementListExport.forEach(function (column) {
                            var d = {};
                            d['ID'] = column.id;
                            d['Name'] = column.name;
                            d['Agreement Type'] = column.agreement_type;
                            d['Start Date Validity'] = moment(column.start_date_validity).format('lll');
                            d['End Date Validity'] = moment(column.end_date_validity).format('lll');
                            d['Commercial Classification'] = column.commercial_classification;
                            d['Corporate Name'] = column.corporate_id.company_name;
                            d['Corporate RUT'] = RutHelper.format(column.corporate_id.RUT);
                            d['Corporate ID'] = column.corporate_id.id;
                            d['Branch'] = [];
                            d['Payment Methods'] = [];
                            d['Type of Service'] = [];
                            if (column.branch && column.branch.length) {
                                column.branch.forEach(function (data) {
                                    d['Branch'].push(data.region_name);
                                });
                            }
                            if (column.payment && column.payment.length) {
                                column.payment.forEach(function (data) {
                                    d['Payment Methods'].push(data[0].type);
                                });
                            }
                            if (column.type_of_service && column.type_of_service.length) {
                                column.type_of_service.forEach(function (data) {
                                    if (data.type_of_service_id) {
                                        d['Type of Service'].push(data.type_of_service_id.service_name);
                                    }
                                });
                            }
                            d['Charges For No Show'] = column.charges_for_no_show;
                            d['Max Wait Time In Route (in mins)'] = column.max_wait_time_en_route;
                            d['Max Wait Time Free (in mins)'] = column.max_wait_time_free;
                            d['Max Wait Time Tolerance (in mins)'] = column.max_wait_time_tolerance;
                            //d['Base Fare Discount (in %)'] = column.discount_based_fare;
                            d['PEP Mandatory'] = column.PEP_mandatory == 1 ? 'YES' : 'NO';
                            d['ROL Mandatory'] = column.ROL_mandatory == 1 ? 'YES' : 'NO';
                            d['RUT Mandatory'] = column.RUT_mendatory == 1 ? 'YES' : 'NO';
                            d['Applicant RUT Mandatory'] = column.applicant_RUT_mendatory == 1 ? 'YES' : 'NO';
                            d['Authorizer RUT Mandatory'] = column.auth_RUT_mendatory == 1 ? 'YES' : 'NO';
                            d['Cost Center Mandatory'] = column.cost_center_mandatory == 1 ? 'YES' : 'NO';
                            d['Cost Sub Center Mandatory'] = column.cost_sub_center_mandatory == 1 ? 'YES' : 'NO';
                            d['Fare To Customer'] = column.fare_to_customer == 1 ? 'YES' : 'NO';
                            d['Fare To Driver'] = column.fare_to_driver == 1 ? 'YES' : 'NO';
                            d['Graph Mandatory'] = column.graph_mandatory == 1 ? 'YES' : 'NO';
                            d['Invoice to Applicant'] = column.invoice_to_applicant == 1 ? 'YES' : 'NO';
                            d['Invoice to Contact Person'] = column.invoice_to_contact_person == 1 ? 'YES' : 'NO';
                            d['Invoice to Customer'] = column.invoice_to_customer == 1 ? 'YES' : 'NO';
                            d['Invoice to Employee'] = column.invoice_to_employee == 1 ? 'YES' : 'NO';
                            d['Number Of Voucher Mandatory'] = column.number_of_voucher_mandatory == 1 ? 'YES' : 'NO';
                            d['Purpose of Trip Mandatory'] = column.purpose_of_trip_mandatory == 1 ? 'YES' : 'NO';
                            d['Required Auth Load Profile'] = column.require_auth_load_profile == 1 ? 'YES' : 'NO';
                            d['Round Trip Wait Time'] = column.round_trip_wait_time == 1 ? 'YES' : 'NO';
                            d['Virtual Fleet'] = column.virtual_fleet;
                            d['Work Order Mandatory'] = column.work_order_mandatory == 1 ? 'YES' : 'NO';
                            d['Status'] = column.status == 0 ? 'Inactive' : 'Active';
                            d['Deleted'] = column.is_deleted == 0 ? 'No' : 'Yes';
                            d['Comments'] = column.comments;

                            dataArrayExport.push(d);
                        });
                        vm.agreementListExport = dataArrayExport;
                        alasql('SELECT * INTO CSV("agreementList.csv",{headers:true}) FROM ?', [vm.agreementListExport]);

                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };
        //====================get branch list====================
        // function getBranch() {

        // vm.branchList = [];
        // vm.branchList = JSON.parse(JSON.stringify(getFilters.branchesFiltersData.data));
        // vm.branchList.push({
        //     region_name: 'All',
        //     region_id: 'all'
        // });
        // $scope.$apply();


        // vm.loading = true;
        // var promise = getGeofence.branch();
        // promise.then(
        //     function (payload) {
        //         $log.log(payload);
        //         //vm.loading = false;
        //         if (payload.title.status == 400) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 0);
        //         } else if (payload.title.status == 401) {
        //             errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
        //         } else if (payload.title.status == 201 || payload.title.status == 200) {
        //             var where = _.where(payload.title.data, {
        //                 parent_id: 0
        //             });
        //             //vm.branchList = _.where(where, { is_active: 1 });
        //             vm.branchList = where;

        //             vm.branchList.push({
        //                 region_name: 'All',
        //                 region_id: 'all'
        //             });
        //         }
        //     },
        //     function (errorPayload) {
        //         $log.log(errorPayload);
        // vm.loading = false;
        //         if (errorPayload.data.status == 401) {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //         } else {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //         }
        //     }
        // );
        // }
        // WHen Page refresh service take time to get data from backend
        // setTimeout(function () {
        //     getBranch();
        // }, 1000);
        //==============get all corporate=================
        // function getAllCorporate() {
        // vm.corporatesList = [];
        // vm.corporatesList = JSON.parse(JSON.stringify(getFilters.corporateFiltersData.data));
        // vm.corporatesList.push({
        //     company_name: 'All',
        //     id: 'all'
        // });

        // vm.loading = true;
        // var dataSend = {};
        // dataSend.access_token = $cookies.get('obj');
        // dataSend.limit = 0;
        // dataSend.offset = 0;
        // dataSend.key = 2;
        // dataSend.search_filter = 0;
        // var promise = getCorporate.allCorporates(dataSend);
        // promise.then(
        //     function (payload) {
        //         $log.log('sxdsads', payload);
        //         //vm.loading = false;
        //         //vm.corporatesList = _.where(payload.title.data.result,{status:1});
        //         vm.corporatesList = payload.title.data.result;
        //         vm.corporatesList.push({
        //             company_name: 'All',
        //             id: 'all'
        //         });
        //     },
        //     function (errorPayload) {
        //         //vm.loading = false;
        //         if (errorPayload.data.status == 401) {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
        //         } else {
        //             errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
        //         }
        //     }
        // );
        // };
        // WHen Page refresh service take time to get data from backend
        // setTimeout(function () {
        //     getAllCorporate();
        // }, 1000);
        //======================inactive bulk flag==========================
        function inactivateFlag(data, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('inactiveMessage', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.contract_id = data.id;
                dataSend.status_value = data.uploadFlag == 1 ? 0 : 1;
                vm.loading = true;
                var promise = getAgreement.activeInactiveBulkFlag(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        languageBasedErrorFactory.getProperErrorMessage('inactiveMessageSucc', 0, 1, 'layout.agreementMain.agreement');
                        //errorMessageFactory.showErrorMessage('Agreement deleted successfully.',1);
                        //$state.reload();
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        }

    }
})();
/**
 * Created by cl-macmini-51 on 10/3/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('ViewRolesController', ViewRolesController);

    /** @ngInject */
    function ViewRolesController($cookies, $state, $log, $rootScope, $timeout, $scope, filterFilter, $mdDialog, $document, getAdminRoles,
                                 $stateParams, languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.selectAll = false;
        vm.goBack = goBack;
        vm.updateRole = updateRole;
        vm.selectAllRoles = selectAllRoles;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.dataToFill = {
            permissionName: '',
            permissionId: '',
            roleName: '',
            description: '',
            roleNameGiven: '',
            allStates: [],
            finalArrayStates: []
        };

        //===============handle states===================
        vm.dataToFill.allStates = $state.get();
        vm.dataToFill.finalArrayStates = [];
        for(var i=5;i<vm.dataToFill.allStates.length;i++){
            if(vm.dataToFill.allStates[i].name == 'layout.applicantsMain' ||
            vm.dataToFill.allStates[i].name == 'layout.approvedDriverMain' ||
            vm.dataToFill.allStates[i].name == 'layout.approvedInvestorsMain' ||
            vm.dataToFill.allStates[i].name == 'layout.customersMain' ||
            vm.dataToFill.allStates[i].name == 'layout.illuminatedZoneServicesMain' ||
            vm.dataToFill.allStates[i].name == 'layout.corporateMain' ||
            vm.dataToFill.allStates[i].name == 'layout.upcomingBookingsMain' ||
            vm.dataToFill.allStates[i].name == 'layout.ongoingBookingsMain' ||
            vm.dataToFill.allStates[i].name == 'layout.completedBookingsMain' ||
            vm.dataToFill.allStates[i].name == 'layout.carMain' ||
            vm.dataToFill.allStates[i].name == 'layout.assignedCarsMain' ||
            vm.dataToFill.allStates[i].name == 'layout.paymentTypeMain' ||
            vm.dataToFill.allStates[i].name == 'layout.typeOfServiceMain' ||
            vm.dataToFill.allStates[i].name == 'layout.vehicleTypeMain' ||
            vm.dataToFill.allStates[i].name == 'layout.agreementMain' ||
            vm.dataToFill.allStates[i].name == 'layout.branchMain' ||
            vm.dataToFill.allStates[i].name == 'layout.fixedRouteGeofenceMain' ||
            vm.dataToFill.allStates[i].name == 'layout.fixedRouteMain' ||
            vm.dataToFill.allStates[i].name == 'layout.illuminatedZoneMain' ||
            vm.dataToFill.allStates[i].name == 'layout.couponMain' ||
            vm.dataToFill.allStates[i].name == 'layout.binMain' ||
            vm.dataToFill.allStates[i].name == 'layout.createBookingMain' ||
            vm.dataToFill.allStates[i].name == 'layout.itemOfChargeMain' ||
            vm.dataToFill.allStates[i].name == 'layout.cancelReasonMain' ||
            vm.dataToFill.allStates[i].name == 'layout.driverEarningMain' ||
            vm.dataToFill.allStates[i].name == 'layout.communaMain' ||
            vm.dataToFill.allStates[i].name == 'layout.promoCodeMain' ||
            vm.dataToFill.allStates[i].name == 'layout.adminRolesMain' ||
            vm.dataToFill.allStates[i].name == 'layout.dashboardMain' ||
            vm.dataToFill.allStates[i].name == 'layout.globalParametersMain' ||
            vm.dataToFill.allStates[i].name == 'layout.summaryProductionMain' ||
            vm.dataToFill.allStates[i].name == 'layout.detailedProductionMain' ||
            vm.dataToFill.allStates[i].name == 'layout.itemOfChargeCsvMain' || 
            vm.dataToFill.allStates[i].name == 'layout.onOffDutyMain' ||
            vm.dataToFill.allStates[i].name == 'layout.correctFareReasonMain' ||
            vm.dataToFill.allStates[i].name == 'layout.helpDocMain' ||
            vm.dataToFill.allStates[i].name == 'layout.searchBookingMain' ||
            vm.dataToFill.allStates[i].name == 'layout.generatePaymentStatusMain' ||
            vm.dataToFill.allStates[i].name == 'layout.cierroPeriodeMain' ||
            vm.dataToFill.allStates[i].name == 'layout.abrirPeriodoMain' ||
            vm.dataToFill.allStates[i].name == 'layout.rejectedBookingMain' ||
            vm.dataToFill.allStates[i].name == 'layout.operationalReportMain' ||
            vm.dataToFill.allStates[i].name == 'layout.operationPointUserMain' ||
            vm.dataToFill.allStates[i].name == 'layout.operationPointMain' ||
            vm.dataToFill.allStates[i].name == 'layout.quickSaleMain' ||
            vm.dataToFill.allStates[i].name == 'layout.sharedRouteAssignmentMain' ||
            vm.dataToFill.allStates[i].name == 'layout.groupedRouteAssignmentMain' ||
            vm.dataToFill.allStates[i].name == 'layout.sharedGroupMain' ||
            vm.dataToFill.allStates[i].name == 'layout.adminUsersMain'
            ){

            }
            else{
                vm.dataToFill.finalArrayStates.push(vm.dataToFill.allStates[i]);
            }
        }
        for(var i=0;i<vm.dataToFill.finalArrayStates.length;i++){
            vm.dataToFill.finalArrayStates[i].checked = false;
        }

        //==========================select all roles===========================
        function selectAllRoles(data){
            if(data){
                for(var i=0;i<vm.dataToFill.finalArrayStates.length;i++){
                    vm.dataToFill.finalArrayStates[i].checked = true;
                }
            }
            else{
                for(var i=0;i<vm.dataToFill.finalArrayStates.length;i++){
                    vm.dataToFill.finalArrayStates[i].checked = false;
                }
            }
        };


        //===========================get admin permissions=============================
        function getAdminRoleSingle(){

            var dataSend = {};

            var promise = getAdminRoles.getAllRolesApi(dataSend);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    var where = _.where(payload.title.data,{_id:$stateParams.id})[0];
                    vm.dataToFill.permissionName = where.permissionName;
                    vm.dataToFill.permissionId = where.permissionsId;
                    vm.dataToFill.roleName = where.roleName;
                    vm.dataToFill.roleNameGiven = where.roleName;
                    vm.dataToFill.description = where.description;
                    vm.dataToFill.roleType = where.roleType;
                    if(where.access && where.access.length){
                        for(var i=0;i<where.access.length;i++){
                            for(var j=0;j<vm.dataToFill.finalArrayStates.length;j++){
                                if(where.access[i] == vm.dataToFill.finalArrayStates[j].title){
                                    vm.dataToFill.finalArrayStates[j].checked = true;
                                }
                            }
                        }
                        for(var i=0;i<vm.dataToFill.finalArrayStates.length;i++){
                            if(!vm.dataToFill.finalArrayStates[i].checked){
                                vm.selectAll = false;
                                break;
                            }
                            else{
                                vm.selectAll = true;
                            }
                        }
                    }
                    else{
                        vm.dataToFill.finalArrayStates = [];
                    }
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                });
        };
        getAdminRoleSingle();
        ////======================update admin with this role=======================
        //function updateAdminWithThisRole(data){
        //    var dataSend = {};
        //    dataSend.access_token = $cookies.get('obj');
        //    dataSend.role = data.data.data.ops[0]._id;
        //    dataSend.user_id = Number($stateParams.id);
        //
        //    var promise = getAdminRoles.updateAdminWithRole(dataSend);
        //    promise.then(
        //        function(payload) {
        //            $log.log('sxdsads', payload);
        //            vm.loading = false;
        //            errorMessageFactory.showErrorMessage('Permission given successfully',2,'layout.adminRolesMain.adminRolesList');
        //        },
        //        function(errorPayload) {
        //            vm.loading = false;
        //            if (errorPayload.data.status == 401) {
        //                errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
        //            } else {
        //                errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
        //            }
        //        });
        //};
        //
        ////===============================add role hit============================
        //function addRoleApiHit(data){
        //    var dataSend = {};
        //    dataSend.permissionId = data.data.data.ops[0]._id;
        //    dataSend.roleName = vm.dataToFill.roleName;
        //
        //    var promise = getAdminRoles.addRole(dataSend);
        //    promise.then(
        //        function(payload) {
        //            $log.log('sxdsads', payload);
        //            //vm.loading = false;
        //            updateAdminWithThisRole(payload);
        //            //errorMessageFactory.showErrorMessage('Permission given successfully',1);
        //        },
        //        function(errorPayload) {
        //            vm.loading = false;
        //            if (errorPayload.data.status == 401) {
        //                errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
        //            } else {
        //                errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
        //            }
        //        });
        //}


        //==================================add permission api==========================
        function updateRole(){
            //errorMessageFactory.showErrorMessage('Functionality is pending.');
            var dataSend = {};
            dataSend.access = [];
            if(vm.dataToFill.roleNameGiven != vm.dataToFill.roleName)
                dataSend.roleName = vm.dataToFill.roleNameGiven;
            dataSend.roleId = $stateParams.id;
            for(var i=0;i<vm.dataToFill.finalArrayStates.length;i++){
                if(vm.dataToFill.finalArrayStates[i].checked)
                    dataSend.access.push(vm.dataToFill.finalArrayStates[i].title);
            }
            vm.loading = true;
            var promise = getAdminRoles.updateRoleApi(dataSend);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    //addRoleApiHit(payload);
                    languageBasedErrorFactory.getProperErrorMessage('roleUpdateSuces',0,2,'layout.adminRolesMain.adminRolesList')
                    //errorMessageFactory.showErrorMessage('Role updated successfully',2,'layout.adminRolesMain.adminRolesList');
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                });

        };

        //=========================go back=============================
        function goBack(){
            $state.go('layout.adminRolesMain.adminRolesList');
        };
    }
})();

/**
 * Created by cl-macmini-51 on 9/7/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('UpdateRoleToAdminUserController', UpdateRoleToAdminUserController);

    /** @ngInject */
    function UpdateRoleToAdminUserController($cookies, $state, $log, $rootScope, $timeout, $scope, filterFilter, $mdDialog, $document, getAdminRoles, $stateParams,updateAccessForLoggedInUser,languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.goBack = goBack;
        vm.updateRoleToUserApiHit = updateRoleToUserApiHit;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.dataToFill = {};


        //==========================get all admin roles list=======================
        function getAllAdminRolesHit() {
            var dataSend = {};
            dataSend.user_type = Number($stateParams.userType);
            console.log($stateParams.userType,'$stateParams.userType');
            
            vm.loading = true;
            var promise = getAdminRoles.getAllRolesApi(dataSend);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);

                    vm.loading = false;
                    var dataArray = [];
                    var adminRoleList = payload.title.data;
                    adminRoleList.forEach(function(column) {
                        var d = {};
                        d.is_active = column.is_active;
                        d.is_deleted = column.is_deleted;
                        d.permissionsId = column.permissionsId;
                        d.roleName = column.roleName;
                        d.access = column.access;
                        d.id = column._id;
                        d.checked = false;
                        dataArray.push(d);
                    });
                    var where = _.where(dataArray,{is_active:true});

                    vm.adminRoleList = where;

                    getAdminAccessList();
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                });
        };
        getAllAdminRolesHit();

        //======================get admin access list===================
        function getAdminAccessList(){
            var dataSend = {};
            dataSend.limit = 0;
            dataSend.offset = 0;
            dataSend.admin_id = $stateParams.id;
            var promise = getAdminRoles.getAdminUserList(dataSend);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if(payload.title.data.result[0].role && payload.title.data.result[0].role.length){
                        for(var i=0;i<payload.title.data.result[0].role.length;i++){
                            for(var j=0;j<vm.adminRoleList.length;j++){
                                if(payload.title.data.result[0].role[i]._id == vm.adminRoleList[j].id){
                                    vm.adminRoleList[j].checked = true;
                                }
                            }
                        }
                    }
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                });
        }


        //============================add role to admin user hit==========================
        function updateRoleToUserApiHit(){
            var dataSend = {};
            dataSend.role = [];
            dataSend.access_token = $cookies.get('obj');
            dataSend.user_id = $stateParams.id;
            for(var i=0;i<vm.adminRoleList.length;i++){
                if(vm.adminRoleList[i].checked)
                    dataSend.role.push(vm.adminRoleList[i].id);
            }
            vm.loading = true;
            var promise = getAdminRoles.addRoleToUser(dataSend);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    languageBasedErrorFactory.getProperErrorMessage('roleUserSucc',0,2,'layout.adminUsersMain.adminUsersList')
                    //errorMessageFactory.showErrorMessage('Role updated to user successfully',2,'layout.adminUsersMain.adminUsersList');
                    updateAccessForLoggedInUser.updateTheAccessListForLoginAdmin();
                    //errorMessageFactory.showErrorMessage('Permission given successfully',1);
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                });
        }
        //=========================go back=============================
        function goBack(){
            $state.go('layout.adminUsersMain.adminUsersList');
        };
    }
})();

/**
 * Created by cl-macmini-51 on 6/27/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('UpdateRolesController', UpdateRolesController);

    /** @ngInject */
    function UpdateRolesController($cookies, $state, $log, $rootScope, $timeout, $scope, filterFilter, $mdDialog, $document, getAdminRoles, $stateParams, updateAccessForLoggedInUser, languageBasedErrorFactory, errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.selectAll = false;
        vm.FlagApi = false;
        vm.goBack = goBack;
        vm.updateRole = updateRole;
        vm.selectAllRoles = selectAllRoles;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.dataToFill = {
            permissionName: '',
            permissionId: '',
            roleName: '',
            description: '',
            roleNameGiven: '',
            allStates: [],
            finalArrayStates: [],
            roles_pet: 'roles_encale',
        };
        vm.RoleNormal = RoleNormal;
        vm.RolePet = RolePet;
        vm.selected = true;
        vm.dataToFill.allStates = $state.get();

        function RolePet() {
            vm.rolePet = [];
            vm.count = 1;
            if (vm.dataToFill.roles_pet == 'roles_pet') {
                vm.dataToFill.finalArrayStates = [];
                for (var i = 5; i < vm.dataToFill.allStates.length; i++) {
                    if (vm.dataToFill.allStates[i].name == 'layout.applicantsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.approvedDriverMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.approvedInvestorsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.customersMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.illuminatedZoneServicesMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.corporateMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.upcomingBookingsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.ongoingBookingsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.completedBookingsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.carMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.assignedCarsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.paymentTypeMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.typeOfServiceMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.vehicleTypeMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.agreementMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.branchMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.fixedRouteGeofenceMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.fixedRouteMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.illuminatedZoneMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.couponMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.binMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.createBookingMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.createBookingHereMapsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.itemOfChargeMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.cancelReasonMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.driverEarningMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.communaMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.promoCodeMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.adminRolesMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.dashboardMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.globalParametersMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.summaryProductionMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.vehicleBalanceReportMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.detailedProductionMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.itemOfChargeCsvMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.onOffDutyMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.correctFareReasonMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.generatePaymentStatusMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.cierroPeriodeMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.abrirPeriodoMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.rejectedBookingMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.operationalReportMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.helpDocMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.searchBookingMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.operationPointMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.operationPointUserMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.quickSaleMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.sharedRouteAssignmentMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.groupedRouteAssignmentMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.sharedGroupMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.adminUsersMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.newMessageMain' ||
                        // vm.dataToFill.allStates[i].name == 'layout.groupDriversMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.historyMessageMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.heatMapMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.vechicleBalanceMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.controlledWayMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.controlledWayMain.editControlledWay' ||
                        vm.dataToFill.allStates[i].name == 'layout.gaussControlMain'
                        // vm.dataToFill.allStates[i].name == 'layout.mailDriverMain'
                    ) {

                    } else {
                        if (vm.dataToFill.allStates[i].title == 'Create Booking') {
                            vm.rolePet.push('Create Booking');
                        } else if (vm.dataToFill.allStates[i].title == 'Create Booking Here Maps') {
                            vm.rolePet.push('Create Booking Here Maps');
                        } else if (vm.dataToFill.allStates[i].title == 'Agreement') {
                            vm.rolePet.push('Agreement');
                            vm.rolePet.push('Manage Employee');
                            vm.rolePet.push('Fixed Price List');
                            vm.rolePet.push('Variable Price List');
                            vm.rolePet.push('Cambiar Contraseña Empleado Dotación');
                            vm.rolePet.push('Fixed Price List Route Details');
                            vm.rolePet.push('Variable Price List Route Details');
                        } else if (vm.dataToFill.allStates[i].title == 'Upcoming Bookings') {
                            vm.rolePet.push('Upcoming Bookings');
                            vm.rolePet.push('Upcoming Bookings Details');
                            vm.rolePet.push('Modify Booking');
                            vm.rolePet.push('Ongoing Bookings');
                            vm.rolePet.push('Ongoing Bookings Details');
                            vm.rolePet.push('Completed Bookings');
                            vm.rolePet.push('Completed Bookings Details');
                            vm.rolePet.push('Search Booking');
                            vm.rolePet.push('Search Bookings Details');
                            vm.rolePet.push('Search Modify Booking');
                            // vm.rolePet.push('Asignar Manualmente');
                            vm.rolePet.push('Ver voucher');
                            // vm.rolePet.push('Unassign');
                            vm.rolePet.push('Message To Client');
                            vm.rolePet.push('No Show');
                            vm.rolePet.push('Enviar voucher');
                            vm.rolePet.push('Descargar Voucher');
                            vm.rolePet.push('BWR');
                            vm.rolePet.push('Print Receipt');
                        } else if (vm.dataToFill.allStates[i].title == 'Generate Payment Status') {
                            vm.rolePet.push('Adminstración');
                            vm.rolePet.push('Generate Payment Status');
                        } else if (vm.dataToFill.allStates[i].title == 'Corporate') {
                            vm.rolePet.push('Corporate');
                        } else {
                            if (vm.count == 1) {
                                vm.rolePet.push('Control de Gastos');
                                vm.count++;
                            }
                        }

                    }
                }

            }
            for (var i = 0; i < vm.rolePet.length; i++) {
                vm.dataToFill.finalArrayStates.push({
                    title: vm.rolePet[i],
                    checked: false
                });
            }
        }

        function RoleNormal() {
            if (vm.dataToFill.roles_pet == 'roles_encale') {
                vm.dataToFill.finalArrayStates = [];
                for (var i = 5; i < vm.dataToFill.allStates.length; i++) {
                    if (vm.dataToFill.allStates[i].name == 'layout.applicantsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.approvedDriverMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.approvedInvestorsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.customersMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.illuminatedZoneServicesMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.corporateMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.upcomingBookingsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.ongoingBookingsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.completedBookingsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.carMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.assignedCarsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.paymentTypeMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.typeOfServiceMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.vehicleTypeMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.agreementMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.branchMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.fixedRouteGeofenceMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.fixedRouteMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.illuminatedZoneMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.couponMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.binMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.createBookingMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.createBookingHereMapsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.itemOfChargeMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.cancelReasonMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.driverEarningMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.communaMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.promoCodeMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.adminRolesMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.dashboardMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.globalParametersMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.summaryProductionMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.vehicleBalanceReportMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.detailedProductionMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.itemOfChargeCsvMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.onOffDutyMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.correctFareReasonMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.generatePaymentStatusMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.cierroPeriodeMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.abrirPeriodoMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.rejectedBookingMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.operationalReportMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.helpDocMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.searchBookingMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.operationPointMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.operationPointUserMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.quickSaleMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.sharedRouteAssignmentMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.groupedRouteAssignmentMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.sharedGroupMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.adminUsersMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.newMessageMain' ||
                        // vm.dataToFill.allStates[i].name == 'layout.groupDriversMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.historyMessageMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.heatMapMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.vechicleBalanceMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.controlledWayMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.controlledWayMain.editControlledWay' ||
                        vm.dataToFill.allStates[i].name == 'layout.gaussControlMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.fleetCapacityMatrixMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.fleetCapacityMatrixMain.fleetCapacityMatrixDetail' ||
                        vm.dataToFill.allStates[i].name == 'layout.fleetCapacityMatrixMain.fleetCapacityMatrixCreate' ||
                        vm.dataToFill.allStates[i].name == 'layout.fleetCapacityMatrixMain.fleetCapacityMatrixEdit' ||
                        vm.dataToFill.allStates[i].name == 'layout.fleetCapacityMatrixMain.fleetCapacityMatrixExceptions' ||
                        vm.dataToFill.allStates[i].name == 'layout.fleetCapacityMatrixMain.fleetCapacityMatrixCalendar' ||
                        vm.dataToFill.allStates[i].name == 'layout.factorMultiplicadorMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.factorMultiplicadorMain.factorMultiplicador' || 
                        vm.dataToFill.allStates[i].name == 'layout.factorMultiplicadorMain.factorMultiplicadorView' ||
                        vm.dataToFill.allStates[i].name == 'layout.factorMultiplicadorMain.factorMultiplicadorViewCalendar'
                        // vm.dataToFill.allStates[i].name == 'layout.mailDriverMain'
                    ) {

                    } else {
                        vm.dataToFill.finalArrayStates.push({
                            title: vm.dataToFill.allStates[i].title,
                            checked: false
                        });
                    }
                }
                for (var i = 0; i < vm.extraPermissions.length; i++) {
                    vm.dataToFill.finalArrayStates.push(vm.extraPermissions[i]);
                }
            }
        }
        vm.extraPermissions = [{
                'title': 'Adjust Fare',
                'checked': false
            },
            {
                'title': 'Unassign',
                'checked': false
            },
            {
                'title': 'No Show',
                'checked': false
            },
            {
                'title': 'Ver voucher',
                'checked': false
            },
            {
                'title': 'Enviar voucher',
                'checked': false
            },
            {
                'title': 'Message To Client',
                'checked': false
            },
            {
                'title': 'Print Receipt',
                'checked': false
            },
            {
                'title': 'Desbloquear',
                'checked': false
            },
            {
                'title': 'Permitir Modificar Tarifa - POS',
                'checked': false
            },
            {
                'title': 'Permitir Modificar Tarifa - PANEL',
                'checked': false
            },
            {
                'title': 'BWR',
                'checked': false
            },
            {
                'title': 'Add/Remove Cars of Illuminated Zone',
                'checked': false
            },
            {
                'title': 'Ajuste Convenio',
                'checked': false
            },
            {
                'title': 'Activar / Inactivar Conductor',
                'checked': false
            },
            {
                'title': 'Asignar Manualmente',
                'checked': false
            },
            {
                'title': 'Restablecer',
                'checked': false
            },
            {
                'title': 'Eliminar grupo de difusión',
                'checked': false
            },
            {
                'title': 'Autorizar Anulación de Reserva',
                'checked': false
            },
            {
                'title': 'Cambiar Contraseña Empleado Dotación',
                'checked': false
            },
            {
                'title': 'Cambiar Contraseña Cuenta Usuario Cliente',
                'checked': false
            },
            {
                'title': 'Agregar balance general',
                'checked': false
            },
            {
                'title': 'Editar balance mínimo general',
                'checked': false
            },
            {
                'title': 'Borrar balance mínimo general',
                'checked': false
            },
            {
                'title': 'Agregar balance dínamico',
                'checked': false
            },
            {
                'title': 'Editar balance mínimo dinámico',
                'checked': false
            },
            {
                'title': 'Borrar balance mínimo dinámico',
                'checked': false
            },
            {
                'title': 'Descargar Voucher',
                'checked': false
            },
            {
                'title': 'Adjustar reserva en efectivo',
                'checked': false
            },
            {
                'title': 'Crear Masivamente',
                'checked': false
            },
            {
                'title': 'Modificar Masivamente',
                'checked': false
            },
            {
                'title': "Eliminar item de cargo TAG",
                'checked': false
            },
            {
                'title': "Modificar item de cargo TAG",
                'checked': false
            },
            {
                'title': 'Activar factor multiplicador',
                'checked': false
            },
            {
                'title': "Eliminar matriz factor multiplicador",
                'checked': false
            },
            {
                'title': "Creación zona autoasignación",
                'checked': false
            },
            {
                'title': "Editar zona autoasignación",
                'checked': false
            },
            {
                'title': "Activar/Desactivar zona autoasignación",
                'checked': false
            },
            {
                'title': "Eliminar zona autoasignación",
                'checked': false
            }

            // {
            //     'title': 'Modificar grupo de difusión',
            //     'checked': false
            // },
            // {
            //     'title': 'Ver grupo de difusión',
            //     'checked': false
            // },
            // {
            //     'title': 'Agregar grupo de difusión',
            //     'checked': false
            // }
        ];

        //===============handle states===================

        //==========================select all roles===========================
        function selectAllRoles(data) {
            if (!data) {
                for (var i = 0; i < vm.dataToFill.finalArrayStates.length; i++) {
                    vm.dataToFill.finalArrayStates[i].checked = true;
                }
            } else {
                for (var i = 0; i < vm.dataToFill.finalArrayStates.length; i++) {
                    vm.dataToFill.finalArrayStates[i].checked = false;
                }
            }
        };


        //===========================get admin permissions=============================
        function getAdminRoleSingle() {
            var dataSend = {};
            vm.editArray = [];
            var promise = getAdminRoles.getAllRolesApi(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    var where = _.where(payload.title.data, {
                        _id: $stateParams.id
                    })[0];
                    vm.dataToFill.permissionName = where.permissionName;
                    vm.dataToFill.permissionId = where.permissionsId;
                    vm.dataToFill.roleName = where.roleName;
                    vm.dataToFill.roleNameGiven = where.roleName;
                    vm.dataToFill.description = where.description;
                    vm.dataToFill.roles_pet = where.roleType;
                    vm.editArray = where.access;
                    for (var i = 0; i < where.access.length; i++) {
                        for (var j = 0; j < vm.dataToFill.finalArrayStates.length; j++) {
                            if (where.access[i] == vm.dataToFill.finalArrayStates[j].title) {
                                vm.dataToFill.finalArrayStates[j].checked = true;
                            }
                        }
                    }
                    for (var i = 0; i < vm.dataToFill.finalArrayStates.length; i++) {
                        if (!vm.dataToFill.finalArrayStates[i].checked) {
                            vm.selectAll = false;
                            break;
                        } else {
                            vm.selectAll = true;
                        }
                    }
                    vm.FlagApi = true;
                    getAdminRolesParameter();
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };
        getAdminRoleSingle();


        function getAdminRolesParameter() {
            if (vm.FlagApi = true) {
                if (vm.dataToFill.roles_pet == 'roles_encale') {
                    vm.dataToFill.finalArrayStates = [];
                    for (var i = 5; i < vm.dataToFill.allStates.length; i++) {
                        if (vm.dataToFill.allStates[i].name == 'layout.applicantsMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.approvedDriverMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.approvedInvestorsMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.customersMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.illuminatedZoneServicesMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.corporateMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.upcomingBookingsMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.ongoingBookingsMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.completedBookingsMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.carMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.assignedCarsMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.paymentTypeMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.typeOfServiceMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.vehicleTypeMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.agreementMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.branchMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.fixedRouteGeofenceMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.fixedRouteMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.illuminatedZoneMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.couponMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.binMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.createBookingMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.createBookingHereMapsMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.massiveCreateBookingMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.itemOfChargeMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.cancelReasonMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.driverEarningMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.communaMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.promoCodeMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.adminRolesMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.dashboardMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.globalParametersMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.summaryProductionMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.vehicleBalanceReportMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.detailedProductionMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.itemOfChargeCsvMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.onOffDutyMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.correctFareReasonMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.helpDocMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.searchBookingMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.generatePaymentStatusMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.cierroPeriodeMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.abrirPeriodoMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.rejectedBookingMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.operationalReportMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.operationPointUserMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.operationPointMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.quickSaleMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.sharedRouteAssignmentMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.sharedGroupMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.groupedRouteAssignmentMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.specialDirectionsMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.adminUsersMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.newMessageMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.groupDriversMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.historyMessageMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.heatMapMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.vechicleBalanceMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.controlledWayMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.controlledWayMain.editControlledWay' ||
                            vm.dataToFill.allStates[i].name == 'layout.gaussControlMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.fleetCapacityMatrixMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.fleetCapacityMatrixMain.fleetCapacityMatrixDetail' ||
                            vm.dataToFill.allStates[i].name == 'layout.fleetCapacityMatrixMain.fleetCapacityMatrixCreate' ||
                            vm.dataToFill.allStates[i].name == 'layout.fleetCapacityMatrixMain.fleetCapacityMatrixEdit' ||
                            vm.dataToFill.allStates[i].name == 'layout.fleetCapacityMatrixMain.fleetCapacityMatrixExceptions' ||
                            vm.dataToFill.allStates[i].name == 'layout.fleetCapacityMatrixMain.fleetCapacityMatrixCalendar' ||
                            vm.dataToFill.allStates[i].name == 'layout.factorMultiplicadorMain' ||
                            vm.dataToFill.allStates[i].name == 'layout.factorMultiplicadorMain.factorMultiplicador' ||
                            vm.dataToFill.allStates[i].name == 'layout.factorMultiplicadorMain.factorMultiplicadorView' ||
                            vm.dataToFill.allStates[i].name == 'layout.factorMultiplicadorMain.factorMultiplicadorViewCalendar'
                            // vm.dataToFill.allStates[i].name == 'layout.mailDriverMain'
                        ) {

                        } else {
                            vm.dataToFill.finalArrayStates.push({
                                title: vm.dataToFill.allStates[i].title,
                                checked: vm.editArray.includes(vm.dataToFill.allStates[i].title) ? true : false
                            });
                            vm.extraPermissions.map(function (data) {
                                data.checked = vm.editArray.includes(data.title) ? true : false
                            })
                        }
                    }
                    //vm.dataToFill.finalArrayStates.push('Correct Fare');
                    for (var i = 0; i < vm.extraPermissions.length; i++) {
                        vm.dataToFill.finalArrayStates.push(vm.extraPermissions[i]);
                    }
                } else {
                    vm.rolePet = [];
                    vm.count = 1;
                    if (vm.dataToFill.roles_pet == 'roles_pet') {
                        vm.dataToFill.finalArrayStates = [];
                        vm.dataToFill.finalArrayStatesNew = [];
                        for (var i = 5; i < vm.dataToFill.allStates.length; i++) {
                            if (vm.dataToFill.allStates[i].name == 'layout.applicantsMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.approvedDriverMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.approvedInvestorsMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.customersMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.illuminatedZoneServicesMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.corporateMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.upcomingBookingsMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.ongoingBookingsMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.completedBookingsMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.carMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.assignedCarsMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.paymentTypeMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.typeOfServiceMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.vehicleTypeMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.agreementMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.branchMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.fixedRouteGeofenceMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.fixedRouteMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.illuminatedZoneMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.couponMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.binMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.createBookingMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.createBookingHereMapsMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.massiveCreateBookingMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.itemOfChargeMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.cancelReasonMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.driverEarningMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.communaMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.promoCodeMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.adminRolesMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.dashboardMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.globalParametersMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.summaryProductionMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.vehicleBalanceReportMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.detailedProductionMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.itemOfChargeCsvMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.onOffDutyMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.correctFareReasonMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.generatePaymentStatusMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.cierroPeriodeMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.abrirPeriodoMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.rejectedBookingMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.operationalReportMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.helpDocMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.searchBookingMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.operationPointMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.operationPointUserMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.quickSaleMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.sharedRouteAssignmentMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.groupedRouteAssignmentMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.sharedGroupMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.adminUsersMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.newMessageMain' ||
                                // vm.dataToFill.allStates[i].name == 'layout.groupDriversMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.historyMessageMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.heatMapMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.vechicleBalanceMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.controlledWayMain' ||
                                vm.dataToFill.allStates[i].name == 'layout.controlledWayMain.editControlledWay' ||
                                vm.dataToFill.allStates[i].name == 'layout.gaussControlMain'
                                // vm.dataToFill.allStates[i].name == 'layout.mailDriverMain'
                            ) {

                            } else {
                                if (vm.dataToFill.allStates[i].title == 'Create Booking') {
                                    vm.rolePet.push('Create Booking');
                                } else if (vm.dataToFill.allStates[i].title == 'Create Booking Here Maps') {
                                    vm.rolePet.push('Create Booking Here Maps');
                                } else if (vm.dataToFill.allStates[i].title == 'Agreement') {
                                    vm.rolePet.push('Agreement');
                                    vm.rolePet.push('Manage Employee');
                                    vm.rolePet.push('Fixed Price List');
                                    vm.rolePet.push('Variable Price List');
                                    vm.rolePet.push('Cambiar Contraseña Empleado Dotación');
                                    vm.rolePet.push('Fixed Price List Route Details');
                                    vm.rolePet.push('Variable Price List Route Details');
                                } else if (vm.dataToFill.allStates[i].title == 'Upcoming Bookings') {
                                    vm.rolePet.push('Upcoming Bookings');
                                    vm.rolePet.push('Upcoming Bookings Details');
                                    vm.rolePet.push('Modify Booking');
                                    vm.rolePet.push('Ongoing Bookings');
                                    vm.rolePet.push('Ongoing Bookings Details');
                                    vm.rolePet.push('Completed Bookings');
                                    vm.rolePet.push('Completed Bookings Details');
                                    vm.rolePet.push('Search Booking');
                                    vm.rolePet.push('Search Bookings Details');
                                    vm.rolePet.push('Search Modify Booking');
                                    // vm.rolePet.push('Asignar Manualmente');
                                    vm.rolePet.push('Ver voucher');
                                    // vm.rolePet.push('Unassign');
                                    vm.rolePet.push('Message To Client');
                                    vm.rolePet.push('No Show');
                                    vm.rolePet.push('Enviar voucher');
                                    vm.rolePet.push('Descargar Voucher');
                                    vm.rolePet.push('BWR');
                                    vm.rolePet.push('Print Receipt');
                                } else if (vm.dataToFill.allStates[i].title == 'Generate Payment Status') {
                                    vm.rolePet.push('Adminstración');
                                    vm.rolePet.push('Generate Payment Status');
                                } else if (vm.dataToFill.allStates[i].title == 'Corporate') {
                                    vm.rolePet.push('Corporate');
                                } else {
                                    if (vm.count == 1) {
                                        vm.rolePet.push('Control de Gastos');
                                        vm.count++;
                                    }
                                }
                            }
                        }

                    }
                    for (var i = 0; i < vm.rolePet.length; i++) {
                        vm.dataToFill.finalArrayStates.push({
                            title: vm.rolePet[i],
                            checked: vm.editArray.includes(vm.rolePet[i]) ? true : false
                        });
                    }
                }
            }
        }
        ////======================update admin with this role=======================
        //function updateAdminWithThisRole(data){
        //    var dataSend = {};
        //    dataSend.access_token = $cookies.get('obj');
        //    dataSend.role = data.data.data.ops[0]._id;
        //    dataSend.user_id = Number($stateParams.id);
        //
        //    var promise = getAdminRoles.updateAdminWithRole(dataSend);
        //    promise.then(
        //        function(payload) {
        //            $log.log('sxdsads', payload);
        //            vm.loading = false;
        //            errorMessageFactory.showErrorMessage('Permission given successfully',2,'layout.adminRolesMain.adminRolesList');
        //        },
        //        function(errorPayload) {
        //            vm.loading = false;
        //            if (errorPayload.data.status == 401) {
        //                errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
        //            } else {
        //                errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
        //            }
        //        });
        //};
        //
        ////===============================add role hit============================
        //function addRoleApiHit(data){
        //    var dataSend = {};
        //    dataSend.permissionId = data.data.data.ops[0]._id;
        //    dataSend.roleName = vm.dataToFill.roleName;
        //
        //    var promise = getAdminRoles.addRole(dataSend);
        //    promise.then(
        //        function(payload) {
        //            $log.log('sxdsads', payload);
        //            //vm.loading = false;
        //            updateAdminWithThisRole(payload);
        //            //errorMessageFactory.showErrorMessage('Permission given successfully',1);
        //        },
        //        function(errorPayload) {
        //            vm.loading = false;
        //            if (errorPayload.data.status == 401) {
        //                errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
        //            } else {
        //                errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
        //            }
        //        });
        //}


        //==================================add permission api==========================
        function updateRole() {
            //errorMessageFactory.showErrorMessage('Functionality is pending.');
            var dataSend = {};
            dataSend.access = [];
            if (vm.dataToFill.roleNameGiven != vm.dataToFill.roleName)
                dataSend.roleName = vm.dataToFill.roleNameGiven;
            dataSend.roleId = $stateParams.id;
            dataSend.description = vm.dataToFill.description;
            for (var i = 0; i < vm.dataToFill.finalArrayStates.length; i++) {
                console.log(vm.dataToFill.finalArrayStates, 'vm.dataToFill.finalArrayStates');

                if (vm.dataToFill.finalArrayStates[i].checked)
                    dataSend.access.push(vm.dataToFill.finalArrayStates[i].title);
            }
            dataSend.roleType = vm.dataToFill.roles_pet;
            vm.loading = true;
            var promise = getAdminRoles.updateRoleApi(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    //addRoleApiHit(payload);
                    languageBasedErrorFactory.getProperErrorMessage('roleUpdateSuces', 0, 2, 'layout.adminRolesMain.adminRolesList')
                    //errorMessageFactory.showErrorMessage('Role updated successfully',2,'layout.adminRolesMain.adminRolesList');
                    updateAccessForLoggedInUser.updateTheAccessListForLoginAdmin();
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });

        };

        //=========================go back=============================
        function goBack() {
            $state.go('layout.adminRolesMain.adminRolesList');
        };
    }
})();

/**
 * Created by cl-macmini-51 on 6/27/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('NewRoleController', NewRoleController);

    /** @ngInject */
    function NewRoleController($cookies, $state, $log, $rootScope, $timeout, $scope, filterFilter, $mdDialog, $document, getAdminRoles, $stateParams, languageBasedErrorFactory, errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.selectAll = false;
        vm.goBack = goBack;
        vm.addRoleApiHit = addRoleApiHit;
        vm.addPermissionApi = addPermissionApi;
        vm.selectAllRoles = selectAllRoles;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.dataToFill = {
            permissionName: '',
            roleName: '',
            description: '',
            allStates: [],
            finalArrayStates: [],
            roles_pet: 'roles_encale',
        };
        vm.RoleNormal = RoleNormal;
        vm.RolePet = RolePet;
        vm.selected = true;
        vm.dataToFill.allStates = $state.get();

        function RolePet() {
            vm.rolePet= [];
            vm.count = 1;
            if (vm.dataToFill.roles_pet == 'roles_pet') {
                vm.dataToFill.finalArrayStates = [];
                for (var i = 5; i < vm.dataToFill.allStates.length; i++) {
                    if (vm.dataToFill.allStates[i].name == 'layout.applicantsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.approvedDriverMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.approvedInvestorsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.customersMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.illuminatedZoneServicesMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.corporateMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.upcomingBookingsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.ongoingBookingsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.completedBookingsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.carMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.assignedCarsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.paymentTypeMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.typeOfServiceMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.vehicleTypeMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.agreementMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.branchMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.fixedRouteGeofenceMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.fixedRouteMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.illuminatedZoneMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.couponMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.binMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.createBookingMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.createBookingHereMapsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.itemOfChargeMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.cancelReasonMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.driverEarningMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.communaMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.promoCodeMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.adminRolesMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.dashboardMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.globalParametersMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.summaryProductionMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.vehicleBalanceReportMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.detailedProductionMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.itemOfChargeCsvMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.onOffDutyMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.correctFareReasonMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.generatePaymentStatusMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.cierroPeriodeMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.abrirPeriodoMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.rejectedBookingMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.operationalReportMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.helpDocMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.searchBookingMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.operationPointMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.operationPointUserMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.quickSaleMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.sharedRouteAssignmentMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.groupedRouteAssignmentMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.sharedGroupMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.adminUsersMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.newMessageMain' ||
                        // vm.dataToFill.allStates[i].name == 'layout.groupDriversMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.historyMessageMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.heatMapMain' || 
                        vm.dataToFill.allStates[i].name == 'layout.vechicleBalanceMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.controlledWayMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.controlledWayMain.editControlledWay' ||
                        vm.dataToFill.allStates[i].name == 'layout.gaussControlMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.autoAssignMain'
                        // vm.dataToFill.allStates[i].name == 'layout.mailDriverMain'
                    ) {

                    } else {
                        if(vm.dataToFill.allStates[i].title == 'Create Booking'){
                            vm.rolePet.push('Create Booking');
                        }else if(vm.dataToFill.allStates[i].title == 'Create Booking Here Maps'){
                            vm.rolePet.push('Create Booking Here Maps');
                        }else if(vm.dataToFill.allStates[i].title == 'Agreement'){
                            vm.rolePet.push('Agreement');
                            vm.rolePet.push('Manage Employee');
                            vm.rolePet.push('Fixed Price List');
                            vm.rolePet.push('Variable Price List');
                            vm.rolePet.push('Cambiar Contraseña Empleado Dotación');
                            vm.rolePet.push('Fixed Price List Route Details');
                            vm.rolePet.push('Variable Price List Route Details');
                        }else if(vm.dataToFill.allStates[i].title == 'Upcoming Bookings'){
                            vm.rolePet.push('Upcoming Bookings');
                            vm.rolePet.push('Upcoming Bookings Details');
                            vm.rolePet.push('Modify Booking');
                            vm.rolePet.push('Ongoing Bookings');
                            vm.rolePet.push('Ongoing Bookings Details');
                            vm.rolePet.push('Completed Bookings');
                            vm.rolePet.push('Completed Bookings Details');
                            vm.rolePet.push('Search Booking');
                            vm.rolePet.push('Search Bookings Details');
                            vm.rolePet.push('Search Modify Booking');
                            // vm.rolePet.push('Asignar Manualmente');
                            vm.rolePet.push('Ver voucher');
                            // vm.rolePet.push('Unassign');
                            vm.rolePet.push('Message To Client');
                            vm.rolePet.push('No Show');
                            vm.rolePet.push('Enviar voucher');
                            vm.rolePet.push('Descargar Voucher');
                            vm.rolePet.push('BWR');
                            vm.rolePet.push('Print Receipt');
                        }
                        else if(vm.dataToFill.allStates[i].title == 'Generate Payment Status'){
                            vm.rolePet.push('Adminstración');
                            vm.rolePet.push('Generate Payment Status');
                        }else if(vm.dataToFill.allStates[i].title == 'Corporate'){
                            vm.rolePet.push('Corporate');
                        }else{
                            if(vm.count == 1){
                                vm.rolePet.push('Control de Gastos');
                                vm.count++;
                            }
                        }
                       
                    }
                }

            }
            for(var i= 0; i < vm.rolePet.length ; i++){
                vm.dataToFill.finalArrayStates.push({
                    title: vm.rolePet[i],
                    checked: false
                });
            }
        }

        function RoleNormal() {
            if (vm.dataToFill.roles_pet == 'roles_encale') {
                vm.dataToFill.finalArrayStates = [];
                for (var i = 5; i < vm.dataToFill.allStates.length; i++) {
                    if (vm.dataToFill.allStates[i].name == 'layout.applicantsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.approvedDriverMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.approvedInvestorsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.customersMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.illuminatedZoneServicesMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.corporateMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.upcomingBookingsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.ongoingBookingsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.completedBookingsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.carMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.assignedCarsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.paymentTypeMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.typeOfServiceMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.vehicleTypeMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.agreementMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.branchMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.fixedRouteGeofenceMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.fixedRouteMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.illuminatedZoneMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.couponMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.binMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.createBookingMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.createBookingHereMapsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.massiveCreateBookingMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.itemOfChargeMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.cancelReasonMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.driverEarningMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.communaMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.promoCodeMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.adminRolesMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.dashboardMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.globalParametersMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.summaryProductionMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.vehicleBalanceReportMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.detailedProductionMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.itemOfChargeCsvMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.onOffDutyMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.correctFareReasonMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.generatePaymentStatusMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.cierroPeriodeMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.abrirPeriodoMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.rejectedBookingMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.operationalReportMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.helpDocMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.searchBookingMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.operationPointMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.operationPointUserMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.quickSaleMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.sharedRouteAssignmentMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.groupedRouteAssignmentMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.sharedGroupMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.adminUsersMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.newMessageMain' ||
                        // vm.dataToFill.allStates[i].name == 'layout.groupDriversMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.historyMessageMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.heatMapMain' || 
                        vm.dataToFill.allStates[i].name == 'layout.vechicleBalanceMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.controlledWayMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.controlledWayMain.editControlledWay'  ||
                        vm.dataToFill.allStates[i].name == 'layout.gaussControlMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.autoAssignMain'
                        // vm.dataToFill.allStates[i].name == 'layout.mailDriverMain'
                    ) {

                    } else {
                        vm.dataToFill.finalArrayStates.push({
                            title: vm.dataToFill.allStates[i].title,
                            checked: false
                        });
                    }
                }
                for (var i = 0; i < vm.extraPermissions.length; i++) {
                    vm.dataToFill.finalArrayStates.push(vm.extraPermissions[i]);
                }
            }
        }
        vm.extraPermissions = [{
                'title': 'Adjust Fare',
                'checked': false
            },
            {
                'title': 'Unassign',
                'checked': false
            },
            {
                'title': 'No Show',
                'checked': false
            },
            {
                'title': 'Ver voucher',
                'checked': false
            },
            {
                'title': 'Enviar voucher',
                'checked': false
            },
            {
                'title': 'Message To Client',
                'checked': false
            },
            {
                'title': 'Print Receipt',
                'checked': false
            },
            {
                'title': 'Desbloquear',
                'checked': false
            },
            {
                'title': 'Permitir Modificar Tarifa - POS',
                'checked': false
            },
            {
                'title': 'Permitir Modificar Tarifa - PANEL',
                'checked': false
            },
            {
                'title': 'BWR',
                'checked': false
            },
            {
                'title': 'Add/Remove Cars of Illuminated Zone',
                'checked': false
            },
            {
                'title': 'Ajuste Convenio',
                'checked': false
            },
            {
                'title': 'Activar / Inactivar Conductor',
                'checked': false
            },
            {
                'title': 'Asignar Manualmente',
                'checked': false
            },
            {
                'title': 'Restablecer',
                'checked': false
            },
            {
                'title': 'Cambiar Contraseña Empleado Dotación',
                'checked': false
            },
            // {
            //     'title': 'Agregar grupo de difusión',
            //     'checked': false
            // },
            // {
            //     'title': 'Ver grupo de difusión',
            //     'checked': false
            // },
            // {
            //     'title': 'Modificar grupo de difusión',
            //     'checked': false
            // },
            {
                'title': 'Eliminar grupo de difusión',
                'checked': false
            },
            {
                'title': 'Autorizar Anulación de Reserva',
                'checked': false
            },
            {
                'title': 'Cambiar Contraseña Cuenta Usuario Cliente',
                'checked': false
            },
            {
                'title': 'Agregar balance general',
                'checked': false
            },
            {
                'title': 'Editar balance mínimo general',
                'checked': false
            },
            {
                'title': 'Borrar balance mínimo general',
                'checked': false
            },
            {
                'title': 'Agregar balance dínamico',
                'checked': false
            },
            {
                'title': ' Editar balance mínimo dinámico',
                'checked': false
            },
            {
                'title': 'Borrar balance mínimo dinámico',
                'checked': false
            },
            {
                'title': 'Descargar Voucher',
                'checked': false
            },
            {
                'title': 'Adjustar reserva en efectivo',
                'checked': false
            },
            {
                'title': 'Crear Masivamente',
                'checked': false
            },
            {
                'title': 'Modificar Masivamente',
                'checked': false
            },
            {
                'title': "Eliminar item de cargo TAG",
                'checked': false
            },
            {
                'title': "Modificar item de cargo TAG",
                'checked': false
            }
        ];

        //===============handle states===================

        if (vm.dataToFill.roles_pet == 'roles_encale') {
            vm.dataToFill.finalArrayStates = [];
            for (var i = 5; i < vm.dataToFill.allStates.length; i++) {
                if (vm.dataToFill.allStates[i].name == 'layout.applicantsMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.approvedDriverMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.approvedInvestorsMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.customersMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.illuminatedZoneServicesMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.corporateMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.upcomingBookingsMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.ongoingBookingsMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.completedBookingsMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.carMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.assignedCarsMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.paymentTypeMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.typeOfServiceMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.vehicleTypeMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.agreementMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.branchMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.fixedRouteGeofenceMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.fixedRouteMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.illuminatedZoneMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.couponMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.binMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.createBookingMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.createBookingHereMapsMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.massiveCreateBookingMain' || 
                    vm.dataToFill.allStates[i].name == 'layout.itemOfChargeMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.cancelReasonMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.driverEarningMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.communaMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.promoCodeMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.adminRolesMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.dashboardMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.globalParametersMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.summaryProductionMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.vehicleBalanceReportMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.detailedProductionMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.itemOfChargeCsvMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.onOffDutyMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.correctFareReasonMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.generatePaymentStatusMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.cierroPeriodeMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.abrirPeriodoMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.rejectedBookingMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.operationalReportMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.helpDocMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.searchBookingMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.operationPointMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.operationPointUserMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.quickSaleMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.sharedRouteAssignmentMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.groupedRouteAssignmentMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.sharedGroupMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.adminUsersMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.newMessageMain' ||
                    // vm.dataToFill.allStates[i].name == 'layout.groupDriversMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.historyMessageMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.heatMapMain' || 
                    vm.dataToFill.allStates[i].name == 'layout.vechicleBalanceMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.controlledWayMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.controlledWayMain.editControlledWay' ||
                    vm.dataToFill.allStates[i].name == 'layout.gaussControlMain' ||
                    vm.dataToFill.allStates[i].name == 'layout.autoAssignMain'
                    // vm.dataToFill.allStates[i].name == 'layout.mailDriverMain'
                ) {

                } else {
                    vm.dataToFill.finalArrayStates.push({
                        title: vm.dataToFill.allStates[i].title,
                        checked: false
                    });
                }
            }
            //vm.dataToFill.finalArrayStates.push('Correct Fare');
            for (var i = 0; i < vm.extraPermissions.length; i++) {
                vm.dataToFill.finalArrayStates.push(vm.extraPermissions[i]);
            }
        } else {
            vm.rolePet= [];
            vm.count = 1;
            if (vm.dataToFill.roles_pet == 'roles_pet') {
                vm.dataToFill.finalArrayStates = [];
                for (var i = 5; i < vm.dataToFill.allStates.length; i++) {
                    if (vm.dataToFill.allStates[i].name == 'layout.applicantsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.approvedDriverMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.approvedInvestorsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.customersMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.illuminatedZoneServicesMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.corporateMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.upcomingBookingsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.ongoingBookingsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.completedBookingsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.carMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.assignedCarsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.paymentTypeMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.typeOfServiceMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.vehicleTypeMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.agreementMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.branchMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.fixedRouteGeofenceMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.fixedRouteMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.illuminatedZoneMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.couponMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.binMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.createBookingMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.createBookingHereMapsMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.itemOfChargeMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.cancelReasonMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.driverEarningMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.communaMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.promoCodeMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.adminRolesMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.dashboardMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.globalParametersMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.summaryProductionMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.vehicleBalanceReportMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.detailedProductionMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.itemOfChargeCsvMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.onOffDutyMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.correctFareReasonMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.generatePaymentStatusMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.cierroPeriodeMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.abrirPeriodoMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.rejectedBookingMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.operationalReportMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.helpDocMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.searchBookingMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.operationPointMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.operationPointUserMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.quickSaleMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.sharedRouteAssignmentMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.groupedRouteAssignmentMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.sharedGroupMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.adminUsersMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.newMessageMain' ||
                        // vm.dataToFill.allStates[i].name == 'layout.groupDriversMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.historyMessageMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.heatMapMain' || 
                        vm.dataToFill.allStates[i].name == 'layout.vechicleBalanceMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.controlledWayMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.controlledWayMain.editControlledWay' ||
                        vm.dataToFill.allStates[i].name == 'layout.gaussControlMain' ||
                        vm.dataToFill.allStates[i].name == 'layout.autoAssignMain'
                        // vm.dataToFill.allStates[i].name == 'layout.mailDriverMain'
                    ) {

                    } else {
                        if(vm.dataToFill.allStates[i].title == 'Create Booking'){
                            vm.rolePet.push('Create Booking');
                        }else if(vm.dataToFill.allStates[i].title == 'Create Booking Here Maps'){
                            vm.rolePet.push('Create Booking Here Maps');
                        }else if(vm.dataToFill.allStates[i].title == 'Agreement'){
                            vm.rolePet.push('Agreement');
                            vm.rolePet.push('Manage Employee');
                            vm.rolePet.push('Fixed Price List');
                            vm.rolePet.push('Variable Price List');
                            vm.rolePet.push('Cambiar Contraseña Empleado Dotación');
                            vm.rolePet.push('Fixed Price List Route Details');
                            vm.rolePet.push('Variable Price List Route Details');
                        }else if(vm.dataToFill.allStates[i].title == 'Upcoming Bookings'){
                            vm.rolePet.push('Upcoming Bookings');
                            vm.rolePet.push('Upcoming Bookings Details');
                            vm.rolePet.push('Modify Booking');
                            vm.rolePet.push('Ongoing Bookings');
                            vm.rolePet.push('Ongoing Bookings Details');
                            vm.rolePet.push('Completed Bookings');
                            vm.rolePet.push('Completed Bookings Details');
                            vm.rolePet.push('Search Booking');
                            vm.rolePet.push('Search Bookings Details');
                            vm.rolePet.push('Search Modify Booking');
                            // vm.rolePet.push('Asignar Manualmente');
                            vm.rolePet.push('Ver voucher');
                            // vm.rolePet.push('Unassign');
                            vm.rolePet.push('Message To Client');
                            vm.rolePet.push('No Show');
                            vm.rolePet.push('Enviar voucher');
                            vm.rolePet.push('Descargar Voucher');
                            vm.rolePet.push('BWR');
                            vm.rolePet.push('Print Receipt');
                        }
                        else if(vm.dataToFill.allStates[i].title == 'Generate Payment Status'){
                            vm.rolePet.push('Adminstración');
                            vm.rolePet.push('Generate Payment Status');
                        }else if(vm.dataToFill.allStates[i].title == 'Corporate'){
                            vm.rolePet.push('Corporate');
                        }else{
                            if(vm.count == 1){
                                vm.rolePet.push('Control de Gastos');
                                vm.count++;
                            }
                        }
                       
                    }
                }

            }
            for(var i= 0; i < vm.rolePet.length ; i++){
                vm.dataToFill.finalArrayStates.push({
                    title: vm.rolePet[i],
                    checked: false
                });
            }
        }


        //==========================select all roles===========================
        function selectAllRoles(data) {
            if (!data) {
                for (var i = 0; i < vm.dataToFill.finalArrayStates.length; i++) {
                    vm.dataToFill.finalArrayStates[i].checked = true;
                }
            } else {
                for (var i = 0; i < vm.dataToFill.finalArrayStates.length; i++) {
                    vm.dataToFill.finalArrayStates[i].checked = false;
                }
            }
        };

        //======================update admin with this role=======================
        //function updateAdminWithThisRole(data){
        //
        //    var dataSend = {};
        //    dataSend.access_token = $cookies.get('obj');
        //    dataSend.role = data.data.data.ops[0]._id;
        //    dataSend.user_id = Number($stateParams.id);
        //
        //    var promise = getAdminRoles.updateAdminWithRole(dataSend);
        //    promise.then(
        //        function(payload) {
        //            $log.log('sxdsads', payload);
        //            vm.loading = false;
        //            errorMessageFactory.showErrorMessage('Permission given successfully',2,'layout.adminRolesMain.adminRolesList');
        //        },
        //        function(errorPayload) {
        //            vm.loading = false;
        //            if (errorPayload.data.status == 401) {
        //                errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
        //            } else {
        //                errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
        //            }
        //        });
        //};

        //===============================add role hit============================
        function addRoleApiHit(data) {
            var dataSend = {};
            dataSend.access = [];
            //dataSend.permissionId = data.data.data.ops[0]._id;
            dataSend.roleName = vm.dataToFill.roleName;
            dataSend.description = vm.dataToFill.description;
            for (var i = 0; i < vm.dataToFill.finalArrayStates.length; i++) {
                if (vm.dataToFill.finalArrayStates[i].checked)
                    dataSend.access.push(vm.dataToFill.finalArrayStates[i].title);
            }
            dataSend.roleType = vm.dataToFill.roles_pet;
            vm.loading = true;
            var promise = getAdminRoles.addRole(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    languageBasedErrorFactory.getProperErrorMessage('roleSuccessCrear', 0, 2, 'layout.adminRolesMain.adminRolesList')
                    //errorMessageFactory.showErrorMessage('Role created successfully',2,'layout.adminRolesMain.adminRolesList');
                    //errorMessageFactory.showErrorMessage('Permission given successfully',1);
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        }


        //==================================add permission api==========================
        function addPermissionApi() {
            var dataSend = {};
            dataSend.access = [];
            dataSend.permissionName = vm.dataToFill.permissionName;
            for (var i = 0; i < vm.dataToFill.finalArrayStates.length; i++) {
                if (vm.dataToFill.finalArrayStates[i].checked)
                    dataSend.access.push(vm.dataToFill.finalArrayStates[i].title);
            }
            vm.loading = true;
            var promise = getAdminRoles.addPermission(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    addRoleApiHit(payload);
                    //errorMessageFactory.showErrorMessage('New admin user registered successfully',1);
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };

        //=========================go back=============================
        function goBack() {
            $state.go('layout.adminRolesMain.adminRolesList');
        };
    }
})();

/**
 * Created by cl-macmini-51 on 6/29/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('BookingReportsAdminController', BookingReportsAdminController);

    /** @ngInject */
    function BookingReportsAdminController($cookies, $state, $log, $rootScope, $timeout, $scope, filterFilter, $mdDialog, $document, getAdminRoles,$stateParams,moment,languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.totalBookings = 0;
        vm.currentPage = 0;
        vm.totalCars = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.predicate = 'index';
        vm.reverse = false;
        vm.dataToFill = {
            adminEmail : '',
            startDate: new Date(),
            endDate: new Date()
        };
        vm.dateOptions = {};
        vm.datePicker_1 = {
            end: false,
            start: false
        };
        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.altInputFormats = ['M!/d!/yyyy'];
        vm.getPagesCount = getPagesCount;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.init = init;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.getAllAdminBookingReport = getAllAdminBookingReport;
        vm.datePickerE_1 = datePickerE_1;
        vm.dateChanged = dateChanged;
        vm.goBack = goBack;
        vm.exportReport = exportReport;
        vm.paginationNew = paginationNew;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        //==================date picker function==================
        vm.dateOptions = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(2090, 12, 31),
            //minDate: new Date(),
            startingDay: 1,
            showWeeks: false
        };

        function datePickerE_1(type) {
            if(type == '1'){
                vm.datePicker_1.start = true;
                vm.datePicker_1.end = false;
            }
            else if(type == '2'){
                vm.datePicker_1.end = true;
                vm.datePicker_1.start = false;
            }
        };

        function dateChanged(){
            if(vm.dataToFill.startDate < vm.dataToFill.endDate){
                getAllAdminBookingReport(vm.dataToFill,0, vm.searchModel.limit);
            }
        };
        //====================function for dropdown pages and page count===============
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250, 'All']
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];

        function getPagesCount() {
            vm.currentPage = 0;
            if (vm.itemsPerPageSelected == 'All') {
                vm.itemsPerPageGot = vm.dataLength;
                getAllAdminBookingReport(vm.dataToFill,0, vm.itemsPerPageGot);
            } else {
                vm.itemsPerPageGot = vm.itemsPerPageSelected;
                getAllAdminBookingReport(vm.dataToFill,0, vm.itemsPerPageGot);
            }
        };

        function paginationNew(page){
            getAllAdminBookingReport(vm.dataToFill,(page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot);
        }
        //=======================get single admin=========================
        function getSingleAdminUsersHit(skip, limit) {
            var dataSend = {};
            dataSend.limit = limit;
            dataSend.offset = skip;
            dataSend.admin_id = $stateParams.id;
            var promise = getAdminRoles.getAdminUserList(dataSend);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.dataToFill.adminEmail = payload.title.data.result[0].email;
                    init(vm.dataToFill);
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                });
        };
        getSingleAdminUsersHit(0,0);
        //==================get all booking reports=======================
        function getAllAdminBookingReport(data,skip, limit) {
            data.startDate.setHours(0);
            data.startDate.setMinutes(0);
            data.startDate.setSeconds(0);
            data.endDate.setHours(23);
            data.endDate.setMinutes(59);
            data.endDate.setSeconds(0);
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = limit;
            dataSend.offset = skip;
            dataSend.report_start_time = data.startDate.toISOString();
            dataSend.report_end_time = data.endDate.toISOString();
            dataSend.admin_email = data.adminEmail;
            vm.loading = true;
            var promise = getAdminRoles.getAdminBookingReport(dataSend);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.totalBookings = payload.title.data.totalCount;
                    vm.dataLength = payload.title.data.totalCount;

                    if (payload.title.data.totalCount == 0) {
                        vm.sp_pagination = false;
                        vm.tBodyFlag = false;
                        vm.tFootFlag = true;
                    } else {
                        vm.sp_pagination = true;
                        vm.tBodyFlag = true;
                        vm.tFootFlag = false;
                    }

                    var dataArray = [];
                    var adminBookingList = payload.title.data.result;
                    adminBookingList.forEach(function(column) {
                        var d = {};
                        d.acknowledged_datetime = column.acknowledged_datetime;
                        d.arrived_datetime = column.arrived_datetime;
                        d.auth_of = column.auth_of;
                        d.auth_required = column.auth_required;
                        d.branch = column.branch;
                        d.completed_datetime = column.completed_datetime;
                        d.contract_id = column.contract_id;
                        d.contract_name = column.contract_name;
                        d.created_by = column.created_by;
                        d.creation_datetime = column.creation_datetime;
                        d.creator_profile = column.creator_profile;
                        d.customer_country_code = column.customer_country_code;
                        d.customer_email = column.customer_email;
                        d.customer_first_name = column.customer_first_name;
                        d.customer_last_name = column.customer_last_name;
                        d.customer_phone_number = column.customer_phone_number;
                        d.fleet_country_code = column.fleet_country_code;
                        d.fleet_email = column.fleet_email;
                        d.fleet_firat_name = column.fleet_firat_name;
                        d.fleet_id = column.fleet_id;
                        d.fleet_last_name = column.fleet_last_name;
                        d.fleet_phone = column.fleet_phone;
                        d.isAirportService = column.isAirportService;
                        d.is_auth = column.is_auth;
                        d.is_round_trip = column.is_round_trip;
                        d.is_vip = column.is_vip;
                        d.job_address = column.job_address;
                        d.job_id = column.job_id;
                        d.job_latitude = column.job_latitude;
                        d.job_longitude = column.job_longitude;
                        d.job_pickup_address = column.job_pickup_address;
                        //d.job_pickup_datetime = column.job_pickup_datetime;
                        d.number_of_passangers = column.number_of_passangers;
                        d.job_status = column.job_status;
                        d.job_pickup_latitude = column.job_pickup_latitude;
                        d.job_pickup_longitude = column.job_pickup_longitude;
                        //d.job_time = column.job_time;
                        d.job_time_utc = column.job_time_utc;
                        d.payment_amount = column.payment_amount;
                        d.payment_method = column.payment_method; //CAR TYPES
                        d.return_date_time = column.return_date_time; //CAR number
                        d.return_date_time_utc = column.return_date_time_utc;
                        d.round_trip_parent_job_id = column.round_trip_parent_job_id;
                        d.schedule_ride = column.schedule_ride;
                        d.service_cost = column.service_cost;
                        d.service_name = column.service_name;
                        d.started_datetime = column.started_datetime;
                        d.total_distance_travelled = column.total_distance_travelled;
                        d.total_time_travelled = column.total_time_travelled;
                        d.total_wait_time = column.total_wait_time;
                        d.transport_type_id = column.transport_type_id;
                        d.type_of_service = column.type_of_service;
                        d.vehicle_name = column.vehicle_name;
                        dataArray.push(d);
                    });
                    vm.adminBookingList = dataArray;
                    for (var i = 0; i < vm.adminBookingList.length; i++) {
                        vm.adminBookingList[i].index = (skip + i);
                    }
                    if (vm.dataLength <= vm.itemsPerPageGot) {
                        vm.sp_pagination = false;
                    } else {
                        vm.sp_pagination = true;
                        //vm.pageCount(payload.title.data.totalCount);
                    }
                    vm.skipValue = vm.adminBookingList[0].index;
                    vm.limitValue = vm.adminBookingList[vm.adminBookingList.length - 1].index;

                    $scope.$watch('vm.search', function(newVal, oldVal) {
                        vm.filtered = filterFilter(vm.adminBookingList, newVal);
                        vm.totalItems = vm.filtered.length;
                        if (vm.filtered.length == 0) {
                            vm.watchPagination = false;
                        } else {
                            vm.watchPagination = true;
                        }
                        if (vm.filterOn == true) {
                            vm.skipValueFilter = vm.filtered.length;
                            vm.sp_pagination = false;
                        }
                    }, true);

                    //range();
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                });
        };

        //==========================export api to csv==========================
        function exportReport(data){
            data.startDate.setHours(0);
            data.startDate.setMinutes(0);
            data.startDate.setSeconds(0);
            data.endDate.setHours(23);
            data.endDate.setMinutes(59);
            data.endDate.setSeconds(0);
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = 0;
            dataSend.offset = 0;
            dataSend.report_start_time = data.startDate.toISOString();
            dataSend.report_end_time = data.endDate.toISOString();
            dataSend.admin_email = data.adminEmail;
            vm.loading = true;
            var promise = getAdminRoles.getAdminBookingReport(dataSend);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    var dataArrayE = [];
                    var adminBookingListExport = payload.title.data.result;
                    adminBookingListExport.forEach(function(column) {
                        var d = {};
                        d['Job ID'] = column.job_id;
                        d['job Status'] = column.job_status;
                        d['Creation Date'] = moment(column.creation_datetime).format('lll');
                        d['Start Date'] = moment(column.job_time_utc).format('lll');
                        d['Number Of Passengers'] = column.number_of_passangers;
                        d['Customer ID'] = column.created_by;
                        d['Customer Profile'] = column.creator_profile == 0 ? 'Personal':'Corporate';
                        d['Customer Name'] = column.customer_first_name + ' ' + column.customer_last_name;
                        d['Customer Email'] = column.customer_email;
                        d['Customer Mobile'] = column.customer_country_code + column.customer_phone_number;
                        d['Customer VIP'] = column.is_vip == 0?'NO':'YES';
                        d['Contract ID'] = column.contract_id;
                        d['Contract Name'] = column.contract_name;
                        d['Authorization Required'] = column.auth_required == 0?'NO':'YES';
                        d['Authorizer ID'] = column.auth_of;
                        d['Authorization Given'] = column.is_auth == 0?'NO':'YES';
                        d['Authorization Date'] = moment(column.acknowledged_datetime).format('lll');
                        d['Airport Service'] = column.isAirportService == 0?'NO':'YES';
                        //d['Pickup Date'] = moment(column.job_pickup_datetime).format('lll');
                        d['Pickup Address'] = column.job_pickup_address;
                        d['Pickup Latitude'] = column.job_pickup_latitude;
                        d['Pickup Longitude'] = column.job_pickup_longitude;
                        d['Dropoff Address'] = column.job_address;
                        d['Dropoff Latitude'] = column.job_latitude;
                        d['Dropoff Longitude'] = column.job_longitude;
                        d['Round Trip'] = column.is_round_trip == 0?'NO':'YES';
                        d['Round Trip Parent Job ID'] = column.round_trip_parent_job_id;
                        d['Return Date'] = moment(column.return_date_time_utc).format('lll');
                        d['Scheduled Ride'] = column.schedule_ride == 0?'NO':'YES';
                        d['Service Name'] = column.service_name;
                        d['Service Cost'] = column.service_cost;
                        d['Service ID'] = column.type_of_service;
                        d['Transport Type ID'] = column.transport_type_id;
                        d['Vehicle Name'] = column.vehicle_name;
                        d['Branch Name'] = column.branch;
                        d['Driver ID'] = column.fleet_id;
                        d['Driver Name'] = column.fleet_firat_name + ' ' + column.fleet_last_name;
                        d['Driver Email'] = column.fleet_email;
                        d['Driver Mobile'] = column.fleet_country_code + column.fleet_phone;
                        d['Driver Arrival Date'] = moment(column.arrived_datetime).format('lll');
                        d['Driver Started Date'] = moment(column.started_datetime).format('lll');
                        d['Driver Completed Date'] = moment(column.completed_datetime).format('lll');
                        d['Total Distance Travelled'] = column.total_distance_travelled;
                        d['Total Time Travelled'] = column.total_time_travelled;
                        d['Total Wait Time'] = column.total_wait_time;
                        d['Total Amount'] = column.payment_amount;
                        d['Payment Method'] = column.payment_method;
                        dataArrayE.push(d);
                    });
                    vm.adminBookingListExport = dataArrayE;
                    alasql('SELECT * INTO CSV("adminBookingReport.csv",{headers:true}) FROM ?',[vm.adminBookingListExport]);
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                });
        }

        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    } else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        vm.getAllAdminBookingReport(vm.dataToFill,(b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected);
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        vm.currentPage++;
        //        vm.getAllAdminBookingReport(vm.dataToFill,(a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected);
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    vm.getAllAdminBookingReport(vm.dataToFill,(m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected);
        //};

        function init(data) {
            vm.getAllAdminBookingReport(data,0, vm.searchModel.limit);
        };


        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            vm.filterOn = true;
            if (vm.search.length == 0) {
                vm.filterOn = false;
                vm.watchPagination = true;
                vm.sp_pagination = true;
            }
        };
        //====================event for getting refreshed================
        $scope.$on('StateReload', function(evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.adminUsersMain.bookingReports');
            }
        });
        //=================go back================
        function goBack() {
            $state.go('layout.adminUsersMain.adminUsersList');
        };
    }
})();

/**
 * Created by cl-macmini-51 on 9/7/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('AdminUsersListController', AdminUsersListController);

    /** @ngInject */
    function AdminUsersListController($cookies, $state, $log, $rootScope, $timeout, $scope, filterFilter, $mdDialog, $document, getAdminRoles, languageBasedErrorFactory, errorMessageFactory, getOperationPoint, RutHelper, getFilters, getAgreement) {
        var vm = this;
        vm.loading = false;
        vm.totalRoles = 0;
        vm.currentPage = 0;
        vm.totalCars = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.predicate = 'index';
        vm.reverse = false;
        vm.filterData = {
            userStatus: '0'
        };
        vm.getPagesCount = getPagesCount;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.init = init;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.getAllAdminUsersHit = getAllAdminUsersHit;
        vm.createNewUser = createNewUser;
        vm.goToPermission = goToPermission;
        vm.changeAdminStatus = changeAdminStatus;
        vm.deleteUser = deleteUser;
        vm.editUser = editUser;
        vm.paginationNew = paginationNew;
        vm.addToOperationPoint = addToOperationPoint;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        //====================function for dropdown pages and page count===============
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];

        // vm.corporate = corporate;
        vm.corporateOffset = 0;
        vm.agreementOffset = 0;
        vm.globalLimit = 50;
        vm.globalOffset = vm.globalLimit;
        vm.searchFilterArray = ['branch', 'vehicle', 'service', 'agreement', 'corporate', 'operation_point'];
        vm.searchFilterArrayForClearArray = ['branchList', 'vehicle', 'service', 'agreement', 'corporatesList', 'operation_point'];
        vm.corporatesList = [];
        // vm.corporatesList.push({
        //     company_name: 'All',
        //     id: 'all'
        // });

        vm.agreement = [];
        vm.agreement.push({
            name: 'Todos',
            id: 'all'
        });

        // =================== FILTER OBJECT ===================
        vm.filterObject = {
            access_token: $cookies.get('obj'),
            branch_filter: 0,
            vehicle_filter: 0,
            service_filter: 0,
            agreement_filter: 1,
            corporate_filter: 1,
            service_category: 0,
            corporate_status: 2,
            agreement_status: 1,
            vehicle__status: 0,
            operation_point_filter: 0,
            branch_limit: 0,
            branch_offset: 0,
            agreement_limit: vm.globalLimit,
            agreement_offset: vm.agreementOffset,
            corporate_limit: vm.globalLimit,
            corporate_offset: vm.corporateOffset,
            branch_search_filter: 0,
            vehicle_search_filter: 0,
            service_search_filter: 0,
            agreement_search_filter: 0,
            corporate_search_filter: 0,
            operation_point_search_filter: 0
        }

        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllAdminUsersHit(0, vm.itemsPerPageGot, vm.filterData);
        };

        function paginationNew(page) {
            getAllAdminUsersHit((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot, vm.filterData);
        }

        //==================get all drivers=======================
        function getAllAdminUsersHit(skip, limit, filter) {
            var dataSend = {};
            dataSend.limit = limit;
            dataSend.offset = skip;
            dataSend.status = filter.userStatus;
            vm.loading = true;
            var promise = getAdminRoles.getAdminUserList(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.totalRoles = payload.title.data.totalCount;
                    vm.dataLength = payload.title.data.totalCount;

                    if (payload.title.data.totalCount == 0) {
                        vm.sp_pagination = false;
                        vm.tBodyFlag = false;
                        vm.tFootFlag = true;
                    } else {
                        vm.sp_pagination = true;
                        vm.tBodyFlag = true;
                        vm.tFootFlag = false;
                    }

                    var dataArray = [];
                    var adminUserList = payload.title.data.result;
                    adminUserList.forEach(function (column) {
                        var d = {};
                        d.admin_id = column.admin_id;
                        d.admin_type = column.admin_type;
                        d.creation_datetime = column.newCreation_time;
                        d.email = column.email;
                        d.is_active = column.is_active;
                        d.status = column.status;
                        d.role = column.role;
                        d.description = column.description;
                        d.fullName = column.fullName;
                        d.point_name = column.point_name;

                        d.rut = column.RUT;
                        d.RutCorporate = column.rut_corporate;
                        d.corporateName = column.corporate_name;
                        d.corporateId = column.corporate_id;
                        d.userType = column.user_type;
                        d.agreements = column.agreements;

                        dataArray.push(d);
                    });
                    vm.adminUserList = dataArray;
                    for (var i = 0; i < vm.adminUserList.length; i++) {
                        vm.adminUserList[i].index = (skip + i);
                    }
                    if (vm.dataLength <= vm.itemsPerPageGot) {
                        vm.sp_pagination = false;
                    } else {
                        vm.sp_pagination = true;
                        //vm.pageCount(payload.title.data.totalCount);
                    }
                    vm.skipValue = vm.adminUserList[0].index;
                    vm.limitValue = vm.adminUserList[vm.adminUserList.length - 1].index;

                    $scope.$watch('vm.search', function (newVal, oldVal) {
                        vm.filtered = filterFilter(vm.adminUserList, newVal);
                        vm.totalItems = vm.filtered.length;
                        if (vm.filtered.length == 0) {
                            vm.watchPagination = false;
                        } else {
                            vm.watchPagination = true;
                        }
                        if (vm.filterOn == true) {
                            vm.skipValueFilter = vm.filtered.length;
                            vm.sp_pagination = false;
                        }
                    }, true);

                    //range();
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };
        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    } else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        vm.getAllAdminUsersHit((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        vm.currentPage++;
        //        vm.getAllAdminUsersHit((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    vm.getAllAdminUsersHit((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected,vm.filterData);
        //};

        function init() {
            vm.getAllAdminUsersHit(0, vm.searchModel.limit, vm.filterData);
        };
        init();

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            vm.filterOn = true;
            if (vm.search.length == 0) {
                vm.filterOn = false;
                vm.watchPagination = true;
                vm.sp_pagination = true;
            }
        };

        vm.agreementToSendToBackendInMainController = [];
        //================================add new admin hit==========================
        function addNewAdminHit(data) {
            var dataSend = {};
            dataSend.admin_type = data.admin_type;
            dataSend.email = data.email;
            dataSend.password = data.password;
            dataSend.fullName = data.fullName;
            dataSend.description = data.description;
            dataSend.user_type = parseInt(data.userType);
            dataSend.rut = data.rut;
            if (data.userType == 1) {
                dataSend.rut_corporate = data.corporateRut;
                dataSend.agreements = vm.agreementToSendToBackendInMainController;
            }
            vm.loading = true;
            var promise = getAdminRoles.addAdminUser(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return [];
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return [];
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (parseInt(data.userType)) {
                            languageBasedErrorFactory.getProperErrorMessage('popToAssignRolePET', 0, 1, 'layout.adminUsersMain.adminUsersList');
                        } else {
                            languageBasedErrorFactory.getProperErrorMessage('popToAssignRole', 0, 1, 'layout.adminUsersMain.adminUsersList');
                        }
                    }
                    //errorMessageFactory.showErrorMessage('New admin user registered successfully. Assign role to admin user for further actions.',1);
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        };

        //===========================================create new user hit======================================
        function createNewUser($event) {
            vm.items = {
                admin_type: 1,
                email: '',
                fullName: '',
                description: '',
                password: '',
                confirmPassword: '',
                is_active: '',
                role: '',
                passwordMatchFlag: false,
                rut: '',
                userType: '',
                corporateRut: '',
                agreementToSend: [],
                limit: 10,
                offset: 0,
                totalCount: 0
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/addNewAdminUser.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: DialogController
            });

            function DialogController($scope, $mdDialog, items, RutHelper, getAdminRoles) {
                $scope.items = items;
                var dataGet = [];
                $scope.addAgreementStatus = false;
                $scope.userType = [{
                        name: 'TRANSVIP',
                        value: 0
                    },
                    {
                        name: 'PET',
                        value: 1
                    }
                ];

                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    $scope.corporateRUTErrorRequired = false;
                    $scope.agreedAgreementsErrorRequired = false;
                    // if user type is PET
                    if ($scope.items.userType == 1) {
                        $scope.validationCheck = false;
                        // Validation for corporate RUT
                        if (!$scope.items.corporateRut) {
                            $scope.corporateRUTErrorRequired = true;
                            $scope.validationCheck = true;
                        }
                        // Validation for agreement
                        if (vm.agreementToSendToBackendInMainController.length == 0) {
                            $scope.agreedAgreementsErrorRequired = true;
                            $scope.validationCheck = true;
                        }
                        if ($scope.validationCheck)
                            return true;
                        $mdDialog.hide();
                        addNewAdminHit($scope.items);
                    } else {
                        $mdDialog.hide();
                        addNewAdminHit($scope.items);
                    }
                };
                $scope.matchPassword = function (data) {
                    if (data && data.length >= 8) {
                        if (data != $scope.items.password) {
                            $scope.items.passwordMatchFlag = true;
                        } else {
                            $scope.items.passwordMatchFlag = false;
                        }
                    }
                };
                $scope.matchPasswordAgain = function (data) {
                    if (data && $scope.items.confirmPassword) {
                        if (data != $scope.items.confirmPassword) {
                            $scope.items.passwordMatchFlag = true;
                        } else {
                            $scope.items.passwordMatchFlag = false;
                        }
                    }
                };

                $scope.passengerRutChange = function () {
                    if ($scope.items.rut) {
                        if (RutHelper.validate($scope.items.rut)) {
                            $scope.passengerRUTError = false;
                        } else {
                            $scope.passengerRUTError = true;
                        }
                    } else if ($scope.items.rut === null) {
                        $scope.passengerRUTError = true;
                    } else if ($scope.items.rut === undefined) {
                        $scope.passengerRUTError = false;
                    }
                }

                // ******** API FOR SEARCH IN CORPORATE BASED ON CORPORATE RUT *******
                $scope.corporateList = [];
                $scope.corporateRutAPI = function (data) {

                    $scope.items.agreementToSend = [];
                    vm.agreementToSendToBackendInMainController = [];
                    $scope.items.corporateName = '';
                    $scope.selectedAgreement = 'Selecciones los convenios a los cuáles el usuario tendrá acceso';

                    var dataToSend = {};
                    dataToSend.access_token = $cookies.get('obj');
                    dataToSend.search_value = $scope.items.corporateRut;
                    var promise = getAdminRoles.getCorporateListBasedOnSearch(dataToSend);
                    return promise.then(
                        function (payload) {
                            $log.log(payload);
                            vm.loading = false;
                            $scope.corporateList = [];
                            if (payload.title.status == 400) {
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                                return [];
                            } else if (payload.title.status == 401) {
                                errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                                return [];
                            } else if (payload.title.status == 201 || payload.title.status == 200) {
                                $scope.corporateList = payload.title.data.result || [];
                                return $scope.corporateList;
                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }

                $scope.onSelectingCorporate = function () {
                    $scope.corporateRUTErrorRequired = false;
                    $scope.items.corporateName = $scope.items.corporateRut.company_name;
                    $scope.items.corporateId = $scope.items.corporateRut.id;
                    $scope.items.corporateRut = $scope.items.corporateRut.RUT;
                    $scope.getFilterDataForEndowment();
                    getFilterDataFromBackend(0, 0);
                }

                $scope.addAgreement = function () {
                    if ($scope.items.corporateName) {
                        // ANIMATION FOR AGREEMENT LIST SHOW
                        $("#showAgreement").hide("slide", {
                            direction: "left"
                        }, 1200);

                        $timeout(function () {
                            $scope.addAgreementStatus = true;
                            $("#hideAgreement").fadeIn("slow");
                            $timeout(function () {
                                document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                                    // if (vm.branchList && (vm.branchList.length == 0)) {
                                    vm.searchCorporateData = '';
                                    vm.agreementOffset = 0;
                                    vm.agreement = [];
                                    getFilterDataFromBackend(0, 0);
                                });

                                // document.getElementsByClassName('ui-select-search')[1].addEventListener('blur', function ($event) {
                                //     // if (vm.corporatesList && (vm.corporatesList.length == 0)) {
                                //     vm.searchCorporateData = '';
                                //     vm.corporatesList = [];
                                //     vm.corporateOffset = 0;
                                //     getFilterDataFromBackend(0, 0);
                                //     // }
                                // });
                            }, 500);
                        }, 1100)
                    } else {
                        $scope.corporateRUTErrorRequired = true;
                    }
                }

                // ********** CANCEL AGREEMENT ***************
                $scope.cancelAgreement = function () {

                    vm.agreementToSendToBackendInMainController = [];
                    $scope.selectedAgreement = 'Selecciones los convenios a los cuáles el usuario tendrá acceso';
                    $scope.items.agreementToSend = [];

                    $scope.agreedAgreementsErrorRequired = true;

                    for (var i = 0; i < $scope.items.tableAgreement.length; i++) {
                        $scope.items.tableAgreement[i].selected = false;
                    }

                    $("#hideAgreement").hide("slide", {
                        direction: "right"
                    }, 1200);

                    $timeout(function () {
                        $scope.addAgreementStatus = false;
                        $("#showAgreement").show();
                        $("#showAgreement").fadeIn("slow");
                    }, 1100)
                }
                $scope.selectedAgreement = 'Selecciones los convenios a los cuáles el usuario tendrá acceso';
                $scope.confirmAgreement = function () {
                    vm.agreementToSendToBackendInMainController = [];
                    $scope.selectedAgreement = '';
                    for (var i = 0; i < $scope.items.agreementToSend.length; i++) {
                        // VARIABLE TO SHOE AGREEMENT NAMES IN UI
                        $scope.selectedAgreement += $scope.items.agreementToSend[i].name + ((i == $scope.items.agreementToSend.length - 1) ? '' : ', ');
                        // VARIABLE TO SEND AGREEMENT DATA TO BACKEND
                        vm.agreementToSendToBackendInMainController.push($scope.items.agreementToSend[i].contract_id);
                    }
                    if (vm.agreementToSendToBackendInMainController.length > 0) {
                        $scope.agreedAgreementsErrorRequired = false;
                    } else {
                        $scope.selectedAgreement = 'Selecciones los convenios a los cuáles el usuario tendrá acceso';
                        $scope.agreedAgreementsErrorRequired = true;
                    }
                    $("#hideAgreement").hide("slide", {
                        direction: "right"
                    }, 1200);

                    $timeout(function () {
                        $scope.addAgreementStatus = false;
                        $("#showAgreement").show();
                        $("#showAgreement").fadeIn("slow");
                    }, 1100)
                }

                // =================== GET FILTER DATA ===================
                function getFilterDataFromBackend(data, type) {

                    vm.statusToMaintainAPIHits = true;
                    if (data) {
                        vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                        vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
                    } else {
                        vm.filterObject = {
                            access_token: $cookies.get('obj'),
                            branch_filter: 0,
                            vehicle_filter: 0,
                            service_filter: 0,
                            agreement_filter: 1,
                            corporate_filter: 1,
                            service_category: 0,
                            corporate_status: 2,
                            agreement_status: 1,
                            vehicle__status: 0,
                            operation_point_filter: 0,
                            branch_search_filter: 0,
                            vehicle_search_filter: 0,
                            service_search_filter: 0,
                            agreement_search_filter: 0,
                            corporate_search_filter: 0,
                            operation_point_search_filter: 0,
                            agreement_type: 'CORPORATE'
                        }
                    }
                    vm.filterObject.agreement_limit = vm.globalLimit;
                    vm.filterObject.agreement_offset = vm.agreementOffset;
                    vm.filterObject.corporate_limit = vm.globalLimit;
                    vm.filterObject.corporate_offset = vm.corporateOffset;
                    // vm.filterObject.corporate_id = $scope.items.corporateId || '';

                    $scope.agreementShowArray;
                    $scope.coprateListShow;
                    var promise = getFilters.getAllFilterData(vm.filterObject);
                    promise.then(
                        function (payload) {
                            vm.statusToMaintainAPIHits = false;
                            // ********** Agrrement DATA ********
                            if (payload.title.data.agreements) {
                                var index = _.findIndex(vm.agreement, {
                                    id: 'all'
                                });
                                if (index == -1)
                                    vm.agreement.push({
                                        name: 'Todos',
                                        id: 'all'
                                    });
                                angular.forEach(payload.title.data.agreements.data, function (column) {
                                    // vm.corporatesList.push(column)
                                    var agreement = _.findIndex(vm.agreement, {
                                        id: column.id
                                    });
                                    if (agreement == -1)
                                        vm.agreement.push(column)

                                });
                                vm.agreementTotalBackendCount = payload.title.data.agreements.totalCount;
                                $scope.agreementShowArray = vm.agreement;
                            }
                            // ********** CORPORATE DATA ********
                            if (payload.title.data.corporates) {
                                var index = _.findIndex(vm.corporatesList, {
                                    id: 'all'
                                });
                                // if (index == -1)
                                //     vm.corporatesList.push({
                                //         company_name: 'All',
                                //         id: 'all'
                                //     });
                                angular.forEach(payload.title.data.corporates.data, function (column) {
                                    // vm.corporatesList.push(column)
                                    var corprateIndex = _.findIndex(vm.corporatesList, {
                                        id: column.id
                                    });
                                    if (corprateIndex == -1)
                                        vm.corporatesList.push(column)

                                });
                                $scope.coprateListShow = vm.corporatesList;
                                vm.corporateTotalBackendCount = payload.title.data.corporates.totalCount;
                            }
                            $timeout(function () {
                                $scope.$apply();
                            })
                            vm.loading = false;
                        },
                        function (errorPayload) {
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        });
                }

                $scope.corporate = function (data) {
                    // setTimeout(function () {

                    //     document.getElementsByClassName('ui-select-search')[1].addEventListener('blur', function ($event) {
                    //         // if (vm.corporatesList && (vm.corporatesList.length == 0)) {
                    //         vm.searchCorporateData = '';
                    //         vm.corporatesList = [];
                    //         vm.corporateOffset = 0;
                    //         getFilterDataFromBackend(0, 0);
                    //         // }
                    //     });
                    // })
                }
                $scope.aggrementchange = function () {
                    setTimeout(function () {
                        document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                            // if (vm.branchList && (vm.branchList.length == 0)) {
                            vm.searchCorporateData = '';
                            vm.agreementOffset = 0;
                            vm.agreement = [];
                            getFilterDataFromBackend(0, 0);
                        });
                    })
                }
                // *********** COMMON FUNCTION FOR FILTER PAGINATION AND SEARCHING ***********
                function commonFunction(type, mode) {

                    for (var i = 0; i < vm.searchFilterArray.length; i++) {

                        if (mode == 'search' || i != type) {
                            vm[vm.searchFilterArrayForClearArray[i]] = [];
                            // vm[vm.searchFilterArrayForClearArray[i]].push({
                            //     id: 'all',
                            //     name: 'All'
                            // });
                            vm[vm.searchFilterArray[i] + 'Offset'] = 0;
                            vm['search' + vm.searchFilterArray[i].substring(0, 1).toUpperCase() + vm.searchFilterArray[i].substring(1) + 'Data'] = '';
                        }
                    }
                }
                getFilterDataFromBackend(0, 0);
                // setTimeout(function () {
                //     console.log('>>>>>>>>>> IN  >>>>>>>', document.getElementsByClassName('ui-select-search')   );
                //     document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                //         // if (vm.branchList && (vm.branchList.length == 0)) {
                //         vm.searchCorporateData = '';
                //         vm.agreementOffset = 0;
                //         vm.agreement = [];
                //         getFilterDataFromBackend(0, 0);
                //     });

                //     document.getElementsByClassName('ui-select-search')[1].addEventListener('blur', function ($event) {
                //         // if (vm.corporatesList && (vm.corporatesList.length == 0)) {
                //         vm.searchCorporateData = '';
                //         vm.corporatesList = [];
                //         vm.corporateOffset = 0;
                //         getFilterDataFromBackend(0, 0);
                //         // }
                //     });
                // })
                // ************ PAGINATION ON CORPORATE **************
                $scope.paginationChangedForCorporation = function () {
                    var index = _.findIndex(vm[vm.searchFilterArray[5]], {
                        id: 'all'
                    });
                    index = (index == -1 ? 0 : 1);
                    if (vm.corporateTotalBackendCount > (vm.corporatesList.length - index)) {
                        commonFunction(4);
                        vm.corporateOffset += vm.globalOffset;
                        getFilterDataFromBackend(vm.searchCorporateData, 4);
                    }
                }

                // ************ PAGINATION ON AGREEMENT **************
                $scope.paginationChangedForAgreement = function () {
                    var index = _.findIndex(vm[vm.searchFilterArray[3]], {
                        id: 'all'
                    });
                    index = (index == -1 ? 0 : 1);
                    if (vm.agreementTotalBackendCount > (vm.agreement.length - index)) {
                        commonFunction(3);
                        vm.agreementOffset += vm.globalOffset;
                        getFilterDataFromBackend(vm.searchAgreementData, 3);
                    }
                }

                // ************ SEARCH SERVICE ***************
                $scope.corporateSearch = function (data, event) {
                    if (event.keyCode != 40 && event.keyCode != 38) {
                        vm.searchCorporateData = data;
                        $timeout.cancel($scope.timeoutSearch);
                        commonFunction(4, 'search');
                        $scope.timeoutSearch = $timeout(function () {
                            getFilterDataFromBackend(data, 4);
                        }, 2000);
                    }
                }

                // ************ SEARCH AGREEMENT ***************
                $scope.agreementSearch = function (data, event) {
                    if (event.keyCode != 40 && event.keyCode != 38) {
                        vm.searchAgreementData = data;
                        $timeout.cancel($scope.timeoutSearch);
                        commonFunction(3, 'search');
                        $scope.timeoutSearch = $timeout(function () {
                            getFilterDataFromBackend(data, 3);
                        }, 2000);
                    }
                }

                $scope.selectParticularEndowment = function (index) {
                    $scope.existingIndex = _.findIndex($scope.items.agreementToSend, {
                        contract_id: $scope.items.tableAgreement[index].contract_id
                    });
                    if ($scope.existingIndex > -1) {
                        $scope.items.agreementToSend.splice($scope.existingIndex, 1);
                    } else {
                        $scope.items.agreementToSend.push($scope.items.tableAgreement[index]);
                    }
                }

                $scope.paginationChanged = function () {
                    if ($scope.items.totalCount != $scope.items.tableAgreement.length) {
                        $scope.items.offset = $scope.items.offset + $scope.items.limit;
                        $scope.getFilterDataForEndowment('scroll');
                    }
                }

                $scope.getFilterChange = function () {
                    $scope.items.tableAgreement = [];
                    dataGet = [];
                    $scope.items.offset = 0;
                    $scope.items.limit = 10;
                }

                $scope.getFilterDataForEndowment = function (type) {
                    if ($scope.items.rutInvalid) {
                        return;
                    }
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.limit = $scope.items.limit;
                    dataSend.offset = $scope.items.offset;
                    if ($scope.items.agreementSelected && $scope.items.agreementSelected != 'all') {
                        dataSend.agreement_id = Number($scope.items.agreementSelected);
                        $scope.items.tableAgreement = [];
                        dataGet = [];
                    }
                    $scope.items.corporateSelected = $scope.items.corporateId || null;
                    if ($scope.items.corporateSelected && $scope.items.corporateSelected != 'all') {
                        // dataSend.corporate_id = Number($scope.items.corporateSelected);
                        if (type != 'scroll') {
                            $scope.items.tableAgreement = [];
                            dataGet = [];
                        }
                    }

                    if ($scope.items.rutFilter) {
                        dataSend.corporate_rut = RutHelper.clean($scope.items.rutFilter);
                        $scope.items.tableAgreement = [];
                        dataGet = [];
                    }
                    //console.log(dataSend);
                    $scope.items.loading = true;
                    var promise = getAgreement.getAgreementListLessDataWithFilters(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            console.log('>>>>>> RESULT >>>>>>>>>', payload);
                            $scope.items.loading = false;
                            for (var i = 0; i < payload.title.data.contracts.result.length; i++) {
                                payload.title.data.contracts.result[i].selected = false;
                                if (payload.title.data.contracts.result[i].employee_endowment == 1) {
                                    payload.title.data.contracts.result[i].color = 'white';
                                } else {
                                    payload.title.data.contracts.result[i].color = 'white';
                                }
                                dataGet.push(payload.title.data.contracts.result[i]);
                            }
                            $scope.items.totalCount = payload.title.data.contracts.totalCount;
                            $scope.items.tableAgreement = _.where(dataGet, {
                                agreement_type: 'CORPORATE'
                            });
                            if ($scope.items.agreementToSend.length > 0) {
                                for (var i = 0; i < $scope.items.agreementToSend.length; i++) {
                                    $scope.defaultCheckoxSelectedVariable = _.findIndex($scope.items.tableAgreement, {
                                        contract_id: $scope.items.agreementToSend[i].contract_id
                                    });
                                    if ($scope.defaultCheckoxSelectedVariable > -1)
                                        $scope.items.tableAgreement[$scope.defaultCheckoxSelectedVariable].selected = true;
                                }
                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            $scope.items.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }
                // $scope.getFilterDataForEndowment();
            }
        };

        //======================admin status hit===========================
        function changeAdminStatus(data, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('statusAdminPop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                var dataSend = {
                    access_token: $cookies.get('obj'),
                    admin_id: Number(data.admin_id),
                    status: data.status == 1 ? 0 : 1
                };
                // errorMessageFactory.showErrorMessage('Functionality is pending.',0);
                vm.loading = true;
                var promise = getAdminRoles.changeStatus(dataSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        languageBasedErrorFactory.getProperErrorMessage('adminStatusUpdateSuccess', 0, 1, 'layout.adminUsersMain.adminUsersList');
                        //errorMessageFactory.showErrorMessage('Admin Status Updated.',1);
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        }

        //===================go to permission page=======================
        function goToPermission(data) {
            if (data.role && data.role.length) {
                $state.go('layout.adminUsersMain.updateRoleToAdminUser', {
                    id: data.admin_id,
                    userType : data.userType
                });
            } else {
                $state.go('layout.adminUsersMain.addRoleToAdminUser', {
                    id: data.admin_id,
                    userType : data.userType
                });
            }
        }

        //=====================to delete user====================
        function deleteUser(data, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('deleteUserPop', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                vm.loading = true;
                var dataToSend = {};
                dataToSend.access_token = $cookies.get('obj');
                dataToSend.admin_id = data.admin_id;
                dataToSend.is_deleted = 1;
                var promise = getAdminRoles.deleteUser(dataToSend);
                promise.then(
                    function (payload) {
                        $log.log(payload);
                        vm.loading = false;
                        languageBasedErrorFactory.getProperErrorMessage('deleteUserSucc', 0, 1, 'layout.adminUsersMain.adminUsersList')
                        //errorMessageFactory.showErrorMessage('User deleted successfully.',1);
                        //$state.reload();
                    },
                    function (errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }, function () {
                $log.log('not confirmed');
            });
        };

        //========================edit user======================
        function editNewAdminHit(data) {
            vm.loading = true;
            var dataToSend = {};
            dataToSend.access_token = $cookies.get('obj');
            dataToSend.admin_id = data.admin_id;
            dataToSend.email = data.email;
            dataToSend.fullName = data.fullName;
            dataToSend.description = data.description;
            dataToSend.user_type = parseInt(data.userType);
            dataToSend.rut = data.rut;
            if (data.userType == 1) {
                dataToSend.rut_corporate = data.corporateRut;
                dataToSend.agreements = vm.agreementToSendToBackendInMainController;
            }
            var promise = getAdminRoles.editUser(dataToSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;

                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return [];
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return [];
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        languageBasedErrorFactory.getProperErrorMessage('editUserSucc', 0, 1, 'layout.adminUsersMain.adminUsersList');
                    }
                    //errorMessageFactory.showErrorMessage('User profile updated successfully.',1);
                    //$state.reload();
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }


        function editUser(data, $event) {
            vm.items = {
                admin_type: data.admin_type,
                admin_id: data.admin_id,
                email: data.email,
                fullName: data.fullName,
                description: data.description,
                password: '',
                confirmPassword: '',
                is_active: data.is_active,
                role: data.role,
                passwordMatchFlag: false,
                limit: 10,
                offset: 0,
                totalCount: 0,

                rut: data.rut,
                userType: data.userType ? '1' : '0',
                corporateRut: data.userType ? data.RutCorporate : null,
                corporateName: data.userType ? data.corporateName : '',
                corporateId: data.userType ? data.corporateId : '',
                agreementToSend: data.userType ? (data.agreements || []) : []
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/editAdminUser.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: EditDialogController
            });

            function EditDialogController($scope, $mdDialog, items, getAdminRoles) {
                $scope.items = items;
                var dataGet = [];
                $scope.addAgreementStatus = false;
                $scope.userType = [{
                        name: 'TRANSVIP',
                        value: 0
                    },
                    {
                        name: 'PET',
                        value: 1
                    }
                ];
                $scope.selectedAgreement = 'Selecciones los convenios a los cuáles el usuario tendrá acceso';
                // CODE TO SHOW SELCTED AGREEMENTS IF USERTYPE IS "PET"
                if (parseInt($scope.items.userType)) {
                    $scope.selectedAgreement = '';
                    for (var i = 0; i < $scope.items.agreementToSend.length; i++) {
                        // VARIABLE TO SHOE AGREEMENT NAMES IN UI
                        $scope.selectedAgreement += $scope.items.agreementToSend[i].name + ((i == $scope.items.agreementToSend.length - 1) ? '' : ', ');
                        // VARIABLE TO SEND AGREEMENT DATA TO BACKEND
                        vm.agreementToSendToBackendInMainController.push($scope.items.agreementToSend[i].contract_id);
                    }
                }

                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {

                    $scope.corporateRUTErrorRequired = false;
                    $scope.agreedAgreementsErrorRequired = false;
                    console.log('>>>>> IN EDIT >>>>', $scope.items)
                    // if user type is PET
                    if ($scope.items.userType == 1) {
                        $scope.validationCheck = false;
                        // Validation for corporate RUT
                        if (!$scope.items.corporateRut) {
                            $scope.corporateRUTErrorRequired = true;
                            $scope.validationCheck = true;
                        }
                        // Validation for agreement
                        if (vm.agreementToSendToBackendInMainController.length == 0) {
                            $scope.agreedAgreementsErrorRequired = true;
                            $scope.validationCheck = true;
                        }
                        if ($scope.validationCheck)
                            return true;
                        $mdDialog.hide();
                        editNewAdminHit($scope.items);
                    } else {
                        $mdDialog.hide();
                        editNewAdminHit($scope.items);
                    }

                };

                // ******** API FOR SEARCH IN CORPORATE BASED ON CORPORATE RUT *******
                $scope.corporateList = [];
                $scope.corporateRutAPI = function (data) {

                    $scope.items.agreementToSend = [];
                    vm.agreementToSendToBackendInMainController = [];
                    $scope.items.corporateName = '';
                    $scope.selectedAgreement = 'Selecciones los convenios a los cuáles el usuario tendrá acceso';

                    var dataToSend = {};
                    dataToSend.access_token = $cookies.get('obj');
                    dataToSend.search_value = $scope.items.corporateRut;
                    var promise = getAdminRoles.getCorporateListBasedOnSearch(dataToSend);
                    return promise.then(
                        function (payload) {
                            $log.log(payload);
                            vm.loading = false;
                            $scope.corporateList = [];
                            if (payload.title.status == 400) {
                                errorMessageFactory.showErrorMessage(payload.title.message, 0);
                                return [];
                            } else if (payload.title.status == 401) {
                                errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                                return [];
                            } else if (payload.title.status == 201 || payload.title.status == 200) {
                                $scope.corporateList = payload.title.data.result || [];
                                return $scope.corporateList;
                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }

                $scope.onSelectingCorporate = function () {
                    $scope.corporateRUTErrorRequired = false;
                    $scope.items.corporateName = $scope.items.corporateRut.company_name;
                    $scope.items.corporateId = $scope.items.corporateRut.id;
                    $scope.items.corporateRut = $scope.items.corporateRut.RUT;
                    $scope.getFilterDataForEndowment();
                    getFilterDataFromBackend(0, 0);
                }

                $scope.matchPassword = function (data) {
                    if (data && data.length >= 8) {
                        if (data != $scope.items.password) {
                            $scope.items.passwordMatchFlag = true;
                        } else {
                            $scope.items.passwordMatchFlag = false;
                        }
                    }
                };

                $scope.passengerRutChange = function () {
                    if ($scope.items.rut) {
                        if (RutHelper.validate($scope.items.rut)) {
                            $scope.passengerRUTError = false;
                        } else {
                            $scope.passengerRUTError = true;
                        }
                    } else if ($scope.items.rut === null) {
                        $scope.passengerRUTError = true;
                    } else if ($scope.items.rut === undefined) {
                        $scope.passengerRUTError = false;
                    }
                }

                $scope.corporateRutChange = function () {
                    $scope.corporateRUTErrorRequired = false;
                    if ($scope.items.corporateRut) {
                        if (RutHelper.validate($scope.items.corporateRut)) {
                            $scope.corporateRUTError = false;
                        } else {
                            $scope.corporateRUTError = true;
                        }
                    } else if ($scope.items.corporateRut === null) {
                        $scope.corporateRUTError = true;
                    } else if ($scope.items.corporateRut === undefined) {
                        $scope.corporateRUTError = false;
                    }
                }

                $scope.addAgreement = function () {
                    if ($scope.items.corporateName) {
                        // $scope.items.agreementSelected = '',
                        // $scope.getFilterDataForEndowment();
                        // ANIMATION FOR AGREEMENT LIST SHOW
                        $("#showAgreement").hide("slide", {
                            direction: "left"
                        }, 1200);
                        $scope.items.agreementSelected = '',
                        $scope.items.offset = 0;
                        $scope.getFilterDataForEndowment();
                        $timeout(function () {
                            $scope.addAgreementStatus = true;
                            $("#hideAgreement").fadeIn("slow");
                            $timeout(function () {
                                document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                                    // if (vm.branchList && (vm.branchList.length == 0)) {
                                    vm.searchCorporateData = '';
                                    vm.agreementOffset = 0;
                                    vm.agreement = [];
                                    getFilterDataFromBackend(0, 0);
                                });

                                // document.getElementsByClassName('ui-select-search')[1].addEventListener('blur', function ($event) {
                                //     // if (vm.corporatesList && (vm.corporatesList.length == 0)) {
                                //     vm.searchCorporateData = '';
                                //     vm.corporatesList = [];
                                //     vm.corporateOffset = 0;
                                //     getFilterDataFromBackend(0, 0);
                                //     // }
                                // });
                            }, 500);
                        }, 1100)
                    } else {
                        $scope.corporateRUTErrorRequired = true;
                    }

                }

                // ********** CANCEL AGREEMENT ***************
                $scope.cancelAgreement = function () {

                    vm.agreementToSendToBackendInMainController = [];
                    // $scope.selectedAgreement = 'Selecciones los convenios a los cuáles el usuario tendrá acceso';
                    // $scope.items.agreementToSend = [];
                    $scope.items.offset = 0;
                    $scope.agreedAgreementsErrorRequired = true;

                    for (var i = 0; i < $scope.items.tableAgreement.length; i++) {
                        $scope.items.tableAgreement[i].selected = false;
                    }

                    $("#hideAgreement").hide("slide", {
                        direction: "right"
                    }, 1200);

                    $timeout(function () {
                        $scope.addAgreementStatus = false;
                        $("#showAgreement").show();
                        $("#showAgreement").fadeIn("slow");
                    }, 1100)
                }
                $scope.confirmAgreement = function () {
                    $scope.selectedAgreement = '';
                    $scope.items.offset = 0;
                    vm.agreementToSendToBackendInMainController = [];
                    for (var i = 0; i < $scope.items.agreementToSend.length; i++) {

                        $scope.defaultCheckoxSelectedVariable = _.findIndex($scope.items.tableAgreement, {
                            contract_id: $scope.items.agreementToSend[i].contract_id
                        });
                        // if ($scope.defaultCheckoxSelectedVariable > -1) {
                            // VARIABLE TO SHOE AGREEMENT NAMES IN UI
                            $scope.selectedAgreement += $scope.items.agreementToSend[i].name + ((i == $scope.items.agreementToSend.length - 1) ? '' : ', ');
                            // VARIABLE TO SEND AGREEMENT DATA TO BACKEND
                            vm.agreementToSendToBackendInMainController.push($scope.items.agreementToSend[i].contract_id);
                        // }
                    }
                    if (vm.agreementToSendToBackendInMainController.length > 0) {
                        $scope.agreedAgreementsErrorRequired = false;
                    } else {
                        $scope.selectedAgreement = 'Selecciones los convenios a los cuáles el usuario tendrá acceso';
                        $scope.agreedAgreementsErrorRequired = true;
                    }
                    $("#hideAgreement").hide("slide", {
                        direction: "right"
                    }, 1200);

                    $timeout(function () {
                        $scope.addAgreementStatus = false;
                        $("#showAgreement").show();
                        $("#showAgreement").fadeIn("slow");
                    }, 1100)
                }

                // =================== GET FILTER DATA ===================
                function getFilterDataFromBackend(data, type) {

                    vm.statusToMaintainAPIHits = true;
                    if (data) {
                        vm.filterObject[vm.searchFilterArray[type] + '_search_filter'] = 1;
                        vm.filterObject[vm.searchFilterArray[type] + '_search_value'] = data;
                    } else {
                        vm.filterObject = {
                            access_token: $cookies.get('obj'),
                            branch_filter: 0,
                            vehicle_filter: 0,
                            service_filter: 0,
                            agreement_filter: 1,
                            corporate_filter: 1,
                            service_category: 0,
                            corporate_status: 2,
                            agreement_status: 1,
                            vehicle__status: 0,
                            operation_point_filter: 0,
                            branch_search_filter: 0,
                            vehicle_search_filter: 0,
                            service_search_filter: 0,
                            agreement_search_filter: 0,
                            corporate_search_filter: 0,
                            operation_point_search_filter: 0,
                            agreement_type: 'CORPORATE'
                        }
                    }
                    vm.filterObject.agreement_limit = vm.globalLimit;
                    vm.filterObject.agreement_offset = vm.agreementOffset;
                    vm.filterObject.corporate_limit = vm.globalLimit;
                    vm.filterObject.corporate_offset = vm.corporateOffset;
                    // vm.filterObject.corporate_id = $scope.items.corporateId || '';

                    $scope.agreementShowArray;
                    $scope.coprateListShow;
                    var promise = getFilters.getAllFilterData(vm.filterObject);
                    promise.then(
                        function (payload) {
                            vm.statusToMaintainAPIHits = false;
                            // ********** Agrrement DATA ********
                            if (payload.title.data.agreements) {
                                var index = _.findIndex(vm.agreement, {
                                    id: 'all'
                                });
                                if (index == -1)
                                    vm.agreement.push({
                                        name: 'Todos',
                                        id: 'all'
                                    });
                                angular.forEach(payload.title.data.agreements.data, function (column) {
                                    // vm.corporatesList.push(column)
                                    var agreement = _.findIndex(vm.agreement, {
                                        id: column.id
                                    });
                                    if (agreement == -1)
                                        vm.agreement.push(column)

                                });
                                vm.agreementTotalBackendCount = payload.title.data.agreements.totalCount;
                                $scope.agreementShowArray = vm.agreement;
                            }
                            // ********** CORPORATE DATA ********
                            if (payload.title.data.corporates) {
                                // var index = _.findIndex(vm.corporatesList, {
                                //     id: 'all'
                                // });
                                // if (index == -1)
                                //     vm.corporatesList.push({
                                //         company_name: 'All',
                                //         id: 'all'
                                //     });
                                angular.forEach(payload.title.data.corporates.data, function (column) {
                                    // vm.corporatesList.push(column)
                                    var corprateIndex = _.findIndex(vm.corporatesList, {
                                        id: column.id
                                    });
                                    if (corprateIndex == -1)
                                        vm.corporatesList.push(column)

                                });
                                $scope.coprateListShow = vm.corporatesList;
                                vm.corporateTotalBackendCount = payload.title.data.corporates.totalCount;
                            }
                            $timeout(function () {
                                $scope.$apply();
                            })
                            vm.loading = false;
                        },
                        function (errorPayload) {
                            vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        });
                }

                $scope.corporate = function (data) {
                    setTimeout(function () {

                        // document.getElementsByClassName('ui-select-search')[1].addEventListener('blur', function ($event) {
                        //     // if (vm.corporatesList && (vm.corporatesList.length == 0)) {
                        //     vm.searchCorporateData = '';
                        //     vm.corporatesList = [];
                        //     vm.corporateOffset = 0;
                        //     getFilterDataFromBackend(0, 0);
                        //     // }
                        // });
                    })
                }
                $scope.aggrementchange = function () {
                    setTimeout(function () {
                        document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                            // if (vm.branchList && (vm.branchList.length == 0)) {
                            vm.searchCorporateData = '';
                            vm.agreementOffset = 0;
                            vm.agreement = [];
                            getFilterDataFromBackend(0, 0);
                        });
                    })
                }
                // *********** COMMON FUNCTION FOR FILTER PAGINATION AND SEARCHING ***********
                function commonFunction(type, mode) {

                    for (var i = 0; i < vm.searchFilterArray.length; i++) {

                        if (mode == 'search' || i != type) {
                            vm[vm.searchFilterArrayForClearArray[i]] = [];
                            // vm[vm.searchFilterArrayForClearArray[i]].push({
                            //     id: 'all',
                            //     name: 'All'
                            // });
                            vm[vm.searchFilterArray[i] + 'Offset'] = 0;
                            vm['search' + vm.searchFilterArray[i].substring(0, 1).toUpperCase() + vm.searchFilterArray[i].substring(1) + 'Data'] = '';
                        }
                    }
                }
                getFilterDataFromBackend(0, 0);
                // setTimeout(function () {
                //     console.log('>>>>>>>>>> IN  >>>>>>>', document.getElementsByClassName('ui-select-search')   );
                //     document.getElementsByClassName('ui-select-search')[0].addEventListener('blur', function ($event) {
                //         // if (vm.branchList && (vm.branchList.length == 0)) {
                //         vm.searchCorporateData = '';
                //         vm.agreementOffset = 0;
                //         vm.agreement = [];
                //         getFilterDataFromBackend(0, 0);
                //     });

                //     document.getElementsByClassName('ui-select-search')[1].addEventListener('blur', function ($event) {
                //         // if (vm.corporatesList && (vm.corporatesList.length == 0)) {
                //         vm.searchCorporateData = '';
                //         vm.corporatesList = [];
                //         vm.corporateOffset = 0;
                //         getFilterDataFromBackend(0, 0);
                //         // }
                //     });
                // })
                // ************ PAGINATION ON CORPORATE **************
                $scope.paginationChangedForCorporation = function () {
                    var index = _.findIndex(vm[vm.searchFilterArray[5]], {
                        id: 'all'
                    });
                    index = (index == -1 ? 0 : 1);
                    if (vm.corporateTotalBackendCount > (vm.corporatesList.length - index)) {
                        commonFunction(4);
                        vm.corporateOffset += vm.globalOffset;
                        getFilterDataFromBackend(vm.searchCorporateData, 4);
                    }
                }

                // ************ PAGINATION ON AGREEMENT **************
                $scope.paginationChangedForAgreement = function () {
                    var index = _.findIndex(vm[vm.searchFilterArray[3]], {
                        id: 'all'
                    });
                    index = (index == -1 ? 0 : 1);
                    if (vm.agreementTotalBackendCount > (vm.agreement.length - index)) {
                        commonFunction(3);
                        vm.agreementOffset += vm.globalOffset;
                        getFilterDataFromBackend(vm.searchAgreementData, 3);
                    }
                }

                // ************ SEARCH SERVICE ***************
                $scope.corporateSearch = function (data, event) {
                    if (event.keyCode != 40 && event.keyCode != 38) {
                        vm.searchCorporateData = data;
                        $timeout.cancel($scope.timeoutSearch);
                        commonFunction(4, 'search');
                        $scope.timeoutSearch = $timeout(function () {
                            getFilterDataFromBackend(data, 4);
                        }, 2000);
                    }
                }

                // ************ SEARCH AGREEMENT ***************
                $scope.agreementSearch = function (data, event) {
                    if (event.keyCode != 40 && event.keyCode != 38) {
                        vm.searchAgreementData = data;
                        $timeout.cancel($scope.timeoutSearch);
                        commonFunction(3, 'search');
                        $scope.timeoutSearch = $timeout(function () {
                            getFilterDataFromBackend(data, 3);
                        }, 2000);
                    }
                }

                $scope.selectParticularEndowment = function (index) {
                    $scope.existingIndex = _.findIndex($scope.items.agreementToSend, {
                        contract_id: $scope.items.tableAgreement[index].contract_id
                    });
                    if ($scope.existingIndex > -1) {
                        $scope.items.agreementToSend.splice($scope.existingIndex, 1);
                    } else {
                        $scope.items.agreementToSend.push($scope.items.tableAgreement[index]);
                    }
                }

                $scope.paginationChanged = function () {
                    if ($scope.items.totalCount != $scope.items.tableAgreement.length) {
                        $scope.items.offset = $scope.items.offset + $scope.items.limit;
                        $scope.getFilterDataForEndowment('scroll');
                    }
                }

                $scope.getFilterChange = function () {
                    $scope.items.tableAgreement = [];
                    dataGet = [];
                    $scope.items.offset = 0;
                    $scope.items.limit = 10;
                }

                $scope.getFilterDataForEndowment = function (type) {
                    if ($scope.items.rutInvalid) {
                        return;
                    }
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.limit = $scope.items.limit;
                    dataSend.offset = $scope.items.offset;
                    if ($scope.items.agreementSelected && $scope.items.agreementSelected != 'all') {
                        dataSend.agreement_id = Number($scope.items.agreementSelected);
                        $scope.items.tableAgreement = [];
                        dataGet = [];
                    }
                    $scope.items.corporateSelected = $scope.items.corporateId || null;
                    if ($scope.items.corporateSelected && $scope.items.corporateSelected != 'all') {
                        // dataSend.corporate_id = Number($scope.items.corporateSelected);
                        if (type != 'scroll') {
                            $scope.items.tableAgreement = [];
                            dataGet = [];
                        }
                    }

                    if ($scope.items.rutFilter) {
                        dataSend.corporate_rut = RutHelper.clean($scope.items.rutFilter);
                        $scope.items.tableAgreement = [];
                        dataGet = [];
                    }
                    //console.log(dataSend);
                    $scope.items.loading = true;
                    var promise = getAgreement.getAgreementListLessDataWithFilters(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log('sxdsads', payload);
                            $scope.items.loading = false;
                            for (var i = 0; i < payload.title.data.contracts.result.length; i++) {
                                payload.title.data.contracts.result[i].selected = false;
                                if (payload.title.data.contracts.result[i].employee_endowment == 1) {
                                    payload.title.data.contracts.result[i].color = 'white';
                                } else {
                                    payload.title.data.contracts.result[i].color = 'white';
                                }
                                dataGet.push(payload.title.data.contracts.result[i]);
                            }
                            $scope.items.totalCount = payload.title.data.contracts.totalCount;
                            $scope.items.tableAgreement = _.where(dataGet, {
                                agreement_type: 'CORPORATE'
                            });
                            if ($scope.items.agreementToSend.length > 0) {
                                for (var i = 0; i < $scope.items.agreementToSend.length; i++) {
                                    $scope.defaultCheckoxSelectedVariable = _.findIndex($scope.items.tableAgreement, {
                                        contract_id: $scope.items.agreementToSend[i].contract_id
                                    });
                                    if ($scope.defaultCheckoxSelectedVariable > -1)
                                        $scope.items.tableAgreement[$scope.defaultCheckoxSelectedVariable].selected = true;
                                }
                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            $scope.items.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }
                // $scope.getFilterDataForEndowment();
            }
        }
        //=======================function to add to operation  point==================
        function addToOperationPoint(data, $event) {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.limit = 10;
            dataSend.offset = 0;
            var promise = getOperationPoint.getOperation(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload.title.data.result && payload.title.data.result.length == 0) {
                        languageBasedErrorFactory.getProperErrorMessage('noOperation', 0, 0);
                        return;
                    }
                    var opData = [];
                    for (var i = 0; i < payload.title.data.result.length; i++) {
                        payload.title.data.result[i].selected = false;
                        if (payload.title.data.result[i].status) {
                            opData.push(payload.title.data.result[i]);
                        }
                    }
                    openPopUpForAdding(data, opData, $event, payload.title.data.totalCount);

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function openPopUpForAdding(data, opData, $event, total) {
            vm.items = {
                adminData: data,
                opData: opData,
                skip: 0,
                limit: 10,
                errorNotSelected: false,
                search: '',
                selectedOp: '',
                totalCount: total
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/addEditToOperationPoint.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: AddToOperationPoint
            });

            function AddToOperationPoint($scope, $mdDialog, items) {
                $scope.items = items;
                var filterTextTimeout = '';
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    if (!$scope.items.selectedOp) {
                        $scope.items.errorNotSelected = true;
                        $timeout(function () {
                            $scope.items.errorNotSelected = false;
                        }, 2000);
                        return;
                    }
                    $mdDialog.hide();
                    addAdminToOperationHit($scope.items);
                };

                $scope.paginationChanged = function () {
                    if ($scope.items.totalCount != $scope.items.opData.length) {
                        $scope.items.skip = $scope.items.skip + $scope.items.limit;
                        $scope.getNewOperation();
                    }
                };

                $scope.getSearchedResult = function () {
                    $scope.items.limit = 10;
                    $scope.items.skip = 0;
                    if ($scope.items.search) {
                        if (filterTextTimeout) $timeout.cancel(filterTextTimeout);
                        filterTextTimeout = $timeout(function () {
                            $scope.getNewOperation(1);
                        }, 500);
                    } else {
                        $scope.items.opData = [];
                        $scope.getNewOperation();
                    }
                };

                $scope.selectParticularOperation = function (index, data) {
                    $scope.items.selectedOp = data;
                };

                $scope.getNewOperation = function (search) {
                    var dataSend = {};
                    dataSend.access_token = $cookies.get('obj');
                    dataSend.limit = $scope.items.limit;
                    dataSend.offset = $scope.items.skip;
                    if (search) {
                        dataSend.search_filter = 1;
                        dataSend.search_value = $scope.items.search;
                    }
                    var promise = getOperationPoint.getOperation(dataSend);
                    promise.then(
                        function (payload) {
                            $log.log(payload);
                            //vm.loading = false;
                            if (search) {
                                $scope.items.opData = [];
                                for (var i = 0; i < payload.title.data.result.length; i++) {
                                    payload.title.data.result[i].selected = false;
                                    if (payload.title.data.result[i].status) {
                                        $scope.items.opData.push(payload.title.data.result[i]);
                                    }
                                }
                            } else {
                                for (var i = 0; i < payload.title.data.result.length; i++) {
                                    payload.title.data.result[i].selected = false;
                                    if (payload.title.data.result[i].status) {
                                        $scope.items.opData.push(payload.title.data.result[i]);
                                    }
                                }
                            }
                        },
                        function (errorPayload) {
                            $log.log(errorPayload);
                            //vm.loading = false;
                            if (errorPayload.data.status == 401) {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                            } else {
                                errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                            }
                        }
                    );
                }
            }
        }

        function addAdminToOperationHit(data) {
            vm.loading = true;
            var dataToSend = {};
            dataToSend.access_token = $cookies.get('obj');
            dataToSend.admin_id = data.adminData.admin_id;
            dataToSend.point_id = data.selectedOp.point_id;
            var promise = getOperationPoint.addUserToOperation(dataToSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    languageBasedErrorFactory.getProperErrorMessage('operationPointUserSucc', 0, 1, 'layout.adminUsersMain.adminUsersList');
                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.adminUsersMain.adminUsersList');
            }
        });
    }
})();
/**
 * Created by cl-macmini-51 on 6/27/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('AdminRolesListController', AdminRolesListController);

    /** @ngInject */
    function AdminRolesListController($cookies, $state, $log, $rootScope, $timeout, $scope, filterFilter, $mdDialog, $document, getAdminRoles,updateAccessForLoggedInUser,languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.totalRoles = 0;
        //vm.currentPage = 0;
        //vm.totalCars = 0;
        //vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        //vm.maxSize = 5;
        //vm.searchModel = {};
        //vm.filterOn = false;
        vm.predicate = 'index';
        vm.reverse = false;
        vm.filterData = {
            roleStatus: '0'
        };
        //vm.getPagesCount = getPagesCount;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.init = init;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.deleteRole = deleteRole;
        vm.getAllAdminRolesHit = getAllAdminRolesHit;
        vm.goToPermission = goToPermission;
        vm.changeAdminRoleStatus = changeAdminRoleStatus;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        //====================function for dropdown pages and page count===============
        //vm.searchModel = {
        //    limit: 10,
        //    limitOptions: [10, 25, 50, 100, 250, 'All']
        //};
        //vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        //vm.itemsPerPageGot = vm.searchModel.limitOptions[0];
        //
        //function getPagesCount() {
        //    vm.currentPage = 0;
        //    if (vm.itemsPerPageSelected == 'All') {
        //        vm.itemsPerPageGot = vm.dataLength;
        //        getAllAdminRolesHit(0, vm.itemsPerPageGot);
        //    } else {
        //        vm.itemsPerPageGot = vm.itemsPerPageSelected;
        //        getAllAdminRolesHit(0, vm.itemsPerPageGot);
        //    }
        //};
        // GET PET USER ROLE FROM GLOBAL VARIABLE
        vm.petUserRoleNameVariable = $rootScope.petUserRoleName || '';
        //==================get all drivers=======================
        function getAllAdminRolesHit(filter) {
            var dataSend = {};
            dataSend.status = filter.roleStatus;
            vm.loading = true;
            var promise = getAdminRoles.getAllRolesApi(dataSend);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.totalRoles = payload.title.data.length;
                    //vm.dataLength = payload.title.data.totalCount;
                    //if (payload.title.data.totalCount == 0) {
                    //    vm.sp_pagination = false;
                    //    vm.tBodyFlag = false;
                    //    vm.tFootFlag = true;
                    //} else {
                    //    vm.sp_pagination = true;
                    //    vm.tBodyFlag = true;
                    //    vm.tFootFlag = false;
                    //}

                    var dataArray = [];
                    var adminRoleList = payload.title.data;
                    adminRoleList.forEach(function(column) {
                        var d = {};
                        d.is_active = column.is_active;
                        d.is_deleted = column.is_deleted;
                        d.permissionsId = column.permissionsId;
                        d.roleName = column.roleName;
                        d.access = column.access;
                        d.description = column.description;
                        d.id = column._id;
                        dataArray.push(d);
                    });
                    vm.adminRoleList = dataArray;
                    for (var i = 0; i < vm.adminRoleList.length; i++) {
                        vm.adminRoleList[i].index = (i);
                    }
                    //if (vm.dataLength <= vm.itemsPerPageGot) {
                    //    vm.sp_pagination = false;
                    //} else {
                    //    vm.sp_pagination = true;
                    //    vm.pageCount(payload.title.data.totalCount);
                    //}
                    //vm.skipValue = vm.adminRoleList[0].index;
                    //vm.limitValue = vm.adminRoleList[vm.adminRoleList.length - 1].index;

                    //$scope.$watch('vm.search', function(newVal, oldVal) {
                    //    vm.filtered = filterFilter(vm.adminRoleList, newVal);
                    //    vm.totalItems = vm.filtered.length;
                    //    if (vm.filtered.length == 0) {
                    //        vm.watchPagination = false;
                    //    } else {
                    //        vm.watchPagination = true;
                    //    }
                    //    if (vm.filterOn == true) {
                    //        vm.skipValueFilter = vm.filtered.length;
                    //        vm.sp_pagination = false;
                    //    }
                    //}, true);
                    //
                    //range();
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                });
        };
        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    } else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        vm.getAllAdminRolesHit((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected);
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        vm.currentPage++;
        //        vm.getAllAdminRolesHit((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected);
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    vm.getAllAdminRolesHit((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected);
        //};

        function init() {
            vm.getAllAdminRolesHit(vm.filterData);
        };
        init();

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            vm.filterOn = true;
            if (vm.search.length == 0) {
                vm.filterOn = false;
                vm.watchPagination = true;
                vm.sp_pagination = true;
            }
        };

        //================================add new admin hit==========================
        function addNewAdminHit(data){
            var dataSend = {};
            dataSend.admin_type = data.admin_type;
            dataSend.email = data.email;
            dataSend.password = data.password;
            dataSend.is_active = data.is_active;
            vm.loading = true;
            var promise = getAdminRoles.addAdminUser(dataSend);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    languageBasedErrorFactory.getProperErrorMessage('newUserSucc',0,1,'layout.adminRolesMain.adminRolesList')
                    //errorMessageFactory.showErrorMessage('New admin user registered successfully',1);
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                });
        };
        //======================admin status hit===========================
        function changeAdminRoleStatus(data, $event) {
            $log.log('confirmed 1', data, data.id);
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('roleStatusPop',0,'3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton',0,'3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton',0,'3'));

            $mdDialog.show(confirm).then(function() {
                $log.log('confirmed 1', data,  data.id);
                var dataSend = {
                    role_id: data.id,
                    is_active: data.is_active == true?false:true
                };
                // errorMessageFactory.showErrorMessage('Functionality is pending.',0);
                vm.loading = true;
                var promise = getAdminRoles.actInActiveRole(dataSend);
                promise.then(
                   function(payload) {
                       $log.log(payload);
                       vm.loading = false;
                       languageBasedErrorFactory.getProperErrorMessage('roleUpdateSuces',0,1,'layout.adminRolesMain.adminRolesList')
                       //errorMessageFactory.showErrorMessage('Role updated successfully.',1);
                       updateAccessForLoggedInUser.updateTheAccessListForLoginAdmin();
                   },
                   function(errorPayload) {
                       $log.log(errorPayload);
                       vm.loading = false;
                       if(errorPayload.data.status == 401){
                           errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                       }
                       else{
                           errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                       }
                   }
                );
            }, function() {
                $log.log('not confirmed');
            });
        }

        //=====================to delete role====================
        function deleteRole(data, $event) {
            var confirm = $mdDialog.confirm()
                .title(languageBasedErrorFactory.getProperErrorMessage('deleteRolPop',0,'3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('confirmButton',0,'3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('CloseButton',0,'3'));

            $mdDialog.show(confirm).then(function() {
                $log.log('confirmed');
                vm.loading = true;
                var dataToSend = {};
                dataToSend.access_token = $cookies.get('obj');
                dataToSend.role_id = data.id;
                dataToSend.is_deleted = true;
                var promise = getAdminRoles.deleteRoleApi(dataToSend);
                promise.then(
                    function(payload) {
                        $log.log(payload);
                        vm.loading = false;
                        languageBasedErrorFactory.getProperErrorMessage('deleteRolSucc',0,1,'layout.adminRolesMain.adminRolesList');
                        //errorMessageFactory.showErrorMessage('Role deleted successfully.',1);
                        updateAccessForLoggedInUser.updateTheAccessListForLoginAdmin();
                        //$state.reload();
                    },
                    function(errorPayload) {
                        $log.log(errorPayload);
                        vm.loading = false;
                        if(errorPayload.data.status == 401){
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                        }
                        else{
                            errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                        }
                    }
                );
            }, function() {
                $log.log('not confirmed');
            });
        };

        //===================go to permission page=======================
        function goToPermission(data){
            if(data.role && data.role.roleName){
                $state.go('layout.adminRolesMain.updatePermissions',{id:data.admin_id});
            }
            else{
                $state.go('layout.adminRolesMain.givePermissions',{id:data.admin_id});
            }
        }
        //====================event for getting refreshed================
        $scope.$on('StateReload', function(evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.adminRolesMain.adminRolesList');
            }
        });
    }
})();

/**
 * Created by cl-macmini-51 on 7/5/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('AdminLogsController', AdminLogsController);

    /** @ngInject */
    function AdminLogsController($cookies, $state, $log, $rootScope, $mdDialog, $timeout, $document, getAdminRoles, $scope, filterFilter, $stateParams, languageBasedErrorFactory, errorMessageFactory) {
        var vm = this;
        vm.getAllAdminLogs = getAllAdminLogs;
        vm.loading = false;
        vm.currentPage = 0;
        vm.totalAdminLogs = 0;
        vm.sp_pagination = false;
        vm.tBodyFlag = true;
        vm.tFootFlag = false;
        vm.maxSize = 5;
        vm.searchModel = {};
        vm.filterOn = false;
        vm.getPagesCount = getPagesCount;
        //vm.range = range;
        //vm.prevPage = prevPage;
        //vm.prevPageDisabled = prevPageDisabled;
        //vm.pageCount = pageCount;
        //vm.nextPage = nextPage;
        //vm.nextPageDisabled = nextPageDisabled;
        //vm.setPage = setPage;
        //vm.currentData = currentData;
        vm.init = init;
        vm.sort = sort;
        vm.getFilter = getFilter;
        vm.goBack = goBack;
        vm.paginationNew = paginationNew;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.predicate = 'index';
        vm.reverse = false;
        vm.type = $stateParams.fakeType;
        //====================function for dropdown pages and page count===============
        vm.searchModel = {
            limit: 10,
            limitOptions: [10, 25, 50, 100, 250]
        };
        vm.itemsPerPageSelected = vm.searchModel.limitOptions[0];
        vm.itemsPerPageGot = vm.searchModel.limitOptions[0];

        function getPagesCount() {
            vm.currentPage = 0;
            vm.itemsPerPageGot = vm.itemsPerPageSelected;
            getAllAdminLogs(0, vm.itemsPerPageGot);
        };

        function paginationNew(page) {
            getAllAdminLogs((page - 1) * vm.itemsPerPageGot, vm.itemsPerPageGot);
        }
        //====================event for getting refreshed================
        $scope.$on('StateReload', function (evt, data) {
            $log.log(evt);
            $log.log(data);
            if (data.data) {
                $state.reload('layout.vehicleTypeMain.adminLogs');
            }
        });

        //==================get all services=======================
        function getAllAdminLogs(skip, limit) {

            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.id = $stateParams.userId;
            dataSend.identity = $stateParams.type;
            dataSend.limit = limit;
            dataSend.offset = skip;
            vm.loading = true;
            var promise = getAdminRoles.getSystemLogs(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    vm.totalAdminLogs = payload.title.data.total_count;
                    vm.dataLength = payload.title.data.total_count;

                    if (payload.title.data.total_count == 0) {
                        vm.sp_pagination = false;
                        vm.tBodyFlag = false;
                        vm.tFootFlag = true;
                        vm.filterOn = true;
                        vm.skipValueFilter = 0;
                    } else {
                        vm.sp_pagination = true;
                        vm.tBodyFlag = true;
                        vm.tFootFlag = false;
                        vm.filterOn = false;
                        vm.skipValueFilter = 0;

                        var dataArray = [];

                        var adminLogList = payload.title.data.logs;
                        adminLogList.forEach(function (column) {
                            var d = {};
                            d.admin_email = column.admin_email;
                            d.id = column.identity_id;
                            d.message = column.message;
                            d.time = column.time;
                            dataArray.push(d);
                        });
                        vm.adminLogList = dataArray;

                        for (var i = 0; i < vm.adminLogList.length; i++) {
                            vm.adminLogList[i].index = (skip + i);
                        }
                        if (vm.dataLength <= vm.itemsPerPageGot) {
                            vm.sp_pagination = false;
                        } else {
                            vm.sp_pagination = true;
                            //vm.pageCount(payload.title.data.total_count);
                        }
                        vm.skipValue = vm.adminLogList[0].index;
                        vm.limitValue = vm.adminLogList[vm.adminLogList.length - 1].index;

                        $scope.$watch('vm.search', function (newVal, oldVal) {
                            vm.filtered = filterFilter(vm.adminLogList, newVal);
                            vm.totalItems = vm.filtered.length;
                            if (vm.filtered.length == 0) {
                                vm.watchPagination = false;
                            } else {
                                vm.watchPagination = true;
                            }
                            if (vm.filterOn == true) {
                                vm.skipValueFilter = vm.filtered.length;
                                vm.sp_pagination = false;
                            }
                        }, true);
                    }

                    //range();
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        // ==========================pagination==============================
        //function range() {
        //    var a = vm.dataLength / vm.itemsPerPageSelected;
        //    if (Math.ceil(a) > 5) {
        //        var rangeSize = 5;
        //    } else {
        //        var rangeSize = Math.ceil(a);
        //    }
        //    var ret = [];
        //    var start;
        //    start = vm.currentPage;
        //    if (start > vm.totalPages - rangeSize) {
        //        start = vm.totalPages - rangeSize + 1;
        //    }
        //    for (var i = start; i < start + rangeSize; i++) {
        //        ret.push(i);
        //    }
        //    vm.ret = ret;
        //    return vm.ret;
        //};
        //
        //function prevPage(b) {
        //    //$("html, body").animate({scrollTop: 0});
        //    if (vm.currentPage > 0) {
        //        vm.currentPage--;
        //        vm.getAllAdminLogs((b - 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected);
        //    }
        //};
        //
        //function prevPageDisabled() {
        //    return vm.currentPage === 0 ? "disabled" : "";
        //};
        //
        //function pageCount(dataLength) {
        //    vm.totalPages = Math.ceil(dataLength / vm.itemsPerPageGot) - 1;
        //    return (vm.totalPages);
        //};
        //
        //function nextPage(a) {
        //    //$("html, body").animate({scrollTop: 0});
        //    $log.log(a);
        //    $log.log(vm.itemsPerPageSelected);
        //    if (vm.currentPage < vm.totalPages) {
        //        vm.currentPage++;
        //        vm.getAllAdminLogs((a + 1) * vm.itemsPerPageSelected, vm.itemsPerPageSelected);
        //    }
        //};
        //
        //function nextPageDisabled() {
        //    return vm.currentPage === vm.totalPages ? "disabled" : "";
        //};
        //
        //function setPage(m) {
        //    vm.currentPage = m;
        //};
        //
        //function currentData(m) {
        //    //$("html, body").animate({scrollTop: 0});
        //    vm.getAllAdminLogs((m) * vm.itemsPerPageSelected, vm.itemsPerPageSelected);
        //};

        function init() {
            vm.getAllAdminLogs(0, vm.searchModel.limit);
        };
        init();

        function sort(type) {
            vm.predicate = type;
            vm.reverse = !vm.reverse;
        };

        function getFilter() {
            vm.filterOn = true;
            if (vm.search.length == 0) {
                vm.filterOn = false;
                vm.watchPagination = true;
                vm.sp_pagination = true;
            }
        };

        //====================go back============================
        function goBack() {
            if (vm.type == '0') {
                $state.go('layout.applicantsMain.applicants');
            } else if (vm.type == '1') {
                $state.go('layout.approvedDriverMain.approvedDriver');
            } else if (vm.type == '2') {
                $state.go('layout.approvedInvestorsMain.approvedInvestor');
            } else if (vm.type == '3') {
                $state.go('layout.customersMain.customers');
            } else if (vm.type == '4') {
                $state.go('layout.carMain.carsList');
            } else if (vm.type == '5') {
                $state.go('layout.cancelReasonMain.cancelReason');
            } else if (vm.type == '6') {
                $state.go('layout.driverEarningMain.driverEarning');
            } else if (vm.type == '7') {
                $state.go('layout.typeOfServiceMain.typeofService');
            } else if (vm.type == '8') {
                $state.go('layout.vehicleTypeMain.vehicleType');
            } else if (vm.type == '9') {
                $state.go('layout.corporateMain.corporate');
            } else if (vm.type == '10') {
                $state.go('layout.itemOfChargeMain.itemOfChargeList');
            } else if (vm.type == '11') {
                $state.go('layout.paymentTypeMain.paymentTypeList');
            } else if (vm.type == '12') {
                $state.go('layout.promoCodeMain.promoList');
            } else if (vm.type == '13') {
                $state.go('layout.branchMain.branchList');
            } else if (vm.type == '14') {
                $state.go('layout.fixedRouteGeofenceMain.fixedRouteGeofenceList');
            } else if (vm.type == '15') {
                $state.go('layout.fixedRouteMain.fixedRouteList');
            } else if (vm.type == '16') {
                $state.go('layout.agreementMain.agreement');
            } else if (vm.type == '17') {
                var data = JSON.parse($cookies.get('setData'));
                $state.go('layout.agreementMain.manageEmployee', {
                    corporateId: data.corporateId,
                    contractId: data.contractId,
                    path: data.path
                });
            } else if (vm.type == '18') {
                var data = JSON.parse($cookies.get('setData'));
                $state.go('layout.agreementMain.priceListFixedAgreement', {
                    corporateId: data.corporateId,
                    contractId: data.contractId,
                    path: data.path
                });
            } else if (vm.type == '19') {
                var data = JSON.parse($cookies.get('setData'));
                $state.go('layout.agreementMain.priceListVariableAgreement', {
                    corporateId: data.corporateId,
                    contractId: data.contractId,
                    path: data.path
                });
            } else if (vm.type == '20') {
                var data = JSON.parse($cookies.get('setData'));
                $state.go('layout.agreementMain.fixedPriceListRoute', {
                    corporateId: data.corporateId,
                    contractId: data.contractId,
                    priceListId: data.priceListId,
                    path: data.path
                });
            } else if (vm.type == '21') {
                var data = JSON.parse($cookies.get('setData'));
                $state.go('layout.agreementMain.variablePriceListRoute', {
                    corporateId: data.corporateId,
                    contractId: data.contractId,
                    priceListId: data.priceListId,
                    path: data.path
                });
            } else if (vm.type == '22') {
                var data = JSON.parse($cookies.get('setData'));
                $state.go('layout.agreementMain.fixedPriceListRouteDetails', {
                    corporateId: data.corporateId,
                    contractId: data.contractId,
                    priceListId: data.priceListId,
                    path: data.path
                });
            } else if (vm.type == '23') {
                var data = JSON.parse($cookies.get('setData'));
                $state.go('layout.agreementMain.variablePriceListRouteDetails', {
                    corporateId: data.corporateId,
                    contractId: data.contractId,
                    priceListId: data.priceListId,
                    path: data.path
                });
            } else if (vm.type == '24') {
                $state.go('layout.communaMain.communa');
            } else if (vm.type == '25') {
                $state.go('layout.correctFareReasonMain.correctFareReason');
            } else if (vm.type == '26') {
                $state.go('layout.noShowReasonMain.noShowReason');
            } else if (vm.type == '27') {
                $state.go('layout.binMain.binList');
            } else if (vm.type == '28') {
                $state.go('layout.couponMain.couponList');
            } else if (vm.type == '29') {
                $state.go('layout.specialDirectionsMain');
            } else if (vm.type == '30') {
                $state.go('layout.heatMapMain');
            } else if (vm.type == '31') {
                $state.go('layout.autoAssignMain.autoAssign');
            }
        }
    }

})();
/**
 * Created by cl-macmini-51 on 9/7/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('AddRoleToAdminUserController', AddRoleToAdminUserController);

    /** @ngInject */
    function AddRoleToAdminUserController($cookies, $state, $log, $rootScope, $timeout, $scope, filterFilter, $mdDialog, $document, getAdminRoles, $stateParams,updateAccessForLoggedInUser, languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;
        vm.loading = false;
        vm.goBack = goBack;
        vm.addRoleToUserApiHit = addRoleToUserApiHit;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();
        vm.dataToFill = {};


        //==========================get all admin roles list=======================
        function getAllAdminRolesHit() {
            var dataSend = {};
            vm.loading = true;
            console.log($stateParams.userType);
            
            dataSend.user_type = Number($stateParams.userType);
            var promise = getAdminRoles.getAllRolesApi(dataSend);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    var dataArray = [];
                    var adminRoleList = payload.title.data;
                    adminRoleList.forEach(function(column) {
                        var d = {};
                        d.is_active = column.is_active;
                        d.is_deleted = column.is_deleted;
                        d.permissionsId = column.permissionsId;
                        d.roleName = column.roleName;
                        d.access = column.access;
                        d.id = column._id;
                        d.checked = false;
                        dataArray.push(d);
                    });
                    var where = _.where(dataArray,{is_active:true});
                    vm.adminRoleList = where;
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        //errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                });
        };
        getAllAdminRolesHit();


        //============================add role to admin user hit==========================
        function addRoleToUserApiHit(){
            var dataSend = {};
            dataSend.role = [];
            dataSend.access_token = $cookies.get('obj');
            dataSend.user_id = $stateParams.id;
            for(var i=0;i<vm.adminRoleList.length;i++){
                if(vm.adminRoleList[i].checked)
                    dataSend.role.push(vm.adminRoleList[i].id);
            }
            vm.loading = true;
            var promise = getAdminRoles.addRoleToUser(dataSend);
            promise.then(
                function(payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    languageBasedErrorFactory.getProperErrorMessage('roleSuccess',0,2,'layout.adminUsersMain.adminUsersList')
                    //errorMessageFactory.showErrorMessage('Role given to user successfully',2,'layout.adminUsersMain.adminUsersList');
                    updateAccessForLoggedInUser.updateTheAccessListForLoginAdmin();
                    //errorMessageFactory.showErrorMessage('Permission given successfully',1);
                },
                function(errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,2,'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message,0);
                    }
                });
        }
        //=========================go back=============================
        function goBack(){
            $state.go('layout.adminUsersMain.adminUsersList');
        };
    }
})();

/**
 * Created by cl-macmini-51 on 4/18/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('getVehiclesBalance', getVehiclesBalance);

    /** @ngInject */
    function getVehiclesBalance($log, $http, $q, MY_CONSTANT, $cookies,pendingRequests) {
        return {
            addVechicleBalanceApi: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/admin/add_mini_balance",
                    method: 'POST',
                    headers: {
                        'content-language': 'es',
                        'Content-Type': 'application/json'
                    },
                    // headers: {
                    //     'content-type': undefined
                    // },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getVehicleBalanceApi: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/admin/get_mini_balance",
                    method: 'POST',
                    headers: {
                        'content-language': 'es',
                        'Content-Type': 'application/json'
                    },
                    // headers: {
                    //     'content-type': undefined
                    // },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            editVechicleBalanceApi: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/admin/edit_mini_balance",
                    method: 'POST',
                    headers: {
                        'content-language': 'es',
                        'Content-Type': 'application/json'
                    },
                    // headers: {
                    //     'content-type': undefined
                    // },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            deleteVechicleBalanceApi: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/admin/delete_mini_balance",
                    method: 'POST',
                    headers: {
                        'content-language': 'es',
                        'Content-Type': 'application/json'
                    },
                    // headers: {
                    //     'content-type': undefined
                    // },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            addVechicleBalanceExceptionApi: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/admin/add_mini_balance_exception",
                    method: 'POST',
                    headers: {
                        'content-language': 'es',
                        'Content-Type': 'application/json'
                    },
                    // headers: {
                    //     'content-type': undefined
                    // },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getVehicleBalanceExceptionApi: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/admin/get_mini_balance_exception",
                    method: 'POST',
                    headers: {
                        'content-language': 'es',
                        'Content-Type': 'application/json'
                    },
                    // headers: {
                    //     'content-type': undefined
                    // },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            editVechicleBalanceExceptionApi: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/admin/edit_mini_balance_exception",
                    method: 'POST',
                    headers: {
                        'content-language': 'es',
                        'Content-Type': 'application/json'
                    },
                    // headers: {
                    //     'content-type': undefined
                    // },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            deleteVechicleBalanceExceptionApi: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/admin/delete_mini_balance_exception",
                    method: 'POST',
                    headers: {
                        'content-language': 'es',
                        'Content-Type': 'application/json'
                    },
                    // headers: {
                    //     'content-type': undefined
                    // },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
        }
    }
})();
/**
 * Created by cl-macmini-51 on 4/18/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('getVehicles', getVehicles);

    /** @ngInject */
    function getVehicles($log, $http, $q, MY_CONSTANT, $cookies,pendingRequests) {
        return {
            allVehicles: function (skip, limit, filter) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_vehicle_type",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_vehicle_type",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: {
                        access_token: $cookies.get('obj'),
                        limit: limit,
                        offset: skip,
                        key: Number(filter)
                    },
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_vehicle_type");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_vehicle_type");
                        return deferred.promise;
                    });
            },
            vehicleDetails: function (id) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_vehicle_type_detail",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_vehicle_type_detail",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: {
                        access_token: $cookies.get('obj'),
                        vehicle_type_id: id
                    },
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_vehicle_type_detail");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_vehicle_type_detail");
                        return deferred.promise;
                    });
            },
            addVehicles: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/add_vehicle_type",
                    method: 'POST',
                    headers: {
                        'content-language': 'es',
                        'Content-Type': undefined
                    },
                    // headers: {
                    //     'content-type': undefined
                    // },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            editVehicles: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/update_vehicle_type",
                    method: 'POST',
                    headers: {
                        'content-language': 'es',
                        'Content-Type': dataSend.content_type || undefined
                    },
                    // headers: {
                    //     'content-type': undefined
                    // },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            deleteVehicle: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/delete_type_of_vehicle",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getLicenseType: function () {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/get_fleet_license_class_type",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            }
        }
    }
})();
/**
 * Created by cl-macmini-51 on 16/12/17.
 */
(function() {
  'use strict';

  angular
    .module('transVipMain')
    .service('anchorSmoothScroll', anchorSmoothScroll);

  /** @ngInject */
  function anchorSmoothScroll($log, $http, $q, MY_CONSTANT, $cookies, $rootScope,$state,$document,$mdDialog) {
    this.scrollTo = function(eID) {

      // This scrolling function
      // is from http://www.itnewb.com/tutorial/Creating-the-Smooth-Scroll-Effect-with-JavaScript

      var startY = currentYPosition();
      var stopY = elmYPosition(eID);
      var distance = stopY > startY ? stopY - startY : startY - stopY;
      if (distance < 100) {
        scrollTo(0, stopY); return;
      }
      var speed = Math.round(distance / 100);
      if (speed >= 20) speed = 20;
      var step = Math.round(distance / 25);
      var leapY = stopY > startY ? startY + step : startY - step;
      var timer = 0;
      if (stopY > startY) {
        for ( var i=startY; i<stopY; i+=step ) {
          setTimeout("window.scrollTo(0, "+leapY+")", timer * speed);
          leapY += step; if (leapY > stopY) leapY = stopY; timer++;
        } return;
      }
      for ( var i=startY; i>stopY; i-=step ) {
        setTimeout("window.scrollTo(0, "+leapY+")", timer * speed);
        leapY -= step; if (leapY < stopY) leapY = stopY; timer++;
      }

      function currentYPosition() {
        // Firefox, Chrome, Opera, Safari
        if (self.pageYOffset) return self.pageYOffset;
        // Internet Explorer 6 - standards mode
        if (document.documentElement && document.documentElement.scrollTop)
          return document.documentElement.scrollTop;
        // Internet Explorer 6, 7 and 8
        if (document.body.scrollTop) return document.body.scrollTop;
        return 0;
      }

      function elmYPosition(eID) {
        var elm = document.getElementById(eID);
        var y = elm.offsetTop;
        var node = elm;
        while (node.offsetParent && node.offsetParent != document.body) {
          node = node.offsetParent;
          y += node.offsetTop;
        } return y;
      }

    };
  }
})();

/**
 * Created by cl-macmini-51 on 23/02/18.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('sharedRouteAssignmentHereMaps', sharedRouteAssignmentHereMaps);

    /** @ngInject */
    function sharedRouteAssignmentHereMaps($log, $http, $q, MY_CONSTANT, $cookies,pendingRequests) {
        return {
            getSharedBookings: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/filter_shared_bookings",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/filter_shared_bookings",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: dataSend,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/filter_shared_bookings");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/filter_shared_bookings");
                        return deferred.promise;
                    });
            },
            validateSharedServices: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/validate_shared_package",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            sharedServicePackage: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/create_shared_package",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getSharedPackageBookingsList: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/list_shared_package",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/list_shared_package",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: dataSend,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/list_shared_package");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/list_shared_package");
                        return deferred.promise;
                    });
            },
            getAvailableDriverForShared: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/manual_assignment_of_driver_shared",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            checkDriverStatusForShared: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/check_driver_status_grouped",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            manualAssignBookingToFleet: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/assign_fleet_to_package",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            manualUnassignBookingToFleet: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/unassign_fleet_from_package",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            deletePackageBooking: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/delete_package",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getPackageDetails: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_shared_package_details",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_shared_package_details",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: dataSend,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_shared_package_details");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_shared_package_details");
                        return deferred.promise;
                    });
            },
            modifySharedService: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/modify_shared_package",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            makeFlagSetInJob: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/clear_lock",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            distanceMatricHereMapApiGroup: function (data) {
                // Create the XHR request
                var request = new XMLHttpRequest();
                // var pickuplat = 'geo!42.332878,-71.052917';
                // var droplat = 'geo!42.090963,-71.264316';
                // Return it as a Promise
                return new Promise(function (resolve, reject) {
                    // Setup our listener to process compeleted requests
                    request.onreadystatechange = function () {
                        // Only run if the request is complete
                        if (request.readyState !== 4) return;
                        // Process the response
                        if (request.status >= 200 && request.status < 300) {
                            // If successful
                            resolve(request);
                        } else {
                            // If failed
                            reject({
                                status: request.status,
                                statusText: request.statusText
                            });
                        }
            
                    };
                    // Setup our HTTP request
                    // Send the request
                    // request.send(Object.keys(data) + '\n' + Object.values(data));
                    var  a = 'https://router.hereapi.com/v8/routes?apikey='+MY_CONSTANT.here_apikey + '&routingMode=fast&transportMode=taxi&currency=CLP&return=summary';
                    for (var key in data) {
                        if (data.hasOwnProperty(key)) {
                             a += '&' + ( key + "=" + data[key]);
                        }

                    }
                    request.open('GET', a, true);
                    request.send();
                });
            },
        }
    }
})();

/**
 * Created by cl-macmini-51 on 23/02/18.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('sharedRouteAssignment', sharedRouteAssignment);

    /** @ngInject */
    function sharedRouteAssignment($log, $http, $q, MY_CONSTANT, $cookies,pendingRequests) {
        return {
            getSharedBookings: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/filter_shared_bookings",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/filter_shared_bookings",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: dataSend,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/filter_shared_bookings");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/filter_shared_bookings");
                        return deferred.promise;
                    });
            },
            validateSharedServices: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/validate_shared_package",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            sharedServicePackage: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/create_shared_package",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getSharedPackageBookingsList: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/list_shared_package",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/list_shared_package",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: dataSend,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/list_shared_package");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/list_shared_package");
                        return deferred.promise;
                    });
            },
            getAvailableDriverForShared: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/manual_assignment_of_driver_shared",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            checkDriverStatusForShared: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/check_driver_status_grouped",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            manualAssignBookingToFleet: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/assign_fleet_to_package",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            manualUnassignBookingToFleet: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/unassign_fleet_from_package",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            deletePackageBooking: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/delete_package",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getPackageDetails: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_shared_package_details",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_shared_package_details",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: dataSend,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_shared_package_details");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_shared_package_details");
                        return deferred.promise;
                    });
            },
            modifySharedService: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/modify_shared_package",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            makeFlagSetInJob: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/clear_lock",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            distanceMatricHereMapApiGroup: function (data) {
                // Create the XHR request
                var request = new XMLHttpRequest();
                // var pickuplat = 'geo!42.332878,-71.052917';
                // var droplat = 'geo!42.090963,-71.264316';
                // Return it as a Promise
                return new Promise(function (resolve, reject) {
                    // Setup our listener to process compeleted requests
                    request.onreadystatechange = function () {
                        // Only run if the request is complete
                        if (request.readyState !== 4) return;
                        // Process the response
                        if (request.status >= 200 && request.status < 300) {
                            // If successful
                            resolve(request);
                        } else {
                            // If failed
                            reject({
                                status: request.status,
                                statusText: request.statusText
                            });
                        }
            
                    };
                    // Setup our HTTP request
                    // Send the request
                    // request.send(Object.keys(data) + '\n' + Object.values(data));
                    var  a = 'https://router.hereapi.com/v8/routes?apikey='+MY_CONSTANT.here_apikey + '&routingMode=fast&transportMode=taxi&currency=CLP&return=summary';
                    for (var key in data) {
                        if (data.hasOwnProperty(key)) {
                             a += '&' + ( key + "=" + data[key]);
                        }

                    }
                    request.open('GET', a, true);
                    request.send();
                });
            },
        }
    }
})();

/**
 * Created by cl-macmini-51 on 5/19/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('sharedParams', sharedParams);

    /** @ngInject */
    function sharedParams($log, $http, $q, MY_CONSTANT, $cookies,pendingRequests) {
        return {
            addSharedParams: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/add_shared_parameter",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getSharedParams: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_shared_parameter",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_shared_parameter",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    timeout: deferred.promise,
                    params: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_shared_parameter");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_shared_parameter");
                        return deferred.promise;
                    });
            }
        }
    }
})();

/**
 * Created by cl-macmini-51 on 4/18/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('getServices', getServices);

    /** @ngInject */
    function getServices($log, $http, $q, MY_CONSTANT, $cookies,pendingRequests) {
        return {
            allServices: function (skip, limit, filter,list) {
                console.log(list,"lusr");
                
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_type_of_service",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_type_of_service",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: {
                        access_token: $cookies.get('obj'),
                        limit: limit,
                        offset: skip,
                        key: Number(filter),
                        all_list: Number(list)
                    },
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_type_of_service");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_type_of_service");
                        return deferred.promise;
                    });
            },
            serviceDetails: function (id) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_type_of_service_details",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_type_of_service_details",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: {
                        access_token: $cookies.get('obj'),
                        type_of_service_id: id
                    },
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_type_of_service_details");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_type_of_service_details");
                        return deferred.promise;
                    });
            },
            addServices: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/add_type_of_service",
                    method: 'POST',
                    headers: {
                        'content-language': 'es',
                        'Content-Type': undefined
                    },
                    // headers: {
                    //     'content-type': undefined
                    // },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            addAddress: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/add_agreement_favourite_addresses",
                    method: 'POST',
                    headers: {
                        'content-language': 'es',
                        'Content-Type': 'application/json'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            deleteAddress: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/delete_agreement_favourite_addresses",
                    method: 'POST',
                    headers: {
                        'content-language': 'es',
                        'Content-Type': 'application/json'
                    },
                    // headers: {
                    //     'content-type': undefined
                    // },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getAddress: function (data) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_agreement_favourite_addresses",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_agreement_favourite_addresses",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: {
                        access_token: $cookies.get('obj'),
                        contract_id: data.contract_id,
                        limit: data.limit,
                        offset: data.offset
                    },
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_agreement_favourite_addresses");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_agreement_favourite_addresses");
                        return deferred.promise;
                    });
            },
            editServices: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/update_type_of_service",
                    method: 'POST',
                    headers: {
                        'content-language': 'es',
                        'Content-Type': dataSend.content_type || undefined
                    },
                    // headers: {
                    //     'content-type': undefined
                    // },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            deleteService: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/delete_type_of_service",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            dataForBookingPaymentCorrection: function (job_id) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_data_for_booking_payment_correction",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_data_for_booking_payment_correction",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: {
                        access_token: $cookies.get('obj'),
                        job_id: job_id,
                    },
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_data_for_booking_payment_correction");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_data_for_booking_payment_correction");
                        return deferred.promise;
                    });
            },

        }
    }
})();

/**
 * Created by cl-macmini-51 on 5/19/17.
 */
 (function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('selfAssignmentEditService', selfAssignmentEditService);

    /** @ngInject */
    function selfAssignmentEditService($log, $http, $q, MY_CONSTANT, $cookies,pendingRequests) {
        return {
            addInstance: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.urlAutoAssignment + "/allocation/v1/parametros",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            updateInstance: function (id,dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.urlAutoAssignment + "/allocation/v1/parametros/" + id,
                    method: 'PUT',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getDetailUpdate: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.urlAutoAssignment + "/allocation/v1/parametros/" + dataSend,
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.urlAutoAssignment + "/allocation/v1/parametros/" + dataSend,
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.urlAutoAssignment + "/allocation/v1/parametros");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.urlAutoAssignment + "/allocation/v1/parametros");
                        return deferred.promise;
                    });
            },
            addGlobalParams: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/add_status_parameter",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getGlobalParams: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_params",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_params",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    timeout: deferred.promise,
                    params: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_params");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_params");
                        return deferred.promise;
                    });
            },
            getAutoassignRegions: function () {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.urlAutoAssignment + "/allocation/v1/parametros/regions",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.urlAutoAssignment + "/allocation/v1/parametros/regions",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.urlAutoAssignment + "/allocation/v1/parametros/regions");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.urlAutoAssignment + "/allocation/v1/parametros/regions");
                        return deferred.promise;
                    });
            },

        }
    }
})();

/**
 * Created by cl-macmini-51 on 23/02/18.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('selfAssignmentDetailsService', selfAssignmentDetailsService);

    /** @ngInject */
    function selfAssignmentDetailsService($log, $http, $q, MY_CONSTANT, $cookies,pendingRequests) {
        return {
            getDetails: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.urlAutoAssignment + "/allocation/v1/parametros/"+ dataSend,
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.urlAutoAssignment + "/allocation/v1/parametros/"+ dataSend,
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.urlAutoAssignment + "/autoassign_instance");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.urlAutoAssignment + "/autoassign_instance");
                        return deferred.promise;
                    });
            },
        }
    }
})();

/**
 * Created by cl-macmini-51 on 5/19/17.
 */
 (function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('selfAssignmentCreateService', selfAssignmentCreateService);

    /** @ngInject */
    function selfAssignmentCreateService($log, $http, $q, MY_CONSTANT, $cookies,pendingRequests) {
        return {
            addInstance: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.urlAutoAssignment + "/allocation/v1/parametros",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            updateInstance: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/autoassign_instance",
                    method: 'PUT',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getDetailUpdate: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/autoassign_instance",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/autoassign_instance",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: dataSend,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/autoassign_instance");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/autoassign_instance");
                        return deferred.promise;
                    });
            },
            addGlobalParams: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/add_status_parameter",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getGlobalParams: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_params",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_params",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    timeout: deferred.promise,
                    params: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_params");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_params");
                        return deferred.promise;
                    });
            },
            getAutoassignRegions: function () {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.urlAutoAssignment + "/allocation/v1/parametros/regions",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.urlAutoAssignment + "/allocation/v1/parametros/regions",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.urlAutoAssignment + "/allocation/v1/parametros/regions");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.urlAutoAssignment + "/allocation/v1/parametros/regions");
                        return deferred.promise;
                    });
            },
        }
    }
})();

/**
 * Created by cl-macmini-51 on 23/02/18.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('selfAssignmentService', selfAssignmentService);

    /** @ngInject */
    function selfAssignmentService($log, $http, $q, MY_CONSTANT, $cookies,pendingRequests) {
        return {
            getServicios: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_booking_type",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_booking_type",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: dataSend,
                    timeout: deferred.promise
                })
                .then(function (data) {
                    deferred.resolve({
                        title: data.data
                    });
                    pendingRequests.remove(MY_CONSTANT.url + "/get_booking_type");
                    return deferred.promise;
                })
                .catch(function (msg) {
                    deferred.reject(msg);
                    pendingRequests.remove(MY_CONSTANT.url + "/get_booking_type");
                    return deferred.promise;
                });
            },
            getExclusivos: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.urlAutoAssignment + "/allocation/v1/parametros/type/" + dataSend,
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.urlAutoAssignment + "/allocation/v1/parametros/type/" + dataSend,
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.urlAutoAssignment + "/allocation/v1/parametros");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.urlAutoAssignment + "/allocation/v1/parametros");
                        return deferred.promise;
                    });
            },
            deleteInstance: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/autoassign_instance",
                    method: 'DELETE',
                    headers: {
                        'content-language': 'es'
                    },
                    params: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
        }
    }
})();

/**
 * Created by cl-macmini-51 on 09/02/18.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('quickSaleService', quickSaleService);

    /** @ngInject */
    function quickSaleService($log, $http, $q, MY_CONSTANT, $cookies,pendingRequests) {
        var apiKeyAconcagua = 'API_KEY_ACME';
        return {
            getShift: function (data) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_shift",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_shift",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: data,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_shift");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_shift");
                        return deferred.promise;
                    });
            },
            getAddress: function (data) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_point_of_sale_addresses",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_point_of_sale_addresses",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: data,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_point_of_sale_addresses");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_point_of_sale_addresses");
                        return deferred.promise;
                    });
            },
            getCustomerData: function (data) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_default_customer_by_contract_for_POS",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_default_customer_by_contract_for_POS",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: data,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_default_customer_by_contract_for_POS");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_default_customer_by_contract_for_POS");
                        return deferred.promise;
                    });
            },
            getAgreement: function (data) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_default_customer_in_contract_for_pos",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_default_customer_in_contract_for_pos",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: data,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_default_customer_in_contract_for_pos");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_default_customer_in_contract_for_pos");
                        return deferred.promise;
                    });
            },
            getOperationData: function (data) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_admin_point_data",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_admin_point_data",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: data,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_admin_point_data");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_admin_point_data");
                        return deferred.promise;
                    });
            },
            startEndShift: function (data) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/start_end_shift",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: data,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getSaleHeight: function (data) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/get_sales_report_height",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: data,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getSaleReport: function (data) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/get_sales_report",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: data,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            applyCoupon: function(dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/apply_promo",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function(data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function(msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            autoSuggestAconcagua: function (dataSend) {
                // Create the XHR request
                var request = new XMLHttpRequest();
                // Return it as a Promise
                return new Promise(function (resolve, reject) {
                    // Setup our listener to process compeleted requests
                    request.onreadystatechange = function () {
                        // Only run if the request is complete
                        if (request.readyState !== 4) return;
                        // Process the response
                        if (request.status >= 200 && request.status < 300) {
                            // If successful
                            resolve(request);
                        } else {
                            // If failed
                            reject({
                                status: request.status,
                                statusText: request.statusText
                            });
                        }
            
                    };
                    // Setup our HTTP request
                    request.open('GET', MY_CONSTANT.autossugestUrl + '/address/locations?channel=' + dataSend.channel + '&q=' + dataSend.query_string + '&at=' + dataSend.at, true);
                    //request.open('GET', 'http://localhost:3000/aconcagua', true);
                    // Send the request
                    request.send();
            
                });
            },
            autoSuggestDetailsAconcagua: function (dataSend) {
                // Create the XHR request
                var request = new XMLHttpRequest();
                // Return it as a Promise
                return new Promise(function (resolve, reject) {
                    // Setup our listener to process compeleted requests
                    request.onreadystatechange = function () {
                        // Only run if the request is complete
                        if (request.readyState !== 4) return;
                        // Process the response
                        if (request.status >= 200 && request.status < 300) {
                            // If successful
                            resolve(request);
                        } else {
                            // If failed
                            reject({
                                status: request.status,
                                statusText: request.statusText
                            });
                        }
            
                    };
                    // Setup our HTTP request
                    request.open('GET', MY_CONSTANT.autossugestUrl + '/address/location/'+ dataSend.id_origin +'?channel=' + dataSend.channel, true);

                    //request.open('GET', 'http://localhost:3000/aconcagua', true);
                    // Send the request
                    request.send();
            
                });
            },
            getFlotaCuota: function (dataSend) {
                // Create the XHR request
                var request = new XMLHttpRequest();
                // Return it as a Promise
                return new Promise(function (resolve, reject) {
                    // Setup our listener to process compeleted requests
                    request.onreadystatechange = function () {
                        // Only run if the request is complete
                        if (request.readyState !== 4) return;
                        // Process the response
                        if (request.status >= 200 && request.status < 300) {
                            // If successful
                            resolve(request);
                        } else {
                            // If failed
                            reject({
                                status: request.status,
                                statusText: request.statusText
                            });
                        }
            
                    };
                    // Setup our HTTP request
                    request.open('GET', MY_CONSTANT.matriz_flota + '/servicestype/v1/matriz_flota/cupos?access_token='+dataSend.access_token+'&fecha=' + dataSend.fecha +'&tipo_servicio=' + dataSend.tipo_servicio + '&sucursal_id=' + dataSend.sucursal_id, true);
                    //request.open('GET', 'http://localhost:3000/aconcagua', true);
                    // Send the request
                    request.send();
            
                });
            }
        }
    }
})();

/**
 * Created by cl-macmini-51 on 6/23/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('getPromoCodes', getPromoCodes);

    /** @ngInject */
    function getPromoCodes($log, $http, $q, MY_CONSTANT, $cookies, pendingRequests) {
        return {
            addPromoCodes: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/add_promocode",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            editPromoCode: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/update_promocode",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getPromoCode: function (skip, limit, id) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_promocode",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_promocode",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: {
                            limit: limit,
                            offset: skip,
                            promo_id: id,
                            access_token: $cookies.get('obj')
                        },
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_promocode");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_promocode");
                        return deferred.promise;
                    });
            },
            deletePromoCode: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/remove_promo",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getpromoChannelsList: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_promo_channels",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_promo_channels",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: {
                            access_token: $cookies.get('obj')
                        }
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_promo_channels");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_promo_channels");
                        return deferred.promise;
                    });
            },
            getAllBins: function (skip, limit) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_bin_promo",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_bin_promo",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: {
                            limit: limit,
                            offset: skip,
                            access_token: $cookies.get('obj')
                        },
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_bin_promo");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_bin_promo");
                        return deferred.promise;
                    });
            },
            getPromoListForBin: function (key) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_promo_list_bin",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_promo_list_bin",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: {
                            key: key,
                            access_token: $cookies.get('obj')
                        },
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_promo_list_bin");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_promo_list_bin");
                        return deferred.promise;
                    });
            },
            addBinPromo: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/add_bin_promo",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            binDelete: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/remove_bin_promo",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            editBin: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/update_bin_promo",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            addCouponPromo: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/add_coupon_promo",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            editCouponPromo: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/update_coupon_promo",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getCouponsList: function (skip, limit) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_coupon_promo",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_coupon_promo",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: {
                            limit: limit,
                            offset: skip,
                            access_token: $cookies.get('obj')
                        },
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_coupon_promo");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_coupon_promo");
                        return deferred.promise;
                    });
            },
            allCoupons: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_export_coupon_promo",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_export_coupon_promo",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_export_coupon_promo");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_export_coupon_promo");
                        return deferred.promise;
                    });
            },
            getpromoChannelsListNew: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_payment_method_channels",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_payment_method_channels",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: {
                            access_token: $cookies.get('obj')
                        }
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_payment_method_channels");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_payment_method_channels");
                        return deferred.promise;
                    });
            },
        }
    }

})();
/**
 * Created by cl-macmini-51 on 9/8/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('getProduction', getProduction);

    /** @ngInject */
    function getProduction($log, $http, $q, MY_CONSTANT, $cookies,pendingRequests) {
        return {
            summaryProduction: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_production_summary_vehicle",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_production_summary_vehicle",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: dataSend,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_production_summary_vehicle");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_production_summary_vehicle");
                        return deferred.promise;
                    });
            },
            detailedProduction: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_detail_summary_vehicle",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_detail_summary_vehicle",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: dataSend,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_detail_summary_vehicle");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_detail_summary_vehicle");
                        return deferred.promise;
                    });
            },
            vechicleReport: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/weekly_report_mini",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getVehicleReport: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/generate_mini_report",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/generate_mini_report",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: dataSend,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/generate_mini_report");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/generate_mini_report");
                        return deferred.promise;
                    });
            },
        }
    }
})();
/**
 * Created by cl-macmini-51 on 18/12/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .service('pendingRequests', pendingRequests);

    /** @ngInject */
    function pendingRequests($log, $http, $q, MY_CONSTANT, $cookies) {
        var pending = [];
        return {
            get: function() {
                return pending;
            },
            add: function(request) {
                pending.push(request);
            },
            remove: function(request) {
                pending = _.filter(pending, function(p) {
                    return p.url !== request;
                });
            },
            cancelAll: function() {
                angular.forEach(pending, function(p) {
                    p.canceller.resolve();
                });
                pending.length = 0;
            }
        }
    }
})();
/**
 * Created by cl-macmini-51 on 5/15/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .service('getPaymentMethods', getPaymentMethods);

    /** @ngInject */
    function getPaymentMethods($log, $http, $q, MY_CONSTANT, $cookies,pendingRequests) {
        return {
            allMethods: function(filter,skip, limit) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_payment_methods",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_payment_methods",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: {
                        access_token: $cookies.get('obj'),
                        limit: limit,
                        offset: skip,
                        key: Number(filter)

                    },
                    timeout: deferred.promise
                })
                    .then(function(data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_payment_methods");
                        return deferred.promise;
                    })
                    .catch(function(msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_payment_methods");
                        return deferred.promise;
                    });
            },
            methodDetails: function(id) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_payment_methods_details",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_payment_methods_details",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: {
                        access_token: $cookies.get('obj'),
                        payment_methods_id: id
                    },
                    timeout: deferred.promise
                })
                    .then(function(data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_payment_methods_details");
                        return deferred.promise;
                    })
                    .catch(function(msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_payment_methods_details");
                        return deferred.promise;
                    });
            },
            addMethod: function(dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/add_payment_methods",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function(data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function(msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            }
            ,
            updateMethod: function(dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/update_payment_methods",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function(data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function(msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            deletePaymentMethod: function(dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/delete_payment_method",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function(data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function(msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            }
        }
    }
})();
/**
 * Created by cl-macmini-51 on 4/18/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('getOperationPoint', getOperationPoint);

    /** @ngInject */
    function getOperationPoint($log, $http, $q, MY_CONSTANT, $cookies,pendingRequests) {
        return {
            registerOperation: function(dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/add_operation_point",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            editOperation: function(dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/edit_operation_point",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            blockUnblockOperation: function(dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/block_unblock_point",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            deleteOperation: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/delete_operation_point",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            addUserToOperation: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/add_admin_to_point",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            changeUserToOperation: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/change_admin_on_point",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getOperation: function (data) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_operation_point",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_operation_point",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: data,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_operation_point");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_operation_point");
                        return deferred.promise;
                    });
            },
            getOperationList: function (data) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_operation_point_list",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_operation_point_list",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: data,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_operation_point_list");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_operation_point_list");
                        return deferred.promise;
                    });
            },
            addAddress: function(dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/add_point_of_sale_addresses",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            addAgrrement: function(dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/add_default_customer_in_contract_for_pos",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            deleteAddress: function(dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/delete_point_of_sale_addresses",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            deleteAgreement: function(dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/delete_default_customer_in_contract_for_pos",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getOperatioUserList: function (data) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_admin_of_point",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_admin_of_point",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: data,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_admin_of_point");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_admin_of_point");
                        return deferred.promise;
                    });
            },
            getAddress: function (data) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_point_of_sale_addresses",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_point_of_sale_addresses",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: data,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_point_of_sale_addresses");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_point_of_sale_addresses");
                        return deferred.promise;
                    });
            },
            searchCustomer: function (data) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/search_customer_based_on_contract",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/search_customer_based_on_contract",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: data,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/search_customer_based_on_contract");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/search_customer_based_on_contract");
                        return deferred.promise;
                    });
            },
            getAgreement: function (data) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_default_customer_in_contract_for_pos",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_default_customer_in_contract_for_pos",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: data,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_default_customer_in_contract_for_pos");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_default_customer_in_contract_for_pos");
                        return deferred.promise;
                    });
            }




        }
    }
})();

/**
 * Created by cl-macmini-51 on 24/10/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .service('getNoShowReason', getNoShowReason);

    /** @ngInject */
    function getNoShowReason($log, $http, $q, MY_CONSTANT, $cookies,pendingRequests) {
        return {
            getNoShowReasonList: function (data) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_NOSHOW_reasons",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_NOSHOW_reasons",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: data,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_NOSHOW_reasons");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_NOSHOW_reasons");
                        return deferred.promise;
                    });
            },
            addNoShowReason: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/add_NOSHOW_reasons",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            editNoShowReason: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/update_NOSHOW_reasons",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            statusNoShowReason: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/block_unblock_NOSHOW_reasons",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            deleteCorrectFareReason: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/delete_NOSHOW_reasons",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            }
        }
    }
})();
/**
 * Created by cl-macmini-51 on 5/29/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .service('getItemOfCharge', getItemOfCharge);

    /** @ngInject */
    function getItemOfCharge($log, $http, $q, MY_CONSTANT, $cookies,pendingRequests) {
        return {
            getItemOfChargePagination: function (skip,limit,filter) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_all_item_of_charges",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_all_item_of_charges",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: {
                        limit: limit,
                        offset: skip,
                        access_token: $cookies.get('obj'),
                        key: Number(filter)
                    },
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_all_item_of_charges");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_all_item_of_charges");
                        return deferred.promise;
                    });
            },
            getHeadingOfCharge: function (skip,limit,filter) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_all_item_of_charges",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_all_item_of_charges",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: {
                        limit: 0,
                        offset: 0,
                        access_token: $cookies.get('obj'),
                        key: 2
                    },
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_all_item_of_charges");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_all_item_of_charges");
                        return deferred.promise;
                    });
            },
            getItemOfChargeNew: function (data) {
                
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_item_of_charegs_report",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_item_of_charegs_report",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: {
                        limit: data.limit,
                        offset: data.offset,
                        time_form: data.time_from,
                        time_upto: data.time_upto,
                        access_token: $cookies.get('obj'),
                    },
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_item_of_charegs_report");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_item_of_charegs_report");
                        return deferred.promise;
                    });
            },
            exportCsv: function (data) {
                
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_item_of_charegs_report_csv",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_item_of_charegs_report_csv",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: {
                        time_form: data.time_from,
                        time_upto: data.time_upto,
                        access_token: $cookies.get('obj'),
                        socket: data.socket
                    },
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_item_of_charegs_report_csv");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_item_of_charegs_report_csv");
                        return deferred.promise;
                    });
            },
            addItemOfCharge: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/add_item_of_charge",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            addFixedItemOfCharge: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/add_item_of_charge_fixed",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            addVariableItemOfCharge: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/add_item_of_charge_variable",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            editItemOfCharge: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/update_item_of_charge",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            deleteItemOfCharge: function(dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/delete_item_of_charge",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function(data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function(msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            geofenceForParticularAgreemnt: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/regions_for_agreement",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/regions_for_agreement",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: {
                        access_token: $cookies.get('obj'),
                        region_id:  dataSend.region_id,
                        contract_variable_pricing_id: dataSend.contract_variable_pricing_id
                    },
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/regions_for_agreement");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/regions_for_agreement");
                        return deferred.promise;
                    });
            },
            addGeofenceForParticularVariable: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/add_geofence_for_region",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
        }
    }
})();
/**
 * Created by cl-macmini-51 on 12/12/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('helpDocumentService', helpDocumentService);

    /** @ngInject */
    function helpDocumentService($log, $http, $q, MY_CONSTANT, $cookies,pendingRequests) {
        return {
            addDocument: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/add_help_documents",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            updateDocument: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/update_help_documents",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getDocument: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_help_documents",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_help_documents",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: dataSend,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_help_documents");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_help_documents");
                        return deferred.promise;
                    });
            },
            getDocumentName: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_document_names",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_document_names",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: dataSend,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_document_names");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_document_names");
                        return deferred.promise;
                    });
            }
        }
    }
})();
/**
 * Created by cl-macmini-51 on 08/03/18.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('groupedRouteAssignment', groupedRouteAssignment);

    /** @ngInject */
    function groupedRouteAssignment($log, $http, $q, MY_CONSTANT, $cookies, pendingRequests) {
        return {
            getGroupedBookings: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/filter_grouped_bookings",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/filter_grouped_bookings",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/filter_grouped_bookings");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/filter_grouped_bookings");
                        return deferred.promise;
                    });
            },
            validateGroupedServices: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/validate_group_package",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            groupedServicePackage: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/create_group_package",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            checkPassengerLimit: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/check_passenger_limit",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            groupedModifyPackage: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/modify_group_package",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            discardBooking: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/discard_undiscard_booking",
                        method: 'POST',
                        headers: {
                            'content-language': 'en'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            enviarVoucherApi: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/send_voucher_to_package_passengers",
                        method: 'POST',
                        headers: {
                            'content-language': 'en'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            }
        }
    }
})();
/**
 * Created by Ashish Garg.
 */
(function () {
    'use strict';
    angular.module('transVipMain')
        .factory('Initializer', function ($window, $q, MY_CONSTANT) {

            //Google's url for async maps initialization accepting callback function
            var asyncUrl = 'https://maps.googleapis.com/maps/api/js?key=' + MY_CONSTANT.googleApiKey + '&libraries=drawing,places,geometry&callback=',
                mapsDefer = $q.defer();

            $window.googleMapsInitialized = mapsDefer.resolve;

            //Async loader
            var asyncLoad = function (asyncUrl, callbackName) {
                var script = document.createElement('script');
                //script.type = 'text/javascript';
                script.src = asyncUrl + callbackName;
                document.body.appendChild(script);

                script.onload = function () {
                    // document.body.appendChild(script);
                    var scriptForGMap = document.createElement('script');
                    scriptForGMap.type = 'text/javascript';
                    scriptForGMap.src =
                        "https://cdn.sobekdigital.com/includes/gmaps-markerwithlabel/1.9.1/gmaps-markerwithlabel-1.9.1.js";
                    document.body.appendChild(scriptForGMap);

                    var scriptJsMap = document.createElement('script');
                    scriptJsMap.type = 'text/javascript';
                    scriptJsMap.src =
                        "https://cdn.rawgit.com/googlemaps/js-map-label/gh-pages/src/maplabel.js";
                    document.body.appendChild(scriptJsMap);
                };

            };

            //Start loading google maps
            asyncLoad(asyncUrl, 'googleMapsInitialized');

            //Usage: Initializer.mapsInitialized.then(callback)
            return {
                mapsInitialized: mapsDefer.promise
            };
        })

})();
/**
 * Created by cl-macmini-51 on 5/19/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('globalParams', globalParams);

    /** @ngInject */
    function globalParams($log, $http, $q, MY_CONSTANT, $cookies,pendingRequests) {
        return {
            addGlobalParams: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/add_status_parameter",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getGlobalParams: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_status_parameter",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_status_parameter",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    timeout: deferred.promise,
                    params: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_status_parameter");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_status_parameter");
                        return deferred.promise;
                    });
            }
        }
    }
})();
/**
 * Created by cl-macmini-51 on 5/19/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('getGeofence', getGeofence);

    /** @ngInject */
    function getGeofence($log, $http, $q, MY_CONSTANT, $cookies, pendingRequests) {
        return {
            branchGeofenceAdd: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/add_transvip_region",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            branchGeofenceAddAutoAssign: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/add_auto_assignment_region",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            autoAssign: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/auto_assignment_push_drivers",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getAllBranchList: function (filter) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/view_transvip_regions",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/view_transvip_regions",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: {
                            access_token: $cookies.get('obj'),
                            key: Number(filter)
                        },
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/view_transvip_regions");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/view_transvip_regions");
                        return deferred.promise;
                    });
            },
            getAllBranchListForPopup: function (filter, limit, offset, searchString, sortByString, sortByASCOrDESC) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/v2/view_transvip_regions",
                    canceller: deferred
                });
                var data = {
                    access_token: $cookies.get('obj'),
                    key: Number(filter),
                    limit: limit,
                    offset: offset
                }
                if (searchString) {
                    data.search_value = searchString;
                }
                if (sortByString && sortByASCOrDESC) {
                    data.sortBy = sortByString + ' ' + sortByASCOrDESC;
                }
                return $http({
                        url: MY_CONSTANT.url + "/v2/view_transvip_regions",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: data,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/v2/view_transvip_regions");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/v2/view_transvip_regions");
                        return deferred.promise;
                    });
            },
            getAllBranchListForPopupAutoAssign: function (filter, limit, offset, searchString, sortByString, sortByASCOrDESC, sucursal_id) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/view_auto_assignment_regions",
                    canceller: deferred
                });
                var data = {
                    access_token: $cookies.get('obj'),
                    key: Number(filter),
                    limit: limit,
                    skip: offset,
                    sucursal_id: sucursal_id
                }
                if (searchString) {
                    data.search_value = searchString;
                }
                if (sortByString && sortByASCOrDESC) {
                    data.sortBy = sortByString + ' ' + sortByASCOrDESC;
                }
                return $http({
                        url: MY_CONSTANT.url + "/view_auto_assignment_regions",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: data,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/view_auto_assignment_regions");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/view_auto_assignment_regions");
                        return deferred.promise;
                    });
            },
            getAllBranchListNew: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/listing_of_branches",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/listing_of_branches",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/listing_of_branches");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/listing_of_branches");
                        return deferred.promise;
                    });
            },
            editBranchList: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/edit_transvip_region",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            editBranchListAutoAssignment: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/edit_auto_assignment_region",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            addFixedRoute: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/add_fixed_routes",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            editFixedRoute: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/edit_fixed_routes",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            removeRegion: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/removeTransVipRegionParent",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            removeRegionAutoAssign: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/remove_auto_assignment_region",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            activeInactiveRegion: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/activeInTransVipRegionParent",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            blockUnblockAutoAssignmentRegion: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/block_unblock_auto_assignment_region",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getAllFixedRoute: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_all_fixed_routes",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_all_fixed_routes",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_all_fixed_routes");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_all_fixed_routes");
                        return deferred.promise;
                    });
            },
            getAllFixedRouteNew: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_all_fixed_routes_without_details",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_all_fixed_routes_without_details",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_all_fixed_routes_without_details");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_all_fixed_routes_without_details");
                        return deferred.promise;
                    });
            },
            getAllFixedRouteAgreementSearch: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_all_fixed_routes_for_agreement",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_all_fixed_routes_for_agreement",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_all_fixed_routes_for_agreement");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_all_fixed_routes_for_agreement");
                        return deferred.promise;
                    });
            },
            branch: function () {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_branches",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_branches",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: {
                            access_token: $cookies.get('obj')
                            //fleet_status: fleet_status
                        }
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_branches");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_branches");
                        return deferred.promise;
                    });
            },
            deleteFixedRoute: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/delete_fixed_routes",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },

            // Illuminated Zone service
            illuminatedZoneBranchAdd: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/add_transvip_illuminated_region",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getAllIlluminatedZoneBranchList: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/view_transvip_illuminated_regions",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/view_transvip_illuminated_regions",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/view_transvip_illuminated_regions");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/view_transvip_illuminated_regions");
                        return deferred.promise;
                    });
            },
            editIlluminatedZoneList: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/edit_transvip_illuminated_region",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            removeIlluminationZone: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/remove_transvip_illuminated_region",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            blockUnblockIlluminationZone: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/block_unblock_illuminated_region",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getilluminatedRegionsList: function (dataToSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/get_illuminated_zones_for_branch",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataToSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getilluminatedZoneServices: function (dataToSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/get_illuminated_zone_services",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataToSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            SearchVechileByID: function (dataToSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/get_driver_details_search",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataToSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getDriverOfSelectedService: function (dataToSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/view_illuminated_zone_data_admin",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataToSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getDriverOfSelectedServiceLogs: function (dataToSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/view_illuminated_zone_data_logs",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataToSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getAllGeoFences: function (dataToSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/view_transvip_regions_details",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataToSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            findAutoassignRegions: function (dataToSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/find_auto_assignment_regions",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataToSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },

            addSpecialDirections: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/add_addresses_in_db",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            addDriverMaunally: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/manually_add_driver_queue",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getSpecialAddress: function (dataToSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/get_addresses_from_db",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataToSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            editSpecialAddress: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/update_addresses_in_db",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            bookingIdToShow: function (dataToSend) {
                console.log('>>>>>>> IN SERVICE >>>>', dataToSend);
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_jobs_id_from_db",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_jobs_id_from_db",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: {
                            access_token: $cookies.get('obj'),
                            address_id: Number(dataToSend)
                        },
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_jobs_id_from_db");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_jobs_id_from_db");
                        return deferred.promise;
                    });
            },
            deleteSpecialAddress: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/delete_addresses_from_db",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            branchGeofenceAddHeatMap: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/heatmap/addRegion",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            editBranchListHeatMap: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/heatmap/editRegion",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getAllBranchListForPopupHeatMap: function (filter, limit, offset, searchString, sortByString, sortByASCOrDESC) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/heatmap/viewRegions",
                    canceller: deferred
                });
                var data = {
                    access_token: $cookies.get('obj'),
                    flag: Number(filter),
                    limit: limit,
                    offset: offset
                }
                if (searchString) {
                    data.search_value = searchString;
                }
                if (sortByString && sortByASCOrDESC) {
                    data.sortBy = sortByString + ' ' + sortByASCOrDESC;
                }
                return $http({
                        url: MY_CONSTANT.url + "/heatmap/viewRegions",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: data,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/heatmap/viewRegions");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/heatmap/viewRegions");
                        return deferred.promise;
                    });
            },
            activeInactiveRegionHeadMap: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/heatmap/activeInactiveRegion",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            removeRegionHeatMap: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/heatmap/deleteRegion",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getAllGeoFencesHeatMap: function (dataToSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/heatmap/viewRegionDetails",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataToSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getParentHeatMap: function (dataToSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/heatmap/viewRegionParent",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataToSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getRoutingApi: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/getPickupRangeMethod",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/getPickupRangeMethod",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/getPickupRangeMethod");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/getPickupRangeMethod");
                        return deferred.promise;
                    });
            },
            getPetRoles: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/getAdminAccess",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/getAdminAccess",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/getAdminAccess");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/getAdminAccess");
                        return deferred.promise;
                    });
            },
            viewTransvipIlluminatedRegionsRestriction: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/view_transvip_illuminated_regions_restriction",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            editTransvipIlluminatedRegionsRestriction: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/edit_transvip_illuminated_region_restriction",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getilluminatedZoneServicesNew: function (dataToSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/get_vehicle_type_all",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataToSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
 
        }
    }
})();

/**
 * Created by cl-macmini-51 on 10/11/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .service('generatePaymentStatus', generatePaymentStatus);

    /** @ngInject */
    function generatePaymentStatus($log, $http, $q, MY_CONSTANT, $cookies,pendingRequests) {
        return {
            getGeneratePaymentStatusList: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/generate_payment_report",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/generate_payment_report",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: dataSend,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/generate_payment_report");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/generate_payment_report");
                        return deferred.promise;
                    });
            },
            getGeneratePaymentStatusList_1: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/generate_testing_report",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/generate_testing_report",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: dataSend,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/generate_testing_report");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/generate_testing_report");
                        return deferred.promise;
                    });
            },
            getRejectLogs: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_reject_logs",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_reject_logs",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: dataSend,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_reject_logs");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_reject_logs");
                        return deferred.promise;
                    });
            },
            getOperationalReport: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/generate_payment_report_new",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/generate_payment_report_new",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: dataSend,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/generate_payment_report_new");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/generate_payment_report_new");
                        return deferred.promise;
                    });
            },
        }
    }

})();
/**
 * Created by cl-macmini-51 on 5/18/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('gaussControlService', gaussControlService);

    /** @ngInject */
    function gaussControlService($log, $http, $q, MY_CONSTANT, $cookies, pendingRequests) {
        return {
            getGaussControlData: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/admin/get_guass_control_info",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                .then(function (data) {
                    deferred.resolve({
                        title: data.data
                    });
                    return deferred.promise;
                })
                .catch(function (msg) {
                    deferred.reject(msg);
                    return deferred.promise;
                });
            },
            
            updateGaussControl: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/update_guass_control_info",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
        }
    }
})();
/**
 * Created by cl-macmini-51 on 23/02/18.
 */
 (function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('fleetCapacityMatrixService', fleetCapacityMatrixService);

    /** @ngInject */
    function fleetCapacityMatrixService($log, $http, $q, MY_CONSTANT, $cookies,pendingRequests) {
        return {
            addMatrix: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.matriz_flota + "/servicestype/v1/matriz_flota",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            addException: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/matriz_flota_excepcion",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            updateMatrix: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.matriz_flota + "/servicestype/v1/matriz_flota/"+ dataSend.id,
                    method: 'PUT',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            deleteMatrix: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.matriz_flota + "/servicestype/v1/matriz_flota/"+ dataSend.id,
                    method: 'DELETE',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            activeMatrix: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.matriz_flota + "/servicestype/v1/matriz_flota/"+ dataSend.id + "/" + dataSend.status,
                    method: 'PATCH',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getMatrices: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.matriz_flota + "/servicestype/v1/matriz_flota",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.matriz_flota + "/servicestype/v1/matriz_flota",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: dataSend,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.matriz_flota + "/servicestype/v1/matriz_flota");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.matriz_flota + "/servicestype/v1/matriz_flota");
                        return deferred.promise;
                    });
            },
            getMatriz: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.matriz_flota + "/servicestype/v1/matriz_flota/"+ dataSend.id,
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.matriz_flota + "/servicestype/v1/matriz_flota/" + dataSend.id,
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.matriz_flota + "/matriz_flota_detalle/" + dataSend.id);
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.matriz_flota + "/matriz_flota_detalle/" + dataSend.id);
                        return deferred.promise;
                    });
            },
            getTypeOfServiceUsed: function (dataSend) {
                var deferred = $q.defer();
                var addId = "";
                if(dataSend.id !== undefined) {
                    addId = "/"+ dataSend.id
                }
                pendingRequests.add({
                    url:  MY_CONSTANT.matriz_flota + "/servicestype/v1/type_of_service/matrizflota/"+ dataSend.branch_id + addId,
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.matriz_flota + "/servicestype/v1/type_of_service/matrizflota/" + dataSend.branch_id + addId,
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.matriz_flota + "/servicestype/v1/type_of_service/matrizflota/" + dataSend.branch_id + addId);
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.matriz_flota + "/servicestype/v1/type_of_service/matrizflota/" + dataSend.branch_id + addId);
                        return deferred.promise;
                    });
            },
            getCalendar: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.matriz_flota + "/servicestype/v1/matriz_flota/calendario",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.matriz_flota + "/servicestype/v1/matriz_flota/calendario",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: dataSend,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.matriz_flota + "/servicestype/v1/matriz_flota/calendario");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.matriz_flota + "/servicestype/v1/matriz_flota/calendario");
                        return deferred.promise;
                    });
            },
            getException: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/matriz_flota_excepcion",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/matriz_flota_excepcion",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: dataSend,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/matriz_flota_excepcion");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/matriz_flota_excepcion");
                        return deferred.promise;
                    });
            },
            deleteExcep: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/matriz_flota_excepcion",
                    method: 'DELETE',
                    headers: {
                        'content-language': 'es'
                    },
                    params: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
        }
    }
})();

/**
 * Created by cl-macmini-51 on 4/18/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .factory('getFilters', getFilters);

    /** @ngInject */
    function getFilters($log, $http, $q, MY_CONSTANT, $cookies, pendingRequests) {
        var allFiltersData = [];
        var a = {};
        var filterObject = {
            branch_filter: 1,
            vehicle_filter: 1,
            service_filter: 1,
            agreement_filter: 1,
            corporate_filter: 1,
            service_category: 1,
            corporate_status: 1,
            agreement_status: 1,
            vehicle__status: 1,
            operation_point_filter: 1,
        }
        // getAllFilterData(filterObject);
        var obj = {
            branchesFiltersData: {},
            vehiclesFiltersData: {},
            servicesFiltersData: {},
            aggrementsFiltersData: {},
            corporateFiltersData: {},
            // getAllFilterData: function (filterObject) {
            //     var deferred = $q.defer();
            //     pendingRequests.add({
            //         url: MY_CONSTANT.url + "/get_filters",
            //         canceller: deferred
            //     });
            //     return $http({
            //             url: MY_CONSTANT.url + "/get_filters",
            //             method: 'GET',
            //             headers: {
            //                 'content-language': 'es'
            //             },
            //             params: {
            //                 access_token: $cookies.get('obj'),
            //                 branch_filter: filterObject.branch_filter,
            //                 vehicle_filter: filterObject.vehicle_filter,
            //                 service_filter: filterObject.service_filter,
            //                 agreement_filter: filterObject.agreement_filter,
            //                 corporate_filter: filterObject.corporate_filter,
            //                 service_category: filterObject.service_category,
            //                 corporate_status: filterObject.corporate_status,
            //                 agreement_status: filterObject.agreement_status,
            //                 vehicle__status: filterObject.vehicle__status,
            //                 operation_point_filter: filterObject.operation_point_filter,
            //                 limit: 10,
            //                 offset: 0
            //             },
            //             timeout: deferred.promise
            //         })
            //         .then(function (data) {
            //             deferred.resolve({
            //                 title: data.data
            //             });
            //             pendingRequests.remove(MY_CONSTANT.url + "/get_filters");
            //             allFiltersData = data.data;
            //             obj.branchesFiltersData = data.data.branches;
            //             obj.vehiclesFiltersData = data.data.vehicles;
            //             obj.servicesFiltersData = data.data.services;
            //             obj.aggrementsFiltersData = data.data.agreements;
            //             obj.corporateFiltersData = data.data.corporates;
            //         })
            //         .catch(function (msg) {
            //             deferred.reject(msg);
            //             pendingRequests.remove(MY_CONSTANT.url + "/get_filters");
            //         });
            // },
            getAllFilterData: function (filterObject) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_filters",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_filters",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: filterObject,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_filters");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_filters");
                        return deferred.promise;
                    });
            }
        };
        return obj;
    }
})();
/**
 * Created by cl-macmini-51 on 5/19/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('factorMultiplicadorService', factorMultiplicadorService);

    /** @ngInject */
    function factorMultiplicadorService($log, $http, $q, MY_CONSTANT, $cookies, pendingRequests) {
        return {
            addMatrix: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.priceUrl + "/pricing/v1/matriz",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            updateInstance: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/autoassign_instance",
                    method: 'PUT',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getDetailUpdate: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/autoassign_instance",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/autoassign_instance",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: dataSend,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/autoassign_instance");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/autoassign_instance");
                        return deferred.promise;
                    });
            },
            addGlobalParams: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/add_status_parameter",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getTypeOfService: function (skip, limit, filter, list) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_type_of_service",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_type_of_service",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: {
                        access_token: $cookies.get('obj'),
                        limit: limit,
                        offset: skip,
                        key: Number(filter),
                        all_list: Number(list)
                    },
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_type_of_service");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_type_of_service");
                        return deferred.promise;
                    });

            },
            getMatrices: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.priceUrl + "/pricing/v1/matriz",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.priceUrl + "/pricing/v1/matriz",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: dataSend,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.priceUrl + "/pricing/v1/matriz");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.priceUrl + "/pricing/v1/matriz");
                        return deferred.promise;
                    });
            },
            activarMatriz: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.priceUrl + "/pricing/v1/matriz",
                    method: 'PUT',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            eliminarMatriz: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.priceUrl + "/pricing/v1/matriz/"+ dataSend.id,
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getMatriz: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.priceUrl + "/pricing/v1/matriz/list",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.priceUrl + "/pricing/v1/matriz/list",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: dataSend,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.priceUrl + "/pricing/v1/matriz/list");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.priceUrl + "/pricing/v1/matriz/list");
                        return deferred.promise;
                    });
            },
            getDataCalendar: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.priceUrl + "/pricing/v1/matriz/calendar",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.priceUrl + "/pricing/v1/matriz/calendar",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: dataSend,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.priceUrl + "/pricing/v1/matriz/calendar");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.priceUrl + "/pricing/v1/matriz/calendar");
                        return deferred.promise;
                    });
            },
        }
    }
})();

/**
 * Created by cl-macmini-51 on 5/2/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('getExpenseControlData', getExpenseControlData);

    /** @ngInject */
    function getExpenseControlData($log, $http, $q, MY_CONSTANT, $cookies, pendingRequests) {
        return {
            updateCorporateBudget: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/update_corporate_budget_warning",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getDataForChart: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_corporate_budget_data",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_corporate_budget_data",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_corporate_budget_data");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_corporate_budget_data");
                        return deferred.promise;
                    });
            }
        }
    }
})();
/**
 * Created by cl-macmini-51 on 6/7/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('DriverPushesService', DriverPushesService);

    /** @ngInject */
    function DriverPushesService($log, $http, $q, MY_CONSTANT, $cookies, pendingRequests) {
        return {
            getBuscarDriverData: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/notification/getDiversListBySearchValue",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: {
                            access_token: $cookies.get('obj'),
                            search_value: dataSend.search_value,
                            unique_car_id: dataSend.unique_car_id,
                            group_id: dataSend.group_id
                        }
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getDriverList: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/notification/getAllDrivers",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: {
                            access_token: $cookies.get('obj'),
                            limit: dataSend.limit,
                            offset: dataSend.offset,
                            search_value: dataSend.search_value,
                            unique_car_id: dataSend.unique_car_id
                        }
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            addGroupDrivers: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/notification/addGroup",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: {
                            access_token: $cookies.get('obj'),
                            group_name: dataSend.group_name,
                            group_description: dataSend.group_description,
                            fleet_list: dataSend.fleet_list
                        }
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getGroupDrivers: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/notification/getGroupList",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: {
                            access_token: $cookies.get('obj'),
                            limit: dataSend.limit,
                            offset: dataSend.offset,
                            search_value: dataSend.search_value
                        }
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getGroupDriversVeiw: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/notification/getGroupDriver",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: {
                            access_token: $cookies.get('obj'),
                            group_id: dataSend.group_id,
                            limit: dataSend.limit,
                            offset: dataSend.offset,
                            search_value: dataSend.search_value,
                            unique_car_id: dataSend.unique_car_id
                        }
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getValidateDriverForVechicle: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/notification/validateFilter",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: {
                            // access_token: $cookies.get('obj'),
                            region_id: (dataSend.region_id).toString(),
                            id: (dataSend.id).toString()
                        }
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            DriverDetails: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/notification/viewGroupDetails",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: {
                            access_token: $cookies.get('obj'),
                            group_id: dataSend.group_id,
                        }
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            editGroupDrivers: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/notification/editGroup",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: {
                            access_token: $cookies.get('obj'),
                            group_id: dataSend.group_id,
                            group_name: dataSend.group_name,
                            group_description: dataSend.group_description,
                            // fleet_list : dataSend.fleet_list
                        }
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            deleteGroupDrivers: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/notification/deleteGroup",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: {
                            access_token: $cookies.get('obj'),
                            group_id: dataSend.group_id,
                        }
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            deleteParticularGroupDriver: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/notification/deleteDriverFromGroup",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: {
                            access_token: $cookies.get('obj'),
                            group_id: dataSend.group_id,
                            fleet_id: dataSend.fleet_id
                        }
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            searchParticularGroupDriver: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/notification/searchDriverInGroup",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: {
                            access_token: $cookies.get('obj'),
                            group_id: dataSend.group_id,
                            fleet_id: dataSend.fleet_id,
                            search_value: dataSend.search_value,
                            unique_car_id: dataSend.unique_car_id
                        }
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            sendPushToDriver: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/notification/sendBulkPushToDrivers",
                        method: 'POST',
                        headers: {
                            'content-type': undefined,
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getHistoryLogs: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/notification/getBulkNotificationLogs",
                        method: 'POST',
                        headers: {
                            // 'content-type': undefined,
                            'content-language': 'es'
                        },
                        data: {
                            access_token: $cookies.get('obj'),
                            limit: dataSend.limit,
                            offset: dataSend.offset,
                            search_value: dataSend.search_value,
                        }
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            addDriverToGroup: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/notification/addDriverToGroup",
                        method: 'POST',
                        headers: {
                            // 'content-type': undefined,
                            'content-language': 'es'
                        },
                        data: {
                            access_token: $cookies.get('obj'),
                            group_id: dataSend.group_id,
                            fleet_list: dataSend.fleet_list,
                        }
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getBulkNotificationFleetLogsApi: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/notification/getBulkNotificationFleetLogs",
                        method: 'POST',
                        headers: {
                            // 'content-type': undefined,
                            'content-language': 'es'
                        },
                        data: {
                            access_token: $cookies.get('obj'),
                            log_id: dataSend.log_id,
                            limit: dataSend.limit,
                            offset: dataSend.offset,
                            search_value: dataSend.search_value,
                            unique_car_id: dataSend.unique_car_id
                        }
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            addDriverMail: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/add_email_template",
                        method: 'POST',
                        headers: {
                            // 'content-type': undefined,
                            'content-language': 'es'
                        },
                        data: {
                            access_token: $cookies.get('obj'),
                            subject: dataSend.subject,
                            static: dataSend.static,
                            body: dataSend.dynamic,
                            fully_html: dataSend.fully_html,
                            type: dataSend.type,
                            image_url : dataSend.image_url
                        }
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getDriverMail: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/get_email_template",
                        method: 'POST',
                        headers: {
                            // 'content-type': undefined,
                            'content-language': 'es'
                        },
                        data: {
                            access_token: $cookies.get('obj'),
                        }
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            editDriverMail: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/edit_email_template",
                        method: 'POST',
                        headers: {
                            // 'content-type': undefined,
                            'content-language': 'es'
                        },
                        data: {
                            access_token: $cookies.get('obj'),
                            subject: dataSend.subject,
                            static: dataSend.static,
                            body: dataSend.dynamic,
                            fully_html: dataSend.fully_html,
                            type: dataSend.type,
                            template_id: dataSend.template_id,
                            image_url : dataSend.image_url
                        }
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            imageUploadApi: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/image_upload",
                        method: 'POST',
                        headers: {
                            'content-type': undefined,
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
        }
    }
})();
/**
 * Created by cl-macmini-51 on 6/22/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .service('getDriverEvaluation', getDriverEvaluation);

    /** @ngInject */
    function getDriverEvaluation($log, $http, $q, MY_CONSTANT, $cookies,pendingRequests) {
        return {
            addDriverEvaluation: function(dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/admin_driver_evaluation",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function(data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function(msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getDriverEvaluationAPI: function (data) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_admin_driver_evaluation",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_admin_driver_evaluation",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: {
                        template: data,
                        access_token: $cookies.get('obj')
                    },
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_admin_driver_evaluation");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_admin_driver_evaluation");
                        return deferred.promise;
                    });
            }
        }
    }

})();
/**
 * Created by cl-macmini-51 on 6/22/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .service('getDriverEarning', getDriverEarning);

    /** @ngInject */
    function getDriverEarning($log, $http, $q, MY_CONSTANT, $cookies,pendingRequests) {
        return {
            addDriverEarning: function(dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/add_driver_earning_matrix",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function(data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function(msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            editDriverEarning: function(dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/update_driver_earning_matrix",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function(data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function(msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getDriverEarningList: function (skip,limit) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_driver_earning_matrix",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_driver_earning_matrix",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: {
                        limit: limit,
                        offset: skip,
                        access_token: $cookies.get('obj')
                    },
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_driver_earning_matrix");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_driver_earning_matrix");
                        return deferred.promise;
                    });
            }
        }
    }

})();
/**
 * Created by cl-macmini-51 on 4/18/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('getDrivers', getDrivers);

    /** @ngInject */
    function getDrivers($log, $http, $q, MY_CONSTANT, $cookies, pendingRequests) {
        return {
            allDrivers: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_all_drivers",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_all_drivers",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_all_drivers");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_all_drivers");
                        return deferred.promise;
                    });
            },
            allDriversWithoutLimit: function () {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_driver_list",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_driver_list",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: {
                            access_token: $cookies.get('obj')
                        },
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_driver_list");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_driver_list");
                        return deferred.promise;
                    });
            },
            singleDriver: function (id) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_driver_info",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_driver_info",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: {
                            access_token: $cookies.get('obj'),
                            fleet_id: id
                        },
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_driver_info");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_driver_info");
                        return deferred.promise;
                    });
            },
            getCloseProduction: function (flag) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_close_production",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_close_production",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: {
                            access_token: $cookies.get('obj'),
                            isClosed: flag
                        },
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_close_production");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_close_production");
                        return deferred.promise;
                    });
            },
            completeCloseProduction: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/close_production",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            sendEmailToDriverResetPassword: function(dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/forgot_password_fleet",
                        method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                        data: dataSend
                    })
                    .then(function(data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function(msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            resetPasswordDriverThroughAdmin: function(dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/reset_password_fleet_by_admin",
                        method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                        data: dataSend
                    })
                    .then(function(data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function(msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            approveDriverSteps: function(dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/update_verify_status",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            approveDriverDocuments: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/verify_fleet_documents",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            blockUnblockDriver: function (id, flag, comments, blocktime, timeZone) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/block_unblock_transvip_fleet",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: {
                            access_token: $cookies.get('obj'),
                            fleet_id: id,
                            block_unblock_comments: comments,
                            is_blocked: flag, // 0-unblock, 1-block,
                            block_hours: blocktime,
                            timezone: timeZone
                        }
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            deleteUser: function (id, $event) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/delete_driver",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: {
                            access_token: $cookies.get('obj'),
                            fleet_id: JSON.stringify(id),
                        }
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            editDocument: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/edit_fleet_documents",
                        method: 'POST',
                        headers: {
                            'content-type': undefined,
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            registerDriver: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/add_transvip_fleet",
                        method: 'POST',
                        headers: {
                            'content-type': undefined,
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            editDriver: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/edit_fleet_data",
                        method: 'POST',
                        headers: {
                            'content-type': undefined,
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            driverFilter: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_drivers_by_filters",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_drivers_by_filters",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_drivers_by_filters");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_drivers_by_filters");
                        return deferred.promise;
                    });
            },
            applicantFilter: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_all_drivers_by_filters",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_all_drivers_by_filters",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_all_drivers_by_filters");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_all_drivers_by_filters");
                        return deferred.promise;
                    });
            },
            getDriverRatingFilteres: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_driver_ratingFilteres",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_driver_ratingFilteres",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_driver_ratingFilteres");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_driver_ratingFilteres");
                        return deferred.promise;
                    });
            },
            onOffDutyApi: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_on_off_data",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_on_off_data",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_on_off_data");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_on_off_data");
                        return deferred.promise;
                    });
            },
            viewOTP: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_otp",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_otp",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_otp");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_otp");
                        return deferred.promise;
                    });
            },
            driverBankNames: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_driver_bank_names",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_driver_bank_names",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_driver_bank_names");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_driver_bank_names");
                        return deferred.promise;
                    });
            },
            sendEmailToCustomerResetPassword: function(dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/forgot_password_customer",
                        method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                        data: dataSend
                    })
                    .then(function(data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function(msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            resetPasswordToCustomer: function(dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/change_customer_password",
                        method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                        data: dataSend
                    })
                    .then(function(data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function(msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            allDriversCsv: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_all_drivers_csv",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_all_drivers_csv",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_all_drivers_csv");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_all_drivers_csv");
                        return deferred.promise;
                    });
            },
            onOffDutyApiCsv: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_on_off_data_csv",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_on_off_data_csv",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_on_off_data_csv");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_on_off_data_csv");
                        return deferred.promise;
                    });
            },
            societiesList: function () {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/get_societies",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: {
                        access_token: $cookies.get('obj'),
                    }
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },


        }
    }
})();
/**
 * Created by cl-macmini-51 on 4/18/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('mapDashboard', mapDashboard);

    /** @ngInject */
    function mapDashboard($log, $http, $q, MY_CONSTANT, $cookies, pendingRequests) {
        return {
            map: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_driver_on_route_V2",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_driver_on_route_V2",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_driver_on_route_V2");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_driver_on_route_V2");
                        return deferred.promise;
                    });
            },
            newMap: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_driver_on_route_new",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_driver_on_route_new",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_driver_on_route_new");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_driver_on_route_new");
                        return deferred.promise;
                    });
            },
            getNearestETAApi: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/nearest_eta_quick_assignment",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/nearest_eta_quick_assignment",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/nearest_eta_quick_assignment");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/nearest_eta_quick_assignment");
                        return deferred.promise;
                    });
            },
            notification: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/send_notification",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getOnOffData: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_fleet_on_off_data",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_fleet_on_off_data",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_fleet_on_off_data");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_fleet_on_off_data");
                        return deferred.promise;
                    });
            },
            markDriverOffDuty: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/set_driver_off_duty",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getNotification: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/get_notifications",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            markNotificationRead: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/read_notifications",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getVehicleOnSearch: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_driver_on_route_search",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_driver_on_route_search",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_driver_on_route_search");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_driver_on_route_search");
                        return deferred.promise;
                    });
            },
            getHomeScreenData: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/get_user_iframes",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
        }
    }

})();
/**
 * Created by cl-macmini-51 on 4/18/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('getCustomers', getCustomers);

    /** @ngInject */
    function getCustomers($log, $http, $q, MY_CONSTANT, $cookies,pendingRequests) {
        return {
            allCustomers: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_all_transvip_customers",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_all_transvip_customers",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_all_transvip_customers");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        pendingRequests.remove(MY_CONSTANT.url + "/get_all_transvip_customers");
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            allCustomerLevels: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_all_customers_levels",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_all_customers_levels",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_all_customers_levels");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        pendingRequests.remove(MY_CONSTANT.url + "/get_all_customers_levels");
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getFavoriteLocation: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_user_favourite_addresses",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_user_favourite_addresses",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_user_favourite_addresses");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_user_favourite_addresses");
                        return deferred.promise;
                    });
            },
            block_unblock: function (customer_id, is_blocked) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/block_unblock_transvip_customers",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: {
                            access_token: $cookies.get('obj'),
                            customer_id: customer_id,
                            is_blocked: is_blocked

                        }
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            addCustomer: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/register_user_admin",
                        headers: {
                            'content-type': undefined,
                            'content-language': 'es'
                        },
                        method: 'POST',
                        data:dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            addCustomerCorporateProfile: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/attach_corporate_account_admin",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data:dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            editCustomerProfile: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/customer_update_profile_admin",
                        method: 'POST',
                        headers: {
                            'content-type': undefined,
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            deleteCustomerProfile: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/delete_customer_transvip",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getCustomerAccordingToSearch: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_customer_by_name_email_phone",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_customer_by_name_email_phone",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_customer_by_name_email_phone");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_customer_by_name_email_phone");
                        return deferred.promise;
                    });
            },
            getPersonAccordingToSearch: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_employee_data_for_someone_else",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_employee_data_for_someone_else",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_employee_data_for_someone_else");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_employee_data_for_someone_else");
                        return deferred.promise;
                    });
            }
        }
    }

})();
/**
 * Created by cl-macmini-51 on 11/10/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .service('getCorrectFareReason', getCorrectFareReason);

    /** @ngInject */
    function getCorrectFareReason($log, $http, $q, MY_CONSTANT, $cookies,pendingRequests) {
        return {
            getCorrectFareReasonList: function (data) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_correct_fare_reasons",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_correct_fare_reasons",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: data,
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_correct_fare_reasons");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_correct_fare_reasons");
                        return deferred.promise;
                    });
            },
            addCorrectFareReason: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/add_correct_fare_reasons",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            editCorrectFareReason: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/update_correct_fare_reasons",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            statusCorrectFareReason: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/block_unblock_correct_fare_reasons",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            deleteCorrectFareReason: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/delete_correct_fare_reasons",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            }
        }
    }
})();
/**
 * Created by cl-macmini-51 on 4/18/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('getCorporate', getCorporate);

    /** @ngInject */
    function getCorporate($log, $http, $q, MY_CONSTANT, $cookies,pendingRequests) {
        return {
            allCorporates: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_corporate_accounts",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_corporate_accounts",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    timeout: deferred.promise,
                    params: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_corporate_accounts");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_corporate_accounts");
                        return deferred.promise;
                    });
            },
            addCorporate: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/add_corporate_account",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    // headers: {
                    //     'content-type': undefined
                    // },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            editCorporate: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/edit_corporate_account",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            }
        }
    }
})();
/**
 * Created by cl-macmini-51 on 5/18/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('controlledWayService', controlledWayService);

    /** @ngInject */
    function controlledWayService($log, $http, $q, MY_CONSTANT, $cookies, pendingRequests) {
        return {
            getControlledWayData: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_controlled_way",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_controlled_way",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_controlled_way");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_controlled_way");
                        return deferred.promise;
                    });
            },
            
            updateControlledWay: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/update_controlled_way",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
        }
    }
})();
/**
 * Created by cl-macmini-51 on 4/28/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('getCommuna', getCommuna);

    /** @ngInject */
    function getCommuna($log, $http, $q, MY_CONSTANT, $cookies) {
        return {
            communaList: function (skip, limit, verificationStatus) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/get_communa",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    //params: {
                    //    access_token: $cookies.get('obj'),
                    //    limit: limit,
                    //    offset: skip,
                    //    driver_status: verificationStatus
                    //}
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            addComuna: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/add_communa",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            }
        }
    }
})();
/**
 * Created by cl-macmini-51 on 5/3/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('getCars', getCars);

    /** @ngInject */
    function getCars($log, $http, $q, MY_CONSTANT, $cookies,pendingRequests) {
        return {
            allCars: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_all_cars",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_all_cars",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    timeout: deferred.promise,
                    params: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_all_cars");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_all_cars");
                        return deferred.promise;
                    });
            },
            carShift: function (id, dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/set_car_shift",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: {
                        access_token: $cookies.get('obj'),
                        car_id: id,
                        shift: dataSend
                    }
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            carGetShift: function (id, start, end) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/get_car_shift",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: {
                        access_token: $cookies.get('obj'),
                        car_id: Number(id),
                        start_date: start,
                        end_date: end
                    }
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            onlineCars: function () {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_cars_list",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_cars_list",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: {
                        access_token: $cookies.get('obj')
                    },
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_cars_list");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_cars_list");
                        return deferred.promise;
                    });
            },
            assignCarToDriver: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/assign_car_to_fleet",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            unassignCarToDriver: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/unassign_car_to_fleet",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            editCarDetails: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/edit_car_details",
                    method: 'POST',
                    headers: {
                        'content-type': undefined,
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            addCarDetails: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/add_new_car",
                    method: 'POST',
                    headers: {
                        'content-language': 'es',
                        'content-type': undefined
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            approveUnapprove: function (id, flag, comments, unique_car_id) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/verify_car",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: {
                        access_token: $cookies.get('obj'),
                        car_id: id,
                        verification_comment: comments,
                        unique_car_id: unique_car_id,
                        verification_status: flag // 0-unapprove, 1-approve
                    }
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            assignedDrivers: function (skip, limit) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/car_fleet_mapping",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: {
                        access_token: $cookies.get('obj'),
                        limit: limit,
                        offset: skip
                    }
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            deleteCar: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/delete_car",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            carModelList: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/admin/view_model",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: {
                        access_token: $cookies.get('obj'),
                        limit: dataSend.limit,
                        skip: dataSend.offset,
                        search_value: dataSend.search_value,
                        is_active: dataSend.is_active
                    }
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            editCarModelList: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/admin/edit_model",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: {
                        access_token: $cookies.get('obj'),
                        name: dataSend.name,
                        model_id: dataSend.model_id,
                        is_deleted : dataSend.is_deleted,
                        is_active : dataSend.is_active
                    }
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            addCarModelList: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/admin/add_model",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: {
                        access_token: $cookies.get('obj'),
                        name: dataSend.name,
                    }
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            carcolorList: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/admin/view_color",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: {
                        access_token: $cookies.get('obj'),
                        limit: dataSend.limit,
                        skip: dataSend.offset,
                        search_value: dataSend.search_value,
                        is_active: dataSend.is_active
                    }
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            editCarColorList: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/admin/edit_color",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: {
                        access_token: $cookies.get('obj'),
                        name: dataSend.name,
                        color_id: dataSend.color_id,
                        code : dataSend.code,
                        is_deleted : dataSend.is_deleted,
                        is_active : dataSend.is_active
                    }
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            addCarColorList: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/admin/add_color",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: {
                        access_token: $cookies.get('obj'),
                        name: dataSend.name,
                        code : dataSend.code
                    }
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            societiesList: function () {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/get_societies",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: {
                        access_token: $cookies.get('obj'),
                    }
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
        }
    }
})();
/**
 * Created by cl-macmini-51 on 6/7/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .service('getCancelReason', getCancelReason);

    /** @ngInject */
    function getCancelReason($log, $http, $q, MY_CONSTANT, $cookies,pendingRequests) {
        return {
            getCancelReasonList: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/get_cancel_reason",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_cancel_reason",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: dataSend,
                    // params: {
                    //     //limit: limit,
                    //     //offset: skip,
                    //     //access_token: $cookies.get('obj')
                    //     key: Number(filter),
                        
                        
                    // },
                    timeout: deferred.promise
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_cancel_reason");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_cancel_reason");
                        return deferred.promise;
                    });
            },
            addCancelReason: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/add_cancel_reason",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            editCancelReason: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/edit_cancel_reason",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            deleteCancelReason: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/delete_cancel_reason",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            }
        }
    }
})();
/**
 * Created by Ashish Garg.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('calenderTranslate', calenderTranslate);

    /** @ngInject */
    function calenderTranslate($log, $http, $q, MY_CONSTANT, $cookies, pendingRequests) {
        var translationObject = {
            "January": "enero",
            "February": "febrero",
            "March": "marzo",
            "April": "abril",
            "May": "Mayo",
            "June": "junio",
            "July": "julio",
            "August": "agosto",
            "September": "septiembre",
            "October": "octubre",
            "November": "noviembre",
            "December": "diciembre",
            
            "enero": "enero",
            "febrero": "febrero",
            "marzo": "marzo",
            "abril": "abril",
            "Mayo": "Mayo",
            "junio": "junio",
            "julio": "julio",
            "agosto": "agosto",
            "septiembre": "septiembre",
            "octubre": "octubre",
            "noviembre": "noviembre",
            "diciembre": "diciembre",

            "Mon": "Lun",
            "Tue": "mar",
            "Wed": "Mie",
            "Thu": "Jue",
            "Fri": "Vie",
            "Sat": "Sab",
            "Sun": "Dom"
        }
        return {
            getTranslatedText: function (textInEnglish) {
                return translationObject[textInEnglish];
            }
        }
    }
})();
/**
 * Created by cl-macmini-51 on 5/2/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('getBookingsHereMaps', getBookingsHereMaps);

    /** @ngInject */
    function getBookingsHereMaps($log, $http, $q, MY_CONSTANT, $cookies, pendingRequests) {
        var apiKeyAconcagua = 'API_KEY_ACME';
        return {
            allBookings: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_bookings",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_bookings",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_bookings");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_bookings");
                        return deferred.promise;
                    });
            },
            allAssignBookings: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_assigned_bookings",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_assigned_bookings",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_assigned_bookings");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_assigned_bookings");
                        return deferred.promise;
                    });
            },
            allAssignBookingsV2: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_assigned_bookings_v1",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_assigned_bookings_v1",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_assigned_bookings_v1");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_assigned_bookings_v1");
                        return deferred.promise;
                    });
            },
            allUnAssignBookings: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_unassigned_bookings",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_unassigned_bookings",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_unassigned_bookings");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_unassigned_bookings");
                        return deferred.promise;
                    });
            },
            allUnAssignBookingsV2: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_unassigned_bookings_v1",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_unassigned_bookings_v1",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_unassigned_bookings_v1");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_unassigned_bookings_v1");
                        return deferred.promise;
                    });
            },
            singleBooking: function (id) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_booking_info",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_booking_info",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: {
                            access_token: $cookies.get('obj'),
                            job_id: id
                        },
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_booking_info");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_booking_info");
                        return deferred.promise;
                    });
            },
            createBooking: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/create_booking_admin",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            modifyBooking: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/modify_booking",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            manualAssignBooking: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/manual_assignment_of_driver",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            manualAssignBookingToFleet: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/assign_fleet_to_transVIP_task",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            checkBeforeAssignDriverApi: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/check_driver_status",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            checkBeforeAssignDriverToJobApi: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/check_driver_status_for_job",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            unassignBookingDriver: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/unassign_transvip_fleet_to_task",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            changeJobStatus: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/change_job_status_admin",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getSpotAgreementForBooking: function () {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_spot_agreement",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_spot_agreement",
                        method: 'GET',
                        headers: {
                            'content-language': 'es',
                            'Content-Type': 'application/json'
                        },
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_spot_agreement");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_spot_agreement");
                        return deferred.promise;
                    });
            },
            getCustomerAdjustAgreemtent: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_customer_agreements",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_customer_agreements",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_customer_agreements");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_customer_agreements");
                        return deferred.promise;
                    });
            },
            getCorporateAgreementForBooking: function(dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_customer_corporate_contract_admin",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_customer_corporate_contract_admin",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_customer_corporate_contract_admin");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_customer_corporate_contract_admin");
                        return deferred.promise;
                    });
            },
            getFixedRoutesForPersonal: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.priceUrl + "/pricing/v1/search_fixed_variable",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.priceUrl + "/pricing/v1/search_fixed_variable",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.priceUrl + "/pricing/v1/search_fixed_variable");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.priceUrl + "/pricing/v1/search_fixed_variable");
                        return deferred.promise;
                    });
            },
            AdjustAgreement: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/edit_customer_agreement",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/edit_customer_agreement",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    timeout: deferred.promise,
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/edit_customer_agreement");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/edit_customer_agreement");
                        return deferred.promise;
                    });
            },
            getRideSummary: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_ride_summary_admin",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_ride_summary_admin",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_ride_summary_admin");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_ride_summary_admin");
                        return deferred.promise;
                    });
            },
            manualReassignBookingToFleet: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/reassign_transvip_fleet_to_task",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getBookingById: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/search_booking_by_id",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/search_booking_by_id",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/search_booking_by_id");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/search_booking_by_id");
                        return deferred.promise;
                    });
            },
            getPreviousAddress: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_previous_addresses",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_previous_addresses",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_previous_addresses");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_previous_addresses");
                        return deferred.promise;
                    });
            },
            sendMassivePush: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/sendMassivePush",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getNearDriver: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/nearsetETA_admin_new",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/nearsetETA_admin_new",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/nearsetETA_admin_new");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/nearsetETA_admin_new");
                        return deferred.promise;
                    });
            },
            adjustFareHit: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/correct_trip_payment_amount",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getNoShowData: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_NOSHOW_data",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_NOSHOW_data",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_NOSHOW_data");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_NOSHOW_data");
                        return deferred.promise;
                    });
            },
            printReceipt: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_thermal_print",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_thermal_print",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_thermal_print");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_thermal_print");
                        return deferred.promise;
                    });
            },
            getAirportZone: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/check_airport_booking",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/check_airport_booking",
                        method: 'GET',
                        timeout: deferred.promise,
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/check_airport_booking");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/check_airport_booking");
                        return deferred.promise;
                    });
            },
            getBookingLocation: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_booking_locations",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_booking_locations",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_booking_locations");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_booking_locations");
                        return deferred.promise;
                    });
            },
            getHeightForPrint: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_thermal_print_height",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_thermal_print_height",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_thermal_print_height");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                    deferred.reject(msg);
                    pendingRequests.remove(MY_CONSTANT.url + "/get_thermal_print_height");
                    return deferred.promise;
                });
            },
            makeCreateBookingPdfHeight: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_booking_email_pdf_height",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_booking_email_pdf_height",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_booking_email_pdf_height");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                    deferred.reject(msg);
                    pendingRequests.remove(MY_CONSTANT.url + "/get_booking_email_pdf_height");
                    return deferred.promise;
                });
            },
            makeCreateBookingPdf: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_booking_email_pdf_link",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_booking_email_pdf_link",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_booking_email_pdf_link");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                    deferred.reject(msg);
                    pendingRequests.remove(MY_CONSTANT.url + "/get_booking_email_pdf_link");
                    return deferred.promise;
                });
            },
            sendVoucherToCustomer: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/resend_voucher",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            viewVoucherOfCustomer: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/create_pdf_of_email_pdf",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            searchBookings: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_bookings_search",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_bookings_search",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_bookings_search");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_bookings_search");
                        return deferred.promise;
                    });
            },
            makePaymentFromSearchApi: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/mark_booking_paid",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            sharedGroupBookings: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_shared_group_packages",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_shared_group_packages",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_shared_group_packages");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_shared_group_packages");
                        return deferred.promise;
                    });
            },
            sharedGroupBookingsById: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_shared_group_packages_by_id",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_shared_group_packages_by_id",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_shared_group_packages_by_id");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_shared_group_packages_by_id");
                        return deferred.promise;
                    });
            },
            checkCustomerIsAllowedInContract: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/customer_contract_check",
                        method: 'POST',
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            autoAssignMassivePush: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/auto_assignment_push_drivers_multiple",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            correctTripPaymentAmountByItem: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/correct_trip_payment_amount_by_item",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            RoutingApi: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/pick_range_calc_routing",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',

                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getAdminListAccordingToRole: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_admin_auth",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_admin_auth",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_admin_auth");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_admin_auth");
                        return deferred.promise;
                    });
            },
            setFavouriteAddress: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/set_favourite_location",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',

                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            validatePassword: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/check_admin",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            setUnFavouriteAddress: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/delete_favourite_location",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },getCancelThermalPrintHeight: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/thermal_height_cancel",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getCancelThermalPrint: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/thermal_height_cancel",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getFavouriteAddress: function (data) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/check_favourite_location",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/check_favourite_location",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: {
                            address: data.address,
                            customer_id: data.customer_id
                        },
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/check_favourite_location");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/check_favourite_location");
                        return deferred.promise;
                    });
            },
            getCancelThermalPrintPdf: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/get_thermal_print_cancel",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getAirportAddress: function (data) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_airport_within_branch",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_airport_within_branch",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params:data,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_airport_within_branch");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_airport_within_branch");
                        return deferred.promise;
                    });
            },
            allUnAssignPackagesV2: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_unassigned_grouped_pakages",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_unassigned_grouped_pakages",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_unassigned_grouped_pakages");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_unassigned_grouped_pakages");
                        return deferred.promise;
                    });
            },
            allAssignPackagesV2: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_assigned_grouped_pakages",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_assigned_grouped_pakages",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_assigned_grouped_pakages");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_assigned_grouped_pakages");
                        return deferred.promise;
                    });
            },
            autoAssignMassivePushGrouped: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/auto_assignment_push_drivers_multiple_grouped",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            validMassiveCreateCSV: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/validate_csv",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',
                            'content-type': undefined
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getBulkCSVData: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/get_bulk_csv_data",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',
                            // 'content-type': undefined
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            tollCostEstimatedRouteHereMaps: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/toll-cost-estimated-route",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',
                            // 'content-type': undefined
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            autoSuggestHereMaps: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/autosuggest",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data :dataSend,
                    timeout: deferred.promise
                })
                .then(function (data) {
                    deferred.resolve({
                        title: data.data
                    });
                    pendingRequests.remove(MY_CONSTANT.url + "/autosuggest");
                    return deferred.promise;
                })
                .catch(function (msg) {
                    deferred.reject(msg);
                    pendingRequests.remove(MY_CONSTANT.url + "/autosuggest");
                    return deferred.promise;
                });
            },
            autoSuggestAconcagua: function (dataSend) {
                // Create the XHR request
                var request = new XMLHttpRequest();
                // Return it as a Promise
                return new Promise(function (resolve, reject) {
                    // Setup our listener to process compeleted requests
                    request.onreadystatechange = function () {
                        // Only run if the request is complete
                        if (request.readyState !== 4) return;
                        // Process the response
                        if (request.status >= 200 && request.status < 300) {
                            // If successful
                            resolve(request);
                        } else {
                            // If failed
                            reject({
                                status: request.status,
                                statusText: request.statusText
                            });
                        }
            
                    };
                    // Setup our HTTP request
                    request.open('GET', MY_CONSTANT.autossugestUrl + '/address/locations?channel=' + dataSend.channel + '&q=' + dataSend.query_string + '&at=' + dataSend.at, true);
                    //request.open('GET', 'http://localhost:3000/aconcagua', true);
                    // Send the request
                    request.send();
            
                });
            },
            autoSuggestDetailsAconcagua: function (dataSend) {
                // Create the XHR request
                var request = new XMLHttpRequest();
                // Return it as a Promise
                return new Promise(function (resolve, reject) {
                    // Setup our listener to process compeleted requests
                    request.onreadystatechange = function () {
                        // Only run if the request is complete
                        if (request.readyState !== 4) return;
                        // Process the response
                        if (request.status >= 200 && request.status < 300) {
                            // If successful
                            resolve(request);
                        } else {
                            // If failed
                            reject({
                                status: request.status,
                                statusText: request.statusText
                            });
                        }
            
                    };
                    // Setup our HTTP request
                    request.open('GET', MY_CONSTANT.autossugestUrl + '/address/location/'+ dataSend.id_origin +'?channel=' + dataSend.channel, true);
                    //request.open('GET', 'http://localhost:3000/aconcagua', true);
                    // Send the request
                    request.send();
            
                });
            },
            autoCompleteHereMaps: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/search-by-tags",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/search-by-tags",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/search-by-tags");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/search-by-tags");
                        return deferred.promise;
                    });
            },
            reverseGeocoding: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/reverse-geocode",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            gecodeApiNew: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/geocode",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getFlotaCuota: function (dataSend) {
                // Create the XHR request
                var request = new XMLHttpRequest();
                // Return it as a Promise
                return new Promise(function (resolve, reject) {
                    // Setup our listener to process compeleted requests
                    request.onreadystatechange = function () {
                        // Only run if the request is complete
                        if (request.readyState !== 4) return;
                        // Process the response
                        if (request.status >= 200 && request.status < 300) {
                            // If successful
                            resolve(request);
                        } else {
                            // If failed
                            reject({
                                status: request.status,
                                statusText: request.statusText
                            });
                        }
            
                    };
                    // Setup our HTTP request
                    request.open('GET', MY_CONSTANT.matriz_flota + '/servicestype/v1/matriz_flota/cupos?access_token='+dataSend.access_token+'&fecha=' + dataSend.fecha +'&tipo_servicio=' + dataSend.tipo_servicio + '&sucursal_id=' + dataSend.sucursal_id + '&pasajeros='+ dataSend.pasajeros, true);
                    //request.open('GET', 'http://localhost:3000/aconcagua', true);
                    // Send the request
                    request.send();
            
                });
            }
        }
    }
})();

/**
 * Created by cl-macmini-51 on 5/2/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('getBookings', getBookings);

    /** @ngInject */
    function getBookings($log, $http, $q, MY_CONSTANT, $cookies, pendingRequests) {
        var apiKeyAconcagua = 'API_KEY_ACME';
        return {
            allBookings: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_bookings",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_bookings",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_bookings");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_bookings");
                        return deferred.promise;
                    });
            },
            allAssignBookings: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_assigned_bookings",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_assigned_bookings",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_assigned_bookings");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_assigned_bookings");
                        return deferred.promise;
                    });
            },
            allAssignBookingsV2: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_assigned_bookings_v1",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_assigned_bookings_v1",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_assigned_bookings_v1");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_assigned_bookings_v1");
                        return deferred.promise;
                    });
            },
            allAssignBookingsV3: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.booking + "/booking/v1/booking/assigned_bookings",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.booking + "/booking/v1/booking/assigned_bookings",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.booking + "/booking/v1/booking/assigned_bookings");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.booking + "/booking/v1/booking/assigned_bookings");
                        return deferred.promise;
                    });
            },
            allUnAssignBookings: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_unassigned_bookings",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_unassigned_bookings",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_unassigned_bookings");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_unassigned_bookings");
                        return deferred.promise;
                    });
            },
            allUnAssignBookingsV2: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_unassigned_bookings_v1",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_unassigned_bookings_v1",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_unassigned_bookings_v1");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_unassigned_bookings_v1");
                        return deferred.promise;
                    });
            },
            allUnAssignBookingsV3: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.booking + "/booking/v1/booking/unassigned_bookings",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.booking + "/booking/v1/booking/unassigned_bookings",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.booking + "/booking/v1/booking/unassigned_bookings");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.booking + "/booking/v1/booking/unassigned_bookings");
                        return deferred.promise;
                    });
            },
            singleBooking: function (id) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_booking_info",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_booking_info",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: {
                            access_token: $cookies.get('obj'),
                            job_id: id
                        },
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_booking_info");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_booking_info");
                        return deferred.promise;
                    });
            },
            createBooking: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/create_booking_admin",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            modifyBooking: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/modify_booking",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            manualAssignBooking: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/manual_assignment_of_driver",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            manualAssignBookingToFleet: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/assign_fleet_to_transVIP_task",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            checkBeforeAssignDriverApi: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/check_driver_status",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            checkBeforeAssignDriverToJobApi: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/check_driver_status_for_job",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            unassignBookingDriver: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/unassign_transvip_fleet_to_task",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            changeJobStatus: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/change_job_status_admin",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getSpotAgreementForBooking: function () {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_spot_agreement",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_spot_agreement",
                        method: 'GET',
                        headers: {
                            'content-language': 'es',
                            'Content-Type': 'application/json'
                        },
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_spot_agreement");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_spot_agreement");
                        return deferred.promise;
                    });
            },
            getCustomerAdjustAgreemtent: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_customer_agreements",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_customer_agreements",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_customer_agreements");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_customer_agreements");
                        return deferred.promise;
                    });
            },
            getCorporateAgreementForBooking: function(dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_customer_corporate_contract_admin",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_customer_corporate_contract_admin",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_customer_corporate_contract_admin");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_customer_corporate_contract_admin");
                        return deferred.promise;
                    });
            },
            getFixedRoutesForPersonal: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.priceUrl + "/pricing/v1/search_fixed_variable",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.priceUrl + "/pricing/v1/search_fixed_variable",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.priceUrl + "/pricing/v1/search_fixed_variable");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.priceUrl + "/pricing/v1/search_fixed_variable");
                        return deferred.promise;
                    });
            },
            AdjustAgreement: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url:  MY_CONSTANT.url + "/edit_customer_agreement",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/edit_customer_agreement",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    timeout: deferred.promise,
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/edit_customer_agreement");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/edit_customer_agreement");
                        return deferred.promise;
                    });
            },
            getRideSummary: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_ride_summary_admin",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_ride_summary_admin",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_ride_summary_admin");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_ride_summary_admin");
                        return deferred.promise;
                    });
            },
            manualReassignBookingToFleet: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/reassign_transvip_fleet_to_task",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getBookingById: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/search_booking_by_id",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/search_booking_by_id",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/search_booking_by_id");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/search_booking_by_id");
                        return deferred.promise;
                    });
            },
            getPreviousAddress: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_previous_addresses",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_previous_addresses",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_previous_addresses");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_previous_addresses");
                        return deferred.promise;
                    });
            },
            sendMassivePush: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/sendMassivePush",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getNearDriver: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/nearsetETA_admin_new",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/nearsetETA_admin_new",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/nearsetETA_admin_new");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/nearsetETA_admin_new");
                        return deferred.promise;
                    });
            },
            adjustFareHit: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/correct_trip_payment_amount",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getNoShowData: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_NOSHOW_data",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_NOSHOW_data",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_NOSHOW_data");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_NOSHOW_data");
                        return deferred.promise;
                    });
            },
            printReceipt: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_thermal_print",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_thermal_print",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_thermal_print");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_thermal_print");
                        return deferred.promise;
                    });
            },
            getAirportZone: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/check_airport_booking",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/check_airport_booking",
                        method: 'GET',
                        timeout: deferred.promise,
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/check_airport_booking");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/check_airport_booking");
                        return deferred.promise;
                    });
            },
            getBookingLocation: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_booking_locations",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_booking_locations",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_booking_locations");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_booking_locations");
                        return deferred.promise;
                    });
            },
            getHeightForPrint: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_thermal_print_height",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_thermal_print_height",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_thermal_print_height");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                    deferred.reject(msg);
                    pendingRequests.remove(MY_CONSTANT.url + "/get_thermal_print_height");
                    return deferred.promise;
                });
            },
            makeCreateBookingPdfHeight: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_booking_email_pdf_height",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_booking_email_pdf_height",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_booking_email_pdf_height");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                    deferred.reject(msg);
                    pendingRequests.remove(MY_CONSTANT.url + "/get_booking_email_pdf_height");
                    return deferred.promise;
                });
            },
            makeCreateBookingPdf: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_booking_email_pdf_link",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_booking_email_pdf_link",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_booking_email_pdf_link");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                    deferred.reject(msg);
                    pendingRequests.remove(MY_CONSTANT.url + "/get_booking_email_pdf_link");
                    return deferred.promise;
                });
            },
            sendVoucherToCustomer: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/resend_voucher",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            viewVoucherOfCustomer: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/create_pdf_of_email_pdf",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            searchBookings: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_bookings_search",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_bookings_search",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_bookings_search");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_bookings_search");
                        return deferred.promise;
                    });
            },
            makePaymentFromSearchApi: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/mark_booking_paid",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            sharedGroupBookings: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_shared_group_packages",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_shared_group_packages",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_shared_group_packages");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_shared_group_packages");
                        return deferred.promise;
                    });
            },
            sharedGroupBookingsById: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_shared_group_packages_by_id",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_shared_group_packages_by_id",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_shared_group_packages_by_id");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_shared_group_packages_by_id");
                        return deferred.promise;
                    });
            },
            checkCustomerIsAllowedInContract: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/customer_contract_check",
                        method: 'POST',
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            autoAssignMassivePush: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/auto_assignment_push_drivers_multiple",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            correctTripPaymentAmountByItem: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/correct_trip_payment_amount_by_item",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            correctTripPaymentAmountNoshowCancel: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/correct_trip_payment_amount_noshow_cancel",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            RoutingApi: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/pick_range_calc_routing",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',

                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getAdminListAccordingToRole: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_admin_auth",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_admin_auth",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_admin_auth");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_admin_auth");
                        return deferred.promise;
                    });
            },
            setFavouriteAddress: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/set_favourite_location",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',

                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            validatePassword: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/check_admin",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            setUnFavouriteAddress: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/delete_favourite_location",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getCancelThermalPrintHeight: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/thermal_height_cancel",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getCancelThermalPrint: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/thermal_height_cancel",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getFavouriteAddress: function (data) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/check_favourite_location",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/check_favourite_location",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: {
                            address: data.address,
                            customer_id: data.customer_id
                        },
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/check_favourite_location");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/check_favourite_location");
                        return deferred.promise;
                    });
            },
            getCancelThermalPrintPdf: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/get_thermal_print_cancel",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getAirportAddress: function (data) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_airport_within_branch",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_airport_within_branch",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params:data,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_airport_within_branch");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_airport_within_branch");
                        return deferred.promise;
                    });
            },
            allUnAssignPackagesV2: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_unassigned_grouped_pakages",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_unassigned_grouped_pakages",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_unassigned_grouped_pakages");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_unassigned_grouped_pakages");
                        return deferred.promise;
                    });
            },
            allUnAssignPackagesV3: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.booking + "/booking/v1/shared_service/unassigned_packages",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.booking + "/booking/v1/shared_service/unassigned_packages",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.booking + "/booking/v1/shared_service/unassigned_packages");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.booking + "/booking/v1/shared_service/unassigned_packages");
                        return deferred.promise;
                    });
            },
            allAssignPackagesV2: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_assigned_grouped_pakages",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_assigned_grouped_pakages",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_assigned_grouped_pakages");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_assigned_grouped_pakages");
                        return deferred.promise;
                    });
            },
            allAssignPackagesV3: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.booking + "/booking/v1/shared_service/assigned_packages",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.booking + "/booking/v1/shared_service/assigned_packages",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.booking + "/booking/v1/shared_service/assigned_packages");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.booking + "/booking/v1/shared_service/assigned_packages");
                        return deferred.promise;
                    });
            },
            autoAssignMassivePushGrouped: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/auto_assignment_push_drivers_multiple_grouped",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            autoAssignNewMassivePushShared: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.urlAutoAssignment + "/allocation/v1/autoasignar_compartido",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
       
            validMassiveCreateCSV: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/validate_csv",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',
                            'content-type': undefined
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getBulkCSVData: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/get_bulk_csv_data",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',
                            // 'content-type': undefined
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            tollCostEstimatedRouteHereMaps: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/toll-cost-estimated-route",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',
                            // 'content-type': undefined
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            autoSuggestAconcagua: function (dataSend) {
                // Create the XHR request
                var request = new XMLHttpRequest();
                // Return it as a Promise
                return new Promise(function (resolve, reject) {
                    // Setup our listener to process compeleted requests
                    request.onreadystatechange = function () {
                        // Only run if the request is complete
                        if (request.readyState !== 4) return;
                        // Process the response
                        if (request.status >= 200 && request.status < 300) {
                            // If successful
                            resolve(request);
                        } else {
                            // If failed
                            reject({
                                status: request.status,
                                statusText: request.statusText
                            });
                        }
            
                    };
                    // Setup our HTTP request
                    request.open('GET', MY_CONSTANT.autossugestUrl + '/get_suggestions?apikey='+apiKeyAconcagua+'&channel=' + dataSend.channel + '&query_string=' + dataSend.query_string + '&user_id='+ dataSend.user_id + '&at=' + dataSend.at, true);
                    //request.open('GET', 'http://localhost:3000/aconcagua', true);
                    // Send the request
                    request.send();
            
                });
            },
            autoSuggestDetailsAconcagua: function (dataSend) {
                // Create the XHR request
                var request = new XMLHttpRequest();
                // Return it as a Promise
                return new Promise(function (resolve, reject) {
                    // Setup our listener to process compeleted requests
                    request.onreadystatechange = function () {
                        // Only run if the request is complete
                        if (request.readyState !== 4) return;
                        // Process the response
                        if (request.status >= 200 && request.status < 300) {
                            // If successful
                            resolve(request);
                        } else {
                            // If failed
                            reject({
                                status: request.status,
                                statusText: request.statusText
                            });
                        }
            
                    };
                    // Setup our HTTP request
                    request.open('GET', MY_CONSTANT.autossugestUrl + '/get_address_details?apikey='+apiKeyAconcagua+'&channel=' + dataSend.channel +'&add_to_history=true&label=' + dataSend.label + '&origin=' + dataSend.origin +'&id_origin='+ dataSend.id_origin + '&user_id='+ dataSend.user_id, true);
                    //request.open('GET', 'http://localhost:3000/aconcagua', true);
                    // Send the request
                    request.send();
            
                });
            },
            getFlotaCuota: function (dataSend) {
                // Create the XHR request
                var request = new XMLHttpRequest();
                // Return it as a Promise
                return new Promise(function (resolve, reject) {
                    // Setup our listener to process compeleted requests
                    request.onreadystatechange = function () {
                        // Only run if the request is complete
                        if (request.readyState !== 4) return;
                        // Process the response
                        if (request.status >= 200 && request.status < 300) {
                            // If successful
                            resolve(request);
                        } else {
                            // If failed
                            reject({
                                status: request.status,
                                statusText: request.statusText
                            });
                        }
            
                    };
                    // Setup our HTTP request
                    request.open('GET', MY_CONSTANT.matriz_flota + '/servicestype/v1/matriz_flota/cupos?access_token='+dataSend.access_token+'&fecha=' + dataSend.fecha +'&tipo_servicio=' + dataSend.tipo_servicio + '&sucursal_id=' + dataSend.sucursal_id + '&pasajeros=' + dataSend.pasajeros + '&edit='+ dataSend.edit + '&original_tipo_servicio='+ dataSend.original_tipo_servicio +'&job_id='+dataSend.job_id, true);
                    //request.open('GET', 'http://localhost:3000/aconcagua', true);
                    // Send the request
                    request.send();
            
                });
            },
            getCreateBookingFields: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/new_massive_bookings/get_create_booking_fields",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',
                            // 'content-type': undefined
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            submitFieldsCreateBooking: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/new_massive_bookings/submit_fields_and_create_bookings",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getUploadedFiles: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/new_massive_bookings/get_uploaded_files",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',
                            // 'content-type': undefined
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getBookingWithinFile: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/new_massive_bookings/get_bookings_within_file",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',
                            // 'content-type': undefined
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
        }
    }
})();

/**
 * Created by cl-macmini-51 on 5/18/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('getAgreement', getAgreement);

    /** @ngInject */
    function getAgreement($log, $http, $q, MY_CONSTANT, $cookies, pendingRequests) {
        return {
            newAgreement: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/add_corporate_contract",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            editAgreement: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/edit_corporate_contract",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            editAgreementStatus: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/edit_corporate_contract_status",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            allAgreements: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_corporate_contract",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_corporate_contract",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_corporate_contract");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_corporate_contract");
                        return deferred.promise;
                    });
            },
            newEditAgreement: function (dataSend, id) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.convenios + "/agreements/v1/contract/" + id,
                        method: 'PUT',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            oneAgreement: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.convenios + "/agreements/v1/contract",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.convenios + "/agreements/v1/contract",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.convenios + "/agreements/v1/contract");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.convenios + "/agreements/v1/contract");
                        return deferred.promise;
                    });
            },
            allAgreementsExpenseControl: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_corporate_expense_control",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_corporate_expense_control",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_corporate_expense_control");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_corporate_expense_control");
                        return deferred.promise;
                    });
            },
            allAgreementBooking: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_corporate_contract_booking",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_corporate_contract_booking",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_corporate_contract_booking");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_corporate_contract_booking");
                        return deferred.promise;
                    });
            },
            getDetailsForPET: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_employee_customer_details",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_employee_customer_details",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_employee_customer_details");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_employee_customer_details");
                        return deferred.promise;
                    });
            },
            
            manageEmployees: function (dataSend, contract_id, corporate_id) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/add_employees_to_contracts",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            manageEmployeesFromCreateBooking: function (dataSend, contract_id, corporate_id) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/add_employees_to_contracts_through_booking",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            manageEmployeesBulk: function (dataSend, contract_id, corporate_id) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/add_employees_to_contracts_in_bulk",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',
                            'content-type': undefined
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            deleteEmployeeHit: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/delete_corporate_customer",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getContractRelatedEmployee: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_employee_list_contract",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_employee_list_contract",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_employee_list_contract");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_employee_list_contract");
                        return deferred.promise;
                    });
            },
            getPriceListContract: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_price_list_contract",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_price_list_contract",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_price_list_contract");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_price_list_contract");
                        return deferred.promise;
                    });
            },
            getFixedPriceListContract: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_price_list_contract_fixed",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_price_list_contract_fixed",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_price_list_contract_fixed");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_price_list_contract_fixed");
                        return deferred.promise;
                    });
            },
            getVariablePriceListContract: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_price_list_contract_variable",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_price_list_contract_variable",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_price_list_contract_variable");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_price_list_contract_variable");
                        return deferred.promise;
                    });
            },
            minimumPrice: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_minimum_price_of_pricelist",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_minimum_price_of_pricelist",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_minimum_price_of_pricelist");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_minimum_price_of_pricelist");
                        return deferred.promise;
                    });
            },
            getPriceListDetailId: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_price_list_contract_detail",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_price_list_contract_detail",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_price_list_contract_detail");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_price_list_contract_detail");
                        return deferred.promise;
                    });
            },
            addHeadersOfPriceList: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/add_price_list_contract",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            changeStatusPriceListActive: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/activate_price_list",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            changeStatusPriceListInActive: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/inactivate_price_list",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            addPriceListRouteFixed: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/add_fixed_pricing_contract",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            addPriceListRouteVariable: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/add_varible_pricing_contract",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            deleteContract: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/delete_contract",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            editAgreementPriceList: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/edit_transvip_contract_price_list",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            editAgreementFixedRoutePriceList: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/edit_fixed_pricing_routes_contract",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            editAgreementVariableRoutePriceList: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/edit_variable_pricing_routes_contract",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            deleteItemOfChargeVariable: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/delete_item_of_charge_variable",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            deleteItemOfChargeFixed: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/delete_item_of_charge_fixed",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getFixedRoutePriceList: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_fixed_pricing_contract",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_fixed_pricing_contract",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_fixed_pricing_contract");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_fixed_pricing_contract");
                        return deferred.promise;
                    });
            },
            getVariableRoutePriceList: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_varible_pricing_contract",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_varible_pricing_contract",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_varible_pricing_contract");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_varible_pricing_contract");
                        return deferred.promise;
                    });
            },
            copyPriceList: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/copyPricingListFixed",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            copyVariablePriceList: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/copyPricingListVariable",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            editEmployeeDetails: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/edit_employee_details",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            deleteFixedPriceList: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/delete_fixed_price_list",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            deleteVariablePriceList: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/delete_variable_price_list",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getAuthorizerList: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/getAuhterisableEmployee",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/getAuhterisableEmployee",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/getAuhterisableEmployee");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/getAuhterisableEmployee");
                        return deferred.promise;
                    });
            },
            getBasedPriceListData: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_price_lists_for_copy",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_price_lists_for_copy",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_price_lists_for_copy");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_price_lists_for_copy");
                        return deferred.promise;
                    });
            },
            registerCustomerFromEmployee: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/add_new_customer",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getAgreementListLessData: function(dataSend) {
                var data = {};
                data.access_token =  $cookies.get('obj');
                if(dataSend && dataSend.group_booking){
                    data.group_booking = dataSend.group_booking;
                }
                if(dataSend && dataSend.service_grouping_type){
                    data.service_grouping_type = dataSend.service_grouping_type;
                }
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_agreements_list",
                    canceller: deferred
                });
                return $http({
                    url: MY_CONSTANT.url + "/get_agreements_list",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    timeout: deferred.promise,
                    params: data
                })
                    .then(function(data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_agreements_list");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_agreements_list");
                        return deferred.promise;
                    });
            },
            getAgreementListLessDataWithFilters: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_agreements_list_for_filters",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_agreements_list_for_filters",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        timeout: deferred.promise,
                        params: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_agreements_list_for_filters");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_agreements_list_for_filters");
                        return deferred.promise;
                    });
            },
            updateEmployeeAdditionalFields: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/update_additional_fields_for_employees_admin",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            AdjustPrice: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/adjustment_of_list_of_prices",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            activeInactiveBulkFlag: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/active_inactive_bulk_load_process",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            createMassiveBooking: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/create_massive_booking",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            afterCreateMassiveBooking: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/get_bulk_Creation_data",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            cancelValidatedData: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/cancel_validated_data",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getBookingForMassiveModification: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_bookings_for_massive_modification",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_bookings_for_massive_modification",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_bookings_for_massive_modification");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_bookings_for_massive_modification");
                        return deferred.promise;
                    });
            },
            massiveUpdateBookings: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/update_bookings_for_massive_modification",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getMassiveModificationData: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_bookings_carga_masiva",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_bookings_carga_masiva",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_bookings_carga_masiva");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_bookings_carga_masiva");
                        return deferred.promise;
                    });
            },
            getBookingForPackageCreation: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/get_bulk_bookings_for_package",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            UploadMassivePackageFile: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/validate_package_xlsx",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',
                            'content-type': undefined
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            createMassivePackage: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/create_bulk_package",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',
                            // 'content-type': undefined
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getPackageDataAfterCreation: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/get_final_bulk_creation_data",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',
                            // 'content-type': undefined
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getPackageDataAfterCreationNew: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/get_bulk_package_data",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',
                            // 'content-type': undefined
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            addEditDestinationBase: function (dataSend, isEdit) {
                var deferred = $q.defer();
                var path = isEdit ? '/admin/contract/edit_destination_base' : '/admin/contract/add_destination_base'
                return $http({
                        url: MY_CONSTANT.url + path,
                        method: 'POST',
                        headers: {
                            'content-language': 'es',
                            // 'content-type': undefined
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getDestinationBases: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/contract/get_destination_bases",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',
                            // 'content-type': undefined
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            enableDisableDestinationBase: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/contract/enable_disable_destination_base",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            deleteDestinationBase: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/contract/delete_destination_base",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getTypeOfServices: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/contract/get_type_of_services",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',
                            // 'content-type': undefined
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            updateTypeOfServices: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + '/admin/contract/edit_type_of_services',
                        method: 'POST',
                        headers: {
                            'content-language': 'es',
                            // 'content-type': undefined
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            uploadXlsxGetHeaders: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/admin/new_massive_bookings/save_xlsx_and_get_headers",
                        method: 'POST',
                        headers: {
                            'content-language': 'es',
                            'content-type': undefined
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
        }
    }
})();

/**
 * Created by cl-macmini-51 on 6/27/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('getAdminRoles', getAdminRoles);

    /** @ngInject */
    function getAdminRoles($log, $http, $q, MY_CONSTANT, $cookies, pendingRequests) {
        return {
            getAdminUserList: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/getAllAdminsNew",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/getAllAdminsNew",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/getAllAdminsNew");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/getAllAdminsNew");
                        return deferred.promise;
                    });
            },
            getAdminBookingReport: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_reports_data",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_reports_data",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_reports_data");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_reports_data");
                        return deferred.promise;
                    });
            },
            addAdminUser: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/add_admin_user",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/add_admin_user",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/add_admin_user");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/add_admin_user");
                        return deferred.promise;
                    });
            },
            addRoleToUser: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/add_role_to_admin",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            updateRoleToUser: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/update_role_to_admin",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            //addPermission: function (dataSend) {
            //    var deferred = $q.defer();
            //    return $http({
            //        url: MY_CONSTANT.url + "/permissions",
            //        method: 'POST',
            //        headers: {
            //            'content-language': 'es'
            //        },
            //        data: dataSend
            //    })
            //        .then(function (data) {
            //            deferred.resolve({
            //                title: data.data
            //            });
            //            return deferred.promise;
            //        })
            //        .catch(function (msg) {
            //            deferred.reject(msg);
            //            return deferred.promise;
            //        });
            //},
            addRole: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/add_roles",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            //updateAdminWithRole: function (dataSend) {
            //    var deferred = $q.defer();
            //    return $http({
            //        url: MY_CONSTANT.url + "/update_role",
            //        method: 'POST',
            //        headers: {
            //            'content-language': 'es'
            //        },
            //        data: dataSend
            //    })
            //        .then(function (data) {
            //            deferred.resolve({
            //                title: data.data
            //            });
            //            return deferred.promise;
            //        })
            //        .catch(function (msg) {
            //            deferred.reject(msg);
            //            return deferred.promise;
            //        });
            //},
            //updateAdminPermission: function (dataSend) {
            //    var deferred = $q.defer();
            //    return $http({
            //        url: MY_CONSTANT.url + "/update_permission",
            //        method: 'POST',
            //        headers: {
            //            'content-language': 'es'
            //        },
            //        data: dataSend
            //    })
            //        .then(function (data) {
            //            deferred.resolve({
            //                title: data.data
            //            });
            //            return deferred.promise;
            //        })
            //        .catch(function (msg) {
            //            deferred.reject(msg);
            //            return deferred.promise;
            //        });
            //},
            updateRoleApi: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/edit_role",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            systemLogs: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/add_logs",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getSystemLogs: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_logs",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_logs",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_logs");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_logs");
                        return deferred.promise;
                    });
            },
            changeStatus: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/activeInActiveAdmin",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            actInActiveRole: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/actInActiveRole",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getAllRolesApi: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/get_roles",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            deleteUser: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/deleteAdmin",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            deleteRoleApi: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/deleteRole",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            editUser: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/editAdmin",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getCorporateListBasedOnSearch: function (dataSend) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_corporate_Detail_Pet",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_corporate_Detail_Pet",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: dataSend,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_corporate_Detail_Pet");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_corporate_Detail_Pet");
                        return deferred.promise;
                    });
            }
        }
    }
})();
/**
 * Created by cl-macmini-51 on 6/27/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .service('adminAccessService', adminAccessService);

    /** @ngInject */
    function adminAccessService($log, $http, $q, MY_CONSTANT, $cookies, $rootScope,$state,getAdminRoles) {
        var adminAccessArray = [];
        return {
            getAdminAccess: function () {
                return JSON.parse(localStorage.getItem('getAdminAccess'));
            },
            putAdminAccess: function (dataSend) {
                var arrayToCheck = [];

                for(var i=0;i<dataSend.length;i++){
                    for(var j=0;j<dataSend[i].access.length;j++){
                        arrayToCheck.push(dataSend[i].access[j]);
                    }
                }
                var unique = arrayToCheck.filter(function(elem, index, self) {
                    return index == self.indexOf(elem);
                });
                var rolesArray = [];
                for(var i=0;i<dataSend.length;i++){
                    rolesArray.push(dataSend[i].roleName)
                }
                adminAccessArray = unique;
                localStorage.setItem('getAdminAccess',JSON.stringify(adminAccessArray));
                localStorage.setItem('getAdminRoles',JSON.stringify(rolesArray));
            },
            getPreviousState: function () {

                //=======================to get appropriate state====================
                var allStates = $state.get();
                //alert('hello');
                $rootScope.finalArrayStates = [];
                for(var i=5;i<allStates.length;i++){
                    if(allStates[i].name == 'layout.applicantsMain' ||
                        allStates[i].name == 'layout.approvedDriverMain' ||
                        allStates[i].name == 'layout.approvedInvestorsMain' ||
                        allStates[i].name == 'layout.customersMain' ||
                        allStates[i].name == 'layout.illuminatedZoneServicesMain' ||
                        allStates[i].name == 'layout.corporateMain' ||
                        allStates[i].name == 'layout.upcomingBookingsMain' ||
                        allStates[i].name == 'layout.ongoingBookingsMain' ||
                        allStates[i].name == 'layout.completedBookingsMain' ||
                        allStates[i].name == 'layout.carMain' ||
                        allStates[i].name == 'layout.assignedCarsMain' ||
                        allStates[i].name == 'layout.paymentTypeMain' ||
                        allStates[i].name == 'layout.typeOfServiceMain' ||
                        allStates[i].name == 'layout.vehicleTypeMain' ||
                        allStates[i].name == 'layout.agreementMain' ||
                        allStates[i].name == 'layout.branchMain' ||
                        allStates[i].name == 'layout.fixedRouteGeofenceMain' ||
                        allStates[i].name == 'layout.fixedRouteMain' ||
                        allStates[i].name == 'layout.illuminatedZoneMain' ||
                        allStates[i].name == 'layout.couponMain' ||
                        allStates[i].name == 'layout.binMain' ||
                        allStates[i].name == 'layout.createBookingMain' ||
                        allStates[i].name == 'layout.itemOfChargeMain' ||
                        allStates[i].name == 'layout.cancelReasonMain' ||
                        allStates[i].name == 'layout.driverEarningMain' ||
                        allStates[i].name == 'layout.communaMain' ||
                        allStates[i].name == 'layout.promoCodeMain' ||
                        allStates[i].name == 'layout.adminRolesMain' ||
                        allStates[i].name == 'layout.dashboardMain' ||
                        allStates[i].name == 'layout.homeScreenMain' ||
                        allStates[i].name == 'layout.globalParametersMain' ||
                        allStates[i].name == 'layout.summaryProductionMain' ||
                        allStates[i].name == 'layout.detailedProductionMain' ||
                        allStates[i].name == 'layout.itemOfChargeCsvMain' ||
                        allStates[i].name == 'layout.onOffDutyMain' ||
                        allStates[i].name == 'layout.correctFareReasonMain' ||
                        allStates[i].name == 'layout.generatePaymentStatusMain' ||
                        allStates[i].name == 'layout.rejectedBookingMain' ||
                        allStates[i].name == 'layout.operationalReportMain' ||
                        allStates[i].name == 'layout.helpDocMain' ||
                        allStates[i].name == 'layout.searchBookingMain' ||
                        allStates[i].name == 'layout.operationPointMain' ||
                        allStates[i].name == 'layout.operationPointUserMain' ||
                        allStates[i].name == 'layout.quickSaleMain' ||
                        allStates[i].name == 'layout.sharedRouteAssignmentMain' ||
                        allStates[i].name == 'layout.groupedRouteAssignmentMain' ||
                        allStates[i].name == 'layout.sharedGroupMain' ||
                        allStates[i].name == 'layout.adminUsersMain'
                    ){

                    }
                    else{
                        $rootScope.finalArrayStates.push(allStates[i]);
                    }
                }
                // console.log($rootScope.finalArrayStates,'$rootScope.finalArrayStates');
                
                var accessArray = JSON.parse(localStorage.getItem('getAdminAccess'));
                //TV-2206 
                // if(accessArray && accessArray.length){
                //     for(var i=0;i<$rootScope.finalArrayStates.length;i++){
                //         if($rootScope.finalArrayStates[i].title == accessArray[0]){
                //             $rootScope.previousState = $rootScope.finalArrayStates[i].name;
                //         }
                //     }
                // }
                $rootScope.previousState = 'layout.homeScreenMain';
                // console.log($rootScope.previousState,'$rootScope.previousState1>>>>>');
                
                return $rootScope.previousState;
            },
            checkStateValid: function(data){
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/verifyAccessNew",
                    method: 'GET',
                    headers: {
                        'content-language': 'es'
                    },
                    params: {
                        access_token: $cookies.get('obj'),
                        admin_id: $cookies.get('adminId'),
                        access: data
                    }
                })
                    .then(function(data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function(msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            }
        }
    }
})();

/**
 * Created by cl-macmini-51 on 4/17/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('sidebarJSON', sidebarJSON);

    /** @ngInject */
    function sidebarJSON($log, $http, $q, MY_CONSTANT, $cookies, $filter, $translate, languageBasedErrorFactory) {
        function getData(dataNew) {
            var data = [

                {
                    "text": languageBasedErrorFactory.getProperErrorMessage('HomePageHead', 0, '3'),
                    "sref": "layout.homeScreenMain",
                    "icon": "fa fa-home fa-lg",
                    "isPetUser": 1
                },
                {
                    "text": languageBasedErrorFactory.getProperErrorMessage('dashboardPageHead', 0, '3'),
                    "sref": "layout.dashboardMain",
                    "icon": "fa fa-bank",
                    "isPetUser": dataNew.includes() ? 1 :0
                },
                {
                    "text": languageBasedErrorFactory.getProperErrorMessage('comminicationSuppliers', 0, '3'),
                    "sref": "",
                    "icon": "fa fa-list",
                    "isPetUser": dataNew.includes() ? 1 :0,
                    "submenu": [{
                            "text": languageBasedErrorFactory.getProperErrorMessage('newMessage', 0, '3'),
                            "sref": "layout.newMessageMain",
                            "isPetUser": dataNew.includes() ? 1 :0
                        },
                        {
                            "text": languageBasedErrorFactory.getProperErrorMessage('groupDrivers', 0, '3'),
                            "sref": "layout.groupDriversMain",
                            "isPetUser": dataNew.includes() ? 1 :0
                        },
                        {
                            "text": languageBasedErrorFactory.getProperErrorMessage('historyMessage', 0, '3'),
                            "sref": "layout.historyMessageMain",
                            "isPetUser": 0
                        },
                        {
                            "text": languageBasedErrorFactory.getProperErrorMessage('driverMail',0,'3'),
                            "sref": "layout.mailDriverMain",
                            "isPetUser": 0
                        },
                    ]
                },
                {
                    "text": languageBasedErrorFactory.getProperErrorMessage('applicantHead', 0, '3'),
                    "sref": "layout.applicantsMain",
                    "icon": "fa fa-users",
                    "isPetUser": dataNew.includes() ? 1 :0
                },
                {
                    "text": languageBasedErrorFactory.getProperErrorMessage('driverOnly', 0, '3'),
                    "sref": "layout.approvedDriverMain",
                    "icon": "fa fa-users",
                    "isPetUser": dataNew.includes() ? 1 :0
                },
                {
                    "text": languageBasedErrorFactory.getProperErrorMessage('carInvestors', 0, '3'),
                    "sref": "layout.approvedInvestorsMain",
                    "icon": "fa fa-users",
                    "isPetUser": dataNew.includes() ? 1 :0
                },
                {
                    "text": languageBasedErrorFactory.getProperErrorMessage('customerHead', 0, '3'),
                    "sref": "layout.customersMain",
                    "icon": "fa fa-users",
                    "isPetUser": dataNew.includes() ? 1 :0
                },
                {
                    "text": "Zona iluminada",
                    "sref": "",
                    "icon": "fa fa-list",
                    "isPetUser": dataNew.includes() ? 1 :0,
                    "submenu": [{
                            "text": "Zona iluminada",
                            "sref": "layout.illuminatedZoneServicesMain",
                            "isPetUser": dataNew.includes() ? 1 :0
                        },
                        {
                            "text": "Historial zona iluminada",
                            "sref": "layout.illuminatedZoneServicesLogMain",
                            "isPetUser": dataNew.includes() ? 1 :0
                        },
                        {
                            "text": "Cantidad Máxima",
                            "sref": "layout.illuminatedZoneServicesNewPageMain",
                            "isPetUser": dataNew.includes() ? 1 :0
                        },
                    ]
                },
                {
                    "text": "Punto de Venta Rápido",
                    "sref": "layout.quickSaleMain",
                    "icon": "fa fa-plane",
                    "isPetUser": dataNew.includes() ? 1 :0
                },
                {
                    "text": "Ruta y asignación",
                    "sref": "",
                    "icon": "fa fa-road",
                    "isPetUser": dataNew.includes() ? 1 :0,
                    "submenu": [{
                            "text": "Shared Services",
                            "sref": "layout.sharedRouteAssignmentMain",
                            "isPetUser": dataNew.includes() ? 1 :0
                        },
                        {
                            "text": "Grouped Services",
                            "sref": "layout.groupedRouteAssignmentMain",
                            "isPetUser": dataNew.includes() ? 1 :0
                        },
                        {
                            "text": "Asignación Rápida",
                            "sref": "layout.quickAssignmentMain",
                            "isPetUser": dataNew.includes() ? 1 :0
                        },
                        {
                            "text":"Asignación Masiva",
                            "sref": "layout.massiveQuickassignmentMain",
                            "isPetUser": dataNew.includes() ? 1 :0
                        },
                        {
                            "text": "Auto-asignación de paquetes",
                            "sref": "layout.groupMassiveQuickassignmentMain",
                            "isPetUser": dataNew.includes() ? 1 :0
                        },
                        {
                            "text": "Configuración auto-asignación",
                            "sref": "layout.selfAssignmentMain",
                            "isPetUser": dataNew.includes() ? 1 :0
                        },
                    ]
                },
                {
                    "text": "Matriz de capacidad de flota",
                    "sref": "layout.fleetCapacityMatrixMain",
                    "icon": "fa fa-list-alt",
                    "isPetUser": dataNew.includes() ? 1 :0
                },
                {
                    "text": languageBasedErrorFactory.getProperErrorMessage('bookingOnly', 0, '3'),
                    "sref": "",
                    "icon": "fa fa-list",
                    "isPetUser": dataNew.includes("Upcoming Bookings") ? 1 :0,
                    "submenu": [{
                            "text": languageBasedErrorFactory.getProperErrorMessage('searchBookingPage', 0, '3'),
                            "sref": "layout.searchBookingMain",
                            "isPetUser": dataNew.includes("Search Booking") ? 1 :0
                        },
                        {
                            "text": languageBasedErrorFactory.getProperErrorMessage('bookingupOnly', 0, '3'),
                            "sref": "layout.upcomingBookingsMain",
                            "isPetUser": dataNew.includes("Upcoming Bookings") ? 1 :0
                        },
                        {
                            "text": languageBasedErrorFactory.getProperErrorMessage('bookingonOnly', 0, '3'),
                            "sref": "layout.ongoingBookingsMain",
                            "isPetUser": dataNew.includes("Ongoing Bookings") ? 1 :0
                        },
                        {
                            "text": languageBasedErrorFactory.getProperErrorMessage('bookingcoOnly', 0, '3'),
                            "sref": "layout.completedBookingsMain",
                            "isPetUser": dataNew.includes("Completed Bookings") ? 1 :0
                        },
                        {
                            "text": 'Shared/ Group',
                            "sref": "layout.sharedGroupMain",
                            "isPetUser": dataNew.includes() ? 1 :0
                        }
                    ]
                },
                // {
                //     "text": languageBasedErrorFactory.getProperErrorMessage('vehiclesLabel',0,'3'),
                //     "sref": "layout.carMain",
                //     "icon": "fa fa-car",
                //    "isPetUser": dataNew.includes() ? 1 :0
                // },
                {
                    "text": languageBasedErrorFactory.getProperErrorMessage('vehiclesLabel', 0, '3'),
                    "sref": "",
                    "icon": "fa fa-car",
                    "isPetUser": dataNew.includes() ? 1 :0,
                    "submenu": [{
                            "text": "Vehículos",
                            "sref": "layout.carMain",
                            "isPetUser": dataNew.includes() ? 1 :0
                        },
                        {
                            "text": "Marcas y Modelos",
                            "sref": "layout.carModelsMain",
                            "isPetUser": dataNew.includes() ? 1 :0
                        },
                        {
                            "text": "Colores",
                            "sref": "layout.carColorsMain",
                            "isPetUser": dataNew.includes() ? 1 :0
                        },
                        {
                            "text": "Parámetros BMP",
                            "sref": "layout.vechicleBalanceMain",
                            "isPetUser": dataNew.includes() ? 1 :0
                        }
                    ]
                },
                {
                    "text": languageBasedErrorFactory.getProperErrorMessage('geofenceOnly', 0, '3'),
                    "sref": "",
                    "icon": "fa fa-globe",
                    "isPetUser": dataNew.includes() ? 1 :0,
                    "submenu": [{
                            "text": languageBasedErrorFactory.getProperErrorMessage('branchLabel', 0, '3'),
                            "sref": "layout.branchMain",
                            "isPetUser": dataNew.includes() ? 1 :0
                        },
                        {
                            "text": languageBasedErrorFactory.getProperErrorMessage('geofencesOnly', 0, '3'),
                            "sref": "layout.fixedRouteGeofenceMain",
                            "isPetUser": dataNew.includes() ? 1 :0
                        },
                        {
                            "text": languageBasedErrorFactory.getProperErrorMessage('fixedRoutesOly', 0, '3'),
                            "sref": "layout.fixedRouteMain",
                            "isPetUser": dataNew.includes() ? 1 :0
                        },
                        {
                            "text": 'Zona iluminada',
                            "sref": "layout.illuminatedZoneMain",
                            "isPetUser": dataNew.includes() ? 1 :0
                        },
                        {
                            "text": 'Direcciones Especiales',
                            "sref": "layout.specialDirectionsMain",
                            "isPetUser": dataNew.includes() ? 1 :0
                        },
                        {
                            "text": 'Mapa de calor',
                            "sref": "layout.heatMapMain",
                            "isPetUser": dataNew.includes() ? 1 :0
                        },
                        {
                            "text": $filter('translate')('autoAssign'),
                            "sref": "layout.autoAssignMain",
                            "isPetUser": dataNew.includes('Administrar Geocerca Autoasignacion') ? 1 :0
                        }
                    ]
                },
                {
                    "text": languageBasedErrorFactory.getProperErrorMessage('createBookingHead', 0, '3'),
                    "sref": "layout.createBookingMain",
                    "icon": "fa fa-shopping-cart",
                    "isPetUser": dataNew.includes("Create Booking") ? 1 :0
                },
                {
                    "text": languageBasedErrorFactory.getProperErrorMessage('createBookingHereMaps', 0, '3'),
                    "sref": "layout.createBookingHereMapsMain",
                    "icon": "fa fa-shopping-cart",
                    "isPetUser": dataNew.includes("Create Booking Here Maps") ? 1 :0
                },
                {
                    "text": languageBasedErrorFactory.getProperErrorMessage('massiveCreateBookingHead', 0, '3'),
                    "sref": "",
                    "icon": "fa fa-shopping-cart",
                    "isPetUser": dataNew.includes() ? 1 :0,
                    "submenu": [{
                            "text": "Creación Masiva",
                            "sref": "layout.massiveCreateBookingMain",
                            "isPetUser": dataNew.includes() ? 1 :0
                        },
                        {
                            "text": "Nueva Creación masiva",
                            "sref": "layout.newMassiveCreateBookingMain",
                            "isPetUser": dataNew.includes() ? 1 :0
                        }
                    ]
                },
                {
                    "text": languageBasedErrorFactory.getProperErrorMessage('agreementLabel', 0, '3'),
                    "sref": "layout.agreementMain",
                    "icon": "fa fa-file",
                    "isPetUser": dataNew.includes("Agreement") ? 1 :0
                },
                {
                    "text": languageBasedErrorFactory.getProperErrorMessage('adminstrationOnly', 0, '3'),
                    "sref": "",
                    "icon": "fa fa-bank",
                    "isPetUser": dataNew.includes("Adminstración") ? 1 :0,
                    "submenu": [{
                            "text": languageBasedErrorFactory.getProperErrorMessage('paymentStatusGenerate', 0, '3'),
                            "sref": "layout.generatePaymentStatusMain",
                            "isPetUser": dataNew.includes("Generate Payment Status") ? 1 :0
                        },
                        {
                            "text": $filter('translate')('controlledWayHead'),
                            "sref": "layout.controlledWayMain",
                            "isPetUser": dataNew.includes('Editar Valor Via Controlada') ? 1 :0
                        },
                        {
                            "text": 'Informe Operacional',
                            "sref": "layout.operationalReportMain",
                           "isPetUser": dataNew.includes() ? 1 :0
                        },
                        {
                            "text": 'Reservas Rechazadas',
                            "sref": "layout.rejectedBookingMain",
                           "isPetUser": dataNew.includes() ? 1 :0
                        },
                        {
                            "text": 'Cierre de Período',
                            "sref": "layout.cierroPeriodeMain",
                           "isPetUser": dataNew.includes() ? 1 :0
                        },
                        {
                            "text": 'Abrir último Período Cerrado',
                            "sref": "layout.abrirPeriodoMain",
                           "isPetUser": dataNew.includes() ? 1 :0
                        }
                    ]
                },
                {
                    "text": languageBasedErrorFactory.getProperErrorMessage('serviceLabel', 0, '3'),
                    "sref": "layout.typeOfServiceMain",
                    "icon": "fa fa-cogs",
                   "isPetUser": dataNew.includes() ? 1 :0
                },
                {
                    "text": languageBasedErrorFactory.getProperErrorMessage('vehicleType', 0, '3'),
                    "sref": "layout.vehicleTypeMain",
                    "icon": "fa fa-automobile",
                   "isPetUser": dataNew.includes() ? 1 :0
                },
                {
                    "text": languageBasedErrorFactory.getProperErrorMessage('corporateHead', 0, '3'),
                    "sref": "layout.corporateMain",
                    "icon": "fa fa-building",
                    "isPetUser": dataNew.includes("Corporate") ? 1 :0
                },
                {
                    "text": languageBasedErrorFactory.getProperErrorMessage('itemSide', 0, '3'),
                    "sref": "layout.itemOfChargeMain",
                    "icon": "fa fa-list",
                   "isPetUser": dataNew.includes() ? 1 :0
                },
                {
                    "text": languageBasedErrorFactory.getProperErrorMessage('pTypes', 0, '3'),
                    "sref": "layout.paymentTypeMain",
                    "icon": "fa fa-money",
                   "isPetUser": dataNew.includes() ? 1 :0
                },
                {
                    "text": languageBasedErrorFactory.getProperErrorMessage('promoTypes', 0, '3'),
                    "sref": "",
                    "icon": "fa fa-list",
                   "isPetUser": dataNew.includes() ? 1 :0,
                    "submenu": [{
                            "text": "Promotions",
                            "sref": "layout.promoCodeMain",
                           "isPetUser": dataNew.includes() ? 1 :0
                        },
                        {
                            "text": "Coupons",
                            "sref": "layout.couponMain",
                           "isPetUser": dataNew.includes() ? 1 :0
                        },
                        {
                            "text": "Bin",
                            "sref": "layout.binMain",
                           "isPetUser": dataNew.includes() ? 1 :0
                        }
                    ]
                },
                {
                    "text": languageBasedErrorFactory.getProperErrorMessage('driverEarningSide', 0, '3'),
                    "sref": "layout.driverEarningMain",
                    "icon": "fa fa-money",
                   "isPetUser": dataNew.includes() ? 1 :0
                },
                {
                    "text": languageBasedErrorFactory.getProperErrorMessage('reasonOnly', 0, '3'),
                    "sref": "",
                    "icon": "fa fa-times-circle-o",
                   "isPetUser": dataNew.includes() ? 1 :0,
                    "submenu": [{
                            "text": languageBasedErrorFactory.getProperErrorMessage('cancelButton', 0, '3'),
                            "sref": "layout.cancelReasonMain",
                           "isPetUser": dataNew.includes() ? 1 :0
                        },
                        {
                            "text": languageBasedErrorFactory.getProperErrorMessage('correctFare', 0, '3'),
                            "sref": "layout.correctFareReasonMain",
                           "isPetUser": dataNew.includes() ? 1 :0
                        },
                        {
                            "text": languageBasedErrorFactory.getProperErrorMessage('noShowButton', 0, '3'),
                            "sref": "layout.noShowReasonMain",
                           "isPetUser": dataNew.includes() ? 1 :0
                        }
                    ]
                },
                {
                    "text": languageBasedErrorFactory.getProperErrorMessage('adminRoleLabelTable', 0, '3'),
                    "sref": "",
                    "icon": "fa fa-user",
                   "isPetUser": dataNew.includes() ? 1 :0,
                    "submenu": [{
                            "text": languageBasedErrorFactory.getProperErrorMessage('rolesOnly', 0, '3'),
                            "sref": "layout.adminRolesMain",
                           "isPetUser": dataNew.includes() ? 1 :0
                        },
                        {
                            "text": languageBasedErrorFactory.getProperErrorMessage('usersOnly', 0, '3'),
                            "sref": "layout.adminUsersMain",
                           "isPetUser": dataNew.includes() ? 1 :0
                        }
                    ]
                },
                {
                    "text": 'Punto de Operación',
                    "sref": "",
                    "icon": "fa fa-user",
                   "isPetUser": dataNew.includes() ? 1 :0,
                    "submenu": [{
                            "text": 'Punto de Operación',
                            "sref": "layout.operationPointMain",
                           "isPetUser": dataNew.includes() ? 1 :0
                        },
                        {
                            "text": 'Usuarios por Punto de Operación',
                            "sref": "layout.operationPointUserMain",
                           "isPetUser": dataNew.includes() ? 1 :0
                        }
                    ]
                },
                {
                    "text": languageBasedErrorFactory.getProperErrorMessage('globalParameters', 0, '3'),
                    "sref": "layout.globalParametersMain",
                    "icon": "fa fa-times-circle-o",
                   "isPetUser": dataNew.includes() ? 1 :0
                },
                {
                    // assets/images/driver-safety.png
                    "text": "Gauss Control",
                    "sref": "",
                    "icon": "assets/images/driver-safety.png",
                    "iconType": "image",
                   "isPetUser": dataNew.includes() ? 1 :0,
                    "submenu": [{
                            "text": "Matriz de Control",
                            "sref": "layout.gaussControlMain",
                           "isPetUser": dataNew.includes() ? 1 :0
                        },
                    ]
                },
                {
                    "text": languageBasedErrorFactory.getProperErrorMessage('prodOnly', 0, '3'),
                    "sref": "",
                    "icon": "fa fa-line-chart",
                   "isPetUser": dataNew.includes() ? 1 :0,
                    "submenu": [{
                            "text": languageBasedErrorFactory.getProperErrorMessage('summaryOnly', 0, '3'),
                            "sref": "layout.summaryProductionMain",
                           "isPetUser": dataNew.includes() ? 1 :0
                        },
                        {
                            "text": languageBasedErrorFactory.getProperErrorMessage('detailedOnly', 0, '3'),
                            "sref": "layout.detailedProductionMain",
                           "isPetUser": dataNew.includes() ? 1 :0
                        },
                        {
                            "text": languageBasedErrorFactory.getProperErrorMessage('itemOfChargeOnly', 0, '3'),
                            "sref": "layout.itemOfChargeCsvMain",
                           "isPetUser": dataNew.includes() ? 1 :0
                        },
                        {
                            "text": 'Balance de vehículos',
                            "sref": "layout.vehicleBalanceReportMain",
                           "isPetUser": dataNew.includes() ? 1 :0
                        }
                    ]
                },
                {
                    "text": languageBasedErrorFactory.getProperErrorMessage('onOff', 0, '3'),
                    "sref": "layout.onOffDutyMain",
                    "icon": "fa fa-toggle-on",
                   "isPetUser": dataNew.includes() ? 1 :0
                },
                {
                    "text": languageBasedErrorFactory.getProperErrorMessage('helpDocuments', 0, '3'),
                    "sref": "layout.helpDocMain",
                    "icon": "fa fa-info-circle",
                   "isPetUser": dataNew.includes() ? 1 :0
                },
                {
                    "text": languageBasedErrorFactory.getProperErrorMessage('expenseControl', 0, '3'),
                    "sref": "",
                    "icon": "fa fa-line-chart",
                    "isPetUser": dataNew.includes("Control de Gastos") ? 1 :0,
                    "submenu": [{
                            "text": languageBasedErrorFactory.getProperErrorMessage('defineBudget', 0, '3'),
                            "sref": "layout.expenseControlMain",
                            "isPetUser": dataNew.includes("Control de Gastos") ? 1 :0
                        },
                        {
                            "text": languageBasedErrorFactory.getProperErrorMessage('expenditureControlReport', 0, '3'),
                            "sref": "layout.expenseControlReportMain",
                            "isPetUser": dataNew.includes("Control de Gastos") ? 1 :0
                        }
                    ]
                },
                {
                    "text": languageBasedErrorFactory.getProperErrorMessage('driverRatingSidebar', 0, '3'),
                    "sref": "layout.driverEvaluationMain",
                    "icon": "fa fa-star-half-o",
                   "isPetUser": dataNew.includes() ? 1 :0
                }
            ];
            return data;
        }


        this.getJson = getJson;

        function getJson(dataNew) {
            return getData(dataNew);
        }
    }
})();

/**
 * Created by cl-macmini-51 on 4/17/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .factory('logoutFactory', logoutFactory);

    /** @ngInject */
    function logoutFactory($log, $http, $q, MY_CONSTANT, $cookies) {
        return {
            getLogout: function () {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/super_admin_logout",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: {
                        access_token: $cookies.get('obj') //$cookies.get('obj')
                    }
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            changePasswordApi: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/changePasswordAdmin",
                    method: 'POST',
                    headers: {
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            }
        }
    }
})();

/**
 * Created by cl-macmini-51 on 4/13/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('AppController', AppController);

    /** @ngInject */
    function AppController($cookies, $state, $log, $rootScope, $document, $window, $mdDialog, logoutFactory, sidebarJSON, $scope, MY_CONSTANT, getAdminRoles,
        languageBasedErrorFactory, errorMessageFactory, pendingRequests, mapDashboard, Idle, Keepalive, getGeofence, $timeout, $location, checkDomain) {
        var vm = this;
        vm.hit = hit;
        vm.showSide = true;
        $rootScope.setFlag = false;
        vm.createBookingCount = 0;
        vm.modifyBookingCount = 0;
        vm.getMenuItemPropClasses = getMenuItemPropClasses;
        vm.toggleCollapse = toggleCollapse;
        vm.driverCsvCount = 0;
        vm.driverOnOddDustyCsvCount = 0;
        vm.addCollapse = addCollapse;
        vm.createPackageCount = 0;
        vm.isCollapse = isCollapse;
        vm.stateReload = stateReload;
        vm.changePassword = changePassword;
        vm.logOut = logOut;
        vm.markReadAndDownload = markReadAndDownload;
        vm.wakeUpCall = wakeUpCall;
        vm.showSearchOption = showSearchOption;
        languageBasedErrorFactory.checkLanguageOnLoad();
        // languageBasedErrorFactory.getTranslationStrings(runThis, 0);
        vm.collapseList = [];
        vm.countToSocket = 0;
        vm.totalRequestCount = 0;
        vm.noti = 0;
        // constant variable define for pet user
        $rootScope.petUserRoleName = 'PET_USER';
        //Idle.watch();
        function runThis() {
            vm.adminType = JSON.parse($cookies.get('adminType') || 0);
            vm.json = sidebarJSON.getJson(vm.petRoles != [] ? vm.petRoles : localStorage.getItem('getAdminAccess'));
            // console.log(vm.json);
        }
        var vm = this;
        vm.isSocketConnected = false;
        vm.petRoles = [];

        function apiForPetRole(cb) {
            vm.loading = true;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            var promise = getGeofence.getPetRoles(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    if (payload && payload.title.status == 200) {
                        vm.petRoles = payload.title.data.granted_access;
                        cb();
                    } else {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    }

                },
                function (errorPayload) {
                    $log.log(errorPayload);
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        $timeout(function () {
            if (JSON.parse($cookies.get('adminType') || 0)) {
                apiForPetRole(function (err, data) {
                    languageBasedErrorFactory.getTranslationStrings(runThis, 0);
                });
            } else {
                languageBasedErrorFactory.getTranslationStrings(runThis, 0);
            }
        }, 500);


        //================to check if logggedin or not ===========================
        if (typeof $cookies.get('obj') == "undefined") {
            $state.go('home');
        }

        //================toggle side bar from burgor icon===========================
        window.addEventListener("resize", function (event) {
            // console.log(event);
            if (vm.showSide) {
                if ($window.innerWidth <= 1200) {
                    vm.showSide = false;
                } else {
                    vm.showSide = true;
                }
            }
        });

        function hit() {
            $log.log('sadasdsadas');
            if (vm.showSide) {
                vm.showSide = false;
            } else {
                vm.showSide = true;
            }

            if (!vm.search) {
                $('.inputSearch').removeClass('showSearch');
            } else {
                $('.inputSearch').addClass('showSearch');
            }
        }

        //================sidebar functions===========================
        // Check item and children active state
        var isActive = function (item) {

            if (!item) return;
            
            if (!item.sref || item.sref == '#') {
                var foundActive = false;
                angular.forEach(item.submenu, function (value, key) {
                    if (isActive(value)) foundActive = true;
                });
                return foundActive;
            } else
                return $state.is(item.sref) || $state.includes(item.sref);
        };

        // Load menu from json file
        // -----------------------------------

        function getMenuItemPropClasses(item) {
            return (item.heading ? '' : '') +
                (isActive(item) ? ' active' : '');
        };

        function addCollapse($index, item) {
            vm.collapseList[$index] = !isActive(item);
        };

        function isCollapse($index) {
            return (vm.collapseList[$index]);
        };

        function stateReload(item, event) {
            // console.log(item);
            // console.log(event);
            if (event) {
                var id = '#' + event.currentTarget.id;
                if ($(id).find('ul.sidebar-subnav').length && $("#wrapper").hasClass("smallNav")) { //&& $("#wrapper").hasClass( "smallNav" )
                    var newId = id + ' ul.sidebar-subnav';
                    $(newId).css({
                        'top': $(id).offset().top
                    });

                }
            }

            if (item.submenu && item.submenu.length) {

            } else {
                if (isActive(item)) {
                    console.log(item.text);
                    //$rootScope.$broadcast('StateReload', {data: true});
                }
            }
        }

        function toggleCollapse($index, isParentItem, item) {
            $log.log(isActive(item));
            //if(isActive(item)){
            //  $rootScope.$broadcast('StateReload', {data:true});
            //}
            // make sure the item index exists
            if (angular.isDefined(vm.collapseList[$index])) {
                if (!vm.lastEventFromChild) {
                    vm.collapseList[$index] = !vm.collapseList[$index];
                    closeAllBut($index);
                }
            } else if (isParentItem) {
                closeAllBut(-1);
            }
            vm.lastEventFromChild = isChild($index);
            return true;
        };

        function closeAllBut(index) {
            index += '';
            for (var i in vm.collapseList) {
                if (index < 0 || index.indexOf(i) < 0)
                    vm.collapseList[i] = true;
            }
        };

        function isChild($index) {
            return (typeof $index === 'string') && !($index.indexOf('-') < 0);
        };

        function showSearchOption() {
            $('.inputSearch').toggleClass('showSearch');
        }


        //===================check the all pending requests=====================
        vm.requests = [];
        $scope.$watch(function () {
            return pendingRequests.get();
        }, function (pending) {
            vm.requests = pending;
        });

        //==============binding names with title================
        $rootScope.$on('$stateChangeSuccess',
            function (event, toState, toParams, fromState, fromParams) {
                // display new view from top
                $window.scrollTo(0, 0);

                // To change language - Change in following files
                // file Name - line No
                // App.controller - 175
                // index.config.js - 36
                // ForgotPassword.controller.js - 15
                // Login.controller.js - 15

                $cookies.put('language', 'spanish');
                // $cookies.put('language', 'en');
                // Save the route title
                //$rootScope.previousState = fromState;
                if (fromState.name != toState.name) {
                    pendingRequests.cancelAll();
                }
                $rootScope.currTitle = $state.current.title;
                if ($cookies.get('obj') && toState.name == 'home') {
                    $state.go(fromState.name);
                }
            });

        $rootScope.currTitle = $state.current.title;
        $log.log('title', $state);
        $rootScope.pageTitle = function () {
            var title = $rootScope.app.name + ' - ' + ($rootScope.currTitle || $rootScope.app.description);
            $document.title = title;
            return title;
        };
        //==================logout function======================
        function logOut($event) {
            $log.log('logout');
            var parentEl = angular.element($document.body);

            //==============dialog for confirm====================
            var confirm = $mdDialog.confirm()
                //.title('Do you want to logout?')
                .title(languageBasedErrorFactory.getProperErrorMessage('logOut', 0, '3'))
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent($event)
                .ok(languageBasedErrorFactory.getProperErrorMessage('yes', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('cancelButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                $rootScope.socket.emit('disconnectSocket', {
                    token: $cookies.get('obj')
                }, function (res) {
                    console.log('emit', res);
                });
                var promise = logoutFactory.getLogout(); //$stateParams.id
                promise.then(
                    function (payload) {
                        $log.log('sxdsads', payload);
                        if (payload.title.status == 200) {
                            $cookies.remove('obj');
                            $cookies.remove('adminEmail');
                            $cookies.remove('adminId');
                            localStorage.removeItem('getAdminAccess');
                            localStorage.removeItem('adminName');
                            localStorage.removeItem('getAdminRoles');
                            localStorage.removeItem('searchingFilter');
                            localStorage.removeItem('upcomingFilter');
                            localStorage.removeItem('completedFilter');
                            localStorage.removeItem('ongoingFilter');
                            localStorage.removeItem('quickAssignmentDateFilter');
                            localStorage.removeItem('quickAssignmentFilter');
                            localStorage.removeItem('version');
                            $cookies.remove('language');
                            $cookies.remove('saleShiftId');
                            $rootScope.reconnectFlag = false;
                            $rootScope.socket.disconnect();
                            languageBasedErrorFactory.getTranslationStrings(runThis, 0);
                            $state.go('home');
                        } else if (payload.title.status == 401) {
                            //errorMessageFactory.showErrorMessage(payload.title.message, $event);
                            $cookies.remove('obj');
                            $cookies.remove('adminEmail');
                            $cookies.remove('adminId');
                            $cookies.remove('saleShiftId');
                            localStorage.removeItem('getAdminAccess');
                            localStorage.removeItem('adminName');
                            localStorage.removeItem('getAdminRoles');
                            localStorage.removeItem('quickAssignmentDateFilter');
                            localStorage.removeItem('quickAssignmentFilter');
                            $rootScope.reconnectFlag = false;
                            $rootScope.socket.disconnect();
                            $state.go('home');
                        } else {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        }
                    });
            }, function () {
                $log.log('not confirmed');
            });

        };

        $rootScope.$on("$stateChangeSuccess", function (event, toState, toParams, fromState, fromParams) {
            if (toState.url === "/massiveQuickassignment" || toState.url === "/groupMassiveQuickassignment"  || $state.current.url === "/dashboard"
            || $state.current.url === "/illuminatedZoneServices" ) {
                $rootScope.getConnection();
            }
        });
        //=====================socket Function=========================
        //var $toastlast;

        $rootScope.firstMessage = false;

        $rootScope.getConnection = function () {
            $rootScope.socket = '';
            //delete $rootScope.socket;
            //$scope.$on('$destroy', function (event) {
            //    console.log('In Destroyee Functionnnnnn==============================');
            //    $rootScope.socket.removeAllListeners();
            //});
            $rootScope.socket = io.connect(MY_CONSTANT.url, {
                forceNew: false,
                reconnection: false,
                autoConnect: false,
                transports: ['websocket']
            }); //test-new
            $rootScope.socket.on("connect", function () {
                console.log('>>>>>> SOCKET IN APP >>>>>>>', $rootScope.socket);
                vm.isSocketConnected = true;
                // var socketObject = Object.assign({}, $rootScope.socket);
                // // delete socketObject['json'];
                // // delete socketObject['io'];
                // // delete socketObject.io['connected'];
                // console.log('>>>>>>>>>>>.', socketObject);
                // console.log(objToString($rootScope.socket), $rootScope.socket);
                // $cookies.put('socketDataAndAccessTokanData', JSON.stringify({
                //     accessTokan: $cookies.get('obj'),
                //     socket: socketObject//$.compactJSON($rootScope.socket)//objToString($rootScope.socket)
                // }));
                $rootScope.socket.emit('messageFromClientTrans', {
                    token: $cookies.get('obj'),
                    type: 'admin'
                }, function (res) {
                    // console.log('emait', res);
                });
                $rootScope.socket.on('messageFromServerTrans', function (res) {
                    console.log('on==========', res);
                });
                // $rootScope.socket.on('socketEventToUser',function(res){
                //     console.log('socketEventToUser',res);
                //     $rootScope.$broadcast('SocketComes', {data: res});
                // });
                $rootScope.socket.on('socketEventToUserUpcoming', function (res) {
                    $rootScope.$broadcast('SocketComesUpcoming', {
                        data: true,
                        res: res
                    });
                });
                $rootScope.socket.on('quickScreeenUrgentBookingSocket', function (res) {
                    $rootScope.$broadcast('quickScreeenUrgentBookingSocket', {
                        data: true,
                        res: res
                    });
                });
                $rootScope.socket.on('quickScreeenBookingModifySocket', function (res) {
                    $rootScope.$broadcast('quickScreeenBookingModifySocket', {
                        data: true,
                        res: res
                    });
                });
                $rootScope.socket.on('quickScreeenBookingGroupedSocket', function (res) {
                    $rootScope.$broadcast('quickScreeenBookingGroupedSocket', {
                        data: true,
                        res: res
                    });
                });
                $rootScope.socket.on('quickScreeenBookingCreationSocket', function (res) {
                    $rootScope.$broadcast('quickScreeenBookingCreationSocket', {
                        data: true,
                        res: res
                    });
                });
                $rootScope.socket.on('quickScreeenBookingSharedSocket', function (res) {
                    $rootScope.$broadcast('quickScreeenBookingSharedSocket', {
                        data: true,
                        res: res
                    });
                });
                $rootScope.socket.on('socketEventToUserOngoing', function (res) {
                    $rootScope.$broadcast('SocketComesOngoing', {
                        data: true,
                        res: res
                    });
                });
                $rootScope.socket.on('socketEventPackageCreationForSharedScreen', function (res) {
                    $rootScope.$broadcast('socketEventPackageCreationForSharedScreen', {
                        data: true,
                        res: res
                    });
                });
                $rootScope.socket.on('socketEventUpdatePax', function (res) {
                    $rootScope.$broadcast('socketEventUpdatePax', {
                        data: true,
                        res: res
                    });
                });
                $rootScope.socket.on('socketEventPackageCreationForGroupedScreen', function (res) {
                    $rootScope.$broadcast('socketEventPackageCreationForGroupedScreen', {
                        data: true,
                        res: res
                    });
                });
                $rootScope.socket.on('SocketForBookingPaid', function (res) {
                    $rootScope.$broadcast('SocketForBookingPaid', {
                        data: true,
                        res: res
                    });
                });
                $rootScope.socket.on('socketEventPackageDeletionShared', function (res) {
                    $rootScope.$broadcast('socketEventPackageDeletionShared', {
                        data: true,
                        res: res
                    });
                });
                $rootScope.socket.on('SocketForStartEndShift', function (res) {
                    $rootScope.$broadcast('SocketForStartEndShift', {
                        data: true,
                        res: res
                    });
                });
                $rootScope.socket.on('socketEventToUserCompleted', function (res) {
                    console.log('debug', res);
                    $rootScope.$broadcast('SocketComesCompleted', {
                        data: true,
                        res: res
                    });
                });
                $rootScope.socket.on('socketEventPackageCreation', function (res) {
                    $rootScope.$broadcast('SocketComesShared', {
                        data: true,
                        res: res
                    });
                });
                $rootScope.socket.on('sendGroupedPakageStatusChangeSocket', function (res) {
                    $rootScope.$broadcast('sendGroupedPakageStatusChangeSocket', {
                        data: true,
                        res: res
                    });
                });
                $rootScope.socket.on('socketEventPackageDeletion', function (res) {
                    $rootScope.$broadcast('socketEventDeletion', {
                        data: true,
                        res: res
                    });
                });
                $rootScope.socket.on('socketEventPackageEnded', function (res) {
                    $rootScope.$broadcast('socketEventPackageEnded', {
                        data: res
                    });
                });
                $rootScope.socket.on('sendGroupedPakageBookingCancelSocket', function (res) {
                    $rootScope.$broadcast('sendGroupedPakageBookingCancelSocket', {
                        res: res
                    });
                });
                $rootScope.socket.on('socketEventPackageValidation', function (res) {
                    $rootScope.$broadcast('SocketComesValidation', {
                        data: true,
                        res: res
                    });
                });
                $rootScope.socket.on('socketEventPackageValidationADMINDataAdd', function (res) {
                    $rootScope.$broadcast('socketComesToUnlockTheBooking', {
                        data: true,
                        res: res
                    });
                });
                $rootScope.socket.on('socketbookingPayment', function (res) {
                    $rootScope.$broadcast('SocketComesDetailsBooking', {
                        data: true,
                        res: res
                    });
                });
                $rootScope.socket.on('NotifyToAdminForJob', function (res) {
                    $rootScope.$broadcast('NotifyToAdminForJob', {
                        data: true,
                        res: res
                    });
                });
                $rootScope.socket.on('NotifyToAdminForJobAccepted', function (res) {
                    $rootScope.$broadcast('NotifyToAdminForJobAccepted', {
                        data: true,
                        res: res
                    });
                });
                $rootScope.socket.on('csvPriceAdminFile', function (res) {
                    $rootScope.$broadcast('csvPriceAdminFile', {
                        data: true,
                        res: res
                    });
                });
                $rootScope.socket.on('socketEventAutomaticRefreshAssigned', function (res) {
                    $rootScope.$broadcast('socketEventAutomaticRefreshAssigned', {
                        data: true,
                        res: res
                    });
                });
                $rootScope.socket.on('quickScreeenBookingScanneddSocket', function (res) {
                    $rootScope.$broadcast('quickScreeenBookingScanneddSocket', {
                        data: true,
                        res: res
                    });
                });
                $rootScope.socket.on('quickScreeenBookingunassignedSocket', function (res) {
                    $rootScope.$broadcast('quickScreeenBookingunassignedSocket', {
                        data: true,
                        res: res
                    });
                });
                $rootScope.socket.on('NotifyToAdminForJobMultiple', function (res) {
                    $rootScope.$broadcast('NotifyToAdminForJobMultiple', {
                        data: true,
                        res: res
                    });
                });
                $rootScope.socket.on('NotifyToAdminForJobAcceptedMultiple', function (res) {
                    $rootScope.$broadcast('NotifyToAdminForJobAcceptedMultiple', {
                        data: true,
                        res: res
                    });
                });
                $rootScope.socket.on('quickScreeenBookingAssignedSocket', function (res) {
                    $rootScope.$broadcast('quickScreeenBookingAssignedSocket', {
                        data: true,
                        res: res
                    });
                });
                $rootScope.socket.on('SocketForGetDataDiscardBooking', function (res) {
                    $rootScope.$broadcast('SocketForGetDataDiscardBooking', {
                        data: res
                    });
                });
                $rootScope.socket.on('SocketForGetDataUnDiscardBooking', function (res) {
                    $rootScope.$broadcast('SocketForGetDataUnDiscardBooking', {
                        data: res
                    });
                });
                $rootScope.socket.on('SocketForGetDataEnviarVoucher', function (res) {
                    $rootScope.$broadcast('SocketForGetDataEnviarVoucher', {
                        data: res
                    });
                });
                $rootScope.socket.on('newDriverInIlluminateZoneAdmin', function (res) {
                    console.log('newDriverInIlluminateZoneAdmin', res);
                    $rootScope.$broadcast('SocketComesIlluminated', {
                        data: true,
                        res: res
                    });
                });
                $rootScope.socket.on('cacheBursting', function (res) {
                    // location.reload(true);
                    //   var version =   $cookies.get('version');

                });

                $rootScope.socket.on('bulkUploadAdminFile', function (res) {
                    console.log('bulkUploadAdminFile', res);
                    if (vm.noti == 0) {
                        getAllNotifications();
                    }
                    if (vm.countToSocket == 0) {
                        bulkSuccess(res);
                        $rootScope.$broadcast('SocketComesEmployee', {
                            data: true
                        });
                    }
                });
                $rootScope.socket.on('bulkBookingEndedSocket', function (res) {
                    console.log('bulkBookingEndedSocket>>>>>>>>>', res);
                    if (vm.createBookingCount == 0) {
                        var admid_id = $cookies.get('adminId');
                        if (admid_id == res.message.admin_id) {
                            MassiveCreateBookingSocketPopUp(event, res);
                            vm.createBookingCount++;
                        }
                    }
                });
                $rootScope.socket.on('transvipCargaMasivaProcessComplete', function (res) {
                    console.log('transvipCargaMasivaProcessComplete>>>>>>>>>', res);
                    if (vm.modifyBookingCount == 0) {
                        var admid_id = $cookies.get('adminId');
                        if (admid_id == res.message.admin_id) {
                            MassiveModificationBookingSocketPopUp(event, res);
                            vm.modifyBookingCount++;
                        }
                    }
                });
                $rootScope.socket.on('bulkUploadMinFile', function (res) {
                    var link = document.createElement("a");
                    link.download = res.message.link;
                    link.href = res.message.link;
                    link.click();

                });
                $rootScope.socket.on('driverBlockUnblockSocket', function (res) {
                    $rootScope.$broadcast('driverBlockUnblockSocket', {
                        data: true,
                        res: res
                    });
                });
                $rootScope.socket.on('bulkPackageEndedSocket', function (res) {
                    if (vm.createPackageCount == 0) {
                        var admid_id = $cookies.get('adminId');
                        if (admid_id == res.message.admin_id) {
                            MassiveCreatePackageSocketPopUp(event, res);
                            vm.createPackageCount++;
                        }
                    }
                });
            });
            //});
            console.log($state.current.url, '$state.current.url');
            $rootScope.socket.on('completeDriverXlsxSocket', function (res) {
                if (vm.driverCsvCount == 0) {
                    var admid_id = $cookies.get('adminId');
                    if (admid_id == res.message.admin_id) {
                        driverCsvCountMockUp(event, res);
                        vm.driverCsvCount++;
                    }
                }
            });
            $rootScope.socket.on('onOffDutyXlsxSocket', function (res) {
                if (vm.driverOnOddDustyCsvCount == 0) {
                    var admid_id = $cookies.get('adminId');
                    if (admid_id == res.message.admin_id) {
                        driverCsvCountMockUp(event, res);
                        vm.driverOnOddDustyCsvCount++;
                    }
                }
            });

            $rootScope.firstMessage = true;
            $rootScope.reconnectFlag = "true";
            var maxReconnectAttempts = 100; // Número máximo de intentos de reconexión
            var currentReconnectAttempt = 0; // Contador de intentos de reconexión
            function reconnectSocket() {
                if (!$rootScope.reconnectFlag) {
                    return; // Detener los reintentos si reconnectFlag es false
                }
                if (vm.isSocketConnected) {
                    console.log("La conexión se ha restablecido con éxito.");
                    return; // Detener los reintentos si la conexión ya se ha restablecido
                }
                if ($rootScope.reconnectFlag && currentReconnectAttempt < maxReconnectAttempts) {
                    console.log("Intentando reconectar (Intento " + (currentReconnectAttempt + 1) + ")");
        
                    if ($state.current.url === "/massiveQuickassignment" || $state.current.url === "/groupMassiveQuickassignment"
                    || $state.current.url === "/dashboard" || $state.current.url === "/illuminatedZoneServices") {
                        $rootScope.socket.connect();
                    }
        
                    currentReconnectAttempt++;
                    // Espera un segundo antes de intentar la siguiente reconexión
                    setTimeout(reconnectSocket, 1000);
                }
            }
            $rootScope.socket.on("disconnect", function (data) {
                vm.isSocketConnected = false;
                console.log("Socket Disconnected",$state.current.url);
                console.log($rootScope.socket);
                if ($rootScope.reconnectFlag == "true") {
                    if ($state.current.url === "/massiveQuickassignment" || $state.current.url === "/groupMassiveQuickassignment"
                    || $state.current.url === "/dashboard" || $state.current.url === "/illuminatedZoneServices" ) {
                        reconnectSocket();
                    }
                }
            });

            window.addEventListener('online', function (event) {
                if ($state.current.url === "/massiveQuickassignment" || $state.current.url === "/groupMassiveQuickassignment"
                || $state.current.url === "/dashboard" || $state.current.url === "/illuminatedZoneServices" ) {
                    setTimeout(function () {
                        $rootScope.socket.connect();
                    }, 1000)
                }
            });
        };
        if (!$rootScope.socket) {
            // console.log('>>>>>>>>>>>>>> ACCESS TOKAN FROM COOKIE>>>>>>>',JSON.parse($cookies.get('socketDataAndAccessTokanData')).accessTokan);
            // console.log('>>>>>>>>>>>>>> socket FROM COOKIE >>>>>>>',JSON.parse($cookies.get('socketDataAndAccessTokanData')).socket);
            // console.log(objToString($rootScope.socket), $rootScope.socket);
            // if($cookies.get('obj') == JSON.parse($cookies.get('socketDataAndAccessTokanData')).accessTokan){
            //     $rootScope.socket = JSON.parse($cookies.get('socketDataAndAccessTokanData')).socket;
            // } else {
            $rootScope.getConnection();
            // }
        }

        function objToString(obj) {
            console.log('>>>>>>>>>>>obj>>>>>>>>>', obj);
            var str = '';
            for (var p in obj) {
                console.log('>>>>>> IN P >>>>', p);
                for (var a in p) {
                    if (p.hasOwnProperty(a)) {
                        str += a + '::' + p[a] + '\n';
                    }
                }
            }
            return str;
        }

        // Close the connection when the window is closed
        // $window.addEventListener('beforeunload', function () {
        //     $rootScope.socket.emit('disconnectSocket', {
        //         token: $cookies.get('obj')
        //     }, function (res) {
        //         console.log('emit', res);
        //     });
        //     $rootScope.reconnectFlag = false;
        //     $rootScope.socket.disconnect();
        // });
        $rootScope.adminNameUpper = JSON.parse(localStorage.getItem('adminName'));
        $rootScope.adminRolesUpper = JSON.parse(localStorage.getItem('getAdminRoles'));
        $rootScope.version = JSON.parse(localStorage.getItem('version'));



        //========================get all notifications===================
        function getAllNotifications() {
            vm.noti = vm.noti + 1;
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            var promise = mapDashboard.getNotification(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.noti = 0;
                        if (payload.title.data.final_data && payload.title.data.final_data.length) {
                            vm.notifications = payload.title.data.final_data;
                            vm.notificationsUnread = _.where(vm.notifications, {
                                status: "0"
                            });
                            // console.log('ddddd', vm.notificationsUnread);
                            vm.totalRequestCount = vm.notificationsUnread.length;
                        } else {
                            vm.totalRequestCount = 0;
                            vm.notificationsUnread = [];
                            vm.notifications = [];
                        }
                    }
                },
                function (errorPayload) {
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }
        getAllNotifications();

        function markReadAndDownload(data) {
            console.log(data);

            var link = document.createElement("a");
            link.download = data.link;
            link.href = data.link;
            link.click();

            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.notification_id = data.notification_id;
            var promise = mapDashboard.markNotificationRead(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    getAllNotifications();
                },
                function (errorPayload) {
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );

        }

        function bulkSuccess(res) {
            vm.countToSocket = vm.countToSocket + 1;
            console.log('data', res);
            var parentEl = angular.element($document.body);
            var confirm = $mdDialog.confirm()
                //.title('Do you want to logout?')
                .title(res.message.message)
                .textContent('')
                .ariaLabel('Lucky day')
                .targetEvent(parentEl)
                .ok(languageBasedErrorFactory.getProperErrorMessage('download', 0, '3'))
                .cancel(languageBasedErrorFactory.getProperErrorMessage('cancelButton', 0, '3'));

            $mdDialog.show(confirm).then(function () {
                $log.log('confirmed');
                vm.countToSocket = 0;
                var link = document.createElement("a");
                link.download = res.message.link;
                link.href = res.message.link;
                link.click();

            }, function () {
                $log.log('not confirmed');
                vm.countToSocket = 0;
            });
        }




        //=========================create systems logs of admin=============================
        $rootScope.systemLogsAdmin = function (data) {

            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.id = Number(data.id);
            dataSend.identity = Number(data.identity);
            dataSend.message = data.message;

            vm.loading = true;
            var promise = getAdminRoles.systemLogs(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        };

        //=====================change password=======================
        function changePasswordHit(data) {
            var dataSend = {};
            dataSend.access_token = $cookies.get('obj');
            dataSend.new_password = data.password;
            dataSend.old_password = data.oldPassword;
            vm.loading = true;
            $rootScope.socket.emit('disconnectSocket', {
                token: $cookies.get('obj')
            }, function (res) {
                console.log('emit', res);
            });
            var promise = logoutFactory.changePasswordApi(dataSend);
            promise.then(
                function (payload) {
                    $log.log(payload);
                    vm.loading = false;
                    languageBasedErrorFactory.getProperErrorMessage('passwordSucc', 0, 2, 'home');
                    //errorMessageFactory.showErrorMessage('Password changed successfully.',2,'home');
                    $cookies.remove('obj');
                    $cookies.remove('adminEmail');
                    $cookies.remove('adminId');
                    localStorage.removeItem('getAdminAccess');
                    localStorage.removeItem('adminName');
                    localStorage.removeItem('getAdminRoles');
                    $rootScope.reconnectFlag = false;
                    $rootScope.socket.disconnect();
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        function changePassword($event) {
            vm.items = {
                oldPassword: '',
                password: '',
                confirmPassword: '',
                passwordMatchFlag: false
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/changePassword.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: ChangePasswordController
            });

            function ChangePasswordController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    console.log($scope.items);
                    if ($scope.items.passwordMatchFlag) {
                        return;
                    } else {
                        $mdDialog.hide();
                        changePasswordHit($scope.items);
                    }
                };
                //=======================password match function====================
                $scope.matchConfirmPassword = function (data) {
                    if (data) {
                        if (data != $scope.items.password) {
                            $scope.items.passwordMatchFlag = true;
                        } else {
                            $scope.items.passwordMatchFlag = false;
                        }
                    } else {
                        $scope.items.passwordMatchFlag = false;
                    }
                };
                $scope.matchPassword = function (data) {
                    if (data && $scope.items.confirmPassword) {
                        if (data != $scope.items.confirmPassword) {
                            $scope.items.passwordMatchFlag = true;
                        } else {
                            $scope.items.passwordMatchFlag = false;
                        }
                    }
                };
            }
        }

        function MassiveCreateBookingSocketPopUp($event, data) {
            vm.items = {
                data: data
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/massiveCreateBookingSocketPopUp.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: ChangePasswordController
            });

            function ChangePasswordController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    vm.createBookingCount = 0;
                    $mdDialog.hide();
                };
                $scope.confirmUpload = function () {
                    vm.createBookingCount = 0;
                    var link = document.createElement("a");
                    link.download = data.message.xlsxLink;
                    link.href = data.message.xlsxLink;
                    link.click();
                    $mdDialog.hide();
                };
                $scope.goToNewPage = function () {
                    vm.createBookingCount = 0;
                    $state.go('layout.massiveCreateBookingNewpageMain.massiveCreateBookingNewpage', {
                        id: data.message.refId,
                    });
                    $mdDialog.hide();
                }
            }
        }

        function MassiveModificationBookingSocketPopUp($event, data) {
            vm.items = {
                data: data
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/massiveModificationBookingSocketPopUp.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: ChangePasswordController
            });

            function ChangePasswordController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                    vm.modifyBookingCount = 0;
                };
                $scope.confirmUpload = function () {
                    var link = document.createElement("a");
                    link.download = data.message.excel_link;
                    link.href = data.message.excel_link;
                    link.click();
                    $mdDialog.hide();
                    vm.modifyBookingCount = 0;
                };
                $scope.goToNewPage = function () {
                    $state.go('layout.massiveModifyBookingNewpageMain.massiveModifyBookingNewpage', {
                        id: data.message.carga_masiva_id,
                    });
                    $mdDialog.hide();
                    vm.modifyBookingCount = 0;
                }
            }
        }

        function MassiveCreatePackageSocketPopUp($event, data) {
            vm.items = {
                data: data
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/massiveCreatePackageSocketPopUp.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: ChangePasswordController
            });

            function ChangePasswordController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                    vm.createPackageCount = 0;
                };
                $scope.confirmUpload = function () {
                    var link = document.createElement("a");
                    link.download = data.message.xlsxLink;
                    link.href = data.message.xlsxLink;
                    link.click();
                    $mdDialog.hide();
                    vm.createPackageCount = 0;
                };
                $scope.goToNewPage = function () {
                    $state.go('layout.massiveCreatePackageNewpageMain.massiveCreatePackageNewScreen', {
                        id: data.message.refId,
                    });
                    $mdDialog.hide();
                    vm.createPackageCount = 0;
                }
            }
        }

        function driverCsvCountMockUp($event, data) {
            vm.items = {
                data: data
            };
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: $event,
                templateUrl: 'app/components/dialogViews/driverMockupCsvFinalDownload.html',
                locals: {
                    items: vm.items
                },
                bindToController: true,
                controller: ChangePasswordController
            });

            function ChangePasswordController($scope, $mdDialog, items) {
                $scope.items = items;
                $scope.closeDialog = function () {
                    $mdDialog.hide();
                    vm.driverCsvCount = 0;
                    vm.driverOnOddDustyCsvCount = 0;
                };
                $scope.confirmUpload = function () {
                    var link = document.createElement("a");
                    link.download = data.message.link;
                    link.href = data.message.link;
                    link.click();
                    $mdDialog.hide();
                    vm.driverCsvCount = 0;
                    vm.driverOnOddDustyCsvCount = 0;
                };
            }
        }

        //==============keep idle====================
        //$scope.$on('IdleStart', function() {
        //    console.log('idle start');
        //});
        //
        //$scope.$on('IdleEnd', function() {
        //    console.log('idle end');
        //});
        //
        //$scope.$on('IdleTimeout', function() {
        //    console.log('idle timeout');
        //    $('#idleOut').css('display','block');
        //});

        function wakeUpCall() {
            console.log('asdsad');
            $rootScope.socket.emit('disconnectSocket', {
                token: $cookies.get('obj')
            }, function (res) {
                console.log('emit', res);
            });
            $cookies.remove('obj');
            $cookies.remove('adminEmail');
            $cookies.remove('adminId');
            localStorage.removeItem('getAdminAccess');
            localStorage.removeItem('adminName');
            localStorage.removeItem('getAdminRoles');
            $rootScope.reconnectFlag = false;
            $rootScope.socket.disconnect();
            $state.go('home');
        }
    }
})();

/**
 * Created by cl-macmini-51 on 09/03/18.
 */
(function () {
    'use strict';
    var promise;
    angular
        .module('transVipMain')
        .factory('httpRequestInterceptor', httpRequestInterceptor);

    /** @ngInject */
    function httpRequestInterceptor($window, $q ,$cookies) {
        return {
            request: function (config) {
                config.headers['version'] = '300'; // changes this version with every release or hot fixot 
                localStorage.setItem('version',(config.headers['version']/100) );
                return config;
            },
            responseError: function (response) {
                // console.log(response,"response>>>>>>>>>>>>>>>>>>>>>>>");

                if (response.data == 'version_updated') {
                    $window.location.reload(true)
                }
                return $q.reject(response);
            }
        };
    }

})();

/**
 * Created by cl-macmini-51 on 13/10/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .factory('updateAccessForLoggedInUser', updateAccessForLoggedInUser);

    /** @ngInject */
    function updateAccessForLoggedInUser($log, $http, $q, MY_CONSTANT, $cookies, $rootScope,$state,getAdminRoles,adminAccessService) {
        return{
            updateTheAccessListForLoginAdmin: function(){
                var dataSend = {};
                dataSend.limit = 0;
                dataSend.offset = 0;
                dataSend.admin_id = $cookies.get('adminId');
                var promise = getAdminRoles.getAdminUserList(dataSend);
                promise.then(
                    function(payload) {
                        adminAccessService.putAdminAccess(payload.title.data.result[0].role);
                    },
                    function(errorPayload) {
                    });
            }
        }
    }
})();
/**
 * Created by cl-macmini-51 on 09/10/17.
 */
(function () {
    'use strict';
    angular
        .module('transVipMain')
        .factory('languageBasedErrorFactory', languageBasedErrorFactory);

    /** @ngInject */
    function languageBasedErrorFactory($log, $http, $q, MY_CONSTANT, $cookies, $rootScope, $state, $translate, errorMessageFactory) {
        return {
            getProperErrorMessage: function (stringName, page, type, state) {
                if (page == 'login' || page == 'reset' || page == 'forget') {
                    if (state == undefined || state == null || state == '') {
                        //errorMessageFactory.showErrorMessageL($rootScope.translationStrings[stringName],type,state);
                        errorMessageFactory.showErrorMessage($rootScope.translationStrings[stringName], type, state);
                    } else {
                        //errorMessageFactory.showErrorMessageL($rootScope.translationStrings[stringName],type,state);
                        errorMessageFactory.showErrorMessage($rootScope.translationStrings[stringName], type, state);
                    }
                } else {
                    if (state) {
                        //errorMessageFactory.showErrorMessage($rootScope.translationStrings[stringName],type,state);
                        errorMessageFactory.showErrorMessage($rootScope.translationStrings[stringName], type, state);
                    } else {
                        if (type == '3') {
                            return $rootScope.translationStrings[stringName];
                        } else {
                            //errorMessageFactory.showErrorMessage($rootScope.translationStrings[stringName],type,state);
                            errorMessageFactory.showErrorMessage($rootScope.translationStrings[stringName], type, state);
                        }
                    }
                }
            },
            getTranslationStrings: function (cb , count1) {
                console.log(count1,'count1');
                // if (count1 == 0) {
                    $rootScope.translationStrings = '';
                    if ($cookies.get('language') == 'en') {
                        var translationStrings = 'englishTranslate.json',
                            translationStringsG = translationStrings + '?v=' + (new Date().getTime()); // jumps cache
                    } else {
                        var translationStrings = 'spanishTranslate.json',
                            translationStringsG = translationStrings + '?v=' + (new Date().getTime()); // jumps cache
                    }
                    $http.get(translationStringsG)
                        .then(function (items) {
                            console.log('debug', items);
                            $rootScope.translationStrings = items.data;
                            if (cb) {
                                // count++;
                                cb();
                            }
                        })
                        .catch(function (data, status, headers, config) {})
                    // count++;
                // }
            },
            checkLanguageOnLoad: function () {
                if ($cookies.get('language') == 'en') {
                    $translate.use('englishTranslate');
                    $cookies.put('language', 'en');
                    return 'en';
                } else if ($cookies.get('language') == 'spanish') {
                    $translate.use('spanishTranslate');
                    $cookies.put('language', 'spanish');
                    return 'spanish';
                } else {
                    $translate.use('englishTranslate');
                    $cookies.put('language', 'en');
                    return 'en';
                }
            }
        }
    }
})();
/**
 * Created by cl-macmini-51 on 07/12/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .factory('hidePublicPlaces', hidePublicPlaces);

    /** @ngInject */
    function hidePublicPlaces() {
        return {
            hidePublic: function(){
                var noPoi = [
                    {
                        featureType: "poi",
                        stylers: [
                            { visibility: "off" }
                        ]
                    },
                    {
                        "featureType": "poi.business",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    }
                ];
                return noPoi;
            },
            formattedAddress: function(place){
                var street,route,city,formattedAddress;
                for(var i=0;i<place.address_components.length;i++){
                    for(var j=0;j<place.address_components[i].types.length;j++){
                        if(place.address_components[i].types[j] == 'street_number'){
                            street = place.address_components[i].short_name;
                        }
                        if(place.address_components[i].types[j] == 'route'){
                            route = place.address_components[i].short_name;
                        }
                        if(place.address_components[i].types[j] == 'locality'){
                            city = place.address_components[i].short_name;
                        }
                    }
                }

                //var formattedAddress = place.formatted_address;
                if(street){
                    if(route){
                        if(city){
                            formattedAddress = route + ' ' + street + ', ' + city;
                        }
                        else{
                            formattedAddress = route + ' ' + street;
                        }
                    }
                    else{
                        if(city){
                            formattedAddress = street + ', ' + city;
                        }
                        else{
                            formattedAddress = street;
                        }
                    }
                }
                else{
                    if(route){
                        if(city){
                            formattedAddress = route + ', ' + city;
                        }
                        else{
                            formattedAddress = route;
                        }
                    }
                    else{
                        if(city){
                            formattedAddress = city;
                        }
                        else{
                            formattedAddress = '';
                        }
                    }
                }
                return formattedAddress;
            }
        }
    }
})();

/**
 * Created by cl-macmini-51 on 14/11/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .factory('errorMessageFactory', errorMessageFactory);

    /** @ngInject */
    function errorMessageFactory($log, $http, $q, MY_CONSTANT, $cookies, $rootScope,$state,$translate,$document,$mdDialog) {
        return {
            showErrorMessage: function(msg,type,state){
                var parentEl = angular.element($document.body);
                $mdDialog.show({
                    parent: parentEl,
                    clickOutsideToClose: false,
                    template:
                        '<md-dialog md-theme="default" aria-label="Alert Dialog Demo" ng-class="dialog.css">' +
                        '  <md-dialog-content class="md-dialog-content">' +
                        '    <h2 class="md-title">{{ msg }}</h2>' +
                        '  </md-dialog-content>' +
                        '  <md-dialog-actions>' +
                        '    <md-button class="md-primary md-confirm-button md-autofocus" ng-click="cerrarDialogo()" data-testid="boton-aceptar">' +
                        '      Lo Tengo' +
                        '    </md-button>' +
                        '  </md-dialog-actions>' +
                        '</md-dialog>',
                    controller: function($scope, $mdDialog) {
                        $scope.msg = msg;
                        $scope.cerrarDialogo = function() {
                            $mdDialog.hide();
                        };
                    }
                    //$mdDialog.alert()
                        //.parent(parentEl)
                        //.clickOutsideToClose(false)
                        //.title(msg)
                        //.textContent('')
                        //.ariaLabel('Alert Dialog Demo')
                        //.ok('Lo Tengo')
                    ////.targetEvent($event)
                    })
                    .finally(function() {
                        if(type == 0 || type == '0'){

                        }
                        else if(type == 1 || type == '1'){
                            if(state){
                                $state.reload(state);
                            }
                            else{
                                $state.reload();
                            }
                        }
                        else if(type == 2 || type == '2'){
                            if(state == 'home'){
                                $cookies.remove('obj');
                                $cookies.remove('adminEmail');
                                $cookies.remove('adminId');
                                localStorage.removeItem('getAdminAccess');
                                localStorage.removeItem('adminName');
                                localStorage.removeItem('getAdminRoles');
                                localStorage.removeItem('searchingFilter');
                                localStorage.removeItem('upcomingFilter');
                                localStorage.removeItem('completedFilter');
                                localStorage.removeItem('ongoingFilter');
                                $rootScope.reconnectFlag = false;
                                $rootScope.socket.disconnect();
                                $state.go(state);
                            }
                            else{
                                $state.go(state);
                            }
                        }
                        else{

                        }
                    });
            }
        }
    }
})();

/**
 * Created by cl-macmini-51 on 05/12/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .factory('checkDomain', checkDomain);

    /** @ngInject */
    function checkDomain() {
        return {
            getDomainName: function () {
                if (location.hostname == 'dev.transvip.cl' || location.hostname == 'pet-dev.transvip.cl') {
                    return 'dev';
                } else if (location.hostname == 'test.transvip.cl') {
                    return 'test';
                } else if (location.hostname == 'admin-staging.transvip.cl') {
                    return 'staging';
                } else if (location.hostname == 'admin.transvip.cl' || location.hostname == 'admin-mirror.transvip.cl') {
                    return 'production';
                } else if (location.hostname == 'preprod-admin.transvip.cl' || location.hostname == 'admin-preprod.transvip.cl') {
                    return 'pre-production';
                } else if (location.hostname == 'admin-preprod.transvip.cl') {
                    return 'pre-production';
                } else if (location.hostname == 'pet-qa.transvip.cl') {
                    return 'staging_pet';
                } else if (location.hostname == 'pet-test.transvip.cl') {
                    return 'test_pet';
                } else if (location.hostname == 'admin-elb.transvip.cl' || location.hostname == 'elb-live.transvip.cl') {
                    return 'live';
                } else {
                    return 'dev';
                }

            }
        }
    }
})();

/**
 * Created by cl-macmini-51 on 08/01/18.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .directive('whenScrollEnds', whenScrollEnds);

    /** @ngInject */
    function whenScrollEnds() {
        var directive = {
            link: linkFunc
        };

      
        function linkFunc(scope, element, attrs) {
           
            var threshold = 100;  
            element.scroll(function() {
                var visibleHeight = element.height();
                var scrollableHeight = element.prop('scrollHeight');
                var hiddenContentHeight = scrollableHeight - visibleHeight;
                
                if ((hiddenContentHeight - element.scrollTop()) <= threshold) {
                    // Scroll is almost at the bottom. Loading more rows
                    scope.$apply(attrs.whenScrollEnds);
                }
            });
        }
        return directive;
    }

})();
/**
 * Created by cl-macmini-51 on 22/11/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .directive('tableColumnSorting', tableColumnSorting);

    /** @ngInject */
    function tableColumnSorting($log) {
        var directive = {
            restrict: 'A',
            scope: {
                text: '=',
                check: '=check',
                currentText: '=currentText'
            },
            transclude: true,
            link: linkFunc,
            template: function(scope, el, attr, model){
                return  '<div class="text-center" ng-click="onClick()">'+
                    '<span ng-transclude></span>'+
                    ' <span>'+
                    '<i class="fa" ng-class="{\'fa-caret-down\' : text === currentText && !check,  \'fa-caret-up\' : text===currentText && check , \'fa-sort sortOpacity\' : text!==currentText}"></i>'+
                   ' </span>'+
                    '</div>';
            }
        };

        return directive;

        function linkFunc(scope, el, attr, model) {
            scope.onClick = function () {
                if(scope.text === scope.currentText ) {
                    scope.check = !scope.check
                } else {
                    scope.currentText = scope.text ;
                    scope.check = false;
                }
            }
        }
    }

})();
/**
 * Created by cl-macmini-51 on 11/04/18.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .directive('filterSidebar', filterSidebar);

    /** @ngInject */
    function filterSidebar(getGeofence, errorMessageFactory, getVehicles, getServices, getAgreement, $cookies, $state) {
        var directive = {
            restrict: 'E',
            scope: {
                showFilterSidebar: '=',
                filterData: '=',
                filterToShow: '=',
                branchDetailChanged: '&',
                vehicleDetailChanged: '&',
                serviceDetailChanged: '&',
                agreementDetailChanged: '&',
                virtualFleetDetailChanged: '&',
                operationDetailChanged: '&',
                trafficDetailChanged: '&',
                modelityDetailChanged: '&',
                approvalStageDetailChanged: '&',
                applicantDetailChanged: '&',
                vehicleAssignDetailChanged: '&',
                typeTripDetailChanged: '&'
            },
            templateUrl: 'app/components/views/filterSideBar/filterSideBar.html',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, elm, attr, model) {
            //=====================to hide show side bar==================
            scope.$watch('showFilterSidebar', function (newValue, oldValue) {
                console.log(newValue, oldValue);
                if (newValue) {
                    $('.rightSideBarFilter').addClass('show');
                } else {
                    $('.rightSideBarFilter').removeClass('show');
                }
            });

            scope.disappearFilter = function () {
                scope.showFilterSidebar = false;
            };
            //======================get all branches with geofence data==============
            function getAllBranchesWithGeofenceData() {
                var promise = getGeofence.getAllBranchList(2);
                promise.then(
                    function (payload) {
                        console.log('sxdsads', payload);
                        //vm.loading = false;
                        scope.branch = [];
                        scope.filterData.totalBranchList = payload.title.data;
                        angular.forEach(payload.title.data, function (column) {
                            if (column.is_active == 1 && column.parent_id == 0)
                                scope.branch.push({
                                    id: column.region_id,
                                    name: column.region_name
                                });
                        });
                        scope.branch.push({
                            id: 'all',
                            name: 'All'
                        })
                    },
                    function (errorPayload) {
                        console.log(errorPayload);
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            };
            //=======================branch change=====================
            scope.branchChange = function () {
                console.log(scope.filterData);
                scope.branchDetailChanged(scope.filterData);
            }

            //======================get all vehicles==============
            function getAllVehicles(skip, limt, filter) {
                var promise = getVehicles.allVehicles(skip, limt, filter);
                promise.then(
                    function (payload) {
                        console.log('sxdsads', payload);
                        //vm.loading = false;
                        if (payload.title.status == 400) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            scope.vehicle = [];
                            angular.forEach(payload.title.data.result, function (column) {
                                if (column.status == 1)
                                    scope.vehicle.push({
                                        id: column.id,
                                        name: column.name
                                    })
                            });
                            scope.vehicle.push({
                                id: 'all',
                                name: 'All'
                            });
                        }
                    },
                    function (errorPayload) {
                        console.log(errorPayload);
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            };

            //=======================branch change=====================
            scope.vehicleChanged = function () {
                console.log(scope.filterData);
                scope.vehicleDetailChanged(scope.filterData);
            }

            //======================get all services==============
            function getAllServices(skip, limit) {
                var promise = getServices.allServices(skip, limit, 2 , 0);
                promise.then(
                    function (payload) {
                        console.log('sxdsads', payload);
                        if (payload.title.status == 400) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            scope.service = [];
                            angular.forEach(payload.title.data.result, function (column) {
                                if (column.status == 1)
                                    scope.service.push({
                                        id: column.id,
                                        name: column.service_name
                                    });
                            });
                            scope.service.push({
                                id: 'all',
                                name: 'All'
                            })
                        }
                    },
                    function (errorPayload) {
                        console.log(errorPayload);
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            };

            //=======================branch change=====================
            scope.serviceChanged = function () {
                console.log(scope.filterData);
                scope.serviceDetailChanged(scope.filterData);
            }

            //======================get all services==============
            function getAllAgreement(skip, limt) {
                var dataSend = {};
                dataSend.access_token = $cookies.get('obj');
                dataSend.offset = skip;
                dataSend.limit = limt;
                // dataSend.key = 3;

                var promise = getAgreement.getAgreementListLessData(dataSend);
                promise.then(
                    function (payload) {
                        if (payload.title.status == 400) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            scope.agreement = [];
                            angular.forEach(payload.title.data, function (column) {
                                if (column.status == 1) {
                                    scope.agreement.push({
                                        id: column.id,
                                        name: column.name
                                    });
                                }
                            });
                            scope.agreement.push({
                                id: 'all',
                                name: 'All'
                            });
                        }
                    },
                    function (errorPayload) {
                        console.log(errorPayload);
                        //vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            };

            //=======================branch change=====================
            scope.agreementChanged = function () {
                console.log(scope.filterData);
                scope.agreementDetailChanged(scope.filterData);
            }

            //===================virtual fleet=======================
            scope.total_truck = [];

            scope.virtualFleetChanged = function () {
                console.log(scope.filterData);
                scope.virtualFleetDetailChanged(scope.filterData);
            }

            //===================operation area=======================
            scope.total_operation = [];

            scope.operationChanged = function () {
                console.log(scope.filterData);
                scope.operationDetailChanged(scope.filterData);
            }

            //================help traffic====================

            scope.setBooleans = function (type) {
                switch (type) {
                    case 'HELP_TRAFFIC':
                        if (scope.filterData.helpTraffic) {
                            scope.filterData.helpTraffic = false;
                            scope.trafficDetailChanged(scope.filterData);
                        } else {
                            scope.filterData.helpTraffic = true;
                            scope.trafficDetailChanged(scope.filterData);
                        }
                        break;
                }
            };

            //====================get branch list without geofence====================
            function getBranchWithoutGeofence() {
                var promise = getGeofence.branch();
                promise.then(
                    function (payload) {
                        console.log(payload);
                        if (payload.title.status == 400) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        } else if (payload.title.status == 401) {
                            errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        } else if (payload.title.status == 201 || payload.title.status == 200) {
                            var where = _.where(payload.title.data, {
                                parent_id: 0
                            });
                            //vm.branchList = _.where(where, { is_active: 1 });
                            scope.branchList = where;

                            scope.branchList.push({
                                region_name: 'All',
                                region_id: 'all'
                            });
                        }
                    },
                    function (errorPayload) {
                        console.log(errorPayload);
                        //vm.loading = false;
                        if (errorPayload.data.status == 401) {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                        } else {
                            errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                        }
                    }
                );
            }

            //======================modelity filter=======================
            scope.modelityChanged = function () {
                scope.modelityDetailChanged(scope.filterData);
            }

            //======================approval stage=======================
            scope.approvalStageChanged = function () {
                scope.approvalStageDetailChanged(scope.filterData);
            }

            //======================applicant changed stage=======================
            scope.applicantChanged = function () {
                scope.applicantDetailChanged(scope.filterData);
            }

            //======================vehicle assigned changed=======================
            scope.vehicleAssignChanged = function () {
                scope.vehicleAssignDetailChanged(scope.filterData);
            }

            //===================type of trip=======================
            scope.typeTripFilter = [{
                    text: 'All',
                    id: 'all'
                },
                {
                    text: 'From Airport',
                    id: 'Z'
                },
                {
                    text: 'To Airport',
                    id: 'R'
                },
                {
                    text: 'Point to Point',
                    id: 'P'
                }
            ];

            scope.typeTripChanged = function () {
                scope.typeTripDetailChanged(scope.filterData);
            }

            //=======================function callings==========================
            getAllVehicles(0, 0, 2);
            getAllServices(0, 0);
            getAllAgreement(0, 0);
            if ($state.current.name == 'layout.dashboardMain.dashboard') {
                getAllBranchesWithGeofenceData();
            } else {
                getBranchWithoutGeofence();
            }
        }
    }

})();
/**
 * Created by cl-macmini-51 on 08/01/18.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .directive('whenScrolled', whenScrolled);

    /** @ngInject */
    function whenScrolled() {
        var directive = {
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, elm, attr, model) {
            var raw = elm[0];
            var previousScrollHeight = 0;
            elm.bind('scroll', function() {
                // console.log(raw.scrollTop ,raw, raw.offsetHeight,raw.scrollHeight,previousScrollHeight);
                if (((raw.scrollTop + raw.offsetHeight )>= raw.scrollHeight) ) {
                    // && (raw.scrollHeight > previousScrollHeight)
                    // previousScrollHeight = raw.scrollHeight;
                    scope.$apply(attr.whenScrolled);
                }
            });
        }
    }

})();

/**
 * Created by cl-macmini-51 on 7/12/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .directive('numberDot', numberDot);

    /** @ngInject */
    function numberDot() {
        var directive = {
            require: 'ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, el, attr, model) {
            model.$parsers.push(function (inputValue) {
                // this next if is necessary for when using ng-required on your input.
                // In such cases, when a letter is typed first, this parser will be called
                // again, and the 2nd time, the value will be undefined
                if (inputValue == undefined) return '';
                var transformedInput = inputValue.replace(/[^0-9.]/g, '');
                if (transformedInput!=inputValue) {
                    model.$setViewValue(transformedInput);
                    model.$render();
                }
                return transformedInput;
            });
        }
    }

})();
/**
 * Created by cl-macmini-51 on 6/12/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .directive('isNumber', isNumber);

    /** @ngInject */
    function isNumber() {
        var directive = {
            require: 'ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, el, attr, model) {
            model.$parsers.push(function (inputValue) {
                // this next if is necessary for when using ng-required on your input.
                // In such cases, when a letter is typed first, this parser will be called
                // again, and the 2nd time, the value will be undefined
                if (inputValue == undefined) return '';
                var transformedInput = inputValue.replace(/[^0-9]/g, '');
                if (transformedInput!=inputValue) {
                    model.$setViewValue(transformedInput);
                    model.$render();
                }
                return transformedInput;
            });
        }
    }

})();
//
//return {
//    require: 'ngModel',
//    link: function(scope, element, attrs, modelCtrl) {
//        modelCtrl.$parsers.push(function (inputValue) {
//            // this next if is necessary for when using ng-required on your input.
//            // In such cases, when a letter is typed first, this parser will be called
//            // again, and the 2nd time, the value will be undefined
//            if (inputValue == undefined) return ''
//            var transformedInput = inputValue.replace(/[^0-9]/g, '');
//            if (transformedInput!=inputValue) {
//                modelCtrl.$setViewValue(transformedInput);
//                modelCtrl.$render();
//            }
//
//            return transformedInput;
//        });
//    }
//};
/**
 * Created by cl-macmini-51 on 4/28/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .directive('googlePlace', googlePlace);

    /** @ngInject */
    function googlePlace() {
        var directive = {
            require: 'ngModel',
            link: linkFunc,
            scope: {someCtrlFn: '&callbackFn', ngModel: '='}
        };
        var autocompleteAdded = false;
        ;
        return directive;

        function linkFunc(scope, el, attr, model, ngModel) {
            var flag = false
            el.bind("keyup", function(event) {
                if((!flag) && el[0].value.length >=3){
                    flag = true;
                    scope.gPlace = new google.maps.places.Autocomplete(el[0], {placeIdOnly: true});
                    var geocoder = new google.maps.Geocoder();
                    // autocompleteAdded = true;
                    if (attr.domain != 'dev' && attr.domain != 'test')
                    // scope.gPlace.setComponentRestrictions({
                    //         'country': ['CL']
                    //     });
                    
                    google.maps.event.addListener(scope.gPlace, 'place_changed', function() {
                        scope.$apply(function() {
                            var place = scope.gPlace.getPlace();
                            geocoder.geocode({
                                'placeId': place.place_id
                            }, function (results, status) {
                                if (status !== 'OK') {
                                    window.alert('Geocoder failed due to: ' + status);
                                    return;
                                }
                            scope.someCtrlFn({data:results[0]});
                            model.$setViewValue(el.val());
                        });
                        });
                    });
                  //  $(".pac-container").css('display', 'block');
                }else if(el[0].value.length <3){
                    flag = false;
                    google.maps.event.clearInstanceListeners(el[0]);
                    $(".pac-container").hide();

                }
              });
           
            //var options = {
            //    types: [],
            //    componentRestrictions: {}
            //};
            
            
        }
    }

})();
/**
 * Created by cl-macmini-51 on 7/10/17.
 */
(function() {
    'use strict';

    angular
        .module('transVipMain')
        .directive('alphaNumeric', alphaNumeric);

    /** @ngInject */
    function alphaNumeric() {
        var directive = {
            require: 'ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, el, attr, model) {
            model.$parsers.push(function (inputValue) {
                // this next if is necessary for when using ng-required on your input.
                // In such cases, when a letter is typed first, this parser will be called
                // again, and the 2nd time, the value will be undefined
                if (inputValue == undefined) return '';
                var transformedInput = inputValue.replace(/[^0-9a-zA-Z]/g, '');
                if (transformedInput!=inputValue) {
                    model.$setViewValue(transformedInput);
                    model.$render();
                }
                return transformedInput;
            });
        }
    }

})();
//socket 1.3.7
!function(t){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var e;"undefined"!=typeof window?e=window:"undefined"!=typeof global?e=global:"undefined"!=typeof self&&(e=self),e.io=t()}}(function(){var t;return function e(t,n,r){function o(s,a){if(!n[s]){if(!t[s]){var c="function"==typeof require&&require;if(!a&&c)return c(s,!0);if(i)return i(s,!0);throw new Error("Cannot find module '"+s+"'")}var p=n[s]={exports:{}};t[s][0].call(p.exports,function(e){var n=t[s][1][e];return o(n?n:e)},p,p.exports,e,t,n,r)}return n[s].exports}for(var i="function"==typeof require&&require,s=0;s<r.length;s++)o(r[s]);return o}({1:[function(t,e){e.exports=t("./lib/")},{"./lib/":2}],2:[function(t,e,n){function r(t,e){"object"==typeof t&&(e=t,t=void 0),e=e||{};var n,r=o(t),i=r.source,p=r.id;return e.forceNew||e["force new connection"]||!1===e.multiplex?(a("ignoring socket cache for %s",i),n=s(i,e)):(c[p]||(a("new io instance for %s",i),c[p]=s(i,e)),n=c[p]),n.socket(r.path)}var o=t("./url"),i=t("socket.io-parser"),s=t("./manager"),a=t("debug")("socket.io-client");e.exports=n=r;var c=n.managers={};n.protocol=i.protocol,n.connect=r,n.Manager=t("./manager"),n.Socket=t("./socket")},{"./manager":3,"./socket":5,"./url":6,debug:10,"socket.io-parser":44}],3:[function(t,e){function n(t,e){return this instanceof n?(t&&"object"==typeof t&&(e=t,t=void 0),e=e||{},e.path=e.path||"/socket.io",this.nsps={},this.subs=[],this.opts=e,this.reconnection(e.reconnection!==!1),this.reconnectionAttempts(e.reconnectionAttempts||1/0),this.reconnectionDelay(e.reconnectionDelay||1e3),this.reconnectionDelayMax(e.reconnectionDelayMax||5e3),this.randomizationFactor(e.randomizationFactor||.5),this.backoff=new f({min:this.reconnectionDelay(),max:this.reconnectionDelayMax(),jitter:this.randomizationFactor()}),this.timeout(null==e.timeout?2e4:e.timeout),this.readyState="closed",this.uri=t,this.connected=[],this.encoding=!1,this.packetBuffer=[],this.encoder=new s.Encoder,this.decoder=new s.Decoder,this.autoConnect=e.autoConnect!==!1,void(this.autoConnect&&this.open())):new n(t,e)}var r=(t("./url"),t("engine.io-client")),o=t("./socket"),i=t("component-emitter"),s=t("socket.io-parser"),a=t("./on"),c=t("component-bind"),p=(t("object-component"),t("debug")("socket.io-client:manager")),u=t("indexof"),f=t("backo2");e.exports=n,n.prototype.emitAll=function(){this.emit.apply(this,arguments);for(var t in this.nsps)this.nsps[t].emit.apply(this.nsps[t],arguments)},n.prototype.updateSocketIds=function(){for(var t in this.nsps)this.nsps[t].id=this.engine.id},i(n.prototype),n.prototype.reconnection=function(t){return arguments.length?(this._reconnection=!!t,this):this._reconnection},n.prototype.reconnectionAttempts=function(t){return arguments.length?(this._reconnectionAttempts=t,this):this._reconnectionAttempts},n.prototype.reconnectionDelay=function(t){return arguments.length?(this._reconnectionDelay=t,this.backoff&&this.backoff.setMin(t),this):this._reconnectionDelay},n.prototype.randomizationFactor=function(t){return arguments.length?(this._randomizationFactor=t,this.backoff&&this.backoff.setJitter(t),this):this._randomizationFactor},n.prototype.reconnectionDelayMax=function(t){return arguments.length?(this._reconnectionDelayMax=t,this.backoff&&this.backoff.setMax(t),this):this._reconnectionDelayMax},n.prototype.timeout=function(t){return arguments.length?(this._timeout=t,this):this._timeout},n.prototype.maybeReconnectOnOpen=function(){!this.reconnecting&&this._reconnection&&0===this.backoff.attempts&&this.reconnect()},n.prototype.open=n.prototype.connect=function(t){if(p("readyState %s",this.readyState),~this.readyState.indexOf("open"))return this;p("opening %s",this.uri),this.engine=r(this.uri,this.opts);var e=this.engine,n=this;this.readyState="opening",this.skipReconnect=!1;var o=a(e,"open",function(){n.onopen(),t&&t()}),i=a(e,"error",function(e){if(p("connect_error"),n.cleanup(),n.readyState="closed",n.emitAll("connect_error",e),t){var r=new Error("Connection error");r.data=e,t(r)}else n.maybeReconnectOnOpen()});if(!1!==this._timeout){var s=this._timeout;p("connect attempt will timeout after %d",s);var c=setTimeout(function(){p("connect attempt timed out after %d",s),o.destroy(),e.close(),e.emit("error","timeout"),n.emitAll("connect_timeout",s)},s);this.subs.push({destroy:function(){clearTimeout(c)}})}return this.subs.push(o),this.subs.push(i),this},n.prototype.onopen=function(){p("open"),this.cleanup(),this.readyState="open",this.emit("open");var t=this.engine;this.subs.push(a(t,"data",c(this,"ondata"))),this.subs.push(a(this.decoder,"decoded",c(this,"ondecoded"))),this.subs.push(a(t,"error",c(this,"onerror"))),this.subs.push(a(t,"close",c(this,"onclose")))},n.prototype.ondata=function(t){this.decoder.add(t)},n.prototype.ondecoded=function(t){this.emit("packet",t)},n.prototype.onerror=function(t){p("error",t),this.emitAll("error",t)},n.prototype.socket=function(t){var e=this.nsps[t];if(!e){e=new o(this,t),this.nsps[t]=e;var n=this;e.on("connect",function(){e.id=n.engine.id,~u(n.connected,e)||n.connected.push(e)})}return e},n.prototype.destroy=function(t){var e=u(this.connected,t);~e&&this.connected.splice(e,1),this.connected.length||this.close()},n.prototype.packet=function(t){p("writing packet %j",t);var e=this;e.encoding?e.packetBuffer.push(t):(e.encoding=!0,this.encoder.encode(t,function(t){for(var n=0;n<t.length;n++)e.engine.write(t[n]);e.encoding=!1,e.processPacketQueue()}))},n.prototype.processPacketQueue=function(){if(this.packetBuffer.length>0&&!this.encoding){var t=this.packetBuffer.shift();this.packet(t)}},n.prototype.cleanup=function(){for(var t;t=this.subs.shift();)t.destroy();this.packetBuffer=[],this.encoding=!1,this.decoder.destroy()},n.prototype.close=n.prototype.disconnect=function(){this.skipReconnect=!0,this.backoff.reset(),this.readyState="closed",this.engine&&this.engine.close()},n.prototype.onclose=function(t){p("close"),this.cleanup(),this.backoff.reset(),this.readyState="closed",this.emit("close",t),this._reconnection&&!this.skipReconnect&&this.reconnect()},n.prototype.reconnect=function(){if(this.reconnecting||this.skipReconnect)return this;var t=this;if(this.backoff.attempts>=this._reconnectionAttempts)p("reconnect failed"),this.backoff.reset(),this.emitAll("reconnect_failed"),this.reconnecting=!1;else{var e=this.backoff.duration();p("will wait %dms before reconnect attempt",e),this.reconnecting=!0;var n=setTimeout(function(){t.skipReconnect||(p("attempting reconnect"),t.emitAll("reconnect_attempt",t.backoff.attempts),t.emitAll("reconnecting",t.backoff.attempts),t.skipReconnect||t.open(function(e){e?(p("reconnect attempt error"),t.reconnecting=!1,t.reconnect(),t.emitAll("reconnect_error",e.data)):(p("reconnect success"),t.onreconnect())}))},e);this.subs.push({destroy:function(){clearTimeout(n)}})}},n.prototype.onreconnect=function(){var t=this.backoff.attempts;this.reconnecting=!1,this.backoff.reset(),this.updateSocketIds(),this.emitAll("reconnect",t)}},{"./on":4,"./socket":5,"./url":6,backo2:7,"component-bind":8,"component-emitter":9,debug:10,"engine.io-client":11,indexof:40,"object-component":41,"socket.io-parser":44}],4:[function(t,e){function n(t,e,n){return t.on(e,n),{destroy:function(){t.removeListener(e,n)}}}e.exports=n},{}],5:[function(t,e,n){function r(t,e){this.io=t,this.nsp=e,this.json=this,this.ids=0,this.acks={},this.io.autoConnect&&this.open(),this.receiveBuffer=[],this.sendBuffer=[],this.connected=!1,this.disconnected=!0}var o=t("socket.io-parser"),i=t("component-emitter"),s=t("to-array"),a=t("./on"),c=t("component-bind"),p=t("debug")("socket.io-client:socket"),u=t("has-binary");e.exports=n=r;var f={connect:1,connect_error:1,connect_timeout:1,disconnect:1,error:1,reconnect:1,reconnect_attempt:1,reconnect_failed:1,reconnect_error:1,reconnecting:1},h=i.prototype.emit;i(r.prototype),r.prototype.subEvents=function(){if(!this.subs){var t=this.io;this.subs=[a(t,"open",c(this,"onopen")),a(t,"packet",c(this,"onpacket")),a(t,"close",c(this,"onclose"))]}},r.prototype.open=r.prototype.connect=function(){return this.connected?this:(this.subEvents(),this.io.open(),"open"==this.io.readyState&&this.onopen(),this)},r.prototype.send=function(){var t=s(arguments);return t.unshift("message"),this.emit.apply(this,t),this},r.prototype.emit=function(t){if(f.hasOwnProperty(t))return h.apply(this,arguments),this;var e=s(arguments),n=o.EVENT;u(e)&&(n=o.BINARY_EVENT);var r={type:n,data:e};return"function"==typeof e[e.length-1]&&(p("emitting packet with ack id %d",this.ids),this.acks[this.ids]=e.pop(),r.id=this.ids++),this.connected?this.packet(r):this.sendBuffer.push(r),this},r.prototype.packet=function(t){t.nsp=this.nsp,this.io.packet(t)},r.prototype.onopen=function(){p("transport is open - connecting"),"/"!=this.nsp&&this.packet({type:o.CONNECT})},r.prototype.onclose=function(t){p("close (%s)",t),this.connected=!1,this.disconnected=!0,delete this.id,this.emit("disconnect",t)},r.prototype.onpacket=function(t){if(t.nsp==this.nsp)switch(t.type){case o.CONNECT:this.onconnect();break;case o.EVENT:this.onevent(t);break;case o.BINARY_EVENT:this.onevent(t);break;case o.ACK:this.onack(t);break;case o.BINARY_ACK:this.onack(t);break;case o.DISCONNECT:this.ondisconnect();break;case o.ERROR:this.emit("error",t.data)}},r.prototype.onevent=function(t){var e=t.data||[];p("emitting event %j",e),null!=t.id&&(p("attaching ack callback to event"),e.push(this.ack(t.id))),this.connected?h.apply(this,e):this.receiveBuffer.push(e)},r.prototype.ack=function(t){var e=this,n=!1;return function(){if(!n){n=!0;var r=s(arguments);p("sending ack %j",r);var i=u(r)?o.BINARY_ACK:o.ACK;e.packet({type:i,id:t,data:r})}}},r.prototype.onack=function(t){p("calling ack %s with %j",t.id,t.data);var e=this.acks[t.id];e.apply(this,t.data),delete this.acks[t.id]},r.prototype.onconnect=function(){this.connected=!0,this.disconnected=!1,this.emit("connect"),this.emitBuffered()},r.prototype.emitBuffered=function(){var t;for(t=0;t<this.receiveBuffer.length;t++)h.apply(this,this.receiveBuffer[t]);for(this.receiveBuffer=[],t=0;t<this.sendBuffer.length;t++)this.packet(this.sendBuffer[t]);this.sendBuffer=[]},r.prototype.ondisconnect=function(){p("server disconnect (%s)",this.nsp),this.destroy(),this.onclose("io server disconnect")},r.prototype.destroy=function(){if(this.subs){for(var t=0;t<this.subs.length;t++)this.subs[t].destroy();this.subs=null}this.io.destroy(this)},r.prototype.close=r.prototype.disconnect=function(){return this.connected&&(p("performing disconnect (%s)",this.nsp),this.packet({type:o.DISCONNECT})),this.destroy(),this.connected&&this.onclose("io client disconnect"),this}},{"./on":4,"component-bind":8,"component-emitter":9,debug:10,"has-binary":36,"socket.io-parser":44,"to-array":48}],6:[function(t,e){(function(n){function r(t,e){var r=t,e=e||n.location;return null==t&&(t=e.protocol+"//"+e.host),"string"==typeof t&&("/"==t.charAt(0)&&(t="/"==t.charAt(1)?e.protocol+t:e.hostname+t),/^(https?|wss?):\/\//.test(t)||(i("protocol-less url %s",t),t="undefined"!=typeof e?e.protocol+"//"+t:"https://"+t),i("parse %s",t),r=o(t)),r.port||(/^(http|ws)$/.test(r.protocol)?r.port="80":/^(http|ws)s$/.test(r.protocol)&&(r.port="443")),r.path=r.path||"/",r.id=r.protocol+"://"+r.host+":"+r.port,r.href=r.protocol+"://"+r.host+(e&&e.port==r.port?"":":"+r.port),r}var o=t("parseuri"),i=t("debug")("socket.io-client:url");e.exports=r}).call(this,"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{debug:10,parseuri:42}],7:[function(t,e){function n(t){t=t||{},this.ms=t.min||100,this.max=t.max||1e4,this.factor=t.factor||2,this.jitter=t.jitter>0&&t.jitter<=1?t.jitter:0,this.attempts=0}e.exports=n,n.prototype.duration=function(){var t=this.ms*Math.pow(this.factor,this.attempts++);if(this.jitter){var e=Math.random(),n=Math.floor(e*this.jitter*t);t=0==(1&Math.floor(10*e))?t-n:t+n}return 0|Math.min(t,this.max)},n.prototype.reset=function(){this.attempts=0},n.prototype.setMin=function(t){this.ms=t},n.prototype.setMax=function(t){this.max=t},n.prototype.setJitter=function(t){this.jitter=t}},{}],8:[function(t,e){var n=[].slice;e.exports=function(t,e){if("string"==typeof e&&(e=t[e]),"function"!=typeof e)throw new Error("bind() requires a function");var r=n.call(arguments,2);return function(){return e.apply(t,r.concat(n.call(arguments)))}}},{}],9:[function(t,e){function n(t){return t?r(t):void 0}function r(t){for(var e in n.prototype)t[e]=n.prototype[e];return t}e.exports=n,n.prototype.on=n.prototype.addEventListener=function(t,e){return this._callbacks=this._callbacks||{},(this._callbacks[t]=this._callbacks[t]||[]).push(e),this},n.prototype.once=function(t,e){function n(){r.off(t,n),e.apply(this,arguments)}var r=this;return this._callbacks=this._callbacks||{},n.fn=e,this.on(t,n),this},n.prototype.off=n.prototype.removeListener=n.prototype.removeAllListeners=n.prototype.removeEventListener=function(t,e){if(this._callbacks=this._callbacks||{},0==arguments.length)return this._callbacks={},this;var n=this._callbacks[t];if(!n)return this;if(1==arguments.length)return delete this._callbacks[t],this;for(var r,o=0;o<n.length;o++)if(r=n[o],r===e||r.fn===e){n.splice(o,1);break}return this},n.prototype.emit=function(t){this._callbacks=this._callbacks||{};var e=[].slice.call(arguments,1),n=this._callbacks[t];if(n){n=n.slice(0);for(var r=0,o=n.length;o>r;++r)n[r].apply(this,e)}return this},n.prototype.listeners=function(t){return this._callbacks=this._callbacks||{},this._callbacks[t]||[]},n.prototype.hasListeners=function(t){return!!this.listeners(t).length}},{}],10:[function(t,e){function n(t){return n.enabled(t)?function(e){e=r(e);var o=new Date,i=o-(n[t]||o);n[t]=o,e=t+" "+e+" +"+n.humanize(i),window.console&&console.log&&Function.prototype.apply.call(console.log,console,arguments)}:function(){}}function r(t){return t instanceof Error?t.stack||t.message:t}e.exports=n,n.names=[],n.skips=[],n.enable=function(t){try{localStorage.debug=t}catch(e){}for(var r=(t||"").split(/[\s,]+/),o=r.length,i=0;o>i;i++)t=r[i].replace("*",".*?"),"-"===t[0]?n.skips.push(new RegExp("^"+t.substr(1)+"$")):n.names.push(new RegExp("^"+t+"$"))},n.disable=function(){n.enable("")},n.humanize=function(t){var e=1e3,n=6e4,r=60*n;return t>=r?(t/r).toFixed(1)+"h":t>=n?(t/n).toFixed(1)+"m":t>=e?(t/e|0)+"s":t+"ms"},n.enabled=function(t){for(var e=0,r=n.skips.length;r>e;e++)if(n.skips[e].test(t))return!1;for(var e=0,r=n.names.length;r>e;e++)if(n.names[e].test(t))return!0;return!1};try{window.localStorage&&n.enable(localStorage.debug)}catch(o){}},{}],11:[function(t,e){e.exports=t("./lib/")},{"./lib/":12}],12:[function(t,e){e.exports=t("./socket"),e.exports.parser=t("engine.io-parser")},{"./socket":13,"engine.io-parser":25}],13:[function(t,e){(function(n){function r(t,e){if(!(this instanceof r))return new r(t,e);if(e=e||{},t&&"object"==typeof t&&(e=t,t=null),t&&(t=u(t),e.host=t.host,e.secure="https"==t.protocol||"wss"==t.protocol,e.port=t.port,t.query&&(e.query=t.query)),this.secure=null!=e.secure?e.secure:n.location&&"https:"==location.protocol,e.host){var o=e.host.split(":");e.hostname=o.shift(),o.length?e.port=o.pop():e.port||(e.port=this.secure?"443":"80")}this.agent=e.agent||!1,this.hostname=e.hostname||(n.location?location.hostname:"localhost"),this.port=e.port||(n.location&&location.port?location.port:this.secure?443:80),this.query=e.query||{},"string"==typeof this.query&&(this.query=h.decode(this.query)),this.upgrade=!1!==e.upgrade,this.path=(e.path||"/engine.io").replace(/\/$/,"")+"/",this.forceJSONP=!!e.forceJSONP,this.jsonp=!1!==e.jsonp,this.forceBase64=!!e.forceBase64,this.enablesXDR=!!e.enablesXDR,this.timestampParam=e.timestampParam||"t",this.timestampRequests=e.timestampRequests,this.transports=e.transports||["polling","websocket"],this.readyState="",this.writeBuffer=[],this.callbackBuffer=[],this.policyPort=e.policyPort||843,this.rememberUpgrade=e.rememberUpgrade||!1,this.binaryType=null,this.onlyBinaryUpgrades=e.onlyBinaryUpgrades,this.pfx=e.pfx||null,this.key=e.key||null,this.passphrase=e.passphrase||null,this.cert=e.cert||null,this.ca=e.ca||null,this.ciphers=e.ciphers||null,this.rejectUnauthorized=e.rejectUnauthorized||null,this.open()}function o(t){var e={};for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n]);return e}var i=t("./transports"),s=t("component-emitter"),a=t("debug")("engine.io-client:socket"),c=t("indexof"),p=t("engine.io-parser"),u=t("parseuri"),f=t("parsejson"),h=t("parseqs");e.exports=r,r.priorWebsocketSuccess=!1,s(r.prototype),r.protocol=p.protocol,r.Socket=r,r.Transport=t("./transport"),r.transports=t("./transports"),r.parser=t("engine.io-parser"),r.prototype.createTransport=function(t){a('creating transport "%s"',t);var e=o(this.query);e.EIO=p.protocol,e.transport=t,this.id&&(e.sid=this.id);var n=new i[t]({agent:this.agent,hostname:this.hostname,port:this.port,secure:this.secure,path:this.path,query:e,forceJSONP:this.forceJSONP,jsonp:this.jsonp,forceBase64:this.forceBase64,enablesXDR:this.enablesXDR,timestampRequests:this.timestampRequests,timestampParam:this.timestampParam,policyPort:this.policyPort,socket:this,pfx:this.pfx,key:this.key,passphrase:this.passphrase,cert:this.cert,ca:this.ca,ciphers:this.ciphers,rejectUnauthorized:this.rejectUnauthorized});return n},r.prototype.open=function(){var t;if(this.rememberUpgrade&&r.priorWebsocketSuccess&&-1!=this.transports.indexOf("websocket"))t="websocket";else{if(0==this.transports.length){var e=this;return void setTimeout(function(){e.emit("error","No transports available")},0)}t=this.transports[0]}this.readyState="opening";var t;try{t=this.createTransport(t)}catch(n){return this.transports.shift(),void this.open()}t.open(),this.setTransport(t)},r.prototype.setTransport=function(t){a("setting transport %s",t.name);var e=this;this.transport&&(a("clearing existing transport %s",this.transport.name),this.transport.removeAllListeners()),this.transport=t,t.on("drain",function(){e.onDrain()}).on("packet",function(t){e.onPacket(t)}).on("error",function(t){e.onError(t)}).on("close",function(){e.onClose("transport close")})},r.prototype.probe=function(t){function e(){if(h.onlyBinaryUpgrades){var e=!this.supportsBinary&&h.transport.supportsBinary;f=f||e}f||(a('probe transport "%s" opened',t),u.send([{type:"ping",data:"probe"}]),u.once("packet",function(e){if(!f)if("pong"==e.type&&"probe"==e.data){if(a('probe transport "%s" pong',t),h.upgrading=!0,h.emit("upgrading",u),!u)return;r.priorWebsocketSuccess="websocket"==u.name,a('pausing current transport "%s"',h.transport.name),h.transport.pause(function(){f||"closed"!=h.readyState&&(a("changing transport and sending upgrade packet"),p(),h.setTransport(u),u.send([{type:"upgrade"}]),h.emit("upgrade",u),u=null,h.upgrading=!1,h.flush())})}else{a('probe transport "%s" failed',t);var n=new Error("probe error");n.transport=u.name,h.emit("upgradeError",n)}}))}function n(){f||(f=!0,p(),u.close(),u=null)}function o(e){var r=new Error("probe error: "+e);r.transport=u.name,n(),a('probe transport "%s" failed because of error: %s',t,e),h.emit("upgradeError",r)}function i(){o("transport closed")}function s(){o("socket closed")}function c(t){u&&t.name!=u.name&&(a('"%s" works - aborting "%s"',t.name,u.name),n())}function p(){u.removeListener("open",e),u.removeListener("error",o),u.removeListener("close",i),h.removeListener("close",s),h.removeListener("upgrading",c)}a('probing transport "%s"',t);var u=this.createTransport(t,{probe:1}),f=!1,h=this;r.priorWebsocketSuccess=!1,u.once("open",e),u.once("error",o),u.once("close",i),this.once("close",s),this.once("upgrading",c),u.open()},r.prototype.onOpen=function(){if(a("socket open"),this.readyState="open",r.priorWebsocketSuccess="websocket"==this.transport.name,this.emit("open"),this.flush(),"open"==this.readyState&&this.upgrade&&this.transport.pause){a("starting upgrade probes");for(var t=0,e=this.upgrades.length;e>t;t++)this.probe(this.upgrades[t])}},r.prototype.onPacket=function(t){if("opening"==this.readyState||"open"==this.readyState)switch(a('socket receive: type "%s", data "%s"',t.type,t.data),this.emit("packet",t),this.emit("heartbeat"),t.type){case"open":this.onHandshake(f(t.data));break;case"pong":this.setPing();break;case"error":var e=new Error("server error");e.code=t.data,this.emit("error",e);break;case"message":this.emit("data",t.data),this.emit("message",t.data)}else a('packet received with socket readyState "%s"',this.readyState)},r.prototype.onHandshake=function(t){this.emit("handshake",t),this.id=t.sid,this.transport.query.sid=t.sid,this.upgrades=this.filterUpgrades(t.upgrades),this.pingInterval=t.pingInterval,this.pingTimeout=t.pingTimeout,this.onOpen(),"closed"!=this.readyState&&(this.setPing(),this.removeListener("heartbeat",this.onHeartbeat),this.on("heartbeat",this.onHeartbeat))},r.prototype.onHeartbeat=function(t){clearTimeout(this.pingTimeoutTimer);var e=this;e.pingTimeoutTimer=setTimeout(function(){"closed"!=e.readyState&&e.onClose("ping timeout")},t||e.pingInterval+e.pingTimeout)},r.prototype.setPing=function(){var t=this;clearTimeout(t.pingIntervalTimer),t.pingIntervalTimer=setTimeout(function(){a("writing ping packet - expecting pong within %sms",t.pingTimeout),t.ping(),t.onHeartbeat(t.pingTimeout)},t.pingInterval)},r.prototype.ping=function(){this.sendPacket("ping")},r.prototype.onDrain=function(){for(var t=0;t<this.prevBufferLen;t++)this.callbackBuffer[t]&&this.callbackBuffer[t]();this.writeBuffer.splice(0,this.prevBufferLen),this.callbackBuffer.splice(0,this.prevBufferLen),this.prevBufferLen=0,0==this.writeBuffer.length?this.emit("drain"):this.flush()},r.prototype.flush=function(){"closed"!=this.readyState&&this.transport.writable&&!this.upgrading&&this.writeBuffer.length&&(a("flushing %d packets in socket",this.writeBuffer.length),this.transport.send(this.writeBuffer),this.prevBufferLen=this.writeBuffer.length,this.emit("flush"))},r.prototype.write=r.prototype.send=function(t,e){return this.sendPacket("message",t,e),this},r.prototype.sendPacket=function(t,e,n){if("closing"!=this.readyState&&"closed"!=this.readyState){var r={type:t,data:e};this.emit("packetCreate",r),this.writeBuffer.push(r),this.callbackBuffer.push(n),this.flush()}},r.prototype.close=function(){function t(){r.onClose("forced close"),a("socket closing - telling transport to close"),r.transport.close()}function e(){r.removeListener("upgrade",e),r.removeListener("upgradeError",e),t()}function n(){r.once("upgrade",e),r.once("upgradeError",e)}if("opening"==this.readyState||"open"==this.readyState){this.readyState="closing";var r=this;this.writeBuffer.length?this.once("drain",function(){this.upgrading?n():t()}):this.upgrading?n():t()}return this},r.prototype.onError=function(t){a("socket error %j",t),r.priorWebsocketSuccess=!1,this.emit("error",t),this.onClose("transport error",t)},r.prototype.onClose=function(t,e){if("opening"==this.readyState||"open"==this.readyState||"closing"==this.readyState){a('socket close with reason: "%s"',t);var n=this;clearTimeout(this.pingIntervalTimer),clearTimeout(this.pingTimeoutTimer),setTimeout(function(){n.writeBuffer=[],n.callbackBuffer=[],n.prevBufferLen=0},0),this.transport.removeAllListeners("close"),this.transport.close(),this.transport.removeAllListeners(),this.readyState="closed",this.id=null,this.emit("close",t,e)}},r.prototype.filterUpgrades=function(t){for(var e=[],n=0,r=t.length;r>n;n++)~c(this.transports,t[n])&&e.push(t[n]);return e}}).call(this,"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./transport":14,"./transports":15,"component-emitter":9,debug:22,"engine.io-parser":25,indexof:40,parsejson:32,parseqs:33,parseuri:34}],14:[function(t,e){function n(t){this.path=t.path,this.hostname=t.hostname,this.port=t.port,this.secure=t.secure,this.query=t.query,this.timestampParam=t.timestampParam,this.timestampRequests=t.timestampRequests,this.readyState="",this.agent=t.agent||!1,this.socket=t.socket,this.enablesXDR=t.enablesXDR,this.pfx=t.pfx,this.key=t.key,this.passphrase=t.passphrase,this.cert=t.cert,this.ca=t.ca,this.ciphers=t.ciphers,this.rejectUnauthorized=t.rejectUnauthorized}var r=t("engine.io-parser"),o=t("component-emitter");e.exports=n,o(n.prototype),n.timestamps=0,n.prototype.onError=function(t,e){var n=new Error(t);return n.type="TransportError",n.description=e,this.emit("error",n),this},n.prototype.open=function(){return("closed"==this.readyState||""==this.readyState)&&(this.readyState="opening",this.doOpen()),this},n.prototype.close=function(){return("opening"==this.readyState||"open"==this.readyState)&&(this.doClose(),this.onClose()),this},n.prototype.send=function(t){if("open"!=this.readyState)throw new Error("Transport not open");this.write(t)},n.prototype.onOpen=function(){this.readyState="open",this.writable=!0,this.emit("open")},n.prototype.onData=function(t){var e=r.decodePacket(t,this.socket.binaryType);this.onPacket(e)},n.prototype.onPacket=function(t){this.emit("packet",t)},n.prototype.onClose=function(){this.readyState="closed",this.emit("close")}},{"component-emitter":9,"engine.io-parser":25}],15:[function(t,e,n){(function(e){function r(t){var n,r=!1,a=!1,c=!1!==t.jsonp;if(e.location){var p="https:"==location.protocol,u=location.port;u||(u=p?443:80),r=t.hostname!=location.hostname||u!=t.port,a=t.secure!=p}if(t.xdomain=r,t.xscheme=a,n=new o(t),"open"in n&&!t.forceJSONP)return new i(t);if(!c)throw new Error("JSONP disabled");return new s(t)}var o=t("xmlhttprequest"),i=t("./polling-xhr"),s=t("./polling-jsonp"),a=t("./websocket");n.polling=r,n.websocket=a}).call(this,"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./polling-jsonp":16,"./polling-xhr":17,"./websocket":19,xmlhttprequest:20}],16:[function(t,e){(function(n){function r(){}function o(t){i.call(this,t),this.query=this.query||{},a||(n.___eio||(n.___eio=[]),a=n.___eio),this.index=a.length;var e=this;a.push(function(t){e.onData(t)}),this.query.j=this.index,n.document&&n.addEventListener&&n.addEventListener("beforeunload",function(){e.script&&(e.script.onerror=r)},!1)}var i=t("./polling"),s=t("component-inherit");e.exports=o;var a,c=/\n/g,p=/\\n/g;s(o,i),o.prototype.supportsBinary=!1,o.prototype.doClose=function(){this.script&&(this.script.parentNode.removeChild(this.script),this.script=null),this.form&&(this.form.parentNode.removeChild(this.form),this.form=null,this.iframe=null),i.prototype.doClose.call(this)},o.prototype.doPoll=function(){var t=this,e=document.createElement("script");this.script&&(this.script.parentNode.removeChild(this.script),this.script=null),e.async=!0,e.src=this.uri(),e.onerror=function(e){t.onError("jsonp poll error",e)};var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(e,n),this.script=e;var r="undefined"!=typeof navigator&&/gecko/i.test(navigator.userAgent);r&&setTimeout(function(){var t=document.createElement("iframe");document.body.appendChild(t),document.body.removeChild(t)},100)},o.prototype.doWrite=function(t,e){function n(){r(),e()}function r(){if(o.iframe)try{o.form.removeChild(o.iframe)}catch(t){o.onError("jsonp polling iframe removal error",t)}try{var e='<iframe src="javascript:0" name="'+o.iframeId+'">';i=document.createElement(e)}catch(t){i=document.createElement("iframe"),i.name=o.iframeId,i.src="javascript:0"}i.id=o.iframeId,o.form.appendChild(i),o.iframe=i}var o=this;if(!this.form){var i,s=document.createElement("form"),a=document.createElement("textarea"),u=this.iframeId="eio_iframe_"+this.index;s.className="socketio",s.style.position="absolute",s.style.top="-1000px",s.style.left="-1000px",s.target=u,s.method="POST",s.setAttribute("accept-charset","utf-8"),a.name="d",s.appendChild(a),document.body.appendChild(s),this.form=s,this.area=a}this.form.action=this.uri(),r(),t=t.replace(p,"\\\n"),this.area.value=t.replace(c,"\\n");try{this.form.submit()}catch(f){}this.iframe.attachEvent?this.iframe.onreadystatechange=function(){"complete"==o.iframe.readyState&&n()}:this.iframe.onload=n}}).call(this,"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./polling":18,"component-inherit":21}],17:[function(t,e){(function(n){function r(){}function o(t){if(c.call(this,t),n.location){var e="https:"==location.protocol,r=location.port;r||(r=e?443:80),this.xd=t.hostname!=n.location.hostname||r!=t.port,this.xs=t.secure!=e}}function i(t){this.method=t.method||"GET",this.uri=t.uri,this.xd=!!t.xd,this.xs=!!t.xs,this.async=!1!==t.async,this.data=void 0!=t.data?t.data:null,this.agent=t.agent,this.isBinary=t.isBinary,this.supportsBinary=t.supportsBinary,this.enablesXDR=t.enablesXDR,this.pfx=t.pfx,this.key=t.key,this.passphrase=t.passphrase,this.cert=t.cert,this.ca=t.ca,this.ciphers=t.ciphers,this.rejectUnauthorized=t.rejectUnauthorized,this.create()}function s(){for(var t in i.requests)i.requests.hasOwnProperty(t)&&i.requests[t].abort()}var a=t("xmlhttprequest"),c=t("./polling"),p=t("component-emitter"),u=t("component-inherit"),f=t("debug")("engine.io-client:polling-xhr");e.exports=o,e.exports.Request=i,u(o,c),o.prototype.supportsBinary=!0,o.prototype.request=function(t){return t=t||{},t.uri=this.uri(),t.xd=this.xd,t.xs=this.xs,t.agent=this.agent||!1,t.supportsBinary=this.supportsBinary,t.enablesXDR=this.enablesXDR,t.pfx=this.pfx,t.key=this.key,t.passphrase=this.passphrase,t.cert=this.cert,t.ca=this.ca,t.ciphers=this.ciphers,t.rejectUnauthorized=this.rejectUnauthorized,new i(t)},o.prototype.doWrite=function(t,e){var n="string"!=typeof t&&void 0!==t,r=this.request({method:"POST",data:t,isBinary:n}),o=this;r.on("success",e),r.on("error",function(t){o.onError("xhr post error",t)}),this.sendXhr=r},o.prototype.doPoll=function(){f("xhr poll");var t=this.request(),e=this;t.on("data",function(t){e.onData(t)}),t.on("error",function(t){e.onError("xhr poll error",t)}),this.pollXhr=t},p(i.prototype),i.prototype.create=function(){var t={agent:this.agent,xdomain:this.xd,xscheme:this.xs,enablesXDR:this.enablesXDR};t.pfx=this.pfx,t.key=this.key,t.passphrase=this.passphrase,t.cert=this.cert,t.ca=this.ca,t.ciphers=this.ciphers,t.rejectUnauthorized=this.rejectUnauthorized;var e=this.xhr=new a(t),r=this;try{if(f("xhr open %s: %s",this.method,this.uri),e.open(this.method,this.uri,this.async),this.supportsBinary&&(e.responseType="arraybuffer"),"POST"==this.method)try{this.isBinary?e.setRequestHeader("Content-type","application/octet-stream"):e.setRequestHeader("Content-type","text/plain;charset=UTF-8")}catch(o){}"withCredentials"in e&&(e.withCredentials=!0),this.hasXDR()?(e.onload=function(){r.onLoad()},e.onerror=function(){r.onError(e.responseText)}):e.onreadystatechange=function(){4==e.readyState&&(200==e.status||1223==e.status?r.onLoad():setTimeout(function(){r.onError(e.status)},0))},f("xhr data %s",this.data),e.send(this.data)}catch(o){return void setTimeout(function(){r.onError(o)},0)}n.document&&(this.index=i.requestsCount++,i.requests[this.index]=this)},i.prototype.onSuccess=function(){this.emit("success"),this.cleanup()},i.prototype.onData=function(t){this.emit("data",t),this.onSuccess()},i.prototype.onError=function(t){this.emit("error",t),this.cleanup(!0)},i.prototype.cleanup=function(t){if("undefined"!=typeof this.xhr&&null!==this.xhr){if(this.hasXDR()?this.xhr.onload=this.xhr.onerror=r:this.xhr.onreadystatechange=r,t)try{this.xhr.abort()}catch(e){}n.document&&delete i.requests[this.index],this.xhr=null}},i.prototype.onLoad=function(){var t;try{var e;try{e=this.xhr.getResponseHeader("Content-Type").split(";")[0]}catch(n){}t="application/octet-stream"===e?this.xhr.response:this.supportsBinary?"ok":this.xhr.responseText}catch(n){this.onError(n)}null!=t&&this.onData(t)},i.prototype.hasXDR=function(){return"undefined"!=typeof n.XDomainRequest&&!this.xs&&this.enablesXDR},i.prototype.abort=function(){this.cleanup()},n.document&&(i.requestsCount=0,i.requests={},n.attachEvent?n.attachEvent("onunload",s):n.addEventListener&&n.addEventListener("beforeunload",s,!1))}).call(this,"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./polling":18,"component-emitter":9,"component-inherit":21,debug:22,xmlhttprequest:20}],18:[function(t,e){function n(t){var e=t&&t.forceBase64;
    (!c||e)&&(this.supportsBinary=!1),r.call(this,t)}var r=t("../transport"),o=t("parseqs"),i=t("engine.io-parser"),s=t("component-inherit"),a=t("debug")("engine.io-client:polling");e.exports=n;var c=function(){var e=t("xmlhttprequest"),n=new e({xdomain:!1});return null!=n.responseType}();s(n,r),n.prototype.name="polling",n.prototype.doOpen=function(){this.poll()},n.prototype.pause=function(t){function e(){a("paused"),n.readyState="paused",t()}var n=this;if(this.readyState="pausing",this.polling||!this.writable){var r=0;this.polling&&(a("we are currently polling - waiting to pause"),r++,this.once("pollComplete",function(){a("pre-pause polling complete"),--r||e()})),this.writable||(a("we are currently writing - waiting to pause"),r++,this.once("drain",function(){a("pre-pause writing complete"),--r||e()}))}else e()},n.prototype.poll=function(){a("polling"),this.polling=!0,this.doPoll(),this.emit("poll")},n.prototype.onData=function(t){var e=this;a("polling got data %s",t);var n=function(t){return"opening"==e.readyState&&e.onOpen(),"close"==t.type?(e.onClose(),!1):void e.onPacket(t)};i.decodePayload(t,this.socket.binaryType,n),"closed"!=this.readyState&&(this.polling=!1,this.emit("pollComplete"),"open"==this.readyState?this.poll():a('ignoring poll - transport state "%s"',this.readyState))},n.prototype.doClose=function(){function t(){a("writing close packet"),e.write([{type:"close"}])}var e=this;"open"==this.readyState?(a("transport open - closing"),t()):(a("transport not open - deferring close"),this.once("open",t))},n.prototype.write=function(t){var e=this;this.writable=!1;var n=function(){e.writable=!0,e.emit("drain")},e=this;i.encodePayload(t,this.supportsBinary,function(t){e.doWrite(t,n)})},n.prototype.uri=function(){var t=this.query||{},e=this.secure?"https":"http",n="";return!1!==this.timestampRequests&&(t[this.timestampParam]=+new Date+"-"+r.timestamps++),this.supportsBinary||t.sid||(t.b64=1),t=o.encode(t),this.port&&("https"==e&&443!=this.port||"http"==e&&80!=this.port)&&(n=":"+this.port),t.length&&(t="?"+t),e+"://"+this.hostname+n+this.path+t}},{"../transport":14,"component-inherit":21,debug:22,"engine.io-parser":25,parseqs:33,xmlhttprequest:20}],19:[function(t,e){function n(t){var e=t&&t.forceBase64;e&&(this.supportsBinary=!1),r.call(this,t)}var r=t("../transport"),o=t("engine.io-parser"),i=t("parseqs"),s=t("component-inherit"),a=t("debug")("engine.io-client:websocket"),c=t("ws");e.exports=n,s(n,r),n.prototype.name="websocket",n.prototype.supportsBinary=!0,n.prototype.doOpen=function(){if(this.check()){var t=this.uri(),e=void 0,n={agent:this.agent};n.pfx=this.pfx,n.key=this.key,n.passphrase=this.passphrase,n.cert=this.cert,n.ca=this.ca,n.ciphers=this.ciphers,n.rejectUnauthorized=this.rejectUnauthorized,this.ws=new c(t,e,n),void 0===this.ws.binaryType&&(this.supportsBinary=!1),this.ws.binaryType="arraybuffer",this.addEventListeners()}},n.prototype.addEventListeners=function(){var t=this;this.ws.onopen=function(){t.onOpen()},this.ws.onclose=function(){t.onClose()},this.ws.onmessage=function(e){t.onData(e.data)},this.ws.onerror=function(e){t.onError("websocket error",e)}},"undefined"!=typeof navigator&&/iPad|iPhone|iPod/i.test(navigator.userAgent)&&(n.prototype.onData=function(t){var e=this;setTimeout(function(){r.prototype.onData.call(e,t)},0)}),n.prototype.write=function(t){function e(){n.writable=!0,n.emit("drain")}var n=this;this.writable=!1;for(var r=0,i=t.length;i>r;r++)o.encodePacket(t[r],this.supportsBinary,function(t){try{n.ws.send(t)}catch(e){a("websocket closed before onclose event")}});setTimeout(e,0)},n.prototype.onClose=function(){r.prototype.onClose.call(this)},n.prototype.doClose=function(){"undefined"!=typeof this.ws&&this.ws.close()},n.prototype.uri=function(){var t=this.query||{},e=this.secure?"wss":"ws",n="";return this.port&&("wss"==e&&443!=this.port||"ws"==e&&80!=this.port)&&(n=":"+this.port),this.timestampRequests&&(t[this.timestampParam]=+new Date),this.supportsBinary||(t.b64=1),t=i.encode(t),t.length&&(t="?"+t),e+"://"+this.hostname+n+this.path+t},n.prototype.check=function(){return!(!c||"__initialize"in c&&this.name===n.prototype.name)}},{"../transport":14,"component-inherit":21,debug:22,"engine.io-parser":25,parseqs:33,ws:35}],20:[function(t,e){var n=t("has-cors");e.exports=function(t){var e=t.xdomain,r=t.xscheme,o=t.enablesXDR;try{if("undefined"!=typeof XMLHttpRequest&&(!e||n))return new XMLHttpRequest}catch(i){}try{if("undefined"!=typeof XDomainRequest&&!r&&o)return new XDomainRequest}catch(i){}if(!e)try{return new ActiveXObject("Microsoft.XMLHTTP")}catch(i){}}},{"has-cors":38}],21:[function(t,e){e.exports=function(t,e){var n=function(){};n.prototype=e.prototype,t.prototype=new n,t.prototype.constructor=t}},{}],22:[function(t,e,n){function r(){return"WebkitAppearance"in document.documentElement.style||window.console&&(console.firebug||console.exception&&console.table)||navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)&&parseInt(RegExp.$1,10)>=31}function o(){var t=arguments,e=this.useColors;if(t[0]=(e?"%c":"")+this.namespace+(e?" %c":" ")+t[0]+(e?"%c ":" ")+"+"+n.humanize(this.diff),!e)return t;var r="color: "+this.color;t=[t[0],r,"color: inherit"].concat(Array.prototype.slice.call(t,1));var o=0,i=0;return t[0].replace(/%[a-z%]/g,function(t){"%%"!==t&&(o++,"%c"===t&&(i=o))}),t.splice(i,0,r),t}function i(){return"object"==typeof console&&"function"==typeof console.log&&Function.prototype.apply.call(console.log,console,arguments)}function s(t){try{null==t?localStorage.removeItem("debug"):localStorage.debug=t}catch(e){}}function a(){var t;try{t=localStorage.debug}catch(e){}return t}n=e.exports=t("./debug"),n.log=i,n.formatArgs=o,n.save=s,n.load=a,n.useColors=r,n.colors=["lightseagreen","forestgreen","goldenrod","dodgerblue","darkorchid","crimson"],n.formatters.j=function(t){return JSON.stringify(t)},n.enable(a())},{"./debug":23}],23:[function(t,e,n){function r(){return n.colors[u++%n.colors.length]}function o(t){function e(){}function o(){var t=o,e=+new Date,i=e-(p||e);t.diff=i,t.prev=p,t.curr=e,p=e,null==t.useColors&&(t.useColors=n.useColors()),null==t.color&&t.useColors&&(t.color=r());var s=Array.prototype.slice.call(arguments);s[0]=n.coerce(s[0]),"string"!=typeof s[0]&&(s=["%o"].concat(s));var a=0;s[0]=s[0].replace(/%([a-z%])/g,function(e,r){if("%%"===e)return e;a++;var o=n.formatters[r];if("function"==typeof o){var i=s[a];e=o.call(t,i),s.splice(a,1),a--}return e}),"function"==typeof n.formatArgs&&(s=n.formatArgs.apply(t,s));var c=o.log||n.log||console.log.bind(console);c.apply(t,s)}e.enabled=!1,o.enabled=!0;var i=n.enabled(t)?o:e;return i.namespace=t,i}function i(t){n.save(t);for(var e=(t||"").split(/[\s,]+/),r=e.length,o=0;r>o;o++)e[o]&&(t=e[o].replace(/\*/g,".*?"),"-"===t[0]?n.skips.push(new RegExp("^"+t.substr(1)+"$")):n.names.push(new RegExp("^"+t+"$")))}function s(){n.enable("")}function a(t){var e,r;for(e=0,r=n.skips.length;r>e;e++)if(n.skips[e].test(t))return!1;for(e=0,r=n.names.length;r>e;e++)if(n.names[e].test(t))return!0;return!1}function c(t){return t instanceof Error?t.stack||t.message:t}n=e.exports=o,n.coerce=c,n.disable=s,n.enable=i,n.enabled=a,n.humanize=t("ms"),n.names=[],n.skips=[],n.formatters={};var p,u=0},{ms:24}],24:[function(t,e){function n(t){var e=/^((?:\d+)?\.?\d+) *(ms|seconds?|s|minutes?|m|hours?|h|days?|d|years?|y)?$/i.exec(t);if(e){var n=parseFloat(e[1]),r=(e[2]||"ms").toLowerCase();switch(r){case"years":case"year":case"y":return n*u;case"days":case"day":case"d":return n*p;case"hours":case"hour":case"h":return n*c;case"minutes":case"minute":case"m":return n*a;case"seconds":case"second":case"s":return n*s;case"ms":return n}}}function r(t){return t>=p?Math.round(t/p)+"d":t>=c?Math.round(t/c)+"h":t>=a?Math.round(t/a)+"m":t>=s?Math.round(t/s)+"s":t+"ms"}function o(t){return i(t,p,"day")||i(t,c,"hour")||i(t,a,"minute")||i(t,s,"second")||t+" ms"}function i(t,e,n){return e>t?void 0:1.5*e>t?Math.floor(t/e)+" "+n:Math.ceil(t/e)+" "+n+"s"}var s=1e3,a=60*s,c=60*a,p=24*c,u=365.25*p;e.exports=function(t,e){return e=e||{},"string"==typeof t?n(t):e.long?o(t):r(t)}},{}],25:[function(t,e,n){(function(e){function r(t,e){var r="b"+n.packets[t.type]+t.data.data;return e(r)}function o(t,e,r){if(!e)return n.encodeBase64Packet(t,r);var o=t.data,i=new Uint8Array(o),s=new Uint8Array(1+o.byteLength);s[0]=m[t.type];for(var a=0;a<i.length;a++)s[a+1]=i[a];return r(s.buffer)}function i(t,e,r){if(!e)return n.encodeBase64Packet(t,r);var o=new FileReader;return o.onload=function(){t.data=o.result,n.encodePacket(t,e,!0,r)},o.readAsArrayBuffer(t.data)}function s(t,e,r){if(!e)return n.encodeBase64Packet(t,r);if(g)return i(t,e,r);var o=new Uint8Array(1);o[0]=m[t.type];var s=new w([o.buffer,t.data]);return r(s)}function a(t,e,n){for(var r=new Array(t.length),o=h(t.length,n),i=function(t,n,o){e(n,function(e,n){r[t]=n,o(e,r)})},s=0;s<t.length;s++)i(s,t[s],o)}var c=t("./keys"),p=t("has-binary"),u=t("arraybuffer.slice"),f=t("base64-arraybuffer"),h=t("after"),l=t("utf8"),d=navigator.userAgent.match(/Android/i),y=/PhantomJS/i.test(navigator.userAgent),g=d||y;n.protocol=3;var m=n.packets={open:0,close:1,ping:2,pong:3,message:4,upgrade:5,noop:6},v=c(m),b={type:"error",data:"parser error"},w=t("blob");n.encodePacket=function(t,n,i,a){"function"==typeof n&&(a=n,n=!1),"function"==typeof i&&(a=i,i=null);var c=void 0===t.data?void 0:t.data.buffer||t.data;if(e.ArrayBuffer&&c instanceof ArrayBuffer)return o(t,n,a);if(w&&c instanceof e.Blob)return s(t,n,a);if(c&&c.base64)return r(t,a);var p=m[t.type];return void 0!==t.data&&(p+=i?l.encode(String(t.data)):String(t.data)),a(""+p)},n.encodeBase64Packet=function(t,r){var o="b"+n.packets[t.type];if(w&&t.data instanceof w){var i=new FileReader;return i.onload=function(){var t=i.result.split(",")[1];r(o+t)},i.readAsDataURL(t.data)}var s;try{s=String.fromCharCode.apply(null,new Uint8Array(t.data))}catch(a){for(var c=new Uint8Array(t.data),p=new Array(c.length),u=0;u<c.length;u++)p[u]=c[u];s=String.fromCharCode.apply(null,p)}return o+=e.btoa(s),r(o)},n.decodePacket=function(t,e,r){if("string"==typeof t||void 0===t){if("b"==t.charAt(0))return n.decodeBase64Packet(t.substr(1),e);if(r)try{t=l.decode(t)}catch(o){return b}var i=t.charAt(0);return Number(i)==i&&v[i]?t.length>1?{type:v[i],data:t.substring(1)}:{type:v[i]}:b}var s=new Uint8Array(t),i=s[0],a=u(t,1);return w&&"blob"===e&&(a=new w([a])),{type:v[i],data:a}},n.decodeBase64Packet=function(t,n){var r=v[t.charAt(0)];if(!e.ArrayBuffer)return{type:r,data:{base64:!0,data:t.substr(1)}};var o=f.decode(t.substr(1));return"blob"===n&&w&&(o=new w([o])),{type:r,data:o}},n.encodePayload=function(t,e,r){function o(t){return t.length+":"+t}function i(t,r){n.encodePacket(t,s?e:!1,!0,function(t){r(null,o(t))})}"function"==typeof e&&(r=e,e=null);var s=p(t);return e&&s?w&&!g?n.encodePayloadAsBlob(t,r):n.encodePayloadAsArrayBuffer(t,r):t.length?void a(t,i,function(t,e){return r(e.join(""))}):r("0:")},n.decodePayload=function(t,e,r){if("string"!=typeof t)return n.decodePayloadAsBinary(t,e,r);"function"==typeof e&&(r=e,e=null);var o;if(""==t)return r(b,0,1);for(var i,s,a="",c=0,p=t.length;p>c;c++){var u=t.charAt(c);if(":"!=u)a+=u;else{if(""==a||a!=(i=Number(a)))return r(b,0,1);if(s=t.substr(c+1,i),a!=s.length)return r(b,0,1);if(s.length){if(o=n.decodePacket(s,e,!0),b.type==o.type&&b.data==o.data)return r(b,0,1);var f=r(o,c+i,p);if(!1===f)return}c+=i,a=""}}return""!=a?r(b,0,1):void 0},n.encodePayloadAsArrayBuffer=function(t,e){function r(t,e){n.encodePacket(t,!0,!0,function(t){return e(null,t)})}return t.length?void a(t,r,function(t,n){var r=n.reduce(function(t,e){var n;return n="string"==typeof e?e.length:e.byteLength,t+n.toString().length+n+2},0),o=new Uint8Array(r),i=0;return n.forEach(function(t){var e="string"==typeof t,n=t;if(e){for(var r=new Uint8Array(t.length),s=0;s<t.length;s++)r[s]=t.charCodeAt(s);n=r.buffer}o[i++]=e?0:1;for(var a=n.byteLength.toString(),s=0;s<a.length;s++)o[i++]=parseInt(a[s]);o[i++]=255;for(var r=new Uint8Array(n),s=0;s<r.length;s++)o[i++]=r[s]}),e(o.buffer)}):e(new ArrayBuffer(0))},n.encodePayloadAsBlob=function(t,e){function r(t,e){n.encodePacket(t,!0,!0,function(t){var n=new Uint8Array(1);if(n[0]=1,"string"==typeof t){for(var r=new Uint8Array(t.length),o=0;o<t.length;o++)r[o]=t.charCodeAt(o);t=r.buffer,n[0]=0}for(var i=t instanceof ArrayBuffer?t.byteLength:t.size,s=i.toString(),a=new Uint8Array(s.length+1),o=0;o<s.length;o++)a[o]=parseInt(s[o]);if(a[s.length]=255,w){var c=new w([n.buffer,a.buffer,t]);e(null,c)}})}a(t,r,function(t,n){return e(new w(n))})},n.decodePayloadAsBinary=function(t,e,r){"function"==typeof e&&(r=e,e=null);for(var o=t,i=[],s=!1;o.byteLength>0;){for(var a=new Uint8Array(o),c=0===a[0],p="",f=1;255!=a[f];f++){if(p.length>310){s=!0;break}p+=a[f]}if(s)return r(b,0,1);o=u(o,2+p.length),p=parseInt(p);var h=u(o,0,p);if(c)try{h=String.fromCharCode.apply(null,new Uint8Array(h))}catch(l){var d=new Uint8Array(h);h="";for(var f=0;f<d.length;f++)h+=String.fromCharCode(d[f])}i.push(h),o=u(o,p)}var y=i.length;i.forEach(function(t,o){r(n.decodePacket(t,e,!0),o,y)})}}).call(this,"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./keys":26,after:27,"arraybuffer.slice":28,"base64-arraybuffer":29,blob:30,"has-binary":36,utf8:31}],26:[function(t,e){e.exports=Object.keys||function(t){var e=[],n=Object.prototype.hasOwnProperty;for(var r in t)n.call(t,r)&&e.push(r);return e}},{}],27:[function(t,e){function n(t,e,n){function o(t,r){if(o.count<=0)throw new Error("after called too many times");--o.count,t?(i=!0,e(t),e=n):0!==o.count||i||e(null,r)}var i=!1;return n=n||r,o.count=t,0===t?e():o}function r(){}e.exports=n},{}],28:[function(t,e){e.exports=function(t,e,n){var r=t.byteLength;if(e=e||0,n=n||r,t.slice)return t.slice(e,n);if(0>e&&(e+=r),0>n&&(n+=r),n>r&&(n=r),e>=r||e>=n||0===r)return new ArrayBuffer(0);for(var o=new Uint8Array(t),i=new Uint8Array(n-e),s=e,a=0;n>s;s++,a++)i[a]=o[s];return i.buffer}},{}],29:[function(t,e,n){!function(t){"use strict";n.encode=function(e){var n,r=new Uint8Array(e),o=r.length,i="";for(n=0;o>n;n+=3)i+=t[r[n]>>2],i+=t[(3&r[n])<<4|r[n+1]>>4],i+=t[(15&r[n+1])<<2|r[n+2]>>6],i+=t[63&r[n+2]];return o%3===2?i=i.substring(0,i.length-1)+"=":o%3===1&&(i=i.substring(0,i.length-2)+"=="),i},n.decode=function(e){var n,r,o,i,s,a=.75*e.length,c=e.length,p=0;"="===e[e.length-1]&&(a--,"="===e[e.length-2]&&a--);var u=new ArrayBuffer(a),f=new Uint8Array(u);for(n=0;c>n;n+=4)r=t.indexOf(e[n]),o=t.indexOf(e[n+1]),i=t.indexOf(e[n+2]),s=t.indexOf(e[n+3]),f[p++]=r<<2|o>>4,f[p++]=(15&o)<<4|i>>2,f[p++]=(3&i)<<6|63&s;return u}}("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/")},{}],30:[function(t,e){(function(t){function n(t){for(var e=0;e<t.length;e++){var n=t[e];if(n.buffer instanceof ArrayBuffer){var r=n.buffer;if(n.byteLength!==r.byteLength){var o=new Uint8Array(n.byteLength);o.set(new Uint8Array(r,n.byteOffset,n.byteLength)),r=o.buffer}t[e]=r}}}function r(t,e){e=e||{};var r=new i;n(t);for(var o=0;o<t.length;o++)r.append(t[o]);return e.type?r.getBlob(e.type):r.getBlob()}function o(t,e){return n(t),new Blob(t,e||{})}var i=t.BlobBuilder||t.WebKitBlobBuilder||t.MSBlobBuilder||t.MozBlobBuilder,s=function(){try{var t=new Blob(["hi"]);return 2===t.size}catch(e){return!1}}(),a=s&&function(){try{var t=new Blob([new Uint8Array([1,2])]);return 2===t.size}catch(e){return!1}}(),c=i&&i.prototype.append&&i.prototype.getBlob;e.exports=function(){return s?a?t.Blob:o:c?r:void 0}()}).call(this,"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],31:[function(e,n,r){(function(e){!function(o){function i(t){for(var e,n,r=[],o=0,i=t.length;i>o;)e=t.charCodeAt(o++),e>=55296&&56319>=e&&i>o?(n=t.charCodeAt(o++),56320==(64512&n)?r.push(((1023&e)<<10)+(1023&n)+65536):(r.push(e),o--)):r.push(e);return r}function s(t){for(var e,n=t.length,r=-1,o="";++r<n;)e=t[r],e>65535&&(e-=65536,o+=w(e>>>10&1023|55296),e=56320|1023&e),o+=w(e);return o}function a(t){if(t>=55296&&57343>=t)throw Error("Lone surrogate U+"+t.toString(16).toUpperCase()+" is not a scalar value")}function c(t,e){return w(t>>e&63|128)}function p(t){if(0==(4294967168&t))return w(t);var e="";return 0==(4294965248&t)?e=w(t>>6&31|192):0==(4294901760&t)?(a(t),e=w(t>>12&15|224),e+=c(t,6)):0==(4292870144&t)&&(e=w(t>>18&7|240),e+=c(t,12),e+=c(t,6)),e+=w(63&t|128)}function u(t){for(var e,n=i(t),r=n.length,o=-1,s="";++o<r;)e=n[o],s+=p(e);return s}function f(){if(b>=v)throw Error("Invalid byte index");var t=255&m[b];if(b++,128==(192&t))return 63&t;throw Error("Invalid continuation byte")}function h(){var t,e,n,r,o;if(b>v)throw Error("Invalid byte index");if(b==v)return!1;if(t=255&m[b],b++,0==(128&t))return t;if(192==(224&t)){var e=f();if(o=(31&t)<<6|e,o>=128)return o;throw Error("Invalid continuation byte")}if(224==(240&t)){if(e=f(),n=f(),o=(15&t)<<12|e<<6|n,o>=2048)return a(o),o;throw Error("Invalid continuation byte")}if(240==(248&t)&&(e=f(),n=f(),r=f(),o=(15&t)<<18|e<<12|n<<6|r,o>=65536&&1114111>=o))return o;throw Error("Invalid UTF-8 detected")}function l(t){m=i(t),v=m.length,b=0;for(var e,n=[];(e=h())!==!1;)n.push(e);return s(n)}var d="object"==typeof r&&r,y="object"==typeof n&&n&&n.exports==d&&n,g="object"==typeof e&&e;(g.global===g||g.window===g)&&(o=g);var m,v,b,w=String.fromCharCode,k={version:"2.0.0",encode:u,decode:l};if("function"==typeof t&&"object"==typeof t.amd&&t.amd)t(function(){return k});else if(d&&!d.nodeType)if(y)y.exports=k;else{var x={},A=x.hasOwnProperty;for(var B in k)A.call(k,B)&&(d[B]=k[B])}else o.utf8=k}(this)}).call(this,"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],32:[function(t,e){(function(t){var n=/^[\],:{}\s]*$/,r=/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g,o=/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,i=/(?:^|:|,)(?:\s*\[)+/g,s=/^\s+/,a=/\s+$/;e.exports=function(e){return"string"==typeof e&&e?(e=e.replace(s,"").replace(a,""),t.JSON&&JSON.parse?JSON.parse(e):n.test(e.replace(r,"@").replace(o,"]").replace(i,""))?new Function("return "+e)():void 0):null}}).call(this,"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],33:[function(t,e,n){n.encode=function(t){var e="";for(var n in t)t.hasOwnProperty(n)&&(e.length&&(e+="&"),e+=encodeURIComponent(n)+"="+encodeURIComponent(t[n]));return e},n.decode=function(t){for(var e={},n=t.split("&"),r=0,o=n.length;o>r;r++){var i=n[r].split("=");e[decodeURIComponent(i[0])]=decodeURIComponent(i[1])}return e}},{}],34:[function(t,e){var n=/^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/,r=["source","protocol","authority","userInfo","user","password","host","port","relative","path","directory","file","query","anchor"];e.exports=function(t){var e=t,o=t.indexOf("["),i=t.indexOf("]");-1!=o&&-1!=i&&(t=t.substring(0,o)+t.substring(o,i).replace(/:/g,";")+t.substring(i,t.length));for(var s=n.exec(t||""),a={},c=14;c--;)a[r[c]]=s[c]||"";return-1!=o&&-1!=i&&(a.source=e,a.host=a.host.substring(1,a.host.length-1).replace(/;/g,":"),a.authority=a.authority.replace("[","").replace("]","").replace(/;/g,":"),a.ipv6uri=!0),a}},{}],35:[function(t,e){function n(t,e){var n;return n=e?new o(t,e):new o(t)}var r=function(){return this}(),o=r.WebSocket||r.MozWebSocket;e.exports=o?n:null,o&&(n.prototype=o.prototype)},{}],36:[function(t,e){(function(n){function r(t){function e(t){if(!t)return!1;if(n.Buffer&&n.Buffer.isBuffer(t)||n.ArrayBuffer&&t instanceof ArrayBuffer||n.Blob&&t instanceof Blob||n.File&&t instanceof File)return!0;if(o(t)){for(var r=0;r<t.length;r++)if(e(t[r]))return!0}else if(t&&"object"==typeof t){t.toJSON&&(t=t.toJSON());for(var i in t)if(Object.prototype.hasOwnProperty.call(t,i)&&e(t[i]))return!0}return!1}return e(t)}var o=t("isarray");e.exports=r}).call(this,"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{isarray:37}],37:[function(t,e){e.exports=Array.isArray||function(t){return"[object Array]"==Object.prototype.toString.call(t)}},{}],38:[function(t,e){var n=t("global");try{e.exports="XMLHttpRequest"in n&&"withCredentials"in new n.XMLHttpRequest}catch(r){e.exports=!1}},{global:39}],39:[function(t,e){e.exports=function(){return this}()},{}],40:[function(t,e){var n=[].indexOf;e.exports=function(t,e){if(n)return t.indexOf(e);for(var r=0;r<t.length;++r)if(t[r]===e)return r;return-1}},{}],41:[function(t,e,n){var r=Object.prototype.hasOwnProperty;n.keys=Object.keys||function(t){var e=[];for(var n in t)r.call(t,n)&&e.push(n);return e},n.values=function(t){var e=[];for(var n in t)r.call(t,n)&&e.push(t[n]);return e},n.merge=function(t,e){for(var n in e)r.call(e,n)&&(t[n]=e[n]);return t},n.length=function(t){return n.keys(t).length},n.isEmpty=function(t){return 0==n.length(t)}},{}],42:[function(t,e){var n=/^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/,r=["source","protocol","authority","userInfo","user","password","host","port","relative","path","directory","file","query","anchor"];e.exports=function(t){for(var e=n.exec(t||""),o={},i=14;i--;)o[r[i]]=e[i]||"";return o}},{}],43:[function(t,e,n){(function(e){var r=t("isarray"),o=t("./is-buffer");n.deconstructPacket=function(t){function e(t){if(!t)return t;if(o(t)){var i={_placeholder:!0,num:n.length};return n.push(t),i}if(r(t)){for(var s=new Array(t.length),a=0;a<t.length;a++)s[a]=e(t[a]);return s}if("object"==typeof t&&!(t instanceof Date)){var s={};for(var c in t)s[c]=e(t[c]);return s}return t}var n=[],i=t.data,s=t;return s.data=e(i),s.attachments=n.length,{packet:s,buffers:n}},n.reconstructPacket=function(t,e){function n(t){if(t&&t._placeholder){var o=e[t.num];return o}if(r(t)){for(var i=0;i<t.length;i++)t[i]=n(t[i]);return t}if(t&&"object"==typeof t){for(var s in t)t[s]=n(t[s]);return t}return t}return t.data=n(t.data),t.attachments=void 0,t},n.removeBlobs=function(t,n){function i(t,c,p){if(!t)return t;if(e.Blob&&t instanceof Blob||e.File&&t instanceof File){s++;var u=new FileReader;u.onload=function(){p?p[c]=this.result:a=this.result,--s||n(a)},u.readAsArrayBuffer(t)}else if(r(t))for(var f=0;f<t.length;f++)i(t[f],f,t);else if(t&&"object"==typeof t&&!o(t))for(var h in t)i(t[h],h,t)}var s=0,a=t;i(a),s||n(a)}}).call(this,"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./is-buffer":45,isarray:46}],44:[function(t,e,n){function r(){}function o(t){var e="",r=!1;return e+=t.type,(n.BINARY_EVENT==t.type||n.BINARY_ACK==t.type)&&(e+=t.attachments,e+="-"),t.nsp&&"/"!=t.nsp&&(r=!0,e+=t.nsp),null!=t.id&&(r&&(e+=",",r=!1),e+=t.id),null!=t.data&&(r&&(e+=","),e+=f.stringify(t.data)),u("encoded %j as %s",t,e),e}function i(t,e){function n(t){var n=l.deconstructPacket(t),r=o(n.packet),i=n.buffers;i.unshift(r),e(i)}l.removeBlobs(t,n)}function s(){this.reconstructor=null}function a(t){var e={},r=0;if(e.type=Number(t.charAt(0)),null==n.types[e.type])return p();if(n.BINARY_EVENT==e.type||n.BINARY_ACK==e.type){for(var o="";"-"!=t.charAt(++r)&&(o+=t.charAt(r),r!=t.length););if(o!=Number(o)||"-"!=t.charAt(r))throw new Error("Illegal attachments");e.attachments=Number(o)}if("/"==t.charAt(r+1))for(e.nsp="";++r;){var i=t.charAt(r);if(","==i)break;if(e.nsp+=i,r==t.length)break}else e.nsp="/";var s=t.charAt(r+1);if(""!==s&&Number(s)==s){for(e.id="";++r;){var i=t.charAt(r);if(null==i||Number(i)!=i){--r;break}if(e.id+=t.charAt(r),r==t.length)break}e.id=Number(e.id)}if(t.charAt(++r))try{e.data=f.parse(t.substr(r))}catch(a){return p()}return u("decoded %s as %j",t,e),e}function c(t){this.reconPack=t,this.buffers=[]}function p(){return{type:n.ERROR,data:"parser error"}}var u=t("debug")("socket.io-parser"),f=t("json3"),h=(t("isarray"),t("component-emitter")),l=t("./binary"),d=t("./is-buffer");n.protocol=4,n.types=["CONNECT","DISCONNECT","EVENT","BINARY_EVENT","ACK","BINARY_ACK","ERROR"],n.CONNECT=0,n.DISCONNECT=1,n.EVENT=2,n.ACK=3,n.ERROR=4,n.BINARY_EVENT=5,n.BINARY_ACK=6,n.Encoder=r,n.Decoder=s,r.prototype.encode=function(t,e){if(u("encoding packet %j",t),n.BINARY_EVENT==t.type||n.BINARY_ACK==t.type)i(t,e);else{var r=o(t);e([r])}},h(s.prototype),s.prototype.add=function(t){var e;if("string"==typeof t)e=a(t),n.BINARY_EVENT==e.type||n.BINARY_ACK==e.type?(this.reconstructor=new c(e),0===this.reconstructor.reconPack.attachments&&this.emit("decoded",e)):this.emit("decoded",e);else{if(!d(t)&&!t.base64)throw new Error("Unknown type: "+t);if(!this.reconstructor)throw new Error("got binary data when not reconstructing a packet");e=this.reconstructor.takeBinaryData(t),e&&(this.reconstructor=null,this.emit("decoded",e))}},s.prototype.destroy=function(){this.reconstructor&&this.reconstructor.finishedReconstruction()},c.prototype.takeBinaryData=function(t){if(this.buffers.push(t),this.buffers.length==this.reconPack.attachments){var e=l.reconstructPacket(this.reconPack,this.buffers);return this.finishedReconstruction(),e}return null},c.prototype.finishedReconstruction=function(){this.reconPack=null,this.buffers=[]}},{"./binary":43,"./is-buffer":45,"component-emitter":9,debug:10,isarray:46,json3:47}],45:[function(t,e){(function(t){function n(e){return t.Buffer&&t.Buffer.isBuffer(e)||t.ArrayBuffer&&e instanceof ArrayBuffer}e.exports=n}).call(this,"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],46:[function(t,e){e.exports=t(37)},{}],47:[function(e,n,r){!function(e){function n(t){if(n[t]!==s)return n[t];var e;if("bug-string-char-index"==t)e="a"!="a"[0];else if("json"==t)e=n("json-stringify")&&n("json-parse");else{var r,o='{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}';if("json-stringify"==t){var i=u.stringify,c="function"==typeof i&&f;if(c){(r=function(){return 1}).toJSON=r;try{c="0"===i(0)&&"0"===i(new Number)&&'""'==i(new String)&&i(a)===s&&i(s)===s&&i()===s&&"1"===i(r)&&"[1]"==i([r])&&"[null]"==i([s])&&"null"==i(null)&&"[null,null,null]"==i([s,a,null])&&i({a:[r,!0,!1,null,"\x00\b\n\f\r	"]})==o&&"1"===i(null,r)&&"[\n 1,\n 2\n]"==i([1,2],null,1)&&'"-271821-04-20T00:00:00.000Z"'==i(new Date(-864e13))&&'"+275760-09-13T00:00:00.000Z"'==i(new Date(864e13))&&'"-000001-01-01T00:00:00.000Z"'==i(new Date(-621987552e5))&&'"1969-12-31T23:59:59.999Z"'==i(new Date(-1))}catch(p){c=!1}}e=c}if("json-parse"==t){var h=u.parse;if("function"==typeof h)try{if(0===h("0")&&!h(!1)){r=h(o);var l=5==r.a.length&&1===r.a[0];if(l){try{l=!h('"	"')}catch(p){}if(l)try{l=1!==h("01")}catch(p){}if(l)try{l=1!==h("1.")}catch(p){}}}}catch(p){l=!1}e=l}}return n[t]=!!e}var o,i,s,a={}.toString,c="function"==typeof t&&t.amd,p="object"==typeof JSON&&JSON,u="object"==typeof r&&r&&!r.nodeType&&r;u&&p?(u.stringify=p.stringify,u.parse=p.parse):u=e.JSON=p||{};var f=new Date(-0xc782b5b800cec);try{f=-109252==f.getUTCFullYear()&&0===f.getUTCMonth()&&1===f.getUTCDate()&&10==f.getUTCHours()&&37==f.getUTCMinutes()&&6==f.getUTCSeconds()&&708==f.getUTCMilliseconds()}catch(h){}if(!n("json")){var l="[object Function]",d="[object Date]",y="[object Number]",g="[object String]",m="[object Array]",v="[object Boolean]",b=n("bug-string-char-index");if(!f)var w=Math.floor,k=[0,31,59,90,120,151,181,212,243,273,304,334],x=function(t,e){return k[e]+365*(t-1970)+w((t-1969+(e=+(e>1)))/4)-w((t-1901+e)/100)+w((t-1601+e)/400)};(o={}.hasOwnProperty)||(o=function(t){var e,n={};return(n.__proto__=null,n.__proto__={toString:1},n).toString!=a?o=function(t){var e=this.__proto__,n=t in(this.__proto__=null,this);return this.__proto__=e,n}:(e=n.constructor,o=function(t){var n=(this.constructor||e).prototype;return t in this&&!(t in n&&this[t]===n[t])}),n=null,o.call(this,t)});var A={"boolean":1,number:1,string:1,undefined:1},B=function(t,e){var n=typeof t[e];return"object"==n?!!t[e]:!A[n]};if(i=function(t,e){var n,r,s,c=0;(n=function(){this.valueOf=0}).prototype.valueOf=0,r=new n;for(s in r)o.call(r,s)&&c++;return n=r=null,c?i=2==c?function(t,e){var n,r={},i=a.call(t)==l;for(n in t)i&&"prototype"==n||o.call(r,n)||!(r[n]=1)||!o.call(t,n)||e(n)}:function(t,e){var n,r,i=a.call(t)==l;for(n in t)i&&"prototype"==n||!o.call(t,n)||(r="constructor"===n)||e(n);(r||o.call(t,n="constructor"))&&e(n)}:(r=["valueOf","toString","toLocaleString","propertyIsEnumerable","isPrototypeOf","hasOwnProperty","constructor"],i=function(t,e){var n,i,s=a.call(t)==l,c=!s&&"function"!=typeof t.constructor&&B(t,"hasOwnProperty")?t.hasOwnProperty:o;for(n in t)s&&"prototype"==n||!c.call(t,n)||e(n);for(i=r.length;n=r[--i];c.call(t,n)&&e(n));}),i(t,e)},!n("json-stringify")){var C={92:"\\\\",34:'\\"',8:"\\b",12:"\\f",10:"\\n",13:"\\r",9:"\\t"},S="000000",E=function(t,e){return(S+(e||0)).slice(-t)},T="\\u00",j=function(t){var e,n='"',r=0,o=t.length,i=o>10&&b;for(i&&(e=t.split(""));o>r;r++){var s=t.charCodeAt(r);switch(s){case 8:case 9:case 10:case 12:case 13:case 34:case 92:n+=C[s];break;default:if(32>s){n+=T+E(2,s.toString(16));break}n+=i?e[r]:b?t.charAt(r):t[r]}}return n+'"'},_=function(t,e,n,r,c,p,u){var f,h,l,b,k,A,B,C,S,T,P,R,N,O,U,q;try{f=e[t]}catch(D){}if("object"==typeof f&&f)if(h=a.call(f),h!=d||o.call(f,"toJSON"))"function"==typeof f.toJSON&&(h!=y&&h!=g&&h!=m||o.call(f,"toJSON"))&&(f=f.toJSON(t));else if(f>-1/0&&1/0>f){if(x){for(k=w(f/864e5),l=w(k/365.2425)+1970-1;x(l+1,0)<=k;l++);for(b=w((k-x(l,0))/30.42);x(l,b+1)<=k;b++);k=1+k-x(l,b),A=(f%864e5+864e5)%864e5,B=w(A/36e5)%24,C=w(A/6e4)%60,S=w(A/1e3)%60,T=A%1e3}else l=f.getUTCFullYear(),b=f.getUTCMonth(),k=f.getUTCDate(),B=f.getUTCHours(),C=f.getUTCMinutes(),S=f.getUTCSeconds(),T=f.getUTCMilliseconds();f=(0>=l||l>=1e4?(0>l?"-":"+")+E(6,0>l?-l:l):E(4,l))+"-"+E(2,b+1)+"-"+E(2,k)+"T"+E(2,B)+":"+E(2,C)+":"+E(2,S)+"."+E(3,T)+"Z"}else f=null;if(n&&(f=n.call(e,t,f)),null===f)return"null";if(h=a.call(f),h==v)return""+f;if(h==y)return f>-1/0&&1/0>f?""+f:"null";if(h==g)return j(""+f);if("object"==typeof f){for(O=u.length;O--;)if(u[O]===f)throw TypeError();if(u.push(f),P=[],U=p,p+=c,h==m){for(N=0,O=f.length;O>N;N++)R=_(N,f,n,r,c,p,u),P.push(R===s?"null":R);q=P.length?c?"[\n"+p+P.join(",\n"+p)+"\n"+U+"]":"["+P.join(",")+"]":"[]"}else i(r||f,function(t){var e=_(t,f,n,r,c,p,u);e!==s&&P.push(j(t)+":"+(c?" ":"")+e)}),q=P.length?c?"{\n"+p+P.join(",\n"+p)+"\n"+U+"}":"{"+P.join(",")+"}":"{}";return u.pop(),q}};u.stringify=function(t,e,n){var r,o,i,s;if("function"==typeof e||"object"==typeof e&&e)if((s=a.call(e))==l)o=e;else if(s==m){i={};for(var c,p=0,u=e.length;u>p;c=e[p++],s=a.call(c),(s==g||s==y)&&(i[c]=1));}if(n)if((s=a.call(n))==y){if((n-=n%1)>0)for(r="",n>10&&(n=10);r.length<n;r+=" ");}else s==g&&(r=n.length<=10?n:n.slice(0,10));return _("",(c={},c[""]=t,c),o,i,r,"",[])}}if(!n("json-parse")){var P,R,N=String.fromCharCode,O={92:"\\",34:'"',47:"/",98:"\b",116:"	",110:"\n",102:"\f",114:"\r"},U=function(){throw P=R=null,SyntaxError()},q=function(){for(var t,e,n,r,o,i=R,s=i.length;s>P;)switch(o=i.charCodeAt(P)){case 9:case 10:case 13:case 32:P++;break;case 123:case 125:case 91:case 93:case 58:case 44:return t=b?i.charAt(P):i[P],P++,t;case 34:for(t="@",P++;s>P;)if(o=i.charCodeAt(P),32>o)U();else if(92==o)switch(o=i.charCodeAt(++P)){case 92:case 34:case 47:case 98:case 116:case 110:case 102:case 114:t+=O[o],P++;break;case 117:for(e=++P,n=P+4;n>P;P++)o=i.charCodeAt(P),o>=48&&57>=o||o>=97&&102>=o||o>=65&&70>=o||U();t+=N("0x"+i.slice(e,P));break;default:U()}else{if(34==o)break;for(o=i.charCodeAt(P),e=P;o>=32&&92!=o&&34!=o;)o=i.charCodeAt(++P);t+=i.slice(e,P)}if(34==i.charCodeAt(P))return P++,t;U();default:if(e=P,45==o&&(r=!0,o=i.charCodeAt(++P)),o>=48&&57>=o){for(48==o&&(o=i.charCodeAt(P+1),o>=48&&57>=o)&&U(),r=!1;s>P&&(o=i.charCodeAt(P),o>=48&&57>=o);P++);if(46==i.charCodeAt(P)){for(n=++P;s>n&&(o=i.charCodeAt(n),o>=48&&57>=o);n++);n==P&&U(),P=n}if(o=i.charCodeAt(P),101==o||69==o){for(o=i.charCodeAt(++P),(43==o||45==o)&&P++,n=P;s>n&&(o=i.charCodeAt(n),o>=48&&57>=o);n++);n==P&&U(),P=n}return+i.slice(e,P)}if(r&&U(),"true"==i.slice(P,P+4))return P+=4,!0;if("false"==i.slice(P,P+5))return P+=5,!1;if("null"==i.slice(P,P+4))return P+=4,null;
    U()}return"$"},D=function(t){var e,n;if("$"==t&&U(),"string"==typeof t){if("@"==(b?t.charAt(0):t[0]))return t.slice(1);if("["==t){for(e=[];t=q(),"]"!=t;n||(n=!0))n&&(","==t?(t=q(),"]"==t&&U()):U()),","==t&&U(),e.push(D(t));return e}if("{"==t){for(e={};t=q(),"}"!=t;n||(n=!0))n&&(","==t?(t=q(),"}"==t&&U()):U()),(","==t||"string"!=typeof t||"@"!=(b?t.charAt(0):t[0])||":"!=q())&&U(),e[t.slice(1)]=D(q());return e}U()}return t},I=function(t,e,n){var r=L(t,e,n);r===s?delete t[e]:t[e]=r},L=function(t,e,n){var r,o=t[e];if("object"==typeof o&&o)if(a.call(o)==m)for(r=o.length;r--;)I(o,r,n);else i(o,function(t){I(o,t,n)});return n.call(t,e,o)};u.parse=function(t,e){var n,r;return P=0,R=""+t,n=D(q()),"$"!=q()&&U(),P=R=null,e&&a.call(e)==l?L((r={},r[""]=n,r),"",e):n}}}c&&t(function(){return u})}(this)},{}],48:[function(t,e){function n(t,e){var n=[];e=e||0;for(var r=e||0;r<t.length;r++)n[r-e]=t[r];return n}e.exports=n},{}]},{},[1])(1)});
/**
 * @name MarkerClustererPlus for Google Maps V3
 * @version 2.1.2 [May 28, 2014]
 * @author Gary Little
 * @fileoverview
 * The library creates and manages per-zoom-level clusters for large amounts of markers.
 * <p>
 * This is an enhanced V3 implementation of the
 * <a href="http://gmaps-utility-library-dev.googlecode.com/svn/tags/markerclusterer/"
 * >V2 MarkerClusterer</a> by Xiaoxi Wu. It is based on the
 * <a href="http://google-maps-utility-library-v3.googlecode.com/svn/tags/markerclusterer/"
 * >V3 MarkerClusterer</a> port by Luke Mahe. MarkerClustererPlus was created by Gary Little.
 * <p>
 * v2.0 release: MarkerClustererPlus v2.0 is backward compatible with MarkerClusterer v1.0. It
 *  adds support for the <code>ignoreHidden</code>, <code>title</code>, <code>batchSizeIE</code>,
 *  and <code>calculator</code> properties as well as support for four more events. It also allows
 *  greater control over the styling of the text that appears on the cluster marker. The
 *  documentation has been significantly improved and the overall code has been simplified and
 *  polished. Very large numbers of markers can now be managed without causing Javascript timeout
 *  errors on Internet Explorer. Note that the name of the <code>clusterclick</code> event has been
 *  deprecated. The new name is <code>click</code>, so please change your application code now.
 */

/**
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * @name ClusterIconStyle
 * @class This class represents the object for values in the <code>styles</code> array passed
 *  to the {@link MarkerClusterer} constructor. The element in this array that is used to
 *  style the cluster icon is determined by calling the <code>calculator</code> function.
 *
 * @property {string} url The URL of the cluster icon image file. Required.
 * @property {number} height The display height (in pixels) of the cluster icon. Required.
 * @property {number} width The display width (in pixels) of the cluster icon. Required.
 * @property {Array} [anchorText] The position (in pixels) from the center of the cluster icon to
 *  where the text label is to be centered and drawn. The format is <code>[yoffset, xoffset]</code>
 *  where <code>yoffset</code> increases as you go down from center and <code>xoffset</code>
 *  increases to the right of center. The default is <code>[0, 0]</code>.
 * @property {Array} [anchorIcon] The anchor position (in pixels) of the cluster icon. This is the
 *  spot on the cluster icon that is to be aligned with the cluster position. The format is
 *  <code>[yoffset, xoffset]</code> where <code>yoffset</code> increases as you go down and
 *  <code>xoffset</code> increases to the right of the top-left corner of the icon. The default
 *  anchor position is the center of the cluster icon.
 * @property {string} [textColor="black"] The color of the label text shown on the
 *  cluster icon.
 * @property {number} [textSize=11] The size (in pixels) of the label text shown on the
 *  cluster icon.
 * @property {string} [textDecoration="none"] The value of the CSS <code>text-decoration</code>
 *  property for the label text shown on the cluster icon.
 * @property {string} [fontWeight="bold"] The value of the CSS <code>font-weight</code>
 *  property for the label text shown on the cluster icon.
 * @property {string} [fontStyle="normal"] The value of the CSS <code>font-style</code>
 *  property for the label text shown on the cluster icon.
 * @property {string} [fontFamily="Arial,sans-serif"] The value of the CSS <code>font-family</code>
 *  property for the label text shown on the cluster icon.
 * @property {string} [backgroundPosition="0 0"] The position of the cluster icon image
 *  within the image defined by <code>url</code>. The format is <code>"xpos ypos"</code>
 *  (the same format as for the CSS <code>background-position</code> property). You must set
 *  this property appropriately when the image defined by <code>url</code> represents a sprite
 *  containing multiple images. Note that the position <i>must</i> be specified in px units.
 */
/**
 * @name ClusterIconInfo
 * @class This class is an object containing general information about a cluster icon. This is
 *  the object that a <code>calculator</code> function returns.
 *
 * @property {string} text The text of the label to be shown on the cluster icon.
 * @property {number} index The index plus 1 of the element in the <code>styles</code>
 *  array to be used to style the cluster icon.
 * @property {string} title The tooltip to display when the mouse moves over the cluster icon.
 *  If this value is <code>undefined</code> or <code>""</code>, <code>title</code> is set to the
 *  value of the <code>title</code> property passed to the MarkerClusterer.
 */
/**
 * A cluster icon.
 *
 * @constructor
 * @extends google.maps.OverlayView
 * @param {Cluster} cluster The cluster with which the icon is to be associated.
 * @param {Array} [styles] An array of {@link ClusterIconStyle} defining the cluster icons
 *  to use for various cluster sizes.
 * @private
 */
function ClusterIcon(cluster, styles) {
    cluster.getMarkerClusterer().extend(ClusterIcon, google.maps.OverlayView);

    this.cluster_ = cluster;
    this.className_ = cluster.getMarkerClusterer().getClusterClass();
    this.styles_ = styles;
    this.center_ = null;
    this.div_ = null;
    this.sums_ = null;
    this.visible_ = false;

    this.setMap(cluster.getMap()); // Note: this causes onAdd to be called
}


/**
 * Adds the icon to the DOM.
 */
ClusterIcon.prototype.onAdd = function() {
    var cClusterIcon = this;
    var cMouseDownInCluster;
    var cDraggingMapByCluster;

    this.div_ = document.createElement("div");
    this.div_.className = this.className_;
    if (this.visible_) {
        this.show();
    }

    this.getPanes().overlayMouseTarget.appendChild(this.div_);

    // Fix for Issue 157
    this.boundsChangedListener_ = google.maps.event.addListener(this.getMap(), "bounds_changed", function() {
        cDraggingMapByCluster = cMouseDownInCluster;
    });

    google.maps.event.addDomListener(this.div_, "mousedown", function() {
        cMouseDownInCluster = true;
        cDraggingMapByCluster = false;
    });

    google.maps.event.addDomListener(this.div_, "click", function(e) {
        cMouseDownInCluster = false;
        if (!cDraggingMapByCluster) {
            var theBounds;
            var mz;
            var mc = cClusterIcon.cluster_.getMarkerClusterer();
            /**
             * This event is fired when a cluster marker is clicked.
             * @name MarkerClusterer#click
             * @param {Cluster} c The cluster that was clicked.
             * @event
             */
            google.maps.event.trigger(mc, "click", cClusterIcon.cluster_);
            google.maps.event.trigger(mc, "clusterclick", cClusterIcon.cluster_); // deprecated name

            // The default click handler follows. Disable it by setting
            // the zoomOnClick property to false.
            if (mc.getZoomOnClick()) {
                // Zoom into the cluster.
                mz = mc.getMaxZoom();
                theBounds = cClusterIcon.cluster_.getBounds();
                mc.getMap().fitBounds(theBounds);
                // There is a fix for Issue 170 here:
                setTimeout(function() {
                    mc.getMap().fitBounds(theBounds);
                    // Don't zoom beyond the max zoom level
                    if (mz !== null && (mc.getMap().getZoom() > mz)) {
                        mc.getMap().setZoom(mz + 1);
                    }
                }, 100);
            }

            // Prevent event propagation to the map:
            e.cancelBubble = true;
            if (e.stopPropagation) {
                e.stopPropagation();
            }
        }
    });

    google.maps.event.addDomListener(this.div_, "mouseover", function() {
        var mc = cClusterIcon.cluster_.getMarkerClusterer();
        /**
         * This event is fired when the mouse moves over a cluster marker.
         * @name MarkerClusterer#mouseover
         * @param {Cluster} c The cluster that the mouse moved over.
         * @event
         */
        google.maps.event.trigger(mc, "mouseover", cClusterIcon.cluster_);
    });

    google.maps.event.addDomListener(this.div_, "mouseout", function() {
        var mc = cClusterIcon.cluster_.getMarkerClusterer();
        /**
         * This event is fired when the mouse moves out of a cluster marker.
         * @name MarkerClusterer#mouseout
         * @param {Cluster} c The cluster that the mouse moved out of.
         * @event
         */
        google.maps.event.trigger(mc, "mouseout", cClusterIcon.cluster_);
    });
};


/**
 * Removes the icon from the DOM.
 */
ClusterIcon.prototype.onRemove = function() {
    if (this.div_ && this.div_.parentNode) {
        this.hide();
        google.maps.event.removeListener(this.boundsChangedListener_);
        google.maps.event.clearInstanceListeners(this.div_);
        this.div_.parentNode.removeChild(this.div_);
        this.div_ = null;
    }
};


/**
 * Draws the icon.
 */
ClusterIcon.prototype.draw = function() {
    if (this.visible_) {
        var pos = this.getPosFromLatLng_(this.center_);
        this.div_.style.top = pos.y + "px";
        this.div_.style.left = pos.x + "px";
    }
};


/**
 * Hides the icon.
 */
ClusterIcon.prototype.hide = function() {
    if (this.div_) {
        this.div_.style.display = "none";
    }
    this.visible_ = false;
};


/**
 * Positions and shows the icon.
 */
ClusterIcon.prototype.show = function() {
    if (this.div_) {
        var img = "";
        // NOTE: values must be specified in px units
        var bp = this.backgroundPosition_.split(" ");
        var spriteH = parseInt(bp[0].replace(/^\s+|\s+$/g, ""), 10);
        var spriteV = parseInt(bp[1].replace(/^\s+|\s+$/g, ""), 10);
        var pos = this.getPosFromLatLng_(this.center_);
        this.div_.style.cssText = this.createCss(pos);
        img = "<img src='" + this.url_ + "' style='position: absolute; top: " + spriteV + "px; left: " + spriteH + "px; ";
        if (!this.cluster_.getMarkerClusterer().enableRetinaIcons_) {
            img += "clip: rect(" + (-1 * spriteV) + "px, " + ((-1 * spriteH) + this.width_) + "px, " +
                ((-1 * spriteV) + this.height_) + "px, " + (-1 * spriteH) + "px);";
        }
        img += "'>";
        this.div_.innerHTML = img + "<div style='" +
            "position: absolute;" +
            "top: " + this.anchorText_[0] + "px;" +
            "left: " + this.anchorText_[1] + "px;" +
            "color: " + this.textColor_ + ";" +
            "font-size: " + this.textSize_ + "px;" +
            "font-family: " + this.fontFamily_ + ";" +
            "font-weight: " + this.fontWeight_ + ";" +
            "font-style: " + this.fontStyle_ + ";" +
            "text-decoration: " + this.textDecoration_ + ";" +
            "text-align: center;" +
            "width: " + this.width_ + "px;" +
            "line-height:" + this.height_ + "px;" +
            "'>" + this.sums_.text + "</div>";
        if (typeof this.sums_.title === "undefined" || this.sums_.title === "") {
            this.div_.title = this.cluster_.getMarkerClusterer().getTitle();
        } else {
            this.div_.title = this.sums_.title;
        }
        this.div_.style.display = "";
    }
    this.visible_ = true;
};


/**
 * Sets the icon styles to the appropriate element in the styles array.
 *
 * @param {ClusterIconInfo} sums The icon label text and styles index.
 */
ClusterIcon.prototype.useStyle = function(sums) {
    this.sums_ = sums;
    var index = Math.max(0, sums.index - 1);
    index = Math.min(this.styles_.length - 1, index);
    var style = this.styles_[index];
    this.url_ = style.url;
    this.height_ = style.height;
    this.width_ = style.width;
    this.anchorText_ = style.anchorText || [0, 0];
    this.anchorIcon_ = style.anchorIcon || [parseInt(this.height_ / 2, 10), parseInt(this.width_ / 2, 10)];
    this.textColor_ = style.textColor || "black";
    this.textSize_ = style.textSize || 11;
    this.textDecoration_ = style.textDecoration || "none";
    this.fontWeight_ = style.fontWeight || "bold";
    this.fontStyle_ = style.fontStyle || "normal";
    this.fontFamily_ = style.fontFamily || "Arial,sans-serif";
    this.backgroundPosition_ = style.backgroundPosition || "0 0";
};


/**
 * Sets the position at which to center the icon.
 *
 * @param {google.maps.LatLng} center The latlng to set as the center.
 */
ClusterIcon.prototype.setCenter = function(center) {
    this.center_ = center;
};


/**
 * Creates the cssText style parameter based on the position of the icon.
 *
 * @param {google.maps.Point} pos The position of the icon.
 * @return {string} The CSS style text.
 */
ClusterIcon.prototype.createCss = function(pos) {
    var style = [];
    style.push("cursor: pointer;");
    style.push("position: absolute; top: " + pos.y + "px; left: " + pos.x + "px;");
    style.push("width: " + this.width_ + "px; height: " + this.height_ + "px;");
    return style.join("");
};


/**
 * Returns the position at which to place the DIV depending on the latlng.
 *
 * @param {google.maps.LatLng} latlng The position in latlng.
 * @return {google.maps.Point} The position in pixels.
 */
ClusterIcon.prototype.getPosFromLatLng_ = function(latlng) {
    var pos = this.getProjection().fromLatLngToDivPixel(latlng);
    pos.x -= this.anchorIcon_[1];
    pos.y -= this.anchorIcon_[0];
    pos.x = parseInt(pos.x, 10);
    pos.y = parseInt(pos.y, 10);
    return pos;
};


/**
 * Creates a single cluster that manages a group of proximate markers.
 *  Used internally, do not call this constructor directly.
 * @constructor
 * @param {MarkerClusterer} mc The <code>MarkerClusterer</code> object with which this
 *  cluster is associated.
 */
function Cluster(mc) {
    this.markerClusterer_ = mc;
    this.map_ = mc.getMap();
    this.gridSize_ = mc.getGridSize();
    this.minClusterSize_ = mc.getMinimumClusterSize();
    this.averageCenter_ = mc.getAverageCenter();
    this.markers_ = [];
    this.center_ = null;
    this.bounds_ = null;
    this.clusterIcon_ = new ClusterIcon(this, mc.getStyles());
}


/**
 * Returns the number of markers managed by the cluster. You can call this from
 * a <code>click</code>, <code>mouseover</code>, or <code>mouseout</code> event handler
 * for the <code>MarkerClusterer</code> object.
 *
 * @return {number} The number of markers in the cluster.
 */
Cluster.prototype.getSize = function() {
    return this.markers_.length;
};


/**
 * Returns the array of markers managed by the cluster. You can call this from
 * a <code>click</code>, <code>mouseover</code>, or <code>mouseout</code> event handler
 * for the <code>MarkerClusterer</code> object.
 *
 * @return {Array} The array of markers in the cluster.
 */
Cluster.prototype.getMarkers = function() {
    return this.markers_;
};


/**
 * Returns the center of the cluster. You can call this from
 * a <code>click</code>, <code>mouseover</code>, or <code>mouseout</code> event handler
 * for the <code>MarkerClusterer</code> object.
 *
 * @return {google.maps.LatLng} The center of the cluster.
 */
Cluster.prototype.getCenter = function() {
    return this.center_;
};


/**
 * Returns the map with which the cluster is associated.
 *
 * @return {google.maps.Map} The map.
 * @ignore
 */
Cluster.prototype.getMap = function() {
    return this.map_;
};


/**
 * Returns the <code>MarkerClusterer</code> object with which the cluster is associated.
 *
 * @return {MarkerClusterer} The associated marker clusterer.
 * @ignore
 */
Cluster.prototype.getMarkerClusterer = function() {
    return this.markerClusterer_;
};


/**
 * Returns the bounds of the cluster.
 *
 * @return {google.maps.LatLngBounds} the cluster bounds.
 * @ignore
 */
Cluster.prototype.getBounds = function() {
    var i;
    var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
    var markers = this.getMarkers();
    for (i = 0; i < markers.length; i++) {
        bounds.extend(markers[i].getPosition());
    }
    return bounds;
};


/**
 * Removes the cluster from the map.
 *
 * @ignore
 */
Cluster.prototype.remove = function() {
    this.clusterIcon_.setMap(null);
    this.markers_ = [];
    delete this.markers_;
};


/**
 * Adds a marker to the cluster.
 *
 * @param {google.maps.Marker} marker The marker to be added.
 * @return {boolean} True if the marker was added.
 * @ignore
 */
Cluster.prototype.addMarker = function(marker) {
    var i;
    var mCount;
    var mz;

    if (this.isMarkerAlreadyAdded_(marker)) {
        return false;
    }

    if (!this.center_) {
        this.center_ = marker.getPosition();
        this.calculateBounds_();
    } else {
        if (this.averageCenter_) {
            var l = this.markers_.length + 1;
            var lat = (this.center_.lat() * (l - 1) + marker.getPosition().lat()) / l;
            var lng = (this.center_.lng() * (l - 1) + marker.getPosition().lng()) / l;
            this.center_ = new google.maps.LatLng(lat, lng);
            this.calculateBounds_();
        }
    }

    marker.isAdded = true;
    this.markers_.push(marker);

    mCount = this.markers_.length;
    mz = this.markerClusterer_.getMaxZoom();
    if (mz !== null && this.map_.getZoom() > mz) {
        // Zoomed in past max zoom, so show the marker.
        if (marker.getMap() !== this.map_) {
            marker.setMap(this.map_);
        }
    } else if (mCount < this.minClusterSize_) {
        // Min cluster size not reached so show the marker.
        if (marker.getMap() !== this.map_) {
            marker.setMap(this.map_);
        }
    } else if (mCount === this.minClusterSize_) {
        // Hide the markers that were showing.
        for (i = 0; i < mCount; i++) {
            this.markers_[i].setMap(null);
        }
    } else {
        marker.setMap(null);
    }

    this.updateIcon_();
    return true;
};


/**
 * Determines if a marker lies within the cluster's bounds.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @return {boolean} True if the marker lies in the bounds.
 * @ignore
 */
Cluster.prototype.isMarkerInClusterBounds = function(marker) {
    return this.bounds_.contains(marker.getPosition());
};


/**
 * Calculates the extended bounds of the cluster with the grid.
 */
Cluster.prototype.calculateBounds_ = function() {
    var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
    this.bounds_ = this.markerClusterer_.getExtendedBounds(bounds);
};


/**
 * Updates the cluster icon.
 */
Cluster.prototype.updateIcon_ = function() {
    var mCount = this.markers_.length;
    var mz = this.markerClusterer_.getMaxZoom();

    if (mz !== null && this.map_.getZoom() > mz) {
        this.clusterIcon_.hide();
        return;
    }

    if (mCount < this.minClusterSize_) {
        // Min cluster size not yet reached.
        this.clusterIcon_.hide();
        return;
    }

    var numStyles = this.markerClusterer_.getStyles().length;
    var sums = this.markerClusterer_.getCalculator()(this.markers_, numStyles);
    this.clusterIcon_.setCenter(this.center_);
    this.clusterIcon_.useStyle(sums);
    this.clusterIcon_.show();
};


/**
 * Determines if a marker has already been added to the cluster.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @return {boolean} True if the marker has already been added.
 */
Cluster.prototype.isMarkerAlreadyAdded_ = function(marker) {
    var i;
    if (this.markers_.indexOf) {
        return this.markers_.indexOf(marker) !== -1;
    } else {
        for (i = 0; i < this.markers_.length; i++) {
            if (marker === this.markers_[i]) {
                return true;
            }
        }
    }
    return false;
};


/**
 * @name MarkerClustererOptions
 * @class This class represents the optional parameter passed to
 *  the {@link MarkerClusterer} constructor.
 * @property {number} [gridSize=60] The grid size of a cluster in pixels. The grid is a square.
 * @property {number} [maxZoom=null] The maximum zoom level at which clustering is enabled or
 *  <code>null</code> if clustering is to be enabled at all zoom levels.
 * @property {boolean} [zoomOnClick=true] Whether to zoom the map when a cluster marker is
 *  clicked. You may want to set this to <code>false</code> if you have installed a handler
 *  for the <code>click</code> event and it deals with zooming on its own.
 * @property {boolean} [averageCenter=false] Whether the position of a cluster marker should be
 *  the average position of all markers in the cluster. If set to <code>false</code>, the
 *  cluster marker is positioned at the location of the first marker added to the cluster.
 * @property {number} [minimumClusterSize=2] The minimum number of markers needed in a cluster
 *  before the markers are hidden and a cluster marker appears.
 * @property {boolean} [ignoreHidden=false] Whether to ignore hidden markers in clusters. You
 *  may want to set this to <code>true</code> to ensure that hidden markers are not included
 *  in the marker count that appears on a cluster marker (this count is the value of the
 *  <code>text</code> property of the result returned by the default <code>calculator</code>).
 *  If set to <code>true</code> and you change the visibility of a marker being clustered, be
 *  sure to also call <code>MarkerClusterer.repaint()</code>.
 * @property {string} [title=""] The tooltip to display when the mouse moves over a cluster
 *  marker. (Alternatively, you can use a custom <code>calculator</code> function to specify a
 *  different tooltip for each cluster marker.)
 * @property {function} [calculator=MarkerClusterer.CALCULATOR] The function used to determine
 *  the text to be displayed on a cluster marker and the index indicating which style to use
 *  for the cluster marker. The input parameters for the function are (1) the array of markers
 *  represented by a cluster marker and (2) the number of cluster icon styles. It returns a
 *  {@link ClusterIconInfo} object. The default <code>calculator</code> returns a
 *  <code>text</code> property which is the number of markers in the cluster and an
 *  <code>index</code> property which is one higher than the lowest integer such that
 *  <code>10^i</code> exceeds the number of markers in the cluster, or the size of the styles
 *  array, whichever is less. The <code>styles</code> array element used has an index of
 *  <code>index</code> minus 1. For example, the default <code>calculator</code> returns a
 *  <code>text</code> value of <code>"125"</code> and an <code>index</code> of <code>3</code>
 *  for a cluster icon representing 125 markers so the element used in the <code>styles</code>
 *  array is <code>2</code>. A <code>calculator</code> may also return a <code>title</code>
 *  property that contains the text of the tooltip to be used for the cluster marker. If
 *   <code>title</code> is not defined, the tooltip is set to the value of the <code>title</code>
 *   property for the MarkerClusterer.
 * @property {string} [clusterClass="cluster"] The name of the CSS class defining general styles
 *  for the cluster markers. Use this class to define CSS styles that are not set up by the code
 *  that processes the <code>styles</code> array.
 * @property {Array} [styles] An array of {@link ClusterIconStyle} elements defining the styles
 *  of the cluster markers to be used. The element to be used to style a given cluster marker
 *  is determined by the function defined by the <code>calculator</code> property.
 *  The default is an array of {@link ClusterIconStyle} elements whose properties are derived
 *  from the values for <code>imagePath</code>, <code>imageExtension</code>, and
 *  <code>imageSizes</code>.
 * @property {boolean} [enableRetinaIcons=false] Whether to allow the use of cluster icons that
 * have sizes that are some multiple (typically double) of their actual display size. Icons such
 * as these look better when viewed on high-resolution monitors such as Apple's Retina displays.
 * Note: if this property is <code>true</code>, sprites cannot be used as cluster icons.
 * @property {number} [batchSize=MarkerClusterer.BATCH_SIZE] Set this property to the
 *  number of markers to be processed in a single batch when using a browser other than
 *  Internet Explorer (for Internet Explorer, use the batchSizeIE property instead).
 * @property {number} [batchSizeIE=MarkerClusterer.BATCH_SIZE_IE] When Internet Explorer is
 *  being used, markers are processed in several batches with a small delay inserted between
 *  each batch in an attempt to avoid Javascript timeout errors. Set this property to the
 *  number of markers to be processed in a single batch; select as high a number as you can
 *  without causing a timeout error in the browser. This number might need to be as low as 100
 *  if 15,000 markers are being managed, for example.
 * @property {string} [imagePath=MarkerClusterer.IMAGE_PATH]
 *  The full URL of the root name of the group of image files to use for cluster icons.
 *  The complete file name is of the form <code>imagePath</code>n.<code>imageExtension</code>
 *  where n is the image file number (1, 2, etc.).
 * @property {string} [imageExtension=MarkerClusterer.IMAGE_EXTENSION]
 *  The extension name for the cluster icon image files (e.g., <code>"png"</code> or
 *  <code>"jpg"</code>).
 * @property {Array} [imageSizes=MarkerClusterer.IMAGE_SIZES]
 *  An array of numbers containing the widths of the group of
 *  <code>imagePath</code>n.<code>imageExtension</code> image files.
 *  (The images are assumed to be square.)
 */
/**
 * Creates a MarkerClusterer object with the options specified in {@link MarkerClustererOptions}.
 * @constructor
 * @extends google.maps.OverlayView
 * @param {google.maps.Map} map The Google map to attach to.
 * @param {Array.<google.maps.Marker>} [opt_markers] The markers to be added to the cluster.
 * @param {MarkerClustererOptions} [opt_options] The optional parameters.
 */
function MarkerClusterer(map, opt_markers, opt_options) {
    // MarkerClusterer implements google.maps.OverlayView interface. We use the
    // extend function to extend MarkerClusterer with google.maps.OverlayView
    // because it might not always be available when the code is defined so we
    // look for it at the last possible moment. If it doesn't exist now then
    // there is no point going ahead :)
    this.extend(MarkerClusterer, google.maps.OverlayView);

    opt_markers = opt_markers || [];
    opt_options = opt_options || {};

    this.markers_ = [];
    this.clusters_ = [];
    this.listeners_ = [];
    this.activeMap_ = null;
    this.ready_ = false;

    this.gridSize_ = opt_options.gridSize || 60;
    this.minClusterSize_ = opt_options.minimumClusterSize || 2;
    this.maxZoom_ = opt_options.maxZoom || null;
    this.styles_ = opt_options.styles || [];
    this.title_ = opt_options.title || "";
    this.zoomOnClick_ = true;
    if (opt_options.zoomOnClick !== undefined) {
        this.zoomOnClick_ = opt_options.zoomOnClick;
    }
    this.averageCenter_ = false;
    if (opt_options.averageCenter !== undefined) {
        this.averageCenter_ = opt_options.averageCenter;
    }
    this.ignoreHidden_ = false;
    if (opt_options.ignoreHidden !== undefined) {
        this.ignoreHidden_ = opt_options.ignoreHidden;
    }
    this.enableRetinaIcons_ = false;
    if (opt_options.enableRetinaIcons !== undefined) {
        this.enableRetinaIcons_ = opt_options.enableRetinaIcons;
    }
    this.imagePath_ = opt_options.imagePath || MarkerClusterer.IMAGE_PATH;
    this.imageExtension_ = opt_options.imageExtension || MarkerClusterer.IMAGE_EXTENSION;
    this.imageSizes_ = opt_options.imageSizes || MarkerClusterer.IMAGE_SIZES;
    this.calculator_ = opt_options.calculator || MarkerClusterer.CALCULATOR;
    this.batchSize_ = opt_options.batchSize || MarkerClusterer.BATCH_SIZE;
    this.batchSizeIE_ = opt_options.batchSizeIE || MarkerClusterer.BATCH_SIZE_IE;
    this.clusterClass_ = opt_options.clusterClass || "cluster";

    if (navigator.userAgent.toLowerCase().indexOf("msie") !== -1) {
        // Try to avoid IE timeout when processing a huge number of markers:
        this.batchSize_ = this.batchSizeIE_;
    }

    this.setupStyles_();

    this.addMarkers(opt_markers, true);
    this.setMap(map); // Note: this causes onAdd to be called
}


/**
 * Implementation of the onAdd interface method.
 * @ignore
 */
MarkerClusterer.prototype.onAdd = function() {
    var cMarkerClusterer = this;

    this.activeMap_ = this.getMap();
    this.ready_ = true;

    this.repaint();

    // Add the map event listeners
    this.listeners_ = [
        google.maps.event.addListener(this.getMap(), "zoom_changed", function() {
            cMarkerClusterer.resetViewport_(false);
            // Workaround for this Google bug: when map is at level 0 and "-" of
            // zoom slider is clicked, a "zoom_changed" event is fired even though
            // the map doesn't zoom out any further. In this situation, no "idle"
            // event is triggered so the cluster markers that have been removed
            // do not get redrawn. Same goes for a zoom in at maxZoom.
            if (this.getZoom() === (this.get("minZoom") || 0) || this.getZoom() === this.get("maxZoom")) {
                google.maps.event.trigger(this, "idle");
            }
        }),
        google.maps.event.addListener(this.getMap(), "idle", function() {
            cMarkerClusterer.redraw_();
        })
    ];
};


/**
 * Implementation of the onRemove interface method.
 * Removes map event listeners and all cluster icons from the DOM.
 * All managed markers are also put back on the map.
 * @ignore
 */
MarkerClusterer.prototype.onRemove = function() {
    var i;

    // Put all the managed markers back on the map:
    for (i = 0; i < this.markers_.length; i++) {
        if (this.markers_[i].getMap() !== this.activeMap_) {
            this.markers_[i].setMap(this.activeMap_);
        }
    }

    // Remove all clusters:
    for (i = 0; i < this.clusters_.length; i++) {
        this.clusters_[i].remove();
    }
    this.clusters_ = [];

    // Remove map event listeners:
    for (i = 0; i < this.listeners_.length; i++) {
        google.maps.event.removeListener(this.listeners_[i]);
    }
    this.listeners_ = [];

    this.activeMap_ = null;
    this.ready_ = false;
};


/**
 * Implementation of the draw interface method.
 * @ignore
 */
MarkerClusterer.prototype.draw = function() {};


/**
 * Sets up the styles object.
 */
MarkerClusterer.prototype.setupStyles_ = function() {
    var i, size;
    if (this.styles_.length > 0) {
        return;
    }

    for (i = 0; i < this.imageSizes_.length; i++) {
        size = this.imageSizes_[i];
        this.styles_.push({
            url: this.imagePath_ + (i + 1) + "." + this.imageExtension_,
            height: size,
            width: size
        });
    }
};


/**
 *  Fits the map to the bounds of the markers managed by the clusterer.
 */
MarkerClusterer.prototype.fitMapToMarkers = function() {
    var i;
    var markers = this.getMarkers();
    var bounds = new google.maps.LatLngBounds();
    for (i = 0; i < markers.length; i++) {
        bounds.extend(markers[i].getPosition());
    }

    this.getMap().fitBounds(bounds);
};


/**
 * Returns the value of the <code>gridSize</code> property.
 *
 * @return {number} The grid size.
 */
MarkerClusterer.prototype.getGridSize = function() {
    return this.gridSize_;
};


/**
 * Sets the value of the <code>gridSize</code> property.
 *
 * @param {number} gridSize The grid size.
 */
MarkerClusterer.prototype.setGridSize = function(gridSize) {
    this.gridSize_ = gridSize;
};


/**
 * Returns the value of the <code>minimumClusterSize</code> property.
 *
 * @return {number} The minimum cluster size.
 */
MarkerClusterer.prototype.getMinimumClusterSize = function() {
    return this.minClusterSize_;
};

/**
 * Sets the value of the <code>minimumClusterSize</code> property.
 *
 * @param {number} minimumClusterSize The minimum cluster size.
 */
MarkerClusterer.prototype.setMinimumClusterSize = function(minimumClusterSize) {
    this.minClusterSize_ = minimumClusterSize;
};


/**
 *  Returns the value of the <code>maxZoom</code> property.
 *
 *  @return {number} The maximum zoom level.
 */
MarkerClusterer.prototype.getMaxZoom = function() {
    return this.maxZoom_;
};


/**
 *  Sets the value of the <code>maxZoom</code> property.
 *
 *  @param {number} maxZoom The maximum zoom level.
 */
MarkerClusterer.prototype.setMaxZoom = function(maxZoom) {
    this.maxZoom_ = maxZoom;
};


/**
 *  Returns the value of the <code>styles</code> property.
 *
 *  @return {Array} The array of styles defining the cluster markers to be used.
 */
MarkerClusterer.prototype.getStyles = function() {
    return this.styles_;
};


/**
 *  Sets the value of the <code>styles</code> property.
 *
 *  @param {Array.<ClusterIconStyle>} styles The array of styles to use.
 */
MarkerClusterer.prototype.setStyles = function(styles) {
    this.styles_ = styles;
};


/**
 * Returns the value of the <code>title</code> property.
 *
 * @return {string} The content of the title text.
 */
MarkerClusterer.prototype.getTitle = function() {
    return this.title_;
};


/**
 *  Sets the value of the <code>title</code> property.
 *
 *  @param {string} title The value of the title property.
 */
MarkerClusterer.prototype.setTitle = function(title) {
    this.title_ = title;
};


/**
 * Returns the value of the <code>zoomOnClick</code> property.
 *
 * @return {boolean} True if zoomOnClick property is set.
 */
MarkerClusterer.prototype.getZoomOnClick = function() {
    return this.zoomOnClick_;
};


/**
 *  Sets the value of the <code>zoomOnClick</code> property.
 *
 *  @param {boolean} zoomOnClick The value of the zoomOnClick property.
 */
MarkerClusterer.prototype.setZoomOnClick = function(zoomOnClick) {
    this.zoomOnClick_ = zoomOnClick;
};


/**
 * Returns the value of the <code>averageCenter</code> property.
 *
 * @return {boolean} True if averageCenter property is set.
 */
MarkerClusterer.prototype.getAverageCenter = function() {
    return this.averageCenter_;
};


/**
 *  Sets the value of the <code>averageCenter</code> property.
 *
 *  @param {boolean} averageCenter The value of the averageCenter property.
 */
MarkerClusterer.prototype.setAverageCenter = function(averageCenter) {
    this.averageCenter_ = averageCenter;
};


/**
 * Returns the value of the <code>ignoreHidden</code> property.
 *
 * @return {boolean} True if ignoreHidden property is set.
 */
MarkerClusterer.prototype.getIgnoreHidden = function() {
    return this.ignoreHidden_;
};


/**
 *  Sets the value of the <code>ignoreHidden</code> property.
 *
 *  @param {boolean} ignoreHidden The value of the ignoreHidden property.
 */
MarkerClusterer.prototype.setIgnoreHidden = function(ignoreHidden) {
    this.ignoreHidden_ = ignoreHidden;
};


/**
 * Returns the value of the <code>enableRetinaIcons</code> property.
 *
 * @return {boolean} True if enableRetinaIcons property is set.
 */
MarkerClusterer.prototype.getEnableRetinaIcons = function() {
    return this.enableRetinaIcons_;
};


/**
 *  Sets the value of the <code>enableRetinaIcons</code> property.
 *
 *  @param {boolean} enableRetinaIcons The value of the enableRetinaIcons property.
 */
MarkerClusterer.prototype.setEnableRetinaIcons = function(enableRetinaIcons) {
    this.enableRetinaIcons_ = enableRetinaIcons;
};


/**
 * Returns the value of the <code>imageExtension</code> property.
 *
 * @return {string} The value of the imageExtension property.
 */
MarkerClusterer.prototype.getImageExtension = function() {
    return this.imageExtension_;
};


/**
 *  Sets the value of the <code>imageExtension</code> property.
 *
 *  @param {string} imageExtension The value of the imageExtension property.
 */
MarkerClusterer.prototype.setImageExtension = function(imageExtension) {
    this.imageExtension_ = imageExtension;
};


/**
 * Returns the value of the <code>imagePath</code> property.
 *
 * @return {string} The value of the imagePath property.
 */
MarkerClusterer.prototype.getImagePath = function() {
    return this.imagePath_;
};


/**
 *  Sets the value of the <code>imagePath</code> property.
 *
 *  @param {string} imagePath The value of the imagePath property.
 */
MarkerClusterer.prototype.setImagePath = function(imagePath) {
    this.imagePath_ = imagePath;
};


/**
 * Returns the value of the <code>imageSizes</code> property.
 *
 * @return {Array} The value of the imageSizes property.
 */
MarkerClusterer.prototype.getImageSizes = function() {
    return this.imageSizes_;
};


/**
 *  Sets the value of the <code>imageSizes</code> property.
 *
 *  @param {Array} imageSizes The value of the imageSizes property.
 */
MarkerClusterer.prototype.setImageSizes = function(imageSizes) {
    this.imageSizes_ = imageSizes;
};


/**
 * Returns the value of the <code>calculator</code> property.
 *
 * @return {function} the value of the calculator property.
 */
MarkerClusterer.prototype.getCalculator = function() {
    return this.calculator_;
};


/**
 * Sets the value of the <code>calculator</code> property.
 *
 * @param {function(Array.<google.maps.Marker>, number)} calculator The value
 *  of the calculator property.
 */
MarkerClusterer.prototype.setCalculator = function(calculator) {
    this.calculator_ = calculator;
};


/**
 * Returns the value of the <code>batchSizeIE</code> property.
 *
 * @return {number} the value of the batchSizeIE property.
 */
MarkerClusterer.prototype.getBatchSizeIE = function() {
    return this.batchSizeIE_;
};


/**
 * Sets the value of the <code>batchSizeIE</code> property.
 *
 *  @param {number} batchSizeIE The value of the batchSizeIE property.
 */
MarkerClusterer.prototype.setBatchSizeIE = function(batchSizeIE) {
    this.batchSizeIE_ = batchSizeIE;
};


/**
 * Returns the value of the <code>clusterClass</code> property.
 *
 * @return {string} the value of the clusterClass property.
 */
MarkerClusterer.prototype.getClusterClass = function() {
    return this.clusterClass_;
};


/**
 * Sets the value of the <code>clusterClass</code> property.
 *
 *  @param {string} clusterClass The value of the clusterClass property.
 */
MarkerClusterer.prototype.setClusterClass = function(clusterClass) {
    this.clusterClass_ = clusterClass;
};


/**
 *  Returns the array of markers managed by the clusterer.
 *
 *  @return {Array} The array of markers managed by the clusterer.
 */
MarkerClusterer.prototype.getMarkers = function() {
    return this.markers_;
};


/**
 *  Returns the number of markers managed by the clusterer.
 *
 *  @return {number} The number of markers.
 */
MarkerClusterer.prototype.getTotalMarkers = function() {
    return this.markers_.length;
};


/**
 * Returns the current array of clusters formed by the clusterer.
 *
 * @return {Array} The array of clusters formed by the clusterer.
 */
MarkerClusterer.prototype.getClusters = function() {
    return this.clusters_;
};


/**
 * Returns the number of clusters formed by the clusterer.
 *
 * @return {number} The number of clusters formed by the clusterer.
 */
MarkerClusterer.prototype.getTotalClusters = function() {
    return this.clusters_.length;
};


/**
 * Adds a marker to the clusterer. The clusters are redrawn unless
 *  <code>opt_nodraw</code> is set to <code>true</code>.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
 */
MarkerClusterer.prototype.addMarker = function(marker, opt_nodraw) {
    this.pushMarkerTo_(marker);
    if (!opt_nodraw) {
        this.redraw_();
    }
};


/**
 * Adds an array of markers to the clusterer. The clusters are redrawn unless
 *  <code>opt_nodraw</code> is set to <code>true</code>.
 *
 * @param {Array.<google.maps.Marker>} markers The markers to add.
 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
 */
MarkerClusterer.prototype.addMarkers = function(markers, opt_nodraw) {
    var key;
    for (key in markers) {
        if (markers.hasOwnProperty(key)) {
            this.pushMarkerTo_(markers[key]);
        }
    }
    if (!opt_nodraw) {
        this.redraw_();
    }
};


/**
 * Pushes a marker to the clusterer.
 *
 * @param {google.maps.Marker} marker The marker to add.
 */
MarkerClusterer.prototype.pushMarkerTo_ = function(marker) {
    // If the marker is draggable add a listener so we can update the clusters on the dragend:
    if (marker.getDraggable()) {
        var cMarkerClusterer = this;
        google.maps.event.addListener(marker, "dragend", function() {
            if (cMarkerClusterer.ready_) {
                this.isAdded = false;
                cMarkerClusterer.repaint();
            }
        });
    }
    marker.isAdded = false;
    this.markers_.push(marker);
};


/**
 * Removes a marker from the cluster.  The clusters are redrawn unless
 *  <code>opt_nodraw</code> is set to <code>true</code>. Returns <code>true</code> if the
 *  marker was removed from the clusterer.
 *
 * @param {google.maps.Marker} marker The marker to remove.
 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
 * @return {boolean} True if the marker was removed from the clusterer.
 */
MarkerClusterer.prototype.removeMarker = function(marker, opt_nodraw) {
    var removed = this.removeMarker_(marker);

    if (!opt_nodraw && removed) {
        this.repaint();
    }

    return removed;
};


/**
 * Removes an array of markers from the cluster. The clusters are redrawn unless
 *  <code>opt_nodraw</code> is set to <code>true</code>. Returns <code>true</code> if markers
 *  were removed from the clusterer.
 *
 * @param {Array.<google.maps.Marker>} markers The markers to remove.
 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
 * @return {boolean} True if markers were removed from the clusterer.
 */
MarkerClusterer.prototype.removeMarkers = function(markers, opt_nodraw) {
    var i, r;
    var removed = false;

    for (i = 0; i < markers.length; i++) {
        r = this.removeMarker_(markers[i]);
        removed = removed || r;
    }

    if (!opt_nodraw && removed) {
        this.repaint();
    }

    return removed;
};


/**
 * Removes a marker and returns true if removed, false if not.
 *
 * @param {google.maps.Marker} marker The marker to remove
 * @return {boolean} Whether the marker was removed or not
 */
MarkerClusterer.prototype.removeMarker_ = function(marker) {
    var i;
    var index = -1;
    if (this.markers_.indexOf) {
        index = this.markers_.indexOf(marker);
    } else {
        for (i = 0; i < this.markers_.length; i++) {
            if (marker === this.markers_[i]) {
                index = i;
                break;
            }
        }
    }

    if (index === -1) {
        // Marker is not in our list of markers, so do nothing:
        return false;
    }

    marker.setMap(null);
    this.markers_.splice(index, 1); // Remove the marker from the list of managed markers
    return true;
};


/**
 * Removes all clusters and markers from the map and also removes all markers
 *  managed by the clusterer.
 */
MarkerClusterer.prototype.clearMarkers = function() {
    this.resetViewport_(true);
    this.markers_ = [];
};


/**
 * Recalculates and redraws all the marker clusters from scratch.
 *  Call this after changing any properties.
 */
MarkerClusterer.prototype.repaint = function() {
    var oldClusters = this.clusters_.slice();
    this.clusters_ = [];
    this.resetViewport_(false);
    this.redraw_();

    // Remove the old clusters.
    // Do it in a timeout to prevent blinking effect.
    setTimeout(function() {
        var i;
        for (i = 0; i < oldClusters.length; i++) {
            oldClusters[i].remove();
        }
    }, 0);
};


/**
 * Returns the current bounds extended by the grid size.
 *
 * @param {google.maps.LatLngBounds} bounds The bounds to extend.
 * @return {google.maps.LatLngBounds} The extended bounds.
 * @ignore
 */
MarkerClusterer.prototype.getExtendedBounds = function(bounds) {
    var projection = this.getProjection();

    // Turn the bounds into latlng.
    var tr = new google.maps.LatLng(bounds.getNorthEast().lat(),
        bounds.getNorthEast().lng());
    var bl = new google.maps.LatLng(bounds.getSouthWest().lat(),
        bounds.getSouthWest().lng());

    // Convert the points to pixels and the extend out by the grid size.
    var trPix = projection.fromLatLngToDivPixel(tr);
    trPix.x += this.gridSize_;
    trPix.y -= this.gridSize_;

    var blPix = projection.fromLatLngToDivPixel(bl);
    blPix.x -= this.gridSize_;
    blPix.y += this.gridSize_;

    // Convert the pixel points back to LatLng
    var ne = projection.fromDivPixelToLatLng(trPix);
    var sw = projection.fromDivPixelToLatLng(blPix);

    // Extend the bounds to contain the new bounds.
    bounds.extend(ne);
    bounds.extend(sw);

    return bounds;
};


/**
 * Redraws all the clusters.
 */
MarkerClusterer.prototype.redraw_ = function() {
    this.createClusters_(0);
};


/**
 * Removes all clusters from the map. The markers are also removed from the map
 *  if <code>opt_hide</code> is set to <code>true</code>.
 *
 * @param {boolean} [opt_hide] Set to <code>true</code> to also remove the markers
 *  from the map.
 */
MarkerClusterer.prototype.resetViewport_ = function(opt_hide) {
    var i, marker;
    // Remove all the clusters
    for (i = 0; i < this.clusters_.length; i++) {
        this.clusters_[i].remove();
    }
    this.clusters_ = [];

    // Reset the markers to not be added and to be removed from the map.
    for (i = 0; i < this.markers_.length; i++) {
        marker = this.markers_[i];
        marker.isAdded = false;
        if (opt_hide) {
            marker.setMap(null);
        }
    }
};


/**
 * Calculates the distance between two latlng locations in km.
 *
 * @param {google.maps.LatLng} p1 The first lat lng point.
 * @param {google.maps.LatLng} p2 The second lat lng point.
 * @return {number} The distance between the two points in km.
 * @see http://www.movable-type.co.uk/scripts/latlong.html
 */
MarkerClusterer.prototype.distanceBetweenPoints_ = function(p1, p2) {
    var R = 6371; // Radius of the Earth in km
    var dLat = (p2.lat() - p1.lat()) * Math.PI / 180;
    var dLon = (p2.lng() - p1.lng()) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(p1.lat() * Math.PI / 180) * Math.cos(p2.lat() * Math.PI / 180) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d;
};


/**
 * Determines if a marker is contained in a bounds.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @param {google.maps.LatLngBounds} bounds The bounds to check against.
 * @return {boolean} True if the marker is in the bounds.
 */
MarkerClusterer.prototype.isMarkerInBounds_ = function(marker, bounds) {
    return bounds.contains(marker.getPosition());
};


/**
 * Adds a marker to a cluster, or creates a new cluster.
 *
 * @param {google.maps.Marker} marker The marker to add.
 */
MarkerClusterer.prototype.addToClosestCluster_ = function(marker) {
    var i, d, cluster, center;
    var distance = 40000; // Some large number
    var clusterToAddTo = null;
    for (i = 0; i < this.clusters_.length; i++) {
        cluster = this.clusters_[i];
        center = cluster.getCenter();
        if (center) {
            d = this.distanceBetweenPoints_(center, marker.getPosition());
            if (d < distance) {
                distance = d;
                clusterToAddTo = cluster;
            }
        }
    }

    if (clusterToAddTo && clusterToAddTo.isMarkerInClusterBounds(marker)) {
        clusterToAddTo.addMarker(marker);
    } else {
        cluster = new Cluster(this);
        cluster.addMarker(marker);
        this.clusters_.push(cluster);
    }
};


/**
 * Creates the clusters. This is done in batches to avoid timeout errors
 *  in some browsers when there is a huge number of markers.
 *
 * @param {number} iFirst The index of the first marker in the batch of
 *  markers to be added to clusters.
 */
MarkerClusterer.prototype.createClusters_ = function(iFirst) {
    var i, marker;
    var mapBounds;
    var cMarkerClusterer = this;
    if (!this.ready_) {
        return;
    }

    // Cancel previous batch processing if we're working on the first batch:
    if (iFirst === 0) {
        /**
         * This event is fired when the <code>MarkerClusterer</code> begins
         *  clustering markers.
         * @name MarkerClusterer#clusteringbegin
         * @param {MarkerClusterer} mc The MarkerClusterer whose markers are being clustered.
         * @event
         */
        google.maps.event.trigger(this, "clusteringbegin", this);

        if (typeof this.timerRefStatic !== "undefined") {
            clearTimeout(this.timerRefStatic);
            delete this.timerRefStatic;
        }
    }

    // Get our current map view bounds.
    // Create a new bounds object so we don't affect the map.
    //
    // See Comments 9 & 11 on Issue 3651 relating to this workaround for a Google Maps bug:
    if (this.getMap().getZoom() > 3) {
        mapBounds = new google.maps.LatLngBounds(this.getMap().getBounds().getSouthWest(),
            this.getMap().getBounds().getNorthEast());
    } else {
        mapBounds = new google.maps.LatLngBounds(new google.maps.LatLng(85.02070771743472, -178.48388434375), new google.maps.LatLng(-85.08136444384544, 178.00048865625));
    }
    var bounds = this.getExtendedBounds(mapBounds);

    var iLast = Math.min(iFirst + this.batchSize_, this.markers_.length);

    for (i = iFirst; i < iLast; i++) {
        marker = this.markers_[i];
        if (!marker.isAdded && this.isMarkerInBounds_(marker, bounds)) {
            if (!this.ignoreHidden_ || (this.ignoreHidden_ && marker.getVisible())) {
                this.addToClosestCluster_(marker);
            }
        }
    }

    if (iLast < this.markers_.length) {
        this.timerRefStatic = setTimeout(function() {
            cMarkerClusterer.createClusters_(iLast);
        }, 0);
    } else {
        delete this.timerRefStatic;

        /**
         * This event is fired when the <code>MarkerClusterer</code> stops
         *  clustering markers.
         * @name MarkerClusterer#clusteringend
         * @param {MarkerClusterer} mc The MarkerClusterer whose markers are being clustered.
         * @event
         */
        google.maps.event.trigger(this, "clusteringend", this);
    }
};


/**
 * Extends an object's prototype by another's.
 *
 * @param {Object} obj1 The object to be extended.
 * @param {Object} obj2 The object to extend with.
 * @return {Object} The new extended object.
 * @ignore
 */
MarkerClusterer.prototype.extend = function(obj1, obj2) {
    return (function(object) {
        var property;
        for (property in object.prototype) {
            this.prototype[property] = object.prototype[property];
        }
        return this;
    }).apply(obj1, [obj2]);
};


/**
 * The default function for determining the label text and style
 * for a cluster icon.
 *
 * @param {Array.<google.maps.Marker>} markers The array of markers represented by the cluster.
 * @param {number} numStyles The number of marker styles available.
 * @return {ClusterIconInfo} The information resource for the cluster.
 * @constant
 * @ignore
 */
MarkerClusterer.CALCULATOR = function(markers, numStyles) {
    var index = 0;
    var title = "";
    var count = markers.length.toString();

    var dv = count;
    while (dv !== 0) {
        dv = parseInt(dv / 10, 10);
        index++;
    }

    index = Math.min(index, numStyles);
    return {
        text: count,
        index: index,
        title: title
    };
};


/**
 * The number of markers to process in one batch.
 *
 * @type {number}
 * @constant
 */
MarkerClusterer.BATCH_SIZE = 2000;


/**
 * The number of markers to process in one batch (IE only).
 *
 * @type {number}
 * @constant
 */
MarkerClusterer.BATCH_SIZE_IE = 500;


/**
 * The default root name for the marker cluster images.
 *
 * @type {string}
 * @constant
 */
MarkerClusterer.IMAGE_PATH = "assets/images/m";


/**
 * The default extension name for the marker cluster images.
 *
 * @type {string}
 * @constant
 */
MarkerClusterer.IMAGE_EXTENSION = "png";


/**
 * The default array of sizes for the marker cluster images.
 *
 * @type {Array.<number>}
 * @constant
 */
MarkerClusterer.IMAGE_SIZES = [53, 56, 66, 78, 90];
/**
 * angular-drag-and-drop-lists v2.1.0
 *
 * Copyright (c) 2014 Marcel Juenemann marcel@juenemann.cc
 * Copyright (c) 2014-2017 Google Inc.
 * https://github.com/marceljuenemann/angular-drag-and-drop-lists
 *
 * License: MIT
 */
!function(e){function n(e,n){return"all"==n?e:e.filter(function(e){return-1!=n.toLowerCase().indexOf(e)})}var a="application/x-dnd",r="application/json",t="Text",d=["move","copy","link"]
e.directive("dndDraggable",["$parse","$timeout",function(e,i){return function(l,f,c){f.attr("draggable","true"),c.dndDisableIf&&l.$watch(c.dndDisableIf,function(e){f.attr("draggable",!e)}),f.on("dragstart",function(s){if(s=s.originalEvent||s,"false"==f.attr("draggable"))return!0
o.isDragging=!0,o.itemType=c.dndType&&l.$eval(c.dndType).toLowerCase(),o.dropEffect="none",o.effectAllowed=c.dndEffectAllowed||d[0],s.dataTransfer.effectAllowed=o.effectAllowed
var g=l.$eval(c.dndDraggable),u=a+(o.itemType?"-"+o.itemType:"")
try{s.dataTransfer.setData(u,angular.toJson(g))}catch(p){var v=angular.toJson({item:g,type:o.itemType})
try{s.dataTransfer.setData(r,v)}catch(p){var D=n(d,o.effectAllowed)
s.dataTransfer.effectAllowed=D[0],s.dataTransfer.setData(t,v)}}if(f.addClass("dndDragging"),i(function(){f.addClass("dndDraggingSource")},0),s._dndHandle&&s.dataTransfer.setDragImage&&s.dataTransfer.setDragImage(f[0],0,0),e(c.dndDragstart)(l,{event:s}),c.dndCallback){var y=e(c.dndCallback)
o.callback=function(e){return y(l,e||{})}}s.stopPropagation()}),f.on("dragend",function(n){n=n.originalEvent||n,l.$apply(function(){var a=o.dropEffect,r={copy:"dndCopied",link:"dndLinked",move:"dndMoved",none:"dndCanceled"}
e(c[r[a]])(l,{event:n}),e(c.dndDragend)(l,{event:n,dropEffect:a})}),o.isDragging=!1,o.callback=void 0,f.removeClass("dndDragging"),f.removeClass("dndDraggingSource"),n.stopPropagation(),i(function(){f.removeClass("dndDraggingSource")},0)}),f.on("click",function(n){c.dndSelected&&(n=n.originalEvent||n,l.$apply(function(){e(c.dndSelected)(l,{event:n})}),n.stopPropagation())}),f.on("selectstart",function(){this.dragDrop&&this.dragDrop()})}}]),e.directive("dndList",["$parse",function(e){return function(i,l,f){function c(e){if(!e)return t
for(var n=0;n<e.length;n++)if(e[n]==t||e[n]==r||e[n].substr(0,a.length)==a)return e[n]
return null}function s(e){return o.isDragging?o.itemType||void 0:e==t||e==r?null:e&&e.substr(a.length+1)||void 0}function g(e){return E.disabled?!1:E.externalSources||o.isDragging?E.allowedTypes&&null!==e?e&&-1!=E.allowedTypes.indexOf(e):!0:!1}function u(e,a){var r=d
return a||(r=n(r,e.dataTransfer.effectAllowed)),o.isDragging&&(r=n(r,o.effectAllowed)),f.dndEffectAllowed&&(r=n(r,f.dndEffectAllowed)),r.length?e.ctrlKey&&-1!=r.indexOf("copy")?"copy":e.altKey&&-1!=r.indexOf("link")?"link":r[0]:"none"}function p(){return T.remove(),l.removeClass("dndDragover"),!0}function v(n,a,r,t,d,l){return e(n)(i,{callback:o.callback,dropEffect:r,event:a,external:!o.isDragging,index:void 0!==d?d:D(),item:l||void 0,type:t})}function D(){return Array.prototype.indexOf.call(m.children,h)}function y(){var e
return angular.forEach(l.children(),function(n){var a=angular.element(n)
a.hasClass("dndPlaceholder")&&(e=a)}),e||angular.element("<li class='dndPlaceholder'></li>")}var T=y()
T.remove()
var h=T[0],m=l[0],E={}
l.on("dragenter",function(e){e=e.originalEvent||e
var n=f.dndAllowedTypes&&i.$eval(f.dndAllowedTypes)
E={allowedTypes:angular.isArray(n)&&n.join("|").toLowerCase().split("|"),disabled:f.dndDisableIf&&i.$eval(f.dndDisableIf),externalSources:f.dndExternalSources&&i.$eval(f.dndExternalSources),horizontal:f.dndHorizontalList&&i.$eval(f.dndHorizontalList)}
var a=c(e.dataTransfer.types)
return a&&g(s(a))?void e.preventDefault():!0}),l.on("dragover",function(e){e=e.originalEvent||e
var n=c(e.dataTransfer.types),a=s(n)
if(!n||!g(a))return!0
if(h.parentNode!=m&&l.append(T),e.target!=m){for(var r=e.target;r.parentNode!=m&&r.parentNode;)r=r.parentNode
if(r.parentNode==m&&r!=h){var d=r.getBoundingClientRect()
if(E.horizontal)var o=e.clientX<d.left+d.width/2
else var o=e.clientY<d.top+d.height/2
m.insertBefore(h,o?r:r.nextSibling)}}var i=n==t,D=u(e,i)
return"none"==D?p():f.dndDragover&&!v(f.dndDragover,e,D,a)?p():(e.preventDefault(),i||(e.dataTransfer.dropEffect=D),l.addClass("dndDragover"),e.stopPropagation(),!1)}),l.on("drop",function(e){e=e.originalEvent||e
var n=c(e.dataTransfer.types),a=s(n)
if(!n||!g(a))return!0
e.preventDefault()
try{var d=JSON.parse(e.dataTransfer.getData(n))}catch(l){return p()}if((n==t||n==r)&&(a=d.type||void 0,d=d.item,!g(a)))return p()
var y=n==t,T=u(e,y)
if("none"==T)return p()
var h=D()
return f.dndDrop&&(d=v(f.dndDrop,e,T,a,h,d),!d)?p():(o.dropEffect=T,y||(e.dataTransfer.dropEffect=T),d!==!0&&i.$apply(function(){i.$eval(f.dndList).splice(h,0,d)}),v(f.dndInserted,e,T,a,h,d),p(),e.stopPropagation(),!1)}),l.on("dragleave",function(e){e=e.originalEvent||e
var n=document.elementFromPoint(e.clientX,e.clientY)
m.contains(n)&&!e._dndPhShown?e._dndPhShown=!0:p()})}}]),e.directive("dndNodrag",function(){return function(e,n,a){n.attr("draggable","true"),n.on("dragstart",function(e){e=e.originalEvent||e,e._dndHandle||(e.dataTransfer.types&&e.dataTransfer.types.length||e.preventDefault(),e.stopPropagation())}),n.on("dragend",function(e){e=e.originalEvent||e,e._dndHandle||e.stopPropagation()})}}),e.directive("dndHandle",function(){return function(e,n,a){n.attr("draggable","true"),n.on("dragstart dragend",function(e){e=e.originalEvent||e,e._dndHandle=!0})}})
var o={}}(angular.module("dndLists",[]));

/**
 * Created by cl-macmini-51 on 6/28/17.
 */
(function(root,factory){if(typeof define==="function"&&define.amd){define([],factory)}else if(typeof exports==="object"){module.exports=factory()}else{root.alasql=factory()}})(this,function(){var alasql=function alasql(sql,params,cb,scope){if(typeof importScripts!="function"&&alasql.webworker){var id=alasql.lastid++;alasql.buffer[id]=cb;alasql.webworker.postMessage({id:id,sql:sql,params:params})}else{if(arguments.length==0){return new yy.Select({columns:[new yy.Column({columnid:"*"})],from:[new yy.ParamValue({param:0})]})}else if(arguments.length==1&&typeof sql=="object"&&sql instanceof Array){var select=new yy.Select({columns:[new yy.Column({columnid:"*"})],from:[new yy.ParamValue({param:0})]});select.preparams=[sql];return select}else{if(typeof sql=="string"&&sql[0]=="#"&&typeof document=="object"){sql=document.querySelector(sql).textContent}else if(typeof sql=="object"&&sql instanceof HTMElement){sql=sql.textContent}else if(typeof sql=="function"){sql=sql.toString().slice(14,-3)}return alasql.exec(sql,params,cb,scope)}}};alasql.version="0.1.9";alasql.debug=undefined;getAlaSQLPath();function getAlaSQLPath(){alasql.path="";if(typeof importScripts==="function"){alasql.path=""}else if(typeof exports!="undefined"){alasql.path=__dirname}else if(typeof Meteor=="object"&&Meteor.isClient){alasql.path="/packages/dist/"}else if(typeof Meteor=="object"&&Meteor.isServer){alasql.path="assets/packages/dist/"}else if(typeof document!="undefined"){var sc=document.getElementsByTagName("script");for(var i=0;i<sc.length;i++){if(sc[i].src.substr(-16).toLowerCase()=="alasql-worker.js"){alasql.path=sc[i].src.substr(0,sc[i].src.length-16);break}else if(sc[i].src.substr(-20).toLowerCase()=="alasql-worker.min.js"){alasql.path=sc[i].src.substr(0,sc[i].src.length-20);break}else if(sc[i].src.substr(-9).toLowerCase()=="alasql.js"){alasql.path=sc[i].src.substr(0,sc[i].src.length-9);break}else if(sc[i].src.substr(-13).toLowerCase()=="alasql.min.js"){alasql.path=sc[i].src.substr(0,sc[i].src.length-13);break}}}}var parser=function(){var o=function(k,v,o,l){for(o=o||{},l=k.length;l--;o[k[l]]=v);return o},$V0=[2,10],$V1=[1,95],$V2=[1,96],$V3=[1,6],$V4=[1,38],$V5=[1,71],$V6=[1,68],$V7=[1,87],$V8=[1,86],$V9=[1,63],$Va=[1,94],$Vb=[1,78],$Vc=[1,76],$Vd=[1,60],$Ve=[1,64],$Vf=[1,58],$Vg=[1,62],$Vh=[1,56],$Vi=[1,66],$Vj=[1,57],$Vk=[1,61],$Vl=[1,75],$Vm=[1,69],$Vn=[1,77],$Vo=[1,79],$Vp=[1,80],$Vq=[1,73],$Vr=[1,74],$Vs=[1,72],$Vt=[1,81],$Vu=[1,82],$Vv=[1,83],$Vw=[1,84],$Vx=[1,85],$Vy=[1,91],$Vz=[1,59],$VA=[1,70],$VB=[1,65],$VC=[1,89],$VD=[1,90],$VE=[1,99],$VF=[1,100],$VG=[8,264,450,451],$VH=[8,264,268,450,451],$VI=[105,304,357],$VJ=[1,112],$VK=[1,111],$VL=[1,116],$VM=[1,143],$VN=[1,153],$VO=[1,156],$VP=[1,151],$VQ=[1,159],$VR=[1,163],$VS=[1,160],$VT=[1,148],$VU=[1,150],$VV=[1,152],$VW=[1,161],$VX=[1,145],$VY=[1,170],$VZ=[1,166],$V_=[1,167],$V$=[1,171],$V01=[1,172],$V11=[1,173],$V21=[1,174],$V31=[1,175],$V41=[1,176],$V51=[1,177],$V61=[1,178],$V71=[1,179],$V81=[1,154],$V91=[1,155],$Va1=[1,157],$Vb1=[1,158],$Vc1=[1,164],$Vd1=[1,162],$Ve1=[1,165],$Vf1=[1,149],$Vg1=[1,169],$Vh1=[1,180],$Vi1=[4,5],$Vj1=[1,186],$Vk1=[1,194],$Vl1=[8,65,71,93,104,136,142,143,157,172,205,218,264,268,450,451],$Vm1=[4,5,8,65,69,70,71,90,93,97,98,99,104,105,106,107,108,109,110,111,112,113,114,115,116,117,119,120,122,123,124,126,128,130,136,138,140,142,143,144,145,146,147,149,157,159,161,172,244,245,246,247,248,249,250,251,252,264,268,368,372,450,451],$Vn1=[4,5,8,47,65,67,69,70,71,81,85,90,93,97,98,99,104,105,106,107,108,109,110,111,112,113,114,115,116,117,119,120,122,123,124,126,128,130,136,138,140,142,143,144,145,146,147,149,153,154,155,157,159,161,163,172,180,182,194,195,196,197,198,199,200,201,205,212,215,216,218,233,244,245,246,247,248,249,250,251,252,256,264,266,267,268,269,270,271,272,273,274,275,276,277,280,282,283,284,285,287,290,291,298,344,347,348,351,353,355,356,364,365,366,368,372,383,385,386,388,389,390,391,392,396,397,400,401,413,419,447,449,450,451],$Vo1=[1,223],$Vp1=[1,230],$Vq1=[1,240],$Vr1=[1,245],$Vs1=[1,244],$Vt1=[4,5,8,65,70,71,85,93,104,106,107,112,116,119,126,128,136,142,143,153,154,155,157,172,205,218,232,233,234,235,237,244,245,246,247,248,249,250,251,252,254,255,256,257,258,260,261,264,268,270,368,372,450,451],$Vu1=[2,140],$Vv1=[1,256],$Vw1=[8,67,71,264,268,447,450,451],$Vx1=[4,5,8,65,70,71,85,93,104,106,107,112,116,119,126,128,136,138,142,143,153,154,155,157,159,161,169,172,205,218,232,233,234,235,237,244,245,246,247,248,249,250,251,252,254,255,256,257,258,260,261,264,268,270,368,372,450,451],$Vy1=[4,5,8,47,65,67,69,70,71,81,85,90,93,97,98,99,104,105,106,107,108,109,110,111,112,113,114,115,116,117,119,120,122,123,124,126,128,130,136,138,140,142,143,144,145,146,147,149,153,154,155,157,159,161,163,167,172,180,182,194,195,196,197,198,199,200,201,202,203,205,212,215,216,218,233,244,245,246,247,248,249,250,251,252,256,257,264,266,267,268,269,270,271,272,273,274,275,276,277,280,282,283,284,285,287,290,291,294,298,307,319,320,321,324,325,336,338,344,347,348,349,350,351,352,353,355,356,364,365,366,368,372,374,376,382,383,385,386,388,389,390,391,392,396,397,400,401,413,419,447,449,450,451],$Vz1=[4,5,8,47,65,81,99,120,130,163,233,264,287,290,291,298,344,347,348,351,353,355,356,364,365,366,383,385,386,388,389,390,391,392,396,397,400,401,447,449,450,451],$VA1=[2,444],$VB1=[1,270],$VC1=[2,784],$VD1=[8,71,81,107,112,120,163,256,264,268,419,450,451],$VE1=[8,67,264,268,450,451],$VF1=[2,504],$VG1=[1,296],$VH1=[4,5,130],$VI1=[1,302],$VJ1=[1,310],$VK1=[1,309],$VL1=[1,316],$VM1=[1,307],$VN1=[1,311],$VO1=[1,308],$VP1=[1,312],$VQ1=[1,314],$VR1=[1,326],$VS1=[1,323],$VT1=[1,324],$VU1=[1,304],$VV1=[1,306],$VW1=[1,303],$VX1=[1,305],$VY1=[1,313],$VZ1=[1,315],$V_1=[1,317],$V$1=[1,318],$V02=[1,319],$V12=[1,320],$V22=[1,321],$V32=[1,325],$V42=[1,327],$V52=[1,328],$V62=[1,329],$V72=[1,330],$V82=[2,262],$V92=[1,339],$Va2=[4,5,8,47,65,67,69,70,71,81,85,90,93,97,98,99,104,105,106,107,108,109,110,111,112,113,114,115,116,117,119,120,122,123,124,126,128,130,136,138,140,142,143,144,145,146,147,149,153,154,155,157,159,161,163,172,180,182,194,195,196,197,198,199,200,201,202,203,205,212,215,216,218,233,244,245,246,247,248,249,250,251,252,256,257,264,266,267,268,269,270,271,272,273,274,275,276,277,280,282,283,284,285,287,290,291,294,298,307,319,320,324,325,344,347,348,351,353,355,356,364,365,366,368,372,374,376,383,385,386,388,389,390,391,392,396,397,400,401,413,419,447,449,450,451],$Vb2=[2,323],$Vc2=[1,350],$Vd2=[1,360],$Ve2=[4,5,8,47,65,67,69,70,71,81,85,90,93,97,98,99,104,105,106,107,108,109,110,111,112,113,114,115,116,117,119,120,122,123,124,126,128,130,136,138,140,142,143,144,145,146,147,149,153,154,155,157,159,161,163,172,180,182,194,195,196,197,198,199,200,201,202,203,205,212,215,216,218,233,244,245,246,247,248,249,250,251,252,256,264,266,267,268,269,270,271,272,273,274,275,276,277,280,282,283,284,285,287,290,291,298,344,347,348,351,353,355,356,364,365,366,368,372,374,376,383,385,386,388,389,390,391,392,396,397,400,401,413,419,447,449,450,451],$Vf2=[1,376],$Vg2=[1,384],$Vh2=[1,383],$Vi2=[4,5,8,65,67,71,93,104,136,142,143,180,182,194,195,196,197,198,199,200,201,202,203,205,218,264,268,450,451],$Vj2=[8,65,67,71,93,104,136,142,143,180,182,194,195,196,197,198,199,200,201,202,203,205,218,264,268,450,451],$Vk2=[2,178],$Vl2=[1,403],$Vm2=[8,65,71,93,104,136,142,143,157,205,218,264,268,450,451],$Vn2=[2,141],$Vo2=[1,406],$Vp2=[4,5,90],$Vq2=[1,418],$Vr2=[1,435],$Vs2=[1,417],$Vt2=[1,416],$Vu2=[1,412],$Vv2=[1,413],$Vw2=[1,414],$Vx2=[1,415],$Vy2=[1,419],$Vz2=[1,420],$VA2=[1,421],$VB2=[1,422],$VC2=[1,423],$VD2=[1,424],$VE2=[1,425],$VF2=[1,426],$VG2=[1,427],$VH2=[1,428],$VI2=[1,429],$VJ2=[1,430],$VK2=[1,431],$VL2=[1,432],$VM2=[1,434],$VN2=[1,436],$VO2=[1,437],$VP2=[1,438],$VQ2=[1,439],$VR2=[1,440],$VS2=[1,441],$VT2=[1,442],$VU2=[1,445],$VV2=[1,446],$VW2=[1,447],$VX2=[1,448],$VY2=[1,449],$VZ2=[1,450],$V_2=[1,451],$V$2=[1,452],$V03=[1,453],$V13=[1,454],$V23=[1,455],$V33=[1,456],$V43=[67,81,163],$V53=[8,67,71,128,161,257,264,268,294,307,319,320,324,325,450,451],$V63=[1,473],$V73=[8,67,71,264,268,450,451],$V83=[1,474],$V93=[1,482],$Va3=[4,5,70,106,107,112,116,119,126,128,153,154,155,232,233,234,235,237,244,245,246,247,248,249,250,251,252,254,255,256,257,258,260,261,270,368,372],$Vb3=[8,65,71,85,93,104,136,142,143,157,172,205,218,264,268,450,451],$Vc3=[4,5,107,256],$Vd3=[1,504],$Ve3=[8,67,69,71,264,268,450,451],$Vf3=[8,67,69,71,107,112,114,119,126,264,268,368,372,450,451],$Vg3=[2,785],$Vh3=[8,67,69,71,107,114,119,126,264,268,368,372,450,451],$Vi3=[8,71,81,107,120,163,256,264,268,419,450,451],$Vj3=[1,523],$Vk3=[1,524],$Vl3=[138,140,286],$Vm3=[2,395],$Vn3=[1,570],$Vo3=[1,589],$Vp3=[4,5,8,47,65,67,69,70,71,81,85,90,93,99,104,105,106,107,109,110,112,114,115,116,117,119,120,122,123,124,126,128,130,136,138,140,142,143,144,145,146,147,149,153,155,157,159,161,163,172,180,182,194,195,196,197,198,199,200,201,205,212,215,216,218,233,244,245,246,247,248,249,250,251,252,256,264,266,267,268,269,270,271,272,273,274,275,276,277,280,282,283,284,285,287,290,291,298,344,347,348,351,353,355,356,364,365,366,368,372,383,385,386,388,389,390,391,392,396,397,400,401,413,419,447,449,450,451],$Vq3=[2,338],$Vr3=[1,596],$Vs3=[264,266,268],$Vt3=[67,376],$Vu3=[67,374,376],$Vv3=[1,603],$Vw3=[4,5,8,47,65,67,69,71,81,85,90,93,97,98,99,104,105,106,107,108,109,110,111,112,113,114,115,116,117,119,120,122,123,124,126,128,130,136,138,140,142,143,144,145,146,147,149,153,154,155,157,159,161,163,172,180,182,194,195,196,197,198,199,200,201,205,212,215,216,218,233,244,245,246,247,248,249,250,251,252,256,264,266,267,268,269,270,271,272,273,274,275,276,277,280,282,283,284,285,287,290,291,298,344,347,348,351,353,355,356,364,365,366,368,372,383,385,386,388,389,390,391,392,396,397,400,401,413,419,447,449,450,451],$Vx3=[67,374],$Vy3=[8,65,71,93,104,136,142,143,205,218,264,268,450,451],$Vz3=[1,637],$VA3=[8,65,71,264,268,450,451],$VB3=[1,643],$VC3=[1,644],$VD3=[1,645],$VE3=[4,5,8,65,67,69,70,71,90,93,97,98,99,104,105,106,107,108,109,110,111,112,113,114,115,116,117,119,120,122,123,124,126,128,130,136,138,140,142,143,144,145,146,147,149,153,154,155,157,159,161,172,244,245,246,247,248,249,250,251,252,264,268,368,372,450,451],$VF3=[1,695],$VG3=[1,694],$VH3=[1,708],$VI3=[8,65,67,71,85,93,104,136,142,143,157,172,205,218,264,268,450,451],$VJ3=[1,732],$VK3=[8,67,69,71,114,119,126,264,268,368,372,450,451],$VL3=[8,67,71,114,264,268,450,451],$VM3=[8,71,81,120,163,264,268,419,450,451],$VN3=[4,5,8,47,65,67,69,70,71,81,85,90,93,99,104,105,106,107,109,110,112,114,115,116,117,119,120,122,123,124,126,128,130,136,138,140,142,143,144,145,146,147,149,155,157,159,161,163,172,180,182,194,195,196,197,198,199,200,201,205,212,215,216,218,233,244,245,246,247,248,249,250,251,252,256,264,266,267,268,269,271,272,273,274,275,276,277,280,282,283,284,285,287,290,291,298,344,347,348,351,353,355,356,364,365,366,368,372,383,385,386,388,389,390,391,392,396,397,400,401,413,419,447,449,450,451],$VO3=[4,5,8,47,65,67,69,70,71,81,85,90,93,99,104,105,106,107,108,109,110,112,113,114,115,116,117,119,120,122,123,124,126,128,130,136,138,140,142,143,144,145,146,147,149,153,154,155,157,159,161,163,172,180,182,194,195,196,197,198,199,200,201,205,212,215,216,218,233,244,245,246,247,248,249,250,251,252,256,264,266,267,268,269,270,271,272,273,274,275,276,277,280,282,283,284,285,287,290,291,298,344,347,348,351,353,355,356,364,365,366,368,372,383,385,386,388,389,390,391,392,396,397,400,401,413,419,447,449,450,451],$VP3=[4,5,8,47,65,67,69,70,71,81,85,93,99,104,105,106,107,109,110,112,114,115,116,117,119,120,122,123,124,126,130,136,138,140,142,143,144,145,146,147,149,155,157,159,161,163,172,180,182,194,195,196,197,198,199,200,201,205,212,215,216,218,233,244,245,246,247,248,249,250,251,252,256,264,266,267,268,271,272,273,274,275,276,277,282,283,285,287,290,291,298,344,347,348,351,353,355,356,364,365,366,368,372,383,385,386,388,389,390,391,392,396,397,400,401,413,419,447,449,450,451],$VQ3=[2,359],$VR3=[4,5,8,47,65,67,69,70,71,81,85,93,104,105,106,107,109,110,112,116,117,119,120,122,123,124,126,130,136,138,140,142,143,144,145,146,147,149,155,157,159,161,163,172,180,182,194,195,196,197,198,199,200,201,205,212,215,216,218,233,244,245,246,247,248,249,250,251,252,256,264,266,267,268,282,283,285,287,290,291,298,344,347,348,351,353,355,356,364,365,366,368,372,383,385,386,388,389,390,391,392,396,397,400,401,413,419,447,449,450,451],$VS3=[2,260],$VT3=[4,5,8,47,65,67,69,70,71,81,85,90,93,97,98,99,104,105,106,107,108,109,110,111,112,113,114,115,116,117,119,120,122,123,124,126,128,130,136,138,140,142,143,144,145,146,147,149,153,154,155,157,159,161,163,172,180,182,194,195,196,197,198,199,200,201,205,212,215,216,218,233,244,245,246,247,248,249,250,251,252,256,264,266,267,268,269,270,271,272,273,274,275,276,277,280,282,283,284,285,287,290,291,298,344,347,348,351,353,355,356,364,365,366,368,372,374,376,383,385,386,388,389,390,391,392,396,397,400,401,413,419,447,449,450,451],$VU3=[1,788],$VV3=[8,71,264,268,450,451],$VW3=[1,797],$VX3=[8,65,71,93,136,142,143,205,218,264,268,450,451],$VY3=[8,65,67,71,93,104,136,142,143,157,172,205,218,264,268,450,451],$VZ3=[4,5,65,69,70,71,90,93,97,98,99,104,105,106,107,108,109,110,111,112,113,114,115,116,117,119,120,122,123,124,126,128,130,136,138,140,142,143,144,145,146,147,149,159,161,244,245,246,247,248,249,250,251,252,368,372],$V_3=[4,5,65,67,69,70,71,90,93,97,98,99,104,105,106,107,108,109,110,111,112,113,114,115,116,117,119,120,122,123,124,126,128,130,136,138,140,142,143,144,145,146,147,149,159,161,244,245,246,247,248,249,250,251,252,368,372],$V$3=[2,724],$V04=[4,5,65,67,69,70,90,93,97,98,99,104,105,106,107,108,109,110,111,112,113,114,115,116,117,119,120,122,123,124,126,128,130,136,138,140,142,143,144,145,146,147,149,159,161,244,245,246,247,248,249,250,251,252,368,372],$V14=[1,846],$V24=[8,67,71,104,264,266,268,413,450,451],$V34=[1,855],$V44=[1,854],$V54=[2,521],$V64=[1,871],$V74=[69,114],$V84=[8,67,69,71,114,119,264,268,368,372,450,451],$V94=[2,660],$Va4=[1,887],$Vb4=[1,888],$Vc4=[1,893],$Vd4=[1,894],$Ve4=[2,301],$Vf4=[1,909],$Vg4=[1,920],$Vh4=[8,67,71,264,266,268,413,450,451],$Vi4=[1,923],$Vj4=[8,65,67,71,93,104,136,142,143,180,182,194,195,196,197,198,199,200,201,205,218,264,268,450,451],$Vk4=[8,264,266,268,413,450,451],$Vl4=[8,65,71,93,136,142,143,218,264,268,450,451],$Vm4=[1,935],$Vn4=[1,939],$Vo4=[1,940],$Vp4=[1,942],$Vq4=[1,943],$Vr4=[1,944],$Vs4=[1,945],$Vt4=[1,946],$Vu4=[1,947],$Vv4=[1,948],$Vw4=[1,949],$Vx4=[1,973],$Vy4=[67,71],$Vz4=[97,99],$VA4=[1,1026],$VB4=[8,65,71,136,142,143,218,264,268,450,451],$VC4=[8,65,71,93,104,136,142,143,180,182,194,195,196,197,198,199,200,201,205,218,264,268,450,451],$VD4=[1,1064],$VE4=[1,1066],$VF4=[4,5,70,116,119,126,155,260,368,372],$VG4=[1,1080],$VH4=[8,65,67,71,136,142,143,218,264,268,450,451],$VI4=[1,1099],$VJ4=[1,1101],$VK4=[1,1098],$VL4=[1,1097],$VM4=[1,1096],$VN4=[1,1102],$VO4=[1,1093],$VP4=[1,1094],$VQ4=[1,1095],$VR4=[1,1114],$VS4=[4,5,8,47,65,67,69,70,71,81,85,90,93,97,98,99,104,105,106,107,108,109,110,111,112,113,114,115,116,117,119,120,122,123,124,126,128,130,136,138,140,142,143,144,145,146,147,149,153,154,155,157,159,161,163,172,180,182,194,195,196,197,198,199,200,201,205,212,215,216,218,233,244,245,246,247,248,249,250,251,252,256,257,264,266,267,268,269,270,271,272,273,274,275,276,277,280,282,283,284,285,287,290,291,294,298,307,319,320,324,325,344,347,348,351,353,355,356,364,365,366,368,372,383,385,386,388,389,390,391,392,396,397,400,401,413,419,447,449,450,451],$VT4=[1,1123],$VU4=[1,1131],$VV4=[1,1130],$VW4=[8,65,71,136,142,143,264,268,450,451],$VX4=[1,1141],$VY4=[1,1142],$VZ4=[1,1143],$V_4=[8,65,71,93,104,136,142,143,180,182,194,195,196,197,198,199,200,201,202,203,205,218,264,268,450,451],$V$4=[4,5,8,65,71,93,104,136,142,143,180,182,194,195,196,197,198,199,200,201,202,203,205,218,264,268,450,451],$V05=[1,1188],$V15=[1,1187],$V25=[1,1189],$V35=[161,167,319,320,321,324],$V45=[2,456],$V55=[1,1194],$V65=[1,1213],$V75=[1,1224],$V85=[8,65,67,71,93,136,142,143,212,218,264,268,450,451],$V95=[1,1244],$Va5=[4,8,264,268,294,307,450,451],$Vb5=[1,1363],$Vc5=[1,1373],$Vd5=[8,67,71,202,264,268,450,451];var parser={trace:function trace(){},yy:{},symbols_:{error:2,Literal:3,LITERAL:4,BRALITERAL:5,main:6,Statements:7,EOF:8,Statements_group0:9,AStatement:10,ExplainStatement:11,EXPLAIN:12,QUERY:13,PLAN:14,Statement:15,AlterTable:16,AttachDatabase:17,CreateDatabase:18,CreateIndex:19,CreateGraph:20,CreateTable:21,CreateView:22,CreateEdge:23,CreateVertex:24,Declare:25,Delete:26,DetachDatabase:27,DropDatabase:28,DropIndex:29,DropTable:30,DropView:31,If:32,Insert:33,Merge:34,RenameTable:35,Select:36,ShowCreateTable:37,ShowColumns:38,ShowDatabases:39,ShowIndex:40,ShowTables:41,TruncateTable:42,WithSelect:43,BeginTransaction:44,CommitTransaction:45,RollbackTransaction:46,EndTransaction:47,UseDatabase:48,Update:49,Help:50,JavaScript:51,Source:52,Assert:53,While:54,Continue:55,Break:56,BeginEnd:57,Print:58,Require:59,SetVariable:60,ExpressionStatement:61,AddRule:62,Query:63,Echo:64,WITH:65,WithTablesList:66,COMMA:67,WithTable:68,AS:69,LPAR:70,RPAR:71,SelectClause:72,Select_option0:73,IntoClause:74,FromClause:75,WhereClause:76,GroupClause:77,OrderClause:78,LimitClause:79,UnionClause:80,SEARCH:81,Select_repetition0:82,Select_option1:83,RemoveClause:84,REMOVE:85,RemoveClause_option0:86,RemoveColumnsList:87,RemoveColumn:88,Column:89,LIKE:90,StringValue:91,SearchSelector:92,ORDER:93,BY:94,OrderExpressionsList:95,SearchSelector_option0:96,ARROW:97,CARET:98,EQ:99,Expression:100,SearchSelector_repetition_plus0:101,SearchSelector_repetition_plus1:102,SearchSelector_option1:103,WHERE:104,CLASS:105,NUMBER:106,STRING:107,SLASH:108,VERTEX:109,EDGE:110,EXCLAMATION:111,SHARP:112,MODULO:113,GT:114,LT:115,DOLLAR:116,DOT:117,Json:118,AT:119,SET:120,SetColumnsList:121,TO:122,VALUE:123,ROW:124,ExprList:125,COLON:126,PlusStar:127,NOT:128,SearchSelector_repetition2:129,IF:130,SearchSelector_repetition3:131,Aggregator:132,SearchSelector_repetition4:133,SearchSelector_group0:134,SearchSelector_repetition5:135,UNION:136,SearchSelectorList:137,ALL:138,SearchSelector_repetition6:139,ANY:140,SearchSelector_repetition7:141,INTERSECT:142,EXCEPT:143,AND:144,OR:145,PATH:146,RETURN:147,ResultColumns:148,REPEAT:149,SearchSelector_repetition8:150,SearchSelectorList_repetition0:151,SearchSelectorList_repetition1:152,PLUS:153,STAR:154,QUESTION:155,SearchFrom:156,FROM:157,SelectModifier:158,DISTINCT:159,TopClause:160,UNIQUE:161,SelectClause_option0:162,SELECT:163,COLUMN:164,MATRIX:165,TEXTSTRING:166,INDEX:167,RECORDSET:168,TOP:169,NumValue:170,TopClause_option0:171,INTO:172,Table:173,FuncValue:174,ParamValue:175,VarValue:176,FromTablesList:177,JoinTablesList:178,ApplyClause:179,CROSS:180,APPLY:181,OUTER:182,FromTable:183,FromTable_option0:184,FromTable_option1:185,FromString:186,JoinTable:187,JoinMode:188,JoinTableAs:189,OnClause:190,JoinTableAs_option0:191,JoinTableAs_option1:192,JoinModeMode:193,NATURAL:194,JOIN:195,INNER:196,LEFT:197,RIGHT:198,FULL:199,SEMI:200,ANTI:201,ON:202,USING:203,ColumnsList:204,GROUP:205,GroupExpressionsList:206,HavingClause:207,GroupExpression:208,GROUPING:209,ROLLUP:210,CUBE:211,HAVING:212,CORRESPONDING:213,OrderExpression:214,DIRECTION:215,COLLATE:216,NOCASE:217,LIMIT:218,OffsetClause:219,OFFSET:220,ResultColumn:221,Star:222,AggrValue:223,Op:224,LogicValue:225,NullValue:226,ExistsValue:227,CaseValue:228,CastClause:229,NewClause:230,Expression_group0:231,CURRENT_TIMESTAMP:232,JAVASCRIPT:233,NEW:234,CAST:235,ColumnType:236,CONVERT:237,PrimitiveValue:238,OverClause:239,OVER:240,OverPartitionClause:241,OverOrderByClause:242,PARTITION:243,SUM:244,COUNT:245,MIN:246,MAX:247,AVG:248,FIRST:249,LAST:250,AGGR:251,ARRAY:252,FuncValue_option0:253,TRUE:254,FALSE:255,NSTRING:256,NULL:257,EXISTS:258,ParamValue_group0:259,BRAQUESTION:260,CASE:261,WhensList:262,ElseClause:263,END:264,When:265,WHEN:266,THEN:267,ELSE:268,NOT_LIKE:269,MINUS:270,GE:271,LE:272,EQEQ:273,EQEQEQ:274,NE:275,NEEQEQ:276,NEEQEQEQ:277,CondOp:278,AllSome:279,IN:280,ColFunc:281,BETWEEN:282,NOT_BETWEEN:283,IS:284,DOUBLECOLON:285,SOME:286,UPDATE:287,SetColumn:288,SetColumn_group0:289,DELETE:290,INSERT:291,Into:292,ValuesListsList:293,DEFAULT:294,ValuesList:295,Value:296,DateValue:297,CREATE:298,TemporaryClause:299,TableClass:300,IfNotExists:301,CreateTableDefClause:302,CreateTableOptionsClause:303,TABLE:304,CreateTableOptions:305,CreateTableOption:306,IDENTITY:307,TEMP:308,ColumnDefsList:309,ConstraintsList:310,Constraint:311,ConstraintName:312,PrimaryKey:313,ForeignKey:314,UniqueKey:315,IndexKey:316,Check:317,CONSTRAINT:318,CHECK:319,PRIMARY:320,KEY:321,PrimaryKey_option0:322,ColsList:323,FOREIGN:324,REFERENCES:325,ForeignKey_option0:326,OnForeignKeyClause:327,ParColsList:328,OnDeleteClause:329,OnUpdateClause:330,NO:331,ACTION:332,UniqueKey_option0:333,ColumnDef:334,ColumnConstraintsClause:335,ColumnConstraints:336,NumberMax:337,ENUM:338,ColumnConstraintsList:339,ColumnConstraint:340,ParLiteral:341,ColumnConstraint_option0:342,ColumnConstraint_option1:343,DROP:344,DropTable_group0:345,IfExists:346,ALTER:347,RENAME:348,ADD:349,MODIFY:350,ATTACH:351,DATABASE:352,DETACH:353,AsClause:354,USE:355,SHOW:356,VIEW:357,CreateView_option0:358,CreateView_option1:359,SubqueryRestriction:360,READ:361,ONLY:362,OPTION:363,HELP:364,SOURCE:365,ASSERT:366,JsonObject:367,ATLBRA:368,JsonArray:369,JsonValue:370,JsonPrimitiveValue:371,LCUR:372,JsonPropertiesList:373,RCUR:374,JsonElementsList:375,RBRA:376,JsonProperty:377,OnOff:378,AtDollar:379,SetPropsList:380,SetProp:381,OFF:382,COMMIT:383,TRANSACTION:384,ROLLBACK:385,BEGIN:386,ElseStatement:387,WHILE:388,CONTINUE:389,BREAK:390,PRINT:391,REQUIRE:392,StringValuesList:393,PluginsList:394,Plugin:395,ECHO:396,DECLARE:397,DeclaresList:398,DeclareItem:399,TRUNCATE:400,MERGE:401,MergeInto:402,MergeUsing:403,MergeOn:404,MergeMatchedList:405,OutputClause:406,MergeMatched:407,MergeNotMatched:408,MATCHED:409,MergeMatchedAction:410,MergeNotMatchedAction:411,TARGET:412,OUTPUT:413,CreateVertex_option0:414,CreateVertex_option1:415,CreateVertex_option2:416,CreateVertexSet:417,SharpValue:418,CONTENT:419,CreateEdge_option0:420,GRAPH:421,GraphList:422,GraphVertexEdge:423,GraphElement:424,GraphVertexEdge_option0:425,GraphVertexEdge_option1:426,GraphVertexEdge_group0:427,GraphVertexEdge_option2:428,GraphVertexEdge_option3:429,GraphVertexEdge_group1:430,GraphVar:431,GraphAsClause:432,GraphAtClause:433,GraphElement_option0:434,GraphElement_option1:435,GraphElement_option2:436,GraphElement_option3:437,ColonLiteral:438,SharpLiteral:439,DeleteVertex:440,DeleteVertex_option0:441,DeleteEdge:442,DeleteEdge_option0:443,DeleteEdge_option1:444,DeleteEdge_option2:445,Term:446,COLONDASH:447,TermsList:448,QUESTIONDASH:449,SEMICOLON:450,GO:451,PERCENT:452,FuncValue_option0_group0:453,$accept:0,$end:1},terminals_:{2:"error",4:"LITERAL",5:"BRALITERAL",8:"EOF",12:"EXPLAIN",13:"QUERY",14:"PLAN",47:"EndTransaction",65:"WITH",67:"COMMA",69:"AS",70:"LPAR",71:"RPAR",81:"SEARCH",85:"REMOVE",90:"LIKE",93:"ORDER",94:"BY",97:"ARROW",98:"CARET",99:"EQ",104:"WHERE",105:"CLASS",106:"NUMBER",107:"STRING",108:"SLASH",109:"VERTEX",110:"EDGE",111:"EXCLAMATION",112:"SHARP",113:"MODULO",114:"GT",115:"LT",116:"DOLLAR",117:"DOT",119:"AT",120:"SET",122:"TO",123:"VALUE",124:"ROW",126:"COLON",128:"NOT",130:"IF",136:"UNION",138:"ALL",140:"ANY",142:"INTERSECT",143:"EXCEPT",144:"AND",145:"OR",146:"PATH",147:"RETURN",149:"REPEAT",153:"PLUS",154:"STAR",155:"QUESTION",157:"FROM",159:"DISTINCT",161:"UNIQUE",163:"SELECT",164:"COLUMN",165:"MATRIX",166:"TEXTSTRING",167:"INDEX",168:"RECORDSET",169:"TOP",172:"INTO",180:"CROSS",181:"APPLY",182:"OUTER",194:"NATURAL",195:"JOIN",196:"INNER",197:"LEFT",198:"RIGHT",199:"FULL",200:"SEMI",201:"ANTI",202:"ON",203:"USING",205:"GROUP",209:"GROUPING",210:"ROLLUP",211:"CUBE",212:"HAVING",213:"CORRESPONDING",215:"DIRECTION",216:"COLLATE",217:"NOCASE",218:"LIMIT",220:"OFFSET",232:"CURRENT_TIMESTAMP",233:"JAVASCRIPT",234:"NEW",235:"CAST",237:"CONVERT",240:"OVER",243:"PARTITION",244:"SUM",245:"COUNT",246:"MIN",247:"MAX",248:"AVG",249:"FIRST",250:"LAST",251:"AGGR",252:"ARRAY",254:"TRUE",255:"FALSE",256:"NSTRING",257:"NULL",258:"EXISTS",260:"BRAQUESTION",261:"CASE",264:"END",266:"WHEN",267:"THEN",268:"ELSE",269:"NOT_LIKE",270:"MINUS",271:"GE",272:"LE",273:"EQEQ",274:"EQEQEQ",275:"NE",276:"NEEQEQ",277:"NEEQEQEQ",280:"IN",282:"BETWEEN",283:"NOT_BETWEEN",284:"IS",285:"DOUBLECOLON",286:"SOME",287:"UPDATE",290:"DELETE",291:"INSERT",294:"DEFAULT",297:"DateValue",298:"CREATE",304:"TABLE",307:"IDENTITY",308:"TEMP",318:"CONSTRAINT",319:"CHECK",320:"PRIMARY",321:"KEY",324:"FOREIGN",325:"REFERENCES",331:"NO",332:"ACTION",336:"ColumnConstraints",338:"ENUM",344:"DROP",347:"ALTER",348:"RENAME",349:"ADD",350:"MODIFY",351:"ATTACH",352:"DATABASE",353:"DETACH",355:"USE",356:"SHOW",357:"VIEW",361:"READ",362:"ONLY",363:"OPTION",364:"HELP",365:"SOURCE",366:"ASSERT",368:"ATLBRA",372:"LCUR",374:"RCUR",376:"RBRA",382:"OFF",383:"COMMIT",384:"TRANSACTION",385:"ROLLBACK",386:"BEGIN",388:"WHILE",389:"CONTINUE",390:"BREAK",391:"PRINT",392:"REQUIRE",396:"ECHO",397:"DECLARE",400:"TRUNCATE",401:"MERGE",409:"MATCHED",412:"TARGET",413:"OUTPUT",419:"CONTENT",421:"GRAPH",447:"COLONDASH",449:"QUESTIONDASH",450:"SEMICOLON",451:"GO",452:"PERCENT"},productions_:[0,[3,1],[3,1],[6,2],[7,3],[7,1],[7,1],[11,2],[11,4],[10,1],[15,0],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[15,1],[43,3],[66,3],[66,1],[68,5],[36,9],[36,4],[84,3],[87,3],[87,1],[88,1],[88,2],[92,1],[92,5],[92,5],[92,2],[92,1],[92,2],[92,2],[92,3],[92,4],[92,4],[92,4],[92,4],[92,1],[92,1],[92,1],[92,1],[92,1],[92,1],[92,2],[92,2],[92,2],[92,1],[92,1],[92,1],[92,2],[92,1],[92,2],[92,3],[92,4],[92,3],[92,1],[92,4],[92,2],[92,2],[92,4],[92,4],[92,4],[92,4],[92,4],[92,5],[92,4],[92,4],[92,4],[92,4],[92,4],[92,4],[92,4],[92,4],[92,6],[137,3],[137,1],[127,1],[127,1],[127,1],[156,2],[72,4],[72,4],[72,4],[72,3],[158,1],[158,2],[158,2],[158,2],[158,2],[158,2],[158,2],[158,2],[160,3],[160,4],[160,0],[74,0],[74,2],[74,2],[74,2],[74,2],[74,2],[75,2],[75,3],[75,5],[75,0],[179,6],[179,7],[179,6],[179,7],[177,1],[177,3],[183,4],[183,5],[183,3],[183,3],[183,2],[183,3],[183,1],[183,2],[183,3],[183,1],[183,1],[183,2],[183,3],[183,1],[183,2],[183,3],[183,1],[183,2],[183,3],[186,1],[173,3],[173,1],[178,2],[178,2],[178,1],[178,1],[187,3],[189,1],[189,2],[189,3],[189,3],[189,2],[189,3],[189,4],[189,5],[189,1],[189,2],[189,3],[189,1],[189,2],[189,3],[188,1],[188,2],[193,1],[193,2],[193,2],[193,3],[193,2],[193,3],[193,2],[193,3],[193,2],[193,2],[193,2],[190,2],[190,2],[190,0],[76,0],[76,2],[77,0],[77,4],[206,1],[206,3],[208,5],[208,4],[208,4],[208,1],[207,0],[207,2],[80,0],[80,2],[80,3],[80,2],[80,2],[80,3],[80,4],[80,3],[80,3],[78,0],[78,3],[95,1],[95,3],[214,1],[214,2],[214,3],[214,4],[79,0],[79,3],[219,0],[219,2],[148,3],[148,1],[221,3],[221,2],[221,3],[221,2],[221,3],[221,2],[221,1],[222,5],[222,3],[222,1],[89,5],[89,3],[89,3],[89,1],[100,1],[100,1],[100,1],[100,1],[100,1],[100,1],[100,1],[100,1],[100,1],[100,1],[100,1],[100,1],[100,1],[100,1],[100,1],[100,1],[100,3],[100,3],[100,3],[100,1],[100,1],[51,1],[230,2],[230,2],[229,6],[229,8],[229,6],[229,8],[238,1],[238,1],[238,1],[238,1],[238,1],[238,1],[238,1],[223,5],[223,6],[223,6],[239,0],[239,4],[239,4],[239,5],[241,3],[242,3],[132,1],[132,1],[132,1],[132,1],[132,1],[132,1],[132,1],[132,1],[132,1],[174,5],[174,3],[125,1],[125,3],[170,1],[225,1],[225,1],[91,1],[91,1],[226,1],[176,2],[227,4],[175,2],[175,2],[175,1],[175,1],[228,5],[228,4],[262,2],[262,1],[265,4],[263,2],[263,0],[224,3],[224,3],[224,3],[224,3],[224,3],[224,3],[224,3],[224,3],[224,3],[224,3],[224,5],[224,3],[224,3],[224,3],[224,5],[224,3],[224,3],[224,3],[224,3],[224,3],[224,3],[224,3],[224,3],[224,3],[224,3],[224,3],[224,6],[224,6],[224,3],[224,3],[224,2],[224,2],[224,2],[224,2],[224,3],[224,5],[224,6],[224,5],[224,6],[224,4],[224,5],[224,3],[224,4],[224,3],[224,4],[224,3],[224,3],[224,3],[224,3],[281,1],[281,1],[281,4],[278,1],[278,1],[278,1],[278,1],[278,1],[278,1],[279,1],[279,1],[279,1],[49,6],[49,4],[121,1],[121,3],[288,3],[288,4],[26,5],[26,3],[33,5],[33,5],[33,8],[33,4],[33,7],[292,0],[292,1],[293,3],[293,1],[293,1],[293,5],[293,3],[293,3],[295,1],[295,3],[296,1],[296,1],[296,1],[296,1],[296,1],[296,1],[204,1],[204,3],[21,9],[21,5],[300,1],[300,1],[303,0],[303,1],[305,2],[305,1],[306,1],[306,3],[306,3],[299,0],[299,1],[301,0],[301,3],[302,3],[302,1],[302,2],[310,1],[310,3],[311,2],[311,2],[311,2],[311,2],[311,2],[312,0],[312,2],[317,4],[313,6],[314,9],[328,3],[327,0],[327,2],[329,4],[330,4],[315,5],[316,5],[316,5],[323,1],[323,1],[323,3],[323,3],[309,1],[309,3],[334,3],[334,2],[334,1],[236,6],[236,7],[236,4],[236,5],[236,1],[236,2],[236,4],[337,1],[337,1],[335,0],[335,1],[339,2],[339,1],[341,3],[340,2],[340,5],[340,3],[340,6],[340,1],[340,2],[340,4],[340,1],[340,2],[340,1],[340,1],[30,4],[346,0],[346,2],[16,6],[16,6],[16,6],[16,8],[16,6],[35,5],[17,4],[17,7],[17,6],[17,9],[27,3],[18,4],[18,6],[18,9],[18,6],[354,0],[354,2],[48,3],[48,2],[28,4],[28,5],[28,5],[19,8],[19,9],[29,3],[39,2],[39,4],[39,3],[39,5],[41,2],[41,4],[41,4],[41,6],[38,4],[38,6],[40,4],[40,6],[37,4],[37,6],[22,11],[22,8],[360,3],[360,3],[360,5],[31,4],[50,2],[50,1],[61,2],[52,2],[53,2],[53,2],[53,4],[118,4],[118,2],[118,2],[118,2],[118,2],[118,1],[118,2],[118,2],[370,1],[370,1],[371,1],[371,1],[371,1],[371,1],[371,1],[371,1],[371,1],[371,3],[367,3],[367,4],[367,2],[369,2],[369,3],[369,1],[373,3],[373,1],[377,3],[377,3],[377,3],[375,3],[375,1],[60,3],[60,5],[60,6],[379,1],[379,1],[380,3],[380,2],[381,1],[381,1],[381,3],[378,1],[378,1],[45,2],[46,2],[44,2],[32,4],[32,3],[387,2],[54,3],[55,1],[56,1],[57,3],[58,2],[58,2],[59,2],[59,2],[395,1],[395,1],[64,2],[393,3],[393,1],[394,3],[394,1],[25,2],[398,1],[398,3],[399,3],[399,4],[399,5],[399,6],[42,3],[34,6],[402,1],[402,2],[403,2],[404,2],[405,2],[405,2],[405,1],[405,1],[407,4],[407,6],[410,1],[410,3],[408,5],[408,7],[408,7],[408,9],[408,7],[408,9],[411,3],[411,6],[411,3],[411,6],[406,0],[406,2],[406,5],[406,4],[406,7],[24,6],[418,2],[417,0],[417,2],[417,2],[417,1],[23,8],[20,3],[20,4],[422,3],[422,1],[423,3],[423,7],[423,4],[431,2],[432,3],[433,2],[424,4],[438,2],[439,2],[439,2],[440,4],[442,6],[62,3],[62,2],[448,3],[448,1],[446,1],[446,4],[63,2],[9,1],[9,1],[73,0],[73,1],[82,0],[82,2],[83,0],[83,1],[86,0],[86,1],[96,0],[96,1],[101,1],[101,2],[102,1],[102,2],[103,0],[103,1],[129,0],[129,2],[131,0],[131,2],[133,0],[133,2],[134,1],[134,1],[135,0],[135,2],[139,0],[139,2],[141,0],[141,2],[150,0],[150,2],[151,0],[151,2],[152,0],[152,2],[162,0],[162,1],[171,0],[171,1],[184,0],[184,1],[185,0],[185,1],[191,0],[191,1],[192,0],[192,1],[231,1],[231,1],[453,1],[453,1],[253,0],[253,1],[259,1],[259,1],[289,1],[289,1],[322,0],[322,1],[326,0],[326,1],[333,0],[333,1],[342,0],[342,1],[343,0],[343,1],[345,1],[345,1],[358,0],[358,1],[359,0],[359,1],[414,0],[414,1],[415,0],[415,1],[416,0],[416,1],[420,0],[420,1],[425,0],[425,1],[426,0],[426,1],[427,1],[427,1],[428,0],[428,1],[429,0],[429,1],[430,1],[430,1],[434,0],[434,1],[435,0],[435,1],[436,0],[436,1],[437,0],[437,1],[441,0],[441,2],[443,0],[443,2],[444,0],[444,2],[445,0],[445,2]],performAction:function anonymous(yytext,yyleng,yylineno,yy,yystate,$$,_$){var $0=$$.length-1;switch(yystate){case 1:if(yy.casesensitive)this.$=$$[$0];else this.$=$$[$0].toLowerCase();break;case 2:this.$=doubleq($$[$0].substr(1,$$[$0].length-2));break;case 3:return new yy.Statements({statements:$$[$0-1]});break;case 4:this.$=$$[$0-2];if($$[$0])$$[$0-2].push($$[$0]);break;case 5:case 6:case 62:case 68:case 121:case 155:case 181:case 182:case 218:case 237:case 248:case 318:case 335:case 402:case 416:case 417:case 421:case 429:case 469:case 470:case 588:case 595:case 619:case 621:case 623:case 637:case 638:case 668:case 684:this.$=[$$[$0]];break;case 7:this.$=$$[$0];$$[$0].explain=true;
    break;case 8:this.$=$$[$0];$$[$0].explain=true;break;case 9:this.$=$$[$0];if(yy.exists)this.$.exists=yy.exists;delete yy.exists;if(yy.queries)this.$.queries=yy.queries;delete yy.queries;break;case 10:case 140:case 150:case 213:case 214:case 216:case 224:case 226:case 235:case 243:case 245:case 338:case 433:case 442:case 444:case 456:case 462:case 463:case 504:this.$=undefined;break;case 60:this.$=new yy.WithSelect({withs:$$[$0-1],select:$$[$0]});break;case 61:$$[$0-2].push($$[$0]);this.$=$$[$0-2];break;case 63:this.$={name:$$[$0-4],select:$$[$0-1]};break;case 64:yy.extend(this.$,$$[$0-8]);yy.extend(this.$,$$[$0-7]);yy.extend(this.$,$$[$0-6]);yy.extend(this.$,$$[$0-5]);yy.extend(this.$,$$[$0-4]);yy.extend(this.$,$$[$0-3]);yy.extend(this.$,$$[$0-2]);yy.extend(this.$,$$[$0-1]);yy.extend(this.$,$$[$0]);this.$=$$[$0-8];break;case 65:this.$=new yy.Search({selectors:$$[$0-2],from:$$[$0]});yy.extend(this.$,$$[$0-1]);break;case 66:this.$={removecolumns:$$[$0]};break;case 67:case 667:case 683:this.$=$$[$0-2];this.$.push($$[$0]);break;case 69:case 125:case 163:case 223:case 255:case 263:case 264:case 265:case 266:case 267:case 268:case 269:case 270:case 271:case 272:case 273:case 274:case 275:case 276:case 278:case 291:case 292:case 293:case 294:case 295:case 296:case 337:case 391:case 392:case 393:case 394:case 395:case 396:case 457:case 488:case 490:case 562:case 563:case 564:case 565:case 566:case 567:case 571:case 573:case 574:case 583:case 596:case 597:case 659:case 673:case 674:case 676:case 677:this.$=$$[$0];break;case 70:this.$={like:$$[$0]};break;case 71:case 83:this.$={srchid:"PROP",args:[$$[$0]]};break;case 72:this.$={srchid:"ORDERBY",args:$$[$0-1]};break;case 73:var dir=$$[$0-1];if(!dir)dir="ASC";this.$={srchid:"ORDERBY",args:[{expression:new yy.Column({columnid:"_"}),direction:dir}]};break;case 74:this.$={srchid:"APROP",args:[$$[$0]]};break;case 75:this.$={selid:"ROOT"};break;case 76:this.$={srchid:"EQ",args:[$$[$0]]};break;case 77:this.$={srchid:"LIKE",args:[$$[$0]]};break;case 78:case 79:this.$={selid:"WITH",args:$$[$0-1]};break;case 80:this.$={srchid:$$[$0-3].toUpperCase(),args:$$[$0-1]};break;case 81:this.$={srchid:"WHERE",args:[$$[$0-1]]};break;case 82:this.$={srchid:"CLASS",args:[$$[$0-1]]};break;case 84:this.$={srchid:"NAME",args:[$$[$0].substr(1,$$[$0].length-2)]};break;case 85:this.$={srchid:"CHILD"};break;case 86:this.$={srchid:"VERTEX"};break;case 87:this.$={srchid:"EDGE"};break;case 88:this.$={srchid:"REF"};break;case 89:this.$={srchid:"SHARP",args:[$$[$0]]};break;case 90:this.$={srchid:"ATTR",args:typeof $$[$0]=="undefined"?undefined:[$$[$0]]};break;case 91:this.$={srchid:"ATTR"};break;case 92:this.$={srchid:"OUT"};break;case 93:this.$={srchid:"IN"};break;case 94:this.$={srchid:"CONTENT"};break;case 95:this.$={srchid:"PARENT"};break;case 96:this.$={srchid:"EX",args:[new yy.Json({value:$$[$0]})]};break;case 97:this.$={srchid:"AT",args:[$$[$0]]};break;case 98:this.$={srchid:"AS",args:[$$[$0]]};break;case 99:this.$={srchid:"SET",args:$$[$0-1]};break;case 100:this.$={selid:"TO",args:[$$[$0]]};break;case 101:this.$={srchid:"VALUE"};break;case 102:this.$={srchid:"ROW",args:$$[$0-1]};break;case 103:this.$={srchid:"CLASS",args:[$$[$0]]};break;case 104:this.$={selid:$$[$0],args:[$$[$0-1]]};break;case 105:this.$={selid:"NOT",args:$$[$0-1]};break;case 106:this.$={selid:"IF",args:$$[$0-1]};break;case 107:this.$={selid:$$[$0-3],args:$$[$0-1]};break;case 108:this.$={selid:"DISTINCT",args:$$[$0-1]};break;case 109:this.$={selid:"UNION",args:$$[$0-1]};break;case 110:this.$={selid:"UNIONALL",args:$$[$0-1]};break;case 111:this.$={selid:"ALL",args:[$$[$0-1]]};break;case 112:this.$={selid:"ANY",args:[$$[$0-1]]};break;case 113:this.$={selid:"INTERSECT",args:$$[$0-1]};break;case 114:this.$={selid:"EXCEPT",args:$$[$0-1]};break;case 115:this.$={selid:"AND",args:$$[$0-1]};break;case 116:this.$={selid:"OR",args:$$[$0-1]};break;case 117:this.$={selid:"PATH",args:[$$[$0-1]]};break;case 118:this.$={srchid:"RETURN",args:$$[$0-1]};break;case 119:this.$={selid:"REPEAT",sels:$$[$0-3],args:$$[$0-1]};break;case 120:this.$=$$[$0-2];this.$.push($$[$0]);break;case 122:this.$="PLUS";break;case 123:this.$="STAR";break;case 124:this.$="QUESTION";break;case 126:this.$=new yy.Select({columns:$$[$0],distinct:true});yy.extend(this.$,$$[$0-3]);yy.extend(this.$,$$[$0-1]);break;case 127:this.$=new yy.Select({columns:$$[$0],distinct:true});yy.extend(this.$,$$[$0-3]);yy.extend(this.$,$$[$0-1]);break;case 128:this.$=new yy.Select({columns:$$[$0],all:true});yy.extend(this.$,$$[$0-3]);yy.extend(this.$,$$[$0-1]);break;case 129:if(!$$[$0]){this.$=new yy.Select({columns:[new yy.Column({columnid:"_"})],modifier:"COLUMN"})}else{this.$=new yy.Select({columns:$$[$0]});yy.extend(this.$,$$[$0-2]);yy.extend(this.$,$$[$0-1])}break;case 130:if($$[$0]=="SELECT")this.$=undefined;else this.$={modifier:$$[$0]};break;case 131:this.$={modifier:"VALUE"};break;case 132:this.$={modifier:"ROW"};break;case 133:this.$={modifier:"COLUMN"};break;case 134:this.$={modifier:"MATRIX"};break;case 135:this.$={modifier:"TEXTSTRING"};break;case 136:this.$={modifier:"INDEX"};break;case 137:this.$={modifier:"RECORDSET"};break;case 138:this.$={top:$$[$0-1],percent:typeof $$[$0]!="undefined"?true:undefined};break;case 139:this.$={top:$$[$0-1]};break;case 141:case 301:case 464:case 465:case 660:this.$=undefined;break;case 142:case 143:case 144:case 145:this.$={into:$$[$0]};break;case 146:var s=$$[$0];s=s.substr(1,s.length-2);var x3=s.substr(-3).toUpperCase();var x4=s.substr(-4).toUpperCase();if(s[0]=="#"){this.$={into:new yy.FuncValue({funcid:"HTML",args:[new yy.StringValue({value:s}),new yy.Json({value:{headers:true}})]})}}else if(x3=="XLS"||x3=="CSV"||x3=="TAB"){this.$={into:new yy.FuncValue({funcid:x3,args:[new yy.StringValue({value:s}),new yy.Json({value:{headers:true}})]})}}else if(x4=="XLSX"||x4=="JSON"){this.$={into:new yy.FuncValue({funcid:x4,args:[new yy.StringValue({value:s}),new yy.Json({value:{headers:true}})]})}}break;case 147:this.$={from:$$[$0]};break;case 148:this.$={from:$$[$0-1],joins:$$[$0]};break;case 149:this.$={from:$$[$0-2],joins:$$[$0-1]};break;case 151:this.$=new yy.Apply({select:$$[$0-2],applymode:"CROSS",as:$$[$0]});break;case 152:this.$=new yy.Apply({select:$$[$0-3],applymode:"CROSS",as:$$[$0]});break;case 153:this.$=new yy.Apply({select:$$[$0-2],applymode:"OUTER",as:$$[$0]});break;case 154:this.$=new yy.Apply({select:$$[$0-3],applymode:"OUTER",as:$$[$0]});break;case 156:case 219:case 403:case 471:case 472:this.$=$$[$0-2];$$[$0-2].push($$[$0]);break;case 157:this.$=$$[$0-2];this.$.as=$$[$0];break;case 158:this.$=$$[$0-3];this.$.as=$$[$0];break;case 159:this.$=$$[$0-1];this.$.as="default";break;case 160:this.$=new yy.Json({value:$$[$0-2]});$$[$0-2].as=$$[$0];break;case 161:this.$=$$[$0-1];$$[$0-1].as=$$[$0];break;case 162:this.$=$$[$0-2];$$[$0-2].as=$$[$0];break;case 164:case 168:case 171:case 174:this.$=$$[$0-1];$$[$0-1].as=$$[$0];break;case 165:case 169:case 172:case 175:this.$=$$[$0-2];$$[$0-2].as=$$[$0];break;case 166:case 167:case 170:case 173:this.$=$$[$0];$$[$0].as="default";break;case 176:var s=$$[$0];s=s.substr(1,s.length-2);var x3=s.substr(-3).toUpperCase();var x4=s.substr(-4).toUpperCase();var r;if(s[0]=="#"){r=new yy.FuncValue({funcid:"HTML",args:[new yy.StringValue({value:s}),new yy.Json({value:{headers:true}})]})}else if(x3=="XLS"||x3=="CSV"||x3=="TAB"){r=new yy.FuncValue({funcid:x3,args:[new yy.StringValue({value:s}),new yy.Json({value:{headers:true}})]})}else if(x4=="XLSX"||x4=="JSON"){r=new yy.FuncValue({funcid:x4,args:[new yy.StringValue({value:s}),new yy.Json({value:{headers:true}})]})}else{throw new Error("Unknown string in FROM clause")};this.$=r;break;case 177:if($$[$0-2]=="INFORMATION_SCHEMA"){this.$=new yy.FuncValue({funcid:$$[$0-2],args:[new yy.StringValue({value:$$[$0]})]})}else{this.$=new yy.Table({databaseid:$$[$0-2],tableid:$$[$0]})}break;case 178:this.$=new yy.Table({tableid:$$[$0]});break;case 179:case 180:this.$=$$[$0-1];$$[$0-1].push($$[$0]);break;case 183:this.$=new yy.Join($$[$0-2]);yy.extend(this.$,$$[$0-1]);yy.extend(this.$,$$[$0]);break;case 184:this.$={table:$$[$0]};break;case 185:this.$={table:$$[$0-1],as:$$[$0]};break;case 186:this.$={table:$$[$0-2],as:$$[$0]};break;case 187:this.$={json:new yy.Json({value:$$[$0-2],as:$$[$0]})};break;case 188:this.$={param:$$[$0-1],as:$$[$0]};break;case 189:this.$={param:$$[$0-2],as:$$[$0]};break;case 190:this.$={select:$$[$0-3],as:$$[$0]};break;case 191:this.$={select:$$[$0-4],as:$$[$0]};break;case 192:this.$={funcid:$$[$0],as:"default"};break;case 193:this.$={funcid:$$[$0-1],as:$$[$0]};break;case 194:this.$={funcid:$$[$0-2],as:$$[$0]};break;case 195:this.$={variable:$$[$0],as:"default"};break;case 196:this.$={variable:$$[$0-1],as:$$[$0]};break;case 197:this.$={variable:$$[$0-2],as:$$[$0]};break;case 198:this.$={joinmode:$$[$0]};break;case 199:this.$={joinmode:$$[$0-1],natural:true};break;case 200:case 201:this.$="INNER";break;case 202:case 203:this.$="LEFT";break;case 204:case 205:this.$="RIGHT";break;case 206:case 207:this.$="OUTER";break;case 208:this.$="SEMI";break;case 209:this.$="ANTI";break;case 210:this.$="CROSS";break;case 211:this.$={on:$$[$0]};break;case 212:case 633:this.$={using:$$[$0]};break;case 215:this.$={where:new yy.Expression({expression:$$[$0]})};break;case 217:this.$={group:$$[$0-1]};yy.extend(this.$,$$[$0]);break;case 220:this.$=new yy.GroupExpression({type:"GROUPING SETS",group:$$[$0-1]});break;case 221:this.$=new yy.GroupExpression({type:"ROLLUP",group:$$[$0-1]});break;case 222:this.$=new yy.GroupExpression({type:"CUBE",group:$$[$0-1]});break;case 225:this.$={having:$$[$0]};break;case 227:this.$={union:$$[$0]};break;case 228:this.$={unionall:$$[$0]};break;case 229:this.$={except:$$[$0]};break;case 230:this.$={intersect:$$[$0]};break;case 231:this.$={union:$$[$0],corresponding:true};break;case 232:this.$={unionall:$$[$0],corresponding:true};break;case 233:this.$={except:$$[$0],corresponding:true};break;case 234:this.$={intersect:$$[$0],corresponding:true};break;case 236:this.$={order:$$[$0]};break;case 238:this.$=$$[$0-2];$$[$0-2].push($$[$0]);break;case 239:this.$=new yy.Expression({expression:$$[$0],direction:"ASC"});break;case 240:this.$=new yy.Expression({expression:$$[$0-1],direction:$$[$0].toUpperCase()});break;case 241:this.$=new yy.Expression({expression:$$[$0-2],direction:"ASC",nocase:true});break;case 242:this.$=new yy.Expression({expression:$$[$0-3],direction:$$[$0].toUpperCase(),nocase:true});break;case 244:this.$={limit:$$[$0-1]};yy.extend(this.$,$$[$0]);break;case 246:this.$={offset:$$[$0]};break;case 247:case 450:case 474:case 587:case 594:case 618:case 620:case 624:$$[$0-2].push($$[$0]);this.$=$$[$0-2];break;case 249:case 251:case 253:$$[$0-2].as=$$[$0];this.$=$$[$0-2];break;case 250:case 252:case 254:$$[$0-1].as=$$[$0];this.$=$$[$0-1];break;case 256:this.$=new yy.Column({columid:$$[$0],tableid:$$[$0-2],databaseid:$$[$0-4]});break;case 257:this.$=new yy.Column({columnid:$$[$0],tableid:$$[$0-2]});break;case 258:this.$=new yy.Column({columnid:$$[$0]});break;case 259:this.$=new yy.Column({columnid:$$[$0],tableid:$$[$0-2],databaseid:$$[$0-4]});break;case 260:case 261:this.$=new yy.Column({columnid:$$[$0],tableid:$$[$0-2]});break;case 262:this.$=new yy.Column({columnid:$$[$0]});break;case 277:this.$=new yy.Json({value:$$[$0]});break;case 279:case 280:case 281:if(!yy.queries)yy.queries=[];yy.queries.push($$[$0-1]);$$[$0-1].queriesidx=yy.queries.length;this.$=$$[$0-1];break;case 282:this.$=$$[$0];break;case 283:this.$=new yy.FuncValue({funcid:"CURRENT_TIMESTAMP"});break;case 284:this.$=new yy.JavaScript({value:$$[$0].substr(2,$$[$0].length-4)});break;case 285:this.$=new yy.FuncValue({funcid:$$[$0],newid:true});break;case 286:this.$=$$[$0];yy.extend(this.$,{newid:true});break;case 287:this.$=new yy.Convert({expression:$$[$0-3]});yy.extend(this.$,$$[$0-1]);break;case 288:this.$=new yy.Convert({expression:$$[$0-5],style:$$[$0-1]});yy.extend(this.$,$$[$0-3]);break;case 289:this.$=new yy.Convert({expression:$$[$0-1]});yy.extend(this.$,$$[$0-3]);break;case 290:this.$=new yy.Convert({expression:$$[$0-3],style:$$[$0-1]});yy.extend(this.$,$$[$0-5]);break;case 297:this.$=new yy.FuncValue({funcid:"CURRENT_TIMESTAMP"});break;case 298:if($$[$0-2].length>1&&($$[$0-4].toUpperCase()=="MAX"||$$[$0-4].toUpperCase()=="MIN")){this.$=new yy.FuncValue({funcid:$$[$0-4],args:$$[$0-2]})}else{this.$=new yy.AggrValue({aggregatorid:$$[$0-4].toUpperCase(),expression:$$[$0-2].pop(),over:$$[$0]})}break;case 299:this.$=new yy.AggrValue({aggregatorid:$$[$0-5].toUpperCase(),expression:$$[$0-2],distinct:true,over:$$[$0]});break;case 300:this.$=new yy.AggrValue({aggregatorid:$$[$0-5].toUpperCase(),expression:$$[$0-2],over:$$[$0]});break;case 302:case 303:this.$=new yy.Over;yy.extend(this.$,$$[$0-1]);break;case 304:this.$=new yy.Over;yy.extend(this.$,$$[$0-2]);yy.extend(this.$,$$[$0-1]);break;case 305:this.$={partition:$$[$0]};break;case 306:this.$={order:$$[$0]};break;case 307:this.$="SUM";break;case 308:this.$="COUNT";break;case 309:this.$="MIN";break;case 310:case 486:this.$="MAX";break;case 311:this.$="AVG";break;case 312:this.$="FIRST";break;case 313:this.$="LAST";break;case 314:this.$="AGGR";break;case 315:this.$="ARRAY";break;case 316:var funcid=$$[$0-4];var exprlist=$$[$0-1];if(exprlist.length>1&&(funcid.toUpperCase()=="MIN"||funcid.toUpperCase()=="MAX")){this.$=new yy.FuncValue({funcid:funcid,args:exprlist})}else if(alasql.aggr[$$[$0-4]]){this.$=new yy.AggrValue({aggregatorid:"REDUCE",funcid:funcid,expression:exprlist.pop(),distinct:$$[$0-2]=="DISTINCT"})}else{this.$=new yy.FuncValue({funcid:funcid,args:exprlist})};break;case 317:this.$=new yy.FuncValue({funcid:$$[$0-2]});break;case 319:$$[$0-2].push($$[$0]);this.$=$$[$0-2];break;case 320:this.$=new yy.NumValue({value:+$$[$0]});break;case 321:this.$=new yy.LogicValue({value:true});break;case 322:this.$=new yy.LogicValue({value:false});break;case 323:this.$=new yy.StringValue({value:$$[$0].substr(1,$$[$0].length-2).replace(/(\\\')/g,"'").replace(/(\'\')/g,"'")});break;case 324:this.$=new yy.StringValue({value:$$[$0].substr(2,$$[$0].length-3).replace(/(\\\')/g,"'").replace(/(\'\')/g,"'")});break;case 325:this.$=new yy.NullValue({value:undefined});break;case 326:this.$=new yy.VarValue({variable:$$[$0]});break;case 327:if(!yy.exists)yy.exists=[];this.$=new yy.ExistsValue({value:$$[$0-1],existsidx:yy.exists.length});yy.exists.push($$[$0-1]);break;case 328:case 329:this.$=new yy.ParamValue({param:$$[$0]});break;case 330:if(typeof yy.question=="undefined")yy.question=0;this.$=new yy.ParamValue({param:yy.question++});break;case 331:if(typeof yy.question=="undefined")yy.question=0;this.$=new yy.ParamValue({param:yy.question++,array:true});break;case 332:this.$=new yy.CaseValue({expression:$$[$0-3],whens:$$[$0-2],elses:$$[$0-1]});break;case 333:this.$=new yy.CaseValue({whens:$$[$0-2],elses:$$[$0-1]});break;case 334:case 635:case 636:this.$=$$[$0-1];this.$.push($$[$0]);break;case 336:this.$={when:$$[$0-2],then:$$[$0]};break;case 339:this.$=new yy.Op({left:$$[$0-2],op:"LIKE",right:$$[$0]});break;case 340:this.$=new yy.Op({left:$$[$0-2],op:"NOT LIKE",right:$$[$0]});break;case 341:this.$=new yy.Op({left:$$[$0-2],op:"+",right:$$[$0]});break;case 342:this.$=new yy.Op({left:$$[$0-2],op:"-",right:$$[$0]});break;case 343:this.$=new yy.Op({left:$$[$0-2],op:"*",right:$$[$0]});break;case 344:this.$=new yy.Op({left:$$[$0-2],op:"/",right:$$[$0]});break;case 345:this.$=new yy.Op({left:$$[$0-2],op:"%",right:$$[$0]});break;case 346:this.$=new yy.Op({left:$$[$0-2],op:"^",right:$$[$0]});break;case 347:case 348:case 350:this.$=new yy.Op({left:$$[$0-2],op:"->",right:$$[$0]});break;case 349:this.$=new yy.Op({left:$$[$0-4],op:"->",right:$$[$0-1]});break;case 351:case 352:case 354:this.$=new yy.Op({left:$$[$0-2],op:"!",right:$$[$0]});break;case 353:this.$=new yy.Op({left:$$[$0-4],op:"!",right:$$[$0-1]});break;case 355:this.$=new yy.Op({left:$$[$0-2],op:">",right:$$[$0]});break;case 356:this.$=new yy.Op({left:$$[$0-2],op:">=",right:$$[$0]});break;case 357:this.$=new yy.Op({left:$$[$0-2],op:"<",right:$$[$0]});break;case 358:this.$=new yy.Op({left:$$[$0-2],op:"<=",right:$$[$0]});break;case 359:this.$=new yy.Op({left:$$[$0-2],op:"=",right:$$[$0]});break;case 360:this.$=new yy.Op({left:$$[$0-2],op:"==",right:$$[$0]});break;case 361:this.$=new yy.Op({left:$$[$0-2],op:"===",right:$$[$0]});break;case 362:this.$=new yy.Op({left:$$[$0-2],op:"!=",right:$$[$0]});break;case 363:this.$=new yy.Op({left:$$[$0-2],op:"!==",right:$$[$0]});break;case 364:this.$=new yy.Op({left:$$[$0-2],op:"!===",right:$$[$0]});break;case 365:if(!yy.queries)yy.queries=[];this.$=new yy.Op({left:$$[$0-5],op:$$[$0-4],allsome:$$[$0-3],right:$$[$0-1],queriesidx:yy.queries.length});yy.queries.push($$[$0-1]);break;case 366:this.$=new yy.Op({left:$$[$0-5],op:$$[$0-4],allsome:$$[$0-3],right:$$[$0-1]});break;case 367:if($$[$0-2].op=="BETWEEN1"){if($$[$0-2].left.op=="AND"){this.$=new yy.Op({left:$$[$0-2].left.left,op:"AND",right:new yy.Op({left:$$[$0-2].left.right,op:"BETWEEN",right1:$$[$0-2].right,right2:$$[$0]})})}else{this.$=new yy.Op({left:$$[$0-2].left,op:"BETWEEN",right1:$$[$0-2].right,right2:$$[$0]})}}else if($$[$0-2].op=="NOT BETWEEN1"){if($$[$0-2].left.op=="AND"){this.$=new yy.Op({left:$$[$0-2].left.left,op:"AND",right:new yy.Op({left:$$[$0-2].left.right,op:"NOT BETWEEN",right1:$$[$0-2].right,right2:$$[$0]})})}else{this.$=new yy.Op({left:$$[$0-2].left,op:"NOT BETWEEN",right1:$$[$0-2].right,right2:$$[$0]})}}else{this.$=new yy.Op({left:$$[$0-2],op:"AND",right:$$[$0]})}break;case 368:this.$=new yy.Op({left:$$[$0-2],op:"OR",right:$$[$0]});break;case 369:this.$=new yy.UniOp({op:"NOT",right:$$[$0]});break;case 370:this.$=new yy.UniOp({op:"-",right:$$[$0]});break;case 371:this.$=new yy.UniOp({op:"+",right:$$[$0]});break;case 372:this.$=new yy.UniOp({op:"#",right:$$[$0]});break;case 373:this.$=new yy.UniOp({right:$$[$0-1]});break;case 374:if(!yy.queries)yy.queries=[];this.$=new yy.Op({left:$$[$0-4],op:"IN",right:$$[$0-1],queriesidx:yy.queries.length});yy.queries.push($$[$0-1]);break;case 375:if(!yy.queries)yy.queries=[];this.$=new yy.Op({left:$$[$0-5],op:"NOT IN",right:$$[$0-1],queriesidx:yy.queries.length});yy.queries.push($$[$0-1]);break;case 376:this.$=new yy.Op({left:$$[$0-4],op:"IN",right:$$[$0-1]});break;case 377:this.$=new yy.Op({left:$$[$0-5],op:"NOT IN",right:$$[$0-1]});break;case 378:this.$=new yy.Op({left:$$[$0-3],op:"IN",right:[]});break;case 379:this.$=new yy.Op({left:$$[$0-4],op:"NOT IN",right:[]});break;case 380:case 382:this.$=new yy.Op({left:$$[$0-2],op:"IN",right:$$[$0]});break;case 381:case 383:this.$=new yy.Op({left:$$[$0-3],op:"NOT IN",right:$$[$0]});break;case 384:this.$=new yy.Op({left:$$[$0-2],op:"BETWEEN1",right:$$[$0]});break;case 385:this.$=new yy.Op({left:$$[$0-2],op:"NOT BETWEEN1",right:$$[$0]});break;case 386:this.$=new yy.Op({op:"IS",left:$$[$0-2],right:$$[$0]});break;case 387:this.$=new yy.Convert({expression:$$[$0-2]});yy.extend(this.$,$$[$0]);break;case 388:case 389:this.$=$$[$0];break;case 390:this.$=$$[$0-1];break;case 397:this.$="ALL";break;case 398:this.$="SOME";break;case 399:this.$="ANY";break;case 400:this.$=new yy.Update({table:$$[$0-4],columns:$$[$0-2],where:$$[$0]});break;case 401:this.$=new yy.Update({table:$$[$0-2],columns:$$[$0]});break;case 404:this.$=new yy.SetColumn({column:$$[$0-2],expression:$$[$0]});break;case 405:this.$=new yy.SetColumn({variable:$$[$0-2],expression:$$[$0],method:$$[$0-3]});break;case 406:this.$=new yy.Delete({table:$$[$0-2],where:$$[$0]});break;case 407:this.$=new yy.Delete({table:$$[$0]});break;case 408:this.$=new yy.Insert({into:$$[$0-2],values:$$[$0]});break;case 409:this.$=new yy.Insert({into:$$[$0-2],"default":true});break;case 410:this.$=new yy.Insert({into:$$[$0-5],columns:$$[$0-3],values:$$[$0]});break;case 411:this.$=new yy.Insert({into:$$[$0-1],select:$$[$0]});break;case 412:this.$=new yy.Insert({into:$$[$0-4],columns:$$[$0-2],select:$$[$0]});break;case 415:this.$=[$$[$0-1]];break;case 418:this.$=$$[$0-4];$$[$0-4].push($$[$0-1]);break;case 419:case 420:case 422:case 430:this.$=$$[$0-2];$$[$0-2].push($$[$0]);break;case 431:this.$=new yy.CreateTable({table:$$[$0-4]});yy.extend(this.$,$$[$0-7]);yy.extend(this.$,$$[$0-6]);yy.extend(this.$,$$[$0-5]);yy.extend(this.$,$$[$0-2]);yy.extend(this.$,$$[$0]);break;case 432:this.$=new yy.CreateTable({table:$$[$0]});yy.extend(this.$,$$[$0-3]);yy.extend(this.$,$$[$0-2]);yy.extend(this.$,$$[$0-1]);break;case 434:this.$={"class":true};break;case 443:this.$={temporary:true};break;case 445:this.$={ifnotexists:true};break;case 446:this.$={columns:$$[$0-2],constraints:$$[$0]};break;case 447:this.$={columns:$$[$0]};break;case 448:this.$={as:$$[$0]};break;case 449:case 473:this.$=[$$[$0]];break;case 451:case 452:case 453:case 454:case 455:$$[$0].constraintid=$$[$0-1];this.$=$$[$0];break;case 458:this.$={type:"CHECK",expression:$$[$0-1]};break;case 459:this.$={type:"PRIMARY KEY",columns:$$[$0-1],clustered:($$[$0-3]+"").toUpperCase()};break;case 460:this.$={type:"FOREIGN KEY",columns:$$[$0-5],fktable:$$[$0-2],fkcolumns:$$[$0-1]};break;case 461:case 491:case 522:case 558:case 576:case 579:case 598:this.$=$$[$0-1];break;case 466:this.$={type:"UNIQUE",columns:$$[$0-1],clustered:($$[$0-3]+"").toUpperCase()};break;case 475:this.$=new yy.ColumnDef({columnid:$$[$0-2]});yy.extend(this.$,$$[$0-1]);yy.extend(this.$,$$[$0]);break;case 476:this.$=new yy.ColumnDef({columnid:$$[$0-1]});yy.extend(this.$,$$[$0]);break;case 477:this.$=new yy.ColumnDef({columnid:$$[$0],dbtypeid:""});break;case 478:this.$={dbtypeid:$$[$0-5],dbsize:$$[$0-3],dbprecision:+$$[$0-1]};break;case 479:this.$={dbtypeid:$$[$0-6]+($$[$0-5]?" "+$$[$0-5]:""),dbsize:$$[$0-3],dbprecision:+$$[$0-1]};break;case 480:this.$={dbtypeid:$$[$0-3],dbsize:$$[$0-1]};break;case 481:this.$={dbtypeid:$$[$0-4]+($$[$0-3]?" "+$$[$0-3]:""),dbsize:$$[$0-1]};break;case 482:this.$={dbtypeid:$$[$0]};break;case 483:this.$={dbtypeid:$$[$0-1]+($$[$0]?" "+$$[$0]:"")};break;case 484:this.$={dbtypeid:"ENUM",enumvalues:$$[$0-1]};break;case 485:case 678:this.$=+$$[$0];break;case 487:this.$=undefined;break;case 489:yy.extend($$[$0-1],$$[$0]);this.$=$$[$0-1];break;case 492:this.$={primarykey:true};break;case 493:case 494:this.$={foreignkey:{table:$$[$0-1],columnid:$$[$0]}};break;case 495:this.$={identity:{value:$$[$0-3],step:$$[$0-1]}};break;case 496:this.$={identity:{value:1,step:1}};break;case 497:this.$={"default":$$[$0]};break;case 498:this.$={"default":$$[$0-1]};break;case 499:this.$={"null":true};break;case 500:this.$={notnull:true};break;case 501:this.$={check:$$[$0]};break;case 502:this.$={unique:true};break;case 503:this.$=new yy.DropTable({table:$$[$0],type:$$[$0-2]});yy.extend(this.$,$$[$0-1]);break;case 505:this.$={ifexists:true};break;case 506:this.$=new yy.AlterTable({table:$$[$0-3],renameto:$$[$0]});break;case 507:this.$=new yy.AlterTable({table:$$[$0-3],addcolumn:$$[$0]});break;case 508:this.$=new yy.AlterTable({table:$$[$0-3],modifycolumn:$$[$0]});break;case 509:this.$=new yy.AlterTable({table:$$[$0-5],renamecolumn:$$[$0-2],to:$$[$0]});break;case 510:this.$=new yy.AlterTable({table:$$[$0-3],dropcolumn:$$[$0]});break;case 511:this.$=new yy.AlterTable({table:$$[$0-2],renameto:$$[$0]});break;case 512:this.$=new yy.AttachDatabase({databaseid:$$[$0],engineid:$$[$0-2].toUpperCase()});break;case 513:this.$=new yy.AttachDatabase({databaseid:$$[$0-3],engineid:$$[$0-5].toUpperCase(),args:$$[$0-1]});break;case 514:this.$=new yy.AttachDatabase({databaseid:$$[$0-2],engineid:$$[$0-4].toUpperCase(),as:$$[$0]});break;case 515:this.$=new yy.AttachDatabase({databaseid:$$[$0-5],engineid:$$[$0-7].toUpperCase(),as:$$[$0],args:$$[$0-3]});break;case 516:this.$=new yy.DetachDatabase({databaseid:$$[$0]});break;case 517:this.$=new yy.CreateDatabase({databaseid:$$[$0]});yy.extend(this.$,$$[$0]);break;case 518:this.$=new yy.CreateDatabase({engineid:$$[$0-4].toUpperCase(),databaseid:$$[$0-1],as:$$[$0]});yy.extend(this.$,$$[$0-2]);break;case 519:this.$=new yy.CreateDatabase({engineid:$$[$0-7].toUpperCase(),databaseid:$$[$0-4],args:$$[$0-2],as:$$[$0]});yy.extend(this.$,$$[$0-5]);break;case 520:this.$=new yy.CreateDatabase({engineid:$$[$0-4].toUpperCase(),as:$$[$0],args:[$$[$0-1]]});yy.extend(this.$,$$[$0-2]);break;case 521:this.$=undefined;break;case 523:case 524:this.$=new yy.UseDatabase({databaseid:$$[$0]});break;case 525:this.$=new yy.DropDatabase({databaseid:$$[$0]});yy.extend(this.$,$$[$0-1]);break;case 526:case 527:this.$=new yy.DropDatabase({databaseid:$$[$0],engineid:$$[$0-3].toUpperCase()});yy.extend(this.$,$$[$0-1]);break;case 528:this.$=new yy.CreateIndex({indexid:$$[$0-5],table:$$[$0-3],columns:$$[$0-1]});break;case 529:this.$=new yy.CreateIndex({indexid:$$[$0-5],table:$$[$0-3],columns:$$[$0-1],unique:true});break;case 530:this.$=new yy.DropIndex({indexid:$$[$0]});break;case 531:this.$=new yy.ShowDatabases;break;case 532:this.$=new yy.ShowDatabases({like:$$[$0]});break;case 533:this.$=new yy.ShowDatabases({engineid:$$[$0-1].toUpperCase()});break;case 534:this.$=new yy.ShowDatabases({engineid:$$[$0-3].toUpperCase(),like:$$[$0]});break;case 535:this.$=new yy.ShowTables;break;case 536:this.$=new yy.ShowTables({like:$$[$0]});break;case 537:this.$=new yy.ShowTables({databaseid:$$[$0]});break;case 538:this.$=new yy.ShowTables({like:$$[$0],databaseid:$$[$0-2]});break;case 539:this.$=new yy.ShowColumns({table:$$[$0]});break;case 540:this.$=new yy.ShowColumns({table:$$[$0-2],databaseid:$$[$0]});break;case 541:this.$=new yy.ShowIndex({table:$$[$0]});break;case 542:this.$=new yy.ShowIndex({table:$$[$0-2],databaseid:$$[$0]});break;case 543:this.$=new yy.ShowCreateTable({table:$$[$0]});break;case 544:this.$=new yy.ShowCreateTable({table:$$[$0-2],databaseid:$$[$0]});break;case 545:this.$=new yy.CreateTable({table:$$[$0-6],view:true,select:$$[$0-1],viewcolumns:$$[$0-4]});yy.extend(this.$,$$[$0-9]);yy.extend(this.$,$$[$0-7]);break;case 546:this.$=new yy.CreateTable({table:$$[$0-3],view:true,select:$$[$0-1]});yy.extend(this.$,$$[$0-6]);yy.extend(this.$,$$[$0-4]);break;case 550:this.$=new yy.DropTable({table:$$[$0],view:true});yy.extend(this.$,$$[$0-1]);break;case 551:this.$=new yy.Help({subject:$$[$0].value.toUpperCase()});break;case 552:this.$=new yy.Help;break;case 553:this.$=new yy.ExpressionStatement({expression:$$[$0]});break;case 554:this.$=new yy.Source({url:$$[$0].value});break;case 555:this.$=new yy.Assert({value:$$[$0]});break;case 556:this.$=new yy.Assert({value:$$[$0].value});break;case 557:this.$=new yy.Assert({value:$$[$0],message:$$[$0-2]});break;case 559:case 570:case 572:this.$=$$[$0].value;break;case 560:case 568:this.$=+$$[$0].value;break;case 561:this.$=!!$$[$0].value;break;case 569:this.$=""+$$[$0].value;break;case 575:this.$=$$[$0-1];break;case 577:case 580:this.$=$$[$0-2];break;case 578:this.$={};break;case 581:this.$=[];break;case 582:yy.extend($$[$0-2],$$[$0]);this.$=$$[$0-2];break;case 584:this.$={};this.$[$$[$0-2].substr(1,$$[$0-2].length-2)]=$$[$0];break;case 585:case 586:this.$={};this.$[$$[$0-2]]=$$[$0];break;case 589:this.$=new yy.SetVariable({variable:$$[$0-1].toLowerCase(),value:$$[$0]});break;case 590:this.$=new yy.SetVariable({variable:$$[$0-2],expression:$$[$0],method:$$[$0-3]});break;case 591:this.$=new yy.SetVariable({variable:$$[$0-3],props:$$[$0-2],expression:$$[$0],method:$$[$0-4]});break;case 592:this.$="@";break;case 593:this.$="$";break;case 599:this.$=true;break;case 600:this.$=false;break;case 601:this.$=new yy.CommitTransaction;break;case 602:this.$=new yy.RollbackTransaction;break;case 603:this.$=new yy.BeginTransaction;break;case 604:this.$=new yy.If({expression:$$[$0-2],thenstat:$$[$0-1],elsestat:$$[$0]});if($$[$0-1].exists)this.$.exists=$$[$0-1].exists;if($$[$0-1].queries)this.$.queries=$$[$0-1].queries;break;case 605:this.$=new yy.If({expression:$$[$0-1],thenstat:$$[$0]});if($$[$0].exists)this.$.exists=$$[$0].exists;if($$[$0].queries)this.$.queries=$$[$0].queries;break;case 606:this.$=$$[$0];break;case 607:this.$=new yy.While({expression:$$[$0-1],loopstat:$$[$0]});if($$[$0].exists)this.$.exists=$$[$0].exists;if($$[$0].queries)this.$.queries=$$[$0].queries;break;case 608:this.$=new yy.Continue;break;case 609:this.$=new yy.Break;break;case 610:this.$=new yy.BeginEnd({statements:$$[$0-1]});break;case 611:this.$=new yy.Print({exprs:$$[$0]});break;case 612:this.$=new yy.Print({select:$$[$0]});break;case 613:this.$=new yy.Require({paths:$$[$0]});break;case 614:this.$=new yy.Require({plugins:$$[$0]});break;case 615:case 616:this.$=$$[$0].toUpperCase();break;case 617:this.$=new yy.Echo({expr:$$[$0]});break;case 622:this.$=new yy.Declare({declares:$$[$0]});break;case 625:this.$={variable:$$[$0-1]};yy.extend(this.$,$$[$0]);break;case 626:this.$={variable:$$[$0-2]};yy.extend(this.$,$$[$0]);break;case 627:this.$={variable:$$[$0-3],expression:$$[$0]};yy.extend(this.$,$$[$0-2]);break;case 628:this.$={variable:$$[$0-4],expression:$$[$0]};yy.extend(this.$,$$[$0-2]);break;case 629:this.$=new yy.TruncateTable({table:$$[$0]});break;case 630:this.$=new yy.Merge;yy.extend(this.$,$$[$0-4]);yy.extend(this.$,$$[$0-3]);yy.extend(this.$,$$[$0-2]);yy.extend(this.$,{matches:$$[$0-1]});yy.extend(this.$,$$[$0]);break;case 631:case 632:this.$={into:$$[$0]};break;case 634:this.$={on:$$[$0]};break;case 639:this.$={matched:true,action:$$[$0]};break;case 640:this.$={matched:true,expr:$$[$0-2],action:$$[$0]};break;case 641:this.$={"delete":true};break;case 642:this.$={update:$$[$0]};break;case 643:case 644:this.$={matched:false,bytarget:true,action:$$[$0]};break;case 645:case 646:this.$={matched:false,bytarget:true,expr:$$[$0-2],action:$$[$0]};break;case 647:this.$={matched:false,bysource:true,action:$$[$0]};break;case 648:this.$={matched:false,bysource:true,expr:$$[$0-2],action:$$[$0]};break;case 649:this.$={insert:true,values:$$[$0]};break;case 650:this.$={insert:true,values:$$[$0],columns:$$[$0-3]};break;case 651:this.$={insert:true,defaultvalues:true};break;case 652:this.$={insert:true,defaultvalues:true,columns:$$[$0-3]};break;case 654:this.$={output:{columns:$$[$0]}};break;case 655:this.$={output:{columns:$$[$0-3],intovar:$$[$0],method:$$[$0-1]}};break;case 656:this.$={output:{columns:$$[$0-2],intotable:$$[$0]}};break;case 657:this.$={output:{columns:$$[$0-5],intotable:$$[$0-3],intocolumns:$$[$0-1]}};break;case 658:this.$=new yy.CreateVertex({"class":$$[$0-3],sharp:$$[$0-2],name:$$[$0-1]});yy.extend(this.$,$$[$0]);break;case 661:this.$={sets:$$[$0]};break;case 662:this.$={content:$$[$0]};break;case 663:this.$={select:$$[$0]};break;case 664:this.$=new yy.CreateEdge({from:$$[$0-3],to:$$[$0-1],name:$$[$0-5]});yy.extend(this.$,$$[$0]);break;case 665:this.$=new yy.CreateGraph({graph:$$[$0]});break;case 666:this.$=new yy.CreateGraph({from:$$[$0]});break;case 669:this.$=$$[$0-2];if($$[$0-1])this.$.json=new yy.Json({value:$$[$0-1]});if($$[$0])this.$.as=$$[$0];break;case 670:this.$={source:$$[$0-6],target:$$[$0]};if($$[$0-3])this.$.json=new yy.Json({value:$$[$0-3]});if($$[$0-2])this.$.as=$$[$0-2];yy.extend(this.$,$$[$0-4]);break;case 672:this.$={vars:$$[$0],method:$$[$0-1]};break;case 675:var s3=$$[$0-1];this.$={prop:$$[$0-3],sharp:$$[$0-2],name:typeof s3=="undefined"?undefined:s3.substr(1,s3.length-2),"class":$$[$0]};break;case 681:this.$=new yy.AddRule({left:$$[$0-2],right:$$[$0]});break;case 682:this.$=new yy.AddRule({right:$$[$0]});break;case 685:this.$=new yy.Term({termid:$$[$0]});break;case 686:this.$=new yy.Term({termid:$$[$0-3],args:$$[$0-1]});break;case 692:case 706:case 708:case 710:case 714:case 716:case 718:case 720:case 722:case 724:this.$=[];break;case 693:case 701:case 703:case 707:case 709:case 711:case 715:case 717:case 719:case 721:case 723:case 725:$$[$0-1].push($$[$0]);break;case 700:case 702:this.$=[$$[$0]];break}},table:[o([8,450,451],$V0,{6:1,7:2,10:3,11:4,15:5,16:7,17:8,18:9,19:10,20:11,21:12,22:13,23:14,24:15,25:16,26:17,27:18,28:19,29:20,30:21,31:22,32:23,33:24,34:25,35:26,36:27,37:28,38:29,39:30,40:31,41:32,42:33,43:34,44:35,45:36,46:37,48:39,49:40,50:41,51:42,52:43,53:44,54:45,55:46,56:47,57:48,58:49,59:50,60:51,61:52,62:53,63:54,64:55,72:67,446:88,158:92,3:93,4:$V1,5:$V2,12:$V3,47:$V4,65:$V5,81:$V6,99:$V7,120:$V8,130:$V9,163:$Va,233:$Vb,287:$Vc,290:$Vd,291:$Ve,298:$Vf,344:$Vg,347:$Vh,348:$Vi,351:$Vj,353:$Vk,355:$Vl,356:$Vm,364:$Vn,365:$Vo,366:$Vp,383:$Vq,385:$Vr,386:$Vs,388:$Vt,389:$Vu,390:$Vv,391:$Vw,392:$Vx,396:$Vy,397:$Vz,400:$VA,401:$VB,447:$VC,449:$VD}),{1:[3]},{8:[1,97],9:98,450:$VE,451:$VF},o($VG,[2,5]),o($VG,[2,6]),o($VH,[2,9]),o($VG,$V0,{15:5,16:7,17:8,18:9,19:10,20:11,21:12,22:13,23:14,24:15,25:16,26:17,27:18,28:19,29:20,30:21,31:22,32:23,33:24,34:25,35:26,36:27,37:28,38:29,39:30,40:31,41:32,42:33,43:34,44:35,45:36,46:37,48:39,49:40,50:41,51:42,52:43,53:44,54:45,55:46,56:47,57:48,58:49,59:50,60:51,61:52,62:53,63:54,64:55,72:67,446:88,158:92,3:93,10:101,4:$V1,5:$V2,13:[1,102],47:$V4,65:$V5,81:$V6,99:$V7,120:$V8,130:$V9,163:$Va,233:$Vb,287:$Vc,290:$Vd,291:$Ve,298:$Vf,344:$Vg,347:$Vh,348:$Vi,351:$Vj,353:$Vk,355:$Vl,356:$Vm,364:$Vn,365:$Vo,366:$Vp,383:$Vq,385:$Vr,386:$Vs,388:$Vt,389:$Vu,390:$Vv,391:$Vw,392:$Vx,396:$Vy,397:$Vz,400:$VA,401:$VB,447:$VC,449:$VD}),o($VH,[2,11]),o($VH,[2,12]),o($VH,[2,13]),o($VH,[2,14]),o($VH,[2,15]),o($VH,[2,16]),o($VH,[2,17]),o($VH,[2,18]),o($VH,[2,19]),o($VH,[2,20]),o($VH,[2,21]),o($VH,[2,22]),o($VH,[2,23]),o($VH,[2,24]),o($VH,[2,25]),o($VH,[2,26]),o($VH,[2,27]),o($VH,[2,28]),o($VH,[2,29]),o($VH,[2,30]),o($VH,[2,31]),o($VH,[2,32]),o($VH,[2,33]),o($VH,[2,34]),o($VH,[2,35]),o($VH,[2,36]),o($VH,[2,37]),o($VH,[2,38]),o($VH,[2,39]),o($VH,[2,40]),o($VH,[2,41]),o($VH,[2,42]),o($VH,[2,43]),o($VH,[2,44]),o($VH,[2,45]),o($VH,[2,46]),o($VH,[2,47]),o($VH,[2,48]),o($VH,[2,49]),o($VH,[2,50]),o($VH,[2,51]),o($VH,[2,52]),o($VH,[2,53]),o($VH,[2,54]),o($VH,[2,55]),o($VH,[2,56]),o($VH,[2,57]),o($VH,[2,58]),o($VH,[2,59]),{304:[1,103]},{3:104,4:$V1,5:$V2},o($VI,[2,442],{3:106,299:110,4:$V1,5:$V2,109:$VJ,110:$VK,161:[1,108],167:[1,107],308:[1,113],352:[1,105],421:[1,109]}),{119:$VL,398:114,399:115},{157:[1,117]},{352:[1,118]},{3:120,4:$V1,5:$V2,105:[1,125],167:[1,121],304:[1,124],345:122,352:[1,119],357:[1,123]},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:126,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($Vi1,[2,413],{292:181,172:[1,182]}),{3:193,4:$V1,5:$V2,70:$Vj1,107:$Vk1,116:$VQ,118:187,119:$VR,126:$VS,155:$VW,172:[1,185],173:188,174:190,175:189,176:191,183:184,186:192,260:$Vd1,367:168,368:$Vg1,372:$Vh1,402:183},{304:[1,195]},o($Vl1,[2,690],{73:196,84:197,85:[1,198]}),o($Vm1,[2,692],{82:199}),{3:203,4:$V1,5:$V2,164:[1,201],167:[1,204],298:[1,200],304:[1,205],352:[1,202]},{304:[1,206]},{3:209,4:$V1,5:$V2,66:207,68:208},o([264,450,451],$V0,{10:3,11:4,15:5,16:7,17:8,18:9,19:10,20:11,21:12,22:13,23:14,24:15,25:16,26:17,27:18,28:19,29:20,30:21,31:22,32:23,33:24,34:25,35:26,36:27,37:28,38:29,39:30,40:31,41:32,42:33,43:34,44:35,45:36,46:37,48:39,49:40,50:41,51:42,52:43,53:44,54:45,55:46,56:47,57:48,58:49,59:50,60:51,61:52,62:53,63:54,64:55,72:67,446:88,158:92,3:93,7:211,4:$V1,5:$V2,12:$V3,47:$V4,65:$V5,81:$V6,99:$V7,120:$V8,130:$V9,163:$Va,233:$Vb,287:$Vc,290:$Vd,291:$Ve,298:$Vf,344:$Vg,347:$Vh,348:$Vi,351:$Vj,353:$Vk,355:$Vl,356:$Vm,364:$Vn,365:$Vo,366:$Vp,383:$Vq,384:[1,210],385:$Vr,386:$Vs,388:$Vt,389:$Vu,390:$Vv,391:$Vw,392:$Vx,396:$Vy,397:$Vz,400:$VA,401:$VB,447:$VC,449:$VD}),{384:[1,212]},{384:[1,213]},{3:215,4:$V1,5:$V2,352:[1,214]},{3:217,4:$V1,5:$V2,173:216},o($VH,[2,552],{91:218,107:$VO,256:$Va1}),o($Vn1,[2,284]),{91:219,107:$VO,256:$Va1},{3:231,4:$V1,5:$V2,91:225,106:$VN,107:[1,222],116:$VQ,118:220,119:$Vo1,126:$VS,155:$VW,170:224,174:229,175:228,225:226,226:227,232:$Vp1,238:221,254:$V81,255:$V91,256:$Va1,257:$Vb1,260:$Vd1,367:168,368:$Vg1,372:$Vh1},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:232,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($VH,[2,608]),o($VH,[2,609]),{3:147,4:$V1,5:$V2,36:234,51:144,70:$VM,72:67,81:$V6,89:130,91:134,100:235,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,125:233,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,158:92,163:$Va,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:241,4:$V1,5:$V2,91:238,107:$VO,256:$Va1,393:236,394:237,395:239,396:$Vq1},{3:242,4:$V1,5:$V2,116:$Vr1,119:$Vs1,379:243},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:246,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{447:[1,247]},{3:93,4:$V1,5:$V2,446:249,448:248},{3:231,4:$V1,5:$V2,174:250},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:251,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($Vt1,$Vu1,{160:255,138:[1,254],159:[1,252],161:[1,253],169:$Vv1}),o($Vw1,[2,685],{70:[1,257]}),o($Vx1,[2,130],{123:[1,258],124:[1,259],164:[1,260],165:[1,261],166:[1,262],167:[1,263],168:[1,264]}),o($Vy1,[2,1]),o($Vy1,[2,2]),{1:[2,3]},o($VG,$V0,{15:5,16:7,17:8,18:9,19:10,20:11,21:12,22:13,23:14,24:15,25:16,26:17,27:18,28:19,29:20,30:21,31:22,32:23,33:24,34:25,35:26,36:27,37:28,38:29,39:30,40:31,41:32,42:33,43:34,44:35,45:36,46:37,48:39,49:40,50:41,51:42,52:43,53:44,54:45,55:46,56:47,57:48,58:49,59:50,60:51,61:52,62:53,63:54,64:55,72:67,446:88,158:92,3:93,10:265,4:$V1,5:$V2,47:$V4,65:$V5,81:$V6,99:$V7,120:$V8,130:$V9,163:$Va,233:$Vb,287:$Vc,290:$Vd,291:$Ve,298:$Vf,344:$Vg,347:$Vh,348:$Vi,351:$Vj,353:$Vk,355:$Vl,356:$Vm,364:$Vn,365:$Vo,366:$Vp,383:$Vq,385:$Vr,386:$Vs,388:$Vt,389:$Vu,390:$Vv,391:$Vw,392:$Vx,396:$Vy,397:$Vz,400:$VA,401:$VB,447:$VC,449:$VD}),o($Vz1,[2,688]),o($Vz1,[2,689]),o($VG,[2,7]),{14:[1,266]},{3:217,4:$V1,5:$V2,173:267},{352:[1,268]},o($Vi1,$VA1,{301:269,130:$VB1}),{352:[1,271]},{3:272,4:$V1,5:$V2},{167:[1,273]},o([8,67,69,107,112,114,126,264,268,368,372,450,451],$VC1,{422:274,423:276,424:277,427:278,3:279,434:280,431:281,379:282,4:$V1,5:$V2,116:$Vr1,119:$Vs1,157:[1,275]}),{105:[1,286],300:283,304:[1,285],357:[1,284]},{91:288,107:$VO,157:[2,770],256:$Va1,420:287},o($VD1,[2,764],{414:289,3:290,4:$V1,5:$V2}),o($VI,[2,443]),o($VH,[2,622],{67:[1,291]}),o($VE1,[2,623]),{3:292,4:$V1,5:$V2},{3:217,4:$V1,5:$V2,173:293},{3:294,4:$V1,5:$V2},o($Vi1,$VF1,{346:295,130:$VG1}),{352:[1,297]},{3:298,4:$V1,5:$V2},o($Vi1,$VF1,{346:299,130:$VG1}),o($Vi1,$VF1,{346:300,130:$VG1}),o($VH1,[2,758]),o($VH1,[2,759]),o($VH,$V0,{15:5,16:7,17:8,18:9,19:10,20:11,21:12,22:13,23:14,24:15,25:16,26:17,27:18,28:19,29:20,30:21,31:22,32:23,33:24,34:25,35:26,36:27,37:28,38:29,39:30,40:31,41:32,42:33,43:34,44:35,45:36,46:37,48:39,49:40,50:41,51:42,52:43,53:44,54:45,55:46,56:47,57:48,58:49,59:50,60:51,61:52,62:53,63:54,64:55,72:67,446:88,158:92,3:93,10:301,278:322,4:$V1,5:$V2,47:$V4,65:$V5,81:$V6,90:$VI1,97:$VJ1,98:$VK1,99:$VL1,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,120:$V8,128:$VR1,130:$V9,144:$VS1,145:$VT1,153:$VU1,154:$VV1,163:$Va,233:$Vb,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72,287:$Vc,290:$Vd,291:$Ve,298:$Vf,344:$Vg,347:$Vh,348:$Vi,351:$Vj,353:$Vk,355:$Vl,356:$Vm,364:$Vn,365:$Vo,366:$Vp,383:$Vq,385:$Vr,386:$Vs,388:$Vt,389:$Vu,390:$Vv,391:$Vw,392:$Vx,396:$Vy,397:$Vz,400:$VA,401:$VB,447:$VC,449:$VD}),o($Vn1,[2,263]),o($Vn1,[2,264]),o($Vn1,[2,265]),o($Vn1,[2,266]),o($Vn1,[2,267]),o($Vn1,[2,268]),o($Vn1,[2,269]),o($Vn1,[2,270]),o($Vn1,[2,271]),o($Vn1,[2,272]),o($Vn1,[2,273]),o($Vn1,[2,274]),o($Vn1,[2,275]),o($Vn1,[2,276]),o($Vn1,[2,277]),o($Vn1,[2,278]),{3:147,4:$V1,5:$V2,23:336,24:335,33:332,36:331,51:144,70:$VM,72:67,81:$V6,89:130,91:134,100:334,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,158:92,163:$Va,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,231:333,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,291:$Ve,298:[1,337],367:168,368:$Vg1,372:$Vh1},o($Vn1,[2,282]),o($Vn1,[2,283]),{70:[1,338]},o([4,5,8,47,65,67,69,71,81,85,90,93,97,98,99,104,105,106,107,108,109,110,111,112,113,114,115,116,119,120,122,123,124,126,128,130,136,138,140,142,143,144,145,146,147,149,153,154,155,157,159,161,163,172,180,182,194,195,196,197,198,199,200,201,205,212,215,216,218,233,244,245,246,247,248,249,250,251,252,256,264,266,267,268,269,270,271,272,273,274,275,276,277,280,282,283,284,285,287,290,291,298,344,347,348,351,353,355,356,364,365,366,368,372,383,385,386,388,389,390,391,392,396,397,400,401,413,419,447,449,450,451],$V82,{70:$V92,117:[1,340]}),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:341,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:342,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:343,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:344,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($Vn1,[2,258]),o([4,5,8,47,65,67,69,70,71,81,85,90,93,97,98,99,104,105,106,107,108,109,110,111,112,113,114,115,116,117,119,120,122,123,124,126,128,130,136,138,140,142,143,144,145,146,147,149,153,154,155,157,159,161,163,172,180,182,194,195,196,197,198,199,200,201,202,203,205,212,215,216,218,220,232,233,234,235,237,244,245,246,247,248,249,250,251,252,254,255,256,257,258,260,261,264,266,267,268,269,270,271,272,273,274,275,276,277,280,282,283,284,285,287,290,291,294,298,307,319,320,324,325,344,347,348,351,353,355,356,364,365,366,368,372,374,376,383,385,386,388,389,390,391,392,396,397,400,401,413,419,447,449,450,451,452],[2,320]),o($Va2,[2,321]),o($Va2,[2,322]),o($Va2,$Vb2),o($Va2,[2,324]),o([4,5,8,47,65,67,69,70,71,81,85,90,93,97,98,99,104,105,106,107,108,109,110,111,112,113,114,115,116,117,119,120,122,123,124,126,128,130,136,138,140,142,143,144,145,146,147,149,153,154,155,157,159,161,163,172,180,182,194,195,196,197,198,199,200,201,205,212,215,216,218,233,244,245,246,247,248,249,250,251,252,256,257,264,266,267,268,269,270,271,272,273,274,275,276,277,280,282,283,284,285,287,290,291,294,298,307,319,320,324,325,344,347,348,351,353,355,356,364,365,366,368,372,374,376,383,385,386,388,389,390,391,392,396,397,400,401,413,419,447,449,450,451],[2,325]),{3:346,4:$V1,5:$V2,106:[1,347],259:345},{3:348,4:$V1,5:$V2},o($Va2,[2,330]),o($Va2,[2,331]),{3:349,4:$V1,5:$V2,70:$Vc2,91:351,106:$VN,107:$VO,116:$VQ,126:$VS,155:$VW,170:352,175:354,225:353,254:$V81,255:$V91,256:$Va1,260:$Vd1,367:355,372:$Vh1},{70:[1,356]},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:357,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,262:358,265:359,266:$Vd2,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{70:[1,361]},{70:[1,362]},o($Ve2,[2,563]),{3:377,4:$V1,5:$V2,70:$Vf2,89:372,91:370,106:$VN,107:$VO,116:$VQ,118:367,119:$Vo1,126:$VS,155:$VW,170:369,174:375,175:374,225:371,226:373,254:$V81,255:$V91,256:$Va1,257:$Vb1,260:$Vd1,367:168,368:$Vg1,369:363,370:366,371:368,372:$Vh1,375:364,376:[1,365]},{3:378,4:$V1,5:$V2,174:379},{70:[2,307]},{70:[2,308]},{70:[2,309]},{70:[2,310]},{70:[2,311]},{70:[2,312]},{70:[2,313]},{70:[2,314]},{70:[2,315]},{3:385,4:$V1,5:$V2,106:$Vg2,107:$Vh2,373:380,374:[1,381],377:382},{3:217,4:$V1,5:$V2,173:386},o($Vi1,[2,414]),{203:[1,388],403:387},{203:[2,631]},{3:193,4:$V1,5:$V2,70:$Vj1,107:$Vk1,116:$VQ,118:187,119:$VR,126:$VS,155:$VW,173:188,174:190,175:189,176:191,183:389,186:192,260:$Vd1,367:168,368:$Vg1,372:$Vh1},{36:390,72:67,81:$V6,158:92,163:$Va},o($Vi2,[2,730],{184:391,69:[1,392]}),o($Vj2,[2,163],{3:393,4:$V1,5:$V2,69:[1,394]}),o($Vj2,[2,166],{3:395,4:$V1,5:$V2,69:[1,396]}),o($Vj2,[2,167],{3:397,4:$V1,5:$V2,69:[1,398]}),o($Vj2,[2,170],{3:399,4:$V1,5:$V2,69:[1,400]}),o($Vj2,[2,173],{3:401,4:$V1,5:$V2,69:[1,402]}),o([4,5,8,65,67,69,71,93,104,136,142,143,157,180,182,194,195,196,197,198,199,200,201,202,203,205,218,264,268,450,451],$Vk2,{70:$V92,117:$Vl2}),o([4,5,8,65,67,69,71,93,104,136,142,143,180,182,194,195,196,197,198,199,200,201,202,203,205,218,264,268,450,451],[2,176]),{3:217,4:$V1,5:$V2,173:404},o($Vm2,$Vn2,{74:405,172:$Vo2}),o($Vl1,[2,691]),o($Vp2,[2,696],{86:407,164:[1,408]}),o([8,71,157,264,268,450,451],$Vn2,{367:168,74:409,92:410,3:411,118:433,132:443,134:444,4:$V1,5:$V2,65:$Vq2,69:$Vr2,70:$Vs2,90:$Vt2,93:$Vu2,97:$Vv2,98:$Vw2,99:$Vx2,104:$Vy2,105:$Vz2,106:$VA2,107:$VB2,108:$VC2,109:$VD2,110:$VE2,111:$VF2,112:$VG2,113:$VH2,114:$VI2,115:$VJ2,116:$VK2,117:$VL2,119:$VM2,120:$VN2,122:$VO2,123:$VP2,124:$VQ2,126:$VR2,128:$VS2,130:$VT2,136:$VU2,138:$VV2,140:$VW2,142:$VX2,143:$VY2,144:$VZ2,145:$V_2,146:$V$2,147:$V03,149:$V13,159:$V23,161:$V33,172:$Vo2,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,368:$Vg1,372:$Vh1}),{304:[1,457]},{157:[1,458]},o($VH,[2,531],{90:[1,459]}),{352:[1,460]},{157:[1,461]},o($VH,[2,535],{90:[1,462],157:[1,463]}),{3:217,4:$V1,5:$V2,173:464},{36:465,67:[1,466],72:67,81:$V6,158:92,163:$Va},o($V43,[2,62]),{69:[1,467]},o($VH,[2,603]),{9:98,264:[1,468],450:$VE,451:$VF},o($VH,[2,601]),o($VH,[2,602]),{3:469,4:$V1,5:$V2},o($VH,[2,524]),{120:[1,470]},o([8,67,69,70,71,81,104,120,122,123,128,157,161,163,202,257,264,268,294,307,319,320,324,325,344,348,349,350,450,451],$Vk2,{117:$Vl2}),o($VH,[2,551]),o($VH,[2,554]),o($VH,[2,555]),o($VH,[2,556]),o($VH,$Vb2,{67:[1,471]}),{70:$Vc2,91:351,106:$VN,107:$VO,116:$VQ,126:$VS,155:$VW,170:352,175:354,225:353,254:$V81,255:$V91,256:$Va1,260:$Vd1,367:355,372:$Vh1},o($V53,[2,291]),o($V53,[2,292]),o($V53,[2,293]),o($V53,[2,294]),o($V53,[2,295]),o($V53,[2,296]),o($V53,[2,297]),{70:$V92},o($VH,$V0,{15:5,16:7,17:8,18:9,19:10,20:11,21:12,22:13,23:14,24:15,25:16,26:17,27:18,28:19,29:20,30:21,31:22,32:23,33:24,34:25,35:26,36:27,37:28,38:29,39:30,40:31,41:32,42:33,43:34,44:35,45:36,46:37,48:39,49:40,50:41,51:42,52:43,53:44,54:45,55:46,56:47,57:48,58:49,59:50,60:51,61:52,62:53,63:54,64:55,72:67,446:88,158:92,3:93,278:322,10:472,4:$V1,5:$V2,47:$V4,65:$V5,81:$V6,90:$VI1,97:$VJ1,98:$VK1,99:$VL1,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,120:$V8,128:$VR1,130:$V9,144:$VS1,145:$VT1,153:$VU1,154:$VV1,163:$Va,233:$Vb,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72,287:$Vc,290:$Vd,291:$Ve,298:$Vf,344:$Vg,347:$Vh,348:$Vi,351:$Vj,353:$Vk,355:$Vl,356:$Vm,364:$Vn,365:$Vo,366:$Vp,383:$Vq,385:$Vr,386:$Vs,388:$Vt,389:$Vu,390:$Vv,391:$Vw,392:$Vx,396:$Vy,397:$Vz,400:$VA,401:$VB,447:$VC,449:$VD}),o($VH,[2,611],{67:$V63}),o($VH,[2,612]),o($V73,[2,318],{278:322,90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72}),o($VH,[2,613],{67:[1,475]}),o($VH,[2,614],{67:[1,476]}),o($VE1,[2,619]),o($VE1,[2,621]),o($VE1,[2,615]),o($VE1,[2,616]),{202:[1,478],378:477,382:[1,479]},{3:480,4:$V1,5:$V2},o($Vi1,[2,592]),o($Vi1,[2,593]),o($VH,[2,553],{278:322,90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72}),{3:93,4:$V1,5:$V2,446:249,448:481},o($VH,[2,682],{67:$V93}),o($V73,[2,684]),o($VH,[2,687]),o($VH,[2,617],{278:322,90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72}),o($Va3,$Vu1,{160:483,169:$Vv1}),o($Va3,$Vu1,{160:484,169:$Vv1}),o($Va3,$Vu1,{160:485,169:$Vv1}),o($Vb3,[2,726],{223:127,174:128,224:129,89:130,222:131,170:132,225:133,91:134,226:135,175:136,176:137,227:138,228:139,229:140,118:141,230:142,51:144,132:146,3:147,367:168,162:486,148:487,221:488,100:489,4:$V1,5:$V2,70:$VM,106:$VN,107:$VO,112:$VP,116:$VQ,119:$VR,126:$VS,128:$VT,153:$VU,154:$VV,155:$VW,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,368:$Vg1,372:$Vh1}),{70:[1,491],106:$VN,170:490},{3:93,4:$V1,5:$V2,446:249,448:492},o($Vx1,[2,131]),o($Vx1,[2,132]),o($Vx1,[2,133]),o($Vx1,[2,134]),o($Vx1,[2,135]),o($Vx1,[2,136]),o($Vx1,[2,137]),o($VG,[2,4]),o($VG,$V0,{15:5,16:7,17:8,18:9,19:10,20:11,21:12,22:13,23:14,24:15,25:16,26:17,27:18,28:19,29:20,30:21,31:22,32:23,33:24,34:25,35:26,36:27,37:28,38:29,39:30,40:31,41:32,42:33,43:34,44:35,45:36,46:37,48:39,49:40,50:41,51:42,52:43,53:44,54:45,55:46,56:47,57:48,58:49,59:50,60:51,61:52,62:53,63:54,64:55,72:67,446:88,158:92,3:93,10:493,4:$V1,5:$V2,47:$V4,65:$V5,81:$V6,99:$V7,120:$V8,130:$V9,163:$Va,233:$Vb,287:$Vc,290:$Vd,291:$Ve,298:$Vf,344:$Vg,347:$Vh,348:$Vi,351:$Vj,353:$Vk,355:$Vl,356:$Vm,364:$Vn,365:$Vo,366:$Vp,383:$Vq,385:$Vr,386:$Vs,388:$Vt,389:$Vu,390:$Vv,391:$Vw,392:$Vx,396:$Vy,397:$Vz,400:$VA,401:$VB,447:$VC,449:$VD}),{344:[1,497],348:[1,494],349:[1,495],350:[1,496]},{3:498,4:$V1,5:$V2},{3:499,4:$V1,5:$V2},{128:[1,500]},o($Vc3,$VA1,{301:501,130:$VB1}),{202:[1,502]},{3:503,4:$V1,5:$V2},o($VH,[2,665],{67:$Vd3}),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:505,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($V73,[2,668]),o($Ve3,[2,772],{367:168,425:506,118:507,114:[2,776],119:$Vo1,368:$Vg1,372:$Vh1}),{114:[1,508]},o($Vf3,$Vg3,{70:[1,509]}),o($Vh3,[2,786],{435:510,439:511,112:[1,512]}),{114:[2,777]},{3:513,4:$V1,5:$V2},o($Vi1,$VA1,{301:514,130:$VB1}),o($Vi1,$VA1,{301:515,130:$VB1}),o($VH1,[2,433]),o($VH1,[2,434]),{157:[1,516]},{157:[2,771]},o($Vi3,[2,766],{415:517,418:518,112:[1,519]}),o($VD1,[2,765]),{119:$VL,399:520},{4:$Vj3,69:[1,522],236:521,338:$Vk3},o($VH,[2,407],{104:[1,525]}),o($VH,[2,516]),{3:526,4:$V1,5:$V2},{258:[1,527]},o($Vc3,$VF1,{346:528,130:$VG1}),o($VH,[2,530]),{3:217,4:$V1,5:$V2,173:529},{3:217,4:$V1,5:$V2,173:530},o($VG,[2,605],{387:531,268:[1,532]}),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:533,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:534,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:535,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:536,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:537,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:538,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:539,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:540,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:541,4:$V1,5:$V2,70:[1,543],106:$VN,170:542,174:544},{3:545,4:$V1,5:$V2,70:[1,547],106:$VN,170:546,174:548},o($Vl3,[2,391],{223:127,174:128,224:129,89:130,222:131,170:132,225:133,91:134,226:135,175:136,176:137,227:138,228:139,229:140,118:141,230:142,51:144,132:146,3:147,367:168,100:549,4:$V1,5:$V2,70:$VM,106:$VN,107:$VO,112:$VP,116:$VQ,119:$VR,126:$VS,128:$VT,153:$VU,154:$VV,155:$VW,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,368:$Vg1,372:$Vh1}),o($Vl3,[2,392],{223:127,174:128,224:129,89:130,222:131,170:132,225:133,91:134,226:135,175:136,176:137,227:138,228:139,229:140,118:141,230:142,51:144,132:146,3:147,367:168,100:550,4:$V1,5:$V2,70:$VM,106:$VN,107:$VO,112:$VP,116:$VQ,119:$VR,126:$VS,128:$VT,153:$VU,154:$VV,155:$VW,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,368:$Vg1,372:$Vh1}),o($Vl3,[2,393],{223:127,174:128,224:129,89:130,222:131,170:132,225:133,91:134,226:135,175:136,176:137,227:138,228:139,229:140,118:141,230:142,51:144,132:146,3:147,367:168,100:551,4:$V1,5:$V2,70:$VM,106:$VN,107:$VO,112:$VP,116:$VQ,119:$VR,126:$VS,128:$VT,153:$VU,154:$VV,155:$VW,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,368:$Vg1,372:$Vh1}),o($Vl3,[2,394],{223:127,174:128,224:129,89:130,222:131,170:132,225:133,91:134,226:135,175:136,176:137,227:138,228:139,229:140,118:141,230:142,51:144,132:146,3:147,367:168,100:552,4:$V1,5:$V2,70:$VM,106:$VN,107:$VO,112:$VP,116:$VQ,119:$VR,126:$VS,128:$VT,153:$VU,154:$VV,155:$VW,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,368:$Vg1,372:$Vh1}),o($Vl3,$Vm3,{223:127,174:128,224:129,89:130,222:131,170:132,225:133,91:134,226:135,175:136,176:137,227:138,228:139,229:140,118:141,230:142,51:144,132:146,3:147,367:168,100:553,4:$V1,5:$V2,70:$VM,106:$VN,107:$VO,112:$VP,116:$VQ,119:$VR,126:$VS,128:$VT,153:$VU,154:$VV,155:$VW,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,368:$Vg1,372:$Vh1}),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:554,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:555,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($Vl3,[2,396],{223:127,174:128,224:129,89:130,222:131,170:132,225:133,91:134,226:135,175:136,176:137,227:138,228:139,229:140,118:141,230:142,51:144,132:146,3:147,367:168,100:556,4:$V1,5:$V2,70:$VM,106:$VN,107:$VO,112:$VP,116:$VQ,119:$VR,126:$VS,128:$VT,153:$VU,154:$VV,155:$VW,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,368:$Vg1,372:$Vh1}),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:557,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:558,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{138:[1,560],140:[1,562],279:559,286:[1,561]},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:563,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:564,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:377,4:$V1,5:$V2,70:[1,565],89:568,119:$Vn3,174:569,176:567,281:566},{280:[1,571]},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:572,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:573,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:574,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{4:$Vj3,236:575,338:$Vk3},{71:[1,576]},{71:[1,577]},{71:[1,578]},{71:[1,579],90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,278:322,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72},{71:[2,738]},{71:[2,739]},{109:$VJ,110:$VK},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:235,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,125:580,126:$VS,128:$VT,132:146,138:[1,582],153:$VU,154:$VV,155:$VW,159:[1,581],170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($Va3,[2,742],{253:583,453:585,71:[1,584],138:[1,587],159:[1,586]}),{3:588,4:$V1,5:$V2,123:$Vo3,154:[1,590]},o([4,5,8,47,65,67,69,70,71,81,85,93,99,104,105,106,107,109,110,112,114,115,116,117,119,120,122,123,124,126,128,130,136,138,140,142,143,144,145,146,147,149,155,157,159,161,163,172,180,182,194,195,196,197,198,199,200,201,205,212,215,216,218,233,244,245,246,247,248,249,250,251,252,256,264,266,267,268,271,272,273,274,275,276,277,280,282,283,285,287,290,291,298,344,347,348,351,353,355,356,364,365,366,368,372,383,385,386,388,389,390,391,392,396,397,400,401,413,419,447,449,450,451],[2,369],{278:322,90:$VI1,97:$VJ1,98:$VK1,108:$VM1,111:$VN1,113:$VO1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,284:$V62}),o($Vp3,[2,370],{278:322,97:$VJ1,98:$VK1,108:$VM1,111:$VN1,113:$VO1,154:$VV1}),o($Vp3,[2,371],{278:322,97:$VJ1,98:$VK1,108:$VM1,111:$VN1,113:$VO1,154:$VV1}),o($Vn1,[2,372],{278:322}),o($Va2,[2,328]),o($Va2,[2,744]),o($Va2,[2,745]),o($Va2,[2,329]),o([4,5,8,47,65,67,69,70,71,81,85,90,93,97,98,99,104,105,106,107,108,109,110,111,112,113,114,115,116,117,119,120,122,123,124,126,128,130,136,138,140,142,143,144,145,146,147,149,153,154,155,157,159,161,163,172,180,182,194,195,196,197,198,199,200,201,202,203,205,212,215,216,218,233,244,245,246,247,248,249,250,251,252,256,264,266,267,268,269,270,271,272,273,274,275,276,277,280,282,283,284,285,287,290,291,298,344,347,348,351,353,355,356,364,365,366,368,372,383,385,386,388,389,390,391,392,396,397,400,401,413,419,447,449,450,451],[2,326]),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:591,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($Ve2,[2,559]),o($Ve2,[2,560]),o($Ve2,[2,561]),o($Ve2,[2,562]),o($Ve2,[2,564]),{36:592,72:67,81:$V6,158:92,163:$Va},{90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,262:593,265:359,266:$Vd2,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,278:322,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72},{263:594,264:$Vq3,265:595,266:$Vd2,268:$Vr3},o($Vs3,[2,335]),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:597,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:598,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{4:$Vj3,236:599,338:$Vk3},o($Ve2,[2,565]),{67:[1,601],376:[1,600]},o($Ve2,[2,581]),o($Vt3,[2,588]),o($Vu3,[2,566]),o($Vu3,[2,567]),o($Vu3,[2,568]),o($Vu3,[2,569]),o($Vu3,[2,570]),o($Vu3,[2,571]),o($Vu3,[2,572]),o($Vu3,[2,573]),o($Vu3,[2,574]),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:602,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o([4,5,8,47,65,67,69,71,81,85,90,93,97,98,99,104,105,106,107,108,109,110,111,112,113,114,115,116,119,120,122,123,124,126,128,130,136,138,140,142,143,144,145,146,147,149,153,154,155,157,159,161,163,172,180,182,194,195,196,197,198,199,200,201,205,212,215,216,218,233,244,245,246,247,248,249,250,251,252,256,264,266,267,268,269,270,271,272,273,274,275,276,277,280,282,283,284,285,287,290,291,298,344,347,348,351,353,355,356,364,365,366,368,372,374,376,383,385,386,388,389,390,391,392,396,397,400,401,413,419,447,449,450,451],$V82,{70:$V92,117:$Vv3}),o($Vw3,[2,285],{70:$V92}),o($Vn1,[2,286]),{67:[1,605],374:[1,604]},o($Ve2,[2,578]),o($Vx3,[2,583]),{126:[1,606]},{126:[1,607]},{126:[1,608]},{36:612,70:[1,611],72:67,81:$V6,123:[1,609],158:92,163:$Va,294:[1,610]},{202:[1,614],404:613},{3:193,4:$V1,5:$V2,70:$Vj1,107:$Vk1,116:$VQ,118:187,119:$VR,126:$VS,155:$VW,173:188,174:190,175:189,176:191,183:615,186:192,260:$Vd1,367:168,368:$Vg1,372:$Vh1},{203:[2,632]},{71:[1,616]},o($Vj2,[2,732],{185:617,3:618,4:$V1,5:$V2}),o($Vi2,[2,731]),o($Vj2,[2,161]),{3:619,4:$V1,5:$V2},o($Vj2,[2,164]),{3:620,4:$V1,5:$V2},o($Vj2,[2,168]),{3:621,4:$V1,5:$V2},o($Vj2,[2,171]),{3:622,4:$V1,5:$V2},o($Vj2,[2,174]),{3:623,4:$V1,5:$V2},{3:624,4:$V1,5:$V2},{122:[1,625]},o($Vy3,[2,150],{75:626,157:[1,627]}),{3:193,4:$V1,5:$V2,107:[1,632],116:$VQ,119:[1,633],126:$VS,155:$VW,173:628,174:629,175:630,176:631,260:$Vd1},{3:638,4:$V1,5:$V2,87:634,88:635,89:636,90:$Vz3},o($Vp2,[2,697]),o($VA3,[2,694],{83:639,156:640,157:[1,641]}),o($Vm1,[2,693],{127:642,153:$VB3,154:$VC3,155:$VD3}),o([4,5,8,65,67,69,71,90,93,97,98,99,104,105,106,107,108,109,110,111,112,113,114,115,116,117,119,120,122,123,124,126,128,130,136,138,140,142,143,144,145,146,147,149,153,154,155,157,159,161,172,244,245,246,247,248,249,250,251,252,264,268,368,372,450,451],[2,71],{70:[1,646]}),{94:[1,647]},{3:648,4:$V1,5:$V2},o($VE3,[2,75]),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:649,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:650,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:411,4:$V1,5:$V2,65:$Vq2,69:$Vr2,70:$Vs2,90:$Vt2,92:652,93:$Vu2,97:$Vv2,98:$Vw2,99:$Vx2,101:651,104:$Vy2,105:$Vz2,106:$VA2,107:$VB2,108:$VC2,109:$VD2,110:$VE2,111:$VF2,112:$VG2,113:$VH2,114:$VI2,115:$VJ2,116:$VK2,117:$VL2,118:433,119:$VM2,120:$VN2,122:$VO2,123:$VP2,124:$VQ2,126:$VR2,128:$VS2,130:$VT2,132:443,134:444,136:$VU2,138:$VV2,140:$VW2,142:$VX2,143:$VY2,144:$VZ2,145:$V_2,146:$V$2,147:$V03,149:$V13,159:$V23,161:$V33,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,367:168,368:$Vg1,372:$Vh1},{70:[1,653]},{70:[1,654]},{70:[1,655]},o($VE3,[2,83]),o($VE3,[2,84]),o($VE3,[2,85]),o($VE3,[2,86]),o($VE3,[2,87]),o($VE3,[2,88]),{3:656,4:$V1,5:$V2},{3:657,4:$V1,5:$V2,108:[1,658]},o($VE3,[2,92]),o($VE3,[2,93]),o($VE3,[2,94]),{117:[1,659]},o($VE3,[2,96]),{3:660,4:$V1,5:$V2,70:$Vc2,91:351,106:$VN,107:$VO,116:$VQ,126:$VS,155:$VW,170:352,175:354,225:353,254:$V81,255:$V91,256:$Va1,260:$Vd1,367:355,372:$Vh1},{119:[1,661]},{70:[1,662]},{119:[1,663]},o($VE3,[2,101]),{70:[1,664]},{3:665,4:$V1,5:$V2},{70:[1,666]},{70:[1,667]},{70:[1,668]},{70:[1,669]},{70:[1,670],138:[1,671]},{70:[1,672]},{70:[1,673]},{70:[1,674]},{70:[1,675]},{70:[1,676]},{70:[1,677]},{70:[1,678]},{70:[1,679]},{70:[1,680]},{70:[2,712]},{70:[2,713]},{3:217,4:$V1,5:$V2,173:681},{3:217,4:$V1,5:$V2,173:682},{91:683,107:$VO,256:$Va1},o($VH,[2,533],{90:[1,684]}),{3:217,4:$V1,5:$V2,173:685},{91:686,107:$VO,256:$Va1},{3:687,4:$V1,5:$V2},o($VH,[2,629]),o($VH,[2,60]),{3:209,4:$V1,5:$V2,68:688},{70:[1,689]},o($VH,[2,610]),o($VH,[2,523]),{3:638,4:$V1,5:$V2,89:692,116:$VF3,119:$VG3,121:690,288:691,289:693},{118:696,119:$Vo1,367:168,368:$Vg1,372:$Vh1},o($VH,[2,607]),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:697,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($Vl3,$Vm3,{223:127,174:128,224:129,89:130,222:131,170:132,225:133,91:134,226:135,175:136,176:137,227:138,228:139,229:140,118:141,230:142,51:144,132:146,3:147,367:168,100:698,4:$V1,5:$V2,70:$VM,106:$VN,107:$VO,112:$VP,116:$VQ,119:$VR,126:$VS,128:$VT,153:$VU,154:$VV,155:$VW,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,368:$Vg1,372:$Vh1}),{91:699,107:$VO,256:$Va1},{3:241,4:$V1,5:$V2,395:700,396:$Vq1},o($VH,[2,589]),o($VH,[2,599]),o($VH,[2,600]),{97:[1,703],99:[1,701],380:702},o($VH,[2,681],{67:$V93}),{3:93,4:$V1,5:$V2,446:704},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:489,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,148:705,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,221:488,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:489,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,148:706,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,221:488,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:489,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,148:707,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,221:488,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($Vb3,[2,129]),o($Vb3,[2,727],{67:$VH3}),o($VI3,[2,248]),o($VI3,[2,255],{278:322,3:710,91:712,4:$V1,5:$V2,69:[1,709],90:$VI1,97:$VJ1,98:$VK1,99:$V83,106:[1,711],107:$VO,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,256:$Va1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72}),o($Vt1,[2,728],{171:713,452:[1,714]}),{106:$VN,170:715},{67:$V93,71:[1,716]},o($VG,[2,8]),{122:[1,717],164:[1,718]},{164:[1,719]},{164:[1,720]},{164:[1,721]},o($VH,[2,512],{69:[1,723],70:[1,722]}),o($VH,[2,517]),{258:[1,724]},{3:725,4:$V1,5:$V2,91:726,107:$VO,256:$Va1},{3:217,4:$V1,5:$V2,173:727},{202:[1,728]},o([8,67,69,71,107,112,114,126,264,268,368,372,450,451],$VC1,{424:277,427:278,3:279,434:280,431:281,379:282,423:729,4:$V1,5:$V2,116:$Vr1,119:$Vs1}),o($VH,[2,666],{278:322,90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72}),o($V73,[2,774],{426:730,432:731,69:$VJ3}),o($Ve3,[2,773]),o([69,107,112,114,119,126,368,372],$VC1,{434:280,424:733,3:734,4:$V1,5:$V2}),o([67,69,71,107,112,114,126,368,372],$VC1,{423:276,424:277,427:278,3:279,434:280,431:281,379:282,422:735,4:$V1,5:$V2,116:$Vr1,119:$Vs1}),o($VK3,[2,788],{436:736,107:[1,737]}),o($Vh3,[2,787]),{3:738,4:$V1,5:$V2,106:[1,739]},o($VL3,[2,672]),{3:217,4:$V1,5:$V2,173:740},{3:217,4:$V1,5:$V2,173:741},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:742,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($VM3,[2,768],{416:743,91:744,107:$VO,256:$Va1}),o($Vi3,[2,767]),{3:745,4:$V1,5:$V2},o($VE1,[2,624]),o($VE1,[2,625],{99:[1,746]}),{4:$Vj3,236:747,338:$Vk3},o([5,8,47,65,67,69,71,81,85,90,93,97,98,99,104,105,106,107,108,109,110,111,112,113,114,115,116,117,119,120,122,123,124,126,128,130,136,138,140,142,143,144,145,146,147,149,153,154,155,157,159,161,163,172,180,182,194,195,196,197,198,199,200,201,205,212,215,216,218,233,244,245,246,247,248,249,250,251,252,256,257,264,266,267,268,269,270,271,272,273,274,275,276,277,280,282,283,284,285,287,290,291,294,298,307,319,320,324,325,344,347,348,351,353,355,356,364,365,366,368,372,383,385,386,388,389,390,391,392,396,397,400,401,413,419,447,449,450,451],[2,482],{4:[1,749],70:[1,748]}),{70:[1,750]},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:751,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($VH,[2,525]),o($Vc3,[2,505]),{3:752,4:$V1,5:$V2,91:753,107:$VO,256:$Va1},o($VH,[2,503]),o($VH,[2,550]),o($VH,[2,604]),o($VH,$V0,{15:5,16:7,17:8,18:9,19:10,20:11,21:12,22:13,23:14,24:15,25:16,26:17,27:18,28:19,29:20,30:21,31:22,32:23,33:24,34:25,35:26,36:27,37:28,38:29,39:30,40:31,41:32,42:33,43:34,44:35,45:36,46:37,48:39,49:40,50:41,51:42,52:43,53:44,54:45,55:46,56:47,57:48,58:49,59:50,60:51,61:52,62:53,63:54,64:55,72:67,446:88,158:92,3:93,10:754,4:$V1,5:$V2,47:$V4,65:$V5,81:$V6,99:$V7,120:$V8,130:$V9,163:$Va,233:$Vb,287:$Vc,290:$Vd,291:$Ve,298:$Vf,344:$Vg,347:$Vh,348:$Vi,351:$Vj,353:$Vk,355:$Vl,356:$Vm,364:$Vn,365:$Vo,366:$Vp,383:$Vq,385:$Vr,386:$Vs,388:$Vt,389:$Vu,390:$Vv,391:$Vw,392:$Vx,396:$Vy,397:$Vz,400:$VA,401:$VB,447:$VC,449:$VD}),o($VN3,[2,339],{278:322,97:$VJ1,98:$VK1,108:$VM1,111:$VN1,113:$VO1,153:$VU1,154:$VV1,270:$VX1}),o($VN3,[2,340],{278:322,97:$VJ1,98:$VK1,108:$VM1,111:$VN1,113:$VO1,153:$VU1,154:$VV1,270:$VX1}),o($Vp3,[2,341],{278:322,97:$VJ1,98:$VK1,108:$VM1,111:$VN1,113:$VO1,154:$VV1}),o($Vp3,[2,342],{278:322,97:$VJ1,98:$VK1,108:$VM1,111:$VN1,113:$VO1,154:$VV1}),o($VO3,[2,343],{278:322,97:$VJ1,98:$VK1,111:$VN1}),o($VO3,[2,344],{278:322,97:$VJ1,98:$VK1,111:$VN1}),o($VO3,[2,345],{278:322,97:$VJ1,98:$VK1,111:$VN1}),o([4,5,8,47,65,67,69,70,71,81,85,90,93,98,99,104,105,106,107,108,109,110,112,113,114,115,116,117,119,120,122,123,124,126,128,130,136,138,140,142,143,144,145,146,147,149,153,154,155,157,159,161,163,172,180,182,194,195,196,197,198,199,200,201,205,212,215,216,218,233,244,245,246,247,248,249,250,251,252,256,264,266,267,268,269,270,271,272,273,274,275,276,277,280,282,283,284,285,287,290,291,298,344,347,348,351,353,355,356,364,365,366,368,372,383,385,386,388,389,390,391,392,396,397,400,401,413,419,447,449,450,451],[2,346],{278:322,97:$VJ1,111:$VN1}),o($Vw3,[2,347],{70:$V92}),o($Vn1,[2,348]),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:755,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($Vn1,[2,350]),o($Vw3,[2,351],{70:$V92}),o($Vn1,[2,352]),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:756,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($Vn1,[2,354]),o($VP3,[2,355],{278:322,90:$VI1,97:$VJ1,98:$VK1,108:$VM1,111:$VN1,113:$VO1,128:$VR1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,280:$V32,284:$V62}),o($VP3,[2,356],{278:322,90:$VI1,97:$VJ1,98:$VK1,108:$VM1,111:$VN1,113:$VO1,128:$VR1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,280:$V32,284:$V62}),o($VP3,[2,357],{278:322,90:$VI1,97:$VJ1,98:$VK1,108:$VM1,111:$VN1,113:$VO1,128:$VR1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,280:$V32,284:$V62}),o($VP3,[2,358],{278:322,90:$VI1,97:$VJ1,98:$VK1,108:$VM1,111:$VN1,113:$VO1,128:$VR1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,280:$V32,284:$V62}),o([4,5,8,47,65,81,99,114,115,120,130,144,145,163,233,264,268,271,272,273,274,275,276,277,282,283,285,287,290,291,298,344,347,348,351,353,355,356,364,365,366,383,385,386,388,389,390,391,392,396,397,400,401,447,449,450,451],$VQ3,{278:322,90:$VI1,97:$VJ1,98:$VK1,108:$VM1,111:$VN1,113:$VO1,128:$VR1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,280:$V32,284:$V62}),o($VP3,[2,360],{278:322,90:$VI1,97:$VJ1,98:$VK1,108:$VM1,111:$VN1,113:$VO1,128:$VR1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,280:$V32,284:$V62}),o($VP3,[2,361],{278:322,90:$VI1,97:$VJ1,98:$VK1,108:$VM1,111:$VN1,113:$VO1,128:$VR1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,280:$V32,284:$V62}),o($VP3,[2,362],{278:322,90:$VI1,97:$VJ1,98:$VK1,108:$VM1,111:$VN1,113:$VO1,128:$VR1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,280:$V32,284:$V62}),o($VP3,[2,363],{278:322,90:$VI1,97:$VJ1,98:$VK1,108:$VM1,111:$VN1,113:$VO1,128:$VR1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,280:$V32,284:$V62}),o($VP3,[2,364],{278:322,90:$VI1,97:$VJ1,98:$VK1,108:$VM1,111:$VN1,113:$VO1,128:$VR1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,280:$V32,284:$V62}),{70:[1,757]},{70:[2,397]},{70:[2,398]},{70:[2,399]},o($VR3,[2,367],{278:322,90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,280:$V32,284:$V62}),o([4,5,8,47,65,67,69,70,71,81,85,93,104,105,106,107,109,110,112,116,117,119,120,122,123,124,126,130,136,138,140,142,143,145,146,147,149,155,157,159,161,163,172,180,182,194,195,196,197,198,199,200,201,205,212,215,216,218,233,244,245,246,247,248,249,250,251,252,256,264,266,267,268,285,287,290,291,298,344,347,348,351,353,355,356,364,365,366,368,372,383,385,386,388,389,390,391,392,396,397,400,401,413,419,447,449,450,451],[2,368],{278:322,90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,280:$V32,282:$V42,283:$V52,284:$V62}),{3:147,4:$V1,5:$V2,36:758,51:144,70:$VM,71:[1,760],72:67,81:$V6,89:130,91:134,100:235,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,125:759,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,158:92,163:$Va,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($Vn1,[2,380]),o($Vn1,[2,382]),o($Vn1,[2,388]),o($Vn1,[2,389]),{3:349,4:$V1,5:$V2,70:[1,761]},{3:377,4:$V1,5:$V2,70:[1,762],89:568,119:$Vn3,174:569,176:764,281:763},o($VR3,[2,384],{278:322,90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,280:$V32,284:$V62}),o($VR3,[2,385],{278:322,90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,280:$V32,284:$V62}),o([4,5,8,47,65,67,69,70,71,81,85,93,99,104,105,106,107,109,110,112,114,115,116,117,119,120,122,123,124,126,128,130,136,138,140,142,143,144,145,146,147,149,155,157,159,161,163,172,180,182,194,195,196,197,198,199,200,201,205,212,215,216,218,233,244,245,246,247,248,249,250,251,252,256,264,266,267,268,271,272,273,274,275,276,277,280,282,283,284,285,287,290,291,298,344,347,348,351,353,355,356,364,365,366,368,372,383,385,386,388,389,390,391,392,396,397,400,401,413,419,447,449,450,451],[2,386],{278:322,90:$VI1,97:$VJ1,98:$VK1,108:$VM1,111:$VN1,113:$VO1,153:$VU1,154:$VV1,269:$VW1,270:$VX1}),o($Vn1,[2,387]),o($Vn1,[2,279]),o($Vn1,[2,280]),o($Vn1,[2,281]),o($Vn1,[2,373]),{67:$V63,71:[1,765]},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:766,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:767,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:235,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,125:768,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($Va2,[2,317]),o($Va3,[2,743]),o($Va3,[2,740]),o($Va3,[2,741]),o($Vn1,$VS3),o($VT3,[2,261]),o($Vn1,[2,257]),{71:[1,770],90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,278:322,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72},{71:[1,771]},{263:772,264:$Vq3,265:595,266:$Vd2,268:$Vr3},{264:[1,773]},o($Vs3,[2,334]),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:774,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,267:[1,775],269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,278:322,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72},{69:[1,776],90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,278:322,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72},{67:[1,777]},o($Ve2,[2,579]),{3:377,4:$V1,5:$V2,70:$Vf2,89:372,91:370,106:$VN,107:$VO,116:$VQ,118:367,119:$Vo1,126:$VS,155:$VW,170:369,174:375,175:374,225:371,226:373,254:$V81,255:$V91,256:$Va1,257:$Vb1,260:$Vd1,367:168,368:$Vg1,370:779,371:368,372:$Vh1,376:[1,778]},{71:[1,780],90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,278:322,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72},{3:781,4:$V1,5:$V2,123:$Vo3},o($Ve2,[2,576]),{3:385,4:$V1,5:$V2,106:$Vg2,107:$Vh2,374:[1,782],377:783},{3:377,4:$V1,5:$V2,70:$Vf2,89:372,91:370,106:$VN,107:$VO,116:$VQ,118:367,119:$Vo1,126:$VS,155:$VW,170:369,174:375,175:374,225:371,226:373,254:$V81,255:$V91,256:$Va1,257:$Vb1,260:$Vd1,367:168,368:$Vg1,370:784,371:368,372:$Vh1},{3:377,4:$V1,5:$V2,70:$Vf2,89:372,91:370,106:$VN,107:$VO,116:$VQ,118:367,119:$Vo1,126:$VS,155:$VW,170:369,174:375,175:374,225:371,226:373,254:$V81,255:$V91,256:$Va1,257:$Vb1,260:$Vd1,367:168,368:$Vg1,370:785,371:368,372:$Vh1},{3:377,4:$V1,5:$V2,70:$Vf2,89:372,91:370,106:$VN,107:$VO,116:$VQ,118:367,119:$Vo1,126:$VS,155:$VW,170:369,174:375,175:374,225:371,226:373,254:$V81,255:$V91,256:$Va1,257:$Vb1,260:$Vd1,367:168,368:$Vg1,370:786,371:368,372:$Vh1},{70:$VU3,116:$VQ,118:789,119:$Vo1,126:$VS,155:$VW,175:790,260:$Vd1,293:787,367:168,368:$Vg1,372:$Vh1},{123:[1,791]},{3:638,4:$V1,5:$V2,89:793,204:792},o($VV3,[2,411]),{266:$VW3,405:794,407:795,408:796},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:798,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{202:[2,633]},o($Vj2,[2,159],{3:799,4:$V1,5:$V2,69:[1,800]}),o($Vj2,[2,160]),o($Vj2,[2,733]),o($Vj2,[2,162]),o($Vj2,[2,165]),o($Vj2,[2,169]),o($Vj2,[2,172]),o($Vj2,[2,175]),o([4,5,8,65,67,69,70,71,81,93,104,120,122,123,128,136,142,143,157,161,163,180,182,194,195,196,197,198,199,200,201,202,203,205,218,257,264,268,294,307,319,320,324,325,344,348,349,350,450,451],[2,177]),{3:801,4:$V1,5:$V2},o($VX3,[2,214],{76:802,104:[1,803]}),{3:193,4:$V1,5:$V2,70:[1,805],107:$Vk1,116:$VQ,118:187,119:$VR,126:$VS,155:$VW,173:188,174:190,175:189,176:191,177:804,183:806,186:192,260:$Vd1,367:168,368:$Vg1,372:$Vh1},o($Vm2,[2,142]),o($Vm2,[2,143]),o($Vm2,[2,144]),o($Vm2,[2,145]),o($Vm2,[2,146]),{3:349,4:$V1,5:$V2},o($Vl1,[2,66],{67:[1,807]}),o($VY3,[2,68]),o($VY3,[2,69]),{91:808,107:$VO,256:$Va1},o([8,65,67,71,93,99,104,136,142,143,157,172,180,182,194,195,196,197,198,199,200,201,205,218,264,268,450,451],$V82,{117:$Vv3}),o($VA3,[2,65]),o($VA3,[2,695]),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:809,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($VE3,[2,104]),o($VE3,[2,122]),o($VE3,[2,123]),o($VE3,[2,124]),{3:147,4:$V1,5:$V2,51:144,70:$VM,71:[2,704],89:130,91:134,100:235,103:810,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,125:811,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{70:[1,812]},o($VE3,[2,74]),o([4,5,8,65,67,69,70,71,93,99,104,105,106,107,109,110,112,114,115,116,117,119,120,122,123,124,126,130,136,138,140,142,143,144,145,146,147,149,155,157,159,161,172,244,245,246,247,248,249,250,251,252,264,268,368,372,450,451],[2,76],{278:322,90:$VI1,97:$VJ1,98:$VK1,108:$VM1,111:$VN1,113:$VO1,128:$VR1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72}),o([4,5,8,65,67,69,70,71,90,93,99,104,105,106,107,109,110,112,114,115,116,117,119,120,122,123,124,126,128,130,136,138,140,142,143,144,145,146,147,149,155,157,159,161,172,244,245,246,247,248,249,250,251,252,264,268,368,372,450,451],[2,77],{278:322,97:$VJ1,98:$VK1,108:$VM1,111:$VN1,113:$VO1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72}),{3:411,4:$V1,5:$V2,65:$Vq2,69:$Vr2,70:$Vs2,71:[1,813],90:$Vt2,92:814,93:$Vu2,97:$Vv2,98:$Vw2,99:$Vx2,104:$Vy2,105:$Vz2,106:$VA2,107:$VB2,108:$VC2,109:$VD2,110:$VE2,111:$VF2,112:$VG2,113:$VH2,114:$VI2,115:$VJ2,116:$VK2,117:$VL2,118:433,119:$VM2,120:$VN2,122:$VO2,123:$VP2,124:$VQ2,126:$VR2,128:$VS2,130:$VT2,132:443,134:444,136:$VU2,138:$VV2,140:$VW2,142:$VX2,143:$VY2,144:$VZ2,145:$V_2,146:$V$2,147:$V03,149:$V13,159:$V23,161:$V33,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,367:168,368:$Vg1,372:$Vh1},o($VZ3,[2,700],{127:642,153:$VB3,154:$VC3,155:$VD3}),{3:411,4:$V1,5:$V2,65:$Vq2,69:$Vr2,70:$Vs2,90:$Vt2,92:816,93:$Vu2,97:$Vv2,98:$Vw2,99:$Vx2,102:815,104:$Vy2,105:$Vz2,106:$VA2,107:$VB2,108:$VC2,109:$VD2,110:$VE2,111:$VF2,112:$VG2,113:$VH2,114:$VI2,115:$VJ2,116:$VK2,117:$VL2,118:433,119:$VM2,120:$VN2,122:$VO2,123:$VP2,124:$VQ2,126:$VR2,128:$VS2,130:$VT2,132:443,134:444,136:$VU2,138:$VV2,140:$VW2,142:$VX2,143:$VY2,144:$VZ2,145:$V_2,146:$V$2,147:$V03,149:$V13,159:$V23,161:$V33,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,367:168,368:$Vg1,372:$Vh1},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:817,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:818,4:$V1,5:$V2},o($VE3,[2,89]),o($VE3,[2,90]),o($VE3,[2,91]),o($VE3,[2,95]),o($VE3,[2,97]),{3:819,4:$V1,5:$V2},{3:638,4:$V1,5:$V2,89:692,116:$VF3,119:$VG3,121:820,288:691,289:693},{3:821,4:$V1,5:$V2},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:235,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,125:822,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($VE3,[2,103]),o($VZ3,[2,706],{129:823}),o($VZ3,[2,708],{131:824}),o($VZ3,[2,710],{133:825}),o($VZ3,[2,714],{135:826}),o($V_3,$V$3,{137:827,152:828}),{70:[1,829]},o($VZ3,[2,716],{139:830}),o($VZ3,[2,718],{141:831}),o($V_3,$V$3,{152:828,137:832}),o($V_3,$V$3,{152:828,137:833}),o($V_3,$V$3,{152:828,137:834}),o($V_3,$V$3,{152:828,137:835}),{3:411,4:$V1,5:$V2,65:$Vq2,69:$Vr2,70:$Vs2,90:$Vt2,92:836,93:$Vu2,97:$Vv2,98:$Vw2,99:$Vx2,104:$Vy2,105:$Vz2,106:$VA2,107:$VB2,108:$VC2,109:$VD2,110:$VE2,111:$VF2,112:$VG2,113:$VH2,114:$VI2,115:$VJ2,116:$VK2,117:$VL2,118:433,119:$VM2,120:$VN2,122:$VO2,123:$VP2,124:$VQ2,126:$VR2,128:$VS2,130:$VT2,132:443,134:444,136:$VU2,138:$VV2,140:$VW2,142:$VX2,143:$VY2,144:$VZ2,145:$V_2,146:$V$2,147:$V03,149:$V13,159:$V23,161:$V33,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,367:168,368:$Vg1,372:$Vh1},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:489,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,148:837,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,221:488,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($V04,[2,720],{150:838}),o($VH,[2,543],{157:[1,839]}),o($VH,[2,539],{157:[1,840]}),o($VH,[2,532]),{91:841,107:$VO,256:$Va1},o($VH,[2,541],{157:[1,842]}),o($VH,[2,536]),o($VH,[2,537],{90:[1,843]}),o($V43,[2,61]),{36:844,72:67,81:$V6,158:92,163:$Va},o($VH,[2,401],{67:$V14,104:[1,845]}),o($V24,[2,402]),{99:[1,847]},{3:848,4:$V1,5:$V2},o($Vi1,[2,746]),o($Vi1,[2,747]),o($VH,[2,557]),o($V73,[2,319],{278:322,90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72}),o($VP3,$VQ3,{278:322,90:$VI1,97:$VJ1,98:$VK1,108:$VM1,111:$VN1,113:$VO1,128:$VR1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,280:$V32,284:$V62}),o($VE1,[2,618]),o($VE1,[2,620]),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:849,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{97:[1,851],99:[1,850]},{3:853,4:$V1,5:$V2,70:$V34,106:$V44,381:852},o($V73,[2,683]),o($Vb3,[2,126],{67:$VH3}),o($Vb3,[2,127],{67:$VH3}),o($Vb3,[2,128],{67:$VH3}),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:489,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,221:856,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:857,4:$V1,5:$V2,91:859,106:[1,858],107:$VO,256:$Va1},o($VI3,[2,250]),o($VI3,[2,252]),o($VI3,[2,254]),o($Vt1,[2,138]),o($Vt1,[2,729]),{71:[1,860]},o($Vw1,[2,686]),{3:861,4:$V1,5:$V2},{3:862,4:$V1,5:$V2},{3:864,4:$V1,5:$V2,334:863},{3:864,4:$V1,5:$V2,334:865},{3:866,4:$V1,5:$V2},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:235,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,125:867,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:868,4:$V1,5:$V2},o($Vc3,[2,445]),o($VH,$V54,{354:869,69:$V64,70:[1,870]}),o($VH,$V54,{354:872,69:$V64}),{70:[1,873]},{3:217,4:$V1,5:$V2,173:874},o($V73,[2,667]),o($V73,[2,669]),o($V73,[2,775]),{116:$Vr1,119:$Vs1,379:875},o($V74,[2,778],{367:168,428:876,118:877,119:$Vo1,368:$Vg1,372:$Vh1}),o($Vf3,$Vg3),{67:$Vd3,71:[1,878]},o($V84,[2,790],{437:879,438:880,126:[1,881]}),o($VK3,[2,789]),o($Vh3,[2,677]),o($Vh3,[2,678]),o($VH,[2,432],{70:[1,882]}),{69:[1,884],70:[1,883]},{90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,122:[1,885],128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,278:322,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72},o($VV3,$V94,{72:67,158:92,417:886,36:889,81:$V6,120:$Va4,163:$Va,419:$Vb4}),o($VM3,[2,769]),o($Vi3,[2,659]),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:890,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($VE1,[2,626],{99:[1,891]}),{106:$Vc4,247:$Vd4,337:892},o([4,5,8,47,65,67,69,71,81,85,90,93,97,98,99,104,105,106,107,108,109,110,111,112,113,114,115,116,117,119,120,122,123,124,126,128,130,136,138,140,142,143,144,145,146,147,149,153,154,155,157,159,161,163,172,180,182,194,195,196,197,198,199,200,201,205,212,215,216,218,233,244,245,246,247,248,249,250,251,252,256,257,264,266,267,268,269,270,271,272,273,274,275,276,277,280,282,283,284,285,287,290,291,294,298,307,319,320,324,325,344,347,348,351,353,355,356,364,365,366,368,372,383,385,386,388,389,390,391,392,396,397,400,401,413,419,447,449,450,451],[2,483],{70:[1,895]}),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:897,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,295:896,367:168,368:$Vg1,372:$Vh1},o($VH,[2,406],{278:322,90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72}),o($VH,[2,526]),o($VH,[2,527]),o($VH,[2,606]),{71:[1,898],90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,278:322,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72},{71:[1,899],90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,278:322,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72},{3:147,4:$V1,5:$V2,36:900,51:144,70:$VM,72:67,81:$V6,89:130,91:134,100:235,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,125:901,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,158:92,163:$Va,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{71:[1,902]},{67:$V63,71:[1,903]},o($Vn1,[2,378]),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:904,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:147,4:$V1,5:$V2,36:905,51:144,70:$VM,71:[1,907],72:67,81:$V6,89:130,91:134,100:235,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,125:906,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,158:92,163:$Va,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($Vn1,[2,381]),o($Vn1,[2,383]),o($Vn1,$Ve4,{239:908,240:$Vf4}),{71:[1,910],90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,278:322,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72},{71:[1,911],90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,278:322,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72},{67:$V63,71:[1,912]},{3:913,4:$V1,5:$V2,154:[1,914]},o($Ve2,[2,558]),o($Vn1,[2,327]),{264:[1,915]},o($Vn1,[2,333]),{90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,264:[2,337],269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,278:322,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:916,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{4:$Vj3,236:917,338:$Vk3},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:918,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($Ve2,[2,580]),o($Vt3,[2,587]),o($Vu3,[2,575]),o($VT3,$VS3),o($Ve2,[2,577]),o($Vx3,[2,582]),o($Vx3,[2,584]),o($Vx3,[2,585]),o($Vx3,[2,586]),o($VV3,[2,408],{67:$Vg4}),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:897,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,295:921,367:168,368:$Vg1,372:$Vh1},o($Vh4,[2,416]),o($Vh4,[2,417]),o($VV3,[2,409]),{67:$Vi4,71:[1,922]},o($Vj4,[2,429]),o($VH,[2,653],{406:924,407:925,408:926,266:$VW3,413:[1,927]}),o($Vk4,[2,637]),o($Vk4,[2,638]),{128:[1,929],409:[1,928]},{90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,266:[2,634],269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,278:322,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72},o($Vj2,[2,157]),{3:930,4:$V1,5:$V2},o($VH,[2,511]),o($Vl4,[2,216],{77:931,205:[1,932]}),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:933,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($Vy3,[2,147],{178:934,187:936,179:937,188:938,193:941,67:$Vm4,180:$Vn4,182:$Vo4,194:$Vp4,195:$Vq4,196:$Vr4,197:$Vs4,198:$Vt4,199:$Vu4,200:$Vv4,201:$Vw4}),{3:193,4:$V1,5:$V2,36:390,70:$Vj1,72:67,81:$V6,107:$Vk1,116:$VQ,118:187,119:$VR,126:$VS,155:$VW,158:92,163:$Va,173:188,174:190,175:189,176:191,177:950,183:806,186:192,260:$Vd1,367:168,368:$Vg1,372:$Vh1},o($Vj4,[2,155]),{3:638,4:$V1,5:$V2,88:951,89:636,90:$Vz3},o($VY3,[2,70]),o($VA3,[2,125],{278:322,90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72}),{71:[1,952]},{67:$V63,71:[2,705]},{3:147,4:$V1,5:$V2,51:144,70:$VM,71:[2,698],89:130,91:134,95:953,96:954,100:957,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,214:955,215:[1,956],222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($VE3,[2,78]),o($VZ3,[2,701],{127:642,153:$VB3,154:$VC3,155:$VD3}),{3:411,4:$V1,5:$V2,65:$Vq2,69:$Vr2,70:$Vs2,71:[1,958],90:$Vt2,92:959,93:$Vu2,97:$Vv2,98:$Vw2,99:$Vx2,104:$Vy2,105:$Vz2,106:$VA2,107:$VB2,108:$VC2,109:$VD2,110:$VE2,111:$VF2,112:$VG2,113:$VH2,114:$VI2,115:$VJ2,116:$VK2,117:$VL2,118:433,119:$VM2,120:$VN2,122:$VO2,123:$VP2,124:$VQ2,126:$VR2,128:$VS2,130:$VT2,132:443,134:444,136:$VU2,138:$VV2,140:$VW2,142:$VX2,143:$VY2,144:$VZ2,145:$V_2,146:$V$2,147:$V03,149:$V13,159:$V23,161:$V33,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,367:168,368:$Vg1,372:$Vh1},o($VZ3,[2,702],{127:642,153:$VB3,154:$VC3,155:$VD3}),{71:[1,960],90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,278:322,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72},{71:[1,961]},o($VE3,[2,98]),{67:$V14,71:[1,962]},o($VE3,[2,100]),{67:$V63,71:[1,963]},{3:411,4:$V1,5:$V2,65:$Vq2,69:$Vr2,70:$Vs2,71:[1,964],90:$Vt2,92:965,93:$Vu2,97:$Vv2,98:$Vw2,99:$Vx2,104:$Vy2,105:$Vz2,106:$VA2,107:$VB2,108:$VC2,109:$VD2,110:$VE2,111:$VF2,112:$VG2,113:$VH2,114:$VI2,115:$VJ2,116:$VK2,117:$VL2,118:433,119:$VM2,120:$VN2,122:$VO2,123:$VP2,124:$VQ2,126:$VR2,128:$VS2,130:$VT2,132:443,134:444,136:$VU2,138:$VV2,140:$VW2,142:$VX2,143:$VY2,144:$VZ2,145:$V_2,146:$V$2,147:$V03,149:$V13,159:$V23,161:$V33,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,367:168,368:$Vg1,372:$Vh1},{3:411,4:$V1,5:$V2,65:$Vq2,69:$Vr2,70:$Vs2,71:[1,966],90:$Vt2,92:967,93:$Vu2,97:$Vv2,98:$Vw2,99:$Vx2,104:$Vy2,105:$Vz2,106:$VA2,107:$VB2,108:$VC2,109:$VD2,110:$VE2,111:$VF2,112:$VG2,113:$VH2,114:$VI2,115:$VJ2,116:$VK2,117:$VL2,118:433,119:$VM2,120:$VN2,122:$VO2,123:$VP2,124:$VQ2,126:$VR2,128:$VS2,130:$VT2,132:443,134:444,136:$VU2,138:$VV2,140:$VW2,142:$VX2,143:$VY2,144:$VZ2,145:$V_2,146:$V$2,147:$V03,149:$V13,159:$V23,161:$V33,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,367:168,368:$Vg1,372:$Vh1},{3:411,4:$V1,5:$V2,65:$Vq2,69:$Vr2,70:$Vs2,71:[1,968],90:$Vt2,92:969,93:$Vu2,97:$Vv2,98:$Vw2,99:$Vx2,104:$Vy2,105:$Vz2,106:$VA2,107:$VB2,108:$VC2,109:$VD2,110:$VE2,111:$VF2,112:$VG2,113:$VH2,114:$VI2,115:$VJ2,116:$VK2,117:$VL2,118:433,119:$VM2,120:$VN2,122:$VO2,123:$VP2,124:$VQ2,126:$VR2,128:$VS2,130:$VT2,132:443,134:444,136:$VU2,138:$VV2,140:$VW2,142:$VX2,143:$VY2,144:$VZ2,145:$V_2,146:$V$2,147:$V03,149:$V13,159:$V23,161:$V33,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,367:168,368:$Vg1,372:$Vh1},{3:411,4:$V1,5:$V2,65:$Vq2,69:$Vr2,70:$Vs2,71:[1,970],90:$Vt2,92:971,93:$Vu2,97:$Vv2,98:$Vw2,99:$Vx2,104:$Vy2,105:$Vz2,106:$VA2,107:$VB2,108:$VC2,109:$VD2,110:$VE2,111:$VF2,112:$VG2,113:$VH2,114:$VI2,115:$VJ2,116:$VK2,117:$VL2,118:433,119:$VM2,120:$VN2,122:$VO2,123:$VP2,124:$VQ2,126:$VR2,128:$VS2,130:$VT2,132:443,134:444,136:$VU2,138:$VV2,140:$VW2,142:$VX2,143:$VY2,144:$VZ2,145:$V_2,146:$V$2,147:$V03,149:$V13,159:$V23,161:$V33,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,367:168,368:$Vg1,372:$Vh1},{67:$Vx4,71:[1,972]},o($Vy4,[2,121],{367:168,3:411,118:433,132:443,134:444,92:974,4:$V1,5:$V2,65:$Vq2,69:$Vr2,70:$Vs2,90:$Vt2,93:$Vu2,97:$Vv2,98:$Vw2,99:$Vx2,104:$Vy2,105:$Vz2,106:$VA2,107:$VB2,108:$VC2,109:$VD2,110:$VE2,111:$VF2,112:$VG2,113:$VH2,114:$VI2,115:$VJ2,116:$VK2,117:$VL2,119:$VM2,120:$VN2,122:$VO2,123:$VP2,124:$VQ2,126:$VR2,128:$VS2,130:$VT2,136:$VU2,138:$VV2,140:$VW2,142:$VX2,143:$VY2,144:$VZ2,145:$V_2,146:$V$2,147:$V03,149:$V13,159:$V23,161:$V33,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,368:$Vg1,372:$Vh1}),o($V_3,$V$3,{152:828,137:975}),{3:411,4:$V1,5:$V2,65:$Vq2,69:$Vr2,70:$Vs2,71:[1,976],90:$Vt2,92:977,93:$Vu2,97:$Vv2,98:$Vw2,99:$Vx2,104:$Vy2,105:$Vz2,106:$VA2,107:$VB2,108:$VC2,109:$VD2,110:$VE2,111:$VF2,112:$VG2,113:$VH2,114:$VI2,115:$VJ2,116:$VK2,117:$VL2,118:433,119:$VM2,120:$VN2,122:$VO2,123:$VP2,124:$VQ2,126:$VR2,128:$VS2,130:$VT2,132:443,134:444,136:$VU2,138:$VV2,140:$VW2,142:$VX2,143:$VY2,144:$VZ2,145:$V_2,146:$V$2,147:$V03,149:$V13,159:$V23,161:$V33,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,367:168,368:$Vg1,372:$Vh1},{3:411,4:$V1,5:$V2,65:$Vq2,69:$Vr2,70:$Vs2,71:[1,978],90:$Vt2,92:979,93:$Vu2,97:$Vv2,98:$Vw2,99:$Vx2,104:$Vy2,105:$Vz2,106:$VA2,107:$VB2,108:$VC2,109:$VD2,110:$VE2,111:$VF2,112:$VG2,113:$VH2,114:$VI2,115:$VJ2,116:$VK2,117:$VL2,118:433,119:$VM2,120:$VN2,122:$VO2,123:$VP2,124:$VQ2,126:$VR2,128:$VS2,130:$VT2,132:443,134:444,136:$VU2,138:$VV2,140:$VW2,142:$VX2,143:$VY2,144:$VZ2,145:$V_2,146:$V$2,147:$V03,149:$V13,159:$V23,161:$V33,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,367:168,368:$Vg1,372:$Vh1},{67:$Vx4,71:[1,980]},{67:$Vx4,71:[1,981]},{67:$Vx4,71:[1,982]},{67:$Vx4,71:[1,983]},{71:[1,984],127:642,153:$VB3,154:$VC3,155:$VD3},{67:$VH3,71:[1,985]},{3:411,4:$V1,5:$V2,65:$Vq2,67:[1,986],69:$Vr2,70:$Vs2,90:$Vt2,92:987,93:$Vu2,97:$Vv2,98:$Vw2,99:$Vx2,104:$Vy2,105:$Vz2,106:$VA2,107:$VB2,108:$VC2,109:$VD2,110:$VE2,111:$VF2,112:$VG2,113:$VH2,114:$VI2,115:$VJ2,116:$VK2,117:$VL2,118:433,119:$VM2,120:$VN2,122:$VO2,123:$VP2,124:$VQ2,126:$VR2,128:$VS2,130:$VT2,132:443,134:444,136:$VU2,138:$VV2,140:$VW2,142:$VX2,143:$VY2,144:$VZ2,145:$V_2,146:$V$2,147:$V03,149:$V13,159:$V23,161:$V33,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,367:168,368:$Vg1,372:$Vh1},{3:988,4:$V1,5:$V2},{3:989,4:$V1,5:$V2},o($VH,[2,534]),{3:990,4:$V1,5:$V2},{91:991,107:$VO,256:$Va1},{71:[1,992]},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:993,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:638,4:$V1,5:$V2,89:692,116:$VF3,119:$VG3,288:994,289:693},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:995,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{99:[1,996]},o($VH,[2,590],{278:322,90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72}),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:997,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:853,4:$V1,5:$V2,70:$V34,106:$V44,381:998},o($Vz4,[2,595]),o($Vz4,[2,596]),o($Vz4,[2,597]),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:999,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($VI3,[2,247]),o($VI3,[2,249]),o($VI3,[2,251]),o($VI3,[2,253]),o($Vt1,[2,139]),o($VH,[2,506]),{122:[1,1e3]},o($VH,[2,507]),o($V73,[2,477],{236:1001,4:$Vj3,336:[1,1002],338:$Vk3}),o($VH,[2,508]),o($VH,[2,510]),{67:$V63,71:[1,1003]},o($VH,[2,514]),o($VH,[2,518]),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:235,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,125:1004,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:1005,4:$V1,5:$V2},o($VH,[2,520]),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,95:1006,100:957,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,214:955,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{70:[1,1007]},{3:1008,4:$V1,5:$V2},{69:$VJ3,114:[2,780],429:1009,432:1010},o($V74,[2,779]),o($V73,[2,671]),o($V84,[2,675]),o($V84,[2,791]),{3:1011,4:$V1,5:$V2},{3:864,4:$V1,5:$V2,69:[1,1014],302:1012,309:1013,334:1015},{3:638,4:$V1,5:$V2,89:793,204:1016},{36:1017,72:67,81:$V6,158:92,163:$Va},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:1018,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($VV3,[2,658]),{3:638,4:$V1,5:$V2,89:692,116:$VF3,119:$VG3,121:1019,288:691,289:693},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:235,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,125:1020,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($VV3,[2,663]),o($VE1,[2,627],{278:322,90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72}),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:1021,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{67:[1,1022],71:[1,1023]},o($Vy4,[2,485]),o($Vy4,[2,486]),{106:$Vc4,247:$Vd4,337:1024},{67:$VA4,71:[1,1025]},o($Vy4,[2,421],{278:322,90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72}),o($Vn1,[2,349]),o($Vn1,[2,353]),{71:[1,1027]},{67:$V63,71:[1,1028]},o($Vn1,[2,374]),o($Vn1,[2,376]),{71:[1,1029],90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,278:322,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72},{71:[1,1030]},{67:$V63,71:[1,1031]},o($Vn1,[2,379]),o($Vn1,[2,298]),{70:[1,1032]},o($Vn1,$Ve4,{239:1033,240:$Vf4}),o($Vn1,$Ve4,{239:1034,240:$Vf4}),o($Va2,[2,316]),o($VT3,[2,259]),o($Vn1,[2,256]),o($Vn1,[2,332]),o($Vs3,[2,336],{278:322,90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72}),{67:[1,1036],71:[1,1035]},{67:[1,1038],71:[1,1037],90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,278:322,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72},{3:913,4:$V1,5:$V2},{70:[1,1039],116:$VQ,118:1040,119:$Vo1,126:$VS,155:$VW,175:1041,260:$Vd1,367:168,368:$Vg1,372:$Vh1},{67:$VA4,71:[1,1042]},{36:1044,72:67,81:$V6,123:[1,1043],158:92,163:$Va},{3:638,4:$V1,5:$V2,89:1045},o($VH,[2,630]),o($Vk4,[2,635]),o($Vk4,[2,636]),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:489,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,148:1046,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,221:488,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{144:[1,1048],267:[1,1047]},{409:[1,1049]},o($Vj2,[2,158]),o($VB4,[2,235],{78:1050,93:[1,1051]}),{94:[1,1052]},o($VX3,[2,215],{278:322,90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72}),o($Vy3,[2,148],{188:938,193:941,187:1053,179:1054,180:$Vn4,182:$Vo4,194:$Vp4,195:$Vq4,196:$Vr4,197:$Vs4,198:$Vt4,199:$Vu4,200:$Vv4,201:$Vw4}),{3:193,4:$V1,5:$V2,70:$Vj1,107:$Vk1,116:$VQ,118:187,119:$VR,126:$VS,155:$VW,173:188,174:190,175:189,176:191,183:1055,186:192,260:$Vd1,367:168,368:$Vg1,372:$Vh1},o($VC4,[2,181]),o($VC4,[2,182]),{3:193,4:$V1,5:$V2,70:[1,1060],116:$VQ,118:1058,119:$VR,126:$VS,155:$VW,173:1057,174:1061,175:1059,176:1062,189:1056,260:$Vd1,367:168,368:$Vg1,372:$Vh1},{181:[1,1063],195:$VD4},{181:[1,1065],195:$VE4},o($VF4,[2,198]),{180:[1,1069],182:[1,1068],193:1067,195:$Vq4,196:$Vr4,197:$Vs4,198:$Vt4,199:$Vu4,200:$Vv4,201:$Vw4},o($VF4,[2,200]),{195:[1,1070]},{182:[1,1072],195:[1,1071]},{182:[1,1074],195:[1,1073]},{182:[1,1075]},{195:[1,1076]},{195:[1,1077]},{67:$Vm4,178:1078,179:937,180:$Vn4,182:$Vo4,187:936,188:938,193:941,194:$Vp4,195:$Vq4,196:$Vr4,197:$Vs4,198:$Vt4,199:$Vu4,200:$Vv4,201:$Vw4},o($VY3,[2,67]),o($VE3,[2,80]),{67:$VG4,71:[1,1079]},{71:[1,1081]},o($VH4,[2,237]),{71:[2,699]},o($VH4,[2,239],{278:322,90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,215:[1,1082],216:[1,1083],269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72}),o($VE3,[2,79]),o($VZ3,[2,703],{127:642,153:$VB3,154:$VC3,155:$VD3}),o($VE3,[2,81]),o($VE3,[2,82]),o($VE3,[2,99]),o($VE3,[2,102]),o($VE3,[2,105]),o($VZ3,[2,707],{127:642,153:$VB3,154:$VC3,155:$VD3}),o($VE3,[2,106]),o($VZ3,[2,709],{127:642,153:$VB3,154:$VC3,155:$VD3}),o($VE3,[2,107]),o($VZ3,[2,711],{127:642,153:$VB3,154:$VC3,155:$VD3}),o($VE3,[2,108]),o($VZ3,[2,715],{127:642,153:$VB3,154:$VC3,155:$VD3}),o($VE3,[2,109]),o($V_3,[2,722],{151:1084}),o($V_3,[2,725],{127:642,153:$VB3,154:$VC3,155:$VD3}),{67:$Vx4,71:[1,1085]},o($VE3,[2,111]),o($VZ3,[2,717],{127:642,153:$VB3,154:$VC3,155:$VD3}),o($VE3,[2,112]),o($VZ3,[2,719],{127:642,153:$VB3,154:$VC3,155:$VD3}),o($VE3,[2,113]),o($VE3,[2,114]),o($VE3,[2,115]),o($VE3,[2,116]),o($VE3,[2,117]),o($VE3,[2,118]),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:235,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,125:1086,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($V04,[2,721],{127:642,153:$VB3,154:$VC3,155:$VD3}),o($VH,[2,544]),o($VH,[2,540]),o($VH,[2,542]),o($VH,[2,538]),o($V43,[2,63]),o($VH,[2,400],{278:322,90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72}),o($V24,[2,403]),o($V24,[2,404],{278:322,90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72}),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:1087,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($VH,[2,591],{278:322,90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72}),o($Vz4,[2,594]),{71:[1,1088],90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,278:322,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72},{3:1089,4:$V1,5:$V2},o($V73,[2,487],{335:1090,339:1091,340:1092,317:1100,128:$VI4,161:$VJ4,257:$VK4,294:$VL4,307:$VM4,319:$VN4,320:$VO4,324:$VP4,325:$VQ4}),o($V73,[2,476]),o($VH,[2,513],{69:[1,1103]}),{67:$V63,71:[1,1104]},o($VH,[2,522]),{67:$VG4,71:[1,1105]},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,95:1106,100:957,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,214:955,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($VL3,[2,673]),{114:[1,1107]},{114:[2,781]},o($V84,[2,676]),{71:[1,1108]},{67:[1,1109],71:[2,447]},{36:1110,72:67,81:$V6,158:92,163:$Va},o($Vy4,[2,473]),{67:$Vi4,71:[1,1111]},o($VH,[2,762],{359:1112,360:1113,65:$VR4}),o($VV3,$V94,{72:67,158:92,278:322,36:889,417:1115,81:$V6,90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,120:$Va4,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,163:$Va,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72,419:$Vb4}),o($VV3,[2,661],{67:$V14}),o($VV3,[2,662],{67:$V63}),o($VE1,[2,628],{278:322,90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72}),{106:[1,1116]},o($VS4,[2,480]),{67:[1,1117],71:[1,1118]},o($VS4,[2,484]),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:1119,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($Vn1,[2,365]),o($Vn1,[2,366]),o($Vn1,[2,390]),o($Vn1,[2,375]),o($Vn1,[2,377]),{93:$VT4,241:1120,242:1121,243:[1,1122]},o($Vn1,[2,299]),o($Vn1,[2,300]),o($Vn1,[2,287]),{106:[1,1124]},o($Vn1,[2,289]),{106:[1,1125]},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:897,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,295:1126,367:168,368:$Vg1,372:$Vh1},o($Vh4,[2,419]),o($Vh4,[2,420]),o($Vh4,[2,415]),{70:$VU3,116:$VQ,118:789,119:$Vo1,126:$VS,155:$VW,175:790,260:$Vd1,293:1127,367:168,368:$Vg1,372:$Vh1},o($VV3,[2,412]),o($Vj4,[2,430]),o($VH,[2,654],{67:$VH3,172:[1,1128]}),{287:$VU4,290:$VV4,410:1129},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:1132,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{94:[1,1134],144:[1,1135],267:[1,1133]},o($VW4,[2,243],{79:1136,218:[1,1137]}),{94:[1,1138]},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:1144,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,206:1139,208:1140,209:$VX4,210:$VY4,211:$VZ4,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($VC4,[2,179]),o($VC4,[2,180]),o($Vj4,[2,156]),o($VC4,[2,213],{190:1145,202:[1,1146],203:[1,1147]}),o($V_4,[2,184],{3:1148,4:$V1,5:$V2,69:[1,1149]}),o($V$4,[2,734],{191:1150,69:[1,1151]}),{3:1152,4:$V1,5:$V2,69:[1,1153]},{36:1154,72:67,81:$V6,158:92,163:$Va},o($V_4,[2,192],{3:1155,4:$V1,5:$V2,69:[1,1156]}),o($V_4,[2,195],{3:1157,4:$V1,5:$V2,69:[1,1158]}),{70:[1,1159]},o($VF4,[2,210]),{70:[1,1160]},o($VF4,[2,206]),o($VF4,[2,199]),{195:$VE4},{195:$VD4},o($VF4,[2,201]),o($VF4,[2,202]),{195:[1,1161]},o($VF4,[2,204]),{195:[1,1162]},{195:[1,1163]},o($VF4,[2,208]),o($VF4,[2,209]),{71:[1,1164],179:1054,180:$Vn4,182:$Vo4,187:1053,188:938,193:941,194:$Vp4,195:$Vq4,196:$Vr4,197:$Vs4,198:$Vt4,199:$Vu4,200:$Vv4,201:$Vw4},o($VE3,[2,72]),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:957,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,214:1165,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($VE3,[2,73]),o($VH4,[2,240]),{217:[1,1166]},o($Vy4,[2,120],{367:168,3:411,118:433,132:443,134:444,92:1167,4:$V1,5:$V2,65:$Vq2,69:$Vr2,70:$Vs2,90:$Vt2,93:$Vu2,97:$Vv2,98:$Vw2,99:$Vx2,104:$Vy2,105:$Vz2,106:$VA2,107:$VB2,108:$VC2,109:$VD2,110:$VE2,111:$VF2,112:$VG2,113:$VH2,114:$VI2,115:$VJ2,116:$VK2,117:$VL2,119:$VM2,120:$VN2,122:$VO2,123:$VP2,124:$VQ2,126:$VR2,128:$VS2,130:$VT2,136:$VU2,138:$VV2,140:$VW2,142:$VX2,143:$VY2,144:$VZ2,145:$V_2,146:$V$2,147:$V03,149:$V13,159:$V23,161:$V33,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,368:$Vg1,372:$Vh1}),o($VE3,[2,110]),{67:$V63,71:[1,1168]},o($V24,[2,405],{278:322,90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72}),o($Vz4,[2,598]),o($VH,[2,509]),o($V73,[2,475]),o($V73,[2,488],{317:1100,340:1169,128:$VI4,161:$VJ4,257:$VK4,294:$VL4,307:$VM4,319:$VN4,320:$VO4,324:$VP4,325:$VQ4}),o($V53,[2,490]),{321:[1,1170]},{321:[1,1171]},{3:217,4:$V1,5:$V2,173:1172},o($V53,[2,496],{70:[1,1173]}),{3:231,4:$V1,5:$V2,70:[1,1175],91:225,106:$VN,107:$VO,116:$VQ,126:$VS,155:$VW,170:224,174:229,175:228,225:226,226:227,232:$Vp1,238:1174,254:$V81,255:$V91,256:$Va1,257:$Vb1,260:$Vd1},o($V53,[2,499]),{257:[1,1176]},o($V53,[2,501]),o($V53,[2,502]),{70:[1,1177]},{3:1178,4:$V1,5:$V2},o($VH,$V54,{354:1179,69:$V64}),o($VH,[2,528]),{67:$VG4,71:[1,1180]},o([8,67,71,107,112,126,264,268,450,451],$VC1,{434:280,379:282,3:734,430:1181,424:1182,431:1183,4:$V1,5:$V2,116:$Vr1,119:$Vs1}),o($VH,[2,435],{303:1184,305:1185,306:1186,4:$V05,294:$V15,307:$V25}),o($V35,$V45,{3:864,310:1190,334:1191,311:1192,312:1193,4:$V1,5:$V2,318:$V55}),{71:[2,448]},{69:[1,1195]},o($VH,[2,546]),o($VH,[2,763]),{319:[1,1197],361:[1,1196]},o($VV3,[2,664]),{71:[1,1198]},{106:[1,1199]},o($VS4,[2,481]),o($Vy4,[2,422],{278:322,90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72}),{71:[1,1200],93:$VT4,242:1201},{71:[1,1202]},{94:[1,1203]},{94:[1,1204]},{71:[1,1205]},{71:[1,1206]},{67:$VA4,71:[1,1207]},o($VV3,[2,410],{67:$Vg4}),{3:217,4:$V1,5:$V2,116:$Vr1,119:$Vs1,173:1209,379:1208},o($Vk4,[2,639]),o($Vk4,[2,641]),{120:[1,1210]},{90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,267:[1,1211],269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,278:322,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72},{291:$V65,411:1212},{365:[1,1215],412:[1,1214]},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:1216,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($VA3,[2,226],{80:1217,136:[1,1218],142:[1,1220],143:[1,1219]}),{106:$VN,170:1221},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,95:1222,100:957,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,214:955,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($Vl4,[2,224],{207:1223,67:$V75,212:[1,1225]}),o($V85,[2,218]),{120:[1,1226]},{70:[1,1227]},{70:[1,1228]},o($V85,[2,223],{278:322,90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72}),o($VC4,[2,183]),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:1229,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:638,4:$V1,5:$V2,89:793,204:1230},o($V_4,[2,185]),{3:1231,4:$V1,5:$V2},o($V_4,[2,736],{192:1232,3:1233,4:$V1,5:$V2}),o($V$4,[2,735]),o($V_4,[2,188]),{3:1234,4:$V1,5:$V2},{71:[1,1235]},o($V_4,[2,193]),{3:1236,4:$V1,5:$V2},o($V_4,[2,196]),{3:1237,4:$V1,5:$V2},{36:1238,72:67,81:$V6,158:92,163:$Va},{36:1239,72:67,81:$V6,158:92,163:$Va},o($VF4,[2,203]),o($VF4,[2,205]),o($VF4,[2,207]),o($Vy3,[2,149]),o($VH4,[2,238]),o($VH4,[2,241],{215:[1,1240]}),o($V_3,[2,723],{127:642,153:$VB3,154:$VC3,155:$VD3}),o($VE3,[2,119]),o($V53,[2,489]),o($V53,[2,492]),{325:[1,1241]},o($V53,[2,756],{343:1242,341:1243,70:$V95}),{106:$VN,170:1245},o($V53,[2,497]),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:1246,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($V53,[2,500]),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:1247,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($VH,[2,515]),o($VH,[2,519]),o($VH,[2,529]),o($V73,[2,670]),o($V73,[2,782]),o($V73,[2,783]),o($VH,[2,431]),o($VH,[2,436],{306:1248,4:$V05,294:$V15,307:$V25}),o($Va5,[2,438]),o($Va5,[2,439]),{99:[1,1249]},{99:[1,1250]},{67:[1,1251],71:[2,446]},o($Vy4,[2,474]),o($Vy4,[2,449]),{161:[1,1259],167:[1,1260],313:1252,314:1253,315:1254,316:1255,317:1256,319:$VN4,320:[1,1257],321:[1,1261],324:[1,1258]},{3:1262,4:$V1,5:$V2},{36:1263,72:67,81:$V6,158:92,163:$Va},{362:[1,1264]},{363:[1,1265]},o($VS4,[2,478]),{71:[1,1266]},o($Vn1,[2,302]),{71:[1,1267]},o($Vn1,[2,303]),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:1144,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,206:1268,208:1140,209:$VX4,210:$VY4,211:$VZ4,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,95:1269,100:957,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,214:955,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($Vn1,[2,288]),o($Vn1,[2,290]),o($Vh4,[2,418]),{3:1270,4:$V1,5:$V2},o($VH,[2,656],{70:[1,1271]}),{3:638,4:$V1,5:$V2,89:692,116:$VF3,119:$VG3,121:1272,288:691,289:693},{287:$VU4,290:$VV4,410:1273},o($Vk4,[2,643]),{70:[1,1275],123:[1,1274],294:[1,1276]},{144:[1,1278],267:[1,1277]},{144:[1,1280],267:[1,1279]},{90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,267:[1,1281],269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,278:322,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72},o($VA3,[2,64]),{36:1282,72:67,81:$V6,138:[1,1283],158:92,163:$Va,213:[1,1284]},{36:1285,72:67,81:$V6,158:92,163:$Va,213:[1,1286]},{36:1287,72:67,81:$V6,158:92,163:$Va,213:[1,1288]},o($VW4,[2,245],{219:1289,220:[1,1290]}),o($VB4,[2,236],{67:$VG4}),o($Vl4,[2,217]),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:1144,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,208:1291,209:$VX4,210:$VY4,211:$VZ4,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:1292,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{70:[1,1293]},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:1144,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,206:1294,208:1140,209:$VX4,210:$VY4,211:$VZ4,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:1144,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,206:1295,208:1140,209:$VX4,210:$VY4,211:$VZ4,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},o($VC4,[2,211],{278:322,90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72}),o($VC4,[2,212],{67:$Vi4}),o($V_4,[2,186]),o($V_4,[2,187]),o($V_4,[2,737]),o($V_4,[2,189]),{3:1296,4:$V1,5:$V2,69:[1,1297]},o($V_4,[2,194]),o($V_4,[2,197]),{71:[1,1298]},{71:[1,1299]},o($VH4,[2,242]),{3:217,4:$V1,5:$V2,173:1300},o($V53,[2,494]),o($V53,[2,757]),{3:1301,4:$V1,5:$V2},{67:[1,1302]},{71:[1,1303],90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,278:322,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72},{71:[1,1304],90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,278:322,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72},o($Va5,[2,437]),{3:1305,4:$V1,5:$V2},{106:$VN,170:1306},o($V35,$V45,{312:1193,311:1307,318:$V55}),o($V73,[2,451]),o($V73,[2,452]),o($V73,[2,453]),o($V73,[2,454]),o($V73,[2,455]),{321:[1,1308]},{321:[1,1309]},{3:1311,4:$V1,5:$V2,70:[2,752],333:1310},{3:1312,4:$V1,5:$V2},{3:1313,4:$V1,5:$V2},o($V35,[2,457]),o($VH,[2,760],{358:1314,360:1315,65:$VR4}),o($VH,[2,547]),o($VH,[2,548],{318:[1,1316]}),o($VS4,[2,479]),o($Vn1,[2,304]),o([71,93],[2,305],{67:$V75}),{67:$VG4,71:[2,306]},o($VH,[2,655]),{3:638,4:$V1,5:$V2,89:793,204:1317},o($Vk4,[2,642],{67:$V14}),o($Vk4,[2,640]),{70:$VU3,116:$VQ,118:789,119:$Vo1,126:$VS,155:$VW,175:790,260:$Vd1,293:1318,367:168,368:$Vg1,372:$Vh1},{3:638,4:$V1,5:$V2,89:793,204:1319},{123:[1,1320]},{291:$V65,411:1321},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:1322,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{291:$V65,411:1323},{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:1324,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{291:$V65,411:1325},o($VA3,[2,227]),{36:1326,72:67,81:$V6,158:92,163:$Va,213:[1,1327]},{36:1328,72:67,81:$V6,158:92,163:$Va},o($VA3,[2,229]),{36:1329,72:67,81:$V6,158:92,163:$Va},o($VA3,[2,230]),{36:1330,72:67,81:$V6,158:92,163:$Va},o($VW4,[2,244]),{106:$VN,170:1331},o($V85,[2,219]),o($Vl4,[2,225],{278:322,90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72}),{3:147,4:$V1,5:$V2,51:144,70:$VM,89:130,91:134,100:1144,106:$VN,107:$VO,112:$VP,116:$VQ,118:141,119:$VR,126:$VS,128:$VT,132:146,153:$VU,154:$VV,155:$VW,170:132,174:128,175:136,176:137,206:1332,208:1140,209:$VX4,210:$VY4,211:$VZ4,222:131,223:127,224:129,225:133,226:135,227:138,228:139,229:140,230:142,232:$VX,233:$Vb,234:$VY,235:$VZ,237:$V_,244:$V$,245:$V01,246:$V11,247:$V21,248:$V31,249:$V41,250:$V51,251:$V61,252:$V71,254:$V81,255:$V91,256:$Va1,257:$Vb1,258:$Vc1,260:$Vd1,261:$Ve1,270:$Vf1,367:168,368:$Vg1,372:$Vh1},{67:$V75,71:[1,1333]},{67:$V75,71:[1,1334]},o($V_4,[2,190]),{3:1335,4:$V1,5:$V2},{3:1336,4:$V1,5:$V2,69:[1,1337]},{3:1338,4:$V1,5:$V2,69:[1,1339]},o($V53,[2,754],{342:1340,341:1341,70:$V95}),{71:[1,1342]},{106:$VN,170:1343},o($V53,[2,498]),o($V53,[2,458]),o($Va5,[2,440]),o($Va5,[2,441]),o($Vy4,[2,450]),{3:1345,4:$V1,5:$V2,70:[2,748],322:1344},{70:[1,1346]},{70:[1,1347]},{70:[2,753]},{70:[1,1348]},{70:[1,1349]},o($VH,[2,545]),o($VH,[2,761]),o($V35,$V45,{312:1193,311:1350,318:$V55}),{67:$Vi4,71:[1,1351]},o($Vk4,[2,649],{67:$Vg4}),{67:$Vi4,71:[1,1352]},o($Vk4,[2,651]),o($Vk4,[2,644]),{90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,267:[1,1353],269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,278:322,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72},o($Vk4,[2,647]),{90:$VI1,97:$VJ1,98:$VK1,99:$V83,108:$VM1,111:$VN1,113:$VO1,114:$VP1,115:$VQ1,128:$VR1,144:$VS1,145:$VT1,153:$VU1,154:$VV1,267:[1,1354],269:$VW1,270:$VX1,271:$VY1,272:$VZ1,273:$V_1,274:$V$1,275:$V02,276:$V12,277:$V22,278:322,280:$V32,282:$V42,283:$V52,284:$V62,285:$V72},o($Vk4,[2,645]),o($VA3,[2,228]),{36:1355,72:67,81:$V6,158:92,163:$Va},o($VA3,[2,231]),o($VA3,[2,233]),o($VA3,[2,234]),o($VW4,[2,246]),{67:$V75,71:[1,1356]},o($V85,[2,221]),o($V85,[2,222]),o($V_4,[2,191]),o($VC4,[2,151]),{3:1357,4:$V1,5:$V2},o($VC4,[2,153]),{3:1358,4:$V1,5:$V2},o($V53,[2,493]),o($V53,[2,755]),o($V53,[2,491]),{71:[1,1359]},{70:[1,1360]},{70:[2,749]},{3:1362,4:$V1,5:$V2,107:$Vb5,323:1361},{3:638,4:$V1,5:$V2,89:793,204:1364},{3:638,4:$V1,5:$V2,89:793,204:1365},{3:638,4:$V1,5:$V2,89:793,204:1366},o($VH,[2,549]),o($VH,[2,657]),{123:[1,1367],294:[1,1368]},{291:$V65,411:1369},{287:$VU4,290:$VV4,410:1370},o($VA3,[2,232]),o($V85,[2,220]),o($VC4,[2,152]),o($VC4,[2,154]),o($V53,[2,495]),{3:1362,4:$V1,5:$V2,107:$Vb5,323:1371},{67:$Vc5,71:[1,1372]},o($Vy4,[2,469]),o($Vy4,[2,470]),{67:$Vi4,71:[1,1374]},{67:$Vi4,71:[1,1375]},{67:$Vi4,71:[1,1376]},{70:$VU3,116:$VQ,118:789,119:$Vo1,126:$VS,155:$VW,175:790,260:$Vd1,293:1377,367:168,368:$Vg1,372:$Vh1},{123:[1,1378]},o($Vk4,[2,646]),o($Vk4,[2,648]),{67:$Vc5,71:[1,1379]},{325:[1,1380]},{3:1381,4:$V1,5:$V2,107:[1,1382]},o($V73,[2,466]),o($V73,[2,467]),o($V73,[2,468]),o($Vk4,[2,650],{67:$Vg4}),o($Vk4,[2,652]),o($V73,[2,459]),{3:217,4:$V1,5:$V2,173:1383},o($Vy4,[2,471]),o($Vy4,[2,472]),o($Vd5,[2,750],{326:1384,328:1385,70:[1,1386]}),o($V73,[2,462],{327:1387,329:1388,202:[1,1389]}),o($Vd5,[2,751]),{3:1362,4:$V1,5:$V2,107:$Vb5,323:1390},o($V73,[2,460]),{202:[1,1392],330:1391},{290:[1,1393]},{67:$Vc5,71:[1,1394]},o($V73,[2,463]),{287:[1,1395]},{331:[1,1396]},o($Vd5,[2,461]),{331:[1,1397]},{332:[1,1398]},{332:[1,1399]},{202:[2,464]},o($V73,[2,465])],defaultActions:{97:[2,3],171:[2,307],172:[2,308],173:[2,309],174:[2,310],175:[2,311],176:[2,312],177:[2,313],178:[2,314],179:[2,315],184:[2,631],281:[2,777],288:[2,771],335:[2,738],336:[2,739],389:[2,632],455:[2,712],456:[2,713],560:[2,397],561:[2,398],562:[2,399],615:[2,633],956:[2,699],1010:[2,781],1110:[2,448],1311:[2,753],1345:[2,749],1398:[2,464]},parseError:function parseError(str,hash){if(hash.recoverable){this.trace(str)
}else{throw new Error(str)}},parse:function parse(input){var self=this,stack=[0],tstack=[],vstack=[null],lstack=[],table=this.table,yytext="",yylineno=0,yyleng=0,recovering=0,TERROR=2,EOF=1;var args=lstack.slice.call(arguments,1);var lexer=Object.create(this.lexer);var sharedState={yy:{}};for(var k in this.yy){if(Object.prototype.hasOwnProperty.call(this.yy,k)){sharedState.yy[k]=this.yy[k]}}lexer.setInput(input,sharedState.yy);sharedState.yy.lexer=lexer;sharedState.yy.parser=this;if(typeof lexer.yylloc=="undefined"){lexer.yylloc={}}var yyloc=lexer.yylloc;lstack.push(yyloc);var ranges=lexer.options&&lexer.options.ranges;if(typeof sharedState.yy.parseError==="function"){this.parseError=sharedState.yy.parseError}else{this.parseError=Object.getPrototypeOf(this).parseError}function popStack(n){stack.length=stack.length-2*n;vstack.length=vstack.length-n;lstack.length=lstack.length-n}_token_stack:function lex(){var token;token=lexer.lex()||EOF;if(typeof token!=="number"){token=self.symbols_[token]||token}return token}var symbol,preErrorSymbol,state,action,a,r,yyval={},p,len,newState,expected;while(true){state=stack[stack.length-1];if(this.defaultActions[state]){action=this.defaultActions[state]}else{if(symbol===null||typeof symbol=="undefined"){symbol=lex()}action=table[state]&&table[state][symbol]}if(typeof action==="undefined"||!action.length||!action[0]){var errStr="";expected=[];for(p in table[state]){if(this.terminals_[p]&&p>TERROR){expected.push("'"+this.terminals_[p]+"'")}}if(lexer.showPosition){errStr="Parse error on line "+(yylineno+1)+":\n"+lexer.showPosition()+"\nExpecting "+expected.join(", ")+", got '"+(this.terminals_[symbol]||symbol)+"'"}else{errStr="Parse error on line "+(yylineno+1)+": Unexpected "+(symbol==EOF?"end of input":"'"+(this.terminals_[symbol]||symbol)+"'")}this.parseError(errStr,{text:lexer.match,token:this.terminals_[symbol]||symbol,line:lexer.yylineno,loc:yyloc,expected:expected})}if(action[0]instanceof Array&&action.length>1){throw new Error("Parse Error: multiple actions possible at state: "+state+", token: "+symbol)}switch(action[0]){case 1:stack.push(symbol);vstack.push(lexer.yytext);lstack.push(lexer.yylloc);stack.push(action[1]);symbol=null;if(!preErrorSymbol){yyleng=lexer.yyleng;yytext=lexer.yytext;yylineno=lexer.yylineno;yyloc=lexer.yylloc;if(recovering>0){recovering--}}else{symbol=preErrorSymbol;preErrorSymbol=null}break;case 2:len=this.productions_[action[1]][1];yyval.$=vstack[vstack.length-len];yyval._$={first_line:lstack[lstack.length-(len||1)].first_line,last_line:lstack[lstack.length-1].last_line,first_column:lstack[lstack.length-(len||1)].first_column,last_column:lstack[lstack.length-1].last_column};if(ranges){yyval._$.range=[lstack[lstack.length-(len||1)].range[0],lstack[lstack.length-1].range[1]]}r=this.performAction.apply(yyval,[yytext,yyleng,yylineno,sharedState.yy,action[1],vstack,lstack].concat(args));if(typeof r!=="undefined"){return r}if(len){stack=stack.slice(0,-1*len*2);vstack=vstack.slice(0,-1*len);lstack=lstack.slice(0,-1*len)}stack.push(this.productions_[action[1]][0]);vstack.push(yyval.$);lstack.push(yyval._$);newState=table[stack[stack.length-2]][stack[stack.length-1]];stack.push(newState);break;case 3:return true}}return true}};var lexer=function(){var lexer={EOF:1,parseError:function parseError(str,hash){if(this.yy.parser){this.yy.parser.parseError(str,hash)}else{throw new Error(str)}},setInput:function(input,yy){this.yy=yy||this.yy||{};this._input=input;this._more=this._backtrack=this.done=false;this.yylineno=this.yyleng=0;this.yytext=this.matched=this.match="";this.conditionStack=["INITIAL"];this.yylloc={first_line:1,first_column:0,last_line:1,last_column:0};if(this.options.ranges){this.yylloc.range=[0,0]}this.offset=0;return this},input:function(){var ch=this._input[0];this.yytext+=ch;this.yyleng++;this.offset++;this.match+=ch;this.matched+=ch;var lines=ch.match(/(?:\r\n?|\n).*/g);if(lines){this.yylineno++;this.yylloc.last_line++}else{this.yylloc.last_column++}if(this.options.ranges){this.yylloc.range[1]++}this._input=this._input.slice(1);return ch},unput:function(ch){var len=ch.length;var lines=ch.split(/(?:\r\n?|\n)/g);this._input=ch+this._input;this.yytext=this.yytext.substr(0,this.yytext.length-len);this.offset-=len;var oldLines=this.match.split(/(?:\r\n?|\n)/g);this.match=this.match.substr(0,this.match.length-1);this.matched=this.matched.substr(0,this.matched.length-1);if(lines.length-1){this.yylineno-=lines.length-1}var r=this.yylloc.range;this.yylloc={first_line:this.yylloc.first_line,last_line:this.yylineno+1,first_column:this.yylloc.first_column,last_column:lines?(lines.length===oldLines.length?this.yylloc.first_column:0)+oldLines[oldLines.length-lines.length].length-lines[0].length:this.yylloc.first_column-len};if(this.options.ranges){this.yylloc.range=[r[0],r[0]+this.yyleng-len]}this.yyleng=this.yytext.length;return this},more:function(){this._more=true;return this},reject:function(){if(this.options.backtrack_lexer){this._backtrack=true}else{return this.parseError("Lexical error on line "+(this.yylineno+1)+". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n"+this.showPosition(),{text:"",token:null,line:this.yylineno})}return this},less:function(n){this.unput(this.match.slice(n))},pastInput:function(){var past=this.matched.substr(0,this.matched.length-this.match.length);return(past.length>20?"...":"")+past.substr(-20).replace(/\n/g,"")},upcomingInput:function(){var next=this.match;if(next.length<20){next+=this._input.substr(0,20-next.length)}return(next.substr(0,20)+(next.length>20?"...":"")).replace(/\n/g,"")},showPosition:function(){var pre=this.pastInput();var c=new Array(pre.length+1).join("-");return pre+this.upcomingInput()+"\n"+c+"^"},test_match:function(match,indexed_rule){var token,lines,backup;if(this.options.backtrack_lexer){backup={yylineno:this.yylineno,yylloc:{first_line:this.yylloc.first_line,last_line:this.last_line,first_column:this.yylloc.first_column,last_column:this.yylloc.last_column},yytext:this.yytext,match:this.match,matches:this.matches,matched:this.matched,yyleng:this.yyleng,offset:this.offset,_more:this._more,_input:this._input,yy:this.yy,conditionStack:this.conditionStack.slice(0),done:this.done};if(this.options.ranges){backup.yylloc.range=this.yylloc.range.slice(0)}}lines=match[0].match(/(?:\r\n?|\n).*/g);if(lines){this.yylineno+=lines.length}this.yylloc={first_line:this.yylloc.last_line,last_line:this.yylineno+1,first_column:this.yylloc.last_column,last_column:lines?lines[lines.length-1].length-lines[lines.length-1].match(/\r?\n?/)[0].length:this.yylloc.last_column+match[0].length};this.yytext+=match[0];this.match+=match[0];this.matches=match;this.yyleng=this.yytext.length;if(this.options.ranges){this.yylloc.range=[this.offset,this.offset+=this.yyleng]}this._more=false;this._backtrack=false;this._input=this._input.slice(match[0].length);this.matched+=match[0];token=this.performAction.call(this,this.yy,this,indexed_rule,this.conditionStack[this.conditionStack.length-1]);if(this.done&&this._input){this.done=false}if(token){return token}else if(this._backtrack){for(var k in backup){this[k]=backup[k]}return false}return false},next:function(){if(this.done){return this.EOF}if(!this._input){this.done=true}var token,match,tempMatch,index;if(!this._more){this.yytext="";this.match=""}var rules=this._currentRules();for(var i=0;i<rules.length;i++){tempMatch=this._input.match(this.rules[rules[i]]);if(tempMatch&&(!match||tempMatch[0].length>match[0].length)){match=tempMatch;index=i;if(this.options.backtrack_lexer){token=this.test_match(tempMatch,rules[i]);if(token!==false){return token}else if(this._backtrack){match=false;continue}else{return false}}else if(!this.options.flex){break}}}if(match){token=this.test_match(match,rules[index]);if(token!==false){return token}return false}if(this._input===""){return this.EOF}else{return this.parseError("Lexical error on line "+(this.yylineno+1)+". Unrecognized text.\n"+this.showPosition(),{text:"",token:null,line:this.yylineno})}},lex:function lex(){var r=this.next();if(r){return r}else{return this.lex()}},begin:function begin(condition){this.conditionStack.push(condition)},popState:function popState(){var n=this.conditionStack.length-1;if(n>0){return this.conditionStack.pop()}else{return this.conditionStack[0]}},_currentRules:function _currentRules(){if(this.conditionStack.length&&this.conditionStack[this.conditionStack.length-1]){return this.conditions[this.conditionStack[this.conditionStack.length-1]].rules}else{return this.conditions["INITIAL"].rules}},topState:function topState(n){n=this.conditionStack.length-1-Math.abs(n||0);if(n>=0){return this.conditionStack[n]}else{return"INITIAL"}},pushState:function pushState(condition){this.begin(condition)},stateStackSize:function stateStackSize(){return this.conditionStack.length},options:{"case-insensitive":true},performAction:function anonymous(yy,yy_,$avoiding_name_collisions,YY_START){var YYSTATE=YY_START;switch($avoiding_name_collisions){case 0:return 233;break;case 1:return 260;break;case 2:return 368;break;case 3:return 5;break;case 4:return 5;break;case 5:return 256;break;case 6:return 256;break;case 7:return 107;break;case 8:return 107;break;case 9:return;break;case 10:break;case 11:return 145;break;case 12:return 144;break;case 13:yy_.yytext="VALUE";return 163;break;case 14:yy_.yytext="ROW";return 163;break;case 15:yy_.yytext="COLUMN";return 163;break;case 16:yy_.yytext="MATRIX";return 163;break;case 17:yy_.yytext="INDEX";return 163;break;case 18:yy_.yytext="RECORDSET";return 163;break;case 19:yy_.yytext="TEXT";return 163;break;case 20:yy_.yytext="SELECT";return 163;break;case 21:return"ABSOLUTE";break;case 22:return 332;break;case 23:return 349;break;case 24:return 251;break;case 25:return 138;break;case 26:return 347;break;case 27:return 144;break;case 28:return 201;break;case 29:return 140;break;case 30:return 181;break;case 31:return 252;break;case 32:return 69;break;case 33:return 366;break;case 34:return 215;break;case 35:return 351;break;case 36:return 307;break;case 37:return 248;break;case 38:return 386;break;case 39:return 282;break;case 40:return 390;break;case 41:return 283;break;case 42:return 269;break;case 43:return 94;break;case 44:return 261;break;case 45:return 235;break;case 46:return 319;break;case 47:return 105;break;case 48:return"CLOSE";break;case 49:return 216;break;case 50:return 164;break;case 51:return 164;break;case 52:return 383;break;case 53:return 318;break;case 54:return 419;break;case 55:return 389;break;case 56:return 237;break;case 57:return 213;break;case 58:return 245;break;case 59:return 298;break;case 60:return 180;break;case 61:return 211;break;case 62:return 232;break;case 63:return"CURSOR";break;case 64:return 352;break;case 65:return 397;break;case 66:return 294;break;case 67:return 290;break;case 68:return"DELETED";break;case 69:return 215;break;case 70:return 353;break;case 71:return 159;break;case 72:return 344;break;case 73:return 396;break;case 74:return 110;break;case 75:return 264;break;case 76:return 338;break;case 77:return 268;break;case 78:return 143;break;case 79:return 258;break;case 80:return 12;break;case 81:return 255;break;case 82:return"FETCH";break;case 83:return 249;break;case 84:return 324;break;case 85:return 157;break;case 86:return 451;break;case 87:return 421;break;case 88:return 205;break;case 89:return 209;break;case 90:return 212;break;case 91:return 364;break;case 92:return 130;break;case 93:return 307;break;case 94:return 284;break;case 95:return 280;break;case 96:return 167;break;case 97:return 196;break;case 98:return 291;break;case 99:return"INSERTED";break;case 100:return 142;break;case 101:return 172;break;case 102:return 195;break;case 103:return 321;break;case 104:return 250;break;case 105:return"LET";break;case 106:return 197;break;case 107:return 90;break;case 108:return 218;break;case 109:return 409;break;case 110:return 165;break;case 111:return 247;break;case 112:return 401;break;case 113:return 246;break;case 114:return 143;break;case 115:return 350;break;case 116:return 194;break;case 117:return"NEXT";break;case 118:return 234;break;case 119:return 217;break;case 120:return 331;break;case 121:return 128;break;case 122:return 257;break;case 123:return 382;break;case 124:return 202;break;case 125:return 362;break;case 126:return 220;break;case 127:return"OPEN";break;case 128:return 363;break;case 129:return 145;break;case 130:return 93;break;case 131:return 182;break;case 132:return 240;break;case 133:return 146;break;case 134:return 243;break;case 135:return 452;break;case 136:return 14;break;case 137:return 320;break;case 138:return 391;break;case 139:return"PRIOR";break;case 140:return 13;break;case 141:return 361;break;case 142:return 168;break;case 143:return"REDUCE";break;case 144:return 325;break;case 145:return"RELATIVE";break;case 146:return 85;break;case 147:return 348;break;case 148:return 149;break;case 149:return 392;break;case 150:return"RESTORE";break;case 151:return 147;break;case 152:return 147;break;case 153:return 198;break;case 154:return 385;break;case 155:return 210;break;case 156:return 124;break;case 157:return 352;break;case 158:return 81;break;case 159:return 200;break;case 160:return 120;break;case 161:return 120;break;case 162:return 356;break;case 163:return 286;break;case 164:return 365;break;case 165:return"STRATEGY";break;case 166:return"STORE";break;case 167:return 244;break;case 168:return 304;break;case 169:return 304;break;case 170:return 412;break;case 171:return 308;break;case 172:return 308;break;case 173:return 166;break;case 174:return 267;break;case 175:return"TIMEOUT";break;case 176:return 122;break;case 177:return 169;break;case 178:return 384;break;case 179:return 384;break;case 180:return 254;break;case 181:return 400;break;case 182:return 136;break;case 183:return 161;break;case 184:return 287;break;case 185:return 355;break;case 186:return 203;break;case 187:return 123;break;case 188:return 109;break;case 189:return 357;break;case 190:return 266;break;case 191:return 104;break;case 192:return 388;break;case 193:return 65;break;case 194:return 384;break;case 195:return 106;break;case 196:return 106;break;case 197:return 97;break;case 198:return 112;break;case 199:return 153;break;case 200:return 270;break;case 201:return 154;break;case 202:return 108;break;case 203:return 113;break;case 204:return 277;break;case 205:return 274;break;case 206:return 276;break;case 207:return 273;break;case 208:return 271;break;case 209:return 114;break;case 210:return 272;break;case 211:return 275;break;case 212:return 115;break;case 213:return 99;break;case 214:return 275;break;case 215:return 70;break;case 216:return 71;break;case 217:return 119;break;case 218:return 372;break;case 219:return 374;break;case 220:return 376;break;case 221:return 447;break;case 222:return 449;break;case 223:return 117;break;case 224:return 67;break;case 225:return 285;break;case 226:return 126;break;case 227:return 450;break;case 228:return 116;break;case 229:return 155;break;case 230:return 111;break;case 231:return 98;break;case 232:return 4;break;case 233:return 8;break;case 234:return"INVALID";break}},rules:[/^(?:``([^\`])+``)/i,/^(?:\[\?\])/i,/^(?:@\[)/i,/^(?:\[([^\]])*?\])/i,/^(?:`([^\`])*?`)/i,/^(?:N(['](\\.|[^']|\\')*?['])+)/i,/^(?:X(['](\\.|[^']|\\')*?['])+)/i,/^(?:(['](\\.|[^']|\\')*?['])+)/i,/^(?:(["](\\.|[^"]|\\")*?["])+)/i,/^(?:--(.*?)($|\r\n|\r|\n))/i,/^(?:\s+)/i,/^(?:\|\|)/i,/^(?:&&)/i,/^(?:VALUE\s+OF\s+SELECT\b)/i,/^(?:ROW\s+OF\s+SELECT\b)/i,/^(?:COLUMN\s+OF\s+SELECT\b)/i,/^(?:MATRIX\s+OF\s+SELECT\b)/i,/^(?:INDEX\s+OF\s+SELECT\b)/i,/^(?:RECORDSET\s+OF\s+SELECT\b)/i,/^(?:TEXT\s+OF\s+SELECT\b)/i,/^(?:SELECT\b)/i,/^(?:ABSOLUTE\b)/i,/^(?:ACTION\b)/i,/^(?:ADD\b)/i,/^(?:AGGR\b)/i,/^(?:ALL\b)/i,/^(?:ALTER\b)/i,/^(?:AND\b)/i,/^(?:ANTI\b)/i,/^(?:ANY\b)/i,/^(?:APPLY\b)/i,/^(?:ARRAY\b)/i,/^(?:AS\b)/i,/^(?:ASSERT\b)/i,/^(?:ASC\b)/i,/^(?:ATTACH\b)/i,/^(?:AUTO(_)?INCREMENT\b)/i,/^(?:AVG\b)/i,/^(?:BEGIN\b)/i,/^(?:BETWEEN\b)/i,/^(?:BREAK\b)/i,/^(?:NOT\s+BETWEEN\b)/i,/^(?:NOT\s+LIKE\b)/i,/^(?:BY\b)/i,/^(?:CASE\b)/i,/^(?:CAST\b)/i,/^(?:CHECK\b)/i,/^(?:CLASS\b)/i,/^(?:CLOSE\b)/i,/^(?:COLLATE\b)/i,/^(?:COLUMN\b)/i,/^(?:COLUMNS\b)/i,/^(?:COMMIT\b)/i,/^(?:CONSTRAINT\b)/i,/^(?:CONTENT\b)/i,/^(?:CONTINUE\b)/i,/^(?:CONVERT\b)/i,/^(?:CORRESPONDING\b)/i,/^(?:COUNT\b)/i,/^(?:CREATE\b)/i,/^(?:CROSS\b)/i,/^(?:CUBE\b)/i,/^(?:CURRENT_TIMESTAMP\b)/i,/^(?:CURSOR\b)/i,/^(?:DATABASE(S)?)/i,/^(?:DECLARE\b)/i,/^(?:DEFAULT\b)/i,/^(?:DELETE\b)/i,/^(?:DELETED\b)/i,/^(?:DESC\b)/i,/^(?:DETACH\b)/i,/^(?:DISTINCT\b)/i,/^(?:DROP\b)/i,/^(?:ECHO\b)/i,/^(?:EDGE\b)/i,/^(?:END\b)/i,/^(?:ENUM\b)/i,/^(?:ELSE\b)/i,/^(?:EXCEPT\b)/i,/^(?:EXISTS\b)/i,/^(?:EXPLAIN\b)/i,/^(?:FALSE\b)/i,/^(?:FETCH\b)/i,/^(?:FIRST\b)/i,/^(?:FOREIGN\b)/i,/^(?:FROM\b)/i,/^(?:GO\b)/i,/^(?:GRAPH\b)/i,/^(?:GROUP\b)/i,/^(?:GROUPING\b)/i,/^(?:HAVING\b)/i,/^(?:HELP\b)/i,/^(?:IF\b)/i,/^(?:IDENTITY\b)/i,/^(?:IS\b)/i,/^(?:IN\b)/i,/^(?:INDEX\b)/i,/^(?:INNER\b)/i,/^(?:INSERT\b)/i,/^(?:INSERTED\b)/i,/^(?:INTERSECT\b)/i,/^(?:INTO\b)/i,/^(?:JOIN\b)/i,/^(?:KEY\b)/i,/^(?:LAST\b)/i,/^(?:LET\b)/i,/^(?:LEFT\b)/i,/^(?:LIKE\b)/i,/^(?:LIMIT\b)/i,/^(?:MATCHED\b)/i,/^(?:MATRIX\b)/i,/^(?:MAX\b)/i,/^(?:MERGE\b)/i,/^(?:MIN\b)/i,/^(?:MINUS\b)/i,/^(?:MODIFY\b)/i,/^(?:NATURAL\b)/i,/^(?:NEXT\b)/i,/^(?:NEW\b)/i,/^(?:NOCASE\b)/i,/^(?:NO\b)/i,/^(?:NOT\b)/i,/^(?:NULL\b)/i,/^(?:OFF\b)/i,/^(?:ON\b)/i,/^(?:ONLY\b)/i,/^(?:OFFSET\b)/i,/^(?:OPEN\b)/i,/^(?:OPTION\b)/i,/^(?:OR\b)/i,/^(?:ORDER\b)/i,/^(?:OUTER\b)/i,/^(?:OVER\b)/i,/^(?:PATH\b)/i,/^(?:PARTITION\b)/i,/^(?:PERCENT\b)/i,/^(?:PLAN\b)/i,/^(?:PRIMARY\b)/i,/^(?:PRINT\b)/i,/^(?:PRIOR\b)/i,/^(?:QUERY\b)/i,/^(?:READ\b)/i,/^(?:RECORDSET\b)/i,/^(?:REDUCE\b)/i,/^(?:REFERENCES\b)/i,/^(?:RELATIVE\b)/i,/^(?:REMOVE\b)/i,/^(?:RENAME\b)/i,/^(?:REPEAT\b)/i,/^(?:REQUIRE\b)/i,/^(?:RESTORE\b)/i,/^(?:RETURN\b)/i,/^(?:RETURNS\b)/i,/^(?:RIGHT\b)/i,/^(?:ROLLBACK\b)/i,/^(?:ROLLUP\b)/i,/^(?:ROW\b)/i,/^(?:SCHEMA(S)?)/i,/^(?:SEARCH\b)/i,/^(?:SEMI\b)/i,/^(?:SET\b)/i,/^(?:SETS\b)/i,/^(?:SHOW\b)/i,/^(?:SOME\b)/i,/^(?:SOURCE\b)/i,/^(?:STRATEGY\b)/i,/^(?:STORE\b)/i,/^(?:SUM\b)/i,/^(?:TABLE\b)/i,/^(?:TABLES\b)/i,/^(?:TARGET\b)/i,/^(?:TEMP\b)/i,/^(?:TEMPORARY\b)/i,/^(?:TEXTSTRING\b)/i,/^(?:THEN\b)/i,/^(?:TIMEOUT\b)/i,/^(?:TO\b)/i,/^(?:TOP\b)/i,/^(?:TRAN\b)/i,/^(?:TRANSACTION\b)/i,/^(?:TRUE\b)/i,/^(?:TRUNCATE\b)/i,/^(?:UNION\b)/i,/^(?:UNIQUE\b)/i,/^(?:UPDATE\b)/i,/^(?:USE\b)/i,/^(?:USING\b)/i,/^(?:VALUE(S)?)/i,/^(?:VERTEX\b)/i,/^(?:VIEW\b)/i,/^(?:WHEN\b)/i,/^(?:WHERE\b)/i,/^(?:WHILE\b)/i,/^(?:WITH\b)/i,/^(?:WORK\b)/i,/^(?:(\d*[.])?\d+[eE]\d+)/i,/^(?:(\d*[.])?\d+)/i,/^(?:->)/i,/^(?:#)/i,/^(?:\+)/i,/^(?:-)/i,/^(?:\*)/i,/^(?:\/)/i,/^(?:%)/i,/^(?:!===)/i,/^(?:===)/i,/^(?:!==)/i,/^(?:==)/i,/^(?:>=)/i,/^(?:>)/i,/^(?:<=)/i,/^(?:<>)/i,/^(?:<)/i,/^(?:=)/i,/^(?:!=)/i,/^(?:\()/i,/^(?:\))/i,/^(?:@)/i,/^(?:\{)/i,/^(?:\})/i,/^(?:\])/i,/^(?::-)/i,/^(?:\?-)/i,/^(?:\.)/i,/^(?:,)/i,/^(?:::)/i,/^(?::)/i,/^(?:;)/i,/^(?:\$)/i,/^(?:\?)/i,/^(?:!)/i,/^(?:\^)/i,/^(?:[a-zA-Z_][a-zA-Z_0-9]*)/i,/^(?:$)/i,/^(?:.)/i],conditions:{INITIAL:{rules:[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92,93,94,95,96,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,123,124,125,126,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,160,161,162,163,164,165,166,167,168,169,170,171,172,173,174,175,176,177,178,179,180,181,182,183,184,185,186,187,188,189,190,191,192,193,194,195,196,197,198,199,200,201,202,203,204,205,206,207,208,209,210,211,212,213,214,215,216,217,218,219,220,221,222,223,224,225,226,227,228,229,230,231,232,233,234],inclusive:true}}};return lexer}();parser.lexer=lexer;function Parser(){this.yy={}}Parser.prototype=parser;parser.Parser=Parser;return new Parser}();if(typeof require!=="undefined"&&typeof exports!=="undefined"){exports.parser=parser;exports.Parser=parser.Parser;exports.parse=function(){return parser.parse.apply(parser,arguments)};exports.main=function commonjsMain(args){if(!args[1]){console.log("Usage: "+args[0]+" FILE");process.exit(1)}var source=require("fs").readFileSync(require("path").normalize(args[1]),"utf8");return exports.parser.parse(source)};if(typeof module!=="undefined"&&require.main===module){exports.main(process.argv.slice(1))}}alasql.prettyflag=false;alasql.pretty=function(sql,flag){var pf=alasql.prettyflag;alasql.prettyflag=!flag;var s=alasql.parse(sql).toString();alasql.prettyflag=pf;return s};function K(s){if(alasql.prettyflag){return'<b style="color:blue">'+s.toUpperCase()+"</b>"}else{return s}}function P(s){if(alasql.prettyflag){return'<span style="color:green">'+s+"</span>"}else{return s}}function L(s){if(alasql.prettyflag){return'<span style="color:red">'+s+"</span>"}else{return s}}function N(s){if(alasql.prettyflag){return'<span style="color:green">'+s+"</span>"}else{return s}}function S(s){if(alasql.prettyflag){return'<span style="color:green">'+s+"</span>"}else{return s}}function NL(){if(alasql.prettyflag){return"<br/>"}else{return" "}}function ID(){if(alasql.prettyflag){return"&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"}else{return""}}var utils=alasql.utils={};function n2u(s){return"(y="+s+",y===y?y:undefined)"}function und(s,r){return"(y="+s+',typeof y=="undefined"?undefined:'+r+")"}function returnTrue(){return true}function returnUndefined(){}var escapeq=utils.escapeq=function(s){return s.replace(/\'/g,"\\'")};var escapeqq=utils.undoubleq=function(s){return s.replace(/(\')/g,"''")};var doubleq=utils.doubleq=function(s){return s.replace(/(\'\')/g,"\\'")};var doubleqq=utils.doubleqq=function(s){return s.replace(/\'/g,"'")};var cutbom=function(s){if(s[0]==String.fromCharCode(65279))s=s.substr(1);return s};var loadFile=utils.loadFile=function(path,asy,success,error){if(typeof exports=="object"||typeof Meteor!="undefined"&&Meteor.isServer){if(typeof Meteor!="undefined"){var fs=Npm.require("fs")}else{var fs=require("fs")}if(typeof path=="undefined"){var buff="";process.stdin.setEncoding("utf8");process.stdin.on("readable",function(){var chunk=process.stdin.read();if(chunk!==null){buff+=chunk.toString()}});process.stdin.on("end",function(){success(cutbom(buff))})}else{if(asy){fs.readFile(path,function(err,data){if(err){throw err}success(cutbom(data.toString()))})}else{var data=fs.readFileSync(path);success(cutbom(data.toString()))}}}else if(typeof cordova=="object"){window.requestFileSystem(LocalFileSystem.PERSISTENT,0,function(fileSystem){fileSystem.root.getFile(path,{create:false},function(fileEntry){fileEntry.file(function(file){var fileReader=new FileReader;fileReader.onloadend=function(e){success(cutbom(this.result))};fileReader.readAsText(file)})})})}else{if(typeof path=="string"){if(path.substr(0,1)=="#"&&typeof document!="undefined"){var data=document.querySelector(path).textContent;success(data)}else{var xhr=new XMLHttpRequest;xhr.onreadystatechange=function(){if(xhr.readyState===XMLHttpRequest.DONE){if(xhr.status===200){if(success)success(cutbom(xhr.responseText))}else{if(error)error(xhr)}}};xhr.open("GET",path,asy);xhr.send()}}else if(path instanceof Event){var files=path.target.files;var reader=new FileReader;var name=files[0].name;reader.onload=function(e){var data=e.target.result;success(cutbom(data))};reader.readAsText(files[0])}}};var loadBinaryFile=utils.loadBinaryFile=function(path,asy,success,error){if(typeof exports=="object"||typeof Meteor!="undefined"&&Meteor.isServer){if(typeof Meteor!="undefined"){var fs=Npm.require("fs")}else{var fs=require("fs")}if(asy){fs.readFile(path,function(err,data){if(err){throw err}var arr=new Array;for(var i=0;i!=data.length;++i)arr[i]=String.fromCharCode(data[i]);success(arr.join(""))})}else{var data=fs.readFileSync(path);var arr=new Array;for(var i=0;i!=data.length;++i)arr[i]=String.fromCharCode(data[i]);success(arr.join(""))}}else{if(typeof path=="string"){var xhr=new XMLHttpRequest;xhr.open("GET",path,asy);xhr.responseType="arraybuffer";xhr.onload=function(){var data=new Uint8Array(xhr.response);var arr=new Array;for(var i=0;i!=data.length;++i)arr[i]=String.fromCharCode(data[i]);success(arr.join(""))};xhr.send()}else if(path instanceof Event){var files=path.target.files;var reader=new FileReader;var name=files[0].name;reader.onload=function(e){var data=e.target.result;success(data)};reader.readAsBinaryString(files[0])}}};var removeFile=utils.removeFile=function(path,cb){if(typeof exports=="object"){var fs=require("fs");fs.remove(path,cb)}else if(typeof cordova=="object"){window.requestFileSystem(LocalFileSystem.PERSISTENT,0,function(fileSystem){fileSystem.root.getFile(path,{create:false},function(fileEntry){fileEntry.remove(cb);if(cb)cb()},function(){if(cb)cb()})})}else{throw new Error("You can remove files only in Node.js and Apache Cordova")}};var deleteFile=utils.deleteFile=function(path,cb){if(typeof exports=="object"){var fs=require("fs");fs.unlink(path,cb)}};var fileExists=utils.fileExists=function(path,cb){if(typeof exports=="object"){var fs=require("fs");fs.exists(path,cb)}else if(typeof cordova=="object"){window.requestFileSystem(LocalFileSystem.PERSISTENT,0,function(fileSystem){fileSystem.root.getFile(path,{create:false},function(fileEntry){cb(true)},function(){cb(false)})})}else{throw new Error("You can use exists() only in Node.js or Apach Cordova")}};var saveFile=utils.saveFile=function(path,data,cb){var res=1;if(typeof path=="undefined"){res=data;if(cb)res=cb(res)}else{if(typeof exports=="object"){var fs=require("fs");var data=fs.writeFileSync(path,data);if(cb)res=cb(res)}else if(typeof cordova=="object"){window.requestFileSystem(LocalFileSystem.PERSISTENT,0,function(fileSystem){fileSystem.root.getFile(path,{create:true},function(fileEntry){fileEntry.createWriter(function(fileWriter){fileWriter.onwriteend=function(){if(cb)res=cb(res)};fileWriter.write(data)})})})}else{if(isIE()==9){var ndata=data.replace(/\r\n/g,"&#A;&#D;");ndata=ndata.replace(/\n/g,"&#D;");ndata=ndata.replace(/\t/g,"&#9;");var testlink=window.open("about:blank","_blank");testlink.document.write(ndata);testlink.document.close();testlink.document.execCommand("SaveAs",false,path);testlink.close()}else{var blob=new Blob([data],{type:"text/plain;charset=utf-8"});saveAs(blob,path);if(cb)res=cb(res)}}}return res};function isIE(){var myNav=navigator.userAgent.toLowerCase();return myNav.indexOf("msie")!=-1?parseInt(myNav.split("msie")[1]):false}var hash=utils.hash=function hash(str){var h=0;if(str.length==0)return h;for(var i=0;i<str.length;i++){h=(h<<5)-h+str.charCodeAt(i);h=h&h}return h};var arrayUnion=utils.arrayUnion=function(a,b){var r=b.slice(0);a.forEach(function(i){if(r.indexOf(i)<0)r.push(i)});return r};var arrayDiff=utils.arrayDiff=function(a,b){return a.filter(function(i){return b.indexOf(i)<0})};var arrayIntersect=utils.arrayIntersect=function(a,b){var r=[];a.forEach(function(ai){var found=false;b.forEach(function(bi){found=found||ai==bi});if(found){r.push(ai)}});return r};var arrayUnionDeep=utils.arrayUnionDeep=function(a,b){var r=b.slice(0);a.forEach(function(ai){var found=false;r.forEach(function(ri){found=found||deepEqual(ai,ri)});if(!found){r.push(ai)}});return r};var arrayExceptDeep=utils.arrayExceptDeep=function(a,b){var r=[];a.forEach(function(ai){var found=false;b.forEach(function(bi){found=found||deepEqual(ai,bi)});if(!found){r.push(ai)}});return r};var arrayIntersectDeep=utils.arrayIntersectDeep=function(a,b){var r=[];a.forEach(function(ai){var found=false;b.forEach(function(bi){found=found||deepEqual(ai,bi,true)});if(found){r.push(ai)}});return r};var cloneDeep=utils.cloneDeep=function cloneDeep(obj){if(obj==null||typeof obj!="object")return obj;var temp=obj.constructor();for(var key in obj){if(obj.hasOwnProperty(key)){temp[key]=cloneDeep(obj[key])}}return temp};var equalDeep=utils.equalDeep=function equalDeep(x,y,deep){if(deep){if(x==y)return true;var p;for(p in y){if(typeof x[p]=="undefined"){return false}}for(p in y){if(y[p]){switch(typeof y[p]){case"object":if(!equalDeep(y[p],x[p])){return false}break;case"function":if(typeof x[p]=="undefined"||p!="equals"&&y[p].toString()!=x[p].toString())return false;break;default:if(y[p]!=x[p]){return false}}}else{if(x[p])return false}}for(p in x){if(typeof y[p]=="undefined"){return false}}return true}return x==y};var deepEqual=utils.deepEqual=function(x,y){if(typeof x=="object"&&x!=null&&(typeof y=="object"&&y!=null)){if(Object.keys(x).length!=Object.keys(y).length)return false;for(var prop in x){if(y.hasOwnProperty(prop)){if(!deepEqual(x[prop],y[prop]))return false}else return false}return true}else if(x!==y)return false;else return true};var distinctArray=utils.distinctArray=function(data){var uniq={};for(var i=0,ilen=data.length;i<ilen;i++){if(typeof data[i]=="object"){var uix=Object.keys(data[i]).sort().map(function(k){return k+"`"+data[i][k]}).join("`")}else{var uix=data[i]}uniq[uix]=data[i]}var res=[];for(var key in uniq)res.push(uniq[key]);return res};var extend=utils.extend=function extend(a,b){if(typeof a=="undefined")a={};for(var key in b){if(b.hasOwnProperty(key)){a[key]=b[key]}}return a};var flatArray=utils.flatArray=function(a){if(!a||a.length==0)return[];if(typeof a=="object"&&a instanceof alasql.Recordset){return a.data.map(function(ai){return ai[a.columns[0].columnid]})}var key=Object.keys(a[0])[0];if(typeof key=="undefined")return[];return a.map(function(ai){return ai[key]})};var arrayOfArrays=utils.arrayOfArrays=function(a){return a.map(function(aa){var ar=[];for(var key in aa)ar.push(aa[key]);return ar})};var xlsnc=utils.xlsnc=function(i){var addr=String.fromCharCode(65+i%26);if(i>=26){i=(i/26|0)-1;addr=String.fromCharCode(65+i%26)+addr;if(i>26){i=(i/26|0)-1;addr=String.fromCharCode(65+i%26)+addr}}return addr};var xlscn=utils.xlscn=function(s){var n=s.charCodeAt(0)-65;if(s.length>1){n=(n+1)*26+s.charCodeAt(1)-65;if(s.length>2){n=(n+1)*26+s.charCodeAt(2)-65}}return n};var domEmptyChildren=utils.domEmptyChildren=function(container){var len=container.childNodes.length;while(len--){container.removeChild(container.lastChild)}};alasql.utils.uncomment=function uncomment(str){str=("__"+str+"__").split("");var quote=false,quoteSign,blockComment=false,lineComment=false;for(var i=0,l=str.length;i<l;i++){var unescaped=str[i-1]!=="\\"||str[i-2]==="\\";if(quote){if(str[i]===quoteSign&&unescaped)quote=false}else if(blockComment){if(str[i]==="*"&&str[i+1]==="/"){str[i]=str[i+1]="";blockComment=false;i++}else{str[i]=""}}else if(lineComment){if(str[i+1]=="\n"||str[i+1]=="\r")lineComment=false;str[i]=""}else{if(str[i]=='"'||str[i]=="'"){quote=true;quoteSign=str[i]}else if(str[i]=="["&&str[i-1]!="@"){quote=true;quoteSign="]"}else if(str[i]==="/"&&str[i+1]==="*"){str[i]="";blockComment=true}}}str=str.join("").slice(2,-2);return str};alasql.parser=parser;alasql.parse=function(sql){return parser.parse(alasql.utils.uncomment(sql))};alasql.engines={};alasql.databases={};alasql.databasenum=0;alasql.options={};alasql.options.errorlog=false;alasql.options.valueof=false;alasql.options.dropifnotexists=false;alasql.options.datetimeformat="sql";alasql.options.casesensitive=true;alasql.options.logtarget="output";alasql.options.logprompt=true;alasql.options.modifier=undefined;alasql.options.columnlookup=10;alasql.options.autovertex=true;alasql.options.usedbo=true;alasql.options.autocommit=true;alasql.options.cache=true;alasql.options.tsql=true;alasql.options.mysql=true;alasql.options.postgres=true;alasql.options.oracle=true;alasql.options.sqlite=true;alasql.options.orientdb=true;alasql.options.nocount=false;alasql.options.nan=false;alasql.vars={};alasql.declares={};alasql.prompthistory=[];alasql.plugins={};alasql.from={};alasql.into={};alasql.fn={};alasql.aggr={};alasql.busy=0;alasql.MAXSQLCACHESIZE=1e4;
    alasql.DEFAULTDATABASEID="alasql";alasql.lastid=0;alasql.buffer={};alasql.use=function(databaseid){if(!databaseid)databaseid=alasql.DEFAULTDATABASEID;if(alasql.useid==databaseid)return;alasql.useid=databaseid;var db=alasql.databases[alasql.useid];alasql.tables=db.tables;db.resetSqlCache();if(alasql.options.usedbo){alasql.databases.dbo=db}};alasql.exec=function(sql,params,cb,scope){delete alasql.error;if(typeof params=="undefined")params={};if(alasql.options.errorlog){try{return alasql.dexec(alasql.useid,sql,params,cb,scope)}catch(err){alasql.error=err;if(cb)cb(null,alasql.error)}}else{return alasql.dexec(alasql.useid,sql,params,cb,scope)}};alasql.dexec=function(databaseid,sql,params,cb,scope){var db=alasql.databases[databaseid];if(alasql.options.cache){var hh=hash(sql);var statement=db.sqlCache[hh];if(statement&&db.dbversion==statement.dbversion){return statement(params,cb)}}var ast=alasql.parse(sql);if(!ast.statements)return;if(ast.statements.length==0)return 0;else if(ast.statements.length==1){if(ast.statements[0].compile){var statement=ast.statements[0].compile(databaseid);if(!statement)return;statement.sql=sql;statement.dbversion=db.dbversion;if(alasql.options.cache){if(db.sqlCacheSize>alasql.MAXSQLCACHESIZE){db.resetSqlCache()}db.sqlCacheSize++;db.sqlCache[hh]=statement}var res=alasql.res=statement(params,cb,scope);return res}else{alasql.precompile(ast.statements[0],alasql.useid,params);var res=alasql.res=ast.statements[0].execute(databaseid,params,cb,scope);return res}}else{if(cb){alasql.adrun(databaseid,ast,params,cb,scope)}else{return alasql.drun(databaseid,ast,params,cb,scope)}}};alasql.drun=function(databaseid,ast,params,cb,scope){var useid=alasql.useid;if(useid!=databaseid)alasql.use(databaseid);var res=[];for(var i=0,ilen=ast.statements.length;i<ilen;i++){if(ast.statements[i]){if(ast.statements[i].compile){var statement=ast.statements[i].compile(alasql.useid);res.push(alasql.res=statement(params,null,scope))}else{alasql.precompile(ast.statements[i],alasql.useid,params);res.push(alasql.res=ast.statements[i].execute(alasql.useid,params))}}}if(useid!=databaseid)alasql.use(useid);if(cb)cb(res);alasql.res=res;return res};alasql.adrun=function(databaseid,ast,params,cb,scope){var useid=alasql.useid;if(useid!=databaseid)alasql.use(databaseid);var res=[];adrunone();function adrunone(data){if(typeof data!="undefined")res.push(data);var astatement=ast.statements.shift();if(!astatement){if(useid!=databaseid)alasql.use(useid);cb(res)}else{if(astatement.compile){var statement=astatement.compile(alasql.useid);statement(params,adrunone,scope)}else{alasql.precompile(ast.statements[0],alasql.useid,params);astatement.execute(alasql.useid,params,adrunone)}}}};alasql.compile=function(sql,databaseid){if(!databaseid)databaseid=alasql.useid;var ast=alasql.parse(sql);if(ast.statements.length==1){return ast.statements[0].compile(databaseid)}else{throw new Error("Cannot compile, because number of statments in SQL is not equal to 1")}};if(typeof exports=="object"){var Promise=require("es6-promise").Promise}if(typeof Promise=="function"){alasql.promise=function(sql,params){return new Promise(function(resolve,reject){alasql(sql,params,function(data,err){if(err){reject(err)}else{resolve(data)}})})}}var Database=alasql.Database=function(databaseid){var self=this;if(self===alasql){if(databaseid){self=alasql.databases[databaseid];alasql.databases[databaseid]=self;if(!self){throw new Error('Database "'+databaseid+'" not found')}}else{self=alasql.databases.alasql;if(alasql.options.tsql)alasql.databases.tempdb=alasql.databases.alasql}}if(!databaseid){databaseid="db"+alasql.databasenum++}self.databaseid=databaseid;alasql.databases[databaseid]=self;self.tables={};self.views={};self.objects={};self.counter=0;self.indices={};self.resetSqlCache();self.dbversion=0;return self};Database.prototype.resetSqlCache=function(){this.sqlCache={};this.sqlCacheSize=0};Database.prototype.exec=function(sql,params,cb){return alasql.dexec(this.databaseid,sql,params,cb)};Database.prototype.transaction=function(cb){var tx=new alasql.Transaction(this.databaseid);var res=cb(tx);return res};var Transaction=alasql.Transaction=function(databaseid){this.transactionid=Date.now();this.databaseid=databaseid;this.commited=false;this.dbversion=alasql.databases[databaseid].dbversion;this.bank=JSON.stringify(alasql.databases[databaseid]);return this};Transaction.prototype.commit=function(){this.commited=true;alasql.databases[this.databaseid].dbversion=Date.now();delete this.bank};Transaction.prototype.rollback=function(){if(!this.commited){alasql.databases[this.databaseid]=JSON.parse(this.bank);delete this.bank}else{throw new Error("Transaction already commited")}};Transaction.prototype.exec=function(sql,params,cb){return alasql.dexec(this.databaseid,sql,params,cb)};Transaction.prototype.executeSQL=Transaction.prototype.exec;var Table=alasql.Table=function(params){this.columns=[];this.xcolumns={};this.data=[];this.inddefs={};this.indices={};this.uniqs={};this.uniqdefs={};extend(this,params)};Table.prototype.indexColumns=function(){var self=this;self.xcolumns={};self.columns.forEach(function(col){self.xcolumns[col.columnid]=col})};var View=alasql.View=function(params){this.columns=[];this.xcolumns={};this.query=[];extend(this,params)};var Query=alasql.Query=function(params){this.alasql=alasql;this.columns=[];this.xcolumns={};this.selectGroup=[];this.groupColumns={};extend(this,params)};var Recordset=alasql.Recordset=function(params){extend(this,params)};var yy=parser.yy=alasql.yy={};yy.extend=extend;yy.casesensitive=alasql.options.casesensitive;var Base=yy.Base=function(params){return yy.extend(this,params)};Base.prototype.toString=function(){};Base.prototype.toType=function(){};Base.prototype.toJavaScript=function(){};Base.prototype.compile=returnUndefined;Base.prototype.exec=function(){};Base.prototype.compile=returnUndefined;Base.prototype.exec=function(){};yy.Statements=function(params){return yy.extend(this,params)};yy.Statements.prototype.toString=function(){return this.statements.map(function(st){return st.toString()}).join(";"+NL())};yy.Statements.prototype.compile=function(db){var statements=this.statements.map(function(st){return st.compile(db)});if(statements.length==1){return statements[0]}else{return function(params,cb){var res=statements.map(function(st){return st(params)});if(cb)cb(res);return res}}};yy.Search=function(params){return yy.extend(this,params)};yy.Search.prototype.toString=function(){var s=K("SEARCH")+" ";if(this.selectors)s+=this.selectors.toString();if(this.from)s+=K("FROM")+" "+this.from.toString();return s};yy.Search.prototype.toJavaScript=function(context,tableid,defcols){var s="this.queriesfn["+(this.queriesidx-1)+"](this.params,null,"+context+")";return s};yy.Search.prototype.compile=function(databaseid){var dbid=databaseid;var self=this;var statement=function(params,cb){var res;doSearch.bind(self)(dbid,params,function(data){res=modify(statement.query,data);if(cb)res=cb(res)});return res};statement.query={};return statement};function doSearch(databaseid,params,cb){var res;var stope={};var fromdata;var selectors=cloneDeep(this.selectors);if(typeof selectors!="undefined"&&selectors.length>0){if(selectors&&selectors[0]&&selectors[0].srchid=="PROP"&&selectors[0].args&&selectors[0].args[0]){if(selectors[0].args[0].toUpperCase()=="XML"){stope.mode="XML";selectors.shift()}else if(selectors[0].args[0].toUpperCase()=="HTML"){stope.mode="HTML";selectors.shift()}else if(selectors[0].args[0].toUpperCase()=="JSON"){stope.mode="JSON";selectors.shift()}}if(selectors.length>0&&selectors[0].srchid=="VALUE"){stope.value=true;selectors.shift()}}if(this.from instanceof yy.Column){var dbid=this.from.databaseid||databaseid;fromdata=alasql.databases[dbid].tables[this.from.columnid].data}else if(this.from instanceof yy.FuncValue&&alasql.from[this.from.funcid.toUpperCase()]){var args=this.from.args.map(function(arg){var as=arg.toJavaScript();var fn=new Function("params,alasql","var y;return "+as).bind(this);return fn(params,alasql)});fromdata=alasql.from[this.from.funcid.toUpperCase()].apply(this,args)}else if(typeof this.from=="undefined"){fromdata=alasql.databases[databaseid].objects}else{var fromfn=new Function("params,alasql","var y;return "+this.from.toJavaScript());fromdata=fromfn(params,alasql);if(typeof Mongo=="object"&&typeof Mongo.Collection!="object"&&fromdata instanceof Mongo.Collection){fromdata=fromdata.find().fetch()}}if(typeof selectors!="undefined"&&selectors.length>0){if(false){selectors.forEach(function(selector){if(selector.srchid=="TO"){alasql.vars[selector.args[0]]=[]}})}res=processSelector(selectors,0,fromdata)}else{res=fromdata}if(this.into){var a1,a2;if(typeof this.into.args[0]!="undefined"){a1=new Function("params,alasql","var y;return "+this.into.args[0].toJavaScript())(params,alasql)}if(typeof this.into.args[1]!="undefined"){a2=new Function("params,alasql","var y;return "+this.into.args[1].toJavaScript())(params,alasql)}res=alasql.into[this.into.funcid.toUpperCase()](a1,a2,res,[],cb)}else{if(stope.value&&res.length>0)res=res[0];if(cb)res=cb(res)}return res;function processSelector(selectors,sidx,value){var sel=selectors[sidx];var SECURITY_BREAK=1e5;if(sel.selid){if(sel.selid=="PATH"){var queue=[{node:value,stack:[]}];var visited={};var path=[];var objects=alasql.databases[alasql.useid].objects;while(queue.length>0){var q=queue.shift();var node=q.node;var stack=q.stack;var r=processSelector(sel.args,0,node);if(r.length>0){if(sidx+1+1>selectors.length){return stack}else{var rv=[];if(stack&&stack.length>0){stack.forEach(function(stv){rv=rv.concat(processSelector(selectors,sidx+1,stv))})}return rv}}else{if(typeof visited[node.$id]!="undefined"){continue}else{visited[node.$id]=true;if(node.$out&&node.$out.length>0){node.$out.forEach(function(edgeid){var edge=objects[edgeid];var stack2=stack.concat(edge);stack2.push(objects[edge.$out[0]]);queue.push({node:objects[edge.$out[0]],stack:stack2})})}}}}return[]}if(sel.selid=="NOT"){var nest=processSelector(sel.args,0,value);if(nest.length>0){return[]}else{if(sidx+1+1>selectors.length){return[value]}else{return processSelector(selectors,sidx+1,value)}}}else if(sel.selid=="DISTINCT"){if(typeof sel.args=="undefined"||sel.args.length==0){var nest=distinctArray(value)}else{var nest=processSelector(sel.args,0,value)}if(nest.length==0){return[]}else{var res=distinctArray(nest);if(sidx+1+1>selectors.length){return res}else{return processSelector(selectors,sidx+1,res)}}}else if(sel.selid=="AND"){var res=true;sel.args.forEach(function(se){res=res&&processSelector(se,0,value).length>0});if(!res){return[]}else{if(sidx+1+1>selectors.length){return[value]}else{return processSelector(selectors,sidx+1,value)}}}else if(sel.selid=="OR"){var res=false;sel.args.forEach(function(se){res=res||processSelector(se,0,value).length>0});if(!res){return[]}else{if(sidx+1+1>selectors.length){return[value]}else{return processSelector(selectors,sidx+1,value)}}}else if(sel.selid=="ALL"){var nest=processSelector(sel.args[0],0,value);if(nest.length==0){return[]}else{if(sidx+1+1>selectors.length){return nest}else{return processSelector(selectors,sidx+1,nest)}}}else if(sel.selid=="ANY"){var nest=processSelector(sel.args[0],0,value);if(nest.length==0){return[]}else{if(sidx+1+1>selectors.length){return[nest[0]]}else{return processSelector(selectors,sidx+1,[nest[0]])}}}else if(sel.selid=="UNIONALL"){var nest=[];sel.args.forEach(function(se){nest=nest.concat(processSelector(se,0,value))});if(nest.length==0){return[]}else{if(sidx+1+1>selectors.length){return nest}else{return processSelector(selectors,sidx+1,nest)}}}else if(sel.selid=="UNION"){var nest=[];sel.args.forEach(function(se){nest=nest.concat(processSelector(se,0,value))});var nest=distinctArray(nest);if(nest.length==0){return[]}else{if(sidx+1+1>selectors.length){return nest}else{return processSelector(selectors,sidx+1,nest)}}}else if(sel.selid=="IF"){var nest=processSelector(sel.args,0,value);if(nest.length==0){return[]}else{if(sidx+1+1>selectors.length){return[value]}else{return processSelector(selectors,sidx+1,value)}}}else if(sel.selid=="REPEAT"){var lmin=sel.args[0].value;if(!sel.args[1]){var lmax=lmin}else{var lmax=sel.args[1].value}if(sel.args[2]){var lvar=sel.args[2].variable}else{var lvar}var lsel=sel.sels;var retval=[];if(lmin==0){if(sidx+1+1>selectors.length){retval=[value]}else{if(lvar)alasql.vars[lvar]=0;retval=retval.concat(processSelector(selectors,sidx+1,value))}}if(lmax>0){var nests=[{value:value,lvl:1}];var i=0;while(nests.length>0){var nest=nests[0];nests.shift();if(nest.lvl<=lmax){if(lvar)alasql.vars[lvar]=nest.lvl;var nest1=processSelector(sel.sels,0,nest.value);nest1.forEach(function(n){nests.push({value:n,lvl:nest.lvl+1})});if(nest.lvl>=lmin){if(sidx+1+1>selectors.length){retval=retval.concat(nest1)}else{nest1.forEach(function(n){retval=retval.concat(processSelector(selectors,sidx+1,n))})}}}i++;if(i>SECURITY_BREAK){throw new Error("Security brake. Number of iterations = "+i)}}}return retval}else if(sel.selid=="TO"){var oldv=alasql.vars[sel.args[0]];var newv=[];if(typeof oldv!="undefined"){newv=oldv.slice(0)}else{newv=[]}newv.push(value);if(sidx+1+1>selectors.length){return[value]}else{alasql.vars[sel.args[0]]=newv;var r1=processSelector(selectors,sidx+1,value);alasql.vars[sel.args[0]]=oldv;return r1}}else if(sel.selid=="ARRAY"){var nest=processSelector(sel.args,0,value);if(nest.length>0){var val=nest}else{return[]}if(sidx+1+1>selectors.length){return[val]}else{return processSelector(selectors,sidx+1,val)}}else if(sel.selid=="SUM"){var nest=processSelector(sel.args,0,value);if(nest.length>0){var val=nest.reduce(function(sum,current){return sum+current},0)}else{return[]}if(sidx+1+1>selectors.length){return[val]}else{return processSelector(selectors,sidx+1,val)}}else if(sel.selid=="AVG"){var nest=processSelector(sel.args,0,value);if(nest.length>0){var val=nest.reduce(function(sum,current){return sum+current},0)/nest.length}else{return[]}if(sidx+1+1>selectors.length){return[val]}else{return processSelector(selectors,sidx+1,val)}}else if(sel.selid=="COUNT"){var nest=processSelector(sel.args,0,value);if(nest.length>0){var val=nest.length}else{return[]}if(sidx+1+1>selectors.length){return[val]}else{return processSelector(selectors,sidx+1,val)}}else if(sel.selid=="FIRST"){var nest=processSelector(sel.args,0,value);if(nest.length>0)var val=nest[0];else return[];if(sidx+1+1>selectors.length){return[val]}else{return processSelector(selectors,sidx+1,val)}}else if(sel.selid=="LAST"){var nest=processSelector(sel.args,0,value);if(nest.length>0)var val=nest[nest.length-1];else return[];if(sidx+1+1>selectors.length){return[val]}else{return processSelector(selectors,sidx+1,val)}}else if(sel.selid=="MIN"){var nest=processSelector(sel.args,0,value);if(nest.length==0)return[];var val=nest.reduce(function(min,current){return Math.min(min,current)},Infinity);if(sidx+1+1>selectors.length){return[val]}else{return processSelector(selectors,sidx+1,val)}}else if(sel.selid=="MAX"){var nest=processSelector(sel.args,0,value);if(nest.length==0)return[];var val=nest.reduce(function(max,current){return Math.max(max,current)},-Infinity);if(sidx+1+1>selectors.length){return[val]}else{return processSelector(selectors,sidx+1,val)}}else if(sel.selid=="PLUS"){var retval=[];var nests=processSelector(sel.args,0,value).slice();if(sidx+1+1>selectors.length){retval=retval.concat(nests)}else{nests.forEach(function(n){retval=retval.concat(processSelector(selectors,sidx+1,n))})}var i=0;while(nests.length>0){var nest=nests.shift();nest=processSelector(sel.args,0,nest);nests=nests.concat(nest);if(sidx+1+1>selectors.length){retval=retval.concat(nest)}else{nest.forEach(function(n){var rn=processSelector(selectors,sidx+1,n);retval=retval.concat(rn)})}i++;if(i>SECURITY_BREAK){throw new Error("Security brake. Number of iterations = "+i)}}return retval}else if(sel.selid=="STAR"){var retval=[];retval=processSelector(selectors,sidx+1,value);var nests=processSelector(sel.args,0,value).slice();if(sidx+1+1>selectors.length){retval=retval.concat(nests)}else{nests.forEach(function(n){retval=retval.concat(processSelector(selectors,sidx+1,n))})}var i=0;while(nests.length>0){var nest=nests[0];nests.shift();nest=processSelector(sel.args,0,nest);nests=nests.concat(nest);if(sidx+1+1>selectors.length){}else{nest.forEach(function(n){retval=retval.concat(processSelector(selectors,sidx+1,n))})}i++;if(i>SECURITY_BREAK){throw new Error("Security brake. Number of iterations = "+i)}}return retval}else if(sel.selid=="QUESTION"){var retval=[];retval=retval.concat(processSelector(selectors,sidx+1,value));var nest=processSelector(sel.args,0,value);if(sidx+1+1>selectors.length){}else{nest.forEach(function(n){retval=retval.concat(processSelector(selectors,sidx+1,n))})}return retval}else if(sel.selid=="WITH"){var nest=processSelector(sel.args,0,value);if(nest.length==0){return[]}else{var r={status:1,values:nest}}}else if(sel.selid=="ROOT"){if(sidx+1+1>selectors.length){return[value]}else{return processSelector(selectors,sidx+1,fromdata)}}else{throw new Error("Wrong selector "+sel.selid)}}else if(sel.srchid){var r=alasql.srch[sel.srchid.toUpperCase()](value,sel.args,stope,params)}else{throw new Error("Selector not found")}if(typeof r=="undefined"){r={status:1,values:[value]}}var res=[];if(r.status==1){var arr=r.values;if(sidx+1+1>selectors.length){res=arr}else{for(var i=0;i<r.values.length;i++){res=res.concat(processSelector(selectors,sidx+1,arr[i]))}}}return res}}alasql.srch={};alasql.srch.PROP=function(val,args,stope){if(stope.mode=="XML"){var arr=[];val.children.forEach(function(v){if(v.name.toUpperCase()==args[0].toUpperCase()){arr.push(v)}});if(arr.length>0){return{status:1,values:arr}}else{return{status:-1,values:[]}}}else{if(typeof val!="object"||val===null||typeof args!="object"||typeof val[args[0]]=="undefined"){return{status:-1,values:[]}}else{return{status:1,values:[val[args[0]]]}}}};alasql.srch.APROP=function(val,args,stope){if(typeof val!="object"||val===null||typeof args!="object"||typeof val[args[0]]=="undefined"){return{status:1,values:[undefined]}}else{return{status:1,values:[val[args[0]]]}}};alasql.srch.ORDERBY=function(val,args,stope){var res=val.sort(compileSearchOrder(args));return{status:1,values:res}};alasql.srch.EQ=function(val,args,stope,params){var exprs=args[0].toJavaScript("x","");var exprfn=new Function("x,alasql,params","return "+exprs);if(val==exprfn(val,alasql,params)){return{status:1,values:[val]}}else{return{status:-1,values:[]}}};alasql.srch.LIKE=function(val,args,stope,params){var exprs=args[0].toJavaScript("x","");var exprfn=new Function("x,alasql,params","return "+exprs);if(val.toUpperCase().match(new RegExp("^"+exprfn(val,alasql,params).toUpperCase().replace(/%/g,".*")+"$"),"g")){return{status:1,values:[val]}}else{return{status:-1,values:[]}}};alasql.srch.ATTR=function(val,args,stope){if(stope.mode=="XML"){if(typeof args=="undefined"){return{status:1,values:[val.attributes]}}else{if(typeof val=="object"&&typeof val.attributes=="object"&&typeof val.attributes[args[0]]!="undefined"){return{status:1,values:[val.attributes[args[0]]]}}else{return{status:-1,values:[]}}}}else{throw new Error("ATTR is not using in usual mode")}};alasql.srch.CONTENT=function(val,args,stope){if(stope.mode=="XML"){return{status:1,values:[val.content]}}else{throw new Error("ATTR is not using in usual mode")}};alasql.srch.SHARP=function(val,args,stope){var obj=alasql.databases[alasql.useid].objects[args[0]];if(typeof val!="undefined"&&val===obj){return{status:1,values:[val]}}else{return{status:-1,values:[]}}};alasql.srch.PARENT=function(val,args,stope){console.log("PARENT");return{status:-1,values:[]}};alasql.srch.CHILD=function(val,args,stope){if(typeof val=="object"){if(val instanceof Array){return{status:1,values:val}}else{if(stope.mode=="XML"){return{status:1,values:Object.keys(val.children).map(function(key){return val.children[key]})}}else{return{status:1,values:Object.keys(val).map(function(key){return val[key]})}}}}else{return{status:1,values:[]}}};alasql.srch.KEYS=function(val,args){if(typeof val=="object"&&val!==null){return{status:1,values:Object.keys(val)}}else{return{status:1,values:[]}}};alasql.srch.WHERE=function(val,args){var exprs=args[0].toJavaScript("x","");var exprfn=new Function("x,alasql","return "+exprs);if(exprfn(val,alasql)){return{status:1,values:[val]}}else{return{status:-1,values:[]}}};alasql.srch.NAME=function(val,args){if(val.name==args[0]){return{status:1,values:[val]}}else{return{status:-1,values:[]}}};alasql.srch.CLASS=function(val,args){if(val.$class==args){return{status:1,values:[val]}}else{return{status:-1,values:[]}}};alasql.srch.VERTEX=function(val,args){if(val.$node=="VERTEX"){return{status:1,values:[val]}}else{return{status:-1,values:[]}}};alasql.srch.INSTANCEOF=function(val,args){if(val instanceof alasql.fn[args[0]]){return{status:1,values:[val]}}else{return{status:-1,values:[]}}};alasql.srch.EDGE=function(val,args){if(val.$node=="EDGE"){return{status:1,values:[val]}}else{return{status:-1,values:[]}}};alasql.srch.EX=function(val,args,stope,params){var exprs=args[0].toJavaScript("x","");var exprfn=new Function("x,alasql,params","return "+exprs);return{status:1,values:[exprfn(val,alasql,params)]}};alasql.srch.RETURN=function(val,args,stope,params){var res={};if(args&&args.length>0){args.forEach(function(arg){var exprs=arg.toJavaScript("x","");var exprfn=new Function("x,alasql,params","return "+exprs);if(typeof arg.as=="undefined")arg.as=arg.toString();res[arg.as]=exprfn(val,alasql,params)})}return{status:1,values:[res]}};alasql.srch.REF=function(val,args){return{status:1,values:[alasql.databases[alasql.useid].objects[val]]}};alasql.srch.OUT=function(val,args){if(val.$out&&val.$out.length>0){var res=val.$out.map(function(v){return alasql.databases[alasql.useid].objects[v]});return{status:1,values:res}}else{return{status:-1,values:[]}}};alasql.srch.IN=function(val,args){if(val.$in&&val.$in.length>0){var res=val.$in.map(function(v){return alasql.databases[alasql.useid].objects[v]});return{status:1,values:res}}else{return{status:-1,values:[]}}};alasql.srch.AS=function(val,args){alasql.vars[args[0]]=val;return{status:1,values:[val]}};alasql.srch.AT=function(val,args){var v=alasql.vars[args[0]];return{status:1,values:[v]}};alasql.srch.CLONEDEEP=function(val,args){var z=cloneDeep(val);return{status:1,values:[z]}};alasql.srch.SET=function(val,args,stope,params){var s=args.map(function(st){if(st.method=="@"){return"alasql.vars['"+st.variable+"']="+st.expression.toJavaScript("x","")}else if(st.method=="$"){return"params['"+st.variable+"']="+st.expression.toJavaScript("x","")}else{return"x['"+st.column.columnid+"']="+st.expression.toJavaScript("x","")}}).join(";");var setfn=new Function("x,params,alasql",s);setfn(val,params,alasql);return{status:1,values:[val]}};alasql.srch.ROW=function(val,args,stope,params){var s="var y;return [";s+=args.map(function(arg){return arg.toJavaScript("x","")}).join(",");s+="]";var setfn=new Function("x,params,alasql",s);var rv=setfn(val,params,alasql);return{status:1,values:[rv]}};alasql.srch.D3=function(val,args,stope,params){if(val.$node=="VERTEX"){}else if(val.$node=="EDGE"){val.source=val.$in[0];val.target=val.$out[0]}return{status:1,values:[val]}};compileSearchOrder=function(order){if(order){if(order&&order.length==1&&order[0].expression&&typeof order[0].expression=="function"){var func=order[0].expression;return function(a,b){var ra=func(a),rb=func(b);if(ra>rb)return 1;if(ra==rb)return 0;return-1}}var s="";var sk="";order.forEach(function(ord,idx){var dg="";if(ord.expression instanceof yy.NumValue){ord.expression=self.columns[ord.expression.value-1]}if(ord.expression instanceof yy.Column){var columnid=ord.expression.columnid;if(alasql.options.valueof)dg=".valueOf()";if(ord.nocase)dg+=".toUpperCase()";if(columnid=="_"){s+="if(a"+dg+(ord.direction=="ASC"?">":"<")+"b"+dg+")return 1;";s+="if(a"+dg+"==b"+dg+"){"}else{s+="if((a['"+columnid+"']||'')"+dg+(ord.direction=="ASC"?">":"<")+"(b['"+columnid+"']||'')"+dg+")return 1;";s+="if((a['"+columnid+"']||'')"+dg+"==(b['"+columnid+"']||'')"+dg+"){"}}else{dg=".valueOf()";if(ord.nocase)dg+=".toUpperCase()";s+="if(("+ord.toJavaScript("a","")+"||'')"+dg+(ord.direction=="ASC"?">(":"<(")+ord.toJavaScript("b","")+"||'')"+dg+")return 1;";s+="if(("+ord.toJavaScript("a","")+"||'')"+dg+"==("+ord.toJavaScript("b","")+"||'')"+dg+"){"}sk+="}"});s+="return 0;";s+=sk+"return -1";return new Function("a,b",s)}};function queryfn(query,oldscope,cb,A,B){var ms;query.sourceslen=query.sources.length;var slen=query.sourceslen;query.query=query;query.A=A;query.B=B;query.cb=cb;query.oldscope=oldscope;if(query.queriesfn){query.sourceslen+=query.queriesfn.length;slen+=query.queriesfn.length;query.queriesdata=[];query.queriesfn.forEach(function(q,idx){q.query.params=query.params;if(false){queryfn(q.query,query.oldscope,queryfn2,-idx-1,query)}else{queryfn2([],-idx-1,query)}})}var scope;if(!oldscope)scope={};else scope=cloneDeep(oldscope);query.scope=scope;var result;query.sources.forEach(function(source,idx){source.query=query;var rs=source.datafn(query,query.params,queryfn2,idx,alasql);if(typeof rs!=undefined){if((query.intofn||query.intoallfn)&&rs instanceof Array)rs=rs.length;result=rs}source.queriesdata=query.queriesdata});if(slen==0)result=queryfn3(query);return result}function queryfn2(data,idx,query){if(idx>=0){var source=query.sources[idx];source.data=data;if(typeof source.data=="function"){source.getfn=source.data;source.dontcache=source.getfn.dontcache;if(source.joinmode=="OUTER"||source.joinmode=="RIGHT"||source.joinmode=="ANTI"){source.dontcache=false}source.data={}}}else{query.queriesdata[-idx-1]=flatArray(data)}query.sourceslen--;if(query.sourceslen>0)return;return queryfn3(query)}function queryfn3(query){var scope=query.scope;preIndex(query);query.data=[];query.xgroups={};query.groups=[];var h=0;doJoin(query,scope,h);if(query.groupfn){query.data=[];if(query.groups.length==0){var g={};if(query.selectGroup.length>0){query.selectGroup.forEach(function(sg){if(sg.aggregatorid=="COUNT"||sg.aggregatorid=="SUM"){g[sg.nick]=0}else{g[sg.nick]=undefined}})}query.groups=[g]}for(var i=0,ilen=query.groups.length;i<ilen;i++){var g=query.groups[i];if(!query.havingfn||query.havingfn(g,query.params,alasql)){var d=query.selectgfn(g,query.params,alasql);query.data.push(d)}}}doDistinct(query);if(query.unionallfn){if(query.corresponding){if(!query.unionallfn.query.modifier)query.unionallfn.query.modifier=undefined;var ud=query.unionallfn(query.params)}else{if(!query.unionallfn.query.modifier)query.unionallfn.query.modifier="RECORDSET";var nd=query.unionallfn(query.params);var ud=[];for(var i=0,ilen=nd.data.length;i<ilen;i++){var r={};for(var j=0,jlen=Math.min(query.columns.length,nd.columns.length);j<jlen;j++){r[query.columns[j].columnid]=nd.data[i][nd.columns[j].columnid]}ud.push(r)}}query.data=query.data.concat(ud)}else if(query.unionfn){if(query.corresponding){if(!query.unionfn.query.modifier)query.unionfn.query.modifier="ARRAY";var ud=query.unionfn(query.params)}else{if(!query.unionfn.query.modifier)query.unionfn.query.modifier="RECORDSET";var nd=query.unionfn(query.params);var ud=[];for(var i=0,ilen=nd.data.length;i<ilen;i++){var r={};for(var j=0,jlen=Math.min(query.columns.length,nd.columns.length);j<jlen;j++){r[query.columns[j].columnid]=nd.data[i][nd.columns[j].columnid]}ud.push(r)}}query.data=arrayUnionDeep(query.data,ud)}else if(query.exceptfn){if(query.corresponding){if(!query.exceptfn.query.modifier)query.exceptfn.query.modifier="ARRAY";var ud=query.exceptfn(query.params)}else{if(!query.exceptfn.query.modifier)query.exceptfn.query.modifier="RECORDSET";var nd=query.exceptfn(query.params);var ud=[];for(var i=0,ilen=nd.data.length;i<ilen;i++){var r={};for(var j=0,jlen=Math.min(query.columns.length,nd.columns.length);j<jlen;j++){r[query.columns[j].columnid]=nd.data[i][nd.columns[j].columnid]}ud.push(r)}}query.data=arrayExceptDeep(query.data,ud)}else if(query.intersectfn){if(query.corresponding){if(!query.intersectfn.query.modifier)query.intersectfn.query.modifier=undefined;var ud=query.intersectfn(query.params)}else{if(!query.intersectfn.query.modifier)query.intersectfn.query.modifier="RECORDSET";var nd=query.intersectfn(query.params);var ud=[];for(var i=0,ilen=nd.data.length;i<ilen;i++){var r={};for(var j=0,jlen=Math.min(query.columns.length,nd.columns.length);j<jlen;j++){r[query.columns[j].columnid]=nd.data[i][nd.columns[j].columnid]}ud.push(r)}}query.data=arrayIntersectDeep(query.data,ud)}if(query.orderfn){if(query.explain)var ms=Date.now();query.data=query.data.sort(query.orderfn);if(query.explain){query.explaination.push({explid:query.explid++,description:"QUERY BY",ms:Date.now()-ms})}}doLimit(query);if(typeof angular!="undefined"){query.removeKeys.push("$$hashKey")}if(query.removeKeys.length>0){var removeKeys=query.removeKeys;var jlen=removeKeys.length;if(jlen>0){for(var i=0,ilen=query.data.length;i<ilen;i++){for(var j=0;j<jlen;j++){delete query.data[i][removeKeys[j]]}}}if(query.columns.length>0){query.columns=query.columns.filter(function(column){var found=false;removeKeys.forEach(function(key){if(column.columnid==key)found=true});return!found})}}if(typeof query.removeLikeKeys!="undefined"&&query.removeLikeKeys.length>0){var removeLikeKeys=query.removeLikeKeys;for(var i=0,ilen=query.data.length;i<ilen;i++){var r=query.data[i];for(var k in r){for(var j=0;j<query.removeLikeKeys.length;j++){if(k.match(query.removeLikeKeys[j])){delete r[k]}}}}if(query.columns.length>0){query.columns=query.columns.filter(function(column){var found=false;removeLikeKeys.forEach(function(key){if(column.columnid.match(key))found=true});return!found})}}if(query.intoallfn){var res=query.intoallfn(query.columns,query.cb,query.params,query.alasql);return res}else if(query.intofn){for(var i=0,ilen=query.data.length;i<ilen;i++){query.intofn(query.data[i],i,query.params,query.alasql)}if(query.cb)query.cb(query.data.length,query.A,query.B);return query.data.length}else{var res=query.data;if(query.cb)res=query.cb(query.data,query.A,query.B);return res}}function doLimit(query){if(query.limit){var offset=0;if(query.offset)offset=(query.offset|0)-1||0;var limit;if(query.percent){limit=(query.data.length*query.limit/100|0)+offset}else{limit=(query.limit|0)+offset}query.data=query.data.slice(offset,limit)}}function doDistinct(query){if(query.distinct){var uniq={};for(var i=0,ilen=query.data.length;i<ilen;i++){var uix=Object.keys(query.data[i]).map(function(k){return query.data[i][k]}).join("`");uniq[uix]=query.data[i]}query.data=[];for(var key in uniq)query.data.push(uniq[key])}}preIndex=function(query){for(var k=0,klen=query.sources.length;k<klen;k++){var source=query.sources[k];if(k>0&&source.optimization=="ix"&&source.onleftfn&&source.onrightfn){if(source.databaseid&&alasql.databases[source.databaseid].tables[source.tableid]){if(!alasql.databases[source.databaseid].tables[source.tableid].indices)query.database.tables[source.tableid].indices={};var ixx=alasql.databases[source.databaseid].tables[source.tableid].indices[hash(source.onrightfns+"`"+source.srcwherefns)];if(!alasql.databases[source.databaseid].tables[source.tableid].dirty&&ixx){source.ix=ixx}}if(!source.ix){source.ix={};var scope={};var i=0;var ilen=source.data.length;var dataw;while((dataw=source.data[i])||source.getfn&&(dataw=source.getfn(i))||i<ilen){if(source.getfn&&!source.dontcache)source.data[i]=dataw;scope[source.alias||source.tableid]=dataw;if(source.srcwherefn(scope,query.params,alasql)){var addr=source.onrightfn(scope,query.params,alasql);var group=source.ix[addr];if(!group){group=source.ix[addr]=[]}group.push(dataw)}i++}if(source.databaseid&&alasql.databases[source.databaseid].tables[source.tableid]){alasql.databases[source.databaseid].tables[source.tableid].indices[hash(source.onrightfns+"`"+source.srcwherefns)]=source.ix}}}else if(source.wxleftfn){if(!alasql.databases[source.databaseid].engineid){var ixx=alasql.databases[source.databaseid].tables[source.tableid].indices[hash(source.wxleftfns+"`")]
    }if(!alasql.databases[source.databaseid].tables[source.tableid].dirty&&ixx){source.ix=ixx;source.data=source.ix[source.wxrightfn(null,query.params,alasql)]}else{source.ix={};var scope={};var i=0;var ilen=source.data.length;var dataw;while((dataw=source.data[i])||source.getfn&&(dataw=source.getfn(i))||i<ilen){if(source.getfn&&!source.dontcache)source.data[i]=dataw;scope[source.alias||source.tableid]=source.data[i];var addr=source.wxleftfn(scope,query.params,alasql);var group=source.ix[addr];if(!group){group=source.ix[addr]=[]}group.push(source.data[i]);i++}if(!alasql.databases[source.databaseid].engineid){alasql.databases[source.databaseid].tables[source.tableid].indices[hash(source.wxleftfns+"`")]=source.ix}}if(source.srcwherefns){if(source.data){var scope={};source.data=source.data.filter(function(r){scope[source.alias]=r;return source.srcwherefn(scope,query.params,alasql)})}else{source.data=[]}}}else if(source.srcwherefns&&!source.dontcache){if(source.data){var scope={};source.data=source.data.filter(function(r){scope[source.alias]=r;return source.srcwherefn(scope,query.params,alasql)});var scope={};var i=0;var ilen=source.data.length;var dataw;var res=[];while((dataw=source.data[i])||source.getfn&&(dataw=source.getfn(i))||i<ilen){if(source.getfn&&!source.dontcache)source.data[i]=dataw;scope[source.alias]=dataw;if(source.srcwherefn(scope,query.params,alasql))res.push(dataw);i++}source.data=res}else{source.data=[]}}if(source.databaseid&&alasql.databases[source.databaseid].tables[source.tableid]){}else{}}};function doJoin(query,scope,h){if(h>=query.sources.length){if(query.wherefn(scope,query.params,alasql)){if(query.groupfn){query.groupfn(scope,query.params,alasql)}else{query.data.push(query.selectfn(scope,query.params,alasql))}}}else if(query.sources[h].applyselect){var source=query.sources[h];source.applyselect(query.params,function(data){if(data.length>0){for(var i=0;i<data.length;i++){scope[source.alias]=data[i];doJoin(query,scope,h+1)}}else{if(source.applymode=="OUTER"){scope[source.alias]={};doJoin(query,scope,h+1)}}},scope)}else{var source=query.sources[h];var nextsource=query.sources[h+1];if(true){var tableid=source.alias||source.tableid;var pass=false;var data=source.data;var opt=false;if(!source.getfn||source.getfn&&!source.dontcache){if(source.joinmode!="RIGHT"&&source.joinmode!="OUTER"&&source.joinmode!="ANTI"&&source.optimization=="ix"){data=source.ix[source.onleftfn(scope,query.params,alasql)]||[];opt=true}}var i=0;if(typeof data=="undefined"){throw new Error("Data source number "+h+" in undefined")}var ilen=data.length;var dataw;while((dataw=data[i])||!opt&&(source.getfn&&(dataw=source.getfn(i)))||i<ilen){if(!opt&&source.getfn&&!source.dontcache)data[i]=dataw;scope[tableid]=dataw;if(!source.onleftfn||source.onleftfn(scope,query.params,alasql)==source.onrightfn(scope,query.params,alasql)){if(source.onmiddlefn(scope,query.params,alasql)){if(source.joinmode!="SEMI"&&source.joinmode!="ANTI"){doJoin(query,scope,h+1)}if(source.joinmode!="LEFT"&&source.joinmode!="INNER"){dataw._rightjoin=true}pass=true}}i++}if((source.joinmode=="LEFT"||source.joinmode=="OUTER"||source.joinmode=="SEMI")&&!pass){scope[tableid]={};doJoin(query,scope,h+1)}}if(h+1<query.sources.length){if(nextsource.joinmode=="OUTER"||nextsource.joinmode=="RIGHT"||nextsource.joinmode=="ANTI"){scope[source.alias]={};var j=0;var jlen=nextsource.data.length;var dataw;while((dataw=nextsource.data[j])||nextsource.getfn&&(dataw=nextsource.getfn(j))||j<jlen){if(nextsource.getfn&&!nextsource.dontcache)nextsource.data[j]=dataw;if(!dataw._rightjoin){scope[nextsource.alias]=dataw;doJoin(query,scope,h+2)}else{delete dataw._rightjoin}j++}}}scope[tableid]=undefined}}function swapSources(query,h){var source=query.sources[h];var nextsource=query.sources[h+1];var onleftfn=source.onleftfn;var onleftfns=source.onleftfns;var onrightfn=source.onrightfn;var onrightfns=source.onrightfns;var optimization=source.optimization;source.onleftfn=nextsource.onrightfn;source.onleftfns=nextsource.onrightfns;source.onrightfn=nextsource.onleftfn;source.onrightfns=nextsource.onleftfns;source.optimization=nextsource.optimization;nextsource.onleftfn=onleftfn;nextsource.onleftfns=onleftfns;nextsource.onrightfn=onrightfn;nextsource.onrightfns=onrightfns;nextsource.optimization=optimization;query.sources[h]=nextsource;query.sources[h+1]=source}yy.Select=function(params){return yy.extend(this,params)};yy.Select.prototype.toString=function(){var s="";if(this.explain)s+=K("EXPLAIN")+" ";s+=K("SELECT")+" ";if(this.modifier)s+=K(this.modifier)+" ";if(this.top){s+=K("TOP")+" "+N(this.top.value)+" ";if(this.percent)s+=K("PERCENT")+" "}s+=this.columns.map(function(col){var s=col.toString();if(typeof col.as!="undefined")s+=" "+K("AS")+" "+L(col.as);return s}).join(", ");if(this.from){s+=NL()+ID()+K("FROM")+" "+this.from.map(function(f){var ss=f.toString();if(f.as)ss+=" "+K("AS")+" "+f.as;return ss}).join(",")}if(this.joins){s+=this.joins.map(function(jn){var ss=NL()+ID();if(jn.joinmode)ss+=K(jn.joinmode)+" ";if(jn.table)ss+=K("JOIN")+" "+jn.table.toString();else if(jn instanceof yy.Apply)ss+=jn.toString();else{throw new Error("Wrong type in JOIN mode")}if(jn.using)ss+=" "+K("USING")+" "+jn.using.toString();if(jn.on)ss+=" "+K("ON")+" "+jn.on.toString();return ss})}if(this.where)s+=NL()+ID()+K("WHERE")+" "+this.where.toString();if(this.group&&this.group.length>0){s+=NL()+ID()+K("GROUP BY")+" "+this.group.map(function(grp){return grp.toString()}).join(", ")}if(this.having)s+=NL()+ID()+K("HAVING")+" "+this.having.toString();if(this.order&&this.order.length>0){s+=NL()+ID()+K("ORDER BY")+" "+this.order.map(function(ord){return ord.toString()}).join(", ")}if(this.limit)s+=NL()+ID()+K("LIMIT")+" "+this.limit.value;if(this.offset)s+=NL()+ID()+K("OFFSET")+" "+this.offset.value;if(this.union)s+=NL()+K("UNION")+(this.corresponding?" "+K("CORRESPONDING"):"")+NL()+this.union.toString();if(this.unionall)s+=NL()+K("UNION ALL")+(this.corresponding?" "+K("CORRESPONDING"):"")+NL()+this.unionall.toString();if(this.except)s+=NL()+K("EXCEPT")+(this.corresponding?" "+K("CORRESPONDING"):"")+NL()+this.except.toString();if(this.intersect)s+=NL()+K("INTERSECT")+(this.corresponding?" "+K("CORRESPONDING"):"")+NL()+this.intersect.toString();return s};yy.Select.prototype.toJavaScript=function(context,tableid,defcols){var s="alasql.utils.flatArray(this.queriesfn["+(this.queriesidx-1)+"](this.params,null,"+context+"))[0]";return s};yy.Select.prototype.compile=function(databaseid){var db=alasql.databases[databaseid];var query=new Query;query.removeKeys=[];query.explain=this.explain;query.explaination=[];query.explid=1;query.modifier=this.modifier;query.database=db;this.compileWhereExists(query);this.compileQueries(query);query.defcols=this.compileDefCols(query,databaseid);query.fromfn=this.compileFrom(query);if(this.joins)this.compileJoins(query);query.rownums=[];this.compileSelectGroup0(query);if(this.group||query.selectGroup.length>0){query.selectgfns=this.compileSelectGroup1(query)}else{query.selectfns=this.compileSelect1(query)}this.compileRemoveColumns(query);if(this.where)this.compileWhereJoins(query);query.wherefn=this.compileWhere(query);if(this.group||query.selectGroup.length>0)query.groupfn=this.compileGroup(query);if(this.having)query.havingfn=this.compileHaving(query);if(this.group||query.selectGroup.length>0){query.selectgfn=this.compileSelectGroup2(query)}else{query.selectfn=this.compileSelect2(query)}query.distinct=this.distinct;if(this.order)query.orderfn=this.compileOrder(query);if(this.top){query.limit=this.top.value}else if(this.limit){query.limit=this.limit.value;if(this.offset){query.offset=this.offset.value}}query.percent=this.percent;query.corresponding=this.corresponding;if(this.union){query.unionfn=this.union.compile(databaseid);if(this.union.order){query.orderfn=this.union.compileOrder(query)}else{query.orderfn=null}}else if(this.unionall){query.unionallfn=this.unionall.compile(databaseid);if(this.unionall.order){query.orderfn=this.unionall.compileOrder(query)}else{query.orderfn=null}}else if(this.except){query.exceptfn=this.except.compile(databaseid);if(this.except.order){query.orderfn=this.except.compileOrder(query)}else{query.orderfn=null}}else if(this.intersect){query.intersectfn=this.intersect.compile(databaseid);if(this.intersect.order){query.intersectfn=this.intersect.compileOrder(query)}else{query.orderfn=null}}if(this.into){if(this.into instanceof yy.Table){if(alasql.options.autocommit&&alasql.databases[this.into.databaseid||databaseid].engineid){query.intoallfns='return alasql.engines["'+alasql.databases[this.into.databaseid||databaseid].engineid+'"]'+'.intoTable("'+(this.into.databaseid||databaseid)+'","'+this.into.tableid+'",this.data, columns, cb);'}else{query.intofns="alasql.databases['"+(this.into.databaseid||databaseid)+"'].tables"+"['"+this.into.tableid+"'].data.push(r);"}}else if(this.into instanceof yy.VarValue){query.intoallfns='alasql.vars["'+this.into.variable+'"]=this.data;res=this.data.length;if(cb)res=cb(res);return res;'}else if(this.into instanceof yy.FuncValue){var qs="return alasql.into['"+this.into.funcid.toUpperCase()+"'](";if(this.into.args&&this.into.args.length>0){qs+=this.into.args[0].toJavaScript()+",";if(this.into.args.length>1){qs+=this.into.args[1].toJavaScript()+","}else{qs+="undefined,"}}else{qs+="undefined, undefined,"}query.intoallfns=qs+"this.data,columns,cb)"}else if(this.into instanceof yy.ParamValue){query.intofns="params['"+this.into.param+"'].push(r)"}if(query.intofns){query.intofn=new Function("r,i,params,alasql","var y;"+query.intofns)}else if(query.intoallfns){query.intoallfn=new Function("columns,cb,params,alasql","var y;"+query.intoallfns)}}var statement=function(params,cb,oldscope){query.params=params;var res1=queryfn(query,oldscope,function(res){if(query.rownums.length>0){for(var i=0,ilen=res.length;i<ilen;i++){for(var j=0,jlen=query.rownums.length;j<jlen;j++){res[i][query.rownums[j]]=i+1}}}var res2=modify(query,res);if(cb)cb(res2);return res2});return res1};statement.query=query;return statement};function modify(query,res){if(typeof res=="undefined"||typeof res=="number"||typeof res=="string"||typeof res=="boolean"){return res}var modifier=query.modifier||alasql.options.modifier;var columns=query.columns;if(typeof columns=="undefined"||columns.length==0){if(res.length>0){var allcol={};for(var i=0;i<Math.min(res.length,alasql.options.columnlookup||10);i++){for(var key in res[i]){allcol[key]=true}}columns=Object.keys(allcol).map(function(columnid){return{columnid:columnid}})}else{columns=[]}}if(modifier=="VALUE"){if(res.length>0){var key;if(columns&&columns.length>0)key=columns[0].columnid;else key=Object.keys(res[0])[0];res=res[0][key]}else{res=undefined}}if(modifier=="ROW"){if(res.length>0){var key;var a=[];for(var key in res[0]){a.push(res[0][key])}res=a}else{res=undefined}}if(modifier=="COLUMN"){var ar=[];if(res.length>0){var key;if(columns&&columns.length>0)key=columns[0].columnid;else key=Object.keys(res[0])[0];for(var i=0,ilen=res.length;i<ilen;i++){ar.push(res[i][key])}}res=ar}if(modifier=="MATRIX"){var ar=[];for(var i=0;i<res.length;i++){var a=[];var r=res[i];for(var j=0;j<columns.length;j++){a.push(r[columns[j].columnid])}ar.push(a)}res=ar}if(modifier=="INDEX"){var ar={};var key,val;if(columns&&columns.length>0){key=columns[0].columnid;val=columns[1].columnid}else{var okeys=Object.keys(res[0]);key=okeys[0];val=okeys[1]}for(var i=0,ilen=res.length;i<ilen;i++){ar[res[i][key]]=res[i][val]}res=ar}if(modifier=="RECORDSET"){res=new alasql.Recordset({data:res,columns:columns})}if(modifier=="TEXTSTRING"){var key;if(columns&&columns.length>0)key=columns[0].columnid;else key=Object.keys(res[0])[0];var s="";for(var i=0,ilen=res.length;i<ilen;i++){res[i]=res[i][key]}res=res.join("\n")}return res}yy.Select.prototype.execute=function(databaseid,params,cb){return this.compile(databaseid)(params,cb)};yy.ExistsValue=function(params){return yy.extend(this,params)};yy.ExistsValue.prototype.toString=function(){return"EXISTS("+this.value.toString()+")"};yy.ExistsValue.prototype.toType=function(){return"boolean"};yy.ExistsValue.prototype.toJavaScript=function(context,tableid,defcols){return"this.existsfn["+this.existsidx+"](params,null,"+context+").data.length"};yy.Select.prototype.compileWhereExists=function(query){if(!this.exists)return;query.existsfn=this.exists.map(function(ex){var nq=ex.compile(query.database.databaseid);nq.query.modifier="RECORDSET";return nq})};yy.Select.prototype.compileQueries=function(query){if(!this.queries)return;query.queriesfn=this.queries.map(function(q){var nq=q.compile(query.database.databaseid);nq.query.modifier="RECORDSET";return nq})};alasql.precompile=function(statement,databaseid,params){if(!statement)return;statement.params=params;if(statement.queries){statement.queriesfn=statement.queries.map(function(q){var nq=q.compile(databaseid||statement.database.databaseid);nq.query.modifier="RECORDSET";return nq})}if(statement.exists){statement.existsfn=statement.exists.map(function(ex){var nq=ex.compile(databaseid||statement.database.databaseid);nq.query.modifier="RECORDSET";return nq})}};yy.Select.prototype.compileFrom=function(query){var self=this;query.sources=[];query.aliases={};if(!self.from)return;self.from.forEach(function(tq){var alias=tq.as||tq.tableid;if(tq instanceof yy.Table){query.aliases[alias]={tableid:tq.tableid,databaseid:tq.databaseid||query.database.databaseid,type:"table"}}else if(tq instanceof yy.Select){query.aliases[alias]={type:"subquery"}}else if(tq instanceof yy.Search){query.aliases[alias]={type:"subsearch"}}else if(tq instanceof yy.ParamValue){query.aliases[alias]={type:"paramvalue"}}else if(tq instanceof yy.FuncValue){query.aliases[alias]={type:"funcvalue"}}else if(tq instanceof yy.VarValue){query.aliases[alias]={type:"varvalue"}}else if(tq instanceof yy.FromData){query.aliases[alias]={type:"fromdata"}}else if(tq instanceof yy.Json){query.aliases[alias]={type:"json"}}else{throw new Error("Wrong table at FROM")}var source={alias:alias,databaseid:tq.databaseid||query.database.databaseid,tableid:tq.tableid,joinmode:"INNER",onmiddlefn:returnTrue,srcwherefns:"",srcwherefn:returnTrue};if(tq instanceof yy.Table){source.columns=alasql.databases[source.databaseid].tables[source.tableid].columns;if(alasql.options.autocommit&&alasql.databases[source.databaseid].engineid){source.datafn=function(query,params,cb,idx,alasql){return alasql.engines[alasql.databases[source.databaseid].engineid].fromTable(source.databaseid,source.tableid,cb,idx,query)}}else if(alasql.databases[source.databaseid].tables[source.tableid].view){source.datafn=function(query,params,cb,idx,alasql){var res=alasql.databases[source.databaseid].tables[source.tableid].select(params);if(cb)res=cb(res,idx,query);return res}}else{source.datafn=function(query,params,cb,idx,alasql){var res=alasql.databases[source.databaseid].tables[source.tableid].data;if(cb)res=cb(res,idx,query);return res}}}else if(tq instanceof yy.Select){source.subquery=tq.compile(query.database.databaseid);if(typeof source.subquery.query.modifier=="undefined"){source.subquery.query.modifier="RECORDSET"}source.columns=source.subquery.query.columns;source.datafn=function(query,params,cb,idx,alasql){var res;source.subquery(query.params,function(data){res=data.data;if(cb)res=cb(res,idx,query);return res});return res}}else if(tq instanceof yy.Search){source.subsearch=tq;source.columns=[];source.datafn=function(query,params,cb,idx,alasql){var res;source.subsearch.execute(query.database.databaseid,query.params,function(data){res=data;if(cb)res=cb(res,idx,query);return res});return res}}else if(tq instanceof yy.ParamValue){var ps="var res = alasql.prepareFromData(params['"+tq.param+"']";if(tq.array)ps+=",true";ps+=");if(cb)res=cb(res,idx,query);return res";source.datafn=new Function("query,params,cb,idx,alasql",ps)}else if(tq instanceof yy.Json){var ps="var res = alasql.prepareFromData("+tq.toJavaScript();if(tq.array)ps+=",true";ps+=");if(cb)res=cb(res,idx,query);return res";source.datafn=new Function("query,params,cb,idx,alasql",ps)}else if(tq instanceof yy.VarValue){var ps="var res = alasql.prepareFromData(alasql.vars['"+tq.variable+"']";if(tq.array)ps+=",true";ps+=");if(cb)res=cb(res,idx,query);return res";source.datafn=new Function("query,params,cb,idx,alasql",ps)}else if(tq instanceof yy.FuncValue){var s="var res=alasql.from['"+tq.funcid.toUpperCase()+"'](";if(tq.args&&tq.args.length>0){if(tq.args[0]){s+=tq.args[0].toJavaScript("query.oldscope")+","}else{s+="null,"}if(tq.args[1]){s+=tq.args[1].toJavaScript("query.oldscope")+","}else{s+="null,"}}else{s+="null,null,"}s+="cb,idx,query";s+=");/*if(cb)res=cb(res,idx,query);*/return res";source.datafn=new Function("query, params, cb, idx, alasql",s)}else if(tq instanceof yy.FromData){source.datafn=function(query,params,cb,idx,alasql){var res=tq.data;if(cb)res=cb(res,idx,query);return res}}else{throw new Error("Wrong table at FROM")}query.sources.push(source)});query.defaultTableid=query.sources[0].alias};alasql.prepareFromData=function(data,array){var res=data;if(typeof data=="string"){res=data.split(/\r?\n/);if(array){for(var i=0,ilen=res.length;i<ilen;i++){res[i]=[res[i]]}}}else if(array){res=[];for(var i=0,ilen=data.length;i<ilen;i++){res.push([data[i]])}}else if(typeof data=="object"&&!(data instanceof Array)){if(typeof Mongo!="undefined"&&typeof Mongo.Collection!="undefined"&&data instanceof Mongo.Collection){res=data.find().fetch()}else{res=[];for(var key in data){if(data.hasOwnProperty(key))res.push([key,data[key]])}}}return res};yy.Select.prototype.compileJoins=function(query){var self=this;this.joins.forEach(function(jn){if(jn.joinmode=="CROSS"){if(jn.using||jn.on){throw new Error("CROSS JOIN cannot have USING or ON clauses")}else{jn.joinmode=="INNER"}}var source;var tq;if(jn instanceof yy.Apply){source={alias:jn.as,applymode:jn.applymode,onmiddlefn:returnTrue,srcwherefns:"",srcwherefn:returnTrue,columns:[]};source.applyselect=jn.select.compile(query.database.databaseid);source.columns=source.applyselect.query.columns;source.datafn=function(query,params,cb,idx,alasql){var res;if(cb)res=cb(res,idx,query);return res};query.sources.push(source)}else{if(jn.table){tq=jn.table;source={alias:jn.as||tq.tableid,databaseid:tq.databaseid||query.database.databaseid,tableid:tq.tableid,joinmode:jn.joinmode,onmiddlefn:returnTrue,srcwherefns:"",srcwherefn:returnTrue,columns:[]};if(!alasql.databases[source.databaseid].tables[source.tableid]){throw new Error("Table '"+source.tableid+"' is not exists in database '"+source.databaseid)+"'"}source.columns=alasql.databases[source.databaseid].tables[source.tableid].columns;if(alasql.options.autocommit&&alasql.databases[source.databaseid].engineid){source.datafn=function(query,params,cb,idx,alasql){return alasql.engines[alasql.databases[source.databaseid].engineid].fromTable(source.databaseid,source.tableid,cb,idx,query)}}else if(alasql.databases[source.databaseid].tables[source.tableid].view){source.datafn=function(query,params,cb,idx,alasql){var res=alasql.databases[source.databaseid].tables[source.tableid].select(params);if(cb)res=cb(res,idx,query);return res}}else{source.datafn=function(query,params,cb,idx,alasql){var res=alasql.databases[source.databaseid].tables[source.tableid].data;if(cb)res=cb(res,idx,query);return res}}query.aliases[source.alias]={tableid:tq.tableid,databaseid:tq.databaseid||query.database.databaseid}}else if(jn.select){var tq=jn.select;source={alias:jn.as,joinmode:jn.joinmode,onmiddlefn:returnTrue,srcwherefns:"",srcwherefn:returnTrue,columns:[]};source.subquery=tq.compile(query.database.databaseid);if(typeof source.subquery.query.modifier=="undefined"){source.subquery.query.modifier="RECORDSET"}source.columns=source.subquery.query.columns;source.datafn=function(query,params,cb,idx,alasql){return source.subquery(query.params,null,cb,idx).data};query.aliases[source.alias]={type:"subquery"}}else if(jn.param){source={alias:jn.as,joinmode:jn.joinmode,onmiddlefn:returnTrue,srcwherefns:"",srcwherefn:returnTrue};var jnparam=jn.param.param;var ps="var res=alasql.prepareFromData(params['"+jnparam+"']";if(jn.array)ps+=",true";ps+=");if(cb)res=cb(res, idx, query);return res";source.datafn=new Function("query,params,cb,idx, alasql",ps);query.aliases[source.alias]={type:"paramvalue"}}else if(jn.variable){source={alias:jn.as,joinmode:jn.joinmode,onmiddlefn:returnTrue,srcwherefns:"",srcwherefn:returnTrue};var ps="var res=alasql.prepareFromData(alasql.vars['"+jn.variable+"']";if(jn.array)ps+=",true";ps+=");if(cb)res=cb(res, idx, query);return res";source.datafn=new Function("query,params,cb,idx, alasql",ps);query.aliases[source.alias]={type:"varvalue"}}else if(jn.funcid){source={alias:jn.as,joinmode:jn.joinmode,onmiddlefn:returnTrue,srcwherefns:"",srcwherefn:returnTrue};var s="var res=alasql.from['"+js.funcid.toUpperCase()+"'](";if(jn.args&&jn.args.length>0){if(jn.args[0]){s+=jn.args[0].toJavaScript("query.oldscope")+","}else{s+="null,"}if(jn.args[1]){s+=jn.args[1].toJavaScript("query.oldscope")+","}else{s+="null,"}}else{s+="null,null,"}s+="cb,idx,query";s+=");/*if(cb)res=cb(res,idx,query);*/return res";source.datafn=new Function("query, params, cb, idx, alasql",s);query.aliases[source.alias]={type:"funcvalue"}}var alias=source.alias;if(jn.natural){if(jn.using||jn.on){throw new Error("NATURAL JOIN cannot have USING or ON clauses")}else{if(query.sources.length>0){var prevSource=query.sources[query.sources.length-1];var prevTable=alasql.databases[prevSource.databaseid].tables[prevSource.tableid];var table=alasql.databases[source.databaseid].tables[source.tableid];if(prevTable&&table){var c1=prevTable.columns.map(function(col){return col.columnid});var c2=table.columns.map(function(col){return col.columnid});jn.using=arrayIntersect(c1,c2).map(function(colid){return{columnid:colid}})}else{throw new Error("In this version of Alasql NATURAL JOIN "+"works for tables with predefined columns only")}}}}if(jn.using){var prevSource=query.sources[query.sources.length-1];source.onleftfns=jn.using.map(function(col){return"p['"+(prevSource.alias||prevSource.tableid)+"']['"+col.columnid+"']"}).join('+"`"+');source.onleftfn=new Function("p,params,alasql","var y;return "+source.onleftfns);source.onrightfns=jn.using.map(function(col){return"p['"+(source.alias||source.tableid)+"']['"+col.columnid+"']"}).join('+"`"+');source.onrightfn=new Function("p,params,alasql","var y;return "+source.onrightfns);source.optimization="ix"}else if(jn.on){if(jn.on instanceof yy.Op&&jn.on.op=="="&&!jn.on.allsome){source.optimization="ix";var lefts="";var rights="";var middles="";var middlef=false;var ls=jn.on.left.toJavaScript("p",query.defaultTableid,query.defcols);var rs=jn.on.right.toJavaScript("p",query.defaultTableid,query.defcols);if(ls.indexOf("p['"+alias+"']")>-1&&!(rs.indexOf("p['"+alias+"']")>-1)){if((ls.match(/p\[\'.*?\'\]/g)||[]).every(function(s){return s=="p['"+alias+"']"})){rights=ls}else{middlef=true}}else if(!(ls.indexOf("p['"+alias+"']")>-1)&&rs.indexOf("p['"+alias+"']")>-1){if((rs.match(/p\[\'.*?\'\]/g)||[]).every(function(s){return s=="p['"+alias+"']"})){lefts=ls}else{middlef=true}}else{middlef=true}if(rs.indexOf("p['"+alias+"']")>-1&&!(ls.indexOf("p['"+alias+"']")>-1)){if((rs.match(/p\[\'.*?\'\]/g)||[]).every(function(s){return s=="p['"+alias+"']"})){rights=rs}else{middlef=true}}else if(!(rs.indexOf("p['"+alias+"']")>-1)&&ls.indexOf("p['"+alias+"']")>-1){if((ls.match(/p\[\'.*?\'\]/g)||[]).every(function(s){return s=="p['"+alias+"']"})){lefts=rs}else{middlef=true}}else{middlef=true}if(middlef){rights="";lefts="";middles=jn.on.toJavaScript("p",query.defaultTableid,query.defcols);source.optimization="no"}source.onleftfns=lefts;source.onrightfns=rights;source.onmiddlefns=middles||"true";source.onleftfn=new Function("p,params,alasql","var y;return "+source.onleftfns);source.onrightfn=new Function("p,params,alasql","var y;return "+source.onrightfns);source.onmiddlefn=new Function("p,params,alasql","var y;return "+source.onmiddlefns)}else{source.optimization="no";source.onmiddlefns=jn.on.toJavaScript("p",query.defaultTableid,query.defcols);source.onmiddlefn=new Function("p,params,alasql","var y;return "+jn.on.toJavaScript("p",query.defaultTableid,query.defcols))}}query.sources.push(source)}})};yy.Select.prototype.compileWhere=function(query){if(this.where){if(typeof this.where=="function"){return this.where}else{s=this.where.toJavaScript("p",query.defaultTableid,query.defcols);query.wherefns=s;return new Function("p,params,alasql","var y;return "+s)}}else return function(){return true}};yy.Select.prototype.compileWhereJoins=function(query){return;optimizeWhereJoin(query,this.where.expression);query.sources.forEach(function(source){if(source.srcwherefns){source.srcwherefn=new Function("p,params,alasql","var y;return "+source.srcwherefns)}if(source.wxleftfns){source.wxleftfn=new Function("p,params,alasql","var y;return "+source.wxleftfns)}if(source.wxrightfns){source.wxrightfn=new Function("p,params,alasql","var y;return "+source.wxrightfns)}})};function optimizeWhereJoin(query,ast){if(!ast)return false;if(!(ast instanceof yy.Op))return;if(ast.op!="="&&ast.op!="AND")return;if(ast.allsome)return;var s=ast.toJavaScript("p",query.defaultTableid,query.defcols);var fsrc=[];query.sources.forEach(function(source,idx){if(source.tableid){if(s.indexOf("p['"+source.alias+"']")>-1)fsrc.push(source)}});if(fsrc.length==0){return}else if(fsrc.length==1){if(!(s.match(/p\[\'.*?\'\]/g)||[]).every(function(s){return s=="p['"+fsrc[0].alias+"']"})){return}var src=fsrc[0];src.srcwherefns=src.srcwherefns?src.srcwherefns+"&&"+s:s;if(ast instanceof yy.Op&&(ast.op=="="&&!ast.allsome)){if(ast.left instanceof yy.Column){var ls=ast.left.toJavaScript("p",query.defaultTableid,query.defcols);var rs=ast.right.toJavaScript("p",query.defaultTableid,query.defcols);if(rs.indexOf("p['"+fsrc[0].alias+"']")==-1){fsrc[0].wxleftfns=ls;fsrc[0].wxrightfns=rs}}if(ast.right instanceof yy.Column){var ls=ast.left.toJavaScript("p",query.defaultTableid,query.defcols);var rs=ast.right.toJavaScript("p",query.defaultTableid,query.defcols);if(ls.indexOf("p['"+fsrc[0].alias+"']")==-1){fsrc[0].wxleftfns=rs;fsrc[0].wxrightfns=ls}}}ast.reduced=true;return}else{if(ast.op="AND"){optimizeWhereJoin(query,ast.left);optimizeWhereJoin(query,ast.right)}}}yy.Select.prototype.compileGroup=function(query){var self=this;if(query.sources.length>0){var tableid=query.sources[0].alias}else{var tableid=""}var defcols=query.defcols;var allgroup=[[]];if(this.group){allgroup=decartes(this.group,query)}var allgroups=[];allgroup.forEach(function(a){allgroups=arrayUnion(allgroups,a)});query.allgroups=allgroups;if(false){allgroups.forEach(function(col2){if(query.selectColumns[colid]){}else{var tmpid="default";if(query.sources.length>0)tmpid=query.sources[0].alias;if(Object.keys(query.selectColumns).length!=0)query.removeKeys.push(colid);query.selectfns+="r['"+escapeq(colid)+"']="+new yy.Column({columnid:colid}).toJavaScript("p",tmpid)+";"}})}var s="";allgroup.forEach(function(agroup){s+="var acc,g=this.xgroups[";var rg=agroup.map(function(col2){var columnid=col2.split("	")[0];var coljs=col2.split("	")[1];if(columnid=="")return"1";else return coljs});if(rg.length==0)rg=["''"];s+=rg.join('+"`"+');s+="];if(!g) {this.groups.push((g=this.xgroups[";s+=rg.join('+"`"+');s+="] = {";s+=agroup.map(function(col2){var columnid=col2.split("	")[0];var coljs=col2.split("	")[1];if(columnid=="")return"";else return"'"+columnid+"':"+coljs+","}).join("");var neggroup=arrayDiff(allgroups,agroup);s+=neggroup.map(function(col2){var columnid=col2.split("	")[0];var coljs=col2.split("	")[1];return"'"+columnid+"':null,"}).join("");var aft="";s+=query.selectGroup.map(function(col,idx){var colexp=col.expression.toJavaScript("p",tableid,defcols);var colas=col.nick;if(col instanceof yy.AggrValue){if(col.distinct){aft+=",g['$$_VALUES_"+colas+"']={},g['$$_VALUES_"+colas+"']["+colexp+"]=true"}if(col.aggregatorid=="SUM"){return"'"+colas+"':("+colexp+")||0,"}else if(col.aggregatorid=="MIN"||col.aggregatorid=="MAX"||col.aggregatorid=="FIRST"||col.aggregatorid=="LAST"){return"'"+colas+"':"+colexp+","}else if(col.aggregatorid=="ARRAY"){return"'"+colas+"':["+colexp+"],"}else if(col.aggregatorid=="COUNT"){if(col.expression.columnid=="*"){return"'"+colas+"':1,"}else{return"'"+colas+"':(typeof "+colexp+' != "undefined")?1:0,'}}else if(col.aggregatorid=="AVG"){query.removeKeys.push("_SUM_"+colas);query.removeKeys.push("_COUNT_"+colas);return"'"+colas+"':"+colexp+",'_SUM_"+colas+"':("+colexp+")||0,'_COUNT_"+colas+"':(typeof "+colexp+' != "undefined")?1:0,'}else if(col.aggregatorid=="AGGR"){aft+=",g['"+colas+"']="+col.expression.toJavaScript("g",-1);return""}else if(col.aggregatorid=="REDUCE"){query.removeKeys.push("_REDUCE_"+colas);return"'"+colas+"':alasql.aggr['"+col.funcid+"']("+colexp+",undefined,(acc={})),"+"'__REDUCE__"+colas+"':acc,"}return""}else return""}).join("");s+="}"+aft+",g));} else {";s+=query.selectGroup.map(function(col,idx){var colas=col.nick;var colexp=col.expression.toJavaScript("p",tableid,defcols);if(col instanceof yy.AggrValue){if(col.distinct){var pre="if(typeof "+colexp+'!="undefined" && (!g[\'$$_VALUES_'+colas+"']["+colexp+"])) 				 		 {";var post="g['$$_VALUES_"+colas+"']["+colexp+"]=true;}"}else{var pre="",post=""}if(col.aggregatorid=="SUM"){return pre+"g['"+colas+"']+=("+colexp+"||0);"+post}else if(col.aggregatorid=="COUNT"){if(col.expression.columnid=="*")return pre+"g['"+colas+"']++;"+post;else{return pre+"if(typeof "+colexp+'!="undefined") g[\''+colas+"']++;"+post}}else if(col.aggregatorid=="ARRAY"){return pre+"g['"+colas+"'].push("+colexp+");"+post}else if(col.aggregatorid=="MIN"){return pre+"g['"+colas+"']=Math.min(g['"+colas+"'],"+colexp+");"+post}else if(col.aggregatorid=="MAX"){return pre+"g['"+colas+"']=Math.max(g['"+colas+"'],"+colexp+");"+post}else if(col.aggregatorid=="FIRST"){return""}else if(col.aggregatorid=="LAST"){return pre+"g['"+colas+"']="+colexp+";"+post}else if(col.aggregatorid=="AVG"){return pre+"g['_SUM_"+colas+"']+=(y="+colexp+")||0;"+"g['_COUNT_"+colas+'\']+=(typeof y!="undefined")?1:0;'+"g['"+colas+"']=g['_SUM_"+colas+"']/g['_COUNT_"+colas+"'];"+post}else if(col.aggregatorid=="AGGR"){return pre+"g['"+colas+"']="+col.expression.toJavaScript("g",-1)+";"+post}else if(col.aggregatorid=="REDUCE"){return pre+"g['"+colas+"']=alasql.aggr."+col.funcid+"("+colexp+",g['"+colas+"'],g['__REDUCE__"+colas+"']);"+post}return""}else return""}).join("");s+="}"});return new Function("p,params,alasql",s)};function compileSelectStar(query,alias){var s="",sp="",ss=[];query.ixsources={};query.sources.forEach(function(source){query.ixsources[source.alias]=source});var columns;if(query.ixsources[alias]){var columns=query.ixsources[alias].columns}if(columns&&columns.length>0){columns.forEach(function(tcol){ss.push("'"+tcol.columnid+"':p['"+alias+"']['"+tcol.columnid+"']");query.selectColumns[escapeq(tcol.columnid)]=true;var coldef={columnid:tcol.columnid,dbtypeid:tcol.dbtypeid,dbsize:tcol.dbsize,dbprecision:tcol.dbprecision,dbenum:tcol.dbenum};query.columns.push(coldef);query.xcolumns[coldef.columnid]=coldef})}else{sp+='var w=p["'+alias+'"];for(var k in w){r[k]=w[k]};';query.dirtyColumns=true}return{s:ss.join(","),sp:sp}}yy.Select.prototype.compileSelect1=function(query){var self=this;query.columns=[];query.xcolumns={};query.selectColumns={};query.dirtyColumns=false;var s="var r={";var sp="";var ss=[];this.columns.forEach(function(col){if(col instanceof yy.Column){if(col.columnid=="*"){if(col.func){sp+="r=params['"+col.param+"'](p['"+query.sources[0].alias+"'],p,params,alasql);"}else if(col.tableid){var ret=compileSelectStar(query,col.tableid);if(ret.s)ss=ss.concat(ret.s);sp+=ret.sp}else{for(var alias in query.aliases){var ret=compileSelectStar(query,alias);if(ret.s)ss=ss.concat(ret.s);sp+=ret.sp}}}else{var tbid=col.tableid;var dbid=col.databaseid||query.sources[0].databaseid||query.database.databaseid;if(!tbid)tbid=query.defcols[col.columnid];if(!tbid)tbid=query.defaultTableid;if(col.columnid!="_"){ss.push("'"+escapeq(col.as||col.columnid)+"':p['"+tbid+"']['"+col.columnid+"']")
    }else{ss.push("'"+escapeq(col.as||col.columnid)+"':p['"+tbid+"']")}query.selectColumns[escapeq(col.as||col.columnid)]=true;if(query.aliases[tbid]&&query.aliases[tbid].type=="table"){if(!alasql.databases[dbid].tables[query.aliases[tbid].tableid]){throw new Error("Table '"+tbid+"' does not exists in database")}var columns=alasql.databases[dbid].tables[query.aliases[tbid].tableid].columns;var xcolumns=alasql.databases[dbid].tables[query.aliases[tbid].tableid].xcolumns;if(xcolumns&&columns.length>0){var tcol=xcolumns[col.columnid];var coldef={columnid:col.as||col.columnid,dbtypeid:tcol.dbtypeid,dbsize:tcol.dbsize,dbpecision:tcol.dbprecision,dbenum:tcol.dbenum};query.columns.push(coldef);query.xcolumns[coldef.columnid]=coldef}else{var coldef={columnid:col.as||col.columnid};query.columns.push(coldef);query.xcolumns[coldef.columnid]=coldef;query.dirtyColumns=true}}else{var coldef={columnid:col.as||col.columnid};query.columns.push(coldef);query.xcolumns[coldef.columnid]=coldef}}}else if(col instanceof yy.AggrValue){if(!self.group){self.group=[""]}if(!col.as)col.as=escapeq(col.toString());if(col.aggregatorid=="SUM"||col.aggregatorid=="MAX"||col.aggregatorid=="MIN"||col.aggregatorid=="FIRST"||col.aggregatorid=="LAST"||col.aggregatorid=="AVG"||col.aggregatorid=="ARRAY"||col.aggregatorid=="REDUCE"){ss.push("'"+escapeq(col.as)+"':"+n2u(col.expression.toJavaScript("p",query.defaultTableid,query.defcols)))}else if(col.aggregatorid=="COUNT"){ss.push("'"+escapeq(col.as)+"':1")}query.selectColumns[col.aggregatorid+"("+escapeq(col.expression.toString())+")"]=thtd;var coldef={columnid:col.as||col.columnid||col.toString()};query.columns.push(coldef);query.xcolumns[coldef.columnid]=coldef}else{ss.push("'"+escapeq(col.as||col.columnid||col.toString())+"':"+n2u(col.toJavaScript("p",query.defaultTableid,query.defcols)));query.selectColumns[escapeq(col.as||col.columnid||col.toString())]=true;var coldef={columnid:col.as||col.columnid||col.toString()};query.columns.push(coldef);query.xcolumns[coldef.columnid]=coldef}});s+=ss.join(",")+"};"+sp;return s};yy.Select.prototype.compileSelect2=function(query){var s=query.selectfns;return new Function("p,params,alasql","var y;"+s+"return r")};yy.Select.prototype.compileSelectGroup0=function(query){var self=this;self.columns.forEach(function(col,idx){if(col instanceof yy.Column&&col.columnid=="*"){}else{var colas;if(col instanceof yy.Column){colas=escapeq(col.columnid)}else{colas=escapeq(col.toString())}for(var i=0;i<idx;i++){if(colas==self.columns[i].nick){colas=self.columns[i].nick+":"+idx;break}}col.nick=colas;if(col.funcid&&(col.funcid.toUpperCase()=="ROWNUM"||col.funcid.toUpperCase()=="ROW_NUMBER")){query.rownums.push(col.as)}}});this.columns.forEach(function(col){if(col.findAggregator)col.findAggregator(query)});if(this.having){if(this.having.findAggregator)this.having.findAggregator(query)}};yy.Select.prototype.compileSelectGroup1=function(query){var self=this;var s="var r = {};";self.columns.forEach(function(col,idx){if(col instanceof yy.Column&&col.columnid=="*"){s+="for(var k in this.query.groupColumns){r[k]=g[this.query.groupColumns[k]]};"}else{var colas=col.as;if(typeof colas=="undefined"){if(col instanceof yy.Column)colas=escapeq(col.columnid);else colas=col.nick}query.groupColumns[colas]=col.nick;s+="r['"+colas+"']=";s+=n2u(col.toJavaScript("g",""))+";";for(var i=0;i<query.removeKeys.length;i++){if(query.removeKeys[i]==colas){query.removeKeys.splice(i,1);break}}}});return s};yy.Select.prototype.compileSelectGroup2=function(query){var s=query.selectgfns;return new Function("g,params,alasql","var y;"+s+"return r")};yy.Select.prototype.compileRemoveColumns=function(query){if(typeof this.removecolumns!="undefined"){query.removeKeys=query.removeKeys.concat(this.removecolumns.filter(function(column){return typeof column.like=="undefined"}).map(function(column){return column.columnid}));query.removeLikeKeys=this.removecolumns.filter(function(column){return typeof column.like!="undefined"}).map(function(column){return new RegExp(column.like.value.replace(/\%/g,".*"),"g")})}};yy.Select.prototype.compileHaving=function(query){if(this.having){s=this.having.toJavaScript("g",-1);query.havingfns=s;return new Function("g,params,alasql","var y;return "+s)}else return function(){return true}};yy.Select.prototype.compileOrder=function(query){var self=this;if(this.order){if(this.order&&this.order.length==1&&this.order[0].expression&&typeof this.order[0].expression=="function"){var func=this.order[0].expression;return function(a,b){var ra=func(a),rb=func(b);if(ra>rb)return 1;if(ra==rb)return 0;return-1}}var s="";var sk="";this.order.forEach(function(ord,idx){var dg="";if(ord.expression instanceof yy.NumValue){ord.expression=self.columns[ord.expression.value-1];ord.expression=new yy.Column({columnid:ord.expression.nick})}if(ord.expression instanceof yy.Column){var columnid=ord.expression.columnid;if(query.xcolumns[columnid]){var dbtypeid=query.xcolumns[columnid].dbtypeid;if(dbtypeid=="DATE"||dbtypeid=="DATETIME")dg=".valueOf()"}else{if(alasql.options.valueof)dg=".valueOf()"}if(ord.nocase)dg+=".toUpperCase()";s+="if((a['"+columnid+"']||'')"+dg+(ord.direction=="ASC"?">":"<")+"(b['"+columnid+"']||'')"+dg+")return 1;";s+="if((a['"+columnid+"']||'')"+dg+"==(b['"+columnid+"']||'')"+dg+"){"}else{dg=".valueOf()";if(ord.nocase)dg+=".toUpperCase()";s+="if(("+ord.toJavaScript("a","")+"||'')"+dg+(ord.direction=="ASC"?">(":"<(")+ord.toJavaScript("b","")+"||'')"+dg+")return 1;";s+="if(("+ord.toJavaScript("a","")+"||'')"+dg+"==("+ord.toJavaScript("b","")+"||'')"+dg+"){"}sk+="}"});s+="return 0;";s+=sk+"return -1";query.orderfns=s;return new Function("a,b","var y;"+s)}};var rollup=function(a,query){var rr=[];var mask=0;var glen=a.length;for(var g=0;g<glen+1;g++){var ss=[];for(var i=0;i<glen;i++){if(a[i]instanceof yy.Column){a[i].nick=escapeq(a[i].columnid);query.groupColumns[escapeq(a[i].columnid)]=a[i].nick;var aaa=a[i].nick+"	"+a[i].toJavaScript("p",query.sources[0].alias,query.defcols)}else{query.groupColumns[escapeq(a[i].toString())]=escapeq(a[i].toString());var aaa=escapeq(a[i].toString())+"	"+a[i].toJavaScript("p",query.sources[0].alias,query.defcols)}if(mask&1<<i)ss.push(aaa)}rr.push(ss);mask=(mask<<1)+1}return rr};var cube=function(a,query){var rr=[];var glen=a.length;for(var g=0;g<1<<glen;g++){var ss=[];for(var i=0;i<glen;i++){if(g&1<<i)ss=ss.concat(decartes(a[i],query))}rr.push(ss)}return rr};var groupingsets=function(a,query){return a.reduce(function(acc,d){acc=acc.concat(decartes(d,query));return acc},[])};var cartes=function(a1,a2){var rrr=[];for(var i1=0;i1<a1.length;i1++){for(var i2=0;i2<a2.length;i2++){rrr.push(a1[i1].concat(a2[i2]))}}return rrr};function decartes(gv,query){if(gv instanceof Array){var res=[[]];for(var t=0;t<gv.length;t++){if(gv[t]instanceof yy.Column){gv[t].nick=escapeq(gv[t].columnid);query.groupColumns[gv[t].nick]=gv[t].nick;res=res.map(function(r){return r.concat(gv[t].nick+"	"+gv[t].toJavaScript("p",query.sources[0].alias,query.defcols))})}else if(gv[t]instanceof yy.FuncValue){query.groupColumns[escapeq(gv[t].toString())]=escapeq(gv[t].toString());res=res.map(function(r){return r.concat(escapeq(gv[t].toString())+"	"+gv[t].toJavaScript("p",query.sources[0].alias,query.defcols))})}else if(gv[t]instanceof yy.GroupExpression){if(gv[t].type=="ROLLUP")res=cartes(res,rollup(gv[t].group,query));else if(gv[t].type=="CUBE")res=cartes(res,cube(gv[t].group,query));else if(gv[t].type=="GROUPING SETS")res=cartes(res,groupingsets(gv[t].group,query));else throw new Error("Unknown grouping function")}else if(gv[t]===""){res=[["1	1"]]}else{res=res.map(function(r){query.groupColumns[escapeq(gv[t].toString())]=escapeq(gv[t].toString());return r.concat(escapeq(gv[t].toString())+"	"+gv[t].toJavaScript("p",query.sources[0].alias,query.defcols))})}}return res}else if(gv instanceof yy.FuncValue){query.groupColumns[escapeq(gv.toString())]=escapeq(gv.toString());return[gv.toString()+"	"+gv.toJavaScript("p",query.sources[0].alias,query.defcols)]}else if(gv instanceof yy.Column){gv.nick=escapeq(gv.columnid);query.groupColumns[gv.nick]=gv.nick;return[gv.nick+"	"+gv.toJavaScript("p",query.sources[0].alias,query.defcols)]}else{query.groupColumns[escapeq(gv.toString())]=escapeq(gv.toString());return[escapeq(gv.toString())+"	"+gv.toJavaScript("p",query.sources[0].alias,query.defcols)]}}yy.Select.prototype.compileDefCols=function(query,databaseid){var defcols={};if(this.from){this.from.forEach(function(fr){if(fr instanceof yy.Table){var alias=fr.as||fr.tableid;var table=alasql.databases[fr.databaseid||databaseid].tables[fr.tableid];if(table.columns){table.columns.forEach(function(col){if(defcols[col.columnid]){defcols[col.columnid]="-"}else{defcols[col.columnid]=alias}})}}else if(fr instanceof yy.Select){}else if(fr instanceof yy.Search){}else if(fr instanceof yy.ParamValue){}else if(fr instanceof yy.VarValue){}else if(fr instanceof yy.FuncValue){}else if(fr instanceof yy.FromData){}else if(fr instanceof yy.Json){}else{throw new Error("Unknown type of FROM clause")}})}if(this.joins){this.joins.forEach(function(jn){if(jn.table){var alias=jn.table.tableid;if(jn.as)alias=jn.as;var alias=jn.as||jn.table.tableid;var table=alasql.databases[jn.table.databaseid||databaseid].tables[jn.table.tableid];if(table.columns){table.columns.forEach(function(col){if(defcols[col.columnid]){defcols[col.columnid]="-"}else{defcols[col.columnid]=alias}})}}else if(jn.select){}else if(jn.param){}else if(jn.func){}else{throw new Error("Unknown type of FROM clause")}})}return defcols};yy.Union=function(params){return yy.extend(this,params)};yy.Union.prototype.toString=function(){return K("UNION")};yy.Union.prototype.compile=function(tableid){return null};yy.Apply=function(params){return yy.extend(this,params)};yy.Apply.prototype.toString=function(){var s=K(this.applymode)+" "+K("APPLY")+" (";s+=this.select.toString()+")";if(this.as)s+=" "+K("AS")+" "+L(this.as);return s};yy.Over=function(params){return yy.extend(this,params)};yy.Over.prototype.toString=function(){var s=K("OVER")+" (";if(this.partition){s+=K("PARTITION")+" "+K("BY")+" "+this.partition.toString();if(this.order)s+=" "}if(this.order){s+=K("ORDER")+" "+K("BY")+" "+this.order.toString()}s+=")";return s};yy.ExpressionStatement=function(params){return yy.extend(this,params)};yy.ExpressionStatement.prototype.toString=function(){return this.expression.toString()};yy.ExpressionStatement.prototype.execute=function(databaseid,params,cb){if(this.expression){alasql.precompile(this,databaseid,params);var exprfn=new Function("params,alasql,p","var y;return "+this.expression.toJavaScript("({})","",null)).bind(this);var res=exprfn(params,alasql);if(cb)res=cb(res);return res}};yy.Expression=function(params){return yy.extend(this,params)};yy.Expression.prototype.toString=function(){var s=this.expression.toString();if(this.order)s+=" "+this.order.toString();if(this.nocase)s+=" "+K("COLLATE")+" "+K("NOCASE");return s};yy.Expression.prototype.findAggregator=function(query){if(this.expression.findAggregator)this.expression.findAggregator(query)};yy.Expression.prototype.toJavaScript=function(context,tableid,defcols){if(this.expression.reduced)return"true";return this.expression.toJavaScript(context,tableid,defcols)};yy.Expression.prototype.compile=function(context,tableid,defcols){if(this.reduced)return returnTrue();return new Function("p","var y;return "+this.toJavaScript(context,tableid,defcols))};yy.JavaScript=function(params){return yy.extend(this,params)};yy.JavaScript.prototype.toString=function(){var s="``"+this.value+"``";return s};yy.JavaScript.prototype.toJavaScript=function(context,tableid,defcols){return"("+this.value+")"};yy.JavaScript.prototype.execute=function(databaseid,params,cb){var res=1;var expr=new Function("params,alasql,p",this.value);expr(params,alasql);if(cb)res=cb(res);return res};yy.Literal=function(params){return yy.extend(this,params)};yy.Literal.prototype.toString=function(){var s=this.value;if(this.value1)s=this.value1+"."+s;return L(s)};yy.Join=function(params){return yy.extend(this,params)};yy.Join.prototype.toString=function(){var s=NL()+ID();if(this.joinmode)s+=K(this.joinmode)+" ";s+=K("JOIN")+this.table.toString();return s};yy.Table=function(params){return yy.extend(this,params)};yy.Table.prototype.toString=function(){var s=this.tableid;if(this.databaseid)s=this.databaseid+"."+s;return L(s)};yy.View=function(params){return yy.extend(this,params)};yy.View.prototype.toString=function(){var s=this.viewid;if(this.databaseid)s=this.databaseid+"."+s;return L(s)};yy.Op=function(params){return yy.extend(this,params)};yy.Op.prototype.toString=function(){if(this.op=="IN"||this.op=="NOT IN"){return this.left.toString()+" "+P(this.op)+" ("+this.right.toString()+")"}if(this.allsome){return this.left.toString()+" "+P(this.op)+" "+this.allsome+" ("+this.right.toString()+")"}if(this.op=="->"||this.op=="!"){var s=this.left.toString()+this.op;if(typeof this.right!="string"&&typeof this.right!="number")s+="(";s+=this.right.toString();if(typeof this.right!="string"&&typeof this.right!="number")s+=")";return s}return this.left.toString()+" "+P(this.op)+" "+(this.allsome?this.allsome+" ":"")+this.right.toString()};yy.Op.prototype.findAggregator=function(query){if(this.left&&this.left.findAggregator)this.left.findAggregator(query);if(this.right&&this.right.findAggregator&&!this.allsome){this.right.findAggregator(query)}};yy.Op.prototype.toType=function(tableid){if(["-","*","/","%","^"].indexOf(this.op)>-1)return"number";if(this.op=="+"){if(this.left.toType(tableid)=="string"||this.right.toType(tableid)=="string")return"string";if(this.left.toType(tableid)=="number"||this.right.toType(tableid)=="number")return"number"}if(["AND","OR","NOT","=","==","===","!=","!==","!===",">",">=","<","<=","IN","NOT IN","LIKE","NOT LIKE"].indexOf(this.op)>-1)return"boolean";if(this.op=="BETWEEN"||this.op=="NOT BETWEEN"||this.op=="IS NULL"||this.op=="IS NOT NULL")return"boolean";if(this.allsome)return"boolean";if(!this.op)return this.left.toType();return"unknown"};yy.Op.prototype.toJavaScript=function(context,tableid,defcols){var op=this.op;if(this.op=="=")op="===";else if(this.op=="<>")op="!=";else if(this.op=="OR")op="||";if(this.op=="->"){if(typeof this.right=="string"){return this.left.toJavaScript(context,tableid,defcols)+'["'+this.right+'"]'}else if(typeof this.right=="number"){return this.left.toJavaScript(context,tableid,defcols)+"["+this.right+"]"}else if(this.right instanceof yy.FuncValue){ss=[];if(!this.right.args||this.right.args.length==0){}else{var ss=this.right.args.map(function(arg){return arg.toJavaScript(context,tableid,defcols)})}return this.left.toJavaScript(context,tableid,defcols)+"['"+this.right.funcid+"']("+ss.join(",")+")"}else{return this.left.toJavaScript(context,tableid,defcols)+"["+this.right.toJavaScript(context,tableid,defcols)+"]"}}if(this.op=="!"){if(typeof this.right=="string"){return"alasql.databases[alasql.useid].objects["+this.left.toJavaScript(context,tableid,defcols)+']["'+this.right+'"]'}}if(this.op=="IS"){return"((typeof "+this.left.toJavaScript(context,tableid,defcols)+"=='undefined') == "+"(typeof "+this.right.toJavaScript(context,tableid,defcols)+"=='undefined'))"}if(this.op=="=="){return"alasql.utils.deepEqual("+this.left.toJavaScript(context,tableid,defcols)+","+this.right.toJavaScript(context,tableid,defcols)+")"}if(this.op=="==="){return"(("+this.left.toJavaScript(context,tableid,defcols)+").valueOf()===("+this.right.toJavaScript(context,tableid,defcols)+".valueOf()))"}if(this.op=="!==="){return"!(("+this.left.toJavaScript(context,tableid,defcols)+").valueOf()===("+this.right.toJavaScript(context,tableid,defcols)+".valueOf()))"}if(this.op=="!=="){return"(!alasql.utils.deepEqual("+this.left.toJavaScript(context,tableid,defcols)+","+this.right.toJavaScript(context,tableid,defcols)+"))"}if(this.op=="LIKE"){var s="("+this.left.toJavaScript(context,tableid,defcols)+"+'')"+".toUpperCase().match(new RegExp('^'+("+this.right.toJavaScript(context,tableid,defcols)+").replace(/\\%/g,'.*').toUpperCase()+'$','g'))";return s}if(this.op=="NOT LIKE"){var s="!(("+this.left.toJavaScript(context,tableid,defcols)+"+'')"+".toUpperCase().match(new RegExp('^'+("+this.right.toJavaScript(context,tableid,defcols)+").replace(/\\%/g,'.*').toUpperCase()+'$','g')))";return s}if(this.op=="BETWEEN"){return"(("+this.right1.toJavaScript(context,tableid,defcols)+"<="+this.left.toJavaScript(context,tableid,defcols)+")&&"+"("+this.left.toJavaScript(context,tableid,defcols)+"<="+this.right2.toJavaScript(context,tableid,defcols)+"))"}if(this.op=="NOT BETWEEN"){return"!(("+this.right1.toJavaScript(context,tableid,defcols)+"<="+this.left.toJavaScript(context,tableid,defcols)+")&&"+"("+this.left.toJavaScript(context,tableid,defcols)+"<="+this.right2.toJavaScript(context,tableid,defcols)+"))"}if(this.op=="IN"){if(this.right instanceof yy.Select){var s="(";s+="alasql.utils.flatArray(this.queriesfn["+this.queriesidx+"](params,null,context))";s+=".indexOf(";s+=this.left.toJavaScript(context,tableid,defcols)+")>-1)";return s}else if(this.right instanceof Array){var s="(["+this.right.map(function(a){return a.toJavaScript(context,tableid,defcols)}).join(",")+"].indexOf(";s+=this.left.toJavaScript(context,tableid,defcols)+")>-1)";return s}else{var s="("+this.right.toJavaScript(context,tableid,defcols)+".indexOf(";s+=this.left.toJavaScript(context,tableid,defcols)+")>-1)";return s}}if(this.op=="NOT IN"){if(this.right instanceof yy.Select){var s="(";s+="alasql.utils.flatArray(this.queriesfn["+this.queriesidx+"](params,null,p))";s+=".indexOf(";s+=this.left.toJavaScript(context,tableid,defcols)+")<0)";return s}else if(this.right instanceof Array){var s="(["+this.right.map(function(a){return a.toJavaScript(context,tableid,defcols)}).join(",")+"].indexOf(";s+=this.left.toJavaScript(context,tableid,defcols)+")<0)";return s}else{var s="("+this.right.toJavaScript(context,tableid,defcols)+".indexOf(";s+=this.left.toJavaScript(context,tableid,defcols)+")==-1)";return s}}if(this.allsome=="ALL"){if(this.right instanceof yy.Select){var s="alasql.utils.flatArray(this.query.queriesfn["+this.queriesidx+"](params,null,p))";s+=".every(function(b){return (";s+=this.left.toJavaScript(context,tableid,defcols)+")"+op+"b})";return s}else if(this.right instanceof Array){var s="["+this.right.map(function(a){return a.toJavaScript(context,tableid,defcols)}).join(",")+"].every(function(b){return (";s+=this.left.toJavaScript(context,tableid,defcols)+")"+op+"b})";return s}else{throw new Error("Wrong NOT IN operator without SELECT part")}}if(this.allsome=="SOME"||this.allsome=="ANY"){if(this.right instanceof yy.Select){var s="alasql.utils.flatArray(this.query.queriesfn["+this.queriesidx+"](params,null,p))";s+=".some(function(b){return (";s+=this.left.toJavaScript(context,tableid,defcols)+")"+op+"b})";return s}else if(this.right instanceof Array){var s="["+this.right.map(function(a){return a.toJavaScript(context,tableid,defcols)}).join(",")+"].some(function(b){return (";s+=this.left.toJavaScript(context,tableid,defcols)+")"+op+"b})";return s}else{throw new Error("Wrong NOT IN operator without SELECT part")}}if(this.op=="AND"){if(this.left.reduced){if(this.right.reduced){return"true"}else{return this.right.toJavaScript(context,tableid,defcols)}}else if(this.right.reduced){return this.left.toJavaScript(context,tableid,defcols)}op="&&"}if(this.op=="^"){return"Math.pow("+this.left.toJavaScript(context,tableid,defcols)+","+this.right.toJavaScript(context,tableid,defcols)+")"}return"("+this.left.toJavaScript(context,tableid,defcols)+op+this.right.toJavaScript(context,tableid,defcols)+")"};yy.VarValue=function(params){return yy.extend(this,params)};yy.VarValue.prototype.toString=function(){return"@"+L(this.variable)};yy.VarValue.prototype.toType=function(){return"unknown"};yy.VarValue.prototype.toJavaScript=function(){return"alasql.vars['"+this.variable+"']"};yy.NumValue=function(params){return yy.extend(this,params)};yy.NumValue.prototype.toString=function(){return N(this.value.toString())};yy.NumValue.prototype.toType=function(){return"number"};yy.NumValue.prototype.toJavaScript=function(){return""+this.value};yy.StringValue=function(params){return yy.extend(this,params)};yy.StringValue.prototype.toString=function(){return"'"+S(this.value.toString())+"'"};yy.StringValue.prototype.toType=function(){return"string"};yy.StringValue.prototype.toJavaScript=function(){return"'"+escapeq(this.value)+"'"};yy.LogicValue=function(params){return yy.extend(this,params)};yy.LogicValue.prototype.toString=function(){return this.value?"TRUE":"FALSE"};yy.LogicValue.prototype.toType=function(){return"boolean"};yy.LogicValue.prototype.toJavaScript=function(){return this.value?"true":"false"};yy.NullValue=function(params){return yy.extend(this,params)};yy.NullValue.prototype.toString=function(){return"NULL"};yy.NullValue.prototype.toJavaScript=function(){return"undefined"};yy.ParamValue=function(params){return yy.extend(this,params)};yy.ParamValue.prototype.toString=function(){return"$"+this.param};yy.ParamValue.prototype.toJavaScript=function(){if(typeof this.param=="string")return"params['"+this.param+"']";else return"params["+this.param+"]"};yy.UniOp=function(params){return yy.extend(this,params)};yy.UniOp.prototype.toString=function(){if(this.op=="-")return this.op+this.right.toString();if(this.op=="+")return this.op+this.right.toString();if(this.op=="#")return this.op+this.right.toString();if(this.op=="NOT")return this.op+"("+this.right.toString()+")";else if(this.op==null)return"("+this.right.toString()+")"};yy.UniOp.prototype.findAggregator=function(query){if(this.right.findAggregator)this.right.findAggregator(query)};yy.UniOp.prototype.toType=function(tableid){if(this.op=="-")return"number";if(this.op=="+")return"number";if(this.op=="NOT")return"boolean"};yy.UniOp.prototype.toJavaScript=function(context,tableid,defcols){if(this.op=="-")return"(-("+this.right.toJavaScript(context,tableid,defcols)+"))";if(this.op=="+")return"("+this.right.toJavaScript(context,tableid,defcols)+")";if(this.op=="NOT")return"!("+this.right.toJavaScript(context,tableid,defcols)+")";if(this.op=="#"){if(this.right instanceof yy.Column){return"(alasql.databases[alasql.useid].objects['"+this.right.columnid+"'])"}else{return"(alasql.databases[alasql.useid].objects["+this.right.toJavaScript(context,tableid,defcols)+"])"}}else if(this.op==null)return"("+this.right.toJavaScript(context,tableid,defcols)+")"};yy.Column=function(params){return yy.extend(this,params)};yy.Column.prototype.toString=function(){var s;if(this.columnid==+this.columnid){s="["+this.columnid+"]"}else{s=this.columnid}if(this.tableid){if(+this.columnid==this.columnid){s=this.tableid+s}else{s=this.tableid+"."+s}if(this.databaseid){s=this.databaseid+"."+s}}return s};yy.Column.prototype.toJavaScript=function(context,tableid,defcols){var s="";if(!this.tableid&&tableid==""&&!defcols){if(this.columnid!="_"){s=context+"['"+this.columnid+"']"}else{if(context=="g"){s="g['_']"}else{s=context}}}else{if(context=="g"){s="g['"+this.nick+"']"}else if(this.tableid){if(this.columnid!="_"){s=context+"['"+this.tableid+"']['"+this.columnid+"']"}else{if(context=="g"){s="g['_']"}else{s=context+"['"+this.tableid+"']"}}}else if(defcols){var tbid=defcols[this.columnid];if(tbid=="-"){throw new Error('Cannot resolve column "'+this.columnid+'" because it exists in two source tables')}else if(tbid){if(this.columnid!="_"){s=context+"['"+tbid+"']['"+this.columnid+"']"}else{s=context+"['"+tbid+"']"}}else{if(this.columnid!="_"){s=context+"['"+(this.tableid||tableid)+"']['"+this.columnid+"']"}else{s=context+"['"+(this.tableid||tableid)+"']"}}}else if(tableid==-1){s=context+"['"+this.columnid+"']"}else{if(this.columnid!="_"){s=context+"['"+(this.tableid||tableid)+"']['"+this.columnid+"']"}else{s=context+"['"+(this.tableid||tableid)+"']"}}}return s};yy.AggrValue=function(params){return yy.extend(this,params)};yy.AggrValue.prototype.toString=function(){var s="";if(this.aggregatorid=="REDUCE")s+=L(this.funcid)+"(";else s+=this.aggregatorid+"(";if(this.distinct)s+=K("DISTINCT")+" ";if(this.expression)s+=this.expression.toString();s+=")";if(this.over)s+=" "+this.over.toString();return s};yy.AggrValue.prototype.findAggregator=function(query){var colas=escapeq(this.toString())+":"+query.selectGroup.length;var found=false;if(!found){if(!this.nick){this.nick=colas;var found=false;for(var i=0;i<query.removeKeys.length;i++){if(query.removeKeys[i]==colas){found=true;break}}if(!found)query.removeKeys.push(colas)}query.selectGroup.push(this)}return};yy.AggrValue.prototype.toType=function(){if(["SUM","COUNT","AVG","MIN","MAX","AGGR","VAR","STDDEV"].indexOf(this.aggregatorid)>-1)return"number";if(["ARRAY"].indexOf(this.aggregatorid)>-1)return"array";if(["FIRST","LAST"].indexOf(this.aggregatorid)>-1)return this.expression.toType()};yy.AggrValue.prototype.toJavaScript=function(context,tableid,defcols){var colas=this.nick;if(typeof colas=="undefined")colas=this.toString();return"g['"+colas+"']"};yy.OrderExpression=function(params){return yy.extend(this,params)};yy.OrderExpression.prototype.toString=function(){var s=this.expression.toString();if(this.order)s+=" "+this.order.toString();if(this.nocase)s+=" "+K("COLLATE")+" "+K("NOCASE");return s};yy.GroupExpression=function(params){return yy.extend(this,params)};yy.GroupExpression.prototype.toString=function(){return this.type+"("+this.group.toString()+")"};yy.ColumnDef=function(params){return yy.extend(this,params)};yy.ColumnDef.prototype.toString=function(){var s=this.columnid;if(this.dbtypeid)s+=" "+this.dbtypeid;if(this.dbsize){s+="("+this.dbsize;if(this.dbprecision)s+=","+this.dbprecision;s+=")"}if(this.primarykey)s+=" PRIMARY KEY";if(this.notnull)s+=" NOT NULL";return s};yy.FromData=function(params){return yy.extend(this,params)};yy.FromData.prototype.toString=function(){if(this.data)return K("DATA")+"("+(Math.random()*1e16|0)+")";else return"?"};yy.FromData.prototype.toJavaScript=function(){};yy.Select.prototype.exec=function(params,cb){if(this.preparams)params=this.preparams.concat(params);var databaseid=alasql.useid;db=alasql.databases[databaseid];var sql=this.toString();var hh=hash(sql);var statement=this.compile(databaseid);if(!statement)return;statement.sql=sql;statement.dbversion=db.dbversion;if(db.sqlCacheSize>alasql.MAXSQLCACHESIZE){db.resetSqlCache()}db.sqlCacheSize++;db.sqlCache[hh]=statement;var res=alasql.res=statement(params,cb);return res};yy.Select.prototype.Select=function(){var self=this;var agrs=[];if(arguments.length>1){args=Array.prototype.slice.call(arguments)}else if(arguments.length==1){if(arguments[0]instanceof Array){args=arguments[0]}else{args=[arguments[0]]}}else{throw new Error("Wrong number of arguments of Select() function")}self.columns=[];args.forEach(function(arg){if(typeof arg=="string"){self.columns.push(new yy.Column({columnid:arg}))}else if(typeof arg=="function"){var pari=0;if(self.preparams){pari=self.preparams.length}else{self.preparams=[]}self.preparams.push(arg);self.columns.push(new yy.Column({columnid:"*",func:arg,param:pari}))}else{}});return self};yy.Select.prototype.From=function(tableid){var self=this;if(!self.from)self.from=[];if(tableid instanceof Array){var pari=0;if(self.preparams){pari=self.preparams.length}else{self.preparams=[]}self.preparams.push(tableid);self.from.push(new yy.ParamValue({param:pari}))}else if(typeof tableid=="string"){self.from.push(new yy.Table({tableid:tableid}))}else{throw new Error("Unknown arguments in From() function")}return self};yy.Select.prototype.OrderBy=function(){var self=this;var agrs=[];self.order=[];if(arguments.length==0){args=["_"]}else if(arguments.length>1){args=Array.prototype.slice.call(arguments)}else if(arguments.length==1){if(arguments[0]instanceof Array){args=arguments[0]}else{args=[arguments[0]]}}else{throw new Error("Wrong number of arguments of Select() function")}if(args.length>0){args.forEach(function(arg){var expr=new yy.Column({columnid:arg});if(typeof arg=="function"){expr=arg}self.order.push(new yy.OrderExpression({expression:expr,direction:"ASC"}))})}return self};yy.Select.prototype.Top=function(topnum){var self=this;self.top=new yy.NumValue({value:topnum});return self};yy.Select.prototype.GroupBy=function(){var self=this;var agrs=[];if(arguments.length>1){args=Array.prototype.slice.call(arguments)}else if(arguments.length==1){if(arguments[0]instanceof Array){args=arguments[0]}else{args=[arguments[0]]}}else{throw new Error("Wrong number of arguments of Select() function")}self.group=[];args.forEach(function(arg){var expr=new yy.Column({columnid:arg});self.group.push(expr)});return self};yy.Select.prototype.Where=function(expr){var self=this;if(typeof expr=="function"){self.where=expr}return self};yy.FuncValue=function(params){return yy.extend(this,params)};yy.FuncValue.prototype.toString=function(){var s="";if(alasql.fn[this.funcid])s+=this.funcid;else if(alasql.aggr[this.funcid])s+=this.funcid;else if(alasql.stdlib[this.funcid.toUpperCase()]||alasql.stdfn[this.funcid.toUpperCase()])s+=this.funcid.toUpperCase();s+="(";if(this.args&&this.args.length>0){s+=this.args.map(function(arg){return arg.toString()}).join(",")}s+=")";if(this.as)s+=" AS "+this.as.toString();return s};yy.FuncValue.prototype.findAggregator=function(query){if(this.args&&this.args.length>0){this.args.forEach(function(arg){if(arg.findAggregator)arg.findAggregator(query)})}};yy.FuncValue.prototype.toJavaScript=function(context,tableid,defcols){var s="";var funcid=this.funcid;if(alasql.fn[funcid]){if(this.newid)s+="new ";s+="alasql.fn."+this.funcid+"(";if(this.args&&this.args.length>0){s+=this.args.map(function(arg){return arg.toJavaScript(context,tableid,defcols)}).join(",")}s+=")"}else if(alasql.stdlib[funcid.toUpperCase()]){if(this.args&&this.args.length>0){s+=alasql.stdlib[funcid.toUpperCase()].apply(this,this.args.map(function(arg){return arg.toJavaScript(context,tableid)}))}else{s+=alasql.stdlib[funcid.toUpperCase()]()}}else if(alasql.stdfn[funcid.toUpperCase()]){if(this.newid)s+="new ";s+="alasql.stdfn."+this.funcid.toUpperCase()+"(";if(this.args&&this.args.length>0){s+=this.args.map(function(arg){return arg.toJavaScript(context,tableid,defcols)}).join(",")}s+=")"}else{}return s};var stdlib=alasql.stdlib={};var stdfn=alasql.stdfn={};stdlib.ABS=function(a){return"Math.abs("+a+")"};stdlib.CLONEDEEP=function(a){return"alasql.utils.cloneDeep("+a+")"};stdlib.IIF=function(a,b,c){if(arguments.length==3){return"(("+a+")?("+b+"):("+c+"))"}else{throw new Error("Number of arguments of IFF is not equals to 3")}};stdlib.IFNULL=function(a,b){return"("+a+"||"+b+")"};stdlib.INSTR=function(s,p){return"(("+s+").indexOf("+p+")+1)"};stdlib.LEN=stdlib.LENGTH=function(s){return und(s,"y.length")};stdlib.LOWER=stdlib.LCASE=function(s){return und(s,"y.toLowerCase()")};stdlib.MAX=stdlib.GREATEST=function(){return"Math.max("+Array.prototype.join.call(arguments,",")+")"};stdlib.MIN=stdlib.LEAST=function(){return"Math.min("+Array.prototype.join.call(arguments,",")+")"};stdlib.SUBSTRING=stdlib.MID=function(a,b,c){if(arguments.length==2)return und(a,"y.substr("+b+"-1)");else if(arguments.length==3)return und(a,"y.substr("+b+"-1,"+c+")")};stdlib.ISNULL=stdlib.NULLIF=function(a,b){return"("+a+"=="+b+"?undefined:"+a+")"};stdlib.POWER=function(a,b){return"Math.pow("+a+","+b+")"};stdlib.RANDOM=function(r){if(arguments.length==0){return"Math.random()"}else{return"(Math.random()*("+r+")|0)"}};stdlib.ROUND=function(s,d){if(arguments.length==2){return"Math.round("+s+"*Math.pow(10,"+d+"))/Math.pow(10,"+d+")"}else{return"Math.round("+s+")"}};stdlib.ROWNUM=function(){return"1"};stdlib.ROW_NUMBER=function(){return"1"};stdlib.SQRT=function(s){return"Math.sqrt("+s+")"};stdlib.TRIM=function(s){return und(s,"y.trim()")};stdlib.UPPER=stdlib.UCASE=function(s){return und(s,"y.toUpperCase()")};alasql.aggr.GROUP_CONCAT=function(v,s){if(typeof s=="undefined")return v;else return s+","+v};alasql.aggr.MEDIAN=function(v,s,acc){if(typeof acc.arr=="undefined"){acc.arr=[v];
        return v}else{acc.arr.push(v);var p=acc.arr.sort();return p[p.length/2|0]}};alasql.aggr.VAR=function(v,s,acc){if(typeof acc.arr=="undefined"){acc.arr=[v];acc.sum=v}else{acc.arr.push(v);acc.sum+=v}var N=acc.arr.length;var avg=acc.sum/N;var std=0;for(var i=0;i<N;i++){std+=(acc.arr[i]-avg)*(acc.arr[i]-avg)}std=std/(N-1);return std};alasql.aggr.STDEV=function(v,s,acc){return Math.sqrt(alasql.aggr.VAR(v,s,acc))};alasql.aggr.VARP=function(v,s,acc){if(typeof acc.arr=="undefined"){acc.arr=[v];acc.sum=v}else{acc.arr.push(v);acc.sum+=v}var N=acc.arr.length;var avg=acc.sum/N;var std=0;for(var i=0;i<N;i++){std+=(acc.arr[i]-avg)*(acc.arr[i]-avg)}std=std/N;return std};alasql.aggr.STD=alasql.aggr.STDDEV=alasql.aggr.STDEVP=function(v,s,acc){return Math.sqrt(alasql.aggr.VARP(v,s,acc))};yy.CaseValue=function(params){return yy.extend(this,params)};yy.CaseValue.prototype.toString=function(){var s="CASE ";if(this.expression)s+=this.expression.toString();if(this.whens){s+=this.whens.map(function(w){return" WHEN "+w.when.toString()+" THEN "+w.then.toString()}).join()}s+=" END";return s};yy.CaseValue.prototype.findAggregator=function(query){if(this.expression&&this.expression.findAggregator)this.expression.findAggregator(query);if(this.whens&&this.whens.length>0){this.whens.forEach(function(w){if(w.when.findAggregator)w.when.findAggregator(query);if(w.then.findAggregator)w.then.findAggregator(query)})}if(this.elses&&this.elses.findAggregator)this.elses.findAggregator(query)};yy.CaseValue.prototype.toJavaScript=function(context,tableid,defcols){var s="((function("+context+",params,alasql){var r;";if(this.expression){s+="v="+this.expression.toJavaScript(context,tableid,defcols)+";";s+=(this.whens||[]).map(function(w){return" if(v=="+w.when.toJavaScript(context,tableid,defcols)+") {r="+w.then.toJavaScript(context,tableid,defcols)+"}"}).join(" else ");if(this.elses)s+=" else {r="+this.elses.toJavaScript(context,tableid,defcols)+"}"}else{s+=(this.whens||[]).map(function(w){return" if("+w.when.toJavaScript(context,tableid,defcols)+") {r="+w.then.toJavaScript(context,tableid,defcols)+"}"}).join(" else ");if(this.elses)s+=" else {r="+this.elses.toJavaScript(context,tableid,defcols)+"}"}s+=";return r;}).bind(this))("+context+",params,alasql)";return s};yy.Json=function(params){return yy.extend(this,params)};yy.Json.prototype.toString=function(){var s="";s+=JSONtoString(this.value);s+="";return s};var JSONtoString=alasql.utils.JSONtoString=function(obj){var s="";if(typeof obj=="string")s='"'+obj+'"';else if(typeof obj=="number")s=obj;else if(typeof obj=="boolean")s=obj;else if(typeof obj=="object"){if(obj instanceof Array){s+="["+obj.map(function(b){return JSONtoString(b)}).join(",")+"]"}else if(!obj.toJavaScript||obj instanceof yy.Json){s="{";var ss=[];for(var k in obj){var s1="";if(typeof k=="string")s1+='"'+k+'"';else if(typeof k=="number")s1+=k;else if(typeof k=="boolean")s1+=k;else{throw new Error("THis is not ES6... no expressions on left side yet")}s1+=":"+JSONtoString(obj[k]);ss.push(s1)}s+=ss.join(",")+"}"}else if(obj.toString){s=obj.toString()}else{throw new Error("1Can not show JSON object "+JSON.stringify(obj))}}else{throw new Error("2Can not show JSON object "+JSON.stringify(obj))}return s};function JSONtoJavaScript(obj,context,tableid,defcols){var s="";if(typeof obj=="string")s='"'+obj+'"';else if(typeof obj=="number")s="("+obj+")";else if(typeof obj=="boolean")s=obj;else if(typeof obj=="object"){if(obj instanceof Array){s+="["+obj.map(function(b){return JSONtoJavaScript(b,context,tableid,defcols)}).join(",")+"]"}else if(!obj.toJavaScript||obj instanceof yy.Json){s="{";var ss=[];for(var k in obj){var s1="";if(typeof k=="string")s1+='"'+k+'"';else if(typeof k=="number")s1+=k;else if(typeof k=="boolean")s1+=k;else{throw new Error("THis is not ES6... no expressions on left side yet")}s1+=":"+JSONtoJavaScript(obj[k],context,tableid,defcols);ss.push(s1)}s+=ss.join(",")+"}"}else if(obj.toJavaScript){s=obj.toJavaScript(context,tableid,defcols)}else{throw new Error("1Can not parse JSON object "+JSON.stringify(obj))}}else{throw new Error("2Can not parse JSON object "+JSON.stringify(obj))}return s}yy.Json.prototype.toJavaScript=function(context,tableid,defcols){return JSONtoJavaScript(this.value,context,tableid,defcols)};yy.Convert=function(params){return yy.extend(this,params)};yy.Convert.prototype.toString=function(){var s="CONVERT(";s+=this.dbtypeid;if(typeof this.dbsize!="undefined"){s+="("+this.dbsize;if(this.dbprecision)s+=","+dbprecision;s+=")"}s+=","+this.expression.toString();if(this.style)s+=","+this.style;s+=")";return s};yy.Convert.prototype.toJavaScript=function(context,tableid,defcols){return"alasql.stdfn.CONVERT("+this.expression.toJavaScript(context,tableid,defcols)+',{dbtypeid:"'+this.dbtypeid+'",dbsize:'+this.dbsize+",style:"+this.style+"})";throw new Error("There is not such type conversion for "+this.toString())};alasql.stdfn.CONVERT=function(value,args){var val=value;if(args.style){var t;if(/\d{8}/.test(val))t=new Date(+val.substr(0,4),+val.substr(4,2)-1,+val.substr(6,2));else t=new Date(val);if(args.style==1){val=("0"+(t.getMonth()+1)).substr(-2)+"/"+("0"+t.getDate()).substr(-2)+"/"+("0"+t.getYear()).substr(-2)}else if(args.style==2){val=("0"+t.getYear()).substr(-2)+"."+("0"+(t.getMonth()+1)).substr(-2)+"."+("0"+t.getDate()).substr(-2)}else if(args.style==3){val=("0"+t.getDate()).substr(-2)+"/"+("0"+(t.getMonth()+1)).substr(-2)+"/"+("0"+t.getYear()).substr(-2)}else if(args.style==4){val=("0"+t.getDate()).substr(-2)+"."+("0"+(t.getMonth()+1)).substr(-2)+"."+("0"+t.getYear()).substr(-2)}else if(args.style==5){val=("0"+t.getDate()).substr(-2)+"-"+("0"+(t.getMonth()+1)).substr(-2)+"-"+("0"+t.getYear()).substr(-2)}else if(args.style==6){val=("0"+t.getDate()).substr(-2)+" "+t.toString().substr(4,3).toLowerCase()+" "+("0"+t.getYear()).substr(-2)}else if(args.style==7){val=t.toString().substr(4,3)+" "+("0"+t.getDate()).substr(-2)+","+("0"+t.getYear()).substr(-2)}else if(args.style==8){val=("0"+t.getHours()).substr(-2)+":"+("0"+(t.getMinutes()+1)).substr(-2)+":"+("0"+t.getSeconds()).substr(-2)}else if(args.style==10){val=("0"+(t.getMonth()+1)).substr(-2)+"-"+("0"+t.getDate()).substr(-2)+"-"+("0"+t.getYear()).substr(-2)}else if(args.style==11){val=("0"+t.getYear()).substr(-2)+"/"+("0"+(t.getMonth()+1)).substr(-2)+"/"+("0"+t.getDate()).substr(-2)}else if(args.style==12){val=("0"+t.getYear()).substr(-2)+("0"+(t.getMonth()+1)).substr(-2)+("0"+t.getDate()).substr(-2)}else if(args.style==101){val=("0"+(t.getMonth()+1)).substr(-2)+"/"+("0"+t.getDate()).substr(-2)+"/"+t.getFullYear()}else if(args.style==102){val=t.getFullYear()+"."+("0"+(t.getMonth()+1)).substr(-2)+"."+("0"+t.getDate()).substr(-2)}else if(args.style==103){val=("0"+t.getDate()).substr(-2)+"/"+("0"+(t.getMonth()+1)).substr(-2)+"/"+t.getFullYear()}else if(args.style==104){val=("0"+t.getDate()).substr(-2)+"."+("0"+(t.getMonth()+1)).substr(-2)+"."+t.getFullYear()}else if(args.style==105){val=("0"+t.getDate()).substr(-2)+"-"+("0"+(t.getMonth()+1)).substr(-2)+"-"+t.getFullYear()}else if(args.style==106){val=("0"+t.getDate()).substr(-2)+" "+t.toString().substr(4,3).toLowerCase()+" "+t.getFullYear()}else if(args.style==107){val=t.toString().substr(4,3)+" "+("0"+t.getDate()).substr(-2)+","+t.getFullYear()}else if(args.style==108){val=("0"+t.getHours()).substr(-2)+":"+("0"+(t.getMinutes()+1)).substr(-2)+":"+("0"+t.getSeconds()).substr(-2)}else if(args.style==110){val=("0"+(t.getMonth()+1)).substr(-2)+"-"+("0"+t.getDate()).substr(-2)+"-"+t.getFullYear()}else if(args.style==111){val=t.getFullYear()+"/"+("0"+(t.getMonth()+1)).substr(-2)+"/"+("0"+t.getDate()).substr(-2)}else if(args.style==112){val=t.getFullYear()+("0"+(t.getMonth()+1)).substr(-2)+("0"+t.getDate()).substr(-2)}else{throw new Error("The CONVERT style "+args.style+" is not realized yet.")}}var udbtypeid=args.dbtypeid.toUpperCase();if(args.dbtypeid=="Date"){return new Date(val)}else if(udbtypeid=="DATE"){var d=new Date(val);var s=d.getFullYear()+"."+("0"+(d.getMonth()+1)).substr(-2)+"."+("0"+d.getDate()).substr(-2);return s}else if(udbtypeid=="DATETIME"){var d=new Date(val);var s=d.getFullYear()+"."+("0"+(d.getMonth()+1)).substr(-2)+"."+("0"+d.getDate()).substr(-2);s+=" "+("0"+d.getHours()).substr(-2)+":"+("0"+d.getMinutes()).substr(-2)+":"+("0"+d.getSeconds()).substr(-2);s+="."+("00"+d.getMilliseconds()).substr(-3);return s}else if(["NUMBER","FLOAT"].indexOf(udbtypeid)>-1){return+val}else if(["MONEY"].indexOf(udbtypeid)>-1){var m=+val;return(m|0)+m*100%100/100}else if(["BOOLEAN"].indexOf(udbtypeid)>-1){return!!val}else if(["INT","INTEGER","SMALLINT","BIGINT","SERIAL","SMALLSERIAL","BIGSERIAL"].indexOf(args.dbtypeid.toUpperCase())>-1){return val|0}else if(["STRING","VARCHAR","NVARCHAR","CHARACTER VARIABLE"].indexOf(args.dbtypeid.toUpperCase())>-1){if(args.dbsize)return(""+val).substr(0,args.dbsize);else return""+val}else if(["CHAR","CHARACTER","NCHAR"].indexOf(udbtypeid)>-1){return(val+new Array(args.dbsize+1).join(" ")).substr(0,args.dbsize)}else if(["DECIMAL","NUMERIC"].indexOf(udbtypeid)>-1){var m=+val;var fxd=Math.pow(10,args.dbpecision);return(m|0)+m*fxd%fxd/fxd}else if(["JSON"].indexOf(udbtypeid)>-1){if(typeof val=="object")return val;try{return JSON.parse(val)}catch(err){throw new Error("Cannot convert string to JSON")}}return val};yy.ColumnDef=function(params){return yy.extend(this,params)};yy.ColumnDef.prototype.toString=function(){var s=this.columnid;if(this.dbtypeid)s+=" "+this.dbtypeid;if(this.dbsize){s+="("+this.dbsize;if(this.dbprecision)s+=","+this.dbprecision;s+=")"}if(this.primarykey)s+=" PRIMARY KEY";if(this.notnull)s+=" NOT NULL";return s};yy.CreateTable=function(params){return yy.extend(this,params)};yy.CreateTable.prototype.toString=function(){var s=K("CREATE");if(this.temporary)s+=" "+K("TEMPORARY");if(this.view)s+=" "+K("VIEW");else s+=" "+(this.class?K("CLASS"):K("TABLE"));if(this.ifnotexists)s+=" "+K("IF")+" "+K("NOT")+" "+K("EXISTS");s+=" "+this.table.toString();if(this.viewcolumns){s+="("+this.viewcolumns.map(function(vcol){return vcol.toString()}).join(",")+")"}if(this.as)s+=" "+K("AS")+" "+L(this.as);else{var ss=this.columns.map(function(col){return col.toString()});s+=" ("+NL()+ID()+ss.join(","+NL()+ID())+")"}if(this.view&&this.select){s+=" AS "+this.select.toString()}return s};yy.CreateTable.prototype.execute=function(databaseid,params,cb){var db=alasql.databases[this.table.databaseid||databaseid];var tableid=this.table.tableid;if(!tableid){throw new Error("Table name is not defined")}var columns=this.columns;var constraints=this.constraints||[];if(this.ifnotexists&&db.tables[tableid])return 0;if(db.tables[tableid]){throw new Error("Can not create table '"+tableid+"', because it already exists in the database '"+db.databaseid+"'")}var table=db.tables[tableid]=new alasql.Table;if(this.class){table.isclass=true}table.identities={};table.checkfn=[];var ss=[];if(this.columns){this.columns.forEach(function(col){var dbtypeid=col.dbtypeid;if(!alasql.fn[dbtypeid])dbtypeid=dbtypeid.toUpperCase();if(["SERIAL","SMALLSERIAL","BIGSERIAL"].indexOf(dbtypeid)>-1)col.identity={value:1,step:1};var newcol={columnid:col.columnid,dbtypeid:dbtypeid,dbsize:col.dbsize,dbprecision:col.dbprecision,notnull:col.notnull,identity:col.identity};if(col.identity){table.identities[col.columnid]={value:+col.identity.value,step:+col.identity.step}}if(col.check){table.checkfn.push(new Function("r","var y;return "+col.check.expression.toJavaScript("r","")))}if(col.default){ss.push("'"+col.columnid+"':"+col.default.toJavaScript("r",""))}if(col.primarykey){var pk=table.pk={};pk.columns=[col.columnid];pk.onrightfns="r['"+col.columnid+"']";pk.onrightfn=new Function("r","var y;return "+pk.onrightfns);pk.hh=hash(pk.onrightfns);table.uniqs[pk.hh]={}}if(col.unique){var uk={};if(typeof table.uk=="undefined")table.uk=[];table.uk.push(uk);uk.columns=[col.columnid];uk.onrightfns="r['"+col.columnid+"']";uk.onrightfn=new Function("r","var y;return "+uk.onrightfns);uk.hh=hash(uk.onrightfns);table.uniqs[uk.hh]={}}if(col.foreignkey){var fk=col.foreignkey.table;var fktable=alasql.databases[fk.databaseid||alasql.useid].tables[fk.tableid];if(typeof fk.columnid=="undefined"){if(fktable.pk.columns&&fktable.pk.columns.length>0){fk.columnid=fktable.pk.columns[0]}else{throw new Error("FOREIGN KEY allowed only to tables with PRIMARY KEYs")}}var fkfn=function(r){var rr={};if(typeof r[col.columnid]=="undefined")return true;rr[fk.columnid]=r[col.columnid];var addr=fktable.pk.onrightfn(rr);if(!fktable.uniqs[fktable.pk.hh][addr]){throw new Error('Foreign key "'+r[col.columnid]+'" is not found in table '+fktable.tableid)}return true};table.checkfn.push(fkfn)}table.columns.push(newcol);table.xcolumns[newcol.columnid]=newcol})}table.defaultfns=ss.join(",");constraints.forEach(function(con){if(con.type=="PRIMARY KEY"){if(table.pk){throw new Error("Primary key already exists")}var pk=table.pk={};pk.columns=con.columns;pk.onrightfns=pk.columns.map(function(columnid){return"r['"+columnid+"']"}).join("+'`'+");pk.onrightfn=new Function("r","var y;return "+pk.onrightfns);pk.hh=hash(pk.onrightfns);table.uniqs[pk.hh]={}}else if(con.type=="CHECK"){table.checkfn.push(new Function("r","var y;return "+con.expression.toJavaScript("r","")))}else if(con.type=="UNIQUE"){var uk={};if(!table.uk)table.uk=[];table.uk.push(uk);uk.columns=con.columns;uk.onrightfns=uk.columns.map(function(columnid){return"r['"+columnid+"']"}).join("+'`'+");uk.onrightfn=new Function("r","var y;return "+uk.onrightfns);uk.hh=hash(uk.onrightfns);table.uniqs[uk.hh]={}}else if(con.type=="FOREIGN KEY"){var col=table.xcolumns[con.columns[0]];var fk=con.fktable;if(con.fkcolumns&&con.fkcolumns.length>0)fk.columnid=con.fkcolumns[0];var fktable=alasql.databases[fk.databaseid||alasql.useid].tables[fk.tableid];if(typeof fk.columnid=="undefined"){fk.columnid=fktable.pk.columns[0]}var fkfn=function(r){var rr={};if(typeof r[col.columnid]=="undefined")return true;rr[fk.columnid]=r[col.columnid];var addr=fktable.pk.onrightfn(rr);if(!fktable.uniqs[fktable.pk.hh][addr]){throw new Error('Foreign key "'+r[col.columnid]+'" is not found in table '+fktable.tableid)}return true};table.checkfn.push(fkfn)}});if(this.view&&this.viewcolumns){var self=this;this.viewcolumns.forEach(function(vcol,idx){self.select.columns[idx].as=vcol.columnid})}if(db.engineid){return alasql.engines[db.engineid].createTable(this.table.databaseid||databaseid,tableid,this.ifnotexists,cb)}table.insert=function(r){var table=this;for(var columnid in table.identities){var ident=table.identities[columnid];r[columnid]=ident.value}if(table.checkfn&&table.checkfn.length>0){table.checkfn.forEach(function(checkfn){if(!checkfn(r)){throw new Error("Violation of CHECK constraint")}})}table.columns.forEach(function(column){if(column.notnull&&typeof r[column.columnid]=="undefined"){throw new Error("Wrong NULL value in NOT NULL column "+column.columnid)}});if(table.pk){var pk=table.pk;var addr=pk.onrightfn(r);if(typeof table.uniqs[pk.hh][addr]!="undefined"){throw new Error("Cannot insert record, because it already exists in primary key index")}}if(table.uk&&table.uk.length){table.uk.forEach(function(uk){var ukaddr=uk.onrightfn(r);if(typeof table.uniqs[uk.hh][ukaddr]!="undefined"){throw new Error("Cannot insert record, because it already exists in unique index")}})}table.data.push(r);for(var columnid in table.identities){var ident=table.identities[columnid];ident.value+=ident.step}if(table.pk){var pk=table.pk;var addr=pk.onrightfn(r);table.uniqs[pk.hh][addr]=r}if(table.uk&&table.uk.length){table.uk.forEach(function(uk){var ukaddr=uk.onrightfn(r);table.uniqs[uk.hh][ukaddr]=r})}};table.delete=function(i,params,alasql){var table=this;var r=this.data[i];if(this.pk){var pk=this.pk;var addr=pk.onrightfn(r);if(typeof this.uniqs[pk.hh][addr]=="undefined"){throw new Error("Something wrong with primary key index on table")}else{this.uniqs[pk.hh][addr]=undefined}}if(table.uk&&table.uk.length){table.uk.forEach(function(uk){var ukaddr=uk.onrightfn(r);if(typeof table.uniqs[uk.hh][ukaddr]=="undefined"){throw new Error("Something wrong with unique index on table")}table.uniqs[uk.hh][ukaddr]=undefined})}};table.deleteall=function(){this.data.length=0;if(this.pk){this.uniqs[this.pk.hh]={}}if(table.uk&&table.uk.length){table.uk.forEach(function(uk){table.uniqs[uk.hh]={}})}};table.update=function(assignfn,i,params){var r=cloneDeep(this.data[i]);if(this.pk){var pk=this.pk;pk.pkaddr=pk.onrightfn(r,params);if(typeof this.uniqs[pk.hh][pk.pkaddr]=="undefined"){throw new Error("Something wrong with index on table")}else{}}if(table.uk&&table.uk.length){table.uk.forEach(function(uk){uk.ukaddr=uk.onrightfn(r);if(typeof table.uniqs[uk.hh][uk.ukaddr]=="undefined"){throw new Error("Something wrong with unique index on table")}})}assignfn(r,params,alasql);if(table.checkfn&&table.checkfn.length>0){table.checkfn.forEach(function(checkfn){if(!checkfn(r)){throw new Error("Violation of CHECK constraint")}})}table.columns.forEach(function(column){if(column.notnull&&typeof r[column.columnid]=="undefined"){throw new Error("Wrong NULL value in NOT NULL column "+column.columnid)}});if(this.pk){pk.newpkaddr=pk.onrightfn(r);if(typeof this.uniqs[pk.hh][pk.newpkaddr]!="undefined"&&pk.newpkaddr!=pk.pkaddr){throw new Error("Record already exists")}else{}}if(table.uk&&table.uk.length){table.uk.forEach(function(uk){uk.newukaddr=uk.onrightfn(r);if(typeof table.uniqs[uk.hh][uk.newukaddr]!="undefined"&&uk.newukaddr!=uk.ukaddr){throw new Error("Record already exists")}})}if(this.pk){this.uniqs[pk.hh][pk.pkaddr]=undefined;this.uniqs[pk.hh][pk.newpkaddr]=r}if(table.uk&&table.uk.length){table.uk.forEach(function(uk){table.uniqs[uk.hh][uk.ukaddr]=undefined;table.uniqs[uk.hh][uk.newukaddr]=r})}this.data[i]=r};if(this.view&&this.select){table.view=true;table.select=this.select.compile(this.table.databaseid||databaseid)}var res;if(!alasql.options.nocount)res=1;if(cb)res=cb(res);return res};alasql.fn.Date=Object;alasql.fn.Date=Date;alasql.fn.Number=Number;alasql.fn.String=String;alasql.fn.Boolean=Boolean;stdfn.EXTEND=alasql.utils.extend;stdfn.CHAR=String.fromCharCode.bind(String);stdfn.ASCII=function(a){return a.charCodeAt(0)};stdfn.COALESCE=function(){for(var i=0;i<arguments.length;i++){if(typeof arguments[i]=="undefined")continue;if(typeof arguments[i]=="number"&&isNaN(arguments[i]))continue;return arguments[i]}return undefined};stdfn.USER=function(){return"alasql"};stdfn.OBJECT_ID=function(objid){return!!alasql.tables[objid]};stdfn.DATE=function(d){if(/\d{8}/.test(d))return new Date(+d.substr(0,4),+d.substr(4,2)-1,+d.substr(6,2));return new Date(d)};stdfn.NOW=function(){var d=new Date;var s=d.getFullYear()+"."+("0"+(d.getMonth()+1)).substr(-2)+"."+("0"+d.getDate()).substr(-2);s+=" "+("0"+d.getHours()).substr(-2)+":"+("0"+d.getMinutes()).substr(-2)+":"+("0"+d.getSeconds()).substr(-2);s+="."+("00"+d.getMilliseconds()).substr(-3);return s};stdfn.GETDATE=stdfn.NOW;stdfn.CURRENT_TIMESTAMP=stdfn.NOW;stdfn.SECOND=function(d){var d=new Date(d);return d.getSeconds()};stdfn.MINUTE=function(d){var d=new Date(d);return d.getMinutes()};stdfn.HOUR=function(d){var d=new Date(d);return d.getHours()};stdfn.DAYOFWEEK=stdfn.WEEKDAY=function(d){var d=new Date(d);return d.getDay()};stdfn.DAY=stdfn.DAYOFMONTH=function(d){var d=new Date(d);return d.getDate()};stdfn.MONTH=function(d){var d=new Date(d);return d.getMonth()+1};stdfn.YEAR=function(d){var d=new Date(d);return d.getFullYear()};stdfn.DATEDIFF=function(a,b){return+new Date(a).valueOf()-new Date(b).valueOf()};yy.DropTable=function(params){return yy.extend(this,params)};yy.DropTable.prototype.toString=function(){var s=K("DROP")+" ";if(this.view)s+=K("VIEW");else s+=K("TABLE");if(this.ifexists)s+=" "+K("IF")+" "+K("EXISTS");s+=" "+this.table.toString();return s};yy.DropTable.prototype.execute=function(databaseid,params,cb){var db=alasql.databases[this.table.databaseid||databaseid];var tableid=this.table.tableid;if(db.engineid){return alasql.engines[db.engineid].dropTable(this.table.databaseid||databaseid,tableid,this.ifexists,cb)}if(!this.ifexists||this.ifexists&&db.tables[tableid]){if(!db.tables[tableid]){if(!alasql.options.dropifnotexists){throw new Error("Can not drop table '"+this.table.tableid+"', because it does not exist in the database.")}}else{delete db.tables[tableid];return 1}}return 0};yy.TruncateTable=function(params){return yy.extend(this,params)};yy.TruncateTable.prototype.toString=function(){var s=K("TRUNCATE")+" "+K("TABLE");s+=" "+this.table.toString();return s};yy.TruncateTable.prototype.execute=function(databaseid,params,cb){var db=alasql.databases[this.table.databaseid||databaseid];var tableid=this.table.tableid;if(db.engineid){return alasql.engines[db.engineid].truncateTable(this.table.databaseid||databaseid,tableid,this.ifexists,cb)}if(db.tables[tableid]){db.tables[tableid].data=[]}else{throw new Error("Cannot truncate table becaues it does not exist")}return 0};yy.CreateVertex=function(params){return yy.extend(this,params)};yy.CreateVertex.prototype.toString=function(){var s=K("CREATE")+" "+K("VERTEX")+" ";if(this.class)s+=L(this.class)+" ";if(this.sharp)s+="#"+L(this.sharp)+" ";if(this.sets){s+=this.sets.toString()}else if(this.content){s+=this.content.toString()}else if(this.select){s+=this.select.toString()}return s};yy.CreateVertex.prototype.toJavaScript=function(context,tableid,defcols){var s="this.queriesfn["+(this.queriesidx-1)+"](this.params,null,"+context+")";return s};yy.CreateVertex.prototype.compile=function(databaseid){var dbid=databaseid;var sharp=this.sharp;if(typeof this.name!="undefined"){var s="x.name="+this.name.toJavaScript();var namefn=new Function("x",s)}if(this.sets&&this.sets.length>0){var s=this.sets.map(function(st){return"x['"+st.column.columnid+"']="+st.expression.toJavaScript("x","")}).join(";");var setfn=new Function("x,params,alasql",s)}else if(this.content){}else if(this.select){}else{}var statement=function(params,cb){var res;var db=alasql.databases[dbid];if(typeof sharp!="undefined"){var id=sharp}else{var id=db.counter++}var vertex={$id:id,$node:"VERTEX"};db.objects[vertex.$id]=vertex;res=vertex;if(namefn)namefn(vertex);if(setfn)setfn(vertex,params,alasql);if(cb)res=cb(res);return res};return statement};yy.CreateEdge=function(params){return yy.extend(this,params)};yy.CreateEdge.prototype.toString=function(){var s=K("CREATE")+" "+K("EDGE")+" ";if(this.class)s+=L(this.class)+" ";return s};yy.CreateEdge.prototype.toJavaScript=function(context,tableid,defcols){var s="this.queriesfn["+(this.queriesidx-1)+"](this.params,null,"+context+")";return s};yy.CreateEdge.prototype.compile=function(databaseid){var dbid=databaseid;var fromfn=new Function("params,alasql","var y;return "+this.from.toJavaScript());var tofn=new Function("params,alasql","var y;return "+this.to.toJavaScript());if(typeof this.name!="undefined"){var s="x.name="+this.name.toJavaScript();var namefn=new Function("x",s)}if(this.sets&&this.sets.length>0){var s=this.sets.map(function(st){return"x['"+st.column.columnid+"']="+st.expression.toJavaScript("x","")}).join(";");var setfn=new Function("x,params,alasql","var y;"+s)}else if(this.content){}else if(this.select){}else{}var statement=function(params,cb){var res=0;var db=alasql.databases[dbid];var edge={$id:db.counter++,$node:"EDGE"};var v1=fromfn(params,alasql);var v2=tofn(params,alasql);edge.$in=[v1.$id];edge.$out=[v2.$id];if(typeof v1.$out=="undefined")v1.$out=[];v1.$out.push(edge.$id);if(typeof v2.$in=="undefined")v2.$in=[];v2.$in.push(edge.$id);db.objects[edge.$id]=edge;res=edge;if(namefn)namefn(edge);if(setfn)setfn(edge,params,alasql);if(cb)res=cb(res);return res};return statement};yy.CreateGraph=function(params){return yy.extend(this,params)};yy.CreateGraph.prototype.toString=function(){var s=K("CREATE")+" "+K("GRAPH")+" ";if(this.class)s+=L(this.class)+" ";return s};yy.CreateGraph.prototype.execute=function(databaseid,params,cb){var res=[];if(this.from){if(alasql.from[this.from.funcid]){this.graph=alasql.from[this.from.funcid.toUpperCase()](this.from.args[0].value);console.log(this.graph)}}this.graph.forEach(function(g){if(g.source){var e={};if(typeof g.as!="undefined")alasql.vars[g.as]=e;if(typeof g.prop!="undefined"){e.name=g.prop}if(typeof g.sharp!="undefined")e.$id=g.sharp;if(typeof g.name!="undefined")e.name=g.name;if(typeof g.class!="undefined")e.$class=g.class;var db=alasql.databases[databaseid];if(typeof e.$id=="undefined"){e.$id=db.counter++}e.$node="EDGE";if(typeof g.json!="undefined"){extend(e,new Function("params,alasql","var y;return "+g.json.toJavaScript())(params,alasql))}var v1;if(g.source.vars){var vo=alasql.vars[g.source.vars];if(typeof vo=="object")v1=vo;else v1=db.objects[vo]}else{var av1=g.source.sharp;if(typeof av1=="undefined")av1=g.source.prop;v1=alasql.databases[databaseid].objects[av1];if(typeof v1=="undefined"&&alasql.options.autovertex&&(typeof g.source.prop!="undefined"||typeof g.source.name!="undefined")){v1=findVertex(g.source.prop||g.source.name);if(typeof v1=="undefined"){v1=createVertex(g.source)}}}var v2;if(g.source.vars){var vo=alasql.vars[g.target.vars];if(typeof vo=="object")v2=vo;else v2=db.objects[vo]}else{var av2=g.target.sharp;if(typeof av2=="undefined")av2=g.target.prop;v2=alasql.databases[databaseid].objects[av2];if(typeof v2=="undefined"&&alasql.options.autovertex&&(typeof g.target.prop!="undefined"||typeof g.target.name!="undefined")){v2=findVertex(g.target.prop||g.target.name);if(typeof v2=="undefined"){v2=createVertex(g.target)}}}e.$in=[v1.$id];e.$out=[v2.$id];if(typeof v1.$out=="undefined")v1.$out=[];v1.$out.push(e.$id);if(typeof v2.$in=="undefined")v2.$in=[];v2.$in.push(e.$id);db.objects[e.$id]=e;if(typeof e.$class!="undefined"){if(typeof alasql.databases[databaseid].tables[e.$class]=="undefined"){throw new Error("No such class. Pleace use CREATE CLASS")}else{alasql.databases[databaseid].tables[e.$class].data.push(e)}}res.push(e.$id)}else{createVertex(g)}});if(cb)res=cb(res);return res;function findVertex(name){var objects=alasql.databases[alasql.useid].objects;for(var k in objects){if(objects[k].name==name){return objects[k]}}return undefined}function createVertex(g){var v={};if(typeof g.as!="undefined")alasql.vars[g.as]=v;if(typeof g.prop!="undefined"){v.$id=g.prop;v.name=g.prop}if(typeof g.sharp!="undefined")v.$id=g.sharp;if(typeof g.name!="undefined")v.name=g.name;if(typeof g.class!="undefined")v.$class=g.class;var db=alasql.databases[databaseid];if(typeof v.$id=="undefined"){v.$id=db.counter++}v.$node="VERTEX";if(typeof g.json!="undefined"){extend(v,new Function("params,alasql","var y;return "+g.json.toJavaScript())(params,alasql))}db.objects[v.$id]=v;if(typeof v.$class!="undefined"){if(typeof alasql.databases[databaseid].tables[v.$class]=="undefined"){throw new Error("No such class. Pleace use CREATE CLASS")}else{alasql.databases[databaseid].tables[v.$class].data.push(v)}}res.push(v.$id);return v}};yy.CreateGraph.prototype.compile1=function(databaseid){var dbid=databaseid;var fromfn=new Function("params,alasql","var y;return "+this.from.toJavaScript());var tofn=new Function("params,alasql","var y;return "+this.to.toJavaScript());if(typeof this.name!="undefined"){var s="x.name="+this.name.toJavaScript();var namefn=new Function("x",s)}if(this.sets&&this.sets.length>0){var s=this.sets.map(function(st){return"x['"+st.column.columnid+"']="+st.expression.toJavaScript("x","")}).join(";");var setfn=new Function("x,params,alasql","var y;"+s)}else if(this.content){}else if(this.select){}else{}var statement=function(params,cb){var res=0;var db=alasql.databases[dbid];var edge={$id:db.counter++,$node:"EDGE"};var v1=fromfn(params,alasql);var v2=tofn(params,alasql);edge.$in=[v1.$id];edge.$out=[v2.$id];if(typeof v1.$out=="undefined")v1.$out=[];v1.$out.push(edge.$id);if(typeof v2.$in=="undefined")v2.$in=[];v2.$in.push(edge.$id);db.objects[edge.$id]=edge;res=edge;if(namefn)namefn(edge);if(setfn)setfn(edge,params,alasql);if(cb)res=cb(res);return res};return statement};yy.AlterTable=function(params){return yy.extend(this,params)};yy.AlterTable.prototype.toString=function(){var s="ALTER TABLE "+this.table.toString();if(this.renameto)s+=" RENAME TO "+this.renameto;return s};yy.AlterTable.prototype.execute=function(databaseid,params,cb){var db=alasql.databases[databaseid];db.dbversion=Date.now();if(this.renameto){var oldtableid=this.table.tableid;var newtableid=this.renameto;var res=1;if(db.tables[newtableid]){throw new Error("Can not rename a table '"+oldtableid+"' to '"+newtableid+"', because the table with this name already exists")}else if(newtableid==oldtableid){throw new Error("Can not rename a table '"+oldtableid+"' to itself")}else{db.tables[newtableid]=db.tables[oldtableid];delete db.tables[oldtableid];res=1}if(cb)cb(res);return res}else if(this.addcolumn){var db=alasql.databases[this.table.databaseid||databaseid];db.dbversion++;var tableid=this.table.tableid;var table=db.tables[tableid];var columnid=this.addcolumn.columnid;if(table.xcolumns[columnid]){throw new Error('Cannot add column "'+columnid+'", because it already exists in the table "'+tableid+'"')}var col={columnid:columnid,dbtypeid:this.dbtypeid,dbsize:this.dbsize,dbprecision:this.dbprecision,dbenum:this.dbenum,defaultfns:null};var defaultfn=function(){};table.columns.push(col);table.xcolumns[columnid]=col;for(var i=0,ilen=table.data.length;i<ilen;i++){table.data[i][columnid]=defaultfn()}return 1}else if(this.modifycolumn){var db=alasql.databases[this.table.databaseid||databaseid];db.dbversion++;var tableid=this.table.tableid;var table=db.tables[tableid];var columnid=this.modifycolumn.columnid;if(!table.xcolumns[columnid]){throw new Error('Cannot modify column "'+columnid+'", because it was not found in the table "'+tableid+'"')}var col=table.xcolumns[columnid];col.dbtypeid=this.dbtypeid;col.dbsize=this.dbsize;col.dbprecision=this.dbprecision;col.dbenum=this.dbenum;return 1}else if(this.renamecolumn){var db=alasql.databases[this.table.databaseid||databaseid];db.dbversion++;var tableid=this.table.tableid;var table=db.tables[tableid];var columnid=this.renamecolumn;var tocolumnid=this.to;var col;if(!table.xcolumns[columnid]){throw new Error('Column "'+columnid+'" is not found in the table "'+tableid+'"')}if(table.xcolumns[tocolumnid]){throw new Error('Column "'+tocolumnid+'" already exists in the table "'+tableid+'"')}if(columnid!=tocolumnid){for(var j=0;j<table.columns.length;j++){if(table.columns[j].columnid==columnid){table.columns[j].columnid=tocolumnid}}table.xcolumns[tocolumnid]=table.xcolumns[columnid];delete table.xcolumns[columnid];for(var i=0,ilen=table.data.length;i<ilen;i++){table.data[i][tocolumnid]=table.data[i][columnid];delete table.data[i][columnid]}return table.data.length}else return 0}else if(this.dropcolumn){var db=alasql.databases[this.table.databaseid||databaseid];db.dbversion++;var tableid=this.table.tableid;var table=db.tables[tableid];var columnid=this.dropcolumn;var found=false;for(var j=0;j<table.columns.length;j++){if(table.columns[j].columnid==columnid){found=true;table.columns.splice(j,1);break}}if(!found){throw new Error('Cannot drop column "'+columnid+'", because it was not found in the table "'+tableid+'"')}delete table.xcolumns[columnid];for(var i=0,ilen=table.data.length;i<ilen;i++){delete table.data[i][columnid]}return table.data.length}else{throw Error("Unknown ALTER TABLE method")}};yy.CreateIndex=function(params){return yy.extend(this,params)};yy.CreateIndex.prototype.toString=function(){var s="CREATE";if(this.unique)s+=" UNIQUE";s+=" INDEX "+this.indexid+" ON "+this.table.toString();s+="("+this.columns.toString()+")";return s};yy.CreateIndex.prototype.execute=function(databaseid,params,cb){var db=alasql.databases[databaseid];var tableid=this.table.tableid;var table=db.tables[tableid];var indexid=this.indexid;if(this.unique){var rightfns=this.columns.map(function(colid){return"r['"+colid+"']"}).join("+'`'+");table.uniqdefs[indexid]={rightfns:rightfns};var ux=table.uniqs[indexid]={};if(table.data.length>0){for(var i=0,ilen=table.data.length;i<ilen;i++){var addr=rightfns(table.data[i]);
        if(!ux[addr]){ux[addr]={num:0}}ux[addr].num++}}}else{var rightfns=this.columns.map(function(colid){return"r['"+colid+"']"}).join("+'`'+");var hh=hash(rightfns);table.inddefs[indexid]={rightfns:rightfns,hh:hh};table.indices[hh]={};var ix=table.indices[hh]={};if(table.data.length>0){for(var i=0,ilen=table.data.length;i<ilen;i++){var addr=rightfns(table.data[i]);if(!ix[addr]){ix[addr]=[]}ix[addr].push(table.data[i])}}}var res=1;if(cb)res=cb(res);return res};yy.DropIndex=function(params){return yy.extend(this,params)};yy.DropIndex.prototype.toString=function(){return"INDEX TABLE"+this.indexid};yy.DropIndex.prototype.compile=function(db){var indexid=this.indexid;return function(){return 1}};yy.WithSelect=function(params){return yy.extend(this,params)};yy.WithSelect.prototype.toString=function(){var s=K("WITH")+" ";s+=this.withs.map(function(w){return L(w.name)+" "+K("AS")+" ("+w.select.toString()+")"}).join(",")+" ";s+=this.select.toString();return s};yy.WithSelect.prototype.execute=function(databaseid,params,cb){var self=this;var savedTables=[];self.withs.forEach(function(w){savedTables.push(alasql.databases[databaseid].tables[w.name]);var tb=alasql.databases[databaseid].tables[w.name]=new Table({tableid:w.name});tb.data=w.select.execute(databaseid,params)});var res=1;res=this.select.execute(databaseid,params,function(data){self.withs.forEach(function(w,idx){if(savedTables[idx])alasql.databases[databaseid].tables[w.name]=savedTables[idx];else delete alasql.databases[databaseid].tables[w.name]});if(cb)data=cb(data);return data});return res};yy.If=function(params){return yy.extend(this,params)};yy.If.prototype.toString=function(){var s=K("IF")+" ";s+=this.expression.toString();s+=" "+this.thenstat.toString();if(this.elsestat)s+=" "+K("ELSE")+NL()+ID()+this.thenstat.toString();return s};yy.If.prototype.execute=function(databaseid,params,cb){var res;var fn=new Function("params,alasql,p","var y;return "+this.expression.toJavaScript("({})","",null)).bind(this);if(fn(params,alasql))res=this.thenstat.execute(databaseid,params,cb);else{if(this.elsestat)res=this.elsestat.execute(databaseid,params,cb);else{if(cb)res=cb(res)}}return res};yy.While=function(params){return yy.extend(this,params)};yy.While.prototype.toString=function(){var s="WHILE ";s+=this.expression.toString();s+=" "+this.loopstat.toString();return s};yy.While.prototype.execute=function(databaseid,params,cb){var self=this;var res=[];var fn=new Function("params,alasql,p","var y;return "+this.expression.toJavaScript());if(cb){var first=false;loop();function loop(data){if(first){res.push(data)}else{first=true}setTimeout(function(){if(fn(params,alasql)){self.loopstat.execute(databaseid,params,loop)}else{res=cb(res)}},0)}}else{while(fn(params,alasql)){var res1=self.loopstat.execute(databaseid,params);res.push(res1)}}return res};yy.Break=function(params){return yy.extend(this,params)};yy.Break.prototype.toString=function(){var s=K("BREAK");return s};yy.Break.prototype.execute=function(databaseid,params,cb,scope){var res=1;if(cb)res=cb(res);return res};yy.Continue=function(params){return yy.extend(this,params)};yy.Continue.prototype.toString=function(){var s=K("CONTINUE");return s};yy.Continue.prototype.execute=function(databaseid,params,cb,scope){var res=1;if(cb)res=cb(res);return res};yy.BeginEnd=function(params){return yy.extend(this,params)};yy.BeginEnd.prototype.toString=function(){var s=K("BEGIN")+" "+this.statements.toString()+" "+K("END");return s};yy.BeginEnd.prototype.execute=function(databaseid,params,cb,scope){var self=this;var res=[];var idx=0;runone();function runone(){self.statements[idx].execute(databaseid,params,function(data){res.push(data);idx++;if(idx<self.statements.length)return runone();if(cb)res=cb(res)})}return res};yy.Insert=function(params){return yy.extend(this,params)};yy.Insert.prototype.toString=function(){var s="INSERT INTO "+this.into.toString();if(this.columns)s+="("+this.columns.toString()+")";if(this.values)s+=" VALUES "+this.values.toString();if(this.select)s+=" "+this.select.toString();return s};yy.Insert.prototype.toJavaScript=function(context,tableid,defcols){var s="this.queriesfn["+(this.queriesidx-1)+"](this.params,null,"+context+")";return s};yy.Insert.prototype.compile=function(databaseid){var self=this;databaseid=self.into.databaseid||databaseid;var db=alasql.databases[databaseid];var tableid=self.into.tableid;var table=db.tables[tableid];var s="";var sw="";var s3="var a,aa=[],x;";var s33;if(this.values){if(this.exists){this.existsfn=this.exists.map(function(ex){var nq=ex.compile(databaseid);nq.query.modifier="RECORDSET";return nq})}if(this.queries){this.queriesfn=this.queries.map(function(q){var nq=q.compile(databaseid);nq.query.modifier="RECORDSET";return nq})}self.values.forEach(function(values){var ss=[];if(self.columns){self.columns.forEach(function(col,idx){var q="'"+col.columnid+"':";if(table.xcolumns&&table.xcolumns[col.columnid]){if(["INT","FLOAT","NUMBER","MONEY"].indexOf(table.xcolumns[col.columnid].dbtypeid)>=0){q+="(x="+values[idx].toJavaScript()+",x==undefined?undefined:+x)"}else if(alasql.fn[table.xcolumns[col.columnid].dbtypeid]){q+="(new "+table.xcolumns[col.columnid].dbtypeid+"(";q+=values[idx].toJavaScript();q+="))"}else{q+=values[idx].toJavaScript()}}else{q+=values[idx].toJavaScript()}ss.push(q)})}else{if(values instanceof Array&&table.columns&&table.columns.length>0){table.columns.forEach(function(col,idx){var q="'"+col.columnid+"':";if(["INT","FLOAT","NUMBER","MONEY"].indexOf(col.dbtypeid)>=0){q+="+"+values[idx].toJavaScript()}else if(alasql.fn[col.dbtypeid]){q+="(new "+col.dbtypeid+"(";q+=values[idx].toJavaScript();q+="))"}else{q+=values[idx].toJavaScript()}ss.push(q)})}else{sw=JSONtoJavaScript(values)}}if(db.tables[tableid].defaultfns){ss.unshift(db.tables[tableid].defaultfns)}if(sw){s+="a="+sw+";"}else{s+="a={"+ss.join(",")+"};"}if(db.tables[tableid].isclass){s+="var db=alasql.databases['"+databaseid+"'];";s+='a.$class="'+tableid+'";';s+="a.$id=db.counter++;";s+="db.objects[a.$id]=a;"}if(db.tables[tableid].insert){s+="var db=alasql.databases['"+databaseid+"'];";s+="db.tables['"+tableid+"'].insert(a);"}else{s+="aa.push(a);"}});s33=s3+s;if(db.tables[tableid].insert){}else{s+="alasql.databases['"+databaseid+"'].tables['"+tableid+"'].data="+"alasql.databases['"+databaseid+"'].tables['"+tableid+"'].data.concat(aa);"}if(db.tables[tableid].insert){if(db.tables[tableid].isclass){s+="return a.$id;"}else{s+="return "+self.values.length}}else{s+="return "+self.values.length}var insertfn=new Function("db, params, alasql","var y;"+s3+s).bind(this)}else if(this.select){selectfn=this.select.compile(databaseid);if(db.engineid&&alasql.engines[db.engineid].intoTable){var statement=function(params,cb){var aa=selectfn(params);var res=alasql.engines[db.engineid].intoTable(db.databaseid,tableid,aa,null,cb);return res};return statement}else{var insertfn=function(db,params,alasql){var res=selectfn(params);if(db.tables[tableid].insert){for(var i=0,ilen=res.length;i<ilen;i++){db.tables[tableid].insert(res[i])}}else{db.tables[tableid].data=db.tables[tableid].data.concat(res)}if(alasql.options.nocount)return;else return res.length}}}else if(this.default){var insertfns="db.tables['"+tableid+"'].data.push({"+table.defaultfns+"});return 1;";var insertfn=new Function("db,params,alasql",insertfns)}else{throw new Error("Wrong INSERT parameters")}if(db.engineid&&alasql.engines[db.engineid].intoTable&&alasql.options.autocommit){var statement=function(params,cb){var aa=new Function("db,params","var y;"+s33+"return aa;")(db,params);var res=alasql.engines[db.engineid].intoTable(db.databaseid,tableid,aa,null,cb);return res}}else{var statement=function(params,cb){var db=alasql.databases[databaseid];if(alasql.options.autocommit&&db.engineid){alasql.engines[db.engineid].loadTableData(databaseid,tableid)}var res=insertfn(db,params,alasql);if(alasql.options.autocommit&&db.engineid){alasql.engines[db.engineid].saveTableData(databaseid,tableid)}if(alasql.options.nocount)res=undefined;if(cb)cb(res);return res}}return statement};yy.Insert.prototype.execute=function(databaseid,params,cb){return this.compile(databaseid)(params,cb)};yy.Delete=function(params){return yy.extend(this,params)};yy.Delete.prototype.toString=function(){var s="DELETE FROM "+this.table.toString();if(this.where)s+=" WHERE "+this.where.toString();return s};yy.Delete.prototype.compile=function(databaseid){databaseid=this.table.databaseid||databaseid;var tableid=this.table.tableid;var statement;var db=alasql.databases[databaseid];if(this.where){if(this.exists){this.existsfn=this.exists.map(function(ex){var nq=ex.compile(databaseid);nq.query.modifier="RECORDSET";return nq})}if(this.queries){this.queriesfn=this.queries.map(function(q){var nq=q.compile(databaseid);nq.query.modifier="RECORDSET";return nq})}wherefn=new Function("r,params,alasql","var y;return ("+this.where.toJavaScript("r","")+")").bind(this);statement=function(params,cb){if(db.engineid&&alasql.engines[db.engineid].deleteFromTable){return alasql.engines[db.engineid].deleteFromTable(databaseid,tableid,wherefn,params,cb)}if(alasql.options.autocommit&&db.engineid&&db.engineid=="LOCALSTORAGE"){alasql.engines[db.engineid].loadTableData(databaseid,tableid)}var table=db.tables[tableid];var orignum=table.data.length;var newtable=[];for(var i=0,ilen=table.data.length;i<ilen;i++){if(wherefn(table.data[i],params,alasql)){if(table.delete){table.delete(i,params,alasql)}else{}}else newtable.push(table.data[i])}table.data=newtable;var res=orignum-table.data.length;if(alasql.options.autocommit&&db.engineid&&db.engineid=="LOCALSTORAGE"){alasql.engines[db.engineid].saveTableData(databaseid,tableid)}if(cb)cb(res);return res}}else{statement=function(params,cb){if(alasql.options.autocommit&&db.engineid){alasql.engines[db.engineid].loadTableData(databaseid,tableid)}var table=db.tables[tableid];table.dirty=true;var orignum=db.tables[tableid].data.length;db.tables[tableid].data.length=0;if(alasql.options.autocommit&&db.engineid){alasql.engines[db.engineid].saveTableData(databaseid,tableid)}if(cb)cb(orignum);return orignum}}return statement};yy.Delete.prototype.execute=function(databaseid,params,cb){return this.compile(databaseid)(params,cb)};yy.Update=function(params){return yy.extend(this,params)};yy.Update.prototype.toString=function(){var s="UPDATE "+this.table.toString();if(this.columns)s+=" SET "+this.columns.toString();if(this.where)s+=" WHERE "+this.where.toString();return s};yy.SetColumn=function(params){return yy.extend(this,params)};yy.SetColumn.prototype.toString=function(){return this.column.toString()+"="+this.expression.toString()};yy.Update.prototype.compile=function(databaseid){databaseid=this.table.databaseid||databaseid;var tableid=this.table.tableid;if(this.where){if(this.exists){this.existsfn=this.exists.map(function(ex){var nq=ex.compile(databaseid);nq.query.modifier="RECORDSET";return nq})}if(this.queries){this.queriesfn=this.queries.map(function(q){var nq=q.compile(databaseid);nq.query.modifier="RECORDSET";return nq})}var wherefn=new Function("r,params,alasql","var y;return "+this.where.toJavaScript("r","")).bind(this)}var s="";this.columns.forEach(function(col){s+="r['"+col.column.columnid+"']="+col.expression.toJavaScript("r","")+";"});var assignfn=new Function("r,params,alasql","var y;"+s);var statement=function(params,cb){var db=alasql.databases[databaseid];if(db.engineid&&alasql.engines[db.engineid].updateTable){return alasql.engines[db.engineid].updateTable(databaseid,tableid,assignfn,wherefn,params,cb)}if(alasql.options.autocommit&&db.engineid){alasql.engines[db.engineid].loadTableData(databaseid,tableid)}var table=db.tables[tableid];if(!table){throw new Error("Table '"+tableid+"' not exists")}var numrows=0;for(var i=0,ilen=table.data.length;i<ilen;i++){if(!wherefn||wherefn(table.data[i],params,alasql)){if(table.update){table.update(assignfn,i,params)}else{assignfn(table.data[i],params,alasql)}numrows++}}if(alasql.options.autocommit&&db.engineid){alasql.engines[db.engineid].saveTableData(databaseid,tableid)}if(cb)cb(numrows);return numrows};return statement};yy.Update.prototype.execute=function(databaseid,params,cb){return this.compile(databaseid)(params,cb)};yy.Merge=function(params){return yy.extend(this,params)};yy.Merge.prototype.toString=function(){var s=K("MERGE")+" ";s+=L(this.into.tableid)+" ";if(this.into.as)s+=K("AS")+" "+L(this.into.as)+" ";s+=K("USING")+" "+L(this.using.tableid)+" ";if(this.using.as)s+=K("AS")+" "+L(this.using.as)+" ";s+=K("ON")+" "+this.on.toString()+" ";this.matches.forEach(function(m){s+=K("WHEN")+" ";if(!m.matched)s+=K("NOT")+" ";s+=K("MATCHED")+" ";if(m.bytarget)s+=K("BY")+" "+K("TARGET")+" ";if(m.bysource)s+=K("BY")+" "+K("SOURCE")+" ";if(m.expr)s+=K("AND")+" "+m.expr.toString()+" ";s+=K("THEN")+" ";if(m.action.delete)s+=K("DELETE")+" ";if(m.action.insert){s+=K("INSERT")+" ";if(m.action.columns)s+="("+m.action.columns.toString()+") ";if(m.action.values)s+=K("VALUES")+" ("+m.action.values.toString()+") ";if(m.action.defaultvalues)s+=K("DEFAULT")+" "+K("VALUES")+" "}if(m.action.update){s+=K("UPDATE")+" ";s+=m.action.update.map(function(u){return u.toString()}).join(",")+" "}});return s};yy.Merge.prototype.execute=function(databaseid,params,cb){var res=1;if(cb)res=cb(res);return res};yy.CreateDatabase=function(params){return yy.extend(this,params)};yy.CreateDatabase.prototype.toString=function(){var s=K("CREATE");if(this.engineid)s+=" "+L(this.engineid);s+=" "+K("DATABASE");if(this.ifnotexists)s+=" "+K("IF")+" "+K("NOT")+" "+K("EXISTS");s+=" "+L(this.databaseid);if(this.args&&this.args.length>0){s+="("+this.args.map(function(arg){return arg.toString()}).join(", ")+")"}if(this.as)s+=" "+K("AS")+" "+L(this.as);return s};yy.CreateDatabase.prototype.execute=function(databaseid,params,cb){var args;if(this.args&&this.args.length>0){args=this.args.map(function(arg){return new Function("params,alasql","var y;return "+arg.toJavaScript())(params,alasql)})}if(this.engineid){var res=alasql.engines[this.engineid].createDatabase(this.databaseid,this.args,this.ifnotexists,this.as,cb);return res}else{var dbid=this.databaseid;if(alasql.databases[dbid]){throw new Error("Database '"+dbid+"' already exists")}var a=new alasql.Database(dbid);var res=1;if(cb)return cb(res);return res}};yy.AttachDatabase=function(params){return yy.extend(this,params)};yy.AttachDatabase.prototype.toString=function(){var s=K("ATTACH");if(this.engineid)s+=" "+L(this.engineid);s+=" "+K("DATABASE")+" "+L(this.databaseid);if(args){s+="(";if(args.length>0){s+=args.map(function(arg){return arg.toString()}).join(", ")}s+=")"}if(this.as)s+=" "+K("AS")+" "+L(this.as);return s};yy.AttachDatabase.prototype.execute=function(databaseid,params,cb){if(!alasql.engines[this.engineid]){throw new Error('Engine "'+this.engineid+'" is not defined.')}var res=alasql.engines[this.engineid].attachDatabase(this.databaseid,this.as,this.args,params,cb);return res};yy.DetachDatabase=function(params){return yy.extend(this,params)};yy.DetachDatabase.prototype.toString=function(){var s=K("DETACH");s+=" "+K("DATABASE")+" "+L(this.databaseid);return s};yy.DetachDatabase.prototype.execute=function(databaseid,params,cb){if(!alasql.databases[this.databaseid].engineid){throw new Error('Cannot detach database "'+this.engineid+'", because it was not attached.')}var res;var dbid=this.databaseid;if(dbid==alasql.DEFAULTDATABASEID){throw new Error("Drop of default database is prohibited")}if(!alasql.databases[dbid]){if(!this.ifexists){throw new Error("Database '"+dbid+"' does not exist")}else{res=0}}else{delete alasql.databases[dbid];if(dbid==alasql.useid){alasql.use()}res=1}if(cb)cb(res);return res};yy.UseDatabase=function(params){return yy.extend(this,params)};yy.UseDatabase.prototype.toString=function(){return K("USE")+" "+K("DATABASE")+" "+L(this.databaseid)};yy.UseDatabase.prototype.execute=function(databaseid,params,cb){var dbid=this.databaseid;if(!alasql.databases[dbid]){throw new Error("Database '"+dbid+"' does not exist")}alasql.use(dbid);var res=1;if(cb)cb(res);return res};yy.DropDatabase=function(params){return yy.extend(this,params)};yy.DropDatabase.prototype.toString=function(){var s=K("DROP");if(this.ifexists)s+=" "+K("IF")+" "+K("EXISTS");s+=" "+K("DATABASE")+" "+L(this.databaseid);return s};yy.DropDatabase.prototype.execute=function(databaseid,params,cb){if(this.engineid){return alasql.engines[this.engineid].dropDatabase(this.databaseid,this.ifexists,cb)}var res;var dbid=this.databaseid;if(dbid==alasql.DEFAULTDATABASEID){throw new Error("Drop of default database is prohibited")}if(!alasql.databases[dbid]){if(!this.ifexists){throw new Error("Database '"+dbid+"' does not exist")}else{res=0}}else{if(alasql.databases[dbid].engineid){throw new Error("Cannot drop database '"+dbid+"', because it is attached. Detach it.")}delete alasql.databases[dbid];if(dbid==alasql.useid){alasql.use()}res=1}if(cb)cb(res);return res};yy.Declare=function(params){return yy.extend(this,params)};yy.Declare.prototype.toString=function(){var s=K("DECLARE")+" ";if(this.declares&&this.declares.length>0){s=this.declares.map(function(declare){var s="";s+="@"+L(declare.variable)+" ";s+=declare.dbtypeid;if(this.dbsize)s+="("+N(this.dbsize);if(this.dbprecision)s+=","+N(this.dbprecision);s+=")";if(declare.expression)s+=" = "+declare.expression.toString();return s}).join(",")}return s};yy.Declare.prototype.execute=function(databaseid,params,cb){var res=1;if(this.declares&&this.declares.length>0){this.declares.map(function(declare){var dbtypeid=declare.dbtypeid;if(!alasql.fn[dbtypeid])dbtypeid=dbtypeid.toUpperCase();alasql.declares[declare.variable]={dbtypeid:dbtypeid,dbsize:declare.dbsize,dbprecision:declare.dbprecision};if(declare.expression){alasql.vars[declare.variable]=new Function("params,alasql","return "+declare.expression.toJavaScript("({})","",null))(params,alasql);if(alasql.declares[declare.variable]){alasql.vars[declare.variable]=alasql.stdfn.CONVERT(alasql.vars[declare.variable],alasql.declares[declare.variable])}}})}if(cb)res=cb(res);return res};yy.ShowDatabases=function(params){return yy.extend(this,params)};yy.ShowDatabases.prototype.toString=function(){var s=K("SHOW")+" "+K("DATABASES");if(this.like)s+="LIKE "+this.like.toString();return s};yy.ShowDatabases.prototype.execute=function(databaseid,params,cb){if(this.engineid){return alasql.engines[this.engineid].showDatabases(this.like,cb)}else{var self=this;var res=[];for(dbid in alasql.databases){res.push({databaseid:dbid})}if(self.like&&res&&res.length>0){res=res.filter(function(d){return d.databaseid.match(new RegExp(self.like.value.replace(/\%/g,".*"),"g"))})}if(cb)cb(res);return res}};yy.ShowTables=function(params){return yy.extend(this,params)};yy.ShowTables.prototype.toString=function(){var s=K("SHOW")+" "+K("TABLES");if(this.databaseid)s+=" FROM "+this.databaseid;if(this.like)s+=" "+K("LIKE")+" "+this.like.toString();return s};yy.ShowTables.prototype.execute=function(databaseid,params,cb){var db=alasql.databases[this.databaseid||databaseid];var self=this;var res=[];for(tableid in db.tables){res.push({tableid:tableid})}if(self.like&&res&&res.length>0){res=res.filter(function(d){return d.tableid.match(new RegExp(self.like.value.replace(/\%/g,".*"),"g"))})}if(cb)cb(res);return res};yy.ShowColumns=function(params){return yy.extend(this,params)};yy.ShowColumns.prototype.toString=function(){var s=K("SHOW")+" "+K("COLUMNS");if(this.table.tableid)s+=" "+K("FROM")+" "+this.table.tableid;if(this.databaseid)s+=" "+K("FROM")+" "+this.databaseid;return s};yy.ShowColumns.prototype.execute=function(databaseid){var db=alasql.databases[this.databaseid||databaseid];var table=db.tables[this.table.tableid];var self=this;if(table&&table.columns){var res=table.columns.map(function(col){return{columnid:col.columnid,dbtypeid:col.dbtypeid,dbsize:col.dbsize}});return res}else{return[]}};yy.ShowIndex=function(params){return yy.extend(this,params)};yy.ShowIndex.prototype.toString=function(){var s=K("SHOW")+" "+K("INDEX");if(this.table.tableid)s+=" "+K("FROM")+" "+this.table.tableid;if(this.databaseid)s+=" "+K("FROM")+" "+this.databaseid;return s};yy.ShowIndex.prototype.execute=function(databaseid){var db=alasql.databases[this.databaseid||databaseid];var table=db.tables[this.table.tableid];var self=this;var res=[];if(table&&table.indices){for(var ind in table.indices){res.push({hh:ind,len:Object.keys(table.indices[ind]).length})}}return res};yy.ShowCreateTable=function(params){return yy.extend(this,params)};yy.ShowCreateTable.prototype.toString=function(){var s=K("SHOW")+" "+K("CREATE")+" "+K("TABLE")+" "+L(this.table.tableid);if(this.databaseid)s+=" "+K("FROM")+" "+L(this.databaseid);return s};yy.ShowCreateTable.prototype.execute=function(databaseid){var db=alasql.databases[this.databaseid||databaseid];var table=db.tables[this.table.tableid];var self=this;if(table){var s=K("CREATE")+" "+K("TABLE")+" "+L(this.table.tableid)+" (";var ss=[];if(table.columns){table.columns.forEach(function(col){var a=L(col.columnid)+" "+K(col.dbtypeid);if(col.dbsize)a+="("+N(col.dbsize)+")";if(col.primarykey)a+=" "+K("PRIMARY")+" "+K("KEY");ss.push(a)});s+=ss.join(", ")}s+=")";return s}else{throw new Error('There is no such table "'+this.table.tableid+'"')}};yy.SetVariable=function(params){return yy.extend(this,params)};yy.SetVariable.prototype.toString=function(){var s=K("SET")+" ";if(typeof this.value!="undefined")s+=K(this.variable.toUpperCase())+" "+(this.value?"ON":"OFF");if(this.expression)s+=this.method+L(this.variable)+" = "+this.expression.toString();return s};yy.SetVariable.prototype.execute=function(databaseid,params,cb){if(typeof this.value!="undefined"){var val=this.value;if(val=="ON")val=true;else if(val=="OFF")val=false;alasql.options[this.variable]=val}else if(this.expression){if(this.exists){this.existsfn=this.exists.map(function(ex){var nq=ex.compile(databaseid);if(nq.query&&!nq.query.modifier)nq.query.modifier="RECORDSET";return nq})}if(this.queries){this.queriesfn=this.queries.map(function(q){var nq=q.compile(databaseid);if(nq.query&&!nq.query.modifier)nq.query.modifier="RECORDSET";return nq})}var res=new Function("params,alasql","return "+this.expression.toJavaScript("({})","",null)).bind(this)(params,alasql);if(alasql.declares[this.variable]){res=alasql.stdfn.CONVERT(res,alasql.declares[this.variable])}if(this.props&&this.props.length>0){if(this.method=="@"){var fs="alasql.vars['"+this.variable+"']"}else{var fs="params['"+this.variable+"']"}fs+=this.props.map(function(prop){if(typeof prop=="string"){return"['"+prop+"']"}else if(typeof prop=="number"){return"["+prop+"]"}else{return"["+prop.toJavaScript()+"]"}}).join();new Function("value,params,alasql","var y;"+fs+"=value")(res,params,alasql)}else{if(this.method=="@"){alasql.vars[this.variable]=res}else{params[this.variable]=res}}}var res=1;if(cb)res=cb(res);return res};alasql.test=function(name,times,fn){if(arguments.length==0){alasql.log(alasql.con.results);return}else if(arguments.length==1){var tm=Date.now();fn();alasql.con.log(Date.now()-tm);return}if(arguments.length==2){fn=times;times=1}var tm=Date.now();for(var i=0;i<times;i++)fn();alasql.con.results[name]=Date.now()-tm};alasql.log=function(sql,params){var olduseid=alasql.useid;var target=alasql.options.logtarget;if(typeof exports=="object"){target="console"}var res;if(typeof sql=="string"){res=alasql(sql,params)}else{res=sql}if(target=="console"||typeof exports=="object"){if(typeof sql=="string"&&alasql.options.logprompt)console.log(olduseid+">",sql);if(res instanceof Array){if(console.table){console.table(res)}else{console.log(JSONtoString(res))}}else{console.log(JSONtoString(res))}}else{var el;if(target=="output"){el=document.getElementsByTagName("output")[0]}else{if(typeof target=="string"){el=document.getElementById(target)}else{el=target}}var s="";if(typeof sql=="string"&&alasql.options.logprompt){s+="<pre><code>"+alasql.pretty(sql)+"</code></pre>"}if(res instanceof Array){if(res.length==0){s+="<p>[ ]</p>"}else if(typeof res[0]!="object"||res[0]instanceof Array){for(var i=0,ilen=res.length;i<ilen;i++){s+="<p>"+loghtml(res[i])+"</p>"}}else{s+=loghtml(res)}}else{s+=loghtml(res)}el.innerHTML+=s}};alasql.clear=function(){var target=alasql.options.logtarget;if(typeof exports=="object"){target="console"}if(target=="console"||typeof exports=="object"){if(console.clear){console.clear()}else{}}else{var el;if(target=="output"){el=document.getElementsByTagName("output")[0]}else{if(typeof target=="string"){el=document.getElementById(target)}else{el=target}}el.innerHTML=""}};alasql.write=function(s){var target=alasql.options.logtarget;if(typeof exports=="object"){target="console"}if(target=="console"||typeof exports=="object"){if(console.log){console.log(s)}else{}}else{var el;if(target=="output"){el=document.getElementsByTagName("output")[0]}else{if(typeof target=="string"){el=document.getElementById(target)}else{el=target}}el.innerHTML+=s}};function loghtml(res){var s="";if(typeof res=="undefined"){s+="undefined"}else if(res instanceof Array){s+="<style>";s+="table {border:1px black solid; border-collapse: collapse; border-spacing: 0px;}";s+="td,th {border:1px black solid; padding-left:5px; padding-right:5px}";s+="th {background-color: #EEE}";s+="</style>";s+="<table>";var cols=[];for(colid in res[0]){cols.push(colid)}s+="<tr><th>#";cols.forEach(function(colid){s+="<th>"+colid});for(var i=0,ilen=res.length;i<ilen;i++){s+="<tr><th>"+(i+1);cols.forEach(function(colid){s+="<td> ";if(+res[i][colid]==+res[i][colid]){s+='<div style="text-align:right">';if(typeof res[i][colid]=="undefined")s+="NULL";else s+=res[i][colid];s+="</div>"}else{if(typeof res[i][colid]=="undefined"){s+="NULL"}else if(typeof res[i][colid]=="string"){s+=res[i][colid]}else s+=JSONtoString(res[i][colid])}})}s+="</table>"}else{s+="<p>"+JSONtoString(res)+"</p>"}return s}function scrollTo(element,to,duration){if(duration<=0)return;var difference=to-element.scrollTop;var perTick=difference/duration*10;setTimeout(function(){if(element.scrollTop==to)return;element.scrollTop=element.scrollTop+perTick;scrollTo(element,to,duration-10)},10)}alasql.prompt=function(el,useidel,firstsql){if(typeof exports=="object"){throw new Error("The functionality of prompt is not realized for Node.js")}var prompti=0;if(typeof el=="string")el=document.getElementById(el);if(typeof useidel=="string")useidel=document.getElementById(useidel);useidel.textContent=alasql.useid;if(firstsql){alasql.prompthistory.push(firstsql);prompti=alasql.prompthistory.length;try{var tm=Date.now();alasql.log(firstsql);alasql.write('<p style="color:blue">'+(Date.now()-tm)+" ms</p>")}catch(err){alasql.write("<p>"+olduseid+"&gt;&nbsp;<b>"+sql+"</b></p>");alasql.write('<p style="color:red">'+err+"<p>")}}var y=el.getBoundingClientRect().top+document.getElementsByTagName("body")[0].scrollTop;scrollTo(document.getElementsByTagName("body")[0],y,500);el.onkeydown=function(event){if(event.which==13){var sql=el.value;var olduseid=alasql.useid;el.value="";alasql.prompthistory.push(sql);prompti=alasql.prompthistory.length;try{var tm=Date.now();alasql.log(sql);alasql.write('<p style="color:blue">'+(Date.now()-tm)+" ms</p>")}catch(err){alasql.write("<p>"+olduseid+"&gt;&nbsp;"+alasql.pretty(sql,false)+"</p>");alasql.write('<p style="color:red">'+err+"<p>")}el.focus();useidel.textContent=alasql.useid;var y=el.getBoundingClientRect().top+document.getElementsByTagName("body")[0].scrollTop;scrollTo(document.getElementsByTagName("body")[0],y,500)}else if(event.which==38){prompti--;if(prompti<0)prompti=0;if(alasql.prompthistory[prompti]){el.value=alasql.prompthistory[prompti];event.preventDefault()}}else if(event.which==40){prompti++;if(prompti>=alasql.prompthistory.length){prompti=alasql.prompthistory.length;el.value=""}else if(alasql.prompthistory[prompti]){el.value=alasql.prompthistory[prompti];event.preventDefault()}}}};yy.BeginTransaction=function(params){return yy.extend(this,params)};yy.BeginTransaction.prototype.toString=function(){return K("BEGIN")+" "+K("TRANSACTION")};yy.BeginTransaction.prototype.execute=function(databaseid,params,cb){var res=1;if(alasql.databases[databaseid].engineid){return alasql.engines[alasql.databases[alasql.useid].engineid].begin(databaseid,cb)}else{}if(cb)cb(res);return res};yy.CommitTransaction=function(params){return yy.extend(this,params)};yy.CommitTransaction.prototype.toString=function(){return K("COMMIT")+" "+K("TRANSACTION")};yy.CommitTransaction.prototype.execute=function(databaseid,params,cb){var res=1;if(alasql.databases[databaseid].engineid){return alasql.engines[alasql.databases[alasql.useid].engineid].commit(databaseid,cb)}else{}if(cb)cb(res);return res};yy.RollbackTransaction=function(params){return yy.extend(this,params)};yy.RollbackTransaction.prototype.toString=function(){return K("ROLLBACK")+" "+K("TRANSACTION")};yy.RollbackTransaction.prototype.execute=function(databaseid,params,cb){var res=1;if(alasql.databases[databaseid].engineid){return alasql.engines[alasql.databases[databaseid].engineid].rollback(databaseid,cb)}else{}if(cb)cb(res);return res};if(alasql.options.tsql){alasql.stdfn.OBJECT_ID=function(name,type){if(typeof type=="undefined")type="T";type=type.toUpperCase();var sname=name.split(".");var dbid=alasql.useid;var objname=sname[0];if(sname.length==2){dbid=sname[0];objname=sname[1]}var tables=alasql.databases[dbid].tables;dbid=alasql.databases[dbid].databaseid;for(var tableid in tables){if(tableid==objname){if(tables[tableid].view&&type=="V")return dbid+"."+tableid;if(!tables[tableid].view&&type=="T")return dbid+"."+tableid;return undefined}}return undefined}}if(alasql.options.mysql){}if(alasql.options.mysql||alasql.options.sqlite){alasql.from.INFORMATION_SCHEMA=function(filename,opts,cb,idx,query){if(filename=="VIEWS"||filename=="TABLES"){var res=[];for(var databaseid in alasql.databases){var tables=alasql.databases[databaseid].tables;for(var tableid in tables){if(tables[tableid].view&&filename=="VIEWS"||!tables[tableid].view&&filename=="TABLES"){res.push({TABLE_CATALOG:databaseid,TABLE_NAME:tableid})}}}if(cb)res=cb(res,idx,query);return res}throw new Error("Unknown INFORMATION_SCHEMA table")}}if(alasql.options.postgres){}if(alasql.options.oracle){}if(alasql.options.sqlite){}alasql.into.SQL=function(filename,opts,data,columns,cb){var res;if(typeof filename=="object"){opts=filename;filename=undefined}var opt={};alasql.utils.extend(opt,opts);if(typeof opt.tableid=="undefined"){throw new Error("Table for INSERT TO is not defined.")}var s="";if(columns.length==0){if(typeof data[0]=="object"){columns=Object.keys(data[0]).map(function(columnid){return{columnid:columnid}})}else{}}for(var i=0,ilen=data.length;i<ilen;i++){s+="INSERT INTO "+opts.tableid+"(";s+=columns.map(function(col){return col.columnid}).join(",");s+=") VALUES (";s+=columns.map(function(col){var val=data[i][col.columnid];if(col.typeid){if(col.typeid=="STRING"||col.typeid=="VARCHAR"||col.typeid=="NVARCHAR"||col.typeid=="CHAR"||col.typeid=="NCHAR"){val="'"+escapeqq(val)+"'"}}else{if(typeof val=="string"){val="'"+escapeqq(val)+"'"}}return val});s+=");\n"}res=alasql.utils.saveFile(filename,s);if(cb)res=cb(res);return res};alasql.into.HTML=function(selector,opts,data,columns,cb){var res=1;if(typeof exports!="object"){var opt={};alasql.utils.extend(opt,opts);var sel=document.querySelector(selector);if(!sel){throw new Error("Selected HTML element is not found")}if(columns.length==0){if(typeof data[0]=="object"){columns=Object.keys(data[0]).map(function(columnid){return{columnid:columnid}})}else{}}var tbe=document.createElement("table");var thead=document.createElement("thead");tbe.appendChild(thead);if(opt.headers){var tre=document.createElement("tr");for(var i=0;i<columns.length;i++){var the=document.createElement("th");the.textContent=columns[i].columnid;tre.appendChild(the)}thead.appendChild(tre)}var tbody=document.createElement("tbody");tbe.appendChild(tbody);for(var j=0;j<data.length;j++){var tre=document.createElement("tr");for(var i=0;i<columns.length;i++){var the=document.createElement("td");
        the.textContent=data[j][columns[i].columnid];tre.appendChild(the)}tbody.appendChild(tre)}alasql.utils.domEmptyChildren(sel);sel.appendChild(tbe)}if(cb)res=cb(res);return res};alasql.into.JSON=function(filename,opts,data,columns,cb){var res=1;if(typeof filename=="object"){opts=filename;filename=undefined}var opt={};var s=JSON.stringify(data);res=alasql.utils.saveFile(filename,s);if(cb)res=cb(res);return res};alasql.into.TXT=function(filename,opts,data,columns,cb){if(columns.length==0&&data.length>0){columns=Object.keys(data[0]).map(function(columnid){return{columnid:columnid}})}if(typeof filename=="object"){opts=filename;filename=undefined}var res=data.length;var s="";if(data.length>0){var key=columns[0].columnid;s+=data.map(function(d){return d[key]}).join("\n")}res=alasql.utils.saveFile(filename,s);if(cb)res=cb(res);return res};alasql.into.TAB=alasql.into.TSV=function(filename,opts,data,columns,cb){var opt={};alasql.utils.extend(opt,opts);opt.separator="	";return alasql.into.CSV(filename,opt,data,columns,cb)};alasql.into.CSV=function(filename,opts,data,columns,cb){if(columns.length==0&&data.length>0){columns=Object.keys(data[0]).map(function(columnid){return{columnid:columnid}})}if(typeof filename=="object"){opts=filename;filename=undefined}var opt={};opt.separator=",";opt.quote='"';alasql.utils.extend(opt,opts);var res=data.length;var s="";if(opt.headers){s+=columns.map(function(col){return col.columnid}).join(opt.separator)+"\n"}data.forEach(function(d,idx){s+=columns.map(function(col){var s=d[col.columnid];s=(s+"").replace(new RegExp("\\"+opt.quote,"g"),'""');if((s+"").indexOf(opt.separator)>-1||(s+"").indexOf(opt.quote)>-1)s=opt.quote+s+opt.quote;return s}).join(opt.separator)+"\n"});res=alasql.utils.saveFile(filename,s);if(cb)res=cb(res);return res};alasql.into.XLS=function(filename,opts,data,columns,cb){if(typeof filename=="object"){opts=filename;filename=undefined}var sheets={};if(opts&&opts.sheets){sheets=opts.sheets}var sheet={};if(typeof sheets["Sheet1"]!="undefined"){sheet=sheets[0]}else{if(typeof opts!="undefined"){sheet=opts}}if(typeof sheet.sheetid=="undefined"){sheet.sheetid="Sheet1"}var s=toHTML();var res=alasql.utils.saveFile(filename,s);if(cb)res=cb(res);return res;function toHTML(){var s='<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" 		xmlns="http://www.w3.org/TR/REC-html40"><head> 		<meta charset="utf-8" /> 		<!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets> ';s+=" <x:ExcelWorksheet><x:Name>"+sheet.sheetid+"</x:Name><x:WorksheetOptions><x:DisplayGridlines/>     </x:WorksheetOptions> 		</x:ExcelWorksheet>";s+="</x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head>";s+="<body";if(typeof sheet.style!="undefined"){s+=' style="';if(typeof sheet.style=="function"){s+=sheet.style(sheet)}else{s+=sheet.style}s+='"'}s+=">";s+="<table>";if(typeof sheet.caption!="undefined"){var caption=sheet.caption;if(typeof caption=="string"){caption={title:caption}}s+="<caption";if(typeof caption.style!="undefined"){s+=' style="';if(typeof caption.style=="function"){s+=caption.style(sheet,caption)}else{s+=caption.style}s+='" '}s+=">";s+=caption.title;s+="</caption>"}if(typeof sheet.columns!="undefined"){columns=sheet.columns}else{if(columns.length==0&&data.length>0){if(typeof data[0]=="object"){if(data[0]instanceof Array){columns=data[0].map(function(d,columnidx){return{columnid:columnidx}})}else{columns=Object.keys(data[0]).map(function(columnid){return{columnid:columnid}})}}}}columns.forEach(function(column,columnidx){if(typeof sheet.column!="undefined"){extend(column,sheet.column)}if(typeof column.width=="undefined"){if(sheet.column&&sheet.column.width!="undefined"){column.width=sheet.column.width}else{column.width="120px"}}if(typeof column.width=="number")column.width=column.width+"px";if(typeof column.columnid=="undefined")column.columnid=columnidx;if(typeof column.title=="undefined")column.title=""+column.columnid;if(sheet.headers&&sheet.headers instanceof Array)column.title=sheet.headers[idx]});s+="<colgroups>";columns.forEach(function(column){s+='<col style="width: '+column.width+'"></col>'});s+="</colgroups>";if(sheet.headers){s+="<thead>";s+="<tr>";columns.forEach(function(column,columnidx){s+="<th ";if(typeof column.style!="undefined"){s+=' style="';if(typeof column.style=="function"){s+=column.style(sheet,column,columnidx)}else{s+=column.style}s+='" '}s+=">";if(typeof column.title!="undefined"){if(typeof column.title=="function"){s+=column.title(sheet,column,columnidx)}else{s+=column.title}}s+="</th>"});s+="</tr>";s+="</thead>"}s+="<tbody>";if(data&&data.length>0){data.forEach(function(row,rowidx){if(rowidx>sheet.limit)return;s+="<tr";var srow={};extend(srow,sheet.row);if(sheet.rows&&sheet.rows[rowidx]){extend(srow,sheet.rows[rowidx])}if(typeof srow!="undefined"){if(typeof srow.style!="undefined"){s+=' style="';if(typeof srow.style=="function"){s+=srow.style(sheet,row,rowidx)}else{s+=srow.style}s+='" '}}s+=">";columns.forEach(function(column,columnidx){var cell={};extend(cell,sheet.cell);extend(cell,srow.cell);if(typeof sheet.column!="undefined"){extend(cell,sheet.column.cell)}extend(cell,column.cell);if(sheet.cells&&sheet.cells[rowidx]&&sheet.cells[rowidx][columnidx]){extend(cell,sheet.cells[rowidx][columnidx])}var value=row[column.columnid];if(typeof cell.value=="function"){value=cell.value(value,sheet,row,column,cell,rowidx,columnidx)}var typeid=cell.typeid;if(typeof typeid=="function"){typeid=typeid(value,sheet,row,column,cell,rowidx,columnidx)}if(typeof typeid=="undefined"){if(typeof value=="number")typeid="number";else if(typeof value=="string")typeid="string";else if(typeof value=="boolean")typeid="boolean";else if(typeof value=="object"){if(value instanceof Date)typeid="date"}}var typestyle="";if(typeid=="money"){typestyle='mso-number-format:"\\#\\,\\#\\#0\\\\ _р_\\.";white-space:normal;'}else if(typeid=="number"){typestyle=" "}else if(typeid=="date"){typestyle='mso-number-format:"Short Date";'}else{if(opts.types&&opts.types[typeid]&&opts.types[typeid].typestyle){typestyle=opts.types[typeid].typestyle}}typestyle=typestyle||'mso-number-format:"\\@";';s+="<td style='"+typestyle+"' ";if(typeof cell.style!="undefined"){s+=' style="';if(typeof cell.style=="function"){s+=cell.style(value,sheet,row,column,rowidx,columnidx)}else{s+=cell.style}s+='" '}s+=">";var format=cell.format;if(typeof value=="undefined"){s+=""}else if(typeof format!="undefined"){if(typeof format=="function"){s+=format(value)}else if(typeof format=="string"){s+=value}else{throw new Error("Unknown format type. Should be function or string")}}else{if(typeid=="number"||typeid=="date"){s+=value.toString()}else if(typeid=="money"){s+=(+value).toFixed(2)}else{s+=value}}s+="</td>"});s+="</tr>"})}s+="</tbody>";s+="</table>";s+="</body>";s+="</html>";return s}function style(a){var s=' style="';if(a&&typeof a.style!="undefined"){s+=a.style+";"}s+='" ';return s}};alasql.into.XLSXML=function(filename,opts,data,columns,cb){if(typeof filename=="object"){opts=filename;filename=undefined}var sheets={};if(opts&&opts.sheets){sheets=opts.sheets}else{sheets.Sheet1=opts}var res=alasql.utils.saveFile(filename,toXML());if(cb)res=cb(res);return res;function toXML(){var s1='<?xml version="1.0"?> 		<Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet" 		 xmlns:o="urn:schemas-microsoft-com:office:office" 		 xmlns:x="urn:schemas-microsoft-com:office:excel" 		 xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet" 		 xmlns:html="http://www.w3.org/TR/REC-html40"> 		 <DocumentProperties xmlns="urn:schemas-microsoft-com:office:office"> 		 </DocumentProperties> 		 <OfficeDocumentSettings xmlns="urn:schemas-microsoft-com:office:office"> 		  <AllowPNG/> 		 </OfficeDocumentSettings> 		 <ExcelWorkbook xmlns="urn:schemas-microsoft-com:office:excel"> 		  <ActiveSheet>0</ActiveSheet> 		 </ExcelWorkbook> 		 <Styles> 		  <Style ss:ID="Default" ss:Name="Normal"> 		   <Alignment ss:Vertical="Bottom"/> 		   <Borders/> 		   <Font ss:FontName="Calibri" x:Family="Swiss" ss:Size="12" ss:Color="#000000"/> 		   <Interior/> 		   <NumberFormat/> 		   <Protection/> 		  </Style>';var s2="";var s3=" </Styles>";var styles={};var stylesn=62;function hstyle(st){var s="";for(var key in st){s+="<"+key;for(var attr in st[key]){s+=" ";if(attr.substr(0,2)=="x:"){s+=attr}else{s+="ss:"}s+=attr+'="'+st[key][attr]+'"'}s+="/>"}var hh=hash(s);if(styles[hh]){}else{styles[hh]={styleid:stylesn};s2+='<Style ss:ID="s'+stylesn+'">';s2+=s;s2+="</Style>";stylesn++}return"s"+styles[hh].styleid}for(var sheetid in sheets){var sheet=sheets[sheetid];if(typeof sheet.columns!="undefined"){columns=sheet.columns}else{if(columns.length==0&&data.length>0){if(typeof data[0]=="object"){if(data[0]instanceof Array){columns=data[0].map(function(d,columnidx){return{columnid:columnidx}})}else{columns=Object.keys(data[0]).map(function(columnid){return{columnid:columnid}})}}}}columns.forEach(function(column,columnidx){if(typeof sheet.column!="undefined"){extend(column,sheet.column)}if(typeof column.width=="undefined"){if(sheet.column&&typeof sheet.column.width!="undefined"){column.width=sheet.column.width}else{column.width=120}}if(typeof column.width=="number")column.width=column.width;if(typeof column.columnid=="undefined")column.columnid=columnidx;if(typeof column.title=="undefined")column.title=""+column.columnid;if(sheet.headers&&sheet.headers instanceof Array)column.title=sheet.headers[idx]});s3+='<Worksheet ss:Name="'+sheetid+'"> 	  			<Table ss:ExpandedColumnCount="'+columns.length+'" ss:ExpandedRowCount="'+((sheet.headers?1:0)+Math.min(data.length,sheet.limit||data.length))+'" x:FullColumns="1" 	   			x:FullRows="1" ss:DefaultColumnWidth="65" ss:DefaultRowHeight="15">';columns.forEach(function(column,columnidx){s3+='<Column ss:Index="'+(columnidx+1)+'" ss:AutoFitWidth="0" ss:Width="'+column.width+'"/>'});if(sheet.headers){s3+='<Row ss:AutoFitHeight="0">';columns.forEach(function(column,columnidx){s3+="<Cell ";if(typeof column.style!="undefined"){var st={};if(typeof column.style=="function"){extend(st,column.style(sheet,column,columnidx))}else{extend(st,column.style)}s3+='ss:StyleID="'+hstyle(st)+'"'}s3+='><Data ss:Type="String">';if(typeof column.title!="undefined"){if(typeof column.title=="function"){s3+=column.title(sheet,column,columnidx)}else{s3+=column.title}}s3+="</Data></Cell>"});s3+="</Row>"}if(data&&data.length>0){data.forEach(function(row,rowidx){if(rowidx>sheet.limit)return;var srow={};extend(srow,sheet.row);if(sheet.rows&&sheet.rows[rowidx]){extend(srow,sheet.rows[rowidx])}s3+="<Row ";if(typeof srow!="undefined"){var st={};if(typeof srow.style!="undefined"){if(typeof srow.style=="function"){extend(st,srow.style(sheet,row,rowidx))}else{extend(st,srow.style)}s3+='ss:StyleID="'+hstyle(st)+'"'}}s3+=">";columns.forEach(function(column,columnidx){var cell={};extend(cell,sheet.cell);extend(cell,srow.cell);if(typeof sheet.column!="undefined"){extend(cell,sheet.column.cell)}extend(cell,column.cell);if(sheet.cells&&sheet.cells[rowidx]&&sheet.cells[rowidx][columnidx]){extend(cell,sheet.cells[rowidx][columnidx])}var value=row[column.columnid];if(typeof cell.value=="function"){value=cell.value(value,sheet,row,column,cell,rowidx,columnidx)}var typeid=cell.typeid;if(typeof typeid=="function"){typeid=typeid(value,sheet,row,column,cell,rowidx,columnidx)}if(typeof typeid=="undefined"){if(typeof value=="number")typeid="number";else if(typeof value=="string")typeid="string";else if(typeof value=="boolean")typeid="boolean";else if(typeof value=="object"){if(value instanceof Date)typeid="date"}}var Type="String";if(typeid=="number")Type="Number";else if(typeid=="date")Type="Date";var typestyle="";if(typeid=="money"){typestyle='mso-number-format:"\\#\\,\\#\\#0\\\\ _р_\\.";white-space:normal;'}else if(typeid=="number"){typestyle=" "}else if(typeid=="date"){typestyle='mso-number-format:"Short Date";'}else{if(opts.types&&opts.types[typeid]&&opts.types[typeid].typestyle){typestyle=opts.types[typeid].typestyle}}typestyle=typestyle||'mso-number-format:"\\@";';s3+="<Cell ";if(false){s+="<td style='"+typestyle+"' "}var st={};if(typeof cell.style!="undefined"){if(typeof cell.style=="function"){extend(st,cell.style(value,sheet,row,column,rowidx,columnidx))}else{extend(st,cell.style)}s3+='ss:StyleID="'+hstyle(st)+'"'}s3+=">";s3+='<Data ss:Type="'+Type+'">';var format=cell.format;if(typeof value=="undefined"){s3+=""}else if(typeof format!="undefined"){if(typeof format=="function"){s3+=format(value)}else if(typeof format=="string"){s3+=value}else{throw new Error("Unknown format type. Should be function or string")}}else{if(typeid=="number"||typeid=="date"){s3+=value.toString()}else if(typeid=="money"){s3+=(+value).toFixed(2)}else{s3+=value}}s3+="</Data></Cell>"});s3+="</Row>"})}s3+="</Table></Worksheet>"}s3+="</Workbook>";return s1+s2+s3}};alasql.into.XLSX=function(filename,opts,data,columns,cb){var res=1;if(deepEqual(columns,[{columnid:"_"}])){data=data.map(function(dat){return dat._});columns=undefined}else{}if(typeof exports=="object"){var XLSX=require("xlsx")}else{var XLSX=window.XLSX}if(typeof filename=="object"){opts=filename;filename=undefined}var wb={SheetNames:[],Sheets:{}};if(opts.sourcefilename){alasql.utils.loadBinaryFile(opts.sourcefilename,!!cb,function(data){wb=XLSX.read(data,{type:"binary"});doExport()})}else{doExport()}if(cb)res=cb(res);return res;function doExport(){if(typeof opts=="object"&&opts instanceof Array){if(data&&data.length>0){data.forEach(function(dat,idx){prepareSheet(opts[idx],dat,undefined,idx+1)})}}else{prepareSheet(opts,data,columns,{},1)}saveWorkbook(cb)}function prepareSheet(opts,data,columns,idx){var opt={sheetid:"Sheet"+idx,headers:true};alasql.utils.extend(opt,opts);if((!columns||columns.length==0)&&data.length>0){columns=Object.keys(data[0]).map(function(columnid){return{columnid:columnid}})}var cells={};if(wb.SheetNames.indexOf(opt.sheetid)>-1){cells=wb.Sheets[opt.sheetid]}else{wb.SheetNames.push(opt.sheetid);wb.Sheets[opt.sheetid]={};cells=wb.Sheets[opt.sheetid]}var range="A1";if(opt.range)range=opt.range;var col0=alasql.utils.xlscn(range.match(/[A-Z]+/)[0]);var row0=+range.match(/[0-9]+/)[0]-1;if(wb.Sheets[opt.sheetid]["!ref"]){var rangem=wb.Sheets[opt.sheetid]["!ref"];var colm=alasql.utils.xlscn(rangem.match(/[A-Z]+/)[0]);var rowm=+rangem.match(/[0-9]+/)[0]-1}else{var colm=1,rowm=1}var colmax=Math.max(col0+columns.length,colm);var rowmax=Math.max(row0+data.length+2,rowm);var i=row0+1;wb.Sheets[opt.sheetid]["!ref"]="A1:"+alasql.utils.xlsnc(colmax)+rowmax;if(opt.headers){columns.forEach(function(col,idx){cells[alasql.utils.xlsnc(col0+idx)+""+i]={v:col.columnid}});i++}for(var j=0;j<data.length;j++){columns.forEach(function(col,idx){var cell={v:data[j][col.columnid]};if(typeof data[j][col.columnid]=="number"){cell.t="n"}else if(typeof data[j][col.columnid]=="string"){cell.t="s"}else if(typeof data[j][col.columnid]=="boolean"){cell.t="b"}else if(typeof data[j][col.columnid]=="object"){if(data[j][col.columnid]instanceof Date){cell.t="d"}}cells[alasql.utils.xlsnc(col0+idx)+""+i]=cell});i++}}function saveWorkbook(cb){if(typeof filename=="undefined"){res=wb}else{if(typeof exports=="object"){XLSX.writeFile(wb,filename)}else{var wopts={bookType:"xlsx",bookSST:false,type:"binary"};var wbout=XLSX.write(wb,wopts);function s2ab(s){var buf=new ArrayBuffer(s.length);var view=new Uint8Array(buf);for(var i=0;i!=s.length;++i)view[i]=s.charCodeAt(i)&255;return buf}if(isIE()==9){throw new Error("Cannot save XLSX files in IE9. Please use XLS() export function")}else{saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}),filename)}}}}};alasql.ZipWriter=function(){var entries=[];function calculateCrc32(buf){var CRC_TABLE=[0,1996959894,3993919788,2567524794,124634137,1886057615,3915621685,2657392035,249268274,2044508324,3772115230,2547177864,162941995,2125561021,3887607047,2428444049,498536548,1789927666,4089016648,2227061214,450548861,1843258603,4107580753,2211677639,325883990,1684777152,4251122042,2321926636,335633487,1661365465,4195302755,2366115317,997073096,1281953886,3579855332,2724688242,1006888145,1258607687,3524101629,2768942443,901097722,1119000684,3686517206,2898065728,853044451,1172266101,3705015759,2882616665,651767980,1373503546,3369554304,3218104598,565507253,1454621731,3485111705,3099436303,671266974,1594198024,3322730930,2970347812,795835527,1483230225,3244367275,3060149565,1994146192,31158534,2563907772,4023717930,1907459465,112637215,2680153253,3904427059,2013776290,251722036,2517215374,3775830040,2137656763,141376813,2439277719,3865271297,1802195444,476864866,2238001368,4066508878,1812370925,453092731,2181625025,4111451223,1706088902,314042704,2344532202,4240017532,1658658271,366619977,2362670323,4224994405,1303535960,984961486,2747007092,3569037538,1256170817,1037604311,2765210733,3554079995,1131014506,879679996,2909243462,3663771856,1141124467,855842277,2852801631,3708648649,1342533948,654459306,3188396048,3373015174,1466479909,544179635,3110523913,3462522015,1591671054,702138776,2966460450,3352799412,1504918807,783551873,3082640443,3233442989,3988292384,2596254646,62317068,1957810842,3939845945,2647816111,81470997,1943803523,3814918930,2489596804,225274430,2053790376,3826175755,2466906013,167816743,2097651377,4027552580,2265490386,503444072,1762050814,4150417245,2154129355,426522225,1852507879,4275313526,2312317920,282753626,1742555852,4189708143,2394877945,397917763,1622183637,3604390888,2714866558,953729732,1340076626,3518719985,2797360999,1068828381,1219638859,3624741850,2936675148,906185462,1090812512,3747672003,2825379669,829329135,1181335161,3412177804,3160834842,628085408,1382605366,3423369109,3138078467,570562233,1426400815,3317316542,2998733608,733239954,1555261956,3268935591,3050360625,752459403,1541320221,2607071920,3965973030,1969922972,40735498,2617837225,3943577151,1913087877,83908371,2512341634,3803740692,2075208622,213261112,2463272603,3855990285,2094854071,198958881,2262029012,4057260610,1759359992,534414190,2176718541,4139329115,1873836001,414664567,2282248934,4279200368,1711684554,285281116,2405801727,4167216745,1634467795,376229701,2685067896,3608007406,1308918612,956543938,2808555105,3495958263,1231636301,1047427035,2932959818,3654703836,1088359270,936918e3,2847714899,3736837829,1202900863,817233897,3183342108,3401237130,1404277552,615818150,3134207493,3453421203,1423857449,601450431,3009837614,3294710456,1567103746,711928724,3020668471,3272380065,1510334235,755167117];var crc=~0;for(var ix=0;ix<buf.length;ix++){var offset=(crc^buf[ix])&255;crc=crc>>>8^CRC_TABLE[offset]}return crc^-1}function pack(items){var data=arguments,idx=0,buffer,bufferSize=0;items=items.split("");items.forEach(function(type){if(type=="v"){bufferSize+=2}else if(type=="V"||type=="l"){bufferSize+=4}});buffer=new Buffer(bufferSize);items.forEach(function(type,index){if(type=="v"){buffer.writeUInt16LE(data[index+1],idx);idx+=2}else if(type=="V"){buffer.writeUInt32LE(data[index+1],idx);idx+=4}else if(type=="l"){buffer.writeInt32LE(data[index+1],idx);idx+=4}});return buffer}function normalizeZipPath(zipPath){return zipPath.replace(/\\/g,"/").replace(/^\/|\/$/g,"")}this.addEntry=function(entry){entry.path=normalizeZipPath(entry.path);entries.push(entry)};this.addDir=function(zipPath,localPath){this.addEntry({path:zipPath,file:localPath,isFile:false})};this.addData=function(zipPath,data){if(!Buffer.isBuffer(data)){data=new Buffer(data)}this.addEntry({path:zipPath,data:data})};function buildZipBuffer(){var buffers=[];var length=0;function append(buf){if(typeof buf=="string"){buf=new Buffer(buf)}buffers.push(buf);length+=buf.length}entries.forEach(function(entry){var mtime,mdate;entry.extra=entry.extra||"";entry.comment=entry.comment||"";entry.cmethod=0;mtime=entry.mtime;mdate=entry.mdate;if(entry.mtime instanceof Date){mtime=entry.mtime.getHours();mtime=mtime<<6;mtime=mtime|entry.mtime.getMinutes();mtime=mtime<<5;mtime=mtime|entry.mtime.getSeconds()/2;mdate=entry.mtime.getFullYear()-1980;mdate=mdate<<4;mdate=mdate|entry.mtime.getMonth()+1;mdate=mdate<<5;mdate=mdate|entry.mtime.getDate()}var fileName=entry.path;if(!entry.isFile&&fileName.charAt(fileName.length-1)!="/"){entry.path=fileName=fileName+"/"}entry.offset=length;append(pack("VvvvvvlVVvv",67324752,20,2,entry.cmethod,mtime,mdate,entry.crc32,entry.csize,entry.size,fileName.length,entry.extra.length));append(fileName);append(entry.extra);append(entry.data);entry.mtime=mtime;entry.mdate=mdate;entry.eattr=entry.isFile?32:48});var startOffset=length;var centralDirSize=0;entries.forEach(function(entry){append(pack("VvvvvvvlVVvvvvvVV",33639248,20,20,2,entry.cmethod,entry.mtime,entry.mdate,entry.crc32,entry.csize,entry.size,entry.path.length,entry.extra.length,entry.comment.length,0,0,entry.eattr,entry.offset));append(entry.path);append(entry.extra);append(entry.comment);centralDirSize+=46+entry.path.length+entry.extra.length+entry.comment.length});var comment="";append(pack("VvvvvVVv",101010256,0,0,entries.length,entries.length,centralDirSize,startOffset,comment.length));append(comment);var buffer=Buffer.concat(buffers);return buffer}this.toBuffer=function(callback){var index=-1;function deflateNext(){var data;var entry=entries[++index];if(entry){entry.csize=entry.size=entry.crc32=0;data=entry.data=entry.data?entry.data:new Buffer(0);entry.mtime=new Date;if(entry.isFile!==false){entry.crc32=calculateCrc32(data);entry.isFile=true;entry.size=data.length;entry.csize=entry.size;deflateNext()}else{deflateNext()}}else{callback(buildZipBuffer())}}deflateNext()}};alasql.from.METEOR=function(filename,opts,cb,idx,query){var res=filename.find(opts).fetch();if(cb)res=cb(res,idx,query);return res};alasql.from.TABLETOP=function(key,opts,cb,idx,query){var res=[];var opt={headers:true,simpleSheet:true,key:key};alasql.utils.extend(opt,opts);opt.callback=function(data){res=data;if(cb)res=cb(res,idx,query)};Tabletop.init(opt);return res};alasql.from.HTML=function(selector,opts,cb,idx,query){var opt={};alasql.utils.extend(opt,opts);var sel=document.querySelector(selector);if(!sel&&sel.tagName!="TABLE"){throw new Error("Selected HTML element is not a TABLE")}var res=[];var headers=opt.headers;if(headers&&!(headers instanceof Array)){headers=[];var ths=sel.querySelector("thead tr").children;for(var i=0;i<ths.length;i++){if(!(ths.item(i).style&&ths.item(i).style.display=="none"&&opt.skipdisplaynone)){headers.push(ths.item(i).textContent)}else{headers.push(undefined)}}}var trs=sel.querySelectorAll("tbody tr");for(var j=0;j<trs.length;j++){var tds=trs.item(j).children;var r={};for(var i=0;i<tds.length;i++){if(!(tds.item(i).style&&tds.item(i).style.display=="none"&&opt.skipdisplaynone)){if(headers){r[headers[i]]=tds.item(i).textContent}else{r[i]=tds.item(i).textContent}}}res.push(r)}if(cb)res=cb(res,idx,query);return res};alasql.from.RANGE=function(start,finish,cb,idx,query){var res=[];for(i=start;i<=finish;i++)res.push(i);if(cb)res=cb(res,idx,query);return res};alasql.from.FILE=function(filename,opts,cb,idx,query){if(typeof filename=="string"){fname=filename}else if(filename instanceof Event){fname=filename.target.files[0].name}else{throw new Error("Wrong usage of FILE() function")}var parts=fname.split(".");var ext=parts[parts.length-1].toUpperCase();if(alasql.from[ext]){return alasql.from[ext](filename,opts,cb,idx,query)}else{throw new Error("Cannot recognize file type for loading")}};alasql.from.JSON=function(filename,opts,cb,idx,query){var res;alasql.utils.loadFile(filename,!!cb,function(data){res=JSON.parse(data);if(cb)res=cb(res,idx,query)});return res};alasql.from.TXT=function(filename,opts,cb,idx,query){var res;alasql.utils.loadFile(filename,!!cb,function(data){res=data.split(/\r?\n/);for(var i=0,ilen=res.length;i<ilen;i++){if(res[i]==+res[i])res[i]=+res[i];res[i]=[res[i]]}if(cb)res=cb(res,idx,query)});return res};alasql.from.TAB=alasql.from.TSV=function(filename,opts,cb,idx,query){if(!opts)opts={};opts.separator="	";return alasql.from.CSV(filename,opts,cb,idx,query)};alasql.from.CSV=function(filename,opts,cb,idx,query){var opt={separator:",",quote:'"'};alasql.utils.extend(opt,opts);var res;alasql.utils.loadFile(filename,!!cb,function(text){var delimiterCode=opt.separator.charCodeAt(0);var quoteCode=opt.quote.charCodeAt(0);var EOL={},EOF={},rows=[],N=text.length,I=0,n=0,t,eol;function token(){if(I>=N)return EOF;if(eol)return eol=false,EOL;var j=I;if(text.charCodeAt(j)===quoteCode){var i=j;while(i++<N){if(text.charCodeAt(i)===quoteCode){if(text.charCodeAt(i+1)!==quoteCode)break;++i}}I=i+2;var c=text.charCodeAt(i+1);if(c===13){eol=true;if(text.charCodeAt(i+2)===10)++I}else if(c===10){eol=true}return text.substring(j+1,i).replace(/""/g,'"')}while(I<N){var c=text.charCodeAt(I++),k=1;if(c===10)eol=true;else if(c===13){eol=true;if(text.charCodeAt(I)===10)++I,++k}else if(c!==delimiterCode)continue;return text.substring(j,I-k)}return text.substring(j)}while((t=token())!==EOF){var a=[];while(t!==EOL&&t!==EOF){a.push(t);t=token()}if(opt.headers){if(n==0){if(typeof opt.headers=="boolean"){hs=a}else if(opt.headers instanceof Array){hs=opt.headers;var r={};hs.forEach(function(h,idx){r[h]=a[idx];if(typeof r[h]!="undefined"&&r[h].trim()==+r[h])r[h]=+r[h]});rows.push(r)}}else{var r={};hs.forEach(function(h,idx){r[h]=a[idx];if(typeof r[h]!="undefined"&&r[h].trim()==+r[h])r[h]=+r[h]});rows.push(r)}n++}else{rows.push(a)}}res=rows;if(opt.headers){if(query&&query.sources&&query.sources[idx]){var columns=query.sources[idx].columns=[];hs.forEach(function(h){columns.push({columnid:h})})}}if(cb)res=cb(res,idx,query)});return res};alasql.from.XLS=function(filename,opts,cb,idx,query){if(typeof exports==="object"){var X=require("xlsjs")}else{var X=window.XLS;if(!X){throw new Error("XLS library is not attached")}}return XLSXLSX(X,filename,opts,cb,idx,query)};alasql.from.XLSX=function(filename,opts,cb,idx,query){if(typeof exports==="object"){var X=require("xlsx")}else{var X=window.XLSX;if(!X){throw new Error("XLSX library is not attached")}}return XLSXLSX(X,filename,opts,cb,idx,query)};function XLSXLSX(X,filename,opts,cb,idx,query){var opt={};if(!opts)opts={};alasql.utils.extend(opt,opts);var res;alasql.utils.loadBinaryFile(filename,!!cb,function(data){var workbook=X.read(data,{type:"binary"});var sheetid;if(typeof opt.sheetid=="undefined"){sheetid=workbook.SheetNames[0]}else{sheetid=opt.sheetid}var range;if(typeof opt.range=="undefined"){range=workbook.Sheets[sheetid]["!ref"]}else{range=opt.range;if(workbook.Sheets[sheetid][range])range=workbook.Sheets[sheetid][range]}var rg=range.split(":");var col0=rg[0].match(/[A-Z]+/)[0];var row0=+rg[0].match(/[0-9]+/)[0];var col1=rg[1].match(/[A-Z]+/)[0];var row1=+rg[1].match(/[0-9]+/)[0];var hh={};for(var j=alasql.utils.xlscn(col0);j<=alasql.utils.xlscn(col1);j++){var col=alasql.utils.xlsnc(j);if(opt.headers){if(workbook.Sheets[sheetid][col+""+row0]){hh[col]=workbook.Sheets[sheetid][col+""+row0].v}else{hh[col]=col}}else{hh[col]=col}}var res=[];if(opt.headers)row0++;for(var i=row0;i<=row1;i++){var row={};for(var j=alasql.utils.xlscn(col0);j<=alasql.utils.xlscn(col1);j++){var col=alasql.utils.xlsnc(j);if(workbook.Sheets[sheetid][col+""+i]){row[hh[col]]=workbook.Sheets[sheetid][col+""+i].v}}res.push(row)}if(cb)res=cb(res,idx,query)},function(err){throw err});return res}alasql.from.XML=function(filename,opts,cb,idx,query){var res;alasql.utils.loadFile(filename,!!cb,function(data){res=xmlparse(data).root;if(cb)res=cb(res,idx,query)});return res};function xmlparse(xml){xml=xml.trim();xml=xml.replace(/<!--[\s\S]*?-->/g,"");return document();function document(){return{declaration:declaration(),root:tag()}}function declaration(){var m=match(/^<\?xml\s*/);if(!m)return;var node={attributes:{}};while(!(eos()||is("?>"))){var attr=attribute();if(!attr)return node;node.attributes[attr.name]=attr.value}match(/\?>\s*/);return node}function tag(){var m=match(/^<([\w-:.]+)\s*/);if(!m)return;var node={name:m[1],attributes:{},children:[]};while(!(eos()||is(">")||is("?>")||is("/>"))){var attr=attribute();if(!attr)return node;node.attributes[attr.name]=attr.value}if(match(/^\s*\/>\s*/)){return node}match(/\??>\s*/);node.content=content();var child;while(child=tag()){node.children.push(child)}match(/^<\/[\w-:.]+>\s*/);return node}function content(){var m=match(/^([^<]*)/);if(m)return m[1];return""}function attribute(){var m=match(/([\w:-]+)\s*=\s*("[^"]*"|'[^']*'|\w+)\s*/);if(!m)return;return{name:m[1],value:strip(m[2])}}function strip(val){return val.replace(/^['"]|['"]$/g,"")}function match(re){var m=xml.match(re);if(!m)return;xml=xml.slice(m[0].length);return m}function eos(){return 0==xml.length}function is(prefix){return 0==xml.indexOf(prefix)}}alasql.from.GEXF=function(filename,opts,cb,idx,query){var res;alasql("SEARCH FROM XML("+filename+")",[],function(data){res=data;console.log(res);if(cb)res=cb(res)});return res};yy.Help=function(params){return yy.extend(this,params)};yy.Help.prototype.toString=function(){var s=K("HELP");if(this.subject)s+=" "+L(this.subject);return s};helpdocs=[{command:"ALTER TABLE table RENAME TO table"},{command:"ALTER TABLE table ADD COLUMN column coldef"},{command:"ALTER TABLE table MODIFY COLUMN column coldef"},{command:"ALTER TABLE table RENAME COLUMN column TO column"},{command:"ALTER TABLE table DROP column"},{command:"ATTACH engine DATABASE database"},{command:"ASSERT value"},{command:"BEGIN [TRANSACTION]"},{command:"COMMIT [TRANSACTION]"},{command:"CREATE [engine] DATABASE [IF NOT EXISTS] database"},{command:"CREATE TABLE [IF NOT EXISTS] table (column definitions)"},{command:"DELETE FROM table [WHERE expression]"},{command:"DETACH DATABASE database"},{command:"DROP [engine] DATABASE [IF EXISTS] database"},{command:"DROP TABLE [IF EXISTS] table"},{command:"INSERT INTO table VALUES value,..."},{command:"INSERT INTO table DEFAULT VALUES"},{command:"INSERT INTO table SELECT select"},{command:"HELP [subject]"},{command:"ROLLBACK [TRANSACTION]"},{command:"SELECT [modificator] columns [INTO table] [FROM table,...] [[mode] JOIN [ON] [USING]] [WHERE ] [GROUP BY] [HAVING] [ORDER BY] "},{command:"SET option value"},{command:"SHOW [engine] DATABASES"},{command:"SHOW TABLES"},{command:"SHOW CREATE TABLE table"},{command:"UPDATE table SET column1 = expression1, ... [WHERE expression]"},{command:"USE [DATABASE] database"},{command:"expression"},{command:'See also <a href="http://github/agershun/alasq">http://github/agershun/alasq</a> for more information'}];yy.Help.prototype.execute=function(databaseid,params,cb){var ss=[];if(!this.subject){ss=helpdocs}else{ss.push('See also <a href="http://github/agershun/alasq">http://github/agershun/alasq</a> for more information')}if(cb)ss=cb(ss);return ss};yy.Print=function(params){return yy.extend(this,params)};yy.Print.prototype.toString=function(){var s=K("PRINT");if(this.statement)s+=" "+this.statement.toString();return s};yy.Print.prototype.execute=function(databaseid,params,cb){var self=this;var res=1;alasql.precompile(this,databaseid,params);if(this.exprs&&this.exprs.length>0){var rs=this.exprs.map(function(expr){var exprfn=new Function("params,alasql,p","var y;return "+expr.toJavaScript("({})","",null)).bind(self);var r=exprfn(params,alasql);return JSONtoString(r)});console.log.apply(console,rs)}else if(this.select){var r=this.select.execute(databaseid,params);console.log(JSONtoString(r))}else{console.log()}if(cb)res=cb(res);return res};yy.Source=function(params){return yy.extend(this,params)};yy.Source.prototype.toString=function(){var s=K("SOURCE");if(this.url)s+=" "+S("'"+this.url+"'");return s};yy.Source.prototype.execute=function(databaseid,params,cb){var res;loadFile(this.url,!!cb,function(data){res=alasql(data);if(cb)res=cb(res);return res},function(err){throw err});return res};yy.Require=function(params){return yy.extend(this,params)};yy.Require.prototype.toString=function(){var s=K("REQUIRE");if(this.paths&&this.paths.length>0){s+=this.paths.map(function(path){return path.toString()}).join(",")}if(this.plugins&&this.plugins.length>0){s+=this.plugins.map(function(plugin){return plugin.toUpperCase()
    }).join(",")}return s};yy.Require.prototype.execute=function(databaseid,params,cb){var self=this;var res=0;var ss="";if(this.paths&&this.paths.length>0){this.paths.forEach(function(path){loadFile(path.value,!!cb,function(data){res++;ss+=data;if(res<self.paths.length)return;new Function("params,alasql",ss)(params,alasql);if(cb)res=cb(res)})})}else if(this.plugins&&this.plugins.length>0){this.plugins.forEach(function(plugin){if(!alasql.plugins[plugin]){loadFile(alasql.path+"/alasql-"+plugin.toLowerCase()+".js",!!cb,function(data){res++;ss+=data;if(res<self.plugins.length)return;new Function("params,alasql",ss)(params,alasql);alasql.plugins[plugin]=true;if(cb)res=cb(res)})}})}else{if(cb)res=cb(res)}return res};yy.Assert=function(params){return yy.extend(this,params)};yy.Source.prototype.toString=function(){var s=K("ASSERT");if(this.value)s+=" "+JSON.stringify(this.value);return s};yy.Assert.prototype.execute=function(databaseid){if(!deepEqual(alasql.res,this.value)){throw new Error((this.message||"Assert wrong")+": "+JSON.stringify(alasql.res)+" == "+JSON.stringify(this.value))}return 1};var WEBSQL=alasql.engines.WEBSQL=function(){};WEBSQL.createDatabase=function(wdbid,args,dbid,cb){var res=1;var wdb=openDatabase(wdbid,args[0],args[1],args[2]);if(this.dbid){var db=alasql.createDatabase(this.dbid);db.engineid="WEBSQL";db.wdbid=wdbid;sb.wdb=db}if(!wdb){throw new Error('Cannot create WebSQL database "'+databaseid+'"')}if(cb)cb(res);return res};WEBSQL.dropDatabase=function(databaseid){throw new Error("This is impossible to drop WebSQL database.")};WEBSQL.attachDatabase=function(databaseid,dbid,args,params,cb){var res=1;if(alasql.databases[dbid]){throw new Error('Unable to attach database as "'+dbid+'" because it already exists')}alasqlopenDatabase(databaseid,args[0],args[1],args[2]);return res};if(typeof window!="undefined"&&typeof window.indexedDB!="undefined"){var IDB=alasql.engines.INDEXEDDB=function(){};if(typeof window.indexedDB.webkitGetDatabaseNames=="function"){IDB.getDatabaseNames=window.indexedDB.webkitGetDatabaseNames.bind(window.indexedDB)}else{IDB.getDatabaseNames=function(){var request={};var result={contains:function(name){return true},notsupported:true};setTimeout(function(){var event={target:{result:result}};request.onsuccess(event)},0);return request};IDB.getDatabaseNamesNotSupported=true}IDB.showDatabases=function(like,cb){var request=IDB.getDatabaseNames();request.onsuccess=function(event){var dblist=event.target.result;if(IDB.getDatabaseNamesNotSupported){throw new Error("SHOW DATABASE is not supported in this browser")}var res=[];if(like){var relike=new RegExp(like.value.replace(/\%/g,".*"),"g")}for(var i=0;i<dblist.length;i++){if(!like||dblist[i].match(relike)){res.push({databaseid:dblist[i]})}}cb(res)}};IDB.createDatabase=function(ixdbid,args,ifnotexists,dbid,cb){console.log(arguments);if(ifnotexists){var request2=window.indexedDB.open(ixdbid,1);request2.onsuccess=function(event){event.target.result.close();cb(1)}}else{var request1=window.indexedDB.open(ixdbid,1);request1.onupgradeneeded=function(e){console.log("abort");e.target.transaction.abort()};request1.onsuccess=function(e){console.log("success");if(ifnotexists){cb(0)}else{throw new Error('IndexedDB: Cannot create new database "'+ixdbid+'" because it already exists')}}}};IDB.createDatabase=function(ixdbid,args,ifnotexists,dbid,cb){if(IDB.getDatabaseNamesNotSupported){if(ifnotexists){var dbExists=true;var request2=window.indexedDB.open(ixdbid);request2.onupgradeneeded=function(e){dbExists=false};request2.onsuccess=function(event){event.target.result.close();if(dbExists){cb(0)}else{cb(1)}}}else{var request1=window.indexedDB.open(ixdbid);request1.onupgradeneeded=function(e){e.target.transaction.abort()};request1.onabort=function(event){cb(1)};request1.onsuccess=function(event){event.target.result.close();throw new Error('IndexedDB: Cannot create new database "'+ixdbid+'" because it already exists')}}}else{var request1=IDB.getDatabaseNames();request1.onsuccess=function(event){var dblist=event.target.result;if(dblist.contains(ixdbid)){if(ifnotexists){cb(0);return}else{throw new Error('IndexedDB: Cannot create new database "'+ixdbid+'" because it already exists')}}var request2=window.indexedDB.open(ixdbid,1);request2.onsuccess=function(event){event.target.result.close();cb(1)}}}};IDB.dropDatabase=function(ixdbid,ifexists,cb){var request1=IDB.getDatabaseNames();request1.onsuccess=function(event){var dblist=event.target.result;if(!dblist.contains(ixdbid)){if(ifexists){cb(0);return}else{throw new Error('IndexedDB: Cannot drop new database "'+ixdbid+'" because it does not exist')}}var request2=window.indexedDB.deleteDatabase(ixdbid);request2.onsuccess=function(event){if(cb)cb(1)}}};IDB.attachDatabase=function(ixdbid,dbid,args,params,cb){var request1=IDB.getDatabaseNames();request1.onsuccess=function(event){var dblist=event.target.result;if(!dblist.contains(ixdbid)){throw new Error('IndexedDB: Cannot attach database "'+ixdbid+'" because it does not exist')}var request2=window.indexedDB.open(ixdbid);request2.onsuccess=function(event){var ixdb=event.target.result;var db=new alasql.Database(dbid||ixdbid);db.engineid="INDEXEDDB";db.ixdbid=ixdbid;db.tables=[];var tblist=ixdb.objectStoreNames;for(var i=0;i<tblist.length;i++){db.tables[tblist[i]]={}}event.target.result.close();cb(1)}}};IDB.createTable=function(databaseid,tableid,ifnotexists,cb){var ixdbid=alasql.databases[databaseid].ixdbid;var request1=IDB.getDatabaseNames();request1.onsuccess=function(event){var dblist=event.target.result;if(!dblist.contains(ixdbid)){throw new Error('IndexedDB: Cannot create table in database "'+ixdbid+'" because it does not exist')}var request2=window.indexedDB.open(ixdbid);request2.onversionchange=function(event){event.target.result.close()};request2.onsuccess=function(event){var version=event.target.result.version;event.target.result.close();var request3=window.indexedDB.open(ixdbid,version+1);request3.onupgradeneeded=function(event){var ixdb=event.target.result;var store=ixdb.createObjectStore(tableid,{autoIncrement:true})};request3.onsuccess=function(event){event.target.result.close();cb(1)};request3.onerror=function(event){throw event};request3.onblocked=function(event){throw new Error('Cannot create table "'+tableid+'" because database "'+databaseid+'"  is blocked')}}}};IDB.dropTable=function(databaseid,tableid,ifexists,cb){var ixdbid=alasql.databases[databaseid].ixdbid;var request1=IDB.getDatabaseNames();request1.onsuccess=function(event){var dblist=event.target.result;if(!dblist.contains(ixdbid)){throw new Error('IndexedDB: Cannot drop table in database "'+ixdbid+'" because it does not exist')}var request2=window.indexedDB.open(ixdbid);request2.onversionchange=function(event){event.target.result.close()};request2.onsuccess=function(event){var version=event.target.result.version;event.target.result.close();var request3=window.indexedDB.open(ixdbid,version+1);request3.onupgradeneeded=function(event){var ixdb=event.target.result;if(ixdb.objectStoreNames.contains(tableid)){ixdb.deleteObjectStore(tableid);delete alasql.databases[databaseid].tables[tableid]}else{if(!ifexists){throw new Error('IndexedDB: Cannot drop table "'+tableid+'" because it is not exist')}}};request3.onsuccess=function(event){event.target.result.close();cb(1)};request3.onerror=function(event){throw event};request3.onblocked=function(event){throw new Error('Cannot drop table "'+tableid+'" because database "'+databaseid+'" is blocked')}}}};IDB.intoTable=function(databaseid,tableid,value,columns,cb){var ixdbid=alasql.databases[databaseid].ixdbid;var request1=window.indexedDB.open(ixdbid);request1.onsuccess=function(event){var ixdb=event.target.result;var tx=ixdb.transaction([tableid],"readwrite");var tb=tx.objectStore(tableid);for(var i=0,ilen=value.length;i<ilen;i++){tb.add(value[i])}tx.oncomplete=function(){ixdb.close();cb(ilen)}}};IDB.fromTable=function(databaseid,tableid,cb,idx,query){var ixdbid=alasql.databases[databaseid].ixdbid;var request=window.indexedDB.open(ixdbid);request.onsuccess=function(event){var res=[];var ixdb=event.target.result;var tx=ixdb.transaction([tableid]);var store=tx.objectStore(tableid);var cur=store.openCursor();cur.onblocked=function(event){};cur.onerror=function(event){};cur.onsuccess=function(event){var cursor=event.target.result;if(cursor){res.push(cursor.value);cursor.continue()}else{ixdb.close();cb(res,idx,query)}}}};IDB.deleteFromTable=function(databaseid,tableid,wherefn,params,cb){var ixdbid=alasql.databases[databaseid].ixdbid;var request=window.indexedDB.open(ixdbid);request.onsuccess=function(event){var res=[];var ixdb=event.target.result;var tx=ixdb.transaction([tableid],"readwrite");var store=tx.objectStore(tableid);var cur=store.openCursor();var num=0;cur.onblocked=function(event){};cur.onerror=function(event){};cur.onsuccess=function(event){var cursor=event.target.result;if(cursor){if(!wherefn||wherefn(cursor.value,params)){cursor.delete();num++}cursor.continue()}else{ixdb.close();cb(num)}}}};IDB.updateTable=function(databaseid,tableid,assignfn,wherefn,params,cb){var ixdbid=alasql.databases[databaseid].ixdbid;var request=window.indexedDB.open(ixdbid);request.onsuccess=function(event){var res=[];var ixdb=event.target.result;var tx=ixdb.transaction([tableid],"readwrite");var store=tx.objectStore(tableid);var cur=store.openCursor();var num=0;cur.onblocked=function(event){};cur.onerror=function(event){};cur.onsuccess=function(event){var cursor=event.target.result;if(cursor){if(!wherefn||wherefn(cursor.value,params)){var r=cursor.value;assignfn(r,params);cursor.update(r);num++}cursor.continue()}else{ixdb.close();cb(num)}}}}}var LS=alasql.engines.LOCALSTORAGE=function(){};LS.get=function(key){var s=localStorage.getItem(key);if(typeof s=="undefined")return;var v=undefined;try{v=JSON.parse(s)}catch(err){throw new Error("Cannot parse JSON "+s)}return v};LS.set=function(key,value){if(typeof value=="undefined")localStorage.removeItem(key);else localStorage.setItem(key,JSON.stringify(value))};LS.createDatabase=function(lsdbid,args,ifnotexists,dbid,cb){var res=1;var ls=LS.get("alasql");if(!(ifnotexists&&ls&&ls.databases&&ls.databases[lsdbid])){if(!ls)ls={databases:{}};if(ls.databases&&ls.databases[lsdbid]){throw new Error('localStorage: Cannot create new database "'+lsdbid+'" because it already exists')}ls.databases[lsdbid]=true;LS.set("alasql",ls);LS.set(lsdbid,{databaseid:lsdbid,tables:{}})}else{res=0}if(cb)cb(res);return res};LS.dropDatabase=function(lsdbid,ifexists,cb){var res=1;var ls=LS.get("alasql");if(!(ifexists&&ls&&ls.databases&&!ls.databases[lsdbid])){if(!ls){if(!ifexists){throw new Error("There are no alasql databases in localStorage")}else{return 0}}if(ls.databases&&!ls.databases[lsdbid]){throw new Error('localStorage: Cannot drop database "'+lsdbid+'" because there is no such database')}delete ls.databases[lsdbid];LS.set("alasql",ls);var db=LS.get(lsdbid);for(var tableid in db.tables){localStorage.removeItem(lsdbid+"."+tableid)}localStorage.removeItem(lsdbid)}else{res=0}if(cb)cb(res);return res};LS.attachDatabase=function(lsdbid,dbid,args,params,cb){var res=1;if(alasql.databases[dbid]){throw new Error('Unable to attach database as "'+dbid+'" because it already exists')}var db=new alasql.Database(dbid||lsdbid);db.engineid="LOCALSTORAGE";db.lsdbid=lsdbid;db.tables=LS.get(lsdbid).tables;if(!alasql.options.autocommit){if(db.tables){for(var tbid in db.tables){db.tables[tbid].data=LS.get(db.lsdbid+"."+tbid)}}}if(cb)res=cb(res);return res};LS.showDatabases=function(like,cb){var res=[];var ls=LS.get("alasql");if(like){var relike=new RegExp(like.value.replace(/\%/g,".*"),"g")}if(ls&&ls.databases){for(dbid in ls.databases){res.push({databaseid:dbid})}if(like&&res&&res.length>0){res=res.filter(function(d){return d.databaseid.match(relike)})}}if(cb)cb(res);return res};LS.createTable=function(databaseid,tableid,ifnotexists,cb){var lsdbid=alasql.databases[databaseid].lsdbid;var tb=LS.get(lsdbid+"."+tableid);var res=1;if(tb&&!ifnotexists){throw new Error('Table "'+tableid+'" alsready exists in localStorage database "'+lsdbid+'"')}var lsdb=LS.get(lsdbid);var table=alasql.databases[databaseid].tables[tableid];lsdb.tables[tableid]={columns:table.columns};LS.set(lsdbid,lsdb);LS.set(lsdbid+"."+tableid,[]);if(cb)cb(res);return res};LS.dropTable=function(databaseid,tableid,ifexists,cb){var res=1;var lsdbid=alasql.databases[databaseid].lsdbid;if(alasql.options.autocommit){var lsdb=LS.get(lsdbid)}else{var lsdb=alasql.databases[databaseid]}if(!ifexists&&!lsdb.tables[tableid]){throw new Error('Cannot drop table "'+tableid+'" in localStorage, because it does not exist')}delete lsdb.tables[tableid];LS.set(lsdbid,lsdb);localStorage.removeItem(lsdbid+"."+tableid);if(cb)cb(res);return res};LS.fromTable=function(databaseid,tableid,cb,idx,query){var lsdbid=alasql.databases[databaseid].lsdbid;var res=LS.get(lsdbid+"."+tableid);if(cb)res=cb(res,idx,query);return res};LS.intoTable=function(databaseid,tableid,value,columns,cb){var lsdbid=alasql.databases[databaseid].lsdbid;var res=value.length;var tb=LS.get(lsdbid+"."+tableid);if(!tb)tb=[];tb=tb.concat(value);LS.set(lsdbid+"."+tableid,tb);if(cb)cb(res);return res};LS.loadTableData=function(databaseid,tableid){var db=alasql.databases[databaseid];var lsdbid=alasql.databases[databaseid].lsdbid;db.tables[tableid].data=LS.get(lsdbid+"."+tableid)};LS.saveTableData=function(databaseid,tableid){var db=alasql.databases[databaseid];var lsdbid=alasql.databases[databaseid].lsdbid;LS.set(lsdbid+"."+tableid,db.tables[tableid].data);db.tables[tableid].data=null};LS.commit=function(databaseid,cb){var db=alasql.databases[databaseid];var lsdbid=alasql.databases[databaseid].lsdbid;var lsdb={databaseid:lsdbid,tables:{}};if(db.tables){for(var tbid in db.tables){lsdb.tables[tbid]={columns:db.tables[tbid].columns};LS.set(lsdbid+"."+tbid,db.tables[tbid].data)}}LS.set(lsdbid,lsdb);return 1};LS.begin=LS.commit;LS.rollback=function(databaseid,cb){var db=alasql.databases[databaseid];db.dbversion++;var lsdbid=alasql.databases[databaseid].lsdbid;var lsdb=LS.get(lsdbid);if(lsdb.tables){for(var tbid in lsdb.tables){var tb=new alasql.Table({columns:db.tables[tbid].columns});extend(tb,lsdb.tables[tbid]);lsdb.tables[tbid]=tb;if(!alasql.options.autocommit){lsdb.tables[tbid].data=LS.get(db.lsdbid+"."+tbid)}lsdb.tables[tbid].indexColumns()}}delete alasql.databases[databaseid];alasql.databases[databaseid]=new alasql.Database(databaseid);extend(alasql.databases[databaseid],lsdb);alasql.databases[databaseid].databaseid=databaseid;alasql.databases[databaseid].engineid="LOCALSTORAGE"};var SQLITE=alasql.engines.SQLITE=function(){};SQLITE.createDatabase=function(wdbid,args,ifnotexists,dbid,cb){throw new Error("Connot create SQLITE database in memory. Attach it.")};SQLITE.dropDatabase=function(databaseid){throw new Error("This is impossible to drop SQLite database. Detach it.")};SQLITE.attachDatabase=function(sqldbid,dbid,args,params,cb){var res=1;if(alasql.databases[dbid]){throw new Error('Unable to attach database as "'+dbid+'" because it already exists')}if(args[0]&&args[0]instanceof yy.StringValue||args[0]instanceof yy.ParamValue){if(args[0]instanceof yy.StringValue){var value=args[0].value}else if(args[0]instanceof yy.ParamValue){var value=params[args[0].param]}alasql.utils.loadBinaryFile(value,true,function(data){var db=new alasql.Database(dbid||sqldbid);db.engineid="SQLITE";db.sqldbid=sqldbid;var sqldb=db.sqldb=new SQL.Database(data);db.tables=[];var tables=sqldb.exec("SELECT * FROM sqlite_master WHERE type='table'")[0].values;tables.forEach(function(tbl){db.tables[tbl[1]]={};var columns=db.tables[tbl[1]].columns=[];var ast=alasql.parse(tbl[4]);var coldefs=ast.statements[0].columns;if(coldefs&&coldefs.length>0){coldefs.forEach(function(cd){columns.push(cd)})}});cb(1)},function(err){throw new Error('Cannot open SQLite database file "'+args[0].value+'"')});return res}else{throw new Error("Cannot attach SQLite database without a file")}return res};SQLITE.fromTable=function(databaseid,tableid,cb,idx,query){var data=alasql.databases[databaseid].sqldb.exec("SELECT * FROM "+tableid);var columns=query.sources[idx].columns=[];if(data[0].columns.length>0){data[0].columns.forEach(function(columnid){columns.push({columnid:columnid})})}var res=[];if(data[0].values.length>0){data[0].values.forEach(function(d){var r={};columns.forEach(function(col,idx){r[col.columnid]=d[idx]});res.push(r)})}if(cb)cb(res,idx,query)};SQLITE.intoTable=function(databaseid,tableid,value,columns,cb){var sqldb=alasql.databases[databaseid].sqldb;for(var i=0,ilen=value.length;i<ilen;i++){var s="INSERT INTO "+tableid+" (";var d=value[i];var keys=Object.keys(d);s+=keys.join(",");s+=") VALUES (";s+=keys.map(function(k){v=d[k];if(typeof v=="string")v="'"+v+"'";return v}).join(",");s+=")";sqldb.exec(s)}var res=ilen;if(cb)cb(res);return res};var FS=alasql.engines.FILESTORAGE=alasql.engines.FILE=function(){};FS.createDatabase=function(fsdbid,args,ifnotexists,dbid,cb){var res=1;var filename=args[0].value;alasql.utils.fileExists(filename,function(fex){if(fex){if(ifnotexists){res=0;if(cb)res=cb(res);return res}else{throw new Error("Cannot create new database file, because it alreagy exists")}}else{var data={tables:{}};alasql.utils.saveFile(filename,JSON.stringify(data),function(data){if(cb)res=cb(res)})}});return res};FS.dropDatabase=function(fsdbid,ifexists,cb){var res;var filename=fsdbid.value;alasql.utils.fileExists(filename,function(fex){if(fex){res=1;alasql.utils.deleteFile(filename,function(){res=1;if(cb)res=cb(res)})}else{if(!ifexists){throw new Error("Cannot drop database file, because it does not exist")}res=0;if(cb)res=cb(res)}});return res};FS.attachDatabase=function(fsdbid,dbid,args,params,cb){var res=1;if(alasql.databases[dbid]){throw new Error('Unable to attach database as "'+dbid+'" because it already exists')}var db=new alasql.Database(dbid||fsdbid);db.engineid="FILESTORAGE";db.filename=args[0].value;loadFile(db.filename,!!cb,function(s){try{db.data=JSON.parse(s)}catch(err){throw new Error("Data in FileStorage database are corrupted")}db.tables=db.data.tables;if(!alasql.options.autocommit){if(db.tables){for(var tbid in db.tables){db.tables[tbid].data=db.data[tbid]}}}if(cb)res=cb(res)});return res};FS.createTable=function(databaseid,tableid,ifnotexists,cb){var db=alasql.databases[databaseid];var tb=db.data[tableid];var res=1;if(tb&&!ifnotexists){throw new Error('Table "'+tableid+'" alsready exists in the database "'+fsdbid+'"')}var table=alasql.databases[databaseid].tables[tableid];db.data.tables[tableid]={columns:table.columns};db.data[tableid]=[];FS.updateFile(databaseid);if(cb)cb(res);return res};FS.updateFile=function(databaseid){var db=alasql.databases[databaseid];if(db.issaving){db.postsave=true;return}db.issaving=true;db.postsave=false;alasql.utils.saveFile(db.filename,JSON.stringify(db.data),function(){db.issaving=false;if(db.postsave){setTimeout(function(){FS.updateFile(databaseid)},50)}})};FS.dropTable=function(databaseid,tableid,ifexists,cb){var res=1;var db=alasql.databases[databaseid];if(!ifexists&&!db.tables[tableid]){throw new Error('Cannot drop table "'+tableid+'" in fileStorage, because it does not exist')}delete db.tables[tableid];delete db.data.tables[tableid];delete db.data[tableid];FS.updateFile(databaseid);if(cb)cb(res);return res};FS.fromTable=function(databaseid,tableid,cb,idx,query){var db=alasql.databases[databaseid];var res=db.data[tableid];if(cb)res=cb(res,idx,query);return res};FS.intoTable=function(databaseid,tableid,value,columns,cb){var db=alasql.databases[databaseid];var res=value.length;var tb=db.data[tableid];if(!tb)tb=[];db.data[tableid]=tb.concat(value);FS.updateFile(databaseid);if(cb)cb(res);return res};FS.loadTableData=function(databaseid,tableid){var db=alasql.databases[databaseid];db.tables[tableid].data=db.data[tableid]};FS.saveTableData=function(databaseid,tableid){var db=alasql.databases[databaseid];db.data[tableid]=db.tables[tableid].data;db.tables[tableid].data=null;FS.updateFile(databaseid)};FS.commit=function(databaseid,cb){var db=alasql.databases[databaseid];var fsdb={tables:{}};if(db.tables){for(var tbid in db.tables){db.data.tables[tbid]={columns:db.tables[tbid].columns};db.data[tbid]=db.tables[tbid].data}}FS.updateFile(databaseid);return 1};FS.begin=FS.commit;FS.rollback=function(databaseid,cb){var res=1;var db=alasql.databases[databaseid];db.dbversion++;wait();function wait(){setTimeout(function(){if(db.issaving){return wait()}else{alasql.loadFile(db.filename,!!cb,function(data){db.data=data;db.tables={};for(var tbid in db.data.tables){var tb=new alasql.Table({columns:db.data.tables[tbid].columns});extend(tb,db.data.tables[tbid]);db.tables[tbid]=tb;if(!alasql.options.autocommit){db.tables[tbid].data=db.data[tbid]}db.tables[tbid].indexColumns()}delete alasql.databases[databaseid];alasql.databases[databaseid]=new alasql.Database(databaseid);extend(alasql.databases[databaseid],db);alasql.databases[databaseid].engineid="FILESTORAGE";alasql.databases[databaseid].filename=db.filename;if(cb)res=cb(res)})}},100)}};if(typeof exports!="object"&&typeof importScripts!="function"&&typeof document=="object"){var saveAs=saveAs||typeof navigator!=="undefined"&&navigator.msSaveOrOpenBlob&&navigator.msSaveOrOpenBlob.bind(navigator)||function(view){"use strict";if(typeof navigator!=="undefined"&&/MSIE [1-9]\./.test(navigator.userAgent)){return}var doc=view.document,get_URL=function(){return view.URL||view.webkitURL||view},save_link=doc.createElementNS("http://www.w3.org/1999/xhtml","a"),can_use_save_link="download"in save_link,click=function(node){var event=doc.createEvent("MouseEvents");event.initMouseEvent("click",true,false,view,0,0,0,0,0,false,false,false,false,0,null);node.dispatchEvent(event)},webkit_req_fs=view.webkitRequestFileSystem,req_fs=view.requestFileSystem||webkit_req_fs||view.mozRequestFileSystem,throw_outside=function(ex){(view.setImmediate||view.setTimeout)(function(){throw ex},0)},force_saveable_type="application/octet-stream",fs_min_size=0,arbitrary_revoke_timeout=500,revoke=function(file){var revoker=function(){if(typeof file==="string"){get_URL().revokeObjectURL(file)}else{file.remove()}};if(view.chrome){revoker()}else{setTimeout(revoker,arbitrary_revoke_timeout)}},dispatch=function(filesaver,event_types,event){event_types=[].concat(event_types);var i=event_types.length;while(i--){var listener=filesaver["on"+event_types[i]];if(typeof listener==="function"){try{listener.call(filesaver,event||filesaver)}catch(ex){throw_outside(ex)}}}},FileSaver=function(blob,name){var filesaver=this,type=blob.type,blob_changed=false,object_url,target_view,dispatch_all=function(){dispatch(filesaver,"writestart progress write writeend".split(" "))},fs_error=function(){if(blob_changed||!object_url){object_url=get_URL().createObjectURL(blob)}if(target_view){target_view.location.href=object_url}else{var new_tab=view.open(object_url,"_blank");if(new_tab==undefined&&typeof safari!=="undefined"){view.location.href=object_url}}filesaver.readyState=filesaver.DONE;dispatch_all();revoke(object_url)},abortable=function(func){return function(){if(filesaver.readyState!==filesaver.DONE){return func.apply(this,arguments)}}},create_if_not_found={create:true,exclusive:false},slice;filesaver.readyState=filesaver.INIT;if(!name){name="download"}if(can_use_save_link){object_url=get_URL().createObjectURL(blob);save_link.href=object_url;save_link.download=name;click(save_link);filesaver.readyState=filesaver.DONE;dispatch_all();revoke(object_url);return}if(/^\s*(?:text\/(?:plain|xml)|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)){blob=new Blob(["﻿",blob],{type:blob.type})}if(view.chrome&&type&&type!==force_saveable_type){slice=blob.slice||blob.webkitSlice;blob=slice.call(blob,0,blob.size,force_saveable_type);blob_changed=true}if(webkit_req_fs&&name!=="download"){name+=".download"}if(type===force_saveable_type||webkit_req_fs){target_view=view}if(!req_fs){fs_error();return}fs_min_size+=blob.size;req_fs(view.TEMPORARY,fs_min_size,abortable(function(fs){fs.root.getDirectory("saved",create_if_not_found,abortable(function(dir){var save=function(){dir.getFile(name,create_if_not_found,abortable(function(file){file.createWriter(abortable(function(writer){writer.onwriteend=function(event){target_view.location.href=file.toURL();filesaver.readyState=filesaver.DONE;dispatch(filesaver,"writeend",event);revoke(file)};writer.onerror=function(){var error=writer.error;if(error.code!==error.ABORT_ERR){fs_error()}};"writestart progress write abort".split(" ").forEach(function(event){writer["on"+event]=filesaver["on"+event]});writer.write(blob);filesaver.abort=function(){writer.abort();filesaver.readyState=filesaver.DONE};filesaver.readyState=filesaver.WRITING}),fs_error)}),fs_error)};dir.getFile(name,{create:false},abortable(function(file){file.remove();save()}),abortable(function(ex){if(ex.code===ex.NOT_FOUND_ERR){save()}else{fs_error()}}))}),fs_error)}),fs_error)},FS_proto=FileSaver.prototype,saveAs=function(blob,name){return new FileSaver(blob,name)};FS_proto.abort=function(){var filesaver=this;filesaver.readyState=filesaver.DONE;dispatch(filesaver,"abort")};FS_proto.readyState=FS_proto.INIT=0;FS_proto.WRITING=1;FS_proto.DONE=2;FS_proto.error=FS_proto.onwritestart=FS_proto.onprogress=FS_proto.onwrite=FS_proto.onabort=FS_proto.onerror=FS_proto.onwriteend=null;return saveAs}(typeof self!=="undefined"&&self||typeof window!=="undefined"&&window||this.content);if(typeof module!=="undefined"&&module.exports){module.exports.saveAs=saveAs}else if(typeof define!=="undefined"&&define!==null&&define.amd!=null){define([],function(){return saveAs})}alasql.utils.saveAs=saveAs}new Database("alasql");alasql.use("alasql");return alasql});if(typeof importScripts==="function"){}else if(typeof exports!="object"){alasql.worker=function(path,paths,cb){if(path===true)path=undefined;if(typeof path=="undefined"){var sc=document.getElementsByTagName("script");for(var i=0;i<sc.length;i++){if(sc[i].src.substr(-16).toLowerCase()=="alasql-worker.js"){path=sc[i].src.substr(0,sc[i].src.length-16)+"alasql.js";break}else if(sc[i].src.substr(-20).toLowerCase()=="alasql-worker.min.js"){path=sc[i].src.substr(0,sc[i].src.length-20)+"alasql.min.js";break}else if(sc[i].src.substr(-9).toLowerCase()=="alasql.js"){path=sc[i].src;break}else if(sc[i].src.substr(-13).toLowerCase()=="alasql.min.js"){path=sc[i].src.substr(0,sc[i].src.length-13)+"alasql.min.js";break}}}if(typeof path=="undefined"){throw new Error("Path to alasql.js is not specified")}else if(path!==false){var js="importScripts('";js+=path;js+="');self.onmessage = function(event) {"+"alasql(event.data.sql,event.data.params, function(data){"+"postMessage({id:event.data.id, data:data});});}";var blob=new Blob([js],{type:"text/plain"});alasql.webworker=new Worker(URL.createObjectURL(blob));alasql.webworker.onmessage=function(event){var id=event.data.id;alasql.buffer[id](event.data.data);delete alasql.buffer[id]};alasql.webworker.onerror=function(e){throw e};if(arguments.length>1){var sql="REQUIRE "+paths.map(function(p){return'"'+p+'"'}).join(",");alasql(sql,[],cb)}}else if(path===false){delete alasql.webworker;return}}}
/**
 * Created by cl-macmini-51 on 8/10/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('resetPasswordService', resetPasswordService);

    /** @ngInject */
    function resetPasswordService($log, $http, $q, MY_CONSTANT) {
        return {
            getResetPasswordCustomer: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/reset_password_customer",
                    method: 'POST',
                    headers:{
                        'content-language': 'es'
                    },
                    data:dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getResetPasswordDriver: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/reset_password_fleet",
                    method: 'POST',
                    headers:{
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getResetPasswordAdmin: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/reset_password_admin",
                    method: 'POST',
                    headers:{
                        'content-language': 'es'
                    },
                    data: dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            }
        }
    }
})();

/**
 * Created by cl-macmini-51 on 8/10/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('ResetPasswordController', ResetPasswordController);

    /** @ngInject */
    function ResetPasswordController(toastr, $cookies, $log, $state, $http, resetPasswordService, $translate, getAdminRoles,adminAccessService,$rootScope, $timeout, $stateParams, languageBasedErrorFactory,errorMessageFactory) {
        var vm = this;

        vm.typeUser = $stateParams.type;
        vm.passwordMatchFlag = false;
        vm.matchPassword = matchPassword;
        vm.errorMessage = false;
        vm.matchConfirmPassword = matchConfirmPassword;
        vm.resetPassword = resetPassword;
        if($stateParams.lang == 'en'){
            $cookies.put('language','en')
        }
        else{
            $cookies.put('language','spanish')
        }
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();

        //=======================password match function====================
        function matchConfirmPassword(data) {
            if (data) {
                if (data != vm.password) {
                    vm.passwordMatchFlag = true;
                } else {
                    vm.passwordMatchFlag = false;
                }
            }
            else{
                vm.passwordMatchFlag = false;
            }
        };
        function matchPassword(data) {
            if (data && vm.confirmPassword) {
                if (data != vm.confirmPassword) {
                    vm.passwordMatchFlag = true;
                } else {
                    vm.passwordMatchFlag = false;
                }
            }
            else{
                vm.passwordMatchFlag = false;
            }
        };

        //========================submit api hit for reset password=================

        function resetPassword(){
            if(vm.passwordMatchFlag){
                return;
            }
            var dataSend = {};
            dataSend.new_password = vm.password;
            dataSend.id = $stateParams.id;
            dataSend.lang = $stateParams.lang;
            //dataSend.login_id = vm.email;
            if(vm.typeUser == 'customer'){
                vm.loading = true;
                var promise = resetPasswordService.getResetPasswordCustomer(dataSend); //$stateParams.id
                promise.then(
                    function(payload) {
                        $log.log('sxdsads', payload);
                        
                        vm.loading = false;
                        if(payload.title.status == 200){
                            if($cookies.get('language') == 'en'){
                                vm.successMsg = 'Password reset successfully.';
                                vm.errorMessage = true;
                            }
                            else{
                                vm.successMsg = 'La contraseña fue cambiada exitosamente Ahora vuelve a iniciar sesión en la App Cliente';
                                vm.errorMessage = true;
                            }
                            $timeout(function(){
                                // vm.successMsg = '';
                                // $state.go('home');
                            },2000);
                        }else{
                           vm.errMsg = payload.title.message;
                        }
                    },
                    function(errorPayload) {
                        vm.loading = false;
                        vm.errMsg = errorPayload.data.message;
                        $timeout(function(){
                            vm.errMsg = '';
                        },2000);
                    }
                );
            }
            else if(vm.typeUser == 'fleet'){
                vm.loading = true;
                var promise = resetPasswordService.getResetPasswordDriver(dataSend); //$stateParams.id
                promise.then(
                    function(payload) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        if(payload.title.status == 200){
                            if($cookies.get('language') == 'en'){
                                vm.successMsg = 'Password reset successfully.';
                                vm.errorMessage = true;
                            }
                            else{
                                vm.successMsg = 'La contraseña fue cambiada exitosamente Ahora vuelve a iniciar sesión en la App Conductor';
                                vm.errorMessage = true;
                            }
                            $timeout(function(){
                                // vm.successMsg = '';
                                // $state.go('home');
                            },2000);
                        }else{
                           vm.errMsg = payload.title.message;
                        }
                    },
                    function(errorPayload) {
                        vm.loading = false;
                        vm.errMsg = errorPayload.data.message;
                        $timeout(function(){
                            vm.errMsg = '';
                        },2000);

                    }
                );
            }
            else if(vm.typeUser == 'admin'){
                var dataSend = {};
                dataSend.new_password = vm.password;
                dataSend.id = $stateParams.id;
                dataSend.lang = $stateParams.lang;
                //dataSend.email = vm.email;
                vm.loading = true;
                var promise = resetPasswordService.getResetPasswordAdmin(dataSend); //$stateParams.id
                promise.then(
                    function(payload) {
                        $log.log('sxdsads', payload);
                        vm.loading = false;
                        if(payload.title.status == 200){
                            if($cookies.get('language') == 'en'){
                                vm.successMsg = 'Password reset successfully.';
                                vm.errorMessage = false;
                            }
                            else{
                                vm.successMsg = 'Contraseña modificada exitosamente';
                                vm.errorMessage = false;
                            }
                            $timeout(function(){
                                vm.successMsg = '';
                                $state.go('home');
                            },2000);
                        }else{
                           vm.errMsg = payload.title.message;
                        }
                        
                    },
                    function(errorPayload) {
                        vm.loading = false;
                        vm.errMsg = errorPayload.data.message;
                        $timeout(function(){
                            vm.errMsg = '';
                        },2000);

                    }
                );
            }
        }

    };
})();

/**
 * Created by cl-macmini-51 on 4/13/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('loginService', loginService);

    /** @ngInject */
    function loginService($log, $http, $q, MY_CONSTANT, $cookies) {
        return {
            getLogin: function (e, p) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/admin_login",
                    method: 'POST',
                    headers:{
                        'content-language': $cookies.get('language') == 'spanish' ? 'es' : 'en'
                    },
                    data: {
                        email: e,
                        password: p
                    }
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            }
        }
    }
})();

(function () {
    'use strict';
    var intervalFuncation;
    angular
        .module('transVipMain')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController(toastr, $cookies, $log, $state, $http, loginService, $translate, getAdminRoles, adminAccessService, $rootScope, $timeout, $document, $mdDialog, languageBasedErrorFactory, errorMessageFactory, $interval) {
        var vm = this;
        vm.email = '';
        vm.password = '';
        vm.loading = false;
        vm.authMsg = '';
        $cookies.put('language', 'spanish')
        // $cookies.put('language','en')
        vm.languageSelected = languageBasedErrorFactory.checkLanguageOnLoad();
        vm.loginAdmin = loginAdmin;
        vm.selectParticularLanguage = selectParticularLanguage;
        //vm.print = print;
        $log.log(vm);
        languageBasedErrorFactory.getTranslationStrings();

        //=================function for language translate=================
        vm.language = {
            setLanguage: 'en',
            listIsOpen: false,
            available: {
                'en': 'English',
                'Spanish': 'Spanish'
            },
            //by default will load this language
            init: function () {
                vm.language.selected = vm.language.available['englishTranslate'];
                $translate.use('englishTranslate');
            },
            //Set the new language
            set: function (localeId, ev) {
                $translate.use(localeId);
                vm.language.selected = vm.language.available[localeId]
            }
        };



        //===================select particular language====================
        function selectParticularLanguage(data) {
            if (data == 'en') {
                $translate.use('englishTranslate');
                $cookies.put('language', 'en');
                languageBasedErrorFactory.getTranslationStrings();
            } else {
                $translate.use('spanishTranslate');
                $cookies.put('language', 'spanish');
                languageBasedErrorFactory.getTranslationStrings();
            }
        }

        //======================get admin access list===================
        function getAdminAccessList(data) {
            var dataSend = {};
            dataSend.limit = 0;
            dataSend.offset = 0;
            dataSend.admin_id = data;
            var promise = getAdminRoles.getAdminUserList(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    localStorage.setItem('adminName', JSON.stringify(payload.title.data.result[0].fullName));
                    vm.loading = false;
                    if (payload.title.data.result[0].role.length == 0) {
                        //$state.go('layout.dashboardMain');
                        //adminAccess.checkStateValid('Dashboard');
                        languageBasedErrorFactory.getProperErrorMessage('noRoleError', 'login', 0);
                        $cookies.remove('obj');
                        $cookies.remove('adminEmail');
                        $cookies.remove('adminId');
                        localStorage.removeItem('getAdminAccess');
                        localStorage.removeItem('adminName');
                        localStorage.removeItem('getAdminRoles');
                        $cookies.remove('petAgreements');
                        //$state.go('layout.dashboardMain');
                    } else {
                        adminAccessService.putAdminAccess(payload.title.data.result[0].role);
                        //adminAccess.checkStateValid('Dashboard');
                        // if(JSON.parse($cookies.get('adminType')) == 0) {
                        $state.go('layout.homeScreenMain');
                        // } else {
                        //     $state.go('layout.createBookingMain');
                        // }
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    if (errorPayload.data.status == 401) {
                        //errorMessageFactory.showErrorMessageL(errorPayload.data.message,0);
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    } else {
                        //errorMessageFactory.showErrorMessageL(errorPayload.data.message,0);
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                });
        }


        //===================function for login===================
        function loginAdmin() {
            $log.log(vm);
            vm.loading = true;
            var promise = loginService.getLogin(vm.email, vm.password); //$stateParams.id
            promise.then(
                function (payload) {
                    console.log('debug', payload);

                    //vm.loading = false;
                    if (payload.title.status == 200) {
                        $cookies.put('obj', payload.title.data.access_token);
                        $cookies.put('adminEmail', payload.title.data.email);
                        $cookies.put('adminId', payload.title.data.id);
                        $cookies.put('adminType', payload.title.data.user_type);
                        $cookies.put('saleShiftId',payload.title.data.shift_id);
                        if (payload.title.data.agreements && payload.title.data.agreements.length > 0){
                            $cookies.put('petAgreements', JSON.stringify(payload.title.data.agreements));
                        } else {
                            $cookies.remove('petAgreements');
                        }
                        getAdminAccessList(payload.title.data.id);
                        if (payload.title.data.forceUpdate) {
                            if (intervalFuncation) {

                            } else {
                                intervalFuncation = $interval(function () {
                                    var confirm = $mdDialog.confirm()
                                        .title(' Hay una nueva versión, ¿quieres actualizar ahora?')
                                        .textContent('')
                                        .ariaLabel('Lucky day')
                                        // .targetEvent($event)
                                        .ok('Confirmar')
                                        .cancel('Cancelar');

                                    $mdDialog.show(confirm).then(function () {
                                        location.reload(true);
                                    }, function () {});
                                    // var alert = $mdDialog.alert({
                                    //     title: 'Hay una nueva versión, ¿quieres actualizar ahora?',
                                    //     textContent: '',
                                    //     ok: 'Confirmar'
                                    // });
                                    // $mdDialog
                                    //     .show(alert)
                                    //     .finally(function () {
                                    //         location.reload(true);
                                    //     });
                                }, 600000);
                            }
                        }
                    } else {
                        vm.loading = false;
                        vm.authMsg = payload.title.message;
                        $timeout(function () {
                            vm.authMsg = '';
                        }, 3000);
                    }
                }
            );
        }
    };
})();
/**
 * Created by cl-macmini-51 on 9/27/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('forgetPasswordService', forgetPasswordService);

    /** @ngInject */
    function forgetPasswordService($log, $http, $q, MY_CONSTANT) {
        return {
            forgetPasswordApi: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                    url: MY_CONSTANT.url + "/forgot_password_admin",
                    method: 'POST',
                    headers:{
                        'content-language': 'es'
                    },
                    data:dataSend
                })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            }
        }
    }
})();

/**
 * Created by cl-macmini-51 on 9/27/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('ForgetPasswordController', ForgetPasswordController);

    /** @ngInject */
    function ForgetPasswordController(toastr, $cookies, $log, $state, $http, forgetPasswordService, $translate, getAdminRoles, adminAccessService, $rootScope, $timeout, $stateParams, languageBasedErrorFactory, errorMessageFactory, checkDomain) {
        var vm = this;

        vm.buttonDisable = false;

        $cookies.put('language', 'spanish');
        vm.forgetPassword = forgetPassword;
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();

        //========================submit api hit for forget password=================
        function forgetPassword() {
            var dataSend = {};
            dataSend.domainUrl = checkDomain.getDomainName();
            dataSend.email = vm.email;
            vm.loading = true;
            var promise = forgetPasswordService.forgetPasswordApi(dataSend); //$stateParams.id
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.loading = false;
                    if (payload.title.status == 200) {
                        vm.buttonDisable = true;
                        if ($cookies.get('language') == 'en') {
                            vm.successMsg = 'Reset password link sent to registered email successfully.';
                        } else {
                            vm.successMsg = 'Le hemos enviado un correo electrónico a la dirección indicada para restablecer su contraseña.';
                        }
                    } else {
                        vm.errMsg = payload.title.message;
                    }

                    $timeout(function(){
                        // vm.successMsg = '';
                        vm.errMsg  = '';
                    },2000);
                },
                function (errorPayload) {
                    vm.loading = false;
                    vm.errMsg = errorPayload.data.message;
                    $timeout(function () {
                        vm.errMsg = '';
                    }, 2000);
                }
            );
        }

    };
})();
/**
 * Created by cl-macmini-51 on 8/10/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('DriverRatingAppController', DriverRatingAppController);

    /** @ngInject */
    function DriverRatingAppController() {
    }
})();
/**
 * Created by cl-macmini-51 on 8/10/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .service('DriverRatingService', DriverRatingService);

    /** @ngInject */
    function DriverRatingService($log, $http, $q, MY_CONSTANT, pendingRequests) {
        return {
            addDriverRating: function (dataSend) {
                var deferred = $q.defer();
                return $http({
                        url: MY_CONSTANT.url + "/email_customer_rating_to_fleet",
                        method: 'POST',
                        headers: {
                            'content-language': 'es'
                        },
                        data: dataSend
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        return deferred.promise;
                    });
            },
            getDriverRatingAPI: function (data) {
                var deferred = $q.defer();
                pendingRequests.add({
                    url: MY_CONSTANT.url + "/get_email_driver_evaluation",
                    canceller: deferred
                });
                return $http({
                        url: MY_CONSTANT.url + "/get_email_driver_evaluation",
                        method: 'GET',
                        headers: {
                            'content-language': 'es'
                        },
                        params: data,
                        timeout: deferred.promise
                    })
                    .then(function (data) {
                        deferred.resolve({
                            title: data.data
                        });
                        pendingRequests.remove(MY_CONSTANT.url + "/get_email_driver_evaluation");
                        return deferred.promise;
                    })
                    .catch(function (msg) {
                        deferred.reject(msg);
                        pendingRequests.remove(MY_CONSTANT.url + "/get_email_driver_evaluation");
                        return deferred.promise;
                    });
            }
        }
    }
})();
/**
 * Created by cl-macmini-51 on 8/10/17.
 */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .controller('DriverRatingController', DriverRatingController);

    /** @ngInject */
    function DriverRatingController(toastr, $window , $cookies, $log, $state, $http, DriverRatingService, $translate, getAdminRoles, adminAccessService, $rootScope, $timeout, $stateParams, languageBasedErrorFactory, errorMessageFactory) {
        var vm = this;

        vm.getDataAPI = getDataAPI;
        vm.selectedComment = selectedComment;
        vm.submitRating = submitRating;
        vm.retry = retry;
        vm.description = '';
        vm.title = '';
        vm.star1flag = false;
        vm.star2flag = false;
        vm.star3flag = false;
        vm.star4flag = false;
        vm.star5flag = false;
        vm.star1 = star1;
        vm.star2 = star2;
        vm.star3 = star3;
        vm.star4 = star4;
        vm.star5 = star5;
        vm.star1Leave = star1Leave;
        vm.star2Leave = star2Leave;
        vm.star3Leave = star3Leave;
        vm.star4Leave = star4Leave;
        vm.star5Leave = star5Leave;
        vm.otherComment = '';
        vm.link = location.hostname;
        vm.showManualCommentBox = false;
        vm.selectedCommentButtonError = false;
        vm.errorMsgForStarAndCommentMandatory = false;
        vm.errorMsginHtml = '';
        vm.expireLink = false;
        vm.idValue= $stateParams.id.split('+');
        vm.selectedStarValue =  vm.idValue[0] || 0;
        // if ($cookies.get('successMsg') == 'true') {
        //     vm.successMsg = true;
        // } else {
        vm.successMsg = false;
        // }
        // if ($cookies.get('linkExpireError') == 'true') {
        //     vm.linkExpireError = true;
        // } else {
        vm.linkExpireError = false;
        // }
        vm.getStarRating = getStarRating;
        if ($stateParams.lang == 'en') {
            $cookies.put('language', 'en')
        } else {
            $cookies.put('language', 'spanish')
        }
        languageBasedErrorFactory.checkLanguageOnLoad();
        languageBasedErrorFactory.getTranslationStrings();

        // TO GET DATA
        function getDataAPI() {
            vm.loading = true;

            var dataSend = {};
            dataSend.access_token = $cookies.get('obj') || 'spanish';
            dataSend.template = vm.selectedStarValue;
            dataSend.job_id = $stateParams.job_id;
            dataSend.unique_code = $stateParams.verify_tokan;

            var promise = DriverRatingService.getDriverRatingAPI(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.expireLink = false;
                    vm.loading = false;
                    if (payload.title.status == 400) {
                        vm.errorMsginHtml = payload.title.message;
                        if (payload.title && payload.title.data && payload.title.data.is_already_rated) {
                            vm.linkExpireError = true;
                        }
                        if (payload.title && payload.title.data && payload.title.data.is_error) {
                            vm.linkExpireError = true;
                            vm.expireLink = true;
                        }
                        // $cookies.put('linkExpireError', true);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        vm.linkExpireError = false;
                        // $cookies.put('linkExpireError', false);
                        vm.description = payload.title.data.description || '';
                        vm.title = payload.title.data.title || '';
                        vm.categories = payload.title.data.categories || [];
                        if (vm.selectedStarValue > 0)
                            vm.categories.push({
                                label: 'Otros',
                                other: true
                            });
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    vm.errMsg = errorPayload.data.message;
                    $timeout(function () {
                        vm.errMsg = '';
                    }, 2000);
                }
            );
        }

        getDataAPI();

        // GET SELECTED COMMENTS INDEX
        function selectedComment(index, is_selected) {
            vm.selectedCommentButtonError = false;
            index = index || 0;
            vm.count = 0;
            vm.categories.forEach(function (object) {
                if (object.selected)
                    vm.count++;
            });
            // FOR FIVE STAR USER CAN SELECT ONLY ONE COMMENT
            if (vm.selectedStarValue == 5) {
                if (vm.count < 1) {
                    vm.categories[index].selected = is_selected ? false : true;

                    // CHECK TO SHOW MANUAL COMMENT BOX
                    if (vm.categories[index].label === 'Otros' && vm.categories[index].selected)
                        vm.showManualCommentBox = true;
                    vm.errorMsgForStarAndCommentMandatory = false;
                    // CHECK TO HIDE MANUAL COMMENT BOX
                    if (vm.categories[index].label === 'Otros' && !vm.categories[index].selected) {
                        vm.otherComment = '';
                        vm.showManualCommentBox = false;
                    }
                } else {
                    if (vm.categories[index].selected) {
                        vm.categories[index].selected = false;

                        // CHECK TO HIDE MANUAL COMMENT BOX
                        if (vm.categories[index].label === 'Otros') {
                            vm.otherComment = '';
                            vm.showManualCommentBox = false;
                        }
                    } else {
                        vm.selectedCommentButtonError = true;
                    }
                }
            } else {
                if (vm.count < 3) {
                    vm.categories[index].selected = is_selected ? false : true;

                    // CHECK TO SHOW MANUAL COMMENT BOX
                    if (vm.categories[index].label === 'Otros' && vm.categories[index].selected)
                        vm.showManualCommentBox = true;
                    vm.errorMsgForStarAndCommentMandatory = false;
                    // CHECK TO HIDE MANUAL COMMENT BOX
                    if (vm.categories[index].label === 'Otros' && !vm.categories[index].selected) {
                        vm.otherComment = '';
                        vm.showManualCommentBox = false;
                    }
                } else {
                    if (vm.categories[index].selected) {
                        vm.categories[index].selected = false;

                        // CHECK TO HIDE MANUAL COMMENT BOX
                        if (vm.categories[index].label === 'Otros') {
                            vm.otherComment = '';
                            vm.showManualCommentBox = false;
                        }
                    } else {
                        vm.selectedCommentButtonError = true;
                    }
                }
            }
        }

        function submitRating() {

            var dataSend = {};
            dataSend.job_id = $stateParams.job_id;
            dataSend.unique_code = $stateParams.verify_tokan;
            dataSend.rating = vm.selectedStarValue;
            dataSend.comment = [];
            vm.categories.forEach(function (object) {
                if (object.selected && !object.other)
                    dataSend.comment.push(object.label);
            });
            // ADD MANUAL COMMENT
            if (vm.otherComment) {
                dataSend.comment.push('Otros');
                dataSend.other_comment = vm.otherComment;
            }

            // MAKE COMMENTS MANDATORY
            if (vm.selectedStarValue == 0 || dataSend.comment.length == 0) {
                vm.errorMsgForStarAndCommentMandatory = true;
                return false;
            }
            vm.loading = true;

            var promise = DriverRatingService.addDriverRating(dataSend);
            promise.then(
                function (payload) {
                    $log.log('sxdsads', payload);
                    vm.expireLink = false;
                    vm.loading = false;
                    console.log(payload,"payloadf>>>>>>>>>>>>>>>>>>>>>>");
                    
                    if (payload.title.status == 400) {
                        // errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        vm.errorMsginHtml = payload.title.message;
                        if (payload.title && payload.title.data && payload.title.data.is_already_rated) {
                            vm.linkExpireError = true;
                        }
                        if (payload.title && payload.title.data && payload.title.data.is_error) {
                            vm.linkExpireError = true;
                            vm.expireLink = true;
                        }

                        // $cookies.put('linkExpireError', true);
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if(vm.idValue[1] == 1){
                        window.location.href = 'https://s3.amazonaws.com/transvip/blank_page/index.html'
                        }else{
                            vm.linkExpireError = false;
                            vm.successMsg = true;
                        }
                    }
                },
                function (errorPayload) {
                    vm.loading = false;
                    vm.errMsg = errorPayload.data.message;
                    $timeout(function () {
                        vm.errMsg = '';
                    }, 2000);
                }
            );
        }

        function getStarRating(starRating) {
            console.log('getStarRating if',$stateParams.id);
            if (vm.idValue[0] == 0) {
                console.log('getStarRating if',$stateParams.id);
                vm.selectedStarValue = starRating;
                getDataAPI();
            }
        }

        function retry() {
            location.reload();
        }






        
        function star1(){
            vm.star1flag = true;
        }
        function star2(){
            vm.star1flag = true;
            vm.star2flag = true;
        }
        function star3(){
            vm.star1flag = true;
            vm.star2flag = true;
            vm.star3flag = true;
        }
        function star4(){ 
            vm.star1flag = true;
            vm.star2flag = true;
            vm.star3flag = true;
            vm.star4flag = true;
        }
        function star5(){
            vm.star1flag = true;
            vm.star2flag = true;
            vm.star3flag = true;
            vm.star4flag = true;
            vm.star5flag = true;
        }

        function star1Leave(){
            vm.star1flag = false;
        }
        function star2Leave(){
            vm.star2flag = false;
            vm.star3flag = false;
            vm.star4flag = false;
            vm.star5flag = false;
        }
        function star3Leave(){
            vm.star3flag = false;
            vm.star4flag = false;
            vm.star5flag = false;
        }
        function star4Leave(){
            vm.star4flag = false;
            vm.star5flag = false;
        }
        function star5Leave(){
            vm.star5flag = false;
        }
    };
})();
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .run(runBlock);

    /** @ngInject */
    function runBlock($log) {

        $log.debug('runBlock end');

    }

})();

(function () {
    'use strict';
    var intervalFuncation;
    angular
        .module('transVipMain')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider, $locationProvider, $injector) {

        //$locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise('/');
        $urlRouterProvider.when('/layout/homeScreenMain', '/layout/homeScreenMain/homeScreen');
        $urlRouterProvider.when('/layout/dashboardMain', '/layout/dashboardMain/dashboard');
        $urlRouterProvider.when('/layout/applicantsMain', '/layout/applicantsMain/applicants');
        $urlRouterProvider.when('/layout/approvedDriverMain', '/layout/approvedDriverMain/approvedDriver');
        $urlRouterProvider.when('/layout/pendingInvestorsMain', '/layout/pendingInvestorsMain/pendingInvestor');
        $urlRouterProvider.when('/layout/approvedInvestorsMain', '/layout/approvedInvestorsMain/approvedInvestor');
        $urlRouterProvider.when('/layout/upcomingBookingsMain', '/layout/upcomingBookingsMain/upcomingBookings');
        $urlRouterProvider.when('/layout/quickAssignmentMain', '/layout/quickAssignmentMain/quickAssignment');
        $urlRouterProvider.when('/layout/massiveQuickassignmentMain', '/layout/massiveQuickassignmentMain/massiveQuickassignment');
        $urlRouterProvider.when('/layout/groupMassiveQuickassignmentMain', '/layout/groupMassiveQuickassignmentMain/groupMassiveQuickassignment');
        $urlRouterProvider.when('/layout/configAssignmentMain', '/layout/configAssignmentMain/configAssignment');
        $urlRouterProvider.when('/layout/ongoingBookingsMain', '/layout/ongoingBookingsMain/ongoingBookings');
        $urlRouterProvider.when('/layout/completedBookingsMain', '/layout/completedBookingsMain/completedBookings');
        $urlRouterProvider.when('/layout/carMain', '/layout/carMain/carsList');
        $urlRouterProvider.when('/layout/carColorsMain', '/layout/carColorsMain/carColors');
        $urlRouterProvider.when('/layout/carModelsMain', '/layout/carModelsMain/carModels');
        $urlRouterProvider.when('/layout/vechicleBalanceMain', '/layout/vechicleBalanceMain/vechicleBalance');
        $urlRouterProvider.when('/layout/paymentTypeMain', '/layout/paymentTypeMain/paymentTypeList');
        $urlRouterProvider.when('/layout/corporateMain', '/layout/corporateMain/corporate');
        $urlRouterProvider.when('/layout/typeOfServiceMain', '/layout/typeOfServiceMain/services');
        $urlRouterProvider.when('/layout/vehicleTypeMain', '/layout/vehicleTypeMain/vehicle');
        $urlRouterProvider.when('/layout/agreementMain', '/layout/agreementMain/agreement');
        $urlRouterProvider.when('/layout/assignedCarsMain', '/layout/assignedCarsMain/assignedCarList');
        $urlRouterProvider.when('/layout/branchMain', '/layout/branchMain/branchList');
        $urlRouterProvider.when('/layout/heatMapMain', '/layout/heatMapMain/heatMap');
        $urlRouterProvider.when('/layout/fixedRouteGeofenceMain', '/layout/fixedRouteGeofenceMain/fixedRouteGeofenceList');
        $urlRouterProvider.when('/layout/illuminatedZoneMain', '/layout/illuminatedZoneMain/illuminatedZone');
        $urlRouterProvider.when('/layout/fixedRouteMain', '/layout/fixedRouteMain/fixedRouteList');
        $urlRouterProvider.when('/layout/createBookingMain', '/layout/createBookingMain/createBooking/{id}');
        $urlRouterProvider.when('/layout/massiveCreateBookingMain', '/layout/massiveCreateBookingMain/massiveCreateBooking');
        $urlRouterProvider.when('/layout/createBookingHereMapsMain', '/layout/createBookingHereMapsMain/createBookingHereMaps/{id}');
        $urlRouterProvider.when('/layout/newMassiveCreateBookingMain', '/layout/newMassiveCreateBookingMain/newMassiveCreateBooking');
        $urlRouterProvider.when('/layout/massiveCreateBookingNewpageMain', '/layout/massiveCreateBookingNewpageMain/massiveCreateBookingNewpage/{id}');
        $urlRouterProvider.when('/layout/massiveModifyBookingNewpageMain', '/layout/massiveModifyBookingNewpageMain/massiveModifyBookingNewpage/{id}');
        $urlRouterProvider.when('/layout/itemOfChargeMain', '/layout/itemOfChargeMain/itemOfChargeList');
        $urlRouterProvider.when('/layout/cancelReasonMain', '/layout/cancelReasonMain/cancelReason');
        $urlRouterProvider.when('/layout/customersMain', '/layout/customersMain/customers');
        $urlRouterProvider.when('/layout/illuminatedZoneServicesMain', '/layout/illuminatedZoneServicesMain/illuminatedZoneServices');
        $urlRouterProvider.when('/layout/illuminatedZoneServicesNewPageMain', '/layout/illuminatedZoneServicesNewPageMain/illuminatedZoneServicesNewPage');
        $urlRouterProvider.when('/layout/massiveCreatePackageNewpageMain', '/layout/massiveCreatePackageNewpageMain/massiveCreatePackageNewScreen/{id}');
        $urlRouterProvider.when('/layout/driverEarningMain', '/layout/driverEarningMain/driverEarning');
        $urlRouterProvider.when('/layout/communaMain', '/layout/communaMain/communa');
        $urlRouterProvider.when('/layout/promoCodeMain', '/layout/promoCodeMain/promoList');
        $urlRouterProvider.when('/layout/couponMain', '/layout/couponMain/couponList');
        $urlRouterProvider.when('/layout/binMain', '/layout/binMain/binList');
        $urlRouterProvider.when('/layout/adminRolesMain', '/layout/adminRolesMain/adminRolesList');
        $urlRouterProvider.when('/layout/adminUsersMain', '/layout/adminUsersMain/adminUsersList');
        $urlRouterProvider.when('/layout/globalParametersMain', '/layout/globalParametersMain/globalParameters');
        $urlRouterProvider.when('/layout/summaryProductionMain', '/layout/summaryProductionMain/summaryProduction');
        $urlRouterProvider.when('/layout/vehicleBalanceReportMain', '/layout/vehicleBalanceReportMain/vehicleBalanceReport');
        $urlRouterProvider.when('/layout/detailedProductionMain', '/layout/detailedProductionMain/detailedProduction');
        $urlRouterProvider.when('/layout/itemOfChargeCsvMain', '/layout/itemOfChargeCsvMain/itemOfChargeCsv');
        $urlRouterProvider.when('/layout/onOffDutyMain', '/layout/onOffDutyMain/onOffDuty');
        $urlRouterProvider.when('/layout/correctFareReasonMain', '/layout/correctFareReasonMain/correctFareReason');
        $urlRouterProvider.when('/layout/noShowReasonMain', '/layout/noShowReasonMain/noShowReason');
        $urlRouterProvider.when('/layout/generatePaymentStatusMain', '/layout/generatePaymentStatusMain/generatePaymentStatus');
        $urlRouterProvider.when('/layout/controlledWayMain', '/layout/controlledWayMain/controlledWay');
        $urlRouterProvider.when('/layout/gaussControlMain', '/layout/gaussControlMain/gaussControl');
        $urlRouterProvider.when('/layout/autoAssignMain', '/layout/autoAssignMain/autoAssign');
        $urlRouterProvider.when('/layout/cierroPeriodeMain', '/layout/cierroPeriodeMain/cierroPeriode');
        $urlRouterProvider.when('/layout/abrirPeriodoMain', '/layout/abrirPeriodoMain/abrirPeriodo');
        $urlRouterProvider.when('/layout/operationalReportMain', '/layout/operationalReportMain/operationalReport');
        $urlRouterProvider.when('/layout/rejectedBookingMain', '/layout/rejectedBookingMain/rejectedBooking');
        $urlRouterProvider.when('/layout/searchBookingMain', '/layout/searchBookingMain/searchBooking');
        $urlRouterProvider.when('/layout/helpDocMain', '/layout/helpDocMain/helpDocs');
        $urlRouterProvider.when('/layout/driverEvaluationMain', '/layout/driverEvaluationMain/driverEvaluation');
        $urlRouterProvider.when('/layout/operationPointMain', '/layout/operationPointMain/operationPoint');
        $urlRouterProvider.when('/layout/operationPointUserMain', '/layout/operationPointUserMain/operationPointUser');
        $urlRouterProvider.when('/layout/quickSaleMain', '/layout/quickSaleMain/quickSale');
        $urlRouterProvider.when('/layout/illuminatedZoneServicesLogMain', '/layout/illuminatedZoneServicesLogMain/illuminatedZoneServicesLog');
        $urlRouterProvider.when('/layout/sharedRouteAssignmentMain', '/layout/sharedRouteAssignmentMain/sharedRouteAssignment');
        $urlRouterProvider.when('/layout/groupedRouteAssignmentMain', '/layout/groupedRouteAssignmentMain/groupedRouteAssignment');
        $urlRouterProvider.when('/layout/sharedGroupMain', '/layout/sharedGroupMain/sharedGroup');
        $urlRouterProvider.when('/layout/specialDirectionsMain', '/layout/specialDirectionsMain/specialDirections');
        $urlRouterProvider.when('/layout/expenseControlMain', '/layout/expenseControlMain/expenseControl');
        $urlRouterProvider.when('/layout/expenseControlReportMain', '/layout/expenseControlReportMain/expenseControlReport');
        $urlRouterProvider.when('/layout/newMessageMain', '/layout/newMessageMain/newMessage');
        $urlRouterProvider.when('/layout/groupDriversMain', '/layout/groupDriversMain/groupDrivers');
        $urlRouterProvider.when('/layout/historyMessageMain', '/layout/historyMessageMain/historyMessage');
        $urlRouterProvider.when('/layout/mailDriverMain', '/layout/mailDriverMain/mailDriver');
        $urlRouterProvider.when('/layout/selfAssignmentMain', '/layout/selfAssignmentMain/selfAssignment');
        $urlRouterProvider.when('/layout/fleetCapacityMatrixMain', '/layout/fleetCapacityMatrixMain/fleetCapacityMatrix');
        $urlRouterProvider.when('/layout/fleetCapacityMatrixMain', '/layout/fleetCapacityMatrixMain/fleetCapacityMatrixDetail');
        $urlRouterProvider.when('/layout/fleetCapacityMatrixMain', '/layout/fleetCapacityMatrixMain/fleetCapacityMatrixCreate');
        $urlRouterProvider.when('/layout/fleetCapacityMatrixMain', '/layout/fleetCapacityMatrixMain/fleetCapacityMatrixEdit');
        $urlRouterProvider.when('/layout/fleetCapacityMatrixMain', '/layout/fleetCapacityMatrixMain/fleetCapacityMatrixExceptions');
        $urlRouterProvider.when('/layout/fleetCapacityMatrixMain', '/layout/fleetCapacityMatrixMain/fleetCapacityMatrixCalendar');
        $urlRouterProvider.when('/layout/factorMultiplicadorMain', '/layout/factorMultiplicadorMain/factorMultiplicador');
        // $urlRouterProvider.when('/layout/groupMassiveQuickassignmentMain', '/layout/groupMassiveQuickassignmentMain/groupMassiveQuickassignment');

        function callAccessGiven(data, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies, $stateParams) {
            console.log(JSON.parse($cookies.get('adminType') || 0), 'type');

            var promise = adminAccessService.checkStateValid(data); //$stateParams.id
            promise.then(
                function (payload) {
                    console.log(payload)
                    adminAccessService.getPreviousState();
                    if (payload.title.status == 400) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 0);
                        return false;
                    } else if (payload.title.status == 401) {
                        errorMessageFactory.showErrorMessage(payload.title.message, 2, 'home');
                        return false;
                    } else if (payload.title.status == 201 || payload.title.status == 200) {
                        if (!payload.title.data.granted) {
                            console.log('debug data', data);
                            if (data === 'Editar Matriz de Control Gauss Control') {
                                errorMessageFactory.showErrorMessage('Acceso no autorizado', 2, $rootScope.previousState);
                            }
                            else {
                                errorMessageFactory.showErrorMessage('No tiene permiso para ejecutar esta opción', 2, $rootScope.previousState);
                            }
                            return true;
                        }
                        if (payload.title.data.forceUpdate) {
                            if (intervalFuncation) {

                            } else {
                                intervalFuncation = $interval(function () {
                                    var confirm = $mdDialog.confirm()
                                        .title(' Hay una nueva versión, ¿quieres actualizar ahora?')
                                        .textContent('')
                                        .ariaLabel('Lucky day')
                                        // .targetEvent($event)
                                        .ok('Confirmar')
                                        .cancel('Cancelar');

                                    $mdDialog.show(confirm).then(function () {
                                        location.reload(true);
                                    }, function () { });
                                    // var alert = $mdDialog.alert({
                                    //     title: 'Hay una nueva versión, ¿quieres actualizar ahora?',
                                    //     textContent: '',
                                    //     ok: 'Confirmar'
                                    // });
                                    // $mdDialog
                                    //     .show(alert)
                                    //     .finally(function () {
                                    //         location.reload(true);
                                    //     });
                                }, 600000);
                            }
                        }
                    }
                },
                function (errorPayload) {
                    console.log(errorPayload);
                    if (errorPayload.data.status == 401) {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 2, 'home');
                    } else {
                        errorMessageFactory.showErrorMessage(errorPayload.data.message, 0);
                    }
                }
            );
        }

        $stateProvider
            .state('home', {
                url: '/',
                title: "Iniciar sesión",
                templateUrl: 'app/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm'
            })
            .state('resetPassword', {
                url: '/resetPassword/{type}/{id}/{lang}',
                title: "Reset Password",
                templateUrl: 'app/resetPassword/resetPassword.html',
                controller: 'ResetPasswordController',
                controllerAs: 'vm'
            })
            .state('driverRating', {
                url: '/driverRating/{id}/{job_id}/{verify_tokan}',
                title: "Driver Rating",
                templateUrl: 'app/driverRating/driverRating.html',
                controller: 'DriverRatingController',
                controllerAs: 'vm'
            })
            .state('forgetPassword', {
                url: '/forgetPassword',
                title: "Forget Password",
                templateUrl: 'app/forgotPassword/forgotPassword.html',
                controller: 'ForgetPasswordController',
                controllerAs: 'vm'
            })
            .state('layout', {
                url: '/layout',
                title: "Layout",
                templateUrl: 'app/components/innerLayout/app.html',
                controller: 'AppController',
                controllerAs: 'vm'
            })
            .state('layout.homeScreenMain', {
                url: '/homeScreenMain',
                title: 'Home Screen Main',
                templateUrl: 'app/components/views/home-screen/homeScreenMain.html'
            })
            .state('layout.homeScreenMain.homeScreen', {
                url: '/homeScreen',
                title: "Pantalla de inicio",
                templateUrl: 'app/components/views/home-screen/homeScreen.html',
                controller: 'HomeScreenController',
                controllerAs: 'vm',
                // resolve: {
                //     getAccessApplicant : function($state,$stateParams,$rootScope,adminAccessService, errorMessageFactory , $mdDialog , $interval , $cookies){
                //         callAccessGiven('',$rootScope,adminAccessService, errorMessageFactory , $mdDialog , $interval , $cookies);
                //     }
                // }
            })
            .state('layout.dashboardMain', {
                url: '/dashboardMain',
                title: 'Dashboard Main',
                templateUrl: 'app/components/views/dashboard/dashboardMain.html'
            })
            .state('layout.dashboardMain.dashboard', {
                url: '/dashboard',
                title: "Dashboard",
                templateUrl: 'app/components/views/dashboard/dashboard.html',
                controller: 'DashboardController',
                controllerAs: 'vm',
                resolve: {
                    getAccessDashboard: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Dashboard', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.applicantsMain', {
                url: '/applicantsMain',
                title: 'Applicants Main',
                templateUrl: 'app/components/views/applicants/applicantsMain.html'
            })
            .state('layout.applicantsMain.applicants', {
                url: '/applicants',
                title: "Applicants",
                templateUrl: 'app/components/views/applicants/applicants.html',
                controller: 'ApplicantsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessApplicant: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Applicants', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.applicantsMain.applicantsDetails', {
                url: '/applicantsDetails/{id}',
                title: "Applicant Details",
                templateUrl: 'app/components/views/applicants/applicantDetails.html',
                controller: 'ApplicantDetailsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessApplicantDetails: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Applicant Details', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.applicantsMain.registerApplicant', {
                url: '/registerApplicants',
                title: "Register Applicants",
                templateUrl: 'app/components/views/applicants/registerApplicants.html',
                controller: 'RegisterApplicantController',
                controllerAs: 'vm',
                resolve: {
                    getAccessApplicantRegister: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Register Applicants', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.applicantsMain.applicantsApproval', {
                url: '/applicantsApproval/{id}',
                title: "Applicant Approval",
                templateUrl: 'app/components/views/applicants/applicantApprovalProcess.html',
                controller: 'ApplicantApprovalProcessController',
                controllerAs: 'vm',
                resolve: {
                    getAccessApplicantApproval: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Applicant Approval', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.applicantsMain.editApplicantsDetails', {
                url: '/editApplicantsDetails/{id}',
                title: "Edit Applicant Details",
                templateUrl: 'app/components/views/applicants/editApplicantDetails.html',
                controller: 'EditApplicantDetailsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessApplicantEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Edit Applicant Details', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.applicantsMain.adminLogs', {
                url: '/adminLogs/{userId}/{type}/{fakeType}',
                title: "Applicants Admin Logs",
                templateUrl: 'app/components/views/admin-role/getAdminSysLogs.html',
                controller: 'AdminLogsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessApplicantEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Applicants Admin Logs', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })

            .state('layout.approvedDriverMain', {
                url: '/approvedDriverMain',
                title: 'Approve Driver Main',
                templateUrl: 'app/components/views/approved-driver/approveDriverMain.html'
            })
            .state('layout.approvedDriverMain.approvedDriver', {
                url: '/approvedDriver',
                title: "Approved Driver",
                templateUrl: 'app/components/views/approved-driver/approvedDriver.html',
                controller: 'ApprovedDriverController',
                controllerAs: 'vm',
                resolve: {
                    getAccessDriver: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Approved Driver', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.approvedDriverMain.driverDetails', {
                url: '/driverDetails/{id}/{path}',
                title: "Approved Driver Details",
                templateUrl: 'app/components/views/approved-driver/driverDetails.html',
                controller: 'DriverDetailsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessDriverDetails: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Approved Driver Details', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.approvedDriverMain.editDriverDetails', {
                url: '/editDriverDetails/{id}/{path}',
                title: "Edit Approved Driver Details",
                templateUrl: 'app/components/views/approved-driver/editDriverDetails.html',
                controller: 'EditDriverDetailsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessDriverEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Edit Approved Driver Details', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.approvedDriverMain.adminLogs', {
                url: '/adminLogs/{userId}/{type}/{fakeType}',
                title: "Drivers Admin Logs",
                templateUrl: 'app/components/views/admin-role/getAdminSysLogs.html',
                controller: 'AdminLogsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessApplicantEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Drivers Admin Logs', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.approvedInvestorsMain', {
                url: '/approvedInvestorsMain',
                title: 'Approved Investors Main',
                templateUrl: 'app/components/views/approved-investor/approvedCarInvestorMain.html'
            })
            .state('layout.approvedInvestorsMain.approvedInvestor', {
                url: '/approvedInvestor',
                title: "Approved Investor",
                templateUrl: 'app/components/views/approved-investor/approvedCarInvestor.html',
                controller: 'ApprovedInvestorController',
                controllerAs: 'vm',
                resolve: {
                    getAccessInvestor: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Approved Investor', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.approvedInvestorsMain.investorDetails', {
                url: '/investorDetails/{id}/{path}',
                title: "Approved Investor Details",
                templateUrl: 'app/components/views/approved-investor/carInvestorDetails.html',
                controller: 'InvestorDetailsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessInvestorDetails: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Approved Investor Details', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.approvedInvestorsMain.editInvestorDetails', {
                url: '/editInvestorDetails/{id}/{path}',
                title: "Edit Approved Investor Details",
                templateUrl: 'app/components/views/approved-investor/editCarInvestorDetails.html',
                controller: 'EditInvestorDetailsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessInvestorEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Edit Approved Investor Details', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.approvedInvestorsMain.adminLogs', {
                url: '/adminLogs/{userId}/{type}/{fakeType}',
                title: "Investor Admin Logs",
                templateUrl: 'app/components/views/admin-role/getAdminSysLogs.html',
                controller: 'AdminLogsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessApplicantEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Investor Admin Logs', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.approvedInvestorsMain.addCars', {
                url: '/addCars/{id}/{path}',
                title: "Add More Cars For Investor",
                templateUrl: 'app/components/views/approved-investor/addMoreCars.html',
                controller: 'AddMoreCarController',
                controllerAs: 'vm',
                resolve: {
                    getAccessInvestorCars: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Add More Cars For Investor', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.customersMain', {
                url: '/customersMain',
                title: "Customer Main",
                templateUrl: 'app/components/views/customer/customerMain.html'
            })
            .state('layout.customersMain.customers', {
                url: '/customers',
                title: "Customers",
                templateUrl: 'app/components/views/customer/customer.html',
                controller: 'CustomerController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCustomers: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Customers', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.customersMain.customerRegister', {
                url: '/customerRegister',
                title: "Register Customer",
                templateUrl: 'app/components/views/customer/registerCustomer.html',
                controller: 'RegisterCustomerController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCustomersRegister: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Register Customer', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.customersMain.customerDetails', {
                url: '/customerDetails/{id}',
                title: "Customer Details",
                templateUrl: 'app/components/views/customer/customerDetails.html',
                controller: 'CustomerDetailsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCustomersDetails: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Customer Details', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.customersMain.editCustomerDetails', {
                url: '/editCustomerDetails/{id}',
                title: "Edit Customer Details",
                templateUrl: 'app/components/views/customer/editCustomerDetails.html',
                controller: 'EditCustomerDetailsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCustomersEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Edit Customer Details', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.customersMain.adminLogs', {
                url: '/adminLogs/{userId}/{type}/{fakeType}',
                title: "Customer Admin Logs",
                templateUrl: 'app/components/views/admin-role/getAdminSysLogs.html',
                controller: 'AdminLogsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessApplicantEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Customer Admin Logs', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.illuminatedZoneServicesMain', {
                url: '/illuminatedZoneServicesMain',
                title: "Illuminated Zone Services Main",
                templateUrl: 'app/components/views/illuminated-zone-services/illuminatedZoneServicesMain.html'
            })
            .state('layout.illuminatedZoneServicesMain.illuminatedZoneServices', {
                url: '/illuminatedZoneServices',
                title: "Illuminated Zone Services",
                templateUrl: 'app/components/views/illuminated-zone-services/illuminatedZoneServices.html',
                controller: 'IlluminatedZoneServicesController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCustomers: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Illuminated Zone Services', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.illuminatedZoneServicesNewPageMain', {
                url: '/illuminatedZoneServicesNewPageMain',
                title: "Illuminated Zone Services New Page Main",
                templateUrl: 'app/components/views/illuminated-zone-services/illuminatedZoneServicesNewPageMain.html'
            })
            .state('layout.illuminatedZoneServicesNewPageMain.illuminatedZoneServicesNewPage', {
                url: '/illuminatedZoneServicesNewPage',
                title: "Illuminated Zone Services",
                templateUrl: 'app/components/views/illuminated-zone-services/illuminatedZoneServicesNewPage.html',
                controller: 'IlluminatedZoneServicesNewPageController',
                controllerAs: 'vm',
                // resolve: {
                //     getAccessCustomers: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                //         callAccessGiven('Illuminated Zone Services', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                //     }
                // }
            })
            .state('layout.illuminatedZoneServicesLogMain', {
                url: '/illuminatedZoneServicesLogMain',
                title: "Illuminated Zone Services Log Main",
                templateUrl: 'app/components/views/illuminated-zone-services/illuminatedZoneServiceLogMain.html'
            })
            .state('layout.illuminatedZoneServicesLogMain.illuminatedZoneServicesLog', {
                url: '/illuminatedZoneServicesLog',
                title: "Illuminated Zone Services Log",
                templateUrl: 'app/components/views/illuminated-zone-services/illuminatedZoneServiceLog.html',
                controller: 'IlluminatedZoneServicesLogController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCustomers: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Illuminated Zone Services Log', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })

            .state('layout.quickSaleMain', {
                url: '/quickSaleMain',
                title: 'Quick Sale Main',
                templateUrl: 'app/components/views/quickSale/quickSaleMain.html'
            })
            .state('layout.quickSaleMain.quickSale', {
                url: '/quickSale',
                title: 'Quick Sale',
                templateUrl: 'app/components/views/quickSale/quickSale.html',
                controller: 'QuickSaleController',
                controllerAs: 'vm',
                resolve: {
                    getAccessUpcoming: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Quick Sale', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.sharedRouteAssignmentMain', {
                url: '/sharedRouteAssignmentMain',
                title: 'Shared Route Assignment Main',
                templateUrl: 'app/components/views/shared-service/sharedServiceRouteAssignmentMain.html'
            })
            .state('layout.sharedRouteAssignmentMain.sharedRouteAssignment', {
                url: '/sharedRouteAssignment',
                title: 'Shared Route Assignment',
                templateUrl: 'app/components/views/shared-service/sharedServiceRouteAssignment.html',
                controller: 'SharedRouteAssignmentController',
                controllerAs: 'vm',
                resolve: {
                    getAccessUpcoming: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Shared Route Assignment', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.groupedRouteAssignmentMain', {
                url: '/groupedRouteAssignmentMain',
                title: 'Grouped Route Assignment Main',
                templateUrl: 'app/components/views/grouped-route-assignment/groupedRouteAssignmentMain.html'
            })
            .state('layout.groupedRouteAssignmentMain.groupedRouteAssignment', {
                url: '/groupedRouteAssignment',
                title: 'Grouped Route Assignment',
                templateUrl: 'app/components/views/grouped-route-assignment/groupedRouteAssignment.html',
                controller: 'GroupedRouteAssignmentController',
                controllerAs: 'vm',
                resolve: {
                    getAccessUpcoming: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Grouped Route Assignment', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })

            .state('layout.upcomingBookingsMain', {
                url: '/upcomingBookingsMain',
                title: 'Upcoming Bookings Main',
                templateUrl: 'app/components/views/booking-list/upcomingBookingsMain.html'
            })
            .state('layout.upcomingBookingsMain.upcomingBookings', {
                url: '/upcomingBookings',
                title: 'Upcoming Bookings',
                templateUrl: 'app/components/views/booking-list/upcomingBookings.html',
                controller: 'UpcomingBookingsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessUpcoming: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Upcoming Bookings', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.quickAssignmentMain', {
                url: '/quickAssignmentMain',
                title: 'Quick Assignment Main',
                templateUrl: 'app/components/views/booking-list/quickAssignmentMain.html'
            })
            .state('layout.quickAssignmentMain.quickAssignment', {
                url: '/quickAssignment',
                title: 'Quick Assignment',
                templateUrl: 'app/components/views/booking-list/quickAssignment.html',
                controller: 'QuickAssignmentController',
                controllerAs: 'vm',
                resolve: {
                    getAccessUpcoming: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Upcoming Bookings', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.massiveQuickassignmentMain', {
                url: '/massiveQuickassignmentMain',
                title: 'Massive Quick Assignment Main',
                templateUrl: 'app/components/views/booking-list/massiveQuickassignmentMain.html'
            })
            .state('layout.massiveQuickassignmentMain.massiveQuickassignment', {
                url: '/massiveQuickassignment',
                title: 'Massive Quick Assignment',
                templateUrl: 'app/components/views/booking-list/massiveQuickassignment.html',
                controller: 'MassiveQuickassignmentController',
                controllerAs: 'vm',
                resolve: {
                    getAccessUpcoming: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Upcoming Bookings', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.upcomingBookingsMain.upcomingBookingDetailsNew', {
                url: '/upcomingBookingDetailsNew/{id}/{type}',
                title: 'Upcoming Bookings Details',
                templateUrl: 'app/components/views/booking-list/bookingDetailsNew.html',
                controller: 'BookingDetailsControllerNew',
                controllerAs: 'vm',
                resolve: {
                    getAccessOngoing: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Upcoming Bookings Details', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.upcomingBookingsMain.modifyBooking', {
                url: '/modifyBooking/{id}/{custId}',
                title: "Modify Booking",
                templateUrl: 'app/components/views/create-booking/createBooking.html',
                controller: 'CreateBookingController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCreateBooking: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Modify Booking', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.ongoingBookingsMain', {
                url: '/ongoingBookingsMain',
                title: 'Ongoing Bookings Main',
                templateUrl: 'app/components/views/booking-list/ongoingBookingsMain.html'
            })
            .state('layout.ongoingBookingsMain.ongoingBookings', {
                url: '/ongoingBookings',
                title: 'Ongoing Bookings',
                templateUrl: 'app/components/views/booking-list/ongoingBookings.html',
                controller: 'OngoingBookingsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessOngoing: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Ongoing Bookings', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.ongoingBookingsMain.ongoingBookingDetailsNew', {
                url: '/ongoingBookingDetailsNew/{id}/{type}',
                title: 'Ongoing Bookings Details',
                templateUrl: 'app/components/views/booking-list/bookingDetailsNew.html',
                controller: 'BookingDetailsControllerNew',
                controllerAs: 'vm',
                resolve: {
                    getAccessOngoing: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Ongoing Bookings Details', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.completedBookingsMain', {
                url: '/completedBookingsMain',
                title: 'Completed Bookings Main',
                templateUrl: 'app/components/views/booking-list/completedBookingsMain.html'
            })
            .state('layout.completedBookingsMain.completedBookings', {
                url: '/completedBookings',
                title: 'Completed Bookings',
                templateUrl: 'app/components/views/booking-list/completedBookings.html',
                controller: 'CompletedBookingsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCompleted: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Completed Bookings', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.completedBookingsMain.completedBookingDetailsNew', {
                url: '/completedBookingDetailsNew/{id}/{type}',
                title: 'Completed Bookings Details',
                templateUrl: 'app/components/views/booking-list/bookingDetailsNew.html',
                controller: 'BookingDetailsControllerNew',
                controllerAs: 'vm',
                resolve: {
                    getAccessOngoing: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Completed Bookings Details', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.searchBookingMain', {
                url: '/searchBookingMain',
                title: 'Search Booking Main',
                templateUrl: 'app/components/views/booking-list/searchBookingMain.html'
            })
            .state('layout.searchBookingMain.searchBooking', {
                url: '/searchBooking',
                title: 'Search Booking',
                templateUrl: 'app/components/views/booking-list/searchBooking.html',
                controller: 'SearchBookingController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCompleted: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Search Booking', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })

            .state('layout.searchBookingMain.searchBookingDetailsNew', {
                url: '/searchBookingDetailsNew/{id}/{type}',
                title: 'Search Bookings Details',
                templateUrl: 'app/components/views/booking-list/bookingDetailsNew.html',
                controller: 'BookingDetailsControllerNew',
                controllerAs: 'vm',
                resolve: {
                    getAccessOngoing: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Search Bookings Details', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.searchBookingMain.modifyBooking', {
                url: '/modifyBooking/{id}/{custId}',
                title: "Search Modify Booking",
                templateUrl: 'app/components/views/create-booking/createBooking.html',
                controller: 'CreateBookingController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCreateBooking: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Search Modify Booking', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.sharedGroupMain', {
                url: '/sharedGroupMain',
                title: 'Shared Group Main',
                templateUrl: 'app/components/views/booking-list/sharedGroupedListMain.html'
            })
            .state('layout.sharedGroupMain.sharedGroup', {
                url: '/sharedGroup',
                title: 'Shared Group',
                templateUrl: 'app/components/views/booking-list/sharedGroupedList.html',
                controller: 'SharedGroupListController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCompleted: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Shared Group', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.carMain', {
                url: '/carMain',
                title: 'Cars Main',
                templateUrl: 'app/components/views/cars-list/carsMain.html'
            })
            .state('layout.carMain.carsList', {
                url: '/carsList',
                title: 'Cars List',
                templateUrl: 'app/components/views/cars-list/carsList.html',
                controller: 'CarsListController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCars: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Cars List', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.carColorsMain', {
                url: '/carColorsMain',
                title: 'Cars Colors Main',
                templateUrl: 'app/components/views/cars-list/carColorsMain.html'
            })
            .state('layout.carColorsMain.carColors', {
                url: '/carColors',
                title: 'Cars colors',
                templateUrl: 'app/components/views/cars-list/carColors.html',
                controller: 'CarsColorController',
                controllerAs: 'vm',
                // resolve: {
                //     getAccessCars: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                //         callAccessGiven('Cars List', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                //     }
                // }
            })
            .state('layout.carModelsMain', {
                url: '/carModelsMain',
                title: 'Cars Models Main',
                templateUrl: 'app/components/views/cars-list/carModelsMain.html'
            })
            .state('layout.carModelsMain.carModels', {
                url: '/carModels',
                title: 'Cars Models',
                templateUrl: 'app/components/views/cars-list/carModels.html',
                controller: 'CarsModelsController',
                controllerAs: 'vm',
                // resolve: {
                //     getAccessCars: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                //         callAccessGiven('Cars List', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                //     }
                // }
            })
            .state('layout.vechicleBalanceMain', {
                url: '/vechicleBalanceMain',
                title: 'vechicle mains',
                templateUrl: 'app/components/views/cars-list/vechicleBalanceMain.html'
            })
            .state('layout.vechicleBalanceMain.vechicleBalance', {
                url: '/vechicleBalance',
                title: 'Parámetros BMP',
                templateUrl: 'app/components/views/cars-list/vechicleBalance.html',
                controller: 'VechicleBalanceController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCars: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Parámetros BMP', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.carMain.viewCarDetails', {
                url: '/viewCarDetails/{id}',
                title: 'View Car Details',
                templateUrl: 'app/components/views/cars-list/viewCarDetails.html',
                controller: 'ViewCarDetailsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCars: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('View Car Details', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.carMain.assignDriver', {
                url: '/assignDriver/{id}/{carType}/{carNumber}',
                title: "Assign Driver To Car",
                templateUrl: 'app/components/views/cars-list/assignCarToDriver.html',
                controller: 'AssignDriverToCarController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCarsAssign: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Assign Driver To Car', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.carMain.unassignDriver', {
                url: '/unassignDriver/{id}/{carType}/{carNumber}',
                title: "Unassign Driver To Car",
                templateUrl: 'app/components/views/cars-list/unassignCarToDriver.html',
                controller: 'UnassignDriverToCarController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCarsUnassign: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Unassign Driver To Car', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.carMain.adminLogs', {
                url: '/adminLogs/{userId}/{type}/{fakeType}',
                title: "Cars Admin Logs",
                templateUrl: 'app/components/views/admin-role/getAdminSysLogs.html',
                controller: 'AdminLogsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessApplicantEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Cars Admin Logs', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.branchMain', {
                url: '/branchMain',
                title: "Branch Main",
                templateUrl: 'app/components/views/geofence/branchMain.html'
            })
            .state('layout.branchMain.branchList', {
                url: '/branchList',
                title: "Branch List",
                templateUrl: 'app/components/views/geofence/branchList.html',
                controller: 'BranchListController',
                controllerAs: 'vm',
                resolve: {
                    getAccessBranch: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Branch List', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.heatMapMain', {
                url: '/heatMapMain',
                title: "HeatMap Main",
                templateUrl: 'app/components/views/geofence/heatMapMain.html'
            })
            .state('layout.heatMapMain.heatMap', {
                url: '/heatMap',
                title: "Mapa de calor",
                templateUrl: 'app/components/views/geofence/heatMap.html',
                controller: 'HeatMapController',
                controllerAs: 'vm',
                resolve: {
                    getAccessBranch: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Mapa de calor', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.heatMapMain.adminLogs', {
                url: '/adminLogs/{userId}/{type}/{fakeType}',
                title: "Branch Admin Logs",
                templateUrl: 'app/components/views/admin-role/getAdminSysLogs.html',
                controller: 'AdminLogsController',
                controllerAs: 'vm'
                // resolve: {
                //     getAccessApplicantEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                //         // callAccessGiven('Branch Admin Logs', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                //     }
                // }
            })
            .state('layout.branchMain.adminLogs', {
                url: '/adminLogs/{userId}/{type}/{fakeType}',
                title: "Branch Admin Logs",
                templateUrl: 'app/components/views/admin-role/getAdminSysLogs.html',
                controller: 'AdminLogsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessApplicantEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Branch Admin Logs', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.fixedRouteGeofenceMain', {
                url: '/fixedRouteGeofenceMain',
                title: "Fixed Route Geofence Main",
                templateUrl: 'app/components/views/geofence/fixedRouteGeofenceMain.html'
            })
            .state('layout.fixedRouteGeofenceMain.fixedRouteGeofenceList', {
                url: '/fixedRouteGeofenceList',
                title: "Fixed Route Geofence List",
                templateUrl: 'app/components/views/geofence/fixedRouteGeofenceList.html',
                controller: 'FixedRouteGeofenceListController',
                controllerAs: 'vm',
                resolve: {
                    getAccessFixedRoute: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Fixed Route Geofence List', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.illuminatedZoneMain', {
                url: '/illuminatedZoneMain',
                title: "Illuminated Zone Main",
                templateUrl: 'app/components/views/geofence/illuminatedZoneMain.html'
            })
            .state('layout.illuminatedZoneMain.illuminatedZone', {
                url: '/illuminatedZone',
                title: "Illuminated Zone",
                templateUrl: 'app/components/views/geofence/illuminatedZone.html',
                controller: 'IlluminatedZoneController',
                controllerAs: 'vm',
                resolve: {
                    getAccessFixedRoute: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Illuminated Zone', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.fixedRouteGeofenceMain.adminLogs', {
                url: '/adminLogs/{userId}/{type}/{fakeType}',
                title: "Fixed Route Geofence Admin Logs",
                templateUrl: 'app/components/views/admin-role/getAdminSysLogs.html',
                controller: 'AdminLogsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessApplicantEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Fixed Route Geofence Admin Logs', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.specialDirectionsMain', {
                url: '/specialDirectionsMain',
                title: 'Direcciones Especiales Main',
                templateUrl: 'app/components/views/special-directions/specialDirectionsMain.html'
            })
            .state('layout.specialDirectionsMain.specialDirections', {
                url: '/specialDirections',
                title: "Direcciones Especiales",
                templateUrl: 'app/components/views/special-directions/specialDirections.html',
                controller: 'SpecialDirectionsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessApplicant: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Direcciones Especiales', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.fixedRouteMain', {
                url: '/fixedRouteMain',
                title: "Fixed Route Main",
                templateUrl: 'app/components/views/geofence/fixedRouteMain.html'
            })
            .state('layout.fixedRouteMain.fixedRouteList', {
                url: '/fixedRouteList',
                title: "Fixed Route List",
                templateUrl: 'app/components/views/geofence/fixedRouteList.html',
                controller: 'FixedRouteListController',
                controllerAs: 'vm',
                resolve: {
                    getAccessFixedRouteList: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Fixed Route List', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.fixedRouteMain.viewFixedRoute', {
                url: '/viewFixedRoute/{id}',
                title: "View Fixed Route",
                templateUrl: 'app/components/views/geofence/viewFixedRouteDetails.html',
                controller: 'ViewFixedRouteListController',
                controllerAs: 'vm',
                resolve: {
                    getAccessFixedRouteList: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('View Fixed Route', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.fixedRouteMain.adminLogs', {
                url: '/adminLogs/{userId}/{type}/{fakeType}',
                title: "Fixed Route Admin Logs",
                templateUrl: 'app/components/views/admin-role/getAdminSysLogs.html',
                controller: 'AdminLogsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessApplicantEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Fixed Route Admin Logs', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.autoAssignMain.adminLogs', {
                url: '/adminLogs/{userId}/{type}/{fakeType}',
                title: "Auto Assignment Geofence Admin Logs",
                templateUrl: 'app/components/views/admin-role/getAdminSysLogs.html',
                controller: 'AdminLogsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessApplicantEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Auto Assignment Geofence Admin Logs', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.createBookingMain', {
                url: '/createBookingMain',
                title: "Create Booking Main",
                templateUrl: 'app/components/views/create-booking/createBookingMain.html'
            })
            .state('layout.createBookingMain.createBooking', {
                url: '/createBooking/{id}',
                title: "Create Booking",
                templateUrl: 'app/components/views/create-booking/createBooking.html',
                controller: 'CreateBookingController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCreateBooking: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Create Booking', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.createBookingHereMapsMain', {
                url: '/createBookingHereMapsMain',
                title: "Create Booking Here Maps Main",
                templateUrl: 'app/components/views/create-booking-here-maps/createBookingHereMapsMain.html'
            })
            .state('layout.createBookingHereMapsMain.createBookingHereMaps', {
                url: '/createBookingHereMaps/{id}',
                title: "Create Booking Here Maps",
                templateUrl: 'app/components/views/create-booking-here-maps/createBookingHereMaps.html',
                controller: 'CreateBookingControllerHereMaps',
                controllerAs: 'vm',
                resolve: {
                    getAccessCreateBooking: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Create Booking Here Maps', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.massiveCreateBookingMain', {
                url: '/massiveCreateBookingMain',
                title: "Massive Create Booking Main",
                templateUrl: 'app/components/views/massive-create-booking/massiveCreateBookingNewMain.html'
            })
            .state('layout.massiveCreateBookingMain.massiveCreateBooking', {
                url: '/massiveCreateBooking',
                title: "Administración Masiva",
                templateUrl: 'app/components/views/massive-create-booking/massiveCreateBooking.html',
                controller: 'MassiveCreateBookingController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCreateBooking: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Administración Masiva', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.massiveCreateBookingNewpageMain', {
                url: '/massiveCreateBookingNewpageMain',
                title: "Massive Create Booking New Page Main",
                templateUrl: 'app/components/views/massive-create-booking-new-page/massiveCreateBookingNewpageMain.html'
            })
            .state('layout.massiveCreateBookingNewpageMain.massiveCreateBookingNewpage', {
                url: '/massiveCreateBookingNewpage/{id}',
                title: "Administración Masiva New Page",
                templateUrl: 'app/components/views/massive-create-booking-new-page/massiveCreateBookingNewScreen.html',
                controller: 'MassiveCreateBookingNewPageController',
                controllerAs: 'vm',
                // resolve: {
                //     getAccessCreateBooking: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                //         callAccessGiven('Administración Masiva', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                //     }
                // }
            })
            .state('layout.massiveModifyBookingNewpageMain', {
                url: '/massiveModifyBookingNewpageMain',
                title: "Massive Modify Booking New Page Main",
                templateUrl: 'app/components/views/massive-modify-booking/massiveModifyBookingNewpageMain.html'
            })
            .state('layout.massiveModifyBookingNewpageMain.massiveModifyBookingNewpage', {
                url: '/massiveModifyBookingNewpage/{id}',
                title: "Administración Masiva modification",
                templateUrl: 'app/components/views/massive-modify-booking/massiveModifyBookingNewpage.html',
                controller: 'MassiveModifyBookingController',
                controllerAs: 'vm',
                // resolve: {
                //     getAccessCreateBooking: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                //         callAccessGiven('Administración Masiva', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                //     }
                // }
            })
            .state('layout.massiveCreatePackageNewpageMain', {
                url: '/massiveCreatePackageNewpageMain',
                title: "Massive Create Package New Page Main",
                templateUrl: 'app/components/views/massive-create-package-new-page/massiveCreatePackageNewpageMain.html'
            })
            .state('layout.massiveCreatePackageNewpageMain.massiveCreatePackageNewScreen', {
                url: '/massiveCreatePackageNewScreen/{id}',
                title: "Administración Masiva Packae Page",
                templateUrl: 'app/components/views/massive-create-package-new-page/massiveCreatePackageNewScreen.html',
                controller: 'MassiveCreatePackageNewPageController',
                controllerAs: 'vm',
                // resolve: {
                //     getAccessCreateBooking: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                //         callAccessGiven('Administración Masiva', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                //     }
                // }
            })
            .state('layout.newMassiveCreateBookingMain', {
                url: '/newMassiveCreateBookingMain',
                title: "New Massive Create Booking Main",
                templateUrl: 'app/components/views/new-massive-create-booking/newMassiveCreateBookingNewMain.html'
            })
            .state('layout.newMassiveCreateBookingMain.newMassiveCreateBooking', {
                url: '/newMassiveCreateBooking',
                title: "Nueva Creación masiva",
                templateUrl: 'app/components/views/new-massive-create-booking/newMassiveCreateBooking.html',
                controller: 'NewMassiveCreateBookingController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCreateBooking: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Nueva Creación masiva', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.agreementMain', {
                url: '/agreementMain',
                title: "Agreement Main",
                templateUrl: 'app/components/views/agreement/agreementMain.html'

            })
            .state('layout.agreementMain.agreement', {
                url: '/agreement',
                title: "Agreement",
                templateUrl: 'app/components/views/agreement/Agreement.html',
                controller: 'AgreementController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAgreement: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Agreement', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.agreementMain.addAgreement', {
                url: '/addAgreement',
                title: "New Agreement",
                templateUrl: 'app/components/views/agreement/newAgreement.html',
                controller: 'NewAgreementController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAgreementAdd: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('New Agreement', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.agreementMain.editAgreement', {
                url: '/editAgreement/{id}',
                title: "Edit Agreement",
                templateUrl: 'app/components/views/agreement/editAgreement.html',
                controller: 'EditAgreementController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAgreementEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Edit Agreement', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.agreementMain.configureAgreement', {
                url: '/configureAgreement/{id}',
                title: "Configure Agreement",
                templateUrl: 'app/components/views/agreement/configureAgreement.html',
                controller: 'ConfigureAgreementController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAgreementEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Configure Agreement', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.agreementMain.adminLogs', {
                url: '/adminLogs/{userId}/{type}/{fakeType}',
                title: "Agreement Admin Logs",
                templateUrl: 'app/components/views/admin-role/getAdminSysLogs.html',
                controller: 'AdminLogsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessApplicantEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Agreement Admin Logs', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.agreementMain.viewAgreementDetails', {
                url: '/viewAgreementDetails/{id}',
                title: "View Agreement Details",
                templateUrl: 'app/components/views/agreement/viewAgreementDetails.html',
                controller: 'ViewAgreementDetailsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAgreementDetails: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('View Agreement Details', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.agreementMain.manageEmployee', {
                url: '/manageEmployee/{corporateId}/{contractId}/{path}',
                title: "Manage Employee",
                templateUrl: 'app/components/views/employee/manageEmployee.html',
                controller: 'ManageEmployeeController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAgreementEmployee: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Manage Employee', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.agreementMain.viewEmployeeDetails', {
                url: '/viewEmployeeDetails/{corporateId}/{contractId}/{id}',
                title: "View Employee Details",
                templateUrl: 'app/components/views/employee/viewEmployeeDetails.html',
                controller: 'ViewEmployeeDetailsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAgreementEmployee: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('View Employee Details', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.agreementMain.priceListFixedAgreement', {
                url: '/priceListFixedAgreement/{corporateId}/{contractId}/{path}',
                title: "Fixed Price List",
                templateUrl: 'app/components/views/agreement-route/fixedPriceListAgreement.html',
                controller: 'FixedPriceListAgreementController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAgreementPriceList: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Fixed Price List', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.agreementMain.priceListVariableAgreement', {
                url: '/priceListVariableAgreement/{corporateId}/{contractId}/{path}',
                title: "Variable Price List",
                templateUrl: 'app/components/views/agreement-route/variablePriceListAgreement.html',
                controller: 'VariablePriceListAgreementController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAgreementPriceList: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Variable Price List', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.agreementMain.fixedPriceListRoute', {
                url: '/fixedPriceListRoute/{corporateId}/{contractId}/{priceListId}/{path}',
                title: "Fixed Price List Route",
                templateUrl: 'app/components/views/agreement-route/fixedPriceListRoute.html',
                controller: 'FixedPriceListRouteController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAgreementPriceRoutes: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Fixed Price List Route', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.agreementMain.variablePriceListRoute', {
                url: '/variablePriceListRoute/{corporateId}/{contractId}/{priceListId}/{path}',
                title: "Variable Price List Route",
                templateUrl: 'app/components/views/agreement-route/variablePriceListRoute.html',
                controller: 'VariablePriceListRouteController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAgreementPriceRoutes: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Variable Price List Route', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })

            .state('layout.agreementMain.fixedPriceListRouteDetails', {
                url: '/fixedPriceListRouteDetails/{corporateId}/{contractId}/{priceListId}/{path}',
                title: "Fixed Price List Route Details",
                templateUrl: 'app/components/views/agreement-route/fixedPriceListRouteDetails.html',
                controller: 'FixedPriceListRouteDetailsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAgreementPriceRouteDetails: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Fixed Price List Route Details', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })

            .state('layout.agreementMain.variablePriceListRouteDetails', {
                url: '/variablePriceListRouteDetails/{corporateId}/{contractId}/{priceListId}/{path}',
                title: "Variable Price List Route Details",
                templateUrl: 'app/components/views/agreement-route/variablePriceListRouteDetails.html',
                controller: 'VariablePriceListRouteDetailsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAgreementPriceRouteDetails: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Variable Price List Route Details', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })

            .state('layout.generatePaymentStatusMain', {
                url: '/generatePaymentStatusMain',
                title: "Generate Payment Status Main",
                templateUrl: 'app/components/views/generate-payment-status/generatePaymentStatusMain.html'
            })
            .state('layout.generatePaymentStatusMain.generatePaymentStatus', {
                url: '/generatePaymentStatus',
                title: "Generate Payment Status",
                templateUrl: 'app/components/views/generate-payment-status/generatePaymentStatus.html',
                controller: 'GeneratePaymentStatusController',
                controllerAs: 'vm',
                resolve: {
                    getAccessService: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Generate Payment Status', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })

            .state('layout.controlledWayMain', {
                url: '/controlledWayMain',
                title: 'Editar Valor Via Controlada Main',
                templateUrl: 'app/components/views/controlled-way/controlledWayMain.html'
            })
            .state('layout.controlledWayMain.controlledWay', {
                url: '/controlledWay',
                title: 'Editar Valor Via Controlada',
                templateUrl: 'app/components/views/controlled-way/controlledWay.html',
                controller: 'controlledWayController',
                controllerAs: 'vm',
                resolve: {
                    getAccessService: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Editar Valor Via Controlada', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })

            .state('layout.controlledWayMain.editControlledWay', {
                url: '/editControlledWay/{controlled_way_id}',
                title: "Editar Valor Via Controlada Edit",
                templateUrl: 'app/components/views/controlled-way/editControlledWay.html',
                controller: 'editControlledWayController',
                controllerAs: 'vm',
            })

            .state('layout.gaussControlMain', {
                url: '/gaussControlMain',
                title: 'Editar Matriz de Control Gauss Control Main',
                templateUrl: 'app/components/views/gauss-control/gaussControlMain.html'
            })
            .state('layout.gaussControlMain.gaussControl', {
                url: '/gaussControl',
                title: 'Editar Matriz de Control Gauss Control',
                templateUrl: 'app/components/views/gauss-control/gaussControl.html',
                controller: 'gaussControlController',
                controllerAs: 'vm',
                resolve: {
                    getAccessService: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Editar Matriz de Control Gauss Control', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.autoAssignMain', {
                url: '/autoAssignMain',
                title: 'Autoasignacion Main',
                templateUrl: 'app/components/views/auto-assign/autoAssignMain.html'
            })
            .state('layout.autoAssignMain.autoAssign', {
                url: '/autoAssign',
                title: 'Administrar Geocerca Autoasignacion',
                templateUrl: 'app/components/views/auto-assign/autoAssign.html',
                controller: 'autoAssignController',
                controllerAs: 'vm',
                resolve: {
                    getAccessService: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Administrar Geocerca Autoasignacion', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })


            .state('layout.cierroPeriodeMain', {
                url: '/cierroPeriodeMain',
                title: "cierro Periode Main",
                templateUrl: 'app/components/views/generate-payment-status/cierroPeriodeMain.html'
            })
            .state('layout.cierroPeriodeMain.cierroPeriode', {
                url: '/cierroPeriode',
                title: "Cierro De Periode",
                templateUrl: 'app/components/views/generate-payment-status/cierroPeriode.html',
                controller: 'CierroPeriodeController',
                controllerAs: 'vm',
                resolve: {
                    getAccessService: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Cierro De Periode', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.abrirPeriodoMain', {
                url: '/abrirPeriodoMain',
                title: "Abrir último Período Cerrado Main",
                templateUrl: 'app/components/views/generate-payment-status/abrirPeriodoMain.html'
            })
            .state('layout.abrirPeriodoMain.abrirPeriodo', {
                url: '/abrirPeriodo',
                title: "Abrir último Período Cerrado",
                templateUrl: 'app/components/views/generate-payment-status/abrirPeriodo.html',
                controller: 'AbrirPeriodoController',
                controllerAs: 'vm',
                resolve: {
                    getAccessService: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Abrir último Período Cerrado', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.operationalReportMain', {
                url: '/operationalReportMain',
                title: "Operational Report Main",
                templateUrl: 'app/components/views/generate-payment-status/operationalReportMain.html'
            })
            .state('layout.operationalReportMain.operationalReport', {
                url: '/operationalReport',
                title: "Operational Report",
                templateUrl: 'app/components/views/generate-payment-status/operationalReport.html',
                controller: 'OperationalReportController',
                controllerAs: 'vm',
                resolve: {
                    getAccessService: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Operational Report', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.rejectedBookingMain', {
                url: '/rejectedBookingMain',
                title: "Rejected Booking Main",
                templateUrl: 'app/components/views/rejected-booking/rejectedBookingMain.html'
            })
            .state('layout.rejectedBookingMain.rejectedBooking', {
                url: '/rejectedBooking',
                title: "Rejected Booking",
                templateUrl: 'app/components/views/rejected-booking/rejectedBooking.html',
                controller: 'RejectedBookingController',
                controllerAs: 'vm',
                resolve: {
                    getAccessService: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Rejected Booking', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })

            .state('layout.typeOfServiceMain', {
                url: '/typeOfServiceMain',
                title: "Type of Service Main",
                templateUrl: 'app/components/views/type-of-service/typeOfServiceMain.html'

            })
            .state('layout.typeOfServiceMain.typeofService', {
                url: '/services',
                title: "Services",
                templateUrl: 'app/components/views/type-of-service/typeofService.html',
                controller: 'ServiceController',
                controllerAs: 'vm',
                resolve: {
                    getAccessService: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Services', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }

            })
            .state('layout.typeOfServiceMain.addService', {
                url: '/addService',
                title: "Add Service",
                templateUrl: 'app/components/views/type-of-service/addService.html',
                controller: 'AddServiceController',
                controllerAs: 'vm',
                resolve: {
                    getAccessServiceAdd: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Add Service', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }

            })
            .state('layout.typeOfServiceMain.editTypeofService', {
                url: '/editTypeofService/{id}',
                title: "Edit Service Type",
                templateUrl: 'app/components/views/type-of-service/edittypeofService.html',
                controller: 'EditServiceController',
                controllerAs: 'vm',
                resolve: {
                    getAccessServiceEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Edit Service Type', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.typeOfServiceMain.viewTypeofService', {
                url: '/viewTypeofService/{id}',
                title: "View Service Type",
                templateUrl: 'app/components/views/type-of-service/viewTypeOfServiceDetails.html',
                controller: 'ViewTypeOfServiceController',
                controllerAs: 'vm',
                resolve: {
                    getAccessServiceEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('View Service Type', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.typeOfServiceMain.adminLogs', {
                url: '/adminLogs/{userId}/{type}/{fakeType}',
                title: "Service Admin Logs",
                templateUrl: 'app/components/views/admin-role/getAdminSysLogs.html',
                controller: 'AdminLogsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessApplicantEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Service Admin Logs', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.vehicleTypeMain', {
                url: '/vehicleTypeMain',
                title: "Vehicle Type Main",
                templateUrl: 'app/components/views/vehicle-type/vehicleTypeMain.html'

            })
            .state('layout.vehicleTypeMain.vehicleType', {
                url: '/vehicle',
                title: "Vehicle Type",
                templateUrl: 'app/components/views/vehicle-type/vehicleType.html',
                controller: 'VehicleController',
                controllerAs: 'vm',
                resolve: {
                    getAccessVehicle: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Vehicle Type', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }

            })
            .state('layout.vehicleTypeMain.addVehicle', {
                url: '/addVehicle',
                title: "Add Vehicle",
                templateUrl: 'app/components/views/vehicle-type/addVehicle.html',
                controller: 'AddVehicleController',
                controllerAs: 'vm',
                resolve: {
                    getAccessVehicleAdd: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Add Vehicle', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }

            })
            .state('layout.vehicleTypeMain.editVehicleType', {
                url: '/editVehicleType/{id}',
                title: "Edit Vehicle Type",
                templateUrl: 'app/components/views/vehicle-type/editVehicletype.html',
                controller: 'EditVehicleController',
                controllerAs: 'vm',
                resolve: {
                    getAccessVehicleEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Edit Vehicle Type', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.vehicleTypeMain.viewVehicleType', {
                url: '/viewVehicleType/{id}',
                title: "View Vehicle Type",
                templateUrl: 'app/components/views/vehicle-type/viewVehicleType.html',
                controller: 'ViewVehicleController',
                controllerAs: 'vm',
                resolve: {
                    getAccessVehicleEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('View Vehicle Type', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.vehicleTypeMain.adminLogs', {
                url: '/adminLogs/{userId}/{type}/{fakeType}',
                title: "Vehicle Admin Logs",
                templateUrl: 'app/components/views/admin-role/getAdminSysLogs.html',
                controller: 'AdminLogsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessApplicantEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Vehicle Admin Logs', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.corporateMain', {
                url: '/corporateMain',
                title: "Corporate Main",
                templateUrl: 'app/components/views/corporate/corporateMain.html'
            })
            .state('layout.corporateMain.corporate', {
                url: '/corporate',
                title: "Corporate",
                templateUrl: 'app/components/views/corporate/corporate.html',
                controller: 'CorporateController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCorporate: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Corporate', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.corporateMain.viewCorporate', {
                url: '/viewCorporate/{id}',
                title: "View Corporate",
                templateUrl: 'app/components/views/corporate/viewCorporateDetails.html',
                controller: 'ViewCorporateDetailsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCorporate: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('View Corporate', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.corporateMain.addCorporate', {
                url: '/addCorporate',
                title: "Add Corporate",
                templateUrl: 'app/components/views/corporate/addCorporate.html',
                controller: 'AddCorporateController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCorporateAdd: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Add Corporate', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.corporateMain.editCorporate', {
                url: '/editCorporate/{id}',
                title: "Edit Corporate",
                templateUrl: 'app/components/views/corporate/editCorporate.html',
                controller: 'EditCorporateController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCorporateEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Edit Corporate', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.corporateMain.adminLogs', {
                url: '/adminLogs/{userId}/{type}/{fakeType}',
                title: "Corporate Admin Logs",
                templateUrl: 'app/components/views/admin-role/getAdminSysLogs.html',
                controller: 'AdminLogsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessApplicantEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Corporate Admin Logs', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.itemOfChargeMain', {
                url: '/itemOfChargeMain',
                title: 'Item of Charges Main',
                templateUrl: 'app/components/views/item-of-charge/itemOfChargeMain.html'
            })
            .state('layout.itemOfChargeMain.itemOfChargeList', {
                url: '/itemOfChargeList',
                title: 'Item of Charge',
                templateUrl: 'app/components/views/item-of-charge/itemOfChargeList.html',
                controller: 'ItemOfChargeController',
                controllerAs: 'vm',
                resolve: {
                    getAccessItemCharge: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Item of Charge', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.itemOfChargeMain.adminLogs', {
                url: '/adminLogs/{userId}/{type}/{fakeType}',
                title: "Item of Charge Admin Logs",
                templateUrl: 'app/components/views/admin-role/getAdminSysLogs.html',
                controller: 'AdminLogsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessApplicantEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Item of Charge Admin Logs', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.paymentTypeMain', {
                url: '/paymentTypeMain',
                title: 'Payment Type Main',
                templateUrl: 'app/components/views/payment-method/paymentTypeMain.html'
            })
            .state('layout.paymentTypeMain.paymentTypeList', {
                url: '/paymentTypeList',
                title: 'Payment Type List',
                templateUrl: 'app/components/views/payment-method/paymentTypeList.html',
                controller: 'PaymentTypeListController',
                controllerAs: 'vm',
                resolve: {
                    getAccessPayment: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Payment Type List', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.paymentTypeMain.addPaymentType', {
                url: '/addPaymentType',
                title: 'Add Payment Type',
                templateUrl: 'app/components/views/payment-method/addPaymentMethod.html',
                controller: 'PaymentTypeAddController',
                controllerAs: 'vm',
                resolve: {
                    getAccessPaymentAdd: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Add Payment Type', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.paymentTypeMain.editPaymentType', {
                url: '/editPaymentType/{id}',
                title: 'Edit Payment Type',
                templateUrl: 'app/components/views/payment-method/editPaymentMethod.html',
                controller: 'PaymentTypeEditController',
                controllerAs: 'vm',
                resolve: {
                    getAccessPaymentEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Edit Payment Type', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.paymentTypeMain.viewPaymentType', {
                url: '/viewPaymentType/{id}',
                title: 'View Payment Type',
                templateUrl: 'app/components/views/payment-method/viewPaymentType.html',
                controller: 'ViewPaymentTypeListController',
                controllerAs: 'vm',
                resolve: {
                    getAccessPaymentEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('View Payment Type', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.paymentTypeMain.adminLogs', {
                url: '/adminLogs/{userId}/{type}/{fakeType}',
                title: "Payment Type Admin Logs",
                templateUrl: 'app/components/views/admin-role/getAdminSysLogs.html',
                controller: 'AdminLogsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessApplicantEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Payment Type Admin Logs', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.promoCodeMain', {
                url: '/promoCodeMain',
                title: 'Promo Code Main',
                templateUrl: 'app/components/views/promo-code/promoCodeMain.html'
            })
            .state('layout.promoCodeMain.promoList', {
                url: '/promoList',
                title: 'Promo List',
                templateUrl: 'app/components/views/promo-code/promoCodeList.html',
                controller: 'PromoCodeListController',
                controllerAs: 'vm',
                resolve: {
                    getAccessPromo: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Promo List', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.promoCodeMain.addPromoCode', {
                url: '/addPromoCode',
                title: 'Add Promo Code',
                templateUrl: 'app/components/views/promo-code/addPromoCode.html',
                controller: 'AddPromoCodeController',
                controllerAs: 'vm',
                resolve: {
                    getAccessPromoAdd: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Add Promo Code', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.promoCodeMain.editPromoCode', {
                url: '/editPromoCode/{id}',
                title: 'Edit Promo Code',
                templateUrl: 'app/components/views/promo-code/editPromoCode.html',
                controller: 'EditPromoCodeController',
                controllerAs: 'vm',
                resolve: {
                    getAccessPromoEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Edit Promo Code', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.promoCodeMain.viewPromoCode', {
                url: '/viewPromoCode/{id}',
                title: 'View Promo Code',
                templateUrl: 'app/components/views/promo-code/viewPromoCode.html',
                controller: 'ViewPromoCodeController',
                controllerAs: 'vm',
                resolve: {
                    getAccessPromoEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('View Promo Code', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.promoCodeMain.adminLogs', {
                url: '/adminLogs/{userId}/{type}/{fakeType}',
                title: "Promo Codes Admin Logs",
                templateUrl: 'app/components/views/admin-role/getAdminSysLogs.html',
                controller: 'AdminLogsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessApplicantEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Promo Codes Admin Logs', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.couponMain', {
                url: '/couponMain',
                title: 'Coupon Main',
                templateUrl: 'app/components/views/promo-code/couponMain.html'
            })
            .state('layout.couponMain.couponList', {
                url: '/couponList',
                title: 'Coupon List',
                templateUrl: 'app/components/views/promo-code/couponList.html',
                controller: 'CouponListController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCoupon: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Coupon List', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.couponMain.addCoupon', {
                url: '/addCoupon/{id}/{isUnique}/{uniqueName}/{isEdit}',
                title: 'Add Coupon',
                templateUrl: 'app/components/views/promo-code/addCoupon.html',
                controller: 'AddCouponController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCouponAdd: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Add Coupon', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.couponMain.adminLogs', {
                url: '/adminLogs/{userId}/{type}/{fakeType}',
                title: "Coupon Admin Logs",
                templateUrl: 'app/components/views/admin-role/getAdminSysLogs.html',
                controller: 'AdminLogsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCouponEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Coupon Admin Logs', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.binMain', {
                url: '/binMain',
                title: 'Bin Main',
                templateUrl: 'app/components/views/promo-code/binMain.html'
            })
            .state('layout.binMain.binList', {
                url: '/binList',
                title: 'Bin List',
                templateUrl: 'app/components/views/promo-code/binList.html',
                controller: 'BinListController',
                controllerAs: 'vm',
                resolve: {
                    getAccessBin: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Bin List', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.binMain.addBin', {
                url: '/addBin',
                title: 'Add Bin',
                templateUrl: 'app/components/views/promo-code/addBin.html',
                controller: 'AddBinController',
                controllerAs: 'vm',
                resolve: {
                    getAccessBinAdd: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Add Bin', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.binMain.viewBin', {
                url: '/viewBin/{id}',
                title: 'View Bin',
                templateUrl: 'app/components/views/promo-code/viewBin.html',
                controller: 'ViewBinController',
                controllerAs: 'vm',
                resolve: {
                    getAccessBinEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('View Bin', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.binMain.editBin', {
                url: '/editBin/{id}',
                title: 'Edit Bin',
                templateUrl: 'app/components/views/promo-code/editBin.html',
                controller: 'EditBinController',
                controllerAs: 'vm',
                resolve: {
                    getAccessBinEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Edit Bin', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.binMain.adminLogs', {
                url: '/adminLogs/{userId}/{type}/{fakeType}',
                title: "Bin Admin Logs",
                templateUrl: 'app/components/views/admin-role/getAdminSysLogs.html',
                controller: 'AdminLogsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessBinEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Bin Admin Logs', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.driverEarningMain', {
                url: '/driverEarningMain',
                title: 'Driver Earnings Main',
                templateUrl: 'app/components/views/driver-earning/driverEarningMain.html'
            })
            .state('layout.driverEarningMain.driverEarning', {
                url: '/driverEarning',
                title: 'Driver Earning',
                templateUrl: 'app/components/views/driver-earning/driverEarning.html',
                controller: 'DriverEarningController',
                controllerAs: 'vm',
                resolve: {
                    getAccessDriverEarning: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Driver Earning', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.driverEarningMain.adminLogs', {
                url: '/adminLogs/{userId}/{type}/{fakeType}',
                title: "Driver Earning Admin Logs",
                templateUrl: 'app/components/views/admin-role/getAdminSysLogs.html',
                controller: 'AdminLogsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessApplicantEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Driver Earning Admin Logs', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })

            .state('layout.cancelReasonMain', {
                url: '/cancelReasonMain',
                title: 'Cancel Reason Main',
                templateUrl: 'app/components/views/cancel-reason/cancelReasonMain.html'
            })
            .state('layout.cancelReasonMain.cancelReason', {
                url: '/cancelReason',
                title: 'Cancel Reason',
                templateUrl: 'app/components/views/cancel-reason/cancelReason.html',
                controller: 'CancelReasonController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCancel: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Cancel Reason', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.cancelReasonMain.viewCancelReason', {
                url: '/viewCancelReason/{id}',
                title: 'View Cancel Reason',
                templateUrl: 'app/components/views/cancel-reason/viewCancelReason.html',
                controller: 'ViewCancelReasonController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCancel: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('View Cancel Reason', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.cancelReasonMain.adminLogs', {
                url: '/adminLogs/{userId}/{type}/{fakeType}',
                title: "Cancel Reason Admin Logs",
                templateUrl: 'app/components/views/admin-role/getAdminSysLogs.html',
                controller: 'AdminLogsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessApplicantEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Cancel Reason Admin Logs', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })

            .state('layout.correctFareReasonMain', {
                url: '/correctFareReasonMain',
                title: 'Correct Fare Reason Main',
                templateUrl: 'app/components/views/correct-fare-reason/correctFareReasonMain.html'
            })
            .state('layout.correctFareReasonMain.correctFareReason', {
                url: '/correctFareReason',
                title: 'Correct Fare Reason',
                templateUrl: 'app/components/views/correct-fare-reason/correctFareReason.html',
                controller: 'CorrectFareReasonController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCancel: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Correct Fare Reason', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.correctFareReasonMain.adminLogs', {
                url: '/adminLogs/{userId}/{type}/{fakeType}',
                title: "Correct Fare Reason Admin Logs",
                templateUrl: 'app/components/views/admin-role/getAdminSysLogs.html',
                controller: 'AdminLogsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessApplicantEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Correct Fare Reason Admin Logs', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.correctFareReasonMain.viewCorrectFareReason', {
                url: '/viewCorrectFareReason/{id}',
                title: 'View Correct Fare Reason',
                templateUrl: 'app/components/views/correct-fare-reason/viewCorrectFareReason.html',
                controller: 'ViewCorrectFareReasonController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCancel: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('View Correct Fare Reason', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })

            .state('layout.noShowReasonMain', {
                url: '/noShowReasonMain',
                title: 'No Show Reason Main',
                templateUrl: 'app/components/views/no-show-reason/noShowReasonMain.html'
            })
            .state('layout.noShowReasonMain.noShowReason', {
                url: '/noShowReason',
                title: 'No Show Reason',
                templateUrl: 'app/components/views/no-show-reason/noShowReason.html',
                controller: 'NoShowReasonController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCancel: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('No Show Reason', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.noShowReasonMain.adminLogs', {
                url: '/adminLogs/{userId}/{type}/{fakeType}',
                title: "No Show Reason Admin Logs",
                templateUrl: 'app/components/views/admin-role/getAdminSysLogs.html',
                controller: 'AdminLogsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessApplicantEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('No Show Reason Admin Logs', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.noShowReasonMain.viewNoShowReason', {
                url: '/viewNoShowReason/{id}',
                title: 'View No Show Reason',
                templateUrl: 'app/components/views/no-show-reason/viewNoShowReason.html',
                controller: 'ViewNoShowReasonController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCancel: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('View No Show Reason', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })

            .state('layout.adminRolesMain', {
                url: '/adminRolesMain',
                title: 'Admin Roles Main',
                templateUrl: 'app/components/views/admin-role/adminRolesMain.html'
            })
            .state('layout.adminRolesMain.adminRolesList', {
                url: '/adminRolesList',
                title: 'Admin Role List',
                templateUrl: 'app/components/views/admin-role/adminRolesList.html',
                controller: 'AdminRolesListController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAdminRole: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Admin Role List', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.adminRolesMain.givePermissions', {
                url: '/givePermissions/{id}',
                title: 'Give Permissions',
                templateUrl: 'app/components/views/admin-role/newRole.html',
                controller: 'NewRoleController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAdminRolePermission: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Give Permissions', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.adminRolesMain.updatePermissions', {
                url: '/updatePermissions/{id}',
                title: 'Update Permissions',
                templateUrl: 'app/components/views/admin-role/updateRole.html',
                controller: 'UpdateRolesController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAdminRoleEditPermission: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Update Permissions', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.adminRolesMain.viewRoles', {
                url: '/viewRoles/{id}',
                title: 'View Admin Roles',
                templateUrl: 'app/components/views/admin-role/viewAdminRoles.html',
                controller: 'ViewRolesController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAdminRoleEditPermission: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('View Admin Roles', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.adminRolesMain.adminLogs', {
                url: '/adminLogs/{userId}/{type}/{fakeType}',
                title: "Admin Role List Logs",
                templateUrl: 'app/components/views/admin-role/getAdminSysLogs.html',
                controller: 'AdminLogsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessApplicantEdit: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Admin Role List Logs', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.adminUsersMain.bookingReports', {
                url: '/bookingReports/{id}',
                title: 'Booking Reports Admin',
                templateUrl: 'app/components/views/admin-role/bookingReportsAdmin.html',
                controller: 'BookingReportsAdminController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAdminReportsBookingPermission: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Booking Reports Admin', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.adminUsersMain', {
                url: '/adminUsersMain',
                title: 'Admin Users Main',
                templateUrl: 'app/components/views/admin-role/adminUserListMain.html'
            })
            .state('layout.adminUsersMain.adminUsersList', {
                url: '/adminUsersList',
                title: 'Admin Users List',
                templateUrl: 'app/components/views/admin-role/adminUsersList.html',
                controller: 'AdminUsersListController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAdminRole: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Admin Users List', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.adminUsersMain.addRoleToAdminUser', {
                url: '/addRoleToAdminUser/{id}/{userType}',
                title: 'Add Role To Admin User',
                templateUrl: 'app/components/views/admin-role/addRoleToAdminUser.html',
                controller: 'AddRoleToAdminUserController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAdminRole: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Add Role To Admin User', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.adminUsersMain.updateRoleToAdminUser', {
                url: '/updateRoleToAdminUser/{id}/{userType}',
                title: 'Update Role To Admin User',
                templateUrl: 'app/components/views/admin-role/updateRoleToAdminUser.html',
                controller: 'UpdateRoleToAdminUserController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAdminRole: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Update Role To Admin User', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })

            .state('layout.operationPointMain', {
                url: '/operationPointMain',
                title: 'Operation Point Main',
                templateUrl: 'app/components/views/operationPoint/operationPointMain.html'
            })
            .state('layout.operationPointMain.operationPoint', {
                url: '/operationPoint',
                title: 'Operation Point',
                templateUrl: 'app/components/views/operationPoint/operationPoint.html',
                controller: 'OperationPointController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAdminRole: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Operation Point', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.operationPointMain.operationPointRegister', {
                url: '/operationPointRegister',
                title: 'Register Operation Point',
                templateUrl: 'app/components/views/operationPoint/operationPointRegister.html',
                controller: 'OperationPointRegisterController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAdminRole: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Register Operation Point', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.operationPointMain.operationPointEdit', {
                url: '/operationPointEdit/{id}',
                title: 'Edit Operation Point',
                templateUrl: 'app/components/views/operationPoint/operationPointEdit.html',
                controller: 'OperationPointEditController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAdminRole: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Edit Operation Point', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.operationPointMain.operationPointView', {
                url: '/operationPointView/{id}',
                title: 'View Operation Point',
                templateUrl: 'app/components/views/operationPoint/operationPointView.html',
                controller: 'OperationPointViewController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAdminRole: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('View Operation Point', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.operationPointUserMain', {
                url: '/operationPointUserMain',
                title: 'Operation Point User Main',
                templateUrl: 'app/components/views/operationPointUser/operationPointUserMain.html'
            })
            .state('layout.operationPointUserMain.operationPointUser', {
                url: '/operationPointUser',
                title: 'Operation Point User',
                templateUrl: 'app/components/views/operationPointUser/operationPointUser.html',
                controller: 'OperationPointUserController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAdminRole: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Operation Point User', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })

            .state('layout.globalParametersMain', {
                url: '/globalParametersMain',
                title: 'Global Parameters Main',
                templateUrl: 'app/components/views/global-parameters/globalParamtersMain.html'
            })
            .state('layout.globalParametersMain.globalParameters', {
                url: '/globalParameters',
                title: 'Global Parameters',
                templateUrl: 'app/components/views/global-parameters/globalParameters.html',
                controller: 'GlobalParametersController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAdminRole: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Global Parameters', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.driverEvaluationMain', {
                url: '/driverEvaluationMain',
                title: 'Driver Evaluation Main',
                templateUrl: 'app/components/views/driver-evaluation/driverEvaluationMain.html'
            })
            .state('layout.driverEvaluationMain.driverEvaluation', {
                url: '/driverEvaluation',
                title: 'Driver Evaluation',
                templateUrl: 'app/components/views/driver-evaluation/driverEvaluation.html',
                controller: 'DriverEvaluationController',
                controllerAs: 'vm',
                // resolve: {
                //     getAccessAdminRole: function ($state, $stateParams, $rootScope, adminAccessService,  errorMessageFactory , $mdDialog , $interval , $cookies) {
                //         callAccessGiven('Global Parameters', $rootScope, adminAccessService,  errorMessageFactory , $mdDialog , $interval , $cookies);
                //     }
                // }
            })
            .state('layout.summaryProductionMain', {
                url: '/summaryProductionMain',
                title: 'Summary Production Main',
                templateUrl: 'app/components/views/production-list/summaryProductionVehicleMain.html'
            })
            .state('layout.summaryProductionMain.summaryProduction', {
                url: '/summaryProduction',
                title: 'Summary Production',
                templateUrl: 'app/components/views/production-list/summaryProductionVehicle.html',
                controller: 'SummaryProductionVehicleController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAdminRole: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Summary Production', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.vehicleBalanceReportMain', {
                url: '/vehicleBalanceReportMain',
                title: 'Vehicle Balance Report Main',
                templateUrl: 'app/components/views/production-list/vehicleBalanceReportMain.html'
            })
            .state('layout.vehicleBalanceReportMain.vehicleBalanceReport', {
                url: '/vehicleBalanceReport',
                title: 'Balance de vehículos',
                templateUrl: 'app/components/views/production-list/vehicleBalanceReport.html',
                controller: 'VehicleBalanceReportController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAdminRole: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Balance de vehículos', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.detailedProductionMain', {
                url: '/detailedProductionMain',
                title: 'Detailed Production Main',
                templateUrl: 'app/components/views/production-list/detailedProductionVehicleMain.html'
            })
            .state('layout.detailedProductionMain.detailedProduction', {
                url: '/detailedProduction',
                title: 'Detailed Production',
                templateUrl: 'app/components/views/production-list/detailedProductionVehicle.html',
                controller: 'DetailedProductionVehicleController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAdminRole: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Detailed Production', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.itemOfChargeCsvMain', {
                url: '/itemOfChargeCsvMain',
                title: 'Item of Charge Main',
                templateUrl: 'app/components/views/production-list/itemOfChargeCsvMain.html'
            })
            .state('layout.itemOfChargeCsvMain.itemOfChargeCsv', {
                url: '/itemOfChargeCsv',
                title: 'Item of Charge',
                templateUrl: 'app/components/views/production-list/itemOfChargeCsv.html',
                controller: 'ItemOfChargeCsvMainController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAdminRole: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Item of Charge', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.onOffDutyMain', {
                url: '/onOffDutyMain',
                title: "On Off Duty Main",
                templateUrl: 'app/components/views/onOffDuty/onOffDutyMain.html'
            })
            .state('layout.onOffDutyMain.onOffDuty', {
                url: '/onOffDuty',
                title: "On Off Duty",
                templateUrl: 'app/components/views/onOffDuty/onOffDuty.html',
                controller: 'OnOffDutyController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCreateBooking: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('On Off Duty', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.helpDocMain', {
                url: '/helpDocMain',
                title: "Help Documents Main",
                templateUrl: 'app/components/views/help-documents/helpDocumentsMain.html'
            })
            .state('layout.helpDocMain.helpDocs', {
                url: '/helpDocs',
                title: "Help Documents",
                templateUrl: 'app/components/views/help-documents/helpDocuments.html',
                controller: 'HelpDocumentsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCreateBooking: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Help Documents', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.helpDocMain.addHelpDocs', {
                url: '/addHelpDocs',
                title: "Add Help Documents",
                templateUrl: 'app/components/views/help-documents/addHelpDocuments.html',
                controller: 'AddHelpDocumentsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCreateBooking: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Add Help Documents', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.helpDocMain.editHelpDocs', {
                url: '/editHelpDocs/{lang}/{userType}/{type}',
                title: "Edit Help Documents",
                templateUrl: 'app/components/views/help-documents/updateHelpDocuments.html',
                controller: 'EditHelpDocumentsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessCreateBooking: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Edit Help Documents', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.expenseControlMain', {
                url: '/expenseControlMain',
                title: 'Definir Presupuesto',
                templateUrl: 'app/components/views/expense-control/expenseControlMain.html'
            })
            .state('layout.expenseControlMain.expenseControl', {
                url: '/expenseControl',
                title: "Definir Presupuesto",
                templateUrl: 'app/components/views/expense-control/expenseControl.html',
                controller: 'ExpenseControlController',
                controllerAs: 'vm',
                // resolve: {
                //     getAccessApplicant : function($state,$stateParams,$rootScope,adminAccessService, errorMessageFactory , $mdDialog , $interval , $cookies){
                //         callAccessGiven('Direcciones Especiales',$rootScope,adminAccessService, errorMessageFactory , $mdDialog , $interval , $cookies);
                //     }
                // }
            })
            .state('layout.expenseControlReportMain', {
                url: '/expenseControlReportMain',
                title: 'Definir Presupuesto',
                templateUrl: 'app/components/views/expense-control/expenseControlReportMain.html'
            })
            .state('layout.expenseControlReportMain.expenseControlReport', {
                url: '/expenseControlReport',
                title: "Definir Presupuesto",
                templateUrl: 'app/components/views/expense-control/expenseControlReport.html',
                controller: 'ExpenseControlReportController',
                controllerAs: 'vm',
                // resolve: {
                //     getAccessApplicant : function($state,$stateParams,$rootScope,adminAccessService, errorMessageFactory , $mdDialog , $interval , $cookies){
                //         callAccessGiven('Direcciones Especiales',$rootScope,adminAccessService, errorMessageFactory , $mdDialog , $interval , $cookies);
                //     }
                // }
            })

            .state('layout.newMessageMain', {
                url: '/newMessageMain',
                title: 'new Message Main',
                templateUrl: 'app/components/views/comminication-suppliers/newMessageMain.html'
            })
            .state('layout.newMessageMain.newMessage', {
                url: '/newMessage',
                title: 'Nuevo mensaje proveedores',
                templateUrl: 'app/components/views/comminication-suppliers/newMessage.html',
                controller: 'NewMessageController',
                controllerAs: 'vm',
                resolve: {
                    getAccessUpcoming: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Nuevo mensaje proveedores', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.groupDriversMain', {
                url: '/groupDriversMain',
                title: 'group Driver Main',
                templateUrl: 'app/components/views/comminication-suppliers/groupDriversMain.html'
            })
            .state('layout.groupDriversMain.groupDrivers', {
                url: '/groupDrivers',
                title: 'Grupos de difusión',
                templateUrl: 'app/components/views/comminication-suppliers/groupDrivers.html',
                controller: 'GroupDriverController',
                controllerAs: 'vm',
                resolve: {
                    getAccessUpcoming: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Grupos de difusión', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.historyMessageMain', {
                url: '/historyMessageMain',
                title: 'history Message Main',
                templateUrl: 'app/components/views/comminication-suppliers/historyMessageMain.html'
            })
            .state('layout.historyMessageMain.historyMessage', {
                url: '/historyMessage',
                title: 'Historial de mensajes',
                templateUrl: 'app/components/views/comminication-suppliers/historyMessage.html',
                controller: 'HistoryMessageController',
                controllerAs: 'vm',
                resolve: {
                    getAccessUpcoming: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Historial de mensajes', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.mailDriverMain', {
                url: '/mailDriverMain',
                title: 'Mail Driver Main',
                templateUrl: 'app/components/views/comminication-suppliers/mailDriverMain.html'
            })
            .state('layout.mailDriverMain.mailDriver', {
                url: '/mailDriver',
                title: 'Editar Mail Bienvenida Postulante',
                templateUrl: 'app/components/views/comminication-suppliers/mailDriver.html',
                controller: 'DriverMailController',
                controllerAs: 'vm',
                resolve: {
                    getAccessUpcoming: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Editar Mail Bienvenida Postulante', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.groupDriversMain.addGroupDrivers', {
                url: '/addGroupDrivers',
                title: 'Agregar grupo de difusión',
                templateUrl: 'app/components/views/comminication-suppliers/addGroupDrivers.html',
                controller: 'GroupDriverController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAdminRolePermission: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Agregar grupo de difusión', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.groupDriversMain.addDriversList', {
                url: '/addDriversList',
                title: 'Agregar conductor',
                templateUrl: 'app/components/views/comminication-suppliers/addDriversList.html',
                controller: 'GroupDriverController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAdminRolePermission: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Agregar grupo de difusión', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.groupDriversMain.editGroupDrivers', {
                url: '/editGroupDrivers/{id}',
                title: 'Modificar grupo de difusión',
                templateUrl: 'app/components/views/comminication-suppliers/editGroupDrivers.html',
                controller: 'EditGroupController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAdminRolePermission: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Modificar grupo de difusión', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.groupDriversMain.viewGroupDrivers', {
                url: '/viewGroupDrivers/{id}',
                title: 'Ver grupo de difusión',
                templateUrl: 'app/components/views/comminication-suppliers/viewGroupDrivers.html',
                controller: 'VeiwGroupDetailsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessAdminRolePermission: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Ver grupo de difusión', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.groupMassiveQuickassignmentMain', {
                url: '/groupMassiveQuickassignmentMain',
                title: 'Auto-asignación de paquetes Main',
                templateUrl: 'app/components/views/booking-list/groupMassiveQuickassignmentMain.html'
            })
            .state('layout.groupMassiveQuickassignmentMain.groupMassiveQuickassignment', {
                url: '/groupMassiveQuickassignment',
                title: 'Auto-asignación de paquetes',
                templateUrl: 'app/components/views/booking-list/groupMassiveQuickassignment.html',
                controller: 'GroupMassiveQuickassignmentController',
                controllerAs: 'vm',
                resolve: {
                    getAccessUpcoming: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Upcoming Bookings', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.selfAssignmentMain', {
                url: '/selfAssignmentMain',
                title: 'Autoasignación Principal',
                templateUrl: 'app/components/views/booking-list/selfAssignmentMain.html'
            })
            .state('layout.selfAssignmentMain.selfAssignment', {
                url: '/selfAssignment',
                params: { typeSelected: 0 },
                title: 'Autoasignación',
                templateUrl: 'app/components/views/booking-list/selfAssignment.html',
                controller: 'SelfAssignmentController',
                controllerAs: 'vm',
                resolve: {
                    getAccessUpcoming: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Autoasignación', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            }).state('layout.selfAssignmentMain.selfAssignmentDetails', {
                url: '/selfAssignmentDetails/{id}',
                title: 'Vista detalles de las instancia',
                templateUrl: 'app/components/views/booking-list/selfAssignmentDetails.html',
                controller: 'SelfAssignmentDetailsController',
                controllerAs: 'vm',
                resolve: {
                    getAccessOngoing: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Vista detalles de las instancia', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            }).state('layout.selfAssignmentMain.selfAssignmentCreate', {
                url: '/selfAssignmentCreate/{id}',
                title: 'Crear instancia autoasignacion',
                templateUrl: 'app/components/views/booking-list/selfAssignmentCreate.html',
                controller: 'SelfAssignmentCreateController',
                controllerAs: 'vm',
                resolve: {
                    getAccessOngoing: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Crear instancia autoasignacion', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            }).state('layout.selfAssignmentMain.selfAssignmentEdit', {
                url: '/selfAssignmentEdit/{id}',
                title: 'Editar instancia autoasignacion',
                templateUrl: 'app/components/views/booking-list/selfAssignmentEdit.html',
                controller: 'SelfAssignmentEditController',
                controllerAs: 'vm',
                resolve: {
                    getAccessOngoing: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Editar instancia autoasignacion', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            }).state('layout.selfAssignmentMain.selfAssignmentDelete', {
                url: '/selfAssignmentDelete/{id}',
                params: { event: null, refresh: false, data: null, serviceSelected: null },
                title: 'Inactivar instancia autoasignacion',
                templateUrl: 'app/components/views/booking-list/selfAssignmentDelete.html',
                controller: 'SelfAssignmentDeleteController',
                controllerAs: 'vm',
                resolve: {
                    getAccessOngoing: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Inactivar instancia autoasignacion', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            }).state('layout.factorMultiplicadorMain', {
                url: '/FactorMultiplicadorMain',
                title: 'Factor Multiplicador Main',
                templateUrl: 'app/components/views/factor-multiplicador/factorMultiplicadorMain.html'
            })
            .state('layout.factorMultiplicadorMain.factorMultiplicador', {
                url: '/FactorMultiplicador/{contractId}/{tipo}',
                params: { params: null, tipo: null, contractId: null },
                title: 'Factor Multiplicador',
                templateUrl: 'app/components/views/factor-multiplicador/factorMultiplicador.html',
                controller: 'FactorMultiplicadorController',
                controllerAs: 'vm'
            }).state('layout.factorMultiplicadorMain.factorMultiplicadorCreate', {
                url: '/factorMultiplicadorCreate',
                params: { tipo: null, convenioId: null, corporateId: null },
                title: 'Crear factor multiplicador',
                templateUrl: 'app/components/views/factor-multiplicador/factorMultiplicadorCreate.html',
                controller: 'FactorMultiplicadorCreateController',
                controllerAs: 'vm',
                resolve: {
                    getAccessOngoing: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Crear factor multiplicador', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            }).state('layout.factorMultiplicadorMain.factorMultiplicadorView', {
                url: '/factorMultiplicadorView',
                params: { tipo: null, convenioId: null, corporateId: null, id: null },
                title: 'Ver factor multiplicador',
                templateUrl: 'app/components/views/factor-multiplicador/factorMultiplicadorView.html',
                controller: 'FactorMultiplicadorViewController',
                controllerAs: 'vm'
            }).state('layout.factorMultiplicadorMain.factorMultiplicadorViewCalendar', {
                url: '/factorMultiplicadorViewCalendar',
                params: { tipo: null, convenioId: null, corporateId: null, id: null, params: null },
                title: 'Ver calendario factor multiplicador',
                templateUrl: 'app/components/views/factor-multiplicador/factorMultiplicadorViewCalendar.html',
                controller: 'factorMultiplicadorViewCalendarController',
                controllerAs: 'vm'
            })
            .state('layout.fleetCapacityMatrixMain', {
                url: '/fleetCapacityMatrixMain',
                title: 'Matriz de capacidad de flota principal',
                templateUrl: 'app/components/views/matriz-flota/fleetCapacityMatrixMain.html'
            })
            .state('layout.fleetCapacityMatrixMain.fleetCapacityMatrix', {
                url: '/fleetCapacityMatrix',
                params: { estadoSelected: null, sucursalSelected: null },
                title: 'Matriz de capacidad de flota',
                templateUrl: 'app/components/views/matriz-flota/fleetCapacityMatrix.html',
                controller: 'FleetCapacityMatrixController',
                controllerAs: 'vm',
                resolve: {
                    getAccessUpcoming: function ($state, $stateParams, $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies) {
                        callAccessGiven('Matriz de capacidad de flota', $rootScope, adminAccessService, errorMessageFactory, $mdDialog, $interval, $cookies);
                    }
                }
            })
            .state('layout.fleetCapacityMatrixMain.fleetCapacityMatrixDetail', {
                url: '/fleetCapacityMatrixDetail/{id}',
                params: { matriz: null, estado: null, sucursal: null, id: null },
                title: 'Vista detalle matriz',
                templateUrl: 'app/components/views/matriz-flota/fleetCapacityMatrixDetail.html',
                controller: 'FleetCapacityMatrixDetailController',
                controllerAs: 'vm'
            })
            .state('layout.fleetCapacityMatrixMain.fleetCapacityMatrixCreate', {
                url: '/fleetCapacityMatrixCreate/{id}',
                params: { matriz: null, exception: null, create: false, estado: null, id:null },
                title: 'Vista creación matriz',
                templateUrl: 'app/components/views/matriz-flota/fleetCapacityMatrixCreate.html',
                controller: 'FleetCapacityMatrixCreateController',
                controllerAs: 'vm'
            })
            .state('layout.fleetCapacityMatrixMain.fleetCapacityMatrixEdit', {
                url: '/fleetCapacityMatrixEdit/{matriz}',
                params: { matriz: null, id: null, exception: null, estado: null },
                title: 'Vista editar matriz',
                templateUrl: 'app/components/views/matriz-flota/fleetCapacityMatrixCreate.html',
                controller: 'FleetCapacityMatrixCreateController',
                controllerAs: 'vm'
            })
            .state('layout.fleetCapacityMatrixMain.fleetCapacityMatrixExceptions', {
                url: '/fleetCapacityMatrixExceptions/{id}',
                params: { matriz: null, exception: null, id: null, sucursal: null },
                title: 'Vista excepciones',
                templateUrl: 'app/components/views/matriz-flota/fleetCapacityMatrixExceptions.html',
                controller: 'FleetCapacityMatrixExceptionsController',
                controllerAs: 'vm'
            })
            .state('layout.fleetCapacityMatrixMain.fleetCapacityMatrixCalendar', {
                url: '/fleetCapacityMatrixCalendar/{id}',
                params: { matriz: null, exception: null, id: null },
                title: 'Vista excepciones',
                templateUrl: 'app/components/views/matriz-flota/fleetCapacityMatrixCalendar.html',
                controller: 'FleetCapacityMatrixCalendarController',
                controllerAs: 'vm'
            })
    }
})();

/* global malarkey:false, moment:false */
(function () {
    'use strict';

    angular
        .module('transVipMain')
        .constant('malarkey', malarkey)
        .constant('moment', moment)
})();

(function () {
    'use strict';

    angular
        .module('transVipMain')
        .config(config);
    /** @ngInject */
    function config($logProvider,  toastrConfig, $translateProvider,$sceDelegateProvider,tmhDynamicLocaleProvider,KeepaliveProvider, IdleProvider,$httpProvider) {
        // Enable log
        $logProvider.debugEnabled(true);
        angular.lowercase = angular.$$lowercase;

        // Set options third-party lib
        toastrConfig.allowHtml = true;
        toastrConfig.timeOut = 3000;
        toastrConfig.positionClass = 'toast-top-right';
        toastrConfig.preventDuplicates = true;
        toastrConfig.progressBar = true;

        //Set options translate language
        $translateProvider.useStaticFilesLoader({
            prefix: '',  // folder path of JSON files
            suffix: '.json'
        });
        $translateProvider.preferredLanguage('englishTranslate');

        $sceDelegateProvider.resourceUrlWhitelist([
            // Allow same origin resource loads.
            'self',
            // Allow loading from our assets domain.  Notice the difference between * and **.
            'https://s3.amazonaws.com/transvip/**'
        ]);
        // The blacklist overrides the whitelist so the open redirect here is blocked.
        //$sceDelegateProvider.resourceUrlBlacklist([
        //    'http://myapp.example.com/clickThru**'
        //]);
        tmhDynamicLocaleProvider.defaultLocale('spanish');
        tmhDynamicLocaleProvider.localeLocationPattern('../angular-locale_{{locale}}.js');

        //IdleProvider.idle(480);
        //IdleProvider.timeout(480);
        //KeepaliveProvider.interval(960);

        $httpProvider.interceptors.push('httpRequestInterceptor');

    }
})();

angular.module("transVipMain").run(["$templateCache", function($templateCache) {$templateCache.put("app/driverRating/driverRating.html","<div class=\"container-fluid _wd_rating block-center mt-xl ng-cloak river_rating_page driver_rating_page\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=\"panel panel-default\" id=driverRating style=\"min-height: 80vh\"><div class=\"panel-body paddingTopZero\" ng-if=!vm.successMsg><div class=row ng-if=!vm.linkExpireError><div class=text-center><a><img width=auto src=../../assets/images/img_encuesta-01.png alt=Image class=\"block-center rating_logo-div\"></a></div><!-- TITLE  --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\"><h2 class=_heading_font_size style=\"padding: 20px 4px;font-size: 26px\">{{vm.title || \'\'}}</h2></div><!-- STAR RATING --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\"><div class=rating><!-- filled star --><!-- if value is less --> <span ng-click=vm.getStarRating(5) ng-if=\"vm.selectedStarValue < 5 && vm.selectedStarValue != 0\"><img width=38px height=38px src=../../assets/images/star5empty.png> </span><span ng-click=vm.getStarRating(4) ng-if=\"vm.selectedStarValue < 4  && vm.selectedStarValue != 0\"><img width=38px height=38px src=../../assets/images/star4empty.png> </span><span ng-click=vm.getStarRating(3) ng-if=\"vm.selectedStarValue < 3  && vm.selectedStarValue != 0\"><img width=38px height=38px src=../../assets/images/star3empty.png> </span><span ng-click=vm.getStarRating(2) ng-if=\"vm.selectedStarValue < 2  && vm.selectedStarValue != 0\"><img width=38px height=38px src=../../assets/images/star2empty.png> </span><span ng-click=vm.getStarRating(1) ng-if=\"vm.selectedStarValue < 1  && vm.selectedStarValue != 0\"><img width=38px height=38px src=../../assets/images/star1empty.png> </span><span ng-click=vm.getStarRating(5) ng-if=\"vm.selectedStarValue >= 5\"><img width=38px height=38px src=../../assets/images/star5full.png> </span><span ng-click=vm.getStarRating(4) ng-if=\"vm.selectedStarValue >= 4\"><img width=38px height=38px src=../../assets/images/star4full.png> </span><span ng-click=vm.getStarRating(3) ng-if=\"vm.selectedStarValue >= 3\"><img width=38px height=38px src=../../assets/images/star3full.png> </span><span ng-click=vm.getStarRating(2) ng-if=\"vm.selectedStarValue >= 2\"><img width=38px height=38px src=../../assets/images/star2full.png> </span><span ng-click=vm.getStarRating(1) ng-if=\"vm.selectedStarValue >= 1\"><img width=38px height=38px src=../../assets/images/star1full.png> </span><!-- Un filled star --> <span ng-mouseover=vm.star5() ng-mouseleave=vm.star5Leave() ng-if=\"vm.selectedStarValue == 0\" ng-click=vm.getStarRating(5)><img width=38px height=38px ng-if=!vm.star5flag src=../../assets/images/star5empty.png> <img width=38px height=38px ng-if=vm.star5flag src=../../assets/images/star5full.png> </span><span ng-mouseover=vm.star4() ng-mouseleave=vm.star4Leave() ng-if=\"vm.selectedStarValue == 0\" ng-click=vm.getStarRating(4)><img width=38px height=38px ng-if=!vm.star4flag src=../../assets/images/star4empty.png> <img width=38px height=38px ng-if=vm.star4flag src=../../assets/images/star4full.png> </span><span ng-mouseover=vm.star3() ng-mouseleave=vm.star3Leave() ng-if=\"vm.selectedStarValue == 0\" ng-click=vm.getStarRating(3)><img width=38px height=38px ng-if=!vm.star3flag src=../../assets/images/star3empty.png> <img width=38px height=38px ng-if=vm.star3flag src=../../assets/images/star3full.png> </span><span ng-mouseover=vm.star2() ng-mouseleave=vm.star2Leave() ng-if=\"vm.selectedStarValue == 0\" ng-click=vm.getStarRating(2)><img width=38px height=38px ng-if=!vm.star2flag src=../../assets/images/star2empty.png> <img width=38px height=38px ng-if=vm.star2flag src=../../assets/images/star2full.png> </span><span ng-mouseover=vm.star1() ng-mouseleave=vm.star1Leave() ng-if=\"vm.selectedStarValue == 0\" ng-click=vm.getStarRating(1)><img width=38px height=38px class=img1 ng-if=!vm.star1flag src=../../assets/images/star1empty.png> <img width=38px height=38px class=img1 ng-if=vm.star1flag src=../../assets/images/star1full.png></span></div></div><!-- DESCRIPTION --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\"><h2 class=_description_font_size style=\"font-weight: bold\">{{vm.description || \'\'}}</h2></div><!-- COMMENTS FROM BACKEND --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center _main_comment_box\"><div ng-repeat=\"data in vm.categories\" ng-click=\"vm.selectedComment($index, data.selected)\" class=_comment_box ng-class=\"{\'_selected_comment\': data.selected}\">{{data.label}}</div></div><!-- ERROR --><!-- <div ng-if=\"vm.selectedCommentButtonError\" class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center _main_comment_box\">\n                    <div>\n                        El límite para seleccionar el máximo de comentarios es 3\n                    </div>\n                </div> --><!-- MANDATORY ERROR --><div ng-if=vm.errorMsgForStarAndCommentMandatory class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center _main_comment_box\"><div>Por favor seleccione la calificación de estrellas y cualquier comentario</div></div><!-- COMMENTS --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\"><h4 ng-if=\"vm.selectedStarValue < 5\">Puedes seleccionar hasta tres opciones.</h4><h4 ng-if=\"vm.selectedStarValue == 5\">Selecciona sólo una opción.</h4></div><!-- MANUAL COMMENT BOX --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\" ng-if=vm.showManualCommentBox><h3>Cuéntanos un poco más:</h3><div><textarea rows=4 cols=50 ng-model=vm.otherComment> </textarea></div></div><!-- BUTTON DIV --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\"><div><button type=submit ng-if=\"vm.selectedStarValue > 0\" ng-click=vm.submitRating() class=\"btn mt-lg _comment_box _enviar_button\">Enviar</button></div></div></div><!-- SHOW IF USER TRY MULTIPLE TIMES AND GET ERROR --><div class=row ng-if=vm.linkExpireError><div class=text-center><a><img src=../../assets/images/img_encuesta-01.png alt=Image class=\"block-center rating_logo-div\"></a></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\" ng-if=vm.expireLink><h2>Nos interesa conocer tu opinión.</h2></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\"><h3 class=_error_message_font_size>{{ vm.errorMsginHtml}}</h3></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\" ng-if=vm.expireLink><div><button type=submit ng-click=vm.retry() style=\"margin: 20px\" class=\"btn mt-lg\">Reintentar</button></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\" ng-if=vm.expireLink><a><img src=\"assets/images/logo transvip_2_Rating.png\" alt=Logo style=\"width: 200px\" class=\"block-center rating_logo-div\"></a></div></div></div><div class=\"panel-body paddingTopZero\" ng-if=vm.successMsg><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center\"><a><img src=../../assets/images/img_encuesta-01.png alt=Image class=\"block-center rating_logo-div\"></a></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center block-center\" style=\"margin: 50px 0px\"><h1>Calificación enviada</h1></div></div></div></div><style>._main_comment_box {\n        display: flex;\n        flex-wrap: wrap;\n        width: 100%;\n        justify-content: center;\n    }\n\n    ._comment_box {\n        border: 1px solid;\n        padding: 15px 20px;\n        margin: 6px;\n        border-radius: 5px;\n    }\n\n    ._comment_box:hover {\n        background-color: #FF6900;\n        color: white;\n    }\n\n    ._selected_comment {\n        background-color: #FF6900;\n        color: white;\n    }\n\n    textarea {\n        width: 65%;\n        border: 1.5px solid #FF6900;\n        border-radius: 20px;\n        padding: 10px 15px;\n        margin-bottom: 15px;\n    }\n\n    button {\n        background-color: #FF6900;\n        color: white;\n    }\n\n    .rating>._selected_star:before {\n        content: \"\\2605\";\n        position: absolute;\n        left: 0;\n        color: #FF6900;\n    }\n\n    .rating>._selected_star {\n        color: transparent;\n    }\n\n    .rating>._selected_star_0:hover:before,\n    .rating>._selected_star_0:hover~._selected_star_0:before {\n        content: url(\"../../assets/images/star1full.png\");\n        position: absolute;\n        left: 0;\n        padding: 5px 0px 0px 4px;\n        /* color: #FF6900; */\n    }\n\n    .rating>._selected_star_2:hover:before,\n    .rating>._selected_star_2:hover~._selected_star_2:before{\n        content: url(\"../../assets/images/star2full.png\");\n        position: absolute;\n        padding: 5px 0px 0px 4px;\n        left: 0;\n    }\n\n    .rating>._selected_star_3:hover:before,\n    .rating>._selected_star_3:hover~._selected_star_3:before {\n        content: url(\"../../assets/images/star3full.png\");\n        position: absolute;\n        padding: 5px 0px 0px 4px;\n        left: 0;\n    }\n\n    .rating>._selected_star_4:hover:before,\n    .rating>._selected_star_4:hover~._selected_star_4:before {\n        content: url(\"../../assets/images/star4full.png\");\n        position: absolute;\n        padding: 5px 0px 0px 4px;\n        left: 0;\n    }\n\n    .rating>._selected_star_5:hover:before,\n    .rating>._selected_star_5:hover~._selected_star_5:before {\n        content: url(\"../../assets/images/star5full.png\");\n        position: absolute;\n        padding: 5px 0px 0px 4px;\n        left: 0;\n    }\n\n\n    @media (max-width: 426px) {\n        ._heading_font_size {\n            font-size: 18px !important;\n        }\n\n        ._description_font_size {\n            font-size: 16px !important;\n        }\n\n        ._comment_box {\n            border: 1px solid;\n            padding: 8px !important;\n            margin: 6px;\n            border-radius: 5px;\n        }\n\n        h4 {\n            font-size: 12px;\n        }\n\n        textarea {\n            width: 240px;\n            border: 1px solid #FF6900;\n            border-radius: 5px;\n            padding: 9px;\n            margin-bottom: 15px;\n        }\n\n        ._error_message_font_size {\n            font-size: 20px;\n        }\n    }\n\n    ._enviar_button {\n        width: 208px;\n        height: 45px;\n        font-size: 17px;\n    }</style>");
$templateCache.put("app/driverRatingApp/driverRatingApp.html","");
$templateCache.put("app/forgotPassword/forgotPassword.html","<div class=\"container-fluid wd-xl block-center mt-xl ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=\"panel panel-default\" id=login><div class=\"panel-body paddingTopZero\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center logoBackground\"><a><img src=assets/images/transvip_sinlogo.png alt=Image class=\"block-center logo-div\"></a></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 logoHeadChild\"><p class=\"text-center pv\">{{\'forgotPasswordText\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><h6 class=text-center>{{\'forgotPasswordTextDescription\' | translate}}</h6><form name=forgetPasswordForm ng-submit=\"submit=true; forgetPasswordForm.$valid&&vm.forgetPassword()\" novalidate autocomplete=off><div class=\"form-group has-feedback\"><input type=email placeholder=\"{{\'emailPlaceholder\' | translate}}\" ng-model=vm.email required name=email class=form-control autocomplete=off pattern=^([_a-zA-Z0-9-+]+)(\\.[_a-zA-Z0-9-+]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*\\.)+([a-zA-Z]{2,3})$> <span class=\"fa fa-envelope form-control-feedback text-muted\"></span><div ng-if=\"forgetPasswordForm.email.$touched|| submit\" ng-messages=forgetPasswordForm.email.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'requiredEmail\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'validEmail\' | translate}}</div></div></div><button type=submit ng-if=!vm.buttonDisable class=\"btn btn-block btn-primary mt-lg\">{{\'forgotSubmitButton\' | translate}}</button></form><div ng-if=vm.errMsg class=\"alert alert-danger text-center alertMargin\">{{vm.errMsg}}</div><div ng-if=vm.successMsg class=\"alert alert-success text-center alertMargin\">{{vm.successMsg}}</div></div></div></div></div></div><!--<button class=\"btn\" ng-click=\"vm.print()\">print</button>-->");
$templateCache.put("app/login/login.html","<div class=\"container-fluid wd-xl block-center mt-xl ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=\"panel panel-default\" id=login><div class=\"panel-body paddingTopZero\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center logoBackground\"><a><img src=assets/images/logo_transvip.png alt=Image class=\"block-center logo-div\"></a></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 logoHeadChild\"><p class=\"text-center pv\">{{\'loginHead\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 loginFormStyle\"><form name=signInForm ng-submit=\"submit=true; signInForm.$valid&&vm.loginAdmin()\" novalidate autocomplete=off><div class=\"form-group has-feedback\"><input type=email placeholder=\"{{\'emailPlaceholder\' | translate}}\" ng-model=vm.email required name=email class=form-control autocomplete=off pattern=^([_a-zA-Z0-9-+]+)(\\.[_a-zA-Z0-9-+]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*\\.)+([a-zA-Z]{2,3})$> <span class=\"fa fa-envelope form-control-feedback text-muted\"></span><div ng-if=\"signInForm.email.$touched|| submit\" ng-messages=signInForm.email.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'requiredEmail\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'validEmail\' | translate}}</div></div></div><div class=\"form-group has-feedback\"><input type=password placeholder=\"{{\'passwordPlaceholder\' | translate}}\" ng-model=vm.password name=password required class=form-control autocomplete=off> <span class=\"fa fa-lock form-control-feedback text-muted\"></span><div ng-if=\"signInForm.password.$touched|| submit\" ng-messages=signInForm.password.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'passwordRequired\' | translate}}</div></div></div><!--<div class=\"form-group has-feedback\">--><!--<select ng-model=\"vm.languageSelected\" name=\"language\" required=\"required\" class=\"form-control\" ng-change=\"vm.selectParticularLanguage(vm.languageSelected)\">--><!--<option value=\"\" selected disabled>{{\'selectLanguage\'|translate}}</option>--><!--<option value=\"en\">English</option>--><!--<option value=\"spanish\">Spanish</option>--><!--</select>--><!--<div ng-if=\"signInForm.language.$touched|| submit\" ng-messages=\"signInForm.language.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">{{\'selectLanguageR\'|translate}}</div>--><!--</div>--><!--</div>--><div class=\"form-group has-feedback\"><a style=\"cursor: pointer\" ui-sref=forgetPassword>{{\'forgotPassword\'|translate}}</a></div><button type=submit class=\"btn btn-block btn-primary mt-lg\" title=\"Log In\">{{\'loginButtonText\' | translate}}</button><!--<div ng-controller=\"RegisterFormController\">--><!--<button type=\"submit\" class=\"btn btn-block btn-primary mt-lg\" ng-click=\"register\">signup</button>--><!--</div>--></form><div ng-if=vm.authMsg class=\"alert alert-danger text-center alertMargin\">{{vm.authMsg}}</div></div></div></div></div></div><!--<button class=\"btn\" ng-click=\"vm.print()\">print</button>-->");
$templateCache.put("app/resetPassword/resetPassword.html","<div class=\"container-fluid wd-xl block-center mt-xl ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=\"panel panel-default\" id=login><div class=\"panel-body paddingTopZero\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center logoBackground\"><a><img src=assets/images/transvip_sinlogo.png alt=Image class=\"block-center logo-div\"></a></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 logoHeadChild\"><p class=\"text-center pv\" ng-if=\"vm.typeUser == \'customer\'\">Reiniciar Contraseña Cliente</p><p class=\"text-center pv\" ng-if=\"vm.typeUser == \'fleet\'\">Reiniciar Contraseña Conductor</p><p class=\"text-center pv\" ng-if=\"vm.typeUser == \'admin\'\">Reiniciar Contraseña</p></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 loginFormStyle\"><form name=resetPasswordForm ng-submit=\"submit=true; resetPasswordForm.$valid&&vm.resetPassword()\" novalidate autocomplete=off><!--<div class=\"form-group has-feedback\">--><!--<input type=\"email\" placeholder=\"Email ID\"--><!--ng-model=\"vm.email\" required=\"required\" name=\"email\" class=\"form-control\"--><!--autocomplete=\"off\"--><!--pattern=\"^([_a-zA-Z0-9-+]+)(\\.[_a-zA-Z0-9-+]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*\\.)+([a-zA-Z]{2,3})$\"/>--><!--<span class=\"fa fa-envelope form-control-feedback text-muted\"></span>--><!--<div ng-if=\"resetPasswordForm.email.$touched|| submit\" ng-messages=\"resetPasswordForm.email.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter an email id.--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid email id.--><!--</div>--><!--</div>--><!--</div>--><div ng-if=!vm.errorMessage class=\"form-group has-feedback\"><input type=password placeholder=\"{{\'newPasswordPlaceholder\' | translate}}\" ng-model=vm.password name=password required class=form-control autocomplete=off ng-change=vm.matchPassword(vm.password) ng-minlength=8 ng-maxlength=16> <span class=\"fa fa-lock form-control-feedback text-muted\"></span><div ng-if=\"resetPasswordForm.password.$touched|| submit\" ng-messages=resetPasswordForm.password.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'newPasswordRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'passwordMin\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'passwordMax\' | translate}}</div></div></div><div ng-if=!vm.errorMessage class=\"form-group has-feedback\"><input type=password placeholder=\"{{\'ConfirmPasswordPlaceholder\' | translate}}\" ng-model=vm.confirmPassword name=confirmPassword required class=form-control ng-change=vm.matchConfirmPassword(vm.confirmPassword) autocomplete=off ng-minlength=8 ng-maxlength=16> <span class=\"fa fa-lock form-control-feedback text-muted\"></span><div ng-if=\"resetPasswordForm.confirmPassword.$touched|| submit\" ng-messages=resetPasswordForm.confirmPassword.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'confirmPasswordRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'passwordMin\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'passwordMax\' | translate}}</div></div><div class=\"errormessage text-danger\" ng-if=vm.passwordMatchFlag>{{\'passwordNotMatch\' | translate}}</div></div><button ng-if=!vm.errorMessage type=submit class=\"btn btn-block btn-primary mt-lg\">Cambiar Contraseña</button></form><div ng-if=vm.errMsg class=\"alert alert-danger text-center alertMargin\">{{vm.errMsg}}</div><div ng-if=\"vm.successMsg && !vm.errorMessage\" class=\"alert alert-success text-center alertMargin\">{{vm.successMsg}}</div><div ng-if=\"vm.successMsg && vm.errorMessage && vm.typeUser == \'fleet\'\" class=\"alert alert-success1 text-center alertMargin\">La contraseña fue cambiada exitosamente.<br>Ahora vuelve a iniciar sesión en la App<br>Conductor...</div><div ng-if=\"vm.successMsg && vm.errorMessage && vm.typeUser == \'customer\'\" class=\"alert alert-success1 text-center alertMargin\">La contraseña fue cambiada exitosamente.<br>Ahora vuelve a iniciar sesión en la App Cliente...</div></div></div></div></div></div><!--<button class=\"btn\" ng-click=\"vm.print()\">print</button>-->");
$templateCache.put("app/components/dialogViews/MessageDetails.html","<form name=operationRegisterForm ng-submit=\"submit=true;operationRegisterForm.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog aria-label=\"List dialog\" style=\"width:800px;max-width: 100%\"><md-dialog-content ng-class=\"{\'whirl duo\' : items.loading }\"><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label ng-if=copymessage style=color:red>El cuerpo del mensaje fue copiado exitosamente.</label><button ng-click=copyMessage(items.html_data) type=submit style=\"float: right\" class=\"btn btn-primary\">Copiar</button></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\"><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>Título</label><input disabled type=text ng-model=items.title placeholder=Nombre class=form-control></div></div></div><div class=basicDetailsDiv><div class=row><div style=\"padding: 20px\" class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>Mensaje</label><!--<textarea class=\"form-control helpTextArea\" ng-model=\"data.html_data\" readonly ></textarea>--><div class=\"form-control MessageShow\" ng-bind-html=items.html_data></div></div><span style=\"float: right;font-size: 11px;padding: 0px;margin-right: 20px\">{{changeDateIntoSpanish(items.created_at)}} {{::items.created_at | date: \'HH:mm\'}}</span></div></div></div></md-dialog-content><md-dialog-actions><!-- <md-button type=\"submit\" class=\"md-primary\">\n                {{\'confirmButton\' | translate}}\n            </md-button> --><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></md-dialog><input id=copy style=\"opacity: 0 ; z-index:0\" type=text></form>");
$templateCache.put("app/components/dialogViews/ReceptorDetails.html","<form name=operationRegisterForm ng-submit=\"submit=true;operationRegisterForm.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog aria-label=\"List dialog\" style=\"width:800px;max-width: 100%\"><md-dialog-content ng-class=\"{\'whirl duo\' : items.loading }\" style=\"overflow-x: hidden\"><h3 style=\"text-align: center; padding: 15px\" class=ng-cloak><u>Receptores</u></h3><div class=\"row m0 p10\"><!-- <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">\n                    <div class=\"row\">\n                        <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">\n                            <div class=\"panel panel-default\">\n                                <div class=\"panel-body\"> --><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control ng-model-options=\"{ debounce: 500 }\" placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=items.searchLogFleet ng-change=items.getFillter()></div></div><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><!-- <input type=\"type\" id=\"searchText\"  is-number=\"\" class=\"form-control\" ng-model-options=\"{ debounce: 500 }\" placeholder=\"Número de móvil\"\n                                ng-model=\"items.UniqueCarLogFleet\" ng-change=\"items.getFillter()\"> --> <input id=searchText type=text class=form-control is-number=\"\" name=binNumber placeholder=\"Número de móvil\" ng-model=items.UniqueCarLogFleet ng-change=items.getFillter()></div></div><!--<div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\">--><!--<label class=\"control-label\">Records per page</label>--><!--<select class=\"form-control\" ng-model=\"vm.itemsPerPageSelected\"--><!--ng-options=\"pages for pages in vm.searchModel.limitOptions\"--><!--ng-change=\"vm.getPagesCount()\"></select>--><!--</div>--></div><div style=\"padding-top: 20px\" class=\"table-responsive tableWithMasterDataParentDive\" ng-switch=\"(items.driverList | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><!-- <th style=\"width:70px;\" current-text=\"vm.predicate\" title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=\"vm.reverse\">\n                                    id\n                                </th> --><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>Nombre</th><th style=width:70px current-text=vm.predicate title=\"{{\'Nombre\' | translate}}\" text=\"\'admin_id\'\" check=vm.reverse>Email</th><th style=width:70px current-text=vm.predicate title=\"{{\'roleNameLabel\' | translate}}\" text=\"\'roleName\'\" check=vm.reverse>Movil</th><th style=width:70px current-text=vm.predicate title=\"{{\'roleNameLabel\' | translate}}\" text=\"\'roleName\'\" check=vm.reverse>Leído</th></tr></thead><tbody style=\"max-height: 200px\" ng-if=\"items.driverList.length > 0\" when-scrolled=items.paginationChangedForLogDriverList()><tr ng-repeat=\"data in filtered = items.driverList\"><!-- <td style=\"width:70px;\">{{$index + 1}}</td> --><td style=width:70px>{{::data.fleet_name}}</td><td style=width:70px>{{::data.email}}</td><td style=width:70px>{{::data.unique_car_id || \'--\'}}</td><td style=width:70px ng-if=\"data.seen_at != null\">{{changeDateIntoSpanish(data.seen_at)}} {{::data.seen_at | date: \'HH:mm\'}}</td><td style=width:70px ng-if=\"data.seen_at == null\">--</td><!-- <td style=\"width:70px;\"> <i class=\"fa fa-user\" aria-hidden=\"true\"></i>  {{::data.fleet_count || 0}}</td> --><!--<td>{{data.admin_type}}</td>--><!--<td>{{data.email}}</td>--><!--<td>{{data.role.roleName || \'&#45;&#45;\'}}</td>--></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noRole\' | translate}}</th></tr></tfoot></table></div><div class=row><!-- <div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\">\n                                            <span ng-hide=\"vm.filterOn\">{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue\n                                                + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span>\n                                            <span ng-if=\"vm.filterOn\">{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}}\n                                                {{\'enteries\' | translate}}</span>\n                                        </div> --><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-if=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-if=\"sp_pagination\" ng-if=\"watchPagination\"&ndash;&gt;--><!--<nav>--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\"--><!--ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><!-- <div class=\"pull-right\" ng-if=\"vm.sp_pagination\">\n                                                <ul uib-pagination total-items=\"vm.dataLength\" items-per-page=\"vm.itemsPerPageGot\" ng-change=\"vm.paginationNew(vm.currentPage)\"\n                                                    ng-model=\"vm.currentPage\" max-size=\"vm.maxSize\" class=\"pagination-sm\" boundary-link-numbers=\"true\"\n                                                    rotate=\"false\"></ul>\n                                            </div>\n                                            <div class=\"clearfix\"></div> --></div><!-- </div>\n                                </div>\n                            </div>\n                        </div>\n\n                    </div> --></div></div></md-dialog-content><md-dialog-actions><!-- <md-button type=\"submit\" class=\"md-primary\">\n                    {{\'confirmButton\' | translate}}\n                </md-button> --><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></md-dialog></form>");
$templateCache.put("app/components/dialogViews/SearchCustomerPopInPos.html","<md-dialog aria-label=\"List dialog\" style=width:400px><md-dialog-content ng-class=\"{\'whirl duo\' : items.loading }\"><div class=\"row m0 p10\" style=\"height: 300px\"><form name=operationRegisterForm ng-submit=\"submit=true;operationRegisterForm.$valid&&vm.registerApi()\" novalidate autocomplete=off><!-- <div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\">\n                    <p class=\"editDocumentP text-center\" ng-if=\"!items.editData\" style=\"text-decoration: underline;\">{{\'operationPointAdd\' | translate}}</p>\n                    <p class=\"editDocumentP text-center\" ng-if=\"items.editData\" style=\"text-decoration: underline;\">{{\'operationPointChange\' | translate}}</p>\n                </div> --><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\"><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>Buscar cliente :</label><input type=text ng-model=vm.dataToFill.customerMobile placeholder=\"Buscar cliente\" uib-typeahead=\"customers as customers.name for customers in searchCustomer($viewValue)\" typeahead-loading=loadingCustomers typeahead-no-results=noResults class=\"form-control createBookingSelect\" name=searchCustomer typeahead-on-select=vm.onSelectingCustomer() typeahead-wait-ms=200 typeahead-template-url=customTemplate.html required ng-class=\"{ \'has-error\': createBookingForm.searchCustomer.$touched && createBookingForm.searchCustomer.$invalid }\"> <i ng-if=loadingCustomers class=\"glyphicon glyphicon-refresh\"></i><div ng-if=noResults class=mt5><span><i class=\"glyphicon glyphicon-remove\"></i> {{\'searchCustError\' | translate}}</span><!-- <span class=\"pull-right\">\n                                                    <a class=\"btn btn-primary tableButton\" ng-click=\"vm.addNewCustomer()\">{{\'searchCustAddUser\' | translate}}</a>\n                                                </span> --></div><div ng-if=\"createBookingForm.searchCustomer.$touched|| submit\" ng-messages=createBookingForm.searchCustomer.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'searchCustReq\' | translate}}</div></div></div></div></div></form></div></md-dialog-content><md-dialog-actions><md-button type=button ng-click=confirmUpload() class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></md-dialog><script type=text/ng-template id=customTemplate.html><a style=\"cursor: pointer;\">\n            <span class=\"displayFlex\">\n                <!-- <span>\n                    <img ng-src=\"{{match.model.profile_pic_thumb || \'assets/images/noImage.jpeg\'}}\" width=\"35\">\n                </span> -->\n                <span style=\"padding-left: 10px;\">\n                    <span ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"></span>\n                    <span>/</span>\n                    <span ng-bind-html=\"match.model.email\"></span>\n                    <br/>\n                    <span ng-bind-html=\"match.model.phone_number\"></span>\n                </span>\n            </span>\n        </a></script>");
$templateCache.put("app/components/dialogViews/ViewGroupDetails.html","<div class=basicDiv style=\"width: 100%\" ng-class=\"{\'whirl duo\' : items.loading }\"><p class=\"basicRegistrationP backgroundBasicPending text-center\">Ver lista de difusión</p><div class=basicDetailsDiv><form method=post name=givePermissionForm ng-submit=\"submit=true;givePermissionForm.$valid&&vm.addRoleApiHit()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label class=control-label>Nombre <span style=color:red>*</span></label><input disabled type=text class=form-control ng-model=items.group_name name=roleName placeholder=Nombre required ng-class=\"{ \'has-error\': givePermissionForm.roleName.$touched && givePermissionForm.roleName.$invalid }\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\"givePermissionForm.roleName.$touched|| submit\" ng-messages=givePermissionForm.roleName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'roleNameReq\' | translate}}</div></div></div><!-- <div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"padding-top: 20px\">\n                    <label class=\"control-label\">Descripción</label>\n                    <textarea disabled class=\"form-control\" ng-model=\"items.group_description\" name=\"description\" placeholder=\"Descripción\" ng-class=\"{ \'has-error\': givePermissionForm.description.$touched && givePermissionForm.description.$invalid }\"></textarea>\n                </div> --><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"padding-top: 20px\"><div class=\"col-sm-4 col-md-4 col-lg-4\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input style=\"width: 100%\" ng-model-options=\"{ debounce: 500 }\" type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=items.search ng-change=items.getFilter()></div></div><div class=\"col-sm-4 col-md-4 col-lg-4\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input style=\"width: 100%\" type=text is-number=\"\" id=UniqueCar class=form-control placeholder=\"Número de móvil\" ng-model=items.UniqueCar ng-change=items.getFilter()></div></div></div><div style=\"padding-top: 20px;max-height: 200px;overflow-y: hidden\" class=\"table-responsive tableWithMasterDataParentDive col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-switch=\"(vm.FleetArray | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead ng-if=\"items.fleet_list.length > 0\"><tr><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>Nombre</th><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>Email</th><th style=width:70px current-text=vm.predicate title=\"{{\'pointName\' | translate}}\" text=\"\'pointname\'\" check=vm.reverse>Movil</th><!-- <th style=\"width:70px;\" current-text=\"vm.predicate\" title=\"{{\'pointName\' | translate}}\" text=\"\'pointname\'\" check=\"vm.reverse\">\n    \n                                                        </th> --></tr></thead><tbody style=\"max-height: 150px\" ng-if=\"items.fleet_list.length > 0\" when-scrolled=items.paginationChangedForVeiwDriverInGroup()><tr ng-repeat=\"data in filtered = items.fleet_list| filter:vm.search | filter:vm.UniqueCar\"><td style=width:70px>{{::data.fleet_name}}</td><td style=width:70px>{{::data.email}}</td><td style=width:70px>{{data.unique_car_id || \'--\'}}</td></tr></tbody></table></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\" style=margin-top:10px><button class=\"btn btn-primary\" ng-click=closeDialog() style=width:200px>{{\'CloseButton\' | translate}}</button></div></div></form></div></div>");
$templateCache.put("app/components/dialogViews/addAgrrement.html","<form name=operationRegisterForm ng-submit=\"submit=true;operationRegisterForm.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog aria-label=\"List dialog\" style=width:800px><md-dialog-content ng-class=\"{\'whirl duo\' : items.loading }\"><div class=\"row m0 p10\" style=\"height: 280px\"><!-- <form name=\"operationRegisterForm\" ng-submit=\"submit=true;operationRegisterForm.$valid&&vm.registerApi()\" novalidate autocomplete=\"off\"> --><!-- <div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\">\n                    <p class=\"editDocumentP text-center\" ng-if=\"!items.editData\" style=\"text-decoration: underline;\">{{\'operationPointAdd\' | translate}}</p>\n                    <p class=\"editDocumentP text-center\" ng-if=\"items.editData\" style=\"text-decoration: underline;\">{{\'operationPointChange\' | translate}}</p>\n                </div> --><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\"><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>Convenio :</label><input type=text disabled ng-model=items.agreementName placeholder=Convenio class=form-control maxlength=50 name=pointName1 required ng-class=\"{ \'has-error\': operationRegisterForm.pointName1.$touched && operationRegisterForm.pointName1.$invalid }\"><div ng-if=\"operationRegisterForm.pointName1.$touched|| submit\" ng-messages=operationRegisterForm.pointName1.$error><div class=\"errormessage text-danger\" ng-message=required>Convenio es requerido</div></div></div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\"><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><button type=button class=\"btn btn-primary\" style=\"float: right\" ng-click=openPopUpForAgrrement()>Agregar convenio</button></div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\"><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>Pasajero :</label><input type=text ng-model=items.cName placeholder=Pasajero uib-typeahead=\"customers as customers.name for customers in searchCustomer($viewValue)\" typeahead-loading=loadingCustomers typeahead-no-results=noResults class=\"form-control createBookingSelect\" name=searchCustomer typeahead-on-select=onSelectingCustomer($event) typeahead-wait-ms=200 typeahead-template-url=customTemplate.html ng-class=\"{ \'has-error\': createBookingForm.searchCustomer.$touched && createBookingForm.searchCustomer.$invalid }\"> <i ng-if=loadingCustomers class=\"glyphicon glyphicon-refresh\"></i><div ng-if=noResults class=mt5><span><i class=\"glyphicon glyphicon-remove\"></i> {{\'searchCustError\' | translate}}</span><!-- <span class=\"pull-right\">\n                                                    <a class=\"btn btn-primary tableButton\" ng-click=\"vm.addNewCustomer()\">{{\'searchCustAddUser\' | translate}}</a>\n                                                </span> --></div><div ng-if=\"operationRegisterForm.searchCustomer.$touched|| submit\" ng-messages=operationRegisterForm.searchCustomer.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'searchCustReq\' | translate}}</div></div></div></div></div></div></md-dialog-content><md-dialog-actions><md-button type=sumbit class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></md-dialog></form><script type=text/ng-template id=customTemplate.html><a style=\"cursor: pointer;\">\n        <span class=\"displayFlex\">\n            <!-- <span>\n                    <img ng-src=\"{{match.model.profile_pic_thumb || \'assets/images/noImage.jpeg\'}}\" width=\"35\">\n                </span> -->\n            <span style=\"padding-left: 10px;\">\n                <span ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"></span>\n                <span>/</span>\n                <span ng-bind-html=\"match.model.email\"></span>\n                <br/>\n                <span ng-bind-html=\"match.model.phone_number\"></span>\n            </span>\n        </span>\n    </a></script>");
$templateCache.put("app/components/dialogViews/addBudget.html","<form name=budgetFrom ng-submit=\"submit=true;budgetFrom.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog aria-label=\"List dialog\" style=width:800px><md-dialog-content ng-class=\"{\'whirl duo\' : items.loading }\"><div class=\"row m0 p10\" style=\"height: 280px\"><h3 style=\"text-align: center\">Definir Presupuesto</h3><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\"><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>Habilitar Control de Gastos :</label><div style=\"float: right\"><i class=boleeanTypeColor ng-click=\"items.budgetToggleButton = !items.budgetToggleButton\" ng-class=\"{\'fa fa-toggle-on\': items.budgetToggleButton , \'fa fa-toggle-off\': !items.budgetToggleButton}\"></i></div></div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\"><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>Presupuesto ($)<span style=color:red>*</span></label><input ng-disabled=!items.budgetToggleButton type=number ng-model=items.budgetAmount placeholder=Presupuesto class=form-control name=Presupuesto required ng-class=\"{ \'has-error\': budgetFrom.Presupuesto.$touched && budgetFrom.Presupuesto.$invalid }\"><div ng-if=\"budgetFrom.Presupuesto.$touched || submit\" ng-messages=budgetFrom.Presupuesto.$error><div class=\"errormessage text-danger\" ng-message=required>Se requiere presupuesto</div><div class=\"errormessage text-danger\" ng-message=number>No ingresaste un número válido</div></div></div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\"><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>Advertencia ($)<span style=color:red>*</span></label><input ng-disabled=!items.budgetToggleButton type=number ng-model=items.warningAmount placeholder=Advertencia class=form-control name=Advertencia required ng-class=\"{ \'has-error\': budgetFrom.Advertencia.$touched && budgetFrom.Advertencia.$invalid }\"><div ng-if=\"budgetFrom.Advertencia.$touched || submit\" ng-messages=budgetFrom.Advertencia.$error><div class=\"errormessage text-danger\" ng-message=required>Se requiere advertencia</div><div class=\"errormessage text-danger\" ng-message=number>No ingresaste un número válido</div></div></div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\"><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>Enviar Email Alerta a</label><textarea class=form-control ng-readonly=!items.budgetToggleButton rows=4 cols=50 ng-model=items.emails> </textarea></div></div></div></div></md-dialog-content><md-dialog-actions><md-button type=sumbit class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></md-dialog></form>");
$templateCache.put("app/components/dialogViews/addCancelReason.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><form method=post name=addCancelReason ng-submit=\"submit=true;addCancelReason.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">{{\'addReasonHead\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>{{\'reasonVariable\' | translate}} <span style=color:red>*</span></label><textarea placeholder=\"{{\'messagePlaceholder\' | translate}}\" class=form-control name=reason ng-model=items.reason required ng-class=\"{ \'has-error\': addCancelReason.reason.$touched && addCancelReason.reason.$invalid }\"></textarea><div ng-if=\"addCancelReason.reason.$touched|| submit\" ng-messages=addCancelReason.reason.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'editReasonError\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid item price.</div>--></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>{{\'cancelReasonEnglish\' | translate}} <span style=color:red>*</span></label><textarea placeholder=\"{{\'messagePlaceholder\' | translate}}\" class=form-control name=reasonEnglish ng-model=items.reason_name_english pattern=\"^[a-zA-Z0-9 ]+$\" required ng-class=\"{ \'has-error\': addCancelReason.reasonEnglish.$touched && addCancelReason.reasonEnglish.$invalid }\" ng-maxlength=50></textarea><div ng-if=\"addCancelReason.reasonEnglish.$touched|| submit\" ng-messages=addCancelReason.reasonEnglish.$error><div class=\"errormessage text-danger\" ng-message=required>Favor ingrese Causa de Cancelación (Versión Inglés)</div><div class=\"errormessage text-danger\" ng-message=pattern>Razón (Versión Inglés) no válido.</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'usernameMax\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid item price.</div>--></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>{{\'descriptionVariable\' | translate}}</label><textarea placeholder=\"{{\'messagePlaceholder\' | translate}}\" class=form-control name=description ng-model=items.description ng-class=\"{ \'has-error\': addCancelReason.description.$touched && addCancelReason.description.$invalid }\"></textarea><div ng-if=\"addCancelReason.description.$touched|| submit\" ng-messages=addCancelReason.description.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'descriptionR\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid item price.</div>--></div></div><!-- ticket Tv-1931 toggle buttons--><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 visibilityFlags\"><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'visibleVariable\' | translate}}</p><div class=displayflex><p class=classBold>App</p><div style=\"font-size: 25px\" class=boleeanTypeColor><i ng-click=\"changeToggle(\'app\')\" ng-class=\"{\'fa fa-toggle-on\': app , \'fa fa-toggle-off\': !app}\"></i></div></div><div class=displayflex><p class=classBold>Panel</p><div style=\"font-size: 25px\" class=boleeanTypeColor><i ng-click=\"changeToggle(\'panel\')\" ng-class=\"{\'fa fa-toggle-on\': panel, \'fa fa-toggle-off\': !panel}\"></i></div></div><div class=displayflex><p class=classBold>POS</p><div style=\"font-size: 25px\" class=boleeanTypeColor><i ng-click=\"changeToggle(\'pos\')\" ng-class=\"{\'fa fa-toggle-on\':pos , \'fa fa-toggle-off\': !pos}\"></i></div></div><div class=displayflex><p class=classBold>Web</p><div style=\"font-size: 25px\" class=boleeanTypeColor><i ng-click=\"changeToggle(\'web\')\" ng-class=\"{\'fa fa-toggle-on\': web , \'fa fa-toggle-off\': !web}\"></i></div></div></div></div></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dialogViews/addCorporateProfile.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><form method=post name=addCorporateProfile ng-submit=\"submit=true;addCorporateProfile.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">{{\'addCorporateProfile\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt10\"><label>{{\'employeeCode\' | translate}}<span style=color:red>*</span></label><input type=text placeholder=\"{{\'employeeCode\' | translate}}\" class=form-control name=employeeCode ng-model=items.uniqueCode required ng-class=\"{ \'has-error\': addCorporateProfile.employeeCode.$touched && addCorporateProfile.employeeCode.$invalid }\"><div ng-if=\"addCorporateProfile.employeeCode.$touched|| submit\" ng-messages=addCorporateProfile.employeeCode.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'employeeCR\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid employee code.</div>--></div></div></div></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dialogViews/addCorrectFareReason.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><form method=post name=addCorrectFareReason ng-submit=\"submit=true;addCorrectFareReason.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">{{\'addCorrectReason\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>{{\'reasonLabel\' | translate}}<span style=color:red>*</span></label><textarea placeholder=\"{{\'messagePlaceholder\' | translate}}\" class=form-control name=reason ng-model=items.reason required ng-class=\"{ \'has-error\': addCorrectFareReason.reason.$touched && addCorrectFareReason.reason.$invalid }\"></textarea><div ng-if=\"addCorrectFareReason.reason.$touched|| submit\" ng-messages=addCorrectFareReason.reason.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'editReasonError\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid item price.</div>--></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>{{\'description\' | translate}}</label><textarea placeholder=\"{{\'messagePlaceholder\' | translate}}\" class=form-control name=description ng-model=items.description ng-class=\"{ \'has-error\': addCorrectFareReason.description.$touched && addCorrectFareReason.description.$invalid }\"></textarea><div ng-if=\"addCorrectFareReason.description.$touched|| submit\" ng-messages=addCorrectFareReason.description.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'descriptionR\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid item price.</div>--></div></div></div></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dialogViews/addDriverEarning.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><form method=post name=addDriverEarning ng-submit=\"submit=true;addDriverEarning.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">{{\'addPopHead\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt10\"><label class=control-label>{{\'branchLabel\' | translate}}<span style=color:red>*</span></label><ui-select ng-model=items.branchSelected name=branch required ng-class=\"{ \'has-error\': addDriverEarning.branch.$touched && addDriverEarning.branch.$invalid }\" close-on-select=true><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in items.branches | filter: $select.search\"><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select><div ng-if=\"addDriverEarning.branch.$touched|| submit\" ng-messages=addDriverEarning.branch.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'branchR\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label class=control-label>{{\'typeServiceHead\' | translate}}<span style=color:red>*</span></label><ui-select ng-model=items.typeOfServiceSelected name=service required ng-class=\"{ \'has-error\': addDriverEarning.service.$touched && addDriverEarning.service.$invalid }\" close-on-select=true ng-change=serviceChanged()><ui-select-match placeholder=\"{{\'selectTService\' | translate}}\">{{$select.selected.service_name}}</ui-select-match><ui-select-choices repeat=\"services.id as services in items.typeOfService | filter: $select.search\"><div ng-bind-html=services.service_name></div></ui-select-choices></ui-select><div ng-if=\"addDriverEarning.service.$touched|| submit\" ng-messages=addDriverEarning.service.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'serviceReq\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label class=control-label>{{\'vehicleTypeLabel\' | translate}}<span style=color:red>*</span></label><ui-select ng-model=items.vehicleTypeSelected name=vehicle required ng-class=\"{ \'has-error\': addDriverEarning.vehicle.$touched && addDriverEarning.vehicle.$invalid }\" close-on-select=true ng-disabled=\"items.vehicleType.length == 0\"><ui-select-match placeholder=\"{{\'vehiclePlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"vehicles.id as vehicles in items.vehicleType | filter: $select.search\"><div ng-bind-html=vehicles.name></div></ui-select-choices></ui-select><div ng-if=\"addDriverEarning.vehicle.$touched|| submit\" ng-messages=addDriverEarning.vehicle.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'selectTVehicleR\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'forAirportLabel\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=items.airportService name=airportService placeholder=\"{{\'forAirportLabel\' | translate}}\" required maxlength=3 ng-class=\"{ \'has-error\': addDriverEarning.airportService.$touched && addDriverEarning.airportService.$invalid }\" pattern=^[1-9][0-9.]*$><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\"addDriverEarning.airportService.$touched|| submit\" ng-messages=addDriverEarning.airportService.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'forAirportReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'forAirportValid\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'forNonAirportLabel\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=items.nonAirportService name=nonAirportService placeholder=\"{{\'forNonAirportLabel\' | translate}}\" pattern=^[1-9][0-9.]*$ required maxlength=3 ng-class=\"{ \'has-error\': addDriverEarning.nonAirportService.$touched && addDriverEarning.nonAirportService.$invalid }\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\"addDriverEarning.nonAirportService.$touched|| submit\" ng-messages=addDriverEarning.nonAirportService.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'forNonAirportReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'forNonAirportValid\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><div ng-if=items.error class=\"alert alert-danger text-center alertMargin\">{{items.error}}</div></div></div></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dialogViews/addDriverManually.html","<form name=operationRegisterForm ng-submit=\"submit=true;operationRegisterForm.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog aria-label=\"List dialog\" style=width:600px><md-dialog-content ng-class=\"{\'whirl duo\' : items.loading }\"><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\"><h3 style=\"border-bottom: 2px solid grey;padding-bottom: 5px\">{{\'AddPopUpHeading\' | translate}}</h3><!-- <div class=\"row\"> --><!-- <div class=\"col-lg-4 col-sm-4 col-xs-4 col-md-12 \">\n                            <label>Nro Veiculo:</label>\n                        </div> --><!-- <div class=\"col-lg-7 col-sm-7 col-xs-7 col-md-12 \">\n                            <input type=\"text\" ng-model=\"items.pointName1\" placeholder=\"Nro Veiculo\" class=\"form-control\" maxlength=\"50\" name=\"pointName1\"\n                                style=\"border-radius: 0;\" required ng-class=\"{ \'has-error\': operationRegisterForm.pointName1.$touched && operationRegisterForm.pointName1.$invalid }\">\n                            <div ng-if=\"operationRegisterForm.pointName1.$touched|| submit\" ng-messages=\"operationRegisterForm.pointName1.$error\">\n                                <div class=\"errormessage text-danger\" ng-message=\"required\">Nombre es requerido</div>\n                            </div>\n                        </div>\n                        <div class=\"col-lg-1 col-sm-1 col-xs-1 col-md-12 \" style=\"top: -1px;left: 390px;position: absolute;\">\n                            <button type=\"button\" class=\"SearchButton\">\n                                <i class=\"fa fa-search\"></i>\n                            </button>\n                        </div> --><!-- </div> --></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\"><div class=row><div class=\"col-lg-4 col-sm-4 col-xs-4 col-md-12\"><label>{{\'NorVehicle\' | translate}}:</label></div><div class=\"col-lg-7 col-sm-7 col-xs-7 col-md-12\"><input type=text ng-model=items.pointName1 placeholder=\"{{\'NorVehicle\' | translate}}\" class=form-control maxlength=50 name=pointName1 style=\"border-radius: 0;border-top-left-radius: 4px;border-bottom-left-radius: 4px\" required ng-class=\"{ \'has-error\': operationRegisterForm.pointName1.$touched && operationRegisterForm.pointName1.$invalid }\"><div ng-if=\"operationRegisterForm.pointName1.$touched|| submit\" ng-messages=operationRegisterForm.pointName1.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'NorVehicle\' | translate}} es requerido</div></div><div class=\"errormessage text-danger\" ng-if=errorFlag>{{errorMessage}}</div></div><div class=\"col-lg-1 col-sm-1 col-xs-1 col-md-12\" style=\"top: -1px;left: 390px;position: absolute\"><button type=button class=SearchButton ng-click=searchVechile(items.pointName1)><i class=\"fa fa-search\" style=\"font-weight: bold\"></i></button></div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\" style=\"padding-top: 5px\"><div class=row><div class=\"col-lg-4 col-sm-4 col-xs-4 col-md-12\"><label>{{\'Conductor\' | translate}}:</label></div><div class=\"col-lg-8 col-sm-8 col-xs-9 col-md-12\"><input disabled type=text ng-model=items.pointName2 placeholder=\"{{\'Conductor\' | translate}}\" class=form-control maxlength=50 name=pointName2 required ng-class=\"{ \'has-error\': operationRegisterForm.pointName2.$touched && operationRegisterForm.pointName2.$invalid }\"><div ng-if=\"operationRegisterForm.pointName2.$touched|| submit\" ng-messages=operationRegisterForm.pointName2.$error><!-- <div class=\"errormessage text-danger\" ng-message=\"required\">{{\'Conductor\' | translate}} es requerido</div> --></div></div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\" style=\"padding-top: 5px\"><div class=row><div class=\"col-lg-4 col-sm-4 col-xs-4 col-md-12\"><label>{{\'TypeOfVehicle\' | translate}}:</label></div><div class=\"col-lg-8 col-sm-8 col-xs-9 col-md-12\"><input disabled type=text ng-model=items.pointName3 placeholder=\"{{\'TypeOfVehicle\' | translate}}\" class=form-control maxlength=50 name=pointName3 required ng-class=\"{ \'has-error\': operationRegisterForm.pointName3.$touched && operationRegisterForm.pointName3.$invalid }\"><div ng-if=\"operationRegisterForm.pointName3.$touched|| submit\" ng-messages=operationRegisterForm.pointName3.$error><!-- <div class=\"errormessage text-danger\" ng-message=\"required\">{{\'TypeOfVehicle\' | translate}} es requerido</div> --></div></div></div></div></div></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></md-dialog></form>");
$templateCache.put("app/components/dialogViews/addEditToOperationPoint.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><md-dialog-content ng-class=\"{\'whirl duo\' : items.loading }\"><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" ng-if=!items.editData style=\"text-decoration: underline\">{{\'operationPointAdd\' | translate}}</p><p class=\"editDocumentP text-center\" ng-if=items.editData style=\"text-decoration: underline\">{{\'operationPointChange\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\"><div class=row><div class=\"col-lg-4 col-sm-4 col-xs-12 col-md-4\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=items.search ng-change=getSearchedResult()></div></div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><p class=\"alert alert-danger\" ng-if=items.errorNotSelected>{{\'operationError\'| translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\" style=max-height:300px;overflow-y:auto when-scrolled=paginationChanged()><div class=table-responsive><table class=\"table table-hover\"><thead><tr><th>{{\'pointName\' | translate}}</th><th>{{\'pickUpAddressDefault\' | translate}}</th><th>{{\'branchLabel\' | translate}}</th><th>{{\'selectOnly\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"data in items.opData\" ng-style=\"{\'background-color\':data.color}\"><td>{{data.point_name}}</td><td>{{data.address}}</td><td>{{data.region_name}}</td><td><input type=radio ng-if=!data.selected name=selectOperation ng-click=selectParticularOperation($index,data)></td></tr></tbody><tfoot ng-if=\"items.opData.length == 0\"><tr><td colspan=4>{{\'noOperation\' | translate}}</td></tr></tfoot></table></div></div></div></md-dialog-content><md-dialog-actions><md-button type=button ng-click=confirmUpload() class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dialogViews/addEndowmentOfNewCustomer.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><md-dialog-content ng-class=\"{\'whirl duo\' : items.loading }\" style=min-height:325px><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">{{\'addEndowmentButton\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\"><div class=row><!-- <div class=\"col-lg-4 col-sm-4 col-xs-12 col-md-4\">\n                        <label>{{\'agreNameLabel\' | translate}}</label>\n                        <ui-select ng-model=\"items.agreementSelected\" name=\"agreementName\"\n                                   close-on-select=\"true\" ng-change=\"getFilterChange();getFilterDataForEndowment()\">\n                            <ui-select-match placeholder=\"{{\'agreementPlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match>\n                            <ui-select-choices repeat=\"data.id as data in items.agreement | filter: $select.search | orderBy:\'name\'\">\n                                <div ng-bind-html=\"data.name\"></div>\n                            </ui-select-choices>\n                        </ui-select>\n                    </div> --><div class=\"col-lg-4 col-sm-4 col-xs-12 col-md-4\"><label>{{\'agreementLabel\' | translate}}:</label><div><ui-select ng-model=items.agreementSelected ng-change=getFilterChange();getFilterDataForEndowment() close-on-select=true ng-keyup=agreementSearch($select.search,$event) ng-change=getFilterChange();getFilterDataForEndowment() data-testid=dotacion_convenio><ui-select-match placeholder=\"{{\'agreementPlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in agreementShowArray | filter: $select.search\" when-scrolled=paginationChangedForAgreement() ng-click=aggrementchange();><div ng-bind-html=data.name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-4 col-sm-4 col-xs-12 col-md-4\"><label class=control-label>{{\'corpoRut\' | translate}}</label><input type=text class=form-control data-testid=dotacion_rut ng-model=items.rutFilter name=RUT placeholder=\"{{\'corpoRut\' | translate}}\" ng-rut ng-change=rutChange() ng-blur=getFilterChange();getFilterDataForEndowment()><div class=\"errormessage text-danger\" ng-if=items.rutInvalid>{{\'rutValid\' | translate}}</div></div><!-- <div class=\"col-lg-4 col-sm-4 col-xs-12 col-md-4\">\n                        <label>{{\'corporateLabel\' | translate}}</label>\n                        <ui-select ng-model=\"items.corporateSelected\" name=\"corporateName\"\n                                   close-on-select=\"true\" ng-change=\"getFilterChange();getFilterDataForEndowment()\">\n                            <ui-select-match placeholder=\"{{\'corporatePlaceholder\' | translate}}\">{{$select.selected.company_name}}</ui-select-match>\n                            <ui-select-choices repeat=\"data.id as data in items.corporatesList | filter: $select.search | orderBy:\'company_name\'\">\n                                <div ng-bind-html=\"data.company_name\"></div>\n                            </ui-select-choices>\n                        </ui-select>\n                    </div> --><div class=\"col-lg-4 col-sm-4 col-xs-12 col-md-4\"><label>{{\'corporateLabel\' | translate}}</label><ui-select ng-model=items.corporateSelected ng-change=getFilterChange();getFilterDataForEndowment();corporate ng-keyup=corporateSearch($select.search,$event) name=corporateName required data-testid=dotacion_empresa close-on-select=true><ui-select-match placeholder=\"{{\'corporatePlaceholder\' | translate}}\">{{$select.selected.company_name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in coprateListShow | filter: $select.search | orderBy:\'company_name\'\" when-scrolled=paginationChangedForCorporation() ng-click=corporate($select)><div ng-bind-html=data.company_name></div></ui-select-choices></ui-select></div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><p class=\"alert alert-danger\" ng-if=items.errorMsg>{{\'selectAgreementReq\'| translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\" style=height:300px;overflow-y:auto when-scrolled=paginationChanged()><div class=table-responsive><table class=\"table table-hover\"><thead><tr><th>{{\'agreNameLabel\' | translate}}</th><th>{{\'corpoRut\' | translate}}</th><th>{{\'corporateLabel\' | translate}}</th><th>{{\'selectOnly\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"data in items.tableAgreement\" ng-style=\"{\'background-color\':data.color}\"><td>{{data.name}}</td><td>{{data.RUT | rut}}</td><td>{{data.company_name}}</td><td><input type=radio ng-if=\"data.employee_endowment == 0\" name=selectAgreement ng-click=selectParticularEndowment($index)></td></tr></tbody></table></div></div></div></md-dialog-content><md-dialog-actions><div style=color:red ng-if=!items.internetFlag>Por razones de mala conexión es necesario que selecciones el convenio nuevamente.</div><md-button type=button ng-click=confirmUpload() class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dialogViews/addItemOfChargeInPrice.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><form method=post name=addItemOfChargeInPriceForm ng-submit=\"submit=true;addItemOfChargeInPriceForm.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">{{\'addItem\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>{{\'itemOfCharge\' | translate}}<span style=color:red>*</span></label><select class=form-control ng-model=items.selectedItem ng-options=\"data.id as data.long_name for data in items.allItemsOfCharges\" name=itemOfCharge required ng-class=\"{ \'has-error\': addItemOfChargeInPriceForm.itemOfCharge.$touched && addItemOfChargeInPriceForm.itemOfCharge.$invalid }\" ng-change=checkItem(items.selectedItem)><option value=\"\" disabled selected>{{\'selectItemP\' | translate}}</option></select><div ng-if=\"addItemOfChargeInPriceForm.itemOfCharge.$touched|| submit\" ng-messages=addItemOfChargeInPriceForm.itemOfCharge.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'selectItemR\' | translate}}.</div></div></div><div class=\"col-lg-12 margin10\" ng-if=\"items.selectedItem == 2\"><div class=col-lg-12><div class=row><div class=\"col-lg-2 col-sm-4 col-xs-12 col-md-2\" style=\"font-weight: bold;padding-top: 5px\"><input type=radio required name=toll value=2 ng-model=items.toll> Por precio real</div><div class=\"col-lg-2 col-sm-4 col-xs-12 col-md-2\" style=\"font-weight: bold;padding-top: 5px\"><input type=radio required name=toll value=1 ng-model=items.toll> Por precio fijo</div></div><div ng-if=\"addItemOfChargeInPriceForm.toll.$touched|| submit\" ng-messages=addItemOfChargeInPriceForm.toll.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'selectItemR\' | translate}}.</div></div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" ng-if=items.showPrice><label>{{\'itemPrice\' | translate}}<span style=color:red>*</span></label><input type=text placeholder=\"{{\'itemPrice\' | translate}}\" class=form-control name=price ng-model=items.price ng-required=\"items.toll != 2 \" ng-class=\"{ \'has-error\': addItemOfChargeInPriceForm.price.$touched && addItemOfChargeInPriceForm.price.$invalid }\" number-dot=\"\" ng-disabled=\"items.disablePrice || items.toll == 2\"><div ng-if=\"addItemOfChargeInPriceForm.price.$touched|| submit\" ng-messages=addItemOfChargeInPriceForm.price.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'itemPriceR\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid item price.</div>--></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\" ng-if=!items.showPrice><p class=text-center><b>{{\'itemDriverCall\' | translate}}</b></p></div></div></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dialogViews/addModelVechicles.html","<form name=operationRegisterForm ng-submit=\"submit=true;operationRegisterForm.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog aria-label=\"List dialog\" style=\"width:800px;max-width: 100%\"><md-dialog-content ng-class=\"{\'whirl duo\' : items.loading }\"><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\"><h3 ng-if=\"items.key == 1\" style=\"border-bottom: 2px solid grey;padding-bottom: 5px;text-align: center\">Agregar Marca y Modelo</h3><h3 ng-if=\"items.key == 2\" style=\"border-bottom: 2px solid grey;padding-bottom: 5px;text-align: center\">Modificar Marca y Modelo</h3><h3 ng-if=\"items.key == 3\" style=\"border-bottom: 2px solid grey;padding-bottom: 5px;text-align: center\">Marca y Modelo</h3><!-- <div class=\"row\"> --><!-- <div class=\"col-lg-4 col-sm-4 col-xs-4 col-md-12 \">\n                            <label>Nro Veiculo:</label>\n                        </div> --><!-- <div class=\"col-lg-7 col-sm-7 col-xs-7 col-md-12 \">\n                            <input type=\"text\" ng-model=\"items.pointName1\" placeholder=\"Nro Veiculo\" class=\"form-control\" maxlength=\"50\" name=\"pointName1\"\n                                style=\"border-radius: 0;\" required ng-class=\"{ \'has-error\': operationRegisterForm.pointName1.$touched && operationRegisterForm.pointName1.$invalid }\">\n                            <div ng-if=\"operationRegisterForm.pointName1.$touched|| submit\" ng-messages=\"operationRegisterForm.pointName1.$error\">\n                                <div class=\"errormessage text-danger\" ng-message=\"required\">Nombre es requerido</div>\n                            </div>\n                        </div>\n                        <div class=\"col-lg-1 col-sm-1 col-xs-1 col-md-12 \" style=\"top: -1px;left: 390px;position: absolute;\">\n                            <button type=\"button\" class=\"SearchButton\">\n                                <i class=\"fa fa-search\"></i>\n                            </button>\n                        </div> --><!-- </div> --></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\"><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>Marca y Modelo: <span style=color:red>*</span></label><input ng-disabled=\"items.key == 3\" type=text ng-model=items.name placeholder=\"Marcas y Modelos\" class=form-control name=color required ng-class=\"{ \'has-error\': operationRegisterForm.color.$touched && operationRegisterForm.color.$invalid }\"><div ng-if=\"operationRegisterForm.color.$touched || submit\" ng-messages=operationRegisterForm.color.$error><div class=\"errormessage text-danger\" ng-message=required>Marca y Modelo es requerido</div></div></div></div></div></div></md-dialog-content><md-dialog-actions><md-button ng-if=\"items.key == 1 || items.key == 2\" type=submit class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></md-dialog></form>");
$templateCache.put("app/components/dialogViews/addNewAdminUser.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><form method=post name=addNewAdminForm ng-submit=\"submit=true;addNewAdminForm.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10 slideOutLeft\" id=showAgreement ng-show=!addAgreementStatus><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">{{\'addAdminHead\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"col-lg-6 col-sm-12 col-md-6 col-xs-12 pl0\"><!-- NAME --><label class=control-label>{{\'name\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=items.fullName name=fullName placeholder=\"{{\'namePlaceholderPet\' | translate}}\" required ng-class=\"{ \'has-error\': addNewAdminForm.fullName.$touched && addNewAdminForm.fullName.$invalid }\"><div ng-if=\"addNewAdminForm.fullName.$touched|| submit\" ng-messages=addNewAdminForm.fullName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'nameR\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'nameV\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-12 col-md-6 col-xs-12 pr0\"><!-- RUT --><label class=control-label>{{\'rutLabel\' | translate}} <span style=color:red>*</span></label><input ng-rut type=text class=form-control ng-model=items.rut name=rut placeholder=\"{{\'namePlaceholderRUT\' | translate}}\" required ng-change=passengerRutChange() ng-class=\"{ \'has-error\': addNewAdminForm.rut.$touched && addNewAdminForm.rut.$invalid }\"><div ng-if=\"addNewAdminForm.rut.$touched|| submit\" ng-messages=addNewAdminForm.rut.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'rutRequired\' | translate}}</div></div><div class=\"errormessage text-danger\" ng-if=passengerRUTError>{{\'rutValid\' | translate}}</div></div></div><!-- EMAIL --><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5\"><label class=control-label>{{\'email\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=items.email name=email placeholder=\"{{\'namePlaceholderEmail\' | translate}}\" required ng-class=\"{ \'has-error\': addNewAdminForm.email.$touched && addNewAdminForm.email.$invalid }\" pattern=^([_a-zA-Z0-9-+]+)(\\.[_a-zA-Z0-9-+]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*\\.)+([a-zA-Z]{2,3})$><div ng-if=\"addNewAdminForm.email.$touched|| submit\" ng-messages=addNewAdminForm.email.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'requiredEmail\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'validEmail\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><!-- PASSWORD --><div class=\"col-lg-6 col-sm-12 col-md-6 col-xs-12 pl0 mt5\"><label class=control-label>{{\'passwordPlaceholder\' | translate}} <span style=color:red>*</span></label><input type=password class=form-control ng-model=items.password name=password placeholder=\"{{\'passwordPlaceholder\' | translate}}\" required ng-minlength=8 ng-maxlength=16 ng-change=matchPasswordAgain(items.password) ng-class=\"{ \'has-error\': addNewAdminForm.password.$touched\n                                                && addNewAdminForm.password.$invalid }\"><div ng-if=\"addNewAdminForm.password.$touched|| submit\" ng-messages=addNewAdminForm.password.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'passwordRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'passwordMin\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'passwordMax\' | translate}}</div></div></div><!-- CONFIRM PASSWORD --><div class=\"col-lg-6 col-sm-12 col-md-6 col-xs-12 pr0 mt5\"><label class=control-label>{{\'confirmPasswordAdmin\' | translate}} <span style=color:red>*</span></label><input type=password class=form-control ng-model=items.confirmPassword name=confirmPassword placeholder=\"{{\'confirmPasswordAdmin\' | translate}}\" required ng-minlength=8 ng-maxlength=16 ng-class=\"{\'has-error\': addNewAdminForm.confirmPassword.$touched && addNewAdminForm.confirmPassword.$invalid }\" ng-change=matchPassword(items.confirmPassword)><div ng-if=\"addNewAdminForm.confirmPassword.$touched|| submit\" ng-messages=addNewAdminForm.confirmPassword.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'passwordRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'passwordMin\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'passwordMax\' | translate}}</div></div><div class=\"errormessage text-danger\" ng-if=items.passwordMatchFlag>{{\'passwordNotMatch\' | translate}}</div></div></div><!-- USER TYPE --><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5\"><label class=control-label>{{\'userType\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=items.userType required name=userType ng-class=\"{ \'has-error\': addNewAdminForm.userType.$touched && addNewAdminForm.userType.$invalid }\"><option value=\"\" disabled selected>{{\'selectTypeOfUser\' | translate}}</option><option ng-repeat=\"userName in userType\" value={{userName.value}}>{{userName.name}}</option></select><div ng-if=\"addNewAdminForm.userType.$touched|| submit\" ng-messages=addNewAdminForm.userType.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'pleaseSelectUserType\' | translate}}.</div></div></div><!-- CORPORATE RUT --><div ng-if=\"items.userType == 1\" class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5\"><label class=control-label>{{\'corporateRut\' | translate}} <span style=color:red>*</span></label><input type=text ng-model=items.corporateRut placeholder=\"{{\'namePlaceholderCorporateRut\' | translate}}\" uib-typeahead=\"corporate as corporate.id for corporate in corporateRutAPI()\" class=\"form-control createBookingSelect\" name=corporateRut typeahead-on-select=onSelectingCorporate() typeahead-wait-ms=200 typeahead-template-url=customTemplate.html ng-class=\"{ \'has-error\': addNewAdminForm.corporateRut.$touched && addNewAdminForm.corporateRut.$invalid }\"><div class=\"errormessage text-danger\" ng-if=corporateRUTErrorRequired>{{\'rutRequired\' | translate}}</div></div><!-- CORPORATE Name --><div ng-if=\"items.userType == 1\" class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5\"><label class=control-label>{{\'corporateName\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control disabled ng-model=items.corporateName name=corporateName placeholder=\"{{\'corporateName\' | translate}}\"></div><!-- AGREED AGREEMENT --><div ng-if=\"items.userType == 1\" class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5\"><label class=control-label>{{\'agreedAgreements\' | translate}} <span style=color:red>*</span></label><div style=\"display: flex\"><div ng-click=addAgreement() class=manual-input>{{selectedAgreement}}</div><div><p><i class=\"fa fa-angle-right\" style=\"font-size:30px;padding: 0px 10px\" ng-click=addAgreement()></i></p></div></div><div class=\"errormessage text-danger\" ng-if=\"agreedAgreementsErrorRequired && submit\">{{\'selectAgreementReq\' | translate}}</div></div><!-- DESCRIPTION --><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5\"><label class=control-label>{{\'description\' | translate}}</label><textarea class=form-control ng-model=items.description placeholder=\"{{\'namePlaceholderDescription\'| translate}}\"></textarea></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><div ng-if=items.error class=\"alert alert-danger text-center alertMargin\">{{items.error}}</div></div></div><div class=\"row m0 p10\" id=hideAgreement ng-show=addAgreementStatus><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><!-- <p><i class=\"fa fa-angle-left\" style=\"font-size:26px\" ng-click=\"confirmAgreement()\"></i></p> --><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">{{\'agreementHeaderInRole\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\"><div class=row><div class=\"col-lg-4 col-sm-4 col-xs-12 col-md-4\"><label>{{\'agreNameLabel\' | translate}}:</label><div><ui-select ng-model=items.agreementSelected ng-change=getFilterChange();getFilterDataForEndowment() close-on-select=true ng-keyup=agreementSearch($select.search,$event) ng-change=getFilterChange();getFilterDataForEndowment()><ui-select-match placeholder=\"{{\'agreNameLabel\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in agreementShowArray | filter: $select.search\" when-scrolled=paginationChangedForAgreement() ng-click=aggrementchange();><div ng-bind-html=data.name></div></ui-select-choices></ui-select></div></div><!-- <div class=\"col-lg-4 col-sm-4 col-xs-12 col-md-4\">\n                            <label class=\"control-label\">{{\'corpoRut\' | translate}}</label>\n                            <input type=\"text\" class=\"form-control\" ng-model=\"items.rutFilter\" name=\"RUT\" placeholder=\"{{\'corpoRut\' | translate}}\"\n                                ng-rut ng-change=\"rutChange()\" ng-blur=\"getFilterChange();getFilterDataForEndowment()\" />\n                            <div class=\"errormessage text-danger\" ng-if=\"items.rutInvalid\">{{\'rutValid\' | translate}}</div>\n                        </div> --><!-- <div class=\"col-lg-4 col-sm-4 col-xs-12 col-md-4\">\n                            <label>{{\'corporateLabel\' | translate}}</label>\n                            <ui-select ng-model=\"items.corporateSelected\" ng-change=\"getFilterChange();getFilterDataForEndowment();corporate\"\n                                ng-keyup=\"corporateSearch($select.search,$event)\" close-on-select=\"true\">\n                                <ui-select-match placeholder=\"{{\'corporatePlaceholder\' | translate}}\">{{$select.selected.company_name}}</ui-select-match>\n                                <ui-select-choices repeat=\"data.id as data in coprateListShow | filter: $select.search | orderBy:\'company_name\'\"\n                                    when-scrolled=\"paginationChangedForCorporation()\" ng-click=\"corporate($select)\">\n                                    <div ng-bind-html=\"data.company_name\"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div> --></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><p class=\"alert alert-danger\" ng-if=items.errorMsg>{{\'selectAgreementReq\'| translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\" style=height:300px;overflow-y:auto when-scrolled=paginationChanged()><div class=table-responsive><table class=\"table table-hover\"><thead><tr><th>{{\'agreNameLabel\' | translate}}</th><th>{{\'corpoRut\' | translate}}</th><th>{{\'corporateLabel\' | translate}}</th><th>{{\'selectOnly\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"data in items.tableAgreement\" ng-style=\"{\'background-color\':data.color}\"><td>{{data.name}}</td><td>{{data.RUT | rut}}</td><td>{{data.company_name}}</td><td><input style=\"font-size: 16px\" type=checkbox ng-model=data.selected ng-click=selectParticularEndowment($index)></td></tr></tbody></table></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\"><button type=button style=\"text-transform: uppercase;float: right\" class=\"md-primary custom-button\" ng-click=cancelAgreement()>{{\'cancelButton\' | translate}}</button> <button type=button class=\"md-primary custom-button\" style=\"float: right\" ng-click=confirmAgreement()>{{\'confirmButtonInRole\' | translate}}</button></div></div></md-dialog-content><md-dialog-actions ng-show=!addAgreementStatus><md-button type=submit class=md-primary>{{\'confirmButtonInRole\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'cancelButton\' | translate}}</md-button></md-dialog-actions></form></md-dialog><script type=text/ng-template id=customTemplate.html><a style=\"cursor: pointer;\">\n        <span class=\"displayFlex\">\n            <span style=\"padding-left: 10px;\">\n                <span>{{match.model.company_name}}</span>\n            </span>\n        </span>\n    </a></script>");
$templateCache.put("app/components/dialogViews/addNoShowReason.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><form method=post name=addNoShowReasonForm ng-submit=\"submit=true;addNoShowReasonForm.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">{{\'addNoShowReason\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>{{\'reasonLabel\' | translate}}<span style=color:red>*</span></label><textarea placeholder=\"{{\'messagePlaceholder\' | translate}}\" class=form-control name=reason ng-model=items.reason required ng-class=\"{ \'has-error\': addNoShowReasonForm.reason.$touched && addNoShowReasonForm.reason.$invalid }\"></textarea><div ng-if=\"addNoShowReasonForm.reason.$touched|| submit\" ng-messages=addNoShowReasonForm.reason.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'editReasonError\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid item price.</div>--></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>{{\'description\' | translate}}</label><textarea placeholder=\"{{\'messagePlaceholder\' | translate}}\" class=form-control name=description ng-model=items.description ng-class=\"{ \'has-error\': addNoShowReasonForm.description.$touched && addNoShowReasonForm.description.$invalid }\"></textarea><div ng-if=\"addNoShowReasonForm.description.$touched|| submit\" ng-messages=addNoShowReasonForm.description.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'descriptionR\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid item price.</div>--></div></div></div></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dialogViews/addOperationPointAgreement.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><md-dialog-content ng-class=\"{\'whirl duo\' : items.loading }\" style=min-height:325px><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">Seleccionar acuerdo</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\"><div class=row><div class=\"col-lg-4 col-sm-4 col-xs-12 col-md-4\"><label>{{\'agreNameLabel\' | translate}}</label><ui-select ng-model=items.agreementSelected name=agreementName close-on-select=true ng-change=getFilterChange();getFilterDataForEndowment()><ui-select-match placeholder=\"{{\'agreementPlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in items.agreement | filter: $select.search | orderBy:\'name\'\"><div ng-bind-html=data.name></div></ui-select-choices></ui-select></div><div class=\"col-lg-4 col-sm-4 col-xs-12 col-md-4\"><label class=control-label>{{\'corpoRut\' | translate}}</label><input type=text class=form-control ng-model=items.rutFilter name=RUT placeholder=\"{{\'corpoRut\' | translate}}\" ng-rut ng-change=rutChange() ng-blur=getFilterChange();getFilterDataForEndowment()><div class=\"errormessage text-danger\" ng-if=items.rutInvalid>{{\'rutValid\' | translate}}</div></div><div class=\"col-lg-4 col-sm-4 col-xs-12 col-md-4\"><label>{{\'corporateLabel\' | translate}}</label><ui-select ng-model=items.corporateSelected name=corporateName close-on-select=true ng-change=getFilterChange();getFilterDataForEndowment()><ui-select-match placeholder=\"{{\'corporatePlaceholder\' | translate}}\">{{$select.selected.company_name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in items.corporatesList | filter: $select.search | orderBy:\'company_name\'\"><div ng-bind-html=data.company_name></div></ui-select-choices></ui-select></div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><p class=\"alert alert-danger\" ng-if=items.errorMsg>{{\'selectAgreementReq\'| translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\" style=height:300px;overflow-y:auto when-scrolled=paginationChanged()><div class=table-responsive><table class=\"table table-hover\"><thead><tr><th>{{\'agreNameLabel\' | translate}}</th><th>{{\'corpoRut\' | translate}}</th><th>{{\'corporateLabel\' | translate}}</th><th>{{\'selectOnly\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"data in items.tableAgreement\"><td>{{data.name}}</td><td>{{data.RUT | rut}}</td><td>{{data.company_name}}</td><td><input type=radio name=selectAgreement ng-click=selectParticularEndowment($index)></td></tr></tbody></table></div></div></div></md-dialog-content><md-dialog-actions><md-button type=button ng-click=confirmUpload() class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dialogViews/addOperationPointRegesiter.html","<form name=operationRegisterForm ng-submit=\"submit=true;operationRegisterForm.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog aria-label=\"List dialog\" style=width:400px><md-dialog-content ng-class=\"{\'whirl duo\' : items.loading }\"><div class=\"row m0 p10\"><!-- <div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\">\n                <p class=\"editDocumentP text-center\" ng-if=\"!items.editData\" style=\"text-decoration: underline;\">{{\'operationPointAdd\' | translate}}</p>\n                <p class=\"editDocumentP text-center\" ng-if=\"items.editData\" style=\"text-decoration: underline;\">{{\'operationPointChange\' | translate}}</p>\n            </div> --><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\"><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>Nombre :</label><input type=text ng-model=items.pointName1 placeholder=Nombre class=form-control maxlength=50 name=pointName1 required ng-class=\"{ \'has-error\': operationRegisterForm.pointName1.$touched && operationRegisterForm.pointName1.$invalid }\"><div ng-if=\"operationRegisterForm.pointName1.$touched|| submit\" ng-messages=operationRegisterForm.pointName1.$error><div class=\"errormessage text-danger\" ng-message=required>Nombre es requerido</div></div></div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\"><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>Direccion :</label><input type=text ng-model=vm.dataToFill.pickUpDefault1 placeholder=Direccion class=form-control google-place callback-fn=mapFn1(data) domain={{vm.domain}} name=pickUpDefault1 id=pickAddress required ng-class=\"{ \'has-error\': operationEditForm.pickUpDefault1.$touched && operationEditForm.pickUpDefault1.$invalid }\"><div ng-if=\"operationRegisterForm.pickUpDefault1.$touched|| submit\" ng-messages=operationRegisterForm.pickUpDefault1.$error><div class=\"errormessage text-danger\" ng-message=required>Direccion es requerido</div></div></div></div></div></div></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></md-dialog></form>");
$templateCache.put("app/components/dialogViews/addcolorVechicles.html","<form name=operationRegisterForm ng-submit=\"submit=true;operationRegisterForm.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog aria-label=\"List dialog\" style=\"width:800px;max-width: 100%\"><md-dialog-content ng-class=\"{\'whirl duo\' : items.loading }\"><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\"><h3 ng-if=\"items.key == 1\" style=\"border-bottom: 2px solid grey;padding-bottom: 5px;text-align: center\">Agregar Color</h3><h3 ng-if=\"items.key == 2\" style=\"border-bottom: 2px solid grey;padding-bottom: 5px;text-align: center\">Modificar Color</h3><h3 ng-if=\"items.key == 3\" style=\"border-bottom: 2px solid grey;padding-bottom: 5px;text-align: center\">Color</h3><!-- <div class=\"row\"> --><!-- <div class=\"col-lg-4 col-sm-4 col-xs-4 col-md-12 \">\n                            <label>Nro Veiculo:</label>\n                        </div> --><!-- <div class=\"col-lg-7 col-sm-7 col-xs-7 col-md-12 \">\n                            <input type=\"text\" ng-model=\"items.pointName1\" placeholder=\"Nro Veiculo\" class=\"form-control\" maxlength=\"50\" name=\"pointName1\"\n                                style=\"border-radius: 0;\" required ng-class=\"{ \'has-error\': operationRegisterForm.pointName1.$touched && operationRegisterForm.pointName1.$invalid }\">\n                            <div ng-if=\"operationRegisterForm.pointName1.$touched|| submit\" ng-messages=\"operationRegisterForm.pointName1.$error\">\n                                <div class=\"errormessage text-danger\" ng-message=\"required\">Nombre es requerido</div>\n                            </div>\n                        </div>\n                        <div class=\"col-lg-1 col-sm-1 col-xs-1 col-md-12 \" style=\"top: -1px;left: 390px;position: absolute;\">\n                            <button type=\"button\" class=\"SearchButton\">\n                                <i class=\"fa fa-search\"></i>\n                            </button>\n                        </div> --><!-- </div> --></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\"><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>Color: <span style=color:red>*</span></label><input ng-disabled=\"items.key == 3\" type=text ng-model=items.name placeholder=Color class=form-control name=color required ng-class=\"{ \'has-error\': operationRegisterForm.color.$touched && operationRegisterForm.color.$invalid }\"><div ng-if=\"operationRegisterForm.color.$touched || submit\" ng-messages=operationRegisterForm.color.$error><div class=\"errormessage text-danger\" ng-message=required>Color es requerido</div></div></div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\"><div class=row><div class=\"col-lg-6 col-sm-6 col-xs-6 col-md-12\"><label>HexaCode: <span style=color:red>*</span></label><input ng-keyup=hexaEnter() maxlength=7 minlength=7 ng-disabled=\"items.key == 3\" type=text ng-model=items.HexaCode placeholder=HexaCode class=form-control name=HexaCode required ng-class=\"{ \'has-error\': operationRegisterForm.HexaCode.$touched && operationRegisterForm.HexaCode.$invalid }\"><div ng-if=\"operationRegisterForm.HexaCode.$touched || submit\" ng-messages=operationRegisterForm.HexaCode.$error><div class=\"errormessage text-danger\" ng-message=required>HexaCode es requerido</div></div><div ng-if=\"hexaError == true\" ng-messages=operationRegisterForm.HexaCode.$error><div class=\"errormessage text-danger\">El primer personaje debe ser #.</div></div></div><div class=\"col-lg-6 col-sm-6 col-xs-6 col-md-12\" style=\"height: 34px;width: 300px;margin-top: 24px; background-color: {{items.HexaCode}}\"></div></div></div></div></md-dialog-content><md-dialog-actions><md-button ng-if=\"items.key == 1 || items.key == 2\" type=submit class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></md-dialog></form>");
$templateCache.put("app/components/dialogViews/agreementFixedRouteMapView.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">{{\'fixedView\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\"><div id=googleMapPop style=width:100%;height:400px></div></div></div></md-dialog-content><md-dialog-actions><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dialogViews/approveCar.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">{{items.message}}</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\"><label class=control-label>{{\'adminComments\' | translate}}:</label><textarea class=form-control ng-model=items.comments placeholder=\"{{\'messagePlaceholder\' | translate}}\"></textarea></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\"><label class=control-label>{{\'uniqueNumber\' | translate}}:</label><input type=text class=form-control onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=items.unique_car_id placeholder=\"{{\'uniqueNumber\' | translate}}\"></div><p style=color:red ng-if=carId>{{\'uniqueNumberReq\' | translate}}</p></div></md-dialog-content><md-dialog-actions><md-button ng-click=confirmUpload() class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dialogViews/assignDriverToSharedService.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><!--{{items}}--><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">{{\'assignHead-1\' | translate}}</p><div ng-if=items.ShiftErrMsg class=\"alert alert-danger text-center alertMargin\">{{items.ShiftErrMsg}}</div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 table-responsive\"><table class=\"table table-hover\"><thead><tr><th>ID</th><th>BK</th><th>PAX</th><th>Time</th><th>First Booking</th><th>Address</th><th>Móvil</th><th>Status</th></tr></thead><tbody><tr><td>#{{items.jobData.shared_service_id}}</td><td>{{items.jobData.total_bookings}}</td><td>{{items.jobData.pax || 0}}</td><td>{{items.jobData.eta}}</td><td>{{items.jobData.first_pickup_time | date:\'dd MMM, HH:mm\'}}</td><td>{{items.jobData.first_pickup_address || \'--\'}}</td><td><span ng-if=items.jobData.unique_car_id>{{items.jobData.unique_car_id}}</span> <span ng-if=!items.jobData.unique_car_id>sin assignar</span></td><td><span ng-if=\"items.jobData.status == 0\">{{\'upcomingStatus\' | translate}}</span> <span ng-if=\"items.jobData.status == 1\">Viaje Iniciado</span> <span ng-if=\"items.jobData.status == 2\">Ended</span> <span ng-if=\"items.jobData.status == 3\">Failed</span> <span ng-if=\"items.jobData.status == 4\">En Posición</span> <span ng-if=\"items.jobData.status == 5\">Partial</span> <span ng-if=\"items.jobData.status == 6\">Unassigned</span> <span ng-if=\"items.jobData.status == 7\">Accepted</span> <span ng-if=\"items.jobData.status == 8\">Decline</span> <span ng-if=\"items.jobData.status == 9\">Cancel</span> <span ng-if=\"items.jobData.status == 15\">Onroad</span></td></tr></tbody></table></div><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">{{\'assignPopUpHead\' | translate}}</p></div></div><div class=row><div class=\"col-lg-3 col-sm-3 col-xs-6 col-md-3\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=items.searchDriver ng-change=getAssignDriverSearch(items.searchDriver)></div></div><div class=\"col-lg-3 col-sm-3 col-xs-6 col-md-3\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"Número de vehículo\" ng-model=items.searchDriverbyVehicleId ng-change=getAssignDriverSearch(items.searchDriverbyVehicleId) ng-model-options=\"{ debounce: 500 }\"></div></div><div class=\"col-lg-3 col-sm-3 col-xs-6 col-md-3 mt10\"><select class=form-control ng-model=items.onOffDuty name=promoType ng-change=getDataDriverChange()><option value=\"\" disabled>Incluir vehículos fuera de servicio</option><option value=1>On</option><option selected value=0>Off</option></select></div><div class=\"col-lg-3 col-sm-3 col-xs-6 col-md-3 mt10\"><select class=form-control ng-model=items.allVehicle name=promoType ng-change=getDataDriverChange()><option value=\"\" disabled>Incluir otros vehículos</option><option value=1>Yes</option><option selected value=0>No</option></select></div></div><!--<div  class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\">--><!--<div ng-if=\"items.busy\" class=\"noSearch\"><span>Loading.......</span></div>--><!--</div>--><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 table-responsive\" style=height:300px;overflow-y:auto when-scrolled=paginationFunction()><table class=\"table table-hover\"><thead><tr><th>{{\'serialNumber\' | translate}}</th><th>{{\'uniqueNumber\' | translate}}</th><th>{{\'driverName\' | translate}}</th><th>{{\'driverPhone\' | translate}}</th><th>{{\'vehicleLabel\' | translate}}</th><th>{{\'stateTable\' | translate}}</th><th>{{\'select\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"data in items.allDrivers\" ng-class=\"{\'grey-color\': data.off}\"><!-- | filter:items.searchDriver\"--><td>{{$index + 1}}</td><td>{{data.unique_car_id || \'--\'}}</td><td>{{data.first_name + \" \" + data.last_name}}</td><td>{{data.country_code}}-{{data.phone}}</td><td>{{data.name}}</td><td><span ng-if=\"data.is_available == 0\">Off Duty</span> <span ng-if=\"data.is_available == 1 && data.status == 0\">On Duty Free</span> <span ng-if=\"data.is_available == 1 && data.status == 1 && data.job_status == 7\">Accepted</span> <span ng-if=\"data.is_available == 1 && data.status == 1 && data.job_status == 15\">En Camino</span> <span ng-if=\"data.is_available == 1 && data.status == 1 && data.job_status == 4\">En Posición</span> <span ng-if=\"data.is_available == 1 && data.status == 1 && data.job_status == 1\">Viaje Iniciado</span></td><td><input ng-if=!data.off type=radio name=driver ng-click=selectDriver(data)><!--<md-radio-group>--><!--<md-radio-button value=\"{{$index}}\" name=\"driver\" aria-label=\"Driver{{$index}}\" class=\"md-primary\" ng-click=\"selectDriver(data)\"></md-radio-button>--><!--</md-radio-group>--></td></tr></tbody><tfoot ng-if=\"items.allDrivers.length == 0\"><tr class=text-center><th colspan=7 class=\"noDataClass text-center\">{{\'noDriverFound\' | translate}}</th></tr></tfoot></table></div></div></div></md-dialog-content><md-dialog-actions><md-button ng-click=confirmUpload() class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dialogViews/blockUblockDriverJobIds.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><md-dialog-content ng-class=\"{\'whirl duo\' : items.loading }\"><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\">{{items.message}}</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><table class=\"table table-hover\"><thead><tr><th style=width:200px>{{\'bookingOrPackageId\' | translate}}</th><th style=width:200px>{{\'JobStatus\' | translate}}</th></tr></thead><tbody id=copyData><tr ng-repeat=\"data in items.tableData\"><td style=width:200px><span style=\"color: #337ab7;text-decoration: none\">{{data.job_id}} <span ng-if=\"data.shared_service_id != null\">/ {{data.shared_service_id}}</span> &nbsp;&nbsp;&nbsp;</span></td><td style=width:200px><span ng-if=\"data.job_status == \'0\'\">{{\'upcomingStatus\' | translate}}</span> <span ng-if=\"data.job_status == \'1\'\">Viaje Iniciado</span> <span ng-if=\"data.job_status == \'2\'\">Completada</span> <span ng-if=\"data.job_status == \'3\'\">Failed</span> <span ng-if=\"data.job_status == \'4\'\">En Posición</span> <span ng-if=\"data.job_status == \'5\'\">Partial</span> <span ng-if=\"data.job_status == \'6\'\">No Asignada</span> <span ng-if=\"data.job_status == \'7\'\">Accepted</span> <span ng-if=\"data.job_status == \'8\'\">Rejected</span> <span ng-if=\"data.job_status == \'9\'\">Cancelada</span> <span ng-if=\"data.job_status == \'10\'\">Deleted</span> <span ng-if=\"data.job_status == \'11\'\">Ignored</span> <span ng-if=\"data.job_status == \'12\'\">No Show</span> <span ng-if=\"data.job_status == \'15\'\">En Camino</span></td></tr></tbody></table></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><!-- <button class=\"btn btn-primary\"  ng-if=\"items.tableData.length == 1\" ng-click=\"getIndex(0)\">{{\'copyButton1\' | translate}}</button> --> <button class=\"btn btn-primary\" ng-click=closeDialog()>{{\'acceptOnly1\' | translate}}</button></div></div></md-dialog-content><!--<md-dialog-actions>--><!--<md-button type=\"submit\" class=\"md-primary\">--><!--{{\'confirmButton\' | translate}}--><!--</md-button>--><!--<md-button ng-click=\"closeDialog()\" class=\"md-primary\">--><!--{{\'CloseButton\' | translate}}--><!--</md-button>--><!--</md-dialog-actions>--></md-dialog>");
$templateCache.put("app/components/dialogViews/blockUnblockPop.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><md-dialog-content><div class=\"row m0 p10\"><div style=\"margin-bottom: 20px\" class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">{{items.message}}</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\"><div ng-repeat=\"data in items.hours\" style=\"font-size: 18px\" ng-if=\"items.FlagBlocked == 0\"><!-- <label class=\"control-label\">{{\'adminComments\' | translate}}:</label> --> <input type=radio ng-click=hours(data.id) name=selectAgreement> {{data.name}}<br><!-- <textarea class=\"form-control\" ng-model=\"items.comments\" placeholder=\"{{\'messagePlaceholder\' | translate}}\"></textarea> --></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\"><label class=control-label>{{\'adminComments\' | translate}}:</label><textarea class=form-control ng-model=items.comments placeholder=\"{{\'messagePlaceholder\' | translate}}\"></textarea></div><!--<div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\">\n                <label class=\"control-label\">Enter Unique Id:</label>\n                <input type=\"text\" class=\"form-control\" onkeypress=\'return event.charCode >= 48 && event.charCode <= 57\' ng-model=\"items.unique_car_id\" placeholder=\"Enter Unique Id\">\n            </div>\n            <p style=\"color:red\" ng-if=\"carId\">Please Enter Unique Car Id</p>--></div></md-dialog-content><md-dialog-actions><md-button ng-click=confirmUpload() class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dialogViews/cancelBookingPopUp.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><form method=post name=cancelBookingForm ng-submit=\"submit=true;cancelBookingForm.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">{{\'cancelReasonHead\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>Motivo <span style=color:red>*</span></label><select class=form-control name=reason ng-model=cancelPopItems.reasonSelected required ng-options=\"data.reason for data in cancelPopItems.cancelReasonList\" ng-class=\"{ \'has-error\': cancelBookingForm.reason.$touched && cancelBookingForm.reason.$invalid }\"><option value=\"\" selected disabled>{{\'selectCancel\' | translate}}</option></select><div ng-if=\"cancelBookingForm.reason.$touched|| submit\" ng-messages=cancelBookingForm.reason.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'selectCancelRe\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid item price.</div>--></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>Comentarios</label><textarea placeholder=\"Enter Text Here\" class=form-control name=comments ng-model=cancelPopItems.cancellation_description maxlength=100></textarea></div></div></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button type=button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dialogViews/cancelBookingPopUpAuthorization.html","<md-dialog aria-label=\"List dialog\" style=width:750px><form method=post name=cancelBookingForm ng-submit=\"submit=true;cancelBookingForm.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">Anular Reserva</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"margin-top: 10px\"><div class=\"col-lg-3 col-sm-3 col-xs-3 col-md-12\" style=\"margin-top: 10px\"><label>Nombre pasajero:</label></div><div class=\"col-lg-9 col-sm-9 col-xs-9 col-md-12\" style=\"margin-top: 10px\"><span>{{cancelPopItems.jobData.customer_first_name}} {{cancelPopItems.jobData.customer_last_name}}</span></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"margin-top: 10px\"><div class=\"col-lg-3 col-sm-3 col-xs-3 col-md-12\" style=\"margin-top: 10px\"><label>Monto pagado:</label></div><div class=\"col-lg-9 col-sm-9 col-xs-9 col-md-12\" style=\"margin-top: 10px\"><span ng-if=!cancelPopItems.jobData.round_trip>$ {{cancelPopItems.jobData.estimated_payment_cost}}</span> <span ng-if=cancelPopItems.jobData.round_trip>$ {{cancelPopItems.jobData.total_estimated_payment_cost}}</span></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"margin-top: 10px\"><div class=\"col-lg-3 col-sm-3 col-xs-3 col-md-12\" style=\"margin-top: 10px\"><label>Método de pago:</label></div><div class=\"col-lg-9 col-sm-9 col-xs-9 col-md-12\" style=\"margin-top: 10px\"><span>{{cancelPopItems.cancelReasonList[0].payment_data.type}}</span></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"margin-top: 10px\"><div class=\"col-lg-3 col-sm-3 col-xs-3 col-md-12\" style=\"margin-top: 10px\"><label>Cajero de la venta:</label></div><div class=\"col-lg-9 col-sm-9 col-xs-9 col-md-12\" style=\"margin-top: 10px\"><span>{{cancelPopItems.jobData.admin_fullyname}}</span></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"margin-top: 10px\"><div class=\"col-lg-3 col-sm-3 col-xs-3 col-md-12\" style=\"margin-top: 10px\"><label>Monto a devolver:</label></div><div class=\"col-lg-9 col-sm-9 col-xs-9 col-md-12\" style=\"margin-top: 10px\"><span ng-if=!cancelPopItems.jobData.round_trip>${{cancelPopItems.jobData.estimated_payment_cost}}</span> <span ng-if=cancelPopItems.jobData.round_trip>${{cancelPopItems.jobData.total_refund_amount}}</span></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"margin-top: 10px\"><div class=\"col-lg-3 col-sm-3 col-xs-3 col-md-12\" style=\"margin-top: 10px\"><label>Método devolución:</label></div><div class=\"col-lg-9 col-sm-9 col-xs-9 col-md-12\" style=\"margin-top: 10px\"><span>{{cancelPopItems.cancelReasonList[0].payment_data.refund_type}}</span></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"margin-top: 10px\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>Motivo <span style=color:red>*</span></label><select class=form-control name=reason ng-model=cancelPopItems.reasonSelected required ng-options=\"data.reason for data in cancelPopItems.cancelReasonList\" ng-class=\"{ \'has-error\': cancelBookingForm.reason.$touched && cancelBookingForm.reason.$invalid }\"><option value=\"\" selected disabled>{{\'selectCancel\' | translate}}</option></select><div ng-if=\"cancelBookingForm.reason.$touched|| submit\" ng-messages=cancelBookingForm.reason.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'selectCancelRe\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid item price.</div>--></div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"margin-top: 10px\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>Comentarios</label><textarea placeholder=\"Enter Text Here\" class=form-control name=comments ng-model=cancelPopItems.cancellation_description maxlength=100></textarea></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"margin-top: 10px\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"border: 4px solid black;padding:10px\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>Autorizador <span style=color:red>*</span></label><select ng-click=vm.setMethod() class=form-control ng-model=cancelPopItems.email name=model ng-options=\"data.email\n                        as data.email for data in cancelPopItems.adminList\"><option value=\"\" disabled selected>Autorizador</option></select></div><div style=\"color: red\" class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" ng-if=\"cancelPopItems.RequiredMessageEmail != \'\'\">Seleccione Cancelar Autorizador</div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"margin-top: 10px\"><label>Contraseña <span style=color:red>*</span></label><input ng-model=cancelPopItems.password type=password class=form-control></div><div style=\"color: red\" class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" ng-if=\"cancelPopItems.RequiredMessage != \'\'\">Seleccione Cancelar Contraseña</div><div style=\"color: red\" class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" ng-if=\"cancelPopItems.message != \'\'\">{{cancelPopItems.message}}</div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=margin-top:20px><a type=button ng-disabled=cancelPopItems.flagForValidateButton class=\"btn btn-primary tableButton\" style=float:right title=\"Admin Logs\" ng-click=validatorAutorizator()>Validar Autorizador</a></div></div></div></div></md-dialog-content><md-dialog-actions><md-button ng-disabled=cancelPopItems.flagForConfirm type=submit class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button type=button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dialogViews/cancelBookingPopUpNew.html","<md-dialog aria-label=\"List dialog\" style=width:750px><form method=post name=cancelBookingForm ng-submit=\"submit=true;cancelBookingForm.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">Anular Reserva</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"margin-top: 10px\"><div class=\"col-lg-3 col-sm-3 col-xs-3 col-md-12\" style=\"margin-top: 10px\"><label>Nombre pasajero:</label></div><div class=\"col-lg-9 col-sm-9 col-xs-9 col-md-12\" style=\"margin-top: 10px\"><span>{{cancelPopItems.jobData.customer_first_name}} {{cancelPopItems.jobData.customer_last_name}}</span></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"margin-top: 10px\"><div class=\"col-lg-3 col-sm-3 col-xs-3 col-md-12\" style=\"margin-top: 10px\"><label>Monto pagado:</label></div><div class=\"col-lg-9 col-sm-9 col-xs-9 col-md-12\" style=\"margin-top: 10px\"><span ng-if=!cancelPopItems.jobData.round_trip>${{cancelPopItems.jobData.estimated_payment_cost}}</span> <span ng-if=cancelPopItems.jobData.round_trip>${{cancelPopItems.jobData.total_estimated_payment_cost}}</span></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"margin-top: 10px\"><div class=\"col-lg-3 col-sm-3 col-xs-3 col-md-12\" style=\"margin-top: 10px\"><label>Método de pago:</label></div><div class=\"col-lg-9 col-sm-9 col-xs-9 col-md-12\" style=\"margin-top: 10px\"><span>{{cancelPopItems.cancelReasonList[0].payment_data.type}}</span></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"margin-top: 10px\"><div class=\"col-lg-3 col-sm-3 col-xs-3 col-md-12\" style=\"margin-top: 10px\"><label>Cajero de la venta:</label></div><div class=\"col-lg-9 col-sm-9 col-xs-9 col-md-12\" style=\"margin-top: 10px\"><span>{{cancelPopItems.jobData.admin_fullyname}}</span></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"margin-top: 10px\"><div class=\"col-lg-3 col-sm-3 col-xs-3 col-md-12\" style=\"margin-top: 10px\"><label>Monto a devolver:</label></div><div class=\"col-lg-9 col-sm-9 col-xs-9 col-md-12\" style=\"margin-top: 10px\"><span ng-if=!cancelPopItems.jobData.round_trip>${{cancelPopItems.jobData.estimated_payment_cost}}</span> <span ng-if=cancelPopItems.jobData.round_trip>${{cancelPopItems.jobData.total_refund_amount}}</span></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"margin-top: 10px\"><div class=\"col-lg-3 col-sm-3 col-xs-3 col-md-12\" style=\"margin-top: 10px\"><label>Método devolución:</label></div><div class=\"col-lg-9 col-sm-9 col-xs-9 col-md-12\" style=\"margin-top: 10px\"><span>{{cancelPopItems.cancelReasonList[0].payment_data.refund_type}}</span></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"margin-top: 10px\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>Motivo <span style=color:red>*</span></label><select class=form-control name=reason ng-model=cancelPopItems.reasonSelected required ng-options=\"data.reason for data in cancelPopItems.cancelReasonList\" ng-class=\"{ \'has-error\': cancelBookingForm.reason.$touched && cancelBookingForm.reason.$invalid }\"><option value=\"\" selected disabled>{{\'selectCancel\' | translate}}</option></select><div ng-if=\"cancelBookingForm.reason.$touched|| submit\" ng-messages=cancelBookingForm.reason.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'selectCancelRe\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid item price.</div>--></div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"margin-top: 10px\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>Comentarios</label><textarea placeholder=\"Enter Text Here\" class=form-control name=comments ng-model=cancelPopItems.cancellation_description maxlength=100></textarea></div></div></div></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button type=button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dialogViews/changePassword.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><form method=post name=changePasswordForm ng-submit=\"submit=true;changePasswordForm.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">{{\'changePassword\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=margin-top:10px><div class=\"form-group has-feedback\"><input type=password placeholder=\"{{\'oldPassword\' | translate}}\" ng-class=\"{ \'has-error\': changePasswordForm.oldPassword.$touched\n                                        && changePasswordForm.oldPassword.$invalid }\" ng-model=items.oldPassword name=oldPassword required class=form-control autocomplete=off> <span class=\"fa fa-lock form-control-feedback text-muted\"></span><div ng-if=\"changePasswordForm.oldPassword.$touched|| submit\" ng-messages=changePasswordForm.oldPassword.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'oldPasswordR\' | translate}}</div></div></div><div class=\"form-group has-feedback\"><input type=password placeholder=\"{{\'newPasswordPlaceholder\' | translate}}\" ng-class=\"{ \'has-error\': changePasswordForm.password.$touched\n                                        && changePasswordForm.password.$invalid }\" ng-model=items.password name=password required class=form-control autocomplete=off ng-change=matchPassword(items.password) ng-minlength=8 ng-maxlength=16> <span class=\"fa fa-lock form-control-feedback text-muted\"></span><div ng-if=\"changePasswordForm.password.$touched|| submit\" ng-messages=changePasswordForm.password.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'newPasswordRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'passwordMin\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'passwordMax\' | translate}}</div></div></div><div class=\"form-group has-feedback\"><input type=password placeholder=\"{{\'ConfirmPasswordPlaceholder\' | translate}}\" ng-class=\"{ \'has-error\': changePasswordForm.confirmPassword.$touched\n                                        && changePasswordForm.confirmPassword.$invalid }\" ng-model=items.confirmPassword name=confirmPassword required class=form-control ng-change=matchConfirmPassword(items.confirmPassword) autocomplete=off ng-minlength=8 ng-maxlength=16> <span class=\"fa fa-lock form-control-feedback text-muted\"></span><div ng-if=\"changePasswordForm.confirmPassword.$touched|| submit\" ng-messages=changePasswordForm.confirmPassword.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'confirmPasswordRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'passwordMin\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'passwordMax\' | translate}}</div></div><div class=\"errormessage text-danger\" ng-if=items.passwordMatchFlag>{{\'passwordNotMatch\' | translate}}</div></div></div></div></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dialogViews/copyBasedPriceList.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px ng-class=\"{\'whirl duo\' : loading1 }\"><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><p class=\"editDocumentP text-center\">{{\'selectPriceList\' | translate}}</p></div></div><div class=\"row m0 p10\"><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12\"><label>{{\'agreementLabel\' | translate}}</label><ui-select ng-model=items.agreementFilter close-on-select=true ng-change=agreementChangeFilter(items.agreementFilter)><ui-select-match placeholder=\"{{\'agreementPlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in items.agreementListForCopy | filter: $select.search\"><div ng-bind-html=data.name></div></ui-select-choices></ui-select></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12\"><label>{{\'priceListStatusLabel\' | translate}}</label><select class=form-control ng-model=items.statusFilter ng-change=statusChangeFilter(items.statusFilter)><option value=\"\" disabled>{{\'priceListStatusPlaceholder\' | translate}}</option><option value=1>Inactive</option><option value=0>Active</option><option selected value=2>All</option></select></div></div><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\" style=\"height: 350px;overflow-y: auto\"><table class=\"table table-hover\"><thead><tr><th style=min-width:105px>{{\'agreementLabel\' | translate}}</th><th style=min-width:105px>{{\'priceListNameLabel\' | translate}}</th><th style=min-width:115px>{{\'fixedVariable\' | translate}}</th><th style=min-width:115px>{{\'stateTable\' | translate}}</th><th style=min-width:125px>{{\'action\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"data in items.priceListData\"><td>{{data.contract_name}}</td><td>{{data.name}}</td><td><span ng-if=\"data.type == 1\">Variable</span> <span ng-if=\"data.type == 0\">Fixed</span></td><td><span ng-if=\"data.status == 0\">Active</span> <span ng-if=\"data.status == 1\">Inactive</span></td><td><a class=\"btn btn-primary tableButton\" title=\"{{\'copyButton\' | translate}}\" ng-click=copyBasedPriceList(data,$event)>{{\'copyButton\' | translate}}</a></td></tr></tbody></table></div></div></md-dialog-content><md-dialog-actions><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dialogViews/correctAgreement.html","<md-dialog aria-label=\"List dialog\" style=min-width:500px ng-class=\"{\'whirl duo\' : items.loading }\"><form method=post name=correctFareForm ng-submit=\"submit=true;correctFareForm.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 table-responsive\" style=\"border-bottom: 1px solid black\"><table class=table><thead><tr><th>{{\'bookingId\' | translate}}</th><th>{{\'pickTime\' | translate}}</th><th>{{\'agreementLabel\' | translate}}</th><th>{{\'paymentAmount\' | translate}} $</th></tr></thead><tbody><tr><td>{{items.jobData.job_id}}</td><td>{{items.jobData.job_pickup_datetime | date:\'medium\'}}</td><td>{{items.jobData.new_contract_name ?items.jobData.new_contract_name : items.jobData.contract_name }}</td><td>{{items.jobData.newPaymentTotal}}</td></tr></tbody></table></div></div><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><div ng-if=items.minimumAmount class=\"alert alert-danger text-center alertMargin\">{{\'correctFareMaxPAY\' | translate}} $ {{items.jobData.newPaymentTotal}}</div></div><!-- <div class=\"col-lg-7 col-sm-7 col-xs-12 col-md-7\">\n                        <div class=\"displayFlex\" style=\"height: 60px;\">\n                            <span class=\"correctFareClass\">{{\'amountAdjustLabel\' | translate}} $<span style=\"color:red\">*</span></span>\n                            <div style=\"display: block;width: 65%;\">\n                                <input type=\"number\" class=\"form-control\" name=\"adjustAmount\" placeholder=\"{{\'amountAdjustLabel\' | translate}}\" ng-model=\"items.settledAmount\" ng-change=\"makePendingAmountUpdate(items.settledAmount)\"\n                                       required  ng-class=\"{ \'has-error\': correctFareForm.adjustAmount.$touched && correctFareForm.adjustAmount.$invalid }\" />\n                                <div ng-if=\"correctFareForm.adjustAmount.$touched|| submit\" ng-messages=\"correctFareForm.adjustAmount.$error\">\n                                    <div class=\"errormessage text-danger\" ng-message=\"required\">{{\'amountAdjustLabelR\' | translate}}</div>\n                                </div>\n                            </div>\n                        </div>\n                    </div> --><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><div class=displayFlex style=\"height: 60px\"><span class=correctFareClass>{{\'SelectAgreement\' | translate}} <span style=color:red>*</span></span><div style=\"display: block;width: 65%\"><select class=form-control ng-model=items.AgreementsSelected ng-options=\"data.id as data.name for data in items.Agreements\" name=motive required ng-class=\"{ \'has-error\': correctFareForm.motive.$touched && correctFareForm.motive.$invalid }\"><option value=\"\" selected disabled>{{\'SelectAgreement\' | translate}}<span style=color:red>*</span></option></select><div ng-if=\"correctFareForm.motive.$touched|| submit\" ng-messages=correctFareForm.motive.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'SelectAgreementR\' | translate}}</div></div></div></div></div><!-- <div class=\"col-lg-7 col-sm-7 col-xs-12 col-md-7\">\n                        <div class=\"displayFlex\" style=\"height: 60px;\">\n                            <span class=\"correctFareClass\">{{\'coorectFinalAmountLable\' | translate}} $<span style=\"color:red\">*</span></span>\n                            <div style=\"display: block;width: 65%;\">\n                                <input type=\"number\" class=\"form-control\" name=\"correctedAmount\" placeholder=\"{{\'coorectFinalAmountLable\' | translate}}\" ng-model=\"items.newAmount\" readonly\n                                       required  ng-class=\"{ \'has-error\': correctFareForm.correctedAmount.$touched && correctFareForm.correctedAmount.$invalid }\" />\n                                <div ng-if=\"correctFareForm.correctedAmount.$touched|| submit\" ng-messages=\"correctFareForm.correctedAmount.$error\">\n                                    <div class=\"errormessage text-danger\" ng-message=\"required\">{{\'coorectFinalAmountLableR\' | translate}}</div>\n                                </div>\n                            </div>\n                        </div>\n                    </div> --><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>{{\'Motivo\' | translate}}<span style=color:red>*</span></label><textarea placeholder=\"{{\'Motivo\' | translate}}\" class=form-control name=comment ng-model=items.comment required ng-class=\"{ \'has-error\': correctFareForm.comment.$touched && correctFareForm.comment.$invalid }\"></textarea><div ng-if=\"correctFareForm.comment.$touched|| submit\" ng-messages=correctFareForm.comment.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'MotiveR\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid item price.</div>--></div></div></div></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dialogViews/correctFareBooking.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px;max-width:1150px ng-class=\"{\'whirl duo\' : items.loading }\" class=customDialogWidth><form method=post name=correctFareForm ng-submit=\"submit=true;correctFareForm.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 table-responsive\" style=\"border: 1px solid grey\"><table class=table><thead><tr><th>{{\'bookingId\' | translate}}</th><th>{{\'pickTime\' | translate}}</th><th>{{\'agreementLabel\' | translate}}</th><th>{{\'paymentAmount\' | translate}} $</th></tr></thead><tbody><tr><td>{{items.jobData.job_id}}</td><td>{{items.jobData.job_pickup_datetime | date:\'medium\'}}</td><td>{{items.jobData.contract_name}}</td><td>{{items.jobData.newPaymentTotal}}</td></tr></tbody></table></div></div><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 table-responsive\" style=\"border: 1px solid grey;padding: 10px\"><div class=\"col-lg-2 col-sm-4 col-xs-12 col-md-2\"><span class=correctFareClass style=\"width: 100%\">{{\'correctFare\' | translate}} <span style=color:red>*</span></span></div><div class=\"col-lg-2 col-sm-4 col-xs-12 col-md-2\" style=\"font-weight: bold;padding-top: 5px\"><input type=radio name=amount value=amount ng-click=\"amountValue(\'amount\')\" checked> {{\'byAmount\' | translate}}</div><div class=\"col-lg-2 col-sm-4 col-xs-12 col-md-2\" style=\"font-weight: bold;padding-top: 5px\"><input type=radio name=amount value=item ng-click=\"itemValue(\'item\')\"> {{\'byItem\' | translate}}</div><div class=\"col-lg-3 col-sm-4 col-xs-12 col-md-3\" style=\"font-weight: bold;padding-top: 5px\"><input type=radio name=amount value=noShow ng-click=\"noShowValue(\'noShow\')\"> {{\'setNoShow\' | translate}}</div><div class=\"col-lg-3 col-sm-4 col-xs-12 col-md-3\" style=\"font-weight: bold;padding-top: 5px\"><input type=radio name=amount value=cancel ng-click=\"cancelValue(\'cancel\')\"> {{\'setCancel\' | translate}}</div></div></div><!-- ******************************** BY AMOUNT ******************************** --><div class=\"row m0 p10\" ng-if=\"amountIsSelected == true\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><div ng-if=items.minimumAmount class=\"alert alert-danger text-center alertMargin\">{{\'correctFareMaxPAY\' | translate}} $ {{items.jobData.newPaymentTotal}}</div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"border: 1px solid grey;padding-top: 20px\"><span class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"font-weight: bold\">By Amounts</span><div class=\"row m0 col-lg-6 col-sm-6 col-xs-12 col-md-6\" style=\"margin-left: -16px\"><div class=displayFlex style=\"height: 60px\"><span class=correctFareClass style=\"width: 65%\">{{\'amountAdjustLabel\' | translate}} $ <span style=color:red>*</span></span><div style=\"display: block;width: 83%\"><input type=number class=form-control ng-keypress=\"notIncludeDotAmount($event , \'Amount\')\" name=adjustAmount placeholder=\"{{\'amountAdjustLabel\' | translate}}\" ng-model=items.settledAmount ng-change=makePendingAmountUpdate(items.settledAmount) required ng-class=\"{ \'has-error\': correctFareForm.adjustAmount.$touched && correctFareForm.adjustAmount.$invalid }\"><div ng-if=\"correctFareForm.adjustAmount.$touched|| submit\" ng-messages=correctFareForm.adjustAmount.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'amountAdjustLabelR\' | translate}}</div></div></div></div></div><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6\"><div class=displayFlex style=\"height: 60px\"><span class=correctFareClass style=\"width: 65%\">{{\'coorectFinalAmountLable\' | translate}} $ <span style=color:red>*</span></span><div style=\"display: block;width: 83%\"><input type=number class=form-control name=correctedAmount placeholder=\"{{\'coorectFinalAmountLable\' | translate}}\" ng-model=items.newAmount readonly required ng-class=\"{ \'has-error\': correctFareForm.correctedAmount.$touched && correctFareForm.correctedAmount.$invalid }\"><div ng-if=\"correctFareForm.correctedAmount.$touched|| submit\" ng-messages=correctFareForm.correctedAmount.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'coorectFinalAmountLableR\' | translate}}</div></div></div></div></div></div></div><!-- ******************************** BY AMOUNT ******************************** --><!-- ******************************** BY ITEM ******************************** --><div class=\"row m0 p10\" ng-if=\"itemIsSelected == true\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><div ng-if=fixedFareValidation class=\"alert alert-danger text-center alertMargin\">Fixed fare should be greater than or equal to zero.</div><!-- <div ng-if=\"items.fixedFareValiation\" class=\"alert alert-danger text-center alertMargin\">{{\'correctFareMaxPAY\' | translate}} $ {{items.jobData.newPaymentTotal}}</div> --></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"border: 1px solid grey;padding-top:20px;padding-bottom:20px\"><!-- <span class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"font-weight: bold;\">By Item</span> --><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><div class=\"col-lg-3 col-sm-3 col-xs-12 col-md-3\" style=\"font-weight: bold\">By Item</div><div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\" style=\"font-weight: bold;text-align:center;margin-right: 5px\">Quantity</div><div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\" style=\"font-weight: bold;text-align:center;margin-right: 5px\">Unit Value</div><div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\" style=\"font-weight: bold;text-align:center;margin-right: 5px\">Total</div><div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\" style=\"font-weight: bold;text-align:center;margin-right: 5px\">Total Adjustment</div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=padding-top:10px><div ng-repeat=\"data in appliedItemOfCharge\" style=\"height: 34px\"><span class=\"fa fa-close\" ng-click=removeItemOfCharge($index) ng-if=\"data.isItemOfCharge == 1\"></span><div class=\"col-lg-3 col-sm-3 col-xs-12 col-md-3\" style=\"text-transform: capitalize\">{{data.long_name}}</div><div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\" style=\"margin-right: 5px\"><input ng-keypress=\"notIncludeDotAmount($event, data)\" min=0 type=text placeholder=0 ng-if=\"data.mode != 0\" ng-disabled=\"data.mode == 0 || data.quantity == \'-\'\" name=quantity class=form-control ng-change=\"calculateFare(data.quantity, $index, \'quantity\')\" ng-model=data.quantity><div ng-if=\"correctFareForm.quantity.$touched|| submit\" ng-messages=correctFareForm.quantity.$error><div class=\"errormessage text-danger\" ng-message=min>La calidad no debe ser negativa.</div></div></div><div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\" style=\"margin-right: 5px\"><input min=0 ng-keypress=\"notIncludeDotAmount($event, data)\" oninput=\"this.value = this.value.replace(/[^0-9]/g, \'\').replace(/(\\*)\\./g, \'$1\')\" type=text placeholder=0 name=price ng-disabled=\"data.mode == 1 || (data.quantity != \'-\' && data.price == \'-\') || data.heremapsTolls\" class=form-control ng-change=\"calculateFare(data.price, $index, \'unitValue\')\" ng-model=data.price><div ng-if=\"correctFareForm.price.$touched|| submit\" ng-messages=correctFareForm.price.$error><div class=\"errormessage text-danger\" ng-message=min>El valor unitario no debe ser negativo.</div></div></div><div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\" style=\"margin-right: 5px\"><input min=0 oninput=\"this.value = this.value.replace(/[^0-9]/g, \'\').replace(/(\\*)\\./g, \'$1\')\" type=text name=totalFare ng-disabled=\"((data.quantity != \'-\' && !data.heremapsTolls) || data.price!=\'-\')\" class=form-control ng-change=\"calculateFare(data.total, $index, \'total\')\" ng-model=data.total><div ng-if=\"correctFareForm.totalFare.$touched|| submit\" ng-messages=correctFareForm.totalFare.$error><div class=\"errormessage text-danger\" ng-message=min>El valor unitario no debe ser negativo.</div></div></div><div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\" style=\"margin-right: 5px\"><input oninput=\"this.value = this.value.replace(/[^0-9.]/g, \'\').replace(/(\\..*)\\./g, \'$1\')\" disabled type=text class=form-control ng-model=data.totalAdjustment></div></div></div><!-- <div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"padding-top:10px\" ng-if=\"items.jobData.route_type == 1\">\n                        <div class=\"col-lg-3 col-sm-3 col-xs-12 col-md-3\">\n                            Fixed Fare\n                        </div>\n                        <div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\" style=\"margin-right: 5px;\">\n                            <input min=\"0\" type=\"number\" name=\"quantity\" class=\"form-control\" ng-model=\"items.quantity\">\n                            <div ng-if=\"correctFareForm.quantity.$touched|| submit\" ng-messages=\"correctFareForm.quantity.$error\">\n                                <div class=\"errormessage text-danger\" ng-message=\"min\">La calidad no debe ser negativa.</div>\n                            </div>\n                        </div>\n                        <div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\" style=\"margin-right: 5px;\">\n                            <input min=\"0\" type=\"number\" name=\"unitValue\" class=\"form-control\" ng-model=\"items.unitValue\">\n                            <div ng-if=\"correctFareForm.unitValue.$touched|| submit\" ng-messages=\"correctFareForm.unitValue.$error\">\n                                <div class=\"errormessage text-danger\" ng-message=\"min\">\n                                    El valor unitario no debe ser negativo.</div>\n                            </div>\n                        </div>\n                        <div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\" style=\"margin-right: 5px;\">\n                            <input min=\"0\" type=\"number\" name=\"totalFare\" class=\"form-control\" ng-model=\"items.totalItemFare \">\n                            <div ng-if=\"correctFareForm.totalFare.$touched|| submit\" ng-messages=\"correctFareForm.totalFare.$error\">\n                                <div class=\"errormessage text-danger\" ng-message=\"min\">\n                                    El valor unitario no debe ser negativo.</div>\n                            </div>\n                        </div>\n                        <div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\" style=\"margin-right: 5px;\">\n                            <input disabled type=\"number\" class=\"form-control\" ng-model=\"items.totalAdjustedFare\">\n                        </div>\n                    </div> --><!-- <div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"padding-top:10px\" ng-if=\"items.jobData.route_type == 0\">\n                        <div class=\"col-lg-3 col-sm-3 col-xs-12 col-md-3\">\n                            Base Fare (BB): $\n                        </div>\n                        <div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\" style=\"margin-right: 5px;\">\n                            <input disabled min=\"0\" type=\"number\" name=\"quantity\" class=\"form-control\" ng-model=\"items.quantity\">\n                            <div ng-if=\"correctFareForm.quantity.$touched|| submit\" ng-messages=\"correctFareForm.quantity.$error\">\n                                <div class=\"errormessage text-danger\" ng-message=\"min\">La calidad no debe ser negativa.</div>\n                            </div>\n                        </div>\n                        <div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\" style=\"margin-right: 5px;\">\n                            <input min=\"0\" type=\"number\" name=\"unitValue\" class=\"form-control\" ng-model=\"items.unitValue\">\n                            <div ng-if=\"correctFareForm.unitValue.$touched|| submit\" ng-messages=\"correctFareForm.unitValue.$error\">\n                                <div class=\"errormessage text-danger\" ng-message=\"min\">\n                                    El valor unitario no debe ser negativo.</div>\n                            </div>\n                        </div>\n                        <div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\" style=\"margin-right: 5px;\">\n                            <input disabled min=\"0\" type=\"number\" name=\"totalFare\" class=\"form-control\" ng-model=\"items.totalItemFare \">\n                            <div ng-if=\"correctFareForm.totalFare.$touched|| submit\" ng-messages=\"correctFareForm.totalFare.$error\">\n                                <div class=\"errormessage text-danger\" ng-message=\"min\">\n                                    El valor unitario no debe ser negativo.</div>\n\n                            </div>\n                        </div>\n                        <div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\" style=\"margin-right: 5px;\">\n                            <input disabled type=\"number\" class=\"form-control\" ng-model=\"items.totalAdjustedFare\">\n                        </div>\n                    </div> --><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=padding-top:10px><div class=\"col-lg-3 col-sm-3 col-xs-12 col-md-3\"></div><div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\" style=\"margin-right: 5px\"><!-- <input type=\"number\"> --></div><div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\" style=\"text-align: right;margin-right: 5px;font-weight: bold;margin-top:8px\">Total Booking</div><div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\" style=\"margin-right: 5px\"><input type=number class=form-control disabled ng-model=newPaymentTotal></div><div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\" style=\"margin-right: 5px\"><input type=number class=form-control disabled ng-model=newPaymentTotal></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=padding-top:10px><div class=\"col-lg-3 col-sm-3 col-xs-12 col-md-3\"><!-- Fixed Fare --></div><div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\" style=\"margin-right: 5px\"><!-- <input type=\"number\"> --></div><div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\" style=\"text-align: right;margin-right: 5px\"><!-- Total Booking --></div><div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\" style=\"margin-right: 5px\"><!-- <input type=\"number\"> --></div><div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\" style=\"text-align: right\"><button class=ButtonItem ng-click=addItem()>Add Item</button><div ng-if=addItemPopup><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5 paddingTwo\" ng-if=\"applicableItemOfChargeList.length > 0\" style=\"width: 115%\"><!-- <label>{{\'itemOfCharge\' | translate}}</label> --><ui-select multiple ng-model=itemOfChargeSelected theme=bootstrap close-on-select=false title=\"{{\'selectItemP\' | translate}}\" name=itemOfCharge on-select=\"selectingItemOfCharges($select.selected, \'add\')\" on-remove=\"selectingItemOfCharges($select.selected, \'remove\')\" ng-class=\"{ \'has-error\': createBookingForm.itemOfCharge.$touched && createBookingForm.itemOfCharge.$invalid }\"><ui-select-match placeholder=\"{{\'selectItemP\' | translate}}\">{{$item.item_of_charge_id.long_name}}</ui-select-match><ui-select-choices repeat=\"data in applicableItemOfChargeList | filter:$select.search\">{{data.item_of_charge_id.long_name}}</ui-select-choices></ui-select></div><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5 noItemOfChargeClass\" ng-if=\"applicableItemOfChargeList.length == 0\">No Applicable Charges Found.</div><div ng-if=\"itemOfChargeSelected.length> 0\"><table class=table><thead><tr><th>{{\'itemName\' | translate}}</th><th>{{\'itemPrice\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"item in itemOfChargeSelected\"><td>{{item.long_name}}</td><td><span ng-if=\"item.mode == 0\">${{item.price}}</span> <span ng-if=\"item.mode == 1\" style=\"display: flex; align-items: center; justify-content: center\">$&nbsp;&nbsp; <input type=text placeholder=\"{{\'itemPrice\' | translate}}\" ng-model=item.price number-dot></span></td></tr></tbody></table></div></div></div></div></div></div><!-- ******************************** By NoShow ****************************** --><div class=\"row m0 p10\" ng-if=\"noShowIsSelected == true\"></div><!-- ******************************** By SetCancel ****************************** --><div class=\"row m0 p10\" ng-if=\"setCancelIsSelected == true\"></div><!-- ******************************** BY ITEM ******************************** --><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><div class=\"col-lg-7 col-sm-7 col-xs-12 col-md-7\"><div class=displayFlex style=\"height: 60px\"><span class=correctFareClass style=\"width: 37%\">{{\'reasonForAdjustment\' | translate}} $ <span style=color:red>*</span></span><div style=\"display: block;width: 50%\"><select class=form-control ng-model=items.reasonSelected ng-options=\"data.reason as data.reason for data in items.reasons\" name=motive required ng-class=\"{ \'has-error\': correctFareForm.motive.$touched && correctFareForm.motive.$invalid }\"><option value=\"\" selected disabled>{{\'adjustMotiveLable\' | translate}} <span style=color:red>*</span></option></select><div ng-if=\"correctFareForm.motive.$touched|| submit\" ng-messages=correctFareForm.motive.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'adjustMotiveLableR\' | translate}}</div></div></div></div></div><div class=\"col-lg-4 col-sm-12 col-xs-12 col-md-4\" ng-if=noShowIsSelected style=\"border: 1px solid blue\"><div style=\"height: 85px\"><span class=correctFareClass style=\"width: 65%\">{{\'typeNoShow\' | translate}} <span style=color:red>*</span>:</span><div class=\"col-lg-offset-1 col-lg-11 col-md-offset-1 col-sm-12 col-xs-12 col-md-11\" style=\"font-weight: bold;padding-top: 5px\"><input type=radio name=noShow value=noDriverNoShowPayment ng-click=\"selectnoDriverNoShowPayment(\'noDriverNoShowPayment\')\" checked> {{\'noDriverNoShowPayment\' | translate}}</div><div class=\"col-lg-offset-1 col-lg-11 col-md-offset-1 col-sm-12 col-xs-12 col-md-11\" style=\"font-weight: bold;padding-top: 5px\"><input type=radio name=noShow value=withNoShowPaymentToTheDriver ng-click=\"selectnoDriverNoShowPayment(\'withNoShowPaymentToTheDriver\')\"> {{\'withNoShowPaymentToTheDriver\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>{{\'comments\' | translate}} <span style=color:red>*</span></label><textarea placeholder=\"{{\'messagePlaceholder\' | translate}}\" class=form-control name=comment ng-model=items.comment required ng-class=\"{ \'has-error\': correctFareForm.comment.$touched && correctFareForm.comment.$invalid }\"></textarea><div ng-if=\"correctFareForm.comment.$touched|| submit\" ng-messages=correctFareForm.comment.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'commentR\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid item price.</div>--></div></div></div></div></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dialogViews/createBookingSuccess.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><md-dialog-content ng-class=\"{\'whirl duo\' : items.loading }\"><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" ng-if=items.authPending>{{\'bookingSuccAS\' | translate}}</p><p class=\"editDocumentP text-center\" ng-if=\"!items.authPending && items.singleBooking\">{{\'bookingSucc11\' | translate}}</p><p class=\"editDocumentP text-center\" ng-if=\"!items.authPending && !items.singleBooking\">{{\'bookingSucc22\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><table class=\"table table-hover\"><thead><tr><th>{{\'idBooking1\' | translate}}</th><th>{{\'dateTimePickB1\' | translate}}</th><th ng-if=items.roundTrip>{{\'typeTableHead1\' | translate}}</th></tr></thead><tbody id=copyData><tr ng-repeat=\"data in items.tableData\"><td><span style=\"color: #337ab7;text-decoration: none\" ng-click=openPdf(data)>{{data.job_id}}&nbsp;&nbsp;&nbsp;</span></td><td>{{data.pickup_datetime | date:\'dd MMM yyyy, HH:mm\'}} hrs&nbsp;&nbsp;&nbsp;<span ng-if=!items.roundTrip><br></span></td><td ng-if=items.roundTrip><span ng-if=\"data.round == 0\">{{\'goOnly1\' | translate}}<br></span><span ng-if=\"data.round == 1\">{{\'returnOnly1\' | translate}}<br></span></td><td ng-if=\"items.tableData.length > 1\"><i data-testid=copiar_reserva_{{data.job_id}} class=\"fa fa-copy\" ng-click=getIndex($index)></i></td></tr></tbody></table></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\" ng-if=items.copied><p class=\"alert alert-success\">Resumen copiado correctamente</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><button data-testid=copiar_numero_reserva class=\"btn btn-primary\" ng-if=\"items.tableData.length == 1\" ng-click=getIndex(0)>{{\'copyButton1\' | translate}}</button> <button data-testid=cerrar_dialogo_reserva class=\"btn btn-primary\" ng-click=closeDialog()>{{\'acceptOnly1\' | translate}}</button></div></div></md-dialog-content><!--<md-dialog-actions>--><!--<md-button type=\"submit\" class=\"md-primary\">--><!--{{\'confirmButton\' | translate}}--><!--</md-button>--><!--<md-button ng-click=\"closeDialog()\" class=\"md-primary\">--><!--{{\'CloseButton\' | translate}}--><!--</md-button>--><!--</md-dialog-actions>--></md-dialog>");
$templateCache.put("app/components/dialogViews/driverMockupCsvFinalDownload.html","<md-dialog aria-label=\"List dialog\" style=width:700px><form method=post name=cancelBookingForm ng-submit=\"submit=true;cancelBookingForm.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"text-align: center;font-size: 30px;font-weight: 400;padding: 19px\">Datos listos para descargar</div></div></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary>Descargar plantilla terminada</md-button><md-button type=button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dialogViews/driverRating.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">{{items.message}}</p></div><select ng-model=items.selected_product ng-init=\" items.selected_product = \'January\'\" ng-options=\"product as product.name for product in items.monthRange\"></select><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\">{{items.ratingArray}}</div></div></md-dialog-content><md-dialog-actions><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dialogViews/editAdminUser.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><form method=post name=editNewAdminForm ng-submit=\"submit=true;editNewAdminForm.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\" id=showAgreement ng-show=!addAgreementStatus><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">{{\'editAdminHead\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"col-lg-6 col-sm-12 col-md-6 col-xs-12 pl0\"><!-- NAME --><label class=control-label>{{\'name\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=items.fullName name=fullName placeholder=\"{{\'namePlaceholderPet\' | translate}}\" required ng-class=\"{ \'has-error\': editNewAdminForm.fullName.$touched && editNewAdminForm.fullName.$invalid }\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\"editNewAdminForm.fullName.$touched|| submit\" ng-messages=editNewAdminForm.fullName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'nameR\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'nameV\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-12 col-md-6 col-xs-12 pr0\"><!-- RUT --><label class=control-label>{{\'rutLabel\' | translate}} <span style=color:red>*</span></label><input ng-rut type=text class=form-control ng-model=items.rut name=rut placeholder=\"{{\'namePlaceholderRUT\' | translate}}\" required ng-change=passengerRutChange() ng-class=\"{ \'has-error\': editNewAdminForm.rut.$touched && editNewAdminForm.rut.$invalid }\"><div ng-if=\"editNewAdminForm.rut.$touched || submit\" ng-messages=editNewAdminForm.rut.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'rutRequired\' | translate}}</div></div><div class=\"errormessage text-danger\" ng-if=passengerRUTError>{{\'rutValid\' | translate}}</div></div></div><!-- EMAIL --><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5\"><label class=control-label>{{\'email\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=items.email name=email placeholder=\"{{\'namePlaceholderEmail\' | translate}}\" required ng-class=\"{ \'has-error\': editNewAdminForm.email.$touched && editNewAdminForm.email.$invalid }\" pattern=^([_a-zA-Z0-9-+]+)(\\.[_a-zA-Z0-9-+]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*\\.)+([a-zA-Z]{2,3})$><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\"editNewAdminForm.email.$touched|| submit\" ng-messages=editNewAdminForm.email.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'requiredEmail\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'validEmail\' | translate}}</div></div></div><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5\">--><!--<label class=\"control-label\">User Status<span style=\"color:red\">*</span></label>--><!--<select class=\"form-control\" ng-model=\"items.is_active\" required name=\"statusUser\" ng-class=\"{ \'has-error\': editNewAdminForm.statusUser.$touched && editNewAdminForm.statusUser.$invalid }\">--><!--<option value=\"\" disabled selected>Select status of user</option>--><!--<option value=\"0\" >Inactive</option>--><!--<option value=\"1\" >Active</option>--><!--</select>--><!--<div ng-if=\"editNewAdminForm.statusUser.$touched|| submit\" ng-messages=\"editNewAdminForm.statusUser.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please select user status.</div>--><!--&lt;!&ndash;<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid email id.</div>&ndash;&gt;--><!--</div>--><!--</div>--><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5\">--><!--<label class=\"control-label\">Password<span style=\"color:red\">*</span></label>--><!--<input type=\"password\" class=\"form-control\" ng-model=\"items.password\" name=\"password\" placeholder=\"Password\" required ng-minlength=\"8\" ng-maxlength=\"16\" ng-class=\"{ \'has-error\': editNewAdminForm.password.$touched--><!--&& editNewAdminForm.password.$invalid }\" />--><!--<div ng-if=\"editNewAdminForm.password.$touched|| submit\" ng-messages=\"editNewAdminForm.password.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter password--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"minlength\">Minimum 8 characters are required.--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"maxlength\">Maximum 16 characters are allowed.--><!--</div>--><!--&lt;!&ndash;<div class=\"errormessage text-danger \" ng-message=\"pattern \">Please enter a valid country code.</div>&ndash;&gt;--><!--</div>--><!--</div>--><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5\">--><!--<label class=\"control-label\">Confirm Password<span--><!--style=\"color:red\">*</span></label>--><!--<input type=\"password\" class=\"form-control\" ng-model=\"items.confirmPassword\" name=\"confirmPassword\" placeholder=\"Confirm Password\" required ng-minlength=\"8\" ng-maxlength=\"16\" ng-class=\"{\'has-error\': editNewAdminForm.confirmPassword.$touched && editNewAdminForm.confirmPassword.$invalid }\"--><!--ng-change=\"matchPassword(items.confirmPassword)\" />--><!--<div ng-if=\"editNewAdminForm.confirmPassword.$touched|| submit\" ng-messages=\"editNewAdminForm.confirmPassword.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter confirm password.--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"minlength\">Minimum 8 characters are required.--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"maxlength\">Maximum 16 characters are allowed.--><!--</div>--><!--&lt;!&ndash;<div class=\"errormessage text-danger \" ng-message=\"pattern \">Please enter a valid mobile number.</div>&ndash;&gt;--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-show=\"items.passwordMatchFlag\">--><!--Password does not match.--><!--</div>--><!--</div>--><!-- USER TYPE --><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5\"><label class=control-label>{{\'userType\' | translate}}s <span style=color:red>*</span></label><select class=form-control ng-model=items.userType required name=userType ng-class=\"{ \'has-error\': editNewAdminForm.userType.$touched && editNewAdminForm.userType.$invalid }\"><option value=\"\" disabled>{{\'selectTypeOfUser\' | translate}}</option><option ng-repeat=\"userName in userType\" value={{userName.value}}>{{userName.name}}</option></select><div ng-if=\"editNewAdminForm.userType.$touched|| submit\" ng-messages=editNewAdminForm.userType.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'pleaseSelectUserType\' | translate}}.</div></div></div><!-- CORPORATE RUT --><div ng-if=\"items.userType == 1\" class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5\"><label class=control-label>{{\'corporateRut\' | translate}} <span style=color:red>*</span></label><input type=text ng-model=items.corporateRut placeholder=\"{{\'namePlaceholderCorporateRut\' | translate}}\" uib-typeahead=\"corporate as corporate.id for corporate in corporateRutAPI()\" class=\"form-control createBookingSelect\" name=corporateRut typeahead-on-select=onSelectingCorporate() typeahead-wait-ms=200 typeahead-template-url=customTemplate.html ng-class=\"{ \'has-error\': addNewAdminForm.corporateRut.$touched && addNewAdminForm.corporateRut.$invalid }\"><div class=\"errormessage text-danger\" ng-if=corporateRUTErrorRequired>{{\'rutRequired\' | translate}}</div></div><!-- CORPORATE Name --><div ng-if=\"items.userType == 1\" class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5\"><label class=control-label>{{\'corporateName\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control disabled ng-model=items.corporateName name=corporateName placeholder=\"{{\'corporateName\' | translate}}\"></div><!-- AGREED AGREEMENT --><div ng-if=\"items.userType == 1\" class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5\"><label class=control-label>{{\'agreedAgreements\' | translate}} <span style=color:red>*</span></label><div style=\"display: flex\"><div ng-click=addAgreement() class=manual-input>{{selectedAgreement}}</div><div><p><i class=\"fa fa-angle-right\" style=\"font-size:30px;padding: 0px 10px\" ng-click=addAgreement()></i></p></div></div><div class=\"errormessage text-danger\" ng-if=\"agreedAgreementsErrorRequired && submit\">{{\'selectAgreementReq\' | translate}}</div></div><!-- DESCRIPTION --><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5\"><label class=control-label>{{\'description\' | translate}}</label><textarea class=form-control ng-model=items.description placeholder=\"{{\'namePlaceholderDescription\' | translate}}\"></textarea></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><div ng-if=items.error class=\"alert alert-danger text-center alertMargin\">{{items.error}}</div></div></div><div class=\"row m0 p10\" id=hideAgreement ng-show=addAgreementStatus><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><!-- <p><i class=\"fa fa-angle-left\" style=\"font-size:26px\" ng-click=\"confirmAgreement()\"></i></p> --><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">{{\'agreementHeaderInRole\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\"><div class=row><div class=\"col-lg-4 col-sm-4 col-xs-12 col-md-4\"><label>{{\'agreNameLabel\' | translate}}:</label><div><ui-select ng-model=items.agreementSelected ng-change=getFilterChange();getFilterDataForEndowment() close-on-select=true ng-keyup=agreementSearch($select.search,$event) ng-change=getFilterChange();getFilterDataForEndowment()><ui-select-match placeholder=\"{{\'agreNameLabel\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in agreementShowArray | filter: $select.search\" when-scrolled=paginationChangedForAgreement() ng-click=aggrementchange();><div ng-bind-html=data.name></div></ui-select-choices></ui-select></div></div><!-- <div class=\"col-lg-4 col-sm-4 col-xs-12 col-md-4\">\n                                <label class=\"control-label\">{{\'corpoRut\' | translate}}</label>\n                                <input type=\"text\" class=\"form-control\" ng-model=\"items.rutFilter\" name=\"RUT\" placeholder=\"{{\'corpoRut\' | translate}}\" ng-rut\n                                    ng-change=\"rutChange()\" ng-blur=\"getFilterChange();getFilterDataForEndowment()\" />\n                                <div class=\"errormessage text-danger\" ng-if=\"items.rutInvalid\">{{\'rutValid\' | translate}}</div>\n                            </div>\n                            <div class=\"col-lg-4 col-sm-4 col-xs-12 col-md-4\">\n                                <label>{{\'corporateLabel\' | translate}}</label>\n                                <ui-select ng-model=\"items.corporateSelected\" ng-change=\"getFilterChange();getFilterDataForEndowment();corporate\" ng-keyup=\"corporateSearch($select.search,$event)\"\n                                     close-on-select=\"true\">\n                                    <ui-select-match placeholder=\"{{\'corporatePlaceholder\' | translate}}\">{{$select.selected.company_name}}</ui-select-match>\n                                    <ui-select-choices repeat=\"data.id as data in coprateListShow | filter: $select.search | orderBy:\'company_name\'\" when-scrolled=\"paginationChangedForCorporation()\"\n                                        ng-click=\"corporate($select)\">\n                                        <div ng-bind-html=\"data.company_name\"></div>\n                                    </ui-select-choices>\n                                </ui-select>\n                            </div> --></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><p class=\"alert alert-danger\" ng-if=items.errorMsg>{{\'selectAgreementReq\'| translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\" style=height:300px;overflow-y:auto when-scrolled=paginationChanged()><div class=table-responsive><table class=\"table table-hover\"><thead><tr><th>{{\'agreNameLabel\' | translate}}</th><th>{{\'corpoRut\' | translate}}</th><th>{{\'corporateLabel\' | translate}}</th><th>{{\'selectOnly\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"data in items.tableAgreement\" ng-style=\"{\'background-color\':data.color}\"><td>{{data.name}}</td><td>{{data.RUT | rut}}</td><td>{{data.company_name}}</td><td><input style=\"font-size: 16px\" type=checkbox ng-model=data.selected ng-click=selectParticularEndowment($index)></td></tr></tbody></table></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\"><button type=button style=\"text-transform: uppercase;float: right\" class=\"md-primary custom-button\" ng-click=cancelAgreement()>{{\'cancelButton\' | translate}}</button> <button type=button class=\"md-primary custom-button\" style=\"float: right\" ng-click=confirmAgreement()>{{\'confirmButtonInRole\' | translate}}</button></div></div></md-dialog-content><md-dialog-actions ng-show=!addAgreementStatus><md-button type=submit class=md-primary>{{\'confirmButtonInRole\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'cancelButton\' | translate}}</md-button></md-dialog-actions></form></md-dialog><script type=text/ng-template id=customTemplate.html><a style=\"cursor: pointer;\">\n        <span class=\"displayFlex\">\n            <span style=\"padding-left: 10px;\">\n                <span>{{match.model.company_name}}</span>\n            </span>\n        </span>\n    </a></script>");
$templateCache.put("app/components/dialogViews/editCancelReason.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><form method=post name=editCancelReason ng-submit=\"submit=true;editCancelReason.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">{{\'editReasonHead\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>{{\'reasonVariable\' | translate}} <span style=color:red>*</span></label><textarea placeholder=\"{{\'messagePlaceholder\' | translate}}\" class=form-control name=reason ng-model=items.reason required ng-class=\"{ \'has-error\': editCancelReason.reason.$touched && editCancelReason.reason.$invalid }\"></textarea><div ng-if=\"editCancelReason.reason.$touched|| submit\" ng-messages=editCancelReason.reason.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'editReasonError\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid item price.</div>--></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>{{\'cancelReasonEnglish\' | translate}} <span style=color:red>*</span></label><textarea placeholder=\"{{\'messagePlaceholder\' | translate}}\" class=form-control name=reasonEnglish ng-model=items.reason_name_english pattern=\"^[a-zA-Z0-9 ]+$\" required ng-class=\"{ \'has-error\': editCancelReason.reasonEnglish.$touched && editCancelReason.reasonEnglish.$invalid }\" ng-maxlength=50></textarea><div ng-if=\"editCancelReason.reasonEnglish.$touched|| submit\" ng-messages=editCancelReason.reasonEnglish.$error><div class=\"errormessage text-danger\" ng-message=required>Favor ingrese Causa de Cancelación (Versión Inglés)</div><div class=\"errormessage text-danger\" ng-message=pattern>Razón (Versión Inglés) no válido.</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'usernameMax\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid item price.</div>--></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>{{\'descriptionVariable\' | translate}}</label><textarea placeholder=\"{{\'messagePlaceholder\' | translate}}\" class=form-control name=description ng-model=items.description ng-class=\"{ \'has-error\': editCancelReason.description.$touched && editCancelReason.description.$invalid }\"></textarea><div ng-if=\"editCancelReason.description.$touched|| submit\" ng-messages=editCancelReason.description.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'descriptionR\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid item price.</div>--></div></div></div><!-- ticket Tv-1931 toggle buttons--><div><p class=\"basicRegistrationP text-center backgroundBasicPending editCancelReasonsVisibility\">{{\'visibleVariable\' | translate}}</p><div class=displayflex><p class=classBold>App</p><div style=\"font-size: 25px\" class=boleeanTypeColor><i ng-click=\"changeToggle(\'app\')\" ng-class=\"{\'fa fa-toggle-on\': items.is_visible_on_app , \'fa fa-toggle-off\': !items.is_visible_on_app}\"></i></div></div><div class=displayflex><p class=classBold>Panel</p><div style=\"font-size: 25px\" class=boleeanTypeColor><i ng-click=\"changeToggle(\'panel\')\" ng-class=\"{\'fa fa-toggle-on\': items.is_visible_on_panel, \'fa fa-toggle-off\': !items.is_visible_on_panel}\"></i></div></div><div class=displayflex><p class=classBold>POS</p><div style=\"font-size: 25px\" class=boleeanTypeColor><i ng-click=\"changeToggle(\'pos\')\" ng-class=\"{\'fa fa-toggle-on\':items.is_visible_on_pos , \'fa fa-toggle-off\': !items.is_visible_on_pos}\"></i></div></div><div class=displayflex><p class=classBold>Web</p><div style=\"font-size: 25px\" class=boleeanTypeColor><i ng-click=\"changeToggle(\'web\')\" ng-class=\"{\'fa fa-toggle-on\': items.is_visible_on_web , \'fa fa-toggle-off\': !items.is_visible_on_web}\"></i></div></div></div></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dialogViews/editCarDetailsPop.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><form method=post name=carEditForm ng-submit=\"submit=true;carEditForm.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">{{\'editCarPop\' | translate}}</p><!--{{items}}--></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt10\"><div ng-if=items.ErrMsg class=\"alert alert-danger text-center alertMargin\">{{items.ErrMsg}}</div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6\"><label class=control-label>{{\'vehicleTypeLabel\' | translate}}</label><ui-select ng-model=items.car_type name=carType required ng-class=\"{ \'has-error\': carEditForm.carType.$touched && carEditForm.carType.$invalid }\" close-on-select=true><ui-select-match placeholder=\"{{\'vehiclePlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in items.vehicleList | filter: $select.search\"><div ng-bind-html=data.name></div></ui-select-choices></ui-select><!--<select class=\"form-control\" ng-model=\"items.car_type\" name=\"carType\" required ng-class=\"{ \'has-error\': carEditForm.carType.$touched && carEditForm.carType.$invalid }\">--><!--<option value=\"\" disabled selected>Select Car Type</option>--><!--<option value=\"1\">SUV</option>--><!--<option value=\"2\">Sedan</option>--><!--<option value=\"3\">VAN</option>--><!--</select>--><div ng-if=\"carEditForm.carType.$touched || submit\" ng-messages=carEditForm.carType.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'vehicleReq\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6\"><label class=control-label>{{\'PPU\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=items.registration_number name=registrationNumber placeholder=\"{{\'PPU\' | translate}}\" required ng-class=\"{ \'has-error\': carEditForm.registrationNumber.$touched && carEditForm.registrationNumber.$invalid }\" pattern=^([A-Za-z]{2})([A-Za-z0-9]{2})([0-9]{2})*$ ng-maxlength=8 ng-minlength=3><div ng-if=\"carEditForm.registrationNumber.$touched|| submit\" ng-messages=carEditForm.registrationNumber.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'registrationNumRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'registrationNumValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'registrationNumMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'registrationNumMaximum\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'workingFor24\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=items.modelity name=modelityS required ng-class=\"{ \'has-error\': carEditForm.modelityS.$touched && carEditForm.modelityS.$invalid }\"><option value=\"\" disabled>{{\'selectModelityCar\' | translate}}</option><option value=1>Yes</option><option value=0>No</option></select><div ng-if=\"carEditForm.modelityS.$touched || submit\" ng-messages=carEditForm.modelityS.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'selectModelityCarReq\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'workingStatus\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=items.working_status name=workingStatus required ng-class=\"{ \'has-error\': carEditForm.workingStatus.$touched && carEditForm.workingStatus.$invalid }\"><option value=\"\" disabled>{{\'workingStatusPlaceholder\' | translate}}</option><option value=1>Active</option><option value=0>Inactive</option></select><div ng-if=\"carEditForm.workingStatus.$touched || submit\" ng-messages=carEditForm.workingStatus.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'workingStatusReq\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12 mt5\"><label class=control-label>{{\'uniqueNumber\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=items.uniqueCarId name=uniqueNumber placeholder=\"{{\'uniqueNumber\' | translate}}\" required ng-class=\"{ \'has-error\': carEditForm.uniqueNumber.$touched && carEditForm.uniqueNumber.$invalid }\" is-number=\"\" maxlength=5><div ng-if=\"carEditForm.uniqueNumber.$touched|| submit\" ng-messages=carEditForm.uniqueNumber.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'uniqueNumberReq\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Tipo Contrato <span style=color:red>*</span></label><select class=form-control ng-model=items.contrato_name name=contrato required ng-class=\"{ \'has-error\': carEditForm.contrato.$touched && carEditForm.contrato.$invalid }\"><option value=\"\" disabled>Select Tipo Contrato</option><option value=Freelance>Freelance</option><option value=Leasing>Leasing</option></select><div ng-if=\"carEditForm.contrato.$touched || submit\" ng-messages=carEditForm.contrato.$error><div class=\"errormessage text-danger\" ng-message=required>Favor seleccione Tipo Contrato</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Marca y Modelo:</label><!-- <ui-select ng-model=\"items.model\" name=\"model\" required ng-class=\"{ \'has-error\': carEditForm.model.$touched && carEditForm.model.$invalid }\"\n                            close-on-select=\"true\">\n                            <ui-select-match placeholder=\"Marca y Modelo\">{{$select.selected.name}}</ui-select-match>\n                            <ui-select-choices repeat=\"data.model_id as data in items.modelList | filter: $select.search\">\n                                <div ng-bind-html=\"data.name\"></div>\n                            </ui-select-choices>\n                        </ui-select> --><select class=form-control ng-model=items.model name=model required ng-class=\"{ \'has-error\': carEditForm.model.$touched && carEditForm.model.$invalid }\" ng-options=\"data.model_id\n                            as data.name for data in items.modelList\"><option value=\"\" disabled selected>Marca y Modelo</option></select><div ng-if=\"carEditForm.model.$touched || submit\" ng-messages=carEditForm.model.$error><div class=\"errormessage text-danger\" ng-message=required>Favor seleccione Marca y Modelo\"</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Sociedad SAP</label><select class=form-control ng-model=items.society_id name=society_id required ng-class=\"{ \'has-error\': carEditForm.society_id.$touched && carEditForm.society_id.$invalid }\" ng-options=\"data.society_id\n                            as data.name for data in items.societies\"><option value=\"\" disabled selected>Sociedad SAP</option></select><div ng-if=\"carEditForm.society_id.$touched || submit\" ng-messages=carEditForm.society_id.$error><div class=\"errormessage text-danger\" ng-message=required>Favor seleccione Sociedad</div></div></div><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6\"><div style=\"margin-left: -13px\" class=\"col-lg-8 col-sm-8 col-xs-12 col-md-8\"><label class=control-label>Color:</label><ui-select ng-model=items.color name=color required ng-class=\"{ \'has-error\': carEditForm.color.$touched && carEditForm.color.$invalid }\" close-on-select=true><ui-select-match placeholder=Color>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"data as data in items.vehicleColorList | filter: $select.search\"><div ng-bind-html=data.name></div></ui-select-choices></ui-select><div ng-if=\"carEditForm.color.$touched || submit\" ng-messages=carEditForm.color.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'vehicleReq\' | translate}}</div></div></div><div class=\"col-lg-4 col-sm-4 col-xs-12 col-md-4\" style=\"height: 34px;margin-top: 24px; background-color: {{items.color.code}}\"></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5\"><label class=control-label>{{\'verificationComments\' | translate}}:</label><div class=text-capitalize><textarea class=form-control ng-model=items.verification_comment placeholder=\"No Description\"></textarea></div></div></div><!-- <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12 mt5\">\n                    <input id=\"documentUpload\" filestyle=\"\" type=\"file\" style=\"display: none;\" image=\"image\" name=\"{{uploadName}}\" onchange=\"angular.element(this).scope().file_to_upload(this.files,this.name)\" onclick=\"this.value = null;\" data-button-text=\"Single\" data-class-button=\"btn btn-default\"\n                        data-classinput=\"form-control inline\" nv-file-select=\"\" uploader=\"uploader\" />\n                    <label class=\"control-label mt10\">{{\'Car Image\' | translate}}<span style=\"color:red\">*</span></label><br/>\n                    <img ng-src=\"{{ items.car_photo || \'assets/images/noImage.jpeg\'}}\" id=\"carImage\" class=\"documentStyle\" /><br/>\n                    <button type=\"button\" class=\"btn btn-primary upload mt10\" ng-click=\"clickTrigger($event,\'CAR_IMAGE\')\">{{\'uploadButton\' | translate}}\n                    </button>\n                </div> --><!-- <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12 mt5\">\n                    <label class=\"control-label mt10\">{{\'vehicleImage\' | translate}}<span style=\"color:red\">*</span></label><br/>\n                    <img ng-src=\"{{ items.registration_image || \'assets/images/noImage.jpeg\'}}\" id=\"registerImage\" class=\"documentStyle\" /><br/>\n                    <button type=\"button\" class=\"btn btn-primary upload mt10\" ng-click=\"clickTrigger($event,\'REGISTER_IMAGE\')\">{{\'uploadButton\' | translate}}\n                    </button>\n                </div> --><!-- <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12 mt5\">\n                    <label class=\"control-label mt10\">{{\'travelCard\' | translate}}<span style=\"color:red\">*</span></label><br/>\n                    <img ng-src=\"{{ items.travel_card_key || \'assets/images/noImage.jpeg\'}}\" id=\"travel\" class=\"documentStyle\" /><br/>\n                    <button type=\"button\" class=\"btn btn-primary upload mt10\" ng-click=\"clickTrigger($event,\'TRAVEL_CARD_KEY\')\">{{\'uploadButton\' | translate}}\n                    </button>\n                </div> --><!-- <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12 mt5\">\n                    <label class=\"control-label mt10\">{{\'passengerSeatInsurance\' | translate}}<span style=\"color:red\">*</span></label><br/>\n                    <img ng-src=\"{{ items.passenger_insurance_key || \'assets/images/noImage.jpeg\'}}\" id=\"seatInsurance\" class=\"documentStyle\" /><br/>\n                    <button type=\"button\" class=\"btn btn-primary upload mt10\" ng-click=\"clickTrigger($event,\'PASSENGER_INSURANCE_KEY\')\">{{\'uploadButton\' | translate}}\n                    </button>\n                </div> --><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12 mt5\"><input id=documentUpload filestyle=\"\" type=file style=\"display: none\" image=image name={{uploadName}} onchange=angular.element(this).scope().file_to_upload(this.files,this.name) onclick=\"this.value = null\" data-button-text=Single data-class-button=\"btn btn-default\" data-classinput=\"form-control inline\" nv-file-select=\"\" uploader=uploader><label class=\"control-label mt10\">{{\'circulationPermission\' | translate}} <span style=color:red>*</span></label><br><img ng-src=\"{{ items.permission_of_circulation || \'assets/images/noImage.jpeg\'}}\" id=permission class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10\" ng-click=\"clickTrigger($event,\'PERMISSION_OF_CIRCULATION\')\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12 mt5\"><label class=\"control-label mt10\">Permiso Min. Transporte<!-- <span style=\"color:red\">*</span> --></label><br><img ng-src=\"{{ items.transportation_permit || \'assets/images/noImage.jpeg\'}}\" id=transportation_permit class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10\" ng-click=\"clickTrigger($event,\'TRANSPORTATION_PERMIT\')\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12 mt5\"><label class=\"control-label mt10\">Contrato<!-- <span style=\"color:red\">*</span> --></label><br><img ng-src=\"{{ items.contrato || \'assets/images/noImage.jpeg\'}}\" id=contrato_image class=documentStyle><br><div ng-if=errorMessageSize><div class=\"errormessage text-danger\">el tamaño del archivo debe ser inferior a 5 MB.</div></div><div ng-if=errorMessage><div class=\"errormessage text-danger\">Document can only be JPG Type or PDF.</div></div><button type=button class=\"btn btn-primary upload mt10\" ng-click=\"clickTrigger($event,\'PERMISSION_OF_CONTRATO\')\">{{\'uploadButton\' | translate}}</button></div></div></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dialogViews/editCorrectFareReason.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><form method=post name=editCorrectFareReason ng-submit=\"submit=true;editCorrectFareReason.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">{{\'editCorrectReason\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>{{\'reasonLabel\' | translate}}<span style=color:red>*</span></label><textarea placeholder=\"{{\'messagePlaceholder\' | translate}}\" class=form-control name=reason ng-model=items.reason required ng-class=\"{ \'has-error\': editCorrectFareReason.reason.$touched && editCorrectFareReason.reason.$invalid }\"></textarea><div ng-if=\"editCorrectFareReason.reason.$touched|| submit\" ng-messages=editCorrectFareReason.reason.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'editReasonError\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid item price.</div>--></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>{{\'description\' | translate}}</label><textarea placeholder=\"{{\'messagePlaceholder\' | translate}}\" class=form-control name=description ng-model=items.description ng-class=\"{ \'has-error\': editCorrectFareReason.description.$touched && editCorrectFareReason.description.$invalid }\"></textarea><div ng-if=\"editCorrectFareReason.description.$touched|| submit\" ng-messages=editCorrectFareReason.description.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'descriptionR\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid item price.</div>--></div></div></div></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dialogViews/editDeleteRedHeading.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><form method=post name=addNoShowReasonForm ng-submit=\"submit=true;confirmUpload(items.editDelete)\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><h2 ng-if=items.editDelete style=\"color: red;font-size: 20px;font-weight: 500;letter-spacing: 0.005em\">{{ \'modifyItemPopToll\' | translate }}</h2><h2 style=\"color: red;font-size: 20px;font-weight: 500;letter-spacing: 0.005em\" ng-if=!items.editDelete>{{ \'deleteItemPopToll\' | translate }}</h2></div></div></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dialogViews/editDriverDocument.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><!--{{editDocument.url}}--><p class=editDocumentP ng-if=\"editDocument.name == \'RUT\'\">{{\'changeRutDoc\' | translate}}</p><p class=editDocumentP ng-if=\"editDocument.name == \'LICENSE\'\">{{\'changeVehicleDoc\' | translate}}</p><p class=editDocumentP ng-if=\"editDocument.name == \'ANTECENTS\'\">{{\'changeAntecedentsDoc\' | translate}}</p><p class=editDocumentP ng-if=\"editDocument.name == \'LIFE_SHEET\'\">{{\'changeLifeSheetDoc\' | translate}}</p><p class=editDocumentP ng-if=\"editDocument.name == \'COMPANY_IDENTITY\'\">{{\'changeIdentityDoc\' | translate}}</p><p class=editDocumentP ng-if=\"editDocument.name == \'COMPANY_CONSTITUTION\'\">{{\'changeCompanyConstDoc\' | translate}}</p><p class=editDocumentP ng-if=\"editDocument.name == \'ACTIVITY\'\">{{\'changeActivityDoc\' | translate}}</p><p class=editDocumentP ng-if=\"editDocument.name == \'INVOICE\'\">{{\'changeInvoiceDoc\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5 text-center\"><img ng-src=\"{{editDocument.url || \'assets/images/noImage.jpeg\'}}\" id=editDocument><br><input id=editDocumentType filestyle=\"\" type=file style=\"display: none\" image=image name={{editDocument.name}} onchange=angular.element(this).scope().file_to_upload(this.files,this.name) data-button-text=Single data-class-button=\"btn btn-default\" data-classinput=\"form-control inline\" nv-file-select=\"\" uploader=uploader> <button class=\"btn btn-primary mt25\" ng-click=clickTrigger($event)>{{\'uploadButton\' | translate}}</button><!--$(\'#editDocumentType\')[0].click() angular.element(document.getElementById(\'editDocumentType\')).triggerHandler(\'click\')--></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><div ng-if=editDocument.ErrMsg class=\"alert alert-danger text-center alertMargin\">{{editDocument.ErrMsg}}</div></div></div></md-dialog-content><md-dialog-actions><md-button ng-click=confirmUpload(FileUploaded,type) class=md-primary ng-disabled=editDocument.btnDisable>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dialogViews/editDriverEarning.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><form method=post name=editDriverEarning ng-submit=\"submit=true;editDriverEarning.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">{{\'editEarninigPopHead\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt10\"><label class=control-label>{{\'branchLabel\' | translate}}<span style=color:red>*</span></label><ui-select ng-model=items.branchSelected name=branch required ng-class=\"{ \'has-error\': editDriverEarning.branch.$touched && editDriverEarning.branch.$invalid }\" close-on-select=true><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in items.branches | filter: $select.search\"><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select><div ng-if=\"editDriverEarning.branch.$touched|| submit\" ng-messages=editDriverEarning.branch.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'branchR\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label class=control-label>{{\'serviceLabel\' | translate}}<span style=color:red>*</span></label><ui-select ng-model=items.typeOfServiceSelected name=service required ng-class=\"{ \'has-error\': editDriverEarning.service.$touched && editDriverEarning.service.$invalid }\" close-on-select=true ng-change=serviceChanged()><ui-select-match placeholder=\"{{\'selectTService\' | translate}}\">{{$select.selected.service_name}}</ui-select-match><ui-select-choices repeat=\"services.id as services in items.typeOfService | filter: $select.search\"><div ng-bind-html=services.service_name></div></ui-select-choices></ui-select><div ng-if=\"editDriverEarning.service.$touched|| submit\" ng-messages=editDriverEarning.service.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'serviceReq\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label class=control-label>{{\'vehicleTypeLabel\' | translate}}<span style=color:red>*</span></label><ui-select ng-model=items.vehicleTypeSelected name=vehicle required ng-class=\"{ \'has-error\': editDriverEarning.vehicle.$touched && editDriverEarning.vehicle.$invalid }\" close-on-select=true ng-disabled=\"items.vehicleType.length == 0\"><ui-select-match placeholder=\"{{\'vehiclePlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"vehicles.id as vehicles in items.vehicleType | filter: $select.search\"><div ng-bind-html=vehicles.name></div></ui-select-choices></ui-select><div ng-if=\"editDriverEarning.vehicle.$touched|| submit\" ng-messages=editDriverEarning.vehicle.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'selectTVehicleR\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'forAirportLabel\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=items.airportService name=airportService placeholder=\"{{\'forAirportLabel\' | translate}}\" required maxlength=3 ng-class=\"{ \'has-error\': editDriverEarning.airportService.$touched && editDriverEarning.airportService.$invalid }\" pattern=^[1-9][0-9.]*$><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\"editDriverEarning.airportService.$touched|| submit\" ng-messages=editDriverEarning.airportService.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'forAirportReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'forAirportValid\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'forNonAirportLabel\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=items.nonAirportService name=nonAirportService placeholder=\"{{\'forNonAirportLabel\' | translate}}\" pattern=^[1-9][0-9.]*$ required maxlength=3 ng-class=\"{ \'has-error\': editDriverEarning.nonAirportService.$touched && editDriverEarning.nonAirportService.$invalid }\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\"editDriverEarning.nonAirportService.$touched|| submit\" ng-messages=editDriverEarning.nonAirportService.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'forNonAirportReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'forNonAirportValid\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><div ng-if=items.error class=\"alert alert-danger text-center alertMargin\">{{items.error}}</div></div></div></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dialogViews/editNoShowReason.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><form method=post name=editNoShowReasonForm ng-submit=\"submit=true;editNoShowReasonForm.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">{{\'editNoShowReason\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>{{\'reasonLabel\' | translate}}<span style=color:red>*</span></label><textarea placeholder=\"{{\'messagePlaceholder\' | translate}}\" class=form-control name=reason ng-model=items.reason required ng-class=\"{ \'has-error\': editNoShowReasonForm.reason.$touched && editNoShowReasonForm.reason.$invalid }\"></textarea><div ng-if=\"editNoShowReasonForm.reason.$touched|| submit\" ng-messages=editNoShowReasonForm.reason.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'editReasonError\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid item price.</div>--></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>{{\'description\' | translate}}</label><textarea placeholder=\"{{\'messagePlaceholder\' | translate}}\" class=form-control name=description ng-model=items.description ng-class=\"{ \'has-error\': editNoShowReasonForm.description.$touched && editNoShowReasonForm.description.$invalid }\"></textarea><div ng-if=\"editNoShowReasonForm.description.$touched|| submit\" ng-messages=editNoShowReasonForm.description.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'descriptionR\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid item price.</div>--></div></div></div></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dialogViews/enableDisableGeoFence.html","<md-dialog aria-label=\"List dialog\" style=min-width:550px><form method=post name=addItemOfChargeInPriceForm ng-submit=\"submit=true;addItemOfChargeInPriceForm.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"font-size: 20px\">Habiliatar / deshabilitar Geocercas</p></div></div><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><div style=\"border: 1px black solid;  width: 500px\" class=\"col-lg-4 col-sm-4 col-xs-4 col-md-4\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\">Geocercas</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6 col-xs-12\"><label class=control-label>Nombre Sucursal</label><!-- <div class=\"input-group\">\n                                            <div class=\"input-group-addon searchBackground\">\n                                                <i class=\"fa fa-search\"></i>\n                                            </div> --> <input type=text class=form-control ng-model=Uniquesearch ng-change=vm.getFilter()><!-- </div> --></div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><div class=\"table-responsive tableWithMasterDataParentDive\" ng-switch=\"(vm.variableRoutePriceGot | filter:vm.search).length\"><div ng-switch-when=0 class=\"noSearch text-center\"><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse><!-- {{\'serialNumber\' | translate}} --></th><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>Nombre Sucursal</th><th style=width:70px current-text=vm.predicate title=\"{{\'branchLabel\' | translate}}\" text=\"\'coverage_area_id\'\" check=vm.reverse>Nombre Geocerca</th><th style=width:70px current-text=vm.predicate title=\"{{\'serviceLabel\' | translate}}\" text=\"\'typeOfService\'\" check=vm.reverse>Zona Aeropuerto</th></tr></thead><tbody ng-if=\"items.geofance_data.length > 0\"><tr ng-repeat=\"data in filtered =  items.geofance_data  | filter:Uniquesearch\"><td style=width:70px><md-checkbox class=md-primary ng-click=checkData(data,$index) ng-model=data.checked aria-label=Checkbox{{$index}}></md-checkbox></td><td style=width:70px>{{::data.region_id}}</td><td style=width:70px>{{::data.branch_name}}</td><!--<td>{{data.price_list_id.name}}</td>--><td style=width:70px>{{::data.region_name}}</td><td style=width:70px><span ng-if=\"data.isAirportService == 0\">NO</span> <span ng-if=\"data.isAirportService == 1\">YES</span></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=9 class=\"noDataClass text-center\">{{\'variablePriceNotFound\' | translate}}</th></tr></tfoot></table></div></div></div><button type=button ng-click=rightSide($index) class=topButton>>></button> <button type=button class=redButton ng-click=leftSide()>{{\'redButton\' | translate}}</button><!-- <div class=\"col-lg-4 col-sm-4 col-xs-4 col-md-4\">\n                        \n\n                    </div> --><div style=\"margin-left:70px;border: 1px black solid;width: 500px\" class=\"col-lg-4 col-sm-4 col-xs-4 col-md-4\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\">Geocercas habiliatadas</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6 col-xs-12\"><label class=control-label>Nombre Sucursal</label><!-- <div class=\"input-group\">\n                                                <div class=\"input-group-addon searchBackground\">\n                                                    <i class=\"fa fa-search\"></i>\n                                                </div> --> <input type=text class=form-control ng-model=UniquesearchIn ng-change=vm.getFilter()><!-- </div> --></div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><div class=\"table-responsive tableWithMasterDataParentDive\" ng-switch=\"(vm.variableRoutePriceGot | filter:vm.search).length\"><div ng-switch-when=0 class=\"noSearch text-center\"><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse><!-- {{\'serialNumber\' | translate}} --></th><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>Nombre Sucursal</th><th style=width:100px current-text=vm.predicate title=\"{{\'branchLabel\' | translate}}\" text=\"\'coverage_area_id\'\" check=vm.reverse>Nombre Geocerca</th><th style=width:125px current-text=vm.predicate title=\"{{\'serviceLabel\' | translate}}\" text=\"\'typeOfService\'\" check=vm.reverse>Zona Aeropuerto</th></tr></thead><tbody><tr ng-repeat=\"data in filtered =  items.geofance_data_in  | filter:UniquesearchIn\"><td style=width:70px><md-checkbox class=md-primary ng-click=checkDataIn(data,$index) ng-model=data.checkedLeft aria-label=Checkbox{{$index}}></md-checkbox></td><td style=width:70px>{{::data.region_id}}</td><td style=width:70px>{{::data.branch_name}}</td><!--<td>{{data.price_list_id.name}}</td>--><td style=width:100px>{{::data.region_name}}</td><td style=width:125px><span ng-if=\"data.isAirportService == 0\">NO</span> <span ng-if=\"data.isAirportService == 1\">YES</span></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=9 class=\"noDataClass text-center\">{{\'variablePriceNotFound\' | translate}}</th></tr></tfoot></table></div></div></div></div></div></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dialogViews/enableDisableGeoFenceVeiw.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><form method=post name=addItemOfChargeInPriceForm ng-submit=\"submit=true;addItemOfChargeInPriceForm.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"font-size: 20px\">Habiliatar / deshabilitar Geocercas</p></div></div><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><div style=\"border: 1px black solid;width: 500px\" class=\"col-lg-4 col-sm-4 col-xs-4 col-md-4\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\">Geocercas habiliatadas</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6 col-xs-12\"><label class=control-label>Nombre Sucursal</label><!-- <div class=\"input-group\">\n                                                <div class=\"input-group-addon searchBackground\">\n                                                    <i class=\"fa fa-search\"></i>\n                                                </div> --> <input type=text class=form-control ng-model=UniquesearchIn ng-change=vm.getFilter()><!-- </div> --></div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><div class=\"table-responsive tableWithMasterDataParentDive\" ng-switch=\"(vm.variableRoutePriceGot | filter:vm.search).length\"><div ng-switch-when=0 class=\"noSearch text-center\"><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>Nombre Sucursal</th><th style=width:100px current-text=vm.predicate title=\"{{\'branchLabel\' | translate}}\" text=\"\'coverage_area_id\'\" check=vm.reverse>Nombre Geocerca</th><th style=width:125px current-text=vm.predicate title=\"{{\'serviceLabel\' | translate}}\" text=\"\'typeOfService\'\" check=vm.reverse>Zona Aeropuerto</th></tr></thead><tbody><tr ng-repeat=\"data in filtered =  items.geofance_data_in  | filter:UniquesearchIn\"><td style=width:70px>{{::data.region_id}}</td><td style=width:70px>{{::data.branch_name}}</td><!--<td>{{data.price_list_id.name}}</td>--><td style=width:100px>{{::data.region_name}}</td><td style=width:125px><span ng-if=\"data.isAirportService == 0\">NO</span> <span ng-if=\"data.isAirportService == 1\">YES</span></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=9 class=\"noDataClass text-center\">{{\'variablePriceNotFound\' | translate}}</th></tr></tfoot></table></div></div></div></div></div></md-dialog-content><md-dialog-actions><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dialogViews/errorForCreateBooking.html","<div class=\"container-fluid ng-cloak\" style=\"max-width:600px;min-width: 100px;min-height: 100px;overflow: hidden;padding: 15px\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"text-align: center\"><i class=\"fa fa-exclamation-circle iconColor\" aria-hidden=true></i></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 textIn\">No disponemos de servicios para Ia direccion ingresada.<br>Le informaremos prontamente Ia ampliación de nuestra cobertura.</div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 textIn\" style=\"margin-bottom: 10px\"><button ng-click=closeDialog() class=aceptarButton>Aceptar</button></div></div></div><style>.iconColor {\n        font-size: 50px;\n        color: red;\n    }\n\n    .textIn {\n        padding-top: 14px;\n        text-align: center;\n        font-weight: 400;\n        text-align: center;\n        font-size: 16px;\n    }\n\n    .aceptarButton {\n        width: 250px;\n        height: 40px;\n        background-color: #ff6900;\n        color: white;\n        font-weight: bold;\n        font-size: 17px;\n        border-radius: 4px;\n    }</style>");
$templateCache.put("app/components/dialogViews/evidenceDeliveryPopUp.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><form method=post name=evidenceDeliver novalidate autocomplete=off><md-dialog-content style=\"border: 4px solid #ff6900\"><div class=\"row m0 evidencePop\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 evidenceHeaderDiv\"><p class=editDocumentP>{{\'evidenceDeliver\' | translate}}</p><span flex></span> <i class=\"fa fa-close\" style=font-size:24px ng-click=closeDialog()></i></div><div ng-if=showEvidenceOne class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"padding: 2px\"><img src={{items.delivered_evidence_photo_one}} class=evidenceImg></div><div ng-if=showEvidenceTwo class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"padding: 2px\"><img src={{items.delivered_evidence_photo_two}} class=evidenceImg></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 evidenceHeaderDiv\"><p class=editDocumentP style=\"color: #ff6900; margin: 0 auto !important\"><span ng-click=\"showEvidenceOne = true; showEvidenceTwo = false;\" ng-class=\"{\'disableSubmit\': showEvidenceOne}\">&lt </span><span ng-if=showEvidenceOne>1 {{\'of\' | translate}} 2 </span><span ng-if=showEvidenceTwo>2 {{\'of\' | translate}} 2 </span><span ng-click=\"showEvidenceOne = false; showEvidenceTwo = true;\" ng-class=\"{\'disableSubmit\': showEvidenceTwo}\">&gt</span></p></div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/components/dialogViews/evidenceNoDeliveryPopUp.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><form method=post name=evidenceNoDeliver novalidate autocomplete=off><md-dialog-content style=\"border: 4px solid #ff6900\"><div class=\"row m0 p10 evidencePop\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 evidenceHeaderDiv\"><p class=editDocumentP>{{\'evidenceNoDeliver\' | translate}}</p><span flex></span> <i class=\"fa fa-close\" style=font-size:24px ng-click=closeDialog()></i></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"padding: 2px\"><img src={{items.non_delivered_evidence_photo}} class=evidenceImg style=\"padding-bottom: 35px\"></div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/components/dialogViews/favAddressesView.html","<md-dialog aria-label=\"List dialog\" style=max-width:550px><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">Direcciones Favoritas</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchFavLoc class=\"form-control ng-pristine ng-valid ng-empty ng-touched\" placeholder=\"Buscar ubicación favorito\" ng-model-options=\"{ debounce: 500 }\" ng-model=items.searchaddress ng-change=getFilter() aria-invalid=false style=margin-top:3px;padding-top:3px></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 editDocumentP text-center mt25\" ng-if=\"items.list.length == 0 && items.agreementList.length == 0\">{{\'favLocationNo\' | translate}}</div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt25\" ng-repeat=\"data in items.list\" ng-click=divSelected(data,$index) ng-class=\"{\'colorChangeNewSelected apps-container\':  colorFlag[$index] }\"><div class=row><div class=\"col-lg-8 col-sm-8 col-xs-8 col-md-8\"><p><b>{{\'locationName\' | translate}}:</b> {{data.location_name}}</p><p><b>{{\'address\' | translate}}:</b> {{data.address}}</p></div><!-- <div class=\"col-lg-3 col-sm-3 col-xs-3 col-md-3\">\n                            <input type=\"radio\" name=\"location\" ng-model=\"items.selected\" value=\"{{data.location_id}}\" />\n                        </div> --><div class=\"col-lg-4 col-sm-4 col-xs-4 col-md-4\" ng-if=\"data.aggreement_address == 0\"><a data-testid=eliminar_favorito_{{data.location_id}} title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=deleteFavouriteAddress(data,$index)><i class=\"fa fa-trash\"></i></a></div><div class=\"col-lg-4 col-sm-4 col-xs-4 col-md-4\" ng-if=\"data.aggreement_address == 1\"></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-sm-12\"><span ng-if=\"$index != items.list.length - 1\"><hr></span></div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-sm-12\"><div data-testid=mensaje_favoritos ng-if=items.errMsg class=\"alert alert-danger text-center alertMargin\">{{items.errMsg}}</div></div></div></div></md-dialog-content><md-dialog-actions><md-button data-testid=confirmar_direccion_favorita ng-click=confirmUpload() ng-disabled=\"items.list.length == 0\" class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button data-testid=cancelar_direccion_favorita ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dialogViews/favAddressesViewChange.html","<md-dialog aria-label=\"List dialog\" style=width:550px><md-dialog-content><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"margin-left: 38px;margin-top: 10px;padding: 10px\"><span class=heartTop><i class=\"fa fa-heart-o\" aria-hidden=true></i> <span class=textTop>Direcciones Favoritas </span></span><button ng-click=closeDialog() class=buttonCancel><i class=\"fa fa-times\" aria-hidden=true></i> Cerrar</button></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center SearchBarView1\"><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\" style=\"margin-left: 14px;margin-bottom: 10px;margin-top: 10px\"><div><input type=text id=searchFavLoc class=\"form-control ng-pristine ng-valid ng-empty ng-touched\" placeholder=\"Buscar dirección favorito\" ng-model-options=\"{ debounce: 500 }\" ng-model=items.searchaddress ng-change=getFilter() aria-invalid=false style=\"border-radius: 4px 0px 0px 4px;margin-left: 19px\"> <button class=searchBarView><i style=color:#7E7E7E class=\"fa fa-search\" aria-hidden=true></i></button></div></div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><table class=\"table table-hover\"><!--ng-switch-default--><thead><tr><th style=\"padding-left: 35px !important;text-align: left;font-weight: unset;text-align: left !important;width:300px;font-weight: bold\" title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>Direcciones</th><th style=\"font-weight: unset;width:100px;font-weight: bold\" title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse>Eliminar</th></tr></thead><tbody><tr ng-repeat=\"data in items.list\"><td style=\"width:300px;text-align: left !important;padding-left: 35px !important\"><img src=../../../assets/images/placeholder.png><div style=\"padding-left: 25px;font-weight: 450;position: relative;margin-top: -20px\">{{data.address}}</div></td><td style=width:100px><md-checkbox class=md-primary ng-if=\"data.aggreement_address == 0\" ng-click=checkData(data,$index) ng-model=data.checked aria-label=Checkbox{{$index}}></md-checkbox></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noInvestorFound\' | translate}}</th></tr></tfoot></table></div></div></md-dialog-content><md-dialog-actions style=\"padding-bottom: 30px;padding-top: 30px\" ng-if=\"indexNew != 0\"><button class=selecciondaDelete>{{indexNew}} dirección seleccionda</button> <button class=cancelDelete ng-click=blackArray()>Cancelar</button> <button class=confirmDelete ng-click=confirmUpload() ng-disabled=\"items.list.length == 0\">{{\'confirmButton\' | translate}}</button></md-dialog-actions></md-dialog><style>md-checkbox.md-default-theme:not([disabled]).md-primary.md-checked .md-icon,\n    md-checkbox:not([disabled]).md-primary.md-checked .md-icon {\n        border: 2px solid #62D236;\n        border-radius: 4px;\n        background-color: white;\n        color: #62D236;\n    }\n\n    md-checkbox.md-default-theme:not([disabled]).md-primary:not(.md-checked) .md-icon,\n    md-checkbox:not([disabled]).md-primary:not(.md-checked) .md-icon {\n        color: rgba(0, 0, 0, 0.54);\n        border-radius: 4px;\n    }\n\n    md-checkbox.md-default-theme:not([disabled]).md-primary.md-checked .md-icon:after,\n    md-checkbox:not([disabled]).md-primary.md-checked .md-icon:after {\n        border-color: #62D236;\n    }\n\n    md-dialog md-dialog-content {\n        order: 1;\n        flex-direction: column;\n        overflow-y: auto;\n        overflow-x: hidden;\n        -webkit-overflow-scrolling: touch;\n    }</style>");
$templateCache.put("app/components/dialogViews/gaussControlSuccess.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px class=gaussControlClass><md-dialog-content><i class=\"fa fa-check fa-3x\" aria-hidden=true></i><h3>{{\'matrixSuccessfullySaved\' | translate}}</h3></md-dialog-content></md-dialog>");
$templateCache.put("app/components/dialogViews/generateCouponSuccess.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><md-dialog-content style=\"padding: 4%\"><h3 ng-if=\"items == 0\">Los cupones de descuento han sido generados.</h3><h3 ng-if=\"items == 1\">Cupón de promoción creado exitosamente</h3></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary ng-click=closeDialog()>Aceptar</md-button><md-button ng-if=\"items == 0\" ng-click=decline() class=md-primary>Descargar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dialogViews/lastGeneratedOTP.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">{{\'lastGeneratedOTP\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><p class=lastOTP>{{items.otp}}</p></div></div></md-dialog-content><md-dialog-actions><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dialogViews/makePaymentForSearch.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><h1 class=text-center>${{items.jobData.estimated_payment_cost || \'0\'}}</h1></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center mt10\"><p class=editDocumentP>Selección de Metodo de Pago</p><div class=mt10><table class=table><tbody><tr ng-repeat=\"data in items.agreementData.paymentNew\"><td style=\"text-align: left !important\">{{data.type}}</td><td><input type=radio ng-model=data.selected name=Payment ng-click=selectParticularPayment(data) ng-value=true></td></tr></tbody></table></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt10\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean>Imprimir comprobante</td><!--{{\'roundTrip\' | translate}}--><td class=boleeanTypeColor><i ng-click=\"items.print = !items.print;\" ng-class=\"{\'fa fa-toggle-on\': items.print , \'fa fa-toggle-off\': !items.print}\"></i></td></tr></tbody></table></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5 text-center\"><button class=\"btn btn-primary\" ng-click=confirmUpload()>Generar Venta</button></div></div></md-dialog-content><!--<md-dialog-actions>--><!--<md-button ng-click=\"confirmUpload()\" class=\"md-primary\">--><!--{{\'confirmButton\' | translate}}--><!--</md-button>--><!--<md-button ng-click=\"closeDialog()\" class=\"md-primary\">--><!--{{\'CloseButton\' | translate}}--><!--</md-button>--><!--</md-dialog-actions>--></md-dialog>");
$templateCache.put("app/components/dialogViews/manualAssignErrors.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">Errors</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><ul><li ng-repeat=\"msg in items.data\">{{msg.message}}</li><li>¿Seguro que deseas asignar?</li></ul></div></div></md-dialog-content><md-dialog-actions><md-button ng-click=confirmDialog() class=md-primary>CONTINUE</md-button><md-button ng-click=closeDialog() class=md-primary>CANCEL</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dialogViews/massivCreationOfPackage.html","<md-dialog aria-label=\"List dialog\" style=\"width: 750px\"><form method=post name=cancelBookingForm ng-submit=\"submit=true;cancelBookingForm.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"text-align: center;font-size: 26px;font-weight: 400;padding: 19px\">¿Seguro que desea realizar la Carga Masiva de Paquetes?</div></div></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary>SI</md-button><md-button type=button ng-click=closeDialog() class=md-primary>NO</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dialogViews/massiveCreateBookingSocketPopUp.html","<md-dialog aria-label=\"List dialog\" style=width:700px><form method=post name=cancelBookingForm ng-submit=\"submit=true;cancelBookingForm.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"text-align: center;font-size: 30px;font-weight: 400;padding: 19px\">El proceso de carga ha finalizado</div></div></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary>Descargar plantilla terminada</md-button><md-button type=button ng-click=goToNewPage() class=md-primary>Ver resultado</md-button><md-button type=button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dialogViews/massiveCreatePackageSocketPopUp.html","<md-dialog aria-label=\"List dialog\" style=width:700px><form method=post name=cancelBookingForm ng-submit=\"submit=true;cancelBookingForm.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"text-align: center;font-size: 30px;font-weight: 400;padding: 19px\">El proceso de carga ha finalizado</div></div></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary>Descargar plantilla terminada</md-button><md-button type=button ng-click=goToNewPage() class=md-primary>Ver resultado</md-button><md-button type=button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dialogViews/massiveModificationBookingSocketPopUp.html","<md-dialog aria-label=\"List dialog\" style=width:700px><form method=post name=cancelBookingForm ng-submit=\"submit=true;cancelBookingForm.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"text-align: center;font-size: 30px;font-weight: 400;padding: 19px\">El proceso de modificación a finalizado</div></div></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary>Descargar plantilla terminada</md-button><md-button type=button ng-click=goToNewPage() class=md-primary>Ver resultado</md-button><md-button type=button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dialogViews/massiveModificationOfBookingConfirmationPopUp.html","<md-dialog aria-label=\"List dialog\" style=width:833px><form method=post name=cancelBookingForm ng-submit=\"submit=true;cancelBookingForm.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"text-align: center;font-size: 25px;font-weight: 400;padding: 19px\">¿Está seguro que desea aplicar la modificación de reservas masiva?</div></div></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary>Si</md-button><md-button type=button ng-click=closeDialog() class=md-primary>No</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dialogViews/noShowMark.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px ng-class=\"{\'whirl duo\' : noShowitems.loading }\"><form method=post name=noShowMarkForm ng-submit=\"submit=true; noShowMarkForm.$valid&&confirmUpload();\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><!--{{noShowitems}}--><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">{{\'noShowMarkHead\' | translate}}</p><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 table-responsive\"><table class=\"table table-hover\"><thead><tr><th style=min-width:105px>{{\'idBooking\' | translate}}</th><th style=min-width:105px>{{\'dateTimePick\' | translate}}</th><th style=min-width:115px>{{\'assignmentState\' | translate}}</th><th style=min-width:115px>{{\'passengersCount\' | translate}}</th><th style=min-width:125px>{{\'customerDetailsHead\' | translate}}</th><th style=\"min-width: 150px\">{{\'thirdPersonBooking\' | translate}}</th><th style=\"min-width: 150px\">{{\'pickUpAddress\' | translate}}</th><th style=\"min-width: 150px\">{{\'dropOffAddress\' | translate}}</th><th>{{\'branchLabel\' | translate}}</th><th>{{\'serviceLabel\' | translate}}</th><th>{{\'agreementLabel\' | translate}}</th><th style=\"min-width: 100px\">{{\'roundTripShort\' | translate}}</th><th>{{\'stateTable\' | translate}}</th></tr></thead><tbody><tr><td>{{noShowitems.jobData.job_id}}</td><td><span ng-if=!noShowitems.jobData.dateFlagForShow>{{noShowitems.jobData.job_time | date: \'MMM d, yyyy hh:mm a\'}} </span><span ng-if=noShowitems.jobData.dateFlagForShow>{{noShowitems.jobData.job_time | date: \'hh:mm a\'}}</span></td><td><span ng-if=!noShowitems.jobData.fleet_first_name>No Assigned</span> <span ng-if=noShowitems.jobData.fleet_first_name>Vehicle #{{noShowitems.jobData.transport_details}}<br>Unique #{{noShowitems.jobData.unique_car_id}}<br>{{noShowitems.jobData.fleet_first_name + \' \' + noShowitems.jobData.fleet_last_name}}<br>{{noShowitems.jobData.fleet_country_code?noShowitems.jobData.fleet_phone_number:noShowitems.jobData.fleet_country_code + noShowitems.jobData.fleet_phone_number || \'--\'}}</span></td><td>{{noShowitems.jobData.number_of_passangers}}</td><td>Name: <b>{{noShowitems.jobData.customer_first_name + \' \' + noShowitems.jobData.customer_last_name}}</b><br>Mobile Number: <b>{{noShowitems.jobData.customer_country_code?noShowitems.jobData.customer_phone_number:noShowitems.jobData.customer_country_code+noShowitems.jobData.customer_phone_number}}</b><br>ID: <b>{{noShowitems.jobData.created_by}}</b><br></td><td><div ng-if=noShowitems.jobData.booking_for>Name: <b>{{noShowitems.jobData.job_pickup_name}}</b><br>Mobile Number: <b>{{noShowitems.jobData.job_pickup_phone}}</b><br>Email: <b>{{noShowitems.jobData.job_pickup_email || \'--\'}}</b><br></div><div ng-if=!noShowitems.jobData.booking_for>NO</div></td><td>{{noShowitems.jobData.job_pickup_address || \'--\'}}</td><td>{{noShowitems.jobData.job_address || \'--\'}}</td><td>{{noShowitems.jobData.branch || \'--\'}}</td><td>{{noShowitems.jobData.type_of_service}}</td><td>{{noShowitems.jobData.agreement}}</td><td><span ng-if=noShowitems.jobData.is_round_trip><span ng-if=\"noShowitems.jobData.round_trip_parent_job_id == 0\">{{noShowitems.jobData.return_date_time | date:\'medium\'}}</span> <span ng-if=\"noShowitems.jobData.round_trip_parent_job_id != 0\">#{{noShowitems.jobData.round_trip_parent_job_id}}</span> </span><span ng-if=\"noShowitems.jobData.is_round_trip == 0\"><span ng-if=\"noShowitems.jobData.round_trip_parent_job_id == 0\">NO</span> <a ui-sref=\"layout.upcomingBookingsMain.upcomingBookingDetails({id:\'{{noShowitems.jobData.round_trip_parent_job_id}}\',type:\'0\'})\" ng-if=\"noShowitems.jobData.round_trip_parent_job_id != 0\"><span>#{{noShowitems.jobData.round_trip_parent_job_id}}</span></a></span></td><td><sapn ng-if=\"noShowitems.jobData.job_status == \'0\'\">{{\'upcomingStatus\' | translate}}</sapn><sapn ng-if=\"noShowitems.jobData.job_status == \'1\'\">Viaje Iniciado</sapn><sapn ng-if=\"noShowitems.jobData.job_status == \'2\'\">Ended</sapn><sapn ng-if=\"noShowitems.jobData.job_status == \'3\'\">Failed</sapn><sapn ng-if=\"noShowitems.jobData.job_status == \'4\'\">En Posición</sapn><sapn ng-if=\"noShowitems.jobData.job_status == \'5\'\">Partial</sapn><sapn ng-if=\"noShowitems.jobData.job_status == \'6\'\">Unassigned</sapn><sapn ng-if=\"noShowitems.jobData.job_status == \'7\'\">Accepted</sapn><sapn ng-if=\"noShowitems.jobData.job_status == \'8\'\">Decline</sapn><sapn ng-if=\"noShowitems.jobData.job_status == \'9\'\">Cancel</sapn><sapn ng-if=\"noShowitems.jobData.job_status == \'10\'\">Deleted</sapn><sapn ng-if=\"noShowitems.jobData.job_status == \'11\'\">Ignored</sapn><sapn ng-if=\"noShowitems.jobData.job_status == \'12\'\">No Show</sapn><sapn ng-if=\"noShowitems.jobData.job_status == \'15\'\">En Camino</sapn></td></tr></tbody></table></div></div></div><div class=\"row m0 p10\"><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 editDocumentP1 text-center\" style=padding:6px><div><p><b>{{\'maxTimeLabel\' | translate}}:</b> {{noShowitems.noShowData.max_wait_time_tolerance}}</p></div></div><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 editDocumentP1\" style=padding:6px><div><p><b>{{\'originalPickUpTime\' | translate}}:</b> {{noShowitems.noShowData.job_time_utc | date:\'medium\'}}</p></div></div><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 col-lg-offset-6 col-md-offset-6 col-xs-offset-0 col-sm-offset-6 editDocumentP1\" style=padding:6px><div><p><b>{{\'pickTimeTolerance\' | translate}}:</b> {{noShowitems.noShowData.pickup_scheduled_datetime_tolerance | date:\'medium\'}}</p></div></div><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 col-lg-offset-6 col-md-offset-6 col-xs-offset-0 col-sm-offset-6 editDocumentP1\" style=padding:6px><div><p><b>{{\'inpositionDateTime\' | translate}}:</b> {{noShowitems.noShowData.arrived_datetime | date:\'medium\'}}</p></div></div><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 col-lg-offset-6 col-md-offset-6 col-xs-offset-0 col-sm-offset-6 editDocumentP1\" style=padding:6px><div><p><b>{{\'minuteDelay\' | translate}}:</b> {{noShowitems.noShowData.minute_of_delay}} minutes</p></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=margin-top:10px><p class=\"editDocumentP text-center\" style=color:red>{{noShowitems.noShowData.message}}</p></div></div><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=margin-top:10px><div ng-if=noShowitems.errorMsg class=\"alert alert-danger text-center alertMargin\">{{noShowitems.errorMsg}}</div><div class=displayFlex><label class=\"control-label noShowmarkLabel\">{{\'noShowReasonLabel\' | translate}}<span style=color:red>*</span> :</label><div style=\"display: block;width: 58%\"><select style=width:50% class=form-control ng-model=noShowitems.reasonSelected ng-options=\"data.reason as data.reason for data in noShowitems.noShowReasonData\" name=noShowReason required ng-class=\"{ \'has-error\': noShowMarkForm.noShowReason.$touched && noShowMarkForm.noShowReason.$invalid }\"><option value=\"\" selected disabled>{{\'noShowReasonPlaceholder\' | translate}}</option></select><div ng-if=\"noShowMarkForm.noShowReason.$touched || submit\" ng-messages=noShowMarkForm.noShowReason.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'reasonR\' | translate}}</div></div></div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=margin-top:10px><div class=displayFlex><label class=noShowmarkLabel>{{\'commentsLabel\' | translate}}:</label><textarea style=width:50% placeholder=\"{{\'messagePlaceholder\' | translate}}\" class=form-control name=description ng-model=noShowitems.description ng-class=\"{ \'has-error\': noShowMarkForm.description.$touched && noShowMarkForm.description.$invalid }\"></textarea></div></div></div></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dialogViews/openPopForPendingPayment.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: none\">{{items.data.message}}<span>Su última reserva de pago pendiente es <a style=\"cursor: pointer\" ng-click=gotToPreviousBooking(items)>#{{items.data.data.job_id}}</a></span></p></div></div></md-dialog-content><md-dialog-actions><md-button ng-click=closeDialog() class=md-primary>Cerrar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dialogViews/pushNotification.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">{{\'pushPopHead\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label class=control-label>{{\'to\' | translate}}:</label><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 fleet_notification\" style=\"padding-bottom: 5px\"><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 text-center paddingZero\"><p class=orange ng-class=\"{\'aFleet\': drivers,\'aCar\': !drivers}\" id=fleet ng-click=allFleet()>{{\'allFleet\' | translate}}</p></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 text-center paddingZero\"><p class=orange ng-click=virtualFleet() ng-class=\"{\'aFleet\': virtualDrivers,\'aCar\': !virtualDrivers}\">{{\'virtualFleetLabel\' | translate}}</p></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 text-center paddingZero\"><p class=orange id=car ng-click=allCar() ng-class=\"{\'aFleet\': carNumber,\'aCar\': !carNumber}\">{{\'carLabel\' | translate}}</p></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt10\"><label ng-if=drivers>{{\'selectFleet\' | translate}}:</label><div ng-if=drivers ng-dropdown-multiselect=\"\" options=allDrivers selected-model=dataToFill.notificationFleet checkboxes=true extra-settings=example14settings></div><!--<select ng-if=\"drivers\" style=\"padding-top: 20px;\" ng-options=\"data for data in allDrivers\" show-select-all=\"true\" show-unselect-all=\"true\" ng-model=\"dataToFill.notificationFleet\" required multiple=\"multiple\"><div ng-bind-html=\"data.name\"></div></select>--><!--<ui-select ng-if=\"drivers\" ng-model=\"dataToFill.notificationFleet\" close-on-select=\"true\">\n                                <ui-select-match placeholder=\"Select Fleet\">{{$select.selected.name}} </ui-select-match>\n                                <ui-select-choices repeat=\"data in allDrivers\">\n                                    <div ng-bind-html=\"data.name\"></div>\n                                </ui-select-choices>\n                            </ui-select>{{dataToFill.notificationFleet.id}}--><label ng-if=virtualDrivers>{{\'virtualFleetPlaceholder\' | translate}}:</label><ui-select ng-if=virtualDrivers ng-model=dataToFill.notificationVirtualFleet close-on-select=true><ui-select-match placeholder=\"{{\'virtualFleetPlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"data in vm.branch | filter: $select.search\"><div ng-bind-html=data.name></div></ui-select-choices></ui-select><label ng-if=carNumber>{{\'selectCar\' | translate}}:</label><div ng-if=carNumber ng-dropdown-multiselect=\"\" options=onlineCar selected-model=dataToFill.notificationCar checkboxes=true extra-settings=example14settings></div><!--<ui-select ng-if=\"carNumber\" ng-model=\"dataToFill.notificationCar\" close-on-select=\"true\">\n                                <ui-select-match placeholder=\"Select Car\">{{$select.selected.id}} </ui-select-match>\n                                <ui-select-choices repeat=\"data in onlineCar\">\n                                    <div ng-bind-html=\"data.id\"></div>\n                                </ui-select-choices>\n                            </ui-select>--></div></div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt10\"><label class=control-label>{{\'message\' | translate}}:</label><br><textarea class=form-control ng-model=dataToFill.adminMessage placeholder=\"{{\'messagePlaceholder\' | translate}}\"></textarea></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt10\"><div ng-if=items.ErrMsg class=\"alert alert-danger text-center alertMargin\">{{items.ErrMsg}}</div></div></div><!--<p style=\"color:red\" ng-if=\"message\">Please Enter admin message</p>\n        <p style=\"color:red\" ng-if=\"fleet\">Please select fleet</p>--></md-dialog-content><md-dialog-actions><md-button ng-click=confirmUpload() class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dialogViews/pushNotificationToCustomer.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">{{\'sendMessageTo\' | translate}} {{items.userName}}</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt10\"><label class=control-label>{{\'messageAdminLog\' | translate}}:</label><br><textarea class=form-control ng-model=adminMessage placeholder=\"{{\'messagePlaceholder\' | translate}}\"></textarea></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt10\"><p style=color:red ng-if=items.adminMessageEmpty>{{\'messageR\' | translate}}</p></div></div><!--<p style=\"color:red\" ng-if=\"message\">Please Enter admin message</p>--></md-dialog-content><md-dialog-actions><md-button ng-click=confirmSendNotification(adminMessage) class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dialogViews/readjustPrice.html","<form name=operationRegisterForm ng-submit=\"submit=true;operationRegisterForm.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog aria-label=\"List dialog\" style=min-width:550px ng-class=\"{\'whirl duo\' : loading1 }\"><md-dialog-content><div class=\"row m0 p10\"><!-- <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">\n                <p class=\"editDocumentP text-center\">{{\'selectPriceList\' | translate}}</p>\n            </div> --><div class=\"col-lg-5 col-sm-5 col-md-5 col-xs-12\" style=\"padding: 30px;font-size: 18px;font-weight: bold\">Tipo de rejuste :</div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" style=\"padding: 30px 0px; font-size: 16px\"><input type=radio name=gender value=percentage ng-click=\"percentage(\'percentage\')\" name=pointName1 required> Porcentaje<br></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" style=\"padding: 0px 0px; font-size: 16px\"><input type=radio name=gender value=monto ng-click=\"MontoFija(\'monto\')\" name=pointName2 required> Monto fijo<br></div></div><!-- <div class=\"row m0 p10\">\n            <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12\">\n                <label>{{\'agreementLabel\' | translate}}</label>\n                <ui-select ng-model=\"items.agreementFilter\" close-on-select=\"true\" ng-change=\"agreementChangeFilter(items.agreementFilter)\">\n                    <ui-select-match placeholder=\"{{\'agreementPlaceholder\' | translate}}\">{{$select.selected.name}} </ui-select-match>\n                    <ui-select-choices repeat=\"data.id as data in items.agreementListForCopy | filter: $select.search\">\n                        <div ng-bind-html=\"data.name\"></div>\n                    </ui-select-choices>\n                </ui-select>\n            </div>\n            <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12\">\n                <label>{{\'priceListStatusLabel\' | translate}}</label>\n                <select class=\"form-control\" ng-model=\"items.statusFilter\" ng-change=\"statusChangeFilter(items.statusFilter)\">\n                    <option value=\"\" selected disabled>{{\'priceListStatusPlaceholder\' | translate}}</option>\n                    <option value=\"1\">Inactive</option>\n                    <option value=\"0\">Active</option>\n                    <option value=\"2\">All</option>\n                </select>\n            </div>\n        </div> --><div class=\"row m0 p10\" ng-if=\"showInputBox == true\"><div class=\"col-lg-5 col-sm-5 col-md-5 col-xs-12\" style=\"padding: 30px;font-size: 18px;font-weight: bold\">Valor :</div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12\" style=\"padding: 30px 0px; font-size: 16px\"><input type=text ng-model=value ng-keyup=valuePrice(value,$event) placeholder=1 ng-keydown=valueDown($event) class=form-control name=pointName2 required ng-class=\"{ \'has-error\': operationRegisterForm.pointName2.$touched && operationRegisterForm.pointName2.$invalid }\" min={{messageToShowInvalid}} pattern=^(\\-?|\\+?)\\d*$><div ng-if=\"operationRegisterForm.pointName2.$touched || submit\" ng-messages=operationRegisterForm.pointName2.$error><!-- <div class=\"errormessage text-danger\" ng-message=\"min\">Monto no válido. Debe ser mayor que {{priceValue}}</div>--><div class=\"errormessage text-danger\" ng-if=\"messageToShowInvalidMonto == true\">Monto no válido. Debe ser mayor que -{{priceValue}}</div><div class=\"errormessage text-danger\" ng-if=\"messageToShowInvalidMonto != true\" ng-message=pattern>número no es válido</div><div class=\"errormessage text-danger\" ng-if=\"messageToShowInvalidMonto != true\" ng-message=required>Valor es requerido</div></div></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\" style=\"padding: 35px 5px; font-size: 16px;color:red\">Minima: {{priceValue}}</div><div ng-if=\"reAdjustPrice.pointName3.$touched|| submit\" ng-messages=reAdjustPrice.pointName3.$error><div class=\"errormessage text-danger\" ng-message=required>Nombre es requerido</div></div><!-- <div class=\"errormessage text-danger\" ng-message=\"required\">Nombre es requerido</div> --></div><div class=\"row m0 p10\" ng-if=\"showInputBox == false\"><div class=\"col-lg-5 col-sm-5 col-md-5 col-xs-12\" style=\"padding: 30px;font-size: 18px;font-weight: bold\">Valor :</div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12\" style=\"padding: 30px 0px; font-size: 16px\"><input type=number ng-model=value ng-keydown=downValuePercentage($event) ng-keyup=valuePricePercentage(value) placeholder=1.0 max={{max}} ng-keydown=valueDownPercentage($event) class=form-control name=pointName1 required ng-class=\"{ \'has-error\': operationRegisterForm.pointName1.$touched && operationRegisterForm.pointName1.$invalid }\" pattern=^-?\\d*\\.?\\d+$><!-- <div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div> --><div ng-if=\"operationRegisterForm.pointName1.$touched|| submit\" ng-messages=operationRegisterForm.pointName1.$error><div class=\"errormessage text-danger\" ng-if=\"messageToShowInvalid != true\" ng-message=required>Valor es requerido</div><div class=\"errormessage text-danger\" ng-if=\"messageToShowInvalid == true\">Descuento no puede ser mayor que 100% del valor.</div><div class=\"errormessage text-danger\" ng-if=\"messageToShowInvalid != true\" ng-message=max>El porcentaje debe ser menor o igual a 9999%</div><div class=\"errormessage text-danger\" ng-if=\"messageToShowInvalid != true\" ng-message=pattern>número no es válido</div></div></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\" style=\"padding: 30px 5px; font-size: 23px;color:grey\">%</div><!-- <div class=\"errormessage text-danger\" ng-message=\"required\">Nombre es requerido</div> --></div></md-dialog-content><md-dialog-actions><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button><md-button ng-click=confirmUpload(operationRegisterForm) class=md-primary>{{\'confirmButton\' | translate}}</md-button></md-dialog-actions></md-dialog></form>");
$templateCache.put("app/components/dialogViews/resetPassWordDriver.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><form method=post name=changePasswordForm ng-submit=\"submit=true;changePasswordForm.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">Restablecer Contraseña</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=margin-top:10px><div class=\"form-group has-feedback\"><label>Nueva Contraseña</label><input type=password placeholder=\"Nueva Contraseña\" ng-class=\"{ \'has-error\': changePasswordForm.password.$touched\n                                                    && changePasswordForm.password.$invalid }\" ng-model=items.password name=password required class=form-control autocomplete=off ng-change=matchPassword(items.password) ng-minlength=8 maxlength=16> <span class=\"fa fa-lock form-control-feedback text-muted\"></span><div ng-if=\"changePasswordForm.password.$touched|| submit\" ng-messages=changePasswordForm.password.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'RequiredField\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>Contraseña debe tener al menos 8 caracteres</div><!-- <div class=\"errormessage text-danger\" ng-message=\"maxlength\">{{\'passwordMax\' | translate}}\n                            </div> --></div></div><div class=\"form-group has-feedback\"><label>Repetir Contraseña</label><input type=password placeholder=\"Repetir Contraseña\" ng-class=\"{ \'has-error\': changePasswordForm.confirmPassword.$touched\n                                            && changePasswordForm.confirmPassword.$invalid }\" ng-model=items.confirmPassword name=confirmPassword required class=form-control ng-change=matchConfirmPassword(items.confirmPassword) autocomplete=off ng-minlength=8 maxlength=16> <span class=\"fa fa-lock form-control-feedback text-muted\"></span><div ng-if=\"changePasswordForm.confirmPassword.$touched|| submit\" ng-messages=changePasswordForm.confirmPassword.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'RequiredField\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>Contraseña debe tener al menos 8 caracteres</div><!-- <div class=\"errormessage text-danger\" ng-message=\"maxlength\">{{\'passwordMax\' | translate}}\n                            </div> --></div><div class=\"errormessage text-danger\" ng-if=items.passwordMatchFlag>{{\'passwordNotMatch\' | translate}}</div></div></div></div></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dialogViews/resetPassWordDriverMail.html","<md-dialog aria-label=\"List dialog\" style=min-width:300px><form method=post name=changePasswordForm ng-submit=\"submit=true;changePasswordForm.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">Enviar correo restablecimiento de Contraseña</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"margin-top: 20px;text-align: center;font-size: 15px\">{{\'sendEmail\' | translate}}</div></div></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dialogViews/resetPasswordOfCustomer.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><form method=post name=changePasswordForm ng-submit=\"submit=true;changePasswordForm.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">Restablecer Contraseña</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=margin-top:10px><div class=\"form-group has-feedback\"><label>Nueva Contraseña</label><input type=password placeholder=\"Nueva Contraseña\" ng-class=\"{ \'has-error\': changePasswordForm.password.$touched\n                                                    && changePasswordForm.password.$invalid }\" ng-model=items.password name=password required class=form-control autocomplete=off ng-change=matchPassword(items.password) ng-minlength=8 maxlength=16> <span class=\"fa fa-lock form-control-feedback text-muted\"></span><div ng-if=\"changePasswordForm.password.$touched|| submit\" ng-messages=changePasswordForm.password.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'RequiredField\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>Contraseña debe tener al menos 8 caracteres</div><!-- <div class=\"errormessage text-danger\" ng-message=\"maxlength\">{{\'passwordMax\' | translate}}\n                            </div> --></div></div><div class=\"form-group has-feedback\"><label>Repetir Contraseña</label><input type=password placeholder=\"Repetir Contraseña\" ng-class=\"{ \'has-error\': changePasswordForm.confirmPassword.$touched\n                                            && changePasswordForm.confirmPassword.$invalid }\" ng-model=items.confirmPassword name=confirmPassword required class=form-control ng-change=matchConfirmPassword(items.confirmPassword) autocomplete=off ng-minlength=8 maxlength=16> <span class=\"fa fa-lock form-control-feedback text-muted\"></span><div ng-if=\"changePasswordForm.confirmPassword.$touched|| submit\" ng-messages=changePasswordForm.confirmPassword.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'RequiredField\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>Contraseña debe tener al menos 8 caracteres</div><!-- <div class=\"errormessage text-danger\" ng-message=\"maxlength\">{{\'passwordMax\' | translate}}\n                            </div> --></div><div class=\"errormessage text-danger\" ng-if=items.passwordMatchFlag>{{\'passwordNotMatch\' | translate}}</div></div></div></div></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dialogViews/resetPasswordOfCustomerMail.html","<md-dialog aria-label=\"List dialog\" style=min-width:300px><form method=post name=changePasswordForm ng-submit=\"submit=true;changePasswordForm.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">Enviar correo restablecimiento de Contraseña</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"margin-top: 20px;text-align: center;font-size: 15px\">{{\'sendEmail\' | translate}}</div></div></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dialogViews/selectDriverForCarShift.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><!--{{items}}--><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">{{\'assignHead-1\' | translate}}</p><div ng-if=items.ShiftErrMsg class=\"alert alert-danger text-center alertMargin\">{{items.ShiftErrMsg}}</div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 table-responsive\"><table class=\"table table-hover\"><thead><tr><th style=min-width:105px>{{\'idBooking\' | translate}}</th><th style=min-width:105px>{{\'dateTimePick\' | translate}}</th><th style=min-width:115px>{{\'assignmentState\' | translate}}</th><th style=min-width:115px>{{\'passengersCount\' | translate}}</th><th style=min-width:125px>{{\'customerDetailsHead\' | translate}}</th><th style=\"min-width: 150px\">{{\'thirdPersonBooking\' | translate}}</th><th style=\"min-width: 150px\">{{\'pickUpAddress\' | translate}}</th><th style=\"min-width: 150px\">{{\'dropOffAddress\' | translate}}</th><th>{{\'branchLabel\' | translate}}</th><th>{{\'serviceLabel\' | translate}}</th><th>{{\'agreementLabel\' | translate}}</th><th style=\"min-width: 100px\">{{\'roundTripShort\' | translate}}</th><th>{{\'stateTable\' | translate}}</th></tr></thead><tbody><tr><td>{{items.jobData.job_id}}</td><td><span ng-if=!items.jobData.dateFlagForShow>{{items.jobData.job_time | date: \'MMM d, yyyy hh:mm a\'}} </span><span ng-if=items.jobData.dateFlagForShow>{{items.jobData.job_time | date: \'hh:mm a\'}}</span></td><td><span ng-if=!items.jobData.fleet_first_name>No Assigned</span> <span ng-if=items.jobData.fleet_first_name>Vehicle #{{items.jobData.transport_details}}<br>Unique #{{items.jobData.unique_car_id}}<br>{{items.jobData.fleet_first_name + \' \' + items.jobData.fleet_last_name}}<br>{{items.jobData.fleet_country_code?items.jobData.fleet_phone_number:items.jobData.fleet_country_code + items.jobData.fleet_phone_number || \'--\'}}</span></td><td>{{items.jobData.number_of_passangers}}</td><td>Name: <b>{{items.jobData.customer_first_name + \' \' + items.jobData.customer_last_name}}</b><br>Mobile Number: <b>{{items.jobData.customer_country_code?items.jobData.customer_phone_number:items.jobData.customer_country_code+items.jobData.customer_phone_number}}</b><br>ID: <b>{{items.jobData.created_by}}</b><br></td><td><div ng-if=items.jobData.booking_for>Name: <b>{{items.jobData.job_pickup_name}}</b><br>Mobile Number: <b>{{items.jobData.job_pickup_phone}}</b><br>Email: <b>{{items.jobData.job_pickup_email || \'--\'}}</b><br></div><div ng-if=!items.jobData.booking_for>NO</div></td><td>{{items.jobData.job_pickup_address || \'--\'}}</td><td>{{items.jobData.job_address || \'--\'}}</td><td>{{items.jobData.branch || \'--\'}}</td><td>{{items.jobData.type_of_service}}</td><td>{{items.jobData.agreement}}</td><td><span ng-if=items.jobData.is_round_trip><span ng-if=\"items.jobData.round_trip_parent_job_id == 0\">{{items.jobData.return_date_time | date:\'medium\'}}</span> <span ng-if=\"items.jobData.round_trip_parent_job_id != 0\">#{{items.jobData.round_trip_parent_job_id}}</span> </span><span ng-if=\"items.jobData.is_round_trip == 0\"><span ng-if=\"items.jobData.round_trip_parent_job_id == 0\">NO</span> <a ui-sref=\"layout.upcomingBookingsMain.upcomingBookingDetails({id:\'{{items.jobData.round_trip_parent_job_id}}\',type:\'0\'})\" ng-if=\"items.jobData.round_trip_parent_job_id != 0\"><span>#{{items.jobData.round_trip_parent_job_id}}</span></a></span></td><td><sapn ng-if=\"items.jobData.job_status == \'0\'\">{{\'upcomingStatus\' | translate}}</sapn><sapn ng-if=\"items.jobData.job_status == \'1\'\">Viaje Iniciado</sapn><sapn ng-if=\"items.jobData.job_status == \'2\'\">Ended</sapn><sapn ng-if=\"items.jobData.job_status == \'3\'\">Failed</sapn><sapn ng-if=\"items.jobData.job_status == \'4\'\">En Posición</sapn><sapn ng-if=\"items.jobData.job_status == \'5\'\">Partial</sapn><sapn ng-if=\"items.jobData.job_status == \'6\'\">No Asignada</sapn><sapn ng-if=\"items.jobData.job_status == \'7\'\">Accepted</sapn><sapn ng-if=\"items.jobData.job_status == \'8\'\">Decline</sapn><sapn ng-if=\"items.jobData.job_status == \'9\'\">Cancel</sapn><sapn ng-if=\"items.jobData.job_status == \'10\'\">Deleted</sapn><sapn ng-if=\"items.jobData.job_status == \'11\'\">Ignored</sapn><sapn ng-if=\"items.jobData.job_status == \'12\'\">No Show</sapn><sapn ng-if=\"items.jobData.job_status == \'15\'\">En Camino</sapn></td></tr></tbody></table></div><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">{{\'assignPopUpHead\' | translate}}</p></div></div><div class=row><div class=\"col-lg-3 col-sm-3 col-xs-6 col-md-3\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=items.searchDriver ng-change=getAssignDriverSearch(items.searchDriver)></div></div><div class=\"col-lg-3 col-sm-3 col-xs-6 col-md-3\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"Número de vehículo\" ng-model=items.searchDriverbyVehicleId ng-change=getAssignDriverSearch(items.searchDriverbyVehicleId) ng-model-options=\"{ debounce: 500 }\"></div></div><div class=\"col-lg-3 col-sm-3 col-xs-6 col-md-3 mt10\"><select class=form-control ng-model=items.onOffDuty name=promoType ng-change=getDataDriverChange()><option value=\"\" disabled>Incluir vehículos fuera de servicio</option><option value=1>Yes</option><option selected value=0>No</option></select></div><div class=\"col-lg-3 col-sm-3 col-xs-6 col-md-3 mt10\"><select class=form-control ng-model=items.allVehicle name=promoType ng-change=getDataDriverChange()><option value=\"\" disabled>Incluir otros vehículos</option><option value=1>Yes</option><option selected value=0>No</option></select></div><!-- YE WALA DIV COPY KARNA HA VAHAN --></div><!--<div  class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\">--><!--<div ng-if=\"items.busy\" class=\"noSearch\"><span>Loading.......</span></div>--><!--</div>--><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 table-responsive\" style=height:300px;overflow-y:auto when-scrolled=paginationFunction()><table class=\"table table-hover\"><thead><tr><th>{{\'serialNumber\' | translate}}</th><th>{{\'uniqueNumber\' | translate}}</th><th>{{\'driverName\' | translate}}</th><th>{{\'driverPhone\' | translate}}</th><th>{{\'vehicleLabel\' | translate}}</th><th>{{\'stateTable\' | translate}}</th><th>{{\'select\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"data in items.allDrivers\" ng-class=\"{\'grey-color\': data.off}\"><!-- | filter:items.searchDriver\"--><td>{{$index + 1}}</td><td>{{data.unique_car_id || \'--\'}}</td><td>{{data.first_name + \" \" + data.last_name}}</td><td>{{data.country_code}}-{{data.phone}}</td><td>{{data.name}}</td><td><span ng-if=\"data.is_available == 0\">Off Duty</span> <span ng-if=\"data.is_available == 1 && data.status == 0\">On Duty Free</span> <span ng-if=\"data.is_available == 1 && data.status == 1 && data.job_status == 7\">Accepted</span> <span ng-if=\"data.is_available == 1 && data.status == 1 && data.job_status == 15\">En Camino</span> <span ng-if=\"data.is_available == 1 && data.status == 1 && data.job_status == 4\">En Posición</span> <span ng-if=\"data.is_available == 1 && data.status == 1 && data.job_status == 1\">Viaje Iniciado</span></td><td><input ng-if=!data.off type=radio name=driver ng-click=selectDriver(data)><!--<md-radio-group>--><!--<md-radio-button value=\"{{$index}}\" name=\"driver\" aria-label=\"Driver{{$index}}\" class=\"md-primary\" ng-click=\"selectDriver(data)\"></md-radio-button>--><!--</md-radio-group>--></td></tr></tbody><tfoot ng-if=\"items.allDrivers.length == 0\"><tr class=text-center><th colspan=7 class=\"noDataClass text-center\">{{\'noDriverFound\' | translate}}</th></tr></tfoot></table></div></div></div></md-dialog-content><md-dialog-actions><md-button ng-click=confirmUpload() class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dialogViews/selectMultipleGeofence.html","<md-dialog aria-label=\"List dialog\" style=width:650px><md-dialog-content ng-class=\"{\'whirl duo\' : loading }\"><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">Lista de Geocercas</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label class=control-label>Total geocercas seleccionadas: {{branchListForPopupCount || 0}}</label></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><div class=\"col-lg-3 col-sm-6 col-md-3 col-xs-12 input-group pull-left\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=search ng-change=searchGeofenceFunction(search)></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12 input-group pull-right\" style=\"line-height: 2\"><input type=radio checked name=radioButtonToShowActiveOrInactiveGeoFence ng-click=showActiveOrInactiveGeofenceFunction(1)> Ver Sólo Activas <input type=radio name=radioButtonToShowActiveOrInactiveGeoFence ng-click=showActiveOrInactiveGeofenceFunction(2)> Ver Todas</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive tableWithMasterDataParentDive\"><table class=\"table table-hover tableWithMasterData\"><thead><tr><th style=width:70px hidden>{{\'serialNumber\' | translate}}</th><th style=width:70px ng-click=\"sortByHead(\'region_id\')\">Region Id <i class=fa ng-class=\"{\'fa-sort\': sortStringVariable != \'region_id\',\'fa-sort-asc\': (sortStringVariable == \'region_id\' && !isDesc),\'fa-sort-desc\': (sortStringVariable == \'region_id\' && isDesc) }\" aria-hidden=true></i></th><th style=width:100px ng-click=\"sortByHead(\'branch_name\')\">{{\'branchNameLabel\' | translate}} <i class=fa ng-class=\"{\'fa-sort\': sortStringVariable != \'branch_name\',\'fa-sort-asc\': (sortStringVariable == \'branch_name\' && !isDesc),\'fa-sort-desc\': (sortStringVariable == \'branch_name\' && isDesc) }\" aria-hidden=true></i></th><th style=width:100px ng-click=\"sortByHead(\'region_name\')\">{{\'routeName\' | translate}} <i class=fa ng-class=\"{\'fa-sort\': sortStringVariable != \'region_name\',\'fa-sort-asc\': (sortStringVariable == \'region_name\' && !isDesc),\'fa-sort-desc\': (sortStringVariable == \'region_name\' && isDesc) }\" aria-hidden=true></i></th><th style=width:100px>Status</th><th style=width:100px>Action</th></tr></thead><tbody style=\"max-height: 360px\" when-scrolled=paginationChangedForMultipleGeofence()><tr ng-repeat=\"data in branchListForPopup | filter: vm.search\"><td style=width:70px hidden>{{data.index+1}}</td><td style=width:70px>{{data.region_id || data.auto_assignment_region_id}}</td><td style=width:100px>{{data.branch_name || data.parent.region_name}}</td><td style=width:100px>{{data.region_name}}</td><td style=width:100px>{{data.is_active == 0 ? \'inactive\' : \'active\'}}</td><td style=width:100px><input type=checkbox ng-click=\"getGeofenceRegionId(data.region_id ? data.region_id : data.auto_assignment_region_id)\" style=\"font-size: 16px\"></td></tr></tbody><tfoot ng-if=\"branchListForPopupCount == 0\"><tr><th class=\"noDataClass text-center\">{{\'noFixedGeoFound\' | translate}}</th></tr></tfoot><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt10\"><div ng-if=items.ErrMsg class=\"alert alert-danger text-center alertMargin\">{{items.ErrMsg}}</div></div></table></div></div></md-dialog-content><md-dialog-actions><md-button ng-click=confirmUpload() class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dialogViews/selectMultipleGeofenceAutoassign.html","<md-dialog aria-label=\"List dialog\" style=width:100%><md-dialog-content ng-class=\"{\'whirl duo\' : loading }\"><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\">Ver Geocercas <span style=font-size:12px;color:gray>({{branchListForPopupCount || 0}} geocercas en total)</span></p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><div class=\"col-lg-2 col-sm-2 col-md-2 col-xs-12\"><label class=control-label>Sucursal</label><ui-select multiple ng-model=selectedBranch name=selectedBranch required on-select=\"selectingZones($select.selected,\'select\')\" on-remove=\"selectingZones($select.selected,\'remove\')\" close-on-select=true><ui-select-match placeholder=All>{{$item.region_name}}</ui-select-match><ui-select-choices repeat=\"data in branchList | filter: $select.search\"><div ng-bind-html=data.region_name></div></ui-select-choices></ui-select></div><div class=\"col-lg-2 col-sm-2 col-md-2 col-xs-12\"><label class=control-label>Estado</label><ui-select ng-model=selectedEstado name=estado required on-select=showActiveOrInactiveGeofenceFunction($item.id) close-on-select=true><ui-select-match placeholder=Estados>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"data in estados | filter: $select.search\"><div ng-bind-html=data.name></div></ui-select-choices></ui-select></div><div class=\"col-lg-2 col-sm-2 col-md-2 col-xs-12 input-group pull-left\" style=\"margin-top: 25px\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText style=\"width:100% !important\" class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=search></div><div class=\"col-lg-2 col-sm-2 col-md-2 col-xs-12\"></div><div class=\"col-lg-2 col-sm-2 col-md-2 col-xs-12\" style=padding-top:26px><button class=\"btn btn-primary\" style=\"width:100%;padding: 6px;margin: 0px;font-size: 13px!important\" ng-click=selectAllItems()>Seleccionar todo</button><div style=font-size:11px;color:gray;font-weight:bold>{{ regionIdArrayLength }} geocerca seleccionada</div></div><div class=\"col-lg-2 col-sm-2 col-md-2 col-xs-12\" style=padding-top:26px><button class=\"btn btn-primary\" style=\"width:100%;padding: 6px;margin: 0px;font-size: 13px!important\" ng-click=unselectAllItems()>Limpiar seleccion</button></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive tableWithMasterDataParentDive\"><table class=\"table table-hover tableWithMasterData\"><thead><tr><th style=width:70px hidden>{{\'serialNumber\' | translate}}</th><th style=width:100px ng-click=\"sortByHead(\'branch_name\')\">Sucursal <i class=fa ng-class=\"{\'fa-sort\': sortStringVariable != \'branch_name\',\'fa-sort-asc\': (sortStringVariable == \'branch_name\' && !isDesc),\'fa-sort-desc\': (sortStringVariable == \'branch_name\' && isDesc) }\" aria-hidden=true></i></th><th style=width:100px ng-click=\"sortByHead(\'region_name\')\">Nombre <i class=fa ng-class=\"{\'fa-sort\': sortStringVariable != \'region_name\',\'fa-sort-asc\': (sortStringVariable == \'region_name\' && !isDesc),\'fa-sort-desc\': (sortStringVariable == \'region_name\' && isDesc) }\" aria-hidden=true></i></th><th style=width:100px>Estado</th><th style=width:100px>Acción</th></tr></thead><tbody style=\"max-height: 360px\" when-scrolled=paginationChangedForMultipleGeofence()><tr ng-repeat=\"data in branchListForPopup | filter: search\" ng-if=\"data.auto_assignment_region_id != blockID\"><td style=width:70px hidden>{{data.index+1}}</td><td style=width:100px>{{data.branch_name || data.parent.region_name}}</td><td style=width:100px>{{data.region_name}}</td><td style=width:100px>{{data.is_active == 0 ? \'inactiva\' : \'activa\'}}</td><td style=width:100px><input type=checkbox ng-click=\"getGeofenceRegionId(data.region_id ? data.region_id : data.auto_assignment_region_id)\" style=\"font-size: 16px\" ng-model=data.selected></td></tr></tbody><tfoot ng-if=\"branchListForPopupCount == 0\"><tr><th class=\"noDataClass text-center\">{{\'noFixedGeoFound\' | translate}}</th></tr></tfoot><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt10\"><div ng-if=items.ErrMsg class=\"alert alert-danger text-center alertMargin\">{{items.ErrMsg}}</div></div></table></div></div></md-dialog-content><md-dialog-actions><md-button ng-click=confirmUpload() class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dialogViews/selectMultipleGeofenceHeatMap.html","<md-dialog aria-label=\"List dialog\" style=width:650px><md-dialog-content ng-class=\"{\'whirl duo\' : loading }\"><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">Lista de Geocercas</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label class=control-label>Total geocercas seleccionadas: {{branchListForPopupCount || 0}}</label></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><div class=\"col-lg-3 col-sm-6 col-md-3 col-xs-12 input-group pull-left\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=search ng-change=searchGeofenceFunction(search)></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12 input-group pull-right\" style=\"line-height: 2\"><input type=radio checked name=radioButtonToShowActiveOrInactiveGeoFence ng-click=showActiveOrInactiveGeofenceFunction(1)> Ver Sólo Activas <input type=radio name=radioButtonToShowActiveOrInactiveGeoFence ng-click=showActiveOrInactiveGeofenceFunction(2)> Ver Todas</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive tableWithMasterDataParentDive\"><table class=\"table table-hover tableWithMasterData\"><thead><tr><th style=width:70px hidden>{{\'serialNumber\' | translate}}</th><th style=width:70px ng-click=\"sortByHead(\'rg.region_id\')\">Region Id <i class=fa ng-class=\"{\'fa-sort\': sortStringVariable != \'rg.region_id\',\'fa-sort-asc\': (sortStringVariable == \'rg.region_id\' && !isDesc),\'fa-sort-desc\': (sortStringVariable == \'rg.region_id\' && isDesc) }\" aria-hidden=true></i></th><th style=width:100px ng-click=\"sortByHead(\'prg.region_name\')\">{{\'branchNameLabel\' | translate}} <i class=fa ng-class=\"{\'fa-sort\': sortStringVariable != \'prg.region_name\',\'fa-sort-asc\': (sortStringVariable == \'prg.region_name\' && !isDesc),\'fa-sort-desc\': (sortStringVariable == \'prg.region_name\' && isDesc) }\" aria-hidden=true></i></th><th style=width:100px ng-click=\"sortByHead(\'rg.region_name\')\">Nombre Tramo <i class=fa ng-class=\"{\'fa-sort\': sortStringVariable != \'rg.region_name\',\'fa-sort-asc\': (sortStringVariable == \'rg.region_name\' && !isDesc),\'fa-sort-desc\': (sortStringVariable == \'rg.region_name\' && isDesc) }\" aria-hidden=true></i></th><th style=width:100px>Status</th><th style=width:100px>Action</th></tr></thead><tbody style=\"max-height: 360px\" when-scrolled=paginationChangedForMultipleGeofence()><tr ng-repeat=\"data in branchListForPopup | filter: vm.search\"><td style=width:70px hidden>{{data.index+1}}</td><td style=width:70px>{{data.region_id}}</td><td style=width:100px>{{data.branch_name || data.parent_region_name}}</td><td style=width:100px>{{data.region_name}}</td><td style=width:100px>{{data.is_active == 0 ? \'inactive\' : \'active\'}}</td><td style=width:100px><input type=checkbox ng-click=getGeofenceRegionId(data.region_id) style=\"font-size: 16px\"></td></tr></tbody><tfoot ng-if=\"branchListForPopupCount == 0\"><tr><th class=\"noDataClass text-center\">{{\'noFixedGeoFound\' | translate}}</th></tr></tfoot><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt10\"><div ng-if=items.ErrMsg class=\"alert alert-danger text-center alertMargin\">{{items.ErrMsg}}</div></div></table></div></div></md-dialog-content><md-dialog-actions><md-button ng-click=confirmUpload() class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dialogViews/sendVoucherToCustomer.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px ng-class=\"{\'whirl duo\' : items.loading }\"><form method=post name=sendVoucherForm ng-submit=\"submit=true;sendVoucherForm.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">Send Voucher to Cliente</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>{{\'email\' | translate}}<span style=color:red>*</span></label><input type=text name=email class=form-control placeholder=\"{{\'emailPlaceholder\' | translate}}\" required ng-model=items.emailToSendVoucher ng-class=\"{ \'has-error\': sendVoucherForm.email.$touched && sendVoucherForm.email.$invalid }\" pattern=^([_a-zA-Z0-9-+]+)(\\.[_a-zA-Z0-9-+]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*\\.)+([a-zA-Z]{2,3})$><div ng-if=\"sendVoucherForm.email.$touched|| submit\" ng-messages=sendVoucherForm.email.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'requiredEmail\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'validEmail\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center mt10\"><button type=button class=\"btn btn-primary btn-danger\" ng-click=closeDialog()>{{\'cancelButton\' | translate}}</button> <button type=submit class=\"btn btn-primary\">{{\'sendVoucher\' | translate}}</button></div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/components/dialogViews/sharedGroupedError.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><form method=post name=addCancelReason ng-submit=\"submit=true;addCancelReason.$valid&&confirmUpload()\" novalidate autocomplete=off><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">Errors</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" ng-bind-html=items.msg></div></div></md-dialog-content><md-dialog-actions><!--<md-button type=\"submit\" class=\"md-primary\">--><!--{{\'confirmButton\' | translate}}--><!--</md-button>--><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/dialogViews/shiftCarPop.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=editDocumentP>{{\'selectShiftFor\' | translate}} {{items.date | date:\'mediumDate\'}}</p><label class=control-label></label><div><label><input type=radio name=shift ng-model=items.shiftTime value=0>&nbsp;&nbsp;Morning</label><br><label><input type=radio name=shift ng-model=items.shiftTime value=1>&nbsp;&nbsp;Evening</label><br><label><input type=radio name=shift ng-model=items.shiftTime value=2>&nbsp;&nbsp;Night</label></div><div ng-if=items.ShiftErrMsg class=\"alert alert-danger text-center alertMargin\">{{items.ShiftErrMsg}}</div></div></div></md-dialog-content><md-dialog-actions><md-button ng-click=confirmUpload() class=md-primary>{{\'confirmButton\' | translate}}</md-button><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dialogViews/showBookingIds.html","<md-dialog aria-label=\"List dialog\" style=min-width:300px><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><h4>Booking IDs</h4><div class=bookingIdsDiv><div class=bookingIds ng-repeat=\"id in items.bookingIds\">{{id.job_id}}</div></div></div></div></md-dialog-content><md-dialog-actions><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dialogViews/uploadCSVDialogEmployee.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px ng-class=\"{\'whirl duo\' : items.loadingE }\"><md-dialog-content><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"text-decoration: underline\">{{\'uploadCSVeMPLO\' | translate}}</p></div><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6\" style=\"border-right: 1px solid black\"><p><b>{{\'guideLineString\' | translate}}</b></p><ul><li>Solo alfabetos de primer nombre. Sin caracteres especiales, números y caracteres españoles.</li><li>Sólo alfabetos del último nombre. Sin caracteres especiales, números y caracteres españoles.</li><li>Correo electrónico del formato de correo electrónico apropiado.</li><li>El número de teléfono solo tiene un máximo de 9 dígitos.</li><li>RUT solo es válido.</li><li>Coloque el texto libre, de lo contrario, vacío.</li><li>Centro de costo de texto libre pero solo 50 caracteres.</li><li>Coste de texto libre de Sub Center, pero solo 50 caracteres.</li><li>Texto libre PEP pero solo 50 caracteres.</li><li>Texto libre ROL pero solo 50 caracteres.</li><li>Graficar texto libre pero solo 50 caracteres.</li><li>Tercera reserva 0 y 1 solamente.</li><li>Aprobación requerida 0 y 1 solamente.</li><li>Auth Rut solo cuando la aprobación requerida es 1 de lo contrario vacía.</li><li>Empleado VIP 0 y 1 solamente.</li><!--<li>{{\'orderCheck\' | translate}}</li>--><li>Comentarios texto libre de lo contrario vacío.</li><li>autorizadoApp define si el empleado puede crear reservas desde la aplicación Cliente Transvip. Debe ser 1 para permitir y 0 para no permitir crear reservas. Valor distinto o vacio generará error</li><li>autorizadoPanel define si el empleado puede crear reservas desde el panel Enlace. Debe ser 1 para permitir y 0 para no permitir crear reservas. Valor distinto o vacio generará error</li></ul></div><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 text-center\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt25\"><div ng-if=!items.confirmHide><input id=documentUpload filestyle=\"\" type=file style=\"display: none\" name={{vm.uploadName}} onchange=angular.element(this).scope().file_to_upload(this.files,this.name) onclick=\"this.value = null\" data-button-text=Single data-class-button=\"btn btn-default\" data-classinput=\"form-control inline\" nv-file-select=\"\" uploader=uploader accept=\".csv, text/csv\"> <button type=button class=\"btn btn-primary mt5\" ng-click=\"clickTrigger($event,\'EMPLOYEE_CSV\')\">{{\'uploadCSV\' | translate}}</button><p>{{items.file}}</p><br><a href=employee.csv download=demoEmployeeCSV.csv>{{\'downloadDemoCsv\' | translate}}</a></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><div ng-if=items.error class=\"alert alert-danger text-center alertMargin\" style=\"word-break: break-all\">{{items.error}}</div><div class=\"alert alert-success text-center alertMargin\" ng-if=items.success><div ng-if=items.success_1>{{items.success_1}}</div><div ng-if=items.success>{{items.success}}</div></div></div><!--<div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\">--><!--<a class=\"btn btn-primary mb10\" ng-if=\"items.csvButtonDownloadSucc\" ng-click=\"exportToCSVBulk()\">{{\'csvWithSucc\' | translate}}</a><br/>--><!--<a class=\"btn btn-primary mb10\" ng-if=\"items.csvButtonDownloadErr\" ng-click=\"exportToCSVBulk()\">{{\'csvWithErr\' | translate}}</a>--><!--</div>--></div></div></div></md-dialog-content><md-dialog-actions><md-button class=md-primary ng-click=confirmUpload() ng-if=!items.confirmHide ng-disabled=items.error>{{\'confirmButton\' | translate}}</md-button><!--<md-button class=\"md-primary\" ng-click=\"exportToCSVBulk()\" ng-if=\"items.confirmHide\">--><!--{{\'confirmButton\' | translate}}--><!--</md-button>--><md-button ng-click=closeDialog() class=md-primary>{{\'CloseButton\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/components/dialogViews/validateBooking.html","<md-dialog aria-label=\"List dialog\" style=min-width:450px><md-dialog-content ng-class=\"{\'whirl duo\' : items.loading }\"><div class=\"row m0 p10\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><p class=\"editDocumentP text-center\" style=\"color: red\">Reserva con los mismos datos</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><table class=\"table table-hover\"><thead><tr><th>{{\'idBooking1\' | translate}}</th><th>{{\'dateTimePickB1\' | translate}}</th><!-- <th ng-if=\"items.roundTrip\">{{\'typeTableHead1\' | translate}}</th> --></tr></thead><tbody id=copyData><tr ng-repeat=\"data in items.tableData\"><td><span style=\"color: #337ab7;text-decoration: none\" ng-click=openPdf(data)>{{data.job_id}}&nbsp;&nbsp;&nbsp;</span></td><td>{{data.job_time_utc | date:\'dd MMM yyyy, HH:mm\'}} hrs<!-- <td ng-if=\"items.roundTrip\">\n                            <span ng-if=\"data.round == 0\">{{\'goOnly1\' | translate}}<br/></span>\n                            <span ng-if=\"data.round == 1\">{{\'returnOnly1\' | translate}}<br/></span>\n                        </td> --></td></tr></tbody></table></div><!-- <div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\" ng-if=\"items.copied\">\n                <p class=\"alert alert-success\">{{\'data1\' | translate}}</p>\n            </div> --><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><button class=\"btn btn-primary\" ng-click=cancelValidatePopUp()>Cancelar</button><!-- <button class=\"btn btn-primary\" ng-click=\"closeDialog()\">{{\'acceptOnly1\' | translate}}</button> --></div></div></md-dialog-content><!--<md-dialog-actions>--><!--<md-button type=\"submit\" class=\"md-primary\">--><!--{{\'confirmButton\' | translate}}--><!--</md-button>--><!--<md-button ng-click=\"closeDialog()\" class=\"md-primary\">--><!--{{\'CloseButton\' | translate}}--><!--</md-button>--><!--</md-dialog-actions>--></md-dialog>");
$templateCache.put("app/components/dialogViews/waringMessageForCreateBooking.html","<div class=\"container-fluid ng-cloak\" style=\"max-width:800px;min-width: 100px;min-height: 100px;overflow: hidden;padding: 15px\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 textIn\"><span class=iconColor>Alert: </span><span>Esta reserva se creará como </span><span ng-if=\"items.trip == \'R\'\" class=iconColor1>Desde Aeropuerto<span style=color:black>.</span></span> <span ng-if=\"items.trip == \'Z\'\" class=iconColor1>Hacia Aeropuerto<span style=color:black>.</span></span> <span ng-if=\"items.trip == \'P\'\" class=iconColor1>Punto a Punto<span style=color:black>.</span></span> <span>Por favor revise los datos una vez más.</span></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 textIn\" style=\"margin-bottom: 10px\"><button ng-click=closeDialog() class=aceptarButton>Aceptar</button></div></div></div><style>.iconColor {\n        font-weight: bold;\n        font-size: 20px;\n        color: red;\n    }\n    .iconColor1 {\n        font-size: 16px;\n        font-weight: bold;\n        color: red;\n    }\n\n    .textIn {\n        padding-top: 14px;\n        text-align: center;\n        font-weight: 400;\n        text-align: center;\n        font-size: 16px;\n    }\n\n    .aceptarButton {\n        width: 250px;\n        height: 40px;\n        background-color: #ff6900;\n        color: white;\n        font-weight: bold;\n        font-size: 17px;\n        border-radius: 4px;\n    }</style>");
$templateCache.put("app/components/innerLayout/app.html","<!-- top navbar--><header ng-include=\"\'app/components/innerLayout/partials/topnavbar.html\'\" class=ng-cloak></header><div id=wrapper ng-class=\"{\'toggled\': vm.showSide,\'smallNav\': !vm.showSide}\" class=ng-cloak><!--,\'smallNav\': !vm.showSide--><!-- sidebar--><aside ng-include=\"\'app/components/innerLayout/partials/sidebar.html\'\" class=aside></aside><!-- Main section--><section id=page-content-wrapper><!-- Page content--><div ui-view=\"\"></div></section><!-- Page footer--><footer ng-include=\"\'app/components/innerLayout/partials/footer.html\'\"></footer></div><div id=idleOut><div><p><i class=\"fa fa-clock-o faFont\"></i></p><h1>Estás inactivo de los últimos 10 minutos.</h1><p class=loginText>Por favor inicie sesión de nuevo.</p><button class=\"btn btn-primary mt10\" ng-click=vm.wakeUpCall()>Iniciar sesión</button></div></div>");
$templateCache.put("app/components/innerLayout/partials/footer.html","<span>&copy; {{app.year}} - {{ app.name }}</span>");
$templateCache.put("app/components/innerLayout/partials/sidebar.html","<div id=sidebar-wrapper-search><ul class=sidebar-nav-search><li><div class=\"firstChild search-icon\" ng-click=vm.showSearchOption()><i class=\"fa fa-search\"></i></div><div class=\"firstChild inputSearch\"><input type=text placeholder=\"{{\'Search Menu\' | translate}}\" class=form-control ng-model=vm.search></div></li></ul></div><div id=sidebar-wrapper style=margin-top:105px><ul class=sidebar-nav><!--<li>--><!--<div class=\"firstChild\">--><!--<input type=\"text\" placeholder=\"Search Menu\" class=\"form-control\" ng-model=\"vm.search\" />--><!--</div>--><!--</li>--><li ng-repeat=\"data in vm.json | filter:vm.search\" ng-if=\"vm.adminType ? data.isPetUser : 1\" ng-class=vm.getMenuItemPropClasses(data) ng-attr-id=\"{{$index+\'_Main\'}}\" ng-click=vm.toggleCollapse(pIndex,true,data);vm.stateReload(data,$event); ng-init=\"pIndex = $index\"><a ng-if=data.sref ui-sref={{data.sref}} ng-class=\"{\'firstChild\': data.heading}\" title={{data.text}}><i ng-if=!data.heading ng-class=data.icon class=mainIcon></i><!-- <img src = \"assets/images/driver-safety.png\" ng-if=\"!data.heading && data.iconType\" style=\"height: 20px; padding-left: 10px\"/>                 --> <span data-testid=menu_{{data.text}} class=mainSpan>{{data.text}} </span><i ng-if=data.submenu class=arrowSidebar ng-class=\"{\'fa fa-caret-right\': vm.isCollapse(pIndex),\'fa fa-caret-down\':!vm.isCollapse(pIndex) }\"></i> </a><a ng-if=!data.sref ng-class=\"{\'firstChild\': data.heading}\" title={{data.text}}><i ng-if=\"!data.heading && !data.iconType\" ng-class=data.icon class=mainIcon></i> <img src=assets/images/driver-safety.png ng-if=\"!data.heading && data.iconType\" style=\"height: 20px; padding-left: 10px\"> <span data-testid=submenu_{{data.text}} class=mainSpan ng-class=\"{\'padL17\': data.iconType}\">{{data.text}} </span><i ng-if=data.submenu class=arrowSidebar ng-class=\"{\'fa fa-caret-right\': vm.isCollapse(pIndex),\'fa fa-caret-down\':!vm.isCollapse(pIndex) }\"></i></a><ul ng-if=data.submenu class=\"sidebar-subnav collapse\" uib-collapse=vm.isCollapse(pIndex) ng-init=\"vm.addCollapse(pIndex, data)\" aria-expanded=false aria-hidden=true><li ng-repeat=\"item in data.submenu\" ng-if=\"vm.adminType ? item.isPetUser : 1\" ng-class=vm.getMenuItemPropClasses(item) ng-attr-id=\"{{$index+\'_SubMain\'}}\" ng-init=\"pIndex=(pIndex+\'-\'+$index)\" ng-click=vm.toggleCollapse(pIndex,false,item);vm.stateReload(item)><a ui-sref={{item.sref}} ng-class=\"{\'firstChild\': item.heading}\" title={{item.text}}><i ng-if=!item.heading ng-class=item.icon class=mainIcon></i><!-- <img src= \"assets/images/driver-safety.png\" ng-if=\"!item.heading && item.iconType\" style=\"height: 20px; padding-left: 10px\"/> --> <span data-testid=submenu2_{{item.text}} class=subSpan>{{item.text}}</span></a></li></ul></li></ul></div>");
$templateCache.put("app/components/innerLayout/partials/topnavbar.html","<!-- START Top Navbar--><nav role=navigation class=\"navbar topnavbar\"><!-- START navbar header--><div class=navbar-header><a href=\"\" class=navbar-brand><div class=brand-logo><img src=assets/images/transvip_sinlogo.png alt=\"App Logo\" class=\"img-responsive img-logo\" style=\"width: 135px;height: 100px;padding-bottom: 4px\"></div><div class=brand-logo-collapsed><img src=\"\" alt=\"App Logo\" class=img-responsive></div></a></div><!-- END navbar header--><!-- START Nav wrapper--><div class=nav-wrapper><!-- START Left navbar--><ul class=\"nav navbar-nav\"><li><!--ng-class=\"{\'burgerActive\': !vm.showSide,\'burgor\':vm.showSide}\"--><!-- Button used to collapse the left sidebar. Only visible on tablet and desktops--> <a ng-click=vm.hit() class=\"hidden-xs cursor\" ng-class=\"{\'burgerActive\': !vm.showSide,\'burgor\':vm.showSide}\"><em class=\"fa fa-bars\"></em> </a><!-- Button to show/hide the sidebar on mobile. Visible on mobile only.--> <a ng-click=vm.hit() class=\"visible-xs cursor sidebar-toggle\" ng-class=\"{\'burgerActive\': !vm.showSide,\'burgor\':vm.showSide}\"><em class=\"fa fa-bars\"></em></a></li></ul><ul class=\"nav navbar-nav userdetails\"><li>{{\'adminName\' | translate}} : {{adminNameUpper}}</li><li style=\"overflow: hidden;text-overflow: ellipsis;white-space: nowrap\">&nbsp; (<span ng-repeat=\"role in adminRolesUpper\">{{role}}<span ng-if=!$last>{{\', \'}}</span></span>)</li></ul><!-- END Left navbar--><!-- START Right Navbar--><ul class=\"nav navbar-nav navbar-right\"><!--<li>--><!--<a title=\"Change Password\"  ng-click=\"$state.go(\'app.changepassword\')\">--><!--<em class=\"fa fa-lock icon-nav\"></em>--><!--</a>--><!--</li>--><!-- START Logout function--><li><span style=\"font-size: 14px; padding: 11px;line-height: 51px;color:white;font-size: 20px;font-weight: bold\">V {{version}}</span></li><li><a title=\"{{\'changePassword\' | translate}}\" class=changePassword style=\"font-size: 14px; padding: 5px;line-height: 40px;text-decoration: underline;cursor: pointer\" ng-click=vm.changePassword($event)>{{\'changePassword\' | translate}}</a></li><li class=\"dropdown dropdown-list\"><a data-toggle=dropdown class=\"dropdown-toggle notificationIcon\"><em class=\"fa fa-bell fa-lg\" id=notification></em><!--shake--><div class=\"label label-danger notificationCountDis\" ng-if=\"vm.totalRequestCount > 0\">{{vm.totalRequestCount}}</div></a><div class=\"dropdown-menu paddingZero\"><div><ul class=\"logOutMargin oshj\"><li ng-if=\"vm.notificationsUnread.length == 0\" style=\"list-style: none\"><div class=\"list-group m0\"><a class=\"list-group-item text-center\" style=\"border-bottom: 1px solid #dedede\"><div class=media-box><!--<div class=\"pull-left\">--><!--<em class=\"fa fa-eye icon-nav  text-info\" style=\"color: #21bfd6;\"></em>--><!--</div>--><div class=\"media-box-body clearfix\"><p class=\"m0 text-muted\" style=\"color: rgba(0, 0, 0, 0.74)\">No New Notifications</p></div></div></a></div></li><li ng-repeat=\"unreadNoti in vm.notificationsUnread\" ng-if=\"vm.notificationsUnread.length > 0 \" style=\"list-style: none\"><div class=\"list-group m0\"><a class=list-group-item style=\"border-bottom: 1px solid #dedede\"><div class=media-box><div class=\"pull-right iconDive\"><i class=\"fa fa-arrow-circle-down fa-lg\" ng-click=vm.markReadAndDownload(unreadNoti) aria-hidden=true title=Download></i></div><div class=\"media-box-body clearfix\"><p class=\"m0 text-muted\" style=\"color: rgba(0, 0, 0, 0.74)\">{{unreadNoti.message}}</p></div></div></a></div></li></ul></div></div></li><li class=logout><a title=Logout class=cursor ng-click=vm.logOut($event)><i class=\"fa fa-sign-out fa-lg\"></i></a></li><!-- END Logout function--></ul><!-- END Right Navbar--></div><!-- END Nav wrapper--></nav>");
$templateCache.put("app/components/views/admin-role/addRoleToAdminUser.html","<h2 class=ng-cloak>{{\'adminUserHead\' | translate}} / {{\'addRoleToUserScreen\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'addRoleToUserHead\' | translate}}</p><div class=basicDetailsDiv><form method=post name=giveRoleToUserForm ng-submit=\"submit=true;giveRoleToUserForm.$valid&&vm.addRoleToUserApiHit()\" novalidate autocomplete=off><div class=row><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">Permission Name<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.permissionName\" name=\"permissionName\" placeholder=\"Permission Name\"--><!--required ng-class=\"{ \'has-error\': giveRoleToUserForm.permissionName.$touched && giveRoleToUserForm.permissionName.$invalid }\"/>&lt;!&ndash;pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"&ndash;&gt;--><!--<div ng-if=\"giveRoleToUserForm.permissionName.$touched|| submit\" ng-messages=\"giveRoleToUserForm.permissionName.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter permission name.</div>--><!--</div>--><!--</div>--><!--<div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\">--><!--<label class=\"control-label\">Role Name<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.roleName\" name=\"roleName\" placeholder=\"Role Name\"--><!--required ng-class=\"{ \'has-error\': giveRoleToUserForm.roleName.$touched && giveRoleToUserForm.roleName.$invalid }\"/>&lt;!&ndash;pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"&ndash;&gt;--><!--<div ng-if=\"giveRoleToUserForm.roleName.$touched|| submit\" ng-messages=\"giveRoleToUserForm.roleName.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter role name.</div>--><!--</div>--><!--</div>--><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=margin-top:10px><div class=\"table-responsive tableWithMasterDataParentDive\"><table class=\"table tableWithMasterData\" id=adminTable><thead><tr><th style=width:125px>{{\'roleNameLabel\' | translate}}</th><th style=width:125px>{{\'select\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"data in vm.adminRoleList\"><td style=width:125px>{{::data.roleName}}</td><td style=width:125px><!--<input type=\"checkbox\" ng-model=\"data.checked\" />--><md-checkbox class=md-primary ng-model=data.checked aria-label=Checkbox{{$index}}></md-checkbox></td></tr></tbody></table></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\" style=margin-top:10px><button class=\"btn btn-primary\" style=width:200px>{{\'submit\' | translate}}</button></div></div></form></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/admin-role/adminRolesList.html","<h2 class=ng-cloak>{{\'adminRoleListHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-4 col-sm-6 col-md-4 col-xs-12\"><label class=control-label>{{\'roleStatusLabel\' | translate}}</label><select class=form-control ng-model=vm.filterData.roleStatus ng-change=vm.getAllAdminRolesHit(vm.filterData)><option value=\"\" disabled selected>{{\'roleStatusPlace\' | translate}}</option><option value=0>Active</option><option value=1>Inactive</option><option value=2>All</option></select></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><p class=totalSize><span class=pull-right><a class=\"btn btn-primary mb10\" ui-sref=layout.adminRolesMain.givePermissions>+ {{\'newRole\' | translate}}</a> </span>{{\'totalAdminRoles\' | translate}}: {{vm.totalRoles}}</p></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.getFilter()></div></div><!--<div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\">--><!--<label class=\"control-label\">Records per page</label>--><!--<select class=\"form-control\" ng-model=\"vm.itemsPerPageSelected\"--><!--ng-options=\"pages for pages in vm.searchModel.limitOptions\"--><!--ng-change=\"vm.getPagesCount()\"></select>--><!--</div>--></div><div class=\"table-responsive tableWithMasterDataParentDive\" ng-switch=\"(vm.promoLIst | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'admin_id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'roleNameLabel\' | translate}}\" text=\"\'roleName\'\" check=vm.reverse>{{\'roleNameLabel\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'noFixedRouteFound\' | translate}}\" text=\"\'description\'\" check=vm.reverse>{{\'description\' | translate}}</th><!--<th>--><!--<div class=\"\" ng-click=\"vm.sort(\'email\')\">--><!--Email--><!--<span ng-hide=\"vm.predicate == \'email\' && vm.reverse || vm.predicate == \'email\' && !vm.reverse\"--><!--class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'email\' && !vm.reverse\"--><!--class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'email\' && vm.reverse\"--><!--class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><!--<th>--><!--<div class=\"\" ng-click=\"vm.sort(\'role\')\">--><!--Admin Role--><!--<span ng-hide=\"vm.predicate == \'role\' && vm.reverse || vm.predicate == \'role\' && !vm.reverse\"--><!--class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'role\' && !vm.reverse\"--><!--class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'role\' && vm.reverse\"--><!--class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><th style=width:100px><div>{{\'stateTable\' | translate}}</div></th><th style=width:150px><div>{{\'action\' | translate}}</div></th><!--<th>--><!--<div>--><!--Admin Logs--><!--</div>--><!--</th>--><!--<th>--><!--<div>--><!--Reports--><!--</div>--><!--</th>--></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.adminRoleList| filter:vm.search | orderBy:vm.predicate:vm.reverse\"><td style=width:70px>{{data.index + 1}}</td><td style=width:70px hidden>{{::data.id}}</td><td style=width:125px>{{::data.roleName}}</td><td style=width:125px>{{::data.description || \'--\'}}</td><!--<td>{{data.admin_type}}</td>--><!--<td>{{data.email}}</td>--><!--<td>{{data.role.roleName || \'&#45;&#45;\'}}</td>--><td style=width:100px><a class=\"cursor btn btn-sm\" ng-class=\"{\'blockIconColor\': data.is_active == false || data.is_active == \'false\', \'unblockIconColor\': data.is_active == true || data.is_active == \'true\'}\" ng-click=vm.changeAdminRoleStatus(data,$event)><i ng-class=\"{\'fa fa-unlock\': data.is_active == true || data.is_active == \'true\',\'fa fa-lock\': data.is_active == false || data.is_active == \'false\'}\"></i></a></td><td style=width:150px><a title=\"Edit Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.adminRolesMain.updatePermissions({id:\'{{data.id}}\'})\"><i class=\"fa fa-pencil\"></i> </a><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteRole(data,$event)><i class=\"fa fa-trash\"></i> </a><a title=\"View Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.adminRolesMain.viewRoles({id:\'{{data.id}}\'})\"><i class=\"fa fa-eye\"></i></a></td><!--<td>--><!--<a class=\"btn btn-primary tableButton mb10\" ng-class=\"{\'roleGiven\': !data.role.roleName,\'roleUpdate\':data.role.roleName}\" ng-click=\"vm.goToPermission(data)\">--><!--{{data.role.roleName?\'Update Permissions\':\'Give Permissions\'}}--><!--</a>--><!--&lt;!&ndash;<a class=\"btn btn-primary tableButton mb10\" style=\"background-color: #2f80e7;border-color: #2f80e7\" ng-disabled=\"!data.role.roleName\" ui-sref=\"layout.adminRolesMain.updatePermissions({id:\'{{data.admin_id}}\'})\">Update Permissions</a><br/>&ndash;&gt;--><!--&lt;!&ndash;<a class=\"btn btn-primary tableButton mb10\" style=\"background-color: #f18903;border-color: #f18903\" ng-disabled=\"data.role.roleName\" ui-sref=\"layout.adminRolesMain.givePermissions({id:\'{{data.admin_id}}\'})\">Give Permissions</a>&ndash;&gt;--><!--</td>--><!--<td>--><!--<a class=\"btn btn-primary tableButton mb10\" ui-sref=\"layout.adminRolesMain.bookingReports({id:\'{{data.admin_id}}\'})\">Booking Reports</a>--><!--</td>--><!--<td>--><!--<a class=\"btn btn-primary tableButton\" title=\"Admin Logs\"--><!--ui-sref=\"layout.agreementMain.adminLogs({userId:\'{{data.id}}\',type:\'7\',fakeType: \'25\'})\" >Admin Logs</a>--><!--</td>--></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noRole\' | translate}}</th></tr></tfoot></table></div><!--<div class=\"row\">--><!--<div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\">--><!--<span ng-hide=\"vm.filterOn\">Showing {{vm.skipValue + 1}} to {{vm.limitValue + 1}} of {{vm.dataLength}} entries</span>--><!--<span ng-show=\"vm.filterOn\">Showing {{vm.skipValueFilter}} of {{vm.dataLength}} entries</span>--><!--</div>--><!--<div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\">--><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav ng-show=\"vm.watchPagination\">--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">Previous</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\"--><!--ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">Next</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><!--</div>--><!--</div>--></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/admin-role/adminRolesMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/admin-role/adminUserListMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/admin-role/adminUsersList.html","<h2 class=ng-cloak>{{\'adminUserHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-4 col-sm-6 col-md-4 col-xs-12\"><label class=control-label>{{\'userStatusLabel\' | translate}}</label><select class=form-control ng-model=vm.filterData.userStatus ng-change=\"vm.getAllAdminUsersHit(0,10,vm.filterData);vm.currentPage = 0;vm.itemsPerPageSelected=10;vm.itemsPerPageGot=10\"><option value=\"\" disabled>{{\'userStatusPlace\' | translate}}</option><option selected value=0>Active</option><option value=1>Inactive</option><option value=2>All</option></select></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><p class=totalSize><span class=pull-right><a class=\"btn btn-primary mb10\" ng-click=vm.createNewUser($event)>+ {{\'newAdminButton\' | translate}}</a> </span>{{\'totalAdminUsers\' | translate}}: {{vm.totalRoles}}</p></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\" ng-switch=\"(vm.promoLIst | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'admin_id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'addedAt\' | translate}}\" text=\"\'creation_datetime\'\" check=vm.reverse>{{\'addedAt\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'email\' | translate}}\" text=\"\'email\'\" check=vm.reverse>{{\'email\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'name\' | translate}}\" text=\"\'fullName\'\" check=vm.reverse>{{\'name\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'adminRoleLabelTable\' | translate}}\" text=\"\'role\'\" check=vm.reverse>{{\'adminRoleLabelTable\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'operationPointName\' | translate}}\" text=\"\'point_name\'\" check=vm.reverse>{{\'operationPointName\' | translate}}</th><th style=width:100px><div>{{\'stateTable\' | translate}}</div></th><th style=width:125px><div>{{\'action\' | translate}}</div></th><th style=width:250px><div>{{\'addUpdateRole\' | translate}}</div></th><th style=width:250px><div>{{\'operationPoint\' | translate}}</div></th><th style=width:250px><div>{{\'reports\' | translate}}</div></th><!--<th>--><!--<div>--><!--Admin Logs--><!--</div>--><!--</th>--></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.adminUserList| filter:vm.search | orderBy:vm.predicate:vm.reverse\"><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:70px>{{::data.admin_id}}</td><td style=width:125px>{{data.creation_datetime | date:\'medium\'}}</td><!--<td>{{data.admin_type}}</td>--><td style=width:125px>{{::data.email}}</td><td style=width:125px>{{data.fullName || \'--\'}}</td><td style=width:125px><span ng-if=\"data.role.length == 0\">No Role Given</span> <span ng-repeat=\"role in data.role\">{{role.roleName}}<span ng-if=\"$index != data.role.length - 1\">,</span></span></td><td style=width:125px>{{data.point_name || \'--\'}}</td><td style=width:100px><a class=\"cursor btn btn-sm\" ng-class=\"{\'blockIconColor\': data.status == 1, \'unblockIconColor\': data.status == 0}\" ng-click=vm.changeAdminStatus(data,$event)><i ng-class=\"{\'fa fa-unlock\': data.status == 0,\'fa fa-lock\': data.status == 1}\"></i></a></td><td style=width:125px><a title=\"Edit Details\" class=\"cursor editIconColor btn btn-sm\" ng-click=vm.editUser(data,$event)><i class=\"fa fa-edit\"></i> </a><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteUser(data,$event)><i class=\"fa fa-trash\"></i></a></td><td style=width:250px><a class=\"btn btn-primary tableButton mb10\" ng-class=\"{\'roleGiven\': !data.role.length,\'roleUpdate\':data.role.length}\" ng-click=vm.goToPermission(data)><span ng-if=data.role.length>{{\'updateRoleButton\' | translate}}</span> <span ng-if=!data.role.length>{{\'addRoleButton\' | translate}}</span> </a><!--<a class=\"btn btn-primary tableButton mb10\" style=\"background-color: #2f80e7;border-color: #2f80e7\" ng-disabled=\"!data.role.roleName\" ui-sref=\"layout.adminRolesMain.updatePermissions({id:\'{{data.admin_id}}\'})\">Update Permissions</a><br/>--><!--<a class=\"btn btn-primary tableButton mb10\" style=\"background-color: #f18903;border-color: #f18903\" ng-disabled=\"data.role.roleName\" ui-sref=\"layout.adminRolesMain.givePermissions({id:\'{{data.admin_id}}\'})\">Give Permissions</a>--></td><td style=width:250px><a ng-disabled=\"data.userType == 1\" class=\"btn btn-primary tableButton mb10\" ng-click=vm.addToOperationPoint(data,$event)>{{\'operationPointAdd\' | translate}}</a></td><td style=width:250px><a class=\"btn btn-primary tableButton mb10\" ui-sref=\"layout.adminUsersMain.bookingReports({id:\'{{data.admin_id}}\'})\">{{\'bookingReportButton\' | translate}}</a></td><!--<td>--><!--<a class=\"btn btn-primary tableButton\" title=\"Admin Logs\"--><!--ui-sref=\"layout.agreementMain.adminLogs({userId:\'{{data.id}}\',type:\'7\',fakeType: \'26\'})\" >Admin Logs</a>--><!--</td>--></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noAdminUser\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav ng-show=\"vm.watchPagination\">--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\"--><!--ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/admin-role/bookingReportsAdmin.html","<h2 class=ng-cloak>{{\'adminUserHead\' | translate}} / {{\'bookingReportHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><p class=\"totalSize text-center\"><span class=pull-left><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button> </span>{{\'totalBookings\' | translate}}: {{vm.totalBookings}}</p></div><div class=\"row mt10 marginZero\"><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12\"><label>{{\'tableStartDate\' | translate}}</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=startValidity ng-model=vm.dataToFill.startDate placeholder=\"{{\'tableStartDate\' | translate}}\" is-open=vm.datePicker_1.start datepicker-options=vm.dateOptions required close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.dateChanged()> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'1\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12\"><label>{{\'tableEndDate\' | translate}}</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=endValidity ng-model=vm.dataToFill.endDate placeholder=\"{{\'tableEndDate\' | translate}}\" is-open=vm.datePicker_1.end datepicker-options=vm.dateOptions required close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.dateChanged()> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'2\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12\"><div class=text-right><label style=\"visibility: hidden\">Button</label><br><button class=\"btn btn-default\" ng-click=vm.exportReport(vm.dataToFill)>CSV</button></div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\" ng-switch=\"(vm.promoLIst | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'job_id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'creationDate\' | translate}}\" text=\"\'creation_datetime\'\" check=vm.reverse>{{\'creationDate\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'actualStartDate\' | translate}}\" text=\"\'job_time\'\" check=vm.reverse>{{\'actualStartDate\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'status\' | translate}}\" text=\"\'job_status\'\" check=vm.reverse>{{\'status\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'passengersCount\' | translate}}\" text=\"\'number_of_passangers\'\" check=vm.reverse>{{\'passengersCount\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'customerDetails\' | translate}}\" text=\"\'created_by\'\" check=vm.reverse>{{\'customerDetails\' | translate}}</th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.adminBookingList| filter:vm.search | orderBy:vm.predicate:vm.reverse\"><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:70px>{{::data.job_id}}</td><td style=width:125px>{{data.creation_datetime | date: \'medium\'}}</td><td style=width:125px>{{data.job_time | date: \'medium\'}}</td><td style=width:100px><sapn ng-if=\"data.job_status == \'0\'\">{{\'upcomingStatus\' | translate}}</sapn><sapn ng-if=\"data.job_status == \'1\'\">Viaje Iniciado</sapn><sapn ng-if=\"data.job_status == \'2\'\">Completada</sapn><sapn ng-if=\"data.job_status == \'3\'\">Failed</sapn><sapn ng-if=\"data.job_status == \'4\'\">En Posición</sapn><sapn ng-if=\"data.job_status == \'5\'\">Partial</sapn><sapn ng-if=\"data.job_status == \'6\'\">No Asignada</sapn><sapn ng-if=\"data.job_status == \'7\'\">Accepted</sapn><sapn ng-if=\"data.job_status == \'8\'\">Decline</sapn><sapn ng-if=\"data.job_status == \'9\'\">Cancelada</sapn><sapn ng-if=\"data.job_status == \'10\'\">Deleted</sapn><sapn ng-if=\"data.job_status == \'11\'\">Ignored</sapn></td><td style=width:125px>{{::data.number_of_passangers}}</td><td style=width:125px>Name: <b>{{data.customer_first_name + \' \' + data.customer_last_name}}</b><br>Mobile Number: <b>{{data.customer_country_code?data.customer_phone_number:data.customer_country_code+data.customer_phone_number}}</b><br>ID: <b>{{::data.created_by}}</b><br></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noReportFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav ng-show=\"vm.watchPagination\">--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\"--><!--ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/admin-role/getAdminSysLogs.html","<h2 class=ng-cloak><span ng-if=\"vm.type == \'0\'\">{{\'applicantHead\' | translate}} / {{\'adminLogs\' | translate}}</span> <span ng-if=\"vm.type == \'1\'\">{{\'approveDriversHead\' | translate}} / {{\'adminLogs\' | translate}}</span> <span ng-if=\"vm.type == \'2\'\">{{\'approvedInvestorsHead\' | translate}} / {{\'adminLogs\' | translate}}</span> <span ng-if=\"vm.type == \'3\'\">{{\'customerHead\' | translate}} / {{\'adminLogs\' | translate}}</span> <span ng-if=\"vm.type == \'4\'\">{{\'vehiclesLabel\' | translate}} / {{\'adminLogs\' | translate}}</span> <span ng-if=\"vm.type == \'5\'\">{{\'cancelReasonHead\' | translate}} / {{\'adminLogs\' | translate}}</span> <span ng-if=\"vm.type == \'6\'\">{{\'driverEarningHead\' | translate}} / {{\'adminLogs\' | translate}}</span> <span ng-if=\"vm.type == \'7\'\">{{\'serviceLabel\' | translate}} / {{\'adminLogs\' | translate}}</span> <span ng-if=\"vm.type == \'8\'\">{{\'vehicleTypeLabel\' | translate}} / {{\'adminLogs\' | translate}}</span> <span ng-if=\"vm.type == \'9\'\">{{\'corporateHead\' | translate}} / {{\'adminLogs\' | translate}}</span> <span ng-if=\"vm.type == \'10\'\">{{\'itemChargeHead\' | translate}} / {{\'adminLogs\' | translate}}</span> <span ng-if=\"vm.type == \'11\'\">{{\'paymentPHead\' | translate}} / {{\'adminLogs\' | translate}}</span> <span ng-if=\"vm.type == \'12\'\">{{\'promoHead\' | translate}} / {{\'adminLogs\' | translate}}</span> <span ng-if=\"vm.type == \'13\'\">{{\'branchListHead\' | translate}} / {{\'adminLogs\' | translate}}</span> <span ng-if=\"vm.type == \'14\'\">{{\'fixedGeoHead\' | translate}} / {{\'adminLogs\' | translate}}</span> <span ng-if=\"vm.type == \'15\'\">{{\'fixedGeoList\' | translate}} / {{\'adminLogs\' | translate}}</span> <span ng-if=\"vm.type == \'16\'\">{{\'agreementHead\' | translate}} / {{\'adminLogs\' | translate}}</span> <span ng-if=\"vm.type == \'17\'\">{{\'agreementHead\' | translate}} / {{\'employeeHead\' | translate}} / {{\'adminLogs\' | translate}}</span> <span ng-if=\"vm.type == \'18\'\">{{\'agreementHead\' | translate}} / {{\'priceListHead1\' | translate}} / {{\'adminLogs\' | translate}}</span> <span ng-if=\"vm.type == \'19\'\">{{\'agreementHead\' | translate}} / {{\'priceListHead2\' | translate}} / {{\'adminLogs\' | translate}}</span> <span ng-if=\"vm.type == \'20\'\">{{\'agreementHead\' | translate}} / {{\'priceListHead1\' | translate}} / {{\'priceRouteHead1\' | translate}} / {{\'adminLogs\' | translate}}</span> <span ng-if=\"vm.type == \'21\'\">{{\'agreementHead\' | translate}} / {{\'priceListHead2\' | translate}} / {{\'priceRouteHead2\' | translate}} / {{\'adminLogs\' | translate}}</span> <span ng-if=\"vm.type == \'22\'\">{{\'agreementHead\' | translate}} / {{\'priceListHead1\' | translate}} / {{\'priceRouteHead1\' | translate}} / {{\'adminLogs\' | translate}}</span> <span ng-if=\"vm.type == \'23\'\">{{\'agreementHead\' | translate}} / {{\'priceListHead2\' | translate}} / {{\'priceRouteHead2\' | translate}} / {{\'adminLogs\' | translate}}</span><!--<span ng-if=\"vm.type == \'24\'\">{{\'adminLogs\' | translate}} / {{\'adminLogs\' | translate}}</span>--> <span ng-if=\"vm.type == \'25\'\">{{\'correctReasonHead\' | translate}} / {{\'adminLogs\' | translate}}</span> <span ng-if=\"vm.type == \'26\'\">{{\'noShowReasonHead\' | translate}} / {{\'adminLogs\' | translate}}</span> <span ng-if=\"vm.type == \'27\'\">Bins / {{\'adminLogs\' | translate}}</span> <span ng-if=\"vm.type == \'28\'\">Cupones de Descuento / {{\'adminLogs\' | translate}}</span> <span ng-if=\"vm.type == \'30\'\">Administración de Mapa de Calor / {{\'adminLogs\' | translate}}</span> <span ng-if=\"vm.type == \'31\'\">{{\'fixedGeoHeadAuto\' | translate}} / {{\'adminLogs\' | translate}}</span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><p class=totalSize><span class=pull-left><a class=\"btn btn-primary mb10\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</a> </span>{{\'totalAdminLogs\' | translate}}: {{vm.totalAdminLogs}}</p></div><br><br><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>Records per page</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\" ng-switch=\"(vm.serviceList | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'userId\' | translate}}\" text=\"\'id\'\" check=vm.reverse>{{\'userId\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'adminEmail\' | translate}}\" text=\"\'admin_email\'\" check=vm.reverse>{{\'adminEmail\' | translate}}</th><th style=width:200px table-column-sorting current-text=vm.predicate title=\"{{\'messageAdminLog\' | translate}}\" text=\"\'message\'\" check=vm.reverse>{{\'messageAdminLog\' | translate}}</th><th style=width:150px table-column-sorting current-text=vm.predicate title=\"{{\'date\' | translate}}\" text=\"\'time\'\" check=vm.reverse>{{\'date&Time\' | translate}}</th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.adminLogList| filter:vm.search | orderBy:vm.predicate:vm.reverse\"><td style=width:70px>{{data.index + 1}}</td><td style=width:100px>{{::data.id}}</td><td style=width:125px>{{::data.admin_email}}</td><td style=width:200px>{{::data.message}}</td><td style=width:150px>{{data.time | date:\'medium\'}}</td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noAdminLog\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav ng-show=\"vm.watchPagination\">--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\"--><!--ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/admin-role/newRole.html","<h2 class=ng-cloak>{{\'adminRoleListHead\' | translate}} / {{\'createRoleHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'createRoleHead\' | translate}}</p><div class=basicDetailsDiv><form method=post name=givePermissionForm ng-submit=\"submit=true;givePermissionForm.$valid&&vm.addRoleApiHit()\" novalidate autocomplete=off><div class=row><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">Permission Name<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.permissionName\" name=\"permissionName\" placeholder=\"Permission Name\"--><!--required ng-class=\"{ \'has-error\': givePermissionForm.permissionName.$touched && givePermissionForm.permissionName.$invalid }\"/>&lt;!&ndash;pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"&ndash;&gt;--><!--<div ng-if=\"givePermissionForm.permissionName.$touched|| submit\" ng-messages=\"givePermissionForm.permissionName.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter permission name.</div>--><!--</div>--><!--</div>--><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label class=control-label>{{\'roleNameLabel\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.roleName name=roleName placeholder=\"{{\'roleNameLabel\' | translate}}\" required ng-class=\"{ \'has-error\': givePermissionForm.roleName.$touched && givePermissionForm.roleName.$invalid }\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\"givePermissionForm.roleName.$touched|| submit\" ng-messages=givePermissionForm.roleName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'roleNameReq\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label class=control-label>{{\'description\' | translate}}</label><textarea class=form-control ng-model=vm.dataToFill.description name=description placeholder=\"{{\'messagePlaceholder\' | translate}}\" ng-class=\"{ \'has-error\': givePermissionForm.description.$touched && givePermissionForm.description.$invalid }\"></textarea><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"padding-top: 20px\"><div class=\"col-lg-6 col-sm-6 col-xs-6 col-md-12\"><span class=HeadingRole>Roles PET </span><input class=radioButtonRoles type=radio ng-model=vm.dataToFill.roles_pet name=role value=roles_pet ng-click=vm.RolePet();></div><div class=\"col-lg-6 col-sm-6 col-xs-6 col-md-12\"><span class=HeadingRole>Roles Enlace </span><input class=radioButtonRoles type=radio ng-model=vm.dataToFill.roles_pet name=role ng-checked=vm.selected value=roles_encale ng-click=vm.RoleNormal();></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=margin-top:10px><div class=\"table-responsive tableWithMasterDataParentDive\"><table class=\"table tableWithMasterData\" id=adminTable><thead><tr><th style=width:125px>{{\'pageNameHead\' | translate}}</th><th style=\"width:122px;text-align: center !important\"><!--<input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.selectAllRoles(vm.selectAll)\"/>&nbsp;&nbsp;Select All--><md-checkbox class=md-primary ng-model=vm.selectAll ng-click=vm.selectAllRoles(vm.selectAll) aria-label=CheckboxAll>{{\'selectAll\' | translate}}</md-checkbox></th></tr></thead><tbody><tr ng-repeat=\"data in vm.dataToFill.finalArrayStates\"><td style=width:125px>{{::data.title}}</td><td style=\"width:125px;text-align: center !important\"><!--<input type=\"checkbox\" ng-model=\"data.checked\" />--><md-checkbox class=md-primary ng-model=data.checked aria-label=Checkbox{{$index}}></md-checkbox></td></tr></tbody></table></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\" style=margin-top:10px><button class=\"btn btn-primary\" style=width:200px>{{\'submit\' | translate}}</button></div></div></form></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/admin-role/updateRole.html","<h2 class=ng-cloak>{{\'adminRoleListHead\' | translate}}/ {{\'updateRoleButton\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'updateRoleButton\' | translate}}</p><div class=basicDetailsDiv><form method=post name=updatePermissionForm ng-submit=\"submit=true;updatePermissionForm.$valid&&vm.updateRole()\" novalidate autocomplete=off><div class=row><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">Permission Name<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.permissionName\" name=\"permissionName\" placeholder=\"Permission Name\"--><!--required ng-class=\"{ \'has-error\': updatePermissionForm.permissionName.$touched && updatePermissionForm.permissionName.$invalid }\"/>&lt;!&ndash;pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"&ndash;&gt;--><!--<div ng-if=\"updatePermissionForm.permissionName.$touched|| submit\" ng-messages=\"updatePermissionForm.permissionName.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter permission name.</div>--><!--</div>--><!--</div>--><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label class=control-label>{{\'roleNameLabel\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.roleNameGiven name=roleName placeholder=\"{{\'roleNameLabel\' | translate}}\" required ng-class=\"{ \'has-error\': updatePermissionForm.roleName.$touched && updatePermissionForm.roleName.$invalid }\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\"updatePermissionForm.roleName.$touched|| submit\" ng-messages=updatePermissionForm.roleName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'roleNameReq\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label class=control-label>{{\'description\' | translate}}</label><textarea class=form-control ng-model=vm.dataToFill.description name=description placeholder=\"{{\'messagePlaceholder\' | translate}}\" ng-class=\"{ \'has-error\': updatePermissionForm.description.$touched && updatePermissionForm.description.$invalid }\"></textarea><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"padding-top: 20px\"><div class=\"col-lg-6 col-sm-6 col-xs-6 col-md-12\"><span class=HeadingRole>Roles PET </span><input class=radioButtonRoles type=radio ng-model=vm.dataToFill.roles_pet name=role value=roles_pet ng-click=vm.RolePet();></div><div class=\"col-lg-6 col-sm-6 col-xs-6 col-md-12\"><span class=HeadingRole>Roles Enlace </span><input class=radioButtonRoles type=radio ng-model=vm.dataToFill.roles_pet name=role ng-checked=vm.selected value=roles_encale ng-click=vm.RoleNormal();></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=margin-top:10px><div class=\"table-responsive tableWithMasterDataParentDive\"><table class=\"table tableWithMasterData\" id=adminTable><thead><tr><th style=width:125px>{{\'pageNameHead\' | translate}}</th><th style=\"width:122px;text-align: center !important\"><!--<input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.selectAllRoles(vm.selectAll)\"/>&nbsp;&nbsp;Select All--><md-checkbox class=md-primary ng-model=vm.selectAll ng-click=vm.selectAllRoles(vm.selectAll) aria-label=CheckboxAll>{{\'selectAll\' | translate}}</md-checkbox></th></tr></thead><tbody><tr ng-repeat=\"data in vm.dataToFill.finalArrayStates\"><td style=width:125px>{{::data.title}}</td><td style=\"width:122px;text-align: center !important\"><!--<input type=\"checkbox\" ng-model=\"data.checked\" />--><md-checkbox class=md-primary ng-model=data.checked aria-label=Checkbox{{$index}}></md-checkbox></td></tr></tbody></table></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\" style=margin-top:10px><button class=\"btn btn-primary\" style=width:200px>{{\'submit\' | translate}}</button></div></div></form></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/admin-role/updateRoleToAdminUser.html","<h2 class=ng-cloak>{{\'adminUserHead\' | translate}} / {{\'updateRoleToUser\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'updateRoleToUser\' | translate}}</p><div class=basicDetailsDiv><form method=post name=updateRoleToUserForm ng-submit=\"submit=true;updateRoleToUserForm.$valid&&vm.updateRoleToUserApiHit()\" novalidate autocomplete=off><div class=row><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">Permission Name<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.permissionName\" name=\"permissionName\" placeholder=\"Permission Name\"--><!--required ng-class=\"{ \'has-error\': updateRoleToUserForm.permissionName.$touched && updateRoleToUserForm.permissionName.$invalid }\"/>&lt;!&ndash;pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"&ndash;&gt;--><!--<div ng-if=\"updateRoleToUserForm.permissionName.$touched|| submit\" ng-messages=\"updateRoleToUserForm.permissionName.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter permission name.</div>--><!--</div>--><!--</div>--><!--<div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\">--><!--<label class=\"control-label\">Role Name<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.roleName\" name=\"roleName\" placeholder=\"Role Name\"--><!--required ng-class=\"{ \'has-error\': updateRoleToUserForm.roleName.$touched && updateRoleToUserForm.roleName.$invalid }\"/>&lt;!&ndash;pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"&ndash;&gt;--><!--<div ng-if=\"updateRoleToUserForm.roleName.$touched|| submit\" ng-messages=\"updateRoleToUserForm.roleName.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter role name.</div>--><!--</div>--><!--</div>--><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=margin-top:10px><div class=\"table-responsive tableWithMasterDataParentDive\"><table class=\"table tableWithMasterData\" id=adminTable><thead><tr><th style=width:125px>{{\'roleNameLabel\' | translate}}</th><th style=width:125px>{{\'select\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"data in vm.adminRoleList\"><td style=width:125px>{{::data.roleName}}</td><td style=width:125px><!--<input type=\"checkbox\" ng-model=\"data.checked\" />--><md-checkbox class=md-primary ng-model=data.checked aria-label=Checkbox{{$index}}></md-checkbox></td></tr></tbody></table></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\" style=margin-top:10px><button class=\"btn btn-primary\" style=width:200px>{{\'submit\' | translate}}</button></div></div></form></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/admin-role/viewAdminRoles.html","<h2 class=ng-cloak>{{\'adminRoleListHead\' | translate}} / {{\'viewRole\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'viewRole\' | translate}}</p><div class=basicDetailsDiv><!--<form method=\"post\" name=\"updatePermissionForm\" ng-submit=\"submit=true;updatePermissionForm.$valid&&vm.updateRole()\" novalidate autocomplete=\"off\">--><div class=row><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">Permission Name<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.permissionName\" name=\"permissionName\" placeholder=\"Permission Name\"--><!--required ng-class=\"{ \'has-error\': updatePermissionForm.permissionName.$touched && updatePermissionForm.permissionName.$invalid }\"/>&lt;!&ndash;pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"&ndash;&gt;--><!--<div ng-if=\"updatePermissionForm.permissionName.$touched|| submit\" ng-messages=\"updatePermissionForm.permissionName.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter permission name.</div>--><!--</div>--><!--</div>--><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label class=control-label>{{\'roleNameLabel\' | translate}}<span style=color:red>*</span></label><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.roleNameGiven\" name=\"roleName\" placeholder=\"Role Name\"--><!--required ng-class=\"{ \'has-error\': updatePermissionForm.roleName.$touched && updatePermissionForm.roleName.$invalid }\"/>&lt;!&ndash;pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"&ndash;&gt;--><div class=form-control>{{vm.dataToFill.roleNameGiven || \'--\'}}</div><!--<div ng-if=\"updatePermissionForm.roleName.$touched|| submit\" ng-messages=\"updatePermissionForm.roleName.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter role name.</div>--><!--</div>--></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label class=control-label>{{\'description\' | translate}}</label><textarea class=form-control readonly ng-model=vm.dataToFill.description name=description placeholder=\"{{\'messagePlaceholder\' | translate}}\"></textarea><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label class=control-label>Tipo de rol<span style=color:red>*</span></label><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.roleNameGiven\" name=\"roleName\" placeholder=\"Role Name\"--><!--required ng-class=\"{ \'has-error\': updatePermissionForm.roleName.$touched && updatePermissionForm.roleName.$invalid }\"/>&lt;!&ndash;pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"&ndash;&gt;--><div class=form-control>{{vm.dataToFill.roleType == \'roles_pet\' ? \'Roles PET\' : \'Roles Enlace\' || \'--\'}}</div><!--<div ng-if=\"updatePermissionForm.roleName.$touched|| submit\" ng-messages=\"updatePermissionForm.roleName.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter role name.</div>--><!--</div>--></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=margin-top:10px><div ng-if=\"vm.dataToFill.finalArrayStates.length == 0\"><p class=text-center>No permission given.</p></div><div class=table-responsive ng-if=vm.dataToFill.finalArrayStates.length><table class=table><thead><tr><th>{{\'pageNameHead\' | translate}}</th><!--<th><input type=\"checkbox\" ng-model=\"vm.selectAll\" ng-click=\"vm.selectAllRoles(vm.selectAll)\"/>&nbsp;&nbsp;Select All</th>--></tr></thead><tbody><tr ng-repeat=\"data in vm.dataToFill.finalArrayStates\"><td ng-if=data.checked>{{::data.title}}</td><!--<td>--><!--<input type=\"checkbox\" ng-model=\"data.checked\" />--><!--</td>--></tr></tbody></table></div></div><!--<div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\" style=\"margin-top:10px;\">--><!--<button class=\"btn btn-primary\" style=\"width:200px;\">Submit</button>--><!--</div>--></div><!--</form>--></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/agreement/Agreement.html","<h2 class=ng-cloak><span>{{\'agreementHead\' | translate}}</span> <span class=pull-right><button class=\"btn btn-primary tableButton\" ng-click=vm.refreshData()>Volver a cargar</button></span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label class=control-label>{{\'branchLabel\' | translate}}</label><ui-select ng-model=vm.filterData.region_id ng-keyup=vm.branchSearch($select.search,$event) name=branch required close-on-select=true><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \" when-scrolled=vm.paginationChangedForBranch() ng-click=\"vm.getAllAgreements(0,vm.itemsPerPageGot,vm.filterData);vm.currentPage = 0;\"><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label>{{\'corporateLabel\' | translate}}</label><ui-select ng-model=vm.filterData.corporate_id ng-keyup=vm.corporateSearch($select.search,$event) name=corporateName required close-on-select=true><ui-select-match placeholder=\"{{\'corporatePlaceholder\' | translate}}\">{{$select.selected.company_name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in vm.corporatesList | filter: $select.search | orderBy:\'company_name\'\" when-scrolled=vm.paginationChangedForCorporation() ng-click=vm.corporate()><div ng-bind-html=data.company_name></div></ui-select-choices></ui-select></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label class=control-label>{{\'agreementStatusLabel\' | translate}}</label><select class=form-control ng-model=vm.filterData.agreementStatus ng-change=\"vm.getAllAgreements(0,vm.itemsPerPageGot,vm.filterData);vm.currentPage = 0;vm.itemsPerPageSelected = 10;\"><option value=\"\" disabled>{{\'agreementStatusPlaceholder\' | translate}}</option><option value=3>Todos</option><option value=1 selected>Activo</option><option value=0>Inactivo</option><option value=2>En Progreso</option></select></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center mt5\"><p class=totalSize><span class=pull-left><a class=\"btn btn-primary tableButton mb10\" ng-click=vm.exportToCSV(vm.filterData,0,vm.dataLength)>CSV</a> </span><span class=pull-right><a ng-if=\"vm.userType == 0\" class=\"btn btn-primary mb10\" ui-sref=layout.agreementMain.addAgreement>+ {{\'addNewAgreementButton\' | translate}}</a> </span>{{\'totalAgreement\' | translate}}: {{vm.totalAgreement}}</p></div><br><br><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model-options=\"{ debounce: 500 }\" ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\"><!--ng-switch=\"(vm.employeeList | filter:vm.search).length\"--><!--<div ng-switch-when=\"0\" class=\"noSearch\"><span>{{\'nothingFound\' | translate}}</span></div>--><table class=\"table table-hover tableWithMasterData\"><!--ng-switch-default--><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'typeTableHead\' | translate}}\" text=\"\'agreement_type\'\" check=vm.reverse>{{\'typeTableHead\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'name\' | translate}}\" text=\"\'name\'\" check=vm.reverse>{{\'name\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'companyTableHead\' | translate}}\" text=\"\'companyName\'\" check=vm.reverse>{{\'companyTableHead\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'categoryTableHead\' | translate}}\" text=\"\'commercial_classification\'\" check=vm.reverse>{{\'categoryTableHead\' | translate}}</th><!--<th>--><!--<div ng-click=\"vm.sort(\'companyRUT\')\">--><!--Company RUT--><!--<span ng-hide=\"vm.predicate == \'companyRUT\' && vm.reverse || vm.predicate == \'companyRUT\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'companyRUT\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'companyRUT\' && vm.reverse\" class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'paymentMethodLabel\' | translate}}\" text=\"\'paymentMethod\'\" check=vm.reverse>{{\'paymentMethodLabel\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'serviceTableHead\' | translate}}\" text=\"\'typeOfService\'\" check=vm.reverse>{{\'serviceTableHead\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'branchesTableHead\' | translate}}\" text=\"\'branch\'\" check=vm.reverse>{{\'branchesTableHead\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"Descuento de ida y vuelta\" text=\"\'branch\'\" check=vm.reverse>Descuento de ida y vuelta</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"Descuento por correo electrónico WebPay / URL\" text=\"\'branch\'\" check=vm.reverse>Descuento por correo electrónico WebPay / URL</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'fixedListUpdate\' | translate}}\" text=\"\'fixedListUpdate\'\" check=vm.reverse>{{\'fixedListUpdate\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'variableListUpdate\' | translate}}\" text=\"\'variableListUpdate\'\" check=vm.reverse>{{\'variableListUpdate\' | translate}}</th><!--<th>--><!--<div ng-click=\"vm.sort(\'status\')\">--><!--Status--><!--<span ng-hide=\"vm.predicate == \'status\' && vm.reverse || vm.predicate == \'status\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'status\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'status\' && vm.reverse\" class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><th style=width:100px><div>{{\'stateTable\' | translate}}</div></th><th style=width:150px><div>{{\'action\' | translate}}</div></th><th style=width:250px ng-if=\"vm.userType == 0\"><div>Permitir Modificar Tarifa - PANEL</div></th><th style=width:250px ng-if=\"vm.userType == 0\"><div>Permitir Modificar Tarifa - POS</div></th><th style=width:150px><div>{{\'manageTableHead\' | translate}}</div></th><th style=width:150px><div>{{\'managePriceListTableHead\' | translate}}</div></th><th style=width:150px ng-if=\"vm.userType == 0\"><div>{{\'bulkupload\' | translate}}</div></th><th style=width:150px ng-if=\"vm.userType == 0\"><div>{{\'adminLogs\' | translate}}</div></th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.agreementList | orderBy:vm.predicate:vm.reverse\"><!--| filter:vm.search --><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:70px>{{::data.id}}</td><td style=width:100px>{{::data.agreement_type}}</td><td style=width:125px>{{::data.name}}</td><td style=width:125px>{{::data.companyName}}</td><td style=width:125px>{{::data.commercial_classification}}</td><td style=width:125px><span ng-repeat=\"payment in data.paymentMethod\">{{payment[0].type}} <span ng-if=\"$index != data.paymentMethod.length - 1\"><br></span></span></td><td style=width:125px><span ng-repeat=\"service in data.typeOfService\">{{service.type_of_service_id.service_name}} <span ng-if=\"$index != data.typeOfService.length - 1\"><br></span></span></td><td style=width:125px><span ng-repeat=\"dataG in data.branch\">{{dataG.region_name}} <span ng-if=\"$index != data.branch.length - 1\"><br></span></span><span ng-if=\"!data.branch && data.branch.length == 0\">--</span></td><td style=width:125px>{{::data.rt_discount}}</td><td style=width:125px>{{::data.web_discount}}</td><td style=width:125px>{{data.fixedListUpdate || \'--\' | date:\'dd-MMM-yy HH:mm\'}}</td><td style=width:125px>{{data.variableListUpdate || \'--\' | date:\'dd-MMM-yy HH:mm\'}}</td><!--<td>{{data.companyRUT}}</td>--><!--<td>--><!--<span ng-if=\"data.status == 1\">Active</span>--><!--<span ng-if=\"data.status == 0\">Inactive</span>--><!--<span ng-if=\"data.status == 2\">In Progress</span>--><!--</td>--><td style=width:100px><a class=\"cursor btn btn-sm\" ng-class=\"{\'blockIconColor\': data.status == 0, \'unblockIconColor\': data.status == 1 ,\'editIconColor\': data.status == 2}\" ng-click=vm.changeAgreementStatus(data,$event)><i ng-class=\"{\'fa fa-unlock\': data.status == 1,\'fa fa-lock\': data.status == 0,\'fa fa-clock-o\': data.status == 2}\"></i></a></td><td style=width:150px><a title=\"View Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.agreementMain.viewAgreementDetails({id:\'{{data.id}}\'})\"><i class=\"fa fa-eye\"></i> </a><a title=\"Edit Details\" ng-if=\"vm.userType == 0\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.agreementMain.editAgreement({id:\'{{data.id}}\'})\"><i class=\"fa fa-edit\"></i> </a><a title=\"Delete Details\" ng-if=\"vm.userType == 0\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteAgreement(data,$event) ng-disabled=\"data.status == 0 || data.status == 1\"><i class=\"fa fa-trash\"></i></a></td><td style=\"width:250px;font-size: 25px\" class=boleeanTypeColor ng-if=\"vm.userType == 0\"><!-- <label class=\"switch\">\n                                                    <input ng-click=\"vm.setBooleans(\'Allow_Change_Fare_Create_Booking\');vm.editAgreementApi(data.id)\" type=\"checkbox\">\n                                                    <span class=\"slider round\"  ng-class=\"{\'trueFlag slider switch\': data.id == 2,\'falseFlag\': data.id != 2 }\" ></span>\n                                                </label> --> <i ng-click=\"vm.editAgreementApi(data.id,data.allow_change_fare_panel,\'Allow_Change_Fare_Create_Booking\',\'Permitir Modificar Tarifa - PANEL\',$index)\" ng-class=\"{\'fa fa-toggle-on\': data.allow_change_fare_panel , \'fa fa-toggle-off\': !data.allow_change_fare_panel}\"></i></td><td style=\"width:250px;font-size: 25px\" class=boleeanTypeColor ng-if=\"vm.userType == 0\"><!-- <label class=\"switch\">\n                                                    <input ng-class=\"{\'trueFlag\': checkClicked,\'falseFlag\': !checkClicked }\" ng-click=\"vm.setBooleans(\'Allow_Change_Fare_POS\');vm.editAgreementApi(data.id)\" type=\"checkbox\">\n                                                    <span class=\"slider round\"></span>\n                                                </label> --> <i ng-click=\"vm.editAgreementApi(data.id,data.allow_change_fare_POS,\'Allow_Change_Fare_POS\',\'Permitir Modificar Tarifa - POS\',$index)\" ng-class=\"{\'fa fa-toggle-on\': data.allow_change_fare_POS , \'fa fa-toggle-off\': !data.allow_change_fare_POS}\"></i></td><td style=width:150px><a class=\"btn btn-primary tableButton\" title=\"Manage Employee\" ui-sref=\"layout.agreementMain.manageEmployee({corporateId:\'{{data.corporateid}}\',contractId:\'{{data.id}}\', path:\'0\'})\" ng-disabled=\"data.agreement_type == \'SPOT\'\">{{\'employeeButtonTable\' | translate}}</a></td><td style=width:150px><a class=\"btn btn-primary tableButton\" title=\"Fixed Price List\" ui-sref=\"layout.agreementMain.priceListFixedAgreement({corporateId:\'{{data.corporateid}}\',contractId:\'{{data.id}}\', path:\'1\'})\">{{\'fixedButtonTable\' | translate}}</a><br><a class=\"btn btn-primary tableButton mt5\" title=\"Variable Price List\" ui-sref=\"layout.agreementMain.priceListVariableAgreement({corporateId:\'{{data.corporateid}}\',contractId:\'{{data.id}}\', path:\'2\'})\">{{\'variableButtonTable\' | translate}}</a></td><td style=width:150px ng-if=\"vm.userType == 0\"><button ng-if=\"data.uploadFlag == 1\" class=\"btn btn-primary tableButton\" ng-click=vm.inactivateFlag(data,$event)>{{\'inactivate\' | translate}}</button> <span ng-if=\"data.uploadFlag == 0\">{{\'inactive\' | translate}}</span></td><td style=width:150px ng-if=\"vm.userType == 0\"><a class=\"btn btn-primary tableButton\" title=\"{{\'adminLogs\' | translate}}\" ui-sref=\"layout.agreementMain.adminLogs({userId:\'{{data.id}}\',type:\'7\',fakeType: \'16\'})\">{{\'adminLogs\' | translate}}</a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th class=\"noDataClass text-center\">{{\'noAgreementFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--<nav>--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\" ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div><style>.switch {\n      position: relative;\n      display: inline-block;\n      width: 60px;\n      height: 34px;\n    }\n    \n    .switch input { \n      opacity: 0;\n      width: 0;\n      height: 0;\n    }\n    \n    .slider {\n      position: absolute;\n      cursor: pointer;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background-color: #ccc;\n      -webkit-transition: .4s;\n      transition: .4s;\n    }\n    \n    .slider:before {\n      position: absolute;\n      content: \"\";\n      height: 26px;\n      width: 26px;\n      left: 4px;\n      bottom: 4px;\n      background-color: white;\n      -webkit-transition: .4s;\n      transition: .4s;\n    }\n    \n    input:checked + .slider {\n      background-color: #2196F3;\n    }\n    \n    .trueFlag {\n        background-color: #2196F3;    \n    }\n    .falseFlag {\n        /* background-color: #2196F3;     */\n        \n        background-color: #ccc;\n    }\n    input:focus + .slider {\n      box-shadow: 0 0 1px #2196F3;\n    }\n    \n    input:checked + .slider:before {\n      -webkit-transform: translateX(26px);\n      -ms-transform: translateX(26px);\n      transform: translateX(26px);\n    }\n    \n    /* Rounded sliders */\n    .slider.round {\n      border-radius: 34px;\n    }\n    \n    .slider.round:before {\n      border-radius: 50%;\n    }</style>");
$templateCache.put("app/components/views/agreement/agreementMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/agreement/configureAgreement.html","<h2 class=ng-cloak>{{\'agreementHead\' | translate}} / {{\'agreementEditHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=corporate><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><div class=\"panel with-nav-tabs panel-default\" style=\"margin-bottom: 0px !important\"><div class=panel-heading style=\"background-color: #fff;border-color: #ddd\"><ul class=\"nav nav-tabs\" style=\"border:0 !important\"><li id=tab1 class=TabsBar ng-click=\"vm.forTabsView=1\" ng-class=\"{\'active\': vm.forTabsView == 1}\"><a>Bases de destino</a></li><li id=tab2 class=TabsBar ng-click=\"vm.forTabsView=2;vm.getTypeOfServices()\" ng-class=\"{\'active\':vm.forTabsView == 2}\"><a href=tab2default data-toggle=tab>Tipos de servicio</a></li></ul></div><div class=panel-body><div class=tab-content><div class=\"tab-pane fade in active\"><div class=\"row mt5\" ng-if=\"vm.forTabsView == 1\"><div class=basicDetailsDiv><div class=\"row mt5\" style=margin-left:0px;margin-right:0px><button style=float:right type=button class=\"btn btn-primary\" ng-click=vm.openAddEdit(0)>Agregar</button></div><div ng-if=vm.showAddEdit class=\"row mt5\"><form name=configureAgreementForm ng-submit=\"submit=true;configureAgreementForm.$valid&&vm.onSubmit()\" novalidate autocomplete=off><div class=\"row pb10 plr15\"><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12\"><label>{{\'Depot nid\' | translate}} <span style=color:red>*</span></label><input type=text placeholder=\"{{\'Depot nid\' | translate}}\" ng-model=vm.dataToFill.depot_id class=form-control name=depotId required ng-class=\"{ \'has-error\': configureAgreementForm.depotId.$touched && configureAgreementForm.depotId.$invalid }\"><!--pattern=\"^[a-zA-Z0-9][a-zA-Z0-9\\s]*$\"--><div ng-if=\"configureAgreementForm.depotId.$touched|| submit\" ng-messages=configureAgreementForm.depotId.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'Favor ingrese Depot nid\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid agreement name.</div>--></div></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12\"><label>{{\'Zone bucket\' | translate}} <span style=color:red>*</span></label><input type=text placeholder=\"{{\'Zone bucket\' | translate}}\" ng-model=vm.dataToFill.zone_bucket class=form-control name=zoneBucket required ng-class=\"{ \'has-error\': configureAgreementForm.zoneBucket.$touched && configureAgreementForm.zoneBucket.$invalid }\"><!--pattern=\"^[a-zA-Z0-9][a-zA-Z0-9\\s]*$\"--><div ng-if=\"configureAgreementForm.zoneBucket.$touched|| submit\" ng-messages=configureAgreementForm.zoneBucket.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'Favor ingrese Zone bucket\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid agreement name.</div>--></div></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12\"><label>{{\'Sucursal\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.branch_id name=sucursal required ng-class=\"{ \'has-error\': configureAgreementForm.sucursal.$touched && configureAgreementForm.sucursal.$invalid }\"><option value=\"\" disabled>{{\'Seleccionar Sucursal\' | translate}}</option><option ng-repeat=\"branch in vm.branchesArray\" ng-value=branch.region_id>{{branch.region.region_name}}</option></select><!--<input type=\"text\" placeholder=\"Agreement Type\" ng-model=\"vm.dataToFill.agreementType\" class=\"form-control\" name=\"agreementType\" required  ng-class=\"{ \'has-error\': configureAgreementForm.agreementType.$touched && configureAgreementForm.agreementType.$invalid }\" pattern=\"^[a-zA-Z0-9][a-zA-Z0-9\\s]*$\"/>--><div ng-if=\"configureAgreementForm.sucursal.$touched|| submit\" ng-messages=configureAgreementForm.sucursal.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'Favor seleccione Sucursal\' | translate}}</div></div></div></div><div class=\"row plr15\"><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12\"><label>{{\'Dirección de llegada\' | translate}} <span style=color:red>*</span></label><input type=text placeholder=\"{{\'Dirección de llegada\' | translate}}\" ng-model=vm.dataToFill.address class=form-control name=address required ng-class=\"{ \'has-error\': configureAgreementForm.address.$touched && configureAgreementForm.address.$invalid }\"><!--pattern=\"^[a-zA-Z0-9][a-zA-Z0-9\\s]*$\"--><div ng-if=\"configureAgreementForm.address.$touched|| submit\" ng-messages=configureAgreementForm.address.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'Favor ingrese Dirección de llegada\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid agreement name.</div>--></div></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12\"><label>{{\'Latitud\' | translate}} <span style=color:red>*</span></label><input type=text placeholder=\"{{\'Latitud\' | translate}}\" ng-model=vm.dataToFill.latitude class=form-control name=latitude required ng-class=\"{ \'has-error\': configureAgreementForm.latitude.$touched && configureAgreementForm.latitude.$invalid }\"><!--pattern=\"^[a-zA-Z0-9][a-zA-Z0-9\\s]*$\"--><div ng-if=\"configureAgreementForm.latitude.$touched|| submit\" ng-messages=configureAgreementForm.latitude.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'Favor ingrese Latitud\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid agreement name.</div>--></div></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12\"><label>{{\'Longitud\' | translate}} <span style=color:red>*</span></label><input type=text placeholder=\"{{\'Longitud\' | translate}}\" ng-model=vm.dataToFill.longitude class=form-control name=longitude required ng-class=\"{ \'has-error\': configureAgreementForm.longitude.$touched && configureAgreementForm.longitude.$invalid }\"><!--pattern=\"^[a-zA-Z0-9][a-zA-Z0-9\\s]*$\"--><div ng-if=\"configureAgreementForm.longitude.$touched|| submit\" ng-messages=configureAgreementForm.longitude.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'Favor ingrese Longitud\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid agreement name.</div>--></div></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><button class=\"btn btn-primary\" type=submit>{{\'submit\' | translate}}</button> <button class=\"btn btn-default\" type=button ng-click=vm.closeAddEdit()>{{\'cancelButton\' | translate}}</button></div></div></form></div><div ng-if=!vm.showAddEdit class=\"row mt5\" style=margin-left:0px;margin-right:0px><table class=\"table table-hover tableWithMasterData\"><thead><tr><th style=width:30px>ID</th><th style=width:120px>Sucursal - Depot Nid - Zone Bucket</th><th style=width:70px>Address</th><th style=width:100px>Latitud,Longitud</th><th style=width:70px>Acción</th></tr></thead><tbody ng-if=\"vm.basesArray.length>0\" style=max-height:300px;overflow-y:auto><tr ng-repeat=\"data in vm.basesArray\"><td style=width:30px>{{data.base_id}}</td><td style=width:120px>{{data.region_name+\' - \'+data.depot_id+\' - \'+data.zone_bucket}}</td><td style=width:70px>{{data.address}}</td><td style=width:100px>{{data.latitude+\",\"+data.longitude}}</td><td style=width:70px><a title=\"Edit Details\" class=\"cursor editIconColor btn btn-sm\" ng-click=vm.openAddEdit(1,data)><i class=\"fa fa-edit\"></i> </a><a title=\"Enable Disable\" class=\"cursor editIconColor btn btn-sm\" ng-click=vm.enableDisableDestinationBase($event,data) ng-class=\"{\'blockIconColor\': data.is_active == 0, \'unblockIconColor\': data.is_active == 1}\"><i ng-class=\"{\'fa fa-unlock\': data.is_active == 1,\'fa fa-lock\': data.is_active == 0}\"></i> </a><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteDestinationBase($event,data)><i class=\"fa fa-trash\"></i></a></td></tr></tbody></table></div></div></div><div class=\"row mt5\" ng-if=\"vm.forTabsView == 2\"><p class=m15 style=\"margin: 15px!important;color:#9F9F9F\">Tipo de servicio designado a un paquete de reservas según cantidad total de pasajeros del paquete</p><div class=\"row mt5\" style=margin-left:0px;margin-right:0px><form name=updateServicesForm ng-submit=\"submit=true;updateServicesForm.$valid&&vm.onServicesSubmit()\" novalidate autocomplete=off><table class=\"table table-hover tableWithMasterData\"><thead><tr><th style=width:30px>ID</th><th style=width:80px>Servicio</th><th style=width:40px>Mínimo</th><th style=width:40px>Máximo</th></tr></thead><tbody ng-if=\"vm.contractServicesArray.length>0\" style=max-height:300px;overflow-y:auto><tr ng-repeat=\"service in vm.contractServicesArray\"><td style=width:30px>{{service.type_of_service_id}}</td><td style=width:80px>{{service.service_name}}</td><td style=width:40px><input type=number min=0 placeholder=\"{{\'Mínimo de pasajeros\'}}\" ng-model=service.min_passengers class=form-control name=service.service_name required ng-class=\"{ \'has-error\': updateServicesForm.service.service_name.$touched && updateServicesForm.service.service_name.$invalid }\"></td><td style=width:40px><input type=number min=0 placeholder=\"{{\'Máximo de pasajeros\'}}\" ng-model=service.max_passengers class=form-control name=service.service_name required ng-class=\"{ \'has-error\': updateServicesForm.service.service_name.$touched && updateServicesForm.service.service_name.$invalid }\"></td></tr></tbody></table><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-right plr30\"><button class=\"btn btn-primary\" type=submit>{{\'submit\' | translate}}</button> <button class=\"btn btn-default\" type=reset>{{\'cancelButton\' | translate}}</button></div></div></form></div></div></div></div></div></div></div></div></div></div></div></div><style>.nav-tabs > li > a{\n        border-radius: 0px !important;\n        margin: 0px !important;\n        color: #ff5200 !important;\n        background: #F5F5F5;\n        border: 1px solid #cdcdcd !important;\n    }\n    .nav-tabs > li.active{\n        background: #FFFFFF !important;\n        border: 1px solid #ff5200 !important;\n    }\n    .nav-tabs > li.active > a{\n        border: 0 !important;\n    }\n    .nav-tabs > li > a:hover{\n        color: white !important;\n        background-color: #ff5100 !important;\n    }\n    .panel-heading{\n        border: 0px !important;\n    }\n    .plr30{\n        padding-left: 30px !important;\n        padding-right: 30px !important;\n    }</style>");
$templateCache.put("app/components/views/agreement/editAgreement.html","<h2 class=ng-cloak>{{\'agreementHead\' | translate}} / {{\'agreementEditHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=corporate><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'enterDetailsHead\' | translate}}</p><div class=basicDetailsDiv><form name=editAgreementForm ng-submit=\"submit=true;editAgreementForm.$valid&&vm.editAgreementApi()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'agreNameLabel\' | translate}} <span style=color:red>*</span></label><input type=text placeholder=\"{{\'agreNameLabel\' | translate}}\" ng-model=vm.dataToFill.agreementName class=form-control name=agreementName required ng-class=\"{ \'has-error\': editAgreementForm.agreementName.$touched && editAgreementForm.agreementName.$invalid }\"><!--pattern=\"^[a-zA-Z0-9][a-zA-Z0-9\\s]*$\"--><div ng-if=\"editAgreementForm.agreementName.$touched|| submit\" ng-messages=editAgreementForm.agreementName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'agreNameReq\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid agreement name.</div>--></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'agreTypeLabel\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.agreementType name=agreementType required ng-class=\"{ \'has-error\': editAgreementForm.agreementType.$touched && editAgreementForm.agreementType.$invalid }\"><option value=\"\" disabled selected>{{\'agreTypePlaceholder\' | translate}}</option><option value=SPOT>Spot</option><option value=CORPORATE>Corporate</option></select><!--<input type=\"text\" placeholder=\"Agreement Type\" ng-model=\"vm.dataToFill.agreementType\" class=\"form-control\" name=\"agreementType\" required  ng-class=\"{ \'has-error\': editAgreementForm.agreementType.$touched && editAgreementForm.agreementType.$invalid }\" pattern=\"^[a-zA-Z0-9][a-zA-Z0-9\\s]*$\"/>--><div ng-if=\"editAgreementForm.agreementType.$touched|| submit\" ng-messages=editAgreementForm.agreementType.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'agreTypeReq\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'validSdateLabel\' | translate}} <span style=color:red>*</span></label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=startValidity ng-model=vm.dataToFill.startDate placeholder=\"{{\'validSdateLabel\' | translate}}\" is-open=vm.datePicker_1.start datepicker-options=vm.dateOptions required ng-class=\"{ \'has-error\': editAgreementForm.startValidity.$touched && editAgreementForm.startValidity.$invalid }\" close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'1\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"editAgreementForm.startValidity.$touched|| submit\" ng-messages=editAgreementForm.startValidity.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'validSdateReq\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'validEdateLabel\' | translate}} <span style=color:red>*</span></label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=endValidity ng-model=vm.dataToFill.endDate placeholder=\"{{\'validEdateLabel\' | translate}}\" is-open=vm.datePicker_1.end datepicker-options=vm.dateOptions required ng-class=\"{ \'has-error\': editAgreementForm.endValidity.$touched && editAgreementForm.endValidity.$invalid }\" close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'2\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"editAgreementForm.endValidity.$touched|| submit\" ng-messages=editAgreementForm.endValidity.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'promoEndReq\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'corporateLabel\' | translate}} <span style=color:red>*</span></label><ui-select ng-model=vm.dataToFill.corporateName name=corporateName required ng-class=\"{ \'has-error\': editAgreementForm.corporateName.$touched && editAgreementForm.corporateName.$invalid }\" close-on-select=true><ui-select-match placeholder=\"{{\'corporatePlaceholder\' | translate}}\">{{$select.selected.company_name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in vm.corporatesList | filter: $select.search | orderBy:\'company_name\'\"><div ng-bind-html=data.company_name></div></ui-select-choices></ui-select><!--<select class=\"form-control\" ng-model=\"vm.dataToFill.corporateName\" ng-options=\"data.id as data.company_name for data in vm.corporatesList | orderBy:\'company_name\'\"--><!--name=\"corporateName\" required  ng-class=\"{ \'has-error\': editAgreementForm.corporateName.$touched && editAgreementForm.corporateName.$invalid }\">--><!--<option value=\"\" disabled selected>Select Corporate Name</option>--><!--</select>--><div ng-if=\"editAgreementForm.corporateName.$touched|| submit\" ng-messages=editAgreementForm.corporateName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'corpoNameReq\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'serviceLabel\' | translate}} <span style=color:red>*</span></label><ui-select multiple ng-model=vm.dataToFill.typeOfService theme=bootstrap close-on-select=false title=\"Select Type Of Services\" required name=typeOfService ng-class=\"{ \'has-error\': editAgreementForm.typeOfService.$touched && editAgreementForm.typeOfService.$invalid }\"><ui-select-match placeholder=\"{{\'selectTService\' | translate}}\">{{$item.service_name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in vm.servicesList | filter:$select.search\">{{data.service_name}}</ui-select-choices></ui-select><!--<select class=\"form-control\" ng-model=\"vm.dataToFill.typeOfService\" ng-options=\"data.id as data.service_name for data in vm.servicesList\"--><!--name=\"typeOfService\" required  ng-class=\"{ \'has-error\': editAgreementForm.typeOfService.$touched && editAgreementForm.typeOfService.$invalid }\">--><!--<option value=\"\" disabled selected>Select Type of Service</option>--><!--</select>--><div ng-if=\"editAgreementForm.typeOfService.$touched|| submit\" ng-messages=editAgreementForm.typeOfService.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'serviceReq\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'noShowChargeLabel\' | translate}} <span style=color:red>*</span></label><input type=text placeholder=\"{{\'noShowChargeLabel\' | translate}}\" class=form-control ng-model=vm.dataToFill.noShowCharges maxlength=5 is-number name=noShowCharges required ng-class=\"{ \'has-error\': editAgreementForm.noShowCharges.$touched && editAgreementForm.noShowCharges.$invalid }\" pattern=^[0-9][0-9]*$><div ng-if=\"editAgreementForm.noShowCharges.$touched|| submit\" ng-messages=editAgreementForm.noShowCharges.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'noShowChargeReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'noShowChargeValid\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'maxWaitTimeLabel\' | translate}} <span style=color:red>*</span></label><input type=text placeholder=\"{{\'maxWaitTimeTolerance\' | translate}}\" class=form-control name=waitTolerance ng-model=vm.dataToFill.waitTolerance maxlength=3 is-number required ng-class=\"{ \'has-error\': editAgreementForm.waitTolerance.$touched && editAgreementForm.waitTolerance.$invalid }\" pattern=^[0-9][0-9]*$><div ng-if=\"editAgreementForm.waitTolerance.$touched|| submit\" ng-messages=editAgreementForm.waitTolerance.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'maxWaitTimeReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'maxWaitTimeValid\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'maxWaitTimeFLabel\' | translate}} <span style=color:red>*</span></label><input type=text placeholder=\"{{\'maxWaitTimeFree\' | translate}}\" class=form-control name=waitTimeFree ng-model=vm.dataToFill.waitTimeFree maxlength=3 is-number required ng-class=\"{ \'has-error\': editAgreementForm.waitTimeFree.$touched && editAgreementForm.waitTimeFree.$invalid }\" pattern=^[0-9][0-9]*$><div ng-if=\"editAgreementForm.waitTimeFree.$touched|| submit\" ng-messages=editAgreementForm.waitTimeFree.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'maxWaitTimeFReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'maxWaitTimeFValid\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'maxWaitTimeFRLabel\' | translate}} <span style=color:red>*</span></label><input type=text placeholder=\"{{\'maxWaitTimeFRLabel\' | translate}}\" class=form-control name=waitRoute ng-model=vm.dataToFill.waitRoute required maxlength=3 is-number ng-class=\"{ \'has-error\': editAgreementForm.waitRoute.$touched && editAgreementForm.waitRoute.$invalid }\" pattern=^[0-9][0-9]*$><div ng-if=\"editAgreementForm.waitRoute.$touched|| submit\" ng-messages=editAgreementForm.waitRoute.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'maxWaitTimeFRReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'maxWaitTimeFRValid\' | translate}}</div></div></div></div><div class=\"row mt5\"><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label>Base Fare Discount (in %)<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" placeholder=\"Base Fare Discount\" class=\"form-control\" name=\"baseFareDiscount\" ng-model=\"vm.dataToFill.baseFareDiscount\" maxlength=\"3\" is-number required  ng-class=\"{ \'has-error\': editAgreementForm.baseFareDiscount.$touched && editAgreementForm.baseFareDiscount.$invalid }\" pattern=\"^[0-9][0-9]*$\"/>--><!--<div ng-if=\"editAgreementForm.baseFareDiscount.$touched|| submit\" ng-messages=\"editAgreementForm.baseFareDiscount.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter base fare discount.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid base fare discount.</div>--><!--</div>--><!--</div>--><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'comeclass\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.commercialClassification name=commercialClassification required ng-class=\"{ \'has-error\': editAgreementForm.commercialClassification.$touched && editAgreementForm.commercialClassification.$invalid }\"><option value=\"\" disabled selected>{{\'comeclassPlace\' | translate}}</option><option value=GOLD>Gold</option><option value=SILVER>Silver</option><option value=BRONZE>Bronze</option></select><!--<input type=\"text\" placeholder=\"Commercial Classification\" class=\"form-control\" name=\"commercialClassification\" ng-model=\"vm.dataToFill.commercialClassification\" required  ng-class=\"{ \'has-error\': editAgreementForm.commercialClassification.$touched && editAgreementForm.commercialClassification.$invalid }\" pattern=\"^[a-zA-Z0-9][a-zA-Z0-9\\s]*$\"/>--><div ng-if=\"editAgreementForm.commercialClassification.$touched|| submit\" ng-messages=editAgreementForm.commercialClassification.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'comeclassReq\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'paymentMethodLabel\' | translate}} <span style=color:red>*</span></label><ui-select multiple ng-model=vm.dataToFill.paymentMethodSelected theme=bootstrap close-on-select=false title=\"Select Payment Method\" required name=paymentMethodAnother ng-class=\"{ \'has-error\': editAgreementForm.paymentMethodAnother.$touched && editAgreementForm.paymentMethodAnother.$invalid }\"><ui-select-match placeholder=\"Metodos de pago\">{{$item.type}}</ui-select-match><ui-select-choices repeat=\"data as data in vm.paymentTypesList | filter: isPaymentSelected | filter:$select.search\">{{data.type}}</ui-select-choices></ui-select><!--<select class=\"form-control\" ng-model=\"vm.dataToFill.payment_method_id\" ng-options=\"data.id as data.type for data in vm.paymentTypesList\"--><!--name=\"paymentMethodAnother\" required  ng-class=\"{ \'has-error\': addAgreementForm.paymentMethodAnother.$touched && addAgreementForm.paymentMethodAnother.$invalid }\">--><!--<option value=\"\" disabled selected>Select Another Payment Method</option>--><!--</select>--><div ng-if=\"editAgreementForm.paymentMethodAnother.$touched|| submit\" ng-messages=editAgreementForm.paymentMethodAnother.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'paymentReq\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'defaultPaymentLabel\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.paymentMethod ng-options=\"data.id as data.type for data in vm.dataToFill.paymentMethodSelected\" name=paymentMethod required ng-class=\"{ \'has-error\': editAgreementForm.paymentMethod.$touched && editAgreementForm.paymentMethod.$invalid }\"><option value=\"\" disabled selected>{{\'paymentSelect\' | translate}}</option></select><div ng-if=\"editAgreementForm.paymentMethod.$touched|| submit\" ng-messages=editAgreementForm.paymentMethod.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'paymentReq\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'branchLabel\' | translate}} <span style=color:red>*</span></label><ui-select multiple ng-model=vm.dataToFill.branch theme=bootstrap close-on-select=false title=\"Select Branch\" required name=branch ng-class=\"{ \'has-error\': editAgreementForm.branch.$touched && editAgreementForm.branch.$invalid }\"><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$item.region_name}}</ui-select-match><ui-select-choices repeat=\"data.region_id as data in vm.branchList | filter:$select.search\">{{data.region_name}}</ui-select-choices></ui-select><!--<select class=\"form-control\" ng-model=\"vm.dataToFill.typeOfService\" ng-options=\"data.id as data.service_name for data in vm.servicesList\"--><!--name=\"typeOfService\" required  ng-class=\"{ \'has-error\': addAgreementForm.typeOfService.$touched && addAgreementForm.typeOfService.$invalid }\">--><!--<option value=\"\" disabled selected>Select Type of Service</option>--><!--</select>--><div ng-if=\"editAgreementForm.branch.$touched|| submit\" ng-messages=editAgreementForm.branch.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'branchR\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'virtualFleetLabel\' | translate}}</label><input type=text placeholder=\"{{\'virtualFleetLabel\' | translate}}\" class=form-control name=virtualFleet ng-model=vm.dataToFill.virtualFleet ng-class=\"{ \'has-error\': editAgreementForm.virtualFleet.$touched && editAgreementForm.virtualFleet.$invalid }\" pattern=^[0-9][0-9]*$ maxlength=3><div ng-if=\"editAgreementForm.virtualFleet.$touched|| submit\" ng-messages=editAgreementForm.virtualFleet.$error><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter virtual fleet.</div>--><div class=\"errormessage text-danger\" ng-message=pattern>{{\'virtualFleetValid\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'emailAdmins\' | translate}}</label><input type=text placeholder=\"{{\'emailAdmins\' | translate}}\" class=form-control name=emailAdministrator ng-model=vm.dataToFill.emailAdministrator ng-class=\"{ \'has-error\': editAgreementForm.emailAdministrator.$touched && editAgreementForm.emailAdministrator.$invalid }\" pattern=^([_a-zA-Z0-9-+]+)(\\.[_a-zA-Z0-9-+]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*\\.)+([a-zA-Z]{2,3})$><div ng-if=\"editAgreementForm.emailAdministrator.$touched|| submit\" ng-messages=editAgreementForm.emailAdministrator.$error><div class=\"errormessage text-danger\" ng-message=pattern>{{\'validEmail\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'strictEndowment\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.employeeEndowment name=employeeEndowment ng-class=\"{ \'has-error\': editAgreementForm.employeeEndowment.$touched && editAgreementForm.employeeEndowment.$invalid }\"><option value=\"\" selected disabled>{{\'selectEndowment\' | translate}}</option><option value=1>Yes</option><option value=0>No</option></select><div ng-if=\"editAgreementForm.employeeEndowment.$touched|| submit\" ng-messages=editAgreementForm.employeeEndowment.$error><div class=\"errormessage text-danger\" ng-message=pattern>{{\'selectEndowment\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>Factor QTH <span style=color:red>*</span></label><div class=displayFlex><input type=text placeholder=\"Factor QTH\" style=width:35% class=form-control name=qthFactor ng-model=vm.dataToFill.qthFactor required ng-class=\"{ \'has-error\': addAgreementForm.qthFactor.$touched && addAgreementForm.qthFactor.$invalid }\" is-number=\"\"> <span style=\"padding-left: 10px;font-size: 13px;color: #888;word-break: break-word\">Usado para calcular tarifa en servicios agrupados</span></div><div ng-if=\"addAgreementForm.qthFactor.$touched|| submit\" ng-messages=addAgreementForm.qthFactor.$error><div class=\"errormessage text-danger\" ng-message=required>Please enter factor QTH.</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>Descuento de ida y vuelta <span style=color:red>*</span></label><input type=text placeholder=\"Descuento de ida y vuelta\" required is-number=\"\" class=form-control name=roundTripDiscount ng-model=vm.dataToFill.roundTripDiscount ng-class=\"{ \'has-error\': editAgreementForm.roundTripDiscount.$touched && editAgreementForm.roundTripDiscount.$invalid }\"><div ng-if=\"editAgreementForm.roundTripDiscount.$touched|| submit\" ng-messages=editAgreementForm.roundTripDiscount.$error><div class=\"errormessage text-danger\" ng-message=required>Ingrese el descuento de ida y vuelta</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>Descuento por correo electrónico WebPay / URL <span style=color:red>*</span></label><input type=text placeholder=\"Descuento por correo electrónico WebPay / URL\" is-number=\"\" required class=form-control name=webPayDiscount ng-model=vm.dataToFill.webPayDiscount ng-class=\"{ \'has-error\': editAgreementForm.webPayDiscount.$touched && editAgreementForm.webPayDiscount.$invalid }\"><div ng-if=\"editAgreementForm.webPayDiscount.$touched|| submit\" ng-messages=editAgreementForm.webPayDiscount.$error><div class=\"errormessage text-danger\" ng-message=required>Ingrese el descuento de webpay / URL</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" style=\"padding-top: 20px\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">Direcciones Favoritas</p><div class=basicDetailsDiv><div class=\"row mt5\" style=margin-left:0px;margin-right:0px><button style=float:right type=button class=\"btn btn-primary\" ng-click=vm.openPopUpForEdit($event,editAgreementForm)>Agregar</button></div><div class=\"row mt5\" style=margin-left:0px;margin-right:0px><table class=\"table table-hover tableWithMasterData\"><thead><tr><th style=width:70px>Nombre</th><th style=width:70px>Direccion</th><th style=width:70px>Action</th></tr></thead><tbody ng-if=\"vm.addressArray.length>0\" style=max-height:300px;overflow-y:auto when-scrolled=vm.onScrollAddressBody()><tr ng-repeat=\"data in filtered = vm.addressArray\"><td style=width:70px>{{data.address_nick_name}}</td><td style=width:70px>{{data.address_location}}</td><td style=width:70px><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteAddress(data,$event)><i class=\"fa fa-trash\"></i></a></td></tr></tbody></table></div></div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>Umbral Agrupación <span style=color:red>*</span></label><input type=text placeholder=\"Grouping threshold\" is-number=\"\" required class=form-control ng-disabled=!vm.dataToFill.groupServices name=groupThreshold ng-model=vm.dataToFill.groupThreshold ng-class=\"{ \'has-error\': editAgreementForm.groupThreshold.$touched && editAgreementForm.groupThreshold.$invalid }\"><div ng-if=\"editAgreementForm.groupThreshold.$touched|| submit\" ng-messages=editAgreementForm.groupThreshold.$error><div class=\"errormessage text-danger\" ng-message=required>Umbral Agrupación is Required</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=vm.dataToFill.apply_qr_p><label>Cant. mins envío anticipado de SMS <span style=color:red>*</span></label><div class=displayFlex><input type=text placeholder=\"Minutos de envío sms previo a reserva\" style=width:35% is-number=\"\" required class=form-control name=sms_minutes_qr_p ng-model=vm.dataToFill.sms_minutes_qr_p ng-class=\"{ \'has-error\': editAgreementForm.sms_minutes_qr_p.$touched && editAgreementForm.sms_minutes_qr_p.$invalid }\"> <span style=\"padding-left: 10px;font-size: 13px;color: #888;word-break: break-word\">Define cuanto tiempo antes de la hora de retiro se envía el SMS con QR para servicio Punto a Punto.</span></div><div ng-if=\"editAgreementForm.sms_minutes_qr_p.$touched|| submit\" ng-messages=editAgreementForm.sms_minutes_qr_p.$error><div class=\"errormessage text-danger\" ng-message=required>Cant. mins envío anticipado de SMS is Required</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>Configuración agrupación automática</label><div class=displayFlex><button style=float:right type=button class=\"btn btn-primary\" ng-click=vm.redirectToConfigure($event,editAgreementForm)>Configurar</button></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label>{{\'comments\' | translate}}</label><textarea style=height:100px placeholder=\"{{\'messagePlaceholder\' | translate}}\" ng-model=vm.dataToFill.comments class=form-control name=comments ng-class=\"{ \'has-error\': editAgreementForm.comments.$touched && editAgreementForm.comments.$invalid }\"></textarea><div ng-if=\"editAgreementForm.comments.$touched|| submit\" ng-messages=editAgreementForm.comments.$error><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter comments.</div>--></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Allow to mixed shared services:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'SHARED_SERVICES\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.sharedServices , \'fa fa-toggle-off\': !vm.dataToFill.sharedServices}\"></i></div></div></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Allow group services:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'GROUP_SERVICES\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.groupServices , \'fa fa-toggle-off\': !vm.dataToFill.groupServices}\"></i></div></div></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Agrupación External:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'GROUP_EXTERNAL\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.groupExternal , \'fa fa-toggle-off\': !vm.dataToFill.groupExternal}\"></i></div></div></td></tr></tbody></table></div></div><div class=\"row mt5\" ng-if=vm.dataToFill.groupServices><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Cobrar por ruta completa:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'charge_Full_Path\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.chargeFullPath , \'fa fa-toggle-off\': !vm.dataToFill.chargeFullPath}\"></i></div></div></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Cobrar por cada reserva:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'charge_Each_Reservation\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.chargeEachReservation , \'fa fa-toggle-off\': !vm.dataToFill.chargeEachReservation}\"></i></div></div></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Activar agrupación automática:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'AUTOMATIC_GROUPING\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.automaticGrouping , \'fa fa-toggle-off\': !vm.dataToFill.automaticGrouping}\"></i></div></div></td></tr></tbody></table></div></div><div class=\"row mt5\" ng-if=vm.dataToFill.groupServices><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>SMS de agrupación a pasajero:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'sms_to_passenger_on_grouping\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.smsToPass , \'fa fa-toggle-off\': !vm.dataToFill.smsToPass}\"></i></div></div></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>SMS de agrupación a solicitante:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'sms_to_applicant_on_grouping\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.smsToAppl , \'fa fa-toggle-off\': !vm.dataToFill.smsToAppl}\"></i></div></div></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Email de agrupación a pasajero:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'email_to_passenger_on_grouping\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.emailToPass , \'fa fa-toggle-off\': !vm.dataToFill.emailToPass}\"></i></div></div></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Email de agrupación a solicitante:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'email_to_applicant_on_grouping\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.emailToAppl , \'fa fa-toggle-off\': !vm.dataToFill.emailToAppl}\"></i></div></div></td></tr></tbody></table></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Apply Via Controlled:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'CONTROLLED_WAY\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.controlledWay , \'fa fa-toggle-off\': !vm.dataToFill.controlledWay}\"></i></div></div></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Mostrar Items Vía Controlada en Voucher:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'VIA_CONTROLLED\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.viaControlled , \'fa fa-toggle-off\': !vm.dataToFill.viaControlled}\"></i></div></div></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Vía Controlada incluida en la Tarifa:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'VIA_CONTROLLED_TARIFA\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.viaControlledTarifa , \'fa fa-toggle-off\': !vm.dataToFill.viaControlledTarifa}\"></i></div></div></td></tr></tbody></table></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Habilitar Tarifa Variable<br>por Geocerca:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'ENABLE_VARIBLE_RATE\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.enableVaribleRate , \'fa fa-toggle-off\': !vm.dataToFill.enableVaribleRate}\"></i></div></div></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>{{\'enable_sms_parcels\' | translate}}:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'ENABLE_SMS\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.enableSMS , \'fa fa-toggle-off\': !vm.dataToFill.enableSMS}\"></i></div></div></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Restringir por flota:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'restriccion_flota\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.restriccion_flota , \'fa fa-toggle-off\': !vm.dataToFill.restriccion_flota}\"></i></div></div></td></tr></tbody></table></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>{{\'applyTagCollection\' | translate}}:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'APPLY_CHARGE\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.applyCharge , \'fa fa-toggle-off\': !vm.dataToFill.applyCharge}\"></i></div></div></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>{{\'calculateVariableRateUsingEstimatedDistance\' | translate}}:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'APPLY_ESTIMATED_FARE\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.applyEstimatedFare , \'fa fa-toggle-off\': !vm.dataToFill.applyEstimatedFare}\"></i></div></div><p class=optionDeactivatedNote>{{\'optionDeactivatedNote\' | translate}}</p></td></tr></tbody></table></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean><div class=displayFlex ng-class=\"{\'disableSubmit\': !vm.dataToFill.applyCharge}\"><div style=padding-top:10px>{{\'collectEstimatedTag\' | translate}}:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'COLLECT_ESTIMATED_TAG\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.collectEstimatedTag, \'fa fa-toggle-off\': !vm.dataToFill.collectEstimatedTag}\"></i></div></div><p class=optionDeactivatedNote>{{\'whenDeactivatedToll\' | translate}}</p></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>{{\'aplicarQrPuntoApunto\' | translate}}:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'APPLY_QR_P\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.apply_qr_p, \'fa fa-toggle-off\': !vm.dataToFill.apply_qr_p}\"></i></div></div></td></tr></tbody></table></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>{{\'applyChargeForEstimatedTravelTime\' | translate}}:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'APPLY_REAL_TIME_TRAVEL\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.charge_for_estimated_travel_time, \'fa fa-toggle-off\': !vm.dataToFill.charge_for_estimated_travel_time}\"></i></div></div><p class=optionDeactivatedNote>{{\'applyRealTimeTravel\' | translate}}</p></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>{{\'disableSmsCustomer\' | translate}}:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'DISABLE_SMS_CUSTOMER\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.disable_sms_customer, \'fa fa-toggle-off\': !vm.dataToFill.disable_sms_customer}\"></i></div></div></td></tr></tbody></table></div></div><!--<div class=\"row mt5\" style=\"margin-left: 0px;margin-right: 0px;\">--><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"padding:0px;\">--><!--<p class=\"basicRegistrationP backgroundBasicPending text-center\">Employee Details</p>--><!--</div>--><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"border:1px solid #dedede;\" ng-repeat=\"employeeData in vm.dataToFill.employeeData\">--><!--<div class=\"row mt5\">--><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-right\">--><!--<a class=\"btn btn-sm blockIconColor\" title=\"Delete Employeee\" ng-click=\"vm.deleteEmployee($index)\" style=\"border: 1px solid red;margin-left:5px;\" ng-if=\"vm.dataToFill.employeeData.length > 1\">--><!--<i class=\"fa fa-trash\"></i>--><!--</a>--><!--<a class=\"btn btn-sm editIconColor\" ng-click=\"vm.addEmployee($index)\" title=\"Add Employee\" style=\"border: 1px solid #7266ba;margin-left:5px;\">--><!--<i class=\"fa fa-plus\"></i>--><!--</a>--><!--</div>--><!--<div class=\"col-lg-6 col-ms-6 col-md-6 col-xs-12\">--><!--<label>Employee Name<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" placeholder=\"Employee Name\" class=\"form-control\" ng-model=\"employeeData.name\" name=\"employeeName{{$index}}\" required  ng-class=\"{ \'has-error\': editAgreementForm[\'employeeName\'+$index].$touched && editAgreementForm[\'employeeName\'+$index].$invalid }\" pattern=\"^[a-zA-Z0-9][a-zA-Z0-9\\s]*$\"/>--><!--<div ng-if=\"editAgreementForm[\'employeeName\'+$index].$touched|| submit\" ng-messages=\"editAgreementForm[\'employeeName\'+$index].$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter employee name.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid employee name.</div>--><!--</div>--><!--</div>--><!--<div class=\"col-lg-6 col-ms-6 col-md-6 col-xs-12 \">--><!--<label>Employee RUT<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" placeholder=\"Employee RUT\" ng-rut ng-change=\"vm.rutChange($index)\" ng-model=\"employeeData.RUT\" class=\"form-control\" name=\"employeeRut{{$index}}\" required  ng-class=\"{ \'has-error\': editAgreementForm[\'employeeRut\'+$index].$touched && editAgreementForm[\'employeeRut\'+$index].$invalid }\"/>--><!--<div ng-if=\"editAgreementForm[\'employeeRut\'+$index].$touched|| submit\" ng-messages=\"editAgreementForm[\'employeeRut\'+$index].$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter employee RUT.</div>--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-show=\"employeeData.rutFlag\">Please enter a valid employee RUT.</div>--><!--</div>--><!--</div>--><!--<div class=\"row mt5\">--><!--<div class=\"col-lg-6 col-ms-6 col-md-6 col-xs-12 \">--><!--<label>Employee Email<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" placeholder=\"Employee Email\" ng-model=\"employeeData.email\" class=\"form-control\" name=\"employeeEmail{{$index}}\" required--><!--ng-class=\"{ \'has-error\': addAgreementForm[\'employeeEmail\'+$index].$touched && addAgreementForm[\'employeeEmail\'+$index].$invalid }\" pattern=\"^([_a-zA-Z0-9-+]+)(\\.[_a-zA-Z0-9-+]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*\\.)+([a-zA-Z]{2,3})$\"/>--><!--<div ng-if=\"addAgreementForm[\'employeeEmail\'+$index].$touched|| submit\" ng-messages=\"addAgreementForm[\'employeeEmail\'+$index].$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter employee email.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid employee email.</div>--><!--</div>--><!--</div>--><!--</div>--><!--<div class=\"row mt5\">--><!--<div class=\"col-lg-12 col-ms-12 col-md-12 col-xs-12 table-responsive mt5\">--><!--<table class=\"table\">--><!--<tbody>--><!--<tr>--><!--<td class=\"headingBollean\">Third Booking</td>--><!--<td class=\"boleeanTypeColor\"><i ng-click=\"vm.setBooleanEmployee(\'THIRD_BOOKING\',$index)\" ng-class=\"{\'fa fa-toggle-on\': employeeData.thirdBooking , \'fa fa-toggle-off\': !employeeData.thirdBooking}\"></i></td>--><!--</tr>--><!--<tr>--><!--<td class=\"headingBollean\">Approval Required</td>--><!--<td class=\"boleeanTypeColor\"><i ng-click=\"vm.setBooleanEmployee(\'APPROVAL_REQUIRED\',$index)\" ng-class=\"{\'fa fa-toggle-on\': employeeData.approval_required , \'fa fa-toggle-off\': !employeeData.approval_required}\"></i></td>--><!--</tr>--><!--</tbody>--><!--</table>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><div class=\"row mt25\" style=\"margin-left: 0px;margin-right: 0px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=padding:0px><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'otherDetails\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean>{{\'fareToCust\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'FARE_TO_CUSTOMER\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.fareToCustomer , \'fa fa-toggle-off\': !vm.dataToFill.fareToCustomer}\"></i></td></tr><tr><td class=headingBollean>{{\'fareToDriver\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'FARE_TO_DRIVER\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.fareToDriver , \'fa fa-toggle-off\': !vm.dataToFill.fareToDriver}\"></i></td></tr><tr><td class=headingBollean>{{\'roundTripWaitTime\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'ROUND_TRIP_WAIT_TIME\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.roundTripWaitTime , \'fa fa-toggle-off\': !vm.dataToFill.roundTripWaitTime}\"></i></td></tr><tr><td class=headingBollean>Monitoring Services</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'Monitoring_Services\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.monitoringServices , \'fa fa-toggle-off\': !vm.dataToFill.monitoringServices}\"></i></td></tr><tr><td colspan=2><label class=control-label>Voucher para pasajero:</label><br><br></td></tr><tr><td class=headingBollean>Al Crear Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'crear_reserva\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.crearReserva , \'fa fa-toggle-off\': !vm.dataToFill.crearReserva}\"></i></td></tr><tr><td class=headingBollean>Al Finalizar Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'finalizar_reserva\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.finalizarReserva , \'fa fa-toggle-off\': !vm.dataToFill.finalizarReserva}\"></i></td></tr><tr><td class=headingBollean>Para Calificar al Conductor</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'para_calificar_conductor\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.paraCalificarConductor , \'fa fa-toggle-off\': !vm.dataToFill.paraCalificarConductor}\"></i></td></tr><tr><td class=headingBollean>Al Anular Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'anular_reserva\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.anularReserva , \'fa fa-toggle-off\': !vm.dataToFill.anularReserva}\"></i></td></tr><tr><td class=headingBollean>Al marcar Reserva NoShow</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'marcar_reserva\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.marcarReserva , \'fa fa-toggle-off\': !vm.dataToFill.marcarReserva}\"></i></td></tr><tr><td class=headingBollean>Al Retarificar Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'retarificar_reserva\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.retarificarReserva , \'fa fa-toggle-off\': !vm.dataToFill.retarificarReserva}\"></i></td></tr><tr><td colspan=2><label class=control-label>Voucher para Solicitante:</label><br><br></td></tr><tr><td class=headingBollean>Al Crear Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'crear_reserva_solicitante\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.crearReservaSolicitante , \'fa fa-toggle-off\': !vm.dataToFill.crearReservaSolicitante}\"></i></td></tr><tr><td class=headingBollean>Al Finalizar Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'finalizar_reserva_solicitante\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.finalizarReservaSolicitante , \'fa fa-toggle-off\': !vm.dataToFill.finalizarReservaSolicitante}\"></i></td></tr><tr><td class=headingBollean>Para Calificar al Conductor</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'para_calificar_conductor_solicitante\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.paraCalificarConductorSolicitante , \'fa fa-toggle-off\': !vm.dataToFill.paraCalificarConductorSolicitante}\"></i></td></tr><tr><td class=headingBollean>Al Anular Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'anular_reserva_solicitante\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.anularReservaSolicitante , \'fa fa-toggle-off\': !vm.dataToFill.anularReservaSolicitante}\"></i></td></tr><tr><td class=headingBollean>Al marcar Reserva NoShow</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'marcar_reserva_solicitante\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.marcarReservaSolicitante , \'fa fa-toggle-off\': !vm.dataToFill.marcarReservaSolicitante}\"></i></td></tr><tr><td class=headingBollean>Al Retarificar Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'retarificar_reserva_solicitante\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.retarificarReservaSolicitante , \'fa fa-toggle-off\': !vm.dataToFill.retarificarReservaSolicitante}\"></i></td></tr><tr><td colspan=2><label class=control-label>Voucher para Administrador del Convenio:</label><br><br></td></tr><tr><td class=headingBollean>Al Crear Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'crear_reserva_administrador\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.crearReservaAdministrador , \'fa fa-toggle-off\': !vm.dataToFill.crearReservaAdministrador}\"></i></td></tr><tr><td class=headingBollean>Al Finalizar Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'finalizar_reserva_administrador\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.finalizarReservaAdministrador , \'fa fa-toggle-off\': !vm.dataToFill.finalizarReservaAdministrador}\"></i></td></tr><tr><td class=headingBollean>Al Anular Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'anular_reserva_administrador\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.anularReservaAdministrador , \'fa fa-toggle-off\': !vm.dataToFill.anularReservaAdministrador}\"></i></td></tr><tr><td class=headingBollean>Al marcar Reserva NoShow</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'marcar_reserva_administrador\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.marcarReservaAdministrador , \'fa fa-toggle-off\': !vm.dataToFill.marcarReservaAdministrador}\"></i></td></tr><tr><td class=headingBollean>Al Retarificar Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'retarificar_reserva_administrador\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.retarificarReservaAdministrador , \'fa fa-toggle-off\': !vm.dataToFill.retarificarReservaAdministrador}\"></i></td></tr></tbody></table></div></div><div class=\"row mt25\" style=\"margin-left: 0px;margin-right: 0px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=padding:0px><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'otherDetails\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean>{{\'authRut\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'AUTHERIZER_RUT\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.authrizerRut , \'fa fa-toggle-off\': !vm.dataToFill.authrizerRut}\"></i></td></tr><!-- <tr>\n                                                    <td class=\"headingBollean\">{{\'vToPassenger\' | translate}}</td>\n                                                    <td class=\"boleeanTypeColor\">\n                                                        <i ng-click=\"vm.setBooleans(\'INVOICE_CUSTOMER\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.invoiceCustomer , \'fa fa-toggle-off\': !vm.dataToFill.invoiceCustomer}\"></i>\n                                                    </td>\n                                                </tr>\n                                                <tr>\n                                                    <td class=\"headingBollean\">{{\'vToApplicant\' | translate}}</td>\n                                                    <td class=\"boleeanTypeColor\">\n                                                        <i ng-click=\"vm.setBooleans(\'INVOICE_APPLICANT\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.invoiceApplicant , \'fa fa-toggle-off\': !vm.dataToFill.invoiceApplicant}\"></i>\n                                                    </td>\n                                                </tr>\n                                                <tr>\n                                                    <td class=\"headingBollean\">{{\'vToAgreAdmin\' | translate}}</td>\n                                                    <td class=\"boleeanTypeColor\">\n                                                        <i ng-click=\"vm.setBooleans(\'INVOICE_CONTACT_PERSON\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.invoiceContactPerson , \'fa fa-toggle-off\': !vm.dataToFill.invoiceContactPerson}\"></i>\n                                                    </td>\n                                                </tr> --><!--<tr>--><!--<td class=\"headingBollean\">Invoice to Contract Person</td>--><!--<td class=\"boleeanTypeColor\"><i ng-click=\"vm.setBooleans(\'INVOICE_CONTRACT_PERSON\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.invoiceContractPerson , \'fa fa-toggle-off\': !vm.dataToFill.invoiceContractPerson}\"></i></td>--><!--</tr>--><!--<tr>--><!--<td class=\"headingBollean\">Invoice to Employee</td>--><!--<td class=\"boleeanTypeColor\"><i ng-click=\"vm.setBooleans(\'INVOICE_EMPLOYEE\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.invoiceEmployee , \'fa fa-toggle-off\': !vm.dataToFill.invoiceEmployee}\"></i></td>--><!--</tr>--><tr><td class=headingBollean>{{\'passengerRut\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'PASSANGER_RUT\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.passengerRut , \'fa fa-toggle-off\': !vm.dataToFill.passengerRut}\"></i></td></tr><tr><td class=headingBollean>{{\'applicantRut\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'APPLICANT_RUT\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.applicantRut , \'fa fa-toggle-off\': !vm.dataToFill.applicantRut}\"></i></td></tr><tr><td class=headingBollean>{{\'costCenter\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'COST_CENTER\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.costCenter , \'fa fa-toggle-off\': !vm.dataToFill.costCenter}\"></i></td></tr><tr><td class=headingBollean>{{\'costSubCenter\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'COST_SUB_CENTER\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.costSubCenter , \'fa fa-toggle-off\': !vm.dataToFill.costSubCenter}\"></i></td></tr><tr><td class=headingBollean>{{\'ROL\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'ROL\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.rol , \'fa fa-toggle-off\': !vm.dataToFill.rol}\"></i></td></tr><tr><td class=headingBollean>{{\'graph\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'GRAPH\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.graph , \'fa fa-toggle-off\': !vm.dataToFill.graph}\"></i></td></tr><tr><td class=headingBollean>{{\'workOrder\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'WORK_ORDER\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.workOrder , \'fa fa-toggle-off\': !vm.dataToFill.workOrder}\"></i></td></tr><tr><td class=headingBollean>{{\'pep\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'PEP\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.pep , \'fa fa-toggle-off\': !vm.dataToFill.pep}\"></i></td></tr><tr><td class=headingBollean>{{\'noOfVoucher\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'NUMBER_VOUCHERS\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.numberVoucher , \'fa fa-toggle-off\': !vm.dataToFill.numberVoucher}\"></i></td></tr><tr><td class=headingBollean>{{\'purOfTrip\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'PURPOSE_TRIP\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.purpouseOfTrip , \'fa fa-toggle-off\': !vm.dataToFill.purpouseOfTrip}\"></i></td></tr><tr><td class=headingBollean>{{\'nomina\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'NOMINA\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.nomina , \'fa fa-toggle-off\': !vm.dataToFill.nomina}\"></i></td></tr><tr><td class=headingBollean>{{\'solicitud\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'SOLICITUDE\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.solicitude , \'fa fa-toggle-off\': !vm.dataToFill.solicitude}\"></i></td></tr><tr><td class=headingBollean>{{\'loadProfile\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'AUTH_LOAD_PROFILE\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.authLoadProfile , \'fa fa-toggle-off\': !vm.dataToFill.authLoadProfile}\"></i></td></tr><tr><td class=headingBollean>{{\'mandtoryAirline\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'Mandatory_Airline\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.airline , \'fa fa-toggle-off\': !vm.dataToFill.airline}\"></i></td></tr><tr><td class=headingBollean>{{\'mandtoryFlight\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'Mandatory_Flight\')\" ng-class=\"{\'fa fa-toggle-on\':   vm.dataToFill.flight , \'fa fa-toggle-off\': !vm.dataToFill.flight}\"></i></td></tr><tr><td class=headingBollean>{{\'mandtoryFlightDate\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'Mandatory_Flight_Date\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.flightDate , \'fa fa-toggle-off\': !vm.dataToFill.flightDate}\"></i></td></tr><tr><td class=headingBollean>{{\'mandtoryFlightType\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'Mandatory_Flight_Type\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.flightType , \'fa fa-toggle-off\': !vm.dataToFill.flightType}\"></i></td></tr><tr><td class=headingBollean>{{\'allowBookingWithoutRequest\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'ALLOW_BOOKINGS_WITHOUT_REQUEST\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.allowBookingWithoutRequest , \'fa fa-toggle-off\': !vm.dataToFill.allowBookingWithoutRequest}\"></i></td></tr><!-- <tr>\n                                                    <td class=\"headingBollean\">{{\'allowChangeFareForPos\' | translate}}</td>\n                                                    <td class=\"boleeanTypeColor\">\n                                                        <i ng-click=\"vm.setBooleans(\'Allow_Change_Fare_POS\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.changeFareForPos , \'fa fa-toggle-off\': !vm.dataToFill.changeFareForPos}\"></i>\n                                                    </td>\n                                                </tr>\n                                                <tr>\n                                                    <td class=\"headingBollean\">{{\'allowChangeFareForCreateBooking\' | translate}}</td>\n                                                    <td class=\"boleeanTypeColor\">\n                                                        <i ng-click=\"vm.setBooleans(\'Allow_Change_Fare_Create_Booking\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.changeFareForCreateBooking , \'fa fa-toggle-off\': !vm.dataToFill.changeFareForCreateBooking}\"></i>\n                                                    </td>\n                                                </tr> --></tbody></table></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><button class=\"btn btn-primary\" type=submit style=width:200px>{{\'submit\' | translate}}</button></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/agreement/newAgreement.html","<h2 class=ng-cloak>{{\'agreementHead\' | translate}} / {{\'newAgreementHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=corporate><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'basicDetails\' | translate}}</p><div class=basicDetailsDiv><form name=addAgreementForm ng-submit=\"submit=true;addAgreementForm.$valid&&vm.addAgreementApi()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'agreNameLabel\' | translate}} <span style=color:red>*</span></label><input type=text placeholder=\"{{\'agreNameLabel\' | translate}}\" ng-model=vm.dataToFill.agreementName class=form-control name=agreementName required ng-class=\"{ \'has-error\': addAgreementForm.agreementName.$touched && addAgreementForm.agreementName.$invalid }\"><!--pattern=\"^[a-zA-Z0-9][a-zA-Z0-9\\s]*$\"--><div ng-if=\"addAgreementForm.agreementName.$touched|| submit\" ng-messages=addAgreementForm.agreementName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'agreNameReq\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid agreement name.</div>--></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'agreTypeLabel\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.agreementType name=agreementType required ng-class=\"{ \'has-error\': addAgreementForm.agreementType.$touched && addAgreementForm.agreementType.$invalid }\"><option value=\"\" disabled selected>{{\'agreTypePlaceholder\' | translate}}</option><option value=SPOT>Spot</option><option value=CORPORATE>Corporate</option></select><!--<input type=\"text\" placeholder=\"Agreement Type\" ng-model=\"vm.dataToFill.agreementType\" class=\"form-control\" name=\"agreementType\" required  ng-class=\"{ \'has-error\': addAgreementForm.agreementType.$touched && addAgreementForm.agreementType.$invalid }\" pattern=\"^[a-zA-Z0-9][a-zA-Z0-9\\s]*$\"/>--><div ng-if=\"addAgreementForm.agreementType.$touched|| submit\" ng-messages=addAgreementForm.agreementType.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'agreTypeReq\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid agreement type.</div>--></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'validSdateLabel\' | translate}} <span style=color:red>*</span></label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=startValidity ng-model=vm.dataToFill.startDate placeholder=\"{{\'validSdateLabel\' | translate}}\" is-open=vm.datePicker_1.start datepicker-options=vm.dateOptions required ng-class=\"{ \'has-error\': addAgreementForm.startValidity.$touched && addAgreementForm.startValidity.$invalid }\" close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'1\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"addAgreementForm.startValidity.$touched|| submit\" ng-messages=addAgreementForm.startValidity.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'promoStartReq\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'validEdateLabel\' | translate}} <span style=color:red>*</span></label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=endValidity ng-model=vm.dataToFill.endDate placeholder=\"{{\'validEdateLabel\' | translate}}\" is-open=vm.datePicker_1.end datepicker-options=vm.dateOptions required ng-class=\"{ \'has-error\': addAgreementForm.endValidity.$touched && addAgreementForm.endValidity.$invalid }\" close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'2\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"addAgreementForm.endValidity.$touched|| submit\" ng-messages=addAgreementForm.endValidity.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'validEdateReq\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'corporateLabel\' | translate}} <span style=color:red>*</span></label><ui-select ng-model=vm.dataToFill.corporateName name=corporateName required ng-class=\"{ \'has-error\': addAgreementForm.corporateName.$touched && addAgreementForm.corporateName.$invalid }\" close-on-select=true><ui-select-match placeholder=\"{{\'corporatePlaceholder\' | translate}}\">{{$select.selected.company_name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in vm.corporatesList | filter: $select.search | orderBy:\'company_name\'\"><div ng-bind-html=data.company_name></div></ui-select-choices></ui-select><!--<select class=\"form-control\" ng-model=\"vm.dataToFill.corporateName\" ng-options=\"data.id as data.company_name for data in vm.corporatesList | orderBy:\'company_name\'\"--><!--name=\"corporateName\" required  ng-class=\"{ \'has-error\': addAgreementForm.corporateName.$touched && addAgreementForm.corporateName.$invalid }\">--><!--<option value=\"\" disabled selected>Select Corporate Name</option>--><!--</select>--><div ng-if=\"addAgreementForm.corporateName.$touched|| submit\" ng-messages=addAgreementForm.corporateName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'corpoNameReq\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'typeServiceHead\' | translate}} <span style=color:red>*</span></label><ui-select multiple ng-model=vm.dataToFill.typeOfService theme=bootstrap close-on-select=false title=\"Select Type Of Services\" required name=typeOfService ng-class=\"{ \'has-error\': addAgreementForm.typeOfService.$touched && addAgreementForm.typeOfService.$invalid }\"><ui-select-match placeholder=\"{{\'selectTService\' | translate}}\">{{$item.service_name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in vm.servicesList | filter:$select.search\">{{data.service_name}}</ui-select-choices></ui-select><!--<select class=\"form-control\" ng-model=\"vm.dataToFill.typeOfService\" ng-options=\"data.id as data.service_name for data in vm.servicesList\"--><!--name=\"typeOfService\" required  ng-class=\"{ \'has-error\': addAgreementForm.typeOfService.$touched && addAgreementForm.typeOfService.$invalid }\">--><!--<option value=\"\" disabled selected>Select Type of Service</option>--><!--</select>--><div ng-if=\"addAgreementForm.typeOfService.$touched|| submit\" ng-messages=addAgreementForm.typeOfService.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'serviceReq\' | translate}}.</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'noShowChargeLabel\' | translate}} <span style=color:red>*</span></label><input type=text placeholder=\"{{\'noShowChargeLabel\' | translate}}\" class=form-control ng-model=vm.dataToFill.noShowCharges maxlength=5 is-number name=noShowCharges required ng-class=\"{ \'has-error\': addAgreementForm.noShowCharges.$touched && addAgreementForm.noShowCharges.$invalid }\" pattern=^[0-9][0-9]*$><div ng-if=\"addAgreementForm.noShowCharges.$touched|| submit\" ng-messages=addAgreementForm.noShowCharges.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'noShowChargeReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'noShowChargeValid\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'maxWaitTimeLabel\' | translate}} <span style=color:red>*</span></label><input type=text placeholder=\"{{\'maxWaitTimeTolerance\' | translate}}\" class=form-control name=waitTolerance ng-model=vm.dataToFill.waitTolerance is-number maxlength=3 required ng-class=\"{ \'has-error\': addAgreementForm.waitTolerance.$touched && addAgreementForm.waitTolerance.$invalid }\" pattern=^[0-9][0-9]*$><div ng-if=\"addAgreementForm.waitTolerance.$touched|| submit\" ng-messages=addAgreementForm.waitTolerance.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'maxWaitTimeReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'maxWaitTimeValid\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'maxWaitTimeFLabel\' | translate}} <span style=color:red>*</span></label><input type=text placeholder=\"{{\'maxWaitTimeFree\' | translate}}\" class=form-control name=waitTimeFree ng-model=vm.dataToFill.waitTimeFree is-number maxlength=3 required ng-class=\"{ \'has-error\': addAgreementForm.waitTimeFree.$touched && addAgreementForm.waitTimeFree.$invalid }\" pattern=^[0-9][0-9]*$><div ng-if=\"addAgreementForm.waitTimeFree.$touched|| submit\" ng-messages=addAgreementForm.waitTimeFree.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'maxWaitTimeFReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'maxWaitTimeFValid\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'maxWaitTimeFRLabel\' | translate}} <span style=color:red>*</span></label><input type=text placeholder=\"{{\'maxWaitTimeFRLabel\' | translate}}\" class=form-control name=waitRoute ng-model=vm.dataToFill.waitRoute is-number maxlength=3 required ng-class=\"{ \'has-error\': addAgreementForm.waitRoute.$touched && addAgreementForm.waitRoute.$invalid }\" pattern=^[0-9][0-9]*$><div ng-if=\"addAgreementForm.waitRoute.$touched|| submit\" ng-messages=addAgreementForm.waitRoute.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'maxWaitTimeFRReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'maxWaitTimeFRValid\' | translate}}</div></div></div></div><div class=\"row mt5\"><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label>Base Fare Discount (in %)<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" placeholder=\"Base Fare Discount\" class=\"form-control\" name=\"baseFareDiscount\" ng-model=\"vm.dataToFill.baseFareDiscount\" is-number maxlength=\"3\" required  ng-class=\"{ \'has-error\': addAgreementForm.baseFareDiscount.$touched && addAgreementForm.baseFareDiscount.$invalid }\" pattern=\"^[0-9][0-9]*$\"/>--><!--<div ng-if=\"addAgreementForm.baseFareDiscount.$touched|| submit\" ng-messages=\"addAgreementForm.baseFareDiscount.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter base fare discount.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid base fare discount.</div>--><!--</div>--><!--</div>--><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'comeclass\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.commercialClassification name=commercialClassification required ng-class=\"{ \'has-error\': addAgreementForm.commercialClassification.$touched && addAgreementForm.commercialClassification.$invalid }\"><option value=\"\" disabled selected>{{\'comeclassPlace\' | translate}}</option><option value=GOLD>Gold</option><option value=SILVER>Silver</option><option value=BRONZE>Bronze</option></select><!--<input type=\"text\" placeholder=\"Commercial Classification\" class=\"form-control\" name=\"commercialClassification\" ng-model=\"vm.dataToFill.commercialClassification\" required  ng-class=\"{ \'has-error\': addAgreementForm.commercialClassification.$touched && addAgreementForm.commercialClassification.$invalid }\" pattern=\"^[a-zA-Z0-9][a-zA-Z0-9\\s]*$\"/>--><div ng-if=\"addAgreementForm.commercialClassification.$touched|| submit\" ng-messages=addAgreementForm.commercialClassification.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'comeclassReq\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid commercial classification.</div>--></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'paymentMethodLabel\' | translate}} <span style=color:red>*</span></label><ui-select multiple ng-model=vm.dataToFill.paymentMethodSelected theme=bootstrap close-on-select=false title=\"Select Payment Method\" on-remove=\"vm.paymentMethodChange(\'1\')\" on-select=\"vm.paymentMethodChange(\'2\')\" required name=paymentMethodAnother ng-class=\"{ \'has-error\': addAgreementForm.paymentMethodAnother.$touched && addAgreementForm.paymentMethodAnother.$invalid }\"><ui-select-match placeholder=\"{{\'paymentSelect\' | translate}}\">{{$item.type}}</ui-select-match><ui-select-choices repeat=\"data as data in vm.paymentTypesList | filter:$select.search\">{{data.type}}</ui-select-choices></ui-select><!--<select class=\"form-control\" ng-model=\"vm.dataToFill.payment_method_id\" ng-options=\"data.id as data.type for data in vm.paymentTypesList\"--><!--name=\"paymentMethodAnother\" required  ng-class=\"{ \'has-error\': addAgreementForm.paymentMethodAnother.$touched && addAgreementForm.paymentMethodAnother.$invalid }\">--><!--<option value=\"\" disabled selected>Select Another Payment Method</option>--><!--</select>--><div ng-if=\"addAgreementForm.paymentMethodAnother.$touched|| submit\" ng-messages=addAgreementForm.paymentMethodAnother.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'paymentReq\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'defaultPaymentLabel\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.paymentMethod ng-options=\"data.id as data.type for data in vm.dataToFill.paymentMethodSelected\" name=paymentMethod required ng-class=\"{ \'has-error\': addAgreementForm.paymentMethod.$touched && addAgreementForm.paymentMethod.$invalid }\"><option value=\"\" disabled selected>{{\'paymentSelect\' | translate}}</option></select><div ng-if=\"addAgreementForm.paymentMethod.$touched|| submit\" ng-messages=addAgreementForm.paymentMethod.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'paymentReq\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'branchLabel\' | translate}} <span style=color:red>*</span></label><ui-select multiple ng-model=vm.dataToFill.branch theme=bootstrap close-on-select=false title=\"Select Branch\" required name=branch ng-class=\"{ \'has-error\': addAgreementForm.branch.$touched && addAgreementForm.branch.$invalid }\"><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$item.region_name}}</ui-select-match><ui-select-choices repeat=\"data.region_id as data in vm.branchList | filter:$select.search\">{{data.region_name}}</ui-select-choices></ui-select><!--<select class=\"form-control\" ng-model=\"vm.dataToFill.typeOfService\" ng-options=\"data.id as data.service_name for data in vm.servicesList\"--><!--name=\"typeOfService\" required  ng-class=\"{ \'has-error\': addAgreementForm.typeOfService.$touched && addAgreementForm.typeOfService.$invalid }\">--><!--<option value=\"\" disabled selected>Select Type of Service</option>--><!--</select>--><div ng-if=\"addAgreementForm.branch.$touched|| submit\" ng-messages=addAgreementForm.branch.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'branchR\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'virtualFleetLabel\' | translate}}</label><input type=text placeholder=\"{{\'virtualFleetLabel\' | translate}}\" class=form-control name=virtualFleet ng-model=vm.dataToFill.virtualFleet ng-class=\"{ \'has-error\': addAgreementForm.virtualFleet.$touched && addAgreementForm.virtualFleet.$invalid }\" pattern=^[0-9][0-9]*$ maxlength=3><div ng-if=\"addAgreementForm.virtualFleet.$touched|| submit\" ng-messages=addAgreementForm.virtualFleet.$error><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter virtual fleet.</div>--><div class=\"errormessage text-danger\" ng-message=pattern>{{\'virtualFleetValid\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'emailAdmins\' | translate}}</label><input type=text placeholder=\"{{\'emailAdmins\' | translate}}\" class=form-control name=emailAdministrator ng-model=vm.dataToFill.emailAdministrator ng-class=\"{ \'has-error\': addAgreementForm.emailAdministrator.$touched && addAgreementForm.emailAdministrator.$invalid }\" pattern=^([_a-zA-Z0-9-+]+)(\\.[_a-zA-Z0-9-+]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*\\.)+([a-zA-Z]{2,3})$><div ng-if=\"addAgreementForm.emailAdministrator.$touched|| submit\" ng-messages=addAgreementForm.emailAdministrator.$error><div class=\"errormessage text-danger\" ng-message=pattern>{{\'validEmail\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'strictEndowment\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.employeeEndowment name=employeeEndowment ng-class=\"{ \'has-error\': addAgreementForm.employeeEndowment.$touched && addAgreementForm.employeeEndowment.$invalid }\"><option value=\"\" selected disabled>{{\'selectEndowment\' | translate}}</option><option value=1>Yes</option><option value=0>No</option></select><div ng-if=\"addAgreementForm.employeeEndowment.$touched|| submit\" ng-messages=addAgreementForm.employeeEndowment.$error><div class=\"errormessage text-danger\" ng-message=pattern>{{\'selectEndowment\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>Factor QTH <span style=color:red>*</span></label><div class=displayFlex><input type=text placeholder=\"Factor QTH\" style=width:35% class=form-control name=qthFactor ng-model=vm.dataToFill.qthFactor required ng-class=\"{ \'has-error\': addAgreementForm.qthFactor.$touched && addAgreementForm.qthFactor.$invalid }\" is-number=\"\"> <span style=\"padding-left: 10px;font-size: 13px;color: #888;word-break: break-word\">Usado para calcular tarifa en servicios agrupados</span></div><div ng-if=\"addAgreementForm.qthFactor.$touched|| submit\" ng-messages=addAgreementForm.qthFactor.$error><div class=\"errormessage text-danger\" ng-message=required>Please enter factor QTH.</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>Descuento de ida y vuelta <span style=color:red>*</span></label><input type=text placeholder=\"Descuento de ida y vuelta\" class=form-control required is-number name=roundTripDiscount ng-model=vm.dataToFill.roundTripDiscount ng-class=\"{ \'has-error\': addAgreementForm.roundTripDiscount.$touched && addAgreementForm.roundTripDiscount.$invalid }\"><div ng-if=\"addAgreementForm.roundTripDiscount.$touched|| submit\" ng-messages=addAgreementForm.roundTripDiscount.$error><div class=\"errormessage text-danger\" ng-message=required>Ingrese el descuento de ida y vuelta</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" style=\"padding-top: 20px\"><label>Descuento por correo electrónico WebPay / URL <span style=color:red>*</span></label><input type=text placeholder=\"Descuento por correo electrónico WebPay / URL\" required class=form-control is-number name=webPayDiscount ng-model=vm.dataToFill.webPayDiscount ng-class=\"{ \'has-error\': addAgreementForm.webPayDiscount.$touched && addAgreementForm.webPayDiscount.$invalid }\"><div ng-if=\"addAgreementForm.webPayDiscount.$touched|| submit\" ng-messages=addAgreementForm.webPayDiscount.$error><div class=\"errormessage text-danger\" ng-message=required>Ingrese el descuento de webpay / URL</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">Direcciones Favoritas</p><div class=basicDetailsDiv><div class=\"row mt5\" style=margin-left:0px;margin-right:0px><button style=float:right type=button class=\"btn btn-primary\" ng-click=vm.openPopUpForAdding($event,addAgreementForm)>Agregar</button></div><div class=\"row mt5\" style=margin-left:0px;margin-right:0px><table class=\"table table-hover tableWithMasterData\"><thead><tr><th style=width:70px>Nombre</th><th style=width:70px>Direccion</th><th style=width:70px>Action</th></tr></thead><tbody ng-if=\"vm.addressArray.length>0\"><tr ng-repeat=\"data in filtered = vm.addressArray\"><td style=width:70px>{{data.address_nick_name}}</td><td style=width:70px>{{data.address_location}}</td><td style=width:70px><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteAddress($index)><i class=\"fa fa-trash\"></i></a></td></tr></tbody></table></div></div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>Umbral Agrupación <span style=color:red>*</span></label><input type=text placeholder=\"Grouping threshold\" is-number=\"\" required class=form-control name=groupThreshold ng-model=vm.dataToFill.groupThreshold ng-disabled=!vm.dataToFill.groupServices ng-class=\"{ \'has-error\': editAgreementForm.groupThreshold.$touched && editAgreementForm.groupThreshold.$invalid }\"><div ng-if=\"editAgreementForm.groupThreshold.$touched|| submit\" ng-messages=editAgreementForm.groupThreshold.$error><div class=\"errormessage text-danger\" ng-message=required>Umbral Agrupación is Required</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=vm.dataToFill.apply_qr_p><label>Cant. mins envío anticipado de SMS <span style=color:red>*</span></label><input type=text placeholder=\"Minutos de envío sms previo a reserva\" is-number=\"\" required class=form-control name=sms_minutes_qr_p ng-model=vm.dataToFill.sms_minutes_qr_p ng-class=\"{ \'has-error\': editAgreementForm.sms_minutes_qr_p.$touched && editAgreementForm.sms_minutes_qr_p.$invalid }\"><div ng-if=\"editAgreementForm.sms_minutes_qr_p.$touched|| submit\" ng-messages=editAgreementForm.sms_minutes_qr_p.$error><div class=\"errormessage text-danger\" ng-message=required>Cant. mins envío anticipado de SMS is Required</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label>{{\'comments\' | translate}}</label><textarea style=height:100px placeholder=\"{{\'messagePlaceholder\' | translate}}\" ng-model=vm.dataToFill.comments class=form-control name=comments ng-class=\"{ \'has-error\': addAgreementForm.comments.$touched && addAgreementForm.comments.$invalid }\"></textarea></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Allow to mixed shared services:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'SHARED_SERVICES\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.sharedServices , \'fa fa-toggle-off\': !vm.dataToFill.sharedServices}\"></i></div></div></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Allow group services:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'GROUP_SERVICES\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.groupServices , \'fa fa-toggle-off\': !vm.dataToFill.groupServices}\"></i></div></div></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Agrupación External:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'GROUP_EXTERNAL\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.groupExternal , \'fa fa-toggle-off\': !vm.dataToFill.groupExternal}\"></i></div></div></td></tr></tbody></table></div></div><div class=\"row mt5\" ng-if=vm.dataToFill.groupServices><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Cobrar por ruta completa:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'charge_Full_Path\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.chargeFullPath , \'fa fa-toggle-off\': !vm.dataToFill.chargeFullPath}\"></i></div></div></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Cobrar por cada reserva:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'charge_Each_Reservation\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.chargeEachReservation , \'fa fa-toggle-off\': !vm.dataToFill.chargeEachReservation}\"></i></div></div></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Activar agrupación automática:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'AUTOMATIC_GROUPING\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.automaticGrouping , \'fa fa-toggle-off\': !vm.dataToFill.automaticGrouping}\"></i></div></div></td></tr></tbody></table></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Apply Via Controlled:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'CONTROLLED_WAY\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.controlledWay , \'fa fa-toggle-off\': !vm.dataToFill.controlledWay}\"></i></div></div></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Mostrar Items Vía Controlada en Voucher:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'VIA_CONTROLLED\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.viaControlled , \'fa fa-toggle-off\': !vm.dataToFill.viaControlled}\"></i></div></div></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Vía Controlada incluida en la Tarifa:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'VIA_CONTROLLED_TARIFA\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.viaControlledTarifa , \'fa fa-toggle-off\': !vm.dataToFill.viaControlledTarifa}\"></i></div></div></td></tr></tbody></table></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Habilitar Tarifa Variable<br>por Geocerca:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'ENABLE_VARIBLE_RATE\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.enableVaribleRate , \'fa fa-toggle-off\': !vm.dataToFill.enableVaribleRate}\"></i></div></div></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>{{\'enable_sms_parcels\' | translate}}:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'ENABLE_SMS\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.enableSMS , \'fa fa-toggle-off\': !vm.dataToFill.enableSMS}\"></i></div></div></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Restringir por flota:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'restriccion_flota\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.restriccion_flota , \'fa fa-toggle-off\': !vm.dataToFill.restriccion_flota}\"></i></div></div></td></tr></tbody></table></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>{{\'applyTagCollection\' | translate}}:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'APPLY_CHARGE\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.applyCharge , \'fa fa-toggle-off\': !vm.dataToFill.applyCharge}\"></i></div></div></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>{{\'calculateVariableRateUsingEstimatedDistance\' | translate}}:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'APPLY_ESTIMATED_FARE\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.applyEstimatedFare , \'fa fa-toggle-off\': !vm.dataToFill.applyEstimatedFare}\"></i></div></div><p class=optionDeactivatedNote>{{\'optionDeactivatedNote\' | translate}}</p></td></tr></tbody></table></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean><div class=displayFlex ng-class=\"{\'disableSubmit\': !vm.dataToFill.applyCharge}\"><div style=padding-top:10px>{{\'collectEstimatedTag\' | translate}}:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'COLLECT_ESTIMATED_TAG\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.collectEstimatedTag, \'fa fa-toggle-off\': !vm.dataToFill.collectEstimatedTag}\"></i></div></div><p class=optionDeactivatedNote>{{\'whenDeactivatedToll\' | translate}}</p></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>{{\'aplicarQrPuntoApunto\' | translate}}:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'APPLY_QR_P\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.apply_qr_p, \'fa fa-toggle-off\': !vm.dataToFill.apply_qr_p}\"></i></div></div></td></tr></tbody></table></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>{{\'applyChargeForEstimatedTravelTime\' | translate}}:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'APPLY_REAL_TIME_TRAVEL\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.charge_for_estimated_travel_time, \'fa fa-toggle-off\': !vm.dataToFill.charge_for_estimated_travel_time}\"></i></div></div><p class=optionDeactivatedNote>{{\'applyRealTimeTravel\' | translate}}</p></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>{{\'disableSmsCustomer\' | translate}}:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'DISABLE_SMS_CUSTOMER\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.disable_sms_customer, \'fa fa-toggle-off\': !vm.dataToFill.disable_sms_customer}\"></i></div></div></td></tr></tbody></table></div></div><div class=\"row mt25\" style=\"margin-left: 0px;margin-right: 0px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=padding:0px><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'otherDetails\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean>{{\'fareToCust\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'FARE_TO_CUSTOMER\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.fareToCustomer , \'fa fa-toggle-off\': !vm.dataToFill.fareToCustomer}\"></i></td></tr><tr><td class=headingBollean>{{\'fareToDriver\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'FARE_TO_DRIVER\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.fareToDriver , \'fa fa-toggle-off\': !vm.dataToFill.fareToDriver}\"></i></td></tr><tr><td class=headingBollean>{{\'roundTripWaitTime\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'ROUND_TRIP_WAIT_TIME\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.roundTripWaitTime , \'fa fa-toggle-off\': !vm.dataToFill.roundTripWaitTime}\"></i></td></tr><tr><td class=headingBollean>Monitoring Services</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'Monitoring_Services\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.monitoringServices , \'fa fa-toggle-off\': !vm.dataToFill.monitoringServices}\"></i></td></tr><tr><td colspan=2><label class=control-label>Voucher para pasajero:</label><br><br></td></tr><tr><td class=headingBollean>Al Crear Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'crear_reserva\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.crearReserva , \'fa fa-toggle-off\': !vm.dataToFill.crearReserva}\"></i></td></tr><tr><td class=headingBollean>Al Finalizar Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'finalizar_reserva\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.finalizarReserva , \'fa fa-toggle-off\': !vm.dataToFill.finalizarReserva}\"></i></td></tr><tr><td class=headingBollean>Para Calificar al Conductor</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'para_calificar_conductor\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.paraCalificarConductor , \'fa fa-toggle-off\': !vm.dataToFill.paraCalificarConductor}\"></i></td></tr><tr><td class=headingBollean>Al Anular Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'anular_reserva\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.anularReserva , \'fa fa-toggle-off\': !vm.dataToFill.anularReserva}\"></i></td></tr><tr><td class=headingBollean>Al marcar Reserva NoShow</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'marcar_reserva\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.marcarReserva , \'fa fa-toggle-off\': !vm.dataToFill.marcarReserva}\"></i></td></tr><tr><td class=headingBollean>Al Retarificar Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'retarificar_reserva\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.retarificarReserva , \'fa fa-toggle-off\': !vm.dataToFill.retarificarReserva}\"></i></td></tr><tr><td colspan=2><label class=control-label>Voucher para Solicitante:</label><br><br></td></tr><tr><td class=headingBollean>Al Crear Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'crear_reserva_solicitante\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.crearReservaSolicitante , \'fa fa-toggle-off\': !vm.dataToFill.crearReservaSolicitante}\"></i></td></tr><tr><td class=headingBollean>Al Finalizar Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'finalizar_reserva_solicitante\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.finalizarReservaSolicitante , \'fa fa-toggle-off\': !vm.dataToFill.finalizarReservaSolicitante}\"></i></td></tr><tr><td class=headingBollean>Para Calificar al Conductor</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'para_calificar_conductor_solicitante\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.paraCalificarConductorSolicitante , \'fa fa-toggle-off\': !vm.dataToFill.paraCalificarConductorSolicitante}\"></i></td></tr><tr><td class=headingBollean>Al Anular Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'anular_reserva_solicitante\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.anularReservaSolicitante , \'fa fa-toggle-off\': !vm.dataToFill.anularReservaSolicitante}\"></i></td></tr><tr><td class=headingBollean>Al marcar Reserva NoShow</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'marcar_reserva_solicitante\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.marcarReservaSolicitante , \'fa fa-toggle-off\': !vm.dataToFill.marcarReservaSolicitante}\"></i></td></tr><tr><td class=headingBollean>Al Retarificar Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'retarificar_reserva_solicitante\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.retarificarReservaSolicitante , \'fa fa-toggle-off\': !vm.dataToFill.retarificarReservaSolicitante}\"></i></td></tr><tr><td colspan=2><label class=control-label>Voucher para Administrador del Convenio:</label><br><br></td></tr><tr><td class=headingBollean>Al Crear Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'crear_reserva_administrador\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.crearReservaAdministrador , \'fa fa-toggle-off\': !vm.dataToFill.crearReservaAdministrador}\"></i></td></tr><tr><td class=headingBollean>Al Finalizar Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'finalizar_reserva_administrador\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.finalizarReservaAdministrador , \'fa fa-toggle-off\': !vm.dataToFill.finalizarReservaAdministrador}\"></i></td></tr><tr><td class=headingBollean>Al Anular Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'anular_reserva_administrador\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.anularReservaAdministrador , \'fa fa-toggle-off\': !vm.dataToFill.anularReservaAdministrador}\"></i></td></tr><tr><td class=headingBollean>Al marcar Reserva NoShow</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'marcar_reserva_administrador\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.marcarReservaAdministrador , \'fa fa-toggle-off\': !vm.dataToFill.marcarReservaAdministrador}\"></i></td></tr><tr><td class=headingBollean>Al Retarificar Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'retarificar_reserva_administrador\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.retarificarReservaAdministrador , \'fa fa-toggle-off\': !vm.dataToFill.retarificarReservaAdministrador}\"></i></td></tr></tbody></table></div></div><div class=\"row mt25\" style=\"margin-left: 0px;margin-right: 0px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=padding:0px><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'otherDetails\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean>{{\'authRut\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'AUTHERIZER_RUT\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.authrizerRut , \'fa fa-toggle-off\': !vm.dataToFill.authrizerRut}\"></i></td></tr><!-- <tr>\n                                                    <td class=\"headingBollean\">{{\'vToPassenger\' | translate}}</td>\n                                                    <td class=\"boleeanTypeColor\">\n                                                        <i ng-click=\"vm.setBooleans(\'INVOICE_CUSTOMER\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.invoiceCustomer , \'fa fa-toggle-off\': !vm.dataToFill.invoiceCustomer}\"></i>\n                                                    </td>\n                                                </tr>\n                                                <tr>\n                                                    <td class=\"headingBollean\">{{\'vToApplicant\' | translate}}</td>\n                                                    <td class=\"boleeanTypeColor\">\n                                                        <i ng-click=\"vm.setBooleans(\'INVOICE_APPLICANT\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.invoiceApplicant , \'fa fa-toggle-off\': !vm.dataToFill.invoiceApplicant}\"></i>\n                                                    </td>\n                                                </tr>\n                                                <tr>\n                                                    <td class=\"headingBollean\">{{\'vToAgreAdmin\' | translate}}</td>\n                                                    <td class=\"boleeanTypeColor\">\n                                                        <i ng-click=\"vm.setBooleans(\'INVOICE_CONTACT_PERSON\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.invoiceContactPerson , \'fa fa-toggle-off\': !vm.dataToFill.invoiceContactPerson}\"></i>\n                                                    </td>\n                                                </tr> --><!--<tr>--><!--<td class=\"headingBollean\">Invoice to Contract Person</td>--><!--<td class=\"boleeanTypeColor\"><i ng-click=\"vm.setBooleans(\'INVOICE_CONTRACT_PERSON\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.invoiceContractPerson , \'fa fa-toggle-off\': !vm.dataToFill.invoiceContractPerson}\"></i></td>--><!--</tr>--><!--<tr>--><!--<td class=\"headingBollean\">Invoice to Employee</td>--><!--<td class=\"boleeanTypeColor\"><i ng-click=\"vm.setBooleans(\'INVOICE_EMPLOYEE\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.invoiceEmployee , \'fa fa-toggle-off\': !vm.dataToFill.invoiceEmployee}\"></i></td>--><!--</tr>--><tr><td class=headingBollean>{{\'passengerRut\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'PASSANGER_RUT\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.passengerRut , \'fa fa-toggle-off\': !vm.dataToFill.passengerRut}\"></i></td></tr><tr><td class=headingBollean>{{\'applicantRut\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'APPLICANT_RUT\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.applicantRut , \'fa fa-toggle-off\': !vm.dataToFill.applicantRut}\"></i></td></tr><tr><td class=headingBollean>{{\'costCenter\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'COST_CENTER\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.costCenter , \'fa fa-toggle-off\': !vm.dataToFill.costCenter}\"></i></td></tr><tr><td class=headingBollean>{{\'costSubCenter\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'COST_SUB_CENTER\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.costSubCenter , \'fa fa-toggle-off\': !vm.dataToFill.costSubCenter}\"></i></td></tr><tr><td class=headingBollean>{{\'ROL\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'ROL\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.rol , \'fa fa-toggle-off\': !vm.dataToFill.rol}\"></i></td></tr><tr><td class=headingBollean>{{\'graph\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'GRAPH\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.graph , \'fa fa-toggle-off\': !vm.dataToFill.graph}\"></i></td></tr><tr><td class=headingBollean>{{\'workOrder\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'WORK_ORDER\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.workOrder , \'fa fa-toggle-off\': !vm.dataToFill.workOrder}\"></i></td></tr><tr><td class=headingBollean>{{\'pep\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'PEP\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.pep , \'fa fa-toggle-off\': !vm.dataToFill.pep}\"></i></td></tr><tr><td class=headingBollean>{{\'noOfVoucher\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'NUMBER_VOUCHERS\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.numberVoucher , \'fa fa-toggle-off\': !vm.dataToFill.numberVoucher}\"></i></td></tr><tr><td class=headingBollean>{{\'purOfTrip\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'PURPOSE_TRIP\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.purpouseOfTrip , \'fa fa-toggle-off\': !vm.dataToFill.purpouseOfTrip}\"></i></td></tr><tr><td class=headingBollean>{{\'nomina\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'NOMINA\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.nomina , \'fa fa-toggle-off\': !vm.dataToFill.nomina}\"></i></td></tr><tr><td class=headingBollean>{{\'solicitud\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'SOLICITUDE\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.solicitude , \'fa fa-toggle-off\': !vm.dataToFill.solicitude}\"></i></td></tr><tr><td class=headingBollean>{{\'loadProfile\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'AUTH_LOAD_PROFILE\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.authLoadProfile , \'fa fa-toggle-off\': !vm.dataToFill.authLoadProfile}\"></i></td></tr><tr><td class=headingBollean>{{\'mandtoryAirline\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'Mandatory_Airline\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.airline , \'fa fa-toggle-off\': !vm.dataToFill.airline}\"></i></td></tr><tr><td class=headingBollean>{{\'mandtoryFlight\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'Mandatory_Flight\')\" ng-class=\"{\'fa fa-toggle-on\':   vm.dataToFill.flight , \'fa fa-toggle-off\': !vm.dataToFill.flight}\"></i></td></tr><tr><td class=headingBollean>{{\'mandtoryFlightDate\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'Mandatory_Flight_Date\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.flightDate , \'fa fa-toggle-off\': !vm.dataToFill.flightDate}\"></i></td></tr><tr><td class=headingBollean>{{\'mandtoryFlightType\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'Mandatory_Flight_Type\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.flightType , \'fa fa-toggle-off\': !vm.dataToFill.flightType}\"></i></td></tr><tr><td class=headingBollean>{{\'allowBookingWithoutRequest\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'ALLOW_BOOKINGS_WITHOUT_REQUEST\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.allowBookingWithoutRequest , \'fa fa-toggle-off\': !vm.dataToFill.allowBookingWithoutRequest}\"></i></td></tr><!-- <tr>\n                                                    <td class=\"headingBollean\">{{\'allowChangeFareForPos\' | translate}}</td>\n                                                    <td class=\"boleeanTypeColor\">\n                                                        <i ng-click=\"vm.setBooleans(\'Allow_Change_Fare_POS\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.changeFareForPos , \'fa fa-toggle-off\': !vm.dataToFill.changeFareForPos}\"></i>\n                                                    </td>\n                                                </tr>\n                                                <tr>\n                                                    <td class=\"headingBollean\">{{\'allowChangeFareForCreateBooking\' | translate}}</td>\n                                                    <td class=\"boleeanTypeColor\">\n                                                        <i ng-click=\"vm.setBooleans(\'Allow_Change_Fare_Create_Booking\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.changeFareForCreateBooking , \'fa fa-toggle-off\': !vm.dataToFill.changeFareForCreateBooking}\"></i>\n                                                    </td>\n                                                </tr> --></tbody></table></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><button class=\"btn btn-primary\" type=submit style=width:200px>{{\'submit\' | translate}}</button></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/agreement/viewAgreementDetails.html","<h2 class=ng-cloak>{{\'agreementHead\' | translate}} / {{\'agreementDetailsHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=driver><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'basicDetails\' | translate}}</p><div class=basicDetailsDiv><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'agreNameLabel\' | translate}}:</label><div class=\"form-control text-capitalize\">{{vm.dataToFill.agreementName}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'agreTypeLabel\' | translate}}:</label><div class=form-control>{{vm.dataToFill.agreementType}}</div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'validSdateLabel\' | translate}}:</label><div class=\"form-control text-capitalize\">{{vm.dataToFill.startDate | date:\'mediumDate\'}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'validEdateLabel\' | translate}}:</label><div class=form-control>{{vm.dataToFill.endDate | date:\'mediumDate\'}}</div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'corporateLabel\' | translate}}:</label><div class=\"form-control text-capitalize\">{{vm.dataToFill.corporateName}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'typeServiceHead\' | translate}}:</label><div class=form-control><span ng-repeat=\"data in vm.dataToFill.typeOfService\">{{data}} <span ng-if=\"$index != vm.dataToFill.typeOfService.length - 1\">,</span></span></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'noShowChargeLabel\' | translate}}:</label><div class=\"form-control text-capitalize\">{{vm.dataToFill.noShowCharges}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'maxWaitTimeLabel\' | translate}}:</label><div class=form-control>{{vm.dataToFill.waitTolerance}}</div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'maxWaitTimeFLabel\' | translate}}:</label><div class=\"form-control text-capitalize\">{{vm.dataToFill.waitTimeFree}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'maxWaitTimeFRLabel\' | translate}}:</label><div class=form-control>{{vm.dataToFill.waitRoute}}</div></div></div><div class=\"row mt5\"><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">Base Fare Discount (in %):</label>--><!--<div class=\"form-control text-capitalize\">{{vm.dataToFill.baseFareDiscount}}--><!--</div>--><!--</div>--><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'comeclass\' | translate}}:</label><div class=form-control>{{vm.dataToFill.commercialClassification}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'paymentMethodLabel\' | translate}}:</label><div class=\"form-control heightAuto\"><span ng-repeat=\"data in vm.dataToFill.payment_method_id\">{{data}} <span ng-if=\"$index != vm.dataToFill.payment_method_id.length - 1\">,</span></span></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'defaultPaymentLabel\' | translate}}:</label><div class=\"form-control text-capitalize\">{{vm.dataToFill.paymentMethod}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'branchesTableHead\' | translate}}:</label><div class=form-control style=\"height: auto\"><span ng-repeat=\"data in vm.dataToFill.branch\">{{data}} <span ng-if=\"$index != vm.dataToFill.branch.length - 1\">,</span></span></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'virtualFleetLabel\' | translate}}:</label><div class=\"form-control text-capitalize\">{{vm.dataToFill.virtualFleet}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'emailAdmins\' | translate}}:</label><div class=form-control>{{vm.dataToFill.emailAdministrator}}</div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'strictEndowment\' | translate}}:</label><div class=\"form-control text-capitalize\" ng-if=\"vm.dataToFill.employeeEndowment == \'0\'\">No</div><div class=\"form-control text-capitalize\" ng-if=\"vm.dataToFill.employeeEndowment == \'1\'\">Yes</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Descuento de ida y vuelta:</label><div class=\"form-control text-capitalize\">{{vm.dataToFill.roundTripDiscount}}</div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Descuento por correo electrónico WebPay / URL:</label><div class=\"form-control text-capitalize\">{{vm.dataToFill.webPayDiscount}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>Factor QTH</label><div class=displayFlex><div class=\"form-control text-capitalize\" style=width:35%>{{vm.dataToFill.QTH_factor || 0}}</div><span style=\"padding-left: 10px;font-size: 13px;color: #888;word-break: break-word\">Usado para calcular tarifa en servicios agrupados</span></div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" style=padding:10px><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">Direcciones Favoritas</p><div class=basicDetailsDiv><!-- <div class=\"row mt5\" style=\"margin-left:0px;margin-right:0px;\">\n                                                <button style=\"float:right\"  type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.openPopUpForAdding($event,addAgreementForm)\">\n                                                        Agregar \n                                                </button>\n                                            </div> --><div class=\"row mt5\" style=margin-left:0px;margin-right:0px><table class=\"table table-hover tableWithMasterData\"><thead><tr><th style=width:70px>Nombre</th><th style=width:70px>Direccion</th><th style=width:70px>Action</th></tr></thead><tbody ng-if=\"vm.addressArray.length>0\" style=max-height:300px;overflow-y:auto when-scrolled=vm.onScrollAddressBody()><tr ng-repeat=\"data in filtered = vm.addressArray\"><td style=width:70px>{{data.address_nick_name}}</td><td style=width:70px>{{data.address_location}}</td><td style=width:70px><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteAddress($index)><i class=\"fa fa-trash\"></i></a></td></tr></tbody></table></div></div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=vm.dataToFill.groupServices><label>Umbral Agrupación <span style=color:red>*</span></label><input type=text placeholder=\"Grouping threshold\" is-number=\"\" required class=form-control name=groupThreshold ng-model=vm.dataToFill.groupThreshold ng-class=\"{ \'has-error\': editAgreementForm.groupThreshold.$touched && editAgreementForm.groupThreshold.$invalid }\"></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=vm.dataToFill.apply_qr_p><label>Cant. mins envío anticipado de SMS <span style=color:red>*</span></label><input type=text placeholder=\"Minutos de envío sms previo a reserva\" is-number=\"\" required class=form-control name=sms_minutes_qr_p ng-model=vm.dataToFill.sms_minutes_qr_p ng-class=\"{ \'has-error\': editAgreementForm.sms_minutes_qr_p.$touched && editAgreementForm.sms_minutes_qr_p.$invalid }\"></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'comments\' | translate}}:</label><textarea class=form-control ng-model=vm.dataToFill.comments readonly></textarea></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Allow to mixed shared services:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.sharedServices , \'fa fa-toggle-off\': !vm.dataToFill.sharedServices}\"></i></div></div></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Allow group services:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.groupServices , \'fa fa-toggle-off\': !vm.dataToFill.groupServices}\"></i></div></div></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Agrupación External:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.groupExternal , \'fa fa-toggle-off\': !vm.dataToFill.groupExternal}\"></i></div></div></td></tr></tbody></table></div></div><div class=\"row mt5\" ng-if=vm.dataToFill.groupServices><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Cobrar por ruta completa:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.chargeFullPath , \'fa fa-toggle-off\': !vm.dataToFill.chargeFullPath}\"></i></div></div></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Cobrar por cada reserva:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.chargeEachReservation , \'fa fa-toggle-off\': !vm.dataToFill.chargeEachReservation}\"></i></div></div></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Activar agrupación automática:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'AUTOMATIC_GROUPING\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.automaticGrouping , \'fa fa-toggle-off\': !vm.dataToFill.automaticGrouping}\"></i></div></div></td></tr></tbody></table></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Apply Via Controlled:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.controlledWay , \'fa fa-toggle-off\': !vm.dataToFill.controlledWay}\"></i></div></div></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Mostrar Items Vía Controlada en Voucher:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.viaControlled , \'fa fa-toggle-off\': !vm.dataToFill.viaControlled}\"></i></div></div></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Vía Controlada incluida en la Tarifa:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.viaControlledTarifa , \'fa fa-toggle-off\': !vm.dataToFill.viaControlledTarifa}\"></i></div></div></td></tr></tbody></table></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Habilitar Tarifa Variable<br>por Geocerca:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.enableVaribleRate , \'fa fa-toggle-off\': !vm.dataToFill.enableVaribleRate}\"></i></div></div></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>{{\'enable_sms_parcels\' | translate}}:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'ENABLE_SMS\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.enableSMS , \'fa fa-toggle-off\': !vm.dataToFill.enableSMS}\"></i></div></div></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>Restringir por flota:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'restriccion_flota\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.restriccion_flota , \'fa fa-toggle-off\': !vm.dataToFill.restriccion_flota}\"></i></div></div></td></tr></tbody></table></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>{{\'applyTagCollection\' | translate}}:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'APPLY_CHARGE\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.applyCharge , \'fa fa-toggle-off\': !vm.dataToFill.applyCharge}\"></i></div></div></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>{{\'calculateVariableRateUsingEstimatedDistance\' | translate}}:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'APPLY_ESTIMATED_FARE\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.applyEstimatedFare , \'fa fa-toggle-off\': !vm.dataToFill.applyEstimatedFare}\"></i></div></div><p class=optionDeactivatedNote>{{\'optionDeactivatedNote\' | translate}}</p></td></tr></tbody></table></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>{{\'collectEstimatedTag\' | translate}}:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'COLLECT_ESTIMATED_TAG\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.collectEstimatedTag, \'fa fa-toggle-off\': !vm.dataToFill.collectEstimatedTag}\"></i></div></div><p class=optionDeactivatedNote>{{\'whenDeactivatedToll\' | translate}}</p></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>{{\'aplicarQrPuntoApunto\' | translate}}:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'APPLY_QR_P\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.apply_qr_p, \'fa fa-toggle-off\': !vm.dataToFill.apply_qr_p}\"></i></div></div></td></tr></tbody></table></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>{{\'applyChargeForEstimatedTravelTime\' | translate}}:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'APPLY_REAL_TIME_TRAVEL\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.charge_for_estimated_travel_time, \'fa fa-toggle-off\': !vm.dataToFill.charge_for_estimated_travel_time}\"></i></div></div><p class=optionDeactivatedNote>{{\'applyRealTimeTravel\' | translate}}</p></td><td class=headingBollean><div class=displayFlex><div style=padding-top:10px>{{\'disableSmsCustomer\' | translate}}:</div><div class=boleeanTypeColor style=padding-left:15px><i ng-click=\"vm.setBooleans(\'DISABLE_SMS_CUSTOMER\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.disable_sms_customer, \'fa fa-toggle-off\': !vm.dataToFill.disable_sms_customer}\"></i></div></div></td></tr></tbody></table></div></div><div class=\"row mt25\" style=\"margin-left: 0px;margin-right: 0px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=padding:0px><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'otherDetails\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean>{{\'fareToCust\' | translate}}</td><td class=boleeanTypeColor><i ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.fareToCustomer , \'fa fa-toggle-off\': !vm.dataToFill.fareToCustomer}\"></i></td></tr><tr><td class=headingBollean>{{\'fareToDriver\' | translate}}</td><td class=boleeanTypeColor><i ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.fareToDriver , \'fa fa-toggle-off\': !vm.dataToFill.fareToDriver}\"></i></td></tr><tr><td class=headingBollean>{{\'roundTripWaitTime\' | translate}}</td><td class=boleeanTypeColor><i ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.roundTripWaitTime , \'fa fa-toggle-off\': !vm.dataToFill.roundTripWaitTime}\"></i></td></tr><tr><td class=headingBollean>Monitoring Services</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'Monitoring_Services\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.monitoringServices , \'fa fa-toggle-off\': !vm.dataToFill.monitoringServices}\"></i></td></tr><tr><td colspan=2><label class=control-label>Voucher para pasajero:</label><br><br></td></tr><tr><td class=headingBollean>Al Crear Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'crear_reserva\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.crearReserva , \'fa fa-toggle-off\': !vm.dataToFill.crearReserva}\"></i></td></tr><tr><td class=headingBollean>Al Finalizar Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'finalizar_reserva\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.finalizarReserva , \'fa fa-toggle-off\': !vm.dataToFill.finalizarReserva}\"></i></td></tr><tr><td class=headingBollean>Para Calificar al Conductor</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'para_calificar_conductor\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.paraCalificarConductor , \'fa fa-toggle-off\': !vm.dataToFill.paraCalificarConductor}\"></i></td></tr><tr><td class=headingBollean>Al Anular Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'anular_reserva\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.anularReserva , \'fa fa-toggle-off\': !vm.dataToFill.anularReserva}\"></i></td></tr><tr><td class=headingBollean>Al marcar Reserva NoShow</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'marcar_reserva\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.marcarReserva , \'fa fa-toggle-off\': !vm.dataToFill.marcarReserva}\"></i></td></tr><tr><td class=headingBollean>Al Retarificar Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'retarificar_reserva\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.retarificarReserva , \'fa fa-toggle-off\': !vm.dataToFill.retarificarReserva}\"></i></td></tr><tr><td colspan=2><label class=control-label>Voucher para Solicitante:</label><br><br></td></tr><tr><td class=headingBollean>Al Crear Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'crear_reserva_solicitante\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.crearReservaSolicitante , \'fa fa-toggle-off\': !vm.dataToFill.crearReservaSolicitante}\"></i></td></tr><tr><td class=headingBollean>Al Finalizar Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'finalizar_reserva_solicitante\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.finalizarReservaSolicitante , \'fa fa-toggle-off\': !vm.dataToFill.finalizarReservaSolicitante}\"></i></td></tr><tr><td class=headingBollean>Para Calificar al Conductor</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'para_calificar_conductor\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.paraCalificarConductorSolicitante , \'fa fa-toggle-off\': !vm.dataToFill.paraCalificarConductorSolicitante}\"></i></td></tr><tr><td class=headingBollean>Al Anular Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'anular_reserva_solicitante\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.anularReservaSolicitante , \'fa fa-toggle-off\': !vm.dataToFill.anularReservaSolicitante}\"></i></td></tr><tr><td class=headingBollean>Al marcar Reserva NoShow</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'marcar_reserva_solicitante\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.marcarReservaSolicitante , \'fa fa-toggle-off\': !vm.dataToFill.marcarReservaSolicitante}\"></i></td></tr><tr><td class=headingBollean>Al Retarificar Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'retarificar_reserva_solicitante\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.retarificarReservaSolicitante , \'fa fa-toggle-off\': !vm.dataToFill.retarificarReservaSolicitante}\"></i></td></tr><tr><td colspan=2><label class=control-label>Voucher para Administrador del Convenio:</label><br><br></td></tr><tr><td class=headingBollean>Al Crear Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'crear_reserva_administrador\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.crearReservaAdministrador , \'fa fa-toggle-off\': !vm.dataToFill.crearReservaAdministrador}\"></i></td></tr><tr><td class=headingBollean>Al Finalizar Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'finalizar_reserva_administrador\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.finalizarReservaAdministrador , \'fa fa-toggle-off\': !vm.dataToFill.finalizarReservaAdministrador}\"></i></td></tr><tr><td class=headingBollean>Al Anular Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'anular_reserva_administrador\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.anularReservaAdministrador , \'fa fa-toggle-off\': !vm.dataToFill.anularReservaAdministrador}\"></i></td></tr><tr><td class=headingBollean>Al marcar Reserva NoShow</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'marcar_reserva_administrador\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.marcarReservaAdministrador , \'fa fa-toggle-off\': !vm.dataToFill.marcarReservaAdministrador}\"></i></td></tr><tr><td class=headingBollean>Al Retarificar Reserva</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'retarificar_reserva_administrador\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.retarificarReservaAdministrador , \'fa fa-toggle-off\': !vm.dataToFill.retarificarReservaAdministrador}\"></i></td></tr></tbody></table></div></div><div class=\"row mt25\" style=\"margin-left: 0px;margin-right: 0px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=padding:0px><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'otherDetails\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean>{{\'authRut\' | translate}}</td><td class=boleeanTypeColor><i ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.authrizerRut , \'fa fa-toggle-off\': !vm.dataToFill.authrizerRut}\"></i></td></tr><!-- <tr>\n                                                <td class=\"headingBollean\">{{\'vToPassenger\' | translate}}</td>\n                                                <td class=\"boleeanTypeColor\">\n                                                    <i ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.invoiceCustomer , \'fa fa-toggle-off\': !vm.dataToFill.invoiceCustomer}\"></i>\n                                                </td>\n                                            </tr>\n                                            <tr>\n                                                <td class=\"headingBollean\">{{\'vToApplicant\' | translate}}</td>\n                                                <td class=\"boleeanTypeColor\">\n                                                    <i ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.invoiceApplicant , \'fa fa-toggle-off\': !vm.dataToFill.invoiceApplicant}\"></i>\n                                                </td>\n                                            </tr>\n                                            <tr>\n                                                <td class=\"headingBollean\">{{\'vToAgreAdmin\' | translate}}</td>\n                                                <td class=\"boleeanTypeColor\">\n                                                    <i ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.invoiceContactPerson , \'fa fa-toggle-off\': !vm.dataToFill.invoiceContactPerson}\"></i>\n                                                </td>\n                                            </tr> --><!--<tr>--><!--<td class=\"headingBollean\">Invoice to Contract Person</td>--><!--<td class=\"boleeanTypeColor\"><i ng-click=\"vm.setBooleans(\'INVOICE_CONTRACT_PERSON\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.invoiceContractPerson , \'fa fa-toggle-off\': !vm.dataToFill.invoiceContractPerson}\"></i></td>--><!--</tr>--><!--<tr>--><!--<td class=\"headingBollean\">Invoice to Employee</td>--><!--<td class=\"boleeanTypeColor\"><i ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.invoiceEmployee , \'fa fa-toggle-off\': !vm.dataToFill.invoiceEmployee}\"></i></td>--><!--</tr>--><tr><td class=headingBollean>{{\'passengerRut\' | translate}}</td><td class=boleeanTypeColor><i ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.passengerRut , \'fa fa-toggle-off\': !vm.dataToFill.passengerRut}\"></i></td></tr><tr><td class=headingBollean>{{\'applicantRut\' | translate}}</td><td class=boleeanTypeColor><i ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.applicantRut , \'fa fa-toggle-off\': !vm.dataToFill.applicantRut}\"></i></td></tr><tr><td class=headingBollean>{{\'costCenter\' | translate}}</td><td class=boleeanTypeColor><i ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.costCenter , \'fa fa-toggle-off\': !vm.dataToFill.costCenter}\"></i></td></tr><tr><td class=headingBollean>{{\'costSubCenter\' | translate}}</td><td class=boleeanTypeColor><i ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.costSubCenter , \'fa fa-toggle-off\': !vm.dataToFill.costSubCenter}\"></i></td></tr><tr><td class=headingBollean>{{\'ROL\' | translate}}</td><td class=boleeanTypeColor><i ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.rol , \'fa fa-toggle-off\': !vm.dataToFill.rol}\"></i></td></tr><tr><td class=headingBollean>{{\'graph\' | translate}}</td><td class=boleeanTypeColor><i ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.graph , \'fa fa-toggle-off\': !vm.dataToFill.graph}\"></i></td></tr><tr><td class=headingBollean>{{\'workOrder\' | translate}}</td><td class=boleeanTypeColor><i ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.workOrder , \'fa fa-toggle-off\': !vm.dataToFill.workOrder}\"></i></td></tr><tr><td class=headingBollean>{{\'pep\' | translate}}</td><td class=boleeanTypeColor><i ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.pep , \'fa fa-toggle-off\': !vm.dataToFill.pep}\"></i></td></tr><tr><td class=headingBollean>{{\'noOfVoucher\' | translate}}</td><td class=boleeanTypeColor><i ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.numberVoucher , \'fa fa-toggle-off\': !vm.dataToFill.numberVoucher}\"></i></td></tr><tr><td class=headingBollean>{{\'purOfTrip\' | translate}}</td><td class=boleeanTypeColor><i ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.purpouseOfTrip , \'fa fa-toggle-off\': !vm.dataToFill.purpouseOfTrip}\"></i></td></tr><tr><td class=headingBollean>{{\'nomina\' | translate}}</td><td class=boleeanTypeColor><i ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.nomina , \'fa fa-toggle-off\': !vm.dataToFill.nomina}\"></i></td></tr><tr><td class=headingBollean>{{\'solicitud\' | translate}}</td><td class=boleeanTypeColor><i ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.solicitude , \'fa fa-toggle-off\': !vm.dataToFill.solicitude}\"></i></td></tr><tr><td class=headingBollean>{{\'loadProfile\' | translate}}</td><td class=boleeanTypeColor><i ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.authLoadProfile , \'fa fa-toggle-off\': !vm.dataToFill.authLoadProfile}\"></i></td></tr><tr><td class=headingBollean>{{\'mandtoryAirline\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'Mandatory_Airline\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.airline , \'fa fa-toggle-off\': !vm.dataToFill.airline}\"></i></td></tr><tr><td class=headingBollean>{{\'mandtoryFlight\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'Mandatory_Flight\')\" ng-class=\"{\'fa fa-toggle-on\':   vm.dataToFill.flight , \'fa fa-toggle-off\': !vm.dataToFill.flight}\"></i></td></tr><tr><td class=headingBollean>{{\'mandtoryFlightDate\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'Mandatory_Flight_Date\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.flightDate , \'fa fa-toggle-off\': !vm.dataToFill.flightDate}\"></i></td></tr><tr><td class=headingBollean>{{\'mandtoryFlightType\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'Mandatory_Flight_Type\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.flightType , \'fa fa-toggle-off\': !vm.dataToFill.flightType}\"></i></td></tr><tr><td class=headingBollean>{{\'allowBookingWithoutRequest\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'ALLOW_BOOKINGS_WITHOUT_REQUEST\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.allowBookingWithoutRequest , \'fa fa-toggle-off\': !vm.dataToFill.allowBookingWithoutRequest}\"></i></td></tr><!-- <tr>\n                                                <td class=\"headingBollean\">{{\'allowChangeFareForPos\' | translate}}</td>\n                                                <td class=\"boleeanTypeColor\">\n                                                    <i ng-click=\"vm.setBooleans(\'Allow_Change_Fare_POS\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.changeFareForPos , \'fa fa-toggle-off\': !vm.dataToFill.changeFareForPos}\"></i>\n                                                </td>\n                                            </tr>\n                                            <tr>\n                                                <td class=\"headingBollean\">{{\'allowChangeFareForCreateBooking\' | translate}}</td>\n                                                <td class=\"boleeanTypeColor\">\n                                                     <i ng-click=\"vm.setBooleans(\'Allow_Change_Fare_Create_Booking\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.changeFareForCreateBooking , \'fa fa-toggle-off\': !vm.dataToFill.changeFareForCreateBooking}\"></i>\n                                                </td>\n                                            </tr> --></tbody></table></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/agreement-route/fixedPriceListAgreement.html","<h2 class=ng-cloak><span>{{\'agreementHead\' | translate}} / {{\'priceListHead1\' | translate}}</span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=employee><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 wordBreak\"><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><div class=\"row marginZero\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 paddingZero\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div ng-include=\"\'app/components/views/agreement-route/priceListTopHeadBar.html\'\"></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=basicDiv ng-if=vm.addHeaderFFlag><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'createNewListHead\' | translate}}</p><div class=basicDetailsDiv><form name=HeaderFForm ng-submit=\"submit=true;HeaderFForm.$valid&&vm.addHeadersHitF()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'name\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFillHeader.type_of_pricing_list_name name=Name placeholder=\"{{\'name\' | translate}}\" required ng-maxlength=60 ng-minlength=3 ng-class=\"{ \'has-error\': HeaderFForm.Name.$touched && HeaderFForm.Name.$invalid }\"><div ng-if=\"HeaderFForm.Name.$touched|| submit\" ng-messages=HeaderFForm.Name.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'nameR\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid name.</div>--><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'firstNameMaximum\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'priceStartDateLabel\' | translate}}<span style=color:red>*</span></label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=priceStartValidity ng-model=vm.dataToFillHeader.type_of_pricing_date_of_start placeholder=\"{{\'priceStartDateLabel\' | translate}}\" is-open=vm.datePicker_1.startPriceH datepicker-options=vm.dateOptions required ng-class=\"{ \'has-error\': HeaderFForm.priceStartValidity.$touched && HeaderFForm.priceStartValidity.$invalid }\" close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'1\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"HeaderFForm.priceStartValidity.$touched|| submit\" ng-messages=HeaderFForm.priceStartValidity.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'priceStartDateReq\' | translate}}</div></div></div><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">Adjustment of Price (in %)<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFillHeader.type_of_pricing_list_percentage_of_price_adj\" name=\"priceAdjust\" maxlength=\"3\" is-number--><!--placeholder=\"Price Adjustment\" required ng-class=\"{ \'has-error\': HeaderFForm.priceAdjust.$touched && HeaderFForm.priceAdjust.$invalid }\" pattern=\"^[0-9][0-9]*$\"/>--><!--<div ng-if=\"HeaderFForm.priceAdjust.$touched|| submit\" ng-messages=\"HeaderFForm.priceAdjust.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter adjustment of price</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid adjustment of price.</div>--><!--</div>--><!--</div>--></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'priceEndDateLabel\' | translate}}<span style=color:red>*</span></label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=priceEndValidity ng-model=vm.dataToFillHeader.type_of_pricing_date_of_end placeholder=\"{{\'priceEndDateLabel\' | translate}}\" is-open=vm.datePicker_1.endPriceH datepicker-options=vm.dateOptions required ng-class=\"{ \'has-error\': HeaderFForm.priceEndValidity.$touched && HeaderFForm.priceEndValidity.$invalid }\" close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'2\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"HeaderFForm.priceEndValidity.$touched|| submit\" ng-messages=HeaderFForm.priceEndValidity.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'priceEndDateReq\' | translate}}</div></div></div></div><!--<div class=\"row mt5\">--><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label>Price Status<span style=\"color:red\">*</span></label>--><!--<select class=\"form-control\" ng-model=\"vm.dataToFillHeader.type_of_price_status\"--><!--name=\"priceStatus\" required  ng-class=\"{ \'has-error\': HeaderFForm.priceStatus.$touched && HeaderFForm.priceStatus.$invalid }\">--><!--<option value=\"\" disabled selected>Select Price Status</option>--><!--<option value=\"1\">Active</option>--><!--<option value=\"0\">Inactive</option>--><!--<option value=\"2\">In Progress</option>--><!--</select>--><!--<div ng-if=\"HeaderFForm.priceStatus.$touched|| submit\" ng-messages=\"HeaderFForm.priceStatus.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please select status.</div>--><!--</div>--><!--</div>--><!--</div>--><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label>{{\'comments\' | translate}}</label><textarea style=height:100px placeholder=\"{{\'messagePlaceholder\' | translate}}\" ng-model=vm.dataToFillHeader.type_of_pricing_comments class=form-control name=comments ng-class=\"{ \'has-error\': HeaderFForm.comments.$touched && HeaderFForm.comments.$invalid }\"></textarea></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" style=margin-top:10px><button type=submit class=\"btn btn-primary\" style=width:30%>{{\'submit\' | translate}}</button> <button type=button ng-click=vm.cancel() class=\"btn btn-danger\" style=width:30%>{{\'cancelButton\' | translate}}</button></div></div></form></div></div><div class=basicDiv ng-if=vm.editHeaderFFlag><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'editHead\' | translate}}</p><div class=basicDetailsDiv><form name=editHeaderFForm ng-submit=\"submit=true;editHeaderFForm.$valid&&vm.editPriceListFixedApi()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'name\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFillHeader.type_of_pricing_list_name name=Name placeholder=\"{{\'name\' | translate}}\" required ng-maxlength=60 ng-minlength=3 ng-class=\"{ \'has-error\': editHeaderFForm.Name.$touched && editHeaderFForm.Name.$invalid }\"><div ng-if=\"editHeaderFForm.Name.$touched|| submit\" ng-messages=editHeaderFForm.Name.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'nameR\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid name.</div>--><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'firstNameMaximum\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'priceStartDateLabel\' | translate}}<span style=color:red>*</span></label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=priceStartValidity ng-model=vm.dataToFillHeader.type_of_pricing_date_of_start placeholder=\"{{\'priceStartDateLabel\' | translate}}\" is-open=vm.datePicker_1.startPriceH datepicker-options=vm.dateOptions required ng-class=\"{ \'has-error\': editHeaderFForm.priceStartValidity.$touched && editHeaderFForm.priceStartValidity.$invalid }\" close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'1\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"editHeaderFForm.priceStartValidity.$touched|| submit\" ng-messages=editHeaderFForm.priceStartValidity.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'priceStartDateReq\' | translate}}</div></div></div><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">Adjustment of Price (in %)<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFillHeader.type_of_pricing_list_percentage_of_price_adj\" name=\"priceAdjust\" maxlength=\"3\" is-number--><!--placeholder=\"Price Adjustment\" required ng-class=\"{ \'has-error\': editHeaderFForm.priceAdjust.$touched && editHeaderFForm.priceAdjust.$invalid }\" pattern=\"^[0-9][0-9]*$\"/>--><!--<div ng-if=\"editHeaderFForm.priceAdjust.$touched|| submit\" ng-messages=\"editHeaderFForm.priceAdjust.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter adjustment of price</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid adjustment of price.</div>--><!--</div>--><!--</div>--></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'priceEndDateLabel\' | translate}}<span style=color:red>*</span></label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=priceEndValidity ng-model=vm.dataToFillHeader.type_of_pricing_date_of_end placeholder=\"{{\'priceEndDateLabel\' | translate}}\" is-open=vm.datePicker_1.endPriceH datepicker-options=vm.dateOptions required ng-class=\"{ \'has-error\': editHeaderFForm.priceEndValidity.$touched && editHeaderFForm.priceEndValidity.$invalid }\" close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'2\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"editHeaderFForm.priceEndValidity.$touched|| submit\" ng-messages=editHeaderFForm.priceEndValidity.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'priceEndDateReq\' | translate}}</div></div></div></div><!--<div class=\"row mt5\">--><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label>Price Status<span style=\"color:red\">*</span></label>--><!--<select class=\"form-control\" ng-model=\"vm.dataToFillHeader.type_of_price_status\"--><!--name=\"priceStatus\" required  ng-class=\"{ \'has-error\': HeaderFForm.priceStatus.$touched && HeaderFForm.priceStatus.$invalid }\">--><!--<option value=\"\" disabled selected>Select Price Status</option>--><!--<option value=\"1\">Active</option>--><!--<option value=\"0\">Inactive</option>--><!--<option value=\"2\">In Progress</option>--><!--</select>--><!--<div ng-if=\"HeaderFForm.priceStatus.$touched|| submit\" ng-messages=\"HeaderFForm.priceStatus.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please select status.</div>--><!--</div>--><!--</div>--><!--</div>--><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label>{{\'comments\' | translate}}</label><textarea style=height:100px placeholder=\"{{\'messagePlaceholder\' | translate}}\" ng-model=vm.dataToFillHeader.type_of_pricing_comments class=form-control name=comments ng-class=\"{ \'has-error\': editHeaderFForm.comments.$touched && editHeaderFForm.comments.$invalid }\"></textarea></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" style=margin-top:10px><button type=submit class=\"btn btn-primary\" style=width:30%>{{\'submit\' | translate}}</button> <button type=button ng-click=vm.cancel() class=\"btn btn-danger\" style=width:30%>{{\'cancelButton\' | translate}}</button></div></div></form></div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-4 col-md-4 col-lg-4 col-xs-12\"><label class=control-label style=\"visibility: hidden\">{{\'priceListStatusLabel\' | translate}}</label><div class=input-group><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-3 col-md-3 col-lg-3 col-xs-12 col-sm-offset-2 col-md-offset-2 col-lg-offset-2 col-xs-offset-0 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label class=control-label>Price List Status</label><select class=form-control ng-model=vm.filterData.priceListStatus ng-change=\"vm.getAllFixedPriceList(0,10,vm.filterData.priceListStatus);vm.currentPage = 0;vm.itemsPerPageSelected=10;\"><option value=\"\" disabled>{{\'priceListStatusPlaceholder\' | translate}}</option><option value=3>All</option><option selected value=1>Active</option><option value=0>Inactive</option><option value=2>In Progress</option></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\" ng-switch=\"(vm.fixedRouteListG | filter:vm.search).length\"><div ng-switch-when=0 class=\"noSearch text-center\"><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px>{{\'serialNumber\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'name\' | translate}}\" text=\"\'name\'\" check=vm.reverse>{{\'name\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'creationDate\' | translate}}\" text=\"\'creation_date\'\" check=vm.reverse>{{\'creationDate\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'tableStartDate\' | translate}}\" text=\"\'date_of_start\'\" check=vm.reverse>{{\'tableStartDate\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'tableEndDate\' | translate}}\" text=\"\'date_of_end\'\" check=vm.reverse>{{\'tableEndDate\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'comments\' | translate}}\" text=\"\'comments\'\" check=vm.reverse>{{\'comments\' | translate}}</th><!--<th>--><!--<div ng-click=\"vm.sort(\'percentage_of_price_adj\')\">--><!--Price Adjustment (in %)--><!--<span ng-hide=\"vm.predicate == \'percentage_of_price_adj\' && vm.reverse || vm.predicate == \'percentage_of_price_adj\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'percentage_of_price_adj\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'percentage_of_price_adj\' && vm.reverse\" class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><!--<th>--><!--<div ng-click=\"vm.sort(\'status\')\">--><!--Status--><!--<span ng-hide=\"vm.predicate == \'status\' && vm.reverse || vm.predicate == \'status\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'status\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'status\' && vm.reverse\" class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><th style=width:350px><div>{{\'action\' | translate}}</div></th><th style=width:150px ng-if=\"vm.userType == 0\"><div>{{\'manageTableHead\' | translate}}</div></th><th style=width:150px ng-if=\"vm.userType == 0\"><div>{{\'adminLogs\' | translate}}</div></th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.fixedRouteListG| filter:vm.search | orderBy:vm.predicate:vm.reverse\"><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:70px>{{::data.id}}</td><td style=width:125px>{{::data.name}}</td><td style=width:125px>{{data.creation_date | date:\'dd-MMM-yy hh:mm\'}}</td><td style=width:125px>{{data.date_of_start | date:\'dd-MMM-yy\'}}</td><td style=width:125px>{{data.date_of_end | date:\'dd-MMM-yy\'}}</td><td style=width:125px>{{data.comments || \'--\'}}</td><!--<td>{{data.percentage_of_price_adj}}</td>--><!--<td>--><!--<span ng-if=\"data.status == 0\">Active</span>--><!--<span ng-if=\"data.status == 1\">Inactive</span>--><!--<span ng-if=\"data.status == 2\">In Progress</span>--><!--</td>--><td style=width:350px><a ng-if=\"vm.userType == 0\" ng-disabled=\"data.status == 1\" class=\"cursor btn btn-sm\" ng-class=\"{\'blockIconColor\': data.status == 1, \'unblockIconColor\': data.status == 0,\'editIconColor\': data.status == 2}\" ng-click=vm.changePriceListStatus(data,$event)><i ng-class=\"{\'fa fa-unlock\': data.status == 0,\'fa fa-clock-o\': data.status == 2,\'fa fa-lock\': data.status == 1}\"></i> </a><a title=\"View Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.agreementMain.fixedPriceListRouteDetails({corporateId:\'{{vm.corporateId}}\',contractId:\'{{vm.contractId}}\',priceListId:\'{{data.id}}\', path:\'0\'})\"><i class=\"fa fa-eye\"></i> </a><a ng-if=\"vm.userType == 0\" ng-disabled=\"data.status == 1 || data.status == 0\" title=\"Edit Details\" class=\"cursor editIconColor btn btn-sm\" ng-click=vm.editPriceListDetails(data)><i class=\"fa fa-edit\"></i> </a><a ng-if=\"vm.userType == 0\" ng-disabled=\"data.status == 1 || data.status == 0\" title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deletePriceList($event,data)><i class=\"fa fa-trash\"></i> </a><a ng-if=\"vm.userType == 0\" title=\"Stretch Details\" class=\"cursor btn blockIconColor btn-sm\" style=color:orange ui-sref=\"layout.agreementMain.fixedPriceListRouteDetails({corporateId:\'{{vm.corporateId}}\',contractId:\'{{vm.contractId}}\',priceListId:\'{{data.id}}\', path:\'0\'})\"><i class=\"fa fa-list\"></i> </a><a ng-if=\"vm.userType == 0\" class=\"btn btn-primary tableButton\" title=\"{{\'copyButton\' | translate}}\" ng-click=vm.copyPriceList(data,$event)>{{\'copyButton\' | translate}}</a> <a class=\"btn btn-primary tableButton\" title=\"{{\'exportButton\' | translate}}\" ng-click=vm.exportPriceList(data,$event)>{{\'exportButton\' | translate}}</a></td><td style=width:150px ng-if=\"vm.userType == 0\"><a class=\"btn btn-primary tableButton\" title=\"{{\'addStretchButton\' | translate}}\" ng-disabled=\"data.status != 2\" ui-sref=\"layout.agreementMain.fixedPriceListRoute({corporateId:\'{{vm.corporateId}}\',contractId:\'{{vm.contractId}}\',priceListId:\'{{data.id}}\', path:\'0\'})\">+ {{\'addStretchButton\' | translate}}</a></td><td style=width:150px ng-if=\"vm.userType == 0\"><a class=\"btn btn-primary tableButton\" title=\"Admin Logs\" ui-sref=\"layout.agreementMain.adminLogs({userId:\'{{data.id}}\',type:\'18\',fakeType: \'18\'})\" ng-click=vm.storeDetails()>{{\'adminLogs\' | translate}}</a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=9 class=\"noDataClass text-center\">{{\'noPriceListFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav ng-show=\"vm.watchPagination\">--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\" ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/agreement-route/fixedPriceListRoute.html","<h2 class=ng-cloak><span>{{\'agreementHead\' | translate}} / {{\'priceListHead1\' | translate}} / {{\'priceRouteHead1\' | translate}}</span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=employee><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 wordBreak\"><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><div class=\"row marginZero\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 paddingZero\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 informationDetails\"><div class=information>{{\'employeeAgreDetails\' | translate}}:</div><div class=details><div><span class=pull-left><span class=informName>{{\'agreementLabel\' | translate}}:</span> <span class=informDetail>{{::vm.contractName}}</span> </span><span class=pull-right><span class=informName>{{\'typeTableHead\' | translate}}:</span> <span class=informDetail>{{::vm.agreementType}}</span></span></div><div class=clearfix></div><div><span class=pull-left><span class=informName>{{\'companyTableHead\' | translate}}:</span> <span class=informDetail>{{::vm.corporateName}}</span> </span><span class=pull-right><span class=informName>{{\'stateAgreement\' | translate}}:</span> <span class=informDetail ng-if=\"vm.agreementStatus == 1\">Active</span> <span class=informDetail ng-if=\"vm.agreementStatus == 0\">Inactive</span></span></div><div class=clearfix></div><div><span class=pull-left style=width:60%><span class=informName>{{\'typeServiceHead\' | translate}}:</span> <span ng-repeat=\"data in vm.agreementServices\"><span class=\"informDetail ml5\">{{::data.type_of_service_id.service_name}}</span></span></span><div class=clearfix></div><span class=pull-left style=width:60%><span class=informName>{{\'branchesTableHead\' | translate}}:</span> <span ng-repeat=\"data in vm.agreementBranches\"><span class=\"informDetail ml5\">{{::data.region_name}}</span></span> </span><span class=pull-right><a class=\"btn btn-primary agreementButtons\" ng-click=vm.addMoreRoutes()>+ {{\'addStretchButton\' | translate}}</a></span></div><div class=clearfix></div></div><div class=information>{{\'detailsInRouteHead\' | translate}}:</div><div class=details><div><span class=pull-left><span class=informName>{{\'priceListNameLabel\' | translate}}:</span> <span class=informDetail>{{::vm.name}}</span> </span><span class=pull-right><span class=informName>{{\'period\' | translate}}:</span> <span class=informDetail>{{vm.startDate | date:\'dd-MMM-yy\'}} &nbsp;&nbsp;&nbsp;&nbsp; {{vm.endDate | date:\'dd-MMM-yy\'}}</span></span></div><div class=clearfix></div><div><span class=pull-left><span class=informName>{{\'priceListStatusLabel\' | translate}}:</span> <span class=informDetail ng-if=\"vm.status == 1\">Inactive</span> <span class=informDetail ng-if=\"vm.status == 0\">Active</span> <span class=informDetail ng-if=\"vm.status == 2\">In Progress</span></span></div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5 paddingZero\"><div class=basicDiv ng-if=vm.fixedRouteFlag><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'enterDetailsHead\' | translate}}</p><div class=basicDetailsDiv><form name=fixedRouteForm ng-submit=\"submit=true;fixedRouteForm.$valid&&vm.addFixedRouteHit()\" novalidate autocomplete=off><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'branchLabel\' | translate}}<span style=color:red>*</span></label><ui-select ng-model=vm.dataToFill.branchDetails name=branchList required ng-class=\"{ \'has-error\': fixedRouteForm.branchList.$touched && fixedRouteForm.branchList.$invalid }\" close-on-select=true ng-change=\"vm.branchChanged(\'0\')\"><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"data in vm.agreementBranches | filter: $select.search | orderBy:\'region_name\'\"><div ng-bind-html=data.region_name></div></ui-select-choices></ui-select><div ng-if=\"fixedRouteForm.branchList.$touched|| submit\" ng-messages=fixedRouteForm.branchList.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'branchR\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 searchRoute\"><label class=control-label>{{\'routes\' | translate}}<span style=color:red>*</span></label><input type=text ng-model=vm.dataToFill.actualRoute placeholder=\"{{\'routeSelect\' | translate}}\" uib-typeahead=\"routes as routes.name for routes in vm.searchRoutesInput($viewValue,\'add\',0,30,true)\" typeahead-loading=loadingRoutes typeahead-no-results=noResults class=form-control name=routeList typeahead-on-select=vm.onSelectingRoute() typeahead-wait-ms=200 ng-disabled=vm.routeDisabled typeahead-template-url=customTemplate.html required ng-class=\"{ \'has-error\': fixedRouteForm.routeList.$touched && fixedRouteForm.routeList.$invalid }\"><!--typeahead-template-url vm.allCustomersList--> <i ng-if=loadingRoutes class=\"glyphicon glyphicon-refresh\"></i><div ng-if=noResults class=mt5><span><i class=\"glyphicon glyphicon-remove\"></i> {{\'searchCustError\' | translate}}</span></div><!--<ui-select ng-model=\"vm.dataToFill.routeDetails\" name=\"routeList\" required ng-class=\"{ \'has-error\': fixedRouteForm.routeList.$touched && fixedRouteForm.routeList.$invalid }\"--><!--close-on-select=\"true\" ng-change=\"vm.selectedRouteFromList()\"  ng-disabled=\"vm.routeDisabled\">--><!--<ui-select-match placeholder=\"{{\'routeSelect\' | translate}}\">{{$select.selected.name}}</ui-select-match>--><!--<ui-select-choices repeat=\"data in vm.routeList | filter: $select.search | orderBy:\'name\'\">--><!--<div ng-bind-html=\"data.name\"></div>--><!--</ui-select-choices>--><!--</ui-select>--><div ng-if=\"fixedRouteForm.routeList.$touched|| submit\" ng-messages=fixedRouteForm.routeList.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'routesReq\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label>{{\'serviceLabel\' | translate}}<span style=color:red>*</span></label><ui-select multiple ng-model=vm.dataToFill.type_of_service_id theme=bootstrap close-on-select=false required name=typeOfService ng-class=\"{ \'has-error\': fixedRouteForm.typeOfService.$touched && fixedRouteForm.typeOfService.$invalid }\"><ui-select-match placeholder=\"{{\'selectTService\' | translate}}\" style=width:100%>{{$item.type_of_service_id.service_name}}</ui-select-match><ui-select-choices repeat=\"data.type_of_service_id.id as data in vm.serviceList | filter:$select.search\">{{data.type_of_service_id.service_name}}</ui-select-choices></ui-select><div ng-if=\"fixedRouteForm.typeOfService.$touched|| submit\" ng-messages=fixedRouteForm.typeOfService.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'serviceReq\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'price\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.price name=price placeholder=\"{{\'price\' | translate}}\" required ng-class=\"{ \'has-error\': fixedRouteForm.price.$touched && fixedRouteForm.price.$invalid }\" number-dot=\"\" maxlength=8><div ng-if=\"fixedRouteForm.price.$touched|| submit\" ng-messages=fixedRouteForm.price.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'priceReq\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please--><!--enter a valid price.--><!--</div>--></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label>{{\'comments\' | translate}}</label><textarea style=height:100px placeholder=\"{{\'messagePlaceholder\' | translate}}\" ng-model=vm.dataToFill.comments class=form-control name=comments ng-class=\"{ \'has-error\': fixedRouteForm.comments.$touched && fixedRouteForm.comments.$invalid }\"></textarea></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" style=margin-top:10px><button type=submit class=\"btn btn-primary\" style=width:30%>{{\'submit\' | translate}}</button> <button type=button ng-click=vm.cancel() class=\"btn btn-danger\" style=width:30%>{{\'cancelButton\' | translate}}</button></div></div></div><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6\"><div id=googleMap style=width:100%;height:500px></div></div></div></form></div></div><div class=basicDiv ng-if=vm.editFixedRouteDetailsFlag><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'editDetailsButton\' | translate}}</p><div class=basicDetailsDiv><form name=editFixedRouteForm ng-submit=\"submit=true;editFixedRouteForm.$valid&&vm.editFixedRouteDetailsHit()\" novalidate autocomplete=off><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'branchLabel\' | translate}}<span style=color:red>*</span></label><ui-select ng-model=vm.dataToFill.branchDetails name=branchList required ng-class=\"{ \'has-error\': editFixedRouteForm.branchList.$touched && editFixedRouteForm.branchList.$invalid }\" close-on-select=true ng-change=\"vm.branchChanged(\'0\')\"><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"data in vm.agreementBranches | filter: $select.search | orderBy:\'region_name\'\"><div ng-bind-html=data.region_name></div></ui-select-choices></ui-select><div ng-if=\"editFixedRouteForm.branchList.$touched|| submit\" ng-messages=editFixedRouteForm.branchList.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'branchR\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 searchRoute\"><label class=control-label>{{\'routes\' | translate}}<span style=color:red>*</span></label><input type=text ng-model=vm.dataToFill.actualRoute placeholder=\"{{\'routeSelect\' | translate}}\" uib-typeahead=\"routes as routes.name for routes in vm.searchRoutesInput($viewValue,\'edit\',0,30,true)\" typeahead-loading=loadingRoutes typeahead-no-results=noResults class=form-control name=routeList typeahead-on-select=vm.onSelectingRoute() typeahead-wait-ms=200 ng-disabled=vm.routeDisabled typeahead-template-url=customTemplate.html required ng-class=\"{ \'has-error\': editFixedRouteForm.routeList.$touched && editFixedRouteForm.routeList.$invalid }\"><!--typeahead-template-url vm.allCustomersList--> <i ng-if=loadingRoutes class=\"glyphicon glyphicon-refresh\"></i><div ng-if=noResults class=mt5><span><i class=\"glyphicon glyphicon-remove\"></i> {{\'searchCustError\' | translate}}</span></div><!--<ui-select ng-model=\"vm.dataToFill.route_id\" name=\"routeList\" required ng-class=\"{ \'has-error\': editFixedRouteForm.routeList.$touched && editFixedRouteForm.routeList.$invalid }\"--><!--close-on-select=\"true\" ng-change=\"vm.selectedRouteFromList(1)\"  ng-disabled=\"vm.routeDisabled\">--><!--<ui-select-match placeholder=\"{{\'routeSelect\' | translate}}\">{{$select.selected.name}}</ui-select-match>--><!--<ui-select-choices repeat=\"data.id as data in vm.routeList | filter: $select.search | orderBy:\'name\'\">--><!--<div ng-bind-html=\"data.name\"></div>--><!--</ui-select-choices>--><!--</ui-select>--><div ng-if=\"editFixedRouteForm.routeList.$touched|| submit\" ng-messages=editFixedRouteForm.routeList.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'routesReq\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label>{{\'serviceLabel\' | translate}}<span style=color:red>*</span></label><ui-select multiple ng-model=vm.dataToFill.type_of_service_id theme=bootstrap close-on-select=false required name=typeOfService ng-class=\"{ \'has-error\': editFixedRouteForm.typeOfService.$touched && editFixedRouteForm.typeOfService.$invalid }\"><ui-select-match placeholder=\"{{\'selectTService\' | translate}}\" style=width:100%>{{$item.type_of_service_id.service_name}}</ui-select-match><ui-select-choices repeat=\"data.type_of_service_id.id as data in vm.serviceList | filter:$select.search\">{{data.type_of_service_id.service_name}}</ui-select-choices></ui-select><div ng-if=\"editFixedRouteForm.typeOfService.$touched|| submit\" ng-messages=editFixedRouteForm.typeOfService.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'serviceReq\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'price\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.price name=price placeholder=\"{{\'price\' | translate}}\" required ng-class=\"{ \'has-error\': editFixedRouteForm.price.$touched && editFixedRouteForm.price.$invalid }\" number-dot=\"\" maxlength=8><div ng-if=\"editFixedRouteForm.price.$touched|| submit\" ng-messages=editFixedRouteForm.price.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'priceReq\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please--><!--enter a valid price.--><!--</div>--></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label>{{\'comments\' | translate}}</label><textarea style=height:100px placeholder=\"{{\'messagePlaceholder\' | translate}}\" ng-model=vm.dataToFill.comments class=form-control name=comments ng-class=\"{ \'has-error\': editFixedRouteForm.comments.$touched && editFixedRouteForm.comments.$invalid }\"></textarea></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" style=margin-top:10px><button type=submit class=\"btn btn-primary\" style=width:30%>{{\'submit\' | translate}}</button> <button type=button ng-click=vm.cancel() class=\"btn btn-danger\" style=width:30%>{{\'cancelButton\' | translate}}</button></div></div></div><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6\"><div id=googleMapEdit style=width:100%;height:500px></div></div></div></form></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 paddingZero mt5\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-3 col-md-3 col-lg-3 col-xs-12\"><label class=control-label style=\"visibility: hidden\">SS</label><div class=input-group><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText1 class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-3 col-md-3 col-lg-3 col-xs-12 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div><div class=\"col-lg-2 col-sm-2 col-md-2 col-xs-12\"><label class=control-label>{{\'priceRouteStatusLabel\' | translate}}</label><select class=form-control ng-model=vm.filterData.priceListRouteStatus ng-change=\"vm.getFixedRoutePriceList(0,10,vm.filterData);vm.currentPage=0;vm.itemsPerPageSelected=10;\"><option value=\"\" disabled>{{\'priceRouteStatusPlace\' | translate}}</option><option value=2>All</option><option selected value=1>Active</option><option value=0>Inactive</option></select></div><div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\"><label>{{\'branchLabel\' | translate}}</label><ui-select ng-model=vm.filterData.branch_id name=branch required close-on-select=true ng-change=\"vm.getFixedRoutePriceList(0,10,vm.filterData);vm.currentPage=0;vm.itemsPerPageSelected=10;\"><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"data.region_id as data in vm.branchListFilterGot | filter:$select.search | orderBy: \'region_name\'\"><div ng-bind-html=data.region_name></div></ui-select-choices></ui-select></div><div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\"><label>{{\'serviceLabel\' | translate}}</label><ui-select ng-model=vm.filterData.type_of_service name=typeOfService required close-on-select=true ng-change=\"vm.getFixedRoutePriceList(0,10,vm.filterData);vm.currentPage=0;vm.itemsPerPageSelected=10;\"><ui-select-match placeholder=\"{{\'selectTService\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in vm.serviceListFilterGot | filter:$select.search\"><div ng-bind-html=data.name></div></ui-select-choices></ui-select></div></div><div class=\"table-responsive tableWithMasterDataParentDive col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-switch=\"(vm.fixedRoutePriceGot | filter:vm.search).length\"><div ng-switch-when=0 class=\"noSearch text-center\"><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'branchLabel\' | translate}}\" text=\"\'route_id.branch_name\'\" check=vm.reverse>{{\'branchLabel\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'stretchLabel\' | translate}}\" text=\"\'route_id\'\" check=vm.reverse>{{\'stretchLabel\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'serviceLabel\' | translate}}\" text=\"\'typeOfService\'\" check=vm.reverse>{{\'serviceLabel\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'price\' | translate}}\" text=\"\'price\'\" check=vm.reverse>{{\'price\' | translate}}</th><th style=width:100px><div>{{\'stateTable\' | translate}}</div></th><th style=width:150px table-column-sorting current-text=vm.predicate title=\"{{\'itemChargeLabel\' | translate}}\" text=\"\'item_of_charge.price\'\" check=vm.reverse>{{\'itemChargeLabel\' | translate}}</th><th style=width:150px><div>{{\'action\' | translate}}</div></th><th style=width:150px><div>{{\'manageTableHead\' | translate}}</div></th><th style=width:150px><div>{{\'adminLogs\' | translate}}</div></th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.fixedRoutePriceGot| filter:vm.search | orderBy:vm.predicate:vm.reverse\"><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:70px>{{::data.id}}</td><!--<td>{{data.price_list_id.name}}</td>--><td style=width:100px>{{::data.route_id.branch_name}}</td><td style=width:125px>{{::data.route_id.name}}</td><td style=width:125px><span ng-repeat=\"dataG in data.typeOfService\">{{dataG.service_name}}<span ng-if=\"$index != data.typeOfService.length - 1\"><br></span></span></td><td style=width:125px>${{::data.price}}</td><td style=width:100px><a class=\"cursor btn btn-sm\" ng-class=\"{\'blockIconColor\': data.status == 0, \'unblockIconColor\': data.status == 1}\" ng-click=vm.changePriceListRouteStatus(data,$event)><i ng-class=\"{\'fa fa-unlock\': data.status == 1,\'fa fa-lock\': data.status == 0}\"></i></a></td><td style=width:150px><div class=displayFlex ng-if=\"data.item_of_charge && data.item_of_charge.length\" ng-repeat=\"itemsList in data.item_of_charge\"><div style=width:70%><b>Name: </b>{{itemsList.long_name}}<br><b>Price: </b><span ng-if=\"itemsList.id != 2 \">${{itemsList.price}}</span> <span ng-if=\"itemsList.id == 2 && itemsList.toll_charge_way == 2\">Precio real</span> <span ng-if=\"itemsList.id == 2 && itemsList.toll_charge_way == 1\">${{itemsList.price}}</span></div><div class=pull-right><a title=\"Delete Price List\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteItemOfCharge($event,data,itemsList)><i class=\"fa fa-trash\"></i></a></div><span ng-if=\"$index != data.item_of_charge.length - 1\"><hr></span></div><div ng-if=\"data.item_of_charge.length == 0\">No item of charge found</div></td><td style=width:150px><a title=\"Edit Details\" class=\"cursor editIconColor btn btn-sm\" ng-click=vm.editRouteBranchDetails(data)><i class=\"fa fa-edit\"></i> </a><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteRouteAndBranch($event,data)><i class=\"fa fa-trash\"></i> </a><a title=\"Route View\" class=\"cursor blockIconColor btn btn-sm\" style=color:green ng-click=vm.showBranchOnMap(data,$event)><i class=\"fa fa-map\"></i></a></td><td style=width:150px><a class=\"btn btn-primary tableButton\" ng-click=vm.addItemOfCharge(data,$event) title=\"Item of Charge\">+ {{\'itemOfCharge\' | translate}}</a></td><td style=width:150px><a class=\"btn btn-primary tableButton\" title=\"{{\'adminLogs\' | translate}}\" ui-sref=\"layout.agreementMain.adminLogs({userId:\'{{data.id}}\',type:\'9\',fakeType: \'20\'})\" ng-click=vm.storeDetails()>{{\'adminLogs\' | translate}}</a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=9 class=\"noDataClass text-center\">{{\'fixedPriceNotFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav ng-show=\"vm.watchPagination\">--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\" ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div></div></div></div><!--<script type=\"text/ng-template\" id=\"customTemplate.html\">--><!--<a style=\"cursor: pointer;\">--><!--<span class=\"displayFlex\">--><!--<span style=\"padding-left: 10px;\">--><!--<span ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"></span>--><!--</span>--><!--</span>--><!--</a>--><!--</script>--><!--when-scrolled=\"$parent.$parent.vm.paginationFunction()\"--><script type=text/ng-template id=customTemplate.html><!--<div class=\"custom-popup-wrapper\"-->\n         <!--ng-style=\"{top: position().top+\'px\', left: position().left+\'px\'}\"-->\n         <!--style=\"display: block;\"-->\n         <!--ng-if=\"isOpen() && !moveInProgress\"-->\n         <!--aria-hidden=\"{{!isOpen()}}\" >-->\n\n        <!--<ul class=\"dropdown-menu\" role=\"listbox\" >-->\n            <!--<li class=\"uib-typeahead-match\" ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\"-->\n                <!--ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index)\" role=\"option\" id=\"{{::match.name}}\">-->\n                <!--<div uib-typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div>-->\n            <!--</li>-->\n        <!--</ul>-->\n    <!--</div>-->\n\n    <a style=\"cursor: pointer;\">\n        <span ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"></span>\n    </a></script>");
$templateCache.put("app/components/views/agreement-route/fixedPriceListRouteDetails.html","<h2 class=ng-cloak><span>{{\'agreementHead\' | translate}} / {{\'priceListHead1\' | translate}} / {{\'priceRouteHead1\' | translate}}</span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=employee><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 wordBreak\"><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><div class=\"row marginZero\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 paddingZero\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 informationDetails\"><div class=information>{{\'employeeAgreDetails\' | translate}}:</div><div class=details><div><span class=pull-left><span class=informName>{{\'agreementLabel\' | translate}}:</span> <span class=informDetail>{{::vm.contractName}}</span> </span><span class=pull-right><span class=informName>{{\'typeTableHead\' | translate}}:</span> <span class=informDetail>{{::vm.agreementType}}</span></span></div><div class=clearfix></div><div><span class=pull-left><span class=informName>{{\'companyTableHead\' | translate}}:</span> <span class=informDetail>{{::vm.corporateName}}</span> </span><span class=pull-right><span class=informName>{{\'stateAgreement\' | translate}}:</span> <span class=informDetail ng-if=\"vm.agreementStatus == 1\">Active</span> <span class=informDetail ng-if=\"vm.agreementStatus == 0\">Inactive</span></span></div><div class=clearfix></div><div><span class=pull-left style=width:60%><span class=informName>{{\'typeServiceHead\' | translate}}:</span> <span ng-repeat=\"data in vm.agreementServices\"><span class=\"informDetail ml5\">{{::data}}</span></span></span><div class=clearfix></div><span class=pull-left style=width:60%><span class=informName>{{\'branchesTableHead\' | translate}}:</span> <span ng-repeat=\"data in vm.agreementBranches\"><span class=\"informDetail ml5\">{{::data}}</span></span> </span><!--<span class=\"pull-right\">--><!--<a class=\"btn btn-primary agreementButtons\" ng-click=\"vm.addMoreRoutes()\">+ {{\'addStretchButton\' | translate}}</a>--><!--</span>--></div><div class=clearfix></div></div><div class=information>{{\'detailsInRouteHead\' | translate}}:</div><div class=details><div><span class=pull-left><span class=informName>{{\'priceListNameLabel\' | translate}}:</span> <span class=informDetail>{{::vm.name}}</span> </span><span class=pull-right><span class=informName>{{\'period\' | translate}}:</span> <span class=informDetail>{{vm.startDate | date:\'dd-MMM-yy\'}} &nbsp;&nbsp;&nbsp;&nbsp; {{vm.endDate | date:\'dd-MMM-yy\'}}</span></span></div><div class=clearfix></div><div><span class=pull-left><span class=informName>{{\'priceListStatusLabel\' | translate}}:</span> <span class=informDetail ng-if=\"vm.status == 1\">Inactive</span> <span class=informDetail ng-if=\"vm.status == 0\">Active</span> <span class=informDetail ng-if=\"vm.status == 2\">In Progress</span></span></div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5 paddingZero\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 paddingZero mt5\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-3 col-md-3 col-lg-3 col-xs-12\"><label class=control-label style=\"visibility: hidden\">SS</label><div class=input-group><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText1 class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-3 col-md-3 col-lg-3 col-xs-12 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div><div class=\"col-lg-2 col-sm-2 col-md-2 col-xs-12\"><label class=control-label>{{\'priceRouteStatusLabel\' | translate}}</label><select class=form-control ng-model=vm.filterData.priceListRouteStatus ng-change=\"vm.getFixedRoutePriceList(0,10,vm.filterData);vm.currentPage=0;vm.itemsPerPageSelected=10;\"><option value=\"\" disabled>{{\'priceRouteStatusPlace\' | translate}}</option><option value=2>All</option><option selected value=1>Active</option><option value=0>Inactive</option></select></div><div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\"><label>{{\'branchLabel\' | translate}}</label><ui-select ng-model=vm.filterData.branch_id name=branch required close-on-select=true ng-change=\"vm.getFixedRoutePriceList(0,10,vm.filterData);vm.currentPage=0;vm.itemsPerPageSelected=10;\"><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"data.region_id as data in vm.branchListFilterGot | filter:$select.search | orderBy: \'region_name\'\"><div ng-bind-html=data.region_name></div></ui-select-choices></ui-select></div><div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\"><label>{{\'serviceLabel\' | translate}}</label><ui-select ng-model=vm.filterData.type_of_service name=typeOfService required close-on-select=true ng-change=\"vm.getFixedRoutePriceList(0,10,vm.filterData);vm.currentPage=0;vm.itemsPerPageSelected=10;\"><ui-select-match placeholder=\"{{\'selectTService\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in vm.serviceListFilterGot | filter:$select.search\"><div ng-bind-html=data.name></div></ui-select-choices></ui-select></div></div><div class=\"table-responsive tableWithMasterDataParentDive col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-switch=\"(vm.fixedRoutePriceGot | filter:vm.search).length\"><div ng-switch-when=0 class=\"noSearch text-center\"><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'branchLabel\' | translate}}\" text=\"\'route_id.branch_name\'\" check=vm.reverse>{{\'branchLabel\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'stretchLabel\' | translate}}\" text=\"\'route_id\'\" check=vm.reverse>{{\'stretchLabel\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'serviceLabel\' | translate}}\" text=\"\'typeOfService\'\" check=vm.reverse>{{\'serviceLabel\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'price\' | translate}}\" text=\"\'price\'\" check=vm.reverse>{{\'price\' | translate}}</th><th style=width:150px table-column-sorting current-text=vm.predicate title=\"{{\'itemChargeLabel\' | translate}}\" text=\"\'item_of_charge.price\'\" check=vm.reverse>{{\'itemChargeLabel\' | translate}}</th><th style=width:150px><div>{{\'adminLogs\' | translate}}</div></th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.fixedRoutePriceGot| filter:vm.search | orderBy:vm.predicate:vm.reverse\"><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:70px>{{::data.id}}</td><!--<td>{{data.price_list_id.name}}</td>--><td style=width:100px>{{::data.route_id.branch_name}}</td><td style=width:125px>{{::data.route_id.name}}</td><td style=width:125px><span ng-repeat=\"dataG in data.typeOfService\">{{dataG.service_name}}<span ng-if=\"$index != data.typeOfService.length - 1\"><br></span></span></td><td style=width:125px>${{::data.price}}</td><td style=width:150px><div class=displayFlex ng-if=\"data.item_of_charge && data.item_of_charge.length\" ng-repeat=\"itemsList in data.item_of_charge\"><div style=width:100%><b>Name: </b>{{itemsList.long_name}}<br><b>Price: </b>${{itemsList.price}}</div><span ng-if=\"$index != data.item_of_charge.length - 1\"><hr></span></div><div ng-if=\"data.item_of_charge.length == 0\">No item of charge found</div></td><td style=width:150px><a class=\"btn btn-primary tableButton\" title=\"{{\'adminLogs\' | translate}}\" ui-sref=\"layout.agreementMain.adminLogs({userId:\'{{data.id}}\',type:\'9\',fakeType: \'22\'})\" ng-click=vm.storeDetails()>{{\'adminLogs\' | translate}}</a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=9 class=\"noDataClass text-center\">{{\'fixedPriceNotFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav ng-show=\"vm.watchPagination\">--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\" ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/agreement-route/priceListTopHeadBar.html","<div class=\"informationDetails col-lg-12 col-sm-12 col-xs-12 col-md-12\"><div class=information><span>{{\'employeeAgreDetails\' | translate}}: </span><span style=float:right><span style=\"font-weight: bold;color:black\">Vía Controlada incluida en la Tarifa:</span> <span>{{vm.tarifaKey}}</span></span></div><div class=details><div><span class=pull-left><span class=informName>{{\'companyTableHead\' | translate}}:</span> <span class=informDetail>{{::vm.corporateName}}</span> </span><span class=pull-right><span class=informName>{{\'typeTableHead\' | translate}}:</span> <span class=informDetail>{{::vm.agreementType}}</span></span></div><div class=clearfix></div><div><span class=pull-left><span class=informName>{{\'agreementLabel\' | translate}}:</span> <span class=informDetail>{{::vm.contractName}}</span> </span><span class=pull-right><span class=informName>{{\'stateAgreement\' | translate}}:</span> <span class=informDetail ng-if=\"vm.agreementStatus == 1\">Active</span> <span class=informDetail ng-if=\"vm.agreementStatus == 0\">Inactive</span></span></div><div class=clearfix></div><div><span class=pull-left style=width:60%><span class=informName>{{\'typeServiceHead\' | translate}}:</span> <span ng-repeat=\"data in vm.agreementServices\"><span class=\"informDetail ml5\">{{::data}}</span></span></span><div class=clearfix></div><span class=pull-left style=width:60%><span class=informName>{{\'branchesTableHead\' | translate}}:</span> <span ng-repeat=\"data in vm.agreementBranches\"><span class=\"informDetail ml5\">{{::data}}</span></span> </span><span class=pull-right><a ng-if=\"vm.userType == 0\" class=\"btn btn-primary agreementButtons\" ng-click=vm.goToFactor()>Factor multiplicador</a> <a ng-if=\"vm.userType == 0\" class=\"btn btn-primary agreementButtons\" ng-click=vm.newListByPass()>+ {{\'newListButton\' | translate}}</a> <a ng-if=\"vm.userType == 0\" class=\"btn btn-primary agreementButtons\" ng-click=vm.readjustPrice($event) ng-disabled=\"vm.filterData.priceListStatus != 1\">{{\'readjustPrice\' | translate}}</a></span></div><div class=clearfix></div><div class=priceListCopyDiv ng-if=\"vm.variableNewListButtons || vm.fixedNewListButtons\"><button class=\"btn btn-primary\" ng-click=vm.addHeadersPriceDetails()>{{\'asEmptyPriceList\' | translate}}</button> <button class=\"btn btn-primary\" ng-click=vm.decidePopUpToOpen($event)>{{\'asBasedPriceList\' | translate}}</button></div></div></div>");
$templateCache.put("app/components/views/agreement-route/variablePriceListAgreement.html","<h2 class=ng-cloak><span>{{\'agreementHead\' | translate}} / {{\'priceListHead2\' | translate}}</span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=employee><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 wordBreak\"><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><div class=\"row marginZero\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 paddingZero\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div ng-include=\"\'app/components/views/agreement-route/priceListTopHeadBar.html\'\"></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=basicDiv ng-if=vm.addHeaderVFlag><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'createNewListHead\' | translate}}</p><div class=basicDetailsDiv><form name=HeaderVForm ng-submit=\"submit=true;HeaderVForm.$valid&&vm.addHeadersHitF()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'name\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFillHeader.type_of_pricing_list_name name=Name placeholder=\"{{\'name\' | translate}}\" required ng-maxlength=60 ng-minlength=3 ng-class=\"{ \'has-error\': HeaderVForm.Name.$touched && HeaderVForm.Name.$invalid }\"><div ng-if=\"HeaderVForm.Name.$touched|| submit\" ng-messages=HeaderVForm.Name.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'nameR\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid name.</div>--><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'firstNameMaximum\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'priceStartDateLabel\' | translate}}<span style=color:red>*</span></label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=priceStartValidity ng-model=vm.dataToFillHeader.type_of_pricing_date_of_start placeholder=\"{{\'priceStartDateLabel\' | translate}}\" is-open=vm.datePicker_1.startPriceH datepicker-options=vm.dateOptions required ng-class=\"{ \'has-error\': HeaderVForm.priceStartValidity.$touched && HeaderVForm.priceStartValidity.$invalid }\" close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'1\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"HeaderVForm.priceStartValidity.$touched|| submit\" ng-messages=HeaderVForm.priceStartValidity.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'priceStartDateReq\' | translate}}</div></div></div><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">Adjustment of Price (in %)<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFillHeader.type_of_pricing_list_percentage_of_price_adj\" name=\"priceAdjust\" maxlength=\"3\" is-number--><!--placeholder=\"Price Adjustment\" required ng-class=\"{ \'has-error\': HeaderVForm.priceAdjust.$touched && HeaderVForm.priceAdjust.$invalid }\" pattern=\"^[0-9][0-9]*$\"/>--><!--<div ng-if=\"HeaderVForm.priceAdjust.$touched|| submit\" ng-messages=\"HeaderVForm.priceAdjust.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter adjustment of price</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid adjustment of price.</div>--><!--</div>--><!--</div>--></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'priceEndDateLabel\' | translate}}<span style=color:red>*</span></label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=priceEndValidity ng-model=vm.dataToFillHeader.type_of_pricing_date_of_end placeholder=\"{{\'priceEndDateLabel\' | translate}}\" is-open=vm.datePicker_1.endPriceH datepicker-options=vm.dateOptions required ng-class=\"{ \'has-error\': HeaderVForm.priceEndValidity.$touched && HeaderVForm.priceEndValidity.$invalid }\" close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'2\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"HeaderVForm.priceEndValidity.$touched|| submit\" ng-messages=HeaderVForm.priceEndValidity.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'priceEndDateReq\' | translate}}</div></div></div></div><!--<div class=\"row mt5\">--><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label>Price Status<span style=\"color:red\">*</span></label>--><!--<select class=\"form-control\" ng-model=\"vm.dataToFillHeader.type_of_price_status\"--><!--name=\"priceStatus\" required  ng-class=\"{ \'has-error\': HeaderVForm.priceStatus.$touched && HeaderVForm.priceStatus.$invalid }\">--><!--<option value=\"\" disabled selected>Select Price Status</option>--><!--<option value=\"1\">Active</option>--><!--<option value=\"0\">Inactive</option>--><!--<option value=\"2\">In Progress</option>--><!--</select>--><!--<div ng-if=\"HeaderVForm.priceStatus.$touched|| submit\" ng-messages=\"HeaderVForm.priceStatus.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please select status.</div>--><!--</div>--><!--</div>--><!--</div>--><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label>{{\'comments\' | translate}}</label><textarea style=height:100px placeholder=\"{{\'messagePlaceholder\' | translate}}\" ng-model=vm.dataToFillHeader.type_of_pricing_comments class=form-control name=comments ng-class=\"{ \'has-error\': HeaderVForm.comments.$touched && HeaderVForm.comments.$invalid }\"></textarea></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" style=margin-top:10px><button type=submit class=\"btn btn-primary\" style=width:30%>{{\'submit\' | translate}}</button> <button type=button ng-click=vm.cancel() class=\"btn btn-danger\" style=width:30%>{{\'cancelButton\' | translate}}</button></div></div></form></div></div><div class=basicDiv ng-if=vm.editHeaderVFlag><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'editHead\' | translate}}</p><div class=basicDetailsDiv><form name=editHeaderVForm ng-submit=\"submit=true;editHeaderVForm.$valid&&vm.editVariableList()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'name\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFillHeader.type_of_pricing_list_name name=Name placeholder=Name required ng-maxlength=60 ng-minlength=3 ng-class=\"{ \'has-error\': editHeaderVForm.Name.$touched && editHeaderVForm.Name.$invalid }\"><div ng-if=\"editHeaderVForm.Name.$touched|| submit\" ng-messages=editHeaderVForm.Name.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'nameR\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid name.</div>--><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'firstNameMaximum\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'priceStartDateLabel\' | translate}}<span style=color:red>*</span></label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=priceStartValidity ng-model=vm.dataToFillHeader.type_of_pricing_date_of_start placeholder=\"{{\'priceStartDateLabel\' | translate}}\" is-open=vm.datePicker_1.startPriceH datepicker-options=vm.dateOptions required ng-class=\"{ \'has-error\': editHeaderVForm.priceStartValidity.$touched && editHeaderVForm.priceStartValidity.$invalid }\" close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'1\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"editHeaderVForm.priceStartValidity.$touched|| submit\" ng-messages=editHeaderVForm.priceStartValidity.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'priceStartDateReq\' | translate}}</div></div></div><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">Adjustment of Price (in %)<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFillHeader.type_of_pricing_list_percentage_of_price_adj\" name=\"priceAdjust\" maxlength=\"3\" is-number--><!--placeholder=\"Price Adjustment\" required ng-class=\"{ \'has-error\': editHeaderVForm.priceAdjust.$touched && editHeaderVForm.priceAdjust.$invalid }\" pattern=\"^[0-9][0-9]*$\"/>--><!--<div ng-if=\"editHeaderVForm.priceAdjust.$touched|| submit\" ng-messages=\"editHeaderVForm.priceAdjust.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter adjustment of price</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid adjustment of price.</div>--><!--</div>--><!--</div>--></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'priceEndDateLabel\' | translate}}<span style=color:red>*</span></label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=priceEndValidity ng-model=vm.dataToFillHeader.type_of_pricing_date_of_end placeholder=\"{{\'priceEndDateLabel\' | translate}}\" is-open=vm.datePicker_1.endPriceH datepicker-options=vm.dateOptions required ng-class=\"{ \'has-error\': editHeaderVForm.priceEndValidity.$touched && editHeaderVForm.priceEndValidity.$invalid }\" close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'2\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"editHeaderVForm.priceEndValidity.$touched|| submit\" ng-messages=editHeaderVForm.priceEndValidity.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'priceEndDateReq\' | translate}}</div></div></div></div><!--<div class=\"row mt5\">--><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label>Price Status<span style=\"color:red\">*</span></label>--><!--<select class=\"form-control\" ng-model=\"vm.dataToFillHeader.type_of_price_status\"--><!--name=\"priceStatus\" required  ng-class=\"{ \'has-error\': HeaderVForm.priceStatus.$touched && HeaderVForm.priceStatus.$invalid }\">--><!--<option value=\"\" disabled selected>Select Price Status</option>--><!--<option value=\"1\">Active</option>--><!--<option value=\"0\">Inactive</option>--><!--<option value=\"2\">In Progress</option>--><!--</select>--><!--<div ng-if=\"HeaderVForm.priceStatus.$touched|| submit\" ng-messages=\"HeaderVForm.priceStatus.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please select status.</div>--><!--</div>--><!--</div>--><!--</div>--><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label>{{\'comments\' | translate}}</label><textarea style=height:100px placeholder=\"{{\'messagePlaceholder\' | translate}}\" ng-model=vm.dataToFillHeader.type_of_pricing_comments class=form-control name=comments ng-class=\"{ \'has-error\': editHeaderVForm.comments.$touched && editHeaderVForm.comments.$invalid }\"></textarea></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" style=margin-top:10px><button type=submit class=\"btn btn-primary\" style=width:30%>{{\'submit\' | translate}}</button> <button type=button ng-click=vm.cancel() class=\"btn btn-danger\" style=width:30%>{{\'cancelButton\' | translate}}</button></div></div></form></div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-4 col-md-4 col-lg-4 col-xs-12\"><label class=control-label style=\"visibility: hidden\">HHH</label><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText1 class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-3 col-md-3 col-lg-3 col-xs-12 col-sm-offset-2 col-md-offset-2 col-lg-offset-2 col-xs-offset-0 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label class=control-label>{{\'priceListStatusLabel\' | translate}}</label><select class=form-control ng-model=vm.filterData.priceListStatus ng-change=\"vm.getAllVariablePriceList(0,10,vm.filterData.priceListStatus);vm.currentPage = 0;vm.itemsPerPageSelected=10;\"><option value=\"\" disabled>{{\'priceListStatusPlaceholder\' | translate}}</option><option value=3>All</option><option selected value=1>Active</option><option value=0>Inactive</option><option value=2>In Progress</option></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\" ng-switch=\"(vm.variableRouteListG | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'name\' | translate}}\" text=\"\'name\'\" check=vm.reverse>{{\'name\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'creationDate\' | translate}}\" text=\"\'creation_date\'\" check=vm.reverse>{{\'creationDate\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'tableStartDate\' | translate}}\" text=\"\'date_of_start\'\" check=vm.reverse>{{\'tableStartDate\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'tableEndDate\' | translate}}\" text=\"\'date_of_end\'\" check=vm.reverse>{{\'tableEndDate\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'comments\' | translate}}\" text=\"\'comments\'\" check=vm.reverse>{{\'comments\' | translate}}</th><!--<th>--><!--<div ng-click=\"vm.sort(\'percentage_of_price_adj\')\">--><!--Price Adjustment (in %)--><!--<span ng-hide=\"vm.predicate == \'percentage_of_price_adj\' && vm.reverse || vm.predicate == \'percentage_of_price_adj\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'percentage_of_price_adj\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'percentage_of_price_adj\' && vm.reverse\" class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><!--<th>--><!--<div ng-click=\"vm.sort(\'status\')\">--><!--Status--><!--<span ng-hide=\"vm.predicate == \'status\' && vm.reverse || vm.predicate == \'status\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'status\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'status\' && vm.reverse\" class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><th style=width:350px><div>{{\'action\' | translate}}</div></th><th style=width:150px ng-if=\"vm.userType == 0\"><div>{{\'manageTableHead\' | translate}}</div></th><th style=width:150px ng-if=\"vm.userType == 0\"><div>{{\'adminLogs\' | translate}}</div></th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.variableRouteListG| filter:vm.search | orderBy:vm.predicate:vm.reverse\"><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:70px>{{::data.id}}</td><td style=width:125px>{{::data.name}}</td><td style=width:125px>{{data.creation_date | date:\'dd-MMM-yy HH:mm\'}}</td><td style=width:125px>{{data.date_of_start | date:\'dd-MMM-yy\'}}</td><td style=width:125px>{{data.date_of_end | date:\'dd-MMM-yy\'}}</td><td style=width:125px>{{data.comments || \'--\'}}</td><!--<td>{{data.percentage_of_price_adj}}</td>--><!--<td>--><!--<span ng-if=\"data.status == 0\">Active</span>--><!--<span ng-if=\"data.status == 1\">Inactive</span>--><!--<span ng-if=\"data.status == 2\">In Progress</span>--><!--</td>--><td style=width:350px><a ng-if=\"vm.userType == 0\" ng-disabled=\"data.status == 1\" class=\"cursor btn btn-sm\" ng-class=\"{\'blockIconColor\': data.status == 1, \'unblockIconColor\': data.status == 0 ,\'editIconColor\':data.status == 2}\" ng-click=vm.changePriceListStatus(data,$event)><i ng-class=\"{\'fa fa-unlock\': data.status == 0,\'fa fa-clock-o\': data.status == 2,\'fa fa-lock\': data.status == 1}\"></i> </a><a title=\"View Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.agreementMain.variablePriceListRouteDetails({corporateId:\'{{vm.corporateId}}\',contractId:\'{{vm.contractId}}\',priceListId:\'{{data.id}}\', path:\'1\'})\"><i class=\"fa fa-eye\"></i> </a><a ng-if=\"vm.userType == 0\" ng-disabled=\"data.status == 1 || data.status == 0\" title=\"Edit Details\" class=\"cursor editIconColor btn btn-sm\" ng-click=vm.editPriceListDetails(data)><i class=\"fa fa-edit\"></i> </a><a ng-if=\"vm.userType == 0\" ng-disabled=\"data.status == 1 || data.status == 0\" title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deletePriceList($event,data)><i class=\"fa fa-trash\"></i> </a><a ng-if=\"vm.userType == 0\" title=\"Item Details\" class=\"cursor btn blockIconColor btn-sm\" style=color:orange ui-sref=\"layout.agreementMain.variablePriceListRouteDetails({corporateId:\'{{vm.corporateId}}\',contractId:\'{{vm.contractId}}\',priceListId:\'{{data.id}}\', path:\'1\'})\"><i class=\"fa fa-list\"></i> </a><a ng-if=\"vm.userType == 0\" class=\"btn btn-primary tableButton\" title=\"{{\'copyButton\' | translate}}\" ng-click=vm.copyPriceListVariable(data,$event)>{{\'copyButton\' | translate}}</a> <a class=\"btn btn-primary tableButton\" title=\"{{\'exportButton\' | translate}}\" ng-click=vm.exportPriceList(data,$event,2)>{{\'exportButton\' | translate}}</a></td><td style=width:150px ng-if=\"vm.userType == 0\"><a class=\"btn btn-primary tableButton\" title=\"{{\'addItemButton\' | translate}}\" ng-disabled=\"data.status != 2\" ui-sref=\"layout.agreementMain.variablePriceListRoute({corporateId:\'{{vm.corporateId}}\',contractId:\'{{vm.contractId}}\',priceListId:\'{{data.id}}\', path:\'1\'})\">+ {{\'addItemButton\' | translate}}</a></td><td style=width:150px ng-if=\"vm.userType == 0\"><a class=\"btn btn-primary tableButton\" title=\"{{\'adminLogs\' | translate}}\" ui-sref=\"layout.agreementMain.adminLogs({userId:\'{{data.id}}\',type:\'18\',fakeType: \'19\'})\" ng-click=vm.storeDetails()>{{\'adminLogs\' | translate}}</a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=9 class=\"noDataClass text-center\">{{\'noPriceListFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav ng-show=\"vm.watchPagination\">--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\" ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/agreement-route/variablePriceListRoute.html","<h2 class=ng-cloak><span>{{\'agreementHead\' | translate}} / {{\'priceListHead2\' | translate}} / {{\'priceRouteHead2\' | translate}}</span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=employee><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 wordBreak\"><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><div class=\"row marginZero\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 paddingZero\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 informationDetails\"><div class=information>{{\'employeeAgreDetails\' | translate}}:</div><div class=details><div><span class=pull-left><span class=informName>{{\'agreementLabel\' | translate}}:</span> <span class=informDetail>{{::vm.contractName}}</span> </span><span class=pull-right><span class=informName>{{\'typeTableHead\' | translate}}:</span> <span class=informDetail>{{::vm.agreementType}}</span></span></div><div class=clearfix></div><div><span class=pull-left><span class=informName>{{\'companyTableHead\' | translate}}:</span> <span class=informDetail>{{::vm.corporateName}}</span> </span><span class=pull-right><span class=informName>{{\'stateAgreement\' | translate}}:</span> <span class=informDetail ng-if=\"vm.agreementStatus == 1\">Active</span> <span class=informDetail ng-if=\"vm.agreementStatus == 0\">Inactive</span></span></div><div class=clearfix></div><div><span class=pull-left style=width:60%><span class=informName>{{\'typeServiceHead\' | translate}}:</span> <span ng-repeat=\"data in vm.agreementServices\"><span class=\"informDetail ml5\">{{::data.type_of_service_id.service_name}}</span></span></span><div class=clearfix></div><span class=pull-left style=width:60%><span class=informName>{{\'branchesTableHead\' | translate}}:</span> <span ng-repeat=\"data in vm.agreementBranches\"><span class=\"informDetail ml5\">{{::data.region_name}}</span></span> </span><span class=pull-right><a class=\"btn btn-primary agreementButtons\" ng-click=\"vm.addMoreRoutes(\'2\')\">+ {{\'addItemButton\' | translate}}</a></span></div><div class=clearfix></div></div><div class=information>{{\'detailsInRouteHead\' | translate}}:</div><div class=details><div><span class=pull-left><span class=informName>{{\'priceListNameLabel\' | translate}}:</span> <span class=informDetail>{{::vm.name}}</span> </span><span class=pull-right><span class=informName>{{\'period\' | translate}}:</span> <span class=informDetail>{{vm.startDate | date:\'dd-MMM-yy\'}} &nbsp;&nbsp;&nbsp;&nbsp; {{vm.endDate | date:\'dd-MMM-yy\'}}</span></span></div><div class=clearfix></div><div><span class=pull-left><span class=informName>{{\'priceListStatusLabel\' | translate}}:</span> <span class=informDetail ng-if=\"vm.status == 1\">Inactive</span> <span class=informDetail ng-if=\"vm.status == 0\">Active</span> <span class=informDetail ng-if=\"vm.status == 2\">In Progress</span></span></div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5 paddingZero\"><div class=basicDiv ng-if=vm.variableRouteFlag><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'enterDetailsHead\' | translate}}</p><div class=basicDetailsDiv><form name=variableRouteForm ng-submit=\"submit=true;variableRouteForm.$valid&&vm.addVariableRouteHit()\" novalidate autocomplete=off><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'branchLabel\' | translate}} <span style=color:red>*</span></label><ui-select ng-model=vm.dataToFill.branch name=branchList required ng-class=\"{ \'has-error\': variableRouteForm.branchList.$touched && variableRouteForm.branchList.$invalid }\" close-on-select=true ng-change=\"vm.branchChanged(\'1\')\"><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"data.region_id as data in vm.agreementBranches | filter: $select.search | orderBy:\'region_name\'\"><div ng-bind-html=data.region_name></div></ui-select-choices></ui-select><div ng-if=\"variableRouteForm.branchList.$touched|| submit\" ng-messages=variableRouteForm.branchList.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'branchR\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'serviceLabel\' | translate}} <span style=color:red>*</span></label><ui-select multiple ng-model=vm.dataToFill.type_of_service_id theme=bootstrap close-on-select=false title=\"{{\'selectTService\' | translate}}\" required name=typeOfServiceId ng-class=\"{ \'has-error\': variableRouteForm.typeOfServiceId.$touched && variableRouteForm.typeOfServiceId.$invalid }\"><ui-select-match placeholder=\"{{\'selectTService\' | translate}}\">{{$item.type_of_service_id.service_name}}</ui-select-match><ui-select-choices repeat=\"data.type_of_service_id.id as data in vm.serviceList | filter:$select.search\">{{data.type_of_service_id.service_name}}</ui-select-choices></ui-select><div ng-if=\"variableRouteForm.typeOfServiceId.$touched|| submit\" ng-messages=variableRouteForm.typeOfServiceId.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'serviceReq\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'parameters\' | translate}}</label><div class=row><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4 col-lg-offset-2 col-xs-offset-2 col-md-offset-2 col-sm-offset-2\"><label>$ {{\'baseFareLabel\' | translate}}</label></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><input type=text ng-model=vm.dataToFill.baseFare number-dot=\"\" class=form-control placeholder=\"{{\'baseFareLabel\' | translate}}\"></div></div><div class=\"row mt5\"><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4 col-lg-offset-2 col-xs-offset-2 col-md-offset-2 col-sm-offset-2\"><label>$ {{\'kmFareLabel\' | translate}}</label></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><input type=text ng-model=vm.dataToFill.perKMChanges number-dot=\"\" class=form-control placeholder=\"{{\'kmFareLabel\' | translate}}\"></div></div><div class=\"row mt5\"><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4 col-lg-offset-2 col-xs-offset-2 col-md-offset-2 col-sm-offset-2\"><label>$ {{\'waitInitialTimeLabel\' | translate}}</label></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><input type=text ng-model=vm.dataToFill.waitTimeCharges number-dot=\"\" class=form-control placeholder=\"{{\'waitInitialTimeLabel\' | translate}}\"></div></div><div class=\"row mt5\"><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4 col-lg-offset-2 col-xs-offset-2 col-md-offset-2 col-sm-offset-2\"><label>$ {{\'waitTripTimeLabel\' | translate}}</label></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><input type=text ng-model=vm.dataToFill.waitTimeInTrip number-dot=\"\" class=form-control placeholder=\"{{\'waitTripTimeLabel\' | translate}}\"></div></div><div class=\"row mt5\"><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4 col-lg-offset-2 col-xs-offset-2 col-md-offset-2 col-sm-offset-2\"><label>$ {{\'minimalFareLabel\' | translate}}</label></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><input type=text ng-model=vm.dataToFill.minimumFare number-dot=\"\" class=form-control placeholder=\"{{\'minimalFareLabel\' | translate}}\"></div></div><div class=\"row mt5\"><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4 col-lg-offset-2 col-xs-offset-2 col-md-offset-2 col-sm-offset-2\"><label>$ {{\'timeOfTripPrice\' | translate}}</label></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><input type=text ng-model=vm.dataToFill.time_of_trip_price number-dot=\"\" class=form-control placeholder=\"{{\'timeOfTripPrice\' | translate}}\"></div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label>{{\'comments\' | translate}}</label><textarea style=height:100px placeholder=\"{{\'messagePlaceholder\' | translate}}\" ng-model=vm.dataToFill.comments class=form-control name=comments ng-class=\"{ \'has-error\': variableRouteForm.comments.$touched && variableRouteForm.comments.$invalid }\"></textarea></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" style=margin-top:10px><button type=submit class=\"btn btn-primary\" style=width:30%>{{\'submit\' | translate}}</button> <button type=button ng-click=vm.cancel() class=\"btn btn-danger\" style=width:30%>{{\'cancelButton\' | translate}}</button></div></div></form></div></div><div class=basicDiv ng-if=vm.editVariableRouteDetailsFlag><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'editDetailsButton\' | translate}}</p><div class=basicDetailsDiv><form name=editVariableRouteForm ng-submit=\"submit=true;editVariableRouteForm.$valid&&vm.editVariableRouteDetailsHit()\" novalidate autocomplete=off><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'branchLabel\' | translate}} <span style=color:red>*</span></label><ui-select ng-model=vm.dataToFill.branch name=branchList required ng-class=\"{ \'has-error\': editVariableRouteForm.branchList.$touched && editVariableRouteForm.branchList.$invalid }\" close-on-select=true ng-change=\"vm.branchChanged(\'1\')\"><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"data.region_id as data in vm.agreementBranches | filter: $select.search | orderBy:\'region_name\'\"><div ng-bind-html=data.region_name></div></ui-select-choices></ui-select><div ng-if=\"editVariableRouteForm.branchList.$touched|| submit\" ng-messages=editVariableRouteForm.branchList.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'branchR\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'serviceLabel\' | translate}} <span style=color:red>*</span></label><ui-select multiple ng-model=vm.dataToFill.type_of_service_id theme=bootstrap close-on-select=false title=\"{{\'selectTService\' | translate}}\" required name=typeOfServiceId ng-class=\"{ \'has-error\': editVariableRouteForm.typeOfServiceId.$touched && editVariableRouteForm.typeOfServiceId.$invalid }\"><ui-select-match placeholder=\"{{\'selectTService\' | translate}}\">{{$item.type_of_service_id.service_name}}</ui-select-match><ui-select-choices repeat=\"data.type_of_service_id.id as data in vm.serviceList | filter:$select.search\">{{data.type_of_service_id.service_name}}</ui-select-choices></ui-select><div ng-if=\"editVariableRouteForm.typeOfServiceId.$touched|| submit\" ng-messages=editVariableRouteForm.typeOfServiceId.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'serviceReq\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'parameters\' | translate}}</label><div class=row><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4 col-lg-offset-2 col-xs-offset-2 col-md-offset-2 col-sm-offset-2\"><label>$ {{\'baseFareLabel\' | translate}}</label></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><input type=text ng-model=vm.dataToFill.baseFare number-dot=\"\" class=form-control placeholder=\"{{\'baseFareLabel\' | translate}}\"></div></div><div class=\"row mt5\"><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4 col-lg-offset-2 col-xs-offset-2 col-md-offset-2 col-sm-offset-2\"><label>$ {{\'Fare By Kilometer\' | translate}}</label></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><input type=text ng-model=vm.dataToFill.perKMChanges number-dot=\"\" class=form-control placeholder=\"{{\'Fare By Kilometer\' | translate}}\"></div></div><div class=\"row mt5\"><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4 col-lg-offset-2 col-xs-offset-2 col-md-offset-2 col-sm-offset-2\"><label>$ {{\'waitInitialTimeLabel\' | translate}}</label></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><input type=text ng-model=vm.dataToFill.waitTimeCharges number-dot=\"\" class=form-control placeholder=\"{{\'waitInitialTimeLabel\' | translate}}\"></div></div><div class=\"row mt5\"><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4 col-lg-offset-2 col-xs-offset-2 col-md-offset-2 col-sm-offset-2\"><label>$ {{\'waitTripTimeLabel\' | translate}}</label></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><input type=text ng-model=vm.dataToFill.waitTimeInTrip number-dot=\"\" class=form-control placeholder=\"{{\'waitTripTimeLabel\' | translate}}\"></div></div><div class=\"row mt5\"><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4 col-lg-offset-2 col-xs-offset-2 col-md-offset-2 col-sm-offset-2\"><label>$ {{\'minimalFareLabel\' | translate}}</label></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><input type=text ng-model=vm.dataToFill.minimumFare number-dot=\"\" class=form-control placeholder=\"{{\'minimalFareLabel\' | translate}}\"></div></div><div class=\"row mt5\"><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4 col-lg-offset-2 col-xs-offset-2 col-md-offset-2 col-sm-offset-2\"><label>$ {{\'timeOfTripPrice\' | translate}}</label></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><input type=text ng-model=vm.dataToFill.time_of_trip_price number-dot=\"\" class=form-control placeholder=\"{{\'timeOfTripPrice\' | translate}}\"></div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label>{{\'comments\' | translate}}</label><textarea style=height:100px placeholder=\"{{\'messagePlaceholder\' | translate}}\" ng-model=vm.dataToFill.comments class=form-control name=comments ng-class=\"{ \'has-error\': editVariableRouteForm.comments.$touched && editVariableRouteForm.comments.$invalid }\"></textarea></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" style=margin-top:10px><button type=submit class=\"btn btn-primary\" style=width:30%>{{\'submit\' | translate}}</button> <button type=button ng-click=vm.cancel() class=\"btn btn-danger\" style=width:30%>{{\'cancelButton\' | translate}}</button></div></div></form></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 paddingZero mt5\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-3 col-md-3 col-lg-3 col-xs-12\"><label class=control-label style=\"visibility: hidden\">JJJJ</label><div class=input-group><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-3 col-md-3 col-lg-3 col-xs-12 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div><div class=\"col-lg-2 col-sm-2 col-md-2 col-xs-12\"><label class=control-label>{{\'priceRouteStatusLabel\' | translate}}</label><select class=form-control ng-model=vm.filterData.priceListRouteStatus ng-change=\"vm.getVariableRoutePriceList(0,10,vm.filterData);vm.currentPage=0;vm.itemsPerPageSelected=10;\"><option value=\"\" disabled>{{\'priceRouteStatusPlace\' | translate}}</option><option value=2>All</option><option selected value=1>Active</option><option value=0>Inactive</option></select></div><div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\"><label>{{\'branchLabel\' | translate}}</label><ui-select ng-model=vm.filterData.branch_id name=branch required close-on-select=true ng-change=\"vm.getVariableRoutePriceList(0,10,vm.filterData);vm.currentPage=0;vm.itemsPerPageSelected=10;\"><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"data.region_id as data in vm.branchListFilterGot | filter:$select.search | orderBy: \'region_name\'\"><div ng-bind-html=data.region_name></div></ui-select-choices></ui-select></div><div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\"><label>{{\'serviceLabel\' | translate}}</label><ui-select ng-model=vm.filterData.type_of_service name=typeOfService required close-on-select=true ng-change=\"vm.getVariableRoutePriceList(0,10,vm.filterData);vm.currentPage=0;vm.itemsPerPageSelected=10;\"><ui-select-match placeholder=\"{{\'selectTService\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in vm.serviceListFilterGot | filter:$select.search\"><div ng-bind-html=data.name></div></ui-select-choices></ui-select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\" ng-switch=\"(vm.variableRoutePriceGot | filter:vm.search).length\"><div ng-switch-when=0 class=\"noSearch text-center\"><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'branchLabel\' | translate}}\" text=\"\'coverage_area_id\'\" check=vm.reverse>{{\'branchLabel\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'serviceLabel\' | translate}}\" text=\"\'typeOfService\'\" check=vm.reverse>{{\'serviceLabel\' | translate}}</th><th style=width:260px><div>{{\'parameters\' | translate}}</div></th><th style=width:150px table-column-sorting current-text=vm.predicate title=\"{{\'itemChargeLabel\' | translate}}\" text=\"\'item_of_charge.price\'\" check=vm.reverse>{{\'itemChargeLabel\' | translate}}</th><th style=width:150px><div>{{\'action\' | translate}}</div></th><th style=width:150px><div>Geocercas</div></th><th style=width:150px><div>{{\'manageTableHead\' | translate}}</div></th><th style=width:150px><div>{{\'adminLogs\' | translate}}</div></th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.variableRoutePriceGot| filter:vm.search | orderBy:vm.predicate:vm.reverse\"><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:70px>{{::data.id}}</td><!--<td>{{data.price_list_id.name}}</td>--><td style=width:100px>{{::data.coverage_area_data.region_name}}</td><td style=width:125px><span ng-repeat=\"dataG in data.typeOfService\">{{dataG.service_name}} <span ng-if=\"$index != data.typeOfService.length - 1\"><br></span></span></td><td style=width:260px><span>$ {{\'baseFareLabel\' | translate}}</span> <span class=pull-right>${{data.baseFare}}</span><br><span>$ {{\'kmFareLabel\' | translate}}</span> <span class=pull-right>${{data.perKMChanges}}</span><br><span>$ {{\'waitInitialTimeLabel\' | translate}}</span> <span class=pull-right>${{data.waitTimeCharges}}</span><br><span>$ {{\'waitTripTimeLabel\' | translate}}</span> <span class=pull-right>${{data.waitTimeInTrip}}</span><br><span>$ {{\'minimalFareLabel\' | translate}}</span> <span class=pull-right>${{data.minimumFare}}</span><br><span>$ {{\'timeOfTripPrice\' | translate}}</span> <span class=pull-right>${{data.time_of_trip_price}}</span><br></td><td style=width:150px><div class=displayFlex ng-if=\"data.item_of_charge && data.item_of_charge.length\" ng-repeat=\"itemsList in data.item_of_charge\"><div style=width:70%><b>Name: </b>{{itemsList.long_name}}<br><b>Price: </b><span ng-if=\"itemsList.id != 2 \">${{itemsList.price}}</span> <span ng-if=\"itemsList.id == 2 && itemsList.toll_charge_way == 2\">Precio real</span> <span ng-if=\"itemsList.id == 2 && itemsList.toll_charge_way == 1\">${{itemsList.price}}</span></div><div class=pull-right><a title=\"Delete Price List\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteItemOfCharge($event,data,itemsList)><i class=\"fa fa-trash\"></i></a></div><span ng-if=\"$index != data.item_of_charge.length - 1\"><hr></span></div><div ng-if=\"data.item_of_charge.length == 0 || !data.item_of_charge.length || !data.item_of_charge\">No item of charge found</div></td><td style=width:150px><a class=\"cursor btn btn-sm\" ng-class=\"{\'blockIconColor\': data.status == 0, \'unblockIconColor\': data.status == 1}\" ng-click=vm.changePriceListRouteStatus(data,$event)><i ng-class=\"{\'fa fa-unlock\': data.status == 1,\'fa fa-lock\': data.status == 0}\"></i> </a><a title=\"Edit Details\" class=\"cursor editIconColor btn btn-sm\" ng-click=vm.editRouteBranchDetails(data)><i class=\"fa fa-edit\"></i> </a><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteRouteAndBranch($event,data)><i class=\"fa fa-trash\"></i></a></td><td style=width:150px>{{data.itemsCount}}</td><td style=width:150px><a class=\"btn btn-primary tableButton\" ng-click=vm.addItemOfCharge(data,$event,1) title=\"Item of Charge\">+ {{\'itemOfCharge\' | translate}}</a> <a style=\"margin-top: 10px;    width: 173px\" class=\"btn btn-primary tableButton\" ng-click=vm.Geocercas(data,$event,1) title=\"Item of Charge\">+ Geocercas</a></td><td style=width:150px><a class=\"btn btn-primary tableButton\" title=\"{{\'adminLogs\' | translate}}\" ui-sref=\"layout.agreementMain.adminLogs({userId:\'{{data.id}}\',type:\'8\',fakeType: \'21\'})\" ng-click=vm.storeDetails()>{{\'adminLogs\' | translate}}</a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=9 class=\"noDataClass text-center\">{{\'variablePriceNotFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav ng-show=\"vm.watchPagination\">--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\" ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/agreement-route/variablePriceListRouteDetails.html","<h2 class=ng-cloak><span>{{\'agreementHead\' | translate}} / {{\'priceListHead2\' | translate}} / {{\'priceRouteHead2\' | translate}}</span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=employee><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 wordBreak\"><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><div class=\"row marginZero\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 paddingZero\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 informationDetails\"><div class=information>{{\'employeeAgreDetails\' | translate}}:</div><div class=details><div><span class=pull-left><span class=informName>{{\'agreementLabel\' | translate}}:</span> <span class=informDetail>{{::vm.contractName}}</span> </span><span class=pull-right><span class=informName>{{\'typeTableHead\' | translate}}:</span> <span class=informDetail>{{::vm.agreementType}}</span></span></div><div class=clearfix></div><div><span class=pull-left><span class=informName>{{\'companyTableHead\' | translate}}:</span> <span class=informDetail>{{::vm.corporateName}}</span> </span><span class=pull-right><span class=informName>{{\'stateAgreement\' | translate}}:</span> <span class=informDetail ng-if=\"vm.agreementStatus == 1\">Active</span> <span class=informDetail ng-if=\"vm.agreementStatus == 0\">Inactive</span></span></div><div class=clearfix></div><div><span class=pull-left style=width:60%><span class=informName>{{\'typeServiceHead\' | translate}}:</span> <span ng-repeat=\"data in vm.agreementServices\"><span class=\"informDetail ml5\">{{::data}}</span></span></span><div class=clearfix></div><span class=pull-left style=width:60%><span class=informName>{{\'branchesTableHead\' | translate}}:</span> <span ng-repeat=\"data in vm.agreementBranches\"><span class=\"informDetail ml5\">{{::data}}</span></span> </span><!--<span class=\"pull-right\">--><!--<a class=\"btn btn-primary agreementButtons\" ng-click=\"vm.addMoreRoutes(\'2\')\">+ {{\'addItemButton\' | translate}}</a>--><!--</span>--></div><div class=clearfix></div></div><div class=information>{{\'detailsInRouteHead\' | translate}}:</div><div class=details><div><span class=pull-left><span class=informName>{{\'priceListNameLabel\' | translate}}:</span> <span class=informDetail>{{::vm.name}}</span> </span><span class=pull-right><span class=informName>{{\'period\' | translate}}:</span> <span class=informDetail>{{vm.startDate | date:\'dd-MMM-yy\'}} &nbsp;&nbsp;&nbsp;&nbsp; {{vm.endDate | date:\'dd-MMM-yy\'}}</span></span></div><div class=clearfix></div><div><span class=pull-left><span class=informName>{{\'priceListStatusLabel\' | translate}}:</span> <span class=informDetail ng-if=\"vm.status == 1\">Inactive</span> <span class=informDetail ng-if=\"vm.status == 0\">Active</span> <span class=informDetail ng-if=\"vm.status == 2\">In Progress</span></span></div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5 paddingZero\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 paddingZero mt5\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-3 col-md-3 col-lg-3 col-xs-12\"><label class=control-label style=\"visibility: hidden\">JJJJ</label><div class=input-group><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-3 col-md-3 col-lg-3 col-xs-12 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div><div class=\"col-lg-2 col-sm-2 col-md-2 col-xs-12\"><label class=control-label>{{\'priceRouteStatusLabel\' | translate}}</label><select class=form-control ng-model=vm.filterData.priceListRouteStatus ng-change=\"vm.getVariableRoutePriceList(0,10,vm.filterData);vm.currentPage=0;vm.itemsPerPageSelected=10;\"><option value=\"\" disabled>{{\'priceRouteStatusPlace\' | translate}}</option><option value=2>All</option><option selected value=1>Active</option><option value=0>Inactive</option></select></div><div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\"><label>{{\'branchLabel\' | translate}}</label><ui-select ng-model=vm.filterData.branch_id name=branch required close-on-select=true ng-change=\"vm.getVariableRoutePriceList(0,10,vm.filterData);vm.currentPage=0;vm.itemsPerPageSelected=10;\"><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"data.region_id as data in vm.branchListFilterGot | filter:$select.search | orderBy: \'region_name\'\"><div ng-bind-html=data.region_name></div></ui-select-choices></ui-select></div><div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\"><label>{{\'serviceLabel\' | translate}}</label><ui-select ng-model=vm.filterData.type_of_service name=typeOfService required close-on-select=true ng-change=\"vm.getVariableRoutePriceList(0,10,vm.filterData);vm.currentPage=0;vm.itemsPerPageSelected=10;\"><ui-select-match placeholder=\"{{\'selectTService\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in vm.serviceListFilterGot | filter:$select.search\"><div ng-bind-html=data.name></div></ui-select-choices></ui-select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\" ng-switch=\"(vm.variableRoutePriceGot | filter:vm.search).length\"><div ng-switch-when=0 class=\"noSearch text-center\"><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'branchLabel\' | translate}}\" text=\"\'coverage_area_id\'\" check=vm.reverse>{{\'branchLabel\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'serviceLabel\' | translate}}\" text=\"\'typeOfService\'\" check=vm.reverse>{{\'serviceLabel\' | translate}}</th><th style=width:260px><div>{{\'parameters\' | translate}}</div></th><th style=width:150px table-column-sorting current-text=vm.predicate title=\"{{\'itemChargeLabel\' | translate}}\" text=\"\'item_of_charge.price\'\" check=vm.reverse>{{\'itemChargeLabel\' | translate}}</th><th style=width:150px><div>Geocercas</div></th><th style=width:150px><div>{{\'manageTableHead\' | translate}}</div></th><th style=width:150px><div>{{\'adminLogs\' | translate}}</div></th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.variableRoutePriceGot| filter:vm.search | orderBy:vm.predicate:vm.reverse\"><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:70px>{{::data.id}}</td><!--<td>{{data.price_list_id.name}}</td>--><td style=width:100px>{{::data.coverage_area_data.region_name}}</td><td style=width:125px><span ng-repeat=\"dataG in data.typeOfService\">{{dataG.service_name}}<span ng-if=\"$index != data.typeOfService.length - 1\"><br></span></span></td><td style=width:260px><span>$ {{\'baseFareLabel\' | translate}}</span><span class=pull-right>${{data.baseFare}}</span><br><span>$ {{\'kmFareLabel\' | translate}}</span><span class=pull-right>${{data.perKMChanges}}</span><br><span>$ {{\'waitInitialTimeLabel\' | translate}}</span><span class=pull-right>${{data.waitTimeCharges}}</span><br><span>$ {{\'waitTripTimeLabel\' | translate}}</span><span class=pull-right>${{data.waitTimeInTrip}}</span><br><span>$ {{\'minimalFareLabel\' | translate}}</span><span class=pull-right>${{data.minimumFare}}</span><br><span>$ {{\'timeOfTripPrice\' | translate}}</span><span class=pull-right>${{data.time_of_trip_price}}</span><br></td><td style=width:150px><div class=displayFlex ng-if=\"data.item_of_charge && data.item_of_charge.length\" ng-repeat=\"itemsList in data.item_of_charge\"><div style=width:100%><b>Name: </b>{{itemsList.long_name}}<br><b>Price: </b>${{itemsList.price}}</div><span ng-if=\"$index != data.item_of_charge.length - 1\"><hr></span></div><div ng-if=\"data.item_of_charge.length == 0 || !data.item_of_charge.length || !data.item_of_charge\">No item of charge found</div></td><td style=width:150px>{{data.itemsCount}}</td><td style=width:150px><!-- <a class=\"btn btn-primary tableButton\" ng-click=\"vm.addItemOfCharge(data,$event,1)\" title=\"Item of Charge\">+ {{\'itemOfCharge\' | translate}}</a> --> <a class=\"btn btn-primary tableButton\" ng-click=vm.Geocercas(data,$event,1) title=\"Item of Charge\" ng-if=\"data.price_list_data.status != 1\">+ Geocercas</a> <a class=\"btn btn-primary tableButton\" ng-click=vm.GeocercasView(data,$event,1) title=\"Item of Charge\" ng-if=\"data.price_list_data.status == 1\">Geocercas</a></td><td style=width:150px><a class=\"btn btn-primary tableButton\" title=\"{{\'adminLogs\' | translate}}\" ui-sref=\"layout.agreementMain.adminLogs({userId:\'{{data.id}}\',type:\'8\',fakeType: \'23\'})\" ng-click=vm.storeDetails()>{{\'adminLogs\' | translate}}</a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=9 class=\"noDataClass text-center\">{{\'variablePriceNotFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav ng-show=\"vm.watchPagination\">--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\" ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/applicants/applicantApprovalProcess.html","<!--<h2>--><!--{{\'approveDriverProcess.heading.main\' | translate}}--><!--</h2>--><h2 ng-if=\"vm.driverDetail.fleet_type == 0\" class=ng-cloak>{{\'approveApplicantHead1\' | translate}}</h2><h2 ng-if=\"vm.driverDetail.fleet_type == 2\" class=ng-cloak>{{\'approveApplicantHead2\' | translate}}</h2><h2 ng-if=\"vm.driverDetail.fleet_type == 1\" class=ng-cloak>{{\'approveApplicantHead3\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=driver><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button> <a class=\"btn btn-primary mb25\" style=\"background-color: #2f80e7;border-color: #2f80e7\" ui-sref=\"layout.applicantsMain.editApplicantsDetails({id:\'{{vm.fleet_id}}\',path:\'0\'})\">{{\'editDetailsButton\' | translate}}</a></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><div class=\"row marginZero\"><div class=\"col-lg-3 col-sm-3 col-xs-4 col-md-3 approvalProcessStages\" ng-class=\"{\'borderWidthPending\': vm.driverDetail.basicRegistration_status == 0,\'borderWidthRejected\': vm.driverDetail.basicRegistration_status == 2,\'borderWidthVerified\': vm.driverDetail.basicRegistration_status == 1}\">{{\'basicRegistartion\' | translate}}</div><div class=\"col-lg-3 col-sm-3 col-xs-4 col-md-3 approvalProcessStages\" ng-class=\"{\'borderWidthPending\': vm.driverDetail.documentation_status == 0,\'borderWidthRejected\': vm.driverDetail.documentation_status == 2,\'borderWidthVerified\': vm.driverDetail.documentation_status == 1}\">{{\'documents\' | translate}}</div><!-- <div class=\"col-lg-2 col-sm-4 col-xs-4 col-md-4 approvalProcessStages\" ng-class=\"{\'borderWidthPending\': vm.driverDetail.interview_status == 0,\'borderWidthRejected\': vm.driverDetail.interview_status == 2,\'borderWidthVerified\': vm.driverDetail.interview_status == 1}\">\n                            {{\'interview\' | translate}}\n                        </div> --><div class=\"col-lg-3 col-sm-3 col-xs-4 col-md-3 approvalProcessStages\" ng-class=\"{\'borderWidthPending\': vm.driverDetail.training_status == 0,\'borderWidthRejected\': vm.driverDetail.training_status == 2,\'borderWidthVerified\': vm.driverDetail.training_status == 1}\">{{\'training\' | translate}}</div><!-- <div class=\"col-lg-2 col-sm-4 col-xs-4 col-md-4 approvalProcessStages\" ng-if=\"vm.driverDetail.fleet_type!=1\"\n                            ng-class=\"{\'borderWidthPending\': vm.driverDetail.signOfContract_status == 0,\'borderWidthRejected\': vm.driverDetail.signOfContract_status == 2,\'borderWidthVerified\': vm.driverDetail.signOfContract_status == 1}\">\n                            {{\'signOfContract\' | translate}}\n                        </div> --><div class=\"col-lg-3 col-sm-3 col-xs-4 col-md-3 approvalProcessStages\" ng-class=\"{\'borderWidthPending\': vm.driverDetail.activation_status == 0,\'borderWidthRejected\': vm.driverDetail.activation_status == 2,\'borderWidthVerified\': vm.driverDetail.activation_status == 1}\">{{\'accountActivation\' | translate}}</div></div></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12 mt10\"><div class=basicDiv><p class=basicRegistrationP ng-class=\"{\'backgroundBasicPending\': vm.driverDetail.basicRegistration_status == 0,\'backgroundBasicNot\': vm.driverDetail.basicRegistration_status == 2,\'backgroundBasicVerified\': vm.driverDetail.basicRegistration_status == 1}\"><span>{{\'basicRegistartion\' | translate}}</span> <span class=pull-right ng-if=\"vm.driverDetail.basicRegistration_status == 0\">{{\'pending\' | translate}}</span> <span class=pull-right ng-if=\"vm.driverDetail.basicRegistration_status == 1\">{{\'approved\' | translate}}</span> <span class=pull-right ng-if=\"vm.driverDetail.basicRegistration_status == 2\">{{\'unapproved\' | translate}}</span></p><div class=basicDetailsDiv><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><img ng-src=\"{{vm.driverDetail.fleet_image || \'assets/images/noImage.jpeg\'}}\" class=profilePic title=\"{{\'profilePic\' | translate}}\"></div></div><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'name\' | translate}}:</label><div class=\"form-control text-capitalize\">{{vm.driverDetail.first_name + \" \" + vm.driverDetail.last_name}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'email\' | translate}}:</label><div class=form-control>{{::vm.driverDetail.email}}</div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'mobileNumber\' | translate}}:</label><div class=form-control>{{vm.driverDetail.country_code?vm.driverDetail.country_code + \"-\" + vm.driverDetail.phone:vm.driverDetail.phone}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'usernameLabel\' | translate}}:</label><div class=form-control>{{::vm.driverDetail.username}}</div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'address\' | translate}}:</label><div class=form-control>{{::vm.driverDetail.addressFormed}}</div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'applicantType\' | translate}}:</label><div class=form-control><span ng-if=\"vm.driverDetail.fleet_type == 0\">Driver with car</span> <span ng-if=\"vm.driverDetail.fleet_type == 1\">Driver without car</span> <span ng-if=\"vm.driverDetail.fleet_type == 2\">Car investor</span></div></div></div><div class=\"row mt5\" ng-hide=\"vm.driverDetail.fleet_type == 2\"><!-- ng-hide=\"vm.driverDetail.fleet_type == 2\"--><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'liceneClassLabel\' | translate}}:</label><div class=form-control>{{::vm.driverDetail.license_type}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'liceneExpiaryLabel\' | translate}}:</label><div class=form-control>{{vm.driverDetail.license_expiry_date | date:\'mediumDate\'}}</div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'cityOfWorkLabel\' | translate}}:</label><div class=form-control>{{vm.driverDetail.region_name || \'--\'}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=\"vm.driverDetail.fleet_type != 2\"><label class=control-label>{{\'invoiceRut\' | translate}}:</label><div class=form-control>{{::vm.driverDetail.invoice_rut}}</div></div><!-- <div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=\"vm.driverDetail.fleet_type == 0\">\n                                    <label class=\"control-label\">{{\'modalityOfworkLabel\' | translate}}: </label>\n                                    <div class=\"form-control\">\n                                        <span ng-if=\"vm.driverDetail.work_schedule == 0\">Part Time</span>\n                                        <span ng-if=\"vm.driverDetail.work_schedule == 1\">Full Time</span>\n                                    </div>\n                                </div> --><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">{{\'approveDriverProcess.approvalText.companyType\' |--><!--translate}}:</label>--><!--<div class=\"form-control\">{{vm.driverDetail.company_type || \'&#45;&#45;\'}}</div>--><!--</div>--></div><div class=\"row mt5\" ng-hide=\"vm.driverDetail.fleet_type == 2\"><!-- ng-hide=\"vm.driverDetail.fleet_type == 2\"--><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'rutLabel\' | translate}}:</label><div class=form-control>{{::vm.driverDetail.RUT}}</div></div><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">Company Type:</label>--><!--<div class=\"form-control\">{{vm.driverDetail.company_type || \'&#45;&#45;\'}}</div>--><!--</div>--></div><div class=row ng-hide=\"vm.driverDetail.fleet_type == 1\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'paymentModulityLabel\' | translate}}</label><div class=form-control><!-- <span ng-if=\"vm.driverDetail.payment_modulity == 1\">Bank Deposit</span>\n                                        <span ng-if=\"vm.driverDetail.payment_modulity == 2\">Vale View</span>  --> <span ng-if=\"vm.driverDetail.payment_modulity == 1\">1 Vale Vista</span> <span ng-if=\"vm.driverDetail.payment_modulity == 2\">3 Abono Cta Cte y Cta Vista</span> <span ng-if=\"vm.driverDetail.payment_modulity == 3\">4 Abono Cta Ahorro</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'bankLabel\' | translate}}</label><div class=form-control>{{::vm.driverDetail.bank_name}}</div></div><!-- <div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">\n                                    <label class=\"control-label\">{{\'accountTypeLabel\' | translate}}</label>\n                                    <div class=\"form-control\">\n                                        <span ng-if=\"vm.driverDetail.account_type == 1\">Electronic Cheque Book</span>\n                                        <span ng-if=\"vm.driverDetail.account_type == 2\">Saving Account</span>\n                                        <span ng-if=\"vm.driverDetail.account_type == 3\">Checking Account</span>\n                                    </div>\n                                </div> --><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'accountTypeLabel\' | translate}}</label><div class=form-control><span ng-if=vm.driverDetail.account_rut>{{::vm.driverDetail.account_rut}}</span> <span ng-if=\"vm.driverDetail.account_rut == null\">Conductor sin rut</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'accountNumberLabel\' | translate}}</label><div class=form-control>{{::vm.driverDetail.account_number}}</div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label class=control-label>{{\'adminComments\' | translate}}:</label><!--ng-show=\"vm.driverDetail.basicRegistration_status != 1\"--><textarea class=form-control ng-model=vm.driverDetail.basicRegistration_comments ng-disabled=\"vm.driverDetail.basicRegistration_status == 1\" placeholder=\"{{\'messagePlaceholder\' | translate}}\"></textarea></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" ng-if=\"vm.driverDetail.basicRegistration_status != 1\"><button class=\"btn btn-primary approve\" ng-click=\"vm.approveDisapproveSteps(1,\'BASIC\',$event,vm.driverDetail.basicRegistration_comments)\">{{\'approve\' | translate}}</button> <button class=\"btn btn-danger approve\" ng-click=\"vm.approveDisapproveSteps(2,\'BASIC\',$event,vm.driverDetail.basicRegistration_comments)\">{{\'unapproveButton\' | translate}}</button></div></div></div></div><div class=basicDiv><p class=basicRegistrationP ng-class=\"{\'backgroundBasicPending\': vm.driverDetail.documentation_status == 0,\'backgroundBasicNot\': vm.driverDetail.documentation_status == 2,\'backgroundBasicVerified\': vm.driverDetail.documentation_status == 1}\"><span>{{\'documents\' | translate}}</span> <span class=pull-right ng-if=\"vm.driverDetail.documentation_status == 0\">{{\'pending\' | translate}}</span> <span class=pull-right ng-if=\"vm.driverDetail.documentation_status == 1\">{{\'approved\' | translate}}</span> <span class=pull-right ng-if=\"vm.driverDetail.documentation_status == 2\">{{\'unapproved\' | translate}}</span></p><div class=basicDetailsDiv><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><ol><li ng-hide=\"vm.driverDetail.fleet_type == 2\"><!--ng-hide=\"vm.driverDetail.fleet_type == 2\"--><div class=displayFlex><div class=widthDiv>{{\'rutLabel\' | translate}}<br class=showBr><span class=colorPending ng-if=\"vm.driverDetail.identity_card_RUT_status == 0\">({{\'pending\' | translate}}) </span><span class=colorVerified ng-if=\"vm.driverDetail.identity_card_RUT_status == 1\">({{\'approve\' | translate}}) </span><span class=colorNot ng-if=\"vm.driverDetail.identity_card_RUT_status == 2\">({{\'unapproveButton\' | translate}})</span> <span class=colorUpload ng-if=\"vm.driverDetail.identity_card_RUT_status == 3\">({{\'uploadAgain\' | translate}})</span></div><div class=\"widthDiv1 text-right\"><a class=\"cursor btn btn-sm editIconColor\" ng-disabled=!vm.driverDetail.RUT_image href={{vm.driverDetail.RUT_image}} target=_blank><i class=\"fa fa-eye\"></i></a> <a class=\"cursor btn btn-sm editIconColor\" ng-disabled=\"vm.driverDetail.documentation_status == 1\" ng-click=\"vm.showEditDocumentDialog($event,vm.driverDetail.RUT_image,\'RUT\')\"><i class=\"fa fa-edit\"></i></a> <a class=\"btn btn-primary approve cursor btn btn-sm editIconColor\" ng-disabled=\"vm.driverDetail.identity_card_RUT_status == 1 || !vm.driverDetail.RUT_image\" ng-click=\"vm.approveDocument(1,\'RUT\',$event)\"><i class=\"fa fa-check\"></i></a><br class=showBr><a class=\"btn btn-danger approve cursor btn btn-sm editIconColor\" ng-disabled=\"vm.driverDetail.identity_card_RUT_status == 2 || vm.driverDetail.documentation_status == 1 || !vm.driverDetail.RUT_image\" ng-click=\"vm.approveDocument(2,\'RUT\',$event)\"><i class=\"fa fa-times\"></i></a> <a class=\"btn btn-primary upload\" ng-disabled=\"vm.driverDetail.identity_card_RUT_status == 3 || vm.driverDetail.documentation_status == 1 || !vm.driverDetail.RUT_image\" ng-click=\"vm.approveDocument(3,\'RUT\',$event)\">{{\'uploadAgain\' | translate}}</a></div></div></li><li ng-hide=\"vm.driverDetail.fleet_type == 2\"><!--ng-hide=\"vm.driverDetail.fleet_type == 2\"--><div class=displayFlex><div class=widthDiv>{{\'licenseImage\' | translate}}<br class=showBr><span class=colorPending ng-if=\"vm.driverDetail.driver_license_status == 0\">({{\'pending\' | translate}}) </span><span class=colorVerified ng-if=\"vm.driverDetail.driver_license_status == 1\">({{\'approve\' | translate}}) </span><span class=colorNot ng-if=\"vm.driverDetail.driver_license_status == 2\">({{\'unapproveButton\' | translate}}) </span><span class=colorUpload ng-if=\"vm.driverDetail.driver_license_status == 3\">({{\'uploadAgain\' | translate}})</span></div><div class=\"widthDiv1 text-right\"><a title=\"View Document\" class=\"cursor btn btn-sm editIconColor\" ng-disabled=!vm.driverDetail.license_img href={{vm.driverDetail.license_img}} target=_blank><i class=\"fa fa-eye\"></i></a> <a title=\"Edit Document\" class=\"cursor btn btn-sm editIconColor\" ng-disabled=\"vm.driverDetail.documentation_status == 1\" ng-click=\"vm.showEditDocumentDialog($event,vm.driverDetail.license_img,\'LICENSE\')\"><i class=\"fa fa-edit\"></i></a> <a title=\"Approve Document\" class=\"btn btn-primary approve cursor btn btn-sm editIconColor\" ng-disabled=\"vm.driverDetail.driver_license_status == 1 || !vm.driverDetail.license_img\" ng-click=\"vm.approveDocument(1,\'LICENSE\',$event)\"><i class=\"fa fa-check\"></i></a><br class=showBr><a title=\"Disapprove Document\" class=\"btn btn-danger approve cursor btn btn-sm editIconColor\" ng-disabled=\"vm.driverDetail.driver_license_status == 2 || vm.driverDetail.documentation_status == 1 || !vm.driverDetail.license_img\" ng-click=\"vm.approveDocument(2,\'LICENSE\',$event)\"><i class=\"fa fa-times\"></i></a> <a class=\"btn btn-primary upload\" ng-disabled=\"vm.driverDetail.driver_license_status == 3 || vm.driverDetail.documentation_status == 1 || !vm.driverDetail.license_img\" ng-click=\"vm.approveDocument(3,\'LICENSE\',$event)\">{{\'uploadAgain\' | translate}}</a></div></div></li><li ng-hide=\"vm.driverDetail.fleet_type == 2\"><!--ng-hide=\"vm.driverDetail.fleet_type == 2\"--><div class=displayFlex><div class=widthDiv>{{\'antcedentsImage\' | translate}}<br class=showBr><span class=colorPending ng-if=\"vm.driverDetail.antecents_certificate_status == 0\">({{\'pending\' | translate}}) </span><span class=colorVerified ng-if=\"vm.driverDetail.antecents_certificate_status == 1\">({{\'approve\' | translate}}) </span><span class=colorNot ng-if=\"vm.driverDetail.antecents_certificate_status == 2\">({{\'unapproveButton\' | translate}})</span> <span class=colorUpload ng-if=\"vm.driverDetail.antecents_certificate_status == 3\">({{\'uploadAgain\' | translate}})</span></div><div class=\"widthDiv1 text-right\"><a title=\"View Document\" class=\"cursor btn btn-sm editIconColor\" ng-disabled=!vm.driverDetail.antecents_certificate href={{vm.driverDetail.antecents_certificate}} target=_blank><i class=\"fa fa-eye\"></i></a> <a title=\"Edit Document\" class=\"cursor btn btn-sm editIconColor\" ng-disabled=\"vm.driverDetail.documentation_status == 1\" ng-click=\"vm.showEditDocumentDialog($event,vm.driverDetail.antecents_certificate,\'ANTECENTS\')\"><i class=\"fa fa-edit\"></i></a> <a title=\"Approve Document\" class=\"btn btn-primary approve cursor btn btn-sm editIconColor\" ng-disabled=\"vm.driverDetail.antecents_certificate_status == 1 || !vm.driverDetail.antecents_certificate\" ng-click=\"vm.approveDocument(1,\'ANTECENTS\',$event)\"><i class=\"fa fa-check\"></i></a><br class=showBr><a title=\"Disapprove Document\" class=\"btn btn-danger approve cursor btn btn-sm editIconColor\" ng-disabled=\"vm.driverDetail.antecents_certificate_status == 2 || vm.driverDetail.documentation_status == 1 || !vm.driverDetail.antecents_certificate\" ng-click=\"vm.approveDocument(2,\'ANTECENTS\',$event)\"><i class=\"fa fa-times\"></i></a> <a class=\"btn btn-primary upload\" ng-disabled=\"vm.driverDetail.antecents_certificate_status == 3 || vm.driverDetail.antecents_certificate_status == 1 || !vm.driverDetail.antecents_certificate_status\" ng-click=\"vm.approveDocument(3,\'ANTECENTS\',$event)\">{{\'uploadAgain\' | translate}}</a></div></div></li><li ng-hide=\"vm.driverDetail.fleet_type == 2\"><!--ng-hide=\"vm.driverDetail.fleet_type == 2\"--><div class=displayFlex><div class=widthDiv>{{\'lifeSheetImage\' | translate}}<br class=showBr><span class=colorPending ng-if=\"vm.driverDetail.life_sheet_img_status == 0\">({{\'pending\' | translate}}) </span><span class=colorVerified ng-if=\"vm.driverDetail.life_sheet_img_status == 1\">({{\'approve\' | translate}}) </span><span class=colorNot ng-if=\"vm.driverDetail.life_sheet_img_status == 2\">({{\'unapproveButton\' | translate}})</span> <span class=colorUpload ng-if=\"vm.driverDetail.life_sheet_img_status == 3\">({{\'uploadAgain\' | translate}})</span></div><div class=\"widthDiv1 text-right\"><a class=\"bcursor btn btn-sm editIconColor\" ng-disabled=!vm.driverDetail.life_sheet_img href={{vm.driverDetail.life_sheet_img}} target=_blank><i class=\"fa fa-eye\"></i></a> <a class=\"cursor btn btn-sm editIconColor\" ng-disabled=\"vm.driverDetail.documentation_status == 1\" ng-click=\"vm.showEditDocumentDialog($event,vm.driverDetail.life_sheet_img,\'LIFE_SHEET\')\"><i class=\"fa fa-edit\"></i></a> <a class=\"btn btn-primary approve cursor btn btn-sm editIconColor\" ng-disabled=\"vm.driverDetail.life_sheet_img_status == 1 || !vm.driverDetail.life_sheet_img\" ng-click=\"vm.approveDocument(1,\'LIFE_SHEET\',$event)\"><i class=\"fa fa-check\"></i></a><br class=showBr><a class=\"btn btn-danger approve cursor btn btn-sm editIconColor\" ng-disabled=\"vm.driverDetail.life_sheet_img_status == 2 || vm.driverDetail.documentation_status == 1 || !vm.driverDetail.life_sheet_img\" ng-click=\"vm.approveDocument(2,\'LIFE_SHEET\',$event)\"><i class=\"fa fa-times\"></i></a> <a class=\"btn btn-primary upload\" ng-disabled=\"vm.driverDetail.life_sheet_img_status == 3 || vm.driverDetail.documentation_status == 1 || !vm.driverDetail.life_sheet_img\" ng-click=\"vm.approveDocument(3,\'LIFE_SHEET\',$event)\">{{\'uploadAgain\' | translate}}</a></div></div></li><li ng-if=\"vm.driverDetail.fleet_type == 0\"><div class=displayFlex><div class=widthDiv>{{\'identityCard\' | translate}}<br class=showBr><span class=colorPending ng-if=\"vm.driverDetail.identity_card_company_status == 0\">({{\'pending\' | translate}}) </span><span class=colorVerified ng-if=\"vm.driverDetail.identity_card_company_status == 1\">({{\'approve\' | translate}}) </span><span class=colorNot ng-if=\"vm.driverDetail.identity_card_company_status == 2\">({{\'unapproveButton\' | translate}})</span> <span class=colorUpload ng-if=\"vm.driverDetail.identity_card_company_status == 3\">({{\'uploadAgain\' | translate}})</span></div><div class=\"widthDiv1 text-right\"><a class=\"cursor btn btn-sm editIconColor\" ng-disabled=!vm.driverDetail.company_identity_card href={{vm.driverDetail.company_identity_card}} target=_blank><i class=\"fa fa-eye\"></i></a> <a class=\"cursor btn btn-sm editIconColor\" ng-disabled=\"vm.driverDetail.documentation_status == 1\" ng-click=\"vm.showEditDocumentDialog($event,vm.driverDetail.company_identity_card,\'COMPANY_IDENTITY\')\"><i class=\"fa fa-edit\"></i></a> <a class=\"btn btn-primary approve cursor btn btn-sm editIconColor\" ng-disabled=\"vm.driverDetail.identity_card_company_status == 1 || !vm.driverDetail.company_identity_card\" ng-click=\"vm.approveDocument(1,\'CARD\',$event)\"><i class=\"fa fa-check\" aria-hidden=true></i></a><br class=showBr><a class=\"btn btn-danger approve cursor btn btn-sm editIconColor\" ng-disabled=\"vm.driverDetail.identity_card_company_status == 2 || vm.driverDetail.documentation_status == 1 || !vm.driverDetail.company_identity_card\" ng-click=\"vm.approveDocument(2,\'CARD\',$event)\"><i class=\"fa fa-times\" aria-hidden=true></i></a> <a class=\"btn btn-primary upload\" ng-disabled=\"vm.driverDetail.identity_card_company_status == 3 || vm.driverDetail.documentation_status == 1 || !vm.driverDetail.company_identity_card\" ng-click=\"vm.approveDocument(3,\'CARD\',$event)\">{{\'uploadAgain\' | translate}}</a></div></div></li><!--<li>\n                                            <div class=\"displayFlex\">\n                                                <div class=\"widthDiv\">\n                                                    {{\'approveDriverProcess.approvalText.companyConstitution\' | translate}}\n                                                    <br class=\"showBr\" />\n                                                    <span class=\"colorPending\" ng-if=\"vm.driverDetail.constitution_company_status == 0\">({{\'approveDriverProcess.approvalText.pending\' | translate}})</span>\n                                                    <span class=\"colorVerified\" ng-if=\"vm.driverDetail.constitution_company_status == 1\">({{\'approveDriverProcess.approvalText.approved\' | translate}})</span>\n                                                    <span class=\"colorNot\" ng-if=\"vm.driverDetail.constitution_company_status == 2\">({{\'approveDriverProcess.approvalText.unapproved\' | translate}})</span>\n                                                    <span class=\"colorUpload\" ng-if=\"vm.driverDetail.constitution_company_status == 3\">({{\'approveDriverProcess.approvalText.uploadAagain\' | translate}})</span>\n                                                </div>\n                                                <div class=\"widthDiv1 text-right\">\n                                                    <a class=\"cursor btn btn-sm editIconColor\" ng-disabled=\"!vm.driverDetail.company_constitution\" href=\"{{vm.driverDetail.company_constitution}}\" target=\"_blank\"><i class=\"fa fa-eye\"></i></a>\n                                                    <a class=\"cursor btn btn-sm editIconColor\" ng-disabled=\"vm.driverDetail.documentation_status == 1\" ng-click=\"vm.showEditDocumentDialog($event,vm.driverDetail.company_constitution,\'COMPANY_CONSTITUTION\')\"><i\n                                                            class=\"fa fa-edit\"></i></a>\n                                                    <a class=\"btn btn-primary approve cursor btn btn-sm editIconColor\" ng-disabled=\"vm.driverDetail.constitution_company_status == 1 || !vm.driverDetail.company_constitution\" ng-click=\"vm.approveDocument(1,\'CONSTITUTION\',$event)\"><i\n                                                            class=\"fa fa-check\"></i></a>\n                                                    <br class=\"showBr\" />\n                                                    <a class=\"btn btn-danger approve cursor btn btn-sm editIconColor\" ng-disabled=\"vm.driverDetail.constitution_company_status == 2 || vm.driverDetail.documentation_status == 1 || !vm.driverDetail.company_constitution\" ng-click=\"vm.approveDocument(2,\'CONSTITUTION\',$event)\"><i class=\"fa fa-times\"></i></a>\n                                                    <a class=\"btn btn-primary upload\" ng-disabled=\"vm.driverDetail.constitution_company_status == 3 || vm.driverDetail.documentation_status == 1 || !vm.driverDetail.company_constitution\" ng-click=\"vm.approveDocument(3,\'CONSTITUTION\',$event)\">{{\'approveDriverProcess.approvalText.uploadAagain\'\n                                                        | translate}}</a>\n                                                </div>\n                                            </div>\n                                        </li>\n                                        <li>\n                                            <div class=\"displayFlex\">\n                                                <div class=\"widthDiv\">\n                                                    {{\'approveDriverProcess.approvalText.activityStart\' | translate}}\n                                                    <br class=\"showBr\" />\n                                                    <span class=\"colorPending\" ng-if=\"vm.driverDetail.start_activities_status == 0\">({{\'approveDriverProcess.approvalText.pending\' | translate}})</span>\n                                                    <span class=\"colorVerified\" ng-if=\"vm.driverDetail.start_activities_status == 1\">({{\'approveDriverProcess.approvalText.approved\' | translate}})</span>\n                                                    <span class=\"colorNot\" ng-if=\"vm.driverDetail.start_activities_status == 2\">({{\'approveDriverProcess.approvalText.unapproved\' | translate}})</span>\n                                                    <span class=\"colorUpload\" ng-if=\"vm.driverDetail.start_activities_status == 3\">({{\'approveDriverProcess.approvalText.uploadAagain\' | translate}})</span>\n                                                </div>\n                                                <div class=\"widthDiv1 text-right\">\n                                                    <a class=\"cursor btn btn-sm editIconColor\" ng-disabled=\"!vm.driverDetail.start_activities\" href=\"{{vm.driverDetail.start_activities}}\" target=\"_blank\"><i\n                                                            class=\"fa fa-eye\"></i></a>\n                                                    <a class=\"cursor btn btn-sm editIconColor\" ng-disabled=\"vm.driverDetail.documentation_status == 1\" ng-click=\"vm.showEditDocumentDialog($event,vm.driverDetail.start_activities,\'ACTIVITY\')\"><i\n                                                            class=\"fa fa-edit\"></i></a>\n                                                    <a class=\"btn btn-primary approve cursor btn btn-sm editIconColor\" ng-disabled=\"vm.driverDetail.start_activities_status == 1 || !vm.driverDetail.start_activities\" ng-click=\"vm.approveDocument(1,\'ACTIVITY\',$event)\"><i\n                                                            class=\"fa fa-check\"></i></a>\n                                                    <br class=\"showBr\" />\n                                                    <a class=\"btn btn-danger approve cursor btn btn-sm editIconColor\" ng-disabled=\"vm.driverDetail.start_activities_status == 2 || vm.driverDetail.documentation_status == 1 || !vm.driverDetail.start_activities\" ng-click=\"vm.approveDocument(2,\'ACTIVITY\',$event)\"><i class=\"fa fa-times\"></i></a>\n                                                    <a class=\"btn btn-primary upload\" ng-disabled=\"vm.driverDetail.start_activities_status == 3 || vm.driverDetail.documentation_status == 1 || !vm.driverDetail.start_activities\" ng-click=\"vm.approveDocument(3,\'ACTIVITY\',$event)\">{{\'approveDriverProcess.approvalText.uploadAagain\'\n                                                        | translate}}</a>\n                                                </div>\n                                            </div>\n                                        </li>\n                                        <li>\n                                            <div class=\"displayFlex\">\n                                                <div class=\"widthDiv\">\n                                                    {{\'approveDriverProcess.approvalText.invoiceStamping\' | translate}}\n                                                    <br class=\"showBr\" />\n                                                    <span class=\"colorPending\" ng-if=\"vm.driverDetail.stamping_invoice_status == 0\">({{\'approveDriverProcess.approvalText.pending\' | translate}})</span>\n                                                    <span class=\"colorVerified\" ng-if=\"vm.driverDetail.stamping_invoice_status == 1\">({{\'approveDriverProcess.approvalText.approved\' | translate}})</span>\n                                                    <span class=\"colorNot\" ng-if=\"vm.driverDetail.stamping_invoice_status == 2\">({{\'approveDriverProcess.approvalText.unapproved\' | translate}})</span>\n                                                    <span class=\"colorUpload\" ng-if=\"vm.driverDetail.stamping_invoice_status == 3\">({{\'approveDriverProcess.approvalText.uploadAagain\' | translate}})</span>\n                                                </div>\n                                                <div class=\"widthDiv1 text-right\">\n                                                    <a class=\"cursor btn btn-sm editIconColor\" ng-disabled=\"!vm.driverDetail.invoice_stamping\" href=\"{{vm.driverDetail.invoice_stamping}}\" target=\"_blank\"><i\n                                                            class=\"fa fa-eye\"></i></a>\n                                                    <a class=\"cursor btn btn-sm editIconColor\" ng-disabled=\"vm.driverDetail.documentation_status == 1\" ng-click=\"vm.showEditDocumentDialog($event,vm.driverDetail.invoice_stamping,\'INVOICE\')\"><i\n                                                            class=\"fa fa-edit\"></i></a>\n                                                    <a class=\"btn btn-primary approve cursor btn btn-sm editIconColor\" ng-disabled=\"vm.driverDetail.stamping_invoice_status == 1 || !vm.driverDetail.invoice_stamping\" ng-click=\"vm.approveDocument(1,\'INVOICE\',$event)\"><i\n                                                            class=\"fa fa-check\"></i></a>\n                                                    <br class=\"showBr\" />\n                                                    <a class=\"btn btn-danger approve cursor btn btn-sm editIconColor\" ng-disabled=\"vm.driverDetail.stamping_invoice_status == 2 || vm.driverDetail.documentation_status == 1 || !vm.driverDetail.invoice_stamping\" ng-click=\"vm.approveDocument(2,\'INVOICE\',$event)\"><i class=\"fa fa-times\"></i></a>\n                                                    <a class=\"btn btn-primary upload\" ng-disabled=\"vm.driverDetail.stamping_invoice_status == 3 || vm.driverDetail.documentation_status == 1 || !vm.driverDetail.invoice_stamping\" ng-click=\"vm.approveDocument(3,\'INVOICE\',$event)\">{{\'approveDriverProcess.approvalText.uploadAagain\'\n                                                        | translate}}</a>\n                                                </div>\n                                            </div>\n                                        </li>--></ol></div></div><!-- ****** VEHICLE DATA ***** --><p class=basicRegistrationP ng-class=\"{\'backgroundBasicPending\': vm.driverDetail.documentation_status == 0,\'backgroundBasicNot\': vm.driverDetail.documentation_status == 2,\'backgroundBasicVerified\': vm.driverDetail.documentation_status == 1}\"><span>{{\'documentsOfVehicles\' | translate}}</span></p><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><ol style=\"list-style: none\"><li ng-hide=\"vm.driverDetail.fleet_type == 2\" ng-repeat=\"data in vm.carDetail\"><h5 style=\"float: left\"><b>Vehiculo {{data.registration_number}}</b></h5><div class=displayFlex><div class=widthDiv>1 Permiso de Circulación<br class=showBr><span class=colorPending ng-if=\"data.permission_of_circulation_status == 0\">({{\'pending\' | translate}}) </span><span class=colorVerified ng-if=\"data.permission_of_circulation_status == 1\">({{\'approve\' | translate}}) </span><span class=colorNot ng-if=\"data.permission_of_circulation_status == 2\">({{\'unapproveButton\' | translate}})</span> <span class=colorUpload ng-if=\"data.permission_of_circulation_status == 3\">({{\'uploadAgain\' | translate}})</span></div><div class=\"widthDiv1 text-right\"><a class=\"cursor btn btn-sm editIconColor\" ng-disabled=!data.permission_of_circulation href={{data.permission_of_circulation}} target=_blank><i class=\"fa fa-eye\"></i></a> <a class=\"cursor btn btn-sm editIconColor\" ng-disabled=\"vm.driverDetail.documentation_status == 1\" ng-click=\"vm.showEditDocumentDialog($event,data.permission_of_circulation,\'Permiso de Circulación\', data.registration_number)\"><i class=\"fa fa-edit\"></i></a> <a class=\"btn btn-primary approve cursor btn btn-sm editIconColor\" ng-disabled=\"data.permission_of_circulation_status == 1 || !data.permission_of_circulation\" ng-click=\"vm.approveDocument(1,\'Permiso de Circulación\',$event, data)\"><i class=\"fa fa-check\"></i></a><br class=showBr><a class=\"btn btn-danger approve cursor btn btn-sm editIconColor\" ng-disabled=\"data.permission_of_circulation_status == 2 || vm.driverDetail.documentation_status == 1 || !data.permission_of_circulation\" ng-click=\"vm.approveDocument(2,\'Permiso de Circulación\',$event, data)\"><i class=\"fa fa-times\"></i></a> <a class=\"btn btn-primary upload\" ng-disabled=\"data.permission_of_circulation_status == 3 || vm.driverDetail.documentation_status == 1 || !data.permission_of_circulation\" ng-click=\"vm.approveDocument(3,\'Permiso de Circulación\',$event, data)\">{{\'uploadAgain\' | translate}}</a></div></div><div class=displayFlex style=\"margin: 10px 0px\"><div class=widthDiv>2 Permiso Ministerio de Transporte<br class=showBr><span class=colorPending ng-if=\"data.transportation_permit_status == 0\">({{\'pending\' | translate}}) </span><span class=colorVerified ng-if=\"data.transportation_permit_status == 1\">({{\'approve\' | translate}}) </span><span class=colorNot ng-if=\"data.transportation_permit_status == 2\">({{\'unapproveButton\' | translate}})</span> <span class=colorUpload ng-if=\"data.transportation_permit_status == 3\">({{\'uploadAgain\' | translate}})</span></div><div class=\"widthDiv1 text-right\"><a class=\"cursor btn btn-sm editIconColor\" ng-disabled=!data.transportation_permit href={{data.transportation_permit}} target=_blank><i class=\"fa fa-eye\"></i></a> <a class=\"cursor btn btn-sm editIconColor\" ng-disabled=\"vm.driverDetail.documentation_status == 1\" ng-click=\"vm.showEditDocumentDialog($event,data.transportation_permit,\'Permiso Ministerio de Transporte\', data.registration_number)\"><i class=\"fa fa-edit\"></i></a> <a class=\"btn btn-primary approve cursor btn btn-sm editIconColor\" ng-disabled=\"data.transportation_permit_status == 1 || !data.transportation_permit\" ng-click=\"vm.approveDocument(1,\'Permiso Ministerio de Transporte\',$event, data)\"><i class=\"fa fa-check\"></i></a><br class=showBr><a class=\"btn btn-danger approve cursor btn btn-sm editIconColor\" ng-disabled=\"data.transportation_permit_status == 2 || vm.driverDetail.documentation_status == 1 || !data.transportation_permit\" ng-click=\"vm.approveDocument(2,\'Permiso Ministerio de Transporte\',$event, data)\"><i class=\"fa fa-times\"></i></a> <a class=\"btn btn-primary upload\" ng-disabled=\"data.transportation_permit_status == 3 || vm.driverDetail.documentation_status == 1 || !data.transportation_permit\" ng-click=\"vm.approveDocument(3,\'Permiso Ministerio de Transporte\',$event, data)\">{{\'uploadAgain\' | translate}}</a></div></div></li></ol></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label class=control-label>{{\'adminComments\' | translate}}:</label><!--ng-show=\"vm.driverDetail.documentation_status != 1\"--><textarea class=form-control ng-model=vm.driverDetail.documentation_comments ng-disabled=\"vm.driverDetail.documentation_status == 1\" placeholder=\"{{\'messagePlaceholder\' | translate}}\"></textarea></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" ng-if=\"vm.driverDetail.documentation_status != 1\"><button class=\"btn btn-primary approve\" ng-disabled=\"vm.driverDetail.basicRegistration_status != 1 || vm.driverDetail.antecents_certificate_status != 1 || vm.driverDetail.life_sheet_img_status != 1\n                                            || vm.driverDetail.driver_license_status != 1 || vm.driverDetail.identity_card_RUT_status != 1\" ng-click=\"vm.approveDisapproveSteps(1,\'DOCS\',$event,vm.driverDetail.documentation_comments)\" ng-hide=\"vm.driverDetail.fleet_type == 2\">{{\'approve\' | translate}}</button><!--ng-hide=\"vm.driverDetail.fleet_type == 2\"  || vm.driverDetail.stamping_invoice_status != 1 || vm.driverDetail.start_activities_status != 1\n                                    || vm.driverDetail.constitution_company_status != 1 || vm.driverDetail.identity_card_company_status != 1--> <button class=\"btn btn-primary approve\" ng-if=\"vm.driverDetail.fleet_type == 2\" ng-disabled=\"vm.driverDetail.basicRegistration_status != 1\" ng-click=\"vm.approveDisapproveSteps(1,\'DOCS\',$event,vm.driverDetail.documentation_comments)\">{{\'approve\' | translate}}</button> <button class=\"btn btn-danger approve\" ng-disabled=\"vm.driverDetail.basicRegistration_status != 1\" ng-click=\"vm.approveDisapproveSteps(2,\'DOCS\',$event,vm.driverDetail.documentation_comments)\">{{\'unapproveButton\' | translate}}</button></div></div></div></div><!-- <div class=\"basicDiv\">\n                        <p class=\"basicRegistrationP\" ng-class=\"{\'backgroundBasicPending\': vm.driverDetail.interview_status == 0,\'backgroundBasicNot\': vm.driverDetail.interview_status == 2,\'backgroundBasicVerified\': vm.driverDetail.interview_status == 1}\">\n                            <span>{{\'interview\' | translate}}</span>\n                            <span class=\"pull-right\" ng-if=\"vm.driverDetail.interview_status == 0\">{{\'pending\' |\n                                translate}}</span>\n                            <span class=\"pull-right\" ng-if=\"vm.driverDetail.interview_status == 1\">{{\'approved\' |\n                                translate}}</span>\n                            <span class=\"pull-right\" ng-if=\"vm.driverDetail.interview_status == 2\">{{\'unapproved\' |\n                                translate}}</span>\n                        </p>\n                        <div class=\"basicDetailsDiv\"> --><!-- <div class=\"row\" ng-hide=\"vm.driverDetail.fleet_type == 1\">\n                                <div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">\n                                    <label class=\"control-label\">{{\'paymentModulityLabel\' | translate}}</label>\n                                    <div class=\"form-control\">\n                                         <span ng-if=\"vm.driverDetail.payment_modulity == 1\">Bank Deposit</span>\n                                        <span ng-if=\"vm.driverDetail.payment_modulity == 2\">Vale View</span> \n                                        <span ng-if=\"vm.driverDetail.payment_modulity == 1\">Vale Vista</span>\n                                        <span ng-if=\"vm.driverDetail.payment_modulity == 2\">Abono Cta Cte y Cta Vista</span>\n                                        <span ng-if=\"vm.driverDetail.payment_modulity == 3\">Abono Cta Ahorro</span>\n                                    </div>\n                                </div>\n                                <div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">\n                                    <label class=\"control-label\">{{\'bankLabel\' | translate}}</label>\n                                    <div class=\"form-control\">{{::vm.driverDetail.bank_name}}</div>\n\n                                </div>\n                                <div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">\n                                    <label class=\"control-label\">{{\'accountTypeLabel\' | translate}}</label>\n                                    <div class=\"form-control\">\n                                        <span ng-if=\"vm.driverDetail.account_type == 1\">Electronic Cheque Book</span>\n                                        <span ng-if=\"vm.driverDetail.account_type == 2\">Saving Account</span>\n                                        <span ng-if=\"vm.driverDetail.account_type == 3\">Checking Account</span>\n                                    </div>\n                                </div>\n                                <div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">\n                                    <label class=\"control-label\">{{\'accountNumberLabel\' | translate}}</label>\n                                    <div class=\"form-control\">{{::vm.driverDetail.account_number}}</div>\n                                </div>\n                            </div> --><!-- <div class=\"row mt5\">\n                                <div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\" ng-if=\"vm.driverDetail.interview_status == 1\">\n                                    <p class=\"text-center editDocumentP\">\n                                        {{\'sectionApproved\' | translate}} </p>\n                                </div>\n                                <div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\">\n                                    <label class=\"control-label\">{{\'adminComments\' | translate}}:</label>\n                                    <textarea class=\"form-control\" ng-model=\"vm.driverDetail.interview_comments\"\n                                        ng-disabled=\"vm.driverDetail.interview_status == 1\" placeholder=\"{{\'messagePlaceholder\' | translate}}\"></textarea>\n                                </div>\n                            </div>\n                            <div class=\"row mt25\">\n                                <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" ng-if=\"vm.driverDetail.interview_status != 1\">\n                                    <button class=\"btn btn-primary approve\" ng-disabled=\"vm.driverDetail.documentation_status != 1\"\n                                        ng-click=\"vm.approveDisapproveSteps(1,\'INTERVIEW\',$event,vm.driverDetail.interview_comments)\">\n                                        {{\'approve\' | translate}}\n                                    </button>\n                                    <button class=\"btn btn-danger approve\" ng-disabled=\"vm.driverDetail.documentation_status != 1\"\n                                        ng-click=\"vm.approveDisapproveSteps(2,\'INTERVIEW\',$event,vm.driverDetail.interview_comments)\">\n                                        {{\'unapproveButton\' | translate}}\n                                    </button>\n                                </div>\n                            </div>\n                        </div>\n                    </div> --><div class=basicDiv><p class=basicRegistrationP ng-class=\"{\'backgroundBasicPending\': vm.driverDetail.training_status == 0,\'backgroundBasicNot\': vm.driverDetail.training_status == 2,\'backgroundBasicVerified\': vm.driverDetail.training_status == 1}\"><span>{{\'training\' | translate}}</span> <span class=pull-right ng-if=\"vm.driverDetail.training_status == 0\">{{\'pending\' | translate}}</span> <span class=pull-right ng-if=\"vm.driverDetail.training_status == 1\">{{\'approved\' | translate}}</span> <span class=pull-right ng-if=\"vm.driverDetail.training_status == 2\">{{\'unapproved\' | translate}}</span></p><div class=basicDetailsDiv><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\" ng-if=\"vm.driverDetail.training_status == 1\"><p class=\"text-center editDocumentP\">{{\'sectionApproved\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label class=control-label>{{\'adminComments\' | translate}}:</label><!--ng-show=\"vm.driverDetail.training_status != 1\"--><textarea class=form-control ng-model=vm.driverDetail.training_comments ng-disabled=\"vm.driverDetail.training_status == 1\" placeholder=\"{{\'messagePlaceholder\' | translate}}\"></textarea></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" ng-if=\"vm.driverDetail.training_status != 1\"><button class=\"btn btn-primary approve\" ng-disabled=\"vm.driverDetail.documentation_status != 1\" ng-click=\"vm.approveDisapproveSteps(1,\'TRAINING\',$event,vm.driverDetail.training_comments)\">{{\'approve\' | translate}}</button> <button class=\"btn btn-danger approve\" ng-disabled=\"vm.driverDetail.documentation_status != 1\" ng-click=\"vm.approveDisapproveSteps(2,\'TRAINING\',$event,vm.driverDetail.training_comments)\">{{\'unapproveButton\' | translate}}</button></div></div></div></div><!-- <div class=\"basicDiv\" ng-if=\"vm.driverDetail.fleet_type!=1\">\n                        <p class=\"basicRegistrationP\" ng-class=\"{\'backgroundBasicPending\': vm.driverDetail.signOfContract_status == 0,\'backgroundBasicNot\': vm.driverDetail.signOfContract_status == 2,\'backgroundBasicVerified\': vm.driverDetail.signOfContract_status == 1}\">\n                            <span>{{\'signOfContract\' | translate}}</span>\n                            <span class=\"pull-right\" ng-if=\"vm.driverDetail.signOfContract_status == 0\">{{\'pending\' |\n                                translate}}</span>\n                            <span class=\"pull-right\" ng-if=\"vm.driverDetail.signOfContract_status == 1\">{{\'approved\' |\n                                translate}}</span>\n                            <span class=\"pull-right\" ng-if=\"vm.driverDetail.signOfContract_status == 2\">{{\'unapproved\'\n                                | translate}}</span>\n                        </p>\n                        <div class=\"basicDetailsDiv\">\n                            <div class=\"row\">\n                                <div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\" ng-if=\"vm.driverDetail.signOfContract_status == 1\">\n                                    <p class=\"text-center editDocumentP\">\n                                        {{\'sectionApproved\' | translate}} </p>\n                                </div>\n                                <div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\">\n                                    <label class=\"control-label\">{{\'adminComments\' | translate}}:</label>\n                                    <textarea class=\"form-control\" ng-model=\"vm.driverDetail.signOfContract_comments\"\n                                        ng-disabled=\"vm.driverDetail.signOfContract_status == 1\" placeholder=\"{{\'messagePlaceholder\' | translate}}\"></textarea>\n                                </div>\n                            </div>\n                            <div class=\"row mt25\">\n                                <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" ng-if=\"vm.driverDetail.signOfContract_status != 1\">\n                                    <button class=\"btn btn-primary approve\" ng-disabled=\"vm.driverDetail.training_status != 1\"\n                                        ng-click=\"vm.approveDisapproveSteps(1,\'SIGN\',$event,vm.driverDetail.signOfContract_comments)\">\n                                        {{\'approve\' | translate}}\n                                    </button>\n                                    <button class=\"btn btn-danger approve\" ng-disabled=\"vm.driverDetail.training_status != 1\"\n                                        ng-click=\"vm.approveDisapproveSteps(2,\'SIGN\',$event,vm.driverDetail.signOfContract_comments)\">\n                                        {{\'unapproveButton\' | translate}}\n                                    </button>\n                                </div>\n                            </div>\n                        </div>\n                    </div> --><div class=basicDiv><p class=basicRegistrationP ng-class=\"{\'backgroundBasicPending\': vm.driverDetail.activation_status == 0,\'backgroundBasicNot\': vm.driverDetail.activation_status == 2,\'backgroundBasicVerified\': vm.driverDetail.activation_status == 1}\"><span>{{\'accountActivation\' | translate}}</span> <span class=pull-right ng-if=\"vm.driverDetail.activation_status == 0\">{{\'pending\' | translate}}</span> <span class=pull-right ng-if=\"vm.driverDetail.activation_status == 1\">{{\'approved\' | translate}}</span> <span class=pull-right ng-if=\"vm.driverDetail.activation_status == 2\">{{\'unapproved\' | translate}}</span></p><div class=basicDetailsDiv><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\" ng-if=\"vm.driverDetail.activation_status == 1\"><p class=\"text-center editDocumentP\">{{\'sectionApproved\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label class=control-label>{{\'adminComments\' | translate}}:</label><!--ng-if=\"vm.driverDetail.activation_status != 1\"--><textarea class=form-control ng-model=vm.driverDetail.activation_comments ng-disabled=\"vm.driverDetail.activation_status == 1\" placeholder=\"{{\'messagePlaceholder\' | translate}}\"></textarea></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" ng-if=\"vm.driverDetail.activation_status != 1\"><button ng-if=\"vm.driverDetail.fleet_type==1\" class=\"btn btn-primary approve\" ng-disabled=\"vm.driverDetail.training_status != 1\" ng-click=\"vm.approveDisapproveSteps(1,\'ACCOUNT\',$event,vm.driverDetail.activation_comments)\">{{\'approve\' | translate}}</button> <button ng-if=\"vm.driverDetail.fleet_type!=1\" class=\"btn btn-primary approve\" ng-disabled=\"vm.driverDetail.training_status != 1\" ng-click=\"vm.approveDisapproveSteps(1,\'ACCOUNT\',$event,vm.driverDetail.activation_comments)\">{{\'approve\' | translate}}</button> <button class=\"btn btn-danger approve\" ng-disabled=\"vm.driverDetail.training_status != 1\" ng-click=\"vm.approveDisapproveSteps(2,\'ACCOUNT\',$event,vm.driverDetail.activation_comments)\">{{\'unapproveButton\' | translate}}</button></div></div></div></div><div class=\"basicDiv finalConfirmDiv mt25\"><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-right\"><button ng-if=\"vm.driverDetail.fleet_type==1\" class=\"btn btn-primary\" ng-click=\"vm.approveDisapproveSteps(1,\'FULL\',$event)\" ng-disabled=\"vm.driverDetail.basicRegistration_status != \'1\' || vm.driverDetail.documentation_status != \'1\' || vm.driverDetail.training_status != \'1\' || vm.driverDetail.activation_status != \'1\'\">{{\'confirmApplicant\' | translate}}</button> <button ng-if=\"vm.driverDetail.fleet_type!=1\" class=\"btn btn-primary\" ng-click=\"vm.approveDisapproveSteps(1,\'FULL\',$event)\" ng-disabled=\"vm.driverDetail.basicRegistration_status != \'1\' || vm.driverDetail.documentation_status != \'1\' || vm.driverDetail.training_status != \'1\' || vm.driverDetail.activation_status != \'1\'\">{{\'confirmApplicant\' | translate}}</button> <button class=\"btn btn-danger\" ng-click=vm.goBack()>{{\'cancelButton\' | translate}}</button></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/applicants/applicantDetails.html","<h2 ng-hide=\"vm.driverDetail.fleet_type != 0\" class=ng-cloak>{{\'applicantDetailsHead1\' | translate}}</h2><h2 ng-hide=\"vm.driverDetail.fleet_type != 2\" class=ng-cloak>{{\'applicantDetailsHead2\' | translate}}</h2><h2 ng-hide=\"vm.driverDetail.fleet_type != 1\" class=ng-cloak>{{\'applicantDetailsHead3\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=driver><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'detailsApplicant\' | translate}}</p><div class=basicDetailsDiv><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><img ng-src=\"{{vm.driverDetail.fleet_image || \'assets/images/noImage.jpeg\'}}\" class=profilePic title=\"{{\'profilePic\' | translate}}\"></div></div><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'name\' | translate}}:</label><div class=\"form-control text-capitalize\">{{vm.driverDetail.first_name + \" \" + vm.driverDetail.last_name}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'email\' | translate}}:</label><div class=form-control>{{::vm.driverDetail.email}}</div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'mobileNumber\' | translate}}:</label><div class=form-control>{{vm.driverDetail.country_code?vm.driverDetail.country_code + \"-\" + vm.driverDetail.phone:vm.driverDetail.phone}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-hide=\"vm.driverDetail.fleet_type == 1\"><label class=control-label>{{\'businessName\' | translate}}:</label><div class=form-control>{{::vm.driverDetail.business_name}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'usernameLabel\' | translate}}:</label><div class=form-control>{{::vm.driverDetail.username}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-hide=\"vm.driverDetail.fleet_type == 1\"><label class=control-label>{{\'invoiceRut\' | translate}}:</label><div class=form-control>{{::vm.driverDetail.invoice_rut}}</div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'address\' | translate}}:</label><div class=form-control>{{::vm.driverDetail.addressFormed}}</div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'applicantType\' | translate}}:</label><div class=form-control><span ng-if=\"vm.driverDetail.fleet_type == 0\">Driver with car</span> <span ng-if=\"vm.driverDetail.fleet_type == 1\">Driver without car</span> <span ng-if=\"vm.driverDetail.fleet_type == 2\">Car investor</span></div></div></div><div class=\"row mt5\" ng-hide=\"vm.driverDetail.fleet_type == 2\"><!--ng-hide=\"vm.driverDetail.fleet_type == 2\"--><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'liceneClassLabel\' | translate}}:</label><div class=form-control>{{::vm.driverDetail.license_type}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'liceneExpiaryLabel\' | translate}}:</label><div class=form-control>{{vm.driverDetail.license_expiry_date | date:\'mediumDate\'}}</div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'cityOfWorkLabel\' | translate}}:</label><div class=form-control>{{vm.driverDetail.region_name || \'--\'}}</div></div><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">\n                                    <label class=\"control-label\">Company Type:</label>\n                                    <div class=\"form-control\">{{vm.driverDetail.company_type || \'--\'}}</div>\n                                </div>--></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-hide=\"vm.driverDetail.fleet_type == 2\"><!--ng-hide=\"vm.driverDetail.fleet_type == 2\"--><label class=control-label>{{\'rutLabel\' | translate}}:</label><div class=form-control>{{::vm.driverDetail.RUT}}</div></div><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">\n                                    <label class=\"control-label\">Driver Route:</label>\n                                    <div class=\"form-control\">\n                                        <span ng-if=\"vm.driverDetail.fleet_route == 0\">Fixed Route</span>\n                                        <span ng-if=\"vm.driverDetail.fleet_route == 1\">Point to Point</span>\n                                    </div>\n                                </div>--><!-- TV_2680 --><!-- <div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"\n                                     ng-hide=\"vm.driverDetail.fleet_type != 0\">\n                                    <label class=\"control-label\">{{\'modalityOfworkLabel\' | translate}}: </label>\n                                    <div class=\"form-control\">\n                                        <span ng-if=\"vm.driverDetail.work_schedule == 0\">Part Time</span>\n                                        <span ng-if=\"vm.driverDetail.work_schedule == 1\">Full Time</span>\n                                    </div>\n                                </div> --><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">Company Type:</label>--><!--<div class=\"form-control\">{{vm.driverDetail.company_type || \'&#45;&#45;\'}}</div>--><!--</div>--></div></div></div><p class=\"basicRegistrationP backgroundBasicPending text-center mt10\" ng-hide=\"vm.driverDetail.fleet_type == 1\">Información de pago</p><div class=\"row mt5\" ng-hide=\"vm.driverDetail.fleet_type == 1\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'paymentModulityLabel\' | translate}}</label><div class=form-control><!-- <span ng-if=\"vm.driverDetail.payment_modulity == 1\">Bank Deposit</span>\n                                <span ng-if=\"vm.driverDetail.payment_modulity == 2\">Vale View</span> --> <span ng-if=\"vm.driverDetail.payment_modulity == 1\">1 Vale Vista</span> <span ng-if=\"vm.driverDetail.payment_modulity == 2\">3 Abono Cta Cte y Cta Vista</span> <span ng-if=\"vm.driverDetail.payment_modulity == 3\">4 Abono Cta Ahorro</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'bankLabel\' | translate}}</label><div class=form-control>{{::vm.driverDetail.bank_name}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'accountTypeLabel\' | translate}}</label><div class=form-control><span ng-if=vm.driverDetail.account_rut>{{::vm.driverDetail.account_rut}}</span> <span ng-if=\"vm.driverDetail.account_rut == null\">Conductor sin rut</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'accountNumberLabel\' | translate}}</label><div class=form-control>{{::vm.driverDetail.account_number}}</div></div></div><div class=\"basicDiv mt5\"><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'documents\' | translate}}</p><div class=basicDetailsDiv><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><ol><li ng-hide=\"vm.driverDetail.fleet_type == 2\"><!--ng-hide=\"vm.driverDetail.fleet_type == 2\"--><div class=displayFlex><div class=widthDiv>{{\'identityCard\' | translate}}<br class=showBr><span class=colorPending ng-if=\"vm.driverDetail.identity_card_RUT_status == 0\">({{\'pending\' | translate}}) </span><span class=colorVerified ng-if=\"vm.driverDetail.identity_card_RUT_status == 1\">({{\'approved\' | translate}}) </span><span class=colorNot ng-if=\"vm.driverDetail.identity_card_RUT_status == 2\">({{\'unapproved\' | translate}}) </span><span class=colorUpload ng-if=\"vm.driverDetail.identity_card_RUT_status == 3\">({{\'uploadAgain\' | translate}})</span></div><div class=\"widthDiv1 text-right\"><a class=\"cursor btn btn-sm editIconColor\" ng-disabled=!vm.driverDetail.RUT_image href={{vm.driverDetail.RUT_image}} target=_blank><i class=\"fa fa-eye\"></i> </a><a href={{vm.driverDetail.RUT_image}} ng-disabled=!vm.driverDetail.RUT_image class=\"btn btn-primary upload\" download>{{\'download\' | translate}}</a></div></div></li><li ng-hide=\"vm.driverDetail.fleet_type == 2\"><!--ng-hide=\"vm.driverDetail.fleet_type == 2\"--><div class=displayFlex><div class=widthDiv>{{\'licenseImage\' | translate}}<br class=showBr><span class=colorPending ng-if=\"vm.driverDetail.driver_license_status == 0\">({{\'pending\' | translate}}) </span><span class=colorVerified ng-if=\"vm.driverDetail.driver_license_status == 1\">({{\'approved\' | translate}}) </span><span class=colorNot ng-if=\"vm.driverDetail.driver_license_status == 2\">({{\'unapproved\' | translate}}) </span><span class=colorUpload ng-if=\"vm.driverDetail.driver_license_status == 3\">({{\'uploadAgain\' | translate}})</span></div><div class=\"widthDiv1 text-right\"><a class=\"cursor btn btn-sm editIconColor\" ng-disabled=!vm.driverDetail.license_img href={{vm.driverDetail.license_img}} target=_blank><i class=\"fa fa-eye\"></i> </a><a href={{vm.driverDetail.license_img}} ng-disabled=!vm.driverDetail.license_img class=\"btn btn-primary upload\" download>{{\'download\' | translate}}</a></div></div></li><li ng-hide=\"vm.driverDetail.fleet_type == 2\"><!--ng-hide=\"vm.driverDetail.fleet_type == 2\"--><div class=displayFlex><div class=widthDiv>{{\'antcedentsImage\' | translate}}<br class=showBr><span class=colorPending ng-if=\"vm.driverDetail.antecents_certificate_status == 0\">({{\'pending\' | translate}}) </span><span class=colorVerified ng-if=\"vm.driverDetail.antecents_certificate_status == 1\">({{\'approved\' | translate}}) </span><span class=colorNot ng-if=\"vm.driverDetail.antecents_certificate_status == 2\">({{\'unapproved\' | translate}}) </span><span class=colorUpload ng-if=\"vm.driverDetail.antecents_certificate_status == 3\">({{\'uploadAgain\' | translate}})</span></div><div class=\"widthDiv1 text-right\"><a class=\"cursor btn btn-sm editIconColor\" ng-disabled=!vm.driverDetail.antecents_certificate href={{vm.driverDetail.antecents_certificate}} target=_blank><i class=\"fa fa-eye\"></i> </a><a href={{vm.driverDetail.antecents_certificate}} ng-disabled=!vm.driverDetail.antecents_certificate class=\"btn btn-primary upload\" download>{{\'download\' | translate}}</a></div></div></li><li ng-hide=\"vm.driverDetail.fleet_type == 2\"><!--ng-hide=\"vm.driverDetail.fleet_type == 2\"--><div class=displayFlex><div class=widthDiv>{{\'lifeSheetImage\' | translate}}<br class=showBr><span class=colorPending ng-if=\"vm.driverDetail.life_sheet_img_status == 0\">({{\'pending\' | translate}}) </span><span class=colorVerified ng-if=\"vm.driverDetail.life_sheet_img_status == 1\">({{\'approved\' | translate}}) </span><span class=colorNot ng-if=\"vm.driverDetail.life_sheet_img_status == 2\">({{\'unapproved\' | translate}}) </span><span class=colorUpload ng-if=\"vm.driverDetail.life_sheet_img_status == 3\">({{\'uploadAgain\' | translate}})</span></div><div class=\"widthDiv1 text-right\"><a class=\"cursor btn btn-sm editIconColor\" ng-disabled=!vm.driverDetail.life_sheet_img href={{vm.driverDetail.life_sheet_img}} target=_blank><i class=\"fa fa-eye\"></i> </a><a href={{vm.driverDetail.life_sheet_img}} ng-disabled=!vm.driverDetail.life_sheet_img class=\"btn btn-primary upload\" download>{{\'download\' | translate}}</a></div></div></li><!--<li>--><!--<div class=\"displayFlex\">--><!--<div class=\"widthDiv\">--><!--Company Identity Card--><!--<br class=\"showBr\" />--><!--<span class=\"colorPending\" ng-if=\"vm.driverDetail.identity_card_company_status == 0\">(Pending)</span>--><!--<span class=\"colorVerified\" ng-if=\"vm.driverDetail.identity_card_company_status == 1\">(Approved)</span>--><!--<span class=\"colorNot\" ng-if=\"vm.driverDetail.identity_card_company_status == 2\">(Unapproved)</span>--><!--<span class=\"colorUpload\" ng-if=\"vm.driverDetail.identity_card_company_status == 3\">(Upload Again)</span>--><!--</div>--><!--<div class=\"widthDiv1 text-right\">--><!--<a class=\"btn btn-primary view\" ng-disabled=\"!vm.driverDetail.company_identity_card\" href=\"{{vm.driverDetail.company_identity_card}}\" target=\"_blank\">View</a>--><!--<a href=\"{{vm.driverDetail.company_identity_card}}\" ng-disabled=\"!vm.driverDetail.company_identity_card\" class=\"btn btn-primary upload\" download>Download</a>--><!--</div>--><!--</div>--><!--</li>--><!--<li>--><!--<div class=\"displayFlex\">--><!--<div class=\"widthDiv\">--><!--Company Constitution--><!--<br class=\"showBr\" />--><!--<span class=\"colorPending\" ng-if=\"vm.driverDetail.constitution_company_status == 0\">(Pending)</span>--><!--<span class=\"colorVerified\" ng-if=\"vm.driverDetail.constitution_company_status == 1\">(Approved)</span>--><!--<span class=\"colorNot\" ng-if=\"vm.driverDetail.constitution_company_status == 2\">(Unapproved)</span>--><!--<span class=\"colorUpload\" ng-if=\"vm.driverDetail.constitution_company_status == 3\">(Upload Again)</span>--><!--</div>--><!--<div class=\"widthDiv1 text-right\">--><!--<a class=\"btn btn-primary view\" ng-disabled=\"!vm.driverDetail.company_constitution\" href=\"{{vm.driverDetail.company_constitution}}\" target=\"_blank\">View</a>--><!--<a href=\"{{vm.driverDetail.company_constitution}}\" ng-disabled=\"!vm.driverDetail.company_constitution\" class=\"btn btn-primary upload\" download>Download</a>--><!--</div>--><!--</div>--><!--</li>--><!--<li>--><!--<div class=\"displayFlex\">--><!--<div class=\"widthDiv\">--><!--Activity Start--><!--<br class=\"showBr\" />--><!--<span class=\"colorPending\" ng-if=\"vm.driverDetail.start_activities_status == 0\">(Pending)</span>--><!--<span class=\"colorVerified\" ng-if=\"vm.driverDetail.start_activities_status == 1\">(Approved)</span>--><!--<span class=\"colorNot\" ng-if=\"vm.driverDetail.start_activities_status == 2\">(Unapproved)</span>--><!--<span class=\"colorUpload\" ng-if=\"vm.driverDetail.start_activities_status == 3\">(Upload Again)</span>--><!--</div>--><!--<div class=\"widthDiv1 text-right\">--><!--<a class=\"btn btn-primary view\" ng-disabled=\"!vm.driverDetail.start_activities\" href=\"{{vm.driverDetail.start_activities}}\" target=\"_blank\">View</a>--><!--<a href=\"{{vm.driverDetail.start_activities}}\" ng-disabled=\"!vm.driverDetail.start_activities\" class=\"btn btn-primary upload\" download>Download</a>--><!--</div>--><!--</div>--><!--</li>--><!--<li>--><!--<div class=\"displayFlex\">--><!--<div class=\"widthDiv\">--><!--Invoice Stamping--><!--<br class=\"showBr\" />--><!--<span class=\"colorPending\" ng-if=\"vm.driverDetail.stamping_invoice_status == 0\">(Pending)</span>--><!--<span class=\"colorVerified\" ng-if=\"vm.driverDetail.stamping_invoice_status == 1\">(Approved)</span>--><!--<span class=\"colorNot\" ng-if=\"vm.driverDetail.stamping_invoice_status == 2\">(Unapproved)</span>--><!--<span class=\"colorUpload\" ng-if=\"vm.driverDetail.stamping_invoice_status == 3\">(Upload Again)</span>--><!--</div>--><!--<div class=\"widthDiv1 text-right\">--><!--<a class=\"btn btn-primary view\" ng-disabled=\"!vm.driverDetail.invoice_stamping\" href=\"{{vm.driverDetail.invoice_stamping}}\" target=\"_blank\">View</a>--><!--<a href=\"{{vm.driverDetail.invoice_stamping}}\" ng-disabled=\"!vm.driverDetail.invoice_stamping\" class=\"btn btn-primary upload\" download>Download</a>--><!--</div>--><!--</div>--><!--</li>--><li ng-hide=\"vm.driverDetail.fleet_type == 1\"><div class=displayFlex><div class=widthDiv>{{\'invoiceRut\' | translate}}<!--<br class=\"showBr\" />--><!--<span class=\"colorPending\" ng-if=\"vm.driverDetail.stamping_invoice_status == 0\">(Pending)</span>--><!--<span class=\"colorVerified\" ng-if=\"vm.driverDetail.stamping_invoice_status == 1\">(Approved)</span>--><!--<span class=\"colorNot\" ng-if=\"vm.driverDetail.stamping_invoice_status == 2\">(Unapproved)</span>--><!--<span class=\"colorUpload\" ng-if=\"vm.driverDetail.stamping_invoice_status == 3\">(Upload Again)</span>--></div><div class=\"widthDiv1 text-right\"><a class=\"cursor btn btn-sm editIconColor\" ng-disabled=!vm.driverDetail.invoice_rut_image href={{vm.driverDetail.invoice_rut_image}} target=_blank><i class=\"fa fa-eye\"></i> </a><a href={{vm.driverDetail.invoice_rut_image}} ng-disabled=!vm.driverDetail.invoice_rut_image class=\"btn btn-primary upload\" download>{{\'download\' | translate}}</a></div></div></li></ol></div></div></div></div><div class=basicDiv ng-if=vm.driverDetail.car_details.length ng-hide=\"vm.driverDetail.fleet_type == 1\"><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'carDetailsHead\' | translate}}</p><div class=basicDetailsDiv><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" ng-repeat=\"data in vm.driverDetail.car_details\"><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'vehicleLabel\' | translate}}:</label><div class=form-control><span>{{::data.carName}}</span><!--<span ng-if=\"data.car_type == 1\">SUV</span>--><!--<span ng-if=\"data.car_type == 2\">Sedan</span>--><!--<span ng-if=\"data.car_type == 3\">VAN</span>--></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'PPU\' | translate}}:</label><div class=form-control>{{data.registration_number || \'--\'}}</div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'addedAt\' | translate}}:</label><div class=form-control>{{data.added_at | date:\'medium\'}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'working24\' | translate}}:</label><div class=form-control ng-if=\"data.modelity == 0\">No</div><div class=form-control ng-if=\"data.modelity == 1\">Yes</div></div><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">Car Status:</label>--><!--<div class=\"form-control\" ng-if=\"data.car_status == 0\"> Free </div>--><!--<div class=\"form-control\" ng-if=\"data.car_status == 1\"> Occupied/{{data.occupied_by || \'&#45;&#45;\'}}</div>--><!--</div>--></div><div class=\"row mt5\" ng-if=\"data.society_name != null\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Sociedad SAP:</label><div class=form-control>{{::data.society_name}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"></div></div><div class=\"row mt5\"><!-- // ticket 2807  --><!-- <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12\">\n                                            <label class=\"control-label\">{{\'carImage\' | translate}}:</label>\n                                            <div>\n                                                <img ng-src=\"{{data.car_photo || \'assets/images/noImage.jpeg\'}}\"\n                                                     class=\"profilePic\" title=\"{{\'carImage\' | translate}}\"/>\n                                            </div>\n                                        </div>\n                                        <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12\">\n                                            <label class=\"control-label\">{{\'vehicleImage\' | translate}}:</label>\n                                            <div>\n                                                <img ng-src=\"{{data.registration_image || \'assets/images/noImage.jpeg\'}}\"\n                                                     class=\"profilePic\" title=\"{{\'vehicleImage\' | translate}}\"/>\n                                            </div>\n                                        </div>\n                                        <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6  mt5\">\n                                            <label class=\"control-label mt10\">{{\'travelCard\' | translate}}<span\n                                                    style=\"color:red\">*</span></label>\n                                            <div>\n                                                <img src=\"{{data.travel_card_key || \'assets/images/noImage.jpeg\'}}\"\n                                                     class=\"profilePic\" title=\"{{\'travelCard\' | translate}}\"/>\n                                            </div>\n                                        </div>\n                                        <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6  mt5\">\n                                            <label class=\"control-label mt10\">{{\'passengerSeatInsurance\' | translate}}<span\n                                                    style=\"color:red\">*</span></label>\n                                            <div>\n                                                <img src=\"{{data.passenger_insurance_key || \'assets/images/noImage.jpeg\'}}\"\n                                                     class=\"profilePic\" title=\"{{\'passengerSeatInsurance\' | translate}}\"/>\n                                            </div>\n                                        </div> --><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\"><label class=\"control-label mt10\">{{\'circulationPermission\' | translate}} <span style=color:red>*</span></label><div><img src=\"{{data.permission_of_circulation || \'assets/images/noImage.jpeg\'}}\" class=profilePic title=\"{{\'circulationPermission\' | translate}}\"></div></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\"><label class=\"control-label mt10\">Permiso Ministerio de Transporte<!-- <span style=\"color:red\">*</span> --></label><div><img src=\"{{data.transportation_permit || \'assets/images/noImage.jpeg\'}}\" class=profilePic title=\"Permiso Ministerio de Transporte\"></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5\"><label class=control-label>{{\'verificationComments\' | translate}}:</label><div class=text-capitalize><textarea disabled class=form-control ng-model=data.verification_comment placeholder=\"No Description\"></textarea></div></div></div><div class=\"row mt5\" ng-if=\"$index != (vm.driverDetail.car_details.length-1)\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><span><hr></span></div></div></div></div></div></div><div class=basicDiv><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'adminComments\' | translate}}</p><div class=basicDetailsDiv><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=vm.driverDetail.basicRegistration_comments><label class=control-label>{{\'basicRegistartion\' | translate}}:</label><textarea class=form-control ng-model=vm.driverDetail.basicRegistration_comments placeholder=\"{{\'messagePlaceholder\' | translate}}\" readonly></textarea></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=vm.driverDetail.documentation_comments><label class=control-label>{{\'documents\' | translate}}:</label><textarea class=form-control ng-model=vm.driverDetail.documentation_comments placeholder=\"{{\'messagePlaceholder\' | translate}}\" readonly></textarea></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=vm.driverDetail.interview_comments><label class=control-label>{{\'interview\' | translate}}:</label><textarea class=form-control ng-model=vm.driverDetail.interview_comments placeholder=\"{{\'messagePlaceholder\' | translate}}\" readonly></textarea></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=vm.driverDetail.training_comments><label class=control-label>{{\'training\' | translate}}:</label><textarea class=form-control ng-model=vm.driverDetail.training_comments placeholder=\"{{\'messagePlaceholder\' | translate}}\" readonly></textarea></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=vm.driverDetail.signOfContract_comments><label class=control-label>{{\'signOfContract\' | translate}}:</label><textarea class=form-control ng-model=vm.driverDetail.signOfContract_comments placeholder=\"{{\'messagePlaceholder\' | translate}}\" readonly></textarea></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=vm.driverDetail.activation_comments><label class=control-label>{{\'accountActivation\' | translate}}:</label><textarea class=form-control ng-model=vm.driverDetail.activation_comments placeholder=\"{{\'messagePlaceholder\' | translate}}\" readonly></textarea></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=vm.driverDetail.block_unblock_comments><label class=control-label>{{\'blockUnblock\' | translate}}:</label><textarea class=form-control ng-model=vm.driverDetail.block_unblock_comments placeholder=\"{{\'messagePlaceholder\' | translate}}\" readonly></textarea></div></div><div class=row><div class=\"col-lg-12 col-ms-12 col-md-12 col-xs-12 table-responsive\"><table class=\"table table-hover\"><thead><tr><th>{{\'registrationSteps\' | translate}}</th><th>{{\'approvedBy\' | translate}}</th><th>{{\'approvedAt\' | translate}}</th></tr></thead><tbody><tr><td>Basic Registration</td><td>{{vm.driverDetail.basicRegistration_modified_by || \'--\'}}</td><td>{{vm.driverDetail.basicRegistration_modified_at || \'--\' | date: \'medium\'}}</td></tr><tr><td>Documents</td><td>{{vm.driverDetail.documentation_modified_by || \'--\'}}</td><td>{{vm.driverDetail.documentation_modified_at || \'--\' | date: \'medium\'}}</td></tr><!-- <tr>\n                                            <td>\n                                                Interview\n                                            </td>\n                                            <td>\n                                                {{vm.driverDetail.interview_modified_by || \'--\'}}\n                                            </td>\n                                            <td>\n                                                {{vm.driverDetail.interview_modified_at || \'--\' | date: \'medium\'}}\n                                            </td>\n                                        </tr> --><tr><td>Training</td><td>{{vm.driverDetail.training_modified_by || \'--\'}}</td><td>{{vm.driverDetail.training_modified_at || \'--\' | date: \'medium\'}}</td></tr><!-- <tr>\n                                            <td>\n                                                Sign of Contract\n                                            </td>\n                                            <td>\n                                                {{vm.driverDetail.signOfContract_modified_by || \'--\'}}\n                                            </td>\n                                            <td>\n                                                {{vm.driverDetail.signOfContract_modified_at || \'--\' | date: \'medium\'}}\n                                            </td>\n                                        </tr> --><tr><td>Account Activation</td><td>{{vm.driverDetail.activation_modified_by || \'--\'}}</td><td>{{vm.driverDetail.activation_modified_at || \'--\' | date: \'medium\'}}</td></tr></tbody></table></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/applicants/applicants.html","<h2 class=ng-cloak><span>{{\'applicantHead\' | translate}}</span> <span class=pull-right><!--<button class=\"btn btn-info\" title=\"{{\'filterButton\' | translate}}\" style=\"min-width: 100px;\" ng-click=\"vm.showFilterArea()\">{{\'filterButton\' | translate}}</button>&lt;!&ndash;vm.showFilterArea()&ndash;&gt;--><!--<button class=\"btn btn-info\" title=\"{{\'resetButton\' | translate}}\" ng-click=\"vm.removeFilter()\">{{\'resetButton\' | translate}}</button>--> <button class=\"btn btn-primary tableButton\" ng-click=vm.refreshData()>Volver a cargar</button></span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><!--<filter-sidebar show-filter-sidebar=\"vm.showFilterFlag\" filter-data=\"vm.filterData\" filter-to-show=\"vm.filterWhichToShow\" branch-detail-changed=\"vm.branchChangedFilter(vm.filterData)\"--><!--modelity-detail-changed=\"vm.modelityChangedFilter(vm.filterData)\" approval-stage-detail-changed=\"vm.approvalChangedFilter(vm.filterData)\" applicant-detail-changed=\"vm.applicantChangedFilter(vm.filterData)\"></filter-sidebar>--><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label class=control-label>{{\'branchLabel\' | translate}}</label><ui-select ng-init=vm.focusEvent() ng-model=vm.filterData.branch ng-blur=vm.blurEvent() ng-keyup=\"vm.branchSearch($select.search, $event)\" name=branch required close-on-select=true><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select></div><!-- TV_2680 --><!-- <div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\">\n                    <label class=\"control-label\">{{\'modalityOfworkLabel\' | translate}}</label>\n                    <select class=\"form-control\" ng-model=\"vm.filterData.modelity\" ng-change=\"vm.modelityValueChanged()\">\n                        <option value=\"\" selected disabled>{{\'modalityOfworkPlaceholder\' | translate}}</option>\n                        <option value=\"0\">No</option>\n                        <option value=\"1\">Yes</option>\n                        <option value=\"all\">All</option>\n                    </select>\n                </div> --><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label class=control-label>{{\'approvalStage\' | translate}}</label><select class=form-control ng-model=vm.filterData.verification_stage ng-change=vm.approvalValueChanged()><option value=\"\" disabled>{{\'approvalStagePlaceholder\' | translate}}</option><option value=1>Basic Registration Stage</option><option value=2>Documents Stage</option><option value=3>Interview Stage</option><option value=4>Training Stage</option><option value=5>Sign of Contract Stage</option><option value=6>Account Activation Stage</option><option value=7>Fleet Verification Stage</option><option selected value=all>All</option></select></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label class=control-label>{{\'applicantType\' | translate}}</label><select class=form-control ng-model=vm.filterData.driver ng-change=vm.applicantTypeChanged()><option value=\"\" disabled>{{\'applicantTypePlaceholder\' | translate}}</option><option value=0>Driver with car</option><option value=1>Driver without car</option><option value=2>Car investor</option><option selected value=all>All</option></select></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><p class=totalSize><span class=pull-right><a class=\"btn btn-primary mb10\" ui-sref=layout.applicantsMain.registerApplicant>+ {{\'addApplicants\' | translate}}</a> </span><span>{{\'totalApplicants\' | translate}}: {{vm.totalDrivers}}</span></p></div><br><br><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.getFilter() ng-model-options=\"{ debounce: 500 }\"></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\"><!--ng-switch=\"(vm.driverList | filter:vm.search).length\"--><!--<div ng-switch-when=\"0\" class=\"noSearch\"><span>{{\'nothingFound\' | translate}}</span></div>--><table class=\"table table-hover tableWithMasterData\"><!---ng-switch-default--><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}<!--<div class=\"text-center\" ng-click=\"vm.sort(\'index\')\">--><!--{{\'serialNumber\' | translate}}--><!--<span ng-hide=\"vm.predicate == \'index\' && vm.reverse || vm.predicate == \'index\' && !vm.reverse\"--><!--class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-if=\"vm.predicate == \'index\' && !vm.reverse\"--><!--class=\"fa fa-caret-down\"></span>--><!--<span ng-if=\"vm.predicate == \'index\' && vm.reverse\"--><!--class=\"fa fa-caret-up\"></span>--><!--</div>--></th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'name\' | translate}}\" text=\"\'name\'\" check=vm.reverse>{{\'name\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'email\' | translate}}\" text=\"\'email\'\" check=vm.reverse>{{\'email\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'mobileNumber\' | translate}}\" text=\"\'phone\'\" check=vm.reverse>{{\'mobileNumber\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'joiningDate\' | translate}}\" text=\"\'creation_datetime\'\" check=vm.reverse>{{\'joiningDate\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'approvalStage\' | translate}}\" text=\"\'verification_status\'\" check=vm.reverse>{{\'approvalStage\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'applicantType\' | translate}}\" text=\"\'fleet_type\'\" check=vm.reverse>{{\'applicantType\' | translate}}</th><!--<th>--><!--<div class=\"text-center\" ng-click=\"vm.sort(\'fleet_route\')\">--><!--{{\'pendingDrivers.table.driverRoute\' | translate}}--><!--<span ng-hide=\"vm.predicate == \'fleet_route\' && vm.reverse || vm.predicate == \'fleet_route\' && !vm.reverse\"--><!--class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-if=\"vm.predicate == \'fleet_route\' && !vm.reverse\"--><!--class=\"fa fa-caret-down\"></span>--><!--<span ng-if=\"vm.predicate == \'fleet_route\' && vm.reverse\"--><!--class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><!-- <th style=\"width:100px;\" table-column-sorting current-text=\"vm.predicate\" title=\"{{\'modalityOfworkLabel\' | translate}}\" text=\"\'work_schedule\'\"\n                                                check=\"vm.reverse\">\n                                                {{\'modalityOfworkLabel\' | translate}}\n                                            </th> --><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'branchLabel\' | translate}}\" text=\"\'branch_name\'\" check=vm.reverse>{{\'branchLabel\' | translate}}</th><th style=\"width: 150px\"><div class=text-center>{{\'action\' | translate}}</div></th><th style=width:100px><div class=text-center>{{\'approve\' | translate}}</div></th><th style=width:100px><div class=text-center>{{\'viewOtp\' | translate}}</div></th><th style=width:150px><div class=text-center><!--{{\'pendingDrivers.table.approve\' | translate}}--> {{\'adminLogs\' | translate}}</div></th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.driverList | orderBy:vm.predicate:vm.reverse\"><!--| filter:vm.search--><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:70px>{{::data.fleet_id}}</td><td style=width:100px>{{::data.name}}</td><td style=width:100px>{{::data.email}}</td><td style=width:100px>{{::data.phone}}</td><td style=width:100px>{{data.creation_datetime | date:\'medium\'}}</td><td style=width:100px><span ng-if=\"data.verification_status == 1\">Basic Registration Stage</span> <span ng-if=\"data.verification_status == 2\">Documents Stage</span> <span ng-if=\"data.verification_status == 3\">Interview Stage</span> <span ng-if=\"data.verification_status == 4\">Training Stage</span> <span ng-if=\"data.verification_status == 5\">Sign of Contract Stage</span> <span ng-if=\"data.verification_status == 6\">Account Activation Stage</span> <span ng-if=\"data.verification_status == 7\">Fleet Verification Stage</span></td><td style=width:100px><span ng-if=\"data.fleet_type == 0\">Conductor con auto</span> <span ng-if=\"data.fleet_type == 1\">Conductor sin auto</span> <span ng-if=\"data.fleet_type == 2\">Soy inversionista</span></td><!--<td>--><!--<span ng-if=\"data.fleet_route == 0\">Fixed Route</span>--><!--<span ng-if=\"data.fleet_route == 1\">Point to Point</span>--><!--</td>--><!-- <td style=\"width:100px;\">\n                                                <span ng-if=\"data.work_schedule == 0\">Part Time</span>\n                                                <span ng-if=\"data.work_schedule == 1\">Full Time</span>\n                                                <span ng-if=\"data.work_schedule == null\">--</span>\n                                            </td> --><td style=width:100px>{{data.branch_name || \'--\'}}</td><td style=\"width: 150px\"><a title=\"View Details\" class=\"cursor btn btn-sm editIconColor\" ui-sref=\"layout.applicantsMain.applicantsDetails({id:\'{{data.fleet_id}}\'})\"><i class=\"fa fa-eye\"></i> </a><a title=\"Edit Details\" class=\"cursor btn btn-sm editIconColor\" ui-sref=\"layout.applicantsMain.editApplicantsDetails({id:\'{{data.fleet_id}}\'})\"><i class=\"fa fa-edit\"></i> </a><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteUser(data.fleet_id,$event)><i class=\"fa fa-trash\"></i></a></td><td style=width:100px><a class=\"btn btn-primary tableButton\" title=\"{{\'approve\' | translate}}\" ui-sref=\"layout.applicantsMain.applicantsApproval({id:\'{{data.fleet_id}}\'})\">{{\'approve\' | translate}}</a></td><td style=width:100px><a class=\"btn btn-primary tableButton\" title=\"{{\'viewOtp\' | translate}}\" ng-click=vm.viewOTP(data,$event)>{{\'viewOtp\' | translate}}</a></td><td style=width:150px><a class=\"btn btn-primary tableButton\" title=\"{{\'adminLogs\' | translate}}\" ui-sref=\"layout.applicantsMain.adminLogs({userId:\'{{data.fleet_id}}\',type:\'0\',fakeType: \'0\'})\">{{\'adminLogs\' | translate}}</a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noApplicantFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-if=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-if=\"sp_pagination\" ng-if=\"watchPagination\"&ndash;&gt;--><!--<nav>--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\"--><!--ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/applicants/applicantsMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/applicants/editApplicantDetails.html","<h2 ng-hide=\"vm.dataToFill.fleet_type != \'0\'\" class=ng-cloak><!--Process Of Postulation - Driver With a Car--> {{\'editApplicantHead1\' | translate}}</h2><h2 ng-hide=\"vm.dataToFill.fleet_type != \'2\'\" class=ng-cloak><!--Process Of Postulation - Car Investor--> {{\'editApplicantHead2\' | translate}}</h2><h2 ng-hide=\"vm.dataToFill.fleet_type != \'1\'\" class=ng-cloak><!--Process Of Postulation - Driver Without a Car--> {{\'editApplicantHead3\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=driver><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'detailsApplicant\' | translate}}</p><div class=basicDetailsDiv><form name=driverEditForm ng-submit=\"submit=true;driverEditForm.$valid&&vm.editBasicApi()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'applicantTypes\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.fleet_type name=driverType required ng-class=\"{ \'has-error\': driverEditForm.driverType.$touched && driverEditForm.driverType.$invalid }\"><option value=\"\" disabled selected>{{\'applicantTypePlaceholder\' | translate}}</option><option value=0>Conductor con auto</option><option value=1>Conductor sin auto</option><option value=2>Soy inversionista</option></select><div ng-if=\"driverEditForm.driverType.$touched || submit\" ng-messages=driverEditForm.driverType.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'applicantTypeRequired\' | translate}}</div></div></div></div><div><!--ng-if=\"vm.dataToFill.fleet_type\"--><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'firstNameLabel\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.first_name name=firstName placeholder=\"{{\'firstNameLabel\' | translate}}\" required ng-maxlength=60 ng-minlength=2 ng-class=\"{ \'has-error\': driverEditForm.firstName.$touched && driverEditForm.firstName.$invalid }\" pattern=^\\D*$><div ng-if=\"driverEditForm.firstName.$touched|| submit\" ng-messages=driverEditForm.firstName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'firstNameRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'firstNameValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'firstNameMaximum\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'lastNameLabel\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.last_name name=lastName placeholder=\"{{\'lastNameLabel\' | translate}}\" required ng-maxlength=60 ng-minlength=2 ng-class=\"{ \'has-error\': driverEditForm.lastName.$touched && driverEditForm.lastName.$invalid }\" pattern=^\\D*$><div ng-if=\"driverEditForm.lastName.$touched|| submit\" ng-messages=driverEditForm.lastName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'lastNameRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'lastNameValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'lastNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'lastNameMaximum\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'emailPlaceholder\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.email name=driverEmail placeholder=\"{{\'emailPlaceholder\' | translate}}\" required ng-class=\"{ \'has-error\': driverEditForm.driverEmail.$touched && driverEditForm.driverEmail.$invalid }\" pattern=^([_a-zA-Z0-9-+]+)(\\.[_a-zA-Z0-9-+]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*\\.)+([a-zA-Z]{2,3})$><div ng-if=\"driverEditForm.driverEmail.$touched|| submit\" ng-messages=driverEditForm.driverEmail.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'requiredEmail\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'validEmail\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=\"vm.dataToFill.fleet_type != \'2\'\"><!--ng-if=\"vm.dataToFill.fleet_type != \'2\'\"--><label class=control-label>{{\'rutLabel\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.RUT name=driverRUT placeholder=\"{{\'rutLabel\' | translate}}\" ng-rut ng-change=vm.rutChange() required ng-class=\"{ \'has-error\': driverEditForm.driverRUT.$touched && driverEditForm.driverRUT.$invalid }\"><div ng-if=\"driverEditForm.driverRUT.$touched|| submit\" ng-messages=driverEditForm.driverRUT.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'rutRequired\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid RUT.</div>--></div><div class=\"errormessage text-danger\" ng-if=vm.rutFlag>{{\'rutValid\' | translate}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=\"vm.dataToFill.fleet_type != \'1\'\"><label class=control-label>{{\'invoiceRut\' | translate}} <span style=color:red ng-if=\"vm.dataToFill.fleet_type == \'2\'\">*</span></label><input type=text class=form-control ng-model=vm.dataToFill.invoice_rut name=invoiceRUT placeholder=\"{{\'invoiceRut\' | translate}}\" ng-rut ng-change=vm.rutChange1() ng-required=\"vm.dataToFill.fleet_type == \'2\'\" ng-class=\"{ \'has-error\': driverEditForm.invoiceRUT.$touched && driverEditForm.invoiceRUT.$invalid }\"><div ng-if=\"driverEditForm.invoiceRUT.$touched|| submit\" ng-messages=driverEditForm.invoiceRUT.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'rutRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>Ingresa un rut válido</div></div><div class=\"errormessage text-danger\" ng-if=vm.rutFlag1>Ingresa un rut válido</div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'mobileNumber\' | translate}} <span style=color:red>*</span></label><div class=displayFlex><div><input type=text style=width:50px class=form-control ng-model=vm.dataToFill.country_code name=countryCode placeholder=\"Country Code\" required ng-class=\"{ \'has-error\': driverEditForm.countryCode.$touched && driverEditForm.countryCode.$invalid }\" pattern=^[0-9+][0-9+]*$ readonly><div ng-if=\"driverEditForm.countryCode.$touched|| submit\" ng-messages=driverEditForm.countryCode.$error><div class=\"errormessage text-danger\" ng-message=required>Please enter country code</div><div class=\"errormessage text-danger\" ng-message=pattern>Please enter a valid country code.</div></div></div><div style=\"width:90%; margin-left:5px\"><input type=text class=form-control ng-model=vm.dataToFill.phone_number name=mobileNumber placeholder=\"{{\'mobileNumber\' | translate}}\" required ng-minlength=9 ng-maxlength=9 ng-class=\"{\'has-error\': driverEditForm.mobileNumber.$touched && driverEditForm.mobileNumber.$invalid}\" pattern=^([9]{1}[0-9]{8})*$><!--\"^([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1})*$\"--><div ng-if=\"driverEditForm.mobileNumber.$touched|| submit\" ng-messages=driverEditForm.mobileNumber.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'mobileRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'mobileValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'mobileValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'mobileValid\' | translate}}</div></div></div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'usernameLabel\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.username name=username placeholder=\"{{\'usernameLabel\' | translate}}\" required ng-class=\"{ \'has-error\': driverEditForm.username.$touched && driverEditForm.username.$invalid }\" pattern=^[a-zA-Zñ0-9][a-zA-Zñ0-9\\s,]*$ ng-minlength=4 ng-maxlength=50><div ng-if=\"driverEditForm.username.$touched|| submit\" ng-messages=driverEditForm.username.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'usernameRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'usernameValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'usernameMin\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'usernameMax\' | translate}}</div></div></div></div><div class=\"row mt5\" ng-if=\"vm.dataToFill.fleet_type != \'2\'\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'liceneClassLabel\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.license_type name=licencseType required ng-class=\"{\'has-error\': driverEditForm.licencseType.$touched && driverEditForm.licencseType.$invalid}\"><option value=\"\" disabled selected>{{\'liceneClassLabel\' | translate}}</option><option ng-repeat=\"licenseType in vm.licenceTypesData\" value={{licenseType}}>{{licenseType}}</option></select><div ng-if=\"driverEditForm.licencseType.$touched|| submit\" ng-messages=driverEditForm.licencseType.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'licenseRequired\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'liceneExpiaryLabel\' | translate}}<!-- <span style=\"color:red\">*</span> --></label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} ng-model=vm.dataToFill.license_expiry_date name=licenseExpiry ng-class=\"{ \'has-error\': driverEditForm.licenseExpiry.$touched && driverEditForm.licenseExpiry.$invalid }\" placeholder=\"{{\'liceneExpiaryLabel\' | translate}}\" is-open=vm.datePicker_1.end datepicker-options=vm.dateOptions close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_1()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"driverEditForm.licenseExpiry.$touched|| submit\" ng-messages=driverEditForm.licenseExpiry.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'licenseExpiryRequired\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'cityOfWorkLabel\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.branch name=branch required ng-class=\"{ \'has-error\': driverEditForm.branch.$touched && driverEditForm.branch.$invalid }\" ng-options=\"branch.region_id as branch.region_name for branch in vm.branchList\"><option value=\"\" disabled selected>{{\'cityOfWorkLabelSelect\' | translate}}</option></select><div ng-if=\"driverEditForm.branch.$touched|| submit\" ng-messages=driverEditForm.branch.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'cityWorkRequired\' | translate}}</div></div><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.branch\" name=\"branch\" placeholder=\"Branch\"--><!--required ng-class=\"{ \'has-error\': driverEditForm.branch.$touched && driverEditForm.branch.$invalid }\" pattern=\"^[a-zA-Z0-9][a-zA-Z0-9\\s]*$\" ng-minlength=\"3\" ng-maxlength=\"16\"/>--><!--<div ng-if=\"driverEditForm.branch.$touched|| submit\" ng-messages=\"driverEditForm.branch.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter branch</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid branch.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"minlength\">Minimum 3 characters are allowed.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"maxlength\">Maximum 16 characters are allowed.</div>--><!--</div>--></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=\"vm.dataToFill.fleet_type != \'1\'\"><label class=control-label>{{\'businessName\' | translate}} <span style=color:red ng-if=\"vm.dataToFill.fleet_type == \'2\'\">*</span></label><input type=text class=form-control ng-model=vm.dataToFill.business_name name=BusinessName placeholder=\"{{\'businessName\' | translate}}\" ng-required=\"vm.dataToFill.fleet_type == \'2\'\" ng-maxlength=60 ng-minlength=3 ng-class=\"{ \'has-error\': driverEditForm.BusinessName.$touched && driverEditForm.BusinessName.$invalid }\" pattern=^[a-zA-Z][a-zA-Z\\s]*$><div ng-if=\"driverEditForm.BusinessName.$touched|| submit\" ng-messages=driverEditForm.BusinessName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'businessNameRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'businessNameValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'businessNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'businessNameMaximum\' | translate}}</div></div><!--<div ng-if=\"vm.dataToFill.registration_flag==0\" class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">Work Schedule<span style=\"color:red\">*</span></label>--><!--<select class=\"form-control\" ng-model=\"vm.dataToFill.work_schedule\" name=\"workSchedule\" required ng-class=\"{ \'has-error\': driverEditForm.workSchedule.$touched && driverEditForm.workSchedule.$invalid }\">--><!--<option value=\"\" disabled selected>Select Work Schedule</option>--><!--<option value=\"0\" >Part Time</option>--><!--<option value=\"1\" >Full Time</option>--><!--</select>--><!--<div ng-if=\"driverEditForm.workSchedule.$touched || submit\" ng-messages=\"driverEditForm.workSchedule.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please select work schedule.</div>--><!--</div>--><!--</div>--></div><!-- TV_2680 --><!-- <div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"\n                                             ng-if=\"vm.dataToFill.fleet_type == \'0\'\">\n                                            <label class=\"control-label\">{{\'modalityOfworkLabel\' | translate}}</label>\n                                            <select class=\"form-control\" ng-model=\"vm.dataToFill.work_schedule\"\n                                                    name=\"workSchedule\"\n                                                    ng-class=\"{ \'has-error\': driverEditForm.workSchedule.$touched && driverEditForm.workSchedule.$invalid }\">\n                                                <option value=\"\" disabled selected>{{\'modalityOfworkPlaceholder\' | translate}}</option>\n                                                <option value=\"0\">Part Time</option>\n                                                <option value=\"1\">Full Time</option>\n                                            </select>\n                                            <div ng-if=\"driverEditForm.workSchedule.$touched || submit\"\n                                                 ng-messages=\"driverEditForm.workSchedule.$error\">\n                                            </div>\n                                        </div> --></div><div class=\"row mt5\"><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">Company Type<span style=\"color:red\" ng-if=\"vm.dataToFill.fleet_type!=\'1\'\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.company_type\" name=\"companyType\" placeholder=\"Company type\" ng-required=\"vm.dataToFill.fleet_type!=\'1\'\" ng-class=\"{ \'has-error\': driverEditForm.companyType.$touched && driverEditForm.companyType.$invalid }\"--><!--pattern=\"^[a-zA-Z0-9][a-zA-Z0-9\\s]*$\" />--><!--<div ng-if=\"driverEditForm.companyType.$touched|| submit\" ng-messages=\"driverEditForm.companyType.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter company type.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid company type.</div>--><!--</div>--><!--</div>--><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">Driver Route<span--><!--style=\"color:red\">*</span></label>--><!--<select class=\"form-control\" ng-model=\"vm.dataToFill.fleet_route\"--><!--name=\"fleetRoute\" required--><!--ng-class=\"{ \'has-error\': driverEditForm.fleetRoute.$touched && driverEditForm.fleetRoute.$invalid }\">--><!--<option value=\"\" disabled selected>Select Driver Route</option>--><!--<option value=\"0\">Fixed Route</option>--><!--<option value=\"1\">Poit to Point</option>--><!--</select>--><!--<div ng-if=\"driverEditForm.fleetRoute.$touched || submit\"--><!--ng-messages=\"driverEditForm.fleetRoute.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please--><!--select driver route.--><!--</div>--><!--</div>--><!--</div>--></div><p class=\"basicRegistrationP backgroundBasicPending text-center mt10\">{{\'address\' | translate}}</p><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'street\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.street name=street placeholder=\"{{\'street\' | translate}}\" required ng-class=\"{ \'has-error\': driverEditForm.street.$touched && driverEditForm.street.$invalid }\" pattern=^[a-zA-Zñ0-9][a-zA-Zñ0-9\\s,]*$ ng-minlength=4 ng-maxlength=50><div ng-if=\"driverEditForm.street.$touched|| submit\" ng-messages=driverEditForm.street.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'streetRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'streetValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'streetMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'streetMaximum\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'number\' | translate}}</label><input type=text class=form-control ng-model=vm.dataToFill.number name=houseNumber placeholder=Number ng-class=\"{ \'has-error\': driverEditForm.houseNumber.$touched && driverEditForm.houseNumber.$invalid }\" pattern=^[1-9][0-9]*$ ng-maxlength=6><div ng-if=\"driverEditForm.houseNumber.$touched|| submit\" ng-messages=driverEditForm.houseNumber.$error><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter number.</div>--><div class=\"errormessage text-danger\" ng-message=pattern>{{\'numberRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'numberMax\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'apartment\' | translate}}</label><input type=text class=form-control ng-model=vm.dataToFill.apartment name=apartment placeholder=\"{{\'apartment\' | translate}}\" ng-class=\"{ \'has-error\': driverEditForm.apartment.$touched && driverEditForm.apartment.$invalid }\" pattern=^[a-zA-Z0-9][a-zA-Z0-9\\s,]*$ ng-maxlength=6><div ng-if=\"driverEditForm.apartment.$touched|| submit\" ng-messages=driverEditForm.apartment.$error><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter apartment.</div>--><div class=\"errormessage text-danger\" ng-message=pattern>{{\'apartmentRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'apartmentMax\' | translate}}</div></div></div><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">Communa<span style=\"color:red\">*</span></label>--><!--<select class=\"form-control\" ng-model=\"vm.dataToFill.sector\" name=\"communa\" required ng-class=\"{ \'has-error\': driverEditForm.communa.$touched && driverEditForm.communa.$invalid }\" ng-options=\"communa.communa as communa.communa for communa in vm.communaList\">--><!--&lt;!&ndash;communa.communa_id as &ndash;&gt;--><!--<option value=\"\" disabled selected>Select Communa</option>--><!--</select>--><!--<div ng-if=\"driverEditForm.communa.$touched|| submit\" ng-messages=\"driverEditForm.communa.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please select communa.--><!--</div>--><!--</div>--><!--</div>--></div><!--<div class=\"row mt5\">--><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">Region<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.region\" name=\"region\" placeholder=\"Region\" required ng-class=\"{ \'has-error\': driverEditForm.region.$touched && driverEditForm.region.$invalid }\" pattern=\"^[a-zA-Z0-9][a-zA-Z0-9\\s,]*$\" ng-minlength=\"4\"--><!--ng-maxlength=\"50\" />--><!--<div ng-if=\"driverEditForm.region.$touched|| submit\" ng-messages=\"driverEditForm.region.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter region.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid region.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"minlength\">Minimum 4 characters are allowed.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"maxlength\">Maximum 50 characters are allowed.</div>--><!--</div>--><!--</div>--><!--</div>--><p class=\"basicRegistrationP backgroundBasicPending text-center mt10\" ng-if=\"vm.dataToFill.fleet_type != \'1\'\">{{\'paymentHead\' | translate}}</p><div class=\"row mt5\" ng-if=\"vm.dataToFill.fleet_type != \'1\'\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'paymentModulityLabel\' | translate}} <span style=color:red ng-if=\"vm.dataToFill.fleet_type == \'2\'\">*</span></label><select class=form-control ng-model=vm.dataToFill.payment_modulity name=paymentModulity ng-required=\"vm.dataToFill.fleet_type == \'2\'\" ng-class=\"{ \'has-error\': driverEditForm.paymentModulity.$touched && driverEditForm.paymentModulity.$invalid }\"><option value=\"\" disabled selected>{{\'paymentModulityLabelSelect\' | translate}}</option><!-- <option value=\"1\">Bank Deposit</option>\n                                                <option value=\"2\">Vale View</option> --><option value=1>1 Vale Vista</option><option value=2>3 Abono Cta Cte y Cta Vista</option><option value=3>4 Abono Cta Ahorro</option></select><div ng-if=\"driverEditForm.paymentModulity.$touched || submit\" ng-messages=driverEditForm.paymentModulity.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'paymentModulityRequired\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'bankLabel\' | translate}} <span style=color:red ng-if=\"vm.dataToFill.fleet_type == \'2\'\">*</span></label><!-- <input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.bank_name\"\n                                                   name=\"Bank\" placeholder=\"{{\'bankLabel\' | translate}}\" ng-required=\"vm.dataToFill.fleet_type == \'2\'\"\n                                                   ng-class=\"{ \'has-error\': driverEditForm.Bank.$touched && driverEditForm.Bank.$invalid }\"\n                                                   pattern=\"^[a-zA-Z0-9][a-zA-Z0-9\\s,]*$\"/> --><select class=form-control ng-model=vm.dataToFill.bank_name name=Bank ng-required=\"vm.dataToFill.registration_flag == \'2\'\" ng-class=\"{ \'has-error\': driverRegisterForm.Bank.$touched && driverRegisterForm.Bank.$invalid && vm.dataToFill.registration_flag == \'2\' }\"><option value=\"\" disabled selected>{{\'bankLabel\' | translate}}</option><option value={{bankName.bank_name}} ng-repeat=\"bankName in vm.driverBankNamesArray\">{{bankName.bank_name}}</option></select><div ng-if=\"driverEditForm.Bank.$touched|| submit\" ng-messages=driverEditForm.Bank.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'bankReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'bankValid\' | translate}}</div></div></div><!-- <div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">\n                                            <label class=\"control-label\">{{\'accountTypeLabel\' | translate}}\n                                                <span style=\"color:red\" ng-if=\"vm.dataToFill.fleet_type == \'2\'\">*</span>\n                                            </label>\n                                            <select class=\"form-control\" ng-model=\"vm.dataToFill.account_type\" name=\"accountType\" ng-required=\"vm.dataToFill.fleet_type == \'2\'\"\n                                                ng-class=\"{ \'has-error\': driverEditForm.accountType.$touched && driverEditForm.accountType.$invalid }\">\n                                                <option value=\"\" disabled selected>{{\'accountTypeLabelSelect\' | translate}}</option>\n                                                <option value=\"1\">Electronic Cheque Book</option>\n                                                <option value=\"2\">Saving Account</option>\n                                                <option value=\"3\">Checking Account</option>\n                                            </select>\n                                            <div ng-if=\"driverEditForm.accountType.$touched || submit\" ng-messages=\"driverEditForm.accountType.$error\">\n                                                <div class=\"errormessage text-danger\" ng-message=\"required\">{{\'accTypeReq\' | translate}}\n                                                </div>\n                                            </div>\n                                        </div> --><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=\"vm.dataToFill.registration_flag !=\'1\'\"><!--ng-if=\"vm.dataToFill.registration_flag != \'2\'\"--><label class=control-label>{{\'accountTypeLabel\' | translate}} <span style=color:red ng-if=\"vm.dataToFill.registration_flag == \'2\'\">*</span></label><input type=text class=form-control ng-model=vm.dataToFill.account_rut name=account_rut placeholder=\"{{\'rutLabel\' | translate}}\" ng-rut ng-change=vm.rutChange2() ng-class=\"{ \'has-error\': driverRegisterForm.account_rut.$touched && driverRegisterForm.account_rut.$invalid }\"><div ng-if=\"driverRegisterForm.account_rut.$touched || submit\" ng-messages=driverRegisterForm.account_rut.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'rutRequired\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid RUT.</div>--></div><div class=\"errormessage text-danger\" ng-if=vm.rutFlag>{{\'rutValid\' | translate}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'accountNumberLabel\' | translate}} <span style=color:red ng-if=\"vm.dataToFill.fleet_type == \'2\'\">*</span></label><input type=text class=form-control ng-model=vm.dataToFill.account_number name=accountNumber ng-required=\"vm.dataToFill.fleet_type == \'2\'\" placeholder=\"{{\'accountNumberLabel\' | translate}}\" ng-class=\"{ \'has-error\': driverEditForm.accountNumber.$touched && driverEditForm.accountNumber.$invalid }\" pattern=^([0-9])*$><div ng-if=\"driverEditForm.accountNumber.$touched|| submit\" ng-messages=driverEditForm.accountNumber.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'accNumReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'accNumValid\' | translate}}</div></div></div></div><p class=\"basicRegistrationP backgroundBasicPending text-center mt10\">{{\'documentsHead\' | translate}}</p><div class=\"row mt5\"><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\"><img ng-src=\"{{ vm.driverDetails.fleet_image || \'assets/images/noImage.jpeg\'}}\" id=profilePic class=documentStyle><br><input id=documentUpload filestyle=\"\" type=file style=\"display: none\" image=image name={{vm.uploadName}} onchange=angular.element(this).scope().file_to_upload(this.files,this.name) onclick=\"this.value = null\" data-button-text=Single data-class-button=\"btn btn-default\" data-classinput=\"form-control inline\" nv-file-select=\"\" uploader=uploader><label class=\"control-label mt10\">{{\'profilePic\' | translate}}</label><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'PROFILE\')\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\" ng-if=\"vm.dataToFill.fleet_type !=\'2\'\"><!--ng-if=\"vm.dataToFill.fleet_type !=\'2\'\"--> <img ng-src=\"{{ vm.driverDetails.RUT_image || \'assets/images/noImage.jpeg\'}}\" id=rutImage class=documentStyle><br><label class=\"control-label mt10\">{{\'rutLabel\' | translate}}<!-- <span style=\"color:red\">*</span> --></label><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'RUT\')\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\" ng-if=\"vm.dataToFill.fleet_type !=\'2\'\"><!--ng-if=\"vm.dataToFill.fleet_type !=\'2\'\">--> <img ng-src=\"{{ vm.driverDetails.license_img || \'assets/images/noImage.jpeg\'}}\" id=licenseImage class=documentStyle><br><label class=\"control-label mt10\">{{\'licenseImage\' | translate}}<!-- alvaro change --> <span style=color:red>*</span></label><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'LICENSE\')\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\" ng-if=\"vm.dataToFill.fleet_type !=\'2\'\"><!--ng-if=\"vm.dataToFill.fleet_type !=\'2\'\"--> <img ng-src=\"{{ vm.driverDetails.life_sheet_img || \'assets/images/noImage.jpeg\'}}\" id=lifeSheet class=documentStyle><br><label class=\"control-label mt10\">{{\'lifeSheetImage\' | translate}} <span style=color:red>*</span></label><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'LIFE_SHEET\')\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\" ng-if=\"vm.dataToFill.fleet_type !=\'2\'\"><!--ng-if=\"vm.dataToFill.fleet_type !=\'2\'\"--> <img ng-src=\"{{ vm.driverDetails.antecents_certificate || \'assets/images/noImage.jpeg\'}}\" id=antecents class=documentStyle><br><label class=\"control-label mt10\">{{\'antcedentsImage\' | translate}} <span style=color:red>*</span></label><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'ANTECENTS\')\">{{\'uploadButton\' | translate}}</button></div><!--<div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\">\n                                            <img ng-src=\"{{ vm.driverDetails.company_identity_card || \'assets/images/noImage.jpeg\'}}\" id=\"companyIdentity\" class=\"documentStyle\" /><br/>\n                                            <label class=\"control-label mt10\">Company Identity Card<span\n                                                    style=\"color:red\">*</span></label>\n                                            <button type=\"button\" class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'COMPANY_IDENTITY_CARD\')\">Upload\n                                            </button>\n                                        </div>\n                                        <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\">\n                                            <img ng-src=\"{{ vm.driverDetails.company_constitution || \'assets/images/noImage.jpeg\'}}\" id=\"constitution\" class=\"documentStyle\" /><br/>\n                                            <label class=\"control-label mt10\">Company Constitution<span\n                                                    style=\"color:red\">*</span></label>\n                                            <button type=\"button\" class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'CONSTITUTION\')\">Upload\n                                            </button>\n                                        </div>\n                                        <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\">\n                                            <img ng-src=\"{{ vm.driverDetails.start_activities || \'assets/images/noImage.jpeg\'}}\" id=\"activity\" class=\"documentStyle\" /><br/>\n                                            <label class=\"control-label mt10\">Activity Start<span\n                                                    style=\"color:red\">*</span></label>\n                                            <button type=\"button\" class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'ACTIVITY\')\">Upload\n                                            </button>\n                                        </div>\n                                        <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\">\n                                            <img ng-src=\"{{ vm.driverDetails.invoice_stamping || \'assets/images/noImage.jpeg\'}}\" id=\"invoice\" class=\"documentStyle\" /><br/>\n                                            <label class=\"control-label mt10\">Stamping Invoice<span\n                                                    style=\"color:red\">*</span></label>\n                                            <button type=\"button\" class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'INVOICE\')\">Upload\n                                            </button>\n                                        </div>--><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\" ng-if=\"vm.dataToFill.fleet_type != \'1\'\"><img src=\"{{ vm.driverDetails.invoice_rut_image || \'assets/images/noImage.jpeg\'}}\" id=invoiceRUT class=documentStyle><br><!--<input id=\"documentUpload\" filestyle=\"\" type=\"file\" style=\"display: none;\" image=\"image\" name=\"{{vm.uploadinvoice_rut_image }}\" onchange=\"angular.element(this).scope().file_to_upload(this.files,this.name)\" onclick=\"this.value = null;\" data-button-text=\"Single\"--><!--data-class-button=\"btn btn-default\" data-classinput=\"form-control inline\" nv-file-select=\"\" uploader=\"uploader\" />--><label class=\"control-label mt10\">{{\'invoiceRut\' | translate}}</label><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'INVOICE_RUT\')\">{{\'uploadButton\' | translate}}</button></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><button class=\"btn btn-primary\" type=submit style=width:200px>{{\'submit\' | translate}}</button></div></div></div></form></div></div></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12 mt25\" ng-if=vm.carDetails.length><div class=basicDiv ng-if=\"vm.dataToFill.fleet_type != \'1\'\"><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'carDetailsHead\' | translate}}</p><div class=basicDetailsDiv><form name=driverCarEditForm ng-submit=\"submitCar=true;driverCarEditForm.$valid&&vm.editCarApi($index,carsData)\" novalidate autocomplete=off ng-repeat=\"carsData in vm.carDetails\"><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'vehicleLabel\' | translate}} <span style=color:red>*</span></label><ui-select ng-model=carsData.car_type name=carType{{$index}} required ng-class=\"{ \'has-error\': driverCarEditForm[\'carType\'+$index].$touched && driverCarEditForm[\'carType\'+$index].$invalid }\" close-on-select=true><ui-select-match placeholder=\"{{\'vehiclePlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in vm.vehicle | filter: $select.search\"><div ng-bind-html=data.name></div></ui-select-choices></ui-select><div ng-if=\"driverCarEditForm[\'carType\'+$index].$touched || submitCar\" ng-messages=\"driverCarEditForm[\'carType\'+$index].$error\"><div class=\"errormessage text-danger\" ng-message=required>{{\'vehicleReq\' | translate}}</div></div><!--<select class=\"form-control\" ng-model=\"carsData.car_type\" name=\"carType{{$index}}\" required ng-class=\"{ \'has-error\': driverCarEditForm[\'carType\'+$index].$touched && driverCarEditForm[\'carType\'+$index].$invalid }\">\n                                            <option value=\"\" disabled selected>Select Car Type</option>\n                                            <option value=\"1\">SUV</option>\n                                            <option value=\"2\">Sedan</option>\n                                            <option value=\"3\">VAN</option>\n                                        </select>\n                                        <div ng-if=\"driverCarEditForm[\'carType\'+$index].$touched || submitCar\" ng-messages=\"driverCarEditForm[\'carType\'+$index].$error\">\n                                            <div class=\"errormessage text-danger\" ng-message=\"required\">Please select car type.\n                                            </div>\n                                        </div>--></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'PPU\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=carsData.registration_number name=registrationNumber{{$index}} placeholder=\"{{\'PPU\' | translate}}\" required ng-class=\"{ \'has-error\': driverCarEditForm[\'registrationNumber\'+$index].$touched && driverCarEditForm[\'registrationNumber\'+$index].$invalid }\" pattern=^([A-Za-z]{2})([A-Za-z0-9]{2})([0-9]{2})*$ ng-minlength=3 ng-maxlength=8><!--[a-zA-Z0-9][a-zA-Z0-9-]--><div ng-if=\"driverCarEditForm[\'registrationNumber\'+$index].$touched|| submitCar\" ng-messages=\"driverCarEditForm[\'registrationNumber\'+$index].$error\"><div class=\"errormessage text-danger\" ng-message=required>{{\'registrationNumRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'registrationNumValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'registrationNumMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'registrationNumMaximum\' | translate}}</div></div></div></div><div class=\"row mt5\"><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">\n                                        <label class=\"control-label\">Working for 24 hrs<span style=\"color:red\">*</span></label>\n                                        <select class=\"form-control\" ng-model=\"carsData.modelity\"\n                                                name=\"modelityS{{$index}}\" required\n                                                ng-class=\"{ \'has-error\': driverCarEditForm[\'modelityS\'+$index].$touched && driverCarEditForm[\'modelityS\'+$index].$invalid }\">\n                                            <option value=\"\" disabled selected>Select Modelity</option>\n                                            <option value=\"1\">Yes</option>\n                                            <option value=\"0\">No</option>\n                                        </select>\n                                        <div ng-if=\"driverCarEditForm[\'modelityS\'+$index].$touched || submitCar\"\n                                             ng-messages=\"driverCarEditForm[\'modelityS\'+$index].$error\">\n                                            <div class=\"errormessage text-danger\" ng-message=\"required\">Please select\n                                                modelity.\n                                            </div>\n                                        </div>\n                                    </div>--><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'workingStatus\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=carsData.working_status name=workingStatus{{$index}} required ng-class=\"{ \'has-error\': driverCarEditForm[\'workingStatus\'+$index].$touched && driverCarEditForm[\'workingStatus\'+$index].$invalid }\"><option value=\"\" disabled selected>{{\'workingStatusPlaceholder\' | translate}}</option><option value=1>Active</option><option value=0>Inactive</option></select><div ng-if=\"driverCarEditForm[\'workingStatus\'+$index].$touched || submitCar\" ng-messages=\"driverCarEditForm[\'workingStatus\'+$index].$error\"><div class=\"errormessage text-danger\" ng-message=required>{{\'workingStatusReq\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Sociedad SAP <span style=color:red>*</span></label><select class=form-control ng-model=carsData.society_id name=societyId{{$index}} required ng-class=\"{ \'has-error\': driverCarEditForm[\'societyId\'+$index].$touched && driverCarEditForm[\'societyId\'+$index].$invalid }\" ng-options=\"data.society_id\n                                            as data.name for data in vm.societies\"><option value=\"\" disabled selected>Sociedad SAP</option></select><div ng-if=\"driverCarEditForm[\'societyId\'+$index].$touched || submitCar\" ng-messages=\"driverCarEditForm[\'societyId\'+$index].$error\"><div class=\"errormessage text-danger\" ng-message=required>Favor seleccione Sociedad</div></div></div></div><!-- <div class=\"row mt5\"> --><!-- <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\">\n                                        <label class=\"control-label mt10\">{{\'carImage\' | translate}}<span\n                                                style=\"color:red\">*</span></label><br/>\n                                        <img ng-src=\"{{ carsData.car_photo || \'assets/images/noImage.jpeg\'}}\"\n                                             id=\"carImage{{$index}}\" class=\"documentStyle\"/><br/>\n                                        <button type=\"button\" class=\"btn btn-primary upload mt10\"\n                                                ng-click=\"vm.clickTrigger($event,\'CAR_IMAGE\',$index)\">{{\'uploadButton\' | translate}}\n                                        </button>\n                                    </div> --><!-- <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\">\n                                        <label class=\"control-label mt10\">{{\'vehicleImage\' | translate}}<span\n                                                style=\"color:red\">*</span></label><br/>\n                                        <img ng-src=\"{{ carsData.registration_image || \'assets/images/noImage.jpeg\'}}\"\n                                             id=\"registerImage{{$index}}\" class=\"documentStyle\"/><br/>\n                                        <button type=\"button\" class=\"btn btn-primary upload mt10\"\n                                                ng-click=\"vm.clickTrigger($event,\'REGISTER_IMAGE\',$index)\">{{\'uploadButton\' | translate}}\n                                        </button>\n                                    </div> --><!-- <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6  mt5\">\n                                        <label class=\"control-label mt10\">{{\'travelCard\' | translate}}<span\n                                                style=\"color:red\">*</span></label><br/>\n                                        <img src=\"{{ carsData.travel_card_key || \'assets/images/noImage.jpeg\'}}\"\n                                             id=\"travel{{$index}}\" class=\"documentStyle\"/><br/>\n                                        <button type=\"button\" class=\"btn btn-primary upload mt10 ml5\"\n                                                ng-click=\"vm.clickTrigger($event,\'TRAVEL_CARD_KEY\',$index)\">\n                                            {{\'uploadButton\' | translate}}\n                                        </button>\n                                    </div> --><!-- </div> --><div class=\"row mt5\"><!-- <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\">\n                                        <label class=\"control-label mt10\">{{\'passengerSeatInsurance\' | translate}}<span\n                                                style=\"color:red\">*</span></label><br/>\n                                        <img src=\"{{carsData.passenger_insurance_key || \'assets/images/noImage.jpeg\'}}\"\n                                             id=\"seatInsurance{{$index}}\" class=\"documentStyle\"/><br/>\n                                        <button type=\"button\" class=\"btn btn-primary upload mt10 ml5\"\n                                                ng-click=\"vm.clickTrigger($event,\'PASSENGER_INSURANCE_KEY\',$index)\">\n                                            {{\'uploadButton\' | translate}}\n                                        </button>\n                                    </div> --><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\"><label class=\"control-label mt10\">{{\'circulationPermission\' | translate}} <span style=color:red>*</span></label><br><img src=\"{{carsData.permission_of_circulation || \'assets/images/noImage.jpeg\'}}\" id=permission{{$index}} class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'PERMISSION_OF_CIRCULATION\',$index)\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\"><label class=\"control-label mt10\">Permiso Ministerio de Transporte<!-- <span style=\"color:red\">*</span> --></label><br><img src=\"{{carsData.transportation_permit || \'assets/images/noImage.jpeg\'}}\" id=transportation_permit{{$index}} class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'TRANSPORTATION_PERMIT\',$index)\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5\"><label class=control-label>{{\'verificationComments\' | translate}}:</label><div class=text-capitalize><textarea class=form-control ng-model=carsData.verification_comment placeholder=\"No Description\"></textarea></div></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><button class=\"btn btn-primary\" type=submit style=width:200px>{{\'submit\' | translate}}</button></div></div><div class=row ng-if=\"$index != vm.carDetails.length - 1\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><hr></div></div></form></div></div></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12 mt25\" ng-if=\"vm.carDetails.length == 0\"><div class=basicDiv ng-if=\"vm.dataToFill.fleet_type != \'1\'\"><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'carDetailsHead\' | translate}}</p><div class=basicDetailsDiv><form name=driverCarAddFormF ng-submit=\"submitCar=true;driverCarAddFormF.$valid&&vm.addCarApi()\" novalidate autocomplete=off><div ng-repeat=\"addCars in vm.dataToFill.addNewCar\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-right\"><a class=\"btn btn-sm blockIconColor\" title=\"Delete Vehicle\" ng-click=vm.deleteVehicleType($index) style=\"border: 1px solid red;margin-left:5px\" ng-if=\"vm.dataToFill.addNewCar.length > 1\"><i class=\"fa fa-trash\"></i> </a><a class=\"btn btn-sm editIconColor\" ng-click=vm.addVehicle($index) title=\"Add Vehicle\" style=\"border: 1px solid #7266ba;margin-left:5px\"><i class=\"fa fa-plus\"></i></a></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'vehicleLabel\' | translate}} <span style=color:red>*</span></label><ui-select ng-model=addCars.car_type name=carTypeAdd{{$index}} required ng-class=\"{ \'has-error\': driverCarAddFormF[\'carTypeAdd\'+$index].$touched && driverCarAddFormF[\'carTypeAdd\'+$index].$invalid }\" close-on-select=true><ui-select-match placeholder=\"{{\'vehiclePlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in vm.vehicle | filter: $select.search\"><div ng-bind-html=data.name></div></ui-select-choices></ui-select><div ng-if=\"driverCarAddFormF[\'carTypeAdd\'+$index].$touched || submitCar\" ng-messages=\"driverCarAddFormF[\'carTypeAdd\'+$index].$error\"><div class=\"errormessage text-danger\" ng-message=required>{{\'vehicleReq\' | translate}}</div></div><!--<select class=\"form-control\" ng-model=\"addCars.car_type\" name=\"carTypeAdd{{$index}}\" required ng-class=\"{ \'has-error\': driverCarAddFormF[\'carTypeAdd\'+$index].$touched && driverCarAddFormF[\'carTypeAdd\'+$index].$invalid }\">\n                                                <option value=\"\" disabled selected>Select Car Type</option>\n                                                <option value=\"1\">SUV</option>\n                                                <option value=\"2\">Sedan</option>\n                                                <option value=\"3\">VAN</option>\n                                            </select>\n                                            <div ng-if=\"driverCarAddFormF[\'carTypeAdd\'+$index].$touched || submitCar\" ng-messages=\"driverCarAddFormF[\'carTypeAdd\'+$index].$error\">\n                                                <div class=\"errormessage text-danger\" ng-message=\"required\">Please select car type.\n                                                </div>\n                                            </div>--></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'PPU\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=addCars.registration_number name=registrationNumberAdd{{$index}} placeholder=\"{{\'PPU\' | translate}}\" required ng-class=\"{ \'has-error\': driverCarAddFormF[\'registrationNumberAdd\'+$index].$touched && driverCarAddFormF[\'registrationNumberAdd\'+$index].$invalid }\" pattern=^([A-Za-z]{2})([A-Za-z0-9]{2})([0-9]{2})*$ ng-minlength=3 ng-maxlength=8><!--pattern=\"^[a-zA-Z0-9][a-zA-Z0-9-]*$\"--><div ng-if=\"driverCarAddFormF[\'registrationNumberAdd\'+$index].$touched|| submitCar\" ng-messages=\"driverCarAddFormF[\'registrationNumberAdd\'+$index].$error\"><div class=\"errormessage text-danger\" ng-message=required>{{\'registrationNumRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'registrationNumValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'registrationNumMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'registrationNumMaximum\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'workingFor24\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=addCars.modelity name=modelityAddF{{$index}} required ng-class=\"{ \'has-error\': driverCarAddFormF[\'modelityAddF\'+$index].$touched && driverCarAddFormF[\'modelityAddF\'+$index].$invalid }\"><option value=\"\" disabled selected>{{\'selectModelityCar\' | translate}}</option><option value=1>Yes</option><option value=0>No</option></select><div ng-if=\"driverCarAddFormF[\'modelityAddF\'+$index].$touched || submitCar\" ng-messages=\"driverCarAddFormF[\'modelityAddF\'+$index].$error\"><div class=\"errormessage text-danger\" ng-message=required>{{\'selectModelityCarReq\' | translate}}</div></div></div></div><div class=\"row mt5\"><!-- <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\">\n                                            <label class=\"control-label mt10\">{{\'carImage\' | translate}}<span style=\"color:red\">*</span></label><br/>\n                                            <img src=\'assets/images/noImage.jpeg\' id=\"addCarImage{{$index}}\"\n                                                 class=\"documentStyle\"/><br/>\n                                            <button type=\"button\" class=\"btn btn-primary upload mt10\"\n                                                    ng-click=\"vm.clickTrigger($event,\'ADD_CAR_IMAGE\',$index)\">{{\'uploadButton\' | translate}}\n                                            </button>\n                                        </div>\n                                        <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\">\n                                            <label class=\"control-label mt10\">{{\'vehicleImage\' | translate}}<span\n                                                    style=\"color:red\">*</span></label><br/>\n                                            <img src=\'assets/images/noImage.jpeg\' id=\"addRegisterImage{{$index}}\"\n                                                 class=\"documentStyle\"/><br/>\n                                            <button type=\"button\" class=\"btn btn-primary upload mt10\"\n                                                    ng-click=\"vm.clickTrigger($event,\'ADD_REGISTER_IMAGE\',$index)\">\n                                                {{\'uploadButton\' | translate}}\n                                            </button>\n                                        </div>\n                                        <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\">\n                                            <label class=\"control-label mt10\">{{\'passengerSeatInsurance\' | translate}}<span\n                                                    style=\"color:red\">*</span></label><br/>\n                                            <img src=\'assets/images/noImage.jpeg\' id=\"addSeatInsurance{{$index}}\"\n                                                 class=\"documentStyle\"/><br/>\n                                            <button type=\"button\" class=\"btn btn-primary upload mt10\"\n                                                    ng-click=\"vm.clickTrigger($event,\'ADD_PASSENGER_INSURANCE_KEY\',$index)\">\n                                                {{\'uploadButton\' | translate}}\n                                            </button>\n                                        </div>\n                                        <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\">\n                                            <label class=\"control-label mt10\">{{\'travelCard\' | translate}}<span\n                                                    style=\"color:red\">*</span></label><br/>\n                                            <img src=\'assets/images/noImage.jpeg\' id=\"addTravel{{$index}}\"\n                                                 class=\"documentStyle\"/><br/>\n                                            <button type=\"button\" class=\"btn btn-primary upload mt10\"\n                                                    ng-click=\"vm.clickTrigger($event,\'ADD_TRAVEL_CARD_KEY\',$index)\">\n                                                {{\'uploadButton\' | translate}}\n                                            </button>\n                                        </div> --><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\"><label class=\"control-label mt10\">{{\'circulationPermission\' | translate}} <span style=color:red>*</span></label><br><img src=assets/images/noImage.jpeg id=addPermission{{$index}} class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10\" ng-click=\"vm.clickTrigger($event,\'ADD_PERMISSION_OF_CIRCULATION\',$index)\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\"><label class=\"control-label mt10\">Permiso Ministerio de Transporte<!-- <span style=\"color:red\">*</span> --></label><br><img src=assets/images/noImage.jpeg id=addTransportationPermit{{$index}} class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10\" ng-click=\"vm.clickTrigger($event,\'ADD_TRANSPORTATION_PERMIT\',$index)\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5\"><label class=control-label>{{\'verificationComments\' | translate}}:</label><div class=text-capitalize><textarea class=form-control ng-model=carsData.verification_comment placeholder=\"No Description\"></textarea></div></div></div><div class=row ng-if=\"$index != vm.dataToFill.addNewCar.length - 1\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><hr></div></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><button class=\"btn btn-primary\" type=submit style=width:200px>{{\'submit\' | translate}}</button></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/applicants/registerApplicants.html","<h2 class=ng-cloak>{{\'applicantHead\' | translate}} / {{\'applicantRegisterHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=driver><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'detailsApplicant\' | translate}}</p><div class=basicDetailsDiv><form name=driverRegisterForm ng-submit=\"submit=true;driverRegisterForm.$valid&&vm.registerApi()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'applicantTypes\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.registration_flag name=driverType required ng-class=\"{\'has-error\': driverRegisterForm.driverType.$touched && driverRegisterForm.driverType.$invalid}\"><option value=\"\" disabled selected>{{\'applicantTypePlaceholder\' | translate}}</option><option value=0>Conductor con auto</option><option value=1>Conductor sin auto</option><option value=2>Soy inversionista</option></select><div ng-if=\"driverRegisterForm.driverType.$touched || submit\" ng-messages=driverRegisterForm.driverType.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'applicantTypeRequired\' | translate}}</div></div></div></div><div ng-if=vm.dataToFill.registration_flag><!--ng-if=\"vm.dataToFill.registration_flag\"--><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'firstNameLabel\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.first_name name=firstName placeholder=\"{{\'firstNameLabel\' | translate}}\" required ng-maxlength=60 ng-minlength=3 ng-class=\"{ \'has-error\': driverRegisterForm.firstName.$touched && driverRegisterForm.firstName.$invalid }\" pattern=^\\D*$><!--onkeypress=\'return event.charCode >= 65 && event.charCode <= 90 || event.charCode >= 97 && event.charCode <= 122 || event.charCode >= 128 && event.charCode <= 165 || event.charCode == 8 || event.charCode == 9 || event.charCode == 32\'--><div ng-if=\"driverRegisterForm.firstName.$touched|| submit\" ng-messages=driverRegisterForm.firstName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'firstNameRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'firstNameValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'firstNameMaximum\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'lastNameLabel\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.last_name name=lastName placeholder=\"{{\'lastNameLabel\' | translate}}\" required ng-maxlength=60 ng-minlength=3 ng-class=\"{ \'has-error\': driverRegisterForm.lastName.$touched && driverRegisterForm.lastName.$invalid }\" pattern=^\\D*$><!--onkeypress=\'return event.charCode >= 65 && event.charCode <= 90 || event.charCode >= 97 && event.charCode <= 122 || event.charCode >= 128 && event.charCode <= 165 || event.charCode == 8 || event.charCode == 9 || event.charCode == 32\'--><div ng-if=\"driverRegisterForm.lastName.$touched|| submit\" ng-messages=driverRegisterForm.lastName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'lastNameRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'lastNameValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'lastNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'lastNameMaximum\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'emailPlaceholder\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.email name=driverEmail placeholder=\"{{\'emailPlaceholder\' | translate}}\" required ng-class=\"{ \'has-error\': driverRegisterForm.driverEmail.$touched && driverRegisterForm.driverEmail.$invalid }\" pattern=^([_a-zA-Z0-9-+]+)(\\.[_a-zA-Z0-9-+]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*\\.)+([a-zA-Z]{2,3})$><div ng-if=\"driverRegisterForm.driverEmail.$touched|| submit\" ng-messages=driverRegisterForm.driverEmail.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'requiredEmail\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'validEmail\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=\"vm.dataToFill.registration_flag !=\'2\'\"><!--ng-if=\"vm.dataToFill.registration_flag != \'2\'\"--><label class=control-label>{{\'rutLabel\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.RUT name=driverRUT placeholder=\"{{\'rutLabel\' | translate}}\" ng-rut ng-change=vm.rutChange() required ng-class=\"{ \'has-error\': driverRegisterForm.driverRUT.$touched && driverRegisterForm.driverRUT.$invalid }\"><div ng-if=\"driverRegisterForm.driverRUT.$touched|| submit\" ng-messages=driverRegisterForm.driverRUT.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'rutRequired\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid RUT.</div>--></div><div class=\"errormessage text-danger\" ng-if=vm.rutFlag>{{\'rutValid\' | translate}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=\"vm.dataToFill.registration_flag !=\'1\'\"><label class=control-label>{{\'invoiceRut\' | translate}} <span style=color:red ng-if=\"vm.dataToFill.registration_flag == \'2\'\">*</span></label><input type=text class=form-control ng-model=vm.dataToFill.invoice_rut name=invoiceRUT placeholder=\"{{\'invoiceRut\' | translate}}\" ng-rut ng-change=vm.rutChange1() ng-required=\"vm.dataToFill.registration_flag == \'2\'\" ng-class=\"{ \'has-error\': driverRegisterForm.invoiceRUT.$touched && driverRegisterForm.invoiceRUT.$invalid && (vm.dataToFill.registration_flag == \'2\') }\"><div ng-if=\"driverRegisterForm.invoiceRUT.$touched|| submit\" ng-messages=driverRegisterForm.invoiceRUT.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'rutRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>Ingresa un rut válido</div></div><div class=\"errormessage text-danger\" ng-if=vm.rutFlag1>Ingresa un rut válido</div></div></div><div class=\"row mt5\"><!--<div class=\"col-lg-2 col-sm-2 col-md-2 col-xs-4\">\n                                            <label class=\"control-label\">Mobile Number<span style=\"color:red\">*</span></label>\n                                            <input type=\"text\" style=\"width:50px\" class=\"form-control\" ng-model=\"vm.dataToFill.country_code\" name=\"countryCode\" placeholder=\"Country Code\" required ng-class=\"{ \'has-error\': driverRegisterForm.countryCode.$touched && driverRegisterForm.countryCode.$invalid }\"\n                                                pattern=\"^[0-9+][0-9+]*$\" readonly/>\n                                            <div ng-if=\"driverRegisterForm.countryCode.$touched|| submit\" ng-messages=\"driverRegisterForm.countryCode.$error\">\n                                                <div class=\"errormessage text-danger\" ng-message=\"required\">Please enter country code\n                                                </div>\n                                                <div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid country code.\n                                                </div>\n                                            </div>\n                                        </div>--><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'mobileNumber\' | translate}} <span style=color:red>*</span></label><div class=displayFlex><div><input type=text style=width:50px class=form-control ng-model=vm.dataToFill.country_code name=countryCode placeholder=\"Country Code\" required ng-class=\"{ \'has-error\': driverRegisterForm.countryCode.$touched && driverRegisterForm.countryCode.$invalid }\" pattern=^[0-9+][0-9+]*$ readonly><div ng-if=\"driverRegisterForm.countryCode.$touched|| submit\" ng-messages=driverRegisterForm.countryCode.$error><div class=\"errormessage text-danger\" ng-message=required>Please enter country code</div><div class=\"errormessage text-danger\" ng-message=pattern>Please enter a valid country code.</div></div></div><div style=\"width:90%; margin-left:5px\"><input type=text class=form-control ng-model=vm.dataToFill.phone_number name=mobileNumber placeholder=\"{{\'mobileNumber\' | translate}}\" required ng-minlength=9 ng-maxlength=9 ng-class=\"{\'has-error\': driverRegisterForm.mobileNumber.$touched && driverRegisterForm.mobileNumber.$invalid}\" pattern=^([9]{1}[0-9]{8})*$><!--\"^([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1})*$\"--><div ng-if=\"driverRegisterForm.mobileNumber.$touched|| submit\" ng-messages=driverRegisterForm.mobileNumber.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'mobileRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'mobileValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'mobileValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'mobileValid\' | translate}}</div></div></div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'usernameLabel\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.username name=username placeholder=\"{{\'usernameLabel\' | translate}}\" required ng-class=\"{ \'has-error\': driverRegisterForm.username.$touched && driverRegisterForm.username.$invalid}\" pattern=^[a-zA-Zñ0-9][a-zA-Zñ0-9\\s,]*$ ng-minlength=4 ng-maxlength=50><div ng-if=\"driverRegisterForm.username.$touched|| submit\" ng-messages=driverRegisterForm.username.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'usernameRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'usernameValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'usernameMin\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'usernameMax\' | translate}}</div></div></div></div><div class=\"row mt5\" ng-if=\"vm.dataToFill.registration_flag !=\'2\'\"><!--ng-if=\" vm.dataToFill.registration_flag !=\'2\' \"--><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'liceneClassLabel\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.license_type name=licencseType required ng-class=\"{\'has-error\': driverEditForm.licencseType.$touched && driverEditForm.licencseType.$invalid}\"><option value=\"\" disabled selected>{{\'liceneClassLabel\' | translate}}</option><option ng-repeat=\"licenseType in vm.licenceTypesData\" value={{licenseType}}>{{licenseType}}</option></select><!--<select class=\"form-control\" ng-model=\"vm.dataToFill.license_type\" name=\"licencseType\" required ng-class=\"{\'has-error\': driverRegisterForm.licencseType.$touched && driverRegisterForm.licencseType.$invalid}\">--><!--<option value=\"\" disabled selected>Select Class Of License</option>--><!--<option value=\"A1\">A1</option>--><!--<option value=\"A2\">A2</option>--><!--<option value=\"A3\">A3</option>--><!--</select>--><!-- <input type=\"text\" class=\"form-control\"\n                                                   ng-model=\"vm.dataToFill.license_type\" alpha-numeric=\"\"\n                                                   name=\"licencseType\" placeholder=\"{{\'liceneClassLabel\' | translate}}\" required ng-class=\"{ \'has-error\': driverRegisterForm.licencseType.$touched\n                                        && driverRegisterForm.licencseType.$invalid }\" maxlength=\"10\"/> --><div ng-if=\"driverRegisterForm.licencseType.$touched|| submit\" ng-messages=driverRegisterForm.licencseType.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'licenseRequired\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid license type.\n                                                </div>\n                                                <div class=\"errormessage text-danger\" ng-message=\"minlength\">Minimum 1 characters are allowed.\n                                                </div>\n                                                <div class=\"errormessage text-danger\" ng-message=\"maxlength\">Maximum 2 characters are allowed.\n                                                </div>--></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'liceneExpiaryLabel\' | translate}}<!-- <span style=\"color:red\">*</span> --></label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} ng-model=vm.dataToFill.license_expiry_date name=licenseExpiry placeholder=\"{{\'liceneExpiaryLabel\' | translate}}\" is-open=vm.datePicker_1.end datepicker-options=vm.dateOptions close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_1()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"driverRegisterForm.licenseExpiry.$touched|| submit\" ng-messages=driverRegisterForm.licenseExpiry.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'licenseExpiryRequired\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'cityOfWorkLabel\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.branch name=branch required ng-class=\"{\'has-error\': driverRegisterForm.branch.$touched && driverRegisterForm.branch.$invalid}\" ng-options=\"branch.region_id\n                                        as branch.region_name for branch in vm.branchList\"><option value=\"\" disabled selected>{{\'cityOfWorkLabelSelect\' | translate}}</option></select><div ng-if=\"driverRegisterForm.branch.$touched|| submit\" ng-messages=driverRegisterForm.branch.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'cityWorkRequired\' | translate}}</div></div><!--<input type=\"text \" class=\"form-control \" ng-model=\"vm.dataToFill.branch \" name=\"branch \" placeholder=\"Branch \" required ng-class=\"{ \'has-error\': driverRegisterForm.branch.$touched && driverRegisterForm.branch.$invalid\n                                        } \" pattern=\"^[a-zA-Z0-9][a-zA-Z0-9\\s]*$ \"--><!--ng-minlength=\"3 \" ng-maxlength=\"16 \"/>--><!--<div ng-if=\"driverRegisterForm.branch.$touched|| submit \" ng-messages=\"driverRegisterForm.branch.$error \">--><!--<div class=\"errormessage text-danger \" ng-message=\"required \">Please enter branch</div>--><!--<div class=\"errormessage text-danger \" ng-message=\"pattern \">Please enter a valid branch.</div>--><!--<div class=\"errormessage text-danger \" ng-message=\"minlength \">Minimum 3 characters are allowed.</div>--><!--<div class=\"errormessage text-danger \" ng-message=\"maxlength \">Maximum 16 characters are allowed.</div>--><!--</div>--></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=\"vm.dataToFill.registration_flag !=\'1\'\"><label class=control-label>{{\'businessName\' | translate}} <span style=color:red ng-if=\"vm.dataToFill.registration_flag == \'2\'\">*</span></label><input type=text class=form-control ng-model=vm.dataToFill.business_name name=BusinessName placeholder=\"{{\'businessName\' | translate}}\" ng-required=\"vm.dataToFill.registration_flag == \'2\'\" ng-maxlength=60 ng-minlength=3 ng-class=\"{ \'has-error\': driverRegisterForm.BusinessName.$touched && driverRegisterForm.BusinessName.$invalid && vm.dataToFill.registration_flag == \'2\' }\" pattern=^[a-zA-Z][a-zA-Z\\s]*$><div ng-if=\"driverRegisterForm.BusinessName.$touched|| submit\" ng-messages=driverRegisterForm.BusinessName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'businessNameRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'businessNameValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'businessNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'businessNameMaximum\' | translate}}</div></div><!--<div ng-if=\"vm.dataToFill.registration_flag==0\" class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">Work Schedule<span style=\"color:red\">*</span></label>--><!--<select class=\"form-control\" ng-model=\"vm.dataToFill.work_schedule\" name=\"workSchedule\" required ng-class=\"{ \'has-error\': driverRegisterForm.workSchedule.$touched && driverRegisterForm.workSchedule.$invalid }\">--><!--<option value=\"\" disabled selected>Select Work Schedule</option>--><!--<option value=\"0\" >Part Time</option>--><!--<option value=\"1\" >Full Time</option>--><!--</select>--><!--<div ng-if=\"driverRegisterForm.workSchedule.$touched || submit\" ng-messages=\"driverRegisterForm.workSchedule.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please select work schedule.</div>--><!--</div>--><!--</div>--></div><!-- TV_2680 --><!-- <div ng-if=\"vm.dataToFill.registration_flag==0\"\n                                             class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">\n                                            <label class=\"control-label\">{{\'modalityOfworkLabel\' | translate}}<span\n                                                    style=\"color:red\">*</span></label>\n                                            <select class=\"form-control\" ng-model=\"vm.dataToFill.work_schedule\"\n                                                    name=\"workSchedule\" required\n                                                    ng-class=\"{ \'has-error\': driverRegisterForm.workSchedule.$touched && driverRegisterForm.workSchedule.$invalid}\">\n                                                <option value=\"\" disabled selected>{{\'modalityOfworkPlaceholder\' | translate}}</option>\n                                                <option value=\"0\">Part Time</option>\n                                                <option value=\"1\">Full Time</option>\n                                            </select>\n                                            <div ng-if=\"driverRegisterForm.workSchedule.$touched || submit\"\n                                                 ng-messages=\"driverRegisterForm.workSchedule.$error\">\n                                                <div class=\"errormessage text-danger\" ng-message=\"required\">{{\'modalityWorkRequired\' | translate}}\n                                                </div>\n                                            </div>\n                                        </div> --></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'passwordPlaceholder\' | translate}} <span style=color:red>*</span></label><input type=password class=form-control ng-model=vm.dataToFill.password name=password placeholder=\"{{\'passwordPlaceholder\' | translate}}\" required ng-minlength=8 ng-maxlength=16 ng-change=vm.matchPasswordAgain(vm.dataToFill.password) ng-class=\"{ \'has-error\': driverRegisterForm.password.$touched\n                                        && driverRegisterForm.password.$invalid }\"><div ng-if=\"driverRegisterForm.password.$touched|| submit\" ng-messages=driverRegisterForm.password.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'passwordRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'passwordMin\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'passwordMax\' | translate}}</div><!--<div class=\"errormessage text-danger \" ng-message=\"pattern \">Please enter a valid country code.</div>--></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'ConfirmPasswordPlaceholder\' | translate}} <span style=color:red>*</span></label><input type=password class=form-control ng-model=vm.dataToFill.confirm_password name=confirmPassword placeholder=\"{{\'ConfirmPasswordPlaceholder\' | translate}}\" required ng-minlength=8 ng-maxlength=16 ng-class=\"{\'has-error\': driverRegisterForm.confirmPassword.$touched && driverRegisterForm.confirmPassword.$invalid }\" ng-change=vm.matchPassword(vm.dataToFill.confirm_password)><div ng-if=\"driverRegisterForm.confirmPassword.$touched|| submit\" ng-messages=driverRegisterForm.confirmPassword.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'confirmPasswordRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'passwordMin\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'passwordMax\' | translate}}</div><!--<div class=\"errormessage text-danger \" ng-message=\"pattern \">Please enter a valid mobile number.</div>--></div><div class=\"errormessage text-danger\" ng-if=vm.passwordMatchFlag>{{\'passwordNotMatch\' | translate}}</div></div></div><!--<div class=\"row mt5 \">\n                                        <div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12 \">\n                                            <label class=\"control-label \">Company Type<span style=\"color:red \" ng-if=\"vm.dataToFill.registration_flag!=\'1\' \">*</span></label>\n                                            <input type=\"text \" class=\"form-control \" ng-model=\"vm.dataToFill.company_type \" name=\"companyType \" placeholder=\"Company type \" ng-required=\"vm.dataToFill.registration_flag!=\'1\' \" ng-class=\"{ \'has-error\':\n                                        driverRegisterForm.companyType.$touched && driverRegisterForm.companyType.$invalid } \"\n                                                pattern=\"^[a-zA-Z0-9][a-zA-Z0-9\\s]*$ \" />\n                                            <div ng-if=\"driverRegisterForm.companyType.$touched|| submit \" ng-messages=\"driverRegisterForm.companyType.$error \">\n                                                <div class=\"errormessage text-danger \" ng-message=\"required \">Please enter company type.</div>\n                                                <div class=\"errormessage text-danger \" ng-message=\"pattern \">Please enter a valid company type.</div>\n                                            </div>\n                                        </div>\n                                    </div>--><!--<div class=\"row mt5 \">--><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 \">--><!--<label class=\"control-label \">Search Address<span style=\"color:red \">*</span></label>--><!--<input type=\"text \" class=\"form-control \" ng-model=\"vm.dataToFill.fullAddress \" name=\"fullAddress \" placeholder=\"Search Address \"--><!--required ng-class=\"{ \'has-error\': driverRegisterForm.fullAddress.$touched && driverRegisterForm.fullAddress.$invalid } \" googleplace callback-fn=\"vm.ctrlFn(data) \"/>--><!--<div ng-if=\"driverRegisterForm.fullAddress.$touched|| submit \" ng-messages=\"driverRegisterForm.fullAddress.$error \">--><!--<div class=\"errormessage text-danger \" ng-message=\"required \">Please enter address</div>--><!--</div>--><!--</div>--><!--</div>--><p class=\"basicRegistrationP backgroundBasicPending text-center mt10\">{{\'address\' | translate}}</p><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'street\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.street name=street placeholder=\"{{\'street\' | translate}}\" required ng-class=\"{ \'has-error\': driverRegisterForm.street.$touched && driverRegisterForm.street.$invalid}\" pattern=^[a-zA-Zñ0-9][a-zA-Zñ0-9\\s,]*$ ng-minlength=4 ng-maxlength=50><div ng-if=\"driverRegisterForm.street.$touched|| submit\" ng-messages=driverRegisterForm.street.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'streetRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'streetValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'streetMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'streetMaximum\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'number\' | translate}}</label><!---<span style=\"color:red \">*</span>--> <input type=text class=form-control ng-model=vm.dataToFill.number name=houseNumber placeholder=\"{{\'number\' | translate}}\" ng-class=\"{ \'has-error\': driverRegisterForm.houseNumber.$touched && driverRegisterForm.houseNumber.$invalid}\" pattern=^[1-9][0-9]*$ ng-maxlength=6><div ng-if=\"driverRegisterForm.houseNumber.$touched|| submit\" ng-messages=driverRegisterForm.houseNumber.$error><!--<div class=\"errormessage text-danger \" ng-message=\"required \">Please enter number.</div>--><div class=\"errormessage text-danger\" ng-message=pattern>{{\'numberRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'numberMax\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'apartment\' | translate}}</label><input type=text class=form-control ng-model=vm.dataToFill.apartment name=apartment placeholder=\"{{\'apartment\' | translate}}\" ng-class=\"{ \'has-error\': driverRegisterForm.apartment.$touched && driverRegisterForm.apartment.$invalid}\" pattern=^[a-zA-Z0-9][a-zA-Z0-9\\s,]*$ ng-maxlength=6><div ng-if=\"driverRegisterForm.apartment.$touched|| submit\" ng-messages=driverRegisterForm.apartment.$error><!--<div class=\"errormessage text-danger \" ng-message=\"required \">Please enter apartment.</div>--><div class=\"errormessage text-danger\" ng-message=pattern>{{\'apartmentRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'apartmentMax\' | translate}}</div></div></div><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">Communa<span--><!--style=\"color:red\">*</span></label>--><!--<select class=\"form-control\" ng-model=\"vm.dataToFill.sector\" name=\"communa\" required ng-class=\"{ \'has-error\': driverRegisterForm.communa.$touched && driverRegisterForm.communa.$invalid }\" ng-options=\"communa.communa as communa.communa for communa in vm.communaList\">--><!--<option value=\"\" disabled selected>Select Communa</option>--><!--</select>--><!--<div ng-if=\"driverRegisterForm.communa.$touched|| submit\" ng-messages=\"driverRegisterForm.communa.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please select communa.--><!--</div>--><!--</div>--><!--</div>--></div><!--<div class=\"row mt5 \">\n                                        <div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12 \">\n                                            <label class=\"control-label \">Region<span style=\"color:red \">*</span></label>\n                                            <input type=\"text \" class=\"form-control \" ng-model=\"vm.dataToFill.region \" name=\"region \" placeholder=\"Region \" required ng-class=\"{ \'has-error\': driverRegisterForm.region.$touched && driverRegisterForm.region.$invalid\n                                        } \" pattern=\"^[a-zA-Z0-9][a-zA-Z0-9\\s,]*$ \"\n                                                ng-minlength=\"4 \" ng-maxlength=\"50 \" />\n                                            <div ng-if=\"driverRegisterForm.region.$touched|| submit \" ng-messages=\"driverRegisterForm.region.$error \">\n                                                <div class=\"errormessage text-danger \" ng-message=\"required \">Please enter region.</div>\n                                                <div class=\"errormessage text-danger \" ng-message=\"pattern \">Please enter a valid region.</div>\n                                                <div class=\"errormessage text-danger \" ng-message=\"minlength \">Minimum 4 characters are allowed.</div>\n                                                <div class=\"errormessage text-danger \" ng-message=\"maxlength \">Maximum 50 characters are allowed.</div>\n                                            </div>\n                                        </div>\n                                    </div>--><p class=\"basicRegistrationP backgroundBasicPending text-center mt10\" ng-if=\"vm.dataToFill.registration_flag != \'1\'\">{{\'paymentHead\' | translate}}</p><div class=\"row mt5\" ng-if=\"vm.dataToFill.registration_flag != \'1\'\"><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">\n                                                <label class=\"control-label\">Payment Modulity<span style=\"color:red\">*</span></label>\n                                                <select class=\"form-control\" ng-model=\"vm.dataToFill.payment_modulity\" name=\"paymentModulity\" required ng-class=\"{ \'has-error\': driverRegisterForm.paymentModulity.$touched && driverRegisterForm.paymentModulity.$invalid }\" ng-options=\"communa.communa as communa.communa for communa in vm.communaList\">\n                                                <option value=\"\" disabled selected>Select Modulity</option>\n                                            </select>\n                                                <div ng-if=\"driverRegisterForm.paymentModulity.$touched|| submit\" ng-messages=\"driverRegisterForm.paymentModulity.$error\">\n                                                    <div class=\"errormessage text-danger\" ng-message=\"required\">Please select payment.</div>\n                                                </div>\n                                            </div>--><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'paymentModulityLabel\' | translate}} <span style=color:red ng-if=\"vm.dataToFill.registration_flag == \'2\'\">*</span></label><select class=form-control ng-model=vm.dataToFill.payment_modulity name=paymentModulity ng-required=\"vm.dataToFill.registration_flag == \'2\'\" ng-class=\"{ \'has-error\': driverRegisterForm.paymentModulity.$touched && driverRegisterForm.paymentModulity.$invalid && vm.dataToFill.registration_flag == \'2\' }\"><option value=\"\" disabled selected>{{\'paymentModulityLabelSelect\' | translate}}</option><!-- <option value=\"1\">Bank Deposit</option>\n                                                <option value=\"2\">Vale View</option> --><option value=1>1 Vale Vista</option><option value=2>3 Abono Cta Cte y Cta Vista</option><option value=3>4 Abono Cta Ahorro</option></select><div ng-if=\"driverRegisterForm.paymentModulity.$touched || submit\" ng-messages=driverRegisterForm.paymentModulity.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'paymentModulityRequired\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'bankLabel\' | translate}} <span style=color:red ng-if=\"vm.dataToFill.registration_flag == \'2\'\">*</span></label><!-- <input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.bank_name\"\n                                                   name=\"Bank\" placeholder=\"{{\'bankLabel\' | translate}}\" ng-required=\"vm.dataToFill.registration_flag == \'2\'\"\n                                                   ng-class=\"{ \'has-error\': driverRegisterForm.Bank.$touched && driverRegisterForm.Bank.$invalid && vm.dataToFill.registration_flag == \'2\' }\"\n                                                   pattern=\"^[a-zA-Z0-9][a-zA-Z0-9\\s,]*$\"\n                                            /> --><select class=form-control ng-model=vm.dataToFill.bank_name name=Bank ng-required=\"vm.dataToFill.registration_flag == \'2\'\" ng-class=\"{ \'has-error\': driverRegisterForm.Bank.$touched && driverRegisterForm.Bank.$invalid && vm.dataToFill.registration_flag == \'2\' }\"><option value=\"\" disabled selected>{{\'bankLabel\' | translate}}</option><option value={{bankName.bank_name}} ng-repeat=\"bankName in vm.driverBankNamesArray\">{{bankName.bank_name}}</option></select><div ng-if=\"driverRegisterForm.Bank.$touched|| submit\" ng-messages=driverRegisterForm.Bank.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'bankReq\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid bank.--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"maxlength\">Maximum 6 characters are allowed.</div>--></div></div><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">\n                                                <label class=\"control-label\">Account Type<span style=\"color:red\">*</span></label>\n                                                <select class=\"form-control\" ng-model=\"vm.dataToFill\" name=\"\" required ng-class=\"{ \'has-error\': driverRegisterForm.communa.$touched && driverRegisterForm.communa.$invalid }\" ng-options=\"communa.communa as communa.communa for communa in vm.communaList\">\n                                                <option value=\"\" disabled selected>Select Account Type</option>\n                                            </select>\n                                                <div ng-if=\"driverRegisterForm.communa.$touched|| submit\" ng-messages=\"driverRegisterForm.communa.$error\">\n                                                    <div class=\"errormessage text-danger\" ng-message=\"required\">Please select communa.</div>\n                                                </div>\n                                            </div>--><!-- <div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">\n                                            <label class=\"control-label\">{{\'accountTypeLabel\' | translate}}\n                                                <span style=\"color:red\" ng-if=\"vm.dataToFill.registration_flag == \'2\'\">*</span>\n                                            </label>\n                                             <select class=\"form-control\" ng-model=\"vm.dataToFill.account_type\" name=\"accountType\" ng-required=\"vm.dataToFill.registration_flag == \'2\'\"\n                                                ng-class=\"{ \'has-error\': driverRegisterForm.accountType.$touched && driverRegisterForm.accountType.$invalid && vm.dataToFill.registration_flag == \'2\' }\">\n                                                <option value=\"\" disabled selected>{{\'accountTypeLabelSelect\' | translate}}</option>\n                                                <option value=\"1\">Electronic Cheque Book</option>\n                                                <option value=\"2\">Saving Account</option>\n                                                <option value=\"3\">Checking Account</option>\n                                            </select> \n                                             <div ng-if=\"driverRegisterForm.accountType.$touched || submit\" ng-messages=\"driverRegisterForm.accountType.$error\">\n                                                <div class=\"errormessage text-danger\" ng-message=\"required\">{{\'accTypeReq\' | translate}}\n                                                </div>\n                                            </div>\n                                        </div> --><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=\"vm.dataToFill.registration_flag !=\'1\'\"><!--ng-if=\"vm.dataToFill.registration_flag != \'2\'\"--><label class=control-label>{{\'accountTypeLabel\' | translate}} <span style=color:red ng-if=\"vm.dataToFill.registration_flag == \'2\'\">*</span></label><input type=text class=form-control ng-model=vm.dataToFill.account_rut name=account_rut placeholder=\"{{\'accountTypeLabel\' | translate}}\" ng-rut ng-change=vm.rutChange2() ng-class=\"{ \'has-error\': driverRegisterForm.account_rut.$touched && driverRegisterForm.account_rut.$invalid }\"><div ng-if=\"driverRegisterForm.account_rut.$touched || submit\" ng-messages=driverRegisterForm.account_rut.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'rutRequired\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid RUT.</div>--></div><div class=\"errormessage text-danger\" ng-if=vm.rutFlag>{{\'rutValid\' | translate}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'accountNumberLabel\' | translate}} <span style=color:red ng-if=\"vm.dataToFill.registration_flag == \'2\'\">*</span></label><input type=text class=form-control ng-model=vm.dataToFill.account_number name=accountNumber placeholder=\"{{\'accountNumberLabel\' | translate}}\" ng-required=\"vm.dataToFill.registration_flag == \'2\'\" ng-class=\"{ \'has-error\': driverRegisterForm.accountNumber.$touched && driverRegisterForm.accountNumber.$invalid && vm.dataToFill.registration_flag == \'2\' }\" pattern=^([0-9])*$><div ng-if=\"driverRegisterForm.accountNumber.$touched|| submit\" ng-messages=driverRegisterForm.accountNumber.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'accNumReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'accNumValid\' | translate}}</div></div></div></div><p class=\"basicRegistrationP backgroundBasicPending text-center mt10\">{{\'documentsHead\' | translate}}</p><div class=\"row mt5\"><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\"><img src=assets/images/noImage.jpeg id=profilePic class=documentStyle><br><input id=documentUpload filestyle=\"\" type=file style=\"display: none\" image=image name={{vm.uploadName}} onchange=angular.element(this).scope().file_to_upload(this.files,this.name) onclick=\"this.value=null\" data-button-text=Single data-class-button=\"btn btn-default\" data-classinput=\"form-control inline\" nv-file-select=\"\" uploader=uploader><label class=\"control-label mt10\">{{\'profilePic\' | translate}}</label><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event, \'PROFILE\')\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\" ng-if=\"vm.dataToFill.registration_flag !=\'1\'\"><img src=assets/images/noImage.jpeg id=invoiceRUT class=documentStyle><br><!--<input id=\"documentUpload\" filestyle=\"\" type=\"file\" style=\"display: none;\" image=\"image\" name=\"{{vm.uploadinvoice_rut_image }}\" onchange=\"angular.element(this).scope().file_to_upload(this.files,this.name)\" onclick=\"this.value = null;\" data-button-text=\"Single\"--><!--data-class-button=\"btn btn-default\" data-classinput=\"form-control inline\" nv-file-select=\"\" uploader=\"uploader\" />--><label class=\"control-label mt10\">{{\'invoiceRut\' | translate}}</label><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'INVOICE\')\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\" ng-if=\"vm.dataToFill.registration_flag !=\'2\'\"><!--ng-if=\"vm.dataToFill.registration_flag !=\'2\' \"--> <img src=assets/images/noImage.jpeg id=rutImage class=documentStyle><br><label class=\"control-label mt10\">{{\'identityCard\' | translate}}<!-- <span style=\"color:red\">*</span> --></label><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event, \'RUT\')\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\" ng-if=\"vm.dataToFill.registration_flag !=\'2\'\"><!--ng-if=\"vm.dataToFill.registration_flag !=\'2\' \"--> <img src=assets/images/noImage.jpeg id=licenseImage class=documentStyle><br><label class=\"control-label mt10\">{{\'licenseImage\' | translate}}<!-- Alvaro rqquest --> <span style=color:red>*</span></label><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event, \'LICENSE\') \">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\" ng-if=\"vm.dataToFill.registration_flag !=\'2\'\"><!--ng-if=\"vm.dataToFill.registration_flag !=\'2\' \"--> <img src=assets/images/noImage.jpeg id=lifeSheet class=documentStyle><br><label class=\"control-label mt10\">{{\'lifeSheetImage\' | translate}} <span style=color:red>*</span></label><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event, \'LIFE_SHEET\')\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\" ng-if=\"vm.dataToFill.registration_flag !=\'2\'\"><!--ng-if=\"vm.dataToFill.registration_flag !=\'2\' \"--> <img src=assets/images/noImage.jpeg id=antecents class=documentStyle><br><label class=\"control-label mt10\">{{\'antcedentsImage\' | translate}} <span style=color:red>*</span></label><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event, \'ANTECENTS\')\">{{\'uploadButton\' | translate}}</button></div><!--<div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5 \">--><!--<img src=\"assets/images/noImage.jpeg \" id=\"companyIdentity \" class=\"documentStyle \"/><br/>--><!--<label class=\"control-label mt10 \">Company Identity Card<span style=\"color:red \">*</span></label>--><!--<button class=\"btn btn-primary upload mt10 \" ng-click=\"vm.clickTrigger($event, \'COMPANY_IDENTITY_CARD\') \">Upload</button>--><!--</div>--><!--<div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5 \">--><!--<img src=\"assets/images/noImage.jpeg \" id=\"constitution \" class=\"documentStyle \"/><br/>--><!--<label class=\"control-label mt10 \">Company Constitution<span style=\"color:red \">*</span></label>--><!--<button class=\"btn btn-primary upload mt10 \" ng-click=\"vm.clickTrigger($event, \'CONSTITUTION\') \">Upload</button>--><!--</div>--><!--<div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5 \">--><!--<img src=\"assets/images/noImage.jpeg \" id=\"activity \" class=\"documentStyle \"/><br/>--><!--<label class=\"control-label mt10 \">Activity Start<span style=\"color:red \">*</span></label>--><!--<button class=\"btn btn-primary upload mt10 \" ng-click=\"vm.clickTrigger($event, \'ACTIVITY\') \">Upload</button>--><!--</div>--><!--<div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5 \">--><!--<img src=\"assets/images/noImage.jpeg \" id=\"invoice \" class=\"documentStyle \"/><br/>--><!--<label class=\"control-label mt10 \">Stamping Invoice<span style=\"color:red \">*</span></label>--><!--<button class=\"btn btn-primary upload mt10 \" ng-click=\"vm.clickTrigger($event, \'INVOICE\') \">Upload</button>--><!--</div>--></div><p class=\"basicRegistrationP backgroundBasicPending text-center mt10\" ng-if=\"vm.dataToFill.registration_flag !=\'1\'\">{{\'carDetailsHead\' | translate}}</p><div ng-repeat=\"cars in vm.dataToFill.car_details\" ng-if=\"vm.dataToFill.registration_flag !=\'1\'\"><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-right\"><a class=\"btn btn-sm blockIconColor\" title=\"Delete Vehicle\" ng-click=vm.deleteVehicleType($index) style=\"border: 1px solid red;margin-left:5px\" ng-if=\"vm.dataToFill.car_details.length> 1\"><i class=\"fa fa-trash\"></i> </a><a class=\"btn btn-sm editIconColor\" ng-click=vm.addVehicle($index) title=\"{{\'addVehicleButton\' | translate}}\" style=\"border: 1px solid #7266ba;margin-left:5px\"><i class=\"fa fa-plus\"></i></a></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'carDetailsHead\' | translate}} <span style=color:red>*</span></label><ui-select ng-model=cars.car_type name=carType{{$index}} required ng-class=\"{ \'has-error\': driverRegisterForm[\'carType\'+$index].$touched && driverRegisterForm[\'carType\'+$index].$invalid }\" close-on-select=true><ui-select-match placeholder=\"{{\'vehiclePlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"data in vm.vehicle | filter: $select.search\"><div ng-bind-html=data.name></div></ui-select-choices></ui-select><div ng-if=\"driverRegisterForm[\'carType\'+$index].$touched || submit\" ng-messages=\"driverRegisterForm[\'carType\'+$index].$error\"><div class=\"errormessage text-danger\" ng-message=required>{{\'vehicleReq\' | translate}}</div></div><!--<select class=\"form-control\" ng-model=\"cars.car_type\" name=\"carType{{$index}}\" required ng-class=\"{ \'has-error\': driverRegisterForm[\'carType\'+$index].$touched && driverRegisterForm[\'carType\'+$index].$invalid }\">\n                                                    <option value=\"\" disabled selected>Select Car Type</option>\n                                                    <option value=\"1\">SUV</option>\n                                                    <option value=\"2\">Sedan</option>\n                                                    <option value=\"3\">VAN</option>\n                                                </select>\n                                                <div ng-if=\"driverRegisterForm[\'carType\'+$index].$touched || submit\" ng-messages=\"driverRegisterForm[\'carType\'+$index].$error\">\n                                                    <div class=\"errormessage text-danger\" ng-message=\"required\">Please select car type.\n                                                    </div>\n                                                </div>--></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'PPU\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=cars.register_number name=registrationNumber{{$index}} placeholder=\"{{\'PPU\' | translate}}\" required ng-class=\"{\'has-error\': driverRegisterForm[\'registrationNumber\'+$index].$touched && driverRegisterForm[\'registrationNumber\'+$index].$invalid}\" pattern=^([A-Za-z]{2})([A-Za-z0-9]{2})([0-9]{2})*$ ng-minlength=3 ng-maxlength=8><!--pattern=\"^[a-zA-Z0-9][a-zA-Z0-9-]*$\"--><div ng-if=\"driverRegisterForm[\'registrationNumber\'+$index].$touched||submit\" ng-messages=\"driverRegisterForm[\'registrationNumber\'+$index].$error\"><div class=\"errormessage text-danger\" ng-message=required>{{\'registrationNumRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'registrationNumValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'registrationNumMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'registrationNumMaximum\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Sociedad SAP <span style=color:red>*</span></label><select class=form-control ng-model=cars.society_id name=societyId{{$index}} required ng-class=\"{ \'has-error\': driverRegisterForm[\'societyId\'+$index].$touched && driverRegisterForm[\'societyId\'+$index].$invalid }\" ng-options=\"data.society_id\n                                                    as data.name for data in vm.societies\"><option value=\"\" disabled selected>Sociedad SAP</option></select><div ng-if=\"driverRegisterForm[\'societyId\'+$index].$touched || submit\" ng-messages=\"driverRegisterForm[\'societyId\'+$index].$error\"><div class=\"errormessage text-danger\" ng-message=required>Favor seleccione Sociedad</div></div></div></div><!--<div class=\"row mt5\">\n                                            <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"\n                                                 ng-if=\"vm.dataToFill.registration_flag !=\'2\'\">\n                                                <label class=\"control-label\">Working for 24 hrs<span\n                                                        style=\"color:red\">*</span></label>\n                                                <select class=\"form-control\" ng-model=\"cars.modelity\"\n                                                        name=\"modelityS{{$index}}\" required\n                                                        ng-class=\"{ \'has-error\': driverRegisterForm[\'modelityS\'+$index].$touched && driverRegisterForm[\'modelityS\'+$index].$invalid }\">\n                                                    <option value=\"\" disabled selected>Select Modelity</option>\n                                                    <option value=\"1\">Yes</option>\n                                                    <option value=\"0\">No</option>\n                                                </select>\n                                                <div ng-if=\"driverRegisterForm[\'modelityS\'+$index].$touched || submit\"\n                                                     ng-messages=\"driverRegisterForm[\'modelityS\'+$index].$error\">\n                                                    <div class=\"errormessage text-danger\" ng-message=\"required\">Please\n                                                        select modelity.\n                                                    </div>\n                                                </div>\n                                            </div>\n                                        </div>--><div class=\"row mt5\"><!-- <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\">\n                                                <label class=\"control-label mt10\">{{\'carImage\' | translate}}<span\n                                                        style=\"color:red\">*</span></label><br/>\n                                                <img src=\"assets/images/noImage.jpeg\" id=\"carImage{{$index}}\"\n                                                     class=\"documentStyle\"/><br/>\n                                                <button type=\"button\" class=\"btn btn-primary upload mt10\"\n                                                        ng-click=\"vm.clickTrigger($event,\'CAR_IMAGE\',$index)\"> {{\'uploadButton\' | translate}}\n                                                </button>\n                                            </div> --><!-- <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\">\n                                                <label class=\"control-label mt10\">{{\'vehicleImage\' | translate}}<span\n                                                        style=\"color:red\">*</span></label><br/>\n                                                <img src=\"assets/images/noImage.jpeg\" id=\"registerImage{{$index}}\"\n                                                     class=\"documentStyle\"/><br/>\n                                                <button type=\"button\" class=\"btn btn-primary upload mt10\"\n                                                        ng-click=\"vm.clickTrigger($event,\'REGISTER_IMAGE\',$index)\">\n                                                    {{\'uploadButton\' | translate}}\n                                                </button>\n                                            </div> --><!-- <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6  mt5\">\n                                                <label class=\"control-label mt10\">{{\'travelCard\' | translate}}<span\n                                                        style=\"color:red\">*</span></label><br/>\n                                                <img src=\"assets/images/noImage.jpeg\" id=\"travel{{$index}}\"\n                                                     class=\"documentStyle\"/><br/>\n                                                <button type=\"button\" class=\"btn btn-primary upload mt10 ml5\"\n                                                        ng-click=\"vm.clickTrigger($event,\'TRAVEL_CARD_KEY\',$index)\">\n                                                    {{\'uploadButton\' | translate}}\n                                                </button>\n                                            </div> --><!-- <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\">\n                                                <label class=\"control-label mt10\">{{\'passengerSeatInsurance\' | translate}}<span\n                                                        style=\"color:red\">*</span></label><br/>\n                                                <img src=\"assets/images/noImage.jpeg\" id=\"seatInsurance{{$index}}\"\n                                                     class=\"documentStyle\"/><br/>\n                                                <button type=\"button\" class=\"btn btn-primary upload mt10 ml5\"\n                                                        ng-click=\"vm.clickTrigger($event,\'PASSENGER_INSURANCE_KEY\',$index)\">\n                                                    {{\'uploadButton\' | translate}}\n                                                </button>\n                                            </div> --><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\"><label class=\"control-label mt10\">{{\'circulationPermission\' | translate}} <span style=color:red>*</span></label><br><img src=assets/images/noImage.jpeg id=permission{{$index}} class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'PERMISSION_OF_CIRCULATION\',$index)\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\"><label class=\"control-label mt10\">Permiso Min. Transporte<!-- <span style=\"color:red\">*</span> --></label><br><img src=assets/images/noImage.jpeg id=transportation_permit{{$index}} class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'TRANSPORTATION_PERMIT\',$index)\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5\"><label class=control-label>{{\'verificationComments\' | translate}}:</label><div class=text-capitalize><textarea class=form-control ng-model=cars.verification_comment placeholder=\"No Description\"></textarea></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" ng-if=\"$index != vm.dataToFill.car_details.length - 1\"><hr></div></div></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><button type=submit class=\"btn btn-primary\">{{\'confirmApplicant\' | translate}}</button></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/approved-driver/approveDriverMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/approved-driver/approvedDriver.html","<h2 class=ng-cloak><span>{{\'approveDriversHead\' | translate}}</span> <span class=pull-right><!--<button class=\"btn btn-info\" title=\"{{\'filterButton\' | translate}}\" style=\"min-width: 100px;\" ng-click=\"vm.showFilterArea()\">{{\'filterButton\' | translate}}</button>&lt;!&ndash;vm.showFilterArea()&ndash;&gt;--><!--<button class=\"btn btn-info\" title=\"{{\'resetButton\' | translate}}\" ng-click=\"vm.removeFilter()\">{{\'resetButton\' | translate}}</button>--> <button class=\"btn btn-primary tableButton\" ng-click=vm.refreshData()>Volver a cargar</button></span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><!--<filter-sidebar show-filter-sidebar=\"vm.showFilterFlag\" filter-data=\"vm.filterData\" filter-to-show=\"vm.filterWhichToShow\" branch-detail-changed=\"vm.branchChangedFilter(vm.filterData)\"--><!--modelity-detail-changed=\"vm.modelityChangedFilter(vm.filterData)\" vehicle-assign-detail-changed=\"vm.vehicleAssignChangedFilter(vm.filterData)\"></filter-sidebar>--><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label class=control-label>{{\'branchLabel\' | translate}}</label><ui-select ng-model=vm.filterData.branch name=branch ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select></div><!-- TV_2680 --><!-- <div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\">\n                            <label class=\"control-label\">{{\'modalityOfworkLabel\' | translate}}</label>\n                            <select class=\"form-control\" ng-model=\"vm.filterData.modelity\" ng-change=\"vm.modelityValueChanged()\">\n                                <option value=\"\" selected disabled>{{\'modalityOfworkPlaceholder\' | translate}}</option>\n                                <option value=\"0\">No</option>\n                                <option value=\"1\">Yes</option>\n                                <option value=\"all\">All</option>\n                            </select>\n                        </div> --><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label class=control-label>{{\'vehicleAssigned\' | translate}}</label><input type=text class=form-control ng-model=vm.filterData.vehicle_unique ng-change=vm.vehicleChanged(vm.filterData.vehicle_unique) placeholder=\"{{\'uniqueNumber\' | translate}}\" ng-blur=vm.getUniqueNumber()></div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center mt5\"><p class=totalSize><span class=pull-left><a class=\"btn btn-primary tableButton mb10\" ng-click=vm.exportToCSV(0,vm.dataLength,1,0)>CSV</a> </span><span>{{\'totalDrivers\' | translate}}: {{vm.totalDrivers}}</span></p></div><br><br><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.getFilter() ng-model-options=\"{ debounce: 500 }\"></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\"><!-- ng-switch=\"(vm.driverList | filter:vm.search).length\"--><!--<div ng-switch-when=\"0\" class=\"noSearch\"><span>{{\'nothingFound\' | translate}}</span></div>--><table class=\"table table-hover tableWithMasterData\"><!--ng-switch-default--><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'name\' | translate}}\" text=\"\'name\'\" check=vm.reverse>{{\'name\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'email\' | translate}}\" text=\"\'email\'\" check=vm.reverse>{{\'email\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'mobileNumber\' | translate}}\" text=\"\'phone\'\" check=vm.reverse>{{\'mobileNumber\' | translate}}</th><!--<th>--><!--<div class=\"text-center\" ng-click=\"vm.sort(\'creation_datetime\')\">--><!--Date of Joining--><!--<span ng-hide=\"vm.predicate == \'creation_datetime\' && vm.reverse || vm.predicate == \'creation_datetime\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'creation_datetime\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'creation_datetime\' && vm.reverse\" class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><!--<th>--><!--<div class=\"text-center\" ng-click=\"vm.sort(\'fleet_type\')\">--><!--Driver Type--><!--<span ng-hide=\"vm.predicate == \'fleet_type\' && vm.reverse || vm.predicate == \'fleet_type\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'fleet_type\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'fleet_type\' && vm.reverse\" class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><!--<th>--><!--<div class=\"text-center\" ng-click=\"vm.sort(\'fleet_route\')\">--><!--Driver Route--><!--<span ng-hide=\"vm.predicate == \'fleet_route\' && vm.reverse || vm.predicate == \'fleet_route\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'fleet_route\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'fleet_route\' && vm.reverse\" class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><!-- TV_2680 --><!-- <th style=\"width:100px;\" table-column-sorting current-text=\"vm.predicate\" title=\"{{\'modalityOfworkLabel\' | translate}}\" text=\"\'work_schedule\'\"\n                                                check=\"vm.reverse\">\n                                                {{\'modalityOfworkLabel\' | translate}}\n                                            </th> --><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'branchLabel\' | translate}}\" text=\"\'branch_name\'\" check=vm.reverse>{{\'branchLabel\' | translate}}</th><th style=width:150px><div class=text-center>{{\'vehicleAssigned\' | translate}}</div></th><th style=width:100px><div class=text-center>{{\'blockedBy\' | translate}}</div></th><th style=width:100px><div class=text-center>{{\'blockTime\' | translate}}</div></th><th style=width:100px><div class=text-center>{{\'stateTable\' | translate}}</div></th><th style=width:150px><div class=text-center>{{\'action\' | translate}}</div></th><!--<th>\n                                                <div class=\"text-center\">\n                                                    Add Cars\n                                                </div>\n                                            </th>--><th style=width:150px><div class=text-center>{{\'adminLogs\' | translate}}</div></th><th style=width:300px><div class=text-center>Contraseña</div></th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.driverList | orderBy:vm.predicate:vm.reverse\"><!--| filter:vm.search--><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:70px>{{::data.fleet_id}}</td><td style=width:100px>{{::data.name}}</td><td style=width:125px>{{::data.email}}</td><td style=width:125px>{{::data.phone}}</td><!--<td>{{data.creation_datetime | date:\'medium\'}}</td>--><!--<td>--><!--<span ng-if=\"data.fleet_type == 0\">Driver with car</span>--><!--<span ng-if=\"data.fleet_type == 1\">Driver without car</span>--><!--<span ng-if=\"data.fleet_type == 2\">Car investor</span>--><!--</td>--><!--<td>--><!--<span ng-if=\"data.fleet_route == 0\">Fixed Route</span>--><!--<span ng-if=\"data.fleet_route == 1\">Point to Point</span>--><!--</td>--><!-- TV_2680 --><!-- <td style=\"width:100px;\">\n                                                <span ng-if=\"data.work_schedule == 0\">Part Time</span>\n                                                <span ng-if=\"data.work_schedule == 1\">Full Time</span>\n                                                <span ng-if=\"data.work_schedule == null\">--</span>\n                                            </td> --><td style=width:100px>{{data.branch_name || \'--\'}}</td><td style=width:150px><span ng-repeat=\"vehicles in data.assigned_cars\">{{vehicles.unique_car_id || \'--\'}} <span ng-if=\"$index != data.assigned_cars.length - 1\"><br></span></span><span ng-if=!data.assigned_cars.length>None</span></td><td style=width:100px>{{data.block_hours || \'--\'}} <span ng-if=data.block_hours>Hrs.</span></td><td style=width:100px>{{data.block_Time_left || \'--\'}} <span ng-if=data.block_Time_left>Hrs.</span></td><td style=width:100px><a class=\"cursor btn btn-sm\" ng-class=\"{\'blockIconColor\': data.is_blocked == 1, \'unblockIconColor\': data.is_blocked == 0}\" ng-click=vm.blockUnblockDriver($event,data.fleet_id,data.is_blocked)><i ng-class=\"{\'fa fa-unlock\': data.is_blocked == 0,\'fa fa-lock\': data.is_blocked == 1}\"></i></a></td><td style=width:150px><a title=\"View Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.approvedDriverMain.driverDetails({id:\'{{data.fleet_id}}\',path:\'1\'})\"><i class=\"fa fa-eye\"></i> </a><a title=\"Edit Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.approvedDriverMain.editDriverDetails({id:\'{{data.fleet_id}}\',path:\'1\'})\"><i class=\"fa fa-edit\"></i> </a><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteUser(data.fleet_id,$event)><i class=\"fa fa-trash\"></i></a></td><!--<td>\n                                                <a class=\"btn btn-primary tableButton\" title=\"Add Cars\" ui-sref=\"layout.approvedDriverMain.addCars({id:\'{{data.fleet_id}}\',path:\'0\'})\" ng-disabled=\"data.fleet_type == 1\">Add Cars</a>\n                                            </td>--><td style=width:150px><a class=\"btn btn-primary tableButton\" title=\"Admin Logs\" ui-sref=\"layout.approvedDriverMain.adminLogs({userId:\'{{data.fleet_id}}\',type:\'0\',fakeType: \'1\'})\">{{\'adminLogs\' | translate}}</a></td><td style=width:300px><a class=\"btn btn-primary tableButton\" title=\"Admin Logs\" ng-click=vm.resetPassword(data)>Restablecer</a> <a class=\"btn btn-primary tableButton\" title=\"Admin Logs\" ng-click=vm.SendEmail(data)>Enviar email</a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noDriverFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav>--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\" ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/approved-driver/driverDetails.html","<h2 class=ng-cloak>{{\'approveDriversHead\' | translate}} / {{\'driverDetailsHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=driver><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\" style=\"text-align: right\"><button class=\"btn btn-primary mb25\" ng-click=vm.gotoRattings()>{{\'driverRating\' | translate}}</button></div></div><!--<div class=\"col-lg-2 col-xs-2 col-sm-12 col-md-12\">--><!--<button class=\"btn btn-primary mb25\" ng-click=\"vm.showCustomerRating(vm.driverDetail.fleet_id, $event)\"> Rating</button>--><!--</div>--><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'basicDetails\' | translate}}</p><div class=basicDetailsDiv><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><img ng-src=\"{{vm.driverDetail.fleet_image || \'assets/images/noImage.jpeg\'}}\" class=profilePic title=\"{{\'profilePic\' | translate}}\"></div></div><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'name\' | translate}}:</label><div class=\"form-control text-capitalize\">{{vm.driverDetail.first_name + \" \" + vm.driverDetail.last_name}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'email\' | translate}}:</label><div class=form-control>{{::vm.driverDetail.email}}</div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'mobileNumber\' | translate}}:</label><div class=form-control>{{vm.driverDetail.country_code?vm.driverDetail.country_code + \"-\" + vm.driverDetail.phone:vm.driverDetail.phone}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'usernameLabel\' | translate}}:</label><div class=form-control>{{::vm.driverDetail.username}}</div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'address\' | translate}}:</label><div class=form-control>{{::vm.driverDetail.addressFormed}}</div></div></div><!--<div class=\"row mt5\">--><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">Driver Type:</label>--><!--<div class=\"form-control\">--><!--<span ng-if=\"vm.driverDetail.fleet_type == 0\">Driver with car</span>--><!--<span ng-if=\"vm.driverDetail.fleet_type == 1\">Driver without car</span>--><!--&lt;!&ndash;<span ng-if=\"vm.driverDetail.fleet_type == 2\">Car investor</span>&ndash;&gt;--><!--</div>--><!--</div>--><!--</div>--><div class=\"row mt5\"><!--ng-hide=\"vm.driverDetail.fleet_type == 2\"--><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'liceneClassLabel\' | translate}}:</label><div class=form-control>{{::vm.driverDetail.license_type}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'liceneExpiaryLabel\' | translate}}:</label><div class=form-control>{{vm.driverDetail.license_expiry_date | date:\'mediumDate\'}}</div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'cityOfWorkLabel\' | translate}}:</label><div class=form-control>{{::vm.driverDetail.region_name}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><!--ng-hide=\"vm.driverDetail.fleet_type == 2\"--><label class=control-label>{{\'rutLabel\' | translate}}:</label><div class=form-control>{{::vm.driverDetail.RUT}}</div></div><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">Company Type:</label>--><!--<div class=\"form-control\">{{vm.driverDetail.company_type || \'&#45;&#45;\'}}</div>--><!--</div>--></div><div class=\"row mt5\"><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">\n                                    <label class=\"control-label\">Driver Route:</label>\n                                    <div class=\"form-control\">\n                                        <span ng-if=\"vm.driverDetail.fleet_route == 0\">Fixed Route</span>\n                                        <span ng-if=\"vm.driverDetail.fleet_route == 1\">Point to Point</span>\n                                    </div>\n                                </div>--><!-- TV_2680 --><!-- <div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"\n                                     ng-if=\"vm.driverDetail.fleet_type == 0\">\n                                    <label class=\"control-label\">{{\'modalityOfworkLabel\' | translate}}:</label>\n                                    <div class=\"form-control\">\n                                        <span ng-if=\"vm.driverDetail.work_schedule == 0\">Part Time</span>\n                                        <span ng-if=\"vm.driverDetail.work_schedule == 1\">Full Time</span>\n                                    </div>\n                                </div> --><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'joiningDate\' | translate}}:</label><div class=form-control><span>{{vm.driverDetail.creation_datetime | date:\'medium\'}}</span></div></div></div></div></div><div class=basicDiv><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'documents\' | translate}}</p><div class=basicDetailsDiv><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><ol><li><!--ng-hide=\"vm.driverDetail.fleet_type == 2\"--><div class=displayFlex><div class=widthDiv>{{\'identityCard\' | translate}}<br class=showBr><span class=colorPending ng-if=\"vm.driverDetail.identity_card_RUT_status == 0\">({{\'pending\' | translate}}) </span><span class=colorVerified ng-if=\"vm.driverDetail.identity_card_RUT_status == 1\">({{\'approved\' | translate}}) </span><span class=colorNot ng-if=\"vm.driverDetail.identity_card_RUT_status == 2\">({{\'unapproved\' | translate}}) </span><span class=colorUpload ng-if=\"vm.driverDetail.identity_card_RUT_status == 3\">({{\'uploadAgain\' | translate}})</span></div><div class=\"widthDiv1 text-right\"><a class=\"cursor btn btn-sm editIconColor\" ng-disabled=!vm.driverDetail.RUT_image href={{vm.driverDetail.RUT_image}} target=_blank><i class=\"fa fa-eye\"></i> </a><!--<a class=\"btn btn-primary view\" ng-disabled=\"!vm.driverDetail.RUT_image\" href=\"{{vm.driverDetail.RUT_image}}\" target=\"_blank\">View</a>--> <a href={{vm.driverDetail.RUT_image}} ng-disabled=!vm.driverDetail.RUT_image class=\"btn btn-primary upload\" download>{{\'download\' | translate}}</a></div></div></li><li><!--ng-hide=\"vm.driverDetail.fleet_type == 2\"--><div class=displayFlex><div class=widthDiv>{{\'licenseImage\' | translate}}<br class=showBr><span class=colorPending ng-if=\"vm.driverDetail.driver_license_status == 0\">({{\'pending\' | translate}}) </span><span class=colorVerified ng-if=\"vm.driverDetail.driver_license_status == 1\">({{\'approved\' | translate}}) </span><span class=colorNot ng-if=\"vm.driverDetail.driver_license_status == 2\">({{\'unapproved\' | translate}}) </span><span class=colorUpload ng-if=\"vm.driverDetail.driver_license_status == 3\">({{\'uploadAgain\' | translate}})</span></div><div class=\"widthDiv1 text-right\"><a class=\"cursor btn btn-sm editIconColor\" ng-disabled=!vm.driverDetail.license_img href={{vm.driverDetail.license_img}} target=_blank><i class=\"fa fa-eye\"></i> </a><!--<a class=\"btn btn-primary view\" ng-disabled=\"!vm.driverDetail.license_img\" href=\"{{vm.driverDetail.license_img}}\" target=\"_blank\">View</a>--> <a href={{vm.driverDetail.license_img}} ng-disabled=!vm.driverDetail.license_img class=\"btn btn-primary upload\" download>{{\'download\' | translate}}</a></div></div></li><li><!--ng-hide=\"vm.driverDetail.fleet_type == 2\"--><div class=displayFlex><div class=widthDiv>{{\'antcedentsImage\' | translate}}<br class=showBr><span class=colorPending ng-if=\"vm.driverDetail.antecents_certificate_status == 0\">({{\'pending\' | translate}}) </span><span class=colorVerified ng-if=\"vm.driverDetail.antecents_certificate_status == 1\">({{\'approved\' | translate}}) </span><span class=colorNot ng-if=\"vm.driverDetail.antecents_certificate_status == 2\">({{\'unapproved\' | translate}}) </span><span class=colorUpload ng-if=\"vm.driverDetail.antecents_certificate_status == 3\">({{\'uploadAgain\' | translate}})</span></div><div class=\"widthDiv1 text-right\"><a class=\"cursor btn btn-sm editIconColor\" ng-disabled=!vm.driverDetail.antecents_certificate href={{vm.driverDetail.antecents_certificate}} target=_blank><i class=\"fa fa-eye\"></i> </a><!--<a class=\"btn btn-primary view\" ng-disabled=\"!vm.driverDetail.antecents_certificate\" href=\"{{vm.driverDetail.antecents_certificate}}\" target=\"_blank\">View</a>--> <a href={{vm.driverDetail.antecents_certificate}} ng-disabled=!vm.driverDetail.antecents_certificate class=\"btn btn-primary upload\" download>{{\'download\' | translate}}</a></div></div></li><li><!--ng-hide=\"vm.driverDetail.fleet_type == 2\"--><div class=displayFlex><div class=widthDiv>{{\'lifeSheetImage\' | translate}}<br class=showBr><span class=colorPending ng-if=\"vm.driverDetail.life_sheet_img_status == 0\">({{\'pending\' | translate}}) </span><span class=colorVerified ng-if=\"vm.driverDetail.life_sheet_img_status == 1\">({{\'approved\' | translate}}) </span><span class=colorNot ng-if=\"vm.driverDetail.life_sheet_img_status == 2\">({{\'unapproved\' | translate}}) </span><span class=colorUpload ng-if=\"vm.driverDetail.life_sheet_img_status == 3\">({{\'uploadAgain\' | translate}})</span></div><div class=\"widthDiv1 text-right\"><a class=\"cursor btn btn-sm editIconColor\" ng-disabled=!vm.driverDetail.life_sheet_img href={{vm.driverDetail.life_sheet_img}} target=_blank><i class=\"fa fa-eye\"></i> </a><!--<a class=\"btn btn-primary view\" ng-disabled=\"!vm.driverDetail.life_sheet_img\" href=\"{{vm.driverDetail.life_sheet_img}}\" target=\"_blank\">View</a>--> <a href={{vm.driverDetail.life_sheet_img}} ng-disabled=!vm.driverDetail.life_sheet_img class=\"btn btn-primary upload\" download>{{\'download\' | translate}}</a></div></div></li><!--<li>\n                                            <div class=\"displayFlex\">\n                                                <div class=\"widthDiv\">\n                                                    Company Identity Card\n                                                    <br class=\"showBr\" />\n                                                    <span class=\"colorPending\" ng-if=\"vm.driverDetail.identity_card_company_status == 0\">(Pending)</span>\n                                                    <span class=\"colorVerified\" ng-if=\"vm.driverDetail.identity_card_company_status == 1\">(Approved)</span>\n                                                    <span class=\"colorNot\" ng-if=\"vm.driverDetail.identity_card_company_status == 2\">(Unapproved)</span>\n                                                    <span class=\"colorUpload\" ng-if=\"vm.driverDetail.identity_card_company_status == 3\">(Upload Again)</span>\n                                                </div>\n                                                <div class=\"widthDiv1 text-right\">\n                                                    <a class=\"btn btn-primary view\" ng-disabled=\"!vm.driverDetail.company_identity_card\" href=\"{{vm.driverDetail.company_identity_card}}\" target=\"_blank\">View</a>\n                                                    <a href=\"{{vm.driverDetail.company_identity_card}}\" ng-disabled=\"!vm.driverDetail.company_identity_card\" class=\"btn btn-primary upload\" download>Download</a>\n                                                </div>\n\n                                            </div>\n                                        </li>\n                                        <li>\n                                            <div class=\"displayFlex\">\n                                                <div class=\"widthDiv\">\n                                                    Company Constitution\n                                                    <br class=\"showBr\" />\n                                                    <span class=\"colorPending\" ng-if=\"vm.driverDetail.constitution_company_status == 0\">(Pending)</span>\n                                                    <span class=\"colorVerified\" ng-if=\"vm.driverDetail.constitution_company_status == 1\">(Approved)</span>\n                                                    <span class=\"colorNot\" ng-if=\"vm.driverDetail.constitution_company_status == 2\">(Unapproved)</span>\n                                                    <span class=\"colorUpload\" ng-if=\"vm.driverDetail.constitution_company_status == 3\">(Upload Again)</span>\n                                                </div>\n                                                <div class=\"widthDiv1 text-right\">\n                                                    <a class=\"btn btn-primary view\" ng-disabled=\"!vm.driverDetail.company_constitution\" href=\"{{vm.driverDetail.company_constitution}}\" target=\"_blank\">View</a>\n                                                    <a href=\"{{vm.driverDetail.company_constitution}}\" ng-disabled=\"!vm.driverDetail.company_constitution\" class=\"btn btn-primary upload\" download>Download</a>\n                                                </div>\n                                            </div>\n                                        </li>\n                                        <li>\n                                            <div class=\"displayFlex\">\n                                                <div class=\"widthDiv\">\n                                                    Activity Start\n                                                    <br class=\"showBr\" />\n                                                    <span class=\"colorPending\" ng-if=\"vm.driverDetail.start_activities_status == 0\">(Pending)</span>\n                                                    <span class=\"colorVerified\" ng-if=\"vm.driverDetail.start_activities_status == 1\">(Approved)</span>\n                                                    <span class=\"colorNot\" ng-if=\"vm.driverDetail.start_activities_status == 2\">(Unapproved)</span>\n                                                    <span class=\"colorUpload\" ng-if=\"vm.driverDetail.start_activities_status == 3\">(Upload Again)</span>\n                                                </div>\n                                                <div class=\"widthDiv1 text-right\">\n                                                    <a class=\"btn btn-primary view\" ng-disabled=\"!vm.driverDetail.start_activities\" href=\"{{vm.driverDetail.start_activities}}\" target=\"_blank\">View</a>\n                                                    <a href=\"{{vm.driverDetail.start_activities}}\" ng-disabled=\"!vm.driverDetail.start_activities\" class=\"btn btn-primary upload\" download>Download</a>\n                                                </div>\n                                            </div>\n                                        </li>\n                                        <li>\n                                            <div class=\"displayFlex\">\n                                                <div class=\"widthDiv\">\n                                                    Invoice Stamping\n                                                    <br class=\"showBr\" />\n                                                    <span class=\"colorPending\" ng-if=\"vm.driverDetail.stamping_invoice_status == 0\">(Pending)</span>\n                                                    <span class=\"colorVerified\" ng-if=\"vm.driverDetail.stamping_invoice_status == 1\">(Approved)</span>\n                                                    <span class=\"colorNot\" ng-if=\"vm.driverDetail.stamping_invoice_status == 2\">(Unapproved)</span>\n                                                    <span class=\"colorUpload\" ng-if=\"vm.driverDetail.stamping_invoice_status == 3\">(Upload Again)</span>\n                                                </div>\n                                                <div class=\"widthDiv1 text-right\">\n                                                    <a class=\"btn btn-primary view\" ng-disabled=\"!vm.driverDetail.invoice_stamping\" href=\"{{vm.driverDetail.invoice_stamping}}\" target=\"_blank\">View</a>\n                                                    <a href=\"{{vm.driverDetail.invoice_stamping}}\" ng-disabled=\"!vm.driverDetail.invoice_stamping\" class=\"btn btn-primary upload\" download>Download</a>\n                                                </div>\n                                            </div>\n                                        </li>--></ol></div></div></div></div><!--<div class=\"basicDiv\" ng-if=\"vm.driverDetail.car_details.length\" ng-hide=\"vm.driverDetail.fleet_type == 1\">--><!--<p class=\"basicRegistrationP text-center backgroundBasicPending\">Car Details</p>--><!--<div class=\"basicDetailsDiv\">--><!--<div class=\"row\">--><!--<div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" ng-repeat=\"data in vm.driverDetail.car_details\">--><!--<div class=\"row\">--><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">Car Type:</label>--><!--<div class=\"form-control\">--><!--<span>{{data.carName}}</span>--><!--&lt;!&ndash;<span ng-if=\"data.car_type == 1\">SUV</span>&ndash;&gt;--><!--&lt;!&ndash;<span ng-if=\"data.car_type == 2\">Sedan</span>&ndash;&gt;--><!--&lt;!&ndash;<span ng-if=\"data.car_type == 3\">VAN</span>&ndash;&gt;--><!--</div>--><!--</div>--><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">Registration Number:</label>--><!--<div class=\"form-control\">{{data.registration_number || \'&#45;&#45;\'}}</div>--><!--</div>--><!--</div>--><!--<div class=\"row mt5\">--><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">Added At:</label>--><!--<div class=\"form-control\">--><!--{{data.added_at | date:\'medium\'}}--><!--</div>--><!--</div>--><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">Work 24 hrs:</label>--><!--<div class=\"form-control\">--><!--<span ng-if=\"data.modelity == 0\">No</span>--><!--<span ng-if=\"data.modelity == 1\">Yes</span>--><!--</div>--><!--</div>--><!--&lt;!&ndash;<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">&ndash;&gt;--><!--&lt;!&ndash;<label class=\"control-label\">Car Status:</label>&ndash;&gt;--><!--&lt;!&ndash;<div class=\"form-control\" ng-if=\"data.car_status == 0\"> Free </div>&ndash;&gt;--><!--&lt;!&ndash;<div class=\"form-control\" ng-if=\"data.car_status == 1\"> Occupied/{{data.occupied_by || \'&#45;&#45;\'}}</div>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--<div class=\"row mt5\">--><!--<div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12\">--><!--<label class=\"control-label\">Car Image:</label>--><!--<div>--><!--<img ng-src=\"{{data.car_photo || \'assets/images/noImage.jpeg\'}}\" class=\"profilePic\" title=\"Car Pic\" />--><!--</div>--><!--</div>--><!--<div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12\">--><!--<label class=\"control-label\">Registration Image:</label>--><!--<div>--><!--<img ng-src=\"{{data.registration_image || \'assets/images/noImage.jpeg\'}}\" class=\"profilePic\" title=\"Registration Pic\" />--><!--</div>--><!--</div>--><!--<div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6  mt5\">--><!--<label class=\"control-label mt10\">Travel Card<span style=\"color:red\">*</span></label>--><!--<div>--><!--<img src=\"{{data.travel_card_key || \'assets/images/noImage.jpeg\'}}\" class=\"profilePic\" title=\"Travel Card Pic\" />--><!--</div>--><!--</div>--><!--<div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6  mt5\">--><!--<label class=\"control-label mt10\">Passenger Seat Insurance<span style=\"color:red\">*</span></label>--><!--<div>--><!--<img src=\"{{data.passenger_insurance_key || \'assets/images/noImage.jpeg\'}}\" class=\"profilePic\" title=\"Passenger Seat Insurance Pic\" />--><!--</div>--><!--</div>--><!--<div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6  mt5\">--><!--<label class=\"control-label mt10\">Permission Of Circulation<span style=\"color:red\">*</span></label>--><!--<div>--><!--<img src=\"{{data.permission_of_circulation || \'assets/images/noImage.jpeg\'}}\" class=\"profilePic\" title=\"Permission Of Circulation Pic\" />--><!--</div>--><!--</div>--><!--</div>--><!--<div class=\"row mt5\" ng-if=\"$index != (vm.driverDetail.car_details.length-1)\">--><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<span><hr/></span>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><div class=basicDiv><p class=\"basicRegistrationP text-center backgroundBasicPending\">Vehicle Assigned</p><div class=basicDetailsDiv><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 table-responsive\" ng-if=\"vm.driverDetail.assigned_cars.length > 0\"><table class=\"table table-hover\"><thead><tr><th>{{\'uniqueNumber\' | translate}}</th><th>{{\'vehicleLabel\' | translate}}</th><th>{{\'PPU\' | translate}}</th><th>{{\'owner\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"data in vm.driverDetail.assigned_cars\"><td>{{data.unique_car_id || \'--\'}}</td><td>{{data.car_name}}</td><td>{{data.car_number}}</td><td>{{data.fleet_first_name + \' \' + data.fleet_last_name}}</td></tr></tbody></table></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\" ng-if=\"vm.driverDetail.assigned_cars.length == 0\"><p>{{\'withoutAssignedCar\' | translate}}</p></div></div></div></div><div class=basicDiv><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'adminComments\' | translate}}</p><div class=basicDetailsDiv><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=vm.driverDetail.basicRegistration_comments><label class=control-label>Basic Registration:</label><textarea class=form-control ng-model=vm.driverDetail.basicRegistration_comments placeholder=\"{{\'messagePlaceholder\' | translate}}\" readonly></textarea></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=vm.driverDetail.documentation_comments><label class=control-label>Documents:</label><textarea class=form-control ng-model=vm.driverDetail.documentation_comments placeholder=\"{{\'messagePlaceholder\' | translate}}\" readonly></textarea></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=vm.driverDetail.interview_comments><label class=control-label>Interview:</label><textarea class=form-control ng-model=vm.driverDetail.interview_comments placeholder=\"{{\'messagePlaceholder\' | translate}}\" readonly></textarea></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=vm.driverDetail.training_comments><label class=control-label>Training:</label><textarea class=form-control ng-model=vm.driverDetail.training_comments placeholder=\"{{\'messagePlaceholder\' | translate}}\" readonly></textarea></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=vm.driverDetail.signOfContract_comments><label class=control-label>Sign of Contract:</label><textarea class=form-control ng-model=vm.driverDetail.signOfContract_comments placeholder=\"{{\'messagePlaceholder\' | translate}}\" readonly></textarea></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=vm.driverDetail.activation_comments><label class=control-label>Account Activation:</label><textarea class=form-control ng-model=vm.driverDetail.activation_comments placeholder=\"{{\'messagePlaceholder\' | translate}}\" readonly></textarea></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=vm.driverDetail.block_unblock_comments><label class=control-label>Block/ Unblock:</label><textarea class=form-control ng-model=vm.driverDetail.block_unblock_comments placeholder=\"{{\'messagePlaceholder\' | translate}}\" readonly></textarea></div></div><div class=row><div class=\"col-lg-12 col-ms-12 col-md-12 col-xs-12 table-responsive\"><table class=\"table table-hover\"><thead><tr><th>{{\'registrationSteps\' | translate}}</th><th>{{\'approvedBy\' | translate}}</th><th>{{\'approvedAt\' | translate}}</th></tr></thead><tbody><tr><td>Basic Registration</td><td>{{vm.driverDetail.basicRegistration_modified_by || \'--\'}}</td><td>{{vm.driverDetail.basicRegistration_modified_at || \'--\' | date: \'medium\'}}</td></tr><tr><td>Documents</td><td>{{vm.driverDetail.documentation_modified_by || \'--\'}}</td><td>{{vm.driverDetail.documentation_modified_at || \'--\' | date: \'medium\'}}</td></tr><tr><td>Interview</td><td>{{vm.driverDetail.interview_modified_by || \'--\'}}</td><td>{{vm.driverDetail.interview_modified_at || \'--\' | date: \'medium\'}}</td></tr><tr><td>Training</td><td>{{vm.driverDetail.training_modified_by || \'--\'}}</td><td>{{vm.driverDetail.training_modified_at || \'--\' | date: \'medium\'}}</td></tr><tr><td>Sign of Contract</td><td>{{vm.driverDetail.signOfContract_modified_by || \'--\'}}</td><td>{{vm.driverDetail.signOfContract_modified_at || \'--\' | date: \'medium\'}}</td></tr><tr><td>Account Activation</td><td>{{vm.driverDetail.activation_modified_by || \'--\'}}</td><td>{{vm.driverDetail.activation_modified_at || \'--\' | date: \'medium\'}}</td></tr></tbody></table></div></div></div></div><div class=basicDiv><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'driverRating\' | translate}}</p><div class=basicDetailsDiv><!--<select ng-model=\"vm.selectedMonth\"--><!--ng-options=\"product as product.name for product in vm.newArrayMonth\"--><!--ng-change=\"vm.showCustomerRating(vm.driverDetail.fleet_id, vm.selectedMonth.value)\"--><!--&gt;--><!--</select>--><div class=\"col-lg-6 col-md-6 col-md-6 col-xs-12\"><span class=pull-left><a class=\"btn btn-primary tableButton mb10\" ng-click=vm.exportToCSVDriverRatings(vm.driverRatingArray)>CSV</a></span></div><div class=\"col-lg-6 col-md-6 col-md-6 col-xs-12\"><div class=\"col-lg-4 col-md-4 col-md-4 col-xs-12\"><h5>{{\'selectRange\' | translate}}:</h5></div><div class=\"col-lg-8 col-md-8 col-md-8 col-xs-12\"><input date-range-picker class=\"form-control date-picker\" type=text ng-model=datePicker.date options=options></div></div><div class=row id=rattings><!--<div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 table-responsive\" ng-if=\"vm.driverRatingArray.length > 0\">--><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 table-responsive\"><table class=\"table table-hover\"><thead><tr><th>{{\'bookingId\' | translate}}</th><th>{{\'rating\' | translate}}</th><th>{{\'customerComment\' | translate}}</th><th>{{\'customerName\' | translate}}</th><th>{{\'pickTime\' | translate}}</th><th>{{\'agreNameLabel\' | translate}}</th></tr></thead><tbody ng-if=\"vm.driverRatingArray.length > 0\"><tr ng-repeat=\"data in vm.driverRatingArray\"><td>{{::data.job_id}}</td><td>{{::data.fleet_rating}}</td><td>{{::data.fleet_comment}}</td><td>{{::data.job_pickup_name}}</td><td>{{data.job_pickup_datetime | date:\'medium\'}}</td><td>{{::data.contract_name}}</td></tr></tbody><tbody ng-if=\"!vm.driverRatingArray.length > 0\" style=\"text-align: center\"><tr><td colspan=5>{{\'noRating\' | translate}}</td></tr></tbody></table></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/approved-driver/editDriverDetails.html","<h2 class=ng-cloak>{{\'approveDriversHead\' | translate}} / {{\'editDriverHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=driver><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'basicDetails\' | translate}}</p><div class=basicDetailsDiv><form name=driverEditForm ng-submit=\"submit=true;driverEditForm.$valid&&vm.editBasicApi()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'driverType\' | translate}}<span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.fleet_type name=driverType required ng-class=\"{ \'has-error\': driverEditForm.driverType.$touched && driverEditForm.driverType.$invalid }\"><option value=\"\" disabled selected>{{\'driverTypePlaceholder\' | translate}}</option><option value=0>Conductor con auto</option><option value=1>Conductor sin auto</option><!--<option value=\"2\" >I am a Car Investor</option>--></select><div ng-if=\"driverEditForm.driverType.$touched || submit\" ng-messages=driverEditForm.driverType.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'driverTypeReq\' | translate}}</div></div></div></div><div><!--ng-if=\"vm.dataToFill.fleet_type\"--><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'firstNameLabel\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.first_name name=firstName placeholder=\"{{\'firstNameLabel\' | translate}}\" required ng-maxlength=60 ng-minlength=2 ng-class=\"{ \'has-error\': driverEditForm.firstName.$touched && driverEditForm.firstName.$invalid }\" pattern=^\\D*$><div ng-if=\"driverEditForm.firstName.$touched|| submit\" ng-messages=driverEditForm.firstName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'firstNameRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'firstNameValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'firstNameMaximum\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'lastNameLabel\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.last_name name=lastName placeholder=\"{{\'lastNameLabel\' | translate}}\" required ng-maxlength=60 ng-minlength=2 ng-class=\"{ \'has-error\': driverEditForm.lastName.$touched && driverEditForm.lastName.$invalid }\" pattern=^\\D*$><div ng-if=\"driverEditForm.lastName.$touched|| submit\" ng-messages=driverEditForm.lastName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'lastNameRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'lastNameValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'lastNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'lastNameMaximum\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'emailPlaceholder\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.email name=driverEmail placeholder=\"{{\'emailPlaceholder\' | translate}}\" required ng-class=\"{ \'has-error\': driverEditForm.driverEmail.$touched && driverEditForm.driverEmail.$invalid }\" pattern=^([_a-zA-Z0-9-+]+)(\\.[_a-zA-Z0-9-+]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*\\.)+([a-zA-Z]{2,3})$><div ng-if=\"driverEditForm.driverEmail.$touched|| submit\" ng-messages=driverEditForm.driverEmail.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'requiredEmail\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'validEmail\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><!--ng-if=\"vm.dataToFill.fleet_type != \'2\'\"--><label class=control-label>{{\'rutLabel\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.RUT name=driverRUT placeholder=\"{{\'rutLabel\' | translate}}\" ng-rut ng-change=vm.rutChange() required ng-class=\"{ \'has-error\': driverEditForm.driverRUT.$touched && driverEditForm.driverRUT.$invalid }\"><div ng-if=\"driverEditForm.driverRUT.$touched|| submit\" ng-messages=driverEditForm.driverRUT.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'rutRequired\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid RUT.</div>--></div><div class=\"errormessage text-danger\" ng-if=vm.rutFlag>{{\'rutValid\' | translate}}</div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'mobileNumber\' | translate}}<span style=color:red>*</span></label><div class=displayFlex><div><input type=text style=width:50px class=form-control ng-model=vm.dataToFill.country_code name=countryCode placeholder=\"Country Code\" required ng-class=\"{ \'has-error\': driverEditForm.countryCode.$touched && driverEditForm.countryCode.$invalid }\" pattern=^[0-9+][0-9+]*$ readonly><div ng-if=\"driverEditForm.countryCode.$touched|| submit\" ng-messages=driverEditForm.countryCode.$error><div class=\"errormessage text-danger\" ng-message=required>Please enter country code</div><div class=\"errormessage text-danger\" ng-message=pattern>Please enter a valid country code.</div></div></div><div style=\"width:90%; margin-left:5px\"><input type=text class=form-control ng-model=vm.dataToFill.phone_number name=mobileNumber placeholder=\"{{\'mobileNumber\' | translate}}\" required ng-minlength=9 ng-maxlength=9 ng-class=\"{\'has-error\': driverEditForm.mobileNumber.$touched && driverEditForm.mobileNumber.$invalid}\" pattern=^([9]{1}[0-9]{8})*$><!--\"^([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1})*$\"--><div ng-if=\"driverEditForm.mobileNumber.$touched|| submit\" ng-messages=driverEditForm.mobileNumber.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'mobileRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'mobileValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'mobileValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'mobileValid\' | translate}}</div></div></div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'usernameLabel\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.username name=username placeholder=\"{{\'usernameLabel\' | translate}}\" required ng-class=\"{ \'has-error\': driverEditForm.username.$touched && driverEditForm.username.$invalid }\" pattern=^[a-zA-Zñ0-9][a-zA-Zñ0-9\\s,]*$ ng-minlength=4 ng-maxlength=50><div ng-if=\"driverEditForm.username.$touched|| submit\" ng-messages=driverEditForm.username.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'usernameRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'usernameValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'usernameMin\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'usernameMax\' | translate}}</div></div></div></div><div class=\"row mt5\"><!-- ng-if=\"vm.dataToFill.fleet_type != \'2\'\"--><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'liceneClassLabel\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.license_type name=licencseType required ng-class=\"{\'has-error\': driverRegisterForm.licencseType.$touched && driverRegisterForm.licencseType.$invalid}\"><option value=\"\" disabled selected>{{\'liceneClassLabel\' | translate}}</option><option ng-repeat=\"licenseType in vm.licenceTypesData\" value={{licenseType}}>{{licenseType}}</option></select><!-- <label class=\"control-label\">{{\'liceneClassLabel\' | translate}}<span\n                                                    style=\"color:red\">*</span></label> --><!--<select class=\"form-control\" ng-model=\"vm.dataToFill.license_type\" name=\"licencseType\" required ng-class=\"{\'has-error\': driverRegisterForm.licencseType.$touched && driverRegisterForm.licencseType.$invalid}\">--><!--<option value=\"\" disabled selected>Select Class Of License</option>--><!--<option value=\"A1\">A1</option>--><!--<option value=\"A2\">A2</option>--><!--<option value=\"A3\">A3</option>--><!--</select>--><!-- <input type=\"text\" class=\"form-control\"\n                                                   ng-model=\"vm.dataToFill.license_type\" name=\"licencseType\"\n                                                   placeholder=\"{{\'liceneClassLabel\' | translate}}\" required ng-class=\"{ \'has-error\': driverEditForm.licencseType.$touched\n                                        && driverEditForm.licencseType.$invalid }\" maxlength=\"10\" alpha-numeric=\"\"/> --><div ng-if=\"driverRegisterForm.licencseType.$touched|| submit\" ng-messages=driverRegisterForm.licencseType.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'licenseRequired\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid license type.\n                                       </div>\n                                       <div class=\"errormessage text-danger\" ng-message=\"minlength\">Minimum 1 characters are allowed.\n                                       </div>\n                                       <div class=\"errormessage text-danger\" ng-message=\"maxlength\">Maximum 2 characters are allowed.\n                                       </div>--></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'liceneExpiaryLabel\' | translate}}<span style=color:red>*</span></label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} ng-model=vm.dataToFill.license_expiry_date name=licenseExpiry placeholder=\"{{\'liceneExpiaryLabel\' | translate}}\" is-open=vm.datePicker_1.end datepicker-options=vm.dateOptions required ng-class=\"{ \'has-error\': driverEditForm.licenseExpiry.$touched && driverEditForm.licenseExpiry.$invalid }\" close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_1()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"driverEditForm.licenseExpiry.$touched|| submit\" ng-messages=driverEditForm.licenseExpiry.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'licenseExpiryRequired\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'cityOfWorkLabel\' | translate}}<span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.branch name=branch required ng-class=\"{ \'has-error\': driverEditForm.branch.$touched && driverEditForm.branch.$invalid }\" ng-options=\"branch.region_id as branch.region_name for branch in vm.branchList\"><option value=\"\" disabled selected>{{\'cityOfWorkLabelSelect\' | translate}}</option></select><div ng-if=\"driverEditForm.branch.$touched|| submit\" ng-messages=driverEditForm.branch.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'cityWorkRequired\' | translate}}</div></div><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.branch\" name=\"branch\" placeholder=\"Branch\"--><!--required ng-class=\"{ \'has-error\': driverEditForm.branch.$touched && driverEditForm.branch.$invalid }\" pattern=\"^[a-zA-Z0-9][a-zA-Z0-9\\s]*$\" ng-minlength=\"3\" ng-maxlength=\"16\"/>--><!--<div ng-if=\"driverEditForm.branch.$touched|| submit\" ng-messages=\"driverEditForm.branch.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter branch</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid branch.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"minlength\">Minimum 3 characters are allowed.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"maxlength\">Maximum 16 characters are allowed.</div>--><!--</div>--></div><!-- TV_2680 --><!-- <div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"\n                                             ng-if=\"vm.dataToFill.fleet_type == \'0\'\">\n                                            <label class=\"control-label\">{{\'modalityOfworkLabel\' | translate}}</label>\n                                            <select class=\"form-control\" ng-model=\"vm.dataToFill.work_schedule\"\n                                                    name=\"workSchedule\"\n                                                    ng-class=\"{ \'has-error\': driverEditForm.workSchedule.$touched && driverEditForm.workSchedule.$invalid }\">\n                                                <option value=\"\" disabled selected>{{\'modalityOfworkPlaceholder\' | translate}}</option>\n                                                <option value=\"0\">Part Time</option>\n                                                <option value=\"1\">Full Time</option>\n                                            </select>\n                                            <div ng-if=\"driverEditForm.workSchedule.$touched || submit\"\n                                                 ng-messages=\"driverEditForm.workSchedule.$error\">\n                                            </div>\n                                        </div> --></div><div class=\"row mt5\"><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">Company Type<span style=\"color:red\" ng-if=\"vm.dataToFill.fleet_type!=\'1\'\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.company_type\" name=\"companyType\" placeholder=\"Company type\" ng-required=\"vm.dataToFill.fleet_type!=\'1\'\" ng-class=\"{ \'has-error\': driverEditForm.companyType.$touched && driverEditForm.companyType.$invalid }\"--><!--pattern=\"^[a-zA-Z0-9][a-zA-Z0-9\\s]*$\" />--><!--<div ng-if=\"driverEditForm.companyType.$touched|| submit\" ng-messages=\"driverEditForm.companyType.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter company type.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid company type.</div>--><!--</div>--><!--</div>--><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">\n                                            <label class=\"control-label\">Driver Route<span\n                                                    style=\"color:red\">*</span></label>\n                                            <select class=\"form-control\" ng-model=\"vm.dataToFill.fleet_route\" name=\"fleetRoute\" required ng-class=\"{ \'has-error\': driverEditForm.fleetRoute.$touched && driverEditForm.fleetRoute.$invalid }\">\n                                                <option value=\"\" disabled selected>Select Driver Route</option>\n                                                <option value=\"0\">Fixed Route</option>\n                                                <option value=\"1\">Poit to Point</option>\n                                            </select>\n                                            <div ng-if=\"driverEditForm.fleetRoute.$touched || submit\" ng-messages=\"driverEditForm.fleetRoute.$error\">\n                                                <div class=\"errormessage text-danger\" ng-message=\"required\">Please select driver route.\n                                                </div>\n                                            </div>\n                                        </div>--></div><p class=\"basicRegistrationP backgroundBasicPending text-center mt10\">{{\'address\' | translate}}</p><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'street\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.street name=street placeholder=\"{{\'street\' | translate}}\" required ng-class=\"{ \'has-error\': driverEditForm.street.$touched && driverEditForm.street.$invalid }\" pattern=^[a-zA-Zñ0-9][a-zA-Zñ0-9\\s,]*$ ng-minlength=4 ng-maxlength=50><div ng-if=\"driverEditForm.street.$touched|| submit\" ng-messages=driverEditForm.street.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'streetRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'streetValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'streetMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'streetMaximum\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'number\' | translate}}</label><input type=text class=form-control ng-model=vm.dataToFill.number name=houseNumber placeholder=\"{{\'number\' | translate}}\" ng-class=\"{ \'has-error\': driverEditForm.houseNumber.$touched && driverEditForm.houseNumber.$invalid }\" pattern=^[1-9][0-9]*$ ng-maxlength=6><div ng-if=\"driverEditForm.houseNumber.$touched|| submit\" ng-messages=driverEditForm.houseNumber.$error><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter number.</div>--><div class=\"errormessage text-danger\" ng-message=pattern>{{\'numberRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'numberMax\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'apartment\' | translate}}</label><input type=text class=form-control ng-model=vm.dataToFill.apartment name=apartment placeholder=\"{{\'apartment\' | translate}}\" ng-class=\"{ \'has-error\': driverEditForm.apartment.$touched && driverEditForm.apartment.$invalid }\" pattern=^[a-zA-Z0-9][a-zA-Z0-9\\s,]*$ ng-maxlength=6><div ng-if=\"driverEditForm.apartment.$touched|| submit\" ng-messages=driverEditForm.apartment.$error><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter apartment.</div>--><div class=\"errormessage text-danger\" ng-message=pattern>{{\'apartmentRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'apartmentMax\' | translate}}</div></div></div><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">Communa<span style=\"color:red\">*</span></label>--><!--<select class=\"form-control\" ng-model=\"vm.dataToFill.sector\" name=\"communa\" required ng-class=\"{ \'has-error\': driverEditForm.communa.$touched && driverEditForm.communa.$invalid }\" ng-options=\"communa.communa as communa.communa for communa in vm.communaList\">--><!--&lt;!&ndash;communa.communa_id as &ndash;&gt;--><!--<option value=\"\" disabled selected>Select Communa</option>--><!--</select>--><!--<div ng-if=\"driverEditForm.communa.$touched|| submit\" ng-messages=\"driverEditForm.communa.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please select communa.--><!--</div>--><!--</div>--><!--</div>--></div><!--<div class=\"row mt5\">--><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">Region<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.region\" name=\"region\" placeholder=\"Region\" required ng-class=\"{ \'has-error\': driverEditForm.region.$touched && driverEditForm.region.$invalid }\" pattern=\"^[a-zA-Z0-9][a-zA-Z0-9\\s,]*$\" ng-minlength=\"4\"--><!--ng-maxlength=\"50\" />--><!--<div ng-if=\"driverEditForm.region.$touched|| submit\" ng-messages=\"driverEditForm.region.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter region.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid region.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"minlength\">Minimum 4 characters are allowed.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"maxlength\">Maximum 50 characters are allowed.</div>--><!--</div>--><!--</div>--><!--</div>--><p class=\"basicRegistrationP backgroundBasicPending text-center mt10\">{{\'documentsHead\' | translate}}</p><div class=\"row mt5\"><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\"><img ng-src=\"{{ vm.driverDetails.fleet_image || \'assets/images/noImage.jpeg\'}}\" id=profilePic class=documentStyle><br><input id=documentUpload filestyle=\"\" type=file style=\"display: none\" image=image name={{vm.uploadName}} onchange=angular.element(this).scope().file_to_upload(this.files,this.name) onclick=\"this.value = null\" data-button-text=Single data-class-button=\"btn btn-default\" data-classinput=\"form-control inline\" nv-file-select=\"\" uploader=uploader><label class=\"control-label mt10\">{{\'profilePic\' | translate}}</label><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'PROFILE\')\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\"><!--ng-if=\"vm.dataToFill.fleet_type !=\'2\'\"--> <img ng-src=\"{{ vm.driverDetails.RUT_image || \'assets/images/noImage.jpeg\'}}\" id=rutImage class=documentStyle><br><label class=\"control-label mt10\">{{\'rutLabel\' | translate}}<span style=color:red>*</span></label><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'RUT\')\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\"><!--ng-if=\"vm.dataToFill.fleet_type !=\'2\'\">--> <img ng-src=\"{{ vm.driverDetails.license_img || \'assets/images/noImage.jpeg\'}}\" id=licenseImage class=documentStyle><br><label class=\"control-label mt10\">{{\'licenseImage\' | translate}}<span style=color:red>*</span></label><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'LICENSE\')\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\"><!--ng-if=\"vm.dataToFill.fleet_type !=\'2\'\"--> <img ng-src=\"{{ vm.driverDetails.life_sheet_img || \'assets/images/noImage.jpeg\'}}\" id=lifeSheet class=documentStyle><br><label class=\"control-label mt10\">{{\'lifeSheetImage\' | translate}}<span style=color:red>*</span></label><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'LIFE_SHEET\')\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\"><!--ng-if=\"vm.dataToFill.fleet_type !=\'2\'\"--> <img ng-src=\"{{ vm.driverDetails.antecents_certificate || \'assets/images/noImage.jpeg\'}}\" id=antecents class=documentStyle><br><label class=\"control-label mt10\">{{\'antcedentsImage\' | translate}}<span style=color:red>*</span></label><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'ANTECENTS\')\">{{\'uploadButton\' | translate}}</button></div><!--<div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\">\n                                            <img ng-src=\"{{ vm.driverDetails.company_identity_card || \'assets/images/noImage.jpeg\'}}\" id=\"companyIdentity\" class=\"documentStyle\" /><br/>\n                                            <label class=\"control-label mt10\">Company Identity Card<span\n                                                    style=\"color:red\">*</span></label>\n                                            <button type=\"button\" class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'COMPANY_IDENTITY_CARD\')\">Upload\n                                            </button>\n                                        </div>\n                                        <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\">\n                                            <img ng-src=\"{{ vm.driverDetails.company_constitution || \'assets/images/noImage.jpeg\'}}\" id=\"constitution\" class=\"documentStyle\" /><br/>\n                                            <label class=\"control-label mt10\">Company Constitution<span\n                                                    style=\"color:red\">*</span></label>\n                                            <button type=\"button\" class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'CONSTITUTION\')\">Upload\n                                            </button>\n                                        </div>\n                                        <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\">\n                                            <img ng-src=\"{{ vm.driverDetails.start_activities || \'assets/images/noImage.jpeg\'}}\" id=\"activity\" class=\"documentStyle\" /><br/>\n                                            <label class=\"control-label mt10\">Activity Start<span\n                                                    style=\"color:red\">*</span></label>\n                                            <button type=\"button\" class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'ACTIVITY\')\">Upload\n                                            </button>\n                                        </div>\n                                        <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\">\n                                            <img ng-src=\"{{ vm.driverDetails.invoice_stamping || \'assets/images/noImage.jpeg\'}}\" id=\"invoice\" class=\"documentStyle\" /><br/>\n                                            <label class=\"control-label mt10\">Stamping Invoice<span\n                                                    style=\"color:red\">*</span></label>\n                                            <button type=\"button\" class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'INVOICE\')\">Upload\n                                            </button>\n                                        </div>--></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><button class=\"btn btn-primary\" type=submit style=width:200px>{{\'submit\' | translate}}</button></div></div></div></form></div></div></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12 mt25\" ng-if=vm.carDetails.length><div class=basicDiv ng-if=\"vm.dataToFill.fleet_type != \'1\'\"><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'carDetailsHead\' | translate}}</p><div class=basicDetailsDiv><form name=driverCarEditForm ng-submit=\"submitCar=true;driverCarEditForm.$valid&&vm.editCarApi($index,carsData)\" novalidate autocomplete=off ng-repeat=\"carsData in vm.carDetails\"><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'vehicleLabel\' | translate}}<span style=color:red>*</span></label><ui-select ng-model=carsData.car_type name=carType{{$index}} required ng-class=\"{ \'has-error\': driverCarEditForm[\'carType\'+$index].$touched && driverCarEditForm[\'carType\'+$index].$invalid }\" close-on-select=true><ui-select-match placeholder=\"{{\'vehiclePlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in vm.vehicle | filter: $select.search\"><div ng-bind-html=data.name></div></ui-select-choices></ui-select><div ng-if=\"driverCarEditForm[\'carType\'+$index].$touched || submitCar\" ng-messages=\"driverCarEditForm[\'carType\'+$index].$error\"><div class=\"errormessage text-danger\" ng-message=required>{{\'vehicleReq\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'PPU\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=carsData.registration_number name=registrationNumber{{$index}} placeholder=\"{{\'PPU\' | translate}}\" required ng-class=\"{ \'has-error\': driverCarEditForm[\'registrationNumber\'+$index].$touched && driverCarEditForm[\'registrationNumber\'+$index].$invalid }\" pattern=^([A-Za-z]{2})([A-Za-z0-9]{2})([0-9]{2})*$ ng-minlength=3 ng-maxlength=8><!--[a-zA-Z0-9][a-zA-Z0-9-]--><div ng-if=\"driverCarEditForm[\'registrationNumber\'+$index].$touched|| submitCar\" ng-messages=\"driverCarEditForm[\'registrationNumber\'+$index].$error\"><div class=\"errormessage text-danger\" ng-message=required>{{\'registrationNumRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'registrationNumValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'registrationNumMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'registrationNumMaximum\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'workingFor24\' | translate}}<span style=color:red>*</span></label><select class=form-control ng-model=carsData.modelity name=modelityS{{$index}} required ng-class=\"{ \'has-error\': driverCarEditForm[\'modelityS\'+$index].$touched && driverCarEditForm[\'modelityS\'+$index].$invalid }\"><option value=\"\" disabled selected>{{\'selectModelityCar\' | translate}}</option><option value=1>Yes</option><option value=0>No</option></select><div ng-if=\"driverCarEditForm[\'modelityS\'+$index].$touched || submitCar\" ng-messages=\"driverCarEditForm[\'modelityS\'+$index].$error\"><div class=\"errormessage text-danger\" ng-message=required>{{\'selectModelityCarReq\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'workingStatus\' | translate}}<span style=color:red>*</span></label><select class=form-control ng-model=carsData.working_status name=workingStatus{{$index}} required ng-class=\"{ \'has-error\': driverCarEditForm[\'workingStatus\'+$index].$touched && driverCarEditForm[\'workingStatus\'+$index].$invalid }\"><option value=\"\" disabled selected>{{\'workingStatusPlaceholder\' | translate}}=</option><option value=1>Active</option><option value=0>Inactive</option></select><div ng-if=\"driverCarEditForm[\'workingStatus\'+$index].$touched || submitCar\" ng-messages=\"driverCarEditForm[\'workingStatus\'+$index].$error\"><div class=\"errormessage text-danger\" ng-message=required>{{\'workingStatusReq\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Sociedad SAP <span style=color:red>*</span></label><select class=form-control ng-model=carsData.society_id name=societyId{{$index}} required ng-class=\"{ \'has-error\': driverCarEditForm[\'societyId\'+$index].$touched && driverCarEditForm[\'societyId\'+$index].$invalid }\" ng-options=\"data.society_id\n                                            as data.name for data in vm.societies\"><option value=\"\" disabled selected>Sociedad SAP</option></select><div ng-if=\"driverCarEditForm[\'societyId\'+$index].$touched || submitCar\" ng-messages=\"driverCarEditForm[\'societyId\'+$index].$error\"><div class=\"errormessage text-danger\" ng-message=required>Favor seleccione Sociedad</div></div></div></div><!-- <div class=\"row mt5\">\n                                    <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\">\n                                        <label class=\"control-label mt10\">{{\'carImage\' | translate}}<span\n                                                style=\"color:red\">*</span></label><br/>\n                                        <img ng-src=\"{{ carsData.car_photo || \'assets/images/noImage.jpeg\'}}\"\n                                             id=\"carImage{{$index}}\" class=\"documentStyle\"/><br/>\n                                        <button type=\"button\" class=\"btn btn-primary upload mt10\"\n                                                ng-click=\"vm.clickTrigger($event,\'CAR_IMAGE\',$index)\">{{\'uploadButton\' | translate}}\n                                        </button>\n                                    </div>\n                                    <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\">\n                                        <label class=\"control-label mt10\">{{\'vehicleImage\' | translate}}<span\n                                                style=\"color:red\">*</span></label><br/>\n                                        <img ng-src=\"{{ carsData.registration_image || \'assets/images/noImage.jpeg\'}}\"\n                                             id=\"registerImage{{$index}}\" class=\"documentStyle\"/><br/>\n                                        <button type=\"button\" class=\"btn btn-primary upload mt10\"\n                                                ng-click=\"vm.clickTrigger($event,\'REGISTER_IMAGE\',$index)\">{{\'uploadButton\' | translate}}\n                                        </button>\n                                    </div>\n                                    <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6  mt5\">\n                                        <label class=\"control-label mt10\">{{\'travelCard\' | translate}}<span\n                                                style=\"color:red\">*</span></label><br/>\n                                        <img src=\"{{ carsData.travel_card_key || \'assets/images/noImage.jpeg\'}}\"\n                                             id=\"travel{{$index}}\" class=\"documentStyle\"/><br/>\n                                        <button type=\"button\" class=\"btn btn-primary upload mt10 ml5\"\n                                                ng-click=\"vm.clickTrigger($event,\'TRAVEL_CARD_KEY\',$index)\">\n                                            {{\'uploadButton\' | translate}}\n                                        </button>\n                                    </div>\n                                </div> --><div class=\"row mt5\"><!-- <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\">\n                                        <label class=\"control-label mt10\">{{\'passengerSeatInsurance\' | translate}}<span\n                                                style=\"color:red\">*</span></label><br/>\n                                        <img src=\"{{ carsData.passenger_insurance_key || \'assets/images/noImage.jpeg\'}}\"\n                                             id=\"seatInsurance{{$index}}\" class=\"documentStyle\"/><br/>\n                                        <button type=\"button\" class=\"btn btn-primary upload mt10 ml5\"\n                                                ng-click=\"vm.clickTrigger($event,\'PASSENGER_INSURANCE_KEY\',$index)\">\n                                            {{\'uploadButton\' | translate}}\n                                        </button>\n                                    </div> --><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\"><label class=\"control-label mt10\">{{\'circulationPermission\' | translate}}<span style=color:red>*</span></label><br><img src=\"{{ carsData.permission_of_circulation || \'assets/images/noImage.jpeg\'}}\" id=permission{{$index}} class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'PERMISSION_OF_CIRCULATION\',$index)\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\"><label class=\"control-label mt10\">Permiso Min. Transporte<!-- <span style=\"color:red\">*</span> --></label><br><img src=\"{{ carsData.transportation_permit || \'assets/images/noImage.jpeg\'}}\" id=transportation_permit{{$index}} class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'TRANSPORTATION_PERMIT\',$index)\">{{\'uploadButton\' | translate}}</button></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><button class=\"btn btn-primary\" type=submit style=width:200px>{{\'submit\' | translate}}</button></div></div><div class=row ng-if=\"$index != vm.carDetails.length - 1\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><hr></div></div></form></div></div></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12 mt25\" ng-if=\"vm.carDetails.length == 0\"><div class=basicDiv ng-if=\"vm.dataToFill.fleet_type != \'1\'\"><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'carDetailsHead\' | translate}}</p><div class=basicDetailsDiv><form name=driverCarAddFormF ng-submit=\"submitCar=true;driverCarAddFormF.$valid&&vm.addCarApi()\" novalidate autocomplete=off><div ng-repeat=\"addCars in vm.dataToFill.addNewCar\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-right\"><a class=\"btn btn-sm blockIconColor\" title=\"Delete Vehicle\" ng-click=vm.deleteVehicleType($index) style=\"border: 1px solid red;margin-left:5px\" ng-if=\"vm.dataToFill.addNewCar.length > 1\"><i class=\"fa fa-trash\"></i> </a><a class=\"btn btn-sm editIconColor\" ng-click=vm.addVehicle($index) title=\"Add Vehicle\" style=\"border: 1px solid #7266ba;margin-left:5px\"><i class=\"fa fa-plus\"></i></a></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'vehicleLabel\' | translate}}<span style=color:red>*</span></label><ui-select ng-model=addCars.car_type name=carTypeAdd{{$index}} required ng-class=\"{ \'has-error\': driverCarAddFormF[\'carTypeAdd\'+$index].$touched && driverCarAddFormF[\'carTypeAdd\'+$index].$invalid }\" close-on-select=true><ui-select-match placeholder=\"{{\'vehiclePlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in vm.vehicle | filter: $select.search\"><div ng-bind-html=data.name></div></ui-select-choices></ui-select><div ng-if=\"driverCarAddFormF[\'carTypeAdd\'+$index].$touched || submit\" ng-messages=\"driverCarAddFormF[\'carTypeAdd\'+$index].$error\"><div class=\"errormessage text-danger\" ng-message=required>{{\'vehicleReq\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'PPU\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=addCars.registration_number name=registrationNumberAdd{{$index}} placeholder=\"{{\'PPU\' | translate}}\" required ng-class=\"{ \'has-error\': driverCarAddFormF[\'registrationNumberAdd\'+$index].$touched && driverCarAddFormF[\'registrationNumberAdd\'+$index].$invalid }\" pattern=^([A-Za-z]{2})([A-Za-z0-9]{2})([0-9]{2})*$ ng-minlength=3 ng-maxlength=8><!--pattern=\"^[a-zA-Z0-9][a-zA-Z0-9-]*$\"--><div ng-if=\"driverCarAddFormF[\'registrationNumberAdd\'+$index].$touched|| submitCar\" ng-messages=\"driverCarAddFormF[\'registrationNumberAdd\'+$index].$error\"><div class=\"errormessage text-danger\" ng-message=required>{{\'registrationNumRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'registrationNumValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'registrationNumMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'registrationNumMaximum\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'workingFor24\' | translate}}<span style=color:red>*</span></label><select class=form-control ng-model=addCars.modelity name=modelityAddF{{$index}} required ng-class=\"{ \'has-error\': driverCarAddFormF[\'modelityAddF\'+$index].$touched && driverCarAddFormF[\'modelityAddF\'+$index].$invalid }\"><option value=\"\" disabled selected>{{\'selectModelityCar\' | translate}}</option><option value=1>Yes</option><option value=0>No</option></select><div ng-if=\"driverCarAddFormF[\'modelityAddF\'+$index].$touched || submitCar\" ng-messages=\"driverCarAddFormF[\'modelityAddF\'+$index].$error\"><div class=\"errormessage text-danger\" ng-message=required></div></div></div></div><div class=\"row mt5\"><!-- <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\">\n                                            <label class=\"control-label mt10\">{{\'carImage\' | translate}}<span style=\"color:red\">*</span></label><br/>\n                                            <img src=\'assets/images/noImage.jpeg\' id=\"addCarImage{{$index}}\"\n                                                 class=\"documentStyle\"/><br/>\n                                            <button type=\"button\" class=\"btn btn-primary upload mt10\"\n                                                    ng-click=\"vm.clickTrigger($event,\'ADD_CAR_IMAGE\',$index)\">{{\'uploadButton\' | translate}}\n                                            </button>\n                                        </div>\n                                        <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\">\n                                            <label class=\"control-label mt10\">{{\'vehicleImage\' | translate}}<span\n                                                    style=\"color:red\">*</span></label><br/>\n                                            <img src=\'assets/images/noImage.jpeg\' id=\"addRegisterImage{{$index}}\"\n                                                 class=\"documentStyle\"/><br/>\n                                            <button type=\"button\" class=\"btn btn-primary upload mt10\"\n                                                    ng-click=\"vm.clickTrigger($event,\'ADD_REGISTER_IMAGE\',$index)\">\n                                                {{\'uploadButton\' | translate}}\n                                            </button>\n                                        </div>\n                                        <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\">\n                                            <label class=\"control-label mt10\">{{\'passengerSeatInsurance\' | translate}}<span\n                                                    style=\"color:red\">*</span></label><br/>\n                                            <img src=\'assets/images/noImage.jpeg\' id=\"addSeatInsurance{{$index}}\"\n                                                 class=\"documentStyle\"/><br/>\n                                            <button type=\"button\" class=\"btn btn-primary upload mt10\"\n                                                    ng-click=\"vm.clickTrigger($event,\'ADD_PASSENGER_INSURANCE_KEY\',$index)\">\n                                                {{\'uploadButton\' | translate}}\n                                            </button>\n                                        </div>\n                                        <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\">\n                                            <label class=\"control-label mt10\">{{\'travelCard\' | translate}}<span\n                                                    style=\"color:red\">*</span></label><br/>\n                                            <img src=\'assets/images/noImage.jpeg\' id=\"addTravel{{$index}}\"\n                                                 class=\"documentStyle\"/><br/>\n                                            <button type=\"button\" class=\"btn btn-primary upload mt10\"\n                                                    ng-click=\"vm.clickTrigger($event,\'ADD_TRAVEL_CARD_KEY\',$index)\">\n                                                {{\'uploadButton\' | translate}}\n                                            </button>\n                                        </div> --><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\"><label class=\"control-label mt10\">{{\'circulationPermission\' | translate}}<span style=color:red>*</span></label><br><img src=assets/images/noImage.jpeg id=addPermission{{$index}} class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10\" ng-click=\"vm.clickTrigger($event,\'ADD_PERMISSION_OF_CIRCULATION\',$index)\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\"><label class=\"control-label mt10\">Permiso Min. Transporte<!-- <span style=\"color:red\">*</span> --></label><br><img src=assets/images/noImage.jpeg id=addTransportationPermit{{$index}} class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10\" ng-click=\"vm.clickTrigger($event,\'ADD_TRANSPORTATION_PERMIT\',$index)\">{{\'uploadButton\' | translate}}</button></div></div><div class=row ng-if=\"$index != vm.dataToFill.addNewCar.length - 1\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><hr></div></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><button class=\"btn btn-primary\" type=submit style=width:200px>{{\'submit\' | translate}}</button></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/approved-investor/addMoreCars.html","<h2 class=ng-cloak><span ng-if=\"vm.path == \'0\'\">{{\'approveDriversHead\' | translate}} / {{\'addMoreCarsHead\' | translate}}</span> <span ng-if=\"vm.path == \'1\'\">{{\'approvedInvestorsHead\' | translate}} / {{\'addMoreCarsHead\' | translate}}</span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=driver><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=\"panel panel-default\"><div class=panel-body><form name=addMoreCarsForm ng-submit=\"submit=true;addMoreCarsForm.$valid&&vm.addCarApi()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-repeat=\"cars in vm.car_details\"><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-right\"><a class=\"btn btn-sm blockIconColor\" title=\"Delete Vehicle\" ng-click=vm.deleteVehicleType($index) style=\"border: 1px solid red;margin-left:5px\" ng-if=\"vm.car_details.length > 1\"><i class=\"fa fa-trash\"></i> </a><a class=\"btn btn-sm editIconColor\" ng-click=vm.addVehicle($index) title=\"Add Vehicle\" style=\"border: 1px solid #7266ba;margin-left:5px\"><i class=\"fa fa-plus\"></i></a></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'vehicleLabel\' | translate}}<span style=color:red>*</span></label><ui-select ng-model=cars.car_type ng-keyup=vm.vehicleSearch($select.search,$event) name=carType{{$index}} required ng-class=\"{ \'has-error\': addMoreCarsForm[\'carType\'+$index].$touched && addMoreCarsForm[\'carType\'+$index].$invalid }\" close-on-select=true><ui-select-match placeholder=\"{{\'vehiclePlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in vm.vehicle | filter: $select.search\" when-scrolled=vm.paginationChangedForVehicle() ng-click=vm.vechileChanged()><div ng-bind-html=data.name></div></ui-select-choices></ui-select><!--<select class=\"form-control\" ng-model=\"cars.car_type\" name=\"carType{{$index}}\" required ng-class=\"{ \'has-error\': addMoreCarsForm[\'carType\'+$index].$touched && addMoreCarsForm[\'carType\'+$index].$invalid }\">--><!--<option value=\"\" disabled selected>Select Car Type</option>--><!--<option value=\"1\">SUV</option>--><!--<option value=\"2\">Sedan</option>--><!--<option value=\"3\">VAN</option>--><!--</select>--><div ng-if=\"addMoreCarsForm[\'carType\'+$index].$touched || submit\" ng-messages=\"addMoreCarsForm[\'carType\'+$index].$error\"><div class=\"errormessage text-danger\" ng-message=required>{{\'vehicleReq\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'PPU\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=cars.register_number name=registrationNumber{{$index}} placeholder=\"{{\'PPU\' | translate}}\" required ng-class=\"{ \'has-error\': addMoreCarsForm[\'registrationNumber\'+$index].$touched && addMoreCarsForm[\'registrationNumber\'+$index].$invalid }\" pattern=^([A-Za-z]{2})([A-Za-z0-9]{2})([0-9]{2})*$ ng-minlength=3 ng-maxlength=8><!--pattern=\"^[a-zA-Z0-9][a-zA-Z0-9-]*$\" --><div ng-if=\"addMoreCarsForm[\'registrationNumber\'+$index].$touched|| submit\" ng-messages=\"addMoreCarsForm[\'registrationNumber\'+$index].$error\"><div class=\"errormessage text-danger\" ng-message=required>{{\'registrationNumRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'registrationNumValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'registrationNumMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'registrationNumMaximum\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'workingFor24\' | translate}}<span style=color:red>*</span></label><select class=form-control ng-model=cars.modelity name=modelityS{{$index}} required ng-class=\"{ \'has-error\': addMoreCarsForm[\'modelityS\'+$index].$touched && addMoreCarsForm[\'modelityS\'+$index].$invalid }\"><option value=\"\" disabled selected>{{\'selectModelityCar\' | translate}}</option><option value=1>Yes</option><option value=0>No</option></select><div ng-if=\"addMoreCarsForm[\'modelityS\'+$index].$touched || submit\" ng-messages=\"addMoreCarsForm[\'modelityS\'+$index].$error\"><div class=\"errormessage text-danger\" ng-message=required>{{\'selectModelityCarReq\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Sociedad SAP <span style=color:red>*</span></label><select class=form-control ng-model=cars.society_id name=societyId{{$index}} required ng-class=\"{ \'has-error\': addMoreCarsForm[\'societyId\'+$index].$touched && addMoreCarsForm[\'societyId\'+$index].$invalid }\" ng-options=\"data.society_id\n                                                    as data.name for data in vm.societies\"><option value=\"\" disabled selected>Sociedad SAP</option></select><div ng-if=\"addMoreCarsForm[\'societyId\'+$index].$touched || submit\" ng-messages=\"addMoreCarsForm[\'societyId\'+$index].$error\"><div class=\"errormessage text-danger\" ng-message=required>Favor seleccione Sociedad</div></div></div></div><div class=\"row mt5\"><!-- <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\"> --> <input id=documentUpload filestyle=\"\" type=file style=\"display: none\" image=image name={{vm.uploadName}} onchange=angular.element(this).scope().file_to_upload(this.files,this.name) onclick=\"this.value = null\" data-button-text=Single data-class-button=\"btn btn-default\" data-classinput=\"form-control inline\" nv-file-select=\"\" uploader=uploader><!--   <label class=\"control-label mt10\">{{\'Car Image\' | translate}}<span\n                                                        style=\"color:red\">*</span></label><br/>\n                                                <img src=\"assets/images/noImage.jpeg\" id=\"carImage{{$index}}\" class=\"documentStyle\" /><br/>\n                                                <button type=\"button\" class=\"btn btn-primary upload mt10\" ng-click=\"vm.clickTrigger($event,\'CAR_IMAGE\',$index)\">{{\'uploadButton\' | translate}}\n                                                </button>\n                                            </div>\n                                            <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\">\n                                                <label class=\"control-label mt10\">{{\'vehicleImage\' | translate}}<span\n                                                        style=\"color:red\">*</span></label><br/>\n                                                <img src=\"assets/images/noImage.jpeg\" id=\"registerImage{{$index}}\" class=\"documentStyle\" /><br/>\n                                                <button type=\"button\" class=\"btn btn-primary upload mt10\" ng-click=\"vm.clickTrigger($event,\'REGISTER_IMAGE\',$index)\">\n                                                    {{\'uploadButton\' | translate}}\n                                                </button>\n                                            </div>\n                                            <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6  mt5\">\n                                                <label class=\"control-label mt10\">{{\'travelCard\' | translate}}<span\n                                                        style=\"color:red\">*</span></label><br/>\n                                                <img src=\"assets/images/noImage.jpeg\" id=\"travel{{$index}}\" class=\"documentStyle\" /><br/>\n                                                <button type=\"button\" class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'TRAVEL_CARD_KEY\',$index)\">\n                                                    {{\'uploadButton\' | translate}}\n                                                </button>\n                                            </div>\n                                            <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\">\n                                                <label class=\"control-label mt10\">{{\'passengerSeatInsurance\' | translate}}<span\n                                                        style=\"color:red\">*</span></label><br/>\n                                                <img src=\"assets/images/noImage.jpeg\" id=\"seatInsurance{{$index}}\" class=\"documentStyle\" /><br/>\n                                                <button type=\"button\" class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'PASSENGER_INSURANCE_KEY\',$index)\">\n                                                    {{\'uploadButton\' | translate}}\n                                                </button>\n                                            </div> --><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\"><label class=\"control-label mt10\">{{\'circulationPermission\' | translate}}<span style=color:red>*</span></label><br><img src=assets/images/noImage.jpeg id=permission{{$index}} class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'PERMISSION_OF_CIRCULATION\',$index)\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\"><label class=\"control-label mt10\">Permiso Min. Transporte<!-- <span style=\"color:red\">*</span> --></label><br><img src=assets/images/noImage.jpeg id=transportation_permit{{$index}} class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'TRANSPORTATION_PERMIT\',$index)\">{{\'uploadButton\' | translate}}</button></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" ng-if=\"$index != vm.car_details.length - 1\"><hr></div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center mt25\"><button type=submit class=\"btn btn-primary\">{{\'submit\' | translate}}</button></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/approved-investor/approvedCarInvestor.html","<h2 class=ng-cloak><span>{{\'approvedInvestorsHead\' | translate}}</span> <span class=pull-right><!--<button class=\"btn btn-info\" title=\"{{\'filterButton\' | translate}}\" style=\"min-width: 100px;\" ng-click=\"vm.showFilterArea();\">{{\'filterButton\' | translate}}</button>&lt;!&ndash;vm.showFilterArea()&ndash;&gt;--><!--<button class=\"btn btn-info\" title=\"{{\'resetButton\' | translate}}\" ng-click=\"vm.removeFilter()\">{{\'resetButton\' | translate}}</button>--> <button class=\"btn btn-primary tableButton\" ng-click=vm.refreshData()>Volver a cargar</button></span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><!--<filter-sidebar show-filter-sidebar=\"vm.showFilterFlag\" filter-data=\"vm.filterData\" filter-to-show=\"vm.filterWhichToShow\" branch-detail-changed=\"vm.branchChangedFilter(vm.filterData)\"--><!--vehicle-assign-detail-changed=\"vm.vehicleAssignChangedFilter(vm.filterData)\"></filter-sidebar>--><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label class=control-label>{{\'branchLabel\' | translate}}</label><ui-select ng-model=vm.filterData.branch name=branch ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label class=control-label>{{\'vehiclesLabel\' | translate}}</label><input type=text class=form-control ng-model=vm.filterData.vehicle_unique ng-change=vm.vehicleChanged(vm.filterData.vehicle_unique) placeholder=\"{{\'uniqueNumber\' | translate}}\" ng-blur=vm.getUniqueNumber()></div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center mt5\"><p class=totalSize><span class=pull-left><a class=\"btn btn-primary tableButton mb10\" ng-click=vm.exportToCSV(0,vm.dataLength,1,1)>CSV</a> </span><span>{{\'totalInvestors\' | translate}}: {{vm.totalDrivers}}</span></p></div><br><br><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.getFilter() ng-model-options=\"{ debounce: 500 }\"></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\"><!--ng-switch=\"(vm.driverList | filter:vm.search).length\"--><!--<div ng-switch-when=\"0\" class=\"noSearch\"><span>{{\'nothingFound\' | translate}}</span></div>--><table class=\"table table-hover tableWithMasterData\"><!--ng-switch-default--><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'name\' | translate}}\" text=\"\'name\'\" check=vm.reverse>{{\'name\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'email\' | translate}}\" text=\"\'email\'\" check=vm.reverse>{{\'email\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'mobileNumber\' | translate}}\" text=\"\'phone\'\" check=vm.reverse>{{\'mobileNumber\' | translate}}</th><!--<th>--><!--<div class=\"text-center\" ng-click=\"vm.sort(\'creation_datetime\')\">--><!--Date of Joining--><!--<span ng-hide=\"vm.predicate == \'creation_datetime\' && vm.reverse || vm.predicate == \'creation_datetime\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'creation_datetime\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'creation_datetime\' && vm.reverse\" class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'branchLabel\' | translate}}\" text=\"\'branch_name\'\" check=vm.reverse>{{\'branchLabel\' | translate}}</th><!--<th>--><!--<div class=\"text-center\" ng-click=\"vm.sort(\'fleet_type\')\">--><!--Driver Type--><!--<span ng-hide=\"vm.predicate == \'fleet_type\' && vm.reverse || vm.predicate == \'fleet_type\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'fleet_type\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'fleet_type\' && vm.reverse\" class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><!--<th>--><!--<div class=\"text-center\" ng-click=\"vm.sort(\'fleet_route\')\">--><!--Driver Route--><!--<span ng-hide=\"vm.predicate == \'fleet_route\' && vm.reverse || vm.predicate == \'fleet_route\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'fleet_route\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'fleet_route\' && vm.reverse\" class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><!--<th>--><!--<div class=\"text-center\" ng-click=\"vm.sort(\'work_schedule\')\">--><!--Work Schedule--><!--<span ng-hide=\"vm.predicate == \'work_schedule\' && vm.reverse || vm.predicate == \'work_schedule\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'work_schedule\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'work_schedule\' && vm.reverse\" class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><th style=width:150px><div class=text-center>{{\'vehicleTable\' | translate}}</div></th><th style=width:100px><div class=text-center>{{\'stateTable\' | translate}}</div></th><th style=width:150px><div class=text-center>{{\'action\' | translate}}</div></th><th style=width:100px><div class=text-center>{{\'addCars\' | translate}}</div></th><th style=width:150px><div class=text-center>{{\'adminLogs\' | translate}}</div></th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.driverList | orderBy:vm.predicate:vm.reverse\"><!--| filter:vm.search--><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:70px>{{::data.fleet_id}}</td><td style=width:125px>{{::data.name}}</td><td style=width:125px>{{::data.email}}</td><td style=width:125px>{{::data.phone}}</td><!--<td>{{data.creation_datetime | date:\'medium\'}}</td>--><td style=width:100px>{{data.branch_name || \'--\'}}</td><!--<td>--><!--<span ng-if=\"data.fleet_type == 0\">Driver with car</span>--><!--<span ng-if=\"data.fleet_type == 1\">Driver without car</span>--><!--<span ng-if=\"data.fleet_type == 2\">Car investor</span>--><!--</td>--><!--<td>--><!--<span ng-if=\"data.fleet_route == 0\">Fixed Route</span>--><!--<span ng-if=\"data.fleet_route == 1\">Point to Point</span>--><!--</td>--><!--<td>--><!--<span ng-if=\"data.work_schedule == 0\">Part Time</span>--><!--<span ng-if=\"data.work_schedule == 1\">Full Time</span>--><!--<span ng-if=\"data.work_schedule == null\">&#45;&#45;</span>--><!--</td>--><td style=width:150px><span ng-repeat=\"vehicles in data.car_details\">{{vehicles.car_name || \'--\'}} / {{vehicles.unique_car_id || \'--\'}} / {{vehicles.modelity == 0?\'Not 24 Hrs\':\'24 Hrs\' || \'--\'}} <span ng-if=\"$index != data.car_details.length - 1\"><br></span></span><span ng-if=\"!data.car_details || data.car_details.length == 0\">{{\'nopVehicleList\' | translate}}</span></td><td style=width:100px><a class=\"cursor btn btn-sm\" ng-class=\"{\'blockIconColor\': data.is_blocked == 1, \'unblockIconColor\': data.is_blocked == 0}\" ng-click=vm.blockUnblockDriver($event,data.fleet_id,data.is_blocked)><i ng-class=\"{\'fa fa-unlock\': data.is_blocked == 0,\'fa fa-lock\': data.is_blocked == 1}\"></i></a></td><td style=width:150px><a title=\"View Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.approvedInvestorsMain.investorDetails({id:\'{{data.fleet_id}}\',path:\'1\'})\"><i class=\"fa fa-eye\"></i> </a><a title=\"Edit Details\" class=\"cursor btn btn-sm editIconColor\" ui-sref=\"layout.approvedInvestorsMain.editInvestorDetails({id:\'{{data.fleet_id}}\',path:\'1\'})\"><i class=\"fa fa-edit\"></i> </a><a title=\"Delete Details\" class=\"cursor btn btn-sm blockIconColor\" ng-click=vm.deleteUser(data.fleet_id,$event)><i class=\"fa fa-trash\"></i></a></td><td style=width:100px><a class=\"btn btn-primary tableButton\" title=\"{{\'addCars\' | translate}}\" ui-sref=\"layout.approvedInvestorsMain.addCars({id:\'{{data.fleet_id}}\',path:\'1\'})\">{{\'addCars\' | translate}}</a></td><td style=width:150px><a class=\"btn btn-primary tableButton\" title=\"{{\'adminLogs\' | translate}}\" ui-sref=\"layout.approvedInvestorsMain.adminLogs({userId:\'{{data.fleet_id}}\',type:\'0\',fakeType:\'2\'})\">{{\'adminLogs\' | translate}}</a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noInvestorFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav>--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\" ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/approved-investor/approvedCarInvestorMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/approved-investor/carInvestorDetails.html","<h2 class=ng-cloak>{{\'approvedInvestorsHead\' | translate}} / {{\'investorDetailsHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=driver><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'basicDetails\' | translate}}</p><div class=basicDetailsDiv><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><img ng-src=\"{{vm.driverDetail.fleet_image || \'assets/images/noImage.jpeg\'}}\" class=profilePic title=\"{{\'profilePic\' | translate}}\"></div></div><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'name\' | translate}}:</label><div class=\"form-control text-capitalize\">{{vm.driverDetail.first_name + \" \" + vm.driverDetail.last_name}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'email\' | translate}}:</label><div class=form-control>{{::vm.driverDetail.email}}</div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'mobileNumber\' | translate}}:</label><div class=form-control>{{vm.driverDetail.country_code?vm.driverDetail.country_code + \"-\" + vm.driverDetail.phone:vm.driverDetail.phone}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'businessName\' | translate}}:</label><div class=form-control>{{::vm.driverDetail.business_name}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'usernameLabel\' | translate}}:</label><div class=form-control>{{::vm.driverDetail.username}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'invoiceRut\' | translate}}:</label><div class=form-control>{{::vm.driverDetail.invoice_rut}}</div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'address\' | translate}}:</label><div class=form-control>{{::vm.driverDetail.addressFormed}}</div></div></div><!--<div class=\"row mt5\">--><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">Driver Type:</label>--><!--<div class=\"form-control\">--><!--&lt;!&ndash;<span ng-if=\"vm.driverDetail.fleet_type == 0\">Driver with car</span>&ndash;&gt;--><!--&lt;!&ndash;<span ng-if=\"vm.driverDetail.fleet_type == 1\">Driver without car</span>&ndash;&gt;--><!--<span ng-if=\"vm.driverDetail.fleet_type == 2\">Car investor</span>--><!--</div>--><!--</div>--><!--</div>--><!--<div class=\"row mt5\" ng-hide=\"vm.driverDetail.fleet_type == 2\">--><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">License Type:</label>--><!--<div class=\"form-control\">--><!--{{vm.driverDetail.license_type}}--><!--</div>--><!--</div>--><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">License Expiry Date:</label>--><!--<div class=\"form-control\">{{vm.driverDetail.license_expiry_date | date:\'mediumDate\'}}</div>--><!--</div>--><!--</div>--><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'cityOfWorkLabel\' | translate}}:</label><div class=form-control>{{vm.driverDetail.region_name || \'--\'}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'joiningDate\' | translate}}:</label><div class=form-control>{{vm.driverDetail.creation_datetime | date:\'medium\'}}</div></div><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">Company Type:</label>--><!--<div class=\"form-control\">{{vm.driverDetail.company_type || \'&#45;&#45;\'}}</div>--><!--</div>--></div><!--<div class=\"row mt5\">--><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-hide=\"vm.driverDetail.fleet_type == 2\">--><!--<label class=\"control-label\">RUT:</label>--><!--<div class=\"form-control\">--><!--{{vm.driverDetail.RUT}}--><!--</div>--><!--</div>--><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">Driver Route:</label>--><!--<div class=\"form-control\">--><!--<span ng-if=\"vm.driverDetail.fleet_route == 0\">Fixed Route</span>--><!--<span ng-if=\"vm.driverDetail.fleet_route == 1\">Point to Point</span>--><!--</div>--><!--</div>--><!--</div>--></div></div><div class=basicDiv><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'documents\' | translate}}</p><div class=basicDetailsDiv><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><ol><!--<li ng-hide=\"vm.driverDetail.fleet_type == 2\">--><!--<div class=\"displayFlex\">--><!--<div class=\"widthDiv\">--><!--RUT--><!--<br class=\"showBr\"/>--><!--<span class=\"colorPending\"--><!--ng-if=\"vm.driverDetail.identity_card_RUT_status == 0\">(Pending)</span>--><!--<span class=\"colorVerified\"--><!--ng-if=\"vm.driverDetail.identity_card_RUT_status == 1\">(Approved)</span>--><!--<span class=\"colorNot\"--><!--ng-if=\"vm.driverDetail.identity_card_RUT_status == 2\">(Unapproved)</span>--><!--<span class=\"colorUpload\"--><!--ng-if=\"vm.driverDetail.identity_card_RUT_status == 3\">(Upload Again)</span>--><!--</div>--><!--<div class=\"widthDiv1 text-right\">--><!--<a class=\"btn btn-primary view\"--><!--ng-disabled=\"!vm.driverDetail.RUT_image\"--><!--href=\"{{vm.driverDetail.RUT_image}}\" target=\"_blank\">View</a>--><!--<a href=\"{{vm.driverDetail.RUT_image}}\" ng-disabled=\"!vm.driverDetail.RUT_image\" class=\"btn btn-primary upload\" download>Download</a>--><!--</div>--><!--</div>--><!--</li>--><!--<li ng-hide=\"vm.driverDetail.fleet_type == 2\">--><!--<div class=\"displayFlex\">--><!--<div class=\"widthDiv\">--><!--License--><!--<br class=\"showBr\"/>--><!--<span class=\"colorPending\"--><!--ng-if=\"vm.driverDetail.driver_license_status == 0\">(Pending)</span>--><!--<span class=\"colorVerified\"--><!--ng-if=\"vm.driverDetail.driver_license_status == 1\">(Approved)</span>--><!--<span class=\"colorNot\"--><!--ng-if=\"vm.driverDetail.driver_license_status == 2\">(Unapproved)</span>--><!--<span class=\"colorUpload\"--><!--ng-if=\"vm.driverDetail.driver_license_status == 3\">(Upload Again)</span>--><!--</div>--><!--<div class=\"widthDiv1 text-right\">--><!--<a class=\"btn btn-primary view\"--><!--ng-disabled=\"!vm.driverDetail.license_img\"--><!--href=\"{{vm.driverDetail.license_img}}\" target=\"_blank\">View</a>--><!--<a href=\"{{vm.driverDetail.license_img}}\" ng-disabled=\"!vm.driverDetail.license_img\" class=\"btn btn-primary upload\" download>Download</a>--><!--</div>--><!--</div>--><!--</li>--><!--<li ng-hide=\"vm.driverDetail.fleet_type == 2\">--><!--<div class=\"displayFlex\">--><!--<div class=\"widthDiv\">--><!--Antecedents Certificate--><!--<br class=\"showBr\"/>--><!--<span class=\"colorPending\"--><!--ng-if=\"vm.driverDetail.antecents_certificate_status == 0\">(Pending)</span>--><!--<span class=\"colorVerified\"--><!--ng-if=\"vm.driverDetail.antecents_certificate_status == 1\">(Approved)</span>--><!--<span class=\"colorNot\"--><!--ng-if=\"vm.driverDetail.antecents_certificate_status == 2\">(Unapproved)</span>--><!--<span class=\"colorUpload\"--><!--ng-if=\"vm.driverDetail.antecents_certificate_status == 3\">(Upload Again)</span>--><!--</div>--><!--<div class=\"widthDiv1 text-right\">--><!--<a class=\"btn btn-primary view\"--><!--ng-disabled=\"!vm.driverDetail.antecents_certificate\"--><!--href=\"{{vm.driverDetail.antecents_certificate}}\" target=\"_blank\">View</a>--><!--<a href=\"{{vm.driverDetail.antecents_certificate}}\" ng-disabled=\"!vm.driverDetail.antecents_certificate\" class=\"btn btn-primary upload\" download>Download</a>--><!--</div>--><!--</div>--><!--</li>--><!--<li ng-hide=\"vm.driverDetail.fleet_type == 2\">--><!--<div class=\"displayFlex\">--><!--<div class=\"widthDiv\">--><!--Life Sheet--><!--<br class=\"showBr\"/>--><!--<span class=\"colorPending\"--><!--ng-if=\"vm.driverDetail.life_sheet_img_status == 0\">(Pending)</span>--><!--<span class=\"colorVerified\"--><!--ng-if=\"vm.driverDetail.life_sheet_img_status == 1\">(Approved)</span>--><!--<span class=\"colorNot\"--><!--ng-if=\"vm.driverDetail.life_sheet_img_status == 2\">(Unapproved)</span>--><!--<span class=\"colorUpload\"--><!--ng-if=\"vm.driverDetail.life_sheet_img_status == 3\">(Upload Again)</span>--><!--</div>--><!--<div class=\"widthDiv1 text-right\">--><!--<a class=\"btn btn-primary view\"--><!--ng-disabled=\"!vm.driverDetail.life_sheet_img\"--><!--href=\"{{vm.driverDetail.life_sheet_img}}\" target=\"_blank\">View</a>--><!--<a href=\"{{vm.driverDetail.life_sheet_img}}\" ng-disabled=\"!vm.driverDetail.life_sheet_img\" class=\"btn btn-primary upload\" download>Download</a>--><!--</div>--><!--</div>--><!--</li>--><!--<li>--><!--<div class=\"displayFlex\">--><!--<div class=\"widthDiv\">--><!--Company Identity Card--><!--<br class=\"showBr\"/>--><!--<span class=\"colorPending\"--><!--ng-if=\"vm.driverDetail.identity_card_company_status == 0\">(Pending)</span>--><!--<span class=\"colorVerified\"--><!--ng-if=\"vm.driverDetail.identity_card_company_status == 1\">(Approved)</span>--><!--<span class=\"colorNot\"--><!--ng-if=\"vm.driverDetail.identity_card_company_status == 2\">(Unapproved)</span>--><!--<span class=\"colorUpload\"--><!--ng-if=\"vm.driverDetail.identity_card_company_status == 3\">(Upload Again)</span>--><!--</div>--><!--<div class=\"widthDiv1 text-right\">--><!--<a class=\"btn btn-primary view\"--><!--ng-disabled=\"!vm.driverDetail.company_identity_card\"--><!--href=\"{{vm.driverDetail.company_identity_card}}\" target=\"_blank\">View</a>--><!--<a href=\"{{vm.driverDetail.company_identity_card}}\"--><!--ng-disabled=\"!vm.driverDetail.company_identity_card\"--><!--class=\"btn btn-primary upload\" download>Download</a>--><!--</div>--><!--</div>--><!--</li>--><!--<li>--><!--<div class=\"displayFlex\">--><!--<div class=\"widthDiv\">--><!--Company Constitution--><!--<br class=\"showBr\"/>--><!--<span class=\"colorPending\"--><!--ng-if=\"vm.driverDetail.constitution_company_status == 0\">(Pending)</span>--><!--<span class=\"colorVerified\"--><!--ng-if=\"vm.driverDetail.constitution_company_status == 1\">(Approved)</span>--><!--<span class=\"colorNot\"--><!--ng-if=\"vm.driverDetail.constitution_company_status == 2\">(Unapproved)</span>--><!--<span class=\"colorUpload\"--><!--ng-if=\"vm.driverDetail.constitution_company_status == 3\">(Upload Again)</span>--><!--</div>--><!--<div class=\"widthDiv1 text-right\">--><!--<a class=\"btn btn-primary view\"--><!--ng-disabled=\"!vm.driverDetail.company_constitution\"--><!--href=\"{{vm.driverDetail.company_constitution}}\" target=\"_blank\">View</a>--><!--<a href=\"{{vm.driverDetail.company_constitution}}\"--><!--ng-disabled=\"!vm.driverDetail.company_constitution\"--><!--class=\"btn btn-primary upload\" download>Download</a>--><!--</div>--><!--</div>--><!--</li>--><!--<li>--><!--<div class=\"displayFlex\">--><!--<div class=\"widthDiv\">--><!--Activity Start--><!--<br class=\"showBr\"/>--><!--<span class=\"colorPending\"--><!--ng-if=\"vm.driverDetail.start_activities_status == 0\">(Pending)</span>--><!--<span class=\"colorVerified\"--><!--ng-if=\"vm.driverDetail.start_activities_status == 1\">(Approved)</span>--><!--<span class=\"colorNot\"--><!--ng-if=\"vm.driverDetail.start_activities_status == 2\">(Unapproved)</span>--><!--<span class=\"colorUpload\"--><!--ng-if=\"vm.driverDetail.start_activities_status == 3\">(Upload Again)</span>--><!--</div>--><!--<div class=\"widthDiv1 text-right\">--><!--<a class=\"btn btn-primary view\"--><!--ng-disabled=\"!vm.driverDetail.start_activities\"--><!--href=\"{{vm.driverDetail.start_activities}}\"--><!--target=\"_blank\">View</a>--><!--<a href=\"{{vm.driverDetail.start_activities}}\"--><!--ng-disabled=\"!vm.driverDetail.start_activities\"--><!--class=\"btn btn-primary upload\" download>Download</a>--><!--</div>--><!--</div>--><!--</li>--><!--<li>--><!--<div class=\"displayFlex\">--><!--<div class=\"widthDiv\">--><!--Invoice Stamping--><!--<br class=\"showBr\"/>--><!--<span class=\"colorPending\"--><!--ng-if=\"vm.driverDetail.stamping_invoice_status == 0\">(Pending)</span>--><!--<span class=\"colorVerified\"--><!--ng-if=\"vm.driverDetail.stamping_invoice_status == 1\">(Approved)</span>--><!--<span class=\"colorNot\"--><!--ng-if=\"vm.driverDetail.stamping_invoice_status == 2\">(Unapproved)</span>--><!--<span class=\"colorUpload\"--><!--ng-if=\"vm.driverDetail.stamping_invoice_status == 3\">(Upload Again)</span>--><!--</div>--><!--<div class=\"widthDiv1 text-right\">--><!--<a class=\"btn btn-primary view\"--><!--ng-disabled=\"!vm.driverDetail.invoice_stamping\"--><!--href=\"{{vm.driverDetail.invoice_stamping}}\"--><!--target=\"_blank\">View</a>--><!--<a href=\"{{vm.driverDetail.invoice_stamping}}\"--><!--ng-disabled=\"!vm.driverDetail.invoice_stamping\"--><!--class=\"btn btn-primary upload\" download>Download</a>--><!--</div>--><!--</div>--><!--</li>--><li><div class=displayFlex><div class=widthDiv>{{\'invoiceRut\' | translate}}<br class=showBr><!--<span class=\"colorPending\" ng-if=\"vm.driverDetail.stamping_invoice_status == 0\">(Pending)</span>--><!--<span class=\"colorVerified\" ng-if=\"vm.driverDetail.stamping_invoice_status == 1\">(Approved)</span>--><!--<span class=\"colorNot\" ng-if=\"vm.driverDetail.stamping_invoice_status == 2\">(Unapproved)</span>--><!--<span class=\"colorUpload\" ng-if=\"vm.driverDetail.stamping_invoice_status == 3\">(Upload Again)</span>--></div><div class=\"widthDiv1 text-right\"><a class=\"cursor btn btn-sm editIconColor\" ng-disabled=!vm.driverDetail.invoice_rut_image href={{vm.driverDetail.invoice_rut_image}} target=_blank><i class=\"fa fa-eye\"></i> </a><!--<a class=\"btn btn-primary view\"--><!--ng-disabled=\"!vm.driverDetail.invoice_rut_image\"--><!--href=\"{{vm.driverDetail.invoice_rut_image}}\"--><!--target=\"_blank\">View</a>--> <a href={{vm.driverDetail.invoice_rut_image}} ng-disabled=!vm.driverDetail.invoice_rut_image class=\"btn btn-primary upload\" download>{{\'download\' | translate}}</a></div></div></li></ol></div></div></div></div><p class=\"basicRegistrationP backgroundBasicPending text-center mt10\">{{\'paymentHead\' | translate}}</p><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'paymentModulityLabel\' | translate}}</label><div class=form-control><!-- <span ng-if=\"vm.driverDetail.payment_modulity == 1\">Bank Deposit</span>\n                                <span ng-if=\"vm.driverDetail.payment_modulity == 2\">Vale View</span> --> <span ng-if=\"vm.driverDetail.payment_modulity == 1\">1 Vale Vista</span> <span ng-if=\"vm.driverDetail.payment_modulity == 2\">3 Abono Cta Cte y Cta Vista</span> <span ng-if=\"vm.driverDetail.payment_modulity == 3\">4 Abono Cta Ahorro</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'bankLabel\' | translate}}</label><div class=form-control>{{::vm.driverDetail.bank_name}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'accountTypeLabel\' | translate}}</label><div class=form-control><span ng-if=vm.driverDetail.account_rut>{{::vm.driverDetail.account_rut}}</span> <span ng-if=\"vm.driverDetail.account_rut == null\">Conductor sin rut</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'accountNumberLabel\' | translate}}</label><div class=form-control>{{::vm.driverDetail.account_number}}</div></div></div><div class=\"basicDiv mt5\" ng-if=vm.driverDetail.car_details.length><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'carDetailsHead\' | translate}}</p><div class=basicDetailsDiv><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" ng-repeat=\"data in vm.driverDetail.car_details\"><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'vehicleLabel\' | translate}}:</label><div class=form-control><span>{{::data.carName}}</span><!--<span ng-if=\"data.car_type == 1\">SUV</span>--><!--<span ng-if=\"data.car_type == 2\">Sedan</span>--><!--<span ng-if=\"data.car_type == 3\">VAN</span>--></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'PPU\' | translate}}:</label><div class=form-control>{{data.registration_number || \'--\'}}</div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'addedAt\' | translate}}:</label><div class=form-control>{{data.added_at | date:\'medium\'}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Sociedad SAP:</label><div class=form-control>{{ data.society_name || \'--\'}}</div></div><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">Car Status:</label>--><!--<div class=\"form-control\" ng-if=\"data.car_status == 0\"> Free</div>--><!--<div class=\"form-control\" ng-if=\"data.car_status == 1\">--><!--Occupied/{{data.occupied_by || \'&#45;&#45;\'}}--><!--</div>--><!--</div>--></div><div class=\"row mt5\"><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6\"><label class=control-label>{{\'carImage\' | translate}}:</label><div><img ng-src=\"{{data.car_photo || \'assets/images/noImage.jpeg\'}}\" class=profilePic title=\"{{\'carImage\' | translate}}\"></div></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6\"><label class=control-label>{{\'vehicleImage\' | translate}}:</label><div><img ng-src=\"{{data.registration_image || \'assets/images/noImage.jpeg\'}}\" class=profilePic title=\"{{\'vehicleImage\' | translate}}\"></div></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\"><label class=\"control-label mt10\">{{\'travelCard\' | translate}}<span style=color:red>*</span></label><div><img src=\"{{data.travel_card_key || \'assets/images/noImage.jpeg\'}}\" class=profilePic title=\"{{\'travelCard\' | translate}}\"></div></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\"><label class=\"control-label mt10\">{{\'passengerSeatInsurance\' | translate}}<span style=color:red>*</span></label><div><img src=\"{{data.passenger_insurance_key || \'assets/images/noImage.jpeg\'}}\" class=profilePic title=\"{{\'passengerSeatInsurance\' | translate}}\"></div></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\"><label class=\"control-label mt10\">{{\'circulationPermission\' | translate}}<span style=color:red>*</span></label><div><img src=\"{{data.permission_of_circulation || \'assets/images/noImage.jpeg\'}}\" class=profilePic title=\"{{\'circulationPermission\' | translate}}\"></div></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\"><label class=\"control-label mt10\">Permiso Min. Transporte<!-- <span style=\"color:red\">*</span> --></label><div><img src=\"{{data.transportation_permit || \'assets/images/noImage.jpeg\'}}\" class=profilePic title=\"Permiso Ministerio de Transport\"></div></div></div><div class=\"row mt5\" ng-if=\"$index != (vm.driverDetail.car_details.length-1)\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><span><hr></span></div></div></div></div></div></div><div class=basicDiv><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'adminComments\' | translate}}</p><div class=basicDetailsDiv><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=vm.driverDetail.basicRegistration_comments><label class=control-label>Basic Registration:</label><textarea class=form-control ng-model=vm.driverDetail.basicRegistration_comments placeholder=\"{{\'messagePlaceholder\' | translate}}\" readonly></textarea></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=vm.driverDetail.documentation_comments><label class=control-label>Documents:</label><textarea class=form-control ng-model=vm.driverDetail.documentation_comments placeholder=\"{{\'messagePlaceholder\' | translate}}\" readonly></textarea></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=vm.driverDetail.interview_comments><label class=control-label>Interview:</label><textarea class=form-control ng-model=vm.driverDetail.interview_comments placeholder=\"{{\'messagePlaceholder\' | translate}}\" readonly></textarea></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=vm.driverDetail.training_comments><label class=control-label>Training:</label><textarea class=form-control ng-model=vm.driverDetail.training_comments placeholder=\"{{\'messagePlaceholder\' | translate}}\" readonly></textarea></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=vm.driverDetail.signOfContract_comments><label class=control-label>Sign of Contract:</label><textarea class=form-control ng-model=vm.driverDetail.signOfContract_comments placeholder=\"{{\'messagePlaceholder\' | translate}}\" readonly></textarea></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=vm.driverDetail.activation_comments><label class=control-label>Account Activation:</label><textarea class=form-control ng-model=vm.driverDetail.activation_comments placeholder=\"{{\'messagePlaceholder\' | translate}}\" readonly></textarea></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=vm.driverDetail.block_unblock_comments><label class=control-label>Block/ Unblock:</label><textarea class=form-control ng-model=vm.driverDetail.block_unblock_comments placeholder=\"{{\'messagePlaceholder\' | translate}}\" readonly></textarea></div></div><div class=row><div class=\"col-lg-12 col-ms-12 col-md-12 col-xs-12 table-responsive\"><table class=\"table table-hover\"><thead><tr><th>{{\'registrationSteps\' | translate}}</th><th>{{\'approvedBy\' | translate}}</th><th>{{\'approvedAt\' | translate}}</th></tr></thead><tbody><tr><td>Basic Registration</td><td>{{vm.driverDetail.basicRegistration_modified_by || \'--\'}}</td><td>{{vm.driverDetail.basicRegistration_modified_at || \'--\' | date: \'medium\'}}</td></tr><tr><td>Documents</td><td>{{vm.driverDetail.documentation_modified_by || \'--\'}}</td><td>{{vm.driverDetail.documentation_modified_at || \'--\' | date: \'medium\'}}</td></tr><tr><td>Interview</td><td>{{vm.driverDetail.interview_modified_by || \'--\'}}</td><td>{{vm.driverDetail.interview_modified_at || \'--\' | date: \'medium\'}}</td></tr><tr><td>Training</td><td>{{vm.driverDetail.training_modified_by || \'--\'}}</td><td>{{vm.driverDetail.training_modified_at || \'--\' | date: \'medium\'}}</td></tr><tr><td>Sign of Contract</td><td>{{vm.driverDetail.signOfContract_modified_by || \'--\'}}</td><td>{{vm.driverDetail.signOfContract_modified_at || \'--\' | date: \'medium\'}}</td></tr><tr><td>Account Activation</td><td>{{vm.driverDetail.activation_modified_by || \'--\'}}</td><td>{{vm.driverDetail.activation_modified_at || \'--\' | date: \'medium\'}}</td></tr></tbody></table></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/approved-investor/editCarInvestorDetails.html","<h2 class=ng-cloak>{{\'approvedInvestorsHead\' | translate}} / {{\'editInvestorHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=driver><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'basicDetails\' | translate}}</p><div class=basicDetailsDiv><form name=driverEditForm ng-submit=\"submit=true;driverEditForm.$valid&&vm.editBasicApi()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'driverType\' | translate}}<span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.fleet_type name=driverType required ng-class=\"{ \'has-error\': driverEditForm.driverType.$touched && driverEditForm.driverType.$invalid }\" disabled><option value=\"\" disabled selected>{{\'driverTypePlaceholder\' | translate}}</option><option value=0>Conductor con auto</option><!--<option value=\"1\" >I am a Driver without a car</option>--><option value=2>Soy inversionista</option></select><div ng-if=\"driverEditForm.driverType.$touched || submit\" ng-messages=driverEditForm.driverType.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'driverTypeReq\' | translate}}</div></div></div></div><div><!--ng-if=\"vm.dataToFill.fleet_type\"--><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'firstNameLabel\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.first_name name=firstName placeholder=\"{{\'firstNameLabel\' | translate}}\" required ng-maxlength=60 ng-minlength=2 ng-class=\"{ \'has-error\': driverEditForm.firstName.$touched && driverEditForm.firstName.$invalid }\" pattern=^\\D*$><div ng-if=\"driverEditForm.firstName.$touched|| submit\" ng-messages=driverEditForm.firstName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'firstNameRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'firstNameValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'firstNameMaximum\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'lastNameLabel\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.last_name name=lastName placeholder=\"{{\'lastNameLabel\' | translate}}\" required ng-maxlength=60 ng-minlength=2 ng-class=\"{ \'has-error\': driverEditForm.lastName.$touched && driverEditForm.lastName.$invalid }\" pattern=^\\D*$><div ng-if=\"driverEditForm.lastName.$touched|| submit\" ng-messages=driverEditForm.lastName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'lastNameRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'lastNameValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'lastNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'lastNameMaximum\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'emailPlaceholder\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control readonly ng-model=vm.dataToFill.email name=driverEmail placeholder=\"{{\'emailPlaceholder\' | translate}}\" required ng-class=\"{ \'has-error\': driverEditForm.driverEmail.$touched && driverEditForm.driverEmail.$invalid }\" pattern=^([_a-zA-Z0-9-+]+)(\\.[_a-zA-Z0-9-+]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*\\.)+([a-zA-Z]{2,3})$><div ng-if=\"driverEditForm.driverEmail.$touched|| submit\" ng-messages=driverEditForm.driverEmail.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'requiredEmail\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'validEmail\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=\"vm.dataToFill.fleet_type != \'1\'\"><label class=control-label>{{\'invoiceRut\' | translate}}<span style=color:red ng-if=\"vm.dataToFill.fleet_type == \'2\'\">*</span></label><input type=text class=form-control ng-model=vm.dataToFill.invoice_rut name=invoiceRUT placeholder=\"{{\'invoiceRut\' | translate}}\" ng-rut ng-change=vm.rutChange1() ng-required=\"vm.dataToFill.fleet_type == \'2\'\" ng-class=\"{ \'has-error\': driverEditForm.invoiceRUT.$touched && driverEditForm.invoiceRUT.$invalid }\"><div ng-if=\"driverEditForm.invoiceRUT.$touched|| submit\" ng-messages=driverEditForm.invoiceRUT.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'rutRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'rutValid\' | translate}}</div></div><div class=\"errormessage text-danger\" ng-if=vm.rutFlag1>{{\'rutValid\' | translate}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=\"vm.dataToFill.fleet_type != \'2\'\"><label class=control-label>{{\'rutLabel\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.RUT name=RUT placeholder=\"{{\'rutLabel\' | translate}}\" ng-rut ng-change=vm.rutChange() required ng-class=\"{ \'has-error\': driverEditForm.RUT.$touched && driverEditForm.RUT.$invalid }\"><div ng-if=\"driverEditForm.RUT.$touched|| submit\" ng-messages=driverEditForm.RUT.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'rutRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'rutValid\' | translate}}</div></div><div class=\"errormessage text-danger\" ng-if=vm.rutFlag>{{\'rutValid\' | translate}}</div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'mobileNumber\' | translate}}<span style=color:red>*</span></label><div class=displayFlex><div><input type=text style=width:50px class=form-control ng-model=vm.dataToFill.country_code name=countryCode placeholder=\"Country Code\" required ng-class=\"{ \'has-error\': driverEditForm.countryCode.$touched && driverEditForm.countryCode.$invalid }\" pattern=^[0-9+][0-9+]*$ readonly><div ng-if=\"driverEditForm.countryCode.$touched|| submit\" ng-messages=driverEditForm.countryCode.$error><div class=\"errormessage text-danger\" ng-message=required>Please enter country code</div><div class=\"errormessage text-danger\" ng-message=pattern>Please enter a valid country code.</div></div></div><div style=\"width:90%; margin-left:5px\"><input type=text class=form-control ng-model=vm.dataToFill.phone_number name=mobileNumber placeholder=\"{{\'mobileNumber\' | translate}}\" required ng-minlength=9 ng-maxlength=9 ng-class=\"{\'has-error\': driverEditForm.mobileNumber.$touched && driverEditForm.mobileNumber.$invalid}\" pattern=^([9]{1}[0-9]{8})*$><!--\"^([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1})*$\"--><div ng-if=\"driverEditForm.mobileNumber.$touched|| submit\" ng-messages=driverEditForm.mobileNumber.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'mobileRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'mobileValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'mobileValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'mobileValid\' | translate}}</div></div></div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'cityOfWorkLabel\' | translate}}<span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.branch name=branch required ng-class=\"{ \'has-error\': driverEditForm.branch.$touched && driverEditForm.branch.$invalid }\" ng-options=\"branch.region_id as branch.region_name for branch in vm.branchList\"><option value=\"\" disabled selected>{{\'cityOfWorkLabelSelect\' | translate}}</option></select><div ng-if=\"driverEditForm.branch.$touched|| submit\" ng-messages=driverEditForm.branch.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'cityWorkRequired\' | translate}}</div></div></div></div><div class=\"row mt5\" ng-if=\"vm.dataToFill.fleet_type != \'2\'\"><!-- ng-if=\"vm.dataToFill.fleet_type != \'2\'\"--><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'liceneClassLabel\' | translate}}<span style=color:red>*</span></label><!--<select class=\"form-control\" ng-model=\"vm.dataToFill.license_type\" name=\"licencseType\" required ng-class=\"{\'has-error\': driverEditForm.licencseType.$touched && driverEditForm.licencseType.$invalid}\">--><!--<option value=\"\" disabled selected>Select Class Of License</option>--><!--<option value=\"A1\">A1</option>--><!--<option value=\"A2\">A2</option>--><!--<option value=\"A3\">A3</option>--><!--</select>--> <input type=text class=form-control ng-model=vm.dataToFill.license_type name=licencseType placeholder=\"{{\'liceneClassLabel\' | translate}}\" required ng-class=\"{ \'has-error\': driverEditForm.licencseType.$touched\n                                        && driverEditForm.licencseType.$invalid }\" maxlength=10 alpha-numeric=\"\"><div ng-if=\"driverEditForm.licencseType.$touched|| submit\" ng-messages=driverEditForm.licencseType.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'licenseRequired\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid license type.\n                                                </div>\n                                                <div class=\"errormessage text-danger\" ng-message=\"minlength\">Minimum 1 characters are allowed.\n                                                </div>\n                                                <div class=\"errormessage text-danger\" ng-message=\"maxlength\">Maximum 2 characters are allowed.\n                                                </div>--></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'liceneExpiaryLabel\' | translate}}<span style=color:red>*</span></label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} ng-model=vm.dataToFill.license_expiry_date name=licenseExpiry placeholder=\"{{\'liceneExpiaryLabel\' | translate}}\" is-open=vm.datePicker_1.end datepicker-options=vm.dateOptions required ng-class=\"{ \'has-error\': driverEditForm.licenseExpiry.$touched && driverEditForm.licenseExpiry.$invalid }\" close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_1()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"driverEditForm.licenseExpiry.$touched|| submit\" ng-messages=driverEditForm.licenseExpiry.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'licenseExpiryRequired\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=\"vm.dataToFill.fleet_type != \'1\'\"><label class=control-label>{{\'businessName\' | translate}}<span style=color:red ng-if=\"vm.dataToFill.fleet_type == \'2\'\">*</span></label><input type=text class=form-control ng-model=vm.dataToFill.business_name name=BusinessName placeholder=\"{{\'businessName\' | translate}}\" ng-required=\"vm.dataToFill.fleet_type == \'2\'\" ng-maxlength=60 ng-minlength=3 ng-class=\"{ \'has-error\': driverEditForm.BusinessName.$touched && driverEditForm.BusinessName.$invalid }\" pattern=^[a-zA-Z][a-zA-Z\\s]*$><div ng-if=\"driverEditForm.BusinessName.$touched|| submit\" ng-messages=driverEditForm.BusinessName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'businessNameRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'businessNameValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'businessNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'businessNameMaximum\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'usernameLabel\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.username name=username placeholder=\"{{\'usernameLabel\' | translate}}\" required ng-class=\"{ \'has-error\': driverEditForm.username.$touched && driverEditForm.username.$invalid }\" pattern=^[a-zA-Zñ0-9][a-zA-Zñ0-9\\s,]*$ ng-minlength=4 ng-maxlength=50><div ng-if=\"driverEditForm.username.$touched|| submit\" ng-messages=driverEditForm.username.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'usernameRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'usernameValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'usernameMin\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'usernameMax\' | translate}}</div></div></div><!-- <div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=\"vm.dataToFill.fleet_type != \'2\'\">\n                                            <label class=\"control-label\">{{\'modalityOfworkLabel\' | translate}}</label>\n                                            <select class=\"form-control\" ng-model=\"vm.dataToFill.work_schedule\" name=\"workSchedule\" ng-class=\"{ \'has-error\': driverEditForm.workSchedule.$touched && driverEditForm.workSchedule.$invalid }\">\n                                                <option value=\"\" disabled selected>{{\'modalityOfworkPlaceholder\' | translate}}</option>\n                                                <option value=\"0\">Part Time</option>\n                                                <option value=\"1\">Full Time</option>\n                                            </select>\n                                            <div ng-if=\"driverEditForm.workSchedule.$touched || submit\" ng-messages=\"driverEditForm.workSchedule.$error\">\n                                            </div>\n                                        </div> --></div><div class=\"row mt5\"><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">Company Type<span style=\"color:red\"--><!--ng-if=\"vm.dataToFill.fleet_type!=\'1\'\">*</span></label>--><!--<input type=\"text\" class=\"form-control\"--><!--ng-model=\"vm.dataToFill.company_type\" name=\"companyType\"--><!--placeholder=\"Company type\"--><!--ng-required=\"vm.dataToFill.fleet_type!=\'1\'\"--><!--ng-class=\"{ \'has-error\': driverEditForm.companyType.$touched && driverEditForm.companyType.$invalid }\"--><!--pattern=\"^[a-zA-Z0-9][a-zA-Z0-9\\s]*$\"/>--><!--<div ng-if=\"driverEditForm.companyType.$touched|| submit\"--><!--ng-messages=\"driverEditForm.companyType.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter--><!--company type.--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter--><!--a valid company type.--><!--</div>--><!--</div>--><!--</div>--><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">\n                                            <label class=\"control-label\">Driver Route<span\n                                                    style=\"color:red\">*</span></label>\n                                            <select class=\"form-control\" ng-model=\"vm.dataToFill.fleet_route\" name=\"fleetRoute\" required ng-class=\"{ \'has-error\': driverEditForm.fleetRoute.$touched && driverEditForm.fleetRoute.$invalid }\">\n                                                <option value=\"\" disabled selected>Select Driver Route</option>\n                                                <option value=\"0\">Fixed Route</option>\n                                                <option value=\"1\">Poit to Point</option>\n                                            </select>\n                                            <div ng-if=\"driverEditForm.fleetRoute.$touched || submit\" ng-messages=\"driverEditForm.fleetRoute.$error\">\n                                                <div class=\"errormessage text-danger\" ng-message=\"required\">Please select driver route.\n                                                </div>\n                                            </div>\n                                        </div>--></div><p class=\"basicRegistrationP backgroundBasicPending text-center mt10\">{{\'address\' | translate}}</p><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'street\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.street name=street placeholder=\"{{\'street\' | translate}}\" required ng-class=\"{ \'has-error\': driverEditForm.street.$touched && driverEditForm.street.$invalid }\" pattern=^[a-zA-Zñ0-9][a-zA-Zñ0-9\\s,]*$ ng-minlength=4 ng-maxlength=50><div ng-if=\"driverEditForm.street.$touched|| submit\" ng-messages=driverEditForm.street.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'streetRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'streetValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'streetMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'streetMaximum\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'number\' | translate}}</label><input type=text class=form-control ng-model=vm.dataToFill.number name=houseNumber placeholder=\"{{\'number\' | translate}}\" ng-class=\"{ \'has-error\': driverEditForm.houseNumber.$touched && driverEditForm.houseNumber.$invalid }\" pattern=^[1-9][0-9]*$ ng-maxlength=6><div ng-if=\"driverEditForm.houseNumber.$touched|| submit\" ng-messages=driverEditForm.houseNumber.$error><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter number.</div>--><div class=\"errormessage text-danger\" ng-message=pattern>{{\'numberRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'numberMax\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'apartment\' | translate}}</label><input type=text class=form-control ng-model=vm.dataToFill.apartment name=apartment placeholder=\"{{\'apartment\' | translate}}\" ng-class=\"{ \'has-error\': driverEditForm.apartment.$touched && driverEditForm.apartment.$invalid }\" pattern=^[a-zA-Z0-9][a-zA-Z0-9\\s,]*$ ng-maxlength=6><div ng-if=\"driverEditForm.apartment.$touched|| submit\" ng-messages=driverEditForm.apartment.$error><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter apartment.</div>--><div class=\"errormessage text-danger\" ng-message=pattern>{{\'apartmentRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'apartmentMax\' | translate}}</div></div></div><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">Communa<span style=\"color:red\">*</span></label>--><!--<select class=\"form-control\" ng-model=\"vm.dataToFill.sector\" name=\"communa\" required ng-class=\"{ \'has-error\': driverEditForm.communa.$touched && driverEditForm.communa.$invalid }\" ng-options=\"communaG.communa as communaG.communa for communaG in vm.communaList\">--><!--&lt;!&ndash;communa.communa_id as &ndash;&gt;--><!--<option value=\"\" disabled selected>Select Communa</option>--><!--</select>--><!--<div ng-if=\"driverEditForm.communa.$touched|| submit\" ng-messages=\"driverEditForm.communa.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please select communa.--><!--</div>--><!--</div>--><!--</div>--></div><!--<div class=\"row mt5\">--><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">Region<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.region\"--><!--name=\"region\" placeholder=\"Region\" required--><!--ng-class=\"{ \'has-error\': driverEditForm.region.$touched && driverEditForm.region.$invalid }\"--><!--pattern=\"^[a-zA-Z0-9][a-zA-Z0-9\\s,]*$\" ng-minlength=\"4\"--><!--ng-maxlength=\"50\"/>--><!--<div ng-if=\"driverEditForm.region.$touched|| submit\"--><!--ng-messages=\"driverEditForm.region.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter--><!--region.--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter--><!--a valid region.--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"minlength\">Minimum 4--><!--characters are allowed.--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"maxlength\">Maximum 50--><!--characters are allowed.--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><p class=\"basicRegistrationP backgroundBasicPending text-center mt10\" ng-if=\"vm.dataToFill.fleet_type != \'1\'\">{{\'paymentHead\' | translate}}</p><div class=\"row mt5\" ng-if=\"vm.dataToFill.fleet_type != \'1\'\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'paymentModulityLabel\' | translate}}<span style=color:red ng-if=\"vm.dataToFill.fleet_type == \'2\'\">*</span></label><select class=form-control ng-model=vm.dataToFill.payment_modulity name=paymentModulity ng-required=\"vm.dataToFill.fleet_type == \'2\'\" ng-class=\"{ \'has-error\': driverEditForm.paymentModulity.$touched && driverEditForm.paymentModulity.$invalid }\"><option value=\"\" disabled selected>{{\'paymentModulityLabelSelect\' | translate}}</option><!-- <option value=\"1\">Bank Deposit</option>\n                                                <option value=\"2\">Vale View</option> --><option value=1>1 Vale Vista</option><option value=2>3 Abono Cta Cte y Cta Vista</option><option value=3>4 Abono Cta Ahorro</option></select><div ng-if=\"driverEditForm.paymentModulity.$touched || submit\" ng-messages=driverEditForm.paymentModulity.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'paymentModulityRequired\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'bankLabel\' | translate}}<span style=color:red ng-if=\"vm.dataToFill.fleet_type == \'2\'\">*</span></label><!-- <input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.bank_name\" name=\"Bank\" placeholder=\"{{\'bankLabel\' | translate}}\" required ng-class=\"{ \'has-error\': driverEditForm.Bank.$touched && driverEditForm.Bank.$invalid }\" pattern=\"^[a-zA-Z0-9][a-zA-Z0-9\\s,]*$\"\n                                            /> --><select class=form-control ng-model=vm.dataToFill.bank_name name=Bank ng-required=\"vm.dataToFill.fleet_type == \'2\'\" ng-class=\"{ \'has-error\': driverRegisterForm.Bank.$touched && driverRegisterForm.Bank.$invalid && vm.dataToFill.fleet_type == \'2\' }\"><option value=\"\" disabled selected>{{\'bankLabel\' | translate}}</option><option value={{bankName.bank_name}} ng-repeat=\"bankName in vm.driverBankNamesArray\">{{bankName.bank_name}}</option></select><div ng-if=\"driverEditForm.Bank.$touched|| submit\" ng-messages=driverEditForm.Bank.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'bankReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'bankValid\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"maxlength\">Maximum 6 characters are allowed.</div>--></div></div></div><div class=\"row mt5\" ng-if=\"vm.dataToFill.fleet_type != \'1\'\"><!-- <div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">\n                                            <label class=\"control-label\">{{\'accountTypeLabel\' | translate}}<span\n                                                    style=\"color:red\" ng-if=\"vm.dataToFill.fleet_type == \'2\'\">*</span></label>\n                                            <select class=\"form-control\" ng-model=\"vm.dataToFill.account_type\" name=\"accountType\" ng-required=\"vm.dataToFill.fleet_type == \'2\'\" ng-class=\"{ \'has-error\': driverEditForm.accountType.$touched && driverEditForm.accountType.$invalid }\">\n                                                <option value=\"\" disabled selected>{{\'accountTypeLabelSelect\' | translate}}</option>\n                                                <option value=\"1\">Electronic Cheque Book</option>\n                                                <option value=\"2\">Aaving Account</option>\n                                                <option value=\"3\">Checking Account</option>\n                                            </select>\n                                            <div ng-if=\"driverEditForm.accountType.$touched || submit\" ng-messages=\"driverEditForm.accountType.$error\">\n                                                <div class=\"errormessage text-danger\" ng-message=\"required\">{{\'accTypeReq\' | translate}}\n                                                </div>\n                                            </div>\n                                        </div> --><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=\"vm.dataToFill.registration_flag !=\'1\'\"><!--ng-if=\"vm.dataToFill.registration_flag != \'2\'\"--><label class=control-label>{{\'accountTypeLabel\' | translate}} <span style=color:red ng-if=\"vm.dataToFill.registration_flag == \'2\'\">*</span></label><input type=text class=form-control ng-model=vm.dataToFill.account_rut name=account_rut placeholder=\"{{\'accountTypeLabel\' | translate}}\" ng-rut ng-change=vm.rutChange2() ng-class=\"{ \'has-error\': driverRegisterForm.account_rut.$touched && driverRegisterForm.account_rut.$invalid }\"><div ng-if=\"driverRegisterForm.account_rut.$touched || submit\" ng-messages=driverRegisterForm.account_rut.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'rutRequired\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid RUT.</div>--></div><div class=\"errormessage text-danger\" ng-if=vm.rutFlag>{{\'rutValid\' | translate}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'accountNumberLabel\' | translate}}<span style=color:red ng-if=\"vm.dataToFill.fleet_type == \'2\'\">*</span></label><input type=text class=form-control ng-model=vm.dataToFill.account_number name=accountNumber placeholder=\"{{\'accountNumberLabel\' | translate}}\" ng-required=\"vm.dataToFill.fleet_type == \'2\'\" ng-class=\"{ \'has-error\': driverEditForm.accountNumber.$touched && driverEditForm.accountNumber.$invalid }\" pattern=^([0-9])*$><div ng-if=\"driverEditForm.accountNumber.$touched|| submit\" ng-messages=driverEditForm.accountNumber.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'accNumReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'accNumValid\' | translate}}</div></div></div></div><p class=\"basicRegistrationP backgroundBasicPending text-center mt10\">{{\'documentsHead\' | translate}}</p><div class=\"row mt5\"><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\"><img ng-src=\"{{ vm.driverDetails.fleet_image || \'assets/images/noImage.jpeg\'}}\" id=profilePic class=documentStyle><br><input id=documentUpload filestyle=\"\" type=file style=\"display: none\" image=image name={{vm.uploadName}} onchange=angular.element(this).scope().file_to_upload(this.files,this.name) onclick=\"this.value = null\" data-button-text=Single data-class-button=\"btn btn-default\" data-classinput=\"form-control inline\" nv-file-select=\"\" uploader=uploader><label class=\"control-label mt10\">{{\'profilePic\' | translate}}</label><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'PROFILE\')\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\" ng-if=\"vm.dataToFill.fleet_type != \'2\'\"><!--ng-if=\"vm.dataToFill.fleet_type !=\'2\'\"--> <img ng-src=\"{{ vm.driverDetails.RUT_image || \'assets/images/noImage.jpeg\'}}\" id=rutImage class=documentStyle><br><label class=\"control-label mt10\">{{\'rutLabel\' | translate}}<span style=color:red>*</span></label><button type=button class=\"btn btn-primary upload mt10\" ng-click=\"vm.clickTrigger($event,\'RUT\')\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\" ng-if=\"vm.dataToFill.fleet_type != \'2\'\"><!--ng-if=\"vm.dataToFill.fleet_type !=\'2\'\">--> <img ng-src=\"{{ vm.driverDetails.license_img || \'assets/images/noImage.jpeg\'}}\" id=licenseImage class=documentStyle><br><label class=\"control-label mt10\">{{\'vehicleImage\' | translate}}<span style=color:red>*</span></label><button type=button class=\"btn btn-primary upload mt10\" ng-click=\"vm.clickTrigger($event,\'LICENSE\')\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\" ng-if=\"vm.dataToFill.fleet_type != \'2\'\"><!--ng-if=\"vm.dataToFill.fleet_type !=\'2\'\"--> <img ng-src=\"{{ vm.driverDetails.life_sheet_img || \'assets/images/noImage.jpeg\'}}\" id=lifeSheet class=documentStyle><br><label class=\"control-label mt10\">{{\'lifeSheetImage\' | translate}}<span style=color:red>*</span></label><button type=button class=\"btn btn-primary upload mt10\" ng-click=\"vm.clickTrigger($event,\'LIFE_SHEET\')\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\" ng-if=\"vm.dataToFill.fleet_type != \'2\'\"><!--ng-if=\"vm.dataToFill.fleet_type !=\'2\'\"--> <img ng-src=\"{{ vm.driverDetails.antecents_certificate || \'assets/images/noImage.jpeg\'}}\" id=antecents class=documentStyle><br><label class=\"control-label mt10\">{{\'antcedentsImage\' | translate}}<span style=color:red>*</span></label><button type=button class=\"btn btn-primary upload mt10\" ng-click=\"vm.clickTrigger($event,\'ANTECENTS\')\">{{\'uploadButton\' | translate}}</button></div><!--<div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\">--><!--<img ng-src=\"{{ vm.driverDetails.company_identity_card || \'assets/images/noImage.jpeg\'}}\" id=\"companyIdentity\" class=\"documentStyle\" /><br/>--><!--<label class=\"control-label mt10\">Company Identity Card<span--><!--style=\"color:red\">*</span></label>--><!--<button type=\"button\" class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'COMPANY_IDENTITY_CARD\')\">Upload--><!--</button>--><!--</div>--><!--<div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\">--><!--<img ng-src=\"{{ vm.driverDetails.company_constitution || \'assets/images/noImage.jpeg\'}}\" id=\"constitution\" class=\"documentStyle\" /><br/>--><!--<label class=\"control-label mt10\">Company Constitution<span--><!--style=\"color:red\">*</span></label>--><!--<button type=\"button\" class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'CONSTITUTION\')\">Upload--><!--</button>--><!--</div>--><!--<div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\">--><!--<img ng-src=\"{{ vm.driverDetails.start_activities || \'assets/images/noImage.jpeg\'}}\" id=\"activity\" class=\"documentStyle\" /><br/>--><!--<label class=\"control-label mt10\">Activity Start<span--><!--style=\"color:red\">*</span></label>--><!--<button type=\"button\" class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'ACTIVITY\')\">Upload--><!--</button>--><!--</div>--><!--<div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\">--><!--<img ng-src=\"{{ vm.driverDetails.invoice_stamping || \'assets/images/noImage.jpeg\'}}\" id=\"invoice\" class=\"documentStyle\" /><br/>--><!--<label class=\"control-label mt10\">Stamping Invoice<span--><!--style=\"color:red\">*</span></label>--><!--<button type=\"button\" class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'INVOICE\')\">Upload--><!--</button>--><!--</div>--><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 text-center mt5\" ng-if=\"vm.dataToFill.fleet_type == \'2\'\"><img src=\"{{ vm.driverDetails.invoice_rut_image || \'assets/images/noImage.jpeg\'}}\" id=invoiceRUT class=documentStyle><br><!--<input id=\"documentUpload\" filestyle=\"\" type=\"file\" style=\"display: none;\" image=\"image\" name=\"{{vm.uploadinvoice_rut_image }}\" onchange=\"angular.element(this).scope().file_to_upload(this.files,this.name)\" onclick=\"this.value = null;\" data-button-text=\"Single\"--><!--data-class-button=\"btn btn-default\" data-classinput=\"form-control inline\" nv-file-select=\"\" uploader=\"uploader\" />--><label class=\"control-label mt10\">{{\'invoiceRut\' | translate}}</label><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'INVOICE_RUT\')\">{{\'uploadButton\' | translate}}</button></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><button class=\"btn btn-primary\" type=submit style=width:200px>{{\'submit\' | translate}}</button></div></div></div></form></div></div></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12 mt25\" ng-if=vm.carDetails.length><div class=basicDiv ng-if=\"vm.dataToFill.fleet_type != \'1\'\"><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'carDetailsHead\' | translate}}</p><div class=basicDetailsDiv><form name=driverCarEditForm ng-submit=\"submitCar=true;driverCarEditForm.$valid&&vm.editCarApi($index,carsData)\" novalidate autocomplete=off ng-repeat=\"carsData in vm.carDetails\"><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'vehicleLabel\' | translate}}<span style=color:red>*</span></label><ui-select ng-model=carsData.car_type name=carType{{$index}} required ng-class=\"{ \'has-error\': driverCarEditForm[\'carType\'+$index].$touched && driverCarEditForm[\'carType\'+$index].$invalid }\" close-on-select=true><ui-select-match placeholder=\"{{\'vehiclePlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in vm.vehicle | filter: $select.search\"><div ng-bind-html=data.name></div></ui-select-choices></ui-select><div ng-if=\"driverCarEditForm[\'carType\'+$index].$touched || submitCar\" ng-messages=\"driverCarEditForm[\'carType\'+$index].$error\"><div class=\"errormessage text-danger\" ng-message=required>{{\'vehicleReq\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'PPU\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=carsData.registration_number name=registrationNumber{{$index}} placeholder=\"{{\'PPU\' | translate}}\" required ng-class=\"{ \'has-error\': driverCarEditForm[\'registrationNumber\'+$index].$touched && driverCarEditForm[\'registrationNumber\'+$index].$invalid }\" pattern=^([A-Za-z]{2})([A-Za-z0-9]{2})([0-9]{2})*$ ng-minlength=3 ng-maxlength=8><!-- pattern=\"^[a-zA-Z0-9][a-zA-Z0-9-]*$\"--><div ng-if=\"driverCarEditForm[\'registrationNumber\'+$index].$touched|| submitCar\" ng-messages=\"driverCarEditForm[\'registrationNumber\'+$index].$error\"><div class=\"errormessage text-danger\" ng-message=required>{{\'registrationNumRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'registrationNumValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'registrationNumMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'registrationNumMaximum\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'workingFor24\' | translate}}<span style=color:red>*</span></label><select class=form-control ng-model=carsData.modelity name=modelityS{{$index}} required ng-class=\"{ \'has-error\': driverCarEditForm[\'modelityS\'+$index].$touched && driverCarEditForm[\'modelityS\'+$index].$invalid }\"><option value=\"\" disabled selected>{{\'selectModelityCar\' | translate}}</option><option value=1>Yes</option><option value=0>No</option></select><div ng-if=\"driverCarEditForm[\'modelityS\'+$index].$touched || submitCar\" ng-messages=\"driverCarEditForm[\'modelityS\'+$index].$error\"><div class=\"errormessage text-danger\" ng-message=required>{{\'selectModelityCarReq\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'workingStatus\' | translate}}<span style=color:red>*</span></label><select class=form-control ng-model=carsData.working_status name=workingStatus{{$index}} required ng-class=\"{ \'has-error\': driverCarEditForm[\'workingStatus\'+$index].$touched && driverCarEditForm[\'workingStatus\'+$index].$invalid }\"><option value=\"\" disabled selected>{{\'workingStatusPlaceholder\' | translate}}</option><option value=1>Active</option><option value=0>Inactive</option></select><div ng-if=\"driverCarEditForm[\'workingStatus\'+$index].$touched || submitCar\" ng-messages=\"driverCarEditForm[\'workingStatus\'+$index].$error\"><div class=\"errormessage text-danger\" ng-message=required>{{\'workingStatusReq\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Sociedad SAP <span style=color:red>*</span></label><select class=form-control ng-model=carsData.society_id name=societyId{{$index}} required ng-class=\"{ \'has-error\': driverCarEditForm[\'societyId\'+$index].$touched && driverCarEditForm[\'societyId\'+$index].$invalid }\" ng-options=\"data.society_id as data.name for data in vm.societies\"><option value=\"\" disabled selected>Sociedad SAP</option></select><div ng-if=\"driverCarEditForm[\'societyId\'+$index].$touched || submitCar\" ng-messages=\"driverCarEditForm[\'societyId\'+$index].$error\"><div class=\"errormessage text-danger\" ng-message=required>Favor seleccione Sociedad</div></div></div></div><!-- <div class=\"row mt5\">\n                                    <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\">\n                                        <label class=\"control-label mt10\">{{\'carImage\' | translate}}<span\n                                                style=\"color:red\">*</span></label><br/>\n                                        <img ng-src=\"{{ carsData.car_photo || \'assets/images/noImage.jpeg\'}}\" id=\"carImage{{$index}}\" class=\"documentStyle\" /><br/>\n                                        <button type=\"button\" class=\"btn btn-primary upload mt10\" ng-click=\"vm.clickTrigger($event,\'CAR_IMAGE\',$index)\">{{\'uploadButton\' | translate}}\n                                        </button>\n                                    </div>\n                                    <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\">\n                                        <label class=\"control-label mt10\">{{\'vehicleImage\' | translate}}<span\n                                                style=\"color:red\">*</span></label><br/>\n                                        <img ng-src=\"{{ carsData.registration_image || \'assets/images/noImage.jpeg\'}}\" id=\"registerImage{{$index}}\" class=\"documentStyle\" /><br/>\n                                        <button type=\"button\" class=\"btn btn-primary upload mt10\" ng-click=\"vm.clickTrigger($event,\'REGISTER_IMAGE\',$index)\">{{\'uploadButton\' | translate}}\n                                        </button>\n                                    </div>\n                                    <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6  mt5\">\n                                        <label class=\"control-label mt10\">{{\'travelCard\' | translate}}<span\n                                                style=\"color:red\">*</span></label><br/>\n                                        <img src=\"{{ carsData.travel_card_key || \'assets/images/noImage.jpeg\'}}\" id=\"travel{{$index}}\" class=\"documentStyle\" /><br/>\n                                        <button type=\"button\" class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'TRAVEL_CARD_KEY\',$index)\">\n                                            {{\'uploadButton\' | translate}}\n                                        </button>\n                                    </div>\n                                </div> --><div class=\"row mt5\"><!-- <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\">\n                                        <label class=\"control-label mt10\">{{\'passengerSeatInsurance\' | translate}}<span\n                                                style=\"color:red\">*</span></label><br/>\n                                        <img src=\"{{ carsData.passenger_insurance_key || \'assets/images/noImage.jpeg\'}}\" id=\"seatInsurance{{$index}}\" class=\"documentStyle\" /><br/>\n                                        <button type=\"button\" class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'PASSENGER_INSURANCE_KEY\',$index)\">\n                                            {{\'uploadButton\' | translate}}\n                                        </button>\n                                    </div> --><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\"><label class=\"control-label mt10\">{{\'circulationPermission\' | translate}}<span style=color:red>*</span></label><br><img src=\"{{ carsData.permission_of_circulation || \'assets/images/noImage.jpeg\'}}\" id=permission{{$index}} class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'PERMISSION_OF_CIRCULATION\',$index)\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\"><label class=\"control-label mt10\">Permiso Min. Transporte<!-- <span style=\"color:red\">*</span> --></label><br><img src=\"{{ carsData.transportation_permit || \'assets/images/noImage.jpeg\'}}\" id=transportation_permit{{$index}} class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event,\'TRANSPORTATION_PERMIT\',$index)\">{{\'uploadButton\' | translate}}</button></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><button class=\"btn btn-primary\" type=submit style=width:200px>{{\'submit\' | translate}}</button></div></div><div class=row ng-if=\"$index != vm.carDetails.length - 1\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><hr></div></div></form></div></div></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12 mt25\" ng-if=\"vm.carDetails.length == 0\"><div class=basicDiv ng-if=\"vm.dataToFill.fleet_type != \'1\'\"><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'carDetailsHead\' | translate}}</p><div class=basicDetailsDiv><form name=driverCarAddForm ng-submit=\"submitCar=true;driverCarAddForm.$valid&&vm.addCarApi()\" novalidate autocomplete=off><div ng-repeat=\"addCars in vm.dataToFill.addNewCar\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-right\"><a class=\"btn btn-sm blockIconColor\" title=\"Delete Vehicle\" ng-click=vm.deleteVehicleType($index) style=\"border: 1px solid red;margin-left:5px\" ng-if=\"vm.dataToFill.addNewCar.length > 1\"><i class=\"fa fa-trash\"></i> </a><a class=\"btn btn-sm editIconColor\" ng-click=vm.addVehicle($index) title=\"Add Vehicle\" style=\"border: 1px solid #7266ba;margin-left:5px\"><i class=\"fa fa-plus\"></i></a></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'vehicleLabel\' | translate}}<span style=color:red>*</span></label><ui-select ng-model=addCars.car_type name=carTypeAdd{{$index}} required ng-class=\"{ \'has-error\': driverCarAddFormF[\'carTypeAdd\'+$index].$touched && driverCarAddFormF[\'carTypeAdd\'+$index].$invalid }\" close-on-select=true><ui-select-match placeholder=\"{{\'vehiclePlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"data in vm.vehicle | filter: $select.search\"><div ng-bind-html=data.name></div></ui-select-choices></ui-select><div ng-if=\"driverCarAddFormF[\'carTypeAdd\'+$index].$touched || submitCar\" ng-messages=\"driverCarAddFormF[\'carTypeAdd\'+$index].$error\"><div class=\"errormessage text-danger\" ng-message=required>{{\'vehicleReq\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'PPU\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=addCars.registration_number name=registrationNumberAdd{{$index}} placeholder=\"{{\'PPU\' | translate}}\" required ng-class=\"{ \'has-error\': driverCarAddForm[\'registrationNumberAdd\'+$index].$touched && driverCarAddForm[\'registrationNumberAdd\'+$index].$invalid }\" pattern=^([A-Za-z]{2})([A-Za-z0-9]{2})([0-9]{2})*$ ng-minlength=3 ng-maxlength=8><!--pattern=\"^[a-zA-Z0-9][a-zA-Z0-9-]*$\"--><div ng-if=\"driverCarAddForm[\'registrationNumberAdd\'+$index].$touched|| submitCar\" ng-messages=\"driverCarAddForm[\'registrationNumberAdd\'+$index].$error\"><div class=\"errormessage text-danger\" ng-message=required>{{\'registrationNumRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'registrationNumValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'registrationNumMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'registrationNumMaximum\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'workingFor24\' | translate}}<span style=color:red>*</span></label><select class=form-control ng-model=addCars.modelity name=modelityAdd{{$index}} required ng-class=\"{ \'has-error\': driverCarAddForm[\'modelityAdd\'+$index].$touched && driverCarAddForm[\'modelityAdd\'+$index].$invalid }\"><option value=\"\" disabled selected>{{\'selectModelityCar\' | translate}}</option><option value=1>Yes</option><option value=0>No</option></select><div ng-if=\"driverCarAddForm[\'modelityAdd\'+$index].$touched || submitCar\" ng-messages=\"driverCarAddForm[\'modelityAdd\'+$index].$error\"><div class=\"errormessage text-danger\" ng-message=required>{{\'selectModelityCarReq\' | translate}}</div></div></div></div><div class=\"row mt5\"><!-- <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\">\n                                            <label class=\"control-label mt10\">{{\'carImage\' | translate}}<span style=\"color:red\">*</span></label><br/>\n                                            <img src=\'assets/images/noImage.jpeg\' id=\"addCarImage{{$index}}\" class=\"documentStyle\" /><br/>\n                                            <button type=\"button\" class=\"btn btn-primary upload mt10\" ng-click=\"vm.clickTrigger($event,\'ADD_CAR_IMAGE\',$index)\">{{\'uploadButton\' | translate}}\n                                            </button>\n                                        </div>\n                                        <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\">\n                                            <label class=\"control-label mt10\">{{\'vehicleImage\' | translate}}<span style=\"color:red\">*</span></label><br/>\n                                            <img src=\'assets/images/noImage.jpeg\' id=\"addRegisterImage{{$index}}\" class=\"documentStyle\" /><br/>\n                                            <button type=\"button\" class=\"btn btn-primary upload mt10\" ng-click=\"vm.clickTrigger($event,\'ADD_REGISTER_IMAGE\',$index)\">\n                                                {{\'uploadButton\' | translate}}\n                                            </button>\n                                        </div>\n                                        <div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6 mt5\">\n                                            <label class=\"control-label mt10\">{{\'passengerSeatInsurance\' | translate}}<span\n                                                    style=\"color:red\">*</span></label><br/>\n                                            <img src=\'assets/images/noImage.jpeg\' id=\"addSeatInsurance{{$index}}\" class=\"documentStyle\" /><br/>\n                                            <button type=\"button\" class=\"btn btn-primary upload mt10\" ng-click=\"vm.clickTrigger($event,\'ADD_PASSENGER_INSURANCE_KEY\',$index)\">\n                                                {{\'uploadButton\' | translate}}\n                                            </button>\n                                        </div>\n                                        <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\">\n                                            <label class=\"control-label mt10\">{{\'travelCard\' | translate}}<span\n                                                    style=\"color:red\">*</span></label><br/>\n                                            <img src=\'assets/images/noImage.jpeg\' id=\"addTravel{{$index}}\" class=\"documentStyle\" /><br/>\n                                            <button type=\"button\" class=\"btn btn-primary upload mt10\" ng-click=\"vm.clickTrigger($event,\'ADD_TRAVEL_CARD_KEY\',$index)\">\n                                                {{\'uploadButton\' | translate}}\n                                            </button>\n                                        </div> --><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\"><label class=\"control-label mt10\">{{\'circulationPermission\' | translate}}<span style=color:red>*</span></label><br><img src=assets/images/noImage.jpeg id=addPermission{{$index}} class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10\" ng-click=\"vm.clickTrigger($event,\'ADD_PERMISSION_OF_CIRCULATION\',$index)\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-6 mt5\"><label class=\"control-label mt10\">Permiso Min. Transporte<!-- <span style=\"color:red\">*</span> --></label><br><img src=assets/images/noImage.jpeg id=addTransportationPermit{{$index}} class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10\" ng-click=\"vm.clickTrigger($event,\'ADD_TRANSPORTATION_PERMIT\',$index)\">{{\'uploadButton\' | translate}}</button></div></div><div class=row ng-if=\"$index != vm.dataToFill.addNewCar.length - 1\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><hr></div></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><button class=\"btn btn-primary\" type=submit style=width:200px>{{\'submit\' | translate}}</button></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/auto-assign/autoAssign.html","<h2 class=ng-cloak><span>{{\'autoAssignHeader\' | translate}}</span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row ng-class=\"{\'display-none\': !vm.addNewGeoFenceToggle}\" id=showMap><!-- <div class=\"row\">\n                    <div class=\"col-lg-3 col-sm-6 col-md-3 col-xs-12\">\n                        <label class=\"control-label\">{{\'geoFilterLabel\' | translate}}</label>\n                        <select class=\"form-control\" ng-model=\"vm.filterData.geofenceStatus\" ng-change=\"vm.getAllBranches(vm.filterData.geofenceStatus)\">\n                            <option value=\"\" disabled selected>{{\'geoFilterPLaceholder\' | translate}}</option>\n                            <option value=\"1\">Active</option>\n                            <option value=\"0\">Inactive</option>\n                            <option value=\"2\">All</option>\n                        </select>\n                    </div>\n                </div> --><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12 mt5\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=padding:0px><div ng-if=vm.addFixedRouteGeofenceFlag ng-include=\"\'app/components/views/geofence/addSmallRegions.html\'\"></div><div ng-if=vm.editFixedRouteGeofenceFlag ng-include=\"\'app/components/views/geofence/editSmallRegions.html\'\"></div><div ng-if=vm.viewFixedRouteGeofenceFlag ng-include=\"\'app/components/views/geofence/viewSmallRegions.html\'\"></div></div></div></div><div class=\"col-lg-8 col-sm-8 col-md-8 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"margin: 9px 0px\"><button class=\"btn btn-primary pull-right\" ng-click=vm.removeGeoFenceFromMap() ng-disabled=\"vm.removeGeoFenceFromMapDisableButtonStatus || vm.viewFixedRouteGeofenceFlag\">Eliminar Poligono</button> <button class=\"btn btn-primary pull-right\" style=\"margin-right: 10px\" ng-click=vm.openMultipleGeofencePopup($event)>Mostrar otras zonas</button></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><input type=text class=form-control ng-model=vm.addressHave ng-change=vm.addressChange(vm.addressHave) id=addressGot placeholder=\"Enter Location\"></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5\"><div id=googleMap style=width:100%></div></div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=padding:0px><div class=basicDiv><p class=\"basicRegistrationP text-center\" style=\"color: black\"><!-- backgroundBasicPending --><!-- {{\'fixedGeoList\' | translate}} --> Total Geocercas : {{vm.mainBranchListForPopupCount || 0}} <button class=\"btn btn-primary pull-right\" style=\"margin-right: 7%\" ng-class=\"{\'display-none\': vm.addNewGeoFenceToggle}\" ng-click=vm.addNewGeoFence()>+Nueva Geocerca</button></p><div class=row style=margin:0px><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-if=vm.hideFilters><div class=\"col-lg-2 col-sm-6 col-md-2 col-xs-12\"><label class=control-label>{{\'geoFilterLabel\' | translate}}</label><select class=form-control ng-model=vm.filterData.geofenceStatus ng-change=\"vm.getAllBranches(vm.filterData.geofenceStatus, 0, vm.search, \'changeState\')\"><option value=\"\" disabled selected>{{\'geoFilterPLaceholder\' | translate}}</option><option value=1>{{\'active\' | translate}}</option><option value=0>{{\'inactivee\' | translate}}</option><option value=2>{{\'all\' | translate}}</option></select></div><div class=\"col-lg-3 col-sm-6 col-md-3 col-xs-12 input-group pt3\" style=\"padding-top: 23px !important\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-model-options=\"{ debounce: 500 }\" ng-change=vm.mainSearch(vm.search);></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive tableWithMasterDataParentDive\"><table class=\"table table-hover tableWithMasterData\"><thead><tr><th style=width:70px hidden>{{\'serialNumber\' | translate}}</th><th style=width:70px>{{\'serialNumber\' | translate}}</th><th style=width:100px>Sucursal</th><th style=width:100px>Nombre</th><!-- <th style=\"width:100px;\">{{\'airportZone\' | translate}}</th> --><th style=width:100px>{{\'stateTable\' | translate}}</th><th style=width:150px>{{\'action\' | translate}}</th><th style=width:150px>{{\'adminLogs\' | translate}}</th></tr></thead><tbody when-scrolled=vm.mainPaginationChangedForMultipleGeofence()><!-- | filter: vm.search --><tr ng-repeat=\"data in vm.tableFixedRouteList\"><td style=width:70px hidden>{{data.index+1}}</td><td style=width:70px>{{::data.auto_assignment_region_id}}</td><td style=width:100px>{{data.branch_name || data.parent.region_name}}</td><td style=width:100px>{{::data.region_name}}</td><!-- <td style=\"width:100px;\">\n                                                <span ng-if=\"data.isAirportService\">Yes</span>\n                                                <span ng-if=\"!data.isAirportService\">No</span>\n                                            </td> --><td style=width:100px><a class=\"cursor btn btn-sm\" ng-class=\"{\'blockIconColor\': data.is_active == 0, \'unblockIconColor\': data.is_active == 1}\" ng-click=vm.changeFixedRegionStatus(data,$event);><!--ng-click=\"vm.changeFixedRegionStatus(data,$event)\"--> <i ng-class=\"{\'fa fa-unlock\': data.is_active == 1,\'fa fa-lock\': data.is_active == 0}\"></i></a></td><td style=width:150px><a title=\"Edit Fixed route\" class=\"cursor editIconColor btn btn-sm\" ng-click=vm.editFixedRouteGeofence(data);vm.addNewGeoFence(1)><i class=\"fa fa-edit\"></i> </a><a title=\"View Fixed route\" class=\"cursor editIconColor btn btn-sm\" ng-click=vm.viewFixedRouteGeofence(data);vm.addNewGeoFence(2)><i class=\"fa fa-eye\"></i> </a><a title=\"Delete Branch\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteFixedRouteGeofence(data,$event);><i class=\"fa fa-trash\"></i> </a><!--<a class=\"btn btn-primary tableButton mt5\" ng-click=\"vm.editFixedRouteGeofence(data)\" title=\"Edit Fixed route\">Edit</a>--></td><td style=width:150px><a class=\"btn btn-primary tableButton\" title=\"{{\'adminLogs\' | translate}}\" ui-sref=\"layout.autoAssignMain.adminLogs({userId:\'{{data.auto_assignment_region_id}}\',type:\'29\',fakeType: \'31\'})\">{{\'adminLogs\' | translate}}</a></td></tr></tbody><tfoot ng-if=vm.noDataFlag><tr><th class=\"noDataClass text-center\">{{\'noFixedGeoFound\' | translate}}</th></tr></tfoot></table></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/auto-assign/autoAssignMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/booking-list/bookingDetailsNew.html","<style>/* .customTooltip {\n        position: relative;\n        display: inline-block;\n        margin: 0 5px;\n    } */\n    .customTooltip {\n        position: relative;\n    }\n\n    .customTooltip .tooltiptext {\n        visibility: hidden;\n        width: 200px;\n        box-shadow: -1px 3px 6px 0 rgba(0, 0, 0, 0.16);\n        background-color: white;\n        text-align: center;\n        padding: 20px;\n        position: absolute;\n        z-index: 1;\n        top: 30px;\n        right: 165px;\n        opacity: 0;\n        transition: opacity 0.3s;\n    }\n\n    .customTooltip .tooltiptext::after {\n        content: \"\";\n        position: absolute;\n        top: 35%;\n        right: -10%;\n        margin-top: -10px;\n        border-width: 13px;\n        border-style: solid;\n        border-color: transparent rgba(255, 255, 255, 0) transparent white;\n    }\n\n    .customTooltip:hover .tooltiptext {\n        visibility: visible;\n        opacity: 1;\n    }\n\n    .dropdown-menu {\n        width: 250px;\n        top: -50px;\n        left: -250px;\n        padding: 10px;\n        /* max-height: 120px; */\n        overflow: scroll;\n    }\n    .dropdown-menu h6{\n        margin: 0;\n        font-size: 14px;\n        color: #ef6837;\n    }\n    .dropdown-menu .extraDetails{\n        margin: 5px 0;\n    }\n    .dropdown-menu .extraDetails label{\n        margin: 0px;\n    }\n    .dropdown-menu .extraDetails p{\n       font-size: 12px;\n    }\n    .bookingButton {\n       color:#ef6730 !important;\n       border-color:#ef6730 !important;\n       padding: 6px 16px !important;\n    }</style><h2 class=ng-cloak><span ng-if=\"vm.typeFromParam == \'0\'\">{{\'upcomingBookingHead\' | translate}} / {{\'bookingDetailsHead\' | translate}}</span> <span ng-if=\"vm.typeFromParam == \'1\'\">{{\'ongoingBookingHead\' | translate}} / {{\'bookingDetailsHead\' | translate}}</span> <span ng-if=\"vm.typeFromParam == \'2\'\">{{\'completedBookingHead\' | translate}} / {{\'bookingDetailsHead\' | translate}}</span> <span ng-if=\"vm.typeFromParam == \'3\'\">{{\'searchBookingPage\' | translate}} / {{\'bookingDetailsHead\' | translate}}</span></h2><div class=\"container-fluid ng-cloak dropDetailsNew\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=driver><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button> <button class=\"btn btn-primary mb25\" ng-click=vm.vermapa() ng-disabled=\"vm.buttonmap==true\" style=\"margin-left: 65%\">Ver mapa</button><!--&lt;!&ndash;<a class=\"btn btn-primary mb25\" ui-sref=\"layout.completedBookingsMain.bookingSummary({id:\'{{vm.id}}\',type:\'3\'})\" style=\"background-color: #2f80e7;border-color:#2f80e7\">Booking Summary</a>&ndash;&gt;--><!--<a class=\"btn btn-primary mb25\" ng-click=\"vm.markNoShow(vm.bookingDetails,$event)\"--><!--ng-show=\"vm.bookingDetails.job_status == \'0\' || vm.bookingDetails.job_status == \'4\' || vm.bookingDetails.job_status == \'15\' || vm.bookingDetails.job_status == \'7\'\"--><!--style=\"background-color: #2f80e7;border-color:#2f80e7\">{{\'noShowLabel\' | translate}}</a>--><!--<a class=\"btn btn-primary mb25\" ng-click=\"vm.ShowPopUpForPush(vm.bookingDetails,$event)\"--><!--ng-if=\"vm.bookingDetails.job_status != \'2\' && vm.bookingDetails.job_status != \'3\' && vm.bookingDetails.job_status != \'9\' && vm.bookingDetails.job_status != \'8\'--><!--&& vm.bookingDetails.job_status != \'10\' && vm.bookingDetails.job_status != \'11\' \"--><!--style=\"background-color: #2f80e7;border-color:#2f80e7\">{{\'messageToClient\' | translate}}</a>--><!--&lt;!&ndash;<a class=\"btn btn-primary mb25\" ng-click=\"vm.manualAssignBooking(vm.bookingDetails,$event)\"&ndash;&gt;--><!--&lt;!&ndash;ng-show=\"vm.bookingDetails.job_status == \'0\' || vm.bookingDetails.job_status == \'7\' || vm.bookingDetails.job_status == \'4\'\"&ndash;&gt;--><!--&lt;!&ndash;style=\"background-color: #2f80e7;border-color:#2f80e7\">Reassign</a>&ndash;&gt;--><!--<a class=\"btn btn-primary mb25\" ng-click=\"vm.manualUnassignBooking(vm.bookingDetails,$event)\"--><!--ng-disabled=\"vm.bookingDetails.job_status != \'0\' && vm.bookingDetails.job_status != \'4\' && vm.bookingDetails.job_status != \'7\' && vm.bookingDetails.job_status != \'15\'\"--><!--style=\"background-color: #2f80e7;border-color:#2f80e7\">{{\'unassignButton\' | translate}}</a>--><!--<a class=\"btn btn-primary mb25\" ng-click=\"vm.validateAuthForCorrectFare(vm.bookingDetails,$event)\"--><!--ng-disabled=\"vm.bookingDetails.job_status != \'2\'\"--><!--style=\"background-color: #2f80e7;border-color:#2f80e7\">{{\'correctFare\' | translate}}</a>--><!--<a class=\"btn btn-primary mb25 pull-right\" ng-click=\"vm.sendVoucher(vm.bookingDetails,$event)\" style=\"background-color: #2f80e7;border-color:#2f80e7\">{{\'sendVoucher\' | translate}}</a>--><div class=\"dropdown dropdown-list pull-right\"><a data-toggle=dropdown class=\"dropdown-toggle barIcon\"><em class=\"fa fa-bars fa-2x\" id=bars></em></a><div class=\"dropdown-menu paddingZero listButtonDetails\"><ul class=\"logOutMargin oshj m0\"><li style=\"list-style: none\" ng-if=!vm.PetUser><div class=\"list-group m0\"><a class=list-group-item ng-class=\"{\'disabled\' : vm.bookingDetails.job_status != \'0\' && vm.bookingDetails.job_status != \'4\' && vm.bookingDetails.job_status != \'7\' && vm.bookingDetails.job_status != \'15\'}\" ng-click=\"vm.validateAuthForCorrectFare(vm.bookingDetails,$event,\'Unassign\')\">{{\'unassignButton\' | translate}}</a></div></li><li style=\"list-style: none\" ng-if=!vm.PetUser><div class=\"list-group m0\"><a class=list-group-item ng-class=\"{\'disabled\' : vm.bookingDetails.job_status != \'0\' && vm.bookingDetails.job_status != \'4\' && vm.bookingDetails.job_status != \'7\' && vm.bookingDetails.job_status != \'15\'}\" ng-click=\"vm.validateAuthForCorrectFare(vm.bookingDetails,$event,\'No Show\')\">{{\'noShowLabel\' | translate}}</a></div></li><li style=\"list-style: none\" ng-if=!vm.PetUser><div class=\"list-group m0\"><a class=list-group-item ng-class=\"{\'disabled\' : vm.bookingDetails.job_status != \'2\'}\" ng-click=\"vm.validateAuthForCorrectFareNew(vm.bookingDetails,$event,\'Adjust Fare\' , \'Adjustar reserva en efectivo\')\">{{\'correctFare\' | translate}}</a></div></li><li style=\"list-style: none\"><div class=\"list-group m0\"><a class=list-group-item ng-class=\"{\'disabled\': vm.bookingDetails.job_status == \'3\' || vm.bookingDetails.job_status == \'9\'\n                                     || vm.bookingDetails.job_status == \'8\' || vm.bookingDetails.job_status == \'10\' || vm.bookingDetails.job_status == \'11\' || vm.bookingDetails.job_status == \'12\'}\" ng-click=\"vm.validateAuthForCorrectFare(vm.bookingDetails,$event,\'Ver voucher\')\">Ver Voucher</a></div></li><li style=\"list-style: none\"><div class=\"list-group m0\"><a class=list-group-item ng-click=vm.downloadVocher(vm.bookingDetails)>Descargar Voucher</a> <a id=downloadVocher hidden></a></div></li><li style=\"list-style: none\"><div class=\"list-group m0\"><a class=list-group-item ng-click=vm.copy(vm.bookingDetails)>Copiar Resumen</a></div></li><li style=\"list-style: none\"><div class=\"list-group m0\"><a class=list-group-item ng-class=\"{\'disabled\': vm.bookingDetails.job_status == \'3\' || vm.bookingDetails.job_status == \'9\'\n                                     || vm.bookingDetails.job_status == \'8\' || vm.bookingDetails.job_status == \'10\' || vm.bookingDetails.job_status == \'11\' || vm.bookingDetails.job_status == \'12\'}\" ng-click=\"vm.validateAuthForCorrectFare(vm.bookingDetails,$event,\'Enviar voucher\')\">{{\'sendVoucher\' | translate}}</a></div></li><li style=\"list-style: none\"><div class=\"list-group m0\"><a class=list-group-item ng-class=\"{\'disabled\': vm.bookingDetails.job_status == \'2\' || vm.bookingDetails.job_status == \'3\' || vm.bookingDetails.job_status == \'9\'\n                                     || vm.bookingDetails.job_status == \'8\' || vm.bookingDetails.job_status == \'10\' || vm.bookingDetails.job_status == \'11\' || vm.bookingDetails.job_status == \'12\'}\" ng-click=\"vm.validateAuthForCorrectFare(vm.bookingDetails,$event,\'Message To Client\')\">{{\'messageToClient\' | translate}}</a></div></li><li style=\"list-style: none\"><div class=\"list-group m0\"><a class=list-group-item ng-class=\"{\'disabled\' : vm.bookingDetails.job_status != \'2\'}\" ng-click=\"vm.validateAuthForCorrectAgreement(vm.bookingDetails,$event,\'Ajuste Convenio\')\">{{\'AdjustAgreement\' | translate}}</a></div></li></ul></div></div></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=\"basicDiv col-lg-12 col-xs-12 col-sm-12 col-md-12 nopadding\"><div class=\"basicRegistrationP backgroundBasicPending col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=gridBox><div>{{\'bookingId\' | translate}}: #{{::vm.bookingDetails.job_id}}</div><div>{{\'status\' | translate}} : <span ng-if=\"vm.bookingDetails.job_status == \'0\'\">{{\'upcomingStatus\' | translate}}</span> <span ng-if=\"vm.bookingDetails.job_status == \'1\'\">Viaje Iniciado</span> <span ng-if=\"vm.bookingDetails.job_status == \'2\'\">Completada</span> <span ng-if=\"vm.bookingDetails.job_status == \'3\'\">Failed</span> <span ng-if=\"vm.bookingDetails.job_status == \'4\'\">En Posición</span> <span ng-if=\"vm.bookingDetails.job_status == \'5\'\">Partial</span> <span ng-if=\"vm.bookingDetails.job_status == \'6\'\">No Asignada</span> <span ng-if=\"vm.bookingDetails.job_status == \'17\'\">Pendiente de Aceptación</span> <span ng-if=\"vm.bookingDetails.job_status == \'7\'\">Accepted</span> <span ng-if=\"vm.bookingDetails.job_status == \'8\'\">Rejected</span> <span ng-if=\"vm.bookingDetails.job_status == \'9\'\">Cancelada</span> <span ng-if=\"vm.bookingDetails.job_status == \'10\'\">Deleted</span> <span ng-if=\"vm.bookingDetails.job_status == \'11\'\">Ignored</span> <span ng-if=\"vm.bookingDetails.job_status == \'12\'\">No Show</span> <span ng-if=\"vm.bookingDetails.job_status == \'15\'\">En Camino</span></div><div>{{\'fairType\' | translate}} : {{vm.bookingDetails.route_type == 1 ? \'Fija\' : \'Variable\'}}</div><div>{{\'tripType\' | translate}} : {{::vm.bookingDetails.type_of_trip}}</div><!--<div class=\"\">--><!--{{\'paymentAmount\' | translate}} : ${{vm.bookingDetails.newPaymentTotal || \'0\'}}<br/><span--><!--ng-if=\"vm.bookingDetails.reasonsForCorrection.length\">({{\'adjusted\' | translate}})</span>--><!--</div>--></div><!--<div class=\"col-lg-3 col-sm-3 col-xs-3 col-md-3\">--><!--{{\'bookingId\' | translate}}: #{{::vm.bookingDetails.job_id}}--><!--</div>--><!--<div class=\"col-lg-3 col-sm-3 col-xs-3 col-md-3\">--><!--{{\'status\' | translate}} :--><!--<sapn ng-if=\"vm.bookingDetails.job_status == \'0\'\">Upcoming</sapn>--><!--<sapn ng-if=\"vm.bookingDetails.job_status == \'1\'\">Viaje Iniciado</sapn>--><!--<sapn ng-if=\"vm.bookingDetails.job_status == \'2\'\">Ended</sapn>--><!--<sapn ng-if=\"vm.bookingDetails.job_status == \'3\'\">Failed</sapn>--><!--<sapn ng-if=\"vm.bookingDetails.job_status == \'4\'\">En Posición</sapn>--><!--<sapn ng-if=\"vm.bookingDetails.job_status == \'5\'\">Partial</sapn>--><!--<sapn ng-if=\"vm.bookingDetails.job_status == \'6\'\">Unassigned</sapn>--><!--<sapn ng-if=\"vm.bookingDetails.job_status == \'7\'\">Accepted</sapn>--><!--<sapn ng-if=\"vm.bookingDetails.job_status == \'8\'\">Rejected</sapn>--><!--<sapn ng-if=\"vm.bookingDetails.job_status == \'9\'\">Cancel</sapn>--><!--<sapn ng-if=\"vm.bookingDetails.job_status == \'10\'\">Deleted</sapn>--><!--<sapn ng-if=\"vm.bookingDetails.job_status == \'11\'\">Ignored</sapn>--><!--<sapn ng-if=\"vm.bookingDetails.job_status == \'12\'\">No Show</sapn>--><!--<sapn ng-if=\"vm.bookingDetails.job_status == \'15\'\">En Camino</sapn>--><!--</div>--><!--<div class=\"col-lg-3 col-sm-3 col-xs-3 col-md-3\">--><!--Type fare : {{vm.bookingDetails.route_type == 1 ? \'Fixed\' : \'Variable\'}}--><!--</div>--><!--<div class=\"col-lg-3 col-sm-3 col-xs-3 col-md-3\">--><!--Payment Amount : ${{vm.bookingDetails.newPaymentTotal || \'0\'}}<br/><span ng-if=\"vm.bookingDetails.reasonsForCorrection.length\">(Adjusted)</span>--><!--</div>--><!--<span>--><!--</span>--><!--<span class=\"pull-right\">--><!--{{vm.bookingDetails.creation_datetime | date:\'medium\'}}--><!--</span>--></div><div class=\"basicRegistrationP backgroundBasicPending col-lg-12 col-xs-12 col-sm-12 col-md-12 mt5\"><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 paddingZero\">Metodo de Pago: {{vm.bookingDetails.payment_method_name}}</div><div class=\"col-lg-3 col-sm-3 col-xs-12 col-md-3 paddingZero\">Total del Viaje: ${{vm.bookingDetails.newPaymentTotal || \'0\'}} <span ng-if=vm.bookingDetails.reasonsForCorrection.length>({{\'adjusted\' | translate}})</span></div><div class=\"col-lg-3 col-sm-3 col-xs-12 col-md-3 paddingZero\"><span ng-if=\"vm.bookingDetails.payment_status == 0\">NO PAGADA</span> <span ng-if=\"vm.bookingDetails.payment_status == 1\">PAGADA</span> <span ng-if=\"vm.bookingDetails.payment_status == 2\">PAGADA</span></div></div><div class=\"basicDetailsDiv col-lg-12 col-xs-12 col-sm-12 col-md-12 nopadding\"><section class=\"col-lg-12 col-sm-12 col-xs-12 col-sm-12 pickDrop nopadding\"><div class=\"basicRegistrationP backgroundBasicPending col-lg-12 col-xs-12 col-sm-12 col-md-12 nopadding\">{{\'pickDelivery\' | translate}}</div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12 nopadding\"><div class=\"col-lg-6 col-md-6 col-xs-6 col-sm-6\"><p><b>{{\'agreementLabel\' | translate}}:</b> <span data-testid=convenio>{{vm.bookingDetails.new_contract_name ?vm.bookingDetails.new_contract_name :vm.bookingDetails.contract_name}}</span></p><p><b>{{\'pickPerson\' | translate}}: </b><span data-testid=pasajero_nb>{{vm.bookingDetails.job_pickup_name || \'--\'}}<span></span></span></p><p><b>{{\'pickPersonPhone\' | translate}}:</b> <span data-testid=pasajero_fono>{{vm.bookingDetails.customer_country_code?vm.bookingDetails.job_pickup_phone:vm.bookingDetails.customer_country_code + vm.bookingDetails.job_pickup_phone || \'--\'}}</span></p><p><b>{{\'pickPersonEmail\' | translate}}: </b><span data-testid=pasajero_email>{{::vm.bookingDetails.job_pickup_email}}</span></p><p><b>{{\'VIP_Passenger\' | translate}}: </b><span data-testid=pasajero_vip>{{vm.bookingDetails.is_vip == 1 ? \'Si\' : \'No\'}}</span></p><p><b>{{\'pickTime\' | translate}}: </b><!--{{vm.bookingDetails.job_pickup_datetime | date:\'medium\'}}--> <span data-testid=fecha_recogida>{{vm.changeDateIntoSpanish(vm.bookingDetails.job_time_utc)}} {{vm.bookingDetails.job_time_utc | date:\'HH:mm:ss\'}}</span></p><p><b>Fecha Presentación: </b><!--{{vm.bookingDetails.job_pickup_datetime | date:\'medium\'}}--> <span data-testid=fecha_presentacion>{{vm.changeDateIntoSpanish(vm.bookingDetails.job_delivery_datetime)}} {{vm.bookingDetails.job_delivery_datetime | date:\'HH:mm\'}}</span></p><p ng-if=\"vm.tempPickFlag == true\"><b>{{\'tempPickTime\' | translate}}: </b><!--{{vm.bookingDetails.job_pickup_datetime | date:\'medium\'}}--> <span data-testid=fecha_recogida_paquete>{{vm.bookingDetails.temp_pickup_time | date:\'medium\'}}</span></p><p><b>{{\'pickUpAddressB\' | translate}}:</b> <span data-testid=direccion_retiro>{{::vm.bookingDetails.job_pickup_address}}</span></p><p><b>{{\'pickReferencePoint\' | translate}}: </b><span data-testid=direccion_reco>{{vm.bookingDetails.reference_point || \'--\'}}</span></p><p><b>{{\'requestedAddress\' | translate}}: </b><span data-testid=direccion_destino>{{::vm.bookingDetails.job_address}}</span></p><p><b>{{\'actualAddress\' | translate}}: </b><span data-testid=direccion_real>{{::vm.bookingDetails.actual_job_address}}</span></p><p ng-if=\"vm.bookingDetails.route_type == 1\"><b>{{\'stretchName\' | translate}}: <span data-testid=tramo></span></b> {{vm.bookingDetails.route_details.route_name || \'--\'}}</p></div><div class=\"col-lg-5 col-md-5 col-xs-5 col-sm-5\"><p><b>{{\'passengersCount\' | translate}}:</b> <span data-testid=cantidad_pasajeros>{{::vm.bookingDetails.number_of_passangers}}</span></p><p><b>{{\'typeofServiceBooking\' | translate}}:</b> <span data-testid=servicio>{{::vm.bookingDetails.service_name}}</span></p><p><b>{{\'autRequired\' | translate}}:</b> <span data-testid=requiere_auth>{{vm.bookingDetails.auth_required == 0 ? \'No\' : \'Yes\'}}</span></p><p ng-if=\"vm.bookingDetails.auth_required == 1\"><b>{{\'authGiven\' | translate}}: </b><span ng-if=\"vm.bookingDetails.is_auth == 1\" data-testid=estado_auth>Authorized</span> <span ng-if=\"vm.bookingDetails.is_auth == 2\" data-testid=estado_auth>Rejected</span> <span ng-if=\"vm.bookingDetails.is_auth == 3\" data-testid=estado_auth>Cancelled By Customer</span> <span ng-if=\"vm.bookingDetails.is_auth == 0\" data-testid=estado_auth>Pending</span><!--{{vm.bookingDetails.is_auth == 0 ? \'Pending\' : \'Approved\'}}--></p><p ng-if=\"vm.bookingDetails.auth_required == 1\"><b>{{\'authGivenDate\' | translate}}:</b> <span data-testid=fecha_auth>{{vm.bookingDetails.auth_timing | date:\'medium\'}}</span></p><p ng-if=\"vm.bookingDetails.auth_required == 1\"><b>{{\'authName\' | translate}}: </b><span data-testid=nombre_auth>{{::vm.bookingDetails.autherizer_name}}</span></p><p><b>{{\'bookingFor\' | translate}}: </b><span data-testid=reserva_para>{{vm.bookingDetails.booking_for == 0 ?\'Para mi\':\'Para alguien más\'}}</span></p><!--<p><b>{{\'roundTrip\' | translate}}:</b> {{vm.bookingDetails.is_round_trip == 0 ? \'No\' : \'Yes\' }}</p>--><p><b>Ida y Vuelta:</b> <span ng-if=\"vm.bookingDetails.is_round_trip > 0\" data-testid=ida_vuelta>Si, {{vm.bookingDetails.is_wait_time_included == 0 ? \'sin espera\' : \'con espera\' }} </span><span ng-if=\"vm.bookingDetails.is_round_trip == 0\" data-testid=ida_vuelta>No</span></p><p ng-if=\"vm.bookingDetails.is_round_trip > 0 && vm.bookingDetails.is_wait_time_included == 0\"><b>Reserva Regreso:</b> <span data-testid=job_child>#{{vm.bookingDetails.round_trip_child_job_id || \'0\'}}</span></p><!--<p ng-if=\"vm.bookingDetails.is_round_trip == 1\"><b>{{\'returnDateTime\' | translate}}:</b>{{vm.bookingDetails.return_date_time_utc | date:\'medium\'}}</p>--><p ng-if=\"vm.bookingDetails.is_round_trip == 1 && vm.bookingDetails.is_wait_time_included == 0\"><b>Fecha & Hora Regreso:</b> <span data-testid=fecha_regreso>{{vm.bookingDetails.return_date_time_utc | date:\'dd/MM/yyyy HH:mm\'}} hrs</span></p><p><b>{{\'sharedGrouped\' | translate}}: </b><span ng-if=\"data.booking_type == null\" data-testid=compartido-agrupado>--</span> <span ng-if=\"data.booking_type == 0\" data-testid=compartido-agrupado>Normal</span> <span ng-if=\"data.booking_type == 1\" data-testid=compartido-agrupado>Shared</span> <span ng-if=\"data.booking_type == 2\" data-testid=compartido-agrupado>Grouped</span></p><p><b>{{\'packageId\' | translate}}: </b><span data-testid=numero_paquete>{{vm.bookingDetails.shared_service_id || \'--\'}}</span></p><p><b ng-if=\"vm.bookingDetails.is_routing == 1\">Método Rango Recogida: </b><span ng-if=\"vm.bookingDetails.is_routing == 1\" data-testid=metodo_recogida>ROUTING</span></p><p ng-if=\"vm.bookingDetails.flight_number != null\"><b>{{\'flightNumber\' | translate}}: </b><span data-testid=numero_vuelo>{{::vm.bookingDetails.flight_number }}</span></p><p ng-if=\"vm.bookingDetails.airline != null\"><b>{{\'airline\' | translate}}: </b><span data-testid=aerolinea>{{::vm.bookingDetails.airline }}</span></p><p ng-if=\"vm.bookingDetails.flight_type != null\"><b>{{\'flightType\' | translate}}: </b><span ng-if=\"vm.bookingDetails.flight_type == \'I\' \" data-testid=tipo_vuelo>International</span> <span ng-if=\"vm.bookingDetails.flight_type == \'N\' \" data-testid=tipo_vuelo>National</span></p><p ng-if=\"vm.bookingDetails.flight_date != null\"><b>{{\'flightDate\' | translate}}: </b><span data-testid=fecha_vuelo>{{::vm.bookingDetails.flight_date | date:\'dd MMM yyyy, HH:mm\'}}</span></p></div><div class=\"col-lg-1 col-md-1 col-xs-1 col-sm-1\"><span class=pull-right ng-if=\"vm.bookingDetails.is_vip && vm.bookingDetails.is_vip == 1\"><p class=vipCUstomerDetail data-testid=is_vip>VIP</p></span></div></div><div ng-if=\"vm.mapshow == true\" class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 nopadding\" ng-class=\"{\'whirl duo\' : vm.loading2 }\"><div id=googleMapBookingDetails style=width:100%;height:650px></div><div class=showMapEvents><label><input type=checkbox ng-model=vm.showAllEvents ng-click=vm.checkForEvents(vm.showAllEvents)>&nbsp;&nbsp;{{\'viewEvents\' | translate}}</label></div><div class=showMapParticularLocation><input class=controls ng-change=vm.getSearchedAddress(vm.searchedAddress) type=text ng-model=vm.searchedAddress style=color:#000;width:220px;height:35px placeholder=\"{{\'searchLocationPlaceholder\' | translate}}\" domain={{vm.domain}} google-place callback-fn=vm.ctrlFn(data)></div></div></section><section ng-if=vm.bookingDetails.is_telephonica class=\"col-lg-12 col-sm-12 col-xs-12 col-sm-12 driverDetails nopadding\"><div class=\"basicRegistrationP backgroundBasicPending col-lg-12 col-xs-12 col-sm-12 col-md-12 nopadding\" style=\"margin-bottom: 0px\">Detalle tramos ({{vm.bookingDetails.section_details.length}})</div><div class=\"col-lg-12 col-md-12 col-xs-12 col-sm-12 nopadding\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 60px\">Tramo</th><th>Origen Planificado</th><th>Destino Planificado</th><th>Fecha hora Origen</th><th>Fecha hora Termino</th><th>Kms Recorridos GPS</th><th>Datos Pasajero</th></tr></thead><tbody ng-if=vm.showAllBookings><tr ng-repeat=\"items in vm.bookingDetails.section_details\"><td>{{items.section_id}}</td><td>{{items.job_pickup_address}}</td><td>{{items.job_dropoff_address}}</td><td>{{items.job_pickup_datetime | date:\'dd-MMM-yyyy HH:mm\'}}</td><td>{{items.job_dropoff_datetime | date:\'dd-MMM-yyyy HH:mm\'}}</td><td>{{items.total_distance_travelled}}</td><!-- <td class=\"customTooltip\">\n                                                    <button class=\"btn btn-primary bookingButton\" type=\"button\">Ver\n                                                        Detalle</button>\n                                                    <div class=\"tooltiptext\">\n                                                        <h6>Datos Pasajeros</h6>\n                                                        <div class=\"extraDetails\">\n                                                        <label>Nombre Pasajero:</label>\n                                                        <p>{{items.customer_username}}</p>\n                                                        </div>\n                                                        <div class=\"extraDetails\">\n                                                        <label>Rut Pasajero:</label>\n                                                        <p>{{items.customer_username}}</p>\n                                                        </div>\n                                                        <div class=\"extraDetails\">\n                                                        <label>Tipo Pasajero</label>\n                                                        <p>{{items.customer_username}}</p>\n                                                        </div>\n                                                    </div>\n\n                                                </td> --><td class=dropdown><button class=\"btn btn-primary bookingButton\" data-toggle=dropdown type=button><i class=\"fa fa-user-o\" aria-hidden=true></i> Ver Detalle</button><div class=dropdown-menu><h6>Datos Pasajeros</h6><div class=extraDetails><label>Nombre Pasajero:</label><p>{{items.customer_username}}</p></div><div class=extraDetails><label>Rut Pasajero:</label><p>{{items.RUT}}</p></div><div class=extraDetails><label>Tipo Pasajero:</label><p>{{items.customer_type}}</p></div></div></td></tr></tbody><tbody ng-if=!vm.showAllBookings><tr ng-repeat=\"items in vm.onlyShowThreeBookings\"><td>{{items.section_id}}</td><td>{{items.job_pickup_address}}</td><td>{{items.job_dropoff_address}}</td><td>{{items.job_pickup_datetime | date:\'dd-MMM-yyyy HH:mm\'}}</td><td>{{items.job_dropoff_datetime | date:\'dd-MMM-yyyy HH:mm\'}}</td><td>{{items.total_distance_travelled}}</td><td class=dropdown><button class=\"btn btn-primary bookingButton\" data-toggle=dropdown type=button><i class=\"fa fa-user-o\" aria-hidden=true></i> Ver Detalle</button><div class=dropdown-menu><h6>Datos Pasajeros</h6><div class=extraDetails><label>Nombre Pasajero:</label><p>{{items.customer_username}}</p></div><div class=extraDetails><label>Rut Pasajero:</label><p>{{items.RUT}}</p></div><div class=extraDetails><label>Tipo Pasajero:</label><p>{{items.customer_type}}</p></div></div></td></tr></tbody></table><div class=text-center ng-if=\"vm.bookingDetails.section_details.length > 3\"><!-- ng-if=\"vm.bookingDetails.section_details.length > 3 && vm.showAllBookings\" --> <button ng-if=!vm.showAllBookings class=\"btn btn-primary backgroundBasicPending\" type=button ng-click=vm.showMore()>Ver m&aacute;s tramos</button> <button ng-if=vm.showAllBookings class=\"btn btn-primary backgroundBasicPending\" type=button ng-click=vm.showLess()>Ver menos secciones</button></div></div></section><section class=\"col-lg-12 col-sm-12 col-xs-12 col-sm-12 driverDetails nopadding\"><div class=\"basicRegistrationP backgroundBasicPending col-lg-12 col-xs-12 col-sm-12 col-md-12 nopadding\">{{\'driverDetailsHead\' | translate}}</div><div class=\"col-lg-6 col-md-6 col-xs-6 col-sm-6 nopadding\"><div class=\"col-lg-8 col-md-8 col-xs-12 col-sm-8\"><p><b>{{\'uniqueNumber\' | translate}}:</b> <span data-testid=nro_vehiculo>#{{vm.bookingDetails.uniqueNo || \'--\'}}</span></p><p><b>{{\'vehiclePPU\' | translate}}:</b> <span data-testid=patente_vehiculo>{{vm.bookingDetails.vehicle_ppu || \'--\'}}</span></p><p><b>{{\'vehicleTypeLabel\' | translate}}:</b> <span data-testid=tipo_vehiculo>{{vm.bookingDetails.carName || \'--\'}}</span></p></div><div class=\"col-lg-4 col-md-4 col-xs-12 col-sm-4\"><img src={{vm.bookingDetails.car_photo}} alt=\"{{\'Car Image\' | translate}}\" title=\"{{\'Car Image\' | translate}}\" style=width:100px;height:100px data-testid=imagen_vehiculo></div></div><div class=\"col-lg-6 col-md-6 col-xs-6 col-sm-6 nopadding\"><div class=\"col-lg-8 col-md-8 col-xs-12 col-sm-8\"><p><b>{{\'name\' | translate}}:</b> <span data-testid=nb_conductor>{{((vm.bookingDetails.fleet_first_name || \'--\') +\'\'+(vm.bookingDetails.fleet_last_name || \'--\')) || \'--\'}}</span></p><p><b>{{\'mobileNumber\' | translate}}:</b> <span data-testid=numero_conductor>{{((vm.bookingDetails.fleet_country_code || \'--\') +\'\'+(vm.bookingDetails.fleet_phone_number || \'--\')) || \'--\'}}</span></p><p><b>{{\'driverRating\' | translate}}:</b> <span data-testid=calificacion_conductor>{{vm.bookingDetails.fleet_rating}}</span></p><p><b>{{\'driverComment\' | translate}}:</b> <span data-testid=comentario_conductor>{{vm.bookingDetails.fleet_comment || \'--\'}}</span></p></div><div class=\"col-lg-4 col-md-4 col-xs-12 col-sm-4\"><img src={{vm.bookingDetails.fleet_image}} alt=\"Imagen Conductor\" title=\"Imagen Conductor\" style=width:100px;height:100px data-testid=imagen_conductor></div></div></section><!--<pre>{{vm.bookingDetails}}</pre>--><section class=\"col-lg-12 col-sm-12 col-xs-12 col-sm-12 paymentDetails nopadding\"><div class=\"basicRegistrationP backgroundBasicPending col-lg-12 col-xs-12 col-sm-12 col-md-12 nopadding\">{{\'paymentDetails\' | translate}}</div><div class=\"col-lg-8 col-md-8 col-xs-12 col-sm-12\"><!--<pre>{{vm.bookingDetails}}</pre>--><table class=\"table table-bordered\"><thead><tr><th width=43%></th><th width=17%>{{\'quantity\' | translate}}</th><th width=20%>{{\'unitValue\' | translate}}</th><th width=20%>{{\'total\' | translate}}</th></tr></thead><tbody><tr ng-if=\"vm.bookingDetails.route_type == 0\"><td>{{\'baseFareLabel\' | translate}}: $</td><td>-</td><td ng-if=\"vm.bookingDetails.shared_service_id != null\" data-testid=tarifa_base>$ {{vm.bookingDetails.route_details.baseFareProrated || 0}}</td><td ng-if=\"vm.bookingDetails.shared_service_id != null\" data-testid=tarifa_base>$ {{vm.bookingDetails.route_details.baseFareProrated || 0}}</td><td ng-if=\"vm.bookingDetails.shared_service_id == null\" data-testid=tarifa_base>$ {{vm.bookingDetails.route_details.baseFare || 0}}</td><td ng-if=\"vm.bookingDetails.shared_service_id == null\" data-testid=tarifa_base>$ {{vm.bookingDetails.route_details.baseFare || 0}}</td></tr><tr ng-if=\"vm.bookingDetails.route_type == 0\"><td>{{\'kmFareLabel\' | translate}}: $</td><td data-testid=km_distancia>{{vm.bookingDetails.total_distance_travelled_updated ? vm.bookingDetails.total_distance_travelled_updated : vm.bookingDetails.apply_estimated_distance_variable_fare ? vm.estimated_distanceRounded : vm.bookingDetails.total_distance_travelled || 0.00}} km</td><td data-testid=valor_km_distancia>{{vm.bookingDetails.route_details.perKMChanges || 0}} / km</td><td data-testid=valor_total_distancia>$ {{vm.perKMChanges_new|| 0}}</td></tr><!--{{((vm.bookingDetails.wait_time / 60).toString()).split(\".\")[0]}}--><!--{{((vm.bookingDetails.wait_time / 60).toString()).split(\".\")}}--><tr ng-if=\"vm.bookingDetails.route_type == 0\"><td>{{\'fareWait\' | translate}}: $</td><td data-testid=tiempo_espera_inicial>{{vm.bookingDetails.total_wait_time || 0}} min</td><td data-testid=valor_espera_inicial>{{vm.bookingDetails.route_details.waitTimeCharges || 0}} / min</td><td data-testid=total_espera_inicial>$ {{(vm.bookingDetails.total_wait_time * vm.bookingDetails.route_details.waitTimeCharges)|| 0}}</td></tr><tr ng-if=\"vm.bookingDetails.route_type == 0\"><td>{{\'fareTrip\' | translate}}: $</td><td data-testid=tiempo_espera_viaje>{{vm.bookingDetails.wait_time}} min</td><td data-testid=valor_espera_viaje>{{vm.bookingDetails.route_details.waitTimeInTrip || 0}} / min</td><td data-testid=total_espera_viaje>$ {{((vm.bookingDetails.wait_time) >= 1 ? ((vm.bookingDetails.wait_time)* vm.bookingDetails.route_details.waitTimeInTrip): 0 ) || 0}}</td></tr><tr ng-if=\"vm.bookingDetails.route_type == 0\"><td>Total {{\'timeOfTripPrice\' | translate}}: $</td><td data-testid=minutos_tiempo_viaje>{{vm.total_time_travelled_new}} min</td><td data-testid=valor_tiempo_viaje>{{vm.bookingDetails.route_details.time_of_trip_price || 0}} / min</td><td data-testid=total_tiempo_viaje>$ {{((vm.total_time_travelled_new) >= 1 ? ((vm.total_time_travelled_new)* vm.bookingDetails.route_details.time_of_trip_price): 0 ) || 0}}</td></tr><tr ng-if=\"vm.bookingDetails.route_type == 0\"><td>{{\'minimumFare\' | translate}}: $ <span ng-if=\"vm.bookingDetails.route_details.minimumFare > ((vm.bookingDetails.subTotalFare) + (vm.bookingDetails.item_of_charge_amount?vm.bookingDetails.item_of_charge_amount:0))\"><b>(Applicable)</b> </span><span ng-if=\"vm.bookingDetails.route_details.minimumFare < ((vm.bookingDetails.subTotalFare) + (vm.bookingDetails.item_of_charge_amount?vm.bookingDetails.item_of_charge_amount:0))\"><b>(Not Applicable)</b></span></td><td>-</td><td data-testid=valor_tarifa_minima>$ {{vm.bookingDetails.route_details.minimumFare || 0}}</td><td data-testid=total_tarifa_minima>$ {{vm.bookingDetails.route_details.minimumFare || 0}}</td></tr><tr ng-if=\"vm.bookingDetails.route_type == 0\"><td>{{\'subFare\' | translate}}: $</td><td>-</td><td>-</td><!--<td>$ {{(vm.bookingDetails.payment_amount - --><!--vm.bookingDetails.item_of_charge_amount).toFixed(1) || 0}}--><!--</td>--><td data-testid=subtotal>$ {{vm.bookingDetails.subTotalFare || 0}}</td></tr><tr ng-if=\"vm.bookingDetails.route_type == 1\"><td>{{\'fixedFare\' | translate}}:</td><td>-</td><td>-</td><td data-testid=tarifa_fija><!--$ {{(vm.bookingDetails.payment_amount - vm.bookingDetails.item_of_charge_amount).toFixed(2) || 0.00}}--> $ {{(vm.bookingDetails.ride_charges) || 0}}</td></tr><tr ng-if=vm.bookingDetails.item_of_charge.length ng-repeat=\"items in vm.bookingDetails.item_of_charge\"><td data-testid=nombre_item_cargo>{{items.long_name}}</td><td data-testid=cantidad_item_cargo>{{items.quantity == \'\' || items.quantity == undefined? \'-\' : items.quantity || 0}}</td><!-- <td>$ {{(items.price / (items.quantity == \'\' || items.quantity == undefined?\n                                                    1 : items.quantity)).toFixed(2) || 0.00}}\n                                                </td> --><!-- <td>{{items.manually ? ((items.price/items.quantity) || 0) : ((items.price/items.quantity) || 0)}}</td> --><td ng-if=!items.unit_price data-testid=valor_unitario_item_cargo>{{items.quantity ? (items.price/items.quantity).toString().includes(\'.\') ? (items.price/items.quantity).toFixed(2) : (items.price/items.quantity) : 0}}</td><td ng-if=items.unit_price data-testid=valor_unitario_item_cargo>${{ items.unit_price }}</td><td data-testid=total_item_cargo>$ {{items.manually ? items.price || 0.00 : (items.price || 0)}}</td></tr><tr ng-if=\"vm.bookingDetails.item_of_charge_amount == 0 && vm.bookingDetails.item_of_charge.length != 0\"><td>{{\'subTotalItem\' | translate}}:</td><td>-</td><td>-</td><td data-testid=subtotal_items_cargo>$ {{vm.bookingDetails.item_of_chargeBefore || 0}}</td></tr><tr ng-if=\"vm.bookingDetails.item_of_charge_amount != 0 && vm.bookingDetails.item_of_charge.length != 0\"><td>{{\'subTotalItem\' | translate}}:</td><td>-</td><td>-</td><td data-testid=total_items_cargo>$ {{vm.bookingDetails.item_of_charge_amount || 0}}</td></tr><tr ng-if=\"vm.bookingDetails.type_of_trip == \'Z\'\"><td>Via Controlled Airport:</td><td>-</td><td>-</td><td data-testid=valor_via_controlada>$ {{vm.bookingDetails.via_controlled_price || 0}}</td></tr><tr ng-if=\"vm.bookingDetails.apply_charge_by_toll && vm.bookingDetails.route_details.toll_charge_way && vm.bookingDetails.job_status !=2\"><td>Valor por Portigo TAG: $</td><td data-testid=cantidad_tags>{{vm.bookingDetails.heremaps_estimated_tolls || \'-\'}}</td><td ng-if=\"vm.bookingDetails.booking_type != 2 && vm.bookingDetails.route_details.toll_charge_way == 1\" data-testid=valor_tags>{{vm.bookingDetails.item_of_charge_toll_price ? \'$ \' + vm.bookingDetails.item_of_charge_toll_price : \'-\'}}</td><td ng-if=\"vm.bookingDetails.booking_type != 2 && vm.bookingDetails.route_details.toll_charge_way == 2\" data-testid=valor_tags>-</td><td ng-if=\"vm.bookingDetails.booking_type == 2\" data-testid=valor_tags>$ {{vm.bookingDetails.final_toll_price}}</td><td data-testid=total_tags>$ {{vm.bookingDetails.item_of_charge_toll_price ? (vm.bookingDetails.heremaps_estimated_tolls * vm.bookingDetails.item_of_charge_toll_price) : vm.bookingDetails.estimated_toll_price}}</td></tr><tr ng-if=\"vm.bookingDetails.apply_charge_by_toll && ((vm.bookingDetails.route_details.toll_charge_way && vm.bookingDetails.booking_type != 2) || (vm.bookingDetails.booking_type == 2 && vm.bookingDetails.toll_charge_way)) && vm.bookingDetails.job_status == 2\"><td>Valor por Portigo TAG: $</td><td data-testid=cantidad_tags>{{vm.bookingDetails.final_heremaps_toll_count || \'-\'}}</td><td>{{vm.bookingDetails.item_of_charge_toll_price ? \'$ \' + vm.bookingDetails.item_of_charge_toll_price : \'-\'}}</td><td ng-if=\"vm.bookingDetails.booking_type != 2\" data-testid=valor_tags>$ {{vm.bookingDetails.item_of_charge_toll_price ? (vm.bookingDetails.final_heremaps_toll_count * vm.bookingDetails.item_of_charge_toll_price) : vm.bookingDetails.final_heremaps_total_toll_price}}</td><td ng-if=\"vm.bookingDetails.booking_type == 2\" data-testid=total_tags>$ {{ vm.bookingDetails.final_toll_price }}</td></tr><tr ng-if=\"vm.bookingDetails.discount_amount > \'0\' && vm.bookingDetails.route_type == 1\"><td data-testid=nombre_descuento>Descuento ({{vm.bookingDetails.promo_type == \'0\' ? vm.bookingDetails.promo_id : vm.bookingDetails.promo_type == \'1\' ? \'DSCTO. IDA Y VUELTA\' : vm.bookingDetails.promo_type == \'2\' ? \'Web Discount\' : vm.bookingDetails.promo_type == \'3\' ? \'Bin\' : NA }}):</td><td>1</td><td data-testid=valor_descuento><span ng-if=\"vm.bookingDetails.discount_type == \'0\'\">${{vm.bookingDetails.discount_amount}}</span> <span ng-if=\"vm.bookingDetails.discount_type == \'1\'\">{{vm.bookingDetails.discount_amount}}%</span></td><td data-testid=total_descuento><span ng-if=\"vm.bookingDetails.discount_type == \'0\'\">${{vm.bookingDetails.discount_amount}}</span> <span ng-if=\"vm.bookingDetails.discount_type == \'1\'\">${{vm.bookingDetails.net_discount}}</span></td></tr><tr ng-if=\"vm.bookingDetails.discount_amount > \'0\' && vm.bookingDetails.route_type == 0\"><td data-testid=nombre_descuento>Descuento ({{vm.bookingDetails.promo_type == \'0\' ? vm.bookingDetails.promo_id : vm.bookingDetails.promo_type == \'1\' ? \'DSCTO. IDA Y VUELTA\' : vm.bookingDetails.promo_type == \'2\' ? \'Web Discount\' : vm.bookingDetails.promo_type == \'3\' ? \'Bin\' : NA }}):</td><td>1</td><td data-testid=valor_descuento><span ng-if=\"vm.bookingDetails.discount_type == \'0\'\">${{vm.bookingDetails.discount_amount}}</span> <span ng-if=\"vm.bookingDetails.discount_type == \'1\'\">{{vm.bookingDetails.discount_amount}}%</span></td><td data-testid=total_descuento><span ng-if=\"vm.bookingDetails.discount_type == \'0\'\">${{vm.bookingDetails.discount_amount}}</span> <span ng-if=\"vm.bookingDetails.discount_type == \'1\'\">${{vm.bookingDetails.net_discount}}</span></td></tr><tr ng-if=\"vm.bookingDetails.reasonsForCorrection.length && vm.bookingDetails.job_status == \'2\'\" style=\"background-color: lightgray\"><td style=\"color: red\">{{\'adjustFare\' | translate}} <span style=color:red>*</span>:</td><td>-</td><td>-</td><td style=\"color: red\" data-testid=valor_correccion>$ {{vm.bookingDetails.adjustment_amount}}</td></tr><tr ng-if=\"vm.bookingDetails.package_type == 2 && vm.bookingDetails.QTH_value_individual\"><td>Parada en ruta (Agrupado)</td><td>-</td><td>-</td><td data-testid=valor_parada_ruta>$ {{vm.bookingDetails.QTH_value_individual}}</td></tr><tr><td>{{\'paymentAmount\' | translate}}</td><td colspan=3 style=\"font-size: 20px; font-weight: 600; text-align: right\" data-testid=monto_pago>${{vm.bookingDetails.newPaymentTotal}}</td></tr><tr ng-if=\"vm.bookingDetails.balance_payment_amount > 0\"><td>Balance Amount</td><td colspan=3 style=\"font-size: 20px; font-weight: 600; text-align: right\" data-testid=monto_balance>${{vm.bookingDetails.balance_payment_amount}}</td></tr><tr><td>{{\'paymentMethod\' | translate}}</td><td colspan=3 style=\"font-size: 12px; font-weight: 400; text-align: right\" data-testid=metodo_pago>{{vm.bookingDetails.payment_method_name}}</td></tr></tbody></table></div><div class=\"col-lg-4 col-md-4 col-xs-12 col-sm-12\"><p><b>{{\'estimatedPrice\' | translate}}: </b><span data-testid=valor_estimado>${{vm.bookingDetails.estimated_payment_cost || \'0\'}}</span></p><p><b>{{\'totalDistanceTravel\' | translate}}: </b><span data-testid=distancia_total>{{vm.bookingDetails.total_distance_travelled_updated ? vm.bookingDetails.total_distance_travelled_updated : vm.bookingDetails.apply_estimated_distance_variable_fare ? vm.estimated_distanceRounded : vm.bookingDetails.total_distance_travelled}} km</span></p><p><b>{{\'totalTimeTravel\' | translate}}: </b><span data-testid=tiempo_total>{{vm.total_time_travelled_new}} {{(vm.bookingDetails.total_time_travelled) >= 1 ? \"min\'s\" : \"min\"}}</span></p><p><b>{{\'initialWaitTime\' | translate}}: </b><span data-testid=tiempo_espera_inicial>{{((vm.bookingDetails.initialWaitTime) >= 1 ? (vm.bookingDetails.initialWaitTime) : 0)}} min</span></p><p><b>{{\'inTripWaitTime\' | translate}}: </b><span data-testid=tiem_espera_viaje>{{(vm.bookingDetails.wait_time) >= 1 ? (vm.bookingDetails.wait_time) + \' min\' : \'--\'}}</span></p><p><b>{{\'maxWaitTimeRoute\' | translate}}: </b><span data-testid=max_tiem_espera_viaje>{{vm.bookingDetails.max_wait_time_en_route }} min</span></p><p><b>{{\'maxWaitTimeFree\' | translate}}: </b><span data-testid=max_tiem_espera_free>{{vm.bookingDetails.max_wait_time_free }} min</span></p><p><b>{{\'maxWaitTimeTolerance\' | translate}}: </b><span data-testid=max_tiem_espera_tolerancia>{{vm.bookingDetails.max_wait_time_tolerance }} min</span></p></div><!-- ////////////////////// TV-2057 ///////////////////////// --><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\" style=\"font-weight: bold\">* Motive For Adjustment</div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\" ng-repeat=\"data in vm.bookingDetails.reasonsForCorrection\" ng-if=vm.bookingDetails.reasonsForCorrection.length style=\"background-color: #D3D3D3;height: auto;margin-bottom: 20px;padding:10px\"><div class=\"col-lg-6 col-xs-6 col-sm-6 col-md-6\"><div><span style=\"font-weight: bold\" data-testid=reaseon_adjust>{{data.reason_for_adjustment}}: </span>: <span data-testid=comment_adjust>{{data.comment_for_adjustment}}</span></div><div><span style=\"font-weight: bold\">{{\'amount\' | translate}}: </span>: <span data-testid=amount_adjust>{{data.adjustment_amount}}</span></div><div><span style=\"font-weight: bold\">{{\'date&Time\' | translate}}: </span>: <span data-testid=date_adjust>{{data.time | date: \'medium\'}}</span></div></div><div class=\"col-lg-6 col-xs-6 col-sm-6 col-md-6\"><div><span style=\"font-weight: bold\">Usuario </span>: <span data-testid=admin_emain_adjust>{{data.admin_email}}</span></div></div></div><!-- ////////////////////// TV-2057 ///////////////////////// --><!-- <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-if=\"vm.bookingDetails.reasonsForCorrection.length\">\n                                    <label>*{{\'adjustMotive\' | translate}}</label>\n                                    <div class=\"motiveDiv\" ng-repeat=\"data in vm.bookingDetails.reasonsForCorrection\">\n                                        <p>\n                                            <b>{{data.reason_for_adjustment}}:</b> {{data.comment_for_adjustment}}</p>\n                                        <p>\n                                            <b>{{\'amount\' | translate}}:</b> $ {{data.adjustment_amount}}</p>\n                                        <p>{{\'date&Time\' | translate}}: {{data.time | date: \'medium\'}}</p>\n                                        <div ng-if=\"$index != vm.bookingDetails.reasonsForCorrection.length - 1\">\n                                            <hr style=\"margin:5px 0px;\" />\n                                        </div>\n                                    </div>\n                                </div> --></section><section class=\"col-lg-12 col-sm-12 col-xs-12 col-sm-12 customerdetails nopadding\"><div class=\"basicRegistrationP backgroundBasicPending col-lg-12 col-xs-12 col-sm-12 col-md-12 nopadding\" style=margin-top:0px>{{\'customerDetailsHead\' | translate}}</div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><p><b>{{\'name\' | translate}}: </b><span data-testid=name_customer>{{vm.bookingDetails.customer_last_name?vm.bookingDetails.customer_first_name + \' \' + vm.bookingDetails.customer_last_name:vm.bookingDetails.customer_first_name}}</span></p><p><b>{{\'mobileNumber\' | translate}}: </b><span data-testid=phone_customer>{{vm.bookingDetails.customer_phone_number}}</span></p><p><b>{{\'email\' | translate}}: </b><span data-testid=email_customer>{{vm.bookingDetails.customer_email}}</span></p><p><b>{{\'userProfile\' | translate}}: </b><span data-testid=profile_customer>{{vm.bookingDetails.creator_profile == 0 ? \'Personal\' : \'CORPORATIVA\'}}</span></p></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><p><b>{{\'userRating\' | translate}}: </b><span data-testid=rating_customer>{{vm.bookingDetails.customer_rating}}</span></p><p><b>{{\'userComment\' | translate}}: </b><span data-testid=comment_customer>{{vm.bookingDetails.customer_comment || \'--\'}}</span></p></div></section><section class=\"col-lg-12 col-sm-12 col-xs-12 col-sm-12 mDetails nopadding\"><div class=\"basicRegistrationP backgroundBasicPending col-lg-12 col-xs-12 col-sm-12 col-md-12 nopadding\">{{\'mandatoryDetails\' | translate}}</div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 nopadding\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><p><b>{{\'agreNameLabel\' | translate}}:</b> <span data-testid=convenio>{{vm.bookingDetails.new_contract_name ?vm.bookingDetails.new_contract_name :vm.bookingDetails.contract_name}}</span></p><p><b>{{\'agreTypeLabel\' | translate}}:</b> <span data-testid=tipo_convenio>{{vm.bookingDetails.agreement_type == \'CORPORATE\' ? \'CORPORATIVO\' : vm.bookingDetails.agreement_type}}</span></p><p><b>{{\'startDateValid\' | translate}}:</b> <span data-testid=start_vigencia>{{vm.bookingDetails.agr_start_date_validity | date:\'medium\'}}</span></p><p><b>{{\'endDateValid\' | translate}}:</b> <span data-testid=end_vigencia>{{vm.bookingDetails.agr_end_date_validity | date:\'medium\'}}</span></p><p><b>{{\'serviceLabel\' | translate}}:</b> <span data-testid=service>{{vm.bookingDetails.service_name}}</span></p><p><b>{{\'corporateLabel\' | translate}}:</b> <span data-testid=company>{{vm.bookingDetails.company_name || \'--\' }}</span></p><p><b>{{\'defaultPaymentLabel\' | translate}}:</b> <span data-testid=default_payment>{{vm.bookingDetails.agr_payment_method_default }}</span></p><p ng-if=vm.bookingDetails.passenger_rut><b>{{\'passengerRutB\' | translate}}: </b><span data-testid=customer_rut>{{vm.bookingDetails.passenger_rut}}</span></p><p><b>{{\'costCenterText\' | translate}}: </b><span data-testid=cost_center>{{vm.bookingDetails.cost_center || \'--\'}}</span></p><!--ng-if=\"vm.bookingDetails.cost_center\"--><p><b>{{\'ROLText\' | translate}}:</b><!--ng-if=\"vm.bookingDetails.rol\"--> <span data-testid=rol>{{vm.bookingDetails.rol || \'--\'}}</span></p><p ng-if=vm.bookingDetails.work_order><b>{{\'workOrdrerB\' | translate}}:</b> <span data-testid=work_order>{{vm.bookingDetails.work_order}}</span></p><p ng-if=vm.bookingDetails.purpose_of_trip><b>{{\'purpouseTripB\' | translate}}: </b><span data-testid=purpouse_trip>{{vm.bookingDetails.purpose_of_trip}}</span></p><p ng-if=vm.bookingDetails.nomina><b>{{\'nomina1\' | translate}}:</b> <span data-testid=nomina>{{vm.bookingDetails.nomina}}</span></p></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><p><b>{{\'branchLabel\' | translate}}:</b> <span data-testid=sucursal>{{vm.bookingDetails.branch_name }}</span></p><p><b>{{\'noShowChargeLabel\' | translate}}:</b><span data-testid=cargo_noshow>$ {{vm.bookingDetails.agr_charges_for_no_show }}</span></p><p><b>{{\'maxWaitTimeTolerance\' | translate}}:</b> <span data-testid=max_tiem_espera_tolerancia2>{{vm.bookingDetails.max_wait_time_tolerance }} min</span></p><p><b>{{\'maxWaitTimeFree\' | translate}}:</b> <span data-testid=max_tiem_espera_free2>{{vm.bookingDetails.max_wait_time_free }} min</span></p><p><b>{{\'maxWaitTimeRoute\' | translate}}:</b> <span data-testid=max_tiem_espera_viaje2>{{vm.bookingDetails.max_wait_time_en_route}} min</span></p><p><b>{{\'comeclass\' | translate}}:</b> <span data-testid=clasificacion>{{vm.bookingDetails.agr_commercial_classification }}</span></p><p><b>{{\'paymentPHead\' | translate}}:</b> <span data-testid=metodo_pago_default>{{vm.bookingDetails.agr_payment_method_default }}</span></p><p><b>{{\'applicantRutB\' | translate}}: </b><span data-testid=rut_solicitante>{{vm.bookingDetails.applicant_rut || \'--\'}}</span></p><!--ng-if=\"vm.bookingDetails.applicant_rut\"--><p><b>{{\'subCOst\' | translate}}:</b><!--ng-if=\"vm.bookingDetails.sub_cost_center\"--> <span data-testid=sub_centro_costo>{{vm.bookingDetails.sub_cost_center || \'--\'}}</span></p><p><b>{{\'graphText\' | translate}}:</b><!--ng-if=\"vm.bookingDetails.graph\"--> <span data-testid=grafo>{{vm.bookingDetails.graph || \'--\'}}</span></p><p><b>{{\'PEPText\' | translate}}:</b><!--ng-if=\"vm.bookingDetails.PEP\"--> {{vm.bookingDetails.PEP || \'--\'}}</p><p ng-if=vm.bookingDetails.number_of_voucher><b>{{\'numberOfVoucherText\' | translate}}: </b><span data-testid=nro_voucher>{{vm.bookingDetails.number_of_voucher}}</span></p><p ng-if=vm.bookingDetails.solicitud><b>{{\'solicitud1\' | translate}}:</b> <span data-testid=solicitud>{{vm.bookingDetails.solicitud}}</span></p></div></div></section><section class=\"col-lg-12 col-sm-12 col-xs-12 col-sm-12 mDetails nopadding\"><div class=\"basicRegistrationP backgroundBasicPending col-lg-12 col-xs-12 col-sm-12 col-md-12 nopadding\">{{\'entrust\' | translate}}</div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 nopadding\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><p><b>{{\'recipientRouting\' | translate}}:</b> <span data-testid=rut_destinatario>{{vm.bookingDetails.passenger_rut || \'--\'}}</span></p><p><b>{{\'recipientName\' | translate}}:</b> <span data-testid=nombre_destinatario>{{vm.bookingDetails.customer_last_name?vm.bookingDetails.customer_first_name + \' \' + vm.bookingDetails.customer_last_name:vm.bookingDetails.customer_first_name}}</span></p><p><b>{{\'typeOfLoad\' | translate}}:</b> <span data-testid=tipo_carga>{{vm.bookingDetails.type_of_charge || \'--\'}}</span></p><p><b>{{\'rutApplication\' | translate}}:</b> <span data-testid=rut_solicitante_encomienda>{{vm.bookingDetails.sender_rut || \'--\' }}</span></p><p><b>{{\'evidenceDeliver\' | translate}}:</b> <span ng-if=\"vm.bookingDetails.delivered_evidence_photo_one || vm.bookingDetails.delivered_evidence_photo_one\" data-testid=evidencia_encomienda><img src=assets/images/camera_icon.png ng-click=\"vm.showEvidenceDeliver($event, vm.bookingDetails)\" width=30 height=30> </span><span ng-if=\"!vm.bookingDetails.delivered_evidence_photo_one && !vm.bookingDetails.delivered_evidence_photo_one\" data-testid=evidencia_encomienda>\'--\'</span></p></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><p><b>{{\'storeId\' | translate}}:</b> <span data-testid=id_tienda>{{vm.bookingDetails.location_id || \'--\'}}</span></p><p><b>{{\'storeName\' | translate}}:</b> <span data-testid=nombre_tienda>{{vm.bookingDetails.location_name || \'--\'}}</span></p><p><b>{{\'retirementDate\' | translate}}:</b> <span data-testid=fecha_retiro>{{vm.bookingDetails.location_time_pickup | date:\'medium\' }}</span></p><p><b>{{\'deliveryDate\' | translate}}:</b> <span data-testid=fecha_entrega>{{vm.bookingDetails.drop_off_time | date:\'medium\'}}</span></p><p><b>{{\'evidenceNoDeliver\' | translate}}:</b> <span ng-if=vm.bookingDetails.non_delivered_evidence_photo data-testid=evidencia_no_entrega><img src=assets/images/camera_icon.png ng-click=\"vm.showEvidenceNoDeliver($event, vm.bookingDetails)\" width=30 height=30> </span><span ng-if=!vm.bookingDetails.non_delivered_evidence_photo data-testid=evidencia_no_entrega>\'--\'</span></p></div></div></section><section class=\"col-lg-12 col-sm-12 col-xs-12 col-sm-12 mDetails nopadding\"><div class=\"basicRegistrationP backgroundBasicPending col-lg-12 col-xs-12 col-sm-12 col-md-12 nopadding\">{{\'orderContentDetails\' | translate}}</div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 nopadding\"><div class=\"table-responsive tableWithMasterDataParentDive\"><table class=\"table table-hover tableWithMasterData\"><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serviceOrder\' | translate}}\" text=\"\'cud\'\" check=vm.reverse>{{\'serviceOrder\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'guideNumber\' | translate}}\" text=\"\'cud\'\" check=vm.reverse>{{\'guideNumber\' | translate}}</th><th style=width:125px><div class=text-center>CUD</div></th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'cudState\' | translate}}\" text=\"\'cud_state\'\" check=vm.reverse>{{\'cudState\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'quantity\' | translate}}\" text=\"\'phone\'\" check=vm.reverse>{{\'quantity\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'descProduct\' | translate}}\" text=\"\'corporate_account_id\'\" check=vm.reverse>{{\'descProduct\' | translate}}</th><th style=width:100px><div class=text-center>{{\'productPrice\' | translate}}</div></th></tr></thead><tbody ng-if=\"vm.bookingDetails && vm.bookingDetails.job_cuds_result && vm.bookingDetails.job_cuds_result.length\"><tr ng-repeat=\"data in filtered = vm.bookingDetails.job_cuds_result | orderBy:vm.predicate:vm.reverse\"><!--| filter:vm.search--><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:70px data-testid=id_encomienda>{{vm.bookingDetails.service_order_id || \'--\'}}</td><td style=width:70px data-testid=numero_encomienda>{{::data.guide_number || \'--\'}}</td><td style=\"text-align: center;width:125px\" data-testid=cud_encomienda>{{::data.cud_id}}</td><td style=width:125px data-testid=estado_encomienda><span ng-if=\"data.cud_status == \'0\'\">{{\'upcomingStatus\' | translate}}</span> <span ng-if=\"data.cud_status == \'1\'\">Viaje Iniciado</span> <span ng-if=\"data.cud_status == \'2\'\">{{\'CUD_delivered\' | translate}}</span> <span ng-if=\"data.cud_status == \'3\'\">{{\'CUD_not_delivered\' | translate}}</span> <span ng-if=\"data.cud_status == \'4\'\">En Posición</span> <span ng-if=\"data.cud_status == \'5\'\">Partial</span> <span ng-if=\"data.cud_status == \'6\'\">{{\'CUD_created\' | translate}}</span> <span ng-if=\"data.cud_status == \'17\'\">Pendiente de Aceptación</span> <span ng-if=\"data.cud_status == \'7\'\">{{\'CUD_accepted\' | translate}}</span> <span ng-if=\"data.cud_status == \'8\'\">Rejected</span> <span ng-if=\"data.cud_status == \'9\'\">{{\'CUD_cancelled\' | translate}}</span> <span ng-if=\"data.cud_status == \'10\'\">Deleted</span> <span ng-if=\"data.cud_status == \'11\'\">Ignored</span> <span ng-if=\"data.cud_status == \'12\'\">No Show</span> <span ng-if=\"data.cud_status == \'15\'\">En Camino</span></td><td style=width:125px data-testid=cantidad_encomienda>{{data.product_quantity || \'--\'}}</td><td style=width:125px data-testid=descripcion_encomienda>{{data.product_description || \'--\'}}</td><td style=\"text-align: center;width:100px\" data-testid=valor_encomienda>{{data.product_price || \'--\'}}</td></tr></tbody><tfoot ng-if=\"vm.bookingDetails && ((vm.bookingDetails.job_cuds_result && !vm.bookingDetails.job_cuds_result.length) || !vm.bookingDetails.job_cuds_result)\" class=text-center><tr><th colspan=6 class=\"noDataClass text-center\">{{\'searchCustError\' | translate}}</th></tr></tfoot></table></div></div></section><section class=\"col-lg-12 col-sm-12 col-xs-12 col-sm-12 oDetails nopadding\"><div class=\"basicRegistrationP backgroundBasicPending col-lg-12 col-xs-12 col-sm-12 col-md-12 nopadding\">{{\'otherDetails\' | translate}}</div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 nopadding\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12\"><p><b>Usuario Creación<!--{{\'jobCreationUser\' | translate}}--> : </b><span data-testid=usuario_creacion>{{(vm.bookingDetails.created_by_admin == 1 || vm.bookingDetails.created_by_admin == 2 || vm.bookingDetails.created_by_admin == 7) ? vm.bookingDetails.admin_email : (vm.bookingDetails.created_by_admin == 4 ? vm.bookingDetails.codelco_user : vm.bookingDetails.customer_email)}}</span></p><p><b>Fecha / Hora creación<!--{{\'jobCreationDate\' | translate}}--> : </b><span data-testid=fecha_creacion>{{vm.bookingDetails.creation_datetime | date:\'medium\'}}</span></p><p><b>Nombre del Autorizador<!--{{\'authName\' | translate}}--> : </b><span data-testid=nombre_autorizador>{{vm.bookingDetails.autherizer_name || \'--\' }}</span></p><p><b>Fecha / Hora Autorización<!--{{\'authGivenDate\' | translate}}--> : </b><span data-testid=fecha_autorizador>{{vm.bookingDetails.auth_timing | date:\'medium\' }}</span></p><p><b>Usuario Anulación<!--{{\'cancelUserI\' | translate}}--> : </b><span data-testid=nombre_cancelador>{{vm.bookingDetails.cancellation_identity || \'--\'}}</span></p><p><b>Fecha / Hora Anulación<!--{{\'cancelDate\' | translate}}--> : </b><span data-testid=fecha_cancelacion>{{vm.bookingDetails.cancellation_datetime | date:\'medium\'}}</span></p><p><b>Motivo Anulación<!--{{\'cancelReason\' | translate}}--> : </b><span data-testid=motivo_cancelacion>{{vm.bookingDetails.cancellation_reason || \'--\'}}</span></p><p><b>Comentario de Anulación<!--{{\'cancelReason\' | translate}}--> : </b><span data-testid=comentario_cancelacion>{{vm.bookingDetails.cancellation_description || \'--\'}}</span></p><p><b>Usuario Noshow<!--{{\'noShowUser\' | translate}}--> : </b><span data-testid=usuario_noshow>{{vm.bookingDetails.noshow_identity || \'--\'}}</span></p><!--ng-if=\"vm.bookingDetails.job_status == \'12\'\"--><p><b>Fecha / Hora NoShow<!--{{\'noShowUserDate\' | translate}}--> : </b><span data-testid=fecha_noshow>{{vm.bookingDetails.no_show_datetime | date:\'medium\'}}</span></p><p style=\"word-break: break-all\"><b>Motivo de NoShow<!--{{\'noReason\' | translate}}--> : </b><span data-testid=motivo_noshow>{{vm.bookingDetails.noshow_reason}}</span></p><p><b>Comentario de NoShow<!--{{\'noReasonComment\' | translate}}--> : </b><span data-testid=comentario_noshow>{{vm.bookingDetails.noshow_comment || \'--\'}}</span></p><p><b>Usuario última Modificación<!--{{\'modifiedUser\' | translate}}--> : </b><span data-testid=modificador>{{vm.bookingDetails.modify_identity || \'--\' }}</span></p><p><b>Fecha / Hora Última Modificación<!--{{\'modifiedDate\' | translate}}--> : </b><span data-testid=fecha_modificador>{{vm.bookingDetails.modify_datetime?vm.bookingDetails.modify_datetime:\'0000-00-00 00:00:00\' | date:\'medium\' }}</span></p></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12\"><div style=\"border:1px solid;border-radius: 4px;padding: 10px\"><p data-testid=tipo_asignacion>Reserva <span style=\"text-decoration: underline\" ng-if=\"vm.bookingDetails.auto_assignment == 0 && vm.bookingDetails.job_status != 6\"><b>Asignada Manualmente</b> </span><span style=\"text-decoration: underline\" ng-if=\"vm.bookingDetails.auto_assignment == 1  && vm.bookingDetails.job_status != 6\"><b>Asignada Automáticamente</b> </span><span style=\"text-decoration: underline\" ng-if=\"vm.bookingDetails.job_status == 6\"><b>No Asignada</b> </span>por:</p><p ng-if=\"vm.bookingDetails.assignment_identity != \'SYSTEM_SCAN_QR\'\" data-testid=asignador><b>Usuario Asignación<!--{{\'assignmentUser\' | translate}}--> : </b>{{vm.bookingDetails.assignment_identity || \'--\'}}</p><p ng-if=\"vm.bookingDetails.assignment_identity == \'SYSTEM_SCAN_QR\'\" data-testid=asignador><b>Usuario Asignación<!--{{\'assignmentUser\' | translate}}--> : </b>SYSTEM_SCAN_QR</p><p><b>Fecha / Hora Asignación<!--{{\'assignmentDate\' | translate}}--> : </b><span data-testid=fecha_asignacion>{{vm.bookingDetails.assignment_datetime?vm.bookingDetails.assignment_datetime:\'--\' | date:\'medium\'}}</span></p></div><p><b>Usuario Viaje Aceptado<!--{{\'acceptedTripUser\' | translate}}--> : </b><span data-testid=usuario_aceptado>{{vm.bookingDetails.accepted_identity}}</span></p><p><b>Fecha / Hora Viaje Aceptado<!--{{\'acceptedTripDate\' | translate}}--> : </b><span data-testid=fecha_aceptado>{{vm.bookingDetails.accepted_datetime | date:\'medium\'}}</span></p><p><b>Usuario Vehículo en Camino<!--{{\'onRoadUser\' | translate}}--> : </b><span data-testid=usuario_encamino>{{vm.bookingDetails.on_road_identity || \'--\'}}</span></p><p><b>Fecha / Hora Vehículo en Camino<!--{{\'onRoadDate\' | translate}}--> : </b><span data-testid=fecha_encamino>{{vm.bookingDetails.on_road_datetime | date:\'medium\'}}</span></p><p><b>Usuario Vehículo en Posición<!--{{\'arrivedUser\' | translate}}--> : </b><span data-testid=usuario_enposicion>{{vm.bookingDetails.arrived_identity || \'--\'}}</span></p><p><b>Fecha / Hora Vehículo en Posición<!--{{\'arrivedDate\' | translate}}--> : </b><span data-testid=fecha_enposicion>{{vm.bookingDetails.arrived_datetime | date:\'medium\'}}</span></p><p><b>Usuario Viaje Iniciado<!--{{\'startedUser\' | translate}}--> : </b><span data-testid=usuario_iniciado>{{vm.bookingDetails.started_identity || \'--\'}}</span></p><p><b>Fecha / Hora Viaje Iniciado<!--{{\'startedDate\' | translate}}--> : </b><span data-testid=fecha_iniciado>{{vm.bookingDetails.started_datetime | date:\'medium\'}}</span></p><p><b>Usuario Viaje Completado<!--{{\'completedUser\' | translate}}--> : </b><span data-testid=usuario_completado>{{vm.bookingDetails.ended_identity || \'--\'}}</span></p><p><b>Fecha / Hora Viaje Completado<!--{{\'completedDateTime\' | translate}}--> : </b><span data-testid=fecha_completado>{{vm.bookingDetails.completed_datetime | date:\'medium\'}}</span></p></div></div></section><section class=\"col-lg-12 col-sm-12 col-xs-12 col-sm-12 oDetails nopadding\"><div class=\"basicRegistrationP backgroundBasicPending col-lg-12 col-xs-12 col-sm-12 col-md-12 nopadding\">{{\'printLogs\' | translate}}</div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=max-height:300px;overflow-y:auto data-testid=logsd_impresion><div ng-if=\"vm.bookingDetails.thermalVoucher.length == 0\" class=text-center>{{\'printNo\' | translate}}</div><div class=row ng-repeat=\"print in vm.bookingDetails.thermalVoucher\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><p><b>{{\'adminName\' | translate}}:</b> {{print.admin_name}}</p></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><p><b>{{\'print\' | translate}}:</b> {{\'print\' | translate}}-{{print.voucherCounter}}</p></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><p><b>{{\'date&Time\' | translate}}:</b> {{print.time | date:\'medium\'}}</p></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-if=\"$index != vm.bookingDetails.thermalVoucher.length-1\"><hr></div></div></div></section><section class=\"col-lg-12 col-sm-12 col-xs-12 col-sm-12 oDetails nopadding\"><div class=\"basicRegistrationP backgroundBasicPending col-lg-12 col-xs-12 col-sm-12 col-md-12 nopadding\">{{\'observation\' | translate}}</div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" data-testid=observaciones><pre ng-if=vm.bookingDetails.observations>{{vm.bookingDetails.observations}}</pre><pre ng-if=!vm.bookingDetails.observations>{{\'observationNo\' | translate}}</pre></div></section><section class=\"col-lg-12 col-sm-12 col-xs-12 col-sm-12 oDetails nopadding\" ng-if=\"vm.bookingDetails.oneclick_logs.length > 0\"><div class=\"basicRegistrationP backgroundBasicPending col-lg-12 col-xs-12 col-sm-12 col-md-12 nopadding\">Actas</div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 table-responsive\"><table class=table><thead><tr><th>ID de transacción</th><!-- <th>Usuario</th> --><th>Usuario Email</th><th>Método de pago</th><th>Transacción</th><th style=\"width: 100px\">Estado</th><th>Fecha y hora de pago</th><th>Monto del pago</th></tr></thead><tbody><tr ng-repeat=\"data in vm.bookingDetails.oneclick_logs | orderBy:\'datetime\' : \'ASC\' || \'DES\'\"><td>{{data.order_id}}</td><td>{{data.user_email || vm.bookingDetails.customer_email}}</td><td>{{data.payment_method}}</td><!-- <td ng-if=\"data.payment_method =! \'Mercado Pago\'\" >{{data.payment_method }}</td> --><td ng-if=\"data.type == \'PAY_SERVICE\'\">Cargo</td><td ng-if=\"data.type == \'PAY_NULLIFY\' || data.type ==\'REFUND_PAYMENT\'\">Anulación</td><td style=\"width: 100px\"><span ng-if=\"data.flag == 0\">Fallido</span> <span ng-if=\"data.flag == 1\">Exitoso</span> <span ng-if=\"data.flag == 2\">Exitoso</span></td><td>{{data.datetime | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td ng-if=\"data.amount != \'0.0\' \">${{data.amount}}</td><td ng-if=\"data.amount == \'0.0\' \">${{ vm.bookingDetails.payment_amount }}</td></tr></tbody></table></div></section></div></div></div></div></div></div><input id=copy style=\"opacity: 0 ; z-index:0\" type=text><div id=showPrint></div></div><style>.gm-style .gm-style-iw-c {\n        position: absolute !important;\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        top: 0 !important;\n        left: 0 !important;\n        transform: translate(-50%, -100%) !important;\n        background-color: white !important;\n        border-radius: 8px !important;\n        padding: 12px !important;\n        box-shadow: 0 2px 7px 1px rgba(0, 0, 0, 0.3) !important;\n    }\n    \n    .gm-ui-hover-effect {\n        border: 0px !important;\n        margin: 0px !important;\n        padding: 0px !important;\n        position: absolute !important;\n        cursor: pointer !important;\n        -webkit-user-select: none !important;\n        -moz-user-select: none !important;\n        -ms-user-select: none !important;\n        user-select: none !important;\n        height: 0px !important;\n        opacity: 1 !important;\n        top: 0px !important;\n        right: 0px !important;\n    }\n    \n    .gm-style-iw-d {\n        padding: 0px !important;\n    }\n    \n    .gm-style .gm-style-iw-t::after {\n        background: white !important;\n        left: -1px !important;\n    }</style>");
$templateCache.put("app/components/views/booking-list/completedBookings.html","<h2 class=ng-cloak><span>{{\'completedBookingHead\' | translate}}</span><!--<span class=\"pull-right\">--><!--<button class=\"btn btn-info\" title=\"{{\'filterButton\' | translate}}\" style=\"min-width: 100px;\" ng-click=\"vm.showFilterArea()\">{{\'filterButton\' | translate}}</button>--><!--<button class=\"btn btn-info\" title=\"{{\'resetButton\' | translate}}\" ng-click=\"vm.removeFilter()\">{{\'resetButton\' | translate}}</button>--><!--</span>--></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><!--<filter-sidebar show-filter-sidebar=\"vm.showFilterFlag\" filter-data=\"vm.filterData\" filter-to-show=\"vm.filterWhichToShow\" branch-detail-changed=\"vm.branchChangedFilter(vm.filterData)\"--><!--vehicle-detail-changed=\"vm.vehicleChangedFilter(vm.filterData)\" service-detail-changed=\"vm.serviceChangedFilter(vm.filterData)\"--><!--agreement-detail-changed=\"vm.agreementChangedFilter(vm.filterData)\" type-trip-detail-changed=\"vm.typeTripChangedFilter(vm.filterData)\"></filter-sidebar>--><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"border:1px solid #dedede;padding:0px\" ng-init=\"checkClicked = true\"><h2 class=\"text-center filtersStyle\" ng-click=\"checkClicked = !checkClicked; vm.slideData()\">{{\'filter\' | translate}} <span class=fa ng-class=\"{\'fa-caret-down\': checkClicked,\'fa-caret-up\': !checkClicked }\"></span></h2><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" id=derp><div class=row style=\"padding-top: 10px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'branchLabel\' | translate}}:</label><div><ui-select ng-model=vm.filterData.branch name=branch ng-keyup=vm.branchSearch($select.search,$event) ng-change=vm.branchChanged() required close-on-select=true><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices when-scrolled=vm.paginationChangedForBranch() repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \"><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'agreementLabel\' | translate}}:</label><div><ui-select ng-model=vm.filterData.agreement ng-keyup=vm.agreementSearch($select.search,$event) name=agreement ng-change=vm.agreementChanged() required close-on-select=true><ui-select-match placeholder=\"{{\'agreementPlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices when-scrolled=vm.paginationChangedForAgreement() repeat=\"agreements.id as agreements in vm.agreement | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=agreements.name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'serviceLabel\' | translate}}:</label><div><ui-select ng-model=vm.filterData.service ng-keyup=vm.serviceSearch($select.search,$event) name=service ng-change=vm.serviceChanged() required close-on-select=true><ui-select-match placeholder=\"{{\'selectTService\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices when-scrolled=vm.paginationChangedForService() repeat=\"services.id as services in vm.service | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=services.name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'vehicleLabel\' | translate}}:</label><div><ui-select ng-model=vm.filterData.vehicle ng-keyup=vm.vehicleSearch($select.search,$event) name=vehicle ng-change=vm.vehicleChanged() required close-on-select=true><ui-select-match placeholder=\"{{\'vehicleSelect\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices when-scrolled=vm.paginationChangedForVehicle() repeat=\"vehicles.id as vehicles in vm.vehicle | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=vehicles.name></div></ui-select-choices></ui-select></div></div></div><div class=row style=\"padding-top: 10px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpDateFromLabelPET\' | translate}}:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=pickupDate ng-model=vm.filterData.filter_pickup_from_date_value placeholder=\"{{\'pickUpDateFromLabelPET\' | translate}}\" is-open=vm.datePicker_1.pickupFromDate datepicker-options=vm.dateOptions required close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.pickupFromToDateChanged(1)> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_1(1)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpTimeFromLabelPET\' | translate}}:</label><div uib-timepicker ng-model=vm.filterData.filter_pickup_from_time_value show-spinners=false class=completed ng-change=vm.pickupFromToTimeChanged(1) hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpDateToLabelPET\' | translate}}:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=pickupDate ng-model=vm.filterData.filter_pickup_to_date_value placeholder=\"{{\'pickUpDateToLabelPET\' | translate}}\" is-open=vm.datePicker_1.pickupToDate datepicker-options=vm.dateOptionsT required close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.pickupFromToDateChanged(2)> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_1(2)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpTimeToLabelPET\' | translate}}:</label><div uib-timepicker ng-model=vm.filterData.filter_pickup_to_time_value show-spinners=false class=completed ng-change=vm.pickupFromToTimeChanged(2) hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian></div></div></div><div class=row style=\"padding-top: 10px;padding-bottom:10px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'tripType\' | translate}}:</label><div><!-- <select class=\"form-control\" ng-model=\"vm.filterData.type_of_trip\" ng-change=\"vm.typeTripChanged()\" ng-options=\"data.id as data.text for data in vm.typeTripFilter\">\n                                            <option value=\"\" selected disabled>{{\'selectTripType\' | translate}}</option>\n                                        </select> --><ui-select multiple ng-model=vm.filterData.type_of_trip name=trip required close-on-select=true ng-change=vm.typeTripChanged()><ui-select-match placeholder=\"{{\'selectTripType\' | translate}}\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"data.id as  data in vm.typeTripFilter | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=data.name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'stateOfReservation\' | translate}}:</label><div><ui-select ng-model=vm.filterData.bookingStateValue name=stateOfReservation required close-on-select=true ng-change=vm.bookingStatusChange()><ui-select-match placeholder=\"{{\'stateOfReservation\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"data.id as  data in vm.stateOfBookingArray | filter: $select.search\"><div ng-bind-html=data.name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><p><!-- <input type=\"radio\" name=\"searchByName\" value=\"0\" ng-model=\"vm.filterData.searchByName\"> --> <span>{{\'searchLabel\' | translate}}</span></p><p><input type=radio name=searchByName value=0 ng-model=vm.filterData.searchByName ng-change=vm.searchByNameRadioButtonChange()> <span class=padding-left-10>{{\'applicantPET\' | translate}}</span></p><p><input type=radio name=searchByName value=1 ng-model=vm.filterData.searchByName ng-change=vm.searchByNameRadioButtonChange()> <span class=padding-left-10>{{\'passengerPET\' | translate}}</span></p></div><div class=\"col-sm-4 col-md-3 col-lg-3 col-xs-4\"><label>Búsqueda por {{vm.filterData.searchByName == 2 ? (\'solicitantePET\' | translate) : (vm.filterData.searchByName == 0 ? (\'applicantPET\' | translate) : (\'passengerPET\' | translate))}}</label><div class=input-group><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model-options=\"{ debounce: 500 }\" ng-model=vm.filterData.searchByNameFilter ng-change=vm.getFilterForSearchByNameFilter()></div></div></div><div class=row style=\"padding-top: 10px;padding-bottom:10px\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px;float: right\" ng-click=vm.applyFilter()>Apply Filter</button></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px\" ng-click=vm.resetFilter()>{{\'resetFilterButton\' | translate}}</button></div></div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><p class=totalSize>{{\'totalBookings\' | translate}}: {{vm.totalCompletedBookings}}</p></div><br><br><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 paddingZero text-center\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><!-- <div class=\"col-sm-3 col-md-3 col-lg-3 mt10\" ng-if=\"vm.searchBookingField == true\">\n                                    <div class=\"input-group pt3\">\n                                        <div class=\"input-group-addon searchBackground\">\n                                            <i class=\"fa fa-search\"></i>\n                                        </div>\n                                        <input type=\"text\" id=\"searchText\" class=\"form-control\" placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model-options=\"{ debounce: 500 }\"\n                                            ng-model=\"vm.filterData.search\" ng-change=\"vm.getFilter()\">\n                                    </div>\n                                </div> --><!-- <div class=\"col-sm-3 col-md-3 col-lg-3 mt10\">\n                                        <div class=\"input-group pt3\">\n                                            <div class=\"input-group-addon searchBackground\">\n                                                <i class=\"fa fa-search\"></i>\n                                            </div>\n                                            <input type=\"text\" id=\"searchText\" class=\"form-control\" placeholder=\"{{\'searchAgreement\' | translate}}\" ng-model-options=\"{ debounce: 500 }\"\n                                                ng-model=\"vm.filterData.agreementSearch\" ng-change=\"vm.getFilterForAgreement()\">\n                                        </div>\n                                </div> --><div class=\"col-sm-3 col-md-3 col-lg-3 mt10\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchBookingId\' | translate}}\" is-number=\"\" ng-model-options=\"{ debounce: 500 }\" ng-model=vm.filterData.searchBookingId ng-change=vm.getFilterBookingId(vm.filterData.searchBookingId)></div></div><div class=\"col-sm-3 col-md-3 col-lg-3 mt10\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"Buscar Número Paquete\" is-number=\"\" ng-model-options=\"{ debounce: 500 }\" ng-model=vm.filterData.searchPackageId ng-change=vm.getFilterBookingId(vm.filterData.searchPackageId)></div></div><div class=\"col-sm-3 col-md-3 col-lg-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\"><!--ng-switch=\"(vm.completedBookingsList | filter:vm.search).length\"--><!--<div ng-switch-when=\"0\" class=\"noSearch\"><span>{{\'nothingFound\' | translate}}</span></div>--><table class=\"table table-hover tableWithMasterData\"><!--ng-switch-default--><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:105px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'job_id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'creationDate\' | translate}}\" text=\"\'creation_datetime\'\" check=vm.reverse>{{\'creationDate\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'actualStartDate\' | translate}}\" text=\"\'job_time\'\" check=vm.reverse>{{\'actualStartDate\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'status\' | translate}}\" text=\"\'job_status\'\" check=vm.reverse>{{\'status\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'pickUpAddress\' | translate}}\" text=\"\'job_pickup_address\'\" check=vm.reverse>{{\'pickUpAddress\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'dropOffAddress\' | translate}}\" text=\"\'job_address\'\" check=vm.reverse>{{\'dropOffAddress\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'passengersCount\' | translate}}\" text=\"\'number_of_passangers\'\" check=vm.reverse>{{\'passengersCount\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'customerDetails\' | translate}}\" text=\"\'created_by\'\" check=vm.reverse>{{\'customerDetails\' | translate}}</th><th style=\"width: 200px\" table-column-sorting current-text=vm.predicate title=\"{{\'thirdPersonBooking\' | translate}}\" text=\"\'job_pickup_name\'\" check=vm.reverse>{{\'thirdPersonBooking\' | translate}}</th><th style=\"width: 100px\" table-column-sorting current-text=vm.predicate title=\"{{\'tripType\' | translate}}\" text=\"\'type_of_trip\'\" check=vm.reverse>{{\'tripType\' | translate}}</th><th style=width:100px><div class=text-center>{{\'adjustedFare\' | translate}}</div></th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'packageId\' | translate}}\" text=\"\'shared_service_id\'\" check=vm.reverse>{{\'packageId\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'sharedGrouped\' | translate}}\" text=\"\'booking_type\'\" check=vm.reverse>{{\'sharedGrouped\' | translate}}</th><th style=width:100px><div class=text-center>{{\'action\' | translate}}</div></th><!--<th>--><!--<div class=\"text-center\">--><!--Ride Summary--><!--</div>--><!--</th>--></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.completedBookingsList | orderBy:vm.predicate:vm.reverse\"><!--| filter:vm.search--><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:105px>{{::data.job_id}}</td><td style=width:125px>{{vm.changeDateIntoSpanish(data.job_time)}} {{data.creation_datetime | date: \'HH:mm\'}}</td><td style=width:125px><span ng-if=!data.dateFlagForShow>{{vm.changeDateIntoSpanish(data.job_time)}} {{data.job_time | date: \'HH:mm\'}}<!--{{data.job_pickup_datetime | date: \'MMM d, yyyy hh:mm a\'}}--> </span><span ng-if=data.dateFlagForShow>{{data.job_time | date: \'HH:mm\'}}<!--{{data.job_pickup_datetime | date: \'hh:mm a\'}}--></span></td><td style=width:100px><sapn ng-if=\"data.job_status == \'0\'\">{{\'upcomingStatus\' | translate}}</sapn><sapn ng-if=\"data.job_status == \'1\'\">Viaje Iniciado</sapn><sapn ng-if=\"data.job_status == \'2\'\">Completada</sapn><sapn ng-if=\"data.job_status == \'3\'\">Failed</sapn><sapn ng-if=\"data.job_status == \'4\'\">En Posición</sapn><sapn ng-if=\"data.job_status == \'5\'\">Partial</sapn><sapn ng-if=\"data.job_status == \'6\'\">No Asignada</sapn><sapn ng-if=\"data.job_status == \'7\'\">Accepted</sapn><sapn ng-if=\"data.job_status == \'8\'\">Rejected</sapn><sapn ng-if=\"data.job_status == \'9\'\">Cancelada</sapn><sapn ng-if=\"data.job_status == \'10\'\">Deleted</sapn><sapn ng-if=\"data.job_status == \'11\'\">Ignored</sapn><sapn ng-if=\"data.job_status == \'12\'\">No Show</sapn><sapn ng-if=\"data.job_status == \'15\'\">En Camino</sapn></td><td style=\"width: 125px\">{{data.job_pickup_address || \'--\'}}</td><td style=\"width: 125px\">{{data.job_address || \'--\'}}</td><td style=width:125px>{{::data.number_of_passangers}}</td><td style=width:125px>{{\'name\' | translate}}: <b>{{data.customer_first_name + \' \' + data.customer_last_name}}</b><br>{{\'mobile_number\' | translate}}: <b>{{data.customer_country_code?data.customer_phone_number:data.customer_country_code+data.customer_phone_number}}</b><br>ID: <b>{{::data.created_by}}</b><br></td><td style=width:200px><div ng-if=data.booking_for>{{\'name\' | translate}}: <b>{{::data.job_pickup_name}}</b><br>{{\'mobile_number\' | translate}}: <b>{{::data.job_pickup_phone}}</b><br>Email: <b>{{data.job_pickup_email || \'--\'}}</b><br></div><div ng-if=!data.booking_for>NO</div></td><td style=width:100px>{{::data.type_of_trip}}</td><td style=width:100px><span ng-if=!data.is_adjusted>NO</span> <span ng-if=data.is_adjusted>YES</span></td><td style=width:125px>{{data.shared_service_id || \'--\'}}</td><td style=width:125px><span ng-if=\"data.booking_type == null\">--</span> <span ng-if=\"data.booking_type == 0\">Normal</span> <span ng-if=\"data.booking_type == 1\">{{\'Shared\' | translate}}</span> <span ng-if=\"data.booking_type == 2\">Grouped</span></td><td style=width:100px><!--<a title=\"View Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.completedBookingsMain.completedBookingDetails({id:\'{{data.job_id}}\',type:\'2\'})\">--><!--<i class=\"fa fa-eye\"></i>--><!--</a>--> <a title=\"View Details\" class=\"cursor editIconColor btn btn-sm\" ng-click=vm.bookingDetails(data)><!--ui-sref=\"layout.completedBookingsMain.completedBookingDetailsNew({id:\'{{data.job_id}}\',type:\'2\'})\"--> <i class=\"fa fa-eye\"></i></a></td><!--<td>--><!--<a title=\"Ride Summary\" class=\"btn btn-primary tableButton\" ui-sref=\"layout.completedBookingsMain.bookingSummary({id:\'{{data.job_id}}\',type:\'2\'})\">--><!--Ride Summary--><!--</a>--><!--</td>--></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=13 class=\"noDataClass text-center\">{{\'noCompletedFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav>--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\"--><!--ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/booking-list/completedBookingsMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/booking-list/groupMassiveQuickassignment.html","<h2 class=ng-cloak><!-- <span>Massive Assignment Grouped services</span> --> <span>Auto-asignación de Paquetes</span><!--<span class=\"pull-right\">--><!--<button class=\"btn btn-info\" title=\"{{\'filterButton\' | translate}}\" style=\"min-width: 100px;\" ng-click=\"vm.showFilterArea()\">{{\'filterButton\' | translate}}</button>--><!--<button class=\"btn btn-info\" title=\"{{\'resetButton\' | translate}}\" ng-click=\"vm.removeFilter()\">{{\'resetButton\' | translate}}</button>--><!--</span>--></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><!--<filter-sidebar show-filter-sidebar=\"vm.showFilterFlag\" filter-data=\"vm.filterData\" filter-to-show=\"vm.filterWhichToShow\" branch-detail-changed=\"vm.branchChangedFilter(vm.filterData)\"--><!--vehicle-detail-changed=\"vm.vehicleChangedFilter(vm.filterData)\" service-detail-changed=\"vm.serviceChangedFilter(vm.filterData)\"--><!--agreement-detail-changed=\"vm.agreementChangedFilter(vm.filterData)\" type-trip-detail-changed=\"vm.typeTripChangedFilter(vm.filterData)\"></filter-sidebar>--><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"border:1px solid #dedede;padding:0px\" ng-init=\"checkClicked = true\"><h2 class=\"text-center filtersStyle\" ng-click=\"checkClicked = !checkClicked; vm.slideData()\">Filters <span class=fa ng-class=\"{\'fa-caret-down\': checkClicked,\'fa-caret-up\': !checkClicked }\"></span></h2><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" id=derp><div class=row style=\"padding-top: 10px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'branchLabel\' | translate}}:</label><div><ui-select ng-model=vm.filterData.branch name=branch ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select></div></div><!-- <div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\">\n                                <label>{{\'agreementLabel\' | translate}}:</label>\n                                <div>\n                                    <ui-select ng-model=\"vm.filterData.agreement\" name=\"agreement\" ng-keyup=\"vm.agreementSearch($select.search,$event)\" required\n                                        close-on-select=\"true\">\n                                        <ui-select-match placeholder=\"{{\'agreementPlaceholder\' | translate}}\">\n                                            {{$select.selected.name}}\n                                        </ui-select-match>\n                                        <ui-select-choices repeat=\"agreements.id as agreements in vm.agreement | filter: $select.search | orderBy:\'name\' \" when-scrolled=\"vm.paginationChangedForAgreement()\"\n                                            when-scrolled=\"vm.paginationChangedForAgreement()\" ng-click=\"vm.agreementChanged()\">\n                                            <div ng-bind-html=\"agreements.name\"></div>\n                                        </ui-select-choices>\n                                    </ui-select>\n                                </div>\n                            </div> --><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'agreementLabel\' | translate}}:</label><div><ui-select multiple ng-model=vm.filterData.agreement name=agreement ng-change=vm.agreementChanged() ng-keyup=vm.agreementSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=\"{{\'agreementPlaceholder\' | translate}}\">{{$item.name}}</ui-select-match><ui-select-choices when-scrolled=vm.paginationChangedForAgreement() repeat=\"agreements.id as agreements in vm.agreement | filter: $select.search | orderBy:\'name\' \" when-scrolled=vm.paginationChangedForAgreement()><div ng-bind-html=agreements.name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'serviceLabel\' | translate}}:</label><div><ui-select multiple ng-model=vm.filterData.service name=service ng-change=vm.serviceChanged() ng-keyup=vm.serviceSearch($select.search,$event) required close-on-select=true><!-- <ui-select-match placeholder=\"{{\'selectTService\' | translate}}\">\n                                                {{$select.selected.name}}\n                                            </ui-select-match>\n                                            <ui-select-choices repeat=\"services.id as services in vm.service | filter: $select.search | orderBy:\'name\' \"\n                                             when-scrolled=\"vm.paginationChangedForService()\" ng-click=\"vm.serviceChanged()\">\n                                                <div ng-bind-html=\"services.name\"></div>\n                                            </ui-select-choices> --><ui-select-match placeholder=\"{{\'selectTripType\' | translate}}\">{{$item.name}}</ui-select-match><ui-select-choices when-scrolled=vm.paginationChangedForService() repeat=\"services.id as services in vm.service | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=services.name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'vehicleLabel\' | translate}}:</label><div><ui-select ng-model=vm.filterData.vehicle name=vehicle ng-keyup=vm.vehicleSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=\"{{\'vehicleSelect\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"vehicles.id as vehicles in vm.vehicle | filter: $select.search | orderBy:\'name\' \" when-scrolled=vm.paginationChangedForVehicle() ng-click=vm.vehicleChanged()><div ng-bind-html=vehicles.name></div></ui-select-choices></ui-select></div></div></div><div class=row style=\"padding-top: 10px;padding-bottom: 10px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'tripType\' | translate}}:</label><div><!-- <select   class=\"form-control\" ng-model=\"vm.filterData.type_of_trip\" ng-change=\"vm.typeTripChanged()\" ng-options=\"data.id as data.text for data in vm.typeTripFilter\">\n                                            <option value=\"\" selected disabled>{{\'selectTripType\' | translate}}</option>\n                                        </select> --><ui-select multiple ng-model=vm.filterData.type_of_trip name=trip required close-on-select=true ng-change=vm.typeTripChanged()><ui-select-match placeholder=\"{{\'selectTripType\' | translate}}\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"data.id as  data in vm.typeTripFilter | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=data.name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpDateFromLabel\' | translate}}:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} id=fromDate name=pickupDate ng-model=vm.filterData.filter_pickup_from_date_value placeholder=\"{{\'pickUpDateLabel\' | translate}}\" is-open=vm.datePicker_1.pickupFromDate datepicker-options=vm.dateOptions close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.pickupFromToDateChanged(1)> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_3(1)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpTimeFromLabel\' | translate}}:</label><div uib-timepicker ng-model=vm.filterData.filter_pickup_from_time_value show-spinners=false class=completed ng-change=vm.pickupFromToTimeChanged(1) hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpDateToLabel\' | translate}}:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} id=toDate name=pickupDate ng-model=vm.filterData.filter_pickup_to_date_value placeholder=\"{{\'pickUpDateToLabel\' | translate}}\" is-open=vm.datePicker_1.pickupToDate datepicker-options=vm.dateOptionsForEndDate close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.pickupFromToDateChanged(2)> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_3(2)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=row style=\"padding-top: 10px;padding-bottom:10px;padding-left: 15px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpTimeToLabel\' | translate}}:</label><div uib-timepicker ng-model=vm.filterData.filter_pickup_to_time_value show-spinners=false class=completed ng-change=vm.pickupFromToTimeChanged(2) hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian></div></div><div class=\"col-lg-2 col-sm-4 col-md-2 col-xs-4\"><button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px;margin-top:25px\" ng-click=vm.applyFilter()>Apply Filter</button></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px;margin-top:25px\" ng-click=vm.resetFilter()>{{\'resetFilterButton\' | translate}}</button></div></div><!--<div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\">--><!--<label>{{\'pickUpDateLabel\' | translate}}:</label>--><!--<p class=\"input-group\">--><!--<input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{vm.format}}\" name=\"pickupDate\" ng-model=\"vm.filterData.filter_pickup_date_value\"--><!--placeholder=\"{{\'pickUpDateLabel\' | translate}}\" is-open=\"vm.datePicker_1.pickupDate\" datepicker-options=\"vm.dateOptions\" required--><!--close-text=\"Close\" alt-input-formats=\"vm.altInputFormats\" show-button-bar=\"false\" readonly ng-change=\"vm.pickupDateChanged()\"/>--><!--<span class=\"input-group-btn\">--><!--<button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.datePickerE_1()\"><i--><!--class=\"glyphicon glyphicon-calendar\"></i></button>--><!--</span>--><!--</p>--><!--</div>--><!--<div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\">--><!--<label>{{\'pickUpTimeLabel\' | translate}}:</label>--><!--<div uib-timepicker ng-model=\"vm.filterData.filter_pickup_time_value\" show-spinners=\"false\" ng-change=\"vm.pickupTimeChanged()\" hour-step=\"vm.hstep\" minute-step=\"vm.mstep\" show-meridian=\"vm.ismeridian\"></div>--><!--</div>--><!-- <div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\">\n                                    <button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px;margin-top:25px;\" ng-click=\"vm.resetFilter()\">{{\'resetFilterButton\' | translate}}</button>\n                                </div> --></div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-5 col-sm-5 col-md-4 col-xs-4\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><!-- <div class=\"SideQuickAssignmentBarButton col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"padding: 0px\">\n                                <p class=\"input-group\">\n                                    <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{vm.format}}\" name=\"scheduledDate\" ng-model=\"vm.dataToFill.selectedDate\"\n                                        placeholder=\"{{\'scheduleDate\' | translate}}\" is-open=\"vm.datePicker_1.scheduledDate\" datepicker-options=\"vm.dateOptions\"\n                                        required ng-change=\"vm.scheduleDateChanged()\" close-text=\"Close\" alt-input-formats=\"vm.altInputFormats\"\n                                        show-button-bar=\"false\" readonly/>\n                                    <span class=\"input-group-btn\">\n                                        <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'1\')\">\n                                            <i class=\"glyphicon glyphicon-calendar\"></i>\n                                        </button>\n                                    </span>\n                                </p>\n                            </div> --><div class=\"SideQuickAssignmentBarButton col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"padding: 0px\"><div class=\"col-md-4 col-sm-4 col-xs-12\" style=\"padding: 0px\"><button style=\"width: 99%\" id=boxId1 ng-class=\"{\'defaulfColor\': vm.defaultcolorUnassign , \'colorChange\': !vm.defaultcolorUnassign}\">SIN ASIGNAR</button></div><div class=\"col-md-8 col-sm-8 col-xs-12\"><div class=\"col-md-3 col-sm-3\" style=\"padding: 0px\"><button ng-click=vm.resetSelectedData() class=reloadButton><i class=\"fa fa-refresh\" aria-hidden=true></i></button></div><div class=\"col-md-9 col-sm-9\" style=\"padding: 0px\"><button class=massiveButton ng-click=vm.massivePushToDrivers()>Auto Asignar ({{vm.selectedAutoAssignBookingCount}})</button></div></div></div><div class=\"SideQuickAssignmentBarMainHeading apps-container\"><div class=\"headingUnassigned SideQuickAssignmentBarHeading\" style=\"height: 30px;overflow-x: hidden\"><div class=\"BookingId timeGruop\" style=\"font-size: 13px;line-height: 1.7;text-align: center; padding-top: 3px;font-weight: bold;border-right: 1px solid black;margin: 0px\">Package ID</div><div class=\"TimeHeading timeGruop\" style=\"font-size: 13px;line-height: 1.7;text-align: center; padding-top: 3px;font-weight: bold;border-right: 1px solid black;margin: 0px\"><p>RETIRO</p></div><!-- <div class=\"timeGruop\" ng-if=\"data.is_round_trip == 1\"><p style=\"line-height: 2\">{{data.round_trip_pickup_time_utc | date: \'HH:mm\'}}</p><p style=\"line-height: 1;font-size: 10px;font-weight: bold\">{{data.round_trip_pickup_time_utc | date: short}}</p></div> --><div class=\"AddressHeading addressmain\" style=\"font-size: 13px;line-height: 1.7;text-align: center; padding-left: 50px;font-weight: bold;margin: 0px;border-right: 1px solid black\"><div class=address>DATOS PACKAGE</div><!-- <div class=\"Tripmain\">\n                                                    <div class=\"trip\">P</div>\n                                                    <div>{{data.service_name}}</div>\n                                                </div> --></div><div class=\"TimeHeading timeGruop\" style=\"font-size: 13px;line-height: 1.7;text-align: center; padding-top: 3px;font-weight: bold;margin: 0px\"><p>ESTADO</p></div></div></div><!-- <div ng-if=\"vm.loadMoreAssigned && vm.assignBookingFlag == true && vm.assignBookingList.length > 0\" style=\"text-align: center;margin: 5px;line-height: 2;\">\n                                <p>\n                                    <div ng-click=\"vm.loadMoreBookings()\" style=\"cursor: pointer;background-color: rgb(239, 125, 7);margin: auto;width: 100px;color: white;border-radius: 18px;font-weight: bold;\">Load More</div>\n                                </p>\n                            </div> --><div class=SideQuickAssignmentBar id=test1 when-scrolled=vm.paginationChangedForUnassignedAssign()><div class=SideQuickAssignmentBarNew ng-click=vm.bookingSelected(1,data,$index) ng-repeat=\"data in vm.UnAssignBookingList | orderBy:vm.predicate:vm.reverse\" ng-style=\"{\'color\':data.color}\" ng-class=\"{\'colorChangeNew apps-container\':  vm.colorFlag[$index] }\"><div class=timeGruop style=\"line-height: 2.7;margin-left: 3px\">{{data.shared_service_id}}</div><div class=timeGruop><p style=\"line-height: 2\">{{data.job_time_utc | date: \'HH:mm\'}}</p><p style=\"line-height: 1;font-size: 10px;font-weight: bold\">{{data.job_time_utc | date: short}}</p></div><!-- <div class=\"timeGruop\" ng-if=\"data.is_round_trip == 1 && data.round_trip_pickup_time_utc != null && data.round_trip_pickup_time_utc != \'0000-00-00 00:00:00\'\">\n                                    <p style=\"line-height: 2\">{{data.round_trip_pickup_time_utc | date: \'HH:mm\'}}</p>\n                                    <p style=\"line-height: 1;font-size: 10px;font-weight: bold\">{{data.round_trip_pickup_time_utc | date: short}}</p>\n                                </div> --><div class=addressmainGruop><div class=address><div style=\"font-weight: bold\">{{data.contract_name}}</div><div style=\"font-weight: bold;color: blue\">{{data.job_id}}</div><div ng-click=vm.showName()><span>{{data.job_pickup_name.length>12? data.job_pickup_name.substring(0,13)+\'...\':data.job_pickup_name}}</span></div><div style=\"font-style: italic\"><i class=\"fa fa-map-marker\" style=color:#A1A4A6></i> {{data.job_pickup_address.length>25? data.job_pickup_address.substring(0,26)+\'...\':data.job_pickup_address}}</div></div></div><div class=timeGruop><p ng-if=\"data.auto_assignment == 1 && data.booking_visibility_flag == 0\" style=\"line-height: 2;font-size: 13px;font-weight: bold\">Buscando Vehículo</p><p ng-if=\"data.auto_assignment == 1 && data.booking_visibility_flag == 1\" style=\"line-height: 2;font-size: 13px;font-weight: bold\">Fallido</p></div></div></div><div class=\"SideQuickAssignmentBarMainHeading apps-container\"></div><!-- <div ng-if=\"vm.loadMore && vm.UnassignBookingFlag == true && vm.UnAssignBookingList.length > 0 \" style=\"text-align: center;margin: 5px;line-height: 2;\">\n                                <p>\n                                    <div ng-click=\"vm.loadMoreBookings()\" style=\"cursor: pointer;background-color: rgb(239, 125, 7);margin: auto;width: 100px;color: white;border-radius: 18px;font-weight: bold;\">Load More</div>\n                                </p>\n                            </div> --><div style=\"font-size: 30px\" ng-if=\"vm.UnassignBookingFlag == true && vm.UnAssignBookingList.length == 0  && vm.loading == false\">No se encontraron reservas</div><div style=\"font-size: 30px\" ng-if=\"vm.assignBookingFlag == true && vm.assignBookingList.length == 0 && vm.loading == false\">No se encontraron reservas</div></div></div><div class=\"col-lg-7 col-sm-7 col-md-7 col-xs-7\"><p style=\"margin-top: 7px !important\" class=\"basicRegistrationP backgroundBasicPending text-center\">Package Assigned (Viaje No Iniciado)</p><div class=\"SideQuickAssignmentBarMainHeading apps-container\"><div class=\"headingUnassigned SideQuickAssignmentBarHeading\" style=\"height: 30px;overflow-x: hidden\"><div class=\"BookingId timegroupNew\" style=\"font-size: 13px;line-height: 1.7;text-align: center; padding-top: 3px;font-weight: bold;border-right: 1px solid black;margin: 0px\">PACKAGE ID</div><div class=\"TimeHeading timegroupNew\" style=\"font-size: 13px;line-height: 1.7;text-align: center; padding-top: 3px;font-weight: bold;border-right: 1px solid black;margin: 0px\"><p>RETIRO</p></div><!-- <div class=\"timeGruop\" ng-if=\"data.is_round_trip == 1\"><p style=\"line-height: 2\">{{data.round_trip_pickup_time_utc | date: \'HH:mm\'}}</p><p style=\"line-height: 1;font-size: 10px;font-weight: bold\">{{data.round_trip_pickup_time_utc | date: short}}</p></div> --><div class=\"AddressHeading addressmain\" style=\"font-size: 13px;line-height: 1.7;text-align: center; padding-left: 50px;font-weight: bold;margin: 0px;border-right: 1px solid black\"><div class=address>DATOS PACKAGE</div><!-- <div class=\"Tripmain\">\n                                                            <div class=\"trip\">P</div>\n                                                            <div>{{data.service_name}}</div>\n                                                        </div> --></div><div class=\"TimeHeading timegroupNew\" style=\"font-size: 13px;line-height: 1.7;text-align: center; padding-top: 3px;font-weight: bold;margin: 0px\"><p>VEHÍCULO</p></div><div class=\"TimeHeading timegroupNew\" style=\"font-size: 13px;line-height: 1.7;text-align: center; padding-top: 3px;font-weight: bold;margin: 0px\"><p>TIPO ASIG.</p></div><div class=\"TimeHeading timegroupNew\" style=\"font-size: 13px;line-height: 1.7;text-align: center; padding-top: 3px;font-weight: bold;margin: 0px\"><p>ESTADO</p></div></div></div><div class=SideQuickAssignmentBarAceepted id=test1 when-scrolled=vm.paginationChangedForAssignedAssign()><div class=SideQuickAssignmentBarAccpetedBar ng-repeat=\"data in vm.assignBookingList | orderBy:vm.predicate:vm.reverse\"><div class=timegroupNew style=\"line-height: 2.7;margin-left: 3px\">{{data.shared_service_id}}</div><div class=timegroupNew style=\"width: 42%\"><p style=\"line-height: 3\">{{data.job_time_utc | date: \'HH:mm\'}}</p></div><div class=addressmainAccpeted><div class=address><div style=\"font-weight: bold\">{{data.contract_name}}</div><div style=\"font-weight: bold;color: blue\">{{data.job_id}}</div><div ng-click=vm.showName()><span>{{data.job_pickup_name.length>12? data.job_pickup_name.substring(0,13)+\'...\':data.job_pickup_name}}</span></div><div style=\"font-style: italic\"><i class=\"fa fa-map-marker\" style=color:#A1A4A6></i> {{data.job_pickup_address.length>25? data.job_pickup_address.substring(0,26)+\'...\':data.job_pickup_address}}</div></div></div><div class=timegroupNew><div><span style=\"font-size: 14px;font-weight: bold\">#{{data.unique_car_id}}</span></div><div ng-click=vm.showName()><span>{{data.fleet_first_name.length>12? data.fleet_first_name.substring(0,13)+\'...\':data.fleet_first_name}}</span> <span>{{data.fleet_phone_number}}</span></div></div><div class=timegroupNew><span style=\"font-weight: bold\" ng-if=\"data.auto_assignment == 0 && data.assignment_identity != \'SYSTEM_SCAN_QR\'\">Asignada Manualmente </span><span style=\"font-weight: bold\" ng-if=\"data.auto_assignment == 1 && data.assignment_identity != \'SYSTEM_SCAN_QR\'\">Asignada Automáticamente </span><span style=\"font-weight: bold\" ng-if=\"data.assignment_identity == \'SYSTEM_SCAN_QR\'\">SYSTEM_SCAN_QR</span></div><div class=timegroupNew><span ng-if=\"data.job_status == \'0\'\">{{\'upcomingStatus\' | translate}}</span> <span ng-if=\"data.job_status == \'1\'\">Viaje Iniciado</span> <span ng-if=\"data.job_status == \'2\'\">Completada</span> <span ng-if=\"data.job_status == \'3\'\">Failed</span> <span ng-if=\"data.job_status == \'4\'\">En Posición</span> <span ng-if=\"data.job_status == \'5\'\">Partial</span> <span ng-if=\"data.job_status == \'6\'\">No Asignada</span> <span ng-if=\"data.job_status == \'7\'\">Accepted</span> <span ng-if=\"data.job_status == \'8\'\">Rejected</span> <span ng-if=\"data.job_status == \'9\'\">Cancelada</span> <span ng-if=\"data.job_status == \'10\'\">Deleted</span> <span ng-if=\"data.job_status == \'11\'\">Ignored</span> <span ng-if=\"data.job_status == \'12\'\">No Show</span> <span ng-if=\"data.job_status == \'15\'\">En Camino</span></div></div></div></div></div></div><br><br></div></div><div id=showPrint></div>");
$templateCache.put("app/components/views/booking-list/groupMassiveQuickassignmentMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/booking-list/massiveQuickassignment.html","<h2 class=ng-cloak><span>Massive Assignment Screen</span><!--<span class=\"pull-right\">--><!--<button class=\"btn btn-info\" title=\"{{\'filterButton\' | translate}}\" style=\"min-width: 100px;\" ng-click=\"vm.showFilterArea()\">{{\'filterButton\' | translate}}</button>--><!--<button class=\"btn btn-info\" title=\"{{\'resetButton\' | translate}}\" ng-click=\"vm.removeFilter()\">{{\'resetButton\' | translate}}</button>--><!--</span>--></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><!--<filter-sidebar show-filter-sidebar=\"vm.showFilterFlag\" filter-data=\"vm.filterData\" filter-to-show=\"vm.filterWhichToShow\" branch-detail-changed=\"vm.branchChangedFilter(vm.filterData)\"--><!--vehicle-detail-changed=\"vm.vehicleChangedFilter(vm.filterData)\" service-detail-changed=\"vm.serviceChangedFilter(vm.filterData)\"--><!--agreement-detail-changed=\"vm.agreementChangedFilter(vm.filterData)\" type-trip-detail-changed=\"vm.typeTripChangedFilter(vm.filterData)\"></filter-sidebar>--><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"border:1px solid #dedede;padding:0px\" ng-init=\"checkClicked = true\"><h2 class=\"text-center filtersStyle\" ng-click=\"checkClicked = !checkClicked; vm.slideData()\">Filters <span class=fa ng-class=\"{\'fa-caret-down\': checkClicked,\'fa-caret-up\': !checkClicked }\"></span></h2><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" id=derp><div class=row style=\"padding-top: 10px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'branchLabel\' | translate}}:</label><div><ui-select ng-model=vm.filterData.branch name=branch ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'agreementLabel\' | translate}}:</label><div><ui-select ng-model=vm.filterData.agreement name=agreement ng-keyup=vm.agreementSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=\"{{\'agreementPlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"agreements.id as agreements in vm.agreement | filter: $select.search | orderBy:\'name\' \" when-scrolled=vm.paginationChangedForAgreement() when-scrolled=vm.paginationChangedForAgreement() ng-click=vm.agreementChanged()><div ng-bind-html=agreements.name></div></ui-select-choices></ui-select></div></div><!-- <div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\">\n                                <label>{{\'agreementLabel\' | translate}}:</label>\n                                <div>\n                                    <ui-select multiple ng-model=\"vm.filterData.agreement\" name=\"agreement\" ng-change=\"vm.agreementChanged()\" ng-keyup=\"vm.agreementSearch($select.search,$event)\"\n                                        required close-on-select=\"true\">\n                                         <ui-select-match placeholder=\"{{\'agreementPlaceholder\' | translate}}\">\n                                            {{$item.name}}\n                                        </ui-select-match >\n                                        <ui-select-choices when-scrolled=\"vm.paginationChangedForAgreement()\" repeat=\"agreements.id as agreements in vm.agreement | filter: $select.search | orderBy:\'name\' \" when-scrolled=\"vm.paginationChangedForAgreement()\">\n                                            <div ng-bind-html=\"agreements.name\"></div>\n                                        </ui-select-choices>\n                                    </ui-select>\n                                </div>\n                            </div> --><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'serviceLabel\' | translate}}:</label><div><ui-select multiple ng-model=vm.filterData.service name=service ng-change=vm.serviceChanged() ng-keyup=vm.serviceSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=\"{{\'selectTripType\' | translate}}\">{{$item.name}}</ui-select-match><ui-select-choices when-scrolled=vm.paginationChangedForService() repeat=\"services.id as services in vm.service | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=services.name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'vehicleLabel\' | translate}}:</label><div><ui-select ng-model=vm.filterData.vehicle name=vehicle ng-keyup=vm.vehicleSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=\"{{\'vehicleSelect\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"vehicles.id as vehicles in vm.vehicle | filter: $select.search | orderBy:\'name\' \" when-scrolled=vm.paginationChangedForVehicle() ng-click=vm.vehicleChanged()><div ng-bind-html=vehicles.name></div></ui-select-choices></ui-select></div></div></div><div class=row style=\"padding-top: 10px;padding-bottom: 10px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'tripType\' | translate}}:</label><div><!-- <select   class=\"form-control\" ng-model=\"vm.filterData.type_of_trip\" ng-change=\"vm.typeTripChanged()\" ng-options=\"data.id as data.text for data in vm.typeTripFilter\">\n                                            <option value=\"\" selected disabled>{{\'selectTripType\' | translate}}</option>\n                                        </select> --><ui-select multiple ng-model=vm.filterData.type_of_trip name=trip required close-on-select=true ng-change=vm.typeTripChanged()><ui-select-match placeholder=\"{{\'selectTripType\' | translate}}\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"data.id as  data in vm.typeTripFilter | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=data.name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpDateFromLabel\' | translate}}:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} id=fromDate name=pickupDate ng-model=vm.filterData.filter_pickup_from_date_value placeholder=\"{{\'pickUpDateLabel\' | translate}}\" is-open=vm.datePicker_1.pickupFromDate datepicker-options=vm.dateOptions close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.pickupFromToDateChanged(1)> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_3(1)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpTimeFromLabel\' | translate}}:</label><div uib-timepicker ng-model=vm.filterData.filter_pickup_from_time_value show-spinners=false class=completed ng-change=vm.pickupFromToTimeChanged(1) hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpDateToLabel\' | translate}}:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} id=toDate name=pickupDate ng-model=vm.filterData.filter_pickup_to_date_value placeholder=\"{{\'pickUpDateToLabel\' | translate}}\" is-open=vm.datePicker_1.pickupToDate datepicker-options=vm.dateOptionsForEndDate close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.pickupFromToDateChanged(2)> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_3(2)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=row style=\"padding-top: 10px;padding-bottom:10px;padding-left: 15px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpTimeToLabel\' | translate}}:</label><div uib-timepicker ng-model=vm.filterData.filter_pickup_to_time_value show-spinners=false class=completed ng-change=vm.pickupFromToTimeChanged(2) hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian></div></div><div class=\"col-lg-2 col-sm-4 col-md-2 col-xs-4\"><button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px;margin-top:25px\" ng-click=vm.applyFilter()>Apply Filter</button></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px;margin-top:25px\" ng-click=vm.resetFilter()>{{\'resetFilterButton\' | translate}}</button></div></div><!--<div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\">--><!--<label>{{\'pickUpDateLabel\' | translate}}:</label>--><!--<p class=\"input-group\">--><!--<input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{vm.format}}\" name=\"pickupDate\" ng-model=\"vm.filterData.filter_pickup_date_value\"--><!--placeholder=\"{{\'pickUpDateLabel\' | translate}}\" is-open=\"vm.datePicker_1.pickupDate\" datepicker-options=\"vm.dateOptions\" required--><!--close-text=\"Close\" alt-input-formats=\"vm.altInputFormats\" show-button-bar=\"false\" readonly ng-change=\"vm.pickupDateChanged()\"/>--><!--<span class=\"input-group-btn\">--><!--<button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.datePickerE_1()\"><i--><!--class=\"glyphicon glyphicon-calendar\"></i></button>--><!--</span>--><!--</p>--><!--</div>--><!--<div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\">--><!--<label>{{\'pickUpTimeLabel\' | translate}}:</label>--><!--<div uib-timepicker ng-model=\"vm.filterData.filter_pickup_time_value\" show-spinners=\"false\" ng-change=\"vm.pickupTimeChanged()\" hour-step=\"vm.hstep\" minute-step=\"vm.mstep\" show-meridian=\"vm.ismeridian\"></div>--><!--</div>--><!-- <div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\">\n                                    <button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px;margin-top:25px;\" ng-click=\"vm.resetFilter()\">{{\'resetFilterButton\' | translate}}</button>\n                                </div> --></div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-5 col-sm-5 col-md-4 col-xs-4\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><!-- <div class=\"SideQuickAssignmentBarButton col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"padding: 0px\">\n                                <p class=\"input-group\">\n                                    <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{vm.format}}\" name=\"scheduledDate\" ng-model=\"vm.dataToFill.selectedDate\"\n                                        placeholder=\"{{\'scheduleDate\' | translate}}\" is-open=\"vm.datePicker_1.scheduledDate\" datepicker-options=\"vm.dateOptions\"\n                                        required ng-change=\"vm.scheduleDateChanged()\" close-text=\"Close\" alt-input-formats=\"vm.altInputFormats\"\n                                        show-button-bar=\"false\" readonly/>\n                                    <span class=\"input-group-btn\">\n                                        <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'1\')\">\n                                            <i class=\"glyphicon glyphicon-calendar\"></i>\n                                        </button>\n                                    </span>\n                                </p>\n                            </div> --><div class=\"SideQuickAssignmentBarButton col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"padding: 0px\"><div class=\"col-md-4 col-sm-4 col-xs-12\" style=\"padding: 0px\"><button style=\"width: 99%\" id=boxId1 ng-class=\"{\'defaulfColor\': vm.defaultcolorUnassign , \'colorChange\': !vm.defaultcolorUnassign}\">SIN ASIGNAR</button></div><div class=\"col-md-8 col-sm-8 col-xs-12\"><div class=\"col-md-3 col-sm-3\" style=\"padding: 0px\"><button ng-click=vm.resetSelectedData() class=reloadButton><i class=\"fa fa-refresh\" aria-hidden=true></i></button></div><div class=\"col-md-9 col-sm-9\" style=\"padding: 0px\"><button class=massiveButton ng-click=vm.massivePushToDrivers()>Auto Asignar ({{vm.selectedAutoAssignBookingCount}})</button></div></div></div><div class=\"SideQuickAssignmentBarMainHeading apps-container\"><div class=\"headingUnassigned SideQuickAssignmentBarHeading\" style=\"height: 30px;overflow-x: hidden\"><div class=\"BookingId time1\" style=\"font-size: 13px;line-height: 1.7;text-align: center; padding-top: 3px;font-weight: bold;border-right: 1px solid black;margin: 0px\">RVA</div><div class=\"TimeHeading time1\" style=\"font-size: 13px;line-height: 1.7;text-align: center; padding-top: 3px;font-weight: bold;border-right: 1px solid black;margin: 0px\"><p>RETIRO</p></div><!-- <div class=\"time1\" ng-if=\"data.is_round_trip == 1\"><p style=\"line-height: 2\">{{data.round_trip_pickup_time_utc | date: \'HH:mm\'}}</p><p style=\"line-height: 1;font-size: 10px;font-weight: bold\">{{data.round_trip_pickup_time_utc | date: short}}</p></div> --><div class=\"AddressHeading addressmain\" style=\"font-size: 13px;line-height: 1.7;text-align: center; padding-left: 50px;font-weight: bold;margin: 0px;border-right: 1px solid black\"><div class=address>DATOS RESERVAS</div><!-- <div class=\"Tripmain\">\n                                                    <div class=\"trip\">P</div>\n                                                    <div>{{data.service_name}}</div>\n                                                </div> --></div><div class=\"TimeHeading time1\" style=\"font-size: 13px;line-height: 1.7;text-align: center; padding-top: 3px;font-weight: bold;margin: 0px\"><p>ESTADO</p></div></div></div><!-- <div ng-if=\"vm.loadMoreAssigned && vm.assignBookingFlag == true && vm.assignBookingList.length > 0\" style=\"text-align: center;margin: 5px;line-height: 2;\">\n                                <p>\n                                    <div ng-click=\"vm.loadMoreBookings()\" style=\"cursor: pointer;background-color: rgb(239, 125, 7);margin: auto;width: 100px;color: white;border-radius: 18px;font-weight: bold;\">Load More</div>\n                                </p>\n                            </div> --><div class=SideQuickAssignmentBar id=test1 when-scrolled=vm.paginationChangedForUnassignedAssign()><div class=SideQuickAssignmentBarNew ng-click=vm.bookingSelected(1,data,$index) ng-repeat=\"data in vm.UnAssignBookingList | orderBy:vm.predicate:vm.reverse\" ng-style=\"{\'color\':data.color}\" ng-class=\"{\'colorChangeNew apps-container\':  vm.colorFlag[$index] }\"><div class=time1 style=\"line-height: 2.7;margin-left: 3px\">{{data.job_id}}</div><div class=time1><p style=\"line-height: 2\">{{data.job_time_utc | date: \'HH:mm\'}}</p><p style=\"line-height: 1;font-size: 10px;font-weight: bold\">{{data.job_time_utc | date: short}}</p></div><div class=time1 ng-if=\"data.is_round_trip == 1 && data.round_trip_pickup_time_utc != null && data.round_trip_pickup_time_utc != \'0000-00-00 00:00:00\'\"><p style=\"line-height: 2\">{{data.round_trip_pickup_time_utc | date: \'HH:mm\'}}</p><p style=\"line-height: 1;font-size: 10px;font-weight: bold\">{{data.round_trip_pickup_time_utc | date: short}}</p></div><div class=addressmain><div class=address><div style=\"font-weight: bold\">{{data.contract_name}}</div><div ng-click=vm.showName()><span style=\"color: blue;font-weight: bold\">{{data.is_VIP==1?\'VIP\':\'Normal\'}}</span> <span>{{data.job_pickup_name.length>12? data.job_pickup_name.substring(0,13)+\'...\':data.job_pickup_name}}</span> <span>{{data.job_pickup_phone}}</span></div><div style=\"font-style: italic\"><i class=\"fa fa-map-marker\" style=color:#A1A4A6></i> {{data.job_pickup_address.length>25? data.job_pickup_address.substring(0,26)+\'...\':data.job_pickup_address}}</div></div><!-- <div class=\"Tripmain\">\n                                            <div class=\"trip\">{{data.type_of_trip}}</div>\n                                            <div>{{data.service_name}}</div>\n                                        </div> --></div><div class=time1><p ng-if=\"data.auto_assignment == 1 && data.booking_visibility_flag == 0\" style=\"line-height: 2;font-size: 13px;font-weight: bold\">Buscando Vehículo</p><p ng-if=\"data.auto_assignment == 1 && data.booking_visibility_flag == 1\" style=\"line-height: 2;font-size: 13px;font-weight: bold\">Fallido</p></div></div></div><div class=\"SideQuickAssignmentBarMainHeading apps-container\"></div><!-- <div ng-if=\"vm.loadMore && vm.UnassignBookingFlag == true && vm.UnAssignBookingList.length > 0 \" style=\"text-align: center;margin: 5px;line-height: 2;\">\n                                <p>\n                                    <div ng-click=\"vm.loadMoreBookings()\" style=\"cursor: pointer;background-color: rgb(239, 125, 7);margin: auto;width: 100px;color: white;border-radius: 18px;font-weight: bold;\">Load More</div>\n                                </p>\n                            </div> --><div style=\"font-size: 30px\" ng-if=\"vm.UnassignBookingFlag == true && vm.UnAssignBookingList.length == 0  && vm.loading == false\">No se encontraron reservas</div><div style=\"font-size: 30px\" ng-if=\"vm.assignBookingFlag == true && vm.assignBookingList.length == 0 && vm.loading == false\">No se encontraron reservas</div></div></div><div class=\"col-lg-7 col-sm-7 col-md-7 col-xs-7\"><p style=\"margin-top: 7px !important\" class=\"basicRegistrationP backgroundBasicPending text-center\">Reservas Asignadas (viaje no iniciado)</p><div class=\"SideQuickAssignmentBarMainHeading apps-container\"><div class=\"headingUnassigned SideQuickAssignmentBarHeading\" style=\"height: 30px;overflow-x: hidden\"><div class=\"BookingId time2\" style=\"font-size: 13px;line-height: 1.7;text-align: center; padding-top: 3px;font-weight: bold;border-right: 1px solid black;margin: 0px\">RVA</div><div class=\"TimeHeading time4\" style=\"font-size: 13px;line-height: 1.7;text-align: center; padding-top: 3px;font-weight: bold;border-right: 1px solid black;margin: 0px\"><p>RETIRO</p></div><!-- <div class=\"time1\" ng-if=\"data.is_round_trip == 1\"><p style=\"line-height: 2\">{{data.round_trip_pickup_time_utc | date: \'HH:mm\'}}</p><p style=\"line-height: 1;font-size: 10px;font-weight: bold\">{{data.round_trip_pickup_time_utc | date: short}}</p></div> --><div class=\"AddressHeading addressmain\" style=\"font-size: 13px;line-height: 1.7;text-align: center; padding-left: 50px;font-weight: bold;margin: 0px;border-right: 1px solid black\"><div class=address>DATOS RESERVAS</div><!-- <div class=\"Tripmain\">\n                                                            <div class=\"trip\">P</div>\n                                                            <div>{{data.service_name}}</div>\n                                                        </div> --></div><div class=\"TimeHeading time2\" style=\"font-size: 13px;line-height: 1.7;text-align: center; padding-top: 3px;font-weight: bold;margin: 0px\"><p>VEHÍCULO</p></div><div class=\"TimeHeading time2\" style=\"font-size: 13px;line-height: 1.7;text-align: center; padding-top: 3px;font-weight: bold;margin: 0px\"><p>TIPO ASIG.</p></div><div class=\"TimeHeading time2\" style=\"font-size: 13px;line-height: 1.7;text-align: center; padding-top: 3px;font-weight: bold;margin: 0px\"><p>ESTADO</p></div><div class=\"TimeHeading time3\" style=\"font-size: 13px;line-height: 1.7;text-align: center; padding-top: 3px;font-weight: bold;margin: 0px\"><p>TV</p></div></div></div><div class=SideQuickAssignmentBarAceepted id=test1 when-scrolled=vm.paginationChangedForAssignedAssign()><div class=SideQuickAssignmentBarAccpetedBar ng-repeat=\"data in vm.assignBookingList | orderBy:vm.predicate:vm.reverse\"><div class=time2 style=\"line-height: 2.7;margin-left: 3px\">{{data.job_id}}</div><div class=time4 style=\"width: 42%\"><p style=\"line-height: 3\">{{data.job_time_utc | date: \'HH:mm\'}}</p></div><div class=addressmainAccpeted><div class=address><div style=\"font-weight: bold\">{{data.contract_name}}</div><div ng-click=vm.showName()><span style=\"color: blue;font-weight: bold\">{{data.is_VIP==1?\'VIP\':\'Normal\'}}</span> <span>{{data.job_pickup_name.length>12? data.job_pickup_name.substring(0,13)+\'...\':data.job_pickup_name}}</span> <span>{{data.job_pickup_phone}}</span></div><div style=\"font-style: italic\"><i class=\"fa fa-map-marker\" style=color:#A1A4A6></i> {{data.job_pickup_address.length>25? data.job_pickup_address.substring(0,26)+\'...\':data.job_pickup_address}}</div></div><!-- <div class=\"Tripmain\">\n                                                <div class=\"trip\">{{data.type_of_trip}}</div>\n                                                <div>{{data.service_name}}</div>\n                                            </div> --></div><div class=time2><div><span style=\"font-size: 14px;font-weight: bold\">#{{data.unique_car_id}}</span></div><div ng-click=vm.showName()><span>{{data.fleet_first_name.length>12? data.fleet_first_name.substring(0,13)+\'...\':data.fleet_first_name}}</span> <span>{{data.fleet_phone_number}}</span></div></div><div class=time2><span style=\"font-weight: bold\" ng-if=\"data.auto_assignment == 0 && data.assignment_identity != \'SYSTEM_SCAN_QR\'\">Asignada Manualmente </span><span style=\"font-weight: bold\" ng-if=\"data.auto_assignment == 1 && data.assignment_identity != \'SYSTEM_SCAN_QR\'\">Asignada Automáticamente </span><span style=\"font-weight: bold\" ng-if=\"data.assignment_identity == \'SYSTEM_SCAN_QR\'\">SYSTEM_SCAN_QR</span></div><div class=time2><span ng-if=\"data.job_status == \'0\'\">{{\'upcomingStatus\' | translate}}</span> <span ng-if=\"data.job_status == \'1\'\">Viaje Iniciado</span> <span ng-if=\"data.job_status == \'2\'\">Completada</span> <span ng-if=\"data.job_status == \'3\'\">Failed</span> <span ng-if=\"data.job_status == \'4\'\">En Posición</span> <span ng-if=\"data.job_status == \'5\'\">Partial</span> <span ng-if=\"data.job_status == \'6\'\">No Asignada</span> <span ng-if=\"data.job_status == \'7\'\">Accepted</span> <span ng-if=\"data.job_status == \'8\'\">Rejected</span> <span ng-if=\"data.job_status == \'9\'\">Cancelada</span> <span ng-if=\"data.job_status == \'10\'\">Deleted</span> <span ng-if=\"data.job_status == \'11\'\">Ignored</span> <span ng-if=\"data.job_status == \'12\'\">No Show</span> <span ng-if=\"data.job_status == \'15\'\">En Camino</span></div><div class=time3><span ng-if=\"data.schedule_ride == 0\">Viaje<br>inmediato</span> <span ng-if=\"data.schedule_ride == 1\">Viaje<br>programado</span></div></div></div></div></div></div><br><br></div></div><div id=showPrint></div>");
$templateCache.put("app/components/views/booking-list/massiveQuickassignmentMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/booking-list/ongoingBookings.html","<h2 class=ng-cloak><span>{{\'ongoingBookingHead\' | translate}}</span><!--<span class=\"pull-right\">--><!--<button class=\"btn btn-info\" title=\"{{\'filterButton\' | translate}}\" style=\"min-width: 100px;\" ng-click=\"vm.showFilterArea()\">{{\'filterButton\' | translate}}</button>--><!--<button class=\"btn btn-info\" title=\"{{\'resetButton\' | translate}}\" ng-click=\"vm.removeFilter()\">{{\'resetButton\' | translate}}</button>--><!--</span>--></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><!--<filter-sidebar show-filter-sidebar=\"vm.showFilterFlag\" filter-data=\"vm.filterData\" filter-to-show=\"vm.filterWhichToShow\" branch-detail-changed=\"vm.branchChangedFilter(vm.filterData)\"--><!--vehicle-detail-changed=\"vm.vehicleChangedFilter(vm.filterData)\" service-detail-changed=\"vm.serviceChangedFilter(vm.filterData)\"--><!--agreement-detail-changed=\"vm.agreementChangedFilter(vm.filterData)\" type-trip-detail-changed=\"vm.typeTripChangedFilter(vm.filterData)\"></filter-sidebar>--><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"border:1px solid #dedede;padding:0px\" ng-init=\"checkClicked = true\"><h2 class=\"text-center filtersStyle\" ng-click=\"checkClicked = !checkClicked; vm.slideData()\">{{\'filter\' | translate}} <span class=fa ng-class=\"{\'fa-caret-down\': checkClicked,\'fa-caret-up\': !checkClicked }\"></span></h2><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" id=derp><div class=row style=\"padding-top: 10px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'branchLabel\' | translate}}:</label><div><ui-select ng-model=vm.filterData.branch name=branch ng-keyup=vm.branchSearch($select.search,$event) ng-change=vm.branchChanged() required close-on-select=true><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices when-scrolled=vm.paginationChangedForBranch() repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \"><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'agreementLabel\' | translate}}:</label><div><ui-select ng-model=vm.filterData.agreement ng-keyup=vm.agreementSearch($select.search,$event) name=agreement ng-change=vm.agreementChanged() required close-on-select=true><ui-select-match placeholder=\"{{\'agreementPlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices when-scrolled=vm.paginationChangedForAgreement() repeat=\"agreements.id as agreements in vm.agreement | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=agreements.name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'serviceLabel\' | translate}}:</label><div><ui-select ng-model=vm.filterData.service ng-keyup=vm.serviceSearch($select.search,$event) name=service ng-change=vm.serviceChanged() required close-on-select=true><ui-select-match placeholder=\"{{\'selectTService\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices when-scrolled=vm.paginationChangedForService() repeat=\"services.id as services in vm.service | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=services.name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'vehicleLabel\' | translate}}:</label><div><ui-select ng-model=vm.filterData.vehicle ng-keyup=vm.vehicleSearch($select.search,$event) name=vehicle ng-change=vm.vehicleChanged() required close-on-select=true><ui-select-match placeholder=\"{{\'vehicleSelect\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices when-scrolled=vm.paginationChangedForVehicle() repeat=\"vehicles.id as vehicles in vm.vehicle | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=vehicles.name></div></ui-select-choices></ui-select></div></div></div><div class=row style=\"padding-top: 10px;padding-bottom: 10px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpDateFromLabelPET\' | translate}}:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} id=fromDate name=pickupDate ng-model=vm.filterData.filter_pickup_from_date_value placeholder=\"{{\'pickUpDateFromLabelPET\' | translate}}\" is-open=vm.datePicker_1.pickupFromDate datepicker-options=vm.dateOptions close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.pickupFromToDateChanged(1)> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_3(1)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpTimeFromLabelPET\' | translate}}:</label><div uib-timepicker ng-model=vm.filterData.filter_pickup_from_time_value show-spinners=false class=completed ng-change=vm.pickupFromToTimeChanged(1) hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpDateToLabelPET\' | translate}}:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} id=toDate name=pickupDate ng-model=vm.filterData.filter_pickup_to_date_value placeholder=\"{{\'pickUpDateToLabelPET\' | translate}}\" is-open=vm.datePicker_1.pickupToDate datepicker-options=vm.dateOptions close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.pickupFromToDateChanged(2)> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_3(2)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpTimeToLabelPET\' | translate}}:</label><div uib-timepicker ng-model=vm.filterData.filter_pickup_to_time_value show-spinners=false class=completed ng-change=vm.pickupFromToTimeChanged(2) hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian></div></div><!--<div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\">--><!--<label>{{\'pickUpDateLabel\' | translate}}:</label>--><!--<p class=\"input-group\">--><!--<input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{vm.format}}\" name=\"pickupDate\" ng-model=\"vm.filterData.filter_pickup_date_value\"--><!--placeholder=\"{{\'pickUpDateLabel\' | translate}}\" is-open=\"vm.datePicker_1.pickupDate\" datepicker-options=\"vm.dateOptions\" required--><!--close-text=\"Close\" alt-input-formats=\"vm.altInputFormats\" show-button-bar=\"false\" readonly ng-change=\"vm.pickupDateChanged()\"/>--><!--<span class=\"input-group-btn\">--><!--<button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.datePickerE_1()\"><i--><!--class=\"glyphicon glyphicon-calendar\"></i></button>--><!--</span>--><!--</p>--><!--</div>--><!--<div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\">--><!--<label>{{\'pickUpTimeLabel\' | translate}}:</label>--><!--<div uib-timepicker ng-model=\"vm.filterData.filter_pickup_time_value\" show-spinners=\"false\"--><!--ng-change=\"vm.pickupTimeChanged()\" hour-step=\"vm.hstep\" minute-step=\"vm.mstep\" show-meridian=\"vm.ismeridian\"></div>--><!--</div>--><!-- <div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\">\n                                <button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px;margin-top:25px;\" ng-click=\"vm.resetFilter()\">{{\'resetFilterButton\' | translate}}</button>\n                            </div> --></div><div class=row style=\"padding-top: 10px;padding-bottom:10px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'tripType\' | translate}}:</label><div><!-- <select class=\"form-control\" ng-model=\"vm.filterData.type_of_trip\" ng-change=\"vm.typeTripChanged()\" ng-options=\"data.id as data.text for data in vm.typeTripFilter\">\n                                                <option value=\"\" selected disabled>{{\'selectTripType\' | translate}}</option>\n                                            </select> --><ui-select multiple ng-model=vm.filterData.type_of_trip name=trip required close-on-select=true ng-change=vm.typeTripChanged()><ui-select-match placeholder=\"{{\'selectTripType\' | translate}}\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"data.id as  data in vm.typeTripFilter | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=data.name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'stateOfReservation\' | translate}}:</label><div><ui-select ng-model=vm.filterData.bookingStateValue name=stateOfReservation required close-on-select=true ng-change=vm.bookingStatusChange()><ui-select-match placeholder=\"{{\'stateOfReservation\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"data.id as  data in vm.stateOfBookingArray | filter: $select.search\"><div ng-bind-html=data.name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><p><!-- <input type=\"radio\" name=\"searchByName\" value=\"0\" ng-model=\"vm.filterData.searchByName\"> --> <span>{{\'searchLabel\' | translate}}</span></p><p><input type=radio name=searchByName value=0 ng-model=vm.filterData.searchByName ng-change=vm.searchByNameRadioButtonChange()> <span class=padding-left-10>{{\'applicantPET\' | translate}}</span></p><p><input type=radio name=searchByName value=1 ng-model=vm.filterData.searchByName ng-change=vm.searchByNameRadioButtonChange()> <span class=padding-left-10>{{\'passengerPET\' | translate}}</span></p></div><div class=\"col-sm-4 col-md-3 col-lg-3 col-xs-4\"><label>Búsqueda por {{vm.filterData.searchByName == 2 ? (\'solicitantePET\' | translate) : (vm.filterData.searchByName == 0 ? (\'applicantPET\' | translate) : (\'passengerPET\' | translate))}}</label><div class=input-group><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model-options=\"{ debounce: 500 }\" ng-model=vm.filterData.searchByNameFilter ng-change=vm.getFilterForSearchByNameFilter()></div></div></div><div class=row style=\"padding-top: 10px;padding-bottom:10px\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px;float: right\" ng-click=vm.applyFilter()>Apply Filter</button></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px\" ng-click=vm.resetFilter()>{{\'resetFilterButton\' | translate}}</button></div></div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><p class=totalSize>{{\'totalBookings\' | translate}}: {{vm.totalOngoingBookings}}</p></div><br><br><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 paddingZero text-center\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><!-- <div class=\"col-sm-3 col-md-3 col-lg-3 mt10\" ng-if=\"vm.searchBookingField == true\">\n                                    <div class=\"input-group pt3\">\n                                        <div class=\"input-group-addon searchBackground\">\n                                            <i class=\"fa fa-search\"></i>\n                                        </div>\n                                        <input type=\"text\" id=\"searchText\" class=\"form-control\" placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model-options=\"{ debounce: 500 }\"\n                                            ng-model=\"vm.filterData.search\" ng-change=\"vm.getFilter()\">\n                                    </div>\n                                </div> --><!-- <div class=\"col-sm-3 col-md-3 col-lg-3 mt10\">\n                                        <div class=\"input-group pt3\">\n                                            <div class=\"input-group-addon searchBackground\">\n                                                <i class=\"fa fa-search\"></i>\n                                            </div>\n                                            <input type=\"text\" id=\"searchText\" class=\"form-control\" placeholder=\"{{\'searchAgreement\' | translate}}\" ng-model-options=\"{ debounce: 500 }\"\n                                                ng-model=\"vm.filterData.agreementSearch\" ng-change=\"vm.getFilterForAgreement()\">\n                                        </div>\n                                </div> --><div class=\"col-sm-3 col-md-3 col-lg-3 mt10\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchBookingId\' | translate}}\" is-number=\"\" ng-model-options=\"{ debounce: 500 }\" ng-model=vm.filterData.searchBookingId ng-change=vm.getFilterBookingId(vm.filterData.searchBookingId)></div></div><div class=\"col-sm-3 col-md-3 col-lg-3 mt10\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"Buscar Número Paquete\" is-number=\"\" ng-model-options=\"{ debounce: 500 }\" ng-model=vm.filterData.searchPackageId ng-change=vm.getFilterBookingId(vm.filterData.searchPackageId)></div></div><div class=\"col-sm-3 col-md-3 col-lg-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\"><!-- ng-switch=\"(vm.ongoingBookingsList | filter:vm.search).length\"--><!--<div ng-switch-when=\"0\" class=\"noSearch\"><span>{{\'nothingFound\' | translate}}</span></div>--><table class=\"table table-hover tableWithMasterData\"><!--ng-switch-default--><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:105px table-column-sorting current-text=vm.predicate title=\"{{\'idBooking\' | translate}}\" text=\"\'job_id\'\" check=vm.reverse>{{\'idBooking\' | translate}}</th><th style=width:105px table-column-sorting current-text=vm.predicate title=\"{{\'idBooking\' | translate}}\" text=\"\'is_vip\'\" check=vm.reverse>VIP</th><!--<th>--><!--<div class=\"text-center\" ng-click=\"vm.sort(\'creation_datetime\')\">--><!--Creation Date--><!--<span ng-hide=\"vm.predicate == \'creation_datetime\' && vm.reverse || vm.predicate == \'creation_datetime\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'creation_datetime\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'creation_datetime\' && vm.reverse\" class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><th style=width:105px table-column-sorting current-text=vm.predicate title=\"{{\'dateTimePick\' | translate}}\" text=\"\'job_time\'\" check=vm.reverse>{{\'dateTimePick\' | translate}}</th><th style=width:110px table-column-sorting current-text=vm.predicate title=\"{{\'stateServiceLabel\' | translate}}\" text=\"\'job_status\'\" check=vm.reverse>{{\'stateServiceLabel\' | translate}}</th><th style=width:105px table-column-sorting current-text=vm.predicate title=\"{{\'etaText\' | translate}}\" text=\"\'etaPickUp\'\" check=vm.reverse>{{\'etaText\' | translate}}</th><th style=width:110px table-column-sorting current-text=vm.predicate title=\"{{\'etaDropText\' | translate}}\" text=\"\'etaDropoff\'\" check=vm.reverse>{{\'etaDropText\' | translate}}</th><th style=width:115px table-column-sorting current-text=vm.predicate title=\"{{\'customerDetailsHead\' | translate}}\" text=\"\'created_by\'\" check=vm.reverse>{{\'customerDetailsHead\' | translate}}</th><th style=\"width: 200px\" table-column-sorting current-text=vm.predicate title=\"{{\'thirdPersonBooking\' | translate}}\" text=\"\'job_pickup_name\'\" check=vm.reverse>{{\'thirdPersonBooking\' | translate}}</th><th style=width:115px table-column-sorting current-text=vm.predicate title=\"{{\'driverDetailsHead\' | translate}}\" text=\"\'transport_details\'\" check=vm.reverse>{{\'driverDetailsHead\' | translate}}</th><th style=\"width: 150px\" table-column-sorting current-text=vm.predicate title=\"{{\'pickUpAddress\' | translate}}\" text=\"\'job_pickup_address\'\" check=vm.reverse>{{\'pickUpAddress\' | translate}}</th><th style=\"width: 150px\" table-column-sorting current-text=vm.predicate title=\"{{\'dropOffAddress\' | translate}}\" text=\"\'job_address\'\" check=vm.reverse>{{\'dropOffAddress\' | translate}}</th><th style=\"width: 150px\" table-column-sorting current-text=vm.predicate title=\"{{\'estimatedPrice\' | translate}}\" text=\"\'estimated_payment_cost\'\" check=vm.reverse>{{\'estimatedPrice\' | translate}}</th><th style=\"width: 100px\" table-column-sorting current-text=vm.predicate title=\"{{\'branchLabel\' | translate}}\" text=\"\'branch\'\" check=vm.reverse>{{\'branchLabel\' | translate}}</th><th style=\"width: 125px\" table-column-sorting current-text=vm.predicate title=\"{{\'serviceLabel\' | translate}}\" text=\"\'type_of_service\'\" check=vm.reverse>{{\'serviceLabel\' | translate}}</th><th style=\"width: 125px\" table-column-sorting current-text=vm.predicate title=\"{{\'agreementLabel\' | translate}}\" text=\"\'agreement\'\" check=vm.reverse>{{\'agreementLabel\' | translate}}</th><th style=\"width: 100px\" table-column-sorting current-text=vm.predicate title=\"{{\'tripType\' | translate}}\" text=\"\'type_of_trip\'\" check=vm.reverse>{{\'tripType\' | translate}}</th><th style=\"width: 125px\" table-column-sorting current-text=vm.predicate title=\"{{\'packageId\' | translate}}\" text=\"\'shared_service_id\'\" check=vm.reverse>{{\'packageId\' | translate}}</th><th style=\"width: 125px\" table-column-sorting current-text=vm.predicate title=\"{{\'sharedGrouped\' | translate}}\" text=\"\'booking_type\'\" check=vm.reverse>{{\'sharedGrouped\' | translate}}</th><th style=\"width: 100px\"><div class=text-center>{{\'action\' | translate}}</div></th><th style=\"width: 125px\" ng-if=\"vm.userType == 0\"><div class=text-center>{{\'noShowLabel\' | translate}}</div></th><th style=\"width: 125px\" ng-if=\"vm.userType == 0\"><div class=text-center>{{\'manualUnassignLabel\' | translate}}</div></th><th style=\"width: 150px\"><div class=text-center>{{\'manualEvent\' | translate}}</div></th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.ongoingBookingsList | orderBy:vm.predicate:vm.reverse\"><!--| filter:vm.search--><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:105px>{{::data.job_id}}</td><td style=\"width: 95px\"><span ng-if=\"data.is_vip == 0\">No</span> <span ng-if=\"data.is_vip == 1\">Si</span></td><!--<td>{{data.creation_datetime | date: \'medium\'}}</td>--><td style=width:105px><!-- <span ng-if=\"!data.dateFlagForShow\">\n                                                 {{data.job_time | date: \'MMM d, yyyy HH:mm\'}}\n                                            </span>\n                                           <span ng-if=\"data.dateFlagForShow\">\n                                                {{data.job_time | date: \'HH:mm\'}}\n                                           </span> --> <span ng-if=!data.dateFlagForShow>{{vm.changeDateIntoSpanish(data.job_time)}} {{data.job_time | date: \'HH:mm\'}}<!--{{data.job_pickup_datetime | date: \'MMM d, yyyy hh:mm a\'}}--></span><br ng-if=!data.dateFlagForShow><span ng-if=data.dateFlagForShow>{{data.job_time | date: \'HH:mm\'}}<!--{{data.job_pickup_datetime | date: \'hh:mm a\'}}--></span><br ng-if=data.dateFlagForShow><span ng-if=\"data.flight_number != null\" style=\"font-weight: bold;margin-top: 20px\">{{data.flight_number}}</span></td><td style=width:110px><sapn ng-if=\"data.job_status == \'0\'\">{{\'upcomingStatus\' | translate}}</sapn><sapn ng-if=\"data.job_status == \'1\'\">Viaje Iniciado</sapn><sapn ng-if=\"data.job_status == \'2\'\">Completada</sapn><sapn ng-if=\"data.job_status == \'3\'\">Failed</sapn><sapn ng-if=\"data.job_status == \'4\'\">En Posición</sapn><sapn ng-if=\"data.job_status == \'5\'\">Partial</sapn><sapn ng-if=\"data.job_status == \'6\'\">No Asignada</sapn><sapn ng-if=\"data.job_status == \'7\'\">Accepted</sapn><sapn ng-if=\"data.job_status == \'8\'\">Rejected</sapn><sapn ng-if=\"data.job_status == \'9\'\">Cancelada</sapn><sapn ng-if=\"data.job_status == \'10\'\">Deleted</sapn><sapn ng-if=\"data.job_status == \'11\'\">Ignored</sapn><sapn ng-if=\"data.job_status == \'12\'\">No Show</sapn><sapn ng-if=\"data.job_status == \'15\'\">En Camino</sapn></td><td style=width:105px>{{data.etaPickUp || \'--\'}}</td><td style=width:110px>{{data.etaDropoff || \'--\'}}</td><td style=width:115px>{{\'name\' | translate}}: <b>{{data.customer_first_name + \' \' + data.customer_last_name}}</b><br>{{\'mobile_number\' | translate}}: <b>{{data.customer_country_code?data.customer_phone_number:data.customer_country_code+data.customer_phone_number}}</b><br>ID: <b>{{::data.created_by}}</b><br></td><td style=width:200px><div ng-if=data.booking_for>{{\'name\' | translate}}: <b>{{::data.job_pickup_name}}</b><br>{{\'mobile_number\' | translate}}: <b>{{::data.job_pickup_phone}}</b><br>Email: <b>{{data.job_pickup_email || \'--\'}}</b><br></div><div ng-if=!data.booking_for>NO</div></td><td style=width:115px><span ng-if=!data.fleet_first_name>No Assigned</span> <span ng-if=data.fleet_first_name>Vehicle #{{::data.transport_details}}<br>Unique #{{::data.unique_car_id}}<br>{{data.fleet_first_name + \' \' + data.fleet_last_name}}<br>{{data.fleet_country_code?data.fleet_phone_number:data.fleet_country_code + data.fleet_phone_number || \'--\'}}</span></td><td style=width:150px>{{data.job_pickup_address || \'--\'}}</td><td style=width:150px>{{data.job_address || \'--\'}}</td><td style=width:150px>${{data.estimated_payment_cost || \'0\'}}</td><td style=width:100px>{{data.branch || \'--\'}}</td><td style=width:125px>{{::data.type_of_service}}</td><td style=width:125px>{{::data.agreement}}</td><td style=width:100px>{{::data.type_of_trip}}</td><td style=width:125px>{{data.shared_service_id || \'--\'}}</td><td style=width:125px><span ng-if=\"data.booking_type == null\">--</span> <span ng-if=\"data.booking_type == 0\">Normal</span> <span ng-if=\"data.booking_type == 1\">{{\'Shared\' | translate}}</span> <span ng-if=\"data.booking_type == 2\">Grouped</span></td><td style=width:100px><!--<a title=\"View Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.ongoingBookingsMain.ongoingBookingDetails({id:\'{{data.job_id}}\',type:\'1\'})\">--><!--<i class=\"fa fa-eye\"></i>--><!--</a>--> <a title=\"View Details\" class=\"cursor editIconColor btn btn-sm\" ng-click=vm.bookingDetails(data)><!--ui-sref=\"layout.ongoingBookingsMain.ongoingBookingDetailsNew({id:\'{{data.job_id}}\',type:\'1\'})\"--> <i class=\"fa fa-eye\"></i></a></td><td style=width:125px ng-if=\"vm.userType == 0\"><a class=\"btn btn-primary tableButton mt5\" ng-click=vm.markNoShow(data,$event) title=\"{{\'noShowButton\' | translate}}\" ng-disabled=\"data.job_status == \'1\'\">{{\'noShowButton\' | translate}}</a></td><td style=width:125px ng-if=\"vm.userType == 0\"><a class=\"btn btn-primary tableButton mt5\" ng-disabled=\"data.job_status == \'1\'\" ng-click=vm.manualUnassignBooking(data,$event) title=\"{{\'unassignButton\' | translate}}\">{{\'unassignButton\' | translate}}</a></td><td style=width:150px><a class=\"btn btn-primary tableButton mt5\" ng-click=\"vm.makeBookingStatusChange(data,$event,\'arrived\')\" ng-if=\"vm.userType == 0 && data.job_status == 15\" style=\"background-color: rgb(237,125,49);border-color:rgb(237,125,49)\" title=\"{{\'vehicleArrived\' | translate}}\">{{\'vehicleArrived\' | translate}}</a> <a class=\"btn btn-primary tableButton mt5\" ng-click=\"vm.makeBookingStatusChange(data,$event,\'started\')\" ng-if=\"vm.userType == 0 && data.job_status == 4\" style=\"background-color: red;border-color:red\" title=\"{{\'tripStarted\' | translate}}\">{{\'tripStarted\' | translate}}</a> <a class=\"btn btn-primary tableButton mt5\" ng-click=\"vm.makeBookingStatusChange(data,$event,\'completed\')\" ng-if=\"vm.userType == 0 && data.job_status == 1\" style=\"background-color: rgb(0,112,192);border-color:rgb(0,112,192)\" title=\"{{\'endTrip\' | translate}}\">{{\'endTrip\' | translate}}</a> <a class=\"btn btn-primary tableButton mt5\" style=background-color:red;border-color:red ng-click=\"vm.makeBookingStatusChange(data,$event,\'cancel\')\" ng-if=\"data.job_status == 15 || (vm.shiftIdStatus == undefined && data.shift_id != null)\" title=\"{{\'cancelButton\' | translate}}\">{{\'cancelButton\' | translate}}</a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noOngoingFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav>--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\"--><!--ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div><div id=cancelPrint></div></div>");
$templateCache.put("app/components/views/booking-list/ongoingBookingsMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/booking-list/quickAssignment.html","<h2 class=ng-cloak><span>{{\'quickAssignment1\' | translate}}</span><!--<span class=\"pull-right\">--><!--<button class=\"btn btn-info\" title=\"{{\'filterButton\' | translate}}\" style=\"min-width: 100px;\" ng-click=\"vm.showFilterArea()\">{{\'filterButton\' | translate}}</button>--><!--<button class=\"btn btn-info\" title=\"{{\'resetButton\' | translate}}\" ng-click=\"vm.removeFilter()\">{{\'resetButton\' | translate}}</button>--><!--</span>--></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><!--<filter-sidebar show-filter-sidebar=\"vm.showFilterFlag\" filter-data=\"vm.filterData\" filter-to-show=\"vm.filterWhichToShow\" branch-detail-changed=\"vm.branchChangedFilter(vm.filterData)\"--><!--vehicle-detail-changed=\"vm.vehicleChangedFilter(vm.filterData)\" service-detail-changed=\"vm.serviceChangedFilter(vm.filterData)\"--><!--agreement-detail-changed=\"vm.agreementChangedFilter(vm.filterData)\" type-trip-detail-changed=\"vm.typeTripChangedFilter(vm.filterData)\"></filter-sidebar>--><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"border:1px solid #dedede;padding:0px\" ng-init=\"checkClicked = true\"><h2 class=\"text-center filtersStyle\" ng-click=\"checkClicked = !checkClicked; vm.slideData()\">Filters <span class=fa ng-class=\"{\'fa-caret-down\': checkClicked,\'fa-caret-up\': !checkClicked }\"></span></h2><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" id=derp><div class=row style=\"padding-top: 10px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'branchLabel\' | translate}}:</label><div><ui-select ng-model=vm.filterData.branch name=branch ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'agreementLabel\' | translate}}:</label><div><ui-select ng-model=vm.filterData.agreement name=agreement ng-keyup=vm.agreementSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=\"{{\'agreementPlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"agreements.id as agreements in vm.agreement | filter: $select.search | orderBy:\'name\' \" when-scrolled=vm.paginationChangedForAgreement() when-scrolled=vm.paginationChangedForAgreement() ng-click=vm.agreementChanged()><div ng-bind-html=agreements.name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'serviceLabel\' | translate}}:</label><div><ui-select multiple ng-model=vm.filterData.service name=service ng-change=vm.serviceChanged() ng-keyup=vm.serviceSearch($select.search,$event) required close-on-select=true><!-- <ui-select-match placeholder=\"{{\'selectTService\' | translate}}\">\n                                            {{$select.selected.name}}\n                                        </ui-select-match>\n                                        <ui-select-choices repeat=\"services.id as services in vm.service | filter: $select.search | orderBy:\'name\' \"\n                                         when-scrolled=\"vm.paginationChangedForService()\" ng-click=\"vm.serviceChanged()\">\n                                            <div ng-bind-html=\"services.name\"></div>\n                                        </ui-select-choices> --><ui-select-match placeholder=\"{{\'selectTripType\' | translate}}\">{{$item.name}}</ui-select-match><ui-select-choices when-scrolled=vm.paginationChangedForService() repeat=\"services.id as services in vm.service | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=services.name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'vehicleLabel\' | translate}}:</label><div><ui-select ng-model=vm.filterData.vehicle name=vehicle ng-keyup=vm.vehicleSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=\"{{\'vehicleSelect\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"vehicles.id as vehicles in vm.vehicle | filter: $select.search | orderBy:\'name\' \" when-scrolled=vm.paginationChangedForVehicle() ng-click=vm.vehicleChanged()><div ng-bind-html=vehicles.name></div></ui-select-choices></ui-select></div></div></div><div class=row style=\"padding-top: 10px;padding-bottom: 10px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'tripType\' | translate}}:</label><div><!-- <select   class=\"form-control\" ng-model=\"vm.filterData.type_of_trip\" ng-change=\"vm.typeTripChanged()\" ng-options=\"data.id as data.text for data in vm.typeTripFilter\">\n                                        <option value=\"\" selected disabled>{{\'selectTripType\' | translate}}</option>\n                                    </select> --><ui-select multiple ng-model=vm.filterData.type_of_trip name=trip required close-on-select=true ng-change=vm.typeTripChanged()><ui-select-match placeholder=\"{{\'selectTripType\' | translate}}\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"data.id as  data in vm.typeTripFilter | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=data.name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpDateFromLabel\' | translate}}:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} id=fromDate name=pickupDate ng-model=vm.filterData.filter_pickup_from_date_value placeholder=\"{{\'pickUpDateLabel\' | translate}}\" is-open=vm.datePicker_1.pickupFromDate datepicker-options=vm.dateOptions close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.pickupFromToDateChanged(1)> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_3(1)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpTimeFromLabel\' | translate}}:</label><div uib-timepicker ng-model=vm.filterData.filter_pickup_from_time_value show-spinners=false class=completed ng-change=vm.pickupFromToTimeChanged(1) hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpDateToLabel\' | translate}}:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} id=toDate name=pickupDate ng-model=vm.filterData.filter_pickup_to_date_value placeholder=\"{{\'pickUpDateToLabel\' | translate}}\" is-open=vm.datePicker_1.pickupToDate datepicker-options=vm.dateOptionsForEndDate close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.pickupFromToDateChanged(2)> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_3(2)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=row style=\"padding-top: 10px;padding-bottom:10px;padding-left: 15px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpTimeToLabel\' | translate}}:</label><div uib-timepicker ng-model=vm.filterData.filter_pickup_to_time_value show-spinners=false class=completed ng-change=vm.pickupFromToTimeChanged(2) hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian></div></div><div class=\"col-lg-2 col-sm-4 col-md-2 col-xs-4\"><button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px;margin-top:25px\" ng-click=vm.applyFilter()>Apply Filter</button></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px;margin-top:25px\" ng-click=vm.resetFilter()>{{\'resetFilterButton\' | translate}}</button></div></div><!--<div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\">--><!--<label>{{\'pickUpDateLabel\' | translate}}:</label>--><!--<p class=\"input-group\">--><!--<input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{vm.format}}\" name=\"pickupDate\" ng-model=\"vm.filterData.filter_pickup_date_value\"--><!--placeholder=\"{{\'pickUpDateLabel\' | translate}}\" is-open=\"vm.datePicker_1.pickupDate\" datepicker-options=\"vm.dateOptions\" required--><!--close-text=\"Close\" alt-input-formats=\"vm.altInputFormats\" show-button-bar=\"false\" readonly ng-change=\"vm.pickupDateChanged()\"/>--><!--<span class=\"input-group-btn\">--><!--<button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.datePickerE_1()\"><i--><!--class=\"glyphicon glyphicon-calendar\"></i></button>--><!--</span>--><!--</p>--><!--</div>--><!--<div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\">--><!--<label>{{\'pickUpTimeLabel\' | translate}}:</label>--><!--<div uib-timepicker ng-model=\"vm.filterData.filter_pickup_time_value\" show-spinners=\"false\" ng-change=\"vm.pickupTimeChanged()\" hour-step=\"vm.hstep\" minute-step=\"vm.mstep\" show-meridian=\"vm.ismeridian\"></div>--><!--</div>--><!-- <div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\">\n                                <button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px;margin-top:25px;\" ng-click=\"vm.resetFilter()\">{{\'resetFilterButton\' | translate}}</button>\n                            </div> --></div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-5 col-sm-5 col-md-4 col-xs-4\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><!-- <div class=\"SideQuickAssignmentBarButton col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"padding: 0px\">\n                            <p class=\"input-group\">\n                                <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{vm.format}}\" name=\"scheduledDate\" ng-model=\"vm.dataToFill.selectedDate\"\n                                    placeholder=\"{{\'scheduleDate\' | translate}}\" is-open=\"vm.datePicker_1.scheduledDate\" datepicker-options=\"vm.dateOptions\"\n                                    required ng-change=\"vm.scheduleDateChanged()\" close-text=\"Close\" alt-input-formats=\"vm.altInputFormats\"\n                                    show-button-bar=\"false\" readonly/>\n                                <span class=\"input-group-btn\">\n                                    <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'1\')\">\n                                        <i class=\"glyphicon glyphicon-calendar\"></i>\n                                    </button>\n                                </span>\n                            </p>\n                        </div> --><div class=\"SideQuickAssignmentBarButton col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"padding: 0px\"><div class=\"col-md-6 col-sm-6 col-xs-12\" style=\"padding: 0px\"><button style=\"width: 99%\" class=firstButton id=boxId1 ng-click=\"vm.unAssignBooking(\'boxId1\')\">Sin asignar</button></div><div class=\"col-md-6 col-sm-6 col-xs-12\" style=\"padding: 0px\"><button style=\"width: 100%\" class=secondButton id=boxId ng-click=\"vm.assignBooking(\'boxId\')\">Asignadas</button></div></div><div class=\"SideQuickAssignmentBarMainHeading apps-container\"><div class=\"headingUnassigned SideQuickAssignmentBarHeading\" style=\"height: 30px;overflow-x: hidden\" ng-if=\"vm.assignBookingFlag == true && vm.assignBookingList.length > 0\"><div class=\"BookingId time1\" style=\"font-size: 13px;line-height: 1.7;text-align: center; padding-top: 3px;font-weight: bold;border-right: 1px solid black;margin: 0px\">RVA</div><div class=\"TimeHeading time1\" style=\"font-size: 13px;line-height: 1.7;text-align: center; padding-top: 3px;font-weight: bold;border-right: 1px solid black;margin: 0px\"><p>RETIRO</p></div><!-- <div class=\"time1\" ng-if=\"data.is_round_trip == 1\"><p style=\"line-height: 2\">{{data.round_trip_pickup_time_utc | date: \'HH:mm\'}}</p><p style=\"line-height: 1;font-size: 10px;font-weight: bold\">{{data.round_trip_pickup_time_utc | date: short}}</p></div> --><div class=\"AddressHeading addressmain\" style=\"font-size: 13px;line-height: 1.7;text-align: center; padding-left: 50px;font-weight: bold;margin: 0px\"><div class=address>DATOS RESERVAS</div><!-- <div class=\"Tripmain\">\n                                                <div class=\"trip\">P</div>\n                                                <div>{{data.service_name}}</div>\n                                            </div> --></div></div></div><!-- <div ng-if=\"vm.loadMoreAssigned && vm.assignBookingFlag == true && vm.assignBookingList.length > 0\" style=\"text-align: center;margin: 5px;line-height: 2;\">\n                            <p>\n                                <div ng-click=\"vm.loadMoreBookings()\" style=\"cursor: pointer;background-color: rgb(239, 125, 7);margin: auto;width: 100px;color: white;border-radius: 18px;font-weight: bold;\">Load More</div>\n                            </p>\n                        </div> --><div class=SideQuickAssignmentBar id=test1 when-scrolled=vm.paginationChangedForUnassignedAssign()><div class=SideQuickAssignmentBar1 ng-if=\"vm.assignBookingFlag == true && vm.assignBookingList.length > 0\" ng-repeat=\"data in vm.assignBookingList | orderBy:vm.predicate:vm.reverse\"><div class=time1 style=\"line-height: 2.7;margin-left: 3px\">{{data.job_id}}</div><div class=time1><p style=\"line-height: 2\">{{data.job_time_utc | date: \'HH:mm\'}}</p><p style=\"line-height: 1;font-size: 10px;font-weight: bold\">{{data.job_time_utc | date: short}}</p></div><div class=time1 ng-if=\"data.is_round_trip == 1 && data.round_trip_pickup_time_utc != null && data.round_trip_pickup_time_utc != \'0000-00-00 00:00:00\'\"><p style=\"line-height: 2\">{{data.round_trip_pickup_time_utc | date: \'HH:mm\'}}</p><p style=\"line-height: 1;font-size: 10px;font-weight: bold\">{{data.round_trip_pickup_time_utc | date: short}}</p></div><div class=addressmain><div class=address><div style=\"font-weight: bold\">{{data.contract_name}}</div><div ng-click=vm.showName()><span style=\"color: blue;font-weight: bold\">{{data.is_VIP==1?\'VIP\':\'Normal\'}}</span> <span>{{data.job_pickup_name.length>12? data.job_pickup_name.substring(0,13)+\'...\':data.job_pickup_name}}</span> <span>{{data.job_pickup_phone}}</span></div><div style=\"font-style: italic\"><i class=\"fa fa-map-marker\" style=color:#A1A4A6></i> {{data.job_pickup_address.length>25? data.job_pickup_address.substring(0,26)+\'...\':data.job_pickup_address}}</div></div><!-- <div class=\"Tripmain\">\n                                        <div class=\"trip\">{{data.type_of_trip}}</div>\n                                        <div>{{data.service_name}}</div>\n                                    </div> --></div></div></div><div class=\"SideQuickAssignmentBarMainHeading apps-container\"><div class=\"headingUnassigned SideQuickAssignmentBarHeading\" style=\"height: 30px;overflow-x: hidden\" ng-if=\"vm.UnassignBookingFlag == true &&   vm.UnAssignBookingList.length > 0 \"><div class=\"BookingId time1\" style=\"font-size: 13px;line-height: 1.7;text-align: center; padding-top: 3px;font-weight: bold;border-right: 1px solid black;margin: 0px\">RVA</div><div class=\"TimeHeading time1\" style=\"font-size: 13px;line-height: 1.7;text-align: center; padding-top: 3px;font-weight: bold;border-right: 1px solid black;margin: 0px\"><p>RETIRO</p></div><!-- <div class=\"time1\" ng-if=\"data.is_round_trip == 1\"><p style=\"line-height: 2\">{{data.round_trip_pickup_time_utc | date: \'HH:mm\'}}</p><p style=\"line-height: 1;font-size: 10px;font-weight: bold\">{{data.round_trip_pickup_time_utc | date: short}}</p></div> --><div class=\"AddressHeading addressmain\" style=\"font-size: 13px;line-height: 1.7;text-align: center; padding-left: 50px;font-weight: bold;margin: 0px\"><div class=address>DATOS RESERVAS</div><!-- <div class=\"Tripmain\">\n                                                <div class=\"trip\">P</div>\n                                                <div>{{data.service_name}}</div>\n                                            </div> --></div></div></div><!-- <div ng-if=\"vm.loadMore && vm.UnassignBookingFlag == true && vm.UnAssignBookingList.length > 0 \" style=\"text-align: center;margin: 5px;line-height: 2;\">\n                            <p>\n                                <div ng-click=\"vm.loadMoreBookings()\" style=\"cursor: pointer;background-color: rgb(239, 125, 7);margin: auto;width: 100px;color: white;border-radius: 18px;font-weight: bold;\">Load More</div>\n                            </p>\n                        </div> --><div class=\"SideQuickAssignmentBar apps-container main-bookings-div\" when-scrolled=vm.paginationChangedForUnassigned()><div class=SideQuickAssignmentBar1 ng-click=vm.showFleetsWithFilter(1,data,$index) ng-if=\"vm.UnassignBookingFlag == true &&   vm.UnAssignBookingList.length > 0 \" ng-repeat=\"data in vm.UnAssignBookingList | orderBy:vm.predicate:vm.reverse\" ng-style=\"{\'color\':data.color}\" ng-class=\"{\'colorChange apps-container\':  vm.colorFlag[$index] }\"><div class=\"time1 colorChange1\" style=\"line-height: 2.7;margin-left: 3px\">{{data.job_id}}</div><div class=time1><p style=\"line-height: 2\">{{data.job_time_utc | date: \'HH:mm\'}}</p><p style=\"line-height: 1;font-size: 10px;font-weight: bold\">{{data.job_time_utc | date: short}}</p></div><div class=time1 ng-if=\"data.is_round_trip == 1 && data.round_trip_pickup_time_utc != null && data.round_trip_pickup_time_utc != \'0000-00-00 00:00:00\'\"><p style=\"line-height: 2\">{{data.round_trip_pickup_time_utc | date: \'HH:mm\'}}</p><p style=\"line-height: 1;font-size: 10px;font-weight: bold\">{{data.round_trip_pickup_time_utc | date: short}}</p></div><div class=addressmain><div class=address><div style=\"font-weight: bold\">{{data.contract_name}}</div><div ng-click=vm.showName()><span style=\"color: blue;font-weight: bold\">{{data.is_VIP==1?\'VIP\':\'Normal\'}}</span> <span>{{data.job_pickup_name.length>12? data.job_pickup_name.substring(0,13)+\'...\':data.job_pickup_name}}</span> <span>{{data.job_pickup_phone}}</span></div><div style=\"font-style: italic\"><i class=\"fa fa-map-marker\" style=color:#A1A4A6></i> {{data.job_pickup_address.length>25? data.job_pickup_address.substring(0,26)+\'...\':data.job_pickup_address}}</div></div><!-- <div class=\"Tripmain\">\n                                                <div class=\"trip\">P</div>\n                                                <div>{{data.service_name}}</div>\n                                            </div> --></div></div></div><div style=\"font-size: 30px\" ng-if=\"vm.UnassignBookingFlag == true && vm.UnAssignBookingList.length == 0  && vm.loading == false\">No se encontraron reservas</div><div style=\"font-size: 30px\" ng-if=\"vm.assignBookingFlag == true && vm.assignBookingList.length == 0 && vm.loading == false\">No se encontraron reservas</div></div></div><div class=\"col-lg-7 col-sm-7 col-md-7 col-xs-7 text-center\" style=\"max-height: 100vh\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div><div id=map-div-content class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\" style=position:relative ng-class=\"{\'whirl duo\' : vm.loadingOnMap }\"><div id=googleMap style=\"height: calc(100vh - 300px)\"></div><div style=\"position: absolute;bottom:30px;right:0;left:0;margin:auto;background-color: white;color:black;width:260px;padding:5px\" ng-if=vm.dataToFill.helpTraffic><span>Live Traffic</span>&nbsp;&nbsp;&nbsp;&nbsp; <span style=font-size:12px;color:grey>Fast</span>&nbsp;&nbsp; <span><img src=assets/images/traffic-legend.png> </span>&nbsp;&nbsp; <span style=font-size:12px;color:grey>Slow</span></div><div style=\"position: absolute;top:10px;left:25px\"><!-- <button ng-class=\"{\'offDuty\': !vm.offDuty_1,\'offDutyActive\' : vm.offDuty_1}\" type=\"button\" ng-click=\"vm.showFleetsWithFilter(2)\"\n                                                    title=\"{{\'offDutyLabel\' | translate}}\">\n                                                    <span>\n                                                        <i class=\"fa fa-map-marker\" aria-hidden=\"true\"></i>\n                                                    </span>&nbsp;{{vm.dataToFill.total_no_of_off_duty_drivers}}</button> --> <button ng-class=\"{\'onDuty\': !vm.onDuty_1,\'onDutyActive\' : vm.onDuty_1}\" type=button ng-click=vm.showFleetsWithFilter(7) title=\"{{\'onDutyLabel\' | translate}}\" class=boxShadow><span><i class=\"fa fa-map-marker\" aria-hidden=true></i> </span>&nbsp;{{vm.dataToFill.total_no_of_drivers_on_duty}}</button> <button ng-class=\"{\'newMarkerActive\': !vm.all_1,\'newMarkerAll\' : vm.all_1}\" type=button ng-click=vm.showFleetsWithFilter(6) style=color:white title=\"Servicio por comenzar\" class=boxShadow><span><i class=\"fa fa-map-marker\" aria-hidden=true></i> </span>&nbsp;{{vm.dataToFill.total_no_of_drivers_available1}}</button> <button ng-class=\"{\'started\': !vm.started_1,\'startedActive\' : vm.started_1}\" type=button ng-click=vm.showFleetsWithFilter(3) title=\"{{\'onRoadLabel\' | translate}}\" class=boxShadow><span><i class=\"fa fa-map-marker\" aria-hidden=true></i> </span>&nbsp;{{vm.dataToFill.total_no_of_started_drivers}}</button> <button ng-class=\"{\'atPosition\': !vm.inPosition_1,\'atPositionActive\' : vm.inPosition_1}\" type=button ng-click=vm.showFleetsWithFilter(5) title=\"{{\'atPositionLabel\' | translate}}\" class=boxShadow><span><i class=\"fa fa-map-marker\" aria-hidden=true></i> </span>&nbsp;{{vm.dataToFill.total_no_of_at_position_drivers}}</button> <button ng-class=\"{\'busy\': !vm.busy_1,\'busyActive\' : vm.busy_1}\" type=button ng-click=vm.showFleetsWithFilter(4) title=\"{{\'serviceStartedLabel\' | translate}}\" class=boxShadow><span><i class=\"fa fa-map-marker\" aria-hidden=true></i> </span>&nbsp;{{vm.dataToFill.total_no_of_busy_drivers}}</button></div><div style=\"position: absolute;top:10px;right:25px\"><input id=pac-input class=controls ng-change=vm.getSearchedAddress(vm.searchedAddress) type=text ng-model=vm.searchedAddress style=color:#000;width:220px;height:35px placeholder=\"{{\'searchLocationPlaceholder\' | translate}}\" google-place callback-fn=vm.ctrlFn(data)><!-- <input type=\"text\" ng-model=\"vm.uniqueCarNumberSearch\" placeholder=\"{{\'searchBoxPlaceholder\' | translate}}\" uib-typeahead=\"carsUnique as carsUnique.unique_car_id for carsUnique in vm.uniqueCarsArray | filter:{unique_car_id:$viewValue}\"\n                                                    typeahead-loading=\"loadingCustomers\" typeahead-no-results=\"noResults\" name=\"searchUnique\" typeahead-on-select=\"vm.onSelectingUnique(vm.uniqueCarNumberSearch)\"\n                                                    style=\"color:#000;width:220px;height:35px;margin-right:10px;\" ng-change=\"vm.getSearchedAddress(vm.uniqueCarNumberSearch)\"> --><!-- <input type=\"text\" ng-model=\"vm.uniqueCarNumberSearch\" placeholder=\"Buscar Vehículo\" typeahead-loading=\"loadingCustomers\"\n                                            typeahead-no-results=\"noResults\" name=\"searchUnique\" style=\"color:#000;width:110px;height:35px;margin-right:10px;\"\n                                            ng-blur=\"vm.getVehicleOnSearch(vm.uniqueCarNumberSearch)\">\n                                        <div ng-if=\"noResults\" class=\"mt5\" style=\"background-color: #fff;padding: 3px;width:120px;\"> --><!-- <span>\n                                                <i class=\"glyphicon glyphicon-remove\"></i> No Results Found</span> --></div></div></div><div style=clear:both></div></div></div></div></div><br><br></div></div></div><div id=showPrint></div>");
$templateCache.put("app/components/views/booking-list/quickAssignmentMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/booking-list/searchBooking.html","<h2 class=ng-cloak>{{\'searchBookingPage\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><!-- <div class=\"row\">\n                    <div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"border:1px solid #dedede;padding:0px;\" ng-init=\"checkClicked = true\">\n                        <h2 class=\"text-center filtersStyle\" ng-click=\"checkClicked = !checkClicked; vm.slideData()\">\n                            Filters\n                            <span class=\"fa\" ng-class=\"{\'fa-caret-down\': checkClicked,\'fa-caret-up\': !checkClicked }\"></span>\n                        </h2>\n                        <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" id=\"filterPanel\">\n                            <div class=\"row\" style=\"padding-top: 10px;\">\n                                <div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\">\n                                    <label>{{\'branchLabel\' | translate}}:</label>\n                                    <div>\n                                        <ui-select ng-model=\"vm.filterData.branch\" name=\"branch\" ng-change=\"vm.branchChanged()\" required close-on-select=\"true\"\n                                           >\n                                            <ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">\n                                                {{$select.selected.region_name}}\n                                            </ui-select-match>\n                                            <ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \">\n                                                <div ng-bind-html=\"branch.region_name\"></div>\n                                            </ui-select-choices>\n                                        </ui-select>\n                                    </div>\n                                </div>\n                                <div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\">\n                                    <label>{{\'agreementLabel\' | translate}}:</label>\n                                    <div>\n                                        <ui-select ng-model=\"vm.filterData.agreement\" name=\"agreement\" required close-on-select=\"true\" ng-change=\"vm.agreementChanged()\"\n                                           >\n                                            <ui-select-match placeholder=\"{{\'agreementPlaceholder\' | translate}}\">\n                                                {{$select.selected.name}}\n                                            </ui-select-match>\n                                            <ui-select-choices repeat=\"agreements.id as agreements in vm.agreement | filter: $select.search | orderBy:\'name\' \" >\n                                                <div ng-bind-html=\"agreements.name\"></div>\n                                            </ui-select-choices>\n                                        </ui-select>\n                                    </div>\n                                </div>\n                                <div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\">\n                                    <label>{{\'serviceLabel\' | translate}}:</label>\n                                    <div>\n                                        <ui-select ng-model=\"vm.filterData.service\" name=\"service\" required close-on-select=\"true\" ng-change=\"vm.serviceChanged()\"\n                                            >\n                                            <ui-select-match placeholder=\"{{\'selectTService\' | translate}}\">\n                                                {{$select.selected.name}}\n                                            </ui-select-match>\n                                            <ui-select-choices repeat=\"services.id as services in vm.service | filter: $select.search | orderBy:\'name\' \" >\n                                                <div ng-bind-html=\"services.name\"></div>\n                                            </ui-select-choices>\n                                        </ui-select>\n                                    </div>\n                                </div>\n                                <div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\">\n                                    <label>{{\'vehicleLabel\' | translate}}:</label>\n                                    <div>\n                                        <ui-select ng-model=\"vm.filterData.vehicle\" name=\"vehicle\" required close-on-select=\"true\" ng-change=\"vm.vehicleChanged()\"\n                                           >\n                                            <ui-select-match placeholder=\"{{\'vehicleSelect\' | translate}}\">\n                                                {{$select.selected.name}}\n                                            </ui-select-match>\n                                            <ui-select-choices repeat=\"vehicles.id as vehicles in vm.vehicle | filter: $select.search | orderBy:\'name\' \" >\n                                                <div ng-bind-html=\"vehicles.name\"></div>\n                                            </ui-select-choices>\n                                        </ui-select>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"row\" style=\"padding-top: 10px;padding-bottom: 10px;\">\n                                <div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\">\n                                    <label>{{\'tripType\' | translate}}:</label>\n                                    <div>\n                                        <ui-select multiple ng-model=\"vm.filterData.type_of_trip\" name=\"trip\" required close-on-select=\"true\" ng-change=\"vm.typeTripChanged()\">\n                                            <ui-select-match placeholder=\"{{\'selectTripType\' | translate}}\">\n                                                {{$item.name}}\n                                            </ui-select-match>\n                                            <ui-select-choices repeat=\"data.id as  data in vm.typeTripFilter | filter: $select.search | orderBy:\'name\' \">\n                                                <div ng-bind-html=\"data.name\"></div>\n                                            </ui-select-choices>\n                                        </ui-select>\n                                    </div>\n                                </div>\n                                \n                                <div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\">\n                                    <label>{{\'pickUpDateFromLabel\' | translate}}:</label>\n                                    <p class=\"input-group\">\n                                        <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{vm.format}}\" id=\"fromDate\" name=\"pickupDate\" ng-model=\"vm.filterData.filter_pickup_from_date_value\"\n                                            placeholder=\"{{\'pickUpDateLabel\' | translate}}\" is-open=\"vm.datePicker_1.pickupFromDate\"\n                                            datepicker-options=\"vm.dateOptions\" close-text=\"Close\" alt-input-formats=\"vm.altInputFormats\"\n                                            show-button-bar=\"false\" readonly ng-change=\"vm.pickupFromToDateChanged(1)\" />\n                                        <span class=\"input-group-btn\">\n                                        <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.datePickerE_3(1)\">\n                                                <i class=\"glyphicon glyphicon-calendar\"></i>\n                                            </button>\n                                        </span>\n                                    </p>\n                                </div>\n                                <div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\">\n                                        <label>{{\'pickUpTimeFromLabel\' | translate}}:</label>\n                                        <div uib-timepicker ng-model=\"vm.filterData.filter_pickup_from_time_value\" show-spinners=\"false\"\n                                             class=\"completed\"  ng-change=\"vm.pickupFromToTimeChanged(1)\" hour-step=\"vm.hstep\" minute-step=\"vm.mstep\" show-meridian=\"vm.ismeridian\"></div>\n                                    </div>\n                                <div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\">\n                                    <label>{{\'pickUpDateToLabel\' | translate}}:</label>\n                                    <p class=\"input-group\">\n                                        <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{vm.format}}\" id=\"toDate\" name=\"pickupDate\" ng-model=\"vm.filterData.filter_pickup_to_date_value\"\n                                            placeholder=\"{{\'pickUpDateToLabel\' | translate}}\"  is-open=\"vm.datePicker_1.pickupToDate\"\n                                            datepicker-options=\"vm.dateOptions\" close-text=\"Close\" alt-input-formats=\"vm.altInputFormats\"\n                                            show-button-bar=\"false\" readonly ng-change=\"vm.pickupFromToDateChanged(2)\" />\n                                        <span class=\"input-group-btn\">\n                                        <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.datePickerE_3(2)\">\n                                                <i class=\"glyphicon glyphicon-calendar\"></i>\n                                            </button>\n                                        </span>\n                                    </p>\n                                </div>\n                                <div class=\"row\" style=\"padding-top: 10px;padding-bottom:10px;padding-left: 15px\">\n                                        <div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\">\n                                            <label>{{\'pickUpTimeToLabel\' | translate}}:</label>\n                                            <div uib-timepicker ng-model=\"vm.filterData.filter_pickup_to_time_value\" show-spinners=\"false\" class=\"completed\"\n                                                 ng-change=\"vm.pickupFromToTimeChanged(2)\" hour-step=\"vm.hstep\" minute-step=\"vm.mstep\" show-meridian=\"vm.ismeridian\"></div>\n                                        </div>\n                                        <div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\">\n                                                <button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px;margin-top:25px;\" ng-click=\"vm.resetFilter()\">{{\'resetFilterButton\' | translate}}</button>\n                                            </div>\n                                </div>\n                               \n                            </div>\n                        </div>\n                    </div>\n                </div> --><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><p class=totalSize>{{\'totalBookings\' | translate}}: {{vm.totalSearchedBookings}}</p></div><br><br><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center paddingZero\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><!--<div class=\"col-sm-3 col-md-3 col-lg-3 mt10\" ng-if=\"vm.searchBookingField == true\">\n                                    <div class=\"input-group pt3\">\n                                        <div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i>\n                                        </div>\n                                        <input type=\"text\" id=\"searchText\" class=\"form-control\" placeholder=\"Buscar\"\n                                               ng-model-options=\"{ debounce: 500 }\" ng-model=\"vm.filterData.search\" ng-change=\"vm.getFilter()\">\n                                    </div>\n                                </div> --><div class=\"col-sm-3 col-md-3 col-lg-3 mt10\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"Buscar ID de reserva\" is-number=\"\" ng-model-options=\"{ debounce: 500 }\" ng-model=vm.filterData.searchBookingId ng-change=vm.getFilterBookingId(vm.filterData.searchBookingId)></div></div><div class=\"col-sm-3 col-md-3 col-lg-3 mt10\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"Buscar Número Paquete\" is-number=\"\" ng-model-options=\"{ debounce: 500 }\" ng-model=vm.filterData.searchPackageId ng-change=vm.getFilterBookingId(vm.filterData.searchPackageId)></div></div><div class=\"col-sm-3 col-md-3 col-lg-3 mt10\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"Buscar Número CUD\" ng-model-options=\"{ debounce: 500 }\" ng-model=vm.filterData.searchCUD ng-change=vm.getFilterBookingId(vm.filterData.searchCUD)></div></div><div class=\"col-sm-3 col-md-3 col-lg-3 mt10\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"Buscar Orden de Servicio\" ng-model-options=\"{ debounce: 500 }\" ng-model=vm.filterData.searchOrderService ng-change=vm.getFilterBookingId(vm.filterData.searchOrderService)></div></div><div class=\"col-sm-3 col-md-3 col-lg-3 text-left\"><!-- <label class=\"control-label\">Registros por página</label>\n                                    <select class=\"form-control\" ng-model=\"vm.itemsPerPageSelected\" ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=\"vm.getPagesCount()\"></select> --></div></div><div class=\"table-responsive tableWithMasterDataParentDive\"><!--ng-switch=\"(vm.searchedBookingList | filter:vm.search).length\"--><!--<div ng-switch-when=\"0\" class=\"noSearch\"><span>{{\'nothingFound\' | translate}}</span></div>--><table class=\"table table-hover tableWithMasterData\"><!--ng-switch-default--><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:105px table-column-sorting current-text=vm.predicate title=\"{{\'idBooking\' | translate}}\" text=\"\'job_id\'\" check=vm.reverse>Reserva</th><th style=width:105px table-column-sorting current-text=vm.predicate text=\"\'is_vip\'\" check=vm.reverse>VIP</th><!--<th>--><!--<div class=\"text-center\" ng-click=\"vm.sort(\'creation_datetime\')\">--><!--Creation Date--><!--<span ng-hide=\"vm.predicate == \'creation_datetime\' && vm.reverse || vm.predicate == \'creation_datetime\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'creation_datetime\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'creation_datetime\' && vm.reverse\" class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><th style=width:105px table-column-sorting current-text=vm.predicate title=\"{{\'dateTimePick\' | translate}}\" text=\"\'job_time\'\" check=vm.reverse>Fecha Retiro</th><th style=width:115px table-column-sorting current-text=vm.predicate title=\"{{\'assignmentState\' | translate}}\" text=\"\'transport_details\'\" check=vm.reverse>Asignación</th><th style=width:115px table-column-sorting current-text=vm.predicate title=\"{{\'passengersCount\' | translate}}\" text=\"\'number_of_passangers\'\" check=vm.reverse>Nro Pasajeros</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'customerDetails\' | translate}}\" text=\"\'created_by\'\" check=vm.reverse>Cliente</th><th style=\"width: 150px\" table-column-sorting current-text=vm.predicate title=\"{{\'thirdPersonBooking\' | translate}}\" text=\"\'job_pickup_name\'\" check=vm.reverse>Para un tercero</th><th style=\"width: 150px\" table-column-sorting current-text=vm.predicate title=\"{{\'pickUpAddress\' | translate}}\" text=\"\'job_pickup_address\'\" check=vm.reverse>Origen</th><th style=\"width: 150px\" table-column-sorting current-text=vm.predicate title=\"{{\'dropOffAddress\' | translate}}\" text=\"\'job_address\'\" check=vm.reverse>Destino</th><th style=\"width: 150px\" table-column-sorting current-text=vm.predicate title=\"Tipo Viaje\" text=\"\'type_of_trip\'\" check=vm.reverse>Tipo Viaje</th><th style=\"width: 150px\" table-column-sorting current-text=vm.predicate title=RT text=\"\'roundTrip\'\" check=vm.reverse>RT</th><th style=\"width: 150px\" table-column-sorting current-text=vm.predicate title=\"Estado Autorización\" text=\"\'is_auth\'\" check=vm.reverse>Estado Autorización</th><th style=\"width: 125px\" table-column-sorting current-text=vm.predicate title=Convenio text=\"\'agreement\'\" check=vm.reverse>Convenio</th><th style=\"width: 125px\" table-column-sorting current-text=vm.predicate title=\"Tipo Servicio\" text=\"\'type_of_service\'\" check=vm.reverse>Tipo Servicio</th><th style=\"width: 125px\" table-column-sorting current-text=vm.predicate title=\"Precio Estimado\" text=\"\'estimated_payment_cost\'\" check=vm.reverse>Precio Estimado</th><th style=\"width: 125px\" table-column-sorting current-text=vm.predicate title=\"Estado del pago\" text=\"\'payment_status\'\" check=vm.reverse>Estado del pago</th><th style=\"width: 125px\" table-column-sorting current-text=vm.predicate title=Estado text=\"\'job_status\'\" check=vm.reverse>Estado</th><th style=\"width: 125px\" table-column-sorting current-text=vm.predicate title=\"{{\'packageId\' | translate}}\" text=\"\'shared_service_id\'\" check=vm.reverse>{{\'packageId\' | translate}}</th><th style=\"width: 125px\" table-column-sorting current-text=vm.predicate title=\"{{\'sharedGrouped\' | translate}}\" text=\"\'booking_type\'\" check=vm.reverse>{{\'sharedGrouped\' | translate}}</th><th style=\"width: 500px\"><div class=text-center>Acción</div></th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in vm.searchedBookingList | orderBy:vm.predicate:vm.reverse\" ng-style=\"{\'color\':data.color}\"><!--| filter:vm.search--><td style=\"width: 70px\" hidden>{{data.index + 1}}</td><td style=\"width: 105px\">{{::data.job_id}}</td><td style=\"width: 95px\"><span ng-if=\"data.is_vip == 0\">No</span> <span ng-if=\"data.is_vip == 1\">Yes</span></td><!--<td>{{data.creation_datetime | date: \'medium\'}}</td>--><td style=\"width: 105px\"><span ng-if=!data.dateFlagForShow>{{vm.changeDateIntoSpanish(data.job_time)}} {{data.job_time | date: \'HH:mm\'}}<!--{{data.job_pickup_datetime | date: \'MMM d, yyyy hh:mm a\'}}--></span><br ng-if=!data.dateFlagForShow><span ng-if=data.dateFlagForShow>{{data.job_time | date: \'HH:mm\'}}<!--{{data.job_pickup_datetime | date: \'hh:mm a\'}}--></span><br ng-if=data.dateFlagForShow><span ng-if=\"data.flight_number != null\" style=\"font-weight: bold;margin-top: 20px\">{{data.flight_number}}</span></td><td style=\"width: 115px\"><span ng-if=!data.fleet_first_name>No Assigned</span> <span ng-if=data.fleet_first_name>Vehicle #{{::data.transport_details}}<br>Unique #{{::data.unique_car_id}}<br>{{data.fleet_first_name + \' \' + data.fleet_last_name}}<br>{{data.fleet_country_code?data.fleet_phone_number:data.fleet_country_code + data.fleet_phone_number || \'--\'}}</span></td><td style=\"width: 115px\">{{::data.number_of_passangers}}</td><td style=\"width: 125px\">{{\'name\' | translate}}: <b>{{data.customer_first_name + \' \' + data.customer_last_name}}</b><br>{{\'mobile_number\' | translate}}: <b>{{data.customer_country_code?data.customer_phone_number:data.customer_country_code+data.customer_phone_number}}</b><br>ID: <b>{{::data.created_by}}</b><br></td><td style=\"width: 150px\"><div ng-if=data.booking_for>{{\'name\' | translate}}: <b>{{::data.job_pickup_name}}</b><br>{{\'mobile_number\' | translate}}: <b>{{::data.job_pickup_phone}}</b><br>Email: <b>{{data.job_pickup_email || \'--\'}}</b><br></div><div ng-if=!data.booking_for>NO</div></td><td style=\"width: 150px\">{{data.job_pickup_address || \'--\'}}</td><td style=\"width: 150px\">{{data.job_address || \'--\'}}</td><td style=\"width: 150px\">{{::data.type_of_trip}}</td><td style=\"width: 150px\"><div ng-if=\"data.is_round_trip > 0\"><span ng-if=\"data.is_wait_time_included == 0\"><span ng-if=\"data.round_trip_parent_job_id == 0\">{{data.return_date_time | date: \'MMM d, yyyy HH:mm\'}}</span> <span ng-if=\"data.round_trip_parent_job_id != 0\">#{{data.round_trip_parent_job_id}}</span> </span><span ng-if=\"data.is_wait_time_included > 0\">Con Espera</span></div><span ng-if=\"data.is_round_trip == 0\"><span ng-if=\"data.round_trip_parent_job_id == 0\">NO</span> <a ui-sref=\"layout.upcomingBookingsMain.upcomingBookingDetailsNew({id:\'{{data.round_trip_parent_job_id}}\',type:\'0\'})\" ng-if=\"data.round_trip_parent_job_id != 0\"><span>#{{::data.round_trip_parent_job_id}}</span></a></span></td><td style=\"width: 150px\"><span ng-if=\"data.auth_required == 1\"><span ng-if=\"data.is_auth == 1\">Authorized</span> <span ng-if=\"data.is_auth == 2\">Rejected</span> <span ng-if=\"data.is_auth == 3\">Cancelled By Customer</span> <span ng-if=\"data.is_auth == 0\">Pending</span> </span><span ng-if=\"data.auth_required == 0\"><span>Not Required</span></span></td><td style=\"width: 125px\">{{data.agreement || \'--\'}}</td><td style=\"width: 125px\">{{::data.type_of_service}}</td><td style=\"width: 125px\">${{data.estimated_payment_cost || \'0\'}}</td><td style=\"width: 125px\"><span ng-if=\"data.payment_status == 0\">No Pagada</span> <span ng-if=\"data.payment_status == 1 || data.payment_status == 2\">Pagada</span></td><td style=\"width: 125px\"><sapn ng-if=\"data.job_status == \'0\'\">Creada</sapn><sapn ng-if=\"data.job_status == \'1\'\">Viaje Iniciado</sapn><sapn ng-if=\"data.job_status == \'2\'\">Completada</sapn><sapn ng-if=\"data.job_status == \'3\'\">Failed</sapn><sapn ng-if=\"data.job_status == \'4\'\">En Posición</sapn><sapn ng-if=\"data.job_status == \'5\'\">Partial</sapn><sapn ng-if=\"data.job_status == \'6\' || data.job_status == \'17\'\">No Asignada</sapn><sapn ng-if=\"data.job_status == \'7\'\">Accepted</sapn><sapn ng-if=\"data.job_status == \'8\'\">Rejected</sapn><sapn ng-if=\"data.job_status == \'9\'\">Cancelada</sapn><sapn ng-if=\"data.job_status == \'10\'\">Deleted</sapn><sapn ng-if=\"data.job_status == \'11\'\">Ignored</sapn><sapn ng-if=\"data.job_status == \'12\'\">No Show</sapn><sapn ng-if=\"data.job_status == \'15\'\">En Camino</sapn></td><td style=\"width: 125px\">{{data.shared_service_id || \'--\'}}</td><td style=\"width: 125px\"><span ng-if=\"data.booking_type == null\">--</span> <span ng-if=\"data.booking_type == 0\">Normal</span> <span ng-if=\"data.booking_type == 1\">Shared</span> <span ng-if=\"data.booking_type == 2\">Grouped</span></td><td style=\"width: 500px\"><div class=displayFlex><a title=Ver class=\"cursor editIconColor btn btn-sm\" ng-click=vm.bookingDetails(data)><!--ui-sref=\"layout.searchBookingMain.searchBookingDetailsNew({id:\'{{data.job_id}}\',type:\'3\'})\"--> <i class=\"fa fa-eye\"></i> </a><a class=\"btn btn-primary tableButton mt5 marginLeft\" title=Pagar ng-disabled=\"data.job_status == \'3\'|| data.job_status == \'9\'|| data.job_status == \'10\'||\n                                            data.job_status == \'11\'|| data.payment_status == 1 || vm.showPaidButton || data.payment_status == 2\" ng-click=vm.makePayment(data) ng-if=\"vm.userType == 0\">Pagar</a> <a class=\"btn btn-primary tableButton mt5 marginLeft\" title=Imprimir ng-disabled=\"data.job_status == \'2\' || data.job_status == \'3\'|| data.job_status == \'9\'|| data.job_status == \'10\'||\n                                            data.job_status == \'11\'|| data.job_status == \'12\'\" ng-click=vm.printReceiptApi(data) ng-if=\"vm.userType == 0\">Imprimir</a> <a class=\"btn btn-primary tableButton mt5 marginLeft\" title=Modificar ng-disabled=vm.checkModifyStatus(data) ng-click=vm.modifyBooking(data)>Modificar</a><!-- ui-sref=\"layout.createBookingMain.createBooking({id:\'{{data.job_id}}\'})\"--> <a class=\"btn btn-primary tableButton mt5 marginLeft\" title=Copiar ng-click=vm.copyTemplate(data)>Copiar</a> <a class=\"btn btn-primary tableButton mt5 marginLeft\" style=background-color:red;border-color:red ng-disabled=\"data.job_status == \'2\' || data.job_status == \'3\'||\n                                            data.job_status == \'9\'|| data.job_status == \'10\'|| data.job_status == \'11\'|| data.job_status == \'12\' || (vm.shiftIdStatus == undefined && data.shift_id != null )\" ng-click=\"vm.makeBookingStatusChange(data,$event,\'cancel\')\" title=Cancelar>Cancelar</a></div></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noReportFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div><input id=copy style=\"opacity: 0 ; z-index:0\" type=text><div id=showPrint></div><div id=cancelPrint></div></div>");
$templateCache.put("app/components/views/booking-list/searchBookingMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/booking-list/selfAssignment.html","<h2 class=ng-cloak><span>{{\'selfAssignmentHead\' | translate}}</span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><!--<filter-sidebar show-filter-sidebar=\"vm.showFilterFlag\" filter-data=\"vm.filterData\" filter-to-show=\"vm.filterWhichToShow\" branch-detail-changed=\"vm.branchChangedFilter(vm.filterData)\"--><!--modelity-detail-changed=\"vm.modelityChangedFilter(vm.filterData)\" approval-stage-detail-changed=\"vm.approvalChangedFilter(vm.filterData)\" applicant-detail-changed=\"vm.applicantChangedFilter(vm.filterData)\"></filter-sidebar>--><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"row mt5\"><!-- <br/>\n                <br/> --><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><div class=\"panel panel-default\"><div class=panel-body><div class=row style=\"max-width: 99.99%\"><div class=\"col-sm-6 col-md-6 col-lg-6\" style=\"padding: 0px;margin-left: 10px\"><div ng-repeat=\"data in vm.tipoServicios\" class=\"col-md-4 col-sm-6 col-xs-12\" style=\"padding: 0px\"><button style=\"width: 99%; {{ vm.serviceSelected == data.id ? \'background-color: rgb(239, 125, 7); color: white\' : \'\' }}\" class=firstButton id=boxId1 ng-click=vm.servicioSeleccionado(data.id)>{{ data.nombre }}</button></div><!--<div class=\"col-md-4 col-sm-6 col-xs-12 \" style=\"padding: 0px\">--><!--<button style=\"width: 99%; {{ vm.agrupadosSelected ? \'background-color: rgb(239, 125, 7); color: white\' : \'\' }}\" class=\"firstButton\" id=\"boxId1\" ng-click=\"vm.selectAgrupados()\">Agrupados</button>--><!--</div>--><!--<div class=\"col-md-4 col-sm-6 col-xs-12 \" style=\"padding: 0px\">--><!--<button style=\"width: 100%; {{ vm.exclusivosSelected ? \'background-color: rgb(239, 125, 7); color: white\' : \'\' }}\" class=\"secondButton\" id=\"boxId\" ng-click=\"vm.selectExclusivos()\">Exclusivos</button>--><!--</div>--></div></div><br><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6 text-right\" style=\"padding: 0px\"><a class=\"btn btn-primary\" title=\"Crear instancia\" ng-click=vm.instanceCreate() ui-sref=layout.selfAssignmentMain.selfAssignmentCreate>Crear instancia</a></div></div><br><div class=table-responsive><table class=\"table table-hover\" style=\"max-width: 80%\"><thead><tr style=\"border: none !important\"><th style=\"width:30px;border: none !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 18px;font-weight: 700\">Nombre instancia</p></th><th style=\"width:30px;border: none !important\"><p style=\"font-size: 18px;font-weight: 700\">Sucursal</p></th><th style=\"width:30px;border: none !important\"><p style=\"font-size: 18px;font-weight: 700\">Zonas</p></th><th style=\"width:30px;border: none !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p class=text-right style=\"font-size: 18px;font-weight: 700\">Acción</p></th></tr></thead><tbody style=\"font-size: 15px\"><tr ng-repeat=\"data in vm.instancias\"><td style=\"width:140px;border: none !important\"><p>{{ data.nombre }}</p></td><td><span ng-if=data.eliminable style=\"text-transform: capitalize\" ng-repeat=\"region in data.zones|unique: \'region.autoAssignRegions.regions.regionName\'\">{{ region.autoAssignRegions.regions.regionName }}{{$last ? \'\' : ($index==Users.length-2) ? \' and \' : \', \'}}</span> <span ng-if=!data.eliminable style=\"text-transform: capitalize\">{{ data.sucursal.regionName }}</span></td><td><span style=\"text-transform: capitalize\" ng-repeat=\"zone in data.zones\" nf-if=zone.autoAssignRegions>{{ zone.autoAssignRegions.regionName }}{{$last ? \'\' : (zone.autoAssignRegions) ? \', \': \'\'}}</span></td><td style=\"width: 150px;border-top: none\"><div class=text-right><a ng-if=data.eliminable class=\"cursor btn btn-sm editIconColor\" ng-click=vm.instanceDelete(data,$event)><i class=\"fa fa-lock\"></i> </a><a title=\"Edit Details\" class=\"cursor btn btn-sm editIconColor\" ng-click=vm.instanceEdit(data)><i class=\"fa fa-edit\"></i> </a><a title=\"View Details\" class=\"cursor btn btn-sm editIconColor\" ng-click=vm.instanceDetails(data)><i class=\"fa fa-eye\"></i></a></div></td></tr><!--<tr>\n                                            <td style=\"width:140px;\">\n                                                <p style=\"font-size: 18px;\">Instancia general</p>\n                                            </td>\n                                            <td style=\"width: 150px;border-top: none;\">\n                                                <div class=\"text-right\">\n\n                                                    <!-- <a ng-if=\"data.init\" title=\"View Details\" ng-style=\"{ \'margin-right\' : (data.init) ? \'30px\' : \'0px\' }\"  class=\"cursor btn btn-sm editIconColor\" ui-sref=\"layout.applicantsMain.applicantsDetails({id:\'{{data.fleet_id}}\'})\">\n                                                        <i ng-class=\"{\'fa fa-unlock\': data.is_blocked == 0,\'fa fa-lock\': data.is_blocked == 1}\"></i>\n                                                    </a> --><!--<a ng-if=\"data.init\"  class=\"cursor btn btn-sm\" ng-style=\"{ \'margin-right\' : (data.init) ? \'30px\' : \'0px\' }\"  ng-class=\"{\'blockIconColor\': data.is_blocked == 1, \'unblockIconColor\': data.is_blocked == 0}\"\n                                                    ng-click=\"vm.block_unblock($event,data.customer_id,data.is_blocked, data.name)\">\n                                                    <i ng-class=\"{\'fa fa-unlock\': data.is_blocked == 0,\'fa fa-lock\': data.is_blocked == 1}\"></i>\n                                                    </a>\n\n\n\n                                                    <a title=\"Edit Details\" class=\"cursor btn btn-sm editIconColor\" ng-click=\"vm.instanceEdit(data)\">\n                                                        <i class=\"fa fa-edit\"></i>\n                                                    </a>\n\n                                                    <a title=\"View Details\" class=\"cursor btn btn-sm editIconColor\" ng-click=\"vm.instanceDetails(data)\">\n                                                        <i class=\"fa fa-eye\"></i>\n                                                    </a>\n\n                                                    <!-- <a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=\"vm.deleteUser(data.fleet_id,$event)\">\n                                                        <i class=\"fa fa-trash\"></i>\n                                                    </a> --><!--</div>\n                                            </td>\n                                         \n                                        </tr>\n\n                                        <tr >\n                                            <td style=\"width:140px;\">\n                                                <p style=\"font-size: 18px;\">Horario valle</p>\n                                            </td>\n                                            <td style=\"width: 150px;\" >\n                                                <div class=\"text-right\">\n                                                    <a class=\"cursor btn btn-sm editIconColor\">\n                                                        <i class=\"fa fa-lock\"></i>\n                                                    </a>\n                                                    <a title=\"Edit Details\" style=\"margin-left: 30px;\" class=\"cursor btn btn-sm editIconColor\" ui-sref=\"layout.applicantsMain.editApplicantsDetails({id:\'{{data.fleet_id}}\'})\">\n                                                        <i class=\"fa fa-edit\"></i>\n                                                    </a>\n                                                    <a title=\"View Details\" class=\"cursor btn btn-sm editIconColor\" ui-sref=\"layout.applicantsMain.applicantsDetails({id:\'{{data.fleet_id}}\'})\">\n                                                        <i class=\"fa fa-eye\"></i>\n                                                    </a>\n\n                                                </div>\n                                            </td>\n                                         \n                                        </tr>--></tbody></table></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/booking-list/selfAssignmentCreate.html","<h2 class=ng-cloak><span>{{vm.filterInstance(vm.id)}} {{\'instancesCreatesHead\' | translate}}</span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"panel panel-default\"><div class=panel-body><form name=formInstance ng-submit=guardar_datos(formInstance,$event) novalidate autocomplete=off><div class=\"col-lg-6 col-sm-12 col-md-6 col-xs-12\" style=\"padding-right: 5%\"><!-- <div class=\"form-group\" style=\"margin-bottom: 50px;\">\n                <p style=\"font-size: 18px;text-align: left; font-weight: bold; padding-bottom: 10px;\">Nombre instancia</p>\n                <input ng-model=\"vm.dataForInstance.nombre\" type=\"text\" class=\"form-control\" id=\"exampleInputEmail1\" placeholder=\"Nombre\">\n              </div> --><div style=\"margin-bottom: 20px\"><p style=\"font-size: 18px;text-align: left; font-weight: bold; padding-bottom: 10px\">Nombre instancia <span style=color:red>*</span></p><input type=text ng-model=dataForInstance.nombre placeholder=Nombre class=form-control maxlength=55 name=nombre required ng-change=vm.onchange(dataForInstance.nombre) data-testid=instance_name><!--<div ng-hide=\"formInstance.nombre.$valid || formInstance.$pristine\" >--><!--<div class=\"errormessage text-danger\">Este campo es obligatorio.</div>--><!--</div>--><div ng-if=vm.isError><div class=\"errormessage text-danger\">Este campo es obligatorio.</div></div></div><div style=\"margin-bottom: 40px\"><p style=\"font-size: 18px;text-align: left; font-weight: bold; padding-bottom: 10px\">Zona de asignación <span style=color:red>*</span></p><div class=row><div class=\"col-lg-9 col-sm-9 col-md-9 col-xs-12\"><ui-select multiple data-testid=param_region_list ng-model=vm.selectedZones name=zones close-on-select=true on-select=\"vm.selectingZones($select.selected,\'select\')\" on-remove=\"vm.selectingZones($select.selected,\'remove\')\"><ui-select-match placeholder=\"Zona de asignación\">{{$item.regionName}}</ui-select-match><ui-select-choices when-scrolled=vm.paginationChangedForVehicle() repeat=\"z.id as z in vm.zones | filter: $select.search\"><div ng-bind-html=z.regionName></div></ui-select-choices></ui-select></div></div><div ng-if=vm.isError><div class=\"errormessage text-danger\">Este campo es obligatorio.</div></div></div><table class=\"table table-bordered\" id=globalTable><p style=\"font-size: 18px;text-align: left; font-weight: bold; padding-bottom: 10px\">Parámetros de autoasignación</p><thead><tr><td width=40%>{{\'name\' | translate}}</td><td width=40%>{{\'value\' | translate}}</td></tr></thead><tbody><tr ng-repeat=\"data in vm.parametersData\"><td><span data-testid=param_name>{{data.display_name}}</span></td><td><input ng-if=\"data.param != \'TYPE_DRIVER_ORDER\'\" ng-model=dataForInstance.params[data.id] min=0 class=form-control type=number name=\"param[{{ data.id }}]\" ng-keypress=\"restrictdecimals($event, data)\" data-testid=\"config_param_{{ data.param }}\"><select ng-if=\"data.param == \'TYPE_DRIVER_ORDER\'\" ng-model=dataForInstance.params[data.id] class=form-control ng-options=\"option.value as option.name for option in vm.prioridadOptions\" name=\"param[{{ data.id }}]\" data-testid=\"config_param_{{ data.param }}\"></select></td></tr></tbody></table></div><div class=\"col-lg-6 col-sm-12 col-md-6 col-xs-12\"><div class=row><div class=\"col-lg-6 col-sm-12 col-md-6 col-xs-12\"><p style=\"font-size: 18px;text-align: left; font-weight: bold; padding-bottom: 10px\">Bloques horario de funcionamiento</p></div><div class=\"col-sm-6 col-md-3 col-lg-3 text-right\" style=\"padding: 0px\"><a class=\"btn btn-primary\" title=\"{{\'approve\' | translate}}\" ng-click=vm.addInstance()>Agregar bloque</a></div></div><div class=table-responsive style=\"margin-top: 40px;min-height: 516px\"><table class=table style=\"border: none\"><thead><tr style=\"border: none !important\"><th style=\"width:30px;border: none !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 18px;font-weight: 700\">Día</p></th><th style=\"width:30px;border: none !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 18px;font-weight: 700\">Hora inicio</p></th><th style=\"width:30px;border: none !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 18px;font-weight: 700\">Hora término</p></th></tr></thead><tbody><tr ng-repeat=\"data in vm.blocks\"><td style=\"width:140px;border: none !important\"><p style=\"font-size: 18px\">{{vm.filterDay(data.dia)}}</p></td><td style=\"width:140px;border: none !important\"><p style=\"font-size: 18px\">{{data.hora_inicio}}</p></td><td style=\"width:140px;border: none !important\"><p style=\"font-size: 18px\">{{data.hora_fin}}</p></td><td style=\"width:140px;border: none !important\"><a title=\"Borrar bloque\" style=\"font-size: 20px\" class=cursor ng-click=vm.removeBlock(data)><i class=\"fa fa-times-circle fa-lg\"></i></a></td></tr><tr ng-if=vm.isAdd><td style=\"width:140px;border: none !important\"><select class=form-control ng-model=vm.dataForBlock.dia ng-change=vm.approvalValueChanged()><option value=\"\" disabled>Seleccionar día de la semana</option><option id=1 value=1>Lunes</option><option id=2 value=2>Martes</option><option id=3 value=3>Miércoles</option><option id=4 value=4>Jueves</option><option id=5 value=5>Viernes</option><option id=6 value=6>Sábado</option><option id=7 value=7>Domingo</option></select><!-- <select class=\"form-control\" ng-model=\"vm.dataForBlock.dia\" ng-options=\"days.id as days.nombre for days in daysArray\">\n                                    <option value=\"\" disabled>Seleccionar día de la semana</option>\n                                </select> --></td><td style=\"width:140px;border: none !important;vertical-align: middle;text-align: center\"><!-- <p style=\"font-size: 15px\">00:00</p> --><!--<input type=\"time\" ng-model=\"vm.dataForBlock.fecha_inicio\" min=\"05:00\" max=\"00:00\" step=\"00:15\" name=\"fechaIncio\" id=\"echaIncio\">--><div class=row style=\"padding-left: 23px\"><div class=col-md-5 style=\"padding-left: 3px;padding-right: 3px;max-width: 55px\"><ui-select ng-model=vm.dataForBlock.fecha_inicio.hora name=hora ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match>{{$select.selected.id}}</ui-select-match><ui-select-choices repeat=\"hours.id as hours in vm.hoursArray\" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=hours.id></div></ui-select-choices></ui-select></div><div class=col-md-2 style=\"padding-left: 0px;padding-right: 0px;max-width: 2px; align-items:center;margin-top: 5px\">:</div><div class=col-md-5 style=\"padding-left: 3px;padding-right: 3px;max-width: 55px\"><ui-select style=\"padding: 0px\" ng-model=vm.dataForBlock.fecha_inicio.minute name=minutos ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match>{{$select.selected.id}}</ui-select-match><ui-select-choices repeat=\"minutes.id as minutes in vm.minutesArray\" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=minutes.id></div></ui-select-choices></ui-select></div></div></td><td style=\"width:140px;border: none !important;vertical-align: middle\"><!-- <p style=\"font-size: 15px\">06:00</p> --><!--<input type=\"time\" ng-model=\"vm.dataForBlock.fecha_fin\" step=\"00:15\" name=\"fechaFin\" id=\"fechaFin\">--><div class=row style=\"padding-left: 23px\"><div class=col-md-5 style=\"padding-left: 3px;padding-right: 3px;max-width: 55px\"><ui-select ng-model=vm.dataForBlock.fecha_fin.hora name=hora ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match>{{$select.selected.id}}</ui-select-match><ui-select-choices repeat=\"hours.id as hours in vm.hoursArray\" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=hours.id></div></ui-select-choices></ui-select></div><div class=col-md-2 style=\"padding-left: 0px;padding-right: 0px;max-width: 2px; align-items:center;margin-top: 5px\">:</div><div class=col-md-5 style=\"padding-left: 3px;padding-right: 3px;max-width: 55px\"><ui-select style=\"padding: 0px\" ng-model=vm.dataForBlock.fecha_fin.minute name=minutos ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match>{{$select.selected.id}}</ui-select-match><ui-select-choices repeat=\"minutes.id as minutes in vm.minutesArray\" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=minutes.id></div></ui-select-choices></ui-select></div></div></td><td style=\"width:100px;border: none !important;vertical-align: middle\"><div><a type=button style=\"padding-left: 3px;padding-right: 3px\" class=\"btn btn-primary btn-xs\" title=\"{{\'approve\' | translate}}\" ng-click=vm.saveBlock(vm.dataForBlock)>Guardar</a></div></td></tr></tbody></table></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center mt5 mb0\"><div style=\"flex: 1\"><button class=btn ng-click=vm.cancel() type=button style=\"height: 35px;line-height: 20px;margin-right: 5px\">Cancelar</button><!-- <button class=\"btn btn-primary ng-binding\" type=\"button\" style=\"height: 35px;line-height: 20px;\" ng-click=\"vm.saveInstance(vm.dataForInstance)\">Guardar\n                        </button> --> <button class=\"btn btn-primary ng-binding\" type=submit style=\"height: 35px;line-height: 20px\">Guardar</button></div></div></div></form></div></div></div></div><script type=text/ng-template id=customTemplate.html><a style=\"cursor: pointer;\">\n        <span class=\"displayFlex\">\n            <span style=\"padding-left: 10px;\">\n                <span ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"></span>\n            </span>\n        </span>\n    </a></script>");
$templateCache.put("app/components/views/booking-list/selfAssignmentDelete.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/booking-list/selfAssignmentDetails.html","<style>.table-borderless > tbody > tr > td,\n.table-borderless > tbody > tr > th,\n.table-borderless > tfoot > tr > td,\n.table-borderless > tfoot > tr > th,\n.table-borderless > thead > tr > td,\n.table-borderless > thead > tr > th {\n    border: none;\n}</style><h2 class=ng-cloak><span>{{ vm.booking_type }} {{\'instancesDetailsHead\' | translate}}</span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6 table-responsive\"><div class=col-md-12 style=padding-left:0><label class=\"control-label ng-binding\">Nombre instancia</label></div><div class=col-md-12 style=padding-left:0><input style=\"width: 100%\" type=text value=\"{{ vm.nombre_instancia }}\" class=form-control data-testid=instance_name readonly></div><div style=\"margin-top: 40px\" ng-if=vm.eliminable><p style=\"font-size: 12px;text-align: left; font-weight: bold; padding-bottom: 10px\">Zona de asignación</p><div class=row><div class=\"col-lg-9 col-sm-9 col-md-9 col-xs-12\"><ui-select multiple data-testid=param_region_list ng-model=vm.selectedZones name=zones close-on-select=true on-select=\"vm.selectingZones($select.selected,\'select\')\" on-remove=\"vm.selectingZones($select.selected,\'remove\')\" readonly><ui-select-match placeholder=\"Zona de asignación\">{{$item.regionName}}</ui-select-match><ui-select-choices><div ng-bind-html=z.regionName></div></ui-select-choices></ui-select></div></div></div><div style=\"margin-bottom: 40px\" ng-if=!vm.eliminable><p style=\"font-size: 12px;text-align: left; font-weight: bold; padding-bottom: 10px\">Sucursal <span style=color:red>*</span></p><div class=row><div class=\"col-lg-9 col-sm-9 col-md-9 col-xs-12\"><input type=text value={{vm.sucursal}} class=form-control data-testid=param_region readonly></div></div></div><div class=col-md-12 style=padding-left:0;margin-top:50px><label class=\"control-label ng-binding\">Parametros autoasignación</label></div><table class=\"table table-bordered\"><tbody><tr ng-repeat=\"data in vm.parametros\"><td style=width:50% data-testid=param_name>{{ data.autoAssignParams.displayName }}</td><td ng-if=\"data.autoAssignParams.param != \'TYPE_DRIVER_ORDER\'\" style=width:50% data-testid=param_value>{{ data.value }}</td><td ng-if=\"data.autoAssignParams.param == \'TYPE_DRIVER_ORDER\'\" style=width:50% data-testid=param_value>{{ data.value == 0 ? \'Sin Prioridad\': \'Prioridad Leasing\' }}</td></tr></tbody></table></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6 table-responsive\"><div ng-if=\"vm.eliminable == 1\" style=min-height:430px><div class=col-md-12><label class=\"control-label ng-binding\">Bloques horario de funcionamiento</label></div><table class=\"table table-borderless\" style=\"width: 92%; margin-left:8%;padding-bottom: 10px\"><thead><tr><td>Día</td><td style=\"text-align: center!important\">Hora inicio</td><td style=\"text-align: center!important\">Hora término</td></tr></thead><tbody><tr ng-repeat=\"data in vm.horarios\"><td ng-if=\"data.dia == 1\" style=\"text-align: left!important\">Lunes</td><td ng-if=\"data.dia == 2\" style=\"text-align: left!important\">Martes</td><td ng-if=\"data.dia == 3\" style=\"text-align: left!important\">Miércoles</td><td ng-if=\"data.dia == 4\" style=\"text-align: left!important\">Jueves</td><td ng-if=\"data.dia == 5\" style=\"text-align: left!important\">Viernes</td><td ng-if=\"data.dia == 6\" style=\"text-align: left!important\">Sábado</td><td ng-if=\"data.dia == 7\" style=\"text-align: left!important\">Domingo</td><td style=\"text-align: center!important\">{{ data.horaDesde }}</td><td style=\"text-align: center!important\">{{ data.horaHasta }}</td></tr></tbody></table><div style=clear:both></div></div><div ng-if=\"vm.eliminable == 0\" style=\"height: 430px\" class=ng-scope></div><div class=text-center><div style=\"flex: 1\"><button ng-if=\"vm.eliminable == 1\" class=\"btn ng-binding\" ng-click=vm.instanceDelete(vm.payload,$event) type=buton style=\"height: 35px;line-height: 20px;max-width: 150px;padding: 5px\">Inactivar instancia</button> <button class=\"btn btn-primary\" ng-click=vm.cancel() type=button style=\"height: 35px;line-height: 20px;margin-right: 5px;margin-left: 5px\">Volver</button></div></div></div></div></div></div>");
$templateCache.put("app/components/views/booking-list/selfAssignmentEdit.html","<h2 class=ng-cloak><span>{{vm.filterInstanceEdit(vm.type_id)}} {{\'instancesEditHead\' | translate}}</span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"panel panel-default\"><div class=panel-body><form name=formInstance ng-submit=guardar_datos(formInstance) novalidate autocomplete=off><div class=\"col-lg-6 col-sm-12 col-md-6 col-xs-12\" style=\"padding-right: 5%\"><div style=\"margin-bottom: 50px\"><p style=\"font-size: 18px;text-align: left; font-weight: bold; padding-bottom: 10px\">Nombre instancia <span style=color:red>*</span></p><input type=text ng-model=dataForInstance.nombre placeholder=Nombre class=form-control maxlength=55 name=nombre required ng-change=vm.onchange(dataForInstance.nombre) data-testid=instance_name><div ng-hide=\"formInstance.nombre.$valid || formInstance.$pristine\"><div class=\"errormessage text-danger\">Este campo es obligatorio.</div></div><div ng-if=vm.isError><div class=\"errormessage text-danger\">Este campo es obligatorio.</div></div></div><div style=\"margin-bottom: 40px\" ng-if=vm.eliminable><p style=\"font-size: 18px;text-align: left; font-weight: bold; padding-bottom: 10px\">Zona de asignación <span style=color:red>*</span></p><div class=row><div class=\"col-lg-9 col-sm-9 col-md-9 col-xs-12\"><ui-select multiple data-testid=param_region_list ng-model=vm.selectedZones name=zones close-on-select=true on-select=\"vm.selectingZones($select.selected,\'select\')\" on-remove=\"vm.selectingZones($select.selected,\'remove\')\"><ui-select-match placeholder=\"Zona de asignación\">{{$item.regionName}}</ui-select-match><ui-select-choices when-scrolled=vm.paginationChangedForVehicle() repeat=\"zone in vm.zones | filter: filterZones | filter: $select.search\"><div ng-bind-html=zone.regionName></div></ui-select-choices></ui-select></div></div></div><div style=\"margin-bottom: 40px\" ng-if=!vm.eliminable><p style=\"font-size: 18px;text-align: left; font-weight: bold; padding-bottom: 10px\">Sucursal <span style=color:red>*</span></p><div class=row><div class=\"col-lg-9 col-sm-9 col-md-9 col-xs-12\"><input type=text value={{vm.sucursal}} class=form-control data-testid=param_region readonly></div></div></div><table class=\"table table-bordered\" id=globalTable><p style=\"font-size: 18px;text-align: left; font-weight: bold; padding-bottom: 10px\">Parámetros de autoasignación</p><thead><tr><td width=40%>{{\'name\' | translate}}</td><td width=40%>{{\'value\' | translate}}</td></tr></thead><tbody><tr ng-repeat=\"data in vm.parametersData\"><td><span data-testid=param_name>{{data.autoAssignParams.displayName}}</span></td><td ng-if=\"data.autoAssignParams.param != \'TYPE_DRIVER_ORDER\'\"><input ng-model=dataForInstance.params[data.id] min=0 class=form-control type=number ng-keypress=\"restrictDecimals($event, data.autoAssignParams)\" data-testid=\"config_param_{{ data.autoAssignParams.param }}\"></td><td ng-if=\"data.autoAssignParams.param == \'TYPE_DRIVER_ORDER\'\"><select ng-model=dataForInstance.params[data.id] class=form-control ng-options=\"option.value as option.name for option in vm.prioridadOptions\" data-testid=\"config_param_{{ data.autoAssignParams.param }}\"></select></td></tr></tbody></table></div><div class=\"col-lg-6 col-sm-12 col-md-6 col-xs-12\"><div ng-if=\"vm.eliminable == 1\" class=row><div class=\"col-lg-6 col-sm-12 col-md-6 col-xs-12\"><p style=\"font-size: 18px;text-align: left; font-weight: bold; padding-bottom: 10px\">Bloques horario de funcionamiento</p></div><div class=\"col-sm-6 col-md-3 col-lg-3 text-right\" style=\"padding: 0px\"><a class=\"btn btn-primary\" title=\"Agregar bloque\" ng-click=vm.addInstance()>Agregar bloque</a></div></div><div ng-if=\"vm.eliminable == 1\" class=table-responsive style=\"margin-top: 40px;min-height: 517px\"><table class=table style=\"border: none\"><thead><tr style=\"border: none !important\"><th style=\"width:30px;border: none !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 18px;font-weight: 700\">Día</p></th><th style=\"width:30px;border: none !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 18px;font-weight: 700\">Hora inicio</p></th><th style=\"width:30px;border: none !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 18px;font-weight: 700\">Hora término</p></th></tr></thead><tbody><tr ng-repeat=\"data in vm.blocksUpdate\"><td style=\"width:140px;border: none !important\"><select class=form-control ng-model=data.dia ng-change=vm.approvalValueChanged()><option value=\"\" disabled>Seleccionar día de la semana</option><option id=1 value=1>Lunes</option><option id=2 value=2>Martes</option><option id=3 value=3>Miércoles</option><option id=4 value=4>Jueves</option><option id=5 value=5>Viernes</option><option id=6 value=6>Sábado</option><option id=7 value=7>Domingo</option></select></td><td style=\"width:140px;border: none !important;vertical-align: middle;text-align: center\"><div class=row style=\"padding-left: 23px\"><div class=col-md-5 style=\"padding-left: 3px;padding-right: 3px;max-width: 55px\"><ui-select ng-model=data.hora_inicio.hora name=hora ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match>{{$select.selected.id}}</ui-select-match><ui-select-choices repeat=\"hours.id as hours in vm.hoursArray\" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=hours.id></div></ui-select-choices></ui-select></div><div class=col-md-2 style=\"padding-left: 0px;padding-right: 0px;max-width: 2px; align-items:center;margin-top: 5px\">:</div><div class=col-md-5 style=\"padding-left: 3px;padding-right: 3px;max-width: 55px\"><ui-select style=\"padding: 0px\" ng-model=data.hora_inicio.minute name=minutos ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match>{{$select.selected.id}}</ui-select-match><ui-select-choices repeat=\"minutes.id as minutes in vm.minutesArray\" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=minutes.id></div></ui-select-choices></ui-select></div></div></td><td style=\"width:140px;border: none !important;vertical-align: middle\"><div class=row style=\"padding-left: 23px\"><div class=col-md-5 style=\"padding-left: 3px;padding-right: 3px;max-width: 55px\"><ui-select ng-model=data.hora_fin.hora name=hora ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match>{{$select.selected.id}}</ui-select-match><ui-select-choices repeat=\"hours.id as hours in vm.hoursArray\" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=hours.id></div></ui-select-choices></ui-select></div><div class=col-md-2 style=\"padding-left: 0px;padding-right: 0px;max-width: 2px; align-items:center;margin-top: 5px\">:</div><div class=col-md-5 style=\"padding-left: 3px;padding-right: 3px;max-width: 55px\"><ui-select style=\"padding: 0px\" ng-model=data.hora_fin.minute name=minutos ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match>{{$select.selected.id}}</ui-select-match><ui-select-choices repeat=\"minutes.id as minutes in vm.minutesArray\" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=minutes.id></div></ui-select-choices></ui-select></div></div></td><td style=\"width:140px;border: none !important\"><a title=\"Borrar bloque\" style=\"font-size: 20px\" class=cursor ng-click=vm.removeBlock(data)><i class=\"fa fa-times-circle fa-lg\"></i></a></td></tr><tr ng-if=vm.isAdd><td style=\"width:140px;border: none !important\"><select class=form-control ng-model=vm.dataForBlock.dia ng-change=vm.approvalValueChanged()><option value=\"\" disabled>Seleccionar día de la semana</option><option id=1 value=1>Lunes</option><option id=2 value=2>Martes</option><option id=3 value=3>Miércoles</option><option id=4 value=4>Jueves</option><option id=5 value=5>Viernes</option><option id=6 value=6>Sábado</option><option id=7 value=7>Domingo</option></select></td><td style=\"width:140px;border: none !important;vertical-align: middle;text-align: center\"><div class=row style=\"padding-left: 23px\"><div class=col-md-5 style=\"padding-left: 3px;padding-right: 3px;max-width: 55px\"><ui-select ng-model=vm.dataForBlock.fecha_inicio.hora name=hora ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=00>{{$select.selected.id}}</ui-select-match><ui-select-choices repeat=\"hours.id as hours in vm.hoursArray\" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=hours.id></div></ui-select-choices></ui-select></div><div class=col-md-2 style=\"padding-left: 0px;padding-right: 0px;max-width: 2px; align-items:center;margin-top: 5px\">:</div><div class=col-md-5 style=\"padding-left: 3px;padding-right: 3px;max-width: 55px\"><ui-select style=\"padding: 0px\" ng-model=vm.dataForBlock.fecha_inicio.minute name=minutos ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=00>{{$select.selected.id}}</ui-select-match><ui-select-choices repeat=\"minutes.id as minutes in vm.minutesArray\" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=minutes.id></div></ui-select-choices></ui-select></div></div></td><td style=\"width:140px;border: none !important;vertical-align: middle\"><div class=row style=\"padding-left: 23px\"><div class=col-md-5 style=\"padding-left: 3px;padding-right: 3px;max-width: 55px\"><ui-select ng-model=vm.dataForBlock.fecha_fin.hora name=hora ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=00>{{$select.selected.id}}</ui-select-match><ui-select-choices repeat=\"hours.id as hours in vm.hoursArray\" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=hours.id></div></ui-select-choices></ui-select></div><div class=col-md-2 style=\"padding-left: 0px;padding-right: 0px;max-width: 2px; align-items:center;margin-top: 5px\">:</div><div class=col-md-5 style=\"padding-left: 3px;padding-right: 3px;max-width: 55px\"><ui-select style=\"padding: 0px\" ng-model=vm.dataForBlock.fecha_fin.minute name=minutos ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=00>{{$select.selected.id}}</ui-select-match><ui-select-choices repeat=\"minutes.id as minutes in vm.minutesArray\" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=minutes.id></div></ui-select-choices></ui-select></div></div></td><td style=\"width:100px;border: none !important;vertical-align: middle\"><div><a type=button style=\"padding-left: 3px;padding-right: 3px\" class=\"btn btn-primary btn-xs\" title=\"{{\'approve\' | translate}}\" ng-click=vm.saveBlock(vm.dataForBlock)>Guardar</a></div></td></tr></tbody></table></div><div ng-if=\"vm.eliminable == 0\" style=\"height: 620px\"></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center mt5 mb0\"><div style=\"flex: 1\"><button class=btn ng-click=vm.cancel() type=button style=\"height: 35px;line-height: 20px;margin-right: 5px\">Cancelar</button> <button class=\"btn btn-primary ng-binding\" type=submit style=\"height: 35px;line-height: 20px\">Guardar instancia</button></div></div></div></form></div></div></div></div>");
$templateCache.put("app/components/views/booking-list/selfAssignmentMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/booking-list/sharedGroupedList.html","<h2 class=ng-cloak>Shared/ Group Package List</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"border:1px solid #dedede;padding:0px\" ng-init=\"checkClicked = true\"><h2 class=\"text-center filtersStyle\" ng-click=\"checkClicked = !checkClicked; vm.slideData()\">Filters <span class=fa ng-class=\"{\'fa-caret-down\': checkClicked,\'fa-caret-up\': !checkClicked }\"></span></h2><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" id=derp><div class=row style=\"padding-top: 10px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'branchLabel\' | translate}}:</label><div><ui-select ng-model=vm.filterData.branch_value name=branch ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \" ng-click=vm.branchChanged() when-scrolled=vm.paginationChangedForBranch()><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select></div></div><!--<div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\">--><!--<label>{{\'agreementLabel\' | translate}}:</label>--><!--<div>--><!--<ui-select ng-model=\"vm.filterData.aggrement_value\" name=\"agreement\" required--><!--close-on-select=\"true\" ng-change=\"vm.agreementChanged()\">--><!--<ui-select-match placeholder=\"{{\'agreementPlaceholder\' | translate}}\">--><!--{{$select.selected.name}}--><!--</ui-select-match>--><!--<ui-select-choices--><!--repeat=\"agreements.id as agreements in vm.agreement | filter: $select.search | orderBy:\'name\' \">--><!--<div ng-bind-html=\"agreements.name\"></div>--><!--</ui-select-choices>--><!--</ui-select>--><!--</div>--><!--</div>--><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'serviceLabel\' | translate}}:</label><div><ui-select ng-model=vm.filterData.service_value name=service ng-keyup=vm.serviceSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=\"{{\'selectTService\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"services.id as services in vm.service | filter: $select.search | orderBy:\'name\' \" ng-click=vm.serviceChanged() when-scrolled=vm.paginationChangedForService()><div ng-bind-html=services.name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'vehicleLabel\' | translate}}:</label><div><ui-select ng-model=vm.filterData.vehicle_value name=vehicle ng-keyup=vm.vehicleSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=\"{{\'vehicleSelect\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"vehicles.id as vehicles in vm.vehicle | filter: $select.search | orderBy:\'name\' \" when-scrolled=vm.paginationChangedForVehicle() ng-click=vm.vehicleChanged()><div ng-bind-html=vehicles.name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>Package Type:</label><div><select class=form-control ng-model=vm.filterData.package_type_value ng-change=vm.packageTypeChanged()><option value=\"\" selected disabled>Select Package</option><option value=1>Shared</option><option value=2>Grouped</option><option value=all>All</option></select></div></div></div><div class=row style=\"padding-top: 10px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'tripType\' | translate}}:</label><div><select class=form-control ng-model=vm.filterData.type_of_trip_value ng-change=vm.typeTripChanged() ng-options=\"data.id as data.text for data in vm.typeTripFilter\"><option value=\"\" selected disabled>{{\'selectTripType\' | translate}}</option></select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpDateFromLabel\' | translate}}:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=pickupDate ng-model=vm.filterData.filter_pickup_from_date_value placeholder=\"{{\'pickUpDateLabel\' | translate}}\" is-open=vm.datePicker_1.pickupFromDate datepicker-options=vm.dateOptions required close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.pickupFromToDateChanged(1)> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_1(1)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpTimeFromLabel\' | translate}}:</label><div uib-timepicker ng-model=vm.filterData.filter_pickup_from_time_value show-spinners=false class=completed ng-change=vm.pickupFromToTimeChanged(1) hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpDateToLabel\' | translate}}:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=pickupDate ng-model=vm.filterData.filter_pickup_to_date_value placeholder=\"{{\'pickUpDateLabel\' | translate}}\" is-open=vm.datePicker_1.pickupToDate datepicker-options=vm.dateOptionsT required close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.pickupFromToDateChanged(2)> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_1(2)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=row style=\"padding-top: 10px;padding-bottom:10px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpTimeToLabel\' | translate}}:</label><div uib-timepicker ng-model=vm.filterData.filter_pickup_to_time_value show-spinners=false class=completed ng-change=vm.pickupFromToTimeChanged(2) hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian></div></div><div class=\"col-lg-2 col-sm-4 col-md-2 col-xs-4\"><button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px;margin-top:25px\" ng-click=vm.applyFilter()>Apply Filter</button></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px;margin-top:25px\" ng-click=vm.resetFilter()>{{\'resetFilterButton\' | translate}}</button></div></div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><p class=totalSize>Total Packages: {{vm.totalPackages}}</p></div><br><br><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 paddingZero text-center\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-3 col-md-3 col-lg-3\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model-options=\"{ debounce: 500 }\" ng-model=vm.filterData.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-3 col-md-3 col-lg-3\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"Search Package ID\" is-number=\"\" ng-model-options=\"{ debounce: 500 }\" ng-model=vm.filterData.searchBookingId ng-change=vm.getFilterBookingId(vm.filterData.searchBookingId)></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\"><!--ng-switch=\"(vm.sharedGroupList | filter:vm.search).length\"--><!--<div ng-switch-when=\"0\" class=\"noSearch\"><span>{{\'nothingFound\' | translate}}</span></div>--><table class=\"table table-hover tableWithMasterData\"><!--ng-switch-default--><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:105px table-column-sorting current-text=vm.predicate title=\"Unique ID\" text=\"\'shared_service_id\'\" check=vm.reverse>Unique ID</th><th style=width:105px table-column-sorting current-text=vm.predicate title=\"Type (Shared/Grouped)\" text=\"\'booking_type\'\" check=vm.reverse>Type (Shared/Grouped)</th><th style=width:105px table-column-sorting current-text=vm.predicate title=\"Type of Trip\" text=\"\'type_of_trip\'\" check=vm.reverse>Type of Trip</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"Datetime of Creation\" text=\"\'creation_datetime\'\" check=vm.reverse>Datetime of Creation</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"Total Bookings of Package\" text=\"\'number_of_bookings_in_package\'\" check=vm.reverse>Total Bookings of Package</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"Total Passengers of Package\" text=\"\'number_of_passengres_in_package\'\" check=vm.reverse>Total Passengers of Package</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"Driver Assigned\" text=\"\'fleet_id\'\" check=vm.reverse>Driver Assigned</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"Status of Execution\" text=\"\'status\'\" check=vm.reverse>Status of Execution</th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.sharedGroupList | orderBy:vm.predicate:vm.reverse\"><!--| filter:vm.search--><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:105px>{{::data.shared_service_id}}</td><td style=width:105px>{{::data.booking_type}}</td><td style=width:105px>{{::data.type_of_trip || \'--\'}}</td><td style=width:125px>{{data.creation_datetime | date: \'MMM d, yyyy HH:mm\'}}</td><td style=width:125px>{{::data.number_of_bookings_in_package}}</td><td style=width:125px>{{::data.number_of_passengres_in_package}}</td><td style=width:125px><span ng-if=data.fleet_id>{{::data.unique_car_id || \'--\'}} / {{data.first_name + \' \' + data.last_name}} </span><span ng-if=!data.fleet_id>Sin assignar</span></td><td style=width:125px><span ng-if=\"data.status == 0\">{{\'upcomingStatus\' | translate}}</span> <span ng-if=\"data.status == 1\">Viaje Iniciado</span> <span ng-if=\"data.status == 2\">Completada</span> <span ng-if=\"data.status == 3\">Failed</span> <span ng-if=\"data.status == 4\">En Posición</span> <span ng-if=\"data.status == 5\">Partial</span> <span ng-if=\"data.status == 6\">No Asignada</span> <span ng-if=\"data.status == 7\">Accepted</span> <span ng-if=\"data.status == 8\">Decline</span> <span ng-if=\"data.status == 9\">Cancelada</span> <span ng-if=\"data.status == 15\">Onroad</span></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=13 class=\"noDataClass text-center\">No Package Found.</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav>--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\"--><!--ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/booking-list/sharedGroupedListMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/booking-list/upcomingBookings.html","<h2 class=ng-cloak><span>{{\'upcomingBookingHead\' | translate}}</span><!--<span class=\"pull-right\">--><!--<button class=\"btn btn-info\" title=\"{{\'filterButton\' | translate}}\" style=\"min-width: 100px;\" ng-click=\"vm.showFilterArea()\">{{\'filterButton\' | translate}}</button>--><!--<button class=\"btn btn-info\" title=\"{{\'resetButton\' | translate}}\" ng-click=\"vm.removeFilter()\">{{\'resetButton\' | translate}}</button>--><!--</span>--></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><!--<filter-sidebar show-filter-sidebar=\"vm.showFilterFlag\" filter-data=\"vm.filterData\" filter-to-show=\"vm.filterWhichToShow\" branch-detail-changed=\"vm.branchChangedFilter(vm.filterData)\"--><!--vehicle-detail-changed=\"vm.vehicleChangedFilter(vm.filterData)\" service-detail-changed=\"vm.serviceChangedFilter(vm.filterData)\"--><!--agreement-detail-changed=\"vm.agreementChangedFilter(vm.filterData)\" type-trip-detail-changed=\"vm.typeTripChangedFilter(vm.filterData)\"></filter-sidebar>--><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"border:1px solid #dedede;padding:0px\" ng-init=\"checkClicked = true\"><h2 class=\"text-center filtersStyle\" ng-click=\"checkClicked = !checkClicked; vm.slideData()\">{{\'filter\' | translate}} <span class=fa ng-class=\"{\'fa-caret-down\': checkClicked,\'fa-caret-up\': !checkClicked }\"></span></h2><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" id=derp><div class=row style=\"padding-top: 10px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'branchLabel\' | translate}}:</label><div><ui-select ng-model=vm.filterData.branch ng-change=vm.branchChanged() name=branch ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices when-scrolled=vm.paginationChangedForBranch() repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \"><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'agreementLabel\' | translate}}:</label><div><ui-select ng-model=vm.filterData.agreement name=agreement ng-keyup=vm.agreementSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=\"{{\'agreementPlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices when-scrolled=vm.paginationChangedForAgreement() ng-click=vm.agreementChanged() repeat=\"agreements.id as agreements in vm.agreement | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=agreements.name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'serviceLabel\' | translate}}:</label><div><ui-select ng-model=vm.filterData.service name=service ng-keyup=vm.serviceSearch($select.search,$event) required close-on-select=true ng-change=vm.serviceChanged()><ui-select-match placeholder=\"{{\'selectTService\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices when-scrolled=vm.paginationChangedForService() repeat=\"services.id as services in vm.service | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=services.name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'vehicleLabel\' | translate}}:</label><div><ui-select ng-model=vm.filterData.vehicle name=vehicle ng-keyup=vm.vehicleSearch($select.search,$event) required close-on-select=true ng-change=vm.vehicleChanged()><ui-select-match placeholder=\"{{\'vehicleSelect\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices when-scrolled=vm.paginationChangedForVehicle() ng-click=vm.vehicleChanged() repeat=\"vehicles.id as vehicles in vm.vehicle | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=vehicles.name></div></ui-select-choices></ui-select></div></div></div><div class=row style=\"padding-top: 10px;padding-bottom: 10px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpDateFromLabelPET\' | translate}}:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} id=fromDate name=pickupDate ng-model=vm.filterData.filter_pickup_from_date_value placeholder=\"{{\'pickUpDateFromLabelPET\' | translate}}\" is-open=vm.datePicker_1.pickupFromDate datepicker-options=vm.dateOptions close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.pickupFromToDateChanged(1)> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_3(1)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpTimeFromLabelPET\' | translate}}:</label><div uib-timepicker ng-model=vm.filterData.filter_pickup_from_time_value show-spinners=false class=completed ng-change=vm.pickupFromToTimeChanged(1) hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpDateToLabelPET\' | translate}}:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} id=toDate name=pickupDate ng-model=vm.filterData.filter_pickup_to_date_value placeholder=\"{{\'pickUpDateToLabelPET\' | translate}}\" is-open=vm.datePicker_1.pickupToDate datepicker-options=vm.dateOptions close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.pickupFromToDateChanged(2)> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_3(2)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpTimeToLabelPET\' | translate}}:</label><div uib-timepicker ng-model=vm.filterData.filter_pickup_to_time_value show-spinners=false class=completed ng-change=vm.pickupFromToTimeChanged(2) hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian></div></div></div><div class=row style=\"padding-top: 10px;padding-bottom:10px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'tripType\' | translate}}:</label><div><!-- <select   class=\"form-control\" ng-model=\"vm.filterData.type_of_trip\" ng-change=\"vm.typeTripChanged()\" ng-options=\"data.id as data.text for data in vm.typeTripFilter\">\n                                                <option value=\"\" selected disabled>{{\'selectTripType\' | translate}}</option>\n                                            </select> --><ui-select multiple ng-model=vm.filterData.type_of_trip name=trip required close-on-select=true ng-change=vm.typeTripChanged()><ui-select-match placeholder=\"{{\'selectTripType\' | translate}}\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"data.id as  data in vm.typeTripFilter | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=data.name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'stateOfReservation\' | translate}}:</label><div><ui-select ng-model=vm.filterData.bookingStateValue name=stateOfReservation required close-on-select=true ng-change=vm.bookingStatusChange()><ui-select-match placeholder=\"{{\'stateOfReservation\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"data.id as  data in vm.stateOfBookingArray | filter: $select.search\"><div ng-bind-html=data.name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><p><!-- <input type=\"radio\" name=\"searchByName\" value=\"0\" ng-model=\"vm.filterData.searchByName\"> --> <span>{{\'searchLabel\' | translate}}</span></p><p><input type=radio name=searchByName value=0 ng-model=vm.filterData.searchByName ng-change=vm.searchByNameRadioButtonChange()> <span class=padding-left-10>{{\'applicantPET\' | translate}}</span></p><p><input type=radio name=searchByName value=1 ng-model=vm.filterData.searchByName ng-change=vm.searchByNameRadioButtonChange()> <span class=padding-left-10>{{\'passengerPET\' | translate}}</span></p></div><div class=\"col-sm-4 col-md-3 col-lg-3 col-xs-4\"><label>Búsqueda por {{vm.filterData.searchByName == 2 ? (\'solicitantePET\' | translate) : (vm.filterData.searchByName == 0 ? (\'applicantPET\' | translate) : (\'passengerPET\' | translate))}}</label><div class=input-group><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model-options=\"{ debounce: 500 }\" ng-model=vm.filterData.searchByNameFilter ng-change=vm.getFilterForSearchByNameFilter()></div></div></div><div class=row style=\"padding-top: 10px;padding-bottom:10px\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px;float: right\" ng-click=vm.applyFilter()>Apply Filter</button></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px\" ng-click=vm.resetFilter()>{{\'resetFilterButton\' | translate}}</button></div></div><!--<div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\">--><!--<label>{{\'pickUpDateLabel\' | translate}}:</label>--><!--<p class=\"input-group\">--><!--<input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{vm.format}}\" name=\"pickupDate\" ng-model=\"vm.filterData.filter_pickup_date_value\"--><!--placeholder=\"{{\'pickUpDateLabel\' | translate}}\" is-open=\"vm.datePicker_1.pickupDate\" datepicker-options=\"vm.dateOptions\" required--><!--close-text=\"Close\" alt-input-formats=\"vm.altInputFormats\" show-button-bar=\"false\" readonly ng-change=\"vm.pickupDateChanged()\"/>--><!--<span class=\"input-group-btn\">--><!--<button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.datePickerE_1()\"><i--><!--class=\"glyphicon glyphicon-calendar\"></i></button>--><!--</span>--><!--</p>--><!--</div>--><!--<div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\">--><!--<label>{{\'pickUpTimeLabel\' | translate}}:</label>--><!--<div uib-timepicker ng-model=\"vm.filterData.filter_pickup_time_value\" show-spinners=\"false\" ng-change=\"vm.pickupTimeChanged()\" hour-step=\"vm.hstep\" minute-step=\"vm.mstep\" show-meridian=\"vm.ismeridian\"></div>--><!--</div>--></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><p class=totalSize>{{\'totalBookings\' | translate}}: {{vm.totalUpcomingBookings}}</p></div><br><br><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center paddingZero\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><!-- <div class=\"col-sm-3 col-md-3 col-lg-3 mt10\" ng-if=\"vm.searchBookingField == true\">\n                                    <div class=\"input-group pt3\">\n                                        <div class=\"input-group-addon searchBackground\">\n                                            <i class=\"fa fa-search\"></i>\n                                        </div>\n                                        <input type=\"text\" id=\"searchText\" class=\"form-control\" placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model-options=\"{ debounce: 500 }\"\n                                            ng-model=\"vm.filterData.search\" ng-change=\"vm.getFilter()\">\n                                    </div>\n                                </div> --><!-- <div class=\"col-sm-3 col-md-3 col-lg-3 mt10\">\n                                        <div class=\"input-group pt3\">\n                                            <div class=\"input-group-addon searchBackground\">\n                                                <i class=\"fa fa-search\"></i>\n                                            </div>\n                                            <input type=\"text\" id=\"searchText\" class=\"form-control\" placeholder=\"{{\'searchAgreement\' | translate}}\" ng-model-options=\"{ debounce: 500 }\"\n                                                ng-model=\"vm.filterData.agreementSearch\" ng-change=\"vm.getFilterForAgreement()\">\n                                        </div>\n                                </div> --><div class=\"col-sm-3 col-md-3 col-lg-3 mt10\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchBookingId\' | translate}}\" is-number=\"\" ng-model-options=\"{ debounce: 500 }\" ng-model=vm.filterData.searchBookingId ng-change=vm.getFilterBookingId(vm.filterData.searchBookingId)></div></div><div class=\"col-sm-3 col-md-3 col-lg-3 mt10\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"Buscar Número Paquete\" is-number=\"\" ng-model-options=\"{ debounce: 500 }\" ng-model=vm.filterData.searchPackageId ng-change=vm.getFilterBookingId(vm.filterData.searchPackageId)></div></div><div class=\"col-sm-3 col-md-3 col-lg-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\"><!--ng-switch=\"(vm.upcomingBookingList | filter:vm.search).length\"--><!--<div ng-switch-when=\"0\" class=\"noSearch\"><span>{{\'nothingFound\' | translate}}</span></div>--><table class=\"table table-hover tableWithMasterData\"><!--ng-switch-default--><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:105px table-column-sorting current-text=vm.predicate title=\"{{\'idBooking\' | translate}}\" text=\"\'job_id\'\" check=vm.reverse>{{\'idBooking\' | translate}}</th><th style=width:105px table-column-sorting current-text=vm.predicate title=\"{{\'idBooking\' | translate}}\" text=\"\'is_vip\'\" check=vm.reverse>VIP</th><!--<th>--><!--<div class=\"text-center\" ng-click=\"vm.sort(\'creation_datetime\')\">--><!--Creation Date--><!--<span ng-hide=\"vm.predicate == \'creation_datetime\' && vm.reverse || vm.predicate == \'creation_datetime\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'creation_datetime\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'creation_datetime\' && vm.reverse\" class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><th style=width:105px table-column-sorting current-text=vm.predicate title=\"{{\'dateTimePick\' | translate}}\" text=\"\'job_time\'\" check=vm.reverse>{{\'dateTimePick\' | translate }}</th><th style=width:115px table-column-sorting current-text=vm.predicate title=\"{{\'assignmentState\' | translate}}\" text=\"\'transport_details\'\" check=vm.reverse>{{\'assignmentState\' | translate}}</th><th style=width:115px table-column-sorting current-text=vm.predicate title=\"{{\'passengersCount\' | translate}}\" text=\"\'number_of_passangers\'\" check=vm.reverse>{{\'passengersCount\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'customerDetails\' | translate}}\" text=\"\'created_by\'\" check=vm.reverse>{{\'customerDetails\' | translate}}</th><th style=\"width: 150px\" table-column-sorting current-text=vm.predicate title=\"{{\'thirdPersonBooking\' | translate}}\" text=\"\'job_pickup_name\'\" check=vm.reverse>{{\'thirdPersonBooking\' | translate}}</th><th style=\"width: 150px\" table-column-sorting current-text=vm.predicate title=\"{{\'pickUpAddress\' | translate}}\" text=\"\'job_pickup_address\'\" check=vm.reverse>{{\'pickUpAddress\' | translate}}</th><th style=\"width: 150px\" table-column-sorting current-text=vm.predicate title=\"{{\'dropOffAddress\' | translate}}\" text=\"\'job_address\'\" check=vm.reverse>{{\'dropOffAddress\' | translate}}</th><th style=\"width: 150px\" table-column-sorting current-text=vm.predicate title=\"{{\'estimatedPrice\' | translate}}\" text=\"\'estimated_payment_cost\'\" check=vm.reverse>{{\'estimatedPrice\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'branchLabel\' | translate}}\" text=\"\'branch\'\" check=vm.reverse>{{\'branchLabel\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'serviceLabel\' | translate}}\" text=\"\'type_of_service\'\" check=vm.reverse>{{\'serviceLabel\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'agreementLabel\' | translate}}\" text=\"\'agreement\'\" check=vm.reverse>{{\'agreementLabel\' | translate}}</th><th style=\"width: 100px\" table-column-sorting current-text=vm.predicate title=\"{{\'tripType\' | translate}}\" text=\"\'type_of_trip\'\" check=vm.reverse>{{\'tripType\' | translate}}</th><th style=\"width: 100px\" table-column-sorting current-text=vm.predicate title=\"Correct address\" text=\"\'not_valid_address\'\" check=vm.reverse>{{\'addressNotValid\' | translate}}</th><th style=\"width: 100px\" table-column-sorting current-text=vm.predicate title=\"{{\'roundTripShort\' | translate}}\" text=\"\'roundTrip\'\" check=vm.reverse>{{\'roundTripShort\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'status\' | translate}}\" text=\"\'job_status\'\" check=vm.reverse>{{\'status\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'approvalStatus\' | translate}}\" text=\"\'is_auth\'\" check=vm.reverse>{{\'approvalStatus\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'packageId\' | translate}}\" text=\"\'shared_service_id\'\" check=vm.reverse>{{\'packageId\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'sharedGrouped\' | translate}}\" text=\"\'booking_type\'\" check=vm.reverse>{{\'sharedGrouped\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'sharedGrouped\' | translate}}\" text=\"\'booking_type\'\" check=vm.reverse>Estado de asignación</th><th style=width:100px><div class=text-center>{{\'action\' | translate}}</div></th><th style=width:125px ng-if=\"vm.userType == 0\"><div class=text-center>{{\'print\' | translate}}</div></th><th style=width:180px ng-if=\"vm.userType == 0\"><div class=text-center>{{\'manualAssignLabel\' | translate}}</div></th><th style=width:125px ng-if=\"vm.userType == 0\"><div class=text-center>{{\'manualUnassignLabel\' | translate}}</div></th><th style=width:125px ng-if=\"vm.userType == 0\"><div class=text-center>{{\'noShowLabel\' | translate}}</div></th><th style=width:125px><div class=text-center>{{\'modify\' | translate}}</div></th><th style=width:125px><div class=text-center>{{\'manualEvent\' | translate}}</div></th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in vm.upcomingBookingList | orderBy:vm.predicate:vm.reverse\" ng-style=\"{\'color\':data.color}\" ng-class=\"{\'ColorGrey\': data.dicardFlag}\"><!--| filter:vm.search--><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:105px>{{::data.job_id}}</td><td style=\"width: 95px\"><span ng-if=\"data.is_vip == 0\">No</span> <span ng-if=\"data.is_vip == 1\">Si</span></td><!--<td>{{data.creation_datetime | date: \'medium\'}}</td>--><td style=width:105px><span ng-if=!data.dateFlagForShow>{{vm.changeDateIntoSpanish(data.job_time)}} {{data.job_time | date: \'HH:mm\'}}<!--{{data.job_pickup_datetime | date: \'MMM d, yyyy hh:mm a\'}}--></span><br ng-if=!data.dateFlagForShow><span ng-if=data.dateFlagForShow>{{data.job_time | date: \'HH:mm\'}}<!--{{data.job_pickup_datetime | date: \'hh:mm a\'}}--></span><br ng-if=data.dateFlagForShow><span ng-if=\"data.flight_number != null\" style=\"font-weight: bold;margin-top: 20px\">{{data.flight_number}}</span></td><td style=width:115px><span ng-if=!data.fleet_first_name>No Asignada</span> <span ng-if=data.fleet_first_name>Vehicle #{{::data.transport_details}}<br>Unique #{{::data.unique_car_id}}<br>{{data.fleet_first_name + \' \' + data.fleet_last_name}}<br>{{data.fleet_country_code?data.fleet_phone_number:data.fleet_country_code + data.fleet_phone_number || \'--\'}}</span></td><td style=width:115px>{{::data.number_of_passangers}}</td><td style=width:125px>{{\'name\' | translate}}: <b>{{data.customer_first_name + \' \' + data.customer_last_name}}</b><br>{{\'mobile_number\' | translate}}: <b>{{data.customer_country_code?data.customer_phone_number:data.customer_country_code+data.customer_phone_number}}</b><br>ID: <b>{{::data.created_by}}</b><br></td><td style=width:150px><div ng-if=data.booking_for>{{\'name\' | translate}}: <b>{{::data.job_pickup_name}}</b><br>{{\'mobile_number\' | translate}}: <b>{{::data.job_pickup_phone}}</b><br>Email: <b>{{data.job_pickup_email || \'--\'}}</b><br></div><div ng-if=!data.booking_for>NO</div></td><td style=width:150px>{{data.job_pickup_address || \'--\'}}</td><td style=width:150px>{{data.job_address || \'--\'}}</td><td style=width:150px>${{data.estimated_payment_cost || \'0\'}}</td><td style=width:100px>{{data.branch || \'--\'}}</td><td style=width:100px>{{::data.type_of_service}}</td><td style=width:100px>{{::data.agreement}}</td><td style=width:100px>{{::data.type_of_trip}}</td><td style=width:100px>{{::data.not_valid_address ? \'SI\':\'NO\'}}</td><td style=width:100px><div ng-if=\"data.is_round_trip > 0\"><span ng-if=\"data.is_wait_time_included == 0\"><span ng-if=\"data.round_trip_parent_job_id == 0\">{{data.return_date_time | date: \'MMM d, yyyy HH:mm\'}}</span> <span ng-if=\"data.round_trip_parent_job_id != 0\">#{{data.round_trip_parent_job_id}}</span> </span><span ng-if=\"data.is_wait_time_included > 0\">Con Espera</span></div><span ng-if=\"data.is_round_trip == 0\"><span ng-if=\"data.round_trip_parent_job_id == 0\">NO</span> <a ui-sref=\"layout.upcomingBookingsMain.upcomingBookingDetailsNew({id:\'{{data.round_trip_parent_job_id}}\',type:\'0\'})\" ng-if=\"data.round_trip_parent_job_id != 0\"><span>#{{::data.round_trip_parent_job_id}}</span></a></span></td><td style=width:100px><span ng-if=\"data.job_status == \'0\'\">{{\'upcomingStatus\' | translate}}</span> <span ng-if=\"data.job_status == \'1\'\">Viaje Iniciado</span> <span ng-if=\"data.job_status == \'2\'\">Completada</span> <span ng-if=\"data.job_status == \'3\'\">Failed</span> <span ng-if=\"data.job_status == \'4\'\">En Posición</span> <span ng-if=\"data.job_status == \'5\'\">Partial</span> <span ng-if=\"data.job_status == \'6\'\">No Asignada</span> <span ng-if=\"data.job_status == \'17\'\">Pendiente de Aceptación</span> <span ng-if=\"data.job_status == \'7\'\">Accepted</span> <span ng-if=\"data.job_status == \'8\'\">Rejected</span> <span ng-if=\"data.job_status == \'9\'\">Cancelada</span> <span ng-if=\"data.job_status == \'10\'\">Deleted</span> <span ng-if=\"data.job_status == \'11\'\">Ignored</span> <span ng-if=\"data.job_status == \'12\'\">No Show</span> <span ng-if=\"data.job_status == \'15\'\">En Camino</span></td><td style=width:125px><span ng-if=\"data.auth_required == 1\"><span ng-if=\"data.is_auth == 1\">Authorized</span> <span ng-if=\"data.is_auth == 2\">Rejected</span> <span ng-if=\"data.is_auth == 3\">Cancelled By Customer</span> <span ng-if=\"data.is_auth == 0\">Pendiente</span> </span><span ng-if=\"data.auth_required == 0\"><span>No Requerido</span></span></td><td style=width:125px>{{data.shared_service_id || \'--\'}}</td><td style=width:125px><span ng-if=\"data.booking_type == null\">--</span> <span ng-if=\"data.booking_type == 0\">Normal</span> <span ng-if=\"data.booking_type == 1\">{{ \'Shared\' | translate}}</span> <span ng-if=\"data.booking_type == 2\">Grouped</span></td><td style=width:125px><span ng-if=\"data.manual_rejection == 0 || data.manual_rejection == null\">--</span> <span ng-if=\"data.manual_rejection == 1\">Rechazo Manual</span></td><td style=width:100px><!--<a title=\"View Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.upcomingBookingsMain.upcomingBookingDetails({id:\'{{data.job_id}}\',type:\'0\'})\">--><!--<i class=\"fa fa-eye\"></i>--><!--</a>--> <a title=\"View Details\" class=\"cursor editIconColor btn btn-sm\" ng-click=vm.bookingDetails(data)><!--ui-sref=\"layout.upcomingBookingsMain.upcomingBookingDetailsNew({id:\'{{data.job_id}}\',type:\'0\'})\"--> <i class=\"fa fa-eye\"></i></a></td><td style=width:125px ng-if=\"vm.userType == 0\"><a ng-disabled=\"data.job_status == \'2\' || data.job_status == \'3\'|| data.job_status == \'9\'|| data.job_status == \'10\'||\n                                                data.job_status == \'11\'|| data.job_status == \'12\'\" title=\"{{\'print\' | translate}}\" class=\"btn btn-primary tableButton mt5\" ng-click=vm.printReceiptApi(data)>{{\'print\' | translate}}</a></td><td style=width:180px ng-if=\"vm.userType == 0\"><a ng-if=\"data.job_status == 6  || data.job_status == 0 || data.job_status == 7 || (data.auth_required == 1 && data.is_auth != 1)\" class=\"btn btn-primary tableButton mt5\" ng-disabled=\"(data.dicardFlag  || data.job_status == 0 || data.job_status == 7 || (data.auth_required == 1 && data.is_auth != 1))\" ng-click=vm.manualAssignBooking(data,$event) title=Asignar>Asignar</a> <a ng-if=\"data.job_status == 17 \" style=background-color:red;border-color:red class=\"btn btn-primary tableButton mt5\" ng-click=vm.cancelarAsignacion(data,$event) title=cancelarAsignar>Cancelar Asignación</a><!-- <a  style=\"background-color:red;border-color:red;\"  ng-if=\"data.job_status == 17 \"\n                                                    ng-click=\"vm.cancelarAsignación(data,$event)\" title=\"Asignar\">Cancelar Asignación</a> --></td><td style=width:125px ng-if=\"vm.userType == 0\"><a class=\"btn btn-primary tableButton mt5\" ng-disabled=\"data.job_status == 6 || data.job_status == 17\" ng-click=vm.manualUnassignBooking(data,$event) title=\"{{\'unassignButton\' | translate}}\">{{\'unassignButton\' | translate}}</a></td><td style=width:125px ng-if=\"vm.userType == 0\"><a class=\"btn btn-primary tableButton mt5\" ng-click=vm.markNoShow(data,$event) ng-disabled=\"data.job_status == 6\" title=\"{{\'noShowButton\' | translate}}\">{{\'noShowButton\' | translate}}</a></td><td style=width:125px><!-- ng-disabled=\"data.is_POS_booking == 1\" // for ticket 1699 --> <a class=\"btn btn-primary tableButton mt5\" title=\"{{\'booking\' | translate}}\" ng-click=vm.modifyBooking(data)>{{\'booking\' | translate}}</a><!-- ui-sref=\"layout.createBookingMain.createBooking({id:\'{{data.job_id}}\'})\"--></td><td style=width:125px><a class=\"btn btn-primary tableButton mt5\" style=background-color:rgb(255,217,101);border-color:rgb(255,217,101) ng-hide=\"data.job_status == 6 || data.job_status == 17\" ng-click=\"vm.makeBookingStatusChange(data,$event,\'onroad\')\" ng-if=\"vm.userType == 0\" title=\"{{\'onRoad\' | translate}}\">{{\'onRoad\' | translate}}</a> <a class=\"btn btn-primary tableButton mt5\" ng-disabled=\"(vm.shiftIdStatus == undefined && data.shift_id != null)\" style=background-color:red;border-color:red ng-click=\"vm.makeBookingStatusChange(data,$event,\'cancel\')\" title=\"{{\'cancelButton\' | translate}}\">{{\'cancelButton\' | translate}}</a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noUpcomingFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav>--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\" ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div><div id=showPrint></div><div id=cancelPrint></div></div><style></style>");
$templateCache.put("app/components/views/booking-list/upcomingBookingsMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/cancel-reason/cancelReason.html","<h2 class=ng-cloak>{{\'cancelReasonHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-4 col-sm-6 col-md-4 col-xs-12\"><label class=control-label>{{\'cancelReasonStatusHead\' | translate}}</label><select class=form-control ng-model=vm.filterData.cancelStatus ng-change=vm.getCancelReasonHit(vm.filterData.cancelStatus)><option value=\"\" disabled>{{\'cancelReasonStatusPlaceholder\' | translate}}</option><option selected value=0>Active</option><option value=2>Inactive</option><option value=1>All</option></select></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><p class=totalSize><span class=pull-right><a class=\"btn btn-primary mb10\" ng-click=vm.addNewReason($event)>+ {{\'addNewReasonButton\' | translate}}</a> </span>{{\'totalReason\' | translate}}: {{vm.totalReasons}}</p></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive tableWithMasterDataParentDive\"><table class=\"table table-hover tableWithMasterData\"><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'reason_id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'reasonLabel\' | translate}}\" text=\"\'reason\'\" check=vm.reverse>{{\'reasonVariable\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'description\' | translate}}\" text=\"\'description\'\" check=vm.reverse>{{\'descriptionVariable\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=Visibilidad text=\"\'Visibilidad\'\" check=vm.reverse>{{\'visibleVariable\' | translate}}</th><!--<th>--><!--<div ng-click=\"vm.sort(\'status\')\">--><!--Status--><!--<span ng-hide=\"vm.predicate == \'status\' && vm.reverse || vm.predicate == \'status\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'status\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'status\' && vm.reverse\" class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><th style=width:100px><div>{{\'stateTable\' | translate}}</div></th><th style=width:150px><div>{{\'action\' | translate}}</div></th><th style=width:150px><div>{{\'adminLogs\' | translate}}</div></th></tr></thead><tbody><tr ng-repeat=\"data in vm.cancelReasonList | filter: vm.search | orderBy:vm.predicate:vm.reverse\"><td style=width:70px hidden>{{data.index+1}}</td><td style=width:70px>{{::data.reason_id}}</td><td style=width:125px>{{::data.reason}}</td><td style=width:125px>{{::data.description}}</td><td style=width:125px>{{ ::data.is_visible_on_panel ? \'Panel\' : \'\'}}<br>{{ ::data.is_visible_on_app? \'App\' : \'\' }}<br>{{ ::data.is_visible_on_pos? \'POS\' : \'\'}}<br>{{ ::data.is_visible_on_web? \'Web\' : \'\' }}</td><!--<td>--><!--<span ng-if=\"data.status == 1\">Active</span>--><!--<span ng-if=\"data.status == 0\">Inactive</span>--><!--</td>--><td style=width:100px><a class=\"cursor btn btn-sm\" ng-class=\"{\'blockIconColor\': data.status == 0, \'unblockIconColor\': data.status == 1}\" ng-click=vm.changeReasonStatus(data.reason_id,data.status,$event)><i ng-class=\"{\'fa fa-unlock\': data.status == 1,\'fa fa-lock\': data.status == 0}\"></i></a></td><td style=width:150px><a title=\"Edit Details\" class=\"cursor editIconColor btn btn-sm\" ng-click=vm.editReasonPop(data,$event)><i class=\"fa fa-edit\"></i> </a><a title=\"View Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.cancelReasonMain.viewCancelReason({id:\'{{data.reason_id}}\'})\"><i class=\"fa fa-eye\"></i> </a><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteReason(data,$event)><i class=\"fa fa-trash\"></i></a></td><td style=width:150px><a class=\"btn btn-primary tableButton mt5\" ui-sref=\"layout.cancelReasonMain.adminLogs({userId:\'{{data.reason_id}}\',type:\'3\',fakeType:\'5\'})\">{{\'adminLogs\' | translate}}</a></td></tr></tbody><tfoot ng-if=vm.noDataFlag><tr><th class=\"noDataClass text-center\">{{\'noReasonFound\' | translate}}</th></tr></tfoot></table></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/cancel-reason/cancelReasonMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/cancel-reason/viewCancelReason.html","<h2 class=ng-cloak>{{\'cancelReasonHead\' | translate}} / {{\'cancelReasonDetailsHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=driver><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'allDetails\' | translate}}</p><div class=basicDetailsDiv><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'reasonLabel\' | translate}}:</label><div class=\"form-control text-capitalize\">{{::vm.cancelReasonDetail.reason}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'cancelReasonEnglish\' | translate}}:</label><div class=\"form-control text-capitalize\">{{::vm.cancelReasonDetail.reason_name_english}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'description\' | translate}}:</label><textarea class=form-control ng-model=vm.cancelReasonDetail.description placeholder=\"No Description\" readonly></textarea></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'reasonId\' | translate}}:</label><div class=\"form-control text-capitalize\">{{::vm.cancelReasonDetail.reason_id}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'reasonStatus\' | translate}}:</label><div class=\"form-control text-capitalize\"><span ng-if=\"vm.cancelReasonDetail.status == 1\">Active</span> <span ng-if=\"vm.cancelReasonDetail.status == 0\">Not Active</span></div></div><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">Reason Deleted:</label>--><!--<div class=\"form-control text-capitalize\">--><!--<span ng-if=\"vm.cancelReasonDetail.is_deleted == 1\">Yes</span>--><!--<span ng-if=\"vm.cancelReasonDetail.is_deleted == 0\">No</span>--><!--</div>--><!--</div>--></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/cars-list/assignCarToDriver.html","<h2 class=ng-cloak>{{\'vehiclesLabel\' | translate}} / {{\'assignDriverHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=driver><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button> <a class=\"btn btn-primary mb25\" style=\"background-color: #2f80e7;border-color: #2f80e7\" ui-sref=\"layout.carMain.unassignDriver({id:\'{{vm.carId}}\',carType:\'{{vm.carType}}\',carNumber:\'{{vm.carNumber}}\'})\">{{\'unassignButtonDriver\' | translate}}</a></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><p><b>{{\'vehiclePPU\' | translate}}:</b> {{::vm.carNumber}}</p><p><b>{{\'vehicleType\' | translate}}:</b> <span>{{::vm.carNameGot}}</span><!--<span ng-if=\"vm.carType  == 1\">SUV</span>--><!--<span ng-if=\"vm.carType  == 2\">Sedan</span>--><!--<span ng-if=\"vm.carType  == 3\">VAN</span>--></p></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 table-responsive tableWithMasterDataParentDive\"><table class=\"table table-hover tableWithMasterData\"><thead><tr><th style=width:70px>{{\'serialNumber\' | translate}}</th><th style=width:125px>{{\'driverName\' | translate}}</th><th style=width:125px>{{\'driverEmail\' | translate}}</th><th style=width:100px>{{\'select\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"data in vm.allDrivers | filter:vm.search\"><td style=width:70px>{{$index + 1}}</td><td style=width:125px>{{data.first_name + \" \" + data.last_name}}</td><td style=width:125px>{{::data.email}}</td><td style=width:100px><!--<input type=\"checkbox\" name=\"driver\" ng-model=\"data.checked\"  />--><md-checkbox class=md-primary ng-model=data.checked aria-label=DriverCheckbox></md-checkbox></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=\"noDataClass text-center\">{{\'noDriverFound\' | translate}}</th></tr></tfoot></table></div></div></div><div class=panel-footer><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><button type=button class=\"btn btn-primary\" ng-click=vm.selectDriver(vm.allDrivers,$event) style=width:40%>{{\'submit\' | translate}}</button></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/cars-list/assignedCarsMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/cars-list/carColors.html","<h2 class=ng-cloak><span>Colores</span> <span class=pull-right><button class=\"btn btn-primary tableButton\" ng-click=vm.refreshData()>Volver a cargar</button></span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-3 col-sm-6 col-md-3 col-xs-12\"><label class=control-label>Estado Color</label><select class=form-control ng-model=vm.filterData.carStatus ng-change=\"vm.getAllColorCars(vm.filterData,0,vm.itemsPerPageGot);vm.currentPage = 0;\"><option value=\"\" disabled>{{\'vehicleFilterPlaceHolder\' | translate}}</option><option selected value=1>Active</option><option value=0>Inactive</option></select></div><!-- <div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\">\n                    <label class=\"control-label\">{{\'branchLabel\' | translate}}</label>\n                    <ui-select ng-model=\"vm.filterData.branch\" name=\"branch\" ng-keyup=\"vm.branchSearch($select.search,$event)\" required close-on-select=\"true\"\n                        ng-change=\"vm.getAllCars(vm.filterData,0,vm.itemsPerPageGot);vm.currentPage = 0;\">\n                        <ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">\n                            {{$select.selected.region_name}}\n                        </ui-select-match>\n                        <ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \"\n                            when-scrolled=\"vm.paginationChangedForBranch()\" ng-click=\"vm.branchChanged()\">\n                            <div ng-bind-html=\"branch.region_name\"></div>\n                        </ui-select-choices>\n                    </ui-select>\n                </div> --><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5 text-center\"><p class=totalSize><span class=pull-right><a class=\"btn btn-primary mb10\" ng-click=\"vm.openPopForAdd($event , 1)\">+ Agregar nueva Color</a> </span><span>Colores totales : {{vm.totalCars}}</span></p></div><br><br><div style=\"padding-top: 20px\" class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.getFilter() ng-model-options=\"{ debounce: 500 }\"></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\"><!--ng-switch=\"(vm.carsList | filter:vm.search).length\"--><!--<div ng-switch-when=\"0\" class=\"noSearch\"><span>{{\'nothingFound\' | translate}}</span></div>--><table class=\"table table-hover tableWithMasterData\"><!--ng-switch-default--><thead><tr><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'color_id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'name\'\" check=vm.reverse>color</th><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'code\'\" check=vm.reverse><!-- Codigo --></th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'code\'\" check=vm.reverse>Codigo</th><th style=width:70px><div class=text-center>{{\'status\' | translate}}</div></th><th style=width:150px><div class=text-center>{{\'action\' | translate}}</div></th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.carsModelList | orderBy:vm.predicate:vm.reverse\"><!--| filter:vm.search--><!-- <td style=\"width:70px;\" hidden=\"true\">{{data.index + 1}}</td> --><td style=width:70px>{{::data.color_id}}</td><td style=width:70px>{{::data.name}}</td><td style=\"width:70px;background-color: {{data.code}}\"></td><td style=width:70px>{{::data.code}}</td><td style=width:70px><a class=\"cursor btn btn-sm\" ng-class=\"{\'blockIconColor\': data.is_blocked == 0, \'unblockIconColor\': data.is_blocked == 1}\" ng-click=vm.blockModel($event,data)><i ng-class=\"{\'fa fa-unlock\': data.is_blocked == 1,\'fa fa-lock\': data.is_blocked == 0}\"></i></a></td><td style=width:150px><a title=\"Edit Details\" class=\"cursor editIconColor btn btn-sm\" ng-click=\"vm.openPopForAdd($event , 2 , data)\"><i class=\"fa fa-edit\"></i> </a><a title=\"View Details\" class=\"cursor editIconColor btn btn-sm\" ng-click=\"vm.openPopForAdd($event , 3 , data)\"><i class=\"fa fa-eye\"></i> </a><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteVehicleColor(data,$event)><i class=\"fa fa-trash\"></i></a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noVehicleFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav>--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\"--><!--ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/cars-list/carColorsMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/cars-list/carModels.html","<h2 class=ng-cloak><span>Marcas y Modelos</span> <span class=pull-right><button class=\"btn btn-primary tableButton\" ng-click=vm.refreshData()>Volver a cargar</button></span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-3 col-sm-6 col-md-3 col-xs-12\"><label class=control-label>Estado Marca y Modelo</label><select class=form-control ng-model=vm.filterData.carStatus ng-change=\"vm.getAllModelsCars(vm.filterData,0,vm.itemsPerPageGot);vm.currentPage = 0;\"><option value=\"\" disabled>{{\'vehicleFilterPlaceHolder\' | translate}}</option><option selected value=1>Active</option><option value=0>Inactive</option></select></div><!-- <div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\">\n                    <label class=\"control-label\">{{\'branchLabel\' | translate}}</label>\n                    <ui-select ng-model=\"vm.filterData.branch\" name=\"branch\" ng-keyup=\"vm.branchSearch($select.search,$event)\" required close-on-select=\"true\"\n                        ng-change=\"vm.getAllCars(vm.filterData,0,vm.itemsPerPageGot);vm.currentPage = 0;\">\n                        <ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">\n                            {{$select.selected.region_name}}\n                        </ui-select-match>\n                        <ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \"\n                            when-scrolled=\"vm.paginationChangedForBranch()\" ng-click=\"vm.branchChanged()\">\n                            <div ng-bind-html=\"branch.region_name\"></div>\n                        </ui-select-choices>\n                    </ui-select>\n                </div> --><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5 text-center\"><p class=totalSize><span class=pull-right><a class=\"btn btn-primary mb10\" ng-click=\"vm.openPopForAdd($event , 1)\">+ Agregar nueva Marca y Modelo</a> </span><span>Totales Marcas y Modelos	: {{vm.totalCars}}</span></p></div><br><br><div style=\"padding-top: 20px\" class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.getFilter() ng-model-options=\"{ debounce: 500 }\"></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\"><!--ng-switch=\"(vm.carsList | filter:vm.search).length\"--><!--<div ng-switch-when=\"0\" class=\"noSearch\"><span>{{\'nothingFound\' | translate}}</span></div>--><table class=\"table table-hover tableWithMasterData\"><!--ng-switch-default--><thead><tr><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'model_id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'name\'\" check=vm.reverse>Marca y Modelo</th><th style=width:70px><div class=text-center>{{\'status\' | translate}}</div></th><th style=width:150px><div class=text-center>{{\'action\' | translate}}</div></th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.carsModelList | orderBy:vm.predicate:vm.reverse\"><!--| filter:vm.search--><!-- <td style=\"width:70px;\" hidden=\"true\">{{data.index + 1}}</td> --><td style=width:70px>{{::data.model_id}}</td><td style=width:70px>{{::data.name}}</td><td style=width:70px><a class=\"cursor btn btn-sm\" ng-class=\"{\'blockIconColor\': data.is_blocked == 0, \'unblockIconColor\': data.is_blocked == 1}\" ng-click=vm.blockModel($event,data)><i ng-class=\"{\'fa fa-unlock\': data.is_blocked == 1,\'fa fa-lock\': data.is_blocked == 0}\"></i></a></td><td style=width:150px><a title=\"Edit Details\" class=\"cursor editIconColor btn btn-sm\" ng-click=\"vm.openPopForAdd($event , 2 , data)\"><i class=\"fa fa-edit\"></i> </a><a title=\"View Details\" class=\"cursor editIconColor btn btn-sm\" ng-click=\"vm.openPopForAdd($event , 3 , data)\"><i class=\"fa fa-eye\"></i> </a><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteVehicleModel(data,$event)><i class=\"fa fa-trash\"></i></a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noVehicleFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav>--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\"--><!--ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/cars-list/carModelsMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/cars-list/carsList.html","<h2 class=ng-cloak><span>{{\'vehiclesLabel\' | translate}}</span> <span class=pull-right><button class=\"btn btn-primary tableButton\" ng-click=vm.refreshData()>Volver a cargar</button></span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-3 col-sm-6 col-md-3 col-xs-12\"><label class=control-label>{{\'vehicleFilterLabel\' | translate}}</label><select class=form-control ng-model=vm.filterData.carStatus ng-change=\"vm.getAllCars(vm.filterData,0,vm.itemsPerPageGot);vm.currentPage = 0;\"><option value=\"\" disabled>{{\'vehicleFilterPlaceHolder\' | translate}}</option><option selected value=1>Active</option><option value=0>Inactive</option></select></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label class=control-label>{{\'branchLabel\' | translate}}</label><ui-select ng-model=vm.filterData.branch name=branch ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true ng-change=\"vm.getAllCars(vm.filterData,0,vm.itemsPerPageGot);vm.currentPage = 0;\"><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5 text-center\"><p class=totalSize><span class=pull-left><a class=\"btn btn-primary tableButton mb10\" ng-click=vm.exportToCSV(vm.filterData,0,vm.dataLength)>CSV</a> </span><span>{{\'totalVehicles\' | translate}}: {{vm.totalCars}}</span></p></div><br><br><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.getFilter() ng-model-options=\"{ debounce: 500 }\"></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\"><!--ng-switch=\"(vm.carsList | filter:vm.search).length\"--><!--<div ng-switch-when=\"0\" class=\"noSearch\"><span>{{\'nothingFound\' | translate}}</span></div>--><table class=\"table table-hover tableWithMasterData\"><!--ng-switch-default--><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'uniqueNumber\' | translate}}\" text=\"\'unique_car_id\'\" check=vm.reverse>{{\'uniqueNumber\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'uniqueNumber\' | translate}}\" text=\"\'model_name\'\" check=vm.reverse>Marca y Modelo</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'uniqueNumber\' | translate}}\" text=\"\'color_name\'\" check=vm.reverse>Color</th><th style=width:100px current-text=vm.predicate title=\"{{\'uniqueNumber\' | translate}}\" text=\"\'color_name\'\" check=vm.reverse><!-- Color --></th><!-- <th style=\"width:125px;\">\n                                                <div class=\"text-center\">\n                                                    {{\'Car Image\' | translate}}\n                                                </div>\n                                            </th> --><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'vehicleLabel\' | translate}}\" text=\"\'car_type\'\" check=vm.reverse>{{\'vehicleLabel\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'PPU\' | translate}}\" text=\"\'registration_number\'\" check=vm.reverse>{{\'PPU\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'ownerName\' | translate}}\" text=\"\'first_name\'\" check=vm.reverse>{{\'ownerName\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'working24\' | translate}}\" text=\"\'modelity\'\" check=vm.reverse>{{\'working24\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'branchLabel\' | translate}}\" text=\"\'branch\'\" check=vm.reverse>{{\'branchLabel\' | translate}}</th><th style=width:150px><div class=text-center>{{\'driverAssigned\' | translate}}</div></th><th style=width:70px><div class=text-center>{{\'status\' | translate}}</div></th><th style=width:150px><div class=text-center>{{\'action\' | translate}}</div></th><th style=width:150px><div class=text-center>{{\'driver\' | translate}}</div></th><th style=width:150px><div class=text-center>{{\'adminLogs\' | translate}}</div></th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.carsList | orderBy:vm.predicate:vm.reverse\"><!--| filter:vm.search--><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:70px>{{::data.id}}</td><td style=width:100px>{{data.unique_car_id || \'--\'}}</td><td style=width:100px>{{data.model_name || \'--\'}}</td><td style=width:100px>{{data.color_name || \'--\'}}</td><td style=\"width:100px;background-color: {{data.color_code}}\"></td><!-- <td style=\"width:125px;\">\n                                                <img ng-src=\"{{data.car_photo || \'assets/images/noImage.jpeg\'}}\" class=\"tableImage\"\n                                                />\n                                            </td> --><!--<td><img ng-src=\"{{data.registration_image || \'assets/images/noImage.jpeg\'}}\"  class=\"tableImage\" /></td>--><td style=width:125px>{{::data.carName}}<!--<span ng-if=\"data.car_type  == 1\">SUV</span>--><!--<span ng-if=\"data.car_type  == 2\">Sedan</span>--><!--<span ng-if=\"data.car_type  == 3\">VAN</span>--></td><td style=width:100px>{{::data.registration_number}}</td><!--<td>{{data.added_at | date:\'medium\'}}</td>--><!--<td>--><!--<span ng-if=\"data.car_status  == 0\">Offline</span>--><!--<span ng-if=\"data.car_status  == 1\">Online</span>--><!--</td>--><td style=width:125px>{{data.first_name + \' \' + data.last_name}}</td><td style=width:125px><span ng-if=\"data.modelity == 0\">Not 24 hrs</span> <span ng-if=\"data.modelity == 1\">Work 24 hrs</span></td><td style=width:100px>{{data.branch || \'--\'}}</td><td style=width:150px><span ng-repeat=\"drivers in data.assigned_drivers\">{{drivers.first_name + \' \' + drivers.last_name}} {{drivers.country_code + \' \' + drivers.phone}} <span ng-if=\"$index != data.assigned_drivers.length - 1\"><br></span></span><span ng-if=\"data.assigned_drivers.length == 0\">Not Assigned</span></td><td style=width:70px>--</td><!--<td>--><!--<span ng-if=\"data.verification_status  == 0\">Not Verified</span>--><!--<span ng-if=\"data.verification_status  == 1\">Verified</span>--><!--</td>--><!--<td>{{data.verification_comment || \'&#45;&#45;\'}}</td>--><!--<td>--><!--<span ng-if=\"data.working_status  == 0\">Inactive</span>--><!--<span ng-if=\"data.working_status  == 1\">Active</span>--><!--</td>--><td style=width:150px><a title=\"Edit Details\" class=\"cursor editIconColor btn btn-sm\" ng-click=vm.editCarDetailsPop(data,$event)><i class=\"fa fa-edit\"></i> </a><a title=\"View Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.carMain.viewCarDetails({id:\'{{data.id}}\'})\"><i class=\"fa fa-eye\"></i> </a><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteVehicle(data,$event)><i class=\"fa fa-trash\"></i></a></td><!--<td>--><!--&lt;!&ndash;<a class=\"btn  tableButton \"&ndash;&gt;--><!--&lt;!&ndash;ng-class=\"{\'btn-primary\': data.verification_status == 0, \'btn-danger\':data.verification_status == 1}\"&ndash;&gt;--><!--&lt;!&ndash;ng-click=\"vm.approveUnapproverCar(data,$event)\" title=\"Approve\">{{data.verification_status&ndash;&gt;--><!--&lt;!&ndash;== 1?\'Not Approve\':\'Approve\'}}</a>&ndash;&gt;--><!--<a class=\"btn btn-primary tableButton \" ng-click=\"vm.approveUnapproverCar(data,$event)\" ng-disabled=\"data.verification_status == 1\" title=\"Approve\">Approve</a>--><!--<a class=\"btn btn-danger tableButton mt5\" ng-click=\"vm.approveUnapproverCar(data,$event)\" ng-disabled=\"data.verification_status == 0\" title=\"Not Approve\">Not Approve</a>--><!--</td>--><td style=width:150px><!--<a class=\"btn btn-primary tableButton\"--><!--ui-sref=\"layout.carMain.carSetShift({id:\'{{data.id}}\'})\">Set Shifts</a><br/>--><!--<a class=\"btn btn-primary view tableButton mt5\"--><!--ui-sref=\"layout.carMain.carGetShift({id:\'{{data.id}}\'})\">Get Shifts</a>--> <a class=\"btn btn-primary view tableButton mt5\" ui-sref=\"layout.carMain.assignDriver({id:\'{{data.id}}\',carType:\'{{data.car_type}}\',carNumber:\'{{data.registration_number}}\'})\" ng-disabled=!data.unique_car_id>{{\'assignButton\' | translate}}</a><!--data.verification_status == 0 || --> <a class=\"btn btn-primary view tableButton mt5\" style=background-color:#f18903;border-color:#f18903 ui-sref=\"layout.carMain.unassignDriver({id:\'{{data.id}}\',carType:\'{{data.car_type}}\',carNumber:\'{{data.registration_number}}\'})\" ng-disabled=!data.unique_car_id>{{\'unassignButton\' | translate}}</a></td><td style=width:150px><a class=\"btn btn-primary tableButton mt5\" ui-sref=\"layout.carMain.adminLogs({userId:\'{{data.id}}\',type:\'2\',fakeType:\'4\'})\">{{\'adminLogs\' | translate}}</a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noVehicleFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav>--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\"--><!--ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/cars-list/carsMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/cars-list/unassignCarToDriver.html","<h2 class=ng-cloak>{{\'vehiclesLabel\' | translate}} / {{\'unassignButtonDriver\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=driver><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button> <a class=\"btn btn-primary mb25\" style=\"background-color: #2f80e7;border-color: #2f80e7\" ui-sref=\"layout.carMain.assignDriver({id:\'{{vm.carId}}\',carType:\'{{vm.carType}}\',carNumber:\'{{vm.carNumber}}\'})\">{{\'assignButtonDriver\' | translate}}</a></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><p><b>{{\'vehiclePPU\' | translate}}:</b> {{::vm.carNumber}}</p><p><b>{{\'vehicleType\' | translate}}:</b> <span>{{::vm.carNameGot}}</span><!--<span ng-if=\"vm.carType  == 1\">SUV</span>--><!--<span ng-if=\"vm.carType  == 2\">Sedan</span>--><!--<span ng-if=\"vm.carType  == 3\">VAN</span>--></p></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 table-responsive tableWithMasterDataParentDive\"><table class=\"table table-hover tableWithMasterData\"><thead><tr><th style=width:70px>{{\'serialNumber\' | translate}}</th><th style=width:125px>{{\'driverName\' | translate}}</th><th style=width:125px>{{\'driverEmail\' | translate}}</th><th style=width:100px>{{\'select\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"data in vm.singleCarAssignedDetails | filter:vm.search\"><td style=width:70px>{{$index + 1}}</td><td style=width:125px>{{data.first_name + \" \" + data.last_name}}</td><td style=width:125px>{{::data.email}}</td><td style=width:100px><!--<input type=\"checkbox\" ng-model=\"data.checked\" name=\"driver\" ng-click=\"vm.unassignDriver(data,$event,$index)\" />--><md-checkbox class=md-primary ng-model=data.checked aria-label=DriverCheckbox ng-click=vm.unassignDriver(data,$event,$index)></md-checkbox></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=\"noDataClass text-center\">{{\'noDriverFound\' | translate}}</th></tr></tfoot></table></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/cars-list/vechicleBalance.html","<div style=\"margin-top: 50px;padding-left: 0px;padding-right: 0px\" class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=corporate><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><p ng-if=vm.generalIsSelected class=\"basicRegistrationP backgroundBasicPending text-center\">Balance mínimo general</p><p ng-if=vm.expectationsIsSelected class=\"basicRegistrationP backgroundBasicPending text-center\">Balance Mínimo Dinámico</p></div><div class=row style=\"margin-top: 50px\"><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><span style=\"width: 200px;position: absolute;top: -24px\" ng-class=\"{\'basicRegistrationP backgroundBasicPending text-center\' : vm.generalIsSelected  , \'basicRegistrationP1 backgroundBasicPending1 text-center\' : !vm.generalIsSelected}\" ng-click=vm.general()>Balance General</span> <span style=\"width: 200px;position: absolute;top: -24px;left: 227px\" ng-class=\"{\'basicRegistrationP backgroundBasicPending text-center\' : vm.expectationsIsSelected  , \'basicRegistrationP1 backgroundBasicPending1 text-center\' : !vm.expectationsIsSelected}\" ng-click=vm.expectations()>Balance Dinámico</span><hr><div ng-if=vm.generalIsSelected><button type=button ng-disabled=vm.showAddFields ng-click=vm.addVechicleBalance() style=\"margin-top: 20px;float: right\" class=\"btn btn-primary mb10 ng-binding ng-scope\">Agregar balance general</button><table class=\"table table-hover tableWithMasterData\"><thead><tr><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'model_id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'name\'\" check=vm.reverse>Tipo de Contrato</th><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'name\'\" check=vm.reverse>Tipo de Servicio</th><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'name\'\" check=vm.reverse>Balance mínimo</th><th style=width:100px><div class=text-center>{{\'action\' | translate}}</div></th></tr></thead><tbody style=\"min-height: 200px;max-height: 400px\" when-scrolled=vm.paginationChangedForVehicleBalance()><tr ng-if=vm.showAddFields style=\"margin-bottom: 30px\"><td style=width:70px></td><td style=width:70px><select class=form-control ng-model=vm.dataToFill.contrato_name name=contrato required ng-class=\"{ \'has-error\': carEditForm.contrato.$touched && carEditForm.contrato.$invalid }\"><option value=\"\" disabled selected>Select Tipo Contrato</option><option value=Freelance>Freelance</option><option value=Leasing>Leasing</option><option value=all>Todos</option></select><div class=\"errormessage text-danger\" ng-if=\"vm.flagError && vm.dataToFill.contrato_name == \'\'\">Campo obligatorio</div></td><td style=width:70px><ui-select class=form-control multiple ng-model=vm.dataToFill.service_type theme=bootstrap close-on-select=false title=\"Select Vehicle type\" required name=vehicleType ng-class=\"{ \'has-error\': addServiceForm.vehicleType.$touched && addServiceForm.vehicleType.$invalid }\"><ui-select-match placeholder=\"{{\'vehicleSelect\' | translate}}\">{{$item.name}}</ui-select-match><ui-select-choices style=\"max-height: 150px;top: 0px\" repeat=\"data.id as data in vm.service | filter:$select.search\">{{data.name}}</ui-select-choices></ui-select><div class=\"errormessage text-danger\" ng-if=\"vm.flagError && (vm.dataToFill.service_type == \'\' || vm.dataToFill.service_type == []) \">Campo obligatorio</div></td><td style=width:70px><input placeholder=\"Balance mínimo\" ng-model=vm.dataToFill.balanceAmount class=form-control type=number ng-keypress=vm.integersCheck(vm.dataToFill.balanceAmount,$event)><div class=\"errormessage text-danger\" ng-if=\"vm.flagError && (vm.dataToFill.balanceAmount == \'\' || vm.dataToFill.balanceAmount == null) \">Campo obligatorio</div></td><td style=width:100px><button type=button class=addLabelButton ng-click=vm.addFormBalance()>Guardar</button> <button type=button class=cancelLabelButton ng-click=vm.cancelFormBalance()>Cancelar</button></td></tr><tr ng-repeat=\"data in filtered = vm.vehicleBalanceList | orderBy:vm.predicate:vm.reverse\"><td style=width:70px ng-if=!vm.flagEdit[$index]>{{data.mini_balance_id}}</td><td style=width:70px ng-if=vm.flagEdit[$index]></td><td style=width:70px ng-if=!vm.flagEdit[$index]>{{data.tipo_contrato}}</td><td style=width:70px ng-if=vm.flagEdit[$index]><select class=form-control ng-model=vm.dataToFill.contrato_name name=contrato required ng-class=\"{ \'has-error\': carEditForm.contrato.$touched && carEditForm.contrato.$invalid }\"><option value=\"\" disabled selected>Select Tipo Contrato</option><option value=Freelance>Freelance</option><option value=Leasing>Leasing</option><option value=all>Todos</option></select><div class=\"errormessage text-danger\" ng-if=\"vm.flagError && vm.dataToFill.contrato_name == \'\'\">Campo obligatorio</div></td><td style=width:70px ng-if=!vm.flagEdit[$index]>{{data.service_name? data.service_name: \'--\' }}</td><td style=width:70px ng-if=vm.flagEdit[$index]><ui-select class=form-control multiple ng-model=vm.dataToFill.service_type theme=bootstrap close-on-select=false title=\"Select Vehicle type\" required name=vehicleType ng-class=\"{ \'has-error\': addServiceForm.vehicleType.$touched && addServiceForm.vehicleType.$invalid }\"><ui-select-match placeholder=\"{{\'vehicleSelect\' | translate}}\">{{$item.name}}</ui-select-match><ui-select-choices style=\"max-height: 150px;top: 0px\" repeat=\"data.id as data in vm.service | filter:$select.search\">{{data.name}}</ui-select-choices></ui-select><div class=\"errormessage text-danger\" ng-if=\"vm.flagError && (vm.dataToFill.service_type == \'\' || vm.dataToFill.service_type == []) \">Campo obligatorio</div></td><td style=width:70px ng-if=!vm.flagEdit[$index]>{{data.balance_amount}}</td><td style=width:70px ng-if=vm.flagEdit[$index]><input placeholder=\"Balance mínimo\" ng-model=vm.dataToFill.balanceAmount class=form-control type=number ng-keypress=vm.integersCheck(vm.dataToFill.balanceAmount,$event)><div class=\"errormessage text-danger\" ng-if=\"vm.flagError && (vm.dataToFill.balanceAmount == \'\' || vm.dataToFill.balanceAmount == null) \">Campo obligatorio</div></td><td style=width:100px ng-if=!vm.flagEdit[$index]><a title=\"Edit Details\" class=\"cursor editIconColor btn btn-sm\" ng-click=\"vm.editVechicleBalance($event , data , $index)\"><i class=\"fa fa-edit\"></i> </a><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteVechicleBalance(data,$event)><i class=\"fa fa-trash\"></i></a></td><td style=width:70px ng-if=vm.flagEdit[$index]><button type=button class=addLabelButton ng-click=vm.addFormBalance()>Guardar</button> <button type=button class=cancelLabelButton ng-click=vm.cancelEditButton()>Cancelar</button></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noVehicleFound\' | translate}}</th></tr></tfoot></table></div><div ng-if=vm.expectationsIsSelected><button type=button ng-disabled=vm.showAddFieldsDynamic ng-click=vm.addVechicleBalanceDynamice() style=\"margin-top: 20px;float: right\" class=\"btn btn-primary mb10 ng-binding ng-scope\">Agregar balance dínamico</button><table class=\"table table-hover tableWithMasterData\"><thead><tr><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'model_id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:100px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'name\'\" check=vm.reverse>Tipo de Contrato</th><th style=width:100px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'name\'\" check=vm.reverse>Tipo de Servicio</th><th style=width:100px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'name\'\" check=vm.reverse>Días activo</th><th style=width:120px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'name\'\" check=vm.reverse>Horario activo</th><th style=width:100px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'name\'\" check=vm.reverse>Balance Mínimo</th><th style=width:130px><div class=text-center>{{\'action\' | translate}}</div></th></tr></thead><tbody style=\"min-height: 400px;max-height: 400px\" when-scrolled=vm.paginationChangedForVehicleBalanceDynamic()><tr ng-if=vm.showAddFieldsDynamic style=\"margin-bottom: 30px\"><td style=width:70px></td><td style=width:100px><select class=form-control ng-model=vm.dataToFill.contrato_name_dynamic name=contrato required ng-class=\"{ \'has-error\': carEditForm.contrato.$touched && carEditForm.contrato.$invalid }\"><option value=\"\" disabled selected>Select Tipo Contrato</option><option value=Freelance>Freelance</option><option value=Leasing>Leasing</option><option value=all>Todos</option></select><div class=\"errormessage text-danger\" ng-if=\"vm.flagErrorDynamic && vm.dataToFill.contrato_name_dynamic == \'\'\">Campo obligatorio</div></td><td style=width:100px><ui-select class=form-control multiple ng-model=vm.dataToFill.service_type_dynamice theme=bootstrap close-on-select=false title=\"Select Vehicle type\" required name=vehicleType ng-class=\"{ \'has-error\': addServiceForm.vehicleType.$touched && addServiceForm.vehicleType.$invalid }\"><ui-select-match placeholder=\"{{\'vehicleSelect\' | translate}}\">{{$item.name}}</ui-select-match><ui-select-choices style=\"max-height: 150px;top: 0px\" repeat=\"data.id as data in vm.service | filter:$select.search\">{{data.name}}</ui-select-choices></ui-select><div class=\"errormessage text-danger\" ng-if=\"vm.flagErrorDynamic && (vm.dataToFill.service_type_dynamice == \'\' || vm.dataToFill.service_type_dynamice == []) \">Campo obligatorio</div></td><td style=width:100px><ui-select class=form-control multiple ng-model=vm.dataToFill.weekDay theme=bootstrap close-on-select=false title=\"Select Vehicle type\" required name=vehicleType ng-class=\"{ \'has-error\': addServiceForm.vehicleType.$touched && addServiceForm.vehicleType.$invalid }\"><ui-select-match placeholder=\"{{\'vehicleSelect\' | translate}}\">{{$item.name}}</ui-select-match><ui-select-choices style=\"max-height: 150px;top: 0px\" repeat=\"data.id as data in vm.weekDayArray | filter:$select.search\">{{data.name}}</ui-select-choices></ui-select><div class=\"errormessage text-danger\" ng-if=\"vm.flagErrorDynamic && vm.dataToFill.weekDay == \'\'\">Campo obligatorio</div></td><td style=width:120px><label>Desde:</label><div class=row><input type=text is-number=\"\" ng-model=vm.dataToFill.desdeHours class=clockTime maxlength=2 ng-pattern=/^[0-9]*$/ ng-value=\"(vm.dataToFill.desdeHours > 24 ? vm.dataToFill.desdeHours = \'00\' : vm.dataToFill.desdeHours)\">: <input type=text is-number=\"\" ng-model=vm.dataToFill.desdeMinutes class=clockTime maxlength=2 ng-pattern=/^[0-9]*$/ ng-value=\"(vm.dataToFill.desdeMinutes > 60 ? vm.dataToFill.desdeMinutes = \'00\' : vm.dataToFill.desdeMinutes)\"></div><div class=row><label>Hasta:</label><div class=row><input type=text is-number=\"\" ng-model=vm.dataToFill.hastaHours class=clockTime maxlength=2 ng-pattern=/^[0-9]*$/ ng-value=\"(vm.dataToFill.hastaHours > 24 ? vm.dataToFill.hastaHours = \'00\' : vm.dataToFill.hastaHours)\">: <input type=text is-number=\"\" ng-model=vm.dataToFill.hastaMinutes class=clockTime maxlength=2 ng-pattern=/^[0-9]*$/ ng-value=\"(vm.dataToFill.hastaMinutes > 60 ? vm.dataToFill.hastaMinutes = \'00\' : vm.dataToFill.hastaMinutes)\"></div></div><div class=row><div style=\"text-align: center\" class=\"errormessage text-danger\" ng-if=\"vm.flagErrorDynamic && (vm.dataToFill.hastaHours == \'\'  || vm.dataToFill.hastaMinutes == \'\' \n                                             ||vm.dataToFill.desdeMinutes == \'\' || vm.dataToFill.desdeHours == \'\') \">Campo obligatorio</div></div></td><td style=width:100px><input placeholder=\"Balance mínimo\" ng-model=vm.dataToFill.balanceAmountDynamic class=form-control type=number><div class=\"errormessage text-danger\" ng-if=\"vm.flagErrorDynamic && (vm.dataToFill.balanceAmountDynamic == \'\' || vm.dataToFill.balanceAmountDynamic == null) \">Campo obligatorio</div></td><td style=width:130px><button type=button class=addLabelButton ng-click=vm.addFormBalanceDynamic()>Guardar</button> <button type=button class=cancelLabelButton ng-click=vm.cancelFormBalanceDynamic()>Cancelar</button></td></tr><tr ng-repeat=\"data in  vm.vehicleBalanceDynamicList\"><td style=width:70px ng-if=!vm.flagEditDynamic[$index]>{{data.mini_balance_exception_id}}</td><td style=width:70px ng-if=vm.flagEditDynamic[$index]></td><td style=width:100px ng-if=!vm.flagEditDynamic[$index]>{{data.tipo_contrato}}</td><td style=width:100px ng-if=vm.flagEditDynamic[$index]><select class=form-control ng-model=vm.dataToFill.contrato_name_dynamic name=contrato required ng-class=\"{ \'has-error\': carEditForm.contrato.$touched && carEditForm.contrato.$invalid }\"><option value=\"\" disabled selected>Select Tipo Contrato</option><option value=Freelance>Freelance</option><option value=Leasing>Leasing</option><option value=all>Todos</option></select><div class=\"errormessage text-danger\" ng-if=\"vm.flagError && vm.dataToFill.contrato_name == \'\'\">Campo obligatorio</div></td><td style=width:100px ng-if=!vm.flagEditDynamic[$index]>{{data.service_name? data.service_name: \'--\' }}</td><td style=width:100px ng-if=vm.flagEditDynamic[$index]><ui-select class=form-control multiple ng-model=vm.dataToFill.service_type_dynamice theme=bootstrap close-on-select=false title=\"Select Vehicle type\" required name=vehicleType ng-class=\"{ \'has-error\': addServiceForm.vehicleType.$touched && addServiceForm.vehicleType.$invalid }\"><ui-select-match placeholder=\"{{\'vehicleSelect\' | translate}}\">{{$item.name}}</ui-select-match><ui-select-choices style=\"max-height: 150px;top: 0px\" repeat=\"data.id as data in vm.service | filter:$select.search\">{{data.name}}</ui-select-choices></ui-select><div class=\"errormessage text-danger\" ng-if=\"vm.flagError && (vm.dataToFill.service_type == \'\' || vm.dataToFill.service_type == []) \">Campo obligatorio</div></td><td style=width:100px ng-if=!vm.flagEditDynamic[$index]>{{data.day_name_week? data.day_name_week: \'--\' }}</td><td style=width:100px ng-if=vm.flagEditDynamic[$index]><ui-select class=form-control multiple ng-model=vm.dataToFill.weekDay theme=bootstrap close-on-select=false title=\"Select Vehicle type\" required name=vehicleType ng-class=\"{ \'has-error\': addServiceForm.vehicleType.$touched && addServiceForm.vehicleType.$invalid }\"><ui-select-match placeholder=\"{{\'vehicleSelect\' | translate}}\">{{$item.name}}</ui-select-match><ui-select-choices style=\"max-height: 150px;top: 0px\" repeat=\"data.id as data in vm.weekDayArray | filter:$select.search\">{{data.name}}</ui-select-choices></ui-select><div class=\"errormessage text-danger\" ng-if=\"vm.flagErrorDynamic && vm.dataToFill.weekDay == \'\'\">Campo obligatorio</div></td><td style=width:120px ng-if=!vm.flagEditDynamic[$index]>{{data.start_time ? data.start_time : \'--\' }} - {{data.end_time ? data.end_time : \'--\' }}</td><td style=width:120px ng-if=vm.flagEditDynamic[$index]><label>Desde:</label><div class=row><input type=text is-number=\"\" ng-model=vm.dataToFill.desdeHours class=clockTime maxlength=2 ng-pattern=/^[0-9]*$/ ng-value=\"(vm.dataToFill.desdeHours > 23 ? vm.dataToFill.desdeHours = \'00\' : vm.dataToFill.desdeHours)\">: <input type=text is-number=\"\" ng-model=vm.dataToFill.desdeMinutes class=clockTime maxlength=2 ng-pattern=/^[0-9]*$/ ng-value=\"(vm.dataToFill.desdeMinutes > 59 ? vm.dataToFill.desdeMinutes = \'00\' : vm.dataToFill.desdeMinutes)\"></div><div class=row><label>Hasta:</label><div class=row><input type=text is-number=\"\" ng-model=vm.dataToFill.hastaHours class=clockTime maxlength=2 ng-pattern=/^[0-9]*$/ ng-value=\"(vm.dataToFill.hastaHours > 23 ? vm.dataToFill.hastaHours = \'00\' : vm.dataToFill.hastaHours)\">: <input type=text is-number=\"\" ng-model=vm.dataToFill.hastaMinutes class=clockTime maxlength=2 ng-pattern=/^[0-9]*$/ ng-value=\"(vm.dataToFill.hastaMinutes > 59 ? vm.dataToFill.hastaMinutes = \'00\' : vm.dataToFill.hastaMinutes)\"></div></div><div class=row><div style=\"text-align: center\" class=\"errormessage text-danger\" ng-if=\"vm.flagErrorDynamic && (vm.dataToFill.hastaHours == \'\'  || vm.dataToFill.hastaMinutes == \'\' \n                                                     ||vm.dataToFill.desdeMinutes == \'\' || vm.dataToFill.desdeHours == \'\') \">Campo obligatorio</div></div></td><td style=width:100px ng-if=!vm.flagEditDynamic[$index]>{{data.balance_amount}}</td><td style=width:100px ng-if=vm.flagEditDynamic[$index]><input placeholder=\"Balance mínimo\" ng-model=vm.dataToFill.balanceAmountDynamic class=form-control type=number><div class=\"errormessage text-danger\" ng-if=\"vm.flagErrorDynamic && (vm.dataToFill.balanceAmountDynamic == \'\' || vm.dataToFill.balanceAmountDynamic == null) \">Campo obligatorio</div></td><td style=width:130px ng-if=!vm.flagEditDynamic[$index]><a title=\"Edit Details\" class=\"cursor editIconColor btn btn-sm\" ng-click=\"vm.editVechicleBalanceDynamic($event , data , $index)\"><i class=\"fa fa-edit\"></i> </a><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteVechicleBalanceDynamic(data,$event)><i class=\"fa fa-trash\"></i></a></td><td style=width:130px ng-if=vm.flagEditDynamic[$index]><button type=button class=addLabelButton ng-click=vm.addFormBalanceDynamic()>Guardar</button> <button type=button class=cancelLabelButton ng-click=vm.EditcancelFormBalanceDynamic()>Cancelar</button></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noVehicleFound\' | translate}}</th></tr></tfoot></table></div></div></div></div></div></div>");
$templateCache.put("app/components/views/cars-list/vechicleBalanceMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/cars-list/viewCarDetails.html","<h2 class=ng-cloak>{{\'vehiclesLabel\' | translate}} / {{\'vehicleDetailsHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=driver><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-1 col-md-offset-1 col-xs-offset-0 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'allDetails\' | translate}}</p><div class=basicDetailsDiv><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'vehicleLabel\' | translate}}:</label><div class=\"form-control text-capitalize\">{{::vm.carDetails.carName}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'PPU\' | translate}}:</label><div class=\"form-control text-capitalize\">{{::vm.carDetails.registration_number}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'uniqueNumber\' | translate}}:</label><div class=\"form-control text-capitalize\">{{::vm.carDetails.unique_car_id}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'ownerName\' | translate}}:</label><div class=\"form-control text-capitalize\">{{vm.carDetails.first_name + \' \' + vm.carDetails.last_name}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'ownerId\' | translate}}:</label><div class=\"form-control text-capitalize\">{{::vm.carDetails.owner_id}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'vehicleAddedDate\' | translate}}:</label><div class=\"form-control text-capitalize\">{{vm.carDetails.added_at | date: \'medium\'}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'vehicleID\' | translate}}:</label><div class=\"form-control text-capitalize\">{{::vm.carDetails.id}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'vehicleDeleted\' | translate}}:</label><div class=\"form-control text-capitalize\"><span ng-if=\"vm.carDetails.is_deleted == 1\">Yes</span> <span ng-if=\"vm.carDetails.is_deleted == 0\">No</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'working24\' | translate}}:</label><div class=\"form-control text-capitalize\"><span ng-if=\"vm.carDetails.modelity == 1\">Yes</span> <span ng-if=\"vm.carDetails.modelity == 0\">No</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'vehicleVerified\' | translate}}:</label><div class=\"form-control text-capitalize\"><span ng-if=\"vm.carDetails.verification_status == 1\">Yes</span> <span ng-if=\"vm.carDetails.verification_status == 0\">No</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'vehicleFilterLabel\' | translate}}:</label><div class=\"form-control text-capitalize\"><span ng-if=\"vm.carDetails.working_status == 1\">Yes</span> <span ng-if=\"vm.carDetails.working_status == 0\">No</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'branchLabel\' | translate}}:</label><div class=\"form-control text-capitalize\"><span>{{vm.carDetails.branch || \'--\'}}</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>Tipo Contrato:</label><div class=\"form-control text-capitalize\"><span>{{vm.carDetails.tipo_contrato || \'--\'}}</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>Marca y Modelo:</label><div class=\"form-control text-capitalize\"><span>{{vm.carDetails.model_name || \'--\'}}</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>Color:</label><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"padding: 0\"><span class=\"col-lg-8 col-sm-8 col-md-8 col-xs-8\" style=\"padding: 0\"><div class=\"form-control text-capitalize\"><span>{{vm.carDetails.color_name || \'--\'}}</span></div></span><span class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\" style=\"padding-right: 0\"><div class=\"form-control text-capitalize\" style=\"background-color: {{vm.carDetails.color_code}}\"></div></span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>Sociedad SAP</label><div class=\"form-control text-capitalize\"><span>{{ vm.carDetails.society_name || \'--\'}}</span></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'verificationComments\' | translate}}:</label><div class=text-capitalize><textarea disabled class=form-control ng-model=vm.carDetails.verification_comment placeholder=\"No Description\"></textarea></div></div><!-- <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\">\n                                    <label class=\"control-label\">{{\'Car Image\' | translate}}:</label>\n                                    <div class=\"text-capitalize\">\n                                        <img ng-src=\"{{vm.carDetails.car_photo || \'assets/images/noImage.jpeg\'}}\"  class=\"tableImage\" />\n                                    </div>\n                                </div> --><!-- <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\">\n                                    <label class=\"control-label\">{{\'vehicleImage\' | translate}}:</label>\n                                    <div class=\"text-capitalize\">\n                                        <img ng-src=\"{{vm.carDetails.registration_image || \'assets/images/noImage.jpeg\'}}\"  class=\"tableImage\" />\n                                    </div>\n                                </div> --><!-- <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\">\n                                    <label class=\"control-label\">{{\'passengerSeatInsurance\' | translate}}:</label>\n                                    <div class=\"text-capitalize\">\n                                        <img ng-src=\"{{vm.carDetails.passenger_insurance_key || \'assets/images/noImage.jpeg\'}}\"  class=\"tableImage\" />\n                                    </div>\n                                </div> --><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><label class=control-label>{{\'circulationPermission\' | translate}}:</label><div class=text-capitalize><img ng-src=\"{{vm.carDetails.permission_of_circulation || \'assets/images/noImage.jpeg\'}}\" class=tableImage></div></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><label class=control-label>Permiso Min. Transporte</label><div class=text-capitalize><img ng-src=\"{{vm.carDetails.transportation_permit || \'assets/images/noImage.jpeg\'}}\" class=tableImage></div></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><label class=control-label>Contrato</label><div class=text-capitalize><img ng-src=\"{{vm.carDetails.image_contrato || \'assets/images/noImage.jpeg\'}}\" class=tableImage></div></div><!-- <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\">\n                                    <label class=\"control-label\">{{\'travelCard\' | translate}}:</label>\n                                    <div class=\"text-capitalize\">\n                                        <img ng-src=\"{{vm.carDetails.travel_card_key || \'assets/images/noImage.jpeg\'}}\"  class=\"tableImage\" />\n                                    </div>\n                                </div> --></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/comminication-suppliers/addDriversList.html","<h2 class=ng-cloak>Mensajes Proveedores / Listas de difusión / Agregar conductor</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBackToGroup()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><!-- <p class=\"basicRegistrationP backgroundBasicPending text-center\">Agregar lista de difusión</p> --><div class=basicDetailsDiv style=\"background-color: white\"><form method=post name=givePermissionForm ng-submit=\"submit=true;givePermissionForm.$valid&&vm.addGroupForDriver()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"padding-top: 20px\"><div class=\"col-sm-4 col-md-4 col-lg-4\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input style=\"width: 100%\" type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model-options=\"{ debounce: 500 }\" ng-model=vm.filterData.search ng-change=vm.getDriverBuscarData(vm.filterData.search)></div></div><div class=\"col-sm-4 col-md-4 col-lg-4\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input style=\"width: 100%\" type=number is-number=\"\" id=searchText class=form-control placeholder=\"número de móvil\" ng-model=vm.filterData.UniqueCar ng-model-options=\"{ debounce: 500 }\" ng-change=vm.getDriverBuscarData(vm.filterData.UniqueCar)></div></div></div><div style=\"padding-top: 20px;max-height: 200px\" class=\"table-responsive tableWithMasterDataParentDive col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-switch=\"(vm.serviceList | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead ng-if=\"vm.buscarDriverData.length > 0\"><tr><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>Nombre</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>Email</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'pointName\' | translate}}\" text=\"\'pointname\'\" check=vm.reverse>Movil</th><th style=width:70px current-text=vm.predicate title=\"{{\'pointName\' | translate}}\" text=\"\'pointname\'\" check=vm.reverse></th></tr></thead><tbody style=\"overflow-y: hidden\" ng-if=\"vm.buscarDriverData.length > 0\"><tr ng-repeat=\"data in vm.buscarDriverData\"><td style=width:70px>{{::data.fleet_name}}</td><td style=width:70px>{{::data.email}}</td><td style=width:70px>{{::data.unique_car_id || \'--\'}}</td><td style=width:70px><button type=button class=agregar ng-click=vm.AddBuscarVechicle(data)>Agregar</button></td></tr></tbody></table></div><!-- <div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\" style=\"margin-top:10px;\">\n                                            <button type=\"submit\" class=\"btn btn-primary\" style=\"width:200px;\">{{\'submit\' | translate}}</button>\n                                        </div> --></div></form></div></div></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\" style=\"padding-top: 50px\"><div class=basicDiv><!-- <p class=\"basicRegistrationP backgroundBasicPending text-center\">Agregar lista de difusión</p> --><div class=basicDetailsDiv style=\"background-color: white\"><form method=post name=givePermissionForm ng-submit=\"submit=true;givePermissionForm.$valid&&vm.goBackToGroup()\" novalidate autocomplete=off><div class=row><div style=\"padding-top: 20px;max-height: 200px\" class=\"table-responsive tableWithMasterDataParentDive col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-switch=\"(vm.serviceList | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead ng-if=\"vm.destinationBuscarDriverArray.length > 0\"><tr><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>Nombre</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>Email</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'pointName\' | translate}}\" text=\"\'pointname\'\" check=vm.reverse>Movil</th><th style=width:70px current-text=vm.predicate title=\"{{\'pointName\' | translate}}\" text=\"\'pointname\'\" check=vm.reverse></th></tr></thead><tbody style=\"overflow-y: hidden\" ng-if=\"vm.destinationBuscarDriverArray.length > 0\"><tr ng-repeat=\"data in vm.destinationBuscarDriverArray\"><td style=width:70px>{{::data.fleet_name}}</td><td style=width:70px>{{::data.email}}</td><td style=width:70px>{{::data.unique_car_id || \'--\'}}</td><td style=width:70px><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteBuscarDriver(data)><i class=\"fa fa-trash\"></i></a></td></tr></tbody></table></div></div></form></div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\" style=margin-top:10px><button type=button class=\"btn btn-primary\" ng-click=vm.goBackToGroup() style=width:200px>{{\'submit\' | translate}}</button></div></div></div></div></div></div>");
$templateCache.put("app/components/views/comminication-suppliers/addGroupDrivers.html","<h2 class=ng-cloak ng-if=!vm.showDriverList>Mensajes Proveedores / Listas de difusión</h2><div ng-if=!vm.showDriverList class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">Agregar lista de difusión</p><div class=basicDetailsDiv><form method=post name=givePermissionForm ng-submit=\"submit=true;givePermissionForm.$valid&&vm.addGroupForDriver()\" novalidate autocomplete=off><div class=row><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">Permission Name<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.permissionName\" name=\"permissionName\" placeholder=\"Permission Name\"--><!--required ng-class=\"{ \'has-error\': givePermissionForm.permissionName.$touched && givePermissionForm.permissionName.$invalid }\"/>&lt;!&ndash;pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"&ndash;&gt;--><!--<div ng-if=\"givePermissionForm.permissionName.$touched|| submit\" ng-messages=\"givePermissionForm.permissionName.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter permission name.</div>--><!--</div>--><!--</div>--><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label class=control-label>Nombre <span style=color:red>*</span></label><input type=text class=form-control maxlength=35 ng-model=vm.filterData.GroupName name=roleName placeholder=Nombre required ng-class=\"{ \'has-error\': givePermissionForm.roleName.$touched && givePermissionForm.roleName.$invalid }\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\"givePermissionForm.roleName.$touched|| submit\" ng-messages=givePermissionForm.roleName.$error><div class=\"errormessage text-danger\" ng-message=required>Este campo es obligatorio.</div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"padding-top: 20px\"><label class=control-label>Descripción</label><textarea class=form-control ng-model=vm.filterData.description name=description maxlength=60 placeholder=Descripción ng-class=\"{ \'has-error\': givePermissionForm.description.$touched && givePermissionForm.description.$invalid }\"></textarea><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"padding-top: 20px\"><div class=\"col-sm-4 col-md-4 col-lg-4\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input style=\"width: 100%\" type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model-options=\"{ debounce: 500 }\" ng-model=vm.filterData.searchDriver ng-change=vm.getFilter()></div></div><div class=\"col-sm-4 col-md-4 col-lg-4\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input style=\"width: 100%\" type=text is-number=\"\" id=searchText class=form-control placeholder=\"Número de móvil\" ng-model=vm.filterData.UniqueCarDriver ng-change=vm.getFilter()></div></div><div class=\"col-sm-4 col-md-4 col-lg-4\"><div class=\"input-group pt3\"><a class=\"btn btn-primary mb10\" ng-click=vm.AddGroupOfDriver()>Agregar conductor</a></div></div></div><div style=\"padding-top: 20px;max-height: 200px\" class=\"table-responsive tableWithMasterDataParentDive col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-switch=\"(vm.serviceList | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead ng-if=\"vm.destinationBuscarDriverArrayActualAdd.length > 0\"><tr><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>Nombre</th><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>Email</th><th style=width:70px current-text=vm.predicate title=\"{{\'pointName\' | translate}}\" text=\"\'pointname\'\" check=vm.reverse>Movil</th></tr></thead><tbody style=\"overflow-y: hidden\" ng-if=\"vm.destinationBuscarDriverArrayActualAdd.length > 0\"><tr ng-repeat=\"data in filtered = vm.destinationBuscarDriverArrayActualAdd| filter:vm.filterData.searchDriver | filter:vm.filterData.UniqueCarDriver\"><td style=width:70px>{{::data.fleet_name}}</td><td style=width:70px>{{::data.email}}</td><td style=width:70px>{{data.unique_car_id || \'--\'}}</td></tr></tbody></table></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\" style=margin-top:10px><button type=submit class=\"btn btn-primary\" style=width:200px>{{\'submit\' | translate}}</button></div></div></form></div></div></div></div></div></div></div></div><h2 ng-if=vm.showDriverList class=ng-cloak>Mensajes Proveedores / Listas de difusión / Agregar conductor</h2><div ng-if=vm.showDriverList class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBackToGroup()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><!-- <p class=\"basicRegistrationP backgroundBasicPending text-center\">Agregar lista de difusión</p> --><div class=basicDetailsDiv style=\"background-color: white\"><form method=post name=givePermissionForm ng-submit=\"submit=true;givePermissionForm.$valid&&vm.addGroupForDriver()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"padding-top: 20px\"><div class=\"col-sm-4 col-md-4 col-lg-4\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input style=\"width: 100%\" type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model-options=\"{ debounce: 500 }\" ng-model=vm.filterData.search ng-change=vm.getDriverBuscarData(vm.filterData.search)></div></div><div class=\"col-sm-4 col-md-4 col-lg-4\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input style=\"width: 100%\" type=text is-number=\"\" id=searchText class=form-control placeholder=\"Número de móvil\" ng-model=vm.filterData.UniqueCar ng-change=vm.getDriverBuscarDataUniqueCar(vm.filterData.UniqueCar)></div></div></div><div style=\"padding-top: 20px\" class=\"table-responsive tableWithMasterDataParentDive col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-switch=\"(vm.serviceList | filter:vm.search).length\"><div ng-if=\"vm.buscarDriverData.length == 0\" class=noSearch><span>No se han encontrado resultados</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead ng-if=\"vm.buscarDriverData.length > 0\"><tr><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>Nombre</th><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>Email</th><th style=width:70px current-text=vm.predicate title=\"{{\'pointName\' | translate}}\" text=\"\'pointname\'\" check=vm.reverse>Movil</th><th style=width:70px current-text=vm.predicate title=\"{{\'pointName\' | translate}}\" text=\"\'pointname\'\" check=vm.reverse></th></tr></thead><tbody ng-if=\"vm.buscarDriverData.length > 0\"><tr ng-repeat=\"data in vm.buscarDriverData\"><td style=width:70px>{{::data.fleet_name}}</td><td style=width:70px>{{::data.email}}</td><td style=width:70px>{{::data.unique_car_id || \'--\'}}</td><td style=width:70px><button type=button class=agregar ng-click=vm.AddBuscarVechicle(data)>Agregar</button></td></tr></tbody></table></div><!-- <div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\" style=\"margin-top:10px;\">\n                                                <button type=\"submit\" class=\"btn btn-primary\" style=\"width:200px;\">{{\'submit\' | translate}}</button>\n                                            </div> --></div></form></div></div></div><div ng-if=\"vm.destinationBuscarDriverArray.length > 0\" class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\" style=\"padding-top: 50px\"><label>Destinatarios</label><div class=basicDiv><!-- <p class=\"basicRegistrationP backgroundBasicPending text-center\">Agregar lista de difusión</p> --><div class=basicDetailsDiv style=\"background-color: white\"><form method=post name=givePermissionForm ng-submit=\"submit=true;givePermissionForm.$valid&&vm.goBackToGroup()\" novalidate autocomplete=off><div class=row><div style=\"padding-top: 20px;overflow: hidden\" class=\"table-responsive tableWithMasterDataParentDive col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-switch=\"(vm.serviceList | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead ng-if=\"vm.destinationBuscarDriverArray.length > 0\"><tr><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>Nombre</th><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>Email</th><th style=width:70px current-text=vm.predicate title=\"{{\'pointName\' | translate}}\" text=\"\'pointname\'\" check=vm.reverse>Movil</th><th style=width:70px current-text=vm.predicate title=\"{{\'pointName\' | translate}}\" text=\"\'pointname\'\" check=vm.reverse></th></tr></thead><tbody style=\"height: 200px ; overflow: scroll\" ng-if=\"vm.destinationBuscarDriverArray.length > 0\"><tr ng-repeat=\"data in vm.destinationBuscarDriverArray\"><td style=width:70px>{{::data.fleet_name}}</td><td style=width:70px>{{::data.email}}</td><td style=width:70px>{{::data.unique_car_id || \'--\'}}</td><td style=width:70px><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteBuscarDriver($index)><i class=\"fa fa-trash\"></i></a></td></tr></tbody></table></div></div></form></div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\" style=margin-top:10px><button type=button class=\"btn btn-primary\" ng-click=vm.SubmitDriverList() style=width:200px>{{\'submit\' | translate}}</button></div></div></div></div></div></div>");
$templateCache.put("app/components/views/comminication-suppliers/editGroupDrivers.html","<h2 ng-if=!vm.showDriverList class=ng-cloak>Mensajes Proveedores / Listas de difusión</h2><div ng-if=!vm.showDriverList class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBackFirst()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">Modificar lista de difusión</p><div class=basicDetailsDiv><form method=post name=givePermissionForm ng-submit=\"submit=true;givePermissionForm.$valid&&vm.editGroupApi()\" novalidate autocomplete=off><div class=row><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">Permission Name<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.permissionName\" name=\"permissionName\" placeholder=\"Permission Name\"--><!--required ng-class=\"{ \'has-error\': givePermissionForm.permissionName.$touched && givePermissionForm.permissionName.$invalid }\"/>&lt;!&ndash;pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"&ndash;&gt;--><!--<div ng-if=\"givePermissionForm.permissionName.$touched|| submit\" ng-messages=\"givePermissionForm.permissionName.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter permission name.</div>--><!--</div>--><!--</div>--><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label class=control-label>Nombre <span style=color:red>*</span></label><input type=text maxlength=35 class=form-control ng-model=vm.dataToFill.roleName name=roleName placeholder=Nombre required ng-class=\"{ \'has-error\': givePermissionForm.roleName.$touched && givePermissionForm.roleName.$invalid }\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\"givePermissionForm.roleName.$touched|| submit\" ng-messages=givePermissionForm.roleName.$error><div class=\"errormessage text-danger\" ng-message=required>Este campo es obligatorio.</div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"padding-top: 20px\"><label class=control-label>Descripción</label><textarea class=form-control maxlength=60 ng-model=vm.dataToFill.description name=description placeholder=Descripción ng-class=\"{ \'has-error\': givePermissionForm.description.$touched && givePermissionForm.description.$invalid }\"></textarea><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"padding-top: 20px\"><div class=\"col-sm-4 col-md-4 col-lg-4\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input style=\"width: 100%\" type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model-options=\"{ debounce: 500 }\" ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-4 col-md-4 col-lg-4\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input style=\"width: 100%\" type=text is-number=\"\" id=UniqueCar class=form-control placeholder=\"Número de móvil\" ng-model=vm.filterData.uniqueCarSearch ng-change=vm.getFilterForUniqueCar()></div></div><div class=\"col-sm-4 col-md-4 col-lg-4\"><div class=\"input-group pt3\"><a class=\"btn btn-primary mb10\" ng-click=vm.AddGroupOfDriver()>Agregar conductor</a></div></div></div><div style=\"padding-top: 20px;max-height: 200px;overflow-y: hidden\" class=\"table-responsive tableWithMasterDataParentDive col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-switch=\"(vm.FleetArray | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead ng-if=\"vm.FleetArray.length > 0\"><tr><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>Nombre</th><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>Email</th><th style=width:70px current-text=vm.predicate title=\"{{\'pointName\' | translate}}\" text=\"\'pointname\'\" check=vm.reverse>Movil</th><th style=width:70px current-text=vm.predicate title=\"{{\'pointName\' | translate}}\" text=\"\'pointname\'\" check=vm.reverse></th></tr></thead><tbody style=\"max-height: 150px\" ng-if=\"vm.FleetArray.length > 0\" when-scrolled=vm.paginationChangedForVeiwDriverInGroup()><tr ng-repeat=\"data in filtered = vm.FleetArray\"><td style=width:70px>{{::data.fleet_name}}</td><td style=width:70px>{{::data.email}}</td><td style=width:70px>{{data.unique_car_id || \'--\'}}</td><td style=width:70px><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.editGroupDriver(data,$index)><i class=\"fa fa-trash\"></i></a></td></tr></tbody></table></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\" style=margin-top:10px><button type=submit class=\"btn btn-primary\" style=width:200px>{{\'submit\' | translate}}</button></div></div></form></div></div></div></div></div></div></div></div><h2 ng-if=vm.showDriverList class=ng-cloak>Mensajes Proveedores / Listas de difusión / Agregar conductor</h2><div ng-if=vm.showDriverList class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBackToGroup()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><!-- <p class=\"basicRegistrationP backgroundBasicPending text-center\">Agregar lista de difusión</p> --><div class=basicDetailsDiv style=\"background-color: white\"><form method=post name=givePermissionForm ng-submit=\"submit=true;givePermissionForm.$valid&&vm.addGroupForDriver()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"padding-top: 20px\"><div class=\"col-sm-4 col-md-4 col-lg-4\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input style=\"width: 100%\" type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model-options=\"{ debounce: 500 }\" ng-model=vm.filterData.search ng-change=vm.getDriverBuscarData(vm.filterData.search)></div></div><div class=\"col-sm-4 col-md-4 col-lg-4\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input style=\"width: 100%\" type=text is-number=\"\" id=searchText class=form-control placeholder=\"Número de móvil\" ng-model=vm.filterData.UniqueCar ng-change=vm.getDriverBuscarDataUniqueCar(vm.filterData.UniqueCar)></div></div></div><div style=\"padding-top: 20px\" class=\"table-responsive tableWithMasterDataParentDive col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-switch=\"(vm.serviceList | filter:vm.search).length\"><div ng-if=\"vm.buscarDriverData.length == 0\" class=noSearch><span>No se han encontrado resultados</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead ng-if=\"vm.buscarDriverData.length > 0\"><tr><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>Nombre</th><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>Email</th><th style=width:70px current-text=vm.predicate title=\"{{\'pointName\' | translate}}\" text=\"\'pointname\'\" check=vm.reverse>Movil</th><th style=width:70px current-text=vm.predicate title=\"{{\'pointName\' | translate}}\" text=\"\'pointname\'\" check=vm.reverse></th></tr></thead><tbody ng-if=\"vm.buscarDriverData.length > 0\"><tr ng-repeat=\"data in vm.buscarDriverData\"><td style=width:70px>{{::data.fleet_name}}</td><td style=width:70px>{{::data.email}}</td><td style=width:70px>{{::data.unique_car_id || \'--\'}}</td><td style=width:70px><button type=button class=agregar ng-click=vm.AddBuscarVechicle(data)>Agregar</button></td></tr></tbody></table></div><!-- <div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\" style=\"margin-top:10px;\">\n                                                    <button type=\"submit\" class=\"btn btn-primary\" style=\"width:200px;\">{{\'submit\' | translate}}</button>\n                                                </div> --></div></form></div></div></div><div ng-if=\"vm.destinationBuscarDriverArray.length > 0\" class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\" style=\"padding-top: 50px\"><label>Destinatarios</label><div class=basicDiv><!-- <p class=\"basicRegistrationP backgroundBasicPending text-center\">Agregar lista de difusión</p> --><div class=basicDetailsDiv style=\"background-color: white\"><form method=post name=givePermissionForm ng-submit=\"submit=true;givePermissionForm.$valid&&vm.goBackToGroup()\" novalidate autocomplete=off><div class=row><div style=\"padding-top: 20px\" class=\"table-responsive tableWithMasterDataParentDive col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-switch=\"(vm.serviceList | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead ng-if=\"vm.destinationBuscarDriverArray.length > 0\"><tr><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>Nombre</th><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>Email</th><th style=width:70px current-text=vm.predicate title=\"{{\'pointName\' | translate}}\" text=\"\'pointname\'\" check=vm.reverse>Movil</th><th style=width:70px current-text=vm.predicate title=\"{{\'pointName\' | translate}}\" text=\"\'pointname\'\" check=vm.reverse></th></tr></thead><tbody ng-if=\"vm.destinationBuscarDriverArray.length > 0\"><tr ng-repeat=\"data in vm.destinationBuscarDriverArray\"><td style=width:70px>{{::data.fleet_name}}</td><td style=width:70px>{{::data.email}}</td><td style=width:70px>{{::data.unique_car_id || \'--\'}}</td><td style=width:70px><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteBuscarDriver(data,$index)><i class=\"fa fa-trash\"></i></a></td></tr></tbody></table></div></div></form></div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\" style=margin-top:10px><button type=button class=\"btn btn-primary\" ng-click=vm.SubmitDriverList() style=width:200px>{{\'submit\' | translate}}</button></div></div></div></div></div></div>");
$templateCache.put("app/components/views/comminication-suppliers/groupDrivers.html","<h2 class=ng-cloak>Mensajes Proveedores / Grupos de difusión</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><p class=totalSize><span class=pull-right><a class=\"btn btn-primary mb10\" ui-sref=layout.groupDriversMain.addGroupDrivers ng-click=vm.AddGroupOfDriver()>+ Agregar grupo de difusión</a><!-- </span> {{\'totalAdminRoles\' | translate}}: {{vm.totalRoles}} --></span></p></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control ng-model-options=\"{ debounce: 500 }\" placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.filterData.serachGroupDriver ng-change=vm.serachGroupDriver()></div></div><!--<div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\">--><!--<label class=\"control-label\">Records per page</label>--><!--<select class=\"form-control\" ng-model=\"vm.itemsPerPageSelected\"--><!--ng-options=\"pages for pages in vm.searchModel.limitOptions\"--><!--ng-change=\"vm.getPagesCount()\"></select>--><!--</div>--></div><div class=\"table-responsive tableWithMasterDataParentDive\" ng-switch=\"(vm.groupDriver | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'group_id\'\" check=vm.reverse>ID</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'Nombre\' | translate}}\" text=\"\'group_name\'\" check=vm.reverse>Nombre</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'roleNameLabel\' | translate}}\" text=\"\'group_description\'\" check=vm.reverse>Descripción</th><th style=width:70px current-text=vm.predicate title=\"{{\'roleNameLabel\' | translate}}\" text=\"\'roleName\'\" check=vm.reverse><!-- Descripción --></th><th style=width:150px current-text=vm.predicate title=\"{{\'noFixedRouteFound\' | translate}}\" text=\"\'description\'\" check=vm.reverse>Acción</th></tr></thead><tbody><tr ng-repeat=\"data in filtered = vm.groupDriver | orderBy:vm.predicate:vm.reverse\"><td style=width:70px>{{::data.group_id}}</td><td style=width:70px>{{::data.group_name}}</td><td style=width:70px>{{::data.group_description || \'--\'}}</td><td style=width:70px><i class=\"fa fa-user\" aria-hidden=true></i> {{::data.fleet_count || 0}}</td><!--<td>{{data.admin_type}}</td>--><!--<td>{{data.email}}</td>--><!--<td>{{data.role.roleName || \'&#45;&#45;\'}}</td>--><td style=width:150px><a title=\"View Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.groupDriversMain.viewGroupDrivers({id:\'{{data.group_id}}\'})\"><i class=\"fa fa-eye\"></i> </a><a title=\"Edit Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.groupDriversMain.editGroupDrivers({id:\'{{data.group_id}}\'})\"><i class=\"fa fa-pencil\"></i> </a><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteGroupDrivers($event,data)><i class=\"fa fa-trash\"></i></a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noRole\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-if=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-if=\"sp_pagination\" ng-if=\"watchPagination\"&ndash;&gt;--><!--<nav>--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\"--><!--ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/comminication-suppliers/groupDriversMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/comminication-suppliers/historyMessage.html","<h2 class=ng-cloak>Mensajes Proveedores / Historial de mensajes</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control ng-model-options=\"{ debounce: 500 }\" placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.filterData.serachHistory ng-change=vm.serachHistoryMessage()></div></div><!--<div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\">--><!--<label class=\"control-label\">Records per page</label>--><!--<select class=\"form-control\" ng-model=\"vm.itemsPerPageSelected\"--><!--ng-options=\"pages for pages in vm.searchModel.limitOptions\"--><!--ng-change=\"vm.getPagesCount()\"></select>--><!--</div>--></div><div style=\"padding-top: 20px\" class=\"table-responsive tableWithMasterDataParentDive\" ng-switch=\"(vm.historyMessage | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'log_id\'\" check=vm.reverse>ID</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'Nombre\' | translate}}\" text=\"\'title\'\" check=vm.reverse>Título</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'roleNameLabel\' | translate}}\" text=\"\'sender\'\" check=vm.reverse>Remitente</th><th style=width:150px table-column-sorting current-text=vm.predicate title=\"{{\'roleNameLabel\' | translate}}\" text=\"\'admin_email\'\" check=vm.reverse><!-- Descripción --> Usuario</th><th style=width:100px current-text=vm.predicate title=\"{{\'noFixedRouteFound\' | translate}}\" text=\"\'description\'\" check=vm.reverse>Receptor</th><th style=width:100px current-text=vm.predicate title=\"{{\'noFixedRouteFound\' | translate}}\" text=\"\'description\'\" check=vm.reverse>Mensaje</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'noFixedRouteFound\' | translate}}\" text=\"\'created_at\'\" check=vm.reverse>Fecha y hora</th></tr></thead><tbody ng-if=\"vm.historyMessage.length > 0\"><tr ng-repeat=\"data in filtered = vm.historyMessage | orderBy:vm.predicate:vm.reverse\"><td style=width:70px>{{::data.log_id}}</td><td style=width:70px>{{::data.title}}</td><td style=width:70px>{{::data.sender || \'--\'}}</td><!-- <td style=\"width:70px;\"> <i class=\"fa fa-user\" aria-hidden=\"true\"></i>  {{::data.fleet_count || 0}}</td> --><!--<td>{{data.admin_type}}</td>--><!--<td>{{data.email}}</td>--><!--<td>{{data.role.roleName || \'&#45;&#45;\'}}</td>--><td style=width:150px>{{::data.admin_email || \'--\'}}</td><td style=width:100px><a title=\"View Details\" class=\"cursor editIconColor btn btn-sm\" ng-click=\"vm.getReceptorDetails(data , $event , \'unscroll\' , true)\"><i class=\"fa fa-eye\"></i></a></td><td style=width:100px><a title=\"View Details\" class=\"cursor editIconColor btn btn-sm\" ng-click=vm.openPopForMessageDetails(data)><i class=\"fa fa-eye\"></i></a></td><td style=width:70px>{{vm.changeDateIntoSpanish(data.created_at)}} {{::data.created_at | date: \'HH:mm\'}}</td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'histroylog\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-if=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-if=\"sp_pagination\" ng-if=\"watchPagination\"&ndash;&gt;--><!--<nav>--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\"--><!--ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/comminication-suppliers/historyMessageMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/comminication-suppliers/mailDriver.html","<h2 class=ng-cloak>Mail de Bienvenida Nuevos Postulantes</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><form name=driverMailFrom ng-submit=\"vm.submit=true;driverMailFrom.$valid&&vm.mailToDriver($event)\" novalidate autocomplete=off><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"panel panel-default\"><div class=panel-body><div class=\"row mt25\"><div style=\"color:red;text-align: right\" class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">Importante: La longitud máxima permitida para el mensaje son 2000 caracteres.</div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Mensaje <span style=color:red>*</span></label><text-angular ta-toolbar=\"[[\'h1\',\'h2\',\'h3\',\'h4\',\'h5\',\'h6\',\'pre\',\'p\',\'quote\',\'bold\',\'italics\',\'underline\',\'strikeThrough\',\'ul\',\'ol\',\'undo\',\'redo\',\'clear\',\'justifyLeft\',\'justifyCenter\',\'justifyRight\',\'justifyFull\',\'indent\',\'outdent\',\'html\',\'insertImage\',\'insertLink\',\'wordcount\',\'charcount\']]\" ng-keyup=vm.changeMessageError() ng-model=vm.filterData.Message ng-class=\"{ \'has-error\': driverMailFrom.titleMessage.$touched && driverMailFrom.titleMessage.$invalid }\"></text-angular><div ng-if=vm.messageToSend><div class=\"errormessage text-danger\">Este campo es obligatorio.</div></div></div></div><!-- <div class=\"row\">\n                                    <div style=\"margin-top: 30px\" class=\"col-lg-2 col-sm-12 col-md-2 col-xs-12\">\n                                        <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.uploadMessageIcon($event)\">\n                                            Adjuntar Footer\n                                        </button>\n                                        <input  hidden id=\"uploadFooter\" filestyle=\"\" type=\"file\" style=\"display: none;\" image=\"image\" name=\"{{vm.uploadName}}\"\n                                            onchange=\"angular.element(this).scope().file_to_upload(this.files,this.name)\" onclick=\"this.value=null;\"\n                                            data-button-text=\"Single\" data-class-button=\"btn btn-default\" data-classinput=\"form-control inline\"\n                                            nv-file-select=\"\" uploader=\"uploader\" accept=\"image/x-png,image/PNG,image/jpg,image/JPG,image/JPEG,image/jpeg\"\n                                        />\n                                    </div>\n                                    <div style=\"margin-top: 30px\" class=\"col-lg-10 col-sm-12 col-md-10 col-xs-12\">\n                                        <img height=\"20px\" width=\"40px\" ng-src=\"{{vm.ImageOfFotter || \'assets/images/noImage.jpeg\'}}\" id=\"profilePic\" class=\"documentStyle\" />\n                                        <br/>\n                                    </div>\n                                </div> --><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><button style=\"float: right;margin-left: 10px\" class=\"btn btn-danger\">{{\'cancelButton\' | translate}}</button> <button type=submit style=\"float: right\" class=\"btn btn-primary\">{{\'submit\' | translate}}</button></div></div></div></div></div></div></div></div></form></div>");
$templateCache.put("app/components/views/comminication-suppliers/mailDriverMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/comminication-suppliers/newMessage.html","<h2 class=ng-cloak>Mensajes Proveedores / Mensaje nuevo</h2><div class=\"ng-cloak container-fluid\" ng-class=\"{\'whirl duo\' : vm.loading }\"><form name=newMessageFrom ng-submit=\"vm.submit=true;newMessageFrom.$valid&&vm.sendPushToDrivers($event)\" novalidate autocomplete=off><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-6 col-sm-12 col-md-6 col-xs-12\"><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"col-lg-4 col-sm-12 col-md-4 col-xs-12\"><label>Remitente <span style=color:red>*</span></label><input type=text ng-model=vm.filterData.newMessage placeholder=Remitente class=form-control maxlength=40 name=newMessage required ng-class=\"{ \'has-error\': newMessageFrom.newMessage.$touched && newMessageFrom.newMessage.$invalid }\"><div ng-if=\"newMessageFrom.newMessage.$touched|| vm.submit\" ng-messages=newMessageFrom.newMessage.$error><div class=\"errormessage text-danger\" ng-message=required>Este campo es obligatorio.</div></div></div><div class=\"col-lg-4 col-sm-12 col-md-4 col-xs-12\"><label>Icono del mensaje <span style=color:red>*</span></label><button type=button class=\"btn btn-primary\" ng-click=vm.uploadMessageIcon($event)>Adjuntar ícono</button> <input hidden id=documentUpload filestyle=\"\" type=file style=\"display: none\" image=image name={{vm.uploadName}} onchange=angular.element(this).scope().file_to_upload(this.files,this.name) onclick=\"this.value=null\" data-button-text=Single data-class-button=\"btn btn-default\" data-classinput=\"form-control inline\" nv-file-select=\"\" uploader=uploader accept=image/x-png,image/PNG,image/jpg,image/JPG,image/JPEG,image/jpeg></div><div class=\"col-lg-2 col-sm-12 col-md-2 col-xs-12\"><img height=20px width=40px src=assets/images/noImage.jpeg id=profilePic class=documentStyle><br></div></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label>Título <span style=color:red>*</span></label><input type=text ng-model=vm.filterData.titleMessage placeholder=Título class=form-control maxlength=55 name=titleMessage required ng-class=\"{ \'has-error\': newMessageFrom.titleMessage.$touched && newMessageFrom.titleMessage.$invalid }\"><div ng-if=\"newMessageFrom.titleMessage.$touched|| vm.submit\" ng-messages=newMessageFrom.titleMessage.$error><div class=\"errormessage text-danger\" ng-message=required>Este campo es obligatorio.</div></div></div></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label class=control-label>Mensaje <span style=color:red>*</span></label><text-angular ta-toolbar=\"[[\'h1\',\'h2\',\'h3\',\'h4\',\'h5\',\'h6\',\'pre\',\'p\',\'quote\',\'bold\',\'italics\',\'underline\',\'strikeThrough\',\'ul\',\'ol\',\'undo\',\'redo\',\'clear\',\'justifyLeft\',\'justifyCenter\',\'justifyRight\',\'justifyFull\',\'indent\',\'outdent\',\'html\',\'insertImage\',\'insertLink\',\'wordcount\',\'charcount\']]\" ng-keyup=vm.changeMessageError() ng-model=vm.filterData.Message></text-angular><div ng-if=vm.messageToSend><div class=\"errormessage text-danger\">Este campo es obligatorio.</div></div></div></div></div></div><div class=\"col-lg-6 col-sm-12 col-md-6 col-xs-12\"><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label>Destinatario <span style=color:red>*</span></label></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"padding-left: 50px;padding-top: 8px\"><button type=button ng-class=\"{\'unSelected\': vm.unselected, \'selected\':  vm.selected}\" ng-click=vm.buscar()>Buscar</button> <button type=button ng-class=\"{\'unSelected\': vm.unselected1, \'selected\':  vm.selected1}\" ng-click=vm.groups()>Grupos</button> <button type=button ng-class=\"{\'unSelected\': vm.unselected2, \'selected\':  vm.selected2}\" ng-click=vm.vechicle()>Tipo de vehículo</button></div></div></div><div class=\"row mt25\" ng-if=vm.selected><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6 mt10\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=Buscar ng-model-options=\"{ debounce: 500 }\" ng-model=vm.filterData.Driver ng-change=vm.getDriverBuscarData(vm.filterData.Driver)></div></div><div class=\"col-sm-6 col-md-6 col-lg-6 mt10\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=UniqueCarId class=form-control placeholder=\"Número de móvil\" is-number=\"\" ng-model=vm.filterData.UniqueCarId ng-change=vm.getDriverBuscarDataByUniqueCarId(vm.filterData.UniqueCarId)></div></div></div><div style=\"padding-top: 20px;max-height: 200px\" class=\"table-responsive tableWithMasterDataParentDive col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-switch=\"(vm.serviceList | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead ng-if=\"vm.buscarDriverData.length > 0\"><tr><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>Nombre</th><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>Email</th><th style=width:70px current-text=vm.predicate title=\"{{\'pointName\' | translate}}\" text=\"\'pointname\'\" check=vm.reverse>Movil</th><th style=width:70px current-text=vm.predicate title=\"{{\'pointName\' | translate}}\" text=\"\'pointname\'\" check=vm.reverse></th></tr></thead><tbody ng-if=\"vm.buscarDriverData.length > 0\"><tr ng-repeat=\"data in vm.buscarDriverData\"><td style=width:70px>{{::data.fleet_name}}</td><td style=width:70px>{{::data.email}}</td><td style=width:70px>{{::data.unique_car_id || \'--\'}}</td><td style=width:70px><button type=button class=agregar ng-click=vm.AddBuscarVechicle(data)>Agregar</button></td></tr></tbody></table></div></div></div></div></div><div class=\"row mt25\" ng-if=vm.selected2><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-5 col-md-5 col-lg-5 mt10\"><!-- <div class=\"input-group pt3\"> --><label class=control-label>Tipo de vehículo</label><ui-select ng-model=vm.filterData.vehicle name=vehicle close-on-select=true ng-change=vm.vehicleChanged(vm.filterData.vehicle)><ui-select-match placeholder=Select>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"vehicles as vehicles in vm.vehicle | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=vehicles.name></div></ui-select-choices></ui-select><!-- </div> --></div><div class=\"col-sm-5 col-md-5 col-lg-5 mt10\"><!-- <div class=\"input-group pt3\"> --><label class=control-label>Sucursal</label><ui-select ng-model=vm.filterData.branch name=branch ng-change=vm.vehicleChanged(vm.filterData.branch) close-on-select=true><ui-select-match placeholder=Select>{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \"><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select><!-- </div> --></div><div class=\"col-sm-2 col-md-2 col-lg-2 mt10\"><label class=control-label style=\"opacity: 0;width: 100px\">hey</label><button class=agregar ng-if=!vm.hideAddButton type=button ng-click=vm.AdTipoTheVechilo(vm.filterData.vehicle,vm.filterData.branch)>Agregar</button></div></div></div></div></div></div><div class=\"row mt25\" ng-if=\"vm.selected && vm.destinationBuscarDriverArray.length > 0\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label>Destinatarios<!-- <span style=\"color:red\">*</span> --></label><label style=\"float: right;    font-size: 15px !important;font-weight: normal\">Total : {{vm.destinationBuscarDriverArray.length}}</label></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"panel panel-default\"><div class=panel-body><div style=\"overflow-y: hidden\" class=\"table-responsive tableWithMasterDataParentDive col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-switch=\"(vm.serviceList | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead ng-if=\"vm.destinationBuscarDriverArray.length > 0\"><tr><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>Nombre</th><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>Email</th><th style=width:70px current-text=vm.predicate title=\"{{\'pointName\' | translate}}\" text=\"\'pointname\'\" check=vm.reverse>Movil</th><th style=width:70px current-text=vm.predicate title=\"{{\'pointName\' | translate}}\" text=\"\'pointname\'\" check=vm.reverse></th></tr></thead><tbody style=\"max-height: 200px\" ng-if=\"vm.destinationBuscarDriverArray.length > 0\"><tr ng-repeat=\"data in vm.destinationBuscarDriverArray\"><td style=width:70px>{{::data.fleet_name}}</td><td style=width:70px>{{::data.email}}</td><td style=width:70px>{{::data.unique_car_id || \'--\'}}</td><td style=width:70px><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteBuscarDriver($index)><i class=\"fa fa-trash\"></i></a></td></tr></tbody></table></div></div></div></div></div><div class=\"row mt25\" ng-if=\"vm.selected2 && vm.destinationVechiloDriverArray.length> 0\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label>Destinatarios<!-- <span style=\"color:red\">*</span> --></label></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"panel panel-default\"><div class=panel-body><div style=\"overflow-y: hidden\" class=\"table-responsive tableWithMasterDataParentDive col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-switch=\"(vm.serviceList | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead ng-if=\"vm.destinationVechiloDriverArray.length > 0\"><tr><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>Tipo de vehículo</th><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>Sucursal</th><th style=width:70px current-text=vm.predicate title=\"{{\'pointName\' | translate}}\" text=\"\'pointname\'\" check=vm.reverse></th></tr></thead><tbody style=\"overflow-y: scroll;max-height: 200px\" ng-if=\"vm.destinationVechiloDriverArray.length > 0\"><tr ng-repeat=\"data in  vm.destinationVechiloDriverArray\"><td style=width:70px>{{::data.name}}</td><td style=width:70px>{{::data.region_name}}</td><td style=width:70px><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteTipoDriver(data)><i class=\"fa fa-trash\"></i></a></td></tr></tbody></table></div></div></div></div></div></div><div class=\"row mt25\" ng-if=vm.selected1><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"panel panel-default\"><div class=panel-body><!-- <div class=\"row\">\n                                                <div class=\"col-sm-6 col-md-6 col-lg-6 mt10\">\n                                                    <div class=\"input-group pt3\">\n                                                        <div class=\"input-group-addon searchBackground\">\n                                                            <i class=\"fa fa-search\"></i>\n                                                        </div>\n                                                        <input type=\"text\" id=\"searchText\" class=\"form-control\" placeholder=\"Buscar\" ng-model-options=\"{ debounce: 500 }\" ng-model=\"vm.filterData.Driver\"\n                                                            ng-change=\"vm.getDriverBuscarData(vm.filterData.Driver)\">\n                                                    </div>\n                                                </div>\n                                                <div class=\"col-sm-6 col-md-6 col-lg-6 mt10\">\n                                                    <div class=\"input-group pt3\">\n                                                        <div class=\"input-group-addon searchBackground\">\n                                                            <i class=\"fa fa-search\"></i>\n                                                        </div>\n                                                        <input type=\"text\" id=\"UniqueCarId\" class=\"form-control\" placeholder=\"Buscar\" is-number=\"\" ng-model-options=\"{ debounce: 500 }\"\n                                                            ng-model=\"vm.filterData.UniqueCarId\" ng-change=\"vm.getDriverBuscarDataByUniqueCarId(vm.filterData.UniqueCarId)\">\n                                                    </div>\n                                                </div>\n                                            </div> --><div style=\"padding-top: 20px;height: auto;overflow-y: hidden\" class=\"table-responsive tableWithMasterDataParentDive col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-switch=\"(vm.serviceList | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead ng-if=\"vm.groupDriver.length > 0\"><tr><th style=\"width:70px;border-bottom: hidden\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse><!-- Nombre --></th><th style=\"width:70px;border-bottom: hidden\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse><!-- Name --></th><th style=\"width:70px;border-bottom: hidden\" current-text=vm.predicate title=\"{{\'pointName\' | translate}}\" text=\"\'pointname\'\" check=vm.reverse><!-- No Of Fleets --></th><th style=\"width:70px;border-bottom: hidden\" current-text=vm.predicate title=\"{{\'pointName\' | translate}}\" text=\"\'pointname\'\" check=vm.reverse></th></tr></thead><tbody ng-if=\"vm.groupDriver.length > 0\" when-scrolled=vm.paginationChangedForGroupDriver()><tr style=\"border-top: hidden\" ng-repeat=\"data in vm.groupDriver\"><td style=width:70px><md-checkbox class=md-primary ng-click=vm.checkGroupDriver(data) ng-model=data.checked aria-label=Checkbox{{$index}}></md-checkbox></td><td style=width:70px>{{::data.group_name}}</td><td style=width:70px><i class=\"fa fa-user\" aria-hidden=true></i> {{::data.fleet_count || 0}}</td><td style=width:70px><a style=\"font-size: 9px\" title=\"View Details\" ng-click=\"vm.PopForDetails(data,$event , \'unscroll\')\" class=\"cursor editIconColor btn btn-sm\"><i class=\"fa fa-eye\"></i></a></td></tr></tbody></table></div></div></div></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><button type=submit style=\"float: right\" class=\"btn btn-primary\">Enviar</button></div></div></div></div></div></div></form></div>");
$templateCache.put("app/components/views/comminication-suppliers/newMessageMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/comminication-suppliers/viewGroupDrivers.html","<h2 class=ng-cloak>Mensajes Proveedores / Listas de difusión</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">Ver lista de difusión</p><div class=basicDetailsDiv><form method=post name=givePermissionForm ng-submit=\"submit=true;givePermissionForm.$valid&&vm.addRoleApiHit()\" novalidate autocomplete=off><div class=row><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">Permission Name<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.permissionName\" name=\"permissionName\" placeholder=\"Permission Name\"--><!--required ng-class=\"{ \'has-error\': givePermissionForm.permissionName.$touched && givePermissionForm.permissionName.$invalid }\"/>&lt;!&ndash;pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"&ndash;&gt;--><!--<div ng-if=\"givePermissionForm.permissionName.$touched|| submit\" ng-messages=\"givePermissionForm.permissionName.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter permission name.</div>--><!--</div>--><!--</div>--><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label class=control-label>Nombre <span style=color:red>*</span></label><input disabled type=text class=form-control ng-model=vm.dataToFill.roleName name=roleName placeholder=Nombre required ng-class=\"{ \'has-error\': givePermissionForm.roleName.$touched && givePermissionForm.roleName.$invalid }\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\"givePermissionForm.roleName.$touched|| submit\" ng-messages=givePermissionForm.roleName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'roleNameReq\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"padding-top: 20px\"><label class=control-label>Descripción</label><textarea disabled class=form-control ng-model=vm.dataToFill.description name=description placeholder=Descripción ng-class=\"{ \'has-error\': givePermissionForm.description.$touched && givePermissionForm.description.$invalid }\"></textarea></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"padding-top: 20px\"><div class=\"col-sm-4 col-md-4 col-lg-4\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input style=\"width: 100%\" type=text id=searchText class=form-control ng-model-options=\"{ debounce: 500 }\" placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-4 col-md-4 col-lg-4\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input style=\"width: 100%\" type=text is-number=\"\" id=UniqueCar class=form-control placeholder=\"Número de móvil\" ng-model=vm.dataToFill.UniqueCar ng-change=vm.getFilterForUniqueCar()></div></div></div><!-- <div style=\"padding-top: 20px;max-height: 200px;\" class=\"table-responsive tableWithMasterDataParentDive col-lg-12 col-sm-12 col-md-12 col-xs-12\"\n                                            ng-switch=\"(vm.FleetArray | filter:vm.search).length\">\n                                            <div ng-switch-when=\"0\" class=\"noSearch\">\n                                                <span>{{\'nothingFound\' | translate}}</span>\n                                            </div>\n                                            <table class=\"table table-hover tableWithMasterData\" ng-switch-default>\n                                                <thead ng-if=\"vm.FleetArray.length > 0\">\n                                                    <tr>\n                                                        <th style=\"width:70px;\" current-text=\"vm.predicate\" title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=\"vm.reverse\">\n                                                            Nombre\n                                                        </th>\n                                                        <th style=\"width:70px;\" current-text=\"vm.predicate\" title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=\"vm.reverse\">\n                                                            Email\n                                                        </th>\n                                                        <th style=\"width:70px;\" current-text=\"vm.predicate\" title=\"{{\'pointName\' | translate}}\" text=\"\'pointname\'\" check=\"vm.reverse\">\n                                                            Movil\n                                                        </th>\n                                                    </tr>\n                                                </thead>\n\n                                                <tbody ng-if=\"vm.FleetArray.length > 0\">\n                                                    <tr ng-repeat=\"data in filtered = vm.FleetArray| filter:vm.search | filter:vm.UniqueCar\">\n                                                        <td style=\"width:70px;\">{{::data.fleet_name}}</td>\n                                                        <td style=\"width:70px;\">{{::data.email}}</td>\n                                                        <td style=\"width:70px;\">\n                                                            {{data.unique_car_id || \'--\'}}\n                                                        </td>\n\n\n                                                </tbody>\n                                            </table>\n                                        </div> --><div style=\"padding-top: 20px;max-height: 200px;overflow-y: hidden\" class=\"table-responsive tableWithMasterDataParentDive col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-switch=\"(vm.FleetArray | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead ng-if=\"vm.FleetArray.length > 0\"><tr><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>Nombre</th><th style=width:70px current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>Email</th><th style=width:70px current-text=vm.predicate title=\"{{\'pointName\' | translate}}\" text=\"\'pointname\'\" check=vm.reverse>Movil</th><!-- <th style=\"width:70px;\" current-text=\"vm.predicate\" title=\"{{\'pointName\' | translate}}\" text=\"\'pointname\'\" check=\"vm.reverse\">\n\n                                                    </th> --></tr></thead><tbody style=\"max-height: 150px\" ng-if=\"vm.FleetArray.length > 0\" when-scrolled=vm.paginationChangedForVeiwDriverInGroup()><tr ng-repeat=\"data in filtered = vm.FleetArray\"><td style=width:70px>{{::data.fleet_name}}</td><td style=width:70px>{{::data.email}}</td><td style=width:70px>{{data.unique_car_id || \'--\'}}</td><!-- <td style=\"width:70px;\">\n                                                        <a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=\"vm.editGroupDriver($index)\">\n                                                            <i class=\"fa fa-trash\"></i>\n                                                        </a>\n                                                    </td> --></tr></tbody></table></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\" style=margin-top:10px><!-- <button class=\"btn btn-primary\" style=\"width:200px;\">{{\'submit\' | translate}}</button> --></div></div></form></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/controlled-way/controlledWay.html","<h2 class=ng-cloak><span>{{\'controlledWayHead\' | translate}}</span><!-- <span class=\"pull-right\">\n        <button class=\"btn btn-primary tableButton\" ng-click=\"vm.refreshData()\">Volver a cargar</button>\n    </span> --></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"panel panel-default\"><div class=panel-body><div class=\"table-responsive tableWithMasterDataParentDive\"><!--ng-switch=\"(vm.employeeList | filter:vm.search).length\"--><!--<div ng-switch-when=\"0\" class=\"noSearch\"><span>{{\'nothingFound\' | translate}}</span></div>--><table class=\"table table-hover tableWithMasterData\"><div style=\"text-align: center\" class=col-xs-12><b>Valores para servicios compartidos</b></div><thead style=\"margin-top: -1%; width: 100%\"><tr><th style=width:3%>ID</th><th style=width:13%>{{\'category\' | translate}}</th><th style=width:16%>Valor para servicios Exclusivo/Agrupado</th><th style=width:7%>1 Pax</th><th style=width:7%>2 Pax</th><th style=width:7%>3 Pax</th><th style=width:7%>4 Pax</th><th style=width:7%>5 Pax</th><th style=width:7%>6 Pax</th><th style=width:7%>7 Pax</th><th style=width:12%>Modificado FechaHora</th><th style=width:7%>Modificado. Por</th><th style=width:13%>Accion</th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in vm.controlledWayData\"><!--| filter:vm.search --><td style=width:3%>{{data.ID}}</td><td style=width:13%>{{data.category === \'S\' ? \'Sedan\' : \'Minibus\'}}</td><td style=width:16%>${{vm.numberWithCommas(data.ValueExclusive)}}</td><td style=width:7%><span ng-if=data.ValuePass1>${{vm.numberWithCommas(data.ValuePass1)}} </span><span ng-if=!data.ValuePass1>--</span></td><td style=width:7%><span ng-if=data.ValuePass2>${{vm.numberWithCommas(data.ValuePass2)}} </span><span ng-if=!data.ValuePass2>--</span></td><td style=width:7%><span ng-if=data.ValuePass3>${{vm.numberWithCommas(data.ValuePass3)}} </span><span ng-if=!data.ValuePass3>--</span></td><td style=width:7%><span ng-if=data.ValuePass4>${{vm.numberWithCommas(data.ValuePass4)}} </span><span ng-if=!data.ValuePass4>--</span></td><td style=width:7%><span ng-if=data.ValuePass5>${{vm.numberWithCommas(data.ValuePass5)}} </span><span ng-if=!data.ValuePass5>--</span></td><td style=width:7%><span ng-if=data.ValuePass6>${{vm.numberWithCommas(data.ValuePass6)}} </span><span ng-if=!data.ValuePass6>--</span></td><td style=width:7%><span ng-if=data.ValuePass7>${{vm.numberWithCommas(data.ValuePass7)}} </span><span ng-if=!data.ValuePass7>--</span></td><td style=width:12%><span ng-if=\"(data[\'DateTime Update\'])\">{{vm.changeDateIntoSpanish(data[\'DateTime Update\'])}} {{(data[\'DateTime Update\']) | date: \'HH:mm\'}} </span><span ng-if=\"(!data[\'DateTime Update\'])\">--</span></td><td style=width:7%>{{data.fullName || \'--\'}}</td><td style=width:13%><a title=\"Edit Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.controlledWayMain.editControlledWay({controlled_way_id:\'{{data.ID}}\'})\"><i class=\"fa fa-edit\"></i></a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th class=\"noDataClass text-center\">{{\'noAgreementFound\' | translate}}</th></tr></tfoot></table></div><!-- <div class=\"row\">\n                                <div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\">\n                                    <span ng-hide=\"vm.filterOn\">{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue +\n                                        1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span>\n                                    <span ng-if=\"vm.filterOn\">{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}}\n                                        {{\'enteries\' | translate}}</span>\n                                </div>\n                                <div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\">\n                                    <div class=\"pull-right\" ng-if=\"vm.sp_pagination\">\n                                        <ul uib-pagination total-items=\"vm.dataLength\" items-per-page=\"vm.itemsPerPageGot\" ng-change=\"vm.paginationNew(vm.currentPage)\"\n                                            ng-model=\"vm.currentPage\" max-size=\"vm.maxSize\" class=\"pagination-sm\" boundary-link-numbers=\"true\"\n                                            rotate=\"false\"></ul>\n                                    </div>\n                                    <div class=\"clearfix\"></div>\n                                </div>\n                            </div> --></div></div></div></div></div></div></div><style>.switch {\n        position: relative;\n        display: inline-block;\n        width: 60px;\n        height: 34px;\n    }\n\n    .switch input {\n        opacity: 0;\n        width: 0;\n        height: 0;\n    }\n\n    .slider {\n        position: absolute;\n        cursor: pointer;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background-color: #ccc;\n        -webkit-transition: .4s;\n        transition: .4s;\n    }\n\n    .slider:before {\n        position: absolute;\n        content: \"\";\n        height: 26px;\n        width: 26px;\n        left: 4px;\n        bottom: 4px;\n        background-color: white;\n        -webkit-transition: .4s;\n        transition: .4s;\n    }\n\n    input:checked+.slider {\n        background-color: #2196F3;\n    }\n\n    .trueFlag {\n        background-color: #2196F3;\n    }\n\n    .falseFlag {\n        /* background-color: #2196F3;     */\n\n        background-color: #ccc;\n    }\n\n    input:focus+.slider {\n        box-shadow: 0 0 1px #2196F3;\n    }\n\n    input:checked+.slider:before {\n        -webkit-transform: translateX(26px);\n        -ms-transform: translateX(26px);\n        transform: translateX(26px);\n    }\n\n    /* Rounded sliders */\n    .slider.round {\n        border-radius: 34px;\n    }\n\n    .slider.round:before {\n        border-radius: 50%;\n    }</style>");
$templateCache.put("app/components/views/controlled-way/controlledWayMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/controlled-way/editControlledWay.html","<h2 class=ng-cloak><span>{{\'controlledWayHead\' | translate}}</span> <span class=pull-right style=\"padding-right: 105px\"><span>{{\'category\' | translate}}</span> <span style=\"color: #e41b35\">{{vm.controlledWayData[0].category === \'S\' ? \'SEDAN\' : \'MINIBUS\'}}</span></span></h2><div class=\"container-fluid ng-cloak\" id=valor_via ng-class=\"{\'whirl duo\' : vm.loading }\" style=\"padding-left: 110px; padding-right: 110px\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"panel panel-default\"><div class=panel-body style=\"padding: 25px\"><div class=upper-div><div class=upper-div-head><b>Ultima actualización:</b></div><div class=col-xs-12><span class=align-right style=\"margin-left: 8px\" ng-if=\"(vm.controlledWayData[0][\'DateTime Update\'])\">{{vm.changeDateIntoSpanish(vm.controlledWayData[0][\'DateTime Update\'])}} {{(vm.controlledWayData[0][\'DateTime Update\']) | date: \'HH:mm\'}} </span><span class=align-right style=\"margin-left: 8px\" ng-if=\"(!vm.controlledWayData[0][\'DateTime Update\'])\"></span> <b class=align-right>Fecha:</b></div><div class=col-xs-12><span class=align-right style=\"margin-left: 8px\">{{vm.controlledWayData[0].fullName}} </span><b class=align-right>Actualizado por:</b></div></div><br><div class=lower-div><div class=\"col-xs-12 padR0\"><div class=\"col-md-6 col-xs-12\"><label>Valor para Servicio Exclusivos/Agrupados: <span style=color:red>*</span></label></div><div class=\"col-md-6 col-xs-12 padR0\"><input type=text class=form-control id=exclusiveValue ng-model=vm.value_exclusive is-number maxlength=4 placeholder=\"Valor de la vía\" ng-required=true ng-class=\"{ \'has-error\': vm.value_exclusive_error }\" ng-keyup=vm.updateValueExclusive() style=\"padding-left: 20px\"> <span class=unit>$</span><p ng-if=vm.value_exclusive_error style=color:red>{{\'controlledWayError\' | translate}}</p></div></div><br><br><div class=\"col-xs-12 padR0\"><div class=\"col-md-6 col-xs-12\"><label>Valor para Servicio Compartidos: <span style=color:red>*</span></label></div><div class=\"col-md-6 col-xs-12 padR0 marT10\"><table class=\"table table-hover controlledWayTable tableWithMasterData\"><thead><tr><th style=\"background: lightgrey\">Pasajeros</th><th>Valor</th><th style=\"background: lightgrey\">Total Vía</th></tr></thead><tbody><tr ng-repeat=\"data in vm.editDataArray\"><td style=\"vertical-align: middle; background: lightgrey\">{{data.pasejro + 1}}</td><td><input type=text class=\"form-control inputHeight28 inputText1\" name=discount ng-model=data.value_pass is-number maxlength=4 ng-required=true ng-class=\"{ \'has-error\': !data.value_pass || data.value_pass < 1 || data.value_pass > 5000 }\" ng-keyup=vm.value_pass() style=\"padding-left: 60px\"> <span class=\"unitPass{{data.pasejro + 1}}\">$</span></td><td style=\"vertical-align: middle; background: lightgrey\"><span ng-if=data.value_pass class=align-left>$ </span><span ng-if=data.value_pass class=align-right><!-- {{vm.numberWithCommas(data.value_pass * (data.pasejro + 1))}} --> {{vm.numberWithCommas(data.total_value)}} </span><span ng-if=!data.value_pass>--</span></td></tr></tbody></table><p ng-if=vm.value_pass_error style=\"color:red; padding-bottom: 20px\">{{\'controlledWayError\' | translate}}</p></div><div class=\"col-md-6 col-xs-12 middle-div\"><h4><u id=imp_info>Información importante:</u></h4><ul class=padL15><li>La via aplica solo para viajes zarpe Aeropuerto SCL (Santiago)</li><li>Es calculado por viaje-zarpe.</li><li>El valor para los servicios exclusivos y agrupados es el mismo.</li><li>El monto para los servicios compartidos debe ser ingresado por pasajero y debe ser una buena aproximación del valor usado en servicios exclusivos/agrupados. Use el valor TotalVia para guiarse.</li></ul></div></div></div><br><br><div class=\"col-xs-12 padR0\"><button type=button class=\"cancelLabelButton align-right padLR25\" ui-sref=layout.controlledWayMain.controlledWay style=\"margin-left: 8px\">Cancelar</button> <button type=button class=\"addLabelButton align-right padLR25\" ng-click=vm.updateControlledWay()>Guardar</button></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/corporate/addCorporate.html","<h2 class=ng-cloak>{{\'corporateHead\' | translate}} / {{\'addCorpoHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=corporate><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'enterDetailsHead\' | translate}}</p><div class=basicDetailsDiv><form name=addcorporateForm ng-submit=\"submit=true;addcorporateForm.$valid&&vm.registerApi()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-if=vm.errorFlag><p class=noholdingCheck>{{vm.errorFlag}}</p></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'companyNameLabel\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.company_name name=companyName placeholder=\"{{\'companyNameLabel\' | translate}}\" required ng-maxlength=60 ng-minlength=3 ng-class=\"{ \'has-error\': addcorporateForm.companyName.$touched && addcorporateForm.companyName.$invalid }\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\"addcorporateForm.companyName.$touched|| submit\" ng-messages=addcorporateForm.companyName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'companyReq\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid company name.</div>--><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'firstNameMaximum\' | translate}}</div></div></div><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">{{\'typeOfCompany\' | translate}}<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.type_of_company\" ng-class=\"{ \'has-error\': addcorporateForm.typeOfCompany.$touched && addcorporateForm.typeOfCompany.$invalid }\"--><!--name=\"typeOfCompany\" placeholder=\"{{\'typeOfCompany\' | translate}}\" required>--><!--<div ng-if=\"addcorporateForm.typeOfCompany.$touched|| submit\" ng-messages=\"addcorporateForm.typeOfCompany.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">{{\'companyTypeReq\' | translate}}</div>--><!--</div>--><!--</div>--><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'rutLabel\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.RUT name=corporateRUT placeholder=\"{{\'rutLabel\' | translate}}\" ng-rut ng-change=vm.rutChange() required ng-class=\"{ \'has-error\': addcorporateForm.corporateRUT.$touched && addcorporateForm.corporateRUT.$invalid }\"><div ng-if=\"addcorporateForm.corporateRUT.$touched|| submit\" ng-messages=addcorporateForm.corporateRUT.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'rutRequired\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid RUT.</div>--></div><div class=\"errormessage text-danger\" ng-if=vm.rutFlag>{{\'rutValid\' | translate}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'holding\' | translate}}<span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.holding ng-class=\"{ \'has-error\': addcorporateForm.holding.$touched && addcorporateForm.holding.$invalid }\" name=holding required ng-change=vm.selectHolding()><option value=\"\" disabled>{{\'selectHolding\' | translate}}</option><option value=1>Yes</option><option selected value=0>No</option></select><div ng-if=\"addcorporateForm.holding.$touched|| submit\" ng-messages=addcorporateForm.holding.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'holdingR\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label>{{\'companyHolding\' | translate}}<span style=color:red>*</span></label><ui-select ng-model=vm.dataToFill.company_holding name=companyHolding required ng-disabled=\"vm.dataToFill.holding == \'1\'\" close-on-select=true ng-class=\"{ \'has-error\': addcorporateForm.companyHolding.$touched && addcorporateForm.companyHolding.$invalid }\"><ui-select-match placeholder=\"{{\'companyHoldingPlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in vm.companyHoldingList | filter: $select.search\"><div ng-bind-html=data.name></div></ui-select-choices></ui-select><div ng-if=\"addcorporateForm.companyHolding.$touched|| submit\" ng-messages=addcorporateForm.companyHolding.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'companyHoldingR\' | translate}}</div></div></div><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">Search Address<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.fullAddress\" name=\"fullAddress\" placeholder=\"Search Address\" required ng-class=\"{ \'has-error\': driverRegisterForm.fullAddress.$touched && driverRegisterForm.fullAddress.$invalid }\" googleplace--><!--callback-fn=\"vm.ctrlFn(data)\" />--><!--<div ng-if=\"driverRegisterForm.fullAddress.$touched|| submit\" ng-messages=\"driverRegisterForm.fullAddress.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter address</div>--><!--</div>--><!--</div>--><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">\n                                        <label class=\"control-label\">Created On<span style=\"color:red\">*</span></label>\n                                        <p class=\"input-group\">\n                                            <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{vm.format}}\" ng-model=\"vm.dataToFill.vehicle_creation_date\" name=\"VehicleDate\" required ng-class=\"{ \'has-error\': addcorporateForm.vehicle_creation_date.$touched && addcorporateForm.vehicle_creation_date.$invalid }\"\n                                                close-text=\"Close\" alt-input-formats=\"vm.altInputFormats\" show-button-bar=\"false\" readonly/>\n\n                                        </p>\n                                        <div ng-if=\"addcorporateForm.vehicle_creation_date.$touched|| submit\" ng-messages=\"addcorporateForm.vehicle_creation_date.$error\">\n                                            <div class=\"errormessage text-danger\" ng-message=\"required\"></div>\n                                        </div>\n                                    </div>\n                                    <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">\n                                        <label class=\"control-label\">Category By<span style=\"color:red\">*</span></label>\n                                        <input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.login_name\" name=\"loginName\" required />\n\n                                    </div>--><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">\n                                        <label class=\"control-label\">Company Type<span style=\"color:red\">*</span></label>\n                                        <select class=\"form-control\" ng-model=\"vm.dataToFill.company_type\" name=\"companyType\" required ng-class=\"{ \'has-error\': addcorporateForm.companyType.$touched && addcorporateForm.companyType.$invalid }\">\n                                            <option value=\"\" disabled selected>Select Company Type</option>--><!--<option value=\"3\" >Micro</option>\n                                                <option value=\"4\" >Mini</option>\n                                                <option value=\"5\" >Sedan</option>--><!--</select>\n                                        <div ng-if=\"addcorporateForm.companyType.$touched || submit\" ng-messages=\"addcorporateForm.companyType.$error\">\n                                            <div class=\"errormessage text-danger\" ng-message=\"required\">Please select Coporate Type.</div>\n                                        </div>\n                                    </div>--><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">State<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.state\" name=\"state\" placeholder=\"Enter State\" required ng-maxlength=\"60\" ng-minlength=\"2\" ng-class=\"{ \'has-error\': addcorporateForm.state.$touched && addcorporateForm.state.$invalid }\" pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><!--/>--><!--<div ng-if=\"addcorporateForm.state.$touched|| submit\" ng-messages=\"addcorporateForm.state.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter company state</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid state.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"minlength\">Minimum 2 characters are required.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"maxlength\">Maximum 60 characters are allowed.</div>--><!--</div>--><!--</div>--><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">City<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.city\" name=\"city\" placeholder=\"Enter City\" required ng-maxlength=\"60\" ng-minlength=\"2\" ng-class=\"{ \'has-error\': addcorporateForm.city.$touched && addcorporateForm.city.$invalid }\" pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><!--/>--><!--<div ng-if=\"addcorporateForm.city.$touched|| submit\" ng-messages=\"addcorporateForm.city.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter company city</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid city.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"minlength\">Minimum 2 characters are required.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"maxlength\">Maximum 60 characters are allowed.</div>--><!--</div>--><!--</div>--><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">Street<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.street\" name=\"street\" placeholder=\"Enter Street\" required ng-class=\"{ \'has-error\': addcorporateForm.street.$touched && addcorporateForm.street.$invalid }\" />--><!--<div ng-if=\"addcorporateForm.street.$touched|| submit\" ng-messages=\"addcorporateForm.street.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter street</div>--><!--&lt;!&ndash;<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid city.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"minlength\">Minimum 2 characters are required.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"maxlength\">Maximum 60 characters are allowed.</div>&ndash;&gt;--><!--</div>--><!--</div>--><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">Flat No<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\"  ng-model=\"vm.dataToFill.flat_no\" is-number=\"\" name=\"flat_no\" placeholder=\"Enter Flat No.\" required ng-class=\"{ \'has-error\': addcorporateForm.flat_no.$touched && addcorporateForm.flat_no.$invalid }\"--><!--/>&lt;!&ndash;onkeypress=\'return event.charCode >= 48 && event.charCode <= 57\'&ndash;&gt;--><!--<div ng-if=\"addcorporateForm.flat_no.$touched|| submit\" ng-messages=\"addcorporateForm.flat_no.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter Flat No.</div>--><!--&lt;!&ndash;<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid city.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"minlength\">Minimum 2 characters are required.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"maxlength\">Maximum 60 characters are allowed.</div>&ndash;&gt;--><!--</div>--><!--</div>--><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">Contact Person Name<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.contact_person_name\" name=\"contactPersonName\" placeholder=\"Contract Person Name\" required ng-maxlength=\"60\" ng-minlength=\"2\" ng-class=\"{ \'has-error\': addcorporateForm.contactPersonName.$touched && addcorporateForm.contactPersonName.$invalid }\"--><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\" />--><!--<div ng-if=\"addcorporateForm.contactPersonName.$touched|| submit\" ng-messages=\"addcorporateForm.contactPersonName.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter contact person name</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid contact person name.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"minlength\">Minimum 2 characters are required.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"maxlength\">Maximum 60 characters are allowed.</div>--><!--</div>--><!--</div>--><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">Designation<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.designation\" name=\"designation\" placeholder=\"Designation\" required ng-maxlength=\"60\" ng-minlength=\"2\" ng-class=\"{ \'has-error\': addcorporateForm.designation.$touched && addcorporateForm.designation.$invalid }\"--><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\" />--><!--<div ng-if=\"addcorporateForm.designation.$touched|| submit\" ng-messages=\"addcorporateForm.designation.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter designation</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid designation.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"minlength\">Minimum 2 characters are required.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"maxlength\">Maximum 60 characters are allowed.</div>--><!--</div>--><!--</div>--><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">Contact Person Phone Number<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.contact_person_phone_number\" name=\"contact_person_phone_number\" placeholder=\"Contact person phone number\" required ng-class=\"{ \'has-error\': addcorporateForm.contact_person_phone_number.$touched && addcorporateForm.contact_person_phone_number.$invalid }\"--><!--pattern=\"^([9]{1}[0-9]{8})*$\" ng-minlength=\"9\" ng-maxlength=\"9\" />--><!--<div ng-if=\"addcorporateForm.contact_person_phone_number.$touched|| submit\" ng-messages=\"addcorporateForm.contact_person_phone_number.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter mobile number</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid mobile number.</div>--><!--</div>--><!--</div>--><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">Contact Person Email ID<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.contact_person_email_id\" name=\"corporateEmail\" placeholder=\"Email ID\" required ng-class=\"{ \'has-error\': addcorporateForm.corporateEmail.$touched && addcorporateForm.corporateEmail.$invalid }\"--><!--pattern=\"^([_a-zA-Z0-9-+]+)(\\.[_a-zA-Z0-9-+]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*\\.)+([a-zA-Z]{2,3})$\" />--><!--<div ng-if=\"addcorporateForm.corporateEmail.$touched|| submit\" ng-messages=\"addcorporateForm.corporateEmail.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter an Email ID</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid Email.</div>--><!--</div>--><!--</div>--><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">Contact Person RUT<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.contact_person_RUT\" name=\"contact_person_RUT\" placeholder=\"RUT\" ng-rut ng-change=\"vm.rutChangePerson()\" required ng-class=\"{ \'has-error\': addcorporateForm.contact_person_RUT.$touched && addcorporateForm.contact_person_RUT.$invalid }\"--><!--/>--><!--<div ng-if=\"addcorporateForm.contact_person_RUT.$touched|| submit\" ng-messages=\"addcorporateForm.contact_person_RUT.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter an RUT</div>--><!--&lt;!&ndash;<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid RUT.</div>&ndash;&gt;--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-show=\"vm.rutFlag_person\">Please enter a valid RUT.</div>--><!--</div>--><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" style=margin-top:10px><button type=submit class=\"btn btn-primary\">{{\'submit\' | translate}}</button></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/corporate/corporate.html","<h2 class=ng-cloak><span>{{\'corporateHead\' | translate}}</span> <span class=pull-right><button class=\"btn btn-primary tableButton\" ng-click=vm.refreshData()>Volver a cargar</button></span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-3 col-sm-6 col-md-3 col-xs-12\"><label class=control-label>{{\'corporateStatusHead\' | translate}}</label><select class=form-control ng-model=vm.filterData.corporateStatus ng-change=\"vm.getAllCorporates(0,vm.itemsPerPageGot,vm.filterData);vm.currentPage = 0;\"><option value=\"\" disabled>{{\'corporateStatusPlace\' | translate}}</option><option selected value=1>Activo</option><option value=0>Inactivo</option><option value=2>Todos</option></select></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center mt5\"><p class=totalSize><span class=pull-left><a class=\"btn btn-primary tableButton mb10\" ng-click=vm.exportToCSV(0,vm.dataLength,2)>CSV</a> </span><span class=pull-right><a class=\"btn btn-primary mb10\" ng-if=\"vm.userType == 0\" ui-sref=layout.corporateMain.addCorporate>+ {{\'addCorporateButton\' | translate}}</a> </span>{{\'totalCorporates\' | translate}}: {{vm.totalCorporates}}</p></div><br><br><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model-options=\"{ debounce: 500 }\" ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\"><!--ng-switch=\"(vm.corporateList | filter:vm.search).length\"--><!--<div ng-switch-when=\"0\" class=\"noSearch\"><span>{{\'nothingFound\' | translate}}</span></div>--><table class=\"table table-hover tableWithMasterData\"><!--ng-switch-default--><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'companyNameLabel\' | translate}}\" text=\"\'company_name\'\" check=vm.reverse>{{\'companyNameLabel\' | translate}}</th><!--<th>--><!--<div class=\"text-center\" ng-click=\"vm.sort(\'type_of_company\')\">--><!--{{\'typeOfCompany\' | translate}}--><!--<span ng-hide=\"vm.predicate == \'type_of_company\' && vm.reverse || vm.predicate == \'type_of_company\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'type_of_company\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'type_of_company\' && vm.reverse\" class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'holding\' | translate}}\" text=\"\'holding\'\" check=vm.reverse>{{\'holding\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'companyHolding\' | translate}}\" text=\"\'company_holding\'\" check=vm.reverse>{{\'companyHolding\' | translate}}</th><!--<th>--><!--<div class=\"text-center\" ng-click=\"vm.sort(\'address\')\">--><!--Address--><!--<span ng-hide=\"vm.predicate == \'address\' && vm.reverse || vm.predicate == \'address\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'address\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'address\' && vm.reverse\" class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><!--<th>--><!--<div class=\"text-center\" ng-click=\"vm.sort(\'status\')\">--><!--Status--><!--<span ng-hide=\"vm.predicate == \'status\' && vm.reverse || vm.predicate == \'status\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'status\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'status\' && vm.reverse\" class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><!--<th>\n                                                <div class=\"text-center\" ng-click=\"vm.sort(\'state\')\">\n                                                    State\n                                                    <span ng-hide=\"vm.predicate == \'state\' && vm.reverse || vm.predicate == \'state\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>\n                                                    <span ng-show=\"vm.predicate == \'state\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>\n                                                    <span ng-show=\"vm.predicate == \'state\' && vm.reverse\" class=\"fa fa-caret-up\"></span>\n                                                </div>\n                                            </th>--><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'rutLabel\' | translate}}\" text=\"\'RUT\'\" check=vm.reverse>{{\'rutLabel\' | translate}}</th><!--<th>--><!--<div class=\"text-center\" ng-click=\"vm.sort(\'created_on\')\">--><!--Created On--><!--<span ng-hide=\"vm.predicate == \'created_on\' && vm.reverse || vm.predicate == \'created_on\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'created_on\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'created_on\' && vm.reverse\" class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><!--<th>--><!--<div class=\"text-center\" ng-click=\"vm.sort(\'created_by\')\">--><!--Created By--><!--<span ng-hide=\"vm.predicate == \'created_by\' && vm.reverse || vm.predicate == \'created_by\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'created_by\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'created_by\' && vm.reverse\" class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><!--<th>--><!--<div class=\"text-center\" ng-click=\"vm.sort(\'updated_on\')\">--><!--Updated On--><!--<span ng-hide=\"vm.predicate == \'updated_on\' && vm.reverse || vm.predicate == \'updated_on\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'updated_on\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'updated_on\' && vm.reverse\" class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><!--<th>--><!--<div class=\"text-center\" ng-click=\"vm.sort(\'updated_by\')\">--><!--Updated By--><!--<span ng-hide=\"vm.predicate == \'updated_by\' && vm.reverse || vm.predicate == \'updated_by\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'updated_by\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'updated_by\' && vm.reverse\" class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><th style=width:100px ng-if=\"vm.userType == 0\"><div class=text-center>{{\'stateTable\' | translate}}</div></th><th style=width:125px><div class=text-center>{{\'action\' | translate}}</div></th><th style=width:150px ng-if=\"vm.userType == 0\"><div class=text-center>{{\'adminLogs\' | translate}}</div></th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.corporateList| orderBy:vm.predicate:vm.reverse\"><!--| filter:vm.search--><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:70px>{{::data.id}}</td><td style=width:125px>{{data.company_name==null?\"-----\":data.company_name}}</td><!--<td>{{data.type_of_company==null?\"-&#45;&#45;&#45;&#45;\":data.type_of_company}}</td>--><td style=width:125px>{{data.holding==1?\"Yes\":\'No\'}}</td><td style=width:125px><span ng-if=\"data.company_holding == 0 || data.company_holding == null\">{{\'notApplicable\' | translate}}</span> <span ng-if=\"data.company_holding != 0\">{{data.company_holding_name}}</span></td><!--<td style=\"text-align:left\">--><!--<span ng-if=\"!data.address\">--><!--<b>Flat No:</b> {{data.flat_no}}<br/>--><!--<b>Street:</b> {{data.street}}<br/>--><!--<b>State:</b> {{data.state}}<br/>--><!--<b>City:</b> {{data.city}}--><!--</span>--><!--<span ng-if=\"data.address\">{{data.address}}</span>--><!--</td>--><!--<td>--><!--<span ng-if=\"data.status == 1\">Active</span>--><!--<span ng-if=\"data.status == 0\">Inactive</span>--><!--</td>--><!--<td>{{data.state==null?\"-----\":data.state}}</td>--><td style=width:125px>{{data.RUT==null?\"-----\":data.RUT}}</td><!--<td>{{data.created_on==null?\"-&#45;&#45;&#45;&#45;\":data.created_on}}</td>--><!--<td>{{data.created_by==null?\"-&#45;&#45;&#45;&#45;\":data.created_by}}</td>--><!--<td>{{data.updated_on==null?\"-&#45;&#45;&#45;&#45;\":data.updated_on}}</td>--><!--<td>{{data.updated_by==null?\"-&#45;&#45;&#45;&#45;\":data.updated_by}}</td>--><td style=width:100px ng-if=\"vm.userType == 0\"><a class=\"cursor btn btn-sm\" ng-class=\"{\'blockIconColor\': data.status == 0, \'unblockIconColor\': data.status == 1}\" ng-click=vm.changeCorporateStatus(data,$event)><i ng-class=\"{\'fa fa-unlock\': data.status == 1,\'fa fa-lock\': data.status == 0}\"></i></a></td><td style=width:125px><a title=\"Edit Details\" ng-if=\"vm.userType == 0\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.corporateMain.editCorporate({id: \'{{data.id}}\'})\"><i class=\"fa fa-edit\"></i> </a><a title=\"View Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.corporateMain.viewCorporate({id: \'{{data.id}}\'})\"><i class=\"fa fa-eye\"></i> </a><!--<a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=\"vm.deleteCorporate(data,$event)\"><i class=\"fa fa-trash\"></i></a>--></td><td style=width:150px ng-if=\"vm.userType == 0\"><a class=\"btn btn-primary tableButton\" title=\"{{\'adminLogs\' | translate}}\" ui-sref=\"layout.corporateMain.adminLogs({userId:\'{{data.id}}\',type:\'6\',fakeType: \'9\'})\">{{\'adminLogs\' | translate}}</a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noCorporateFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav>--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\" ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/corporate/corporateMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/corporate/editCorporate.html","<h2 class=ng-cloak>{{\'corporateHead\' | translate}} / {{\'corpoEditHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=corporate><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'enterDetailsHead\' | translate}}</p><div class=basicDetailsDiv><form name=editCorporateForm ng-submit=\"submit=true;editCorporateForm.$valid&&vm.editApi()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-if=vm.errorFlag><p class=noholdingCheck>{{vm.errorFlag}}</p></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'companyNameLabel\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.company_name name=companyName placeholder=\"{{\'companyNameLabel\' | translate}}\" required ng-maxlength=60 ng-minlength=3 ng-class=\"{ \'has-error\': editCorporateForm.companyName.$touched && editCorporateForm.companyName.$invalid }\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\"editCorporateForm.companyName.$touched|| submit\" ng-messages=editCorporateForm.companyName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'companyReq\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid company name.--><!--</div>--><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'firstNameMaximum\' | translate}}</div></div></div><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">{{\'typeOfCompany\' | translate}}<span--><!--style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.type_of_company\"--><!--ng-class=\"{ \'has-error\': editCorporateForm.typeOfCompany.$touched && editCorporateForm.typeOfCompany.$invalid }\"--><!--name=\"typeOfCompany\" placeholder=\"{{\'typeOfCompany\' | translate}}\" required>--><!--<div ng-if=\"editCorporateForm.typeOfCompany.$touched|| submit\"--><!--ng-messages=\"editCorporateForm.typeOfCompany.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">{{\'companyTypeReq\' | translate}}--><!--</div>--><!--</div>--><!--</div>--><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'rutLabel\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.RUT name=corporateRUT placeholder=\"{{\'rutLabel\' | translate}}\" ng-rut ng-change=vm.rutChange() required ng-class=\"{ \'has-error\': editCorporateForm.corporateRUT.$touched && editCorporateForm.corporateRUT.$invalid }\"><div ng-if=\"editCorporateForm.corporateRUT.$touched|| submit\" ng-messages=editCorporateForm.corporateRUT.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'rutRequired\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid RUT.</div>--></div><div class=\"errormessage text-danger\" ng-if=vm.rutFlag>{{\'rutValid\' | translate}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'holding\' | translate}}<span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.holding ng-class=\"{ \'has-error\': editCorporateForm.holding.$touched && editCorporateForm.holding.$invalid }\" name=holding required ng-change=vm.selectHolding()><option value=\"\" disabled selected>{{\'selectHolding\' | translate}}</option><option value=1>Yes</option><option value=0>No</option></select><div ng-if=\"editCorporateForm.holding.$touched|| submit\" ng-messages=editCorporateForm.holding.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'holdingR\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label>{{\'companyHolding\' | translate}}<span style=color:red>*</span></label><ui-select ng-model=vm.dataToFill.company_holding name=companyHolding required ng-disabled=\"vm.dataToFill.holding == \'1\'\" close-on-select=true ng-class=\"{ \'has-error\': editCorporateForm.companyHolding.$touched && editCorporateForm.companyHolding.$invalid }\"><ui-select-match placeholder=\"{{\'companyHoldingPlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in vm.companyHoldingList | filter: $select.search\"><div ng-bind-html=data.name></div></ui-select-choices></ui-select><div ng-if=\"editCorporateForm.companyHolding.$touched|| submit\" ng-messages=editCorporateForm.companyHolding.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'companyHoldingR\' | translate}}</div></div></div><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">Search Address</label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.fullAddress\"--><!--name=\"fullAddress\" placeholder=\"Search Address\"--><!--ng-class=\"{ \'has-error\': editCorporateForm.fullAddress.$touched && editCorporateForm.fullAddress.$invalid }\"--><!--googleplace--><!--callback-fn=\"vm.ctrlFn(data)\"/>--><!--&lt;!&ndash;<div ng-if=\"editCorporateForm.fullAddress.$touched|| submit\" ng-messages=\"editCorporateForm.fullAddress.$error\">&ndash;&gt;--><!--&lt;!&ndash;<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter address</div>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">Full Address</label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.address\"--><!--name=\"fullAddress\" placeholder=\"Search Address\"--><!--ng-class=\"{ \'has-error\': editCorporateForm.fullAddress.$touched && editCorporateForm.fullAddress.$invalid }\" readonly/>--><!--&lt;!&ndash;<div ng-if=\"editCorporateForm.fullAddress.$touched|| submit\" ng-messages=\"editCorporateForm.fullAddress.$error\">&ndash;&gt;--><!--&lt;!&ndash;<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter address</div>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">State<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.state\"--><!--name=\"state\" placeholder=\"Enter State\" required ng-maxlength=\"60\"--><!--ng-minlength=\"2\"--><!--ng-class=\"{ \'has-error\': editCorporateForm.state.$touched && editCorporateForm.state.$invalid }\"--><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><!--/>--><!--<div ng-if=\"editCorporateForm.state.$touched|| submit\"--><!--ng-messages=\"editCorporateForm.state.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter--><!--company state--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid state.--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"minlength\">Minimum 2--><!--characters are required.--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"maxlength\">Maximum 60--><!--characters are allowed.--><!--</div>--><!--</div>--><!--</div>--><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">City<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.city\"--><!--name=\"city\" placeholder=\"Enter City\" required ng-maxlength=\"60\"--><!--ng-minlength=\"2\"--><!--ng-class=\"{ \'has-error\': editCorporateForm.city.$touched && editCorporateForm.city.$invalid }\"--><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><!--/>--><!--<div ng-if=\"editCorporateForm.city.$touched|| submit\"--><!--ng-messages=\"editCorporateForm.city.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter--><!--company city--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid city.--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"minlength\">Minimum 2--><!--characters are required.--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"maxlength\">Maximum 60--><!--characters are allowed.--><!--</div>--><!--</div>--><!--</div>--><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">Street<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.street\"--><!--name=\"street\" placeholder=\"Enter Street\" required--><!--ng-class=\"{ \'has-error\': editCorporateForm.street.$touched && editCorporateForm.street.$invalid }\"/>--><!--<div ng-if=\"editCorporateForm.street.$touched|| submit\"--><!--ng-messages=\"editCorporateForm.street.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter--><!--street--><!--</div>--><!--&lt;!&ndash;<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid city.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"minlength\">Minimum 2 characters are required.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"maxlength\">Maximum 60 characters are allowed.</div>&ndash;&gt;--><!--</div>--><!--</div>--><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">Flat No<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.flat_no\"--><!--is-number=\"\" name=\"flat_no\" placeholder=\"Enter Flat No.\" required--><!--ng-class=\"{ \'has-error\': editCorporateForm.flat_no.$touched && editCorporateForm.flat_no.$invalid }\"--><!--/>&lt;!&ndash;onkeypress=\'return event.charCode >= 48 && event.charCode <= 57\'&ndash;&gt;--><!--<div ng-if=\"editCorporateForm.flat_no.$touched|| submit\"--><!--ng-messages=\"editCorporateForm.flat_no.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter--><!--Flat No.--><!--</div>--><!--&lt;!&ndash;<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid city.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"minlength\">Minimum 2 characters are required.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"maxlength\">Maximum 60 characters are allowed.</div>&ndash;&gt;--><!--</div>--><!--</div>--><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">Contact Person Name<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\"--><!--ng-model=\"vm.dataToFill.contact_person_name\" name=\"contactPersonName\"--><!--placeholder=\"Contract Person Name\" required ng-maxlength=\"60\"--><!--ng-minlength=\"2\"--><!--ng-class=\"{ \'has-error\': editCorporateForm.contactPersonName.$touched && editCorporateForm.contactPersonName.$invalid }\"--><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"/>--><!--<div ng-if=\"editCorporateForm.contactPersonName.$touched|| submit\"--><!--ng-messages=\"editCorporateForm.contactPersonName.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter--><!--contact person name--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid contact person name.--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"minlength\">Minimum 2--><!--characters are required.--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"maxlength\">Maximum 60--><!--characters are allowed.--><!--</div>--><!--</div>--><!--</div>--><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">Designation<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.designation\"--><!--name=\"designation\" placeholder=\"Designation\" required ng-maxlength=\"60\"--><!--ng-minlength=\"2\"--><!--ng-class=\"{ \'has-error\': editCorporateForm.designation.$touched && editCorporateForm.designation.$invalid }\"--><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"/>--><!--<div ng-if=\"editCorporateForm.designation.$touched|| submit\"--><!--ng-messages=\"editCorporateForm.designation.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter--><!--designation--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid designation.--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"minlength\">Minimum 2--><!--characters are required.--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"maxlength\">Maximum 60--><!--characters are allowed.--><!--</div>--><!--</div>--><!--</div>--><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">Contact Person Phone Number<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\"--><!--ng-model=\"vm.dataToFill.contact_person_phone_number\"--><!--name=\"contact_person_phone_number\"--><!--placeholder=\"Contact person phone number\" required--><!--ng-class=\"{ \'has-error\': editCorporateForm.contact_person_phone_number.$touched && editCorporateForm.contact_person_phone_number.$invalid }\"--><!--pattern=\"^([9]{1}[0-9]{8})*$\" ng-minlength=\"9\" ng-maxlength=\"9\"/>--><!--<div ng-if=\"editCorporateForm.contact_person_phone_number.$touched|| submit\"--><!--ng-messages=\"editCorporateForm.contact_person_phone_number.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter--><!--mobile number--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid mobile number.--><!--</div>--><!--</div>--><!--</div>--><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">Contact Person Email ID<span--><!--style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\"--><!--ng-model=\"vm.dataToFill.contact_person_email_id\" name=\"corporateEmail\"--><!--placeholder=\"Email ID\" required--><!--ng-class=\"{ \'has-error\': editCorporateForm.corporateEmail.$touched && editCorporateForm.corporateEmail.$invalid }\"--><!--pattern=\"^([_a-zA-Z0-9-+]+)(\\.[_a-zA-Z0-9-+]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*\\.)+([a-zA-Z]{2,3})$\"/>--><!--<div ng-if=\"editCorporateForm.corporateEmail.$touched|| submit\"--><!--ng-messages=\"editCorporateForm.corporateEmail.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter an--><!--Email ID--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid Email.--><!--</div>--><!--</div>--><!--</div>--><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">Contact Person RUT<span style=\"color:red\">*</span></label>--><!--<input type=\"text\" class=\"form-control\"--><!--ng-model=\"vm.dataToFill.contact_person_RUT\" name=\"contact_person_RUT\"--><!--placeholder=\"RUT\" ng-rut ng-change=\"vm.rutChangePerson()\" required--><!--ng-class=\"{ \'has-error\': editCorporateForm.contact_person_RUT.$touched && editCorporateForm.contact_person_RUT.$invalid }\"--><!--/>--><!--<div ng-if=\"editCorporateForm.contact_person_RUT.$touched|| submit\"--><!--ng-messages=\"editCorporateForm.contact_person_RUT.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter an--><!--RUT--><!--</div>--><!--&lt;!&ndash;<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid RUT.</div>&ndash;&gt;--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-show=\"vm.rutFlag_person\">Please enter a--><!--valid RUT.--><!--</div>--><!--</div>--><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" style=margin-top:10px><button type=submit class=\"btn btn-primary\">{{\'submit\' | translate}}</button></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/corporate/viewCorporateDetails.html","<h2 class=ng-cloak>{{\'corporateHead\' | translate}} / {{\'corpoDetailsHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=driver><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-1 col-md-offset-1 col-xs-offset-0 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'allDetails\' | translate}}</p><div class=basicDetailsDiv><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'companyNameLabel\' | translate}}:</label><div class=\"form-control text-capitalize\">{{::vm.corporateDetails.company_name}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'holding\' | translate}}:</label><div class=\"form-control text-capitalize\"><span ng-if=\"vm.corporateDetails.holding==0\">No</span> <span ng-if=\"vm.corporateDetails.holding==1\">Yes</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'companyHolding\' | translate}}:</label><div class=\"form-control text-capitalize\"><span ng-if=vm.corporateDetails.company_holding_name>{{::vm.corporateDetails.company_holding_name}}</span> <span ng-if=!vm.corporateDetails.company_holding_name>{{\'notApplicable\' | translate}}</span></div></div><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\">--><!--<label class=\"control-label\">Full Address:</label>--><!--<div class=\"form-control text-capitalize\">{{vm.corporateDetails.address}}--><!--</div>--><!--</div>--><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\">--><!--<label class=\"control-label\">Flat Number:</label>--><!--<div class=\"form-control text-capitalize\">{{vm.corporateDetails.flat_no}}--><!--</div>--><!--</div>--><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\">--><!--<label class=\"control-label\">Street:</label>--><!--<div class=\"form-control text-capitalize\">{{vm.corporateDetails.street}}--><!--</div>--><!--</div>--><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\">--><!--<label class=\"control-label\">City:</label>--><!--<div class=\"form-control text-capitalize\">{{vm.corporateDetails.city}}--><!--</div>--><!--</div>--><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\">--><!--<label class=\"control-label\">State:</label>--><!--<div class=\"form-control text-capitalize\">{{vm.corporateDetails.state}}--><!--</div>--><!--</div>--><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'rutLabel\' | translate}}:</label><div class=\"form-control text-capitalize\">{{::vm.corporateDetails.RUT}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'corpoID\' | translate}}:</label><div class=\"form-control text-capitalize\">{{::vm.corporateDetails.id}}</div></div><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\">--><!--<label class=\"control-label\">Corporate Contact Person:</label>--><!--<div class=\"form-control text-capitalize\">--><!--{{vm.corporateDetails.contactPersonData.person_name}}--><!--</div>--><!--</div>--><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\">--><!--<label class=\"control-label\">Corporate Contact Person Mobile:</label>--><!--<div class=\"form-control text-capitalize\">--><!--{{vm.corporateDetails.contactPersonData.person_phone_number}}--><!--</div>--><!--</div>--><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\">--><!--<label class=\"control-label\">Corporate Contact Person Email:</label>--><!--<div class=\"form-control text-capitalize\">--><!--{{vm.corporateDetails.contactPersonData.person_email_id}}--><!--</div>--><!--</div>--><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\">--><!--<label class=\"control-label\">Corporate Contact Person RUT:</label>--><!--<div class=\"form-control text-capitalize\">--><!--{{vm.corporateDetails.contactPersonData.person_RUT}}--><!--</div>--><!--</div>--><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\">--><!--<label class=\"control-label\">Corporate Contact Person Designation:</label>--><!--<div class=\"form-control text-capitalize\">--><!--{{vm.corporateDetails.contactPersonData.designation}}--><!--</div>--><!--</div>--><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'corpoDelete\' | translate}}:</label><div class=\"form-control text-capitalize\"><span ng-if=\"vm.corporateDetails.is_deleted == 1\">Yes</span> <span ng-if=\"vm.corporateDetails.is_deleted == 0\">No</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'corporateStatusHead\' | translate}}:</label><div class=\"form-control text-capitalize\"><span ng-if=\"vm.corporateDetails.status == 1\">Activa</span> <span ng-if=\"vm.corporateDetails.status == 0\">Inactive</span></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/correct-fare-reason/correctFareReason.html","<h2 class=ng-cloak>{{\'correctReasonHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-4 col-sm-6 col-md-4 col-xs-12\"><label class=control-label>{{\'correctReasonStatus\' | translate}}</label><select class=form-control ng-model=vm.filterData.correctFareStatus ng-change=\"vm.getCorrectFareReasonHit(0,10,vm.filterData.correctFareStatus);vm.currentPage = 0;\"><option value=\"\" disabled>{{\'correctReasonStatusPlace\' | translate}}</option><option selected value=0>Active</option><option value=1>Inactive</option><option value=2>All</option></select></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><p class=totalSize><span class=pull-right><a class=\"btn btn-primary mb10\" ng-click=vm.addNewReason($event)>+ {{\'addNewReasonButton\' | translate}}</a> </span>{{\'totalReason\' | translate}}: {{vm.totalReasons}}</p></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-switch=\"(vm.serviceList | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'reasonLabel\' | translate}}\" text=\"\'reason\'\" check=vm.reverse>{{\'reasonLabel\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'description\' | translate}}\" text=\"\'description\'\" check=vm.reverse>{{\'description\' | translate}}</th><th style=width:100px><div>{{\'stateTable\' | translate}}</div></th><th style=width:150px><div>{{\'action\' | translate}}</div></th><th style=width:150px><div>{{\'adminLogs\' | translate}}</div></th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.correctFareReasonList| filter:vm.search | orderBy:vm.predicate:vm.reverse\"><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:70px>{{::data.id}}</td><td style=width:125px>{{::data.reason}}</td><td style=width:125px>{{::data.description}}</td><td style=width:100px><a class=\"cursor btn btn-sm\" ng-class=\"{\'blockIconColor\': data.status == 1, \'unblockIconColor\': data.status == 0}\" ng-click=vm.changeReasonStatus(data.id,data.status,$event)><i ng-class=\"{\'fa fa-unlock\': data.status == 0,\'fa fa-lock\': data.status == 1}\"></i></a></td><td style=width:150px><a title=\"Edit Details\" class=\"cursor editIconColor btn btn-sm\" ng-click=vm.editReasonPop(data,$event)><i class=\"fa fa-edit\"></i> </a><a title=\"View Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.correctFareReasonMain.viewCorrectFareReason({id:\'{{data.id}}\'})\"><i class=\"fa fa-eye\"></i> </a><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteReason(data,$event)><i class=\"fa fa-trash\"></i></a></td><td style=width:150px><a class=\"btn btn-primary tableButton\" title=\"{{\'adminLogs\' | translate}}\" ui-sref=\"layout.correctFareReasonMain.adminLogs({userId:\'{{data.id}}\',type:\'23\',fakeType: \'25\'})\">{{\'adminLogs\' | translate}}</a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noReasonFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav ng-show=\"vm.watchPagination\">--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\" ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/correct-fare-reason/correctFareReasonMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/correct-fare-reason/viewCorrectFareReason.html","<h2 class=ng-cloak>{{\'correctReasonHead\' | translate}} / {{\'correctReasonDetailsHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=driver><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'allDetails\' | translate}}</p><div class=basicDetailsDiv><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'reasonLabel\' | translate}}:</label><div class=\"form-control text-capitalize\">{{::vm.correctFareReasonDetail.reason}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'description\' | translate}}:</label><textarea class=form-control ng-model=vm.correctFareReasonDetail.description placeholder=\"No Description\" readonly></textarea></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'reasonId\' | translate}}:</label><div class=\"form-control text-capitalize\">{{::vm.correctFareReasonDetail.reason_id}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'reasonStatus\' | translate}}:</label><div class=\"form-control text-capitalize\"><span ng-if=\"vm.correctFareReasonDetail.block_status == 1\">Not Active</span> <span ng-if=\"vm.correctFareReasonDetail.block_status == 0\">Active</span></div></div><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">Reason Deleted:</label>--><!--<div class=\"form-control text-capitalize\">--><!--<span ng-if=\"vm.correctFareReasonDetail.is_deleted == 1\">Yes</span>--><!--<span ng-if=\"vm.correctFareReasonDetail.is_deleted == 0\">No</span>--><!--</div>--><!--</div>--></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/create-booking/createBooking.html","<h2 class=ng-cloak><span ng-if=!vm.dataToFill.bookingId>{{\'createBookingHead\' | translate}}</span> <span ng-if=vm.dataToFill.bookingId>{{\'modifyBookingHead\' | translate}}</span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><form name=createBookingForm ng-submit=\"submit=true;createBookingForm.$valid&&vm.createBookingByPass($event , false , true);vm.CreateBookingNew(createBookingForm , $event)\" novalidate autocomplete=off><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 paddingZero\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" ng-if=\"vm.dataToFill.authRequired == \'1\'\" style=color:red;font-size:14px>{{\'passenegerRequireAuth\' | translate}}</div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" ng-if=vm.onclickErrorPickDrop style=color:red;font-size:14px>{{vm.onclickErrorPickDrop}}</div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><span ng-if=vm.dataToFill.customerMobile.profile_pic_thumb><img ng-src={{vm.dataToFill.customerMobile.profile_pic_thumb}} style=height:75px> </span><span class=pull-right ng-if=\"vm.dataToFill.is_vip && vm.dataToFill.is_vip == 1\"><p class=vipCustomer>VIP</p></span></div></div><div class=\"row mt5\" ng-hide=vm.newCustomerFlag><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'searchCustLabel\' | translate}} <span style=color:red>*</span></label><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) maxlength=80 type=text ng-model=vm.dataToFill.customerMobile placeholder=\"{{\'searchCustLabel\' | translate}}\" uib-typeahead=\"customers as customers.name for customers in vm.searchCustomer($viewValue)\" typeahead-loading=loadingCustomers typeahead-no-results=noResults class=\"form-control createBookingSelect\" name=searchCustomer typeahead-on-select=vm.onSelectingCustomer() typeahead-wait-ms=600 typeahead-template-url=customTemplate.html required ng-class=\"{ \'has-error\': createBookingForm.searchCustomer.$touched && createBookingForm.searchCustomer.$invalid }\"><!--vm.allCustomersList--> <i ng-if=loadingCustomers class=\"glyphicon glyphicon-refresh\"></i><div ng-if=\"noResults && vm.dataToFill.customerMobile.length > 3\" class=mt5><span><i class=\"glyphicon glyphicon-remove\"></i> {{\'searchCustError\' | translate}}</span> <span class=pull-right><a class=\"btn btn-primary tableButton\" ng-click=vm.addNewCustomer()>{{\'searchCustAddUser\' | translate}}</a></span></div><div ng-if=\"createBookingForm.searchCustomer.$touched|| submit\" ng-messages=createBookingForm.searchCustomer.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'searchCustReq\' | translate}}</div></div></div></div><div class=\"row mt5\" ng-if=vm.newCustomerFlag><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'custFirstName\' | translate}} <span style=color:red>*</span></label><input type=text ng-model=vm.dataToFill.first_name placeholder=\"{{\'custFirstName\' | translate}}\" class=form-control pattern=^\\D*$ ng-maxlength=60 ng-minlength=3 name=customerFirstName required ng-class=\"{ \'has-error\': createBookingForm.customerFirstName.$touched && createBookingForm.customerFirstName.$invalid }\"><div ng-if=\"createBookingForm.customerFirstName.$touched|| submit\" ng-messages=createBookingForm.customerFirstName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'custFirstNameReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'custFirstNameValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'businessNameMaximum\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'custLastName\' | translate}} <span style=color:red>*</span></label><input type=text ng-model=vm.dataToFill.last_name placeholder=\"{{\'custLastName\' | translate}}\" class=form-control pattern=^\\D*$ ng-maxlength=60 ng-minlength=3 name=customerLastName required ng-class=\"{ \'has-error\': createBookingForm.customerLastName.$touched && createBookingForm.customerLastName.$invalid }\"><div ng-if=\"createBookingForm.customerLastName.$touched|| submit\" ng-messages=createBookingForm.customerLastName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'custLastNameReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'custLastNameValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'businessNameMaximum\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'custEmail\' | translate}} <span style=color:red>*</span></label><input type=text ng-model=vm.dataToFill.customerEmail placeholder=\"{{\'custEmail\' | translate}}\" class=form-control pattern=^([_a-zA-Z0-9-+]+)(\\.[_a-zA-Z0-9-+]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*\\.)+([a-zA-Z]{2,13})$ name=customerEmail ng-disabled=\"!vm.newCustomerFlag || vm.CheckBookingStatus(vm.bookingDetails)\" required ng-class=\"{ \'has-error\': createBookingForm.customerEmail.$touched && createBookingForm.customerEmail.$invalid }\"><div ng-if=\"createBookingForm.customerEmail.$touched|| submit\" ng-messages=createBookingForm.customerEmail.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'custEmailReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'custEmailValid\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'custMobile\' | translate}} <span style=color:red>*</span></label><input type=text ng-model=vm.dataToFill.customerMobileG placeholder=\"{{\'custMobile\' | translate}}\" class=form-control pattern=^([1-9]{1}[0-9]{8})*$ ng-minlength=9 ng-maxlength=9 name=customerMobileG required ng-disabled=\"vm.makePhoneEditAble || vm.CheckBookingStatus(vm.bookingDetails)\" ng-class=\"{ \'has-error\': createBookingForm.customerMobileG.$touched && createBookingForm.customerMobileG.$invalid }\"><!--ng-disabled=\"!vm.newCustomerFlag\"--><div ng-if=\"createBookingForm.customerMobileG.$touched|| submit\" ng-messages=createBookingForm.customerMobileG.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'custMobileReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'custMobileValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'custMobileValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'custMobileValid\' | translate}}</div></div></div></div><!--<div class=\"row mt5\" ng-if=\"vm.newCustomerFlag\">--><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">{{\'passwordPlaceholder\' | translate}}<span style=\"color:red\">*</span></label>--><!--<input type=\"password\" class=\"form-control\" ng-model=\"vm.dataToFill.password\"--><!--name=\"password\" placeholder=\"{{\'passwordPlaceholder\' | translate}}\"--><!--required ng-minlength=\"8\" ng-maxlength=\"16\"  ng-change=\"vm.matchPasswordAgain(vm.dataToFill.password)\"--><!--ng-class=\"{ \'has-error\': createBookingForm.password.$touched && createBookingForm.password.$invalid }\"/>--><!--<div ng-if=\"createBookingForm.password.$touched|| submit\"--><!--ng-messages=\"createBookingForm.password.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">{{\'passwordRequired\' | translate}}--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"minlength\">{{\'passwordMin\' | translate}}--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"maxlength\">{{\'passwordMax\' | translate}}--><!--</div>--><!--&lt;!&ndash;<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid country code.</div>&ndash;&gt;--><!--</div>--><!--</div>--><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">{{\'ConfirmPasswordPlaceholder\' | translate}}<span--><!--style=\"color:red\">*</span></label>--><!--<input type=\"password\" class=\"form-control\"--><!--ng-model=\"vm.dataToFill.confirmPassword\" name=\"confirmPassword\"--><!--placeholder=\"{{\'ConfirmPasswordPlaceholder\' | translate}}\" required ng-minlength=\"8\"--><!--ng-maxlength=\"16\"--><!--ng-class=\"{ \'has-error\': createBookingForm.confirmPassword.$touched && createBookingForm.confirmPassword.$invalid }\"--><!--ng-change=\"vm.matchPassword(vm.dataToFill.confirmPassword)\"/>--><!--<div ng-if=\"createBookingForm.confirmPassword.$touched|| submit\"--><!--ng-messages=\"createBookingForm.confirmPassword.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">{{\'confirmPasswordRequired\' | translate}}--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"minlength\">{{\'passwordMin\' | translate}}--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"maxlength\">{{\'passwordMax\' | translate}}--><!--</div>--><!--&lt;!&ndash;<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid mobile number.</div>&ndash;&gt;--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-show=\"vm.passwordMatchFlag\">{{\'passwordNotMatch\' | translate}}--><!--</div>--><!--</div>--><!--</div>--><div class=\"row mtb20\" ng-if=\"vm.userType == 0\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12 text-center\"><label class=control-label style=\"font-size:16px !important\"><input type=radio ng-disabled=\"vm.disableAgreementService == true || vm.CheckBookingStatus(vm.bookingDetails)\" ng-model=vm.dataToFill.customerProfile ng-change=vm.profileChanges() value=0 name=profile>&nbsp;&nbsp;Personal</label></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label style=\"font-size:16px !important\"><input type=radio ng-disabled=\"vm.disableAgreementService == true || vm.CheckBookingStatus(vm.bookingDetails)\" ng-model=vm.dataToFill.customerProfile ng-change=vm.profileChanges() value=1 name=profile>&nbsp;&nbsp;Corporate</label></div></div><div class=\"row mt5\" ng-if=\"vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == \'1\'\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'selectAgreement\' | translate}} <span style=color:red>*</span></label><select ng-disabled=\"vm.disableAgreementService == true || vm.CheckBookingStatus(vm.bookingDetails)\" class=form-control ng-model=vm.dataToFill.contractIdSelected name=agreement ng-change=vm.agreementTypeChanged() required ng-class=\"{ \'has-error\': createBookingForm.agreement.$touched && createBookingForm.agreement.$invalid }\" ng-options=\"data.id as data.name for data in vm.dataToFill.contractListShowing\"><option value=\"\" selected disabled>{{\'selectAgreement\' | translate}}</option></select><div ng-if=\"createBookingForm.agreement.$touched|| submit\" ng-messages=createBookingForm.agreement.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'selectAgreementReq\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=\"vm.dataToFill.customerProfile == \'1\' || vm.dataToFill.customerProfile == 1\"><label class=control-label style=\"visibility: hidden\">{{\'selectAgreement\' | translate}}</label><button ng-disabled=\"vm.disableAgreementService == true || vm.CheckBookingStatus(vm.bookingDetails)\" class=\"btn btn-primary endowmentButton\" type=button style=padding:5px ng-click=vm.addEndowment($event)>{{\'addEndowmentButton\' | translate}}</button></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=\"vm.dataToFill.authRequired == \'1\'\"><label class=control-label>{{\'authName\' | translate}} <span style=color:red>*</span></label><!--<input type=\"text\" ng-model=\"vm.dataToFill.authRUT\" placeholder=\"Authorizer RUT\"--><!--ng-rut ng-change=\"vm.rutChange()\" class=\"form-control\" name=\"authRUT\"--><!--required--><!--ng-class=\"{ \'has-error\': createBookingForm.authRUT.$touched && createBookingForm.authRUT.$invalid }\"--><!--readonly>--> <input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text ng-model=vm.dataToFill.authName placeholder=\"{{\'authName\' | translate}}\" class=form-control name=authName required ng-class=\"{ \'has-error\': createBookingForm.authName.$touched && createBookingForm.authName.$invalid }\" readonly><div ng-if=\"createBookingForm.authName.$touched|| submit\" ng-messages=createBookingForm.authName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'authNameR\' | translate}}</div></div><!--<div class=\"errormessage text-danger\" ng-show=\"vm.dataToFill.rutFlag\">Please--><!--enter a valid authorizer RUT.--><!--</div>--></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=\"vm.dataToFill.customerProfile == \'0\' || vm.dataToFill.customerProfile == \'1\'\"><label class=control-label>{{\'serviceLabel\' | translate}} <span style=color:red>*</span></label><select ng-disabled=\"vm.disableAgreementService == true || vm.CheckBookingStatus(vm.bookingDetails)\" class=form-control ng-model=vm.dataToFill.serviceTypeSelected name=typeOfService ng-change=vm.serviceTypeChanged() ng-disabled=\"vm.serviceTypeList.length == 0\" required ng-class=\"{ \'has-error\': createBookingForm.typeOfService.$touched && createBookingForm.typeOfService.$invalid }\" ng-options=\"data.id as data.service_name for data in vm.serviceTypeList\"><option value=\"\" selected disabled>{{\'selectTService\' | translate}}</option></select><div ng-if=\"createBookingForm.typeOfService.$touched|| submit\" ng-messages=createBookingForm.typeOfService.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'serviceReq\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'passengersCount\' | translate}} <span style=color:red>*</span></label><!-- <input ng-disabled=\"vm.disabledNumberOfpassengerByCount == true || vm.CheckBookingStatus(vm.bookingDetails)\" type=\"text\" --> <input type=text ng-model=vm.dataToFill.passengerCount placeholder=\"{{\'passengersCount\' | translate}}\" class=form-control name=passengerCount ng-change=vm.numberOfPassenger(vm.dataToFill.passengerCount) required ng-class=\"{ \'has-error\': createBookingForm.passengerCount.$touched && createBookingForm.passengerCount.$invalid }\" pattern=^[0-9][0-9]*$ ng-disabled=!vm.dataToFill.serviceTypeSelected><div ng-if=\"createBookingForm.passengerCount.$touched|| submit\" ng-messages=createBookingForm.passengerCount.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'noOfPassengerReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'noOfPassengerValid\' | translate}}</div></div><div class=\"errormessage text-danger\" ng-if=vm.dataToFill.numberOfPassengerError>{{\'maximum\' | translate}} {{vm.dataToFill.numberOfPassengerCount}} {{\'passengerAllowed\' | translate}}</div></div></div><div class=\"row mt5\"><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">{{\'custProfile\' | translate}}<span--><!--style=\"color:red\">*</span></label>--><!--<select class=\"form-control\" ng-model=\"vm.dataToFill.customerProfile\"--><!--name=\"customerProfile\" ng-change=\"vm.profileChanges()\"--><!--required--><!--ng-class=\"{ \'has-error\': createBookingForm.customerProfile.$touched && createBookingForm.customerProfile.$invalid }\"--><!--ng-disabled=\"vm.makePhoneEditAble\"--><!--ng-options=\"data.value as data.name for data in vm.customerProfileOption\">&lt;!&ndash;!vm.dataToFill.customerMobileG && !vm.newCustomerFlag&ndash;&gt;--><!--<option value=\"\" selected disabled>{{\'custProfilePlaceholder\' | translate}}</option>--><!--&lt;!&ndash;<option value=\"0\">Personal Profile</option>&ndash;&gt;--><!--&lt;!&ndash;<option value=\"1\">Corporate Profile</option>&ndash;&gt;--><!--</select>--><!--<div ng-if=\"createBookingForm.customerProfile.$touched|| submit\"--><!--ng-messages=\"createBookingForm.customerProfile.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">{{\'custProfileReq\' | translate}}--><!--</div>--><!--</div>--><!--</div>--><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=\"vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == \'1\'\"><label class=control-label>{{\'bookingType\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.bookingType ng-disabled=\"!vm.dataToFill.serviceTypeSelected || vm.CheckBookingStatus(vm.bookingDetails)\" name=bookingType required ng-class=\"{ \'has-error\': createBookingForm.bookingType.$touched && createBookingForm.bookingType.$invalid }\" ng-change=vm.bookingType() ng-options=\"data.value as data.name for data in vm.bookingTypeOptions\"><option value=\"\" selected disabled>{{\'bookingTypePlaceholder\' | translate}}</option></select><div ng-if=\"createBookingForm.bookingType.$touched|| submit\" ng-messages=createBookingForm.bookingType.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'bookingTypeReq\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=\"vm.dataToFill.customerProfile == 0 || vm.dataToFill.customerProfile == \'0\' || vm.dataToFill.customerProfile == null || vm.dataToFill.customerProfile == undefined\"><label class=control-label>{{\'bookingType\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.bookingType ng-disabled=\"!vm.dataToFill.serviceTypeSelected || vm.CheckBookingStatus(vm.bookingDetails)\" name=bookingType required ng-class=\"{ \'has-error\': createBookingForm.bookingType.$touched && createBookingForm.bookingType.$invalid }\" ng-change=vm.bookingType() ng-options=\"data.value as data.name for data in vm.bookingTypeOptions\"><option value=\"\" selected disabled>{{\'bookingTypePlaceholder\' | translate}}</option></select><div ng-if=\"createBookingForm.bookingType.$touched|| submit\" ng-messages=createBookingForm.bookingType.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'bookingTypeReq\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><!-- <input  type=\"checkbox\"  > --><label class=control-label><!-- <span style=\"color:red\">*</span> --></label><div class=newCheckbox ng-if=vm.funcationif()><input type=checkbox style=zoom:2.3 ng-checked=vm.checkBoxValueIs ng-disabled=\"vm.CheckBookingStatus(vm.bookingDetails) || vm.modifyFalg\" ng-model=vm.checkBoxValueIs ng-click=vm.checkBoxValue(vm.checkBoxValueIs)> <span style=\"font-size: 16px;padding-top: 3px;padding-left: 10px\">Reserva sin Respaldo</span></div></div></div><div class=\"row mt5\"><div class=\"col-lg-5 col-sm-5 col-md-5 col-xs-12\" ng-if=\"vm.dataToFill.scheduledBooking == 1 && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2 ) && !(vm.routingBase && vm.routingBase.routing_base_id > 0)\"><label ng-if=\"vm.dataToFill.scheduledBooking == 1 && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2) && vm.type_of_trip_Validate_Booking == \'Z\' \">{{\'scheduleDateAirPort\' | translate}} <span style=color:red>*</span></label><label ng-if=\"vm.dataToFill.scheduledBooking == 1 && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2) && vm.type_of_trip_Validate_Booking == \'P\'\">{{(vm.routingBase && vm.routingBase.routing_base_id > 0)?\'Fecha De Llegada\':(\'scheduleDate\' | translate)}} <span style=color:red>*</span></label><label ng-if=\"vm.dataToFill.scheduledBooking == 1 && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2) && (vm.type_of_trip_Validate_Booking == \'R\' ||  !vm.type_of_trip_Validate_Booking)\">{{(vm.routingBase && vm.routingBase.routing_base_id > 0)?\'Fecha De Llegada\':\'Fecha Recogida\'}} <span style=color:red>*</span></label><!-- <label ng-if=\"vm.dataToFill.scheduledBooking == 1 && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2) && vm.type_of_trip_Validate_Booking == \'R\'\">Fecha Recogida\n                                            <span style=\"color:red\">*</span>\n                                        </label> --><p class=input-group><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text id=datePickerPickup class=form-control uib-datepicker-popup={{vm.format}} name=scheduledDate ng-model=vm.dataToFill.scheduledDate placeholder=\"{{\'scheduleDate\' | translate}}\" is-open=vm.datePicker_1.scheduledDate datepicker-options=vm.dateOptions required ng-class=\"{ \'has-error\': createBookingForm.scheduledDate.$touched && createBookingForm.scheduledDate.$invalid }\" ng-change=\"vm.scheduleDateChanged(); vm.compareDates()\" close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly> <span class=input-group-btn><button ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'1\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"createBookingForm.scheduledDate.$touched|| submit\" ng-messages=createBookingForm.scheduledDate.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'scheduleDateReq\' | translate}}</div></div></div><div class=\"col-lg-7 col-sm-7 col-md-7 col-xs-12\" ng-if=\"vm.dataToFill.scheduledBooking == 1 && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2) && !(vm.routingBase && vm.routingBase.routing_base_id > 0)\"><div style=\"display: inline-flex;width:100%\"><div><label ng-if=\"vm.dataToFill.scheduledBooking == 1 && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2) && vm.type_of_trip_Validate_Booking == \'P\'\">{{(vm.routingBase && vm.routingBase.routing_base_id > 0)?\'Hora De Llegada\':(\'scheduleTime\' | translate)}} <span style=color:red>*</span></label><label ng-if=\"vm.dataToFill.scheduledBooking == 1 && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2) && vm.type_of_trip_Validate_Booking == \'Z\'\">Hora Salida Desde Aeropuerto <span style=color:red>*</span></label><label ng-if=\"vm.dataToFill.scheduledBooking == 1 && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2) && (vm.type_of_trip_Validate_Booking == \'R\' || !vm.type_of_trip_Validate_Booking)\">{{(vm.routingBase && vm.routingBase.routing_base_id > 0)?\'Hora De Llegada\':(\'scheduleTime\' | translate)}} <span style=color:red>*</span></label><div ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) uib-timepicker ng-model=vm.dataToFill.scheduledTime show-spinners=false mousewheel=false arrowkeys=false ng-change=vm.scheduleTimeChanged() ng-model-options=\"{ debounce: 0 }\" hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian></div><div ng-if=\"createBookingForm.scheduledDate.$touched|| submit\" ng-messages=createBookingForm.scheduledDate.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'scheduleTimeReq\' | translate}}</div></div></div><div style=padding-left:15px ng-if=\"(vm.dataToFill.dropDate != \'\' && vm.dataToFill.selectedServiceDetails.category == 0 && (vm.type_of_trip_Validate_Booking == \'P\'|| vm.type_of_trip_Validate_Booking == \'R\')) || (vm.routingBase && vm.routingBase.routing_base_id > 0) \"><div class=etaDiv style=font-size:14px><p>Hora de Retiro Estimada:<br><span style=\"font-weight: bold\" ng-if=\"vm.type_of_trip_Validate_Booking == \'P\'\">({{vm.ptoptravelTime | date:\'HH:mm\'}} <span ng-if=\"vm.time_trip_shared_service_point_to_point > 0 &&  vm.is_group_external == 0\">- {{vm.rangeOfPointToPoint | date:\'HH:mm\'}} </span>hrs)</span> <span style=\"font-weight: bold\" ng-if=\"vm.type_of_trip_Validate_Booking == \'R\'\">({{vm.pickRangeForRType | date:\'HH:mm\'}} <span ng-if=\"vm.tolerance_time_withdrawal_pickup > 0\">- {{vm.pickRangeForEstimated | date:\'HH:mm\'}} </span>hrs)</span></p></div><div class=etaDiv style=font-size:14px ng-if=\"vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat && vm.type_of_trip_Validate_Booking == \'P\'\"><p>ETA - {{vm.dataToFill.etaScheduleValue + vm.pickup_travel_time_pap || \'0\'}}mins</p></div><div class=etaDiv style=font-size:14px ng-if=\"vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat && vm.type_of_trip_Validate_Booking == \'R\'\"><p>ETA - {{vm.dataToFill.etaScheduleValue + vm.travel_time_service_pick_up || \'0\'}}mins</p></div></div><!--<div style=\"padding-left:15px;\" ng-show=\"(vm.dataToFill.scheduledDate != \'\' && vm.dataToFill.scheduledTime != \'\') &&  (vm.dataToFill.selectedServiceDetails.category == 0) && --><!--( vm.type_of_trip_Validate_Booking == \'R\') && ( vm.pickRangeForEstimated)\">--><!--<div class=\"etaDiv\" style=\"font-size:14px;\">--><!--<p>Hora Recogida Estimada:--><!--<br> {{ vm.pickRangeForRType | date:\'HH:mm\'}} --><!--<span ng-if=\"vm.tolerance_time_withdrawal_pickup > 0 && vm.is_group_external == 0\" > - {{vm.pickRangeForEstimated | date:\'HH:mm\'}}  </span> hrs</p>--><!--</div>--><!--<div class=\"etaDiv\" style=\"font-size:14px;\">--><!--[> <p ng-if=\"vm.dataToFill.selectedServiceDetails.category != 1\">ETA - {{vm.dataToFill.etaSchedule || \'0 min\'}}</p> <]--><!--<p>ETA - {{vm.dataToFill.etaScheduleValue + vm.travel_time_service_pick_up--><!--|| \'0\'}}mins</p>--><!--</div>--><!--</div>--></div></div><div class=\"col-lg-4 col-sm-4 col-md-6 col-xs-12\" ng-if=\"vm.dataToFill.selectedServiceDetails.category ==  1 || (vm.routingBase && vm.routingBase.routing_base_id > 0)\"><label ng-if=\"vm.dataToFill.airportCheck == \'Z\'\">{{\'scheduleDateAirPort\' | translate}} <span style=color:red>*</span></label><label ng-if=\"vm.dataToFill.airportCheck != \'Z\'\">{{vm.routingBase && vm.routingBase.routing_base_id > 0?\'Fecha De Llegada\':\'Fecha Presentación\'}} <span style=color:red>*</span></label><p class=input-group><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text class=form-control uib-datepicker-popup={{vm.format}} name=dropDate ng-model=vm.dataToFill.dropDate placeholder=\"Drop Date\" is-open=vm.datePicker_1.dropDate datepicker-options=vm.dateOptions required ng-class=\"{ \'has-error\': createBookingForm.dropDate.$touched && createBookingForm.dropDate.$invalid }\" ng-change=\"vm.dropDateChanged(); vm.compareDates()\" close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly> <span class=input-group-btn><button ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'3\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"createBookingForm.dropDate.$touched|| submit\" ng-messages=createBookingForm.dropDate.$error><div class=\"errormessage text-danger\" ng-message=required>Please select drop date.</div></div></div><div class=\"col-lg-8 col-sm-8 col-md-6 col-xs-12\" ng-if=\"vm.dataToFill.selectedServiceDetails.category ==  1 || (vm.routingBase && vm.routingBase.routing_base_id > 0)\"><div style=\"display: inline-flex;width:100%\"><div><label ng-if=\"vm.dataToFill.airportCheck == \'Z\'\">{{\'scheduleTimeAirport\' | translate}} <span style=color:red>*</span></label><label ng-if=\"vm.dataToFill.airportCheck != \'Z\'\">{{vm.routingBase && vm.routingBase.routing_base_id > 0?\'Hora De Llegada\':\'Hora Presentación\'}} <span style=color:red>*</span></label><div ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) uib-timepicker ng-model=vm.dataToFill.dropTime show-spinners=false ng-model-options=\"{ debounce: 0 }\" mousewheel=false arrowkeys=false ng-change=vm.dropTimeChanged() hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian></div><div ng-if=\"createBookingForm.dropTime.$touched|| submit\" ng-messages=createBookingForm.dropTime.$error><div class=\"errormessage text-danger\" ng-message=required>Please enter drop time.</div></div></div><div style=padding-left:15px ng-if=\"(vm.dataToFill.dropDate != \'\' &&  vm.type_of_trip_Validate_Booking != \'P\') || (vm.type_of_trip_Validate_Booking == \'P\' && vm.routingBase && vm.routingBase.routing_base_id > 0)\"><div class=etaDiv style=font-size:14px ng-if=\"vm.dataToFill.selectedServiceDetails.category == 1 && vm.pickRange1 && vm.pickRange2 && vm.dataToFill.airportCheck != \'Z\'  &&  !vm.method_range_pickup\"><p>Hora Retiro Estimada: <span ng-if=\"vm.showToleranceFlag == 0\">{{vm.pickRange3}}</span> <span ng-if=\"vm.showToleranceFlag != 0\"><br>{{vm.newPickRange3}} - {{vm.pickRange3ToShowAdd}}</span> hrs</p></div><div class=etaDiv style=font-size:14px ng-if=\"vm.dataToFill.selectedServiceDetails.category == 1 && vm.dataToFill.airportCheck == \'Z\'  &&  !vm.method_range_pickup\"><p>Hora Recogida Estimada: {{vm.dataToFill.dropTime | date:\'HH:mm\'}} hrs</p></div><div class=etaDiv style=font-size:14px ng-show=\"((vm.dataToFill.bookingType == \'1\' || vm.dataToFill.bookingType == 1 || vm.dataToFill.airportCheck == \'Z\') && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) &&  !vm.method_range_pickup\"><p ng-if=\"vm.dataToFill.selectedServiceDetails.category != 1\">ETA - {{vm.dataToFill.etaSchedule || \'0 min\'}}</p><p ng-if=\"vm.dataToFill.selectedServiceDetails.category == 1\">ETA - {{vm.dataToFill.etaScheduleValue + vm.dataToFill.time_trip_shared_service || \'0\'}}mins</p></div><div class=etaDiv style=font-size:14px ng-if=\"(vm.dataToFill.selectedServiceDetails.category == 1 && vm.pickRange1 && vm.pickRange2 && vm.dataToFill.airportCheck != \'Z\'  &&  vm.method_range_pickup) || (vm.routingBase && vm.routingBase.routing_base_id > 0)\"><p>Hora Retiro Estimada: {{vm.pickRangeForRouting}} hrs</p></div><div class=etaDiv style=font-size:14px ng-show=\"((vm.dataToFill.bookingType == \'1\' || vm.dataToFill.bookingType == 1 || vm.dataToFill.airportCheck == \'Z\') && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) &&  vm.method_range_pickup\"><p>ETA - {{vm.dataToFill.etaSchedule || \'0 min\'}}</p></div></div></div></div></div><div class=\"row mt5\" style=\"margin-bottom: 0px !important\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Seleccionar viaje <span style=color:red>*</span></label><div class=\"panel with-nav-tabs panel-default\" style=\"margin-bottom: 0px !important;margin-top: 3px\"><div class=panel-heading><ul class=\"nav nav-tabs\"><li id=toAirport class=\"active TabsBar\" ng-click=\"vm.forTabsView(1);vm.flagForPanel = true\"><a>Hacia Aeropuerto<hr></a></li><li id=fromAirport class=TabsBar ng-click=\"vm.forTabsView(2);vm.flagForPanel = true\"><a href=tab2default data-toggle=tab>Desde Aeropuerto<hr></a></li><li id=pointToPoint class=TabsBar ng-click=\"vm.forTabsView(3);vm.flagForPanel = true\"><a href=tab3default data-toggle=tab>Punto a Punto<hr class=PtoP></a></li></ul></div><div class=panel-body ng-if=\"vm.flagForPanel == true\"><div class=tab-content><div class=\"tab-pane fade in active\"><div class=\"row mt5\" ng-if=\"vm.toAirportFlag || vm.ptopAirportFlag\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label style=\"margin-bottom: 20px\">{{\'pickUpAddressB\' | translate}} <span style=color:red>*</span></label><div class=displayFlex><div ng-style=vm.favAddFlagI><i class=\"fa fa-times-circle crossButton\" ng-click=vm.pickUpAddressBlank() aria-hidden=true></i> <input style=\"margin-top: -27px\" ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text ng-model=vm.dataToFill.pickUpAddress placeholder=\"{{\'pickUpAddressB\' | translate}}\" class=\"form-control focusInput\" name=pickUpAddress id=pickUpAddress required ng-change=vm.PickUpAddressLength(vm.dataToFill.pickUpAddress) ng-class=\"{ \'has-error\': createBookingForm.pickUpAddress.$touched && createBookingForm.pickUpAddress.$invalid }\" ng-keyup=vm.pickUpaddressBlack(vm.dataToFill.pickUpAddress) ng-click=vm.getPreviousAddressHit(1) ng-focus=vm.getPreviousAddressHit(1) autocomplete=nope><div ng-if=vm.dataToFill.previousPickFlag style=\"margin-top:1px;width:149%;border: 1px solid #F17F3A;max-height: 260px;border-radius: 4px\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><img src=../../../../assets/images/Artboard.png style=\"top: -2px;position: relative\"> <span class=tableHeader>Direcciones recientes</span><div style=\"max-height: 200px; overflow-y: scroll\"><table class=\"table table-hover\" style=\"margin-top:20px;font-weight: 450;margin-left: 25px\"><tbody><tr ng-if=\"vm.previousAddressList.length != 0\" ng-repeat=\"previousAddress in vm.previousAddressList\"><td style=\"text-align: left !important\" ng-click=vm.selectPreviousAddress(previousAddress,1)>{{previousAddress.address}}</td></tr><tr ng-if=\"vm.previousAddressList.length == 0\"><td style=\"text-align: left !important\">{{\'noPreviousAddress\' | translate}}</td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noInvestorFound\' | translate}}</th></tr></tfoot></table></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><i class=\"fa fa-heart-o\" style=\"font-size:19px;color: #F17F3A;font-weight: bold\"></i> <span class=tableHeader>Direcciones favoritas</span><div style=\"max-height: 200px; overflow-y: scroll\"><table class=\"table table-hover\" style=\"margin-top:20px;margin-left: 25px\"><tbody><tr ng-if=\"vm.favAddressList.length != 0\" ng-repeat=\"favAddress in vm.favAddressList\"><td data-testid=direcciones_favoritas style=\"text-align: left !important\" ng-click=vm.selectFavAddressNewPop(1,favAddress)><p><span style=\"font-weight: 600\">{{\'locationName\' | translate}}:</span>&nbsp;&nbsp;<span>{{favAddress.location_name != \"\" ? favAddress.location_name : \'--\'}}</span></p><p><span style=\"font-weight: 600\">Dirección:</span>&nbsp;&nbsp;<span>{{favAddress.address}}</span></p></td></tr><tr ng-if=\"vm.favAddressList.length == 0\"><td style=\"text-align: left !important\">No se encontró ninguna dirección favorita.</td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noInvestorFound\' | translate}}</th></tr></tfoot></table></div></div></div><!-- <div class=\"row\" ng-repeat=\"previousAddress in vm.previousAddressList\">\n                                                                                        <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"cursor: pointer;\" ng-click=\"vm.selectPreviousAddress(previousAddress,1)\">\n                                                                                            <p>{{previousAddress.address}}</p>\n                                                                                        </div>\n                                                                                        <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-if=\"$index != vm.previousAddressList.length - 1\">\n                                                                                            <hr/>\n                                                                                        </div>\n                                                                                    </div> --></div></div><!-- <div class=\"panel panel-default\" ng-if=\"vm.previousAddressList.length == 0\">\n                                                                                <div class=\"panel-body\">\n                                                                                    <div class=\"row\">\n                                                                                        <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">\n                                                                                            <p>{{\'noPreviousAddress\' | translate}}</p>\n                                                                                        </div>\n                                                                                    </div>\n                                                                                </div>\n\n                                                                            </div> --></div></div><div><i ng-click=vm.MarkfavouriteAddressPickUp(true) ng-if=\"(vm.dataToFill.pickUpLng && vm.dataToFill.pickUpLat) &&  (vm.isActivePick)\" class=\"fa fa-heart greenClass\" aria-hidden=true></i> <i ng-click=vm.MarkfavouriteAddressPickUp(false) ng-if=\"(vm.dataToFill.pickUpLng && vm.dataToFill.pickUpLat) && (!vm.isActivePick)\" class=\"fa fa-heart-o whiteClass\" aria-hidden=true></i></div></div><div ng-if=\"createBookingForm.pickUpAddress.$touched|| submit\" ng-messages=createBookingForm.pickUpAddress.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'pickUpReq\' | translate}}</div></div></div></div><div class=\"row mt5\" ng-if=\"vm.fromAirportFlag || vm.ptopAirportFlag\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label style=\"margin-bottom: 20px\" class=control-label>{{\'dropOffAddressB\' | translate}} <span style=color:red>*</span></label><div class=displayFlex><div ng-style=vm.favAddFlagI><i class=\"fa fa-times-circle crossButton\" ng-click=vm.dropOffAddressBlank() aria-hidden=true></i> <input style=\"margin-top: -27px\" ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text ng-model=vm.dataToFill.dropOffAddress placeholder=\"{{\'dropOffAddressB\' | translate}}\" class=\"form-control focusInput\" name=dropOffAddress id=dropOffAddress ng-change=vm.DropUpAddressLength(vm.dataToFill.dropOffAddress) required ng-class=\"{ \'has-error\': createBookingForm.dropOffAddress.$touched && createBookingForm.dropOffAddress.$invalid }\" ng-keyup=vm.dropOfdAddressBlack(vm.dataToFill.dropOffAddress) ng-click=vm.getPreviousAddressHit(2) ng-focus=vm.getPreviousAddressHit(2) autocomplete=nope><div ng-if=vm.dataToFill.previousDropFlag style=\"margin-top:1px;width:149%;border: 1px solid #F17F3A;max-height: 260px;border-radius: 4px\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><img src=../../../../assets/images/Artboard.png style=\"top: -2px;position: relative\"> <span class=tableHeader>Direcciones recientes</span><div style=\"max-height: 200px; overflow-y: scroll\"><table class=\"table table-hover\" style=\"margin-top:20px;font-weight: 450;;margin-left: 25px\"><tbody><tr ng-if=\"vm.previousAddressList.length != 0\" ng-repeat=\"previousAddress in vm.previousAddressList\"><td style=\"text-align: left !important\" ng-click=vm.selectPreviousAddress(previousAddress,2)>{{previousAddress.address}}</td></tr><tr ng-if=\"vm.previousAddressList.length == 0\"><td style=\"text-align: left !important\">{{\'noPreviousAddress\' | translate}}</td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noInvestorFound\' | translate}}</th></tr></tfoot></table></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><i class=\"fa fa-heart-o\" style=\"font-size:19px;color: #F17F3A;font-weight: bold\"></i> <span class=tableHeader>Direcciones favoritas</span><div style=\"max-height: 200px; overflow-y: scroll\"><table class=\"table table-hover\" style=\"margin-top:20px;margin-left: 25px\"><tbody><tr ng-if=\"vm.favAddressList.length != 0\" ng-repeat=\"favAddress in vm.favAddressList\"><td style=\"text-align: left !important\" ng-click=vm.selectFavAddressNewPop(2,favAddress)><p><span style=\"font-weight: 600\">{{\'locationName\' | translate}}:</span>&nbsp;&nbsp;<span>{{favAddress.location_name != \"\" ? favAddress.location_name : \'--\'}}</span></p><p><span style=\"font-weight: 600\">Dirección:</span>&nbsp;&nbsp;<span>{{favAddress.address}}</span></p></td></tr><tr ng-if=\"vm.favAddressList.length == 0\"><td style=\"text-align: left !important\">No se encontró ninguna dirección favorita.</td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noInvestorFound\' | translate}}</th></tr></tfoot></table></div></div></div><!-- <div class=\"row\" ng-repeat=\"previousAddress in vm.previousAddressList\">\n                                                                                                <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"cursor: pointer;\" ng-click=\"vm.selectPreviousAddress(previousAddress,1)\">\n                                                                                                    <p>{{previousAddress.address}}</p>\n                                                                                                </div>\n                                                                                                <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-if=\"$index != vm.previousAddressList.length - 1\">\n                                                                                                    <hr/>\n                                                                                                </div>\n                                                                                            </div> --></div></div><!-- <div class=\"panel panel-default\" ng-if=\"vm.previousAddressList.length\">\n                                                                                <div class=\"panel-body\" style=\"max-height:300px;overflow-y: auto\">\n                                                                                    <div class=\"row\" ng-repeat=\"previousAddress in vm.previousAddressList\">\n                                                                                        <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"cursor: pointer;\" ng-click=\"vm.selectPreviousAddress(previousAddress,2)\">\n                                                                                            <p>{{previousAddress.address}}</p>\n                                                                                        </div>\n                                                                                        <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-if=\"$index != vm.previousAddressList.length - 1\">\n                                                                                            <hr/>\n                                                                                        </div>\n                                                                                    </div>\n                                                                                </div>\n                                                                            </div>\n                                                                            <div class=\"panel panel-default\" ng-if=\"vm.previousAddressList.length == 0\">\n                                                                                <div class=\"panel-body\">\n                                                                                    <div class=\"row\">\n                                                                                        <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">\n                                                                                            <p>{{\'noPreviousAddress\' | translate}}</p>\n                                                                                        </div>\n                                                                                    </div>\n                                                                                </div>\n\n                                                                            </div> --></div></div><i ng-click=vm.MarkfavouriteAddressDrop(true) ng-if=\"(vm.dataToFill.dropOffLng && vm.dataToFill.dropOffLat) && (vm.isActiveDrop)\" class=\"fa fa-heart greenClass\" aria-hidden=true></i> <i ng-click=vm.MarkfavouriteAddressDrop(false) ng-if=\" (vm.dataToFill.dropOffLng && vm.dataToFill.dropOffLat) && (!vm.isActiveDrop)\" class=\"fa fa-heart-o whiteClass\" aria-hidden=true></i><div></div></div><div ng-if=\"createBookingForm.dropOffAddress.$touched|| submit\" ng-messages=createBookingForm.dropOffAddress.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'dropOffReq\' | translate}}</div></div></div></div><div class=\"row mt5\" ng-if=!vm.flagForMarkFavAddress><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"padding-top: 10px\"><div class=addressLength ng-if=\"vm.toAirportFlag && vm.dataToFill.pickUpAddress && !vm.ErrorFlagForNewApi\">Destino :<div style=\"position: relative;margin-left: 70px;margin-top:-20px\">{{vm.dataToFill.dropOffAddress}}</div><!-- <div ng-if=\"vm.modifyFalg\" style=\"position: relative;margin-left: 70px;margin-top:-20px\">{{vm.airportAddress}}</div> --></div><span class=addressLength ng-if=\"vm.fromAirportFlag && vm.dataToFill.dropOffAddress && !vm.ErrorFlagForNewApi\">Retiro :<div style=\"position: relative;margin-left: 60px;margin-top:-20px\">{{vm.dataToFill.pickUpAddress}}</div><!-- <div ng-if=\"vm.modifyFalg\" style=\"position: relative;margin-left: 70px;margin-top:-20px\">{{vm.airportAddress}}</div> --> </span><span class=addressLength ng-if=\"vm.ErrorFlagForNewApi && vm.ErrorFlagForNewApiMessage != undefined\"><i class=\"fa fa-exclamation-circle iconColor\" style=\"font-size: 20px;color: red\" aria-hidden=true></i><div style=\"position: relative;margin-left: 25px;margin-top:-24px;color: red\">{{vm.ErrorFlagForNewApiMessage}}</div></span></div></div><div class=textMarkAddressFav ng-if=vm.flagForMarkFavAddress>La Dirección se agregó como favorita</div></div></div></div></div></div></div><div class=\"row mt5 favButtonShow\"><div ng-style=vm.favAddFlagB class=text-center><button type=button ng-disabled=\"vm.CheckBookingStatus(vm.bookingDetails) || !vm.favAddFlag\" id=DisabledButton class=\"btn btn-primary newTableClass\" ng-click=vm.pickFavAddress($event)>{{\'favAddressButton\' | translate}}</button></div></div><!-- <div class=\"row mt5\">\n                                    <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">\n                                        <label class=\"control-label\">{{\'pickUpAddressB\' | translate}}\n                                            <span style=\"color:red\">*</span>\n                                        </label>\n                                        <div class=\"displayFlex\">\n                                            <div ng-style=\"vm.favAddFlagI\">\n                                                <input ng-disabled=\"vm.CheckBookingStatus(vm.bookingDetails)\" type=\"text\" ng-model=\"vm.dataToFill.pickUpAddress\" placeholder=\"{{\'pickUpAddressB\' | translate}}\"\n                                                    class=\"form-control\" name=\"pickUpAddress\" id=\"pickUpAddress\" required ng-change=\"vm.PickUpAddressLength(vm.dataToFill.pickUpAddress)\"\n                                                    ng-class=\"{ \'has-error\': createBookingForm.pickUpAddress.$touched && createBookingForm.pickUpAddress.$invalid }\"\n                                                    ng-click=\"vm.getPreviousAddressHit(1)\" ng-focus=\"vm.getPreviousAddressHit(1)\">\n\n                                                <div ng-if=\"vm.dataToFill.previousPickFlag\">\n\n                                                    <div class=\"panel panel-default\" ng-if=\"vm.previousAddressList.length\">\n                                                        <div class=\"panel-body\" style=\"max-height:300px;overflow-y: auto\">\n                                                            <div class=\"row\" ng-repeat=\"previousAddress in vm.previousAddressList\">\n                                                                <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"cursor: pointer;\" ng-click=\"vm.selectPreviousAddress(previousAddress,1)\">\n                                                                    <p>{{previousAddress.address}}</p>\n                                                                </div>\n                                                                <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-if=\"$index != vm.previousAddressList.length - 1\">\n                                                                    <hr/>\n                                                                </div>\n                                                            </div>\n                                                        </div>\n                                                    </div>\n                                                    <div class=\"panel panel-default\" ng-if=\"vm.previousAddressList.length == 0\">\n                                                        <div class=\"panel-body\">\n                                                            <div class=\"row\">\n                                                                <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">\n                                                                    <p>{{\'noPreviousAddress\' | translate}}</p>\n                                                                </div>\n                                                            </div>\n                                                        </div>\n\n                                                    </div>\n                                                </div>\n                                            </div>\n                                            <div>\n                                                <i ng-click=\"vm.MarkfavouriteAddressPickUp(true)\" ng-if=\"(vm.dataToFill.pickUpLng && vm.dataToFill.pickUpLat) &&  (vm.isActivePick)\"\n                                                    class=\"fa fa-heart redClass\" aria-hidden=\"true\"></i>\n                                                <i ng-click=\"vm.MarkfavouriteAddressPickUp(false)\" ng-if=\"(vm.dataToFill.pickUpLng && vm.dataToFill.pickUpLat) && (!vm.isActivePick)\"\n                                                    class=\"fa fa-heart-o whiteClass\" aria-hidden=\"true\"></i>\n                                            </div>\n                                            <div ng-style=\"vm.favAddFlagB\" class=\"text-center\" ng-if=\"vm.favAddFlag\">\n                                                <a ng-disabled=\"vm.CheckBookingStatus(vm.bookingDetails)\" class=\"btn btn-primary tableButton\" ng-click=\"vm.pickFavAddress($event)\">{{\'favAddressButton\' | translate}}</a>\n                                            </div>\n                                        </div>\n                                        <div ng-if=\"createBookingForm.pickUpAddress.$touched|| submit\" ng-messages=\"createBookingForm.pickUpAddress.$error\">\n                                            <div class=\"errormessage text-danger\" ng-message=\"required\">{{\'pickUpReq\' | translate}}\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"row mt5\">\n                                    <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">\n                                        <label class=\"control-label\">{{\'dropOffAddressB\' | translate}}\n                                            <span style=\"color:red\">*</span>\n                                        </label>\n                                        <div class=\"displayFlex\">\n\n                                            <div ng-style=\"vm.favAddFlagI\">\n                                                <input ng-disabled=\"vm.CheckBookingStatus(vm.bookingDetails)\" type=\"text\" ng-model=\"vm.dataToFill.dropOffAddress\" placeholder=\"{{\'dropOffAddressB\' | translate}}\"\n                                                    class=\"form-control\" name=\"dropOffAddress\" id=\"dropOffAddress\" ng-change=\"vm.DropUpAddressLength(vm.dataToFill.dropOffAddress)\"\n                                                    required ng-class=\"{ \'has-error\': createBookingForm.dropOffAddress.$touched && createBookingForm.dropOffAddress.$invalid }\"\n                                                    ng-click=\"vm.getPreviousAddressHit(2)\" ng-focus=\"vm.getPreviousAddressHit(2)\">\n                                                <div ng-if=\"vm.dataToFill.previousDropFlag\">\n                                                    <div class=\"panel panel-default\" ng-if=\"vm.previousAddressList.length\">\n                                                        <div class=\"panel-body\" style=\"max-height:300px;overflow-y: auto\">\n                                                            <div class=\"row\" ng-repeat=\"previousAddress in vm.previousAddressList\">\n                                                                <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"cursor: pointer;\" ng-click=\"vm.selectPreviousAddress(previousAddress,2)\">\n                                                                    <p>{{previousAddress.address}}</p>\n                                                                </div>\n                                                                <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-if=\"$index != vm.previousAddressList.length - 1\">\n                                                                    <hr/>\n                                                                </div>\n                                                            </div>\n                                                        </div>\n                                                    </div>\n                                                    <div class=\"panel panel-default\" ng-if=\"vm.previousAddressList.length == 0\">\n                                                        <div class=\"panel-body\">\n                                                            <div class=\"row\">\n                                                                <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">\n                                                                    <p>{{\'noPreviousAddress\' | translate}}</p>\n                                                                </div>\n                                                            </div>\n                                                        </div>\n\n                                                    </div>\n                                                </div>\n\n                                            </div>\n                                            <i ng-click=\"vm.MarkfavouriteAddressDrop(true)\" ng-if=\"(vm.dataToFill.dropOffLng && vm.dataToFill.dropOffLat) && (vm.isActiveDrop)\"\n                                                class=\"fa fa-heart redClass\" aria-hidden=\"true\"></i>\n                                            <i ng-click=\"vm.MarkfavouriteAddressDrop(false)\" ng-if=\" (vm.dataToFill.dropOffLng && vm.dataToFill.dropOffLat) && (!vm.isActiveDrop)\"\n                                                class=\"fa fa-heart-o whiteClass\" aria-hidden=\"true\"></i>\n                                            <div>\n                                            </div>\n                                            <div ng-style=\"vm.favAddFlagB\" class=\"text-center\" ng-if=\"vm.favAddFlag\">\n                                                <a ng-disabled=\"vm.CheckBookingStatus(vm.bookingDetails)\" class=\"btn btn-primary tableButton\" ng-click=\"vm.dropFavAddress($event)\">{{\'favAddressButton\' | translate}}</a>\n                                            </div>\n                                        </div>\n                                        <div ng-if=\"createBookingForm.dropOffAddress.$touched|| submit\" ng-messages=\"createBookingForm.dropOffAddress.$error\">\n                                            <div class=\"errormessage text-danger\" ng-message=\"required\">{{\'dropOffReq\' | translate}}\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div> --><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'pickUpReferLabel\' | translate}}</label><textarea ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) class=form-control ng-model=vm.dataToFill.reference_point placeholder=\"{{\'messagePlaceholder\' | translate}}\" name=reference maxlength=140 ng-class=\"{ \'has-error\': createBookingForm.reference.$touched && createBookingForm.reference.$invalid }\" autocomplete=nope></textarea></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'bookingFor\' | translate}} <span style=color:red>*</span></label><select ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) class=form-control ng-model=vm.dataToFill.bookingFor name=bookingFor required ng-class=\"{ \'has-error\': createBookingForm.bookingFor.$touched && createBookingForm.bookingFor.$invalid }\" ng-change=vm.bookingFor() ng-options=\"data.value as data.name for data in vm.bookingForOptions\"><option value=\"\" selected disabled>{{\'bookingForPlaceholder\' | translate}}</option><!--<option value=\"0\">Self</option>--><!--<option value=\"1\">Someone else</option>--></select><div ng-if=\"createBookingForm.bookingFor.$touched|| submit\" ng-messages=createBookingForm.bookingFor.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'bookingForReq\' | translate}}</div></div></div></div><div class=\"row mt5\" ng-if=\"(vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == \'1\')\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5\" ng-if=vm.dataToFill.otherBooking><label class=control-label style=\"display: flex\">VIP?<p style=\"font-size: 19px;line-height: 1\"><i ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) style=\"padding-left: 12px\" ng-click=vm.changeVip(); ng-class=\"{\'fa fa-toggle-on\': vm.is_vip , \'fa fa-toggle-off\': !vm.is_vip}\"></i></p></label></div></div><div class=\"row mt5\" ng-if=\"(vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == \'1\') && vm.dataToFill.otherBooking && !vm.newPersonFlag\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Buscar Persona <span style=color:red>*</span></label><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text ng-model=vm.dataToFill.personSelected placeholder=\"{{\'searchCustLabel\' | translate}}\" uib-typeahead=\"customers as customers.name for customers in vm.searchPerson($viewValue)\" typeahead-loading=loadingCustomers typeahead-no-results=noResultsPerson class=\"form-control createBookingSelect\" name=searchPerson typeahead-on-select=vm.onSelectingPerson() typeahead-wait-ms=200 typeahead-template-url=personTemplate.html required ng-class=\"{ \'has-error\': createBookingForm.searchPerson.$touched && createBookingForm.searchPerson.$invalid }\"> <i ng-if=loadingCustomers class=\"glyphicon glyphicon-refresh\"></i><div ng-if=noResultsPerson class=mt5><span><i class=\"glyphicon glyphicon-remove\"></i> {{\'searchCustError\' | translate}}</span> <span class=pull-right><a class=\"btn btn-primary tableButton\" ng-click=vm.addNewPerson()>Ingresar manualmente</a></span></div><div ng-if=\"createBookingForm.searchPerson.$touched|| submit\" ng-messages=createBookingForm.searchPerson.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'searchCustReq\' | translate}}</div></div></div></div><div class=\"row mt5\" ng-if=\"!((vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == \'1\') && vm.dataToFill.otherBooking && !vm.newPersonFlag)\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-if=vm.dataToFill.otherBooking><label class=control-label>{{\'personName\' | translate}} <span style=color:red>*</span></label><input type=text ng-model=vm.dataToFill.personName placeholder=\"{{\'personName\' | translate}}\" class=form-control name=personName required ng-class=\"{ \'has-error\': createBookingForm.personName.$touched && createBookingForm.personName.$invalid }\" ng-maxlength=60 ng-minlength=3><div ng-if=\"createBookingForm.personName.$touched|| submit\" ng-messages=createBookingForm.personName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'personNameReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'personNameValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'firstNameMaximum\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=vm.dataToFill.otherBooking><label class=control-label>{{\'personMail\' | translate}}</label><input type=text ng-model=vm.dataToFill.personEmail placeholder=\"{{\'personMail\' | translate}}\" class=form-control name=personEmail ng-class=\"{ \'has-error\': createBookingForm.personEmail.$touched && createBookingForm.personEmail.$invalid }\" pattern=^([_a-zA-Z0-9-+]+)(\\.[_a-zA-Z0-9-+]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*\\.)+([a-zA-Z]{2,13})$ ng-disabled=\"((vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == \'1\') && !vm.newPersonFlag) || vm.CheckBookingStatus(vm.bookingDetails)\"><div ng-if=\"createBookingForm.personEmail.$touched|| submit\" ng-messages=createBookingForm.personEmail.$error><!--<div class=\"errormessage text-danger\" ng-message=\"required\">{{\'personMailReq\' | translate}}--><!--</div>--><div class=\"errormessage text-danger\" ng-message=pattern>{{\'personMailValid\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=vm.dataToFill.otherBooking><label class=control-label>{{\'personMobile\' | translate}} <span style=color:red>*</span></label><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text ng-model=vm.dataToFill.personMobile placeholder=\"{{\'personMobile\' | translate}}\" class=form-control name=personMobile required ng-class=\"{ \'has-error\': createBookingForm.personMobile.$touched && createBookingForm.personMobile.$invalid }\" pattern=^([1-9]{1}[0-9]{8})*$ ng-minlength=9 ng-maxlength=9 ng-disabled=\"!vm.newPersonFlag && !vm.dataToFill.personName\"><div ng-if=\"createBookingForm.personMobile.$touched|| submit\" ng-messages=createBookingForm.personMobile.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'personMobileReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'personMobileValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'personMobileValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'personMobileValid\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt25\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean>Ida y Vuelta</td><!--{{\'roundTrip\' | translate}}--><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'ROUND_TRIP\', undefined, \'return\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.roundTrip , \'fa fa-toggle-off\': !vm.dataToFill.roundTrip, \'disableRoundTripToggle\': vm.dataToFill.bookingId }\"></i><!--,\'pointerEvent\': vm.dataToFill.bookingId && !vm.dataToFill.roundTrip--></td></tr><tr ng-if=vm.dataToFill.roundTrip><td colspan=2><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-if=\"vm.dataToFill.customerProfile == \'1\' && vm.dataToFill.roundTrip\"><!--vm.dataToFill.customerProfile == \'1\' && --><div class=\"boleeanTypeColor col-lg-3 col-sm-3 col-md-3 col-xs-12\"><i ng-click=\"vm.setBooleans(\'WAIT_TIME_INCLUDED\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.is_wait_time_included ,\n                                                                   \'fa fa-toggle-off\': !vm.dataToFill.is_wait_time_included }\" ng-disabled=\"vm.disabledRoundTrip == true\"></i><!--,\'pointerEvent\': vm.dataToFill.bookingId && vm.dataToFill.is_wait_time_included--></div><div class=\"headingBollean col-lg-9 col-sm-9 col-md-9 col-xs-12\" style=padding-top:10px><!--{{\'waitTimeInclude\' | translate}}--> <span ng-if=!vm.dataToFill.is_wait_time_included>Sin espera</span> <span ng-if=vm.dataToFill.is_wait_time_included>Con espera</span></div></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12\" ng-if=\"((!vm.dataToFill.is_wait_time_included ||  !vm.disabledRoundTrip) || (vm.type_of_trip != \'R\' && vm.dataToFill.selectedServiceDetails.category == 1)) &&  ((!vm.dataToFill.is_wait_time_included  && vm.type_of_trip != \'R\') || vm.dataToFill.selectedServiceDetails.category != 0 && vm.type_of_trip != \'R\')\"><!-- <label>Fecha Salida Desde Aeropuerto\n                                                                    <span style=\"color:red\">*</span>\n                                                                </label> --><label ng-if=\"vm.type_of_trip == \'P\'\">Fecha de Regreso <span style=color:red>*</span></label><label ng-if=\"vm.type_of_trip == \'Z\'\">Fecha Salida Desde Aeropuerto <span style=color:red>*</span></label><!--{{\'retuenDateLabel\' | translate}}--><p class=input-group><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) id=datePickerReturnDate type=text class=form-control uib-datepicker-popup={{vm.format}} name=returnDate id=returnDate ng-model=vm.dataToFill.returnDate placeholder=\"{{\'retuenDateLabel\' | translate}}\" is-open=vm.datePicker_1.returnDate datepicker-options=vm.returnDateOptions ng-class=\"{ \'has-error\': createBookingForm.returnDate.$touched && createBookingForm.returnDate.$invalid }\" close-text=Close alt-input-formats=vm.altInputFormats ng-change=vm.returnDateChange(); show-button-bar=false readonly> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'2\')\" ng-disabled=\"vm.disabledRoundTrip == true || vm.CheckBookingStatus(vm.bookingDetails)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"createBookingForm.returnDate.$touched|| submit\" ng-messages=createBookingForm.returnDate.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'retuenDateReq\' | translate}}</div></div></div><div class=\"col-lg-8 col-sm-8 col-md-8 col-xs-12\" ng-if=\"((!vm.dataToFill.is_wait_time_included ||  !vm.disabledRoundTrip) || (vm.type_of_trip != \'R\' && vm.dataToFill.selectedServiceDetails.category == 1)) &&  ((!vm.dataToFill.is_wait_time_included  && vm.type_of_trip != \'R\') || vm.dataToFill.selectedServiceDetails.category != 0 && vm.type_of_trip != \'R\')\"><div style=\"display: inline-flex;width:100%\"><div><label ng-if=\"vm.type_of_trip == \'P\'\">Hora de Presentacion <span style=color:red>*</span></label><label ng-if=\"vm.type_of_trip == \'Z\'\">Hora Salida Desde Aeropuerto <span style=color:red>*</span></label><!--{{\'retuenTimeLabel\' | translate}}--><div uib-timepicker ng-model=vm.dataToFill.returnTime name=returnTime class=completed show-spinners=false ng-change=vm.retunrTimeChanged() ng-model-options=\"{ debounce: 400 }\" hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian ng-disabled=\"vm.disabledRoundTrip == true || vm.CheckBookingStatus(vm.bookingDetails)\"></div><div ng-if=\"createBookingForm.returnTime.$touched|| submit\" ng-messages=createBookingForm.returnTime.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'retuenTimeReq\' | translate}}</div></div></div><div style=padding-left:15px ng-if=\"vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip == \'P\' \"><div class=etaDiv style=font-size:14px><p>Hora de Regreso Estimada:<br><span style=\"font-weight: bold\">({{vm.ptoptravelTimeReturn | date:\'HH:mm\'}} <span ng-if=\"vm.time_trip_shared_service_point_to_point > 0 &&  vm.is_group_external == 0\">- {{vm.rangeOfPointToPointReturn | date:\'HH:mm\'}}</span> hrs)</span></p></div><div class=etaDiv style=font-size:14px ng-if=\"vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat\"><p>ETA - {{vm.dataToFill.etaScheduleValueReturn + vm.pickup_travel_time_pap || \'0\'}}mins</p></div></div></div></div><div class=\"col-lg-4 col-sm-4 col-md-6 col-xs-12\" ng-if=\"(vm.dataToFill.selectedServiceDetails.category == 1 &&  vm.type_of_trip == \'R\') || (vm.dataToFill.selectedServiceDetails.category == 0 &&  vm.type_of_trip == \'R\') \"><label ng-if=\"vm.dataToFill.selectedServiceDetails.category == 1\">Fecha Presentación <span style=color:red>*</span></label><label ng-if=\"vm.dataToFill.selectedServiceDetails.category == 0\">Fecha Recogida <span style=color:red>*</span></label><p class=input-group><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text class=form-control uib-datepicker-popup={{vm.format}} name=dropDateReturn ng-model=vm.dataToFill.dropDateReturn placeholder=\"Drop Date\" is-open=vm.datePicker_1.dropDateReturn datepicker-options=vm.returnDateOptions required ng-class=\"{ \'has-error\': createBookingForm.dropDateReturn.$touched && createBookingForm.dropDateReturn.$invalid }\" ng-change=\"vm.dropDateReturnChanged(); vm.compareDates()\" close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'4\')\" ng-disabled=\"vm.disabledRoundTrip == true || vm.CheckBookingStatus(vm.bookingDetails)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"createBookingForm.dropDate.$touched|| submit\" ng-messages=createBookingForm.dropDate.$error><div class=\"errormessage text-danger\" ng-message=required>Please select drop date.</div></div></div><div class=\"col-lg-8 col-sm-8 col-md-6 col-xs-12\" ng-if=\"(vm.dataToFill.selectedServiceDetails.category == 1  &&  vm.type_of_trip == \'R\') || (vm.dataToFill.selectedServiceDetails.category == 0 &&  vm.type_of_trip == \'R\') \"><div style=\"display: inline-flex;width:100%\"><div><label ng-if=\"vm.dataToFill.selectedServiceDetails.category == 1\">Hora Presentación <span style=color:red>*</span></label><label ng-if=\"vm.dataToFill.selectedServiceDetails.category == 0\">Hora Recogida <span style=color:red>*</span></label><div uib-timepicker ng-model=vm.dataToFill.dropTimeReturn show-spinners=false mousewheel=false arrowkeys=false ng-change=vm.dropTimeReturnChanged() ng-disabled=\"vm.disabledRoundTrip == true || vm.CheckBookingStatus(vm.bookingDetails)\" hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian></div><div ng-if=\"createBookingForm.dropTime.$touched|| submit\" ng-messages=createBookingForm.dropTime.$error><div class=\"errormessage text-danger\" ng-message=required>Please enter drop time.</div></div></div><div style=padding-left:15px><div class=etaDiv style=font-size:14px ng-if=\"!vm.method_range_pickup_return && (vm.dataToFill.selectedServiceDetails.category == 1)\"><p>Hora Retiro Estimada: {{vm.pickRange5}} - {{vm.pickRange3ToShowAddReturn}} hrs</p></div><div class=etaDiv style=font-size:14px ng-if=\"vm.method_range_pickup_return && (vm.dataToFill.selectedServiceDetails.category == 1)\"><p>Hora Retiro Estimada: {{vm.pickRangeForRoutingReturn}} hrs</p></div><div class=etaDiv style=font-size:14px ng-if=\"vm.method_range_pickup_return && (vm.dataToFill.selectedServiceDetails.category == 0 &&  vm.type_of_trip == \'R\')\"><p>Hora Retiro Estimada: {{vm.pickRange2}} - {{vm.pickRange10}} hrs</p></div><!--<div class=\"etaDiv\" style=\"font-size:14px;\" ng-if=\"(vm.dataToFill.selectedServiceDetails.category == 0 &&  vm.type_of_trip == \'R\')\">--><!--<p>Hora Recogida Estimada:--><!--<br> {{ vm.pickRangeForRTypeReturn | date:\'HH:mm\'}}--><!--<span ng-if=\"vm.tolerance_time_withdrawal_pickup > 0 &&  vm.is_group_external == 0\">  - {{vm.pickRangeForEstimatedReturn | date:\'HH:mm\'}} </span>--><!--hrs--><!--</p>--><!--</div>--><!-- <div class=\"etaDiv\" style=\"font-size:14px;\" ng-if=\"vm.dataToFill.selectedServiceDetails.category == 1 && vm.dataToFill.airportCheck == \'Z\'\">\n                                                                                <p>Hora Recogida Estimada: {{vm.dataToFill.dropTimeReturn\n                                                                                    | date:\'HH:mm\'}} hrs</p> \n                                                                            </div> --><!--<div class=\"etaDiv\" style=\"font-size:14px;\" ng-if=\"(vm.dataToFill.selectedServiceDetails.category == 0 &&  vm.type_of_trip == \'R\')\">--><!--[> <p ng-if=\"vm.dataToFill.selectedServiceDetails.category != 1\">ETA - {{vm.dataToFill.etaSchedule || \'0 min\'}}</p> <]--><!--<p>ETA - {{vm.dataToFill.etaScheduleValueReturn--><!--+ vm.travel_time_service_pick_up || \'0\'}}mins</p>--><!--</div>--><div class=etaDiv style=font-size:14px ng-show=\"((vm.dataToFill.bookingType == \'1\' || vm.dataToFill.bookingType == 1 || vm.dataToFill.airportCheck == \'Z\') && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) && !vm.method_range_pickup_return  && (vm.dataToFill.selectedServiceDetails.category == 1)\"><p ng-if=\"vm.dataToFill.selectedServiceDetails.category != 1\">ETA - {{vm.dataToFill.etaScheduleReturn || \'0 min\'}}</p><p ng-if=\"vm.dataToFill.selectedServiceDetails.category == 1\">ETA - {{vm.dataToFill.etaScheduleValueReturn + vm.dataToFill.time_trip_shared_service || \'0\'}}mins</p></div><div class=etaDiv style=font-size:14px ng-show=\"((vm.dataToFill.bookingType == \'1\' || vm.dataToFill.bookingType == 1 || vm.dataToFill.airportCheck == \'Z\') && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) && vm.method_range_pickup_return  && (vm.dataToFill.selectedServiceDetails.category == 1)\"><p>ETA - {{vm.dataToFill.etaScheduleValueReturn || \'0\'}}mins</p></div><div class=etaDiv style=font-size:14px ng-show=\"vm.method_range_pickup_return && (vm.dataToFill.selectedServiceDetails.category == 0 &&  vm.type_of_trip == \'R\')\"><p>ETA - {{vm.dataToFill.etaScheduleValueReturn}}mins</p></div></div></div></div></div></td></tr><tr><td class=headingBollean>{{\'reaccurBooking\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'REACCURING_BOOKING\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.reaccurringBooking , \'fa fa-toggle-off\': !vm.dataToFill.reaccurringBooking, \'disableRoundTripToggle\': vm.dataToFill.bookingId}\"></i><!--,\'pointerEvent\':vm.dataToFill.bookingId--></td></tr><tr ng-if=vm.dataToFill.reaccurringBooking><td colspan=2><!--<div class=\"row\">--><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><table class=\"table table-hover\"><thead><tr><th>{{\'Sunday\' | translate}}</th><th>{{\'Monday\' | translate}}</th><th>{{\'Tuesday\' | translate}}</th><th>{{\'Wednesday\' | translate}}</th><th>{{\'Thursday\' | translate}}</th><th>{{\'Friday\' | translate}}</th><th>{{\'Saturday\' | translate}}</th></tr></thead><tbody><tr><td><div style=text-align:center><!--<input type=\"checkbox\"--><!--ng-model=\"vm.daysList.sunday.selected\"--><!--ng-click=\"vm.selectDay(\'Sunday\')\"--><!--value=\"Sunday\">--><md-checkbox ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) class=md-primary ng-click=\"vm.selectDay(\'Sunday\')\" ng-model=vm.daysList.sunday.selected aria-label=Sunday></md-checkbox></div></td><td><div style=text-align:center><!--<input type=\"checkbox\"--><!--ng-model=\"vm.daysList.monday.selected\"--><!--ng-click=\"vm.selectDay(\'Monday\')\"--><!--value=\"Monday\">--><md-checkbox ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) class=md-primary ng-click=\"vm.selectDay(\'Monday\')\" ng-model=vm.daysList.monday.selected aria-label=Monday></md-checkbox></div></td><td><div style=text-align:center><!--<input type=\"checkbox\"--><!--ng-model=\"vm.daysList.tuesday.selected\"--><!--ng-click=\"vm.selectDay(\'Tuesday\')\"--><!--value=\"Tuesday\">--><md-checkbox ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) class=md-primary ng-click=\"vm.selectDay(\'Tuesday\')\" ng-model=vm.daysList.tuesday.selected aria-label=Tuesday></md-checkbox></div></td><td><div style=text-align:center><!--<input type=\"checkbox\"--><!--ng-model=\"vm.daysList.wednesday.selected\"--><!--ng-click=\"vm.selectDay(\'Wednesday\')\"--><!--value=\"Wednesday\">--><md-checkbox ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) class=md-primary ng-click=\"vm.selectDay(\'Wednesday\')\" ng-model=vm.daysList.wednesday.selected aria-label=Wednesday></md-checkbox></div></td><td><div style=text-align:center><!--<input type=\"checkbox\"--><!--ng-model=\"vm.daysList.thursday.selected\"--><!--ng-click=\"vm.selectDay(\'Thursday\')\"--><!--value=\"Thursday\">--><md-checkbox ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) class=md-primary ng-click=\"vm.selectDay(\'Thursday\')\" ng-model=vm.daysList.thursday.selected aria-label=Thursday></md-checkbox></div></td><td><div style=text-align:center><!--<input type=\"checkbox\"--><!--ng-model=\"vm.daysList.friday.selected\"--><!--ng-click=\"vm.selectDay(\'Friday\')\"--><!--value=\"Friday\">--><md-checkbox ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) class=md-primary ng-click=\"vm.selectDay(\'Friday\')\" ng-model=vm.daysList.friday.selected aria-label=Friday></md-checkbox></div></td><td><div style=text-align:center><!--<input type=\"checkbox\"--><!--ng-model=\"vm.daysList.saturday.selected\"--><!--ng-click=\"vm.selectDay(\'Saturday\')\"--><!--value=\"Saturday\">--><md-checkbox ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) class=md-primary ng-click=\"vm.selectDay(\'Saturday\')\" ng-model=vm.daysList.saturday.selected aria-label=Saturday></md-checkbox></div></td></tr></tbody></table><!--</div>--><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'tillDate\' | translate}} <span style=color:red>*</span></label><p class=input-group><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) id=datePickerTillDate type=text class=form-control uib-datepicker-popup={{vm.tformat}} name=tillDate ng-model=vm.dataToFill.tillDate placeholder=\"{{\'tillDate\' | translate}}\" is-open=vm.datePicker_2.tillDate datepicker-options=vm.dateOption required ng-class=\"{ \'has-error\': createBookingForm.tillDate.$touched && createBookingForm.tillDate.$invalid }\" close-text=Close alt-input-formats=vm.altInputFormat show-button-bar=false readonly ng-change=vm.tillDateChange($event);> <span class=input-group-btn><button ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_2(\'1\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"createBookingForm.tillDate.$touched|| submit\" ng-messages=createBookingForm.tillDate.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'tillDateReq\' | translate}}</div></div></div><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label>Till Time<span style=\"color:red\">*</span></label>--><!--<div uib-timepicker ng-model=\"vm.dataToFill.tillTime\"--><!--show-spinners=\"false\" ng-change=\"vm.tillTimes()\"--><!--hour-step=\"vm.hsteps\" minute-step=\"vm.msteps\"--><!--show-meridian=\"vm.ismeridians\"></div>--><!--</div>--><!--</div>--></td></tr></tbody></table></div></div><div class=row><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.passengerRutCheck == 1\"><label>{{\'passengerRutB\' | translate}} <span style=color:red>*</span></label><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text class=form-control ng-model=vm.dataToFill.passengerRut name=passengerRut placeholder=\"{{\'passengerRutB\' | translate}}\" ng-rut ng-change=vm.passengerRutChange() required maxlength=13 ng-class=\"{ \'has-error\': createBookingForm.passengerRut.$touched && createBookingForm.passengerRut.$invalid }\"><div ng-if=\"createBookingForm.passengerRut.$touched|| submit\" ng-messages=createBookingForm.passengerRut.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'passengerRutBR\' | translate}}</div></div><div class=\"errormessage text-danger\" ng-if=vm.dataToFill.passengerRUTError>{{\'rutValid\' | translate}}</div></div><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.applicantRutCheck == 1\"><!--ng-if=\"((vm.dataToFill.customerProfile == 1 && vm.dataToFill.contractIdSelected) || (vm.dataToFill.customerProfile == 0 && vm.dataToFill.applicantRutCheck == 1))\"--><label>{{\'applicantRutB\' | translate}} <span style=color:red>*</span></label><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text class=form-control ng-model=vm.dataToFill.applicantRut name=applicantRut placeholder=\"{{\'applicantRutB\' | translate}}\" ng-rut ng-change=vm.applicantRutChange() required maxlength=13 ng-class=\"{ \'has-error\': createBookingForm.applicantRut.$touched && createBookingForm.applicantRut.$invalid }\"><div ng-if=\"createBookingForm.applicantRut.$touched|| submit\" ng-messages=createBookingForm.applicantRut.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'applicantRutBR\' | translate}}</div></div><div class=\"errormessage text-danger\" ng-if=vm.dataToFill.applicantRUTError>{{\'rutValid\' | translate}}</div></div></div><div class=row><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.costCenterCheck == 1\"><!--ng-if=\"((vm.dataToFill.customerProfile == 1 && vm.dataToFill.contractIdSelected) || (vm.dataToFill.customerProfile == 0 && vm.dataToFill.costCenterCheck == 1))\"--><label>{{\'costCenterText\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.costCenter name=costCenter placeholder=\"{{\'costCenterText\' | translate}}\" ng-required=!vm.checkBoxValueIs ng-class=\"{ \'has-error\': createBookingForm.costCenter.$touched && createBookingForm.costCenter.$invalid }\" ng-maxlength=50 maxlength=50><div ng-if=\"createBookingForm.costCenter.$touched|| submit\" ng-messages=createBookingForm.costCenter.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'costCenterR\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'usernameMax\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid position.--><!--</div>--></div></div><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.costSubCenterCheck == 1\"><!--ng-if=\"((vm.dataToFill.customerProfile == 1 && vm.dataToFill.contractIdSelected) || (vm.dataToFill.customerProfile == 0 && vm.dataToFill.costSubCenterCheck == 1))\"--><label>{{\'subCostText\' | translate}} <span style=color:red>*</span></label><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text class=form-control ng-model=vm.dataToFill.costSubCenter name=costSubCenter placeholder=\"{{\'subCostText\' | translate}}\" required ng-class=\"{ \'has-error\': createBookingForm.costSubCenter.$touched && createBookingForm.costSubCenter.$invalid }\" ng-maxlength=50 maxlength=50><div ng-if=\"createBookingForm.costSubCenter.$touched|| submit\" ng-messages=createBookingForm.costSubCenter.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'costSubCenterR\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'usernameMax\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid position.--><!--</div>--></div></div></div><div class=row><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.RolCheck == 1\"><!--ng-if=\"((vm.dataToFill.customerProfile == 1 && vm.dataToFill.contractIdSelected) || (vm.dataToFill.customerProfile == 0 && vm.dataToFill.RolCheck == 1))\"--><label>{{\'ROLText\' | translate}} <span style=color:red>*</span></label><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text class=form-control ng-model=vm.dataToFill.Rol name=Rol placeholder=\"{{\'ROLText\' | translate}}\" required ng-class=\"{ \'has-error\': createBookingForm.Rol.$touched && createBookingForm.Rol.$invalid }\" ng-maxlength=50 maxlength=50><div ng-if=\"createBookingForm.Rol.$touched|| submit\" ng-messages=createBookingForm.Rol.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'rolR\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'usernameMax\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid position.--><!--</div>--></div></div><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.graphCheck == 1\"><!--ng-if=\"((vm.dataToFill.customerProfile == 1 && vm.dataToFill.contractIdSelected) || (vm.dataToFill.customerProfile == 0 && vm.dataToFill.graphCheck == 1))\"--><label>{{\'graphText\' | translate}} <span style=color:red>*</span></label><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text class=form-control ng-model=vm.dataToFill.graph name=graph placeholder=Graph required ng-class=\"{ \'has-error\': createBookingForm.graph.$touched && createBookingForm.graph.$invalid }\" ng-maxlength=50 maxlength=50><div ng-if=\"createBookingForm.graph.$touched|| submit\" ng-messages=createBookingForm.graph.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'graphR\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'usernameMax\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid position.--><!--</div>--></div></div></div><div class=row><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.workOrderCheck == 1\"><label>{{\'workOrdrerB\' | translate}} <span style=color:red>*</span></label><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text class=form-control ng-model=vm.dataToFill.workOrder name=workOrder placeholder=\"{{\'workOrdrerB\' | translate}}\" required ng-class=\"{ \'has-error\': createBookingForm.workOrder.$touched && createBookingForm.workOrder.$invalid }\" ng-maxlength=15 maxlength=15><div ng-if=\"createBookingForm.workOrder.$touched|| submit\" ng-messages=createBookingForm.workOrder.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'workOrderBR\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'max15\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid position.--><!--</div>--></div></div><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.pepCheck == 1\"><!--ng-if=\"((vm.dataToFill.customerProfile == 1 && vm.dataToFill.contractIdSelected) || (vm.dataToFill.customerProfile == 0 && vm.dataToFill.pepCheck == 1))\"--><label>{{\'PEPText\' | translate}} <span style=color:red>*</span></label><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text class=form-control ng-model=vm.dataToFill.pep name=pep placeholder=\"{{\'PEPText\' | translate}}\" required ng-class=\"{ \'has-error\': createBookingForm.pep.$touched && createBookingForm.pep.$invalid }\" ng-maxlength=50 maxlength=50><div ng-if=\"createBookingForm.pep.$touched|| submit\" ng-messages=createBookingForm.pep.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'pepR\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'usernameMax\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid position.--><!--</div>--></div></div></div><div class=row><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.noOfVoucherCheck == 1\"><label>{{\'numberOfVoucherText\' | translate}} <span style=color:red>*</span></label><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text class=form-control ng-model=vm.dataToFill.noOfVoucher name=numberOfVoucher placeholder=\"{{\'numberOfVoucherText\' | translate}}\" required ng-class=\"{ \'has-error\': createBookingForm.numberOfVoucher.$touched && createBookingForm.numberOfVoucher.$invalid }\" ng-maxlength=15 maxlength=15><div ng-if=\"createBookingForm.numberOfVoucher.$touched|| submit\" ng-messages=createBookingForm.numberOfVoucher.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'voucherR\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'max15\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid position.--><!--</div>--></div></div><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.nominaCheck == 1\"><label>{{\'nomina1\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.nomina name=nomina alpha-numeric=\"\" maxlength=15 ng-maxlength=15 ng-required=!vm.checkBoxValueIs placeholder=\"{{\'nomina1\' | translate}}\" ng-class=\"{ \'has-error\': createBookingForm.nomina.$touched && createBookingForm.nomina.$invalid }\"><div ng-if=\"createBookingForm.nomina.$touched|| submit\" ng-messages=createBookingForm.nomina.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'nominaR\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"minlength\">{{\'max15\' | translate}}</div>--><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'max15\' | translate}}</div></div></div></div><div class=row><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.solictudCheck == 1\"><label>{{\'solicitud1\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.solictud name=solicitud placeholder=\"{{\'solicitud1\' | translate}}\" ng-required=!vm.checkBoxValueIs alpha-numeric=\"\" maxlength=15 ng-maxlength=15 ng-class=\"{ \'has-error\': createBookingForm.solicitud.$touched && createBookingForm.solicitud.$invalid }\"><div ng-if=\"createBookingForm.solicitud.$touched|| submit\" ng-messages=createBookingForm.solicitud.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'solicitudR\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"minlength\">{{\'min10\' | translate}}</div>--><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'max15\' | translate}}</div></div></div></div><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\" ng-if=\"vm.dataToFill.purposeOfTripCheck == 1\"><label>{{\'purpouseTripB\' | translate}} <span style=color:red>*</span></label><textarea ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) class=form-control ng-model=vm.dataToFill.purposeOfTrip name=purposeOfTrip placeholder=\"{{\'purpouseTripB\' | translate}}\" required ng-class=\"{ \'has-error\': createBookingForm.purposeOfTrip.$touched && createBookingForm.purposeOfTrip.$invalid }\" ng-maxlength=50 maxlength=50></textarea><div ng-if=\"createBookingForm.purposeOfTrip.$touched|| submit\" ng-messages=createBookingForm.purposeOfTrip.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'purpouseTripBR\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'usernameMax\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid position.--><!--</div>--></div></div></div><div class=row><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.itemOfChargeList.length > 0\"><label>{{\'itemOfCharge\' | translate}}</label><ui-select ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) multiple ng-model=vm.dataToFill.itemOfChargeSelected theme=bootstrap close-on-select=false title=\"{{\'selectItemP\' | translate}}\" name=itemOfCharge on-select=\"vm.selectingItemOfCharges($select.selected,\'select\')\" on-remove=\"vm.selectingItemOfCharges($select.selected,\'remove\')\" ng-class=\"{ \'has-error\': createBookingForm.itemOfCharge.$touched && createBookingForm.itemOfCharge.$invalid }\"><ui-select-match placeholder=\"{{\'selectItemP\' | translate}}\">{{$item.tic_long_name}}</ui-select-match><ui-select-choices repeat=\"data in vm.dataToFill.itemOfChargeList | filter:$select.search \">{{data.tic_long_name}}</ui-select-choices></ui-select></div><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.itemOfChargeSelected.length> 0\"><table class=table><thead><tr><th>{{\'itemName\' | translate}}</th><th>{{\'itemPrice\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"itemData in vm.dataToFill.itemOfChargeSelected\"><td>{{itemData.tic_long_name}}</td><td><span ng-if=\"itemData.tic_mode == 0\">${{itemData.price}}</span> <span ng-if=\"itemData.tic_mode == 1\">$&nbsp;&nbsp; <input type=text ng-change=\"vm.selectingItemOfCharges($index,\'change\')\" placeholder=\"{{\'itemPrice\' | translate}}\" ng-model=itemData.price number-dot></span></td></tr></tbody></table></div></div><div class=\"row mt5\" ng-if=\" vm.type_of_trip1 != \'P\' && vm.flagForAirline == true\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>{{\'airline\' | translate}} <span style=color:red>*</span></label></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text class=form-control ng-model=vm.dataToFill.airline required maxlength=20 ng-maxlength=20 name=airline placeholder=\"{{\'airline\' | translate}}\" ng-class=\"{ \'has-error\': spotBookingForm.airline.$touched && spotBookingForm.airline.$invalid }\" ng-change=\"vm.dataToFill.couponValidation=false\"><div ng-if=\"createBookingForm.airline.$touched|| submit\" ng-messages=createBookingForm.airline.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'airlineReq\' | translate}}</div></div></div></div><div class=\"row mt5\" ng-if=\" vm.type_of_trip1 != \'P\' && vm.flagForFlightNumber == true\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>{{\'flightNumber\' | translate}}</label><span style=color:red>*</span> <input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text class=form-control ng-model=vm.dataToFill.flightNumber required alpha-numeric=\"\" maxlength=8 ng-maxlength=8 name=flightNumber placeholder=\"{{\'flightNumber\' | translate}}\" ng-class=\"{ \'has-error\': spotBookingForm.flightNumber.$touched && spotBookingForm.flightNumber.$invalid }\" ng-change=\"vm.dataToFill.couponValidation=false\"><div ng-if=\"createBookingForm.flightNumber.$touched|| submit\" ng-messages=createBookingForm.flightNumber.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'flightNumberReq\' | translate}}</div></div></div></div><div class=\"row mt5\" ng-if=\" vm.type_of_trip1 != \'P\' && vm.flagForFlightType == true\"><div class=\"col-lg-6 col-sm-6 col-xs-6 col-md-5\"><label>{{\'flightType\' | translate}}</label><span style=color:red>*</span><br><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=radio name=gender value=I ng-model=vm.international ng-click=\"vm.changeFlightType(\'I\')\"> <span style=\"margin-left: 5px;font-weight: 450;font-size: 14px\">{{\'international\' | translate}}</span> <input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=radio name=gender value=N style=\"margin-left:15px;margin-top: 10px\" ng-model=vm.national ng-click=\"vm.changeFlightType(\'N\')\"> <span style=\"margin-left: 5px;font-weight: 450;font-size: 14px\" ng-model=vm.national>{{\'national\' | translate}}</span><br><div ng-if=\"vm.international == null && vm.national == null || submit\"><div class=\"errormessage text-danger\" ng-message=required>{{\'flightDateReq\' | translate}}</div></div></div></div><!-- ng-if=\" vm.type_of_trip1 != \'P\' && vm.flagForFlightDate == true\" --><div class=\"row mt5\" ng-if=\" vm.type_of_trip1 != \'P\' && vm.flagForFlightDate == true\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>{{\'flightDate\' | translate}}</label><span style=color:red>*</span></div><div class=\"col-lg-7 col-sm-7 col-xs-12 col-md-7\"><p class=input-group><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text class=form-control uib-datepicker-popup={{vm.format}} name=pickupDate ng-model=vm.filterData.filter_pickup_from_date_value placeholder=\"{{\'flightDate\' | translate}}\" is-open=vm.datePicker_1.pickupFromDate required datepicker-options=vm.dateOptions close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=\"vm.pickupFromToDateChanged(1); vm.compareDates()\"> <span class=input-group-btn><button ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=button class=\"btn btn-default\" ng-click=vm.datePickerE_New(1)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=\"errormessage text-danger\" ng-if=\"vm.scheduleDateValidation || vm.dropoffDateValidation\">Fecha de vuelo debe ser menor que la fecha de recogida.</div><div class=\"errormessage text-danger\" ng-if=\"vm.flightDateValidation \">Fecha de vuelo debe ser mayor que la fecha de recogida.</div><div ng-if=\"createBookingForm.pickupDate.$touched|| submit\" ng-messages=createBookingForm.pickupDate.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'flightDateReq\' | translate}}</div></div><p></p></div><div class=\"col-lg-5 col-sm-5 col-xs-12 col-md-5\"><div ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) uib-timepicker ng-model=vm.filterData.filter_pickup_from_time_value ng-model-options=\"{ debounce: 400 }\" show-spinners=false class=completed ng-change=vm.pickupFromToTimeChanged(1);vm.changeTime() hour-step=vm.hstep minute-step=vm.mstep show-meridian=false min=vm.TimeChange()></div><!-- min=\"vm.TimeChange()\" --></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Métodos de pago <span style=color:red>*</span></label><ui-select ng-disabled=\"vm.disabledPaymentMethod == true || vm.CheckBookingStatus(vm.bookingDetails)\" ng-model=vm.dataToFill.payment_method name=pago ng-required=!vm.modifyFalg close-on-select=true ng-class=\"{ \'has-error\': createBookingForm.pago.$touched && createBookingForm.pago.$invalid }\"><ui-select-match placeholder=\"Métodos de pago\">{{$select.selected.type}}</ui-select-match><ui-select-choices repeat=\"payment.id as payment in vm.dataToFill.paymentMethodList | filter: $select.search | orderBy:\'type\' \"><div ng-bind-html=payment.type></div></ui-select-choices></ui-select><div ng-if=\"createBookingForm.pago.$touched|| submit\" ng-messages=createBookingForm.pago.$error><div class=\"errormessage text-danger\" ng-message=required>Debe seleccionar un Método de pago</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>Cupón Descuento</label></div><div class=\"col-lg-10 col-sm-10 col-xs-12 col-md-10\"><input ng-disabled=\"((vm.isAdjustedDiscountedAmount == 1 ) || (vm.finalAdjustedPriceFromAdmin > 0) || (vm.dataToFill.roundTrip == true || (vm.bookingDetails.round_trip_parent_job_id > 0 || vm.bookingDetails.round_trip_child_job_id > 0) ||  !vm.couponFlag)) || vm.CheckBookingStatus(vm.bookingDetails) \" type=text class=form-control ng-model=vm.dataToFill.couponCode name=couponCode placeholder=\"Cupón Descuento\" ng-class=\"{ \'has-error\': spotBookingForm.couponCode.$touched && spotBookingForm.couponCode.$invalid }\" ng-change=\"vm.dataToFill.couponValidation=false\"><div ng-if=vm.dataToFill.couponValidation class=\"parsley-errors-list filled\"><div class=\"errormessage text-danger\">Este cupón no es válido</div></div><!--<div ng-if=\"spotBookingForm.couponCode.$touched|| vm.submit\" ng-messages=\"spotBookingForm.couponCode.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Por favor, ingrese la solicitud</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"maxlength\">Se permiten un máximo de 15 caracteres.</div>--><!--</div>--></div><div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\"><input ng-disabled=\"((vm.isAdjustedDiscountedAmount == 1 ) || (vm.finalAdjustedPriceFromAdmin > 0) || (vm.dataToFill.roundTrip == true || (vm.bookingDetails.round_trip_parent_job_id > 0 || vm.bookingDetails.round_trip_child_job_id > 0 || !vm.couponFlag))|| vm.CheckBookingStatus(vm.bookingDetails))\" type=button class=\"btn btn-primary\" ng-click=vm.applyCoupon() value=Aplicar></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>{{\'observationText\' | translate}}</label><textarea ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) class=form-control ng-model=vm.dataToFill.observations name=observation placeholder=\"{{\'messagePlaceholder\' | translate}}\" style=\"height: 120px\" ng-class=\"{ \'has-error\': createBookingForm.observation.$touched && createBookingForm.observation.$invalid }\" ng-maxlength=500 maxlength=500></textarea><div ng-if=\"createBookingForm.observation.$touched|| submit\" ng-messages=createBookingForm.observation.$error><div class=\"errormessage text-danger\" ng-message=required>Please enter observation.</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'max500\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid position.--><!--</div>--></div></div></div></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><button ng-disabled=\"vm.flightDateValidation || vm.scheduleDateValidation || vm.dropoffDateValidation || !vm.disabledSubmitButton\" ng-class=\"{\'disableSubmit\' : vm.disabledSubmitButton1 }\" type=submit class=\"btn btn-primary\" style=width:200px>{{\'submit\' | translate}}</button><!-- ng-disabled=\"vm.disableSubmitButton\" --></div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><div class=\"panel panel-default\"><div class=panel-body><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><div style=padding:0 class=\"col-lg-9 col-sm-12 col-xs-12 col-md-9 paddingBottom\"><div ng-if=vm.dataToFill.nearDriver><p class=driverSelected>{{\'driverBooking\' | translate}} <span class=\"fa fa-close\" ng-click=vm.removeSelectedDriver()></span></p></div><div class=\"etaDiv text-align-left\" ng-if=\"((vm.dataToFill.bookingType == \'1\' || vm.dataToFill.bookingType == 1 || vm.dataToFill.airportCheck == \'Z\') && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) && !vm.method_range_pickup\"><p ng-if=\"vm.dataToFill.selectedServiceDetails.category != 1\">ETA - {{vm.type_of_trip1 == \'R\' ? + vm.travel_time_service_pick_up + vm.dataToFill.etaSchedule : vm.dataToFill.etaSchedule}}mins</p><!-- <p ng-if=\"vm.dataToFill.selectedServiceDetails.category != 1 && vm.modifyFalgNew\">ETA - {{vm.dataToFill.etaSchedule}}mins</p>                                             --><p ng-if=\"vm.dataToFill.selectedServiceDetails.category == 1\">ETA - {{vm.dataToFill.etaScheduleValue + vm.dataToFill.time_trip_shared_service || \'0\'}}mins</p></div><div class=\"etaDiv text-align-left\" ng-if=\"((vm.dataToFill.bookingType == \'1\' || vm.dataToFill.bookingType == 1 || vm.dataToFill.airportCheck == \'Z\') && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) && vm.method_range_pickup\"><p>ETA - {{vm.dataToFill.etaSchedule + \'mins\'|| \'0 min\'}}</p></div><div class=\"etaDiv text-align-left\" ng-if=vm.dataToFill.estimatedFare><p ng-if=\"vm.dataToFill.route_type == 0\">Tipo de Tarifa: Variable</p><p ng-if=\"vm.dataToFill.route_type == 1\">Tipo de Tarifa: Fija</p></div><div class=\"etaDiv text-align-left\" ng-if=\"vm.showEstimatePriceInHtml(vm.dataToFill.roundTrip, vm.viaControlledFLag1, vm.viaControlledFLag)\"><p>{{\'estimatedPrice\' | translate}} - <span ng-if=\"!vm.click && vm.finalAdjustedPriceFromAdmin == 0\">${{ vm.calculatedEstimatePriceFormFunction }} </span><span ng-if=\"!vm.click && vm.finalAdjustedPriceFromAdmin != 0\">${{ vm.calculatedEstimatePriceFormFunctionEstimated }} </span><!-- <input style=\"width: 90px;\" type=\"number\" ng-model=\"vm.calculatedEstimatePriceFormFunction\" ng-if=\"vm.click && vm.finalAdjustedPriceFromAdmin == 0\" > --> <input style=\"width: 90px\" type=number ng-model=vm.calculatedEstimatePriceFormFunctionEstimated ng-if=vm.click> <button type=button class=\"btn-primary tableButton\" ng-disabled=\"vm.couponType != undefined\" ng-click=\"vm.clickFunction(\'Modify\')\" ng-if=\"!vm.click && vm.dataToFill.route_type == 1  && !vm.dataToFill.roundTrip && vm.dataToFill.allowChangeFarePanel  && !vm.modifyFalg\">Modificar Tarifa</button> <button type=button class=\"btn-primary tableButton\" ng-disabled=\"vm.couponType != undefined\" ng-click=\"vm.clickFunction(\'Done\')\" ng-if=\"vm.click && vm.dataToFill.route_type == 1  && !vm.dataToFill.roundTrip && vm.dataToFill.allowChangeFarePanel  && !vm.modifyFalg\">Confirmar</button></p></div><!--!703 change  && vm.dataToFill.route_type == 1 --><!-- <div class=\"etaDiv\" ng-if=\" vm.dataToFill.roundTrip == false && vm.viaControlledFLag1 == false && vm.viaControlledFLag == false \">\n                                    <p>{{\'estimatedPrice\' | translate}} - ${{ vm.math.round(vm.dataToFill.estimatedFare) ||\n                                        \'0\'}}</p>\n                                </div>\n                                <div class=\"etaDiv\" ng-if=\" vm.dataToFill.roundTrip == false && vm.viaControlledFLag1 == true && vm.viaControlledFLag == false \">\n                                    <p>{{\'estimatedPrice\' | translate}} - ${{ vm.math.round((vm.dataToFill.estimatedFare) +\n                                            (vm.dataToFill.controllerWayTarifa ? 0 : vm.viaControlled1))|| \'0\'}}\n                                        \n                                    </p>\n                                </div>\n                                <div class=\"etaDiv\" ng-if=\" vm.dataToFill.roundTrip == false && vm.viaControlledFLag1 == false && vm.viaControlledFLag == true \">\n                                        <p>{{\'estimatedPrice\' | translate}} - ${{ vm.math.round(vm.dataToFill.estimatedFare) ||\n                                            \'0\'}}</p>\n                                            \n                                </div>\n                                <div class=\"etaDiv\" ng-if=\" vm.dataToFill.roundTrip == true && vm.viaControlledFLag1 == false && vm.viaControlledFLag == false \">\n                                    <p>{{\'estimatedPrice\' | translate}} - ${{ vm.math.round((vm.dataToFill.estimatedFare) +\n                                        (vm.dataToFill.Return_policy.estimatedFare )) || \'0\'}}</p>\n                                        \n                                </div>\n                                <div class=\"etaDiv\" ng-if=\" vm.dataToFill.roundTrip == true && vm.viaControlledFLag1 == true && vm.viaControlledFLag == false \">\n                                    <p>{{\'estimatedPrice\' | translate}} - ${{ vm.math.round((vm.dataToFill.estimatedFare) +\n                                        (vm.dataToFill.Return_policy.estimatedFare )+ (vm.dataToFill.controllerWayTarifa ? 0 : vm.viaControlled1)) || \'0\'}}</p>\n                                </div>\n                                <div class=\"etaDiv\" ng-if=\" vm.dataToFill.roundTrip == true && vm.viaControlledFLag1 == false && vm.viaControlledFLag == true \">\n                                    <p>{{\'estimatedPrice\' | translate}} - ${{ vm.math.round((vm.dataToFill.estimatedFare) +\n                                        (vm.dataToFill.Return_policy.estimatedFare )+ (vm.dataToFill.controllerWayTarifa ? 0 : vm.viaControlled2)) || \'0\'}}</p>\n                                </div> --><div class=\"etaDiv text-align-left\" ng-if=\"vm.showEstimatePriceForFixedPriceInHtml(vm.dataToFill.estimatedFare, vm.dataToFill.roundTrip, vm.viaControlledFLag1)\"><p>{{\'fixedPrice\' | translate}} - ${{ vm.calculatedEstimatePriceForFixedPriceFormFunction || \'0\'}}</p></div><!-- <div class=\"etaDiv\" ng-if=\"vm.showEstimatePriceForRoundTripInHtml(vm.dataToFill.Return_policy.estimatedFare, vm.dataToFill.roundTrip, vm.viaControlledFLag)\">\n                                    <p>{{\'roundPrice\' | translate}} - ${{ vm.calculatedEstimatePriceForRoundTripFormFunction\n                                        || \'0\'}}</p>\n                                </div> --><!-- <div class=\"etaDiv\" ng-if=\"vm.showEstimatePriceForFixedPriceInHtml(vm.dataToFill.estimatedFare, vm.dataToFill.roundTrip, vm.viaControlledFLag1)\">\n                                    <p>{{\'fixedPrice\' | translate}} - ${{ vm.calculatedEstimatePriceForFixedPriceFormFunction || \'0\'}}\n                                    </p>\n                                </div> --><div class=\"etaDiv text-align-left\" ng-if=\"vm.showEstimatePriceForRoundTripInHtml(vm.dataToFill.Return_policy.estimatedFare, vm.dataToFill.roundTrip, vm.viaControlledFLag)\"><p>{{\'roundPrice\' | translate}} - ${{ vm.calculatedEstimatePriceForRoundTripFormFunction || \'0\'}}</p></div></div><div class=\"col-lg-3 col-sm-12 col-xs-12 col-md-3 verMapaButton\"><input ng-disabled=\"!(vm.dataToFill.pickUpAddress && vm.dataToFill.dropOffAddress) || (vm.showGoogleMap)\" type=button class=\"btn btn-primary\" ng-click=\"vm.showGoogleMap = true; vm.mapInitialize()\" value=\"Ver Mapa\"></div></div><!--<div class=\"etaDiv\" ng-if=\"vm.dataToFill.selectedServiceDetails.category == 1 && vm.pickRange1 && vm.pickRange2 && vm.dataToFill.airportCheck != \'Z\'\">--><!--<p>Estimated Pickup: {{vm.pickRange1}} - {{vm.pickRange2}}</p>--><!--</div>--><!--<div class=\"etaDiv\" ng-if=\"vm.dataToFill.selectedServiceDetails.category == 1 && vm.dataToFill.airportCheck == \'Z\'\">--><!--<p>Pickup: {{vm.dataToFill.dropTime | date:\'HH:mm\'}}</p>--><!--</div>--><!--<div class=\"etaDiv\" ng-if=\"vm.dataToFill.selectedServiceDetails.category == 0 && vm.dropRange1 && vm.dropRange1\">--><!--<p>Estimated Dropoff: {{vm.dropRange1}} - {{vm.dropRange1}}</p>--><!--</div>--><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" ng-show=vm.showGoogleMap><div id=googleMap style=width:100%></div></div></div></div><div class=\"row mt5\" ng-if=\"((vm.dataToFill.roundTrip || vm.dataToFill.couponApplied) && vm.dataToFill.discounts.length > 0)\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">Monto de la reserva</p><div class=row style=\"padding:0px 10px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\" style=\"max-height:345px;overflow-y: auto\"><table class=\"table table-hover\"><thead><tr><th>Descuento Nombre</th><th>Descuento</th><th>Tipo</th><th>{{\'estimatedPrice\' | translate}}</th><th>Cantidad total</th></tr></thead><tbody><tr><td><span ng-if=\"vm.dataToFill.discounts[0].name == \'ROUND TRIP\'\">DSCTO. IDA Y VUELTA</span> <span ng-if=\"vm.dataToFill.discounts[0].name != \'ROUND TRIP\'\">{{vm.dataToFill.discounts[0].name}}</span></td><td>{{vm.dataToFill.discounts[0].discountTypeValue}}</td><td><span ng-if=\"vm.dataToFill.discounts[0].discountType == \'0\' || vm.dataToFill.discounts[0].discountType == 0\">Flat</span> <span ng-if=\"vm.dataToFill.discounts[0].discountType == \'1\' || vm.dataToFill.discounts[0].discountType == 1\">Percentage</span></td><!-- (vm.roundTripChildJobId) Contain Child Job Id --><!-- Default value of vm.roundTripChildJobId is 1 --><!-- (vm.roundTripChildJobId == 0) is for Child booking --><!-- (vm.roundTripChildJobId > 0) is for Parent booking --><td ng-if=\"vm.roundTripChildJobId == 0\">${{vm.dataToFill.discounts[0].estimatedFare}}</td><td ng-if=\"vm.roundTripChildJobId > 0\">${{vm.dataToFill.discounts[0].estimatedFare + vm.dataToFill.discounts[0].roundTripFare}}</td><td ng-if=\"vm.roundTripChildJobId > 0\">${{vm.dataToFill.discounts[0].finalAmount + vm.dataToFill.discounts[0].roundFinalAmount}}</td><td ng-if=\"vm.roundTripChildJobId == 0\">${{vm.dataToFill.discounts[0].finalAmount}}</td></tr></tbody></table></div></div></div></div></div></div></div></form></div></div><input id=copy style=\"opacity: 0 ; z-index:0\" type=text><div id=showPrint></div></div><script type=text/ng-template id=customTemplate.html><a style=\"cursor: pointer;\">\n        <span class=\"displayFlex\">\n            <span>\n                <img ng-src=\"{{match.model.profile_pic_thumb || \'assets/images/noImage.jpeg\'}}\" width=\"35\">\n            </span>\n            <span style=\"padding-left: 10px;\">\n                <span ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"></span>\n                <span>/</span>\n                <span ng-bind-html=\"match.model.email\"></span>\n                <br/>\n                <span ng-bind-html=\"match.model.phone_number\"></span>\n            </span>\n        </span>\n    </a></script><script type=text/ng-template id=personTemplate.html><a style=\"cursor: pointer;\">\n        <span class=\"displayFlex\">\n            <span>\n                <img ng-src=\"{{match.model.profile_pic_thumb || \'assets/images/noImage.jpeg\'}}\" width=\"35\">\n            </span>\n            <span style=\"padding-left: 10px;\">\n                <span ng-bind-html=\"match.model.name | uibTypeaheadHighlight:query\"></span>\n                <span>/</span>\n                <span ng-bind-html=\"match.model.email\"></span>\n                <br/>\n                <span ng-bind-html=\"match.model.phone_number\"></span>\n            </span>\n        </span>\n    </a></script><style>.nav>li.TabsBar>a:hover {\n        background-color: white !important;\n        color: #F17F3A !important;\n        /* text-decoration: underline !important; */\n    }\n\n    .panel.with-nav-tabs .panel-heading {\n        padding: 5px 5px 0 5px;\n    }\n\n    .panel.with-nav-tabs .nav-tabs {\n        border-bottom: none;\n    }\n\n    .panel.with-nav-tabs .nav-justified {\n        margin-bottom: -1px;\n    }\n\n    /********************************************************************/\n\n    /*** PANEL DEFAULT ***/\n\n    .with-nav-tabs.panel-default .nav-tabs>li>a,\n    .with-nav-tabs.panel-default .nav-tabs>li>a:hover,\n    .with-nav-tabs.panel-default .nav-tabs>li>a:focus {\n        color: #777;\n        font-weight: bold;\n    }\n\n    .with-nav-tabs.panel-default .nav-tabs>.open>a,\n    .with-nav-tabs.panel-default .nav-tabs>.open>a:hover,\n    .with-nav-tabs.panel-default .nav-tabs>.open>a:focus,\n    .with-nav-tabs.panel-default .nav-tabs>li>a:hover,\n    .with-nav-tabs.panel-default .nav-tabs>li>a:focus {\n        color: #777;\n        background-color: #ddd;\n        border-color: transparent;\n        /* font-size: 12px; */\n    }\n\n    .with-nav-tabs.panel-default .nav-tabs>li.active>a,\n    .with-nav-tabs.panel-default .nav-tabs>li.active>a:hover .with-nav-tabs.panel-default .nav-tabs>li.active>a:focus {\n        color: #F17F3A;\n        background-color: #fff;\n        border-color: #ddd;\n        /* text-decoration: underline; */\n        font-size: 14px;\n        font-weight: bold;\n        border-bottom-color: transparent;\n    }\n\n    .with-nav-tabs.panel-default .nav-tabs>li.dropdown .dropdown-menu {\n        background-color: #f5f5f5;\n        border-color: #ddd;\n    }\n\n    .with-nav-tabs.panel-default .nav-tabs>li.dropdown .dropdown-menu>li>a {\n        color: #777;\n    }\n\n    .with-nav-tabs.panel-default .nav-tabs>li.dropdown .dropdown-menu>li>a:hover,\n    .with-nav-tabs.panel-default .nav-tabs>li.dropdown .dropdown-menu>li>a:focus {\n        background-color: #ddd;\n    }\n\n    .with-nav-tabs.panel-default .nav-tabs>li.dropdown .dropdown-menu>.active>a,\n    .with-nav-tabs.panel-default .nav-tabs>li.dropdown .dropdown-menu>.active>a:hover,\n    .with-nav-tabs.panel-default .nav-tabs>li.dropdown .dropdown-menu>.active>a:focus {\n        color: #fff;\n        background-color: #555;\n    }\n\n    /********************************************************************/\n\n    /*** PANEL PRIMARY ***/\n\n    .with-nav-tabs.panel-primary .nav-tabs>li>a,\n    .with-nav-tabs.panel-primary .nav-tabs>li>a:hover,\n    .with-nav-tabs.panel-primary .nav-tabs>li>a:focus {\n        color: #fff;\n    }\n\n    .with-nav-tabs.panel-primary .nav-tabs>.open>a,\n    .with-nav-tabs.panel-primary .nav-tabs>.open>a:hover,\n    .with-nav-tabs.panel-primary .nav-tabs>.open>a:focus,\n    .with-nav-tabs.panel-primary .nav-tabs>li>a:hover,\n    .with-nav-tabs.panel-primary .nav-tabs>li>a:focus {\n        color: #fff;\n        background-color: #3071a9;\n        border-color: transparent;\n    }\n\n    .with-nav-tabs.panel-primary .nav-tabs>li.active>a,\n    .with-nav-tabs.panel-primary .nav-tabs>li.active>a:hover,\n    .with-nav-tabs.panel-primary .nav-tabs>li.active>a:focus {\n        color: #428bca;\n        background-color: #fff;\n        border-color: #428bca;\n        border-bottom-color: transparent;\n    }\n\n    .with-nav-tabs.panel-primary .nav-tabs>li.dropdown .dropdown-menu {\n        background-color: #428bca;\n        border-color: #3071a9;\n    }\n\n    .with-nav-tabs.panel-primary .nav-tabs>li.dropdown .dropdown-menu>li>a {\n        color: #fff;\n    }\n\n    .with-nav-tabs.panel-primary .nav-tabs>li.dropdown .dropdown-menu>li>a:hover,\n    .with-nav-tabs.panel-primary .nav-tabs>li.dropdown .dropdown-menu>li>a:focus {\n        background-color: #3071a9;\n    }\n\n    .with-nav-tabs.panel-primary .nav-tabs>li.dropdown .dropdown-menu>.active>a,\n    .with-nav-tabs.panel-primary .nav-tabs>li.dropdown .dropdown-menu>.active>a:hover,\n    .with-nav-tabs.panel-primary .nav-tabs>li.dropdown .dropdown-menu>.active>a:focus {\n        background-color: #4a9fe9;\n    }\n\n    /********************************************************************/\n\n    /*** PANEL SUCCESS ***/\n\n    .with-nav-tabs.panel-success .nav-tabs>li>a,\n    .with-nav-tabs.panel-success .nav-tabs>li>a:hover,\n    .with-nav-tabs.panel-success .nav-tabs>li>a:focus {\n        color: #3c763d;\n    }\n\n    .with-nav-tabs.panel-success .nav-tabs>.open>a,\n    .with-nav-tabs.panel-success .nav-tabs>.open>a:hover,\n    .with-nav-tabs.panel-success .nav-tabs>.open>a:focus,\n    .with-nav-tabs.panel-success .nav-tabs>li>a:hover,\n    .with-nav-tabs.panel-success .nav-tabs>li>a:focus {\n        color: #3c763d;\n        background-color: #d6e9c6;\n        border-color: transparent;\n    }\n\n    .with-nav-tabs.panel-success .nav-tabs>li.active>a,\n    .with-nav-tabs.panel-success .nav-tabs>li.active>a:hover,\n    .with-nav-tabs.panel-success .nav-tabs>li.active>a:focus {\n        color: #3c763d;\n        background-color: #fff;\n        border-color: #d6e9c6;\n        border-bottom-color: transparent;\n    }\n\n    .with-nav-tabs.panel-success .nav-tabs>li.dropdown .dropdown-menu {\n        background-color: #dff0d8;\n        border-color: #d6e9c6;\n    }\n\n    .with-nav-tabs.panel-success .nav-tabs>li.dropdown .dropdown-menu>li>a {\n        color: #3c763d;\n    }\n\n    .with-nav-tabs.panel-success .nav-tabs>li.dropdown .dropdown-menu>li>a:hover,\n    .with-nav-tabs.panel-success .nav-tabs>li.dropdown .dropdown-menu>li>a:focus {\n        background-color: #d6e9c6;\n    }\n\n    .with-nav-tabs.panel-success .nav-tabs>li.dropdown .dropdown-menu>.active>a,\n    .with-nav-tabs.panel-success .nav-tabs>li.dropdown .dropdown-menu>.active>a:hover,\n    .with-nav-tabs.panel-success .nav-tabs>li.dropdown .dropdown-menu>.active>a:focus {\n        color: #fff;\n        background-color: #3c763d;\n    }\n\n    /********************************************************************/\n\n    /*** PANEL INFO ***/\n\n    .with-nav-tabs.panel-info .nav-tabs>li>a,\n    .with-nav-tabs.panel-info .nav-tabs>li>a:hover,\n    .with-nav-tabs.panel-info .nav-tabs>li>a:focus {\n        color: #31708f;\n    }\n\n    .with-nav-tabs.panel-info .nav-tabs>.open>a,\n    .with-nav-tabs.panel-info .nav-tabs>.open>a:hover,\n    .with-nav-tabs.panel-info .nav-tabs>.open>a:focus,\n    .with-nav-tabs.panel-info .nav-tabs>li>a:hover,\n    .with-nav-tabs.panel-info .nav-tabs>li>a:focus {\n        color: #31708f;\n        background-color: #bce8f1;\n        border-color: transparent;\n    }\n\n    .with-nav-tabs.panel-info .nav-tabs>li.active>a,\n    .with-nav-tabs.panel-info .nav-tabs>li.active>a:hover,\n    .with-nav-tabs.panel-info .nav-tabs>li.active>a:focus {\n        color: #31708f;\n        background-color: #fff;\n        border-color: #bce8f1;\n        border-bottom-color: transparent;\n    }\n\n    .with-nav-tabs.panel-info .nav-tabs>li.dropdown .dropdown-menu {\n        background-color: #d9edf7;\n        border-color: #bce8f1;\n    }\n\n    .with-nav-tabs.panel-info .nav-tabs>li.dropdown .dropdown-menu>li>a {\n        color: #31708f;\n    }\n\n    .with-nav-tabs.panel-info .nav-tabs>li.dropdown .dropdown-menu>li>a:hover,\n    .with-nav-tabs.panel-info .nav-tabs>li.dropdown .dropdown-menu>li>a:focus {\n        background-color: #bce8f1;\n    }\n\n    .with-nav-tabs.panel-info .nav-tabs>li.dropdown .dropdown-menu>.active>a,\n    .with-nav-tabs.panel-info .nav-tabs>li.dropdown .dropdown-menu>.active>a:hover,\n    .with-nav-tabs.panel-info .nav-tabs>li.dropdown .dropdown-menu>.active>a:focus {\n        color: #fff;\n        background-color: #31708f;\n    }\n\n    /********************************************************************/\n\n    /*** PANEL WARNING ***/\n\n    .with-nav-tabs.panel-warning .nav-tabs>li>a,\n    .with-nav-tabs.panel-warning .nav-tabs>li>a:hover,\n    .with-nav-tabs.panel-warning .nav-tabs>li>a:focus {\n        color: #8a6d3b;\n    }\n\n    .with-nav-tabs.panel-warning .nav-tabs>.open>a,\n    .with-nav-tabs.panel-warning .nav-tabs>.open>a:hover,\n    .with-nav-tabs.panel-warning .nav-tabs>.open>a:focus,\n    .with-nav-tabs.panel-warning .nav-tabs>li>a:hover,\n    .with-nav-tabs.panel-warning .nav-tabs>li>a:focus {\n        color: #8a6d3b;\n        background-color: #faebcc;\n        border-color: transparent;\n    }\n\n    .with-nav-tabs.panel-warning .nav-tabs>li.active>a,\n    .with-nav-tabs.panel-warning .nav-tabs>li.active>a:hover,\n    .with-nav-tabs.panel-warning .nav-tabs>li.active>a:focus {\n        color: #8a6d3b;\n        background-color: #fff;\n        border-color: #faebcc;\n        border-bottom-color: transparent;\n    }\n\n    .with-nav-tabs.panel-warning .nav-tabs>li.dropdown .dropdown-menu {\n        background-color: #fcf8e3;\n        border-color: #faebcc;\n    }\n\n    .with-nav-tabs.panel-warning .nav-tabs>li.dropdown .dropdown-menu>li>a {\n        color: #8a6d3b;\n    }\n\n    .with-nav-tabs.panel-warning .nav-tabs>li.dropdown .dropdown-menu>li>a:hover,\n    .with-nav-tabs.panel-warning .nav-tabs>li.dropdown .dropdown-menu>li>a:focus {\n        background-color: #faebcc;\n    }\n\n    .with-nav-tabs.panel-warning .nav-tabs>li.dropdown .dropdown-menu>.active>a,\n    .with-nav-tabs.panel-warning .nav-tabs>li.dropdown .dropdown-menu>.active>a:hover,\n    .with-nav-tabs.panel-warning .nav-tabs>li.dropdown .dropdown-menu>.active>a:focus {\n        color: #fff;\n        background-color: #8a6d3b;\n    }\n\n    /********************************************************************/\n\n    /*** PANEL DANGER ***/\n\n    .with-nav-tabs.panel-danger .nav-tabs>li>a,\n    .with-nav-tabs.panel-danger .nav-tabs>li>a:hover,\n    .with-nav-tabs.panel-danger .nav-tabs>li>a:focus {\n        color: #a94442;\n    }\n\n    .with-nav-tabs.panel-danger .nav-tabs>.open>a,\n    .with-nav-tabs.panel-danger .nav-tabs>.open>a:hover,\n    .with-nav-tabs.panel-danger .nav-tabs>.open>a:focus,\n    .with-nav-tabs.panel-danger .nav-tabs>li>a:hover,\n    .with-nav-tabs.panel-danger .nav-tabs>li>a:focus {\n        color: #a94442;\n        background-color: #ebccd1;\n        border-color: transparent;\n    }\n\n    .with-nav-tabs.panel-danger .nav-tabs>li.active>a,\n    .with-nav-tabs.panel-danger .nav-tabs>li.active>a:hover,\n    .with-nav-tabs.panel-danger .nav-tabs>li.active>a:focus {\n        color: #a94442;\n        background-color: #fff;\n        border-color: #ebccd1;\n        border-bottom-color: transparent;\n    }\n\n    .with-nav-tabs.panel-danger .nav-tabs>li.dropdown .dropdown-menu {\n        background-color: #f2dede;\n        /* bg color */\n        border-color: #ebccd1;\n        /* border color */\n    }\n\n    .with-nav-tabs.panel-danger .nav-tabs>li.dropdown .dropdown-menu>li>a {\n        color: #a94442;\n        /* normal text color */\n    }\n\n    .with-nav-tabs.panel-danger .nav-tabs>li.dropdown .dropdown-menu>li>a:hover,\n    .with-nav-tabs.panel-danger .nav-tabs>li.dropdown .dropdown-menu>li>a:focus {\n        background-color: #ebccd1;\n        /* hover bg color */\n    }\n\n    .with-nav-tabs.panel-danger .nav-tabs>li.dropdown .dropdown-menu>.active>a,\n    .with-nav-tabs.panel-danger .nav-tabs>li.dropdown .dropdown-menu>.active>a:hover,\n    .with-nav-tabs.panel-danger .nav-tabs>li.dropdown .dropdown-menu>.active>a:focus {\n        color: #fff;\n        /* active text color */\n        background-color: #a94442;\n        /* active bg color */\n    }\n\n    .favButtonShow {\n        padding-bottom: 10px;\n        padding-left: 20px;\n        padding-top: 17px !important;\n        margin: 0px;\n        margin-top: -5px !important;\n        padding-top: 0px;\n        border-left: 1px solid #EDEDED;\n        border-right: 1px solid #EDEDED;\n        border-bottom: 1px solid #EDEDED;\n    }\n\n    .textMarkAddressFav {\n        color: #7ed321;\n        padding-top: 10px;\n        font-size: 16px;\n        font-weight: bold;\n    }\n\n    .crossButton {\n        font-size: 14px;\n        color: grey;\n        display: flex;\n        direction: rtl;\n        margin-right: 5px;\n        margin-bottom: 2px;\n        color: darkgrey;\n    }\n\n    .tableHeader {\n        font-size: 18px;\n        color: #F17F3A;\n        font-weight: bold;\n        margin-left: 7px;\n    }\n\n    .addressLength {\n        color: #F17F3A;\n        font-weight: bold;\n    }\n\n    .focusInput:focus {\n        border: 1px solid #F17F3A;\n    }\n\n    .newTableClass {\n        background-color: white;\n        color: #7ed321\n    }\n\n    button#DisabledButton:disabled {\n        background: none;\n        color: #afa8a8;\n        border-color: #dad7d7;\n    }\n\n    .panel-default>.panel-heading {\n        background-color: #FBFBFB;\n    }\n\n    .with-nav-tabs.panel-default .nav-tabs>li.active>a>hr {\n        /* margin-top: 20px; */\n        /* margin-bottom: 20px; */\n        border: 0;\n        width: 30px;\n        border-top: 2px solid #F17F3A;\n        margin-top: 5px;\n        margin-bottom: 0px;\n    }\n\n    .with-nav-tabs.panel-default .nav-tabs>li>a>hr {\n        border: 0;\n        width: 30px;\n        /* border-top: 2px solid #F17F3A; */\n        margin-top: 5px;\n        margin-bottom: 0px;\n    }\n\n    .with-nav-tabs.panel-default .nav-tabs>li.active>a>hr.PtoP {\n        /* margin-top: 20px; */\n        /* margin-bottom: 20px; */\n        border: 0;\n        width: 30px;\n        border-top: 2px solid #F17F3A;\n        margin-top: 5px;\n        margin-bottom: 0px;\n    }\n\n    @media only screen and (max-width: 600px) {\n        .with-nav-tabs.panel-default .nav-tabs>li.active>a {\n            font-size: 9px !important;\n        }\n        .with-nav-tabs.panel-default .nav-tabs>li>a {\n            font-size: 9px !important;\n        }\n    }\n\n    @media only screen and (min-width: 600px) {\n        .with-nav-tabs.panel-default .nav-tabs>li.active>a {\n            font-size: 16px !important;\n        }\n        .with-nav-tabs.panel-default .nav-tabs>li>a {\n            font-size: 16px !important;\n        }\n        #pointToPoint {\n            width: 28.33% !important;\n            text-align: center;\n        }\n    }\n\n    @media only screen and (min-width: 768px) {\n        .with-nav-tabs.panel-default .nav-tabs>li.active>a {\n            font-size: 8px !important;\n        }\n        .with-nav-tabs.panel-default .nav-tabs>li>a {\n            font-size: 8px !important;\n        }\n        #pointToPoint {\n            width: 28.33% !important;\n            text-align: center;\n        }\n    }\n\n    @media only screen and (min-width: 900px) {\n        .with-nav-tabs.panel-default .nav-tabs>li.active>a {\n            font-size: 11px !important;\n        }\n        .with-nav-tabs.panel-default .nav-tabs>li>a {\n            font-size: 11px !important;\n        }\n        #pointToPoint {\n            width: 28.33% !important;\n            text-align: center;\n        }\n    }\n\n    @media only screen and (min-width: 1100px) {\n        .with-nav-tabs.panel-default .nav-tabs>li.active>a {\n            font-size: 14px !important;\n        }\n        .with-nav-tabs.panel-default .nav-tabs>li>a {\n            font-size: 14px !important;\n        }\n    }\n\n    #pointToPoint {\n        width: 33.33%;\n        text-align: center;\n    }\n\n    #toAirport {\n        width: 33.33%;\n        text-align: center;\n    }\n\n    #fromAirport {\n        width: 33.33%;\n        text-align: center;\n    }</style>");
$templateCache.put("app/components/views/create-booking/createBookingMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/create-booking-here-maps/createBookingHereMaps.html","<h2 class=ng-cloak><span data-testid=createBookingHereMaps ng-if=!vm.dataToFill.bookingId>{{\'createBookingHereMaps\' | translate}}</span> <span data-testid=modifyBookingHead ng-if=vm.dataToFill.bookingId>{{\'modifyBookingHead\' | translate}}</span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><form name=createBookingForm ng-submit=\"submit=true;createBookingForm.$valid&&vm.createBookingByPass($event , false , true);vm.CreateBookingNew(createBookingForm , $event)\" novalidate autocomplete=off><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 paddingZero\"><div class=row><div data-testid=passenegerRequireAuth class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" ng-if=\"vm.dataToFill.authRequired == \'1\'\" style=color:red;font-size:14px>{{\'passenegerRequireAuth\' | translate}}</div><div data-testid=onErrorPickDrop data-testid=onclickErrorPickDrop class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" ng-if=vm.onclickErrorPickDrop style=color:red;font-size:14px>{{vm.onclickErrorPickDrop}}</div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><span data-testid=profile_pic_thumb ng-if=vm.dataToFill.customerMobile.profile_pic_thumb><img ng-src={{vm.dataToFill.customerMobile.profile_pic_thumb}} style=height:75px> </span><span data-testid=vipCustomer class=pull-right ng-if=\"vm.dataToFill.is_vip && vm.dataToFill.is_vip == 1\"><p class=vipCustomer>VIP</p></span></div></div><div class=\"row mt5\" ng-hide=vm.newCustomerFlag><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label data-testid=\"\" class=control-label>{{\'searchCustLabel\' | translate}} <span style=color:red>*</span></label><input data-testid=searchCustLabel ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) maxlength=80 type=text ng-model=vm.dataToFill.customerMobile placeholder=\"{{\'searchCustLabel\' | translate}}\" uib-typeahead=\"customers as customers.name for customers in vm.searchCustomer($viewValue)\" typeahead-loading=loadingCustomers typeahead-no-results=noResults class=\"form-control createBookingSelect\" name=searchCustomer typeahead-on-select=vm.onSelectingCustomer() typeahead-wait-ms=600 typeahead-template-url=customTemplate.html required ng-class=\"{ \'has-error\': createBookingForm.searchCustomer.$touched && createBookingForm.searchCustomer.$invalid }\"><!--vm.allCustomersList--> <i ng-if=loadingCustomers class=\"glyphicon glyphicon-refresh\"></i><div ng-if=\"noResults && vm.dataToFill.customerMobile.length > 3\" class=mt5><span><i class=\"glyphicon glyphicon-remove\"></i> {{\'searchCustError\' | translate}}</span> <span class=pull-right><a class=\"btn btn-primary tableButton\" ng-click=vm.addNewCustomer()>{{\'searchCustAddUser\' | translate}}</a></span></div><div data-testid=searchCustReq ng-if=\"createBookingForm.searchCustomer.$touched|| submit\" ng-messages=createBookingForm.searchCustomer.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'searchCustReq\' | translate}}</div></div></div></div><div class=\"row mt5\" ng-if=vm.newCustomerFlag><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label data-testid=custFirstNameLabel class=control-label>{{\'custFirstName\' | translate}} <span style=color:red>*</span></label><input data-testid=custFirstNameInput type=text ng-model=vm.dataToFill.first_name placeholder=\"{{\'custFirstName\' | translate}}\" class=form-control pattern=^\\D*$ ng-maxlength=60 ng-minlength=3 name=customerFirstName required ng-class=\"{ \'has-error\': createBookingForm.customerFirstName.$touched && createBookingForm.customerFirstName.$invalid }\"><div ng-if=\"createBookingForm.customerFirstName.$touched|| submit\" ng-messages=createBookingForm.customerFirstName.$error><div data-testid=custFirstNameReq class=\"errormessage text-danger\" ng-message=required>{{\'custFirstNameReq\' | translate}}</div><div data-testid=custFirstNameValid class=\"errormessage text-danger\" ng-message=pattern>{{\'custFirstNameValid\' | translate}}</div><div data-testid=firstNameMinimum class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div data-testid=businessNameMaximum class=\"errormessage text-danger\" ng-message=maxlength>{{\'businessNameMaximum\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label data-testid=custLastNameLabel class=control-label>{{\'custLastName\' | translate}} <span style=color:red>*</span></label><input type=text ng-model=vm.dataToFill.last_name placeholder=\"{{\'custLastName\' | translate}}\" class=form-control pattern=^\\D*$ ng-maxlength=60 ng-minlength=3 name=customerLastName required ng-class=\"{ \'has-error\': createBookingForm.customerLastName.$touched && createBookingForm.customerLastName.$invalid }\"><div ng-if=\"createBookingForm.customerLastName.$touched|| submit\" ng-messages=createBookingForm.customerLastName.$error><div data-testid=custLastNameReq class=\"errormessage text-danger\" ng-message=required>{{\'custLastNameReq\' | translate}}</div><div data-testid=custLastNameValid class=\"errormessage text-danger\" ng-message=pattern>{{\'custLastNameValid\' | translate}}</div><div data-testid=firstNameMinimumLastName class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div data-testid=businessNameMaximumLastName class=\"errormessage text-danger\" ng-message=maxlength>{{\'businessNameMaximum\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label data-testid=custEmailLabel class=control-label>{{\'custEmail\' | translate}} <span style=color:red>*</span></label><input data-testid=custEmailInput type=text ng-model=vm.dataToFill.customerEmail placeholder=\"{{\'custEmail\' | translate}}\" class=form-control pattern=^([_a-zA-Z0-9-+]+)(\\.[_a-zA-Z0-9-+]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*\\.)+([a-zA-Z]{2,12})$ name=customerEmail ng-disabled=\"!vm.newCustomerFlag || vm.CheckBookingStatus(vm.bookingDetails)\" required ng-class=\"{ \'has-error\': createBookingForm.customerEmail.$touched && createBookingForm.customerEmail.$invalid }\"><div data-testid=\"\" ng-if=\"createBookingForm.customerEmail.$touched|| submit\" ng-messages=createBookingForm.customerEmail.$error><div data-testid=\"\" class=\"errormessage text-danger\" ng-message=required>{{\'custEmailReq\' | translate}}</div><div data-testid=\"\" class=\"errormessage text-danger\" ng-message=pattern>{{\'custEmailValid\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label data-testid=custMobileLabel class=control-label>{{\'custMobile\' | translate}} <span style=color:red>*</span></label><input data-testid=custMobileInput type=text ng-model=vm.dataToFill.customerMobileG placeholder=\"{{\'custMobile\' | translate}}\" class=form-control pattern=^([1-9]{1}[0-9]{8})*$ ng-minlength=9 ng-maxlength=9 name=customerMobileG required ng-disabled=\"vm.makePhoneEditAble || vm.CheckBookingStatus(vm.bookingDetails)\" ng-class=\"{ \'has-error\': createBookingForm.customerMobileG.$touched && createBookingForm.customerMobileG.$invalid }\"><!--ng-disabled=\"!vm.newCustomerFlag\"--><div ng-if=\"createBookingForm.customerMobileG.$touched|| submit\" ng-messages=createBookingForm.customerMobileG.$error><div data-testid=custMobileReqError class=\"errormessage text-danger\" ng-message=required>{{\'custMobileReq\' | translate}}</div><div data-testid=custMobileValidMsg class=\"errormessage text-danger\" ng-message=pattern>{{\'custMobileValid\' | translate}}</div><div data-testid=custMobileValidMsg class=\"errormessage text-danger\" ng-message=minlength>{{\'custMobileValid\' | translate}}</div><div data-testid=custMobileValidMsg class=\"errormessage text-danger\" ng-message=maxlength>{{\'custMobileValid\' | translate}}</div></div></div></div><!--<div class=\"row mt5\" ng-if=\"vm.newCustomerFlag\">--><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">{{\'passwordPlaceholder\' | translate}}<span style=\"color:red\">*</span></label>--><!--<input type=\"password\" class=\"form-control\" ng-model=\"vm.dataToFill.password\"--><!--name=\"password\" placeholder=\"{{\'passwordPlaceholder\' | translate}}\"--><!--required ng-minlength=\"8\" ng-maxlength=\"16\"  ng-change=\"vm.matchPasswordAgain(vm.dataToFill.password)\"--><!--ng-class=\"{ \'has-error\': createBookingForm.password.$touched && createBookingForm.password.$invalid }\"/>--><!--<div ng-if=\"createBookingForm.password.$touched|| submit\"--><!--ng-messages=\"createBookingForm.password.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">{{\'passwordRequired\' | translate}}--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"minlength\">{{\'passwordMin\' | translate}}--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"maxlength\">{{\'passwordMax\' | translate}}--><!--</div>--><!--&lt;!&ndash;<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid country code.</div>&ndash;&gt;--><!--</div>--><!--</div>--><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">{{\'ConfirmPasswordPlaceholder\' | translate}}<span--><!--style=\"color:red\">*</span></label>--><!--<input type=\"password\" class=\"form-control\"--><!--ng-model=\"vm.dataToFill.confirmPassword\" name=\"confirmPassword\"--><!--placeholder=\"{{\'ConfirmPasswordPlaceholder\' | translate}}\" required ng-minlength=\"8\"--><!--ng-maxlength=\"16\"--><!--ng-class=\"{ \'has-error\': createBookingForm.confirmPassword.$touched && createBookingForm.confirmPassword.$invalid }\"--><!--ng-change=\"vm.matchPassword(vm.dataToFill.confirmPassword)\"/>--><!--<div ng-if=\"createBookingForm.confirmPassword.$touched|| submit\"--><!--ng-messages=\"createBookingForm.confirmPassword.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">{{\'confirmPasswordRequired\' | translate}}--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"minlength\">{{\'passwordMin\' | translate}}--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"maxlength\">{{\'passwordMax\' | translate}}--><!--</div>--><!--&lt;!&ndash;<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid mobile number.</div>&ndash;&gt;--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-show=\"vm.passwordMatchFlag\">{{\'passwordNotMatch\' | translate}}--><!--</div>--><!--</div>--><!--</div>--><div class=\"row mtb20\" ng-if=\"vm.userType == 0\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12 text-center\"><label class=control-label style=\"font-size:16px !important\"><input data-testid=personalService type=radio ng-disabled=\"vm.disableAgreementService == true || vm.CheckBookingStatus(vm.bookingDetails)\" ng-model=vm.dataToFill.customerProfile ng-change=vm.profileChanges() value=0 name=profile>&nbsp;&nbsp;Personal</label></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label style=\"font-size:16px !important\"><input data-testid=corporateService type=radio ng-disabled=\"vm.disableAgreementService == true || vm.CheckBookingStatus(vm.bookingDetails)\" ng-model=vm.dataToFill.customerProfile ng-change=vm.profileChanges() value=1 name=profile>&nbsp;&nbsp;Corporate</label></div></div><div class=\"row mt5\" ng-if=\"vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == \'1\'\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label data-testid=selectAgreement class=control-label>{{\'selectAgreement\' | translate}} <span style=color:red>*</span></label><select data-testid=selectAgreement2 ng-disabled=\"vm.disableAgreementService == true || vm.CheckBookingStatus(vm.bookingDetails)\" class=form-control ng-model=vm.dataToFill.contractIdSelected name=agreement ng-change=vm.agreementTypeChanged() required ng-class=\"{ \'has-error\': createBookingForm.agreement.$touched && createBookingForm.agreement.$invalid }\" ng-options=\"data.id as data.name for data in vm.dataToFill.contractListShowing\"><option value=\"\" selected disabled>{{\'selectAgreement\' | translate}}</option></select><div data-testid=selectAgreementReqMsg ng-if=\"createBookingForm.agreement.$touched|| submit\" ng-messages=createBookingForm.agreement.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'selectAgreementReq\' | translate}}</div></div></div><div data-testid=addEndowmentBtn class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=\"vm.dataToFill.customerProfile == \'1\' || vm.dataToFill.customerProfile == 1\"><label class=control-label style=\"visibility: hidden\">{{\'selectAgreement\' | translate}}</label><button ng-disabled=\"vm.disableAgreementService == true || vm.CheckBookingStatus(vm.bookingDetails)\" class=\"btn btn-primary endowmentButton\" type=button style=padding:5px ng-click=vm.addEndowment($event)>{{\'addEndowmentButton\' | translate}}</button></div></div><div class=\"row mt5\"><div data-testid=authNameLabel class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=\"vm.dataToFill.authRequired == \'1\'\"><label class=control-label>{{\'authName\' | translate}} <span style=color:red>*</span></label><!--<input type=\"text\" ng-model=\"vm.dataToFill.authRUT\" placeholder=\"Authorizer RUT\"--><!--ng-rut ng-change=\"vm.rutChange()\" class=\"form-control\" name=\"authRUT\"--><!--required--><!--ng-class=\"{ \'has-error\': createBookingForm.authRUT.$touched && createBookingForm.authRUT.$invalid }\"--><!--readonly>--> <input data-testid=bookingStatusName ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text ng-model=vm.dataToFill.authName placeholder=\"{{\'authName\' | translate}}\" class=form-control name=authName required ng-class=\"{ \'has-error\': createBookingForm.authName.$touched && createBookingForm.authName.$invalid }\" readonly><div ng-if=\"createBookingForm.authName.$touched|| submit\" ng-messages=createBookingForm.authName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'authNameR\' | translate}}</div></div><!--<div class=\"errormessage text-danger\" ng-show=\"vm.dataToFill.rutFlag\">Please--><!--enter a valid authorizer RUT.--><!--</div>--></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=\"vm.dataToFill.customerProfile == \'0\' || vm.dataToFill.customerProfile == \'1\'\"><label data-testid=serviceLabel class=control-label>{{\'serviceLabel\' | translate}} <span style=color:red>*</span></label><select data-testid=selectTServiceDropDown ng-disabled=\"vm.disableAgreementService == true || vm.CheckBookingStatus(vm.bookingDetails)\" class=form-control ng-model=vm.dataToFill.serviceTypeSelected name=typeOfService ng-change=vm.serviceTypeChanged() ng-disabled=\"vm.serviceTypeList.length == 0\" required ng-class=\"{ \'has-error\': createBookingForm.typeOfService.$touched && createBookingForm.typeOfService.$invalid }\" ng-options=\"data.id as data.service_name for data in vm.serviceTypeList\"><option value=\"\" selected disabled>{{\'selectTService\' | translate}}</option></select><div data-testid=errorMessageTypeOfService ng-if=\"createBookingForm.typeOfService.$touched|| submit\" ng-messages=createBookingForm.typeOfService.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'serviceReq\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'passengersCount\' | translate}} <span style=color:red>*</span></label><input ng-disabled=\"vm.disabledNumberOfpassengerByCount == true || vm.CheckBookingStatus(vm.bookingDetails)\" type=text data-testid=numero_pasajeros ng-model=vm.dataToFill.passengerCount placeholder=\"{{\'passengersCount\' | translate}}\" class=form-control name=passengerCount ng-change=vm.numberOfPassenger(vm.dataToFill.passengerCount) required ng-class=\"{ \'has-error\': createBookingForm.passengerCount.$touched && createBookingForm.passengerCount.$invalid }\" pattern=^[0-9][0-9]*$ ng-disabled=!vm.dataToFill.serviceTypeSelected><div ng-if=\"createBookingForm.passengerCount.$touched|| submit\" ng-messages=createBookingForm.passengerCount.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'noOfPassengerReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'noOfPassengerValid\' | translate}}</div></div><div class=\"errormessage text-danger\" ng-if=vm.dataToFill.numberOfPassengerError>{{\'maximum\' | translate}} {{vm.dataToFill.numberOfPassengerCount}} {{\'passengerAllowed\' | translate}}</div></div></div><div class=\"row mt5\"><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label class=\"control-label\">{{\'custProfile\' | translate}}<span--><!--style=\"color:red\">*</span></label>--><!--<select class=\"form-control\" ng-model=\"vm.dataToFill.customerProfile\"--><!--name=\"customerProfile\" ng-change=\"vm.profileChanges()\"--><!--required--><!--ng-class=\"{ \'has-error\': createBookingForm.customerProfile.$touched && createBookingForm.customerProfile.$invalid }\"--><!--ng-disabled=\"vm.makePhoneEditAble\"--><!--ng-options=\"data.value as data.name for data in vm.customerProfileOption\">&lt;!&ndash;!vm.dataToFill.customerMobileG && !vm.newCustomerFlag&ndash;&gt;--><!--<option value=\"\" selected disabled>{{\'custProfilePlaceholder\' | translate}}</option>--><!--&lt;!&ndash;<option value=\"0\">Personal Profile</option>&ndash;&gt;--><!--&lt;!&ndash;<option value=\"1\">Corporate Profile</option>&ndash;&gt;--><!--</select>--><!--<div ng-if=\"createBookingForm.customerProfile.$touched|| submit\"--><!--ng-messages=\"createBookingForm.customerProfile.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">{{\'custProfileReq\' | translate}}--><!--</div>--><!--</div>--><!--</div>--><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=\"vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == \'1\'\"><label class=control-label>{{\'bookingType\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.bookingType ng-disabled=\"!vm.dataToFill.serviceTypeSelected || vm.CheckBookingStatus(vm.bookingDetails)\" data-testid=tipo_reserva name=bookingType required ng-class=\"{ \'has-error\': createBookingForm.bookingType.$touched && createBookingForm.bookingType.$invalid }\" ng-change=vm.bookingType() ng-options=\"data.value as data.name for data in vm.bookingTypeOptions\"><option value=\"\" selected disabled>{{\'bookingTypePlaceholder\' | translate}}</option></select><div ng-if=\"createBookingForm.bookingType.$touched|| submit\" ng-messages=createBookingForm.bookingType.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'bookingTypeReq\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=\"vm.dataToFill.customerProfile == 0 || vm.dataToFill.customerProfile == \'0\' || vm.dataToFill.customerProfile == null || vm.dataToFill.customerProfile == undefined\"><label class=control-label>{{\'bookingType\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.bookingType ng-disabled=\"!vm.dataToFill.serviceTypeSelected || vm.CheckBookingStatus(vm.bookingDetails)\" data-testid=tipo_reserva name=bookingType required ng-class=\"{ \'has-error\': createBookingForm.bookingType.$touched && createBookingForm.bookingType.$invalid }\" ng-change=vm.bookingType() ng-options=\"data.value as data.name for data in vm.bookingTypeOptions\"><option value=\"\" selected disabled>{{\'bookingTypePlaceholder\' | translate}}</option></select><div ng-if=\"createBookingForm.bookingType.$touched|| submit\" ng-messages=createBookingForm.bookingType.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'bookingTypeReq\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><!-- <input  type=\"checkbox\"  > --><label class=control-label><!-- <span style=\"color:red\">*</span> --></label><div class=newCheckbox ng-if=vm.funcationif()><input type=checkbox style=zoom:2.3 ng-checked=vm.checkBoxValueIs ng-disabled=\"vm.CheckBookingStatus(vm.bookingDetails) || vm.modifyFalg\" data-testid=reserva_respaldo ng-model=vm.checkBoxValueIs ng-click=vm.checkBoxValue(vm.checkBoxValueIs)> <span style=\"font-size: 16px;padding-top: 3px;padding-left: 10px\">Reserva sin Respaldo</span></div></div></div><div class=\"row mt5\"><div class=\"col-lg-5 col-sm-5 col-md-5 col-xs-12\" ng-if=\"vm.dataToFill.scheduledBooking == 1 && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2) && !(vm.routingBase && vm.routingBase.routing_base_id > 0)\"><label ng-if=\"vm.dataToFill.scheduledBooking == 1 && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2) && vm.type_of_trip_Validate_Booking == \'Z\'\">Fecha Salida Desde Aeropuerto <span style=color:red>*</span></label><label ng-if=\"vm.dataToFill.scheduledBooking == 1 && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2) && vm.type_of_trip_Validate_Booking == \'P\'\">{{(vm.routingBase && vm.routingBase.routing_base_id > 0)?\'Fecha De Llegada\':(\'scheduleDate\' | translate)}} <span style=color:red>*</span></label><label ng-if=\"vm.dataToFill.scheduledBooking == 1 && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2) && (vm.type_of_trip_Validate_Booking == \'R\' ||  !vm.type_of_trip_Validate_Booking)\">{{(vm.routingBase && vm.routingBase.routing_base_id > 0)?\'Fecha De Llegada\':\'Fecha Recogida\'}} <span style=color:red>*</span></label><p class=input-group><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text id=datePickerPickup class=form-control uib-datepicker-popup={{vm.format}} data-testid=fecha_reserva name=scheduledDate ng-model=vm.dataToFill.scheduledDate placeholder=\"{{\'scheduleDate\' | translate}}\" is-open=vm.datePicker_1.scheduledDate datepicker-options=vm.dateOptions required ng-class=\"{ \'has-error\': createBookingForm.scheduledDate.$touched && createBookingForm.scheduledDate.$invalid }\" ng-change=\"vm.scheduleDateChanged(); vm.compareDates()\" close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly> <span class=input-group-btn><button ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'1\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"createBookingForm.scheduledDate.$touched|| submit\" ng-messages=createBookingForm.scheduledDate.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'scheduleDateReq\' | translate}}</div></div></div><div class=\"col-lg-7 col-sm-7 col-md-7 col-xs-12\" ng-if=\"vm.dataToFill.scheduledBooking == 1 && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2) && !(vm.routingBase && vm.routingBase.routing_base_id > 0)\"><div style=\"display: inline-flex;width:100%\"><div><label ng-if=\"vm.dataToFill.scheduledBooking == 1 && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2) && vm.type_of_trip_Validate_Booking == \'P\'\">{{(vm.routingBase && vm.routingBase.routing_base_id > 0)?\'Hora De Llegada\':(\'scheduleTime\' | translate)}} <span style=color:red>*</span></label><label ng-if=\"vm.dataToFill.scheduledBooking == 1 && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2) && vm.type_of_trip_Validate_Booking == \'Z\'\">Hora Salida Desde Aeropuerto <span style=color:red>*</span></label><label ng-if=\"vm.dataToFill.scheduledBooking == 1 && (vm.dataToFill.selectedServiceDetails.category == 0 || vm.dataToFill.selectedServiceDetails.category == 2) && (vm.type_of_trip_Validate_Booking == \'R\' || !vm.type_of_trip_Validate_Booking)\">{{(vm.routingBase && vm.routingBase.routing_base_id > 0)?\'Hora De Llegada\':(\'scheduleTime\' | translate)}} <span style=color:red>*</span></label><div ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) uib-timepicker ng-model=vm.dataToFill.scheduledTime show-spinners=false ng-model-options=\"{ debounce: 0 }\" data-testid=hora_reserva mousewheel=false arrowkeys=false ng-change=vm.scheduleTimeChanged() hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian></div><div ng-if=\"createBookingForm.scheduledDate.$touched|| submit\" ng-messages=createBookingForm.scheduledDate.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'scheduleTimeReq\' | translate}}</div></div></div><div style=padding-left:15px ng-if=\"(vm.dataToFill.dropDate != \'\' && vm.dataToFill.selectedServiceDetails.category == 0 && (vm.type_of_trip_Validate_Booking == \'P\'|| vm.type_of_trip_Validate_Booking == \'R\' )) || (vm.routingBase && vm.routingBase.routing_base_id > 0) \" data-testid=hora_estimada><div class=etaDiv style=font-size:14px><p>Hora de Retiro Estimada:<br><span style=\"font-weight: bold\" ng-if=\"vm.type_of_trip_Validate_Booking == \'P\'\">({{vm.ptoptravelTime | date:\'HH:mm\'}} <span ng-if=\"vm.time_trip_shared_service_point_to_point > 0 &&  vm.is_group_external == 0\">- {{vm.rangeOfPointToPoint | date:\'HH:mm\'}} </span>hrs)</span> <span style=\"font-weight: bold\" ng-if=\"vm.type_of_trip_Validate_Booking == \'R\'\">({{vm.pickRangeForRType | date:\'HH:mm\'}} <span ng-if=\"vm.tolerance_time_withdrawal_pickup > 0\">- {{vm.pickRangeForEstimated | date:\'HH:mm\'}} </span>hrs)</span></p></div><div class=etaDiv style=font-size:14px ng-if=\"vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat && vm.type_of_trip_Validate_Booking == \'P\'\"><p>ETA - {{vm.dataToFill.etaScheduleValue + vm.pickup_travel_time_pap || \'0\'}}mins</p></div><div class=etaDiv style=font-size:14px ng-if=\"vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat && vm.type_of_trip_Validate_Booking == \'R\'\"><p>ETA - {{vm.dataToFill.etaScheduleValue + vm.travel_time_service_pick_up || \'0\'}}mins</p></div></div><!--<div style=\"padding-left:15px;\" ng-show=\"(vm.dataToFill.scheduledDate != \'\' && vm.dataToFill.scheduledTime != \'\') &&  (vm.dataToFill.selectedServiceDetails.category == 0) && --><!--( vm.type_of_trip_Validate_Booking == \'R\') && ( vm.pickRangeForEstimated)\">--><!--<div class=\"etaDiv\" style=\"font-size:14px;\">--><!--<p>Hora Recogida Estimada:--><!--<br> {{ vm.pickRangeForRType | date:\'HH:mm\'}}--><!--<span ng-if=\"vm.tolerance_time_withdrawal_pickup > 0 &&  vm.is_group_external == 0\"> - {{vm.pickRangeForEstimated | date:\'HH:mm\'}} </span> hrs</p>--><!--</div>--><!--<div class=\"etaDiv\" style=\"font-size:14px;\">--><!--[> <p ng-if=\"vm.dataToFill.selectedServiceDetails.category != 1\">ETA - {{vm.dataToFill.etaSchedule || \'0 min\'}}</p> <]--><!--<p>ETA - {{vm.dataToFill.etaScheduleValue + vm.travel_time_service_pick_up--><!--|| \'0\'}}mins</p>--><!--</div>--><!--</div>--></div></div><div class=\"col-lg-4 col-sm-4 col-md-6 col-xs-12\" ng-if=\"vm.dataToFill.selectedServiceDetails.category == 1 || (vm.routingBase && vm.routingBase.routing_base_id > 0)\"><label ng-if=\"vm.type_of_trip_Validate_Booking == \'Z\'\">Fecha Salida Desde Aeropuerto <span style=color:red>*</span></label><label ng-if=\"vm.type_of_trip_Validate_Booking != \'Z\'\">{{vm.routingBase && vm.routingBase.routing_base_id > 0?\'Fecha De Llegada\':\'Fecha Presentación\'}} <span style=color:red>*</span></label><p class=input-group><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text class=form-control uib-datepicker-popup={{vm.format}} data-testid=fecha_reserva name=dropDate ng-model=vm.dataToFill.dropDate placeholder=\"Drop Date\" is-open=vm.datePicker_1.dropDate datepicker-options=vm.dateOptions required ng-class=\"{ \'has-error\': createBookingForm.dropDate.$touched && createBookingForm.dropDate.$invalid }\" ng-change=\"vm.dropDateChanged(); vm.compareDates()\" close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly> <span class=input-group-btn><button ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'3\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"createBookingForm.dropDate.$touched|| submit\" ng-messages=createBookingForm.dropDate.$error><div class=\"errormessage text-danger\" ng-message=required>Please select drop date.</div></div></div><div class=\"col-lg-8 col-sm-8 col-md-6 col-xs-12\" ng-if=\"vm.dataToFill.selectedServiceDetails.category ==  1 || (vm.routingBase && vm.routingBase.routing_base_id > 0)\"><div style=\"display: inline-flex;width:100%\"><div><label ng-if=\"vm.type_of_trip_Validate_Booking == \'Z\'\">Hora Salida Desde Aeropuerto <span style=color:red>*</span></label><label ng-if=\"vm.type_of_trip_Validate_Booking != \'Z\'\">{{vm.routingBase && vm.routingBase.routing_base_id > 0?\'Hora De Llegada\':\'Hora Presentación\'}} <span style=color:red>*</span></label><div ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) uib-timepicker ng-model=vm.dataToFill.dropTime show-spinners=false ng-model-options=\"{ debounce: 0 }\" data-testid=hora_reserva mousewheel=false arrowkeys=false ng-change=vm.dropTimeChanged() hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian></div><div ng-if=\"createBookingForm.dropTime.$touched|| submit\" ng-messages=createBookingForm.dropTime.$error><div class=\"errormessage text-danger\" ng-message=required>Please enter drop time.</div></div></div><div style=padding-left:15px ng-if=\"(vm.dataToFill.dropDate != \'\' &&  vm.type_of_trip_Validate_Booking != \'P\') || (vm.type_of_trip_Validate_Booking == \'P\' && vm.routingBase && vm.routingBase.routing_base_id > 0)\" data-testid=hora_estimada><div class=etaDiv style=font-size:14px ng-if=\"vm.dataToFill.selectedServiceDetails.category == 1 && vm.pickRange1 && vm.pickRange2 && vm.dataToFill.airportCheck != \'Z\'  &&  !vm.method_range_pickup\"><p>Hora Retiro Estimada: <span ng-if=\"vm.showToleranceFlag == 0\">{{vm.pickRange3}}</span> <span ng-if=\"vm.showToleranceFlag != 0\"><br>{{vm.newPickRange3}} - {{vm.pickRange3ToShowAdd}}</span> hrs</p></div><div class=etaDiv style=font-size:14px ng-if=\"vm.dataToFill.selectedServiceDetails.category == 1 && vm.dataToFill.airportCheck == \'Z\'  &&  !vm.method_range_pickup\"><p>Hora Salida Desde Aeropuerto: {{vm.dataToFill.dropTime | date:\'HH:mm\'}} hrs</p></div><div class=etaDiv style=font-size:14px ng-show=\"((vm.dataToFill.bookingType == \'1\' || vm.dataToFill.bookingType == 1 || vm.dataToFill.airportCheck == \'Z\') && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) &&  !vm.method_range_pickup\"><p ng-if=\"vm.dataToFill.selectedServiceDetails.category != 1\">ETA - {{vm.dataToFill.etaSchedule || \'0 min\'}}</p><p ng-if=\"vm.dataToFill.selectedServiceDetails.category == 1\">ETA - {{vm.dataToFill.etaScheduleValue + vm.dataToFill.time_trip_shared_service || \'0\'}}mins</p></div><div class=etaDiv style=font-size:14px ng-if=\"(vm.dataToFill.selectedServiceDetails.category == 1 && vm.pickRange1 && vm.pickRange2 && vm.dataToFill.airportCheck != \'Z\'  &&  vm.method_range_pickup) || (vm.routingBase && vm.routingBase.routing_base_id > 0)\"><p>Hora Retiro Estimada: {{vm.pickRangeForRouting}} hrs</p></div><div class=etaDiv style=font-size:14px ng-show=\"((vm.dataToFill.bookingType == \'1\' || vm.dataToFill.bookingType == 1 || vm.dataToFill.airportCheck == \'Z\') && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) &&  vm.method_range_pickup\"><p>ETA - {{vm.dataToFill.etaSchedule || \'0 min\'}}</p></div></div></div></div><!-- <div class=\"col-lg-4 col-sm-4 col-md-6 col-xs-12\" ng-if=\"vm.dataToFill.bookingType == \'1\' && vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking == \'R\'\">\n                                        <label>Fecha Presentación\n                                            <span style=\"color:red\">*</span>\n                                        </label>\n                                        <p class=\"input-group\">\n                                            <input ng-disabled=\"vm.CheckBookingStatus(vm.bookingDetails)\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{vm.format}}\"\n                                                name=\"dropDate\" ng-model=\"vm.dataToFill.dropDateOfRType\" placeholder=\"Drop Date\"\n                                                is-open=\"vm.datePicker_1.dropDate\" datepicker-options=\"vm.dateOptions\" required\n                                                ng-class=\"{ \'has-error\': createBookingForm.dropDate.$touched && createBookingForm.dropDate.$invalid }\"\n                                                ng-change=\"vm.dropDateChanged(); vm.compareDates()\" close-text=\"Close\" alt-input-formats=\"vm.altInputFormats\"\n                                                show-button-bar=\"false\" readonly/>\n                                            <span class=\"input-group-btn\">\n                                                <button ng-disabled=\"vm.CheckBookingStatus(vm.bookingDetails)\" type=\"button\" class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'3\')\">\n                                                    <i class=\"glyphicon glyphicon-calendar\"></i>\n                                                </button>\n                                            </span>\n                                        </p>\n                                        <div ng-if=\"createBookingForm.dropDate.$touched|| submit\" ng-messages=\"createBookingForm.dropDate.$error\">\n                                            <div class=\"errormessage text-danger\" ng-message=\"required\">Please select drop date.\n                                            </div>\n                                        </div>\n                                    </div> --><!-- <div class=\"col-lg-8 col-sm-8 col-md-6 col-xs-12\" ng-if=\"vm.dataToFill.bookingType == \'1\' &&  vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking == \'R\'\">\n                                        <div style=\"display: inline-flex;width:100%;\">\n                                            <div>\n                                                <label>Hora Presentación\n                                                    <span style=\"color:red\">*</span>\n                                                </label>\n                                                <div ng-disabled=\"vm.CheckBookingStatus(vm.bookingDetails)\" uib-timepicker ng-model=\"vm.dataToFill.dropTimeOfRtype\" show-spinners=\"false\"\n                                                    mousewheel=\"false\" arrowkeys=\"false\" ng-change=\"vm.dropTimeChangedForRType()\" hour-step=\"vm.hstep\"\n                                                    minute-step=\"vm.mstep\" show-meridian=\"vm.ismeridian\"></div>\n                                                <div ng-if=\"createBookingForm.dropTime.$touched|| submit\" ng-messages=\"createBookingForm.dropTime.$error\">\n                                                    <div class=\"errormessage text-danger\" ng-message=\"required\">Please enter drop time.\n                                                    </div>\n                                                </div>\n                                            </div>\n                                             <div style=\"padding-left:15px;\" ng-if=\"vm.dataToFill.dropDate != \'\'\">\n                                                 <div class=\"etaDiv\" style=\"font-size:14px;\" ng-if=\"vm.dataToFill.selectedServiceDetails.category == 0 && vm.pickRange1 && vm.pickRange2 && vm.dataToFill.airportCheck != \'Z\'\">\n                                                    <p>Hora Retiro Estimada: {{vm.pickRange3}} hrs</p>\n                                                </div>\n                                                <div class=\"etaDiv\" style=\"font-size:14px;\" ng-if=\"vm.dataToFill.selectedServiceDetails.category == 0 && vm.dataToFill.airportCheck == \'Z\'\">\n                                                    <p>Hora Recogida Estimada: {{vm.dataToFill.dropDateOfRType | date:\'HH:mm\'}} hrs</p>\n                                                </div>\n                                                <div class=\"etaDiv\" style=\"font-size:14px;\" ng-show=\"(vm.dataToFill.bookingType == \'1\' || vm.dataToFill.bookingType == 1 || vm.dataToFill.airportCheck == \'Z\') && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat\">\n                                                    <p ng-if=\"vm.dataToFill.selectedServiceDetails.category != 1\">ETA - {{vm.dataToFill.etaSchedule || \'0 min\'}}</p>\n                                                    <p ng-if=\"vm.dataToFill.selectedServiceDetails.category == 1\">ETA - {{vm.dataToFill.etaScheduleValue + vm.dataToFill.time_trip_shared_service\n                                                        || \'0\'}}mins</p>\n                                                </div>\n                                                <div class=\"etaDiv\" style=\"font-size:14px;\">\n                                                    <p>Hora Recogida Estimada:\n                                                        <br> {{ vm.pickRangeForRType | date:\'HH:mm\'}} - {{vm.pickRangeForEstimated  | date:\'HH:mm\'}} hrs</p>\n                                                </div>\n                                                <div class=\"etaDiv\" style=\"font-size:14px;\" >\n                                                    <p ng-if=\"vm.dataToFill.selectedServiceDetails.category != 1\">ETA - {{vm.dataToFill.etaSchedule || \'0 min\'}}</p>\n                                                    <p>ETA - {{vm.dataToFill.etaScheduleValue + vm.travel_time_service_pick_up\n                                                        || \'0\'}}mins</p>\n                                                </div> \n                                            </div>\n                                        </div>\n                                    </div> --></div><div class=\"row mt5\" style=\"margin-bottom: 0px !important\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Seleccionar viaje <span style=color:red>*</span></label><div class=\"panel with-nav-tabs panel-default\" style=\"margin-bottom: 0px !important;margin-top: 3px\"><div class=panel-heading><ul class=\"nav nav-tabs\"><li id=toAirport class=\"active TabsBar\" ng-click=\"vm.forTabsView(1);vm.flagForPanel = true\" data-testid=btn_hacia_aeropuerto><a>Hacia Aeropuerto<hr></a></li><li id=fromAirport class=TabsBar ng-click=\"vm.forTabsView(2);vm.flagForPanel = true\" data-testid=btn_desde_aeropuerto><a href=tab2default data-toggle=tab>Desde Aeropuerto<hr></a></li><li id=pointToPoint class=TabsBar ng-click=\"vm.forTabsView(3);vm.flagForPanel = true\" data-testid=btn_punto_punto><a href=tab3default data-toggle=tab>Punto a Punto<hr class=PtoP></a></li></ul></div><div class=panel-body ng-if=\"vm.flagForPanel == true\"><div class=tab-content><div class=\"tab-pane fade in active\"><div class=\"row mt5\" ng-if=\"vm.toAirportFlag || vm.ptopAirportFlag\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label style=\"margin-bottom: 20px\">{{\'pickUpAddressB\' | translate}} <span style=color:red>*</span></label><div class=displayFlex><div ng-style=vm.favAddFlagI><i class=\"fa fa-times-circle crossButton\" ng-click=vm.pickUpAddressBlank() aria-hidden=true></i> <input style=\"margin-top: -27px\" ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text ng-model=vm.dataToFill.pickUpAddress data-testid=direccion_reserva_retiro placeholder=\"{{\'pickUpAddressB\' | translate}}\" class=\"form-control focusInput\" name=pickUpAddress id=pickUpAddress required ng-change=vm.PickUpAddressLength(vm.dataToFill.pickUpAddress) ng-class=\"{ \'has-error\': createBookingForm.pickUpAddress.$touched && createBookingForm.pickUpAddress.$invalid }\" ng-keyup=vm.pickUpaddressBlack(vm.dataToFill.pickUpAddress) ng-model-options=\"{ debounce: 500 }\" ng-click=vm.getPreviousAddressHit(1) ng-focus=vm.getPreviousAddressHit(1)><div style=\"background-color: white\" ng-if=\"vm.addressPickUpArray.length > 0\"><table class=\"table table-hover tableWithMasterData\"><thead></thead><tbody style=\"max-height: 250px\" data-testid=direccion_reserva_retiro_sugerencias><tr ng-click=vm.fillInAddress(data) ng-repeat=\"data in vm.addressPickUpArray | filter: vm.search\"><td style=\"width: 5px;text-align: left !important\"><i class=\"fa fa-map-marker\"></i></td><!-- <td style=\"text-align: left !important;\">{{data.title}}</td> --><td style=\"text-align: left !important\"><!-- <span ng-bind-html=\"data.highlightedTitle\"></span>\n                                                                                            <span ng-if=\"data.flag\">,</span>\n                                                                                            <span ng-if=\"data.flag && data.highlightedVicinity[1] != undefined\">{{data.highlightedVicinity[1]}}</span>\n                                                                                            <span ng-if=\"data.flag && data.highlightedVicinity[2] != undefined\">,{{data.highlightedVicinity[2]}}</span> --><!-- <span ng-if=\"data.type == 0\">{{data.full_address}}</span> --> <span>{{data.label}}</span></td></tr></tbody></table></div><div ng-if=vm.dataToFill.previousPickFlag style=\"margin-top:1px;width:149%;border: 1px solid #F17F3A;max-height: 260px;border-radius: 4px\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><img src=../../../../assets/images/Artboard.png style=\"top: -2px;position: relative\"> <span class=tableHeader>Direcciones recientes</span><div style=\"max-height: 200px; overflow-y: scroll\"><table class=\"table table-hover\" style=\"margin-top:20px;font-weight: 450;margin-left: 25px\"><tbody data-testid=direccion_reserva_retiro_recientes><tr ng-if=\"vm.previousAddressList.length != 0\" ng-repeat=\"previousAddress in vm.previousAddressList\"><td style=\"text-align: left !important\" ng-click=vm.selectPreviousAddress(previousAddress,1)>{{previousAddress.address}}</td></tr><tr ng-if=\"vm.previousAddressList.length == 0\"><td style=\"text-align: left !important\">{{\'noPreviousAddress\' | translate}}</td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noInvestorFound\' | translate}}</th></tr></tfoot></table></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><i class=\"fa fa-heart-o\" style=\"font-size:19px;color: #F17F3A;font-weight: bold\"></i> <span class=tableHeader>Direcciones favoritas</span><div style=\"max-height: 200px; overflow-y: scroll\"><table class=\"table table-hover\" style=\"margin-top:20px;margin-left: 25px\"><tbody data-testid=direccion_reserva_favoritas><tr ng-if=\"vm.favAddressList.length != 0\" ng-repeat=\"favAddress in vm.favAddressList\"><td style=\"text-align: left !important\" ng-click=vm.selectFavAddressNewPop(1,favAddress)><p><span style=\"font-weight: 600\">{{\'locationName\' | translate}}: </span>&nbsp;&nbsp; <span>{{favAddress.location_name != \"\" ? favAddress.location_name : \'--\'}}</span></p><p><span style=\"font-weight: 600\">Dirección:</span>&nbsp;&nbsp; <span>{{favAddress.address}}</span></p></td></tr><tr ng-if=\"vm.favAddressList.length == 0\"><td style=\"text-align: left !important\">No se encontró ninguna dirección favorita.</td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noInvestorFound\' | translate}}</th></tr></tfoot></table></div></div></div><!-- <div class=\"row\" ng-repeat=\"previousAddress in vm.previousAddressList\">\n                                                                                        <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"cursor: pointer;\" ng-click=\"vm.selectPreviousAddress(previousAddress,1)\">\n                                                                                            <p>{{previousAddress.address}}</p>\n                                                                                        </div>\n                                                                                        <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-if=\"$index != vm.previousAddressList.length - 1\">\n                                                                                            <hr/>\n                                                                                        </div>\n                                                                                    </div> --></div></div><!-- <div class=\"panel panel-default\" ng-if=\"vm.previousAddressList.length == 0\">\n                                                                                <div class=\"panel-body\">\n                                                                                    <div class=\"row\">\n                                                                                        <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">\n                                                                                            <p>{{\'noPreviousAddress\' | translate}}</p>\n                                                                                        </div>\n                                                                                    </div>\n                                                                                </div>\n\n                                                                            </div> --></div></div><div><i ng-click=vm.MarkfavouriteAddressPickUp(true) ng-if=\"(vm.dataToFill.pickUpLng && vm.dataToFill.pickUpLat) &&  (vm.isActivePick)\" data-testid=agregar_direccion_favorita class=\"fa fa-heart greenClass\" aria-hidden=true></i> <i ng-click=vm.MarkfavouriteAddressPickUp(false) ng-if=\"(vm.dataToFill.pickUpLng && vm.dataToFill.pickUpLat) && (!vm.isActivePick)\" data-testid=eliminar_direccion_favorita class=\"fa fa-heart-o whiteClass\" aria-hidden=true></i></div></div><div ng-if=\"createBookingForm.pickUpAddress.$touched|| submit\" ng-messages=createBookingForm.pickUpAddress.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'pickUpReq\' | translate}}</div></div></div></div><div class=\"row mt5\" ng-if=\"vm.fromAirportFlag || vm.ptopAirportFlag\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label style=\"margin-bottom: 20px\" class=control-label>{{\'dropOffAddressB\' | translate}} <span style=color:red>*</span></label><div class=displayFlex><div ng-style=vm.favAddFlagI><i class=\"fa fa-times-circle crossButton\" ng-click=vm.dropOffAddressBlank() aria-hidden=true></i> <input style=\"margin-top: -27px\" ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text ng-model=vm.dataToFill.dropOffAddress data-testid=direccion_reserva_detino placeholder=\"{{\'dropOffAddressB\' | translate}}\" class=\"form-control focusInput\" name=dropOffAddress id=dropOffAddress ng-change=vm.DropUpAddressLength(vm.dataToFill.dropOffAddress) required ng-class=\"{ \'has-error\': createBookingForm.dropOffAddress.$touched && createBookingForm.dropOffAddress.$invalid }\" ng-keyup=vm.dropOfdAddressBlack(vm.dataToFill.dropOffAddress) ng-model-options=\"{ debounce: 500 }\" ng-click=vm.getPreviousAddressHit(2) ng-focus=vm.getPreviousAddressHit(2)><div style=\"background-color: white\" ng-if=\"vm.addressDropArray.length > 0\"><table class=\"table table-hover tableWithMasterData\"><thead></thead><tbody style=\"max-height: 250px\" data-testid=direccion_reserva_destino_sugerencias><tr ng-click=vm.fillInAddressD(data) ng-repeat=\"data in vm.addressDropArray | filter: vm.search\"><td style=\"width: 5px;text-align: left !important\"><i class=\"fa fa-map-marker\"></i></td><td style=\"text-align: left !important\"><!-- <span ng-bind-html=\"data.highlightedTitle\"></span>\n                                                                                            <span ng-if=\"data.flag\">,</span>\n                                                                                            <span ng-if=\"data.flag && data.highlightedVicinity[1] != undefined\">{{data.highlightedVicinity[1]}}</span>\n                                                                                            <span ng-if=\"data.flag && data.highlightedVicinity[2] != undefined\">,{{data.highlightedVicinity[2]}}</span> --><!-- <span ng-if=\"data.type == 0\">{{data.full_address}}</span> --> <span>{{data.label}}</span></td><!-- <td style=\"text-align: left !important;\">{{data.title}}</td> --></tr></tbody></table></div><div ng-if=vm.dataToFill.previousDropFlag style=\"margin-top:1px;width:149%;border: 1px solid #F17F3A;max-height: 260px;border-radius: 4px\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><img src=../../../../assets/images/Artboard.png style=\"top: -2px;position: relative\"> <span class=tableHeader>Direcciones recientes</span><div style=\"max-height: 200px; overflow-y: scroll\"><table class=\"table table-hover\" style=\"margin-top:20px;font-weight: 450;;margin-left: 25px\"><tbody data-testid=direccion_reserva_destino_recientes><tr ng-if=\"vm.previousAddressList.length != 0\" ng-repeat=\"previousAddress in vm.previousAddressList\"><td style=\"text-align: left !important\" ng-click=vm.selectPreviousAddress(previousAddress,2)>{{previousAddress.address}}</td></tr><tr ng-if=\"vm.previousAddressList.length == 0\"><td style=\"text-align: left !important\">{{\'noPreviousAddress\' | translate}}</td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noInvestorFound\' | translate}}</th></tr></tfoot></table></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><i class=\"fa fa-heart-o\" style=\"font-size:19px;color: #F17F3A;font-weight: bold\"></i> <span class=tableHeader>Direcciones favoritas</span><div style=\"max-height: 200px; overflow-y: scroll\"><table class=\"table table-hover\" style=\"margin-top:20px;margin-left: 25px\"><tbody data-testid=direccion_reserva_favoritas><tr ng-if=\"vm.favAddressList.length != 0\" ng-repeat=\"favAddress in vm.favAddressList\"><td style=\"text-align: left !important\" ng-click=vm.selectFavAddressNewPop(2,favAddress)><p><span style=\"font-weight: 600\">{{\'locationName\' | translate}}: </span>&nbsp;&nbsp; <span>{{favAddress.location_name != \"\" ? favAddress.location_name : \'--\'}}</span></p><p><span style=\"font-weight: 600\">Dirección:</span>&nbsp;&nbsp; <span>{{favAddress.address}}</span></p></td></tr><tr ng-if=\"vm.favAddressList.length == 0\"><td style=\"text-align: left !important\">No se encontró ninguna dirección favorita.</td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noInvestorFound\' | translate}}</th></tr></tfoot></table></div></div></div><!-- <div class=\"row\" ng-repeat=\"previousAddress in vm.previousAddressList\">\n                                                                                                <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"cursor: pointer;\" ng-click=\"vm.selectPreviousAddress(previousAddress,1)\">\n                                                                                                    <p>{{previousAddress.address}}</p>\n                                                                                                </div>\n                                                                                                <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-if=\"$index != vm.previousAddressList.length - 1\">\n                                                                                                    <hr/>\n                                                                                                </div>\n                                                                                            </div> --></div></div><!-- <div class=\"panel panel-default\" ng-if=\"vm.previousAddressList.length\">\n                                                                                <div class=\"panel-body\" style=\"max-height:300px;overflow-y: auto\">\n                                                                                    <div class=\"row\" ng-repeat=\"previousAddress in vm.previousAddressList\">\n                                                                                        <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"cursor: pointer;\" ng-click=\"vm.selectPreviousAddress(previousAddress,2)\">\n                                                                                            <p>{{previousAddress.address}}</p>\n                                                                                        </div>\n                                                                                        <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-if=\"$index != vm.previousAddressList.length - 1\">\n                                                                                            <hr/>\n                                                                                        </div>\n                                                                                    </div>\n                                                                                </div>\n                                                                            </div>\n                                                                            <div class=\"panel panel-default\" ng-if=\"vm.previousAddressList.length == 0\">\n                                                                                <div class=\"panel-body\">\n                                                                                    <div class=\"row\">\n                                                                                        <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">\n                                                                                            <p>{{\'noPreviousAddress\' | translate}}</p>\n                                                                                        </div>\n                                                                                    </div>\n                                                                                </div>\n\n                                                                            </div> --></div></div><i ng-click=vm.MarkfavouriteAddressDrop(true) ng-if=\"(vm.dataToFill.dropOffLng && vm.dataToFill.dropOffLat) && (vm.isActiveDrop)\" class=\"fa fa-heart greenClass\" aria-hidden=true></i> <i ng-click=vm.MarkfavouriteAddressDrop(false) ng-if=\" (vm.dataToFill.dropOffLng && vm.dataToFill.dropOffLat) && (!vm.isActiveDrop)\" class=\"fa fa-heart-o whiteClass\" aria-hidden=true></i><div></div></div><div ng-if=\"createBookingForm.dropOffAddress.$touched|| submit\" ng-messages=createBookingForm.dropOffAddress.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'dropOffReq\' | translate}}</div></div></div></div><div class=\"row mt5\" ng-if=!vm.flagForMarkFavAddress><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"padding-top: 10px\"><div class=addressLength ng-if=\"vm.toAirportFlag && vm.dataToFill.pickUpAddress && !vm.ErrorFlagForNewApi\">Destino :<div style=\"position: relative;margin-left: 70px;margin-top:-20px\">{{vm.dataToFill.dropOffAddress}}</div><!-- <div ng-if=\"vm.modifyFalg\" style=\"position: relative;margin-left: 70px;margin-top:-20px\">{{vm.airportAddress}}</div> --></div><span class=addressLength ng-if=\"vm.fromAirportFlag && vm.dataToFill.dropOffAddress && !vm.ErrorFlagForNewApi\">Retiro :<div style=\"position: relative;margin-left: 60px;margin-top:-20px\">{{vm.dataToFill.pickUpAddress}}</div><!-- <div ng-if=\"vm.modifyFalg\" style=\"position: relative;margin-left: 70px;margin-top:-20px\">{{vm.airportAddress}}</div> --> </span><span class=addressLength ng-if=\"vm.ErrorFlagForNewApi && vm.ErrorFlagForNewApiMessage != undefined\"><i class=\"fa fa-exclamation-circle iconColor\" style=\"font-size: 20px;color: red\" aria-hidden=true></i><div style=\"position: relative;margin-left: 25px;margin-top:-24px;color: red\">{{vm.ErrorFlagForNewApiMessage}}</div></span></div></div><div class=textMarkAddressFav ng-if=vm.flagForMarkFavAddress>La Dirección se agregó como favorita</div></div></div></div></div></div></div><div class=\"row mt5 favButtonShow\"><div ng-style=vm.favAddFlagB class=text-center><button type=button ng-disabled=\"vm.CheckBookingStatus(vm.bookingDetails) || !vm.favAddFlag\" id=DisabledButton class=\"btn btn-primary newTableClass\" data-testid=\"direcciones favoritas\" ng-click=vm.pickFavAddress($event)>{{\'favAddressButton\' | translate}}</button></div></div><!-- <div class=\"row mt5\">\n                                    <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">\n                                        <label class=\"control-label\">{{\'pickUpAddressB\' | translate}}\n                                            <span style=\"color:red\">*</span>\n                                        </label>\n                                        <div class=\"displayFlex\">\n                                            <div ng-style=\"vm.favAddFlagI\">\n                                                <input ng-disabled=\"vm.CheckBookingStatus(vm.bookingDetails)\" type=\"text\" ng-model=\"vm.dataToFill.pickUpAddress\" placeholder=\"{{\'pickUpAddressB\' | translate}}\"\n                                                    class=\"form-control\" name=\"pickUpAddress\" id=\"pickUpAddress\" required ng-change=\"vm.PickUpAddressLength(vm.dataToFill.pickUpAddress)\"\n                                                    ng-class=\"{ \'has-error\': createBookingForm.pickUpAddress.$touched && createBookingForm.pickUpAddress.$invalid }\"\n                                                    ng-click=\"vm.getPreviousAddressHit(1)\" ng-focus=\"vm.getPreviousAddressHit(1)\">\n\n                                                <div ng-if=\"vm.dataToFill.previousPickFlag\">\n\n                                                    <div class=\"panel panel-default\" ng-if=\"vm.previousAddressList.length\">\n                                                        <div class=\"panel-body\" style=\"max-height:300px;overflow-y: auto\">\n                                                            <div class=\"row\" ng-repeat=\"previousAddress in vm.previousAddressList\">\n                                                                <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"cursor: pointer;\" ng-click=\"vm.selectPreviousAddress(previousAddress,1)\">\n                                                                    <p>{{previousAddress.address}}</p>\n                                                                </div>\n                                                                <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-if=\"$index != vm.previousAddressList.length - 1\">\n                                                                    <hr/>\n                                                                </div>\n                                                            </div>\n                                                        </div>\n                                                    </div>\n                                                    <div class=\"panel panel-default\" ng-if=\"vm.previousAddressList.length == 0\">\n                                                        <div class=\"panel-body\">\n                                                            <div class=\"row\">\n                                                                <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">\n                                                                    <p>{{\'noPreviousAddress\' | translate}}</p>\n                                                                </div>\n                                                            </div>\n                                                        </div>\n\n                                                    </div>\n                                                </div>\n                                            </div>\n                                            <div>\n                                                <i ng-click=\"vm.MarkfavouriteAddressPickUp(true)\" ng-if=\"(vm.dataToFill.pickUpLng && vm.dataToFill.pickUpLat) &&  (vm.isActivePick)\"\n                                                    class=\"fa fa-heart redClass\" aria-hidden=\"true\"></i>\n                                                <i ng-click=\"vm.MarkfavouriteAddressPickUp(false)\" ng-if=\"(vm.dataToFill.pickUpLng && vm.dataToFill.pickUpLat) && (!vm.isActivePick)\"\n                                                    class=\"fa fa-heart-o whiteClass\" aria-hidden=\"true\"></i>\n                                            </div>\n                                            <div ng-style=\"vm.favAddFlagB\" class=\"text-center\" ng-if=\"vm.favAddFlag\">\n                                                <a ng-disabled=\"vm.CheckBookingStatus(vm.bookingDetails)\" class=\"btn btn-primary tableButton\" ng-click=\"vm.pickFavAddress($event)\">{{\'favAddressButton\' | translate}}</a>\n                                            </div>\n                                        </div>\n                                        <div ng-if=\"createBookingForm.pickUpAddress.$touched|| submit\" ng-messages=\"createBookingForm.pickUpAddress.$error\">\n                                            <div class=\"errormessage text-danger\" ng-message=\"required\">{{\'pickUpReq\' | translate}}\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"row mt5\">\n                                    <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">\n                                        <label class=\"control-label\">{{\'dropOffAddressB\' | translate}}\n                                            <span style=\"color:red\">*</span>\n                                        </label>\n                                        <div class=\"displayFlex\">\n\n                                            <div ng-style=\"vm.favAddFlagI\">\n                                                <input ng-disabled=\"vm.CheckBookingStatus(vm.bookingDetails)\" type=\"text\" ng-model=\"vm.dataToFill.dropOffAddress\" placeholder=\"{{\'dropOffAddressB\' | translate}}\"\n                                                    class=\"form-control\" name=\"dropOffAddress\" id=\"dropOffAddress\" ng-change=\"vm.DropUpAddressLength(vm.dataToFill.dropOffAddress)\"\n                                                    required ng-class=\"{ \'has-error\': createBookingForm.dropOffAddress.$touched && createBookingForm.dropOffAddress.$invalid }\"\n                                                    ng-click=\"vm.getPreviousAddressHit(2)\" ng-focus=\"vm.getPreviousAddressHit(2)\">\n                                                <div ng-if=\"vm.dataToFill.previousDropFlag\">\n                                                    <div class=\"panel panel-default\" ng-if=\"vm.previousAddressList.length\">\n                                                        <div class=\"panel-body\" style=\"max-height:300px;overflow-y: auto\">\n                                                            <div class=\"row\" ng-repeat=\"previousAddress in vm.previousAddressList\">\n                                                                <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"cursor: pointer;\" ng-click=\"vm.selectPreviousAddress(previousAddress,2)\">\n                                                                    <p>{{previousAddress.address}}</p>\n                                                                </div>\n                                                                <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-if=\"$index != vm.previousAddressList.length - 1\">\n                                                                    <hr/>\n                                                                </div>\n                                                            </div>\n                                                        </div>\n                                                    </div>\n                                                    <div class=\"panel panel-default\" ng-if=\"vm.previousAddressList.length == 0\">\n                                                        <div class=\"panel-body\">\n                                                            <div class=\"row\">\n                                                                <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">\n                                                                    <p>{{\'noPreviousAddress\' | translate}}</p>\n                                                                </div>\n                                                            </div>\n                                                        </div>\n\n                                                    </div>\n                                                </div>\n\n                                            </div>\n                                            <i ng-click=\"vm.MarkfavouriteAddressDrop(true)\" ng-if=\"(vm.dataToFill.dropOffLng && vm.dataToFill.dropOffLat) && (vm.isActiveDrop)\"\n                                                class=\"fa fa-heart redClass\" aria-hidden=\"true\"></i>\n                                            <i ng-click=\"vm.MarkfavouriteAddressDrop(false)\" ng-if=\" (vm.dataToFill.dropOffLng && vm.dataToFill.dropOffLat) && (!vm.isActiveDrop)\"\n                                                class=\"fa fa-heart-o whiteClass\" aria-hidden=\"true\"></i>\n                                            <div>\n                                            </div>\n                                            <div ng-style=\"vm.favAddFlagB\" class=\"text-center\" ng-if=\"vm.favAddFlag\">\n                                                <a ng-disabled=\"vm.CheckBookingStatus(vm.bookingDetails)\" class=\"btn btn-primary tableButton\" ng-click=\"vm.dropFavAddress($event)\">{{\'favAddressButton\' | translate}}</a>\n                                            </div>\n                                        </div>\n                                        <div ng-if=\"createBookingForm.dropOffAddress.$touched|| submit\" ng-messages=\"createBookingForm.dropOffAddress.$error\">\n                                            <div class=\"errormessage text-danger\" ng-message=\"required\">{{\'dropOffReq\' | translate}}\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div> --><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'pickUpReferLabel\' | translate}}</label><textarea ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) class=form-control ng-model=vm.dataToFill.reference_point data-testid=referencia_direccion placeholder=\"{{\'messagePlaceholder\' | translate}}\" name=reference maxlength=140 ng-class=\"{ \'has-error\': createBookingForm.reference.$touched && createBookingForm.reference.$invalid }\"></textarea></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'bookingFor\' | translate}} <span style=color:red>*</span></label><select ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) class=form-control ng-model=vm.dataToFill.bookingFor name=bookingFor data-testid=reserva_para required ng-class=\"{ \'has-error\': createBookingForm.bookingFor.$touched && createBookingForm.bookingFor.$invalid }\" ng-change=vm.bookingFor() ng-options=\"data.value as data.name for data in vm.bookingForOptions\"><option value=\"\" selected disabled>{{\'bookingForPlaceholder\' | translate}}</option><!--<option value=\"0\">Self</option>--><!--<option value=\"1\">Someone else</option>--></select><div ng-if=\"createBookingForm.bookingFor.$touched|| submit\" ng-messages=createBookingForm.bookingFor.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'bookingForReq\' | translate}}</div></div></div></div><div class=\"row mt5\" ng-if=\"(vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == \'1\')\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5\" ng-if=vm.dataToFill.otherBooking><label class=control-label style=\"display: flex\">VIP?<p style=\"font-size: 19px;line-height: 1\"><i ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) style=\"padding-left: 12px\" ng-click=vm.changeVip(); ng-class=\"{\'fa fa-toggle-on\': vm.is_vip , \'fa fa-toggle-off\': !vm.is_vip}\" data-testid=ida_vuelta></i></p></label></div></div><div class=\"row mt5\" ng-if=\"(vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == \'1\') && vm.dataToFill.otherBooking && !vm.newPersonFlag\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Buscar Persona <span style=color:red>*</span></label><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text ng-model=vm.dataToFill.personSelected placeholder=\"{{\'searchCustLabel\' | translate}}\" data-testid=buscar_persona uib-typeahead=\"customers as customers.name for customers in vm.searchPerson($viewValue)\" typeahead-loading=loadingCustomers typeahead-no-results=noResultsPerson class=\"form-control createBookingSelect\" name=searchPerson typeahead-on-select=vm.onSelectingPerson() typeahead-wait-ms=200 typeahead-template-url=personTemplate.html required ng-class=\"{ \'has-error\': createBookingForm.searchPerson.$touched && createBookingForm.searchPerson.$invalid }\"> <i ng-if=loadingCustomers class=\"glyphicon glyphicon-refresh\"></i><div ng-if=noResultsPerson class=mt5><span><i class=\"glyphicon glyphicon-remove\"></i> {{\'searchCustError\' | translate}}</span> <span class=pull-right><a class=\"btn btn-primary tableButton\" ng-click=vm.addNewPerson()>Ingresar manualmente</a></span></div><div ng-if=\"createBookingForm.searchPerson.$touched|| submit\" ng-messages=createBookingForm.searchPerson.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'searchCustReq\' | translate}}</div></div></div></div><div class=\"row mt5\" ng-if=\"!((vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == \'1\') && vm.dataToFill.otherBooking && !vm.newPersonFlag)\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-if=vm.dataToFill.otherBooking><label class=control-label>{{\'personName\' | translate}} <span style=color:red>*</span></label><input type=text ng-model=vm.dataToFill.personName placeholder=\"{{\'personName\' | translate}}\" class=form-control name=personName data-testid=nombre_persona required ng-class=\"{ \'has-error\': createBookingForm.personName.$touched && createBookingForm.personName.$invalid }\" pattern=^\\D*$ ng-maxlength=60 ng-minlength=3><div ng-if=\"createBookingForm.personName.$touched|| submit\" ng-messages=createBookingForm.personName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'personNameReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'personNameValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'firstNameMaximum\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=vm.dataToFill.otherBooking><label class=control-label>{{\'personMail\' | translate}}</label><input type=text ng-model=vm.dataToFill.personEmail placeholder=\"{{\'personMail\' | translate}}\" class=form-control name=personEmail data-testid=email_persona ng-class=\"{ \'has-error\': createBookingForm.personEmail.$touched && createBookingForm.personEmail.$invalid }\" pattern=^([_a-zA-Z0-9-+]+)(\\.[_a-zA-Z0-9-+]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*\\.)+([a-zA-Z]{2,3})$ ng-disabled=\"((vm.dataToFill.customerProfile == 1 || vm.dataToFill.customerProfile == \'1\') && !vm.newPersonFlag) || vm.CheckBookingStatus(vm.bookingDetails)\"><div ng-if=\"createBookingForm.personEmail.$touched|| submit\" ng-messages=createBookingForm.personEmail.$error><!--<div class=\"errormessage text-danger\" ng-message=\"required\">{{\'personMailReq\' | translate}}--><!--</div>--><div class=\"errormessage text-danger\" ng-message=pattern>{{\'personMailValid\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=vm.dataToFill.otherBooking><label class=control-label>{{\'personMobile\' | translate}} <span style=color:red>*</span></label><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text ng-model=vm.dataToFill.personMobile placeholder=\"{{\'personMobile\' | translate}}\" data-testid=telefono_persona class=form-control name=personMobile required ng-class=\"{ \'has-error\': createBookingForm.personMobile.$touched && createBookingForm.personMobile.$invalid }\" pattern=^([1-9]{1}[0-9]{8})*$ ng-minlength=9 ng-maxlength=9 ng-disabled=\"!vm.newPersonFlag && !vm.dataToFill.personName\"><div ng-if=\"createBookingForm.personMobile.$touched|| submit\" ng-messages=createBookingForm.personMobile.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'personMobileReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'personMobileValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'personMobileValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'personMobileValid\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt25\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean>Ida y Vuelta</td><!--{{\'roundTrip\' | translate}}--><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'ROUND_TRIP\', undefined, \'return\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.roundTrip , \'fa fa-toggle-off\': !vm.dataToFill.roundTrip, \'disableRoundTripToggle\': vm.dataToFill.bookingId }\" data-testid=round_trip></i><!--,\'pointerEvent\': vm.dataToFill.bookingId && !vm.dataToFill.roundTrip--></td></tr><tr ng-if=vm.dataToFill.roundTrip><td colspan=2><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-if=\"vm.dataToFill.customerProfile == \'1\' && vm.dataToFill.roundTrip\"><!--vm.dataToFill.customerProfile == \'1\' && --><div class=\"boleeanTypeColor col-lg-3 col-sm-3 col-md-3 col-xs-12\"><i ng-click=\"vm.setBooleans(\'WAIT_TIME_INCLUDED\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.is_wait_time_included ,\n                                                                   \'fa fa-toggle-off\': !vm.dataToFill.is_wait_time_included }\" ng-disabled=\"vm.disabledRoundTrip == true\"></i><!--,\'pointerEvent\': vm.dataToFill.bookingId && vm.dataToFill.is_wait_time_included--></div><div class=\"headingBollean col-lg-9 col-sm-9 col-md-9 col-xs-12\" style=padding-top:10px><!--{{\'waitTimeInclude\' | translate}}--> <span ng-if=!vm.dataToFill.is_wait_time_included>Sin espera</span> <span ng-if=vm.dataToFill.is_wait_time_included>Con espera</span></div></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12\" ng-if=\"((!vm.dataToFill.is_wait_time_included ||  !vm.disabledRoundTrip) || (vm.type_of_trip != \'R\' && vm.dataToFill.selectedServiceDetails.category == 1)) &&  ((!vm.dataToFill.is_wait_time_included  && vm.type_of_trip != \'R\') || vm.dataToFill.selectedServiceDetails.category != 0 && vm.type_of_trip != \'R\')\"><label ng-if=\"vm.type_of_trip == \'P\'\">Fecha de Regreso <span style=color:red>*</span></label><label ng-if=\"vm.type_of_trip == \'Z\'\">Fecha Salida Desde Aeropuerto <span style=color:red>*</span></label><!--{{\'retuenDateLabel\' | translate}}--><p class=input-group><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) id=datePickerReturnDate type=text class=form-control data-testid=fecha_regreso uib-datepicker-popup={{vm.format}} name=returnDate id=returnDate ng-model=vm.dataToFill.returnDate placeholder=\"{{\'retuenDateLabel\' | translate}}\" is-open=vm.datePicker_1.returnDate datepicker-options=vm.returnDateOptions ng-class=\"{ \'has-error\': createBookingForm.returnDate.$touched && createBookingForm.returnDate.$invalid }\" close-text=Close alt-input-formats=vm.altInputFormats ng-change=vm.returnDateChange(); show-button-bar=false readonly> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'2\')\" ng-disabled=\"vm.disabledRoundTrip == true || vm.CheckBookingStatus(vm.bookingDetails)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"createBookingForm.returnDate.$touched|| submit\" ng-messages=createBookingForm.returnDate.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'retuenDateReq\' | translate}}</div></div></div><div class=\"col-lg-8 col-sm-8 col-md-8 col-xs-12\" ng-if=\"((!vm.dataToFill.is_wait_time_included ||  !vm.disabledRoundTrip) || (vm.type_of_trip != \'R\' && vm.dataToFill.selectedServiceDetails.category == 1)) &&  ((!vm.dataToFill.is_wait_time_included  && vm.type_of_trip != \'R\') || vm.dataToFill.selectedServiceDetails.category != 0 && vm.type_of_trip != \'R\')\"><div style=\"display: inline-flex;width:100%\"><div><label ng-if=\"vm.type_of_trip == \'P\'\">Hora de Presentacion <span style=color:red>*</span></label><label ng-if=\"vm.type_of_trip == \'Z\'\">Hora Salida Desde Aeropuerto <span style=color:red>*</span></label><!--{{\'retuenTimeLabel\' | translate}}--><div uib-timepicker ng-model=vm.dataToFill.returnTime name=returnTime class=completed show-spinners=false ng-change=vm.retunrTimeChanged() ng-model-options=\"{ debounce: 400 }\" data-testid=hora_regreso hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian ng-disabled=\"vm.disabledRoundTrip == true || vm.CheckBookingStatus(vm.bookingDetails)\"></div><div ng-if=\"createBookingForm.returnTime.$touched|| submit\" ng-messages=createBookingForm.returnTime.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'retuenTimeReq\' | translate}}</div></div></div><div style=padding-left:15px ng-if=\"vm.dataToFill.selectedServiceDetails.category == 1 && vm.type_of_trip == \'Z\'\" data-testid=hora_retiro_regreso_estimado><div class=etaDiv style=font-size:14px><p>Hora de Recogida Estimada:<br><span style=\"font-weight: bold\">{{vm.dataToFill.returnTime | date:\'HH:mm\'}} hrs</span></p></div><div class=etaDiv style=font-size:14px ng-if=\"vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat\"><p>ETA - {{vm.dataToFill.etaScheduleValueReturn + vm.dataToFill.time_trip_shared_service || \'0\'}}mins</p></div></div><div style=padding-left:15px ng-if=\"vm.dataToFill.selectedServiceDetails.category == 0  && vm.type_of_trip == \'P\'  \"><div class=etaDiv style=font-size:14px><p>Hora de Regreso Estimada:<br><span style=\"font-weight: bold\">({{vm.ptoptravelTimeReturn | date:\'HH:mm\'}} <span ng-if=\"vm.time_trip_shared_service_point_to_point > 0 &&  vm.is_group_external == 0\">- {{vm.rangeOfPointToPointReturn | date:\'HH:mm\'}}</span> hrs)</span></p></div><div class=etaDiv style=font-size:14px ng-if=\"vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat\"><p>ETA - {{vm.dataToFill.etaScheduleValueReturn + vm.pickup_travel_time_pap || \'0\'}}mins</p></div></div></div></div><div class=\"col-lg-4 col-sm-4 col-md-6 col-xs-12\" ng-if=\"(vm.dataToFill.selectedServiceDetails.category == 1 &&  vm.type_of_trip == \'R\') || (vm.dataToFill.selectedServiceDetails.category == 0 &&  vm.type_of_trip == \'R\') \"><label ng-if=\"vm.dataToFill.selectedServiceDetails.category==0\">Fecha Recogida <span style=color:red>*</span></label><label ng-if=\"vm.dataToFill.selectedServiceDetails.category==1\">Fecha Presentación <span style=color:red>*</span></label><p class=input-group><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text class=form-control uib-datepicker-popup={{vm.format}} data-testid=fecha_regreso name=dropDateReturn ng-model=vm.dataToFill.dropDateReturn placeholder=\"Drop Date\" is-open=vm.datePicker_1.dropDateReturn datepicker-options=vm.returnDateOptions required ng-class=\"{ \'has-error\': createBookingForm.dropDateReturn.$touched && createBookingForm.dropDateReturn.$invalid }\" ng-change=\"vm.dropDateReturnChanged(); vm.compareDates()\" close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'4\')\" ng-disabled=\"vm.disabledRoundTrip == true || vm.CheckBookingStatus(vm.bookingDetails)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"createBookingForm.dropDate.$touched|| submit\" ng-messages=createBookingForm.dropDate.$error><div class=\"errormessage text-danger\" ng-message=required>Please select drop date.</div></div></div><div class=\"col-lg-8 col-sm-8 col-md-6 col-xs-12\" ng-if=\"(vm.dataToFill.selectedServiceDetails.category == 1  &&  vm.type_of_trip == \'R\') || (vm.dataToFill.selectedServiceDetails.category == 0 &&  vm.type_of_trip == \'R\') \"><div style=\"display: inline-flex;width:100%\"><div><label ng-if=\"vm.dataToFill.selectedServiceDetails.category==1\">Hora Presentación <span style=color:red>*</span></label><label ng-if=\"vm.dataToFill.selectedServiceDetails.category==0\">Hora Recogida <span style=color:red>*</span></label><div uib-timepicker ng-model=vm.dataToFill.dropTimeReturn show-spinners=false mousewheel=false arrowkeys=false ng-change=vm.dropTimeReturnChanged() ng-model-options=\"{ debounce: 400 }\" data-testid=hora_regreso ng-disabled=\"vm.disabledRoundTrip == true || vm.CheckBookingStatus(vm.bookingDetails)\" hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian></div><div ng-if=\"createBookingForm.dropTime.$touched|| submit\" ng-messages=createBookingForm.dropTime.$error><div class=\"errormessage text-danger\" ng-message=required>Please enter drop time.</div></div></div><div style=padding-left:15px data-testid=hora_retiro_regreso_estimado><div class=etaDiv style=font-size:14px ng-if=\"!vm.method_range_pickup_return && (vm.dataToFill.selectedServiceDetails.category == 1)\"><p>Hora Retiro Estimada: {{vm.pickRange5}} - {{vm.pickRange3ToShowAddReturn}} hrs</p></div><div class=etaDiv style=font-size:14px ng-if=\"vm.method_range_pickup_return && (vm.dataToFill.selectedServiceDetails.category == 1)\"><p>Hora Retiro Estimada: {{vm.pickRangeForRoutingReturn}} hrs</p></div><div class=etaDiv style=font-size:14px ng-if=\"vm.method_range_pickup_return && (vm.dataToFill.selectedServiceDetails.category == 0 &&  vm.type_of_trip == \'R\')\"><p>Hora Retiro Estimada: {{vm.pickRange2}} - {{vm.pickRange10}} hrs</p></div><!--<div class=\"etaDiv\" style=\"font-size:14px;\" ng-if=\"(vm.dataToFill.selectedServiceDetails.category == 0 &&  vm.type_of_trip == \'R\')\">--><!--<p>Hora Recogida Estimada:--><!--<br> {{ vm.pickRangeForRTypeReturn | date:\'HH:mm\'}}--><!--<span ng-if=\"vm.tolerance_time_withdrawal_pickup > 0 &&  vm.is_group_external == 0\"> - {{vm.pickRangeForEstimatedReturn | date:\'HH:mm\'}}--><!--</span>--><!--hrs--><!--</p>--><!--</div>--><!-- <div class=\"etaDiv\" style=\"font-size:14px;\" ng-if=\"vm.dataToFill.selectedServiceDetails.category == 1 && vm.dataToFill.airportCheck == \'Z\'\">\n                                                                                <p>Hora Recogida Estimada: {{vm.dataToFill.dropTimeReturn\n                                                                                    | date:\'HH:mm\'}} hrs</p> \n                                                                            </div> --><!--<div class=\"etaDiv\" style=\"font-size:14px;\" ng-if=\"(vm.dataToFill.selectedServiceDetails.category == 0 &&  vm.type_of_trip == \'R\')\">--><!--[> <p ng-if=\"vm.dataToFill.selectedServiceDetails.category != 1\">ETA - {{vm.dataToFill.etaSchedule || \'0 min\'}}</p> <]--><!--<p>ETA - {{vm.dataToFill.etaScheduleValueReturn--><!--+ vm.travel_time_service_pick_up || \'0\'}}mins</p>--><!--</div>--><div class=etaDiv style=font-size:14px ng-show=\"((vm.dataToFill.bookingType == \'1\' || vm.dataToFill.bookingType == 1 || vm.dataToFill.airportCheck == \'Z\') && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) && !vm.method_range_pickup_return  && (vm.dataToFill.selectedServiceDetails.category == 1)\"><p ng-if=\"vm.dataToFill.selectedServiceDetails.category != 1\">ETA - {{vm.dataToFill.etaScheduleReturn || \'0 min\'}}</p><p ng-if=\"vm.dataToFill.selectedServiceDetails.category == 1\">ETA - {{vm.dataToFill.etaScheduleValueReturn + vm.dataToFill.time_trip_shared_service || \'0\'}}mins</p></div><div class=etaDiv style=font-size:14px ng-show=\"((vm.dataToFill.bookingType == \'1\' || vm.dataToFill.bookingType == 1 || vm.dataToFill.airportCheck == \'Z\') && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) && vm.method_range_pickup_return  && (vm.dataToFill.selectedServiceDetails.category == 1)\"><p>ETA - {{vm.dataToFill.etaScheduleValueReturn || \'0\'}}mins</p></div><div class=etaDiv style=font-size:14px ng-show=\"vm.method_range_pickup_return && (vm.dataToFill.selectedServiceDetails.category == 0 &&  vm.type_of_trip == \'R\')\"><p>ETA - {{vm.dataToFill.etaScheduleValueReturn}}mins</p></div></div></div></div></div></td></tr><tr><td class=headingBollean>{{\'reaccurBooking\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'REACCURING_BOOKING\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.reaccurringBooking , \'fa fa-toggle-off\': !vm.dataToFill.reaccurringBooking}\" data-testid=repetir_reserva></i><!--,\'pointerEvent\':vm.dataToFill.bookingId--></td></tr><tr ng-if=vm.dataToFill.reaccurringBooking><td colspan=2><!--<div class=\"row\">--><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><table class=\"table table-hover\"><thead><tr><th>{{\'Sunday\' | translate}}</th><th>{{\'Monday\' | translate}}</th><th>{{\'Tuesday\' | translate}}</th><th>{{\'Wednesday\' | translate}}</th><th>{{\'Thursday\' | translate}}</th><th>{{\'Friday\' | translate}}</th><th>{{\'Saturday\' | translate}}</th></tr></thead><tbody><tr><td><div style=text-align:center><!--<input type=\"checkbox\"--><!--ng-model=\"vm.daysList.sunday.selected\"--><!--ng-click=\"vm.selectDay(\'Sunday\')\"--><!--value=\"Sunday\">--><md-checkbox ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) class=md-primary ng-click=\"vm.selectDay(\'Sunday\')\" data-testid=repetir_reserva_domingo ng-model=vm.daysList.sunday.selected aria-label=Sunday></md-checkbox></div></td><td><div style=text-align:center><!--<input type=\"checkbox\"--><!--ng-model=\"vm.daysList.monday.selected\"--><!--ng-click=\"vm.selectDay(\'Monday\')\"--><!--value=\"Monday\">--><md-checkbox ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) class=md-primary ng-click=\"vm.selectDay(\'Monday\')\" data-testid=repetir_reserva_lunes ng-model=vm.daysList.monday.selected aria-label=Monday></md-checkbox></div></td><td><div style=text-align:center><!--<input type=\"checkbox\"--><!--ng-model=\"vm.daysList.tuesday.selected\"--><!--ng-click=\"vm.selectDay(\'Tuesday\')\"--><!--value=\"Tuesday\">--><md-checkbox ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) class=md-primary ng-click=\"vm.selectDay(\'Tuesday\')\" data-testid=repetir_reserva_martes ng-model=vm.daysList.tuesday.selected aria-label=Tuesday></md-checkbox></div></td><td><div style=text-align:center><!--<input type=\"checkbox\"--><!--ng-model=\"vm.daysList.wednesday.selected\"--><!--ng-click=\"vm.selectDay(\'Wednesday\')\"--><!--value=\"Wednesday\">--><md-checkbox ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) class=md-primary ng-click=\"vm.selectDay(\'Wednesday\')\" data-testid=repetir_reserva_miercoles ng-model=vm.daysList.wednesday.selected aria-label=Wednesday></md-checkbox></div></td><td><div style=text-align:center><!--<input type=\"checkbox\"--><!--ng-model=\"vm.daysList.thursday.selected\"--><!--ng-click=\"vm.selectDay(\'Thursday\')\"--><!--value=\"Thursday\">--><md-checkbox ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) class=md-primary ng-click=\"vm.selectDay(\'Thursday\')\" data-testid=repetir_reserva_jueves ng-model=vm.daysList.thursday.selected aria-label=Thursday></md-checkbox></div></td><td><div style=text-align:center><!--<input type=\"checkbox\"--><!--ng-model=\"vm.daysList.friday.selected\"--><!--ng-click=\"vm.selectDay(\'Friday\')\"--><!--value=\"Friday\">--><md-checkbox ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) class=md-primary ng-click=\"vm.selectDay(\'Friday\')\" data-testid=repetir_reserva_viernes ng-model=vm.daysList.friday.selected aria-label=Friday></md-checkbox></div></td><td><div style=text-align:center><!--<input type=\"checkbox\"--><!--ng-model=\"vm.daysList.saturday.selected\"--><!--ng-click=\"vm.selectDay(\'Saturday\')\"--><!--value=\"Saturday\">--><md-checkbox ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) class=md-primary ng-click=\"vm.selectDay(\'Saturday\')\" data-testid=repetir_reserva_sabado ng-model=vm.daysList.saturday.selected aria-label=Saturday></md-checkbox></div></td></tr></tbody></table><!--</div>--><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label>{{\'tillDate\' | translate}} <span style=color:red>*</span></label><p class=input-group><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) id=datePickerTillDate type=text class=form-control uib-datepicker-popup={{vm.tformat}} data-testid=fecha_finalizacion name=tillDate ng-model=vm.dataToFill.tillDate placeholder=\"{{\'tillDate\' | translate}}\" is-open=vm.datePicker_2.tillDate datepicker-options=vm.dateOption required ng-class=\"{ \'has-error\': createBookingForm.tillDate.$touched && createBookingForm.tillDate.$invalid }\" close-text=Close alt-input-formats=vm.altInputFormat show-button-bar=false readonly ng-change=vm.tillDateChange($event);> <span class=input-group-btn><button ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_2(\'1\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"createBookingForm.tillDate.$touched|| submit\" ng-messages=createBookingForm.tillDate.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'tillDateReq\' | translate}}</div></div></div><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">--><!--<label>Till Time<span style=\"color:red\">*</span></label>--><!--<div uib-timepicker ng-model=\"vm.dataToFill.tillTime\"--><!--show-spinners=\"false\" ng-change=\"vm.tillTimes()\"--><!--hour-step=\"vm.hsteps\" minute-step=\"vm.msteps\"--><!--show-meridian=\"vm.ismeridians\"></div>--><!--</div>--><!--</div>--></td></tr></tbody></table></div></div><div class=row><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.passengerRutCheck == 1\"><label>{{\'passengerRutB\' | translate}} <span style=color:red>*</span></label><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text class=form-control ng-model=vm.dataToFill.passengerRut data-testid=rut_pasajero name=passengerRut placeholder=\"{{\'passengerRutB\' | translate}}\" ng-rut ng-change=vm.passengerRutChange() required maxlength=13 ng-class=\"{ \'has-error\': createBookingForm.passengerRut.$touched && createBookingForm.passengerRut.$invalid }\"><div ng-if=\"createBookingForm.passengerRut.$touched|| submit\" ng-messages=createBookingForm.passengerRut.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'passengerRutBR\' | translate}}</div></div><div class=\"errormessage text-danger\" ng-if=vm.dataToFill.passengerRUTError>{{\'rutValid\' | translate}}</div></div><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.applicantRutCheck == 1\"><!--ng-if=\"((vm.dataToFill.customerProfile == 1 && vm.dataToFill.contractIdSelected) || (vm.dataToFill.customerProfile == 0 && vm.dataToFill.applicantRutCheck == 1))\"--><label>{{\'applicantRutB\' | translate}} <span style=color:red>*</span></label><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text class=form-control ng-model=vm.dataToFill.applicantRut data-testid=rut_solicitante name=applicantRut placeholder=\"{{\'applicantRutB\' | translate}}\" ng-rut ng-change=vm.applicantRutChange() required maxlength=13 ng-class=\"{ \'has-error\': createBookingForm.applicantRut.$touched && createBookingForm.applicantRut.$invalid }\"><div ng-if=\"createBookingForm.applicantRut.$touched|| submit\" ng-messages=createBookingForm.applicantRut.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'applicantRutBR\' | translate}}</div></div><div class=\"errormessage text-danger\" ng-if=vm.dataToFill.applicantRUTError>{{\'rutValid\' | translate}}</div></div></div><div class=row><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.costCenterCheck == 1\"><!--ng-if=\"((vm.dataToFill.customerProfile == 1 && vm.dataToFill.contractIdSelected) || (vm.dataToFill.customerProfile == 0 && vm.dataToFill.costCenterCheck == 1))\"--><label>{{\'costCenterText\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.costCenter name=costCenter placeholder=\"{{\'costCenterText\' | translate}}\" data-testid=centro_costo ng-required=!vm.checkBoxValueIs ng-class=\"{ \'has-error\': createBookingForm.costCenter.$touched && createBookingForm.costCenter.$invalid }\" ng-maxlength=50 maxlength=50><div ng-if=\"createBookingForm.costCenter.$touched|| submit\" ng-messages=createBookingForm.costCenter.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'costCenterR\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'usernameMax\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid position.--><!--</div>--></div></div><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.costSubCenterCheck == 1\"><!--ng-if=\"((vm.dataToFill.customerProfile == 1 && vm.dataToFill.contractIdSelected) || (vm.dataToFill.customerProfile == 0 && vm.dataToFill.costSubCenterCheck == 1))\"--><label>{{\'subCostText\' | translate}} <span style=color:red>*</span></label><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text class=form-control ng-model=vm.dataToFill.costSubCenter data-testid=centro_subcosto name=costSubCenter placeholder=\"{{\'subCostText\' | translate}}\" required ng-class=\"{ \'has-error\': createBookingForm.costSubCenter.$touched && createBookingForm.costSubCenter.$invalid }\" ng-maxlength=50 maxlength=50><div ng-if=\"createBookingForm.costSubCenter.$touched|| submit\" ng-messages=createBookingForm.costSubCenter.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'costSubCenterR\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'usernameMax\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid position.--><!--</div>--></div></div></div><div class=row><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.RolCheck == 1\"><!--ng-if=\"((vm.dataToFill.customerProfile == 1 && vm.dataToFill.contractIdSelected) || (vm.dataToFill.customerProfile == 0 && vm.dataToFill.RolCheck == 1))\"--><label>{{\'ROLText\' | translate}} <span style=color:red>*</span></label><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text class=form-control ng-model=vm.dataToFill.Rol data-testid=rol name=Rol placeholder=\"{{\'ROLText\' | translate}}\" required ng-class=\"{ \'has-error\': createBookingForm.Rol.$touched && createBookingForm.Rol.$invalid }\" ng-maxlength=50 maxlength=50><div ng-if=\"createBookingForm.Rol.$touched|| submit\" ng-messages=createBookingForm.Rol.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'rolR\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'usernameMax\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid position.--><!--</div>--></div></div><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.graphCheck == 1\"><!--ng-if=\"((vm.dataToFill.customerProfile == 1 && vm.dataToFill.contractIdSelected) || (vm.dataToFill.customerProfile == 0 && vm.dataToFill.graphCheck == 1))\"--><label>{{\'graphText\' | translate}} <span style=color:red>*</span></label><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text class=form-control ng-model=vm.dataToFill.graph data-testid=grafo name=graph placeholder=Graph required ng-class=\"{ \'has-error\': createBookingForm.graph.$touched && createBookingForm.graph.$invalid }\" ng-maxlength=50 maxlength=50><div ng-if=\"createBookingForm.graph.$touched|| submit\" ng-messages=createBookingForm.graph.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'graphR\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'usernameMax\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid position.--><!--</div>--></div></div></div><div class=row><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.workOrderCheck == 1\"><label>{{\'workOrdrerB\' | translate}} <span style=color:red>*</span></label><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text class=form-control ng-model=vm.dataToFill.workOrder data-testid=orden_trabajo name=workOrder placeholder=\"{{\'workOrdrerB\' | translate}}\" required ng-class=\"{ \'has-error\': createBookingForm.workOrder.$touched && createBookingForm.workOrder.$invalid }\" ng-maxlength=15 maxlength=15><div ng-if=\"createBookingForm.workOrder.$touched|| submit\" ng-messages=createBookingForm.workOrder.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'workOrderBR\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'max15\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid position.--><!--</div>--></div></div><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.pepCheck == 1\"><!--ng-if=\"((vm.dataToFill.customerProfile == 1 && vm.dataToFill.contractIdSelected) || (vm.dataToFill.customerProfile == 0 && vm.dataToFill.pepCheck == 1))\"--><label>{{\'PEPText\' | translate}} <span style=color:red>*</span></label><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text class=form-control ng-model=vm.dataToFill.pep data-testid=pep name=pep placeholder=\"{{\'PEPText\' | translate}}\" required ng-class=\"{ \'has-error\': createBookingForm.pep.$touched && createBookingForm.pep.$invalid }\" ng-maxlength=50 maxlength=50><div ng-if=\"createBookingForm.pep.$touched|| submit\" ng-messages=createBookingForm.pep.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'pepR\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'usernameMax\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid position.--><!--</div>--></div></div></div><div class=row><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.noOfVoucherCheck == 1\"><label>{{\'numberOfVoucherText\' | translate}} <span style=color:red>*</span></label><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text class=form-control ng-model=vm.dataToFill.noOfVoucher data-testid=numero_voucher name=numberOfVoucher placeholder=\"{{\'numberOfVoucherText\' | translate}}\" required ng-class=\"{ \'has-error\': createBookingForm.numberOfVoucher.$touched && createBookingForm.numberOfVoucher.$invalid }\" ng-maxlength=15 maxlength=15><div ng-if=\"createBookingForm.numberOfVoucher.$touched|| submit\" ng-messages=createBookingForm.numberOfVoucher.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'voucherR\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'max15\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid position.--><!--</div>--></div></div><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.nominaCheck == 1\"><label>{{\'nomina1\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.nomina name=nomina alpha-numeric=\"\" maxlength=15 ng-maxlength=15 data-testid=nomina ng-required=!vm.checkBoxValueIs placeholder=\"{{\'nomina1\' | translate}}\" ng-class=\"{ \'has-error\': createBookingForm.nomina.$touched && createBookingForm.nomina.$invalid }\"><div ng-if=\"createBookingForm.nomina.$touched|| submit\" ng-messages=createBookingForm.nomina.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'nominaR\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"minlength\">{{\'max15\' | translate}}</div>--><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'max15\' | translate}}</div></div></div></div><div class=row><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.solictudCheck == 1\"><label>{{\'solicitud1\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.solictud name=solicitud placeholder=\"{{\'solicitud1\' | translate}}\" data-testid=solicitud ng-required=!vm.checkBoxValueIs alpha-numeric=\"\" maxlength=15 ng-maxlength=15 ng-class=\"{ \'has-error\': createBookingForm.solicitud.$touched && createBookingForm.solicitud.$invalid }\"><div ng-if=\"createBookingForm.solicitud.$touched|| submit\" ng-messages=createBookingForm.solicitud.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'solicitudR\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"minlength\">{{\'min10\' | translate}}</div>--><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'max15\' | translate}}</div></div></div></div><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\" ng-if=\"vm.dataToFill.purposeOfTripCheck == 1\"><label>{{\'purpouseTripB\' | translate}} <span style=color:red>*</span></label><textarea ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) class=form-control ng-model=vm.dataToFill.purposeOfTrip data-testid=proposito_viaje name=purposeOfTrip placeholder=\"{{\'purpouseTripB\' | translate}}\" required ng-class=\"{ \'has-error\': createBookingForm.purposeOfTrip.$touched && createBookingForm.purposeOfTrip.$invalid }\" ng-maxlength=50 maxlength=50></textarea><div ng-if=\"createBookingForm.purposeOfTrip.$touched|| submit\" ng-messages=createBookingForm.purposeOfTrip.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'purpouseTripBR\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'usernameMax\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid position.--><!--</div>--></div></div></div><div class=row><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.itemOfChargeList.length > 0\"><label>{{\'itemOfCharge\' | translate}}</label><ui-select ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) multiple ng-model=vm.dataToFill.itemOfChargeSelected data-testid=cargos_adicionales theme=bootstrap close-on-select=false title=\"{{\'selectItemP\' | translate}}\" name=itemOfCharge on-select=\"vm.selectingItemOfCharges($select.selected,\'select\')\" on-remove=\"vm.selectingItemOfCharges($select.selected,\'remove\')\" ng-class=\"{ \'has-error\': createBookingForm.itemOfCharge.$touched && createBookingForm.itemOfCharge.$invalid }\"><ui-select-match placeholder=\"{{\'selectItemP\' | translate}}\">{{$item.tic_long_name}}</ui-select-match><ui-select-choices repeat=\"data in vm.dataToFill.itemOfChargeList | filter:$select.search \">{{data.tic_long_name}}</ui-select-choices></ui-select></div><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.itemOfChargeSelected.length> 0\"><table class=table><thead><tr><th>{{\'itemName\' | translate}}</th><th>{{\'itemPrice\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"itemData in vm.dataToFill.itemOfChargeSelected\"><td>{{itemData.tic_long_name}}</td><td><span ng-if=\"itemData.tic_mode == 0\">${{itemData.price}}</span> <span ng-if=\"itemData.tic_mode == 1\">$&nbsp;&nbsp; <input type=text ng-change=\"vm.selectingItemOfCharges($index,\'change\')\" placeholder=\"{{\'itemPrice\' | translate}}\" ng-model=itemData.price data-testid=cargo_adicional{{$index}} number-dot></span></td></tr></tbody></table></div></div><div class=\"row mt5\" ng-if=\" vm.type_of_trip1 != \'P\' && vm.flagForAirline == true\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>{{\'airline\' | translate}} <span style=color:red>*</span></label></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text class=form-control ng-model=vm.dataToFill.airline data-testid=aerolinea required maxlength=20 ng-maxlength=20 name=airline placeholder=\"{{\'airline\' | translate}}\" ng-class=\"{ \'has-error\': spotBookingForm.airline.$touched && spotBookingForm.airline.$invalid }\" ng-change=\"vm.dataToFill.couponValidation=false\"><div ng-if=\"createBookingForm.airline.$touched|| submit\" ng-messages=createBookingForm.airline.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'airlineReq\' | translate}}</div></div></div></div><div class=\"row mt5\" ng-if=\" vm.type_of_trip1 != \'P\' && vm.flagForFlightNumber == true\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>{{\'flightNumber\' | translate}}</label><span style=color:red>*</span> <input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text class=form-control ng-model=vm.dataToFill.flightNumber required alpha-numeric=\"\" maxlength=8 ng-maxlength=8 name=flightNumber placeholder=\"{{\'flightNumber\' | translate}}\" ng-class=\"{ \'has-error\': spotBookingForm.flightNumber.$touched && spotBookingForm.flightNumber.$invalid }\" ng-change=\"vm.dataToFill.couponValidation=false\"><div ng-if=\"createBookingForm.flightNumber.$touched|| submit\" ng-messages=createBookingForm.flightNumber.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'flightNumberReq\' | translate}}</div></div></div></div><div class=\"row mt5\" ng-if=\" vm.type_of_trip1 != \'P\' && vm.flagForFlightType == true\"><div class=\"col-lg-6 col-sm-6 col-xs-6 col-md-5\"><label>{{\'flightType\' | translate}}</label><span style=color:red>*</span><br><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=radio name=gender value=I ng-model=vm.international ng-click=vm.changeFlightType(vm.international)> <span style=\"margin-left: 5px;font-weight: 450;font-size: 14px\">{{\'international\' | translate}}</span> <input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=radio name=gender value=N style=\"margin-left:15px;margin-top: 10px\" ng-model=vm.national ng-click=vm.changeFlightType(vm.national)> <span style=\"margin-left: 5px;font-weight: 450;font-size: 14px\" ng-model=vm.national>{{\'national\' | translate}}</span><br><div ng-if=\"vm.international == null && vm.national == null || submit\"><div class=\"errormessage text-danger\" ng-message=required>{{\'flightDateReq\' | translate}}</div></div></div></div><!-- ng-if=\" vm.type_of_trip1 != \'P\' && vm.flagForFlightDate == true\" --><div class=\"row mt5\" ng-if=\" vm.type_of_trip1 != \'P\' && vm.flagForFlightDate == true\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>{{\'flightDate\' | translate}}</label><span style=color:red>*</span></div><div class=\"col-lg-7 col-sm-7 col-xs-12 col-md-7\"><p class=input-group><input ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=text class=form-control uib-datepicker-popup={{vm.format}} name=pickupDate ng-model=vm.filterData.filter_pickup_from_date_value placeholder=\"{{\'flightDate\' | translate}}\" is-open=vm.datePicker_1.pickupFromDate required datepicker-options=vm.dateOptions close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=\"vm.pickupFromToDateChanged(1); vm.compareDates()\"> <span class=input-group-btn><button ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) type=button class=\"btn btn-default\" ng-click=vm.datePickerE_New(1)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=\"errormessage text-danger\" ng-if=\"vm.scheduleDateValidation || vm.dropoffDateValidation\">Fecha de vuelo debe ser menor que la fecha de recogida.</div><div class=\"errormessage text-danger\" ng-if=\"vm.flightDateValidation \">Fecha de vuelo debe ser mayor que la fecha de recogida.</div><div ng-if=\"createBookingForm.pickupDate.$touched|| submit\" ng-messages=createBookingForm.pickupDate.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'flightDateReq\' | translate}}</div></div><p></p></div><div class=\"col-lg-5 col-sm-5 col-xs-12 col-md-5\"><div ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) uib-timepicker ng-model=vm.filterData.filter_pickup_from_time_value ng-model-options=\"{ debounce: 400 }\" show-spinners=false class=completed ng-change=vm.pickupFromToTimeChanged(1);vm.changeTime() hour-step=vm.hstep minute-step=vm.mstep show-meridian=false min=vm.TimeChange()></div><!-- min=\"vm.TimeChange()\" --></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Métodos de pago <span style=color:red>*</span></label><ui-select ng-disabled=\"vm.disabledPaymentMethod == true || vm.CheckBookingStatus(vm.bookingDetails)\" ng-model=vm.dataToFill.payment_method data-testid=metodos_pago name=pago ng-required=!vm.modifyFalg close-on-select=true ng-class=\"{ \'has-error\': createBookingForm.pago.$touched && createBookingForm.pago.$invalid }\"><ui-select-match placeholder=\"Métodos de pago\">{{$select.selected.type}}</ui-select-match><ui-select-choices repeat=\"payment.id as payment in vm.dataToFill.paymentMethodList | filter: $select.search | orderBy:\'type\' \"><div data-testid=metodo_pago_{{payment.id}} ng-bind-html=payment.type></div></ui-select-choices></ui-select><div ng-if=\"createBookingForm.pago.$touched|| submit\" ng-messages=createBookingForm.pago.$error><div class=\"errormessage text-danger\" ng-message=required>Debe seleccionar un Método de pago</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>Cupón Descuento</label></div><div class=\"col-lg-10 col-sm-10 col-xs-12 col-md-10\"><input ng-disabled=\"((vm.isAdjustedDiscountedAmount == 1 ) || (vm.finalAdjustedPriceFromAdmin > 0) || (vm.dataToFill.roundTrip == true || (vm.bookingDetails.round_trip_parent_job_id > 0 || vm.bookingDetails.round_trip_child_job_id > 0) ||  !vm.couponFlag)) || vm.CheckBookingStatus(vm.bookingDetails) \" data-testid=couponCode type=text class=form-control ng-model=vm.dataToFill.couponCode name=couponCode placeholder=\"Cupón Descuento\" ng-class=\"{ \'has-error\': spotBookingForm.couponCode.$touched && spotBookingForm.couponCode.$invalid }\" ng-change=\"vm.dataToFill.couponValidation=false\"><div ng-if=vm.dataToFill.couponValidation class=\"parsley-errors-list filled\"><div class=\"errormessage text-danger\">Este cupón no es válido</div></div><!--<div ng-if=\"spotBookingForm.couponCode.$touched|| vm.submit\" ng-messages=\"spotBookingForm.couponCode.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Por favor, ingrese la solicitud</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"maxlength\">Se permiten un máximo de 15 caracteres.</div>--><!--</div>--></div><div class=\"col-lg-2 col-sm-2 col-xs-12 col-md-2\"><input ng-disabled=\"((vm.isAdjustedDiscountedAmount == 1 ) || (vm.finalAdjustedPriceFromAdmin > 0) || (vm.dataToFill.roundTrip == true || (vm.bookingDetails.round_trip_parent_job_id > 0 || vm.bookingDetails.round_trip_child_job_id > 0 || !vm.couponFlag))|| vm.CheckBookingStatus(vm.bookingDetails))\" data-testid=aplicar_descuento type=button class=\"btn btn-primary\" ng-click=vm.applyCoupon() value=Aplicar></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>{{\'observationText\' | translate}}</label><textarea ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) class=form-control ng-model=vm.dataToFill.observations data-testid=observaciones name=observation placeholder=\"{{\'messagePlaceholder\' | translate}}\" style=\"height: 120px\" ng-class=\"{ \'has-error\': createBookingForm.observation.$touched && createBookingForm.observation.$invalid }\" ng-maxlength=500 maxlength=500></textarea><div ng-if=\"createBookingForm.observation.$touched|| submit\" ng-messages=createBookingForm.observation.$error><div class=\"errormessage text-danger\" ng-message=required>Please enter observation.</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'max500\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid position.--><!--</div>--></div></div></div></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><button ng-disabled=\"vm.flightDateValidation || vm.scheduleDateValidation || vm.dropoffDateValidation || !vm.disabledSubmitButton\" data-testid=guardar ng-class=\"{\'disableSubmit\' : vm.disabledSubmitButton1 }\" type=submit class=\"btn btn-primary\" style=width:200px>{{\'submit\' | translate}}</button><!-- ng-disabled=\"vm.disableSubmitButton\" --></div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><div class=\"panel panel-default\"><div class=panel-body><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><div style=padding:0 class=\"col-lg-9 col-sm-12 col-xs-12 col-md-9 paddingBottom\"><div ng-if=vm.dataToFill.nearDriver><p class=driverSelected>{{\'driverBooking\' | translate}} <span class=\"fa fa-close\" ng-click=vm.removeSelectedDriver()></span></p></div><div class=\"etaDiv text-align-left\" ng-if=\"((vm.dataToFill.bookingType == \'1\' || vm.dataToFill.bookingType == 1 || vm.dataToFill.airportCheck == \'Z\') && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) && !vm.method_range_pickup\"><p ng-if=\"vm.dataToFill.selectedServiceDetails.category != 1\">ETA - {{vm.type_of_trip1 == \'R\' ? + vm.travel_time_service_pick_up + vm.dataToFill.etaSchedule : vm.dataToFill.etaSchedule}}mins</p><!-- <p ng-if=\"vm.dataToFill.selectedServiceDetails.category != 1 && vm.modifyFalgNew\">ETA - {{vm.dataToFill.etaSchedule}}mins</p>                                             --><p ng-if=\"vm.dataToFill.selectedServiceDetails.category == 1\">ETA - {{vm.dataToFill.etaScheduleValue + vm.dataToFill.time_trip_shared_service || \'0\'}}mins</p></div><div class=\"etaDiv text-align-left\" ng-if=\"((vm.dataToFill.bookingType == \'1\' || vm.dataToFill.bookingType == 1 || vm.dataToFill.airportCheck == \'Z\') && vm.dataToFill.pickUpLat && vm.dataToFill.dropOffLat) && vm.method_range_pickup\"><p>ETA - {{vm.dataToFill.etaSchedule + \'mins\'|| \'0 min\'}}</p></div><div class=\"etaDiv text-align-left\" ng-if=vm.dataToFill.estimatedFare><p ng-if=\"vm.dataToFill.route_type == 0\">Tipo de Tarifa: Variable</p><p ng-if=\"vm.dataToFill.route_type == 1\">Tipo de Tarifa: Fija</p></div><div class=\"etaDiv text-align-left\" ng-if=\"vm.showEstimatePriceInHtml(vm.dataToFill.roundTrip, vm.viaControlledFLag1, vm.viaControlledFLag)\"><p>{{\'estimatedPrice\' | translate}} - <span ng-if=\"!vm.click && vm.finalAdjustedPriceFromAdmin == 0\">${{ vm.calculatedEstimatePriceFormFunction }} </span><span ng-if=\"!vm.click && vm.finalAdjustedPriceFromAdmin != 0\">${{ vm.calculatedEstimatePriceFormFunctionEstimated }} </span><!-- <input style=\"width: 90px;\" type=\"number\" ng-model=\"vm.calculatedEstimatePriceFormFunction\" ng-if=\"vm.click && vm.finalAdjustedPriceFromAdmin == 0\" > --> <input style=\"width: 90px\" type=number ng-model=vm.calculatedEstimatePriceFormFunctionEstimated ng-if=vm.click> <button type=button class=\"btn-primary tableButton\" ng-disabled=\"vm.couponType != undefined\" ng-click=\"vm.clickFunction(\'Modify\')\" ng-if=\"!vm.click && vm.dataToFill.route_type == 1  && !vm.dataToFill.roundTrip && vm.dataToFill.allowChangeFarePanel  && !vm.modifyFalg\">Modificar Tarifa</button> <button type=button class=\"btn-primary tableButton\" ng-disabled=\"vm.couponType != undefined\" ng-click=\"vm.clickFunction(\'Done\')\" ng-if=\"vm.click && vm.dataToFill.route_type == 1  && !vm.dataToFill.roundTrip && vm.dataToFill.allowChangeFarePanel  && !vm.modifyFalg\">Confirmar</button></p></div><!--!703 change  && vm.dataToFill.route_type == 1 --><!-- <div class=\"etaDiv\" ng-if=\" vm.dataToFill.roundTrip == false && vm.viaControlledFLag1 == false && vm.viaControlledFLag == false \">\n                                    <p>{{\'estimatedPrice\' | translate}} - ${{ vm.math.round(vm.dataToFill.estimatedFare) ||\n                                        \'0\'}}</p>\n                                </div>\n                                <div class=\"etaDiv\" ng-if=\" vm.dataToFill.roundTrip == false && vm.viaControlledFLag1 == true && vm.viaControlledFLag == false \">\n                                    <p>{{\'estimatedPrice\' | translate}} - ${{ vm.math.round((vm.dataToFill.estimatedFare) +\n                                            (vm.dataToFill.controllerWayTarifa ? 0 : vm.viaControlled1))|| \'0\'}}\n                                        \n                                    </p>\n                                </div>\n                                <div class=\"etaDiv\" ng-if=\" vm.dataToFill.roundTrip == false && vm.viaControlledFLag1 == false && vm.viaControlledFLag == true \">\n                                        <p>{{\'estimatedPrice\' | translate}} - ${{ vm.math.round(vm.dataToFill.estimatedFare) ||\n                                            \'0\'}}</p>\n                                            \n                                </div>\n                                <div class=\"etaDiv\" ng-if=\" vm.dataToFill.roundTrip == true && vm.viaControlledFLag1 == false && vm.viaControlledFLag == false \">\n                                    <p>{{\'estimatedPrice\' | translate}} - ${{ vm.math.round((vm.dataToFill.estimatedFare) +\n                                        (vm.dataToFill.Return_policy.estimatedFare )) || \'0\'}}</p>\n                                        \n                                </div>\n                                <div class=\"etaDiv\" ng-if=\" vm.dataToFill.roundTrip == true && vm.viaControlledFLag1 == true && vm.viaControlledFLag == false \">\n                                    <p>{{\'estimatedPrice\' | translate}} - ${{ vm.math.round((vm.dataToFill.estimatedFare) +\n                                        (vm.dataToFill.Return_policy.estimatedFare )+ (vm.dataToFill.controllerWayTarifa ? 0 : vm.viaControlled1)) || \'0\'}}</p>\n                                </div>\n                                <div class=\"etaDiv\" ng-if=\" vm.dataToFill.roundTrip == true && vm.viaControlledFLag1 == false && vm.viaControlledFLag == true \">\n                                    <p>{{\'estimatedPrice\' | translate}} - ${{ vm.math.round((vm.dataToFill.estimatedFare) +\n                                        (vm.dataToFill.Return_policy.estimatedFare )+ (vm.dataToFill.controllerWayTarifa ? 0 : vm.viaControlled2)) || \'0\'}}</p>\n                                </div> --><div class=\"etaDiv text-align-left\" ng-if=\"vm.showEstimatePriceForFixedPriceInHtml(vm.dataToFill.estimatedFare, vm.dataToFill.roundTrip, vm.viaControlledFLag1)\"><p>{{\'fixedPrice\' | translate}} - ${{ vm.calculatedEstimatePriceForFixedPriceFormFunction || \'0\'}}</p></div><!-- <div class=\"etaDiv\" ng-if=\"vm.showEstimatePriceForRoundTripInHtml(vm.dataToFill.Return_policy.estimatedFare, vm.dataToFill.roundTrip, vm.viaControlledFLag)\">\n                                    <p>{{\'roundPrice\' | translate}} - ${{ vm.calculatedEstimatePriceForRoundTripFormFunction\n                                        || \'0\'}}</p>\n                                </div> --><!-- <div class=\"etaDiv\" ng-if=\"vm.showEstimatePriceForFixedPriceInHtml(vm.dataToFill.estimatedFare, vm.dataToFill.roundTrip, vm.viaControlledFLag1)\">\n                                    <p>{{\'fixedPrice\' | translate}} - ${{ vm.calculatedEstimatePriceForFixedPriceFormFunction || \'0\'}}\n                                    </p>\n                                </div> --><div class=\"etaDiv text-align-left\" ng-if=\"vm.showEstimatePriceForRoundTripInHtml(vm.dataToFill.Return_policy.estimatedFare, vm.dataToFill.roundTrip, vm.viaControlledFLag)\"><p>{{\'roundPrice\' | translate}} - ${{ vm.calculatedEstimatePriceForRoundTripFormFunction || \'0\'}}</p></div></div><div class=\"col-lg-3 col-sm-12 col-xs-12 col-md-3 verMapaButton\"><input ng-disabled=\"!(vm.dataToFill.pickUpAddress && vm.dataToFill.dropOffAddress) || (vm.showGoogleMap)\" type=button class=\"btn btn-primary\" ng-click=\"vm.showGoogleMap = true; vm.mapInitialize()\" value=\"Ver Mapa\"></div></div><!--<div class=\"etaDiv\" ng-if=\"vm.dataToFill.selectedServiceDetails.category == 1 && vm.pickRange1 && vm.pickRange2 && vm.dataToFill.airportCheck != \'Z\'\">--><!--<p>Estimated Pickup: {{vm.pickRange1}} - {{vm.pickRange2}}</p>--><!--</div>--><!--<div class=\"etaDiv\" ng-if=\"vm.dataToFill.selectedServiceDetails.category == 1 && vm.dataToFill.airportCheck == \'Z\'\">--><!--<p>Pickup: {{vm.dataToFill.dropTime | date:\'HH:mm\'}}</p>--><!--</div>--><!--<div class=\"etaDiv\" ng-if=\"vm.dataToFill.selectedServiceDetails.category == 0 && vm.dropRange1 && vm.dropRange1\">--><!--<p>Estimated Dropoff: {{vm.dropRange1}} - {{vm.dropRange1}}</p>--><!--</div>--><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" ng-show=vm.showGoogleMap><div id=googleMap style=width:100%></div></div></div></div><div class=\"row mt5\" ng-if=\"((vm.dataToFill.roundTrip || vm.dataToFill.couponApplied) && vm.dataToFill.discounts.length > 0)\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">Monto de la reserva</p><div class=row style=\"padding:0px 10px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\" style=\"max-height:345px;overflow-y: auto\"><table class=\"table table-hover\"><thead><tr><th>Descuento Nombre</th><th>Descuento</th><th>Tipo</th><th>{{\'estimatedPrice\' | translate}}</th><th>Cantidad total</th></tr></thead><tbody><tr><td><span ng-if=\"vm.dataToFill.discounts[0].name == \'ROUND TRIP\'\">DSCTO. IDA Y VUELTA</span> <span ng-if=\"vm.dataToFill.discounts[0].name != \'ROUND TRIP\'\">{{vm.dataToFill.discounts[0].name}}</span></td><td>{{vm.dataToFill.discounts[0].discountTypeValue}}</td><td><span ng-if=\"vm.dataToFill.discounts[0].discountType == \'0\' || vm.dataToFill.discounts[0].discountType == 0\">Flat</span> <span ng-if=\"vm.dataToFill.discounts[0].discountType == \'1\' || vm.dataToFill.discounts[0].discountType == 1\">Percentage</span></td><!-- (vm.roundTripChildJobId) Contain Child Job Id --><!-- Default value of vm.roundTripChildJobId is 1 --><!-- (vm.roundTripChildJobId == 0) is for Child booking --><!-- (vm.roundTripChildJobId > 0) is for Parent booking --><td ng-if=\"vm.roundTripChildJobId == 0\">${{vm.dataToFill.discounts[0].estimatedFare}}</td><td ng-if=\"vm.roundTripChildJobId > 0\">${{vm.dataToFill.discounts[0].estimatedFare + vm.dataToFill.discounts[0].roundTripFare}}</td><td ng-if=\"vm.roundTripChildJobId > 0\">${{vm.dataToFill.discounts[0].finalAmount + vm.dataToFill.discounts[0].roundFinalAmount}}</td><td ng-if=\"vm.roundTripChildJobId == 0\">${{vm.dataToFill.discounts[0].finalAmount}}</td></tr></tbody></table></div></div></div></div></div></div></div></form></div></div><input id=copy style=\"opacity: 0 ; z-index:0\" type=text><div id=showPrint></div></div><script type=text/ng-template id=customTemplate.html><a style=\"cursor: pointer;\">\n        <span class=\"displayFlex\">\n            <span>\n                <img ng-src=\"{{match.model.profile_pic_thumb || \'assets/images/noImage.jpeg\'}}\" width=\"35\">\n            </span>\n            <span style=\"padding-left: 10px;\">\n                <span ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"></span>\n                <span>/</span>\n                <span ng-bind-html=\"match.model.email\"></span>\n                <br/>\n                <span ng-bind-html=\"match.model.phone_number\"></span>\n            </span>\n        </span>\n    </a></script><script type=text/ng-template id=personTemplate.html><a style=\"cursor: pointer;\">\n        <span class=\"displayFlex\">\n            <span>\n                <img ng-src=\"{{match.model.profile_pic_thumb || \'assets/images/noImage.jpeg\'}}\" width=\"35\">\n            </span>\n            <span style=\"padding-left: 10px;\">\n                <span ng-bind-html=\"match.model.name | uibTypeaheadHighlight:query\"></span>\n                <span>/</span>\n                <span ng-bind-html=\"match.model.email\"></span>\n                <br/>\n                <span ng-bind-html=\"match.model.phone_number\"></span>\n            </span>\n        </span>\n    </a></script><style>.nav>li.TabsBar>a:hover {\n        background-color: white !important;\n        color: #F17F3A !important;\n        /* text-decoration: underline !important; */\n    }\n\n    .panel.with-nav-tabs .panel-heading {\n        padding: 5px 5px 0 5px;\n    }\n\n    .panel.with-nav-tabs .nav-tabs {\n        border-bottom: none;\n    }\n\n    .panel.with-nav-tabs .nav-justified {\n        margin-bottom: -1px;\n    }\n\n    /********************************************************************/\n\n    /*** PANEL DEFAULT ***/\n\n    .with-nav-tabs.panel-default .nav-tabs>li>a,\n    .with-nav-tabs.panel-default .nav-tabs>li>a:hover,\n    .with-nav-tabs.panel-default .nav-tabs>li>a:focus {\n        color: #777;\n        font-weight: bold;\n    }\n\n    .with-nav-tabs.panel-default .nav-tabs>.open>a,\n    .with-nav-tabs.panel-default .nav-tabs>.open>a:hover,\n    .with-nav-tabs.panel-default .nav-tabs>.open>a:focus,\n    .with-nav-tabs.panel-default .nav-tabs>li>a:hover,\n    .with-nav-tabs.panel-default .nav-tabs>li>a:focus {\n        color: #777;\n        background-color: #ddd;\n        border-color: transparent;\n        /* font-size: 12px; */\n    }\n\n    .with-nav-tabs.panel-default .nav-tabs>li.active>a,\n    .with-nav-tabs.panel-default .nav-tabs>li.active>a:hover .with-nav-tabs.panel-default .nav-tabs>li.active>a:focus {\n        color: #F17F3A;\n        background-color: #fff;\n        border-color: #ddd;\n        /* text-decoration: underline; */\n        font-size: 14px;\n        font-weight: bold;\n        border-bottom-color: transparent;\n    }\n\n    .with-nav-tabs.panel-default .nav-tabs>li.dropdown .dropdown-menu {\n        background-color: #f5f5f5;\n        border-color: #ddd;\n    }\n\n    .with-nav-tabs.panel-default .nav-tabs>li.dropdown .dropdown-menu>li>a {\n        color: #777;\n    }\n\n    .with-nav-tabs.panel-default .nav-tabs>li.dropdown .dropdown-menu>li>a:hover,\n    .with-nav-tabs.panel-default .nav-tabs>li.dropdown .dropdown-menu>li>a:focus {\n        background-color: #ddd;\n    }\n\n    .with-nav-tabs.panel-default .nav-tabs>li.dropdown .dropdown-menu>.active>a,\n    .with-nav-tabs.panel-default .nav-tabs>li.dropdown .dropdown-menu>.active>a:hover,\n    .with-nav-tabs.panel-default .nav-tabs>li.dropdown .dropdown-menu>.active>a:focus {\n        color: #fff;\n        background-color: #555;\n    }\n\n    /********************************************************************/\n\n    /*** PANEL PRIMARY ***/\n\n    .with-nav-tabs.panel-primary .nav-tabs>li>a,\n    .with-nav-tabs.panel-primary .nav-tabs>li>a:hover,\n    .with-nav-tabs.panel-primary .nav-tabs>li>a:focus {\n        color: #fff;\n    }\n\n    .with-nav-tabs.panel-primary .nav-tabs>.open>a,\n    .with-nav-tabs.panel-primary .nav-tabs>.open>a:hover,\n    .with-nav-tabs.panel-primary .nav-tabs>.open>a:focus,\n    .with-nav-tabs.panel-primary .nav-tabs>li>a:hover,\n    .with-nav-tabs.panel-primary .nav-tabs>li>a:focus {\n        color: #fff;\n        background-color: #3071a9;\n        border-color: transparent;\n    }\n\n    .with-nav-tabs.panel-primary .nav-tabs>li.active>a,\n    .with-nav-tabs.panel-primary .nav-tabs>li.active>a:hover,\n    .with-nav-tabs.panel-primary .nav-tabs>li.active>a:focus {\n        color: #428bca;\n        background-color: #fff;\n        border-color: #428bca;\n        border-bottom-color: transparent;\n    }\n\n    .with-nav-tabs.panel-primary .nav-tabs>li.dropdown .dropdown-menu {\n        background-color: #428bca;\n        border-color: #3071a9;\n    }\n\n    .with-nav-tabs.panel-primary .nav-tabs>li.dropdown .dropdown-menu>li>a {\n        color: #fff;\n    }\n\n    .with-nav-tabs.panel-primary .nav-tabs>li.dropdown .dropdown-menu>li>a:hover,\n    .with-nav-tabs.panel-primary .nav-tabs>li.dropdown .dropdown-menu>li>a:focus {\n        background-color: #3071a9;\n    }\n\n    .with-nav-tabs.panel-primary .nav-tabs>li.dropdown .dropdown-menu>.active>a,\n    .with-nav-tabs.panel-primary .nav-tabs>li.dropdown .dropdown-menu>.active>a:hover,\n    .with-nav-tabs.panel-primary .nav-tabs>li.dropdown .dropdown-menu>.active>a:focus {\n        background-color: #4a9fe9;\n    }\n\n    /********************************************************************/\n\n    /*** PANEL SUCCESS ***/\n\n    .with-nav-tabs.panel-success .nav-tabs>li>a,\n    .with-nav-tabs.panel-success .nav-tabs>li>a:hover,\n    .with-nav-tabs.panel-success .nav-tabs>li>a:focus {\n        color: #3c763d;\n    }\n\n    .with-nav-tabs.panel-success .nav-tabs>.open>a,\n    .with-nav-tabs.panel-success .nav-tabs>.open>a:hover,\n    .with-nav-tabs.panel-success .nav-tabs>.open>a:focus,\n    .with-nav-tabs.panel-success .nav-tabs>li>a:hover,\n    .with-nav-tabs.panel-success .nav-tabs>li>a:focus {\n        color: #3c763d;\n        background-color: #d6e9c6;\n        border-color: transparent;\n    }\n\n    .with-nav-tabs.panel-success .nav-tabs>li.active>a,\n    .with-nav-tabs.panel-success .nav-tabs>li.active>a:hover,\n    .with-nav-tabs.panel-success .nav-tabs>li.active>a:focus {\n        color: #3c763d;\n        background-color: #fff;\n        border-color: #d6e9c6;\n        border-bottom-color: transparent;\n    }\n\n    .with-nav-tabs.panel-success .nav-tabs>li.dropdown .dropdown-menu {\n        background-color: #dff0d8;\n        border-color: #d6e9c6;\n    }\n\n    .with-nav-tabs.panel-success .nav-tabs>li.dropdown .dropdown-menu>li>a {\n        color: #3c763d;\n    }\n\n    .with-nav-tabs.panel-success .nav-tabs>li.dropdown .dropdown-menu>li>a:hover,\n    .with-nav-tabs.panel-success .nav-tabs>li.dropdown .dropdown-menu>li>a:focus {\n        background-color: #d6e9c6;\n    }\n\n    .with-nav-tabs.panel-success .nav-tabs>li.dropdown .dropdown-menu>.active>a,\n    .with-nav-tabs.panel-success .nav-tabs>li.dropdown .dropdown-menu>.active>a:hover,\n    .with-nav-tabs.panel-success .nav-tabs>li.dropdown .dropdown-menu>.active>a:focus {\n        color: #fff;\n        background-color: #3c763d;\n    }\n\n    /********************************************************************/\n\n    /*** PANEL INFO ***/\n\n    .with-nav-tabs.panel-info .nav-tabs>li>a,\n    .with-nav-tabs.panel-info .nav-tabs>li>a:hover,\n    .with-nav-tabs.panel-info .nav-tabs>li>a:focus {\n        color: #31708f;\n    }\n\n    .with-nav-tabs.panel-info .nav-tabs>.open>a,\n    .with-nav-tabs.panel-info .nav-tabs>.open>a:hover,\n    .with-nav-tabs.panel-info .nav-tabs>.open>a:focus,\n    .with-nav-tabs.panel-info .nav-tabs>li>a:hover,\n    .with-nav-tabs.panel-info .nav-tabs>li>a:focus {\n        color: #31708f;\n        background-color: #bce8f1;\n        border-color: transparent;\n    }\n\n    .with-nav-tabs.panel-info .nav-tabs>li.active>a,\n    .with-nav-tabs.panel-info .nav-tabs>li.active>a:hover,\n    .with-nav-tabs.panel-info .nav-tabs>li.active>a:focus {\n        color: #31708f;\n        background-color: #fff;\n        border-color: #bce8f1;\n        border-bottom-color: transparent;\n    }\n\n    .with-nav-tabs.panel-info .nav-tabs>li.dropdown .dropdown-menu {\n        background-color: #d9edf7;\n        border-color: #bce8f1;\n    }\n\n    .with-nav-tabs.panel-info .nav-tabs>li.dropdown .dropdown-menu>li>a {\n        color: #31708f;\n    }\n\n    .with-nav-tabs.panel-info .nav-tabs>li.dropdown .dropdown-menu>li>a:hover,\n    .with-nav-tabs.panel-info .nav-tabs>li.dropdown .dropdown-menu>li>a:focus {\n        background-color: #bce8f1;\n    }\n\n    .with-nav-tabs.panel-info .nav-tabs>li.dropdown .dropdown-menu>.active>a,\n    .with-nav-tabs.panel-info .nav-tabs>li.dropdown .dropdown-menu>.active>a:hover,\n    .with-nav-tabs.panel-info .nav-tabs>li.dropdown .dropdown-menu>.active>a:focus {\n        color: #fff;\n        background-color: #31708f;\n    }\n\n    /********************************************************************/\n\n    /*** PANEL WARNING ***/\n\n    .with-nav-tabs.panel-warning .nav-tabs>li>a,\n    .with-nav-tabs.panel-warning .nav-tabs>li>a:hover,\n    .with-nav-tabs.panel-warning .nav-tabs>li>a:focus {\n        color: #8a6d3b;\n    }\n\n    .with-nav-tabs.panel-warning .nav-tabs>.open>a,\n    .with-nav-tabs.panel-warning .nav-tabs>.open>a:hover,\n    .with-nav-tabs.panel-warning .nav-tabs>.open>a:focus,\n    .with-nav-tabs.panel-warning .nav-tabs>li>a:hover,\n    .with-nav-tabs.panel-warning .nav-tabs>li>a:focus {\n        color: #8a6d3b;\n        background-color: #faebcc;\n        border-color: transparent;\n    }\n\n    .with-nav-tabs.panel-warning .nav-tabs>li.active>a,\n    .with-nav-tabs.panel-warning .nav-tabs>li.active>a:hover,\n    .with-nav-tabs.panel-warning .nav-tabs>li.active>a:focus {\n        color: #8a6d3b;\n        background-color: #fff;\n        border-color: #faebcc;\n        border-bottom-color: transparent;\n    }\n\n    .with-nav-tabs.panel-warning .nav-tabs>li.dropdown .dropdown-menu {\n        background-color: #fcf8e3;\n        border-color: #faebcc;\n    }\n\n    .with-nav-tabs.panel-warning .nav-tabs>li.dropdown .dropdown-menu>li>a {\n        color: #8a6d3b;\n    }\n\n    .with-nav-tabs.panel-warning .nav-tabs>li.dropdown .dropdown-menu>li>a:hover,\n    .with-nav-tabs.panel-warning .nav-tabs>li.dropdown .dropdown-menu>li>a:focus {\n        background-color: #faebcc;\n    }\n\n    .with-nav-tabs.panel-warning .nav-tabs>li.dropdown .dropdown-menu>.active>a,\n    .with-nav-tabs.panel-warning .nav-tabs>li.dropdown .dropdown-menu>.active>a:hover,\n    .with-nav-tabs.panel-warning .nav-tabs>li.dropdown .dropdown-menu>.active>a:focus {\n        color: #fff;\n        background-color: #8a6d3b;\n    }\n\n    /********************************************************************/\n\n    /*** PANEL DANGER ***/\n\n    .with-nav-tabs.panel-danger .nav-tabs>li>a,\n    .with-nav-tabs.panel-danger .nav-tabs>li>a:hover,\n    .with-nav-tabs.panel-danger .nav-tabs>li>a:focus {\n        color: #a94442;\n    }\n\n    .with-nav-tabs.panel-danger .nav-tabs>.open>a,\n    .with-nav-tabs.panel-danger .nav-tabs>.open>a:hover,\n    .with-nav-tabs.panel-danger .nav-tabs>.open>a:focus,\n    .with-nav-tabs.panel-danger .nav-tabs>li>a:hover,\n    .with-nav-tabs.panel-danger .nav-tabs>li>a:focus {\n        color: #a94442;\n        background-color: #ebccd1;\n        border-color: transparent;\n    }\n\n    .with-nav-tabs.panel-danger .nav-tabs>li.active>a,\n    .with-nav-tabs.panel-danger .nav-tabs>li.active>a:hover,\n    .with-nav-tabs.panel-danger .nav-tabs>li.active>a:focus {\n        color: #a94442;\n        background-color: #fff;\n        border-color: #ebccd1;\n        border-bottom-color: transparent;\n    }\n\n    .with-nav-tabs.panel-danger .nav-tabs>li.dropdown .dropdown-menu {\n        background-color: #f2dede;\n        /* bg color */\n        border-color: #ebccd1;\n        /* border color */\n    }\n\n    .with-nav-tabs.panel-danger .nav-tabs>li.dropdown .dropdown-menu>li>a {\n        color: #a94442;\n        /* normal text color */\n    }\n\n    .with-nav-tabs.panel-danger .nav-tabs>li.dropdown .dropdown-menu>li>a:hover,\n    .with-nav-tabs.panel-danger .nav-tabs>li.dropdown .dropdown-menu>li>a:focus {\n        background-color: #ebccd1;\n        /* hover bg color */\n    }\n\n    .with-nav-tabs.panel-danger .nav-tabs>li.dropdown .dropdown-menu>.active>a,\n    .with-nav-tabs.panel-danger .nav-tabs>li.dropdown .dropdown-menu>.active>a:hover,\n    .with-nav-tabs.panel-danger .nav-tabs>li.dropdown .dropdown-menu>.active>a:focus {\n        color: #fff;\n        /* active text color */\n        background-color: #a94442;\n        /* active bg color */\n    }\n\n    .favButtonShow {\n        padding-bottom: 10px;\n        padding-left: 20px;\n        padding-top: 17px !important;\n        margin: 0px;\n        margin-top: -5px !important;\n        padding-top: 0px;\n        border-left: 1px solid #EDEDED;\n        border-right: 1px solid #EDEDED;\n        border-bottom: 1px solid #EDEDED;\n    }\n\n    .textMarkAddressFav {\n        color: #7ed321;\n        padding-top: 10px;\n        font-size: 16px;\n        font-weight: bold;\n    }\n\n    .crossButton {\n        font-size: 14px;\n        color: grey;\n        display: flex;\n        direction: rtl;\n        margin-right: 5px;\n        margin-bottom: 2px;\n        color: darkgrey;\n    }\n\n    .tableHeader {\n        font-size: 18px;\n        color: #F17F3A;\n        font-weight: bold;\n        margin-left: 7px;\n    }\n\n    .addressLength {\n        color: #F17F3A;\n        font-weight: bold;\n    }\n\n    .focusInput:focus {\n        border: 1px solid #F17F3A;\n    }\n\n    .newTableClass {\n        background-color: white;\n        color: #7ed321\n    }\n\n    button#DisabledButton:disabled {\n        background: none;\n        color: #afa8a8;\n        border-color: #dad7d7;\n    }\n\n    .panel-default>.panel-heading {\n        background-color: #FBFBFB;\n    }\n\n    .with-nav-tabs.panel-default .nav-tabs>li.active>a>hr {\n        /* margin-top: 20px; */\n        /* margin-bottom: 20px; */\n        border: 0;\n        width: 30px;\n        border-top: 2px solid #F17F3A;\n        margin-top: 5px;\n        margin-bottom: 0px;\n    }\n\n    .with-nav-tabs.panel-default .nav-tabs>li>a>hr {\n        border: 0;\n        width: 30px;\n        /* border-top: 2px solid #F17F3A; */\n        margin-top: 5px;\n        margin-bottom: 0px;\n    }\n\n    .with-nav-tabs.panel-default .nav-tabs>li.active>a>hr.PtoP {\n        /* margin-top: 20px; */\n        /* margin-bottom: 20px; */\n        border: 0;\n        width: 30px;\n        border-top: 2px solid #F17F3A;\n        margin-top: 5px;\n        margin-bottom: 0px;\n    }\n\n    @media only screen and (max-width: 600px) {\n        .with-nav-tabs.panel-default .nav-tabs>li.active>a {\n            font-size: 9px !important;\n        }\n        .with-nav-tabs.panel-default .nav-tabs>li>a {\n            font-size: 9px !important;\n        }\n    }\n\n    @media only screen and (min-width: 600px) {\n        .with-nav-tabs.panel-default .nav-tabs>li.active>a {\n            font-size: 16px !important;\n        }\n        .with-nav-tabs.panel-default .nav-tabs>li>a {\n            font-size: 16px !important;\n        }\n        #pointToPoint {\n            width: 28.33% !important;\n            text-align: center;\n        }\n    }\n\n    @media only screen and (min-width: 768px) {\n        .with-nav-tabs.panel-default .nav-tabs>li.active>a {\n            font-size: 8px !important;\n        }\n        .with-nav-tabs.panel-default .nav-tabs>li>a {\n            font-size: 8px !important;\n        }\n        #pointToPoint {\n            width: 28.33% !important;\n            text-align: center;\n        }\n    }\n\n    @media only screen and (min-width: 900px) {\n        .with-nav-tabs.panel-default .nav-tabs>li.active>a {\n            font-size: 11px !important;\n        }\n        .with-nav-tabs.panel-default .nav-tabs>li>a {\n            font-size: 11px !important;\n        }\n        #pointToPoint {\n            width: 28.33% !important;\n            text-align: center;\n        }\n    }\n\n    @media only screen and (min-width: 1100px) {\n        .with-nav-tabs.panel-default .nav-tabs>li.active>a {\n            font-size: 14px !important;\n        }\n        .with-nav-tabs.panel-default .nav-tabs>li>a {\n            font-size: 14px !important;\n        }\n    }\n\n    #pointToPoint {\n        width: 33.33%;\n        text-align: center;\n    }\n\n    #toAirport {\n        width: 33.33%;\n        text-align: center;\n    }\n\n    #fromAirport {\n        width: 33.33%;\n        text-align: center;\n    }</style>");
$templateCache.put("app/components/views/create-booking-here-maps/createBookingHereMapsMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/customer/customer.html","<h2 class=ng-cloak><span>{{\'customerHead\' | translate}}</span> <span class=pull-right><button class=\"btn btn-primary tableButton\" ng-click=vm.refreshData()>Volver a cargar</button></span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><p class=totalSize><span class=pull-right><a class=\"btn btn-primary mb10\" ui-sref=layout.customersMain.customerRegister>+ {{\'addCustomerButton\' | translate}}</a> </span><span>{{\'totalCustomers\' | translate}}: {{vm.totalCustomers}}</span></p></div><br><br><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.getFilter() ng-model-options=\"{ debounce: 500 }\"></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\"><!--ng-switch=\"(vm.customerList | filter:vm.search).length\"--><!--<div ng-switch-when=\"0\" class=\"noSearch\"><span>{{\'nothingFound\' | translate}}</span></div>--><table class=\"table table-hover tableWithMasterData\"><!--ng-switch-default--><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'customer_id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:125px><div class=text-center>{{\'profilePic\' | translate}}</div></th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'name\' | translate}}\" text=\"\'name\'\" check=vm.reverse>{{\'name\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'mobileNumber\' | translate}}\" text=\"\'phone\'\" check=vm.reverse>{{\'mobileNumber\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'corporateAccountId\' | translate}}\" text=\"\'corporate_account_id\'\" check=vm.reverse>{{\'corporateAccountId\' | translate}}</th><th style=width:100px><div class=text-center>{{\'stateTable\' | translate}}</div></th><th style=width:150px><div class=text-center>{{\'action\' | translate}}</div></th><th style=width:250px><div class=text-center>{{\'corporateProfile\' | translate}}</div></th><th style=width:150px><div class=text-center>{{\'viewOtp\' | translate}}</div></th><th style=width:150px><div class=text-center>{{\'adminLogs\' | translate}}</div></th><th style=width:300px><div class=text-center>Contraseña</div></th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.customerList | orderBy:vm.predicate:vm.reverse\"><!--| filter:vm.search--><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:70px>{{::data.customer_id}}</td><td style=\"text-align: center;width:125px\"><a href=\"{{data.profile_pic_thumb || \'assets/images/noImage.jpeg\'}}\" data-lightbox=roadtrip data-title=\"{{data.firstName + data.lastName}}\"><img ng-src=\"{{data.profile_pic_thumb || \'assets/images/noImage.jpeg\'}}\" class=tableImage></a></td><td style=width:125px>{{::data.name}}</td><td style=width:125px>{{data.phone || \'--\'}}</td><td style=width:125px><!--{{data.corporate_account_id==null?\"-&#45;&#45;&#45;&#45;\":data.corporate_account_id}}--> <span ng-if=data.employee_details.length ng-repeat=\"employee in data.employee_details\">{{::employee.id}} <span ng-if=\"$index != data.employee_details.length - 1\">,</span> </span><span ng-if=\"data.employee_details.length == 0\">{{\'noCorporateAccount\' | translate}}</span></td><td style=\"text-align: center;width:100px\"><div style=\"text-align: center\"><a class=\"cursor btn btn-sm\" ng-class=\"{\'blockIconColor\': data.is_blocked == 1, \'unblockIconColor\': data.is_blocked == 0}\" ng-click=vm.block_unblock($event,data.customer_id,data.is_blocked)><i ng-class=\"{\'fa fa-unlock\': data.is_blocked == 0,\'fa fa-lock\': data.is_blocked == 1}\"></i></a></div></td><td style=width:150px><a title=\"View Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.customersMain.customerDetails({id:\'{{data.customer_id}}\'})\"><i class=\"fa fa-eye\"></i> </a><a title=\"Edit Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.customersMain.editCustomerDetails({id:\'{{data.customer_id}}\'})\"><i class=\"fa fa-edit\"></i> </a><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteUser(data,$event)><i class=\"fa fa-trash\"></i></a></td><td style=width:250px><a class=\"btn btn-primary tableButton\" ng-click=vm.addCorporateProfile(data,$event) title=\"{{\'addCorporateProfile\' | translate}}\">+ {{\'addCorporateProfile\' | translate}}</a><!--ng-disabled=\"data.hasCorporateAccount == true\"--></td><td style=width:150px><a class=\"btn btn-primary tableButton\" title=\"{{\'viewOtp\' | translate}}\" ng-click=vm.viewOTP(data,$event)>{{\'viewOtp\' | translate}}</a></td><td style=width:150px><a class=\"btn btn-primary tableButton\" title=\"{{\'adminLogs\' | translate}}\" ui-sref=\"layout.customersMain.adminLogs({userId:\'{{data.customer_id}}\',type:\'1\',fakeType:\'3\'})\">{{\'adminLogs\' | translate}}</a></td><td style=width:300px><a class=\"btn btn-primary tableButton\" title=\"Admin Logs\" ng-click=vm.resetPassword(data)>Restablecer</a> <a class=\"btn btn-primary tableButton\" title=\"Admin Logs\" ng-click=vm.SendEmail(data)>Enviar email</a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noCustomerFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav>&lt;!&ndash;ng-show=\"vm.watchPagination\"&ndash;&gt;--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\" ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/customer/customerDetails.html","<h2 class=ng-cloak>{{\'customerHead\' | translate}} / {{\'customerDetailsHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=driver><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'allDetails\' | translate}}</p><div class=basicDetailsDiv><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><img ng-src=\"{{vm.customerDetail.profile_pic_thumb || \'assets/images/noImage.jpeg\'}}\" class=profilePic title=\"{{\'profilePic\' | translate}}\"></div></div><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'name\' | translate}}:</label><div class=\"form-control text-capitalize\">{{vm.customerDetail.first_name + \" \" + vm.customerDetail.last_name}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'email\' | translate}}:</label><div class=form-control>{{::vm.customerDetail.email}}</div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'mobileNumber\' | translate}}:</label><div class=form-control>{{vm.customerDetail.country_code?vm.customerDetail.country_code + \"-\" + vm.customerDetail.phone_number:vm.customerDetail.phone_number}}</div></div></div></div></div><div class=basicDiv ng-if=\"vm.customerDetail.employee_details.length == 0\"><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'employeeData\' | translate}}</p><div class=basicDetailsDiv><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><p class=text-center>{{\'noCorporateAccount\' | translate}}</p></div></div></div></div><div class=basicDiv ng-if=vm.customerDetail.employee_details.length><p class=\"basicRegistrationP text-center backgroundBasicPending\">Employee Data</p><div class=basicDetailsDiv ng-repeat=\"employeeData in vm.customerDetail.employee_details\"><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'name\' | translate}}:</label><div class=\"form-control text-capitalize\">{{employeeData.last_name?employeeData.name + \' \' + employeeData.last_name:employeeData.name}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'email\' | translate}}:</label><div class=form-control>{{::employeeData.email}}</div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'mobileNumber\' | translate}}:</label><div class=\"form-control text-capitalize\">{{::employeeData.phone_number}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'rutLabel\' | translate}}:</label><div class=form-control>{{::employeeData.RUT}}</div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'uniqueCode\' | translate}}:</label><div class=\"form-control text-capitalize\">{{::employeeData.uniquecode}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'employeeId\' | translate}}:</label><div class=form-control>{{::employeeData.id}}</div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'vipEmployee\' | translate}}:</label><div class=\"form-control text-capitalize\"><span ng-if=\"employeeData.is_vip == 0\">NO</span> <span ng-if=\"employeeData.is_vip == 1\">YES</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'thirdBooking\' | translate}}:</label><div class=\"form-control text-capitalize\"><span ng-if=\"employeeData.thirdBooking == 0\">Not Allowed</span> <span ng-if=\"employeeData.thirdBooking == 1\">Allowed</span></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'approvalRequired\' | translate}}:</label><div class=\"form-control text-capitalize\"><span ng-if=\"employeeData.approval_required == 0\">NO</span> <span ng-if=\"employeeData.approval_required == 1\">YES</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=\"employeeData.approval_required == 1\"><label class=control-label>{{\'authRut\' | translate}}:</label><div class=\"form-control text-capitalize\">{{::employeeData.auth_RUT}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'position\' | translate}}:</label><div class=\"form-control text-capitalize\">{{employeeData.position || \'--\'}}</div><label class=control-label>{{\'status\' | translate}}:</label><div class=\"form-control text-capitalize\"><span ng-if=\"employeeData.status == 0\">Not Active</span> <span ng-if=\"employeeData.status == 1\">Active</span></div></div></div><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><span ng-if=\"$index != vm.customerDetail.employee_details.length - 1\"><hr></span></div></div></div></div><div class=basicDiv ng-if=\"vm.customerDetail.favourite_locations && vm.customerDetail.favourite_locations.length\"><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'favAdress\' | translate}}</p><div class=basicDetailsDiv style=\"height:485px;overflow-y: auto;overflow-x: hidden\"><div class=row ng-repeat=\"data in vm.customerDetail.favourite_locations\"><div class=\"col-lg-6 col-xs-12 col-md-6 col-sm-6\"><label class=control-label>{{\'locationName\' | translate}}:</label><div class=\"form-control text-capitalize\">{{data.location_name || \'--\'}}</div></div><div class=\"col-lg-6 col-xs-12 col-md-6 col-sm-6\"><label class=control-label>{{\'address\' | translate}}:</label><textarea class=form-control ng-model=data.address readonly></textarea></div><div class=\"col-lg-6 col-xs-12 col-md-6 col-sm-6\"><label class=control-label>{{\'locationId\' | translate}}:</label><div class=\"form-control text-capitalize\">{{data.location_id}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'status\' | translate}}:</label><div class=\"form-control text-capitalize\"><span ng-if=\"data.status == 0\">Not Active</span> <span ng-if=\"data.status == 1\">Active</span></div></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><span ng-if=\"$index != vm.customerDetail.favourite_locations.length - 1\"><hr></span></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/customer/customerMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/customer/editCustomerDetails.html","<h2 class=ng-cloak>{{\'customerHead\' | translate}} / {{\'editCustomerHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'detailsCustomer\' | translate}}</p><div class=basicDetailsDiv><form name=customerEditForm ng-submit=\"submit=true;customerEditForm.$valid&&vm.editApi()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><label class=\"control-label mt10\">{{\'profilePic\' | translate}}</label><br><img ng-src=\"{{vm.dataToFill.profile_pic || \'assets/images/noImage.jpeg\'}}\" id=profilePic class=documentStyle><br><input id=documentUpload filestyle=\"\" type=file style=\"display: none\" image=image name={{vm.uploadName}} onchange=angular.element(this).scope().file_to_upload(this.files,this.name) onclick=\"this.value=null\" data-button-text=Single data-class-button=\"btn btn-default\" data-classinput=\"form-control inline\" nv-file-select=\"\" uploader=uploader> <button type=button class=\"btn btn-primary upload mt10\" ng-click=\"vm.clickTrigger($event, \'PROFILE\')\">{{\'uploadButton\' | translate}}</button></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'firstNameLabel\' | translate}} <span style=color:red>*</span></label><input type=text data-testid=add_first_name ng-model=vm.dataToFill.first_name placeholder=\"{{\'firstNameLabel\' | translate}}\" class=form-control pattern=^\\D*$ ng-maxlength=60 ng-minlength=3 name=customerFirstName required ng-class=\"{ \'has-error\': customerEditForm.customerFirstName.$touched && customerEditForm.customerFirstName.$invalid }\"><div ng-if=\"customerEditForm.customerFirstName.$touched|| submit\" ng-messages=customerEditForm.customerFirstName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'firstNameRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'firstNameValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'firstNameMaximum\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'lastNameLabel\' | translate}} <span style=color:red>*</span></label><input type=text data-testid=add_last_name ng-model=vm.dataToFill.last_name placeholder=\"{{\'lastNameLabel\' | translate}}\" class=form-control pattern=^\\D*$ ng-maxlength=60 ng-minlength=3 name=customerLastName required ng-class=\"{ \'has-error\': customerEditForm.customerLastName.$touched && createBookingForm.customerLastName.$invalid }\"><div ng-if=\"customerEditForm.customerLastName.$touched|| submit\" ng-messages=customerEditForm.customerLastName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'lastNameRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'lastNameValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'lastNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'lastNameMaximum\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'email\' | translate}} <span style=color:red>*</span></label><input type=text data-testid=add_email ng-model=vm.dataToFill.email placeholder=\"{{\'custEmail\' | translate}}\" class=form-control pattern=^([_a-zA-Z0-9-+]+)(\\.[_a-zA-Z0-9-+]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*\\.)+([a-zA-Z]{2,12})$ readonly name=customerEmail required ng-class=\"{ \'has-error\': customerEditForm.customerEmail.$touched && customerEditForm.customerEmail.$invalid }\"><div ng-if=\"customerEditForm.customerEmail.$touched|| submit\" ng-messages=customerEditForm.customerEmail.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'requiredEmail\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'validEmail\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'mobileNumber\' | translate}} <span style=color:red>*</span></label><input type=text data-testid=add_phone ng-model=vm.dataToFill.mobileNumber placeholder=\"{{\'mobileNumber\' | translate}}\" class=form-control pattern=^([1-9]{1}[0-9]{8})*$ ng-minlength=9 ng-maxlength=9 name=customerMobileG required ng-class=\"{ \'has-error\': customerEditForm.customerMobileG.$touched && customerEditForm.customerMobileG.$invalid }\"><div ng-if=\"customerEditForm.customerMobileG.$touched|| submit\" ng-messages=customerEditForm.customerMobileG.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'mobileRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'mobileValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'mobileValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'mobileValid\' | translate}}</div></div></div></div><div style=\"padding-top: 10px\" class=\"col-lg-12 col-ms-12 col-md-12 col-xs-12\" style=\"margin-top: 5px;text-align: justify\"><strong><u style=\"font-size: 18px\">Importante</u>:</strong> <span style=\"font-size: 14px;font-weight: 450\">Cualquier cambio que se haga en el nombre, apellido o teléfono del Empleado, automáticamente también<br>actualizará los mismos datos en la respectiva cuenta de usuario vinculada y en todos los perfiles corporativos que pertenezcan a dicha cuenta.</span></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" style=\"padding-top: 30px\"><button type=submit data-testid=btn_save class=\"btn btn-primary\" style=width:200px>{{\'submit\' | translate}}</button></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/customer/registerCustomer.html","<h2 class=ng-cloak>{{\'customerHead\' | translate}} / {{\'registerCustomerHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'detailsCustomer\' | translate}}</p><div class=basicDetailsDiv><form name=customerRegisterForm ng-submit=\"submit=true;customerRegisterForm.$valid&&vm.registerApi()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><label class=\"control-label mt10\">{{\'profilePic\' | translate}}</label><br><img src=assets/images/noImage.jpeg id=profilePic class=documentStyle><br><input id=documentUpload filestyle=\"\" type=file style=\"display: none\" image=image name={{vm.uploadName}} onchange=angular.element(this).scope().file_to_upload(this.files,this.name) onclick=\"this.value=null\" data-button-text=Single data-class-button=\"btn btn-default\" data-classinput=\"form-control inline\" nv-file-select=\"\" uploader=uploader> <button type=button class=\"btn btn-primary upload mt10\" ng-click=\"vm.clickTrigger($event, \'PROFILE\')\">{{\'uploadButton\' | translate}}</button></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'firstNameLabel\' | translate}} <span style=color:red>*</span></label><input type=text data-testid=add_first_name ng-model=vm.dataToFill.first_name placeholder=\"{{\'firstNameLabel\' | translate}}\" class=form-control pattern=^\\D*$ ng-maxlength=60 ng-minlength=3 name=customerFirstName required ng-class=\"{ \'has-error\': customerRegisterForm.customerFirstName.$touched && customerRegisterForm.customerFirstName.$invalid }\"><div ng-if=\"customerRegisterForm.customerFirstName.$touched|| submit\" ng-messages=customerRegisterForm.customerFirstName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'firstNameRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'firstNameValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'firstNameMaximum\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'lastNameLabel\' | translate}} <span style=color:red>*</span></label><input type=text data-testid=add_last_name ng-model=vm.dataToFill.last_name placeholder=\"{{\'lastNameLabel\' | translate}}\" class=form-control pattern=^\\D*$ ng-maxlength=60 ng-minlength=3 name=customerLastName required ng-class=\"{ \'has-error\': customerRegisterForm.customerLastName.$touched && createBookingForm.customerLastName.$invalid }\"><div ng-if=\"customerRegisterForm.customerLastName.$touched|| submit\" ng-messages=customerRegisterForm.customerLastName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'lastNameRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'lastNameValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'lastNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'lastNameMaximum\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'email\' | translate}} <span style=color:red>*</span></label><input type=text data-testid=add_email ng-model=vm.dataToFill.email placeholder=\"{{\'custEmail\' | translate}}\" class=form-control pattern=^([_a-zA-Z0-9-+]+)(\\.[_a-zA-Z0-9-+]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*\\.)+([a-zA-Z]{2,13})$ name=customerEmail required ng-class=\"{ \'has-error\': customerRegisterForm.customerEmail.$touched && customerRegisterForm.customerEmail.$invalid }\"><div ng-if=\"customerRegisterForm.customerEmail.$touched|| submit\" ng-messages=customerRegisterForm.customerEmail.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'requiredEmail\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'validEmail\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'mobileNumber\' | translate}} <span style=color:red>*</span></label><input type=text data-testid=add_phone ng-model=vm.dataToFill.mobileNumber placeholder=\"{{\'mobileNumber\' | translate}}\" class=form-control pattern=^([1-9]{1}[0-9]{8})*$ ng-minlength=9 ng-maxlength=9 name=customerMobileG required ng-class=\"{ \'has-error\': customerRegisterForm.customerMobileG.$touched && customerRegisterForm.customerMobileG.$invalid }\"><div ng-if=\"customerRegisterForm.customerMobileG.$touched|| submit\" ng-messages=customerRegisterForm.customerMobileG.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'mobileRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'mobileValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'mobileValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'mobileValid\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'referralCode\' | translate}}</label><input data-testid=add_referral_code type=text class=form-control ng-model=vm.dataToFill.referral_code name=referralCode placeholder=\"Referral Code\" ng-class=\"{ \'has-error\': customerRegisterForm.referralCode.$touched && customerRegisterForm.referralCode.$invalid }\"><div ng-if=\"customerRegisterForm.referralCode.$touched|| submit\" ng-messages=customerRegisterForm.referralCode.$error></div></div></div><div style=\"padding-top: 10px\" class=\"col-lg-12 col-ms-12 col-md-12 col-xs-12\" style=\"margin-top: 5px;text-align: justify\"><strong><u style=\"font-size: 18px\">Importante</u>:</strong> <span style=\"font-size: 14px;font-weight: 450\">Cualquier cambio que se haga en el nombre, apellido o teléfono del Empleado, automáticamente también<br>actualizará los mismos datos en la respectiva cuenta de usuario vinculada y en todos los perfiles corporativos que pertenezcan a dicha cuenta.</span></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" style=\"padding-top: 30px\"><button type=submit class=\"btn btn-primary\" data-testid=btn_save style=width:200px>{{\'submit\' | translate}}</button></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/dashboard/dashboard.html","<h2 class=ng-cloak><span>{{\'dashboardPageHead\' | translate}}</span> <span class=pull-right><button class=\"btn btn-info\" title=\"{{\'filterButton\' | translate}}\" style=\"min-width: 100px\" ng-click=vm.showDriversWithFilter(vm.dataToFill);>{{\'filterButton\' | translate}}</button><!--vm.showFilterArea()--> <button class=\"btn btn-info\" title=\"{{\'resetButton\' | translate}}\" ng-click=vm.removeFilter()>{{\'resetButton\' | translate}}</button><!-- TV-2761  <button class=\"btn Notification\" title=\"{{\'pushNotificationButton\' | translate}}\" type=\"button\" ng-click=\"vm.pushNotificationPop($event)\">{{\'pushNotificationButton\' | translate}}</button> --></span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><!--<filter-sidebar show-filter-sidebar=\"vm.showFilterFlag\" filter-data=\"vm.dataToFill\" filter-to-show=\"vm.filterWhichToShow\" branch-detail-changed=\"vm.branchChangedFilter(vm.dataToFill)\"--><!--vehicle-detail-changed=\"vm.vehicleChangedFilter(vm.dataToFill)\" service-detail-changed=\"vm.serviceChangedFilter(vm.dataToFill)\"--><!--agreement-detail-changed=\"vm.agreementChangedFilter(vm.dataToFill)\" virtual-fleet-detail-changed=\"vm.virtualFleetChangedFilter(vm.dataToFill)\"--><!--operation-detail-changed=\"vm.operationChangedFilter(vm.dataToFill)\" traffic-detail-changed=\"vm.trafficChangedFilter(vm.dataToFill)\"--><!--traffic-detail-changed=\"vm.trafficChangedFilter(vm.dataToFill)\" ></filter-sidebar>--><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-init=\"checkClicked = true\"><h2 class=\"text-center filtersStyle\" ng-click=\"checkClicked = !checkClicked; vm.slideData()\">Filters <span class=fa ng-class=\"{\'fa-caret-down\': checkClicked,\'fa-caret-up\': !checkClicked }\"></span></h2><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" id=collapse><div class=displayFlex><!--col-lg-2 col-sm-4 col-md-4 col-xs-12 style=\"overflow-y: hidden;overflow-x:auto;\"--><div class=filterAlign><label>{{\'branchLabel\' | translate}}:</label><div><ui-select ng-model=vm.dataToFill.branch name=branch ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true ng-change=vm.changeFilter();vm.socketFuncation()><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branch | filter: $select.search | orderBy:\'region_name\' \" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.changeFilterDate();><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select></div></div><div class=filterAlign><label>{{\'vehicleLabel\' | translate}}:</label><div><ui-select multiple ng-model=vm.dataToFill.vehicle name=vehicleType ng-change=vm.changeFilter();vm.socketFuncation() ng-keyup=vm.vehicleSearch($select.search,$event) close-on-select=true><ui-select-match placeholder=\"{{\'vehiclePlaceholder\' | translate}}\">{{$item.name}}</ui-select-match><ui-select-choices when-scrolled=vm.paginationChangedForVehicle() repeat=\"vehicle.id as vehicle in vm.vehicle | filter: $select.search\"><div ng-bind-html=vehicle.name></div></ui-select-choices></ui-select></div></div><div class=filterAlign><label>{{\'serviceLabel\' | translate}}:</label><div><ui-select multiple ng-model=vm.dataToFill.service name=service ng-change=vm.changeFilter();vm.socketFuncation() ng-keyup=vm.serviceSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=\"{{\'selectTripType\' | translate}}\">{{$item.name}}</ui-select-match><ui-select-choices when-scrolled=vm.paginationChangedForService() repeat=\"services.id as services in vm.service | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=services.name></div></ui-select-choices></ui-select></div></div><div class=filterAlign><label>{{\'agreementLabel\' | translate}}:</label><div><ui-select ng-model=vm.dataToFill.agreement close-on-select=true ng-keyup=vm.agreementSearch($select.search,$event) ng-change=vm.changeFilter();vm.socketFuncation()><ui-select-match placeholder=\"{{\'agreementPlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in vm.agreement | filter: $select.search\" when-scrolled=vm.paginationChangedForAgreement() ng-click=vm.changeFilterDate();><div ng-bind-html=data.name></div></ui-select-choices></ui-select></div></div><div class=filterAlign><label>Marca y modelo:</label><div><ui-select multiple ng-model=vm.dataToFill.brands theme=bootstrap close-on-select=true on-select=\"vm.selectingBrand($select.selected,\'select\')\" on-remove=\"vm.selectingBrand($select.selected,\'remove\')\"><ui-select-match placeholder=Todos>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"data in vm.brands | filter:$select.search\"><div ng-bind-html=\"data.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=filterAlign><label>{{\'helpTipoContratoLabel\' | translate}}:</label><div><ui-select ng-model=vm.dataToFill.tipo_contrato name=branch ng-keyup=vm.contratoSearch($select.search,$event) required close-on-select=true ng-change=vm.changeFilter();vm.socketFuncation()><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in vm.tipo_contrato | filter: $select.search | orderBy:\'name\' \" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.changeFilterDate();><div ng-bind-html=data.name></div></ui-select-choices></ui-select></div></div><div class=filterAlignTraffic><label>{{\'helpTrafficLabel\' | translate}}:</label><div><td><i class=boleeanTypeColor ng-click=\"vm.setBooleans(\'HELP_TRAFFIC\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.helpTraffic , \'fa fa-toggle-off\': !vm.dataToFill.helpTraffic}\"></i></td></div></div></div><div class=row id=collapseNew><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px;float: right\" ng-click=vm.applyFilter();vm.makeMapCenterAccToBranch(vm.dataToFill.branch)>Apply Filter</button></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px\" ng-click=vm.resetFilter()>{{\'resetFilterButton\' | translate}}</button></div></div><!--<div class=\"row mt5\">--><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\">--><!--<button class=\"btn btn-info\" style=\"min-width: 100px;\" ng-click=\"vm.showDriversWithFilter(vm.dataToFill)\">Filter</button>--><!--<button class=\"btn btn-info\" ng-click=\"vm.removeFilter()\">Reset</button>--><!--</div>--><!--</div>--></div></div></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div><div id=map-div-content class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\" style=position:relative><div id=googleMap style=\"height: 700px\"></div><div style=\"position: absolute;bottom:30px;right:0;left:0;margin:auto;background-color: white;color:black;width:260px;padding:5px\" ng-if=vm.dataToFill.helpTraffic><span>Live Traffic</span>&nbsp;&nbsp;&nbsp;&nbsp; <span style=font-size:12px;color:grey>Fast</span>&nbsp;&nbsp; <span><img src=assets/images/traffic-legend.png> </span>&nbsp;&nbsp; <span style=font-size:12px;color:grey>Slow</span></div><div style=\"position: absolute;top:10px;left:25px\"><!-- <button ng-class=\"{\'offDuty\': !vm.offDuty_1,\'offDutyActive\' : vm.offDuty_1}\" type=\"button\" ng-click=\"vm.showFleetsWithFilter(2)\"\n                                title=\"{{\'offDutyLabel\' | translate}}\">\n                                <span>\n                                    <i class=\"fa fa-map-marker\" aria-hidden=\"true\"></i>\n                                </span>&nbsp;{{vm.dataToFill.total_no_of_off_duty_drivers}}</button> --> <button ng-class=\"{\'onDuty\': !vm.onDuty_1,\'onDutyActive\' : vm.onDuty_1}\" type=button ng-click=vm.showFleetsWithFilter(1) title=\"{{\'onDutyLabel\' | translate}}\" class=boxShadow><span><i class=\"fa fa-map-marker\" aria-hidden=true></i> </span>&nbsp;{{vm.dataToFill.total_no_of_drivers_on_duty}}</button> <button ng-class=\"{\'started\': !vm.started_1,\'startedActive\' : vm.started_1}\" type=button ng-click=vm.showFleetsWithFilter(3) title=\"{{\'onRoadLabel\' | translate}}\" class=boxShadow><span><i class=\"fa fa-map-marker\" aria-hidden=true></i> </span>&nbsp;{{vm.dataToFill.total_no_of_started_drivers}}</button> <button ng-class=\"{\'atPosition\': !vm.inPosition_1,\'atPositionActive\' : vm.inPosition_1}\" type=button ng-click=vm.showFleetsWithFilter(5) title=\"{{\'atPositionLabel\' | translate}}\" class=boxShadow><span><i class=\"fa fa-map-marker\" aria-hidden=true></i> </span>&nbsp;{{vm.dataToFill.total_no_of_at_position_drivers}}</button> <button ng-class=\"{\'busy\': !vm.busy_1,\'busyActive\' : vm.busy_1}\" type=button ng-click=vm.showFleetsWithFilter(4) title=\"{{\'serviceStartedLabel\' | translate}}\" class=boxShadow><span><i class=\"fa fa-map-marker\" aria-hidden=true></i> </span>&nbsp;{{vm.dataToFill.total_no_of_busy_drivers}}</button> <button ng-class=\"{\'all\': !vm.all_1,\'allActive\' : vm.all_1}\" type=button ng-click=vm.showFleetsWithFilter(0) style=color:white title=\"{{\'allLabel\' | translate}}\" class=boxShadow><span><i class=\"fa fa-map-marker\" aria-hidden=true></i> </span>&nbsp;{{vm.dataToFill.total_no_of_drivers_available}}</button></div><div style=\"position: absolute;top:10px;right:25px\"><input id=pac-input class=controls ng-change=vm.getSearchedAddress(vm.searchedAddress) type=text ng-model=vm.searchedAddress style=color:#000;width:220px;height:35px placeholder=\"{{\'searchLocationPlaceholder\' | translate}}\" domain={{vm.domain}} google-place callback-fn=vm.ctrlFn(data)><!-- <input type=\"text\" ng-model=\"vm.uniqueCarNumberSearch\" placeholder=\"{{\'searchBoxPlaceholder\' | translate}}\" uib-typeahead=\"carsUnique as carsUnique.unique_car_id for carsUnique in vm.uniqueCarsArray | filter:{unique_car_id:$viewValue}\"\n                                typeahead-loading=\"loadingCustomers\" typeahead-no-results=\"noResults\" name=\"searchUnique\" typeahead-on-select=\"vm.onSelectingUnique(vm.uniqueCarNumberSearch)\"\n                                style=\"color:#000;width:220px;height:35px;margin-right:10px;\" ng-change=\"vm.getSearchedAddress(vm.uniqueCarNumberSearch)\"> --> <input type=text ng-model=vm.uniqueCarNumberSearch placeholder=\"Buscar Vehículo\" typeahead-loading=loadingCustomers typeahead-no-results=noResults name=searchUnique style=color:#000;width:220px;height:35px;margin-right:10px ng-blur=vm.getVehicleOnSearch(vm.uniqueCarNumberSearch)><div ng-if=noResults class=mt5 style=\"background-color: #fff;padding: 3px;width:220px\"><span><i class=\"glyphicon glyphicon-remove\"></i> No Results Found</span></div></div></div><div style=clear:both></div></div><!--<center><div class=\"row\" id=\"googleMapsDetailsWithCar\">--><!--<div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\">--><!--<div class=\"row\">--><!--<div class=\"col-lg-4 col-sm-4 col-xs-4 col-md-4\">--><!--<img src=\"assets/images/noImage.jpeg\" />--><!--</div>--><!--<div class=\"col-lg-8 col-sm-8 col-xs-8 col-md-8 paddingZero\">--><!--<h1 style=\"\">Driver Free</h1>--><!--<p id=\"driver\">Driver</p>--><!--<p class=\"details\">Vinay Kumar</p>--><!--<p class=\"details\">+56987677654</p>--><!--<p class=\"details\">Vehicle #45566</p>--><!--<button class=\"btn btn-primary tableButton\">Off Duty</button>--><!--</div>--><!--</div>--><!--</div>--><!--</div></center>--></div></div></div><!--<div class=\"row\">--><!--<div class=\"col-lg-6\">--><!--<div id=\"googleMapTest\" style=\"height: 400px;\"></div>--><!--</div>--><!--<div class=\"col-lg-4\">--><!--<div id=\"panelMap\" style=\"overflow: auto;height:400px;\"></div>--><!--</div>--><!--</div>--></div>");
$templateCache.put("app/components/views/dashboard/dashboardMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/driver-earning/driverEarning.html","<h2 class=ng-cloak>{{\'driverEarningHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><p class=totalSize><span class=pull-right><a class=\"btn btn-primary mb10\" ng-click=vm.addNewEarning($event)>+ {{\'addNewButton\' | translate}}</a> </span>{{\'totalearnings\' | translate}}: {{vm.totalEarnings}}</p></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\" ng-switch=\"(vm.erningList | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'matrix_id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'branchLabel\' | translate}}\" text=\"\'region_name\'\" check=vm.reverse>{{\'branchLabel\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'serviceLabel\' | translate}}\" text=\"\'service_name\'\" check=vm.reverse>{{\'serviceLabel\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'vehiclesLabel\' | translate}}\" text=\"\'name\'\" check=vm.reverse>{{\'vehiclesLabel\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'forAirport\' | translate}}\" text=\"\'airport_trip_charge\'\" check=vm.reverse>{{\'forAirport\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'forNonAirport\' | translate}}\" text=\"\'non_airport_trip_charge\'\" check=vm.reverse>{{\'forNonAirport\' | translate}}</th><th style=width:100px><div class=text-center>{{\'action\' | translate}}</div></th><th style=width:150px><div class=text-center>{{\'adminLogs\' | translate}}</div></th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.erningList| filter:vm.search | orderBy:vm.predicate:vm.reverse\"><td style=width:70px hidden class=text-center>{{data.index + 1}}</td><td style=width:70px class=text-center>{{::data.matrix_id}}</td><td style=width:100px class=text-center>{{::data.region_name}}</td><td style=width:125px class=text-center>{{::data.service_name}}</td><td style=width:125px class=text-center>{{::data.name}}</td><td style=width:125px class=text-center>{{::data.airport_trip_charge}}</td><td style=width:125px class=text-center>{{::data.non_airport_trip_charge}}</td><td style=width:100px class=text-center><a title=\"Edit Details\" class=\"cursor editIconColor btn btn-sm\" ng-click=vm.editEarningPop(data,$event)><i class=\"fa fa-edit\"></i></a></td><td style=width:150px class=text-center><a class=\"btn btn-primary tableButton\" title=\"{{\'adminLogs\' | translate}}\" ui-sref=\"layout.driverEarningMain.adminLogs({userId:\'{{data.matrix_id}}\',type:\'4\',fakeType:\'6\'})\">{{\'adminLogs\' | translate}}</a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noEarning\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav ng-show=\"vm.watchPagination\">--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\"--><!--ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/driver-earning/driverEarningMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/driver-evaluation/driverEvaluation.html","<h2 class=ng-cloak>{{\'driverEvaluationHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label for=Template>{{\'templateLabel\' | translate}}</label><!-- CHANGE EMAIL TYPE --><div class=_template_select><select ng-model=vm.selectEmailType ng-change=vm.changeEmailType();><option value=\"\" disabled hidden>Select Type</option><option value=0>Mail</option><option value=1>1 star</option><option value=2>2 star</option><option value=3>3 star</option><option value=4>4 star</option><option value=5>5 star</option></select></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 p10\"><!-- EMAIL TITLE HEADER --><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'driverRaingEmailTitleLabel\' | translate}} <button type=button class=\"pull-right _driver_rating_title_button\" ng-click=vm.sendDataAPI()>{{\'driverRaingEmailTitleButtonLabel\' | translate}}</button></p><!-- EMAIL TITLE TEXTBOX --><div style=\"padding: 15px\"><textarea class=form-control rows=4 cols=50 ng-model=vm.emailTitle> </textarea></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 p10\"><!-- EMAIL DESRIPTION HEADER --><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'driverRaingEmailDescriptionLabel\' | translate}} <button type=button class=\"pull-right _driver_rating_title_button\" ng-click=vm.sendDataAPI()>{{\'driverRaingEmailDescriptionButtonLabel\' | translate}}</button></p><!-- EMAIL DESRIPTION TEXTBOX --><div style=\"padding: 15px\"><textarea class=form-control rows=4 cols=50 ng-model=vm.emailDescription> </textarea></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 p10\" ng-if=\"vm.selectEmailType !=\'0\'\"><!-- EMAIL COMMENTS HEADER --><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'driverRaingEmailCommentsLabel\' | translate}} <button type=button ng-if=!vm.addComment class=\"pull-left _driver_rating_title_button\" ng-click=\"vm.addComment = !vm.addComment\">+{{\'driverRaingEmailCommentsAddCategoriesButtonLabel\' | translate}}</button> <input type=text ng-if=vm.addComment ng-model=vm.addcommentLabel class=pull-left style=\"color: silver\" placeholder=\"{{\'addComment\' | translate}}\"> <button type=button style=\"margin-left: 10px\" ng-if=vm.addComment class=\"pull-left _driver_rating_title_button\" ng-click=\"vm.addCommentButton();vm.addComment = !vm.addComment;\">{{\'addComment\' | translate}}</button> <button type=button class=\"pull-right _driver_rating_title_button\" ng-click=vm.sendDataAPI()>{{\'driverRaingEmailCommentsButtonLabel\' | translate}}</button></p><!-- EMAIL COMMENTS TEXTBOX --><div style=\"padding: 15px\"><div class=form-control style=\"height: 100px;width: 100%\"><div ng-repeat=\"comment in vm.commentCategories\" class=_comment_label>{{comment.label}} <span class=\"fa fa-close\" ng-click=vm.deleteComment($index)></span></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/driver-evaluation/driverEvaluationMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/employee/addEmployee.html","<div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'enterDetailsHead\' | translate}}</p><div class=basicDetailsDiv><form name=manangeEmployeeForm ng-submit=\"submit=true;manangeEmployeeForm.$valid&&vm.registerApi($event)\" novalidate autocomplete=off><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'firstNameLabel\' | translate}}<span style=color:red>*</span></label><input data-testid=add_nombre type=text class=form-control ng-model=vm.dataToFill.employee_list.first_name name=firstName placeholder=\"{{\'firstNameLabel\' | translate}}\" required ng-maxlength=60 ng-minlength=2 ng-class=\"{ \'has-error\': manangeEmployeeForm.firstName.$touched && manangeEmployeeForm.firstName.$invalid }\" pattern=^[a-zA-Z][a-zA-Z\\s]*$><div ng-if=\"manangeEmployeeForm.firstName.$touched|| submit\" ng-messages=manangeEmployeeForm.firstName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'firstNameRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'firstNameValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'firstNameMaximum\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'lastNameLabel\' | translate}}<span style=color:red>*</span></label><input data-testid=add_apellido type=text class=form-control ng-model=vm.dataToFill.employee_list.last_name name=lastName placeholder=\"{{\'lastNameLabel\' | translate}}\" required ng-maxlength=60 ng-minlength=2 ng-class=\"{ \'has-error\': manangeEmployeeForm.lastName.$touched && manangeEmployeeForm.lastName.$invalid }\" pattern=^[a-zA-Z][a-zA-Z\\s]*$><div ng-if=\"manangeEmployeeForm.lastName.$touched|| submit\" ng-messages=manangeEmployeeForm.lastName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'lastNameRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'lastNameValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'lastNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'lastNameMaximum\' | translate}}</div></div></div></div><div class=row><div class=\"col-lg-6 col-ms-6 col-md-6 col-xs-12\"><label>{{\'employeeEmail\' | translate}}<span style=color:red>*</span></label><input data-testid=add_email type=text placeholder=\"{{\'employeeEmail\' | translate}}\" ng-model=vm.dataToFill.employee_list.email class=form-control name=employeeEmail required ng-class=\"{ \'has-error\': manangeEmployeeForm.employeeEmail.$touched && manangeEmployeeForm.employeeEmail.$invalid }\" pattern=^([_a-zA-Z0-9-+]+)(\\.[_a-zA-Z0-9-+]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*\\.)+([a-zA-Z]{2,12})$><div ng-if=\"manangeEmployeeForm.employeeEmail.$touched|| submit\" ng-messages=manangeEmployeeForm.employeeEmail.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'employeeEmailReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'employeeEmailValid\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'phoneNumber\' | translate}}</label><input data-testid=add_phone type=text class=form-control ng-model=vm.dataToFill.employee_list.phone_number name=phone_number placeholder=\"{{\'phoneNumber\' | translate}}\" ng-class=\"{ \'has-error\': manangeEmployeeForm.phone_number.$touched && manangeEmployeeForm.phone_number.$invalid }\" pattern=^([1-9]{1}[0-9]{8})*$ ng-minlength=9 ng-maxlength=9><div ng-if=\"manangeEmployeeForm.phone_number.$touched|| submit\" ng-messages=manangeEmployeeForm.phone_number.$error><!--<div class=\"errormessage text-danger\" ng-message=\"required\">{{\'mobileRequired\' | translate}}--><!--</div>--><div class=\"errormessage text-danger\" ng-message=pattern>{{\'phoneValid\' | translate}}</div></div></div></div><div class=\"col-lg-12 col-ms-12 col-md-12 col-xs-12\" style=\"margin-top: 5px;text-align: justify\"><strong><u style=\"font-size: 20px\">Importante</u>:</strong> <span style=\"font-size: 18px;font-weight: 450\">Cualquier cambio que se haga en el nombre, apellido o teléfono del Empleado, automáticamente también<br>actualizará los mismos datos en la respectiva cuenta de usuario vinculada y en todos los perfiles corporativos que pertenezcan a dicha cuenta.</span></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'position\' | translate}}</label><input data-testid=add_position type=text class=form-control ng-model=vm.dataToFill.employee_list.position name=position placeholder=\"{{\'position\' | translate}}\" ng-class=\"{ \'has-error\': manangeEmployeeForm.position.$touched && manangeEmployeeForm.position.$invalid }\"><div ng-if=\"manangeEmployeeForm.position.$touched|| submit\" ng-messages=manangeEmployeeForm.position.$error><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter--><!--position--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid position.--><!--</div>--></div></div><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=\"vm.dataToFill.employee_list.show_order_of_work\">--><!--<label class=\"control-label\">{{\'workOrderText\' | translate}}</label>--><!--<input type=\"text\" class=\"form-control\"--><!--ng-model=\"vm.dataToFill.employee_list.order_of_work\" name=\"order_of_work\"--><!--placeholder=\"{{\'workOrderText\' | translate}}\"--><!--ng-class=\"{ \'has-error\': manangeEmployeeForm.order_of_work.$touched && manangeEmployeeForm.order_of_work.$invalid }\" ng-maxlength=\"15\" maxlength=\"15\"/>--><!--<div ng-if=\"manangeEmployeeForm.order_of_work.$touched|| submit\"--><!--ng-messages=\"manangeEmployeeForm.order_of_work.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"maxlength\">{{\'max15\' | translate}}--><!--</div>--><!--&lt;!&ndash;<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter&ndash;&gt;--><!--&lt;!&ndash;position&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a&ndash;&gt;--><!--&lt;!&ndash;valid position.&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--</div>--></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=\"control-label additionalFont\">{{\'additionalData\' | translate}}:</label></div></div><div style=\"border:1px solid black\" class=\"row pb5 m0\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><!--ng-if=\"vm.dataToFill.registration_flag != \'2\'\"--><label class=control-label>{{\'rutLabel\' | translate}}</label><input type=text class=form-control ng-model=vm.dataToFill.employee_list.RUT name=RUT placeholder=\"{{\'rutLabel\' | translate}}\" ng-rut ng-change=vm.rutChange() ng-class=\"{ \'has-error\': manangeEmployeeForm.RUT.$touched && manangeEmployeeForm.RUT.$invalid }\" maxlength=13><div ng-if=\"manangeEmployeeForm.RUT.$touched|| submit\" ng-messages=manangeEmployeeForm.RUT.$error><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter an--><!--RUT--><!--</div>--></div><div class=\"errormessage text-danger\" ng-if=vm.dataToFill.employee_list.rutFlag>{{\'rutValid\' | translate}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><!--ng-if=\"vm.dataToFill.employee_list.show_cost_center\"--><label class=control-label>{{\'costCenterText\' | translate}}</label><input type=text class=form-control ng-model=vm.dataToFill.employee_list.cost_center name=costCenter placeholder=\"{{\'costCenterText\' | translate}}\" ng-class=\"{ \'has-error\': manangeEmployeeForm.costCenter.$touched && manangeEmployeeForm.costCenter.$invalid }\" ng-maxlength=50 maxlength=50><div ng-if=\"manangeEmployeeForm.costCenter.$touched|| submit\" ng-messages=manangeEmployeeForm.costCenter.$error><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter--><!--position--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid position.--><!--</div>--><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'usernameMax\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><!--ng-if=\"vm.dataToFill.employee_list.show_cost_subCenter\"--><label class=control-label>{{\'subCostText\' | translate}}</label><input type=text class=form-control ng-model=vm.dataToFill.employee_list.cost_subCenter name=costSubCenter placeholder=\"{{\'subCostText\' | translate}}\" ng-class=\"{ \'has-error\': manangeEmployeeForm.costSubCenter.$touched && manangeEmployeeForm.costSubCenter.$invalid }\" ng-maxlength=50 maxlength=50><div ng-if=\"manangeEmployeeForm.costSubCenter.$touched|| submit\" ng-messages=manangeEmployeeForm.costSubCenter.$error><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'usernameMax\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter--><!--position--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid position.--><!--</div>--></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><!-- ng-if=\"vm.dataToFill.employee_list.show_ROL\"--><label class=control-label>{{\'ROLText\' | translate}}</label><input type=text class=form-control ng-model=vm.dataToFill.employee_list.ROL name=ROL placeholder=\"{{\'ROLText\' | translate}}\" ng-class=\"{ \'has-error\': manangeEmployeeForm.ROL.$touched && manangeEmployeeForm.ROL.$invalid }\" ng-maxlength=50 maxlength=50><div ng-if=\"manangeEmployeeForm.ROL.$touched|| submit\" ng-messages=manangeEmployeeForm.ROL.$error><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'usernameMax\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter--><!--position--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid position.--><!--</div>--></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><!--ng-if=\"vm.dataToFill.employee_list.show_graph\"--><label class=control-label>{{\'graphText\' | translate}}</label><input type=text class=form-control ng-model=vm.dataToFill.employee_list.graph name=graph placeholder=\"{{\'graphText\' | translate}}\" ng-class=\"{ \'has-error\': manangeEmployeeForm.graph.$touched && manangeEmployeeForm.graph.$invalid }\" ng-maxlength=50 maxlength=50><div ng-if=\"manangeEmployeeForm.graph.$touched|| submit\" ng-messages=manangeEmployeeForm.graph.$error><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'usernameMax\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter--><!--position--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid position.--><!--</div>--></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><!--ng-if=\"vm.dataToFill.employee_list.show_PEP\"--><label class=control-label>{{\'PEPText\' | translate}}</label><input type=text class=form-control ng-model=vm.dataToFill.employee_list.PEP name=PEP placeholder=\"{{\'PEPText\' | translate}}\" ng-class=\"{ \'has-error\': manangeEmployeeForm.PEP.$touched && manangeEmployeeForm.PEP.$invalid }\" ng-maxlength=50 maxlength=50><div ng-if=\"manangeEmployeeForm.PEP.$touched|| submit\" ng-messages=manangeEmployeeForm.PEP.$error><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'usernameMax\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter--><!--position--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid position.--><!--</div>--></div></div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'comments\' | translate}}</label><textarea class=form-control ng-model=vm.dataToFill.employee_list.comments name=comments placeholder=\"{{\'comments\' | translate}}\" ng-class=\"{ \'has-error\': manangeEmployeeForm.comments.$touched && manangeEmployeeForm.comments.$invalid }\"></textarea><div ng-if=\"manangeEmployeeForm.comments.$touched|| submit\" ng-messages=manangeEmployeeForm.comments.$error><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter--><!--position--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid position.--><!--</div>--></div></div></div><div class=row><div class=\"col-lg-12 col-ms-12 col-md-12 col-xs-12 table-responsive mt5\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean>{{\'thirdBooking\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleanEmployee(\'THIRD_BOOKING\',$index)\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.employee_list.thirdBooking , \'fa fa-toggle-off\': !vm.dataToFill.employee_list.thirdBooking}\"></i></td></tr><tr><td class=headingBollean>{{\'vipEmployee\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleanEmployee(\'VIP_EMPLOYEE\',$index)\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.employee_list.is_vip , \'fa fa-toggle-off\': !vm.dataToFill.employee_list.is_vip}\"></i></td></tr><tr><td class=headingBollean>{{\'approvalRequired\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleanEmployee(\'APPROVAL_REQUIRED\',$index)\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.employee_list.approval_required , \'fa fa-toggle-off\': !vm.dataToFill.employee_list.approval_required}\"></i></td></tr><tr><td class=headingBollean>{{\'permissionForAppLabel\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleanEmployee(\'APPROVAL_REQUIRED_BOOKING_APP\',$index)\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.employee_list.approval_required_booking_app , \'fa fa-toggle-off\': !vm.dataToFill.employee_list.approval_required_booking_app}\"></i></td></tr><tr><td class=headingBollean>{{\'permissionForPanelLabel\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleanEmployee(\'APPROVAL_REQUIRED_BOOKING_PANEL\',$index)\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.employee_list.approval_required_booking_panel , \'fa fa-toggle-off\': !vm.dataToFill.employee_list.approval_required_booking_panel}\"></i></td></tr></tbody></table></div></div><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=vm.dataToFill.employee_list.approval_required><label class=control-label>{{\'authRutLabel1\' | translate}}<span style=color:red>*</span></label><input type=text ng-model=vm.dataToFill.employee_list.auth_RUT placeholder=\"{{\'authSearch\' | translate}}\" uib-typeahead=\"auths.RUT as auths.name for auths in vm.allAuthList | filter:{name:$viewValue}\" typeahead-loading=loadingAuths typeahead-no-results=vm.noResults class=form-control name=authRUT typeahead-on-select=vm.onSelectingAuth() required ng-class=\"{ \'has-error\': manangeEmployeeForm.authRUT.$touched && manangeEmployeeForm.authRUT.$invalid }\"> <i ng-if=loadingAuths class=\"glyphicon glyphicon-refresh\"></i><div ng-if=vm.noResults class=mt5><span><i class=\"glyphicon glyphicon-remove\"></i> {{\'searchCustError\' | translate}}</span></div><!--<input type=\"text\" class=\"form-control\"--><!--ng-model=\"vm.dataToFill.employee_list.auth_RUT\" name=\"authRUT\"--><!--placeholder=\"Auth RUT\" ng-rut ng-change=\"vm.rutChangePerson()\" required--><!--ng-class=\"{ \'has-error\': manangeEmployeeForm.authRUT.$touched && manangeEmployeeForm.authRUT.$invalid }\"/>--><div ng-if=\"manangeEmployeeForm.authRUT.$touched|| submit\" ng-messages=manangeEmployeeForm.authRUT.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'authRutNumberReq\' | translate}}</div></div><div class=\"errormessage text-danger\" ng-if=vm.dataToFill.employee_list.rutFlag_person>{{\'authRutNumberValid\' | translate}}</div></div></div><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" style=margin-top:10px><button type=submit class=\"btn btn-primary\" style=width:40%>{{\'submit\' | translate}}</button> <button type=button ng-click=vm.cancel() class=\"btn btn-danger\" style=width:40%>{{\'cancelButton\' | translate}}</button></div></div></form></div></div>");
$templateCache.put("app/components/views/employee/editEmployee.html","<div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'editDetailsButton\' | translate}}</p><div class=basicDetailsDiv><form name=editEmployeeForm ng-submit=\"submit=true;editEmployeeForm.$valid&&vm.editApi()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'firstNameLabel\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.employee_list.first_name name=firstName placeholder=\"{{\'firstNameLabel\' | translate}}\" required ng-maxlength=60 ng-minlength=2 ng-class=\"{ \'has-error\': editEmployeeForm.firstName.$touched && editEmployeeForm.firstName.$invalid }\" pattern=^\\D*$><div ng-if=\"editEmployeeForm.firstName.$touched|| submit\" ng-messages=editEmployeeForm.firstName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'firstNameRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'firstNameValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'firstNameMaximum\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'lastNameLabel\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.employee_list.last_name name=lastName placeholder=\"{{\'lastNameLabel\' | translate}}\" required ng-maxlength=60 ng-minlength=2 ng-class=\"{ \'has-error\': editEmployeeForm.lastName.$touched && editEmployeeForm.lastName.$invalid }\" pattern=^\\D*$><div ng-if=\"editEmployeeForm.lastName.$touched|| submit\" ng-messages=editEmployeeForm.lastName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'lastNameRequired\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'lastNameValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'lastNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'lastNameMaximum\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-ms-6 col-md-6 col-xs-12\"><label>{{\'employeeEmail\' | translate}} <span style=color:red>*</span></label><input type=text placeholder=\"{{\'employeeEmail\' | translate}}\" ng-model=vm.dataToFill.employee_list.email class=form-control name=employeeEmail required ng-class=\"{ \'has-error\': editEmployeeForm.employeeEmail.$touched && editEmployeeForm.employeeEmail.$invalid }\" pattern=^([_a-zA-Z0-9-+]+)(\\.[_a-zA-Z0-9-+]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*\\.)+([a-zA-Z]{2,3})$><div ng-if=\"editEmployeeForm.employeeEmail.$touched|| submit\" ng-messages=editEmployeeForm.employeeEmail.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'employeeEmailReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'employeeEmailValid\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'phoneNumber\' | translate}}</label><input type=text class=form-control ng-model=vm.dataToFill.employee_list.phone_number name=phone_number placeholder=\"{{\'phoneNumber\' | translate}}\" ng-class=\"{ \'has-error\': editEmployeeForm.phone_number.$touched && editEmployeeForm.phone_number.$invalid }\" pattern=^([1-9]{1}[0-9]{8})*$ ng-minlength=9 ng-maxlength=9><div ng-if=\"editEmployeeForm.phone_number.$touched|| submit\" ng-messages=editEmployeeForm.phone_number.$error><!--<div class=\"errormessage text-danger\" ng-message=\"required\">{{\'mobileRequired\' | translate}}--><!--</div>--><div class=\"errormessage text-danger\" ng-message=pattern>{{\'phoneValid\' | translate}}</div></div></div></div><div class=\"col-lg-12 col-ms-12 col-md-12 col-xs-12\" style=\"margin-top: 5px;text-align: justify\"><strong><u style=\"font-size: 20px\">Importante</u>:</strong> <span style=\"font-size: 18px;font-weight: 450\">Cualquier cambio que se haga en el nombre, apellido o teléfono del Empleado, automáticamente también<br>actualizará los mismos datos en la respectiva cuenta de usuario vinculada y en todos los perfiles corporativos que pertenezcan a dicha cuenta.</span></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'position\' | translate}}</label><input type=text class=form-control ng-model=vm.dataToFill.employee_list.position name=position placeholder=\"{{\'position\' | translate}}\" ng-class=\"{ \'has-error\': manangeEmployeeForm.position.$touched && manangeEmployeeForm.position.$invalid }\"><div ng-if=\"manangeEmployeeForm.position.$touched|| submit\" ng-messages=manangeEmployeeForm.position.$error><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter--><!--position--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid position.--><!--</div>--></div></div><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=\"vm.dataToFill.employee_list.show_order_of_work\">--><!--<label class=\"control-label\">{{\'workOrderText\' | translate}}</label>--><!--<input type=\"text\" class=\"form-control\"--><!--ng-model=\"vm.dataToFill.employee_list.order_of_work\" name=\"order_of_work\"--><!--placeholder=\"{{\'workOrderText\' | translate}}\"--><!--ng-class=\"{ \'has-error\': manangeEmployeeForm.order_of_work.$touched && manangeEmployeeForm.order_of_work.$invalid }\" ng-maxlength=\"15\" maxlength=\"15\"/>--><!--<div ng-if=\"manangeEmployeeForm.order_of_work.$touched|| submit\"--><!--ng-messages=\"manangeEmployeeForm.order_of_work.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"maxlength\">{{\'max15\' | translate}}--><!--</div>--><!--&lt;!&ndash;<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter&ndash;&gt;--><!--&lt;!&ndash;position&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--&lt;!&ndash;<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a&ndash;&gt;--><!--&lt;!&ndash;valid position.&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--</div>--></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=\"control-label additionalFont\">{{\'additionalData\' | translate}}:</label></div></div><div style=\"border:1px solid black\" class=\"row pb5 m0\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><!--ng-if=\"vm.dataToFill.registration_flag != \'2\'\"--><label class=control-label>{{\'rutLabel\' | translate}}</label><input type=text class=form-control ng-model=vm.dataToFill.employee_list.RUT name=RUT placeholder=\"{{\'rutLabel\' | translate}}\" ng-rut ng-change=vm.rutChange() ng-class=\"{ \'has-error\': editEmployeeForm.RUT.$touched && editEmployeeForm.RUT.$invalid }\" maxlength=13><div ng-if=\"editEmployeeForm.RUT.$touched|| submit\" ng-messages=editEmployeeForm.RUT.$error><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter an--><!--RUT--><!--</div>--></div><div class=\"errormessage text-danger\" ng-if=vm.dataToFill.employee_list.rutFlag>{{\'rutValid\' | translate}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><!--ng-if=\"vm.dataToFill.employee_list.show_cost_center\"--><label class=control-label>{{\'costCenterText\' | translate}}</label><input type=text class=form-control ng-model=vm.dataToFill.employee_list.cost_center name=costCenter placeholder=\"{{\'costCenterText\' | translate}}\" ng-class=\"{ \'has-error\': manangeEmployeeForm.costCenter.$touched && manangeEmployeeForm.costCenter.$invalid }\" ng-maxlength=50 maxlength=50><div ng-if=\"manangeEmployeeForm.costCenter.$touched|| submit\" ng-messages=manangeEmployeeForm.costCenter.$error><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'usernameMax\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter--><!--position--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid position.--><!--</div>--></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><!--ng-if=\"vm.dataToFill.employee_list.show_cost_subCenter\"--><label class=control-label>{{\'subCostText\' | translate}}</label><input type=text class=form-control ng-model=vm.dataToFill.employee_list.cost_subCenter name=costSubCenter placeholder=\"{{\'subCostText\' | translate}}\" ng-class=\"{ \'has-error\': manangeEmployeeForm.costSubCenter.$touched && manangeEmployeeForm.costSubCenter.$invalid }\" ng-maxlength=50 maxlength=50><div ng-if=\"manangeEmployeeForm.costSubCenter.$touched|| submit\" ng-messages=manangeEmployeeForm.costSubCenter.$error><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'usernameMax\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter--><!--position--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid position.--><!--</div>--></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><!--ng-if=\"vm.dataToFill.employee_list.show_ROL\"--><label class=control-label>{{\'ROLText\' | translate}}</label><input type=text class=form-control ng-model=vm.dataToFill.employee_list.ROL name=ROL placeholder=\"{{\'ROLText\' | translate}}\" ng-class=\"{ \'has-error\': manangeEmployeeForm.ROL.$touched && manangeEmployeeForm.ROL.$invalid }\" ng-maxlength=50 maxlength=50><div ng-if=\"manangeEmployeeForm.ROL.$touched|| submit\" ng-messages=manangeEmployeeForm.ROL.$error><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'usernameMax\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter--><!--position--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid position.--><!--</div>--></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><!--ng-if=\"vm.dataToFill.employee_list.show_graph\"--><label class=control-label>{{\'graphText\' | translate}}</label><input type=text class=form-control ng-model=vm.dataToFill.employee_list.graph name=graph placeholder=\"{{\'graphText\' | translate}}\" ng-class=\"{ \'has-error\': manangeEmployeeForm.graph.$touched && manangeEmployeeForm.graph.$invalid }\" ng-maxlength=50 maxlength=50><div ng-if=\"manangeEmployeeForm.graph.$touched|| submit\" ng-messages=manangeEmployeeForm.graph.$error><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'usernameMax\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter--><!--position--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid position.--><!--</div>--></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><!--ng-if=\"vm.dataToFill.employee_list.show_PEP\"--><label class=control-label>{{\'PEPText\' | translate}}</label><input type=text class=form-control ng-model=vm.dataToFill.employee_list.PEP name=PEP placeholder=\"{{\'PEPText\' | translate}}\" ng-class=\"{ \'has-error\': manangeEmployeeForm.PEP.$touched && manangeEmployeeForm.PEP.$invalid }\" ng-maxlength=50 maxlength=50><div ng-if=\"manangeEmployeeForm.PEP.$touched|| submit\" ng-messages=manangeEmployeeForm.PEP.$error><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'usernameMax\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter--><!--position--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid position.--><!--</div>--></div></div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'comments\' | translate}}</label><textarea class=form-control ng-model=vm.dataToFill.employee_list.comments name=comments placeholder=\"{{\'messagePlaceholder\' | translate}}\" ng-class=\"{ \'has-error\': manangeEmployeeForm.comments.$touched && manangeEmployeeForm.comments.$invalid }\"></textarea><div ng-if=\"manangeEmployeeForm.comments.$touched|| submit\" ng-messages=manangeEmployeeForm.comments.$error><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please enter--><!--position--><!--</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a--><!--valid position.--><!--</div>--></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-ms-12 col-md-12 col-xs-12 table-responsive mt5\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean>{{\'thirdBooking\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleanEmployee(\'THIRD_BOOKING\',$index)\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.employee_list.thirdBooking , \'fa fa-toggle-off\': !vm.dataToFill.employee_list.thirdBooking}\"></i></td></tr><tr><td class=headingBollean>{{\'vipEmployee\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleanEmployee(\'VIP_EMPLOYEE\',$index)\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.employee_list.is_vip , \'fa fa-toggle-off\': !vm.dataToFill.employee_list.is_vip}\"></i></td></tr><tr><td class=headingBollean>{{\'approvalRequired\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleanEmployee(\'APPROVAL_REQUIRED\',$index)\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.employee_list.approval_required , \'fa fa-toggle-off\': !vm.dataToFill.employee_list.approval_required}\"></i></td></tr><tr><td class=headingBollean>{{\'permissionForAppLabel\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleanEmployee(\'APPROVAL_REQUIRED_BOOKING_APP\',$index)\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.employee_list.approval_required_booking_app , \'fa fa-toggle-off\': !vm.dataToFill.employee_list.approval_required_booking_app}\"></i></td></tr><tr><td class=headingBollean>{{\'permissionForPanelLabel\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleanEmployee(\'APPROVAL_REQUIRED_BOOKING_PANEL\',$index)\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.employee_list.approval_required_booking_panel , \'fa fa-toggle-off\': !vm.dataToFill.employee_list.approval_required_booking_panel}\"></i></td></tr></tbody></table></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=vm.dataToFill.employee_list.approval_required><label class=control-label>{{\'authRutLabel1\' | translate}} <span style=color:red>*</span></label><input type=text ng-model=vm.dataToFill.employee_list.auth_RUT placeholder=\"{{\'authSearch\' | translate}}\" uib-typeahead=\"auths.RUT as auths.name for auths in vm.allAuthList | filter:{name:$viewValue}\" typeahead-loading=loadingAuths typeahead-no-results=vm.noResults class=form-control name=authRUT typeahead-on-select=vm.onSelectingAuth() required ng-class=\"{ \'has-error\': editEmployeeForm.authRUT.$touched && editEmployeeForm.authRUT.$invalid }\"> <i ng-if=loadingAuths class=\"glyphicon glyphicon-refresh\"></i><div ng-if=vm.noResults class=mt5><span><i class=\"glyphicon glyphicon-remove\"></i> {{\'searchCustError\' | translate}}</span></div><!--<input type=\"text\" class=\"form-control\"--><!--ng-model=\"vm.dataToFill.employee_list.auth_RUT\" name=\"authRUT\"--><!--placeholder=\"Auth RUT\" ng-rut ng-change=\"vm.rutChangePerson()\" required--><!--ng-class=\"{ \'has-error\': editEmployeeForm.authRUT.$touched && editEmployeeForm.authRUT.$invalid }\"/>--><div ng-if=\"editEmployeeForm.authRUT.$touched|| submit\" ng-messages=editEmployeeForm.authRUT.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'authRutNumberReq\' | translate}}</div></div><div class=\"errormessage text-danger\" ng-if=vm.dataToFill.employee_list.rutFlag_person>{{\'authRutNumberValid\' | translate}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" style=margin-top:10px><button type=submit class=\"btn btn-primary\" style=width:40%>{{\'submit\' | translate}}</button> <button type=button ng-click=vm.cancel() class=\"btn btn-danger\" style=width:40%>{{\'cancelButton\' | translate}}</button></div></div></form></div></div>");
$templateCache.put("app/components/views/employee/manageEmployee.html","<h2 class=ng-cloak><span>{{\'agreementHead\' | translate}} / {{\'employeeHead\' | translate}}</span> <span class=pull-right><button class=\"btn btn-primary tableButton\" ng-click=vm.refreshData()>Volver a cargar</button></span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=employee><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 wordBreak\"><div class=\"row marginZero\"><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12 paddingZero\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 informationDetails\"><div class=information>{{\'employeeAgreDetails\' | translate}}:</div><div class=details><div><span class=pull-left><span class=informName>{{\'companyTableHead\' | translate}}:</span> <span class=informDetail>{{::vm.corporateName}}</span> </span><span class=pull-right><span class=informName>{{\'typeTableHead\' | translate}}:</span> <span class=informDetail>{{::vm.agreementType}}</span></span></div><div class=clearfix></div><div><span class=pull-left><span class=informName>{{\'agreementLabel\' | translate}}:</span> <span class=informDetail>{{::vm.contractName}}</span> </span><span class=pull-right><span class=informName>{{\'stateAgreement\' | translate}}:</span> <span class=informDetail ng-if=\"vm.agreementStatus == 1\">Active</span> <span class=informDetail ng-if=\"vm.agreementStatus == 0\">Inactive</span></span></div><div class=clearfix></div><div><span class=pull-left style=width:60%><span class=informName>{{\'typeServiceHead\' | translate}}:</span> <span ng-repeat=\"data in vm.agreementServices\"><span class=\"informDetail ml5\">{{::data}}</span></span></span><div class=clearfix></div><span class=pull-left style=width:60%><span class=informName>{{\'branchesTableHead\' | translate}}:</span> <span ng-repeat=\"data in vm.agreementBranches\"><span class=\"informDetail ml5\">{{::data}}</span> </span></span><span class=pull-right><a class=\"btn btn-primary mb25 agreementButtons\" style=\"background-color: #2f80e7;border-color: #2f80e7\" ng-click=vm.removeEmployees($event)>{{\'removeEmployeeButton\' | translate}}</a> <a class=\"btn btn-primary mb25 agreementButtons\" style=\"background-color: #2f80e7;border-color: #2f80e7\" ng-click=vm.addMoreEmployees()>+ {{\'addEmployeeButton\' | translate}}</a> <button type=button class=\"btn btn-primary mb25 agreementButtons\" ng-click=vm.uploadCSVPop($event) ng-if=\"vm.userType == 0\">{{\'uploadCSV\' | translate}}</button></span></div><div class=clearfix></div></div></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12 mt5 paddingZero\"><div ng-if=vm.addEmployeeFlag ng-include=\"\'app/components/views/employee/addEmployee.html\'\"></div><div ng-if=vm.editEmployeeFlag ng-include=\"\'app/components/views/employee/editEmployee.html\'\" id=editEmployee></div></div></div><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5\"><span class=pull-left><a class=\"btn btn-primary tableButton mb10\" ng-click=vm.exportToCSV(0,vm.dataLength)>CSV</a></span></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model-options=\"{ debounce: 500 }\" ng-model=vm.dataToFill.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\" ng-switch=\"(vm.employeeList | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px>{{\'select\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'position\' | translate}}\" text=\"\'position\'\" check=vm.reverse>{{\'position\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'name\' | translate}}\" text=\"\'name\'\" check=vm.reverse>{{\'name\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'vipMarkTable\' | translate}}\" text=\"\'is_vip\'\" check=vm.reverse>{{\'vipMarkTable\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'email\' | translate}}\" text=\"\'email\'\" check=vm.reverse>{{\'email\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'mobileNumber\' | translate}}\" text=\"\'phone_number\'\" check=vm.reverse>{{\'phoneNumber\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'uniqueCode\' | translate}}\" text=\"\'uniquecode\'\" check=vm.reverse>{{\'uniqueCode\' | translate}}</th><th style=width:100px><div class=text-center>{{\'stateTable\' | translate}}</div></th><th style=width:150px><div class=text-center>{{\'action\' | translate}}</div></th><th style=width:150px ng-if=\"vm.userType == 0\"><div class=text-center>{{\'adminLogs\' | translate}}</div></th><th style=width:300px><div class=text-center>Contraseña</div></th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.employeeListGot| filter:vm.search | orderBy:vm.predicate:vm.reverse\"><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:70px><md-checkbox class=md-primary ng-click=vm.checkForDelete(data) ng-model=data.checked aria-label=EmployeeCheckbox></md-checkbox></td><td style=width:70px>{{::data.id}}</td><td style=width:100px>{{data.position || \'--\'}}</td><td style=width:125px>{{data.last_name?data.name + \' \' + data.last_name:data.name}}</td><td style=width:100px><span ng-if=\"data.is_vip == 1\">Yes</span> <span ng-if=\"data.is_vip == 0\">No</span></td><td style=width:125px>{{::data.email}}</td><td style=width:125px>{{::data.phone_number}}</td><td style=width:125px>{{::data.uniquecode}}</td><td style=width:100px><a class=\"cursor btn btn-sm\" ng-class=\"{\'blockIconColor\': data.status == 0, \'unblockIconColor\': data.status == 1}\" ng-click=vm.changeEmployeeStatus(data,$event)><i ng-class=\"{\'fa fa-unlock\': data.status == 1,\'fa fa-lock\': data.status == 0}\"></i></a></td><td style=width:150px><a title=\"Edit Details\" class=\"cursor editIconColor btn btn-sm\" ng-click=vm.editEmployeeDetails(data)><i class=\"fa fa-edit\"></i> </a><a title=\"View Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.agreementMain.viewEmployeeDetails({corporateId:\'{{vm.corporateID}}\',contractId:\'{{vm.contractID}}\',id: \'{{data.id}}\'})\"><i class=\"fa fa-eye\"></i> </a><a title=\"Delete Details\" ng-if=\"vm.userType == 0\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteEmployee(data,$event)><i class=\"fa fa-trash\"></i></a></td><td style=width:150px ng-if=\"vm.userType == 0\"><a class=\"btn btn-primary tableButton\" title=\"{{\'adminLogs\' | translate}}\" ui-sref=\"layout.agreementMain.adminLogs({userId:\'{{data.id}}\',type:\'11\',fakeType: \'17\'})\" ng-click=vm.storeDetails()>{{\'adminLogs\' | translate}}</a></td><td style=width:300px><a class=\"btn btn-primary tableButton\" ng-disabled=\"data.customer_id == null\" title=\"Admin Logs\" ng-click=vm.resetPassword(data)>Restablecer</a> <a class=\"btn btn-primary tableButton\" ng-disabled=\"data.customer_id == null\" title=\"Admin Logs\" ng-click=vm.SendEmail(data)>Enviar email</a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=9 class=\"noDataClass text-center\">No Employee Found.</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--<nav ng-show=\"vm.watchPagination\">--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\"--><!--ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/employee/viewEmployeeDetails.html","<h2 class=ng-cloak>{{\'agreementHead\' | translate}} / {{\'employeeHead\' | translate}} / {{\'employeeDetailsHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=driver><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 informationDetails\"><div class=information>{{\'employeeAgreDetails\' | translate}}:</div><div class=details><div><span class=pull-left><span class=informName>{{\'companyTableHead\' | translate}}:</span> <span class=informDetail>{{::vm.corporateName}}</span> </span><span class=pull-right><span class=informName>{{\'typeTableHead\' | translate}}:</span> <span class=informDetail>{{::vm.agreementType}}</span></span></div><div class=clearfix></div><div><span class=pull-left><span class=informName>{{\'agreementLabel\' | translate}}:</span> <span class=informDetail>{{::vm.contractName}}</span> </span><span class=pull-right><span class=informName>{{\'stateAgreement\' | translate}}:</span> <span class=informDetail ng-if=\"vm.agreementStatus == 1\">Active</span> <span class=informDetail ng-if=\"vm.agreementStatus == 0\">Inactive</span></span></div><div class=clearfix></div><div><span class=pull-left style=width:60%><span class=informName>{{\'typeServiceHead\' | translate}}:</span> <span ng-repeat=\"data in vm.agreementServices\"><span class=\"informDetail ml5\">{{::data}}</span></span></span><div class=clearfix></div><span class=pull-left style=width:60%><span class=informName>{{\'branchesTableHead\' | translate}}:</span> <span ng-repeat=\"data in vm.agreementBranches\"><span class=\"informDetail ml5\">{{::data}}</span></span></span></div><div class=clearfix></div></div></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12 mt5 paddingZero\"><div class=basicDiv><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'allDetails\' | translate}}</p><div class=basicDetailsDiv><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'name\' | translate}}:</label><div class=form-control>{{vm.employeeDetails.last_name?vm.employeeDetails.name + \' \' + vm.employeeDetails.last_name:vm.employeeDetails.name}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'email\' | translate}}:</label><div class=form-control>{{::vm.employeeDetails.email}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'phoneNumber\' | translate}}:</label><div class=form-control>{{::vm.employeeDetails.phone_number}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'rutLabel\' | translate}}:</label><div class=form-control>{{vm.employeeDetails.RUT || \'--\'}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'uniqueCode\' | translate}}:</label><div class=form-control>{{::vm.employeeDetails.uniquecode}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'employeeId\' | translate}}:</label><div class=form-control>{{::vm.employeeDetails.id}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'corpoID\' | translate}}:</label><div class=form-control>{{::vm.employeeDetails.corporate_id}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'position\' | translate}}:</label><div class=form-control>{{vm.employeeDetails.position || \'--\'}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'costCenterText\' | translate}}:</label><div class=form-control>{{vm.employeeDetails.cost_center || \'--\'}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'subCostText\' | translate}}:</label><div class=form-control>{{vm.employeeDetails.cost_subcenter || \'--\'}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'ROLText\' | translate}}:</label><div class=form-control>{{vm.employeeDetails.ROI || \'--\'}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'PEPText\' | translate}}:</label><div class=form-control>{{vm.employeeDetails.PEP || \'--\'}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'graphText\' | translate}}:</label><div class=form-control>{{vm.employeeDetails.graph || \'--\'}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'workOrderText\' | translate}}:</label><div class=form-control>{{vm.employeeDetails.order_of_work || \'--\'}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'thirdBooking\' | translate}}:</label><div class=form-control><span ng-if=\"vm.employeeDetails.thirdBooking == 1\">Yes</span> <span ng-if=\"vm.employeeDetails.thirdBooking == 0\">No</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'vipMarkTable\' | translate}}:</label><div class=form-control><span ng-if=\"vm.employeeDetails.is_vip == 1\">Yes</span> <span ng-if=\"vm.employeeDetails.is_vip == 0\">No</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'approvalRequired\' | translate}}:</label><div class=form-control><span ng-if=\"vm.employeeDetails.approval_required == 1\">Yes</span> <span ng-if=\"vm.employeeDetails.approval_required == 0\">No</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\" ng-if=\"vm.employeeDetails.approval_required == 1\"><label class=control-label>{{\'authRutLabel\' | translate}}:</label><div class=form-control>{{::vm.employeeDetails.auth_RUT}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'employeeDeleteLabel\' | translate}}:</label><div class=form-control><span ng-if=\"vm.employeeDetails.is_deleted == 1\">Yes</span> <span ng-if=\"vm.employeeDetails.is_deleted == 0\">No</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'employeeStatusLabel\' | translate}}:</label><div class=form-control><span ng-if=\"vm.employeeDetails.status == 1\">Active</span> <span ng-if=\"vm.employeeDetails.status == 0\">Inactive</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'createdAt\' | translate}}:</label><div class=form-control>{{vm.employeeDetails.created_on | date:\'medium\'}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'activatedAt\' | translate}}:</label><div class=form-control>{{vm.employeeDetails.activation_date | date:\'medium\'}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'comments\' | translate}}:</label><textarea class=form-control ng-model=vm.employeeDetails.comments readonly placeholder=\"No Comments\"></textarea></div></div><div class=row><div class=\"col-lg-12 col-ms-12 col-md-12 col-xs-12 table-responsive mt5\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean>{{\'thirdBooking\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleanEmployee(\'THIRD_BOOKING\',$index)\" ng-class=\"{\'fa fa-toggle-on\': vm.employeeDetails.thirdBooking , \'fa fa-toggle-off\': !vm.employeeDetails.thirdBooking}\"></i></td></tr><tr><td class=headingBollean>{{\'vipEmployee\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleanEmployee(\'VIP_EMPLOYEE\',$index)\" ng-class=\"{\'fa fa-toggle-on\': vm.employeeDetails.is_vip , \'fa fa-toggle-off\': !vm.employeeDetails.is_vip}\"></i></td></tr><tr><td class=headingBollean>{{\'approvalRequired\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleanEmployee(\'APPROVAL_REQUIRED\',$index)\" ng-class=\"{\'fa fa-toggle-on\': vm.employeeDetails.approval_required , \'fa fa-toggle-off\': !vm.employeeDetails.approval_required}\"></i></td></tr><tr><td class=headingBollean>{{\'permissionForAppLabel\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleanEmployee(\'APPROVAL_REQUIRED_BOOKING_APP\',$index)\" ng-class=\"{\'fa fa-toggle-on\': vm.employeeDetails.customer_booking_access , \'fa fa-toggle-off\': !vm.employeeDetails.customer_booking_access}\"></i></td></tr><tr><td class=headingBollean>{{\'permissionForPanelLabel\' | translate}}</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleanEmployee(\'APPROVAL_REQUIRED_BOOKING_PANEL\',$index)\" ng-class=\"{\'fa fa-toggle-on\': vm.employeeDetails.panel_booking_access , \'fa fa-toggle-off\': !vm.employeeDetails.panel_booking_access}\"></i></td></tr></tbody></table></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/expense-control/expenseControl.html","<h2 class=ng-cloak><span>{{\'defineBudget\' | translate}}</span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label class=control-label>{{\'branchLabel\' | translate}}</label><ui-select ng-model=vm.filterData.region_id ng-keyup=vm.branchSearch($select.search,$event) name=branch required close-on-select=true><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \" when-scrolled=vm.paginationChangedForBranch() ng-click=\"vm.getAllAgreements(0,vm.itemsPerPageGot,vm.filterData);vm.currentPage = 0;\"><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label>{{\'corporateLabel\' | translate}}</label><ui-select ng-model=vm.filterData.corporate_id ng-keyup=vm.corporateSearch($select.search,$event) name=corporateName required close-on-select=true><ui-select-match placeholder=\"{{\'corporatePlaceholder\' | translate}}\">{{$select.selected.company_name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in vm.corporatesList | filter: $select.search | orderBy:\'company_name\'\" when-scrolled=vm.paginationChangedForCorporation() ng-click=\"vm.getAllAgreements(0,vm.itemsPerPageGot,vm.filterData);vm.currentPage = 0;\"><div ng-bind-html=data.company_name></div></ui-select-choices></ui-select></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label class=control-label>{{\'agreementStatusLabel\' | translate}}</label><select class=form-control ng-model=vm.filterData.agreementStatus ng-change=\"vm.getAllAgreements(0,vm.itemsPerPageGot,vm.filterData);vm.currentPage = 0;vm.itemsPerPageSelected = 10;\"><option value=\"\" disabled>{{\'agreementStatusPlaceholder\' | translate}}</option><option value=3>Todos</option><option selected value=1>Activo</option><option value=0>Inactivo</option><option value=2>En Progreso</option></select></div><!-- <div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\">\n                        <label class=\"control-label\" style=\"visibility: hidden\">{{\'agreementStatusLabel\' | translate}}</label>\n                        <button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px\" ng-click=\"vm.applyFilter()\">Apply Filters</button>\n                </div> --><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center mt5\"><p class=totalSize>{{\'totalAgreement\' | translate}}: {{vm.totalAgreement}}</p></div><br><br><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model-options=\"{ debounce: 500 }\" ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\"><!--ng-switch=\"(vm.employeeList | filter:vm.search).length\"--><!--<div ng-switch-when=\"0\" class=\"noSearch\"><span>{{\'nothingFound\' | translate}}</span></div>--><table class=\"table table-hover tableWithMasterData\"><!--ng-switch-default--><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'typeTableHead\' | translate}}\" text=\"\'agreement_type\'\" check=vm.reverse>{{\'typeTableHead\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'name\' | translate}}\" text=\"\'name\'\" check=vm.reverse>{{\'name\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'companyTableHead\' | translate}}\" text=\"\'companyName\'\" check=vm.reverse>{{\'companyTableHead\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'categoryTableHead\' | translate}}\" text=\"\'commercial_classification\'\" check=vm.reverse>{{\'categoryTableHead\' | translate}}</th><!--<th>--><!--<div ng-click=\"vm.sort(\'companyRUT\')\">--><!--Company RUT--><!--<span ng-hide=\"vm.predicate == \'companyRUT\' && vm.reverse || vm.predicate == \'companyRUT\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'companyRUT\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'companyRUT\' && vm.reverse\" class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'paymentMethodLabel\' | translate}}\" text=\"\'paymentMethod\'\" check=vm.reverse>{{\'paymentMethodLabel\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'serviceTableHead\' | translate}}\" text=\"\'typeOfService\'\" check=vm.reverse>{{\'serviceTableHead\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'branchesTableHead\' | translate}}\" text=\"\'branch\'\" check=vm.reverse>{{\'branchesTableHead\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"Descuento de ida y vuelta\" text=\"\'branch\'\" check=vm.reverse>Descuento de ida y vuelta</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"Descuento por correo electrónico WebPay / URL\" text=\"\'branch\'\" check=vm.reverse>Descuento por correo electrónico WebPay / URL</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"Fixed list update\" text=\"\'fixedListUpdate\'\" check=vm.reverse>Presupuesto</th><th style=width:250px><div>{{\'action\' | translate}}</div></th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.agreementList | orderBy:vm.predicate:vm.reverse\"><!--| filter:vm.search --><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:70px>{{::data.id}}</td><td style=width:100px>{{::data.agreement_type}}</td><td style=width:125px>{{::data.name}}</td><td style=width:125px>{{::data.companyName}}</td><td style=width:125px>{{::data.commercial_classification}}</td><td style=width:125px><span ng-repeat=\"payment in data.paymentMethod\">{{payment}} <span ng-if=\"$index != data.paymentMethod.length - 1\"><br></span></span></td><td style=width:125px><span ng-repeat=\"service in data.typeOfService\">{{service}} <span ng-if=\"$index != data.typeOfService.length - 1\"><br></span></span></td><td style=width:125px><span ng-repeat=\"dataG in data.region_name\">{{dataG}} <span ng-if=\"$index != data.branch.length - 1\"><br></span></span><span ng-if=\"!data.branch && data.branch.length == 0\">--</span></td><td style=width:125px>{{::data.rt_discount}}</td><td style=width:125px>{{::data.web_discount}}</td><td style=width:125px>{{data.budget || 0}}</td><td style=width:250px><button class=\"btn btn-primary\" ng-click=vm.budgetButton(data)>Definir presupuesto</button></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th class=\"noDataClass text-center\">{{\'noAgreementFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--<nav>--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\" ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/expense-control/expenseControlMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/expense-control/expenseControlReport.html","<h2 class=ng-cloak><span>{{\'budgetReport\' | translate}}</span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"border:1px solid #dedede;padding:0px\" ng-init=\"checkClicked = true\"><h2 class=\"text-center filtersStyle\" ng-click=\"checkClicked = !checkClicked; vm.slideData()\">{{\'filter\' | translate}} <span class=fa ng-class=\"{\'fa-caret-down\': checkClicked,\'fa-caret-up\': !checkClicked }\"></span></h2><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" id=derp><div class=row style=\"padding-top: 10px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'branchLabel\' | translate}}<span style=color:red>*</span>:</label><div><ui-select ng-disabled=is_per_month ng-model=vm.filterData.branch name=branch required close-on-select=true><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \"><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'agreementLabel\' | translate}}<span style=color:red>*</span>:</label><div><ui-select ng-keyup=vm.agreementSearch($select.search,$event) ng-disabled=\"is_per_month || vm.selectAllAgreement\" multiple ng-model=vm.filterData.agreement theme=bootstrap close-on-select=false name=agreement required on-select=\"vm.selectingItemOfCharges($select.selected,\'select\')\" on-remove=\"vm.selectingItemOfCharges($select.selected,\'remove\')\"><ui-select-match placeholder=\"{{\'agreementPlaceholder\' | translate}}\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"agreements.id as agreements in vm.agreement | filter: $select.search | orderBy:\'name\'\" when-scrolled=vm.paginationChangedForAgreement()><div ng-bind-html=agreements.name></div></ui-select-choices></ui-select></div><div style=\"margin-top: 15px\"><md-checkbox ng-disabled=is_per_month class=md-primary ng-click=vm.selectAll() ng-model=vm.selectAllFlag aria-label=\"Select All\">{{\'selectAll\' | translate}}</md-checkbox></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'tripType\' | translate}}:</label><div><ui-select ng-disabled=is_per_month ng-model=vm.filterData.type_of_trip name=trip required close-on-select=true ng-change=vm.typeTripChanged()><ui-select-match placeholder=\"{{\'selectTripType\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"data.id as  data in vm.typeTripFilter | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=data.name></div></ui-select-choices></ui-select></div></div></div><div class=row style=\"padding-top: 10px;padding-bottom:10px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><button ng-disabled=is_per_month class=\"btn btn-primary\" type=button ng-click=vm.showGraphFunction(); style=\"height: 35px;line-height: 20px\">Aplicar filtro</button> <button ng-disabled=is_per_month class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px\" ng-click=vm.resetFilter()>{{\'resetFilterButton\' | translate}}</button></div></div></div></div><div ng-if=vm.showGraph class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><h2 ng-if=is_per_month><button type=button class=\"btn btn-primary\" ng-click=vm.back()>{{\'goBack\' | translate}}</button></h2><h2 ng-if=!is_per_month class=text-center>Consumo últimos 13 meses</h2><h2 ng-if=is_per_month class=text-center>Consumo diario {{vm.monthShowInHeader}} {{vm.yearShowInHeader}}</h2><canvas id=base class=chart-bar chart-click=onClick chart-data=data chart-labels=labels chart-colors=colors chart-dataset-override=datasetOverride chart-options=options></canvas></div></div></div></div></div>");
$templateCache.put("app/components/views/expense-control/expenseControlReportMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/factor-multiplicador/factorMultiplicador.html","<h2 class=ng-cloak><span>{{\'factorMultiplicadorHead\' | translate}}</span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"col-md-4 col-sm-6 col-xs-12\" style=\"padding: 0px\"><button class=\"btn btn-primary mb25 ng-binding\" ng-click=vm.goBack()>Volver</button></div><div class=\"row mt5\"><!-- <br/>\n                <br/> --><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><div class=\"panel panel-default\"><div class=panel-body><div class=\"row ng-scope\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><p class=totalSize><span class=pull-right style=\"margin-left: 10px\"><a class=\"btn btn-primary mb10 ng-binding\" ng-click=\"\">Copiar matriz</a> </span>&nbsp;&nbsp; <span class=pull-right><a class=\"btn btn-primary mb10 ng-binding\" ng-click=vm.gotoCreate()>Nueva matriz</a></span></p></div></div><div class=row><!--<div class=\"col-lg-2 col-sm-2 col-md-2 col-xs-12\">\n                                    <label class=\"control-label ng-binding\"\n                                        style=\"text-align:left; width: 100%\">Sucursal</label>\n                                    <select class=\"form-control ng-pristine ng-valid ng-not-empty ng-touched\" style=\"\">\n                                        <option value=\"\" disabled=\"\" class=\"ng-binding\">Todas</option>\n                                    </select>\n                                </div>\n                                <div class=\"col-lg-2 col-sm-2 col-md-2 col-xs-12\">\n                                    <label class=\"control-label ng-binding\" style=\"text-align:left; width: 100%\">Tipo de\n                                        servicio</label>\n                                    <select class=\"form-control ng-pristine ng-valid ng-not-empty ng-touched\" style=\"\">\n                                        <option value=\"\" disabled=\"\" class=\"ng-binding\">Todas</option>\n                                    </select>\n                                </div>\n                                <div class=\"col-lg-2 col-sm-2 col-md-2 col-xs-12\">\n                                    <label class=\"control-label ng-binding\" style=\"text-align:left; width: 100%\">Tipo de\n                                        viaje</label>\n                                    <select class=\"form-control ng-pristine ng-valid ng-not-empty ng-touched\" style=\"\">\n                                        <option value=\"\" disabled=\"\" class=\"ng-binding\">Todas</option>\n                                    </select>\n                                </div>\n                                <div class=\"col-lg-2 col-sm-2 col-md-2 col-xs-12\">\n                                    <label class=\"control-label ng-binding\"\n                                        style=\"text-align:left; width: 100%\">Estado</label>\n                                    <select class=\"form-control ng-pristine ng-valid ng-not-empty ng-touched\" style=\"\">\n                                        <option value=\"\" disabled=\"\" class=\"ng-binding\">Todas</option>\n                                        <option value=\"1\" class=\"ng-binding\">Activas</option>\n                                        <option value=\"0\" class=\"ng-binding\">Inactivas</option>\n                                    </select>\n                                </div>\n                                <div class=\"col-lg-1 col-sm-1 col-md-1 col-xs-1\" style=\"padding-top: 28px;\">\n                                    <button class=\"btn btn-primary btn-sm\"\n                                        style=\"font-size:12px !important;padding: 5px 10px !important;\">Aplicar\n                                        filtro</button>\n                                </div> --></div><br><br><br><div class=table-responsive><table class=\"table table-hover\" style=\"max-width: 95%\"><thead><tr style=\"border: none !important\"><th title=ID check=\"\"><p style=\"font-size: 13px;font-weight: 700\">ID</p></th><th title=nombre check=\"\"><p class=text-cejter style=\"font-size: 13px;font-weight: 700\">Nombre</p></th><th title=nombre check=\"\"><p class=text-center style=\"font-size: 13px;font-weight: 700\">Sucursal</p></th><th title=nombre check=\"\"><p class=text-center style=\"font-size: 13px;font-weight: 700\">Tipo de servicio</p></th><th title=nombre check=\"\"><p class=text-center style=\"font-size: 13px;font-weight: 700\">Tipo de viaje</p></th><th title=nombre check=\"\"><p class=text-center style=\"font-size: 13px;font-weight: 700\">Acción</p></th></tr></thead><tbody><tr ng-if=\"vm.matrixList.length == 0\"><td colspan=6>No existen bloques ingresados</td></tr><tr ng-repeat=\"data in vm.matrixList\"><td><p style=\"font-size: 14px\">{{ data.id }}</p></td><td><p style=\"font-size: 14px\">{{ data.nombre || \'no definido\' }}</p></td><td><p style=\"font-size: 14px\">{{ data.sucursalNb || \'no definido\' }}</p></td><td><p style=\"font-size: 14px\">{{ data.tipoServicioNb || \'no definido\' }}</p></td><td><p style=\"font-size: 14px\">{{ data.tipoViaje == \'R\' ? \'Recogida\': data.tipoViaje == \'Z\' ? \'Zarpe\': data.tipoViaje == \'P\' ? \'Punto a punto\' : \'no definido\' || \'no definido\' }}</p></td><td style=\"width: 263px;border-top: none\"><div class=text-right><a class=\"cursor btn btn-sm\" ng-class=\"{\'editIconColor\': data.isActive == 0, \'unblockIconColor2\': data.isActive == 1}\" ng-click=vm.activarMatriz(data)><i ng-class=\"{\'fa fa-unlock\': data.isActive == 1,\'fa fa-lock\': data.isActive == 0}\"></i> </a><a title=\"Edit Details\" class=\"cursor btn btn-sm editIconColor\" ng-click=vm.gotoEdit()><i class=\"fa fa-edit\"></i> </a><a title=\"View Details\" class=\"cursor btn btn-sm editIconColor\" ng-click=vm.viewMatriz(data)><i class=\"fa fa-eye\"></i> </a><a class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.eliminarMatriz(data)><i class=\"fa fa-trash\"></i> </a><button class=\"btn btn-primary btn-sm\" style=\"font-size:10px !important;padding: 3px 7px !important\">Copiar matriz</button></div></td></tr><!--<tr>\n                                            <td style=\"width:140px;\">\n                                                <p style=\"font-size: 18px;\">Instancia general</p>\n                                            </td>\n                                            <td style=\"width: 150px;border-top: none;\">\n                                                <div class=\"text-right\">\n\n                                                    <!-- <a ng-if=\"data.init\" title=\"View Details\" ng-style=\"{ \'margin-right\' : (data.init) ? \'30px\' : \'0px\' }\"  class=\"cursor btn btn-sm editIconColor\" ui-sref=\"layout.applicantsMain.applicantsDetails({id:\'{{data.fleet_id}}\'})\">\n                                                        <i ng-class=\"{\'fa fa-unlock\': data.is_blocked == 0,\'fa fa-lock\': data.is_blocked == 1}\"></i>\n                                                    </a> --><!--<a ng-if=\"data.init\"  class=\"cursor btn btn-sm\" ng-style=\"{ \'margin-right\' : (data.init) ? \'30px\' : \'0px\' }\"  ng-class=\"{\'blockIconColor\': data.is_blocked == 1, \'unblockIconColor\': data.is_blocked == 0}\"\n                                                    ng-click=\"vm.block_unblock($event,data.customer_id,data.is_blocked, data.name)\">\n                                                    <i ng-class=\"{\'fa fa-unlock\': data.is_blocked == 0,\'fa fa-lock\': data.is_blocked == 1}\"></i>\n                                                    </a>\n\n\n\n                                                    <a title=\"Edit Details\" class=\"cursor btn btn-sm editIconColor\" ng-click=\"vm.instanceEdit(data)\">\n                                                        <i class=\"fa fa-edit\"></i>\n                                                    </a>\n\n                                                    <a title=\"View Details\" class=\"cursor btn btn-sm editIconColor\" ng-click=\"vm.instanceDetails(data)\">\n                                                        <i class=\"fa fa-eye\"></i>\n                                                    </a>\n\n                                                    <!-- <a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=\"vm.deleteUser(data.fleet_id,$event)\">\n                                                        <i class=\"fa fa-trash\"></i>\n                                                    </a> --><!--</div>\n                                            </td>\n                                         \n                                        </tr>\n\n                                        <tr >\n                                            <td style=\"width:140px;\">\n                                                <p style=\"font-size: 18px;\">Horario valle</p>\n                                            </td>\n                                            <td style=\"width: 150px;\" >\n                                                <div class=\"text-right\">\n                                                    <a class=\"cursor btn btn-sm editIconColor\">\n                                                        <i class=\"fa fa-lock\"></i>\n                                                    </a>\n                                                    <a title=\"Edit Details\" style=\"margin-left: 30px;\" class=\"cursor btn btn-sm editIconColor\" ui-sref=\"layout.applicantsMain.editApplicantsDetails({id:\'{{data.fleet_id}}\'})\">\n                                                        <i class=\"fa fa-edit\"></i>\n                                                    </a>\n                                                    <a title=\"View Details\" class=\"cursor btn btn-sm editIconColor\" ui-sref=\"layout.applicantsMain.applicantsDetails({id:\'{{data.fleet_id}}\'})\">\n                                                        <i class=\"fa fa-eye\"></i>\n                                                    </a>\n\n                                                </div>\n                                            </td>\n                                         \n                                        </tr>--></tbody></table></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/factor-multiplicador/factorMultiplicadorCreate.html","<h2 class=ng-cloak><span>Factor multiplicador / {{\'headCreateMatrix\' | translate}}</span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><!--<filter-sidebar show-filter-sidebar=\"vm.showFilterFlag\" filter-data=\"vm.filterData\" filter-to-show=\"vm.filterWhichToShow\" branch-detail-changed=\"vm.branchChangedFilter(vm.filterData)\"--><!--modelity-detail-changed=\"vm.modelityChangedFilter(vm.filterData)\" approval-stage-detail-changed=\"vm.approvalChangedFilter(vm.filterData)\" applicant-detail-changed=\"vm.applicantChangedFilter(vm.filterData)\"></filter-sidebar>--><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"col-md-4 col-sm-6 col-xs-12\" style=\"padding: 0px\"><button class=\"btn btn-primary mb25 ng-binding\" ng-click=vm.goBack()>Volver</button></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><div class=\"panel panel-default\"><div class=panel-body><form name=formInstance ng-submit=guardar_datos(formInstance,$event) autocomplete=off><div class=row><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12 text-left\"><p style=font-size:15px>Nombre</p><input type=text class=form-control ng-model=vm.dataForBlock.nombre name=nombre placeholder=\"Ingrese nombre\"></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12 text-left\"><p style=font-size:15px>Sucursal</p><ui-select ng-model=vm.dataForBlock.sucursal_id name=branch ng-change=vm.branchChanged($select.selected) close-on-select=true><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search\"><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12 text-left\"><p style=font-size:15px>Tipo de servicio</p><ui-select ng-model=vm.dataForBlock.type_of_service name=type_of_service ng-change=vm.serviceTypeChanged($select.selected) close-on-select=true><ui-select-match placeholder=\"{{\'servicePlaceholder\' | translate}}\">{{$select.selected.service_name}}</ui-select-match><ui-select-choices repeat=\"tos.id as tos in vm.servicesList | filter: $select.search\"><div ng-bind-html=tos.service_name></div></ui-select-choices></ui-select></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12 text-left\"><p style=font-size:15px>Tipo de viaje</p><ui-select ng-model=vm.dataForBlock.type_of_trip name=type_of_trip ng-change=\"\" close-on-select=true><ui-select-match placeholder=\"{{\'selectTripType\' | translate}}\">{{$select.selected.id}}</ui-select-match><ui-select-choices repeat=\"tot.id as tot in vm.type_of_trip | filter: $select.search\"><div ng-bind-html=tot.id></div></ui-select-choices></ui-select></div></div><div class=row style=\"margin-top: 40px\"><div class=\"col-sm-3 col-md-3 col-lg-3 text-left\"><p style=\"font-size:15px; font-weight: 700\" ng-if=!vm.excepcionList>Bloques horarios</p><p style=\"font-size:15px; font-weight: 700\" ng-if=vm.excepcionList>Excepciones</p></div><div class=\"col-sm-2 col-md-2 col-lg-2\" style=\"width: 135px\" ng-if=!vm.excepcionList><a class=\"btn btn-primary\" title=\"Crear instancia\" ng-click=vm.addBlock() style=padding-left:8px;padding-right:8px><i class=\"fa fa-plus\" style=border:none></i> Nuevo bloque</a></div><div class=\"col-sm-2 col-md-2 col-lg-2\" style=\"width: 155px\" ng-if=vm.excepcionList><a class=\"btn btn-primary\" title=\"Crear instancia\" ng-click=vm.addException() style=padding-left:8px;padding-right:8px><i class=\"fa fa-plus\" style=border:none></i> Nueva excepción</a></div><div class=\"col-sm-2 col-md-2 col-lg-2\" style=\"width: 118px\"><a class=\"btn btn-primary\" title=\"Crear instancia\" ng-click=vm.toggleCalendar() style=padding-left:8px;padding-right:8px>Ver calendario</a></div><div class=\"col-sm-2 col-md-2 col-lg-2\" style=\"width: 135px\"><a ng-if=!vm.excepcionList class=\"btn btn-primary\" title=\"Crear instancia\" ng-click=vm.handleExceptions() style=padding-left:8px;padding-right:8px>Agregar excepción </a><a ng-if=vm.excepcionList class=\"btn btn-primary\" title=\"Crear instancia\" ng-click=vm.handleBloques() style=padding-left:8px;padding-right:8px>Ver bloques</a></div></div><div class=table-responsive style=\"margin-top: 30px;min-height: auto; overflow: inherit\" ng-if=!vm.excepcionList><table class=\"table table-hover\"><thead><tr style=\"border: none !important\"><th style=\"width:30px;border: none !important;text-align: left !important\" title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 12px\">Día y hora de inicio</p></th><th style=\"width:30px;border: none !important; text-align: left !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 12px\">Día y hora de termino</p></th><th style=\"width:30px;border: none !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 12px\">Factor multiplicador</p></th></tr></thead><tbody><tr ng-repeat=\"data in vm.blocks\"><td style=\"width:140px;border:none !important;text-align:left !important\"><div class=row><div class=col-md-6 style=\"width:130px;border: none !important;padding-right: 0px\"><select class=form-control ng-model=vm.blocks[$index].dia_inicio ng-change=vm.approvalValueChanged() required><option id=1 ng-value=1>Lunes</option><option id=2 ng-value=2>Martes</option><option id=3 ng-value=3>Miércoles</option><option id=4 ng-value=4>Jueves</option><option id=5 ng-value=5>Viernes</option><option id=6 ng-value=6>Sábado</option><option id=7 ng-value=7>Domingo</option></select></div><div class=col-md-6 style=\"padding-left: 5px;max-width: 100px\"><ui-select ng-model=vm.blocks[$index].hora_inicio name=hora ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match>{{$select.selected.id}}</ui-select-match><ui-select-choices repeat=\"hours.id as hours in vm.hoursArray\" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=hours.id></div></ui-select-choices></ui-select></div></div></td><td style=\"width:140px;border: none !important;text-align:left !important\"><div class=row><div class=col-md-6 style=\"width:130px;border: none !important;padding-right: 0px\"><select class=form-control ng-model=vm.blocks[$index].dia_fin ng-change=vm.approvalValueChanged() required><option id=1 ng-value=1>Lunes</option><option id=2 ng-value=2>Martes</option><option id=3 ng-value=3>Miércoles</option><option id=4 ng-value=4>Jueves</option><option id=5 ng-value=5>Viernes</option><option id=6 ng-value=6>Sábado</option><option id=7 ng-value=7>Domingo</option></select></div><div class=col-md-6 style=\"padding-left: 5px;max-width: 100px\"><ui-select ng-model=vm.blocks[$index].hora_fin name=hora ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match>{{$select.selected.id}}</ui-select-match><ui-select-choices repeat=\"hours.id as hours in vm.hoursArray\" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=hours.id></div></ui-select-choices></ui-select></div></div></td><td style=\"border: none !important\"><span style=\"width:90px;display: inline-block\"><input ng-model=vm.blocks[$index].factor class=form-control maxlength=55 name=factor[$index] type=number pattern=^(0|[1-9]\\d*)(\\.\\d+)?$ step=0.01 required ng-change=vm.onchange(dataForInstance.nombre) value={{data.factor}}><div ng-if=\"formInstance.factor[$index].$valid || submit\" ng-messages=formInstance.factor[$index].$error><div class=\"errormessage text-danger\" ng-message=required>Obligatorio</div></div></span><span style=\"margin-left: 10px\"><a title=\"Borrar bloque\" style=\"font-size: 20px\" class=cursor ng-click=vm.removeBlock(data)><i style=\"color: red\" class=\"fa fa-times-circle fa-lg\"></i></a></span></td></tr></tbody></table></div><!-- <div style=\"clear:both;\"></div> --><div class=table-responsive style=\"margin-top: 30px;min-height: auto; overflow: inherit\" ng-if=vm.excepcionList><table class=\"table table-hover\"><thead><tr style=\"border: none !important\"><th style=\"width:30px;border: none !important;text-align: center !important\" title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 12px\">Día y hora de inicio</p></th><th style=\"width:30px;border: none !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 12px\">Día y hora de termino</p></th><th style=\"width:30px;border: none !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 12px\">Factor multiplicador</p></th></tr></thead><tbody><tr ng-repeat=\"data in vm.exceptions\"><td style=\"border: none !important\"><div class=row><div class=col-md-12 style=\"max-width: 300px;margin: 0 auto;position: relative;float: none\"><div class=col-md-6><input style=\"height: 32px;border-radius: 5px;border: 1px solid #ccc\" type=date name=start id=trip-start min={{vm.date}} value=vm.dataForException.start_date ng-model=vm.exceptions[$index].start_date></div><div class=col-md-6><ui-select ng-model=vm.exceptions[$index].hora_inicio name=hora style=\"float: right;;max-width: 100px\" ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match>{{$select.selected.id}}</ui-select-match><ui-select-choices repeat=\"hours.id as hours in vm.hoursArray\" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=hours.id></div></ui-select-choices></ui-select></div></div></div></td><td style=\"border: none !important\"><div class=row><div class=col-md-12 style=\"max-width: 300px;margin: 0 auto;position: relative;float: none\"><div class=col-md-6><p class=input-group><input style=\"height: 32px;border-radius: 5px;border: 1px solid #ccc\" min={{vm.date}} type=date name=date id=date ng-model=vm.exceptions[$index].end_date></p><div ng-if=\"createBookingForm.scheduledDate.$touched|| submit\" ng-messages=createBookingForm.scheduledDate.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'scheduleDateReq\' | translate}}</div></div></div><div class=col-md-6><ui-select ng-model=vm.exceptions[$index].hora_fin name=hora style=\"float: right;;max-width: 100px\" ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match>{{$select.selected.id}}</ui-select-match><ui-select-choices repeat=\"hours.id as hours in vm.hoursArray\" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=hours.id></div></ui-select-choices></ui-select></div></div></div></td><td style=\"border: none !important\"><span style=\"width:90px;display: inline-block\"><input ng-model=vm.exceptions[$index].factor class=form-control maxlength=55 name=factorE[$index] type=number pattern=^(0|[1-9]\\d*)(\\.\\d+)?$ step=0.01 required ng-change=vm.onchange(dataForInstance.nombre) value={{data.factor}}><div ng-if=\"formInstance.factorE[$index].$valid || submit\" ng-messages=formInstance.factorE[$index].$error><div class=\"errormessage text-danger\" ng-message=required>Obligatorio</div></div></span><span style=\"margin-left: 10px\"><a title=\"Borrar bloque\" style=\"font-size: 20px\" class=cursor ng-click=vm.removeException(data)><i style=\"color: red\" class=\"fa fa-times-circle fa-lg\"></i></a></span></td></tr></tbody></table></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-right mt5 mb0\"><div style=\"flex: 1\" ng-if=vm.showCalendar><div ui-calendar=calendarOptions ng-model=eventSources></div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-right mt5 mb0\"><div style=\"flex: 1\"><button class=btn ng-click=vm.cancel() type=button style=\"height: 35px;line-height: 20px;margin-right: 5px\">Cancelar</button><!-- <button class=\"btn btn-primary ng-binding\" type=\"button\" style=\"height: 35px;line-height: 20px;\" ng-click=\"vm.saveInstance(vm.dataForInstance)\">Guardar\n                                    </button> --> <button ng-if=!vm.id class=\"btn btn-primary ng-binding\" type=submit style=\"height: 35px;line-height: 20px\">Guardar</button> <button ng-if=vm.id class=\"btn btn-primary ng-binding\" type=submit style=\"height: 35px;line-height: 20px\">Guardar</button></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/factor-multiplicador/factorMultiplicadorEdit.html","<h2 class=ng-cloak><span>Factor multiplicador / {{\'matrixHeadCreate\' | translate}}</span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><!--<filter-sidebar show-filter-sidebar=\"vm.showFilterFlag\" filter-data=\"vm.filterData\" filter-to-show=\"vm.filterWhichToShow\" branch-detail-changed=\"vm.branchChangedFilter(vm.filterData)\"--><!--modelity-detail-changed=\"vm.modelityChangedFilter(vm.filterData)\" approval-stage-detail-changed=\"vm.approvalChangedFilter(vm.filterData)\" applicant-detail-changed=\"vm.applicantChangedFilter(vm.filterData)\"></filter-sidebar>--><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"col-md-4 col-sm-6 col-xs-12\" style=\"padding: 0px\"><button class=\"btn btn-primary mb25 ng-binding\" ng-click=vm.goBack()>Volver</button></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><div class=\"panel panel-default\"><div class=panel-body><form name=formInstance ng-submit=guardar_datos(formInstance,$event) autocomplete=off><div class=row><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12 text-left\"><p style=font-size:15px>Nombre</p><input type=text class=form-control ng-model=vm.dataToFill.nombre name=nombre placeholder=\"Ingrese nombre\" required ng-class=\"{ \'has-error\': formInstance.nombre.$touched && formInstance.nombre.$invalid }\"><div ng-if=\"formInstance.nombre.$touched|| submit\" ng-messages=formInstance.nombre.$error><div class=\"errormessage text-danger\" ng-message=required>Seleccione nombre</div></div></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12 text-left\"><p style=font-size:15px>Sucursal</p><ui-select ng-model=vm.dataForBlock.sucursal_id name=branch ng-change=\"vm.branchChanged(0,vm.dataForBlock.sucursal_id, $select.selected.region_name)\" required close-on-select=true><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search\"><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select><div ng-if=\"formInstance.branch.$touched|| submit\" ng-messages=formInstance.branch.$error><div class=\"errormessage text-danger\" ng-message=required>Seleccione sucursal</div></div></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12 text-left\"><p style=font-size:15px>Tipo de servicio</p><ui-select ng-model=vm.dataForBlock.type_of_service name=type_of_service ng-change=\"vm.branchChanged(0,vm.dataForBlock.sucursal_id, $select.selected.region_name)\" required close-on-select=true><ui-select-match placeholder=\"{{\'servicePlaceholder\' | translate}}\">{{$select.selected.service_name}}</ui-select-match><ui-select-choices repeat=\"tos.id as tos in vm.servicesList | filter: $select.search\"><div ng-bind-html=tos.service_name></div></ui-select-choices></ui-select><div ng-if=\"formInstance.type_of_service.$touched|| submit\" ng-messages=formInstance.type_of_service.$error><div class=\"errormessage text-danger\" ng-message=required>Seleccione tipo de servicio</div></div></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12 text-left\"><p style=font-size:15px>Tipo de viaje</p><ui-select ng-model=vm.dataForBlock.type_of_trip name=type_of_trip ng-change=\"vm.branchChanged(0,vm.dataForBlock.sucursal_id, $select.selected.region_name)\" required close-on-select=true><ui-select-match placeholder=\"{{\'selectTripType\' | translate}}\">{{$select.selected.id}}</ui-select-match><ui-select-choices repeat=\"tot.id as tot in vm.type_of_trip | filter: $select.search\"><div ng-bind-html=tot.id></div></ui-select-choices></ui-select><div ng-if=\"formInstance.type_of_trip.$touched|| submit\" ng-messages=formInstance.type_of_trip.$error><div class=\"errormessage text-danger\" ng-message=required>Seleccione tipo de viaje</div></div></div></div><div class=row style=\"margin-top: 40px\"><div class=\"col-sm-3 col-md-3 col-lg-3 text-left\"><p style=\"font-size:15px; font-weight: 700\" ng-if=!vm.excepcionList>Bloques horario</p><p style=\"font-size:15px; font-weight: 700\" ng-if=vm.excepcionList>Excepciones</p></div><div class=\"col-sm-2 col-md-2 col-lg-2\" style=\"width: 135px\" ng-if=!vm.excepcionList><a class=\"btn btn-primary\" title=\"Crear instancia\" ng-click=vm.addBlock() style=padding-left:8px;padding-right:8px><i class=\"fa fa-plus\" style=border:none></i> Nuevo bloque</a></div><div class=\"col-sm-2 col-md-2 col-lg-2\" style=\"width: 155px\" ng-if=vm.excepcionList><a class=\"btn btn-primary\" title=\"Crear instancia\" ng-click=vm.addBlock() style=padding-left:8px;padding-right:8px><i class=\"fa fa-plus\" style=border:none></i> Nueva excepción</a></div><div class=\"col-sm-2 col-md-2 col-lg-2\" style=\"width: 118px\"><a class=\"btn btn-primary\" title=\"Crear instancia\" ng-click=vm.addBlock() style=padding-left:8px;padding-right:8px>Ver calendario</a></div><div class=\"col-sm-2 col-md-2 col-lg-2\" style=\"width: 135px\"><a ng-if=!vm.excepcionList class=\"btn btn-primary\" title=\"Crear instancia\" ng-click=vm.handleExceptions() style=padding-left:8px;padding-right:8px>Agregar excepciones </a><a ng-if=vm.excepcionList class=\"btn btn-primary\" title=\"Crear instancia\" ng-click=vm.handleBloques() style=padding-left:8px;padding-right:8px>Ver bloques</a></div></div><div class=table-responsive style=\"margin-top: 30px;min-height: 400px\" ng-if=!vm.excepcionList><table class=\"table table-hover\"><thead><tr style=\"border: none !important\"><th style=\"width:30px;border: none !important;text-align: center !important\" title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 12px\">Día y hora de inicio</p></th><th style=\"width:30px;border: none !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 12px\">Día y hora de termino</p></th><th style=\"width:30px;border: none !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 12px\">Factor multiplicador</p></th></tr></thead><tbody><tr ng-repeat=\"data in vm.blocks\"><td style=\"width:140px;border:none !important;text-align:left !important\"><div class=row><div class=col-md-6 style=\"width:130px;border: none !important;padding-right: 0px\"><select class=form-control ng-model=vm.blocks[$index].dia_inicio ng-change=vm.approvalValueChanged()><option id=1 ng-value=1>Lunes</option><option id=2 ng-value=2>Martes</option><option id=3 ng-value=3>Miércoles</option><option id=4 ng-value=4>Jueves</option><option id=5 ng-value=5>Viernes</option><option id=6 ng-value=6>Sábado</option><option id=7 ng-value=7>Domingo</option></select></div><div class=col-md-6 style=\"padding-left: 5px;max-width: 100px\"><ui-select style=\"z-index: 10 !important\" ng-model=vm.blocks[$index].hora_inicio name=hora ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match>{{$select.selected.id}}</ui-select-match><ui-select-choices repeat=\"hours.id as hours in vm.hoursArray\" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=hours.id></div></ui-select-choices></ui-select></div></div></td><td style=\"width:140px;border: none !important;text-align:left !important\"><div class=row><div class=col-md-6 style=\"width:130px;border: none !important;padding-right: 0px\"><select class=form-control ng-model=vm.blocks[$index].dia_fin ng-change=vm.approvalValueChanged()><option id=1 ng-value=1>Lunes</option><option id=2 ng-value=2>Martes</option><option id=3 ng-value=3>Miércoles</option><option id=4 ng-value=4>Jueves</option><option id=5 ng-value=5>Viernes</option><option id=6 ng-value=6>Sábado</option><option id=7 ng-value=7>Domingo</option></select></div><div class=col-md-6 style=\"padding-left: 5px;max-width: 100px\"><ui-select style=\"z-index: 10 !important\" ng-model=vm.blocks[$index].hora_fin name=hora ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match>{{$select.selected.id}}</ui-select-match><ui-select-choices repeat=\"hours.id as hours in vm.hoursArray\" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=hours.id></div></ui-select-choices></ui-select></div></div></td><td style=\"border: none !important\"><span style=\"width:90px;display: inline-block\"><input ng-model=vm.blocks[$index].factor class=form-control maxlength=55 name=nombre type=number min=0 required ng-change=vm.onchange(dataForInstance.nombre) value={{data.factor}}><!--<div ng-hide=\"formInstance.nombre.$valid || formInstance.$pristine\" >--><!--<div class=\"errormessage text-danger\">Este campo es obligatorio.</div>--><!--</div>--><div ng-if=vm.isError><div class=\"errormessage text-danger\">Este campo es obligatorio.</div></div></span><span style=\"margin-left: 10px\"><a title=\"Borrar bloque\" style=\"font-size: 20px\" class=cursor ng-click=vm.removeBlock(data)><i style=\"color: red\" class=\"fa fa-times-circle fa-lg\"></i></a></span></td></tr></tbody></table></div><!-- <div style=\"clear:both;\"></div> --><div class=table-responsive style=\"margin-top: 30px;min-height: 400px\" ng-if=vm.excepcionList><table class=\"table table-hover\"><thead><tr style=\"border: none !important\"><th style=\"width:30px;border: none !important;text-align: center !important\" title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 12px\">Día y hora de inicio</p></th><th style=\"width:30px;border: none !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 12px\">Día y hora de termino</p></th><th style=\"width:30px;border: none !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 12px\">Factor multiplicador</p></th></tr></thead></table></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-right mt5 mb0\"><div style=\"flex: 1\"><button class=btn ng-click=vm.cancel() type=button style=\"height: 35px;line-height: 20px;margin-right: 5px\">Cancelar</button><!-- <button class=\"btn btn-primary ng-binding\" type=\"button\" style=\"height: 35px;line-height: 20px;\" ng-click=\"vm.saveInstance(vm.dataForInstance)\">Guardar\n                                    </button> --> <button ng-if=!vm.id class=\"btn btn-primary ng-binding\" type=submit style=\"height: 35px;line-height: 20px\">Guardar</button> <button ng-if=vm.id class=\"btn btn-primary ng-binding\" type=submit style=\"height: 35px;line-height: 20px\">Guardar</button></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/factor-multiplicador/factorMultiplicadorMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/factor-multiplicador/factorMultiplicadorView.html","<h2 class=ng-cloak><span>{{\'factorMultiplicadorHead\' | translate}}</span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><!--<filter-sidebar show-filter-sidebar=\"vm.showFilterFlag\" filter-data=\"vm.filterData\" filter-to-show=\"vm.filterWhichToShow\" branch-detail-changed=\"vm.branchChangedFilter(vm.filterData)\"--><!--modelity-detail-changed=\"vm.modelityChangedFilter(vm.filterData)\" approval-stage-detail-changed=\"vm.approvalChangedFilter(vm.filterData)\" applicant-detail-changed=\"vm.applicantChangedFilter(vm.filterData)\"></filter-sidebar>--><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"col-md-4 col-sm-6 col-xs-12\" style=\"padding: 0px\"><button class=\"btn btn-primary mb25 ng-binding\" ng-click=vm.goBack()>Volver</button></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12 text-left\"><p style=font-size:15px>Nombre</p><input type=text name=nombre class=\"form-control ng-pristine ng-valid ng-empty ng-touched\" value=\"{{ vm.matrixListOne.nombre || \'no definido\' }}\" readonly></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12 text-left\"><p style=font-size:15px>Sucursal</p><input type=text name=Sucursal class=\"form-control ng-pristine ng-valid ng-empty ng-touched\" value=\"{{ vm.matrixListOne.sucursalNb || \'no definido\' }}\" readonly></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12 text-left\"><p style=font-size:15px>Tipo de servicio</p><input type=text name=TipoServicio class=\"form-control ng-pristine ng-valid ng-empty ng-touched\" value=\"{{ vm.matrixListOne.tipoServicioNb || \'no definido\' }}\" readonly></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12 text-left\"><p style=font-size:15px>Tipo de viaje</p><input type=text name=Tipoviaje class=\"form-control ng-pristine ng-valid ng-empty ng-touched\" value=\"{{ vm.matrixListOne.tipoViaje == \'R\' ? \'Recogida\':vm.matrixListOne.tipoViaje == \'Z\' ? \'Zarpe\': vm.matrixListOne.tipoViaje == \'P\' ?\'Punto a punto\' : \'no definido\' || \'no definido\' }}\" readonly></div></div><br><br><div class=row><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12 text-left\"><p style=\"font-size:15px; font-weight: 700\" class=ng-scope>Bloques horarios</p></div><div class=\"col-lg-9 col-sm-9 col-md-9 col-xs-12\"><button class=\"btn btn-primary mb25 ng-binding\" ng-click=vm.viewCalendar(vm.matrixListOne)>Ver calendario</button> <button ng-if=!vm.mostrarExcepciones class=\"btn btn-primary mb25 ng-binding\" ng-click=vm.verExcepciones()>Ver excepciones</button> <button ng-if=vm.mostrarExcepciones class=\"btn btn-primary mb25 ng-binding\" ng-click=vm.verBloques()>Ver bloques</button></div></div><div class=table-responsive style=\"margin-top: 30px;min-height: 400px\"><table class=\"table table-hover\" ng-if=!vm.mostrarExcepciones><thead><tr style=\"border: none !important\"><th title=ID check=\"\"><p style=\"font-size: 13px;font-weight: 700\">Día y horario de inicio</p></th><th title=ID check=\"\"><p style=\"font-size: 13px;font-weight: 700\">Día y horario de término</p></th><th title=ID check=\"\"><p style=\"font-size: 13px;font-weight: 700\">Factor multiplicador</p></th></tr></thead><tbody><tr ng-if=\"vm.matrixListOne.bloques.length == 0\"><td colspan=6>No existen bloques ingresados</td></tr><tr ng-repeat=\"data in vm.matrixListOne.bloques\"><td><p style=\"font-size: 14px\">{{ data.diaInicio == 1 ? \'Lunes\': data.diaInicio == 2 ? \'Martes\': data.diaInicio == 3 ? \'Miércoles\': data.diaInicio == 4 ? \'Jueves\': data.diaInicio == 5 ? \'Viernes\': data.diaInicio == 6 ? \'Sábado\': data.diaInicio == 7 ? \'Domingo\': \'no definido\' || \'no definido\' }} {{ data.horaInicio || \'\' }}</p></td><td><p style=\"font-size: 14px\">{{ data.diaFin == 1 ? \'Lunes\': data.diaFin == 2 ? \'Martes\': data.diaFin == 3 ? \'Miércoles\': data.diaFin == 4 ? \'Jueves\': data.diaFin == 5 ? \'Viernes\': data.diaFin == 6 ? \'Sábado\': data.diaFin == 7 ? \'Domingo\': \'no definido\' || \'no definido\' }} {{ data.horaFin || \'\' }}</p></td><td><p style=\"font-size: 14px\">{{ data.factor || \'no definido\' }}</p></td></tr></tbody></table><table class=\"table table-hover\" ng-if=vm.mostrarExcepciones><thead><tr style=\"border: none !important\"><th title=ID check=\"\"><p style=\"font-size: 13px;font-weight: 700\">Día y horario de inicio</p></th><th title=ID check=\"\"><p style=\"font-size: 13px;font-weight: 700\">Día y horario de término</p></th><th title=ID check=\"\"><p style=\"font-size: 13px;font-weight: 700\">Factor multiplicador</p></th></tr></thead><tbody><tr ng-if=\"vm.matrixListOne.excepciones.length == 0\"><td colspan=6>No existen excepciones ingresadas</td></tr><tr ng-repeat=\"data in vm.matrixListOne.excepciones\"><td><p style=\"font-size: 14px\">{{ data.fechaInicio || \'no definido\' | date:\'dd MMM yyyy\' }} {{ data.horaInicio || \'\' }}</p></td><td><p style=\"font-size: 14px\">{{ data.fechaFin || \'no definido\' | date:\'dd MMM yyyy\' }} {{ data.horaFin || \'\' }}</p></td><td><p style=\"font-size: 14px\">{{ data.factor || \'no definido\' }}</p></td></tr></tbody></table></div><!-- <div style=\"clear:both;\"></div> --></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/factor-multiplicador/factorMultiplicadorViewCalendar.html","<h2 class=ng-cloak><span>{{\'factorMultiplicadorHead\' | translate}}</span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><!--<filter-sidebar show-filter-sidebar=\"vm.showFilterFlag\" filter-data=\"vm.filterData\" filter-to-show=\"vm.filterWhichToShow\" branch-detail-changed=\"vm.branchChangedFilter(vm.filterData)\"--><!--modelity-detail-changed=\"vm.modelityChangedFilter(vm.filterData)\" approval-stage-detail-changed=\"vm.approvalChangedFilter(vm.filterData)\" applicant-detail-changed=\"vm.applicantChangedFilter(vm.filterData)\"></filter-sidebar>--><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><div class=\"panel panel-default\"><div class=panel-body><form name=formInstance ng-submit=guardar_datos(formInstance,$event) novalidate autocomplete=off><div class=row><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12 text-left\"><p style=font-size:15px>Nombre</p><input type=text name=nombre class=\"form-control ng-pristine ng-valid ng-empty ng-touched\" value=\"{{ vm.events.nombre || \'no definido\' }}\" readonly></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12 text-left\"><p style=font-size:15px>Sucursal</p><input type=text name=Sucursal class=\"form-control ng-pristine ng-valid ng-empty ng-touched\" value=\"{{ vm.events.sucursalNb || \'no definido\' }}\" readonly></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12 text-left\"><p style=font-size:15px>Tipo de servicio</p><input type=text name=TipoServicio class=\"form-control ng-pristine ng-valid ng-empty ng-touched\" value=\"{{ vm.events.tipoServicioNb || \'no definido\' }}\" readonly></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12 text-left\"><p style=font-size:15px>Tipo de viaje</p><input type=text name=Tipoviaje class=\"form-control ng-pristine ng-valid ng-empty ng-touched\" value=\"{{ vm.events.tipoViaje == \'R\' ? \'Recogida\': vm.events.tipoViaje == \'Z\' ? \'Zarpe\': vm.events.tipoViaje == \'P\' ? \'Punto a punto\' : \'no definido\' || \'no definido\' }}\" readonly></div></div><div class=row style=\"margin-top: 40px\"><div class=\"col-sm-3 col-md-3 col-lg-3 text-left\"><p style=\"font-size:15px; font-weight: 700\">Bloques horarios</p></div><div class=\"col-sm-2 col-md-2 col-lg-2\" style=\"width: 135px\"><a class=\"btn btn-primary\" ng-click=vm.goBack() style=padding-left:8px;padding-right:8px>Ver lista</a></div><div class=\"col-sm-2 col-md-2 col-lg-2\" style=\"width: 135px\"><a class=\"btn btn-primary\" ng-click=vm.handleExceptions() style=padding-left:8px;padding-right:8px>Ver excepciones</a></div></div><div style=\"margin-bottom: 50px\"><div ui-calendar=uiConfig.calendar ng-model=eventSources class=\"span8 calendar\" ng-if=\"eventSources.length > 0\"></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/filterSideBar/filterSideBar.html","<div class=rightSideBarFilter><ul><li><a><i ng-click=disappearFilter() class=\"fa fa-times\"></i></a></li><li ng-if=filterToShow.branchWithDashboard><label>{{\'branchLabel\' | translate}}:</label><div><ui-select ng-model=filterData.branch close-on-select=true ng-change=branchChange()><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in branch | filter: $select.search\"><div ng-bind-html=data.name></div></ui-select-choices></ui-select></div></li><li ng-if=!filterToShow.branchWithDashboard><label class=control-label>{{\'branchLabel\' | translate}}</label><div><ui-select ng-model=filterData.branch name=branch required close-on-select=true ng-change=branchChange()><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in branchList | filter: $select.search | orderBy:\'region_name\' \"><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select></div></li><li ng-if=filterToShow.vehicle><label>{{\'vehicleLabel\' | translate}}:</label><div><ui-select ng-model=filterData.vehicle close-on-select=true ng-change=vehicleChanged()><ui-select-match placeholder=\"{{\'vehiclePlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in vehicle | filter: $select.search\"><div ng-bind-html=data.name></div></ui-select-choices></ui-select></div></li><li ng-if=filterToShow.service><label>{{\'serviceLabel\' | translate}}:</label><div><ui-select ng-model=filterData.service close-on-select=true ng-change=serviceChanged()><ui-select-match placeholder=\"{{\'servicePlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in service | filter: $select.search\"><div ng-bind-html=data.name></div></ui-select-choices></ui-select></div></li><li ng-if=filterToShow.agreement><label>{{\'agreementLabel\' | translate}}:</label><div><ui-select ng-model=filterData.agreement close-on-select=true ng-change=agreementChanged()><ui-select-match placeholder=\"{{\'agreementPlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in agreement | filter: $select.search\"><div ng-bind-html=data.name></div></ui-select-choices></ui-select></div></li><li ng-if=filterToShow.virtualFleet><label>{{\'virtualFleetLabel\' | translate}}:</label><div><ui-select ng-model=filterData.truck theme=bootstrap close-on-select=true ng-change=virtualFleetChanged()><ui-select-match placeholder=\"{{\'virtualFleetPlaceholder\' | translate}}\"></ui-select-match><ui-select-choices repeat=\"data in total_truck | filter:$select.search\"><div ng-bind-html=\"data.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></li><li ng-if=filterToShow.operation><label>{{\'basesOperationLabel\' | translate}}:</label><div><ui-select ng-model=filterData.bases theme=bootstrap close-on-select=true ng-change=operationChanged()><ui-select-match placeholder=\"{{\'basesOperationPlaceholder\' | translate}}\"></ui-select-match><ui-select-choices repeat=\"data in total_operation | filter:$select.search\"><div ng-bind-html=\"data.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></li><li ng-if=filterToShow.helpTraffic><div><span><b>{{\'helpTrafficLabel\' | translate}}</b></span> <span class=pull-right><i class=boleeanTypeColor ng-click=\"setBooleans(\'HELP_TRAFFIC\')\" ng-class=\"{\'fa fa-toggle-on\': filterData.helpTraffic , \'fa fa-toggle-off\': !filterData.helpTraffic}\"></i></span></div></li><li ng-if=filterToShow.modelity><label class=control-label>{{\'modalityOfworkLabel\' | translate}}</label><div><select class=form-control ng-model=filterData.modelity ng-change=modelityChanged()><option value=\"\" selected disabled>{{\'modalityOfworkPlaceholder\' | translate}}</option><option value=0>No</option><option value=1>Yes</option><option value=all>All</option></select></div></li><li ng-if=filterToShow.approvalStage><label class=control-label>{{\'approvalStage\' | translate}}</label><div><select class=form-control ng-model=filterData.verification_stage ng-change=approvalStageChanged()><option value=\"\" selected disabled>{{\'approvalStagePlaceholder\' | translate}}</option><option value=1>Basic Registration Stage</option><option value=2>Documents Stage</option><option value=3>Interview Stage</option><option value=4>Training Stage</option><option value=5>Sign of Contract Stage</option><option value=6>Account Activation Stage</option><option value=7>Fleet Verification Stage</option><option value=all>All</option></select></div></li><li ng-if=filterToShow.applicantType><label class=control-label>{{\'applicantType\' | translate}}</label><div><select class=form-control ng-model=filterData.driver ng-change=applicantChanged()><option value=\"\" selected disabled>{{\'applicantTypePlaceholder\' | translate}}</option><option value=0>Driver with car</option><option value=1>Driver without car</option><option value=2>Car investor</option><option value=all>All</option></select></div></li><li ng-if=filterToShow.vehicleAssigned><label class=control-label>{{\'vehicleAssigned\' | translate}}</label><input type=text class=form-control ng-model=filterData.vehicle_unique ng-change=vehicleAssignChanged() placeholder=\"{{\'uniqueNumber\' | translate}}\" ng-model-options=\"{ debounce: 500 }\"></li><li ng-if=filterToShow.tripType><label>{{\'tripType\' | translate}}:</label><div><select class=form-control ng-model=filterData.type_of_trip ng-change=typeTripChanged() ng-options=\"data.id as data.text for data in typeTripFilter\"><option value=\"\" selected disabled>{{\'selectTripType\' | translate}}</option></select></div></li></ul></div>");
$templateCache.put("app/components/views/gauss-control/gaussControl.html","<h2 class=ng-cloak><span>{{\'gaussControlMatrix\' | translate}}</span><!-- <span class=\"pull-right\">\n        <button class=\"btn btn-primary tableButton\" ng-click=\"vm.refreshData()\">Volver a cargar</button>\n    </span> --></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"padding: 0\" ng-class=\"{\'disableGaussActions\' : !vm.modifyGauss }\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 lastModification\"><span><b>{{\'lastModefication\' | translate}}: {{vm.gaussInfo.datetime_update | date: \'dd/MM/yyyy\'}} - {{\'administrator\' | translate}}: {{vm.gaussInfo.fullName}}</b></span></div><div class=\"col-lg-offset-1 col-lg-11 col-sm-offset-1 col-sm-11 col-md-offset-1 col-md-11 col-xs-offset-1 col-xs-11 text-center\"><hr style=\"border-top: lightgray 1px solid\"><span class=actions><b>{{\'actions\' | translate}}</b></span></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 pad0\"><div class=\"col-xs-1 nfa text-center\"><b>NFA</b></div><div class=\"col-xs-2 nfa-white text-center\"><b>{{\'noAction\' | translate}}</b></div><div class=\"col-xs-3 nfa-white text-center\"><b>{{\'report\' | translate}}</b></div><div class=\"col-xs-3 nfa-white text-center\"><b>{{\'disconnect\' | translate}}</b></div><div class=\"col-xs-3 nfa-white-right text-center\"><b>{{\'toBlock\' | translate}}</b></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 marTop10 pad0\"><div class=\"col-xs-1 nfa1 text-center\"><b>1</b></div><div class=\"col-xs-2 nfa-white1 text-center\"><div class=radio-button><input type=radio ng-model=vm.nfa1 name=nfa1 value=1 ng-click=\"vm.checkNfaValue(\'nfa1\', \'1\')\" class=radio-input></div></div><div class=\"col-xs-3 nfa-white text-center\"><div ng-if=!vm.showInformar1Error class=radio-button><input type=radio ng-model=vm.nfa1 name=nfa1 value=2 ng-click=\"vm.checkNfaValue(\'nfa1\', \'2\')\" class=radio-input></div><div class=arrow_box ng-if=vm.showInformar1Error><i class=\"fa fa-exclamation-circle\"></i> {{\'youMustEnterAMessage\' | translate}}</div><div><textarea maxlength=255 ng-model=vm.informar1 placeholder=\"{{\'enterMessage\' | translate}}\" ng-disabled=\"vm.nfa1 != \'2\'\" ng-class=\"{ \'fieldDisabled\': vm.nfa1 != \'2\', \'erroredValue\': vm.showInformar1Error, \'borderValue\': vm.informar1}\" class=text-input1 ng-keyup=\"vm.detectInputChange(vm.informar1, \'informar1\')\"></textarea></div></div><div class=\"col-xs-3 nfa-white text-center\"><div ng-if=!vm.showDesconectar1Error class=radio-button><input type=radio ng-model=vm.nfa1 name=nfa1 value=3 ng-click=\"vm.checkNfaValue(\'nfa1\', \'3\')\" class=radio-input></div><div class=arrow_box ng-if=vm.showDesconectar1Error><i class=\"fa fa-exclamation-circle\"></i> {{\'youMustEnterAMessage\' | translate}}</div><div><textarea maxlength=255 ng-model=vm.desconectar1 placeholder=\"{{\'enterMessage\' | translate}}\" ng-disabled=\"vm.nfa1 != \'3\'\" ng-keyup=\"vm.detectInputChange(vm.desconectar1, \'desconectar1\')\" ng-class=\"{ \'fieldDisabled\': vm.nfa1 != \'3\', \'erroredValue\':  vm.showDesconectar1Error, \'borderValue\': vm.desconectar1}\" class=text-input1></textarea></div></div><div class=\"col-xs-3 nfa-white-right text-center\"><div ng-if=!vm.showBloquear1Error class=radio-button><span class=marL34><input type=radio ng-model=vm.nfa1 name=nfa1 value=4 ng-click=\"vm.checkNfaValue(\'nfa1\', \'4\')\" class=radio-input> </span><span class=marL28>{{\'tolerance\' | translate}}</span></div><div class=arrow_box ng-if=vm.showBloquear1Error><i class=\"fa fa-exclamation-circle\"></i> {{\'youMustEnterAMessage\' | translate}}</div><div><span class=marL5><textarea maxlength=255 ng-model=vm.bloquear1 placeholder=\"{{\'enterMessage\' | translate}}\" ng-disabled=\"vm.nfa1 != \'4\'\" ng-keyup=\"vm.detectInputChange(vm.bloquear1, \'bloquear1\')\" ng-class=\"{ \'fieldDisabled\': vm.nfa1 != \'4\', \'erroredValue\':  vm.showBloquear1Error, \'borderValue\': vm.bloquear1}\" class=text-input1></textarea></span><span class=marL5><input type=text ng-model=vm.tolerance1 is-number maxlength=2 ng-keyup=\"vm.detectInputChange2(vm.tolerance1, \'tolerance1\')\" ng-disabled=\"vm.nfa1 != \'4\'\" ng-class=\"{ \'fieldDisabled\': vm.nfa1 != \'4\', \'erroredValue\': vm.tolerance1 > 10 || vm.tolerance1Error, \'borderValue\': vm.tolerance1 && vm.tolerance1 < 11 }\" class=text-input2></span></div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 marTop10 pad0\"><div class=\"col-xs-1 nfa1 text-center\"><b>2</b></div><div class=\"col-xs-2 nfa-white1 text-center\"><div class=radio-button><input type=radio ng-model=vm.nfa2 name=nfa2 value=1 ng-click=\"vm.checkNfaValue(\'nfa2\', \'1\')\" class=radio-input></div></div><div class=\"col-xs-3 nfa-white text-center\"><div ng-if=!vm.showInformar2Error class=radio-button><input type=radio ng-model=vm.nfa2 name=nfa2 value=2 ng-click=\"vm.checkNfaValue(\'nfa2\', \'2\')\" class=radio-input></div><div class=arrow_box ng-if=vm.showInformar2Error><i class=\"fa fa-exclamation-circle\"></i> {{\'youMustEnterAMessage\' | translate}}</div><div><textarea maxlength=255 ng-disabled=\"vm.nfa2 != \'2\'\" ng-class=\"{ \'fieldDisabled\': vm.nfa2 != \'2\', \'erroredValue\': vm.showInformar2Error, \'borderValue\': vm.informar2 }\" class=text-input1 ng-model=vm.informar2 ng-keyup=\"vm.detectInputChange(vm.informar2, \'informar2\')\" placeholder=\"{{\'enterMessage\' | translate}}\"></textarea></div></div><div class=\"col-xs-3 nfa-white text-center\"><div ng-if=!vm.showDesconectar2Error class=radio-button><input type=radio ng-model=vm.nfa2 name=nfa2 value=3 ng-click=\"vm.checkNfaValue(\'nfa2\', \'3\')\" class=radio-input></div><div class=arrow_box ng-if=vm.showDesconectar2Error><i class=\"fa fa-exclamation-circle\"></i> {{\'youMustEnterAMessage\' | translate}}</div><div><textarea maxlength=255 ng-disabled=\"vm.nfa2 != \'3\'\" ng-class=\"{ \'fieldDisabled\': vm.nfa2 != \'3\', \'erroredValue\':  vm.showDesconectar2Error, \'borderValue\': vm.desconectar2 }\" class=text-input1 ng-model=vm.desconectar2 ng-keyup=\"vm.detectInputChange(vm.desconectar2, \'desconectar2\')\" placeholder=\"{{\'enterMessage\' | translate}}\"></textarea></div></div><div class=\"col-xs-3 nfa-white-right text-center\"><div ng-if=!vm.showBloquear2Error class=radio-button><span class=marL34><input type=radio ng-model=vm.nfa2 name=nfa2 value=4 ng-click=\"vm.checkNfaValue(\'nfa2\', \'4\')\" class=radio-input> </span><span class=marL28>{{\'tolerance\' | translate}}</span></div><div class=arrow_box ng-if=vm.showBloquear2Error><i class=\"fa fa-exclamation-circle\"></i> {{\'youMustEnterAMessage\' | translate}}</div><span class=marL5><textarea maxlength=255 ng-disabled=\"vm.nfa2 != \'4\'\" ng-class=\"{ \'fieldDisabled\': vm.nfa2 != \'4\', \'erroredValue\':  vm.showBloquear2Error, \'borderValue\': vm.bloquear2}\" class=text-input1 ng-model=vm.bloquear2 ng-keyup=\"vm.detectInputChange(vm.bloquear2, \'bloquear2\')\" placeholder=\"{{\'enterMessage\' | translate}}\"></textarea></span><span class=marL5><input type=text ng-disabled=\"vm.nfa2 != \'4\'\" ng-class=\"{ \'fieldDisabled\': vm.nfa2 != \'4\', \'erroredValue\': vm.tolerance2 > 10 || vm.tolerance2Error, \'borderValue\': vm.tolerance2 && vm.tolerance2 < 11 }\" class=text-input2 ng-model=vm.tolerance2 ng-keyup=\"vm.detectInputChange2(vm.tolerance2, \'tolerance2\')\" is-number maxlength=2></span></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 marTop10 pad0\"><div class=\"col-xs-1 nfa1 text-center\"><b>3</b></div><div class=\"col-xs-2 nfa-white1 text-center\"><div class=radio-button><input type=radio ng-model=vm.nfa3 name=nfa3 value=1 ng-click=\"vm.checkNfaValue(\'nfa3\', \'1\')\" class=radio-input></div></div><div class=\"col-xs-3 nfa-white text-center\"><div ng-if=!vm.showInformar3Error class=radio-button><input type=radio ng-model=vm.nfa3 name=nfa3 value=2 ng-click=\"vm.checkNfaValue(\'nfa3\', \'2\')\" class=radio-input></div><div class=arrow_box ng-if=vm.showInformar3Error><i class=\"fa fa-exclamation-circle\"></i> {{\'youMustEnterAMessage\' | translate}}</div><div><textarea maxlength=255 ng-disabled=\"vm.nfa3 != \'2\'\" ng-class=\"{ \'fieldDisabled\': vm.nfa3 != \'2\', \'erroredValue\': vm.showInformar3Error, \'borderValue\': vm.informar3 }\" class=text-input1 ng-model=vm.informar3 ng-keyup=\"vm.detectInputChange(vm.informar3, \'informar3\')\" placeholder=\"{{\'enterMessage\' | translate}}\"></textarea></div></div><div class=\"col-xs-3 nfa-white text-center\"><div ng-if=!vm.showDesconectar3Error class=radio-button><input type=radio ng-model=vm.nfa3 name=nfa3 value=3 ng-click=\"vm.checkNfaValue(\'nfa3\', \'3\')\" class=radio-input></div><div class=arrow_box ng-if=vm.showDesconectar3Error><i class=\"fa fa-exclamation-circle\"></i> {{\'youMustEnterAMessage\' | translate}}</div><div><textarea ng-disabled=\"vm.nfa3 != \'3\'\" ng-class=\"{ \'fieldDisabled\': vm.nfa3 != \'3\', \'erroredValue\':  vm.showDesconectar3Error, \'borderValue\': vm.desconectar3 }\" class=text-input1 ng-model=vm.desconectar3 maxlength=255 ng-keyup=\"vm.detectInputChange(vm.desconectar3, \'desconectar3\')\" placeholder=\"{{\'enterMessage\' | translate}}\"></textarea></div></div><div class=\"col-xs-3 nfa-white-right text-center\"><div ng-if=!vm.showBloquear3Error class=radio-button><span class=marL34><input type=radio ng-model=vm.nfa3 name=nfa3 value=4 ng-click=\"vm.checkNfaValue(\'nfa3\', \'4\')\" class=radio-input> </span><span class=marL28>{{\'tolerance\' | translate}}</span></div><div class=arrow_box ng-if=vm.showBloquear3Error><i class=\"fa fa-exclamation-circle\"></i> {{\'youMustEnterAMessage\' | translate}}</div><span class=marL5><textarea maxlength=255 ng-disabled=\"vm.nfa3 != \'4\'\" ng-class=\"{ \'fieldDisabled\': vm.nfa3 != \'4\', \'erroredValue\':  vm.showBloquear3Error, \'borderValue\': vm.bloquear3 }\" class=text-input1 ng-model=vm.bloquear3 ng-keyup=\"vm.detectInputChange(vm.bloquear3, \'bloquear3\')\" placeholder=\"{{\'enterMessage\' | translate}}\"></textarea></span><span class=marL5><input type=text ng-model=vm.tolerance3 is-number ng-keyup=\"vm.detectInputChange2(vm.tolerance3, \'tolerance3\')\" maxlength=2 ng-disabled=\"vm.nfa3 != \'4\'\" ng-class=\"{ \'fieldDisabled\': vm.nfa3 != \'4\', \'erroredValue\': vm.tolerance3 > 10 || vm.tolerance3Error, \'borderValue\': vm.tolerance3 && vm.tolerance3 < 11 }\" class=text-input2></span></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 marTop10 pad0\"><div class=\"col-xs-1 nfa1 text-center\"><b>4</b></div><div class=\"col-xs-2 nfa-white1 text-center\"><div class=radio-button><input type=radio ng-model=vm.nfa4 name=nfa4 value=1 ng-click=\"vm.checkNfaValue(\'nfa4\', \'1\')\" class=radio-input></div></div><div class=\"col-xs-3 nfa-white text-center\"><div ng-if=!vm.showInformar4Error class=radio-button><input type=radio ng-model=vm.nfa4 name=nfa4 value=2 ng-click=\"vm.checkNfaValue(\'nfa4\', \'2\')\" class=radio-input></div><div class=arrow_box ng-if=vm.showInformar4Error><i class=\"fa fa-exclamation-circle\"></i> {{\'youMustEnterAMessage\' | translate}}</div><div><textarea ng-disabled=\"vm.nfa4 != \'2\'\" ng-class=\"{ \'fieldDisabled\': vm.nfa4 != \'2\', \'erroredValue\': vm.showInformar4Error, \'borderValue\': vm.informar4 }\" class=text-input1 maxlength=255 ng-model=vm.informar4 ng-keyup=\"vm.detectInputChange(vm.informar4, \'informar4\')\" placeholder=\"{{\'enterMessage\' | translate}}\"></textarea></div></div><div class=\"col-xs-3 nfa-white text-center\"><div ng-if=!vm.showDesconectar4Error class=radio-button><input type=radio ng-model=vm.nfa4 name=nfa4 value=3 ng-click=\"vm.checkNfaValue(\'nfa4\', \'3\')\" class=radio-input></div><div class=arrow_box ng-if=vm.showDesconectar4Error><i class=\"fa fa-exclamation-circle\"></i> {{\'youMustEnterAMessage\' | translate}}</div><div><textarea ng-disabled=\"vm.nfa4 != \'3\'\" ng-class=\"{ \'fieldDisabled\': vm.nfa4 != \'3\', \'erroredValue\':  vm.showDesconectar4Error, \'borderValue\': vm.desconectar4 }\" class=text-input1 maxlength=255 ng-model=vm.desconectar4 ng-keyup=\"vm.detectInputChange(vm.desconectar4, \'desconectar4\')\" placeholder=\"{{\'enterMessage\' | translate}}\"></textarea></div></div><div class=\"col-xs-3 nfa-white-right text-center\"><div ng-if=!vm.showBloquear4Error class=radio-button><span class=marL34><input type=radio ng-model=vm.nfa4 name=nfa4 value=4 ng-click=\"vm.checkNfaValue(\'nfa4\', \'4\')\" class=radio-input> </span><span class=marL28>{{\'tolerance\' | translate}}</span></div><div class=arrow_box ng-if=vm.showBloquear4Error><i class=\"fa fa-exclamation-circle\"></i> {{\'youMustEnterAMessage\' | translate}}</div><span class=marL5><textarea ng-disabled=\"vm.nfa4 != \'4\'\" ng-class=\"{ \'fieldDisabled\': vm.nfa4 != \'4\', \'erroredValue\':  vm.showBloquear4Error, \'borderValue\': vm.bloquear4 }\" maxlength=255 ng-model=vm.bloquear4 ng-keyup=\"vm.detectInputChange(vm.bloquear4, \'bloquear4\')\" placeholder=\"{{\'enterMessage\' | translate}}\" class=text-input1></textarea></span><span class=marL5><input type=text ng-disabled=\"vm.nfa4 != \'4\'\" ng-class=\"{ \'fieldDisabled\': vm.nfa4 != \'4\', \'erroredValue\': vm.tolerance4 > 10 || vm.tolerance4Error, \'borderValue\': vm.tolerance4 && vm.tolerance4 < 11 }\" ng-model=vm.tolerance4 is-number ng-keyup=\"vm.detectInputChange2(vm.tolerance4, \'tolerance4\')\" maxlength=2 class=text-input2></span></div></div></div><div class=action-buttons><button type=button class=modifyLabelButton style=\"padding: 0 20px 0 20px\" ng-click=vm.modifyGaussData() ng-class=\"{\'disableModify\' : vm.modifyGauss}\">{{\'modify\' | translate}}</button> <button type=button class=addLabelButton style=\"padding: 0 20px 0 20px\" ng-click=vm.saveGaussControl() ng-class=\"{\'disableCancelSubmit\' : !vm.modifyGauss}\">{{\'submit\' | translate}}</button> <button type=button class=cancelLabelButton style=\"padding: 0 20px 0 20px\" ng-click=vm.cancelFormBalance() ng-class=\"{\'disableCancelSubmit\' : !vm.modifyGauss}\">{{\'cancelButton\' | translate}}</button></div></div></div><style>input[type=\"radio\"] {\n        /* remove standard background appearance */\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        appearance: none;\n        /* create custom radiobutton appearance */\n        display: inline-block;\n        width: 18px;\n        height: 18px;\n        padding: 2px;\n        /* background-color only for content */\n        background-clip: content-box;\n        border: 2px solid #0000005c;\n            /* background-color: #e7e6e7; */\n        border-radius: 50%;\n    }\n\n    /* appearance for checked radiobutton */\n    input[type=\"radio\"]:checked {\n        background-color: #000000c9;\n    }</style>");
$templateCache.put("app/components/views/gauss-control/gaussControlMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/generate-payment-status/abrirPeriodo.html","<h2 class=ng-cloak style=\"text-align: center\">Abrir último Período Cerrado</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-if=vm.flagToShow><div class=row ng-repeat=\"data in vm.dataReopen\" style=margin-bottom:30px><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" style=\"text-align: right\"><button class=MonthButton>{{data.production_date | date:\'LLLL\'}} {{data.production_date | date:\'yyyy\'}}</button></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><button class=SubmitButton ng-click=vm.AbrirPeriodo($event,data)>Abrir Periodo</button></div></div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-if=!vm.flagToShow><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"text-align: center;font-weight: bold;font-size: 22px\">No hay meses para abrir</div></div></div></div></div>");
$templateCache.put("app/components/views/generate-payment-status/abrirPeriodoMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/generate-payment-status/cierroPeriode.html","<h2 class=ng-cloak style=\"text-align: center\">Cierre de Período</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-if=\"vm.flagToShow || !vm.closeProductionEmpty\"><div class=row ng-repeat=\"data in vm.DateArray\" style=margin-bottom:30px><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" style=\"text-align: right\"><button class=MonthButton>{{data.production_date | date:\'LLLL\'}} {{data.production_date | date:\'yyyy\'}}</button></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><button class=SubmitButton ng-click=vm.CierroPeriodo($event,data)>Cerrar Periodo</button></div></div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-if=\"!vm.flagToShow || vm.closeProductionEmpty\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"text-align: center;font-weight: bold;font-size: 22px\">No hay meses para cerrar</div></div></div></div></div>");
$templateCache.put("app/components/views/generate-payment-status/cierroPeriodeMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/generate-payment-status/generatePaymentStatus.html","<h2 class=ng-cloak>{{\'generatePaymentStatus\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"panel panel-default\"><div class=panel-body><form name=generatePaymentForm ng-submit=\"submit=true;generatePaymentForm.$valid&&vm.generatePaymentApi()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12 col-lg-offset-3 col-sm-offset-3 col-xs-offset-3 col-md-offset-3\"><md-checkbox class=md-primary ng-click=vm.addInactiveAgrrement() ng-model=vm.dataToFill.addInactive aria-label=\"Add Inactive\">{{\'addInactive\' | translate}}</md-checkbox></div></div><div class=row><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label>{{\'singleCorporate\' | translate}} <span style=color:red>*</span></label><ui-select ng-model=vm.dataToFill.corporate ng-keyup=vm.corporateSearch($select.search,$event) name=corporateName required close-on-select=true><ui-select-match placeholder=\"{{\'corporatePlaceholder\' | translate}}\">{{$select.selected.company_name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in vm.corporatesList | filter: $select.search\" when-scrolled=vm.paginationChangedForCorporation() ng-click=vm.corporateChange()><div ng-bind-html=data.company_name></div></ui-select-choices></ui-select><div ng-if=\"generatePaymentForm.corporateName.$touched|| submit\" ng-messages=generatePaymentForm.corporateName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'corpoReq\' | translate}}</div></div></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label>{{\'agreementLabel\' | translate}} <span style=color:red>*</span></label><ui-select multiple theme=bootstrap ng-keyup=vm.agreementSearch($select.search,$event) ng-model=vm.dataToFill.aggrement name=agreement required close-on-select=true ng-class=\"{ \'has-error\': generatePaymentForm.agreement.$touched && generatePaymentForm.agreement.$invalid }\"><ui-select-match placeholder=\"{{\'agreementPlaceholder\' | translate}}\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"agreements.id as agreements in vm.agreement | filter: $select.search\" when-scrolled=vm.paginationChangedForAgreement() ng-click=vm.agreementChanged()><div ng-bind-html=agreements.name></div></ui-select-choices></ui-select><div ng-if=\"generatePaymentForm.agreement.$touched|| submit\" ng-messages=generatePaymentForm.agreement.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'selectAgreementReq\' | translate}}</div></div></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label>{{\'singleFrom\' | translate}} <span style=color:red>*</span></label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=startValidity ng-model=vm.dataToFill.from placeholder=\"{{\'singleFrom\' | translate}}\" ng-class=\"{ \'has-error\': generatePaymentForm.startValidity.$touched && generatePaymentForm.startValidity.$invalid }\" is-open=vm.datePicker_1.from datepicker-options=vm.dateOptionsFrom required close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.fromDateChange()> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'1\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"generatePaymentForm.startValidity.$touched|| submit\" ng-messages=generatePaymentForm.startValidity.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'fromR\' | translate}}</div></div></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label>{{\'singleUntill\' | translate}} <span style=color:red>*</span></label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=endValidity ng-model=vm.dataToFill.untill placeholder=\"{{\'singleUntill\' | translate}}\" ng-class=\"{ \'has-error\': generatePaymentForm.endValidity.$touched && generatePaymentForm.endValidity.$invalid }\" is-open=vm.datePicker_1.untill datepicker-options=vm.dateOptionsUntill required close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.untillDateChange()> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'2\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"generatePaymentForm.endValidity.$touched|| submit\" ng-messages=generatePaymentForm.endValidity.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'untillR\' | translate}}</div></div></div></div><div class=row style=\"margin: 40px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><button class=\"btn btn-primary\" type=submit>{{\'generateReport\' | translate}}</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/components/views/generate-payment-status/generatePaymentStatusMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/generate-payment-status/operationalReport.html","<h2 class=ng-cloak>Informe Operacional</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"panel panel-default\"><div class=panel-body><form name=generatePaymentForm ng-submit=\"submit=true;generatePaymentForm.$valid&&vm.generateOperationalReport()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12 col-lg-offset-3 col-sm-offset-3 col-xs-offset-3 col-md-offset-3\"><md-checkbox class=md-primary ng-click=vm.addInactiveAgrrement() ng-model=vm.dataToFill.addInactive aria-label=\"Add Inactive\">{{\'addInactive\' | translate}}</md-checkbox><!-- <button class=\"btn btn-primary pull-right tableButton\" type=button ng-click=\"vm.selectAll()\">Select All</button> --></div></div><div class=row><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label>{{\'singleCorporate\' | translate}} <span style=color:red>*</span></label><ui-select ng-model=vm.dataToFill.corporate ng-keyup=vm.corporateSearch($select.search,$event) name=corporateName required close-on-select=true><ui-select-match placeholder=\"{{\'corporatePlaceholder\' | translate}}\">{{$select.selected.company_name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in vm.corporatesList | filter: $select.search\" when-scrolled=vm.paginationChangedForCorporation() ng-click=vm.corporateChange()><div ng-bind-html=data.company_name></div></ui-select-choices></ui-select><div ng-if=\"generatePaymentForm.corporateName.$touched|| submit\" ng-messages=generatePaymentForm.corporateName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'corpoReq\' | translate}}</div></div></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label>{{\'agreementLabel\' | translate}} <span style=color:red>*</span></label><ui-select ng-disabled=\" vm.flagToDisable == true\" multiple theme=bootstrap ng-keyup=vm.agreementSearch($select.search,$event) ng-model=vm.dataToFill.aggrement name=agreement close-on-select=true ng-class=\"{ \'has-error\': generatePaymentForm.agreement.$touched && generatePaymentForm.agreement.$invalid }\"><ui-select-match placeholder=\"{{\'agreementPlaceholder\' | translate}}\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"agreements.id as agreements in vm.agreement | filter: $select.search | orderBy:\'name\' \" when-scrolled=vm.paginationChangedForAgreement() ng-click=vm.agreementChanged()><div ng-bind-html=agreements.name></div></ui-select-choices></ui-select><div ng-if=\"generatePaymentForm.agreement.$touched|| submit\" ng-messages=generatePaymentForm.agreement.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'selectAgreementReq\' | translate}}</div></div><div style=\"margin-top: 15px\"><md-checkbox class=md-primary ng-click=vm.selectAll() ng-model=vm.selectAllFlag aria-label=\"Select All\">Select All</md-checkbox></div><!-- for selecting all option --><!-- <ui-select ng-if=\"vm.dataToFill.corporate == \'all\'\" theme=\"bootstrap\" ng-model=\"vm.dataToFill.aggrement\" name=\"agreement\" required close-on-select=\"true\"\n                                    ng-class=\"{ \'has-error\': generatePaymentForm.agreement.$touched && generatePaymentForm.agreement.$invalid }\">\n                                    <ui-select-match placeholder=\"{{\'agreementPlaceholder\' | translate}}\">\n                                        {{$select.selected.name}}\n                                    </ui-select-match>\n                                    <ui-select-choices repeat=\"agreements.id as agreements in vm.allAgreement | filter: $select.search | orderBy:\'name\' \">\n                                        <div ng-bind-html=\"agreements.name\"></div>\n                                    </ui-select-choices>\n                                </ui-select> --></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label>{{\'singleFrom\' | translate}} <span style=color:red>*</span></label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=startValidity ng-model=vm.dataToFill.from placeholder=\"{{\'singleFrom\' | translate}}\" ng-class=\"{ \'has-error\': generatePaymentForm.startValidity.$touched && generatePaymentForm.startValidity.$invalid }\" is-open=vm.datePicker_1.from datepicker-options=vm.dateOptionsFrom required close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.fromDateChange()> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'1\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"generatePaymentForm.startValidity.$touched|| submit\" ng-messages=generatePaymentForm.startValidity.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'fromR\' | translate}}</div></div></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label style=\"visibility: hidden\">{{\'singleFrom\' | translate}} <span style=color:red>*</span></label><div uib-timepicker ng-model=vm.dataToFill.timeOptionsFrom show-spinners=false class=completed hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian></div></div></div><div class=row><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label>{{\'singleUntill\' | translate}} <span style=color:red>*</span></label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=endValidity ng-model=vm.dataToFill.untill placeholder=\"{{\'singleUntill\' | translate}}\" ng-class=\"{ \'has-error\': generatePaymentForm.endValidity.$touched && generatePaymentForm.endValidity.$invalid }\" is-open=vm.datePicker_1.untill datepicker-options=vm.dateOptionsUntill required close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.untillDateChange()> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'2\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"generatePaymentForm.endValidity.$touched|| submit\" ng-messages=generatePaymentForm.endValidity.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'untillR\' | translate}}</div></div></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label style=\"visibility: hidden\">{{\'singleUntill\' | translate}} <span style=color:red>*</span></label><div uib-timepicker ng-model=vm.dataToFill.timeOptionsUntil show-spinners=false class=completed hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian></div></div></div><div class=row style=\"margin: 40px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><button class=\"btn btn-primary\" type=submit>{{\'generateReport\' | translate}}</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/components/views/generate-payment-status/operationalReportMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/geofence/addFixedRoute.html","<div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'fixedRouteNewHead\' | translate}}</p><form name=addFixedRouteForm ng-submit=\"submit=true;addFixedRouteForm.$valid&&vm.addFixedRouteHit()\" novalidate autocomplete=off><div class=row style=\"padding:0px 10px;margin-bottom:5px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'fixedNameLabel\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.name name=fixedRouteName placeholder=\"{{\'fixedNameLabel\' | translate}}\" required ng-maxlength=60 ng-minlength=3 ng-class=\"{ \'has-error\': addFixedRouteForm.fixedRouteName.$touched && addFixedRouteForm.fixedRouteName.$invalid }\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\"addFixedRouteForm.fixedRouteName.$touched|| submit\" ng-messages=addFixedRouteForm.fixedRouteName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'fixedNameReq\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid fixed route  name.</div>--><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'firstNameMaximum\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'branchLabel\' | translate}} <span style=color:red>*</span></label><!--<input type=\"text\" ng-model=\"vm.dataToFill.branchDetails\" placeholder=\"Enter Branch\" uib-typeahead=\"branch as branch.region_name for branch in vm.branchList | filter:{region_name:$viewValue}\" typeahead-loading=\"loadingBranches\"--><!--typeahead-no-results=\"noResults\" class=\"form-control\" name=\"branch\" typeahead-on-select=\"vm.branchChanged()\" required ng-class=\"{ \'has-error\': addFixedRouteForm.branch.$touched && addFixedRouteForm.branch.$invalid }\">--><!--<i ng-show=\"loadingBranches\" class=\"glyphicon glyphicon-refresh\"></i>--><!--<div ng-show=\"noResults\" class=\"mt5\">--><!--<i class=\"glyphicon glyphicon-remove\"></i> No Results Found--><!--</div>--><ui-select ng-model=vm.dataToFill.branch name=branch required ng-class=\"{ \'has-error\': addFixedRouteForm.branch.$touched && addFixedRouteForm.branch.$invalid }\" close-on-select=true ng-change=vm.branchChanged()><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \"><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select><div ng-if=\"addFixedRouteForm.branch.$touched|| submit\" ng-messages=addFixedRouteForm.branch.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'branchR\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'origin\' | translate}} <span style=color:red>*</span></label><ui-select ng-model=vm.dataToFill.pickup name=locationFirst required ng-class=\"{ \'has-error\': addFixedRouteForm.locationFirst.$touched && addFixedRouteForm.locationFirst.$invalid }\" close-on-select=true ng-change=\"vm.locationChanged(\'1\')\" ng-disabled=vm.locationListDisbaled><ui-select-match placeholder=\"{{\'originSelect\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"locationF.region_id as locationF in vm.locationList | filter: $select.search | orderBy:\'region_name\'\"><div ng-bind-html=locationF.region_name></div></ui-select-choices></ui-select><!--<select class=\"form-control\" ng-model=\"vm.dataToFill.pickup\" name=\"locationFirst\" required ng-class=\"{ \'has-error\': addFixedRouteForm.locationFirst.$touched && addFixedRouteForm.locationFirst.$invalid }\"--><!--ng-options=\"locationF.region_id as locationF.region_name for locationF in vm.locationList\" ng-change=\"vm.locationChanged(\'1\')\" ng-disabled=\"vm.locationListDisbaled\">--><!--<option value=\"\" disabled selected>Select Location First</option>--><!--</select>--><div ng-if=\"addFixedRouteForm.locationFirst.$touched|| submit\" ng-messages=addFixedRouteForm.locationFirst.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'originReq\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Destination Branch <span style=color:red>*</span></label><!--<input type=\"text\" ng-model=\"vm.dataToFill.branchDetails\" placeholder=\"Enter Branch\" uib-typeahead=\"branch as branch.region_name for branch in vm.branchList | filter:{region_name:$viewValue}\" typeahead-loading=\"loadingBranches\"--><!--typeahead-no-results=\"noResults\" class=\"form-control\" name=\"branch\" typeahead-on-select=\"vm.branchChanged()\" required ng-class=\"{ \'has-error\': addFixedRouteForm.branch.$touched && addFixedRouteForm.branch.$invalid }\">--><!--<i ng-show=\"loadingBranches\" class=\"glyphicon glyphicon-refresh\"></i>--><!--<div ng-show=\"noResults\" class=\"mt5\">--><!--<i class=\"glyphicon glyphicon-remove\"></i> No Results Found--><!--</div>--><ui-select ng-model=vm.dataToFill.destinationBranch name=destinationBranch required ng-class=\"{ \'has-error\': addFixedRouteForm.destinationBranch.$touched && addFixedRouteForm.destinationBranch.$invalid }\" close-on-select=true ng-change=vm.destinationBranchChanged()><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \"><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select><div ng-if=\"addFixedRouteForm.branch.$touched|| submit\" ng-messages=addFixedRouteForm.branch.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'branchR\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'destination\' | translate}} <span style=color:red>*</span></label><ui-select ng-model=vm.dataToFill.dropoff name=locationSecond required ng-class=\"{ \'has-error\': addFixedRouteForm.locationSecond.$touched && addFixedRouteForm.locationSecond.$invalid }\" close-on-select=true ng-change=\"vm.locationChanged(\'2\')\" ng-disabled=vm.locationListDisbaled><ui-select-match placeholder=\"{{\'destinationSelect\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"locationS.region_id as locationS in vm.locationList1 | filter: $select.search | orderBy:\'region_name\'\"><div ng-bind-html=locationS.region_name></div></ui-select-choices></ui-select><!--<select class=\"form-control\" ng-model=\"vm.dataToFill.dropoff\" name=\"locationSecond\" required ng-class=\"{ \'has-error\': addFixedRouteForm.locationSecond.$touched && addFixedRouteForm.locationSecond.$invalid }\"--><!--ng-options=\"locationS.region_id as locationS.region_name for locationS in vm.locationList\" ng-change=\"vm.locationChanged(\'2\')\" ng-disabled=\"vm.locationListDisbaled\">--><!--<option value=\"\" disabled selected>Select Location Second</option>--><!--</select>--><div ng-if=\"addFixedRouteForm.locationSecond.$touched|| submit\" ng-messages=addFixedRouteForm.locationSecond.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'destinationReq\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'fixedDescLabel\' | translate}}</label><textarea class=form-control ng-model=vm.dataToFill.description placeholder=\"{{\'messagePlaceholder\' | translate}}\" style=\"height: 100px\"></textarea></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5 text-center\"><button class=\"btn btn-primary\" type=submit style=width:40%>{{\'submit\' | translate}}</button> <button class=\"btn btn-danger\" type=button style=width:40% ng-click=vm.cancelEdit()>{{\'cancelButton\' | translate}}</button></div></div></form></div>");
$templateCache.put("app/components/views/geofence/addIlluminatedSmallRegions.html","<div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">Añadir zona iluminada</p><form name=addFixedRouteForm ng-submit=\"submit=true;addFixedRouteForm.$valid&&vm.addIlluminatedZoneHit()\" novalidate autocomplete=off><div class=row style=\"padding:0px 10px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Sucursal <span style=color:red>*</span></label><ui-select ng-model=vm.branchName name=branch required ng-class=\"{ \'has-error\': addFixedRouteForm.branch.$touched && addFixedRouteForm.branch.$invalid }\" close-on-select=true ng-change=vm.branchChanged()><ui-select-match placeholder=\"Seleccionar Sucursal\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\'\"><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select><!--<select class=\"form-control\" ng-model=\"vm.branchName\" name=\"branch\" required ng-class=\"{ \'has-error\': addFixedRouteForm.branch.$touched && addFixedRouteForm.branch.$invalid }\"--><!--ng-options=\"branch.region_id as branch.region_name for branch in vm.branchList\" ng-change=\"vm.branchChanged()\">--><!--<option value=\"\" disabled selected>Select Branch</option>--><!--</select>--><div ng-if=\"addFixedRouteForm.branch.$touched|| submit\" ng-messages=addFixedRouteForm.branch.$error><div class=\"errormessage text-danger\" ng-message=required>Por favor seleccione sucursal</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Nombre de la zona iluminada <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.name name=fixedRouteName placeholder=\"Nombre de la zona iluminada\" required ng-maxlength=60 ng-minlength=3 ng-class=\"{ \'has-error\': addFixedRouteForm.fixedRouteName.$touched && addFixedRouteForm.fixedRouteName.$invalid }\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\"addFixedRouteForm.fixedRouteName.$touched|| submit\" ng-messages=addFixedRouteForm.fixedRouteName.$error><div class=\"errormessage text-danger\" ng-message=required>Por favor ingrese el nombre de la zona iluminada</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid fixed route  name.</div>--><div class=\"errormessage text-danger\" ng-message=minlength>Se requieren un mínimo de 3 caracteres</div><div class=\"errormessage text-danger\" ng-message=maxlength>A lo más pueden ser 60 caracteres</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Controlar cantidad de vehículos en App <span style=color:red>*</span></label><select class=form-control ng-model=vm.control_cantity_driver_app ng-class=\"{ \'has-error\':   addFixedRouteForm.controlCantityDriverApp.$touched &&   addFixedRouteForm.controlCantityDriverApp.$invalid }\" name=controlCantityDriverApp required><!-- <option value=\"\" disabled selected>Controlar cantidad de vehículos en App</option> --><option value=1>Yes</option><option value=0>No</option></select><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\"addFixedRouteForm.controlCantityDriverApp.$touched|| submit\" ng-messages=addFixedRouteForm.controlCantityDriverApp.$error><div class=\"errormessage text-danger\" ng-message=required>Por favor ingrese el Controlar cantidad de vehículos en App</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Maximum number of vehicles <span style=color:red>*</span></label><input type=number ng-disabled=\"vm.control_cantity_driver_app == 0\" class=form-control ng-model=vm.maximum_quantity_show_driverapp name=maximumQuantityShowDriverapp placeholder=\"Nombre de la zona iluminada\" required ng-class=\"{ \'has-error\': addFixedRouteForm.maximumQuantityShowDriverapp.$touched && addFixedRouteForm.maximumQuantityShowDriverapp.$invalid }\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\"addFixedRouteForm.maximumQuantityShowDriverapp.$touched|| submit\" ng-messages=addFixedRouteForm.maximumQuantityShowDriverapp.$error><div class=\"errormessage text-danger\" ng-message=required>Por favor ingrese el Maximum number of vehicles</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Descripción de la zona iluminada</label><textarea class=form-control ng-model=vm.description placeholder=\"Ingresar texto\" style=\"height: 100px\"></textarea></div><!-- <div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 table-responsive\">\n                <table class=\"table\">\n                    <tbody>\n                    <tr>\n                        <td>\n                            <label>{{\'airportZone\' | translate}}:</label>\n                        </td>\n                        <td><i class=\"boleeanTypeColor\" ng-click=\"vm.setBooleans(\'AIRPORT_ZONE\')\" ng-class=\"{\'fa fa-toggle-on\': vm.isAirportService , \'fa fa-toggle-off\': !vm.isAirportService}\"></i></td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div> --><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5 text-center\"><button class=\"btn btn-primary\" type=submit style=width:40%>Enviar</button> <button class=\"btn btn-danger\" type=button style=width:40% ng-click=vm.cancelEdit()>Cancelar</button></div></div></form></div>");
$templateCache.put("app/components/views/geofence/addMainBranch.html","<div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'addBranchHead\' | translate}}</p><form name=addBranchForm ng-submit=\"submit=true;addBranchForm.$valid&&vm.addBranchGeofenceHit()\" novalidate autocomplete=off><div class=row style=\"padding:0px 10px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'branchNameLabel\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.name name=branchName placeholder=\"{{\'branchNameLabel\' | translate}}\" required ng-maxlength=60 ng-minlength=3 ng-class=\"{ \'has-error\': addBranchForm.branchName.$touched && addBranchForm.branchName.$invalid }\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\" --><div ng-if=\"addBranchForm.branchName.$touched|| submit\" ng-messages=addBranchForm.branchName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'branchNameReq\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid branch name.</div>--><div class=\"errormessage text-danger\" ng-message=minlength>{{\'lastNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'lastNameMaximum\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'branchDescription\' | translate}}</label><textarea class=form-control ng-model=vm.description placeholder=\"{{\'messagePlaceholder\' | translate}}\" style=\"height: 100px\"></textarea></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Dirección Aeropuerto<!-- <span style=\"color:red\">*</span> --></label><input type=text class=form-control ng-model=vm.addAirportAddress name=addAirportAddress id=addAirportAddressId ng-keypress=vm.disabledEnter($event) ng-change=vm.addAirportAddressChange(vm.addAirportAddress) placeholder=\"Dirección Aeropuerto\" ng-class=\"{ \'has-error\': addBranchForm.addAirportAddress.$touched && addBranchForm.addAirportAddress.$invalid }\"></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"padding: 10px;left: 5px\"><span style=\"font-size: 18px;font-weight: bold\">COMPARTIDOS</span> <span style=color:red>*</span></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Metodo Rango Recogida <span style=color:red>*</span></label><ui-select ng-model=vm.routingName name=branch required close-on-select=true><ui-select-match placeholder=\"Metodo Rango Recogida\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"routing in vm.routing\"><div ng-bind-html=routing.name></div></ui-select-choices></ui-select></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Tiempo de viaje(en minutos) <span style=color:red>*</span></label><input ng-disabled=\"vm.routingName.value == 1\" type=text class=form-control ng-model=vm.sharedServiceTime name=sharedServiceTime placeholder=\"Tiempo de viaje\" ng-required=\"vm.routingName.value != 1\" ng-keypress=vm.restrictSpaceBar($event) maxlength=3 ng-class=\"{ \'has-error\': addBranchForm.sharedServiceTime.$touched && addBranchForm.sharedServiceTime.$invalid }\" is-number=\"\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\" --><div ng-if=\"addBranchForm.sharedServiceTime.$touched|| submit\" ng-messages=addBranchForm.sharedServiceTime.$error><div class=\"errormessage text-danger\" ng-message=required>Please enter time of trip shared service.</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Diferencia mínima entre hora de creación y de hora de retiro(en minutos) <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dropOfTime name=dropOfTime placeholder=\"Diferencia Mínima entre hora de creación y de hora de retiro \" ng-keypress=vm.restrictSpaceBar($event) required maxlength=3 ng-class=\"{ \'has-error\': addBranchForm.dropOfTime.$touched && addBranchForm.dropOfTime.$invalid }\" is-number=\"\"><div ng-if=\"addBranchForm.dropOfTime.$touched|| submit\" ng-messages=addBranchForm.dropOfTime.$error><div class=\"errormessage text-danger\" ng-message=required>Please enter drop of time.</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"padding: 10px;left: 5px\"><span style=\"font-size: 18px;font-weight: bold\">RECOGIDA EXCLUSIVA</span> <span style=color:red>*</span></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Tolerancia Hora Retiro Recogida(en minutos) <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.exclusiveTime name=exclusiveTime placeholder=\"Tolerancia Hora Retiro Recogida\" ng-keypress=vm.restrictSpaceBar($event) required maxlength=3 ng-class=\"{ \'has-error\': addBranchForm.exclusiveTime.$touched && addBranchForm.exclusiveTime.$invalid }\" is-number=\"\"><div ng-if=\"addBranchForm.exclusiveTime.$touched|| submit\" ng-messages=addBranchForm.exclusiveTime.$error><div class=\"errormessage text-danger\" ng-message=required>Please enter Tolerancia Hora Retiro Recogida.</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Tiempo de viaje Servicio Recodiga(en minutos) <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.exclusiveTimeDropTime name=exclusiveTimeDropTime placeholder=\"Tiempo de viaje Servicio Recodiga\" ng-keypress=vm.restrictSpaceBar($event) required maxlength=3 ng-class=\"{ \'has-error\': addBranchForm.exclusiveTimeDropTime.$touched && addBranchForm.exclusiveTimeDropTime.$invalid }\" is-number=\"\"><div ng-if=\"addBranchForm.exclusiveTimeDropTime.$touched|| submit\" ng-messages=addBranchForm.exclusiveTimeDropTime.$error><div class=\"errormessage text-danger\" ng-message=required>Please enter Tiempo de viaje Servicio Recodiga.</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"padding: 10px;left: 5px\"><span style=\"font-size: 18px;font-weight: bold\">RECOGIDA EXCLUSIVA - AGRUPADOS</span> <span style=color:red>*</span></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Rango Hora Retiro Recogida Agrupados (en minutos) <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.exclusiveTimeGroup name=exclusiveTimeGroup placeholder=\"Rango Hora Retiro Recogida Agrupados\" ng-keypress=vm.restrictSpaceBar($event) required maxlength=3 ng-class=\"{ \'has-error\': addBranchForm.exclusiveTimeGroup.$touched && addBranchForm.exclusiveTimeGroup.$invalid }\" is-number=\"\"><div ng-if=\"addBranchForm.exclusiveTimeGroup.$touched|| submit\" ng-messages=addBranchForm.exclusiveTimeGroup.$error><div class=\"errormessage text-danger\" ng-message=required>Please enter Rango Hora Retiro Recogida Agrupados.</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Tiempo de viaje Servicio Recodiga Agrupados (en minutos) <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.exclusiveTimeDropTimeGroup name=exclusiveTimeDropTimeGroup placeholder=\"Tiempo de viaje Servicio Recodiga Agrupados\" ng-keypress=vm.restrictSpaceBar($event) required maxlength=3 ng-class=\"{ \'has-error\': addBranchForm.exclusiveTimeDropTimeGroup.$touched && addBranchForm.exclusiveTimeDropTimeGroup.$invalid }\" is-number=\"\"><div ng-if=\"addBranchForm.exclusiveTimeDropTimeGroup.$touched|| submit\" ng-messages=addBranchForm.exclusiveTimeDropTimeGroup.$error><div class=\"errormessage text-danger\" ng-message=required>Please enter Tiempo de viaje Servicio Recodiga Agrupados.</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"padding: 10px;left: 5px\"><span style=\"font-size: 18px;font-weight: bold\">PUNTO A PUNTO</span> <span style=color:red>*</span></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Tolerancia Hora Retiro PaP(en minutos) <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.PointToPointVariable name=PointToPointVariable placeholder=\"Tolerancia Hora Retiro PaP\" ng-keypress=vm.restrictSpaceBar($event) required maxlength=3 ng-class=\"{ \'has-error\': addBranchForm.PointToPointVariable.$touched && addBranchForm.PointToPointVariable.$invalid }\" is-number=\"\"><div ng-if=\"addBranchForm.PointToPointVariable.$touched|| submit\" ng-messages=addBranchForm.PointToPointVariable.$error><div class=\"errormessage text-danger\" ng-message=required>Please enter Tolerancia Hora Retiro PaP.</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"padding: 10px;left: 5px\"><span style=\"font-size: 18px;font-weight: bold\">PUNTO A PUNTO - AGRUPADOS </span><span style=color:red>*</span></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Rango Hora Retiro PaP Agrupados (en minutos) <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.PointToPointVariableGroup name=PointToPointVariableGroup placeholder=\"Rango Hora Retiro PaP Agrupados\" ng-keypress=vm.restrictSpaceBar($event) required maxlength=3 ng-class=\"{ \'has-error\': addBranchForm.PointToPointVariableGroup.$touched && addBranchForm.PointToPointVariableGroup.$invalid }\" is-number=\"\"><div ng-if=\"addBranchForm.PointToPointVariableGroup.$touched|| submit\" ng-messages=addBranchForm.PointToPointVariableGroup.$error><div class=\"errormessage text-danger\" ng-message=required>Please enter Rango Hora Retiro PaP Agrupados.</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Tiempo de viaje Servicio PaP Agrupados (en minutos) <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.PointToPointVariableRangeGroup name=PointToPointVariableRangeGroup placeholder=\"Tiempo de viaje Servicio PaP Agrupados\" ng-keypress=vm.restrictSpaceBar($event) required maxlength=3 ng-class=\"{ \'has-error\': addBranchForm.PointToPointVariableRangeGroup.$touched && addBranchForm.PointToPointVariableRangeGroup.$invalid }\" is-number=\"\"><div ng-if=\"addBranchForm.PointToPointVariableRangeGroup.$touched|| submit\" ng-messages=addBranchForm.PointToPointVariableRangeGroup.$error><div class=\"errormessage text-danger\" ng-message=required>Please enter Tiempo de viaje Servicio PaP Agrupados.</div></div></div><!-- // TV - 2738 --><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5 text-center\" style=\"padding: 20px\"><button class=\"btn btn-primary\" type=submit style=width:40%>{{\'submit\' | translate}}</button> <button class=\"btn btn-danger\" type=button style=width:40% ng-click=vm.cancelEdit()>{{\'cancelButton\' | translate}}</button></div></div></form></div>");
$templateCache.put("app/components/views/geofence/addMainHeatMap.html","<div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">Agregar nueva Geocerca</p><form name=addFixedRouteForm ng-submit=\"submit=true;addFixedRouteForm.$valid&&vm.addFixedRouteGeofenceHit()\" novalidate autocomplete=off><div class=row style=\"padding:0px 10px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Sucursal<!-- {{\'branchLabel\' | translate}} --> <span style=color:red>*</span></label><ui-select ng-model=vm.branchName name=branch required ng-class=\"{ \'has-error\': addFixedRouteForm.branch.$touched && addFixedRouteForm.branch.$invalid }\" close-on-select=true ng-change=vm.branchChanged()><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\'\"><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select><!--<select class=\"form-control\" ng-model=\"vm.branchName\" name=\"branch\" required ng-class=\"{ \'has-error\': addFixedRouteForm.branch.$touched && addFixedRouteForm.branch.$invalid }\"--><!--ng-options=\"branch.region_id as branch.region_name for branch in vm.branchList\" ng-change=\"vm.branchChanged()\">--><!--<option value=\"\" disabled selected>Select Branch</option>--><!--</select>--><div ng-if=\"addFixedRouteForm.branch.$touched|| submit\" ng-messages=addFixedRouteForm.branch.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'branchR\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Nombre Geocerca<!-- {{\'fixedNameLabel\' | translate}} --> <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.name name=fixedRouteName placeholder=\"{{\'fixedNameLabel\' | translate}}\" required ng-maxlength=60 ng-minlength=3 ng-class=\"{ \'has-error\': addFixedRouteForm.fixedRouteName.$touched && addFixedRouteForm.fixedRouteName.$invalid }\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\"addFixedRouteForm.fixedRouteName.$touched|| submit\" ng-messages=addFixedRouteForm.fixedRouteName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'fixedNameReq\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid fixed route  name.</div>--><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'firstNameMaximum\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Descripción Geocerca<!-- {{\'fixedDescLabel\' | translate}} --></label><textarea class=form-control ng-model=vm.description placeholder=\"{{\'messagePlaceholder\' | translate}}\" style=\"height: 100px\"></textarea></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5 text-center\"><button class=\"btn btn-primary\" type=submit style=width:40%>{{\'submit\' | translate}}</button> <button class=\"btn btn-danger\" type=button style=width:40% ng-click=vm.cancelEdit()>{{\'cancelButton\' | translate}}</button></div></div></form></div>");
$templateCache.put("app/components/views/geofence/addSmallRegions.html","<div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">Agregar nueva Geocerca</p><form name=addFixedRouteForm ng-submit=\"submit=true;addFixedRouteForm.$valid&&vm.addFixedRouteGeofenceHit()\" novalidate autocomplete=off><div class=row style=\"padding:0px 10px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Sucursal<!-- {{\'branchLabel\' | translate}} --> <span style=color:red>*</span></label><ui-select ng-model=vm.branchName name=branch required ng-class=\"{ \'has-error\': addFixedRouteForm.branch.$touched && addFixedRouteForm.branch.$invalid }\" close-on-select=true ng-change=vm.branchChanged()><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\'\"><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select><!--<select class=\"form-control\" ng-model=\"vm.branchName\" name=\"branch\" required ng-class=\"{ \'has-error\': addFixedRouteForm.branch.$touched && addFixedRouteForm.branch.$invalid }\"--><!--ng-options=\"branch.region_id as branch.region_name for branch in vm.branchList\" ng-change=\"vm.branchChanged()\">--><!--<option value=\"\" disabled selected>Select Branch</option>--><!--</select>--><div ng-if=\"addFixedRouteForm.branch.$touched|| submit\" ng-messages=addFixedRouteForm.branch.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'branchR\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label ng-if=!vm.AutoAssignGeo>Nombre Geocerca<!-- {{\'fixedNameLabel\' | translate}} --> <span style=color:red>*</span></label><label class=control-label ng-if=vm.AutoAssignGeo>{{\'name\' | translate}}<!-- {{\'fixedNameLabel\' | translate}} --> <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.name name=fixedRouteName placeholder=\"{{\'fixedNameLabel\' | translate}}\" required ng-maxlength=60 ng-minlength=3 ng-class=\"{ \'has-error\': addFixedRouteForm.fixedRouteName.$touched && addFixedRouteForm.fixedRouteName.$invalid }\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\"addFixedRouteForm.fixedRouteName.$touched|| submit\" ng-messages=addFixedRouteForm.fixedRouteName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'fixedNameReq\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid fixed route  name.</div>--><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'firstNameMaximum\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Descripción Geocerca<!-- {{\'fixedDescLabel\' | translate}} --></label><textarea class=form-control ng-model=vm.description placeholder=\"{{\'messagePlaceholder\' | translate}}\" style=\"height: 100px\"></textarea></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 table-responsive\" ng-if=!vm.AutoAssignGeo><table class=table><tbody><tr><td><label>Es Zona Aeropuerto<!-- {{\'airportZone\' | translate}} --> :</label></td><td><i class=boleeanTypeColor ng-click=\"vm.setBooleans(\'AIRPORT_ZONE\')\" ng-class=\"{\'fa fa-toggle-on\': vm.isAirportService , \'fa fa-toggle-off\': !vm.isAirportService}\"></i></td></tr></tbody></table></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5 text-center\"><button class=\"btn btn-primary\" type=submit style=width:40%>{{\'submit\' | translate}}</button> <button class=\"btn btn-danger\" type=button style=width:40% ng-click=vm.cancelEdit()>{{\'cancelButton\' | translate}}</button></div></div></form></div>");
$templateCache.put("app/components/views/geofence/branchList.html","<h2 class=ng-cloak>{{\'branchListHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=row><div class=\"col-lg-3 col-sm-6 col-md-3 col-xs-12\"><label class=control-label>{{\'BranchStatusLabel\' | translate}}</label><select class=form-control ng-model=vm.filterData.branchStatus ng-change=vm.getAllBranches(vm.filterData.branchStatus)><option value=\"\" disabled>{{\'BranchStatusPlaceHolder\' | translate}}</option><option selected value=1>Active</option><option value=0>Inactive</option><option value=2>All</option></select></div><div class=margin><p class=\"basicRegistrationP backgroundBasicPending text-center col-lg-2 col-sm-6 col-md-2 col-xs-12\" ng-click=vm.onAddBranchClick()>Add Branch</p></div></div><div ng-if=vm.showAddBranchForm class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12 mt5\"><!-- Forms --><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=padding:0px><div ng-if=vm.addBranchGeofenceFlag ng-include=\"\'app/components/views/geofence/addMainBranch.html\'\"></div><div ng-if=vm.editBranchGeofenceFlag ng-include=\"\'app/components/views/geofence/editMainBranch.html\'\"></div><div ng-if=vm.viewBranchGeofenceFlag ng-include=\"\'app/components/views/geofence/viewMainBranch.html\'\"></div></div></div><!--<div class=\"panel panel-default\">--><!--<div class=\"panel-body\">--><!----><!--</div>--><!--</div>--></div><!-- Map view --><div ng-show=vm.showMap class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><input type=text class=form-control ng-model=vm.addressHave id=addressGot ng-change=vm.addressChange(vm.addressHave) placeholder=\"Enter Location\"></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5\"><div id=googleMap style=width:100%></div></div></div></div><!-- List view --><!-- <div class=\"row mt5\"> --><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=padding:0px><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'branchListHead\' | translate}}</p><div class=row style=margin:0px><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive tableWithMasterDataParentDive\"><table class=\"table table-hover tableWithMasterData\"><thead><tr><th style=width:70px hidden>{{\'serialNumber\' | translate}}</th><th style=width:70px>{{\'serialNumber\' | translate}}</th><th style=width:100px>{{\'branchNameLabel\' | translate}}</th><th style=width:150px>Time of Trip Shared Service(in mins)</th><th style=width:150px>Minimal Time to Shared Booking To Airport (minutes)</th><th style=width:100px>{{\'stateTable\' | translate}}</th><th style=width:150px>{{\'action\' | translate}}</th><th style=width:150px>{{\'adminLogs\' | translate}}</th></tr></thead><tbody><tr ng-repeat=\"data in vm.allBranchList | filter: vm.search\"><td style=width:70px hidden>{{data.index+1}}</td><td style=width:70px>{{::data.region_id}}</td><td style=width:100px>{{::data.region_name}}</td><td style=width:150px>{{::data.time_trip_shared_service}}</td><td style=width:150px>{{::data.minimal_time_to_shared_booking_to_airport}}</td><td style=width:100px><a class=\"cursor btn btn-sm\" ng-class=\"{\'blockIconColor\': data.is_active == 0, \'unblockIconColor\': data.is_active == 1}\" ng-click=vm.changeRegionStatus(data,$event)><!--ng-click=\"vm.changeRegionStatus(data,$event)\"--> <i ng-class=\"{\'fa fa-unlock\': data.is_active == 1,\'fa fa-lock\': data.is_active == 0}\"></i></a></td><td style=width:150px><a title=\"Edit Branch\" class=\"cursor editIconColor btn btn-sm\" ng-click=\"vm.showAddBranchForm = true; vm.showMap = true; vm.mapInitialize(data); vm.editBranchGeofence(data)\"><i class=\"fa fa-edit\"></i> </a><a title=\"View Branch\" class=\"cursor editIconColor btn btn-sm\" ng-click=\"vm.showAddBranchForm = true; vm.showMap = true; vm.mapInitialize(data); vm.viewBranchGeofence(data)\"><i class=\"fa fa-eye\"></i> </a><a title=\"Delete Branch\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteBranchGeofence(data,$event)><i class=\"fa fa-trash\"></i> </a><!--<a class=\"btn btn-primary tableButton mt5\" ng-click=\"vm.editBranchGeofence(data)\" title=\"Edit Branch\">Edit</a>--></td><td style=width:150px><a class=\"btn btn-primary tableButton\" title=\"{{\'adminLogs\' | translate}}\" ui-sref=\"layout.branchMain.adminLogs({userId:\'{{data.region_id}}\',type:\'20\',fakeType: \'13\'})\">{{\'adminLogs\' | translate}}</a></td></tr></tbody><tfoot ng-if=vm.noDataFlag><tr><th class=\"noDataClass text-center\">{{\'noBranchFound\' | translate}}</th></tr></tfoot></table></div></div></div></div><!-- </div> --></div></div></div></div>");
$templateCache.put("app/components/views/geofence/branchMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/geofence/editFixedRoute.html","<div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'editFixedRoute\' | translate}}</p><form name=editFixedRouteForm ng-submit=\"submit=true;editFixedRouteForm.$valid&&vm.editFixedRouteHit()\" novalidate autocomplete=off><div class=row style=\"padding:0px 10px;margin-bottom:5px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'fixedNameLabel\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.name name=fixedRouteName placeholder=\"{{\'fixedNameLabel\' | translate}}\" required ng-maxlength=60 ng-minlength=3 ng-class=\"{ \'has-error\': editFixedRouteForm.fixedRouteName.$touched && editFixedRouteForm.fixedRouteName.$invalid }\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\"editFixedRouteForm.fixedRouteName.$touched|| submit\" ng-messages=editFixedRouteForm.fixedRouteName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'fixedNameReq\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid fixed route  name.</div>--><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'firstNameMaximum\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'branchLabel\' | translate}} <span style=color:red>*</span></label><ui-select ng-model=vm.dataToFill.branch name=branch required ng-class=\"{ \'has-error\': editFixedRouteForm.branch.$touched && editFixedRouteForm.branch.$invalid }\" close-on-select=true ng-change=vm.branchChanged()><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\'\"><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select><!--<select class=\"form-control\" ng-model=\"vm.dataToFill.branch\" name=\"branch\" required ng-class=\"{ \'has-error\': editFixedRouteForm.branch.$touched && editFixedRouteForm.branch.$invalid }\"--><!--ng-options=\"branch.region_id as branch.region_name for branch in vm.branchList\" ng-change=\"vm.branchChanged()\">--><!--<option value=\"\" disabled selected>Select Branch</option>--><!--</select>--><div ng-if=\"editFixedRouteForm.branch.$touched|| submit\" ng-messages=editFixedRouteForm.branch.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'branchR\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'origin\' | translate}} <span style=color:red>*</span></label><ui-select ng-model=vm.dataToFill.pickup name=locationFirst required ng-class=\"{ \'has-error\': editFixedRouteForm.locationFirst.$touched && editFixedRouteForm.locationFirst.$invalid }\" close-on-select=true ng-change=\"vm.locationChanged(\'1\')\" ng-disabled=vm.locationListDisbaled><ui-select-match placeholder=\"{{\'originSelect\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"locationF.region_id as locationF in vm.locationList | filter: $select.search | orderBy:\'region_name\'\"><div ng-bind-html=locationF.region_name></div></ui-select-choices></ui-select><!--<select class=\"form-control\" ng-model=\"vm.dataToFill.pickup\" name=\"locationFirst\" required ng-class=\"{ \'has-error\': editFixedRouteForm.locationFirst.$touched && editFixedRouteForm.locationFirst.$invalid }\"--><!--ng-options=\"locationF.region_id as locationF.region_name for locationF in vm.locationList\" ng-change=\"vm.locationChanged(\'1\')\" ng-disabled=\"vm.locationListDisbaled\">--><!--<option value=\"\" disabled selected>Select Location First</option>--><!--</select>--><div ng-if=\"editFixedRouteForm.locationFirst.$touched|| submit\" ng-messages=editFixedRouteForm.locationFirst.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'originReq\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Destination Branch <span style=color:red>*</span></label><!--<input type=\"text\" ng-model=\"vm.dataToFill.branchDetails\" placeholder=\"Enter Branch\" uib-typeahead=\"branch as branch.region_name for branch in vm.branchList | filter:{region_name:$viewValue}\" typeahead-loading=\"loadingBranches\"--><!--typeahead-no-results=\"noResults\" class=\"form-control\" name=\"branch\" typeahead-on-select=\"vm.branchChanged()\" required ng-class=\"{ \'has-error\': addFixedRouteForm.branch.$touched && addFixedRouteForm.branch.$invalid }\">--><!--<i ng-show=\"loadingBranches\" class=\"glyphicon glyphicon-refresh\"></i>--><!--<div ng-show=\"noResults\" class=\"mt5\">--><!--<i class=\"glyphicon glyphicon-remove\"></i> No Results Found--><!--</div>--><ui-select ng-model=vm.dataToFill.destinationBranch name=destinationBranch required ng-class=\"{ \'has-error\': addFixedRouteForm.destinationBranch.$touched && addFixedRouteForm.destinationBranch.$invalid }\" close-on-select=true ng-change=vm.destinationBranchChanged()><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \"><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select><div ng-if=\"addFixedRouteForm.branch.$touched|| submit\" ng-messages=addFixedRouteForm.branch.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'branchR\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'destination\' | translate}} <span style=color:red>*</span></label><ui-select ng-model=vm.dataToFill.dropoff name=locationSecond required ng-class=\"{ \'has-error\': editFixedRouteForm.locationSecond.$touched && editFixedRouteForm.locationSecond.$invalid }\" close-on-select=true ng-change=\"vm.locationChanged(\'2\')\" ng-disabled=vm.locationListDisbaled><ui-select-match placeholder=\"{{\'destinationSelect\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"locationS.region_id as locationS in vm.locationList1 | filter: $select.search | orderBy:\'region_name\'\"><div ng-bind-html=locationS.region_name></div></ui-select-choices></ui-select><!--<select class=\"form-control\" ng-model=\"vm.dataToFill.dropoff\" name=\"locationSecond\" required ng-class=\"{ \'has-error\': editFixedRouteForm.locationSecond.$touched && editFixedRouteForm.locationSecond.$invalid }\"--><!--ng-options=\"locationS.region_id as locationS.region_name for locationS in vm.locationList\" ng-change=\"vm.locationChanged(\'2\')\" ng-disabled=\"vm.locationListDisbaled\">--><!--<option value=\"\" disabled selected>Select Location Second</option>--><!--</select>--><div ng-if=\"editFixedRouteForm.locationSecond.$touched|| submit\" ng-messages=editFixedRouteForm.locationSecond.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'destinationReq\' | translate}}</div></div></div><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">Status<span style=\"color:red\">*</span></label>--><!--<select class=\"form-control\" ng-model=\"vm.dataToFill.status\" name=\"status\" required ng-class=\"{ \'has-error\': editFixedRouteForm.status.$touched && editFixedRouteForm.status.$invalid }\">--><!--<option value=\"\" disabled selected>Select Status</option>--><!--<option value=\"0\" >Inactive</option>--><!--<option value=\"1\" >Active</option>--><!--</select>--><!--<div ng-if=\"editFixedRouteForm.status.$touched|| submit\" ng-messages=\"editFixedRouteForm.status.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Please select status.</div>--><!--</div>--><!--</div>--><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'fixedDescLabel\' | translate}}</label><textarea class=form-control ng-model=vm.dataToFill.description placeholder=\"{{\'messagePlaceholder\' | translate}}\" style=\"height: 100px\"></textarea></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5 text-center\"><button class=\"btn btn-primary\" type=submit style=width:40%>{{\'submit\' | translate}}</button> <button class=\"btn btn-danger\" type=button style=width:40% ng-click=vm.cancelEdit()>{{\'cancelButton\' | translate}}</button></div></div></form></div>");
$templateCache.put("app/components/views/geofence/editIlluminatedSmallRegion.html","<div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">Editar zona iluminada</p><form name=editFixedRouteForm ng-submit=\"submit=true;editFixedRouteForm.$valid && vm.editIlluminatedZoneHit()\" novalidate autocomplete=off><div class=row style=\"padding:0px 10px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Nombre de la zona iluminada <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.editName name=fixedRouteNameE placeholder=\"Nombre de la zona iluminada\" required ng-maxlength=60 ng-minlength=3 ng-class=\"{ \'has-error\': editFixedRouteForm.fixedRouteNameE.$touched && editFixedRouteForm.fixedRouteNameE.$invalid }\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\"editFixedRouteForm.fixedRouteNameE.$touched|| submit\" ng-messages=editFixedRouteForm.fixedRouteNameE.$error><div class=\"errormessage text-danger\" ng-message=required>Favor ingrese Nombre Tramo</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid fixed route name.</div>--><div class=\"errormessage text-danger\" ng-message=minlength>Se requieren al menos 3 caracteres</div><div class=\"errormessage text-danger\" ng-message=maxlength>A lo más pueden ser 60 caracteres</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Controlar cantidad de vehículos en App <span style=color:red>*</span></label><select class=form-control ng-model=vm.control_cantity_driver_app ng-class=\"{ \'has-error\':  editFixedRouteForm.controlCantityDriverApp.$touched &&  editFixedRouteForm.controlCantityDriverApp.$invalid }\" name=controlCantityDriverApp required><option value=\"\" disabled selected>Controlar cantidad de vehículos en App</option><option value=1>Yes</option><option value=0>No</option></select><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\" editFixedRouteForm.controlCantityDriverApp.$touched|| submit\" ng-messages=\" editFixedRouteForm.controlCantityDriverApp.$error\"><div class=\"errormessage text-danger\" ng-message=required>Por favor ingrese el Controlar cantidad de vehículos en App</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Maximum number of vehicles <span style=color:red>*</span></label><input type=number ng-disabled=\"vm.control_cantity_driver_app == 0\" class=form-control ng-model=vm.maximum_quantity_show_driverapp name=maximumQuantityShowDriverapp placeholder=\"Nombre de la zona iluminada\" required ng-class=\"{ \'has-error\':  editFixedRouteForm.maximumQuantityShowDriverapp.$touched &&  editFixedRouteForm.maximumQuantityShowDriverapp.$invalid }\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\" editFixedRouteForm.maximumQuantityShowDriverapp.$touched|| submit\" ng-messages=\" editFixedRouteForm.maximumQuantityShowDriverapp.$error\"><div class=\"errormessage text-danger\" ng-message=required>Por favor ingrese el Maximum number of vehicles</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Descripción de la zona iluminada</label><textarea class=form-control ng-model=vm.editDescription placeholder=\"Ingresar texto\" style=\"height: 100px\"></textarea></div><!-- <div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 table-responsive\">\n                <table class=\"table\">\n                    <tbody>\n                        <tr>\n                            <td>\n                                <label>{{\'airportZone\' | translate}}:</label>\n                            </td>\n                            <td>\n                                <i class=\"boleeanTypeColor\" ng-click=\"vm.setBooleans(\'AIRPORT_ZONE\')\" ng-class=\"{\'fa fa-toggle-on\': vm.isAirportService , \'fa fa-toggle-off\': !vm.isAirportService}\"></i>\n                            </td>\n                        </tr>\n                    </tbody>\n                </table>\n            </div> --><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5 text-center\"><button class=\"btn btn-primary\" type=submit style=width:40%>Enviar</button> <button class=\"btn btn-danger\" type=button style=width:40% ng-click=vm.cancelEdit()>Cancelar</button></div></div></form></div>");
$templateCache.put("app/components/views/geofence/editMainBranch.html","<div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'editBranchHead\' | translate}}</p><form name=editBranchForm ng-submit=\"submit=true;editBranchForm.$valid&&vm.editBranchGeofenceHit()\" novalidate autocomplete=off><div class=row style=\"padding:0px 10px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'branchNameLabel\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.editName name=branchName placeholder=\"{{\'branchNameLabel\' | translate}}\" required ng-maxlength=60 ng-minlength=3 ng-class=\"{ \'has-error\': editBranchForm.branchName.$touched && editBranchForm.branchName.$invalid }\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\"editBranchForm.branchName.$touched|| submit\" ng-messages=editBranchForm.branchName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'branchNameReq\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid branch name.</div>--><div class=\"errormessage text-danger\" ng-message=minlength>{{\'lastNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'lastNameMaximum\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'branchDescription\' | translate}}</label><textarea class=form-control ng-model=vm.editDescription placeholder=\"{{\'messagePlaceholder\' | translate}}\" style=\"height: 100px\"></textarea></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Dirección Aeropuerto<!-- <span style=\"color:red\">*</span> --></label><input type=text class=form-control ng-model=vm.editAirportAddress name=editAirportAddress id=editAirportAddressId ng-keypress=vm.disabledEnter($event) ng-change=vm.editAirportAddressChange(vm.editAirportAddress) placeholder=\"Dirección Aeropuerto\" ng-class=\"{ \'has-error\': operationEditForm.editAirportAddress.$touched && operationEditForm.editAirportAddress.$invalid }\"></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"padding: 10px;left: 5px\"><span style=\"font-size: 18px;font-weight: bold\">COMPARTIDOS</span> <span style=color:red>*</span></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Metodo Rango Recogida <span style=color:red>*</span></label><ui-select ng-model=vm.routingName name=branch required close-on-select=true><ui-select-match placeholder=\"Metodo Rango Recogida\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"routing in vm.routing\"><div ng-bind-html=routing.name></div></ui-select-choices></ui-select></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Tiempo de viaje(en minutos) <span style=color:red>*</span></label><input ng-disabled=\"vm.routingName.value == 1\" type=text class=form-control ng-model=vm.editSharedServiceTime name=sharedServiceTime ng-keypress=vm.restrictSpaceBar($event) placeholder=\"Time of Trip Shared Service\" required maxlength=3 ng-class=\"{ \'has-error\': editBranchForm.sharedServiceTime.$touched && editBranchForm.sharedServiceTime.$invalid }\" is-number=\"\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\" --><div ng-if=\"editBranchForm.sharedServiceTime.$touched|| submit\" ng-messages=editBranchForm.sharedServiceTime.$error><div class=\"errormessage text-danger\" ng-message=required>Please enter time of trip shared service.</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Diferencia mínima entre hora de creación y de hora de retiro(en minutos) <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.editdropOfTime name=dropOfTime placeholder=\"Minimal Time to Shared Booking To Airport\" ng-keypress=vm.restrictSpaceBar($event) required maxlength=3 ng-class=\"{ \'has-error\': editBranchForm.dropOfTime.$touched && editBranchForm.dropOfTime.$invalid }\" is-number=\"\"><div ng-if=\"editBranchForm.dropOfTime.$touched|| submit\" ng-messages=editBranchForm.dropOfTime.$error><div class=\"errormessage text-danger\" ng-message=required>Please enter Drop of time.</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"padding: 10px;left: 5px\"><span style=\"font-size: 18px;font-weight: bold\">RECOGIDA EXCLUSIVA</span> <span style=color:red>*</span></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Tolerancia Hora Retiro Recogida(en minutos) <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.exclusiveTime name=exclusiveTime placeholder=\"Tolerancia Hora Retiro Recogida\" ng-keypress=vm.restrictSpaceBar($event) required maxlength=3 ng-class=\"{ \'has-error\': editBranchForm.exclusiveTime.$touched && editBranchForm.exclusiveTime.$invalid }\" is-number=\"\"><div ng-if=\"editBranchForm.exclusiveTime.$touched|| submit\" ng-messages=editBranchForm.exclusiveTime.$error><div class=\"errormessage text-danger\" ng-message=required>Please enter Tolerancia Hora Retiro Recogida.</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Tiempo de viaje Servicio Recodiga(en minutos) <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.exclusiveTimeDropTime name=exclusiveTimeDropTime placeholder=\"Tiempo de viaje Servicio Recodiga\" ng-keypress=vm.restrictSpaceBar($event) required maxlength=3 ng-class=\"{ \'has-error\': editBranchForm.exclusiveTimeDropTime.$touched && editBranchForm.exclusiveTimeDropTime.$invalid }\" is-number=\"\"><div ng-if=\"editBranchForm.exclusiveTimeDropTime.$touched|| submit\" ng-messages=editBranchForm.exclusiveTimeDropTime.$error><div class=\"errormessage text-danger\" ng-message=required>Please enter Tiempo de viaje Servicio Recodiga.</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"padding: 10px;left: 5px\"><span style=\"font-size: 18px;font-weight: bold\">RECOGIDA EXCLUSIVA - AGRUPADOS</span> <span style=color:red>*</span></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Rango Hora Retiro Recogida Agrupados (en minutos) <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.exclusiveTimeGroup name=exclusiveTimeGroup placeholder=\"Rango Hora Retiro Recogida Agrupados\" ng-keypress=vm.restrictSpaceBar($event) required maxlength=3 ng-class=\"{ \'has-error\': editBranchForm.exclusiveTimeGroup.$touched && editBranchForm.exclusiveTimeGroup.$invalid }\" is-number=\"\"><div ng-if=\"editBranchForm.exclusiveTimeGroup.$touched|| submit\" ng-messages=editBranchForm.exclusiveTimeGroup.$error><div class=\"errormessage text-danger\" ng-message=required>Please enter Rango Hora Retiro Recogida Agrupados.</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Tiempo de viaje Servicio Recodiga Agrupados (en minutos) <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.exclusiveTimeDropTimeGroup name=exclusiveTimeDropTimeGroup placeholder=\"Tiempo de viaje Servicio Recodiga Agrupados\" ng-keypress=vm.restrictSpaceBar($event) required maxlength=3 ng-class=\"{ \'has-error\': editBranchForm.exclusiveTimeDropTimeGroup.$touched && editBranchForm.exclusiveTimeDropTimeGroup.$invalid }\" is-number=\"\"><div ng-if=\"editBranchForm.exclusiveTimeDropTimeGroup.$touched|| submit\" ng-messages=editBranchForm.exclusiveTimeDropTimeGroup.$error><div class=\"errormessage text-danger\" ng-message=required>Please enter Tiempo de viaje Servicio Recodiga Agrupados.</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"padding: 10px;left: 5px\"><span style=\"font-size: 18px;font-weight: bold\">PUNTO A PUNTO</span> <span style=color:red>*</span></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Tolerancia Hora Retiro PaP(en minutos) <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.PointToPointVariable name=PointToPointVariable placeholder=\"Tolerancia Hora Retiro PaP\" ng-keypress=vm.restrictSpaceBar($event) required maxlength=3 ng-class=\"{ \'has-error\': editBranchForm.PointToPointVariable.$touched && editBranchForm.PointToPointVariable.$invalid }\" is-number=\"\"><div ng-if=\"editBranchForm.PointToPointVariable.$touched|| submit\" ng-messages=editBranchForm.PointToPointVariable.$error><div class=\"errormessage text-danger\" ng-message=required>Please enter Tolerancia Hora Retiro PaP.</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"padding: 10px;left: 5px\"><span style=\"font-size: 18px;font-weight: bold\">PUNTO A PUNTO - AGRUPADOS </span><span style=color:red>*</span></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Rango Hora Retiro PaP Agrupados (en minutos) <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.PointToPointVariableGroup name=PointToPointVariableGroup placeholder=\"Rango Hora Retiro PaP Agrupados\" ng-keypress=vm.restrictSpaceBar($event) required maxlength=3 ng-class=\"{ \'has-error\': editBranchForm.PointToPointVariableGroup.$touched && editBranchForm.PointToPointVariableGroup.$invalid }\" is-number=\"\"><div ng-if=\"editBranchForm.PointToPointVariableGroup.$touched|| submit\" ng-messages=editBranchForm.PointToPointVariableGroup.$error><div class=\"errormessage text-danger\" ng-message=required>Please enter Rango Hora Retiro PaP Agrupados.</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Tiempo de viaje Servicio PaP Agrupados (en minutos) <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.PointToPointVariableRangeGroup name=PointToPointVariableRangeGroup ng-keypress=vm.restrictSpaceBar($event) placeholder=\"Tiempo de viaje Servicio PaP Agrupados\" required maxlength=3 ng-class=\"{ \'has-error\': editBranchForm.PointToPointVariableRangeGroup.$touched && editBranchForm.PointToPointVariableRangeGroup.$invalid }\" is-number=\"\"><div ng-if=\"editBranchForm.PointToPointVariableRangeGroup.$touched|| submit\" ng-messages=editBranchForm.PointToPointVariableRangeGroup.$error><div class=\"errormessage text-danger\" ng-message=required>Please enter Tiempo de viaje Servicio PaP Agrupados.</div></div></div><!-- TV-2738 --><!-- TV-2738 --><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5 text-center\" style=\"padding: 20px\"><button class=\"btn btn-primary\" type=submit style=width:40%>{{\'submit\' | translate}}</button> <button class=\"btn btn-danger\" type=button style=width:40% ng-click=vm.cancelEdit()>{{\'cancelButton\' | translate}}</button></div></div></form></div>");
$templateCache.put("app/components/views/geofence/editMainHeatMap.html","<div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'editFixedHead\' | translate}}</p><form name=editFixedRouteForm ng-submit=\"submit=true;editFixedRouteForm.$valid&&vm.editFixedRouteGeofenceHit()\" novalidate autocomplete=off><div class=row style=\"padding:0px 10px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Sucursal <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.branchNameEdit name=fixedRouteNameE placeholder=\"{{\'fixedNameLabel\' | translate}}\" disabled ng-maxlength=60 ng-minlength=3 ng-class=\"{ \'has-error\': editFixedRouteForm.fixedRouteNameE.$touched && editFixedRouteForm.fixedRouteNameE.$invalid }\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Nombre <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.editName name=fixedRouteNameE placeholder=\"{{\'fixedNameLabel\' | translate}}\" required ng-maxlength=60 ng-minlength=3 ng-class=\"{ \'has-error\': editFixedRouteForm.fixedRouteNameE.$touched && editFixedRouteForm.fixedRouteNameE.$invalid }\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\"editFixedRouteForm.fixedRouteNameE.$touched|| submit\" ng-messages=editFixedRouteForm.fixedRouteNameE.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'fixedNameReq\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid fixed route name.</div>--><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'firstNameMaximum\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'fixedDescLabel\' | translate}}</label><textarea class=form-control ng-model=vm.editDescription placeholder=\"{{\'messagePlaceholder\' | translate}}\" style=\"height: 100px\"></textarea></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5 text-center\"><button class=\"btn btn-primary\" type=submit style=width:40%>{{\'submit\' | translate}}</button> <button class=\"btn btn-danger\" type=button style=width:40% ng-click=vm.cancelEdit()>{{\'cancelButton\' | translate}}</button></div></div></form></div>");
$templateCache.put("app/components/views/geofence/editSmallRegions.html","<div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'editFixedHead\' | translate}}</p><form name=editFixedRouteForm ng-submit=\"submit=true;editFixedRouteForm.$valid&&vm.editFixedRouteGeofenceHit()\" novalidate autocomplete=off><div class=row style=\"padding:0px 10px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label ng-if=!vm.AutoAssignGeo>{{\'fixedNameLabel\' | translate}}<span style=color:red>*</span></label><label class=control-label ng-if=vm.AutoAssignGeo>{{\'name\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.editName name=fixedRouteNameE placeholder=\"{{\'fixedNameLabel\' | translate}}\" required ng-maxlength=60 ng-minlength=3 ng-class=\"{ \'has-error\': editFixedRouteForm.fixedRouteNameE.$touched && editFixedRouteForm.fixedRouteNameE.$invalid }\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\"editFixedRouteForm.fixedRouteNameE.$touched|| submit\" ng-messages=editFixedRouteForm.fixedRouteNameE.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'fixedNameReq\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid fixed route name.</div>--><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'firstNameMaximum\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'fixedDescLabel\' | translate}}</label><textarea class=form-control ng-model=vm.editDescription placeholder=\"{{\'messagePlaceholder\' | translate}}\" style=\"height: 100px\"></textarea></div><div ng-if=!vm.AutoAssignGeo class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 table-responsive\"><table class=table><tbody><tr><td><label>{{\'airportZone\' | translate}}:</label></td><td><i class=boleeanTypeColor ng-click=\"vm.setBooleans(\'AIRPORT_ZONE\')\" ng-class=\"{\'fa fa-toggle-on\': vm.isAirportService , \'fa fa-toggle-off\': !vm.isAirportService}\"></i></td></tr></tbody></table></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5 text-center\"><button class=\"btn btn-primary\" type=submit style=width:40%>{{\'submit\' | translate}}</button> <button class=\"btn btn-danger\" type=button style=width:40% ng-click=vm.cancelEdit()>{{\'cancelButton\' | translate}}</button></div></div></form></div>");
$templateCache.put("app/components/views/geofence/fixedRouteGeofenceList.html","<h2 class=ng-cloak><!-- {{\'fixedGeoHead\' | translate}} --> Administración de Geocercas</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row ng-class=\"{\'display-none\': !vm.addNewGeoFenceToggle}\" id=showMap><!-- <div class=\"row\">\n                    <div class=\"col-lg-3 col-sm-6 col-md-3 col-xs-12\">\n                        <label class=\"control-label\">{{\'geoFilterLabel\' | translate}}</label>\n                        <select class=\"form-control\" ng-model=\"vm.filterData.geofenceStatus\" ng-change=\"vm.getAllBranches(vm.filterData.geofenceStatus)\">\n                            <option value=\"\" disabled selected>{{\'geoFilterPLaceholder\' | translate}}</option>\n                            <option value=\"1\">Active</option>\n                            <option value=\"0\">Inactive</option>\n                            <option value=\"2\">All</option>\n                        </select>\n                    </div>\n                </div> --><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12 mt5\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=padding:0px><div ng-if=vm.addFixedRouteGeofenceFlag ng-include=\"\'app/components/views/geofence/addSmallRegions.html\'\"></div><div ng-if=vm.editFixedRouteGeofenceFlag ng-include=\"\'app/components/views/geofence/editSmallRegions.html\'\"></div><div ng-if=vm.viewFixedRouteGeofenceFlag ng-include=\"\'app/components/views/geofence/viewSmallRegions.html\'\"></div></div></div></div><div class=\"col-lg-8 col-sm-8 col-md-8 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"margin: 9px 0px\"><input type=checkbox name=checkboxLabelToShowAllGeoFence ng-model=vm.checkboxToShowAllGeoFence id=checkboxToShowAllGeoFence ng-click=vm.checkboxToShowAllGeoFenceFunction(vm.checkboxToShowAllGeoFence) style=\"font-size: 16px\"> <span for=checkboxLabelToShowAllGeoFence>Ver otras geocercas en mapa</span> <button class=\"btn btn-primary\" ng-click=vm.openMultipleGeofencePopup($event) ng-disabled=vm.openMultipleGeofencePopupButtonDisable>Seleccionar Geocercas…</button> <button class=\"btn btn-primary pull-right\" ng-click=vm.removeGeoFenceFromMap() ng-disabled=\"vm.removeGeoFenceFromMapDisableButtonStatus || vm.viewFixedRouteGeofenceFlag\">Eliminar Poligono</button></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><input type=text class=form-control ng-model=vm.addressHave ng-change=vm.addressChange(vm.addressHave) id=addressGot placeholder=\"Enter Location\"></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5\"><div id=googleMap style=width:100%></div></div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=padding:0px><div class=basicDiv><p class=\"basicRegistrationP text-center\" style=\"color: black\"><!-- backgroundBasicPending --><!-- {{\'fixedGeoList\' | translate}} --> Total Geocercas : {{vm.mainBranchListForPopupCount || 0}} <button class=\"btn btn-primary pull-right\" style=\"margin-right: 7%\" ng-class=\"{\'display-none\': vm.addNewGeoFenceToggle}\" ng-click=vm.addNewGeoFence()>+Nueva Geocerca</button></p><div class=row style=margin:0px><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-if=vm.hideFilters><div class=\"col-lg-2 col-sm-6 col-md-2 col-xs-12\"><label class=control-label>{{\'geoFilterLabel\' | translate}}</label><select class=form-control ng-model=vm.filterData.geofenceStatus ng-change=\"vm.getAllBranches(vm.filterData.geofenceStatus, 0, vm.search, \'changeState\')\"><option value=\"\" disabled selected>{{\'geoFilterPLaceholder\' | translate}}</option><option value=1>Active</option><option value=0>Inactive</option><option value=2>All</option></select></div><div class=\"col-lg-3 col-sm-6 col-md-3 col-xs-12 input-group pt3\" style=\"padding-top: 23px !important\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.mainSearch(vm.search);></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive tableWithMasterDataParentDive\"><table class=\"table table-hover tableWithMasterData\"><thead><tr><th style=width:70px hidden>{{\'serialNumber\' | translate}}</th><th style=width:70px>{{\'serialNumber\' | translate}}</th><th style=width:100px>{{\'branchNameLabel\' | translate}}</th><th style=width:100px>{{\'routeName\' | translate}}</th><th style=width:100px>{{\'airportZone\' | translate}}</th><th style=width:100px>{{\'stateTable\' | translate}}</th><th style=width:150px>{{\'action\' | translate}}</th><th style=width:150px>{{\'adminLogs\' | translate}}</th></tr></thead><tbody when-scrolled=vm.mainPaginationChangedForMultipleGeofence()><!-- | filter: vm.search --><tr ng-repeat=\"data in vm.tableFixedRouteList\"><td style=width:70px hidden>{{data.index+1}}</td><td style=width:70px>{{::data.region_id}}</td><td style=width:100px>{{data.branch_name || data.parent.region_name}}</td><td style=width:100px>{{::data.region_name}}</td><td style=width:100px><span ng-if=data.isAirportService>Yes</span> <span ng-if=!data.isAirportService>No</span></td><td style=width:100px><a class=\"cursor btn btn-sm\" ng-class=\"{\'blockIconColor\': data.is_active == 0, \'unblockIconColor\': data.is_active == 1}\" ng-click=vm.changeFixedRegionStatus(data,$event);vm.addNewGeoFence()><!--ng-click=\"vm.changeFixedRegionStatus(data,$event)\"--> <i ng-class=\"{\'fa fa-unlock\': data.is_active == 1,\'fa fa-lock\': data.is_active == 0}\"></i></a></td><td style=width:150px><a title=\"Edit Fixed route\" class=\"cursor editIconColor btn btn-sm\" ng-click=vm.editFixedRouteGeofence(data);vm.addNewGeoFence()><i class=\"fa fa-edit\"></i> </a><a title=\"View Fixed route\" class=\"cursor editIconColor btn btn-sm\" ng-click=vm.viewFixedRouteGeofence(data);vm.addNewGeoFence()><i class=\"fa fa-eye\"></i> </a><a title=\"Delete Branch\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteFixedRouteGeofence(data,$event);vm.addNewGeoFence()><i class=\"fa fa-trash\"></i> </a><!--<a class=\"btn btn-primary tableButton mt5\" ng-click=\"vm.editFixedRouteGeofence(data)\" title=\"Edit Fixed route\">Edit</a>--></td><td style=width:150px><a class=\"btn btn-primary tableButton\" title=\"{{\'adminLogs\' | translate}}\" ui-sref=\"layout.fixedRouteGeofenceMain.adminLogs({userId:\'{{data.region_id}}\',type:\'20\',fakeType: \'14\'})\">{{\'adminLogs\' | translate}}</a></td></tr></tbody><tfoot ng-if=vm.noDataFlag><tr><th class=\"noDataClass text-center\">{{\'noFixedGeoFound\' | translate}}</th></tr></tfoot></table></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/geofence/fixedRouteGeofenceMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/geofence/fixedRouteList.html","<h2 class=ng-cloak><span>{{\'fixedGeoList\' | translate}}</span> <span class=pull-right><button class=\"btn btn-primary tableButton\" ng-click=vm.refreshData()>Volver a cargar</button></span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading ||   vm.loadingNew }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row ng-if=!vm.addFixedRouteFlag><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><p class=totalSize><span class=pull-right><a class=\"btn btn-primary mb10\" ng-click=vm.createNewRoute()>+ {{\'fixedRouteHead\' | translate}}</a></span></p></div></div><div class=row><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=padding:0px><div ng-if=vm.addFixedRouteFlag ng-include=\"\'app/components/views/geofence/addFixedRoute.html\'\"></div><div ng-if=vm.editFixedRouteFlag ng-include=\"\'app/components/views/geofence/editFixedRoute.html\'\"></div></div></div></div><div class=\"col-lg-8 col-sm-8 col-md-8 col-xs-12\"><div class=row ng-show=\"vm.addFixedRouteFlag || vm.editFixedRouteFlag\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><input type=text class=form-control ng-model=vm.addressHave id=addressGot placeholder=\"Enter Location\"></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5\"><div id=googleMap style=width:100%></div></div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 paddingZero\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-lg-4 col-sm-6 col-md-4 col-xs-12\"><label class=control-label>{{\'fixedStatusLabel\' | translate}}</label><select class=form-control ng-model=vm.filterData.fixedRouteStatus ng-change=\"vm.getAllFixedRoutes(0,vm.itemsPerPageGot,vm.filterData);vm.currentPage = 0;\"><option value=\"\" disabled>{{\'fixedStatusPaceholder\' | translate}}</option><option selected value=1>Active</option><option value=0>Inactive</option><option value=2>All</option></select></div><div class=\"col-lg-4 col-sm-6 col-md-4 col-xs-12\"><label class=control-label>{{\'branchLabel\' | translate}}</label><ui-select ng-model=vm.filterData.branchId name=branch close-on-select=true ng-change=\"vm.getAllFixedRoutes(0,vm.itemsPerPageGot,vm.filterData);vm.currentPage = 0;\"><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchListFilter | filter: $select.search | orderBy:\'region_name\' \"><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5 text-center\"><p class=totalSize><span>{{\'totalRoutes\' | translate}}: {{vm.totalFixedRoutes}}</span></p></div><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model-options=\"{ debounce: 500 }\" ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\"><!--ng-switch=\"(vm.carsList | filter:vm.search).length\"--><!--<div ng-switch-when=\"0\" class=\"noSearch\"><span>{{\'nothingFound\' | translate}}</span></div>--><table class=\"table table-hover tableWithMasterData\"><!--ng-switch-default--><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'name\' | translate}}\" text=\"\'name\'\" check=vm.reverse>{{\'name\' | translate}}</th><th style=\"width: 150px\" table-column-sorting current-text=vm.predicate title=\"{{\'description\' | translate}}\" text=\"\'description\'\" check=vm.reverse>{{\'description\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'origin\' | translate}}\" text=\"\'location1\'\" check=vm.reverse>{{\'origin\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'destination\' | translate}}\" text=\"\'location2\'\" check=vm.reverse>{{\'destination\' | translate}}</th><th style=width:100px><div>{{\'stateTable\' | translate}}</div></th><th style=\"width: 150px\"><div>{{\'action\' | translate}}</div></th><th style=\"width: 150px\"><div>{{\'adminLogs\' | translate}}</div></th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.fixedRouteListGot | orderBy:vm.predicate:vm.reverse\"><!--| filter:vm.search--><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:70px>{{::data.id}}</td><td style=width:125px>{{::data.name}}</td><td style=width:150px>{{::data.description}}</td><!--<td>{{::data.location1.region_name}}</td>--><!--<td>{{::data.location2.region_name}}</td>--><td style=width:125px>{{::data.origin}}</td><td style=width:125px>{{::data.destination}}</td><td style=\"text-align: center;width:100px\"><a class=\"cursor btn btn-sm\" ng-class=\"{\'blockIconColor\': data.status == 0, \'unblockIconColor\': data.status == 1}\" ng-click=vm.changeStatus($event,data.id,data.status)><i ng-class=\"{\'fa fa-unlock\': data.status == 1,\'fa fa-lock\': data.status == 0}\"></i></a></td><td style=width:150px><a title=\"Edit Details\" class=\"cursor editIconColor btn btn-sm\" ng-click=vm.editFixedRoute(data,$event)><i class=\"fa fa-edit\"></i> </a><a title=\"View Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.fixedRouteMain.viewFixedRoute({id:\'{{data.id}}\'})\"><i class=\"fa fa-eye\"></i> </a><a title=\"Delete Route\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteRoute(data,$event)><i class=\"fa fa-trash\"></i></a></td><td style=width:150px><a class=\"btn btn-primary tableButton\" title=\"{{\'adminLogs\' | translate}}\" ui-sref=\"layout.fixedRouteMain.adminLogs({userId:\'{{data.id}}\',type:\'10\',fakeType: \'15\'})\">{{\'adminLogs\' | translate}}</a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noFixedGeoFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav>--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\"--><!--ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/geofence/fixedRouteMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/geofence/heatMap.html","<h2 class=ng-cloak><!-- {{\'fixedGeoHead\' | translate}} --> Administración de Mapa de Calor</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row ng-class=\"{\'display-none\': !vm.addNewGeoFenceToggle}\" id=showMap><!-- <div class=\"row\">\n                    <div class=\"col-lg-3 col-sm-6 col-md-3 col-xs-12\">\n                        <label class=\"control-label\">{{\'geoFilterLabel\' | translate}}</label>\n                        <select class=\"form-control\" ng-model=\"vm.filterData.geofenceStatus\" ng-change=\"vm.getAllBranches(vm.filterData.geofenceStatus)\">\n                            <option value=\"\" disabled selected>{{\'geoFilterPLaceholder\' | translate}}</option>\n                            <option value=\"1\">Active</option>\n                            <option value=\"0\">Inactive</option>\n                            <option value=\"2\">All</option>\n                        </select>\n                    </div>\n                </div> --><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12 mt5\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=padding:0px><div ng-if=vm.addFixedRouteGeofenceFlag ng-include=\"\'app/components/views/geofence/addMainHeatMap.html\'\"></div><div ng-if=vm.editFixedRouteGeofenceFlag ng-include=\"\'app/components/views/geofence/editMainHeatMap.html\'\"></div><div ng-if=vm.viewFixedRouteGeofenceFlag ng-include=\"\'app/components/views/geofence/viewMainHeatMap.html\'\"></div></div></div></div><div class=\"col-lg-8 col-sm-8 col-md-8 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"margin: 9px 0px\"><input type=checkbox name=checkboxLabelToShowAllGeoFence ng-model=vm.checkboxToShowAllGeoFence id=checkboxToShowAllGeoFence ng-click=vm.checkboxToShowAllGeoFenceFunction(vm.checkboxToShowAllGeoFence) style=\"font-size: 16px\"> <span for=checkboxLabelToShowAllGeoFence>Ver otras geocercas en mapa</span> <button class=\"btn btn-primary\" ng-click=vm.openMultipleGeofencePopup($event) ng-disabled=vm.openMultipleGeofencePopupButtonDisable>Seleccionar Geocercas…</button> <button class=\"btn btn-primary pull-right\" ng-click=vm.removeGeoFenceFromMap() ng-disabled=\"vm.removeGeoFenceFromMapDisableButtonStatus || vm.viewFixedRouteGeofenceFlag\">Eliminar Poligono</button></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><input type=text class=form-control ng-model=vm.addressHave ng-change=vm.addressChange(vm.addressHave) id=addressGot placeholder=\"Enter Location\"></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5\"><div id=googleMap style=width:100%></div></div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=padding:0px><div class=basicDiv><p class=\"basicRegistrationP text-center\" style=\"color: black\"><!-- backgroundBasicPending --><!-- {{\'fixedGeoList\' | translate}} --> Total Geocercas : {{vm.mainBranchListForPopupCount || 0}} <button class=\"btn btn-primary pull-right\" style=\"margin-right: 7%\" ng-class=\"{\'display-none\': vm.addNewGeoFenceToggle}\" ng-click=vm.addNewGeoFence()>+Nueva Geocerca</button></p><div class=row style=margin:0px><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-if=vm.hideFilters><div class=\"col-lg-2 col-sm-6 col-md-2 col-xs-12\"><label class=control-label>{{\'geoFilterLabel\' | translate}}</label><select class=form-control ng-model=vm.filterData.geofenceStatus ng-change=\"vm.getAllBranches(vm.filterData.geofenceStatus, 0, vm.search, \'changeState\')\"><option value=\"\" disabled>{{\'geoFilterPLaceholder\' | translate}}</option><option selected value=1>Active</option><option value=0>Inactive</option><option value=2>Todas</option></select></div><div class=\"col-lg-3 col-sm-6 col-md-3 col-xs-12 input-group pt3\" style=\"padding-top: 23px !important\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.mainSearch(vm.search);></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive tableWithMasterDataParentDive\"><table class=\"table table-hover tableWithMasterData\"><thead><tr><th style=width:70px hidden>{{\'serialNumber\' | translate}}</th><th style=width:70px>{{\'serialNumber\' | translate}}</th><!-- <th style=\"width:100px;\">{{\'branchNameLabel\' | translate}}</th> --><th style=width:100px>{{\'routeNameNew\' | translate}}</th><th style=width:100px>Nombre Sucursal</th><!-- <th style=\"width:100px;\">{{\'airportZone\' | translate}}</th> --><th style=width:100px>{{\'stateTable\' | translate}}</th><th style=width:150px>{{\'action\' | translate}}</th><th style=width:150px>{{\'adminLogs\' | translate}}</th></tr></thead><tbody when-scrolled=vm.mainPaginationChangedForMultipleGeofence()><!-- | filter: vm.search --><tr ng-repeat=\"data in vm.tableFixedRouteList\"><td style=width:70px hidden>{{data.index+1}}</td><td style=width:70px>{{::data.region_id}}</td><!-- <td style=\"width:100px;\">{{data.branch_name || data.parent.region_name}}</td> --><td style=width:100px>{{::data.region_name}}</td><td style=width:100px>{{::data.parent_region_name}}</td><!-- <td style=\"width:100px;\">\n                                                <span ng-if=\"data.isAirportService\">Yes</span>\n                                                <span ng-if=\"!data.isAirportService\">No</span>\n                                            </td> --><td style=width:100px><a class=\"cursor btn btn-sm\" ng-class=\"{\'blockIconColor\': data.is_active == 0, \'unblockIconColor\': data.is_active == 1}\" ng-click=vm.changeFixedRegionStatus(data,$event)><!--ng-click=\"vm.changeFixedRegionStatus(data,$event)\"--> <i ng-class=\"{\'fa fa-unlock\': data.is_active == 1,\'fa fa-lock\': data.is_active == 0}\"></i></a></td><td style=width:150px><a title=\"Edit Fixed route\" class=\"cursor editIconColor btn btn-sm\" ng-click=vm.editFixedRouteGeofence(data);vm.addNewGeoFence()><i class=\"fa fa-edit\"></i> </a><a title=\"View Fixed route\" class=\"cursor editIconColor btn btn-sm\" ng-click=vm.viewFixedRouteGeofence(data);vm.addNewGeoFence()><i class=\"fa fa-eye\"></i> </a><a title=\"Delete Branch\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteFixedRouteGeofence(data,$event);><i class=\"fa fa-trash\"></i> </a><!--<a class=\"btn btn-primary tableButton mt5\" ng-click=\"vm.editFixedRouteGeofence(data)\" title=\"Edit Fixed route\">Edit</a>--></td><td style=width:150px><a class=\"btn btn-primary tableButton\" title=\"{{\'adminLogs\' | translate}}\" ui-sref=\"layout.heatMapMain.adminLogs({userId:\'{{data.region_id}}\',type:\'28\',fakeType: \'30\'})\">{{\'adminLogs\' | translate}}</a></td></tr></tbody><tfoot ng-if=vm.noDataFlag><tr><th class=\"noDataClass text-center\">{{\'noFixedGeoFound\' | translate}}</th></tr></tfoot></table></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/geofence/heatMapMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/geofence/illuminatedZone.html","<h2 class=ng-cloak>Lista de zonas iluminadas</h2><div class=margin><p class=\"basicRegistrationP backgroundBasicPending text-center col-lg-3 col-sm-6 col-md-3 col-xs-12\" ng-click=vm.onAddClick()>Añadir zona iluminada</p></div><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><!-- <div class=\"row\">\n                    <div class=\"col-lg-3 col-sm-6 col-md-3 col-xs-12\">\n                        <label class=\"control-label\">{{\'geoFilterLabel\' | translate}}</label>\n                        <select class=\"form-control\" ng-model=\"vm.filterData.geofenceStatus\" ng-change=\"vm.getAllBranches(vm.filterData.geofenceStatus)\">\n                            <option value=\"\" disabled selected>{{\'geoFilterPLaceholder\' | translate}}</option>\n                            <option value=\"1\">Active</option>\n                            <option value=\"0\">Inactive</option>\n                            <option value=\"2\">All</option>\n                        </select>\n                    </div>\n                </div> --><div class=\"col-lg-5 col-sm-5 col-md-5 col-xs-12 mt5\"><!-- Forms --><div ng-if=vm.showAddBranchForm class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=padding:0px><div ng-if=vm.addIlluminatedZoneFlag ng-include=\"\'app/components/views/geofence/addIlluminatedSmallRegions.html\'\"></div><div ng-if=vm.editIlluminatedZoneFlag ng-include=\"\'app/components/views/geofence/editIlluminatedSmallRegion.html\'\"></div><div ng-if=vm.viewIlluminatedZoneFlag ng-include=\"\'app/components/views/geofence/viewIlluminatedRegion.html\'\"></div></div></div></div><!-- Map view --><div ng-show=vm.showMap class=\"col-lg-7 col-sm-7 col-md-7 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><input type=text class=form-control ng-model=vm.addressHave ng-change=vm.addressChange(vm.addressHave) id=addressGot placeholder=\"Entrar en la ubicación\"></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5\"><div id=googleMap style=width:100%></div></div></div></div><!-- List view --><!-- <div class=\"row mt5\"> --><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=padding:0px><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">Lista de zonas iluminadas</p><div class=row style=margin:0px><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=Buscar ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-4 col-md-4 col-lg-4 col-xs-12 col-lg-offset-4 col-xs-offset-0 col-md-offset-4 col-sm-offset-4 mt5\"><!--<label class=\"control-label\">Resultados por página</label>--><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive tableWithMasterDataParentDive\" ng-switch=\"(vm.tableFixedRouteList | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'region_id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"\'Nombre de la rama\'\" text=\"\'parent.region_name\'\" check=vm.reverse>Nombre de la Sucursal</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"\'Nombre de ruta\'\" text=\"\'region_name\'\" check=vm.reverse>Nombre de zona</th><th style=width:100px>Estado</th><th style=width:150px>Acción</th></tr></thead><tbody><tr ng-repeat=\"data in vm.tableFixedRouteList | filter: vm.search | orderBy:vm.predicate:vm.reverse\"><td style=width:70px hidden>{{data.index+1}}</td><td style=width:70px>{{::data.region_id}}</td><td style=width:100px>{{::data.parent.region_name}}</td><td style=width:100px>{{::data.region_name}}</td><td style=width:100px><a class=\"cursor btn btn-sm\" ng-class=\"{\'blockIconColor\': data.is_active == 0, \'unblockIconColor\': data.is_active == 1}\" ng-click=vm.changeFixedRegionStatus(data,$event)><!--ng-click=\"vm.changeFixedRegionStatus(data,$event)\"--> <i ng-class=\"{\'fa fa-unlock\': data.is_active == 1,\'fa fa-lock\': data.is_active == 0}\"></i></a></td><td style=width:150px><a title=\"Edit Fixed route\" class=\"cursor editIconColor btn btn-sm\" ng-click=\" vm.showAddBranchForm = true; vm.showMap = true; vm.mapInitialize(data); vm.editIlluminatedZoneGeofence(data)\"><i class=\"fa fa-edit\"></i> </a><a title=\"View Fixed route\" class=\"cursor editIconColor btn btn-sm\" ng-click=\"vm.showAddBranchForm = true; vm.showMap = true; vm.mapInitialize(data); vm.viewIlluminatedRegion(data)\"><i class=\"fa fa-eye\"></i> </a><a title=\"Delete Branch\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteIlluminatedZone(data,$event)><i class=\"fa fa-trash\"></i></a></td></tr></tbody><tfoot ng-if=vm.noDataFlag><tr><th class=\"noDataClass text-center\">{{\'noFixedGeoFound\' | translate}}</th></tr></tfoot></table></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-xs-12 text-left pt2\"><span ng-hide=vm.filterOn>Mostrando {{vm.skipValue + 1}} Para {{vm.limitValue + 1}} de {{vm.dataLength}} Entradas</span> <span ng-if=vm.filterOn>Mostrando {{vm.skipValueFilter}} de {{vm.dataLength}} Entradas</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-xs-12\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--<nav>--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\" ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div><!-- </div> --></div></div></div></div>");
$templateCache.put("app/components/views/geofence/illuminatedZoneMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/geofence/viewFixedRouteDetails.html","<h2 class=ng-cloak>{{\'fixedGeoList\' | translate}} / {{\'fixedRouteDetails\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=driver><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-5 col-xs-12 col-sm-5 col-md-5\"><div class=basicDiv><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'allDetails\' | translate}}</p><div class=basicDetailsDiv><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'fixedNameLabel\' | translate}}:</label><div class=\"form-control text-capitalize\">{{::vm.fixedRouteDetails.name}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'origin\' | translate}}:</label><!--<div class=\"form-control text-capitalize\">{{::vm.fixedRouteDetails.location1.region_name}}</div>--><div class=\"form-control text-capitalize\">{{::vm.fixedRouteDetails.origin}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'destination\' | translate}}:</label><!--<div class=\"form-control text-capitalize\">{{::vm.fixedRouteDetails.location2.region_name}}</div>--><div class=\"form-control text-capitalize\">{{::vm.fixedRouteDetails.destination}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'fixedRouteId\' | translate}}:</label><div class=\"form-control text-capitalize\">{{::vm.fixedRouteDetails.id}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'fixedDescLabel\' | translate}}:</label><textarea class=form-control ng-model=vm.fixedRouteDetails.description readonly placeholder=\"No Description\"></textarea></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'fixedStatusLabel\' | translate}}:</label><div class=\"form-control text-capitalize\"><span ng-if=\"vm.fixedRouteDetails.status == 1\">Active</span> <span ng-if=\"vm.fixedRouteDetails.status == 0\">Not Active</span></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'fixedRouteDelete\' | translate}}:</label><div class=\"form-control text-capitalize\"><span ng-if=\"vm.fixedRouteDetails.is_deleted == 1\">Yes</span> <span ng-if=\"vm.fixedRouteDetails.is_deleted == 0\">No</span></div></div></div></div></div></div><div class=\"col-lg-7 col-sm-7 col-md-7 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5\"><div id=googleMap style=width:100%></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/geofence/viewIlluminatedRegion.html","<div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">Ver detalles de geocerca</p><div class=row style=\"padding:0px 10px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Nombre Sucursal:</label><div class=\"form-control text-capitalize\">{{::vm.viewFixedRouteParentName}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Número Sucursal:</label><div class=\"form-control text-capitalize\">{{::vm.viewFixedRouteParentID}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Nombre de la zona iluminada:</label><div class=\"form-control text-capitalize\">{{::vm.viewFixedRouteName}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Controlar cantidad de vehículos en App:</label><!-- <div class=\"form-control text-capitalize\">{{::vm.controlCantityDriverApp}} --><div class=\"form-control text-capitalize\"><span ng-if=\"vm.controlCantityDriverApp == 1\">Yes</span> <span ng-if=\"vm.controlCantityDriverApp == 0\">No</span></div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Maximum number of vehicles:</label><div class=\"form-control text-capitalize\">{{::vm.maximumQuantityShowDriverapp}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>ID de zona iluminada:</label><div class=\"form-control text-capitalize\">{{::vm.viewFixedRouteID}}</div></div><!-- <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">\n            <label class=\"control-label\">{{\'airportZone\' | translate}}:</label>\n            <div class=\"form-control text-capitalize\">\n                <span ng-if=\"vm.viewAirportZone\">Yes</span>\n                <span ng-if=\"!vm.viewAirportZone\">No</span>\n            </div>\n        </div> --><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Estado de zona iluminada:</label><div class=\"form-control text-capitalize\"><span ng-if=\"vm.viewFixedRouteStatus == 1\">Active</span> <span ng-if=\"vm.viewFixedRouteStatus == 0\">Inactive</span></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Descripción de la zona iluminada:</label><textarea class=form-control ng-model=vm.viewFixedRouteDescription placeholder=\"No Description\" readonly></textarea></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5 text-center\"><button class=\"btn btn-primary\" type=button ng-click=\"vm.goBack(); vm.cancelEdit(); \" style=width:40%>Regresa</button></div></div>");
$templateCache.put("app/components/views/geofence/viewMainBranch.html","<div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'branchDetailsHead\' | translate}}</p><div class=row style=\"padding:0px 10px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'branchNameLabel\' | translate}}:</label><span style=color:red>*</span><div class=\"form-control text-capitalize\">{{vm.viewBranchName}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'branchDescription\' | translate}}:</label><textarea class=form-control ng-model=vm.viewBranchDescription placeholder=\"No Description\" readonly></textarea></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Dirección Aeropuerto:</label><!-- <span style=\"color:red\">*</span> --><div class=\"form-control text-capitalize\" style=\"height: auto;min-height: 34px\">{{vm.viewAirportZone}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"padding: 10px;left: 5px\"><span style=\"font-size: 18px;font-weight: bold\">COMPARTIDOS</span> <span style=color:red>*</span></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Tiempo de viaje(en minutos):</label><span style=color:red>*</span><div class=\"form-control text-capitalize\">{{vm.viewSharedServiceTime}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Diferencia mínima entre hora de creación y de hora de retiro(en minutos):</label><span style=color:red>*</span><div class=\"form-control text-capitalize\">{{vm.minimal_time_to_shared_booking_to_airport}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Metodo Rango Recogida <span style=color:red>*</span></label><div class=\"form-control text-capitalize\">{{vm.MethodRoutingName}}</div><!-- <ui-select ng-model=\"vm.routingName\" name=\"branch\" required close-on-select=\"true\">\n                <ui-select-match  placeholder=\"{{\'branchPlaceholder\' | translate}}\">\n                    {{$select.selected.name}}\n                </ui-select-match>\n                <ui-select-choices repeat=\"routing in vm.routing\">\n                    <div ng-bind-html=\"routing.name\"></div>\n                </ui-select-choices>\n            </ui-select> --></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"padding: 10px;left: 5px\"><span style=\"font-size: 18px;font-weight: bold\">RECOGIDA EXCLUSIVA</span> <span style=color:red>*</span></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Tolerancia Hora Retiro Recogida(en minutos):</label><span style=color:red>*</span><div class=\"form-control text-capitalize\">{{vm.exclusiveTime}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Tiempo de viaje Servicio Recodiga(en minutos)</label><span style=color:red>*</span><div class=\"form-control text-capitalize\">{{vm.exclusiveTimeDropTime}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"padding: 10px;left: 5px\"><span style=\"font-size: 18px;font-weight: bold\">RECOGIDA EXCLUSIVA - AGRUPADOS</span> <span style=color:red>*</span></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Rango Hora Retiro Recogida Agrupados (en minutos):</label><span style=color:red>*</span><div class=\"form-control text-capitalize\">{{vm.exclusiveTimeGroup}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Tiempo de viaje Servicio Recodiga Agrupados (en minutos)</label><span style=color:red>*</span><div class=\"form-control text-capitalize\">{{vm.exclusiveTimeDropTimeGroup}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"padding: 10px;left: 5px\"><span style=\"font-size: 18px;font-weight: bold\">PUNTO A PUNTO</span> <span style=color:red>*</span></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Tolerancia Hora Retiro PaP(en minutos):</label><span style=color:red>*</span><div class=\"form-control text-capitalize\">{{vm.PointToPointVariable}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"padding: 10px;left: 5px\"><span style=\"font-size: 18px;font-weight: bold\">PUNTO A PUNTO - AGRUPADOS</span> <span style=color:red>*</span></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Rango Hora Retiro PaP Agrupados (en minutos):</label><span style=color:red>*</span><div class=\"form-control text-capitalize\">{{vm.PointToPointVariableGroup}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Tiempo de viaje Servicio PaP Agrupados (en minutos):</label><span style=color:red>*</span><div class=\"form-control text-capitalize\">{{vm.PointToPointVariableRangeGroup}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"padding: 10px;left: 5px\"><label class=control-label>{{\'branchId\' | translate}}:</label><span style=color:red>*</span><div class=\"form-control text-capitalize\">{{vm.viewBranchID}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'BranchStatusLabel\' | translate}}:</label><div class=\"form-control text-capitalize\"><span ng-if=\"vm.viewBranchStatus == 1\">Active</span> <span ng-if=\"vm.viewBranchStatus == 0\">Inactive</span></div></div><!-- TV-2738 --><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5 text-center\"><button class=\"btn btn-primary\" type=button ng-click=vm.goBack();vm.cancelEdit(); style=width:40%>{{\'goBack\' | translate}}</button></div></div></div>");
$templateCache.put("app/components/views/geofence/viewMainHeatMap.html","<div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'geoDetails\' | translate}}</p><div class=row style=\"padding:0px 10px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Sucursal:</label><div class=\"form-control text-capitalize\">{{vm.viewFixedRouteParentID}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Nombre:</label><div class=\"form-control text-capitalize\">{{vm.viewFixedRouteParentName}}</div></div><!-- <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">\n            <label class=\"control-label\">{{\'fixedGeoName\' | translate}}:</label>\n            <div class=\"form-control text-capitalize\">{{vm.viewFixedRouteName}}\n            </div>\n        </div> --><!-- <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">\n            <label class=\"control-label\">{{\'fixedGeoID\' | translate}}:</label>\n            <div class=\"form-control text-capitalize\">{{vm.viewFixedRouteID}}\n            </div>\n        </div> --><!-- <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">\n            <label class=\"control-label\">{{\'airportZone\' | translate}}:</label>\n            <div class=\"form-control text-capitalize\">\n                <span ng-if=\"vm.viewAirportZone\">Yes</span>\n                <span ng-if=\"!vm.viewAirportZone\">No</span>\n            </div>\n        </div> --><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'fixedGeoStatus\' | translate}}:</label><div class=\"form-control text-capitalize\"><span ng-if=\"vm.viewFixedRouteStatus == 1\">Active</span> <span ng-if=\"vm.viewFixedRouteStatus == 0\">Inactive</span></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'fixedGeoDes\' | translate}}:</label><textarea class=form-control ng-model=vm.viewFixedRouteDescription placeholder=\"No Description\" readonly></textarea></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5 text-center\"><button class=\"btn btn-primary\" type=button ng-click=vm.goBack() style=width:40%>{{\'goBack\' | translate}}</button></div></div></div>");
$templateCache.put("app/components/views/geofence/viewSmallRegions.html","<div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'geoDetails\' | translate}}</p><div class=row style=\"padding:0px 10px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'branchNameLabel\' | translate}}:</label><div class=\"form-control text-capitalize\">{{vm.viewFixedRouteParentName}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'branchId\' | translate}}:</label><div class=\"form-control text-capitalize\">{{vm.viewFixedRouteParentID}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'fixedGeoName\' | translate}}:</label><div class=\"form-control text-capitalize\">{{vm.viewFixedRouteName}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'fixedGeoID\' | translate}}:</label><div class=\"form-control text-capitalize\">{{vm.viewFixedRouteID}}</div></div><div ng-if=!vm.AutoAssignGeo class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'airportZone\' | translate}}:</label><div class=\"form-control text-capitalize\"><span ng-if=vm.viewAirportZone>Yes</span> <span ng-if=!vm.viewAirportZone>No</span></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'fixedGeoStatus\' | translate}}:</label><div class=\"form-control text-capitalize\"><span ng-if=\"vm.viewFixedRouteStatus == 1\">Active</span> <span ng-if=\"vm.viewFixedRouteStatus == 0\">Inactive</span></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'fixedGeoDes\' | translate}}:</label><textarea class=form-control ng-model=vm.viewFixedRouteDescription placeholder=\"No Description\" readonly></textarea></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5 text-center\"><button class=\"btn btn-primary\" type=button ng-click=vm.goBack() style=width:40%>{{\'goBack\' | translate}}</button></div></div></div>");
$templateCache.put("app/components/views/global-parameters/globalParameters.html","<h2 class=ng-cloak>{{\'globalParameters\' | translate}}</h2><div class=\"container-fluid ng-cloak\"><div class=\"panel panel-default\"><table class=\"table table-bordered\" id=globalTable><thead><tr><td width=40%>{{\'name\' | translate}}</td><td width=40%>{{\'value\' | translate}}</td><td width=20%>{{\'action\' | translate}}</td></tr></thead><tbody><tr ng-repeat=\"data in vm.parametersData\"><td><!-- <span ng-if=\"data.reason == \'in position in meters\'\">{{\'inPosition\' | translate}}</span>\n                        <span ng-if=\"data.reason == \'in position in minutes\'\">{{\'inTime\' | translate}}</span>\n                        <span ng-if=\"data.reason == \'km bracket for driver\' || data.reason == \'km_bracket_for_driver\'\">KM Bracket For Driver</span>\n                        <span ng-if=\"data.reason == \'minute bracket for driver\' || data.reason == \'minute_bracket_for_driver\'\">Minute Bracket For Driver</span>\n                        <span ng-if=\"data.reason == \'second bracket for driver\' || data.reason == \'second_bracket_for_driver\'\">Seconds Bracket For Driver</span>\n                        <span ng-if=\"data.reason == \'group booking common point distance in meters\'\">Group Common Point Distance in meters</span>\n                        <span ng-if=\"data.reason == \'search driver for booking assignment time greater than time \'\">Search driver for booking assignment time greater than time</span>\n                        <span ng-if=\"data.reason == \'Number of Vehicles to which the Booking is offered in unison\'\">Number of Vehicles to which the Booking is offered in unison</span>\n                        <span ng-if=\"data.reason == \'Vehicle Search Time for auto Assignment Improvements\'\">Vehicle Search Time for auto Assignment Improvements</span>\n                        <span ng-if=\"data.reason == \'Time in minutes that defines how much time in the future the reservation will be scheduled auto Assignment Improvements\'\">Time in minutes that defines how much time in the future the reservation will be scheduled auto Assignment Improvements</span>\n                        <span ng-if=\"data.reason == \'Number of Vehicles to which the Booking is offered in unison\'\">Number of Vehicles to which the Booking is offered in unison</span> --> <span>{{data.reason}}</span></td><td><span ng-if=\"data.showValue && data.is_text != 6\" style=\"max-width: 220px;    word-break: break-all\">{{data.ratio}}</span> <span ng-if=\"data.showValue && data.is_text == 6\">{{ data.optionSelected }}</span><form class=form-inline ng-if=!data.showValue><select ng-if=\"data.is_text == 6\" class=form-control ng-model=data.value><option value=\"{{ o.id }}\" ng-repeat=\"o in data.options\">{{ o.name }}</option></select><input ng-if=\"!data.showValue && !data.showValue1 && data.type != \'RATE_NOT_FOUND\' &&  data.type != \'ALERT_EMAIL\'\" class=form-control type=text ng-model=data.value is-number=\"\"> <input ng-if=\"data.showValue1 && data.type != \'RATE_NOT_FOUND\' && data.type != \'ALERT_EMAIL\' && data.is_text != 6\" class=form-control type=text ng-model=data.value> <input ng-if=\"data.type == \'RATE_NOT_FOUND\' && data.type != \'ALERT_EMAIL\'\" class=form-control type=text maxlength=150 ng-model=data.value><textarea ng-if=\"data.type == \'ALERT_EMAIL\'\" class=form-control type=text maxlength=150 ng-model=data.value></textarea><button class=\"btn btn-sm btn-primary tableButton\" ng-click=vm.addGlobalParamsFun(data,data.ratio_id)>{{\'save\' | translate}}</button></form></td><td><button ng-if=data.showValue class=\"btn btn-sm btn-primary tableButton\" ng-click=vm.changeValues($index)>{{\'edit\' | translate}}</button> <button ng-if=!data.showValue class=\"btn btn-sm btn-primary tableButton\" ng-click=vm.changeValues($index)>{{\'cancelButton\' | translate}}</button></td></tr></tbody></table></div></div>");
$templateCache.put("app/components/views/global-parameters/globalParamtersMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/global-parameters/sharedParameters.html","<h2 class=ng-cloak>{{\'sharedParameters\' | translate}}</h2><div class=\"container-fluid ng-cloak\"><div class=\"panel panel-default\"><table class=\"table table-bordered\" id=globalTable><thead><tr><td width=40%>{{\'name\' | translate}}</td><td width=40%>{{\'value\' | translate}}</td><td width=20%>{{\'action\' | translate}}</td></tr></thead><tbody><tr ng-repeat=\"data in vm.parametersData\"><td><span>{{data.display_name}}</span></td><td><span ng-if=\"data.showValue \" style=\"max-width: 220px;word-break: break-all\">{{data.value}}</span><form class=form-inline ng-if=!data.showValue><input ng-if=\"!data.showValue && !data.showValue1 && data.type != \'RATE_NOT_FOUND\' &&  data.type != \'ALERT_EMAIL\'\" class=form-control type=text ng-model=data.value is-number=\"\"> <input ng-if=\"data.showValue1 && data.type != \'RATE_NOT_FOUND\' && data.type != \'ALERT_EMAIL\'\" class=form-control type=text ng-model=data.value> <input ng-if=\"data.type == \'RATE_NOT_FOUND\' && data.type != \'ALERT_EMAIL\'\" class=form-control type=text maxlength=150 ng-model=data.value><textarea ng-if=\"data.type == \'ALERT_EMAIL\'\" class=form-control type=text maxlength=150 ng-model=data.value></textarea><button class=\"btn btn-sm btn-primary tableButton\" ng-click=vm.addGlobalParamsFun(data,data.id)>{{\'save\' | translate}}</button></form></td><td><button ng-if=data.showValue class=\"btn btn-sm btn-primary tableButton\" ng-click=vm.changeValues($index)>{{\'edit\' | translate}}</button> <button ng-if=!data.showValue class=\"btn btn-sm btn-primary tableButton\" ng-click=vm.changeValues($index)>{{\'cancelButton\' | translate}}</button></td></tr></tbody></table></div></div>");
$templateCache.put("app/components/views/grouped-route-assignment/groupedRouteAssignment.html","<h2 class=ng-cloak>Routing and Assignment Grouped Trips</h2><div class=\"ng-cloak container-fluid\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><!-- FILTER FOR BOOKING --><div class=\"row m0\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"border:1px solid #dedede;padding:0px\" ng-init=\"checkClicked = true\"><h2 class=\"text-center filtersStyle\" ng-click=\"checkClicked = !checkClicked; vm.slideData()\">Booking Filters <span class=fa ng-class=\"{\'fa-caret-down\': checkClicked,\'fa-caret-up\': !checkClicked }\"></span></h2><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" id=derp><form name=filterGroupedForm ng-submit=\"submit=true;filterGroupedForm.$valid&&vm.applyFilter(\'blank\')\" novalidate autocomplete=off><div class=row style=\"padding-top: 10px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'branchLabel\' | translate}} <span style=color:red>*</span></label><div><ui-select ng-model=vm.filterData.branch_value name=branch ng-change=vm.branchChanged(0) required close-on-select=true ng-class=\"{ \'has-error\': filterGroupedForm.branch.$touched && filterGroupedForm.branch.$invalid }\" data-testid=booking_filter_branch><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \"><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select><div ng-if=\"filterGroupedForm.branch.$touched|| submit\" ng-messages=filterGroupedForm.branch.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'branchR\' | translate}}</div></div></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'agreementLabel\' | translate}} <span style=color:red>*</span></label><div><ui-select ng-model=vm.filterData.aggrement_value name=agreement ng-change=vm.agreementChanged(0) required close-on-select=true data-testid=booking_filter_agreement><ui-select-match placeholder=\"{{\'agreementPlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"agreements.id as agreements in vm.agreement | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=agreements.name></div></ui-select-choices></ui-select><div ng-if=\"filterGroupedForm.agreement.$touched|| submit\" ng-messages=filterGroupedForm.agreement.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'selectAgreementReq\' | translate}}</div></div></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'serviceLabel\' | translate}} <span style=color:red>*</span></label><div><ui-select ng-model=vm.filterData.service_value name=service required close-on-select=true ng-change=vm.serviceChanged(0) data-testid=booking_filter_service><ui-select-match placeholder=\"{{\'selectTService\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"services.id as services in vm.service | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=services.name></div></ui-select-choices></ui-select><div ng-if=\"filterGroupedForm.service.$touched|| submit\" ng-messages=filterGroupedForm.service.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'serviceReq\' | translate}}</div></div></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'tripType\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=vm.filterData.typeOfTrip required name=typeOfTrip ng-class=\"{ \'has-error\': filterGroupedForm.typeOfTrip.$touched && filterGroupedForm.typeOfTrip.$invalid }\" ng-change=vm.typeOfTrip(0) ng-options=\"data.id as data.text for data in vm.typeTripFilter\" data-testid=booking_filter_trip><option value=\"\" selected disabled>{{\'selectTripType\' | translate}}</option></select><div ng-if=\"filterGroupedForm.typeOfTrip.$touched|| submit\" ng-messages=filterGroupedForm.typeOfTrip.$error><div class=\"errormessage text-danger\" ng-message=required>Please select type of trip.</div></div></div></div><div class=row style=\"padding-top: 10px;padding-bottom: 10px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpDateFromLabel\' | translate}}:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=pickupDate ng-model=vm.filterData.filter_pickup_from_date_value placeholder=\"{{\'pickUpDateLabel\' | translate}}\" is-open=vm.datePicker_1.pickupFromDate data-testid=booking_filter_fecha_inicio_reco datepicker-options=vm.dateOptions close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.pickupFromToDateChanged(1)> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_1(1)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpTimeFromLabel\' | translate}}:</label><div uib-timepicker ng-model=vm.filterData.filter_pickup_from_time_value show-spinners=false class=completed ng-change=vm.pickupFromToTimeChanged(1);vm.changeTime(0) hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian data-testid=booking_filter_hora_inicio_reco></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpDateToLabel\' | translate}}:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=pickupDate ng-model=vm.filterData.filter_pickup_to_date_value placeholder=\"{{\'pickUpDateLabel\' | translate}}\" is-open=vm.datePicker_1.pickupToDate data-testid=booking_filter_fecha_fin_reco datepicker-options=vm.dateOptionsT close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.pickupFromToDateChanged(2)> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_1(2)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpTimeToLabel\' | translate}}:</label><div uib-timepicker ng-model=vm.filterData.filter_pickup_to_time_value show-spinners=false class=completed ng-change=vm.pickupFromToTimeChanged(2);vm.changeDropTime(0) hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian data-testid=booking_filter_hora_fin_reco></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center mt5\"><button class=\"btn btn-primary\" type=submit style=\"height: 35px;line-height: 20px\" data-testid=booking_filter_apply>Apply Filter</button> <button class=\"btn btn-danger\" type=button style=\"height: 35px;line-height: 20px\" ng-click=vm.resetFilter(0) data-testid=booking_filter_clean>{{\'resetFilterButton\' | translate}}</button></div></div></form></div></div></div><!-- <div class=\"row mt10\" ng-if=\"vm.filterData.filterApplied\">\n                        <div class=\"col-lg-6 col-xs-12 col-sm-6 col-md-6\">\n                            <div id=\"groupedMap\" style=\"height: 450px;\"></div>\n                            <div class=\"packageCreated mt10\">\n                                <div class=\"servicesCreated\">\n                                    <p>Services Created ({{vm.filterData.createdBookingCount}})</p>\n                                </div>\n                                <div class=\"table-responsive\" id=\"packageMade\">\n                                    <table class=\"table\" id=\"packageMadeTable\" style=\"margin-bottom: 0px;\">\n                                        <thead>\n                                            <tr>\n                                                <th style=\"width: 70px;\">\n                                                    {{\'serialNumber\' | translate}}\n                                                </th>\n                                                <th style=\"width: 70px;\" table-column-sorting current-text=\"vm.filterData.createdPredicate\" title=\"ID\" text=\"\'shared_service_id\'\"\n                                                    check=\"vm.filterData.createdReverse\">\n                                                    ID\n                                                </th>\n                                                <th style=\"width: 50px;\" table-column-sorting current-text=\"vm.filterData.createdPredicate\" title=\"BK\" text=\"\'total_bookings\'\"\n                                                    check=\"vm.filterData.createdReverse\">\n                                                    BK\n                                                </th>\n                                                <th style=\"width: 50px;\" table-column-sorting current-text=\"vm.filterData.createdPredicate\" title=\"PAX\" text=\"\'pax\'\" check=\"vm.filterData.createdReverse\">\n                                                    PAX\n                                                </th>\n                                                <th style=\"width: 60px;\" table-column-sorting current-text=\"vm.filterData.createdPredicate\" title=\"Time\" text=\"\'eta\'\" check=\"vm.filterData.createdReverse\">\n                                                    Time\n                                                </th>\n                                                <th style=\"width: 105px;\" table-column-sorting current-text=\"vm.filterData.createdPredicate\" title=\"First Booking\" text=\"\'first_pickup_time\'\"\n                                                    check=\"vm.filterData.createdReverse\">\n                                                    First Booking\n                                                </th>\n                                                <th style=\"width: 80px;\" table-column-sorting current-text=\"vm.filterData.createdPredicate\" title=\"Address\" text=\"\'first_pickup_address\'\"\n                                                    check=\"vm.filterData.createdReverse\">\n                                                    Address\n                                                </th>\n                                                <th style=\"width:80px;\" table-column-sorting current-text=\"vm.filterData.createdPredicate\" title=\"Móvil\" text=\"\'unique_car_id\'\"\n                                                    check=\"vm.filterData.createdReverse\">\n                                                    Móvil\n                                                </th>\n                                                <th style=\"width: 80px;\" table-column-sorting current-text=\"vm.filterData.createdPredicate\" title=\"Status\" text=\"\'status\'\"\n                                                    check=\"vm.filterData.createdReverse\">\n                                                    Status\n                                                </th>\n                                                <th style=\"width: 330px;\">\n                                                    Action\n                                                </th>\n                                            </tr>\n                                        </thead>\n                                        <tbody ng-if=\"vm.filterData.createdBookingCount > 0\" when-scrolled=\"vm.paginationChangedForCreated()\">\n                                            <tr ng-repeat=\"data in vm.filterData.createdBookingList | orderBy:vm.filterData.createdPredicate:vm.filterData.createdReverse\">\n                                                <td style=\"width: 70px;\">{{$index + 1}}</td>\n                                                <td style=\"width: 70px;\">#{{data.shared_service_id}}</td>\n                                                <td style=\"width: 50px;\">{{data.total_bookings}}</td>\n                                                <td style=\"width: 50px;\">{{data.pax || 0}}</td>\n                                                <td style=\"width: 60px;\">{{data.eta}}</td>\n                                                <td style=\"width: 105px;\">{{data.first_pickup_time | date:\'dd MMM, HH:mm\'}}</td>\n                                                <td style=\"width: 80px;\">{{data.first_pickup_address || \'--\'}}</td>\n                                                <td style=\"width: 80px;\">\n                                                    <span ng-if=\"data.unique_car_id\">{{data.unique_car_id || \'--\'}}</span>\n                                                    <span ng-if=\"!data.unique_car_id\">sin assignar</span>\n                                                </td>\n                                                <td style=\"width: 80px;\">\n                                                    <span ng-if=\"data.status == 0\">Upcoming</span>\n                                                    <span ng-if=\"data.status == 1\">Viaje Iniciado</span>\n                                                    <span ng-if=\"data.status == 2\">Ended</span>\n                                                    <span ng-if=\"data.status == 3\">Failed</span>\n                                                    <span ng-if=\"data.status == 4\">En Posición</span>\n                                                    <span ng-if=\"data.status == 5\">Partial</span>\n                                                    <span ng-if=\"data.status == 6\">Unassigned</span>\n                                                    <span ng-if=\"data.status == 7\">Accepted</span>\n                                                    <span ng-if=\"data.status == 8\">Decline</span>\n                                                    <span ng-if=\"data.status == 9\">Cancel</span>\n                                                    <span ng-if=\"data.status == 15\">Onroad</span>\n                                                </td>\n                                                <td style=\"width: 330px;\">\n                                                    <a title=\"Assignar\" style=\"background-color:#7ed321;color:white\" class=\"cursor editIconColor btn btn-sm\" ng-disabled=\"data.unique_car_id\"\n                                                        ng-click=\"vm.assignBookings(data,$event)\">\n                                                        <span>A</span>\n                                                    </a>\n                                                    <a title=\"Deassignar\" style=\"background-color:#e41b35;color:white\" class=\"cursor editIconColor btn btn-sm\" ng-disabled=\"!data.unique_car_id\"\n                                                        ng-click=\"vm.unassignBooking(data,$event)\">\n                                                        <span>D</span>\n                                                    </a>\n                                                    <a title=\"Modificar\" class=\"cursor editIconColor btn btn-sm\" ng-click=\"vm.modifyBooking(data)\">\n                                                        <i class=\"fa fa-edit\"></i>\n                                                    </a>\n                                                    <a title=\"Delete\" class=\"cursor editIconColor btn btn-sm\" ng-click=\"vm.deletePackage(data)\">\n                                                        <i class=\"fa fa-trash-o\"></i>\n                                                    </a>\n                                                    <a ng-disabled=\"data.send_voucher\" title=\"Enviar Voucher\" class=\"cursor editIconColor btn btn-sm\" ng-click=\"vm.enviarVoucher(data)\">\n                                                        Enviar Voucher\n                                                    </a>\n                                                </td>\n                                            </tr>\n                                        </tbody>\n                                        <tfoot ng-if=\"vm.filterData.createdBookingCount == 0\">\n                                            <tr>\n                                                <td colspan=\"10\" class=\"text-center\">Nothing Found</td>\n                                            </tr>\n                                        </tfoot>\n                                    </table>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"col-lg-6 col-xs-12 col-sm-6 col-md-6\">\n                            <div class=\"basicDiv\">\n                                <div class=\"row\" style=\"padding: 15px;\">\n                                    <div class=\"col-lg-3 col-xs-12 col-sm-12 col-md-3\">\n                                        <label for=\"flight-search\">Flight Number</label>\n                                        <input type=\"text\" name=\"flight-search\" class=\"form-control\" placeholder=\"Search Flight\" ng-model=\"vm.flightSearchModel\"\n                                            ng-change=\"vm.searchFilter()\" maxlength=\"8\">\n                                    </div>\n                                    <div class=\"col-lg-3 col-xs-12 col-sm-12 col-md-3\">\n                                        <label for=\"nomina-search\">Nomina</label>\n                                        <input type=\"text\" name=\"nomina-search\" class=\"form-control\" placeholder=\"Search Nomina\" ng-model=\"vm.nominaSearchModel\"\n                                            ng-change=\"vm.searchFilter()\" maxlength=\"15\">\n                                    </div>\n                                    <div class=\"col-lg-3 col-xs-12 col-sm-12 col-md-3\">\n                                        <label for=\"comuna-search\">Comuna</label>\n                                        <input type=\"text\" name=\"comuna-search\" class=\"form-control\" placeholder=\"Search Comuna\" ng-model=\"vm.comunaSearchModel\"\n                                            ng-change=\"vm.searchFilter()\" maxlength=\"50\">\n                                    </div>\n                                    <div class=\"col-lg-3 col-xs-12 col-sm-12 col-md-3\">\n                                        <label for=\"discardBookingStatusChange\">Ver descartadas</label>\n                                        <i style=\"font-size: 25px;display: block;line-height: 1.4;\" name=\"discardBookingStatusChange\" ng-click=\"vm.discardBookingStatusChange(vm.discardBookingStatus);\"\n                                            ng-class=\"{\'fa fa-toggle-on\': vm.discardBookingStatus , \'fa fa-toggle-off\': !vm.discardBookingStatus }\"></i>\n                                    </div>\n                                </div>\n                                <p class=\"basicRegistrationP backgroundBasicPending text-center\">Unassigned Bookings</p>\n                                <div class=\"basicDetailsDiv\">\n                                    <div class=\"table-responsive\" id=\"tableSharedUnassigned\">\n                                        <table class=\"table tableSharedUnassignedTable\" id=\"parentTable\" dnd-list=\"vm.filterData.unassignedBookingList\" dnd-drop=\"vm.dropedAreaBack(item)\">\n                                            <thead>\n                                                <tr>\n                                                    <th style=\"width: 61px;\">\n                                                        Action\n                                                    </th>\n                                                    <th style=\"width: 61px;\" table-column-sorting current-text=\"vm.filterData.unassignedPredicate\" title=\"{{\'serialNumber\' | translate}}\"\n                                                        text=\"\'index\'\" check=\"vm.filterData.unassignedReverse\">\n                                                        {{\'serialNumber\' | translate}}\n                                                    </th>\n                                                    <th style=\"width: 39px;\" table-column-sorting current-text=\"vm.filterData.unassignedPredicate\" title=\"ID\" text=\"\'job_id\'\"\n                                                        check=\"vm.filterData.unassignedReverse\">\n                                                        ID\n                                                    </th>\n                                                    <th style=\"width: 88px;\" table-column-sorting current-text=\"vm.filterData.unassignedPredicate\" title=\"Agreement\" text=\"\'name\'\"\n                                                        check=\"vm.filterData.unassignedReverse\">\n                                                        Agreement\n                                                    </th>\n                                                    <th style=\"width: 64px;\" table-column-sorting current-text=\"vm.filterData.unassignedPredicate\" title=\"Pickup\" text=\"\'original_pickup_datetime\'\"\n                                                        check=\"vm.filterData.unassignedReverse\">\n                                                        Pickup\n                                                    </th>\n                                                    <th style=\"width: 78px;\" table-column-sorting current-text=\"vm.filterData.unassignedPredicate\" title=\"Tolerance\" text=\"\'time_with_tolerance\'\"\n                                                        check=\"vm.filterData.unassignedReverse\">\n                                                        Tolerance\n                                                    </th>\n                                                    <th style=\"width: 91px;\" table-column-sorting current-text=\"vm.filterData.unassignedPredicate\" title=\"Presentation\" text=\"\'original_delivery_datetime\'\"\n                                                        check=\"vm.filterData.unassignedReverse\">\n                                                        Presentation\n                                                    </th>\n                                                    <th style=\"width: 44px;\" table-column-sorting current-text=\"vm.filterData.unassignedPredicate\" title=\"ETA\" text=\"\'original_eta\'\"\n                                                        check=\"vm.filterData.unassignedReverse\">\n                                                        ETA\n                                                    </th>\n                                                    <th style=\"width: 41px;\" table-column-sorting current-text=\"vm.filterData.unassignedPredicate\" title=\"Pax\" text=\"\'number_of_passangers\'\"\n                                                        check=\"vm.filterData.unassignedReverse\">\n                                                        Pax\n                                                    </th>\n                                                    <th style=\"width: 94px;\" table-column-sorting current-text=\"vm.filterData.unassignedPredicate\" title=\"Pickup Location\" text=\"\'job_pickup_address\'\"\n                                                        check=\"vm.filterData.unassignedReverse\">\n                                                        Pickup Location\n                                                    </th>\n                                                    <th style=\"width: 94px;\" table-column-sorting current-text=\"vm.filterData.unassignedPredicate\" title=\"Pickup Location\" text=\"\'job_pickup_address\'\"\n                                                        check=\"vm.filterData.unassignedReverse\">\n                                                        Flight Number\n                                                    </th>\n                                                    <th style=\"width: 94px;\" table-column-sorting current-text=\"vm.filterData.unassignedPredicate\" title=\"Nomina\" text=\"\'nomina\'\"\n                                                        check=\"vm.filterData.unassignedReverse\">\n                                                        Nomina\n                                                    </th>\n                                                </tr>\n                                            </thead>\n                                            <tbody class=\"apps-container\" when-scrolled=\"vm.paginationChangedForUnassigned()\" ng-model=\"vm.filterData.unassignedBookingList\">\n                                                <tr style=\"width: 61px;\" class=\"app\" ng-repeat=\"data in vm.filterData.unassignedBookingList | orderBy:vm.filterData.unassignedPredicate:vm.filterData.unassignedReverse\"\n                                                    dnd-disable-if=\"data.job_status == 1 || data.job_status == 2\" ng-attr-id=\"{{data.job_id + \'-\' + data.number_of_passangers}}\"\n                                                    ng-class=\"{\'not-sortable\': data.job_status == 1 || data.job_status == 2, \'back-color-ADCE98\': (data.discard_from_group == 1)}\">\n                                                    <td style=\"width:61px; padding: 11px;\">\n                                                        <i class=\"fa fa-arrow-down\" style=\"font-size: 20px;color: #63d8f2;\" ng-if=\"data.discard_from_group == 0\" ng-click=\"vm.click1(data,$index)\"></i>\n                                                        <i class=\"fa fa-plus\" style=\"font-size: 26px;color: #EF7D07;\" ng-if=\"data.discard_from_group == 1;\" ng-click=\"vm.discardBooking(data, 0, $index)\"></i>\n                                                        <i class=\"fa fa-close\" style=\"font-size: 20px;color: #D4001F;\" ng-if=\"data.discard_from_group == 0\" ng-click=\"vm.discardBooking(data, 1, $index)\"></i>\n                                                    </td>\n                                                    <td style=\"width: 61px;\">{{$index + 1}}</td>\n                                                    <td style=\"width: 39px;\">#{{data.job_id}}</td>\n                                                    <td style=\"width: 88px;\">{{data.name}}</td>\n                                                    <td style=\"width: 64px;\">{{data.original_pickup_datetime | date:\'dd MMM, HH:mm\'}}</td>\n                                                    <td style=\"width: 78px;\">{{data.time_with_tolerance_before | date:\'HH:mm\'}} - {{data.time_with_tolerance_after\n                                                        | date:\'HH:mm\'}}</td>\n                                                    <td style=\"width: 91px;\">{{data.original_delivery_datetime | date:\'dd MMM, HH:mm\'}}</td>\n                                                    <td style=\"width: 44px;\">{{data.original_eta}}</td>\n                                                    <td style=\"width: 41px;\">{{data.number_of_passangers}}</td>\n                                                    <td style=\"width: 94px;\">{{data.job_pickup_address}}</td>\n                                                    <td style=\"width: 94px;\" ng-if=\"data.flight_number == null\">--</td>\n                                                    <td style=\"width: 94px;\" ng-if=\"data.flight_number != null\">{{data.flight_number}}</td>\n                                                    <td style=\"width: 94px;\">{{data.nomina || \'--\'}}</td>\n                                                </tr>\n                                            </tbody>\n                                        </table>\n                                    </div>\n                                    <div>\n                                        <p class=\"text-right\">\n                                            <b>{{vm.filterData.unassignedBookingCount}} Bookings</b>\n                                        </p>\n                                    </div>\n                                </div>\n                            </div>\n        \n                            <div class=\"mt10\">\n                                <div class=\"bookingPackageMade\">\n                                    <p class=\"bookingAssignmentText\">Bookings Assignment to Service ({{vm.filterData.sharedServiceName}})</p>\n                                    <p class=\"bookingAssignmementServiceText\">{{ vm.nameForShow}} 1-{{ vm.maxForShow}}</p>\n                                    <div class=\"row assingnedPasseneger1\">\n                                        <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12 assingnedPasseneger2\">\n                                            <p class=\"assingnedPasseneger\">Total Pax: {{vm.filterData.totalPassengerAssigned}}</p>\n                                        </div>\n                                        <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12 assingnedPasseneger2\">\n                                            <p class=\"assingnedPasseneger\">Total Bookings: {{vm.filterData.totalBookingAssigned}}</p>\n                                        </div>\n                                        <div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12 assingnedPasseneger2\">\n                                            <p class=\"assingnedPasseneger\">Total Trip Time: {{vm.filterData.totalAssignedETA}}min</p>\n                                        </div>\n                                    </div>\n                                    <div class=\"tableView\">\n                                        <div class=\"table-responsive\" id=\"tableSharedAssigned\">\n                                            <table class=\"table tableSharedAssignedTable\" dnd-list=\"vm.filterData.makePackageList\" dnd-drop=\"vm.dropedArea(item,index,event)\"\n                                                id=\"dropTable\">\n                                                <thead>\n                                                    <tr>\n                                                        <th style=\"width:61px\">\n                                                            Action\n                                                        </th>\n                                                        <th hidden=\"true\" style=\"width: 61px;\" table-column-sorting current-text=\"vm.filterData.makePackagePredicate\" title=\"{{\'serialNumber\' | translate}}\"\n                                                            text=\"\'index\'\" check=\"vm.filterData.makePackageReverse\">\n                                                            {{\'serialNumber\' | translate}}\n                                                        </th>\n                                                        <th style=\"width: 50px;\" table-column-sorting current-text=\"vm.filterData.makePackagePredicate\" title=\"ID\" text=\"\'job_id\'\"\n                                                            check=\"vm.filterData.makePackageReverse\">\n                                                            ID\n                                                        </th>\n                                                        <th style=\"width: 90px;\" table-column-sorting current-text=\"vm.filterData.makePackagePredicate\" title=\"Agreement\" text=\"\'name\'\"\n                                                            check=\"vm.filterData.makePackageReverse\">\n                                                            Agreement\n                                                        </th>\n                                                        <th style=\"width: 65px;\" table-column-sorting current-text=\"vm.filterData.makePackagePredicate\" title=\"Pickup\" text=\"\'original_pickup_datetime\'\"\n                                                            check=\"vm.filterData.makePackageReverse\">\n                                                            Pickup\n                                                        </th>\n                                                        <th style=\"width: 80px;\" table-column-sorting current-text=\"vm.filterData.makePackagePredicate\" title=\"Tolerance\" text=\"\'time_with_tolerance\'\"\n                                                            check=\"vm.filterData.makePackageReverse\">\n                                                            Tolerance\n                                                        </th>\n                                                        <th style=\"width: 95px;\" table-column-sorting current-text=\"vm.filterData.makePackagePredicate\" title=\"Presentation\" text=\"\'original_delivery_datetime\'\"\n                                                            check=\"vm.filterData.makePackageReverse\">\n                                                            Present.\n                                                        </th>\n                                                        <th style=\"width: 46px;\" table-column-sorting current-text=\"vm.filterData.makePackagePredicate\" title=\"ETA\" text=\"\'original_eta\'\"\n                                                            check=\"vm.filterData.makePackageReverse\">\n                                                            ETA\n                                                        </th>\n                                                        <th style=\"width: 86px;\" table-column-sorting current-text=\"vm.filterData.makePackagePredicate\" title=\"New Pickup\" text=\"\'job_time_new\'\"\n                                                            check=\"vm.filterData.makePackageReverse\">\n                                                            New Pickup\n                                                        </th>\n                                                        <th style=\"width: 110px;\" table-column-sorting current-text=\"vm.filterData.makePackagePredicate\" title=\"New Presentation\"\n                                                            text=\"\'job_dropoff_utc_new\'\" check=\"vm.filterData.makePackageReverse\">\n                                                            New Present.\n                                                        </th>\n                                                        <th style=\"width: 62px;\" table-column-sorting current-text=\"vm.filterData.makePackagePredicate\" title=\"New ETA\" text=\"\'newEta\'\"\n                                                            check=\"vm.filterData.makePackageReverse\">\n                                                            New ETA\n                                                        </th>\n                                                        <th style=\"width: 37px;\" table-column-sorting current-text=\"vm.filterData.makePackagePredicate\" title=\"Pax\" text=\"\'number_of_passangers\'\"\n                                                            check=\"vm.filterData.makePackageReverse\">\n                                                            Pax\n                                                        </th>\n                                                        <th style=\"width: 86px;\" table-column-sorting current-text=\"vm.filterData.makePackagePredicate\" title=\"Pickup Location\" text=\"\'job_pickup_address\'\"\n                                                            check=\"vm.filterData.makePackageReverse\">\n                                                            Pickup Location\n                                                        </th>\n                                                        <th style=\"width: 94px;\" table-column-sorting current-text=\"vm.filterData.unassignedPredicate\" title=\"Pickup Location\" text=\"\'job_pickup_address\'\"\n                                                            check=\"vm.filterData.unassignedReverse\">\n                                                            Flight Number\n                                                        </th>\n                                                    </tr>\n                                                </thead>\n                                                <tbody class=\"apps-container\" ui-sortable=\"vm.sortableOptions\" ng-model=\"vm.filterData.makePackageList\">\n                                                    <tr class=\"app\" ng-repeat=\"data in vm.filterData.makePackageList | orderBy:vm.filterData.makePackagePredicate:vm.filterData.makePackageReverse\"\n                                                        dnd-disable-if=\"data.job_status == 1 || data.job_status == 2\" ng-class=\"{\'shredServiceRed\': !data.is_valid_tolerance,\'shredServiceWhite\':data.is_valid_tolerance,\'not-sortable\': data.job_status == 1 || data.job_status == 2}\"\n                                                        ng-attr-id=\"{{data.job_id + \'-\' + data.number_of_passangers}}\">\n                                                        <td style=\"width:61px;\">\n                                                            <i class=\"fa fa-arrow-up\" style=\"font-size: 20px;color: #63d8f2;\" ng-click=\"vm.click2(data,$index)\"></i>\n                                                        </td>\n                                                        <td hidden=\"true\" style=\"width: 61px;\">{{$index + 1}}</td>\n                                                        <td style=\"width: 50px;\">#{{data.job_id}}</td>\n                                                        <td style=\"width: 90px;\">{{data.name}}</td>\n                                                        <td style=\"width: 65px;\">{{data.original_pickup_datetime | date:\'dd MMM, HH:mm\'}}</td>\n                                                        <td style=\"width: 80px;\">{{data.time_with_tolerance_before | date:\'HH:mm\'}} - {{data.time_with_tolerance_after\n                                                            | date:\'HH:mm\'}}</td>\n                                                        <td style=\"width: 95px;\">{{data.original_delivery_datetime | date:\'dd MMM, HH:mm\'}}</td>\n                                                        <td style=\"width: 46px;\">{{data.original_eta}}</td>\n        \n                                                        <td style=\"width: 86px;\">{{data.job_time_new | date:\'dd MMM, HH:mm\'}}</td>\n                                                        <td style=\"width: 110px;\">{{data.job_dropoff_utc_new | date:\'dd MMM, HH:mm\'}}</td>\n        \n                                                        <td style=\"width: 62px;\">{{data.newEta}}</td>\n                                                        <td style=\"width: 37px;\">{{data.number_of_passangers}}</td>\n                                                        <td style=\"width: 86px;\">{{data.job_pickup_address}}</td>\n                                                        <td style=\"width: 94px;\" ng-if=\"data.flight_number == null\">--</td>\n                                                        <td style=\"width: 94px;\" ng-if=\"data.flight_number != null\">{{data.flight_number}}</td>\n                                                    </tr>\n                                                </tbody>\n                                            </table>\n                                        </div>\n                                    </div>\n                                    <div class=\"row serviceDetails1\">\n                                        <div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12 serviceDetails2\">\n                                            <p class=\"serviceDetails\">Service #: {{vm.filterData.sharedServiceName}}</p>\n                                        </div>\n                                        <div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12 serviceDetails2\">\n                                            <p class=\"serviceDetails\">Móvil Assigned: {{vm.filterData.vehicleAssigned}}</p>\n                                        </div>\n                                    </div>\n                                    <div class=\"row m0\" style=\"border-top: 2px solid #063c4a;padding-top:5px;padding-bottom: 5px;\" ng-if=\"vm.filterData.makePackageList.length > 0 && !vm.filterData.modifyFlag\">\n                                        <div class=\"col-lg-12 col-xs-12 col-ms-12 col-md-12 text-center\">\n                                            <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.saveGroupPackage()\">SAVE</button>\n                                            <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.newPackage()\">NEW</button>\n                                        </div>\n                                    </div>\n                                    <div class=\"row m0\" style=\"border-top: 2px solid #063c4a;padding-top:5px;padding-bottom: 5px;\" ng-if=\"vm.filterData.modifyFlag\">\n                                        <div class=\"col-lg-12 col-xs-12 col-ms-12 col-md-12 text-center\">\n                                            <button type=\"button\" class=\"btn btn-primary\" ng-if=\"vm.filterData.modifyFlag\" ng-click=\"vm.saveModifyGroupPackage()\">SAVE</button>\n                                            <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.newPackage()\">NEW</button>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div> --><div class=\"row mt10\"><div style=\"display: flex; flex-direction: column\"><div class=\"newTabs flex\" ng-if=vm.filterData.filterApplied><div style=\"display: flex\"><div class=tabsOnLeft><div ng-class=\"{\'isSelected\': vm.unassignedBookingsTab}\" class=\"tabs leftTab\" ng-click=\"vm.unassignedBookingsTab = true;vm.mapViewTab = false;vm.UnassignedList()\" data-testid=booking_result_select_list>RESERVAS SIN ASIGNAR (LISTA)</div><div ng-class=\"{\'isSelected\': vm.mapViewTab}\" class=\"tabs rightTab\" ng-click=\"vm.unassignedBookingsTab = false;vm.mapViewTab = true;vm.initializeMap()\" data-testid=booking_result_select_map>RESERVAS SIN ASIGNAR (MAPA)</div></div><!-- <div class=\"row\" style=\"padding: 15px; display: flex; justify-content: center;\"> --><div class=\"col-lg-2 col-xs-12 col-sm-12 col-md-2 padding\"><label for=id-booking>Booking ID</label><input type=text name=id-booking class=form-control placeholder=\"Search Booking\" ng-model=vm.idBooking ng-change=vm.searchFilter() data-testid=booking_filter_booking_id maxlength=10></div><div class=\"col-lg-2 col-xs-12 col-sm-12 col-md-2 padding\"><label for=flight-search>Vuelo Nro</label><input type=text name=flight-search class=form-control placeholder=\"Search Vuelo Nro\" ng-model=vm.flightSearchModel data-testid=booking_filter_flight_number ng-change=vm.searchFilter() maxlength=8></div><div class=\"col-lg-2 col-xs-12 col-sm-12 col-md-2 padding\"><label for=nomina-search>Nomina</label><input type=text name=nomina-search class=form-control placeholder=\"Search Nomina\" ng-model=vm.nominaSearchModel data-testid=booking_filter_nomina ng-change=vm.searchFilter() maxlength=15></div><div class=\"col-lg-2 col-xs-12 col-sm-12 col-md-2 padding\"><label for=comuna-search>Comuna</label><input type=text name=comuna-search class=form-control placeholder=\"Search Comuna\" ng-model=vm.comunaSearchModel data-testid=booking_filter_comuna ng-change=vm.searchFilter() maxlength=50></div><div class=\"col-lg-2 col-xs-12 col-sm-12 col-md-2 padding\"><label for=discardBookingStatusChange>Ver descartadas</label><i style=\"font-size: 25px;display: block;line-height: 1.4\" name=discardBookingStatusChange ng-click=vm.discardBookingStatusChange(vm.discardBookingStatus); ng-class=\"{\'fa fa-toggle-on\': vm.discardBookingStatus , \'fa fa-toggle-off\': !vm.discardBookingStatus }\" data-testid=booking_filter_discards></i></div><!-- </div> --></div><i class=\"fa fa-minus\" ng-if=vm.upperTabsBody ng-click=\"vm.upperTabsBody = false;\" data-testid=booking_show_results></i> <i class=\"fa fa-plus\" ng-if=!vm.upperTabsBody ng-click=\"vm.upperTabsBody = true; vm.initializeMap();\" data-testid=booking_hide_results></i></div><div style=\"display: flex; justify-content: flex-end; align-items: center; padding-right: 15px\"><button class=\"btn btn-primary\" type=button ng-click=vm.SelectAll() style=\"margin-right: 10px\" data-testid=booking_select_results>Seleccionar todos</button> <button class=\"btn btn-primary\" type=button ng-click=vm.DiscardGroup() style=\"margin-right: 10px\" ng-disabled=vm.selectDisabled data-testid=booking_descartar_todo>Descartar de agrupación</button> <button class=\"btn btn-danger\" type=button ng-click=vm.ResetSelection() style=\"margin-right: 10px\" data-testid=booking_clean_selected>Limpiar selección</button><!-- <button class=\"btn btn-danger\" type=\"button\" ng-click=\"vm.ExportToExcel()\" style=\"margin-right: 10px;\">\n                            Exportar\n                        </button> --></div><div ng-if=\"vm.upperTabsBody && vm.filterData.filterApplied\"><!-- <div class=\"row\" style=\"padding: 15px; display: flex; justify-content: center;\">\n                                <div class=\"col-lg-2 col-xs-12 col-sm-12 col-md-2\">\n                                    <label for=\"id-booking\">Booking ID</label>\n                                    <input type=\"text\" name=\"id-booking\" class=\"form-control\" placeholder=\"Search Booking\" ng-model=\"vm.idBooking\" ng-change=\"vm.searchFilter()\"\n                                        maxlength=\"10\">\n                                </div>\n    \n                                <div class=\"col-lg-2 col-xs-12 col-sm-12 col-md-2\">\n                                    <label for=\"flight-search\">Vuelo Nro</label>\n                                    <input type=\"text\" name=\"flight-search\" class=\"form-control\" placeholder=\"Search Vuelo Nro\" ng-model=\"vm.flightSearchModel\"\n                                        ng-change=\"vm.searchFilter()\" maxlength=\"8\">\n                                </div>\n                                <div class=\"col-lg-2 col-xs-12 col-sm-12 col-md-2\">\n                                    <label for=\"nomina-search\">Nomina</label>\n                                    <input type=\"text\" name=\"nomina-search\" class=\"form-control\" placeholder=\"Search Nomina\" ng-model=\"vm.nominaSearchModel\"\n                                        ng-change=\"vm.searchFilter()\" maxlength=\"15\">\n                                </div>\n                                <div class=\"col-lg-2 col-xs-12 col-sm-12 col-md-2\">\n                                    <label for=\"comuna-search\">Comuna</label>\n                                    <input type=\"text\" name=\"comuna-search\" class=\"form-control\" placeholder=\"Search Comuna\" ng-model=\"vm.comunaSearchModel\"\n                                        ng-change=\"vm.searchFilter()\" maxlength=\"50\">\n                                </div>\n                                <div class=\"col-lg-2 col-xs-12 col-sm-12 col-md-2\">\n                                    <label for=\"discardBookingStatusChange\">Ver descartadas</label>\n                                    <i style=\"font-size: 25px;display: block;line-height: 1.4;\" name=\"discardBookingStatusChange\" ng-click=\"vm.discardBookingStatusChange(vm.discardBookingStatus);\"\n                                        ng-class=\"{\'fa fa-toggle-on\': vm.discardBookingStatus , \'fa fa-toggle-off\': !vm.discardBookingStatus }\"></i>\n                                </div>\n                            </div> --><div style=\"display: flex; flex-direction: row\" class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><!-- map view --><div ng-if=vm.mapViewTab class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" id=groupedMap style=\"height: 450px\"></div><!-- unassigned bookings --><div ng-if=vm.unassignedBookingsTab class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">Unassigned Bookings <button type=button class=\"pull-right _driver_rating_title_button ng-binding\" ng-click=vm.VolverButton() data-testid=booking_relead_results>Volver a cargar</button> <span class=\"pull-right booking_count\">{{vm.socketCount}}</span></p><div class=basicDetailsDiv><div class=table-responsive id=tableSharedUnassigned><table class=\"table tableSharedUnassignedTable\" id=parentTable dnd-list=vm.filterData.unassignedBookingList dnd-drop=vm.dropedAreaBack(item)><thead><tr><th style=\"width: 61px\">Action</th><th style=\"width: 61px\" table-column-sorting current-text=vm.filterData.unassignedPredicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.filterData.unassignedReverse>{{\'serialNumber\' | translate}}</th><th style=\"width: 39px\" table-column-sorting current-text=vm.filterData.unassignedPredicate title=ID text=\"\'job_id\'\" check=vm.filterData.unassignedReverse>ID</th><th style=\"width: 88px\" table-column-sorting current-text=vm.filterData.unassignedPredicate title=Agreement text=\"\'name\'\" check=vm.filterData.unassignedReverse>Agreement</th><th style=\"width: 64px\" table-column-sorting current-text=vm.filterData.unassignedPredicate title=Pickup text=\"\'original_pickup_datetime\'\" check=vm.filterData.unassignedReverse>Pickup</th><th style=\"width: 78px\" table-column-sorting current-text=vm.filterData.unassignedPredicate title=Tolerance text=\"\'time_with_tolerance\'\" check=vm.filterData.unassignedReverse>Tolerance</th><th style=\"width: 91px\" table-column-sorting current-text=vm.filterData.unassignedPredicate title=Presentation text=\"\'original_delivery_datetime\'\" check=vm.filterData.unassignedReverse>Presentation</th><th style=\"width: 44px\" table-column-sorting current-text=vm.filterData.unassignedPredicate title=ETA text=\"\'original_eta\'\" check=vm.filterData.unassignedReverse>ETA</th><th style=\"width: 41px\" table-column-sorting current-text=vm.filterData.unassignedPredicate title=Pax text=\"\'number_of_passangers\'\" check=vm.filterData.unassignedReverse>Pax</th><th style=\"width: 94px\" table-column-sorting current-text=vm.filterData.unassignedPredicate title=\"Pickup Location\" text=\"\'job_pickup_address\'\" ng-if=\"vm.filterData.unassignedBookingList[0].type_of_trip != \'Z\'\" check=vm.filterData.unassignedReverse>Pickup Location</th><th style=\"width: 86px\" table-column-sorting current-text=vm.filterData.makePackagePredicate title=\"Dropoff Location\" text=\"\'job_address\'\" ng-if=\"vm.filterData.unassignedBookingList[0].type_of_trip == \'Z\'\" check=vm.filterData.makePackageReverse>DropOff Location</th><th style=\"width: 94px\" table-column-sorting current-text=vm.filterData.unassignedPredicate title=\"Pickup Location\" text=\"\'job_pickup_address\'\" check=vm.filterData.unassignedReverse><!-- Flight Number --> Vuelo Nro</th><th style=\"width: 94px\" table-column-sorting current-text=vm.filterData.unassignedPredicate title=Nomina text=\"\'nomina\'\" check=vm.filterData.unassignedReverse>Nomina</th><th style=\"width: 94px\" table-column-sorting current-text=vm.filterData.unassignedPredicate title=Nomina text=\"\'nomina\'\" check=vm.filterData.unassignedReverse>Bloqueada por</th></tr></thead><tbody class=apps-container when-scrolled=vm.paginationChangedForUnassigned() ng-model=vm.filterData.unassignedBookingList><tr class=app ng-repeat=\"data in vm.filterData.unassignedBookingList | orderBy:vm.filterData.unassignedPredicate:vm.filterData.unassignedReverse\" dnd-disable-if=\"data.job_status == 1 || data.job_status == 2\" ng-attr-id=\"{{data.job_id + \'-\' + data.number_of_passangers}}\" ng-style=\"data.selected ? {\'background-color\': \'grey\'} : {}\" ng-class=\"{\'not-sortable\': data.job_status == 1 || data.job_status == 2, \'back-color-ADCE98\': (data.discard_from_group == 1 || data.selected), \'ColorGrey\': data.locking_id != null}\"><td style=\"width:61px; padding: 11px\" ng-if=\"data.locking_id == null && !data.selected\"><i class=\"fa fa-arrow-down\" style=\"font-size: 20px;color: #63d8f2\" ng-if=\"data.discard_from_group == 0\" ng-click=vm.click1(data,$index)></i> <i class=\"fa fa-plus\" style=\"font-size: 26px;color: #EF7D07\" ng-if=\"data.discard_from_group == 1;\" ng-click=\"vm.discardBooking(data, 0, $index)\"></i> <i class=\"fa fa-close\" style=\"font-size: 20px;color: #D4001F\" ng-if=\"data.discard_from_group == 0\" ng-click=\"vm.discardBooking(data, 1, $index)\"></i></td><td style=\"width:61px; padding: 11px\" ng-if=\"data.locking_id != null && !data.selected\"><button class=Desbloquear ng-click=\"vm.blockUnblockBooking(data.job_id,\'popUp\')\">Desbloquear</button></td><td style=\"width:61px; padding: 11px\" ng-if=data.selected></td><td style=\"width: 61px\" ng-click=vm.seleccionar_reserva(data,$index)>{{$index + 1}}</td><td style=\"width: 39px\" ng-click=vm.seleccionar_reserva(data,$index)>#{{data.job_id}}</td><td style=\"width: 88px\" ng-click=vm.seleccionar_reserva(data,$index)>{{data.name}}</td><td style=\"width: 64px\" ng-click=vm.seleccionar_reserva(data,$index)>{{data.original_pickup_datetime | date:\'dd MMM, HH:mm\'}}</td><td style=\"width: 78px\" ng-click=vm.seleccionar_reserva(data,$index)>{{data.time_with_tolerance_before | date:\'HH:mm\'}} <span ng-if=\"data.is_group_external_new == 0\">- {{data.time_with_tolerance_after | date:\'HH:mm\'}}</span></td><td style=\"width: 91px\" ng-click=vm.seleccionar_reserva(data,$index)>{{data.original_delivery_datetime | date:\'dd MMM, HH:mm\'}}</td><td style=\"width: 44px\" ng-click=vm.seleccionar_reserva(data,$index)>{{data.original_eta}}</td><td style=\"width: 41px\" ng-click=vm.seleccionar_reserva(data,$index)>{{data.number_of_passangers}}</td><td style=\"width: 94px\" ng-if=\"data.type_of_trip != \'Z\'\" ng-click=vm.seleccionar_reserva(data,$index)>{{data.job_pickup_address}}</td><td style=\"width: 94px\" ng-if=\"data.type_of_trip == \'Z\'\" ng-click=vm.seleccionar_reserva(data,$index)>{{data.job_address}}</td><td style=\"width: 94px\" ng-if=\"data.flight_number == null\" ng-click=vm.seleccionar_reserva(data,$index)>--</td><td style=\"width: 94px\" ng-if=\"data.flight_number != null\" ng-click=vm.seleccionar_reserva(data,$index)>{{data.flight_number}}</td><td style=\"width: 94px\" ng-click=vm.seleccionar_reserva(data,$index)>{{data.nomina || \'--\'}}</td><td style=\"width: 94px\" ng-click=vm.seleccionar_reserva(data,$index)>{{data.locking_id_name || \'--\'}}</td></tr></tbody></table></div><div><p class=text-right><b>{{vm.filterData.unassignedBookingCount}} Bookings</b></p></div></div></div></div></div><!-- FILTER FOR PACKAGES --><div class=\"row m0 col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"margin-top: 20px !important\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"border:1px solid #dedede;padding:0px\" ng-init=\"checkClickedPackage = true\"><h2 class=\"text-center filtersStyle\" ng-click=\"(vm.filterData.makePackageList.length > 0 && vm.bookingsAssignmentTab) ? (checkClickedPackage = false) : (checkClickedPackage = !checkClickedPackage); vm.slideDataPackage()\">Package Filters <span class=fa ng-class=\"{\'fa-caret-down\': checkClickedPackage,\'fa-caret-up\': !checkClickedPackage }\"></span></h2><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" id=packageFilter><form name=filterGroupedFormPackage ng-submit=\"submitPackage=true;filterGroupedFormPackage.$valid&&vm.applyFilterServices(\'blank\')\" novalidate autocomplete=off><div class=row style=\"padding-top: 10px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'branchLabel\' | translate}} <span style=color:red>*</span></label><div><ui-select ng-model=vm.filterData.branch_value_package name=branch ng-change=vm.branchChanged(1) required close-on-select=true ng-class=\"{ \'has-error\': filterGroupedFormPackage.branch.$touched && filterGroupedFormPackage.branch.$invalid }\" data-testid=package_filter_branch><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \"><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select><div ng-if=\"filterGroupedFormPackage.branch.$touched|| submitPackage\" ng-messages=filterGroupedFormPackage.branch.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'branchR\' | translate}}</div></div></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'agreementLabel\' | translate}} <span style=color:red>*</span></label><div><ui-select ng-model=vm.filterData.aggrement_value_package name=agreement ng-change=vm.agreementChanged(1) data-testid=package_filter_agreement required close-on-select=true><ui-select-match placeholder=\"{{\'agreementPlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"agreements.id as agreements in vm.agreement | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=agreements.name></div></ui-select-choices></ui-select><div ng-if=\"filterGroupedFormPackage.agreement.$touched|| submitPackage\" ng-messages=filterGroupedFormPackage.agreement.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'selectAgreementReq\' | translate}}</div></div></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'serviceLabel\' | translate}} <span style=color:red>*</span></label><div><ui-select ng-model=vm.filterData.service_value_package name=service required close-on-select=true ng-change=vm.serviceChanged(1) data-testid=package_filter_service><ui-select-match placeholder=\"{{\'selectTService\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"services.id as services in vm.service | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=services.name></div></ui-select-choices></ui-select><div ng-if=\"filterGroupedFormPackage.service.$touched|| submitPackage\" ng-messages=filterGroupedFormPackage.service.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'serviceReq\' | translate}}</div></div></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'tripType\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=vm.filterData.typeOfTripPackage required name=typeOfTrip ng-class=\"{ \'has-error\': filterGroupedFormPackage.typeOfTrip.$touched && filterGroupedFormPackage.typeOfTrip.$invalid }\" ng-change=vm.typeOfTrip(1) ng-options=\"data.id as data.text for data in vm.typeTripFilter\" data-testid=package_filter_trip><option value=\"\" selected disabled>{{\'selectTripType\' | translate}}</option></select><div ng-if=\"filterGroupedFormPackage.typeOfTrip.$touched|| submitPackage\" ng-messages=filterGroupedFormPackage.typeOfTrip.$error><div class=\"errormessage text-danger\" ng-message=required>Please select type of trip.</div></div></div></div><div class=row style=\"padding-top: 10px;padding-bottom: 10px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpDateFromLabel\' | translate}}:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=pickupDate ng-model=vm.filterData.filter_pickup_from_date_value_package placeholder=\"{{\'pickUpDateLabel\' | translate}}\" is-open=vm.datePicker_1.pickupFromDatePackage data-testid=package_filter_fecha_inicio_reco datepicker-options=vm.dateOptions close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.pickupFromToDateChanged(3)> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_1(3)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpTimeFromLabel\' | translate}}:</label><div uib-timepicker ng-model=vm.filterData.filter_pickup_from_time_value_package show-spinners=false class=completed ng-change=vm.pickupFromToTimeChanged(1);vm.changeTime(1) hour-step=vm.hstep data-testid=package_filter_hora_inicio_reco minute-step=vm.mstep show-meridian=vm.ismeridian></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpDateToLabel\' | translate}}:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=pickupDate ng-model=vm.filterData.filter_pickup_to_date_value_package placeholder=\"{{\'pickUpDateLabel\' | translate}}\" is-open=vm.datePicker_1.pickupToDatePackage data-testid=package_filter_fecha_fin_reco datepicker-options=vm.dateOptionsT close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.pickupFromToDateChanged(4)> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_1(4)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpTimeToLabel\' | translate}}:</label><div uib-timepicker ng-model=vm.filterData.filter_pickup_to_time_value_package show-spinners=false class=completed ng-change=vm.pickupFromToTimeChanged(2);vm.changeDropTime(1) hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian data-testid=package_filter_hora_fin_reco></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center mt5\"><button class=\"btn btn-primary\" type=submitPackage style=\"height: 35px;line-height: 20px\" data-testid=package_filter_apply>Apply Filter</button> <button class=\"btn btn-danger\" type=button style=\"height: 35px;line-height: 20px\" ng-click=vm.resetFilter(1) data-testid=package_filter_clean>{{\'resetFilterButton\' | translate}}</button></div></div></form></div></div></div><div class=\"newTabs flex\" ng-if=vm.filterData.filterAppliedService><div style=\"display: flex\"><div class=tabsOnLeft style=\"margin-right: 2px\"><div ng-class=\"{\'isSelected\': vm.servicesCreatedTab}\" class=\"tabs leftTab\" ng-click=\"vm.servicesCreatedTab = true; vm.bookingsAssignmentTab = false;vm.getPackageSection(false)\" data-testid=package_result_select_list>SERVICIOS CREADOS</div><div ng-class=\"{\'isSelected\': vm.bookingsAssignmentTab}\" class=\"tabs rightTab\" ng-click=\"vm.servicesCreatedTab = false; vm.bookingsAssignmentTab = true;vm.getPackageSection(true)\" data-testid=package_result_select_map>CREAR SERVICIOS</div></div><div ng-if=!vm.bookingsAssignmentTab class=display-flex><div class=\"col-lg-2 col-xs-12 col-sm-12 col-md-2 d-flex\"><label class=labels for=booking>Booking ID</label><input type=text name=booking class=form-control placeholder=\"Search Booking\" ng-model=vm.booking ng-change=vm.serviceFilterData() maxlength=10></div><div class=\"col-lg-2 col-xs-12 col-sm-12 col-md-2 d-flex\"><label class=labels for=id-packets>ID Packete</label><input type=text name=id-packete class=form-control placeholder=\"Search ID Packete\" ng-model=vm.idPackete ng-change=vm.serviceFilterData() maxlength=8></div><div class=\"col-lg-2 col-xs-12 col-sm-12 col-md-2 d-flex\"><label class=labels for=vehicle-search>Vehiculo</label><input type=text name=vehicle-search class=form-control placeholder=\"Search Vehicle\" ng-model=vm.vehicleSearch ng-change=vm.serviceFilterData() maxlength=15></div></div></div><i class=\"fa fa-minus\" ng-if=vm.lowerTabsBody ng-click=\"vm.lowerTabsBody = false\" data-testid=package_show_results></i> <i class=\"fa fa-plus\" ng-if=!vm.lowerTabsBody ng-click=\"vm.lowerTabsBody = true;\" data-testid=package_hide_results></i></div><div ng-if=\"vm.servicesCreatedTab && vm.filterData.filterAppliedService\" style=\"display: flex; justify-content: flex-end; align-items: center; padding-right: 15px\"><button class=\"btn btn-primary\" type=button ng-click=vm.SelectAllCreatedBookings() style=\"margin-right: 10px\" data-testid=package_select_results>Seleccionar todos</button> <button class=\"btn btn-primary\" type=button ng-click=vm.ExportDetailToExcel() ng-disabled=!vm.isSomethingSelected() style=\"margin-right: 10px\" data-testid=package_export_results>Exportar detalle</button> <button class=\"btn btn-danger\" type=button ng-click=vm.ClearCreatedSelections() style=\"margin-right: 10px\" data-testid=package_clean_selected>Limpiar selección</button></div><div style=\"display: flex; flex-direction: row\" ng-if=\"vm.lowerTabsBody && vm.filterData.filterAppliedService\"><!-- services  created --><div ng-if=vm.servicesCreatedTab class=\"packageCreated mt10 col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=servicesCreated><p>Services Created ({{vm.filterData.createdBookingCount}})</p></div><div class=table-responsive id=packageMade><table class=table id=packageMadeTable style=\"margin-bottom: 0px\"><thead><tr><th style=\"width: 30px\">Selección</th><th style=\"width: 70px\">{{\'serialNumber\' | translate}}</th><th style=\"width: 70px\" table-column-sorting current-text=vm.filterData.createdPredicate title=ID text=\"\'shared_service_id\'\" check=vm.filterData.createdReverse>ID</th><th style=\"width: 50px\" table-column-sorting current-text=vm.filterData.createdPredicate title=BK text=\"\'total_bookings\'\" check=vm.filterData.createdReverse>BK</th><th style=\"width: 50px\" table-column-sorting current-text=vm.filterData.createdPredicate title=PAX text=\"\'pax\'\" check=vm.filterData.createdReverse>PAX</th><th style=\"width: 60px\" table-column-sorting current-text=vm.filterData.createdPredicate title=Time text=\"\'eta\'\" check=vm.filterData.createdReverse>Time</th><th style=\"width: 105px\" table-column-sorting current-text=vm.filterData.createdPredicate title=\"First Booking\" text=\"\'first_pickup_time\'\" check=vm.filterData.createdReverse>First Booking</th><th style=\"width: 80px\" table-column-sorting current-text=vm.filterData.createdPredicate title=Address text=\"\'first_pickup_address\'\" check=vm.filterData.createdReverse>Address</th><th style=width:80px table-column-sorting current-text=vm.filterData.createdPredicate title=Móvil text=\"\'unique_car_id\'\" check=vm.filterData.createdReverse>Móvil</th><th style=\"width: 80px\" table-column-sorting current-text=vm.filterData.createdPredicate title=Status text=\"\'status\'\" check=vm.filterData.createdReverse>Status</th><th style=\"width: 330px\">Action</th></tr></thead><tbody ng-if=\"vm.filterData.createdBookingCount > 0\" when-scrolled=vm.paginationChangedForCreated()><tr ng-repeat=\"data in vm.filterData.createdBookingList | orderBy:vm.filterData.createdPredicate:vm.filterData.createdReverse\" ng-style=\"data.selected ? {\'background-color\': \'grey\'} : {}\"><td style=width:30px><input type=checkbox ng-model=data.selected ng-click=vm.updateSelected(data)></td><td style=\"width: 70px\">{{$index + 1}}</td><td style=\"width: 70px\">#{{data.shared_service_id}}</td><td style=\"width: 50px\">{{data.total_bookings}}</td><td style=\"width: 50px\">{{data.pax || 0}}</td><td style=\"width: 60px\">{{data.eta}}</td><td style=\"width: 105px\">{{data.first_pickup_time | date:\'dd MMM, HH:mm\'}}</td><td style=\"width: 80px\">{{data.first_pickup_address || \'--\'}}</td><td style=\"width: 80px\"><span ng-if=data.unique_car_id>{{data.unique_car_id || \'--\'}}</span> <span ng-if=!data.unique_car_id>sin assignar</span></td><td style=\"width: 80px\"><span ng-if=\"data.status == 0\">{{\'upcomingStatus\' | translate}}</span> <span ng-if=\"data.status == 1\">Viaje Iniciado</span> <span ng-if=\"data.status == 2\">Completada</span> <span ng-if=\"data.status == 3\">Failed</span> <span ng-if=\"data.status == 4\">En Posición</span> <span ng-if=\"data.status == 5\">Partial</span> <span ng-if=\"data.status == 6\">No Asignada</span> <span ng-if=\"data.status == 7\">Accepted</span> <span ng-if=\"data.status == 8\">Decline</span> <span ng-if=\"data.status == 9\">Cancelada</span> <span ng-if=\"data.status == 15\">Onroad</span></td><td style=\"width: 330px\"><a title=Assignar style=background-color:#7ed321;color:white class=\"cursor editIconColor btn btn-sm\" ng-disabled=data.unique_car_id ng-click=vm.assignBookings(data,$event)><span>A</span> </a><a title=Deassignar style=background-color:#e41b35;color:white class=\"cursor editIconColor btn btn-sm\" ng-disabled=!data.unique_car_id ng-click=vm.unassignBooking(data,$event)><span>D</span> </a><a title=Modificar class=\"cursor editIconColor btn btn-sm\" ng-click=vm.modifyBooking(data)><i class=\"fa fa-edit\"></i> </a><a title=Delete class=\"cursor editIconColor btn btn-sm\" ng-click=vm.deletePackage(data)><i class=\"fa fa-trash-o\"></i> </a><a ng-disabled=data.send_voucher title=\"Enviar Voucher\" class=\"cursor editIconColor btn btn-sm\" ng-click=vm.enviarVoucher(data)>Enviar Voucher </a><!-- <i class=\"fa fa-search\" style=\"font-size: 20px; padding: 2px;\"></i> --></td></tr></tbody><tfoot ng-if=\"vm.filterData.createdBookingCount == 0\"><tr><td colspan=10 class=text-center>Nothing Found</td></tr></tfoot></table></div></div><!-- Bookings Assignment to Service (NEW) --><div ng-if=vm.bookingsAssignmentTab class=\"mt10 col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=bookingPackageMade><p class=bookingAssignmentText>Bookings Assignment to Service ({{vm.filterData.sharedServiceName}})</p><p class=bookingAssignmementServiceText>{{ vm.nameForShow}} 1-{{ vm.maxForShow}}</p><div class=\"row assingnedPasseneger1\"><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12 assingnedPasseneger2\"><p class=assingnedPasseneger>Total Pax: {{vm.filterData.totalPassengerAssigned}}</p></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12 assingnedPasseneger2\"><p class=assingnedPasseneger>Total Bookings: {{vm.filterData.totalBookingAssigned}}</p></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12 assingnedPasseneger2\"><p class=assingnedPasseneger>Total Trip Time: {{vm.filterData.totalAssignedETA}}min</p></div></div><div class=tableView><div class=table-responsive id=tableSharedAssigned><table class=\"table tableSharedAssignedTable\" dnd-list=vm.filterData.makePackageList dnd-drop=vm.dropedArea(item,index,event) id=dropTable><thead><tr><th style=width:61px>Action</th><th hidden style=\"width: 61px\" table-column-sorting current-text=vm.filterData.makePackagePredicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.filterData.makePackageReverse>{{\'serialNumber\' | translate}}</th><th style=\"width: 50px\" table-column-sorting current-text=vm.filterData.makePackagePredicate title=ID text=\"\'job_id\'\" check=vm.filterData.makePackageReverse>ID</th><th style=\"width: 90px\" table-column-sorting current-text=vm.filterData.makePackagePredicate title=Agreement text=\"\'name\'\" check=vm.filterData.makePackageReverse>Agreement</th><th style=\"width: 65px\" table-column-sorting current-text=vm.filterData.makePackagePredicate title=Pickup text=\"\'original_pickup_datetime\'\" check=vm.filterData.makePackageReverse>Pickup</th><th style=\"width: 80px\" table-column-sorting current-text=vm.filterData.makePackagePredicate title=Tolerance text=\"\'time_with_tolerance\'\" check=vm.filterData.makePackageReverse>Tolerance</th><th style=\"width: 95px\" table-column-sorting current-text=vm.filterData.makePackagePredicate title=Presentation text=\"\'original_delivery_datetime\'\" check=vm.filterData.makePackageReverse>Present.</th><th style=\"width: 46px\" table-column-sorting current-text=vm.filterData.makePackagePredicate title=ETA text=\"\'original_eta\'\" check=vm.filterData.makePackageReverse>ETA</th><th style=\"width: 86px\" table-column-sorting current-text=vm.filterData.makePackagePredicate title=\"New Pickup\" text=\"\'job_time_new\'\" check=vm.filterData.makePackageReverse>New Pickup</th><th style=\"width: 110px\" table-column-sorting current-text=vm.filterData.makePackagePredicate title=\"New Presentation\" text=\"\'job_dropoff_utc_new\'\" check=vm.filterData.makePackageReverse>New Present.</th><th style=\"width: 62px\" table-column-sorting current-text=vm.filterData.makePackagePredicate title=\"New ETA\" text=\"\'newEta\'\" check=vm.filterData.makePackageReverse>New ETA</th><th style=\"width: 37px\" table-column-sorting current-text=vm.filterData.makePackagePredicate title=Pax text=\"\'number_of_passangers\'\" check=vm.filterData.makePackageReverse>Pax</th><th style=\"width: 86px\" table-column-sorting current-text=vm.filterData.makePackagePredicate title=\"Pickup Location\" text=\"\'job_pickup_address\'\" ng-if=\"vm.filterData.unassignedBookingList[0].type_of_trip != \'Z\'\" check=vm.filterData.makePackageReverse>Pickup Location</th><th style=\"width: 86px\" table-column-sorting current-text=vm.filterData.makePackagePredicate title=\"Dropoff Location\" text=\"\'job_address\'\" ng-if=\"vm.filterData.unassignedBookingList[0].type_of_trip == \'Z\'\" check=vm.filterData.makePackageReverse>DropOff Location</th><th style=\"width: 94px\" table-column-sorting current-text=vm.filterData.unassignedPredicate title=\"Pickup Location\" text=\"\'job_pickup_address\'\" check=vm.filterData.unassignedReverse>Flight Number</th></tr></thead><tbody class=apps-container ui-sortable=vm.sortableOptions ng-model=vm.filterData.makePackageList><tr class=app ng-repeat=\"data in vm.filterData.makePackageList | orderBy:vm.filterData.makePackagePredicate:vm.filterData.makePackageReverse\" dnd-disable-if=\"data.job_status == 1 || data.job_status == 2\" ng-class=\"{\'shredServiceRed\': !data.is_valid_tolerance,\'shredServiceWhite\':data.is_valid_tolerance,\'not-sortable\': data.job_status == 1 || data.job_status == 2}\" ng-style=\"data.selected ? {\'background-color\': \'grey\'} : {}\" ng-attr-id=\"{{data.job_id + \'-\' + data.number_of_passangers}}\"><td style=width:61px><i class=\"fa fa-arrow-up\" style=\"font-size: 20px;color: #63d8f2\" ng-click=vm.click2(data,$index)></i></td><td hidden style=\"width: 61px\">{{$index + 1}}</td><td style=\"width: 50px\">#{{data.job_id}}</td><td style=\"width: 90px\">{{data.name}}</td><td style=\"width: 65px\">{{data.original_pickup_datetime | date:\'dd MMM, HH:mm\'}}</td><td style=\"width: 80px\">{{data.time_with_tolerance_before | date:\'HH:mm\'}} <span ng-if=\"data.is_group_external_new == 0\">- {{data.time_with_tolerance_after | date:\'HH:mm\'}}</span></td><td style=\"width: 95px\">{{data.original_delivery_datetime | date:\'dd MMM, HH:mm\'}}</td><td style=\"width: 46px\">{{data.original_eta}}</td><td style=\"width: 86px\">{{data.job_time_new | date:\'dd MMM, HH:mm\'}}</td><td style=\"width: 110px\">{{data.job_dropoff_utc_new | date:\'dd MMM, HH:mm\'}}</td><td style=\"width: 62px\">{{data.newEta}}</td><td style=\"width: 37px\">{{data.number_of_passangers}}</td><td style=\"width: 86px\" ng-if=\"data.type_of_trip != \'Z\'\">{{data.job_pickup_address}}</td><td style=\"width: 86px\" ng-if=\"data.type_of_trip == \'Z\'\">{{data.job_address}}</td><td style=\"width: 94px\" ng-if=\"data.flight_number == null\">--</td><td style=\"width: 94px\" ng-if=\"data.flight_number != null\">{{data.flight_number}}</td></tr></tbody></table></div></div><div class=\"row serviceDetails1\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12 serviceDetails2\"><p class=serviceDetails>Service #: {{vm.filterData.sharedServiceName}}</p></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12 serviceDetails2\"><p class=serviceDetails>Móvil Assigned: {{vm.filterData.vehicleAssigned}}</p></div></div><div class=\"row m0\" style=\"border-top: 2px solid #063c4a;padding-top:5px;padding-bottom: 5px\" ng-if=\"vm.filterData.makePackageList.length > 0 && !vm.filterData.modifyFlag\"><div class=\"col-lg-12 col-xs-12 col-ms-12 col-md-12 text-center\"><button type=button class=\"btn btn-primary\" ng-click=vm.saveGroupPackage()>SAVE</button> <button type=button class=\"btn btn-primary\" ng-click=vm.newPackage()>NEW</button></div></div><div class=\"row m0\" style=\"border-top: 2px solid #063c4a;padding-top:5px;padding-bottom: 5px\" ng-if=vm.filterData.modifyFlag><div class=\"col-lg-12 col-xs-12 col-ms-12 col-md-12 text-center\"><button type=button class=\"btn btn-primary\" ng-if=vm.filterData.modifyFlag ng-click=vm.saveModifyGroupPackage()>SAVE</button> <button type=button class=\"btn btn-primary\" ng-click=vm.newPackage()>NEW</button></div></div></div></div></div></div></div></div></div></div><style type=text/css>.labelsMap {\n        color: red;\n        background-color: cornsilk;\n        font-family: \"Lucida Grande\", \"Arial\", sans-serif;\n        font-size: 10px;\n        font-weight: bold;\n        text-align: center;\n        width: 40px;\n        white-space: nowrap;\n    }</style>");
$templateCache.put("app/components/views/grouped-route-assignment/groupedRouteAssignmentMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/help-documents/addHelpDocuments.html","<h2 class=ng-cloak>{{\'addNewDocuments\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-10 col-sm-12 col-xs-12 col-md-10 col-lg-offset-1 col-sm-offset-0 col-md-offset-1 col-xs-offset-0\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'addNewDocuments\' | translate}}</p><div class=basicDetailsDiv><form name=newDocumentForm ng-submit=\"submit=true;newDocumentForm.$valid&&vm.registerNewDocument()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-10 col-sm-12 col-xs-12 col-md-10 col-lg-offset-1 col-sm-offset-0 col-md-offset-1 col-xs-offset-0\"><label class=control-label>{{\'selectLanguage\' | translate}}</label><select class=form-control ng-model=vm.dataToFill.selectedLanguage name=language required ng-class=\"{\'has-error\': newDocumentForm.language.$touched && newDocumentForm.language.$invalid}\"><option value=\"\" selected disabled>{{\'selectLanguage\' | translate}}</option><option value=en>English</option><option value=es>Spanish</option></select><div ng-if=\"newDocumentForm.language.$touched || submit\" ng-messages=newDocumentForm.language.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'selectLanguageR\' | translate}}</div></div></div></div><div class=\"row mt10\"><div class=\"col-lg-10 col-sm-12 col-xs-12 col-md-10 col-lg-offset-1 col-sm-offset-0 col-md-offset-1 col-xs-offset-0\"><label class=control-label>{{\'userType\' | translate}}</label><select class=form-control ng-model=vm.dataToFill.userType name=userType required ng-class=\"{\'has-error\': newDocumentForm.userType.$touched && newDocumentForm.userType.$invalid}\"><option value=\"\" selected disabled>{{\'selectUserType\' | translate}}</option><option value=CUSTOMER>Customer</option><option value=DRIVER>Driver</option></select><div ng-if=\"newDocumentForm.userType.$touched || submit\" ng-messages=newDocumentForm.userType.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'selectUserTypeR\' | translate}}</div></div></div></div><div class=\"row mt10\"><div class=\"col-lg-10 col-sm-12 col-xs-12 col-md-10 col-lg-offset-1 col-sm-offset-0 col-md-offset-1 col-xs-offset-0\"><label class=control-label>{{\'documentType\' | translate}}</label><select class=form-control ng-model=vm.dataToFill.documentType name=typeDoc required ng-class=\"{\'has-error\': newDocumentForm.typeDoc.$touched && newDocumentForm.typeDoc.$invalid}\" ng-options=\"data.document_id as data.document_type for data in vm.dataToFill.documentTypes\"><option value=\"\" selected disabled>{{\'selectDocumentType\' | translate}}</option></select><div ng-if=\"newDocumentForm.typeDoc.$touched || submit\" ng-messages=newDocumentForm.typeDoc.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'selectDocumentTypeR\' | translate}}</div></div></div></div><div class=\"row mt10\"><div class=\"col-lg-10 col-sm-12 col-xs-12 col-md-10 col-lg-offset-1 col-sm-offset-0 col-md-offset-1 col-xs-offset-0\"><label class=control-label>{{\'nameDocument\' | translate}}</label><input type=text class=form-control ng-model=vm.dataToFill.documentName name=nameDoc placeholder=\"{{\'nameDocument\' | translate}}\" required ng-class=\"{\'has-error\': newDocumentForm.nameDoc.$touched && newDocumentForm.nameDoc.$invalid}\"><div ng-if=\"newDocumentForm.nameDoc.$touched || submit\" ng-messages=newDocumentForm.nameDoc.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'nameDocumentR\' | translate}}</div></div></div></div><div class=\"row mt10\"><div class=\"col-lg-10 col-sm-12 col-xs-12 col-md-10 col-lg-offset-1 col-sm-offset-0 col-md-offset-1 col-xs-offset-0\"><label class=control-label>{{\'documentOnly\' | translate}}</label><text-angular ng-model=vm.dataToFill.notes name=document required ng-class=\"{\'has-error\': newDocumentForm.document.$touched && newDocumentForm.document.$invalid}\"></text-angular><div ng-if=\"newDocumentForm.document.$touched || submit\" ng-messages=newDocumentForm.document.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'nameDocumentDR\' | translate}}</div></div></div></div><div class=\"row mt25\"><div class=\"col-lg-10 col-sm-12 col-xs-12 col-md-10 col-lg-offset-1 col-sm-offset-0 col-md-offset-1 col-xs-offset-0 text-center\"><button class=\"btn btn-primary\" type=submit>Submit</button></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/help-documents/helpDocuments.html","<h2 class=ng-cloak>{{\'helpDocuments\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-3 col-sm-6 col-md-4 col-xs-6\"><label class=control-label>{{\'selectLanguage\' | translate}}</label><select class=form-control ng-model=vm.dataToFill.selectedLanguage ng-change=vm.getAllDocuments()><option value=\"\" disabled>{{\'selectLanguage\' | translate}}</option><option value=en>English</option><option value=es>Spanish</option></select></div><div class=\"col-lg-3 col-sm-6 col-md-4 col-xs-6\"><label class=control-label>{{\'userType\' | translate}}</label><select class=form-control ng-model=vm.dataToFill.userType ng-change=vm.getAllDocuments()><option value=\"\" disabled>{{\'selectUserType\' | translate}}</option><option value=CUSTOMER>Customer</option><option value=DRIVER>Driver</option></select></div><div class=\"col-lg-4 col-sm-6 col-md-4 col-xs-6 col-lg-offset-2 col-sm-offset-0 col-md-offset-4 col-xs-offset-0 text-right\"><a class=\"btn btn-primary mb10 mt10\" ui-sref=layout.helpDocMain.addHelpDocs>+ {{\'addNewDocuments\' | translate}}</a></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\" ng-if=\"vm.dataToFill.documentList.length == 0\"><p><b>No document available.</b></p></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" ng-repeat=\"data in vm.dataToFill.documentList\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{data.document_name}} <span class=pull-right><a type=button class=\"btn btn-primary tableButton\" ui-sref=layout.helpDocMain.editHelpDocs({lang:vm.dataToFill.selectedLanguage,userType:vm.dataToFill.userType,type:data.document_type})>{{\'updateOnly\' | translate}}</a></span></p><div class=basicDetailsDiv><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><!--<textarea class=\"form-control helpTextArea\" ng-model=\"data.html_data\" readonly ></textarea>--><div class=\"form-control helpTextArea\" ng-bind-html=data.html_data></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/help-documents/helpDocumentsMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/help-documents/updateHelpDocuments.html","<h2 class=ng-cloak>{{\'updateDocumentsOnly\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-10 col-sm-12 col-xs-12 col-md-10 col-lg-offset-1 col-sm-offset-0 col-md-offset-1 col-xs-offset-0\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'updateDocumentsOnly\' | translate}}</p><div class=basicDetailsDiv><form name=updateDocumentForm ng-submit=\"submit=true;updateDocumentForm.$valid&&vm.updateDocumentApi()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-10 col-sm-12 col-xs-12 col-md-10 col-lg-offset-1 col-sm-offset-0 col-md-offset-1 col-xs-offset-0\"><label class=control-label>{{\'selectLanguage\' | translate}}</label><select class=form-control ng-model=vm.dataToFill.selectedLanguage name=language ng-disabled=true required ng-class=\"{\'has-error\': updateDocumentForm.language.$touched && updateDocumentForm.language.$invalid}\"><option value=\"\" disabled>{{\'selectLanguage\' | translate}}</option><option value=en>English</option><option value=es>Spanish</option></select><div ng-if=\"updateDocumentForm.language.$touched || submit\" ng-messages=updateDocumentForm.language.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'selectLanguageR\' | translate}}</div></div></div></div><div class=\"row mt10\"><div class=\"col-lg-10 col-sm-12 col-xs-12 col-md-10 col-lg-offset-1 col-sm-offset-0 col-md-offset-1 col-xs-offset-0\"><label class=control-label>{{\'userType\' | translate}}</label><select class=form-control ng-model=vm.dataToFill.userType name=userType required ng-disabled=true ng-class=\"{\'has-error\': updateDocumentForm.userType.$touched && updateDocumentForm.userType.$invalid}\"><option value=\"\" disabled>{{\'selectUserType\' | translate}}</option><option value=CUSTOMER>Customer</option><option value=DRIVER>Driver</option></select><div ng-if=\"updateDocumentForm.userType.$touched || submit\" ng-messages=updateDocumentForm.userType.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'selectUserTypeR\' | translate}}</div></div></div></div><div class=\"row mt10\"><div class=\"col-lg-10 col-sm-12 col-xs-12 col-md-10 col-lg-offset-1 col-sm-offset-0 col-md-offset-1 col-xs-offset-0\"><label class=control-label>{{\'documentType\' | translate}}</label><select class=form-control ng-model=vm.dataToFill.documentType name=typeDoc ng-disabled=true required ng-class=\"{\'has-error\': updateDocumentForm.typeDoc.$touched && updateDocumentForm.typeDoc.$invalid}\" ng-options=\"data.document_type as data.document_type for data in vm.dataToFill.documentTypes\"><option value=\"\" selected disabled>{{\'selectDocumentType\' | translate}}</option></select><div ng-if=\"updateDocumentForm.typeDoc.$touched || submit\" ng-messages=updateDocumentForm.typeDoc.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'selectDocumentTypeR\' | translate}}</div></div></div></div><div class=\"row mt10\"><div class=\"col-lg-10 col-sm-12 col-xs-12 col-md-10 col-lg-offset-1 col-sm-offset-0 col-md-offset-1 col-xs-offset-0\"><label class=control-label>{{\'nameDocument\' | translate}}</label><input type=text class=form-control ng-model=vm.dataToFill.documentName name=nameDoc placeholder=\"{{\'nameDocument\' | translate}}\" readonly required ng-class=\"{\'has-error\': updateDocumentForm.nameDoc.$touched && updateDocumentForm.nameDoc.$invalid}\"><div ng-if=\"updateDocumentForm.nameDoc.$touched || submit\" ng-messages=updateDocumentForm.nameDoc.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'nameDocumentR\' | translate}}</div></div></div></div><div class=\"row mt10\"><div class=\"col-lg-10 col-sm-12 col-xs-12 col-md-10 col-lg-offset-1 col-sm-offset-0 col-md-offset-1 col-xs-offset-0\"><label class=control-label>{{\'documentOnly\' | translate}}</label><text-angular ng-model=vm.dataToFill.notes name=document required ng-class=\"{\'has-error\': updateDocumentForm.document.$touched && updateDocumentForm.document.$invalid}\"></text-angular><div ng-if=\"updateDocumentForm.document.$touched || submit\" ng-messages=updateDocumentForm.document.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'nameDocumentDR\' | translate}}</div></div></div></div><div class=\"row mt25\"><div class=\"col-lg-10 col-sm-12 col-xs-12 col-md-10 col-lg-offset-1 col-sm-offset-0 col-md-offset-1 col-xs-offset-0 text-center\"><button class=\"btn btn-primary\" type=submit>Submit</button></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/home-screen/homeScreen.html","<h2 class=ng-cloak>Bienvenido al Sistema Enlace</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row ng-if=vm.isActive><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"height: 100vh\" ng-if=!vm.userType><iframe id=iframeNormal style=\"width: 100%; height: -webkit-fill-available\" src=https://wordpress.transvip.cl/wp-content/uploads/2022/05/MAPA-T1-T2-2-790x1024.jpg></iframe></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"height: 100vh\" ng-if=vm.userType><iframe id=iframePet style=\"width: 100%; height: -webkit-fill-available\" src=https://transportecorporativo.transvip.cl></iframe></div></div></div></div></div>");
$templateCache.put("app/components/views/home-screen/homeScreenMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/illuminated-zone-services/illuminatedZoneServiceLog.html","<h2 class=ng-cloak><span>Historial zona iluminada</span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label class=control-label>Branch</label><ui-select ng-model=vm.dataToFill.branchId name=branch ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=Branch>{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\" ng-if=vm.dataToFill.showRegions><label class=control-label>Regiones iluminadas</label><ui-select ng-model=vm.dataToFill.iluuminatedId name=illuminatedRegions required close-on-select=true ng-change=vm.regionChanged()><ui-select-match placeholder=\"Regiones iluminadas\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"region.region_id as region in vm.illuminatedRegionList | filter: $select.search | orderBy:\'region_name\' \"><div ng-bind-html=region.region_name></div></ui-select-choices></ui-select></div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center mt10\"><!--ng-if=\"vm.dataToFill.iluuminatedId\"--><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\" ng-switch=\"(vm.driverList | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><!--ng-switch-default--><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Sr. No.</th><th style=width:125px table-column-sorting current-text=vm.predicate title=Vehículo text=\"\'car_id\'\" check=vm.reverse>Id Unique Car</th><th style=width:100px table-column-sorting current-text=vm.predicate title=Conductor text=\"\'branch_name\'\" check=vm.reverse>Branch</th><th style=width:125px table-column-sorting current-text=vm.predicate title=Entrada text=\"\'region_name\'\" check=vm.reverse>Illuminated Zone</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"con Pax\" text=\"\'flag\'\" check=vm.reverse>Operation</th><th style=width:125px table-column-sorting current-text=vm.predicate title=Acción text=\"\'flag\'\" check=vm.reverse>Acción</th><th style=width:125px table-column-sorting current-text=vm.predicate title=Usuario text=\"\'flag\'\" check=vm.reverse>Usuario</th><th style=width:125px table-column-sorting current-text=vm.predicate title=Pax text=\"\'entry_time\'\" check=vm.reverse>Date & Time</th><th style=width:100px table-column-sorting current-text=vm.predicate title=Pax text=\"\'position\'\" check=vm.reverse>Posicion</th><th style=width:100px table-column-sorting current-text=vm.predicate title=Pax text=\"\'job_id\'\" check=vm.reverse>Id Booking</th><th style=width:125px table-column-sorting current-text=vm.predicate title=Pax text=\"\'total_passengers\'\" check=vm.reverse>Total Passenger</th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.driverList | filter: vm.search | orderBy:vm.predicate:vm.reverse\"><!--| filter:vm.search--><td style=width:70px hidden>{{::data.index + 1}}</td><td style=width:125px>{{::data.car_id}}</td><td style=width:100px>{{::data.branch_name}}</td><td style=width:125px>{{::data.region_name}}</td><td style=width:125px><span ng-if=\"data.flag == 1\">OUT</span> <span ng-if=\"data.flag == 0\">IN</span></td><td style=width:125px>{{data.action == 0 ? \'Sistemica\' : \'Manual\' }}</td><td style=width:125px>{{data.email ? data.email : \'--\' }}</td><td style=width:125px>{{data.entry_time | date:\'dd MMM yyyy, HH:mm\'}}hrs</td><td style=width:100px>{{::data.position || \'--\'}}</td><td style=width:100px><span ng-if=data.job_id>#{{::data.job_id}}</span> <span ng-if=!data.job_id>--</span></td><td style=width:125px>{{::data.total_passengers || \'0\'}}</td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noDriverFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav>--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\" ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/illuminated-zone-services/illuminatedZoneServiceLogMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/illuminated-zone-services/illuminatedZoneServices.html","<h2 class=ng-cloak><span>Zona iluminada</span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label class=control-label>Branch</label><ui-select ng-model=vm.dataToFill.branchId name=branch ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=Branch>{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\" ng-if=vm.dataToFill.showRegions><label class=control-label>Regiones iluminadas</label><ui-select ng-model=vm.dataToFill.iluuminatedId name=illuminatedRegions required close-on-select=true ng-change=vm.regionChanged()><ui-select-match placeholder=\"Regiones iluminadas\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"region.region_id as region in vm.illuminatedRegionList | filter: $select.search | orderBy:\'region_name\' \"><div ng-bind-html=region.region_name></div></ui-select-choices></ui-select></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\" style=\"margin-top: 23px;float: right\" ng-if=vm.dataToFill.showServiceType><button type=button class=\"btn btn-primary\" ng-click=vm.VerifyMaunalButton($event)>Agregar</button></div></div></div><div class=\"row mt10\" ng-if=vm.dataToFill.showServiceType><!-- <div class=\"col-lg-2 col-sm-2 col-md-2 col-xs-2\" ng-click=\"vm.activeButton($index,service)\" ng-repeat=\"service in vm.illuminatedVehicles\">\n                        <div class=\"div-border mt5\" ng-class=\"{\'selectedDiv\': vm.dataToFill.isDivSelected == $index}\">\n                            <div class=\"text-center\">\n                                <h4>{{service.service_name}}</h4>\n                            </div>\n                            <div class=\"text-center\">\n                                <img src=\"{{service.service_image || \'assets/images/car-placeholder.png\'}}\" alt=\"Image\" class=\"vehicle-image\" />\n                            </div>\n                            <div class=\"text-center\">\n                                <h4>{{service.count}}</h4>\n                            </div>\n                        </div>\n                    </div> --><div class=\"col-lg-2 col-sm-2 col-md-2 col-xs-2\" ng-repeat=\"vehicles in vm.illuminatedVehicles\"><div class=illuminatedServices><a class=servieSales title={{vehicles.name}} ng-class=\"{\'activeServices\': vm.dataToFill.isDivSelected == $index}\" ng-click=vm.activeButton($index,service)><span>{{vehicles.name}}</span><br><img ng-src=\"{{vehicles.vehicle_image || \'assets/images/noImage.jpeg\'}}\"><br><span>{{vehicles.count}}</span></a></div></div></div><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center mt10\" ng-if=\"vm.dataToFill.vehicleId\">--><!--<h1></h1>--><!--</div>--><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center mt10\"><!--ng-if=\"vm.illuminatedVehicles.length\"--><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\" ng-switch=\"(vm.driverList | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><!--ng-switch-default--><thead><tr><th style=width:125px table-column-sorting current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Posición</th><th style=width:125px table-column-sorting current-text=vm.predicate title=Vehículo text=\"\'unique_car_id\'\" check=vm.reverse>Vehículo</th><th style=width:125px table-column-sorting current-text=vm.predicate title=Conductor text=\"\'fleet_name\'\" check=vm.reverse>Conductor</th><th style=width:125px table-column-sorting current-text=vm.predicate title=Entrada text=\"\'entry_time\'\" check=vm.reverse>Entrada</th><th style=width:125px table-column-sorting current-text=vm.predicate title=Acción text=\"\'unique_car_id\'\" check=vm.reverse>Acción</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"con Pax\" text=\"\'unique_car_id\'\" check=vm.reverse>con Pax</th><th style=width:125px table-column-sorting current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Pax</th><th style=width:125px table-column-sorting current-text=vm.predicate title=AcciónDelete text=\"\'unique_car_id\'\" check=vm.reverse>Acción</th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.driverList | filter: vm.search | orderBy:vm.predicate:vm.reverse\"><!--| filter:vm.search--><td style=width:125px>{{::data.index + 1}}</td><td style=width:125px>{{::data.unique_car_id}}</td><td style=width:125px>{{::data.fleet_name}}</td><td style=width:125px>{{data.entry_time | date:\'dd/MM HH:mm\'}}</td><td style=width:125px>{{data.action == 0 ? \'Sistemica\' : \'Manual\' }}</td><td style=width:125px>{{data.passenger_entry_time_formatted }}</td><td style=width:125px>{{data.total_passengers || \'0\'}}</td><td style=width:125px><a class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteDriver(data.fleet_id,$event)><i class=\"fa fa-trash\"></i></a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noDriverFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav>--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\" ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/illuminated-zone-services/illuminatedZoneServicesMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/illuminated-zone-services/illuminatedZoneServicesNewPage.html","<h2 class=ng-cloak><span>Cantidad máxima de vehículos por Horario</span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label class=control-label>Branch</label><ui-select ng-model=vm.dataToFill.branchId name=branch ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=Branch>{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\" ng-if=\"vm.dataToFill.showRegions && vm.illuminatedRegionList.length > 0\"><label class=control-label>Regiones iluminadas</label><ui-select ng-model=vm.dataToFill.iluuminatedId name=illuminatedRegions required close-on-select=true ng-change=vm.regionChanged()><ui-select-match placeholder=\"Regiones iluminadas\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"region.region_id as region in vm.illuminatedRegionList | filter: $select.search | orderBy:\'region_name\' \"><div ng-bind-html=region.region_name></div></ui-select-choices></ui-select></div><!-- <div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\" style=\"margin-top: 23px;float: right;\" ng-if=\"vm.dataToFill.showServiceType\">\n                            <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.VerifyMaunalButton($event)\">\n                                Agregar\n                            </button>\n                        </div> --></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt10\"><nav ng-if=vm.restrictionsArray.length><div class=\"nav nav-tabs\" id=nav-tab role=tablist><a ng-repeat=\"data in vm.illuminatedVehicles\" ng-class=\"{\'active\': vm.dataToFill.isDivSelected == $index}\" class=\"nav-item nav-link\" ng-click=vm.selectedTab(data,$index) id=nav-home-tab data-toggle=tab role=tab aria-controls=nav-home aria-selected=true>{{data.name}}<div class=divClassNav></div></a></div></nav><div class=\"panel panel-default\" ng-if=vm.restrictionsArray.length ng-style=vm.flagForCssNew><div ng-if=vm.restrictionsChangeFlag style=\"margin-top: 15px\"><span class=modifyName>Modificar</span><div class=diaMainDiv><span style=\"font-weight: bold\">Dia</span> <span style=\"margin-left: 63px;font-weight: bold\">Hora</span> <span style=\"margin-left: 50px;font-weight: bold\">Restricción</span></div><div class=diaMainDiv><input disabled ng-model=vm.weekDay style=width:90px> <input disabled ng-model=vm.hourDay style=width:90px> <input is-number=\"\" ng-model=vm.restrictionValue ng-style=vm.flagToShowCss ng-keyup=vm.changeValue() style=width:101px></div><span class=butttonSpan><button type=button class=grabarButton ng-click=vm.sumbitGrabar()>Grabar</button></span></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt10\"><div style=\"margin-top: 20px\" class=\"table-responsive tableWithMasterDataParentDive\" ng-switch=\"(vm.driverList | filter:vm.search).length\"><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=width:125px current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Hora</th><th style=width:125px current-text=vm.predicate title=Vehículo text=\"\'unique_car_id\'\" check=vm.reverse>Lunes</th><th style=width:125px current-text=vm.predicate title=Conductor text=\"\'fleet_name\'\" check=vm.reverse>Martes</th><th style=width:125px current-text=vm.predicate title=Entrada text=\"\'entry_time\'\" check=vm.reverse>Miércoles</th><th style=width:125px current-text=vm.predicate title=Acción text=\"\'unique_car_id\'\" check=vm.reverse>Jueves</th><th style=width:125px current-text=vm.predicate title=\"con Pax\" text=\"\'unique_car_id\'\" check=vm.reverse>Viernes</th><th style=width:125px current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Sábado</th><th style=width:125px current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Domingo</th></tr></thead><tbody><tr ng-repeat=\"data in  vm.hoursArray\"><!--| filter:vm.search--><td id=darkGrey style=width:125px>{{::data.value}}</td><td style=width:125px ng-class=\"{\'red-color\': vm.restrictionsArray[0][data.id] > 0}\" ng-click=\"vm.restrictionsChange(vm.restrictionsArray[0],data,\'Lunes\')\">{{vm.restrictionsArray[0][data.id]}}</td><td style=width:125px ng-class=\"{\'red-color\': vm.restrictionsArray[1][data.id] > 0}\" ng-click=\"vm.restrictionsChange(vm.restrictionsArray[1],data,\'Martes\')\">{{vm.restrictionsArray[1][data.id]}}</td><td style=width:125px ng-class=\"{\'red-color\': vm.restrictionsArray[2][data.id] > 0}\" ng-click=\"vm.restrictionsChange(vm.restrictionsArray[2],data,\'Miércoles\')\">{{vm.restrictionsArray[2][data.id]}}</td><td style=width:125px ng-class=\"{\'red-color\': vm.restrictionsArray[3][data.id] > 0}\" ng-click=\"vm.restrictionsChange(vm.restrictionsArray[3],data,\'Jueves\')\">{{vm.restrictionsArray[3][data.id]}}</td><td style=width:125px ng-class=\"{\'red-color\': vm.restrictionsArray[4][data.id] > 0}\" ng-click=\"vm.restrictionsChange(vm.restrictionsArray[4],data,\'Viernes\')\">{{vm.restrictionsArray[4][data.id]}}</td><td style=width:125px ng-class=\"{\'red-color\': vm.restrictionsArray[5][data.id] > 0}\" ng-click=\"vm.restrictionsChange(vm.restrictionsArray[5],data,\'Sábado\')\">{{vm.restrictionsArray[5][data.id]}}</td><td style=width:125px ng-class=\"{\'red-color\': vm.restrictionsArray[6][data.id] > 0}\" ng-click=\"vm.restrictionsChange(vm.restrictionsArray[6],data,\'Domingo\')\">{{vm.restrictionsArray[6][data.id]}}</td></tr></tbody></table></div></div></div></div></div></div></div></div><style>.panel {\n        /* height: 600px; */\n        /* margin-bottom: 20px; */\n        background-color: #fff;\n        border-left: 1px solid black;\n        border-right: 1px solid black;\n        border-bottom: 1px solid black;\n        margin-top: 0px;\n        border-radius: 4px;\n        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n    }\n\n    table,\n    th,\n    td {\n        border: 1px solid grey;\n        border-collapse: collapse;\n        padding: 5px;\n    }\n\n    table tr:nth-child(odd) {\n        background-color: #d4cfcf;\n        ;\n    }\n\n    #darkGrey {\n        background-color: #d4cfcf;\n        font-weight: bold;\n    }\n\n    .table-hover>tbody>tr:nth-child(odd) {\n        background-color: #ffffff;\n    }\n\n    .table-hover>tbody>tr:nth-child(even) {\n        background-color: #ffffff;\n    }\n\n    table tr:nth-child(even) {\n        background-color: #ffffff;\n    }\n\n    .tableWithMasterData thead {\n        width: calc( 100% - 0.5em);\n    }\n\n    .modifyName {\n        font-size: 30px;\n        font-weight: bold;\n        margin-left: 15px;\n    }\n\n    .diaMainDiv {\n        margin-left: 15px;\n        font-size: 18px;\n        font-weight: 530;\n    }\n\n    .grabarButton {\n        height: 54px;\n        width: 200px;\n        text-align: center;\n        background-color: #70AD46;\n        font-size: 20px;\n        font-weight: 400;\n        color: black;\n        font-weight: bold;\n    }\n\n    .butttonSpan {\n        position: absolute;\n        left: 350px;\n        top: 100px;\n    }\n\n    .nav-tabs .nav-item.show .nav-link,\n    .nav-tabs .nav-link.active {\n        text-align: center;\n        height: 40px;\n        line-height: 2;\n        font-size: 18px;\n        position: relative;\n        font-weight: bold;\n        text-decoration: underline;\n        width: 150px;\n        color: orange;\n        background-color: #fff;\n        border-left: 1px solid black;\n        border-right: 1px solid black;\n        border-top: 1px solid black;\n        /* border-color: #dee2e6 #dee2e6 #fff; */\n    }\n\n    .nav-tabs .nav-link {\n        border: 1px solid transparent;\n        border-top-left-radius: .25rem;\n        border-top-right-radius: .25rem;\n        color: #888888;\n        text-decoration: none;\n        background-color: transparent;\n        height: 40px;\n        line-height: 2;\n        font-size: 18px;\n        font-weight: bold;\n        width: 150px;\n        text-align: center;\n    }\n\n\n    .nav {\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n        padding-left: 0;\n        margin-bottom: 0;\n        list-style: none;\n    }\n\n    article,\n    aside,\n    figcaption,\n    figure,\n    footer,\n    header,\n    hgroup,\n    main,\n    nav,\n    section {\n        display: block;\n    }\n\n    .nav-tabs {\n        border-bottom: 1px solid black;\n    }\n\n    .bd-example-tabs .nav-tabs {\n        margin-bottom: 1rem;\n    }\n\n    .divClassNav {\n        min-width: 100%;\n        border: 2px solid #fff;\n        position: absolute;\n        bottom: -5px;\n    }\n\n    .red-color {\n        color: red;\n        font-weight: bold;\n    }</style>");
$templateCache.put("app/components/views/illuminated-zone-services/illuminatedZoneServicesNewPageMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/item-of-charge/itemOfChargeList.html","<h2 class=ng-cloak>{{\'itemChargeHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=padding:0px><div class=basicDiv ng-if=vm.addItemFlag><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'addItemsHead\' | translate}}</p><form name=addItemForm ng-submit=\"submit=true;addItemForm.$valid&&vm.addItemsHit()\" novalidate autocomplete=off><div class=row style=\"padding:0px 10px;margin-bottom:5px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'longName\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.long_name name=longName placeholder=\"{{\'longName\' | translate}}\" required ng-maxlength=60 ng-minlength=3 ng-class=\"{ \'has-error\': addItemForm.longName.$touched && addItemForm.longName.$invalid }\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\"addItemForm.longName.$touched|| submit\" ng-messages=addItemForm.longName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'longNameReq\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid fixed route  name.</div>--><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'firstNameMaximum\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'shortName\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.short_name name=shortName placeholder=\"{{\'shortName\' | translate}}\" required ng-maxlength=60 ng-class=\"{ \'has-error\': addItemForm.shortName.$touched && addItemForm.shortName.$invalid }\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\"addItemForm.shortName.$touched|| submit\" ng-messages=addItemForm.shortName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'shortNameReq\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid fixed route  name.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"minlength\">Minimum 3 characters are required.</div>--><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'firstNameMaximum\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'modeLabel\' | translate}}<span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.mode name=mode required ng-class=\"{ \'has-error\': addItemForm.mode.$touched && addItemForm.mode.$invalid }\"><option value=\"\" disabled selected>{{\'modePlaceholder\' | translate}}</option><option value=1>By Quantity</option><option value=0>By Value</option></select><div ng-if=\"addItemForm.mode.$touched|| submit\" ng-messages=addItemForm.mode.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'modeReq\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'manualLabel\' | translate}}<span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.manually name=manualEntry required ng-class=\"{ \'has-error\': addItemForm.manualEntry.$touched && addItemForm.manualEntry.$invalid }\"><option value=\"\" disabled selected>{{\'manualPlaceholder\' | translate}}</option><option value=1>For Call Center</option><option value=0>For Driver</option></select><div ng-if=\"addItemForm.manualEntry.$touched|| submit\" ng-messages=addItemForm.manualEntry.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'manualReq\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'driverEarningItem\' | translate}}<span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.driverEarningSelected name=driverEarning ng-options=\"data.id as data.value for data in vm.dataToFill.driverEarning\" required ng-class=\"{ \'has-error\': addItemForm.driverEarning.$touched && addItemForm.driverEarning.$invalid }\"><option value=\"\" disabled selected>{{\'driverEarningItemSelect\' | translate}}</option></select><div ng-if=\"addItemForm.manualEntry.$touched|| submit\" ng-messages=addItemForm.manualEntry.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'driverEarningItemR\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'description\' | translate}}</label><textarea class=form-control ng-model=vm.dataToFill.description placeholder=\"{{\'messagePlaceholder\' | translate}}\" style=\"height: 100px\"></textarea></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5 text-center\"><button class=\"btn btn-primary\" type=submit style=width:40%>{{\'submit\' | translate}}</button> <button class=\"btn btn-danger\" type=button style=width:40% ng-click=vm.cancelEdit()>{{\'cancelButton\' | translate}}</button></div></div></form></div><div class=basicDiv ng-if=vm.editItemOfChargeFlag><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'editItemHead\' | translate}}</p><form name=editItemForm ng-submit=\"submit=true;editItemForm.$valid&&vm.editApi()\" novalidate autocomplete=off><div class=row style=\"padding:0px 10px;margin-bottom:5px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'longName\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.long_name name=longName placeholder=\"{{\'longName\' | translate}}\" required ng-maxlength=60 ng-minlength=3 ng-class=\"{ \'has-error\': editItemForm.longName.$touched && editItemForm.longName.$invalid }\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\"editItemForm.longName.$touched|| submit\" ng-messages=editItemForm.longName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'longNameReq\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid fixed route  name.</div>--><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'lastNameMaximum\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'shortName\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.short_name name=shortName placeholder=\"{{\'shortName\' | translate}}\" required ng-maxlength=60 ng-class=\"{ \'has-error\': editItemForm.shortName.$touched && editItemForm.shortName.$invalid }\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\"editItemForm.shortName.$touched|| submit\" ng-messages=editItemForm.shortName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'shortNameReq\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid fixed route  name.</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"minlength\">Minimum 3 characters are required.</div>--><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'firstNameMaximum\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'modeLabel\' | translate}}<span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.mode name=mode required ng-class=\"{ \'has-error\': editItemForm.mode.$touched && editItemForm.mode.$invalid }\"><option value=\"\" disabled selected>{{\'modePlaceholder\' | translate}}</option><option value=1>By Quantity</option><option value=0>By Value</option></select><div ng-if=\"editItemForm.mode.$touched|| submit\" ng-messages=editItemForm.mode.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'modeReq\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'manualLabel\' | translate}}<span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.manually name=manualEntry required ng-class=\"{ \'has-error\': editItemForm.manualEntry.$touched && editItemForm.manualEntry.$invalid }\"><option value=\"\" disabled selected>{{\'manualPlaceholder\' | translate}}</option><option value=1>For Call Center</option><option value=0>For Driver</option></select><div ng-if=\"editItemForm.manualEntry.$touched|| submit\" ng-messages=editItemForm.manualEntry.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'manualReq\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'driverEarningItem\' | translate}}<span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.driverEarningSelected name=driverEarning ng-options=\"data.id as data.value for data in vm.dataToFill.driverEarning\" required ng-class=\"{ \'has-error\': editItemForm.driverEarning.$touched && editItemForm.driverEarning.$invalid }\"><option value=\"\" disabled selected>{{\'driverEarningItemSelect\' | translate}}</option></select><div ng-if=\"editItemForm.manualEntry.$touched|| submit\" ng-messages=editItemForm.manualEntry.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'driverEarningItemR\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'description\' | translate}}</label><textarea class=form-control ng-model=vm.dataToFill.description placeholder=\"{{\'messagePlaceholder\' | translate}}\" style=\"height: 100px\"></textarea></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5 text-center\"><button class=\"btn btn-primary\" type=submit style=width:40%>{{\'submit\' | translate}}</button> <button class=\"btn btn-danger\" type=button style=width:40% ng-click=vm.cancelEdit()>{{\'cancelButton\' | translate}}</button></div></div></form></div><div class=basicDiv ng-if=vm.viewItemOfChargeFlag><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'viewItemHead\' | translate}}</p><div class=row style=\"padding:0px 10px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'longName\' | translate}}:</label><div class=\"form-control text-capitalize\">{{::vm.itemLongName}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'shortName\' | translate}}:</label><div class=\"form-control text-capitalize\">{{::vm.itemShortName}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'id\' | translate}}:</label><div class=\"form-control text-capitalize\">{{::vm.itemID}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'modeLabel\' | translate}}:</label><div class=\"form-control text-capitalize\"><span ng-if=\"vm.itemMode == 1\">By Quantity</span> <span ng-if=\"vm.itemMode == 0\">By Value</span></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'manualLabel\' | translate}}:</label><div class=\"form-control text-capitalize\"><span ng-if=\"vm.itemManually == 1\">For Call Center</span> <span ng-if=\"vm.itemManually == 0\">For Driver</span></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'driverEarningItem\' | translate}}:</label><div class=\"form-control text-capitalize\"><span ng-if=\"vm.driverEarning == 2\">{{\'accToList\' | translate}}</span> <span ng-if=\"vm.driverEarning == 1\">{{\'100Percent\' | translate}}</span> <span ng-if=\"vm.driverEarning == 0\">{{\'0Percent\' | translate}}</span></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'status\' | translate}}:</label><div class=\"form-control text-capitalize\"><span ng-if=\"vm.itemState == 1\">Active</span> <span ng-if=\"vm.itemState == 0\">Inactive</span></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'description\' | translate}}:</label><textarea class=form-control ng-model=vm.itemDescription placeholder=\"No Description\" readonly></textarea></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5 text-center\"><button class=\"btn btn-primary\" type=button ng-click=vm.goBack() style=width:40%>{{\'goBack\' | translate}}</button></div></div></div></div></div></div><div class=\"col-lg-8 col-sm-8 col-md-8 col-xs-12\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-lg-4 col-sm-6 col-md-4 col-xs-12\"><label class=control-label>{{\'statusLabel\' | translate}}</label><select class=form-control ng-model=vm.filterData.itemStatus ng-change=\"vm.getAllItemOfCharges(0,vm.itemsPerPageGot,vm.filterData.itemStatus);vm.currentPage = 0;\"><option value=\"\" disabled>{{\'statusPlaceholder\' | translate}}</option><option selected value=1>Active</option><option value=0>Inactive</option><option value=2>All</option></select></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt5 text-center\"><p class=totalSize><span>{{\'totalItems\' | translate}}: {{vm.totalItemOfCharge}}</span></p></div><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\" ng-switch=\"(vm.carsList | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=\"width: 106px\" table-column-sorting current-text=vm.predicate title=\"{{\'longName\' | translate}}\" text=\"\'long_name\'\" check=vm.reverse>{{\'longName\' | translate}}</th><th style=\"width: 106px\" table-column-sorting current-text=vm.predicate title=\"{{\'shortName\' | translate}}\" text=\"\'short_name\'\" check=vm.reverse>{{\'shortName\' | translate}}</th><th style=\"width: 106px\" table-column-sorting current-text=vm.predicate title=\"{{\'description\' | translate}}\" text=\"\'description\'\" check=vm.reverse>{{\'description\' | translate}}</th><th style=\"width: 106px\" table-column-sorting current-text=vm.predicate title=\"{{\'modeLabel\' | translate}}\" text=\"\'mode\'\" check=vm.reverse>{{\'modeLabel\' | translate}}</th><th style=\"width: 106px\" table-column-sorting current-text=vm.predicate title=\"{{\'manualCall\' | translate}}\" text=\"\'manually\'\" check=vm.reverse>{{\'manualCall\' | translate}}</th><th style=\"width: 106px\" table-column-sorting current-text=vm.predicate title=\"{{\'manualDriver\' | translate}}\" text=\"\'manually\'\" check=vm.reverse>{{\'manualDriver\' | translate}}</th><th style=\"width: 106px\" table-column-sorting current-text=vm.predicate title=\"{{\'driverEarningItem\' | translate}}\" text=\"\'driver_earnings\'\" check=vm.reverse>{{\'driverEarningItem\' | translate}}</th><th style=width:100px><div class=text-center>{{\'stateTable\' | translate}}</div></th><th style=\"width: 150px\"><div class=text-center>{{\'action\' | translate}}</div></th><th style=\"width: 150px\"><div class=text-center>{{\'adminLogs\' | translate}}</div></th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.itemOfChargeListGot| filter:vm.search | orderBy:vm.predicate:vm.reverse\"><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:70px>{{::data.id}}</td><td style=width:106px>{{::data.long_name}}</td><td style=width:106px>{{::data.short_name}}</td><td style=width:106px>{{::data.description}}</td><td style=width:106px><span ng-if=\"data.mode == \'1\'\">By Quantity</span> <span ng-if=\"data.mode == \'0\'\">By Value</span></td><td style=width:106px><span ng-if=\"data.manually == \'1\'\">Yes</span> <span ng-if=\"data.manually == \'0\'\">No</span></td><td style=width:106px><span ng-if=\"data.manually == \'1\'\">No</span> <span ng-if=\"data.manually == \'0\'\">Yes</span></td><td style=width:106px><span ng-if=\"data.driver_earnings == 2\">{{\'accToList\' | translate}}</span> <span ng-if=\"data.driver_earnings == 1\">{{\'100Percent\' | translate}}</span> <span ng-if=\"data.driver_earnings == 0\">{{\'0Percent\' | translate}}</span></td><td style=width:100px><a class=\"cursor btn btn-sm\" ng-class=\"{\'blockIconColor\': data.state == 0, \'unblockIconColor\': data.state == 1}\" ng-click=vm.blockUnblockItemOfCharge($event,data.id,data.state)><i ng-class=\"{\'fa fa-unlock\': data.state == 1,\'fa fa-lock\': data.state == 0}\"></i></a></td><td style=width:150px><a title=\"Edit Details\" class=\"cursor editIconColor btn btn-sm\" ng-click=\"data.id == \'2\' ? vm.checkEditDeleteAccess(\'Modificar item de cargo TAG\', data, $event) : vm.editItemOfCharge(data)\"><i class=\"fa fa-edit\"></i> </a><a title=\"View Details\" class=\"cursor editIconColor btn btn-sm\" ng-click=vm.viewItemOfCharge(data)><i class=\"fa fa-eye\"></i> </a><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=\"data.id == \'2\' ? vm.checkEditDeleteAccess(\'Eliminar item de cargo TAG\', data, $event) : vm.deleteItemOfChargeHit(data,$event)\"><i class=\"fa fa-trash\"></i></a></td><td style=width:150px><a class=\"btn btn-primary tableButton\" title=\"{{\'adminLogs\' | translate}}\" ui-sref=\"layout.itemOfChargeMain.adminLogs({userId:\'{{data.id}}\',type:\'15\',fakeType: \'10\'})\">{{\'adminLogs\' | translate}}</a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noItemFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav ng-show=\"vm.watchPagination\">--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\"--><!--ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/item-of-charge/itemOfChargeMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/massive-create-booking/massiveCreateBooking.html","<h2 class=ng-cloak><span>{{\'massiveCreateBookingHead\' | translate}}</span></h2><head><meta charset=UTF-8></head><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" ng-if=!vm.previewOfPackageScreenFlag><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><form name=massiveCreateBookingForm ng-submit=\"submit=true;massiveCreateBookingForm.$valid&&vm.submitCsvButton();\" novalidate autocomplete=off><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">{{vm.dataToFill.selectCreateType}} <span ng-if=vm.dataToFill.createBooking>> </span>{{vm.dataToFill.createBooking}} <span ng-if=vm.dataToFillModify.optionToModify>> {{vm.dataToFillModify.optionToModify}}</span></div></div><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label><!-- {{\'selectAgreement\' | translate}}\n                                    <span style=\"color:red\">*</span> --></label><select class=form-control ng-model=vm.dataToFill.selectCreateType ng-class=\"{ \'has-error\': massiveCreateBookingForm.holding.$touched && massiveCreateBookingForm.holding.$invalid }\" ng-disabled=\"vm.confirmBookingsFlag || vm.submitFlag\" name=holding required ng-change=vm.selectBookingType(vm.dataToFill.selectCreateType)><option value=\"\" disabled selected>Seleccionar Crear/Modificar Masivamente</option><option value=\"Crear Masivamente\">Crear Masivamente</option><option value=\"Modificar Masivamente\">Modificar Masivamente</option></select><!-- <div ng-if=\"massiveCreateBookingForm.holding.$touched|| submit\" ng-messages=\"massiveCreateBookingForm.holding.$error\">\n                            <div class=\"errormessage text-danger\" ng-message=\"required\"></div>\n                        </div> --></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\" ng-if=\"vm.dataToFill.selectCreateType != \'\' && !vm.errorFlag\"><label class=control-label><!-- {{\'selectAgreement\' | translate}}\n                                        <span style=\"color:red\">*</span> --></label><select ng-disabled=\"vm.confirmBookingsFlag || vm.submitFlag\" class=form-control ng-model=vm.dataToFill.createBooking ng-class=\"{ \'has-error\': massiveCreateBookingForm.holding.$touched && massiveCreateBookingForm.holding.$invalid }\" name=holding required ng-change=vm.selectHolding()><option value=\"\" disabled selected>Seleccionar Reservas/Paquetes Masivamente</option><option value=Reservas>Reservas</option><option ng-disabled=vm.PackageFlag value=Paquetes>Paquetes</option></select><!-- <div ng-if=\"massiveCreateBookingForm.holding.$touched|| submit\" ng-messages=\"massiveCreateBookingForm.holding.$error\">\n                            <div class=\"errormessage text-danger\" ng-message=\"required\">{{\'holdingR\' | translate}}</div>\n                        </div> --></div></div><div class=row ng-if=\"vm.dataToFill.selectCreateType==\'Modificar Masivamente\' && vm.dataToFill.createBooking==\'Reservas\'\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label><!-- {{\'selectAgreement\' | translate}}\n                                                <span style=\"color:red\">*</span> --></label><select class=form-control ng-model=vm.dataToFillModify.optionToModify ng-class=\"{ \'has-error\': massiveCreateBookingForm.holding.$touched && massiveCreateBookingForm.holding.$invalid }\" ng-disabled=vm.confirmBookingsFlag name=holding required ng-change=vm.optionToModifyChange(vm.dataToFill.selectCreateType)><option value=\"\" disabled selected>Seleccionar lo que quieres modificar</option><option value=\"Modificar Fecha de Retiro\">Modificar Fecha de Retiro</option><option value=\"Modificar Fecha de Retiro y Dirección de Retiro\">Modificar Fecha de Retiro y Dirección de Retiro</option><option disabled value=\"Anular Reservas\">Anular Reservas</option><option disabled value=\"Desanular Reservas\">Desanular Reservas</option></select></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\" ng-if=\"vm.dataToFillModify.optionToModify != \'\'\"><label class=control-label><!-- {{\'selectAgreement\' | translate}}\n                                                    <span style=\"color:red\">*</span> --></label><select class=form-control ng-model=vm.dataToFillModify.filtersToApply ng-class=\"{ \'has-error\': massiveCreateBookingForm.holding.$touched && massiveCreateBookingForm.holding.$invalid }\" ng-disabled=vm.confirmBookingsFlag name=holding required ng-change=vm.changeFiltersValue(vm.dataToFillModify.filtersToApply)><option value=\"\" disabled selected>Seleccionar filtro</option><option value=\"Búsqueda por filtros\">Búsqueda por filtros</option><option value=\"Búsqueda por números de Reservas\">Búsqueda por números de Reservas</option></select></div></div><div class=row ng-if=\"vm.dataToFill.selectCreateType == \'Crear Masivamente\'\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div style=margin-top:20px class=row ng-if=\"vm.dataToFill.createBooking == \'Reservas\'\"><div class=\"col-lg-2 col-sm-2 col-md-2 col-xs-2\"><label class=control-label>Convenio <span style=color:red>*</span></label><ui-select ng-disabled=vm.submitFlag ng-model=vm.dataToFill.contractIdSelected name=agreement ng-change=vm.agreementChanged(vm.dataToFill.contractIdSelected) required close-on-select=true><ui-select-match placeholder=Convenio>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"agreements as agreements in vm.agreementBooking | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=agreements.name></div></ui-select-choices></ui-select><div ng-if=\"massiveCreateBookingForm.agreement.$touched|| submit\" ng-messages=massiveCreateBookingForm.agreement.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'selectAgreementReq\' | translate}}</div></div></div><div class=\"col-lg-2 col-sm-2 col-md-2 col-xs-2\"><label>Tipo Servicio <span style=color:red>*</span></label><div><select ng-disabled=vm.submitFlag class=form-control ng-model=vm.dataToFill.serviceTypeSelected name=typeOfService ng-change=vm.serviceTypeChanged() ng-disabled=\"vm.serviceTypeList.length == 0\" required ng-class=\"{ \'has-error\': massiveCreateBookingForm.typeOfService.$touched && massiveCreateBookingForm.typeOfService.$invalid }\" ng-options=\"data as data.service_name for data in vm.serviceTypeList\"><option value=\"\" selected disabled>{{\'selectTService\' | translate}}</option></select><div ng-if=\"massiveCreateBookingForm.typeOfService.$touched|| submit\" ng-messages=massiveCreateBookingForm.typeOfService.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'serviceReq\' | translate}}</div></div></div></div><div class=\"col-lg-2 col-sm-2 col-md-2 col-xs-2\" ng-if=\"vm.dataToFill.selectCreateType != \'\'\"><label>Tipo Reserva <span style=color:red>*</span></label><select ng-disabled=vm.submitFlag class=form-control ng-model=vm.dataToFill.bookingType ng-class=\"{ \'has-error\': massiveCreateBookingForm.bookingType.$touched && massiveCreateBookingForm.bookingType.$invalid }\" name=bookingType required ng-change=vm.selectHolding()><option value=\"\" disabled selected>Seleccionar Tipo Viaje</option><option value=0>Programada</option></select><div ng-if=\"massiveCreateBookingForm.bookingType.$touched|| submit\" ng-messages=massiveCreateBookingForm.bookingType.$error><div class=\"errormessage text-danger\" ng-message=required>Favor seleccione Tipo Reserva</div></div></div><div class=\"col-lg-2 col-sm-2 col-md-2 col-xs-2\" ng-if=\"vm.dataToFill.selectCreateType != \'\'\"><label>Tipo Viaje <span style=color:red>*</span></label><select ng-disabled=vm.submitFlag class=form-control ng-model=vm.dataToFill.TripType ng-class=\"{ \'has-error\': massiveCreateBookingForm.tripType.$touched && massiveCreateBookingForm.tripType.$invalid }\" name=tripType required ng-change=vm.selectTypeOfService()><option value=\"\" disabled selected>Seleccionar Tipo Viaje</option><option value=Z>Z</option><option value=R>R</option><option value=P>P</option></select><div ng-if=\"massiveCreateBookingForm.tripType.$touched|| submit\" ng-messages=massiveCreateBookingForm.tripType.$error><div class=\"errormessage text-danger\" ng-message=required>Favor seleccione Tipo Viaje</div></div></div><div class=\"col-lg-2 col-sm-2 col-md-2 col-xs-2\"><label>Método de Pago <span style=color:red>*</span></label><div><ui-select ng-disabled=vm.submitFlag ng-change=vm.selectPaymentMethod() ng-model=vm.dataToFill.payment_method name=pago ng-required=!vm.modifyFalg close-on-select=true ng-class=\"{ \'has-error\': massiveCreateBookingForm.pago.$touched && massiveCreateBookingForm.pago.$invalid }\"><ui-select-match placeholder=\"Métodos de pago\">{{$select.selected.type}}</ui-select-match><ui-select-choices repeat=\"payment as payment in vm.dataToFill.paymentMethodList | filter: $select.search | orderBy:\'type\' \"><div ng-bind-html=payment.type></div></ui-select-choices></ui-select><div ng-if=\"massiveCreateBookingForm.pago.$touched|| submit\" ng-messages=massiveCreateBookingForm.pago.$error><div class=\"errormessage text-danger\" ng-message=required>Debe seleccionar un Método de pago</div></div></div></div></div><div class=row style=\"margin-top:20px;text-align: center\" ng-if=\"vm.dataToFill.createBooking == \'Reservas\'\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><button ng-disabled=\"!vm.submitFlag ||  vm.submitButtonActivate\" type=submit class=\"btn btn-primary\">Generar Plantilla de Carga</button></div></div><div class=row style=\"margin-top:20px;text-align: center\" ng-if=\"vm.dataToFill.createBooking == \'Reservas\'\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><input id=documentUpload filestyle=\"\" type=file style=\"display: none\" name={{vm.uploadName}} onchange=angular.element(this).scope().file_to_upload(this.files,this.name) onclick=\"this.value = null\" data-button-text=Single data-class-button=\"btn btn-default\" data-classinput=\"form-control inline\" nv-file-select=\"\" uploader=uploader accept=\".csv, text/csv\"> <button type=button class=\"btn btn-primary\" ng-disabled=!vm.submitButtonActivate ng-click=vm.makeTableViewOfCsv($event) style=\"width: 245px\">Subir Plantilla de Carga</button></div></div><div class=row ng-if=vm.successTableFlag><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt10\" style=\"font-size: 18px;font-weight: bold\">Lineas del archivo: {{vm.achiveLines}}</div></div><div class=row ng-if=vm.successTableFlag><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt10\" style=\"font-size: 18px;font-weight: bold;color: red\">Lineas con error : {{vm.errorLines}}</div></div><div class=row ng-if=vm.successTableFlag><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt10\"><div style=\"margin-top: 20px\" class=\"table-responsive tableWithMasterDataParentDive\" ng-switch=\"(vm.driverList | filter:vm.search).length\"><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Convenio</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Vehículo text=\"\'unique_car_id\'\" check=vm.reverse>Tipo de Servicio</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Conductor text=\"\'fleet_name\'\" check=vm.reverse>Método de Pago</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Conductor text=\"\'fleet_name\'\" check=vm.reverse>Tipo de Viaje</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Conductor text=\"\'fleet_name\'\" check=vm.reverse>Tipo de reserva</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Entrada text=\"\'entry_time\'\" check=vm.reverse>Nombre completo del cliente</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Acción text=\"\'unique_car_id\'\" check=vm.reverse>Email Cliente</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=\"con Pax\" text=\"\'unique_car_id\'\" check=vm.reverse>Teléfono Cliente</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Número de Pasajeros</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Dirección de Retiro</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Dirección de Destino</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Referencia Dirección de Recogida</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Observaciones</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Fecha</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Hora</th><th ng-if=\"vm.passengerRutFlag == 1\" style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Pasajero RUT</th><th ng-if=\"vm.applicantRutFlag == 1\" style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Rut Solicitante</th><th ng-if=\"vm.costCenterCheckFlag == 1\" style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Centro de Costo</th><th ng-if=\"vm.costSubCenterCheckFlag == 1\" style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Centro SubCost</th><th ng-if=\"vm.RolCheckFlag == 1\" style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>ROL</th><th ng-if=\"vm.graphCheckFlag == 1\" style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Grafo</th><th ng-if=\"vm.workOrderCheckFlag == 1\" style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Orden de trabajo</th><th ng-if=\"vm.pepCheckFlag == 1\" style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>PEP</th><th ng-if=\"vm.noOfVoucherCheckFlag == 1\" style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Número Vale</th><th ng-if=\"vm.nominaCheckFlag == 1\" style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Nomina</th><th ng-if=\"vm.solictudCheckFlag == 1\" style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Solicitud</th><th ng-if=\"vm.purposeOfTripCheckFlag == 1\" style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Propósito de viaje</th><th ng-if=\"vm.flagForAirlineNew == 1\" style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Nombre de la aerolínea</th><th ng-if=\"vm.flagForFlightNumberNew == 1\" style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Número de vuelo</th><th ng-if=\"vm.flagForFlightTypeNew == 1\" style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Tipo de vuelo</th><th ng-if=\"vm.flagForFlightDateNew == 1\" style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Fecha de vuelo</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Descripcion del error</th></tr></thead><tbody><tr ng-repeat=\"data in  vm.CsvData\"><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\">{{::data.contract_name != \"\"? data.contract_name : \'--\'}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\">{{::data.service_name != \"\"? data.service_name : \'--\'}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\">{{::data.payment_method_name != \"\"? data.payment_method_name : \'--\'}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\">{{::data.type_of_trip != \"\"? data.type_of_trip : \'--\'}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\">{{::data.booking_type != \"\"? data.booking_type : \'--\'}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\" ng-class=\"{\'red-color\': data.errorNombreCompletoDelCliente && data.errorNombreCompletoDelCliente == 1}\">{{::data.Nombre_completo_del_cliente != \"\"? data.Nombre_completo_del_cliente : \'--\'}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\" ng-class=\"{\'red-color\': data.errorEmailCliente && data.errorEmailCliente == 1}\">{{::data.Email_Cliente != \"\"? data.Email_Cliente : \'--\'}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\" ng-class=\"{\'red-color\': data.errorTelefonoCliente && data.errorTelefonoCliente == 1}\">{{::data.telephone_number != \"\"? data.telephone_number : \'--\'}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\" ng-class=\"{\'red-color\': data.errorNumeroDePasajeros && data.errorNumeroDePasajeros == 1}\">{{::data.No_of_passenger != \"\"? data.No_of_passenger : \'--\'}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\" ng-class=\"{\'red-color\': data.errorDireccionDeRetiro && data.errorDireccionDeRetiro == 1}\">{{::data.pickup_address != \"\"? data.pickup_address : \'--\'}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\" ng-class=\"{\'red-color\': data.errorDireccionDeDestino && data.errorDireccionDeDestino == 1}\">{{::data.dropoff_address != \"\"? data.dropoff_address : \'--\'}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\" ng-class=\"{\'red-color\': data.errorReferenciaDireccionDeRecogida && data.errorReferenciaDireccionDeRecogida == 1}\">{{::data.Reference != \"\"? data.Reference : \'--\'}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\" ng-class=\"{\'red-color\': data.errorObservaciones && data.errorObservaciones == 1}\">{{::data.Observaciones ? data.Observaciones : \'--\' }}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\" ng-class=\"{\'red-color\': data.errorFechaRecogidaProgramada && data.errorFechaRecogidaProgramada == 1}\">{{::data.Fecha_Recogida_Programada ? data.Fecha_Recogida_Programada : \'--\' }}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\" ng-class=\"{\'red-color\': data.errorHoraRecogida && data.errorHoraRecogida == 1}\">{{::data.Hora_Recogida ? data.Hora_Recogida : \'--\' }}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\" ng-class=\"{\'red-color\': data.errorPassengerRutFlag && data.errorPassengerRutFlag == 1}\" ng-if=\"vm.passengerRutFlag == 1\">{{::data.Pasajero_RUT ? data.Pasajero_RUT : \'--\' }}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\" ng-class=\"{\'red-color\': data.errorApplicantRutFlag && data.errorApplicantRutFlag == 1}\" ng-if=\"vm.applicantRutFlag == 1\">{{::data.Rut_Solicitante ? data.Rut_Solicitante : \'--\' }}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\" ng-class=\"{\'red-color\': data.errorCostCenterCheckFlag && data.errorCostCenterCheckFlag == 1}\" ng-if=\"vm.costCenterCheckFlag == 1\">{{::data.Centro_de_Costo ? data.Centro_de_Costo : \'--\' }}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\" ng-class=\"{\'red-color\': data.errorSubCenterCheckFlag && data.errorSubCenterCheckFlag == 1}\" ng-if=\"vm.costSubCenterCheckFlag == 1\">{{::data.Centro_SubCost ? data.Centro_SubCost : \'--\' }}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\" ng-class=\"{\'red-color\': data.errorRolCheckFlag && data.errorRolCheckFlag == 1}\" ng-if=\"vm.RolCheckFlag == 1\">{{::data.ROL ? data.ROL : \'--\' }}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\" ng-class=\"{\'red-color\': data.errorGraphCheckFlag && data.errorGraphCheckFlag == 1}\" ng-if=\"vm.graphCheckFlag == 1\">{{::data.Grafo ? data.Grafo : \'--\' }}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\" ng-class=\"{\'red-color\': data.errorWorkOrderCheckFlag && data.errorWorkOrderCheckFlag == 1}\" ng-if=\"vm.workOrderCheckFlag == 1\">{{::data.Orden_de_trabajo ? data.Orden_de_trabajo : \'--\' }}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\" ng-class=\"{\'red-color\': data.errorPepCheckFlag && data.errorPepCheckFlag == 1}\" ng-if=\"vm.pepCheckFlag == 1\">{{::data.PEP ? data.PEP : \'--\' }}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\" ng-class=\"{\'red-color\': data.errorNoOfVoucherCheckFlag && data.errorNoOfVoucherCheckFlag == 1}\" ng-if=\"vm.noOfVoucherCheckFlag == 1\">{{::data.no_of_vocher ? data.no_of_vocher : \'--\' }}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\" ng-class=\"{\'red-color\': data.errorNominaCheckFlag && data.errorNominaCheckFlag == 1}\" ng-if=\"vm.nominaCheckFlag == 1\">{{::data.Nomina ? data.Nomina : \'--\' }}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\" ng-class=\"{\'red-color\': data.errorSolictudCheckFlag && data.errorSolictudCheckFlag == 1}\" ng-if=\"vm.solictudCheckFlag == 1\">{{::data.Solicitud ? data.Solicitud : \'--\' }}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\" ng-class=\"{\'red-color\': data.errorPurposeOfTripCheckFlag && data.errorPurposeOfTripCheckFlag == 1}\" ng-if=\"vm.purposeOfTripCheckFlag == 1\">{{::data.purpose_de_viaje ? data.purpose_de_viaje : \'--\' }}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\" ng-class=\"{\'red-color\': data.errorFlagForAirlineNew && data.errorFlagForAirlineNew == 1}\" ng-if=\"vm.flagForAirlineNew == 1\">{{::data.name_of_airline ? data.name_of_airline : \'--\' }}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\" ng-class=\"{\'red-color\': data.errorFlagForFlightNumberNew && data.errorFlagForFlightNumberNew == 1}\" ng-if=\"vm.flagForFlightNumberNew == 1\">{{::data.flight_number ? data.flight_number : \'--\' }}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\" ng-class=\"{\'red-color\': data.errorFlagForFlightTypeNew && data.errorFlagForFlightTypeNew == 1}\" ng-if=\"vm.flagForFlightTypeNew == 1\">{{::data.Tipo_de_vuelo ? data.Tipo_de_vuelo : \'--\' }}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" width:125px; ng-class=\"{\'red-color\': data.errorFlagForFlightDateNew && data.errorFlagForFlightDateNew == 1}\" ng-if=\"vm.flagForFlightDateNew == 1\">{{::data.Fecha_de_vuelo ? data.Fecha_de_vuelo : \'--\' }}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\" ng-class=\"{\'red-color\': data.error}\">{{::data.Descripcio_del_error ? data.Descripcio_del_error : \'--\' }}</td></tr></tbody></table></div></div></div><div ng-if=vm.successTableFlag class=row style=\"margin-top:20px;text-align: center\" ng-if=\"vm.dataToFill.createBooking == \'Reservas\'\"><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><button style=\"float: right\" type=button class=\"btn btn-primary\" ng-click=vm.DownloadValidateCSVData()>Descargar Plantilla procesada</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><button style=\"float: left\" type=button class=\"btn btn-primary\" ng-click=vm.startUploadMassiveBooking()>Ejecutar y descartar las líneas con error</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><button style=\"float: left\" type=button ng-click=vm.cancelTheCreateBookingProcess() class=\"btn btn-primary\">Cancelar</button></div></div></div></div><div class=row style=margin-top:10px ng-if=\"vm.dataToFill.selectCreateType==\'Modificar Masivamente\' && vm.dataToFill.createBooking==\'Reservas\'\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\" ng-if=\"(vm.dataToFillModify.optionToModify == \'Modificar Fecha de Retiro\' || vm.dataToFillModify.optionToModify == \'Modificar Fecha de Retiro y Dirección de Retiro\') && vm.dataToFillModify.filtersToApply != \'\'\"><label>Nueva Fecha de retiro</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} id=fromDate name=pickupDate ng-model=vm.filterData.new_pickup_from_date_value placeholder=\"{{\'pickUpDateFromLabelPET\' | translate}}\" is-open=vm.datePicker_1.newDate datepicker-options=vm.dateOptionsPickup close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.pickupFromToDateChanged(1)> <span class=input-group-btn><button ng-disabled=vm.confirmBookingsFlag type=button class=\"btn btn-default\" ng-click=vm.datePickerE_3(3)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\" ng-if=\"(vm.dataToFillModify.optionToModify == \'Modificar Fecha de Retiro\' || vm.dataToFillModify.optionToModify == \'Modificar Fecha de Retiro y Dirección de Retiro\') && vm.dataToFillModify.filtersToApply != \'\'\"><label>Nueva Hora de retiro</label><div ng-disabled=vm.confirmBookingsFlag uib-timepicker ng-model=vm.filterData.new_pickup_to_time_value show-spinners=false class=completed ng-change=vm.pickupFromToTimeChanged(2) hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian></div></div></div><div class=row style=margin-top:10px ng-if=\"vm.dataToFill.selectCreateType==\'Modificar Masivamente\' && vm.dataToFill.createBooking==\'Reservas\'\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\" ng-if=\"vm.dataToFillModify.optionToModify == \'Modificar Fecha de Retiro y Dirección de Retiro\' && vm.dataToFillModify.filtersToApply != \'\'\"><label>Nueva Dirección de Retiro</label><input ng-disabled=vm.confirmBookingsFlag id=pac-input class=\"controls form-control\" ng-change=vm.getSearchedAddress(vm.searchedAddress) type=text ng-model=vm.searchedAddress style=color:#000;height:35px placeholder=\"{{\'searchLocationPlaceholder\' | translate}}\" domain={{vm.domain}} google-place callback-fn=vm.ctrlFn(data)></div></div><div class=row ng-if=\"(vm.dataToFill.selectCreateType==\'Modificar Masivamente\' && vm.dataToFill.createBooking==\'Reservas\') || (vm.dataToFill.createBooking == \'Paquetes\')\"><div class=row ng-if=\"(vm.dataToFillModify.filtersToApply == \'Búsqueda por filtros\') || vm.dataToFill.createBooking == \'Paquetes\'\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row style=\"padding: 32px\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"border:1px solid #dedede;padding:0px\" ng-init=\"checkClicked = true\"><h2 class=\"text-center filtersStyle\"><!-- <span ng-if=\"(vm.dataToFill.selectCreateType==\'Modificar Masivamente\' && vm.dataToFill.createBooking==\'Reservas\')\">{{\'filter\' | translate}}</span> --> <span ng-if=\"(vm.dataToFill.selectCreateType==\'Modificar Masivamente\' && vm.dataToFill.createBooking==\'Reservas\')\">Filtros para encontrar las Reservas a Modificar </span><span ng-if=\"(vm.dataToFill.createBooking == \'Paquetes\')\">Filtros para encontrar las Reservas a Empaquetar</span><!-- <span class=\"fa\" ng-class=\"{\'fa-caret-down\': checkClicked,\'fa-caret-up\': !checkClicked }\"></span> --></h2><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" id=derp><div class=row style=\"padding-top: 10px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'branchLabel\' | translate}}:</label><div><ui-select ng-disabled=vm.confirmBookingsFlag ng-model=vm.filterData.branch ng-change=vm.branchChanged() name=branch ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices when-scrolled=vm.paginationChangedForBranch() repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \"><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'agreementLabel\' | translate}}:</label><div><ui-select ng-disabled=vm.confirmBookingsFlag ng-model=vm.filterData.agreement name=agreement ng-keyup=vm.agreementSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=\"{{\'agreementPlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices when-scrolled=vm.paginationChangedForAgreement() ng-click=vm.agreementChanged() repeat=\"agreements.id as agreements in vm.agreement | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=agreements.name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'serviceLabel\' | translate}}:</label><div><ui-select ng-disabled=vm.confirmBookingsFlag ng-model=vm.filterData.service name=service ng-keyup=vm.serviceSearch($select.search,$event) required close-on-select=true ng-change=vm.serviceChanged()><ui-select-match placeholder=\"{{\'selectTService\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices when-scrolled=vm.paginationChangedForService() repeat=\"services.id as services in vm.service | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=services.name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>Tipo Viaje</label><div><select ng-disabled=vm.confirmBookingsFlag class=form-control ng-model=vm.dataToFillModify.TripTypeModify ng-class=\"{ \'has-error\': massiveCreateBookingForm.tripType.$touched && massiveCreateBookingForm.tripType.$invalid }\" name=tripType required ng-change=vm.selectHolding()><option value=\"\" disabled selected>Seleccionar Tipo Viaje</option><option value=Z>Z</option><option value=R>R</option><option value=P>P</option></select></div></div></div><div class=row style=\"padding-top: 10px;padding-bottom: 10px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpDateFromLabelPET\' | translate}}:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} id=fromDate name=pickupDate ng-model=vm.filterData.filter_pickup_from_date_value placeholder=\"{{\'pickUpDateFromLabelPET\' | translate}}\" is-open=vm.datePicker_1.pickupFromDate datepicker-options=vm.dateOptions close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.pickupFromToDateChanged(1)> <span class=input-group-btn><button ng-disabled=vm.confirmBookingsFlag type=button class=\"btn btn-default\" ng-click=vm.datePickerE_3(1)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpTimeFromLabelPET\' | translate}}:</label><div ng-disabled=vm.confirmBookingsFlag uib-timepicker ng-model=vm.filterData.filter_pickup_from_time_value show-spinners=false class=completed ng-change=vm.pickupFromToTimeChanged(1) hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpDateToLabelPET\' | translate}}:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} id=toDate name=pickupDate ng-model=vm.filterData.filter_pickup_to_date_value placeholder=\"{{\'pickUpDateToLabelPET\' | translate}}\" is-open=vm.datePicker_1.pickupToDate datepicker-options=vm.dateOptions close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.pickupFromToDateChanged(2)> <span class=input-group-btn><button ng-disabled=vm.confirmBookingsFlag type=button class=\"btn btn-default\" ng-click=vm.datePickerE_3(2)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpTimeToLabelPET\' | translate}}:</label><div ng-disabled=vm.confirmBookingsFlag uib-timepicker ng-model=vm.filterData.filter_pickup_to_time_value show-spinners=false class=completed ng-change=vm.pickupFromToTimeChanged(2) hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian></div></div></div><div class=row style=\"padding-top: 10px;padding-bottom:10px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>Vuelo:</label><input ng-disabled=vm.confirmBookingsFlag class=form-control is-number=\"\" placeholder=\"Ingrese Vuelo\" ng-model=vm.dataToFillModify.Vuelo></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>Solicitante:</label><input ng-disabled=vm.confirmBookingsFlag class=form-control placeholder=\"Ingrese Solicitante\" ng-model=vm.dataToFillModify.Solicitante></div></div><div class=row style=\"padding-top: 10px;padding-bottom:10px\" ng-if=\"(vm.dataToFill.selectCreateType==\'Modificar Masivamente\' && vm.dataToFill.createBooking==\'Reservas\')\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6 text-center\"><button ng-disabled=vm.confirmBookingsFlag class=\"btn btn-primary\" type=button style=\"height: 35px;line-height: 20px;float: right\" ng-click=\"vm.applyFilter(\'Búsqueda por filtro\',\'unscroll\',0)\">Aplicar filtros</button></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6 text-center\"><button ng-disabled=vm.confirmBookingsFlag class=\"btn btn-primary\" type=button style=\"height: 35px;line-height: 20px;float: left\" ng-click=\"vm.resetFilter(\'Búsqueda por filtro\')\">{{\'resetFilterButton\' | translate}}</button></div></div><div class=row style=\"padding-top: 10px;padding-bottom:10px\" ng-if=\"(vm.dataToFill.createBooking == \'Paquetes\')\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6 text-center\"><button ng-disabled=vm.confirmBookingsFlag class=\"btn btn-primary\" type=button style=\"height: 35px;line-height: 20px;float: right\" ng-click=\"vm.applyFilterPackageCreation(\'unscroll\',0)\">Aplicar filtros</button></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6 text-center\"><button ng-disabled=vm.confirmBookingsFlag class=\"btn btn-primary\" type=button style=\"height: 35px;line-height: 20px;float: left\" ng-click=\"vm.resetFilter(\'Búsqueda por filtro\')\">{{\'resetFilterButton\' | translate}}</button></div></div><!--<div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\">--><!--<label>{{\'pickUpDateLabel\' | translate}}:</label>--><!--<p class=\"input-group\">--><!--<input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{vm.format}}\" name=\"pickupDate\" ng-model=\"vm.filterData.filter_pickup_date_value\"--><!--placeholder=\"{{\'pickUpDateLabel\' | translate}}\" is-open=\"vm.datePicker_1.pickupDate\" datepicker-options=\"vm.dateOptions\" required--><!--close-text=\"Close\" alt-input-formats=\"vm.altInputFormats\" show-button-bar=\"false\" readonly ng-change=\"vm.pickupDateChanged()\"/>--><!--<span class=\"input-group-btn\">--><!--<button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.datePickerE_1()\"><i--><!--class=\"glyphicon glyphicon-calendar\"></i></button>--><!--</span>--><!--</p>--><!--</div>--><!--<div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\">--><!--<label>{{\'pickUpTimeLabel\' | translate}}:</label>--><!--<div uib-timepicker ng-model=\"vm.filterData.filter_pickup_time_value\" show-spinners=\"false\" ng-change=\"vm.pickupTimeChanged()\" hour-step=\"vm.hstep\" minute-step=\"vm.mstep\" show-meridian=\"vm.ismeridian\"></div>--><!--</div>--></div></div></div></div></div><div style=\"margin-top: 20px;padding: 15px\" class=row ng-if=\"vm.dataToFillModify.filtersToApply == \'Búsqueda por números de Reservas\'\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><h2 class=\"text-center filtersStyle\"><span ng-if=\"(vm.dataToFill.selectCreateType==\'Modificar Masivamente\' && vm.dataToFill.createBooking==\'Reservas\')\">Filtros para encontrar las Reservas a Modificar </span><!-- <span class=\"fa\" ng-class=\"{\'fa-caret-down\': checkClicked,\'fa-caret-up\': !checkClicked }\"></span> --></h2></div></div><div class=row><div style=\"margin-top: 10px\" class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label>Ingrese aquí los Números de Reserva separados por coma</label><textarea ng-disabled=vm.confirmBookingsFlag style=\"border-radius: 4px;border: grey 1px solid;box-sizing: border-box;padding: 4px\" ng-keypress=vm.changeInJobIdArrayFunction(vm.dataToFillModify.job_ids,$event) ng-model=vm.dataToFillModify.job_ids placeholder=\"Ingrese aquí los Números de Reserva separados por coma\"></textarea></div></div></div></div><div class=row style=\"padding-top: 10px;padding-bottom:10px\" ng-if=\"vm.dataToFillModify.filtersToApply == \'Búsqueda por números de Reservas\'\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6 text-center\"><button ng-disabled=vm.confirmBookingsFlag class=\"btn btn-primary\" type=button style=\"height: 35px;line-height: 20px;float: right\" ng-click=\"vm.applyFilter(\'Búsqueda por números de Reservas\')\">Aplicar filtros</button></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6 text-center\"><button ng-disabled=vm.confirmBookingsFlag class=\"btn btn-primary\" type=button style=\"height: 35px;line-height: 20px;float: left\" ng-click=\"vm.resetFilter(\'Búsqueda por números de Reservas\')\">{{\'resetFilterButton\' | translate}}</button></div></div></div><div class=row ng-if=\"vm.bookingData.length > 0 ||  vm.packageData.length > 0\"><div style=\"text-align: center;font-size: 20px;font-weight: bold\" class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt10\">Total Reservas: {{vm.totalCount}}</div></div><div class=row ng-if=\"vm.bookingData.length > 0 ||  vm.packageData.length > 0\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt10\"><div style=\"margin-top: 20px\" class=\"table-responsive tableWithMasterDataParentDive\" ng-switch=\"(vm.driverList | filter:vm.search).length\"><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead style=\"width: 100% !important\"><tr><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>id</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Reserva</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Sucursal</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Convenio</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Tipo Servicio</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Tipo Viaje</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Vuelo</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Nombre Solicitante</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Retiro</th><th ng-if=\"vm.bookingData.length > 0\" style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Presentación</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Pasajero</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Dirección Retiro</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Nómina</th><th ng-if=\"vm.bookingData.length > 0\" style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Estado</th></tr></thead><tbody ng-if=\"vm.bookingData.length > 0\" when-scrolled=vm.bookingDataPagination()><tr ng-repeat=\"data in  vm.bookingData\"><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{$index + 1}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{::data.job_id != \"\"? data.job_id : \'--\'}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{::data.branch_name != \"\"? data.branch_name : \'--\'}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{::data.contract_name != \"\"? data.contract_name : \'--\'}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{::data.service_name != \"\"? data.service_name : \'--\'}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{::data.type_of_trip != \"\"? data.type_of_trip : \'--\'}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{::data.flight_number != null? data.flight_number : \'--\'}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{::data.customer_username != \"\"? data.customer_username : \'--\'}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{vm.changeDateIntoSpanishNew(data.job_time_utc)}} {{data.job_time_utc | date: \'HH:mm\'}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{vm.changeDateIntoSpanishNew(data.job_delivery_datetime)}} {{data.job_delivery_datetime | date: \'HH:mm\'}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{::data.number_of_passangers != \"\"? data.number_of_passangers : \'--\'}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{::data.job_pickup_address != \"\"? data.job_pickup_address : \'--\'}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{::data.nomina != \"\"? data.nomina : \'--\'}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px><span ng-if=\"data.job_status == \'0\'\">{{\'upcomingStatus\' | translate}}</span> <span ng-if=\"data.job_status == \'1\'\">Viaje Iniciado</span> <span ng-if=\"data.job_status == \'2\'\">Completada</span> <span ng-if=\"data.job_status == \'3\'\">Failed</span> <span ng-if=\"data.job_status == \'4\'\">En Posición</span> <span ng-if=\"data.job_status == \'5\'\">Partial</span> <span ng-if=\"data.job_status == \'6\'\">No Asignada</span> <span ng-if=\"data.job_status == \'17\'\">Pendiente de Aceptación</span> <span ng-if=\"data.job_status == \'7\'\">Accepted</span> <span ng-if=\"data.job_status == \'8\'\">Rejected</span> <span ng-if=\"data.job_status == \'9\'\">Cancelada</span> <span ng-if=\"data.job_status == \'10\'\">Deleted</span> <span ng-if=\"data.job_status == \'11\'\">Ignored</span> <span ng-if=\"data.job_status == \'12\'\">No Show</span> <span ng-if=\"data.job_status == \'15\'\">En Camino</span></td></tr></tbody><tbody ng-if=\"vm.packageData.length > 0\" when-scrolled=vm.packageDataPagination()><tr ng-repeat=\"data in  vm.packageData\"><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{$index + 1}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{::data.job_id != \"\"? data.job_id : \'--\'}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{::data.branch_name != \"\"? data.branch_name : \'--\'}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{::data.contract_name != \"\"? data.contract_name : \'--\'}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{::data.service_name != \"\"? data.service_name : \'--\'}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{::data.type_of_trip != \"\"? data.type_of_trip : \'--\'}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{::data.flight_number != null? data.flight_number : \'--\'}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{::data.customer_username != \"\"? data.customer_username : \'--\'}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{vm.changeDateIntoSpanishNew(data.job_pickup_datetime)}} {{data.job_pickup_datetime | date: \'HH:mm\'}}</td><!-- <td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;\" style=\"width:125px;\">{{vm.changeDateIntoSpanish(data.job_delivery_datetime)}} {{data.job_delivery_datetime\n                                            | date: \'HH:mm\'}}</td> --><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{::data.number_of_passangers != \"\"? data.number_of_passangers : \'--\'}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{::data.job_pickup_address != \"\"? data.job_pickup_address : \'--\'}}</td><td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{::data.nomina != \"\"? data.nomina : \'--\'}}</td><!-- <td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;\" style=\"width:125px;\">\n                                            <span ng-if=\"data.job_status == \'0\'\">{{\'upcomingStatus\' | translate}}</span>\n                                            <span ng-if=\"data.job_status == \'1\'\">Viaje Iniciado</span>\n                                            <span ng-if=\"data.job_status == \'2\'\">Completada</span>\n                                            <span ng-if=\"data.job_status == \'3\'\">Failed</span>\n                                            <span ng-if=\"data.job_status == \'4\'\">En Posición</span>\n                                            <span ng-if=\"data.job_status == \'5\'\">Partial</span>\n                                            <span ng-if=\"data.job_status == \'6\'\">No Asignada</span>\n                                            <span ng-if=\"data.job_status == \'17\'\">Pendiente de Aceptación</span>\n                                            <span ng-if=\"data.job_status == \'7\'\">Accepted</span>\n                                            <span ng-if=\"data.job_status == \'8\'\">Rejected</span>\n                                            <span ng-if=\"data.job_status == \'9\'\">Cancelada</span>\n                                            <span ng-if=\"data.job_status == \'10\'\">Deleted</span>\n                                            <span ng-if=\"data.job_status == \'11\'\">Ignored</span>\n                                            <span ng-if=\"data.job_status == \'12\'\">No Show</span>\n                                            <span ng-if=\"data.job_status == \'15\'\">En Camino</span>\n                                        </td> --></tr></tbody></table></div></div></div><div ng-if=\"(vm.packageData.length > 0 || vm.bookingData.length > 0) && !vm.showAppllyModifcationButton\" class=row ng-if=\"vm.bookingData.length > 0\" style=\"margin-top: 10px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><button class=\"btn btn-primary\" type=button style=\"height: 35px;line-height: 20px;float: right\" ng-click=vm.confirmBookings()><span ng-if=\"(vm.dataToFill.createBooking==\'Paquetes\')\">Confirmar reservas para Empaquetar</span> <span ng-if=\"(vm.dataToFill.selectCreateType==\'Modificar Masivamente\' && vm.dataToFill.createBooking==\'Reservas\')\">Confirmar Reservas a Modificar</span></button></div></div><div ng-if=\"vm.showAppllyModifcationButton && vm.bookingData.length > 0\" class=row ng-if=\"vm.bookingData.length > 0\" style=\"margin-top: 10px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><button class=\"btn btn-primary\" type=button style=\"height: 35px;line-height: 20px;float: right;color: white;background-color: red;border-color:red\" ng-click=vm.applyModifications($event)>Aplicar Modificación</button></div></div><div ng-if=\"vm.showAppllyModifcationButton && vm.packageData.length > 0 && !vm.showSubmitButtonAfterDownloadReport\" class=row ng-if=\"vm.bookingData.length > 0\" style=\"margin-top: 10px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><button class=\"btn btn-primary\" type=button style=\"height: 35px;line-height: 20px;float: left\" ng-click=vm.generatePackageReport($event)>Generar Plantilla de Carga</button></div></div><div ng-if=\"vm.showSubmitButtonAfterDownloadReport && vm.packageData.length > 0\" class=row ng-if=\"vm.bookingData.length > 0\" style=\"margin-top: 10px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><input id=documentUploadPackage filestyle=\"\" type=file style=\"display: none\" name={{vm.uploadName}} onchange=angular.element(this).scope().file_to_upload_package(this.files,this.name) onclick=\"this.value = null\" data-button-text=Single data-class-button=\"btn btn-default\" data-classinput=\"form-control inline\" nv-file-select=\"\" uploader=uploader accept=\".xlsx, text/xlsx\"> <button class=\"btn btn-primary\" type=button style=\"height: 35px;line-height: 20px;float: left\" ng-click=vm.makeTableViewOfXlsxPackage($event)>Subir Plantilla de Carga</button></div></div></form></div></div><input id=copy style=\"opacity: 0 ; z-index:0\" type=text><div id=showPrint></div></div><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" ng-if=vm.previewOfPackageScreenFlag><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">{{vm.dataToFill.selectCreateType}} <span ng-if=vm.dataToFill.createBooking>> </span>{{vm.dataToFill.createBooking}} <span>> Vista Previa</span></div></div><div class=row style=\"margin-top:20px;font-size: 19px;font-weight: bold\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">Lineas del archivo: {{vm.totalLines}}</div></div><div class=row style=\"margin-top: 5px;font-size: 19px;font-weight: bold;color: red\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">Lineas con error: {{vm.errorLines}}</div></div><div class=row ng-if=\"vm.previewPackageData.length > 0\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt10\"><div style=\"margin-top: 20px\" class=\"table-responsive tableWithMasterDataParentDive\" ng-switch=\"(vm.driverList | filter:vm.search).length\"><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>id</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Reserva</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Sucursal</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Convenio</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Tipo Servicio</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Tipo Viaje</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Vuelo</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Nombre Solicitante</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Retiro</th><th ng-if=\"vm.bookingData.length > 0\" style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Presentación</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Pasajero</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Dirección Retiro</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Nómina</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Package</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Descripcio_del_error</th></tr></thead><tbody ng-if=\"vm.previewPackageData.length > 0\"><tr ng-repeat=\"data in  vm.previewPackageData\"><td ng-class=\"{\'red-color\': data.error}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\">{{$index + 1}}</td><td ng-class=\"{\'red-color\': data.error}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\">{{::data.Sucursal != \"\"? data.Sucursal : \'--\'}}</td><td ng-class=\"{\'red-color\': data.error}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\">{{::data.Reserva != \"\"? data.Reserva : \'--\'}}</td><td ng-class=\"{\'red-color\': data.error}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\">{{::data.Convenio != \"\"? data.Convenio : \'--\'}}</td><td ng-class=\"{\'red-color\': data.error}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\">{{::data.Tipo_Servicio != \"\"? data.Tipo_Servicio : \'--\'}}</td><td ng-class=\"{\'red-color\': data.error}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\">{{::data.Tipo_Viaje != \"\"? data.Tipo_Viaje : \'--\'}}</td><td ng-class=\"{\'red-color\': data.error}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\">{{::data.Vuelo != null? data.Vuelo : \'--\'}}</td><td ng-class=\"{\'red-color\': data.error}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\">{{::data.Nombre_Solicitante != \"\"? data.Nombre_Solicitante : \'--\'}}</td><td ng-class=\"{\'red-color\': data.error}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\">{{vm.changeDateIntoSpanishNew(data.Retiro)}}</td><!-- <td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;\" style=\"width:125px;\">{{vm.changeDateIntoSpanish(data.job_delivery_datetime)}} {{data.job_delivery_datetime\n                                        | date: \'HH:mm\'}}</td> --><td ng-class=\"{\'red-color\': data.error}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\">{{::data.Pasajero != \"\"? data.Pasajero : \'--\'}}</td><td ng-class=\"{\'red-color\': data.error}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\">{{::data.Direccion_de_Retiro != \"\"? data.Direccion_de_Retiro : \'--\'}}</td><td ng-class=\"{\'red-color\': data.error}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\">{{::data.Nomina != \"\"? data.Nomina : \'--\'}}</td><td ng-class=\"{\'red-color\': data.error}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\">{{::data.package != \"\"? data.package : \'--\'}}</td><td ng-class=\"{\'red-color\': data.error}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\">{{::data.beforeCreationError != \"\"? data.beforeCreationError : \'--\'}}</td></tr></tbody></table></div></div></div><div class=row style=\"margin-top: 20px\"><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><button style=\"float: left\" type=button ng-click=vm.startCreatePackageProcess($event) class=\"btn btn-primary\">Crear Paquetes Masivamente</button></div><div class=\"col-lg-8 col-sm-8 col-md-8 col-xs-8\"><button style=\"float: left;background-color: red;color:white;border: red\" type=button ng-click=vm.cancelTheCreatePackageProcess() class=\"btn btn-primary\">Cancelar</button></div></div><!-- <div class=\"row\" style=\"margin-top: 20px;\">\n                <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">\n                    <button style=\"float: left;background-color: red;color:white;border: red;\" type=\"button\" ng-click=\"vm.cancelTheCreatePackageProcess()\" class=\"btn btn-primary\">Cancelar</button>\n                </div>\n            </div> --></div></div></div><style>.panel {\n        /* height: 600px; */\n        /* margin-bottom: 20px; */\n        background-color: #fff;\n        border-left: 1px solid black;\n        border-right: 1px solid black;\n        border-bottom: 1px solid black;\n        margin-top: 0px;\n        border-radius: 4px;\n        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n    }\n\n    /* table,\n    th,\n    td {\n        border: 1px solid grey;\n        border-collapse: collapse;\n        padding: 5px;\n    } */\n\n    table tr:nth-child(odd) {\n        background-color: #d4cfcf;\n        ;\n    }\n\n    #darkGrey {\n        background-color: #d4cfcf;\n        font-weight: bold;\n    }\n\n    .table-hover>tbody>tr:nth-child(odd) {\n        background-color: #ffffff;\n    }\n\n    .table-hover>tbody>tr:nth-child(even) {\n        background-color: #ffffff;\n    }\n\n    table tr:nth-child(even) {\n        background-color: #ffffff;\n    }\n\n\n\n    .modifyName {\n        font-size: 30px;\n        font-weight: bold;\n        margin-left: 15px;\n    }\n\n    .diaMainDiv {\n        margin-left: 15px;\n        font-size: 18px;\n        font-weight: 530;\n    }\n\n    .grabarButton {\n        height: 54px;\n        width: 200px;\n        text-align: center;\n        background-color: #70AD46;\n        font-size: 20px;\n        font-weight: 400;\n        color: black;\n        font-weight: bold;\n    }\n\n    .butttonSpan {\n        position: absolute;\n        left: 350px;\n        top: 100px;\n    }\n\n    .nav-tabs .nav-item.show .nav-link,\n    .nav-tabs .nav-link.active {\n        text-align: center;\n        height: 40px;\n        line-height: 2;\n        font-size: 18px;\n        position: relative;\n        font-weight: bold;\n        text-decoration: underline;\n        width: 100px;\n        color: orange;\n        background-color: #fff;\n        border-left: 1px solid black;\n        border-right: 1px solid black;\n        border-top: 1px solid black;\n        /* border-color: #dee2e6 #dee2e6 #fff; */\n    }\n\n    .nav-tabs .nav-link {\n        border: 1px solid transparent;\n        border-top-left-radius: .25rem;\n        border-top-right-radius: .25rem;\n        color: #888888;\n        text-decoration: none;\n        background-color: transparent;\n        height: 40px;\n        line-height: 2;\n        font-size: 18px;\n        font-weight: bold;\n        width: 100px;\n        text-align: center;\n    }\n\n\n    .nav {\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n        padding-left: 0;\n        margin-bottom: 0;\n        list-style: none;\n    }\n\n    article,\n    aside,\n    figcaption,\n    figure,\n    footer,\n    header,\n    hgroup,\n    main,\n    nav,\n    section {\n        display: block;\n    }\n\n    .nav-tabs {\n        border-bottom: 1px solid black;\n    }\n\n    .bd-example-tabs .nav-tabs {\n        margin-bottom: 1rem;\n    }\n\n    .divClassNav {\n        min-width: 100%;\n        border: 2px solid #fff;\n        position: absolute;\n        bottom: -5px;\n    }\n\n    .red-color {\n        background-color: red;\n    }</style>");
$templateCache.put("app/components/views/massive-create-booking/massiveCreateBookingNewMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/massive-create-booking-new-page/massiveCreateBookingNewScreen.html","<h2 class=ng-cloak><span>{{\'massiveCreateBookingHeadNew\' | translate}}</span></h2><head><meta charset=UTF-8></head><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt10\" style=\"font-size: 18px;font-weight: bold\">Lineas del archivo: {{vm.achiveLines}}</div></div><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt10\" style=\"font-size: 18px;font-weight: bold;color: red\">Lineas con error : {{vm.errorLines}}</div></div><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt10\"><div style=\"margin-top: 20px\" class=\"table-responsive tableWithMasterDataParentDive\" ng-switch=\"(vm.driverList | filter:vm.search).length\"><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=\"width: 125px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Convenio</th><th style=\"width: 125px\" current-text=vm.predicate title=Vehículo text=\"\'unique_car_id\'\" check=vm.reverse>Tipo de Servicio</th><th style=\"width: 125px\" current-text=vm.predicate title=Conductor text=\"\'fleet_name\'\" check=vm.reverse>Método de Pago</th><th style=\"width: 125px\" current-text=vm.predicate title=Conductor text=\"\'fleet_name\'\" check=vm.reverse>Tipo de Viaje</th><th style=\"width: 125px\" current-text=vm.predicate title=Conductor text=\"\'fleet_name\'\" check=vm.reverse>Tipo de reserva</th><th style=\"width: 125px\" current-text=vm.predicate title=Entrada text=\"\'entry_time\'\" check=vm.reverse>Nombre completo del cliente</th><th style=\"width: 125px\" current-text=vm.predicate title=Acción text=\"\'unique_car_id\'\" check=vm.reverse>Email Cliente</th><th style=\"width: 125px\" current-text=vm.predicate title=\"con Pax\" text=\"\'unique_car_id\'\" check=vm.reverse>Teléfono Cliente</th><th style=\"width: 125px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Número de Pasajeros</th><th style=\"width: 125px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Dirección de Retiro</th><th style=\"width: 125px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Dirección de Destino</th><th style=\"width: 125px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Referencia Dirección de Recogida</th><th style=\"width: 125px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Observaciones</th><th style=\"width: 125px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Fecha</th><th style=\"width: 125px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Hora</th><th style=\"width: 125px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Pasajero RUT</th><th style=\"width: 125px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Rut Solicitante</th><th style=\"width: 125px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Centro de Costo</th><th style=\"width: 125px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Centro SubCost</th><th style=\"width: 125px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>ROL</th><th style=\"width: 125px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Grafo</th><th style=\"width: 125px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Orden de trabajo</th><th style=\"width: 125px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>PEP</th><th style=\"width: 125px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Número Vale</th><th style=\"width: 125px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Nomina</th><th style=\"width: 125px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Solicitud</th><th style=\"width: 125px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Propósito de viaje</th><th style=\"width: 125px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Nombre de la aerolínea</th><th style=\"width: 125px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Número de vuelo</th><th style=\"width: 125px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Tipo de vuelo</th><th style=\"width: 125px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Fecha de vuelo</th><th style=\"width: 125px\" current-text=vm.predicate title=Pax text=\"\'unique_car_id\'\" check=vm.reverse>Detalle</th></tr></thead><tbody><tr ng-repeat=\"data in  vm.CsvData\"><td ng-class=\"{\'red-color\': data.error}\" style=width:125px>{{::data.contract_name != \"\"? data.contract_name : \'--\'}}</td><td ng-class=\"{\'red-color\': data.error}\" style=width:125px>{{::data.service_name != \"\"? data.service_name : \'--\'}}</td><td ng-class=\"{\'red-color\': data.error}\" style=width:125px>{{::data.payment_method_name != \"\"? data.payment_method_name : \'--\'}}</td><td ng-class=\"{\'red-color\': data.error}\" style=width:125px>{{::data.type_of_trip != \"\"? data.type_of_trip : \'--\'}}</td><td ng-class=\"{\'red-color\': data.error}\" style=width:125px>{{::data.booking_type != \"\"? data.booking_type : \'--\'}}</td><td ng-class=\"{\'red-color\': data.error}\" style=width:125px>{{::data.Nombre_completo_del_cliente != \"\"? data.Nombre_completo_del_cliente : \'--\'}}</td><td ng-class=\"{\'red-color\': data.error}\" style=width:125px>{{::data.Email_Cliente != \"\"? data.Email_Cliente : \'--\'}}</td><td ng-class=\"{\'red-color\': data.error}\" style=width:125px>{{::data.telephone_number != \"\"? data.telephone_number : \'--\'}}</td><td ng-class=\"{\'red-color\': data.error}\" style=width:125px>{{::data.No_of_passenger != \"\"? data.No_of_passenger : \'--\'}}</td><td ng-class=\"{\'red-color\': data.error}\" style=width:125px>{{::data.pickup_address != \"\"? data.pickup_address : \'--\'}}</td><td ng-class=\"{\'red-color\': data.error}\" style=width:125px>{{::data.dropoff_address != \"\"? data.dropoff_address : \'--\'}}</td><td ng-class=\"{\'red-color\': data.error}\" style=width:125px>{{::data.Reference != \"\"? data.Reference : \'--\'}}</td><td ng-class=\"{\'red-color\': data.error}\" style=width:125px>{{::data.Observaciones ? data.Observaciones : \'--\' }}</td><td ng-class=\"{\'red-color\': data.error}\" style=width:125px>{{vm.changeDateIntoSpanish(data.Fecha_Recogida_Programada)}}</td><td ng-class=\"{\'red-color\': data.error}\" style=width:125px>{{data.Hora_Recogida | date: \'HH:mm\'}}</td><td ng-class=\"{\'red-color\': data.error}\" style=width:125px>{{::data.Pasajero_RUT ? data.Pasajero_RUT : \'--\' }}</td><td ng-class=\"{\'red-color\': data.error}\" style=width:125px>{{::data.Rut_Solicitante ? data.Rut_Solicitante : \'--\' }}</td><td ng-class=\"{\'red-color\': data.error}\" style=width:125px>{{::data.Centro_de_Costo ? data.Centro_de_Costo : \'--\' }}</td><td ng-class=\"{\'red-color\': data.error}\" style=width:125px>{{::data.Centro_SubCost ? data.Centro_SubCost : \'--\' }}</td><td ng-class=\"{\'red-color\': data.error}\" style=width:125px>{{::data.ROL ? data.ROL : \'--\' }}</td><td ng-class=\"{\'red-color\': data.error}\" style=width:125px>{{::data.Grafo ? data.Grafo : \'--\' }}</td><td ng-class=\"{\'red-color\': data.error}\" style=width:125px>{{::data.Orden_de_trabajo ? data.Orden_de_trabajo : \'--\' }}</td><td ng-class=\"{\'red-color\': data.error}\" style=width:125px>{{::data.PEP ? data.PEP : \'--\' }}</td><td ng-class=\"{\'red-color\': data.error}\" style=width:125px>{{::data.no_of_vocher ? data.no_of_vocher : \'--\' }}</td><td ng-class=\"{\'red-color\': data.error}\" style=width:125px>{{::data.Nomina ? data.Nomina : \'--\' }}</td><td ng-class=\"{\'red-color\': data.error}\" style=width:125px>{{::data.Solicitud ? data.Solicitud : \'--\' }}</td><td ng-class=\"{\'red-color\': data.error}\" style=width:125px>{{::data.purpose_de_viaje ? data.purpose_de_viaje : \'--\' }}</td><td ng-class=\"{\'red-color\': data.error}\" style=width:125px>{{::data.name_of_airline ? data.name_of_airline : \'--\' }}</td><td ng-class=\"{\'red-color\': data.error}\" style=width:125px>{{::data.flight_number ? data.flight_number : \'--\' }}</td><td ng-class=\"{\'red-color\': data.error}\" style=width:125px>{{::data.Tipo_de_vuelo ? data.Tipo_de_vuelo : \'--\' }}</td><td ng-class=\"{\'red-color\': data.error}\" style=width:125px>{{::data.Fecha_de_vuelo ? data.Fecha_de_vuelo : \'--\' }}</td><td ng-class=\"{\'red-color\': data.error}\" style=width:125px><span ng-if=\"data.beforeCreationError != null && data.error\">{{::data.beforeCreationError}} </span><span ng-if=\"data.afterCreationError != null && data.error\">, {{::data.afterCreationError}}</span> <span ng-if=!data.error>{{data.Detalle}}</span></td></tr></tbody></table></div></div></div></div></div><div class=row style=\"padding-top: 20px\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><button type=button class=\"btn btn-primary\" ng-click=vm.downloadData()>Descargar Detalle</button> <button type=button class=\"btn btn-primary\" ng-click=vm.refreshPage()>Finalizar</button></div></div></div><style>.panel {\n        /* height: 600px; */\n        /* margin-bottom: 20px; */\n        background-color: #fff;\n        border-left: 1px solid black;\n        border-right: 1px solid black;\n        border-bottom: 1px solid black;\n        margin-top: 0px;\n        border-radius: 4px;\n        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n    }\n\n    table,\n    th,\n    td {\n        border: 1px solid grey;\n        border-collapse: collapse;\n        padding: 5px;\n    }\n\n    table tr:nth-child(odd) {\n        background-color: #d4cfcf;\n        ;\n    }\n\n    #darkGrey {\n        background-color: #d4cfcf;\n        font-weight: bold;\n    }\n\n    .table-hover>tbody>tr:nth-child(odd) {\n        background-color: #ffffff;\n    }\n\n    .table-hover>tbody>tr:nth-child(even) {\n        background-color: #ffffff;\n    }\n\n    table tr:nth-child(even) {\n        background-color: #ffffff;\n    }\n\n\n\n    .modifyName {\n        font-size: 30px;\n        font-weight: bold;\n        margin-left: 15px;\n    }\n\n    .diaMainDiv {\n        margin-left: 15px;\n        font-size: 18px;\n        font-weight: 530;\n    }\n\n    .grabarButton {\n        height: 54px;\n        width: 200px;\n        text-align: center;\n        background-color: #70AD46;\n        font-size: 20px;\n        font-weight: 400;\n        color: black;\n        font-weight: bold;\n    }\n\n    .butttonSpan {\n        position: absolute;\n        left: 350px;\n        top: 100px;\n    }\n\n    .nav-tabs .nav-item.show .nav-link,\n    .nav-tabs .nav-link.active {\n        text-align: center;\n        height: 40px;\n        line-height: 2;\n        font-size: 18px;\n        position: relative;\n        font-weight: bold;\n        text-decoration: underline;\n        width: 100px;\n        color: orange;\n        background-color: #fff;\n        border-left: 1px solid black;\n        border-right: 1px solid black;\n        border-top: 1px solid black;\n        /* border-color: #dee2e6 #dee2e6 #fff; */\n    }\n\n    .nav-tabs .nav-link {\n        border: 1px solid transparent;\n        border-top-left-radius: .25rem;\n        border-top-right-radius: .25rem;\n        color: #888888;\n        text-decoration: none;\n        background-color: transparent;\n        height: 40px;\n        line-height: 2;\n        font-size: 18px;\n        font-weight: bold;\n        width: 100px;\n        text-align: center;\n    }\n\n\n    .nav {\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n        padding-left: 0;\n        margin-bottom: 0;\n        list-style: none;\n    }\n\n    article,\n    aside,\n    figcaption,\n    figure,\n    footer,\n    header,\n    hgroup,\n    main,\n    nav,\n    section {\n        display: block;\n    }\n\n    .nav-tabs {\n        border-bottom: 1px solid black;\n    }\n\n    .bd-example-tabs .nav-tabs {\n        margin-bottom: 1rem;\n    }\n\n    .divClassNav {\n        min-width: 100%;\n        border: 2px solid #fff;\n        position: absolute;\n        bottom: -5px;\n    }\n\n    .red-color {\n        background-color: red;\n    }\n    .red-color-text{\n        color: red;\n    }</style>");
$templateCache.put("app/components/views/massive-create-booking-new-page/massiveCreateBookingNewpageMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/massive-create-package-new-page/massiveCreatePackageNewScreen.html","<h2 class=ng-cloak><span>{{\'massiveCreateBookingHead\' | translate}}</span></h2><head><meta charset=UTF-8></head><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row ng-if=\"vm.previewPackageData.length > 0\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt10\"><div style=\"margin-top: 20px\" class=\"table-responsive tableWithMasterDataParentDive\" ng-switch=\"(vm.driverList | filter:vm.search).length\"><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Package</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Reserva</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Shared Service ID</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Sucursal</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Convenio</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Tipo_Viaje</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Tipo Servicio</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Nombre Solicitante</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Retiro</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Pasajero</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Dirección_de_Retiro</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Vuelo</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Nómina</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Estado</th></tr></thead><tbody ng-if=\"vm.previewPackageData.length > 0\"><tr ng-repeat=\"data in  vm.previewPackageData\"><td ng-class=\"{\'red-color\': data.Estado != \'OK\'}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\">{{data.group_key ? data.group_key: \'--\'}}</td><td ng-class=\"{\'red-color\': data.Estado != \'OK\'}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\">{{::data.Reserva != \"\"? data.Reserva : \'--\'}}</td><td ng-class=\"{\'red-color\': data.Estado != \'OK\'}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\">{{::data.Detalle != \"\"? data.Detalle : \'--\'}}</td><td ng-class=\"{\'red-color\': data.Estado != \'OK\'}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\">{{::data.Sucursal != \"\"? data.Sucursal : \'--\'}}</td><td ng-class=\"{\'red-color\': data.Estado != \'OK\'}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\">{{::data.Convenio != \"\"? data.Convenio : \'--\'}}</td><td ng-class=\"{\'red-color\': data.Estado != \'OK\'}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\">{{::data.Tipo_Viaje != \"\"? data.Tipo_Viaje : \'--\'}}</td><td ng-class=\"{\'red-color\': data.Estado != \'OK\'}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\">{{::data.Tipo_Servicio != null? data.Tipo_Servicio : \'--\'}}</td><td ng-class=\"{\'red-color\': data.Estado != \'OK\'}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\">{{::data.Nombre_Solicitante != \"\"? data.Nombre_Solicitante : \'--\'}}</td><td ng-class=\"{\'red-color\': data.Estado != \'OK\'}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\">{{data.Retiro}}</td><td ng-class=\"{\'red-color\': data.Estado != \'OK\'}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\">{{::data.Pasajero != \"\"? data.Pasajero : \'--\'}}</td><td ng-class=\"{\'red-color\': data.Estado != \'OK\'}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\">{{::data.Direccion_de_Retiro != \"\"? data.Direccion_de_Retiro : \'--\'}}</td><td ng-class=\"{\'red-color\': data.Estado != \'OK\'}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\">{{::data.Vuelo != \"\"? data.Vuelo : \'--\'}}</td><td ng-class=\"{\'red-color\': data.Estado != \'OK\'}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\">{{::data.Nomina != \"\"? data.Nomina : \'--\'}}</td><td ng-class=\"{\'red-color\': data.Estado != \'OK\'}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\">{{::data.afterPackageCreationError != null ? data.afterPackageCreationError : data.beforeCreationError != null ? data.beforeCreationError : data.Estado}}</td><!-- <td style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px;\">{{::data.afterPackageCreationError != null ? data.afterPackageCreationError : data.beforeCreationError\n                                        != null ? data.beforeCreationError : data.Estado}}</td> --></tr></tbody></table></div></div></div><div class=row style=\"margin-top: 20px\"><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-3\"><button style=\"float: left\" type=button ng-click=vm.downloadData() class=\"btn btn-primary\">Descargar Detalle</button></div><div class=\"col-lg-9 col-sm-9 col-md-9 col-xs-9\"><button style=\"float: left;background-color: red;color:white;border: red\" type=button ng-click=vm.refreshPage() class=\"btn btn-primary\">Finalizar</button></div></div><!-- <div class=\"row\" style=\"margin-top: 20px;\">\n                <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">\n                    <button style=\"float: left;background-color: red;color:white;border: red;\" type=\"button\" ng-click=\"vm.cancelTheCreatePackageProcess()\" class=\"btn btn-primary\">Cancelar</button>\n                </div>\n            </div> --></div></div></div><style>.panel {\n        /* height: 600px; */\n        /* margin-bottom: 20px; */\n        background-color: #fff;\n        border-left: 1px solid black;\n        border-right: 1px solid black;\n        border-bottom: 1px solid black;\n        margin-top: 0px;\n        border-radius: 4px;\n        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n    }\n\n    table,\n    th,\n    td {\n        border: 1px solid grey;\n        border-collapse: collapse;\n        padding: 5px;\n    }\n\n    table tr:nth-child(odd) {\n        background-color: #d4cfcf;\n        ;\n    }\n\n    #darkGrey {\n        background-color: #d4cfcf;\n        font-weight: bold;\n    }\n\n    .table-hover>tbody>tr:nth-child(odd) {\n        background-color: #ffffff;\n    }\n\n    .table-hover>tbody>tr:nth-child(even) {\n        background-color: #ffffff;\n    }\n\n    table tr:nth-child(even) {\n        background-color: #ffffff;\n    }\n\n\n\n    .modifyName {\n        font-size: 30px;\n        font-weight: bold;\n        margin-left: 15px;\n    }\n\n    .diaMainDiv {\n        margin-left: 15px;\n        font-size: 18px;\n        font-weight: 530;\n    }\n\n    .grabarButton {\n        height: 54px;\n        width: 200px;\n        text-align: center;\n        background-color: #70AD46;\n        font-size: 20px;\n        font-weight: 400;\n        color: black;\n        font-weight: bold;\n    }\n\n    .butttonSpan {\n        position: absolute;\n        left: 350px;\n        top: 100px;\n    }\n\n    .nav-tabs .nav-item.show .nav-link,\n    .nav-tabs .nav-link.active {\n        text-align: center;\n        height: 40px;\n        line-height: 2;\n        font-size: 18px;\n        position: relative;\n        font-weight: bold;\n        text-decoration: underline;\n        width: 100px;\n        color: orange;\n        background-color: #fff;\n        border-left: 1px solid black;\n        border-right: 1px solid black;\n        border-top: 1px solid black;\n        /* border-color: #dee2e6 #dee2e6 #fff; */\n    }\n\n    .nav-tabs .nav-link {\n        border: 1px solid transparent;\n        border-top-left-radius: .25rem;\n        border-top-right-radius: .25rem;\n        color: #888888;\n        text-decoration: none;\n        background-color: transparent;\n        height: 40px;\n        line-height: 2;\n        font-size: 18px;\n        font-weight: bold;\n        width: 100px;\n        text-align: center;\n    }\n\n\n    .nav {\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n        padding-left: 0;\n        margin-bottom: 0;\n        list-style: none;\n    }\n\n    article,\n    aside,\n    figcaption,\n    figure,\n    footer,\n    header,\n    hgroup,\n    main,\n    nav,\n    section {\n        display: block;\n    }\n\n    .nav-tabs {\n        border-bottom: 1px solid black;\n    }\n\n    .bd-example-tabs .nav-tabs {\n        margin-bottom: 1rem;\n    }\n\n    .divClassNav {\n        min-width: 100%;\n        border: 2px solid #fff;\n        position: absolute;\n        bottom: -5px;\n    }\n\n    .red-color {\n        background-color: red;\n    }</style>");
$templateCache.put("app/components/views/massive-create-package-new-page/massiveCreatePackageNewpageMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/massive-modify-booking/massiveModifyBookingNewpage.html","<h2 class=ng-cloak><span>{{\'massiveCreateBookingHeadNew\' | translate}}</span></h2><head><meta charset=UTF-8></head><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt10\" style=\"font-size: 18px;font-weight: bold\">Lineas del archivo: {{vm.achiveLines}}</div></div><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt10\" style=\"font-size: 18px;font-weight: bold;color: red\">Lineas con error : {{vm.errorLines}}</div></div><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt10\"><div style=\"margin-top: 20px\" class=\"table-responsive tableWithMasterDataParentDive\" ng-switch=\"(vm.driverList | filter:vm.search).length\"><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>id</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Reserva</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Sucursal</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Convenio</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Tipo Servicio</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Tipo Viaje</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Vuelo</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Nombre Solicitante</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Retiro</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Presentación</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Pasajero</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Dirección Retiro</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Nómina</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Estado</th><th style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse>Detalle</th></tr></thead><tbody when-scrolled=vm.paginationForData()><tr ng-repeat=\"data in  vm.bookingData\"><td ng-class=\"{\'red-color\': data.estado != \'Ok\'}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{$index + 1}}</td><td ng-class=\"{\'red-color\': data.estado != \'Ok\'}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{::data.job_id != \"\"? data.job_id : \'--\'}}</td><td ng-class=\"{\'red-color\': data.estado != \'Ok\'}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{::data.branch_name != \"\"? data.branch_name : \'--\'}}</td><td ng-class=\"{\'red-color\': data.estado != \'Ok\'}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{::data.contract_name != \"\"? data.contract_name : \'--\'}}</td><td ng-class=\"{\'red-color\': data.estado != \'Ok\'}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{::data.service_name != \"\"? data.service_name : \'--\'}}</td><td ng-class=\"{\'red-color\': data.estado != \'Ok\'}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{::data.type_of_trip != \"\"? data.type_of_trip : \'--\'}}</td><td ng-class=\"{\'red-color\': data.estado != \'Ok\'}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{::data.flight_number != null? data.flight_number : \'--\'}}</td><td ng-class=\"{\'red-color\': data.estado != \'Ok\'}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{::data.job_pickup_name != \"\"? data.job_pickup_name : \'--\'}}</td><td ng-class=\"{\'red-color\': data.estado != \'Ok\'}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{vm.changeDateIntoSpanish(data.job_time_utc)}} {{data.job_time_utc | date: \'HH:mm\'}}</td><td ng-class=\"{\'red-color\': data.estado != \'Ok\'}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{vm.changeDateIntoSpanish(data.job_delivery_datetime)}} {{data.job_delivery_datetime | date: \'HH:mm\'}}</td><td ng-class=\"{\'red-color\': data.estado != \'Ok\'}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{::data.number_of_passangers != \"\"? data.number_of_passangers : \'--\'}}</td><td ng-class=\"{\'red-color\': data.estado != \'Ok\'}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{::data.job_pickup_address != \"\"? data.job_pickup_address : \'--\'}}</td><td ng-class=\"{\'red-color\': data.estado != \'Ok\'}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{::data.nomina != \"\"? data.nomina : \'--\'}}</td><td ng-class=\"{\'red-color\': data.estado != \'Ok\'}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" style=width:125px>{{data.estado}}</td><td style=width:125px style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px\" ng-class=\"{\'red-color\': data.estado != \'Ok\'}\">{{data.detalle}}</td></tr></tbody></table></div></div></div></div></div><div class=row style=\"padding-top: 20px\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><button type=button class=\"btn btn-primary\" ng-click=vm.downloadData()>Descargar Detalle</button> <button type=button class=\"btn btn-primary\" ng-click=vm.refreshPage()>Finalizar</button></div></div></div><style>.panel {\n        /* height: 600px; */\n        /* margin-bottom: 20px; */\n        background-color: #fff;\n        border-left: 1px solid black;\n        border-right: 1px solid black;\n        border-bottom: 1px solid black;\n        margin-top: 0px;\n        border-radius: 4px;\n        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n    }\n\n    table,\n    th,\n    td {\n        border: 1px solid grey;\n        border-collapse: collapse;\n        padding: 5px;\n    }\n\n    table tr:nth-child(odd) {\n        background-color: #d4cfcf;\n        ;\n    }\n\n    #darkGrey {\n        background-color: #d4cfcf;\n        font-weight: bold;\n    }\n\n    .table-hover>tbody>tr:nth-child(odd) {\n        background-color: #ffffff;\n    }\n\n    .table-hover>tbody>tr:nth-child(even) {\n        background-color: #ffffff;\n    }\n\n    table tr:nth-child(even) {\n        background-color: #ffffff;\n    }\n\n\n\n    .modifyName {\n        font-size: 30px;\n        font-weight: bold;\n        margin-left: 15px;\n    }\n\n    .diaMainDiv {\n        margin-left: 15px;\n        font-size: 18px;\n        font-weight: 530;\n    }\n\n    .grabarButton {\n        height: 54px;\n        width: 200px;\n        text-align: center;\n        background-color: #70AD46;\n        font-size: 20px;\n        font-weight: 400;\n        color: black;\n        font-weight: bold;\n    }\n\n    .butttonSpan {\n        position: absolute;\n        left: 350px;\n        top: 100px;\n    }\n\n    .nav-tabs .nav-item.show .nav-link,\n    .nav-tabs .nav-link.active {\n        text-align: center;\n        height: 40px;\n        line-height: 2;\n        font-size: 18px;\n        position: relative;\n        font-weight: bold;\n        text-decoration: underline;\n        width: 100px;\n        color: orange;\n        background-color: #fff;\n        border-left: 1px solid black;\n        border-right: 1px solid black;\n        border-top: 1px solid black;\n        /* border-color: #dee2e6 #dee2e6 #fff; */\n    }\n\n    .nav-tabs .nav-link {\n        border: 1px solid transparent;\n        border-top-left-radius: .25rem;\n        border-top-right-radius: .25rem;\n        color: #888888;\n        text-decoration: none;\n        background-color: transparent;\n        height: 40px;\n        line-height: 2;\n        font-size: 18px;\n        font-weight: bold;\n        width: 100px;\n        text-align: center;\n    }\n\n\n    .nav {\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n        padding-left: 0;\n        margin-bottom: 0;\n        list-style: none;\n    }\n\n    article,\n    aside,\n    figcaption,\n    figure,\n    footer,\n    header,\n    hgroup,\n    main,\n    nav,\n    section {\n        display: block;\n    }\n\n    .nav-tabs {\n        border-bottom: 1px solid black;\n    }\n\n    .bd-example-tabs .nav-tabs {\n        margin-bottom: 1rem;\n    }\n\n    .divClassNav {\n        min-width: 100%;\n        border: 2px solid #fff;\n        position: absolute;\n        bottom: -5px;\n    }\n\n    .red-color {\n        background-color: red;\n    }\n\n    .tableWithMasterData tbody {\n        display: contents !important;\n        max-height: 400px;\n        overflow-y: auto;\n        overflow-x: hidden !important;\n    }</style>");
$templateCache.put("app/components/views/massive-modify-booking/massiveModifyBookingNewpageMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/matriz-flota/fleetCapacityMatrix.html","<h2 class=ng-cloak><span>{{\'matrixHead\' | translate}}</span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><!--<filter-sidebar show-filter-sidebar=\"vm.showFilterFlag\" filter-data=\"vm.filterData\" filter-to-show=\"vm.filterWhichToShow\" branch-detail-changed=\"vm.branchChangedFilter(vm.filterData)\"--><!--modelity-detail-changed=\"vm.modelityChangedFilter(vm.filterData)\" approval-stage-detail-changed=\"vm.approvalChangedFilter(vm.filterData)\" applicant-detail-changed=\"vm.applicantChangedFilter(vm.filterData)\"></filter-sidebar>--><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><!-- <div class=\"row\">\n                        <div class=\"col-sm-6 col-md-6 col-lg-6 text-left\" style=\"padding: 15px;background-color: aqua;\">\n                            <p style=\"font-size:15px;\">Estado</p>\n                            \n                            <select class=\"form-control\" ng-model=\"vm.estado\" ng-change=\"vm.approvalValueChanged()\" style=\"max-width: 300px;\">\n                                <option id=\"1\" value=\"1\">Activas</option>\n                                <option id=\"2\" value=\"2\">Inactivas</option>\n                                <option id=\"3\" value=\"3\">Todas</option>\n                            </select>\n\n                        </div>\n                        <div class=\"col-sm-6 col-md-6 col-lg-6 text-right\" style=\"padding: 15px;background-color: red;height: 85.5px;\">\n                            <a class=\"btn btn-primary\" title=\"Crear instancia\" ng-click=\"vm.createAndEdit()\">\n                                <i class=\"fa fa-plus\" style=\"border:none\"></i>\n                                Nueva Matriz\n                            </a>\n                        </div>\n                    </div> --><div><div class=row><div class=\"col-sm-3 col-md-3 col-lg-3 text-left\" style=\"padding: 15px\"><p style=font-size:15px>Estado</p><select data-testid=seleccionar_estado class=form-control ng-model=vm.estado ng-change=vm.approvalValueChanged() style=\"max-width: 300px\"><!-- <option value=\"\" disabled>Seleccionar día de la semana</option> --><option data-testid=opcion_activas id=1 value=1>Activas</option><option data-testid=opcion_inactivas id=2 value=2>Inactivas</option><option data-testid=opcion_todas id=3 value=3>Todas</option></select></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-3 text-left\" style=\"padding: 15px\"><p style=font-size:15px>Sucursal</p><select data-testid=seleccionar_sucursal class=form-control ng-model=vm.sucursal_id ng-change=vm.branchChanged(0,vm.sucursal_id) style=\"max-width: 300px\" ng-options=\"branch.region_id as branch.region_name for branch in vm.branchList\"><option value=\"\">Todas</option></select></div><!--<div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-3 text-left\" style=\"padding: 15px;\">\n                            <p style=\"font-size:15px;\">Tipo de servicio</p>\n                           \n                            <select class=\"form-control\" ng-model=\"vm.type_of_service_id\" ng-change=\"vm.branchChanged(0,vm.sucursal_id)\" style=\"max-width: 300px;\"\n                            ng-options=\"service.id as service.type_of_service_id.service_name for service in vm.serviceList\" >\n                                <option value=\"\">Todos</option>\n                            </select>\n                        </div> --><div class=\"col-sm-3 col-md-3 col-lg-3 text-right\" style=\"padding: 15px\"><p style=\"font-size:15px;color: transparent\">Estado</p><a data-testid=btn_nueva_matriz class=\"btn btn-primary\" title=\"Crear instancia\" ng-click=vm.createAndEdit()><i class=\"fa fa-plus\" style=border:none></i> Nueva Matriz</a></div></div></div><div class=\"panel panel-default\"><div class=panel-body><div class=table-responsive><table class=\"table table-hover\"><thead><tr style=\"border: none !important\"><th style=\"width:30px;border: none !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 16px;font-weight: 700\">Nombre</p></th><th style=\"width:30px;border: none !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 16px;font-weight: 700\">Sucursal</p></th><th style=\"width:30px;border: none !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 16px;font-weight: 700\">Tipo de Servicio</p></th><th style=\"width:30px;border: none !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 16px;font-weight: 700\">Estado</p></th><th style=\"width:30px;border: none !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 16px;font-weight: 700\">Acción</p></th></tr></thead><!-- ACTIVAS --><tbody ng-if=\"vm.estado == 1\"><tr ng-repeat=\"data in vm.activeFleet\"><td ng-if=\"data.status == 1 && (!vm.sucursal_id || data.sucursalId == vm.sucursal_id)\" style=width:140px><p data-testid=nombre_matriz style=\"font-size: 18px;text-transform:capitalize\">{{ data.nombre }}</p></td><td data-testid=nombre_sucursal ng-if=\"data.status == 1 && (!vm.sucursal_id || data.sucursalId == vm.sucursal_id)\" style=width:140px><p style=\"font-size: 18px;text-transform:capitalize\">{{ data.sucursal.regionName }}</p></td><td data-testid=nombre_tipo_servicio ng-if=\"data.status == 1 && (!vm.sucursal_id || data.sucursalId == vm.sucursal_id)\" style=width:140px><p style=\"font-size: 18px;text-transform:capitalize\" ng-repeat=\"service in data.matrizFlotaTypeOfService\">{{ service.typeOfService.serviceName }}</p></td><td ng-if=\"data.status == 1 && (!vm.sucursal_id || data.sucursalId == vm.sucursal_id)\" style=\"width: 150px\"><div><a data-testid=btn_desbloqueo class=\"cursor btn btn-sm unblockIconColor\" ng-click=vm.changeState($event,data)><i class=\"fa fa-unlock\"></i></a></div></td><td ng-if=\"data.status == 1 && (!vm.sucursal_id || data.sucursalId == vm.sucursal_id)\" style=\"width: 150px\"><div><a data-testid=btn_crear_editar title=\"Edit Details\" class=\"cursor btn btn-sm editIconColor\" ng-click=vm.createAndEdit(data,vm.estado)><i class=\"fa fa-edit\"></i> </a><a data-testid=btn_ver_detalle title=\"View Details\" class=\"cursor btn btn-sm editIconColor\" ng-click=vm.viewDetail(data)><i class=\"fa fa-eye\"></i> </a><a data-testid=btn_eliminar class=\"cursor btn btn-sm blockIconColor\" ng-click=vm.deleteMatrix($event,data)><i class=\"fa fa-trash\"></i></a></div></td></tr></tbody><!-- INACTIVAS --><tbody ng-if=\"vm.estado == 2\"><tr ng-repeat=\"data in vm.activeFleet\"><td ng-if=\"data.status == 0 && (!vm.sucursal_id || data.sucursalId == vm.sucursal_id)\" style=width:140px><p data-testid=nombre_matriz2 style=\"font-size: 18px;text-transform: capitalize\">{{ data.nombre }}</p></td><td data-testid=nombre_region_matriz2 ng-if=\"data.status == 0 && (!vm.sucursal_id || data.sucursalId == vm.sucursal_id)\" style=width:140px><p style=\"font-size: 18px;text-transform: capitalize\">{{ data.sucursal.regionName }}</p></td><td data-testid=nombre_tipo_servicio2 ng-if=\"data.status == 0 && (!vm.sucursal_id || data.sucursalId == vm.sucursal_id)\" style=width:140px><p style=\"font-size: 18px;text-transform:capitalize\" ng-repeat=\"service in data.matrizFlotaTypeOfService\">{{ service.typeOfService.serviceName }}</p></td><td ng-if=\"data.status == 0 && (!vm.sucursal_id || data.sucursalId == vm.sucursal_id)\" style=\"width: 150px\"><div><a data-testid=btn_cambiar_estado2 class=\"cursor btn btn-sm editIconColor\" ng-click=vm.changeState($event,data)><i class=\"fa fa-lock\"></i></a></div></td><td ng-if=\"data.status == 0 && (!vm.sucursal_id || data.sucursalId == vm.sucursal_id)\" style=\"width: 150px\"><div><a data-testid=btn_editar_detalles2 title=\"Edit Details\" class=\"cursor btn btn-sm editIconColor\" ng-click=vm.createAndEdit(data,vm.estado)><i class=\"fa fa-edit\"></i> </a><a data-testid=btn_ver_detalle2 title=\"View Details\" class=\"cursor btn btn-sm editIconColor\" ng-click=vm.viewDetail(data)><i class=\"fa fa-eye\"></i> </a><a data-testid=btn_eliminar_matriz2 class=\"cursor btn btn-sm blockIconColor\" ng-click=vm.deleteMatrix($event,data)><i class=\"fa fa-trash\"></i></a></div></td></tr></tbody><!-- TODAS --><tbody ng-if=\"vm.estado == 3\"><tr ng-repeat=\"data in vm.activeFleet\"><td ng-if=\"vm.sucursal_id ? data.sucursalId == vm.sucursal_id : data.sucursalId != vm.sucursal_id\" style=width:140px><p data-testid=nombre_matriz3 style=\"font-size: 18px;text-transform: capitalize\">{{ data.nombre }}</p></td><td ng-if=\"vm.sucursal_id ? data.sucursalId == vm.sucursal_id : data.sucursalId != vm.sucursal_id\" style=width:140px><p data-testid=nombre_sucursal3 style=\"font-size: 18px;text-transform: capitalize\">{{ data.sucursal.regionName }}</p></td><td ng-if=\"vm.sucursal_id ? data.sucursalId == vm.sucursal_id : data.sucursalId != vm.sucursal_id\" style=width:140px><p data-testid=nombre_tipo_servicio3 style=\"font-size: 18px;text-transform:capitalize\" ng-repeat=\"service in data.matrizFlotaTypeOfService\">{{ service.typeOfService.serviceName }}</p></td><td ng-if=\"vm.sucursal_id ? data.sucursalId == vm.sucursal_id : data.sucursalId != vm.sucursal_id\" style=\"width: 150px\"><div><a data-testid=btn_cambio_estado3 class=\"cursor btn btn-sm\" ng-class=\"{\'editIconColor\': data.status == 0, \'unblockIconColor\': data.status == 1}\" ng-click=vm.changeState($event,data)><i ng-class=\"{\'fa fa-unlock\': data.status == 1,\'fa fa-lock\': data.status == 0}\"></i></a></div></td><td ng-if=\"vm.sucursal_id ? data.sucursalId == vm.sucursal_id : data.sucursalId != vm.sucursal_id\" style=\"width: 150px\"><div><a data-testid=btn_editar_detalles3 title=\"Edit Details\" class=\"cursor btn btn-sm editIconColor\" ng-click=vm.createAndEdit(data,vm.estado)><i class=\"fa fa-edit\"></i> </a><a data-testid=btn_ver_detalle3 title=\"View Details\" class=\"cursor btn btn-sm editIconColor\" ng-click=vm.viewDetail(data)><i class=\"fa fa-eye\"></i> </a><a data-testid=btn_eliminar_matriz3 class=\"cursor btn btn-sm blockIconColor\" ng-click=vm.deleteMatrix($event,data)><i class=\"fa fa-trash\"></i></a></div></td></tr></tbody></table></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/matriz-flota/fleetCapacityMatrixCalendar.html","<h2 class=ng-cloak><span>{{\'matrixHeadCreate\' | translate}}</span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><!--<filter-sidebar show-filter-sidebar=\"vm.showFilterFlag\" filter-data=\"vm.filterData\" filter-to-show=\"vm.filterWhichToShow\" branch-detail-changed=\"vm.branchChangedFilter(vm.filterData)\"--><!--modelity-detail-changed=\"vm.modelityChangedFilter(vm.filterData)\" approval-stage-detail-changed=\"vm.approvalChangedFilter(vm.filterData)\" applicant-detail-changed=\"vm.applicantChangedFilter(vm.filterData)\"></filter-sidebar>--><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6 text-left\" style=\"padding: 15px\"><p style=font-size:18px>Ver matriz de capacidad de flota</p></div></div><div class=\"panel panel-default\"><div class=panel-body><form name=formInstance ng-submit=guardar_datos(formInstance,$event) novalidate autocomplete=off><!-- <div class=\"row\">\n                                <div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12 text-left\">\n                                    <p style=\"font-size:15px;\">Sucursal</p>\n                                   \n                                    <ui-select ng-model=\"vm.dataForBlock.sucursal_id\" name=\"branch\" ng-change=\"vm.branchChanged(0,vm.dataForBlock.sucursal_id)\" required close-on-select=\"true\"\n                                        \n                                        >\n                                        <ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">\n                                            {{$select.selected.region_name}}\n                                        </ui-select-match>\n                                        <ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search\">\n                                            <div ng-bind-html=\"branch.region_name\"></div>\n                                        </ui-select-choices>\n                                    </ui-select>\n                                    <div ng-if=\"filterSharedForm.branch.$touched|| submit\" ng-messages=\"filterSharedForm.branch.$error\">\n                                        <div class=\"errormessage text-danger\" ng-message=\"required\">{{\'branchR\' | translate}}</div>\n                                    </div>\n                                </div>\n                            </div> --><div class=row><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12 text-left\"><p style=font-size:15px>Sucursal</p><div style=\"border: 1px solid;padding-left: 5px;padding-right: 5px;border-radius: 4px;width: 280px;border-color:#9f9b9b;padding-top: 2px;padding-bottom: 2px\"><p style=font-size:15px>{{vm.sucursal}}</p></div></div></div><div class=row style=\"margin-top: 40px\"><div class=\"col-sm-3 col-md-3 col-lg-3 text-left\"><p style=\"font-size:15px; font-weight: 700\">Bloques horario</p></div><div class=\"col-sm-2 col-md-2 col-lg-2\" style=\"width: 135px\"><a class=\"btn btn-primary\" ng-click=vm.handleList() style=padding-left:8px;padding-right:8px>Ver lista</a></div><div class=\"col-sm-2 col-md-2 col-lg-2\" style=\"width: 135px\"><a class=\"btn btn-default\" ng-click=vm.handleExceptions() style=\"padding-left:8px;padding-right:8px;color: black\">Ver excepciones</a></div><!-- <div class=\"col-sm-6 col-md-6 col-lg-6\" style=\"padding: 0px;margin-left: 10px;\">\n                                    <div ng-repeat=\"data in vm.tipoServicios\" class=\"col-md-4 col-sm-6 col-xs-12 \" style=\"padding: 0px\">\n                                        <button style=\"max-width: 180px;\" class=\"{{ vm.serviceSelected == data.id ? \'btn btn-primary\' : \'btn btn-default\'}}\" id=\"boxId1\" ng-click=\"vm.servicioSeleccionado(data.id)\">{{ data.nombre }}</button>\n                                    </div>\n                                </div> --><!-- <div class=\"col-sm-6 col-md-6 col-lg-6\" style=\"padding: 0px;margin-left: 10px;\">\n                                    <div ng-repeat=\"data in vm.tipoServicios\" class=\"col-md-4 col-sm-6 col-xs-12 \" style=\"padding: 0px\">\n                                        <button style=\"width: 99%; {{ vm.serviceSelected == data.id ? \'background-color: rgb(239, 125, 7); color: white\' : \'\' }}\" class=\"firstButton\" id=\"boxId1\" ng-click=\"vm.servicioSeleccionado(data.id)\">{{ data.nombre }}</button>\n                                    </div>\n                                   \n                                </div> --></div><div style=\"margin-bottom: 50px\"><div ui-calendar=uiConfig.calendar class=\"span8 calendar\" ng-model=eventSources></div></div><!--<div style=\"margin-bottom: 50px;\">\n                                <div ui-calendar=\"uiConfig.calendar\" class=\"span8 calendar\" ng-model=\"eventSourcesE\" ></div> \n                            </div>--><!-- <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-right mt5 mb0\">\n                                <div style=\"flex: 1;\">\n                                    <button class=\"btn\" ng-click=\"vm.cancel()\" type=\"button\" style=\"height: 35px;line-height: 20px;margin-right: 5px;\">Cancelar\n                                    </button>\n                                  \n            \n                                    <button ng-if=\"!vm.id\" class=\"btn btn-primary ng-binding\" type=\"submit\" style=\"height: 35px;line-height: 20px;\">\n                                        Guardar\n                                    </button>\n                                    <button ng-if=\"vm.id\" class=\"btn btn-primary ng-binding\" type=\"submit\" style=\"height: 35px;line-height: 20px;\">\n                                        Actualizar\n                                    </button>\n            \n                                </div>\n                            </div> --><div class=text-right><div style=\"flex: 1;margin-right: 1px\"><button class=\"btn btn-primary\" ng-click=vm.cancel() type=button style=\"height: 35px;line-height: 20px;margin-right: 5px;margin-left: 5px\">Volver</button></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/matriz-flota/fleetCapacityMatrixCreate.html","<h2 class=ng-cloak><span>{{\'matrixHeadCreate\' | translate}}</span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><!--<filter-sidebar show-filter-sidebar=\"vm.showFilterFlag\" filter-data=\"vm.filterData\" filter-to-show=\"vm.filterWhichToShow\" branch-detail-changed=\"vm.branchChangedFilter(vm.filterData)\"--><!--modelity-detail-changed=\"vm.modelityChangedFilter(vm.filterData)\" approval-stage-detail-changed=\"vm.approvalChangedFilter(vm.filterData)\" applicant-detail-changed=\"vm.applicantChangedFilter(vm.filterData)\"></filter-sidebar>--><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6 text-left\" style=\"padding: 15px\"><p style=font-size:18px>Nueva matriz de capacidad de flota</p></div></div><div class=\"panel panel-default\"><div class=panel-body><form name=formInstance ng-submit=guardar_datos(formInstance,$event) novalidate autocomplete=off><div class=row><div class=\"col-lg-2 col-sm-2 col-md-2 col-xs-12 text-left\"><p style=font-size:15px>Nombre</p><input data-testid=input_nombre_matriz ng-model=vm.dataForBlock.nombre class=form-control maxlength=65 name=nombre type=text required ng-change=vm.onChangeName(dataForInstance.nombre) value={{data.nombre}}></div><div class=\"col-lg-2 col-sm-2 col-md-2 col-xs-12 text-left\"><p style=font-size:15px>Sucursal</p><ui-select data-testid=select_sucursal class=sucursal-selector ng-model=vm.dataForBlock.sucursal_id name=branch ng-change=\"vm.branchChanged(0,vm.dataForBlock.sucursal_id, $select.selected.region_name)\" required close-on-select=true><ui-select-match data-testid=nombre_sucursal_seleccionada_{{$select.selected.region_name}} placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices data-testid=nombre_sucursal_region repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search\"><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select><div data-testid=error_sucursal ng-if=\"filterSharedForm.branch.$touched|| submit\" ng-messages=filterSharedForm.branch.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'branchR\' | translate}}</div></div></div><div class=\"col-lg-2 col-sm-2 col-md-2 col-xs-12 text-left\"><p style=font-size:15px>Tipo de servicio</p><ui-select data-testid=id_tipo_servicio class=tipo-servicio-selector multiple ng-model=vm.dataForBlock.type_of_service_id name=type_of_service ng-change=\"vm.typeOfserviceChanged(0, $select.selected)\" ng-keyup=vm.agreementSearch($select.search,$event) required close-on-select=true><ui-select-match data-testid=nombre_servicio_seleccion_{{$select.selected.service_name}} placeholder=\"Seleccionar tipo de servicio\">{{$item.service_name}}</ui-select-match><ui-select-choices repeat=\"service.id as service in vm.serviceList | filter: { deshabilitado: false } | filter: $select.search\"><div data-testid=seleccion_nombre_{{service.service_name}} ng-bind-html=service.service_name></div></ui-select-choices></ui-select></div></div><div class=row style=\"margin-top: 40px\"><div class=\"col-sm-3 col-md-3 col-lg-3 text-left\" ng-if=\"vm.showExceptions == false\"><p style=\"font-size:15px; font-weight: 700\">Bloques horario</p></div><div class=\"col-sm-3 col-md-3 col-lg-3 text-left\" ng-if=\"vm.showExceptions == true\"><p style=\"font-size:15px; font-weight: 700\">Excepciones</p></div><div class=\"col-sm-2 col-md-2 col-lg-2\" ng-style=\"{\'width\': vm.showExceptions ? \'143px\' : \'135px\'}\"><a data-testid=btn_aregar_bloque class=\"btn btn-primary\" title=\"Crear instancia\" ng-click=vm.addBlock() style=padding-left:8px;padding-right:8px ng-if=\"vm.showExceptions == false\"><i class=\"fa fa-plus\" style=border:none></i> Nuevo bloque </a><a data-testid=btn_nueva_excepcion class=\"btn btn-primary\" title=\"Crear instancia\" ng-click=vm.addException() style=padding-left:8px;padding-right:8px ng-if=\"vm.showExceptions == true\"><i class=\"fa fa-plus\" style=border:none></i> Nueva Excepción</a></div><div class=\"col-sm-2 col-md-2 col-lg-2\" style=\"width: 135px\"><a data-testid=btn_exepciones class=\"btn btn-primary\" title=\"Crear instancia\" ng-click=vm.handleExceptions() style=padding-left:8px;padding-right:8px ng-if=\"vm.showExceptions == false\">Excepciones </a><a data-testid=btn_bloques class=\"btn btn-primary\" title=\"Crear instancia\" ng-click=vm.handleExceptions() style=padding-left:8px;padding-right:8px ng-if=\"vm.showExceptions == true\">Bloques</a></div></div><div class=table-responsive style=\"margin-top: 30px;min-height: 400px\" ng-if=\"vm.showExceptions==false\"><table class=\"table table-hover\"><thead><tr style=\"border: none !important\"><th style=\"width:30px;border: none !important;text-align: center !important\" title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 12px\">Día y hora de inicio</p></th><th style=\"width:30px;border: none !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 12px\">Día y hora de termino</p></th><th style=\"width:30px;border: none !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 12px\">Cupos dispopnibles</p></th><th style=\"width:30px;border: none !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 12px\">Acción</p></th></tr></thead><tbody><tr ng-repeat=\"data in vm.blocks\"><!-- <td style=\"width:140px;border: none !important;\">\n                                                    <p style=\"font-size: 18px\">{{vm.filterDay(data.dia)}}</p>\n                                                </td> --><td style=\"width:140px;border:none !important;text-align:left !important\"><p ng-if=\"vm.editBlockId != data.id\" style=\"font-size: 15px;margin: 0 auto !important;width: 122px\"><span style=\"width: 64px;display:inline-block\">{{vm.filterDay(data.diaInicio)}}</span> <span style=\"font-size: 15px;margin-left: 15px\">{{data.horaInicio}}</span></p><div ng-if=\"vm.editBlockId == data.id\" class=row><div class=col-md-6 style=\"width:130px;border: none !important;padding-right: 0px\"><select data-testid=select_dia class=form-control ng-model=vm.dataForBlock.dia_inicio ng-change=vm.approvalValueChanged()><option id=1 ng-value=1>Lunes</option><option id=2 ng-value=2>Martes</option><option id=3 ng-value=3>Miércoles</option><option id=4 ng-value=4>Jueves</option><option id=5 ng-value=5>Viernes</option><option id=6 ng-value=6>Sábado</option><option id=7 ng-value=7>Domingo</option></select></div><div class=col-md-6 style=\"padding-left: 5px;max-width: 100px\"><ui-select data-testid=select_hora style=\"z-index: 10 !important\" ng-model=vm.dataForBlock.fecha_inicio.hora name=hora ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match>{{$select.selected.id}}</ui-select-match><ui-select-choices data-testid=hora repeat=\"hours.id as hours in vm.hoursArray\" when-scrolled=vm.paginationChangedForBranch()><div ng-bind-html=hours.id></div></ui-select-choices></ui-select></div></div></td><td style=\"width:140px;border: none !important;text-align:left !important\"><p ng-if=\"vm.editBlockId != data.id\" style=\"font-size: 15px;margin: 0 auto !important;width: 122px\"><span style=\"width: 64px;display:inline-block\">{{vm.filterDay(data.diaFin)}}</span> <span style=\"font-size: 15px;margin-left: 15px\">{{data.horaFin}}</span></p><div ng-if=\"vm.editBlockId == data.id\" class=row><div class=col-md-6 style=\"width:130px;border: none !important;padding-right: 0px\"><select data-testid=select_dia_fin class=form-control ng-model=vm.dataForBlock.dia_fin ng-change=vm.approvalValueChanged()><option id=1 ng-value=1>Lunes</option><option id=2 ng-value=2>Martes</option><option id=3 ng-value=3>Miércoles</option><option id=4 ng-value=4>Jueves</option><option id=5 ng-value=5>Viernes</option><option id=6 ng-value=6>Sábado</option><option id=7 ng-value=7>Domingo</option></select></div><div class=col-md-6 style=\"padding-left: 5px;max-width: 100px\"><ui-select style=\"z-index: 10 !important\" ng-model=vm.dataForBlock.fecha_fin.hora name=hora ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match>{{$select.selected.id}}</ui-select-match><ui-select-choices repeat=\"hours.id as hours in vm.hoursArray\" when-scrolled=vm.paginationChangedForBranch()><div ng-bind-html=hours.id></div></ui-select-choices></ui-select></div></div></td><td style=\"width:140px;border: none !important\"><p ng-if=\"vm.editBlockId != data.id\" style=\"font-size: 18px\">{{data.cupos}}</p><div ng-if=\"vm.editBlockId == data.id\"><input data-testid=input_cupos ng-model=vm.dataForBlock.cupos class=form-control maxlength=55 name=nombre type=number min=0 required ng-change=vm.onchange(dataForInstance.nombre) value={{data.cupos}}><!--<div ng-hide=\"formInstance.nombre.$valid || formInstance.$pristine\" >--><!--<div class=\"errormessage text-danger\">Este campo es obligatorio.</div>--><!--</div>--><div data-testid=error_campo_cupos ng-if=vm.isError><div class=\"errormessage text-danger\">Este campo es obligatorio.</div></div></div></td><td style=\"width:140px;border: none !important\"><a data-testid=btn_edita_bloque_{{data.id}} ng-if=\"vm.editBlockId != data.id && data.id\" title=\"Editar bloque\" class=cursor ng-click=vm.editBlock(data)><i class=\"fa fa-edit fa-lg\"></i> </a><a data-testid=btn_guarda_bloque_{{data.id}} ng-if=\"vm.editBlockId == data.id\" title=\"Guardar bloque\" class=cursor ng-click=vm.bloqueChanged(data)><i class=\"fa fa-check fa-lg\"></i> </a><a data-testid=btn_borra_bloque_{{data.id}} title=\"Borrar bloque\" style=\"font-size: 20px\" class=cursor ng-click=vm.removeBlock(data)><i style=\"color: red\" class=\"fa fa-times-circle fa-lg\"></i></a></td></tr><tr ng-if=vm.isAdd><td style=\"border: none !important\"><div class=row><div class=col-md-6 style=\"width:130px;border: none !important;padding-right: 0px\"><select data-testid=add_dia_select class=form-control ng-model=vm.dataForBlock.dia_inicio ng-change=vm.approvalValueChanged()><!-- <option value=\"\" disabled>Seleccionar día de la semana</option> --><option id=1 value=1>Lunes</option><option id=2 value=2>Martes</option><option id=3 value=3>Miércoles</option><option id=4 value=4>Jueves</option><option id=5 value=5>Viernes</option><option id=6 value=6>Sábado</option><option id=7 value=7>Domingo</option></select></div><!-- <div class=\"col-md-5\" style=\"padding-left: 0px;\"> --><div class=col-md-6 style=\"padding-left: 5px;max-width: 100px\"><ui-select data-testid=select_inicio_bloque style=\"z-index: 10 !important\" ng-model=vm.dataForBlock.fecha_inicio.hora name=hora ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match data-testid=id_seleccion>{{$select.selected.id}}</ui-select-match><ui-select-choices repeat=\"hours.id as hours in vm.hoursArray\" when-scrolled=vm.paginationChangedForBranch()><div data-testid=hora_seleccionada_{{hours.id}} ng-bind-html=hours.id></div></ui-select-choices></ui-select></div><!-- <div class=\"col-md-2\" style=\"padding-left: 0px;padding-right: 0px;max-width: 2px; align-items:center;margin-top: 5px;\">\n                                                                    :\n                                                                </div>\n                                                                \n                                                                <div class=\"col-md-5\" style=\"padding-left: 3px;padding-right: 3px;max-width: 55px;\">\n                                    \n                                                                    <ui-select style=\"padding: 0px;\" ng-model=\"vm.dataForBlock.fecha_inicio.minute\" name=\"minutos\" ng-keyup=\"vm.branchSearch($select.search,$event)\" required close-on-select=\"true\">\n                                                                        <ui-select-match>\n                                                                            {{$select.selected.id}}\n                                                                        </ui-select-match>\n                                                                        <ui-select-choices repeat=\"minutes.id as minutes in vm.minutesArray\"\n                                                                        style=\"z-index:10\"\n                                                                            when-scrolled=\"vm.paginationChangedForBranch()\" ng-click=\"vm.branchChanged()\">\n                                                                            <div ng-bind-html=\"minutes.id\"></div>\n                                                                        </ui-select-choices>\n                                                                    </ui-select>\n                                                                </div> --><!-- </div> --></div></td><td style=\"border: none !important\"><!-- <p style=\"font-size: 15px\">06:00</p> --><!--<input type=\"time\" ng-model=\"vm.dataForBlock.fecha_fin\" step=\"00:15\" name=\"fechaFin\" id=\"fechaFin\">--><div class=row style=\"flex: 1;align-items: center\"><div class=col-md-6 style=\"width:130px;border: none !important;padding-right: 0px\"><select data-testid=select_dia_semana class=form-control ng-model=vm.dataForBlock.dia_fin ng-change=vm.approvalValueChanged()><!-- <option value=\"\" disabled>Seleccionar día de la semana</option> --><option id=1 value=1>Lunes</option><option id=2 value=2>Martes</option><option id=3 value=3>Miércoles</option><option id=4 value=4>Jueves</option><option id=5 value=5>Viernes</option><option id=6 value=6>Sábado</option><option id=7 value=7>Domingo</option></select></div><div class=col-md-6 style=\"padding-left: 3px;max-width: 100px\"><ui-select data-testid=select_dia_fin1 ng-model=vm.dataForBlock.fecha_fin.hora name=hora ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match data-testid=seleccion_hora_id_>{{$select.selected.id}}</ui-select-match><ui-select-choices repeat=\"hours.id as hours in vm.hoursArray\" when-scrolled=vm.paginationChangedForBranch()><div data-testid=seleccion_hora_{{hours.id}} ng-bind-html=hours.id></div></ui-select-choices></ui-select></div></div></td><td style=\"border: none !important\"><div><input data-testid=input_cupos1 ng-model=vm.dataForBlock.cupos class=form-control maxlength=55 name=nombre type=number min=0 required ng-change=vm.onchange(dataForInstance.nombre)><!--<div ng-hide=\"formInstance.nombre.$valid || formInstance.$pristine\" >--><!--<div class=\"errormessage text-danger\">Este campo es obligatorio.</div>--><!--</div>--><div ng-if=vm.isError><div data-testid=error_obligatorio class=\"errormessage text-danger\">Este campo es obligatorio.</div></div></div></td><td style=\"width:100px;border: none !important;vertical-align: middle\"><div><a data-testid=btn_guarda_bloque type=button style=\"padding-left: 3px;padding-right: 3px\" class=\"btn btn-primary btn-xs\" title=\"{{\'approve\' | translate}}\" ng-click=vm.saveBlock(vm.dataForBlock,$event)>Guardar</a></div></td></tr></tbody></table><!-- <div style=\"clear:both;\"></div> --></div><div class=table-responsive style=\"margin-top: 30px;min-height: 400px\" ng-if=\"vm.showExceptions == true\"><table class=\"table table-hover\"><thead><tr style=\"border: none !important\"><th style=\"width:30px;border: none !important;text-align: center !important\" title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 12px\">Fecha y hora de inicio</p></th><th style=\"width:30px;border: none !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 12px\">Fecha y hora de termino</p></th><th style=\"width:30px;border: none !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 12px\">Cupos dispopnibles</p></th><th style=\"width:30px;border: none !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 12px\">Acción</p></th></tr></thead><tbody><tr ng-repeat=\"data in vm.exceptions\" ng-if=\"data.status == true\"><!-- <td style=\"width:140px;border: none !important;\">\n                                            <p style=\"font-size: 18px\">{{vm.filterDay(data.dia)}}</p>\n                                        </td> --><td style=\"width:140px;border: none !important\"><p style=\"font-size: 15px\">{{data.start_date}}<span style=\"font-size: 15px;margin-left: 15px\">{{data.hora_inicio}}</span></p></td><td style=\"width:140px;border: none !important\"><p style=\"font-size: 15px\">{{data.end_date}}<span style=\"font-size: 15px;margin-left: 15px\">{{data.hora_fin}}</span></p></td><td style=\"width:140px;border: none !important\"><p style=\"font-size: 18px\">{{data.cupos}}</p></td><td style=\"width:140px;border: none !important\"><a title=\"Borrar bloque\" style=\"font-size: 20px\" class=cursor ng-click=vm.removeException($index)><i style=\"color: red\" class=\"fa fa-times-circle fa-lg\"></i></a></td></tr><tr ng-if=vm.isAddException><td style=\"border: none !important\"><div class=row><div class=col-md-6><input data-testid=input_fecha_inicio style=\"height: 32px;border-radius: 5px;border: 1px solid #ccc\" type=date name=start id=trip-start min={{vm.date}} value=vm.dataForBlock.start_date ng-model=vm.dataForBlock.start_date></div><div class=col-md-6 style=\"padding-left: 5px;max-width: 100px\"><!-- <div class=\"col-md-5\" style=\"padding-left: 3px;padding-right: 3px;max-width: 55px;\"> --><ui-select data-testid=select_fecha_inicio style=\"z-index: 10 !important\" ng-model=vm.dataForBlock.fecha_inicio.hora name=hora required close-on-select=true><ui-select-match>{{$select.selected.id}}</ui-select-match><ui-select-choices data-testid=select_horas repeat=\"hours.id as hours in vm.hoursArray\" when-scrolled=vm.paginationChangedForBranch()><div ng-bind-html=hours.id></div></ui-select-choices></ui-select></div></div></td><td style=\"border: none !important\"><div class=row><div class=col-md-6><p class=input-group><input data-testid=fecha_fin11 style=\"height: 32px;border-radius: 5px;border: 1px solid #ccc\" min={{vm.date}} type=date name=date id=date ng-model=vm.dataForBlock.end_date></p><div ng-if=\"createBookingForm.scheduledDate.$touched|| submit\" ng-messages=createBookingForm.scheduledDate.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'scheduleDateReq\' | translate}}</div></div></div><div class=col-md-6 style=\"padding-left: 5px;max-width: 100px\"><ui-select data-testid=select_hora22 ng-model=vm.dataForBlock.fecha_fin.hora name=hora required close-on-select=true><ui-select-match>{{$select.selected.id}}</ui-select-match><ui-select-choices repeat=\"hours.id as hours in vm.hoursArray\" when-scrolled=vm.paginationChangedForBranch()><div ng-bind-html=hours.id></div></ui-select-choices></ui-select></div></div></td><td style=\"border: none !important\"><div><input data-testid=input_cupos2 ng-model=vm.dataForBlock.cupos class=form-control maxlength=55 name=nombre type=number min=0 required ng-change=vm.onchange(dataForInstance.nombre)><div ng-if=vm.isError><div class=\"errormessage text-danger\">Este campo es obligatorio.</div></div></div></td><td style=\"width:100px;border: none !important;vertical-align: middle\"><div><a data-testid=btn_guarda_exepcion type=button style=\"padding-left: 3px;padding-right: 3px\" class=\"btn btn-primary btn-xs\" title=\"{{\'approve\' | translate}}\" ng-click=vm.saveException(vm.dataForBlock,$event)>Guardar</a></div></td></tr></tbody></table></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-right mt5 mb0\"><div style=\"flex: 1\"><button data-testid=btn_cancelar class=btn ng-click=vm.cancel() type=button style=\"height: 35px;line-height: 20px;margin-right: 5px\">Cancelar</button><!-- <button class=\"btn btn-primary ng-binding\" type=\"button\" style=\"height: 35px;line-height: 20px;\" ng-click=\"vm.saveInstance(vm.dataForInstance)\">Guardar\n                                    </button> --> <button data-testid=btn_guardar ng-if=!vm.id class=\"btn btn-primary ng-binding\" type=submit style=\"height: 35px;line-height: 20px\">Guardar</button> <button data-testid=btn_guardar1 ng-if=vm.id class=\"btn btn-primary ng-binding\" type=submit style=\"height: 35px;line-height: 20px\">Guardar</button></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/matriz-flota/fleetCapacityMatrixDetail.html","<h2 class=ng-cloak><span>{{\'matrixHeadCreate\' | translate}}</span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><!--<filter-sidebar show-filter-sidebar=\"vm.showFilterFlag\" filter-data=\"vm.filterData\" filter-to-show=\"vm.filterWhichToShow\" branch-detail-changed=\"vm.branchChangedFilter(vm.filterData)\"--><!--modelity-detail-changed=\"vm.modelityChangedFilter(vm.filterData)\" approval-stage-detail-changed=\"vm.approvalChangedFilter(vm.filterData)\" applicant-detail-changed=\"vm.applicantChangedFilter(vm.filterData)\"></filter-sidebar>--><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6 text-left\" style=\"padding: 15px\"><p style=font-size:18px>Ver matriz de capacidad de flota</p></div></div><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-4 col-xs-12 text-left\" style=\"max-width: 300px\"><p style=font-size:15px>Nombre</p><div style=\"border: 1px solid; padding: 2px 5px; border-radius: 4px; border-color:#9f9b9b\"><p data-testid=nombre_matriz style=font-size:15px>{{vm.nombre}}</p></div></div><div class=\"col-sm-4 col-xs-12 text-left\" style=\"max-width: 300px\"><p style=font-size:15px>Sucursal</p><div style=\"border: 1px solid; padding: 2px 5px; border-radius: 4px; border-color:#9f9b9b\"><p data-testid=nombre_sucursal style=font-size:15px>{{vm.sucursal}}</p></div></div><div class=\"col-sm-4 col-xs-12 text-left\" style=\"max-width: 300px\"><p style=font-size:15px>Tipo de servicios</p><div style=\"border: 1px solid; padding: 2px 5px; border-radius: 4px; border-color:#9f9b9b\"><p data-testid=tipos_servicio style=font-size:15px>{{vm.type_of_service_names}}</p></div></div></div><div class=row style=\"margin-top: 40px\"><div class=\"col-sm-3 col-md-3 col-lg-3 text-left\"><p style=\"font-size:15px; font-weight: 700\" ng-if=\"vm.showExceptions == false\">Bloques horario</p><p style=\"font-size:15px; font-weight: 700\" ng-if=\"vm.showExceptions == true\">Excepciones</p></div><div class=\"col-sm-2 col-md-2 col-lg-2\" ng-if=\"vm.showExceptions == true\" style=\"width: 135px\"><a data-testid=btn_bloques1 class=\"btn btn-primary\" ng-click=vm.handleExceptions() style=padding-left:8px;padding-right:8px>Bloques</a></div><div class=\"col-sm-2 col-md-2 col-lg-2\" ng-if=\"vm.showExceptions == false\" style=\"width: 135px\"><a data-testid=btn_ver_exepciones class=\"btn btn-primary\" ng-click=vm.handleExceptions() style=padding-left:8px;padding-right:8px>Excepciones</a></div><div class=\"col-sm-2 col-md-2 col-lg-2\" style=\"width: 135px\"><a data-testid=btn_ver_calendario class=\"btn editIconColor\" ng-click=vm.handleCalendar() style=\"padding-left:8px;padding-right:8px;background-color: gray\"><p style=\"color: white\">Ver calendario</p></a></div></div><div class=table-responsive style=\"margin-top: 30px\" ng-if=\"vm.showExceptions==false\"><table class=\"table table-hover\" style=\"max-width: 80%\"><thead><tr style=\"border: none !important\"><th style=\"width:30px;border: none !important\" title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 12px\">Día y hora de inicio</p></th><th style=\"width:30px;border: none !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 12px\">Día y hora de termino</p></th><th style=\"width:30px;border: none !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 12px\">Cupos dispopnibles</p></th><!-- <th style=\"width:30px;border: none !important;\" current-text=\"vm.predicate\" title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\"\n                                            check=\"vm.reverse\">\n                                            <p  style=\"font-size: 12px;\">Acción</p>\n                                        </th> --></tr></thead><tbody><tr ng-repeat=\"data in vm.dates\"><td style=\"border: none !important;text-align:left !important\"><p style=\"font-size: 15px;margin: 0 auto !important;width: 122px\"><span style=\"width: 64px;display:inline-block\">{{vm.filterDay(data.diaInicio)}}</span> <span style=\"font-size: 15px;margin-left: 15px\">{{data.horaInicio}}</span></p></td><td style=\"border: none !important;text-align:left !important\"><p style=\"font-size: 15px;margin: 0 auto !important;width: 122px\"><span style=\"width: 64px;display:inline-block\">{{vm.filterDay(data.diaFin)}}</span> <span style=\"font-size: 15px;margin-left: 15px\">{{data.horaFin}}</span></p></td><td style=\"border: none !important\"><p style=\"font-size: 15px\">{{data.cupos}}</p></td></tr></tbody></table><div style=clear:both></div></div><div class=table-responsive style=\"margin-top: 30px\" ng-if=\"vm.showExceptions==true\"><table class=\"table table-hover\"><thead><tr style=\"border: none !important\"><th style=\"width:30px;border: none !important;text-align: center !important\" title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 12px\">Fecha y hora de inicio</p></th><th style=\"width:30px;border: none !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 12px\">Fecha y hora de termino</p></th><th style=\"width:30px;border: none !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 12px\">Cupos dispopnibles</p></th></tr></thead><tbody><tr ng-repeat=\"data in vm.exceptions\" ng-if=\"data.status == true\"><td style=\"width:140px;border: none !important\"><p data-testid=fecha_inicio1 style=\"font-size: 15px\">{{data.start_date}}<span style=\"font-size: 15px;margin-left: 15px\">{{data.hora_inicio}}</span></p></td><td style=\"width:140px;border: none !important\"><p data-testid=fecha_fin style=\"font-size: 15px\">{{data.end_date}}<span style=\"font-size: 15px;margin-left: 15px\">{{data.hora_fin}}</span></p></td><td style=\"width:140px;border: none !important\"><p data-testid=cupos style=\"font-size: 18px\">{{data.cupos}}</p></td></tr></tbody></table><div style=clear:both></div></div><div style=\"height: 130px\" class=ng-scope></div><div class=text-right><div style=\"flex: 1;margin-right: 100px\"><button data-testid=btn_volver class=\"btn btn-primary\" ng-click=vm.cancel() type=button style=\"height: 35px;line-height: 20px;margin-right: 5px;margin-left: 5px\">Volver</button></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/matriz-flota/fleetCapacityMatrixExceptions.html","<h2 class=ng-cloak><span>{{\'matrixHeadCreate\' | translate}}</span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6 text-left\" style=\"padding: 15px\"><p style=font-size:18px>{{vm.sucursal}} / Excepciones</p></div></div><div class=\"panel panel-default\"><div class=panel-body><form name=formInstance ng-submit=guardar_datos(formInstance,$event) novalidate autocomplete=off><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6 text-left\" style=\"padding: 15px;padding-left: 55px\"><p style=\"font-size:15px; font-weight: 700\">Excepciones</p></div><div class=\"col-sm-6 col-md-6 col-lg-6 text-right\" style=\"padding: 15px;padding-right: 55px\"><!-- <p style=\"font-size:15px;color: transparent;\">Estado</p> --> <a class=\"btn btn-primary\" title=\"Crear instancia\" ng-click=vm.addBlock()><i class=\"fa fa-plus\" style=border:none></i> Nueva Excepción</a></div></div><div class=table-responsive style=\"margin-top: 30px;min-height: 400px\"><table class=\"table table-hover\"><thead><tr style=\"border: none !important\"><th style=\"width:30px;border: none !important;text-align: center !important\" title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 12px\">Fecha y hora de inicio</p></th><th style=\"width:30px;border: none !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 12px\">Fecha y hora de termino</p></th><th style=\"width:30px;border: none !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 12px\">Cupos dispopnibles</p></th><th style=\"width:30px;border: none !important\" current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'fleet_id\'\" check=vm.reverse><p style=\"font-size: 12px\">Acción</p></th></tr></thead><tbody><tr ng-repeat=\"data in vm.blocks\" ng-if=\"data.status == true\"><!-- <td style=\"width:140px;border: none !important;\">\n                                            <p style=\"font-size: 18px\">{{vm.filterDay(data.dia)}}</p>\n                                        </td> --><td style=\"width:140px;border: none !important\"><p style=\"font-size: 15px\">{{data.start_date}}<span style=\"font-size: 15px;margin-left: 15px\">{{data.hora_inicio}}</span></p></td><td style=\"width:140px;border: none !important\"><p style=\"font-size: 15px\">{{data.end_date}}<span style=\"font-size: 15px;margin-left: 15px\">{{data.hora_fin}}</span></p></td><td style=\"width:140px;border: none !important\"><p style=\"font-size: 18px\">{{data.cupos}}</p></td><td style=\"width:140px;border: none !important\"><a title=\"Borrar bloque\" style=\"font-size: 20px\" class=cursor ng-click=vm.removeBlock($index)><i style=\"color: red\" class=\"fa fa-times-circle fa-lg\"></i></a></td></tr><tr ng-if=vm.isAdd><td style=\"border: none !important\"><div class=row><div class=col-md-6><input style=\"height: 32px;border-radius: 5px;border: 1px solid #ccc\" type=date name=start id=trip-start min={{vm.date}} value=vm.dataForBlock.start_date ng-model=vm.dataForBlock.start_date></div><!-- <div class=\"col-md-6\" style=\"width:130px;border: none !important;padding-right: 0px;\">\n                                                    <select  class=\"form-control\" ng-model=\"vm.dataForBlock.dia_inicio\" ng-change=\"vm.approvalValueChanged()\">\n                                                        <option id=\"1\" value=\"1\">Lunes</option>\n                                                        <option id=\"2\" value=\"2\">Martes</option>\n                                                        <option id=\"3\" value=\"3\">Miércoles</option>\n                                                        <option id=\"4\" value=\"4\">Jueves</option>\n                                                        <option id=\"5\" value=\"5\">Viernes</option>\n                                                        <option id=\"6\" value=\"6\">Sábado</option>\n                                                        <option id=\"7\" value=\"7\">Domingo</option>\n                                                    </select>\n                                                </div> --><div class=col-md-6 style=\"padding-left: 5px;max-width: 100px\"><!-- <div class=\"col-md-5\" style=\"padding-left: 3px;padding-right: 3px;max-width: 55px;\"> --><ui-select style=\"z-index: 10 !important\" ng-model=vm.dataForBlock.fecha_inicio.hora name=hora ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match>{{$select.selected.id}}</ui-select-match><ui-select-choices repeat=\"hours.id as hours in vm.hoursArray\" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=hours.id></div></ui-select-choices></ui-select></div></div></td><td style=\"border: none !important\"><div class=row><!-- <div class=\"col-md-6\" style=\"width:130px;border: none !important;padding-right: 0px;\">\n                                                    <select  class=\"form-control\" ng-model=\"vm.dataForBlock.dia_fin\" ng-change=\"vm.approvalValueChanged()\">\n                                                        <option id=\"1\" value=\"1\">Lunes</option>\n                                                        <option id=\"2\" value=\"2\">Martes</option>\n                                                        <option id=\"3\" value=\"3\">Miércoles</option>\n                                                        <option id=\"4\" value=\"4\">Jueves</option>\n                                                        <option id=\"5\" value=\"5\">Viernes</option>\n                                                        <option id=\"6\" value=\"6\">Sábado</option>\n                                                        <option id=\"7\" value=\"7\">Domingo</option>\n                                                    </select>\n                                                </div> --><div class=col-md-6><p class=input-group><input style=\"height: 32px;border-radius: 5px;border: 1px solid #ccc\" min={{vm.date}} type=date name=date id=date ng-model=vm.dataForBlock.end_date><!-- <input ng-disabled=\"vm.CheckBookingStatus(vm.bookingDetails)\" type=\"text\" id=\"datePickerPickup\" class=\"form-control\" uib-datepicker-popup=\"{{vm.format}}\"\n                                                            name=\"scheduledDate\" ng-model=\"vm.dataToFill.scheduledDate\" placeholder=\"{{\'scheduleDate\' | translate}}\"\n                                                            is-open=\"vm.datePicker_1.scheduledDate\" datepicker-options=\"vm.dateOptions\" required\n                                                            ng-class=\"{ \'has-error\': createBookingForm.scheduledDate.$touched && createBookingForm.scheduledDate.$invalid }\"\n                                                            ng-change=\"vm.scheduleDateChanged(); vm.compareDates()\" close-text=\"Close\" alt-input-formats=\"vm.altInputFormats\"\n                                                            show-button-bar=\"false\" readonly/> --><!-- <span class=\"input-group-btn\">\n                                                            <button ng-disabled=\"vm.CheckBookingStatus(vm.bookingDetails)\" type=\"button\" class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'1\')\">\n                                                                <i class=\"glyphicon glyphicon-calendar\"></i>\n                                                            </button>\n                                                        </span> --></p><div ng-if=\"createBookingForm.scheduledDate.$touched|| submit\" ng-messages=createBookingForm.scheduledDate.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'scheduleDateReq\' | translate}}</div></div></div><div class=col-md-6 style=\"padding-left: 5px;max-width: 100px\"><ui-select ng-model=vm.dataForBlock.fecha_fin.hora name=hora ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match>{{$select.selected.id}}</ui-select-match><ui-select-choices repeat=\"hours.id as hours in vm.hoursArray\" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=hours.id></div></ui-select-choices></ui-select></div></div></td><td style=\"border: none !important\"><div><input ng-model=vm.dataForBlock.cupos class=form-control maxlength=55 name=nombre type=number min=0 required ng-change=vm.onchange(dataForInstance.nombre)><!--<div ng-hide=\"formInstance.nombre.$valid || formInstance.$pristine\" >--><!--<div class=\"errormessage text-danger\">Este campo es obligatorio.</div>--><!--</div>--><div ng-if=vm.isError><div class=\"errormessage text-danger\">Este campo es obligatorio.</div></div></div></td><td style=\"width:100px;border: none !important;vertical-align: middle\"><div><a type=button style=\"padding-left: 3px;padding-right: 3px\" class=\"btn btn-primary btn-xs\" title=\"{{\'approve\' | translate}}\" ng-click=vm.saveBlock(vm.dataForBlock,$event)>Guardar</a></div></td></tr></tbody></table><!-- <div style=\"clear:both;\"></div> --></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-right mt5 mb0\"><div style=\"flex: 1\"><button class=btn ng-click=vm.cancel() type=button style=\"height: 35px;line-height: 20px;margin-right: 5px\">Cancelar</button><!-- <button class=\"btn btn-primary ng-binding\" type=\"button\" style=\"height: 35px;line-height: 20px;\" ng-click=\"vm.saveInstance(vm.dataForInstance)\">Guardar\n                                    </button> --> <button class=\"btn btn-primary ng-binding\" type=submit style=\"height: 35px;line-height: 20px\">Guardar</button></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/matriz-flota/fleetCapacityMatrixMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/new-massive-create-booking/newMassiveCreateBooking.html","<h2 class=ng-cloak><span>{{\'Nueva Creación masiva\'}}</span></h2><head><meta charset=UTF-8></head><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row ng-if=vm.bookingsWithinFile.length><button class=\"btn btn-primary\" ng-click=goBack()>{{\'goBack\' | translate}}</button></div><div class=row ng-if=!vm.bookingsWithinFile.length><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><form name=massiveCreateBookingForm ng-submit=\"submit=true;massiveCreateBookingForm.$valid&&vm.submitCsvButton();\" novalidate autocomplete=off><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div style=margin-top:20px class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>Convenio <span style=color:red>*</span></label><ui-select ng-model=vm.dataToFill.contractIdSelected name=agreement ng-change=vm.agreementChanged(vm.dataToFill.contractIdSelected) required close-on-select=true><ui-select-match placeholder=Convenio>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"agreements as agreements in vm.agreementBooking | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=agreements.name></div></ui-select-choices></ui-select><div ng-if=\"massiveCreateBookingForm.agreement.$touched|| submit\" ng-messages=massiveCreateBookingForm.agreement.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'selectAgreementReq\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label>Tipo Viaje <span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.TripType ng-class=\"{ \'has-error\': massiveCreateBookingForm.tripType.$touched && massiveCreateBookingForm.tripType.$invalid }\" name=tripType required ng-change=vm.typeOfTripChanged()><option value=\"\" disabled selected>Seleccionar Tipo Viaje</option><option value=Z>Z</option><option value=R>R</option><option value=P>P</option></select><div ng-if=\"massiveCreateBookingForm.tripType.$touched|| submit\" ng-messages=massiveCreateBookingForm.tripType.$error><div class=\"errormessage text-danger\" ng-message=required>Favor seleccione Tipo Viaje</div></div></div></div></div></div><div class=row ng-if=\"vm.fields.length && !vm.headers\" style=\"margin:15px 0;padding:15px;background: #fff;overflow-y: scroll;height: 360px\"><h4>El archivo debe contener la siguiente información:</h4><ul><li ng-repeat=\"field in vm.fields track by field.name\" ng-if=!field.meta_data><span>{{field.name}}</span><span ng-if=field.required style=color:red>*</span></li></ul><h4 ng-if=vm.fieldsWithMetaData.length>Campos adicionales:</h4><ul><li ng-repeat=\"meta in vm.fieldsWithMetaData track by meta.name\"><span>{{meta.name}}</span><span ng-if=field.required style=color:red>*</span></li></ul></div><div class=row ng-if=vm.headers style=\"margin:15px 0;padding:15px;background: #fff;overflow-y: scroll;height: 360px\"><div class=row ng-repeat=\"field in vm.fields track by field.name\" style=\"padding: 10px 0\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{field.name}}:</label></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><ui-select ng-model=field.value name=field on-select=disableSelection(field.value) required close-on-select=true remove-selected=true ng-disabled=field.value><ui-select-match placeholder=Column>{{$select.selected.value}}</ui-select-match><ui-select-choices repeat=\"header as header in vm.headers | filter: $select.search | orderBy:\'value\' \" ui-disable-choice=\"header.disabled == 1\"><div ng-bind-html=header.value></div></ui-select-choices></ui-select></div></div></div></form></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><div class=row style=\"margin-top:42px;text-align: center\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><input id=fileUpload filestyle=\"\" type=file style=\"display: none\" name={{vm.uploadName}} onchange=angular.element(this).scope().uploadXlsxGetHeaders(this.files,this.name) onclick=\"this.value = null\" data-button-text=Single data-class-button=\"btn btn-default\" data-classinput=\"form-control inline\" nv-file-select=\"\" uploader=uploader accept=\".xlsx, text/xlsx\"> <button class=\"btn btn-primary\" type=button style=\"outline: none;float: left\" ng-disabled=!vm.fields.length ng-click=vm.makeTableViewOfXlsx($event)>Subir archivo</button></div></div><div id=collapseDiv><button id=collapseBtn ng-click=toggle()><i class=fa ng-class=\"{\'fa-caret-up\': !vm.showUploadedFiles,\'fa-caret-down\':vm.showUploadedFiles}\" style=\"margin-right: 16px;background: #ff5100;padding: 6px 18px;color: rgb(255, 255, 255);font-weight: 800\"></i> Cargas realizadas</button><div ng-class=\"{\'collapsed\': !vm.showUploadedFiles,\'collapse\':vm.showUploadedFiles}\"><table class=\"table table-hover tableWithMasterData\"><thead></thead><tbody ng-if=\"vm.uploadedFiles.length > 0\"><tr ng-repeat=\"file in vm.uploadedFiles track by $index\"><!-- <td>{{$index+1}}</td> --><td style=\"vertical-align: middle; width: 40%\">{{file.file_name|limitTo:50}}</td><td style=\"vertical-align: middle; width: 20; justify-content: left\">{{file.processing_status_value}}</td><td style=\"vertical-align: middle; width: 20\" ng-if=file.output_file_url><button class=\"btn btn-primary\" type=button style=\"outline: none;font-size: 12px !important;font-weight: 600 !important;padding:6px 18px\" ng-click=exportExcel(file.output_file_url);>Export</button></td><td style=\"vertical-align: middle; width: 20\" ng-if=!file.output_file_url>-</td><td style=\"vertical-align: middle; width: 20\"><button class=\"btn btn-primary\" type=button style=\"outline: none;font-size: 12px !important;font-weight: 600 !important;padding:6px 18px\" ng-click=getBookingWithinFile(file.file_id);>View</button></td></tr></tbody></table></div></div></div></div><div class=row ng-if=!vm.bookingsWithinFile.length><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\" ng-if=vm.headers.length><button class=\"btn btn-primary\" type=button style=\"outline: none;float: right\" ng-disabled=\"vm.disableCount != vm.fields.length\" ng-click=vm.submitFieldsCreateBooking();>Comenzar carga</button> <button class=\"btn btn-default\" type=button style=\"outline: none;float: right;margin-right: 10px\" ng-click=clearSelection();>Selección clara</button></div></div><div class=row ng-if=vm.bookingsWithinFile.length><div style=\"margin-top: 20px\" class=\"table-responsive tableWithMasterDataParentDive\" ng-switch=\"(vm.bookingsWithinFile | filter:vm.search).length\"><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th ng-repeat=\"(key, value) in vm.bookingsWithinFile[0]\" style=\"width: 125px;border: 1px solid grey;border-collapse: collapse;padding: 5px\" current-text=vm.predicate title=Posición text=\"\'index\'\" check=vm.reverse ng-style=\"key === \'mensaje de estado\' && {\'width\':\'320px\'}\">{{key}}</th></tr></thead><tbody ng-if=\"vm.bookingsWithinFile.length > 0\"><tr ng-repeat=\"booking in vm.bookingsWithinFile\"><td ng-repeat=\"(key, value) in booking\" ng-class=\"{\'red-color\': booking.Reserva == 0}\" style=\"border: 1px solid grey;border-collapse: collapse;padding: 5px;width:125px\" ng-style=\"key === \'mensaje de estado\' && {\'width\':\'320px\'}\">{{value.length>=150 ? (value|limitTo:150)+\'...\' : value}}</td></tr></tbody></table></div></div></div><style>table tr:nth-child(odd) {\n        background-color: #d4cfcf;\n        ;\n    }\n\n    #darkGrey {\n        background-color: #d4cfcf;\n        font-weight: bold;\n    }\n\n    .table-hover>tbody>tr:nth-child(odd) {\n        background-color: #ffffff;\n    }\n\n    .table-hover>tbody>tr:nth-child(even) {\n        background-color: #ffffff;\n    }\n\n    table tr:nth-child(even) {\n        background-color: #ffffff;\n    }\n\n\n\n    .modifyName {\n        font-size: 30px;\n        font-weight: bold;\n        margin-left: 15px;\n    }\n\n    .diaMainDiv {\n        margin-left: 15px;\n        font-size: 18px;\n        font-weight: 530;\n    }\n\n    .grabarButton {\n        height: 54px;\n        width: 200px;\n        text-align: center;\n        background-color: #70AD46;\n        font-size: 20px;\n        font-weight: 400;\n        color: black;\n        font-weight: bold;\n    }\n\n    .butttonSpan {\n        position: absolute;\n        left: 350px;\n        top: 100px;\n    }\n\n    .nav-tabs .nav-item.show .nav-link,\n    .nav-tabs .nav-link.active {\n        text-align: center;\n        height: 40px;\n        line-height: 2;\n        font-size: 18px;\n        position: relative;\n        font-weight: bold;\n        text-decoration: underline;\n        width: 100px;\n        color: orange;\n        background-color: #fff;\n        border-left: 1px solid black;\n        border-right: 1px solid black;\n        border-top: 1px solid black;\n        /* border-color: #dee2e6 #dee2e6 #fff; */\n    }\n\n    .nav-tabs .nav-link {\n        border: 1px solid transparent;\n        border-top-left-radius: .25rem;\n        border-top-right-radius: .25rem;\n        color: #888888;\n        text-decoration: none;\n        background-color: transparent;\n        height: 40px;\n        line-height: 2;\n        font-size: 18px;\n        font-weight: bold;\n        width: 100px;\n        text-align: center;\n    }\n\n    .nav {\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n        padding-left: 0;\n        margin-bottom: 0;\n        list-style: none;\n    }\n\n    article,\n    aside,\n    figcaption,\n    figure,\n    footer,\n    header,\n    hgroup,\n    main,\n    nav,\n    section {\n        display: block;\n    }\n\n    .nav-tabs {\n        border-bottom: 1px solid black;\n    }\n\n    .bd-example-tabs .nav-tabs {\n        margin-bottom: 1rem;\n    }\n\n    .divClassNav {\n        min-width: 100%;\n        border: 2px solid #fff;\n        position: absolute;\n        bottom: -5px;\n    }\n\n    .red-color {\n        background-color: #E7BDBD;\n    }\n\n    #collapseDiv {\n        position: fixed;\n        bottom: 72px;\n        width: 36%;\n        border: 2px solid #f1f1f1;\n        border-radius: 5px;\n        overflow: hidden;\n        transition: height 0.5s;\n        display: flex;\n        flex-direction: column;\n        align-items: start;\n        box-sizing: border-box;\n        z-index: 9999;\n        box-shadow: 6px 0 30px 0 rgb(0 0 0 / 15%);\n	}\n		\n    #collapseBtn {\n        background-color: transparent;\n        border: none;\n        color: #333;\n        font-size: 16px;\n        cursor: pointer;\n        margin-bottom: auto;\n    }\n\n    .collapsed {\n        height: 0;\n        transition: height 0.3s ease-out;\n    }\n\n    .collapse {\n        width: 100%;\n        height: 360px;\n        display: block;\n        overflow: hidden;\n        transition: height 0.3s ease-out;\n    }</style>");
$templateCache.put("app/components/views/new-massive-create-booking/newMassiveCreateBookingNewMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/no-show-reason/noShowReason.html","<h2 class=ng-cloak>{{\'noShowReasonHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-4 col-sm-6 col-md-4 col-xs-12\"><label class=control-label>{{\'noShowReasonStatusHead\' | translate}}</label><select class=form-control ng-model=vm.filterData.noShowStatus ng-change=\"vm.getNoShowReasonHit(0,10,vm.filterData.noShowStatus);vm.currentPage = 0;\"><option value=\"\" disabled>{{\'noShowReasonStatusPlace\' | translate}}</option><option selected value=0>Active</option><option value=1>Inactive</option><option value=2>All</option></select></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><p class=totalSize><span class=pull-right><a class=\"btn btn-primary mb10\" ng-click=vm.addNewReason($event)>+ {{\'addNewReasonButton\' | translate}}</a> </span>{{\'totalReason\' | translate}}: {{vm.totalReasons}}</p></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-switch=\"(vm.serviceList | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'reasonLabel\' | translate}}\" text=\"\'reason\'\" check=vm.reverse>{{\'reasonLabel\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'description\' | translate}}\" text=\"\'description\'\" check=vm.reverse>{{\'description\' | translate}}</th><th style=width:100px><div>{{\'stateTable\' | translate}}</div></th><th style=width:150px><div>{{\'action\' | translate}}</div></th><th style=width:150px><div>{{\'adminLogs\' | translate}}</div></th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.noShowReasonList| filter:vm.search | orderBy:vm.predicate:vm.reverse\"><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:70px>{{::data.id}}</td><td style=width:125px>{{::data.reason}}</td><td style=width:125px>{{::data.description}}</td><td style=width:100px><a class=\"cursor btn btn-sm\" ng-class=\"{\'blockIconColor\': data.status == 1, \'unblockIconColor\': data.status == 0}\" ng-click=vm.changeReasonStatus(data.id,data.status,$event)><i ng-class=\"{\'fa fa-unlock\': data.status == 0,\'fa fa-lock\': data.status == 1}\"></i></a></td><td style=width:150px><a title=\"Edit Details\" class=\"cursor editIconColor btn btn-sm\" ng-click=vm.editReasonPop(data,$event)><i class=\"fa fa-edit\"></i> </a><a title=\"View Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.noShowReasonMain.viewNoShowReason({id:\'{{data.id}}\'})\"><i class=\"fa fa-eye\"></i> </a><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteReason(data,$event)><i class=\"fa fa-trash\"></i></a></td><td style=width:150px><a class=\"btn btn-primary tableButton\" title=\"{{\'adminLogs\' | translate}}\" ui-sref=\"layout.noShowReasonMain.adminLogs({userId:\'{{data.id}}\',type:\'24\',fakeType: \'26\'})\">{{\'adminLogs\' | translate}}</a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noReasonFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav ng-show=\"vm.watchPagination\">--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\" ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/no-show-reason/noShowReasonMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/no-show-reason/viewNoShowReason.html","<h2 class=ng-cloak>{{\'noShowReasonHead\' | translate}} / {{\'noShowReasonDetailsHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=driver><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'allDetails\' | translate}}</p><div class=basicDetailsDiv><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'reasonLabel\' | translate}}:</label><div class=\"form-control text-capitalize\">{{::vm.correctFareReasonDetail.reason}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'description\' | translate}}:</label><textarea class=form-control ng-model=vm.correctFareReasonDetail.description placeholder=\"No Description\" readonly></textarea></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'reasonId\' | translate}}:</label><div class=\"form-control text-capitalize\">{{::vm.correctFareReasonDetail.reason_id}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'reasonStatus\' | translate}}:</label><div class=\"form-control text-capitalize\"><span ng-if=\"vm.correctFareReasonDetail.block_status == 1\">Not Active</span> <span ng-if=\"vm.correctFareReasonDetail.block_status == 0\">Active</span></div></div><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">--><!--<label class=\"control-label\">Reason Deleted:</label>--><!--<div class=\"form-control text-capitalize\">--><!--<span ng-if=\"vm.correctFareReasonDetail.is_deleted == 1\">Yes</span>--><!--<span ng-if=\"vm.correctFareReasonDetail.is_deleted == 0\">No</span>--><!--</div>--><!--</div>--></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/onOffDuty/onOffDuty.html","<h2 class=ng-cloak><span>{{\'onOffHead\' | translate}}</span> <span class=pull-right><button class=\"btn btn-primary tableButton\" ng-click=vm.refreshData()>Volver a cargar</button></span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=displayFlex><div class=filterAlign><label>{{\'since\' | translate}}:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=sinceDate ng-model=vm.filterData.since_date placeholder=\"{{\'since\' | translate}}\" is-open=vm.datePicker_1.sinceDate datepicker-options=vm.dateOptions required close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.sinceDateChanged()> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_1(1)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=filterAlign><label>{{\'singleUntill\' | translate}}:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=untillDate ng-model=vm.filterData.until_date placeholder=\"{{\'singleUntill\' | translate}}\" is-open=vm.datePicker_1.untillDate datepicker-options=vm.dateOptions required close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.untillDateChanged()> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_1(2)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=filterAlign><label>{{\'branchLabel\' | translate}}:</label><div><ui-select ng-model=vm.filterData.branch name=branch ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=\"{{\'branchPlaceholder\' |  translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select></div></div><div class=filterAlign><label>{{\'uniqueNumber\' | translate}}:</label><div><input type=text class=form-control ng-model=vm.filterData.unique_id ng-blur=vm.uniqueChanged() placeholder=\"{{\'uniqueNumber\' | translate}}\"></div></div><div class=filterAlign><label style=\"visibility: hidden\">Pickup Time:</label><br><button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px\" ng-click=vm.applyFilter()>Apply Filter</button></div><div class=filterAlign><label style=\"visibility: hidden\">Pickup Time:</label><br><button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px\" ng-click=vm.resetFilter()>{{\'resetFilterButton\' | translate}}</button></div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><p class=totalSize><span class=pull-left><a class=\"btn btn-primary tableButton mb10\" ng-click=vm.exportToCSV()>CSV</a> </span><span>{{\'totalList\' | translate}}: {{vm.totalOnOffList}}</span></p></div><br><br><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model-options=\"{ debounce: 500 }\" ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\"><!--ng-switch=\"(vm.upcomingBookingList | filter:vm.search).length\"--><!--<div ng-switch-when=\"0\" class=\"noSearch\"><span>{{\'nothingFound\' | translate}}</span></div>--><table class=\"table table-hover tableWithMasterData\"><!--ng-switch-default--><thead><tr><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:105px table-column-sorting current-text=vm.predicate title=\"{{\'uniqueNumber\' | translate}}\" text=\"\'unique_car_id\'\" check=vm.reverse>{{\'uniqueNumber\' | translate}}</th><th style=width:105px table-column-sorting current-text=vm.predicate title=\"{{\'vehicleLabel\' | translate}}\" text=\"\'type_of_car\'\" check=vm.reverse>{{\'vehicleLabel\' | translate}}</th><th style=width:115px table-column-sorting current-text=vm.predicate title=\"{{\'driverName\' | translate}}\" text=\"\'driverName\'\" check=vm.reverse>{{\'driverName\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'branchLabel\' | translate}}\" text=\"\'branch\'\" check=vm.reverse>{{\'branchLabel\' | translate}}</th><th style=\"width: 150px\" table-column-sorting current-text=vm.predicate title=\"{{\'date\' | translate}}\" text=\"\'updated_at\'\" check=vm.reverse>{{\'date&Time\' | translate}}</th><th style=\"width: 150px\" table-column-sorting current-text=vm.predicate title=\"{{\'stateTable\' | translate}}\" text=\"\'on_off_status\'\" check=vm.reverse>{{\'stateTable\' | translate}}</th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.onOffList | orderBy:vm.predicate:vm.reverse\"><!--| filter:vm.search--><td style=width:70px>{{data.index + 1}}</td><td style=width:105px>{{\'#\'+ data.unique_car_id || \'--\'}}</td><td style=width:105px>{{data.type_of_car || \'--\'}}</td><td style=width:115px>{{data.driverName || \'--\'}}</td><td style=width:125px>{{data.branch || \'--\'}}</td><td style=width:150px>{{data.updated_at | date:\'medium\'}}</td><td style=width:150px><span ng-if=!data.on_off_status>OFF </span><span ng-if=data.on_off_status>ON</span></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'onOffFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav>--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\" ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/onOffDuty/onOffDutyMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/operationPoint/operationPoint.html","<h2 class=ng-cloak>Punto de Operación</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><p class=totalSize><span class=pull-right><a class=\"btn btn-primary mb10\" ui-sref=layout.operationPointMain.operationPointRegister>+ Agregar punto de operación</a> </span><span>Puntos totales: {{vm.totalOperationPoints}}</span></p></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-switch=\"(vm.serviceList | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'pointName\' | translate}}\" text=\"\'pointname\'\" check=vm.reverse>{{\'pointName\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'percentageComission\' | translate}}\" text=\"\'commissionPercentage\'\" check=vm.reverse>{{\'percentageComission\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'branchLabel\' | translate}}\" text=\"\'branch    \'\" check=vm.reverse>{{\'branchLabel\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'pickUpAddressDefault\' | translate}}\" text=\"\'address\'\" check=vm.reverse>{{\'pickUpAddressDefault\' | translate}}</th><th style=width:125px>{{\'serviceLabel\' | translate}}</th><th style=width:100px><div>{{\'stateTable\' | translate}}</div></th><th style=width:150px><div>{{\'action\' | translate}}</div></th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.operationList| filter:vm.search | orderBy:vm.predicate:vm.reverse\"><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:70px>{{::data.id}}</td><td style=width:125px>{{::data.pointName}}</td><td style=width:125px>{{::data.commissionPercentage}}</td><td style=width:100px>{{::data.branch}}</td><td style=width:125px>{{::data.address}}</td><td style=width:125px><span ng-repeat=\"i in data.typeofservice\">{{i.service_name}}<span ng-if=\"$index != data.typeofservice.length - 1\"><br></span></span></td><td style=width:100px><a class=\"cursor btn btn-sm\" ng-class=\"{\'blockIconColor\': data.status == 0, \'unblockIconColor\': data.status == 1}\" ng-click=vm.changeOperationStatus(data.id,data.status,$event)><i ng-class=\"{\'fa fa-unlock\': data.status == 1,\'fa fa-lock\': data.status == 0}\"></i></a></td><td style=width:150px><a title=\"Edit Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.operationPointMain.operationPointEdit({id:\'{{data.id}}\'})\"><i class=\"fa fa-edit\"></i> </a><a title=\"View Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.operationPointMain.operationPointView({id:\'{{data.id}}\'})\"><i class=\"fa fa-eye\"></i> </a><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteOperationPoints(data,$event)><i class=\"fa fa-trash\"></i></a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noOperation\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav ng-show=\"vm.watchPagination\">--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\" ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/operationPoint/operationPointEdit.html","<h2 class=ng-cloak>Editar punto de operación</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'basicDetails\' | translate}}</p><div class=basicDetailsDiv><form name=operationEditForm ng-submit=\"submit=true;operationEditForm.$valid&&vm.editApi()\" novalidate autocomplete=off><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'pointName\' | translate}} <span style=color:red>*</span></label><input type=text ng-model=vm.dataToFill.pointName placeholder=\"{{\'pointName\' | translate}}\" class=form-control maxlength=50 name=pointName required ng-class=\"{ \'has-error\': operationEditForm.pointName.$touched && operationEditForm.pointName.$invalid }\"><div ng-if=\"operationEditForm.pointName.$touched|| submit\" ng-messages=operationEditForm.pointName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'pointNameRe\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'percentageComission\' | translate}} <span style=color:red>*</span></label><input type=text ng-model=vm.dataToFill.comission placeholder=\"{{\'percentageComission\' | translate}}\" class=form-control is-number=\"\" maxlength=3 name=comission required ng-class=\"{ \'has-error\': operationEditForm.comission.$touched && createBookingForm.comission.$invalid }\"><div ng-if=\"operationEditForm.comission.$touched|| submit\" ng-messages=operationEditForm.comission.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'percentageComissionReq\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'branchLabel\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.branch name=branch ng-disabled=true ng-options=\"branch.region_id as branch.region_name for branch in vm.branchList\" required ng-class=\"{ \'has-error\': operationEditForm.branch.$touched && operationEditForm.branch.$invalid }\"><option value=\"\" selected disabled>{{\'branchPlaceholder\' | translate}}</option></select><div ng-if=\"operationEditForm.branch.$touched|| submit\" ng-messages=operationEditForm.branch.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'branchR\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'pickUpAddressDefault\' | translate}} <span style=color:red>*</span></label><input type=text ng-model=vm.dataToFill.pickUpDefault placeholder=\"{{\'pickUpAddressDefault\' | translate}}\" class=form-control domain={{vm.domain}} google-place callback-fn=vm.mapFn(data) name=pickUpDefault id=pickAddress required ng-class=\"{ \'has-error\': operationEditForm.pickUpDefault.$touched && operationEditForm.pickUpDefault.$invalid }\"><div ng-if=\"operationEditForm.pickUpDefault.$touched|| submit\" ng-messages=operationEditForm.pickUpDefault.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'pickUpReq\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'serviceLabel\' | translate}} <span style=color:red>*</span></label><ui-select multiple ng-model=vm.dataToFill.services theme=bootstrap close-on-select=false required name=serviceType ng-class=\"{ \'has-error\': operationEditForm.serviceType.$touched && operationEditForm.serviceType.$invalid }\"><ui-select-match placeholder=\"{{\'servicePlaceholder\' | translate}}\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in vm.service | filter:$select.search\">{{data.name}}</ui-select-choices></ui-select><div ng-if=\"operationEditForm.serviceType.$touched|| submit\" ng-messages=operationEditForm.serviceType.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'serviceReq\' | translate}}</div></div></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><button type=submit class=\"btn btn-primary\" style=width:200px>{{\'submit\' | translate}}</button></div></div></form></div></div></div></div><div class=row style=\"margin-top: 30px\"><div class=\"col-lg-5 col-sm-5 col-md-5 col-xs-6 col-lg-offset-1 col-xs-offset-1 col-md-offset-1 col-sm-offset-1\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">Sector Frecuentes</p><div class=basicDetailsDiv><div class=\"row mt5\" style=margin-left:0px;margin-right:0px><button style=float:right class=\"btn btn-primary\" ng-click=vm.openPopUpForAdding() ng-if=\"vm.addressButton == true\">Agregar comuna</button></div><div class=\"row mt5\" style=margin-left:0px;margin-right:0px><table class=\"table table-hover tableWithMasterData\"><thead><tr><th style=width:70px>Nombre</th><th style=width:70px>Direccion</th><th style=width:70px>Action</th></tr></thead><tbody ng-if=\"vm.addressArray.length>0\"><tr ng-repeat=\"data in filtered = vm.addressArray\"><td style=width:70px>{{data.address_name}}</td><td style=width:70px>{{data.direction_name}}</td><td style=width:70px><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteAddress(data,$event)><i class=\"fa fa-trash\"></i></a></td></tr></tbody></table></div></div></div></div><div class=\"col-lg-5 col-sm-5 col-md-5 col-xs-6 col-lg-offset-0 col-xs-offset-1 col-md-offset-1 col-sm-offset-1\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">Convenio Frecuentes</p><div class=basicDetailsDiv><div><div class=\"row mt5\" style=margin-left:0px;margin-right:0px><button style=float:right class=\"btn btn-primary\" ng-click=vm.openPopUpForAgrrementMain() ng-if=\"vm.agrrementButton == true\">Agregar convenio</button></div><div class=\"row mt5\" style=margin-left:0px;margin-right:0px><table class=\"table table-hover tableWithMasterData\"><thead><tr><th style=width:70px>Nombre</th><th style=width:70px>Pasajero</th><th style=width:70px>Action</th></tr></thead><tbody ng-if=\"vm.agreementArray.length>0\"><tr ng-repeat=\"data in filtered = vm.agreementArray\"><td style=width:70px>{{data.contract_name}}</td><td style=width:70px>{{data.customer_name != null ? data.customer_name : \'--\'}}</td><td style=width:70px><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteAgrrement(data,$event)><i class=\"fa fa-trash\"></i></a></td></tr></tbody></table></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/operationPoint/operationPointMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/operationPoint/operationPointRegister.html","<h2 class=ng-cloak>Registrar punto de operación</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'basicDetails\' | translate}}</p><div class=basicDetailsDiv><form name=operationRegisterForm ng-submit=\"submit=true;operationRegisterForm.$valid&&vm.registerApi()\" novalidate autocomplete=off><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'pointName\' | translate}}<span style=color:red>*</span></label><input type=text ng-model=vm.dataToFill.pointName placeholder=\"{{\'pointName\' | translate}}\" class=form-control maxlength=50 name=pointName required ng-class=\"{ \'has-error\': operationRegisterForm.pointName.$touched && operationRegisterForm.pointName.$invalid }\"><div ng-if=\"operationRegisterForm.pointName.$touched|| submit\" ng-messages=operationRegisterForm.pointName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'pointNameRe\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'percentageComission\' | translate}}<span style=color:red>*</span></label><input type=text ng-model=vm.dataToFill.comission placeholder=\"{{\'percentageComission\' | translate}}\" class=form-control is-number=\"\" maxlength=3 name=comission required ng-class=\"{ \'has-error\': operationRegisterForm.comission.$touched && createBookingForm.comission.$invalid }\"><div ng-if=\"operationRegisterForm.comission.$touched|| submit\" ng-messages=operationRegisterForm.comission.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'percentageComissionReq\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'branchLabel\' | translate}}<span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.branch name=branch ng-options=\"branch.region_id as branch.region_name for branch in vm.branchList\" required ng-class=\"{ \'has-error\': operationRegisterForm.branch.$touched && operationRegisterForm.branch.$invalid }\"><option value=\"\" selected disabled>{{\'branchPlaceholder\' | translate}}</option></select><div ng-if=\"operationRegisterForm.branch.$touched|| submit\" ng-messages=operationRegisterForm.branch.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'branchR\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'pickUpAddressDefault\' | translate}}<span style=color:red>*</span></label><input type=text ng-model=vm.dataToFill.pickUpDefault placeholder=\"{{\'pickUpAddressDefault\' | translate}}\" class=form-control domain={{vm.domain}} google-place callback-fn=vm.mapFn(data) name=pickUpDefault id=pickAddress required ng-class=\"{ \'has-error\': operationRegisterForm.pickUpDefault.$touched && operationRegisterForm.pickUpDefault.$invalid }\"><div ng-if=\"operationRegisterForm.pickUpDefault.$touched|| submit\" ng-messages=operationRegisterForm.pickUpDefault.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'pickUpReq\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'serviceLabel\' | translate}}<span style=color:red>*</span></label><ui-select multiple ng-model=vm.dataToFill.services theme=bootstrap close-on-select=false required name=serviceType ng-class=\"{ \'has-error\': operationRegisterForm.serviceType.$touched && operationRegisterForm.serviceType.$invalid }\"><ui-select-match placeholder=\"{{\'servicePlaceholder\' | translate}}\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in vm.service | filter:$select.search\">{{data.name}}</ui-select-choices></ui-select><div ng-if=\"operationRegisterForm.serviceType.$touched|| submit\" ng-messages=operationRegisterForm.serviceType.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'serviceReq\' | translate}}</div></div></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><button type=submit class=\"btn btn-primary\" style=width:200px>{{\'submit\' | translate}}</button></div></div></form></div></div></div></div><div class=row style=\"margin-top: 30px\"><div class=\"col-lg-5 col-sm-5 col-md-5 col-xs-6 col-lg-offset-1 col-xs-offset-1 col-md-offset-1 col-sm-offset-1\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">Sector Frecuentes</p><div class=basicDetailsDiv><div class=\"row mt5\" style=margin-left:0px;margin-right:0px><button style=float:right class=\"btn btn-primary\" ng-click=vm.openPopUpForAdding() ng-if=\"vm.addressButton == true\">Agregar comuna</button></div><div class=\"row mt5\" style=margin-left:0px;margin-right:0px><table class=\"table table-hover tableWithMasterData\"><thead><tr><th style=width:70px>Nombre</th><th style=width:70px>Direccion</th><th style=width:70px>Action</th></tr></thead><tbody ng-if=\"vm.addressArray.length>0\"><tr ng-repeat=\"data in filtered = vm.addressArray\"><td style=width:70px>{{data.address_name}}</td><td style=width:70px>{{data.direction_name}}</td><td style=width:70px><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteAddress(data,$event)><i class=\"fa fa-trash\"></i></a></td></tr></tbody></table></div></div></div></div><div class=\"col-lg-5 col-sm-5 col-md-5 col-xs-6 col-lg-offset-0 col-xs-offset-1 col-md-offset-1 col-sm-offset-1\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">Convenio Frecuentes</p><div class=basicDetailsDiv><div><div class=\"row mt5\" style=margin-left:0px;margin-right:0px><button style=float:right class=\"btn btn-primary\" ng-click=vm.openPopUpForAgrrementMain() ng-if=\"vm.agrrementButton == true\">Agregar convenio</button></div><div class=\"row mt5\" style=margin-left:0px;margin-right:0px><table class=\"table table-hover tableWithMasterData\"><thead><tr><th style=width:70px>Nombre</th><th style=width:70px>Pasajero</th><th style=width:70px>Action</th></tr></thead><tbody ng-if=\"vm.agreementArray.length>0\"><tr ng-repeat=\"data in filtered = vm.agreementArray\"><td style=width:70px>{{data.contract_name}}</td><td style=width:70px>{{data.customer_name != null ? data.customer_name : \'--\'}}</td><td style=width:70px><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteAgrrement(data,$event)><i class=\"fa fa-trash\"></i></a></td></tr></tbody></table></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/operationPoint/operationPointView.html","<h2 class=ng-cloak>Ver punto de operación</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'basicDetails\' | translate}}</p><div class=basicDetailsDiv><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'pointName\' | translate}}<span style=color:red>*</span></label><div class=\"form-control text-capitalize\">{{::vm.dataToFill.point_name}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'percentageComission\' | translate}}<span style=color:red>*</span></label><div class=\"form-control text-capitalize\">{{::vm.dataToFill.percentage}}</div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'branchLabel\' | translate}}<span style=color:red>*</span></label><div class=\"form-control text-capitalize\">{{::vm.dataToFill.region_name}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'pickUpAddressDefault\' | translate}}<span style=color:red>*</span></label><div class=\"form-control text-capitalize\">{{::vm.dataToFill.address}}</div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'serviceLabel\' | translate}}<span style=color:red>*</span></label><div class=\"form-control text-capitalize\" style=\"height: auto\"><span ng-repeat=\"data in vm.dataToFill.services\">{{data.service_name}} <span ng-if=\"$index != vm.dataToFill.services.length - 1\">,</span></span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>{{\'stateTable\' | translate}}<span style=color:red>*</span></label><div class=\"form-control text-capitalize\"><span ng-if=\"vm.dataToFill.status == 1\">Active</span> <span ng-if=\"vm.dataToFill.status == 0\">Inactive</span></div></div></div></div></div></div></div><div class=row style=\"margin-top: 30px\"><div class=\"col-lg-5 col-sm-5 col-md-5 col-xs-6 col-lg-offset-1 col-xs-offset-1 col-md-offset-1 col-sm-offset-1\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">Sector Frecuentes</p><div class=basicDetailsDiv><div class=\"row mt5\" style=margin-left:0px;margin-right:0px><table class=\"table table-hover tableWithMasterData\"><thead><tr><th style=width:70px>Nombre</th><th style=width:70px>Direccion</th></tr></thead><tbody ng-if=\"vm.addressArray.length>0\"><tr ng-repeat=\"data in filtered = vm.addressArray\"><td style=width:70px>{{data.address_name}}</td><td style=width:70px>{{data.direction_name}}</td></tr></tbody></table></div></div></div></div><div class=\"col-lg-5 col-sm-5 col-md-5 col-xs-6 col-lg-offset-0 col-xs-offset-1 col-md-offset-1 col-sm-offset-1\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">Convenio Frecuentes</p><div class=basicDetailsDiv><div><div class=\"row mt5\" style=margin-left:0px;margin-right:0px><table class=\"table table-hover tableWithMasterData\"><thead><tr><th style=width:70px>Nombre</th><th style=width:70px>Pasajero</th></tr></thead><tbody ng-if=\"vm.agreementArray.length>0\"><tr ng-repeat=\"data in filtered = vm.agreementArray\"><td style=width:70px>{{data.contract_name}}</td><td style=width:70px>{{data.customer_name != null ? data.customer_name : \'--\'}}</td></tr></tbody></table></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/operationPointUser/operationPointUser.html","<h2 class=ng-cloak>Usuarios por Punto de Operación</h2><div class=\"ng-cloak container-fluid\" ng-class=\"{\'whirl duo\':vm.loading}\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'operationPoint\' | translate}}:</label><div><ui-select ng-model=vm.filterData.operation_value name=branch required close-on-select=true ng-change=vm.getOperationPointUsers(0,vm.itemsPerPageGot,vm.filterData)><ui-select-match placeholder=\"{{\'operationPoint\' | translate}}\">{{$select.selected.point_name}}</ui-select-match><ui-select-choices repeat=\"operation.point_id as operation in vm.allOperationPoint | filter: $select.search | orderBy:\'point_name\' \"><div ng-bind-html=operation.point_name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><p class=totalSize><!--<span class=\"pull-right\">--><!--<a class=\"btn btn-primary mb10\" ng-click=\"vm.createNewUser($event)\">+ {{\'newAdminButton\' | translate}}</a>--><!--</span> --> {{\'totalUser\' | translate}}: {{vm.totalOperationUsers}}</p></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt10\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-switch=\"(vm.serviceList | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'admin_id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'name\' | translate}}\" text=\"\'fullName\'\" check=vm.reverse>{{\'name\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'email\' | translate}}\" text=\"\'email\'\" check=vm.reverse>{{\'email\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'pointName\' | translate}}\" text=\"\'point_name\'\" check=vm.reverse>{{\'pointName\' | translate}}</th><th style=width:200px><div>{{\'operationPoint\' | translate}}</div></th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.operationUserList| filter:vm.search | orderBy:vm.predicate:vm.reverse\"><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:70px>{{::data.admin_id}}</td><td style=width:125px>{{::data.fullName || \'--\'}}</td><td style=width:125px>{{::data.email}}</td><td style=width:125px>{{::data.point_name}}</td><td style=width:200px><a class=\"btn btn-primary tableButton mb10\" ng-click=vm.changeToOperationPoint(data,$event)>{{\'operationPointChange\' | translate}}</a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noOperationUser\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav ng-show=\"vm.watchPagination\">--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\" ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/operationPointUser/operationPointUserMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/payment-method/addPaymentMethod.html","<h2 class=ng-cloak>{{\'paymentPHead\' | translate}} / {{\'addPaymentButton\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=driver><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><form name=addPaymentMethodForm ng-submit=\"submit=true;addPaymentMethodForm.$valid&&vm.addPaymentMethodApi()\" novalidate autocomplete=off><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'paymentType\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.paymentType name=paymentType placeholder=\"{{\'paymentType\' | translate}}\" required ng-class=\"{ \'has-error\': addPaymentMethodForm.paymentType.$touched && addPaymentMethodForm.paymentType.$invalid }\" ng-minlength=3 ng-maxlength=50><div ng-if=\"addPaymentMethodForm.paymentType.$touched|| submit\" ng-messages=addPaymentMethodForm.paymentType.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'paymentTypeReq\' | translate}}</div><!-- <div class=\"errormessage text-danger\" ng-message=\"pattern\">\n                                                {{\'paymentTypeValid\' | translate}}\n                                            </div> --><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'usernameMax\' | translate}}</div></div></div></div><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'paymentTypeEnglish\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.paymentTypeEnglish name=paymentTypeEnglish placeholder=\"{{\'paymentTypeEnglish\' | translate}}\" required ng-class=\"{ \'has-error\': addPaymentMethodForm.paymentTypeEnglish.$touched && addPaymentMethodForm.paymentTypeEnglish.$invalid }\" pattern=\"^[a-zA-Z0-9 ]+$\" ng-minlength=3 ng-maxlength=50><div ng-if=\"addPaymentMethodForm.paymentTypeEnglish.$touched|| submit\" ng-messages=addPaymentMethodForm.paymentTypeEnglish.$error><div class=\"errormessage text-danger\" ng-message=required>Favor ingrese Tipo de pago (Versión Inglés).</div><div class=\"errormessage text-danger\" ng-message=pattern>Tipo de pago (versión en inglés) no válido.</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'usernameMax\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'paymentStatus\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.paymentStatus required name=paymentStatus ng-class=\"{ \'has-error\': addPaymentMethodForm.paymentStatus.$touched && addPaymentMethodForm.paymentStatus.$invalid }\"><option value=\"\" selected disabled>{{\'selectPaymentStatus\' | translate}}</option><option value=1>Paid</option><option value=0>Not Paid</option></select><div ng-if=\"addPaymentMethodForm.paymentStatus.$touched|| submit\" ng-messages=addPaymentMethodForm.paymentStatus.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'selectPaymentStatusR\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'isIonix\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.isIonix required name=isIonix ng-class=\"{ \'has-error\': addPaymentMethodForm.isIonix.$touched && addPaymentMethodForm.isIonix.$invalid }\"><option value=1>True</option><option value=0>False</option></select><div ng-if=\"addPaymentMethodForm.isIonix.$touched|| submit\" ng-messages=addPaymentMethodForm.isIonix.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'isIonixR\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" style=\"margin-top: 20px\"><span class=headingBollean>Permite devolución de MP : <span style=color:red>*</span> </span><span><i class=boleeanTypeColor ng-click=vm.setBooleansPayment() ng-class=\"{\'fa fa-toggle-on\': vm.paymentStatus , \'fa fa-toggle-off\': !vm.paymentStatus}\"></i></span><div ng-if=\"addPaymentMethodForm.paymentStatus.$touched|| submit\" ng-messages=addPaymentMethodForm.paymentStatus.$error><div class=\"errormessage text-danger\" ng-message=required>Seleccione estado de Permite devolución de MP</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Hacer devolución con este Método de pago <span style=color:red>*</span></label><select ng-disabled=!vm.paymentStatus ng-click=vm.setMethod() class=form-control ng-model=vm.paymentMethodId name=model ng-class=\"{ \'has-error\': addPaymentMethodForm.model.$touched && addPaymentMethodForm.model.$invalid }\" ng-options=\"data.id\n                                        as data.type for data in vm.paymentMethodList\"><option value=\"\" disabled selected>Hacer devolución con este Método de pago</option></select><div ng-if=vm.flagForTrue><div class=\"errormessage text-danger\">Seleccione estado de Hacer devolución con este Método de pago</div></div></div></div><div class=\"row mt25\" style=\"margin-left: 0px;margin-right: 0px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=padding:0px><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'otherDetails\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\"><table class=table id=aggreementTable><tbody><tr ng-repeat=\"channel in  vm.dataToFill.channels\"><td class=headingBollean>{{channel.channel_name}}</td><td class=boleeanTypeColor><i ng-click=vm.setBooleans($index) ng-class=\"{\'fa fa-toggle-on\': channel.checked , \'fa fa-toggle-off\': !channel.checked}\"></i></td></tr></tbody></table></div></div></div><div class=panel-footer><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><button type=submit class=\"btn btn-primary\">{{\'submit\' | translate}}</button></div></div></div></div></form></div></div></div></div></div>");
$templateCache.put("app/components/views/payment-method/editPaymentMethod.html","<h2 class=ng-cloak>{{\'paymentMethodLabel\' | translate}} / {{\'editPaymentHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=driver><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><form name=editPaymentMethodForm ng-submit=\"submit=true;editPaymentMethodForm.$valid&&vm.editPaymentMethodApi()\" novalidate autocomplete=off><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'paymentType\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.paymentType name=paymentType placeholder=\"{{\'paymentType\' | translate}}\" required ng-class=\"{ \'has-error\': editPaymentMethodForm.paymentType.$touched && editPaymentMethodForm.paymentType.$invalid }\" ng-minlength=3 ng-maxlength=50><div ng-if=\"editPaymentMethodForm.paymentType.$touched|| submit\" ng-messages=editPaymentMethodForm.paymentType.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'paymentTypeReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'usernameMax\' | translate}}</div></div></div></div><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'paymentTypeEnglish\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.paymentTypeEnglish name=paymentTypeEnglish placeholder=\"{{\'paymentTypeEnglish\' | translate}}\" required ng-class=\"{ \'has-error\': editPaymentMethodForm.paymentTypeEnglish.$touched && editPaymentMethodForm.paymentTypeEnglish.$invalid }\" pattern=\"^[a-zA-Z0-9 ]+$\" ng-minlength=3 ng-maxlength=50><div ng-if=\"editPaymentMethodForm.paymentTypeEnglish.$touched|| submit\" ng-messages=editPaymentMethodForm.paymentTypeEnglish.$error><div class=\"errormessage text-danger\" ng-message=required>Favor ingrese Tipo de pago (Versión Inglés).</div><div class=\"errormessage text-danger\" ng-message=pattern>Tipo de pago (versión en inglés) no válido.</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'usernameMax\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'paymentStatus\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.paymentStatus required name=paymentStatus ng-class=\"{ \'has-error\': editPaymentMethodForm.paymentStatus.$touched && editPaymentMethodForm.paymentStatus.$invalid }\"><option value=\"\" selected disabled>{{\'selectPaymentStatus\' | translate}}</option><option value=1>Paid</option><option value=0>Not Paid</option></select><div ng-if=\"editPaymentMethodForm.paymentStatus.$touched|| submit\" ng-messages=editPaymentMethodForm.paymentStatus.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'selectPaymentStatusR\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'isIonix\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.isIonix required name=isIonix ng-class=\"{ \'has-error\': editPaymentMethodForm.isIonix.$touched && editPaymentMethodForm.isIonix.$invalid }\"><option value=1>True</option><option value=0>False</option></select><div ng-if=\"editPaymentMethodForm.isIonix.$touched|| submit\" ng-messages=editPaymentMethodForm.isIonix.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'isIonixR\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" style=\"margin-top: 20px\"><span class=headingBollean>Permite devolución de MP : <span style=color:red>*</span> </span><span><i class=boleeanTypeColor ng-click=vm.setBooleansPayment() ng-class=\"{\'fa fa-toggle-on\': vm.paymentStatus , \'fa fa-toggle-off\': ! vm.paymentStatus}\"></i> </span><!-- <div ng-if=\"editPaymentMethodForm.paymentStatus.$touched|| submit\" ng-messages=\"editPaymentMethodForm.paymentStatus.$error\">\n                                            <div class=\"errormessage text-danger\" ng-message=\"required\">\n                                                Seleccione estado de Permite devolución de MP\n                                            </div>\n                                        </div> --></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Hacer devolución con este Método de pago <span style=color:red>*</span></label><select ng-disabled=!vm.paymentStatus class=form-control ng-model=vm.paymentMethodId name=model ng-class=\"{ \'has-error\': editPaymentMethodForm.model.$touched && editPaymentMethodForm.model.$invalid }\" ng-options=\"data.id\n                                        as data.type for data in vm.paymentMethodList\"><option value=\"\" disabled selected>Hacer devolución con este Método de pago</option></select><div ng-if=vm.flagForTrue><div class=\"errormessage text-danger\">Seleccione estado de Hacer devolución con este Método de pago</div></div></div></div><div class=\"row mt25\" style=\"margin-left: 0px;margin-right: 0px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=padding:0px><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'otherDetails\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\"><table class=table id=aggreementTable><tbody><tr ng-repeat=\"channel in  vm.dataToFill.channels\"><td class=headingBollean>{{channel.channel_name}}</td><td class=boleeanTypeColor><i ng-click=vm.setBooleans($index) ng-class=\"{\'fa fa-toggle-on\': channel.checked , \'fa fa-toggle-off\': !channel.checked}\"></i></td></tr></tbody></table></div></div></div><div class=panel-footer><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><button type=submit class=\"btn btn-primary\">{{\'submit\' | translate}}</button></div></div></div></div></form></div></div></div></div></div>");
$templateCache.put("app/components/views/payment-method/paymentTypeList.html","<h2 class=ng-cloak>{{\'paymentMethodLabel\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-4 col-sm-6 col-md-4 col-xs-12\"><label class=control-label>{{\'paymentTypeStatus\' | translate}}</label><select class=form-control ng-model=vm.filterData.paymentStatus ng-change=\"vm.getAllPaymentMethods(vm.filterData.paymentStatus,0,10);vm.currentPage = 0;\"><option value=\"\" disabled>{{\'paymentTypeLabel\' | translate}}</option><option value=0>Inactive</option><option selected value=1>Active</option><option value=2>All</option></select></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><p class=totalSize><span class=pull-right><a class=\"btn btn-primary mb10\" ui-sref=layout.paymentTypeMain.addPaymentType>+ {{\'addPaymentButton\' | translate}}</a> </span>Total Methods: {{vm.totalMethods}}</p></div><br><br><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\" ng-switch=\"(vm.corporateList | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'paymentType\' | translate}}\" text=\"\'type\'\" check=vm.reverse>{{\'paymentType\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'paymentStatus\' | translate}}\" text=\"\'payment_status\'\" check=vm.reverse>{{\'paymentStatus\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=Canal text=\"\'payment_status\'\" check=vm.reverse>Canal</th><th style=width:100px table-column-sorting current-text=vm.predicate title=Ionix text=\"\'is_ionix\'\" check=vm.reverse>Ionix</th><!--<th>--><!--<div class=\"text-center\" ng-click=\"vm.sort(\'status\')\">--><!--Status--><!--<span ng-hide=\"vm.predicate == \'status\' && vm.reverse || vm.predicate == \'status\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'status\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'status\' && vm.reverse\" class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><th style=width:100px><div class=text-center>{{\'stateTable\' | translate}}</div></th><th style=width:150px><div class=text-center>{{\'action\' | translate}}</div></th><th style=width:150px><div class=text-center>{{\'adminLogs\' | translate}}</div></th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.paymentMethodList| filter:vm.search | orderBy:vm.predicate:vm.reverse\"><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:70px>{{::data.id}}</td><td style=width:125px>{{::data.type}}</td><td style=width:100px><span ng-if=\"data.payment_status == 0\">Not Paid</span> <span ng-if=\"data.payment_status == 1\">Paid</span></td><td style=width:125px><span ng-if=\"data.channels.length == 0\">--</span> <span ng-repeat=\"d in data.channels track by $index\">{{d}}{{$last ? \'\' : \', \'}}</span></td><td style=width:100px><span ng-if=\"data.is_ionix == 0\">False</span> <span ng-if=\"data.is_ionix == 1\">True</span></td><!--<td>--><!--<span ng-if=\"data.status == 0 || data.status == null\">Inactive</span>--><!--<span ng-if=\"data.status == 1\">Active</span>--><!--</td>--><td style=width:100px><a class=\"cursor btn btn-sm\" ng-class=\"{\'blockIconColor\': data.status == 0, \'unblockIconColor\': data.status == 1 || data.status == null}\" ng-click=vm.blockUnblockPayments($event,data.id,data.status)><i ng-class=\"{\'fa fa-unlock\': data.status == 1 || data.status == null,\'fa fa-lock\': data.status == 0}\"></i></a></td><td style=width:150px><a title=\"Edit Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.paymentTypeMain.editPaymentType({id:\'{{data.id}}\'})\"><i class=\"fa fa-edit\"></i> </a><a title=\"View Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.paymentTypeMain.viewPaymentType({id:\'{{data.id}}\'})\"><i class=\"fa fa-eye\"></i> </a><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deletePaymentType(data,$event)><i class=\"fa fa-trash\"></i></a></td><td style=width:150px><a class=\"btn btn-primary tableButton\" title=\"{{\'adminLogs\' | translate}}\" ui-sref=\"layout.paymentTypeMain.adminLogs({userId:\'{{data.id}}\',type:\'14\',fakeType: \'11\'})\">{{\'adminLogs\' | translate}}</a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noPaymentFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav ng-show=\"vm.watchPagination\">--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\" ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/payment-method/paymentTypeMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/payment-method/viewPaymentType.html","<h2 class=ng-cloak>{{\'paymentMethodLabel\' | translate}} / {{\'viewPaymentHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=driver><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'allDetails\' | translate}}</p><div class=basicDetailsDiv><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'paymentType\' | translate}}:</label><div class=\"form-control text-capitalize\" style=\"height: auto\">{{::vm.paymentDetail.type}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'paymentTypeEnglish\' | translate}}:</label><div class=\"form-control text-capitalize\" style=\"height: auto\">{{::vm.paymentDetail.type_english}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'paymentStatus\' | translate}}:</label><div class=\"form-control text-capitalize\"><span ng-if=\"vm.paymentDetail.payment_status == 0\">Not Paid</span> <span ng-if=\"vm.paymentDetail.payment_status == 1\">Paid</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'isIonix\' | translate}}:</label><div class=\"form-control text-capitalize\"><span ng-if=\"vm.paymentDetail.is_ionix == 0\">False</span> <span ng-if=\"vm.paymentDetail.is_ionix == 1\">True</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'paymentId\' | translate}}:</label><div class=\"form-control text-capitalize\">{{::vm.paymentDetail.id}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'paymentStatus\' | translate}}:</label><div class=\"form-control text-capitalize\"><span ng-if=\"vm.paymentDetail.status == 1\">Active</span> <span ng-if=\"vm.paymentDetail.status == 0\">Not Active</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'paymentDeleted\' | translate}}:</label><div class=\"form-control text-capitalize\"><span ng-if=\"vm.paymentDetail.is_deleted == 1\">Yes</span> <span ng-if=\"vm.paymentDetail.is_deleted == 0\">No</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Permite devolución de MP:</label><div class=\"form-control text-capitalize\"><span ng-if=\"vm.paymentDetail.is_refund == 1\">true</span> <span ng-if=\"vm.paymentDetail.is_refund == 0\">False</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Hacer devolución con este Método de pago:</label><div class=\"form-control text-capitalize\">{{::vm.paymentDetail.refund_type}}</div></div></div><div class=\"row mt25\" style=\"margin-left: 0px;margin-right: 0px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=padding:0px><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'otherDetails\' | translate}}</p></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\"><table class=table id=aggreementTable><tbody><tr ng-repeat=\"channel in  vm.dataToFill.channels\"><td class=headingBollean>{{channel.channel_name}}</td><td class=boleeanTypeColor><i ng-class=\"{\'fa fa-toggle-on\': channel.checked , \'fa fa-toggle-off\': !channel.checked}\"></i></td></tr></tbody></table></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/production-list/detailedProductionVehicle.html","<h2 class=ng-cloak><span>{{\'detailedProd\' | translate}}</span> <span class=pull-right><button class=\"btn btn-primary tableButton\" ng-click=vm.refreshData()>Volver a cargar</button></span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=displayFlex><div class=filterAlign><label>{{\'since\' | translate}}:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=sinceDate ng-model=vm.filterData.since_date placeholder=\"{{\'since\' | translate}}\" is-open=vm.datePicker_1.sinceDate datepicker-options=vm.dateOptions required close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.sinceDateChanged()> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_1(1)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=filterAlign><label>{{\'singleUntill\' | translate}}:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=untillDate ng-model=vm.filterData.until_date placeholder=\"{{\'singleUntill\' | translate}}\" is-open=vm.datePicker_1.untillDate datepicker-options=vm.dateOptions required close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.untillDateChanged()> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_1(2)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=filterAlign><label>{{\'branchLabel\' | translate}}:</label><div><ui-select ng-model=vm.filterData.branch name=branch ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select></div></div><div class=filterAlign><label>{{\'serviceLabel\' | translate}}:</label><div><ui-select ng-model=vm.filterData.type_of_service name=service ng-keyup=vm.serviceSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=\"{{\'selectTService\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"services.id as services in vm.service | filter: $select.search | orderBy:\'name\' \" when-scrolled=vm.paginationChangedForService() ng-click=vm.serviceChanged()><div ng-bind-html=services.name></div></ui-select-choices></ui-select></div></div><div class=filterAlign><label>{{\'vehicleLabel\' | translate}}:</label><div><ui-select ng-model=vm.filterData.type_of_vehicle name=vehicle ng-keyup=vm.vehicleSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=\"{{\'vehicleSelect\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"vehicles.id as vehicles in vm.vehicle | filter: $select.search | orderBy:\'name\' \" when-scrolled=vm.paginationChangedForVehicle() ng-click=vm.vehicleChanged()><div ng-bind-html=vehicles.name></div></ui-select-choices></ui-select></div></div><div class=filterAlign><label style=\"visibility: hidden\">{{\'pickUpTimeLabel\' | translate}}:</label><br><button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px\" ng-click=vm.applyFilter()>Apply Filter</button></div><div class=filterAlign><label style=\"visibility: hidden\">Pickup Time:</label><br><button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px\" ng-click=vm.resetFilter()>{{\'resetFilterButton\' | translate}}</button></div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><p class=totalSize><span class=pull-left><a class=\"btn btn-primary tableButton mb10\" ng-click=vm.exportToCSV()>CSV</a> </span><span>{{\'totalList\' | translate}}: {{vm.totalDetailedList}}</span></p></div><br><br><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model-options=\"{ debounce: 500 }\" ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\"><!-- ng-switch=\"(vm.upcomingBookingList | filter:vm.search).length\"--><!--<div ng-switch-when=\"0\" class=\"noSearch\"><span>{{\'nothingFound\' | translate}}</span></div>--><table class=\"table table-hover tableWithMasterData\"><!--ng-switch-default--><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'branchLabel\' | translate}}\" text=\"\'region_name\'\" check=vm.reverse>{{\'branchLabel\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'vehicleUnique\' | translate}}\" text=\"\'unique_car_id\'\" check=vm.reverse>{{\'vehicleUnique\' | translate}}</th><!--<th style=\"min-width:115px;\">--><!--<div class=\"text-center\" ng-click=\"vm.sort(\'transport_details\')\">--><!--Virtual Fleet--><!--<span ng-hide=\"vm.predicate == \'transport_details\' && vm.reverse || vm.predicate == \'transport_details\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'transport_details\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'transport_details\' && vm.reverse\" class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><th style=width:115px table-column-sorting current-text=vm.predicate title=\"{{\'Driver\' | translate}}\" text=\"\'driverName\'\" check=vm.reverse>{{\'Driver\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'idBooking\' | translate}}\" text=\"\'booking_id\'\" check=vm.reverse>{{\'idBooking\' | translate}}</th><th style=width:115px table-column-sorting current-text=vm.predicate title=\"{{\'serviceLabel\' | translate}}\" text=\"\'service_name\'\" check=vm.reverse>{{\'serviceLabel\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'vehicleLabel\' | translate}}\" text=\"\'name\'\" check=vm.reverse>{{\'vehicleLabel\' | translate}}</th><th style=\"width: 150px\" table-column-sorting current-text=vm.predicate title=\"{{\'startTime\' | translate}}\" text=\"\'started_datetime\'\" check=vm.reverse>{{\'startTime\' | translate}}</th><th style=\"width: 150px\" table-column-sorting current-text=vm.predicate title=\"{{\'trip\' | translate}}\" text=\"\'payment_amount\'\" check=vm.reverse>$ {{\'trip\' | translate}}</th><th style=\"width: 150px\" table-column-sorting current-text=vm.predicate title=\"{{\'airportService\' | translate}}\" text=\"\'isAirportService\'\" check=vm.reverse>{{\'airportService\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'earning\' | translate}}\" text=\"\'earning_percentage\'\" check=vm.reverse>% {{\'earning\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'earning\' | translate}}\" text=\"\'service_cost\'\" check=vm.reverse>$ {{\'earning\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'working24\' | translate}}\" text=\"\'modelity\'\" check=vm.reverse>{{\'working24\' | translate}}</th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.DetailedProList | orderBy:vm.predicate:vm.reverse\"><!--| filter:vm.search--><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:100px>{{data.region_name || \'--\'}}</td><td style=width:125px>{{data.unique_car_id || \'--\'}}</td><td style=width:115px>{{data.driverName || \'--\'}}</td><td style=width:125px>{{data.booking_id || \'--\'}}</td><td style=width:115px>{{data.service_name || \'--\'}}</td><td style=width:125px>{{data.name || \'--\'}}</td><td style=width:150px>{{data.started_datetime | date: \'medium\'}}</td><td style=width:150px>{{data.payment_amount || \'0\'}}</td><td style=width:150px><span ng-if=!data.isAirportService>NO </span><span ng-if=data.isAirportService>YES</span></td><td style=width:125px>{{data.earning_percentage || \'0\'}}</td><td style=width:125px>{{data.service_cost || \'0\'}}</td><td style=width:125px><span ng-if=!data.modelity>Not 24 Hrs </span><span ng-if=data.modelity>24 Hrs</span></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noDetailed\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav>--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\" ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/production-list/detailedProductionVehicleMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/production-list/itemOfChargeCsv.html","<h2 class=ng-cloak><span>{{\'ItemProd\' | translate}}</span> <span class=pull-right><!-- <button class=\"btn btn-primary tableButton\" ng-click=\"vm.refreshData()\">Volver a cargar</button> --></span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=displayFlex><div class=filterAlign><label>{{\'since\' | translate}}:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=sinceDate ng-model=vm.filterData.since_date placeholder=\"{{\'since\' | translate}}\" is-open=vm.datePicker_1.sinceDate required close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.sinceDateChanged()> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_1(1)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=filterAlign><label>{{\'singleUntill\' | translate}}:</label><p class=input-group><input type=text class=form-control ng-disabled=\"vm.dateFlag == false\" uib-datepicker-popup={{vm.format}} name=untillDate ng-model=vm.filterData.until_date placeholder=\"{{\'singleUntill\' | translate}}\" is-open=vm.datePicker_1.untillDate datepicker-options=vm.dateOptions required close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.untillDateChanged()> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_1(2)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><!-- <div class=\"filterAlign\">\n                            <label>{{\'branchLabel\' | translate}}:</label>\n                            <div>\n                                <ui-select ng-model=\"vm.filterData.branch\" name=\"branch\" required\n                                           close-on-select=\"true\" ng-change=\"vm.branchChanged()\">\n                                    <ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">\n                                        {{$select.selected.region_name}}\n                                    </ui-select-match>\n                                    <ui-select-choices\n                                            repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \">\n                                        <div ng-bind-html=\"branch.region_name\"></div>\n                                    </ui-select-choices>\n                                </ui-select>\n                            </div>\n                        </div> --><!-- <div class=\"filterAlign\">\n                            <label>{{\'serviceLabel\' | translate}}:</label>\n                            <div>\n                                <ui-select ng-model=\"vm.filterData.type_of_service\" name=\"service\" required\n                                           close-on-select=\"true\" ng-change=\"vm.serviceChanged()\">\n                                    <ui-select-match placeholder=\"{{\'selectTService\' | translate}}\">\n                                        {{$select.selected.name}}\n                                    </ui-select-match>\n                                    <ui-select-choices\n                                            repeat=\"services.id as services in vm.service | filter: $select.search | orderBy:\'name\' \">\n                                        <div ng-bind-html=\"services.name\"></div>\n                                    </ui-select-choices>\n                                </ui-select>\n                            </div>\n                        </div> --><!-- <div class=\"filterAlign\">\n                            <label>{{\'vehicleLabel\' | translate}}:</label>\n                            <div>\n                                <ui-select ng-model=\"vm.filterData.type_of_vehicle\" name=\"vehicle\" required\n                                           close-on-select=\"true\" ng-change=\"vm.vehicleChanged()\">\n                                    <ui-select-match placeholder=\"{{\'vehicleSelect\' | translate}}\">\n                                        {{$select.selected.name}}\n                                    </ui-select-match>\n                                    <ui-select-choices\n                                            repeat=\"vehicles.id as vehicles in vm.vehicle | filter: $select.search | orderBy:\'name\' \">\n                                        <div ng-bind-html=\"vehicles.name\"></div>\n                                    </ui-select-choices>\n                                </ui-select>\n                            </div>\n                        </div> --><!-- <div class=\"filterAlign\">\n                                <label style=\"visibility: hidden\">Pickup Time:</label><br/>\n                                <button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px;\" ng-click=\"vm.applyFilter(0,10)\">{{\' applyfilterButton\' | translate}}</button>\n                            </div> --><div class=filterAlign style=\"max-width: 800px\"><label style=\"visibility: hidden\">Pickup Time:</label><br><button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px\" ng-click=vm.applyFilterNew()>Apply Filters</button> <button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px\" ng-click=vm.resetFilter()>{{\'resetFilterButton\' | translate}}</button> <button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px\" ng-click=vm.exportCsv()>CSV</button></div><!-- <div class=\"filterAlign\">\n                                <label style=\"visibility: hidden\">Pickup Time:</label><br/>\n                                <button class=\"btn btn-primary\" ng-disabled=\"vm.flag == false\" style=\"height: 35px;line-height: 20px;\" ng-click=\"vm.downloadCsv()\">{{\'downloadCsv\' | translate}}</button>\n                            </div> --></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><p class=totalSize ng-if=\"vm.flag == true\"><!-- <span class=\"pull-left\">\n                            <a class=\"btn btn-primary tableButton mb10\" ng-click=\"vm.exportToCSV()\">CSV</a>\n                        </span> --> <span>{{\'totalList\' | translate}}: {{vm.totalDetailedList}}</span></p></div><br><br><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model-options=\"{ debounce: 500 }\" ng-model=vm.search></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\"><!-- ng-switch=\"(vm.upcomingBookingList | filter:vm.search).length\"--><table class=\"table table-hover tableWithMasterData\"><!--ng-switch-default--><thead><tr><th style=width:70px ng-if=\"vm.flag == true && vm.itemOfChargeListGotNew.length\">Job Id</th><th ng-repeat=\"data in vm.keys1\" style=width:70px>{{vm.showLongName(vm.itemOfChargeListGotNew[0][data])}}</th></tr></thead><tbody ng-if=\"vm.flag == false\" sty><th colspan=6 class=noDataClass>{{\'searchCustError\' | translate}}</th></tbody><tbody ng-if=\"vm.flag == true\"><tr ng-repeat=\"data in vm.itemOfChargeListGotNew | filter: vm.search \"><!--| filter:vm.search--><td style=\"width: 100px\">{{data.job_id}}</td><td style=width:100px ng-repeat=\"key in vm.keys1 \">{{vm.showValue(data,key)}}</td></tr></tbody></table></div><div class=row ng-if=vm.itemOfChargeListGotNew.length><div ng-if=\"vm.flag == true\" class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><div class=pull-right ng-if=\"vm.sp_pagination && vm.flag == true\"><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/production-list/itemOfChargeCsvMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/production-list/summaryProductionVehicle.html","<h2 class=ng-cloak><span>{{\'summaryProd\' | translate}}</span> <span class=pull-right><button class=\"btn btn-primary tableButton\" ng-click=vm.refreshData()>Volver a cargar</button></span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=displayFlex><div class=filterAlign><label>{{\'since\' | translate}}:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=sinceDate ng-model=vm.filterData.since_date placeholder=\"{{\'since\' | translate}}\" is-open=vm.datePicker_1.sinceDate datepicker-options=vm.dateOptions required close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.sinceDateChanged()> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_1(1)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=filterAlign><label>{{\'singleUntill\' | translate}}:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=untillDate ng-model=vm.filterData.until_date placeholder=\"{{\'singleUntill\' | translate}}\" is-open=vm.datePicker_1.untillDate datepicker-options=vm.dateOptions required close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.untillDateChanged()> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_1(2)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=filterAlign><label>{{\'branchLabel\' | translate}}:</label><div><ui-select ng-model=vm.filterData.branch name=branch ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select></div></div><div class=filterAlign><label>{{\'serviceLabel\' | translate}}:</label><div><ui-select ng-model=vm.filterData.type_of_service name=service ng-keyup=vm.serviceSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=\"{{\'selectTService\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"services.id as services in vm.service | filter: $select.search | orderBy:\'name\' \" when-scrolled=vm.paginationChangedForService() ng-click=vm.serviceChanged()><div ng-bind-html=services.name></div></ui-select-choices></ui-select></div></div><div class=filterAlign><label>{{\'vehicleLabel\' | translate}}:</label><div><ui-select ng-model=vm.filterData.type_of_vehicle name=vehicle ng-keyup=vm.vehicleSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=\"{{\'vehicleSelect\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"vehicles.id as vehicles in vm.vehicle | filter: $select.search | orderBy:\'name\' \" when-scrolled=vm.paginationChangedForVehicle() ng-click=vm.vehicleChanged()><div ng-bind-html=vehicles.name></div></ui-select-choices></ui-select></div></div><div class=filterAlign><label style=\"visibility: hidden\">{{\'pickUpTimeLabel\' | translate}}:</label><br><button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px\" ng-click=vm.applyFilter()>Apply Filter</button></div><div class=filterAlign><label style=\"visibility: hidden\">{{\'pickUpTimeLabel\' | translate}}:</label><br><button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px\" ng-click=vm.resetFilter()>{{\'resetFilterButton\' | translate}}</button></div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><p class=totalSize><span class=pull-left><a class=\"btn btn-primary tableButton mb10\" ng-click=vm.exportToCSV()>CSV</a> </span><span>{{\'totalList\' | translate}}: {{vm.totalSummaryList}}</span></p></div><br><br><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model-options=\"{ debounce: 500 }\" ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\"><!--ng-switch=\"(vm.summarProList | filter:vm.search).length\"--><!--<div ng-switch-when=\"0\" class=\"noSearch\"><span>{{\'nothingFound\' | translate}}</span></div>--><table class=\"table table-hover tableWithMasterData\"><!--ng-switch-default--><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'branchLabel\' | translate}}\" text=\"\'region_name\'\" check=vm.reverse>{{\'branchLabel\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'vehicleUnique\' | translate}}\" text=\"\'unique_car_id\'\" check=vm.reverse>{{\'vehicleUnique\' | translate}}</th><!--<th style=\"min-width:115px;\">--><!--<div class=\"text-center\" ng-click=\"vm.sort(\'transport_details\')\">--><!--Virtual Fleet--><!--<span ng-hide=\"vm.predicate == \'transport_details\' && vm.reverse || vm.predicate == \'transport_details\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'transport_details\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'transport_details\' && vm.reverse\" class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'serviceLabel\' | translate}}\" text=\"\'type_of_service\'\" check=vm.reverse>{{\'serviceLabel\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'vehicleLabel\' | translate}}\" text=\"\'type_of_vehicle\'\" check=vm.reverse>{{\'vehicleLabel\' | translate}}</th><th style=\"width: 150px\" table-column-sorting current-text=vm.predicate title=\"{{\'applicantType\' | translate}}\" text=\"\'fleet_type\'\" check=vm.reverse>{{\'hoursWorked\' | translate}}</th><th style=\"width: 150px\" table-column-sorting current-text=vm.predicate title=\"{{\'tripQuantity\' | translate}}\" text=\"\'quantity_of_trips\'\" check=vm.reverse>{{\'tripQuantity\' | translate}}</th><th style=\"width: 150px\" table-column-sorting current-text=vm.predicate title=\"{{\'totalAirport\' | translate}}\" text=\"\'total_trips_airport_service\'\" check=vm.reverse>$ {{\'totalAirport\' | translate}}</th><th style=width:150px table-column-sorting current-text=vm.predicate title=\"{{\'totalNonAirport\' | translate}}\" text=\"\'total_trips_non_airport_service\'\" check=vm.reverse>$ {{\'totalNonAirport\' | translate}}</th><th style=width:150px table-column-sorting current-text=vm.predicate title=\"{{\'totalTrips\' | translate}}\" text=\"\'total_trips\'\" check=vm.reverse>$ {{\'totalTrips\' | translate}}</th><th style=width:150px table-column-sorting current-text=vm.predicate title=\"{{\'avgTripPrice\' | translate}}\" text=\"\'average_trip_price\'\" check=vm.reverse>$ {{\'avgTripPrice\' | translate}}</th><th style=\"width: 100px\" table-column-sorting current-text=vm.predicate title=\"{{\'totalAirportEarning\' | translate}}\" text=\"\'total_earnings_airport_service\'\" check=vm.reverse>$ {{\'totalAirportEarning\' | translate}}</th><th style=width:150px table-column-sorting current-text=vm.predicate title=\"{{\'totalNonAirportEarning\' | translate}}\" text=\"\'total_earnings_non_airport_service\'\" check=vm.reverse>$ {{\'totalNonAirportEarning\' | translate}}</th><th style=width:150px table-column-sorting current-text=vm.predicate title=\"{{\'totalEarning\' | translate}}\" text=\"\'total_earnings\'\" check=vm.reverse>$ {{\'totalEarning\' | translate}}</th><th style=width:150px table-column-sorting current-text=vm.predicate title=\"{{\'working24\' | translate}}\" text=\"\'working_hours\'\" check=vm.reverse>{{\'working24\' | translate}}</th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.summarProList | orderBy:vm.predicate:vm.reverse\"><!---| filter:vm.search--><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:70px>{{data.region_name || \'--\'}}</td><td style=width:125px>{{data.unique_car_id || \'--\'}}</td><td style=width:125px>{{data.type_of_service || \'--\'}}</td><td style=width:150px>{{data.type_of_vehicle || \'--\'}}</td><td style=width:150px>{{data.hours_worked}}</td><td style=width:150px>{{data.quantity_of_trips || \'0\'}}</td><td style=width:150px>{{data.total_trips_airport_service || \'0\'}}</td><td style=width:150px>{{data.total_trips_non_airport_service || \'0\'}}</td><td style=width:150px>{{data.total_trips || \'0\'}}</td><td style=width:150px>{{data.average_trip_price || \'0\'}}</td><td style=width:150px>{{data.total_earnings_airport_service || \'0\'}}</td><td style=width:150px>{{data.total_earnings_non_airport_service || \'0\'}}</td><td style=width:150px>{{data.total_earnings || \'0\'}}</td><td style=width:150px><span ng-if=!data.working_hours>Not 24 Hrs </span><span ng-if=data.working_hours>24 Hrs</span></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th class=noDataClass colspan=15>{{\'noSummary\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\" ng-show=\"vm.watchPagination\"&ndash;&gt;--><!--<nav>--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\" ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/production-list/summaryProductionVehicleMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/production-list/vehicleBalanceReport.html","<h2 class=ng-cloak><span>Balance de vehículos</span> <span class=pull-right><button class=\"btn btn-primary tableButton\" ng-click=vm.refreshData()>Volver a cargar</button></span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=displayFlex><div class=filterAlign style=width:230px><label>Semana Desde <span style=color:red>*</span>:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} ng-model=vm.dt id=initialInput is-open=vm.popup1.opened datepicker-options=vm.dateOptions ng-required=true close-text=Close alt-input-formats=altInputFormats show-button-bar=false jm-dp-refresh-view=changePromise> <input readonly class=form-control id=finalInput ng-model=vm.dt2> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.open1()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=filterAlign style=width:230px><label>{{\'branchLabel\' | translate}}:</label><div><ui-select ng-model=vm.filterData.branch name=branch ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select></div></div><div class=filterAlign style=width:230px><label>Tipo de Contrato:</label><div><select class=form-control ng-model=vm.filterData.contrato_name name=contrato required ng-class=\"{ \'has-error\': carEditForm.contrato.$touched && carEditForm.contrato.$invalid }\"><option value=\"\" disabled selected>Select Tipo Contrato</option><option value=Freelance>Freelance</option><option value=Leasing>Leasing</option><option value=all>Todos</option></select></div></div><div class=filterAlign style=width:230px><label>{{\'serviceLabel\' | translate}}:</label><div><!-- <ui-select ng-model=\"vm.filterData.type_of_service\" name=\"service\" ng-keyup=\"vm.serviceSearch($select.search,$event)\" required\n                                    close-on-select=\"true\">\n                                    <ui-select-match placeholder=\"{{\'selectTService\' | translate}}\">\n                                        {{$select.selected.name}}\n                                    </ui-select-match>\n                                    <ui-select-choices repeat=\"services.id as services in vm.service | filter: $select.search | orderBy:\'name\' \" when-scrolled=\"vm.paginationChangedForService()\"\n                                        ng-click=\"vm.serviceChanged()\">\n                                        <div ng-bind-html=\"services.name\"></div>\n                                    </ui-select-choices>\n                                </ui-select> --><ui-select class=form-control multiple ng-model=vm.filterData.type_of_service theme=bootstrap close-on-select=false title=\"Select Vehicle type\" required name=vehicleType ng-class=\"{ \'has-error\': addServiceForm.vehicleType.$touched && addServiceForm.vehicleType.$invalid }\"><ui-select-match placeholder=\"{{\'vehicleSelect\' | translate}}\">{{$item.name}}</ui-select-match><ui-select-choices style=\"max-height: 150px;top: 0px\" repeat=\"data.id as data in vm.service| filter:$select.search\">{{data.name}}</ui-select-choices></ui-select></div></div></div></div></div><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=displayFlex><div class=filterAlign style=width:230px><label>Semana Hasta <span style=color:red>*</span>:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.Format}} ng-model=vm.Dt1 id=mainId is-open=vm.popup2.opened datepicker-options=vm.DateOptions ng-required=true close-text=Close alt-input-formats=altInputFormats show-button-bar=false jm-dp-refresh-view=ChangePromise> <input readonly class=form-control id=mainText ng-model=vm.Dt3> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.open2()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=filterAlign style=width:230px><label>Patente:</label><div><input placeholder=Patente type=text class=form-control ng-model=vm.filterData.UniqueCarId></div></div><div class=filterAlign><label style=\"visibility: hidden\">{{\'pickUpTimeLabel\' | translate}}:</label><br><button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px\" ng-click=vm.applyFilter()>Aplicar Filtros</button></div><div class=filterAlign><label style=\"visibility: hidden\">{{\'pickUpTimeLabel\' | translate}}:</label><br><button class=\"btn btn-danger\" style=\"height: 35px;line-height: 20px\" ng-click=vm.resetFilter()>{{\'resetFilterButton\' | translate}}</button></div><div class=filterAlign><label style=\"visibility: hidden\">{{\'pickUpTimeLabel\' | translate}}:</label><br><a class=\"btn btn-primary\" ng-click=vm.exportToCSV()>CSV</a></div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><p class=totalSize></p></div><br><br><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><div class=\"panel panel-default\"><div class=panel-body><div class=\"table-responsive tableWithMasterDataParentDive\"><table class=\"table table-hover tableWithMasterData\"><thead><tr><th style=width:125px current-text=vm.predicate title=\"{{\'branchLabel\' | translate}}\" text=\"\'region_name\'\" check=vm.reverse>{{\'branchLabel\' | translate}}</th><th style=width:100px current-text=vm.predicate title=\"{{\'vehicleUnique\' | translate}}\" text=\"\'unique_car_id\'\" check=vm.reverse>Tipo de Contrato</th><th style=width:100px current-text=vm.predicate title=\"{{\'serviceLabel\' | translate}}\" text=\"\'type_of_service\'\" check=vm.reverse>{{\'businessName\' | translate}}</th><th style=width:100px current-text=vm.predicate title=\"{{\'vehicleLabel\' | translate}}\" text=\"\'type_of_vehicle\'\" check=vm.reverse>Patente</th><th style=\"width: 140px\" current-text=vm.predicate title=\"{{\'applicantType\' | translate}}\" text=\"\'fleet_type\'\" check=vm.reverse>Periodo</th><th style=\"width: 100px\" current-text=vm.predicate title=\"{{\'tripQuantity\' | translate}}\" text=\"\'quantity_of_trips\'\" check=vm.reverse>Producción</th><th style=width:100px current-text=vm.predicate title=\"{{\'totalNonAirport\' | translate}}\" text=\"\'total_trips_non_airport_service\'\" check=vm.reverse>Balance</th></tr></thead><tbody when-scrolled=vm.paginationForVechicleReport()><tr ng-repeat=\"data in filtered = vm.summarProList | orderBy:vm.predicate:vm.reverse\"><td style=width:125px>{{data.region_name || \'--\'}}</td><td style=width:100px>{{data.type_of_contract || \'--\'}}</td><td style=width:100px>{{data.business_name || \'--\'}}</td><td style=width:100px>{{data.registration_number || \'--\'}}</td><td style=width:140px>{{vm.changeDateIntoSpanish(data.start_date)}} -{{vm.changeDateIntoSpanish(data.end_date)}}</td><!-- <td style=\"width:140px;\" ng-if=\"vm.summarProList[0].date != undefined\">{{vm.changeDateIntoSpanish(vm.summarProList[0].date)}} -{{vm.changeDateIntoSpanish(vm.summarProList[0].date)}} </td> --><td style=width:100px>{{data.total_production || \'0\'}}</td><td style=width:100px>{{data.balance || \'0\'}}</td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th class=noDataClass colspan=15>{{\'noSummary\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div><style>.full button span {\n        background-color: #ff6900;\n        font-weight: bold;\n        color: white;\n    }\n\n    .partially button span {\n        background-color: orange;\n        border-radius: 32px;\n        color: white;\n    }\n\n    .Full button span {\n        background-color: #ff6900;\n        font-weight: bold;\n        color: white;\n    }\n\n    .Partially button span {\n        background-color: orange;\n        border-radius: 32px;\n        color: white;\n    }\n\n\n    tr.uib-weeks:hover .btn-default {\n        background-color: #ff6900;\n        color: white;\n    }\n\n    .btn-info.active {\n        background-color: white;\n        border: none;\n    }\n\n    .btn-info {\n        color: #fff;\n        background-color: white;\n        border-color: white;\n    }</style>");
$templateCache.put("app/components/views/production-list/vehicleBalanceReportMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/promo-code/addBin.html","<h2 class=ng-cloak>Bin / Agregar Bin</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=corporate><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">Detalles Bin</p><div class=basicDetailsDiv><form name=addBinForm ng-submit=\"submit=true;addBinForm.$valid&&vm.addNewBin()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Promoción <span style=color:red>*</span></label><ui-select ng-model=vm.dataToFill.promotion name=promotion required close-on-select=true><ui-select-match placeholder=Promoción>{{$select.selected.promo_name}}</ui-select-match><ui-select-choices repeat=\"promo.promo_id as promo in vm.promoForBin | filter: $select.search | orderBy:\'promo_name\' \"><div ng-bind-html=promo.promo_name></div></ui-select-choices></ui-select><div ng-if=\"addBinForm.promotion.$touched|| submit\" ng-messages=addBinForm.promotion.$error><div class=\"errormessage text-danger\" ng-message=required>Promoción requerida</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid company name.</div>--></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Número de BIN <span style=color:red>*</span></label><input type=text class=form-control is-number=\"\" ng-model=vm.dataToFill.binNumber name=binNumber maxlength=6 placeholder=\"Número de BIN\" required ng-class=\"{ \'has-error\': addBinForm.binNumber.$touched && addBinForm.binNumber.$invalid }\" ng-minlength=6 ng-maxlength=6><div ng-if=\"addBinForm.binNumber.$touched|| submit\" ng-messages=addBinForm.binNumber.$error><div class=\"errormessage text-danger\" ng-message=required>Se requiere número de contenedor</div><div class=\"errormessage text-danger\" ng-message=minlength>Se permiten un mínimo de 6 dígitos</div><div class=\"errormessage text-danger\" ng-message=maxlength>Se permiten un máximo de 6 dígitos</div></div></div></div><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Tipo <span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.binType name=binType ng-class=\"{ \'has-error\': addBinForm.binType.$touched && addBinForm.binType.$invalid }\"><option value=\"\" disabled selected>Seleccionar tipo</option><option value=V>Visa</option><option value=M>MasterCard</option><option value=N>Not Defined</option></select><div ng-if=\"addBinForm.binType.$touched|| submit\" ng-messages=addBinForm.binType.$error><div class=\"errormessage text-danger\" ng-message=required>El tipo de contenedor es obligatorio</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid company name.</div>--></div></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" style=margin-top:10px><button type=submit class=\"btn btn-primary\">GRABAR</button></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/promo-code/addCoupon.html","<h2 class=ng-cloak>Promociones de Cupones de Descuento / Generación de nuevo cupones de descuento</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=corporate><div class=\"row loaderHeadingDiv\" ng-if=vm.dataToFill.genrateCouponProcess><h3>Los cupones de descuento están siendo generados...</h3></div><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">Generación de Cupones de Descuento</p><div class=basicDetailsDiv><form name=addCouponForm ng-submit=\"submit=true;addCouponForm.$valid&&vm.addNewCoupon()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Promoción <span style=color:red>*</span></label><ui-select ng-model=vm.dataToFill.promotion ng-disabled=vm.dataToFill.disablePromotion name=promotion required close-on-select=true on-select=vm.onSelected($item)><ui-select-match placeholder=Promoción>{{$select.selected.promo_name}}</ui-select-match><ui-select-choices repeat=\"promo.promo_id as promo in vm.promoForCoupon | filter: $select.search | orderBy:\'promo_name\' \"><div ng-bind-html=promo.promo_name></div></ui-select-choices></ui-select><div ng-if=\"addCouponForm.promotion.$touched|| submit\" ng-messages=addCouponForm.promotion.$error><div class=\"errormessage text-danger\" ng-message=required>Promoción requerida</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid company name.</div>--></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Cantidad de Cupones a Generar <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.noOfCouponToGenerate name=couponToGenerate placeholder=\"Cantidad de Cupones a Generar\" required ng-class=\"{ \'has-error\': addCouponForm.couponToGenerate.$touched && addCouponForm.couponToGenerate.$invalid }\" maxlength=4><div ng-if=\"addCouponForm.couponToGenerate.$touched|| submit\" ng-messages=addCouponForm.couponToGenerate.$error><div class=\"errormessage text-danger\" ng-message=required>La cantidad es requerida</div></div></div></div><div class=row style=\"margin-top: 10px\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'newPromoRadioButtonLabel\' | translate}}</label><div class=_radio_button_new_promo><p class=d-flex><span>{{\'yes\' | translate}}</span><input type=radio value=1 ng-model=vm.dataToFill.isNameOfCoupon name=isNameOfCoupon ng-disabled=\"vm.dataToFill.isEdit == 1 || vm.is_edited\"></p><p class=d-flex><span>{{\'no\' | translate}}</span><input type=radio value=0 ng-model=vm.dataToFill.isNameOfCoupon name=isNameOfCoupon ng-disabled=\"vm.dataToFill.isEdit == 1 || vm.is_edited\"></p></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><div ng-if=\"vm.dataToFill.isNameOfCoupon == 1\"><label class=control-label>Nombre del codigo de Promoción <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.nameOfCoupon name=nameOfCoupon placeholder=\"Nombre del codigo de Promoción\" required ng-class=\"{ \'has-error\': addCouponForm.couponToGenerate.$touched && addCouponForm.couponToGenerate.$invalid }\" style=\"text-transform: uppercase\" ng-disabled=\"vm.dataToFill.isEdit == 1\"><div ng-if=\"addCouponForm.nameOfCoupon.$touched || submit\" ng-messages=addCouponForm.nameOfCoupon.$error><div class=\"errormessage text-danger\" ng-message=required>La cantidad es requerida</div></div></div></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" style=margin-top:10px><button type=submit class=\"btn btn-primary\">GENERAR</button></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/promo-code/addPromoCode.html","<h2 class=ng-cloak>Promoción / Nueva Promoción Detalles</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=corporate><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">Detalles Promoción</p><div class=basicDetailsDiv><form name=addPromoCodeForm ng-submit=\"submit=true;addPromoCodeForm.$valid&&vm.registerApi()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Nombre <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.promo_name name=promoName placeholder=Nombre required ng-class=\"{ \'has-error\': addPromoCodeForm.promoName.$touched && addPromoCodeForm.promoName.$invalid }\"><div ng-if=\"addPromoCodeForm.promoName.$touched|| submit\" ng-messages=addPromoCodeForm.promoName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'promoNameReq\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid company name.</div>--></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Tipo de Valor <span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.promo_type name=promoType ng-class=\"{ \'has-error\': addPromoCodeForm.promoType.$touched && addPromoCodeForm.promoType.$invalid }\" ng-change=\"vm.dataToFill.tope = vm.dataToFill.flagNoTope ? \'\' : vm.dataToFill.tope\"><option value=\"\" disabled selected>Tipo de Valor</option><option value=0>Flat</option><option value=1>Percentage</option></select><div ng-if=\"addPromoCodeForm.promoType.$touched|| submit\" ng-messages=addPromoCodeForm.promoType.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'promoTypeReq\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Valor Descuento <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.value name=value placeholder=\"Valor Descuento\" required ng-class=\"{ \'has-error\': addPromoCodeForm.value.$touched && addPromoCodeForm.value.$invalid }\" pattern=\"^[0-9][0-9 .]*$\"><div ng-if=\"addPromoCodeForm.value.$touched|| submit\" ng-messages=addPromoCodeForm.value.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'promoValueReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'promoValueValid\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Tipo <span style=color:red>*</span></label><div style=\"margin-top: 5px\"><input type=radio ng-model=vm.dataToFill.type name=type value=1> Codigo Descuento <input style=margin-left:5% type=radio ng-model=vm.dataToFill.type name=type value=0> Bins Tarjeta Credito</div><div ng-if=\"addPromoCodeForm.type.$touched|| submit\" ng-messages=addPromoCodeForm.type.$error><div class=\"errormessage text-danger\" ng-message=required>Se requiere un tipo de promoción</div></div></div></div><div class=\"row mt5\" ng-show=\"vm.dataToFill.promo_type==\'1\'\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Tope de descuento <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.tope name=tope placeholder=\"Valor Tope\" pattern=\"^[0-9][0-9 .]*$\" ng-disabled=vm.dataToFill.flagNoTope ng-required=\"!vm.dataToFill.flagNoTope && vm.dataToFill.promo_type==\'1\'\"><div ng-if=\"addPromoCodeForm.tope.$touched|| submit\" ng-messages=addPromoCodeForm.tope.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'promoTopeReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'promoTopeValid\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Descuento sin tope <span style=color:red>*</span></label><div style=\"margin-top: 5px\"><input type=checkbox name=flagNoTope ng-model=vm.dataToFill.flagNoTope value=1 ng-change=\"vm.dataToFill.tope = vm.dataToFill.flagNoTope ? \'\' : vm.dataToFill.tope\"></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=\"control-label col-lg-12 col-sm-12 col-md-12 col-xs-12 padding0 top8\"><span class=\"align-left top12\">Descuento compartido con conductor </span><span class=\"boleeanTypeColor align-right\"><i ng-click=\"vm.dataToFill.discountToggle = !vm.dataToFill.discountToggle; vm.changeInputTextColor()\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.discountToggle , \'fa fa-toggle-off\': !vm.dataToFill.discountToggle}\" role=button tabindex=0 class=\"fa fa-toggle-off\"></i><!--,\'pointerEvent\': vm.dataToFill.bookingId && !vm.dataToFill.roundTrip--></span></label></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=\"control-label col-lg-12 col-sm-12 col-md-12 col-xs-12 padding0 top8\"><span class=\"align-left top12\">Porcentaje asumido por Transvip </span><span ng-if=vm.dataToFill.discountToggle style=\"color:red; position: absolute; left: 41%; top: 10px\">*</span> <span class=\"align-right top6 posAbs\"><input type=text class=\"form-control inputHeight28 inputWidth60 inputText\" name=discount ng-model=vm.dataToFill.discount is-number maxlength=3 placeholder=Discount pattern=^([0-9]|[1-9][0-9]|100)$ ng-disabled=!vm.dataToFill.discountToggle ng-required=vm.dataToFill.discountToggle ng-class=\"{ \'has-error\': addPromoCodeForm.discount.$touched && addPromoCodeForm.discount.$invalid }\"> <span class=percentage>%</span></span></label><!-- <div ng-if=\"addPromoCodeForm.discount.$touched|| submit\" ng-messages=\"addPromoCodeForm.discount.$error\">\n                                            <div class=\"errormessage text-danger\" ng-message=\"required\">Porcentaje asumido por Transvip</div>\n                                        </div> --></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Canal <span style=color:red>*</span></label><ui-select ng-model=vm.dataToFill.channel multiple name=channel required close-on-select=false ng-change=vm.channelChanged(vm.dataToFill.channel)><ui-select-match placeholder=\"Seleccionar Canal\">{{$item.channel_name}}</ui-select-match><ui-select-choices repeat=\"channels in vm.channelsList\">{{channels.channel_name}}</ui-select-choices></ui-select><div ng-if=\"addPromoCodeForm.channel.$touched|| submit\" ng-messages=addPromoCodeForm.channel.$error><div class=\"errormessage text-danger\" ng-message=required>Por favor agregue un canal promocional</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Convenio <span style=color:red>*</span></label><ui-select ng-model=vm.dataToFill.agreement name=agreement required close-on-select=true><ui-select-match placeholder=Convenio>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"agreement.id as agreement in vm.agreement | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=agreement.name></div></ui-select-choices></ui-select><div ng-if=\"addPromoCodeForm.agreement.$touched|| submit\" ng-messages=addPromoCodeForm.agreement.$error><div class=\"errormessage text-danger\" ng-message=required>Por favor agregue acuerdo</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Fecha Inicio <span style=color:red>*</span></label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=startValidity ng-model=vm.dataToFill.valid_from placeholder=\"Fecha Inicio\" is-open=vm.datePicker_1.start datepicker-options=vm.dateOptions required ng-class=\"{ \'has-error\': addPromoCodeForm.startValidity.$touched && addPromoCodeForm.startValidity.$invalid }\" close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'1\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"addPromoCodeForm.startValidity.$touched|| submit\" ng-messages=addPromoCodeForm.startValidity.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'validSdateReq\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Fecha Fin <span style=color:red>*</span></label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=endValidity ng-model=vm.dataToFill.valid_to placeholder=\"Fecha Fin\" is-open=vm.datePicker_1.end datepicker-options=vm.dateOptions required ng-class=\"{ \'has-error\': addPromoCodeForm.endValidity.$touched && addPromoCodeForm.endValidity.$invalid }\" close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'2\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"addPromoCodeForm.endValidity.$touched|| submit\" ng-messages=addPromoCodeForm.endValidity.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'promoEndReq\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Descripción <span style=color:red>*</span></label><textarea type=text class=form-control ng-model=vm.dataToFill.description name=description placeholder=Descripción required ng-class=\"{ \'has-error\': addPromoCodeForm.description.$touched && addPromoCodeForm.description.$invalid }\"></textarea><div ng-if=\"addPromoCodeForm.description.$touched|| submit\" ng-messages=addPromoCodeForm.description.$error><div class=\"errormessage text-danger\" ng-message=required>Descripción requerida</div></div></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" style=margin-top:10px><button type=submit class=\"btn btn-primary\">GRABAR</button></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/promo-code/binList.html","<h2 class=ng-cloak>Bins</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><p class=totalSize><span class=pull-right><a class=\"btn btn-primary mb10\" ui-sref=layout.binMain.addBin>+ Nuevo Bin</a> </span>Total Bins: {{vm.totalBins}}</p></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\" ng-switch=\"(vm.allBinList | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=Campaña text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=Id text=\"\'bin_id\'\" check=vm.reverse>Id</th><th style=width:125px table-column-sorting current-text=vm.predicate title=Número text=\"\'bin_number\'\" check=vm.reverse>Número</th><th style=width:70px table-column-sorting current-text=vm.predicate title=Tipo text=\"\'bin_type\'\" check=vm.reverse>Tipo</th><th style=width:125px table-column-sorting current-text=vm.predicate title=Promoción text=\"\'promo_name\'\" check=vm.reverse>Promoción</th><!-- <th>\n                                                <div>\n                                                    Estado\n                                                </div>\n                                            </th> --><th style=width:100px><div>Acciones</div></th><th style=width:150px><div>{{\'adminLogs\' | translate}}</div></th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered =  vm.allBinList| filter:vm.search | orderBy:vm.predicate:vm.reverse\"><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:70px>{{::data.bin_id}}</td><td style=width:125px>{{::data.bin_number}}</td><td style=width:70px>{{::data.bin_type}}</td><td style=width:125px>{{::data.promo_name}}</td><!-- <td>\n                                                <a class=\"cursor btn btn-sm\" ng-class=\"{\'blockIconColor\': data.status == 0, \'unblockIconColor\': data.status == 1}\" ng-click=\"vm.block_unblock($event,data.bin_id,data.status,data.bin_number)\">\n                                                    <i ng-class=\"{\'fa fa-unlock\': data.status == 1,\'fa fa-lock\': data.status == 0}\"></i>\n                                                </a>\n                                            </td> --><td style=width:100px><!-- <a title=\"Edit Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.binMain.editBin({id:\'{{data.bin_id}}\'})\">\n                                                    <i class=\"fa fa-edit\"></i>\n                                                </a>\n                                                <a title=\"View Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.binMain.viewBin({id:\'{{data.bin_id}}\'})\">\n                                                    <i class=\"fa fa-eye\"></i>\n                                                </a> --> <a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteBin(data,$event)><i class=\"fa fa-trash\"></i></a></td><td style=width:150px><a class=\"btn btn-primary tableButton\" title=\"{{\'adminLogs\' | translate}}\" ui-sref=\"layout.binMain.adminLogs({userId:\'{{data.bin_id}}\',type:\'25\',fakeType: \'27\'})\">{{\'adminLogs\' | translate}}</a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noPromoFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/promo-code/binMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/promo-code/couponList.html","<h2 class=ng-cloak>Promociones con Cupones de Descuento</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><p class=totalSize><span class=pull-right><a class=\"btn btn-primary mb10\" ui-sref=layout.couponMain.addCoupon>+ Agregar cupón</a> </span>Total Cupones de Descuento: {{vm.totalCoupons}}</p></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\" ng-switch=\"(vm.promoLIst | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=Campaña text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=Id text=\"\'promo_id\'\" check=vm.reverse>Id</th><th style=width:125px table-column-sorting current-text=vm.predicate title=Promoción text=\"\'promo_name\'\" check=vm.reverse>Promoción</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"Cantidad de Cupones\" text=\"\'coupon_count\'\" check=vm.reverse>Cantidad de Cupones</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"Cantidad de Cupones\" text=\"\'is_custom_name\'\" check=vm.reverse>tipo</th><th style=width:150px><div>Acciones</div></th><th style=width:150px><div>{{\'adminLogs\' | translate}}</div></th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.allCouponsList| filter:vm.search | orderBy:vm.predicate:vm.reverse\"><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:70px>{{::data.promo_id}}</td><td style=width:125px>{{::data.promo_name}}</td><td style=width:125px>{{::data.coupon_count}}</td><td style=width:125px>{{::(data.is_custom_name == 1 ? \'Unique\' : \'Multiple\')}}</td><td style=width:150px><a class=\"btn btn-primary tableButton\" title=Agregar ui-sref=\"layout.couponMain.addCoupon({id:\'{{data.promo_id}}\', isUnique:\'{{data.is_custom_name}}\', uniqueName: \'{{data.uniqueID}}\', isEdit: \'1\'})\">Agregar</a> <a class=\"btn btn-primary tableButton\" title=Export ng-click=vm.exportCSV(data)>Export</a></td><td style=width:150px><a class=\"btn btn-primary tableButton\" title=\"{{\'adminLogs\' | translate}}\" ui-sref=\"layout.couponMain.adminLogs({userId:\'{{data.promo_id}}\',type:\'26\',fakeType: \'28\'})\">{{\'adminLogs\' | translate}}</a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noPromoFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav ng-show=\"vm.watchPagination\">--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\"--><!--ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/promo-code/couponMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/promo-code/editBin.html","<h2 class=ng-cloak>Bins / Editar contenedor</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=corporate><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'editDetailsButton\' | translate}}</p><div class=basicDetailsDiv><form name=editBinForm ng-submit=\"submit=true;editBinForm.$valid&&vm.binEditApi()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Promoción <span style=color:red>*</span></label><ui-select ng-model=vm.dataToFill.promotion name=promotion required close-on-select=true><ui-select-match placeholder=Promoción>{{$select.selected.promo_name}}</ui-select-match><ui-select-choices repeat=\"promo.promo_id as promo in vm.promoForBin | filter: $select.search | orderBy:\'promo_name\' \"><div ng-bind-html=promo.promo_name></div></ui-select-choices></ui-select><div ng-if=\"editBinForm.promotion.$touched|| submit\" ng-messages=editBinForm.promotion.$error><div class=\"errormessage text-danger\" ng-message=required>Promoción requerida</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid company name.</div>--></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Número de BIN <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.binNumber name=binNumber placeholder=\"Número de BIN\" required ng-class=\"{ \'has-error\': editBinForm.binNumber.$touched && editBinForm.binNumber.$invalid }\"><div ng-if=\"editBinForm.binNumber.$touched|| submit\" ng-messages=editBinForm.binNumber.$error><div class=\"errormessage text-danger\" ng-message=required>Se requiere número de contenedor</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Tipo <span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.binType name=binType ng-class=\"{ \'has-error\': editBinForm.binType.$touched && editBinForm.binType.$invalid }\"><option value=\"\" disabled selected>Seleccionar tipo de contenedor</option><option value=V>Visa</option><option value=M>MasterCard</option><option value=N>Not Defined</option></select><div ng-if=\"editBinForm.binType.$touched|| submit\" ng-messages=editBinForm.binType.$error><div class=\"errormessage text-danger\" ng-message=required>El tipo de contenedor es obligatorio</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid company name.</div>--></div></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" style=margin-top:10px><button type=submit class=\"btn btn-primary\">{{\'submit\' | translate}}</button></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/promo-code/editCoupon.html","<h2 class=ng-cloak>Cupones de Descuento / Editar cupones</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=corporate><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'editDetailsButton\' | translate}}</p><div class=basicDetailsDiv><form name=editCouponForm ng-submit=\"submit=true;addPromoCodeForm.$valid&&vm.registerApi()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Promoción <span style=color:red>*</span></label><ui-select ng-model=vm.dataToFill.promotion name=promotion required close-on-select=true ng-change=vm.branchChanged()><ui-select-match placeholder=promotion>{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \"><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select><div ng-if=\"editCouponForm.promotion.$touched|| submit\" ng-messages=editCouponForm.promotion.$error><div class=\"errormessage text-danger\" ng-message=required>Promoción requerida</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid company name.</div>--></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Cantidad a Cupones a Generar <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.noOfCouponToGenerate name=couponToGenerate placeholder=\"Cantidad a Cupones a Generar\" required ng-class=\"{ \'has-error\': editCouponForm.couponToGenerate.$touched && editCouponForm.couponToGenerate.$invalid }\"><div ng-if=\"editCouponForm.couponToGenerate.$touched|| submit\" ng-messages=editCouponForm.couponToGenerate.$error><div class=\"errormessage text-danger\" ng-message=required>La cantidad es requerida</div></div></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" style=margin-top:10px><button type=submit class=\"btn btn-primary\">GENERAR</button></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/promo-code/editPromoCode.html","<h2 class=ng-cloak>Promoción / Editar Promoción Detalles</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=corporate><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">Detalles Promoción</p><div class=basicDetailsDiv><form name=editPromoCodeForm ng-submit=\"submit=true;editPromoCodeForm.$valid&&vm.editApi()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Nombre <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.promo_name name=promoName readonly placeholder=Nombre required ng-class=\"{ \'has-error\': editPromoCodeForm.promoName.$touched && editPromoCodeForm.promoName.$invalid }\"><div ng-if=\"editPromoCodeForm.promoName.$touched|| submit\" ng-messages=editPromoCodeForm.promoName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'promoNameReq\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid company name.</div>--></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Tipo de Valor <span style=color:red>*</span></label><select class=form-control ng-disabled=true ng-model=vm.dataToFill.promo_type name=promoType ng-class=\"{ \'has-error\': editPromoCodeForm.promoType.$touched && editPromoCodeForm.promoType.$invalid }\"><option value=\"\" disabled selected>Tipo de Valor</option><option value=0>Flat</option><option value=1>Percentage</option></select><div ng-if=\"editPromoCodeForm.promoType.$touched|| submit\" ng-messages=editPromoCodeForm.promoType.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'promoTypeReq\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Valor Descuento <span style=color:red>*</span></label><input type=text class=form-control ng-disabled=true ng-model=vm.dataToFill.value name=value placeholder=\"Valor Descuento\" required ng-class=\"{ \'has-error\': editPromoCodeForm.value.$touched && editPromoCodeForm.value.$invalid }\" pattern=\"^[0-9][0-9 .]*$\"><div ng-if=\"editPromoCodeForm.value.$touched|| submit\" ng-messages=editPromoCodeForm.value.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'promoValueReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'promoValueValid\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Tipo <span style=color:red>*</span></label><div style=\"margin-top: 5px\"><input type=radio ng-model=vm.dataToFill.type ng-disabled=true name=type value=1> Codigo Descuento <input style=margin-left:5% type=radio ng-disabled=true ng-model=vm.dataToFill.type name=type value=0> Bins Tarjeta Credito</div><div ng-if=\"editPromoCodeForm.type.$touched|| submit\" ng-messages=editPromoCodeForm.type.$error><div class=\"errormessage text-danger\" ng-message=required>Se requiere un tipo de promoción</div></div></div></div><div class=\"row mt5\" ng-show=\"vm.dataToFill.promo_type==\'1\'\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Tope de descuento <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.tope name=tope placeholder=\"Valor Tope\" pattern=\"^[0-9][0-9 .]*$\" ng-disabled=vm.dataToFill.flagNoTope ng-required=\"!vm.dataToFill.flagNoTope && vm.dataToFill.promo_type==\'1\'\"><div ng-if=\"editPromoCodeForm.tope.$touched|| submit\" ng-messages=editPromoCodeForm.tope.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'promoTopeReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'promoTopeValid\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Descuento sin tope <span style=color:red>*</span></label><div style=\"margin-top: 5px\"><input type=checkbox name=flagNoTope ng-model=vm.dataToFill.flagNoTope value=1 ng-change=\"vm.dataToFill.tope = vm.dataToFill.flagNoTope ? \'\' : vm.dataToFill.tope\"></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=\"control-label col-lg-12 col-sm-12 col-md-12 col-xs-12 padding0 top8\"><span class=\"align-left top12\">Descuento compartido con conductor </span><span class=\"boleeanTypeColor align-right\"><i ng-click=\"vm.dataToFill.discountToggle = !vm.dataToFill.discountToggle; vm.changeInputTextColor()\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.discountToggle , \'fa fa-toggle-off\': !vm.dataToFill.discountToggle}\" role=button tabindex=0 class=\"fa fa-toggle-off\"></i><!--,\'pointerEvent\': vm.dataToFill.bookingId && !vm.dataToFill.roundTrip--></span></label></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=\"control-label col-lg-12 col-sm-12 col-md-12 col-xs-12 padding0 top8\"><span class=\"align-left top12\">Porcentaje asumido por Transvip </span><span ng-if=vm.dataToFill.discountToggle style=\"color:red; position: absolute; left: 41%; top: 10px\">*</span> <span class=\"align-right top6 posAbs\"><input type=text class=\"form-control inputHeight28 inputWidth60 inputText\" ng-model=vm.dataToFill.discount is-number maxlength=3 name=discount placeholder=Discount pattern=^([0-9]|[1-9][0-9]|100)$ ng-disabled=!vm.dataToFill.discountToggle ng-required=vm.dataToFill.discountToggle ng-class=\"{ \'has-error\': editPromoCodeForm.discount.$touched && editPromoCodeForm.discount.$invalid }\"> <span class=percentage>%</span></span></label><!-- <div ng-if=\"editPromoCodeForm.discount.$touched|| submit\" ng-messages=\"editPromoCodeForm.discount.$error\">\n                                            <div class=\"errormessage text-danger\" ng-message=\"required\">Porcentaje asumido por Transvip</div>\n                                        </div> --></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Canal <span style=color:red>*</span></label><ui-select ng-model=vm.dataToFill.channel_name ng-disabled=true multiple name=channel required close-on-select=false ng-change=vm.channelChanged(vm.dataToFill.channel)><ui-select-match placeholder=\"Seleccionar Canal\">{{$item}}</ui-select-match><ui-select-choices repeat=\"channels in vm.channel_name\">{{channels}}</ui-select-choices></ui-select><div ng-if=\"editPromoCodeForm.channel.$touched|| submit\" ng-messages=editPromoCodeForm.channel.$error><div class=\"errormessage text-danger\" ng-message=required>Por favor agregue un canal promocional</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Convenio <span style=color:red>*</span></label><ui-select ng-model=vm.dataToFill.contract_name ng-disabled=true name=agreement required close-on-select=true><ui-select-match placeholder=Convenio>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"agreement.id as agreement in vm.agreement | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=agreement.name></div></ui-select-choices></ui-select><div ng-if=\"editPromoCodeForm.agreement.$touched|| submit\" ng-messages=editPromoCodeForm.agreement.$error><div class=\"errormessage text-danger\" ng-message=required>Por favor agregue acuerdo</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Fecha Inicio <span style=color:red>*</span></label><p class=input-group><input type=text class=form-control ng-disabled=true uib-datepicker-popup={{vm.format}} name=startValidity ng-model=vm.dataToFill.valid_from placeholder=\"Fecha Inicio\" is-open=vm.datePicker_1.start datepicker-options=vm.dateOptions required ng-class=\"{ \'has-error\': editPromoCodeForm.startValidity.$touched && editPromoCodeForm.startValidity.$invalid }\" close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'1\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"editPromoCodeForm.startValidity.$touched|| submit\" ng-messages=editPromoCodeForm.startValidity.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'promoStartReq\' | translate}}</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Fecha Fin <span style=color:red>*</span></label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=endValidity ng-model=vm.dataToFill.valid_to placeholder=\"Fecha Fin\" is-open=vm.datePicker_1.end datepicker-options=vm.dateOptions ng-model-options=\"{timezone: \'utc\'}\" required ng-class=\"{ \'has-error\': editPromoCodeForm.endValidity.$touched && editPromoCodeForm.endValidity.$invalid }\" close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'2\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div ng-if=\"addAgreementForm.editPromoCodeForm.$touched|| submit\" ng-messages=editPromoCodeForm.endValidity.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'promoEndReq\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Descripción <span style=color:red>*</span></label><textarea type=text class=form-control readonly ng-model=vm.dataToFill.description name=description placeholder=Descripción required ng-class=\"{ \'has-error\': editPromoCodeForm.description.$touched && editPromoCodeForm.description.$invalid }\"></textarea><div ng-if=\"editPromoCodeForm.description$touched|| submit\" ng-messages=editPromoCodeForm.description.$error><div class=\"errormessage text-danger\" ng-message=required>Descripción requerida</div></div></div></div><div class=\"row mt25\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" style=margin-top:10px><button type=submit class=\"btn btn-primary\">GRABAR</button></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/promo-code/promoCodeList.html","<h2 class=ng-cloak>Promociones</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><p class=totalSize><span class=pull-right><a class=\"btn btn-primary mb10\" ui-sref=layout.promoCodeMain.addPromoCode>+ Nueva Promoción</a> </span>Total Promociones: {{vm.totalEarnings}}</p></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\" ng-switch=\"(vm.promoLIst | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=Id text=\"\'promo_id\'\" check=vm.reverse>Id</th><th style=width:100px table-column-sorting current-text=vm.predicate title=Nombre text=\"\'promo_name\'\" check=vm.reverse>Nombre</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"Fecha Inicio\" text=\"\'valid_from\'\" check=vm.reverse>Fecha Inicio</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"Fecha Fin\" text=\"\'valid_to\'\" check=vm.reverse>Fecha Fin</th><th style=width:100px table-column-sorting current-text=vm.predicate title=Tipo text=\"\'bin_or_coupon\'\" check=vm.reverse>Tipo</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"Aplicar por\" text=\"\'promo_type\'\" check=vm.reverse>Aplicar por</th><th style=width:100px table-column-sorting current-text=vm.predicate title=Valor text=\"\'value\'\" check=vm.reverse>Valor</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"Descuento asumido por Transvip\" text=\"\'value\'\" check=vm.reverse>Descuento asumido por Transvip</th><th style=width:125px><div>Canal</div></th><th style=width:125px><div>Convenio</div></th><!--<th>--><!--<div class=\"\" ng-click=\"vm.sort(\'status\')\">--><!--Status--><!--<span ng-hide=\"vm.predicate == \'status\' && vm.reverse || vm.predicate == \'status\' && !vm.reverse\"--><!--class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'status\' && !vm.reverse\"--><!--class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'status\' && vm.reverse\"--><!--class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><!-- <th>\n                                                <div>\n                                                    Estado\n                                                </div>\n                                            </th> --><th style=width:150px><div>Acciones</div></th><th style=width:150px><div>{{\'adminLogs\' | translate}}</div></th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.promoLIst| filter:vm.search | orderBy:vm.predicate:vm.reverse\"><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:70px>{{::data.promo_id}}</td><td style=width:100px>{{::data.promo_name}}</td><td style=width:125px>{{data.valid_from | date: \'MM/dd/yyyy\'}}</td><td style=width:125px>{{vm.changeDate(data.valid_to) | date: \'MM/dd/yyyy\'}}</td><td style=width:100px><span ng-if=\"data.bin_or_coupon == 1\">Discount Code</span> <span ng-if=\"data.bin_or_coupon == 0\">Bins</span></td><td style=width:125px><span ng-if=\"data.promo_type == 0\">$</span> <span ng-if=\"data.promo_type == 1\">%</span></td><td style=width:100px>{{::data.value}}</td><td style=width:100px>{{::data.transvip_assumeddiscountpercentage}}%</td><td style=width:125px><!-- {{data.channel_name}} --> <span ng-repeat=\"d in data.channels track by $index\">{{d}}{{$last ? \'\' : \', \'}}</span></td><td style=width:125px>{{data.contract_name}}</td><!--<td>--><!--<span ng-if=\"data.status == 0\">Inactive</span>--><!--<span ng-if=\"data.status == 1\">Active</span>--><!--</td>--><!-- <td>\n                                                <a class=\"cursor btn btn-sm\" ng-class=\"{\'blockIconColor\': data.status == 0, \'unblockIconColor\': data.status == 1}\" ng-click=\"vm.block_unblock($event,data.promo_id,data.status,data.promo_name)\">\n                                                    <i ng-class=\"{\'fa fa-unlock\': data.status == 1,\'fa fa-lock\': data.status == 0}\"></i>\n                                                </a>\n                                            </td> --><td style=width:150px><a title=\"Edit Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.promoCodeMain.editPromoCode({id:\'{{data.promo_id}}\'})\"><i class=\"fa fa-edit\"></i> </a><a title=\"View Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.promoCodeMain.viewPromoCode({id:\'{{data.promo_id}}\'})\"><i class=\"fa fa-eye\"></i> </a><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deletePromoCode(data,$event)><i class=\"fa fa-trash\"></i></a></td><td style=width:150px><a class=\"btn btn-primary tableButton\" title=\"{{\'adminLogs\' | translate}}\" ui-sref=\"layout.promoCodeMain.adminLogs({userId:\'{{data.promo_id}}\',type:\'5\',fakeType: \'12\'})\">{{\'adminLogs\' | translate}}</a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noPromoFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav ng-show=\"vm.watchPagination\">--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\"--><!--ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/promo-code/promoCodeMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/promo-code/viewBin.html","<h2 class=ng-cloak>Bins / Detalles del contenedor</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=corporate><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'allDetails\' | translate}}</p><div class=basicDetailsDiv><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>Promoción:</label><div class=\"form-control text-capitalize\">{{::vm.binDetails[0].promo_name}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Número de BIN:</label><div class=\"form-control text-capitalize\">{{::vm.binDetails[0].bin_number}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Tipo:</label><div class=\"form-control text-capitalize\">{{vm.binDetails[0].bin_type == \'V\' ? \'Visa\':vm.binDetails[0].bin_type == \'M\' ? \'MasterCard\':vm.binDetails[0].bin_type == \'N\' ? \'Not Defined\':NA}}</div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/promo-code/viewPromoCode.html","<h2 class=ng-cloak>Promoción / Ver Promoción Detalles</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=corporate><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">Detalles Promoción</p><div class=basicDetailsDiv><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-6\"><label class=control-label>Nombre:</label><div class=\"form-control text-capitalize\">{{::vm.promoCodeDetails[0].promo_name}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Tipo:</label><div class=\"form-control text-capitalize\"><span ng-if=\"vm.promoCodeDetails[0].bin_or_coupon == 1\">Codigo Descuento</span> <span ng-if=\"vm.promoCodeDetails[0].bin_or_coupon == 0\">Bins Tarjeta Credito</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Tipo de Valor:</label><div class=\"form-control text-capitalize\">{{vm.promoCodeDetails[0].promo_type == 0 ? \'Flat\':vm.promoCodeDetails[0].promo_type == 1 ? \'Percentage\': \'NA\' }}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Valor Descuento:</label><div class=\"form-control text-capitalize\">{{::vm.promoCodeDetails[0].value}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-show=\"vm.promoCodeDetails[0].promo_type==\'1\'\"><label class=control-label>Tope de descuento:</label><div class=\"form-control text-capitalize\"><span>{{ vm.promoCodeDetails[0].tope }}</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-show=\"vm.promoCodeDetails[0].promo_type==\'1\'\"><label class=control-label>Descuento sin tope:</label><div class=\"form-control text-capitalize\"><span ng-if=\"vm.promoCodeDetails[0].flag_tope == 1\">Sin Tope</span> <span ng-if=\"vm.promoCodeDetails[0].flag_tope == 0\">Tiene Tope</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Canal:</label><div class=\"form-control text-capitalize\"><span ng-repeat=\"d in vm.channelArray track by $index\">{{d}}{{$last ? \'\' : \', \'}}</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Convenio:</label><div class=\"form-control text-capitalize\">{{::vm.promoCodeDetails[0].contract_name}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Fecha Inicio:</label><div class=\"form-control text-capitalize\">{{::vm.promoCodeDetails[0].valid_from | date:\'MMM d, yyyy\'}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Fecha Fin:</label><div class=\"form-control text-capitalize\">{{::vm.promoCodeDetails[0].valid_to | date:\'MMM d, yyyy\'}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Descripción:</label><div class=\"form-control text-capitalize\">{{::vm.promoCodeDetails[0].description}}</div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/quickSale/quickSale.html","<h2 class=ng-cloak>Punto de Venta Rápido <span class=pull-right style=\"font-size: 16px\" ng-if=\"vm.dataToFill.shiftOpenClose == true\" data-testid=caja_apertura>Caja: {{vm.dataToFill.operationData.time.unique_code}}<br>Fecha y hora de apertura: {{vm.dataToFill.operationData.time.login_time | date:\'medium\'}}</span></h2><div class=\"ng-cloak container-fluid\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-6 col-sm-12 col-md-6 col-xs-12\"><div class=pull-left ng-if=\"vm.agreementArray.length>0\"><button class=\"newButton notActive1\" ng-class=\"{\'activeButton\':  vm.classFLag == $index}\" ng-click=vm.spotCorporateShow($index,data) ng-repeat=\"data in filtered = vm.agreementArray\" data-testid=btn_convenio>{{data.contract_name}}</button><!-- <button class=\"newButton\" ng-click=\"vm.salesReport()\">Reporte de Venta</button> --><!-- <button ng-class=\"{\'activeButton\': vm.classFLag[7] == true}\" ng-click=\"vm.spotCorporateShow(\'2\',null)\" class=\"newButton notActive1\">OTROS CONVENIOS</button> --><!-- <button class=\"btn btn-primary\" ng-click=\"vm.salesReport()\">Reporte de Venta</button> --></div><div class=clearFix></div></div><div class=\"col-lg-6 col-sm-12 col-xs-12 col-md-6 mt5\" style=\"margin-top: 5px\"><div class=\"pointName text-center\" style=\"font-size: 22px\"><!-- Punto: {{vm.dataToFill.operationData.operation.point_name}} --> <span class=pull-right ng-if=vm.dataToFill.operationData.operation.point_name><button class=\"btn btn-primary\" ng-click=vm.closeShift(1) ng-disabled=vm.dataToFill.shiftOpenClose data-testid=abrir_turno>Abrir turno</button> <button class=\"btn btn-primary\" ng-click=vm.closeShift(2) ng-disabled=!vm.dataToFill.shiftOpenClose data-testid=cierre_caja>Cierre de Caja</button> <button class=\"btn btn-primary\" ng-click=vm.salesReport() data-testid=reporte_venta>Reporte de Venta</button></span></div><div ng-if=\"vm.dataToFill.shiftOpenClose == false\" class=noShift data-testid=message_turno><p><label class=control-label>Advice:</label><span>Debe abrir el turno para comenzar a trabajar en este punto de Operación</span></p></div></div></div><div class=\"row mt10\" ng-if=vm.dataToFill.shiftOpenClose><form name=spotBookingForm ng-submit=\"vm.submit=true;spotBookingForm.$valid&&vm.createBookingByPass($event)\" novalidate autocomplete=off><div class=\"col-lg-6 col-sm-6 col-sx-12 col-md-6 saleBorder\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" ng-if=\"vm.dataToFill.authRequired == \'1\'\" style=color:red;font-size:14px>Este pasajero requiere autorización. La reserva se creará pero permanecerá en estado pendiente hasta que lo autorice su Autorizador.</div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><h2 ng-if=vm.flagAgreement class=m0 style=\"float: left\">VENTA SPOT</h2><h2 ng-if=!vm.flagAgreement class=m0 style=\"float: left\">VENTA CORPORATE</h2><h2 style=\"display: inline\">Punto: {{vm.dataToFill.operationData.operation.point_name}}</h2></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><span ng-if=vm.dataToFill.customer.profile_pic_thumb><img ng-src={{vm.dataToFill.customer.profile_pic_thumb}} style=height:75px> </span><span class=pull-right ng-if=\"vm.dataToFill.is_vip && vm.dataToFill.is_vip == 1\"><p class=vipCustomer>VIP</p></span></div></div><div class=\"row mt5\" ng-hide=vm.dataToFill.newCustomerFlag><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>Busqueda de Cliente <span style=color:red>*</span></label><input type=text maxlength=80 ng-model=vm.dataToFill.customer placeholder=\"Buscar Cliente\" uib-typeahead=\"customers as customers.name for customers in vm.searchCustomer($viewValue)\" typeahead-loading=loadingCustomers typeahead-no-results=noResults class=\"form-control createBookingSelect\" data-testid=buscar_cliente name=searchCustomer typeahead-on-select=vm.onSelectingCustomer() typeahead-wait-ms=600 typeahead-template-url=customTemplate.html required ng-class=\"{ \'has-error\': spotBookingForm.searchCustomer.$touched && spotBookingForm.searchCustomer.$invalid }\"> <i ng-if=loadingCustomers class=\"glyphicon glyphicon-refresh\"></i><div ng-if=\"vm.flagforError && vm.dataToFill.customer.length > 3\" class=mt5><span><i class=\"glyphicon glyphicon-remove\"></i> No se encontraron Resultados</span> <span class=pull-right><a class=\"btn btn-primary tableButton\" ng-click=vm.addNewCustomer() data-testid=agregar_cliente>{{\'searchCustAddUser\' | translate}}</a></span></div><div ng-if=\"spotBookingForm.searchCustomer.$touched|| vm.submit\" ng-messages=spotBookingForm.searchCustomer.$error><div class=\"errormessage text-danger\" ng-message=required>Por favor ingrese los detalles del cliente.</div></div></div></div><div class=\"row mt5\" ng-if=vm.dataToFill.newCustomerFlag><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Nombre Cliente <span style=color:red>*</span></label><input type=text ng-model=vm.dataToFill.first_name placeholder=\"Nombre Cliente\" class=form-control pattern=^\\D*$ ng-maxlength=60 ng-minlength=3 name=customerFirstName required ng-class=\"{ \'has-error\': spotBookingForm.customerFirstName.$touched && spotBookingForm.customerFirstName.$invalid }\" data-testid=agregar_nombre_cliente><div ng-if=\"spotBookingForm.customerFirstName.$touched|| vm.submit\" ng-messages=spotBookingForm.customerFirstName.$error><div class=\"errormessage text-danger\" ng-message=required>Favor ingrese Nombre Cliente</div><div class=\"errormessage text-danger\" ng-message=pattern>Nombre Cliente no válido</div><div class=\"errormessage text-danger\" ng-message=minlength>Se requieren al menos 3 caracteres</div><div class=\"errormessage text-danger\" ng-message=maxlength>A lo más pueden ser 60 caracteres</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Apellido Cliente <span style=color:red>*</span></label><input type=text ng-model=vm.dataToFill.last_name placeholder=\"Apellido Cliente\" class=form-control pattern=^\\D*$ ng-maxlength=60 ng-minlength=3 name=customerLastName required ng-class=\"{ \'has-error\': spotBookingForm.customerLastName.$touched && spotBookingForm.customerLastName.$invalid }\" data-testid=agregar_apellido_cliente><div ng-if=\"spotBookingForm.customerLastName.$touched|| vm.submit\" ng-messages=spotBookingForm.customerLastName.$error><div class=\"errormessage text-danger\" ng-message=required>Favor ingrese apellido Cliente</div><div class=\"errormessage text-danger\" ng-message=pattern>Apellido Cliente no válido</div><div class=\"errormessage text-danger\" ng-message=minlength>Se requieren al menos 3 caracteres</div><div class=\"errormessage text-danger\" ng-message=maxlength>A lo más pueden ser 60 caracteres</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Email <span style=color:red>*</span></label><input type=text ng-model=vm.dataToFill.customerEmail placeholder=Email class=form-control pattern=^([_a-zA-Z0-9-+]+)(\\.[_a-zA-Z0-9-+]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*\\.)+([a-zA-Z]{2,3})$ data-testid=email_cliente name=customerEmail required ng-class=\"{ \'has-error\': spotBookingForm.customerEmail.$touched && spotBookingForm.customerEmail.$invalid }\"><div ng-if=\"spotBookingForm.customerEmail.$touched|| vm.submit\" ng-messages=spotBookingForm.customerEmail.$error><div class=\"errormessage text-danger\" ng-message=required>Favor ingrese Email Cliente</div><div class=\"errormessage text-danger\" ng-message=pattern>Email Cliente no válido</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Teléfono <span style=color:red>*</span></label><input type=text ng-model=vm.dataToFill.customerMobile placeholder=Teléfono class=form-control pattern=^([1-9]{1}[0-9]{8})*$ data-testid=fono_cliente ng-minlength=9 ng-maxlength=9 name=customerMobileG required ng-class=\"{ \'has-error\': spotBookingForm.customerMobileG.$touched && spotBookingForm.customerMobileG.$invalid }\"><div ng-if=\"spotBookingForm.customerMobileG.$touched|| vm.submit\" ng-messages=spotBookingForm.customerMobileG.$error><div class=\"errormessage text-danger\" ng-message=required>Favor ingrese teléfono Cliente</div><div class=\"errormessage text-danger\" ng-message=pattern>Teléfono Cliente no válido</div><div class=\"errormessage text-danger\" ng-message=minlength>Teléfono Cliente no válido</div><div class=\"errormessage text-danger\" ng-message=maxlength>Teléfono Cliente no válido</div></div></div></div><div class=\"row mt5\" ng-if=vm.showAgreementInUI><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Seleccionar Convenio <span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.contractIdSelected name=agreement ng-change=vm.agreementTypeChanged() data-testid=convenio_cliente required ng-class=\"{ \'has-error\': spotBookingForm.agreement.$touched && spotBookingForm.agreement.$invalid }\" ng-options=\"data.id as data.name for data in vm.dataToFill.contractListShowing\"><option value=\"\" selected disabled>Seleccionar Convenio</option></select><div ng-if=\"spotBookingForm.agreement.$touched|| vm.submit\" ng-messages=spotBookingForm.agreement.$error><div class=\"errormessage text-danger\" ng-message=required>Favor seleccione Convenio</div></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=\"vm.dataToFill.customerProfile == \'1\' || vm.dataToFill.customerProfile == 1\"><label class=control-label style=\"visibility: hidden\">Seleccionar Convenio</label><button class=\"btn btn-primary endowmentButton\" type=button style=padding:5px ng-click=vm.addEndowment($event) data-testid=btn_agregar_otro_convenio>Agregar a la dotación de otro convenio</button></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\" ng-if=\"vm.dataToFill.authRequired == \'1\'\"><label class=control-label>Nombre del autor <span style=color:red>*</span></label><input type=text ng-model=vm.dataToFill.authName placeholder=\"Nombre del autor\" class=form-control name=authName required ng-class=\"{ \'has-error\': spotBookingForm.authName.$touched && spotBookingForm.authName.$invalid }\" readonly><div ng-if=\"spotBookingForm.authName.$touched|| vm.submit\" ng-messages=spotBookingForm.authName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'authNameR\' | translate}}</div></div></div></div><div class=\"row mt5\" ng-if=!vm.showAgreementInUI><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label style=\"margin-bottom: 20px\">Seleccionar Destino <span style=color:red>*</span></label><br><!-- <button type=\"button\" style=\"margin-left: 5px; width: auto;height: 40px;border: 1px solid #7ed321;background-color: #7ed321;color: #fff;font-weight: 600;border-radius: 4px;margin-top: 5px\"\n                                        ng-click=\"vm.SelectAddress(data)\" ng-repeat=\"data in filtered = vm.addressArray\">\n                                        {{data.address_name}}\n                                    </button> --> <button type=button ng-click=vm.SelectAddress($index,data) class=\"newButton notActive1\" ng-class=\"{\'activeButton\':  vm.addressFlag == $index}\" ng-repeat=\"data in  vm.addressArray\">{{data.address_name}}</button></div></div><div class=\"row mt5\"><div class=\"col-lg-6 col-sm-16 col-md-6 col-xs-12\" style=\"margin-top: 20px\"><label class=control-label>Destino <span style=color:red>*</span></label><input type=text ng-model=vm.dataToFill.dropOffAddress placeholder=Destino class=form-control name=dropOffAddress data-testid=destino id=dropOffAddress required ng-change=vm.dropooffaddress(vm.dataToFill.dropOffAddress) ng-focus=vm.getPreviousAddressHit() ng-model-options=\"{ debounce: 500 }\" ng-class=\"{ \'has-error\': spotBookingForm.dropOffAddress.$touched && spotBookingForm.dropOffAddress.$invalid }\"><div style=\"background-color: white\" ng-if=\"vm.addressDropOffArray.length > 0\"><table class=\"table table-hover tableWithMasterData\"><thead></thead><tbody style=\"max-height: 250px\"><tr ng-click=vm.fillInAddress(data) ng-repeat=\"data in vm.addressDropOffArray | filter: vm.search\"><td style=\"width: 5px;text-align: left !important\"><i class=\"fa fa-map-marker\"></i></td><td style=\"text-align: left !important\"><!-- <span ng-bind-html=\"data.highlightedTitle\"></span>\n                                                    <span ng-if=\"data.flag\">,</span>\n                                                    <span ng-if=\"data.flag && data.highlightedVicinity[1] != undefined\">{{data.highlightedVicinity[1]}}</span>\n                                                    <span ng-if=\"data.flag && data.highlightedVicinity[2] != undefined\">,{{data.highlightedVicinity[2]}}</span> --><!-- <span ng-if=\"data.type == 0\">{{data.full_address}}</span> --> <span>{{data.label}}</span></td><!-- <td style=\"text-align: left !important;\">{{data.title}}</td> --></tr></tbody></table></div><div ng-if=\"spotBookingForm.dropOffAddress.$touched|| vm.submit\" ng-messages=spotBookingForm.dropOffAddress.$error><div class=\"errormessage text-danger\" ng-message=required>Favor ingrese Dirección de Destino</div></div></div><div class=\"col-lg-2 col-sm-2 col-md-2 col-xs-12\" style=\"margin-top: 43px\"><i data-testid=favorito_true ng-click=vm.MarkfavouriteAddressDrop(true) ng-if=\"(vm.dataToFill.dropLat && vm.dataToFill.dropLng) && (vm.isActiveDrop)\" class=\"fa fa-heart redClass\" aria-hidden=true></i> <i data-testid=favorito_false ng-click=vm.MarkfavouriteAddressDrop(false) ng-if=\" (vm.dataToFill.dropLat && vm.dataToFill.dropLng) && (!vm.isActiveDrop)\" class=\"fa fa-heart-o whiteClass\" aria-hidden=true></i></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12\" ng-style=vm.favAddFlagB class=text-center ng-if=vm.favAddFlag style=\"margin-top: 43px\"><a ng-disabled=vm.CheckBookingStatus(vm.bookingDetails) class=\"btn btn-primary tableButton\" ng-click=vm.pickFavAddress($event) data-testid=direccion_favorita>{{\'favAddressButton\' | translate}}</a></div></div><div class=\"row mt5\" ng-if=!vm.showAgreementInUI><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label style=\"margin-bottom: 20px\">Nro. Pasajeros <span style=color:red>*</span></label><br><button class=\"newButton1 notActive2\" ng-class=\"{\'activeButton\':  vm.numberFLag == $index}\" ng-repeat=\"data in  vm.NumberArray\" data-testid=nro_pasajeros_{$index} type=button ng-click=vm.PassengerValue($index,data)>{{data.key}}</button><!-- <input type=\"text\" ng-model=\"vm.dataToFill.passengerCount\" placeholder=\"Nro. Pasajeros\" class=\"form-control\" name=\"passengerCount\"\n                                        ng-change=\"vm.numberOfPassenger(vm.dataToFill.passengerCount)\" required ng-class=\"{ \'has-error\': spotBookingForm.passengerCount.$touched && spotBookingForm.passengerCount.$invalid }\"\n                                        is-number=\"\">\n                                    <div ng-if=\"spotBookingForm.passengerCount.$touched|| vm.submit\" ng-messages=\"spotBookingForm.passengerCount.$error\">\n                                        <div class=\"errormessage text-danger\" ng-message=\"required\">Favor ingrese Número de Pasajeros</div>\n                                    </div> --></div></div><div class=\"row mt5\" ng-if=\"vm.dataToFill.customerProfile == 1\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label style=\"margin-bottom: 20px\">Nro. Pasajeros <span style=color:red>*</span></label><input type=text ng-model=vm.dataToFill.passengerCount placeholder=\"Nro. Pasajeros\" class=form-control name=passengerCount data-testid=nro_pasajeros ng-change=vm.PassengerValueForDynamnicAgreementCount(vm.dataToFill.passengerCount) required ng-class=\"{ \'has-error\': spotBookingForm.passengerCount.$touched && spotBookingForm.passengerCount.$invalid }\" is-number=\"\"><div ng-if=\"spotBookingForm.passengerCount.$touched|| vm.submit\" ng-messages=spotBookingForm.passengerCount.$error><div class=\"errormessage text-danger\" ng-message=required>Favor ingrese Número de Pasajeros</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-if=vm.dataToFill.noService style=\"margin-top: 20px\"><label class=control-label>Sin servicio disponible</label></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-if=\"vm.dataToFill.serviceTypeList.length > 0\" style=\"margin-top: 20px\"><label class=control-label>Tipo Servicio <span style=color:red>*</span></label><div class=services><a class=servieSales title={{service.service_name}} ng-class=\"{\'disabledService\': service.disabled,\'activeServices\': service.active}\" data-testid=servicio_{{service.service_name}} ng-repeat=\"service in vm.dataToFill.serviceTypeList\" ng-click=vm.selectService(service,$index)><span>{{service.service_name}}</span><br><img ng-src=\"{{service.service_image || \'assets/images/noImage.jpeg\'}}\"></a></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" ng-if=\"vm.dataToFill.paymentMethodList.length > 0\"><label class=control-label>Metodo de Pago <span style=color:red>*</span></label><div class=payments><a class=paymentsS title={{payment.type}} ng-class=\"{\'activePayment\': payment.active}\" ng-repeat=\"payment in vm.dataToFill.paymentMethodList\" data-testid=metodo_pago_{{payment.type}} ng-click=vm.selectPaymentMethod(payment,$index)><span>{{payment.type}}</span></a></div></div></div><div class=\"row mt25\" style=\"margin-bottom: 25px\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 text-center\"><button ng-disabled=!vm.disabledSubmitButton type=submit class=\"btn btn-primary\" style=width:100% data-testid=generar_venta>Generar Venta</button><!-- ng-disabled=\"vm.disableSubmitButton\" --></div></div><!-- </form> --></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12 saleBorderMap\"><div class=\"panel panel-default\"><div class=row style=\"min-height: 115px\"><div class=\"panel-body col-lg-6 col-sm-6 col-md-6 col-xs-12\"><!-- <div class=\"etaDiv\" ng-if=\"(vm.dataToFill.bookingType == \'1\' || vm.dataToFill.bookingType == 1 || vm.dataToFill.airportCheck == \'Z\') && vm.dataToFill.pickLat && vm.dataToFill.dropLat\">\n                                                <p ng-if=\"vm.dataToFill.selectedServiceDetails.category != 1\">ETA - {{vm.dataToFill.etaSchedule || \'0 min\'}}mins</p>\n                                                <p ng-if=\"vm.dataToFill.selectedServiceDetails.category == 1\">ETA - {{vm.dataToFill.etaScheduleValue + vm.dataToFill.time_trip_shared_service || \'0\'}}mins</p>\n                                            </div> --><div class=etaDiv ng-if=!vm.FlagToShowEstimatedPrice data-testid=eta><p>ETA: --</p></div><div class=etaDiv ng-if=!vm.FlagToShowEstimatedPrice data-testid=tipo_tarifa><p>Tipo de Tarifa: --</p></div><div class=etaDiv ng-if=vm.FlagToShowEstimatedPrice data-testid=eta><p ng-if=\"vm.dataToFill.selectedServiceDetails.category != 1\">ETA - {{vm.dataToFill.etaSchedule+ \'mins\' || \'0 min\'}}</p><p ng-if=\"vm.dataToFill.selectedServiceDetails.category == 1\">ETA - {{vm.dataToFill.etaScheduleValue + vm.dataToFill.time_trip_shared_service || \'0\'}}mins</p></div><div class=etaDiv ng-if=vm.FlagToShowEstimatedPrice data-testid=tipo_tarifa><p ng-if=\"vm.dataToFill.route_type == 0\">Tipo de Tarifa: Variable</p><p ng-if=\"vm.dataToFill.route_type == 1\">Tipo de Tarifa: Fija</p></div><!-- <div class=\"etaDiv\" ng-if=\"vm.dataToFill.estimatedFare\">\n                                                <p>{{\'estimatedPrice\' | translate}} - ${{ vm.estimatedCost_to_show || \'$0\'}}</p>\n                                            </div> --><div class=etaDiv ng-if=\"vm.showEstimatePriceInHtml(vm.FlagToShowEstimatedPrice, vm.dataToFill.roundTrip, vm.viaControlledFLag1, vm.viaControlledFLag)\"><p>{{\'estimatedPrice\' | translate}} - <span ng-if=\"!vm.click && vm.finalAdjustedPriceFromAdmin == 0\" data-testid=valor_reserva>${{ vm.math.round(vm.calculatedEstimatePriceFormFunction) }} </span><span ng-if=\"!vm.click && vm.finalAdjustedPriceFromAdmin != 0\" data-testid=valor_reserva>${{ vm.math.round(vm.calculatedEstimatePriceFormFunctionEstimated) }} </span><input style=\"width: 90px\" type=number ng-model=vm.calculatedEstimatePriceFormFunctionEstimated ng-if=vm.click> <button type=button class=\"btn-primary tableButton\" ng-disabled=vm.disableModifySpecialFareStatus ng-click=\"vm.clickFunction(\'Modify\')\" ng-if=\"!vm.click && !vm.dataToFill.roundTrip  && vm.dataToFill.route_type == 1  && vm.dataToFill.allowChangeFarePanel\">Modificar Tarifa</button> <button type=button class=\"btn-primary tableButton\" ng-disabled=vm.disableModifySpecialFareStatus ng-click=\"vm.clickFunction(\'Done\')\" ng-if=\"vm.click  && !vm.dataToFill.roundTrip && vm.dataToFill.route_type == 1 && vm.dataToFill.allowChangeFarePanel\">Confirmar</button></p></div><!--1703 change  && vm.dataToFill.route_type == 1 --><!-- <div class=\"etaDiv\" ng-if=\"vm.FlagToShowEstimatedPrice &&  vm.dataToFill.roundTrip == false && vm.viaControlledFLag1 == false && vm.viaControlledFLag == false \">\n                                            <p>{{\'estimatedPrice\' | translate}} - ${{ vm.math.round(vm.dataToFill.estimatedFare)\n                                                || \'0\'}}\n                                            </p>\n                                        </div>\n                                        <div class=\"etaDiv\" ng-if=\"vm.FlagToShowEstimatedPrice &&  vm.dataToFill.roundTrip == false && vm.viaControlledFLag1 == true && vm.viaControlledFLag == false \">\n                                            <p>{{\'estimatedPrice\' | translate}} - ${{ vm.math.round((vm.dataToFill.estimatedFare)\n                                                + (vm.dataToFill.controllerWayTarifa ? 0 : vm.via_controlled_price_to_send))|| \'0\'}}\n                                            </p>\n                                        </div>\n                                        <div class=\"etaDiv\" ng-if=\"vm.FlagToShowEstimatedPrice &&  vm.dataToFill.roundTrip == false && vm.viaControlledFLag1 == false && vm.viaControlledFLag == true \">\n                                            <p>{{\'estimatedPrice\' | translate}} - ${{ vm.math.round(vm.dataToFill.estimatedFare)||\n                                                \'0\'}}\n                                            </p>\n                                        </div>\n                                        <div class=\"etaDiv\" ng-if=\"vm.FlagToShowEstimatedPrice && vm.dataToFill.roundTrip == true && vm.viaControlledFLag1 == false && vm.viaControlledFLag == false \">\n                                            <p>{{\'estimatedPrice\' | translate}} - ${{ vm.math.round((vm.dataToFill.estimatedFare\n                                                ) + (vm.dataToFill.Return_policy.estimatedFare )) || \'0\'}}</p>\n                                        </div>\n                                        <div class=\"etaDiv\" ng-if=\"vm.FlagToShowEstimatedPrice &&  vm.dataToFill.roundTrip == true && vm.viaControlledFLag1 == true && vm.viaControlledFLag == false \">\n                                            <p>{{\'estimatedPrice\' | translate}} - ${{ vm.math.round((vm.dataToFill.estimatedFare\n                                                ) +(vm.dataToFill.controllerWayTarifa ? 0 : vm.via_controlled_price_to_send) + (vm.dataToFill.Return_policy.estimatedFare\n                                                )+ (vm.dataToFill.controllerWayTarifa ? 0 : vm.viaControlled2)) || \'0\'}}</p>\n                                        </div>\n                                        <div class=\"etaDiv\" ng-if=\"vm.FlagToShowEstimatedPrice &&  vm.dataToFill.roundTrip == true && vm.viaControlledFLag1 == false && vm.viaControlledFLag == true \">\n                                            <p>{{\'estimatedPrice\' | translate}} - ${{ vm.math.round((vm.dataToFill.estimatedFare)\n                                                + (vm.dataToFill.Return_policy.estimatedFare )+ (vm.dataToFill.controllerWayTarifa ? 0 : vm.viaControlled2)) || \'0\'}}</p>\n                                        </div> --><!-- <div class=\"etaDiv\" ng-if=\"vm.FlagToShowEstimatedPrice && vm.dataToFill.estimatedFare && vm.dataToFill.roundTrip == true && vm.viaControlledFLag1 == false\">\n                                            <p>{{\'fixedPrice\' | translate}} - ${{ vm.math.round(vm.dataToFill.estimatedFare) || \'0\'}}\n                                            </p>\n                                        </div> --><div class=etaDiv ng-if=\"vm.showEstimatePriceForFixedPriceInHtml(vm.FlagToShowEstimatedPrice, vm.dataToFill.estimatedFare, vm.dataToFill.roundTrip, vm.viaControlledFLag1)\"><p>{{\'fixedPrice\' | translate}} - <span data-testid=valor_reserva>${{ vm.math.round(vm.calculatedEstimatePriceForFixedPriceFormFunction) || \'0\'}}</span></p></div><!-- <div class=\"etaDiv\" ng-if=\"vm.FlagToShowEstimatedPrice && vm.dataToFill.Return_policy.estimatedFare && vm.dataToFill.roundTrip == true && vm.viaControlledFLag == false\">\n                                            <p>{{\'roundPrice\' | translate}} - ${{ vm.math.round(vm.dataToFill.Return_policy.estimatedFare)\n                                                || \'0\'}}</p>\n                                        </div> --><!-- <div class=\"etaDiv\" ng-if=\"vm.FlagToShowEstimatedPrice && vm.dataToFill.estimatedFare && vm.dataToFill.roundTrip == true && vm.viaControlledFLag1 == true\">\n                                            <p>{{\'fixedPrice\' | translate}} - ${{ vm.math.round(vm.dataToFill.estimatedFare + (vm.dataToFill.controllerWayTarifa ? 0 : vm.via_controlled_price_to_send))\n                                                || \'0\'}}\n                                            </p>\n                                        </div> --><!-- <div class=\"etaDiv\" ng-if=\"vm.FlagToShowEstimatedPrice &&  vm.dataToFill.roundTrip == true && vm.viaControlledFLag == true\">\n                                            <p>{{\'roundPrice\' | translate}} - ${{ vm.math.round(vm.dataToFill.Return_policy.estimatedFare\n                                                + (vm.dataToFill.controllerWayTarifa ? 0 : vm.viaControlled2)) || \'0\'}}</p>\n                                        </div> --><div class=etaDiv ng-if=\"vm.showEstimatePriceForRoundTripInHtml(vm.FlagToShowEstimatedPrice, vm.dataToFill.Return_policy.estimatedFare, vm.dataToFill.roundTrip, vm.viaControlledFLag)\"><p>{{\'roundPrice\' | translate}} - <span data-testid=valor_reserva_retorno>${{ vm.math.round(vm.calculatedEstimatePriceForRoundTripFormFunction) || \'0\'}}</span></p></div><!-- <div id=\"googleMap\" style=\"width:100%;\"></div> --></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><button data-testid=ver_mapa type=button class=\"btn btn-primary\" ng-click=vm.toggleMap(); style=\"margin-top: 40px\">Ver mapa</button></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 mt25\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean>Ida y Vuelta</td><!--{{\'roundTrip\' | translate}}--><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'ROUND_TRIP\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.roundTrip , \'fa fa-toggle-off\': !vm.dataToFill.roundTrip}\" data-testid=round_trip></i><!--,\'pointerEvent\': vm.dataToFill.bookingId && !vm.dataToFill.roundTrip--></td></tr><tr ng-if=vm.dataToFill.roundTrip><td colspan=2><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" ng-if=\"(!vm.flagAgreement) && vm.dataToFill.roundTrip\"><div class=\"boleeanTypeColor col-lg-3 col-sm-3 col-md-3 col-xs-12\"><i ng-click=\"vm.setBooleans(\'WAIT_TIME_INCLUDED\')\" data-testid=wait_time_included ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.is_wait_time_included ,\n                                                                           \'fa fa-toggle-off\': !vm.dataToFill.is_wait_time_included }\"></i></div><div class=\"headingBollean col-lg-9 col-sm-9 col-md-9 col-xs-12\" style=padding-top:10px><!--{{\'waitTimeInclude\' | translate}}--> <span ng-if=!vm.dataToFill.is_wait_time_included>Sin espera</span> <span ng-if=vm.dataToFill.is_wait_time_included>Con espera</span></div></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12\" ng-if=\"((!vm.dataToFill.is_wait_time_included ) || (vm.type_of_trip != \'R\' && vm.dataToFill.selectedServiceDetails.category == 1)) &&  ( (!vm.dataToFill.is_wait_time_included && vm.type_of_trip != \'R\') || (vm.dataToFill.selectedServiceDetails.category != 0 && vm.type_of_trip != \'R\'))\"><label>Fecha de Regreso<!-- <span style=\"color:red\">*</span> --></label><!--{{\'retuenDateLabel\' | translate}}--><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=returnDate ng-model=vm.dataToFill.returnDate data-testid=fecha_regreso placeholder=\"Fecha Regreso\" is-open=vm.datePicker_1.returnDate ng-change=vm.retunrDateChanged() datepicker-options=vm.returnDateOptions ng-class=\"{ \'has-error\': spotBookingForm.returnDate.$touched && spotBookingForm.returnDate.$invalid }\" close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'2\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><!-- <div ng-if=\"spotBookingForm.returnDate.$touched|| vm.submit\" ng-messages=\"spotBookingForm.returnDate.$error\">\n                                                                <div class=\"errormessage text-danger\" ng-message=\"required\">Favor ingrese Fecha de Regreso</div>\n                                                            </div> --></div><div class=\"col-lg-8 col-sm-8 col-md-8 col-xs-12\" ng-if=\"((!vm.dataToFill.is_wait_time_included )   || (vm.type_of_trip != \'R\' && vm.dataToFill.selectedServiceDetails.category == 1)) && ((!vm.dataToFill.is_wait_time_included && vm.type_of_trip != \'R\') || (vm.dataToFill.selectedServiceDetails.category != 0 && vm.type_of_trip != \'R\'))\"><div style=\"display: inline-flex;width:100%\"><div><label>Hora de Regreso<!-- <span style=\"color:red\">*</span> --></label><!--{{\'retuenTimeLabel\' | translate}}--><div uib-timepicker ng-model=vm.dataToFill.returnTime class=completed show-spinners=false ng-change=vm.retunrTimeChanged() ng-model-options=\"{ debounce: 400 }\" hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian data-testid=hora_regreso></div><!-- <div ng-if=\"spotBookingForm.returnTime.$touched|| vm.submit\" ng-messages=\"spotBookingForm.returnTime.$error\">\n                                                                                            <div class=\"errormessage text-danger\" ng-message=\"required\">Favor ingrese hora Regreso</div>\n                                                                                        </div> --></div><div style=padding-left:15px ng-if=\"vm.dataToFill.returnTime != \'\' && vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip_Validate_Booking == \'P\' \"><div class=etaDiv style=font-size:14px><p>Hora de Retiro Estimada:<br><span style=\"font-weight: bold\" data-testid=hora_retiro_estimada>({{vm.ptoptravelTime | date:\'HH:mm\'}} <span ng-if=\"vm.time_trip_shared_service_point_to_point > 0 &&  vm.is_group_external == 0\">- {{vm.rangeOfPointToPoint | date:\'HH:mm\'}}</span> hrs)</span></p></div><div class=etaDiv style=font-size:14px data-testid=hora_retiro_estimada><p>ETA - {{vm.dataToFill.etaScheduleValueReturn + vm.pickup_travel_time_pap || \'0\'}}mins</p></div></div></div></div><div class=\"col-lg-4 col-sm-4 col-md-6 col-xs-12\" ng-if=\"(!vm.dataToFill.is_wait_time_included && vm.dataToFill.selectedServiceDetails.category == 1  && vm.type_of_trip == \'R\') || (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip == \'R\')\"><label ng-if=\"vm.dataToFill.selectedServiceDetails.category == 1\">Fecha Presentación<!-- <span style=\"color:red\">*</span> --></label><label ng-if=\"vm.dataToFill.selectedServiceDetails.category == 0\">Fecha Recogida<!-- <span style=\"color:red\">*</span> --></label><!--{{\'retuenDateLabel\' | translate}}--><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=returnDate ng-model=vm.dataToFill.returnDateShared data-testid=fecha_regreso placeholder=\"Fecha Regreso\" is-open=vm.datePicker_1.returnDateShared ng-change=vm.returnDateShared() datepicker-options=vm.returnDateOptions ng-class=\"{ \'has-error\': spotBookingForm.returnDate.$touched && spotBookingForm.returnDate.$invalid }\" close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'3\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><!-- <div ng-if=\"spotBookingForm.returnDate.$touched|| vm.submit\" ng-messages=\"spotBookingForm.returnDate.$error\">\n                                                                    <div class=\"errormessage text-danger\" ng-message=\"required\">Favor ingrese Fecha de Regreso</div>\n                                                                </div> --></div><div class=\"col-lg-8 col-sm-8 col-md-6 col-xs-12\" style=\"display: flex\" ng-if=\"(!vm.dataToFill.is_wait_time_included && vm.dataToFill.selectedServiceDetails.category == 1  && vm.type_of_trip == \'R\') ||  (vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip == \'R\')\"><!-- <label>Hora Presentación\n                                                                </label>\n                                                                <div uib-timepicker ng-model=\"vm.dataToFill.returnTimeShared\" class=\"completed\" show-spinners=\"false\" ng-change=\"vm.retunrTimeSharedChanged()\"\n                                                                    hour-step=\"vm.hstep\" minute-step=\"vm.mstep\" show-meridian=\"vm.ismeridian\"></div> --><div><div><label ng-if=\"vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip == \'R\'\">Hora Recogida<!-- <span style=\"color:red\">*</span> --></label><label ng-if=\"vm.dataToFill.selectedServiceDetails.category == 1 && vm.type_of_trip == \'R\'\">Hora Presentación<!-- <span style=\"color:red\">*</span> --></label><div uib-timepicker ng-model=vm.dataToFill.returnTimeShared class=completed show-spinners=false ng-change=vm.retunrTimeSharedChanged() ng-model-options=\"{ debounce: 0 }\" data-testid=hora_regreso hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian></div></div></div><div style=padding-left:9px><div class=etaDiv style=font-size:14px ng-if=\"vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip == \'R\'\" data-testid=hora_retiro_estimada><p><span style=\"font-weight: bold\">Hora Retiro Estimada</span> : {{ vm.pickRangeForRType | date:\'HH:mm\'}} <span ng-if=\"vm.tolerance_time_withdrawal_pickup > 0 &&  vm.is_group_external == 0\">- {{ vm.pickRangeForEstimated | date:\'HH:mm\'}} </span>hrs</p><p><span style=\"font-weight: bold\">ETA</span> - {{vm.dataToFill.etaScheduleValueReturn + vm.travel_time_service_pick_up || \'0\'}}mins</p></div><div style=\"font-size:13px;text-align: center\" ng-if=\"vm.showPickUpTime && !vm.method_range_pickup\" data-testid=hora_retiro_estimada><p><span style=\"font-weight: bold\">Hora Retiro Estimada</span> :{{vm.pickRange5}} - {{vm.pickRange3ToShowAdd}} hrs</p></div><div class=etaDiv style=font-size:14px ng-if=\"vm.method_range_pickup && vm.showPickUpTime && (vm.dataToFill.selectedServiceDetails.category == 1)\" data-testid=hora_retiro_estimada><p>Hora Retiro Estimada: {{vm.pickRangeForRoutingReturn}} hrs</p></div><!-- <div style=\"font-size:13px;text-align: center\" ng-if=\"vm.showPickUpTimeForRtype && !vm.method_range_pickup\">\n                                                                <p>\n                                                                    <span style=\"font-weight: bold\">Hora Retiro Estimada</span> : {{ vm.pickRangeForEstimated\n                                                                    | date:\'HH:mm\'}}\n                                                                    <span ng-if=\"vm.tolerance_time_withdrawal_pickup > 0 &&  vm.is_group_external == 0\">\n                                                                    - {{vm.pickRangeForRType | date:\'HH:mm\'}} </span>\n                                                                    hrs\n                                                                </p>\n                                                            </div> --><div style=\"font-size:13px;text-align: center;padding-top: 5px\" ng-if=\"vm.showPickUpTimeForRtype && !vm.method_range_pickup\" data-testid=hora_retiro_estimada><!-- <p ng-if=\"vm.dataToFill.selectedServiceDetails.category != 1\">ETA - {{vm.dataToFill.etaSchedule || \'0 min\'}}</p> --><p>ETA - {{vm.dataToFill.etaScheduleValue + vm.travel_time_service_pick_up || \'0\'}}mins</p></div><!-- <div class=\"etaDiv\" style=\"font-size:14px;\" ng-if=\"vm.dataToFill.selectedServiceDetails.category == 1 && vm.dataToFill.airportCheck == \'Z\'\">\n                                                                                    <p>Hora Recogida Estimada: {{vm.dataToFill.dropTimeReturn\n                                                                                        | date:\'HH:mm\'}} hrs</p> \n                                                                                </div> --><div style=\"font-size:13px;text-align: center;padding-top: 5px\" ng-if=vm.showPickUpTime data-testid=hora_retiro_estimada><!-- <p ng-if=\"vm.dataToFill.selectedServiceDetails.category != 1\">\n                                                                    <span style=\"font-weight: bold\">ETA</span> - {{vm.dataToFill.etaScheduleReturn || \'0\n                                                                    min\'}}\n                                                                </p> --><p ng-if=\"vm.dataToFill.selectedServiceDetails.category == 1 &&  vm.method_range_pickup && vm.type_of_trip == \'R\'\"><span style=\"font-weight: bold\">ETA</span> - {{vm.dataToFill.etaScheduleValueReturn || \'0\'}}mins</p><!-- <p ng-if=\"vm.dataToFill.selectedServiceDetails.category == 0 && vm.type_of_trip == \'R\'\">\n                                                                    <span style=\"font-weight: bold\">ETA</span> - {{vm.dataToFill.etaScheduleValueReturn ||\n                                                                    \'0\'}}mins\n                                                                </p> --><p ng-if=\"vm.dataToFill.selectedServiceDetails.category == 1 &&  !vm.method_range_pickup\"><span style=\"font-weight: bold\">ETA</span> - {{vm.dataToFill.etaScheduleValueReturn + vm.dataToFill.time_trip_shared_service || \'0\'}}mins</p></div></div></div></div></td></tr></tbody></table></div></div><div class=row><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.passengerRutCheck == 1\"><label>Pasajero RUT <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.passengerRut name=passengerRut placeholder=\"Pasajero RUT\" data-testid=rut_pasajero ng-rut ng-change=vm.passengerRutChange() required maxlength=13 ng-class=\"{ \'has-error\': spotBookingForm.passengerRut.$touched && spotBookingForm.passengerRut.$invalid }\"><div ng-if=\"spotBookingForm.passengerRut.$touched|| vm.submit\" ng-messages=spotBookingForm.passengerRut.$error><div class=\"errormessage text-danger\" ng-message=required>Ingrese pasajero RUT</div></div><div class=\"errormessage text-danger\" ng-if=vm.dataToFill.passengerRUTError>RUT no válido</div></div><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.applicantRutCheck == 1\"><!--ng-if=\"((vm.dataToFill.customerProfile == 1 && vm.dataToFill.contractIdSelected) || (vm.dataToFill.customerProfile == 0 && vm.dataToFill.applicantRutCheck == 1))\"--><label>Solicitante RUT <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.applicantRut name=applicantRut placeholder=\"Solicitante RUT\" ng-rut ng-change=vm.applicantRutChange() required maxlength=13 ng-class=\"{ \'has-error\': spotBookingForm.applicantRut.$touched && spotBookingForm.applicantRut.$invalid }\"><div ng-if=\"spotBookingForm.applicantRut.$touched|| vm.submit\" ng-messages=spotBookingForm.applicantRut.$error><div class=\"errormessage text-danger\" ng-message=required>Por favor ingrese el solicitante RUT</div></div><div class=\"errormessage text-danger\" ng-if=vm.dataToFill.applicantRUTError>RUT no válido</div></div></div><div class=row><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.costCenterCheck == 1\"><!--ng-if=\"((vm.dataToFill.customerProfile == 1 && vm.dataToFill.contractIdSelected) || (vm.dataToFill.customerProfile == 0 && vm.dataToFill.costCenterCheck == 1))\"--><label>Centro de Costo <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.costCenter name=costCenter placeholder=\"Centro de Costo\" data-testid=centro_costo required ng-class=\"{ \'has-error\': spotBookingForm.costCenter.$touched && spotBookingForm.costCenter.$invalid }\" ng-maxlength=50 maxlength=50><div ng-if=\"spotBookingForm.costCenter.$touched|| vm.submit\" ng-messages=spotBookingForm.costCenter.$error><div class=\"errormessage text-danger\" ng-message=required>Por favor ingrese el centro de costos.</div><div class=\"errormessage text-danger\" ng-message=maxlength>A lo más pueden ser 50 caracteres</div></div></div><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.costSubCenterCheck == 1\"><!--ng-if=\"((vm.dataToFill.customerProfile == 1 && vm.dataToFill.contractIdSelected) || (vm.dataToFill.customerProfile == 0 && vm.dataToFill.costSubCenterCheck == 1))\"--><label>Centro SubCost <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.costSubCenter name=costSubCenter placeholder=\"Centro SubCost\" data-testid=centro_subcosto required ng-class=\"{ \'has-error\': spotBookingForm.costSubCenter.$touched && spotBookingForm.costSubCenter.$invalid }\" ng-maxlength=50 maxlength=50><div ng-if=\"spotBookingForm.costSubCenter.$touched|| vm.submit\" ng-messages=spotBookingForm.costSubCenter.$error><div class=\"errormessage text-danger\" ng-message=required>Por favor, ingrese el centro de costos secundarios.</div><div class=\"errormessage text-danger\" ng-message=maxlength>A lo más pueden ser 50 caracteres</div></div></div></div><div class=row><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.RolCheck == 1\"><!--ng-if=\"((vm.dataToFill.customerProfile == 1 && vm.dataToFill.contractIdSelected) || (vm.dataToFill.customerProfile == 0 && vm.dataToFill.RolCheck == 1))\"--><label>ROL <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.Rol name=Rol placeholder=ROL required ng-class=\"{ \'has-error\': spotBookingForm.Rol.$touched && spotBookingForm.Rol.$invalid }\" data-testid=rol ng-maxlength=50 maxlength=50><div ng-if=\"spotBookingForm.Rol.$touched|| vm.submit\" ng-messages=spotBookingForm.Rol.$error><div class=\"errormessage text-danger\" ng-message=required>Por favor ingrese rol.</div><div class=\"errormessage text-danger\" ng-message=maxlength>A lo más pueden ser 50 caracteres</div></div></div><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.graphCheck == 1\"><!--ng-if=\"((vm.dataToFill.customerProfile == 1 && vm.dataToFill.contractIdSelected) || (vm.dataToFill.customerProfile == 0 && vm.dataToFill.graphCheck == 1))\"--><label>Graph <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.graph name=graph placeholder=Graph required ng-class=\"{ \'has-error\': spotBookingForm.graph.$touched && spotBookingForm.graph.$invalid }\" data-testid=graph ng-maxlength=50 maxlength=50><div ng-if=\"spotBookingForm.graph.$touched|| vm.submit\" ng-messages=spotBookingForm.graph.$error><div class=\"errormessage text-danger\" ng-message=required>Por favor ingrese el gráfico.</div><div class=\"errormessage text-danger\" ng-message=maxlength>A lo más pueden ser 50 caracteres</div></div></div></div><div class=row><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.workOrderCheck == 1\"><label>Orden de trabajo <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.workOrder name=workOrder placeholder=\"Orden de trabajo\" data-testid=orden_trabajo required ng-class=\"{ \'has-error\': spotBookingForm.workOrder.$touched && spotBookingForm.workOrder.$invalid }\" ng-maxlength=15 maxlength=15><div ng-if=\"spotBookingForm.workOrder.$touched|| vm.submit\" ng-messages=spotBookingForm.workOrder.$error><div class=\"errormessage text-danger\" ng-message=required>Por favor ingrese la orden de trabajo.</div><div class=\"errormessage text-danger\" ng-message=maxlength>Se permiten un máximo de 15 caracteres.</div></div></div><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.pepCheck == 1\"><!--ng-if=\"((vm.dataToFill.customerProfile == 1 && vm.dataToFill.contractIdSelected) || (vm.dataToFill.customerProfile == 0 && vm.dataToFill.pepCheck == 1))\"--><label>PEP <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.pep name=pep placeholder=PEP required ng-class=\"{ \'has-error\': spotBookingForm.pep.$touched && spotBookingForm.pep.$invalid }\" data-testid=pep ng-maxlength=50 maxlength=50><div ng-if=\"spotBookingForm.pep.$touched|| vm.submit\" ng-messages=spotBookingForm.pep.$error><div class=\"errormessage text-danger\" ng-message=required>Por favor ingrese pep.</div><div class=\"errormessage text-danger\" ng-message=maxlength>A lo más pueden ser 50 caracteres</div></div></div></div><div class=row><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.noOfVoucherCheck == 1\"><label>Número Vale <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.noOfVoucher name=numberOfVoucher placeholder=\"Número Vale\" data-testid=numero_vale required ng-class=\"{ \'has-error\': spotBookingForm.numberOfVoucher.$touched && spotBookingForm.numberOfVoucher.$invalid }\" ng-maxlength=15 maxlength=15><div ng-if=\"spotBookingForm.numberOfVoucher.$touched|| vm.submit\" ng-messages=spotBookingForm.numberOfVoucher.$error><div class=\"errormessage text-danger\" ng-message=required>Por favor ingrese el número de comprobante.</div><div class=\"errormessage text-danger\" ng-message=maxlength>Se permiten un máximo de 15 caracteres.</div></div></div><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.nominaCheck == 1\"><label>Nomina <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.nomina name=nomina alpha-numeric=\"\" maxlength=15 ng-maxlength=15 data-testid=nomina placeholder=Nomina ng-class=\"{ \'has-error\': spotBookingForm.nomina.$touched && spotBookingForm.nomina.$invalid }\"><div ng-if=\"spotBookingForm.nomina.$touched|| vm.submit\" ng-messages=spotBookingForm.nomina.$error><div class=\"errormessage text-danger\" ng-message=required>Por favor ingrese nomina.</div><div class=\"errormessage text-danger\" ng-message=maxlength>Se permiten un máximo de 15 caracteres.</div></div></div></div><div class=row><div class=\"col-lg-6 col-sm-6 col-xs-12 col-md-6 mt5\" ng-if=\"vm.dataToFill.solictudCheck == 1\"><label>Solicitud <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.solictud name=solicitud placeholder=Solicitud required data-testid=solicitud alpha-numeric=\"\" maxlength=15 ng-maxlength=15 ng-class=\"{ \'has-error\': spotBookingForm.solicitud.$touched && spotBookingForm.solicitud.$invalid }\"><div ng-if=\"spotBookingForm.solicitud.$touched|| vm.submit\" ng-messages=spotBookingForm.solicitud.$error><div class=\"errormessage text-danger\" ng-message=required>Por favor, ingrese la solicitud</div><div class=\"errormessage text-danger\" ng-message=maxlength>Se permiten un máximo de 15 caracteres.</div></div></div></div><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12 mt5\" ng-if=\"vm.dataToFill.purposeOfTripCheck == 1\"><label>Propósito de viaje <span style=color:red>*</span></label><textarea class=form-control ng-model=vm.dataToFill.purposeOfTrip name=purposeOfTrip placeholder=\"Propósito de viaje\" data-testid=proposito_viaje required ng-class=\"{ \'has-error\': spotBookingForm.purposeOfTrip.$touched && spotBookingForm.purposeOfTrip.$invalid }\" ng-maxlength=50 maxlength=50></textarea><div ng-if=\"spotBookingForm.purposeOfTrip.$touched|| vm.submit\" ng-messages=spotBookingForm.purposeOfTrip.$error><div class=\"errormessage text-danger\" ng-message=required>Por favor, introduzca el propósito del viaje.</div><div class=\"errormessage text-danger\" ng-message=maxlength>A lo más pueden ser 50 caracteres</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" ng-if=\"vm.dataToFill.itemOfChargeList.length > 0\"><label>Cargos adicionales</label><ui-select multiple ng-model=vm.dataToFill.itemOfChargeSelected theme=bootstrap close-on-select=false title=\"Seleccione el elemento de cargo\" data-testid=cargos_adicionales name=itemOfCharge on-select=\"vm.selectingItemOfCharges($select.selected,\'select\')\" on-remove=\"vm.selectingItemOfCharges($select.selected,\'remove\')\" ng-class=\"{ \'has-error\': spotBookingForm.itemOfCharge.$touched && spotBookingForm.itemOfCharge.$invalid }\"><ui-select-match placeholder=\"Seleccione el elemento de cargo\">{{$item.tic_long_name}}</ui-select-match><ui-select-choices repeat=\"data in vm.dataToFill.itemOfChargeList | filter:$select.search \">{{data.tic_long_name}}</ui-select-choices></ui-select></div><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" ng-if=\"vm.dataToFill.itemOfChargeSelected.length> 0\"><table class=table style=\"border: 1px solid #80808059\"><thead><tr><th>Nombre Cargo Adicional</th><th style=min-width:130px>Cantidad</th><th style=min-width:130px>Precio Cargo Adicional</th></tr></thead><tbody><tr ng-repeat=\"itemData in vm.dataToFill.itemOfChargeSelected\"><td>{{itemData.tic_long_name}}</td><td><input type=number ng-disabled=\"itemData.tic_mode != 1\" placeholder=Cantidad style=width:125px ng-model=itemData.quantity ng-change=\"vm.changeQuantityOfItem(itemData.quantity,$index,\'change\')\" min=1></td><td><span ng-if=\"itemData.tic_mode == 0\">${{itemData.price}}</span> <span ng-if=\"itemData.tic_mode == 1\">$ <input type=text style=width:100px ng-change=\"vm.selectingItemOfCharges($index,\'change\')\" placeholder=\"{{\'itemPrice\' | translate}}\" ng-model=itemData.price number-dot></span></td></tr></tbody></table></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>Cupón Descuento</label></div><div class=\"col-lg-8 col-sm-8 col-xs-12 col-md-8\"><input ng-disabled=\"vm.finalAdjustedPriceFromAdmin > 0 || vm.dataToFill.roundTrip == true ||  !vm.couponFlag\" type=text data-testid=cupon_descuento class=form-control ng-model=vm.dataToFill.couponCode name=couponCode placeholder=\"Cupón Descuento\" ng-class=\"{ \'has-error\': spotBookingForm.couponCode.$touched && spotBookingForm.couponCode.$invalid }\" ng-change=\"vm.dataToFill.couponValidation=false\"><div ng-if=vm.dataToFill.couponValidation class=\"parsley-errors-list filled\"><div class=\"errormessage text-danger\">Este cupón no es válido</div></div><!--<div ng-if=\"spotBookingForm.couponCode.$touched|| vm.submit\" ng-messages=\"spotBookingForm.couponCode.$error\">--><!--<div class=\"errormessage text-danger\" ng-message=\"required\">Por favor, ingrese la solicitud</div>--><!--<div class=\"errormessage text-danger\" ng-message=\"maxlength\">Se permiten un máximo de 15 caracteres.</div>--><!--</div>--></div><div class=\"col-lg-4 col-sm-4 col-xs-12 col-md-4\"><input ng-disabled=\"vm.finalAdjustedPriceFromAdmin > 0 || vm.dataToFill.roundTrip == true || !vm.couponFlag\" type=button data-testid=aplicar_descuento class=\"btn btn-primary\" ng-click=vm.applyCoupon() value=Apply style=width:200px></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\"><label>Observaciones</label><textarea class=form-control ng-model=vm.dataToFill.observations name=observation placeholder=Observaciones style=\"height: 120px\" data-testid=observaciones ng-class=\"{ \'has-error\': spotBookingForm.observation.$touched && spotBookingForm.observation.$invalid }\" ng-maxlength=500 maxlength=500></textarea><div ng-if=\"spotBookingForm.observation.$touched|| vm.submit\" ng-messages=spotBookingForm.observation.$error><div class=\"errormessage text-danger\" ng-message=maxlength>Se permiten un máximo de 500 caracteres.</div></div></div></div><div class=\"row mt5\" ng-if=\"((vm.dataToFill.roundTrip || vm.dataToFill.couponApplied) && vm.dataToFill.sortData.length > 0)\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">Monto de la reserva</p><div class=row style=\"padding:0px 10px\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 table-responsive\" style=\"max-height:345px;overflow-y: auto\"><table class=\"table table-hover\"><thead><tr><th>Descuento Nombre</th><th>Descuento</th><th>Tipo</th><th>{{\'estimatedPrice\' | translate}}</th><th>Cantidad total</th></tr></thead><tbody><tr><td data-testid=nombre_descuento><span ng-if=\"vm.dataToFill.sortData[0].coupon_name == \'Round Trip\'\">DSCTO. IDA Y VUELTA</span> <span ng-if=\"vm.dataToFill.sortData[0].coupon_name != \'Round Trip\'\">{{vm.dataToFill.sortData[0].coupon_name}}</span></td><td data-testid=valor_descuento>{{vm.dataToFill.sortData[0].value}}</td><td data-testid=tipo_descuento>{{vm.dataToFill.sortData[0].type == \'0\' ? \'Flat\' : vm.dataToFill.sortData[0].type == \'1\' ? \'Percentage\' : NA}}</td><!-- <td>${{vm.dataToFill.sortData[0].estimatedCost}}</td> --><td data-testid=precio_estimado>${{vm.dataToFill.estimatedFare + (vm.dataToFill.controllerWayTarifa ? 0 : vm.via_controlled_price_to_send) + (vm.dataToFill.roundTrip ? (vm.dataToFill.Return_policy.estimatedFare + (vm.dataToFill.controllerWayTarifa ? 0 : vm.viaControlled2)) : 0)}}</td><td data-testid=cantidad_total>${{vm.dataToFill.sortData[0].returnFinalAmount + vm.dataToFill.sortData[0].finalAmount}}</td></tr></tbody></table></div></div></div></div></div></div></form></div><!-- <div style=\"margin-top: 50px;\">\n                    <div id=\"googleMap\" style=\"width:100%;\"></div>\n                </div> --></div></div><input id=copy style=\"opacity: 0 ; z-index:0\" type=text><div id=showPrint></div><div id=showPrintR></div><div id=salesReport></div><div id=mapModal class=\"modal fade\" role=dialog><div class=modal-dialog><div class=modal-content><div class=modal-body><div style=\"margin-top: 50px\"><div id=googleMap style=\"width:100%;height: 500px !important\"></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>Close</button></div></div></div></div></div><script type=text/ng-template id=customTemplate.html><a style=\"cursor: pointer;\">\n        <span class=\"displayFlex\">\n            <span>\n                <img ng-src=\"{{match.model.profile_pic_thumb || \'assets/images/noImage.jpeg\'}}\" width=\"35\">\n            </span>\n            <span style=\"padding-left: 10px;\">\n                <span ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"></span>\n                <span>/</span>\n                <span ng-bind-html=\"match.model.email\"></span>\n                <br/>\n                <span ng-bind-html=\"match.model.phone_number\"></span>\n            </span>\n        </span>\n    </a></script>");
$templateCache.put("app/components/views/quickSale/quickSaleMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/rejected-booking/rejectedBooking.html","<h2 class=ng-cloak><span>Reporte reservas rechazadas</span></h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><!-- date picker --><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label>Desde <span style=color:red>*</span></label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=startValidity ng-model=vm.dataToFill.from placeholder=Desde is-open=vm.datePicker_1.from datepicker-options=vm.dateOptionsFrom required close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.onFilterChange()> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'1\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label>Hasta <span style=color:red>*</span></label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=endValidity ng-model=vm.dataToFill.untill placeholder=Hasta is-open=vm.datePicker_1.untill datepicker-options=vm.dateOptionsUntill required close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.onFilterChange()> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"vm.datePickerE_1(\'2\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><!-- branch --><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label class=control-label>Sucursal</label><ui-select ng-model=vm.dataToFill.branch name=branch ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true ng-change=vm.onFilterChange()><ui-select-match placeholder=Sucursal>{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \" when-scrolled=vm.paginationChangedForBranch()><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select></div><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label class=control-label>Tipo Servicio</label><ui-select ng-model=vm.dataToFill.typeOfService name=branch required close-on-select=true ng-change=vm.onFilterChange()><ui-select-match placeholder=\"Tipo Servicio\">{{$select.selected.name}}</ui-select-match>{{vm.servicesList}}<ui-select-choices repeat=\"service.id as service in vm.servicesList | filter: $select.search | orderBy:\'service_name\' \" when-scrolled=vm.paginationChangedForService()><div ng-bind-html=service.name></div></ui-select-choices></ui-select></div></div><div class=row><div class=\"col-lg-3 col-sm-3 col-md-3 col-xs-12\"><label class=control-label>Vehículo</label><input type=text class=form-control is-number=\"\" ng-model=vm.dataToFill.vehicle_number ng-change=vm.vehicleChanged(vm.filterData.filter_vehicle_value) placeholder=Vehículo ng-blur=vm.onFilterChange()></div><div class=\"col-lg-2 col-sm-4 col-md-2 col-xs-4\"><button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px;margin-top:25px\" ng-click=vm.applyFilter()>Apply Filter</button></div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center mt5\"><p class=totalSize><span class=pull-left><a class=\"btn btn-primary tableButton mb10\" ng-click=vm.exportToCSV(0,vm.dataLength)>CSV</a> </span><span>Reservas totales rechazadas: {{vm.totalBookings}}</span></p></div><br><br><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.getFilter() ng-model-options=\"{ debounce: 500 }\"></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\"><!-- ng-switch=\"(vm.driverList | filter:vm.search).length\"--><!--<div ng-switch-when=\"0\" class=\"noSearch\"><span>{{\'nothingFound\' | translate}}</span></div>--><table class=\"table table-hover tableWithMasterData\"><!--ng-switch-default--><thead><tr><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=Sucursal text=\"\'region_name\'\" check=vm.reverse>Sucursal</th><th style=width:100px table-column-sorting current-text=vm.predicate title=Vehículo text=\"\'unique_car_id\'\" check=vm.reverse>Vehículo</th><th style=width:100px table-column-sorting current-text=vm.predicate title=Conductor text=\"\'driver_name\'\" check=vm.reverse>Conductor</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"Estado del vehículo al rechazar\" text=\"\'car_status\'\" check=vm.reverse>Estado del vehículo al rechazar</th><th style=width:100px table-column-sorting current-text=vm.predicate title=Reserva text=\"\'job_id\'\" check=vm.reverse>Reserva</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"Tipo Servicio\" text=\"\'service_name\'\" check=vm.reverse>Tipo Servicio</th><th style=width:100px table-column-sorting current-text=vm.predicate title=Convenio text=\"\'name\'\" check=vm.reverse>Convenio</th><th style=width:100px table-column-sorting current-text=vm.predicate title=Retiro text=\"\'retiro_datetime\'\" check=vm.reverse>Retiro</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"Tipo Viaje\" text=\"\'type_of_trip\'\" check=vm.reverse>Tipo Viaje</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"Tarifa Estimada\" text=\"\'estimated_cost\'\" check=vm.reverse>Tarifa Estimada</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"Tarifa Estimada\" text=\"\'Rechazo\'\" check=vm.reverse>Acción</th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.rejectedBookings | orderBy:vm.predicate:vm.reverse\"><!--| filter:vm.search--><td style=width:70px>{{data.index + 1}}</td><td style=width:100px>{{::data.region_name}}</td><td style=width:100px>{{::data.unique_car_id}}</td><td style=width:100px>{{::data.driver_name}}</td><td style=width:125px>{{::data.car_status}}</td><td style=width:100px>{{::data.job_id}}</td><td style=width:125px>{{::data.service_name}}</td><td style=width:100px>{{data.name}}</td><td style=width:100px>{{::data.retiro_datetime | date: \'dd/MM/yy HH:mm\'}}</td><td style=width:100px>{{::data.type_of_trip}}</td><td style=width:100px>{{::data.estimated_cost}}</td><td style=width:100px ng-if=\"data.is_rejected == 0 && data.is_missed == 1\">Omitido</td><td style=width:100px ng-if=\"data.is_rejected == 1 && data.is_missed == 0\">Rechazado</td><td style=width:100px ng-if=\"data.is_rejected == 0 && data.is_missed == 0\">Aceptado</td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noDriverFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav>--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\" ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/rejected-booking/rejectedBookingMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/shared-service/sharedServiceRouteAssignment.html","<h2 class=ng-cloak>Ruta compartida y asignación</h2><div class=\"ng-cloak container-fluid\" id=sharedScreen ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><!-- FILTER FOR BOOKINGS --><div class=\"row m0\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"border:1px solid #dedede;padding:0px\" ng-init=\"checkClicked = true\"><h2 class=\"text-center filtersStyle\" ng-click=\"checkClicked = !checkClicked; vm.slideData()\">Booking Filters <span class=fa ng-class=\"{\'fa-caret-down\': checkClicked,\'fa-caret-up\': !checkClicked }\"></span></h2><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" id=derp><form name=filterSharedForm ng-submit=\"submit=true;filterSharedForm.$valid&&vm.applyFilter(\'blank\')\" novalidate autocomplete=off><div class=row style=\"padding-top: 10px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'branchLabel\' | translate}} <span style=color:red>*</span></label><div><ui-select ng-model=vm.filterData.branch_value name=branch ng-change=vm.branchChanged(0) required close-on-select=true ng-class=\"{ \'has-error\': filterSharedForm.branch.$touched && filterSharedForm.branch.$invalid }\"><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search\"><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select><div ng-if=\"filterSharedForm.branch.$touched|| submit\" ng-messages=filterSharedForm.branch.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'branchR\' | translate}}</div></div></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'agreementLabel\' | translate}} <span style=color:red>*</span></label><div><ui-select ng-model=vm.filterData.aggrement_value name=agreement ng-change=vm.agreementChanged(0) required close-on-select=true><ui-select-match placeholder=\"{{\'agreementPlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"agreements.id as agreements in vm.agreement | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=agreements.name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'serviceLabel\' | translate}} <span style=color:red>*</span></label><div><ui-select ng-model=vm.filterData.service_value name=service required close-on-select=true ng-change=vm.serviceChanged(0)><ui-select-match placeholder=\"{{\'selectTService\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"services.id as services in vm.service | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=services.name></div></ui-select-choices></ui-select><div ng-if=\"filterSharedForm.service.$touched|| submit\" ng-messages=filterSharedForm.service.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'serviceReq\' | translate}}</div></div></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'tripType\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=vm.filterData.typeOfTrip required name=typeOfTrip ng-class=\"{ \'has-error\': filterGroupedForm.typeOfTrip.$touched && filterGroupedForm.typeOfTrip.$invalid }\" ng-change=vm.typeOfTrip(0) ng-options=\"data.id as data.text for data in vm.typeTripFilter\"><option value=\"\" selected disabled>{{\'selectTripType\' | translate}}</option></select><div ng-if=\"filterGroupedForm.typeOfTrip.$touched|| submit\" ng-messages=filterGroupedForm.typeOfTrip.$error><div class=\"errormessage text-danger\" ng-message=required>Please select type of trip.</div></div></div></div><div class=row style=\"padding-top: 10px;padding-bottom: 10px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpDateFromLabel\' | translate}}:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=pickupDate ng-model=vm.filterData.filter_pickup_from_date_value placeholder=\"{{\'pickUpDateLabel\' | translate}}\" is-open=vm.datePicker_1.pickupFromDate datepicker-options=vm.dateOptions close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.pickupFromToDateChanged(1)> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_1(1)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpTimeFromLabel\' | translate}}:</label><div uib-timepicker ng-model=vm.filterData.filter_pickup_from_time_value show-spinners=false class=completed ng-change=vm.pickupFromToTimeChanged(1);vm.changeTime(0) hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpDateToLabel\' | translate}}:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=pickupDate ng-model=vm.filterData.filter_pickup_to_date_value placeholder=\"{{\'pickUpDateLabel\' | translate}}\" is-open=vm.datePicker_1.pickupToDate datepicker-options=vm.dateOptionsT close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.pickupFromToDateChanged(2)> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_1(2)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpTimeToLabel\' | translate}}:</label><div uib-timepicker ng-model=vm.filterData.filter_pickup_to_time_value show-spinners=false class=completed ng-change=vm.pickupFromToTimeChanged(2);vm.changeDropTime(0) hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center mt5\"><button class=\"btn btn-primary\" type=submit style=\"height: 35px;line-height: 20px\">Apply Filter</button> <button class=\"btn btn-danger\" type=button style=\"height: 35px;line-height: 20px\" ng-click=vm.resetFilter(0)>{{\'resetFilterButton\' | translate}}</button></div></div></form></div></div></div><div class=\"row mt10\"><div class=\"newTabs flex\" ng-if=vm.filterData.filterApplied><div style=\"display: flex\"><div class=tabsOnLeft><div ng-class=\"{\'isSelected\': vm.unassignedBookingsTab}\" class=\"tabs leftTab\" ng-click=\"vm.unassignedBookingsTab = true;vm.mapViewTab = false;vm.AsssignedList()\">RESERVAS SIN ASIGNAR (LISTA)</div><div ng-class=\"{\'isSelected\': vm.mapViewTab}\" class=\"tabs rightTab\" ng-click=\"vm.unassignedBookingsTab = false;vm.mapViewTab = true;vm.initializeMap()\">RESERVAS SIN ASIGNAR (MAPA)</div></div><div class=\"col-lg-4 col-xs-12 col-sm-12 col-md-4 align-items-center\"><label for=id-booking class=labels style=\"width: 113px\">Booking ID</label><input type=text name=id-booking class=form-control placeholder=\"Search Booking\" ng-model=vm.idBooking ng-change=vm.searchFilter() maxlength=10></div></div><i class=\"fa fa-minus\" ng-if=vm.upperTabsBody ng-click=\"vm.upperTabsBody = false;\"></i> <i class=\"fa fa-plus\" ng-if=!vm.upperTabsBody ng-click=\"vm.upperTabsBody = true; vm.initializeMap()\"></i></div><div ng-if=\"vm.upperTabsBody && vm.filterData.filterApplied\"><!-- <div class=\"row\" style=\"padding: 15px; display: flex;\"> --><!-- <div class=\"col-lg-4 col-xs-12 col-sm-12 col-md-4 align-items-center\">\n                                <label for=\"id-booking labels\"> Booking ID</label>\n                                <input type=\"text\" name=\"id-booking\" class=\"form-control\" placeholder=\"Search Booking\" ng-model=\"vm.idBooking\" ng-change=\"vm.searchFilter()\"\n                                    maxlength=\"10\">\n                            </div> --><!-- \n                            <div class=\"col-lg-2 col-xs-12 col-sm-12 col-md-2\">\n                                <label for=\"flight-search\">Flight Number</label>\n                                <input type=\"text\" name=\"flight-search\" class=\"form-control\" placeholder=\"Search Flight\" ng-model=\"vm.flightSearchModel\"\n                                    ng-change=\"vm.searchFilter()\" maxlength=\"8\">\n                            </div>\n                            <div class=\"col-lg-2 col-xs-12 col-sm-12 col-md-2\">\n                                <label for=\"nomina-search\">Nomina</label>\n                                <input type=\"text\" name=\"nomina-search\" class=\"form-control\" placeholder=\"Search Nomina\" ng-model=\"vm.nominaSearchModel\"\n                                    ng-change=\"vm.searchFilter()\" maxlength=\"15\">\n                            </div>\n                            <div class=\"col-lg-2 col-xs-12 col-sm-12 col-md-2\">\n                                <label for=\"comuna-search\">Comuna</label>\n                                <input type=\"text\" name=\"comuna-search\" class=\"form-control\" placeholder=\"Search Comuna\" ng-model=\"vm.comunaSearchModel\"\n                                    ng-change=\"vm.searchFilter()\" maxlength=\"50\">\n                            </div> --><!-- <div class=\"col-lg-2 col-xs-12 col-sm-12 col-md-2\">\n                                    <label for=\"discardBookingStatusChange\">Ver descartadas</label>\n                                    <i style=\"font-size: 25px;display: block;line-height: 1.4;\" name=\"discardBookingStatusChange\" ng-click=\"vm.discardBookingStatusChange(vm.discardBookingStatus);\"\n                                    ng-class=\"{\'fa fa-toggle-on\': vm.discardBookingStatus , \'fa fa-toggle-off\': !vm.discardBookingStatus }\"></i>\n                                    </div> --><!-- </div> --><div style=\"display: flex; flex-direction: row\" class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><!-- map view --><div ng-if=vm.mapViewTab class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" id=googleMap style=\"height: 450px\"></div><!-- unassigned bookings --><div ng-if=vm.unassignedBookingsTab class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">Unassigned Bookings <button type=button class=\"pull-right _driver_rating_title_button ng-binding\" ng-click=vm.VolverButton()>Volver a cargar</button> <span class=\"pull-right booking_count\">{{vm.socketCount}}</span></p><div class=basicDetailsDiv><div class=table-responsive id=tableSharedUnassigned><!--style=\"max-height:400px;overflow-y:auto;\" when-scrolled=\"vm.paginationChangedForUnassigned()\"--><table class=\"table tableSharedUnassignedTable\" id=parentTable><!--dnd-external-sources=\"true\" dnd-drop=\"vm.calculateDataAndValidatePackage(index, item, external, type)\"\n                    dnd-list=\"vm.filterData.unassignedBookingList\"\n                    dnd-drop=\"vm.dropedAreaBack(item)\"--><thead><tr><td style=width:61px>Actions</td><td style=width:39px><!-- Actions --></td><th style=\"width: 61px\" table-column-sorting current-text=vm.filterData.unassignedPredicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.filterData.unassignedReverse>{{\'serialNumber\' | translate}}</th><th style=\"width: 39px\" table-column-sorting current-text=vm.filterData.unassignedPredicate title=ID text=\"\'job_id\'\" check=vm.filterData.unassignedReverse>ID</th><th style=\"width: 88px\" table-column-sorting current-text=vm.filterData.unassignedPredicate title=Agreement text=\"\'name\'\" check=vm.filterData.unassignedReverse>Agreement</th><th style=\"width: 64px\" table-column-sorting current-text=vm.filterData.unassignedPredicate title=Pickup text=\"\'original_pickup_datetime\'\" check=vm.filterData.unassignedReverse>Pickup</th><th style=\"width: 78px\" table-column-sorting current-text=vm.filterData.unassignedPredicate title=Tolerance text=\"\'time_with_tolerance\'\" check=vm.filterData.unassignedReverse>Tolerance</th><th style=\"width: 91px\" table-column-sorting current-text=vm.filterData.unassignedPredicate title=Presentation text=\"\'original_delivery_datetime\'\" check=vm.filterData.unassignedReverse>Presentation</th><th style=\"width: 44px\" table-column-sorting current-text=vm.filterData.unassignedPredicate title=ETA text=\"\'original_eta\'\" check=vm.filterData.unassignedReverse>ETA</th><th style=\"width: 41px\" table-column-sorting current-text=vm.filterData.unassignedPredicate title=Pax text=\"\'number_of_passangers\'\" check=vm.filterData.unassignedReverse>Pax</th><th style=\"width: 94px\" ng-if=\"vm.filterData.typeOfTrip != \'Z\'\" table-column-sorting current-text=vm.filterData.unassignedPredicate title=\"Pickup Location\" text=\"\'job_pickup_address\'\" check=vm.filterData.unassignedReverse>Pickup Location</th><th style=\"width: 94px\" ng-if=\"vm.filterData.typeOfTrip == \'Z\'\" table-column-sorting current-text=vm.filterData.unassignedPredicate title=\"DropOff Location\" text=\"\'job_address\'\" check=vm.filterData.unassignedReverse>DropOff Location</th><th style=\"width: 94px\" table-column-sorting current-text=vm.filterData.unassignedPredicate title=Nomina text=\"\'nomina\'\" check=vm.filterData.unassignedReverse>Bloqueada por</th><!-- <th style=\"width: 94px;\" table-column-sorting current-text=\"vm.filterData.unassignedPredicate\" title=\"Pickup Location\" text=\"\'job_pickup_address\'\" check=\"vm.filterData.unassignedReverse\">\n                    Flight Number\n                    </th> --></tr></thead><tbody style=\"height: 300px !important ; min-height: 0\" class=apps-container when-scrolled=vm.paginationChangedForUnassigned() ng-model=vm.filterData.unassignedBookingList><tr class=app ng-repeat=\"data in vm.filterData.unassignedBookingList | orderBy:vm.filterData.unassignedPredicate:vm.filterData.unassignedReverse\" ng-class=\"{\'not-sortable\': data.job_status == 1 || data.job_status == 2,\'ColorGrey\': data.locking_id != null}\" ng-attr-id=\"{{data.job_id + \'-\' + data.number_of_passangers}}}\"><!--dnd-moved=\"vm.filterData.unassignedBookingList.splice($index, 1)\"\n                    dnd-draggable=\"data\" dnd-effect-allowed=\"move\"\n                    dnd-dragend=\"vm.calculateDataAndValidatePackage()\"\n                    dnd-dragstart=\"vm.onDragstart(item, event)\" dnd-disable-if=\"data.job_status == 1 || data.job_status == 2\"--><td style=width:61px ng-if=\"data.locking_id == null\"><i class=\"fa fa-arrow-down\" style=\"font-size:20px;color: #63d8f2\" ng-click=vm.click1(data,$index)></i></td><td style=width:61px ng-if=\"data.locking_id != null\"><button class=Desbloquear ng-click=\"vm.blockUnblockBooking(data.job_id,\'popUp\')\">Desbloquear</button></td><td style=\"width: 39px;color:#1A7EF6;font-weight: bold\" ng-if=\"data.is_routing == 1 && data.routing_auto == 1\">Rou<br>ting</td><td style=\"width: 39px;color:#E5820A;font-weight: bold\" ng-if=\"data.is_routing == 1 && data.routing_auto == 0\">Man<br>ual</td><td style=\"width: 39px;color:#1A7EF6;font-weight: bold\" ng-if=\"data.is_routing == 0 \"></td><td style=\"width: 61px\">{{$index + 1}}</td><td style=\"width: 39px\">#{{data.job_id}}</td><td style=\"width: 88px\">{{data.name}}</td><td style=\"width: 64px\">{{data.original_pickup_datetime | date:\'dd MMM, HH:mm\'}}</td><td style=\"width: 78px\">{{data.time_with_tolerance_before | date:\'HH:mm\'}} - {{data.time_with_tolerance_after | date:\'HH:mm\'}}</td><td style=\"width: 91px\">{{data.original_delivery_datetime | date:\'dd MMM, HH:mm\'}}</td><td style=\"width: 44px\">{{data.original_eta}}</td><td style=\"width: 41px\">{{data.number_of_passangers}}</td><td style=\"width: 94px\">{{data.job_pickup_address}}</td><td style=\"width: 94px\">{{data.locking_id_name || \'--\'}}</td><!-- <td style=\"width: 94px;\" ng-if=\"data.flight_number == null\">--</td>\n                    <td style=\"width: 94px;\" ng-if=\"data.flight_number != null\">{{data.flight_number}}</td> --></tr></tbody></table></div><div><p class=text-right><b>{{vm.filterData.unassignedBookingCount}} Bookings</b></p></div></div></div></div></div><!-- FILTERS FOR PACKAGE --><div class=\"col-lg-12 col-sm-12 col-xs-12 row m0\" style=\"margin-top: 20px !important\"><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"border:1px solid #dedede;padding:0px\"><h2 class=\"text-center filtersStyle\" ng-click=\"(vm.filterData.makePackageList.length > 0 && vm.bookingsAssignmentTab) ? (checkClickedPackage = false) : (checkClickedPackage = !checkClickedPackage); vm.slideDataPackage()\">Package Filters <span class=fa ng-class=\"{\'fa-caret-down\': checkClickedPackage,\'fa-caret-up\': !checkClickedPackage }\"></span></h2><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" id=packageFilter><form name=filterSharedFormPackage ng-submit=\"submitPackage=true;filterSharedFormPackage.$valid&&vm.applyFilterPackage(\'blank\')\" novalidate autocomplete=off><div class=row style=\"padding-top: 10px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'branchLabel\' | translate}} <span style=color:red>*</span></label><div><ui-select ng-model=vm.filterData.branch_value_package name=branch ng-change=vm.branchChanged(1) required close-on-select=true ng-class=\"{ \'has-error\': filterSharedFormPackage.branch.$touched && filterSharedFormPackage.branch.$invalid }\"><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search\"><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select><div ng-if=\"filterSharedFormPackage.branch.$touched|| submitPackage\" ng-messages=filterSharedFormPackage.branch.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'branchR\' | translate}}</div></div></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'agreementLabel\' | translate}} <span style=color:red>*</span></label><div><ui-select ng-model=vm.filterData.aggrement_value_package name=agreement ng-change=vm.agreementChanged(1) required close-on-select=true><ui-select-match placeholder=\"{{\'agreementPlaceholder\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"agreements.id as agreements in vm.agreement | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=agreements.name></div></ui-select-choices></ui-select></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'serviceLabel\' | translate}} <span style=color:red>*</span></label><div><ui-select ng-model=vm.filterData.service_value_package name=service required close-on-select=true ng-change=vm.serviceChanged(1)><ui-select-match placeholder=\"{{\'selectTService\' | translate}}\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"services.id as services in vm.service | filter: $select.search | orderBy:\'name\' \"><div ng-bind-html=services.name></div></ui-select-choices></ui-select><div ng-if=\"filterSharedFormPackage.service.$touched|| submitPackage\" ng-messages=filterSharedFormPackage.service.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'serviceReq\' | translate}}</div></div></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'tripType\' | translate}} <span style=color:red>*</span></label><select class=form-control ng-model=vm.filterData.typeOfTripPackage required name=typeOfTrip ng-class=\"{ \'has-error\': filterGroupedForm.typeOfTrip.$touched && filterGroupedForm.typeOfTrip.$invalid }\" ng-change=vm.typeOfTrip(1) ng-options=\"data.id as data.text for data in vm.typeTripFilter\"><option value=\"\" selected disabled>{{\'selectTripType\' | translate}}</option></select><div ng-if=\"filterGroupedForm.typeOfTrip.$touched|| submitPackage\" ng-messages=filterGroupedForm.typeOfTrip.$error><div class=\"errormessage text-danger\" ng-message=required>Please select type of trip.</div></div></div></div><div class=row style=\"padding-top: 10px;padding-bottom: 10px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpDateFromLabel\' | translate}}:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=pickupDate ng-model=vm.filterData.filter_pickup_from_date_value_package placeholder=\"{{\'pickUpDateLabel\' | translate}}\" is-open=vm.datePicker_1.pickupFromDatePackage datepicker-options=vm.dateOptions close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.pickupFromToDateChanged(3)> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_1(3)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpTimeFromLabel\' | translate}}:</label><div uib-timepicker ng-model=vm.filterData.filter_pickup_from_time_value_package show-spinners=false class=completed ng-change=vm.pickupFromToTimeChanged(1);vm.changeTime(1) hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpDateToLabel\' | translate}}:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=pickupDate ng-model=vm.filterData.filter_pickup_to_date_value_package placeholder=\"{{\'pickUpDateLabel\' | translate}}\" is-open=vm.datePicker_1.pickupToDatePackage datepicker-options=vm.dateOptionsT close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.pickupFromToDateChanged(4)> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_1(4)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpTimeToLabel\' | translate}}:</label><div uib-timepicker ng-model=vm.filterData.filter_pickup_to_time_value_package show-spinners=false class=completed ng-change=vm.pickupFromToTimeChanged(2);vm.changeDropTime(1) hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center mt5\"><button class=\"btn btn-primary\" type=submit style=\"height: 35px;line-height: 20px\">Apply Filter</button> <button class=\"btn btn-danger\" type=button style=\"height: 35px;line-height: 20px\" ng-click=vm.resetFilter(1)>{{\'resetFilterButton\' | translate}}</button></div></div></form></div></div></div><div class=\"newTabs flex\" ng-if=vm.filterData.filterAppliedPackage><div style=\"display: flex\"><div class=tabsOnLeft style=\"margin-right: 2px\"><div ng-class=\"{\'isSelected\': vm.servicesCreatedTab}\" class=\"tabs leftTab\" ng-click=\"vm.servicesCreatedTab = true; vm.bookingsAssignmentTab = false;vm.getPackageSection(false)\">SERVICIOS CREADOS</div><div ng-class=\"{\'isSelected\': vm.bookingsAssignmentTab}\" class=\"tabs rightTab\" ng-click=\"vm.servicesCreatedTab = false; vm.bookingsAssignmentTab = true;vm.getPackageSection(true)\">CREAR SERVICIOS</div></div><div ng-if=!vm.bookingsAssignmentTab class=display-flex><div class=\"col-lg-2 col-xs-12 col-sm-12 col-md-2 d-flex\"><label class=labels for=booking>Booking ID</label><input type=text name=booking class=form-control placeholder=\"Search Booking\" ng-model=vm.booking ng-change=vm.serviceFilterData() maxlength=10></div><div class=\"col-lg-2 col-xs-12 col-sm-12 col-md-2 d-flex\"><label class=labels for=id-packets>ID Packete</label><input type=text name=id-packete class=form-control placeholder=\"Search ID Packete\" ng-model=vm.idPackete ng-change=vm.serviceFilterData() maxlength=8></div><div class=\"col-lg-2 col-xs-12 col-sm-12 col-md-2 d-flex\"><label class=labels for=vehicle-search>Vehiculo</label><input type=text name=vehicle-search class=form-control placeholder=\"Search Vehicle\" ng-model=vm.vehicleSearch ng-change=vm.serviceFilterData() maxlength=15></div></div></div><i class=\"fa fa-minus\" ng-if=vm.lowerTabsBody ng-click=\"vm.lowerTabsBody = false\"></i> <i class=\"fa fa-plus\" ng-if=!vm.lowerTabsBody ng-click=\"vm.lowerTabsBody = true;\"></i></div><div style=\"display: flex; flex-direction: row\" ng-if=\"vm.lowerTabsBody && vm.filterData.filterAppliedPackage\"><!-- services created --><div ng-if=vm.servicesCreatedTab class=\"packageCreated mt10 col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=servicesCreated><p>Services Created ({{vm.filterData.createdBookingCount}})</p></div><div class=table-responsive id=packageMade><!--style=\"max-height:200px;overflow-y:auto;\"--><table class=table id=packageMadeTable style=\"margin-bottom: 0px\"><thead><tr><th style=width:30px><!-- {{\'serialNumber\' | translate}} --></th><th style=width:70px>{{\'serialNumber\' | translate}}</th><th style=\"width: 70px\" table-column-sorting current-text=vm.filterData.createdPredicate title=ID text=\"\'shared_service_id\'\" check=vm.filterData.createdReverse>ID</th><th style=\"width: 50px\" table-column-sorting current-text=vm.filterData.createdPredicate title=BK text=\"\'total_bookings\'\" check=vm.filterData.createdReverse>BK</th><th style=\"width: 50px\" table-column-sorting current-text=vm.filterData.createdPredicate title=PAX text=\"\'pax\'\" check=vm.filterData.createdReverse>PAX</th><th style=\"width: 60px\" table-column-sorting current-text=vm.filterData.createdPredicate title=Time text=\"\'eta\'\" check=vm.filterData.createdReverse>Time</th><th style=\"width: 105px\" table-column-sorting current-text=vm.filterData.createdPredicate title=\"First Booking\" text=\"\'first_pickup_time\'\" check=vm.filterData.createdReverse>First Booking</th><th style=\"width: 80px\" table-column-sorting current-text=vm.filterData.createdPredicate title=Address text=\"\'first_pickup_address\'\" check=vm.filterData.createdReverse>Address</th><th style=width:80px table-column-sorting current-text=vm.filterData.createdPredicate title=Móvil text=\"\'unique_car_id\'\" check=vm.filterData.createdReverse>Móvil</th><th style=\"width: 80px\" table-column-sorting current-text=vm.filterData.createdPredicate title=Status text=\"\'status\'\" check=vm.filterData.createdReverse>Status</th><th style=\"width: 230px\">Action</th></tr></thead><tbody ng-if=\"vm.filterData.createdBookingCount > 0\" when-scrolled=vm.paginationChangedForCreated()><tr ng-repeat=\"data in vm.filterData.createdBookingList | orderBy:vm.filterData.createdPredicate:vm.filterData.createdReverse\"><!--ng-class=\"{\'redColorShared\':data.status == 1}\"--><td style=\"width: 30px;font-weight: bold;color:#1A7EF6\" ng-if=\"data.planificador_package_id != 0\">ROU<br>TING</td><td style=\"width: 30px\" ng-if=\"data.planificador_package_id == 0\"></td><td style=\"width: 70px\">{{$index + 1}}</td><td style=\"width: 70px\">#{{data.shared_service_id}}</td><td style=\"width: 50px\">{{data.total_bookings}}</td><td style=\"width: 50px\">{{data.pax || 0}}</td><td style=\"width: 60px\">{{data.eta}}</td><td style=\"width: 105px\">{{data.first_pickup_time | date:\'dd MMM, HH:mm\'}}</td><td style=\"width: 80px\">{{data.first_pickup_address || \'--\'}}</td><td style=\"width: 80px\"><span ng-if=data.unique_car_id>{{data.unique_car_id}}</span> <span ng-if=!data.unique_car_id>sin assignar</span></td><!--0 - upcoming,1 - started, 2 - ended, 3 - failed, 4 - arrived, 5 - partial, 6 - unassigned,7 - Accepted, 8 - Decline, 9 - Cancel, 15-ONROAD--><td style=\"width: 80px\"><span ng-if=\"data.status == 0\">{{\'upcomingStatus\' | translate}}</span> <span ng-if=\"data.status == 1\">Viaje Iniciado</span> <span ng-if=\"data.status == 2\">Completada</span> <span ng-if=\"data.status == 3\">Failed</span> <span ng-if=\"data.status == 4\">En Posición</span> <span ng-if=\"data.status == 5\">Partial</span> <span ng-if=\"data.status == 6\">No Asignada</span> <span ng-if=\"data.status == 7\">Accepted</span> <span ng-if=\"data.status == 8\">Decline</span> <span ng-if=\"data.status == 9\">Cancelada</span> <span ng-if=\"data.status == 15\">Onroad</span></td><td style=\"width: 230px\"><a title=view class=\"cursor editIconColor btn btn-sm\" ng-click=\"vm.modifyBooking(data,\'veiw\')\"><i class=\"fa fa-eye\"></i> </a><a title=Assignar style=background-color:#7ed321;color:white class=\"cursor editIconColor btn btn-sm\" ng-disabled=data.unique_car_id ng-click=vm.assignBookings(data,$event)><span>A</span> </a><a title=Deassignar style=background-color:#e41b35;color:white class=\"cursor editIconColor btn btn-sm\" ng-disabled=!data.unique_car_id ng-click=vm.unassignBooking(data,$event)><span>D</span> </a><a title=Modificar class=\"cursor editIconColor btn btn-sm\" ng-click=\"vm.modifyBooking(data,\'edit\')\"><i class=\"fa fa-edit\"></i> </a><!--ng-disabled=\"data.status == 1 || data.status == 2 || data.status == 3 || data.status == 9\" --> <a title=Delete class=\"cursor editIconColor btn btn-sm\" ng-click=vm.deletePackage(data)><i class=\"fa fa-trash-o\"></i> </a><!-- <i class=\"fa fa-search\" style=\"font-size: 20px;\"></i> --></td></tr></tbody><tfoot ng-if=\"vm.filterData.createdBookingCount == 0\"><tr><td colspan=10 class=text-center>Nothing Found</td></tr></tfoot></table></div></div><!-- Bookings Assignment to Service (NEW) --><div ng-if=vm.bookingsAssignmentTab class=\"mt10 col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=bookingPackageMade><p class=bookingAssignmentText>Bookings Assignment to Service ({{vm.filterData.sharedServiceName}})</p><p class=bookingAssignmementServiceText>{{ vm.nameForShow}} 1-{{ vm.maxForShow}}</p><div class=\"row assingnedPasseneger1\"><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12 assingnedPasseneger2\"><p class=assingnedPasseneger>Total Pax: {{vm.filterData.totalPassengerAssigned}}</p></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12 assingnedPasseneger2\"><p class=assingnedPasseneger>Total Bookings: {{vm.filterData.totalBookingAssigned}}</p></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-12 assingnedPasseneger2\"><p class=assingnedPasseneger>Total Trip Time: {{vm.filterData.totalAssignedETA}}min</p></div></div><div class=tableView><div class=table-responsive id=tableSharedAssigned><!--style=\"max-height:400px;overflow-y:auto;\"--><table class=\"table tableSharedAssignedTable\" id=dropTable><!--dnd-external-sources=\"true\" dnd-drop=\"vm.calculateDataAndValidatePackage(index, item, external, type)\"\n                                                        dnd-list=\"vm.filterData.makePackageList\"\n                                                           dnd-drop=\"vm.dropedArea(item,index,event)\"--><thead><tr><th style=width:61px>Actions</th><th style=width:39px><!-- Actions --></th><th hidden style=\"width: 61px\" table-column-sorting current-text=vm.filterData.makePackagePredicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.filterData.makePackageReverse>{{\'serialNumber\' | translate}}</th><th style=\"width: 50px\" table-column-sorting current-text=vm.filterData.makePackagePredicate title=ID text=\"\'job_id\'\" check=vm.filterData.makePackageReverse>ID</th><th style=\"width: 90px\" table-column-sorting current-text=vm.filterData.makePackagePredicate title=Agreement text=\"\'name\'\" check=vm.filterData.makePackageReverse>Agreement</th><th style=\"width: 65px\" table-column-sorting current-text=vm.filterData.makePackagePredicate title=Pickup text=\"\'original_pickup_datetime\'\" check=vm.filterData.makePackageReverse>Pickup</th><th style=\"width: 80px\" table-column-sorting current-text=vm.filterData.makePackagePredicate title=Tolerance text=\"\'time_with_tolerance\'\" check=vm.filterData.makePackageReverse>Tolerance</th><th style=\"width: 95px\" table-column-sorting current-text=vm.filterData.makePackagePredicate title=Presentation text=\"\'original_delivery_datetime\'\" check=vm.filterData.makePackageReverse>Present.</th><th style=\"width: 46px\" table-column-sorting current-text=vm.filterData.makePackagePredicate title=ETA text=\"\'original_eta\'\" check=vm.filterData.makePackageReverse>ETA</th><th style=\"width: 86px\" table-column-sorting current-text=vm.filterData.makePackagePredicate title=\"New Pickup\" text=\"\'job_time_new\'\" check=vm.filterData.makePackageReverse>New Pickup</th><th style=\"width: 110px\" table-column-sorting current-text=vm.filterData.makePackagePredicate title=\"New Presentation\" text=\"\'job_dropoff_utc_new\'\" check=vm.filterData.makePackageReverse>New Present.</th><th style=\"width: 62px\" table-column-sorting current-text=vm.filterData.makePackagePredicate title=\"New ETA\" text=\"\'newEta\'\" check=vm.filterData.makePackageReverse>New ETA</th><th style=\"width: 37px\" table-column-sorting current-text=vm.filterData.makePackagePredicate title=Pax text=\"\'number_of_passangers\'\" check=vm.filterData.makePackageReverse>Pax</th><th style=\"width: 86px\" ng-if=\"vm.filterData.typeOfTrip != \'Z\'\" table-column-sorting current-text=vm.filterData.makePackagePredicate title=\"Pickup Location\" text=\"\'job_pickup_address\'\" check=vm.filterData.makePackageReverse>Pickup Location</th><th style=\"width: 86px\" ng-if=\"vm.filterData.typeOfTrip == \'Z\'\" table-column-sorting current-text=vm.filterData.makePackagePredicate title=\"DropOff Location\" text=\"\'job_address\'\" check=vm.filterData.makePackageReverse>DropOff Location</th><!-- <th style=\"width: 94px;\" table-column-sorting current-text=\"vm.filterData.unassignedPredicate\" title=\"Pickup Location\" text=\"\'job_pickup_address\'\" check=\"vm.filterData.unassignedReverse\">\n                                                                Flight Number\n                                                            </th> --></tr></thead><tbody class=apps-container ui-sortable=vm.sortableOptions ng-model=vm.filterData.makePackageList><tr class=app ng-repeat=\"data in vm.filterData.makePackageList | orderBy:vm.filterData.makePackagePredicate:vm.filterData.makePackageReverse\" ng-class=\"{\'shredServiceRed\': !data.is_valid_tolerance || data.greater_delivery_time,\'shredServiceWhite\':data.is_valid_tolerance || !data.greater_delivery_time\n                                                            ,\'not-sortable\': data.job_status == 1 || data.job_status == 2}\" ng-attr-id=\"{{data.job_id + \'-\' + data.number_of_passangers}}\"><!--dnd-moved=\"vm.filterData.makePackageList.splice($index, 1)\"\n                                                             dnd-draggable=\"data\" dnd-effect-allowed=\"move\"\n                                                            dnd-dragend=\"vm.calculateDataAndValidatePackage()\" dnd-disable-if=\"data.job_status == 1 || data.job_status == 2\"--><td style=width:61px><i class=\"fa fa-arrow-up\" style=\"font-size: 20px;color: #63d8f2\" ng-click=vm.click2(data,$index)></i></td><td style=\"width: 39px;color:#1A7EF6;font-weight: bold\" ng-if=\"data.is_routing == 1\">Rou<br>ting</td><td style=\"width: 39px;color:#1A7EF6;font-weight: bold\" ng-if=\"data.is_routing == 0\"></td><td hidden style=\"width: 61px\">{{$index + 1}}</td><td style=\"width: 50px\">#{{data.job_id}}</td><td style=\"width: 90px\">{{data.name}}</td><td style=\"width: 65px\">{{data.original_pickup_datetime | date:\'dd MMM, HH:mm\'}}</td><td style=\"width: 80px\">{{data.time_with_tolerance_before | date:\'HH:mm\'}} - {{data.time_with_tolerance_after | date:\'HH:mm\'}}</td><td style=\"width: 95px\">{{data.original_delivery_datetime | date:\'dd MMM, HH:mm\'}}</td><td style=\"width: 46px\">{{data.original_eta}}</td><td style=\"width: 86px\">{{data.job_time_new | date:\'dd MMM, HH:mm\'}}</td><td style=\"width: 110px\">{{data.job_dropoff_utc_new | date:\'dd MMM, HH:mm\'}}</td><td style=\"width: 62px\" ng-if=\"vm.filterData.modifyFlag == false\">{{data.newEta}}</td><td style=\"width: 62px\" ng-if=\"vm.filterData.modifyFlag == true\">{{data.newDataEta}}</td><td style=\"width: 37px\">{{data.number_of_passangers}}</td><td style=\"width: 86px\">{{data.job_pickup_address}}</td><!-- <td style=\"width: 94px;\" ng-if=\"data.flight_number == null\">--</td>\n                                                            <td style=\"width: 94px;\" ng-if=\"data.flight_number != null\">{{data.flight_number}}</td> --></tr></tbody></table></div></div><div class=\"row serviceDetails1\"><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12 serviceDetails2\"><p class=serviceDetails>Service #: {{vm.filterData.sharedServiceName}}</p></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12 serviceDetails2\"><p class=serviceDetails>Móvil Assigned: {{vm.filterData.vehicleAssigned}}</p></div></div><div class=\"row m0\" style=\"border-top: 2px solid #063c4a;padding-top:5px;padding-bottom: 5px\" ng-if=\"vm.filterData.makePackageList.length > 0 && !vm.filterData.modifyFlag\"><div class=\"col-lg-12 col-xs-12 col-ms-12 col-md-12 text-center\"><button ng-disabled=vm.showButtonSave type=button class=\"btn btn-primary\" ng-click=vm.saveSharedPackage()>SAVE</button> <button ng-disabled=vm.showButtonSave type=button class=\"btn btn-primary\" ng-click=vm.newPackage()>NEW</button></div></div><div class=\"row m0\" style=\"border-top: 2px solid #063c4a;padding-top:5px;padding-bottom: 5px\" ng-if=vm.filterData.modifyFlag><div class=\"col-lg-12 col-xs-12 col-ms-12 col-md-12 text-center\" ng-if=!vm.showButtonSave><button type=button class=\"btn btn-primary\" ng-if=vm.filterData.modifyFlag ng-click=vm.saveModifySharedPackage()>SAVE</button> <button type=button class=\"btn btn-primary\" ng-click=vm.newPackage()>NEW</button></div><div class=\"col-lg-12 col-xs-12 col-ms-12 col-md-12 text-center\" ng-if=vm.showButtonSave><button type=button class=\"btn btn-primary\" ng-if=vm.filterData.modifyFlag ng-click=\"vm.servicesCreatedTab = true; vm.bookingsAssignmentTab = false;vm.getPackageSection(false);vm.clickOk()\">OK</button><!-- <button  type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.newPackage()\">NEW</button> --></div></div></div></div></div></div></div></div></div><style type=text/css>.labelsMap {\n        color: red;\n        background-color: cornsilk;\n        font-family: \"Lucida Grande\", \"Arial\", sans-serif;\n        font-size: 10px;\n        font-weight: bold;\n        text-align: center;\n        width: 40px;\n        white-space: nowrap;\n    }</style>");
$templateCache.put("app/components/views/shared-service/sharedServiceRouteAssignmentMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/special-directions/specialDirections.html","<h2 class=ng-cloak>Direcciones Especiales</h2><div class=\"ng-cloak container-fluid\" id=sharedScreen ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-xs-12 col-md-12\" style=\"border:1px solid #dedede;padding:0px\" ng-init=\"checkClicked = true\"><h2 class=\"text-center filtersStyle\" ng-click=\"checkClicked = !checkClicked; vm.slideData()\">Filters <span class=fa ng-class=\"{\'fa-caret-down\': checkClicked,\'fa-caret-up\': !checkClicked }\"></span></h2><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" id=derp><div class=row style=\"padding-top: 10px\"><div class=\"col-sm-3 col-md-3 col-lg-3 mt10\"><div style=\"float: left\"><label class=control-label>Estado</label><select class=form-control ng-model=vm.selectedEstadoOptions ng-init=\"vm.selectedEstadoOptions = vm.estadoOptions[0].id\" ng-options=\"option.id as option.name for option in vm.estadoOptions\" ng-change=vm.selectedEstadoOptionsChange()></select></div></div><div class=\"col-sm-3 col-md-3 col-lg-3 mt10\"><label class=control-label>Nro Reserva</label><div class=input-group><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchBookingId\' | translate}}\" is-number=\"\" ng-model-options=\"{ debounce: 500 }\" ng-model=vm.filterData.searchBookingId ng-change=vm.getFilterBookingId(vm.filterData.searchBookingId)></div></div></div><div class=row style=\"padding-top: 10px;padding-bottom: 10px\"><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpDateFromLabel\' | translate}}:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=pickupDate ng-model=vm.filterData.filter_pickup_from_date_value placeholder=\"{{\'pickUpDateLabel\' | translate}}\" is-open=vm.datePicker_1.pickupFromDate datepicker-options=vm.dateOptions close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.pickupFromToDateChanged(1)> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_1(1)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpTimeFromLabel\' | translate}}:</label><div uib-timepicker ng-model=vm.filterData.filter_pickup_from_time_value show-spinners=false class=completed ng-change=vm.pickupFromToTimeChanged(1) hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian></div></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpDateToLabel\' | translate}}:</label><p class=input-group><input type=text class=form-control uib-datepicker-popup={{vm.format}} name=pickupDate ng-model=vm.filterData.filter_pickup_to_date_value placeholder=\"{{\'pickUpDateLabel\' | translate}}\" is-open=vm.datePicker_1.pickupToDate datepicker-options=vm.dateOptionsT close-text=Close alt-input-formats=vm.altInputFormats show-button-bar=false readonly ng-change=vm.pickupFromToDateChanged(2)> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=vm.datePickerE_1(2)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"><label>{{\'pickUpTimeToLabel\' | translate}}:</label><div uib-timepicker ng-model=vm.filterData.filter_pickup_to_time_value show-spinners=false class=completed ng-change=vm.pickupFromToTimeChanged(2) hour-step=vm.hstep minute-step=vm.mstep show-meridian=vm.ismeridian></div></div><!-- <div class=\"col-lg-3 col-sm-4 col-md-3 col-xs-4\"> --><!-- <button class=\"btn btn-primary\" style=\"height: 35px;line-height: 20px;margin-top:25px;\" ng-click=\"vm.resetFilter()\">{{\'resetFilterButton\' | translate}}</button> --><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center mt5\"><button class=\"btn btn-primary\" type=button style=\"height: 35px;line-height: 20px\" ng-click=vm.applyFilter()>Apply Filter</button> <button class=\"btn btn-danger\" type=button style=\"height: 35px;line-height: 20px\" ng-click=vm.resetFilter()>{{\'resetFilterButton\' | translate}}</button></div><!-- </div> --></div></div></div><button class=\"btn btn-primary tableButton addButton\" style=\"float: right\" ng-click=vm.addSpecialDirections()>+ Agregar Dirección Especial</button><!-- ng-if=\"vm.showAddSpecialDirectionContent\" --><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"padding: 0px 30px\" id=showAddSpecialDirectionContentSlide><h1 class=headerInDirections ng-if=!vm.modifyBooking>Agregar nueva dirección especial</h1><h1 class=headerInDirections ng-if=vm.modifyBooking>Modificar dirección especial</h1><div ng-if=!vm.modifyBooking class=\"row headerInDirectionsRow\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"col-lg-6 col-md-6 col-sm-6\"><label for=Dirección>Dirección</label><input type=text class=form-control placeholder=Dirección ng-model=vm.specialDirection.directions maxlength=70></div><div class=\"col-lg-6 col-md-6 col-sm-6\"><label for=Longitud>Longitud</label><input type=text step=0.01 class=form-control placeholder=Longitud ng-model=vm.specialDirection.longitude maxlength=20></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"col-lg-6 col-md-6 col-sm-6\"><label for=Latitud>Latitud</label><input type=text step=0.01 class=form-control placeholder=Latitud ng-model=vm.specialDirection.latitute maxlength=20></div><div class=\"col-lg-6 col-md-6 col-sm-6\"><label class=control-label>Estado</label><!-- <select class=\"form-control\" ng-model=\"vm.selectedEstadoOptionsInAdd\" ng-change=\"vm.selectedEstadoOptionsChange()\">\n                                                    <option ng-repeat=\"pages in vm.estadoOptions\" value=\"{{pages.id}}\">{{pages.name}}</option>\n                                                </select> --><select class=form-control ng-model=vm.selectedEstadoOptionsInAdd ng-init=\"vm.selectedEstadoOptionsInAdd = vm.selectedIndex\" ng-options=\"option.id as option.name for option in vm.estadoOptions\"></select></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"text-align: center;margin: 26px 0px\"><button class=\"btn btn-primary tableButton\" ng-click=vm.addSpecialDirectionsAPI()>Grabar</button><!-- <button class=\"btn btn-primary tableButton\" ng-click=\"vm.editSpecialAddressAPI()\" ng-if=\"vm.modifyBooking\">\n                                Submit\n                            </button> --> <button class=\"btn btn-primary tableButton\" style=\"background-color: #FF0004;border-color: #FF0004\" ng-click=vm.closeSpecialDirections()>Cancelar</button></div></div><div ng-if=vm.modifyBooking class=\"row headerInDirectionsRow\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"col-lg-6 col-md-6 col-sm-6\"><label for=Dirección>Dirección</label><input type=text disabled class=form-control placeholder=Dirección ng-model=vm.specialDirection.directions maxlength=70></div><div class=\"col-lg-6 col-md-6 col-sm-6\"><label for=Dirección>Dirección Correcta</label><input type=text class=form-control ng-model=vm.specialDirection.correctAddress ng-change=vm.addressChange(vm.specialDirection.correctAddress) id=correctDirection placeholder=\"Dirección Correcta\"></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"col-lg-4 col-md-4 col-sm-6\"><label for=Longitud>Longitud</label><input type=text class=form-control placeholder=Longitud ng-model=vm.specialDirection.longitude maxlength=20></div><div class=\"col-lg-4 col-md-4 col-sm-6\"><label for=Latitud>Latitud</label><input type=text class=form-control placeholder=Latitud ng-model=vm.specialDirection.latitute maxlength=20></div><div class=\"col-lg-4 col-md-4 col-sm-4\"><label class=control-label>Estado</label><!-- <select class=\"form-control\" ng-model=\"vm.selectedEstadoOptionsInAdd\" ng-change=\"vm.selectedEstadoOptionsChange()\">\n                                                    <option ng-repeat=\"pages in vm.estadoOptions\" value=\"{{pages.id}}\">{{pages.name}}</option>\n                                                </select> --><select class=form-control ng-model=vm.selectedEstadoOptionsInAdd ng-init=\"vm.selectedEstadoOptionsInAdd = vm.selectedIndex\" ng-options=\"option.id as option.name for option in vm.estadoOptions\"></select></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" style=\"text-align: center;margin: 26px 0px\"><!-- <button class=\"btn btn-primary tableButton\" ng-click=\"vm.addSpecialDirectionsAPI()\">\n                        Grabar\n                    </button> --> <button class=\"btn btn-primary tableButton\" ng-click=vm.editSpecialAddressAPI() ng-if=vm.modifyBooking>Grabar</button> <button class=\"btn btn-primary tableButton\" style=\"background-color: #FF0004;border-color: #FF0004\" ng-click=vm.closeSpecialDirections()>Cancelar</button></div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center paddingZero\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-3 col-md-3 col-lg-3 mt10\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model-options=\"{ debounce: 500 }\" ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-6 col-md-6 col-lg-6\"></div><div class=\"col-sm-3 col-md-3 col-lg-3 text-left\"><div><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div></div><div class=\"table-responsive tableWithMasterDataParentDive\"><!--ng-switch=\"(vm.upcomingBookingList | filter:vm.search).length\"--><!--<div ng-switch-when=\"0\" class=\"noSearch\"><span>{{\'nothingFound\' | translate}}</span></div>--><table class=\"table table-hover tableWithMasterData\"><!--ng-switch-default--><thead><tr><!-- <th style=\"width:70px;\" table-column-sorting current-text=\"vm.predicate\" title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\"\n                                                check=\"vm.reverse\">\n                                                {{\'serialNumber\' | translate}}\n                                            </th> --><th style=width:105px table-column-sorting current-text=vm.predicate title=Id text=\"\'job_id\'\" check=vm.reverse>Id</th><th style=width:105px table-column-sorting current-text=vm.predicate title=Booking text=\"\'booking\'\" check=vm.reverse>Booking</th><th style=width:105px table-column-sorting current-text=vm.predicate title=Dirección text=\"\'is_vip\'\" check=vm.reverse>Dirección</th><th style=width:105px table-column-sorting current-text=vm.predicate title=\"Dirección Correcta\" text=\"\'correct_direction\'\" check=vm.reverse>Dirección Correcta</th><th style=width:105px table-column-sorting current-text=vm.predicate title=Latitude text=\"\'job_time\'\" check=vm.reverse>Latitud</th><th style=width:115px table-column-sorting current-text=vm.predicate title=Longitude text=\"\'transport_details\'\" check=vm.reverse>Longitud</th><th style=width:115px table-column-sorting current-text=vm.predicate title=Estado text=\"\'number_of_passangers\'\" check=vm.reverse>Estado</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"fecha Creación\" text=\"\'created_by\'\" check=vm.reverse>Fecha Creación</th><th style=\"width: 150px\" table-column-sorting current-text=vm.predicate title=\"fecha ultima modification\" text=\"\'job_pickup_name\'\" check=vm.reverse>Fecha ultima modification</th><th style=\"width: 150px\" table-column-sorting current-text=vm.predicate title=Action text=\"\'job_pickup_address\'\" check=vm.reverse>Action</th><th style=\"width: 150px\" table-column-sorting current-text=vm.predicate title=\"Admin Logs\" text=\"\'job_address\'\" check=vm.reverse>Admin Logs</th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in vm.specialDirectionsArray | orderBy:vm.predicate:vm.reverse\" ng-style=\"{\'color\':data.color}\"><!-- <td style=\"width:70px;\">{{data.index + 1}}</td> --><td style=width:105px>{{data.address_id || \'--\'}}</td><td style=\"width: 105px\" ng-class=\"{\'bookingIdInTable\': vm.showJobIdInHtml(data.job_id) != \'--\'}\" ng-click=\"vm.showBookingIds(data.address_id || \'\', data.job_id || \'--\')\">{{vm.showJobIdInHtml(data.job_id)}}</td><td style=\"width: 95px\">{{data.address || \'--\'}}</td><td style=\"width: 95px\">{{data.corrected_address || \'--\'}}</td><td style=width:105px>{{data.latitude || \'--\'}}</td><td style=width:115px>{{data.longitude || \'--\'}}</td><td style=width:115px>{{vm.showEstadoInTable(data.state)}}</td><td style=width:125px>{{(data.created_at != \'0000-00-00 00:00:00\') ? (data.created_at | date: \'d/MM/yyyy HH:mm\') : \'--\'}}</td><td style=width:150px>{{(data.updated_at != \'0000-00-00 00:00:00\') ? (data.updated_at | date: \'d/MM/yyyy HH:mm\') : \'--\'}}</td><td style=width:150px><a title=Edit class=\"cursor editIconColor btn btn-sm\" ng-click=vm.editSpecialDirection(data);><i class=\"fa fa-edit\"></i> </a><a title=Delete class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteSpecialAddressAPI(data)><i class=\"fa fa-trash\"></i></a></td><td style=width:150px><a class=\"btn btn-primary tableButton\" title=\"{{\'adminLogs\' | translate}}\" ui-sref=\"layout.fixedRouteGeofenceMain.adminLogs({userId:\'{{data.address_id}}\',type:\'27\',fakeType: \'29\'})\">{{\'adminLogs\' | translate}}</a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>No Record Found</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationOnTable(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div><style type=text/css>.labelsMap {\n        color: red;\n        background-color: cornsilk;\n        font-family: \"Lucida Grande\", \"Arial\", sans-serif;\n        font-size: 10px;\n        font-weight: bold;\n        text-align: center;\n        width: 40px;\n        white-space: nowrap;\n    }\n\n    .headerInDirections {\n        color: white;\n        background-color: #EA712B;\n        text-align: center;\n        font-size: 23px;\n        height: 36px;\n        padding: 3px;\n    }\n\n    .headerInDirectionsRow label {\n        display: block;\n    }</style>");
$templateCache.put("app/components/views/special-directions/specialDirectionsMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/type-of-service/addService.html","<h2 class=ng-cloak>{{\'serviceLabel\' | translate}} / {{\'addServiceHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=service><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'enterDetailsHead\' | translate}}</p><div class=basicDetailsDiv><form name=addServiceForm ng-submit=\"submit=true;addServiceForm.$valid&&vm.registerApi()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'serviceNameLabel\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.service_name name=firstName placeholder=\"{{\'serviceNameLabel\' | translate}}\" required ng-maxlength=60 ng-minlength=3 ng-class=\"{ \'has-error\': addServiceForm.firstName.$touched && addServiceForm.firstName.$invalid }\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\"addServiceForm.firstName.$touched|| submit\" ng-messages=addServiceForm.firstName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'serviceNameReq\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid service name.</div>--><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'firstNameMaximum\' | translate}}</div></div></div></div><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'typeOfServiceInEnglish\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.service_name_english name=firstNameEnglish placeholder=\"{{\'typeOfServiceInEnglish\' | translate}}\" pattern=\"^[a-zA-Z0-9 ]+$\" required ng-maxlength=60 ng-minlength=3 ng-class=\"{ \'has-error\': addServiceForm.firstNameEnglish.$touched && addServiceForm.firstNameEnglish.$invalid }\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\"addServiceForm.firstNameEnglish.$touched|| submit\" ng-messages=addServiceForm.firstNameEnglish.$error><div class=\"errormessage text-danger\" ng-message=required>Favor ingrese Nombre Nombre Tipo de Servicio (Versión Ingles).</div><!-- <div class=\"errormessage text-danger\" ng-message=\"pattern\">\n                                                Nombre Nombre Tipo de Servicio (Versión Ingles) no válido.\n                                            </div> --><div class=\"errormessage text-danger\" ng-message=pattern>Nombre Tipo de Servicio (Versión Ingles) no válido.</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'firstNameMaximum\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'maxPassenegrLabel\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.max_limit placeholder=\"{{\'maxPassenegrLabel\' | translate}}\" name=maxPassenger required ng-class=\"{ \'has-error\': addServiceForm.maxPassenger.$touched && addServiceForm.maxPassenger.$invalid }\" pattern=^[0-9][0-9]*$><div ng-if=\"addServiceForm.maxPassenger.$touched|| submit\" ng-messages=addServiceForm.maxPassenger.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'maxPassenegrReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'maxPassenegrValid\' | translate}}</div></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'vehicleTypesHead\' | translate}} <span style=color:red>*</span></label><ui-select multiple ng-model=vm.dataToFill.vehicle_type theme=bootstrap ng-keyup=vm.vehicleSearch($select.search,$event) ng-change=vm.vehicleChanged() close-on-select=false title=\"Select Vehicle type\" required name=vehicleType ng-class=\"{ \'has-error\': addServiceForm.vehicleType.$touched && addServiceForm.vehicleType.$invalid }\"><ui-select-match placeholder=\"{{\'vehicleSelect\' | translate}}\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in vm.vehicleList | filter:$select.search\" when-scrolled=vm.paginationChangedForVehicle() ng-click=vm.vehicleChanged()>{{data.name}}</ui-select-choices></ui-select><div ng-if=\"addServiceForm.vehicleType.$touched || submit\" ng-messages=addServiceForm.vehicleType.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'vehicleReq\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-2 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'sImage\' | translate}} <span style=color:red>*</span></label><br><img src=assets/images/noImage.jpeg id=serviceImage class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=vm.clickTrigger($event)>{{\'uploadButton\' | translate}}</button> <input id=documentUpload filestyle=\"\" type=file style=\"display: none\" image=image name=VEHICLE_IMAGE onchange=angular.element(this).scope().file_to_upload(this.files,this.name) onclick=\"this.value=null\" data-button-text=Single data-class-button=\"btn btn-default\" data-classinput=\"form-control inline\" nv-file-select=\"\" uploader=uploader accept=image/x-png,image/PNG,image/jpg,image/JPG,image/JPEG,image/jpeg></div><div class=\"col-lg-10 col-sm-6 col-md-6 col-xs-12\"><div class=displayFlex><div style=width:55%><div class=displayFlex><div class=slab-2-TypeService><div class=\"control-label text-center\"><b>Type Of Bookings Allowed</b></div><div class=\"table-responsive mt5\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean>Current</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'CURRENT\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.current , \'fa fa-toggle-off\': !vm.dataToFill.current}\"></i></td></tr><tr><td class=headingBollean>Scheduled</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'SCHEDULED\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.scheduled , \'fa fa-toggle-off\': !vm.dataToFill.scheduled}\"></i></td></tr></tbody></table></div></div><div class=slab-2-TypeService><div class=\"control-label text-center\"><b>Type Of Fare</b></div><div class=\"table-responsive mt5\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean2>Unique Fare</td><td><input type=radio ng-model=vm.dataToFill.uniquePassengerFare value=true name=fare></td></tr><tr><td class=headingBollean2>Fare by Passenger</td><td><input type=radio ng-model=vm.dataToFill.uniquePassengerFare value=false name=fare></td></tr></tbody></table></div></div></div><div class=\"slab-1-TypeService mt5\"><div class=displayFlex><div class=slab-1-child><label class=control-label>{{\'controlledWay\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.controlledWay name=controlledWay placeholder=\"{{\'controlledWay\' | translate}}\" is-number=\"\" required maxlength=5 ng-class=\"{ \'has-error\': addServiceForm.controlledWay.$touched && addServiceForm.controlledWay.$invalid }\"><div ng-if=\"addServiceForm.controlledWay.$touched|| submit\" ng-messages=addServiceForm.controlledWay.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'controlledWayR\' | translate}}</div></div></div><div class=slab-1-child><label class=control-label>{{\'branchLabel\' | translate}} <span style=color:red>*</span></label><ui-select ng-model=vm.dataToFill.branch_value name=branch ng-keyup=vm.branchSearch($select.search,$event) required close-on-select=true ng-class=\"{ \'has-error\': addServiceForm.branch.$touched && addServiceForm.branch.$invalid }\"><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \" when-scrolled=vm.paginationChangedForBranch() ng-click=vm.branchChanged()><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select><div ng-if=\"addServiceForm.branch.$touched|| submit\" ng-messages=addServiceForm.branch.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'branchR\' | translate}}</div></div></div></div></div></div><div style=width:45%;margin-left:5px><div class=slab-3-TypeService><div class=\"control-label text-center\"><b>Category</b></div><div class=\"table-responsive mt5\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean2>Shared</td><td><input type=radio ng-model=vm.dataToFill.exclusiveShared value=1 name=category></td></tr><tr><td class=headingBollean2>Exclusive</td><td><input type=radio ng-model=vm.dataToFill.exclusiveShared value=0 name=category></td></tr><!--<tr>--><!--<td class=\"headingBollean2\">Normal</td>--><!--<td class=\"\"><input type=\"radio\" ng-model=\"vm.dataToFill.exclusiveShared\" value=\"2\" name=\"category\" /></td>--><!--</tr>--></tbody></table></div><div class=mt5><label class=control-label>Tolerance to Airport(in mins) <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.tolerance placeholder=\"Tolerance to Airport\" name=tolerance required ng-class=\"{ \'has-error\': addServiceForm.tolerance.$touched && addServiceForm.tolerance.$invalid }\" pattern=^[0-9][0-9]*$><div ng-if=\"addServiceForm.tolerance.$touched|| submit\" ng-messages=addServiceForm.tolerance.$error><div class=\"errormessage text-danger\" ng-message=required>Por favor agregue tolernace al aeropuerto.</div><div class=\"errormessage text-danger\" ng-message=pattern>Por favor, introduzca una tolerancia válida al aeropuerto.</div></div></div><div class=mt5><label class=control-label>Tiempo Espera Compartido</label><input type=text maxlength=3 class=form-control ng-model=vm.dataToFill.shared_wait_time placeholder=\"Tiempo Espera Compartido\" name=sharedWaitTime ng-class=\"{ \'has-error\': addServiceForm.sharedWaitTime.$touched && addServiceForm.sharedWaitTime.$invalid }\" pattern=^[0-9][0-9]*$><div ng-if=\"addServiceForm.sharedWaitTime.$touched|| submit\" ng-messages=addServiceForm.sharedWaitTime.$error><!-- <div class=\"errormessage text-danger\" ng-message=\"required\">Please add shared Wait Time.</div> --><div class=\"errormessage text-danger\" ng-message=pattern>Please enter valid Tiempo Espera Compartido.</div></div></div></div></div></div></div></div><div class=\"row mt5 col-xs-10 col-xs-offset-2 padLR5\"><div class=slab-2-TypeService style=\"width: 55%\"><div class=\"control-label text-center\"><b>{{\'typeOfTransport\' | translate}}</b></div><div class=\"table-responsive mt5\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean2>{{\'people\' | translate}}</td><td><input type=radio ng-model=vm.dataToFill.service_transport_type value=false name=transport></td></tr><tr><td class=headingBollean2>{{\'entrust\' | translate}}</td><td><input type=radio ng-model=vm.dataToFill.service_transport_type value=true name=transport></td></tr></tbody></table></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" style=margin-top:10px><button type=submit class=\"btn btn-primary\">{{\'submit\' | translate}}</button></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/type-of-service/edittypeofService.html","<h2 class=ng-cloak>{{\'serviceLabel\' | translate}} / {{\'editServiceHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=service><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'editDetailsButton\' | translate}}</p><div class=basicDetailsDiv><form name=editServiceForm ng-submit=\"submit=true;editServiceForm.$valid&&vm.editApi()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'serviceNameLabel\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.service_name name=firstName placeholder=\"{{\'serviceNameLabel\' | translate}}\" required ng-maxlength=60 ng-minlength=3 ng-class=\"{ \'has-error\': editServiceForm.firstName.$touched && editServiceForm.firstName.$invalid }\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\" --><div ng-if=\"editServiceForm.firstName.$touched|| submit\" ng-messages=editServiceForm.firstName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'serviceNameReq\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid service name.</div>--><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'firstNameMaximum\' | translate}}</div></div></div></div><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'typeOfServiceInEnglish\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.service_name_english name=firstNameEnglish placeholder=\"{{\'typeOfServiceInEnglish\' | translate}}\" pattern=\"^[a-zA-Z0-9 ]+$\" required ng-maxlength=60 ng-minlength=3 ng-class=\"{ \'has-error\': editServiceForm.firstNameEnglish.$touched && firstNameEnglish.firstName.$invalid }\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\" --><div ng-if=\"editServiceForm.firstNameEnglish.$touched|| submit\" ng-messages=editServiceForm.firstNameEnglish.$error><div class=\"errormessage text-danger\" ng-message=required>Favor ingrese Nombre Nombre Tipo de Servicio (Versión Ingles).</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid service name.</div>--><!-- <div class=\"errormessage text-danger\" ng-message=\"pattern\">\n                                                Nombre Nombre Tipo de Servicio (Versión Ingles) no válido.\n                                            </div> --><div class=\"errormessage text-danger\" ng-message=pattern>Nombre Tipo de Servicio (Versión Ingles) no válido.</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'firstNameMaximum\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'maxPassenegrLabel\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.max_limit placeholder=\"{{\'maxPassenegrLabel\' | translate}}\" name=maxPassenger required ng-class=\"{ \'has-error\': editServiceForm.maxPassenger.$touched && editServiceForm.maxPassenger.$invalid }\" pattern=^[0-9][0-9]*$><div ng-if=\"editServiceForm.maxPassenger.$touched|| submit\" ng-messages=editServiceForm.maxPassenger.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'maxPassenegrReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'maxPassenegrValid\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'vehicleTypesHead\' | translate}} <span style=color:red>*</span></label><ui-select multiple ng-model=vm.dataToFill.vehicle_type theme=bootstrap close-on-select=false title=\"Select Vehicle type\" required name=vehicleType ng-class=\"{ \'has-error\': editServiceForm.vehicleType.$touched && editServiceForm.vehicleType.$invalid }\"><ui-select-match placeholder=\"{{\'vehicleSelect\' | translate}}\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"data.id as data in vm.vehicleList | filter:$select.search\">{{data.name}}</ui-select-choices></ui-select><div ng-if=\"editServiceForm.vehicleType.$touched || submit\" ng-messages=editServiceForm.vehicleType.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'vehicleReq\' | translate}}</div></div></div></div><div class=\"row mt5\"><div class=\"col-lg-2 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'sImage\' | translate}} <span style=color:red>*</span></label><br><img ng-src=\"{{ vm.dataToFill.service_img || \'assets/images/noImage.jpeg\'}}\" ng-hide=vm.dataToFill.hideImage id=serviceImage class=documentStyle> <img src=assets/images/noImage.jpeg id=serviceImageEdit ng-show=vm.dataToFill.hideImage class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=vm.clickTrigger($event)>{{\'uploadButton\' | translate}}</button> <input id=documentUpload filestyle=\"\" type=file style=\"display: none\" image=image name=SERVICE_IMAGE onchange=angular.element(this).scope().file_to_upload(this.files,this.name) onclick=\"this.value=null\" data-button-text=Single data-class-button=\"btn btn-default\" data-classinput=\"form-control inline\" nv-file-select=\"\" uploader=uploader accept=image/x-png,image/PNG,image/jpg,image/JPG,image/JPEG,image/jpeg></div><div class=\"col-lg-10 col-sm-6 col-md-6 col-xs-12\"><div class=displayFlex><div style=width:55%><div class=displayFlex><div class=slab-2-TypeService><div class=\"control-label text-center\"><b>Type Of Bookings Allowed</b></div><div class=\"table-responsive mt5\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean>Current</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'CURRENT\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.current , \'fa fa-toggle-off\': !vm.dataToFill.current}\"></i></td></tr><tr><td class=headingBollean>Scheduled</td><td class=boleeanTypeColor><i ng-click=\"vm.setBooleans(\'SCHEDULED\')\" ng-class=\"{\'fa fa-toggle-on\': vm.dataToFill.scheduled , \'fa fa-toggle-off\': !vm.dataToFill.scheduled}\"></i></td></tr></tbody></table></div></div><div class=slab-2-TypeService><div class=\"control-label text-center\"><b>Type Of Fare</b></div><div class=\"table-responsive mt5\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean2>Unique Fare</td><td><input type=radio ng-model=vm.dataToFill.uniquePassengerFare value=true name=fare></td></tr><tr><td class=headingBollean2>Fare by Passenger</td><td><input type=radio ng-model=vm.dataToFill.uniquePassengerFare value=false name=fare></td></tr></tbody></table></div></div></div><div class=\"slab-1-TypeService mt5\"><div class=displayFlex><div class=slab-1-child><label class=control-label>{{\'controlledWay\' | translate}} <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.controlledWay name=controlledWay placeholder=\"{{\'controlledWay\' | translate}}\" is-number=\"\" required maxlength=5 ng-class=\"{ \'has-error\': editServiceForm.controlledWay.$touched && editServiceForm.controlledWay.$invalid }\"><div ng-if=\"editServiceForm.controlledWay.$touched|| submit\" ng-messages=editServiceForm.controlledWay.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'controlledWayR\' | translate}}</div></div></div><div class=slab-1-child><label class=control-label>{{\'branchLabel\' | translate}} <span style=color:red>*</span></label><ui-select ng-model=vm.dataToFill.branch_value name=branch required close-on-select=true ng-change=vm.branchChanged() ng-class=\"{ \'has-error\': editServiceForm.branch.$touched && editServiceForm.branch.$invalid }\"><ui-select-match placeholder=\"{{\'branchPlaceholder\' | translate}}\">{{$select.selected.region_name}}</ui-select-match><ui-select-choices repeat=\"branch.region_id as branch in vm.branchList | filter: $select.search | orderBy:\'region_name\' \"><div ng-bind-html=branch.region_name></div></ui-select-choices></ui-select><div ng-if=\"editServiceForm.branch.$touched|| submit\" ng-messages=editServiceForm.branch.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'branchR\' | translate}}</div></div></div></div></div></div><div style=width:45%;margin-left:5px><div class=slab-3-TypeService><div class=\"control-label text-center\"><b>Category</b></div><div class=\"table-responsive mt5\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean2>Shared</td><td><input type=radio ng-model=vm.dataToFill.exclusiveShared value=1 name=category></td></tr><tr><td class=headingBollean2>Exclusive</td><td><input type=radio ng-model=vm.dataToFill.exclusiveShared value=0 name=category></td></tr><!--<tr>--><!--<td class=\"headingBollean2\">Normal</td>--><!--<td class=\"\"><input type=\"radio\" ng-model=\"vm.dataToFill.exclusiveShared\" value=\"2\" name=\"category\" /></td>--><!--</tr>--></tbody></table></div><div class=mt5><label class=control-label>Tolerance to Airport(in mins) <span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.tolerance placeholder=\"Tolerance to Airport\" name=tolerance required ng-class=\"{ \'has-error\': editServiceForm.tolerance.$touched && editServiceForm.tolerance.$invalid }\" pattern=^[0-9][0-9]*$><div ng-if=\"editServiceForm.tolerance.$touched|| submit\" ng-messages=editServiceForm.tolerance.$error><div class=\"errormessage text-danger\" ng-message=required>Por favor agregue tolernace al aeropuerto.</div><div class=\"errormessage text-danger\" ng-message=pattern>Por favor, introduzca una tolerancia válida al aeropuerto.</div></div></div><div class=mt5><label class=control-label>Tiempo Espera Compartido</label><input type=text maxlength=3 class=form-control ng-model=vm.dataToFill.shared_wait_time placeholder=\"Tiempo Espera Compartido\" name=sharedWaitTime ng-class=\"{ \'has-error\': editServiceForm.sharedWaitTime.$touched && editServiceForm.sharedWaitTime.$invalid }\" pattern=^[0-9][0-9]*$><div ng-if=\"editServiceForm.sharedWaitTime.$touched|| submit\" ng-messages=editServiceForm.sharedWaitTime.$error><!-- <div class=\"errormessage text-danger\" ng-message=\"required\">Please add shared Wait Time.</div> --><div class=\"errormessage text-danger\" ng-message=pattern>Please enter valid Tiempo Espera Compartido.</div></div></div></div></div></div></div></div><div class=\"row mt5 col-xs-10 col-xs-offset-2 padLR5\"><div class=slab-2-TypeService style=\"width: 55%\"><div class=\"control-label text-center\"><b>{{\'typeOfTransport\' | translate}}</b></div><div class=\"table-responsive mt5\"><table class=table id=aggreementTable><tbody><tr><td class=headingBollean2>{{\'people\' | translate}}</td><td><input type=radio ng-model=vm.dataToFill.service_transport_type value=false name=transport></td></tr><tr><td class=headingBollean2>{{\'entrust\' | translate}}</td><td><input type=radio ng-model=vm.dataToFill.service_transport_type value=true name=transport></td></tr></tbody></table></div></div></div><div class=\"row mt5\"><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" style=margin-top:10px><button type=submit class=\"btn btn-primary\">{{\'submit\' | translate}}</button></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/type-of-service/typeOfServiceMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/type-of-service/typeofService.html","<h2 class=ng-cloak>{{\'serviceLabel\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-4 col-sm-6 col-md-4 col-xs-12\"><label class=control-label>{{\'serviceStatusLabel\' | translate}}</label><select class=form-control ng-model=vm.filterData.serviceStatus ng-change=\"vm.getAllServices(0,10,vm.filterData.serviceStatus);vm.currentPage = 0;\"><option value=\"\" disabled>{{\'serviceStatusPlaceholder\' | translate}}</option><option selected value=1>Active</option><option value=0>Inactive</option><option value=2>All</option></select></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><p class=totalSize><span class=pull-right><a class=\"btn btn-primary mb10\" ui-sref=layout.typeOfServiceMain.addService>+ {{\'addServiceButton\' | translate}}</a> </span>{{\'totalServices\' | translate}}: {{vm.totalServices}}</p></div><br><br><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\" ng-switch=\"(vm.serviceList | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:125px><div class=text-center>{{\'sImage\' | translate}}</div></th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'serviceNameLabel\' | translate}}\" text=\"\'service_name\'\" check=vm.reverse>{{\'serviceNameLabel\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'maxPassengerLabel\' | translate}}\" text=\"\'max_limit\'\" check=vm.reverse>{{\'maxPassengerLabel\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'vehiclesLabel\' | translate}}\" text=\"\'vehicle_mapping\'\" check=vm.reverse>{{\'vehiclesLabel\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'controlledWay\' | translate}}\" text=\"\'controlled_way\'\" check=vm.reverse>{{\'controlledWay\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'branchLabel\' | translate}}\" text=\"\'region_name\'\" check=vm.reverse>{{\'branchLabel\' | translate}}</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"Type of Booking\" text=\"\'is_current\'\" check=vm.reverse>Type of Booking</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"Type of Fare\" text=\"\'fare_type\'\" check=vm.reverse>Type of Fare</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"{{\'typeOfTransport\' | translate}}\" text=\"\'fare_type\'\" check=vm.reverse>{{\'typeOfTransport\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=Category text=\"\'category\'\" check=vm.reverse>Category</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"Tolerance to Airport\" text=\"\'tolerance\'\" check=vm.reverse>Tolerance to Airport(in mins)</th><th style=width:125px table-column-sorting current-text=vm.predicate title=\"Shared Wait Time\" text=\"\'sharedWaitTime\'\" check=vm.reverse>Tiempo Espera Compartido(in mins)</th><th style=width:100px><div class=text-center>{{\'stateTable\' | translate}}</div></th><th style=width:150px><div class=text-center>{{\'action\' | translate}}</div></th><th style=width:150px><div class=text-center>{{\'adminLogs\' | translate}}</div></th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.serviceList| filter:vm.search | orderBy:vm.predicate:vm.reverse\"><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:70px>{{::data.id}}</td><td style=width:125px><img ng-src=\"{{data.service_image || \'assets/images/noImage.jpeg\'}}\" class=tableImage></td><td style=width:125px>{{::data.service_name}}</td><td style=width:100px>{{::data.max_limit}}</td><td style=width:125px><span ng-repeat=\"dataV in data.vehicle_mapping\">{{dataV.name}}<span ng-if=\"$index != data.vehicle_mapping.length - 1\"><br></span></span></td><td style=width:125px>${{::data.controlled_way}}</td><td style=width:100px>{{::data.region_name || \'--\'}}</td><td style=width:125px><div ng-if=data.is_current>Current</div><div ng-if=data.is_scheduled>Scheduled</div><span ng-if=\"!data.is_scheduled && !data.is_current\">--</span></td><td style=width:125px><span ng-if=data.fare_type>Fare by Passenger</span> <span ng-if=!data.fare_type>Unique Fare</span></td><td style=width:125px><span ng-if=!data.service_transport_type>{{\'people\' | translate}}</span> <span ng-if=data.service_transport_type>{{\'entrust\' | translate}}</span></td><td style=width:100px><span ng-if=\"data.category == 1\">Shared</span> <span ng-if=\"data.category == 0\">Exclusive</span><!--<span ng-if=\"data.category == 2\">Normal</span>--></td><td style=width:125px>{{::data.tolerance}}</td><td style=width:125px>{{::data.shared_wait_time}}</td><td style=width:100px><a class=\"cursor btn btn-sm\" ng-class=\"{\'blockIconColor\': data.status == 0, \'unblockIconColor\': data.status == 1}\" ng-click=vm.blockUnblockService($event,data.id,data.status)><i ng-class=\"{\'fa fa-unlock\': data.status == 1,\'fa fa-lock\': data.status == 0}\"></i></a></td><td style=width:150px><a title=\"Edit Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.typeOfServiceMain.editTypeofService({id:\'{{data.id}}\'})\"><i class=\"fa fa-edit\"></i> </a><a title=\"View Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.typeOfServiceMain.viewTypeofService({id:\'{{data.id}}\'})\"><i class=\"fa fa-eye\"></i> </a><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteServiceHit(data,$event)><i class=\"fa fa-trash\"></i></a></td><td style=width:150px><a class=\"btn btn-primary tableButton\" title=\"{{\'adminLogs\' | translate}}\" ui-sref=\"layout.typeOfServiceMain.adminLogs({userId:\'{{data.id}}\',type:\'12\',fakeType: \'7\'})\">{{\'adminLogs\' | translate}}</a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noServiceFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav ng-show=\"vm.watchPagination\">--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\" ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/type-of-service/viewTypeOfServiceDetails.html","<h2 class=ng-cloak>{{\'serviceLabel\' | translate}} / {{\'serviceDetailsHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=driver><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'allDetails\' | translate}}</p><div class=basicDetailsDiv><div class=row><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'serviceNameLabel\' | translate}}:</label><div class=\"form-control text-capitalize\" style=\"height: auto\">{{::vm.serviceDetail.service_name}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'typeOfServiceInEnglish\' | translate}}:</label><div class=\"form-control text-capitalize\" style=\"height: auto\">{{::vm.serviceDetail.service_name_english}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'maxPassengerLabel\' | translate}}:</label><div class=\"form-control text-capitalize\">{{::vm.serviceDetail.max_limit}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'serviceId\' | translate}}:</label><div class=\"form-control text-capitalize\">{{::vm.serviceDetail.id}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'serviceStatus\' | translate}}:</label><div class=\"form-control text-capitalize\"><span ng-if=\"vm.serviceDetail.status == 1\">Active</span> <span ng-if=\"vm.serviceDetail.status == 0\">Not Active</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'controlledWay\' | translate}}:</label><div class=\"form-control text-capitalize\">${{vm.serviceDetail.controlled_way}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'branchLabel\' | translate}}:</label><div class=\"form-control text-capitalize\">{{vm.serviceDetail.region_name || \'--\'}}</div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Type of Booking:</label><div class=\"form-control text-capitalize\"><span ng-if=vm.serviceDetail.is_current>Current,</span> <span ng-if=vm.serviceDetail.is_scheduled>Schedule</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Type of Fare:</label><div class=\"form-control text-capitalize\"><span ng-if=vm.serviceDetail.fare_type>Fare by Passenger</span> <span ng-if=!vm.serviceDetail.fare_type>Unique Fare</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>{{\'typeOfTransport\' | translate}}:</label><div class=\"form-control text-capitalize\"><span ng-if=!vm.serviceDetail.service_transport_type>{{\'people\' | translate}}</span> <span ng-if=vm.serviceDetail.service_transport_type>{{\'entrust\' | translate}}</span></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Category:</label><div class=\"form-control text-capitalize\"><span ng-if=\"vm.serviceDetail.category == 1\">Shared</span> <span ng-if=\"vm.serviceDetail.category == 0\">Exclusive</span><!--<span ng-if=\"vm.serviceDetail.category == 2\">Normal</span>--></div></div><div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\"><label class=control-label>Tolerance to Airport(in mins):</label><div class=\"form-control text-capitalize\">{{::vm.serviceDetail.tolerance}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'vehicleTypesHead\' | translate}}:</label><div class=text-capitalize><ul><li ng-repeat=\"data in vm.serviceDetail.vehicle_mapping\">{{::data.name}}</li></ul></div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'sImage\' | translate}}:</label><div><img ng-src=\"{{ vm.serviceDetail.service_image || \'assets/images/noImage.jpeg\'}}\" class=documentStyle></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/vehicle-type/addVehicle.html","<h2 class=ng-cloak>{{\'vehicleTypesHead\' | translate}} / {{\'addVehicleHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=vehicle><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'enterDetailsHead\' | translate}}</p><div class=basicDetailsDiv><form name=addvehicleForm ng-submit=\"submit=true;addvehicleForm.$valid&&vm.registerApi()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'vehicleNameLabel\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.name name=vehicleName placeholder=\"{{\'vehicleNameLabel\' | translate}}\" required ng-maxlength=60 ng-minlength=3 ng-class=\"{ \'has-error\': addvehicleForm.vehicleName.$touched && addvehicleForm.vehicleName.$invalid }\"><!--pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\"addvehicleForm.vehicleName.$touched|| submit\" ng-messages=addvehicleForm.vehicleName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'vehicleNameReq\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid vehicle name.</div>--><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'firstNameMaximum\' | translate}}</div></div></div><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">\n                                        <label class=\"control-label\">Service Status<span style=\"color:red\">*</span></label>\n                                        <select class=\"form-control\" ng-model=\"vm.service.status\" name=\"driverType\" required ng-class=\"{ \'has-error\': addvehicleForm.driverType.$touched && addvehicleForm.driverType.$invalid }\">\n                                            <option value=\"\" disabled selected>Select Status</option>\n                                            <option value=\"0\" >PENDING</option>\n                                            <option value=\"1\" >COMPLETED</option>\n                                        </select>\n                                        <div ng-if=\"addvehicleForm.driverType.$touched || submit\" ng-messages=\"addvehicleForm.driverType.$error\">\n                                            <div class=\"errormessage text-danger\" ng-message=\"required\">Please select service status.</div>\n                                        </div>\n                                    </div>--><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">\n                                        <label class=\"control-label\">Created On<span style=\"color:red\">*</span></label>\n                                        <p class=\"input-group\">\n                                            <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{vm.format}}\" ng-model=\"vm.dataToFill.vehicle_creation_date\" name=\"VehicleDate\" required ng-class=\"{ \'has-error\': addvehicleForm.vehicle_creation_date.$touched && addvehicleForm.vehicle_creation_date.$invalid }\"\n                                                close-text=\"Close\" alt-input-formats=\"vm.altInputFormats\" show-button-bar=\"false\" readonly/>--><!--<span class=\"input-group-btn\">\n                                                    <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.datePickerE_1()\"><i\n                                                    class=\"glyphicon glyphicon-calendar\"></i></button>\n                                                </span>--><!--</p>\n                                        <div ng-if=\"addvehicleForm.vehicle_creation_date.$touched|| submit\" ng-messages=\"addvehicleForm.vehicle_creation_date.$error\">\n                                            <div class=\"errormessage text-danger\" ng-message=\"required\"></div>\n                                        </div>\n                                    </div>\n                                    <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">\n                                        <label class=\"control-label\">Category By<span style=\"color:red\">*</span></label>\n                                        <input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.login_name\" name=\"loginName\" required />--><!--<div ng-if=\"addvehicleForm.firstName.$touched|| submit\" ng-messages=\"addvehicleForm.firstName.$error\">\n                                            <div class=\"errormessage text-danger\" ng-message=\"required\">Please enter service Name</div>\n                                            <div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid service name.</div>\n                                            <div class=\"errormessage text-danger\" ng-message=\"minlength\">Minimum 2 characters are required.</div>\n                                            <div class=\"errormessage text-danger\" ng-message=\"maxlength\">Maximum 60 characters are allowed.</div>\n                                        </div>--><!--</div>--><div class=\"col-lg-7 col-sm-12 col-md-7 col-xs-12\"><label class=control-label>{{\'tag\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.tag name=vehicleTag placeholder=\"{{\'tag\' | translate}}\" required ng-maxlength=60 ng-minlength=3 ng-class=\"{ \'has-error\': addvehicleForm.vehicleTag.$touched && addvehicleForm.vehicleTag.$invalid }\" pattern=^[a-zA-Z][a-zA-Z\\s]*$><div ng-if=\"addvehicleForm.vehicleTag.$touched|| submit\" ng-messages=addvehicleForm.vehicleTag.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'vehicleTagReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'vehicleTagValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'firstNameMaximum\' | translate}}</div></div></div><div class=\"col-lg-5 col-sm-12 col-md-5 col-xs-12\"><label class=control-label>{{\'select\' | translate}} {{\'category\' | translate}}<span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.category name=category required ng-class=\"{ \'has-error\': addvehicleForm.driverType.$touched && addvehicleForm.driverType.$invalid }\"><option value=\"\" disabled selected>{{\'select\' | translate}} {{\'category\' | translate}}</option><option value=S>Sedan</option><option value=M>Minibus</option><option value=O>Otro</option></select><div ng-if=\"addvehicleForm.category.$touched || submit\" ng-messages=addvehicleForm.category.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'pleaseSelectServiceCategory\' | translate}}</div></div></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><label class=control-label>{{\'vImage\' | translate}}<span style=color:red>*</span></label><br><img src=assets/images/noImage.jpeg id=vehicleImage class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event, \'VEHICLE_IMAGE\')\">{{\'uploadButton\' | translate}}</button> <input id=documentUpload filestyle=\"\" type=file style=\"display: none\" image=image name={{vm.dataToFill.uploadName}} onchange=angular.element(this).scope().file_to_upload(this.files,this.name) onclick=\"this.value=null\" data-button-text=Single data-class-button=\"btn btn-default\" data-classinput=\"form-control inline\" nv-file-select=\"\" uploader=uploader accept=image/x-png,image/PNG,image/jpg,image/JPG,image/JPEG,image/jpeg></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><label class=control-label>{{\'vImageOff\' | translate}}<span style=color:red>*</span></label><br><img src=assets/images/noImage.jpeg id=offImage class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event, \'OFF_IMAGE\')\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><label class=control-label>{{\'vImageOn\' | translate}}<span style=color:red>*</span></label><br><img src=assets/images/noImage.jpeg id=onImage class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event, \'ON_IMAGE\')\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><label class=control-label>{{\'vImageBusy\' | translate}}<span style=color:red>*</span></label><br><img src=assets/images/noImage.jpeg id=busyImage class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event, \'BUSY_IMAGE\')\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><label class=control-label>{{\'vImagePosition\' | translate}}<span style=color:red>*</span></label><br><img src=assets/images/noImage.jpeg id=positionImage class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event, \'POSITION_IMAGE\')\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><label class=control-label>{{\'vImageAccepted\' | translate}}<span style=color:red>*</span></label><br><img src=assets/images/noImage.jpeg id=acceptedImage class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event, \'ACCEPTED_IMAGE\')\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><label class=control-label>{{\'vImageOnRoad\' | translate}}<span style=color:red>*</span></label><br><img src=assets/images/noImage.jpeg id=onroadImage class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event, \'ON_ROAD_IMAGE\')\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" style=margin-top:10px><button type=submit class=\"btn btn-primary\">{{\'submit\' | translate}}</button></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/vehicle-type/editVehicletype.html","<h2 class=ng-cloak>{{\'vehicleTypesHead\' | translate}} / {{\'vehicleEditHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=vehicle><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP backgroundBasicPending text-center\">{{\'enterDetailsHead\' | translate}}</p><div class=basicDetailsDiv><form name=editVehicleForm ng-submit=\"submit=true;editVehicleForm.$valid&&vm.registerApi()\" novalidate autocomplete=off><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'vehicleNameLabel\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.name name=vehicleName placeholder=\"{{\'vehicleNameLabel\' | translate}}\" required ng-maxlength=60 ng-minlength=3 ng-class=\"{ \'has-error\': editVehicleForm.vehicleName.$touched && editVehicleForm.vehicleName.$invalid }\"><!-- pattern=\"^[a-zA-Z][a-zA-Z\\s]*$\"--><div ng-if=\"editVehicleForm.vehicleName.$touched|| submit\" ng-messages=editVehicleForm.vehicleName.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'vehicleNameReq\' | translate}}</div><!--<div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid vehicle name.</div>--><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'firstNameMaximum\' | translate}}</div></div></div><!--<div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">\n                                        <label class=\"control-label\">Service Status<span style=\"color:red\">*</span></label>\n                                        <select class=\"form-control\" ng-model=\"vm.service.status\" name=\"driverType\" required ng-class=\"{ \'has-error\': editVehicleForm.driverType.$touched && editVehicleForm.driverType.$invalid }\">\n                                            <option value=\"\" disabled selected>Select Status</option>\n                                            <option value=\"0\" >PENDING</option>\n                                            <option value=\"1\" >COMPLETED</option>\n                                        </select>\n                                        <div ng-if=\"editVehicleForm.driverType.$touched || submit\" ng-messages=\"editVehicleForm.driverType.$error\">\n                                            <div class=\"errormessage text-danger\" ng-message=\"required\">Please select service status.</div>\n                                        </div>\n                                    </div>--><!--<div class=\"col-lg-6 col-sm-6 col-md-6 col-xs-12\">\n                                        <label class=\"control-label\">Created On<span style=\"color:red\">*</span></label>\n                                        <p class=\"input-group\">\n                                            <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{vm.format}}\" ng-model=\"vm.dataToFill.vehicle_creation_date\" name=\"VehicleDate\" required ng-class=\"{ \'has-error\': editVehicleForm.vehicle_creation_date.$touched && editVehicleForm.vehicle_creation_date.$invalid }\"\n                                                close-text=\"Close\" alt-input-formats=\"vm.altInputFormats\" show-button-bar=\"false\" readonly/>--><!--<span class=\"input-group-btn\">\n                                                    <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.datePickerE_1()\"><i\n                                                    class=\"glyphicon glyphicon-calendar\"></i></button>\n                                                </span>--><!--</p>\n                                        <div ng-if=\"editVehicleForm.vehicle_creation_date.$touched|| submit\" ng-messages=\"editVehicleForm.vehicle_creation_date.$error\">\n                                            <div class=\"errormessage text-danger\" ng-message=\"required\"></div>\n                                        </div>\n                                    </div>\n                                    <div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\">\n                                        <label class=\"control-label\">Category By<span style=\"color:red\">*</span></label>\n                                        <input type=\"text\" class=\"form-control\" ng-model=\"vm.dataToFill.login_name\" name=\"loginName\" required />--><!--<div ng-if=\"editVehicleForm.firstName.$touched|| submit\" ng-messages=\"editVehicleForm.firstName.$error\">\n                                            <div class=\"errormessage text-danger\" ng-message=\"required\">Please enter service Name</div>\n                                            <div class=\"errormessage text-danger\" ng-message=\"pattern\">Please enter a valid service name.</div>\n                                            <div class=\"errormessage text-danger\" ng-message=\"minlength\">Minimum 2 characters are required.</div>\n                                            <div class=\"errormessage text-danger\" ng-message=\"maxlength\">Maximum 60 characters are allowed.</div>\n                                        </div>--><!--</div>--><div class=\"col-lg-7 col-sm-12 col-md-7 col-xs-12\"><label class=control-label>{{\'tag\' | translate}}<span style=color:red>*</span></label><input type=text class=form-control ng-model=vm.dataToFill.tag name=vehicleTag placeholder=\"{{\'tag\' | translate}}\" required ng-maxlength=60 ng-minlength=3 ng-class=\"{ \'has-error\': editVehicleForm.vehicleTag.$touched && editVehicleForm.vehicleTag.$invalid }\" pattern=^[a-zA-Z][a-zA-Z\\s]*$><div ng-if=\"editVehicleForm.vehicleTag.$touched|| submit\" ng-messages=editVehicleForm.vehicleTag.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'vehicleTagReq\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=pattern>{{\'vehicleTagValid\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=minlength>{{\'firstNameMinimum\' | translate}}</div><div class=\"errormessage text-danger\" ng-message=maxlength>{{\'firstNameMaximum\' | translate}}</div></div></div><div class=\"col-lg-5 col-sm-12 col-md-5 col-xs-12\"><label class=control-label>{{\'select\' | translate}} {{\'category\' | translate}}<span style=color:red>*</span></label><select class=form-control ng-model=vm.dataToFill.category name=category required ng-class=\"{ \'has-error\': addvehicleForm.driverType.$touched && addvehicleForm.driverType.$invalid }\"><option value=\"\" disabled selected>{{\'select\' | translate}} {{\'category\' | translate}}</option><option value=S>Sedan</option><option value=M>Minibus</option><option value=O>Otro</option></select><div ng-if=\"addvehicleForm.category.$touched || submit\" ng-messages=addvehicleForm.category.$error><div class=\"errormessage text-danger\" ng-message=required>{{\'pleaseSelectServiceCategory\' | translate}}</div></div></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><label class=control-label>{{\'vImage\' | translate}}<span style=color:red>*</span></label><br><img ng-src=\"{{ vm.dataToFill.vehicle_img || \'assets/images/noImage.jpeg\'}}\" ng-hide=vm.dataToFill.hideImageG class=documentStyle> <img src=assets/images/noImage.jpeg id=vehicleImageEdit ng-show=vm.dataToFill.hideImageG class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event, \'VEHICLE_IMAGE\')\">{{\'uploadButton\' | translate}}</button> <input id=documentUpload filestyle=\"\" type=file style=\"display: none\" image=image name={{vm.dataToFill.uploadName}} onchange=angular.element(this).scope().file_to_upload(this.files,this.name) onclick=\"this.value=null\" data-button-text=Single data-class-button=\"btn btn-default\" data-classinput=\"form-control inline\" nv-file-select=\"\" uploader=uploader accept=image/x-png,image/PNG,image/jpg,image/JPG,image/JPEG,image/jpeg></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><label class=control-label>{{\'vImageOff\' | translate}}<span style=color:red>*</span></label><br><img ng-src=\"{{ vm.dataToFill.vehicle_img_offline || \'assets/images/noImage.jpeg\'}}\" ng-hide=vm.dataToFill.hideImageOf class=documentStyle> <img src=assets/images/noImage.jpeg id=vehicleImageOffEdit ng-show=vm.dataToFill.hideImageOf class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event, \'VEHICLE_IMAGE_OFF\')\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><label class=control-label>{{\'vImageOn\' | translate}}<span style=color:red>*</span></label><br><img ng-src=\"{{ vm.dataToFill.vehicle_img_online || \'assets/images/noImage.jpeg\'}}\" ng-hide=vm.dataToFill.hideImageOn class=documentStyle> <img src=assets/images/noImage.jpeg id=vehicleImageOnEdit ng-show=vm.dataToFill.hideImageOn class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event, \'VEHICLE_IMAGE_ON\')\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><label class=control-label>{{\'vImageBusy\' | translate}}<span style=color:red>*</span></label><br><img ng-src=\"{{ vm.dataToFill.vehicle_img_busy || \'assets/images/noImage.jpeg\'}}\" ng-hide=vm.dataToFill.hideImageB class=documentStyle> <img src=assets/images/noImage.jpeg id=vehicleImageBusyEdit ng-show=vm.dataToFill.hideImageB class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event, \'VEHICLE_IMAGE_BUSY\')\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><label class=control-label>{{\'vImagePosition\' | translate}}<span style=color:red>*</span></label><br><img ng-src=\"{{ vm.dataToFill.vehicle_img_position || \'assets/images/noImage.jpeg\'}}\" ng-hide=vm.dataToFill.hideImageP class=documentStyle> <img src=assets/images/noImage.jpeg id=vehicleImagePositionEdit ng-show=vm.dataToFill.hideImageP class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event, \'VEHICLE_IMAGE_POSITION\')\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><label class=control-label>{{\'vImageAccepted\' | translate}}<span style=color:red>*</span></label><br><img ng-src=\"{{ vm.dataToFill.vehicle_img_accepted || \'assets/images/noImage.jpeg\'}}\" ng-hide=vm.dataToFill.hideImageA class=documentStyle> <img src=assets/images/noImage.jpeg id=vehicleImageAcceptedEdit ng-show=vm.dataToFill.hideImageA class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event, \'VEHICLE_IMAGE_ACCEPTED\')\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><label class=control-label>{{\'vImageOnRoad\' | translate}}<span style=color:red>*</span></label><br><img ng-src=\"{{ vm.dataToFill.vehicle_img_road || \'assets/images/noImage.jpeg\'}}\" ng-hide=vm.dataToFill.hideImageO class=documentStyle> <img src=assets/images/noImage.jpeg id=vehicleImageRoadEdit ng-show=vm.dataToFill.hideImageO class=documentStyle><br><button type=button class=\"btn btn-primary upload mt10 ml5\" ng-click=\"vm.clickTrigger($event, \'VEHICLE_IMAGE_ROAD\')\">{{\'uploadButton\' | translate}}</button></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\" style=margin-top:10px><button type=submit class=\"btn btn-primary\">{{\'submit\' | translate}}</button></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/vehicle-type/vehicleType.html","<h2 class=ng-cloak>{{\'vehicleTypesHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\"><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><div class=row><div class=\"col-lg-4 col-sm-6 col-md-4 col-xs-12\"><label class=control-label>{{\'typeOfVehicleLabel\' | translate}}</label><select class=form-control ng-model=vm.filterData.vehicleStatus ng-change=\"vm.getAllVehicles(0,10,vm.filterData.vehicleStatus);vm.currentPage = 0;\"><option value=\"\" disabled>{{\'typeOfVehiclePlace\' | translate}}</option><option selected value=1>Active</option><option value=0>Inactive</option><option value=2>All</option></select></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><p class=totalSize><span class=pull-right><a class=\"btn btn-primary mb10\" ui-sref=layout.vehicleTypeMain.addVehicle>+ {{\'addVehicleButton\' | translate}}</a> </span>{{\'totalVehicle\' | translate}}: {{vm.totalVehicles}}</p></div><br><br><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12 text-center\"><div class=\"panel panel-default\"><div class=panel-body><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group pt3\"><div class=\"input-group-addon searchBackground\"><i class=\"fa fa-search\"></i></div><input type=text id=searchText class=form-control placeholder=\"{{\'searchPLaceholder\' | translate}}\" ng-model=vm.search ng-change=vm.getFilter()></div></div><div class=\"col-sm-4 col-md-4 col-lg-3 col-sm-offset-2 col-md-offset-2 col-lg-offset-3 text-left\"><label class=control-label>{{\'recordsPerPage\' | translate}}</label><select class=form-control ng-model=vm.itemsPerPageSelected ng-options=\"pages for pages in vm.searchModel.limitOptions\" ng-change=vm.getPagesCount()></select></div></div><div class=\"table-responsive tableWithMasterDataParentDive\" ng-switch=\"(vm.VehicleList | filter:vm.search).length\"><div ng-switch-when=0 class=noSearch><span>{{\'nothingFound\' | translate}}</span></div><table class=\"table table-hover tableWithMasterData\" ng-switch-default><thead><tr><th style=width:70px hidden table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'index\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:70px table-column-sorting current-text=vm.predicate title=\"{{\'serialNumber\' | translate}}\" text=\"\'id\'\" check=vm.reverse>{{\'serialNumber\' | translate}}</th><th style=width:125px><div class=text-center>{{\'vImage\' | translate}}</div></th><th style=width:125px><div class=text-center>{{\'vImageOff\' | translate}}</div></th><th style=width:125px><div class=text-center>{{\'vImageOn\' | translate}}</div></th><th style=width:125px><div class=text-center>{{\'vImageBusy\' | translate}}</div></th><th style=width:125px><div class=text-center>{{\'vImagePosition\' | translate}}</div></th><th style=width:125px><div class=text-center>{{\'vImageAccepted\' | translate}}</div></th><th style=width:125px><div class=text-center>{{\'vImageOnRoad\' | translate}}</div></th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'name\' | translate}}\" text=\"\'name\'\" check=vm.reverse>{{\'name\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'tag\' | translate}}\" text=\"\'tag\'\" check=vm.reverse>{{\'tag\' | translate}}</th><th style=width:100px table-column-sorting current-text=vm.predicate title=\"{{\'category\' | translate}}\" text=\"\'category\'\" check=vm.reverse>{{\'category\' | translate}}</th><!--<th>--><!--<div class=\"text-center\" ng-click=\"vm.sort(\'status\')\">--><!--Status--><!--<span ng-hide=\"vm.predicate == \'status\' && vm.reverse || vm.predicate == \'status\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'status\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'status\' && vm.reverse\" class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><!--<th>--><!--<div class=\"text-center\" ng-click=\"vm.sort(\'created_by\')\">--><!--Created By--><!--<span ng-hide=\"vm.predicate == \'created_by\' && vm.reverse || vm.predicate == \'created_by\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'created_by\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'created_by\' && vm.reverse\" class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><!--<th>--><!--<div class=\"text-center\" ng-click=\"vm.sort(\'created_on\')\">--><!--Created On--><!--<span ng-hide=\"vm.predicate == \'created_on\' && vm.reverse || vm.predicate == \'created_on\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'created_on\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'created_on\' && vm.reverse\" class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><!--<th>--><!--<div class=\"text-center\" ng-click=\"vm.sort(\'updated_on\')\">--><!--Updated On--><!--<span ng-hide=\"vm.predicate == \'updated_on\' && vm.reverse || vm.predicate == \'updated_on\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'updated_on\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'updated_on\' && vm.reverse\" class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><!--<th>--><!--<div class=\"text-center\" ng-click=\"vm.sort(\'updated_by\')\">--><!--Updated By--><!--<span ng-hide=\"vm.predicate == \'updated_by\' && vm.reverse || vm.predicate == \'updated_by\' && !vm.reverse\" class=\"fa fa-sort sortOpacity\"></span>--><!--<span ng-show=\"vm.predicate == \'updated_by\' && !vm.reverse\" class=\"fa fa-caret-down\"></span>--><!--<span ng-show=\"vm.predicate == \'updated_by\' && vm.reverse\" class=\"fa fa-caret-up\"></span>--><!--</div>--><!--</th>--><th style=width:100px><div class=text-center>{{\'stateTable\' | translate}}</div></th><th style=width:150px><div class=text-center>{{\'action\' | translate}}</div></th><th style=width:150px><div class=text-center>{{\'adminLogs\' | translate}}</div></th></tr></thead><tbody ng-if=vm.tBodyFlag><tr ng-repeat=\"data in filtered = vm.VehicleList| filter:vm.search | orderBy:vm.predicate:vm.reverse\"><td style=width:70px hidden>{{data.index + 1}}</td><td style=width:70px>{{::data.id}}</td><td style=width:125px><img ng-src=\"{{data.vehicle_image || \'assets/images/noImage.jpeg\'}}\" class=tableImage></td><td style=width:125px><img ng-src=\"{{data.vehicle_img_offline || \'assets/images/noImage.jpeg\'}}\" class=tableImage></td><td style=width:125px><img ng-src=\"{{data.vehicle_img_online || \'assets/images/noImage.jpeg\'}}\" class=tableImage></td><td style=width:125px><img ng-src=\"{{data.vehicle_img_busy || \'assets/images/noImage.jpeg\'}}\" class=tableImage></td><td style=width:125px><img ng-src=\"{{data.vehicle_img_position || \'assets/images/noImage.jpeg\'}}\" class=tableImage></td><td style=width:125px><img ng-src=\"{{data.vehicle_img_accepted || \'assets/images/noImage.jpeg\'}}\" class=tableImage></td><td style=width:125px><img ng-src=\"{{data.vehicle_img_road || \'assets/images/noImage.jpeg\'}}\" class=tableImage></td><td style=width:100px>{{::data.name}}</td><td style=width:100px>{{::data.tag}}</td><td style=width:100px><span ng-if=\"data.categoria === \'M\'\">Minibus </span><span ng-if=\"data.categoria === \'S\'\">Sedan </span><span ng-if=\"data.categoria === \'O\'\">Otro</span></td><!--<td>--><!--<span ng-if=\"data.status == 0\">Inactive</span>--><!--<span ng-if=\"data.status == 1\">Active</span>--><!--</td>--><!--<td>{{data.created_by}}</td>--><!--<td>{{data.created_on}}</td>--><!--<td>{{data.updated_on}}</td>--><!--<td>{{data.updated_by}}</td>--><td style=width:100px><a class=\"cursor btn btn-sm\" ng-class=\"{\'blockIconColor\': data.status == 0, \'unblockIconColor\': data.status == 1}\" ng-click=vm.blockUnblockVehicle($event,data.id,data.status)><i ng-class=\"{\'fa fa-unlock\': data.status == 1,\'fa fa-lock\': data.status == 0}\"></i></a></td><td style=width:150px><a title=\"Edit Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.vehicleTypeMain.editVehicleType({id:\'{{data.id}}\'})\"><i class=\"fa fa-edit\"></i> </a><a title=\"View Details\" class=\"cursor editIconColor btn btn-sm\" ui-sref=\"layout.vehicleTypeMain.viewVehicleType({id:\'{{data.id}}\'})\"><i class=\"fa fa-eye\"></i> </a><a title=\"Delete Details\" class=\"cursor blockIconColor btn btn-sm\" ng-click=vm.deleteVehicleHit(data,$event)><i class=\"fa fa-trash\"></i></a></td><td style=width:150px><a class=\"btn btn-primary tableButton\" title=\"{{\'adminLogs\' | translate}}\" ui-sref=\"layout.vehicleTypeMain.adminLogs({userId:\'{{data.id}}\',type:\'13\',fakeType: \'8\'})\">{{\'adminLogs\' | translate}}</a></td></tr></tbody><tfoot ng-if=vm.tFootFlag><tr><th colspan=6 class=noDataClass>{{\'noVehicleFound\' | translate}}</th></tr></tfoot></table></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-4 text-left pt2\"><span ng-hide=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValue + 1}} {{\'to\' | translate}} {{vm.limitValue + 1}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span> <span ng-if=vm.filterOn>{{\'showing\' | translate}} {{vm.skipValueFilter}} {{\'of\' | translate}} {{vm.dataLength}} {{\'enteries\' | translate}}</span></div><div class=\"col-sm-6 col-md-6 col-lg-6 col-sm-offset-0 col-md-offset-0 col-lg-offset-2\"><!--<div class=\"pull-right\" ng-show=\"vm.sp_pagination\">--><!--&lt;!&ndash;ng-show=\"sp_pagination\" ng-show=\"watchPagination\"&ndash;&gt;--><!--<nav ng-show=\"vm.watchPagination\">--><!--<ul class=\"pagination\">--><!--<li ng-class=\"vm.prevPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.prevPage(vm.currentPage)\">{{\'previous\' | translate}}</a>--><!--</li>--><!--<li ng-class=\"{active: m == vm.currentPage}\" ng-repeat=\"m in vm.ret\" ng-click=\"vm.setPage(m)\">--><!--<a class=\"link\" ng-click=\"vm.currentData(m)\">{{m+1}}</a>--><!--</li>--><!--<li ng-class=\"vm.nextPageDisabled()\" class=\"cursor\">--><!--<a class=\"link\" ng-click=\"vm.nextPage(vm.currentPage)\">{{\'next\' | translate}}</a>--><!--</li>--><!--</ul>--><!--</nav>--><!--</div>--><!--<div class=\"clearfix\"></div>--><div class=pull-right ng-if=vm.sp_pagination><ul uib-pagination total-items=vm.dataLength items-per-page=vm.itemsPerPageGot ng-change=vm.paginationNew(vm.currentPage) ng-model=vm.currentPage max-size=vm.maxSize class=pagination-sm boundary-link-numbers=true rotate=false></ul></div><div class=clearfix></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/views/vehicle-type/vehicleTypeMain.html","<div ui-view=\"\"></div>");
$templateCache.put("app/components/views/vehicle-type/viewVehicleType.html","<h2 class=ng-cloak>{{\'vehicleTypesHead\' | translate}} / {{\'vehicleViewHead\' | translate}}</h2><div class=\"container-fluid ng-cloak\" ng-class=\"{\'whirl duo\' : vm.loading }\" id=driver><div class=row><div class=\"col-lg-10 col-sm-10 col-md-10 col-xs-12 col-lg-offset-1 col-xs-offset-0 col-md-offset-1 col-sm-offset-1 wordBreak\"><div class=row><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><button class=\"btn btn-primary mb25\" ng-click=vm.goBack()>{{\'goBack\' | translate}}</button></div><div class=\"col-lg-12 col-xs-12 col-sm-12 col-md-12\"><div class=basicDiv><p class=\"basicRegistrationP text-center backgroundBasicPending\">{{\'allDetails\' | translate}}</p><div class=basicDetailsDiv><div class=row><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'vehicleNameLabel\' | translate}}:</label><div class=\"form-control text-capitalize\">{{::vm.vehicleDetail.name}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'tag\' | translate}}:</label><div class=\"form-control text-capitalize\">{{::vm.vehicleDetail.tag}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'vehicleID\' | translate}}:</label><div class=\"form-control text-capitalize\">{{::vm.vehicleDetail.id}}</div></div><div class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\"><label class=control-label>{{\'vehicleStatus\' | translate}}:</label><div class=\"form-control text-capitalize\"><span ng-if=\"vm.vehicleDetail.status == 1\">Active</span> <span ng-if=\"vm.vehicleDetail.status == 0\">Not Active</span></div></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><label class=control-label>{{\'vImage\' | translate}}:</label><div><img ng-src=\"{{ vm.vehicleDetail.vehicle_image || \'assets/images/noImage.jpeg\'}}\" class=documentStyle></div></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><label class=control-label>{{\'vImageOff\' | translate}}:</label><div><img ng-src=\"{{ vm.vehicleDetail.vehicle_img_offline || \'assets/images/noImage.jpeg\'}}\" class=documentStyle></div></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><label class=control-label>{{\'vImageOn\' | translate}}:</label><div><img ng-src=\"{{ vm.vehicleDetail.vehicle_img_online || \'assets/images/noImage.jpeg\'}}\" class=documentStyle></div></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><label class=control-label>{{\'vImageBusy\' | translate}}:</label><div><img ng-src=\"{{ vm.vehicleDetail.vehicle_img_busy || \'assets/images/noImage.jpeg\'}}\" class=documentStyle></div></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><label class=control-label>{{\'vImagePosition\' | translate}}:</label><div><img ng-src=\"{{ vm.vehicleDetail.vehicle_img_position || \'assets/images/noImage.jpeg\'}}\" class=documentStyle></div></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><label class=control-label>{{\'vImageAccepted\' | translate}}:</label><div><img ng-src=\"{{ vm.vehicleDetail.vehicle_img_accepted || \'assets/images/noImage.jpeg\'}}\" class=documentStyle></div></div><div class=\"col-lg-4 col-sm-4 col-md-4 col-xs-4\"><label class=control-label>{{\'vImageOnRoad\' | translate}}:</label><div><img ng-src=\"{{ vm.vehicleDetail.vehicle_img_road || \'assets/images/noImage.jpeg\'}}\" class=documentStyle></div></div></div></div></div></div></div></div></div></div>");}]);